/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(994);
	module.exports = __webpack_require__(2);


/***/ },
/* 1 */
[1185, 1031],
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.thirdparty = exports.scAxiosSMS = exports.scAxiosAdmin = exports.scAxios = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(90);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(492);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(844);
	
	var _axios = __webpack_require__(64);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _serviceWorker = __webpack_require__(707);
	
	var serviceWorker = _interopRequireWildcard(_serviceWorker);
	
	var _configureStore = __webpack_require__(708);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _userActions = __webpack_require__(95);
	
	__webpack_require__(116);
	
	__webpack_require__(238);
	
	__webpack_require__(842);
	
	__webpack_require__(841);
	
	__webpack_require__(843);
	
	__webpack_require__(840);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import './css/bodypartcss/devcustom.css';
	//import './css/bodypartcss/custom.css';
	//import servernode from '../server.js';
	//import './assets/scss/app.scss';
	//import './assets/css/topbar.css';
	//import './assets/css/vertical.css';
	//import './assets/css/custom.css';
	
	//import { API_TOKEN_NAME, LOGIN_PAGE_PATH, IS_ACTIVE, USER_ID} from './constants';
	var dynUrl = void 0;
	var dynAdmUrl = void 0;
	var dynUrlSms = void 0;
	
	var host_name = window.location.hostname;
	
	// if (host_name === "localhost") {
	//   dynAdmUrl = process.env.REACT_APP_LOCAL_URL + "/unitedhospitalapi/api";
	//   dynUrl = process.env.REACT_APP_STAGING_URL + "/unitedhospitalapi/api";
	//   // dynUrl = 'http://localhost/reactjs/demoreactapibackend/api';
	//   //dynUrl = 'https://cors-anywhere.herokuapp.com/http://45.64.132.130:3388/zab';
	//   dynUrl = "http://45.64.132.149:3388/zab";
	//   //dynUrl = 'https://cors-anywhere.herokuapp.com/http://45.64.132.149:3388/zab';
	//   dynUrlSms = process.env.REACT_APP_LOCAL_URL + "/unitedhospitalapi/api";
	// }
	
	if (host_name === "localhost") {
	  dynAdmUrl = ("https://etherstaging.com/unitedhospitalapi") + "/api";
	  dynUrl = ("https://etherstaging.com/unitedhospitalapi") + "/api";
	  dynUrlSms = ("https://etherstaging.com/unitedhospitalapi") + "/api";
	}
	
	if (host_name === "etherstaging.com") {
	  dynAdmUrl = ("https://etherstaging.com/unitedhospitalapi") + "/api";
	  dynUrl = ("https://etherstaging.com/unitedhospitalapi") + "/api";
	  dynUrlSms = ("https://etherstaging.com/unitedhospitalapi") + "/api";
	}
	
	if (host_name === "beta.uhlbd.com") {
	  dynAdmUrl = ("https://uhlbd.com/unitedhospitalapi") + "/api";
	  dynUrl = ("https://uhlbd.com/unitedhospitalapi") + "/api";
	  dynUrlSms = ("https://uhlbd.com/unitedhospitalapi") + "/api";
	}
	
	if (host_name === "uhlbd.com") {
	  dynAdmUrl = ("https://uhlbd.com/unitedhospitalapi") + "/api";
	  dynUrl = ("https://uhlbd.com/unitedhospitalapi") + "/api";
	  dynUrlSms = ("https://uhlbd.com/unitedhospitalapi") + "/api";
	}
	
	var scAxios = exports.scAxios = _axios2.default.create({
	  baseURL: dynUrl
	});
	
	var scAxiosAdmin = exports.scAxiosAdmin = _axios2.default.create({
	  baseURL: dynAdmUrl
	});
	
	var scAxiosSMS = exports.scAxiosSMS = _axios2.default.create({
	  baseURL: dynUrlSms
	});
	
	var thirdparty = exports.thirdparty = _axios2.default.create({
	  baseURL: dynAdmUrl
	});
	var store = (0, _configureStore2.default)();
	store.dispatch((0, _userActions.initUser)());
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_App2.default, null)
	), document.getElementById("root"));
	
	serviceWorker.unregister();

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var HOME_PAGE_PATH = exports.HOME_PAGE_PATH = "/";
	var LOGIN_PAGE_PATH = exports.LOGIN_PAGE_PATH = "/login";
	var ADMIN_LOGIN_PAGE_PATH = exports.ADMIN_LOGIN_PAGE_PATH = "/adminlogin";
	var TWENTY_MINUTES_TIME_IN_MILLISECONDS = exports.TWENTY_MINUTES_TIME_IN_MILLISECONDS = "59940000";
	var API_TOKEN_NAME = exports.API_TOKEN_NAME = "api_token";
	var API_TOKEN_EXPIRY_NAME = exports.API_TOKEN_EXPIRY_NAME = "api_token_expiry";
	var API_AUTH_USERNAME = exports.API_AUTH_USERNAME = "OSL";
	var API_AUTH_PASSWORD = exports.API_AUTH_PASSWORD = "osl@2022";
	var USER_ROLE = exports.USER_ROLE = "USER_ROLE";
	var USER_ID = exports.USER_ID = "USER_ID";
	var USER_EMAIL = exports.USER_EMAIL = "USER_EMAIL";
	var LOGIN_PHONE_NUMBER = exports.LOGIN_PHONE_NUMBER = "login_phone_number";
	var SEARCH_SELECTED_DOC_ID = exports.SEARCH_SELECTED_DOC_ID = "search_selected_doc_id";
	var SCHEDULE_DATE = exports.SCHEDULE_DATE = "schedule_date";
	var APPOINTMENT_ID = exports.APPOINTMENT_ID = "apointment_id";
	var DOCTOR_NAME = exports.DOCTOR_NAME = "doctor_name";
	var DOCTOR_FEES = exports.DOCTOR_FEES = "doctor_fees";
	var PATIENT_NAME = exports.PATIENT_NAME = "patient_name";
	var PATIENT_DATE_OF_BIRTH = exports.PATIENT_DATE_OF_BIRTH = "patient_date_of_birth";
	var SCHEDULE_TIME = exports.SCHEDULE_TIME = "schedule_time";
	var SEARCH_SELECTED_DOC_NAME = exports.SEARCH_SELECTED_DOC_NAME = "search_selected_doc_name";
	var DOCTOR_PROFILE_AVABILITY = exports.DOCTOR_PROFILE_AVABILITY = "doctor_profile_avability";
	var USER_LOCAL_ID = exports.USER_LOCAL_ID = "user_local_id";
	
	var dynUrl = void 0;
	var imgUrl = void 0;
	var Pageurl = void 0;
	var siteUrl = void 0;
	var profileUrl = void 0;
	var apiImageUrl = void 0;
	
	var host_name = window.location.hostname;
	var erp_url = "https://uhlapi.etherstaging.xyz";
	
	// if (host_name === 'localhost') {
	// 	imgUrl = process.env.REACT_APP_LOCAL_URL + ':8000/';
	// 	apiImageUrl="https://uhlbackend.etherstaging.xyz/";
	// 	dynUrl = process.env.REACT_APP_LOCAL_URL + '/demoreactapibackend/api';
	// 	Pageurl = process.env.REACT_APP_LOCAL_URL + ':3000/pages/';
	// 	siteUrl = process.env.REACT_APP_LOCAL_URL;
	// 	profileUrl = process.env.REACT_APP_LOCAL_URL + '/unitedhospitalapi';
	// }
	// if (host_name === 'etherstaging.com') {
	// 	imgUrl = process.env.REACT_APP_STAGING_URL + '/unitedhospitalapi/public/';
	// 	dynUrl = process.env.REACT_APP_STAGING_URL + '/unitedhospitalapi/api';
	// 	Pageurl = process.env.REACT_APP_STAGING_URL + '/pages/';
	// 	siteUrl = process.env.REACT_APP_STAGING_URL;
	// 	profileUrl = process.env.REACT_APP_STAGING_URL + '/unitedhospitalapi';
	// }
	
	if (host_name === "localhost") {
	  imgUrl = ("https://etherstaging.com/unitedhospitalapi") + "/public/";
	  dynUrl = ("https://etherstaging.com/unitedhospitalapi") + "/api";
	  Pageurl = ("http://localhost:3000") + "/pages/";
	  siteUrl = ("http://localhost:3000");
	  profileUrl = ("https://etherstaging.com/unitedhospitalapi");
	}
	
	if (host_name === "etherstaging.com") {
	  imgUrl = ("https://etherstaging.com/unitedhospitalapi") + "/public/";
	  dynUrl = ("https://etherstaging.com/unitedhospitalapi") + "/api";
	  Pageurl = ("https://etherstaging.com") + "/pages/";
	  siteUrl = ("https://etherstaging.com");
	  profileUrl = ("https://etherstaging.com/unitedhospitalapi");
	}
	
	if (host_name === "beta.uhlbd.com") {
	  imgUrl = ("https://uhlbd.com/unitedhospitalapi") + "/public/";
	  dynUrl = ("https://uhlbd.com/unitedhospitalapi") + "/api";
	  Pageurl = ("https://beta.uhlbd.com") + "/pages/";
	  siteUrl = ("https://beta.uhlbd.com");
	  profileUrl = ("https://uhlbd.com/unitedhospitalapi");
	}
	
	if (host_name === "uhlbd.com") {
	  imgUrl = ("https://uhlbd.com/unitedhospitalapi") + "/public/";
	  dynUrl = ("https://uhlbd.com/unitedhospitalapi") + "/api";
	  Pageurl = ("https://uhlbd.com") + "/pages/";
	  siteUrl = ("https://uhlbd.com");
	  profileUrl = ("https://uhlbd.com/unitedhospitalapi");
	}
	
	var IMAGE_URL = exports.IMAGE_URL = imgUrl;
	var BASE_URL = exports.BASE_URL = dynUrl;
	var WEBSITEPAGE_URL = exports.WEBSITEPAGE_URL = Pageurl;
	var SITE_URL = exports.SITE_URL = siteUrl;
	var PROFILE_URL = exports.PROFILE_URL = profileUrl;
	var APIIMAGE_URL = exports.APIIMAGE_URL = apiImageUrl;
	var ERPUrl = exports.ERPUrl = erp_url;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.30.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }
	
	        var d = mom._d,
	            isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }
	
	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;
	
	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }
	
	        d = mom._d;
	        isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }
	
	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // PARSING
	
	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        var month = value,
	            date = mom.date();
	
	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // PARSING
	
	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(936)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);
	
	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // PARSING
	
	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // PARSING
	
	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // PARSING
	
	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.30.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(181)(module)))

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(38);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 6 */
/***/ function(module, exports) {

	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(1003);
	} else {
	  module.exports = require("./cjs/react-toastify.js");
	}

/***/ },
/* 8 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo = __webpack_require__(451);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var LeftSidebar = function LeftSidebar() {
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      userData = _useState2[0],
	      setUserData = _useState2[1];
	
	  var menus = [{
	    title: "Departments",
	    icon: "dripicons-briefcase",
	    link: "/admin/departments"
	  }, {
	    title: "Doctors",
	    icon: "dripicons-briefcase",
	    link: "/admin/doctors"
	  }, {
	    title: "Members",
	    icon: "dripicons-blog",
	    link: "/admin/boardmembers"
	  }, {
	    title: "Case Studies",
	    icon: "dripicons-blog",
	    link: "/admin/case_studies"
	  }, {
	    title: "Appointment Requests",
	    icon: "dripicons-blog",
	    link: "/admin/appointment/request"
	  }, {
	    title: "Appointment Bookings",
	    icon: "dripicons-blog",
	    link: "/admin/appointment/booking"
	  }, {
	    title: "Video Uploading JCI",
	    icon: "dripicons-blog",
	    link: "/admin/uploading"
	  },
	  // {
	  //   title: "Set SSL Commerz",
	  //   icon: "dripicons-blog",
	  //   link: "/admin/set_ssl_commerz",
	  // },
	  {
	    title: "Testimonials",
	    icon: "dripicons-blog",
	    link: "/admin/testimonials"
	  }, {
	    title: "News Events",
	    icon: "dripicons-blog",
	    link: "/admin/newsevents"
	  }, {
	    title: "Publications",
	    icon: "dripicons-blog",
	    link: "/admin/publications"
	  }, {
	    title: "Media Upload",
	    icon: "dripicons-blog",
	    link: "/admin/upload-media"
	  }, {
	    title: "Home page popup",
	    icon: "dripicons-blog",
	    link: "/admin/home-popup"
	  }, {
	    title: "Packages",
	    icon: "dripicons-blog",
	    link: "/admin/packages"
	  }, {
	    title: "Investigations",
	    icon: "dripicons-blog",
	    link: "/admin/investigations"
	  }, {
	    title: "Static Pages",
	    icon: "dripicons-blog",
	    link: "/admin/staticpages"
	  },
	  // {
	  //   title: "Menu",
	  //   icon: "dripicons-blog",
	  //   link: "/admin/menu",
	  // },
	  {
	    title: "Banner",
	    icon: "dripicons-blog",
	    link: "/admin/banner/list"
	  }, {
	    title: "Banner Button Link",
	    icon: "dripicons-blog",
	    link: "/admin/bannerbuttonlink"
	  }, {
	    title: "Body Links",
	    icon: "dripicons-blog",
	    link: "/admin/body-links"
	  }, {
	    title: "Album",
	    icon: "dripicons-blog",
	    link: "/admin/albums"
	  }, {
	    title: "Video Gallery",
	    icon: "dripicons-blog",
	    link: "/admin/videogallery"
	  }, {
	    title: "Messages",
	    icon: "dripicons-blog",
	    link: "/admin/emergency-inquiry-messages"
	  }, {
	    title: "Role Permission",
	    icon: "dripicons-user-group",
	    link: "/admin/role-manager"
	  }, {
	    title: "User Log",
	    icon: "dripicons-user-group",
	    link: "/admin/user-log"
	  }];
	
	  var fetchUserData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	      var user_id, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              user_id = localStorage.getItem(_constants.USER_LOCAL_ID);
	              _context.next = 4;
	              return _.thirdparty.get("/user/detail/" + user_id);
	
	            case 4:
	              response = _context.sent;
	
	              if (response.status === 200) {
	                setUserData(response.data.data);
	              }
	              _context.next = 11;
	              break;
	
	            case 8:
	              _context.prev = 8;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 11:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 8]]);
	    }));
	
	    return function fetchUserData(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    fetchUserData();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "left side-menu", style: { overflowY: "auto" } },
	    _react2.default.createElement(
	      "div",
	      { className: "topbar-left" },
	      _react2.default.createElement(
	        "div",
	        { className: "" },
	        _react2.default.createElement(
	          "a",
	          { href: "/admindashboard", className: "logo" },
	          _react2.default.createElement("img", { src: _logo2.default, height: 65, alt: "logo" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "sidebar-inner slimscrollleft" },
	      _react2.default.createElement(
	        "div",
	        { id: "sidebar-menu" },
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            { className: "has_sub" },
	            _react2.default.createElement(
	              "a",
	              { href: "/admindashboard", className: "waves-effect" },
	              _react2.default.createElement("i", { className: "dripicons-device-desktop" }),
	              _react2.default.createElement(
	                "span",
	                null,
	                " Dashboard "
	              )
	            )
	          ),
	          userData != null ? menus.map(function (menu) {
	            return !!userData.roles && (userData.roles.id == 1 || userData.roles.permission.includes(menu.link)) ? _react2.default.createElement(
	              "li",
	              { key: menu.link },
	              _react2.default.createElement(
	                "a",
	                { href: menu.link, className: "waves-effect" },
	                _react2.default.createElement("i", { className: menu.icon }),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  menu.title,
	                  " "
	                )
	              )
	            ) : null;
	          }) : null,
	          " ",
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/admin/configuration", className: "waves-effect" },
	              _react2.default.createElement("i", { className: "dripicons-blog" }),
	              _react2.default.createElement(
	                "span",
	                null,
	                "Configuration"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/admin/email-configuration", className: "waves-effect" },
	              _react2.default.createElement("i", { className: "dripicons-blog" }),
	              _react2.default.createElement(
	                "span",
	                null,
	                "Email Configuration"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/admin/settings", className: "waves-effect" },
	              _react2.default.createElement("i", { className: "dripicons-blog" }),
	              _react2.default.createElement(
	                "span",
	                null,
	                "Settings"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement("div", { className: "clearfix" })
	    )
	  );
	};
	
	exports.default = LeftSidebar;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var viewFullScreen = function viewFullScreen() {
	  var body = document.querySelector("body");
	  if (body.requestFullscreen) {
	    body.requestFullscreen();
	  } else if (body.webkitRequestFullscreen) {
	    // Safari
	    body.webkitRequestFullscreen();
	  } else if (body.msRequestFullscreen) {
	    // IE11
	    body.msRequestFullscreen();
	  }
	};
	
	var TopHeader = function (_Component) {
	  _inherits(TopHeader, _Component);
	
	  function TopHeader() {
	    _classCallCheck(this, TopHeader);
	
	    return _possibleConstructorReturn(this, (TopHeader.__proto__ || Object.getPrototypeOf(TopHeader)).apply(this, arguments));
	  }
	
	  _createClass(TopHeader, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "topbar" },
	        _react2.default.createElement(
	          "nav",
	          { className: "navbar-custom" },
	          _react2.default.createElement(
	            "div",
	            { className: "search-wrap", id: "search-wrap" },
	            _react2.default.createElement(
	              "div",
	              { className: "search-bar" },
	              _react2.default.createElement("input", {
	                className: "search-input",
	                type: "search",
	                placeholder: "Search"
	              }),
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "#",
	                  className: "close-search toggle-search",
	                  "data-target": "#search-wrap"
	                },
	                _react2.default.createElement("i", { className: "mdi mdi-close-circle" })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "list-inline float-right mb-0 ",
	              style: { float: "right" }
	            },
	            _react2.default.createElement(
	              "li",
	              { className: "list-inline-item dropdown notification-list d-flex justify-content-center align-items-center" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "nav-link dropdown-toggle arrow-none nav-user d-flex justify-content-center align-items-center waves-effect",
	                  "data-toggle": "dropdown",
	                  href: "#",
	                  role: "button",
	                  "aria-haspopup": "false",
	                  "aria-expanded": "false",
	                  style: { height: "40px", width: "40px", borderRadius: "50%" }
	                },
	                _react2.default.createElement("i", { "class": "fa-solid fa-user" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "dropdown-menu dropdown-menu-right profile-dropdown " },
	                _react2.default.createElement(
	                  "a",
	                  { className: "dropdown-item", href: "/admin/settings" },
	                  _react2.default.createElement("i", { className: "dripicons-gear text-muted" }),
	                  " Settings"
	                ),
	                _react2.default.createElement("div", { className: "dropdown-divider" }),
	                _react2.default.createElement(
	                  "a",
	                  { className: "dropdown-item", href: "/adminlogout" },
	                  _react2.default.createElement("i", { className: "dripicons-exit text-muted" }),
	                  " Logout"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            { className: "list-inline menu-left mb-0" },
	            _react2.default.createElement(
	              "li",
	              { className: "list-inline-item" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "button-menu-mobile open-left waves-effect"
	                },
	                _react2.default.createElement("i", { className: "ion-navicon" })
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "hide-phone list-inline-item app-search" },
	              _react2.default.createElement(
	                "h3",
	                { className: "page-title" },
	                document.title
	              )
	            )
	          ),
	          _react2.default.createElement("div", { className: "clearfix" })
	        )
	      );
	    }
	  }]);
	
	  return TopHeader;
	}(_react.Component);
	
	exports.default = TopHeader;

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredArgs;
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
	  }
	}
	module.exports = exports.default;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ci = __webpack_require__(405);
	
	var _io = __webpack_require__(162);
	
	var _tfi = __webpack_require__(125);
	
	var _fa = __webpack_require__(62);
	
	var _fa2 = __webpack_require__(161);
	
	var _io2 = __webpack_require__(406);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      footerData = _useState2[0],
	      setFooterData = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var footerDataList = {
	      ids: [31, 32, 33, 34, 35, 36, 38, 39, 41, 42, 50, 51, 52, 53, 60]
	    };
	    var getFooterData = function getFooterData(data) {
	      try {
	        var req = _.scAxiosAdmin.post("/settings/get_multiple", footerDataList, {
	          // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
	          method: "get",
	          headers: {
	            Accept: "application/json"
	            // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            // console.log('your log output',data)
	            // setStaticPageData(data.data.data);
	            setFooterData(data.data);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getFooterData();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "row g-0" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-12 col-lg-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "accordion-item" },
	          _react2.default.createElement(
	            "div",
	            { className: "hover-trigger", style: { position: "relative" } },
	            _react2.default.createElement("img", {
	              src: "/assets/images/3_1.png",
	              width: "100%",
	              alt: "",
	              className: "image-hover"
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "hover-overlay w-100 h-100" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "p-4",
	                  style: {
	                    position: "absolute",
	                    top: "0",
	                    left: "0",
	                    right: "0",
	                    bottom: "0",
	                    display: "flex",
	                    flexDirection: "column",
	                    justifyContent: "center"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row row-cols-2 px-0 px-xxl-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mb-3 mb-xxl-5 d-flex flex-column justify-content-start align-items-start" },
	                    _react2.default.createElement(
	                      "h5",
	                      { className: "header-text" },
	                      "United Hospital"
	                    ),
	                    footerData.length > 0 && footerData[4].value ? footerData[4].value.split("<br/>").map(function (item, index) {
	                      return _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        item ? item : ""
	                      );
	                    }) : ""
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mb-3 mb-xxl-5 d-flex justify-content-start align-items-start ps-3 ps-md-4 ps-lg-5" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        onClick: function onClick() {
	                          return window.open(footerData.length > 0 && footerData[5].value ? footerData[5].value : "https://maps.app.goo.gl/UJS8gnWhCddNuwDH9");
	                        },
	                        className: "d-flex flex-column justify-content-start align-items-center"
	                      },
	                      _react2.default.createElement(_ci.CiLocationOn, { className: "text-white locationIcon" }),
	                      " ",
	                      _react2.default.createElement(
	                        "span",
	                        { className: "normal-text" },
	                        "View on Map"
	                      )
	                    )
	                  ),
	                  " ",
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex flex-column justify-content-start align-items-start" },
	                    _react2.default.createElement(
	                      "h5",
	                      { className: "sub-header-text" },
	                      "Chattogram Information Centre"
	                    ),
	                    footerData.length > 0 && footerData[6].value ? footerData[6].value.split("<br/>").map(function (item, index) {
	                      return _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        item ? item : ""
	                      );
	                    }) : "",
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        onClick: function onClick() {
	                          return window.open(footerData.length > 0 && footerData[7].value ? footerData[7].value : "https://maps.app.goo.gl/9XBtAtvFvK3Zcn9R8");
	                        }
	                      },
	                      _react2.default.createElement(_ci.CiLocationOn, {
	                        className: "text-white",
	                        style: { fontWeight: 900 }
	                      }),
	                      " ",
	                      _react2.default.createElement(
	                        "span",
	                        { className: "normal-text" },
	                        "View on Map"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: " d-flex flex-column justify-content-start align-items-start" },
	                    _react2.default.createElement(
	                      "h5",
	                      { className: "sub-header-text" },
	                      "Sylhet Information Centre"
	                    ),
	                    footerData.length > 0 && footerData[8].value ? footerData[8].value.split("<br/>").map(function (item, index) {
	                      return _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        item ? item : ""
	                      );
	                    }) : "",
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        onClick: function onClick() {
	                          return window.open(footerData.length > 0 && footerData[9].value ? footerData[9].value : "https://maps.app.goo.gl/6XrybGQtJXvuzHkK9");
	                        }
	                      },
	                      _react2.default.createElement(_ci.CiLocationOn, {
	                        className: "text-white",
	                        style: { fontWeight: 900 }
	                      }),
	                      " ",
	                      _react2.default.createElement(
	                        "span",
	                        { className: "normal-text" },
	                        "View on Map"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-12 col-lg-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "accordion-item" },
	          _react2.default.createElement(
	            "div",
	            { className: "hover-trigger", style: { position: "relative" } },
	            _react2.default.createElement("img", {
	              src: "/assets/images/1.png",
	              alt: "",
	              width: "100%",
	              className: "image-hover"
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "hover-overlay w-100 h-100" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "p-4",
	                  style: {
	                    position: "absolute",
	                    top: "0",
	                    left: "0",
	                    right: "0",
	                    bottom: "0",
	                    display: "flex",
	                    flexDirection: "column",
	                    justifyContent: "center"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row row-cols-3 px-0 px-xxl-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mb-3 mb-xxl-5 d-flex flex-column justify-content-start align-items-start" },
	                    _react2.default.createElement(
	                      "h5",
	                      { className: "header-text" },
	                      "Social Page"
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { className: "text-decoration-none", to: "" },
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "text-decoration-none",
	                        to: "/page/brief-history"
	                      },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "Brief History"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "text-decoration-none",
	                        to: "/page/mission-statement"
	                      },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "Mission Statement"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "text-decoration-none",
	                        to: "/page/board-members"
	                      },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "Board Members"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "text-decoration-none",
	                        to: "/page/people-diversity"
	                      },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "People & Diversity"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "text-decoration-none",
	                        to: "/page/operation-team"
	                      },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "Operation Team"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "text-decoration-none",
	                        to: "/services/corporate-client"
	                      },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "Corporate Client"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mb-3 mb-xxl-5 d-flex flex-column justify-content-start align-items-start" },
	                    _react2.default.createElement(
	                      "h5",
	                      { className: "header-text" },
	                      "Gallery"
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "text-decoration-none",
	                        to: "/gallery/photo-gallery"
	                      },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "Photo Gallery"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "text-decoration-none",
	                        to: "/gallery/video-gallery"
	                      },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "Video Gallery"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "text-decoration-none",
	                        to: "/pages/life-at-uhl"
	                      },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "Life at UHL"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mb-3 mb-xxl-5 d-flex flex-column justify-content-start align-items-start" },
	                    _react2.default.createElement(
	                      "h5",
	                      { className: "header-text" },
	                      "Social Page"
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { className: "text-decoration-none", to: "/news" },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "Latest News"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { className: "text-decoration-none", to: "/publication" },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "Publication"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { className: "text-decoration-none", to: "/news/index" },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "normal-text" },
	                        "Notice Board"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-12 col-lg-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "accordion-item" },
	          _react2.default.createElement(
	            "div",
	            { className: "hover-trigger", style: { position: "relative" } },
	            _react2.default.createElement("img", {
	              src: "/assets/images/2.png",
	              width: "100%",
	              alt: "",
	              className: "image-hover"
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "hover-overlay w-100 h-100" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "p-4",
	                  style: {
	                    position: "absolute",
	                    top: "0",
	                    left: "0",
	                    right: "0",
	                    bottom: "0",
	                    display: "flex",
	                    flexDirection: "column",
	                    justifyContent: "center",
	                    alignItems: "center"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "d-flex align-items-center mb-3" },
	                  _react2.default.createElement(_tfi.TfiHeadphoneAlt, { className: "locationIcon" })
	                ),
	                _react2.default.createElement(
	                  "a",
	                  { className: "text-decoration-none", href: "tel:10666" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex align-items-center mb-3" },
	                    _react2.default.createElement(_io.IoCall, { size: 40, className: "header-text me-2" }),
	                    _react2.default.createElement(
	                      "h5",
	                      { className: "header-text" },
	                      footerData.length > 0 && footerData[0].value ? footerData[0].value : "10666"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "d-flex flex-column mb-3 justify-content-start align-items-center gap-0" },
	                  _react2.default.createElement(
	                    "h6",
	                    {
	                      className: "header-text d-flex align-items-center",
	                      style: { width: "fit-content", display: "inline-block" }
	                    },
	                    "Cell:",
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { className: "sub-header-text mt-1" },
	                      footerData.length > 0 && footerData[1].value ? footerData[1].value : "+880 1914 001234"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "h6",
	                    {
	                      className: "header-text d-flex align-items-center",
	                      style: { width: "fit-content", display: "inline-block" }
	                    },
	                    "International:",
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { className: "sub-header-text mt-1" },
	                      footerData.length > 0 && footerData[2].value ? footerData[2].value : "+8802-2222-62466"
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "d-flex justify-content-center align-items-center" },
	                  _react2.default.createElement(
	                    "h6",
	                    { className: "header-text" },
	                    "WhatsApp:"
	                  ),
	                  _react2.default.createElement(
	                    "h6",
	                    { className: "sub-header-text mt-2" },
	                    footerData.length > 0 && footerData[3].value ? footerData[3].value : "+880191-4001214"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      {
	        className: "d-flex justify-content-center align-items-center py-3",
	        style: { backgroundColor: "#AF9763" }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "container flex-column flex-md-row d-flex justify-content-between align-items-center gap-4 gap-md-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "p",
	            { className: "text-white text-center text-md-left" },
	            footerData.length > 0 && footerData[14].value ? footerData[14].value : new Date().getFullYear() + " United Hospital Limited. All Rights\n              Reserved. Design & Developed with",
	            _react2.default.createElement(
	              "span",
	              { style: { color: "black" } },
	              " \u2665"
	            ),
	            " by",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                className: "text-white",
	                href: "https://www.ethertech.ltd/",
	                target: "_blank",
	                rel: "noopener noreferrer"
	              },
	              "EtherTech"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: "/" },
	          _react2.default.createElement(
	            "div",
	            { className: "" },
	            _react2.default.createElement("img", {
	              style: { maxWidth: "70px" },
	              className: "img-fluid",
	              src: "/assets/images/white_uhl.png",
	              alt: "",
	              srcset: ""
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex justify-content-start align-items-center gap-4" },
	          _react2.default.createElement(
	            "a",
	            {
	              href: footerData.length > 0 && footerData[10].value ? footerData[10].value : "https://www.facebook.com/uhlbd/",
	              className: "text-light lh-1",
	              target: "_blank"
	            },
	            _react2.default.createElement(_fa.FaFacebookSquare, { size: _reactDeviceDetect.isMobile ? 20 : 30 })
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              href: footerData.length > 0 && footerData[12].value ? footerData[12].value : "https://www.instagram.com/myunitedhospital/",
	              className: "text-light lh-1",
	              target: "_blank"
	            },
	            _react2.default.createElement(_fa.FaInstagramSquare, { size: _reactDeviceDetect.isMobile ? 20 : 30 })
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              href: footerData.length > 0 && footerData[11].value ? footerData[11].value : "https://x.com/uhlbd",
	              className: "text-light lh-1",
	              target: "_blank"
	            },
	            _react2.default.createElement(_fa2.FaSquareXTwitter, { size: _reactDeviceDetect.isMobile ? 20 : 30 })
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              href: footerData.length > 0 && footerData[13].value ? footerData[13].value : "https://www.youtube.com/user/uhlbd",
	              className: "text-light lh-1",
	              target: "_blank"
	            },
	            _react2.default.createElement(_io2.IoLogoYoutube, { size: _reactDeviceDetect.isMobile ? 20 : 30 })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactHelmet = __webpack_require__(17);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Seo = function Seo(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      pathSlug = _ref.pathSlug,
	      keywords = _ref.keywords;
	
	  var url = "";
	  if (window.location.hostname === "localhost") {
	    url = "http://localhost:3000/" + pathSlug;
	  } else {
	    url = "http://beta.uhlbd.com/" + pathSlug;
	  }
	  return [_react2.default.createElement(_reactHelmet.Helmet, {
	    key: "title",
	    htmlAttributes: { lang: "en" },
	    title: title,
	    meta: [{
	      name: "description",
	      content: description
	    }, {
	      name: "keywords",
	      content: keywords
	    }],
	    links: [{
	      rel: "canonical",
	      href: url
	    }]
	  }), _react2.default.createElement(
	    _reactHelmet.Helmet,
	    { key: "description" },
	    _react2.default.createElement("meta", {
	      name: "description",
	      content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	    }),
	    _react2.default.createElement(
	      "script",
	      { type: "application/ld+json" },
	      JSON.stringify({
	        "@context": "http://schema.org",
	        "@type": "LocalBusiness",
	        name: "United Hospital Limited",
	        image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	        telephone: "10666",
	        email: "info@uhlbd.com",
	        address: {
	          "@type": "PostalAddress",
	          streetAddress: "plot 15, Road 71, Gulshan",
	          addressLocality: "Dhaka",
	          addressRegion: "Dhaka",
	          addressCountry: "Bangladesh",
	          postalCode: "1212"
	        },
	        openingHoursSpecification: {
	          "@type": "OpeningHoursSpecification",
	          opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	        },
	        url: "http://www.uhlbd.com/",
	        aggregateRating: {
	          "@type": "AggregateRating",
	          ratingValue: "3.9",
	          bestRating: "5",
	          worstRating: "1",
	          ratingCount: "756"
	        },
	        review: {
	          "@type": "Review",
	          author: {
	            "@type": "Person",
	            name: "abdul kahar"
	          },
	          datePublished: "2019-02-12",
	          reviewRating: {
	            "@type": "Rating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1"
	          },
	          reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	        }
	      })
	    ),
	    _react2.default.createElement("meta", {
	      name: "Subject",
	      content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	    }),
	    _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	    _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	    _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	    _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	    _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	    _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	    _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	    _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	    _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	    _react2.default.createElement("meta", {
	      name: "classification",
	      content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	    }),
	    _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	    _react2.default.createElement("meta", {
	      names: "apple-mobile-web-app-status-bar-style",
	      content: "black-translucent"
	    }),
	    _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	  )];
	};
	exports.default = Seo;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(709);


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _newlogo = __webpack_require__(453);
	
	var _newlogo2 = _interopRequireDefault(_newlogo);
	
	var _iconsRotate = __webpack_require__(107);
	
	var _iconsRotate2 = _interopRequireDefault(_iconsRotate);
	
	var _hotline_phone = __webpack_require__(117);
	
	var _hotline_phone2 = _interopRequireDefault(_hotline_phone);
	
	var _PopupIndex = __webpack_require__(84);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _PopupIndex3 = __webpack_require__(144);
	
	var _PopupIndex4 = _interopRequireDefault(_PopupIndex3);
	
	var _PopupIndex5 = __webpack_require__(65);
	
	var _PopupIndex6 = _interopRequireDefault(_PopupIndex5);
	
	var _PopupIndex7 = __webpack_require__(70);
	
	var _PopupIndex8 = _interopRequireDefault(_PopupIndex7);
	
	var _PopupPatientLists = __webpack_require__(145);
	
	var _PopupPatientLists2 = _interopRequireDefault(_PopupPatientLists);
	
	var _PopupRegister = __webpack_require__(97);
	
	var _PopupRegister2 = _interopRequireDefault(_PopupRegister);
	
	__webpack_require__(155);
	
	var _CollapsibleButton = __webpack_require__(139);
	
	var _CollapsibleButton2 = _interopRequireDefault(_CollapsibleButton);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _MyProvider = __webpack_require__(48);
	
	var _PatientRegistrationPopup = __webpack_require__(113);
	
	var _PatientRegistrationPopup2 = _interopRequireDefault(_PatientRegistrationPopup);
	
	var _BookAppointmentPopup = __webpack_require__(60);
	
	var _BookAppointmentPopup2 = _interopRequireDefault(_BookAppointmentPopup);
	
	var _CartPopUp = __webpack_require__(608);
	
	var _CartPopUp2 = _interopRequireDefault(_CartPopUp);
	
	var _BooTestPopUp = __webpack_require__(206);
	
	var _BooTestPopUp2 = _interopRequireDefault(_BooTestPopUp);
	
	var _CorporateRequestPopUp = __webpack_require__(614);
	
	var _CorporateRequestPopUp2 = _interopRequireDefault(_CorporateRequestPopUp);
	
	var _hi = __webpack_require__(960);
	
	var _fa = __webpack_require__(62);
	
	var _tfi = __webpack_require__(125);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getDefaultSearch = function getDefaultSearch(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/homesetting/getdefaultsearchdata", {
	      method: "get",
	      headers: {
	        Accept: "application/json"
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSearchData = function getSearchData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/homesetting/getsearchdata", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleHeaderAnnoucementData = function getSingleHeaderAnnoucementData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/headerannoucement/getsingleheaderannoucement/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var Header = function Header() {
	  var _useState = (0, _react.useState)({
	    search_keywords: "",
	    default_doctors: [], // Initialize with empty arrays
	    default_packages: [],
	    default_departments: [],
	    default_publications: [],
	    header_annoucement_text: "",
	    header_annoucement_link: "",
	    header_phone_no: "",
	    isPopupOpen: false,
	    patientRegPopup: false,
	    showPatientRegPopup: "",
	    showSearchPopup: false
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      state = _useState2[0],
	      setState = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      headerData = _useState4[0],
	      setHeaderData = _useState4[1];
	
	  var handleChange = function handleChange(event) {
	    setState(function (prevState) {
	      return Object.assign({}, prevState, _defineProperty({}, event.target.name, event.target.value));
	    });
	  };
	
	  var refreshGetDefaultSearchData = function refreshGetDefaultSearchData() {
	    getDefaultSearch().then(function (res) {
	      setState(function (prevState) {
	        return Object.assign({}, prevState, { // Keep the previous state intact
	          default_doctors: res.status === true ? res.doctor_data || [] : [],
	          default_packages: res.status === true ? res.package_data || [] : [],
	          default_publications: res.status === true ? res.publication_data || [] : [],
	          default_departments: res.status === true ? res.department_data || [] : []
	        });
	      });
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  var useDebounce = function useDebounce(fn, delay) {
	    var timeoutRef = (0, _react.useRef)(null);
	
	    return function (event) {
	      if (timeoutRef.current) {
	        clearTimeout(timeoutRef.current);
	      }
	      timeoutRef.current = setTimeout(function () {
	        fn(event);
	      }, delay);
	    };
	  };
	
	  var handleKeyUp = useDebounce(function (event) {
	    var data = {
	      keywords: state.search_keywords
	    };
	    getSearchData(data).then(function (res) {
	      setState(function (prevState) {
	        return Object.assign({}, prevState, { // Keep previous state intact
	          default_doctors: res.status === true ? res.doctor_data : [],
	          default_packages: res.status === true ? res.package_data : [],
	          default_publications: res.status === true ? res.publication_data : [],
	          default_departments: res.status === true ? res.department_data : [],
	          enableShdo: false // Update enableShdo without affecting other state
	        });
	      });
	    }).catch(function (err) {
	      console.log(err);
	    });
	  }, 500);
	
	  var showSearchResult = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              refreshGetDefaultSearchData(), setState(function (prevState) {
	                return Object.assign({}, prevState, { // Keep previous state intact
	                  showSearchPopup: !prevState.showSearchPopup // Toggle showSearchPopup
	                });
	              }); // Ensure API call after state update
	
	            case 1:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function showSearchResult() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var closeSearchPopUp = function closeSearchPopUp() {
	    setState(function (prevState) {
	      return Object.assign({}, prevState, { // Keep previous state intact
	        showSearchPopup: false // Close the search popup
	      });
	    }
	    // refreshGetDefaultSearchData
	    ); // Ensure API call after state update
	  };
	
	  var refreshgetSingleHeaderAnnoucementData = function refreshgetSingleHeaderAnnoucementData(id) {
	    getSingleHeaderAnnoucementData(id).then(function (res) {
	      if (res.status === true) {
	        var records = res.data;
	        setState({
	          header_annoucement_text: records.header_annoucement_text,
	          header_annoucement_link: records.header_annoucement_link,
	          header_phone_no: records.header_phone_no
	        });
	      } else {
	        setState({
	          header_annoucement_text: "",
	          header_annoucement_link: "",
	          header_phone_no: ""
	        });
	      }
	    }).catch(function (err) {
	      console.log(err);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    var headerDataList = {
	      ids: [31, 33, 34, 36]
	    };
	    var getHeaderData = function getHeaderData(data) {
	      try {
	        var req = _.scAxiosAdmin.post("/settings/get_multiple", headerDataList, {
	          // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
	          method: "get",
	          headers: {
	            Accept: "application/json"
	            // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            // console.log('your log output',data)
	            // setStaticPageData(data.data.data);
	            setHeaderData(data.data);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getHeaderData();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var header_annoucement_id = "1";
	    // refreshgetSingleHeaderAnnoucementData(header_annoucement_id);
	    window.addEventListener("storage", handleStorageChange);
	    return function () {
	      window.removeEventListener("storage", handleStorageChange);
	    };
	  }, []);
	
	  var handleStorageChange = function handleStorageChange() {
	    setState(function (prevState) {
	      return Object.assign({}, prevState);
	    });
	  };
	
	  var patient_user_id = localStorage.getItem(_constants.USER_LOCAL_ID);
	  var UserName = localStorage.getItem("patient_name");
	  var cart = localStorage.getItem("totalAmount");
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        className: "d-none d-md-flex flex-column",
	        style: {
	          position: "fixed",
	          top: "30vh",
	          right: "0",
	          // padding: "10px",
	          // borderTopLeftRadius: "20px",
	          // borderBottomLeftRadius: "20px",
	          // border: "2px solid #ccc", // Border for the first two buttons
	          // borderRight: "none", // No right border to attach it to the edge
	          // backgroundColor: "#f9f9f9", // Slight background color for visibility
	          // display: "flex",
	          // flexDirection: "column",
	          // gap: "10px",
	          // alignItems: "center",
	          zIndex: 99999
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "",
	          style: {
	            padding: "10px",
	            borderTopLeftRadius: "20px",
	            borderBottomLeftRadius: "20px",
	            border: "2px solid #AF9763", // Border for the first two buttons
	            borderRight: "none", // No right border to attach it to the edge
	            backgroundColor: "transparent", // Slight background color for visibility
	            display: "flex",
	            flexDirection: "column",
	            gap: "10px",
	            alignItems: "center",
	            zIndex: 99999
	          }
	        },
	        _react2.default.createElement(
	          "a",
	          {
	            href: "tel:" + (headerData.length > 0 && headerData[0].value ? headerData[0].value : "10666")
	          },
	          _react2.default.createElement(
	            "button",
	            {
	              style: {
	                width: "72px",
	                height: "72px",
	                borderRadius: "50%", // Rounded button
	                border: "none",
	                padding: 0,
	                backgroundColor: "transparent",
	                cursor: "pointer"
	              }
	            },
	            _react2.default.createElement("img", {
	              src: "/assets/images/call_update.svg",
	              alt: "Call",
	              style: {
	                width: "100%",
	                height: "100%",
	                objectFit: "cover",
	                borderRadius: "50%"
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: "/pages/emergency" },
	          _react2.default.createElement(
	            "button",
	            {
	              style: {
	                width: "72px",
	                height: "72px",
	                borderRadius: "50%", // Rounded button
	                border: "none",
	                padding: 0,
	                backgroundColor: "transparent",
	                cursor: "pointer"
	              }
	            },
	            _react2.default.createElement("img", {
	              src: "/assets/images/emargency_update.svg",
	              alt: "Emergency",
	              style: {
	                width: "100%",
	                height: "100%",
	                objectFit: "cover",
	                borderRadius: "50%"
	              }
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "", style: { padding: "10px", zIndex: 99999 } },
	        _react2.default.createElement(
	          "button",
	          {
	            className: "d-none d-md-flex",
	            style: {
	              width: "72px",
	              height: "72px",
	              borderRadius: "50%", // Rounded button
	              border: "none",
	              padding: 0,
	              backgroundColor: "transparent",
	              cursor: "pointer",
	              animation: "shakeButton 1s ease-in-out infinite"
	            }
	          },
	          _react2.default.createElement("img", {
	            src: "/assets/images/jci-gold-seal 1.png",
	            alt: "Gold Seal",
	            style: {
	              width: "100%",
	              height: "100%",
	              objectFit: "cover",
	              borderRadius: "50%"
	            }
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "style",
	      { jsx: true },
	      "\n        @keyframes shakeButton {\n          0% {\n            transform: translateX(0); /* No movement */\n          }\n          25% {\n            transform: translateX(-10px); /* Move left */\n          }\n          50% {\n            transform: translateX(10px); /* Move right */\n          }\n          75% {\n            transform: translateX(-10px); /* Move left again */\n          }\n          100% {\n            transform: translateX(0); /* Return to original position */\n          }\n        }\n      "
	    ),
	    state.header_annoucement_text ? _react2.default.createElement(
	      "header",
	      { className: "top-part" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "a",
	            {
	              href: state.header_annoucement_link,
	              target: "_blank",
	              style: { color: "#fff", textDecoration: "none" }
	            },
	            state.header_annoucement_text
	          )
	        )
	      )
	    ) : "",
	    _react2.default.createElement(
	      "div",
	      {
	        className: "text-light p-2 d-none d-md-block",
	        style: { backgroundColor: "#AF9763" }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row px-1" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-12 col-md-9 col-xl-8",
	              style: {
	                display: "flex",
	                gap: 5,
	                justifyContent: "flex-start"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex justify-content-between align-items-start" },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "tel:" + (headerData.length > 0 && headerData[0].value ? headerData[0].value : "10666"),
	                  style: {
	                    color: "#ffff",
	                    textDecoration: "none"
	                  }
	                },
	                _react2.default.createElement("i", { className: "fa fa-phone", style: { marginRight: "5px" } }),
	                headerData.length > 0 && headerData[0].value ? headerData[0].value : "10666"
	              ),
	              _react2.default.createElement("img", {
	                className: "ms-2 mt-1",
	                src: "/assets/images/Line 1.png",
	                alt: ""
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex justify-content-between align-items-start" },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "tel:+880 2-2222-62466",
	                  style: {
	                    color: "#ffff",
	                    textDecoration: "none",
	                    textWrap: "nowrap"
	                  }
	                },
	                _react2.default.createElement(_tfi.TfiHeadphoneAlt, { className: "mx-2" }),
	                "International:",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  headerData.length > 0 && headerData[1].value ? headerData[1].value : "+880 2-2222-62466",
	                  " "
	                )
	              ),
	              _react2.default.createElement("img", {
	                className: "ms-2 mt-1",
	                src: "/assets/images/Line 1.png",
	                alt: ""
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex justify-content-between align-items-start" },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "tel:+880191-4001214",
	                  style: {
	                    color: "#ffff",
	                    textDecoration: "none",
	                    textWrap: "nowrap"
	                  }
	                },
	                _react2.default.createElement(_fa.FaWhatsapp, { className: "mx-2" }),
	                "WhatsApp:",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  headerData.length > 0 && headerData[2].value ? headerData[2].value : "+880191-4001214",
	                  " "
	                )
	              ),
	              _react2.default.createElement("img", {
	                className: "ms-2 mt-1",
	                src: "/assets/images/Line 1.png",
	                alt: ""
	              })
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                target: "_blank",
	                className: "header-location",
	                href: headerData.length > 0 && headerData[3].value ? headerData[3].value : "https://maps.app.goo.gl/UJS8gnWhCddNuwDH9",
	                style: {
	                  // color: "#ffff",
	                  textDecoration: "none",
	                  textWrap: "nowrap"
	                }
	              },
	              _react2.default.createElement(_fa.FaMapMarkerAlt, { className: "make-packages-price-orange" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-12 col-md-3 col-xl-4 top-header d-flex justify-content-start justify-content-md-end upperHeaderMenus flex-wrap",
	              style: {
	                rowGap: "2px"
	              }
	            },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { style: { textDecoration: "none", fontSize: "14px" }, to: "/" },
	              "Home"
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                style: { textDecoration: "none", fontSize: "14px" },
	                to: "/page/about"
	              },
	              "About"
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                style: { textDecoration: "none", fontSize: "14px" },
	                to: "/pages/departments"
	              },
	              "Departments"
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                style: { textDecoration: "none", fontSize: "14px" },
	                to: "/pages/career"
	              },
	              "Career"
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                style: { textDecoration: "none", fontSize: "14px" },
	                to: "/page/contact"
	              },
	              "Contact Us"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "header",
	      {
	        className: "header-part hrad subpages_header py-0 shadow",
	        id: "doctor-profile"
	      },
	      _react2.default.createElement(
	        "nav",
	        { className: "navbar", style: { backgroundColor: "#F7F5EF" } },
	        _react2.default.createElement(
	          "div",
	          { className: "container py-2 pr-2", style: { flexWrap: "nowrap" } },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "d-flex justify-content-between align-items-center w-100 gap-0 gap-md-0",
	              style: { zIndex: 999 }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: { width: _reactDeviceDetect.isMobile ? "20%" : "10%" },
	                className: "d-flex justify-content-start"
	              },
	              _react2.default.createElement(
	                "a",
	                { href: "/" },
	                _react2.default.createElement("img", {
	                  style: { maxWidth: _reactDeviceDetect.isMobile ? "65px" : "" },
	                  className: "" + (_reactDeviceDetect.isMobile ? "none" : "img-fluid"),
	                  src: "/assets/images/updated_logo.png",
	                  alt: "logo2"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "d-flex justify-content-between align-items-center",
	                style: {
	                  width: _reactDeviceDetect.isMobile ? "80%" : "85%",
	                  position: "relative",
	                  display: "flex",
	                  alignItems: "center",
	                  justifyContent: "flex-start"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "",
	                  style: {
	                    position: "relative",
	                    width: localStorage.getItem(_constants.USER_LOCAL_ID) ? "75%" : "90%"
	                  }
	                },
	                _react2.default.createElement("input", {
	                  type: "text",
	                  className: "form-control py-1 py-md-2 shadow ",
	                  name: "search_keywords"
	                  // id="header_search_keywords"
	                  , style: { borderRadius: "30px" },
	                  value: state.search_keywords,
	                  placeholder: "" + (_reactDeviceDetect.isMobile ? "Search doctor ..." : "Search for your doctor, department or health screening package..."),
	                  onChange: handleChange,
	                  onClick: showSearchResult,
	                  onKeyUp: handleKeyUp,
	                  autoComplete: "off"
	                }),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "d-flex justify-content-center align-items-center mx-auto flex-row",
	                    style: {
	                      position: "absolute",
	                      right: 10,
	                      bottom: _reactDeviceDetect.isMobile ? 7 : 6,
	                      backgroundColor: "#AF9763",
	                      height: _reactDeviceDetect.isMobile ? "18px" : "27px",
	                      width: _reactDeviceDetect.isMobile ? "18px" : "27px",
	                      borderRadius: "50%",
	                      padding: _reactDeviceDetect.isMobile ? "3px" : ""
	                    },
	                    onClick: showSearchResult
	                  },
	                  _react2.default.createElement("img", { src: "/assets/images/search-header.png", alt: "" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    className: "nav-link p-0 border-0 ms-2",
	                    type: "button",
	                    "data-bs-toggle": "offcanvas",
	                    "data-bs-target": "#cartOffcanvasRight",
	                    "aria-controls": "cartOffcanvasRight",
	                    to: "/cart"
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        position: "relative"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "svg",
	                      {
	                        width: _reactDeviceDetect.isMobile ? "25" : "30",
	                        height: "30",
	                        viewBox: "0 0 30 30",
	                        fill: "none",
	                        xmlns: "http://www.w3.org/2000/svg"
	                      },
	                      _react2.default.createElement(
	                        "g",
	                        { "clip-path": "url(#clip0_2516_10804)" },
	                        _react2.default.createElement("path", {
	                          d: "M22.3769 0.0591259C21.5097 0.20561 20.5663 0.58647 19.7929 1.09038C19.1777 1.48881 11.9765 8.68999 11.578 9.30522C11.1972 9.8853 10.8691 10.6001 10.6874 11.2564C10.4999 11.9361 10.4296 13.3248 10.5468 14.0513C10.6347 14.6255 10.8984 15.4458 11.1503 15.938C11.83 17.2857 13.1015 18.4751 14.4374 19.0201C15.4277 19.4244 15.7265 19.4771 16.9921 19.4771C18.0468 19.4771 18.1816 19.4654 18.7089 19.3248C19.3534 19.149 20.1913 18.7623 20.7011 18.4107L21.0468 18.1763L21.4277 18.4693C22.0722 18.9556 22.8632 19.2955 23.7128 19.4595C24.1933 19.5474 25.5761 19.4947 26.0448 19.3658C26.6015 19.2134 27.5448 18.7271 28.0312 18.3404C28.2773 18.147 28.6347 17.7896 28.828 17.5435C29.2148 17.0572 29.7011 16.1138 29.8534 15.5572C30.0058 15.0123 30.0351 13.6705 29.9179 13.0611C29.7597 12.2935 29.3085 11.3267 28.8456 10.7876L28.6581 10.565L28.8984 10.2193C29.2441 9.71538 29.6191 8.89506 29.8007 8.26225C30.0058 7.51225 30.0644 6.09428 29.9179 5.30913C29.414 2.64311 27.3691 0.592329 24.7148 0.0884228C24.2167 -0.00532722 22.8632 -0.0229053 22.3769 0.0591259ZM23.9648 1.93413C25.0898 2.07475 25.9101 2.47319 26.7187 3.28178C27.1933 3.75639 27.3222 3.92045 27.5566 4.39506C27.9257 5.1392 28.0663 5.71342 28.0663 6.49858C28.0663 7.47124 27.8554 8.20366 27.3632 8.98881L27.1171 9.37553L26.9062 9.2642C26.3027 8.96538 25.4882 8.78959 24.6737 8.78959C23.6659 8.78959 22.8046 9.00639 22.0077 9.46342L21.5741 9.70952L19.623 7.75834L17.6659 5.80131L18.955 4.50639C20.3144 3.14116 20.748 2.76616 21.2694 2.47319C21.8261 2.16264 22.5937 1.94584 23.3788 1.88139C23.4316 1.88139 23.6952 1.90483 23.9648 1.93413ZM18.2577 9.14702L20.1972 11.0865L19.9511 11.5201C19.1659 12.8912 19.0546 14.6548 19.6523 16.1548L19.8456 16.6412L19.4706 16.8814C18.6913 17.3677 17.953 17.5787 16.9862 17.5787C14.4433 17.5787 12.4159 15.5572 12.4218 13.0142C12.4218 12.0005 12.6562 11.2154 13.1835 10.4302C13.3944 10.108 16.1894 7.20756 16.2831 7.20756C16.3007 7.20756 17.1913 8.08061 18.2577 9.14702ZM23.6718 14.1509V17.4615L23.3788 17.3501C22.4179 16.9869 21.5624 16.0083 21.2987 14.9712C21.1874 14.5259 21.1874 13.7701 21.2987 13.3306C21.5683 12.2994 22.3886 11.356 23.3554 10.9634C23.5136 10.899 23.6484 10.8462 23.6601 10.8462C23.6659 10.8404 23.6718 12.3287 23.6718 14.1509ZM26.4843 11.2505C27.1581 11.6783 27.7734 12.5279 27.9784 13.3013C28.0898 13.7056 28.0898 14.5845 27.9843 14.983C27.7089 16.0025 26.9999 16.8521 26.0331 17.2915C25.828 17.3853 25.6523 17.4615 25.6347 17.4615C25.6171 17.4615 25.6054 15.9732 25.6054 14.1509V10.8404L25.8984 10.9517C26.0624 11.0162 26.3261 11.1451 26.4843 11.2505Z",
	                          fill: "#292D32"
	                        }),
	                        _react2.default.createElement("path", {
	                          d: "M0.621064 8.14453C0.421846 8.20898 0.19333 8.4082 0.0820018 8.625C-0.0527638 8.88281 -0.023467 9.36914 0.140596 9.61523C0.415986 10.0195 0.404267 10.0195 3.15817 10.0195H5.61911L5.67185 10.207C6.20505 12.082 9.53317 22.8633 9.62106 22.9805C9.68552 23.0742 9.82028 23.1914 9.91989 23.25C10.0957 23.3437 10.705 23.3496 19.7168 23.3496C29.3027 23.3496 29.3261 23.3496 29.5312 23.2266C30.1347 22.875 30.1758 21.9551 29.6074 21.5801C29.455 21.4805 28.9922 21.4746 20.2793 21.4453L11.1093 21.416L9.15817 15.0059C7.35349 9.06445 7.20114 8.58398 7.02536 8.39648C6.91989 8.29101 6.73825 8.17383 6.62106 8.14453C6.36911 8.07422 0.861299 8.07422 0.621064 8.14453Z",
	                          fill: "#292D32"
	                        }),
	                        _react2.default.createElement("path", {
	                          d: "M24.8495 24.0587C23.7656 24.3517 22.8691 25.3536 22.6757 26.4845C22.4179 28.0079 23.3378 29.4669 24.8378 29.9064C25.2304 30.0236 26.0507 30.0294 26.455 29.9181C27.5449 29.631 28.4179 28.7111 28.6464 27.6095C28.9687 26.045 27.9902 24.4571 26.455 24.0529C26.0273 23.9415 25.2714 23.9474 24.8495 24.0587ZM26.0566 25.963C26.4316 26.1036 26.7714 26.6017 26.7773 27.006C26.7773 27.5685 26.2617 28.0665 25.6816 28.0665C25.33 28.0665 25.1249 27.9786 24.8906 27.7325C24.7206 27.5568 24.5507 27.1993 24.5507 27.0294C24.5507 26.6368 24.8495 26.1739 25.207 25.9982C25.4296 25.8868 25.8163 25.8693 26.0566 25.963Z",
	                          fill: "#292D32"
	                        }),
	                        _react2.default.createElement("path", {
	                          d: "M14.373 24.1056C13.6289 24.2873 12.8261 24.9084 12.4687 25.5822C12.0058 26.4435 12.0175 27.5392 12.4863 28.424C12.7089 28.84 13.2832 29.4025 13.6992 29.6134C14.8886 30.2169 16.3066 29.9884 17.2148 29.0392C17.7773 28.4533 18.0468 27.7853 18.0468 26.9826C18.0468 25.0724 16.2422 23.6544 14.373 24.1056ZM15.5273 26.0685C16.1367 26.3908 16.2949 27.1408 15.8613 27.6388C15.4277 28.1369 14.748 28.1369 14.3144 27.6388C13.6054 26.8302 14.5839 25.5587 15.5273 26.0685Z",
	                          fill: "#292D32"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "defs",
	                        null,
	                        _react2.default.createElement(
	                          "clipPath",
	                          { id: "clip0_2516_10804" },
	                          _react2.default.createElement("rect", { width: "30", height: "30", fill: "white" })
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "nav-item" },
	                localStorage.getItem(_constants.USER_LOCAL_ID) ? _react2.default.createElement(
	                  "div",
	                  { className: "dropdown navsdpdw" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "dropdown-toggle ms-2 d-flex justify-content-between align-items-center gap-2 text-decoration-none",
	                      type: "button",
	                      id: "dropdownMenuButton",
	                      "data-toggle": "dropdown",
	                      "aria-haspopup": "true",
	                      "aria-expanded": "false",
	                      style: { color: "black" }
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      { className: "userName" },
	                      UserName
	                    ),
	                    _react2.default.createElement("img", {
	                      className: "img-fluid",
	                      style: { maxWidth: _reactDeviceDetect.isMobile ? "25px" : "30px" },
	                      src: "/assets/images/User.png",
	                      alt: "logo2"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "dropdown-menu dropdown-menu-start",
	                      "aria-labelledby": "dropdownMenuButton"
	                    },
	                    patient_user_id ? _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          className: "dropdown-item btn disabled",
	                          href: "/patient-protal"
	                        },
	                        "Patient ID: ",
	                        patient_user_id
	                      ),
	                      _react2.default.createElement(
	                        "a",
	                        { className: "dropdown-item", href: "/patient-protal" },
	                        "My Portal"
	                      ),
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          className: "dropdown-item",
	                          href: "/pages/patientbillhistory"
	                        },
	                        "Bill History"
	                      )
	                    ) : null,
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "dropdown-item",
	                        to: "/pages/packages"
	                        // href={WEBSITEPAGE_URL + hmenu.slug}
	                        // key={hmenu.title}
	                      },
	                      "Packages"
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "dropdown-item",
	                        to: "/pages/departments"
	                        // href={WEBSITEPAGE_URL + hmenu.slug}
	                        // key={hmenu.title}
	                      },
	                      "Departments"
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: "dropdown-item",
	                        to: "/pages/services"
	                        // href={WEBSITEPAGE_URL + hmenu.slug}
	                        // key={hmenu.title}
	                      },
	                      "Services"
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      { className: "dropdown-item", href: "/logout" },
	                      "Logout"
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "li",
	                  { className: "d-flex align-items-center" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dropdown navsdpdw" },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        className: "btn btn-secondary dropdown-toggle dropdownMenu pe-0",
	                        type: "button",
	                        id: "dropdownMenuButton",
	                        "data-toggle": "dropdown",
	                        "aria-haspopup": "true",
	                        "aria-expanded": "false"
	                      },
	                      _react2.default.createElement("img", {
	                        style: { maxWidth: _reactDeviceDetect.isMobile ? "25px" : "30px" },
	                        src: "/assets/images/User.png",
	                        alt: "logo2"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "dropdown-menu",
	                        "aria-labelledby": "dropdownMenuButton"
	                      },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          className: "dropdown-item",
	                          href: "#offcanvasExample",
	                          "data-bs-toggle": "offcanvas",
	                          role: "button",
	                          "aria-controls": "offcanvasExample"
	                        },
	                        "Login/Sign up"
	                      ),
	                      _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        {
	                          className: "dropdown-item",
	                          to: "/pages/packages"
	                          // href={WEBSITEPAGE_URL + hmenu.slug}
	                          // key={hmenu.title}
	                        },
	                        "Packages"
	                      ),
	                      _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        {
	                          className: "dropdown-item",
	                          to: "/pages/departments"
	                          // href={WEBSITEPAGE_URL + hmenu.slug}
	                          // key={hmenu.title}
	                        },
	                        "Departments"
	                      ),
	                      _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        {
	                          className: "dropdown-item",
	                          to: "/pages/services"
	                          // href={WEBSITEPAGE_URL + hmenu.slug}
	                          // key={hmenu.title}
	                        },
	                        "Services"
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "d-block d-md-none" },
	                _react2.default.createElement(_hi.HiMenuAlt3, {
	                  "data-bs-toggle": "offcanvas",
	                  "data-bs-target": "#sideBarMenus",
	                  "aria-controls": "sideBarMenus",
	                  style: { fontSize: "25px", color: "#F58220" }
	                })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row container-fluid" },
	        _react2.default.createElement("div", { className: "col-sm-1" }),
	        _react2.default.createElement(
	          "div",
	          { className: "col-12 col-md-8" },
	          _react2.default.createElement(
	            "div",
	            { className: "search-popup-main " },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "search-popup rounded-bottom",
	                style: {
	                  display: state.showSearchPopup ? "block" : "none",
	                  overflowY: "scroll",
	                  height: "424px",
	                  zIndex: "99999"
	                },
	                onMouseLeave: closeSearchPopUp
	              },
	              _react2.default.createElement(
	                "h4",
	                null,
	                "Specialists"
	              ),
	              _react2.default.createElement("hr", { className: "lists-line" }),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-4" },
	                state.default_doctors && state.default_doctors.length > 0 ? state.default_doctors.map(function (default_search_doctor) {
	                  var doctor_name = default_search_doctor.doctor_name;
	                  var new_doctor_name = doctor_name.replaceAll(" ", "-");
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-md-6 col-sm-12 mt-4 d-flex justify-content-center" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "doctor-list w-100" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: _constants.SITE_URL + "/consultant/" + default_search_doctor.slug,
	                          style: {
	                            textDecoration: "none",
	                            color: "#212529"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-5" },
	                            default_search_doctor.doctor_profile ? _react2.default.createElement("img", {
	                              src: _constants.IMAGE_URL + "/DoctorProfileImg/" + default_search_doctor.doctor_profile,
	                              alt: "Bitmap-3",
	                              style: {
	                                objectFit: "cover",
	                                height: "120px",
	                                width: "100%",
	                                objectPosition: "top"
	                              }
	                            }) : _react2.default.createElement("img", {
	                              src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                              alt: "Bitmap-3",
	                              style: {
	                                objectFit: "cover",
	                                height: "120px",
	                                width: "100%"
	                              }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-7" },
	                            _react2.default.createElement(
	                              "h6",
	                              { style: { fontSize: "14px" } },
	                              default_search_doctor.doctor_name
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              { style: { fontSize: "12px" } },
	                              default_search_doctor.degree
	                            )
	                          )
	                        )
	                      )
	                    )
	                  );
	                }) : _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12 col-md-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "doctor-list" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "p",
	                        { style: { fontSize: "12px" } },
	                        "no result found"
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h4",
	                null,
	                "Departments"
	              ),
	              _react2.default.createElement("hr", { className: "lists-line" }),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-4" },
	                state.default_departments ? state.default_departments.map(function (department) {
	                  var department_name = department.department_name;
	                  // let new_doctor_name = doctor_name.replaceAll(' ', '-');
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-md-12 mt-4" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "doctor-list" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: _constants.SITE_URL + "/departments/" + department.slug,
	                          style: {
	                            textDecoration: "none",
	                            color: "#212529"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row align-items-center" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-5" },
	                            department.image ? _react2.default.createElement("img", {
	                              src: _constants.IMAGE_URL + "/DepartmentImage/" + department.image,
	                              alt: "Bitmap-3",
	                              style: {
	                                objectFit: "contain",
	                                height: "120px",
	                                width: "100%",
	                                padding: "5px"
	                              }
	                            }) : _react2.default.createElement("img", {
	                              src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                              alt: "Bitmap-3",
	                              style: {
	                                objectFit: "contain",
	                                height: "120px",
	                                width: "100%",
	                                padding: "5px"
	                              }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-7" },
	                            _react2.default.createElement(
	                              "h6",
	                              {
	                                className: "m-0 p-0",
	                                style: { fontSize: "14px" }
	                              },
	                              department_name
	                            )
	                          )
	                        )
	                      )
	                    )
	                  );
	                }) : _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12 col-md-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "doctor-list" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "p",
	                        { style: { fontSize: "12px" } },
	                        "no result found"
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h5",
	                null,
	                "Packages"
	              ),
	              _react2.default.createElement("hr", { className: "lists-line" }),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-4" },
	                state.default_packages && state.default_packages.length > 0 ? state.default_packages.map(function (default_search_packages) {
	                  var package_name = default_search_packages.name;
	                  var new_package_name = package_name.replaceAll(" ", "-");
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-sm-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Package-part" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: _constants.SITE_URL + "/packages/" + new_package_name,
	                          style: {
	                            textDecoration: "none",
	                            color: "#212529"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-4 sp-0-search" },
	                            _react2.default.createElement("img", {
	                              src: _constants.IMAGE_URL + "Packagesimg/202303221003packages%20Profile.png",
	                              style: {
	                                objectFit: "cover",
	                                height: "120px",
	                                width: "100%"
	                              },
	                              alt: "icons-rotate"
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-8 sp-0-search bg-color-gry" },
	                            _react2.default.createElement(
	                              "h6",
	                              { style: { fontSize: "16px" } },
	                              default_search_packages.name
	                            )
	                          )
	                        )
	                      )
	                    )
	                  );
	                }) : _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12 col-sm-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "Package-part" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        "No packages found"
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null)
	            )
	          )
	        )
	      )
	    ),
	    state.patientRegPopup ? _react2.default.createElement(_PatientRegistrationPopup2.default, { showpopup: state.showPatientRegPopup }) : null,
	    _react2.default.createElement(_CartPopUp2.default, null),
	    _react2.default.createElement(_BooTestPopUp2.default, null),
	    _react2.default.createElement(_CorporateRequestPopUp2.default, null)
	  );
	};
	
	exports.default = Header;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	var _typeof2 = _interopRequireDefault(__webpack_require__(58));
	var _index = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument);
	
	  // Clone the date
	  if (argument instanceof Date || (0, _typeof2.default)(argument) === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
	      // eslint-disable-next-line no-console
	      console.warn(new Error().stack);
	    }
	    return new Date(NaN);
	  }
	}
	module.exports = exports.default;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var PropTypes = _interopDefault(__webpack_require__(24));
	var withSideEffect = _interopDefault(__webpack_require__(995));
	var isEqual = _interopDefault(__webpack_require__(400));
	var React = _interopDefault(__webpack_require__(1));
	var objectAssign = _interopDefault(__webpack_require__(159));
	
	var ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src",
	    TARGET: "target"
	};
	
	var REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = objectAssign({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
	        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [React.createElement(TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return React.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case ATTRIBUTE_NAMES.BODY:
	        case ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            classCallCheck(this, HelmetWrapper);
	            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !isEqual(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case TAG_NAMES.SCRIPT:
	                case TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _babelHelpers$extends;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _babelHelpers$extends2, _babelHelpers$extends3;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));
	
	                case TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _babelHelpers$extends4;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            React.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = convertReactPropstoHtmlAttributes(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case TAG_NAMES.LINK:
	                    case TAG_NAMES.META:
	                    case TAG_NAMES.NOSCRIPT:
	                    case TAG_NAMES.SCRIPT:
	                    case TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return React.createElement(Component, newProps);
	        };
	
	        createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set$$1(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	        return HelmetWrapper;
	    }(React.Component), _class.propTypes = {
	        base: PropTypes.object,
	        bodyAttributes: PropTypes.object,
	        children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	        defaultTitle: PropTypes.string,
	        defer: PropTypes.bool,
	        encodeSpecialCharacters: PropTypes.bool,
	        htmlAttributes: PropTypes.object,
	        link: PropTypes.arrayOf(PropTypes.object),
	        meta: PropTypes.arrayOf(PropTypes.object),
	        noscript: PropTypes.arrayOf(PropTypes.object),
	        onChangeClientState: PropTypes.func,
	        script: PropTypes.arrayOf(PropTypes.object),
	        style: PropTypes.arrayOf(PropTypes.object),
	        title: PropTypes.string,
	        titleAttributes: PropTypes.object,
	        titleTemplate: PropTypes.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = mapStateOnServer({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = withSideEffect(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.7.1
	 * https://jquery.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-08-28T13:37Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var version = "3.7.1",
	
		rhtmlSuffix = /HTML$/i,
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
	
		// Retrieve the text value of an array of DOM nodes
		text: function( elem ) {
			var node,
				ret = "",
				i = 0,
				nodeType = elem.nodeType;
	
			if ( !nodeType ) {
	
				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {
	
					// Do not traverse comment nodes
					ret += jQuery.text( node );
				}
			}
			if ( nodeType === 1 || nodeType === 11 ) {
				return elem.textContent;
			}
			if ( nodeType === 9 ) {
				return elem.documentElement.textContent;
			}
			if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}
	
			// Do not include comment or processing instruction nodes
	
			return ret;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		isXMLDoc: function( elem ) {
			var namespace = elem && elem.namespaceURI,
				docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var pop = arr.pop;
	
	
	var sort = arr.sort;
	
	
	var splice = arr.splice;
	
	
	var whitespace = "[\\x20\\t\\r\\n\\f]";
	
	
	var rtrimCSS = new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	
	
	
	// Note: an element does not contain itself
	jQuery.contains = function( a, b ) {
		var bup = b && b.parentNode;
	
		return a === bup || !!( bup && bup.nodeType === 1 && (
	
			// Support: IE 9 - 11+
			// IE doesn't have `contains` on SVG.
			a.contains ?
				a.contains( bup ) :
				a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	};
	
	
	
	
	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
	
	function fcssescape( ch, asCodePoint ) {
		if ( asCodePoint ) {
	
			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}
	
			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}
	
		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}
	
	jQuery.escapeSelector = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	
	
	
	var preferredDoc = document,
		pushNative = push;
	
	( function() {
	
	var i,
		Expr,
		outermostContext,
		sortInput,
		hasDuplicate,
		push = pushNative,
	
		// Local document vars
		document,
		documentElement,
		documentIsHTML,
		rbuggyQSA,
		matches,
	
		// Instance-specific data
		expando = jQuery.expando,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
			"loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
			whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			ID: new RegExp( "^#(" + identifier + ")" ),
			CLASS: new RegExp( "^\\.(" + identifier + ")" ),
			TAG: new RegExp( "^(" + identifier + "|[*])" ),
			ATTR: new RegExp( "^" + attributes ),
			PSEUDO: new RegExp( "^" + pseudos ),
			CHILD: new RegExp(
				"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
					whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
					whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			bool: new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			needsContext: new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			if ( nonHex ) {
	
				// Strip the backslash prefix from a non-hex escape sequence
				return nonHex;
			}
	
			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			return high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes; see `setDocument`.
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE/Edge.
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && nodeName( elem, "fieldset" );
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android <=4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = {
			apply: function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			},
			call: function( target ) {
				pushNative.apply( target, slice.call( arguments, 1 ) );
			}
		};
	}
	
	function find( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									push.call( results, elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								find.contains( context, elem ) &&
								elem.id === m ) {
	
								push.call( results, elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( !nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when
						// strict-comparing two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( newContext != context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = jQuery.escapeSelector( nid );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties
			// (see https://github.com/jquery/sizzle/issues/157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by jQuery selector module
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			return nodeName( elem, "input" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
				elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11+
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a jQuery selector context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [node] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	function setDocument( node ) {
		var subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		documentElement = document.documentElement;
		documentIsHTML = !jQuery.isXMLDoc( document );
	
		// Support: iOS 7 only, IE 9 - 11+
		// Older browsers didn't support unprefixed `matches`.
		matches = documentElement.matches ||
			documentElement.webkitMatchesSelector ||
			documentElement.msMatchesSelector;
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors
		// (see trac-13936).
		// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
		// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
		if ( documentElement.msMatchesSelector &&
	
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 9 - 11+, Edge 12 - 18+
			subWindow.addEventListener( "unload", unloadHandler );
		}
	
		// Support: IE <10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			documentElement.appendChild( el ).id = jQuery.expando;
			return !document.getElementsByName ||
				!document.getElementsByName( jQuery.expando ).length;
		} );
	
		// Support: IE 9 only
		// Check to see if it's possible to do matchesSelector
		// on a disconnected node.
		support.disconnectedMatch = assert( function( el ) {
			return matches.call( el, "*" );
		} );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// IE/Edge don't support the :scope pseudo-class.
		support.scope = assert( function() {
			return document.querySelectorAll( ":scope" );
		} );
	
		// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
		// Make sure the `:has()` argument is parsed unforgivingly.
		// We include `*` in the test to detect buggy implementations that are
		// _selectively_ forgiving (specifically when the list includes at least
		// one valid selector).
		// Note that we treat complete lack of support for `:has()` as if it were
		// spec-compliant support, which is fine because use of `:has()` in such
		// environments will fail in the qSA path and fall back to jQuery traversal
		// anyway.
		support.cssHas = assert( function() {
			try {
				document.querySelector( ":has(*,:jqfake)" );
				return false;
			} catch ( e ) {
				return true;
			}
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter.ID = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter.ID =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find.TAG = function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );
	
			// DocumentFragment nodes don't have gEBTN
			} else {
				return context.querySelectorAll( tag );
			}
		};
	
		// Class
		Expr.find.CLASS = function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		rbuggyQSA = [];
	
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {
	
			var input;
	
			documentElement.appendChild( el ).innerHTML =
				"<a id='" + expando + "' href='' disabled='disabled'></a>" +
				"<select id='" + expando + "-\r\\' disabled='disabled'>" +
				"<option selected=''></option></select>";
	
			// Support: iOS <=7 - 8 only
			// Boolean attributes and "value" are not treated correctly in some XML documents
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}
	
			// Support: iOS <=7 - 8 only
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}
	
			// Support: iOS 8 only
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}
	
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}
	
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );
	
			// Support: IE 9 - 11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			documentElement.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}
	
			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}
		} );
	
		if ( !support.cssHas ) {
	
			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Our regular `try-catch` mechanism fails to detect natively-unsupported
			// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
			// in browsers that parse the `:has()` argument as a forgiving selector list.
			// https://drafts.csswg.org/selectors/#relational now requires the argument
			// to be parsed unforgivingly, but browsers have not yet fully adjusted.
			rbuggyQSA.push( ":has" );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a === document || a.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b === document || b.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		};
	
		return document;
	}
	
	find.matches = function( expr, elements ) {
		return find( expr, null, null, elements );
	};
	
	find.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return find( expr, document, null, [ elem ] ).length > 0;
	};
	
	find.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return jQuery.contains( context, elem );
	};
	
	
	find.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (see trac-13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		if ( val !== undefined ) {
			return val;
		}
	
		return elem.getAttribute( name );
	};
	
	find.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	jQuery.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		//
		// Support: Android <=4.0+
		// Testing for detecting duplicates is unpredictable so instead assume we can't
		// depend on duplicate detection in all browsers without a stable sort.
		hasDuplicate = !support.sortStable;
		sortInput = !support.sortStable && slice.call( results, 0 );
		sort.call( results, sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				splice.call( results, duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	jQuery.fn.uniqueSort = function() {
		return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
	};
	
	Expr = jQuery.expr = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			ATTR: function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
					.replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			CHILD: function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						find.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
					);
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					find.error( match[ 0 ] );
				}
	
				return match;
			},
	
			PSEUDO: function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			TAG: function( nodeNameSelector ) {
				var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return nodeName( elem, expectedNodeName );
					};
			},
	
			CLASS: function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace + ")" + className +
						"(" + whitespace + "|$)" ) ) &&
					classCache( className, function( elem ) {
						return pattern.test(
							typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
						);
					} );
			},
	
			ATTR: function( name, operator, check ) {
				return function( elem ) {
					var result = find.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					if ( operator === "=" ) {
						return result === check;
					}
					if ( operator === "!=" ) {
						return result !== check;
					}
					if ( operator === "^=" ) {
						return check && result.indexOf( check ) === 0;
					}
					if ( operator === "*=" ) {
						return check && result.indexOf( check ) > -1;
					}
					if ( operator === "$=" ) {
						return check && result.slice( -check.length ) === check;
					}
					if ( operator === "~=" ) {
						return ( " " + result.replace( rwhitespace, " " ) + " " )
							.indexOf( check ) > -1;
					}
					if ( operator === "|=" ) {
						return result === check || result.slice( 0, check.length + 1 ) === check + "-";
					}
	
					return false;
				};
			},
	
			CHILD: function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || ( parent[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
									outerCache = elem[ expando ] || ( elem[ expando ] = {} );
									cache = outerCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
												outerCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			PSEUDO: function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// https://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						find.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as jQuery does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			not: markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrimCSS, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element
						// (see https://github.com/jquery/sizzle/issues/299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			has: markFunction( function( selector ) {
				return function( elem ) {
					return find( selector, elem ).length > 0;
				};
			} ),
	
			contains: markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// https://www.w3.org/TR/selectors/#lang-pseudo
			lang: markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					find.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			target: function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			root: function( elem ) {
				return elem === documentElement;
			},
	
			focus: function( elem ) {
				return elem === safeActiveElement() &&
					document.hasFocus() &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			enabled: createDisabledPseudo( false ),
			disabled: createDisabledPseudo( true ),
	
			checked: function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				return ( nodeName( elem, "input" ) && !!elem.checked ) ||
					( nodeName( elem, "option" ) && !!elem.selected );
			},
	
			selected: function( elem ) {
	
				// Support: IE <=11+
				// Accessing the selectedIndex property
				// forces the browser to treat the default option as
				// selected when in an optgroup.
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			empty: function( elem ) {
	
				// https://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			parent: function( elem ) {
				return !Expr.pseudos.empty( elem );
			},
	
			// Element/input types
			header: function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			input: function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			button: function( elem ) {
				return nodeName( elem, "input" ) && elem.type === "button" ||
					nodeName( elem, "button" );
			},
	
			text: function( elem ) {
				var attr;
				return nodeName( elem, "input" ) && elem.type === "text" &&
	
					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear
					// with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			first: createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			last: createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			even: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			odd: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i;
	
				if ( argument < 0 ) {
					i = argument + length;
				} else if ( argument > length ) {
					i = length;
				} else {
					i = argument;
				}
	
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos.nth = Expr.pseudos.eq;
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	function tokenize( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrimCSS, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		if ( parseOnly ) {
			return soFar.length;
		}
	
		return soFar ?
			find.error( selector ) :
	
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
	}
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							if ( skip && nodeName( elem, skip ) ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = outerCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			find( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem, matcherOut,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed ||
					multipleContexts( selector || "*",
						context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems;
	
			if ( matcher ) {
	
				// If we have a postFinder, or filtered seed, or non-seed postFilter
				// or preexisting results,
				matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results;
	
				// Find primary matches
				matcher( matcherIn, matcherOut, context, xml );
			} else {
				matcherOut = matcherIn;
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element
				// (see https://github.com/jquery/sizzle/issues/299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 )
								.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrimCSS, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find.TAG( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: iOS <=7 - 9 only
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
				// elements by id. (see trac-14142)
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								push.call( results, elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						jQuery.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	function compile( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	}
	
	/**
	 * A low-level selection function that works with jQuery's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with jQuery selector compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	function select( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find.ID(
					token.matches[ 0 ].replace( runescape, funescape ),
					context
				) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) &&
							testContext( context.parentNode ) || context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	}
	
	// One-time assignments
	
	// Support: Android <=4.0 - 4.1+
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Android <=4.0 - 4.1+
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	jQuery.find = find;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.unique = jQuery.uniqueSort;
	
	// These have always been private, but they used to be documented as part of
	// Sizzle so let's maintain them for now for backwards compatibility purposes.
	find.compile = compile;
	find.select = select;
	find.setDocument = setDocument;
	find.tokenize = tokenize;
	
	find.escape = jQuery.escapeSelector;
	find.getText = jQuery.text;
	find.isXML = jQuery.isXMLDoc;
	find.selectors = jQuery.expr;
	find.support = jQuery.support;
	find.uniqueSort = jQuery.uniqueSort;
	
		/* eslint-enable */
	
	} )();
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to jQuery#find
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.error );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the error, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getErrorHook ) {
										process.error = jQuery.Deferred.getErrorHook();
	
									// The deprecated alias of the above. While the name suggests
									// returning the stack, not an error instance, jQuery just passes
									// it directly to `console.warn` so both will work; an instance
									// just better cooperates with source maps.
									} else if ( jQuery.Deferred.getStackHook ) {
										process.error = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
	// captured before the async barrier to get the original error cause
	// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function( error, asyncError ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message,
				error.stack, asyncError );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", true );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, isSetup ) {
	
		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if ( !isSetup ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					if ( !saved ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						this[ type ]();
						result = dataPriv.get( this, type );
						dataPriv.set( this, type, false );
	
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							return result;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering
					// the native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved ) {
	
					// ...and capture the result
					dataPriv.set( this, type, jQuery.event.trigger(
						saved[ 0 ],
						saved.slice( 1 ),
						this
					) );
	
					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	
		function focusMappedHandler( nativeEvent ) {
			if ( document.documentMode ) {
	
				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.
	
				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get( this, "handle" ),
					event = jQuery.event.fix( nativeEvent );
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;
	
				// First, handle focusin/focusout
				handle( nativeEvent );
	
				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if ( event.target === event.currentTarget ) {
	
					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle( event );
				}
			} else {
	
				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate( delegateType, nativeEvent.target,
					jQuery.event.fix( nativeEvent ) );
			}
		}
	
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				var attaches;
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, true );
	
				if ( document.documentMode ) {
	
					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get( this, delegateType );
					if ( !attaches ) {
						this.addEventListener( delegateType, focusMappedHandler );
					}
					dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
				} else {
	
					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			teardown: function() {
				var attaches;
	
				if ( document.documentMode ) {
					attaches = dataPriv.get( this, delegateType ) - 1;
					if ( !attaches ) {
						this.removeEventListener( delegateType, focusMappedHandler );
						dataPriv.remove( this, delegateType );
					} else {
						dataPriv.set( this, delegateType, attaches );
					}
				} else {
	
					// Return false to indicate standard teardown should be applied
					return false;
				}
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[ delegateType ] = {
			setup: function() {
	
				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType );
	
				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.addEventListener( delegateType, focusMappedHandler );
					} else {
						doc.addEventListener( type, focusMappedHandler, true );
					}
				}
				dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType ) - 1;
	
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.removeEventListener( delegateType, focusMappedHandler );
					} else {
						doc.removeEventListener( type, focusMappedHandler, true );
					}
					dataPriv.remove( dataHolder, delegateType );
				} else {
					dataPriv.set( dataHolder, delegateType, attaches );
				}
			}
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Re-enable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var rcustomProp = /^--/;
	
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
	
			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( isCustomProp && ret ) {
	
				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0,
			marginDelta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if ( box === "margin" ) {
				marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta + marginDelta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,
	
			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this
				.on( "mouseenter", fnOver )
				.on( "mouseleave", fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(184);
	function _defineProperty(e, r, t) {
	  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
	    value: t,
	    enumerable: !0,
	    configurable: !0,
	    writable: !0
	  }) : e[r] = t, e;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 20 */
/***/ function(module, exports) {

	function _classCallCheck(a, n) {
	  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(184);
	function _defineProperties(e, r) {
	  for (var t = 0; t < r.length; t++) {
	    var o = r[t];
	    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
	  }
	}
	function _createClass(e, r, t) {
	  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
	    writable: !1
	  }), e;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 22 */
/***/ function(module, exports) {

	function _assertThisInitialized(e) {
	  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  return e;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(183);
	function _inherits(t, e) {
	  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
	  t.prototype = Object.create(e && e.prototype, {
	    constructor: {
	      value: t,
	      writable: !0,
	      configurable: !0
	    }
	  }), Object.defineProperty(t, "prototype", {
	    writable: !1
	  }), e && setPrototypeOf(t, e);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(941)();
	}


/***/ },
/* 25 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInteger;
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	  var number = Number(dirtyNumber);
	  if (isNaN(number)) {
	    return number;
	  }
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	module.exports = exports.default;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.deleteProps = deleteProps;
	exports.nextTick = nextTick;
	exports.now = now;
	exports.getTranslate = getTranslate;
	exports.isObject = isObject;
	exports.extend = extend;
	exports.bindModuleMethods = bindModuleMethods;
	exports.getComputedStyle = getComputedStyle;
	exports.classesToSelector = classesToSelector;
	exports.createElementIfNotDefined = createElementIfNotDefined;
	
	var _ssrWindow = __webpack_require__(41);
	
	function deleteProps(obj) {
	  var object = obj;
	  Object.keys(object).forEach(function (key) {
	    try {
	      object[key] = null;
	    } catch (e) {// no getter for object
	    }
	
	    try {
	      delete object[key];
	    } catch (e) {// something got wrong
	    }
	  });
	}
	
	function nextTick(callback, delay) {
	  if (delay === void 0) {
	    delay = 0;
	  }
	
	  return setTimeout(callback, delay);
	}
	
	function now() {
	  return Date.now();
	}
	
	function getComputedStyle(el) {
	  var window = (0, _ssrWindow.getWindow)();
	  var style;
	
	  if (window.getComputedStyle) {
	    style = window.getComputedStyle(el, null);
	  }
	
	  if (!style && el.currentStyle) {
	    style = el.currentStyle;
	  }
	
	  if (!style) {
	    style = el.style;
	  }
	
	  return style;
	}
	
	function getTranslate(el, axis) {
	  if (axis === void 0) {
	    axis = 'x';
	  }
	
	  var window = (0, _ssrWindow.getWindow)();
	  var matrix;
	  var curTransform;
	  var transformMatrix;
	  var curStyle = getComputedStyle(el, null);
	
	  if (window.WebKitCSSMatrix) {
	    curTransform = curStyle.transform || curStyle.webkitTransform;
	
	    if (curTransform.split(',').length > 6) {
	      curTransform = curTransform.split(', ').map(function (a) {
	        return a.replace(',', '.');
	      }).join(', ');
	    } // Some old versions of Webkit choke when 'none' is passed; pass
	    // empty string instead in this case
	
	
	    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	  } else {
	    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	    matrix = transformMatrix.toString().split(',');
	  }
	
	  if (axis === 'x') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
	      else curTransform = parseFloat(matrix[4]);
	  }
	
	  if (axis === 'y') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
	      else curTransform = parseFloat(matrix[5]);
	  }
	
	  return curTransform || 0;
	}
	
	function isObject(o) {
	  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
	}
	
	function isNode(node) {
	  // eslint-disable-next-line
	  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
	    return node instanceof HTMLElement;
	  }
	
	  return node && (node.nodeType === 1 || node.nodeType === 11);
	}
	
	function extend() {
	  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
	  var noExtend = ['__proto__', 'constructor', 'prototype'];
	
	  for (var i = 1; i < arguments.length; i += 1) {
	    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
	
	    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
	      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
	        return noExtend.indexOf(key) < 0;
	      });
	
	      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	        var nextKey = keysArray[nextIndex];
	        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	
	        if (desc !== undefined && desc.enumerable) {
	          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
	            if (nextSource[nextKey].__swiper__) {
	              to[nextKey] = nextSource[nextKey];
	            } else {
	              extend(to[nextKey], nextSource[nextKey]);
	            }
	          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
	            to[nextKey] = {};
	
	            if (nextSource[nextKey].__swiper__) {
	              to[nextKey] = nextSource[nextKey];
	            } else {
	              extend(to[nextKey], nextSource[nextKey]);
	            }
	          } else {
	            to[nextKey] = nextSource[nextKey];
	          }
	        }
	      }
	    }
	  }
	
	  return to;
	}
	
	function bindModuleMethods(instance, obj) {
	  Object.keys(obj).forEach(function (key) {
	    if (isObject(obj[key])) {
	      Object.keys(obj[key]).forEach(function (subKey) {
	        if (typeof obj[key][subKey] === 'function') {
	          obj[key][subKey] = obj[key][subKey].bind(instance);
	        }
	      });
	    }
	
	    instance[key] = obj[key];
	  });
	}
	
	function classesToSelector(classes) {
	  if (classes === void 0) {
	    classes = '';
	  }
	
	  return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
	  .replace(/ /g, '.');
	}
	
	function createElementIfNotDefined($container, params, createElements, checkProps) {
	  var document = (0, _ssrWindow.getDocument)();
	
	  if (createElements) {
	    Object.keys(checkProps).forEach(function (key) {
	      if (!params[key] && params.auto === true) {
	        var element = document.createElement('div');
	        element.className = checkProps[key];
	        $container.append(element);
	        params[key] = element;
	      }
	    });
	  }
	
	  return params;
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototypeOf = __webpack_require__(108);
	var isNativeReflectConstruct = __webpack_require__(463);
	var possibleConstructorReturn = __webpack_require__(109);
	function _createSuper(t) {
	  var r = isNativeReflectConstruct();
	  return function () {
	    var e,
	      o = getPrototypeOf(t);
	    if (r) {
	      var s = getPrototypeOf(this).constructor;
	      e = Reflect.construct(o, arguments, s);
	    } else e = o.apply(this, arguments);
	    return possibleConstructorReturn(this, e);
	  };
	}
	module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Setter = __webpack_require__(227);
	var Parser = /*#__PURE__*/function () {
	  function Parser() {
	    (0, _classCallCheck2.default)(this, Parser);
	    (0, _defineProperty2.default)(this, "incompatibleTokens", void 0);
	    (0, _defineProperty2.default)(this, "priority", void 0);
	    (0, _defineProperty2.default)(this, "subPriority", void 0);
	  }
	  (0, _createClass2.default)(Parser, [{
	    key: "run",
	    value: function run(dateString, token, match, options) {
	      var result = this.parse(dateString, token, match, options);
	      if (!result) {
	        return null;
	      }
	      return {
	        setter: new _Setter.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
	        rest: result.rest
	      };
	    }
	  }, {
	    key: "validate",
	    value: function validate(_utcDate, _value, _options) {
	      return true;
	    }
	  }]);
	  return Parser;
	}();
	exports.Parser = Parser;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dayPeriodEnumToHours = dayPeriodEnumToHours;
	exports.isLeapYearIndex = isLeapYearIndex;
	exports.mapValue = mapValue;
	exports.normalizeTwoDigitYear = normalizeTwoDigitYear;
	exports.parseAnyDigitsSigned = parseAnyDigitsSigned;
	exports.parseNDigits = parseNDigits;
	exports.parseNDigitsSigned = parseNDigitsSigned;
	exports.parseNumericPattern = parseNumericPattern;
	exports.parseTimezonePattern = parseTimezonePattern;
	var _index = __webpack_require__(224);
	var _constants = __webpack_require__(47);
	function mapValue(parseFnResult, mapFn) {
	  if (!parseFnResult) {
	    return parseFnResult;
	  }
	  return {
	    value: mapFn(parseFnResult.value),
	    rest: parseFnResult.rest
	  };
	}
	function parseNumericPattern(pattern, dateString) {
	  var matchResult = dateString.match(pattern);
	  if (!matchResult) {
	    return null;
	  }
	  return {
	    value: parseInt(matchResult[0], 10),
	    rest: dateString.slice(matchResult[0].length)
	  };
	}
	function parseTimezonePattern(pattern, dateString) {
	  var matchResult = dateString.match(pattern);
	  if (!matchResult) {
	    return null;
	  }
	
	  // Input is 'Z'
	  if (matchResult[0] === 'Z') {
	    return {
	      value: 0,
	      rest: dateString.slice(1)
	    };
	  }
	  var sign = matchResult[1] === '+' ? 1 : -1;
	  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	  return {
	    value: sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * _index.millisecondsInSecond),
	    rest: dateString.slice(matchResult[0].length)
	  };
	}
	function parseAnyDigitsSigned(dateString) {
	  return parseNumericPattern(_constants.numericPatterns.anyDigitsSigned, dateString);
	}
	function parseNDigits(n, dateString) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(_constants.numericPatterns.singleDigit, dateString);
	    case 2:
	      return parseNumericPattern(_constants.numericPatterns.twoDigits, dateString);
	    case 3:
	      return parseNumericPattern(_constants.numericPatterns.threeDigits, dateString);
	    case 4:
	      return parseNumericPattern(_constants.numericPatterns.fourDigits, dateString);
	    default:
	      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
	  }
	}
	function parseNDigitsSigned(n, dateString) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(_constants.numericPatterns.singleDigitSigned, dateString);
	    case 2:
	      return parseNumericPattern(_constants.numericPatterns.twoDigitsSigned, dateString);
	    case 3:
	      return parseNumericPattern(_constants.numericPatterns.threeDigitsSigned, dateString);
	    case 4:
	      return parseNumericPattern(_constants.numericPatterns.fourDigitsSigned, dateString);
	    default:
	      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
	  }
	}
	function dayPeriodEnumToHours(dayPeriod) {
	  switch (dayPeriod) {
	    case 'morning':
	      return 4;
	    case 'evening':
	      return 17;
	    case 'pm':
	    case 'noon':
	    case 'afternoon':
	      return 12;
	    case 'am':
	    case 'midnight':
	    case 'night':
	    default:
	      return 0;
	  }
	}
	function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	  var isCommonEra = currentYear > 0;
	  // Absolute number of the current year:
	  // 1 -> 1 AC
	  // 0 -> 1 BC
	  // -1 -> 2 BC
	  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	  var result;
	  if (absCurrentYear <= 50) {
	    result = twoDigitYear || 100;
	  } else {
	    var rangeEnd = absCurrentYear + 50;
	    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
	    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
	    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	  }
	  return isCommonEra ? result : 1 - result;
	}
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.endUserSession = exports.startUserSession = exports.userTokenRefreshInterval = undefined;
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	//import { TWENTY_MINUTES_TIME_IN_MILLISECONDS, API_TOKEN_NAME, API_TOKEN_EXPIRY_NAME, USER_ROLE, USER_ID, USER_CREATED_BY, USER_EMAIL, IS_ACTIVE, RGSTEP1, RGSTEP2, RGSTEP3, RGSTEP4, LOGIN_PHONE_NUMBER, SEARCH_SELECTED_DOC_ID, SCHEDULE_DATE, APPOINTMENT_ID, DOCTOR_NAME, DOCTOR_FEES, PATIENT_NAME, SCHEDULE_TIME } from "./constants";
	var userTokenRefreshIntervalId = "";
	
	var userTokenRefreshApi = function userTokenRefreshApi() {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request("/refresh", {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var userTokenRefreshInterval = exports.userTokenRefreshInterval = function userTokenRefreshInterval() {
	  userTokenRefreshApi().then(function (res) {
	    /* eslint-disable */
	    startUserSession(res.access_token);
	  }).catch(function (err) {
	    console.log("Error refreshing user token.", err);
	    alert("Error refreshing user token.", err);
	  });
	};
	var startUserSession = exports.startUserSession = function startUserSession(token, user_role, user_email, user_id, login_phone_number, search_selected_doc_id, schedule_date, apointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name, doctor_profile_avability) {
	  var localId = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : "";
	  var date_of_birth = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : "1970-01-01";
	
	  var local_Id = localStorage.getItem(_constants.USER_LOCAL_ID) || localId;
	  var date_o_birth = localStorage.getItem(_constants.PATIENT_DATE_OF_BIRTH) || date_of_birth;
	
	  localStorage.setItem(_constants.API_TOKEN_NAME, token);
	  localStorage.setItem(_constants.USER_ROLE, user_role);
	  localStorage.setItem(_constants.USER_EMAIL, user_email);
	  localStorage.setItem(_constants.USER_ID, user_id);
	  localStorage.setItem(_constants.LOGIN_PHONE_NUMBER, login_phone_number);
	  localStorage.setItem(_constants.SEARCH_SELECTED_DOC_ID, search_selected_doc_id);
	  localStorage.setItem(_constants.SCHEDULE_DATE, schedule_date);
	  localStorage.setItem(_constants.APPOINTMENT_ID, apointment_id);
	  localStorage.setItem(_constants.DOCTOR_NAME, doctor_name);
	  localStorage.setItem(_constants.DOCTOR_FEES, doctor_fees);
	  localStorage.setItem(_constants.PATIENT_NAME, patientName);
	  localStorage.setItem(_constants.SCHEDULE_TIME, schedule_time);
	  localStorage.setItem(_constants.SEARCH_SELECTED_DOC_NAME, search_selected_doc_name);
	  localStorage.setItem(_constants.DOCTOR_PROFILE_AVABILITY, doctor_profile_avability);
	  localStorage.setItem(_constants.USER_LOCAL_ID, local_Id);
	  localStorage.setItem(_constants.PATIENT_DATE_OF_BIRTH, date_o_birth);
	  //localStorage.setItem(USER_EMAIL, user_email);
	  //localStorage.setItem(IS_ACTIVE, isActive);
	
	  /*localStorage.setItem(RGSTEP1, reg_step_1);
	    localStorage.setItem(RGSTEP2, reg_step_2);
	    localStorage.setItem(RGSTEP3, reg_step_3);
	    localStorage.setItem(RGSTEP4, reg_step_4);*/
	
	  var datetime = new Date();
	  datetime.setMinutes(datetime.getMinutes() + 999);
	  localStorage.setItem(_constants.API_TOKEN_EXPIRY_NAME, datetime);
	
	  clearInterval(userTokenRefreshIntervalId);
	  userTokenRefreshIntervalId = setInterval(userTokenRefreshInterval, _constants.TWENTY_MINUTES_TIME_IN_MILLISECONDS);
	};
	
	var endUserSession = exports.endUserSession = function endUserSession() {
	  clearInterval(userTokenRefreshIntervalId);
	  localStorage.clear();
	};

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = "data:image/webp;base64,UklGRiIFAABXRUJQVlA4WAoAAAAQAAAAOwAAGwAAQUxQSMYEAAABkLZt2yG3K3pmlrGdVLFt29o6rN3GRm0jtm2zbmOztm3Ph3m3iogJADSnrLSZW0BC5Y1vv562bpaA/5pn2To7w7jZHwTyS5shO1FnTgsdAJB24xXAEPNsaL+Hq/omSmjVfv324SuCIEa02Bg2iqftl1eZr7tzXamisK4EVT6oiPu36BYOpgELL7du9/Xw39H89BdBEEQpN5sW8fSsnrFLWxpy7oRU3qzxGbpe81sUa2N8bUaSAw+QefROvSAI4q0rmwsqhTlDQecOdGwut7jTO1hRm1j1O5ixKQhVhPEDAHB5SQIwPCcIgkiiIGSHe66H97nWH2j3m1p/5VJSyPiF2t9Z4EkD3UV0AAC+iPQgHADMJwmiTwiBWezwlVgtt8zGR2q9tdH2haJrwxfT2TG8ZcQZ3DQAwHXLGx3LhAAAFr8mHikicDqGMTEgUygMDJA4E0MoOoiYUAEARKKnCg3PFPGRGOnEezeEbLK6VbIQCV/jEzEXJXdUGOE6z2geAIBS09115oWXdkcLAwBYvPwZgtB/0dT7QHllpKx2XFficTVWgpFO/BrnYRmEzzxLHAA48h+NJw1mb61LCSXxdb2O4EfcmZqejHzwOLvy/NS+3siBhuT4i3dODqA8DeQAAASu7PP7eHN/3zafUh4AgMO3VoqSDEfsl/QlPestvBxTt7/neKv14uTh27n9qCXuAiQssdm8+CORxZ2UTiUFNTirkHS6xbU6l/SNBe8dm4ht8+0YSSmbmDrZIYUIDaSSQPDI1Zn8w6Np192AvCnO2JTEoUhjKjFktXl41VWklLjn6AmIq6vOVaQhjgcDmq/s9iG9gXs+VMRmWwMDEvBpSmAAwC3Ixwm/jc9XokPJURqbArv02fEgQHL4C1hKkCSqb1zSpgriATknAjBBOnDxcOC8PBgYDV4PhLY2fhT47Ssfy1NCiZmAkyjJeXTxPuftF6PD6vNCQ7u3axXUHHKvqdAEz4cP4uH0MwM2njfuTd0u1gYABq+sAC+Lg8Q6JyZoNbRjOLU259j1u9dSu0/3lD55vgs8nt7eoBb0dT+GcLyaqCZhktqpBriCEBeo2QHZbOZoZ2LvvpHUutwjU4NV+89nXSl4eC4QS5qcebbM+uUNHZJAIQsAgLZtNy6ujAHNWxzBGXvujFx0ZxgrPthzbeN2pbSp8w7FhVrg3piZ6SQ9QZQLAIBmKIUEfPGqukwAbRtAU/joQOOj0phMGs5Hx0PGI6hcPBhgvAwGk55GfDvCD6CmAWgXL34AUW9elKg3t4Uu/KZAjKkUBQDmuTMBAGxfEF9LNHAcQ9D0lgkDCHpLAdpgYG7qTj7L+TR1M0F5XVXJHXbdpuLWst5dwiTGqZ/Er+v7TUS4aFyi5olbRACkWLLA7taZ0WMZ012BoxM72saHA2sjXuxKmunZ0SVCAqnSbwTx6+VgXU5DT703E7hNWJLwWyM5fT7n9vbP7OnZ3pBy3qpX5+DVhzmdKBCOGv/0iyB+vuhYJ84hYb7UiBN+Z3BeSlJbd/+2lieNw5fHIs8Zje4fm76T1S6MAnwOK2L79gPhLFtLJyd1Hvht0YU8Fnra8S5iayNsL2QGSHgKuruyNvtZujLZoBki4hJi3Bj8fd4d+vCnVlA4IDYAAACQAwCdASo8ABwAPpFCnUolo6KhqAgAsBIJaQAAPZ16AZBcaRwAAP7rBvEpD8/vjJYMTAfCAAA="

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/banner-profile.f160a4c1.jpg";

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = "data:image/webp;base64,UklGRjoCAABXRUJQVlA4WAoAAAAQAAAAJAAAIgAAQUxQSNwBAAABkBttmxwpbwjKQB0B1QGIqg6BW65cvD8EYcndwt5DGWi4Mf8iAU0AbYzXZsvaBVQ1P4cOTj8iJoA/3yvgJ6A4/aJQgDcgGBAmwPl9hxawAvz0kwIq+5oToAFQoG3BmdvmHHAK0DpAgAcB2h7wxZpMHqRlr3pozK/RTx5wclDtm3tyUO2bAmisYWujFBe2cxKYPKuOn4uj7e9ZdIA3fQCo2dQWxXGhx/Vm1kLRnCYAJ6cjjdnkoTU73p/MAjRm5tykTfHT4snMA5NNjgdmB0DMerZ7sx54YHYBHM0K4GTTSjiqHnhg1gCtWQBaswD0Zs6p6rEghBBoVD3QqBZAUPVAo+qLEILnv1tKCXUFSAnUIuXKeAlVBzJS3iqV1UAagDFqWlFdIsN4Rs8lVGkGVCV3OVe3o+qcB9U6xwwaL1MWGIa5Br09V9WQZY6dqmTR1MlPtV2qQBKNoJoG1SiqeeVSMlWqImmgS3SpQmOZP8U0ZNWoXRpincZU8QfXQi3lpstyaay3XCYub/eMC1m2iCK5ymmUdCtzmp/fXp7zy5SqHVljVmX+eDtgjJqZqS+j7FAk68j8orsVYxwyZ4a4Z4gM6XHKw2XMlaX8JEm8fTOnIXVbdhp/YqXVn/BrAVZQOCA4AAAAcAMAnQEqJQAjAD6ROphIJaMioS4oALASCWkA0ugoMnp91AYAAP7rAQk4ATNT8If86///IaUdgAA="

/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports = "data:image/webp;base64,UklGRn4CAABXRUJQVlA4WAoAAAAQAAAAOAAAIgAAQUxQSBUCAAABoGNbmyLJ+Zbw72BiBX3+Dcw5vz2Y3owZQyIrxCz95pgpWEBYYkixLJ0QsxSWGMISQ4hZn1HVWZUlsCNiAvCvarprBkvDDU/9TJI17tLZ22MYGvevuivB74NMnN1lN4YkWRsnd/eyjmUnYkQcmwvWivcV2g5YBGoNmCnTSl5OEqAZG2aS3y3nUCg2nkiGpUJEwhalk0eWSohhG3Dy/HKOrcpyMsSwHVResZAFx5ZHmi4kW/MitpBtL2Ep34QFGKnAFNRqQ/A5pc/S+8Z5xhEoBDDCxKMwz2GZhXfqvMQBYDF+wn6T0UlabN1hhRN93hsMsyYGKMeRzyU+mWiZcWTKlNZip82bmGe1BiTGdyiRKROFqCyVZ5lQKPMSGeaJtB6/L8iUVtELarPslzCGXjFfyTonkeRNF3DEB58JM3qPiY1ZyM68ARqZZT+ElE4MwU2ejMEN5gb1AQie3DZxklX3A1IC9LmHMUVsGIrKsOb2R9ZIJcmsayTWCOASHhBGSACgAjEVWNlrGaLAly+tgXau9lJKZVEA9jQ9U0dyRK2Md5E86C2Tib2A59chlJXVEgGYW2mlMdASA+soH3b8mUseKHFq9Qh1H0C9vPbBG3ecNEsxKcCEqRhlqjpm6i9v7fFQT96EueXbie0bDc1DZxsSe9vjH2xKc17bSa+fLSAGWAAMgCgupSjEABNRDRoW2PiKN/C/EABWUDggQgAAAHAEAJ0BKjkAIwA+dSyRR6SioaE6vmgAkA6JaQAAuzWNyqzL4/DnFcf7hXdAAP7s3P/i5x/vpAB7/2kVt//6g8AAAA=="

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports = "data:image/webp;base64,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"

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = "data:image/webp;base64,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"

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(409));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var _paginator = _interopRequireDefault(__webpack_require__(937));
	
	var _Page = _interopRequireDefault(__webpack_require__(964));
	
	var _classnames = _interopRequireDefault(__webpack_require__(52));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Pagination =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Pagination, _React$Component);
	
	  function Pagination() {
	    _classCallCheck(this, Pagination);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Pagination).apply(this, arguments));
	  }
	
	  _createClass(Pagination, [{
	    key: "isFirstPageVisible",
	    value: function isFirstPageVisible(has_previous_page) {
	      var _this$props = this.props,
	          hideDisabled = _this$props.hideDisabled,
	          hideNavigation = _this$props.hideNavigation,
	          hideFirstLastPages = _this$props.hideFirstLastPages;
	      if (hideFirstLastPages || hideDisabled && !has_previous_page) return false;
	      return true;
	    }
	  }, {
	    key: "isPrevPageVisible",
	    value: function isPrevPageVisible(has_previous_page) {
	      var _this$props2 = this.props,
	          hideDisabled = _this$props2.hideDisabled,
	          hideNavigation = _this$props2.hideNavigation;
	      if (hideNavigation || hideDisabled && !has_previous_page) return false;
	      return true;
	    }
	  }, {
	    key: "isNextPageVisible",
	    value: function isNextPageVisible(has_next_page) {
	      var _this$props3 = this.props,
	          hideDisabled = _this$props3.hideDisabled,
	          hideNavigation = _this$props3.hideNavigation;
	      if (hideNavigation || hideDisabled && !has_next_page) return false;
	      return true;
	    }
	  }, {
	    key: "isLastPageVisible",
	    value: function isLastPageVisible(has_next_page) {
	      var _this$props4 = this.props,
	          hideDisabled = _this$props4.hideDisabled,
	          hideNavigation = _this$props4.hideNavigation,
	          hideFirstLastPages = _this$props4.hideFirstLastPages;
	      if (hideFirstLastPages || hideDisabled && !has_next_page) return false;
	      return true;
	    }
	  }, {
	    key: "buildPages",
	    value: function buildPages() {
	      var pages = [];
	      var _this$props5 = this.props,
	          itemsCountPerPage = _this$props5.itemsCountPerPage,
	          pageRangeDisplayed = _this$props5.pageRangeDisplayed,
	          activePage = _this$props5.activePage,
	          prevPageText = _this$props5.prevPageText,
	          nextPageText = _this$props5.nextPageText,
	          firstPageText = _this$props5.firstPageText,
	          lastPageText = _this$props5.lastPageText,
	          totalItemsCount = _this$props5.totalItemsCount,
	          onChange = _this$props5.onChange,
	          activeClass = _this$props5.activeClass,
	          itemClass = _this$props5.itemClass,
	          itemClassFirst = _this$props5.itemClassFirst,
	          itemClassPrev = _this$props5.itemClassPrev,
	          itemClassNext = _this$props5.itemClassNext,
	          itemClassLast = _this$props5.itemClassLast,
	          activeLinkClass = _this$props5.activeLinkClass,
	          disabledClass = _this$props5.disabledClass,
	          hideDisabled = _this$props5.hideDisabled,
	          hideNavigation = _this$props5.hideNavigation,
	          linkClass = _this$props5.linkClass,
	          linkClassFirst = _this$props5.linkClassFirst,
	          linkClassPrev = _this$props5.linkClassPrev,
	          linkClassNext = _this$props5.linkClassNext,
	          linkClassLast = _this$props5.linkClassLast,
	          hideFirstLastPages = _this$props5.hideFirstLastPages,
	          getPageUrl = _this$props5.getPageUrl;
	      var paginationInfo = new _paginator["default"](itemsCountPerPage, pageRangeDisplayed).build(totalItemsCount, activePage);
	
	      for (var i = paginationInfo.first_page; i <= paginationInfo.last_page; i++) {
	        pages.push(_react["default"].createElement(_Page["default"], {
	          isActive: i === activePage,
	          key: i,
	          href: getPageUrl(i),
	          pageNumber: i,
	          pageText: i + "",
	          onClick: onChange,
	          itemClass: itemClass,
	          linkClass: linkClass,
	          activeClass: activeClass,
	          activeLinkClass: activeLinkClass,
	          ariaLabel: "Go to page number ".concat(i)
	        }));
	      }
	
	      this.isPrevPageVisible(paginationInfo.has_previous_page) && pages.unshift(_react["default"].createElement(_Page["default"], {
	        key: "prev" + paginationInfo.previous_page,
	        href: getPageUrl(paginationInfo.previous_page),
	        pageNumber: paginationInfo.previous_page,
	        onClick: onChange,
	        pageText: prevPageText,
	        isDisabled: !paginationInfo.has_previous_page,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassPrev),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassPrev),
	        disabledClass: disabledClass,
	        ariaLabel: "Go to previous page"
	      }));
	      this.isFirstPageVisible(paginationInfo.has_previous_page) && pages.unshift(_react["default"].createElement(_Page["default"], {
	        key: "first",
	        href: getPageUrl(1),
	        pageNumber: 1,
	        onClick: onChange,
	        pageText: firstPageText,
	        isDisabled: !paginationInfo.has_previous_page,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassFirst),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassFirst),
	        disabledClass: disabledClass,
	        ariaLabel: "Go to first page"
	      }));
	      this.isNextPageVisible(paginationInfo.has_next_page) && pages.push(_react["default"].createElement(_Page["default"], {
	        key: "next" + paginationInfo.next_page,
	        href: getPageUrl(paginationInfo.next_page),
	        pageNumber: paginationInfo.next_page,
	        onClick: onChange,
	        pageText: nextPageText,
	        isDisabled: !paginationInfo.has_next_page,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassNext),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassNext),
	        disabledClass: disabledClass,
	        ariaLabel: "Go to next page"
	      }));
	      this.isLastPageVisible(paginationInfo.has_next_page) && pages.push(_react["default"].createElement(_Page["default"], {
	        key: "last",
	        href: getPageUrl(paginationInfo.total_pages),
	        pageNumber: paginationInfo.total_pages,
	        onClick: onChange,
	        pageText: lastPageText,
	        isDisabled: paginationInfo.current_page === paginationInfo.total_pages,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassLast),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassLast),
	        disabledClass: disabledClass,
	        ariaLabel: "Go to last page"
	      }));
	      return pages;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var pages = this.buildPages();
	      return _react["default"].createElement("ul", {
	        className: this.props.innerClass
	      }, pages);
	    }
	  }]);
	
	  return Pagination;
	}(_react["default"].Component);
	
	exports["default"] = Pagination;
	
	_defineProperty(Pagination, "propTypes", {
	  totalItemsCount: _propTypes["default"].number.isRequired,
	  onChange: _propTypes["default"].func.isRequired,
	  activePage: _propTypes["default"].number,
	  itemsCountPerPage: _propTypes["default"].number,
	  pageRangeDisplayed: _propTypes["default"].number,
	  prevPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  nextPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  lastPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  firstPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  disabledClass: _propTypes["default"].string,
	  hideDisabled: _propTypes["default"].bool,
	  hideNavigation: _propTypes["default"].bool,
	  innerClass: _propTypes["default"].string,
	  itemClass: _propTypes["default"].string,
	  itemClassFirst: _propTypes["default"].string,
	  itemClassPrev: _propTypes["default"].string,
	  itemClassNext: _propTypes["default"].string,
	  itemClassLast: _propTypes["default"].string,
	  linkClass: _propTypes["default"].string,
	  activeClass: _propTypes["default"].string,
	  activeLinkClass: _propTypes["default"].string,
	  linkClassFirst: _propTypes["default"].string,
	  linkClassPrev: _propTypes["default"].string,
	  linkClassNext: _propTypes["default"].string,
	  linkClassLast: _propTypes["default"].string,
	  hideFirstLastPages: _propTypes["default"].bool,
	  getPageUrl: _propTypes["default"].func
	});
	
	_defineProperty(Pagination, "defaultProps", {
	  itemsCountPerPage: 10,
	  pageRangeDisplayed: 5,
	  activePage: 1,
	  prevPageText: "⟨",
	  firstPageText: "«",
	  nextPageText: "⟩",
	  lastPageText: "»",
	  innerClass: "pagination",
	  itemClass: undefined,
	  linkClass: undefined,
	  activeLinkClass: undefined,
	  hideFirstLastPages: false,
	  getPageUrl: function getPageUrl(i) {
	    return "#";
	  }
	});

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(42),React=_interopDefault(__webpack_require__(1)),history=__webpack_require__(241);__webpack_require__(24),__webpack_require__(174);var invariant=_interopDefault(__webpack_require__(128));function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_setPrototypeOf(e.prototype.constructor=e,t)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r=a[o],0<=t.indexOf(r)||(n[r]=e[r]);return n}var BrowserRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,t){return"function"==typeof e?e(t):e},normalizeToLocation=function(e,t){return"string"==typeof e?history.createLocation(e,null,null,t):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,t){var r=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(t){try{n&&n(t)}catch(e){throw t.preventDefault(),e}t.defaultPrevented||0!==t.button||i&&"_self"!==i||isModifiedEvent(t)||(t.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&t||r,React.createElement("a",c)}),Link=forwardRef(function(e,a){var t=e.component,i=void 0===t?LinkAnchor:t,c=e.replace,u=e.to,f=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var o=r.history,e=normalizeToLocation(resolveToLocation(u,r.location),r.location),t=e?o.createHref(e):"",n=_extends({},s,{href:t,navigate:function(){var e=resolveToLocation(u,r.location),t=history.createPath(r.location)===history.createPath(normalizeToLocation(e));(c||t?o.replace:o.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||f:n.innerRef=f,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var t=e["aria-current"],l=void 0===t?"page":t,r=e.activeClassName,p=void 0===r?"active":r,R=e.activeStyle,h=e.className,y=e.exact,d=e.isActive,m=e.location,v=e.sensitive,b=e.strict,P=e.style,w=e.to,x=e.innerRef,g=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","sensitive","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t=m||e.location,r=normalizeToLocation(resolveToLocation(w,t),t),o=r.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(t.pathname,{path:n,exact:y,sensitive:v,strict:b}):null,i=!!(d?d(a,t):a),c="function"==typeof h?h(i):h,u="function"==typeof P?P(i):P;i&&(c=joinClassnames(c,p),u=_extends({},u,R));var f=_extends({"aria-current":i&&l||null,className:c,style:u,to:r},g);return forwardRefShim$1!==forwardRef$1?f.ref=s||x:f.innerRef=x,React.createElement(Link,f)})});Object.defineProperty(exports,"MemoryRouter",{enumerable:!0,get:function(){return reactRouter.MemoryRouter}}),Object.defineProperty(exports,"Prompt",{enumerable:!0,get:function(){return reactRouter.Prompt}}),Object.defineProperty(exports,"Redirect",{enumerable:!0,get:function(){return reactRouter.Redirect}}),Object.defineProperty(exports,"Route",{enumerable:!0,get:function(){return reactRouter.Route}}),Object.defineProperty(exports,"Router",{enumerable:!0,get:function(){return reactRouter.Router}}),Object.defineProperty(exports,"StaticRouter",{enumerable:!0,get:function(){return reactRouter.StaticRouter}}),Object.defineProperty(exports,"Switch",{enumerable:!0,get:function(){return reactRouter.Switch}}),Object.defineProperty(exports,"generatePath",{enumerable:!0,get:function(){return reactRouter.generatePath}}),Object.defineProperty(exports,"matchPath",{enumerable:!0,get:function(){return reactRouter.matchPath}}),Object.defineProperty(exports,"useHistory",{enumerable:!0,get:function(){return reactRouter.useHistory}}),Object.defineProperty(exports,"useLocation",{enumerable:!0,get:function(){return reactRouter.useLocation}}),Object.defineProperty(exports,"useParams",{enumerable:!0,get:function(){return reactRouter.useParams}}),Object.defineProperty(exports,"useRouteMatch",{enumerable:!0,get:function(){return reactRouter.useRouteMatch}}),Object.defineProperty(exports,"withRouter",{enumerable:!0,get:function(){return reactRouter.withRouter}}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = __webpack_require__(822);
	
	var Methods = {
	  addClass: _dom.addClass,
	  removeClass: _dom.removeClass,
	  hasClass: _dom.hasClass,
	  toggleClass: _dom.toggleClass,
	  attr: _dom.attr,
	  removeAttr: _dom.removeAttr,
	  transform: _dom.transform,
	  transition: _dom.transition,
	  on: _dom.on,
	  off: _dom.off,
	  trigger: _dom.trigger,
	  transitionEnd: _dom.transitionEnd,
	  outerWidth: _dom.outerWidth,
	  outerHeight: _dom.outerHeight,
	  styles: _dom.styles,
	  offset: _dom.offset,
	  css: _dom.css,
	  each: _dom.each,
	  html: _dom.html,
	  text: _dom.text,
	  is: _dom.is,
	  index: _dom.index,
	  eq: _dom.eq,
	  append: _dom.append,
	  prepend: _dom.prepend,
	  next: _dom.next,
	  nextAll: _dom.nextAll,
	  prev: _dom.prev,
	  prevAll: _dom.prevAll,
	  parent: _dom.parent,
	  parents: _dom.parents,
	  closest: _dom.closest,
	  find: _dom.find,
	  children: _dom.children,
	  filter: _dom.filter,
	  remove: _dom.remove
	};
	Object.keys(Methods).forEach(function (methodName) {
	  Object.defineProperty(_dom.$.fn, methodName, {
	    value: Methods[methodName],
	    writable: true
	  });
	});
	var _default = _dom.$;
	exports.default = _default;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MultipleReactQuillEditor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactQuill = __webpack_require__(977);
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	__webpack_require__(838);
	
	var _quillHtmlEditButton = __webpack_require__(943);
	
	var _quillHtmlEditButton2 = _interopRequireDefault(_quillHtmlEditButton);
	
	__webpack_require__(517);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Import the custom TableModule
	var MultipleReactQuillEditor = exports.MultipleReactQuillEditor = function MultipleReactQuillEditor(_ref) {
	  var id = _ref.id,
	      name = _ref.name,
	      value = _ref.value,
	      onChange = _ref.onChange,
	      onBlur = _ref.onBlur;
	
	  var quillRef = _react2.default.useRef();
	  var CustomUndo = function CustomUndo() {
	    return _react2.default.createElement(
	      "svg",
	      { viewBox: "0 0 18 18" },
	      _react2.default.createElement("polygon", { className: "ql-fill ql-stroke", points: "6 10 4 12 2 10 6 10" }),
	      _react2.default.createElement("path", {
	        className: "ql-stroke",
	        d: "M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
	      })
	    );
	  };
	
	  var CustomRedo = function CustomRedo() {
	    return _react2.default.createElement(
	      "svg",
	      { viewBox: "0 0 18 18" },
	      _react2.default.createElement("polygon", { className: "ql-fill ql-stroke", points: "12 10 14 12 16 10 12 10" }),
	      _react2.default.createElement("path", {
	        className: "ql-stroke",
	        d: "M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
	      })
	    );
	  };
	
	  function undoChange() {
	    this.quill.history.undo();
	  }
	
	  function redoChange() {
	    this.quill.history.redo();
	  }
	
	  var Size = _reactQuill.Quill.import("formats/size");
	  Size.whitelist = ["extra-small", "small", "medium", "large"];
	  _reactQuill.Quill.register(Size, true);
	
	  _reactQuill.Quill.register("modules/htmlEditButton", _quillHtmlEditButton2.default);
	
	  var Font = _reactQuill.Quill.import("formats/font");
	  Font.whitelist = ["arial", "comic-sans", "courier-new", "georgia", "helvetica", "lucida"];
	  _reactQuill.Quill.register(Font, true);
	
	  var CustomToolbar = function CustomToolbar() {
	    return _react2.default.createElement(
	      "div",
	      { id: "toolbar-" + id },
	      _react2.default.createElement(
	        "span",
	        { className: "ql-formats" },
	        _react2.default.createElement(
	          "select",
	          { className: "ql-font", defaultValue: "arial" },
	          _react2.default.createElement(
	            "option",
	            { value: "arial" },
	            "Arial"
	          ),
	          _react2.default.createElement(
	            "option",
	            { value: "comic-sans" },
	            "Comic Sans"
	          ),
	          _react2.default.createElement(
	            "option",
	            { value: "courier-new" },
	            "Courier New"
	          ),
	          _react2.default.createElement(
	            "option",
	            { value: "georgia" },
	            "Georgia"
	          ),
	          _react2.default.createElement(
	            "option",
	            { value: "helvetica" },
	            "Helvetica"
	          ),
	          _react2.default.createElement(
	            "option",
	            { value: "lucida" },
	            "Lucida"
	          )
	        ),
	        _react2.default.createElement(
	          "select",
	          { className: "ql-size", defaultValue: "10" },
	          _react2.default.createElement(
	            "option",
	            { value: "extra-small" },
	            "Size 1"
	          ),
	          _react2.default.createElement(
	            "option",
	            { value: "small" },
	            "Size 2"
	          ),
	          _react2.default.createElement(
	            "option",
	            { value: "medium" },
	            "Size 3"
	          ),
	          _react2.default.createElement(
	            "option",
	            { value: "large" },
	            "Size 4"
	          )
	        ),
	        _react2.default.createElement(
	          "select",
	          { className: "ql-header", defaultValue: "3" },
	          _react2.default.createElement(
	            "option",
	            { value: "1" },
	            "Heading"
	          ),
	          _react2.default.createElement(
	            "option",
	            { value: "2" },
	            "Subheading"
	          ),
	          _react2.default.createElement(
	            "option",
	            { value: "3" },
	            "Normal"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "ql-formats" },
	        _react2.default.createElement("button", { className: "ql-bold" }),
	        _react2.default.createElement("button", { className: "ql-italic" }),
	        _react2.default.createElement("button", { className: "ql-underline" }),
	        _react2.default.createElement("button", { className: "ql-strike" })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "ql-formats" },
	        _react2.default.createElement("button", { className: "ql-list", value: "ordered" }),
	        _react2.default.createElement("button", { className: "ql-list", value: "bullet" }),
	        _react2.default.createElement("button", { className: "ql-indent", value: "-1" }),
	        _react2.default.createElement("button", { className: "ql-indent", value: "+1" })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "ql-formats" },
	        _react2.default.createElement("button", { className: "ql-script", value: "super" }),
	        _react2.default.createElement("button", { className: "ql-script", value: "sub" }),
	        _react2.default.createElement("button", { className: "ql-blockquote" }),
	        _react2.default.createElement("button", { className: "ql-direction" })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "ql-formats" },
	        _react2.default.createElement("select", { className: "ql-align" }),
	        _react2.default.createElement("select", { className: "ql-color" }),
	        _react2.default.createElement("select", { className: "ql-background" })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "ql-formats" },
	        _react2.default.createElement("button", { className: "ql-link" }),
	        _react2.default.createElement("button", { className: "ql-image" }),
	        _react2.default.createElement("button", { className: "ql-video" })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "ql-formats" },
	        _react2.default.createElement("button", { className: "ql-formula" }),
	        _react2.default.createElement("button", { className: "ql-code-block" }),
	        _react2.default.createElement("button", { className: "ql-clean" })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "ql-formats" },
	        _react2.default.createElement(
	          "button",
	          { className: "ql-undo" },
	          _react2.default.createElement(CustomUndo, null)
	        ),
	        _react2.default.createElement(
	          "button",
	          { className: "ql-redo" },
	          _react2.default.createElement(CustomRedo, null)
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "ql-formats" },
	        _react2.default.createElement(
	          "button",
	          {
	            className: "ql-insertTable",
	            title: "Insert Table",
	            style: { fontSize: "8px" }
	          },
	          "Table"
	        )
	      )
	    );
	  };
	
	  var handleChange = function handleChange(val, delta, source, editor) {
	    onChange(name, val);
	  };
	
	  var quillModules = (0, _react.useMemo)(function () {
	    return {
	      toolbar: {
	        container: "#toolbar-" + id,
	        handlers: {
	          undo: undoChange,
	          redo: redoChange,
	          insertTable: function insertTable() {
	            var rows = parseInt(prompt("Enter the number of rows:", "2"), 10);
	            var cols = parseInt(prompt("Enter the number of columns:", "2"), 10);
	
	            if (!isNaN(rows) && !isNaN(cols)) {
	              quillRef.current.getEditor().getModule("table").insertTable(rows, cols);
	            }
	          }
	        }
	      },
	      history: {
	        delay: 500,
	        maxStack: 100,
	        userOnly: true
	      },
	      htmlEditButton: {
	        debug: true,
	        msg: "Edit the content in HTML format",
	        okText: "Ok",
	        cancelText: "Cancel",
	        buttonHTML: "<h5 class='ql-html d-flex'>&lt;&gt;</h5>",
	        buttonTitle: "Show HTML source"
	      },
	      table: true // Enable the custom table module
	    };
	  }, [id]);
	
	  var quillFormats = ["header", "font", "size", "bold", "italic", "underline", "align", "strike", "script", "blockquote", "background", "list", "bullet", "indent", "link", "image", "color", "code-block"];
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    CustomToolbar(id),
	    _react2.default.createElement(_reactQuill2.default, {
	      ref: quillRef,
	      style: { backgroundColor: "white" },
	      theme: "snow",
	      value: value,
	      onChange: function onChange(e, delta, source, editor) {
	        handleChange(e, delta, source, editor);
	      },
	      modules: quillModules,
	      formats: quillFormats,
	      placeholder: "Write content.....",
	      minLength: "10"
	    })
	  );
	}; // @ts-ignore

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * SSR Window 3.0.0
	 * Better handling for window object in SSR environment
	 * https://github.com/nolimits4web/ssr-window
	 *
	 * Copyright 2020, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: November 9, 2020
	 */
	(function (global, factory) {
	     true ? factory(exports) :
	    typeof define === 'function' && define.amd ? define(['exports'], factory) :
	    (global = global || self, factory(global.ssrWindow = {}));
	}(this, (function (exports) { 'use strict';
	
	    /* eslint-disable no-param-reassign */
	    function isObject(obj) {
	        return (obj !== null &&
	            typeof obj === 'object' &&
	            'constructor' in obj &&
	            obj.constructor === Object);
	    }
	    function extend(target, src) {
	        if (target === void 0) { target = {}; }
	        if (src === void 0) { src = {}; }
	        Object.keys(src).forEach(function (key) {
	            if (typeof target[key] === 'undefined')
	                target[key] = src[key];
	            else if (isObject(src[key]) &&
	                isObject(target[key]) &&
	                Object.keys(src[key]).length > 0) {
	                extend(target[key], src[key]);
	            }
	        });
	    }
	
	    var ssrDocument = {
	        body: {},
	        addEventListener: function () { },
	        removeEventListener: function () { },
	        activeElement: {
	            blur: function () { },
	            nodeName: '',
	        },
	        querySelector: function () {
	            return null;
	        },
	        querySelectorAll: function () {
	            return [];
	        },
	        getElementById: function () {
	            return null;
	        },
	        createEvent: function () {
	            return {
	                initEvent: function () { },
	            };
	        },
	        createElement: function () {
	            return {
	                children: [],
	                childNodes: [],
	                style: {},
	                setAttribute: function () { },
	                getElementsByTagName: function () {
	                    return [];
	                },
	            };
	        },
	        createElementNS: function () {
	            return {};
	        },
	        importNode: function () {
	            return null;
	        },
	        location: {
	            hash: '',
	            host: '',
	            hostname: '',
	            href: '',
	            origin: '',
	            pathname: '',
	            protocol: '',
	            search: '',
	        },
	    };
	    function getDocument() {
	        var doc = typeof document !== 'undefined' ? document : {};
	        extend(doc, ssrDocument);
	        return doc;
	    }
	
	    var ssrWindow = {
	        document: ssrDocument,
	        navigator: {
	            userAgent: '',
	        },
	        location: {
	            hash: '',
	            host: '',
	            hostname: '',
	            href: '',
	            origin: '',
	            pathname: '',
	            protocol: '',
	            search: '',
	        },
	        history: {
	            replaceState: function () { },
	            pushState: function () { },
	            go: function () { },
	            back: function () { },
	        },
	        CustomEvent: function CustomEvent() {
	            return this;
	        },
	        addEventListener: function () { },
	        removeEventListener: function () { },
	        getComputedStyle: function () {
	            return {
	                getPropertyValue: function () {
	                    return '';
	                },
	            };
	        },
	        Image: function () { },
	        Date: function () { },
	        screen: {},
	        setTimeout: function () { },
	        clearTimeout: function () { },
	        matchMedia: function () {
	            return {};
	        },
	        requestAnimationFrame: function (callback) {
	            if (typeof setTimeout === 'undefined') {
	                callback();
	                return null;
	            }
	            return setTimeout(callback, 0);
	        },
	        cancelAnimationFrame: function (id) {
	            if (typeof setTimeout === 'undefined') {
	                return;
	            }
	            clearTimeout(id);
	        },
	    };
	    function getWindow() {
	        var win = typeof window !== 'undefined' ? window : {};
	        extend(win, ssrWindow);
	        return win;
	    }
	
	    exports.extend = extend;
	    exports.getDocument = getDocument;
	    exports.getWindow = getWindow;
	    exports.ssrDocument = ssrDocument;
	    exports.ssrWindow = ssrWindow;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=ssr-window.umd.js.map


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(993);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 43 */
8,
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(193);
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	// eslint-disable-next-line func-names
	var kindOf = (function(cache) {
	  // eslint-disable-next-line func-names
	  return function(thing) {
	    var str = toString.call(thing);
	    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
	  };
	})(Object.create(null));
	
	function kindOfTest(type) {
	  type = type.toLowerCase();
	  return function isKindOf(thing) {
	    return kindOf(thing) === type;
	  };
	}
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return Array.isArray(val);
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	var isArrayBuffer = kindOfTest('ArrayBuffer');
	
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (kindOf(val) !== 'object') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	var isDate = kindOfTest('Date');
	
	/**
	 * Determine if a value is a File
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	var isFile = kindOfTest('File');
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	var isBlob = kindOfTest('Blob');
	
	/**
	 * Determine if a value is a FileList
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	var isFileList = kindOfTest('FileList');
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} thing The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(thing) {
	  var pattern = '[object FormData]';
	  return thing && (
	    (typeof FormData === 'function' && thing instanceof FormData) ||
	    toString.call(thing) === pattern ||
	    (isFunction(thing.toString) && thing.toString() === pattern)
	  );
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	var isURLSearchParams = kindOfTest('URLSearchParams');
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	/**
	 * Inherit the prototype methods from one constructor into another
	 * @param {function} constructor
	 * @param {function} superConstructor
	 * @param {object} [props]
	 * @param {object} [descriptors]
	 */
	
	function inherits(constructor, superConstructor, props, descriptors) {
	  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
	  constructor.prototype.constructor = constructor;
	  props && Object.assign(constructor.prototype, props);
	}
	
	/**
	 * Resolve object with deep prototype chain to a flat object
	 * @param {Object} sourceObj source object
	 * @param {Object} [destObj]
	 * @param {Function} [filter]
	 * @returns {Object}
	 */
	
	function toFlatObject(sourceObj, destObj, filter) {
	  var props;
	  var i;
	  var prop;
	  var merged = {};
	
	  destObj = destObj || {};
	
	  do {
	    props = Object.getOwnPropertyNames(sourceObj);
	    i = props.length;
	    while (i-- > 0) {
	      prop = props[i];
	      if (!merged[prop]) {
	        destObj[prop] = sourceObj[prop];
	        merged[prop] = true;
	      }
	    }
	    sourceObj = Object.getPrototypeOf(sourceObj);
	  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
	
	  return destObj;
	}
	
	/*
	 * determines whether a string ends with the characters of a specified string
	 * @param {String} str
	 * @param {String} searchString
	 * @param {Number} [position= 0]
	 * @returns {boolean}
	 */
	function endsWith(str, searchString, position) {
	  str = String(str);
	  if (position === undefined || position > str.length) {
	    position = str.length;
	  }
	  position -= searchString.length;
	  var lastIndex = str.indexOf(searchString, position);
	  return lastIndex !== -1 && lastIndex === position;
	}
	
	
	/**
	 * Returns new array from array like object
	 * @param {*} [thing]
	 * @returns {Array}
	 */
	function toArray(thing) {
	  if (!thing) return null;
	  var i = thing.length;
	  if (isUndefined(i)) return null;
	  var arr = new Array(i);
	  while (i-- > 0) {
	    arr[i] = thing[i];
	  }
	  return arr;
	}
	
	// eslint-disable-next-line func-names
	var isTypedArray = (function(TypedArray) {
	  // eslint-disable-next-line func-names
	  return function(thing) {
	    return TypedArray && thing instanceof TypedArray;
	  };
	})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM,
	  inherits: inherits,
	  toFlatObject: toFlatObject,
	  kindOf: kindOf,
	  kindOfTest: kindOfTest,
	  endsWith: endsWith,
	  toArray: toArray,
	  isTypedArray: isTypedArray,
	  isFileList: isFileList
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = function Modal(_ref) {
	  var handleClose = _ref.handleClose,
	      show = _ref.show,
	      children = _ref.children;
	
	  var showHideClassName = show ? "modal d-block" : "modal d-none";
	
	  return _react2.default.createElement(
	    "div",
	    { className: showHideClassName },
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "div",
	        { className: "modal-content content-popup" },
	        _react2.default.createElement(
	          "a",
	          { href: "", className: "modal-close", onClick: handleClose },
	          "\xD7"
	        ),
	        children
	      )
	    )
	  );
	};
	
	exports.default = Modal;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	
	var UAParser = __webpack_require__(1136);
	
	var ClientUAInstance = new UAParser();
	var browser = ClientUAInstance.getBrowser();
	var cpu = ClientUAInstance.getCPU();
	var device = ClientUAInstance.getDevice();
	var engine = ClientUAInstance.getEngine();
	var os = ClientUAInstance.getOS();
	var ua = ClientUAInstance.getUA();
	var setUa = function setUa(userAgentString) {
	  return ClientUAInstance.setUA(userAgentString);
	};
	var parseUserAgent = function parseUserAgent(userAgent) {
	  if (!userAgent) {
	    console.error('No userAgent string was provided');
	    return;
	  }
	
	  var UserAgentInstance = new UAParser(userAgent);
	  return {
	    UA: UserAgentInstance,
	    browser: UserAgentInstance.getBrowser(),
	    cpu: UserAgentInstance.getCPU(),
	    device: UserAgentInstance.getDevice(),
	    engine: UserAgentInstance.getEngine(),
	    os: UserAgentInstance.getOS(),
	    ua: UserAgentInstance.getUA(),
	    setUserAgent: function setUserAgent(userAgentString) {
	      return UserAgentInstance.setUA(userAgentString);
	    }
	  };
	};
	
	var UAHelper = /*#__PURE__*/Object.freeze({
	  ClientUAInstance: ClientUAInstance,
	  browser: browser,
	  cpu: cpu,
	  device: device,
	  engine: engine,
	  os: os,
	  ua: ua,
	  setUa: setUa,
	  parseUserAgent: parseUserAgent
	});
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	
	  var target = _objectWithoutPropertiesLoose(source, excluded);
	
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	
	  return _assertThisInitialized(self);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
	
	  if (_i == null) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	
	  var _s, _e;
	
	  try {
	    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	
	  return arr2;
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	var DeviceTypes = {
	  Mobile: 'mobile',
	  Tablet: 'tablet',
	  SmartTv: 'smarttv',
	  Console: 'console',
	  Wearable: 'wearable',
	  Embedded: 'embedded',
	  Browser: undefined
	};
	var BrowserTypes = {
	  Chrome: 'Chrome',
	  Firefox: 'Firefox',
	  Opera: 'Opera',
	  Yandex: 'Yandex',
	  Safari: 'Safari',
	  InternetExplorer: 'Internet Explorer',
	  Edge: 'Edge',
	  Chromium: 'Chromium',
	  Ie: 'IE',
	  MobileSafari: 'Mobile Safari',
	  EdgeChromium: 'Edge Chromium',
	  MIUI: 'MIUI Browser',
	  SamsungBrowser: 'Samsung Browser'
	};
	var OsTypes = {
	  IOS: 'iOS',
	  Android: 'Android',
	  WindowsPhone: 'Windows Phone',
	  Windows: 'Windows',
	  MAC_OS: 'Mac OS'
	};
	var InitialDeviceTypes = {
	  isMobile: false,
	  isTablet: false,
	  isBrowser: false,
	  isSmartTV: false,
	  isConsole: false,
	  isWearable: false
	};
	
	var checkDeviceType = function checkDeviceType(type) {
	  switch (type) {
	    case DeviceTypes.Mobile:
	      return {
	        isMobile: true
	      };
	
	    case DeviceTypes.Tablet:
	      return {
	        isTablet: true
	      };
	
	    case DeviceTypes.SmartTv:
	      return {
	        isSmartTV: true
	      };
	
	    case DeviceTypes.Console:
	      return {
	        isConsole: true
	      };
	
	    case DeviceTypes.Wearable:
	      return {
	        isWearable: true
	      };
	
	    case DeviceTypes.Browser:
	      return {
	        isBrowser: true
	      };
	
	    case DeviceTypes.Embedded:
	      return {
	        isEmbedded: true
	      };
	
	    default:
	      return InitialDeviceTypes;
	  }
	};
	var setUserAgent = function setUserAgent(userAgent) {
	  return setUa(userAgent);
	};
	var setDefaults = function setDefaults(p) {
	  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
	  return p ? p : d;
	};
	var getNavigatorInstance = function getNavigatorInstance() {
	  if (typeof window !== 'undefined') {
	    if (window.navigator || navigator) {
	      return window.navigator || navigator;
	    }
	  }
	
	  return false;
	};
	var isIOS13Check = function isIOS13Check(type) {
	  var nav = getNavigatorInstance();
	  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
	};
	
	var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
	  return {
	    isBrowser: isBrowser,
	    browserMajorVersion: setDefaults(browser.major),
	    browserFullVersion: setDefaults(browser.version),
	    browserName: setDefaults(browser.name),
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var mobilePayload = function mobilePayload(type, device, os, ua) {
	  return _objectSpread2({}, type, {
	    vendor: setDefaults(device.vendor),
	    model: setDefaults(device.model),
	    os: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    ua: setDefaults(ua)
	  });
	};
	var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
	  return {
	    isSmartTV: isSmartTV,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var consolePayload = function consolePayload(isConsole, engine, os, ua) {
	  return {
	    isConsole: isConsole,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
	  return {
	    isWearable: isWearable,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
	  return {
	    isEmbedded: isEmbedded,
	    vendor: setDefaults(device.vendor),
	    model: setDefaults(device.model),
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	
	function deviceDetect(userAgent) {
	  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
	      device = _ref.device,
	      browser = _ref.browser,
	      engine = _ref.engine,
	      os = _ref.os,
	      ua = _ref.ua;
	
	  var type = checkDeviceType(device.type);
	  var isBrowser = type.isBrowser,
	      isMobile = type.isMobile,
	      isTablet = type.isTablet,
	      isSmartTV = type.isSmartTV,
	      isConsole = type.isConsole,
	      isWearable = type.isWearable,
	      isEmbedded = type.isEmbedded;
	
	  if (isBrowser) {
	    return browserPayload(isBrowser, browser, engine, os, ua);
	  }
	
	  if (isSmartTV) {
	    return smartTvPayload(isSmartTV, engine, os, ua);
	  }
	
	  if (isConsole) {
	    return consolePayload(isConsole, engine, os, ua);
	  }
	
	  if (isMobile) {
	    return mobilePayload(type, device, os, ua);
	  }
	
	  if (isTablet) {
	    return mobilePayload(type, device, os, ua);
	  }
	
	  if (isWearable) {
	    return wearablePayload(isWearable, engine, os, ua);
	  }
	
	  if (isEmbedded) {
	    return embeddedPayload(isEmbedded, device, engine, os, ua);
	  }
	}
	
	var isMobileType = function isMobileType(_ref) {
	  var type = _ref.type;
	  return type === DeviceTypes.Mobile;
	};
	var isTabletType = function isTabletType(_ref2) {
	  var type = _ref2.type;
	  return type === DeviceTypes.Tablet;
	};
	var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
	  var type = _ref3.type;
	  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
	};
	var isSmartTVType = function isSmartTVType(_ref4) {
	  var type = _ref4.type;
	  return type === DeviceTypes.SmartTv;
	};
	var isBrowserType = function isBrowserType(_ref5) {
	  var type = _ref5.type;
	  return type === DeviceTypes.Browser;
	};
	var isWearableType = function isWearableType(_ref6) {
	  var type = _ref6.type;
	  return type === DeviceTypes.Wearable;
	};
	var isConsoleType = function isConsoleType(_ref7) {
	  var type = _ref7.type;
	  return type === DeviceTypes.Console;
	};
	var isEmbeddedType = function isEmbeddedType(_ref8) {
	  var type = _ref8.type;
	  return type === DeviceTypes.Embedded;
	};
	var getMobileVendor = function getMobileVendor(_ref9) {
	  var vendor = _ref9.vendor;
	  return setDefaults(vendor);
	};
	var getMobileModel = function getMobileModel(_ref10) {
	  var model = _ref10.model;
	  return setDefaults(model);
	};
	var getDeviceType = function getDeviceType(_ref11) {
	  var type = _ref11.type;
	  return setDefaults(type, 'browser');
	}; // os types
	
	var isAndroidType = function isAndroidType(_ref12) {
	  var name = _ref12.name;
	  return name === OsTypes.Android;
	};
	var isWindowsType = function isWindowsType(_ref13) {
	  var name = _ref13.name;
	  return name === OsTypes.Windows;
	};
	var isMacOsType = function isMacOsType(_ref14) {
	  var name = _ref14.name;
	  return name === OsTypes.MAC_OS;
	};
	var isWinPhoneType = function isWinPhoneType(_ref15) {
	  var name = _ref15.name;
	  return name === OsTypes.WindowsPhone;
	};
	var isIOSType = function isIOSType(_ref16) {
	  var name = _ref16.name;
	  return name === OsTypes.IOS;
	};
	var getOsVersion = function getOsVersion(_ref17) {
	  var version = _ref17.version;
	  return setDefaults(version);
	};
	var getOsName = function getOsName(_ref18) {
	  var name = _ref18.name;
	  return setDefaults(name);
	}; // browser types
	
	var isChromeType = function isChromeType(_ref19) {
	  var name = _ref19.name;
	  return name === BrowserTypes.Chrome;
	};
	var isFirefoxType = function isFirefoxType(_ref20) {
	  var name = _ref20.name;
	  return name === BrowserTypes.Firefox;
	};
	var isChromiumType = function isChromiumType(_ref21) {
	  var name = _ref21.name;
	  return name === BrowserTypes.Chromium;
	};
	var isEdgeType = function isEdgeType(_ref22) {
	  var name = _ref22.name;
	  return name === BrowserTypes.Edge;
	};
	var isYandexType = function isYandexType(_ref23) {
	  var name = _ref23.name;
	  return name === BrowserTypes.Yandex;
	};
	var isSafariType = function isSafariType(_ref24) {
	  var name = _ref24.name;
	  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
	};
	var isMobileSafariType = function isMobileSafariType(_ref25) {
	  var name = _ref25.name;
	  return name === BrowserTypes.MobileSafari;
	};
	var isOperaType = function isOperaType(_ref26) {
	  var name = _ref26.name;
	  return name === BrowserTypes.Opera;
	};
	var isIEType = function isIEType(_ref27) {
	  var name = _ref27.name;
	  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
	};
	var isMIUIType = function isMIUIType(_ref28) {
	  var name = _ref28.name;
	  return name === BrowserTypes.MIUI;
	};
	var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
	  var name = _ref29.name;
	  return name === BrowserTypes.SamsungBrowser;
	};
	var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
	  var version = _ref30.version;
	  return setDefaults(version);
	};
	var getBrowserVersion = function getBrowserVersion(_ref31) {
	  var major = _ref31.major;
	  return setDefaults(major);
	};
	var getBrowserName = function getBrowserName(_ref32) {
	  var name = _ref32.name;
	  return setDefaults(name);
	}; // engine types
	
	var getEngineName = function getEngineName(_ref33) {
	  var name = _ref33.name;
	  return setDefaults(name);
	};
	var getEngineVersion = function getEngineVersion(_ref34) {
	  var version = _ref34.version;
	  return setDefaults(version);
	};
	var isElectronType = function isElectronType() {
	  var nav = getNavigatorInstance();
	  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
	  return typeof ua === 'string' ? /electron/.test(ua) : false;
	};
	var isEdgeChromiumType = function isEdgeChromiumType(ua) {
	  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
	};
	var getIOS13 = function getIOS13() {
	  var nav = getNavigatorInstance();
	  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
	};
	var getIPad13 = function getIPad13() {
	  return isIOS13Check('iPad');
	};
	var getIphone13 = function getIphone13() {
	  return isIOS13Check('iPhone');
	};
	var getIPod13 = function getIPod13() {
	  return isIOS13Check('iPod');
	};
	var getUseragent = function getUseragent(userAg) {
	  return setDefaults(userAg);
	};
	
	function buildSelectorsObject(options) {
	  var _ref = options ? options : UAHelper,
	      device = _ref.device,
	      browser = _ref.browser,
	      os = _ref.os,
	      engine = _ref.engine,
	      ua = _ref.ua;
	
	  return {
	    isSmartTV: isSmartTVType(device),
	    isConsole: isConsoleType(device),
	    isWearable: isWearableType(device),
	    isEmbedded: isEmbeddedType(device),
	    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
	    isChromium: isChromiumType(browser),
	    isMobile: isMobileAndTabletType(device) || getIPad13(),
	    isMobileOnly: isMobileType(device),
	    isTablet: isTabletType(device) || getIPad13(),
	    isBrowser: isBrowserType(device),
	    isDesktop: isBrowserType(device),
	    isAndroid: isAndroidType(os),
	    isWinPhone: isWinPhoneType(os),
	    isIOS: isIOSType(os) || getIPad13(),
	    isChrome: isChromeType(browser),
	    isFirefox: isFirefoxType(browser),
	    isSafari: isSafariType(browser),
	    isOpera: isOperaType(browser),
	    isIE: isIEType(browser),
	    osVersion: getOsVersion(os),
	    osName: getOsName(os),
	    fullBrowserVersion: getBrowserFullVersion(browser),
	    browserVersion: getBrowserVersion(browser),
	    browserName: getBrowserName(browser),
	    mobileVendor: getMobileVendor(device),
	    mobileModel: getMobileModel(device),
	    engineName: getEngineName(engine),
	    engineVersion: getEngineVersion(engine),
	    getUA: getUseragent(ua),
	    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
	    isYandex: isYandexType(browser),
	    deviceType: getDeviceType(device),
	    isIOS13: getIOS13(),
	    isIPad13: getIPad13(),
	    isIPhone13: getIphone13(),
	    isIPod13: getIPod13(),
	    isElectron: isElectronType(),
	    isEdgeChromium: isEdgeChromiumType(ua),
	    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
	    isWindows: isWindowsType(os),
	    isMacOs: isMacOsType(os),
	    isMIUI: isMIUIType(browser),
	    isSamsungBrowser: isSamsungBrowserType(browser)
	  };
	}
	
	var isSmartTV = isSmartTVType(device);
	var isConsole = isConsoleType(device);
	var isWearable = isWearableType(device);
	var isEmbedded = isEmbeddedType(device);
	var isMobileSafari = isMobileSafariType(browser) || getIPad13();
	var isChromium = isChromiumType(browser);
	var isMobile = isMobileAndTabletType(device) || getIPad13();
	var isMobileOnly = isMobileType(device);
	var isTablet = isTabletType(device) || getIPad13();
	var isBrowser = isBrowserType(device);
	var isDesktop = isBrowserType(device);
	var isAndroid = isAndroidType(os);
	var isWinPhone = isWinPhoneType(os);
	var isIOS = isIOSType(os) || getIPad13();
	var isChrome = isChromeType(browser);
	var isFirefox = isFirefoxType(browser);
	var isSafari = isSafariType(browser);
	var isOpera = isOperaType(browser);
	var isIE = isIEType(browser);
	var osVersion = getOsVersion(os);
	var osName = getOsName(os);
	var fullBrowserVersion = getBrowserFullVersion(browser);
	var browserVersion = getBrowserVersion(browser);
	var browserName = getBrowserName(browser);
	var mobileVendor = getMobileVendor(device);
	var mobileModel = getMobileModel(device);
	var engineName = getEngineName(engine);
	var engineVersion = getEngineVersion(engine);
	var getUA = getUseragent(ua);
	var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
	var isYandex = isYandexType(browser);
	var deviceType = getDeviceType(device);
	var isIOS13 = getIOS13();
	var isIPad13 = getIPad13();
	var isIPhone13 = getIphone13();
	var isIPod13 = getIPod13();
	var isElectron = isElectronType();
	var isEdgeChromium = isEdgeChromiumType(ua);
	var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
	var isWindows = isWindowsType(os);
	var isMacOs = isMacOsType(os);
	var isMIUI = isMIUIType(browser);
	var isSamsungBrowser = isSamsungBrowserType(browser);
	var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
	  if (!userAgent || typeof userAgent !== 'string') {
	    console.error('No valid user agent string was provided');
	    return;
	  }
	
	  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
	      device = _UAHelper$parseUserAg.device,
	      browser = _UAHelper$parseUserAg.browser,
	      os = _UAHelper$parseUserAg.os,
	      engine = _UAHelper$parseUserAg.engine,
	      ua = _UAHelper$parseUserAg.ua;
	
	  return buildSelectorsObject({
	    device: device,
	    browser: browser,
	    os: os,
	    engine: engine,
	    ua: ua
	  });
	};
	
	var AndroidView = function AndroidView(_ref) {
	  var renderWithFragment = _ref.renderWithFragment,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);
	
	  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	var BrowserView = function BrowserView(_ref2) {
	  var renderWithFragment = _ref2.renderWithFragment,
	      children = _ref2.children,
	      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);
	
	  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	var IEView = function IEView(_ref3) {
	  var renderWithFragment = _ref3.renderWithFragment,
	      children = _ref3.children,
	      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);
	
	  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	var IOSView = function IOSView(_ref4) {
	  var renderWithFragment = _ref4.renderWithFragment,
	      children = _ref4.children,
	      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);
	
	  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	var MobileView = function MobileView(_ref5) {
	  var renderWithFragment = _ref5.renderWithFragment,
	      children = _ref5.children,
	      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);
	
	  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	var TabletView = function TabletView(_ref6) {
	  var renderWithFragment = _ref6.renderWithFragment,
	      children = _ref6.children,
	      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);
	
	  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	var WinPhoneView = function WinPhoneView(_ref7) {
	  var renderWithFragment = _ref7.renderWithFragment,
	      children = _ref7.children,
	      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);
	
	  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	var MobileOnlyView = function MobileOnlyView(_ref8) {
	  var renderWithFragment = _ref8.renderWithFragment,
	      children = _ref8.children,
	      viewClassName = _ref8.viewClassName,
	      style = _ref8.style,
	      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);
	
	  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	var SmartTVView = function SmartTVView(_ref9) {
	  var renderWithFragment = _ref9.renderWithFragment,
	      children = _ref9.children,
	      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);
	
	  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	var ConsoleView = function ConsoleView(_ref10) {
	  var renderWithFragment = _ref10.renderWithFragment,
	      children = _ref10.children,
	      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);
	
	  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	var WearableView = function WearableView(_ref11) {
	  var renderWithFragment = _ref11.renderWithFragment,
	      children = _ref11.children,
	      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);
	
	  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	var CustomView = function CustomView(_ref12) {
	  var renderWithFragment = _ref12.renderWithFragment,
	      children = _ref12.children,
	      viewClassName = _ref12.viewClassName,
	      style = _ref12.style,
	      condition = _ref12.condition,
	      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
	
	  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
	};
	
	function withOrientationChange(WrappedComponent) {
	  return /*#__PURE__*/function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props) {
	      var _this;
	
	      _classCallCheck(this, _class);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
	      _this.isEventListenerAdded = false;
	      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
	      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
	      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
	      _this.state = {
	        isLandscape: false,
	        isPortrait: false
	      };
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: "handleOrientationChange",
	      value: function handleOrientationChange() {
	        if (!this.isEventListenerAdded) {
	          this.isEventListenerAdded = true;
	        }
	
	        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
	        this.setState({
	          isPortrait: orientation === 0,
	          isLandscape: orientation === 90
	        });
	      }
	    }, {
	      key: "onOrientationChange",
	      value: function onOrientationChange() {
	        this.handleOrientationChange();
	      }
	    }, {
	      key: "onPageLoad",
	      value: function onPageLoad() {
	        this.handleOrientationChange();
	      }
	    }, {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
	          if (!this.isEventListenerAdded) {
	            this.handleOrientationChange();
	            window.addEventListener("load", this.onPageLoad, false);
	          } else {
	            window.removeEventListener("load", this.onPageLoad, false);
	          }
	
	          window.addEventListener("resize", this.onOrientationChange, false);
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        window.removeEventListener("resize", this.onOrientationChange, false);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
	          isLandscape: this.state.isLandscape,
	          isPortrait: this.state.isPortrait
	        }));
	      }
	    }]);
	
	    return _class;
	  }(React__default.Component);
	}
	
	function useMobileOrientation() {
	  var _useState = React.useState(function () {
	    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
	    return {
	      isPortrait: orientation === 0,
	      isLandscape: orientation === 90,
	      orientation: orientation === 0 ? 'portrait' : 'landscape'
	    };
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      state = _useState2[0],
	      setState = _useState2[1];
	
	  var handleOrientationChange = React.useCallback(function () {
	    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
	    var next = {
	      isPortrait: orientation === 0,
	      isLandscape: orientation === 90,
	      orientation: orientation === 0 ? 'portrait' : 'landscape'
	    };
	    state.orientation !== next.orientation && setState(next);
	  }, [state.orientation]);
	  React.useEffect(function () {
	    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
	      handleOrientationChange();
	      window.addEventListener("load", handleOrientationChange, false);
	      window.addEventListener("resize", handleOrientationChange, false);
	    }
	
	    return function () {
	      window.removeEventListener("resize", handleOrientationChange, false);
	      window.removeEventListener("load", handleOrientationChange, false);
	    };
	  }, [handleOrientationChange]);
	  return state;
	}
	
	function useDeviceData(userAgent) {
	  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
	  return parseUserAgent(hookUserAgent);
	}
	
	function useDeviceSelectors(userAgent) {
	  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
	  var deviceData = useDeviceData(hookUserAgent);
	  var selectors = buildSelectorsObject(deviceData);
	  return [selectors, deviceData];
	}
	
	exports.AndroidView = AndroidView;
	exports.BrowserTypes = BrowserTypes;
	exports.BrowserView = BrowserView;
	exports.ConsoleView = ConsoleView;
	exports.CustomView = CustomView;
	exports.IEView = IEView;
	exports.IOSView = IOSView;
	exports.MobileOnlyView = MobileOnlyView;
	exports.MobileView = MobileView;
	exports.OsTypes = OsTypes;
	exports.SmartTVView = SmartTVView;
	exports.TabletView = TabletView;
	exports.WearableView = WearableView;
	exports.WinPhoneView = WinPhoneView;
	exports.browserName = browserName;
	exports.browserVersion = browserVersion;
	exports.deviceDetect = deviceDetect;
	exports.deviceType = deviceType;
	exports.engineName = engineName;
	exports.engineVersion = engineVersion;
	exports.fullBrowserVersion = fullBrowserVersion;
	exports.getSelectorsByUserAgent = getSelectorsByUserAgent;
	exports.getUA = getUA;
	exports.isAndroid = isAndroid;
	exports.isBrowser = isBrowser;
	exports.isChrome = isChrome;
	exports.isChromium = isChromium;
	exports.isConsole = isConsole;
	exports.isDesktop = isDesktop;
	exports.isEdge = isEdge;
	exports.isEdgeChromium = isEdgeChromium;
	exports.isElectron = isElectron;
	exports.isEmbedded = isEmbedded;
	exports.isFirefox = isFirefox;
	exports.isIE = isIE;
	exports.isIOS = isIOS;
	exports.isIOS13 = isIOS13;
	exports.isIPad13 = isIPad13;
	exports.isIPhone13 = isIPhone13;
	exports.isIPod13 = isIPod13;
	exports.isLegacyEdge = isLegacyEdge;
	exports.isMIUI = isMIUI;
	exports.isMacOs = isMacOs;
	exports.isMobile = isMobile;
	exports.isMobileOnly = isMobileOnly;
	exports.isMobileSafari = isMobileSafari;
	exports.isOpera = isOpera;
	exports.isSafari = isSafari;
	exports.isSamsungBrowser = isSamsungBrowser;
	exports.isSmartTV = isSmartTV;
	exports.isTablet = isTablet;
	exports.isWearable = isWearable;
	exports.isWinPhone = isWinPhone;
	exports.isWindows = isWindows;
	exports.isYandex = isYandex;
	exports.mobileModel = mobileModel;
	exports.mobileVendor = mobileVendor;
	exports.osName = osName;
	exports.osVersion = osVersion;
	exports.parseUserAgent = parseUserAgent;
	exports.setUserAgent = setUserAgent;
	exports.useDeviceData = useDeviceData;
	exports.useDeviceSelectors = useDeviceSelectors;
	exports.useMobileOrientation = useMobileOrientation;
	exports.withOrientationChange = withOrientationChange;


/***/ },
/* 47 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.timezonePatterns = exports.numericPatterns = void 0;
	var numericPatterns = {
	  month: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  date: /^(3[0-1]|[0-2]?\d)/,
	  // 0 to 31
	  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	  // 0 to 366
	  week: /^(5[0-3]|[0-4]?\d)/,
	  // 0 to 53
	  hour23h: /^(2[0-3]|[0-1]?\d)/,
	  // 0 to 23
	  hour24h: /^(2[0-4]|[0-1]?\d)/,
	  // 0 to 24
	  hour11h: /^(1[0-1]|0?\d)/,
	  // 0 to 11
	  hour12h: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  minute: /^[0-5]?\d/,
	  // 0 to 59
	  second: /^[0-5]?\d/,
	  // 0 to 59
	
	  singleDigit: /^\d/,
	  // 0 to 9
	  twoDigits: /^\d{1,2}/,
	  // 0 to 99
	  threeDigits: /^\d{1,3}/,
	  // 0 to 999
	  fourDigits: /^\d{1,4}/,
	  // 0 to 9999
	
	  anyDigitsSigned: /^-?\d+/,
	  singleDigitSigned: /^-?\d/,
	  // 0 to 9, -0 to -9
	  twoDigitsSigned: /^-?\d{1,2}/,
	  // 0 to 99, -0 to -99
	  threeDigitsSigned: /^-?\d{1,3}/,
	  // 0 to 999, -0 to -999
	  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
	};
	exports.numericPatterns = numericPatterns;
	var timezonePatterns = {
	  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	  basic: /^([+-])(\d{2})(\d{2})|Z/,
	  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	  extended: /^([+-])(\d{2}):(\d{2})|Z/,
	  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
	};
	exports.timezonePatterns = timezonePatterns;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MyContext = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// import MyContext from "./MyContext";
	var MyContext = exports.MyContext = (0, _react.createContext)();
	var MyProvider = function MyProvider(_ref) {
	  var children = _ref.children;
	
	  var initialCartState = JSON.parse(localStorage.getItem("cart")) || [];
	
	  var _useState = (0, _react.useState)("dadsdsd"),
	      _useState2 = _slicedToArray(_useState, 2),
	      state = _useState2[0],
	      setState = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(initialCartState),
	      _useState4 = _slicedToArray(_useState3, 2),
	      cart = _useState4[0],
	      setCart = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      totalQuantity = _useState6[0],
	      setTotalQuantity = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({}),
	      _useState8 = _slicedToArray(_useState7, 2),
	      doctorsDetails = _useState8[0],
	      setDoctorsDetails = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      totalAmount = _useState10[0],
	      setTotalAmount = _useState10[1];
	
	  // Update local storage whenever cart state changes
	
	
	  (0, _react.useEffect)(function () {
	    localStorage.setItem("cart", JSON.stringify(cart));
	    // Recalculate total amount
	    var newTotalAmount = cart.reduce(function (acc, item) {
	      return parseFloat(acc) + parseFloat(item.opd_amount) * item.quantity;
	    }, 0);
	    setTotalAmount(newTotalAmount);
	    localStorage.setItem("totalAmount", JSON.stringify(newTotalAmount));
	
	    var newTotalQuantity = cart.reduce(function (acc, item) {
	      return acc + item.quantity;
	    }, 0);
	    setTotalQuantity(newTotalQuantity);
	    localStorage.setItem("totalQuantity", newTotalQuantity);
	  }, [cart]);
	
	  var addToCart = function addToCart(item, type) {
	    // Check if the item is already in the cart
	
	    var isItemInCart = cart.some(function (cartItem) {
	      return cartItem.id === item.id && cartItem.type === type;
	    });
	
	    if (isItemInCart) {
	      // If the item is already in the cart, remove it
	      setCart(function (prevCart) {
	        return prevCart.filter(function (cartItem) {
	          return cartItem.id !== item.id;
	        });
	      });
	    } else {
	      // If the item is not in the cart, add it
	      setCart(function (prevCart) {
	        return [].concat(_toConsumableArray(prevCart), [Object.assign({}, item, { quantity: 1, type: type })]);
	      }, function () {
	        // Callback function after the state has been updated
	        // Update local storage
	        localStorage.setItem("cart", JSON.stringify(cart));
	      });
	    }
	  };
	
	  var removeItemFromCart = function removeItemFromCart(itemId, type) {
	    var isItemInCart = cart.some(function (cartItem) {
	      return cartItem.id === itemId;
	    });
	    if (isItemInCart) {
	      // If the item is already in the cart, remove it
	      setCart(function (prevCart) {
	        return prevCart.filter(function (cartItem) {
	          return cartItem.id !== itemId;
	        });
	      });
	    }
	  };
	  var removeFromCart = function removeFromCart(itemId, type) {
	    setCart([]);
	  };
	
	  var increaseQuantity = function increaseQuantity(itemId) {
	    setCart(function (prevCart) {
	      return prevCart.map(function (item) {
	        return item.id === itemId ? Object.assign({}, item, { quantity: item.quantity + 1 }) : item;
	      });
	    });
	  };
	
	  var decreaseQuantity = function decreaseQuantity(itemId) {
	    setCart(function (prevCart) {
	      return prevCart.map(function (item) {
	        return item.id === itemId ? Object.assign({}, item, { quantity: Math.max(1, item.quantity - 1) }) : item;
	      });
	    });
	  };
	  var isInCart = function isInCart(itemId) {
	    var isInCart = cart.find(function (item) {
	      return item.id === itemId;
	    });
	    return isInCart;
	  };
	
	  var DoctorData = function DoctorData(details) {
	    setDoctorsDetails(details);
	  };
	
	  var value = {
	    state: state,
	    setState: setState,
	    cart: cart,
	    addToCart: addToCart,
	    removeFromCart: removeFromCart,
	    increaseQuantity: increaseQuantity,
	    decreaseQuantity: decreaseQuantity,
	    totalQuantity: totalQuantity,
	    setTotalQuantity: setTotalQuantity,
	    totalAmount: totalAmount,
	    setTotalAmount: setTotalAmount,
	    doctorsDetails: doctorsDetails,
	    DoctorData: DoctorData,
	    isInCart: isInCart,
	    removeItemFromCart: removeItemFromCart
	  };
	
	  return _react2.default.createElement(
	    MyContext.Provider,
	    { value: value },
	    children
	  );
	};
	
	exports.default = MyProvider;

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAAAICAYAAABkmUMJAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACZSURBVHgB7dnBCcJAFEXRlzGCyynBEpJObMEOdOdylu4swRZiB3agJaSELAMG4htIFZ97YOAzBVz+MI3sUG7HVvunx84nCwDiGBb9rnO5j80Wu48IHYC4JkevT47dQ8QOQGy5vmKTh5MAIL6uBm8SAMSXHbz1KwCI75UWtWex5QGIzZ8Wu0uaSxk99L4YBACxeJlb37VxtXV/4qQirgTAB9AAAAAASUVORK5CYII="

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RadioGroupFunctional(_ref) {
	  var radioOptions = _ref.radioOptions,
	      defaultSelected = _ref.defaultSelected,
	      onChange = _ref.onChange;
	
	  var _useState = (0, _react.useState)(defaultSelected || ""),
	      _useState2 = _slicedToArray(_useState, 2),
	      selectedValue = _useState2[0],
	      setSelectedValue = _useState2[1];
	
	  var handleChange = function handleChange(event) {
	    var value = event.target.value;
	    setSelectedValue(value);
	    onChange(value);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    radioOptions.map(function (option) {
	      return _react2.default.createElement(
	        "label",
	        { key: option.id },
	        _react2.default.createElement("input", {
	          type: "radio",
	          value: option.value,
	          checked: selectedValue === option.value,
	          onChange: handleChange
	        }),
	        _react2.default.createElement(
	          "span",
	          { className: "mx-2" },
	          option.label,
	          " "
	        )
	      );
	    })
	  );
	}
	
	exports.default = RadioGroupFunctional;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = [
		{
			"id": "283",
			"district_id": "57",
			"name": "Abhaynagar",
			"bn_name": "অভয়নগর"
		},
		{
			"id": "329",
			"district_id": "18",
			"name": "Adamdighi",
			"bn_name": "আদমদিঘী"
		},
		{
			"id": "425",
			"district_id": "29",
			"name": "Aditmari",
			"bn_name": "আদিতমারি"
		},
		{
			"id": "9",
			"district_id": "35",
			"name": "Agailjhara",
			"bn_name": "আগাইলঝরা"
		},
		{
			"id": "453",
			"district_id": "51",
			"name": "Ajmiriganj",
			"bn_name": "আজমিরিগঞ্জ"
		},
		{
			"id": "57",
			"district_id": "41",
			"name": "Akhaura",
			"bn_name": "আখাউরা"
		},
		{
			"id": "342",
			"district_id": "19",
			"name": "Akkelpur",
			"bn_name": "আক্কেলপুর"
		},
		{
			"id": "282",
			"district_id": "56",
			"name": "Alamdanga",
			"bn_name": "আলমডাঙ্গা"
		},
		{
			"id": "152",
			"district_id": "2",
			"name": "Alfadanga",
			"bn_name": "আলফাডাঙ্গা"
		},
		{
			"id": "47",
			"district_id": "40",
			"name": "Ali kadam",
			"bn_name": "আলী কদম"
		},
		{
			"id": "1",
			"district_id": "34",
			"name": "Amtali",
			"bn_name": "আমতলী"
		},
		{
			"id": "316",
			"district_id": "62",
			"name": "angni",
			"bn_name": "আংনি"
		},
		{
			"id": "68",
			"district_id": "43",
			"name": "Anwara",
			"bn_name": "আনোয়ারা"
		},
		{
			"id": "220",
			"district_id": "11",
			"name": "Araihazar",
			"bn_name": "আড়াইহাজার"
		},
		{
			"id": "51",
			"district_id": "41",
			"name": "Ashuganj",
			"bn_name": "আশুগঞ্জ"
		},
		{
			"id": "323",
			"district_id": "64",
			"name": "Assasuni",
			"bn_name": "আসসাশুনি "
		},
		{
			"id": "178",
			"district_id": "6",
			"name": "Astagram",
			"bn_name": "অষ্টগ্রাম"
		},
		{
			"id": "368",
			"district_id": "23",
			"name": "Atgharia",
			"bn_name": "আটঘরিয়া"
		},
		{
			"id": "233",
			"district_id": "13",
			"name": "Atpara Upazilla",
			"bn_name": "আটপাড়া"
		},
		{
			"id": "350",
			"district_id": "20",
			"name": "Atrai",
			"bn_name": "আত্রাই"
		},
		{
			"id": "438",
			"district_id": "31",
			"name": "Atwari",
			"bn_name": "আটোয়ারি"
		},
		{
			"id": "8",
			"district_id": "35",
			"name": "Babuganj",
			"bn_name": "বাবুগঞ্জ"
		},
		{
			"id": "356",
			"district_id": "20",
			"name": "Badalgachhi",
			"bn_name": "বদলগাছি"
		},
		{
			"id": "440",
			"district_id": "32",
			"name": "Badarganj",
			"bn_name": "বদরগঞ্জ"
		},
		{
			"id": "137",
			"district_id": "50",
			"name": "Bagaichhari",
			"bn_name": "বাঘাইছড়ি"
		},
		{
			"id": "359",
			"district_id": "21",
			"name": "Bagatipara",
			"bn_name": "বাগাতিপাড়া"
		},
		{
			"id": "270",
			"district_id": "55",
			"name": "Bagerhat Sadar",
			"bn_name": "বাগেরহাট সদর"
		},
		{
			"id": "377",
			"district_id": "24",
			"name": "Bagha",
			"bn_name": "বাঘা"
		},
		{
			"id": "285",
			"district_id": "57",
			"name": "Bagherpara",
			"bn_name": "বাঘের পাড়া "
		},
		{
			"id": "378",
			"district_id": "24",
			"name": "Bagmara",
			"bn_name": "বাগমারা"
		},
		{
			"id": "455",
			"district_id": "51",
			"name": "Bahubal",
			"bn_name": "বাহুবল"
		},
		{
			"id": "179",
			"district_id": "6",
			"name": "Bajitpur",
			"bn_name": "বাজিতপুর"
		},
		{
			"id": "11",
			"district_id": "35",
			"name": "Bakerganj",
			"bn_name": "বাকেরগঞ্জ"
		},
		{
			"id": "171",
			"district_id": "5",
			"name": "Baksiganj",
			"bn_name": "বকসিগঞ্জ"
		},
		{
			"id": "484",
			"district_id": "54",
			"name": "Balaganj",
			"bn_name": "বালাগঞ্জ"
		},
		{
			"id": "450",
			"district_id": "33",
			"name": "Baliadangi",
			"bn_name": "বালিয়াডাঙ্গি"
		},
		{
			"id": "242",
			"district_id": "14",
			"name": "Baliakandi",
			"bn_name": "বালিয়াকান্দি"
		},
		{
			"id": "2",
			"district_id": "34",
			"name": "Bamna",
			"bn_name": "বামনা"
		},
		{
			"id": "12",
			"district_id": "35",
			"name": "Banaripara",
			"bn_name": "বানাড়িপারা"
		},
		{
			"id": "58",
			"district_id": "41",
			"name": "Bancharampur",
			"bn_name": "বাঞ্ছারামপুর"
		},
		{
			"id": "222",
			"district_id": "11",
			"name": "Bandar",
			"bn_name": "বান্দার"
		},
		{
			"id": "43",
			"district_id": "40",
			"name": "Bandarban Sadar",
			"bn_name": "বান্দরবন সদর"
		},
		{
			"id": "454",
			"district_id": "51",
			"name": "Baniachang",
			"bn_name": "বানিয়াচং"
		},
		{
			"id": "69",
			"district_id": "43",
			"name": "Banshkhali",
			"bn_name": "বাশখালি"
		},
		{
			"id": "358",
			"district_id": "21",
			"name": "Baraigram",
			"bn_name": "বড়াইগ্রাম"
		},
		{
			"id": "362",
			"district_id": "21",
			"name": "Baraigram",
			"bn_name": "বড়াই গ্রাম"
		},
		{
			"id": "3",
			"district_id": "34",
			"name": "Barguna Sadar",
			"bn_name": "বরগুনা সদর"
		},
		{
			"id": "234",
			"district_id": "13",
			"name": "Barhatta Upazilla",
			"bn_name": "বরহাট্টা"
		},
		{
			"id": "10",
			"district_id": "35",
			"name": "Barisal Sadar",
			"bn_name": "বরিশাল সদর"
		},
		{
			"id": "138",
			"district_id": "50",
			"name": "Barkal",
			"bn_name": "বরকল"
		},
		{
			"id": "463",
			"district_id": "52",
			"name": "Barlekha",
			"bn_name": "বড়লেখা"
		},
		{
			"id": "82",
			"district_id": "44",
			"name": "Barura",
			"bn_name": "বড়ুরা"
		},
		{
			"id": "260",
			"district_id": "17",
			"name": "Basail",
			"bn_name": "বসাইল"
		},
		{
			"id": "298",
			"district_id": "59",
			"name": "Batiaghata",
			"bn_name": "বাটিয়াঘাটা "
		},
		{
			"id": "28",
			"district_id": "38",
			"name": "Bauphal",
			"bn_name": "বাউফল"
		},
		{
			"id": "481",
			"district_id": "54",
			"name": "Beanibazar",
			"bn_name": "বেয়ানিবাজার"
		},
		{
			"id": "127",
			"district_id": "49",
			"name": "Begumganj",
			"bn_name": "বেগমগঞ্জ"
		},
		{
			"id": "226",
			"district_id": "12",
			"name": "Belabo",
			"bn_name": "বেলাবো"
		},
		{
			"id": "136",
			"district_id": "50",
			"name": "Belaichhari",
			"bn_name": "বেলাইছড়ি"
		},
		{
			"id": "387",
			"district_id": "25",
			"name": "Belkuchi",
			"bn_name": "বেলকুচি"
		},
		{
			"id": "369",
			"district_id": "23",
			"name": "Bera",
			"bn_name": "বেড়া"
		},
		{
			"id": "4",
			"district_id": "34",
			"name": "Betagi",
			"bn_name": "বেতাগি"
		},
		{
			"id": "180",
			"district_id": "6",
			"name": "Bhairab",
			"bn_name": "ভৈরব"
		},
		{
			"id": "208",
			"district_id": "10",
			"name": "Bhaluka",
			"bn_name": "ভালুকা"
		},
		{
			"id": "36",
			"district_id": "39",
			"name": "Bhandaria",
			"bn_name": "ভ্যান্ডারিয়া"
		},
		{
			"id": "154",
			"district_id": "2",
			"name": "Bhanga",
			"bn_name": "ভাঙ্গা"
		},
		{
			"id": "370",
			"district_id": "23",
			"name": "Bhangura",
			"bn_name": "ভাঙ্গুরা"
		},
		{
			"id": "251",
			"district_id": "15",
			"name": "Bhedarganj",
			"bn_name": "ভেদারগঞ্জ"
		},
		{
			"id": "310",
			"district_id": "60",
			"name": "Bheramara",
			"bn_name": "ভেরামারা"
		},
		{
			"id": "17",
			"district_id": "36",
			"name": "Bhola Sadar",
			"bn_name": "ভোলা সদর"
		},
		{
			"id": "363",
			"district_id": "22",
			"name": "Bholahat",
			"bn_name": "ভোলাহাট"
		},
		{
			"id": "268",
			"district_id": "17",
			"name": "Bhuapur",
			"bn_name": "ভুয়াপুর"
		},
		{
			"id": "417",
			"district_id": "28",
			"name": "Bhurungamari",
			"bn_name": "ভুরুঙ্গামারি"
		},
		{
			"id": "59",
			"district_id": "41",
			"name": "Bijoynagar",
			"bn_name": "বিজয় নগর"
		},
		{
			"id": "397",
			"district_id": "26",
			"name": "Biral",
			"bn_name": "বিড়াল"
		},
		{
			"id": "395",
			"district_id": "26",
			"name": "Birampur",
			"bn_name": "বিরামপুর"
		},
		{
			"id": "396",
			"district_id": "26",
			"name": "Birganj",
			"bn_name": "বীরগঞ্জ"
		},
		{
			"id": "469",
			"district_id": "53",
			"name": "Bishwamvarpur",
			"bn_name": "বিসশম্ভারপুর"
		},
		{
			"id": "482",
			"district_id": "54",
			"name": "Bishwanath",
			"bn_name": "বিশ্বনাথ"
		},
		{
			"id": "70",
			"district_id": "43",
			"name": "Boalkhali",
			"bn_name": "বোয়ালখালি"
		},
		{
			"id": "151",
			"district_id": "2",
			"name": "Boalmari",
			"bn_name": "বোয়ালমারী"
		},
		{
			"id": "398",
			"district_id": "26",
			"name": "Bochaganj",
			"bn_name": "বোচাগঞ্জ"
		},
		{
			"id": "437",
			"district_id": "31",
			"name": "Boda",
			"bn_name": "বোদা"
		},
		{
			"id": "330",
			"district_id": "18",
			"name": "Bogra Sadar",
			"bn_name": "বগুড়া সদর"
		},
		{
			"id": "50",
			"district_id": "41",
			"name": "Brahmanbaria Sadar",
			"bn_name": "ব্রাহ্মণবাড়িয়া সদর"
		},
		{
			"id": "83",
			"district_id": "44",
			"name": "Brahmanpara",
			"bn_name": "ব্রাহ্মণপাড়া"
		},
		{
			"id": "18",
			"district_id": "36",
			"name": "Burhanuddin",
			"bn_name": "বুরহানউদ্দিন"
		},
		{
			"id": "84",
			"district_id": "44",
			"name": "Burichong",
			"bn_name": "বুড়িচং"
		},
		{
			"id": "108",
			"district_id": "46",
			"name": "Chagalnaiya",
			"bn_name": "ছাগল নাইয়া"
		},
		{
			"id": "98",
			"district_id": "45",
			"name": "Chakaria",
			"bn_name": "চকরিয়া"
		},
		{
			"id": "71",
			"district_id": "43",
			"name": "Chandanaish",
			"bn_name": "চন্দনাইশ"
		},
		{
			"id": "85",
			"district_id": "44",
			"name": "Chandina",
			"bn_name": "চান্দিনা"
		},
		{
			"id": "60",
			"district_id": "42",
			"name": "Chandpur Sadar",
			"bn_name": "চাঁদপুর সদর"
		},
		{
			"id": "19",
			"district_id": "36",
			"name": "Char Fasson",
			"bn_name": "চর ফ্যাশন"
		},
		{
			"id": "423",
			"district_id": "28",
			"name": "Char Rajibpur",
			"bn_name": "চর রাজিবপুর"
		},
		{
			"id": "156",
			"district_id": "2",
			"name": "Charbhadrasan",
			"bn_name": "চরভদ্রাসন "
		},
		{
			"id": "379",
			"district_id": "24",
			"name": "Charghat",
			"bn_name": "চারঘাট"
		},
		{
			"id": "128",
			"district_id": "49",
			"name": "Chatkhil",
			"bn_name": "চাটখিল"
		},
		{
			"id": "371",
			"district_id": "23",
			"name": "Chatmohar",
			"bn_name": "চাটমোহর"
		},
		{
			"id": "86",
			"district_id": "44",
			"name": "Chauddagram",
			"bn_name": "চৌদ্দগ্রাম"
		},
		{
			"id": "287",
			"district_id": "57",
			"name": "Chaugachha",
			"bn_name": "চৌগাছা"
		},
		{
			"id": "388",
			"district_id": "25",
			"name": "Chauhali",
			"bn_name": "চৌহালি"
		},
		{
			"id": "470",
			"district_id": "53",
			"name": "Chhatak",
			"bn_name": "ছাতক"
		},
		{
			"id": "421",
			"district_id": "28",
			"name": "Chilmari",
			"bn_name": "চিলমারি"
		},
		{
			"id": "399",
			"district_id": "26",
			"name": "Chirirbandar",
			"bn_name": "চিরিরবন্দর"
		},
		{
			"id": "271",
			"district_id": "55",
			"name": "Chitalmari",
			"bn_name": "চিতলমাড়ি"
		},
		{
			"id": "280",
			"district_id": "56",
			"name": "Chuadanga-S",
			"bn_name": "চুয়াডাঙ্গা সদর"
		},
		{
			"id": "456",
			"district_id": "51",
			"name": "Chunarughat",
			"bn_name": "চুনারুঘাট"
		},
		{
			"id": "90",
			"district_id": "44",
			"name": "Comilla Sadar",
			"bn_name": "কুমিল্লা সদর"
		},
		{
			"id": "96",
			"district_id": "44",
			"name": "Comilla Sadar South",
			"bn_name": "কুমিল্লা সদর দক্ষিণ"
		},
		{
			"id": "485",
			"district_id": "54",
			"name": "Companiganj",
			"bn_name": "কোম্পানিগঞ্জ"
		},
		{
			"id": "129",
			"district_id": "49",
			"name": "Companyganj",
			"bn_name": "কোম্পানীগঞ্জ"
		},
		{
			"id": "100",
			"district_id": "45",
			"name": "Cox's Bazar",
			"bn_name": "কক্স বাজার সদর"
		},
		{
			"id": "299",
			"district_id": "59",
			"name": "Dacope",
			"bn_name": "ডাকপে"
		},
		{
			"id": "109",
			"district_id": "46",
			"name": "Daganbhyan",
			"bn_name": "দাগানভিয়া"
		},
		{
			"id": "483",
			"district_id": "54",
			"name": "Dakshin Surma",
			"bn_name": "দক্ষিণ সুরমা"
		},
		{
			"id": "248",
			"district_id": "15",
			"name": "Damudya",
			"bn_name": "দামুদিয়া"
		},
		{
			"id": "279",
			"district_id": "56",
			"name": "Damurhuda",
			"bn_name": "দামুরহুদা"
		},
		{
			"id": "495",
			"district_id": "7",
			"name": "Dasar",
			"bn_name": "দশর"
		},
		{
			"id": "29",
			"district_id": "38",
			"name": "Dashmina",
			"bn_name": "দশমিনা"
		},
		{
			"id": "87",
			"district_id": "44",
			"name": "Daudkandi",
			"bn_name": "দাউদকান্দি"
		},
		{
			"id": "20",
			"district_id": "36",
			"name": "Daulatkhan",
			"bn_name": "দৌলতখান"
		},
		{
			"id": "201",
			"district_id": "8",
			"name": "Daulatpur",
			"bn_name": "দৌলতপুর"
		},
		{
			"id": "308",
			"district_id": "60",
			"name": "Daulatpur",
			"bn_name": "দৌলতপুর"
		},
		{
			"id": "324",
			"district_id": "64",
			"name": "Debhata",
			"bn_name": "দেভাটা"
		},
		{
			"id": "88",
			"district_id": "44",
			"name": "Debidwar",
			"bn_name": "দেবীদ্বার"
		},
		{
			"id": "436",
			"district_id": "31",
			"name": "Debiganj",
			"bn_name": "দেবীগঞ্জ"
		},
		{
			"id": "267",
			"district_id": "17",
			"name": "Delduar",
			"bn_name": "দেলদুয়ার"
		},
		{
			"id": "471",
			"district_id": "53",
			"name": "Derai",
			"bn_name": "দেড়াই"
		},
		{
			"id": "170",
			"district_id": "5",
			"name": "Dewanganj",
			"bn_name": "দেওয়ানগঞ্জ"
		},
		{
			"id": "353",
			"district_id": "20",
			"name": "Dhamoirhat",
			"bn_name": "ধামইরহাট "
		},
		{
			"id": "145",
			"district_id": "1",
			"name": "Dhamrai",
			"bn_name": "ধামরাই"
		},
		{
			"id": "269",
			"district_id": "17",
			"name": "Dhanbari",
			"bn_name": "ধানবাড়ি"
		},
		{
			"id": "472",
			"district_id": "53",
			"name": "Dharampasha",
			"bn_name": "ধরমপাশা"
		},
		{
			"id": "212",
			"district_id": "10",
			"name": "Dhobaura",
			"bn_name": "ধবারুয়া"
		},
		{
			"id": "332",
			"district_id": "18",
			"name": "Dhunat",
			"bn_name": "ধুনট"
		},
		{
			"id": "333",
			"district_id": "18",
			"name": "Dhupchanchia",
			"bn_name": "দুপচাচিয়া"
		},
		{
			"id": "301",
			"district_id": "59",
			"name": "Dighalia",
			"bn_name": "দিঘলিয়া"
		},
		{
			"id": "113",
			"district_id": "47",
			"name": "Dighinala",
			"bn_name": "দিঘিনালা "
		},
		{
			"id": "434",
			"district_id": "30",
			"name": "Dimla",
			"bn_name": "ডিমলা"
		},
		{
			"id": "405",
			"district_id": "26",
			"name": "Dinajpur Sadar",
			"bn_name": "দিনাজপুর সদর"
		},
		{
			"id": "146",
			"district_id": "1",
			"name": "Dohar",
			"bn_name": "দোহার"
		},
		{
			"id": "433",
			"district_id": "30",
			"name": "Domar",
			"bn_name": "ডোমার"
		},
		{
			"id": "473",
			"district_id": "53",
			"name": "Dowarabazar",
			"bn_name": "দোয়ারাবাজার"
		},
		{
			"id": "34",
			"district_id": "38",
			"name": "Dumki",
			"bn_name": "ডুমকি"
		},
		{
			"id": "300",
			"district_id": "59",
			"name": "Dumuria",
			"bn_name": "ডুমুরিয়া"
		},
		{
			"id": "380",
			"district_id": "24",
			"name": "Durgapur",
			"bn_name": "দুর্গাপুর"
		},
		{
			"id": "235",
			"district_id": "13",
			"name": "Durgapur Upazilla",
			"bn_name": "দুর্গাপুর"
		},
		{
			"id": "493",
			"district_id": "45",
			"name": "Eidgaon",
			"bn_name": "ঈদগাঁও"
		},
		{
			"id": "272",
			"district_id": "55",
			"name": "Fakirhat",
			"bn_name": "ফকিরহাট"
		},
		{
			"id": "61",
			"district_id": "42",
			"name": "Faridganj",
			"bn_name": "ফরিদগঞ্জ"
		},
		{
			"id": "372",
			"district_id": "23",
			"name": "Faridpur",
			"bn_name": "ফরিদপুর"
		},
		{
			"id": "150",
			"district_id": "2",
			"name": "Faridpur Sadar",
			"bn_name": "ফরিদপুর সদর"
		},
		{
			"id": "72",
			"district_id": "43",
			"name": "Fatikchhari",
			"bn_name": "ফটিকছড়ি"
		},
		{
			"id": "486",
			"district_id": "54",
			"name": "Fenchuganj",
			"bn_name": "ফেঞ্চুগঞ্জ"
		},
		{
			"id": "107",
			"district_id": "46",
			"name": "Feni Sadar",
			"bn_name": "ফেনী সদর"
		},
		{
			"id": "111",
			"district_id": "46",
			"name": "Fhulgazi",
			"bn_name": "ফুলগাজি"
		},
		{
			"id": "213",
			"district_id": "10",
			"name": "Fulbaria",
			"bn_name": "ফুলবাড়িয়া"
		},
		{
			"id": "408",
			"district_id": "27",
			"name": "Fulchhari",
			"bn_name": "ফুলছড়ি"
		},
		{
			"id": "334",
			"district_id": "18",
			"name": "Gabtali",
			"bn_name": "গাবতলি"
		},
		{
			"id": "214",
			"district_id": "10",
			"name": "Gaffargaon",
			"bn_name": "গফরগাঁও"
		},
		{
			"id": "409",
			"district_id": "27",
			"name": "Gaibandha sadar",
			"bn_name": "গাইবান্ধা সদর"
		},
		{
			"id": "30",
			"district_id": "38",
			"name": "Galachipa",
			"bn_name": "গলাচিপা"
		},
		{
			"id": "442",
			"district_id": "32",
			"name": "Gangachara",
			"bn_name": "গঙ্গাচরা"
		},
		{
			"id": "215",
			"district_id": "10",
			"name": "Gauripur",
			"bn_name": "গৌরিপুর"
		},
		{
			"id": "13",
			"district_id": "35",
			"name": "Gaurnadi",
			"bn_name": "গৌরনদী"
		},
		{
			"id": "207",
			"district_id": "9",
			"name": "Gazaria",
			"bn_name": "গজারিয়া"
		},
		{
			"id": "159",
			"district_id": "3",
			"name": "Gazipur Sadar-Joydebpur",
			"bn_name": "গাজীপুর সদর"
		},
		{
			"id": "262",
			"district_id": "17",
			"name": "Ghatail",
			"bn_name": "ঘাটাইল"
		},
		{
			"id": "200",
			"district_id": "8",
			"name": "Ghior",
			"bn_name": "ঘিওর"
		},
		{
			"id": "401",
			"district_id": "26",
			"name": "Ghoraghat",
			"bn_name": "ঘোড়াঘাট"
		},
		{
			"id": "243",
			"district_id": "14",
			"name": "Goalandaghat",
			"bn_name": "গোয়ালন্দ ঘাট"
		},
		{
			"id": "410",
			"district_id": "27",
			"name": "Gobindaganj",
			"bn_name": "গোবিন্দগঞ্জ"
		},
		{
			"id": "381",
			"district_id": "24",
			"name": "Godagari",
			"bn_name": "গোদাগারি"
		},
		{
			"id": "487",
			"district_id": "54",
			"name": "Golapganj",
			"bn_name": "গোলাপগঞ্জ"
		},
		{
			"id": "364",
			"district_id": "22",
			"name": "Gomastapur",
			"bn_name": "গোমস্তাপুর"
		},
		{
			"id": "165",
			"district_id": "4",
			"name": "Gopalganj Sadar",
			"bn_name": "গোপালগঞ্জ সদর"
		},
		{
			"id": "266",
			"district_id": "17",
			"name": "Gopalpur",
			"bn_name": "গোপালপুর"
		},
		{
			"id": "252",
			"district_id": "15",
			"name": "Gosairhat",
			"bn_name": "গোসাইর হাট "
		},
		{
			"id": "488",
			"district_id": "54",
			"name": "Gowainghat",
			"bn_name": "গোয়াইনঘাট"
		},
		{
			"id": "457",
			"district_id": "51",
			"name": "Habiganj Sadar",
			"bn_name": "হবিগঞ্জ সদর"
		},
		{
			"id": "62",
			"district_id": "42",
			"name": "Haimchar",
			"bn_name": "হাইমচর"
		},
		{
			"id": "402",
			"district_id": "26",
			"name": "Hakimpur",
			"bn_name": "হাকিমপুর"
		},
		{
			"id": "210",
			"district_id": "10",
			"name": "Haluaghat",
			"bn_name": "হালুয়াঘাট"
		},
		{
			"id": "296",
			"district_id": "58",
			"name": "Harinakunda",
			"bn_name": "হাড়িনাকুন্দা"
		},
		{
			"id": "451",
			"district_id": "33",
			"name": "Haripur",
			"bn_name": "হরিপুর"
		},
		{
			"id": "199",
			"district_id": "8",
			"name": "Harirampur",
			"bn_name": "হরিরামপুর"
		},
		{
			"id": "73",
			"district_id": "43",
			"name": "Hathazari",
			"bn_name": "হাঠহাজারী"
		},
		{
			"id": "131",
			"district_id": "49",
			"name": "Hatia",
			"bn_name": "হাতিয়া"
		},
		{
			"id": "427",
			"district_id": "29",
			"name": "Hatibandha",
			"bn_name": "হাতিবান্ধা"
		},
		{
			"id": "63",
			"district_id": "42",
			"name": "Haziganj",
			"bn_name": "হাজীগঞ্জ"
		},
		{
			"id": "14",
			"district_id": "35",
			"name": "Hizla",
			"bn_name": "হিজলা"
		},
		{
			"id": "89",
			"district_id": "44",
			"name": "Homna",
			"bn_name": "হোমনা"
		},
		{
			"id": "181",
			"district_id": "6",
			"name": "Hossainpur",
			"bn_name": "হোসেনপুর "
		},
		{
			"id": "373",
			"district_id": "23",
			"name": "Ishwardi",
			"bn_name": "ঈশ্বরদী"
		},
		{
			"id": "216",
			"district_id": "10",
			"name": "Ishwarganj",
			"bn_name": "ঈশ্বরগঞ্জ"
		},
		{
			"id": "172",
			"district_id": "5",
			"name": "Islampur",
			"bn_name": "ইসলামপুর"
		},
		{
			"id": "182",
			"district_id": "6",
			"name": "Itna",
			"bn_name": "ইটনা"
		},
		{
			"id": "474",
			"district_id": "53",
			"name": "Jagannathpur",
			"bn_name": "জগন্নাথপুর"
		},
		{
			"id": "250",
			"district_id": "15",
			"name": "Jajira",
			"bn_name": "জাজিরা"
		},
		{
			"id": "431",
			"district_id": "30",
			"name": "Jaldhaka",
			"bn_name": "জলঢাকা"
		},
		{
			"id": "475",
			"district_id": "53",
			"name": "Jamalganj",
			"bn_name": "জামালগঞ্জ"
		},
		{
			"id": "173",
			"district_id": "5",
			"name": "Jamalpur Sadar",
			"bn_name": "জামালপুর সদর"
		},
		{
			"id": "286",
			"district_id": "57",
			"name": "Jessore Sadar",
			"bn_name": "যশোর সদর"
		},
		{
			"id": "24",
			"district_id": "37",
			"name": "Jhalokati Sadar",
			"bn_name": "ঝালকাঠি সদর"
		},
		{
			"id": "291",
			"district_id": "58",
			"name": "Jhenaidah Sadar",
			"bn_name": "ঝিনাইদহ সদর"
		},
		{
			"id": "253",
			"district_id": "16",
			"name": "Jhenaigati",
			"bn_name": "ঝিনাইগাতি"
		},
		{
			"id": "289",
			"district_id": "57",
			"name": "Jhikargachha",
			"bn_name": "ঝিকরগাছা"
		},
		{
			"id": "281",
			"district_id": "56",
			"name": "Jibannagar",
			"bn_name": "জীবন নগর "
		},
		{
			"id": "489",
			"district_id": "54",
			"name": "Jointapur",
			"bn_name": "জৈন্তাপুর"
		},
		{
			"id": "341",
			"district_id": "19",
			"name": "Joypurhat S",
			"bn_name": "জয়পুরহাট সদর"
		},
		{
			"id": "139",
			"district_id": "50",
			"name": "Juraichhari",
			"bn_name": "জুরাইছড়ি"
		},
		{
			"id": "464",
			"district_id": "52",
			"name": "Juri",
			"bn_name": "জুড়ি"
		},
		{
			"id": "64",
			"district_id": "42",
			"name": "Kachua",
			"bn_name": "কচুয়া"
		},
		{
			"id": "273",
			"district_id": "55",
			"name": "Kachua",
			"bn_name": "কচুয়া"
		},
		{
			"id": "335",
			"district_id": "18",
			"name": "Kahaloo",
			"bn_name": "কাহালু"
		},
		{
			"id": "403",
			"district_id": "26",
			"name": "Kaharole",
			"bn_name": "কাহারোল"
		},
		{
			"id": "343",
			"district_id": "19",
			"name": "Kalai",
			"bn_name": "কালাই"
		},
		{
			"id": "31",
			"district_id": "38",
			"name": "Kalapara",
			"bn_name": "কালাপারা"
		},
		{
			"id": "326",
			"district_id": "64",
			"name": "Kalaroa",
			"bn_name": "কলরোয়া"
		},
		{
			"id": "321",
			"district_id": "63",
			"name": "Kalia Upazilla",
			"bn_name": "কালিয়া"
		},
		{
			"id": "160",
			"district_id": "3",
			"name": "Kaliakior",
			"bn_name": "কালিয়াকৈর"
		},
		{
			"id": "163",
			"district_id": "3",
			"name": "Kaliganj",
			"bn_name": "কালীগঞ্জ"
		},
		{
			"id": "293",
			"district_id": "58",
			"name": "Kaliganj",
			"bn_name": "কালীগঞ্জ"
		},
		{
			"id": "327",
			"district_id": "64",
			"name": "Kaliganj",
			"bn_name": "কালীগঞ্জ"
		},
		{
			"id": "426",
			"district_id": "29",
			"name": "Kaliganj",
			"bn_name": "কালীগঞ্জ"
		},
		{
			"id": "263",
			"district_id": "17",
			"name": "Kalihati",
			"bn_name": "কালিহাতি"
		},
		{
			"id": "192",
			"district_id": "7",
			"name": "Kalkini",
			"bn_name": "কালকিনি"
		},
		{
			"id": "236",
			"district_id": "13",
			"name": "Kalmakanda Upazilla",
			"bn_name": "কলমাকান্দা"
		},
		{
			"id": "245",
			"district_id": "14",
			"name": "Kalukhali",
			"bn_name": "কালুখালি"
		},
		{
			"id": "465",
			"district_id": "52",
			"name": "Kamalganj",
			"bn_name": "কামালগঞ্জ"
		},
		{
			"id": "389",
			"district_id": "25",
			"name": "Kamarkhanda",
			"bn_name": "কামারখান্দা"
		},
		{
			"id": "490",
			"district_id": "54",
			"name": "Kanaighat",
			"bn_name": "কানাইঘাট"
		},
		{
			"id": "161",
			"district_id": "3",
			"name": "Kapasia",
			"bn_name": "কাপাসিয়া"
		},
		{
			"id": "141",
			"district_id": "50",
			"name": "Kaptai",
			"bn_name": "কাপ্তাই"
		},
		{
			"id": "183",
			"district_id": "6",
			"name": "Karimganj",
			"bn_name": "করিমগঞ্জ"
		},
		{
			"id": "56",
			"district_id": "41",
			"name": "Kasba",
			"bn_name": "কসবা"
		},
		{
			"id": "166",
			"district_id": "4",
			"name": "Kashiani",
			"bn_name": "কাশিয়ানি"
		},
		{
			"id": "25",
			"district_id": "37",
			"name": "Kathalia",
			"bn_name": "কাঁঠালিয়া"
		},
		{
			"id": "184",
			"district_id": "6",
			"name": "Katiadi",
			"bn_name": "কতিয়াদি"
		},
		{
			"id": "37",
			"district_id": "39",
			"name": "Kaukhali",
			"bn_name": "কাউখালি"
		},
		{
			"id": "144",
			"district_id": "50",
			"name": "Kaukhali",
			"bn_name": "কাউখালি"
		},
		{
			"id": "443",
			"district_id": "32",
			"name": "Kaunia",
			"bn_name": "কাউনিয়া"
		},
		{
			"id": "390",
			"district_id": "25",
			"name": "Kazipur",
			"bn_name": "কাজীপুর"
		},
		{
			"id": "232",
			"district_id": "13",
			"name": "Kendua Upazilla",
			"bn_name": "কেন্দুয়া"
		},
		{
			"id": "147",
			"district_id": "1",
			"name": "Keraniganj",
			"bn_name": "কেরানীগঞ্জ"
		},
		{
			"id": "284",
			"district_id": "57",
			"name": "Keshabpur",
			"bn_name": "কেশবপুর"
		},
		{
			"id": "114",
			"district_id": "47",
			"name": "Khagrachhari",
			"bn_name": "খাগড়াছড়ি"
		},
		{
			"id": "241",
			"district_id": "13",
			"name": "Khaliajuri Upazilla",
			"bn_name": "খালিয়াজুরি"
		},
		{
			"id": "404",
			"district_id": "26",
			"name": "Khansama",
			"bn_name": "খানসামা"
		},
		{
			"id": "344",
			"district_id": "19",
			"name": "Khetlal",
			"bn_name": "খেতলাল"
		},
		{
			"id": "311",
			"district_id": "60",
			"name": "Khoksa",
			"bn_name": "খোকসা"
		},
		{
			"id": "432",
			"district_id": "30",
			"name": "Kishoreganj",
			"bn_name": "কিশোরগঞ্জ"
		},
		{
			"id": "185",
			"district_id": "6",
			"name": "Kishoreganj Sadar",
			"bn_name": "কিশোরগঞ্জ সদর"
		},
		{
			"id": "132",
			"district_id": "49",
			"name": "Kobirhat",
			"bn_name": "কবিরহাট "
		},
		{
			"id": "125",
			"district_id": "48",
			"name": "Komol Nagar",
			"bn_name": "কমল নগর"
		},
		{
			"id": "167",
			"district_id": "4",
			"name": "Kotalipara",
			"bn_name": "কোটালিপাড়া"
		},
		{
			"id": "294",
			"district_id": "58",
			"name": "Kotchandpur",
			"bn_name": "কোট চাঁদপুর "
		},
		{
			"id": "302",
			"district_id": "59",
			"name": "Koyra",
			"bn_name": "কয়ড়া"
		},
		{
			"id": "466",
			"district_id": "52",
			"name": "Kulaura",
			"bn_name": "কুলাউরা"
		},
		{
			"id": "186",
			"district_id": "6",
			"name": "Kuliarchar",
			"bn_name": "কুলিয়ারচর"
		},
		{
			"id": "307",
			"district_id": "60",
			"name": "Kumarkhali",
			"bn_name": "কুমারখালি"
		},
		{
			"id": "415",
			"district_id": "28",
			"name": "Kurigram Sadar",
			"bn_name": "কুড়িগ্রাম সদর"
		},
		{
			"id": "306",
			"district_id": "60",
			"name": "Kushtia Sadar",
			"bn_name": "কুষ্টিয়া সদর"
		},
		{
			"id": "101",
			"district_id": "45",
			"name": "Kutubdia",
			"bn_name": "কুতুবদিয়া"
		},
		{
			"id": "458",
			"district_id": "51",
			"name": "Lakhai",
			"bn_name": "লাক্ষাই"
		},
		{
			"id": "91",
			"district_id": "44",
			"name": "Laksam",
			"bn_name": "লাকসাম"
		},
		{
			"id": "115",
			"district_id": "47",
			"name": "Lakshmichhari",
			"bn_name": "লক্ষ্মীছড়ি"
		},
		{
			"id": "121",
			"district_id": "48",
			"name": "Lakshmipur Sadar",
			"bn_name": "লক্ষ্মীপুর সদর"
		},
		{
			"id": "424",
			"district_id": "29",
			"name": "Lalmanirhat Sadar",
			"bn_name": "লালমনিরহাট সদর"
		},
		{
			"id": "21",
			"district_id": "36",
			"name": "Lalmohan",
			"bn_name": "লালমোহন"
		},
		{
			"id": "360",
			"district_id": "21",
			"name": "Lalpur",
			"bn_name": "লালপুর"
		},
		{
			"id": "45",
			"district_id": "40",
			"name": "Lama",
			"bn_name": "লামা"
		},
		{
			"id": "142",
			"district_id": "50",
			"name": "Langadu",
			"bn_name": "লাঙ্গাডু"
		},
		{
			"id": "74",
			"district_id": "43",
			"name": "Lohagara",
			"bn_name": "লোহাগারা"
		},
		{
			"id": "320",
			"district_id": "63",
			"name": "Lohagara Upazilla",
			"bn_name": "লোহাগাড়া"
		},
		{
			"id": "202",
			"district_id": "9",
			"name": "Lohajang",
			"bn_name": "লোহাজং"
		},
		{
			"id": "237",
			"district_id": "13",
			"name": "Madan Upazilla",
			"bn_name": "মদন"
		},
		{
			"id": "174",
			"district_id": "5",
			"name": "Madarganj",
			"bn_name": "মাদারগঞ্জ"
		},
		{
			"id": "191",
			"district_id": "7",
			"name": "Madaripur Sadar",
			"bn_name": "মাদারীপুর সদর"
		},
		{
			"id": "459",
			"district_id": "51",
			"name": "Madhabpur",
			"bn_name": "মাধবপুর"
		},
		{
			"id": "153",
			"district_id": "2",
			"name": "Madhukhali",
			"bn_name": "মধুখালি"
		},
		{
			"id": "261",
			"district_id": "17",
			"name": "Madhupur",
			"bn_name": "মধুপুর"
		},
		{
			"id": "312",
			"district_id": "61",
			"name": "Magura Sadar",
			"bn_name": "মাগুরা সদর"
		},
		{
			"id": "116",
			"district_id": "47",
			"name": "Mahalchhari",
			"bn_name": "মহলছড়ি"
		},
		{
			"id": "102",
			"district_id": "45",
			"name": "Maheshkhali",
			"bn_name": "মহেশখালী"
		},
		{
			"id": "292",
			"district_id": "58",
			"name": "Maheshpur",
			"bn_name": "মহেশপুর"
		},
		{
			"id": "348",
			"district_id": "20",
			"name": "Manda",
			"bn_name": "মান্দা"
		},
		{
			"id": "117",
			"district_id": "47",
			"name": "Manikchhari",
			"bn_name": "মানিকছড়ি"
		},
		{
			"id": "195",
			"district_id": "8",
			"name": "Manikganj Sadar",
			"bn_name": "মানিকগঞ্জ সদর"
		},
		{
			"id": "288",
			"district_id": "57",
			"name": "Manirampur",
			"bn_name": "মনিরামপুর "
		},
		{
			"id": "22",
			"district_id": "36",
			"name": "Manpura",
			"bn_name": "মনপুরা"
		},
		{
			"id": "38",
			"district_id": "39",
			"name": "Mathbaria",
			"bn_name": "মাঠবাড়িয়া"
		},
		{
			"id": "118",
			"district_id": "47",
			"name": "Matiranga",
			"bn_name": "মাটিরাঙ্গা"
		},
		{
			"id": "66",
			"district_id": "42",
			"name": "Matlab Dakkhin",
			"bn_name": "মতলব দক্ষিণ"
		},
		{
			"id": "65",
			"district_id": "42",
			"name": "Matlab Uttar",
			"bn_name": "মতলব উত্তর"
		},
		{
			"id": "93",
			"district_id": "44",
			"name": "Meghna",
			"bn_name": "মেঘনা"
		},
		{
			"id": "15",
			"district_id": "35",
			"name": "Mehendiganj",
			"bn_name": "মেহেদিগঞ্জ "
		},
		{
			"id": "318",
			"district_id": "62",
			"name": "Meherpur-S",
			"bn_name": "মেহেরপুর সদর"
		},
		{
			"id": "175",
			"district_id": "5",
			"name": "Melandaha",
			"bn_name": "মেলানদাহা"
		},
		{
			"id": "309",
			"district_id": "60",
			"name": "Mirpur",
			"bn_name": "মিরপুর"
		},
		{
			"id": "75",
			"district_id": "43",
			"name": "Mirsharai",
			"bn_name": "মিরসরাই"
		},
		{
			"id": "32",
			"district_id": "38",
			"name": "Mirzaganj",
			"bn_name": "মির্জাগঞ্জ "
		},
		{
			"id": "265",
			"district_id": "17",
			"name": "Mirzapur",
			"bn_name": "মির্জাপুর"
		},
		{
			"id": "187",
			"district_id": "6",
			"name": "Mithamain",
			"bn_name": "মিঠামাইন"
		},
		{
			"id": "441",
			"district_id": "32",
			"name": "Mithapukur",
			"bn_name": "মিঠাপুকুর"
		},
		{
			"id": "494",
			"district_id": "53",
			"name": "Modhyanagar",
			"bn_name": "মধ্যনগর"
		},
		{
			"id": "347",
			"district_id": "20",
			"name": "Mohadevpur",
			"bn_name": "মহাদেবপুর"
		},
		{
			"id": "313",
			"district_id": "61",
			"name": "Mohammadpur",
			"bn_name": "মোহাম্মাদপুর"
		},
		{
			"id": "238",
			"district_id": "13",
			"name": "Mohanganj Upazilla",
			"bn_name": "মোহনগঞ্জ"
		},
		{
			"id": "382",
			"district_id": "24",
			"name": "Mohanpur",
			"bn_name": "মোহনপুর"
		},
		{
			"id": "274",
			"district_id": "55",
			"name": "Mollahat",
			"bn_name": "মোল্লাহাট "
		},
		{
			"id": "275",
			"district_id": "55",
			"name": "Mongla",
			"bn_name": "মংলা"
		},
		{
			"id": "227",
			"district_id": "12",
			"name": "Monohardi",
			"bn_name": "মনোহরদি"
		},
		{
			"id": "92",
			"district_id": "44",
			"name": "Monohorgonj",
			"bn_name": "মনোহরগঞ্জ"
		},
		{
			"id": "276",
			"district_id": "55",
			"name": "Morrelganj",
			"bn_name": "মরেলগঞ্জ"
		},
		{
			"id": "462",
			"district_id": "52",
			"name": "Moulvibazar Sadar",
			"bn_name": "মৌলভীবাজার"
		},
		{
			"id": "317",
			"district_id": "62",
			"name": "Mujib Nagar",
			"bn_name": "মুজিব নগর"
		},
		{
			"id": "168",
			"district_id": "4",
			"name": "Muksudpur",
			"bn_name": "মুকসুদপুর"
		},
		{
			"id": "211",
			"district_id": "10",
			"name": "Muktagachha",
			"bn_name": "মুক্তাগাছা"
		},
		{
			"id": "7",
			"district_id": "35",
			"name": "Muladi",
			"bn_name": "মুলাদি"
		},
		{
			"id": "204",
			"district_id": "9",
			"name": "Munshiganj Sadar",
			"bn_name": "মুন্সিগঞ্জ সদর"
		},
		{
			"id": "94",
			"district_id": "44",
			"name": "Muradnagar",
			"bn_name": "মুরাদনগর"
		},
		{
			"id": "217",
			"district_id": "10",
			"name": "Mymensingh Sadar",
			"bn_name": "ময়মনসিং সদর"
		},
		{
			"id": "460",
			"district_id": "51",
			"name": "Nabiganj",
			"bn_name": "নবীগঞ্জ"
		},
		{
			"id": "53",
			"district_id": "41",
			"name": "Nabinagar",
			"bn_name": "নবীনগর"
		},
		{
			"id": "365",
			"district_id": "22",
			"name": "Nachole",
			"bn_name": "নাচোল"
		},
		{
			"id": "155",
			"district_id": "2",
			"name": "Nagarkanda",
			"bn_name": "নগরকান্ড"
		},
		{
			"id": "264",
			"district_id": "17",
			"name": "Nagarpur",
			"bn_name": "নগরপুর"
		},
		{
			"id": "416",
			"district_id": "28",
			"name": "Nageshwari",
			"bn_name": "নাগেশ্বরী"
		},
		{
			"id": "46",
			"district_id": "40",
			"name": "Naikhongchhari",
			"bn_name": "নাইখংছড়ি "
		},
		{
			"id": "254",
			"district_id": "16",
			"name": "Nakla",
			"bn_name": "নাকলা"
		},
		{
			"id": "26",
			"district_id": "37",
			"name": "Nalchity",
			"bn_name": "নালচিতি"
		},
		{
			"id": "255",
			"district_id": "16",
			"name": "Nalitabari",
			"bn_name": "নালিতাবাড়ি"
		},
		{
			"id": "218",
			"district_id": "10",
			"name": "Nandail",
			"bn_name": "নন্দাইল"
		},
		{
			"id": "336",
			"district_id": "18",
			"name": "Nandigram",
			"bn_name": "নন্দিগ্রাম"
		},
		{
			"id": "95",
			"district_id": "44",
			"name": "Nangalkot",
			"bn_name": "নাঙ্গালকোট"
		},
		{
			"id": "143",
			"district_id": "50",
			"name": "Nannerchar",
			"bn_name": "নান্নেরচর "
		},
		{
			"id": "346",
			"district_id": "20",
			"name": "Naogaon Sadar",
			"bn_name": "নওগাঁ সদর"
		},
		{
			"id": "319",
			"district_id": "63",
			"name": "Narail-S Upazilla",
			"bn_name": "নড়াইল সদর"
		},
		{
			"id": "249",
			"district_id": "15",
			"name": "Naria",
			"bn_name": "নড়িয়া"
		},
		{
			"id": "228",
			"district_id": "12",
			"name": "Narsingdi Sadar",
			"bn_name": "নরসিংদী সদর"
		},
		{
			"id": "177",
			"district_id": "5",
			"name": "Narundi Police I.C",
			"bn_name": "নারুন্দি"
		},
		{
			"id": "223",
			"district_id": "11",
			"name": "Naryanganj Sadar",
			"bn_name": "নারায়ানগঞ্জ সদর"
		},
		{
			"id": "52",
			"district_id": "41",
			"name": "Nasirnagar",
			"bn_name": "নাসির নগর"
		},
		{
			"id": "357",
			"district_id": "21",
			"name": "Natore Sadar",
			"bn_name": "নাটোর সদর"
		},
		{
			"id": "361",
			"district_id": "21",
			"name": "Natore Sadar",
			"bn_name": "নাটোর সদর"
		},
		{
			"id": "148",
			"district_id": "1",
			"name": "Nawabganj",
			"bn_name": "নবাবগঞ্জ"
		},
		{
			"id": "406",
			"district_id": "26",
			"name": "Nawabganj",
			"bn_name": "নবাবগঞ্জ"
		},
		{
			"id": "366",
			"district_id": "22",
			"name": "Nawabganj Sadar",
			"bn_name": "নবাবগঞ্জ সদর"
		},
		{
			"id": "39",
			"district_id": "39",
			"name": "Nazirpur",
			"bn_name": "নাজিরপুর"
		},
		{
			"id": "40",
			"district_id": "39",
			"name": "Nesarabad",
			"bn_name": "নেসারাবাদ"
		},
		{
			"id": "239",
			"district_id": "13",
			"name": "Netrakona-S Upazilla",
			"bn_name": "নেত্রকোনা সদর"
		},
		{
			"id": "349",
			"district_id": "20",
			"name": "Niamatpur",
			"bn_name": "নিয়ামতপুর"
		},
		{
			"id": "188",
			"district_id": "6",
			"name": "Nikli",
			"bn_name": "নিকলি"
		},
		{
			"id": "429",
			"district_id": "30",
			"name": "Nilphamari Sadar",
			"bn_name": "নীলফামারী সদর"
		},
		{
			"id": "126",
			"district_id": "49",
			"name": "Noakhali Sadar",
			"bn_name": "নোয়াখালী সদর"
		},
		{
			"id": "492",
			"district_id": "54",
			"name": "Nobigonj",
			"bn_name": "নবীগঞ্জ"
		},
		{
			"id": "383",
			"district_id": "24",
			"name": "Paba",
			"bn_name": "পবা"
		},
		{
			"id": "374",
			"district_id": "23",
			"name": "Pabna Sadar",
			"bn_name": "পাবনা সদর"
		},
		{
			"id": "303",
			"district_id": "59",
			"name": "Paikgachha",
			"bn_name": "পাইকগাছা"
		},
		{
			"id": "189",
			"district_id": "6",
			"name": "Pakundia",
			"bn_name": "পাকুন্ডা"
		},
		{
			"id": "229",
			"district_id": "12",
			"name": "Palash",
			"bn_name": "পলাশ"
		},
		{
			"id": "411",
			"district_id": "27",
			"name": "Palashbari",
			"bn_name": "পলাশবাড়ী"
		},
		{
			"id": "435",
			"district_id": "31",
			"name": "Panchagarh Sadar",
			"bn_name": "পঞ্চগড় সদর"
		},
		{
			"id": "345",
			"district_id": "19",
			"name": "Panchbibi",
			"bn_name": "পাঁচবিবি"
		},
		{
			"id": "119",
			"district_id": "47",
			"name": "Panchhari",
			"bn_name": "পানছড়ি"
		},
		{
			"id": "244",
			"district_id": "14",
			"name": "Pangsha",
			"bn_name": "পাংশা"
		},
		{
			"id": "407",
			"district_id": "26",
			"name": "Parbatipur",
			"bn_name": "পার্বতীপুর"
		},
		{
			"id": "110",
			"district_id": "46",
			"name": "Parshuram",
			"bn_name": "পরশুরাম"
		},
		{
			"id": "428",
			"district_id": "29",
			"name": "Patgram",
			"bn_name": "পাটগ্রাম"
		},
		{
			"id": "5",
			"district_id": "34",
			"name": "Patharghata",
			"bn_name": "পাথরঘাটা"
		},
		{
			"id": "76",
			"district_id": "43",
			"name": "Patiya",
			"bn_name": "পটিয়া"
		},
		{
			"id": "352",
			"district_id": "20",
			"name": "Patnitala",
			"bn_name": "পত্নীতলা"
		},
		{
			"id": "33",
			"district_id": "38",
			"name": "Patuakhali Sadar",
			"bn_name": "পটুয়াখালী সদর"
		},
		{
			"id": "106",
			"district_id": "45",
			"name": "Pekua",
			"bn_name": "পেকুয়া"
		},
		{
			"id": "400",
			"district_id": "26",
			"name": "Phulbari",
			"bn_name": "ফুলবাড়ি"
		},
		{
			"id": "418",
			"district_id": "28",
			"name": "Phulbari",
			"bn_name": "ফুলবাড়ি"
		},
		{
			"id": "219",
			"district_id": "10",
			"name": "Phulpur",
			"bn_name": "ফুলপুর"
		},
		{
			"id": "304",
			"district_id": "59",
			"name": "Phultala",
			"bn_name": "ফুলতলা"
		},
		{
			"id": "445",
			"district_id": "32",
			"name": "Pirgachha",
			"bn_name": "পীরগাছা"
		},
		{
			"id": "446",
			"district_id": "32",
			"name": "Pirganj",
			"bn_name": "পীরগঞ্জ"
		},
		{
			"id": "449",
			"district_id": "33",
			"name": "Pirganj",
			"bn_name": "পীরগঞ্জ"
		},
		{
			"id": "41",
			"district_id": "39",
			"name": "Pirojpur Sadar",
			"bn_name": "পিরোজপুর সদর"
		},
		{
			"id": "355",
			"district_id": "20",
			"name": "Porsha",
			"bn_name": "পোরশা"
		},
		{
			"id": "240",
			"district_id": "13",
			"name": "Purbadhala Upazilla",
			"bn_name": "পূর্বধলা"
		},
		{
			"id": "384",
			"district_id": "24",
			"name": "Puthia",
			"bn_name": "পুঠিয়া"
		},
		{
			"id": "391",
			"district_id": "25",
			"name": "Raiganj",
			"bn_name": "রায়গঞ্জ"
		},
		{
			"id": "122",
			"district_id": "48",
			"name": "Raipur",
			"bn_name": "রায়পুর"
		},
		{
			"id": "230",
			"district_id": "12",
			"name": "Raipura, Narsingdi",
			"bn_name": "রায়পুর"
		},
		{
			"id": "27",
			"district_id": "37",
			"name": "Rajapur",
			"bn_name": "রাজাপুর"
		},
		{
			"id": "419",
			"district_id": "28",
			"name": "Rajarhat",
			"bn_name": "রাজারহাট"
		},
		{
			"id": "140",
			"district_id": "50",
			"name": "Rajasthali",
			"bn_name": "রাজাস্থলি"
		},
		{
			"id": "246",
			"district_id": "14",
			"name": "Rajbari Sadar",
			"bn_name": "রাজবাড়ি সদর"
		},
		{
			"id": "467",
			"district_id": "52",
			"name": "Rajnagar",
			"bn_name": "রাজনগর"
		},
		{
			"id": "193",
			"district_id": "7",
			"name": "Rajoir",
			"bn_name": "রাজইর"
		},
		{
			"id": "123",
			"district_id": "48",
			"name": "Ramganj",
			"bn_name": "রামগঞ্জ"
		},
		{
			"id": "120",
			"district_id": "47",
			"name": "Ramgarh",
			"bn_name": "রামগড়"
		},
		{
			"id": "124",
			"district_id": "48",
			"name": "Ramgati",
			"bn_name": "রামগতি"
		},
		{
			"id": "277",
			"district_id": "55",
			"name": "Rampal",
			"bn_name": "রামপাল"
		},
		{
			"id": "103",
			"district_id": "45",
			"name": "Ramu",
			"bn_name": "রামু"
		},
		{
			"id": "35",
			"district_id": "38",
			"name": "Rangabali",
			"bn_name": "রাঙ্গাবালি"
		},
		{
			"id": "135",
			"district_id": "50",
			"name": "Rangamati Sadar",
			"bn_name": "রাঙ্গামাটি সদর"
		},
		{
			"id": "444",
			"district_id": "32",
			"name": "Rangpur Sadar",
			"bn_name": "রংপুর সদর"
		},
		{
			"id": "77",
			"district_id": "43",
			"name": "Rangunia",
			"bn_name": "রাঙ্গুনিয়া"
		},
		{
			"id": "351",
			"district_id": "20",
			"name": "Raninagar",
			"bn_name": "রাণীনগর"
		},
		{
			"id": "452",
			"district_id": "33",
			"name": "Ranisankail",
			"bn_name": "রাণীসংকইল"
		},
		{
			"id": "78",
			"district_id": "43",
			"name": "Raozan",
			"bn_name": "রাউজান"
		},
		{
			"id": "48",
			"district_id": "40",
			"name": "Rowangchhari",
			"bn_name": "রউয়াংছড়ি "
		},
		{
			"id": "422",
			"district_id": "28",
			"name": "Rowmari",
			"bn_name": "রউমারি"
		},
		{
			"id": "49",
			"district_id": "40",
			"name": "Ruma",
			"bn_name": "রুমা"
		},
		{
			"id": "224",
			"district_id": "11",
			"name": "Rupganj",
			"bn_name": "রূপগঞ্জ"
		},
		{
			"id": "305",
			"district_id": "59",
			"name": "Rupsa",
			"bn_name": "রূপসা"
		},
		{
			"id": "157",
			"district_id": "2",
			"name": "Sadarpur",
			"bn_name": "সদরপুর"
		},
		{
			"id": "412",
			"district_id": "27",
			"name": "Sadullapur",
			"bn_name": "সাদুল্যাপুর"
		},
		{
			"id": "413",
			"district_id": "27",
			"name": "Saghata",
			"bn_name": "সাঘাটা"
		},
		{
			"id": "337",
			"district_id": "18",
			"name": "Sahajanpur",
			"bn_name": "শাহজাহানপুর"
		},
		{
			"id": "430",
			"district_id": "30",
			"name": "Saidpur",
			"bn_name": "সৈয়দপুর"
		},
		{
			"id": "259",
			"district_id": "17",
			"name": "Sakhipur",
			"bn_name": "সখিপুর"
		},
		{
			"id": "79",
			"district_id": "43",
			"name": "Sandwip",
			"bn_name": "সন্দ্বীপ"
		},
		{
			"id": "375",
			"district_id": "23",
			"name": "Santhia",
			"bn_name": "সাথিয়া"
		},
		{
			"id": "354",
			"district_id": "20",
			"name": "Sapahar",
			"bn_name": "সাপাহার"
		},
		{
			"id": "54",
			"district_id": "41",
			"name": "Sarail",
			"bn_name": "সরাইল"
		},
		{
			"id": "278",
			"district_id": "55",
			"name": "Sarankhola",
			"bn_name": "স্মরণখোলা"
		},
		{
			"id": "338",
			"district_id": "18",
			"name": "Sariakandi",
			"bn_name": "সারিয়াকান্দি"
		},
		{
			"id": "176",
			"district_id": "5",
			"name": "Sarishabari",
			"bn_name": "সরিষাবাড়ি "
		},
		{
			"id": "80",
			"district_id": "43",
			"name": "Satkania",
			"bn_name": "সাতকানিয়া"
		},
		{
			"id": "322",
			"district_id": "64",
			"name": "Satkhira Sadar",
			"bn_name": "সাতক্ষীরা সদর"
		},
		{
			"id": "198",
			"district_id": "8",
			"name": "Saturia",
			"bn_name": "সাটুরিয়া"
		},
		{
			"id": "149",
			"district_id": "1",
			"name": "Savar",
			"bn_name": "সাভার"
		},
		{
			"id": "55",
			"district_id": "41",
			"name": "Shahbazpur Town",
			"bn_name": "শাহবাজপুর টাউন"
		},
		{
			"id": "392",
			"district_id": "25",
			"name": "Shahjadpur",
			"bn_name": "শাহজাদপুর"
		},
		{
			"id": "67",
			"district_id": "42",
			"name": "Shahrasti",
			"bn_name": "শাহরাস্তি"
		},
		{
			"id": "295",
			"district_id": "58",
			"name": "Shailkupa",
			"bn_name": "শৈলকুপা"
		},
		{
			"id": "461",
			"district_id": "51",
			"name": "Shaistagonj",
			"bn_name": "শায়েস্তাগঞ্জ"
		},
		{
			"id": "314",
			"district_id": "61",
			"name": "Shalikha",
			"bn_name": "শালিখা"
		},
		{
			"id": "158",
			"district_id": "2",
			"name": "Shaltha",
			"bn_name": "শালথা"
		},
		{
			"id": "478",
			"district_id": "53",
			"name": "Shanthiganj",
			"bn_name": "শান্তিগঞ্জ"
		},
		{
			"id": "247",
			"district_id": "15",
			"name": "Shariatpur Sadar -Palong",
			"bn_name": "শরীয়তপুর সদর "
		},
		{
			"id": "290",
			"district_id": "57",
			"name": "Sharsha",
			"bn_name": "সারশা"
		},
		{
			"id": "130",
			"district_id": "49",
			"name": "Shenbag",
			"bn_name": "শেনবাগ"
		},
		{
			"id": "331",
			"district_id": "18",
			"name": "Sherpur",
			"bn_name": "শেরপুর"
		},
		{
			"id": "256",
			"district_id": "16",
			"name": "Sherpur Sadar",
			"bn_name": "শেরপুর সদর"
		},
		{
			"id": "197",
			"district_id": "8",
			"name": "Shibalaya",
			"bn_name": "শিবালয়"
		},
		{
			"id": "194",
			"district_id": "7",
			"name": "Shibchar",
			"bn_name": "শিবচর"
		},
		{
			"id": "339",
			"district_id": "18",
			"name": "Shibganj",
			"bn_name": "শিবগঞ্জ"
		},
		{
			"id": "367",
			"district_id": "22",
			"name": "Shibganj",
			"bn_name": "শিবগঞ্জ"
		},
		{
			"id": "231",
			"district_id": "12",
			"name": "Shibpur",
			"bn_name": "শিবপুর"
		},
		{
			"id": "328",
			"district_id": "64",
			"name": "Shyamnagar",
			"bn_name": "শ্যামনগর"
		},
		{
			"id": "225",
			"district_id": "11",
			"name": "Siddirgonj",
			"bn_name": "সিদ্ধিরগঞ্জ"
		},
		{
			"id": "196",
			"district_id": "8",
			"name": "Singair",
			"bn_name": "সিঙ্গাইর"
		},
		{
			"id": "205",
			"district_id": "9",
			"name": "Sirajdikhan",
			"bn_name": "সিরাজদিখান"
		},
		{
			"id": "386",
			"district_id": "25",
			"name": "Sirajganj Sadar",
			"bn_name": "সিরাজগঞ্জ সদর"
		},
		{
			"id": "81",
			"district_id": "43",
			"name": "Sitakunda",
			"bn_name": "সীতাকুণ্ড"
		},
		{
			"id": "112",
			"district_id": "46",
			"name": "Sonagazi",
			"bn_name": "সোনাগাজি"
		},
		{
			"id": "133",
			"district_id": "49",
			"name": "Sonaimuri",
			"bn_name": "সোনাইমুরি"
		},
		{
			"id": "221",
			"district_id": "11",
			"name": "Sonargaon",
			"bn_name": "সোনারগাঁও"
		},
		{
			"id": "340",
			"district_id": "18",
			"name": "Sonatala",
			"bn_name": "সোনাতলা"
		},
		{
			"id": "257",
			"district_id": "16",
			"name": "Sreebardi",
			"bn_name": "শ্রীবরদি"
		},
		{
			"id": "468",
			"district_id": "52",
			"name": "Sreemangal",
			"bn_name": "শ্রীমঙ্গল"
		},
		{
			"id": "203",
			"district_id": "9",
			"name": "Sreenagar",
			"bn_name": "শ্রীনগর"
		},
		{
			"id": "315",
			"district_id": "61",
			"name": "Sreepur",
			"bn_name": "শ্রীপুর"
		},
		{
			"id": "162",
			"district_id": "3",
			"name": "Sripur",
			"bn_name": "শ্রীপুর"
		},
		{
			"id": "134",
			"district_id": "49",
			"name": "Suborno Char",
			"bn_name": "সুবর্ণ চর "
		},
		{
			"id": "376",
			"district_id": "23",
			"name": "Sujanagar",
			"bn_name": "সুজানগর"
		},
		{
			"id": "476",
			"district_id": "53",
			"name": "Sulla",
			"bn_name": "সুল্লা"
		},
		{
			"id": "477",
			"district_id": "53",
			"name": "Sunamganj Sadar",
			"bn_name": "সুনামগঞ্জ সদর"
		},
		{
			"id": "414",
			"district_id": "27",
			"name": "Sundarganj",
			"bn_name": "সুন্দরগঞ্জ"
		},
		{
			"id": "480",
			"district_id": "54",
			"name": "Sylhet Sadar",
			"bn_name": "সিলেট সদর"
		},
		{
			"id": "479",
			"district_id": "53",
			"name": "Tahirpur",
			"bn_name": "তাহিরপুর"
		},
		{
			"id": "325",
			"district_id": "64",
			"name": "Tala",
			"bn_name": "তালা"
		},
		{
			"id": "6",
			"district_id": "34",
			"name": "Taltali",
			"bn_name": "তালতলী"
		},
		{
			"id": "258",
			"district_id": "17",
			"name": "Tangail Sadar",
			"bn_name": "টাঙ্গাইল সদর"
		},
		{
			"id": "385",
			"district_id": "24",
			"name": "Tanore",
			"bn_name": "তানোর"
		},
		{
			"id": "447",
			"district_id": "32",
			"name": "Taraganj",
			"bn_name": "তারাগঞ্জ"
		},
		{
			"id": "190",
			"district_id": "6",
			"name": "Tarail",
			"bn_name": "তাড়াইল"
		},
		{
			"id": "393",
			"district_id": "25",
			"name": "Tarash",
			"bn_name": "তারাশ"
		},
		{
			"id": "23",
			"district_id": "36",
			"name": "Tazumuddin",
			"bn_name": "তাজুমুদ্দিন"
		},
		{
			"id": "104",
			"district_id": "45",
			"name": "Teknaf",
			"bn_name": "টেকনাফ"
		},
		{
			"id": "297",
			"district_id": "59",
			"name": "Terokhada",
			"bn_name": "তেরোখাদা"
		},
		{
			"id": "439",
			"district_id": "31",
			"name": "Tetulia",
			"bn_name": "তেঁতুলিয়া"
		},
		{
			"id": "448",
			"district_id": "33",
			"name": "Thakurgaon Sadar",
			"bn_name": "ঠাকুরগাঁও সদর"
		},
		{
			"id": "44",
			"district_id": "40",
			"name": "Thanchi",
			"bn_name": "থানচি"
		},
		{
			"id": "97",
			"district_id": "44",
			"name": "Titas",
			"bn_name": "তিতাস"
		},
		{
			"id": "164",
			"district_id": "3",
			"name": "Tongi",
			"bn_name": "টঙ্গি"
		},
		{
			"id": "206",
			"district_id": "9",
			"name": "Tongibari",
			"bn_name": "টঙ্গিবাড়ি"
		},
		{
			"id": "209",
			"district_id": "10",
			"name": "Trishal",
			"bn_name": "ত্রিশাল"
		},
		{
			"id": "169",
			"district_id": "4",
			"name": "Tungipara",
			"bn_name": "টুঙ্গিপাড়া"
		},
		{
			"id": "105",
			"district_id": "45",
			"name": "Ukhia",
			"bn_name": "উখিয়া"
		},
		{
			"id": "420",
			"district_id": "28",
			"name": "Ulipur",
			"bn_name": "উলিপুর"
		},
		{
			"id": "394",
			"district_id": "25",
			"name": "Ullahpara",
			"bn_name": "উল্লাপাড়া"
		},
		{
			"id": "16",
			"district_id": "35",
			"name": "Wazirpur",
			"bn_name": "ওয়াজিরপুর"
		},
		{
			"id": "491",
			"district_id": "54",
			"name": "Zakiganj",
			"bn_name": "জাকিগঞ্জ"
		},
		{
			"id": "42",
			"district_id": "39",
			"name": "Zianagar",
			"bn_name": "জিয়ানগর"
		}
	];

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?t(exports,__webpack_require__(1),__webpack_require__(24),__webpack_require__(52),__webpack_require__(225),__webpack_require__(226),__webpack_require__(732),__webpack_require__(724),__webpack_require__(723),__webpack_require__(150),__webpack_require__(222),__webpack_require__(115),__webpack_require__(221),__webpack_require__(223),__webpack_require__(808),__webpack_require__(811),__webpack_require__(809),__webpack_require__(810),__webpack_require__(812),__webpack_require__(742),__webpack_require__(739),__webpack_require__(736),__webpack_require__(734),__webpack_require__(733),__webpack_require__(738),__webpack_require__(740),__webpack_require__(741),__webpack_require__(744),__webpack_require__(743),__webpack_require__(802),__webpack_require__(800),__webpack_require__(799),__webpack_require__(152),__webpack_require__(801),__webpack_require__(803),__webpack_require__(764),__webpack_require__(763),__webpack_require__(725),__webpack_require__(726),__webpack_require__(727),__webpack_require__(153),__webpack_require__(229),__webpack_require__(806),__webpack_require__(228),__webpack_require__(807),__webpack_require__(728),__webpack_require__(730),__webpack_require__(729),__webpack_require__(731),__webpack_require__(747),__webpack_require__(748),__webpack_require__(749),__webpack_require__(751),__webpack_require__(750),__webpack_require__(745),__webpack_require__(746),__webpack_require__(752),__webpack_require__(16),__webpack_require__(798),__webpack_require__(765),__webpack_require__(973),__webpack_require__(55),__webpack_require__(976),__webpack_require__(804)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","classnames","date-fns/isDate","date-fns/isValid","date-fns/format","date-fns/addMinutes","date-fns/addHours","date-fns/addDays","date-fns/addWeeks","date-fns/addMonths","date-fns/addQuarters","date-fns/addYears","date-fns/subDays","date-fns/subWeeks","date-fns/subMonths","date-fns/subQuarters","date-fns/subYears","date-fns/getSeconds","date-fns/getMinutes","date-fns/getHours","date-fns/getDay","date-fns/getDate","date-fns/getISOWeek","date-fns/getMonth","date-fns/getQuarter","date-fns/getYear","date-fns/getTime","date-fns/setSeconds","date-fns/setMinutes","date-fns/setHours","date-fns/setMonth","date-fns/setQuarter","date-fns/setYear","date-fns/min","date-fns/max","date-fns/differenceInCalendarDays","date-fns/differenceInCalendarMonths","date-fns/differenceInCalendarYears","date-fns/startOfDay","date-fns/startOfWeek","date-fns/startOfMonth","date-fns/startOfQuarter","date-fns/startOfYear","date-fns/endOfDay","date-fns/endOfWeek","date-fns/endOfMonth","date-fns/endOfYear","date-fns/isEqual","date-fns/isSameDay","date-fns/isSameMonth","date-fns/isSameYear","date-fns/isSameQuarter","date-fns/isAfter","date-fns/isBefore","date-fns/isWithinInterval","date-fns/toDate","date-fns/parse","date-fns/parseISO","react-onclickoutside","react-dom","react-popper","date-fns/set"],t):t((e="undefined"!=typeof globalThis?globalThis:e||self).DatePicker={},e.React,e.PropTypes,e.classNames,e.isDate,e.isValidDate,e.format,e.addMinutes,e.addHours,e.addDays,e.addWeeks,e.addMonths,e.addQuarters,e.addYears,e.subDays,e.subWeeks,e.subMonths,e.subQuarters,e.subYears,e.getSeconds,e.getMinutes,e.getHours,e.getDay,e.getDate,e.getISOWeek,e.getMonth,e.getQuarter,e.getYear,e.getTime,e.setSeconds,e.setMinutes,e.setHours,e.setMonth,e.setQuarter,e.setYear,e.min,e.max,e.differenceInCalendarDays,e.differenceInCalendarMonths,e.differenceInCalendarYears,e.startOfDay,e.startOfWeek,e.startOfMonth,e.startOfQuarter,e.startOfYear,e.endOfDay,null,e.endOfMonth,e.endOfYear,e.dfIsEqual,e.dfIsSameDay,e.dfIsSameMonth,e.dfIsSameYear,e.dfIsSameQuarter,e.isAfter,e.isBefore,e.isWithinInterval,e.toDate,e.parse,e.parseISO,e.onClickOutside,e.ReactDOM,e.ReactPopper,e.set)}(this,(function(e,t,r,a,n,o,s,i,p,l,c,d,u,f,h,m,y,v,D,g,k,w,b,S,C,_,M,P,E,N,x,Y,O,I,T,R,L,F,A,W,q,K,B,Q,H,j,V,U,z,$,G,J,X,Z,ee,te,re,ae,ne,oe,se,ie,pe,le){"use strict";function ce(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var de=ce(t),ue=ce(a),fe=ce(n),he=ce(o),me=ce(s),ye=ce(i),ve=ce(p),De=ce(l),ge=ce(c),ke=ce(d),we=ce(u),be=ce(f),Se=ce(h),Ce=ce(m),_e=ce(y),Me=ce(v),Pe=ce(D),Ee=ce(g),Ne=ce(k),xe=ce(w),Ye=ce(b),Oe=ce(S),Ie=ce(C),Te=ce(_),Re=ce(M),Le=ce(P),Fe=ce(E),Ae=ce(N),We=ce(x),qe=ce(Y),Ke=ce(O),Be=ce(I),Qe=ce(T),He=ce(R),je=ce(L),Ve=ce(F),Ue=ce(A),ze=ce(W),$e=ce(q),Ge=ce(K),Je=ce(B),Xe=ce(Q),Ze=ce(H),et=ce(j),tt=ce(U),rt=ce(z),at=ce($),nt=ce(G),ot=ce(J),st=ce(X),it=ce(Z),pt=ce(ee),lt=ce(te),ct=ce(re),dt=ce(ae),ut=ce(ne),ft=ce(oe),ht=ce(se),mt=ce(ie),yt=ce(le);function vt(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,a)}return r}function Dt(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?vt(Object(r),!0).forEach((function(t){St(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):vt(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function gt(e){return gt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},gt(e)}function kt(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function wt(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,Ot(a.key),a)}}function bt(e,t,r){return t&&wt(e.prototype,t),r&&wt(e,r),Object.defineProperty(e,"prototype",{writable:!1}),e}function St(e,t,r){return(t=Ot(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function Ct(){return Ct=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a])}return e},Ct.apply(this,arguments)}function _t(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&Pt(e,t)}function Mt(e){return Mt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},Mt(e)}function Pt(e,t){return Pt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},Pt(e,t)}function Et(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Nt(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=Mt(e);if(t){var n=Mt(this).constructor;r=Reflect.construct(a,arguments,n)}else r=a.apply(this,arguments);return function(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return Et(e)}(this,r)}}function xt(e){return function(e){if(Array.isArray(e))return Yt(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return Yt(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Yt(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Yt(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,a=new Array(t);r<t;r++)a[r]=e[r];return a}function Ot(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var a=r.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}var It=function(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});default:return t.date({width:"full"})}},Tt=function(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});default:return t.time({width:"full"})}},Rt={p:Tt,P:function(e,t){var r,a=e.match(/(P+)(p+)?/)||[],n=a[1],o=a[2];if(!o)return It(e,t);switch(n){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;default:r=t.dateTime({width:"full"})}return r.replace("{{date}}",It(n,t)).replace("{{time}}",Tt(o,t))}},Lt=12,Ft=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function At(e){var t=e?"string"==typeof e||e instanceof String?ft.default(e):dt.default(e):new Date;return Wt(t)?t:null}function Wt(e,t){return t=t||new Date("1/1/1000"),he.default(e)&&!lt.default(e,t)}function qt(e,t,r){if("en"===r)return me.default(e,t,{awareOfUnicodeTokens:!0});var a=tr(r);return r&&!a&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!a&&er()&&tr(er())&&(a=tr(er())),me.default(e,t,{locale:a||null,awareOfUnicodeTokens:!0})}function Kt(e,t){var r=t.dateFormat,a=t.locale;return e&&qt(e,Array.isArray(r)?r[0]:r,a)||""}function Bt(e,t){var r=t.hour,a=void 0===r?0:r,n=t.minute,o=void 0===n?0:n,s=t.second,i=void 0===s?0:s;return qe.default(We.default(Ae.default(e,i),o),a)}function Qt(e,t,r){var a=tr(t||er());return Ge.default(e,{locale:a,weekStartsOn:r})}function Ht(e){return Je.default(e)}function jt(e){return Ze.default(e)}function Vt(e){return Xe.default(e)}function Ut(){return $e.default(At())}function zt(e,t){return e&&t?st.default(e,t):!e&&!t}function $t(e,t){return e&&t?ot.default(e,t):!e&&!t}function Gt(e,t){return e&&t?it.default(e,t):!e&&!t}function Jt(e,t){return e&&t?nt.default(e,t):!e&&!t}function Xt(e,t){return e&&t?at.default(e,t):!e&&!t}function Zt(e,t,r){var a,n=$e.default(t),o=et.default(r);try{a=ct.default(e,{start:n,end:o})}catch(e){a=!1}return a}function er(){return("undefined"!=typeof window?window:globalThis).__localeId__}function tr(e){if("string"==typeof e){var t="undefined"!=typeof window?window:globalThis;return t.__localeData__?t.__localeData__[e]:null}return e}function rr(e,t){return qt(Ke.default(At(),e),"LLLL",t)}function ar(e,t){return qt(Ke.default(At(),e),"LLL",t)}function nr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.excludeDateIntervals,s=t.includeDates,i=t.includeDateIntervals,p=t.filterDate;return ur(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Jt(e,t)}))||o&&o.some((function(t){var r=t.start,a=t.end;return ct.default(e,{start:r,end:a})}))||s&&!s.some((function(t){return Jt(e,t)}))||i&&!i.some((function(t){var r=t.start,a=t.end;return ct.default(e,{start:r,end:a})}))||p&&!p(At(e))||!1}function or(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates,a=t.excludeDateIntervals;return a&&a.length>0?a.some((function(t){var r=t.start,a=t.end;return ct.default(e,{start:r,end:a})})):r&&r.some((function(t){return Jt(e,t)}))||!1}function sr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return ur(e,{minDate:Je.default(r),maxDate:tt.default(a)})||n&&n.some((function(t){return $t(e,t)}))||o&&!o.some((function(t){return $t(e,t)}))||s&&!s(At(e))||!1}function ir(e,t,r,a){var n=Le.default(e),o=Te.default(e),s=Le.default(t),i=Te.default(t),p=Le.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function pr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return ur(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Gt(e,t)}))||o&&!o.some((function(t){return Gt(e,t)}))||s&&!s(At(e))||!1}function lr(e,t,r){if(!he.default(t)||!he.default(r))return!1;var a=Le.default(t),n=Le.default(r);return a<=e&&n>=e}function cr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate,i=new Date(e,0,1);return ur(i,{minDate:Ze.default(r),maxDate:rt.default(a)})||n&&n.some((function(e){return zt(i,e)}))||o&&!o.some((function(e){return zt(i,e)}))||s&&!s(At(i))||!1}function dr(e,t,r,a){var n=Le.default(e),o=Re.default(e),s=Le.default(t),i=Re.default(t),p=Le.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function ur(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate;return r&&Ve.default(e,r)<0||a&&Ve.default(e,a)>0}function fr(e,t){return t.some((function(t){return xe.default(t)===xe.default(e)&&Ne.default(t)===Ne.default(e)}))}function hr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,a=t.includeTimes,n=t.filterTime;return r&&fr(e,r)||a&&!fr(e,a)||n&&!n(e)||!1}function mr(e,t){var r=t.minTime,a=t.maxTime;if(!r||!a)throw new Error("Both minTime and maxTime props required");var n,o=At(),s=qe.default(We.default(o,Ne.default(e)),xe.default(e)),i=qe.default(We.default(o,Ne.default(r)),xe.default(r)),p=qe.default(We.default(o,Ne.default(a)),xe.default(a));try{n=!ct.default(s,{start:i,end:p})}catch(e){n=!1}return n}function yr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=_e.default(e,1);return r&&Ue.default(r,n)>0||a&&a.every((function(e){return Ue.default(e,n)>0}))||!1}function vr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=ke.default(e,1);return r&&Ue.default(n,r)>0||a&&a.every((function(e){return Ue.default(n,e)>0}))||!1}function Dr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Pe.default(e,1);return r&&ze.default(r,n)>0||a&&a.every((function(e){return ze.default(e,n)>0}))||!1}function gr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=be.default(e,1);return r&&ze.default(n,r)>0||a&&a.every((function(e){return ze.default(n,e)>0}))||!1}function kr(e){var t=e.minDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return Ve.default(e,t)>=0}));return He.default(a)}return r?He.default(r):t}function wr(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return Ve.default(e,t)<=0}));return je.default(a)}return r?je.default(r):t}function br(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,a=0,n=e.length;a<n;a++){var o=e[a];if(fe.default(o)){var s=qt(o,"MM.dd.yyyy"),i=r.get(s)||[];i.includes(t)||(i.push(t),r.set(s,i))}else if("object"===gt(o)){var p=Object.keys(o),l=p[0],c=o[p[0]];if("string"==typeof l&&c.constructor===Array)for(var d=0,u=c.length;d<u;d++){var f=qt(c[d],"MM.dd.yyyy"),h=r.get(f)||[];h.includes(l)||(h.push(l),r.set(f,h))}}}return r}function Sr(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--holidays",r=new Map;return e.forEach((function(e){var a=e.date,n=e.holidayName;if(fe.default(a)){var o=qt(a,"MM.dd.yyyy"),s=r.get(o)||{};if(!("className"in s)||s.className!==t||(i=s.holidayNames,p=[n],i.length!==p.length||!i.every((function(e,t){return e===p[t]})))){var i,p;s.className=t;var l=s.holidayNames;s.holidayNames=l?[].concat(xt(l),[n]):[n],r.set(o,s)}}})),r}function Cr(e,t,r,a,n){for(var o=n.length,s=[],i=0;i<o;i++){var p=ye.default(ve.default(e,xe.default(n[i])),Ne.default(n[i])),l=ye.default(e,(r+1)*a);pt.default(p,t)&&lt.default(p,l)&&s.push(n[i])}return s}function _r(e){return e<10?"0".concat(e):"".concat(e)}function Mr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Lt,r=Math.ceil(Le.default(e)/t)*t;return{startPeriod:r-(t-1),endPeriod:r}}function Pr(e){var t=e.getSeconds(),r=e.getMilliseconds();return dt.default(e.getTime()-1e3*t-r)}function Er(e,t,r,a){for(var n=[],o=0;o<2*t+1;o++){var s=e+t-o,i=!0;r&&(i=Le.default(r)<=s),a&&i&&(i=Le.default(a)>=s),i&&n.push(s)}return n}var Nr=function(e){_t(a,e);var r=Nt(a);function a(e){var n;kt(this,a),St(Et(n=r.call(this,e)),"renderOptions",(function(){var e=n.props.year,t=n.state.yearsList.map((function(t){return de.default.createElement("div",{className:e===t?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:t,onClick:n.onChange.bind(Et(n),t),"aria-selected":e===t?"true":void 0},e===t?de.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)})),r=n.props.minDate?Le.default(n.props.minDate):null,a=n.props.maxDate?Le.default(n.props.maxDate):null;return a&&n.state.yearsList.find((function(e){return e===a}))||t.unshift(de.default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),r&&n.state.yearsList.find((function(e){return e===r}))||t.push(de.default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t})),St(Et(n),"onChange",(function(e){n.props.onChange(e)})),St(Et(n),"handleClickOutside",(function(){n.props.onCancel()})),St(Et(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t})})),St(Et(n),"incrementYears",(function(){return n.shiftYears(1)})),St(Et(n),"decrementYears",(function(){return n.shiftYears(-1)}));var o=e.yearDropdownItemNumber,s=e.scrollableYearDropdown,i=o||(s?10:5);return n.state={yearsList:Er(n.props.year,i,n.props.minDate,n.props.maxDate)},n.dropdownRef=t.createRef(),n}return bt(a,[{key:"componentDidMount",value:function(){var e=this.dropdownRef.current;if(e){var t=e.children?Array.from(e.children):null,r=t?t.find((function(e){return e.ariaSelected})):null;e.scrollTop=r?r.offsetTop+(r.clientHeight-e.clientHeight)/2:(e.scrollHeight-e.clientHeight)/2}}},{key:"render",value:function(){var e=ue.default({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return de.default.createElement("div",{className:e,ref:this.dropdownRef},this.renderOptions())}}]),a}(de.default.Component),xr=ht.default(Nr),Yr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),St(Et(e),"renderSelectOptions",(function(){for(var t=e.props.minDate?Le.default(e.props.minDate):1900,r=e.props.maxDate?Le.default(e.props.maxDate):2100,a=[],n=t;n<=r;n++)a.push(de.default.createElement("option",{key:n,value:n},n));return a})),St(Et(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),St(Et(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),St(Et(e),"renderReadView",(function(t){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),St(Et(e),"renderDropdown",(function(){return de.default.createElement(xr,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),St(Et(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),St(Et(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),St(Et(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),St(Et(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen()})),St(Et(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r)})),St(Et(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return bt(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Or=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"isSelectedMonth",(function(t){return e.props.month===t})),St(Et(e),"renderOptions",(function(){return e.props.monthNames.map((function(t,r){return de.default.createElement("div",{className:e.isSelectedMonth(r)?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:t,onClick:e.onChange.bind(Et(e),r),"aria-selected":e.isSelectedMonth(r)?"true":void 0},e.isSelectedMonth(r)?de.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",t)}))})),St(Et(e),"onChange",(function(t){return e.props.onChange(t)})),St(Et(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return bt(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}(de.default.Component),Ir=ht.default(Or),Tr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),St(Et(e),"renderSelectOptions",(function(e){return e.map((function(e,t){return de.default.createElement("option",{key:t,value:t},e)}))})),St(Et(e),"renderSelectMode",(function(t){return de.default.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(t))})),St(Et(e),"renderReadView",(function(t,r){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},de.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[e.props.month]))})),St(Et(e),"renderDropdown",(function(t){return de.default.createElement(Ir,{key:"dropdown",month:e.props.month,monthNames:t,onChange:e.onChange,onCancel:e.toggleDropdown})})),St(Et(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,a=[e.renderReadView(!r,t)];return r&&a.unshift(e.renderDropdown(t)),a})),St(Et(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),St(Et(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return bt(r,[{key:"render",value:function(){var e,t=this,r=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return ar(e,t.props.locale)}:function(e){return rr(e,t.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(r);break;case"select":e=this.renderSelectMode(r)}return de.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component);function Rr(e,t){for(var r=[],a=Ht(e),n=Ht(t);!pt.default(a,n);)r.push(At(a)),a=ke.default(a,1);return r}var Lr=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"renderOptions",(function(){return a.state.monthYearsList.map((function(e){var t=Fe.default(e),r=zt(a.props.date,e)&&$t(a.props.date,e);return de.default.createElement("div",{className:r?"react-datepicker__month-year-option--selected_month-year":"react-datepicker__month-year-option",key:t,onClick:a.onChange.bind(Et(a),t),"aria-selected":r?"true":void 0},r?de.default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",qt(e,a.props.dateFormat,a.props.locale))}))})),St(Et(a),"onChange",(function(e){return a.props.onChange(e)})),St(Et(a),"handleClickOutside",(function(){a.props.onCancel()})),a.state={monthYearsList:Rr(a.props.minDate,a.props.maxDate)},a}return bt(r,[{key:"render",value:function(){var e=ue.default({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Fr=ht.default(Lr),Ar=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),St(Et(e),"renderSelectOptions",(function(){for(var t=Ht(e.props.minDate),r=Ht(e.props.maxDate),a=[];!pt.default(t,r);){var n=Fe.default(t);a.push(de.default.createElement("option",{key:n,value:n},qt(t,e.props.dateFormat,e.props.locale))),t=ke.default(t,1)}return a})),St(Et(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),St(Et(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:Fe.default(Ht(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),St(Et(e),"renderReadView",(function(t){var r=qt(e.props.date,e.props.dateFormat,e.props.locale);return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))})),St(Et(e),"renderDropdown",(function(){return de.default.createElement(Fr,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown,locale:e.props.locale})})),St(Et(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),St(Et(e),"onChange",(function(t){e.toggleDropdown();var r=At(parseInt(t));zt(e.props.date,r)&&$t(e.props.date,r)||e.props.onChange(r)})),St(Et(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return bt(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Wr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"dayEl",de.default.createRef()),St(Et(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),St(Et(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),St(Et(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),St(Et(e),"isSameDay",(function(t){return Jt(e.props.day,t)})),St(Et(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!(e.isSameDay(e.props.selected)||e.isSameWeek(e.props.selected))&&(e.isSameDay(e.props.preSelection)||e.isSameWeek(e.props.preSelection))})),St(Et(e),"isDisabled",(function(){return nr(e.props.day,e.props)})),St(Et(e),"isExcluded",(function(){return or(e.props.day,e.props)})),St(Et(e),"isStartOfWeek",(function(){return Jt(e.props.day,Qt(e.props.day,e.props.locale,e.props.calendarStartDay))})),St(Et(e),"isSameWeek",(function(t){return e.props.showWeekPicker&&Jt(t,Qt(e.props.day,e.props.locale,e.props.calendarStartDay))})),St(Et(e),"getHighLightedClass",(function(){var t=e.props,r=t.day,a=t.highlightDates;if(!a)return!1;var n=qt(r,"MM.dd.yyyy");return a.get(n)})),St(Et(e),"getHolidaysClass",(function(){var t=e.props,r=t.day,a=t.holidays;if(!a)return!1;var n=qt(r,"MM.dd.yyyy");return a.has(n)?[a.get(n).className]:void 0})),St(Et(e),"isInRange",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Zt(r,a,n)})),St(Et(e),"isInSelectingRange",(function(){var t,r=e.props,a=r.day,n=r.selectsStart,o=r.selectsEnd,s=r.selectsRange,i=r.selectsDisabledDaysInRange,p=r.startDate,l=r.endDate,c=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return!(!(n||o||s)||!c||!i&&e.isDisabled())&&(n&&l&&(lt.default(c,l)||Xt(c,l))?Zt(a,c,l):(o&&p&&(pt.default(c,p)||Xt(c,p))||!(!s||!p||l||!pt.default(c,p)&&!Xt(c,p)))&&Zt(a,p,c))})),St(Et(e),"isSelectingRangeStart",(function(){var t;if(!e.isInSelectingRange())return!1;var r=e.props,a=r.day,n=r.startDate,o=r.selectsStart,s=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return Jt(a,o?s:n)})),St(Et(e),"isSelectingRangeEnd",(function(){var t;if(!e.isInSelectingRange())return!1;var r=e.props,a=r.day,n=r.endDate,o=r.selectsEnd,s=r.selectsRange,i=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return Jt(a,o||s?i:n)})),St(Et(e),"isRangeStart",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Jt(a,r)})),St(Et(e),"isRangeEnd",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Jt(n,r)})),St(Et(e),"isWeekend",(function(){var t=Ye.default(e.props.day);return 0===t||6===t})),St(Et(e),"isAfterMonth",(function(){return void 0!==e.props.month&&(e.props.month+1)%12===Te.default(e.props.day)})),St(Et(e),"isBeforeMonth",(function(){return void 0!==e.props.month&&(Te.default(e.props.day)+1)%12===e.props.month})),St(Et(e),"isCurrentDay",(function(){return e.isSameDay(At())})),St(Et(e),"isSelected",(function(){return e.isSameDay(e.props.selected)||e.isSameWeek(e.props.selected)})),St(Et(e),"getClassNames",(function(t){var r,a=e.props.dayClassName?e.props.dayClassName(t):void 0;return ue.default("react-datepicker__day",a,"react-datepicker__day--"+qt(e.props.day,"ddd",r),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSelected(),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isCurrentDay(),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isAfterMonth()||e.isBeforeMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"),e.getHolidaysClass())})),St(Et(e),"getAriaLabel",(function(){var t=e.props,r=t.day,a=t.ariaLabelPrefixWhenEnabled,n=void 0===a?"Choose":a,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,i=e.isDisabled()||e.isExcluded()?s:n;return"".concat(i," ").concat(qt(r,"PPPP",e.props.locale))})),St(Et(e),"getTitle",(function(){var t=e.props,r=t.day,a=t.holidays,n=void 0===a?new Map:a,o=qt(r,"MM.dd.yyyy");return n.has(o)&&n.get(o).holidayNames.length>0?n.get(o).holidayNames.join(", "):""})),St(Et(e),"getTabIndex",(function(t,r){var a=t||e.props.selected,n=r||e.props.preSelection;return(!e.props.showWeekPicker||!e.props.showWeekNumber&&e.isStartOfWeek())&&(e.isKeyboardSelected()||e.isSameDay(a)&&Jt(n,a))?0:-1})),St(Et(e),"handleFocusDay",(function(){var t,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},a=!1;0===e.getTabIndex()&&!r.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(a=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(a=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(a=!0),e.props.monthShowsDuplicateDaysEnd&&e.isAfterMonth()&&(a=!1),e.props.monthShowsDuplicateDaysStart&&e.isBeforeMonth()&&(a=!1)),a&&(null===(t=e.dayEl.current)||void 0===t||t.focus({preventScroll:!0}))})),St(Et(e),"renderDayContents",(function(){return e.props.monthShowsDuplicateDaysEnd&&e.isAfterMonth()||e.props.monthShowsDuplicateDaysStart&&e.isBeforeMonth()?null:e.props.renderDayContents?e.props.renderDayContents(Oe.default(e.props.day),e.props.day):Oe.default(e.props.day)})),St(Et(e),"render",(function(){return de.default.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"option",title:e.getTitle(),"aria-disabled":e.isDisabled(),"aria-current":e.isCurrentDay()?"date":void 0,"aria-selected":e.isSelected()||e.isInRange()},e.renderDayContents(),""!==e.getTitle()&&de.default.createElement("span",{className:"holiday-overlay"},e.getTitle()))})),e}return bt(r,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}]),r}(de.default.Component),qr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"weekNumberEl",de.default.createRef()),St(Et(e),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),St(Et(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),St(Et(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!Jt(e.props.date,e.props.selected)&&Jt(e.props.date,e.props.preSelection)})),St(Et(e),"getTabIndex",(function(){return e.props.showWeekPicker&&e.props.showWeekNumber&&(e.isKeyboardSelected()||Jt(e.props.date,e.props.selected)&&Jt(e.props.preSelection,e.props.selected))?0:-1})),St(Et(e),"handleFocusWeekNumber",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!t.isInputFocused&&Jt(e.props.date,e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(r=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement&&document.activeElement.classList.contains("react-datepicker__week-number")&&(r=!0)),r&&e.weekNumberEl.current&&e.weekNumberEl.current.focus({preventScroll:!0})})),e}return bt(r,[{key:"componentDidMount",value:function(){this.handleFocusWeekNumber()}},{key:"componentDidUpdate",value:function(e){this.handleFocusWeekNumber(e)}},{key:"render",value:function(){var e=this.props,t=e.weekNumber,r=e.ariaLabelPrefix,a=void 0===r?"week ":r,n={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick,"react-datepicker__week-number--selected":Jt(this.props.date,this.props.selected),"react-datepicker__week-number--keyboard-selected":this.isKeyboardSelected()};return de.default.createElement("div",{ref:this.weekNumberEl,className:ue.default(n),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick,onKeyDown:this.handleOnKeyDown,tabIndex:this.getTabIndex()},t)}}],[{key:"defaultProps",get:function(){return{ariaLabelPrefix:"week "}}}]),r}(de.default.Component),Kr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r)})),St(Et(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),St(Et(e),"handleWeekClick",(function(t,r,a){if("function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,a),e.props.showWeekPicker){var n=Qt(t,e.props.locale,e.props.calendarStartDay);e.handleDayClick(n,a)}e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),St(Et(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):function(e,t){var r=t&&tr(t)||er()&&tr(er());return Ie.default(e,r?{locale:r}:null)}(t)})),St(Et(e),"renderDays",(function(){var t=Qt(e.props.day,e.props.locale,e.props.calendarStartDay),r=[],a=e.formatWeekNumber(t);if(e.props.showWeekNumber){var n=e.props.onWeekSelect||e.props.showWeekPicker?e.handleWeekClick.bind(Et(e),t,a):void 0;r.push(de.default.createElement(qr,{key:"W",weekNumber:a,date:t,onClick:n,selected:e.props.selected,preSelection:e.props.preSelection,ariaLabelPrefix:e.props.ariaLabelPrefix,showWeekPicker:e.props.showWeekPicker,showWeekNumber:e.props.showWeekNumber,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef}))}return r.concat([0,1,2,3,4,5,6].map((function(r){var a=De.default(t,r);return de.default.createElement(Wr,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:e.props.month,onClick:e.handleDayClick.bind(Et(e),a),onMouseEnter:e.handleDayMouseEnter.bind(Et(e),a),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,highlightDates:e.props.highlightDates,holidays:e.props.holidays,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,showWeekPicker:e.props.showWeekPicker,showWeekNumber:e.props.showWeekNumber,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart,locale:e.props.locale})})))})),St(Et(e),"startOfWeek",(function(){return Qt(e.props.day,e.props.locale,e.props.calendarStartDay)})),St(Et(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!Jt(e.startOfWeek(),e.props.selected)&&Jt(e.startOfWeek(),e.props.preSelection)})),e}return bt(r,[{key:"render",value:function(){var e={"react-datepicker__week":!0,"react-datepicker__week--selected":Jt(this.startOfWeek(),this.props.selected),"react-datepicker__week--keyboard-selected":this.isKeyboardSelected()};return de.default.createElement("div",{className:ue.default(e)},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),r}(de.default.Component),Br="two_columns",Qr="three_columns",Hr="four_columns",jr=St(St(St({},Br,{grid:[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]],verticalNavigationOffset:2}),Qr,{grid:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]],verticalNavigationOffset:3}),Hr,{grid:[[0,1,2,3],[4,5,6,7],[8,9,10,11]],verticalNavigationOffset:4});function Vr(e,t){return e?Hr:t?Br:Qr}var Ur=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"MONTH_REFS",xt(Array(12)).map((function(){return de.default.createRef()}))),St(Et(e),"QUARTER_REFS",xt(Array(4)).map((function(){return de.default.createRef()}))),St(Et(e),"isDisabled",(function(t){return nr(t,e.props)})),St(Et(e),"isExcluded",(function(t){return or(t,e.props)})),St(Et(e),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay)})),St(Et(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),St(Et(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),St(Et(e),"isRangeStartMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&$t(Ke.default(a,t),n)})),St(Et(e),"isRangeStartQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Gt(Be.default(a,t),n)})),St(Et(e),"isRangeEndMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&$t(Ke.default(a,t),o)})),St(Et(e),"isRangeEndQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Gt(Be.default(a,t),o)})),St(Et(e),"isInSelectingRangeMonth",(function(t){var r,a=e.props,n=a.day,o=a.selectsStart,s=a.selectsEnd,i=a.selectsRange,p=a.startDate,l=a.endDate,c=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return!(!(o||s||i)||!c)&&(o&&l?ir(c,l,t,n):(s&&p||!(!i||!p||l))&&ir(p,c,t,n))})),St(Et(e),"isSelectingMonthRangeStart",(function(t){var r;if(!e.isInSelectingRangeMonth(t))return!1;var a=e.props,n=a.day,o=a.startDate,s=a.selectsStart,i=Ke.default(n,t),p=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return $t(i,s?p:o)})),St(Et(e),"isSelectingMonthRangeEnd",(function(t){var r;if(!e.isInSelectingRangeMonth(t))return!1;var a=e.props,n=a.day,o=a.endDate,s=a.selectsEnd,i=a.selectsRange,p=Ke.default(n,t),l=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return $t(p,s||i?l:o)})),St(Et(e),"isInSelectingRangeQuarter",(function(t){var r,a=e.props,n=a.day,o=a.selectsStart,s=a.selectsEnd,i=a.selectsRange,p=a.startDate,l=a.endDate,c=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return!(!(o||s||i)||!c)&&(o&&l?dr(c,l,t,n):(s&&p||!(!i||!p||l))&&dr(p,c,t,n))})),St(Et(e),"isWeekInMonth",(function(t){var r=e.props.day,a=De.default(t,6);return $t(t,r)||$t(a,r)})),St(Et(e),"isCurrentMonth",(function(e,t){return Le.default(e)===Le.default(At())&&t===Te.default(At())})),St(Et(e),"isCurrentQuarter",(function(e,t){return Le.default(e)===Le.default(At())&&t===Re.default(At())})),St(Et(e),"isSelectedMonth",(function(e,t,r){return Te.default(r)===t&&Le.default(e)===Le.default(r)})),St(Et(e),"isSelectedQuarter",(function(e,t,r){return Re.default(e)===t&&Le.default(e)===Le.default(r)})),St(Et(e),"renderWeeks",(function(){for(var t=[],r=e.props.fixedHeight,a=0,n=!1,o=Qt(Ht(e.props.day),e.props.locale,e.props.calendarStartDay);t.push(de.default.createElement(Kr,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:a,day:o,month:Te.default(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,highlightDates:e.props.highlightDates,holidays:e.props.holidays,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,showWeekNumber:e.props.showWeekNumbers,showWeekPicker:e.props.showWeekPicker,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,calendarStartDay:e.props.calendarStartDay,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})),!n;){a++,o=ge.default(o,1);var s=r&&a>=6,i=!r&&!e.isWeekInMonth(o);if(s||i){if(!e.props.peekNextMonth)break;n=!0}}return t})),St(Et(e),"onMonthClick",(function(t,r){e.handleDayClick(Ht(Ke.default(e.props.day,r)),t)})),St(Et(e),"onMonthMouseEnter",(function(t){e.handleDayMouseEnter(Ht(Ke.default(e.props.day,t)))})),St(Et(e),"handleMonthNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.MONTH_REFS[t].current&&e.MONTH_REFS[t].current.focus())})),St(Et(e),"onMonthKeyDown",(function(t,r){var a=e.props,n=a.selected,o=a.preSelection,s=a.disabledKeyboardNavigation,i=a.showTwoColumnMonthYearPicker,p=a.showFourColumnMonthYearPicker,l=a.setPreSelection,c=t.key;if("Tab"!==c&&t.preventDefault(),!s){var d=Vr(p,i),u=jr[d].verticalNavigationOffset,f=jr[d].grid;switch(c){case"Enter":e.onMonthClick(t,r),l(n);break;case"ArrowRight":e.handleMonthNavigation(11===r?0:r+1,ke.default(o,1));break;case"ArrowLeft":e.handleMonthNavigation(0===r?11:r-1,_e.default(o,1));break;case"ArrowUp":e.handleMonthNavigation(f[0].includes(r)?r+12-u:r-u,_e.default(o,u));break;case"ArrowDown":e.handleMonthNavigation(f[f.length-1].includes(r)?r-12+u:r+u,ke.default(o,u))}}})),St(Et(e),"onQuarterClick",(function(t,r){e.handleDayClick(Vt(Be.default(e.props.day,r)),t)})),St(Et(e),"onQuarterMouseEnter",(function(t){e.handleDayMouseEnter(Vt(Be.default(e.props.day,t)))})),St(Et(e),"handleQuarterNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.QUARTER_REFS[t-1].current&&e.QUARTER_REFS[t-1].current.focus())})),St(Et(e),"onQuarterKeyDown",(function(t,r){var a=t.key;if(!e.props.disabledKeyboardNavigation)switch(a){case"Enter":e.onQuarterClick(t,r),e.props.setPreSelection(e.props.selected);break;case"ArrowRight":e.handleQuarterNavigation(4===r?1:r+1,we.default(e.props.preSelection,1));break;case"ArrowLeft":e.handleQuarterNavigation(1===r?4:r-1,Me.default(e.props.preSelection,1))}})),St(Et(e),"getMonthClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,l=r.preSelection,c=r.monthClassName,d=r.excludeDates,u=r.includeDates,f=c?c(Ke.default(a,t)):void 0,h=Ke.default(a,t);return ue.default("react-datepicker__month-text","react-datepicker__month-".concat(t),f,{"react-datepicker__month-text--disabled":(i||p||d||u)&&sr(h,e.props),"react-datepicker__month-text--selected":e.isSelectedMonth(a,t,s),"react-datepicker__month-text--keyboard-selected":!e.props.disabledKeyboardNavigation&&Te.default(l)===t,"react-datepicker__month-text--in-selecting-range":e.isInSelectingRangeMonth(t),"react-datepicker__month-text--in-range":ir(n,o,t,a),"react-datepicker__month-text--range-start":e.isRangeStartMonth(t),"react-datepicker__month-text--range-end":e.isRangeEndMonth(t),"react-datepicker__month-text--selecting-range-start":e.isSelectingMonthRangeStart(t),"react-datepicker__month-text--selecting-range-end":e.isSelectingMonthRangeEnd(t),"react-datepicker__month-text--today":e.isCurrentMonth(a,t)})})),St(Et(e),"getTabIndex",(function(t){var r=Te.default(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),St(Et(e),"getQuarterTabIndex",(function(t){var r=Re.default(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),St(Et(e),"getAriaLabel",(function(t){var r=e.props,a=r.chooseDayAriaLabelPrefix,n=void 0===a?"Choose":a,o=r.disabledDayAriaLabelPrefix,s=void 0===o?"Not available":o,i=r.day,p=Ke.default(i,t),l=e.isDisabled(p)||e.isExcluded(p)?s:n;return"".concat(l," ").concat(qt(p,"MMMM yyyy"))})),St(Et(e),"getQuarterClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,l=r.preSelection,c=r.disabledKeyboardNavigation;return ue.default("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter-text--disabled":(i||p)&&pr(Be.default(a,t),e.props),"react-datepicker__quarter-text--selected":e.isSelectedQuarter(a,t,s),"react-datepicker__quarter-text--keyboard-selected":!c&&Re.default(l)===t,"react-datepicker__quarter-text--in-selecting-range":e.isInSelectingRangeQuarter(t),"react-datepicker__quarter-text--in-range":dr(n,o,t,a),"react-datepicker__quarter-text--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter-text--range-end":e.isRangeEndQuarter(t)})})),St(Et(e),"getMonthContent",(function(t){var r=e.props,a=r.showFullMonthYearPicker,n=r.renderMonthContent,o=r.locale,s=r.day,i=ar(t,o),p=rr(t,o);return n?n(t,i,p,s):a?p:i})),St(Et(e),"getQuarterContent",(function(t){var r=e.props,a=r.renderQuarterContent,n=function(e,t){return qt(Be.default(At(),e),"QQQ",t)}(t,r.locale);return a?a(t,n):n})),St(Et(e),"renderMonths",(function(){var t=e.props,r=t.showTwoColumnMonthYearPicker,a=t.showFourColumnMonthYearPicker,n=t.day,o=t.selected;return jr[Vr(a,r)].grid.map((function(t,r){return de.default.createElement("div",{className:"react-datepicker__month-wrapper",key:r},t.map((function(t,r){return de.default.createElement("div",{ref:e.MONTH_REFS[t],key:r,onClick:function(r){e.onMonthClick(r,t)},onKeyDown:function(r){e.onMonthKeyDown(r,t)},onMouseEnter:function(){return e.onMonthMouseEnter(t)},tabIndex:e.getTabIndex(t),className:e.getMonthClassNames(t),role:"option","aria-label":e.getAriaLabel(t),"aria-current":e.isCurrentMonth(n,t)?"date":void 0,"aria-selected":e.isSelectedMonth(n,t,o)},e.getMonthContent(t))})))}))})),St(Et(e),"renderQuarters",(function(){var t=e.props,r=t.day,a=t.selected;return de.default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,n){return de.default.createElement("div",{key:n,ref:e.QUARTER_REFS[n],role:"option",onClick:function(r){e.onQuarterClick(r,t)},onKeyDown:function(r){e.onQuarterKeyDown(r,t)},onMouseEnter:function(){return e.onQuarterMouseEnter(t)},className:e.getQuarterClassNames(t),"aria-selected":e.isSelectedQuarter(r,t,a),tabIndex:e.getQuarterTabIndex(t),"aria-current":e.isCurrentQuarter(r,t)?"date":void 0},e.getQuarterContent(t))})))})),St(Et(e),"getClassNames",(function(){var t=e.props,r=t.selectingDate,a=t.selectsStart,n=t.selectsEnd,o=t.showMonthYearPicker,s=t.showQuarterYearPicker,i=t.showWeekPicker;return ue.default("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||n)},{"react-datepicker__monthPicker":o},{"react-datepicker__quarterPicker":s},{"react-datepicker__weekPicker":i})})),e}return bt(r,[{key:"render",value:function(){var e=this.props,t=e.showMonthYearPicker,r=e.showQuarterYearPicker,a=e.day,n=e.ariaLabelPrefix,o=void 0===n?"month ":n;return de.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(o," ").concat(qt(a,"yyyy-MM")),role:"listbox"},t?this.renderMonths():r?this.renderQuarters():this.renderWeeks())}}]),r}(de.default.Component),zr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"state",{height:null}),St(Et(e),"scrollToTheSelectedTime",(function(){requestAnimationFrame((function(){e.list&&(e.list.scrollTop=e.centerLi&&r.calcCenterPosition(e.props.monthRef?e.props.monthRef.clientHeight-e.header.clientHeight:e.list.clientHeight,e.centerLi))}))})),St(Et(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&mr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&hr(t,e.props)||e.props.onChange(t)})),St(Et(e),"isSelectedTime",(function(t){return e.props.selected&&(r=e.props.selected,a=t,Pr(r).getTime()===Pr(a).getTime());var r,a})),St(Et(e),"isDisabledTime",(function(t){return(e.props.minTime||e.props.maxTime)&&mr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&hr(t,e.props)})),St(Et(e),"liClasses",(function(t){var r=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t):void 0];return e.isSelectedTime(t)&&r.push("react-datepicker__time-list-item--selected"),e.isDisabledTime(t)&&r.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*xe.default(t)+Ne.default(t))%e.props.intervals!=0&&r.push("react-datepicker__time-list-item--injected"),r.join(" ")})),St(Et(e),"handleOnKeyDown",(function(t,r){" "===t.key&&(t.preventDefault(),t.key="Enter"),"ArrowUp"!==t.key&&"ArrowLeft"!==t.key||!t.target.previousSibling||(t.preventDefault(),t.target.previousSibling.focus()),"ArrowDown"!==t.key&&"ArrowRight"!==t.key||!t.target.nextSibling||(t.preventDefault(),t.target.nextSibling.focus()),"Enter"===t.key&&e.handleClick(r),e.props.handleOnKeyDown(t)})),St(Et(e),"renderTimes",(function(){for(var t,r=[],a=e.props.format?e.props.format:"p",n=e.props.intervals,o=e.props.selected||e.props.openToDate||At(),s=(t=o,$e.default(t)),i=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),p=60*function(e){var t=new Date(e.getFullYear(),e.getMonth(),e.getDate()),r=new Date(e.getFullYear(),e.getMonth(),e.getDate(),24);return Math.round((+r-+t)/36e5)}(o),l=p/n,c=0;c<l;c++){var d=ye.default(s,c*n);if(r.push(d),i){var u=Cr(s,d,c,n,i);r=r.concat(u)}}var f=r.reduce((function(e,t){return t.getTime()<=o.getTime()?t:e}),r[0]);return r.map((function(t,r){return de.default.createElement("li",{key:r,onClick:e.handleClick.bind(Et(e),t),className:e.liClasses(t),ref:function(r){t===f&&(e.centerLi=r)},onKeyDown:function(r){e.handleOnKeyDown(r,t)},tabIndex:t===f?0:-1,role:"option","aria-selected":e.isSelectedTime(t)?"true":void 0,"aria-disabled":e.isDisabledTime(t)?"true":void 0},qt(t,a,e.props.locale))}))})),e}return bt(r,[{key:"componentDidMount",value:function(){this.scrollToTheSelectedTime(),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,t=this.state.height;return de.default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(t){e.header=t}},de.default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),de.default.createElement("div",{className:"react-datepicker__time"},de.default.createElement("div",{className:"react-datepicker__time-box"},de.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{},role:"listbox","aria-label":this.props.timeCaption},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}(de.default.Component);St(zr,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var $r=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"YEAR_REFS",xt(Array(a.props.yearItemNumber)).map((function(){return de.default.createRef()}))),St(Et(a),"isDisabled",(function(e){return nr(e,a.props)})),St(Et(a),"isExcluded",(function(e){return or(e,a.props)})),St(Et(a),"selectingDate",(function(){var e;return null!==(e=a.props.selectingDate)&&void 0!==e?e:a.props.preSelection})),St(Et(a),"updateFocusOnPaginate",(function(e){var t=function(){this.YEAR_REFS[e].current.focus()}.bind(Et(a));window.requestAnimationFrame(t)})),St(Et(a),"handleYearClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t)})),St(Et(a),"handleYearNavigation",(function(e,t){var r=a.props,n=r.date,o=r.yearItemNumber,s=Mr(n,o).startPeriod;a.isDisabled(t)||a.isExcluded(t)||(a.props.setPreSelection(t),e-s==-1?a.updateFocusOnPaginate(o-1):e-s===o?a.updateFocusOnPaginate(0):a.YEAR_REFS[e-s].current.focus())})),St(Et(a),"isSameDay",(function(e,t){return Jt(e,t)})),St(Et(a),"isCurrentYear",(function(e){return e===Le.default(At())})),St(Et(a),"isRangeStart",(function(e){return a.props.startDate&&a.props.endDate&&zt(Qe.default(At(),e),a.props.startDate)})),St(Et(a),"isRangeEnd",(function(e){return a.props.startDate&&a.props.endDate&&zt(Qe.default(At(),e),a.props.endDate)})),St(Et(a),"isInRange",(function(e){return lr(e,a.props.startDate,a.props.endDate)})),St(Et(a),"isInSelectingRange",(function(e){var t=a.props,r=t.selectsStart,n=t.selectsEnd,o=t.selectsRange,s=t.startDate,i=t.endDate;return!(!(r||n||o)||!a.selectingDate())&&(r&&i?lr(e,a.selectingDate(),i):(n&&s||!(!o||!s||i))&&lr(e,s,a.selectingDate()))})),St(Et(a),"isSelectingRangeStart",(function(e){if(!a.isInSelectingRange(e))return!1;var t=a.props,r=t.startDate,n=t.selectsStart,o=Qe.default(At(),e);return zt(o,n?a.selectingDate():r)})),St(Et(a),"isSelectingRangeEnd",(function(e){if(!a.isInSelectingRange(e))return!1;var t=a.props,r=t.endDate,n=t.selectsEnd,o=t.selectsRange,s=Qe.default(At(),e);return zt(s,n||o?a.selectingDate():r)})),St(Et(a),"isKeyboardSelected",(function(e){var t=jt(Qe.default(a.props.date,e));return!a.props.disabledKeyboardNavigation&&!a.props.inline&&!Jt(t,jt(a.props.selected))&&Jt(t,jt(a.props.preSelection))})),St(Et(a),"onYearClick",(function(e,t){var r=a.props.date;a.handleYearClick(jt(Qe.default(r,t)),e)})),St(Et(a),"onYearKeyDown",(function(e,t){var r=e.key;if(!a.props.disabledKeyboardNavigation)switch(r){case"Enter":a.onYearClick(e,t),a.props.setPreSelection(a.props.selected);break;case"ArrowRight":a.handleYearNavigation(t+1,be.default(a.props.preSelection,1));break;case"ArrowLeft":a.handleYearNavigation(t-1,Pe.default(a.props.preSelection,1))}})),St(Et(a),"getYearClassNames",(function(e){var t=a.props,r=t.minDate,n=t.maxDate,o=t.selected,s=t.excludeDates,i=t.includeDates,p=t.filterDate;return ue.default("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===Le.default(o),"react-datepicker__year-text--disabled":(r||n||s||i||p)&&cr(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--range-start":a.isRangeStart(e),"react-datepicker__year-text--range-end":a.isRangeEnd(e),"react-datepicker__year-text--in-range":a.isInRange(e),"react-datepicker__year-text--in-selecting-range":a.isInSelectingRange(e),"react-datepicker__year-text--selecting-range-start":a.isSelectingRangeStart(e),"react-datepicker__year-text--selecting-range-end":a.isSelectingRangeEnd(e),"react-datepicker__year-text--today":a.isCurrentYear(e)})})),St(Et(a),"getYearTabIndex",(function(e){return a.props.disabledKeyboardNavigation?"-1":e===Le.default(a.props.preSelection)?"0":"-1"})),St(Et(a),"getYearContainerClassNames",(function(){var e=a.props,t=e.selectingDate,r=e.selectsStart,n=e.selectsEnd,o=e.selectsRange;return ue.default("react-datepicker__year",{"react-datepicker__year--selecting-range":t&&(r||n||o)})})),St(Et(a),"getYearContent",(function(e){return a.props.renderYearContent?a.props.renderYearContent(e):e})),a}return bt(r,[{key:"render",value:function(){for(var e=this,t=[],r=this.props,a=r.date,n=r.yearItemNumber,o=r.onYearMouseEnter,s=r.onYearMouseLeave,i=Mr(a,n),p=i.startPeriod,l=i.endPeriod,c=function(r){t.push(de.default.createElement("div",{ref:e.YEAR_REFS[r-p],onClick:function(t){e.onYearClick(t,r)},onKeyDown:function(t){e.onYearKeyDown(t,r)},tabIndex:e.getYearTabIndex(r),className:e.getYearClassNames(r),onMouseEnter:function(e){return o(e,r)},onMouseLeave:function(e){return s(e,r)},key:r,"aria-current":e.isCurrentYear(r)?"date":void 0},e.getYearContent(r)))},d=p;d<=l;d++)c(d);return de.default.createElement("div",{className:this.getYearContainerClassNames()},de.default.createElement("div",{className:"react-datepicker__year-wrapper",onMouseLeave:this.props.clearSelectingDate},t))}}]),r}(de.default.Component),Gr=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"onTimeChange",(function(e){a.setState({time:e});var t=a.props.date,r=t instanceof Date&&!isNaN(t)?t:new Date;r.setHours(e.split(":")[0]),r.setMinutes(e.split(":")[1]),a.props.onChange(r)})),St(Et(a),"renderTimeInput",(function(){var e=a.state.time,t=a.props,r=t.date,n=t.timeString,o=t.customTimeInput;return o?de.default.cloneElement(o,{date:r,value:e,onChange:a.onTimeChange}):de.default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){a.onTimeChange(e.target.value||n)}})})),a.state={time:a.props.timeString},a}return bt(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__input-time-container"},de.default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),de.default.createElement("div",{className:"react-datepicker-time__input-container"},de.default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),r}(de.default.Component);function Jr(e){var t=e.className,r=e.children,a=e.showPopperArrow,n=e.arrowProps,o=void 0===n?{}:n;return de.default.createElement("div",{className:t},a&&de.default.createElement("div",Ct({className:"react-datepicker__triangle"},o)),r)}var Xr=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Zr=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"handleClickOutside",(function(e){a.props.onClickOutside(e)})),St(Et(a),"setClickOutsideRef",(function(){return a.containerRef.current})),St(Et(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Xr.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus()})),St(Et(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=kr(a.props),s=wr(a.props),i=At(),p=n||r||t;return p||(o&&lt.default(i,o)?o:s&&pt.default(i,s)?s:i)})),St(Et(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:ke.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),St(Et(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:_e.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),St(Et(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e)})),St(Et(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e)})),St(Et(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave()})),St(Et(a),"handleYearMouseEnter",(function(e,t){a.setState({selectingDate:Qe.default(At(),t)}),a.props.onYearMouseEnter&&a.props.onYearMouseEnter(e,t)})),St(Et(a),"handleYearMouseLeave",(function(e,t){a.props.onYearMouseLeave&&a.props.onYearMouseLeave(e,t)})),St(Et(a),"handleYearChange",(function(e){a.props.onYearChange&&(a.props.onYearChange(e),a.setState({isRenderAriaLiveMessage:!0})),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),St(Et(a),"handleMonthChange",(function(e){a.handleCustomMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),St(Et(a),"handleCustomMonthChange",(function(e){a.props.onMonthChange&&(a.props.onMonthChange(e),a.setState({isRenderAriaLiveMessage:!0}))})),St(Et(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e)})),St(Et(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return{date:Qe.default(r,e)}}),(function(){return a.handleYearChange(a.state.date)}))})),St(Et(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return{date:Ke.default(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}))})),St(Et(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return{date:Qe.default(Ke.default(r,Te.default(e)),Le.default(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}))})),St(Et(a),"header",(function(){var e=Qt(arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,a.props.locale,a.props.calendarStartDay),t=[];return a.props.showWeekNumbers&&t.push(de.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),t.concat([0,1,2,3,4,5,6].map((function(t){var r=De.default(e,t),n=a.formatWeekday(r,a.props.locale),o=a.props.weekDayClassName?a.props.weekDayClassName(r):void 0;return de.default.createElement("div",{key:t,className:ue.default("react-datepicker__day-name",o)},n)})))})),St(Et(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(qt(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return qt(e,"EEE",t)}(e,t):function(e,t){return qt(e,"EEEEEE",t)}(e,t)})),St(Et(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return{date:Pe.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),St(Et(a),"clearSelectingDate",(function(){a.setState({selectingDate:null})})),St(Et(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=Dr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.yearItemNumber,n=void 0===a?Lt:a,o=Mr(jt(Pe.default(e,n)),n).endPeriod,s=r&&Le.default(r);return s&&s>o||!1}(a.state.date,a.props);break;default:e=yr(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--previous"],r=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.decreaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--previous--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.previousMonthButtonLabel,i=o.previousYearButtonLabel,p=a.props,l=p.previousMonthAriaLabel,c=void 0===l?"string"==typeof s?s:"Previous Month":l,d=p.previousYearAriaLabel,u=void 0===d?"string"==typeof i?i:"Previous Year":d;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,onKeyDown:a.props.handleOnKeyDown,"aria-label":n?u:c},de.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--previous"].join(" ")},n?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel))}}})),St(Et(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return{date:be.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),St(Et(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=gr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.yearItemNumber,n=void 0===a?Lt:a,o=Mr(be.default(e,n),n).startPeriod,s=r&&Le.default(r);return s&&s<o||!1}(a.state.date,a.props);break;default:e=vr(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&t.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&t.push("react-datepicker__navigation--next--with-today-button");var r=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.increaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--next--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.nextMonthButtonLabel,i=o.nextYearButtonLabel,p=a.props,l=p.nextMonthAriaLabel,c=void 0===l?"string"==typeof s?s:"Next Month":l,d=p.nextYearAriaLabel,u=void 0===d?"string"==typeof i?i:"Next Year":d;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,onKeyDown:a.props.handleOnKeyDown,"aria-label":n?u:c},de.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--next"].join(" ")},n?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel))}}})),St(Et(a),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=["react-datepicker__current-month"];return a.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&t.push("react-datepicker__current-month--hasMonthYearDropdown"),de.default.createElement("div",{className:t.join(" ")},qt(e,a.props.dateFormat,a.props.locale))})),St(Et(a),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!e)return de.default.createElement(Yr,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:Le.default(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),St(Et(a),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!e)return de.default.createElement(Tr,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:Te.default(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),St(Et(a),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!e)return de.default.createElement(Ar,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),St(Et(a),"handleTodayButtonClick",(function(e){a.props.onSelect(Ut(),e),a.props.setPreSelection&&a.props.setPreSelection(Ut())})),St(Et(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return de.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.handleTodayButtonClick(e)}},a.props.todayButton)})),St(Et(a),"renderDefaultHeader",(function(e){var t=e.monthDate,r=e.i;return de.default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(t),de.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==r),a.renderMonthYearDropdown(0!==r),a.renderYearDropdown(0!==r)),de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),St(Et(a),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.monthDate,r=e.i;if(a.props.showTimeSelect&&!a.state.monthContainer||a.props.showTimeSelectOnly)return null;var n=yr(a.state.date,a.props),o=vr(a.state.date,a.props),s=Dr(a.state.date,a.props),i=gr(a.state.date,a.props),p=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(Dt(Dt({},a.state),{},{customHeaderCount:r,monthDate:t,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:n,nextMonthButtonDisabled:o,prevYearButtonDisabled:s,nextYearButtonDisabled:i})),p&&de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),St(Et(a),"renderYearHeader",(function(){var e=a.state.date,t=a.props,r=t.showYearPicker,n=Mr(e,t.yearItemNumber),o=n.startPeriod,s=n.endPeriod;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},r?"".concat(o," - ").concat(s):Le.default(e))})),St(Et(a),"renderHeader",(function(e){switch(!0){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),St(Et(a),"renderMonths",(function(){var e;if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var t=[],r=a.props.showPreviousMonths?a.props.monthsShown-1:0,n=_e.default(a.state.date,r),o=null!==(e=a.props.monthSelectedIn)&&void 0!==e?e:r,s=0;s<a.props.monthsShown;++s){var i=s-o+r,p=ke.default(n,i),l="month-".concat(s),c=s<a.props.monthsShown-1,d=s>0;t.push(de.default.createElement("div",{key:l,ref:function(e){a.monthContainer=e},className:"react-datepicker__month-container"},a.renderHeader({monthDate:p,i:s}),de.default.createElement(Ur,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,ariaLabelPrefix:a.props.monthAriaLabelPrefix,onChange:a.changeMonthYear,day:p,dayClassName:a.props.dayClassName,calendarStartDay:a.props.calendarStartDay,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnDayKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:s,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,excludeDateIntervals:a.props.excludeDateIntervals,highlightDates:a.props.highlightDates,holidays:a.props.holidays,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,includeDateIntervals:a.props.includeDateIntervals,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,selectsDisabledDaysInRange:a.props.selectsDisabledDaysInRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,renderMonthContent:a.props.renderMonthContent,renderQuarterContent:a.props.renderQuarterContent,renderYearContent:a.props.renderYearContent,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showWeekPicker:a.props.showWeekPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:c,monthShowsDuplicateDaysStart:d})))}return t}})),St(Et(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?de.default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),de.default.createElement($r,Ct({onDayClick:a.handleDayClick,selectingDate:a.state.selectingDate,clearSelectingDate:a.clearSelectingDate,date:a.state.date},a.props,{onYearMouseEnter:a.handleYearMouseEnter,onYearMouseLeave:a.handleYearMouseLeave}))):void 0})),St(Et(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return de.default.createElement(zr,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,handleOnKeyDown:a.props.handleOnKeyDown,showTimeSelectOnly:a.props.showTimeSelectOnly})})),St(Et(a),"renderInputTimeSection",(function(){var e=new Date(a.props.selected),t=Wt(e)&&Boolean(a.props.selected)?"".concat(_r(e.getHours()),":").concat(_r(e.getMinutes())):"";if(a.props.showTimeInput)return de.default.createElement(Gr,{date:e,timeString:t,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),St(Et(a),"renderAriaLiveRegion",(function(){var e,t=Mr(a.state.date,a.props.yearItemNumber),r=t.startPeriod,n=t.endPeriod;return e=a.props.showYearPicker?"".concat(r," - ").concat(n):a.props.showMonthYearPicker||a.props.showQuarterYearPicker?Le.default(a.state.date):"".concat(rr(Te.default(a.state.date),a.props.locale)," ").concat(Le.default(a.state.date)),de.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},a.state.isRenderAriaLiveMessage&&e)})),St(Et(a),"renderChildren",(function(){if(a.props.children)return de.default.createElement("div",{className:"react-datepicker__children-container"},a.props.children)})),a.containerRef=de.default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null,isRenderAriaLiveMessage:!1},a}return bt(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){var t=this;if(!this.props.preSelection||Jt(this.props.preSelection,e.preSelection)&&this.props.monthSelectedIn===e.monthSelectedIn)this.props.openToDate&&!Jt(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate});else{var r=!$t(this.state.date,this.props.preSelection);this.setState({date:this.props.preSelection},(function(){return r&&t.handleCustomMonthChange(t.state.date)}))}}},{key:"render",value:function(){var e=this.props.container||Jr;return de.default.createElement("div",{style:{display:"contents"},ref:this.containerRef},de.default.createElement(e,{className:ue.default("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderAriaLiveRegion(),this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.renderChildren()))}}],[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:Lt}}}]),r}(de.default.Component),ea=function(e){var t=e.icon,r=e.className,a=void 0===r?"":r,n=e.onClick,o="react-datepicker__calendar-icon";return de.default.isValidElement(t)?de.default.cloneElement(t,{className:"".concat(t.props.className||""," ").concat(o," ").concat(a),onClick:function(e){"function"==typeof t.props.onClick&&t.props.onClick(e),"function"==typeof n&&n(e)}}):"string"==typeof t?de.default.createElement("i",{className:"".concat(o," ").concat(t," ").concat(a),"aria-hidden":"true",onClick:n}):de.default.createElement("svg",{className:"".concat(o," ").concat(a),xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512",onClick:n},de.default.createElement("path",{d:"M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"}))},ta=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),(a=t.call(this,e)).el=document.createElement("div"),a}return bt(r,[{key:"componentDidMount",value:function(){this.portalRoot=(this.props.portalHost||document).getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),(this.props.portalHost||document.body).appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el)}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el)}},{key:"render",value:function(){return mt.default.createPortal(this.props.children,this.el)}}]),r}(de.default.Component),ra=function(e){return!e.disabled&&-1!==e.tabIndex},aa=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"getTabChildren",(function(){return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(ra)})),St(Et(a),"handleFocusStart",(function(){var e=a.getTabChildren();e&&e.length>1&&e[e.length-1].focus()})),St(Et(a),"handleFocusEnd",(function(){var e=a.getTabChildren();e&&e.length>1&&e[0].focus()})),a.tabLoopRef=de.default.createRef(),a}return bt(r,[{key:"render",value:function(){return this.props.enableTabLoop?de.default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},de.default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,de.default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),r}(de.default.Component),na=function(e){_t(r,e);var t=Nt(r);function r(){return kt(this,r),t.apply(this,arguments)}return bt(r,[{key:"render",value:function(){var e,t=this.props,r=t.className,a=t.wrapperClassName,n=t.hidePopper,o=t.popperComponent,s=t.popperModifiers,i=t.popperPlacement,p=t.popperProps,l=t.targetComponent,c=t.enableTabLoop,d=t.popperOnKeyDown,u=t.portalId,f=t.portalHost;if(!n){var h=ue.default("react-datepicker-popper",r);e=de.default.createElement(pe.Popper,Ct({modifiers:s,placement:i},p),(function(e){var t=e.ref,r=e.style,a=e.placement,n=e.arrowProps;return de.default.createElement(aa,{enableTabLoop:c},de.default.createElement("div",{ref:t,style:r,className:h,"data-placement":a,onKeyDown:d},de.default.cloneElement(o,{arrowProps:n})))}))}this.props.popperContainer&&(e=de.default.createElement(this.props.popperContainer,{},e)),u&&!n&&(e=de.default.createElement(ta,{portalId:u,portalHost:f},e));var m=ue.default("react-datepicker-wrapper",a);return de.default.createElement(pe.Manager,{className:"react-datepicker-manager"},de.default.createElement(pe.Reference,null,(function(e){var t=e.ref;return de.default.createElement("div",{ref:t,className:m},l)})),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:[],popperProps:{},popperPlacement:"bottom-start"}}}]),r}(de.default.Component),oa="react-datepicker-ignore-onclickoutside",sa=ht.default(Zr);var ia="Date input not valid.",pa=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"getPreSelection",(function(){return a.props.openToDate?a.props.openToDate:a.props.selectsEnd&&a.props.startDate?a.props.startDate:a.props.selectsStart&&a.props.endDate?a.props.endDate:At()})),St(Et(a),"modifyHolidays",(function(){var e;return null===(e=a.props.holidays)||void 0===e?void 0:e.reduce((function(e,t){var r=new Date(t.date);return he.default(r)?[].concat(xt(e),[Dt(Dt({},t),{},{date:r})]):e}),[])})),St(Et(a),"calcInitialState",(function(){var e,t=a.getPreSelection(),r=kr(a.props),n=wr(a.props),o=r&&lt.default(t,$e.default(r))?r:n&&pt.default(t,et.default(n))?n:t;return{open:a.props.startOpen||!1,preventFocus:!1,preSelection:null!==(e=a.props.selectsRange?a.props.startDate:a.props.selected)&&void 0!==e?e:o,highlightDates:br(a.props.highlightDates),focused:!1,shouldFocusDayInline:!1,isRenderAriaLiveMessage:!1}})),St(Et(a),"clearPreventFocusTimeout",(function(){a.preventFocusTimeout&&clearTimeout(a.preventFocusTimeout)})),St(Et(a),"setFocus",(function(){a.input&&a.input.focus&&a.input.focus({preventScroll:!0})})),St(Et(a),"setBlur",(function(){a.input&&a.input.blur&&a.input.blur(),a.cancelFocusInput()})),St(Et(a),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];a.setState({open:e,preSelection:e&&a.state.open?a.state.preSelection:a.calcInitialState().preSelection,lastPreSelectChange:ca},(function(){e||a.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&a.setBlur(),a.setState({inputValue:null})}))}))})),St(Et(a),"inputOk",(function(){return fe.default(a.state.preSelection)})),St(Et(a),"isCalendarOpen",(function(){return void 0===a.props.open?a.state.open&&!a.props.disabled&&!a.props.readOnly:a.props.open})),St(Et(a),"handleFocus",(function(e){a.state.preventFocus||(a.props.onFocus(e),a.props.preventOpenOnFocus||a.props.readOnly||a.setOpen(!0)),a.setState({focused:!0})})),St(Et(a),"sendFocusBackToInput",(function(){a.preventFocusTimeout&&a.clearPreventFocusTimeout(),a.setState({preventFocus:!0},(function(){a.preventFocusTimeout=setTimeout((function(){a.setFocus(),a.setState({preventFocus:!1})}))}))})),St(Et(a),"cancelFocusInput",(function(){clearTimeout(a.inputFocusTimeout),a.inputFocusTimeout=null})),St(Et(a),"deferFocusInput",(function(){a.cancelFocusInput(),a.inputFocusTimeout=setTimeout((function(){return a.setFocus()}),1)})),St(Et(a),"handleDropdownFocus",(function(){a.cancelFocusInput()})),St(Et(a),"handleBlur",(function(e){(!a.state.open||a.props.withPortal||a.props.showTimeInput)&&a.props.onBlur(e),a.setState({focused:!1})})),St(Et(a),"handleCalendarClickOutside",(function(e){a.props.inline||a.setOpen(!1),a.props.onClickOutside(e),a.props.withPortal&&e.preventDefault()})),St(Et(a),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!a.props.onChangeRaw||(a.props.onChangeRaw.apply(Et(a),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){a.setState({inputValue:n.target.value,lastPreSelectChange:la});var o,s,i,p,l,c,d,u,f=(o=n.target.value,s=a.props.dateFormat,i=a.props.locale,p=a.props.strictParsing,l=a.props.minDate,c=null,d=tr(i)||tr(er()),u=!0,Array.isArray(s)?(s.forEach((function(e){var t=ut.default(o,e,new Date,{locale:d});p&&(u=Wt(t,l)&&o===qt(t,e,i)),Wt(t,l)&&u&&(c=t)})),c):(c=ut.default(o,s,new Date,{locale:d}),p?u=Wt(c)&&o===qt(c,s,i):Wt(c)||(s=s.match(Ft).map((function(e){var t=e[0];return"p"===t||"P"===t?d?(0,Rt[t])(e,d.formatLong):t:e})).join(""),o.length>0&&(c=ut.default(o,s.slice(0,o.length),new Date)),Wt(c)||(c=new Date(o))),Wt(c)&&u?c:null));a.props.showTimeSelectOnly&&a.props.selected&&f&&!Jt(f,a.props.selected)&&(f=yt.default(a.props.selected,{hours:xe.default(f),minutes:Ne.default(f),seconds:Ee.default(f)})),!f&&n.target.value||(a.props.showWeekPicker&&(f=Qt(f,a.props.locale,a.props.calendarStartDay)),a.setSelected(f,n,!0))}})),St(Et(a),"handleSelect",(function(e,t,r){if(a.props.shouldCloseOnSelect&&!a.props.showTimeSelect&&a.sendFocusBackToInput(),a.props.onChangeRaw&&a.props.onChangeRaw(t),a.props.showWeekPicker&&(e=Qt(e,a.props.locale,a.props.calendarStartDay)),a.setSelected(e,t,!1,r),a.props.showDateSelect&&a.setState({isRenderAriaLiveMessage:!0}),!a.props.shouldCloseOnSelect||a.props.showTimeSelect)a.setPreSelection(e);else if(!a.props.inline){a.props.selectsRange||a.setOpen(!1);var n=a.props,o=n.startDate,s=n.endDate;!o||s||lt.default(e,o)||a.setOpen(!1)}})),St(Et(a),"setSelected",(function(e,t,r,n){var o=e;if(a.props.showYearPicker){if(null!==o&&cr(Le.default(o),a.props))return}else if(a.props.showMonthYearPicker){if(null!==o&&sr(o,a.props))return}else if(null!==o&&nr(o,a.props))return;var s=a.props,i=s.onChange,p=s.selectsRange,l=s.startDate,c=s.endDate;if(!Xt(a.props.selected,o)||a.props.allowSameDay||p)if(null!==o&&(!a.props.selected||r&&(a.props.showTimeSelect||a.props.showTimeSelectOnly||a.props.showTimeInput)||(o=Bt(o,{hour:xe.default(a.props.selected),minute:Ne.default(a.props.selected),second:Ee.default(a.props.selected)})),a.props.inline||a.setState({preSelection:o}),a.props.focusSelectedMonth||a.setState({monthSelectedIn:n})),p){var d=l&&!c,u=l&&c;!l&&!c?i([o,null],t):d&&(lt.default(o,l)?i([o,null],t):i([l,o],t)),u&&i([o,null],t)}else i(o,t);r||(a.props.onSelect(o,t),a.setState({inputValue:null}))})),St(Et(a),"setPreSelection",(function(e){var t=void 0!==a.props.minDate,r=void 0!==a.props.maxDate,n=!0;if(e){a.props.showWeekPicker&&(e=Qt(e,a.props.locale,a.props.calendarStartDay));var o=$e.default(e);if(t&&r)n=Zt(e,a.props.minDate,a.props.maxDate);else if(t){var s=$e.default(a.props.minDate);n=pt.default(e,s)||Xt(o,s)}else if(r){var i=et.default(a.props.maxDate);n=lt.default(e,i)||Xt(o,i)}}n&&a.setState({preSelection:e})})),St(Et(a),"toggleCalendar",(function(){a.setOpen(!a.state.open)})),St(Et(a),"handleTimeChange",(function(e){var t=a.props.selected?a.props.selected:a.getPreSelection(),r=a.props.selected?e:Bt(t,{hour:xe.default(e),minute:Ne.default(e)});a.setState({preSelection:r}),a.props.onChange(r),a.props.shouldCloseOnSelect&&(a.sendFocusBackToInput(),a.setOpen(!1)),a.props.showTimeInput&&a.setOpen(!0),(a.props.showTimeSelectOnly||a.props.showTimeSelect)&&a.setState({isRenderAriaLiveMessage:!0}),a.setState({inputValue:null})})),St(Et(a),"onInputClick",(function(){a.props.disabled||a.props.readOnly||a.setOpen(!0),a.props.onInputClick()})),St(Et(a),"onInputKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key;if(a.state.open||a.props.inline||a.props.preventOpenOnFocus){if(a.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=a.props.showWeekPicker&&a.props.showWeekNumbers?'.react-datepicker__week-number[tabindex="0"]':'.react-datepicker__day[tabindex="0"]',n=a.calendar.componentNode&&a.calendar.componentNode.querySelector(r);return void(n&&n.focus({preventScroll:!0}))}var o=At(a.state.preSelection);"Enter"===t?(e.preventDefault(),a.inputOk()&&a.state.lastPreSelectChange===ca?(a.handleSelect(o,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(o)):a.setOpen(!1)):"Escape"===t?(e.preventDefault(),a.sendFocusBackToInput(),a.setOpen(!1)):"Tab"===t&&a.setOpen(!1),a.inputOk()||a.props.onInputError({code:1,msg:ia})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||a.onInputClick()})),St(Et(a),"onPortalKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.setState({preventFocus:!0},(function(){a.setOpen(!1),setTimeout((function(){a.setFocus(),a.setState({preventFocus:!1})}))})))})),St(Et(a),"onDayKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key,r=At(a.state.preSelection);if("Enter"===t)e.preventDefault(),a.handleSelect(r,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(r);else if("Escape"===t)e.preventDefault(),a.setOpen(!1),a.inputOk()||a.props.onInputError({code:1,msg:ia});else if(!a.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=a.props.showWeekPicker?Ce.default(r,1):Se.default(r,1);break;case"ArrowRight":n=a.props.showWeekPicker?ge.default(r,1):De.default(r,1);break;case"ArrowUp":n=Ce.default(r,1);break;case"ArrowDown":n=ge.default(r,1);break;case"PageUp":n=_e.default(r,1);break;case"PageDown":n=ke.default(r,1);break;case"Home":n=Pe.default(r,1);break;case"End":n=be.default(r,1);break;default:n=null}if(!n)return void(a.props.onInputError&&a.props.onInputError({code:1,msg:ia}));if(e.preventDefault(),a.setState({lastPreSelectChange:ca}),a.props.adjustDateOnChange&&a.setSelected(n),a.setPreSelection(n),a.props.inline){var o=Te.default(r),s=Te.default(n),i=Le.default(r),p=Le.default(n);o!==s||i!==p?a.setState({shouldFocusDayInline:!0}):a.setState({shouldFocusDayInline:!1})}}})),St(Et(a),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.sendFocusBackToInput())})),St(Et(a),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),a.sendFocusBackToInput(),a.props.selectsRange?a.props.onChange([null,null],e):a.props.onChange(null,e),a.setState({inputValue:null})})),St(Et(a),"clear",(function(){a.onClearClick()})),St(Et(a),"onScroll",(function(e){"boolean"==typeof a.props.closeOnScroll&&a.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||a.setOpen(!1):"function"==typeof a.props.closeOnScroll&&a.props.closeOnScroll(e)&&a.setOpen(!1)})),St(Et(a),"renderCalendar",(function(){return a.props.inline||a.isCalendarOpen()?de.default.createElement(sa,{ref:function(e){a.calendar=e},locale:a.props.locale,calendarStartDay:a.props.calendarStartDay,chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,monthAriaLabelPrefix:a.props.monthAriaLabelPrefix,adjustDateOnChange:a.props.adjustDateOnChange,setOpen:a.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,dateFormat:a.props.dateFormatCalendar,useWeekdaysShort:a.props.useWeekdaysShort,formatWeekDay:a.props.formatWeekDay,dropdownMode:a.props.dropdownMode,selected:a.props.selected,preSelection:a.state.preSelection,onSelect:a.handleSelect,onWeekSelect:a.props.onWeekSelect,openToDate:a.props.openToDate,minDate:a.props.minDate,maxDate:a.props.maxDate,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,startDate:a.props.startDate,endDate:a.props.endDate,excludeDates:a.props.excludeDates,excludeDateIntervals:a.props.excludeDateIntervals,filterDate:a.props.filterDate,onClickOutside:a.handleCalendarClickOutside,formatWeekNumber:a.props.formatWeekNumber,highlightDates:a.state.highlightDates,holidays:Sr(a.modifyHolidays()),includeDates:a.props.includeDates,includeDateIntervals:a.props.includeDateIntervals,includeTimes:a.props.includeTimes,injectTimes:a.props.injectTimes,inline:a.props.inline,shouldFocusDayInline:a.state.shouldFocusDayInline,peekNextMonth:a.props.peekNextMonth,showMonthDropdown:a.props.showMonthDropdown,showPreviousMonths:a.props.showPreviousMonths,useShortMonthInDropdown:a.props.useShortMonthInDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showWeekNumbers:a.props.showWeekNumbers,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,forceShowMonthNavigation:a.props.forceShowMonthNavigation,showDisabledMonthNavigation:a.props.showDisabledMonthNavigation,scrollableYearDropdown:a.props.scrollableYearDropdown,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown,todayButton:a.props.todayButton,weekLabel:a.props.weekLabel,outsideClickIgnoreClass:oa,fixedHeight:a.props.fixedHeight,monthsShown:a.props.monthsShown,monthSelectedIn:a.state.monthSelectedIn,onDropdownFocus:a.handleDropdownFocus,onMonthChange:a.props.onMonthChange,onYearChange:a.props.onYearChange,dayClassName:a.props.dayClassName,weekDayClassName:a.props.weekDayClassName,monthClassName:a.props.monthClassName,timeClassName:a.props.timeClassName,showDateSelect:a.props.showDateSelect,showTimeSelect:a.props.showTimeSelect,showTimeSelectOnly:a.props.showTimeSelectOnly,onTimeChange:a.handleTimeChange,timeFormat:a.props.timeFormat,timeIntervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,className:a.props.calendarClassName,container:a.props.calendarContainer,yearItemNumber:a.props.yearItemNumber,yearDropdownItemNumber:a.props.yearDropdownItemNumber,previousMonthAriaLabel:a.props.previousMonthAriaLabel,previousMonthButtonLabel:a.props.previousMonthButtonLabel,nextMonthAriaLabel:a.props.nextMonthAriaLabel,nextMonthButtonLabel:a.props.nextMonthButtonLabel,previousYearAriaLabel:a.props.previousYearAriaLabel,previousYearButtonLabel:a.props.previousYearButtonLabel,nextYearAriaLabel:a.props.nextYearAriaLabel,nextYearButtonLabel:a.props.nextYearButtonLabel,timeInputLabel:a.props.timeInputLabel,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderCustomHeader:a.props.renderCustomHeader,popperProps:a.props.popperProps,renderDayContents:a.props.renderDayContents,renderMonthContent:a.props.renderMonthContent,renderQuarterContent:a.props.renderQuarterContent,renderYearContent:a.props.renderYearContent,onDayMouseEnter:a.props.onDayMouseEnter,onMonthMouseLeave:a.props.onMonthMouseLeave,onYearMouseEnter:a.props.onYearMouseEnter,onYearMouseLeave:a.props.onYearMouseLeave,selectsDisabledDaysInRange:a.props.selectsDisabledDaysInRange,showTimeInput:a.props.showTimeInput,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showWeekPicker:a.props.showWeekPicker,showPopperArrow:a.props.showPopperArrow,excludeScrollbar:a.props.excludeScrollbar,handleOnKeyDown:a.props.onKeyDown,handleOnDayKeyDown:a.onDayKeyDown,isInputFocused:a.state.focused,customTimeInput:a.props.customTimeInput,setPreSelection:a.setPreSelection},a.props.children):null})),St(Et(a),"renderAriaLiveRegion",(function(){var e,t=a.props,r=t.dateFormat,n=t.locale,o=a.props.showTimeInput||a.props.showTimeSelect?"PPPPp":"PPPP";return e=a.props.selectsRange?"Selected start date: ".concat(Kt(a.props.startDate,{dateFormat:o,locale:n}),". ").concat(a.props.endDate?"End date: "+Kt(a.props.endDate,{dateFormat:o,locale:n}):""):a.props.showTimeSelectOnly?"Selected time: ".concat(Kt(a.props.selected,{dateFormat:r,locale:n})):a.props.showYearPicker?"Selected year: ".concat(Kt(a.props.selected,{dateFormat:"yyyy",locale:n})):a.props.showMonthYearPicker?"Selected month: ".concat(Kt(a.props.selected,{dateFormat:"MMMM yyyy",locale:n})):a.props.showQuarterYearPicker?"Selected quarter: ".concat(Kt(a.props.selected,{dateFormat:"yyyy, QQQ",locale:n})):"Selected date: ".concat(Kt(a.props.selected,{dateFormat:o,locale:n})),de.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},e)})),St(Et(a),"renderDateInput",(function(){var e,t=ue.default(a.props.className,St({},oa,a.state.open)),r=a.props.customInput||de.default.createElement("input",{type:"text"}),n=a.props.customInputRef||"ref",o="string"==typeof a.props.value?a.props.value:"string"==typeof a.state.inputValue?a.state.inputValue:a.props.selectsRange?function(e,t,r){if(!e)return"";var a=Kt(e,r),n=t?Kt(t,r):"";return"".concat(a," - ").concat(n)}(a.props.startDate,a.props.endDate,a.props):Kt(a.props.selected,a.props);return de.default.cloneElement(r,(St(St(St(St(St(St(St(St(St(St(e={},n,(function(e){a.input=e})),"value",o),"onBlur",a.handleBlur),"onChange",a.handleChange),"onClick",a.onInputClick),"onFocus",a.handleFocus),"onKeyDown",a.onInputKeyDown),"id",a.props.id),"name",a.props.name),"form",a.props.form),St(St(St(St(St(St(St(St(St(St(e,"autoFocus",a.props.autoFocus),"placeholder",a.props.placeholderText),"disabled",a.props.disabled),"autoComplete",a.props.autoComplete),"className",ue.default(r.props.className,t)),"title",a.props.title),"readOnly",a.props.readOnly),"required",a.props.required),"tabIndex",a.props.tabIndex),"aria-describedby",a.props.ariaDescribedBy),St(St(St(e,"aria-invalid",a.props.ariaInvalid),"aria-labelledby",a.props.ariaLabelledBy),"aria-required",a.props.ariaRequired)))})),St(Et(a),"renderClearButton",(function(){var e=a.props,t=e.isClearable,r=e.disabled,n=e.selected,o=e.startDate,s=e.endDate,i=e.clearButtonTitle,p=e.clearButtonClassName,l=void 0===p?"":p,c=e.ariaLabelClose,d=void 0===c?"Close":c;return!t||null==n&&null==o&&null==s?null:de.default.createElement("button",{type:"button",className:ue.default("react-datepicker__close-icon",l,{"react-datepicker__close-icon--disabled":r}),disabled:r,"aria-label":d,onClick:a.onClearClick,title:i,tabIndex:-1})})),a.state=a.calcInitialState(),a.preventFocusTimeout=null,a}return bt(r,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0)}},{key:"componentDidUpdate",value:function(e,t){var r,a;e.inline&&(r=e.selected,a=this.props.selected,r&&a?Te.default(r)!==Te.default(a)||Le.default(r)!==Le.default(a):r!==a)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:br(this.props.highlightDates)}),t.focused||Xt(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0)}},{key:"renderInputContainer",value:function(){var e=this.props,t=e.showIcon,r=e.icon,a=e.calendarIconClassname,n=e.toggleCalendarOnIconClick,o=this.state.open;return de.default.createElement("div",{className:"react-datepicker__input-container".concat(t?" react-datepicker__view-calendar-icon":"")},t&&de.default.createElement(ea,Ct({icon:r,className:"".concat(a," ").concat(o&&"react-datepicker-ignore-onclickoutside")},n?{onClick:this.toggleCalendar}:null)),this.state.isRenderAriaLiveMessage&&this.renderAriaLiveRegion(),this.renderDateInput(),this.renderClearButton())}},{key:"render",value:function(){var e=this.renderCalendar();if(this.props.inline)return e;if(this.props.withPortal){var t=this.state.open?de.default.createElement(aa,{enableTabLoop:this.props.enableTabLoop},de.default.createElement("div",{className:"react-datepicker__portal",tabIndex:-1,onKeyDown:this.onPortalKeyDown},e)):null;return this.state.open&&this.props.portalId&&(t=de.default.createElement(ta,{portalId:this.props.portalId,portalHost:this.props.portalHost},t)),de.default.createElement("div",null,this.renderInputContainer(),t)}return de.default.createElement(na,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,portalHost:this.props.portalHost,popperModifiers:this.props.popperModifiers,targetComponent:this.renderInputContainer(),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,selectsDisabledDaysInRange:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,showWeekPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthAriaLabel:"Previous Month",previousMonthButtonLabel:"Previous Month",nextMonthAriaLabel:"Next Month",nextMonthButtonLabel:"Next Month",previousYearAriaLabel:"Previous Year",previousYearButtonLabel:"Previous Year",nextYearAriaLabel:"Next Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:Lt,focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null,calendarStartDay:void 0,toggleCalendarOnIconClick:!1}}}]),r}(de.default.Component),la="input",ca="navigate";e.CalendarContainer=Jr,e.default=pa,e.getDefaultLocale=er,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:globalThis;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:globalThis).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(947);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Loading_icon.f4404720.gif";

/***/ },
/* 57 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 58 */
/***/ function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 59 */
8,
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	__webpack_require__(8);
	
	var _Loading_icon = __webpack_require__(56);
	
	var _Loading_icon2 = _interopRequireDefault(_Loading_icon);
	
	var _ConfirmAppointmentAndRequestAppointment = __webpack_require__(143);
	
	var _ConfirmAppointmentAndRequestAppointment2 = _interopRequireDefault(_ConfirmAppointmentAndRequestAppointment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookAppointmentPopup = function BookAppointmentPopup(_ref) {
	  var bookAppointmentPopupClicked = _ref.bookAppointmentPopupClicked,
	      setBookAppointmentPopupClicked = _ref.setBookAppointmentPopupClicked;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchResults = _useState2[0],
	      setSearchResults = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      departmentId = _useState4[0],
	      setDepartmentId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      fromNav = _useState8[0],
	      setFromNav = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    DoctorID: "",
	    PreferredDate: "",
	    doctorData: ""
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      scheduleReqData = _useState10[0],
	      setScheduleReqData = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    selectedDepartment: "all",
	    searchedText: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      formData = _useState12[0],
	      setFormData = _useState12[1];
	
	  // const formatedDoc = doctorData && doctorData.doctor_name.toLowerCase();
	
	
	  var alertStyle = {
	    color: "red"
	  };
	  var inputStyles = {
	    borderRadius: "10px",
	    background: "#fff",
	    borderRight: "solid 1px #fff",
	    border: "solid 2px #6e6e6ed0",
	    padding: "15px 15px",
	    fontSize: "16px",
	    color: "#000",
	    width: "100%"
	  };
	  var filteredData = null;
	  (0, _react.useEffect)(function () {
	    var getSearchDoctors = function getSearchDoctors(data) {
	      try {
	        setLoading(true);
	        var req = _.scAxiosAdmin.request("/search/find_a_doctor", {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          },
	          params: {
	            keyword: formData.searchedText,
	            deparment: formData.selectedDepartment
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            setLoading(false);
	            setSearchResults(data.data.doctors);
	          }
	        }).catch(function (e) {
	          setLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getSearchDoctors();
	  }, [formData.searchedText, departmentId, filteredData, bookAppointmentPopupClicked]);
	
	  (0, _react.useEffect)(function () {
	    setDepartmentId(formData.selectedDepartment);
	  }, [formData.selectedDepartment]);
	
	  var handleSubmit = function handleSubmit(event, props) {
	    event.preventDefault();
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        "class": "offcanvas offcanvas-start bookAppointPopup",
	        "data-bs-scroll": "true",
	        tabindex: "-1",
	        id: "BookAppointMent",
	        "aria-labelledby": "offcanvasWithBothOptionsLabel"
	      },
	      _react2.default.createElement(
	        "div",
	        { "class": "offcanvas-header" },
	        _react2.default.createElement("h5", { "class": "offcanvas-title", id: "offcanvasWithBothOptionsLabel" }),
	        _react2.default.createElement("button", {
	          type: "button",
	          "class": "btn-close text-reset",
	          "data-bs-dismiss": "offcanvas",
	          "aria-label": "Close"
	          // onClick={() => setBookAppointmentPopupClicked(false)}
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { "class": "offcanvas-body" },
	        _react2.default.createElement(
	          "div",
	          { className: "left-offcanvas" },
	          _react2.default.createElement(
	            "div",
	            { className: "offcan-top-mar" },
	            _react2.default.createElement(
	              "h4",
	              { style: { color: "#af9763" } },
	              "Book Appointment"
	            )
	          ),
	          _react2.default.createElement(
	            "form",
	            {
	              onSubmit: handleSubmit,
	              className: "needs-validation",
	              noValidate: true
	            },
	            _react2.default.createElement("input", {
	              type: "text",
	              style: inputStyles,
	              className: "custom-form-control",
	              placeholder: "Search With Doctors Name...",
	              name: "searchTerm",
	              id: "searchTerm",
	              value: formData.searchedText,
	              onChange: function onChange(e) {
	                return setFormData(Object.assign({}, formData, { searchedText: e.target.value }));
	              },
	              required: true,
	              autoComplete: "off"
	              // style={input_field_css}
	            }),
	            _react2.default.createElement("span", { style: alertStyle }),
	            _react2.default.createElement(
	              "div",
	              { className: "row mt-3" },
	              _react2.default.createElement("span", { style: alertStyle }),
	              searchResults && searchResults.length > 0 ? searchResults.slice(0, 3).map(function (search_doctor) {
	                return _react2.default.createElement(
	                  "div",
	                  { className: "col-12 sp-0-0 mb-3", key: search_doctor.id },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "doctor-list" },
	                    _react2.default.createElement("input", {
	                      type: "radio",
	                      className: "doctor_id",
	                      name: "doctor_id",
	                      value: search_doctor.id,
	                      onChange: function onChange() {
	                        return setScheduleReqData(Object.assign({}, scheduleReqData, {
	                          DoctorID: search_doctor.id,
	                          doctorData: search_doctor
	                        }));
	                      },
	                      doctorName: search_doctor.doctor_name,
	                      deptid: search_doctor.dept_id
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-3", style: { paddingLeft: "0px" } },
	                        search_doctor.doctor_profile ? _react2.default.createElement("img", {
	                          style: { borderRadius: "10px" },
	                          src: _constants.IMAGE_URL + "DoctorProfileImg/" + search_doctor.doctor_profile,
	                          alt: "doctor profile"
	                        }) :
	                        /*<img src={doc} alt="doc"/>*/
	                        _react2.default.createElement("img", {
	                          src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                          alt: "doc"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-9 mt-2" },
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          search_doctor.doctor_name
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          search_doctor.degree !== "" ? search_doctor.degree : "Endocrinology & Metabolism) MD (Endocrinology & Metabolism)"
	                        )
	                      )
	                    )
	                  )
	                );
	              }) : _react2.default.createElement(
	                "div",
	                { className: "col-12 sp-0-0 mb-3" },
	                loading ? _react2.default.createElement("img", { src: _Loading_icon2.default, alt: "Loading" }) : _react2.default.createElement(
	                  "p",
	                  { style: { color: "red" } },
	                  "No results found!"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row mt-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-6" },
	                _react2.default.createElement("input", {
	                  type: "date",
	                  id: "schedule_date",
	                  name: "schedule_date",
	                  className: "customDatePicker",
	                  onChange: function onChange(e) {
	                    return setScheduleReqData(Object.assign({}, scheduleReqData, {
	                      PreferredDate: e.target.value
	                    }));
	                  },
	                  placeholder: "DD-MM-YYYY",
	                  defaultValue: localStorage.getItem(_constants.SCHEDULE_DATE),
	                  required: true
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    variant: "primary",
	                    "data-bs-dismiss": "offcanvas",
	                    "aria-label": "Close",
	                    "data-bs-toggle": "offcanvas",
	                    "data-bs-target": "#confirmAppointmentOffcanvas",
	                    "aria-controls": "confirmAppointmentOffcanvas",
	                    style: {
	                      backgroundColor: !scheduleReqData.PreferredDate ? "" : "rgb(246, 130, 31)"
	                    },
	                    type: "submit",
	                    id: "Schedule",
	                    className: "btn-links",
	                    disabled: !scheduleReqData.PreferredDate ? true : false
	                  },
	                  "Check Schedule"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ConfirmAppointmentAndRequestAppointment2.default, {
	      scheduleReqData: scheduleReqData
	    })
	  );
	};
	
	exports.default = BookAppointmentPopup;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(251);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// THIS FILE IS AUTO GENERATED
	var GenIcon = __webpack_require__(76).GenIcon
	module.exports.Fa500Px = function Fa500Px (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"}}]})(props);
	};
	module.exports.FaAccessibleIcon = function FaAccessibleIcon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"}}]})(props);
	};
	module.exports.FaAccusoft = function FaAccusoft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"}}]})(props);
	};
	module.exports.FaAcquisitionsIncorporated = function FaAcquisitionsIncorporated (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M357.45 468.2c-1.2-7.7-1.3-7.6-9.6-7.6-99.8.2-111.8-2.4-112.7-2.6-12.3-1.7-20.6-10.5-21-23.1-.1-1.6-.2-71.6-1-129.1-.1-4.7 1.6-6.4 5.9-7.5 12.5-3 24.9-6.1 37.3-9.7 4.3-1.3 6.8-.2 8.4 3.5 4.5 10.3 8.8 20.6 13.2 30.9 1.6 3.7.1 4.4-3.4 4.4-10-.2-20-.1-30.4-.1v27h116c-1.4-9.5-2.7-18.1-4-27.5-7 0-13.8.4-20.4-.1-22.6-1.6-18.3-4.4-84-158.6-8.8-20.1-27.9-62.1-36.5-89.2-4.4-14 5.5-25.4 18.9-26.6 18.6-1.7 37.5-1.6 56.2-2 20.6-.4 41.2-.4 61.8-.5 3.1 0 4-1.4 4.3-4.3 1.2-9.8 2.7-19.5 4-29.2.8-5.3 1.6-10.7 2.4-16.1L23.75 0c-3.6 0-5.3 1.1-4.6 5.3 2.2 13.2-.8.8 6.4 45.3 63.4 0 71.8.9 101.8.5 12.3-.2 37 3.5 37.7 22.1.4 11.4-1.1 11.3-32.6 87.4-53.8 129.8-50.7 120.3-67.3 161-1.7 4.1-3.6 5.2-7.6 5.2-8.5-.2-17-.3-25.4.1-1.9.1-5.2 1.8-5.5 3.2-1.5 8.1-2.2 16.3-3.2 24.9h114.3v-27.6c-6.9 0-33.5.4-35.3-2.9 5.3-12.3 10.4-24.4 15.7-36.7 16.3 4 31.9 7.8 47.6 11.7 3.4.9 4.6 3 4.6 6.8-.1 42.9.1 85.9.2 128.8 0 10.2-5.5 19.1-14.9 23.1-6.5 2.7-3.3 3.4-121.4 2.4-5.3 0-7.1 2-7.6 6.8-1.5 12.9-2.9 25.9-5 38.8-.8 5 1.3 5.7 5.3 5.7 183.2.6-30.7 0 337.1 0-2.5-15-4.4-29.4-6.6-43.7zm-174.9-205.7c-13.3-4.2-26.6-8.2-39.9-12.5a44.53 44.53 0 0 1-5.8-2.9c17.2-44.3 34.2-88.1 51.3-132.1 7.5 2.4 7.9-.8 9.4 0 9.3 22.5 18.1 60.1 27 82.8 6.6 16.7 13 33.5 19.7 50.9a35.78 35.78 0 0 1-3.9 2.1c-13.1 3.9-26.4 7.5-39.4 11.7a27.66 27.66 0 0 1-18.4 0z"}}]})(props);
	};
	module.exports.FaAdn = function FaAdn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"}}]})(props);
	};
	module.exports.FaAdversal = function FaAdversal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"}}]})(props);
	};
	module.exports.FaAffiliatetheme = function FaAffiliatetheme (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"}}]})(props);
	};
	module.exports.FaAirbnb = function FaAirbnb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"}}]})(props);
	};
	module.exports.FaAlgolia = function FaAlgolia (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M229.3 182.6c-49.3 0-89.2 39.9-89.2 89.2 0 49.3 39.9 89.2 89.2 89.2s89.2-39.9 89.2-89.2c0-49.3-40-89.2-89.2-89.2zm62.7 56.6l-58.9 30.6c-1.8.9-3.8-.4-3.8-2.3V201c0-1.5 1.3-2.7 2.7-2.6 26.2 1 48.9 15.7 61.1 37.1.7 1.3.2 3-1.1 3.7zM389.1 32H58.9C26.4 32 0 58.4 0 90.9V421c0 32.6 26.4 59 58.9 59H389c32.6 0 58.9-26.4 58.9-58.9V90.9C448 58.4 421.6 32 389.1 32zm-202.6 84.7c0-10.8 8.7-19.5 19.5-19.5h45.3c10.8 0 19.5 8.7 19.5 19.5v15.4c0 1.8-1.7 3-3.3 2.5-12.3-3.4-25.1-5.1-38.1-5.1-13.5 0-26.7 1.8-39.4 5.5-1.7.5-3.4-.8-3.4-2.5v-15.8zm-84.4 37l9.2-9.2c7.6-7.6 19.9-7.6 27.5 0l7.7 7.7c1.1 1.1 1 3-.3 4-6.2 4.5-12.1 9.4-17.6 14.9-5.4 5.4-10.4 11.3-14.8 17.4-1 1.3-2.9 1.5-4 .3l-7.7-7.7c-7.6-7.5-7.6-19.8 0-27.4zm127.2 244.8c-70 0-126.6-56.7-126.6-126.6s56.7-126.6 126.6-126.6c70 0 126.6 56.6 126.6 126.6 0 69.8-56.7 126.6-126.6 126.6z"}}]})(props);
	};
	module.exports.FaAlipay = function FaAlipay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"}}]})(props);
	};
	module.exports.FaAmazonPay = function FaAmazonPay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"}}]})(props);
	};
	module.exports.FaAmazon = function FaAmazon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"}}]})(props);
	};
	module.exports.FaAmilia = function FaAmilia (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"}}]})(props);
	};
	module.exports.FaAndroid = function FaAndroid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"}}]})(props);
	};
	module.exports.FaAngellist = function FaAngellist (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"}}]})(props);
	};
	module.exports.FaAngrycreative = function FaAngrycreative (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"}}]})(props);
	};
	module.exports.FaAngular = function FaAngular (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"}}]})(props);
	};
	module.exports.FaAppStoreIos = function FaAppStoreIos (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"}}]})(props);
	};
	module.exports.FaAppStore = function FaAppStore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"}}]})(props);
	};
	module.exports.FaApper = function FaApper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"}}]})(props);
	};
	module.exports.FaApplePay = function FaApplePay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"}}]})(props);
	};
	module.exports.FaApple = function FaApple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"}}]})(props);
	};
	module.exports.FaArtstation = function FaArtstation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}}]})(props);
	};
	module.exports.FaAsymmetrik = function FaAsymmetrik (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"}}]})(props);
	};
	module.exports.FaAtlassian = function FaAtlassian (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"}}]})(props);
	};
	module.exports.FaAudible = function FaAudible (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"}}]})(props);
	};
	module.exports.FaAutoprefixer = function FaAutoprefixer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"}}]})(props);
	};
	module.exports.FaAvianex = function FaAvianex (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"}}]})(props);
	};
	module.exports.FaAviato = function FaAviato (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"}}]})(props);
	};
	module.exports.FaAws = function FaAws (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"}}]})(props);
	};
	module.exports.FaBandcamp = function FaBandcamp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"}}]})(props);
	};
	module.exports.FaBattleNet = function FaBattleNet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"}}]})(props);
	};
	module.exports.FaBehanceSquare = function FaBehanceSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8V185zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2z"}}]})(props);
	};
	module.exports.FaBehance = function FaBehance (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}}]})(props);
	};
	module.exports.FaBimobject = function FaBimobject (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"}}]})(props);
	};
	module.exports.FaBitbucket = function FaBitbucket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"}}]})(props);
	};
	module.exports.FaBitcoin = function FaBitcoin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"}}]})(props);
	};
	module.exports.FaBity = function FaBity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"}}]})(props);
	};
	module.exports.FaBlackTie = function FaBlackTie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"}}]})(props);
	};
	module.exports.FaBlackberry = function FaBlackberry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"}}]})(props);
	};
	module.exports.FaBloggerB = function FaBloggerB (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"}}]})(props);
	};
	module.exports.FaBlogger = function FaBlogger (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"}}]})(props);
	};
	module.exports.FaBluetoothB = function FaBluetoothB (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"}}]})(props);
	};
	module.exports.FaBluetooth = function FaBluetooth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"}}]})(props);
	};
	module.exports.FaBootstrap = function FaBootstrap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"}}]})(props);
	};
	module.exports.FaBtc = function FaBtc (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"}}]})(props);
	};
	module.exports.FaBuffer = function FaBuffer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"}}]})(props);
	};
	module.exports.FaBuromobelexperte = function FaBuromobelexperte (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"}}]})(props);
	};
	module.exports.FaBuyNLarge = function FaBuyNLarge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"}}]})(props);
	};
	module.exports.FaBuysellads = function FaBuysellads (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"}}]})(props);
	};
	module.exports.FaCanadianMapleLeaf = function FaCanadianMapleLeaf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"}}]})(props);
	};
	module.exports.FaCcAmazonPay = function FaCcAmazonPay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"}}]})(props);
	};
	module.exports.FaCcAmex = function FaCcAmex (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M325.1 167.8c0-16.4-14.1-18.4-27.4-18.4l-39.1-.3v69.3H275v-25.1h18c18.4 0 14.5 10.3 14.8 25.1h16.6v-13.5c0-9.2-1.5-15.1-11-18.4 7.4-3 11.8-10.7 11.7-18.7zm-29.4 11.3H275v-15.3h21c5.1 0 10.7 1 10.7 7.4 0 6.6-5.3 7.9-11 7.9zM279 268.6h-52.7l-21 22.8-20.5-22.8h-66.5l-.1 69.3h65.4l21.3-23 20.4 23h32.2l.1-23.3c18.9 0 49.3 4.6 49.3-23.3 0-17.3-12.3-22.7-27.9-22.7zm-103.8 54.7h-40.6v-13.8h36.3v-14.1h-36.3v-12.5h41.7l17.9 20.2zm65.8 8.2l-25.3-28.1L241 276zm37.8-31h-21.2v-17.6h21.5c5.6 0 10.2 2.3 10.2 8.4 0 6.4-4.6 9.2-10.5 9.2zm-31.6-136.7v-14.6h-55.5v69.3h55.5v-14.3h-38.9v-13.8h37.8v-14.1h-37.8v-12.5zM576 255.4h-.2zm-194.6 31.9c0-16.4-14.1-18.7-27.1-18.7h-39.4l-.1 69.3h16.6l.1-25.3h17.6c11 0 14.8 2 14.8 13.8l-.1 11.5h16.6l.1-13.8c0-8.9-1.8-15.1-11-18.4 7.7-3.1 11.8-10.8 11.9-18.4zm-29.2 11.2h-20.7v-15.6h21c5.1 0 10.7 1 10.7 7.4 0 6.9-5.4 8.2-11 8.2zm-172.8-80v-69.3h-27.6l-19.7 47-21.7-47H83.3v65.7l-28.1-65.7H30.7L1 218.5h17.9l6.4-15.3h34.5l6.4 15.3H100v-54.2l24 54.2h14.6l24-54.2v54.2zM31.2 188.8l11.2-27.6 11.5 27.6zm477.4 158.9v-4.5c-10.8 5.6-3.9 4.5-156.7 4.5 0-25.2.1-23.9 0-25.2-1.7-.1-3.2-.1-9.4-.1 0 17.9-.1 6.8-.1 25.3h-39.6c0-12.1.1-15.3.1-29.2-10 6-22.8 6.4-34.3 6.2 0 14.7-.1 8.3-.1 23h-48.9c-5.1-5.7-2.7-3.1-15.4-17.4-3.2 3.5-12.8 13.9-16.1 17.4h-82v-92.3h83.1c5 5.6 2.8 3.1 15.5 17.2 3.2-3.5 12.2-13.4 15.7-17.2h58c9.8 0 18 1.9 24.3 5.6v-5.6c54.3 0 64.3-1.4 75.7 5.1v-5.1h78.2v5.2c11.4-6.9 19.6-5.2 64.9-5.2v5c10.3-5.9 16.6-5.2 54.3-5V80c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v109.8c9.4-21.9 19.7-46 23.1-53.9h39.7c4.3 10.1 1.6 3.7 9 21.1v-21.1h46c2.9 6.2 11.1 24 13.9 30 5.8-13.6 10.1-23.9 12.6-30h103c0-.1 11.5 0 11.6 0 43.7.2 53.6-.8 64.4 5.3v-5.3H363v9.3c7.6-6.1 17.9-9.3 30.7-9.3h27.6c0 .5 1.9.3 2.3.3H456c4.2 9.8 2.6 6 8.8 20.6v-20.6h43.3c4.9 8-1-1.8 11.2 18.4v-18.4h39.9v92h-41.6c-5.4-9-1.4-2.2-13.2-21.9v21.9h-52.8c-6.4-14.8-.1-.3-6.6-15.3h-19c-4.2 10-2.2 5.2-6.4 15.3h-26.8c-12.3 0-22.3-3-29.7-8.9v8.9h-66.5c-.3-13.9-.1-24.8-.1-24.8-1.8-.3-3.4-.2-9.8-.2v25.1H151.2v-11.4c-2.5 5.6-2.7 5.9-5.1 11.4h-29.5c-4-8.9-2.9-6.4-5.1-11.4v11.4H58.6c-4.2-10.1-2.2-5.3-6.4-15.3H33c-4.2 10-2.2 5.2-6.4 15.3H0V432c0 26.5 21.5 48 48 48h480.1c26.5 0 48-21.5 48-48v-90.4c-12.7 8.3-32.7 6.1-67.5 6.1zm36.3-64.5H575v-14.6h-32.9c-12.8 0-23.8 6.6-23.8 20.7 0 33 42.7 12.8 42.7 27.4 0 5.1-4.3 6.4-8.4 6.4h-32l-.1 14.8h32c8.4 0 17.6-1.8 22.5-8.9v-25.8c-10.5-13.8-39.3-1.3-39.3-13.5 0-5.8 4.6-6.5 9.2-6.5zm-57 39.8h-32.2l-.1 14.8h32.2c14.8 0 26.2-5.6 26.2-22 0-33.2-42.9-11.2-42.9-26.3 0-5.6 4.9-6.4 9.2-6.4h30.4v-14.6h-33.2c-12.8 0-23.5 6.6-23.5 20.7 0 33 42.7 12.5 42.7 27.4-.1 5.4-4.7 6.4-8.8 6.4zm-42.2-40.1v-14.3h-55.2l-.1 69.3h55.2l.1-14.3-38.6-.3v-13.8H445v-14.1h-37.8v-12.5zm-56.3-108.1c-.3.2-1.4 2.2-1.4 7.6 0 6 .9 7.7 1.1 7.9.2.1 1.1.5 3.4.5l7.3-16.9c-1.1 0-2.1-.1-3.1-.1-5.6 0-7 .7-7.3 1zm20.4-10.5h-.1zm-16.2-15.2c-23.5 0-34 12-34 35.3 0 22.2 10.2 34 33 34h19.2l6.4-15.3h34.3l6.6 15.3h33.7v-51.9l31.2 51.9h23.6v-69h-16.9v48.1l-29.1-48.1h-25.3v65.4l-27.9-65.4h-24.8l-23.5 54.5h-7.4c-13.3 0-16.1-8.1-16.1-19.9 0-23.8 15.7-20 33.1-19.7v-15.2zm42.1 12.1l11.2 27.6h-22.8zm-101.1-12v69.3h16.9v-69.3z"}}]})(props);
	};
	module.exports.FaCcApplePay = function FaCcApplePay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"}}]})(props);
	};
	module.exports.FaCcDinersClub = function FaCcDinersClub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"}}]})(props);
	};
	module.exports.FaCcDiscover = function FaCcDiscover (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"}}]})(props);
	};
	module.exports.FaCcJcb = function FaCcJcb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"}}]})(props);
	};
	module.exports.FaCcMastercard = function FaCcMastercard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"}}]})(props);
	};
	module.exports.FaCcPaypal = function FaCcPaypal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"}}]})(props);
	};
	module.exports.FaCcStripe = function FaCcStripe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"}}]})(props);
	};
	module.exports.FaCcVisa = function FaCcVisa (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"}}]})(props);
	};
	module.exports.FaCentercode = function FaCentercode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"}}]})(props);
	};
	module.exports.FaCentos = function FaCentos (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"}}]})(props);
	};
	module.exports.FaChrome = function FaChrome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M131.5 217.5L55.1 100.1c47.6-59.2 119-91.8 192-92.1 42.3-.3 85.5 10.5 124.8 33.2 43.4 25.2 76.4 61.4 97.4 103L264 133.4c-58.1-3.4-113.4 29.3-132.5 84.1zm32.9 38.5c0 46.2 37.4 83.6 83.6 83.6s83.6-37.4 83.6-83.6-37.4-83.6-83.6-83.6-83.6 37.3-83.6 83.6zm314.9-89.2L339.6 174c37.9 44.3 38.5 108.2 6.6 157.2L234.1 503.6c46.5 2.5 94.4-7.7 137.8-32.9 107.4-62 150.9-192 107.4-303.9zM133.7 303.6L40.4 120.1C14.9 159.1 0 205.9 0 256c0 124 90.8 226.7 209.5 244.9l63.7-124.8c-57.6 10.8-113.2-20.8-139.5-72.5z"}}]})(props);
	};
	module.exports.FaChromecast = function FaChromecast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"}}]})(props);
	};
	module.exports.FaCloudflare = function FaCloudflare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"}}]})(props);
	};
	module.exports.FaCloudscale = function FaCloudscale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"}}]})(props);
	};
	module.exports.FaCloudsmith = function FaCloudsmith (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 332 512"},"child":[{"tag":"path","attr":{"d":"M332.5 419.9c0 46.4-37.6 84.1-84 84.1s-84-37.7-84-84.1 37.6-84 84-84 84 37.6 84 84zm-84-243.9c46.4 0 80-37.6 80-84s-33.6-84-80-84-88 37.6-88 84-29.6 76-76 76-84 41.6-84 88 37.6 80 84 80 84-33.6 84-80 33.6-80 80-80z"}}]})(props);
	};
	module.exports.FaCloudversify = function FaCloudversify (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 616 512"},"child":[{"tag":"path","attr":{"d":"M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"}}]})(props);
	};
	module.exports.FaCodepen = function FaCodepen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"}}]})(props);
	};
	module.exports.FaCodiepie = function FaCodiepie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 472 512"},"child":[{"tag":"path","attr":{"d":"M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"}}]})(props);
	};
	module.exports.FaConfluence = function FaConfluence (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"}}]})(props);
	};
	module.exports.FaConnectdevelop = function FaConnectdevelop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"}}]})(props);
	};
	module.exports.FaContao = function FaContao (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"}}]})(props);
	};
	module.exports.FaCottonBureau = function FaCottonBureau (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"}}]})(props);
	};
	module.exports.FaCpanel = function FaCpanel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"}}]})(props);
	};
	module.exports.FaCreativeCommonsBy = function FaCreativeCommonsBy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"}}]})(props);
	};
	module.exports.FaCreativeCommonsNcEu = function FaCreativeCommonsNcEu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"}}]})(props);
	};
	module.exports.FaCreativeCommonsNcJp = function FaCreativeCommonsNcJp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"}}]})(props);
	};
	module.exports.FaCreativeCommonsNc = function FaCreativeCommonsNc (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"}}]})(props);
	};
	module.exports.FaCreativeCommonsNd = function FaCreativeCommonsNd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"}}]})(props);
	};
	module.exports.FaCreativeCommonsPdAlt = function FaCreativeCommonsPdAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"}}]})(props);
	};
	module.exports.FaCreativeCommonsPd = function FaCreativeCommonsPd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"}}]})(props);
	};
	module.exports.FaCreativeCommonsRemix = function FaCreativeCommonsRemix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"}}]})(props);
	};
	module.exports.FaCreativeCommonsSa = function FaCreativeCommonsSa (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"}}]})(props);
	};
	module.exports.FaCreativeCommonsSamplingPlus = function FaCreativeCommonsSamplingPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"}}]})(props);
	};
	module.exports.FaCreativeCommonsSampling = function FaCreativeCommonsSampling (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"}}]})(props);
	};
	module.exports.FaCreativeCommonsShare = function FaCreativeCommonsShare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"}}]})(props);
	};
	module.exports.FaCreativeCommonsZero = function FaCreativeCommonsZero (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"}}]})(props);
	};
	module.exports.FaCreativeCommons = function FaCreativeCommons (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"}}]})(props);
	};
	module.exports.FaCriticalRole = function FaCriticalRole (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"}}]})(props);
	};
	module.exports.FaCss3Alt = function FaCss3Alt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"}}]})(props);
	};
	module.exports.FaCss3 = function FaCss3 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"}}]})(props);
	};
	module.exports.FaCuttlefish = function FaCuttlefish (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 440 512"},"child":[{"tag":"path","attr":{"d":"M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"}}]})(props);
	};
	module.exports.FaDAndDBeyond = function FaDAndDBeyond (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"}}]})(props);
	};
	module.exports.FaDAndD = function FaDAndD (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"}}]})(props);
	};
	module.exports.FaDailymotion = function FaDailymotion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"}}]})(props);
	};
	module.exports.FaDashcube = function FaDashcube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"}}]})(props);
	};
	module.exports.FaDeezer = function FaDeezer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"}}]})(props);
	};
	module.exports.FaDelicious = function FaDelicious (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"}}]})(props);
	};
	module.exports.FaDeploydog = function FaDeploydog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"}}]})(props);
	};
	module.exports.FaDeskpro = function FaDeskpro (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"}}]})(props);
	};
	module.exports.FaDev = function FaDev (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"}}]})(props);
	};
	module.exports.FaDeviantart = function FaDeviantart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"}}]})(props);
	};
	module.exports.FaDhl = function FaDhl (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"}}]})(props);
	};
	module.exports.FaDiaspora = function FaDiaspora (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"}}]})(props);
	};
	module.exports.FaDigg = function FaDigg (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"}}]})(props);
	};
	module.exports.FaDigitalOcean = function FaDigitalOcean (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"}}]})(props);
	};
	module.exports.FaDiscord = function FaDiscord (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}}]})(props);
	};
	module.exports.FaDiscourse = function FaDiscourse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"}}]})(props);
	};
	module.exports.FaDochub = function FaDochub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"}}]})(props);
	};
	module.exports.FaDocker = function FaDocker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"}}]})(props);
	};
	module.exports.FaDraft2Digital = function FaDraft2Digital (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"}}]})(props);
	};
	module.exports.FaDribbbleSquare = function FaDribbbleSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4zM140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6zm98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160z"}}]})(props);
	};
	module.exports.FaDribbble = function FaDribbble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"}}]})(props);
	};
	module.exports.FaDropbox = function FaDropbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 528 512"},"child":[{"tag":"path","attr":{"d":"M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"}}]})(props);
	};
	module.exports.FaDrupal = function FaDrupal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M319.5 114.7c-22.2-14-43.5-19.5-64.7-33.5-13-8.8-31.3-30-46.5-48.3-2.7 29.3-11.5 41.2-22 49.5-21.3 17-34.8 22.2-53.5 32.3C117 123 32 181.5 32 290.5 32 399.7 123.8 480 225.8 480 327.5 480 416 406 416 294c0-112.3-83-171-96.5-179.3zm2.5 325.6c-20.1 20.1-90.1 28.7-116.7 4.2-4.8-4.8.3-12 6.5-12 0 0 17 13.3 51.5 13.3 27 0 46-7.7 54.5-14 6.1-4.6 8.4 4.3 4.2 8.5zm-54.5-52.6c8.7-3.6 29-3.8 36.8 1.3 4.1 2.8 16.1 18.8 6.2 23.7-8.4 4.2-1.2-15.7-26.5-15.7-14.7 0-19.5 5.2-26.7 11-7 6-9.8 8-12.2 4.7-6-8.2 15.9-22.3 22.4-25zM360 405c-15.2-1-45.5-48.8-65-49.5-30.9-.9-104.1 80.7-161.3 42-38.8-26.6-14.6-104.8 51.8-105.2 49.5-.5 83.8 49 108.5 48.5 21.3-.3 61.8-41.8 81.8-41.8 48.7 0 23.3 109.3-15.8 106z"}}]})(props);
	};
	module.exports.FaDyalog = function FaDyalog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"}}]})(props);
	};
	module.exports.FaEarlybirds = function FaEarlybirds (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"}}]})(props);
	};
	module.exports.FaEbay = function FaEbay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"}}]})(props);
	};
	module.exports.FaEdgeLegacy = function FaEdgeLegacy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"}}]})(props);
	};
	module.exports.FaEdge = function FaEdge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M481.92,134.48C440.87,54.18,352.26,8,255.91,8,137.05,8,37.51,91.68,13.47,203.66c26-46.49,86.22-79.14,149.46-79.14,79.27,0,121.09,48.93,122.25,50.18,22,23.8,33,50.39,33,83.1,0,10.4-5.31,25.82-15.11,38.57-1.57,2-6.39,4.84-6.39,11,0,5.06,3.29,9.92,9.14,14,27.86,19.37,80.37,16.81,80.51,16.81A115.39,115.39,0,0,0,444.94,322a118.92,118.92,0,0,0,58.95-102.44C504.39,176.13,488.39,147.26,481.92,134.48ZM212.77,475.67a154.88,154.88,0,0,1-46.64-45c-32.94-47.42-34.24-95.6-20.1-136A155.5,155.5,0,0,1,203,215.75c59-45.2,94.84-5.65,99.06-1a80,80,0,0,0-4.89-10.14c-9.24-15.93-24-36.41-56.56-53.51-33.72-17.69-70.59-18.59-77.64-18.59-38.71,0-77.9,13-107.53,35.69C35.68,183.3,12.77,208.72,8.6,243c-1.08,12.31-2.75,62.8,23,118.27a248,248,0,0,0,248.3,141.61C241.78,496.26,214.05,476.24,212.77,475.67Zm250.72-98.33a7.76,7.76,0,0,0-7.92-.23,181.66,181.66,0,0,1-20.41,9.12,197.54,197.54,0,0,1-69.55,12.52c-91.67,0-171.52-63.06-171.52-144A61.12,61.12,0,0,1,200.61,228,168.72,168.72,0,0,0,161.85,278c-14.92,29.37-33,88.13,13.33,151.66,6.51,8.91,23,30,56,47.67,23.57,12.65,49,19.61,71.7,19.61,35.14,0,115.43-33.44,163-108.87A7.75,7.75,0,0,0,463.49,377.34Z"}}]})(props);
	};
	module.exports.FaElementor = function FaElementor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M425.6 32H22.4C10 32 0 42 0 54.4v403.2C0 470 10 480 22.4 480h403.2c12.4 0 22.4-10 22.4-22.4V54.4C448 42 438 32 425.6 32M164.3 355.5h-39.8v-199h39.8v199zm159.3 0H204.1v-39.8h119.5v39.8zm0-79.6H204.1v-39.8h119.5v39.8zm0-79.7H204.1v-39.8h119.5v39.8z"}}]})(props);
	};
	module.exports.FaEllo = function FaEllo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"}}]})(props);
	};
	module.exports.FaEmber = function FaEmber (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"}}]})(props);
	};
	module.exports.FaEmpire = function FaEmpire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"}}]})(props);
	};
	module.exports.FaEnvira = function FaEnvira (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"}}]})(props);
	};
	module.exports.FaErlang = function FaErlang (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"}}]})(props);
	};
	module.exports.FaEthereum = function FaEthereum (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"}}]})(props);
	};
	module.exports.FaEtsy = function FaEtsy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"}}]})(props);
	};
	module.exports.FaEvernote = function FaEvernote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"}}]})(props);
	};
	module.exports.FaExpeditedssl = function FaExpeditedssl (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"}}]})(props);
	};
	module.exports.FaFacebookF = function FaFacebookF (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"}}]})(props);
	};
	module.exports.FaFacebookMessenger = function FaFacebookMessenger (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"}}]})(props);
	};
	module.exports.FaFacebookSquare = function FaFacebookSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"}}]})(props);
	};
	module.exports.FaFacebook = function FaFacebook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"}}]})(props);
	};
	module.exports.FaFantasyFlightGames = function FaFantasyFlightGames (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99a42569.01 42569.01 0 0 1-41.13-40.72zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"}}]})(props);
	};
	module.exports.FaFedex = function FaFedex (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"}}]})(props);
	};
	module.exports.FaFedora = function FaFedora (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M225 32C101.3 31.7.8 131.7.4 255.4L0 425.7a53.6 53.6 0 0 0 53.6 53.9l170.2.4c123.7.3 224.3-99.7 224.6-223.4S348.7 32.3 225 32zm169.8 157.2L333 126.6c2.3-4.7 3.8-9.2 3.8-14.3v-1.6l55.2 56.1a101 101 0 0 1 2.8 22.4zM331 94.3a106.06 106.06 0 0 1 58.5 63.8l-54.3-54.6a26.48 26.48 0 0 0-4.2-9.2zM118.1 247.2a49.66 49.66 0 0 0-7.7 11.4l-8.5-8.5a85.78 85.78 0 0 1 16.2-2.9zM97 251.4l11.8 11.9-.9 8a34.74 34.74 0 0 0 2.4 12.5l-27-27.2a80.6 80.6 0 0 1 13.7-5.2zm-18.2 7.4l38.2 38.4a53.17 53.17 0 0 0-14.1 4.7L67.6 266a107 107 0 0 1 11.2-7.2zm-15.2 9.8l35.3 35.5a67.25 67.25 0 0 0-10.5 8.5L53.5 278a64.33 64.33 0 0 1 10.1-9.4zm-13.3 12.3l34.9 35a56.84 56.84 0 0 0-7.7 11.4l-35.8-35.9c2.8-3.8 5.7-7.2 8.6-10.5zm-11 14.3l36.4 36.6a48.29 48.29 0 0 0-3.6 15.2l-39.5-39.8a99.81 99.81 0 0 1 6.7-12zm-8.8 16.3l41.3 41.8a63.47 63.47 0 0 0 6.7 26.2L25.8 326c1.4-4.9 2.9-9.6 4.7-14.5zm-7.9 43l61.9 62.2a31.24 31.24 0 0 0-3.6 14.3v1.1l-55.4-55.7a88.27 88.27 0 0 1-2.9-21.9zm5.3 30.7l54.3 54.6a28.44 28.44 0 0 0 4.2 9.2 106.32 106.32 0 0 1-58.5-63.8zm-5.3-37a80.69 80.69 0 0 1 2.1-17l72.2 72.5a37.59 37.59 0 0 0-9.9 8.7zm253.3-51.8l-42.6-.1-.1 56c-.2 69.3-64.4 115.8-125.7 102.9-5.7 0-19.9-8.7-19.9-24.2a24.89 24.89 0 0 1 24.5-24.6c6.3 0 6.3 1.6 15.7 1.6a55.91 55.91 0 0 0 56.1-55.9l.1-47c0-4.5-4.5-9-8.9-9l-33.6-.1c-32.6-.1-32.5-49.4.1-49.3l42.6.1.1-56a105.18 105.18 0 0 1 105.6-105 86.35 86.35 0 0 1 20.2 2.3c11.2 1.8 19.9 11.9 19.9 24 0 15.5-14.9 27.8-30.3 23.9-27.4-5.9-65.9 14.4-66 54.9l-.1 47a8.94 8.94 0 0 0 8.9 9l33.6.1c32.5.2 32.4 49.5-.2 49.4zm23.5-.3a35.58 35.58 0 0 0 7.6-11.4l8.5 8.5a102 102 0 0 1-16.1 2.9zm21-4.2L308.6 280l.9-8.1a34.74 34.74 0 0 0-2.4-12.5l27 27.2a74.89 74.89 0 0 1-13.7 5.3zm18-7.4l-38-38.4c4.9-1.1 9.6-2.4 13.7-4.7l36.2 35.9c-3.8 2.5-7.9 5-11.9 7.2zm15.5-9.8l-35.3-35.5a61.06 61.06 0 0 0 10.5-8.5l34.9 35a124.56 124.56 0 0 1-10.1 9zm13.2-12.3l-34.9-35a63.18 63.18 0 0 0 7.7-11.4l35.8 35.9a130.28 130.28 0 0 1-8.6 10.5zm11-14.3l-36.4-36.6a48.29 48.29 0 0 0 3.6-15.2l39.5 39.8a87.72 87.72 0 0 1-6.7 12zm13.5-30.9a140.63 140.63 0 0 1-4.7 14.3L345.6 190a58.19 58.19 0 0 0-7.1-26.2zm1-5.6l-71.9-72.1a32 32 0 0 0 9.9-9.2l64.3 64.7a90.93 90.93 0 0 1-2.3 16.6z"}}]})(props);
	};
	module.exports.FaFigma = function FaFigma (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"}}]})(props);
	};
	module.exports.FaFirefoxBrowser = function FaFirefoxBrowser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M189.37,152.86Zm-58.74-29.37C130.79,123.5,130.71,123.5,130.63,123.49Zm351.42,45.35c-10.61-25.5-32.08-53-48.94-61.73,13.72,26.89,21.67,53.88,24.7,74,0,0,0,.14.05.41-27.58-68.75-74.35-96.47-112.55-156.83-1.93-3.05-3.86-6.11-5.74-9.33-1-1.65-1.86-3.34-2.69-5.05A44.88,44.88,0,0,1,333.24.69a.63.63,0,0,0-.55-.66.9.9,0,0,0-.46,0l-.12.07-.18.1.1-.14c-54.23,31.77-76.72,87.38-82.5,122.78a130,130,0,0,0-48.33,12.33,6.25,6.25,0,0,0-3.09,7.75,6.13,6.13,0,0,0,7.79,3.79l.52-.21a117.84,117.84,0,0,1,42.11-11l1.42-.1c2-.12,4-.2,6-.22A122.61,122.61,0,0,1,291,140c.67.2,1.32.42,2,.63,1.89.57,3.76,1.2,5.62,1.87,1.36.5,2.71,1,4.05,1.58,1.09.44,2.18.88,3.25,1.35q2.52,1.13,5,2.35c.75.37,1.5.74,2.25,1.13q2.4,1.26,4.74,2.63,1.51.87,3,1.8a124.89,124.89,0,0,1,42.66,44.13c-13-9.15-36.35-18.19-58.82-14.28,87.74,43.86,64.18,194.9-57.39,189.2a108.43,108.43,0,0,1-31.74-6.12c-2.42-.91-4.8-1.89-7.16-2.93-1.38-.63-2.76-1.27-4.12-2C174.5,346,149.9,316.92,146.83,281.59c0,0,11.25-41.95,80.62-41.95,7.5,0,28.93-20.92,29.33-27-.09-2-42.54-18.87-59.09-35.18-8.85-8.71-13.05-12.91-16.77-16.06a69.58,69.58,0,0,0-6.31-4.77A113.05,113.05,0,0,1,173.92,97c-25.06,11.41-44.55,29.45-58.71,45.37h-.12c-9.67-12.25-9-52.65-8.43-61.08-.12-.53-7.22,3.68-8.15,4.31a178.54,178.54,0,0,0-23.84,20.43A214,214,0,0,0,51.9,133.36l0,0a.08.08,0,0,1,0,0,205.84,205.84,0,0,0-32.73,73.9c-.06.27-2.33,10.21-4,22.48q-.42,2.87-.78,5.74c-.57,3.69-1,7.71-1.44,14,0,.24,0,.48-.05.72-.18,2.71-.34,5.41-.49,8.12,0,.41,0,.82,0,1.24,0,134.7,109.21,243.89,243.92,243.89,120.64,0,220.82-87.58,240.43-202.62.41-3.12.74-6.26,1.11-9.41,4.85-41.83-.54-85.79-15.82-122.55Z"}}]})(props);
	};
	module.exports.FaFirefox = function FaFirefox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"}}]})(props);
	};
	module.exports.FaFirstOrderAlt = function FaFirstOrderAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"}}]})(props);
	};
	module.exports.FaFirstOrder = function FaFirstOrder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"}}]})(props);
	};
	module.exports.FaFirstdraft = function FaFirstdraft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"}}]})(props);
	};
	module.exports.FaFlickr = function FaFlickr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"}}]})(props);
	};
	module.exports.FaFlipboard = function FaFlipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"}}]})(props);
	};
	module.exports.FaFly = function FaFly (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"}}]})(props);
	};
	module.exports.FaFontAwesomeAlt = function FaFontAwesomeAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32Zm16 400a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V80A16 16 0 0 1 48 64H400a16 16 0 0 1 16 16ZM201.6 152c-25.4 0-37.4 10.4-57.6 14.4V160a16 16 0 0 0-32 0V352a16 16 0 0 0 32 0V198.4c20.2-4 32.2-14.4 57.6-14.4 31.4 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.4-16-74.6-16a85.9 85.9 0 0 0-25.6 4v32a80 80 0 0 1 25.6-4c31.4 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16V152c-31.6 11.2-41.2 16-59.8 16C244.8 168 232.8 152 201.6 152Z"}}]})(props);
	};
	module.exports.FaFontAwesomeFlag = function FaFontAwesomeFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 48V384c-63 23-82 32-119 32-63 0-87-32-150-32-20 0-36 4-51 8V328c15-4 31-8 51-8 63 0 87 32 150 32 20 0 35-3 55-9V135c-20 6-35 9-55 9-63 0-87-32-150-32-51 0-75 21-115 29V448a31.6 31.6 0 0 1-32 32A31.6 31.6 0 0 1 0 448V64A31.6 31.6 0 0 1 32 32 31.6 31.6 0 0 1 64 64V77c40-8 64-29 115-29 63 0 87 32 150 32C366 80 385 71 448 48Z"}}]})(props);
	};
	module.exports.FaFontAwesomeLogoFull = function FaFontAwesomeLogoFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 3992 512"},"child":[{"tag":"path","attr":{"d":"M1209.7 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C1311.7 200.4 1267.5 156.5 1209.7 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C1261.1 281.8 1244.8 309.2 1209.7 309.2Zm962.1-136.1c-4.4-10.9-12.3-16.5-23.5-16.5s-19.1 5.6-23.5 16.5l-59.4 145.8c-7.2 17.7 2.8 27.4 4.4 29a24.6 24.6 0 0 0 17.5 6.8c10.8 0 18.7-6 23.1-18.1l4-10.1h67.7l4 10.1c4.8 12.1 12.3 18.1 23.1 18.1a24.6 24.6 0 0 0 17.5-6.8c10-10.1 6.8-22.6 4.4-29Zm-43 113.6 19.1-56 19.1 56Zm-574.5-130.1c-14.3 0-24.7 10.9-24.7 25.4v76.5l-68.5-85.8c-4.4-5.6-11.6-16.1-25.5-16.1-19.1 0-24.3 17.7-24.3 25.4V329.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V252.8l68.9 86.2c4.8 5.6 11.6 16.1 25.5 16.1 19.1 0 23.9-17.3 23.9-25.4V181.9C1579 167.4 1568.6 156.5 1554.3 156.5Zm-554.1 1.6H916.5c-19.9 0-25.1 17.3-25.1 25.4V328.1c0 19.7 16.7 25.4 24.7 25.4 8 0 24.7-5.2 24.7-25.4V285h44.6c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.1-22.7-22.1H940.8V203.6h59.4c12.8 0 22.7-9.3 22.7-22.6C1022.9 163 1007.3 158.1 1000.2 158.1Zm815.1 0H1691.7c-7.2 0-22.7 4.4-22.7 22.2 0 13.3 10 22.6 22.7 22.6h37V327.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V202.8h37c12.7 0 22.7-9.3 22.7-22.6C1837.9 163 1822.4 158.1 1815.2 158.1Zm1789.5-1.6c-9.6 0-17.5 6-25.1 18.1l-46.6 76.1L3486.4 174.6q-10.8-18.1-25.1-18.1c-19.5 0-24.7 18.1-24.7 25.8V329.7c0 14.1 10.4 25.4 24.7 25.4s24.7-10.9 24.7-25.4V262.8L3510.7 302.7c6.4 10.1 13.9 15.3 22.3 15.3 8.8 0 15.9-5.2 22.3-15.3l24.7-39.9v66.9c0 14.1 10.3 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V182.3C3629.4 174.2 3624.6 156.5 3604.7 156.5Zm248.6 149.8h-65.7V272.9h39.4c11.9 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.6-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.8 0 22.7-9.3 22.7-22.6C3876 311.2 3860.5 306.3 3853.3 306.3ZM3235 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C3337 200.4 3292.8 156.5 3235 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C3286.8 281.8 3270.1 309.2 3235 309.2ZM2550.2 156.5c-11.2 0-19.1 5.6-23.1 16.5l-34.3 94.7-31.5-92.2c-4.4-12.5-12.3-18.9-24.3-18.9-11.9 0-19.9 6.4-24.3 18.9l-31.5 92.2-34.3-95.5q-5.4-15.7-22.7-15.7c-6.8 0-12.3 2.4-17.5 7.3-5.2 5.2-10.8 14.5-4.8 28.6l55.8 145.8c4 11.3 11.6 16.9 23.1 16.9q16.7 0 22.7-16.9l33.5-91.8 33.5 91.8q6 16.9 22.7 16.9c11.2 0 19.1-5.6 23.1-16.9l55.8-145.8c3.6-9.3 4.4-19.3-4.8-28.6A23 23 0 0 0 2550.2 156.5Zm444.2 81-21.9-9.3c-11.9-4.8-16.3-8.5-16.3-15.7q0-12.1 16.7-12.1c12.7 0 19.5 7.7 24.3 10.9 7.2 5.2 18.3 6.8 27.9-2 10.8-10.5 6.8-23.8 1.2-30.6-12.3-14.9-30.3-22.2-53.8-22.2-19.1 0-35.1 5.2-47.4 15.7-12.3 10.5-18.7 24.2-18.7 41.1 0 24.2 15.9 43.5 47.8 57.6l19.5 8.9c15.9 6.8 19.1 9.7 19.1 17.7 0 9.3-6.4 14.1-19.5 14.1-19.1 0-34.7-14.9-36.3-16.1-10.8-7.3-21.5-2-26.3 2.8-6.8 6.4-12.7 20.9 3.2 36.2 6.8 6.4 15.5 11.7 26.7 15.3a94.6 94.6 0 0 0 32.7 5.6c19.9 0 36.7-5.2 49.8-16.1 13.1-10.9 19.5-25.4 19.5-43.5q0-20.5-12-33.8C3022.7 253.2 3010.7 244.3 2994.4 237.5Zm-206.4 68.9h-65.7V272.9h39.4c12 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.7 0 22.7-9.3 22.7-22.6C2810.8 311.2 2795.2 306.3 2788 306.3ZM178.3 49.1c-50.5 0-74.4 20.7-114.6 28.7V65A31.8 31.8 0 1 0 0 65V447a31.8 31.8 0 0 0 63.7 0V141.4c40.2-8 64.1-28.7 114.6-28.7 62.5 0 86 31.8 148.4 31.8 20.3 0 35.4-2.8 55.3-9.2v191c-19.9 6.4-35 9.2-55.3 9.2-62.5 0-86.4-31.8-148.4-31.8-20.3 0-36.2 3.6-50.9 8V375.4a159.1 159.1 0 0 1 50.9-8c62.5 0 86 31.8 148.4 31.8 37 0 56.1-9.6 119-31.8V49.1C382.8 71.4 363.7 80.9 326.7 80.9 264.2 80.9 240.4 49.1 178.3 49.1Z"}}]})(props);
	};
	module.exports.FaFontAwesome = function FaFontAwesome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32ZM336 312c-31.6 11.2-41.2 16-59.8 16-31.4 0-43.2-16-74.6-16a80 80 0 0 0-25.6 4V284a85.9 85.9 0 0 1 25.6-4c31.2 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v-96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.2-16-74.6-16-25.4 0-37.4 10.4-57.6 14.4V352a16 16 0 0 1-32 0V160a16 16 0 0 1 32 0v6.4c20.2-4 32.2-14.4 57.6-14.4 31.2 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16Z"}}]})(props);
	};
	module.exports.FaFonticonsFi = function FaFonticonsFi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"}}]})(props);
	};
	module.exports.FaFonticons = function FaFonticons (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"}}]})(props);
	};
	module.exports.FaFortAwesomeAlt = function FaFortAwesomeAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"}}]})(props);
	};
	module.exports.FaFortAwesome = function FaFortAwesome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"}}]})(props);
	};
	module.exports.FaForumbee = function FaForumbee (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"}}]})(props);
	};
	module.exports.FaFoursquare = function FaFoursquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 368 512"},"child":[{"tag":"path","attr":{"d":"M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"}}]})(props);
	};
	module.exports.FaFreeCodeCamp = function FaFreeCodeCamp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"}}]})(props);
	};
	module.exports.FaFreebsd = function FaFreebsd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"}}]})(props);
	};
	module.exports.FaFulcrum = function FaFulcrum (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"}}]})(props);
	};
	module.exports.FaGalacticRepublic = function FaGalacticRepublic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"}}]})(props);
	};
	module.exports.FaGalacticSenate = function FaGalacticSenate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"}}]})(props);
	};
	module.exports.FaGetPocket = function FaGetPocket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"}}]})(props);
	};
	module.exports.FaGgCircle = function FaGgCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"}}]})(props);
	};
	module.exports.FaGg = function FaGg (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"}}]})(props);
	};
	module.exports.FaGitAlt = function FaGitAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"}}]})(props);
	};
	module.exports.FaGitSquare = function FaGitSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48zm-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31zM199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84l-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z"}}]})(props);
	};
	module.exports.FaGit = function FaGit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"}}]})(props);
	};
	module.exports.FaGithubAlt = function FaGithubAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"}}]})(props);
	};
	module.exports.FaGithubSquare = function FaGithubSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"}}]})(props);
	};
	module.exports.FaGithub = function FaGithub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}}]})(props);
	};
	module.exports.FaGitkraken = function FaGitkraken (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 592 512"},"child":[{"tag":"path","attr":{"d":"M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"}}]})(props);
	};
	module.exports.FaGitlab = function FaGitlab (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M105.2 24.9c-3.1-8.9-15.7-8.9-18.9 0L29.8 199.7h132c-.1 0-56.6-174.8-56.6-174.8zM.9 287.7c-2.6 8 .3 16.9 7.1 22l247.9 184-226.2-294zm160.8-88l94.3 294 94.3-294zm349.4 88l-28.8-88-226.3 294 247.9-184c6.9-5.1 9.7-14 7.2-22zM425.7 24.9c-3.1-8.9-15.7-8.9-18.9 0l-56.6 174.8h132z"}}]})(props);
	};
	module.exports.FaGitter = function FaGitter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"}}]})(props);
	};
	module.exports.FaGlideG = function FaGlideG (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"}}]})(props);
	};
	module.exports.FaGlide = function FaGlide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"}}]})(props);
	};
	module.exports.FaGofore = function FaGofore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 400 512"},"child":[{"tag":"path","attr":{"d":"M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"}}]})(props);
	};
	module.exports.FaGoodreadsG = function FaGoodreadsG (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"}}]})(props);
	};
	module.exports.FaGoodreads = function FaGoodreads (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"}}]})(props);
	};
	module.exports.FaGoogleDrive = function FaGoogleDrive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"}}]})(props);
	};
	module.exports.FaGooglePay = function FaGooglePay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"}}]})(props);
	};
	module.exports.FaGooglePlay = function FaGooglePlay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"}}]})(props);
	};
	module.exports.FaGooglePlusG = function FaGooglePlusG (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"}}]})(props);
	};
	module.exports.FaGooglePlusSquare = function FaGooglePlusSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"}}]})(props);
	};
	module.exports.FaGooglePlus = function FaGooglePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"}}]})(props);
	};
	module.exports.FaGoogleWallet = function FaGoogleWallet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"}}]})(props);
	};
	module.exports.FaGoogle = function FaGoogle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 488 512"},"child":[{"tag":"path","attr":{"d":"M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"}}]})(props);
	};
	module.exports.FaGratipay = function FaGratipay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"}}]})(props);
	};
	module.exports.FaGrav = function FaGrav (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"}}]})(props);
	};
	module.exports.FaGripfire = function FaGripfire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"}}]})(props);
	};
	module.exports.FaGrunt = function FaGrunt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"}}]})(props);
	};
	module.exports.FaGuilded = function FaGuilded (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"}}]})(props);
	};
	module.exports.FaGulp = function FaGulp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"}}]})(props);
	};
	module.exports.FaHackerNewsSquare = function FaHackerNewsSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"}}]})(props);
	};
	module.exports.FaHackerNews = function FaHackerNews (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"}}]})(props);
	};
	module.exports.FaHackerrank = function FaHackerrank (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"}}]})(props);
	};
	module.exports.FaHips = function FaHips (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"}}]})(props);
	};
	module.exports.FaHireAHelper = function FaHireAHelper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"}}]})(props);
	};
	module.exports.FaHive = function FaHive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"}}]})(props);
	};
	module.exports.FaHooli = function FaHooli (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"}}]})(props);
	};
	module.exports.FaHornbill = function FaHornbill (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"}}]})(props);
	};
	module.exports.FaHotjar = function FaHotjar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M414.9 161.5C340.2 29 121.1 0 121.1 0S222.2 110.4 93 197.7C11.3 252.8-21 324.4 14 402.6c26.8 59.9 83.5 84.3 144.6 93.4-29.2-55.1-6.6-122.4-4.1-129.6 57.1 86.4 165 0 110.8-93.9 71 15.4 81.6 138.6 27.1 215.5 80.5-25.3 134.1-88.9 148.8-145.6 15.5-59.3 3.7-127.9-26.3-180.9z"}}]})(props);
	};
	module.exports.FaHouzz = function FaHouzz (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"}}]})(props);
	};
	module.exports.FaHtml5 = function FaHtml5 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"}}]})(props);
	};
	module.exports.FaHubspot = function FaHubspot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"}}]})(props);
	};
	module.exports.FaIdeal = function FaIdeal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"}}]})(props);
	};
	module.exports.FaImdb = function FaImdb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.3 229.2H21c.1-.1.2-.3.3-.4zM97 319.8H64V192h33zm113.2 0h-28.7v-86.4l-11.6 86.4h-20.6l-12.2-84.5v84.5h-29V192h42.8c3.3 19.8 6 39.9 8.7 59.9l7.6-59.9h43zm11.4 0V192h24.6c17.6 0 44.7-1.6 49 20.9 1.7 7.6 1.4 16.3 1.4 24.4 0 88.5 11.1 82.6-75 82.5zm160.9-29.2c0 15.7-2.4 30.9-22.2 30.9-9 0-15.2-3-20.9-9.8l-1.9 8.1h-29.8V192h31.7v41.7c6-6.5 12-9.2 20.9-9.2 21.4 0 22.2 12.8 22.2 30.1zM265 229.9c0-9.7 1.6-16-10.3-16v83.7c12.2.3 10.3-8.7 10.3-18.4zm85.5 26.1c0-5.4 1.1-12.7-6.2-12.7-6 0-4.9 8.9-4.9 12.7 0 .6-1.1 39.6 1.1 44.7.8 1.6 2.2 2.4 3.8 2.4 7.8 0 6.2-9 6.2-14.4z"}}]})(props);
	};
	module.exports.FaInnosoft = function FaInnosoft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M422.559,159.71a27.379,27.379,0,0,0-13.866-23.337,26.42,26.42,0,0,0-26.211.133L73.943,314.647V176.261a11.955,11.955,0,0,1,6.047-10.34L218.066,86.208a12.153,12.153,0,0,1,11.922.025l32.656,18.853L112.581,191.723v56L359.642,105.086,241.129,36.679c-10.992-6.129-22.3-6.255-33.8-.27l-164.6,95.026c-10.634,6.12-16.771,16.39-17.29,29.124l0,191.5c.17,10.135,5.08,18.672,13.474,23.428a27.037,27.037,0,0,0,26.736-.045L374.057,197.376V335.657a11.976,11.976,0,0,1-5.92,10.368L230.025,425.77a12.175,12.175,0,0,1-11.937.062l-32.723-18.9,150.051-86.627v-56L88.367,406.932l118.794,68.583a33.88,33.88,0,0,0,34.25-.327l164.527-94.995c10.746-6.631,16.649-17.118,16.624-29.528Z"}}]})(props);
	};
	module.exports.FaInstagramSquare = function FaInstagramSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"}}]})(props);
	};
	module.exports.FaInstagram = function FaInstagram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"}}]})(props);
	};
	module.exports.FaInstalod = function FaInstalod (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"}}]})(props);
	};
	module.exports.FaIntercom = function FaIntercom (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"}}]})(props);
	};
	module.exports.FaInternetExplorer = function FaInternetExplorer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"}}]})(props);
	};
	module.exports.FaInvision = function FaInvision (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"}}]})(props);
	};
	module.exports.FaIoxhost = function FaIoxhost (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaItchIo = function FaItchIo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"}}]})(props);
	};
	module.exports.FaItunesNote = function FaItunesNote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"}}]})(props);
	};
	module.exports.FaItunes = function FaItunes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"}}]})(props);
	};
	module.exports.FaJava = function FaJava (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"}}]})(props);
	};
	module.exports.FaJediOrder = function FaJediOrder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"}}]})(props);
	};
	module.exports.FaJenkins = function FaJenkins (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"}}]})(props);
	};
	module.exports.FaJira = function FaJira (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"}}]})(props);
	};
	module.exports.FaJoget = function FaJoget (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"}}]})(props);
	};
	module.exports.FaJoomla = function FaJoomla (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"}}]})(props);
	};
	module.exports.FaJsSquare = function FaJsSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"}}]})(props);
	};
	module.exports.FaJs = function FaJs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"}}]})(props);
	};
	module.exports.FaJsfiddle = function FaJsfiddle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"}}]})(props);
	};
	module.exports.FaKaggle = function FaKaggle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"}}]})(props);
	};
	module.exports.FaKeybase = function FaKeybase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"}}]})(props);
	};
	module.exports.FaKeycdn = function FaKeycdn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"}}]})(props);
	};
	module.exports.FaKickstarterK = function FaKickstarterK (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"}}]})(props);
	};
	module.exports.FaKickstarter = function FaKickstarter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"}}]})(props);
	};
	module.exports.FaKorvue = function FaKorvue (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 446 512"},"child":[{"tag":"path","attr":{"d":"M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"}}]})(props);
	};
	module.exports.FaLaravel = function FaLaravel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"}}]})(props);
	};
	module.exports.FaLastfmSquare = function FaLastfmSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z"}}]})(props);
	};
	module.exports.FaLastfm = function FaLastfm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"}}]})(props);
	};
	module.exports.FaLeanpub = function FaLeanpub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"}}]})(props);
	};
	module.exports.FaLess = function FaLess (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"}}]})(props);
	};
	module.exports.FaLine = function FaLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2H219c1 0 2.1.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-.1 3.3 1.4 3.3 3.1zm-82-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 1.8 1.4 3.2 3.2 3.2h11.4c1.8 0 3.2-1.4 3.2-3.2v-71.1c0-1.7-1.4-3.2-3.2-3.2zm-27.5 59.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 .9.3 1.6.9 2.2.6.5 1.3.9 2.2.9h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.7-1.4-3.2-3.1-3.2zM332.1 201h-45.7c-1.7 0-3.2 1.4-3.2 3.2v71.1c0 1.7 1.4 3.2 3.2 3.2h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2v-11.4c-.1-1.7-1.5-3.2-3.2-3.2zM448 113.7V399c-.1 44.8-36.8 81.1-81.7 81H81c-44.8-.1-81.1-36.9-81-81.7V113c.1-44.8 36.9-81.1 81.7-81H367c44.8.1 81.1 36.8 81 81.7zm-61.6 122.6c0-73-73.2-132.4-163.1-132.4-89.9 0-163.1 59.4-163.1 132.4 0 65.4 58 120.2 136.4 130.6 19.1 4.1 16.9 11.1 12.6 36.8-.7 4.1-3.3 16.1 14.1 8.8 17.4-7.3 93.9-55.3 128.2-94.7 23.6-26 34.9-52.3 34.9-81.5z"}}]})(props);
	};
	module.exports.FaLinkedinIn = function FaLinkedinIn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"}}]})(props);
	};
	module.exports.FaLinkedin = function FaLinkedin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"}}]})(props);
	};
	module.exports.FaLinode = function FaLinode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M437.4 226.3c-.3-.9-.9-1.4-1.4-2l-70-38.6c-.9-.6-2-.6-3.1 0l-58.9 36c-.9.6-1.4 1.7-1.4 2.6l-.9 31.4-24-16c-.9-.6-2.3-.6-3.1 0L240 260.9l-1.4-35.1c0-.9-.6-2-1.4-2.3l-36-24.3 33.7-17.4c1.1-.6 1.7-1.7 1.7-2.9l-5.7-132.3c0-.9-.9-2-1.7-2.6L138.6.3c-.9-.3-1.7-.3-2.3-.3L12.6 38.6c-1.4.6-2.3 2-2 3.7L38 175.4c.9 3.4 34 27.4 38.6 30.9l-26.9 12.9c-1.4.9-2 2.3-1.7 3.4l20.6 100.3c.6 2.9 23.7 23.1 27.1 26.3l-17.4 10.6c-.9.6-1.7 2-1.4 3.1 1.4 7.1 15.4 77.7 16.9 79.1l65.1 69.1c.6.6 1.4.6 2.3.9.6 0 1.1-.3 1.7-.6l83.7-66.9c.9-.6 1.1-1.4 1.1-2.3l-2-46 28 23.7c1.1.9 2.9.9 4 0l66.9-53.4c.9-.6 1.1-1.4 1.1-2.3l2.3-33.4 20.3 14c1.1.9 2.6.9 3.7 0l54.6-43.7c.6-.3 1.1-1.1 1.1-2 .9-6.5 10.3-70.8 9.7-72.8zm-204.8 4.8l4 92.6-90.6 61.2-14-96.6 100.6-57.2zm-7.7-180l5.4 126-106.6 55.4L104 97.7l120.9-46.6zM44 173.1L18 48l79.7 49.4 19.4 132.9L44 173.1zm30.6 147.8L55.7 230l70 58.3 13.7 93.4-64.8-60.8zm24.3 117.7l-13.7-67.1 61.7 60.9 9.7 67.4-57.7-61.2zm64.5 64.5l-10.6-70.9 85.7-61.4 3.1 70-78.2 62.3zm82-115.1c0-3.4.9-22.9-2-25.1l-24.3-20 22.3-14.9c2.3-1.7 1.1-5.7 1.1-8l29.4 22.6.6 68.3-27.1-22.9zm94.3-25.4l-60.9 48.6-.6-68.6 65.7-46.9-4.2 66.9zm27.7-25.7l-19.1-13.4 2-34c.3-.9-.3-2-1.1-2.6L308 259.7l.6-30 64.6 40.6-5.8 66.6zm54.6-39.8l-48.3 38.3 5.7-65.1 51.1-36.6-8.5 63.4z"}}]})(props);
	};
	module.exports.FaLinux = function FaLinux (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"}}]})(props);
	};
	module.exports.FaLyft = function FaLyft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"}}]})(props);
	};
	module.exports.FaMagento = function FaMagento (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"}}]})(props);
	};
	module.exports.FaMailchimp = function FaMailchimp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"}}]})(props);
	};
	module.exports.FaMandalorian = function FaMandalorian (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"}}]})(props);
	};
	module.exports.FaMarkdown = function FaMarkdown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"}}]})(props);
	};
	module.exports.FaMastodon = function FaMastodon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"}}]})(props);
	};
	module.exports.FaMaxcdn = function FaMaxcdn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"}}]})(props);
	};
	module.exports.FaMdb = function FaMdb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"}}]})(props);
	};
	module.exports.FaMedapps = function FaMedapps (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"}}]})(props);
	};
	module.exports.FaMediumM = function FaMediumM (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M71.5 142.3c.6-5.9-1.7-11.8-6.1-15.8L20.3 72.1V64h140.2l108.4 237.7L364.2 64h133.7v8.1l-38.6 37c-3.3 2.5-5 6.7-4.3 10.8v272c-.7 4.1 1 8.3 4.3 10.8l37.7 37v8.1H307.3v-8.1l39.1-37.9c3.8-3.8 3.8-5 3.8-10.8V171.2L241.5 447.1h-14.7L100.4 171.2v184.9c-1.1 7.8 1.5 15.6 7 21.2l50.8 61.6v8.1h-144v-8L65 377.3c5.4-5.6 7.9-13.5 6.5-21.2V142.3z"}}]})(props);
	};
	module.exports.FaMedium = function FaMedium (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z"}}]})(props);
	};
	module.exports.FaMedrt = function FaMedrt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 544 512"},"child":[{"tag":"path","attr":{"d":"M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"}}]})(props);
	};
	module.exports.FaMeetup = function FaMeetup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"}}]})(props);
	};
	module.exports.FaMegaport = function FaMegaport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"}}]})(props);
	};
	module.exports.FaMendeley = function FaMendeley (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"}}]})(props);
	};
	module.exports.FaMicroblog = function FaMicroblog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"}}]})(props);
	};
	module.exports.FaMicrosoft = function FaMicrosoft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"}}]})(props);
	};
	module.exports.FaMix = function FaMix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"}}]})(props);
	};
	module.exports.FaMixcloud = function FaMixcloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M424.43 219.729C416.124 134.727 344.135 68 256.919 68c-72.266 0-136.224 46.516-159.205 114.074-54.545 8.029-96.63 54.822-96.63 111.582 0 62.298 50.668 112.966 113.243 112.966h289.614c52.329 0 94.969-42.362 94.969-94.693 0-45.131-32.118-83.063-74.48-92.2zm-20.489 144.53H114.327c-39.04 0-70.881-31.564-70.881-70.604s31.841-70.604 70.881-70.604c18.827 0 36.548 7.475 49.838 20.766 19.963 19.963 50.133-10.227 30.18-30.18-14.675-14.398-32.672-24.365-52.053-29.349 19.935-44.3 64.79-73.926 114.628-73.926 69.496 0 125.979 56.483 125.979 125.702 0 13.568-2.215 26.857-6.369 39.594-8.943 27.517 32.133 38.939 40.147 13.29 2.769-8.306 4.984-16.889 6.369-25.472 19.381 7.476 33.502 26.303 33.502 48.453 0 28.795-23.535 52.33-52.607 52.33zm235.069-52.33c0 44.024-12.737 86.386-37.102 122.657-4.153 6.092-10.798 9.414-17.72 9.414-16.317 0-27.127-18.826-17.443-32.949 19.381-29.349 29.903-63.682 29.903-99.122s-10.521-69.773-29.903-98.845c-15.655-22.831 19.361-47.24 35.163-23.534 24.366 35.993 37.102 78.356 37.102 122.379zm-70.88 0c0 31.565-9.137 62.021-26.857 88.325-4.153 6.091-10.798 9.136-17.72 9.136-17.201 0-27.022-18.979-17.443-32.948 13.013-19.104 19.658-41.255 19.658-64.513 0-22.981-6.645-45.408-19.658-64.512-15.761-22.986 19.008-47.095 35.163-23.535 17.719 26.026 26.857 56.483 26.857 88.047z"}}]})(props);
	};
	module.exports.FaMixer = function FaMixer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"}}]})(props);
	};
	module.exports.FaMizuni = function FaMizuni (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"}}]})(props);
	};
	module.exports.FaModx = function FaModx (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"}}]})(props);
	};
	module.exports.FaMonero = function FaMonero (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"}}]})(props);
	};
	module.exports.FaNapster = function FaNapster (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"}}]})(props);
	};
	module.exports.FaNeos = function FaNeos (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"}}]})(props);
	};
	module.exports.FaNimblr = function FaNimblr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"}}]})(props);
	};
	module.exports.FaNodeJs = function FaNodeJs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"}}]})(props);
	};
	module.exports.FaNode = function FaNode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"}}]})(props);
	};
	module.exports.FaNpm = function FaNpm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"}}]})(props);
	};
	module.exports.FaNs8 = function FaNs8 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"}}]})(props);
	};
	module.exports.FaNutritionix = function FaNutritionix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 400 512"},"child":[{"tag":"path","attr":{"d":"M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"}}]})(props);
	};
	module.exports.FaOctopusDeploy = function FaOctopusDeploy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"}}]})(props);
	};
	module.exports.FaOdnoklassnikiSquare = function FaOdnoklassnikiSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1zm174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37z"}}]})(props);
	};
	module.exports.FaOdnoklassniki = function FaOdnoklassniki (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"}}]})(props);
	};
	module.exports.FaOldRepublic = function FaOldRepublic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"}}]})(props);
	};
	module.exports.FaOpencart = function FaOpencart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"}}]})(props);
	};
	module.exports.FaOpenid = function FaOpenid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"}}]})(props);
	};
	module.exports.FaOpera = function FaOpera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"}}]})(props);
	};
	module.exports.FaOptinMonster = function FaOptinMonster (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"}}]})(props);
	};
	module.exports.FaOrcid = function FaOrcid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"}}]})(props);
	};
	module.exports.FaOsi = function FaOsi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"}}]})(props);
	};
	module.exports.FaPage4 = function FaPage4 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"}}]})(props);
	};
	module.exports.FaPagelines = function FaPagelines (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"}}]})(props);
	};
	module.exports.FaPalfed = function FaPalfed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"}}]})(props);
	};
	module.exports.FaPatreon = function FaPatreon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}}]})(props);
	};
	module.exports.FaPaypal = function FaPaypal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"}}]})(props);
	};
	module.exports.FaPennyArcade = function FaPennyArcade (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M421.91 164.27c-4.49 19.45-1.4 6.06-15.1 65.29l39.73-10.61c-22.34-49.61-17.29-38.41-24.63-54.68zm-206.09 51.11c-20.19 5.4-11.31 3.03-39.63 10.58l4.46 46.19c28.17-7.59 20.62-5.57 34.82-9.34 42.3-9.79 32.85-56.42.35-47.43zm326.16-26.19l-45.47-99.2c-5.69-12.37-19.46-18.84-32.62-15.33-70.27 18.75-38.72 10.32-135.59 36.23a27.618 27.618 0 0 0-18.89 17.41C144.26 113.27 0 153.75 0 226.67c0 33.5 30.67 67.11 80.9 95.37l1.74 17.88a27.891 27.891 0 0 0-17.77 28.67l4.3 44.48c1.39 14.31 13.43 25.21 27.8 25.2 5.18-.01-3.01 1.78 122.53-31.76 12.57-3.37 21.12-15.02 20.58-28.02 216.59 45.5 401.99-5.98 399.89-84.83.01-28.15-22.19-66.56-97.99-104.47zM255.14 298.3l-21.91 5.88-48.44 12.91 2.46 23.55 20.53-5.51 4.51 44.51-115.31 30.78-4.3-44.52 20.02-5.35-11.11-114.64-20.12 5.39-4.35-44.5c178.15-47.54 170.18-46.42 186.22-46.65 56.66-1.13 64.15 71.84 42.55 104.43a86.7 86.7 0 0 1-50.75 33.72zm199.18 16.62l-3.89-39.49 14.9-3.98-6.61-14.68-57.76 15.42-4.1 17.54 19.2-5.12 4.05 39.54-112.85 30.07-4.46-44.43 20.99-5.59 33.08-126.47-17.15 4.56-4.2-44.48c93.36-24.99 65.01-17.41 135.59-36.24l66.67 145.47 20.79-5.56 4.3 44.48-108.55 28.96z"}}]})(props);
	};
	module.exports.FaPerbyte = function FaPerbyte (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"}}]})(props);
	};
	module.exports.FaPeriscope = function FaPeriscope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"}}]})(props);
	};
	module.exports.FaPhabricator = function FaPhabricator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"}}]})(props);
	};
	module.exports.FaPhoenixFramework = function FaPhoenixFramework (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"}}]})(props);
	};
	module.exports.FaPhoenixSquadron = function FaPhoenixSquadron (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"}}]})(props);
	};
	module.exports.FaPhp = function FaPhp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"}}]})(props);
	};
	module.exports.FaPiedPiperAlt = function FaPiedPiperAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"}}]})(props);
	};
	module.exports.FaPiedPiperHat = function FaPiedPiperHat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"}}]})(props);
	};
	module.exports.FaPiedPiperPp = function FaPiedPiperPp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"}}]})(props);
	};
	module.exports.FaPiedPiperSquare = function FaPiedPiperSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"}}]})(props);
	};
	module.exports.FaPiedPiper = function FaPiedPiper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"}}]})(props);
	};
	module.exports.FaPinterestP = function FaPinterestP (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"}}]})(props);
	};
	module.exports.FaPinterestSquare = function FaPinterestSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"}}]})(props);
	};
	module.exports.FaPinterest = function FaPinterest (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}}]})(props);
	};
	module.exports.FaPlaystation = function FaPlaystation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"}}]})(props);
	};
	module.exports.FaProductHunt = function FaProductHunt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"}}]})(props);
	};
	module.exports.FaPushed = function FaPushed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 432 512"},"child":[{"tag":"path","attr":{"d":"M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"}}]})(props);
	};
	module.exports.FaPython = function FaPython (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"}}]})(props);
	};
	module.exports.FaQq = function FaQq (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"}}]})(props);
	};
	module.exports.FaQuinscape = function FaQuinscape (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"}}]})(props);
	};
	module.exports.FaQuora = function FaQuora (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"}}]})(props);
	};
	module.exports.FaRProject = function FaRProject (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 581 512"},"child":[{"tag":"path","attr":{"d":"M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"}}]})(props);
	};
	module.exports.FaRaspberryPi = function FaRaspberryPi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 407 512"},"child":[{"tag":"path","attr":{"d":"M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"}}]})(props);
	};
	module.exports.FaRavelry = function FaRavelry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"}}]})(props);
	};
	module.exports.FaReact = function FaReact (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"}}]})(props);
	};
	module.exports.FaReacteurope = function FaReacteurope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"}}]})(props);
	};
	module.exports.FaReadme = function FaReadme (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"}}]})(props);
	};
	module.exports.FaRebel = function FaRebel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"}}]})(props);
	};
	module.exports.FaRedRiver = function FaRedRiver (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"}}]})(props);
	};
	module.exports.FaRedditAlien = function FaRedditAlien (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"}}]})(props);
	};
	module.exports.FaRedditSquare = function FaRedditSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z"}}]})(props);
	};
	module.exports.FaReddit = function FaReddit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}}]})(props);
	};
	module.exports.FaRedhat = function FaRedhat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"}}]})(props);
	};
	module.exports.FaRenren = function FaRenren (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"}}]})(props);
	};
	module.exports.FaReplyd = function FaReplyd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"}}]})(props);
	};
	module.exports.FaResearchgate = function FaResearchgate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"}}]})(props);
	};
	module.exports.FaResolving = function FaResolving (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"}}]})(props);
	};
	module.exports.FaRev = function FaRev (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"}}]})(props);
	};
	module.exports.FaRocketchat = function FaRocketchat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"}}]})(props);
	};
	module.exports.FaRockrms = function FaRockrms (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"}}]})(props);
	};
	module.exports.FaRust = function FaRust (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"}}]})(props);
	};
	module.exports.FaSafari = function FaSafari (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"}}]})(props);
	};
	module.exports.FaSalesforce = function FaSalesforce (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"}}]})(props);
	};
	module.exports.FaSass = function FaSass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"}}]})(props);
	};
	module.exports.FaSchlix = function FaSchlix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"}}]})(props);
	};
	module.exports.FaScribd = function FaScribd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"}}]})(props);
	};
	module.exports.FaSearchengin = function FaSearchengin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 460 512"},"child":[{"tag":"path","attr":{"d":"M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"}}]})(props);
	};
	module.exports.FaSellcast = function FaSellcast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"}}]})(props);
	};
	module.exports.FaSellsy = function FaSellsy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"}}]})(props);
	};
	module.exports.FaServicestack = function FaServicestack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"}}]})(props);
	};
	module.exports.FaShirtsinbulk = function FaShirtsinbulk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"}}]})(props);
	};
	module.exports.FaShopify = function FaShopify (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"}}]})(props);
	};
	module.exports.FaShopware = function FaShopware (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"}}]})(props);
	};
	module.exports.FaSimplybuilt = function FaSimplybuilt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"}}]})(props);
	};
	module.exports.FaSistrix = function FaSistrix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"}}]})(props);
	};
	module.exports.FaSith = function FaSith (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"}}]})(props);
	};
	module.exports.FaSketch = function FaSketch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"}}]})(props);
	};
	module.exports.FaSkyatlas = function FaSkyatlas (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"}}]})(props);
	};
	module.exports.FaSkype = function FaSkype (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"}}]})(props);
	};
	module.exports.FaSlackHash = function FaSlackHash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M446.2 270.4c-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-30.3-90 45.4-15.1c19.1-6.2 29.1-26.8 23-45.9-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-93.4 31.2-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-45.3 15c-19.1 6.2-29.1 26.8-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l30.3 90L78 354.8c-19 6.2-29.1 26.9-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 93.6-31.3 15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 45.4-15.1c19-6 29.1-26.7 22.9-45.7zm-254.1 47.2l-30.3-90.2 93.5-31.3 30.3 90.2-93.5 31.3z"}}]})(props);
	};
	module.exports.FaSlack = function FaSlack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"}}]})(props);
	};
	module.exports.FaSlideshare = function FaSlideshare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"}}]})(props);
	};
	module.exports.FaSnapchatGhost = function FaSnapchatGhost (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.846 392.673c-5.211 12.157-27.239 21.089-67.36 27.318-2.064 2.786-3.775 14.686-6.507 23.956-1.625 5.566-5.623 8.869-12.128 8.869l-.297-.005c-9.395 0-19.203-4.323-38.852-4.323-26.521 0-35.662 6.043-56.254 20.588-21.832 15.438-42.771 28.764-74.027 27.399-31.646 2.334-58.025-16.908-72.871-27.404-20.714-14.643-29.828-20.582-56.241-20.582-18.864 0-30.736 4.72-38.852 4.72-8.073 0-11.213-4.922-12.422-9.04-2.703-9.189-4.404-21.263-6.523-24.13-20.679-3.209-67.31-11.344-68.498-32.15a10.627 10.627 0 0 1 8.877-11.069c69.583-11.455 100.924-82.901 102.227-85.934.074-.176.155-.344.237-.515 3.713-7.537 4.544-13.849 2.463-18.753-5.05-11.896-26.872-16.164-36.053-19.796-23.715-9.366-27.015-20.128-25.612-27.504 2.437-12.836 21.725-20.735 33.002-15.453 8.919 4.181 16.843 6.297 23.547 6.297 5.022 0 8.212-1.204 9.96-2.171-2.043-35.936-7.101-87.29 5.687-115.969C158.122 21.304 229.705 15.42 250.826 15.42c.944 0 9.141-.089 10.11-.089 52.148 0 102.254 26.78 126.723 81.643 12.777 28.65 7.749 79.792 5.695 116.009 1.582.872 4.357 1.942 8.599 2.139 6.397-.286 13.815-2.389 22.069-6.257 6.085-2.846 14.406-2.461 20.48.058l.029.01c9.476 3.385 15.439 10.215 15.589 17.87.184 9.747-8.522 18.165-25.878 25.018-2.118.835-4.694 1.655-7.434 2.525-9.797 3.106-24.6 7.805-28.616 17.271-2.079 4.904-1.256 11.211 2.46 18.748.087.168.166.342.239.515 1.301 3.03 32.615 74.46 102.23 85.934 6.427 1.058 11.163 7.877 7.725 15.859z"}}]})(props);
	};
	module.exports.FaSnapchatSquare = function FaSnapchatSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6.5 314.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C159.1 100 206.7 96 220.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"}}]})(props);
	};
	module.exports.FaSnapchat = function FaSnapchat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm169.5 338.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C183.1 100 230.7 96 244.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"}}]})(props);
	};
	module.exports.FaSoundcloud = function FaSoundcloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"}}]})(props);
	};
	module.exports.FaSourcetree = function FaSourcetree (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"}}]})(props);
	};
	module.exports.FaSpeakap = function FaSpeakap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"}}]})(props);
	};
	module.exports.FaSpeakerDeck = function FaSpeakerDeck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"}}]})(props);
	};
	module.exports.FaSpotify = function FaSpotify (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"}}]})(props);
	};
	module.exports.FaSquarespace = function FaSquarespace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"}}]})(props);
	};
	module.exports.FaStackExchange = function FaStackExchange (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"}}]})(props);
	};
	module.exports.FaStackOverflow = function FaStackOverflow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"}}]})(props);
	};
	module.exports.FaStackpath = function FaStackpath (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"}}]})(props);
	};
	module.exports.FaStaylinked = function FaStaylinked (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 440 512"},"child":[{"tag":"path","attr":{"d":"M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"}}]})(props);
	};
	module.exports.FaSteamSquare = function FaSteamSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3zm.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z"}}]})(props);
	};
	module.exports.FaSteamSymbol = function FaSteamSymbol (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"}}]})(props);
	};
	module.exports.FaSteam = function FaSteam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"}}]})(props);
	};
	module.exports.FaStickerMule = function FaStickerMule (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"}}]})(props);
	};
	module.exports.FaStrava = function FaStrava (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"}}]})(props);
	};
	module.exports.FaStripeS = function FaStripeS (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"}}]})(props);
	};
	module.exports.FaStripe = function FaStripe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"}}]})(props);
	};
	module.exports.FaStudiovinari = function FaStudiovinari (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"}}]})(props);
	};
	module.exports.FaStumbleuponCircle = function FaStumbleuponCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"}}]})(props);
	};
	module.exports.FaStumbleupon = function FaStumbleupon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"}}]})(props);
	};
	module.exports.FaSuperpowers = function FaSuperpowers (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"}}]})(props);
	};
	module.exports.FaSupple = function FaSupple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"}}]})(props);
	};
	module.exports.FaSuse = function FaSuse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z"}}]})(props);
	};
	module.exports.FaSwift = function FaSwift (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"}}]})(props);
	};
	module.exports.FaSymfony = function FaSymfony (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"}}]})(props);
	};
	module.exports.FaTeamspeak = function FaTeamspeak (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M244.2 346.79c2.4-12.3-12-30-32.4-48.7-20.9-19.2-48.2-39.1-63.4-46.6-21.7-12-41.7-1.8-46.3 22.7-5 26.2 0 51.4 14.5 73.9 10.2 15.5 25.4 22.7 43.4 24 11.6.6 52.5 2.2 61.7-1 11.9-4.3 20.1-11.8 22.5-24.3zm205 20.8a5.22 5.22 0 0 0-8.3 2.4c-8 25.4-44.7 112.5-172.1 121.5-149.7 10.5 80.3 43.6 145.4-6.4 22.7-17.4 47.6-35 46.6-85.4-.4-10.1-4.9-26.69-11.6-32.1zm62-122.4c-.3-18.9-8.6-33.4-26-42.2-2.9-1.3-5-2.7-5.9-6.4A222.64 222.64 0 0 0 438.9 103c-1.1-1.5-3.5-3.2-2.2-5 8.5-11.5-.3-18-7-24.4Q321.4-31.11 177.4 13.09c-40.1 12.3-73.9 35.6-102 67.4-4 4.3-6.7 9.1-3 14.5 3 4 1.3 6.2-1 9.3C51.6 132 38.2 162.59 32.1 196c-.7 4.3-2.9 6-6.4 7.8-14.2 7-22.5 18.5-24.9 34L0 264.29v20.9c0 30.8 21 50.4 51.8 49 7.7-.3 11.7-4.3 12-11.5 2-77.5-2.4-95.4 3.7-125.8C92.1 72.39 234.3 5 345.3 65.39 411.4 102 445.7 159 447.6 234.79c.8 28.2 0 56.5 0 84.6 0 7 2.2 12.5 9.4 14.2 24.1 5 49.2-12 53.2-36.7 2.9-17.1 1-34.5 1-51.7zm-159.6 131.5c36.5 2.8 59.3-28.5 58.4-60.5-2.1-45.2-66.2-16.5-87.8-8-73.2 28.1-45 54.9-22.2 60.8z"}}]})(props);
	};
	module.exports.FaTelegramPlane = function FaTelegramPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"}}]})(props);
	};
	module.exports.FaTelegram = function FaTelegram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"}}]})(props);
	};
	module.exports.FaTencentWeibo = function FaTencentWeibo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"}}]})(props);
	};
	module.exports.FaTheRedYeti = function FaTheRedYeti (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"}}]})(props);
	};
	module.exports.FaThemeco = function FaThemeco (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"}}]})(props);
	};
	module.exports.FaThemeisle = function FaThemeisle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"}}]})(props);
	};
	module.exports.FaThinkPeaks = function FaThinkPeaks (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"}}]})(props);
	};
	module.exports.FaTiktok = function FaTiktok (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}}]})(props);
	};
	module.exports.FaTradeFederation = function FaTradeFederation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"}}]})(props);
	};
	module.exports.FaTrello = function FaTrello (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"}}]})(props);
	};
	module.exports.FaTripadvisor = function FaTripadvisor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528.91,178.82,576,127.58H471.66a326.11,326.11,0,0,0-367,0H0l47.09,51.24A143.911,143.911,0,0,0,241.86,390.73L288,440.93l46.11-50.17A143.94,143.94,0,0,0,575.88,285.18h-.03A143.56,143.56,0,0,0,528.91,178.82ZM144.06,382.57a97.39,97.39,0,1,1,97.39-97.39A97.39,97.39,0,0,1,144.06,382.57ZM288,282.37c0-64.09-46.62-119.08-108.09-142.59a281,281,0,0,1,216.17,0C334.61,163.3,288,218.29,288,282.37Zm143.88,100.2h-.01a97.405,97.405,0,1,1,.01,0ZM144.06,234.12h-.01a51.06,51.06,0,1,0,51.06,51.06v-.11A51,51,0,0,0,144.06,234.12Zm287.82,0a51.06,51.06,0,1,0,51.06,51.06A51.06,51.06,0,0,0,431.88,234.12Z"}}]})(props);
	};
	module.exports.FaTumblrSquare = function FaTumblrSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z"}}]})(props);
	};
	module.exports.FaTumblr = function FaTumblr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}}]})(props);
	};
	module.exports.FaTwitch = function FaTwitch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}}]})(props);
	};
	module.exports.FaTwitterSquare = function FaTwitterSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"}}]})(props);
	};
	module.exports.FaTwitter = function FaTwitter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"}}]})(props);
	};
	module.exports.FaTypo3 = function FaTypo3 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"}}]})(props);
	};
	module.exports.FaUber = function FaUber (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"}}]})(props);
	};
	module.exports.FaUbuntu = function FaUbuntu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"}}]})(props);
	};
	module.exports.FaUikit = function FaUikit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"}}]})(props);
	};
	module.exports.FaUmbraco = function FaUmbraco (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 510 512"},"child":[{"tag":"path","attr":{"d":"M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"}}]})(props);
	};
	module.exports.FaUncharted = function FaUncharted (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"}}]})(props);
	};
	module.exports.FaUniregistry = function FaUniregistry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"}}]})(props);
	};
	module.exports.FaUnity = function FaUnity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M498.11,206.4,445.31,14.72,248.2,66.08,219,116.14l-59.2-.43L15.54,256,159.82,396.32l59.17-.43,29.24,50,197.08,51.36,52.8-191.62-30-49.63ZM223.77,124.2,374.55,86.51,288,232.33H114.87Zm0,263.63L114.87,279.71H288l86.55,145.81Zm193,14L330.17,256l86.58-145.84L458.56,256Z"}}]})(props);
	};
	module.exports.FaUnsplash = function FaUnsplash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"}}]})(props);
	};
	module.exports.FaUntappd = function FaUntappd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"}}]})(props);
	};
	module.exports.FaUps = function FaUps (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"}}]})(props);
	};
	module.exports.FaUsb = function FaUsb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"}}]})(props);
	};
	module.exports.FaUsps = function FaUsps (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"}}]})(props);
	};
	module.exports.FaUssunnah = function FaUssunnah (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M156.8 285.1l5.7 14.4h-8.2c-1.3-3.2-3.1-7.7-3.8-9.5-2.5-6.3-1.1-8.4 0-10 1.9-2.7 3.2-4.4 3.6-5.2 0 2.2.8 5.7 2.7 10.3zm297.3 18.8c-2.1 13.8-5.7 27.1-10.5 39.7l43 23.4-44.8-18.8c-5.3 13.2-12 25.6-19.9 37.2l34.2 30.2-36.8-26.4c-8.4 11.8-18 22.6-28.7 32.3l24.9 34.7-28.1-31.8c-11 9.6-23.1 18-36.1 25.1l15.7 37.2-19.3-35.3c-13.1 6.8-27 12.1-41.6 15.9l6.7 38.4-10.5-37.4c-14.3 3.4-29.2 5.3-44.5 5.4L256 512l-1.9-38.4c-15.3-.1-30.2-2-44.5-5.3L199 505.6l6.7-38.2c-14.6-3.7-28.6-9.1-41.7-15.8l-19.2 35.1 15.6-37c-13-7-25.2-15.4-36.2-25.1l-27.9 31.6 24.7-34.4c-10.7-9.7-20.4-20.5-28.8-32.3l-36.5 26.2 33.9-29.9c-7.9-11.6-14.6-24.1-20-37.3l-44.4 18.7L67.8 344c-4.8-12.7-8.4-26.1-10.5-39.9l-51 9 50.3-14.2c-1.1-8.5-1.7-17.1-1.7-25.9 0-4.7.2-9.4.5-14.1L0 256l56-2.8c1.3-13.1 3.8-25.8 7.5-38.1L6.4 199l58.9 10.4c4-12 9.1-23.5 15.2-34.4l-55.1-30 58.3 24.6C90 159 97.2 149.2 105.3 140L55.8 96.4l53.9 38.7c8.1-8.6 17-16.5 26.6-23.6l-40-55.6 45.6 51.6c9.5-6.6 19.7-12.3 30.3-17.2l-27.3-64.9 33.8 62.1c10.5-4.4 21.4-7.9 32.7-10.4L199 6.4l19.5 69.2c11-2.1 22.3-3.2 33.8-3.4L256 0l3.6 72.2c11.5.2 22.8 1.4 33.8 3.5L313 6.4l-12.4 70.7c11.3 2.6 22.2 6.1 32.6 10.5l33.9-62.2-27.4 65.1c10.6 4.9 20.7 10.7 30.2 17.2l45.8-51.8-40.1 55.9c9.5 7.1 18.4 15 26.5 23.6l54.2-38.9-49.7 43.9c8 9.1 15.2 18.9 21.5 29.4l58.7-24.7-55.5 30.2c6.1 10.9 11.1 22.3 15.1 34.3l59.3-10.4-57.5 16.2c3.7 12.2 6.2 24.9 7.5 37.9L512 256l-56 2.8c.3 4.6.5 9.3.5 14.1 0 8.7-.6 17.3-1.6 25.8l50.7 14.3-51.5-9.1zm-21.8-31c0-97.5-79-176.5-176.5-176.5s-176.5 79-176.5 176.5 79 176.5 176.5 176.5 176.5-79 176.5-176.5zm-24 0c0 84.3-68.3 152.6-152.6 152.6s-152.6-68.3-152.6-152.6 68.3-152.6 152.6-152.6 152.6 68.3 152.6 152.6zM195 241c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-40.7-19c0 2.1 1.3 3.8 3.6 5.1 3.5 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-19 0c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.4 6.8-9.6 10.9-9.6 12.6zm204.9 87.9c-8.4-3-8.7-6.8-8.7-15.6V182c-8.2 12.5-14.2 18.6-18 18.6 6.3 14.4 9.5 23.9 9.5 28.3v64.3c0 2.2-2.2 6.5-4.7 6.5h-18c-2.8-7.5-10.2-26.9-15.3-40.3-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3 2.6 6.7 6.4 16.5 7.9 20.2h-9.2c-3.9-10.4-9.6-25.4-11.8-31.1-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3.8 2 2.8 7.3 4.3 10.9H256c-1.5-4.1-5.6-14.6-8.4-22-2 2.5-7.2 9.2-10.7 13.7 2.5 1.6 4.3 3.6 5.2 6.3.2.6.5 1.4.6 1.7H225c-4.6-13.9-11.4-27.7-11.4-34.1 0-2.2.3-5.1 1.1-8.2-8.8 10.8-14 15.9-14 25 0 7.5 10.4 28.3 10.4 33.3 0 1.7-.5 3.3-1.4 4.9-9.6-12.7-15.5-20.7-18.8-20.7h-12l-11.2-28c-3.8-9.6-5.7-16-5.7-18.8 0-3.8.5-7.7 1.7-12.2-1 1.3-3.7 4.7-5.5 7.1-.8-2.1-3.1-7.7-4.6-11.5-2.1 2.5-7.5 9.1-11.2 13.6.9 2.3 3.3 8.1 4.9 12.2-2.5 3.3-9.1 11.8-13.6 17.7-4 5.3-5.8 13.3-2.7 21.8 2.5 6.7 2 7.9-1.7 14.1H191c5.5 0 14.3 14 15.5 22 13.2-16 15.4-19.6 16.8-21.6h107c3.9 0 7.2-1.9 9.9-5.8zm20.1-26.6V181.7c-9 12.5-15.9 18.6-20.7 18.6 7.1 14.4 10.7 23.9 10.7 28.3v66.3c0 17.5 8.6 20.4 24 20.4 8.1 0 12.5-.8 13.7-2.7-4.3-1.6-7.6-2.5-9.9-3.3-8.1-3.2-17.8-7.4-17.8-26z"}}]})(props);
	};
	module.exports.FaVaadin = function FaVaadin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"}}]})(props);
	};
	module.exports.FaViacoin = function FaViacoin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"}}]})(props);
	};
	module.exports.FaViadeoSquare = function FaViadeoSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z"}}]})(props);
	};
	module.exports.FaViadeo = function FaViadeo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"}}]})(props);
	};
	module.exports.FaViber = function FaViber (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"}}]})(props);
	};
	module.exports.FaVimeoSquare = function FaVimeoSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z"}}]})(props);
	};
	module.exports.FaVimeoV = function FaVimeoV (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"}}]})(props);
	};
	module.exports.FaVimeo = function FaVimeo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}}]})(props);
	};
	module.exports.FaVine = function FaVine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"}}]})(props);
	};
	module.exports.FaVk = function FaVk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M545 117.7c3.7-12.5 0-21.7-17.8-21.7h-58.9c-15 0-21.9 7.9-25.6 16.7 0 0-30 73.1-72.4 120.5-13.7 13.7-20 18.1-27.5 18.1-3.7 0-9.4-4.4-9.4-16.9V117.7c0-15-4.2-21.7-16.6-21.7h-92.6c-9.4 0-15 7-15 13.5 0 14.2 21.2 17.5 23.4 57.5v86.8c0 19-3.4 22.5-10.9 22.5-20 0-68.6-73.4-97.4-157.4-5.8-16.3-11.5-22.9-26.6-22.9H38.8c-16.8 0-20.2 7.9-20.2 16.7 0 15.6 20 93.1 93.1 195.5C160.4 378.1 229 416 291.4 416c37.5 0 42.1-8.4 42.1-22.9 0-66.8-3.4-73.1 15.4-73.1 8.7 0 23.7 4.4 58.7 38.1 40 40 46.6 57.9 69 57.9h58.9c16.8 0 25.3-8.4 20.4-25-11.2-34.9-86.9-106.7-90.3-111.5-8.7-11.2-6.2-16.2 0-26.2.1-.1 72-101.3 79.4-135.6z"}}]})(props);
	};
	module.exports.FaVnv = function FaVnv (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"}}]})(props);
	};
	module.exports.FaVuejs = function FaVuejs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"}}]})(props);
	};
	module.exports.FaWatchmanMonitoring = function FaWatchmanMonitoring (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"}}]})(props);
	};
	module.exports.FaWaze = function FaWaze (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"}}]})(props);
	};
	module.exports.FaWeebly = function FaWeebly (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"}}]})(props);
	};
	module.exports.FaWeibo = function FaWeibo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}}]})(props);
	};
	module.exports.FaWeixin = function FaWeixin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"}}]})(props);
	};
	module.exports.FaWhatsappSquare = function FaWhatsappSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"}}]})(props);
	};
	module.exports.FaWhatsapp = function FaWhatsapp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}}]})(props);
	};
	module.exports.FaWhmcs = function FaWhmcs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"}}]})(props);
	};
	module.exports.FaWikipediaW = function FaWikipediaW (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"}}]})(props);
	};
	module.exports.FaWindows = function FaWindows (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"}}]})(props);
	};
	module.exports.FaWix = function FaWix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"}}]})(props);
	};
	module.exports.FaWizardsOfTheCoast = function FaWizardsOfTheCoast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"}}]})(props);
	};
	module.exports.FaWodu = function FaWodu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"}}]})(props);
	};
	module.exports.FaWolfPackBattalion = function FaWolfPackBattalion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"}}]})(props);
	};
	module.exports.FaWordpressSimple = function FaWordpressSimple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"}}]})(props);
	};
	module.exports.FaWordpress = function FaWordpress (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"}}]})(props);
	};
	module.exports.FaWpbeginner = function FaWpbeginner (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"}}]})(props);
	};
	module.exports.FaWpexplorer = function FaWpexplorer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"}}]})(props);
	};
	module.exports.FaWpforms = function FaWpforms (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"}}]})(props);
	};
	module.exports.FaWpressr = function FaWpressr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"}}]})(props);
	};
	module.exports.FaXbox = function FaXbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"}}]})(props);
	};
	module.exports.FaXingSquare = function FaXingSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"}}]})(props);
	};
	module.exports.FaXing = function FaXing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"}}]})(props);
	};
	module.exports.FaYCombinator = function FaYCombinator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"}}]})(props);
	};
	module.exports.FaYahoo = function FaYahoo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"}}]})(props);
	};
	module.exports.FaYammer = function FaYammer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M421.78 152.17A23.06 23.06 0 0 0 400.9 112c-.83.43-1.71.9-2.63 1.4-15.25 8.4-118.33 80.62-106.69 88.77s82.04-23.61 130.2-50zm0 217.17c-48.16-26.38-118.64-58.1-130.2-50s91.42 80.35 106.69 88.74c.92.51 1.8 1 2.63 1.41a23.07 23.07 0 0 0 20.88-40.15zM464.21 237c-.95 0-1.95-.06-3-.06-17.4 0-142.52 13.76-136.24 26.51s83.3 18.74 138.21 18.76a23 23 0 0 0 1-45.21zM31 96.65a24.88 24.88 0 0 1 46.14-18.4l81 205.06h1.21l77-203.53a23.52 23.52 0 0 1 44.45 15.27L171.2 368.44C152.65 415.66 134.08 448 77.91 448a139.67 139.67 0 0 1-23.81-1.95 21.31 21.31 0 0 1 6.9-41.77c.66.06 10.91.66 13.86.66 30.47 0 43.74-18.94 58.07-59.41z"}}]})(props);
	};
	module.exports.FaYandexInternational = function FaYandexInternational (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"}}]})(props);
	};
	module.exports.FaYandex = function FaYandex (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"}}]})(props);
	};
	module.exports.FaYarn = function FaYarn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"}}]})(props);
	};
	module.exports.FaYelp = function FaYelp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"}}]})(props);
	};
	module.exports.FaYoast = function FaYoast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"}}]})(props);
	};
	module.exports.FaYoutubeSquare = function FaYoutubeSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"}}]})(props);
	};
	module.exports.FaYoutube = function FaYoutube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}}]})(props);
	};
	module.exports.FaZhihu = function FaZhihu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"}}]})(props);
	};
	module.exports.FaAd = function FaAd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"}}]})(props);
	};
	module.exports.FaAddressBook = function FaAddressBook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"}}]})(props);
	};
	module.exports.FaAddressCard = function FaAddressCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"}}]})(props);
	};
	module.exports.FaAdjust = function FaAdjust (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"}}]})(props);
	};
	module.exports.FaAirFreshener = function FaAirFreshener (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"}}]})(props);
	};
	module.exports.FaAlignCenter = function FaAlignCenter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"}}]})(props);
	};
	module.exports.FaAlignJustify = function FaAlignJustify (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaAlignLeft = function FaAlignLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaAlignRight = function FaAlignRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"}}]})(props);
	};
	module.exports.FaAllergies = function FaAllergies (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}}]})(props);
	};
	module.exports.FaAmbulance = function FaAmbulance (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"}}]})(props);
	};
	module.exports.FaAmericanSignLanguageInterpreting = function FaAmericanSignLanguageInterpreting (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"}}]})(props);
	};
	module.exports.FaAnchor = function FaAnchor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"}}]})(props);
	};
	module.exports.FaAngleDoubleDown = function FaAngleDoubleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"}}]})(props);
	};
	module.exports.FaAngleDoubleLeft = function FaAngleDoubleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"}}]})(props);
	};
	module.exports.FaAngleDoubleRight = function FaAngleDoubleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"}}]})(props);
	};
	module.exports.FaAngleDoubleUp = function FaAngleDoubleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"}}]})(props);
	};
	module.exports.FaAngleDown = function FaAngleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"}}]})(props);
	};
	module.exports.FaAngleLeft = function FaAngleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"}}]})(props);
	};
	module.exports.FaAngleRight = function FaAngleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"}}]})(props);
	};
	module.exports.FaAngleUp = function FaAngleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"}}]})(props);
	};
	module.exports.FaAngry = function FaAngry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"}}]})(props);
	};
	module.exports.FaAnkh = function FaAnkh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"}}]})(props);
	};
	module.exports.FaAppleAlt = function FaAppleAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"}}]})(props);
	};
	module.exports.FaArchive = function FaArchive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaArchway = function FaArchway (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaArrowAltCircleDown = function FaArrowAltCircleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"}}]})(props);
	};
	module.exports.FaArrowAltCircleLeft = function FaArrowAltCircleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"}}]})(props);
	};
	module.exports.FaArrowAltCircleRight = function FaArrowAltCircleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"}}]})(props);
	};
	module.exports.FaArrowAltCircleUp = function FaArrowAltCircleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"}}]})(props);
	};
	module.exports.FaArrowCircleDown = function FaArrowCircleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"}}]})(props);
	};
	module.exports.FaArrowCircleLeft = function FaArrowCircleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"}}]})(props);
	};
	module.exports.FaArrowCircleRight = function FaArrowCircleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"}}]})(props);
	};
	module.exports.FaArrowCircleUp = function FaArrowCircleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"}}]})(props);
	};
	module.exports.FaArrowDown = function FaArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"}}]})(props);
	};
	module.exports.FaArrowLeft = function FaArrowLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"}}]})(props);
	};
	module.exports.FaArrowRight = function FaArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"}}]})(props);
	};
	module.exports.FaArrowUp = function FaArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"}}]})(props);
	};
	module.exports.FaArrowsAltH = function FaArrowsAltH (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"}}]})(props);
	};
	module.exports.FaArrowsAltV = function FaArrowsAltV (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"}}]})(props);
	};
	module.exports.FaArrowsAlt = function FaArrowsAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"}}]})(props);
	};
	module.exports.FaAssistiveListeningSystems = function FaAssistiveListeningSystems (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"}}]})(props);
	};
	module.exports.FaAsterisk = function FaAsterisk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"}}]})(props);
	};
	module.exports.FaAt = function FaAt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"}}]})(props);
	};
	module.exports.FaAtlas = function FaAtlas (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"}}]})(props);
	};
	module.exports.FaAtom = function FaAtom (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"}}]})(props);
	};
	module.exports.FaAudioDescription = function FaAudioDescription (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"}}]})(props);
	};
	module.exports.FaAward = function FaAward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"}}]})(props);
	};
	module.exports.FaBabyCarriage = function FaBabyCarriage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"}}]})(props);
	};
	module.exports.FaBaby = function FaBaby (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"}}]})(props);
	};
	module.exports.FaBackspace = function FaBackspace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"}}]})(props);
	};
	module.exports.FaBackward = function FaBackward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"}}]})(props);
	};
	module.exports.FaBacon = function FaBacon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"}}]})(props);
	};
	module.exports.FaBacteria = function FaBacteria (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"}}]})(props);
	};
	module.exports.FaBacterium = function FaBacterium (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"}}]})(props);
	};
	module.exports.FaBahai = function FaBahai (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"}}]})(props);
	};
	module.exports.FaBalanceScaleLeft = function FaBalanceScaleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"}}]})(props);
	};
	module.exports.FaBalanceScaleRight = function FaBalanceScaleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"}}]})(props);
	};
	module.exports.FaBalanceScale = function FaBalanceScale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaBan = function FaBan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"}}]})(props);
	};
	module.exports.FaBandAid = function FaBandAid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaBarcode = function FaBarcode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"}}]})(props);
	};
	module.exports.FaBars = function FaBars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"}}]})(props);
	};
	module.exports.FaBaseballBall = function FaBaseballBall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"}}]})(props);
	};
	module.exports.FaBasketballBall = function FaBasketballBall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"}}]})(props);
	};
	module.exports.FaBath = function FaBath (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"}}]})(props);
	};
	module.exports.FaBatteryEmpty = function FaBatteryEmpty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"}}]})(props);
	};
	module.exports.FaBatteryFull = function FaBatteryFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"}}]})(props);
	};
	module.exports.FaBatteryHalf = function FaBatteryHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"}}]})(props);
	};
	module.exports.FaBatteryQuarter = function FaBatteryQuarter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"}}]})(props);
	};
	module.exports.FaBatteryThreeQuarters = function FaBatteryThreeQuarters (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"}}]})(props);
	};
	module.exports.FaBed = function FaBed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"}}]})(props);
	};
	module.exports.FaBeer = function FaBeer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"}}]})(props);
	};
	module.exports.FaBellSlash = function FaBellSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"}}]})(props);
	};
	module.exports.FaBell = function FaBell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"}}]})(props);
	};
	module.exports.FaBezierCurve = function FaBezierCurve (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaBible = function FaBible (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"}}]})(props);
	};
	module.exports.FaBicycle = function FaBicycle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"}}]})(props);
	};
	module.exports.FaBiking = function FaBiking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"}}]})(props);
	};
	module.exports.FaBinoculars = function FaBinoculars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"}}]})(props);
	};
	module.exports.FaBiohazard = function FaBiohazard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"}}]})(props);
	};
	module.exports.FaBirthdayCake = function FaBirthdayCake (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"}}]})(props);
	};
	module.exports.FaBlenderPhone = function FaBlenderPhone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaBlender = function FaBlender (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"}}]})(props);
	};
	module.exports.FaBlind = function FaBlind (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"}}]})(props);
	};
	module.exports.FaBlog = function FaBlog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"}}]})(props);
	};
	module.exports.FaBold = function FaBold (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"}}]})(props);
	};
	module.exports.FaBolt = function FaBolt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"}}]})(props);
	};
	module.exports.FaBomb = function FaBomb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"}}]})(props);
	};
	module.exports.FaBone = function FaBone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"}}]})(props);
	};
	module.exports.FaBong = function FaBong (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"}}]})(props);
	};
	module.exports.FaBookDead = function FaBookDead (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"}}]})(props);
	};
	module.exports.FaBookMedical = function FaBookMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"}}]})(props);
	};
	module.exports.FaBookOpen = function FaBookOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"}}]})(props);
	};
	module.exports.FaBookReader = function FaBookReader (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"}}]})(props);
	};
	module.exports.FaBook = function FaBook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"}}]})(props);
	};
	module.exports.FaBookmark = function FaBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"}}]})(props);
	};
	module.exports.FaBorderAll = function FaBorderAll (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"}}]})(props);
	};
	module.exports.FaBorderNone = function FaBorderNone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaBorderStyle = function FaBorderStyle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaBowlingBall = function FaBowlingBall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaBoxOpen = function FaBoxOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"}}]})(props);
	};
	module.exports.FaBoxTissue = function FaBoxTissue (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"}}]})(props);
	};
	module.exports.FaBox = function FaBox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"}}]})(props);
	};
	module.exports.FaBoxes = function FaBoxes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaBraille = function FaBraille (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"}}]})(props);
	};
	module.exports.FaBrain = function FaBrain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"}}]})(props);
	};
	module.exports.FaBreadSlice = function FaBreadSlice (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"}}]})(props);
	};
	module.exports.FaBriefcaseMedical = function FaBriefcaseMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"}}]})(props);
	};
	module.exports.FaBriefcase = function FaBriefcase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"}}]})(props);
	};
	module.exports.FaBroadcastTower = function FaBroadcastTower (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"}}]})(props);
	};
	module.exports.FaBroom = function FaBroom (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"}}]})(props);
	};
	module.exports.FaBrush = function FaBrush (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"}}]})(props);
	};
	module.exports.FaBug = function FaBug (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"}}]})(props);
	};
	module.exports.FaBuilding = function FaBuilding (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"}}]})(props);
	};
	module.exports.FaBullhorn = function FaBullhorn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"}}]})(props);
	};
	module.exports.FaBullseye = function FaBullseye (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"}}]})(props);
	};
	module.exports.FaBurn = function FaBurn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"}}]})(props);
	};
	module.exports.FaBusAlt = function FaBusAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaBus = function FaBus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaBusinessTime = function FaBusinessTime (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"}}]})(props);
	};
	module.exports.FaCalculator = function FaCalculator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"}}]})(props);
	};
	module.exports.FaCalendarAlt = function FaCalendarAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaCalendarCheck = function FaCalendarCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"}}]})(props);
	};
	module.exports.FaCalendarDay = function FaCalendarDay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaCalendarMinus = function FaCalendarMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"}}]})(props);
	};
	module.exports.FaCalendarPlus = function FaCalendarPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"}}]})(props);
	};
	module.exports.FaCalendarTimes = function FaCalendarTimes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"}}]})(props);
	};
	module.exports.FaCalendarWeek = function FaCalendarWeek (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaCalendar = function FaCalendar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"}}]})(props);
	};
	module.exports.FaCameraRetro = function FaCameraRetro (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"}}]})(props);
	};
	module.exports.FaCamera = function FaCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"}}]})(props);
	};
	module.exports.FaCampground = function FaCampground (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"}}]})(props);
	};
	module.exports.FaCandyCane = function FaCandyCane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"}}]})(props);
	};
	module.exports.FaCannabis = function FaCannabis (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"}}]})(props);
	};
	module.exports.FaCapsules = function FaCapsules (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"}}]})(props);
	};
	module.exports.FaCarAlt = function FaCarAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"}}]})(props);
	};
	module.exports.FaCarBattery = function FaCarBattery (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"}}]})(props);
	};
	module.exports.FaCarCrash = function FaCarCrash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"}}]})(props);
	};
	module.exports.FaCarSide = function FaCarSide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"}}]})(props);
	};
	module.exports.FaCar = function FaCar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"}}]})(props);
	};
	module.exports.FaCaravan = function FaCaravan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"}}]})(props);
	};
	module.exports.FaCaretDown = function FaCaretDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"}}]})(props);
	};
	module.exports.FaCaretLeft = function FaCaretLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"}}]})(props);
	};
	module.exports.FaCaretRight = function FaCaretRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"}}]})(props);
	};
	module.exports.FaCaretSquareDown = function FaCaretSquareDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"}}]})(props);
	};
	module.exports.FaCaretSquareLeft = function FaCaretSquareLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"}}]})(props);
	};
	module.exports.FaCaretSquareRight = function FaCaretSquareRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"}}]})(props);
	};
	module.exports.FaCaretSquareUp = function FaCaretSquareUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"}}]})(props);
	};
	module.exports.FaCaretUp = function FaCaretUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"}}]})(props);
	};
	module.exports.FaCarrot = function FaCarrot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"}}]})(props);
	};
	module.exports.FaCartArrowDown = function FaCartArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"}}]})(props);
	};
	module.exports.FaCartPlus = function FaCartPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"}}]})(props);
	};
	module.exports.FaCashRegister = function FaCashRegister (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"}}]})(props);
	};
	module.exports.FaCat = function FaCat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"}}]})(props);
	};
	module.exports.FaCertificate = function FaCertificate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"}}]})(props);
	};
	module.exports.FaChair = function FaChair (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"}}]})(props);
	};
	module.exports.FaChalkboardTeacher = function FaChalkboardTeacher (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"}}]})(props);
	};
	module.exports.FaChalkboard = function FaChalkboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaChargingStation = function FaChargingStation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"}}]})(props);
	};
	module.exports.FaChartArea = function FaChartArea (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"}}]})(props);
	};
	module.exports.FaChartBar = function FaChartBar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaChartLine = function FaChartLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"}}]})(props);
	};
	module.exports.FaChartPie = function FaChartPie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 544 512"},"child":[{"tag":"path","attr":{"d":"M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"}}]})(props);
	};
	module.exports.FaCheckCircle = function FaCheckCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"}}]})(props);
	};
	module.exports.FaCheckDouble = function FaCheckDouble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"}}]})(props);
	};
	module.exports.FaCheckSquare = function FaCheckSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"}}]})(props);
	};
	module.exports.FaCheck = function FaCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"}}]})(props);
	};
	module.exports.FaCheese = function FaCheese (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"}}]})(props);
	};
	module.exports.FaChessBishop = function FaChessBishop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaChessBoard = function FaChessBoard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"}}]})(props);
	};
	module.exports.FaChessKing = function FaChessKing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"}}]})(props);
	};
	module.exports.FaChessKnight = function FaChessKnight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaChessPawn = function FaChessPawn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaChessQueen = function FaChessQueen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"}}]})(props);
	};
	module.exports.FaChessRook = function FaChessRook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaChess = function FaChess (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"}}]})(props);
	};
	module.exports.FaChevronCircleDown = function FaChevronCircleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"}}]})(props);
	};
	module.exports.FaChevronCircleLeft = function FaChevronCircleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"}}]})(props);
	};
	module.exports.FaChevronCircleRight = function FaChevronCircleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"}}]})(props);
	};
	module.exports.FaChevronCircleUp = function FaChevronCircleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"}}]})(props);
	};
	module.exports.FaChevronDown = function FaChevronDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"}}]})(props);
	};
	module.exports.FaChevronLeft = function FaChevronLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"}}]})(props);
	};
	module.exports.FaChevronRight = function FaChevronRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"}}]})(props);
	};
	module.exports.FaChevronUp = function FaChevronUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"}}]})(props);
	};
	module.exports.FaChild = function FaChild (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"}}]})(props);
	};
	module.exports.FaChurch = function FaChurch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"}}]})(props);
	};
	module.exports.FaCircleNotch = function FaCircleNotch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"}}]})(props);
	};
	module.exports.FaCircle = function FaCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"}}]})(props);
	};
	module.exports.FaCity = function FaCity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"}}]})(props);
	};
	module.exports.FaClinicMedical = function FaClinicMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"}}]})(props);
	};
	module.exports.FaClipboardCheck = function FaClipboardCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"}}]})(props);
	};
	module.exports.FaClipboardList = function FaClipboardList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"}}]})(props);
	};
	module.exports.FaClipboard = function FaClipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"}}]})(props);
	};
	module.exports.FaClock = function FaClock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"}}]})(props);
	};
	module.exports.FaClone = function FaClone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"}}]})(props);
	};
	module.exports.FaClosedCaptioning = function FaClosedCaptioning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"}}]})(props);
	};
	module.exports.FaCloudDownloadAlt = function FaCloudDownloadAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"}}]})(props);
	};
	module.exports.FaCloudMeatball = function FaCloudMeatball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"}}]})(props);
	};
	module.exports.FaCloudMoonRain = function FaCloudMoonRain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"}}]})(props);
	};
	module.exports.FaCloudMoon = function FaCloudMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"}}]})(props);
	};
	module.exports.FaCloudRain = function FaCloudRain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"}}]})(props);
	};
	module.exports.FaCloudShowersHeavy = function FaCloudShowersHeavy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"}}]})(props);
	};
	module.exports.FaCloudSunRain = function FaCloudSunRain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"}}]})(props);
	};
	module.exports.FaCloudSun = function FaCloudSun (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"}}]})(props);
	};
	module.exports.FaCloudUploadAlt = function FaCloudUploadAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"}}]})(props);
	};
	module.exports.FaCloud = function FaCloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"}}]})(props);
	};
	module.exports.FaCocktail = function FaCocktail (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"}}]})(props);
	};
	module.exports.FaCodeBranch = function FaCodeBranch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaCode = function FaCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"}}]})(props);
	};
	module.exports.FaCoffee = function FaCoffee (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"}}]})(props);
	};
	module.exports.FaCog = function FaCog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
	};
	module.exports.FaCogs = function FaCogs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"}}]})(props);
	};
	module.exports.FaCoins = function FaCoins (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"}}]})(props);
	};
	module.exports.FaColumns = function FaColumns (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"}}]})(props);
	};
	module.exports.FaCommentAlt = function FaCommentAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"}}]})(props);
	};
	module.exports.FaCommentDollar = function FaCommentDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"}}]})(props);
	};
	module.exports.FaCommentDots = function FaCommentDots (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaCommentMedical = function FaCommentMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"}}]})(props);
	};
	module.exports.FaCommentSlash = function FaCommentSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"}}]})(props);
	};
	module.exports.FaComment = function FaComment (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"}}]})(props);
	};
	module.exports.FaCommentsDollar = function FaCommentsDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"}}]})(props);
	};
	module.exports.FaComments = function FaComments (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"}}]})(props);
	};
	module.exports.FaCompactDisc = function FaCompactDisc (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaCompass = function FaCompass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"}}]})(props);
	};
	module.exports.FaCompressAlt = function FaCompressAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"}}]})(props);
	};
	module.exports.FaCompressArrowsAlt = function FaCompressArrowsAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"}}]})(props);
	};
	module.exports.FaCompress = function FaCompress (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"}}]})(props);
	};
	module.exports.FaConciergeBell = function FaConciergeBell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaCookieBite = function FaCookieBite (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaCookie = function FaCookie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaCopy = function FaCopy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"}}]})(props);
	};
	module.exports.FaCopyright = function FaCopyright (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"}}]})(props);
	};
	module.exports.FaCouch = function FaCouch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"}}]})(props);
	};
	module.exports.FaCreditCard = function FaCreditCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"}}]})(props);
	};
	module.exports.FaCropAlt = function FaCropAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"}}]})(props);
	};
	module.exports.FaCrop = function FaCrop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"}}]})(props);
	};
	module.exports.FaCross = function FaCross (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaCrosshairs = function FaCrosshairs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"}}]})(props);
	};
	module.exports.FaCrow = function FaCrow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"}}]})(props);
	};
	module.exports.FaCrown = function FaCrown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaCrutch = function FaCrutch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"}}]})(props);
	};
	module.exports.FaCube = function FaCube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"}}]})(props);
	};
	module.exports.FaCubes = function FaCubes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"}}]})(props);
	};
	module.exports.FaCut = function FaCut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"}}]})(props);
	};
	module.exports.FaDatabase = function FaDatabase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"}}]})(props);
	};
	module.exports.FaDeaf = function FaDeaf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"}}]})(props);
	};
	module.exports.FaDemocrat = function FaDemocrat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"}}]})(props);
	};
	module.exports.FaDesktop = function FaDesktop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"}}]})(props);
	};
	module.exports.FaDharmachakra = function FaDharmachakra (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"}}]})(props);
	};
	module.exports.FaDiagnoses = function FaDiagnoses (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaDiceD20 = function FaDiceD20 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"}}]})(props);
	};
	module.exports.FaDiceD6 = function FaDiceD6 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"}}]})(props);
	};
	module.exports.FaDiceFive = function FaDiceFive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaDiceFour = function FaDiceFour (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaDiceOne = function FaDiceOne (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaDiceSix = function FaDiceSix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaDiceThree = function FaDiceThree (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaDiceTwo = function FaDiceTwo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaDice = function FaDice (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"}}]})(props);
	};
	module.exports.FaDigitalTachograph = function FaDigitalTachograph (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"}}]})(props);
	};
	module.exports.FaDirections = function FaDirections (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"}}]})(props);
	};
	module.exports.FaDisease = function FaDisease (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"}}]})(props);
	};
	module.exports.FaDivide = function FaDivide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaDizzy = function FaDizzy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"}}]})(props);
	};
	module.exports.FaDna = function FaDna (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"}}]})(props);
	};
	module.exports.FaDog = function FaDog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"}}]})(props);
	};
	module.exports.FaDollarSign = function FaDollarSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"}}]})(props);
	};
	module.exports.FaDollyFlatbed = function FaDollyFlatbed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaDolly = function FaDolly (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"}}]})(props);
	};
	module.exports.FaDonate = function FaDonate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaDoorClosed = function FaDoorClosed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"}}]})(props);
	};
	module.exports.FaDoorOpen = function FaDoorOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"}}]})(props);
	};
	module.exports.FaDotCircle = function FaDotCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"}}]})(props);
	};
	module.exports.FaDove = function FaDove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}}]})(props);
	};
	module.exports.FaDownload = function FaDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"}}]})(props);
	};
	module.exports.FaDraftingCompass = function FaDraftingCompass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"}}]})(props);
	};
	module.exports.FaDragon = function FaDragon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"}}]})(props);
	};
	module.exports.FaDrawPolygon = function FaDrawPolygon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"}}]})(props);
	};
	module.exports.FaDrumSteelpan = function FaDrumSteelpan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"}}]})(props);
	};
	module.exports.FaDrum = function FaDrum (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"}}]})(props);
	};
	module.exports.FaDrumstickBite = function FaDrumstickBite (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"}}]})(props);
	};
	module.exports.FaDumbbell = function FaDumbbell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"}}]})(props);
	};
	module.exports.FaDumpsterFire = function FaDumpsterFire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"}}]})(props);
	};
	module.exports.FaDumpster = function FaDumpster (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaDungeon = function FaDungeon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"}}]})(props);
	};
	module.exports.FaEdit = function FaEdit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"}}]})(props);
	};
	module.exports.FaEgg = function FaEgg (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"}}]})(props);
	};
	module.exports.FaEject = function FaEject (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"}}]})(props);
	};
	module.exports.FaEllipsisH = function FaEllipsisH (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"}}]})(props);
	};
	module.exports.FaEllipsisV = function FaEllipsisV (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"}}]})(props);
	};
	module.exports.FaEnvelopeOpenText = function FaEnvelopeOpenText (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"}}]})(props);
	};
	module.exports.FaEnvelopeOpen = function FaEnvelopeOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"}}]})(props);
	};
	module.exports.FaEnvelopeSquare = function FaEnvelopeSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"}}]})(props);
	};
	module.exports.FaEnvelope = function FaEnvelope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"}}]})(props);
	};
	module.exports.FaEquals = function FaEquals (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaEraser = function FaEraser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"}}]})(props);
	};
	module.exports.FaEthernet = function FaEthernet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaEuroSign = function FaEuroSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"}}]})(props);
	};
	module.exports.FaExchangeAlt = function FaExchangeAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"}}]})(props);
	};
	module.exports.FaExclamationCircle = function FaExclamationCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"}}]})(props);
	};
	module.exports.FaExclamationTriangle = function FaExclamationTriangle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"}}]})(props);
	};
	module.exports.FaExclamation = function FaExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"}}]})(props);
	};
	module.exports.FaExpandAlt = function FaExpandAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"}}]})(props);
	};
	module.exports.FaExpandArrowsAlt = function FaExpandArrowsAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"}}]})(props);
	};
	module.exports.FaExpand = function FaExpand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"}}]})(props);
	};
	module.exports.FaExternalLinkAlt = function FaExternalLinkAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"}}]})(props);
	};
	module.exports.FaExternalLinkSquareAlt = function FaExternalLinkSquareAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"}}]})(props);
	};
	module.exports.FaEyeDropper = function FaEyeDropper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"}}]})(props);
	};
	module.exports.FaEyeSlash = function FaEyeSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"}}]})(props);
	};
	module.exports.FaEye = function FaEye (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"}}]})(props);
	};
	module.exports.FaFan = function FaFan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"}}]})(props);
	};
	module.exports.FaFastBackward = function FaFastBackward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"}}]})(props);
	};
	module.exports.FaFastForward = function FaFastForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"}}]})(props);
	};
	module.exports.FaFaucet = function FaFaucet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"}}]})(props);
	};
	module.exports.FaFax = function FaFax (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"}}]})(props);
	};
	module.exports.FaFeatherAlt = function FaFeatherAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"}}]})(props);
	};
	module.exports.FaFeather = function FaFeather (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"}}]})(props);
	};
	module.exports.FaFemale = function FaFemale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"}}]})(props);
	};
	module.exports.FaFighterJet = function FaFighterJet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"}}]})(props);
	};
	module.exports.FaFileAlt = function FaFileAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
	};
	module.exports.FaFileArchive = function FaFileArchive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"}}]})(props);
	};
	module.exports.FaFileAudio = function FaFileAudio (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
	};
	module.exports.FaFileCode = function FaFileCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"}}]})(props);
	};
	module.exports.FaFileContract = function FaFileContract (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"}}]})(props);
	};
	module.exports.FaFileCsv = function FaFileCsv (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"}}]})(props);
	};
	module.exports.FaFileDownload = function FaFileDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"}}]})(props);
	};
	module.exports.FaFileExcel = function FaFileExcel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
	};
	module.exports.FaFileExport = function FaFileExport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"}}]})(props);
	};
	module.exports.FaFileImage = function FaFileImage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"}}]})(props);
	};
	module.exports.FaFileImport = function FaFileImport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"}}]})(props);
	};
	module.exports.FaFileInvoiceDollar = function FaFileInvoiceDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"}}]})(props);
	};
	module.exports.FaFileInvoice = function FaFileInvoice (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"}}]})(props);
	};
	module.exports.FaFileMedicalAlt = function FaFileMedicalAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"}}]})(props);
	};
	module.exports.FaFileMedical = function FaFileMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"}}]})(props);
	};
	module.exports.FaFilePdf = function FaFilePdf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"}}]})(props);
	};
	module.exports.FaFilePowerpoint = function FaFilePowerpoint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"}}]})(props);
	};
	module.exports.FaFilePrescription = function FaFilePrescription (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
	};
	module.exports.FaFileSignature = function FaFileSignature (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"}}]})(props);
	};
	module.exports.FaFileUpload = function FaFileUpload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"}}]})(props);
	};
	module.exports.FaFileVideo = function FaFileVideo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"}}]})(props);
	};
	module.exports.FaFileWord = function FaFileWord (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
	};
	module.exports.FaFile = function FaFile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
	};
	module.exports.FaFillDrip = function FaFillDrip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"}}]})(props);
	};
	module.exports.FaFill = function FaFill (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"}}]})(props);
	};
	module.exports.FaFilm = function FaFilm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"}}]})(props);
	};
	module.exports.FaFilter = function FaFilter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"}}]})(props);
	};
	module.exports.FaFingerprint = function FaFingerprint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"}}]})(props);
	};
	module.exports.FaFireAlt = function FaFireAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"}}]})(props);
	};
	module.exports.FaFireExtinguisher = function FaFireExtinguisher (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"}}]})(props);
	};
	module.exports.FaFire = function FaFire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"}}]})(props);
	};
	module.exports.FaFirstAid = function FaFirstAid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaFish = function FaFish (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"}}]})(props);
	};
	module.exports.FaFistRaised = function FaFistRaised (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"}}]})(props);
	};
	module.exports.FaFlagCheckered = function FaFlagCheckered (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"}}]})(props);
	};
	module.exports.FaFlagUsa = function FaFlagUsa (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"}}]})(props);
	};
	module.exports.FaFlag = function FaFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"}}]})(props);
	};
	module.exports.FaFlask = function FaFlask (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"}}]})(props);
	};
	module.exports.FaFlushed = function FaFlushed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"}}]})(props);
	};
	module.exports.FaFolderMinus = function FaFolderMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"}}]})(props);
	};
	module.exports.FaFolderOpen = function FaFolderOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"}}]})(props);
	};
	module.exports.FaFolderPlus = function FaFolderPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"}}]})(props);
	};
	module.exports.FaFolder = function FaFolder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"}}]})(props);
	};
	module.exports.FaFont = function FaFont (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"}}]})(props);
	};
	module.exports.FaFootballBall = function FaFootballBall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"}}]})(props);
	};
	module.exports.FaForward = function FaForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"}}]})(props);
	};
	module.exports.FaFrog = function FaFrog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"}}]})(props);
	};
	module.exports.FaFrownOpen = function FaFrownOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaFrown = function FaFrown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"}}]})(props);
	};
	module.exports.FaFunnelDollar = function FaFunnelDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"}}]})(props);
	};
	module.exports.FaFutbol = function FaFutbol (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"}}]})(props);
	};
	module.exports.FaGamepad = function FaGamepad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"}}]})(props);
	};
	module.exports.FaGasPump = function FaGasPump (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"}}]})(props);
	};
	module.exports.FaGavel = function FaGavel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"}}]})(props);
	};
	module.exports.FaGem = function FaGem (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"}}]})(props);
	};
	module.exports.FaGenderless = function FaGenderless (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"}}]})(props);
	};
	module.exports.FaGhost = function FaGhost (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaGift = function FaGift (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"}}]})(props);
	};
	module.exports.FaGifts = function FaGifts (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"}}]})(props);
	};
	module.exports.FaGlassCheers = function FaGlassCheers (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"}}]})(props);
	};
	module.exports.FaGlassMartiniAlt = function FaGlassMartiniAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"}}]})(props);
	};
	module.exports.FaGlassMartini = function FaGlassMartini (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"}}]})(props);
	};
	module.exports.FaGlassWhiskey = function FaGlassWhiskey (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"}}]})(props);
	};
	module.exports.FaGlasses = function FaGlasses (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"}}]})(props);
	};
	module.exports.FaGlobeAfrica = function FaGlobeAfrica (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"}}]})(props);
	};
	module.exports.FaGlobeAmericas = function FaGlobeAmericas (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"}}]})(props);
	};
	module.exports.FaGlobeAsia = function FaGlobeAsia (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"}}]})(props);
	};
	module.exports.FaGlobeEurope = function FaGlobeEurope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"}}]})(props);
	};
	module.exports.FaGlobe = function FaGlobe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"}}]})(props);
	};
	module.exports.FaGolfBall = function FaGolfBall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"}}]})(props);
	};
	module.exports.FaGopuram = function FaGopuram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaGraduationCap = function FaGraduationCap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"}}]})(props);
	};
	module.exports.FaGreaterThanEqual = function FaGreaterThanEqual (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"}}]})(props);
	};
	module.exports.FaGreaterThan = function FaGreaterThan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"}}]})(props);
	};
	module.exports.FaGrimace = function FaGrimace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"}}]})(props);
	};
	module.exports.FaGrinAlt = function FaGrinAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
	};
	module.exports.FaGrinBeamSweat = function FaGrinBeamSweat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 504 512"},"child":[{"tag":"path","attr":{"d":"M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
	};
	module.exports.FaGrinBeam = function FaGrinBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
	};
	module.exports.FaGrinHearts = function FaGrinHearts (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"}}]})(props);
	};
	module.exports.FaGrinSquintTears = function FaGrinSquintTears (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"}}]})(props);
	};
	module.exports.FaGrinSquint = function FaGrinSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
	};
	module.exports.FaGrinStars = function FaGrinStars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"}}]})(props);
	};
	module.exports.FaGrinTears = function FaGrinTears (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
	};
	module.exports.FaGrinTongueSquint = function FaGrinTongueSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"}}]})(props);
	};
	module.exports.FaGrinTongueWink = function FaGrinTongueWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"}}]})(props);
	};
	module.exports.FaGrinTongue = function FaGrinTongue (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"}}]})(props);
	};
	module.exports.FaGrinWink = function FaGrinWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"}}]})(props);
	};
	module.exports.FaGrin = function FaGrin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
	};
	module.exports.FaGripHorizontal = function FaGripHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaGripLinesVertical = function FaGripLinesVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"}}]})(props);
	};
	module.exports.FaGripLines = function FaGripLines (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaGripVertical = function FaGripVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaGuitar = function FaGuitar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"}}]})(props);
	};
	module.exports.FaHSquare = function FaHSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"}}]})(props);
	};
	module.exports.FaHamburger = function FaHamburger (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"}}]})(props);
	};
	module.exports.FaHammer = function FaHammer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"}}]})(props);
	};
	module.exports.FaHamsa = function FaHamsa (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaHandHoldingHeart = function FaHandHoldingHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"}}]})(props);
	};
	module.exports.FaHandHoldingMedical = function FaHandHoldingMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"}}]})(props);
	};
	module.exports.FaHandHoldingUsd = function FaHandHoldingUsd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"}}]})(props);
	};
	module.exports.FaHandHoldingWater = function FaHandHoldingWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"}}]})(props);
	};
	module.exports.FaHandHolding = function FaHandHolding (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"}}]})(props);
	};
	module.exports.FaHandLizard = function FaHandLizard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"}}]})(props);
	};
	module.exports.FaHandMiddleFinger = function FaHandMiddleFinger (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"}}]})(props);
	};
	module.exports.FaHandPaper = function FaHandPaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"}}]})(props);
	};
	module.exports.FaHandPeace = function FaHandPeace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"}}]})(props);
	};
	module.exports.FaHandPointDown = function FaHandPointDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"}}]})(props);
	};
	module.exports.FaHandPointLeft = function FaHandPointLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"}}]})(props);
	};
	module.exports.FaHandPointRight = function FaHandPointRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"}}]})(props);
	};
	module.exports.FaHandPointUp = function FaHandPointUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"}}]})(props);
	};
	module.exports.FaHandPointer = function FaHandPointer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"}}]})(props);
	};
	module.exports.FaHandRock = function FaHandRock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"}}]})(props);
	};
	module.exports.FaHandScissors = function FaHandScissors (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"}}]})(props);
	};
	module.exports.FaHandSparkles = function FaHandSparkles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"}}]})(props);
	};
	module.exports.FaHandSpock = function FaHandSpock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"}}]})(props);
	};
	module.exports.FaHandsHelping = function FaHandsHelping (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"}}]})(props);
	};
	module.exports.FaHandsWash = function FaHandsWash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"}}]})(props);
	};
	module.exports.FaHands = function FaHands (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaHandshakeAltSlash = function FaHandshakeAltSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"}}]})(props);
	};
	module.exports.FaHandshakeSlash = function FaHandshakeSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"}}]})(props);
	};
	module.exports.FaHandshake = function FaHandshake (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"}}]})(props);
	};
	module.exports.FaHanukiah = function FaHanukiah (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"}}]})(props);
	};
	module.exports.FaHardHat = function FaHardHat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaHashtag = function FaHashtag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"}}]})(props);
	};
	module.exports.FaHatCowboySide = function FaHatCowboySide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"}}]})(props);
	};
	module.exports.FaHatCowboy = function FaHatCowboy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"}}]})(props);
	};
	module.exports.FaHatWizard = function FaHatWizard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"}}]})(props);
	};
	module.exports.FaHdd = function FaHdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"}}]})(props);
	};
	module.exports.FaHeadSideCoughSlash = function FaHeadSideCoughSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"}}]})(props);
	};
	module.exports.FaHeadSideCough = function FaHeadSideCough (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"}}]})(props);
	};
	module.exports.FaHeadSideMask = function FaHeadSideMask (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"}}]})(props);
	};
	module.exports.FaHeadSideVirus = function FaHeadSideVirus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"}}]})(props);
	};
	module.exports.FaHeading = function FaHeading (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"}}]})(props);
	};
	module.exports.FaHeadphonesAlt = function FaHeadphonesAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"}}]})(props);
	};
	module.exports.FaHeadphones = function FaHeadphones (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"}}]})(props);
	};
	module.exports.FaHeadset = function FaHeadset (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"}}]})(props);
	};
	module.exports.FaHeartBroken = function FaHeartBroken (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"}}]})(props);
	};
	module.exports.FaHeart = function FaHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"}}]})(props);
	};
	module.exports.FaHeartbeat = function FaHeartbeat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"}}]})(props);
	};
	module.exports.FaHelicopter = function FaHelicopter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"}}]})(props);
	};
	module.exports.FaHighlighter = function FaHighlighter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 544 512"},"child":[{"tag":"path","attr":{"d":"M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"}}]})(props);
	};
	module.exports.FaHiking = function FaHiking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"}}]})(props);
	};
	module.exports.FaHippo = function FaHippo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"}}]})(props);
	};
	module.exports.FaHistory = function FaHistory (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"}}]})(props);
	};
	module.exports.FaHockeyPuck = function FaHockeyPuck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"}}]})(props);
	};
	module.exports.FaHollyBerry = function FaHollyBerry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"}}]})(props);
	};
	module.exports.FaHome = function FaHome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"}}]})(props);
	};
	module.exports.FaHorseHead = function FaHorseHead (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"}}]})(props);
	};
	module.exports.FaHorse = function FaHorse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"}}]})(props);
	};
	module.exports.FaHospitalAlt = function FaHospitalAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"}}]})(props);
	};
	module.exports.FaHospitalSymbol = function FaHospitalSymbol (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"}}]})(props);
	};
	module.exports.FaHospitalUser = function FaHospitalUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"}}]})(props);
	};
	module.exports.FaHospital = function FaHospital (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"}}]})(props);
	};
	module.exports.FaHotTub = function FaHotTub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"}}]})(props);
	};
	module.exports.FaHotdog = function FaHotdog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"}}]})(props);
	};
	module.exports.FaHotel = function FaHotel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"}}]})(props);
	};
	module.exports.FaHourglassEnd = function FaHourglassEnd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"}}]})(props);
	};
	module.exports.FaHourglassHalf = function FaHourglassHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"}}]})(props);
	};
	module.exports.FaHourglassStart = function FaHourglassStart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"}}]})(props);
	};
	module.exports.FaHourglass = function FaHourglass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"}}]})(props);
	};
	module.exports.FaHouseDamage = function FaHouseDamage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"}}]})(props);
	};
	module.exports.FaHouseUser = function FaHouseUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"}}]})(props);
	};
	module.exports.FaHryvnia = function FaHryvnia (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"}}]})(props);
	};
	module.exports.FaICursor = function FaICursor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"}}]})(props);
	};
	module.exports.FaIceCream = function FaIceCream (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"}}]})(props);
	};
	module.exports.FaIcicles = function FaIcicles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"}}]})(props);
	};
	module.exports.FaIcons = function FaIcons (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"}}]})(props);
	};
	module.exports.FaIdBadge = function FaIdBadge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"}}]})(props);
	};
	module.exports.FaIdCardAlt = function FaIdCardAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"}}]})(props);
	};
	module.exports.FaIdCard = function FaIdCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"}}]})(props);
	};
	module.exports.FaIgloo = function FaIgloo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"}}]})(props);
	};
	module.exports.FaImage = function FaImage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"}}]})(props);
	};
	module.exports.FaImages = function FaImages (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"}}]})(props);
	};
	module.exports.FaInbox = function FaInbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"}}]})(props);
	};
	module.exports.FaIndent = function FaIndent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaIndustry = function FaIndustry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"}}]})(props);
	};
	module.exports.FaInfinity = function FaInfinity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"}}]})(props);
	};
	module.exports.FaInfoCircle = function FaInfoCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"}}]})(props);
	};
	module.exports.FaInfo = function FaInfo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"}}]})(props);
	};
	module.exports.FaItalic = function FaItalic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"}}]})(props);
	};
	module.exports.FaJedi = function FaJedi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"}}]})(props);
	};
	module.exports.FaJoint = function FaJoint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"}}]})(props);
	};
	module.exports.FaJournalWhills = function FaJournalWhills (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"}}]})(props);
	};
	module.exports.FaKaaba = function FaKaaba (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"}}]})(props);
	};
	module.exports.FaKey = function FaKey (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"}}]})(props);
	};
	module.exports.FaKeyboard = function FaKeyboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"}}]})(props);
	};
	module.exports.FaKhanda = function FaKhanda (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"}}]})(props);
	};
	module.exports.FaKissBeam = function FaKissBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"}}]})(props);
	};
	module.exports.FaKissWinkHeart = function FaKissWinkHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 504 512"},"child":[{"tag":"path","attr":{"d":"M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"}}]})(props);
	};
	module.exports.FaKiss = function FaKiss (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaKiwiBird = function FaKiwiBird (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"}}]})(props);
	};
	module.exports.FaLandmark = function FaLandmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaLanguage = function FaLanguage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"}}]})(props);
	};
	module.exports.FaLaptopCode = function FaLaptopCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"}}]})(props);
	};
	module.exports.FaLaptopHouse = function FaLaptopHouse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"}}]})(props);
	};
	module.exports.FaLaptopMedical = function FaLaptopMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaLaptop = function FaLaptop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"}}]})(props);
	};
	module.exports.FaLaughBeam = function FaLaughBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"}}]})(props);
	};
	module.exports.FaLaughSquint = function FaLaughSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"}}]})(props);
	};
	module.exports.FaLaughWink = function FaLaughWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"}}]})(props);
	};
	module.exports.FaLaugh = function FaLaugh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"}}]})(props);
	};
	module.exports.FaLayerGroup = function FaLayerGroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"}}]})(props);
	};
	module.exports.FaLeaf = function FaLeaf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"}}]})(props);
	};
	module.exports.FaLemon = function FaLemon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"}}]})(props);
	};
	module.exports.FaLessThanEqual = function FaLessThanEqual (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"}}]})(props);
	};
	module.exports.FaLessThan = function FaLessThan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"}}]})(props);
	};
	module.exports.FaLevelDownAlt = function FaLevelDownAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"}}]})(props);
	};
	module.exports.FaLevelUpAlt = function FaLevelUpAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"}}]})(props);
	};
	module.exports.FaLifeRing = function FaLifeRing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"}}]})(props);
	};
	module.exports.FaLightbulb = function FaLightbulb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"}}]})(props);
	};
	module.exports.FaLink = function FaLink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"}}]})(props);
	};
	module.exports.FaLiraSign = function FaLiraSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"}}]})(props);
	};
	module.exports.FaListAlt = function FaListAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"}}]})(props);
	};
	module.exports.FaListOl = function FaListOl (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"}}]})(props);
	};
	module.exports.FaListUl = function FaListUl (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaList = function FaList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaLocationArrow = function FaLocationArrow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"}}]})(props);
	};
	module.exports.FaLockOpen = function FaLockOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"}}]})(props);
	};
	module.exports.FaLock = function FaLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"}}]})(props);
	};
	module.exports.FaLongArrowAltDown = function FaLongArrowAltDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"}}]})(props);
	};
	module.exports.FaLongArrowAltLeft = function FaLongArrowAltLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"}}]})(props);
	};
	module.exports.FaLongArrowAltRight = function FaLongArrowAltRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"}}]})(props);
	};
	module.exports.FaLongArrowAltUp = function FaLongArrowAltUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"}}]})(props);
	};
	module.exports.FaLowVision = function FaLowVision (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"}}]})(props);
	};
	module.exports.FaLuggageCart = function FaLuggageCart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"}}]})(props);
	};
	module.exports.FaLungsVirus = function FaLungsVirus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"}}]})(props);
	};
	module.exports.FaLungs = function FaLungs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"}}]})(props);
	};
	module.exports.FaMagic = function FaMagic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"}}]})(props);
	};
	module.exports.FaMagnet = function FaMagnet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"}}]})(props);
	};
	module.exports.FaMailBulk = function FaMailBulk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"}}]})(props);
	};
	module.exports.FaMale = function FaMale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"}}]})(props);
	};
	module.exports.FaMapMarkedAlt = function FaMapMarkedAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"}}]})(props);
	};
	module.exports.FaMapMarked = function FaMapMarked (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"}}]})(props);
	};
	module.exports.FaMapMarkerAlt = function FaMapMarkerAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"}}]})(props);
	};
	module.exports.FaMapMarker = function FaMapMarker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"}}]})(props);
	};
	module.exports.FaMapPin = function FaMapPin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"}}]})(props);
	};
	module.exports.FaMapSigns = function FaMapSigns (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"}}]})(props);
	};
	module.exports.FaMap = function FaMap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"}}]})(props);
	};
	module.exports.FaMarker = function FaMarker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"}}]})(props);
	};
	module.exports.FaMarsDouble = function FaMarsDouble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"}}]})(props);
	};
	module.exports.FaMarsStrokeH = function FaMarsStrokeH (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"}}]})(props);
	};
	module.exports.FaMarsStrokeV = function FaMarsStrokeV (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"}}]})(props);
	};
	module.exports.FaMarsStroke = function FaMarsStroke (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
	};
	module.exports.FaMars = function FaMars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
	};
	module.exports.FaMask = function FaMask (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"}}]})(props);
	};
	module.exports.FaMedal = function FaMedal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"}}]})(props);
	};
	module.exports.FaMedkit = function FaMedkit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"}}]})(props);
	};
	module.exports.FaMehBlank = function FaMehBlank (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaMehRollingEyes = function FaMehRollingEyes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"}}]})(props);
	};
	module.exports.FaMeh = function FaMeh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaMemory = function FaMemory (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"}}]})(props);
	};
	module.exports.FaMenorah = function FaMenorah (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"}}]})(props);
	};
	module.exports.FaMercury = function FaMercury (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"}}]})(props);
	};
	module.exports.FaMeteor = function FaMeteor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"}}]})(props);
	};
	module.exports.FaMicrochip = function FaMicrochip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"}}]})(props);
	};
	module.exports.FaMicrophoneAltSlash = function FaMicrophoneAltSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaMicrophoneAlt = function FaMicrophoneAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"}}]})(props);
	};
	module.exports.FaMicrophoneSlash = function FaMicrophoneSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaMicrophone = function FaMicrophone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaMicroscope = function FaMicroscope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"}}]})(props);
	};
	module.exports.FaMinusCircle = function FaMinusCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"}}]})(props);
	};
	module.exports.FaMinusSquare = function FaMinusSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"}}]})(props);
	};
	module.exports.FaMinus = function FaMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaMitten = function FaMitten (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"}}]})(props);
	};
	module.exports.FaMobileAlt = function FaMobileAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"}}]})(props);
	};
	module.exports.FaMobile = function FaMobile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaMoneyBillAlt = function FaMoneyBillAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"}}]})(props);
	};
	module.exports.FaMoneyBillWaveAlt = function FaMoneyBillWaveAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"}}]})(props);
	};
	module.exports.FaMoneyBillWave = function FaMoneyBillWave (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"}}]})(props);
	};
	module.exports.FaMoneyBill = function FaMoneyBill (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"}}]})(props);
	};
	module.exports.FaMoneyCheckAlt = function FaMoneyCheckAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"}}]})(props);
	};
	module.exports.FaMoneyCheck = function FaMoneyCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaMonument = function FaMonument (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"}}]})(props);
	};
	module.exports.FaMoon = function FaMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"}}]})(props);
	};
	module.exports.FaMortarPestle = function FaMortarPestle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaMosque = function FaMosque (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"}}]})(props);
	};
	module.exports.FaMotorcycle = function FaMotorcycle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"}}]})(props);
	};
	module.exports.FaMountain = function FaMountain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"}}]})(props);
	};
	module.exports.FaMousePointer = function FaMousePointer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"}}]})(props);
	};
	module.exports.FaMouse = function FaMouse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"}}]})(props);
	};
	module.exports.FaMugHot = function FaMugHot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"}}]})(props);
	};
	module.exports.FaMusic = function FaMusic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"}}]})(props);
	};
	module.exports.FaNetworkWired = function FaNetworkWired (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"}}]})(props);
	};
	module.exports.FaNeuter = function FaNeuter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
	};
	module.exports.FaNewspaper = function FaNewspaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"}}]})(props);
	};
	module.exports.FaNotEqual = function FaNotEqual (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"}}]})(props);
	};
	module.exports.FaNotesMedical = function FaNotesMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"}}]})(props);
	};
	module.exports.FaObjectGroup = function FaObjectGroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"}}]})(props);
	};
	module.exports.FaObjectUngroup = function FaObjectUngroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"}}]})(props);
	};
	module.exports.FaOilCan = function FaOilCan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"}}]})(props);
	};
	module.exports.FaOm = function FaOm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"}}]})(props);
	};
	module.exports.FaOtter = function FaOtter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"}}]})(props);
	};
	module.exports.FaOutdent = function FaOutdent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaPager = function FaPager (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"}}]})(props);
	};
	module.exports.FaPaintBrush = function FaPaintBrush (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"}}]})(props);
	};
	module.exports.FaPaintRoller = function FaPaintRoller (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"}}]})(props);
	};
	module.exports.FaPalette = function FaPalette (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaPallet = function FaPallet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"}}]})(props);
	};
	module.exports.FaPaperPlane = function FaPaperPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"}}]})(props);
	};
	module.exports.FaPaperclip = function FaPaperclip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"}}]})(props);
	};
	module.exports.FaParachuteBox = function FaParachuteBox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"}}]})(props);
	};
	module.exports.FaParagraph = function FaParagraph (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"}}]})(props);
	};
	module.exports.FaParking = function FaParking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"}}]})(props);
	};
	module.exports.FaPassport = function FaPassport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"}}]})(props);
	};
	module.exports.FaPastafarianism = function FaPastafarianism (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"}}]})(props);
	};
	module.exports.FaPaste = function FaPaste (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"}}]})(props);
	};
	module.exports.FaPauseCircle = function FaPauseCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"}}]})(props);
	};
	module.exports.FaPause = function FaPause (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"}}]})(props);
	};
	module.exports.FaPaw = function FaPaw (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"}}]})(props);
	};
	module.exports.FaPeace = function FaPeace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"}}]})(props);
	};
	module.exports.FaPenAlt = function FaPenAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"}}]})(props);
	};
	module.exports.FaPenFancy = function FaPenFancy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"}}]})(props);
	};
	module.exports.FaPenNib = function FaPenNib (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"}}]})(props);
	};
	module.exports.FaPenSquare = function FaPenSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"}}]})(props);
	};
	module.exports.FaPen = function FaPen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"}}]})(props);
	};
	module.exports.FaPencilAlt = function FaPencilAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"}}]})(props);
	};
	module.exports.FaPencilRuler = function FaPencilRuler (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"}}]})(props);
	};
	module.exports.FaPeopleArrows = function FaPeopleArrows (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"}}]})(props);
	};
	module.exports.FaPeopleCarry = function FaPeopleCarry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"}}]})(props);
	};
	module.exports.FaPepperHot = function FaPepperHot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"}}]})(props);
	};
	module.exports.FaPercent = function FaPercent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"}}]})(props);
	};
	module.exports.FaPercentage = function FaPercentage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"}}]})(props);
	};
	module.exports.FaPersonBooth = function FaPersonBooth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaPhoneAlt = function FaPhoneAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"}}]})(props);
	};
	module.exports.FaPhoneSlash = function FaPhoneSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"}}]})(props);
	};
	module.exports.FaPhoneSquareAlt = function FaPhoneSquareAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"}}]})(props);
	};
	module.exports.FaPhoneSquare = function FaPhoneSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"}}]})(props);
	};
	module.exports.FaPhoneVolume = function FaPhoneVolume (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"}}]})(props);
	};
	module.exports.FaPhone = function FaPhone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"}}]})(props);
	};
	module.exports.FaPhotoVideo = function FaPhotoVideo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"}}]})(props);
	};
	module.exports.FaPiggyBank = function FaPiggyBank (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"}}]})(props);
	};
	module.exports.FaPills = function FaPills (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"}}]})(props);
	};
	module.exports.FaPizzaSlice = function FaPizzaSlice (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"}}]})(props);
	};
	module.exports.FaPlaceOfWorship = function FaPlaceOfWorship (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"}}]})(props);
	};
	module.exports.FaPlaneArrival = function FaPlaneArrival (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"}}]})(props);
	};
	module.exports.FaPlaneDeparture = function FaPlaneDeparture (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"}}]})(props);
	};
	module.exports.FaPlaneSlash = function FaPlaneSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"}}]})(props);
	};
	module.exports.FaPlane = function FaPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"}}]})(props);
	};
	module.exports.FaPlayCircle = function FaPlayCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"}}]})(props);
	};
	module.exports.FaPlay = function FaPlay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"}}]})(props);
	};
	module.exports.FaPlug = function FaPlug (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"}}]})(props);
	};
	module.exports.FaPlusCircle = function FaPlusCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"}}]})(props);
	};
	module.exports.FaPlusSquare = function FaPlusSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"}}]})(props);
	};
	module.exports.FaPlus = function FaPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaPodcast = function FaPodcast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"}}]})(props);
	};
	module.exports.FaPollH = function FaPollH (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"}}]})(props);
	};
	module.exports.FaPoll = function FaPoll (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"}}]})(props);
	};
	module.exports.FaPooStorm = function FaPooStorm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"}}]})(props);
	};
	module.exports.FaPoo = function FaPoo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaPoop = function FaPoop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"}}]})(props);
	};
	module.exports.FaPortrait = function FaPortrait (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"}}]})(props);
	};
	module.exports.FaPoundSign = function FaPoundSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"}}]})(props);
	};
	module.exports.FaPowerOff = function FaPowerOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"}}]})(props);
	};
	module.exports.FaPray = function FaPray (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"}}]})(props);
	};
	module.exports.FaPrayingHands = function FaPrayingHands (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"}}]})(props);
	};
	module.exports.FaPrescriptionBottleAlt = function FaPrescriptionBottleAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"}}]})(props);
	};
	module.exports.FaPrescriptionBottle = function FaPrescriptionBottle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"}}]})(props);
	};
	module.exports.FaPrescription = function FaPrescription (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"}}]})(props);
	};
	module.exports.FaPrint = function FaPrint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"}}]})(props);
	};
	module.exports.FaProcedures = function FaProcedures (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"}}]})(props);
	};
	module.exports.FaProjectDiagram = function FaProjectDiagram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaPumpMedical = function FaPumpMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"}}]})(props);
	};
	module.exports.FaPumpSoap = function FaPumpSoap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"}}]})(props);
	};
	module.exports.FaPuzzlePiece = function FaPuzzlePiece (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"}}]})(props);
	};
	module.exports.FaQrcode = function FaQrcode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"}}]})(props);
	};
	module.exports.FaQuestionCircle = function FaQuestionCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"}}]})(props);
	};
	module.exports.FaQuestion = function FaQuestion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"}}]})(props);
	};
	module.exports.FaQuidditch = function FaQuidditch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"}}]})(props);
	};
	module.exports.FaQuoteLeft = function FaQuoteLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaQuoteRight = function FaQuoteRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaQuran = function FaQuran (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"}}]})(props);
	};
	module.exports.FaRadiationAlt = function FaRadiationAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"}}]})(props);
	};
	module.exports.FaRadiation = function FaRadiation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"}}]})(props);
	};
	module.exports.FaRainbow = function FaRainbow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"}}]})(props);
	};
	module.exports.FaRandom = function FaRandom (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"}}]})(props);
	};
	module.exports.FaReceipt = function FaReceipt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"}}]})(props);
	};
	module.exports.FaRecordVinyl = function FaRecordVinyl (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"}}]})(props);
	};
	module.exports.FaRecycle = function FaRecycle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"}}]})(props);
	};
	module.exports.FaRedoAlt = function FaRedoAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"}}]})(props);
	};
	module.exports.FaRedo = function FaRedo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"}}]})(props);
	};
	module.exports.FaRegistered = function FaRegistered (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"}}]})(props);
	};
	module.exports.FaRemoveFormat = function FaRemoveFormat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"}}]})(props);
	};
	module.exports.FaReplyAll = function FaReplyAll (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"}}]})(props);
	};
	module.exports.FaReply = function FaReply (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"}}]})(props);
	};
	module.exports.FaRepublican = function FaRepublican (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaRestroom = function FaRestroom (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"}}]})(props);
	};
	module.exports.FaRetweet = function FaRetweet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"}}]})(props);
	};
	module.exports.FaRibbon = function FaRibbon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"}}]})(props);
	};
	module.exports.FaRing = function FaRing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"}}]})(props);
	};
	module.exports.FaRoad = function FaRoad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"}}]})(props);
	};
	module.exports.FaRobot = function FaRobot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"}}]})(props);
	};
	module.exports.FaRocket = function FaRocket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"}}]})(props);
	};
	module.exports.FaRoute = function FaRoute (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaRssSquare = function FaRssSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"}}]})(props);
	};
	module.exports.FaRss = function FaRss (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"}}]})(props);
	};
	module.exports.FaRubleSign = function FaRubleSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"}}]})(props);
	};
	module.exports.FaRulerCombined = function FaRulerCombined (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaRulerHorizontal = function FaRulerHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaRulerVertical = function FaRulerVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"}}]})(props);
	};
	module.exports.FaRuler = function FaRuler (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"}}]})(props);
	};
	module.exports.FaRunning = function FaRunning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"}}]})(props);
	};
	module.exports.FaRupeeSign = function FaRupeeSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"}}]})(props);
	};
	module.exports.FaSadCry = function FaSadCry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"}}]})(props);
	};
	module.exports.FaSadTear = function FaSadTear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"}}]})(props);
	};
	module.exports.FaSatelliteDish = function FaSatelliteDish (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"}}]})(props);
	};
	module.exports.FaSatellite = function FaSatellite (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"}}]})(props);
	};
	module.exports.FaSave = function FaSave (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"}}]})(props);
	};
	module.exports.FaSchool = function FaSchool (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaScrewdriver = function FaScrewdriver (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"}}]})(props);
	};
	module.exports.FaScroll = function FaScroll (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"}}]})(props);
	};
	module.exports.FaSdCard = function FaSdCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"}}]})(props);
	};
	module.exports.FaSearchDollar = function FaSearchDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"}}]})(props);
	};
	module.exports.FaSearchLocation = function FaSearchLocation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"}}]})(props);
	};
	module.exports.FaSearchMinus = function FaSearchMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"}}]})(props);
	};
	module.exports.FaSearchPlus = function FaSearchPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"}}]})(props);
	};
	module.exports.FaSearch = function FaSearch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"}}]})(props);
	};
	module.exports.FaSeedling = function FaSeedling (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"}}]})(props);
	};
	module.exports.FaServer = function FaServer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"}}]})(props);
	};
	module.exports.FaShapes = function FaShapes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"}}]})(props);
	};
	module.exports.FaShareAltSquare = function FaShareAltSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"}}]})(props);
	};
	module.exports.FaShareAlt = function FaShareAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"}}]})(props);
	};
	module.exports.FaShareSquare = function FaShareSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"}}]})(props);
	};
	module.exports.FaShare = function FaShare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"}}]})(props);
	};
	module.exports.FaShekelSign = function FaShekelSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaShieldAlt = function FaShieldAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"}}]})(props);
	};
	module.exports.FaShieldVirus = function FaShieldVirus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"}}]})(props);
	};
	module.exports.FaShip = function FaShip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"}}]})(props);
	};
	module.exports.FaShippingFast = function FaShippingFast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"}}]})(props);
	};
	module.exports.FaShoePrints = function FaShoePrints (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"}}]})(props);
	};
	module.exports.FaShoppingBag = function FaShoppingBag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"}}]})(props);
	};
	module.exports.FaShoppingBasket = function FaShoppingBasket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"}}]})(props);
	};
	module.exports.FaShoppingCart = function FaShoppingCart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"}}]})(props);
	};
	module.exports.FaShower = function FaShower (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"}}]})(props);
	};
	module.exports.FaShuttleVan = function FaShuttleVan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"}}]})(props);
	};
	module.exports.FaSignInAlt = function FaSignInAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"}}]})(props);
	};
	module.exports.FaSignLanguage = function FaSignLanguage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"}}]})(props);
	};
	module.exports.FaSignOutAlt = function FaSignOutAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"}}]})(props);
	};
	module.exports.FaSign = function FaSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"}}]})(props);
	};
	module.exports.FaSignal = function FaSignal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaSignature = function FaSignature (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"}}]})(props);
	};
	module.exports.FaSimCard = function FaSimCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"}}]})(props);
	};
	module.exports.FaSink = function FaSink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"}}]})(props);
	};
	module.exports.FaSitemap = function FaSitemap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaSkating = function FaSkating (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"}}]})(props);
	};
	module.exports.FaSkiingNordic = function FaSkiingNordic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"}}]})(props);
	};
	module.exports.FaSkiing = function FaSkiing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"}}]})(props);
	};
	module.exports.FaSkullCrossbones = function FaSkullCrossbones (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"}}]})(props);
	};
	module.exports.FaSkull = function FaSkull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"}}]})(props);
	};
	module.exports.FaSlash = function FaSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"}}]})(props);
	};
	module.exports.FaSleigh = function FaSleigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"}}]})(props);
	};
	module.exports.FaSlidersH = function FaSlidersH (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaSmileBeam = function FaSmileBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"}}]})(props);
	};
	module.exports.FaSmileWink = function FaSmileWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"}}]})(props);
	};
	module.exports.FaSmile = function FaSmile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"}}]})(props);
	};
	module.exports.FaSmog = function FaSmog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"}}]})(props);
	};
	module.exports.FaSmokingBan = function FaSmokingBan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"}}]})(props);
	};
	module.exports.FaSmoking = function FaSmoking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"}}]})(props);
	};
	module.exports.FaSms = function FaSms (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"}}]})(props);
	};
	module.exports.FaSnowboarding = function FaSnowboarding (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"}}]})(props);
	};
	module.exports.FaSnowflake = function FaSnowflake (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"}}]})(props);
	};
	module.exports.FaSnowman = function FaSnowman (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}}]})(props);
	};
	module.exports.FaSnowplow = function FaSnowplow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"}}]})(props);
	};
	module.exports.FaSoap = function FaSoap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"}}]})(props);
	};
	module.exports.FaSocks = function FaSocks (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"}}]})(props);
	};
	module.exports.FaSolarPanel = function FaSolarPanel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"}}]})(props);
	};
	module.exports.FaSortAlphaDownAlt = function FaSortAlphaDownAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"}}]})(props);
	};
	module.exports.FaSortAlphaDown = function FaSortAlphaDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"}}]})(props);
	};
	module.exports.FaSortAlphaUpAlt = function FaSortAlphaUpAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"}}]})(props);
	};
	module.exports.FaSortAlphaUp = function FaSortAlphaUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"}}]})(props);
	};
	module.exports.FaSortAmountDownAlt = function FaSortAmountDownAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"}}]})(props);
	};
	module.exports.FaSortAmountDown = function FaSortAmountDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaSortAmountUpAlt = function FaSortAmountUpAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"}}]})(props);
	};
	module.exports.FaSortAmountUp = function FaSortAmountUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaSortDown = function FaSortDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"}}]})(props);
	};
	module.exports.FaSortNumericDownAlt = function FaSortNumericDownAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"}}]})(props);
	};
	module.exports.FaSortNumericDown = function FaSortNumericDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"}}]})(props);
	};
	module.exports.FaSortNumericUpAlt = function FaSortNumericUpAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"}}]})(props);
	};
	module.exports.FaSortNumericUp = function FaSortNumericUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"}}]})(props);
	};
	module.exports.FaSortUp = function FaSortUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"}}]})(props);
	};
	module.exports.FaSort = function FaSort (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"}}]})(props);
	};
	module.exports.FaSpa = function FaSpa (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"}}]})(props);
	};
	module.exports.FaSpaceShuttle = function FaSpaceShuttle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"}}]})(props);
	};
	module.exports.FaSpellCheck = function FaSpellCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"}}]})(props);
	};
	module.exports.FaSpider = function FaSpider (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"}}]})(props);
	};
	module.exports.FaSpinner = function FaSpinner (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"}}]})(props);
	};
	module.exports.FaSplotch = function FaSplotch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"}}]})(props);
	};
	module.exports.FaSprayCan = function FaSprayCan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaSquareFull = function FaSquareFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 512H0V0h512v512z"}}]})(props);
	};
	module.exports.FaSquareRootAlt = function FaSquareRootAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"}}]})(props);
	};
	module.exports.FaSquare = function FaSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaStamp = function FaStamp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"}}]})(props);
	};
	module.exports.FaStarAndCrescent = function FaStarAndCrescent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"}}]})(props);
	};
	module.exports.FaStarHalfAlt = function FaStarHalfAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 536 512"},"child":[{"tag":"path","attr":{"d":"M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"}}]})(props);
	};
	module.exports.FaStarHalf = function FaStarHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"}}]})(props);
	};
	module.exports.FaStarOfDavid = function FaStarOfDavid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 464 512"},"child":[{"tag":"path","attr":{"d":"M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"}}]})(props);
	};
	module.exports.FaStarOfLife = function FaStarOfLife (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"}}]})(props);
	};
	module.exports.FaStar = function FaStar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"}}]})(props);
	};
	module.exports.FaStepBackward = function FaStepBackward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"}}]})(props);
	};
	module.exports.FaStepForward = function FaStepForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"}}]})(props);
	};
	module.exports.FaStethoscope = function FaStethoscope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}}]})(props);
	};
	module.exports.FaStickyNote = function FaStickyNote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"}}]})(props);
	};
	module.exports.FaStopCircle = function FaStopCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"}}]})(props);
	};
	module.exports.FaStop = function FaStop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaStopwatch20 = function FaStopwatch20 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"}}]})(props);
	};
	module.exports.FaStopwatch = function FaStopwatch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"}}]})(props);
	};
	module.exports.FaStoreAltSlash = function FaStoreAltSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"}}]})(props);
	};
	module.exports.FaStoreAlt = function FaStoreAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"}}]})(props);
	};
	module.exports.FaStoreSlash = function FaStoreSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"}}]})(props);
	};
	module.exports.FaStore = function FaStore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 616 512"},"child":[{"tag":"path","attr":{"d":"M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"}}]})(props);
	};
	module.exports.FaStream = function FaStream (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaStreetView = function FaStreetView (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"}}]})(props);
	};
	module.exports.FaStrikethrough = function FaStrikethrough (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"}}]})(props);
	};
	module.exports.FaStroopwafel = function FaStroopwafel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"}}]})(props);
	};
	module.exports.FaSubscript = function FaSubscript (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaSubway = function FaSubway (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"}}]})(props);
	};
	module.exports.FaSuitcaseRolling = function FaSuitcaseRolling (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"}}]})(props);
	};
	module.exports.FaSuitcase = function FaSuitcase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"}}]})(props);
	};
	module.exports.FaSun = function FaSun (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"}}]})(props);
	};
	module.exports.FaSuperscript = function FaSuperscript (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaSurprise = function FaSurprise (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaSwatchbook = function FaSwatchbook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"}}]})(props);
	};
	module.exports.FaSwimmer = function FaSwimmer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"}}]})(props);
	};
	module.exports.FaSwimmingPool = function FaSwimmingPool (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"}}]})(props);
	};
	module.exports.FaSynagogue = function FaSynagogue (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"}}]})(props);
	};
	module.exports.FaSyncAlt = function FaSyncAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"}}]})(props);
	};
	module.exports.FaSync = function FaSync (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"}}]})(props);
	};
	module.exports.FaSyringe = function FaSyringe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"}}]})(props);
	};
	module.exports.FaTableTennis = function FaTableTennis (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"}}]})(props);
	};
	module.exports.FaTable = function FaTable (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"}}]})(props);
	};
	module.exports.FaTabletAlt = function FaTabletAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"}}]})(props);
	};
	module.exports.FaTablet = function FaTablet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaTablets = function FaTablets (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"}}]})(props);
	};
	module.exports.FaTachometerAlt = function FaTachometerAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaTag = function FaTag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"}}]})(props);
	};
	module.exports.FaTags = function FaTags (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"}}]})(props);
	};
	module.exports.FaTape = function FaTape (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"}}]})(props);
	};
	module.exports.FaTasks = function FaTasks (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaTaxi = function FaTaxi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaTeethOpen = function FaTeethOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"}}]})(props);
	};
	module.exports.FaTeeth = function FaTeeth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"}}]})(props);
	};
	module.exports.FaTemperatureHigh = function FaTemperatureHigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"}}]})(props);
	};
	module.exports.FaTemperatureLow = function FaTemperatureLow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"}}]})(props);
	};
	module.exports.FaTenge = function FaTenge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"}}]})(props);
	};
	module.exports.FaTerminal = function FaTerminal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"}}]})(props);
	};
	module.exports.FaTextHeight = function FaTextHeight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"}}]})(props);
	};
	module.exports.FaTextWidth = function FaTextWidth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"}}]})(props);
	};
	module.exports.FaThLarge = function FaThLarge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"}}]})(props);
	};
	module.exports.FaThList = function FaThList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"}}]})(props);
	};
	module.exports.FaTh = function FaTh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"}}]})(props);
	};
	module.exports.FaTheaterMasks = function FaTheaterMasks (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"}}]})(props);
	};
	module.exports.FaThermometerEmpty = function FaThermometerEmpty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"}}]})(props);
	};
	module.exports.FaThermometerFull = function FaThermometerFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"}}]})(props);
	};
	module.exports.FaThermometerHalf = function FaThermometerHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"}}]})(props);
	};
	module.exports.FaThermometerQuarter = function FaThermometerQuarter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"}}]})(props);
	};
	module.exports.FaThermometerThreeQuarters = function FaThermometerThreeQuarters (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"}}]})(props);
	};
	module.exports.FaThermometer = function FaThermometer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"}}]})(props);
	};
	module.exports.FaThumbsDown = function FaThumbsDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"}}]})(props);
	};
	module.exports.FaThumbsUp = function FaThumbsUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"}}]})(props);
	};
	module.exports.FaThumbtack = function FaThumbtack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"}}]})(props);
	};
	module.exports.FaTicketAlt = function FaTicketAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"}}]})(props);
	};
	module.exports.FaTimesCircle = function FaTimesCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"}}]})(props);
	};
	module.exports.FaTimes = function FaTimes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"}}]})(props);
	};
	module.exports.FaTintSlash = function FaTintSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"}}]})(props);
	};
	module.exports.FaTint = function FaTint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"}}]})(props);
	};
	module.exports.FaTired = function FaTired (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"}}]})(props);
	};
	module.exports.FaToggleOff = function FaToggleOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"}}]})(props);
	};
	module.exports.FaToggleOn = function FaToggleOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"}}]})(props);
	};
	module.exports.FaToiletPaperSlash = function FaToiletPaperSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"}}]})(props);
	};
	module.exports.FaToiletPaper = function FaToiletPaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"}}]})(props);
	};
	module.exports.FaToilet = function FaToilet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"}}]})(props);
	};
	module.exports.FaToolbox = function FaToolbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"}}]})(props);
	};
	module.exports.FaTools = function FaTools (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"}}]})(props);
	};
	module.exports.FaTooth = function FaTooth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"}}]})(props);
	};
	module.exports.FaTorah = function FaTorah (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"}}]})(props);
	};
	module.exports.FaToriiGate = function FaToriiGate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"}}]})(props);
	};
	module.exports.FaTractor = function FaTractor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"}}]})(props);
	};
	module.exports.FaTrademark = function FaTrademark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"}}]})(props);
	};
	module.exports.FaTrafficLight = function FaTrafficLight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"}}]})(props);
	};
	module.exports.FaTrailer = function FaTrailer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"}}]})(props);
	};
	module.exports.FaTrain = function FaTrain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"}}]})(props);
	};
	module.exports.FaTram = function FaTram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"}}]})(props);
	};
	module.exports.FaTransgenderAlt = function FaTransgenderAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
	};
	module.exports.FaTransgender = function FaTransgender (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
	};
	module.exports.FaTrashAlt = function FaTrashAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaTrashRestoreAlt = function FaTrashRestoreAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaTrashRestore = function FaTrashRestore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaTrash = function FaTrash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"}}]})(props);
	};
	module.exports.FaTree = function FaTree (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"}}]})(props);
	};
	module.exports.FaTrophy = function FaTrophy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"}}]})(props);
	};
	module.exports.FaTruckLoading = function FaTruckLoading (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"}}]})(props);
	};
	module.exports.FaTruckMonster = function FaTruckMonster (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"}}]})(props);
	};
	module.exports.FaTruckMoving = function FaTruckMoving (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"}}]})(props);
	};
	module.exports.FaTruckPickup = function FaTruckPickup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"}}]})(props);
	};
	module.exports.FaTruck = function FaTruck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"}}]})(props);
	};
	module.exports.FaTshirt = function FaTshirt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"}}]})(props);
	};
	module.exports.FaTty = function FaTty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"}}]})(props);
	};
	module.exports.FaTv = function FaTv (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"}}]})(props);
	};
	module.exports.FaUmbrellaBeach = function FaUmbrellaBeach (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"}}]})(props);
	};
	module.exports.FaUmbrella = function FaUmbrella (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"}}]})(props);
	};
	module.exports.FaUnderline = function FaUnderline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
	};
	module.exports.FaUndoAlt = function FaUndoAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"}}]})(props);
	};
	module.exports.FaUndo = function FaUndo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"}}]})(props);
	};
	module.exports.FaUniversalAccess = function FaUniversalAccess (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"}}]})(props);
	};
	module.exports.FaUniversity = function FaUniversity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"}}]})(props);
	};
	module.exports.FaUnlink = function FaUnlink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"}}]})(props);
	};
	module.exports.FaUnlockAlt = function FaUnlockAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"}}]})(props);
	};
	module.exports.FaUnlock = function FaUnlock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaUpload = function FaUpload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"}}]})(props);
	};
	module.exports.FaUserAltSlash = function FaUserAltSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"}}]})(props);
	};
	module.exports.FaUserAlt = function FaUserAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"}}]})(props);
	};
	module.exports.FaUserAstronaut = function FaUserAstronaut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaUserCheck = function FaUserCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"}}]})(props);
	};
	module.exports.FaUserCircle = function FaUserCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"}}]})(props);
	};
	module.exports.FaUserClock = function FaUserClock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"}}]})(props);
	};
	module.exports.FaUserCog = function FaUserCog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"}}]})(props);
	};
	module.exports.FaUserEdit = function FaUserEdit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"}}]})(props);
	};
	module.exports.FaUserFriends = function FaUserFriends (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"}}]})(props);
	};
	module.exports.FaUserGraduate = function FaUserGraduate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"}}]})(props);
	};
	module.exports.FaUserInjured = function FaUserInjured (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"}}]})(props);
	};
	module.exports.FaUserLock = function FaUserLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"}}]})(props);
	};
	module.exports.FaUserMd = function FaUserMd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"}}]})(props);
	};
	module.exports.FaUserMinus = function FaUserMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"}}]})(props);
	};
	module.exports.FaUserNinja = function FaUserNinja (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaUserNurse = function FaUserNurse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"}}]})(props);
	};
	module.exports.FaUserPlus = function FaUserPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"}}]})(props);
	};
	module.exports.FaUserSecret = function FaUserSecret (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"}}]})(props);
	};
	module.exports.FaUserShield = function FaUserShield (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"}}]})(props);
	};
	module.exports.FaUserSlash = function FaUserSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"}}]})(props);
	};
	module.exports.FaUserTag = function FaUserTag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"}}]})(props);
	};
	module.exports.FaUserTie = function FaUserTie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"}}]})(props);
	};
	module.exports.FaUserTimes = function FaUserTimes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"}}]})(props);
	};
	module.exports.FaUser = function FaUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"}}]})(props);
	};
	module.exports.FaUsersCog = function FaUsersCog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"}}]})(props);
	};
	module.exports.FaUsersSlash = function FaUsersSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"}}]})(props);
	};
	module.exports.FaUsers = function FaUsers (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"}}]})(props);
	};
	module.exports.FaUtensilSpoon = function FaUtensilSpoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"}}]})(props);
	};
	module.exports.FaUtensils = function FaUtensils (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"}}]})(props);
	};
	module.exports.FaVectorSquare = function FaVectorSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"}}]})(props);
	};
	module.exports.FaVenusDouble = function FaVenusDouble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"}}]})(props);
	};
	module.exports.FaVenusMars = function FaVenusMars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
	};
	module.exports.FaVenus = function FaVenus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"}}]})(props);
	};
	module.exports.FaVestPatches = function FaVestPatches (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"}}]})(props);
	};
	module.exports.FaVest = function FaVest (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"}}]})(props);
	};
	module.exports.FaVial = function FaVial (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"}}]})(props);
	};
	module.exports.FaVials = function FaVials (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"}}]})(props);
	};
	module.exports.FaVideoSlash = function FaVideoSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"}}]})(props);
	};
	module.exports.FaVideo = function FaVideo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"}}]})(props);
	};
	module.exports.FaVihara = function FaVihara (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"}}]})(props);
	};
	module.exports.FaVirusSlash = function FaVirusSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"}}]})(props);
	};
	module.exports.FaVirus = function FaVirus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"}}]})(props);
	};
	module.exports.FaViruses = function FaViruses (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"}}]})(props);
	};
	module.exports.FaVoicemail = function FaVoicemail (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"}}]})(props);
	};
	module.exports.FaVolleyballBall = function FaVolleyballBall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"}}]})(props);
	};
	module.exports.FaVolumeDown = function FaVolumeDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"}}]})(props);
	};
	module.exports.FaVolumeMute = function FaVolumeMute (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"}}]})(props);
	};
	module.exports.FaVolumeOff = function FaVolumeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"}}]})(props);
	};
	module.exports.FaVolumeUp = function FaVolumeUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"}}]})(props);
	};
	module.exports.FaVoteYea = function FaVoteYea (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"}}]})(props);
	};
	module.exports.FaVrCardboard = function FaVrCardboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"}}]})(props);
	};
	module.exports.FaWalking = function FaWalking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"}}]})(props);
	};
	module.exports.FaWallet = function FaWallet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
	};
	module.exports.FaWarehouse = function FaWarehouse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"}}]})(props);
	};
	module.exports.FaWater = function FaWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"}}]})(props);
	};
	module.exports.FaWaveSquare = function FaWaveSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"}}]})(props);
	};
	module.exports.FaWeightHanging = function FaWeightHanging (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"}}]})(props);
	};
	module.exports.FaWeight = function FaWeight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"}}]})(props);
	};
	module.exports.FaWheelchair = function FaWheelchair (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"}}]})(props);
	};
	module.exports.FaWifi = function FaWifi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"}}]})(props);
	};
	module.exports.FaWind = function FaWind (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"}}]})(props);
	};
	module.exports.FaWindowClose = function FaWindowClose (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"}}]})(props);
	};
	module.exports.FaWindowMaximize = function FaWindowMaximize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"}}]})(props);
	};
	module.exports.FaWindowMinimize = function FaWindowMinimize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaWindowRestore = function FaWindowRestore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"}}]})(props);
	};
	module.exports.FaWineBottle = function FaWineBottle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"}}]})(props);
	};
	module.exports.FaWineGlassAlt = function FaWineGlassAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"}}]})(props);
	};
	module.exports.FaWineGlass = function FaWineGlass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"}}]})(props);
	};
	module.exports.FaWonSign = function FaWonSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"}}]})(props);
	};
	module.exports.FaWrench = function FaWrench (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"}}]})(props);
	};
	module.exports.FaXRay = function FaXRay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"}}]})(props);
	};
	module.exports.FaYenSign = function FaYenSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"}}]})(props);
	};
	module.exports.FaYinYang = function FaYinYang (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"}}]})(props);
	};
	module.exports.FaRegAddressBook = function FaRegAddressBook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"}}]})(props);
	};
	module.exports.FaRegAddressCard = function FaRegAddressCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"}}]})(props);
	};
	module.exports.FaRegAngry = function FaRegAngry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"}}]})(props);
	};
	module.exports.FaRegArrowAltCircleDown = function FaRegArrowAltCircleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"}}]})(props);
	};
	module.exports.FaRegArrowAltCircleLeft = function FaRegArrowAltCircleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"}}]})(props);
	};
	module.exports.FaRegArrowAltCircleRight = function FaRegArrowAltCircleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"}}]})(props);
	};
	module.exports.FaRegArrowAltCircleUp = function FaRegArrowAltCircleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"}}]})(props);
	};
	module.exports.FaRegBellSlash = function FaRegBellSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"}}]})(props);
	};
	module.exports.FaRegBell = function FaRegBell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"}}]})(props);
	};
	module.exports.FaRegBookmark = function FaRegBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"}}]})(props);
	};
	module.exports.FaRegBuilding = function FaRegBuilding (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"}}]})(props);
	};
	module.exports.FaRegCalendarAlt = function FaRegCalendarAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
	};
	module.exports.FaRegCalendarCheck = function FaRegCalendarCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"}}]})(props);
	};
	module.exports.FaRegCalendarMinus = function FaRegCalendarMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
	};
	module.exports.FaRegCalendarPlus = function FaRegCalendarPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
	};
	module.exports.FaRegCalendarTimes = function FaRegCalendarTimes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
	};
	module.exports.FaRegCalendar = function FaRegCalendar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"}}]})(props);
	};
	module.exports.FaRegCaretSquareDown = function FaRegCaretSquareDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
	};
	module.exports.FaRegCaretSquareLeft = function FaRegCaretSquareLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
	};
	module.exports.FaRegCaretSquareRight = function FaRegCaretSquareRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
	};
	module.exports.FaRegCaretSquareUp = function FaRegCaretSquareUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
	};
	module.exports.FaRegChartBar = function FaRegChartBar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"}}]})(props);
	};
	module.exports.FaRegCheckCircle = function FaRegCheckCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"}}]})(props);
	};
	module.exports.FaRegCheckSquare = function FaRegCheckSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"}}]})(props);
	};
	module.exports.FaRegCircle = function FaRegCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"}}]})(props);
	};
	module.exports.FaRegClipboard = function FaRegClipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"}}]})(props);
	};
	module.exports.FaRegClock = function FaRegClock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"}}]})(props);
	};
	module.exports.FaRegClone = function FaRegClone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"}}]})(props);
	};
	module.exports.FaRegClosedCaptioning = function FaRegClosedCaptioning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"}}]})(props);
	};
	module.exports.FaRegCommentAlt = function FaRegCommentAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"}}]})(props);
	};
	module.exports.FaRegCommentDots = function FaRegCommentDots (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"}}]})(props);
	};
	module.exports.FaRegComment = function FaRegComment (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"}}]})(props);
	};
	module.exports.FaRegComments = function FaRegComments (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"}}]})(props);
	};
	module.exports.FaRegCompass = function FaRegCompass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"}}]})(props);
	};
	module.exports.FaRegCopy = function FaRegCopy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"}}]})(props);
	};
	module.exports.FaRegCopyright = function FaRegCopyright (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"}}]})(props);
	};
	module.exports.FaRegCreditCard = function FaRegCreditCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"}}]})(props);
	};
	module.exports.FaRegDizzy = function FaRegDizzy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"}}]})(props);
	};
	module.exports.FaRegDotCircle = function FaRegDotCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"}}]})(props);
	};
	module.exports.FaRegEdit = function FaRegEdit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"}}]})(props);
	};
	module.exports.FaRegEnvelopeOpen = function FaRegEnvelopeOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"}}]})(props);
	};
	module.exports.FaRegEnvelope = function FaRegEnvelope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"}}]})(props);
	};
	module.exports.FaRegEyeSlash = function FaRegEyeSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"}}]})(props);
	};
	module.exports.FaRegEye = function FaRegEye (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"}}]})(props);
	};
	module.exports.FaRegFileAlt = function FaRegFileAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"}}]})(props);
	};
	module.exports.FaRegFileArchive = function FaRegFileArchive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"}}]})(props);
	};
	module.exports.FaRegFileAudio = function FaRegFileAudio (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"}}]})(props);
	};
	module.exports.FaRegFileCode = function FaRegFileCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"}}]})(props);
	};
	module.exports.FaRegFileExcel = function FaRegFileExcel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"}}]})(props);
	};
	module.exports.FaRegFileImage = function FaRegFileImage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"}}]})(props);
	};
	module.exports.FaRegFilePdf = function FaRegFilePdf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"}}]})(props);
	};
	module.exports.FaRegFilePowerpoint = function FaRegFilePowerpoint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"}}]})(props);
	};
	module.exports.FaRegFileVideo = function FaRegFileVideo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"}}]})(props);
	};
	module.exports.FaRegFileWord = function FaRegFileWord (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"}}]})(props);
	};
	module.exports.FaRegFile = function FaRegFile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"}}]})(props);
	};
	module.exports.FaRegFlag = function FaRegFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"}}]})(props);
	};
	module.exports.FaRegFlushed = function FaRegFlushed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"}}]})(props);
	};
	module.exports.FaRegFolderOpen = function FaRegFolderOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"}}]})(props);
	};
	module.exports.FaRegFolder = function FaRegFolder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"}}]})(props);
	};
	module.exports.FaRegFontAwesomeLogoFull = function FaRegFontAwesomeLogoFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 3992 512"},"child":[{"tag":"path","attr":{"d":"M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"}}]})(props);
	};
	module.exports.FaRegFrownOpen = function FaRegFrownOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"}}]})(props);
	};
	module.exports.FaRegFrown = function FaRegFrown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"}}]})(props);
	};
	module.exports.FaRegFutbol = function FaRegFutbol (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"}}]})(props);
	};
	module.exports.FaRegGem = function FaRegGem (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"}}]})(props);
	};
	module.exports.FaRegGrimace = function FaRegGrimace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"}}]})(props);
	};
	module.exports.FaRegGrinAlt = function FaRegGrinAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"}}]})(props);
	};
	module.exports.FaRegGrinBeamSweat = function FaRegGrinBeamSweat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"}}]})(props);
	};
	module.exports.FaRegGrinBeam = function FaRegGrinBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"}}]})(props);
	};
	module.exports.FaRegGrinHearts = function FaRegGrinHearts (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"}}]})(props);
	};
	module.exports.FaRegGrinSquintTears = function FaRegGrinSquintTears (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"}}]})(props);
	};
	module.exports.FaRegGrinSquint = function FaRegGrinSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"}}]})(props);
	};
	module.exports.FaRegGrinStars = function FaRegGrinStars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"}}]})(props);
	};
	module.exports.FaRegGrinTears = function FaRegGrinTears (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"}}]})(props);
	};
	module.exports.FaRegGrinTongueSquint = function FaRegGrinTongueSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"}}]})(props);
	};
	module.exports.FaRegGrinTongueWink = function FaRegGrinTongueWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"}}]})(props);
	};
	module.exports.FaRegGrinTongue = function FaRegGrinTongue (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaRegGrinWink = function FaRegGrinWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"}}]})(props);
	};
	module.exports.FaRegGrin = function FaRegGrin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"}}]})(props);
	};
	module.exports.FaRegHandLizard = function FaRegHandLizard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"}}]})(props);
	};
	module.exports.FaRegHandPaper = function FaRegHandPaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"}}]})(props);
	};
	module.exports.FaRegHandPeace = function FaRegHandPeace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"}}]})(props);
	};
	module.exports.FaRegHandPointDown = function FaRegHandPointDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"}}]})(props);
	};
	module.exports.FaRegHandPointLeft = function FaRegHandPointLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"}}]})(props);
	};
	module.exports.FaRegHandPointRight = function FaRegHandPointRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"}}]})(props);
	};
	module.exports.FaRegHandPointUp = function FaRegHandPointUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"}}]})(props);
	};
	module.exports.FaRegHandPointer = function FaRegHandPointer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"}}]})(props);
	};
	module.exports.FaRegHandRock = function FaRegHandRock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"}}]})(props);
	};
	module.exports.FaRegHandScissors = function FaRegHandScissors (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"}}]})(props);
	};
	module.exports.FaRegHandSpock = function FaRegHandSpock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"}}]})(props);
	};
	module.exports.FaRegHandshake = function FaRegHandshake (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"}}]})(props);
	};
	module.exports.FaRegHdd = function FaRegHdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"}}]})(props);
	};
	module.exports.FaRegHeart = function FaRegHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"}}]})(props);
	};
	module.exports.FaRegHospital = function FaRegHospital (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"}}]})(props);
	};
	module.exports.FaRegHourglass = function FaRegHourglass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"}}]})(props);
	};
	module.exports.FaRegIdBadge = function FaRegIdBadge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"}}]})(props);
	};
	module.exports.FaRegIdCard = function FaRegIdCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"}}]})(props);
	};
	module.exports.FaRegImage = function FaRegImage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"}}]})(props);
	};
	module.exports.FaRegImages = function FaRegImages (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"}}]})(props);
	};
	module.exports.FaRegKeyboard = function FaRegKeyboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"}}]})(props);
	};
	module.exports.FaRegKissBeam = function FaRegKissBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"}}]})(props);
	};
	module.exports.FaRegKissWinkHeart = function FaRegKissWinkHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 504 512"},"child":[{"tag":"path","attr":{"d":"M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"}}]})(props);
	};
	module.exports.FaRegKiss = function FaRegKiss (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaRegLaughBeam = function FaRegLaughBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"}}]})(props);
	};
	module.exports.FaRegLaughSquint = function FaRegLaughSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"}}]})(props);
	};
	module.exports.FaRegLaughWink = function FaRegLaughWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"}}]})(props);
	};
	module.exports.FaRegLaugh = function FaRegLaugh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"}}]})(props);
	};
	module.exports.FaRegLemon = function FaRegLemon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"}}]})(props);
	};
	module.exports.FaRegLifeRing = function FaRegLifeRing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"}}]})(props);
	};
	module.exports.FaRegLightbulb = function FaRegLightbulb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"}}]})(props);
	};
	module.exports.FaRegListAlt = function FaRegListAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"}}]})(props);
	};
	module.exports.FaRegMap = function FaRegMap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"}}]})(props);
	};
	module.exports.FaRegMehBlank = function FaRegMehBlank (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaRegMehRollingEyes = function FaRegMehRollingEyes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"}}]})(props);
	};
	module.exports.FaRegMeh = function FaRegMeh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"}}]})(props);
	};
	module.exports.FaRegMinusSquare = function FaRegMinusSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
	};
	module.exports.FaRegMoneyBillAlt = function FaRegMoneyBillAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"}}]})(props);
	};
	module.exports.FaRegMoon = function FaRegMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"}}]})(props);
	};
	module.exports.FaRegNewspaper = function FaRegNewspaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"}}]})(props);
	};
	module.exports.FaRegObjectGroup = function FaRegObjectGroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"}}]})(props);
	};
	module.exports.FaRegObjectUngroup = function FaRegObjectUngroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"}}]})(props);
	};
	module.exports.FaRegPaperPlane = function FaRegPaperPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"}}]})(props);
	};
	module.exports.FaRegPauseCircle = function FaRegPauseCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaRegPlayCircle = function FaRegPlayCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"}}]})(props);
	};
	module.exports.FaRegPlusSquare = function FaRegPlusSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
	};
	module.exports.FaRegQuestionCircle = function FaRegQuestionCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"}}]})(props);
	};
	module.exports.FaRegRegistered = function FaRegRegistered (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"}}]})(props);
	};
	module.exports.FaRegSadCry = function FaRegSadCry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"}}]})(props);
	};
	module.exports.FaRegSadTear = function FaRegSadTear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"}}]})(props);
	};
	module.exports.FaRegSave = function FaRegSave (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"}}]})(props);
	};
	module.exports.FaRegShareSquare = function FaRegShareSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"}}]})(props);
	};
	module.exports.FaRegSmileBeam = function FaRegSmileBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"}}]})(props);
	};
	module.exports.FaRegSmileWink = function FaRegSmileWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"}}]})(props);
	};
	module.exports.FaRegSmile = function FaRegSmile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"}}]})(props);
	};
	module.exports.FaRegSnowflake = function FaRegSnowflake (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"}}]})(props);
	};
	module.exports.FaRegSquare = function FaRegSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"}}]})(props);
	};
	module.exports.FaRegStarHalf = function FaRegStarHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"}}]})(props);
	};
	module.exports.FaRegStar = function FaRegStar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"}}]})(props);
	};
	module.exports.FaRegStickyNote = function FaRegStickyNote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"}}]})(props);
	};
	module.exports.FaRegStopCircle = function FaRegStopCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaRegSun = function FaRegSun (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"}}]})(props);
	};
	module.exports.FaRegSurprise = function FaRegSurprise (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaRegThumbsDown = function FaRegThumbsDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"}}]})(props);
	};
	module.exports.FaRegThumbsUp = function FaRegThumbsUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"}}]})(props);
	};
	module.exports.FaRegTimesCircle = function FaRegTimesCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"}}]})(props);
	};
	module.exports.FaRegTired = function FaRegTired (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"}}]})(props);
	};
	module.exports.FaRegTrashAlt = function FaRegTrashAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"}}]})(props);
	};
	module.exports.FaRegUserCircle = function FaRegUserCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"}}]})(props);
	};
	module.exports.FaRegUser = function FaRegUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"}}]})(props);
	};
	module.exports.FaRegWindowClose = function FaRegWindowClose (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"}}]})(props);
	};
	module.exports.FaRegWindowMaximize = function FaRegWindowMaximize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"}}]})(props);
	};
	module.exports.FaRegWindowMinimize = function FaRegWindowMinimize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaRegWindowRestore = function FaRegWindowRestore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"}}]})(props);
	};


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _slider = _interopRequireDefault(__webpack_require__(1001));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _slider["default"];
	exports["default"] = _default;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(474);

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _userSession = __webpack_require__(30);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _PopupRegister = __webpack_require__(97);
	
	var _PopupRegister2 = _interopRequireDefault(_PopupRegister);
	
	var _PopupIndex = __webpack_require__(84);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _BookAppointmentPopup = __webpack_require__(60);
	
	var _BookAppointmentPopup2 = _interopRequireDefault(_BookAppointmentPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var loginUser = function loginUser(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request("/mmphonenumber", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var SendOTPMessage = function SendOTPMessage(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosSMS.request("/user/sendotp", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var SaveOTPNumber = function SaveOTPNumber(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/user/saveotpnumber", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getOtpData = function getOtpData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/user/getotpdata", {
	      method: "get",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var ResetOtpData = function ResetOtpData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/user/resetotpdata", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var LoginPatient = function LoginPatient(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request("/mmlogin", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var LoginPatientIdCheck = function LoginPatientIdCheck(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/login", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: {
	        // ...data,
	        email: data.patientid,
	        password: data.password
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var PatitentDetails = function PatitentDetails(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request("/patients", {
	      method: "get",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      resolve(res.data);
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var activateaccount = function activateaccount(url) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request(url, {
	      method: "post"
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var PopupIndex4 = function (_Component) {
	  _inherits(PopupIndex4, _Component);
	
	  function PopupIndex4() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopupIndex4);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupIndex4.__proto__ || Object.getPrototypeOf(PopupIndex4)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      patient_id: "",
	      password: "",
	      phone_number: "",
	      user_token: "",
	      otp: "",
	      enableLoginBtn: false,
	      signin_success: false,
	      user_active: false,
	      first_otp: "",
	      second_otp: "",
	      third_otp: "",
	      fourth_otp: "",
	      fifth_otp: "",
	      sixth_otp: "",
	      final_otp: "",
	      otp_number: "",
	      showRegisterPopup: false,
	      showPopup: false,
	      showDoctorListPopup: false
	    }, _this.handleChange = function (event) {
	      /*this.setState({ errors:''});
	      let fields = this.state.fields;
	      fields[event.target.name] = event.target.value;*/
	      /*if(event.target.value.length === event.target.maxLength) {
	        document.getElementById("basic-addon2").style.pointerEvents = "visible";
	        document.getElementById("basic-addon2").style.background = "#fb6201";
	        document.getElementById("basic-addon2").style.color = "#ffffff";
	        document.getElementById("basic-addon2").style.textDecoration = "none";
	        document.getElementById("basic-addon2").style.cursor = "pointer";
	      } else {
	        document.getElementById("basic-addon2").style.pointerEvents = "none";
	        document.getElementById("basic-addon2").style.background = "#e9ecef";
	        document.getElementById("basic-addon2").style.color = "#212529";
	        document.getElementById("basic-addon2").style.textDecoration = "none";
	        document.getElementById("basic-addon2").style.cursor = "default";
	      }
	      var phone_number = document.getElementById("phone_number").value;
	      var first_otp = document.getElementById("first_otp").value;
	      var second_otp = document.getElementById("second_otp").value;
	      var third_otp = document.getElementById("third_otp").value;
	      var fourth_otp = document.getElementById("fourth_otp").value;
	      var fifth_otp = document.getElementById("fifth_otp").value;
	      var sixth_otp = document.getElementById("sixth_otp").value;
	      var patient_id = document.getElementById("patient_id").value;
	      if(patient_id){
	        document.getElementById("black-btn").disabled = false;
	        document.getElementById("phone_number").disabled = true;
	        document.getElementById("first_otp").disabled = true;
	        document.getElementById("second_otp").disabled = true;
	        document.getElementById("third_otp").disabled = true;
	        document.getElementById("fourth_otp").disabled = true;
	        document.getElementById("fifth_otp").disabled = true;
	        document.getElementById("sixth_otp").disabled = true;
	        document.getElementById("black-btn").style.background = "#fb6201";
	      } else {
	        if(first_otp!=='' && second_otp!=='' && third_otp!=='' && fourth_otp!=='' && fifth_otp!=='' && sixth_otp!==''){
	          let final_otp = first_otp+second_otp+third_otp+fourth_otp+fifth_otp+sixth_otp;
	          this.setState({final_otp: final_otp});
	          if(final_otp){
	            this.refreshGetOTPData();
	          } else {
	            document.getElementById("black-btn").disabled = true;
	            document.getElementById("black-btn").style.background = "#41414b";
	          }
	        } else {
	          document.getElementById("black-btn").disabled = true;
	          document.getElementById("black-btn").style.background = "#41414b";
	          $('#otp_error').text('');
	        }
	        if(phone_number===''){
	          document.getElementById("black-btn").disabled = true;
	          document.getElementById("black-btn").style.background = "#41414b";
	          document.getElementById("basic-addon2").disabled = true;
	          document.getElementById("basic-addon2").style.background = "#e9ecef";
	          this.setState({first_otp: ''});
	          this.setState({second_otp: ''});
	          this.setState({third_otp: ''});
	          this.setState({fourth_otp: ''});
	          this.setState({fifth_otp: ''});
	          this.setState({sixth_otp: ''});
	        }
	        document.getElementById("black-btn").disabled = true;
	        document.getElementById("phone_number").disabled = false;
	        document.getElementById("first_otp").disabled = false;
	        document.getElementById("second_otp").disabled = false;
	        document.getElementById("third_otp").disabled = false;
	        document.getElementById("fourth_otp").disabled = false;
	        document.getElementById("fifth_otp").disabled = false;
	        document.getElementById("sixth_otp").disabled = false;
	      }*/
	      /*this.setState({
	          fields
	      }, () => this.validateForm());*/
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.onKeyUpMoveInputfocus = function (event) {
	      if (event.target.value.length === event.target.maxLength) {
	        var $next = (0, _jquery2.default)(event.target).next(".otp_input");
	        if ($next.length) {
	          (0, _jquery2.default)(event.target).next(".otp_input").focus();
	        } else {
	          (0, _jquery2.default)(event.target).blur();
	        }
	      }
	    }, _this.sendOtp = function (event) {
	      (0, _jquery2.default)(".otp_resend").show();
	      //let six_digit_random_number = Math.floor(100000 + Math.random() * 999999);
	      var six_digit_random_number = Math.floor(Math.random() * 900000) + 100000;
	      var encoded_otp = "";
	      var otp_number = btoa(six_digit_random_number);
	      for (var i = 0; i < otp_number.length; i++) {
	        var a = otp_number.charCodeAt(i);
	        var b = a ^ 10;
	        encoded_otp += String.fromCharCode(b);
	      }
	      var new_encoded_otp = btoa(encoded_otp);
	
	      var messageBody = "Your Login OTP is " + six_digit_random_number;
	      var encoded = "";
	      var messageBodyText = btoa(messageBody);
	      for (var _i = 0; _i < messageBodyText.length; _i++) {
	        var c = messageBodyText.charCodeAt(_i);
	        var d = c ^ 10;
	        encoded += String.fromCharCode(d);
	      }
	      var encoded_message_body = btoa(encoded);
	      var csms_generate_number = Math.random().toString(36).substring(2, 11);
	      var csmsId = csms_generate_number;
	      var data = {
	        phone_number: _this.state.phone_number,
	        message_body: encoded_message_body,
	        csms_id: csmsId
	      };
	      SendOTPMessage(data).then(function (res) {
	        if (res.status === "SUCCESS") {
	          _this.saveOtp(new_encoded_otp);
	          _reactToastify.toast.success("OTP sent to your phone number!", {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        } else {
	          _reactToastify.toast.error("Otp not send", {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("Error occured", {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.ResendOtp = function (event) {
	      (0, _jquery2.default)(".otp_resend").hide();
	      //let six_digit_random_number = Math.floor(100000 + Math.random() * 999999);
	      var six_digit_random_number = Math.floor(Math.random() * 900000) + 100000;
	      var encoded_otp = "";
	      var otp_number = btoa(six_digit_random_number);
	      for (var i = 0; i < otp_number.length; i++) {
	        var a = otp_number.charCodeAt(i);
	        var b = a ^ 10;
	        encoded_otp += String.fromCharCode(b);
	      }
	      var new_encoded_otp = btoa(encoded_otp);
	
	      var messageBody = "Your Login OTP is " + six_digit_random_number;
	      var encoded = "";
	      var messageBodyText = btoa(messageBody);
	      for (var _i2 = 0; _i2 < messageBodyText.length; _i2++) {
	        var c = messageBodyText.charCodeAt(_i2);
	        var d = c ^ 10;
	        encoded += String.fromCharCode(d);
	      }
	      var encoded_message_body = btoa(encoded);
	      var csms_generate_number = Math.random().toString(36).substring(2, 11);
	      var csmsId = csms_generate_number;
	      var data = {
	        phone_number: _this.state.phone_number,
	        message_body: encoded_message_body,
	        csms_id: csmsId
	      };
	      SendOTPMessage(data).then(function (res) {
	        if (res.status === "SUCCESS") {
	          _this.saveOtp(new_encoded_otp);
	          _reactToastify.toast.success("OTP sent to your phone number!", {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        } else {
	          _reactToastify.toast.error("Otp not send", {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("Error occured", {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.saveOtp = function (otp) {
	      var data = {
	        phone_number: _this.state.phone_number,
	        otp_number: otp
	      };
	      SaveOTPNumber(data).then(function (res) {
	        if (res.data === "success") {} else {}
	      }).catch(function (err) {
	        _reactToastify.toast.error("Error occured", {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.handleSubmit = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(event) {
	        var patient_id, password, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                event.preventDefault();
	                patient_id = _this.state.patient_id;
	                password = _this.state.password;
	                data = {
	                  patientid: patient_id,
	                  password: password
	                };
	
	
	                LoginPatientIdCheck(data).then(function (res) {
	                  if (res.status == false) {
	                    _reactToastify.toast.error("Invalid credentials", {
	                      position: _reactToastify.toast.POSITION.TOP_LEFT
	                    });
	                    return;
	                  }
	
	                  // const inputDate = localStorage.getItem(res.data.date_of_birth);
	                  var inputDate = res.data.date_of_birth;
	                  // Convert input date to Date object
	                  var dateObj = new Date(inputDate);
	
	                  // Extract year, month, and day from the Date object
	                  var year = dateObj.getFullYear();
	                  var month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // Adding 1 as month starts from 0
	                  var day = ("0" + dateObj.getDate()).slice(-2);
	
	                  // Form the desired date string
	                  var formattedDate = year + "-" + month + "-" + day;
	                  // console.log("formattedDate", formattedDate);
	                  // console.log("sobar", res);
	                  var token = res.token;
	                  var user_role = "2";
	                  var user_email = res.data.email;
	                  var login_phone_number = res.data.phone;
	                  var uid = res.data.patient_id ? res.data.patient_id : "";
	                  var search_selected_doc_id = "";
	                  var schedule_date = "";
	                  var apointment_id = "";
	                  var doctor_name = "";
	                  var doctor_fees = "";
	                  var patientName = res.data.fullname;
	                  var schedule_time = "";
	                  var search_selected_doc_name = "";
	                  var doctor_profile_avability = "";
	                  var localId = res.data.id;
	                  var date_of_birth = formattedDate;
	                  // window.location.reload(true);
	                  (0, _userSession.startUserSession)(token, user_role, user_email, uid, login_phone_number, search_selected_doc_id, schedule_date, apointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name, doctor_profile_avability, localId, date_of_birth);
	
	                  if (localStorage.getItem(_constants.USER_LOCAL_ID)) {
	                    window.location.reload(true);
	                  }
	                  //
	                }).catch(function (err) {
	                  console.log(err);
	                });
	
	                /* if (patient_id) {
	                  this.LoginPaitentId(patient_id, password);
	                } else {
	                  if (this.validateForm()) {
	                    let fields = {};
	                    fields["phone_number"] = "";
	                    this.setState({ fields: fields });
	                    const user = {
	                      PhoneNumber: this.state.fields.phone_number,
	                    };
	                      loginUser(user)
	                      .then((res) => {
	                        if (res.length > 1) {
	                          let token = "";
	                          let user_role = "2";
	                          let user_email = "";
	                          let phone_number = this.state.phone_number;
	                          let search_selected_doc_id = "";
	                          let patientid = "";
	                          let schedule_date = "";
	                          let apointment_id = "";
	                          let doctor_name = "";
	                          let doctor_fees = "";
	                          let patientName = "";
	                          let schedule_time = "";
	                          let search_selected_doc_name = "";
	                          let doctor_profile_avability = this.props.doctorProfilePageClick;
	                            startUserSession(
	                            token,
	                            user_role,
	                            user_email,
	                            patientid,
	                            phone_number,
	                            search_selected_doc_id,
	                            schedule_date,
	                            apointment_id,
	                            doctor_name,
	                            doctor_fees,
	                            patientName,
	                            schedule_time,
	                            search_selected_doc_name,
	                            doctor_profile_avability
	                          );
	                          this.props.nextStep();
	                        } else {
	                          let patient_id = res[0].PatientID;
	                          let patient_name = res[0].PatientName;
	                          let phone_number = this.state.phone_number;
	                          const data = {
	                            patientid: patient_id,
	                          };
	                          this.PatientLoginSubmit(data, phone_number, patient_name);
	                        }
	                      })
	                      .catch((err) => {
	                        console.log(err);
	                      });
	                  } else {
	                  }
	                } */
	
	              case 5:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }(), _this.ShowRegisterPopup = function (e) {
	      (0, _jquery2.default)(".login_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".login_popup").removeClass("show");
	      (0, _jquery2.default)(".register_popup").css("visibility", "visible");
	      (0, _jquery2.default)(".register_popup").addClass("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	      _this.setState({
	        showRegisterPopup: true
	      });
	    }, _this.closePopup = function (event) {
	      (0, _jquery2.default)(".login_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".login_popup").removeClass("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  /*validateForm() {
	    let fields = this.state.fields;
	    let errors = {};
	    let formIsValid = true;
	    let patient_id = document.getElementById("patient_id").value;
	    if(patient_id){
	    } else {
	      if (!fields["phone_number"]) {
	          formIsValid = false;
	          errors["phone_number"] = "*Please enter your phone number.";
	      }
	    }
	    this.setState({
	        errors: errors
	    });
	    return formIsValid;
	  }*/
	
	  /* LoginPaitentId = (patient_id, password) => {
	    let login_phone_number = "";
	    let search_selected_doc_id = "";
	    let schedule_date = "";
	    let apointment_id = "";
	    let doctor_name = "";
	    let doctor_fees = "";
	    let patientName = "";
	    let schedule_time = "";
	    let search_selected_doc_name = "";
	    let doctor_profile_avability = "";
	    const data = {
	      patientid: patient_id,
	      password: password,
	    };
	    LoginPatientIdCheck(data)
	      .then((res) => {
	        if (res.status == true) {
	          if (res.data.patient_id == "" || res.data.patient_id == null) {
	            window.location.href = "/popuppatientid?userid=" + res.data.id;
	          } else {
	            const data = {
	              patientid: res.data.patient_id,
	            };
	            LoginPatient(data)
	              .then((res) => {
	                const data = {
	                  patient: res[0]["pid"],
	                };
	                let token = "";
	                let user_role = "2";
	                let user_email = "";
	                PatitentDetails(data)
	                  .then((patient_details_res) => {
	                    let token = "";
	                    let user_role = "2";
	                    let user_email = "";
	                    let login_phone_number =
	                      patient_details_res[0].patient_phone;
	                      let search_selected_doc_id = "";
	                    let schedule_date = "";
	                    let apointment_id = "";
	                    let doctor_name = "";
	                    let doctor_fees = "";
	                    let patientName = patient_details_res[0].patient_name;
	                    let schedule_time = "";
	                    let search_selected_doc_name = "";
	                    let doctor_profile_avability = "";
	                    startUserSession(
	                      token,
	                      user_role,
	                      user_email,
	                      res[0]["pid"],
	                      login_phone_number,
	                      search_selected_doc_id,
	                      schedule_date,
	                      apointment_id,
	                      doctor_name,
	                      doctor_fees,
	                      patientName,
	                      schedule_time,
	                      search_selected_doc_name,
	                      doctor_profile_avability
	                    );
	                    //window.location.href = '/dashboard/patient-dashboard';
	                    this.props.nextStep();
	                  })
	                  .catch((err) => {
	                    console.log(err);
	                  });
	                startUserSession(
	                  token,
	                  user_role,
	                  user_email,
	                  patient_id,
	                  login_phone_number,
	                  search_selected_doc_id,
	                  schedule_date,
	                  apointment_id,
	                  doctor_name,
	                  doctor_fees,
	                  patientName,
	                  schedule_time,
	                  search_selected_doc_name,
	                  doctor_profile_avability
	                );
	                this.setState({ signin_success: true });
	                //this.props.nextStep();
	              })
	              .catch((err) => {
	                console.log(err);
	              });
	          }
	        }
	      })
	      .catch((err) => {
	        console.log(err);
	      });
	  };
	  PatientLoginSubmit = (data, phone_number, patient_name) => {
	    let user_role = "2";
	    let user_email = "";
	    let login_phone_number = phone_number;
	    let search_selected_doc_id = "";
	    let schedule_date = "";
	    let apointment_id = "";
	    let doctor_name = "";
	    let doctor_fees = "";
	    let patientName = patient_name;
	    let schedule_time = "";
	    let search_selected_doc_name = "";
	    let doctor_profile_avability = this.props.doctorProfilePageClick;
	    LoginPatient(data)
	      .then((res) => {
	        if (!!res[0].token) {
	          startUserSession(
	            res[0].token,
	            user_role,
	            user_email,
	            data.patientid,
	            login_phone_number,
	            search_selected_doc_id,
	            schedule_date,
	            apointment_id,
	            doctor_name,
	            doctor_fees,
	            patientName,
	            schedule_time,
	            search_selected_doc_name,
	            doctor_profile_avability
	          );
	          this.setState({ signin_success: true });
	          this.refreshResetOTPData();
	          this.props.nextStep();
	        } else {
	          toast.error(res.message, {
	            position: toast.POSITION.TOP_LEFT,
	          });
	        }
	      })
	      .catch((err) => {
	        console.log(err);
	      });
	  };
	  refreshGetOTPData = (event) => {
	    const data = {
	      phone_number: this.state.phone_number,
	    };
	    getOtpData(data)
	      .then((res) => {
	        if (res.status === true) {
	          this.setState({ otp_number: res.data.otp });
	          if (
	            this.state.final_otp === res.data.otp ||
	            this.state.final_otp === "111111"
	          ) {
	            document.getElementById("black-btn").disabled = false;
	            document.getElementById("black-btn").style.background = "#fb6201";
	          } else {
	            document.getElementById("black-btn").disabled = true;
	            document.getElementById("black-btn").style.background = "#41414b";
	            $("#otp_error").text("");
	          }
	        } else {
	          toast.error("otp data not found", {
	            position: toast.POSITION.TOP_LEFT,
	          });
	        }
	      })
	      .catch((err) => {
	        toast.error("Error occured", {
	          position: toast.POSITION.TOP_LEFT,
	        });
	      });
	  };
	  refreshResetOTPData = (event) => {
	    const data = {
	      phone_number: this.state.phone_number,
	    };
	    ResetOtpData(data)
	      .then((res) => {
	        if (res.status === true) {
	        } else {
	        }
	      })
	      .catch((err) => {
	        toast.error("Error occured", {
	          position: toast.POSITION.TOP_LEFT,
	        });
	      });
	  }; */
	
	
	  _createClass(PopupIndex4, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var search = window.location.search;
	      var params = new URLSearchParams(search);
	      var update_success = params.get("update_success");
	      var active_code = params.get("active_code");
	      if (update_success) {
	        (0, _jquery2.default)(".login_popup").addClass("show");
	      }
	      if (active_code) {
	        //var CHK_USER_ID = localStorage.getItem(USER_ID);
	        (0, _jquery2.default)(".login_popup").addClass("show");
	        var url = "/account/activation/" + active_code;
	        activateaccount(url, active_code).then(function (res) {
	          if (res.status == true) {
	            _reactToastify.toast.success(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	            /*if(CHK_USER_ID==null) {
	              window.location.href = '/login';
	            } else {
	              this.setState({
	                signin_success: true,
	              });
	            }*/
	          } else {
	            _reactToastify.toast.error(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          }
	        }).catch(function (err) {
	          console.log(err);
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            className: "offcanvas offcanvas-start login_popup",
	            tabIndex: -1,
	            id: "offcanvasExample",
	            "aria-labelledby": "offcanvasExampleLabel",
	            style: { visibility: "visible" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-header" },
	            _react2.default.createElement(
	              "h5",
	              { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	              " "
	            ),
	            _react2.default.createElement("button", {
	              type: "button",
	              className: "btn-close text-reset",
	              "data-bs-dismiss": "offcanvas",
	              "aria-label": "Close",
	              onClick: this.closePopup
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-body" },
	            _react2.default.createElement(
	              "div",
	              { className: "left-offcanvas" },
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex justify-content-center" },
	                _react2.default.createElement("img", {
	                  className: "img-fluid",
	                  src: "/assets/images/united_logo.png",
	                  alt: "logo"
	                })
	              ),
	              _react2.default.createElement(
	                "h4",
	                {
	                  className: "my-2",
	                  style: {
	                    fontSize: "2rem",
	                    textAlign: "center",
	                    color: "#af9763"
	                  }
	                },
	                "Take better care of your family"
	              ),
	              _react2.default.createElement(
	                "form",
	                {
	                  onSubmit: this.handleSubmit,
	                  id: "loginform",
	                  className: "needs-validation mt-5",
	                  noValidate: true
	                },
	                _react2.default.createElement("input", {
	                  placeholder: "Enter username",
	                  type: "text",
	                  id: "patient_id",
	                  name: "patient_id",
	                  value: this.state.fields.patient_id,
	                  onChange: this.handleChange,
	                  autoComplete: "off",
	                  className: "form-control"
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: " mt-3" },
	                  _react2.default.createElement("input", {
	                    type: "password",
	                    className: "form-control",
	                    placeholder: "Password",
	                    name: "password",
	                    id: "password",
	                    value: this.state.fields.password,
	                    onChange: this.handleChange,
	                    required: true,
	                    autoComplete: "off"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-3" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 ",
	                      style: {
	                        display: "flex",
	                        justifyContent: "flex-end",
	                        alignItems: "flex-end"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "/forgot-pass", className: "mt-2 text-right" },
	                      "Forgotten password?"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12 mt-2" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "submit",
	                        id: "black-btn",
	                        disabled: this.state.patient_id && this.state.password ? false : true,
	                        style: {
	                          backgroundColor: this.state.patient_id && this.state.password ? "#187979" : "#41414b"
	                        }
	                      },
	                      " ",
	                      "Log in",
	                      " "
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 mt-3",
	                      style: { display: "flex", justifyContent: "center" }
	                    },
	                    _react2.default.createElement(
	                      "h1",
	                      { style: { fontSize: "14px" } },
	                      "Don\u2019t have account?",
	                      _react2.default.createElement(
	                        "span",
	                        {
	                          "data-bs-toggle": "modal",
	                          "data-bs-target": "#registerModal",
	                          style: {
	                            color: "#187979",
	                            cursor: "pointer",
	                            fontWeight: "600"
	                          },
	                          className: "ms-2",
	                          onClick: this.ShowRegisterPopup
	                        },
	                        "Create new account"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        this.state.showRegisterPopup ? _react2.default.createElement(_PopupRegister2.default, { showPopup: this.state.showRegisterPopup }) : null,
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return PopupIndex4;
	}(_react.Component);
	
	exports.default = PopupIndex4;

/***/ },
/* 66 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDefaultOptions = getDefaultOptions;
	exports.setDefaultOptions = setDefaultOptions;
	var defaultOptions = {};
	function getDefaultOptions() {
	  return defaultOptions;
	}
	function setDefaultOptions(newOptions) {
	  defaultOptions = newOptions;
	}

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	var _interopRequireWildcard = __webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_VisibleCellRange = exports.bpfrpt_proptype_Alignment = exports.bpfrpt_proptype_OverscanIndicesGetter = exports.bpfrpt_proptype_OverscanIndices = exports.bpfrpt_proptype_OverscanIndicesGetterParams = exports.bpfrpt_proptype_RenderedSection = exports.bpfrpt_proptype_ScrollbarPresenceChange = exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_NoContentRenderer = exports.bpfrpt_proptype_CellSize = exports.bpfrpt_proptype_CellSizeGetter = exports.bpfrpt_proptype_CellRangeRenderer = exports.bpfrpt_proptype_CellRangeRendererParams = exports.bpfrpt_proptype_StyleCache = exports.bpfrpt_proptype_CellCache = exports.bpfrpt_proptype_CellRenderer = exports.bpfrpt_proptype_CellRendererParams = exports.bpfrpt_proptype_CellPosition = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _ScalingCellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(172));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var bpfrpt_proptype_CellPosition =  true ? null : {
	  "columnIndex": _propTypes["default"].number.isRequired,
	  "rowIndex": _propTypes["default"].number.isRequired
	};
	exports.bpfrpt_proptype_CellPosition = bpfrpt_proptype_CellPosition;
	var bpfrpt_proptype_CellRendererParams =  true ? null : {
	  "columnIndex": _propTypes["default"].number.isRequired,
	  "isScrolling": _propTypes["default"].bool.isRequired,
	  "isVisible": _propTypes["default"].bool.isRequired,
	  "key": _propTypes["default"].string.isRequired,
	  "parent": _propTypes["default"].object.isRequired,
	  "rowIndex": _propTypes["default"].number.isRequired,
	  "style": _propTypes["default"].object.isRequired
	};
	exports.bpfrpt_proptype_CellRendererParams = bpfrpt_proptype_CellRendererParams;
	var bpfrpt_proptype_CellRenderer =  true ? null : _propTypes["default"].func;
	exports.bpfrpt_proptype_CellRenderer = bpfrpt_proptype_CellRenderer;
	var bpfrpt_proptype_CellCache =  true ? null : _propTypes["default"].objectOf(_propTypes["default"].node.isRequired);
	exports.bpfrpt_proptype_CellCache = bpfrpt_proptype_CellCache;
	var bpfrpt_proptype_StyleCache =  true ? null : _propTypes["default"].objectOf(_propTypes["default"].object.isRequired);
	exports.bpfrpt_proptype_StyleCache = bpfrpt_proptype_StyleCache;
	var bpfrpt_proptype_CellRangeRendererParams =  true ? null : {
	  "cellCache": _propTypes["default"].objectOf(_propTypes["default"].node.isRequired).isRequired,
	  "cellRenderer": _propTypes["default"].func.isRequired,
	  "columnSizeAndPositionManager": function columnSizeAndPositionManager() {
	    return (typeof _ScalingCellSizeAndPositionManager["default"] === "function" ? _propTypes["default"].instanceOf(_ScalingCellSizeAndPositionManager["default"]).isRequired : _propTypes["default"].any.isRequired).apply(this, arguments);
	  },
	  "columnStartIndex": _propTypes["default"].number.isRequired,
	  "columnStopIndex": _propTypes["default"].number.isRequired,
	  "deferredMeasurementCache": _propTypes["default"].object,
	  "horizontalOffsetAdjustment": _propTypes["default"].number.isRequired,
	  "isScrolling": _propTypes["default"].bool.isRequired,
	  "isScrollingOptOut": _propTypes["default"].bool.isRequired,
	  "parent": _propTypes["default"].object.isRequired,
	  "rowSizeAndPositionManager": function rowSizeAndPositionManager() {
	    return (typeof _ScalingCellSizeAndPositionManager["default"] === "function" ? _propTypes["default"].instanceOf(_ScalingCellSizeAndPositionManager["default"]).isRequired : _propTypes["default"].any.isRequired).apply(this, arguments);
	  },
	  "rowStartIndex": _propTypes["default"].number.isRequired,
	  "rowStopIndex": _propTypes["default"].number.isRequired,
	  "scrollLeft": _propTypes["default"].number.isRequired,
	  "scrollTop": _propTypes["default"].number.isRequired,
	  "styleCache": _propTypes["default"].objectOf(_propTypes["default"].object.isRequired).isRequired,
	  "verticalOffsetAdjustment": _propTypes["default"].number.isRequired,
	  "visibleColumnIndices": _propTypes["default"].object.isRequired,
	  "visibleRowIndices": _propTypes["default"].object.isRequired
	};
	exports.bpfrpt_proptype_CellRangeRendererParams = bpfrpt_proptype_CellRangeRendererParams;
	var bpfrpt_proptype_CellRangeRenderer =  true ? null : _propTypes["default"].func;
	exports.bpfrpt_proptype_CellRangeRenderer = bpfrpt_proptype_CellRangeRenderer;
	var bpfrpt_proptype_CellSizeGetter =  true ? null : _propTypes["default"].func;
	exports.bpfrpt_proptype_CellSizeGetter = bpfrpt_proptype_CellSizeGetter;
	var bpfrpt_proptype_CellSize =  true ? null : _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].number]);
	exports.bpfrpt_proptype_CellSize = bpfrpt_proptype_CellSize;
	var bpfrpt_proptype_NoContentRenderer =  true ? null : _propTypes["default"].func;
	exports.bpfrpt_proptype_NoContentRenderer = bpfrpt_proptype_NoContentRenderer;
	var bpfrpt_proptype_Scroll =  true ? null : {
	  "clientHeight": _propTypes["default"].number.isRequired,
	  "clientWidth": _propTypes["default"].number.isRequired,
	  "scrollHeight": _propTypes["default"].number.isRequired,
	  "scrollLeft": _propTypes["default"].number.isRequired,
	  "scrollTop": _propTypes["default"].number.isRequired,
	  "scrollWidth": _propTypes["default"].number.isRequired
	};
	exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;
	var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : {
	  "horizontal": _propTypes["default"].bool.isRequired,
	  "vertical": _propTypes["default"].bool.isRequired,
	  "size": _propTypes["default"].number.isRequired
	};
	exports.bpfrpt_proptype_ScrollbarPresenceChange = bpfrpt_proptype_ScrollbarPresenceChange;
	var bpfrpt_proptype_RenderedSection =  true ? null : {
	  "columnOverscanStartIndex": _propTypes["default"].number.isRequired,
	  "columnOverscanStopIndex": _propTypes["default"].number.isRequired,
	  "columnStartIndex": _propTypes["default"].number.isRequired,
	  "columnStopIndex": _propTypes["default"].number.isRequired,
	  "rowOverscanStartIndex": _propTypes["default"].number.isRequired,
	  "rowOverscanStopIndex": _propTypes["default"].number.isRequired,
	  "rowStartIndex": _propTypes["default"].number.isRequired,
	  "rowStopIndex": _propTypes["default"].number.isRequired
	};
	exports.bpfrpt_proptype_RenderedSection = bpfrpt_proptype_RenderedSection;
	var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : {
	  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
	  "direction": _propTypes["default"].oneOf(["horizontal", "vertical"]).isRequired,
	  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
	  "scrollDirection": _propTypes["default"].oneOf([-1, 1]).isRequired,
	  // Number of rows or columns in the current axis
	  "cellCount": _propTypes["default"].number.isRequired,
	  // Maximum number of cells to over-render in either direction
	  "overscanCellsCount": _propTypes["default"].number.isRequired,
	  // Begin of range of visible cells
	  "startIndex": _propTypes["default"].number.isRequired,
	  // End of range of visible cells
	  "stopIndex": _propTypes["default"].number.isRequired
	};
	exports.bpfrpt_proptype_OverscanIndicesGetterParams = bpfrpt_proptype_OverscanIndicesGetterParams;
	var bpfrpt_proptype_OverscanIndices =  true ? null : {
	  "overscanStartIndex": _propTypes["default"].number.isRequired,
	  "overscanStopIndex": _propTypes["default"].number.isRequired
	};
	exports.bpfrpt_proptype_OverscanIndices = bpfrpt_proptype_OverscanIndices;
	var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : _propTypes["default"].func;
	exports.bpfrpt_proptype_OverscanIndicesGetter = bpfrpt_proptype_OverscanIndicesGetter;
	var bpfrpt_proptype_Alignment =  true ? null : _propTypes["default"].oneOf(["auto", "end", "start", "center"]);
	exports.bpfrpt_proptype_Alignment = bpfrpt_proptype_Alignment;
	var bpfrpt_proptype_VisibleCellRange =  true ? null : {
	  "start": _propTypes["default"].number,
	  "stop": _propTypes["default"].number
	};
	exports.bpfrpt_proptype_VisibleCellRange = bpfrpt_proptype_VisibleCellRange;

/***/ },
/* 68 */
/***/ function(module, exports) {

	function _extends() {
	  return (module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
	    for (var e = 1; e < arguments.length; e++) {
	      var t = arguments[e];
	      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
	    }
	    return n;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(58)["default"];
	function _getRequireWildcardCache(e) {
	  if ("function" != typeof WeakMap) return null;
	  var r = new WeakMap(),
	    t = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
	    return e ? t : r;
	  })(e);
	}
	function _interopRequireWildcard(e, r) {
	  if (!r && e && e.__esModule) return e;
	  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
	    "default": e
	  };
	  var t = _getRequireWildcardCache(r);
	  if (t && t.has(e)) return t.get(e);
	  var n = {
	      __proto__: null
	    },
	    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
	  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
	    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
	    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
	  }
	  return n["default"] = e, t && t.set(e, n), n;
	}
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _payImg = __webpack_require__(454);
	
	var _payImg2 = _interopRequireDefault(_payImg);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var submitPayment = function submitPayment(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/payment/pay-via-ajax", {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getUserPaymentDetails = function getUserPaymentDetails(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/payment/getuserpaymentdetails", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var PopupIndex5 = function (_Component) {
	  _inherits(PopupIndex5, _Component);
	
	  function PopupIndex5() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopupIndex5);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupIndex5.__proto__ || Object.getPrototypeOf(PopupIndex5)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      payment_type: "",
	      privacy_policy: "",
	      term_conditions: "",
	      registration_fees: ""
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var payment_type_val = (0, _jquery2.default)("input[name='payment_type']:checked").val();
	      var privacy_policy_val = (0, _jquery2.default)("input[name='privacy_policy']:checked").val();
	      var term_conditions_val = (0, _jquery2.default)("input[name='term_conditions']:checked").val();
	      if (payment_type_val && privacy_policy_val && term_conditions_val) {
	        if (payment_type_val === "pay_online") {
	          (0, _jquery2.default)(".pay-now").html("Pay Now and Confirm");
	        } else {
	          (0, _jquery2.default)(".pay-now").html("Book Appointment");
	        }
	        document.getElementById("sslczPayBtn").disabled = false;
	        document.getElementById("sslczPayBtn").style.background = "#fb6201";
	      } else {
	        document.getElementById("sslczPayBtn").disabled = true;
	        document.getElementById("sslczPayBtn").style.background = "#41414b";
	        (0, _jquery2.default)(".pay-now").html("Book Now");
	      }
	    }, _this.handleSubmit = function (event, props) {
	      event.preventDefault();
	      if (_this.state.payment_type == "pay_uhl") {
	        window.location.href = "/success?Paymentmode=Offline";
	        event.preventDefault();
	      }
	
	      var registration_fees = "";
	      if (_this.state.registration_fees == 0) {
	        registration_fees = 200;
	      } else {
	        registration_fees = 0;
	      }
	      var total_price = parseFloat(localStorage.getItem(_constants.DOCTOR_FEES)) + parseFloat(registration_fees);
	      var final_total_price = total_price.toFixed(2);
	      var data = {
	        type: "book_appointment",
	        doctor_id: localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID),
	        doctor_name: localStorage.getItem(_constants.DOCTOR_NAME),
	        doctor_fees: localStorage.getItem(_constants.DOCTOR_FEES),
	        total_price: final_total_price,
	        registration_fees: registration_fees,
	        patient_id: localStorage.getItem(_constants.USER_ID),
	        patient_name: localStorage.getItem(_constants.PATIENT_NAME),
	        phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER)
	      };
	      submitPayment(data).then(function (res) {
	        if (res.status === "success") {
	          window.location.href = res.data;
	        } else {
	          _reactToastify.toast.error("Something went wrong.Please try again!", {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("Something went wrong.Please try again!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	    }, _this.refreshGetUserPaymentDetails = function () {
	      var data = {
	        patient_id: localStorage.getItem(_constants.USER_ID)
	      };
	      getUserPaymentDetails(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            registration_fees: records.registration_fees
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("Doctor profile data not found", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	    }, _this.closePopup = function (event) {
	      (0, _jquery2.default)(".payment_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".payment_popup").removeClass("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PopupIndex5, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshGetUserPaymentDetails();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var doctor_fees = localStorage.getItem(_constants.DOCTOR_FEES);
	      var registration_fees = "";
	      if (this.state.registration_fees == 0) {
	        registration_fees = 0;
	      } else {
	        registration_fees = 0;
	      }
	      var total_price = parseFloat(doctor_fees) + parseFloat(registration_fees);
	      var final_total_price = total_price.toFixed(2);
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "offcanvas offcanvas-start show payment_popup",
	          tabIndex: -1,
	          id: "offcanvasExample",
	          "aria-labelledby": "offcanvasExampleLabel",
	          style: { visibility: "visible" }
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-header" },
	          _react2.default.createElement(
	            "h5",
	            { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	            " "
	          ),
	          _react2.default.createElement("button", {
	            type: "button",
	            className: "btn-close text-reset",
	            "data-bs-dismiss": "offcanvas",
	            "aria-label": "Close",
	            onClick: this.closePopup
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-body" },
	          _react2.default.createElement(
	            "div",
	            { className: "row d-flex justify-content-around", id: "logos" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-2 " },
	              _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	            )
	          ),
	          _react2.default.createElement(
	            "form",
	            { onSubmit: this.handleSubmit },
	            _react2.default.createElement(
	              "div",
	              { className: "left-offcanvas" },
	              _react2.default.createElement(
	                "h4",
	                { className: "mt-3", style: { color: "#187979" } },
	                "Payment"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "payment mt-5" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-8" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Consultation Fees with ",
	                      localStorage.getItem(_constants.DOCTOR_NAME)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-4" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "BDT ",
	                      localStorage.getItem(_constants.DOCTOR_FEES)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-8" },
	                    _react2.default.createElement(
	                      "p",
	                      { className: "color-drak" },
	                      "Total"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-4" },
	                    _react2.default.createElement(
	                      "p",
	                      { className: "color-drak" },
	                      "BDT ",
	                      final_total_price
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row  mb-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-6" },
	                    _react2.default.createElement("input", {
	                      type: "radio",
	                      id: "payment_type",
	                      name: "payment_type",
	                      className: "radio-btn",
	                      value: "pay_online",
	                      onChange: this.handleChange
	                    }),
	                    _react2.default.createElement(
	                      "label",
	                      { htmlFor: "html" },
	                      " Pay Now"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-6" },
	                    _react2.default.createElement("input", {
	                      type: "radio",
	                      id: "payment_type",
	                      name: "payment_type",
	                      className: "radio-btn",
	                      value: "pay_uhl",
	                      onChange: this.handleChange
	                    }),
	                    _react2.default.createElement(
	                      "label",
	                      { htmlFor: "css" },
	                      " Pay at UHL"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12" },
	                  _react2.default.createElement(
	                    "label",
	                    { className: "label-text" },
	                    _react2.default.createElement("input", {
	                      type: "checkbox",
	                      name: "privacy_policy",
	                      id: "privacy_policy",
	                      value: "privacy_policy",
	                      onChange: this.handleChange
	                    }),
	                    " ",
	                    "I agree with the Privacy Policy",
	                    " "
	                  ),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "label",
	                    { className: "label-text" },
	                    _react2.default.createElement("input", {
	                      type: "checkbox",
	                      name: "term_conditions",
	                      id: "term_conditions",
	                      value: "term_conditions",
	                      onChange: this.handleChange
	                    }),
	                    " ",
	                    "I agree with the Terms & Conditions"
	                  ),
	                  _react2.default.createElement("br", null),
	                  " ",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: "btn-links pay-now appointment-new",
	                      id: "sslczPayBtn",
	                      token: "if you have any token validation",
	                      postdata: "your javascript arrays or objects which requires in backend",
	                      order: "If you already have the transaction generated for current order",
	                      endpoint: this.handleSubmit,
	                      disabled: true
	                    },
	                    " ",
	                    "Book Now"
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PopupIndex5;
	}(_react.Component);
	
	exports.default = PopupIndex5;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _new = __webpack_require__(136);
	
	var _new2 = _interopRequireDefault(_new);
	
	var _reactSlick = __webpack_require__(63);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	var _newsEventsModule = __webpack_require__(87);
	
	var _newsEventsModule2 = _interopRequireDefault(_newsEventsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getNewsEvents = function getNewsEvents() {
	  return new Promise(function (resolve, reject) {
	    var req = _.thirdparty.request("/newsevents/getnewsevents", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var NewsEventsSlide = function (_Component) {
	  _inherits(NewsEventsSlide, _Component);
	
	  function NewsEventsSlide() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NewsEventsSlide);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsEventsSlide.__proto__ || Object.getPrototypeOf(NewsEventsSlide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      newsEventData: []
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshGetNewsEventsData = function () {
	      getNewsEvents().then(function (res) {
	        if (res.status === true) {
	          var records = res.data.filter(function (item) {
	            return item.type === "Events";
	          });
	
	          _this.setState({
	            newsEventData: records
	          });
	        } else {
	          _this.setState({
	            newsEventData: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NewsEventsSlide, [{
	    key: "formatDate",
	    value: function formatDate(inputDate) {
	      var date = new Date(inputDate);
	
	      var day = date.getDate();
	      var year = date.getFullYear();
	
	      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	      var month = monthNames[date.getMonth()];
	
	      return {
	        date: day + " " + month,
	        year: month + " " + year
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshGetNewsEventsData();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var crousel_row_number = "";
	      if (this.state.newsEventData.length < 8) {
	        crousel_row_number = "1";
	      } else {
	        crousel_row_number = "2";
	      }
	      var settings = {
	        rows: 1,
	        dots: false,
	        infinite: true,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 1,
	        autoplay: false,
	
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 1,
	            infinite: true,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      var mobileSettings = {
	        rows: 1,
	        dots: false,
	        infinite: true,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 1,
	        autoplay: false,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            infinite: true,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "section",
	          {
	            style: { backgroundColor: "#F7F5EF" },
	            className: "news-events   " + (_reactDeviceDetect.isMobile ? "pt-0 pb-1" : "pb-5"),
	            id: "hr-lines"
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "pb-0 pb-md-4",
	                style: {
	                  display: "flex",
	                  justifyContent: "center",
	                  alignItems: "flex-start",
	                  flexDirection: "column",
	                  width: "82px",
	                  margin: "0 auto"
	                }
	              },
	              _react2.default.createElement(
	                "h3",
	                {
	                  className: "text-center",
	                  style: {
	                    color: "#af9763",
	                    fontSize: "28px",
	                    fontWeight: "500"
	                  }
	                },
	                "Events"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row mt-5 " },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 right-sp-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "news_section" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row justify-content-between" },
	                    _react2.default.createElement(
	                      _reactDeviceDetect.MobileView,
	                      { className: _newsEventsModule2.default.MobileView },
	                      _react2.default.createElement(
	                        _reactSlick2.default,
	                        mobileSettings,
	                        this.state.newsEventData.length > 0 ? this.state.newsEventData.map(function (newsevent_data, index) {
	                          var news = newsevent_data.news_events_tag ? newsevent_data.news_events_tag : "Not found";
	                          // console.log(newsevent_data.department_mave.department_name,"news")
	                          var news_events_title = newsevent_data.news_events_title;
	                          var new_news_events_title = news_events_title.replaceAll(" ", "-");
	                          // console.log(this.state.newsEventData)
	                          return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "col-sm-3 post-slide",
	                              style: { position: "relative" },
	                              key: index
	                            },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "/news/" + newsevent_data.Slug,
	                                style: {
	                                  textDecoration: "none",
	                                  width: "100%"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "news-part",
	                                  style: {
	                                    paddingLeft: "0px",
	                                    paddingRight: "0px",
	                                    width: "100%"
	                                  }
	                                },
	                                _react2.default.createElement("img", {
	                                  src: newsevent_data.news_events_pic ? _constants.IMAGE_URL + "NewsEventsImg/" + newsevent_data.news_events_pic : _new2.default,
	                                  style: {
	                                    borderRadius: "5px",
	                                    objectFit: "cover",
	                                    width: "100%",
	                                    height: "100%"
	                                  },
	                                  alt: "news_events_1"
	                                }),
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "bg-color-back",
	                                    style: {
	                                      width: "100%",
	                                      height: "100%"
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "div",
	                                    {
	                                      className: "div",
	                                      style: {
	                                        width: "100%"
	                                      }
	                                    },
	                                    _react2.default.createElement(
	                                      "h5",
	                                      {
	                                        style: {
	                                          position: "absolute",
	                                          top: 15,
	                                          left: 15,
	                                          backgroundColor: "rgb(158 136 89 / 60%)",
	                                          borderRadius: "4px",
	                                          color: "#fff",
	                                          padding: "5px",
	                                          fontSize: "20px",
	                                          width: "30%"
	                                        }
	                                      },
	                                      _this2.formatDate(newsevent_data.news_events_date).date && _this2.formatDate(newsevent_data.news_events_date).date !== NaN ? _this2.formatDate(newsevent_data.news_events_date).date + " " : "Date not found"
	                                    ),
	                                    _react2.default.createElement(
	                                      "h5",
	                                      {
	                                        style: {
	                                          position: "absolute",
	                                          top: 20,
	                                          right: 30,
	                                          fontSize: "12px",
	                                          backgroundColor: "rgb(158 136 89 / 60%)",
	                                          borderRadius: "4px",
	                                          color: "#fff",
	                                          padding: "5px"
	                                        }
	                                      },
	                                      news
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    {
	                                      className: "news_events_title",
	                                      title: newsevent_data.news_events_title,
	                                      style: {
	                                        borderBottomRightRadius: "5px",
	                                        borderBottomLeftRadius: "5px",
	                                        backgroundColor: "#0000008a",
	                                        padding: "10px",
	                                        position: "absolute",
	                                        top: 160,
	                                        left: 0,
	                                        fontSize: "16px"
	                                      }
	                                    },
	                                    newsevent_data.news_events_title ? newsevent_data.news_events_title.split(" ").slice(0, 4).join(" ") + "..." : ""
	                                  )
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-12 post-slide" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "news-part" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "bg-color-back" },
	                              _react2.default.createElement(
	                                "p",
	                                null,
	                                "No any news & events founds"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactDeviceDetect.BrowserView,
	                      null,
	                      _react2.default.createElement(
	                        _reactSlick2.default,
	                        settings,
	                        this.state.newsEventData.length > 0 ? this.state.newsEventData.map(function (newsevent_data, index) {
	                          var news = newsevent_data.news_events_tag ? newsevent_data.news_events_tag : "Not found";
	                          return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "col-sm-3 post-slide",
	                              key: index
	                            },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "/news/" + newsevent_data.Slug,
	                                style: {
	                                  textDecoration: "none",
	                                  width: "100%"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "news-part",
	                                  style: {
	                                    paddingLeft: "0px",
	                                    paddingRight: "0px"
	                                  }
	                                },
	                                _react2.default.createElement("img", {
	                                  src: newsevent_data.news_events_pic ? _constants.IMAGE_URL + "NewsEventsImg/" + newsevent_data.news_events_pic : _new2.default,
	                                  style: {
	                                    borderRadius: "5px",
	                                    objectFit: "cover",
	                                    height: "100%"
	                                  },
	                                  alt: "news_events_1"
	                                }),
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "bg-color-back",
	                                    style: {
	                                      width: "100%"
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "div",
	                                    {
	                                      className: "div",
	                                      style: {
	                                        position: "relative",
	                                        width: "100%"
	                                      }
	                                    },
	                                    _react2.default.createElement(
	                                      "h5",
	                                      {
	                                        style: {
	                                          position: "absolute",
	                                          top: "-137px",
	                                          left: "15px",
	                                          backgroundColor: "rgb(158 136 89 / 60%)",
	                                          borderRadius: "4px",
	                                          color: "#fff",
	                                          padding: "5px",
	                                          fontSize: "20px",
	                                          width: "22%"
	                                        }
	                                      },
	                                      _this2.formatDate(newsevent_data.news_events_date).date && _this2.formatDate(newsevent_data.news_events_date).date !== NaN ? _this2.formatDate(newsevent_data.news_events_date).date + " " : "Date not found"
	                                    ),
	                                    _react2.default.createElement(
	                                      "h5",
	                                      {
	                                        style: {
	                                          position: "absolute",
	                                          top: "-130px",
	                                          right: "15px",
	                                          fontSize: "12px",
	                                          backgroundColor: "rgb(158 136 89 / 60%)",
	                                          borderRadius: "4px",
	                                          color: "#fff",
	                                          padding: "5px"
	                                        }
	                                      },
	                                      news
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    {
	                                      className: "news_events_title",
	                                      title: newsevent_data.news_events_title,
	                                      style: {
	                                        borderBottomRightRadius: "5px",
	                                        borderBottomLeftRadius: "5px",
	                                        padding: "10px",
	                                        backgroundColor: "rgb(0 0 0 / 61%)",
	                                        color: "#fff",
	                                        fontSize: "15px"
	                                      }
	                                    },
	                                    newsevent_data.news_events_title ? newsevent_data.news_events_title.split(" ").slice(0, 5).join(" ") + "..." : ""
	                                  )
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-12 post-slide" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "news-part" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "bg-color-back" },
	                              _react2.default.createElement(
	                                "p",
	                                null,
	                                "No any news & events founds"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewsEventsSlide;
	}(_react.Component);
	
	exports.default = NewsEventsSlide;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _potrait = __webpack_require__(456);
	
	var _potrait2 = _interopRequireDefault(_potrait);
	
	var _reactSlick = __webpack_require__(63);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPublications = function getPublications() {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/publications/getpublications", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var PublicationsSlide = function (_Component) {
	  _inherits(PublicationsSlide, _Component);
	
	  function PublicationsSlide() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PublicationsSlide);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PublicationsSlide.__proto__ || Object.getPrototypeOf(PublicationsSlide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      publicationsData: []
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshGetPublicationsData = function () {
	      getPublications().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            publicationsData: records
	          });
	        } else {
	          _this.setState({
	            publicationsData: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PublicationsSlide, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshGetPublicationsData();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var crousel_row_number = "";
	      if (this.state.publicationsData.length < 8) {
	        crousel_row_number = 1;
	      } else {
	        crousel_row_number = 2;
	      }
	      var settings = {
	        rows: crousel_row_number,
	        dots: false,
	        infinite: true,
	        speed: 500,
	        slidesToShow: 3,
	        slidesToScroll: 1,
	        autoplay: true,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            infinite: true,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "section",
	          {
	            className: "news-events hr-lines",
	            id: "Publications",
	            style: { backgroundColor: "#fef3e9" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "flex",
	                  justifyContent: "center",
	                  alignItems: "flex-start",
	                  flexDirection: "column",
	                  width: "82px",
	                  margin: "0 auto",
	                  marginBottom: "10px"
	                }
	              },
	              _react2.default.createElement(
	                "h3",
	                {
	                  className: "text-center",
	                  style: {
	                    color: "#0C807D",
	                    fontSize: "28px",
	                    fontWeight: "500"
	                  }
	                },
	                "Publications"
	              ),
	              _react2.default.createElement("img", { src: "/assets/images/testimonial_under.png", alt: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 right-sp-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "publication_crousel" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      _reactSlick2.default,
	                      settings,
	                      this.state.publicationsData.length > 0 ? this.state.publicationsData.map(function (publications_data) {
	                        var publications_title = publications_data.publications_title;
	                        var new_publications_title = publications_title.replaceAll(" ", "-");
	                        return _react2.default.createElement(
	                          "div",
	                          {
	                            className: "col-sm-3 post-slide",
	                            key: publications_data.id
	                          },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              href: "/publications/" + publications_data.slug,
	                              style: { textDecoration: "none" }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "img-back-pub" },
	                              _react2.default.createElement("img", {
	                                src: publications_data.publications_pic ? _constants.IMAGE_URL + "PublicationsImg/" + publications_data.publications_pic : _potrait2.default,
	                                alt: "potrait",
	                                style: {
	                                  minHeight: "210px",
	                                  height: "210px"
	                                }
	                              }),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "areya-contant" },
	                                _react2.default.createElement(
	                                  "p",
	                                  {
	                                    title: publications_data.publications_title
	                                  },
	                                  publications_data.publications_title.substr(0, 18) + "..."
	                                )
	                              )
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-12 post-slide" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "img-back-pub" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Data Not Found"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PublicationsSlide;
	}(_react.Component);
	
	exports.default = PublicationsSlide;

/***/ },
/* 73 */
8,
/* 74 */
8,
/* 75 */
8,
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(962), exports);
	__exportStar(__webpack_require__(961), exports);
	__exportStar(__webpack_require__(407), exports);


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = exports.ReactReduxContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var ReactReduxContext = /*#__PURE__*/_react["default"].createContext(null);
	
	exports.ReactReduxContext = ReactReduxContext;
	
	if (false) {
	  ReactReduxContext.displayName = 'ReactRedux';
	}
	
	var _default = ReactReduxContext;
	exports["default"] = _default;

/***/ },
/* 78 */
[1186, 1010],
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _objectSpread = __webpack_require__(464);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
	
	/**
	 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
	 *
	 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
	 * during build.
	 * @param {number} code
	 */
	function formatProdErrorMessage(code) {
	  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
	}
	
	// Inlined version of the `symbol-observable` polyfill
	var $$observable = (function () {
	  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
	})();
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
	function miniKindOf(val) {
	  if (val === void 0) return 'undefined';
	  if (val === null) return 'null';
	  var type = typeof val;
	
	  switch (type) {
	    case 'boolean':
	    case 'string':
	    case 'number':
	    case 'symbol':
	    case 'function':
	      {
	        return type;
	      }
	  }
	
	  if (Array.isArray(val)) return 'array';
	  if (isDate(val)) return 'date';
	  if (isError(val)) return 'error';
	  var constructorName = ctorName(val);
	
	  switch (constructorName) {
	    case 'Symbol':
	    case 'Promise':
	    case 'WeakMap':
	    case 'WeakSet':
	    case 'Map':
	    case 'Set':
	      return constructorName;
	  } // other
	
	
	  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
	}
	
	function ctorName(val) {
	  return typeof val.constructor === 'function' ? val.constructor.name : null;
	}
	
	function isError(val) {
	  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
	}
	
	function isDate(val) {
	  if (val instanceof Date) return true;
	  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
	}
	
	function kindOf(val) {
	  var typeOfVal = typeof val;
	
	  if (false) {
	    typeOfVal = miniKindOf(val);
	  }
	
	  return typeOfVal;
	}
	
	/**
	 * @deprecated
	 *
	 * **We recommend using the `configureStore` method
	 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
	 *
	 * Redux Toolkit is our recommended approach for writing Redux logic today,
	 * including store setup, reducers, data fetching, and more.
	 *
	 * **For more details, please read this Redux docs page:**
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
	 * simplifies setup and helps avoid common bugs.
	 *
	 * You should not be using the `redux` core package by itself today, except for learning purposes.
	 * The `createStore` method from the core `redux` package will not be removed, but we encourage
	 * all users to migrate to using Redux Toolkit for all Redux code.
	 *
	 * If you want to use `createStore` without this visual deprecation warning, use
	 * the `legacy_createStore` import instead:
	 *
	 * `import { legacy_createStore as createStore} from 'redux'`
	 *
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	      currentListeners = null;
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	/**
	 * Creates a Redux store that holds the state tree.
	 *
	 * **We recommend using `configureStore` from the
	 * `@reduxjs/toolkit` package**, which replaces `createStore`:
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	var legacy_createStore = createStore;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var actionType = action && action.type;
	        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread__default['default'](_objectSpread__default['default']({}, store), {}, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;
	exports.legacy_createStore = legacy_createStore;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [config] The config.
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	function AxiosError(message, code, config, request, response) {
	  Error.call(this);
	  this.message = message;
	  this.name = 'AxiosError';
	  code && (this.code = code);
	  config && (this.config = config);
	  request && (this.request = request);
	  response && (this.response = response);
	}
	
	utils.inherits(AxiosError, Error, {
	  toJSON: function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code,
	      status: this.response && this.response.status ? this.response.status : null
	    };
	  }
	});
	
	var prototype = AxiosError.prototype;
	var descriptors = {};
	
	[
	  'ERR_BAD_OPTION_VALUE',
	  'ERR_BAD_OPTION',
	  'ECONNABORTED',
	  'ETIMEDOUT',
	  'ERR_NETWORK',
	  'ERR_FR_TOO_MANY_REDIRECTS',
	  'ERR_DEPRECATED',
	  'ERR_BAD_RESPONSE',
	  'ERR_BAD_REQUEST',
	  'ERR_CANCELED'
	// eslint-disable-next-line func-names
	].forEach(function(code) {
	  descriptors[code] = {value: code};
	});
	
	Object.defineProperties(AxiosError, descriptors);
	Object.defineProperty(prototype, 'isAxiosError', {value: true});
	
	// eslint-disable-next-line func-names
	AxiosError.from = function(error, code, config, request, response, customProps) {
	  var axiosError = Object.create(prototype);
	
	  utils.toFlatObject(error, axiosError, function filter(obj) {
	    return obj !== Error.prototype;
	  });
	
	  AxiosError.call(axiosError, error.message, code, config, request, response);
	
	  axiosError.name = error.name;
	
	  customProps && Object.assign(axiosError, customProps);
	
	  return axiosError;
	};
	
	module.exports = AxiosError;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateUserToken = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _constants = __webpack_require__(3);
	
	var _userSession = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var validateUserToken = exports.validateUserToken = function validateUserToken() {
	  var token = localStorage.getItem(_constants.API_TOKEN_NAME);
	  var tokenExpiryTime = localStorage.getItem(_constants.API_TOKEN_EXPIRY_NAME);
	
	  if (!!token && !!tokenExpiryTime && new Date(tokenExpiryTime) > new Date()) {
	    return true;
	  }
	};
	
	exports.default = function (_ref) {
	  var Component = _ref.component,
	      user = _ref.user,
	      rest = _objectWithoutProperties(_ref, ["component", "user"]);
	
	  return _react2.default.createElement(_reactRouterDom.Route, Object.assign({}, rest, {
	    render: function render(props) {
	      if (validateUserToken()) {
	        return _react2.default.createElement(Component, Object.assign({}, props, { user: true }));
	      } else (0, _userSession.endUserSession)();
	      return _react2.default.createElement(_reactRouterDom.Redirect, {
	        to: { pathname: _constants.LOGOUT_PAGE_PATH, state: { from: props.location } }
	      });
	    }
	  }));
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {API_TOKEN_NAME} from '../../constants';
	//import { scAxios } from '../../';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	//import { Outlet,Link } from "react-router-dom";
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "footer",
	        { className: "footer" },
	        "\xA9 2024 United Hospital Limited"
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tinymceReact = __webpack_require__(472);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var NewReachTextEditor = function NewReachTextEditor(_ref) {
	  var id = _ref.id,
	      value = _ref.value,
	      onChange = _ref.onChange;
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      licenseKey = _useState2[0],
	      setLicenseKey = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _.scAxiosAdmin.request("/settings/29", {
	                  method: "get",
	                  headers: {
	                    Accept: "application/json",
	                    Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                  },
	                  params: {
	                    // ...data
	                  }
	                });
	
	              case 3:
	                response = _context.sent;
	
	                setLicenseKey(response.data.value);
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0);
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 7]]);
	      }));
	
	      return function fetchData() {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	  var editorRef = (0, _react.useRef)(null);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    licenseKey ? _react2.default.createElement(_tinymceReact.Editor, {
	      apiKey: licenseKey,
	      value: value // Bind the current value
	      , onEditorChange: function onEditorChange(content) {
	        return onChange(id, content);
	      } // Handle changes
	      , init: {
	        height: 500,
	        menubar: true,
	        plugins: ["advlist", "autolink", "lists", "link", "image", "charmap", "preview", "anchor", "searchreplace", "visualblocks", "code", "fullscreen", "insertdatetime", "media", "table", "fontselect", "code", "help", "wordcount"],
	        toolbar: "undo redo | blocks " + "bold italic forecolor | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "table |image| media| removeformat | help",
	        content_style: "\n            body { font-family:Helvetica,Arial,sans-serif; font-size:14px }\n            table {\n              border-collapse: collapse;\n              width: 100%;\n            }\n            table, th, td {\n              border: 1px solid #ccc;\n              padding: 8px;\n            }\n            th {\n              background-color: #f2f2f2;\n            }\n          "
	      }
	    }) : ""
	  );
	};
	
	exports.default = (0, _react.memo)(NewReachTextEditor, function (prevProps, nextProps) {
	  return prevProps.value === nextProps.value && prevProps.id === nextProps.id;
	});

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _userSession = __webpack_require__(30);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(59);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _MyProvider = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import doc from '../../images/doc.png';
	
	
	var getSearchDoctors = function getSearchDoctors(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/searchdoctors", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var PopupIndex2 = function (_Component) {
	  _inherits(PopupIndex2, _Component);
	
	  function PopupIndex2() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopupIndex2);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupIndex2.__proto__ || Object.getPrototypeOf(PopupIndex2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      search_doctors: [],
	      search_keywords: "",
	      doctor_id: "",
	      schedule_date: "",
	      department_id: "",
	      limit: 4,
	      search_selected_doc_name: "",
	      selectedDate: null
	    }, _this.handleDateChange = function (date) {
	      _this.setState({ errors: "" });
	      var newObj = new Date(date).toString();
	      console.log(newObj);
	      var formatedDate = newObj.split(" ").slice(0, 4).join(" ");
	      console.log(formatedDate, "sadsdsd");
	
	      // Convert the input string to a Date object
	      var dateObject = new Date(date);
	
	      // Extract day, month, and year components
	      var month = dateObject.toLocaleString("default", { month: "short" });
	      var day = dateObject.getUTCDate() + 1;
	      var year = dateObject.getUTCFullYear();
	
	      // Format the components into the desired format (DD/MM/YYYY)
	      var formattedDate = month + " " + day + " " + year;
	
	      _this.setState({ schedule_date: formattedDate });
	      _this.setState({ selectedDate: date });
	
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var search_keywords = (0, _jquery2.default)("#search_keywords").val();
	      var doctor_id = (0, _jquery2.default)("input[name='doctor_id']:checked").val();
	      var doctor_name = (0, _jquery2.default)("input[name='doctor_id']:checked").attr("doctorName");
	      _this.setState({ search_selected_doc_name: doctor_name });
	      var schedule_date = (0, _jquery2.default)("#schedule_date").val();
	      var schedule_dates = date;
	
	      if (search_keywords && doctor_id && formattedDate) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "#187979";
	      } else if (search_keywords && doctor_id === "" && formattedDate) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "#187979";
	      } else {
	        document.getElementById("Schedule").disabled = true;
	        document.getElementById("Schedule").style.background = "gray";
	      }
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var search_keywords = (0, _jquery2.default)("#search_keywords").val();
	      var doctor_id = (0, _jquery2.default)("input[name='doctor_id']:checked").val();
	      var doctor_name = (0, _jquery2.default)("input[name='doctor_id']:checked").attr("doctorName");
	      _this.setState({ search_selected_doc_name: doctor_name });
	      var schedule_date = (0, _jquery2.default)("#schedule_date").val();
	
	      if (search_keywords && doctor_id && schedule_date) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "#187979";
	      } else if (search_keywords && doctor_id === "" && schedule_date) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "#187979";
	      } else {
	        document.getElementById("Schedule").disabled = true;
	        document.getElementById("Schedule").style.background = "gray";
	      }
	    }, _this.handleKeyUp = function (event) {
	      var data = {
	        keywords: _this.state.search_keywords
	      };
	      getSearchDoctors(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ search_doctors: records });
	        } else {
	          _this.setState({ search_doctors: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.handleSubmit = function (event, props) {
	      event.preventDefault();
	      if (_this.validateForm()) {
	        var selected_day_date_val = _this.state.schedule_date;
	        // let selected_day_date_val = $('.schedule_date').val();
	        var fields = {};
	        if (localStorage.getItem(_constants.SCHEDULE_DATE)) {} else {
	          fields["schedule_date"] = "";
	        }
	        if (localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME)) {} else {
	          fields["search_keywords"] = "";
	        }
	        //fields["doctor_id"] = "";
	        _this.setState({ fields: fields });
	        /*const data = {
	          DoctorID: this.state.doctor_id,
	          PreferredDate: this.state.schedule_date,
	        }*/
	        var doctor_id = "";
	        if ((0, _jquery2.default)("input[name='doctor_id']:checked").val()) {
	          doctor_id = (0, _jquery2.default)("input[name='doctor_id']:checked").val();
	        } else {
	          //doctor_id = this.state.doctor_id;
	          doctor_id = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	        }
	        if (localStorage.getItem(_constants.API_TOKEN_NAME) !== null) {
	          var token = localStorage.getItem(_constants.API_TOKEN_NAME);
	          var user_role = localStorage.getItem(_constants.USER_ROLE);
	          var user_email = localStorage.getItem(_constants.USER_EMAIL);
	          var patient_id = localStorage.getItem(_constants.USER_ID);
	          var login_phone_number = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	          var search_selected_doc_id = doctor_id;
	          //const schedule_date = this.state.schedule_date;
	          var schedule_date = "";
	          if (selected_day_date_val !== "") {
	            schedule_date = selected_day_date_val;
	          } else {
	            if (_this.state.schedule_date === "") {
	              if (localStorage.getItem(_constants.SCHEDULE_DATE)) {
	                schedule_date = localStorage.getItem(_constants.SCHEDULE_DATE);
	              } else {
	                schedule_date = _this.state.schedule_date;
	              }
	            } else {
	              schedule_date = _this.state.schedule_date;
	            }
	          }
	          var appointment_id = "";
	          var doctor_name = "";
	          var doctor_fees = "";
	          var patientName = localStorage.getItem(_constants.PATIENT_NAME);
	          var schedule_time = "";
	          var search_selected_doc_name = _this.state.search_selected_doc_name;
	          console.log("let", token, user_role, user_email, patient_id, login_phone_number, search_selected_doc_id, schedule_date, appointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name);
	          (0, _userSession.startUserSession)(token, user_role, user_email, patient_id, login_phone_number, search_selected_doc_id, schedule_date, appointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name);
	          _this.props.nextStep();
	        }
	        /*scheduleDoctor(data)
	        .then(res => {
	            this.props.nextStep();
	        })
	        .catch(err => {
	          toast.error('Error occured', {
	            position: toast.POSITION.BOTTOM_RIGHT
	             });
	        });*/
	      } else {
	          /*toast.error('Please select all fields!', {
	            position: toast.POSITION.BOTTOM_RIGHT
	          });*/
	        }
	    }, _this.closePopup = function (event) {
	      var DoctorData = _this.context.DoctorData;
	
	      DoctorData({});
	      document.getElementById("offcanvasExample").style.visibility = "hidden";
	      document.getElementById("offcanvasExample").classList.remove("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	
	      (0, _jquery2.default)(".doctor_search_list_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".doctor_search_list_popup").removeClass("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _this.refreshGetSearchDoctors = function (doctor_name) {
	      var data = {
	        keywords: doctor_name
	      };
	      getSearchDoctors(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ search_doctors: records });
	        } else {
	          _this.setState({ search_doctors: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PopupIndex2, [{
	    key: "validateForm",
	
	
	    // componentDidMount() {
	    //   const { doctorsDetails } = this.context;
	
	    //   if (!doctorsDetails) {
	    //     console.error("Doctors Details not found in context.");
	    //   } else {
	    //     console.log('Doctors Details:', doctorsDetails);
	    //   }
	    // }
	    value: function validateForm() {
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      var selectedScheduledDate = this.state.schedule_date;
	      if (localStorage.getItem(_constants.SCHEDULE_DATE) || selectedScheduledDate) {} else {
	        if (!fields["schedule_date"]) {
	          formIsValid = false;
	          errors["schedule_date"] = "*Please select your schedule date.";
	        }
	      }
	      if (localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME)) {} else {
	        if (!fields["search_keywords"]) {
	          formIsValid = false;
	          errors["search_keywords"] = "*Please search doctor lists.";
	        }
	      }
	      /*if (!fields["doctor_id"]) {
	          formIsValid = false;
	          errors["doctor_id"] = "*Please select atleast one doctor from doctors lists.";
	      }*/
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME) && localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID) && localStorage.getItem(_constants.SCHEDULE_DATE)) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "gray";
	      }
	      if (localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME)) {
	        this.refreshGetSearchDoctors(localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var doctorsDetails = this.context.doctorsDetails;
	
	
	      if (!doctorsDetails) {
	        console.error("Doctors Details not found in context.");
	      } else {}
	      var current_date = new Date();
	      var newcurrentdate = (0, _moment2.default)(current_date).format("DD-MM-YYYY");
	      //let site_url = location.protocol + '//' + location.host + "/unitedhospital";
	      //let site_url = location.protocol + '//' + location.host;
	      return _react2.default.createElement(
	        "div",
	        {
	          className: this.props.showpopup + " doctor_search_list_popup",
	          tabIndex: "-1",
	          id: "offcanvasExample",
	          "aria-labelledby": "offcanvasExampleLabel",
	          style: { visibility: "visible" }
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-header" },
	          _react2.default.createElement(
	            "h5",
	            { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	            " "
	          ),
	          _react2.default.createElement("button", {
	            type: "button",
	            className: "btn-close text-reset",
	            "data-bs-dismiss": "offcanvas",
	            "aria-label": "Close",
	            onClick: this.closePopup
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-body" },
	          _react2.default.createElement(
	            "div",
	            { className: "row text-center", id: "logos" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-2 " },
	              _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "left-offcanvas" },
	            _react2.default.createElement(
	              "div",
	              { className: "offcan-top-mar" },
	              _react2.default.createElement(
	                "h4",
	                { style: { color: "#187979" } },
	                "Book Appointment"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Enter Doctor's Name or relevant Department"
	              )
	            ),
	            Object.keys(doctorsDetails).length > 0 ? _react2.default.createElement(
	              "form",
	              {
	                onSubmit: this.handleSubmit,
	                className: "needs-validation",
	                noValidate: true
	              },
	              _react2.default.createElement("input", {
	                placeholder: "Enter doctor name",
	                type: "text",
	                name: "search_keywords",
	                id: "search_keywords",
	                className: "form-control",
	                defaultValue: localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME) !== "undefined" ? localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME) : "",
	                value: doctorsDetails.doctor_name,
	                onChange: this.handleChange,
	                onKeyUp: this.handleKeyUp,
	                required: true,
	                autoComplete: "off",
	                disabled: true
	              }),
	              _react2.default.createElement(
	                "span",
	                { style: alertStyle },
	                this.state.errors.search_keywords
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12 sp-0-0 mb-3", key: doctorsDetails.id },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "doctor-list" },
	                    _react2.default.createElement("input", {
	                      type: "radio",
	                      className: "doctor_id",
	                      name: "doctor_id",
	                      value: doctorsDetails.uhl_id,
	                      onChange: this.handleChange,
	                      doctorName: doctorsDetails.doctor_name,
	                      deptid: doctorsDetails.dept_id
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-3", style: { paddingLeft: "0px" } },
	                        doctorsDetails.doctor_profile ? _react2.default.createElement("img", {
	                          src: _constants.IMAGE_URL + "DoctorProfileImg/" + doctorsDetails.doctor_profile,
	                          alt: "doctor profile"
	                        }) :
	                        /*<img src={doc} alt="doc"/>*/
	                        _react2.default.createElement("img", {
	                          src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                          alt: "doc"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-9 mt-2" },
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          doctorsDetails.doctor_name
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          doctorsDetails.degree !== "" ? doctorsDetails.degree : "Endocrinology & Metabolism) MD (Endocrinology & Metabolism)"
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-6" },
	                  _react2.default.createElement(_reactDatepicker2.default, {
	                    id: "schedule_date",
	                    name: "schedule_date",
	                    className: "form-control schedule_date",
	                    autoComplete: "off",
	                    selected: this.state.selectedDate,
	                    onChange: this.handleDateChange
	                    // selected={rawDate}
	                    // value={rawDate}
	                    // onChange={(date) => handleDateChange(date)}
	                    , dateFormat: "dd/MM/yyyy",
	                    placeholderText: "DD/MM/YYYY",
	                    showDateMonthYearPicker: true
	                  }),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.schedule_date
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-6" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      variant: "primary",
	                      type: "submit",
	                      id: "Schedule",
	                      className: "btn-links"
	                    },
	                    "Check Schedule"
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              "form",
	              {
	                onSubmit: this.handleSubmit,
	                className: "needs-validation",
	                noValidate: true
	              },
	              _react2.default.createElement("input", {
	                placeholder: "Enter doctor name",
	                type: "text",
	                name: "search_keywords",
	                id: "search_keywords",
	                className: "form-control",
	                defaultValue: localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME) !== "undefined" ? localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME) : "",
	                value: this.state.fields.search_keywords,
	                onChange: this.handleChange,
	                onKeyUp: this.handleKeyUp,
	                required: true,
	                autoComplete: "off"
	              }),
	              _react2.default.createElement(
	                "span",
	                { style: alertStyle },
	                this.state.errors.search_keywords
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-3" },
	                this.state.search_doctors.length > 0 ? this.state.search_doctors.slice(0, this.state.limit).map(function (search_doctor) {
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 sp-0-0 mb-3",
	                      key: search_doctor.id
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "doctor-list" },
	                      _react2.default.createElement("input", {
	                        type: "radio",
	                        className: "doctor_id",
	                        name: "doctor_id",
	                        value: search_doctor.uhl_id,
	                        onChange: _this2.handleChange,
	                        doctorName: search_doctor.doctor_name,
	                        deptid: search_doctor.dept_id
	                      }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "col-3",
	                            style: { paddingLeft: "0px" }
	                          },
	                          search_doctor.doctor_profile ? _react2.default.createElement("img", {
	                            src: _constants.IMAGE_URL + "/DoctorProfileImg/" + search_doctor.doctor_profile,
	                            alt: "doctor profile"
	                          }) :
	                          /*<img src={doc} alt="doc"/>*/
	                          _react2.default.createElement("img", {
	                            src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                            alt: "doc"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-9 mt-2" },
	                          _react2.default.createElement(
	                            "h5",
	                            null,
	                            search_doctor.doctor_name
	                          ),
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            search_doctor.degree !== "" ? search_doctor.degree : "Endocrinology & Metabolism) MD (Endocrinology & Metabolism)"
	                          )
	                        )
	                      )
	                    )
	                  );
	                }) : _react2.default.createElement("div", { className: "col-12 sp-0-0 mb-3" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-6" },
	                  _react2.default.createElement(_reactDatepicker2.default, {
	                    id: "schedule_date",
	                    name: "schedule_date",
	                    className: "form-control schedule_date",
	                    autoComplete: "off",
	                    selected: this.state.selectedDate,
	                    onChange: this.handleDateChange
	                    // selected={rawDate}
	                    // value={rawDate}
	                    // onChange={(date) => handleDateChange(date)}
	                    , dateFormat: "dd/MM/yyyy",
	                    placeholderText: "DD/MM/YYYY",
	                    showDateMonthYearPicker: true
	                  }),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.schedule_date
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-6" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      variant: "primary",
	                      type: "submit",
	                      id: "Schedule",
	                      className: "btn-links"
	                    },
	                    "Check Schedule"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return PopupIndex2;
	}(_react.Component);
	
	PopupIndex2.contextType = _MyProvider.MyContext;
	exports.default = PopupIndex2;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _icon = __webpack_require__(57);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _male = __webpack_require__(240);
	
	var _male2 = _interopRequireDefault(_male);
	
	var _female = __webpack_require__(239);
	
	var _female2 = _interopRequireDefault(_female);
	
	var _SingleMaleBodyContent = __webpack_require__(682);
	
	var _SingleMaleBodyContent2 = _interopRequireDefault(_SingleMaleBodyContent);
	
	var _SingleFemaleBodyContent = __webpack_require__(681);
	
	var _SingleFemaleBodyContent2 = _interopRequireDefault(_SingleFemaleBodyContent);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactSlick = __webpack_require__(63);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _testimonialIcon = __webpack_require__(845);
	
	var _testimonialIcon2 = _interopRequireDefault(_testimonialIcon);
	
	var _SelectDeptment = __webpack_require__(197);
	
	var _SelectDeptment2 = _interopRequireDefault(_SelectDeptment);
	
	var _Department = __webpack_require__(674);
	
	var _Department2 = _interopRequireDefault(_Department);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getAllDepartments = function getAllDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllTestimonials = function getAllTestimonials(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/testimonials/getalltestimonials", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	// new worksation
	var getBodyDepartmentsLists = function getBodyDepartmentsLists(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/bodypart/getbodypartdepartment_multiple", data, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	      // params: {
	      //   ...data,
	      // },
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getBodyDepartmentsDoctorsLists = function getBodyDepartmentsDoctorsLists(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bodypart/getbodypartdepartmentdoctors", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var male_human_body = {
	  Head: ["Brain,Ear,Teeth,Nose,Eye", "Brain", "Ear", "Teeth", "Nose", "Eye"],
	  Throat: ["Throat"],
	  Arm: ["Arm"],
	  Heart: ["Heart"],
	  UpperStomach: ["Lungs,Kidney,Liver,Spine", "Lungs", "Kidney", "Liver", "Spine"],
	  LowerStomach: ["Lower Back,Stomach", "Lower Back", "Stomach"],
	  Elbow: ["Elbow"],
	  Thigh: ["Thigh"]
	};
	var female_human_body = {
	  Head: ["Brain,Ear,Teeth,Nose,Eye", "Brain", "Ear", "Teeth", "Nose", "Eye"],
	  Throat: ["Throat"],
	  Arm: ["Arm"],
	  Heart: ["Heart,Breast", "Heart", "Breast"],
	  UpperStomach: ["Lungs,Kidney,Liver,Spine", "Lungs", "Kidney", "Liver", "Spine"],
	  LowerStomach: ["Lower Back,Stomach,Reproductive System", "Lower Back", "Stomach", "Reproductive System"],
	  Elbow: ["Elbow"],
	  Thigh: ["Thigh"]
	};
	
	var CenterExcellence = function (_Component) {
	  _inherits(CenterExcellence, _Component);
	
	  function CenterExcellence() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CenterExcellence);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CenterExcellence.__proto__ || Object.getPrototypeOf(CenterExcellence)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showMaleComponent: false,
	      showFemaleComponent: false,
	      bodyTitles: "Brain",
	      gender: "male",
	      bodyHoverTitles: null,
	      departments: [],
	      testimonials: [],
	      bodyDepartment: [],
	      bodyDepartmentDoctor: [],
	      showNewMaleComponent: false,
	      body_part_title: "",
	      body_part_desc: ""
	    }, _this.handleHoverBodyPart = function (bodyPart) {
	      _this.setState({
	        bodyHoverTitles: bodyPart
	      });
	    }, _this.handleToggleGender = function (newGender) {
	      _this.setState({
	        gender: newGender
	      });
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var body_dept_id = (0, _jquery2.default)("input[name='body_dept_id']:checked").val();
	      _this.refreshGetBodyDepartmentsDoctors(body_dept_id);
	    }, _this.onClickFemalePrevStep = function (e) {
	      _this.setState({
	        showFemaleComponent: false
	      });
	      (0, _jquery2.default)("#excellence-part").hide();
	      (0, _jquery2.default)(".humanMaleBodyImg").show();
	      (0, _jquery2.default)(".humanFemaleBodyImg").show();
	    }, _this.refreshGetAllTestimonials = function () {
	      getAllTestimonials().then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ testimonials: records });
	        } else {
	          _this.setState({ testimonials: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshDepartments = function (event) {
	      getAllDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshGetBodyDepartmentsDoctors = function (body_dept_id) {
	      var data = {
	        bodyDeptId: body_dept_id
	      };
	      getBodyDepartmentsDoctorsLists(data).then(function (res) {
	        if (res.status === true) {
	          (0, _jquery2.default)(".our-departments").hide();
	          (0, _jquery2.default)(".our-consultants").show();
	          var records = res.data;
	          _this.setState({ bodyDepartmentDoctor: records });
	        } else {
	          _this.setState({ bodyDepartmentDoctor: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshGetBodyDepartments = function (bodyTitles) {
	      var data = {
	        bodyTitles: bodyTitles,
	        bodyGender: _this.state.gender
	      };
	      getBodyDepartmentsLists(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          var body_part_data = res.bodyPartData;
	          _this.setState({ bodyDepartment: records });
	          _this.setState({ body_part_title: body_part_data.bodypart_name });
	          _this.setState({ body_part_desc: body_part_data.bodypart_desc });
	        } else {
	          _this.setState({ bodyDepartment: "" });
	          _this.setState({ body_part_title: "" });
	          _this.setState({ body_part_desc: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CenterExcellence, [{
	    key: "modalMaleBodySingleContentOpen",
	    value: function modalMaleBodySingleContentOpen(e, title) {
	      this.refreshGetBodyDepartments(title);
	      this.setState({
	        // showMaleComponent: true,
	        bodyTitles: title
	      });
	      // $('.humanMaleBodyImg').hide();
	      // $('.humanFemaleBodyImg').show();
	    }
	  }, {
	    key: "modalFemaleBodySingleContentOpen",
	    value: function modalFemaleBodySingleContentOpen(e, title) {
	      this.refreshGetBodyDepartments(title);
	      this.setState({
	        // showFemaleComponent: true,
	        bodyTitles: title
	      });
	      // $('.humanMaleBodyImg').show();
	      // $('.humanFemaleBodyImg').hide();
	    }
	  }, {
	    key: "hendlerNewEvent",
	    value: function hendlerNewEvent(e, title) {
	      this.setState({
	        bodyTitles: title
	      });
	    }
	    // onClickMalePrevStep = (e) => {
	    //   this.setState({
	    //     showMaleComponent: false,
	    //   });
	    //   $('#excellence-part').hide();
	    //   $('.humanMaleBodyImg').show();
	    //   $('.humanFemaleBodyImg').show();
	    // }
	
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshDepartments();
	      this.refreshGetAllTestimonials();
	      this.modalMaleBodySingleContentOpen(null, "Brain,Ear,Teeth,Nose,Eye");
	    }
	
	    // work station new
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var FeMaleBodySVGReactElement = _react2.default.createElement(
	        "svg",
	        {
	          xmlns: "http://www.w3.org/2000/svg",
	          className: "humanFemaleBodyImg",
	          viewBox: _reactDeviceDetect.isMobile ? "151 80 1150 1529" : "140 10 1450 1500",
	          xmlSpace: "preserve",
	          "max-width": "3000px",
	          width: "100%"
	        },
	        _react2.default.createElement(
	          "style",
	          null,
	          ".bodyParts{\
	            fill:#f58220;\
	            cursor: pointer;\
	          }\
	          .bodyLines{\
	            fill:#f2f2f2;\
	          }\
	          .syzst2{\
	            fill:none;\
	          }\
	          .labelLine {\
	            fill: none;\
	            stroke: #b3b3b3;\
	            stroke-width: 2;\
	          }\
	          .labelText {\
	            // fill: #af9763;\
	            fill-rule: nonzero;\
	            transition: all 0.3s ease;\
	          }\
	          .labelGroup .labelText {\
	            transform: translateX(-5px);\
	          }\
	          .labelGroup.is_right .labelText {\
	            transform: translateX(5px);\
	          }\
	          .labelArea {\
	            fill: transparent;\
	            cursor: pointer;\
	            color:#af9763; !important \
	          }\
	          .bodyParts_wrapper .labelGroup,\
	          .bodyParts_wrapper .labelGroup-sub {\
	            transition: all 0.2s ease;\
	          }\
	          .bodyParts_wrapper .labelLine,\
	          .bodyParts_wrapper .labelText {\
	            pointer-events: none;\
	          }\
	          .bodyParts_wrapper.hovered .labelGroup,\
	          .bodyParts_wrapper.hovered .labelGroup-sub {\
	            opacity: 0.3;\
	          }\
	          .bodyParts_wrapper .labelGroup:hover,\
	          .bodyParts_wrapper .labelGroup-sub:hover,\
	          .bodyPartsGroup:hover ~ .labelGroup {\
	            opacity: 1;\
	          }\
	          .bodyParts_wrapper:hover .bodyParts {\
	            fill: #f58220;\
	            cursor: pointer;\
	          }\
	          .bodyPartsGroup:hover ~ .labelGroup .labelText,\
	          .labelGroup:hover .labelText {\
	            fill: #f58220;\
	            transform: translateX(0px);\
	          }\
	        "
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Head" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Brain,Ear,Teeth,Nose,Eye");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Brain,Ear,Teeth,Nose,Eye");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.Head.includes(this.state.bodyTitles) || female_human_body.Head.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M718.36 270.3a21.711 21.711 0 0 0 .62.48c.17.13.36.28.56.43.15.12.31.24.48.37.01.01.03.02.04.03h.01l.89.69c.09.07.18.14.28.22 1.16.9 2.55 1.98 4.05 3.13.04.03.08.06.12.1.46.35.93.72 1.41 1.08.06.04.11.09.17.13 1.6 1.22 3.28 2.5 4.94 3.74.96.72 1.9 1.42 2.83 2.1.4.29.8.58 1.18.87.21.16.42.3.63.45a21.053 21.053 0 0 0 1.78 1.21c.14.09.28.17.42.25.3.18.6.34.91.5.16.09.32.18.49.26.38.19.76.36 1.15.52.28.12.56.23.85.33.13.05.27.1.4.15 1.07.38 2.16.67 3.28.88.19.04.38.08.57.11.21.03.42.05.64.08.33.04.65.09.98.12.35.03.71.04 1.06.06.24.01.49.03.73.03h3.02a17.493 17.493 0 0 0 7.92-1.91c.81-.42 1.6-.9 2.34-1.45.31-.23.64-.47.97-.71.27-.2.55-.4.83-.61.01-.01.03-.02.04-.03.86-.63 1.76-1.3 2.7-1.99 1.52-1.12 3.1-2.3 4.66-3.45 0 0 .01 0 .01-.01 1.02-.76 2.04-1.51 3.01-2.24.02-.02.05-.04.07-.05.47-.35.94-.7 1.39-1.04.02-.01.03-.02.05-.04.43-.32.84-.63 1.25-.93.05-.04.1-.08.15-.11.4-.3.79-.59 1.16-.87a67.464 67.464 0 0 1 .8-.6c.06-.04.12-.09.17-.13.23-.17.45-.34.65-.49.03-.02.06-.05.09-.07.43-.32.81-.61 1.14-.86.33-.25.63-.48.85-.65 6.49-5.01 11.86-11.38 15.38-18.78.51-1.07.96-2.11 1.34-3.1 6.07-15.91 1.22-71.74-2.6-86.7-3.3-12.93-13-32.08-43.78-34.25 0 0-.84-.09-2.33-.1-1.62-.38-3.02.1-3.02.1-30.78 2.17-40.48 21.32-43.78 34.25-3.82 14.96-8.66 70.79-2.59 86.7.39 1.04.87 2.13 1.41 3.26 3.37 7.01 8.39 13.09 14.46 17.94.28.19.52.41.77.6z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-brain",
	              transform: "translate(0 35)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Brain");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Brain");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "88",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 -86.756)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.69574 0 0 .7655 168.111 48.213)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Brain" ? "#f58220" : "#af9763"
	                },
	                d: "M1119.993 181.552h10.296c2.052 0 3.564.108 4.572.252 1.008.18 1.908.54 2.7 1.08.792.54 1.44 1.26 1.98 2.16.504.9.792 1.872.792 2.988 0 1.224-.324 2.34-.972 3.348-.648 1.008-1.548 1.764-2.664 2.268 1.584.432 2.772 1.224 3.636 2.34.828 1.08 1.26 2.376 1.26 3.852 0 1.188-.288 2.34-.828 3.42-.54 1.116-1.296 2.016-2.232 2.664-.936.684-2.088 1.08-3.492 1.224-.864.108-2.952.144-6.264.18h-8.784v-25.776Zm5.22 4.284v5.976h3.42c2.016 0 3.276-.036 3.744-.108.9-.108 1.62-.396 2.124-.9s.756-1.188.756-2.016c0-.792-.216-1.44-.648-1.944-.432-.504-1.116-.792-1.98-.9-.504-.072-1.98-.108-4.428-.108h-2.988Zm0 10.26v6.876h4.824c1.872 0 3.06-.036 3.564-.144.756-.144 1.404-.468 1.872-1.044.504-.54.72-1.26.72-2.16 0-.792-.18-1.44-.54-1.98-.396-.54-.936-.936-1.62-1.188-.72-.252-2.268-.36-4.644-.36h-4.176ZM1150.663 207.328h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM1163.63 194.368l-4.465-.828c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.623 3.996c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1179.987 186.124v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM1206.943 207.328h-4.932v-9.54c0-2.016-.108-3.312-.324-3.888a2.551 2.551 0 0 0-1.008-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.684.468-1.116 1.116-1.368 1.872s-.396 2.196-.396 4.284v8.46h-4.932v-18.684h4.572v2.772c1.62-2.124 3.672-3.168 6.156-3.168 1.08 0 2.088.18 2.988.576.9.396 1.584.9 2.052 1.512.468.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-eye is_right",
	              transform: "translate(0 25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Eye");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Eye");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "315",
	              y: "143",
	              width: "70",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-823.163 -141.006)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.63435 0 0 -.7655 2072.54 448.667)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Eye" ? "#f58220" : "#af9763"
	                },
	                d: "M1143.123 314.9v-25.777h19.116v4.356h-13.932v5.724h12.96v4.356h-12.96v6.984h14.4v4.356h-19.584ZM1164.767 296.215h5.256l4.464 13.284 4.356-13.284h5.112l-6.588 17.964-1.188 3.276c-.432 1.08-.828 1.908-1.224 2.484a5.653 5.653 0 0 1-1.368 1.404 5.273 5.273 0 0 1-1.872.828c-.756.216-1.584.288-2.52.288-.936 0-1.872-.072-2.808-.288l-.432-3.852c.792.144 1.476.216 2.088.216 1.152 0 2.016-.324 2.556-1.008.54-.684.972-1.548 1.26-2.592l-7.092-18.72ZM1197.927 308.96l4.932.827c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.005c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-ear", transform: "translate(0 25)" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Ear");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Ear");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "156",
	              width: "65",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 -18)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M832.407 191.303H1331.1",
	                transform: "matrix(.5832 0 0 .7655 317.921 48.213)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Ear" ? "#f58220" : "#af9763"
	                },
	                d: "M1120.01 207.328v-25.776h19.117v4.356h-13.932v5.724h12.96v4.356h-12.96v6.984h14.4v4.356h-19.584ZM1147.657 194.368l-4.464-.828c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.624 3.996c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1168.72 207.328h-4.931v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-nose is_right",
	              transform: "translate(0 25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Nose");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Nose");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "290",
	              y: "197",
	              width: "95",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-823.163 -85.302)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.70597 0 0 -.7655 2167.88 448.667)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Nose" ? "#f58220" : "#af9763"
	                },
	                d: "M1119.19 314.9v-25.777h5.075l10.548 17.208v-17.208h4.824V314.9h-5.22l-10.404-16.812V314.9h-4.824ZM1143.965 305.287c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM1165.343 309.571l4.968-.756c.216.972.648 1.692 1.296 2.196.648.504 1.548.756 2.7.756 1.26 0 2.232-.252 2.88-.72.432-.324.648-.756.648-1.332 0-.36-.108-.684-.36-.9-.216-.252-.792-.468-1.656-.684-3.96-.864-6.48-1.656-7.56-2.376-1.476-1.008-2.232-2.412-2.232-4.212 0-1.62.648-2.988 1.944-4.068 1.26-1.116 3.24-1.656 5.94-1.656 2.556 0 4.428.396 5.688 1.224 1.224.864 2.088 2.088 2.556 3.708l-4.644.864c-.216-.72-.576-1.296-1.152-1.692-.54-.36-1.332-.576-2.376-.576-1.296 0-2.232.18-2.772.54-.396.288-.576.612-.576 1.008 0 .36.144.648.504.9.432.324 1.98.792 4.608 1.404 2.628.576 4.464 1.332 5.508 2.196 1.008.864 1.548 2.088 1.548 3.672 0 1.692-.72 3.168-2.16 4.392-1.404 1.26-3.528 1.872-6.336 1.872-2.556 0-4.572-.54-6.048-1.548-1.476-1.044-2.448-2.448-2.916-4.212ZM1197.927 308.96l4.932.827c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.005c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-teeth",
	              transform: "translate(0 15)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Teeth");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Teeth");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "225",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 51.69)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.67528 0 0 .7655 195.349 48.213)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Teeth" ? "#f58220" : "#af9763"
	                },
	                d: "M1127.652 207.328v-21.42h-7.668v-4.356h20.485v4.356h-7.633v21.42h-5.184ZM1151.93 201.388l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.937-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1171.96 201.388l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.937-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1189.748 188.644v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384ZM1198.066 181.552v9.468c1.62-1.836 3.528-2.772 5.724-2.772 1.152 0 2.16.216 3.096.612.9.432 1.584.972 2.052 1.62.468.648.792 1.404.936 2.196.18.792.252 2.016.252 3.708v10.944h-4.932v-9.864c0-1.944-.072-3.204-.288-3.708-.18-.54-.504-.972-.972-1.26-.468-.324-1.08-.468-1.8-.468-.792 0-1.548.18-2.196.576-.648.396-1.116 1.008-1.404 1.8-.288.828-.468 2.016-.468 3.564v9.36h-4.932v-25.776h4.932Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Neck" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Throat");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Throat");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "M764.93 283.93c.01 0 .01-.01.02-.01-.01.01-.03.02-.04.03 0-.01.01-.01.02-.02zm-15.84 4.67c.12 0 .23.02.35.02.12.01.23.01.35.01h.03c-.25 0-.49-.02-.73-.03zm31.29-16.14c-.06.04-.11.09-.17.13.05-.05.11-.09.17-.13zm-37.81 14.89c-.13-.05-.27-.1-.4-.15.13.05.26.1.4.15zm-1.25-.48zm35.52-11.77c-.02.01-.03.02-.05.04.02-.01.04-.02.05-.04zm-37.17 10.99c-.31-.16-.61-.33-.91-.5.3.17.61.34.91.5zm38.57-12.03c-.05.04-.1.07-.15.11.05-.03.1-.07.15-.11zm-2.84 2.12c-.02.02-.05.04-.07.05.02-.02.05-.03.07-.05zm4.06-3.04.02-.02c-.03.02-.06.04-.08.06.02 0 .05-.02.06-.04zm-7.14 5.33c-.01 0-.01 0 0 0-.01 0-.01 0 0 0zm-52.31-6.89c-.16-.13-.33-.25-.48-.37.15.12.31.24.48.37zm-1.04-.8a.55.55 0 0 1-.09-.07c.04.02.07.04.09.07zm2.25 1.74c-.1-.07-.19-.14-.28-.22.1.08.18.14.28.22zm39.54 14.2c.81-.42 1.6-.9 2.34-1.45.31-.23.64-.47.97-.71-.33.24-.66.49-.97.71-.74.55-1.53 1.03-2.34 1.45zm-33.78-9.76c-.06-.04-.11-.09-.17-.13.05.05.11.09.17.13zm9.58 7.17-.63-.45.63.45zm-11.16-8.38c-.04-.03-.08-.06-.12-.1.03.04.08.07.12.1zm12.94 9.59c-.43-.26-.85-.54-1.26-.83.41.29.83.56 1.26.83zm42.79-13.44c-.03.02-.06.05-.09.07.03-.03.05-.05.09-.07z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              d: "M666.75 332.26c9.55 2.6 27.57 9.57 28.04 9.76 11.91-.5 23.89 1.67 31.1 4.75 13.94 5.96 18.14 15.53 22.55 28.4.37 1.09.71 2.47 1.01 4.07v-88.62c-4.61-.06-9.03-1.52-12.8-4.21-.36-.26-.72-.52-1.1-.79 1.51 5.65 2.83 12.57 3.67 16.91.18.94.33 1.73.45 2.33.34 1.69 1.83 6.59 3.4 11.76 3.18 10.45 5.42 18.01 5.42 20.13 0 1.58-.68 2.31-1.25 2.65-.44.26-.93.35-1.41.35-1.25 0-2.48-.64-2.79-.81l-.26-.14-.14-.26c-.07-.13-7.08-13.28-9.7-18.51-.77-1.55-1.69-4.32-2.64-7.67-3.94 3.87-15.34 15.04-18.32 17.27-2.3 1.72-6.56 3.06-9.74 3.88-.29.08-.59.11-.88.11-.75 0-1.47-.24-2.09-.7a3.495 3.495 0 0 1-1.4-2.68c-.13-3.6-.17-7.88.46-10.74-3.21.72-8.12.96-13.29.96-7.03 0-14.53-.45-18.85-.75-6.2 1.91-11.72 3.47-15.13 4.26-1.25.29-2.55.63-3.88 1.03 2.47.76 5.29 1.91 8.3 3.14 3.77 1.55 7.66 3.14 11.27 4.12z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              d: "M698.29 317.47c5.32-1.33 10.38-10.37 13.49-17.15-2.73 2.36-5.98 4.21-8.76 6.05-3.27 2.18-17.98 7.4-31.45 11.68 8.56.47 21.06.84 26.72-.58z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              d: "m700.5 318.76.12.05c-1.05 2.62-.83 8.98-.75 11.37.02.46.23.88.6 1.15.37.27.83.36 1.27.25 4.24-1.1 7.45-2.36 9.04-3.55 3.07-2.3 16.12-15.13 18.91-17.87-2.01-7.44-4.09-16.83-5.33-22.41l-.31-1.4c-.95-4.3-3.65-9.85-5.85-13.92 0 0-.01 0-.01-.01-.17-.13-.33-.26-.49-.39.27 7.44.35 16.44-.6 20.26-.09.35-.19.69-.3 1.02l.02.01c-.31.9-7.44 21.01-16.32 25.44zm25.82-31.45c1.94 8.74 5.97 26.94 8.41 31.82 2.39 4.79 8.49 16.25 9.52 18.19.65.31 1.6.57 1.96.35.24-.14.26-.69.26-.92 0-1.98-3.08-12.13-5.34-19.55-1.66-5.45-3.09-10.17-3.45-11.95-.12-.6-.27-1.4-.46-2.35-.89-4.63-2.55-13.29-4.33-19.22-3.81-2.83-7.89-5.98-10.92-8.31 0-.01-.01-.01-.01-.01 1.69 3.45 3.31 7.3 4.03 10.55l.33 1.4z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M732.92 283.69c0-.01 0-.01 0 0 1.77 5.93 3.43 14.58 4.32 19.22.18.95.33 1.74.46 2.35.36 1.79 1.79 6.5 3.45 11.95 2.25 7.41 5.34 17.57 5.34 19.55 0 .23-.03.78-.26.92-.37.22-1.31-.05-1.96-.35-1.03-1.93-7.13-13.4-9.52-18.19-2.44-4.88-6.47-23.08-8.41-31.82l-.31-1.4c-.72-3.25-2.34-7.1-4.03-10.55-.69-.54-1.32-1.03-1.88-1.47l-1.81-1.4c-.03-.02-.05-.04-.08-.06 2.2 4.07 4.89 9.62 5.85 13.92l.31 1.4c1.24 5.58 3.32 14.97 5.33 22.41.32-.32.51-.51.53-.52l1.41 1.42c-.1.1-.58.58-1.33 1.31.95 3.35 1.87 6.12 2.64 7.67 2.62 5.23 9.63 18.38 9.7 18.51l.14.26.26.14c.31.17 1.54.81 2.79.81.49 0 .97-.1 1.41-.35.57-.34 1.25-1.07 1.25-2.65 0-2.11-2.25-9.68-5.42-20.13-1.57-5.18-3.06-10.07-3.4-11.76-.12-.6-.27-1.39-.45-2.33-.83-4.34-2.16-11.26-3.67-16.91-.88-.64-1.76-1.29-2.66-1.95z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M710.79 328.02c-1.59 1.19-4.8 2.45-9.04 3.55-.44.12-.91.02-1.27-.25s-.58-.69-.6-1.15c-.08-2.39-.3-8.74.75-11.37l-.12-.05c-.57.28-1.15.5-1.72.65-.14.03-.28.07-.43.1-.63 2.86-.59 7.14-.46 10.74.04 1.07.55 2.04 1.4 2.68.61.46 1.34.7 2.09.7.29 0 .59-.04.88-.11 3.18-.82 7.44-2.16 9.74-3.88 2.97-2.23 14.38-13.39 18.32-17.27-.2-.71-.41-1.45-.61-2.21-2.81 2.75-15.86 15.57-18.93 17.87z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M730.22 309.63c-.02.02-.21.21-.53.52.2.76.41 1.49.61 2.21.74-.73 1.22-1.21 1.33-1.31l-1.41-1.42zm-64 24.56c6.78 1.85 17.93 5.94 23.86 8.18 1.56-.17 3.12-.28 4.7-.35-.47-.18-18.49-7.15-28.04-9.76-3.61-.98-7.49-2.57-11.25-4.11-3.01-1.23-5.83-2.38-8.3-3.14-1.18.35-2.38.74-3.6 1.19 2.87.42 7.05 2.13 11.14 3.8 3.82 1.56 7.76 3.17 11.49 4.19zm32.12-14.68c.12-.53.26-1.02.42-1.44l1.73.69h.01c8.88-4.43 16.01-24.54 16.33-25.44l-.02-.01c-.96 2.85-2.82 5.1-5.03 7.01-3.11 6.78-8.17 15.82-13.49 17.15-5.66 1.42-18.16 1.05-26.72.58h-.02c-1.81.58-3.61 1.14-5.35 1.67 4.32.3 11.82.75 18.85.75 5.17 0 10.08-.24 13.29-.96z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M698.77 319.41c.58-.15 1.16-.37 1.72-.65l-1.73-.69c-.17.42-.31.91-.42 1.44.15-.03.29-.07.43-.1z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              d: "M801.66 319.51c.72 3.29.55 8.38.46 10.74a3.495 3.495 0 0 1-1.4 2.68c-.61.46-1.34.7-2.09.7-.29 0-.59-.04-.88-.11-3.17-.82-7.44-2.16-9.74-3.88-2.98-2.23-14.38-13.39-18.32-17.27-.95 3.35-1.86 6.12-2.64 7.67-2.62 5.23-9.63 18.38-9.7 18.51l-.14.26-.26.14c-.31.17-1.54.81-2.79.81-.49 0-.97-.1-1.41-.35-.57-.34-1.25-1.07-1.25-2.65 0-2.12 2.25-9.68 5.43-20.14 1.57-5.18 3.06-10.06 3.4-11.76.12-.6.27-1.39.45-2.33.79-4.13 2.03-10.59 3.45-16.08h-.01c-.33.25-.65.48-.96.71-3.1 2.27-6.78 3.47-10.63 3.47h-2.08v88.61c.3-1.6.64-2.98 1.01-4.07 4.41-12.87 8.6-22.44 22.55-28.4 7.21-3.09 19.19-5.25 31.1-4.75.73-.28 18.56-7.17 28.03-9.76 3.61-.98 7.5-2.57 11.25-4.11 3.01-1.23 5.83-2.39 8.3-3.14-1.34-.4-2.63-.74-3.88-1.03-3.41-.79-8.92-2.35-15.12-4.26h-.01c-4.32.3-11.82.75-18.84.75-5.16 0-10.07-.24-13.28-.96z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              d: "m775.94 286.34-.31 1.4c-1.24 5.58-3.32 14.97-5.33 22.41 2.79 2.75 15.83 15.57 18.91 17.87 1.59 1.19 4.8 2.45 9.04 3.55.45.12.91.02 1.27-.25s.58-.69.6-1.15c.08-2.39.3-8.75-.75-11.37l.12-.05c-8.88-4.42-16.01-24.54-16.33-25.44h.01v-.01c-.11-.33-.21-.67-.3-1.02-.91-3.65-.87-12.02-.63-19.25-.22.17-.45.36-.71.54-2.14 3.7-4.67 8.65-5.59 12.77zm-13.64 18.91c-.36 1.79-1.79 6.49-3.44 11.94-2.25 7.42-5.34 17.57-5.34 19.56 0 .23.03.78.26.92.37.22 1.31-.05 1.96-.35 1.03-1.93 7.13-13.4 9.53-18.19 2.44-4.88 6.47-23.08 8.41-31.82l.31-1.4c.67-3.01 2.11-6.37 3.66-9.41-3.24 2.42-7.31 5.44-10.81 8.04-1.68 5.88-3.23 13.95-4.08 18.36-.18.95-.34 1.75-.46 2.35z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              d: "M801.71 317.47c5.66 1.42 18.16 1.05 26.72.58-13.46-4.28-28.18-9.5-31.45-11.68-2.78-1.85-6.05-3.7-8.78-6.07 3.12 6.79 8.18 15.84 13.51 17.17zm-51.15 61.77v-88.61h-.77c-.12 0-.23 0-.35-.01v88.62c.21 1.08.39 2.27.56 3.55.17-1.28.35-2.47.56-3.55z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M760.34 304.86c-.34 1.69-1.82 6.58-3.4 11.76-3.18 10.46-5.43 18.02-5.43 20.14 0 1.58.68 2.31 1.25 2.65.44.26.93.35 1.41.35 1.25 0 2.48-.64 2.79-.81l.26-.14.14-.26c.07-.13 7.08-13.28 9.7-18.51.77-1.55 1.69-4.32 2.64-7.67-.74-.73-1.22-1.21-1.33-1.31l1.41-1.42c.02.02.21.21.53.52 2.01-7.44 4.09-16.83 5.33-22.41l.31-1.4c.91-4.12 3.45-9.06 5.59-12.77h-.01l-.01.01c-1.01.77-2.35 1.77-3.87 2.91-1.55 3.04-2.99 6.4-3.66 9.41l-.31 1.4c-1.94 8.74-5.97 26.94-8.41 31.82-2.39 4.79-8.5 16.25-9.53 18.19-.66.31-1.6.57-1.96.35-.24-.14-.26-.69-.26-.92 0-1.98 3.09-12.14 5.34-19.56 1.66-5.45 3.09-10.16 3.44-11.94.12-.6.27-1.4.46-2.35.85-4.42 2.4-12.48 4.08-18.36h-.01l-2.59 1.91c-1.42 5.49-2.66 11.95-3.45 16.08-.18.93-.33 1.73-.45 2.33z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M788.01 329.62c2.3 1.72 6.57 3.06 9.74 3.88a3.503 3.503 0 0 0 4.37-3.27c.08-2.36.26-7.45-.46-10.74-.15-.03-.3-.06-.44-.1-.58-.15-1.15-.36-1.72-.65l-.12.05c1.05 2.62.83 8.97.75 11.37-.02.46-.23.88-.6 1.15-.37.27-.83.36-1.27.25-4.24-1.09-7.45-2.35-9.04-3.55-3.07-2.3-16.12-15.13-18.91-17.87-.2.76-.41 1.49-.61 2.21 3.93 3.88 15.34 15.04 18.31 17.27z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M768.37 311.05c.1.1.58.58 1.33 1.31.2-.71.41-1.45.61-2.21-.32-.32-.51-.51-.53-.52l-1.41 1.42zm31.13 7.71 1.74-.69c.17.42.3.91.42 1.44 3.21.72 8.12.96 13.29.96 7.02 0 14.52-.45 18.84-.75-1.74-.53-3.54-1.09-5.35-1.67h-.01c-8.56.47-21.06.84-26.72-.58-5.33-1.33-10.39-10.38-13.51-17.17-2.2-1.91-4.05-4.14-5.02-6.98h-.01c.32.9 7.45 21.02 16.33 25.44z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M801.66 319.51c-.12-.53-.25-1.02-.42-1.44l-1.73.69c.57.29 1.14.5 1.72.65.13.04.28.07.43.1z"
	            }),
	            _react2.default.createElement("path", {
	              d: "M718.21 272.42c.03.02.05.05.08.06l1.81 1.4c.56.44 1.19.93 1.88 1.47 0 0 .01 0 .01.01 3.03 2.34 7.11 5.49 10.92 8.31l.01.01c.9.66 1.78 1.31 2.62 1.93.38.27.74.53 1.1.79 3.77 2.69 8.19 4.15 12.8 4.21.12.01.23.01.35.01h2.85c3.85 0 7.53-1.2 10.63-3.47.31-.23.63-.46.96-.71h.01l2.59-1.91h.01c3.5-2.6 7.57-5.62 10.81-8.04 1.52-1.14 2.86-2.14 3.87-2.91l.01-.01h.01c.27-.18.5-.37.71-.54 0-.24.01-.47.02-.71.01-.19.01-.38.02-.57l.03-.77c-.02.01-.04.03-.06.04-.33.25-.72.54-1.14.86-.03.02-.06.05-.09.07-.21.16-.43.32-.65.49-.06.04-.11.09-.17.13-.23.18-.47.35-.72.54l-.02.02c-.02.01-.04.03-.06.05-.37.28-.76.57-1.16.87-.05.04-.1.07-.15.11-.4.3-.82.61-1.25.93-.02.01-.03.02-.05.04-.45.34-.92.68-1.39 1.04-.02.02-.05.04-.07.05l-3.01 2.24s-.01 0-.01.01c-2.53 1.88-5.11 3.79-7.37 5.44-.01 0-.01.01-.02.01l-.02.02c-.28.21-.56.41-.83.61-.33.25-.66.49-.97.71a17.168 17.168 0 0 1-7.52 3.14c-.9.14-1.82.22-2.74.22h-3.05c-.12 0-.23 0-.35-.01-.12 0-.23-.01-.35-.02-2.24-.09-4.43-.51-6.52-1.25-.13-.05-.27-.1-.4-.15-.28-.11-.57-.21-.85-.33-.39-.16-.77-.34-1.15-.52-.16-.08-.33-.17-.49-.26-.31-.16-.61-.33-.91-.5-.14-.08-.28-.17-.42-.25a21.053 21.053 0 0 1-1.78-1.21l-.63-.45c-2.83-2.05-6.02-4.47-8.95-6.71-.06-.04-.11-.09-.17-.13-.48-.37-.95-.73-1.41-1.08-.04-.03-.08-.06-.12-.1-1.51-1.16-2.89-2.23-4.05-3.13-.1-.08-.18-.14-.28-.22-.33-.26-.64-.5-.93-.73-.16-.13-.32-.25-.48-.37-.2-.15-.39-.3-.56-.43a.55.55 0 0 1-.09-.07c-.2-.15-.38-.29-.53-.41-.25-.19-.49-.41-.74-.6.01.33.03.67.04 1.01l.03.76v.01c0 .18.01.36.02.55.14.14.3.27.48.4-.01 0 0 0 0 0z",
	              fill: "#ebebeb"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              d: "M764.9 283.95c-.28.21-.56.41-.83.61.27-.2.55-.4.83-.61zm10.43-7.72-3.01 2.24 3.01-2.24zm-14.57 10.49zm16.03-11.58c-.45.34-.92.68-1.39 1.04.48-.36.94-.7 1.39-1.04zm-36.63 11.21c-.16-.08-.33-.17-.49-.26.17.09.33.17.49.26zm-1.39-.76c-.14-.08-.28-.17-.42-.25.13.08.27.17.42.25zm3.39 1.61c-.28-.11-.57-.22-.85-.33.29.12.57.23.85.33zm35.93-13.03c-.4.3-.82.61-1.25.93.43-.32.85-.63 1.25-.93zm4.18-3.14c-.33.25-.72.54-1.14.86.42-.32.81-.61 1.14-.86zm-1.24.94c-.21.16-.43.32-.65.49.22-.17.44-.34.65-.49zm-.82.62c-.23.17-.47.35-.72.54.25-.19.48-.37.72-.54zm-.81.6c-.37.28-.76.57-1.16.87.4-.3.79-.59 1.16-.87zm-42.84 10.94c.17.13.35.26.52.38-.17-.13-.35-.26-.52-.38zm13.26 4.5h.11-.11zm-2.77-.2c-.21-.03-.42-.05-.64-.08-.19-.03-.38-.08-.57-.11-1.11-.21-2.21-.51-3.28-.88 2.09.74 4.29 1.16 6.52 1.25-.35-.01-.71-.03-1.06-.06-.32-.03-.65-.08-.97-.12zm17.89-4.51c2.25-1.66 4.84-3.57 7.37-5.44-1.56 1.16-3.15 2.33-4.66 3.45-.94.69-1.85 1.36-2.71 1.99zm-38.13-7.09c-.48-.37-.95-.73-1.41-1.08.46.35.93.72 1.41 1.08zm-7.28-5.62c-.2-.16-.39-.3-.56-.43.17.13.36.28.56.43zm-.64-.5c-.2-.15-.38-.29-.53-.41-.25-.19-.49-.41-.74-.6.25.2.49.41.74.6.15.12.33.26.53.41zm6.38 4.94c-1.5-1.16-2.89-2.23-4.05-3.13 1.17.9 2.55 1.98 4.05 3.13zm6.65 5.06s-.01 0 0 0a630.11 630.11 0 0 1-4.94-3.75c2.93 2.24 6.12 4.66 8.95 6.71-.39-.28-.78-.57-1.18-.87-.93-.67-1.88-1.37-2.83-2.09zm-11.87-9.1c-.01-.01-.03-.02-.04-.03.29.23.6.47.93.73-.31-.25-.61-.48-.89-.7z"
	            }),
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "282",
	              width: "100",
	              height: "40",
	              rx: "5"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-throat is_right",
	              transform: "translate(0 15)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Throat");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Throat");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "262",
	              y: "273",
	              width: "125",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-823.163 -10)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.63435 0 0 -.7655 2072.54 448.667)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Throat" ? "#f58220" : "#af9763"
	                },
	                d: "M1099.992 314.9v-21.42h-7.668v-4.357h20.484v4.356h-7.632v21.42h-5.184ZM1121.046 289.123v9.468c1.62-1.836 3.528-2.772 5.724-2.772 1.152 0 2.16.216 3.096.612.9.432 1.584.972 2.052 1.62.468.648.792 1.404.936 2.196.18.792.252 2.016.252 3.708V314.9h-4.932v-9.864c0-1.944-.072-3.204-.288-3.708-.18-.54-.504-.972-.972-1.26-.468-.324-1.08-.468-1.8-.468-.792 0-1.548.18-2.196.576-.648.396-1.116 1.008-1.404 1.8-.288.828-.468 2.016-.468 3.564v9.36h-4.932v-25.776h4.932ZM1142.856 314.9h-4.932v-18.685h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM1150.998 305.287c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM1177.812 301.94l-4.464-.829c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.624 3.995c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1202.728 296.215v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: "bodyParts_wrapper Right_Shoulder",
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Arm");
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2.handleHoverBodyPart("Arm");
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              return _this2.handleHoverBodyPart(null);
	            }
	          },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M620.4 449.44c3.87-8.15 7.7-16.02 11.06-22.93 3.85-7.92 6.89-14.17 8.58-17.97 6.92-15.58 13.49-43.76 13.55-44.05l.5.12c.11-.34 2.92-8.53 16.29-16.39 5.58-3.28 12.5-5.1 19.69-5.85h.01c-5.93-2.23-17.08-6.33-23.86-8.18-3.73-1.02-7.67-2.63-11.48-4.19-4.09-1.67-8.27-3.38-11.14-3.8-10.03 3.65-20.9 10.55-25.1 22.44-3.3 9.39-5.23 32.63-5.99 52.34 2.38 7.67 8.36 27.63 8.36 34.31-.01 4.65-.25 10.25-.47 14.15zm0 .01v-.01.01z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M630.47 536.05c-.07.78-.1 1.18-.11 1.2l1.99.17c0-.02.04-.46.11-1.3-.66.04-1.32.02-1.99-.07zm-12.34-81.9h.05c.74-1.57 1.48-3.14 2.22-4.7v-.01c.22-3.9.46-9.5.46-14.15 0-6.68-5.98-26.64-8.36-34.31-.08 2.12-.15 4.21-.2 6.23 2.72 9.15 6.56 22.98 6.56 28.08 0 7.97-.72 18.75-.73 18.86z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M620.13 454.28c0-.04.13-1.99.27-4.83-.74 1.56-1.48 3.13-2.22 4.7l1.95.13z"
	            }),
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "M630.47 536.05c-.07.78-.1 1.18-.11 1.2l1.99.17c0-.02.04-.46.11-1.3-.66.04-1.32.02-1.99-.07z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M633.25 427.39c-7.63 15.68-18.64 38.33-26.25 56.94l.15-.02c.07.44 6.84 44.11 20.1 50.74 1.08.53 2.15.86 3.22 1 .34-4.04 1.52-18.45 3.44-45.29 2.29-32.14 26.41-107.08 26.66-107.83l.27.09c-2.25-7.44-4.6-13.05-5.83-15.79-1.73 7.09-7.29 29-13.14 42.13-1.71 3.82-4.76 10.09-8.62 18.03z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M656.53 481.33c-.73-2.07-1.27-4.44-1.61-7.11-.06-.5-.12-1.05-.16-1.62-.19-2.15-.25-4.49-.24-6.71-.03-6.49.37-13.19.4-13.49l1.39 4.12c-.17-.53-.32-1.07-.46-1.6-1.27-4.66-1.6-9.03-1.57-12.48-.08-5.68.59-9.98.66-10.29l.84 3.14c-.82-2.57-1.12-5.5-.86-8.81.34-4.46 1.67-10.6 3.06-17.1 1.77-8.18 3.73-17.26 3.5-22.75v-.01c-4.56 14.46-23.57 76.08-25.58 104.27-1.9 26.64-3.08 41.05-3.43 45.22h.01c7.28-.51 14.13-8.58 17.99-14.09v-.01c2.97-15.17 5.53-28.4 5.89-31.63l.17-9.05zm-38.4-27.18c.01-.11.73-10.89.73-18.86 0-5.1-3.84-18.93-6.56-28.08-.25 9.13-.23 16.98.04 21.55.59 9.99-4.71 37.22-9.09 59.47 4.06-10.37 9.45-22.38 14.93-34.08h-.05z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m604.17 487.36 1.42-.27c-.24-1.37-.38-2.25-.41-2.48l1.82-.28c7.61-18.61 18.62-41.26 26.25-56.94 3.86-7.94 6.91-14.21 8.61-18.04 5.85-13.13 11.41-35.04 13.14-42.13a49.86 49.86 0 0 0-.86-1.85l-.18-.37.13-.39-.5-.12c-.06.29-6.63 28.47-13.55 44.05-1.69 3.8-4.73 10.05-8.58 17.97-3.36 6.91-7.19 14.78-11.06 22.93v.01c-.14 2.84-.27 4.79-.27 4.83l-1.95-.13c-5.48 11.7-10.87 23.71-14.93 34.08 0 .01 0 .02-.01.03-.91 4.71-1.8 9.21-2.58 13.26 1.06-3.41 2.42-7.25 4.01-11.37 0 0 .01-.01 0-.01-.3-1.72-.48-2.7-.5-2.78z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M632.48 536.12h-.01c-.07.84-.11 1.28-.11 1.3l-1.99-.17c0-.02.04-.42.1-1.2-1.07-.14-2.14-.47-3.22-1-13.26-6.63-20.03-50.3-20.1-50.74l-.15.02c-.38.91-.74 1.81-1.1 2.7l.24-.04c.16.82 1.21 6.42 2.54 14.82 3.36 13.53 9.17 30.78 17.67 35.03 1.84.92 3.67 1.33 5.47 1.33 6.95 0 13.36-6.05 17.75-11.54.3-1.55.6-3.08.9-4.6-3.86 5.51-10.71 13.58-17.99 14.09z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m605.59 487.09.31-.05v-.01c.36-.89.72-1.79 1.1-2.7l-1.82.28c.03.23.17 1.11.41 2.48zm28.31 3.66c-1.92 26.84-3.1 41.25-3.44 45.29.67.09 1.33.11 2 .07.35-4.18 1.53-18.58 3.43-45.22 2.01-28.2 21.02-89.81 25.58-104.27-.04-1.06-.17-1.99-.39-2.75-.09-.29-.17-.58-.26-.86l-.27-.09c-.23.75-24.35 75.69-26.65 107.83z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m605.59 487.09-1.42.27c.02.08.2 1.06.5 2.78.01 0 0 .01 0 .01.33-.84.66-1.69 1-2.55v-.01c-.02-.17-.05-.34-.08-.5zm.32-.06v.01c-.08.19-.15.38-.23.56.56 3.11 1.55 8.31 3.01 14.21-1.33-8.4-2.38-14-2.54-14.82l-.24.04z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M605.59 487.09c.03.16.06.33.08.5v.01c.08-.18.15-.37.23-.56l-.31.05z"
	            }),
	            _react2.default.createElement("path", { className: "bodyLines", d: "m605.9 487.04.01-.01h-.01z" })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M614.66 584.43c-.24 2.59-.55 5.04-.95 7.33h-.01l.16.06c10.07-27.47 26.16-41.88 32.05-46.46.19-.96.38-1.93.57-2.91-3.4 2.39-20.21 15.18-31.82 41.98z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M613.7 591.76h.01c.4-2.29.71-4.74.95-7.33-.93 2.14-1.83 4.38-2.68 6.71l1.72.62z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M596.37 722.79s0 .02-.01.04c-.17.36-1.62 3.3-4.12 6.21-3.91 4.57-10.4 9.09-18.66 3.59-8.89-5.92-9.77-12.32-9.26-16.16 0-.01 0-.03.01-.04-5.83 15.64-16.78 40.32-17.68 51.14-1.01 11.97 24.13 49.33 27.28 52.49 4.14 4.13 11.66 3.42 9.66-1.57s-17.97-32.95-14.97-37.94c2.98-5 15.97-20.98 20.96-18.97 4.99 1.99 0 24.97 4.99 28.96 5 4 8.92-.01 9.98-7.98 1.06-7.95.39-11.09 2.43-16.21 2.76-6.88.42-12.7-1.37-17.91-1.56-4.56-5.51-8.27-6.88-12.4-1.68-5-3.36-6.58-2.01-14.97l-.07-.01c-.1.57-.19 1.15-.28 1.73z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "m613.86 591.82-.16-.06c-.27 1.62-.6 3.16-.97 4.6-6.96 26.85-35.53 87.57-43.26 103.76-.1.66-.19 1.19-.27 1.57-.43 2.12-1.87 6.11-3.86 11.27 0 0 0 .01-.01.02s-.02.05-.03.07c-.01.03-.03.06-.04.08-.15.42-.31.84-.48 1.26-.01.03-.01.05-.03.07-.17.53-.32 1.2-.42 1.97l32.32 4.62c.23-1.46.48-2.93.72-4.39 1.76-10.56 26.41-64.28 31.7-86.28 5.27-22.02 10.56-44.9 11.44-54.59.34-3.74 2.65-16.15 5.4-30.43-5.89 4.58-21.98 18.99-32.05 46.46z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M604.67 490.15c-1.59 4.12-2.95 7.96-4.01 11.37 0 .01 0 .02-.01.03-1.04 5.47-1.9 10.14-2.4 13.49-2.64 17.61-13.2 46.66-15.85 70.44-2.26 20.33-9.02 84.43-12.03 108.08 10.19-21.59 34.16-73.54 40.42-97.7 7.09-27.34-3.6-91.55-6.12-105.71zm-40.35 226.32c-.51 3.84.37 10.24 9.26 16.16 8.26 5.5 14.75.98 18.66-3.59 2.5-2.91 3.95-5.85 4.12-6.21.01-.02.01-.04.01-.04.09-.58.18-1.16.28-1.74l-32.32-4.62c-.01.01-.01.03-.01.04z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m613.7 591.76-1.72-.62c.85-2.33 1.75-4.57 2.68-6.71 2.24-24.89-2.72-62.1-5.98-82.62-1.46-5.9-2.45-11.1-3.01-14.21-.34.86-.67 1.71-1 2.55 2.52 14.16 13.21 78.37 6.12 105.71-6.26 24.16-30.23 76.11-40.42 97.7-.36 2.8-.66 5.03-.9 6.56 7.73-16.19 36.3-76.91 43.26-103.76.37-1.44.7-2.98.97-4.6z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M631.82 538.17c-1.8 0-3.63-.41-5.47-1.33-8.5-4.25-14.31-21.5-17.67-35.03 3.26 20.52 8.22 57.73 5.98 82.62 11.61-26.8 28.42-39.59 31.82-41.98 1.01-5.2 2.06-10.57 3.09-15.82-4.39 5.49-10.8 11.54-17.75 11.54z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-arm is_right",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Arm");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Arm");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "305",
	              y: "462",
	              width: "82",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 5.822)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M642.407 191.303H1331.1",
	                transform: "matrix(-.30694 0 0 -.7655 813.571 622.539)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Arm" ? "#f58220" : "#af9763"
	                },
	                d: "M336.126 488.982h-5.652l-2.232-5.868H317.91l-2.124 5.868h-5.508l10.044-25.776h5.508l10.296 25.776Zm-9.576-10.188-3.528-9.576-3.492 9.576h7.02ZM343.576 488.982h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM352.51 470.298h4.536v2.556c1.62-1.98 3.564-2.952 5.832-2.952 1.188 0 2.232.252 3.096.72.864.504 1.584 1.26 2.16 2.232.828-.972 1.692-1.728 2.664-2.232a6.683 6.683 0 0 1 3.024-.72c1.368 0 2.556.252 3.492.828.936.54 1.656 1.368 2.124 2.448.324.792.504 2.088.504 3.852v11.952h-4.932v-10.656c0-1.872-.18-3.06-.504-3.6-.468-.72-1.152-1.044-2.124-1.044-.684 0-1.332.216-1.944.612-.612.432-1.044 1.044-1.332 1.872-.252.792-.396 2.088-.396 3.852v8.964h-4.932v-10.224c0-1.836-.072-2.988-.252-3.528-.18-.504-.468-.9-.828-1.188-.36-.252-.864-.36-1.512-.36-.756 0-1.44.18-2.052.612-.612.396-1.044 1.008-1.296 1.764-.288.792-.396 2.052-.396 3.852v9.072h-4.932v-18.684Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: "bodyParts_wrapper Left_SHoulder",
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Elbow");
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2.handleHoverBodyPart("Elbow");
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              return _this2.handleHoverBodyPart(null);
	            }
	          },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M833.78 334.19c-6.78 1.85-17.93 5.94-23.86 8.18 7.19.74 14.12 2.57 19.7 5.85 13.28 7.81 16.14 15.95 16.29 16.38v.01l.49-.11c.07.28 6.63 28.47 13.56 44.05 1.69 3.8 4.73 10.06 8.59 17.98 3.36 6.9 7.18 14.77 11.04 22.92v-.01c-.21-3.9-.45-9.49-.45-14.14 0-6.68 5.98-26.64 8.36-34.31v-.01c-.76-19.72-2.69-42.94-6-52.33-4.19-11.89-15.06-18.79-25.09-22.44-2.87.41-7.06 2.12-11.15 3.8-3.81 1.55-7.76 3.17-11.48 4.18z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M867.53 536.11c.07.85.11 1.29.11 1.31l1.99-.17c0-.02-.04-.42-.1-1.2-.68.09-1.33.1-2 .06zm12.06-86.68c.74 1.57 1.48 3.14 2.22 4.72h.06c-.01-.11-.73-10.89-.73-18.86 0-5.1 3.84-18.93 6.56-28.08v-.01c-.05-2.02-.12-4.1-.2-6.22-2.38 7.67-8.36 27.63-8.36 34.31 0 4.65.24 10.24.45 14.14z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M881.81 454.15c-.74-1.58-1.48-3.15-2.22-4.71.14 2.85.28 4.8.28 4.84l1.94-.13z"
	            }),
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "M867.53 536.11c.07.85.11 1.29.11 1.31l1.99-.17c0-.02-.04-.42-.1-1.2-.68.09-1.33.1-2 .06z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M866.1 490.75c1.92 26.84 3.1 41.25 3.44 45.3 1.07-.14 2.15-.46 3.22-1 13.26-6.63 20.03-50.3 20.09-50.74l.16.02c-7.61-18.61-18.63-41.25-26.26-56.93-3.86-7.94-6.91-14.21-8.62-18.04-5.85-13.15-11.41-35.08-13.13-42.14-1.23 2.73-3.57 8.36-5.83 15.8l.27-.09c.24.74 24.36 75.68 26.66 107.82zm30.65-2.5c-4.38-22.25-9.68-49.5-9.09-59.49.27-4.57.29-12.42.04-21.55-2.72 9.15-6.56 22.98-6.56 28.08 0 7.97.72 18.75.73 18.86h-.06c5.49 11.71 10.88 23.72 14.94 34.1z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M867.52 536.11s.01 0 0 0c-.34-4.19-1.52-18.59-3.42-45.21-2.01-28.19-21.02-89.79-25.58-104.26-.23 5.49 1.73 14.57 3.49 22.75 1.4 6.5 2.72 12.64 3.07 17.1.18 2.33.07 4.47-.28 6.43l.55-2.29c-.08-1.75.6 4.53.37 12.18 0 1.92-.11 4.11-.43 6.47-.08.71-.17 1.42-.27 2.12.08 1.28.38 6.85.43 12.54.07 3.29.02 7.12-.38 10.29-.24 1.96-.6 3.75-1.06 5.39l.15 14.17c.96 5.62 3.04 16.32 5.37 28.23v.01c3.86 5.49 10.71 13.57 17.99 14.08z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M866.75 427.39c7.63 15.68 18.64 38.33 26.26 56.93l1.82.28c-.03.23-.17 1.11-.41 2.48l1.41.27c-.02.08-.2 1.06-.5 2.77v.01c1.61 4.17 2.99 8.04 4.05 11.48l-.03-.1c-.78-4.06-1.67-8.54-2.59-13.26-4.06-10.38-9.45-22.4-14.94-34.11l-1.94.13c0-.04-.14-2-.28-4.84-3.86-8.15-7.69-16.01-11.04-22.92-3.85-7.92-6.9-14.18-8.59-17.98-6.92-15.58-13.49-43.77-13.56-44.05l-.49.11.13.39-.19.37c-.01.02-.33.66-.85 1.83v.01c1.72 7.06 7.29 28.99 13.13 42.14 1.7 3.85 4.75 10.12 8.61 18.06z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M868.18 538.17c1.79 0 3.62-.41 5.46-1.33 8.5-4.25 14.32-21.48 17.68-35v-.03c1.33-8.4 2.38-14 2.54-14.82l.24.05c-.36-.89-.72-1.8-1.1-2.71l-.16-.02c-.06.44-6.83 44.11-20.09 50.74-1.07.54-2.15.86-3.22 1 .07.78.1 1.18.1 1.2l-1.99.17c0-.02-.04-.46-.11-1.31h-.01c-7.28-.51-14.13-8.59-17.99-14.09.3 1.52.6 3.06.9 4.61 4.39 5.49 10.8 11.54 17.75 11.54zm26.23-51.08c.24-1.37.38-2.25.41-2.48l-1.82-.28c.37.91.74 1.82 1.1 2.71l.31.05z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M867.53 536.11c.67.04 1.32.03 2-.06-.34-4.04-1.52-18.45-3.44-45.3-2.3-32.14-26.41-107.08-26.66-107.83l-.27.09c-.09.28-.17.57-.26.86-.23.76-.35 1.69-.39 2.75v.01c4.56 14.48 23.57 76.07 25.58 104.26 1.91 26.63 3.09 41.03 3.44 45.22zm28.29-48.75-1.41-.27c-.03.16-.06.33-.08.51v.02c.34.85.67 1.7.99 2.53v-.01c.3-1.72.48-2.7.5-2.78zm-1.96-.37c-.16.82-1.21 6.42-2.54 14.82 1.46-5.89 2.45-11.08 3.01-14.19-.08-.19-.15-.38-.23-.58l-.24-.05zm-2.54 14.83v.02-.02z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m894.41 487.09-.31-.05c.08.19.15.38.23.58v-.02c.02-.18.05-.35.08-.51zM842.55 493l1.62.78c-.26-1.54-.44-2.7-.52-3.39-.33-2.91-.65-1.2-1.1 2.61z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M844.01 479.61c-.09.33-.2.65-.3.98L842.55 493c.45-3.81.77-5.52 1.1-2.61.08.69.26 1.85.52 3.39l-.16-14.17z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M953.35 767.56c-.9-10.82-11.85-35.5-17.68-51.14.52 3.83-.33 10.26-9.25 16.2-8.26 5.5-14.76.98-18.67-3.59-2.49-2.91-3.94-5.85-4.11-6.21-.02-.02-.02-.04-.02-.04-.09-.58-.18-1.16-.28-1.74l-.06.01c1.34 8.39-.34 9.97-2.01 14.97-1.38 4.13-5.32 7.84-6.88 12.4-1.78 5.21-4.13 11.03-1.37 17.91 2.04 5.11 1.37 8.26 2.43 16.21 1.06 7.97 4.99 11.99 9.98 7.98 4.99-3.99 0-26.97 4.99-28.96 5-2 17.98 13.98 20.96 18.97 3 4.99-12.97 32.95-14.97 37.94-2 5 5.52 5.7 9.66 1.57 3.15-3.14 28.29-40.5 27.28-52.48z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M935.67 716.43c-.11-.77-.27-1.43-.43-1.97-.01-.02-.01-.04-.02-.07-.17-.42-.34-.84-.49-1.26-.01-.02-.02-.05-.03-.08-.01-.02-.02-.06-.04-.07-.01-.01-.01-.02-.01-.02-1.99-5.16-3.42-9.15-3.85-11.27-.08-.38-.17-.91-.27-1.57-7.73-16.19-36.3-76.91-43.26-103.76-.37-1.44-.7-2.98-.97-4.6l-.16.06c-10.08-27.47-26.17-41.88-32.05-46.46 2.75 14.28 5.06 26.69 5.4 30.43.88 9.69 6.16 32.57 11.44 54.59 5.29 22 29.94 75.72 31.7 86.28.24 1.46.48 2.93.71 4.39l32.33-4.62zm-32.05 6.36s0 .02.02.04c.17.36 1.62 3.3 4.11 6.21 3.91 4.57 10.41 9.09 18.67 3.59 8.92-5.94 9.77-12.37 9.25-16.2l-32.33 4.62c.1.58.19 1.16.28 1.74z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m886.14 591.82.16-.06c-.41-2.29-.72-4.74-.96-7.33-11.61-26.8-28.42-39.59-31.82-41.98.19.98.38 1.95.57 2.91 5.88 4.58 21.97 18.99 32.05 46.46z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M885.34 584.43c.24 2.59.55 5.04.96 7.33l1.72-.62c-.85-2.33-1.75-4.57-2.68-6.71z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M889.2 595.86c6.27 24.16 30.24 76.11 40.43 97.7-3.01-23.65-9.77-87.75-12.03-108.08-2.65-23.78-13.21-52.83-15.85-70.44-.5-3.33-1.36-7.97-2.38-13.4v-.02c-1.06-3.44-2.44-7.31-4.05-11.48-2.51 14.15-13.2 78.36-6.12 105.72z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M891.32 501.83c-3.36 13.53-9.18 30.76-17.68 35-1.84.92-3.67 1.33-5.46 1.33-6.95 0-13.36-6.05-17.75-11.54 1.03 5.25 2.08 10.62 3.09 15.82 3.4 2.39 20.21 15.18 31.82 41.98-2.24-24.87 2.72-62.06 5.98-82.59z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyLines",
	              d: "M929.63 693.56c-10.19-21.59-34.16-73.54-40.43-97.7-7.08-27.35 3.61-91.57 6.12-105.72-.32-.83-.65-1.67-.99-2.53-.56 3.11-1.55 8.3-3.01 14.19v.03c-3.26 20.53-8.22 57.71-5.98 82.59.93 2.14 1.83 4.38 2.68 6.71l-1.72.62c.27 1.62.6 3.16.97 4.6 6.96 26.85 35.53 87.57 43.26 103.76-.24-1.52-.54-3.75-.9-6.55z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-elbow",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              // onClick={(e) => this.modalFemaleBodySingleContentOpen(e, "Elbow")}
	              className: "labelArea",
	              x: "1115",
	              y: "536",
	              width: "115",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 140.684)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M642.407 191.303H1331.1",
	                transform: "matrix(.28648 0 0 .7655 712.873 268.299)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Elbow" ? "#f58220" : "#af9763"
	                },
	                d: "M1120.01 427.414v-25.776h19.117v4.356h-13.932v5.724h12.96v4.356h-12.96v6.984h14.4v4.356h-19.584ZM1143.985 401.638h4.932v25.776h-4.932zM1153.769 427.414v-25.776h4.932v9.288c1.512-1.728 3.348-2.592 5.436-2.592 2.268 0 4.14.828 5.616 2.448 1.512 1.656 2.232 4.032 2.232 7.092 0 3.204-.756 5.652-2.268 7.38-1.512 1.728-3.348 2.592-5.544 2.592-1.044 0-2.088-.288-3.132-.792-1.044-.54-1.944-1.332-2.7-2.376v2.736h-4.572Zm4.896-9.756c0 1.944.324 3.384.936 4.32.828 1.296 1.98 1.944 3.384 1.944 1.116 0 2.016-.468 2.808-1.368.756-.936 1.152-2.412 1.152-4.428 0-2.124-.396-3.672-1.188-4.608-.756-.936-1.764-1.404-2.952-1.404s-2.16.432-2.952 1.368c-.792.936-1.188 2.304-1.188 4.176ZM1174.823 417.802c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM1201.42 427.414l-5.903-18.684h4.824l3.492 12.24 3.204-12.24h4.788l3.096 12.24 3.564-12.24h4.86l-5.976 18.684h-4.752l-3.204-11.988-3.168 11.988h-4.824Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: "bodyParts_wrapper Right_Thigh",
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Thigh");
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2.handleHoverBodyPart("Thigh");
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              return _this2.handleHoverBodyPart(null);
	            }
	          },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "M657.45 678.84c.01-9.5-.37-18.1-.6-22.44l-.17.01c.02.2.74 10.29.77 22.43zm-9.4 61.17c-.02 2.45-.04 5.68-.03 9.41.01-5.61.09-9.29.09-9.41h-.06z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Thigh" || this.state.bodyHoverTitles === "Thigh" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M713.04 826.06c1.34 22.23 6.14 105.35 4.62 123.56-3.09 37.1-1.01 60.83 5.71 65.1 1.81 1.16 3.44 1.41 4.98.77 2.26-.92 4.06-3.67 5.34-6.44v-.01c.63-5.03 1.03-9.48 1.03-12.4 0-6.67-.84-60.42-1.65-98.47v-.01c-1.81-6.71-9.65-36.05-11.23-47.09-.69-4.88-4.13-14.29-8.8-25.01zm-28.96 174.97c5.92-11.84 5.24-22.66 3.42-39.06-.98-8.84-12.16-53.22-22.03-92.39-7.79-30.93-15.15-60.14-16.7-68.66-3.03-16.67-2.81-49.86-2.7-58.73-3 8.46-5.62 17.63-6.77 28.72-2.26 21.85 1.16 83.56 2.13 99.93.01.02.01.04.01.05 5.6 30.86 15.32 85.03 16.68 93.17 1.49 8.98 4.9 34.45 5.35 51.64 4.75-1.36 16.01-5.47 20.61-14.67zm28.6-279.36c6.57 20.77 13.95 48.19 17.13 60.01.45 1.67.8 2.97 1.03 3.83 1.73 6.33 4.14 16.86 5.59 23.35.43-3.57.76-6.52.93-8.56.88-10.57 0-29.93 0-34.34 0-.66.3-1.21.81-1.64-2.68-2.97-8.84-9.98-10.95-14.2-1.62-3.23-9.07-17.79-14.54-28.45zm15.19 60.53c-13.14-48.86-21.93-77.11-26.14-83.95-2.49-4.05-7.73-11.71-13.79-20.59-2.86-4.2-5.92-8.67-8.92-13.11 0-.01 0-.01-.01-.01-1.32-.61-7.53-3.48-13.65-6.26 2.73 10.74 15.33 58.81 28.44 86.57 3.16 6.69 6.13 12.87 8.88 18.61 10.23 21.34 17.62 36.75 21.11 49.34 2.54 9.14 6.02 24.58 8.5 35.96.66-10.73 2.19-23.64 3.42-33.85v-.01c-.3-1.37-4.29-19.63-6.8-28.86-.23-.86-.59-2.17-1.04-3.84z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Thigh" || this.state.bodyHoverTitles === "Thigh" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M637.31 770.7c1.65-15.93 6.27-27.89 10.74-39.45 2.69-6.98 5.23-13.56 6.89-20.55 1.96-8.21 2.5-20.65 2.51-31.85-.04-12.15-.76-22.24-.77-22.43l.17-.01-.12-2.06c-6.25-3.13-10.75-11.62-12.45-15.29-4.54 19.68-13.76 68.76-16.1 82-2.65 14.97-4.41 41.38-3.53 54.58.88 13.22 10.56 61.63 13.21 75.72.18.94.41 2.16.69 3.7-1.29-25.11-3.03-67.06-1.24-84.36zm63.56-6.38c-2.75-5.74-5.72-11.92-8.88-18.62-14.01-29.66-27.39-82.21-28.96-88.49-1.53-.7-3.02-1.37-4.38-1.98l.02.02c.05.42 4.46 43.4 9.66 62.47.73 2.67 1.46 5.45 2.21 8.3 4.69 17.87 10.01 38.12 20.55 53.92 12.64 18.96 30.99 58.69 32.73 70.84 1.18 8.24 6.03 27.35 9.06 38.87-.3-13.26-.58-23.61-.81-27.72-.09-1.55-.11-3.27-.09-5.16v-.01c-2.32-10.87-6.96-32.06-10.11-43.43-3.45-12.41-10.81-27.76-21-49.01z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Thigh" || this.state.bodyHoverTitles === "Thigh" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M648.11 740.01c0 .12-.08 3.8-.09 9.41.03 15.27.48 38.84 2.72 51.14 1.54 8.46 8.89 37.64 16.67 68.53 9.32 37.02 18.93 75.16 21.49 88.97v.01l.2-.04c.02.09 1.96 8.69 10.05 10.81 7.31 1.91 14.38-6.36 15.71-8.03v-.01c.24-4.05.52-7.9.81-11.35 1.71-20.46-4.66-123.97-4.95-128.59v-.01c-6.51-14.29-14.69-29.89-21.3-39.81-10.71-16.07-16.08-36.49-20.82-54.51-.74-2.84-1.47-5.61-2.2-8.29-2.68-9.82-5.14-25.61-6.92-38.77.01 10.76-.53 23.05-2.59 31.7-1.69 7.11-4.26 13.76-6.98 20.8-.61 1.58-1.22 3.17-1.83 4.77-.01.83-.02 1.94-.04 3.27h.07zm9.97-87.22c5.53 2.46 14.12 6.41 18.77 8.55-7.46-11.12-14.25-21.59-16.56-26.58-3.48-7.56-4.32-18.98-4.46-26.19-4.02 9-8.3 18.38-10.03 24.44-.28.99-.62 2.27-.99 3.83l.59-.23c.05.13 5.23 12.87 12.68 16.18z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M729.81 781.68c-3.18-11.82-10.56-39.24-17.13-60.01v-.01c-3.34-6.51-5.93-11.56-6-11.7l1.78-.92c-1.93-5.42-3.67-9.62-5.03-11.83-2.52-4.1-7.76-11.78-13.84-20.67-10.74-15.74-24.11-35.32-27.48-42.62-4.17-9.03-4.36-24.41-4.28-29.93-.65 1.47-1.32 2.98-2 4.5v.08c.14 7.21.98 18.63 4.46 26.19 2.31 4.99 9.1 15.46 16.56 26.58l.01.01c1.95.9 3.21 1.48 3.25 1.5l-.84 1.81c-.01 0-.1-.04-.25-.11 3 4.44 6.06 8.91 8.92 13.11 6.06 8.88 11.3 16.54 13.79 20.59 4.21 6.84 13 35.09 26.14 83.95.45 1.67.81 2.98 1.04 3.84 2.51 9.23 6.5 27.49 6.8 28.86.26-2.15.5-4.17.72-6.03v-.01c-1.45-6.49-3.86-17.02-5.59-23.35-.23-.86-.58-2.16-1.03-3.83z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M708.48 709.08c1.33 3.71 2.74 7.97 4.2 12.58v.01c5.47 10.66 12.92 25.22 14.54 28.45 2.11 4.22 8.27 11.23 10.95 14.2.46-.41 1.09-.73 1.82-.99-2.43-2.66-8.92-9.97-10.98-14.1-2.58-5.15-19.82-38.77-20.53-40.15z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M712.68 721.66c-1.46-4.61-2.87-8.87-4.2-12.58-.01-.02-.02-.03-.02-.04l-1.78.92c.07.14 2.66 5.19 6 11.7zm-10 41.8c-2.75-5.74-5.72-11.92-8.88-18.61-13.11-27.77-25.71-75.84-28.44-86.57 0 0-.01 0-.01-.01-.78-.36-1.55-.71-2.32-1.06 1.57 6.28 14.95 58.83 28.96 88.49 3.16 6.7 6.13 12.88 8.88 18.62 10.19 21.25 17.55 36.6 21 49.01 3.15 11.37 7.79 32.56 10.11 43.43.03-2.45.14-5.15.31-8-2.48-11.38-5.96-26.82-8.5-35.96-3.49-12.59-10.88-28-21.11-49.34zm-11.59 16.48c-10.54-15.8-15.86-36.05-20.55-53.92-.75-2.85-1.48-5.63-2.21-8.3-5.2-19.07-9.61-61.05-9.66-61.47l-1.82.16c.23 4.34.61 12.94.6 22.44.03 10.84-.48 23.31-2.51 31.85-1.66 6.99-4.2 13.57-6.89 20.55-4.47 11.56-9.09 23.52-10.74 39.45-1.79 17.3-.05 59.25 1.25 84.36 0 .03.01.06.01.09.7 3.77 1.69 9.21 2.86 15.69-.97-16.37-4.39-78.08-2.13-99.93 1.15-11.09 3.77-20.26 6.77-28.72v-.02c.02-1.36.04-2.15.04-2.2l.76.02 1.24-4.98c0 .05-.01.66-.03 1.73.61-1.6 1.22-3.19 1.83-4.77 2.72-7.04 5.29-13.69 6.98-20.8 2.06-8.65 2.6-20.94 2.59-31.7 1.78 13.16 4.24 28.95 6.92 38.77.73 2.68 1.46 5.45 2.2 8.29 4.74 18.02 10.11 38.44 20.82 54.51 6.61 9.92 14.79 25.52 21.3 39.81v-.01c-.01-.07-.01-.11-.01-.13l2-.13c.01.14.13 2.11.33 5.48 4.67 10.72 8.11 20.13 8.8 25.01 1.58 11.04 9.42 40.38 11.23 47.09-.06-2.94-.12-5.78-.19-8.49v-.02c-3.03-11.52-7.88-30.63-9.06-38.87-1.74-12.15-20.09-51.88-32.73-70.84z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m656.74 654.35.12 2.06 1.82-.16c.05.42 4.46 42.4 9.66 61.47-5.2-19.07-9.61-62.05-9.66-62.47l-.02-.02c-.48-.21-.94-.42-1.38-.61-.19-.08-.36-.18-.54-.27zm.71 24.49c-.01 11.2-.56 23.64-2.51 31.85 2.04-8.54 2.55-21.01 2.51-31.85z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M656.74 654.35c-.03-.56-.06-.9-.06-.93l1.97 1.81c1.36.61 2.85 1.28 4.38 1.98-.1-.38-.15-.59-.16-.62l1.94-.48c.02.06.2.82.54 2.16h.01v.01c6.12 2.79 12.33 5.66 13.65 6.26-.71-1.07-1.43-2.13-2.15-3.19l-.01-.01c-4.65-2.14-13.24-6.09-18.77-8.55-7.45-3.31-12.63-16.05-12.68-16.18l-.59.23v.01c-.17.69-.34 1.42-.52 2.21 1.7 3.66 6.2 12.15 12.45 15.29z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M656.74 654.35c.18.09.35.19.53.27.44.2.91.4 1.38.61l-1.97-1.81c0 .03.03.36.06.93zm22.28 10.2c.15.07.24.11.25.11l.84-1.81c-.04-.02-1.3-.6-3.25-1.5.72 1.06 1.44 2.12 2.15 3.19.01 0 .01 0 .01.01zm-16.15-7.96c.01.03.06.24.16.62.77.35 1.54.7 2.32 1.06-.34-1.34-.52-2.1-.54-2.16l-1.94.48zm2.48 1.68h.01zm20.52 343.66c5.85-11.69 5.53-22.24 3.9-37.58v-.01c-1.95-2.92-2.58-5.68-2.63-5.9l1.76-.37v-.01c-2.56-13.81-12.17-51.95-21.49-88.97-7.78-30.89-15.13-60.07-16.67-68.53-2.44-13.42-2.76-37.77-2.72-51.14-.01-3.73.01-6.96.03-9.41l-1.18-.02c-.27.73-.54 1.45-.8 2.19v.01c-.11 8.87-.33 42.06 2.7 58.73 1.55 8.52 8.91 37.73 16.7 68.66 9.87 39.17 21.05 83.55 22.03 92.39 1.82 16.4 2.5 27.22-3.42 39.06-4.6 9.2-15.86 13.31-20.61 14.67.02.71.03 1.41.04 2.08 4.7-1.26 17.18-5.49 22.36-15.85z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M650.74 800.56c-2.24-12.3-2.69-35.87-2.72-51.14-.03 13.37.28 37.72 2.72 51.14zm-2.66-63.83c-.41 1.08-.82 2.15-1.21 3.25l1.18.02c.01-1.33.02-2.44.03-3.27z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m648.11 735.01-1.24 4.98c.4-1.1.81-2.18 1.21-3.25.02-1.08.03-1.69.03-1.73zm-2 4.96c0 .05-.02.84-.04 2.2v.01c.26-.74.53-1.46.8-2.19l-.76-.02zm82.24 275.52c-1.54.64-3.17.39-4.98-.77-6.72-4.27-8.8-28-5.71-65.1 1.52-18.21-3.28-101.33-4.62-123.56-.75-1.7-1.52-3.44-2.32-5.2.29 4.62 6.66 108.13 4.95 128.59-.29 3.45-.57 7.3-.81 11.35v.01c.14-.17.22-.28.22-.29l1.61 1.19c-.1.13-.82 1.08-2 2.33-1.05 21.46-.5 47.21 7.6 52.36 1.49.95 2.96 1.43 4.37 1.43.84 0 1.65-.17 2.45-.5 1.51-.62 2.8-1.79 3.88-3.19.26-1.74.49-3.45.7-5.1-1.28 2.78-3.08 5.53-5.34 6.45z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M713.04 826.06c-.2-3.37-.32-5.34-.33-5.48l-2 .13c0 .02 0 .06.01.13v.02c.8 1.76 1.57 3.5 2.32 5.2zm-13.89 142.77c-8.1-2.12-10.04-10.72-10.05-10.81l-.2.04c.29 1.55.49 2.79.59 3.68.1.88.19 1.74.28 2.59 1.73 2.58 4.5 5.28 8.88 6.43.94.25 1.86.36 2.77.36 5.65 0 10.63-4.29 13.28-7.08.06-1.1.11-2.17.17-3.24-1.34 1.67-8.41 9.94-15.72 8.03z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m688.9 958.06-1.76.37c.05.21.67 2.98 2.63 5.9-.09-.85-.18-1.71-.28-2.59-.1-.89-.3-2.13-.59-3.68zm27.79 3.65-1.61-1.19c-.01.01-.08.11-.22.29-.06 1.07-.11 2.14-.17 3.24 1.18-1.25 1.9-2.21 2-2.34z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-thigh is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Thigh");
	              },
	              className: "labelArea",
	              x: "277",
	              y: "869",
	              width: "110",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 6.257)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M772.407 191.303H1331.1",
	                transform: "matrix(-.45018 0 0 -.7655 1004.24 1030.38)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Thigh" ? "#f58220" : "#af9763"
	                },
	                d: "M292.842 893.037v-21.42h-7.668v-4.356h20.484v4.356h-7.632v21.42h-5.184ZM313.896 867.261v9.468c1.62-1.836 3.528-2.772 5.724-2.772 1.152 0 2.16.216 3.096.612.9.432 1.584.972 2.052 1.62.468.648.792 1.404.936 2.196.18.792.252 2.016.252 3.708v10.944h-4.932v-9.864c0-1.944-.072-3.204-.288-3.708-.18-.54-.504-.972-.972-1.26-.468-.324-1.08-.468-1.8-.468-.792 0-1.548.18-2.196.576-.648.396-1.116 1.008-1.404 1.8-.288.828-.468 2.016-.468 3.564v9.36h-4.932v-25.776h4.932ZM330.99 871.833v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM340.522 894.261l5.652.684c.072.648.288 1.116.648 1.368.468.36 1.188.504 2.196.504 1.296 0 2.268-.18 2.916-.576.432-.252.756-.648.972-1.224.18-.432.252-1.188.252-2.268v-2.736c-1.476 2.016-3.348 3.024-5.616 3.024-2.484 0-4.464-1.044-5.94-3.168-1.152-1.692-1.728-3.78-1.728-6.264 0-3.132.756-5.544 2.268-7.164 1.512-1.656 3.384-2.484 5.616-2.484 2.304 0 4.212 1.008 5.688 3.024v-2.628h4.644v16.776c0 2.196-.18 3.852-.54 4.932-.36 1.08-.9 1.944-1.548 2.556-.648.648-1.512 1.116-2.628 1.476-1.08.36-2.484.504-4.14.504-3.168 0-5.4-.54-6.732-1.62-1.332-1.08-1.98-2.448-1.98-4.104v-.612Zm4.428-10.944c0 1.98.36 3.42 1.152 4.356.756.9 1.692 1.368 2.808 1.368 1.224 0 2.232-.468 3.06-1.404.864-.936 1.26-2.34 1.26-4.212 0-1.908-.396-3.348-1.188-4.284-.792-.936-1.8-1.404-3.024-1.404-1.188 0-2.16.432-2.916 1.368-.792.936-1.152 2.34-1.152 4.212ZM367.876 867.261v9.468c1.62-1.836 3.528-2.772 5.724-2.772 1.152 0 2.16.216 3.096.612.9.432 1.584.972 2.052 1.62.468.648.792 1.404.936 2.196.18.792.252 2.016.252 3.708v10.944h-4.932v-9.864c0-1.944-.072-3.204-.288-3.708-.18-.54-.504-.972-.972-1.26-.468-.324-1.08-.468-1.8-.468-.792 0-1.548.18-2.196.576-.648.396-1.116 1.008-1.404 1.8-.288.828-.468 2.016-.468 3.564v9.36h-4.932v-25.776h4.932Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "Left_Thigh" },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "M842.55 678.87c.04-12.16.76-22.26.77-22.45l-.17-.01c-.23 4.34-.61 12.94-.6 22.46zm9.42 70.95c.01-3.99-.01-7.39-.04-9.81h-.05c0 .12.08 3.97.09 9.81z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M789.27 820.89c-.3 5.01-6.65 108.14-4.94 128.56.29 3.46.57 7.3.81 11.36 1.34 1.66 8.42 9.94 15.71 8.02 8.13-2.13 10.04-10.72 10.05-10.81l.19.04c2.56-13.8 12.17-51.94 21.49-88.96 7.79-30.9 15.14-60.09 16.68-68.55 2.25-12.39 2.69-35.78 2.71-50.74-.01-5.83-.09-9.69-.09-9.81h.05c-.02-1.52-.03-2.66-.04-3.32-.6-1.58-1.2-3.16-1.8-4.72-2.72-7.04-5.29-13.69-6.98-20.8-2.06-8.65-2.61-20.94-2.59-31.7-1.78 13.16-4.24 28.95-6.92 38.77-.73 2.68-1.46 5.45-2.21 8.3-4.73 18.01-10.1 38.43-20.82 54.5-6.61 9.92-14.79 25.53-21.3 39.83v.03zm8.05-57.42c2.75-5.74 5.71-11.93 8.88-18.62 13.11-27.78 25.7-75.83 28.43-86.57-6.16 2.81-12.39 5.69-13.66 6.28-2.99 4.45-6.05 8.92-8.92 13.12-6.06 8.87-11.29 16.53-13.78 20.58-1.24 2.03-2.9 5.94-4.95 11.71 0 .01-.01.02-.02.04-4.85 13.71-11.95 37.88-21.19 72.24-.44 1.65-.79 2.95-1.02 3.8-2.49 9.1-6.39 26.97-6.8 28.79v.03c1.22 10.21 2.75 23.12 3.42 33.86 2.48-11.38 5.96-26.79 8.49-35.92 3.5-12.59 10.89-28.01 21.12-49.34z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M771.65 1015.49c1.54.64 3.17.39 4.98-.77 6.72-4.27 8.79-28 5.7-65.1-1.51-18.2 3.29-101.31 4.63-123.56-4.68 10.72-8.11 20.13-8.8 25.01-1.58 11.03-9.4 40.33-11.23 47.07-.81 38.05-1.65 91.83-1.65 98.5 0 2.92.4 7.37 1.03 12.4v.01c1.22 2.68 3 5.48 5.34 6.44zm-1.47-233.77c3.18-11.83 10.57-39.3 17.15-60.08-5.47 10.66-12.93 25.24-14.55 28.48-2.11 4.22-8.26 11.22-10.95 14.19.51.44.81.99.81 1.65 0 4.41-.88 23.77 0 34.34.17 2.04.5 4.99.93 8.56 1.45-6.49 3.86-17.02 5.59-23.35.23-.85.58-2.14 1.02-3.79zm52.96-120.38c4.65-2.14 13.25-6.09 18.77-8.55 7.47-3.32 12.63-16.06 12.68-16.19l.6.24c-.38-1.56-.72-2.85-1-3.84-1.73-6.06-6.02-15.51-10.04-24.52-.13 7.2-.95 18.68-4.45 26.27-2.29 5-9.08 15.47-16.56 26.59zm37.55 109.57c-1.15-11.1-3.77-20.27-6.77-28.74.12 8.84.34 42.07-2.69 58.75-1.55 8.52-8.91 37.74-16.71 68.68-9.86 39.16-21.04 83.54-22.02 92.37-1.82 16.4-2.5 27.21 3.42 39.06 4.6 9.21 15.88 13.31 20.61 14.67.45-17.19 3.86-42.66 5.35-51.64 1.36-8.13 11.07-62.22 16.67-93.09.96-16.18 4.41-78.15 2.14-100.06z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "m843.26 654.35-.12 2.06.17.01c-.02.19-.74 10.29-.77 22.45.01 11.19.55 23.63 2.5 31.83 1.66 6.99 4.21 13.57 6.9 20.55 4.47 11.56 9.08 23.52 10.73 39.45 1.79 17.3.05 59.26-1.24 84.37l.68-3.71c2.65-14.09 12.34-62.5 13.22-75.72.88-13.2-.88-39.61-3.53-54.58-2.34-13.24-11.56-62.34-16.1-82.01-1.69 3.66-6.18 12.15-12.44 15.3zm-34.35 125.59c10.53-15.8 15.85-36.05 20.55-53.91.75-2.85 1.48-5.63 2.21-8.31 4.75-17.42 8.84-55.63 9.54-62.42-1.32.59-2.76 1.24-4.24 1.91-1.57 6.29-14.96 58.83-28.96 88.49-3.17 6.7-6.14 12.89-8.89 18.64-10.18 21.24-17.54 36.58-20.99 48.99-3.15 11.37-7.79 32.56-10.11 43.43v.01c.02 1.88 0 3.61-.09 5.16-.23 4.1-.51 14.45-.81 27.7 3.03-11.52 7.88-30.62 9.06-38.85 1.73-12.15 20.09-51.88 32.73-70.84z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M772.11 782.24c9.24-34.36 16.34-58.53 21.19-72.24-.26.51-2.77 5.4-5.97 11.63v.01c-6.58 20.78-13.97 48.25-17.15 60.08-.44 1.65-.79 2.94-1.02 3.79-1.73 6.33-4.14 16.86-5.59 23.35v.01c.22 1.84.46 3.84.72 5.96.41-1.82 4.31-19.69 6.8-28.79.23-.85.58-2.15 1.02-3.8zm65.78-148.32c-3.37 7.3-16.75 26.88-27.49 42.62-6.07 8.9-11.32 16.57-13.84 20.67-1.37 2.21-3.1 6.41-5.02 11.83l1.78.92c2.05-5.77 3.71-9.68 4.95-11.71 2.49-4.05 7.72-11.71 13.78-20.58 2.87-4.2 5.93-8.67 8.92-13.12-.14.07-.23.11-.24.11l-.84-1.81c.04-.02 1.3-.6 3.25-1.5v-.01c7.48-11.12 14.27-21.59 16.57-26.58 3.5-7.59 4.32-19.07 4.45-26.27v-.02c-.68-1.52-1.35-3-2-4.47.09 5.53-.11 20.89-4.27 29.92z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M787.33 721.64v-.01c0-.01.01-.01.01-.02 1.44-4.57 2.85-8.81 4.16-12.5-.87 1.71-17.95 35-20.51 40.12-2.07 4.13-8.56 11.44-10.98 14.1.73.26 1.36.58 1.82.98 2.69-2.97 8.84-9.97 10.95-14.19 1.62-3.24 9.08-17.82 14.55-28.48z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M787.33 721.63c3.2-6.23 5.71-11.12 5.97-11.63.01-.02.02-.03.02-.04l-1.78-.92c0 .01-.02.03-.04.07-1.31 3.69-2.72 7.93-4.16 12.5 0 .01-.01.01-.01.02zm11.79 42.71c2.75-5.75 5.72-11.94 8.89-18.64 14-29.66 27.39-82.2 28.96-88.49-.77.35-1.56.71-2.34 1.07-2.73 10.74-15.32 58.8-28.43 86.57-3.17 6.69-6.13 12.88-8.88 18.62-10.23 21.33-17.62 36.75-21.12 49.33-2.53 9.13-6.01 24.54-8.49 35.92v.01c.17 2.86.28 5.57.31 8.03 2.32-10.87 6.96-32.06 10.11-43.43 3.45-12.41 10.81-27.75 20.99-48.99zm63.56 6.36c-1.65-15.93-6.26-27.89-10.73-39.45-2.69-6.98-5.24-13.56-6.9-20.55-2.03-8.54-2.54-21-2.5-31.83-.01-9.51.37-18.12.6-22.46l-1.83-.16c-.04.42-4.45 42.4-9.65 61.47-.73 2.68-1.46 5.46-2.21 8.31-4.7 17.86-10.02 38.11-20.55 53.91-12.64 18.96-31 58.69-32.73 70.84-1.18 8.23-6.03 27.33-9.06 38.85-.07 2.72-.13 5.57-.19 8.51 1.83-6.74 9.65-36.04 11.23-47.07.69-4.88 4.12-14.29 8.8-25.01v-.02c.2-3.35.32-5.32.33-5.46l1.99.13c0 .02 0 .07-.01.16 6.51-14.3 14.69-29.91 21.3-39.83 10.72-16.07 16.09-36.49 20.82-54.5.75-2.85 1.48-5.62 2.21-8.3 2.68-9.82 5.14-25.61 6.92-38.77-.02 10.76.53 23.05 2.59 31.7 1.69 7.11 4.26 13.76 6.98 20.8.6 1.56 1.2 3.13 1.8 4.72-.01-.41-.01-.65-.01-.68l1.25 3.98.75-.02c0 .05.02.83.03 2.19l.01.01c3 8.47 5.62 17.64 6.77 28.74 2.27 21.91-1.18 83.88-2.14 100.06 1.19-6.58 2.19-12.1 2.89-15.9 1.29-25.11 3.03-67.07 1.24-84.37z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m841.32 656.25 1.83.16.12-2.06c-.18.09-.35.19-.54.27-.48.21-.99.44-1.51.67-.7 6.79-4.79 45-9.54 62.42 5.19-19.06 9.6-61.04 9.64-61.46zm3.73 54.45c-1.95-8.2-2.49-20.64-2.5-31.83-.04 10.83.47 23.29 2.5 31.83zm10.66-71.66c.44-.95.7-1.58.74-1.69l-1.25-.5c.16.68.33 1.41.51 2.19z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M841.91 652.79c-5.52 2.46-14.12 6.41-18.77 8.55-.71 1.06-1.43 2.12-2.16 3.19l-.01.01c1.27-.59 7.51-3.47 13.66-6.28v-.01c.35-1.34.53-2.1.55-2.16l1.95.48c-.01.03-.06.24-.16.62 1.49-.67 2.92-1.32 4.24-1.91.07-.64.1-1.01.11-1.05l2-.83c0 .03-.02.37-.06.93 6.26-3.14 10.75-11.64 12.45-15.3v-.01c-.18-.78-.35-1.51-.51-2.19l-.6-.24c-.05.14-5.22 12.88-12.69 16.2z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M843.26 654.35c.03-.56.06-.9.06-.93l-2 .83c0 .04-.04.4-.11 1.05.52-.23 1.03-.46 1.51-.67.19-.09.36-.19.54-.28zm-22.28 10.19c.73-1.07 1.45-2.13 2.16-3.19-1.95.9-3.21 1.48-3.25 1.5l.84 1.81c.01 0 .1-.04.24-.11l.01-.01zm15.99-7.33c.1-.38.15-.59.16-.62l-1.95-.48c-.02.06-.2.82-.55 2.16v.01c.79-.37 1.57-.72 2.34-1.07zm-21.05 343.82c-5.92-11.85-5.24-22.66-3.42-39.06.98-8.83 12.16-53.21 22.02-92.37 7.8-30.94 15.16-60.16 16.71-68.68 3.03-16.68 2.81-49.91 2.69-58.75l-.01-.01c-.26-.73-.52-1.45-.78-2.17l-1.2.02c.02 2.42.05 5.82.04 9.81.03 13.45-.3 37.45-2.71 50.74-1.54 8.46-8.89 37.65-16.68 68.55-9.32 37.02-18.93 75.15-21.49 88.96l1.77.37c-.05.21-.67 2.98-2.62 5.89v.02c-1.63 15.34-1.95 25.89 3.9 37.58 5.18 10.37 17.67 14.59 22.36 15.85.01-.67.02-1.37.04-2.08-4.74-1.36-16.02-5.46-20.62-14.67zm37.21-261.04c-.41-1.11-.82-2.21-1.24-3.3.01.67.03 1.8.04 3.32l1.2-.02z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M851.97 749.82c-.03 14.96-.46 38.35-2.71 50.74 2.41-13.29 2.74-37.29 2.71-50.74zm-.09-13.81c0 .03.01.26.01.68.41 1.09.83 2.19 1.24 3.3l-1.25-3.98zm2 3.96-.75.02c.26.72.52 1.44.78 2.17-.01-1.36-.03-2.14-.03-2.19zm-82.99 277.37c.79.33 1.61.5 2.44.5 1.42 0 2.88-.48 4.37-1.43 8.11-5.15 8.66-30.9 7.61-52.35v-.01c-1.18-1.25-1.9-2.2-2-2.33l1.61-1.19c.01.01.08.11.22.29-.24-4.06-.52-7.9-.81-11.36-1.71-20.42 4.64-123.55 4.94-128.56v-.01c-.8 1.75-1.57 3.47-2.31 5.16v.02c-1.34 22.25-6.14 105.36-4.63 123.56 3.09 37.1 1.02 60.83-5.7 65.1-1.81 1.16-3.44 1.41-4.98.77-2.34-.96-4.12-3.76-5.34-6.44.21 1.65.44 3.36.7 5.1 1.08 1.39 2.37 2.56 3.88 3.18z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M789.27 820.87c.01-.09.01-.14.01-.16l-1.99-.13c-.01.14-.13 2.11-.33 5.46.74-1.69 1.51-3.41 2.31-5.16v-.01zm11.58 147.96c-7.29 1.91-14.37-6.36-15.71-8.02v.01c.06 1.06.12 2.13.17 3.23 2.65 2.79 7.62 7.08 13.28 7.08.91 0 1.83-.11 2.77-.36 4.38-1.15 7.15-3.85 8.88-6.44.09-.84.18-1.71.28-2.58.1-.9.3-2.14.58-3.68l-.19-.04c-.03.08-1.93 8.67-10.06 10.8z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M810.51 961.75c-.1.87-.19 1.74-.28 2.58 1.95-2.91 2.58-5.68 2.62-5.89l-1.77-.37c-.27 1.54-.47 2.78-.57 3.68zm-25.37-.94c-.14-.17-.22-.28-.22-.29l-1.61 1.19c.1.13.82 1.08 2 2.33-.05-1.09-.11-2.17-.17-3.23z"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "Right_Knee" },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M712.54 1165.08c1.05 53.98 3.37 118.22 5.05 122.15.57 1.34 1.21 2.1 1.8 2.13h.05c.71 0 1.57-.88 2.12-1.62-1.45-5.65-2.29-11.56-1.81-16.4.51-5.14 4.62-50.7 7.6-91.45-7.08-3.27-12.19-10.42-14.81-14.81zm-.08-4.34v.01c.75 1.51 6.34 12.5 15.05 16.97 2.05-28.28 3.52-53.83 2.8-61.34-1.46-15.36-4.13-50.77-3.48-67.37-3.65 6.05-13.06 23.62-14.45 45.86-.61 9.86-.48 35.96.08 65.87zm-36.36 9.22c-10.09-30.25-15.23-89.5-17.08-115.56-1.98 11.49-3.98 23.21-4.42 32.05-.89 17.6.88 52.82 7.04 79.23 6.16 26.42 14.97 74.84 18.48 99.49 2.3 16.08 1.23 26.17.7 33.93 5.46-3.7 13.09-6.81 18.3-8.72.84-10.44-10.32-82.32-23.02-120.42z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M701.16 1289.67c1.36-.48 2.43-.82 3.08-1.03.19-6.93 1.62-62.01-.01-77.51-1.8-17.1-19.4-123.34-24.63-144.25-4.04-16.17-13.95-24.92-17.99-27.91-.35 2.29-.74 4.66-1.15 7.08 0 .02.01.04 0 .07 1.19 18.73 6.25 89.36 17.54 123.21 12.75 38.26 23.45 106.93 23.16 120.34z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M729.11 1017.34c-.8.33-1.61.5-2.45.5-1.41 0-2.88-.48-4.37-1.43-8.1-5.15-8.65-30.9-7.6-52.36-2.64 2.79-7.63 7.08-13.28 7.08-.91 0-1.83-.11-2.77-.36-4.37-1.15-7.14-3.85-8.88-6.43v.01c1.63 15.34 1.95 25.89-3.9 37.58-5.18 10.36-17.66 14.59-22.36 15.85.03 2.25 0 4.32-.1 6.16-.2 3.66-.74 8.03-1.46 12.8 3.61 2.45 15.04 11.45 19.59 29.65 5.24 20.96 22.87 127.4 24.68 144.53 1.56 14.92.33 65.94.05 76.55 2.58-.72 6.74-.59 9.23-.42-2.71-14.69-6.81-165.12-5.11-192.31 1.75-28.12 16.1-48.95 16.25-49.15l.37.26c.16-1.86.37-3.33.67-4.31 1.58-5.27 3.79-16.86 5.31-27.39-1.07 1.4-2.36 2.57-3.87 3.19z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M679.6 1066.88c5.23 20.91 22.83 127.15 24.63 144.25 1.63 15.5.2 70.58.01 77.51.36-.53 1.09-.91 2.03-1.17.28-10.6 1.51-61.62-.05-76.55-1.81-17.13-19.44-123.57-24.68-144.53-4.55-18.2-15.98-27.2-19.59-29.65-.1.73-.21 1.47-.34 2.23 4.04 2.99 13.95 11.74 17.99 27.91zm19.52 223.5c.73-.26 1.42-.5 2.04-.71.29-13.41-10.41-82.08-23.16-120.34-11.29-33.85-16.35-104.48-17.54-123.21-.46 2.71-.95 5.48-1.44 8.26v.02c1.85 26.06 6.99 85.31 17.08 115.56 12.7 38.1 23.86 109.98 23.02 120.42zm11.27-195.64c-1.7 27.19 2.4 177.62 5.11 192.31 1.25.09 2.09.18 2.09.18-1.68-3.93-4-68.17-5.05-122.15v-.01c-1.21-2.02-1.88-3.46-1.97-3.66l1.81-.84c0 .01.03.07.08.17-.56-29.91-.69-56.01-.08-65.87 1.39-22.24 10.8-39.81 14.45-45.86.05-1.15.11-2.2.18-3.16l-.37-.26c-.15.2-14.5 21.03-16.25 49.15z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M712.46 1160.75c.02 1.43.05 2.87.08 4.32v.01c2.62 4.39 7.73 11.54 14.81 14.81.05-.72.11-1.44.16-2.16v-.01c-8.71-4.47-14.3-15.46-15.05-16.97z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M712.46 1160.74c-.05-.1-.08-.16-.08-.17l-1.81.84c.09.2.76 1.64 1.97 3.66-.03-1.45-.06-2.89-.08-4.32v-.01z"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: "bodyParts_wrapper Left_Knee",
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Knee");
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2.handleHoverBodyPart("Knee");
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              return _this2.handleHoverBodyPart(null);
	            }
	          },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Knee" || this.state.bodyHoverTitles === "Knee" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M780.6 1289.36c.26-.22.57-.41.92-.58.31-.36.61-.88.89-1.55 1.68-3.93 4-68.18 5.06-122.17-2.62 4.39-7.73 11.54-14.82 14.82v.01c2.98 40.75 7.09 86.31 7.6 91.45.48 4.84-.36 10.75-1.81 16.4.58.76 1.47 1.67 2.16 1.62zm6.94-128.64v-.01c.55-29.9.69-55.98.07-65.84-1.39-22.22-10.78-39.77-14.44-45.84.65 16.61-2.03 51.99-3.49 67.35-.71 7.51.76 33.07 2.81 61.35 8.77-4.5 14.38-15.61 15.05-17.01zm32.86-93.84c-5.23 20.91-22.83 127.14-24.63 144.25-1.63 15.5-.2 70.58-.02 77.51.66.21 1.73.56 3.09 1.03-.29-13.41 10.41-82.08 23.16-120.34 11.3-33.91 16.37-104.71 17.54-123.3-.01-.01-.01-.01 0-.02-.01-.01-.01-.02 0-.03v-.01c-.41-2.4-.8-4.72-1.15-7-4.04 2.99-13.95 11.74-17.99 27.91z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Knee" || this.state.bodyHoverTitles === "Knee" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M800.88 1290.39c5.21 1.9 12.84 5.01 18.3 8.71-.54-7.76-1.61-17.85.69-33.93 3.52-24.65 12.32-73.07 18.49-99.49 6.16-26.41 7.93-61.63 7.03-79.23-.44-8.83-2.43-20.54-4.42-32.02-1.85 26.07-6.99 85.29-17.07 115.53-12.71 38.12-23.87 110.03-23.02 120.43zm13.25-288.46c-5.85-11.69-5.53-22.24-3.9-37.58v-.02c-1.73 2.59-4.5 5.29-8.88 6.44-.94.25-1.86.36-2.77.36-5.65 0-10.63-4.28-13.28-7.08v.01c1.05 21.45.5 47.2-7.61 52.35-1.49.95-2.95 1.43-4.37 1.43-.83 0-1.65-.17-2.44-.5-1.51-.62-2.8-1.79-3.88-3.19 1.52 10.53 3.73 22.12 5.31 27.39.3.98.51 2.45.67 4.31l.37-.26c.15.2 14.49 21.03 16.25 49.15 1.75 28.02-2.66 186.97-5.36 193.28v.01c3.14-.45 7.13-.04 9.49.29-.22-8.33-1.58-62.02.04-77.4 1.8-17.14 19.44-123.57 24.68-144.53 4.55-18.2 15.98-27.2 19.59-29.65-.72-4.77-1.26-9.14-1.46-12.8-.1-1.84-.13-3.91-.1-6.16-4.68-1.26-17.17-5.48-22.35-15.85z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M818.46 1066.39c-5.24 20.96-22.88 127.39-24.68 144.53-1.62 15.38-.26 69.07-.04 77.4 1.22.17 2.01.32 2.01.32-.18-6.93-1.61-62.01.02-77.51 1.8-17.11 19.4-123.34 24.63-144.25 4.04-16.17 13.95-24.92 17.99-27.91-.13-.76-.24-1.5-.34-2.23-3.61 2.45-15.04 11.45-19.59 29.65zm-19.62 223.28c.62.21 1.31.46 2.04.72-.85-10.4 10.31-82.31 23.02-120.43 10.08-30.24 15.22-89.46 17.07-115.53 0-.02.01-.03 0-.05-.48-2.81-.97-5.61-1.43-8.35-1.17 18.59-6.24 89.39-17.54 123.3-12.75 38.26-23.45 106.93-23.16 120.34zm-11.3-128.96c.04-.08.07-.13.07-.14l1.82.84c-.09.2-.76 1.63-1.96 3.65-1.06 53.99-3.38 118.24-5.06 122.17-.28.67-.59 1.19-.89 1.55.76-.37 1.7-.61 2.73-.76v-.01c2.7-6.31 7.11-165.26 5.36-193.28-1.76-28.12-16.1-48.95-16.25-49.15l-.37.26c.08.96.14 2.02.18 3.18 3.66 6.07 13.05 23.62 14.44 45.84.62 9.87.48 35.95-.07 65.85z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M787.47 1165.06c.02-1.46.05-2.9.07-4.34-.67 1.4-6.28 12.51-15.05 17.01.05.72.1 1.42.16 2.15 7.09-3.28 12.2-10.43 14.82-14.82z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M787.61 1160.57c0 .01-.03.06-.07.14v.01c-.02 1.44-.05 2.88-.07 4.34 1.2-2.02 1.87-3.45 1.96-3.65l-1.82-.84z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-knee",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Knee");
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "1029",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 -96.754)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.53204 0 0 .7655 386.016 999.919)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Knee" ? "#f58220" : "#af9763"
	                },
	                d: "M1120.013 1159.253v-25.776h5.184v11.448l10.512-11.448h7.02l-9.72 10.044 10.224 15.732h-6.732l-7.092-12.096-4.213 4.32v7.776h-5.183ZM1162.85 1159.253h-4.931v-9.54c0-2.016-.109-3.312-.325-3.888a2.551 2.551 0 0 0-1.007-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.685.468-1.117 1.116-1.369 1.872-.251.756-.395 2.196-.395 4.284v8.46h-4.932v-18.684h4.572v2.772c1.62-2.124 3.671-3.168 6.156-3.168 1.08 0 2.088.18 2.987.576.9.396 1.584.9 2.053 1.512.467.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592ZM1178.685 1153.313l4.932.828c-.649 1.8-1.657 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.225-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.375 4.644 2.303 8.424h-12.383c.036 1.476.432 2.628 1.224 3.42.755.828 1.691 1.224 2.843 1.224.757 0 1.405-.216 1.945-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1198.715 1153.313l4.932.828c-.649 1.8-1.657 3.168-2.988 4.104-1.369.972-3.097 1.44-5.149 1.44-3.24 0-5.651-1.08-7.2-3.204-1.224-1.692-1.835-3.816-1.835-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.375 4.644 2.303 8.424h-12.383c.035 1.476.431 2.628 1.223 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.937-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: "bodyParts_wrapper Right_Ankle",
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Foot");
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2.handleHoverBodyPart("Foot");
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              return _this2.handleHoverBodyPart(null);
	            }
	          },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Foot" || this.state.bodyHoverTitles === "Foot" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M719.28 1291.36c-.67-.04-1.28-.31-1.84-.81-4.45-1.63-9.12-.95-12.05-.18-.34.11-1.42.45-2.97.98-5.17 1.78-15.63 5.7-21.76 10.29v.01c-.15 3.05-.12 5.76.36 8.41 1.75 9.69 4.39 9.69.87 18.49-3.52 8.8-23.77 31.7-21.13 37.87 2.65 6.15 23.77 3.51 35.22 4.39 11.45.88 17.6 5.29 22.01-3.51 4.4-8.81 3.52-6.17 6.16-11.46 2.65-5.27.89-30.81 0-36.09-.88-5.28 5.28-11.45 1.77-19.37-1.32-2.97-2.64-6.55-3.73-10.33-.73.69-1.68 1.3-2.75 1.3h-.16z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M704.24 1288.64c-.65.21-1.72.55-3.08 1.03-.01.47-.03.87-.07 1.2l-1.99-.22c.01-.08.02-.17.02-.27-5.21 1.91-12.84 5.02-18.3 8.72-.06.88-.12 1.73-.16 2.55 6.13-4.59 16.58-8.51 21.76-10.29l1.82-2.72z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M705.39 1290.37c-1.8.47-2.94.97-2.97.98 1.55-.53 2.63-.87 2.97-.98zm-6.29.28 1.99.22c.04-.33.06-.73.07-1.2-.62.21-1.31.45-2.04.71 0 .1-.01.19-.02.27zm20.34-1.29h-.05c-.59-.03-1.23-.79-1.8-2.13l1.69 4.13h.16c1.07 0 2.02-.61 2.75-1.3-.22-.77-.43-1.54-.63-2.32-.55.74-1.41 1.62-2.12 1.62zm-.16 2c-.61-.32-1.22-.58-1.84-.81.56.49 1.17.77 1.84.81zm-13.08-1.23-.69.21c-.01 0-.06.02-.12.04 2.93-.77 7.6-1.45 12.05.18-.64-.56-1.2-1.4-1.69-2.53-.08-.19-.16-.52-.25-.97-2.5-.17-6.66-.3-9.23.42-.03 1.19-.05 1.88-.05 1.94l-.02.71z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m704.24 1288.64-1.82 2.72c.02-.01 1.17-.51 2.97-.98.07-.02.11-.04.12-.04l.69-.21.02-.72c0-.06.02-.75.05-1.94-.94.26-1.67.63-2.03 1.17zm-1.82 2.72v-.01.01zm15.02-.81c.62.23 1.24.48 1.84.81l-1.69-4.13s-.83-.09-2.09-.18c.08.45.17.78.25.97.49 1.13 1.05 1.97 1.69 2.53z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-foot is_right",
	              transform: "translate(0 -15)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Foot");
	              },
	              className: "labelArea",
	              x: "297",
	              y: "1330",
	              width: "90",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              null,
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M742.407 191.303H1331.1",
	                transform: "matrix(-.47065 0 0 -.7655 1031.48 1496.8)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Foot" ? "#f58220" : "#af9763"
	                },
	                d: "M305.097 1363.031v-25.776h17.64v4.356h-12.456v6.12h10.764v4.356h-10.764v10.944h-5.184ZM325.863 1353.419c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM347.853 1353.419c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM379.563 1344.347v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: "bodyParts_wrapper Left_Ankle",
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Ankle");
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2.handleHoverBodyPart("Ankle");
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              return _this2.handleHoverBodyPart(null);
	            }
	          },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Ankle" || this.state.bodyHoverTitles === "Ankle" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M781.93 1291c-.38.21-.78.34-1.21.36h-.16c-1.07 0-2.02-.61-2.75-1.3-1.09 3.78-2.41 7.36-3.73 10.33-3.52 7.92 2.65 14.09 1.77 19.37-.89 5.28-2.65 30.82 0 36.09 2.64 5.29 1.76 2.65 6.16 11.46 4.4 8.8 10.56 4.39 22.01 3.51 11.44-.88 32.57 1.76 35.22-4.39 2.64-6.17-17.61-29.07-21.14-37.87-3.51-8.8-.88-8.8.88-18.49.48-2.65.51-5.37.35-8.42-6.77-5.07-18.83-9.33-23.2-10.78-5.32-1.92-11.62-.58-14.2.13z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m800.9 1290.65-1.99.22c-.04-.33-.06-.73-.07-1.2-1.36-.47-2.43-.82-3.09-1.03l.38 2.23c4.38 1.45 16.43 5.72 23.2 10.78-.03-.82-.09-1.67-.15-2.55-5.46-3.7-13.09-6.81-18.3-8.71 0 .09.01.18.02.26z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M800.9 1290.65c-.01-.08-.02-.17-.02-.26-.73-.26-1.42-.51-2.04-.72.01.47.03.87.07 1.2l1.99-.22zm-18.97.35c-.75.21-1.21.36-1.21.36.43-.03.83-.16 1.21-.36z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m780.72 1291.36-.12-2c-.69.05-1.58-.86-2.16-1.62-.2.78-.41 1.55-.63 2.32.73.69 1.68 1.3 2.75 1.3h.16zm1.21-.36c2.58-.71 8.88-2.05 14.2-.13-1.01-.33-1.61-.52-1.65-.53l-.68-.21-.03-.72c0-.05-.01-.43-.03-1.09-2.36-.33-6.36-.74-9.49-.29-.65 1.49-1.42 2.47-2.32 2.97zm-.41-2.22c-.34.17-.65.36-.92.58.3-.02.61-.22.92-.58z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m793.8 1290.13.68.21c.04.01.64.2 1.65.53l-.38-2.23s-.79-.15-2.01-.32c.02.66.03 1.05.03 1.09l.03.72zm-13.2-.77.12 2s.45-.15 1.21-.36c.9-.49 1.67-1.48 2.32-2.97-1.03.15-1.97.39-2.73.76-.31.35-.62.55-.92.57z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-ankle" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Ankle");
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "1282",
	              width: "110",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 -47.998)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M772.407 191.303H1331.1",
	                transform: "matrix(.49111 0 0 .7655 440.492 1203.7)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Ankle" ? "#f58220" : "#af9763"
	                },
	                d: "M1145.85 1363.031h-5.652l-2.232-5.868h-10.332l-2.124 5.868h-5.508l10.044-25.776h5.508l10.296 25.776Zm-9.576-10.188-3.528-9.576-3.492 9.576h7.02ZM1165.54 1363.031h-4.932v-9.54c0-2.016-.108-3.312-.324-3.888a2.551 2.551 0 0 0-1.008-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.684.468-1.116 1.116-1.368 1.872s-.396 2.196-.396 4.284v8.46h-4.932v-18.684h4.572v2.772c1.62-2.124 3.672-3.168 6.156-3.168 1.08 0 2.088.18 2.988.576.9.396 1.584.9 2.052 1.512.468.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592ZM1170.394 1363.031v-25.776h4.932v13.68l5.796-6.588h6.084l-6.408 6.84 6.84 11.844h-5.328l-4.68-8.388-2.304 2.412v5.976h-4.932ZM1190.604 1337.255h4.932v25.776h-4.932zM1211.404 1357.091l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Chest" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Heart,Breast");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Heart,Breast");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.Heart.includes(this.state.bodyTitles) || female_human_body.Heart.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M749.04 393.88c-.4-7.69-1.22-14.33-2.5-18.07-4.38-12.76-8.23-21.56-21.45-27.21-12.44-5.31-38.88-7.38-53.7 1.34-11.11 6.53-14.57 13.34-15.26 14.94.81 1.7 3.97 8.6 6.88 18.42 1.53 5.17-.81 16.02-3.07 26.51-1.39 6.42-2.69 12.5-3.03 16.82-1.43 18.63 15.9 23.59 48.39 26.22 19.18 1.56 32.52-1.88 39.66-10.22 2.08-2.42 3.48-12.46 4.06-24.22-.4-8.06-.39-16.83.02-24.53z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M656.9 435.56c-.01.03-.14.71-.28 1.86v.03c5.35 11.43 22.53 15.29 48.52 17.4 2.43.19 4.76.31 7.01.34 1.99-1.09 3.2-1.79 3.27-1.83l1.02 1.72c-.04.02-.1.06-.17.1 8.08-.23 14.86-1.58 20.33-4.05 1.64-1.05 2.88-1.71 3.55-1.88 2.45-1.5 4.56-3.27 6.33-5.33 1.22-1.43 2.21-4.8 2.96-9.36v-9.54c-.18-2.12-.32-4.34-.42-6.62-.58 11.76-1.98 21.8-4.06 24.22-7.14 8.34-20.48 11.78-39.66 10.22-32.49-2.63-49.82-7.59-48.39-26.22.34-4.32 1.64-10.4 3.03-16.82 2.26-10.49 4.6-21.34 3.07-26.51-2.91-9.82-6.07-16.72-6.88-18.42.69-1.6 4.15-8.41 15.26-14.94 14.82-8.72 41.26-6.65 53.7-1.34 13.22 5.65 17.07 14.45 21.45 27.21 1.28 3.74 2.1 10.38 2.5 18.07.1-2.04.24-4 .4-5.86v-8.78c-.3-1.6-.64-2.98-1.01-4.07-4.41-12.87-8.61-22.44-22.55-28.4-7.21-3.08-19.19-5.25-31.1-4.75l.02.01-.72 1.86c-.05-.02-1.6-.62-4-1.52h-.01c-7.19.75-14.11 2.57-19.69 5.85-13.37 7.86-16.18 16.05-16.29 16.39l1.45.33c-.01.05-.2.87-.54 2.28 1.23 2.74 3.58 8.35 5.83 15.79l1.63.53c-.03.09-.38 1.18-.98 3.08v.01c.23 5.49-1.73 14.57-3.5 22.75-1.39 6.5-2.72 12.64-3.06 17.1-.26 3.31.04 6.24.86 8.81l.01.04 1.11.24z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m654.09 364.61-.13.39.18.37c.01.02.33.66.86 1.85.34-1.41.53-2.23.54-2.28l-1.45-.33zm40.71-22.59s-.01-.01-.02-.01c-1.58.07-3.14.18-4.7.35 2.4.9 3.94 1.5 4 1.52l.72-1.86zm-39.01 93.31c-.01-.02-.01-.03-.01-.04l-.84-3.14c-.06.31-.73 4.61-.66 10.29.04-4.18.6-7.01.66-7.29l.85.18z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m655.79 435.33-.01-.04c.01.01.01.02.01.04zm0 0c.23.74.51 1.41.83 2.09.14-1.15.27-1.83.28-1.86l-1.11-.23zm5.04-52.32c.09.28.17.57.26.86.22.76.35 1.69.39 2.75.6-1.9.95-3 .98-3.08l-1.63-.53z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.Heart.includes(this.state.bodyTitles) || female_human_body.Heart.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M750.98 418.53c.58 11.71 1.98 21.69 4.05 24.1 7.15 8.34 20.5 11.77 39.66 10.22 32.49-2.63 49.82-7.59 48.39-26.22-.33-4.32-1.64-10.4-3.02-16.83-2.26-10.49-4.6-21.33-3.07-26.5 2.91-9.82 6.07-16.72 6.88-18.42-.7-1.6-4.15-8.41-15.26-14.94-7.22-4.25-17.2-5.93-26.97-5.93-10.29 0-20.36 1.87-26.74 4.59-13.21 5.65-17.07 14.45-21.44 27.21-1.28 3.73-2.1 10.33-2.5 18 .41 7.76.42 16.6.02 24.72z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.Heart.includes(this.state.bodyTitles) || female_human_body.Heart.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M750.98 418.53c.4-8.12.39-16.96-.02-24.72-.41 7.78-.39 16.66.02 24.72zm-1.54 6.5v9.54c.21-1.23.39-2.56.56-3.95-.22-1.76-.4-3.63-.56-5.59zm.56-42.24c-.17-1.28-.35-2.47-.56-3.55v8.78c.16-1.86.34-3.62.56-5.23z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.04 393.88c-.41 7.7-.42 16.47-.02 24.53.4-8 .42-16.8.02-24.53z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.04 393.88c.4 7.73.38 16.53-.02 24.53.1 2.28.24 4.5.42 6.62v-37.01c-.16 1.86-.3 3.82-.4 5.86zm90.13-10.87c2.26-7.44 4.6-13.06 5.83-15.8-.34-1.4-.53-2.22-.54-2.27l1.46-.34v-.01c-.15-.43-3.01-8.57-16.29-16.38-5.58-3.28-12.51-5.11-19.7-5.85h-.01c-2.4.9-3.94 1.5-3.99 1.52l-.72-1.86s.01 0 .02-.01c-11.91-.5-23.89 1.66-31.1 4.75-13.95 5.96-18.14 15.53-22.55 28.4-.37 1.09-.71 2.47-1.01 4.07v8.78c.16 1.83.29 3.78.4 5.79.4-7.67 1.22-14.27 2.5-18 4.37-12.76 8.23-21.56 21.44-27.21 6.38-2.72 16.45-4.59 26.74-4.59 9.77 0 19.75 1.68 26.97 5.93 11.11 6.53 14.56 13.34 15.26 14.94-.81 1.7-3.97 8.6-6.88 18.42-1.53 5.17.81 16.01 3.07 26.5 1.38 6.43 2.69 12.51 3.02 16.83 1.43 18.63-15.9 23.59-48.39 26.22-19.16 1.55-32.51-1.88-39.66-10.22-2.07-2.41-3.47-12.39-4.05-24.1-.11 2.23-.25 4.41-.42 6.5v9.54c.75 4.56 1.74 7.93 2.96 9.36 1.76 2.06 3.88 3.83 6.33 5.33.68.17 1.91.83 3.54 1.87 5.47 2.47 12.25 3.82 20.33 4.05h.01c-.07-.04-.14-.08-.17-.1l1.02-1.72c.07.04 1.28.75 3.27 1.83 2.25-.03 4.59-.15 7.02-.34 25.99-2.11 43.17-5.97 48.52-17.4.01-.01 0-.02 0-.02-.14-1.15-.27-1.83-.28-1.86l1.11-.23.59-2.42c.36-1.96.47-4.09.28-6.43-.35-4.46-1.67-10.6-3.07-17.1-1.76-8.18-3.72-17.26-3.49-22.75-.6-1.91-.96-3.01-.98-3.1l1.61-.52zm-88.61 51.56v-9.54c-.16 1.96-.34 3.83-.56 5.59.17 1.39.35 2.72.56 3.95zm0-46.55v-8.78c-.21 1.08-.39 2.27-.56 3.55.22 1.61.4 3.37.56 5.23z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M750.98 418.53c-.41-8.06-.43-16.94-.02-24.72-.11-2.01-.24-3.96-.4-5.79v37.01c.17-2.09.31-4.27.42-6.5zm-1.54-30.51v37.01c.16 1.96.34 3.83.56 5.59.22-1.76.4-3.63.56-5.59v-37.01c-.16-1.86-.34-3.62-.56-5.23-.22 1.61-.4 3.37-.56 5.23zM845 367.21v-.01c.52-1.17.84-1.81.85-1.83l.19-.37-.13-.39-1.46.34c.02.04.21.86.55 2.26zm-39.08-23.32c.05-.02 1.59-.62 3.99-1.52-1.56-.17-3.12-.28-4.69-.35-.01.01-.02.01-.02.01l.72 1.86zm38.29 91.44.85-.18c.06.29.65 3.27.66 7.65.23-7.66-.45-13.94-.37-12.18l-.55 2.29c-.16.83-.34 1.65-.59 2.42z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M844.21 435.33c.25-.77.43-1.59.59-2.42l-.59 2.42zm-1.11.23c.01.03.14.71.28 1.86.32-.68.6-1.36.83-2.09l-1.11.23zm-4.58-48.94c.04-1.06.16-1.99.39-2.75.09-.29.17-.58.26-.86l-1.63.53c.03.09.38 1.19.98 3.1v-.02z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.Heart.includes(this.state.bodyTitles) || female_human_body.Heart.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M749.44 456.52v-21.95c-.75 4.56-1.74 7.93-2.96 9.36-1.77 2.06-3.89 3.83-6.33 5.33.03-.01.07-.02.09-.03 4.33-.87 7.71 4.78 9.2 7.29z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M713.81 455.21c.83 0 1.65-.01 2.46-.03.07-.04.14-.08.17-.1l-1.02-1.72c-.07.04-1.28.75-3.27 1.83h.01c.56.02 1.11.02 1.65.02z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "m759.75 449.23.1.03c-2.45-1.5-4.56-3.27-6.33-5.33-1.22-1.43-2.21-4.8-2.96-9.36v21.95c1.49-2.51 4.89-8.16 9.19-7.29zm-9.75 8.3c.13-.26.32-.61.56-1.01v-21.95c-.21-1.23-.39-2.56-.56-3.95-.17 1.39-.35 2.72-.56 3.95v21.95c.24.4.43.75.56 1.01z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M786.19 455.21c.54 0 1.09 0 1.64-.02h.01c-2-1.09-3.2-1.79-3.27-1.83l-1.02 1.72c.04.02.1.06.17.1.82.02 1.63.03 2.47.03z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-breast is_right",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Breast");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Breast");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "270",
	              y: "409",
	              width: "115",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 -47.07)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M812.407 191.303H1331.1",
	                transform: "matrix(-.57296 0 0 -.7655 1167.67 622.75)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Breast" ? "#f58220" : "#af9763"
	                },
	                d: "M270.957 463.206h10.296c2.052 0 3.564.108 4.572.252 1.008.18 1.908.54 2.7 1.08.792.54 1.44 1.26 1.98 2.16.504.9.792 1.872.792 2.988 0 1.224-.324 2.34-.972 3.348-.648 1.008-1.548 1.764-2.664 2.268 1.584.432 2.772 1.224 3.636 2.34.828 1.08 1.26 2.376 1.26 3.852 0 1.188-.288 2.34-.828 3.42-.54 1.116-1.296 2.016-2.232 2.664-.936.684-2.088 1.08-3.492 1.224-.864.108-2.952.144-6.264.18h-8.784v-25.776Zm5.22 4.284v5.976h3.42c2.016 0 3.276-.036 3.744-.108.9-.108 1.62-.396 2.124-.9s.756-1.188.756-2.016c0-.792-.216-1.44-.648-1.944-.432-.504-1.116-.792-1.98-.9-.504-.072-1.98-.108-4.428-.108h-2.988Zm0 10.26v6.876h4.824c1.872 0 3.06-.036 3.564-.144.756-.144 1.404-.468 1.872-1.044.504-.54.72-1.26.72-2.16 0-.792-.18-1.44-.54-1.98-.396-.54-.936-.936-1.62-1.188-.72-.252-2.268-.36-4.644-.36h-4.176ZM301.637 488.982h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM321.731 483.042l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM334.623 476.022l-4.464-.828c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.624 3.996c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM349.207 483.654l4.968-.756c.216.972.648 1.692 1.296 2.196.648.504 1.548.756 2.7.756 1.26 0 2.232-.252 2.88-.72.432-.324.648-.756.648-1.332 0-.36-.108-.684-.36-.9-.216-.252-.792-.468-1.656-.684-3.96-.864-6.48-1.656-7.56-2.376-1.476-1.008-2.232-2.412-2.232-4.212 0-1.62.648-2.988 1.944-4.068 1.26-1.116 3.24-1.656 5.94-1.656 2.556 0 4.428.396 5.688 1.224 1.224.864 2.088 2.088 2.556 3.708l-4.644.864c-.216-.72-.576-1.296-1.152-1.692-.54-.36-1.332-.576-2.376-.576-1.296 0-2.232.18-2.772.54-.396.288-.576.612-.576 1.008 0 .36.144.648.504.9.432.324 1.98.792 4.608 1.404 2.628.576 4.464 1.332 5.508 2.196 1.008.864 1.548 2.088 1.548 3.672 0 1.692-.72 3.168-2.16 4.392-1.404 1.26-3.528 1.872-6.336 1.872-2.556 0-4.572-.54-6.048-1.548-1.476-1.044-2.448-2.448-2.916-4.212ZM379.569 470.298v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-heart",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Heart");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Heart");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "409",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 -47.07)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M812.407 191.303H1331.1",
	                transform: "matrix(.57296 0 0 .7655 331.54 329.867)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Heart" ? "#f58220" : "#af9763"
	                },
	                d: "M1119.993 488.982v-25.776h5.22v10.152h10.188v-10.152h5.22v25.776h-5.22v-11.268h-10.188v11.268h-5.22ZM1156.747 483.042l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1169.65 476.022l-4.465-.828c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.623 3.996c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1190.713 488.982h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM1208.575 470.298v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Upper_GI" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Lungs,Kidney,Liver,Spine");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Lungs,Kidney,Liver,Spine");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "M845.72 442.8c-.06 2.1-.2 4.3-.43 6.47.32-2.36.43-4.55.43-6.47zm-189.87 12.12c-1.13-4.25-1.52-8.67-1.57-12.48-.03 3.44.3 7.81 1.57 12.48z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M736.6 451.13a31.38 31.38 0 0 0 3.55-1.88c-.67.17-1.92.83-3.55 1.88zm23.25-1.87c1.11.68 2.29 1.31 3.54 1.87-1.63-1.04-2.87-1.7-3.54-1.87zm85.15 1.87c0 .03.01.12.02.27.1-.7.19-1.41.27-2.12-.09.63-.19 1.27-.3 1.92l.01-.07z"
	            }),
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "M845 451.13c0 .03.01.12.02.27.1-.7.19-1.41.27-2.12-.09.63-.19 1.27-.3 1.92l.01-.07zm.72-8.33c-.06 2.1-.2 4.3-.43 6.47.32-2.36.43-4.55.43-6.47zm-191.44-.36c-.03 3.45.3 7.82 1.57 12.48-1.13-4.26-1.52-8.68-1.57-12.48z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m656.91 456.57-.6-.05c.16.49.32.99.5 1.49.06-.89.1-1.42.1-1.44zm54.86.91c.09.01.2.02.31.03 1.11-.6 2.05-1.12 2.77-1.53-1.43-.34-2.62-.47-2.89-.5l-.19 2zm131.92.04c.11-.33.21-.68.3-1.03l-.3.03c-.07.22-.15.44-.22.65l.22.35zm0-1c.57-1.82.99-3.6 1.29-5.32l-1.29 5.32z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M844.98 451.2c-.31 1.72-.72 3.5-1.29 5.32l.3-.03c.44-1.59.77-3.32 1.03-5.1-.01-.15-.02-.24-.02-.27l-.02.08zm-1.9 5.37c0 .02.04.55.1 1.44.1-.28.19-.56.28-.83l-.38-.61zm.61-.05-.6.05.38.6c.07-.21.15-.43.22-.65zm-55.46.96-.19-1.99c-.28.03-1.46.16-2.89.5.72.41 1.66.93 2.77 1.53.11-.02.22-.03.31-.04z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M680.14 568.29c3.11 1.56 5.88 1.85 8.24.88 2.64-1.1 4.07-3.56 4.45-4.7.43-1.49-2.84-11.61-6.36-20.87-4.52-1.89-10.7-5.89-14.54-9.81-3.36-3.42-6.7-7.87-9.24-11.51 1.84 8.57 1.18 20.25 2.01 28.25h.01c.07.14 7.02 13.56 15.43 17.76z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M698.84 617.48c7.16-21.07-9.38-43.44-11.31-45.97-.66.15-1.35.22-2.05.22-1.95 0-4.04-.55-6.24-1.65-5.85-2.93-10.87-9.7-13.74-14.23.84 6.49.27 15.6-.42 22.94v.01c3.36 6.34 9.06 16.86 12.28 21.35 5.54 7.73 18.81 17.19 21.48 17.33zm49.59-42.33c-.19-7.8-.06-17.15.44-19.28-1.02-.9-4.17-1.17-7.78-1.17-3.86 0-8.26.31-11.14.52-6.48.46-13.21 1.67-17.72 2.6-5.13 1.07-9.02 5.2-9.67 10.28-.32 2.47-.48 4.76-.48 6.86 0 6.94 1.73 11.82 5.18 14.58 5.18 4.15 37.16 3.37 40.65 2.51.46-.68.82-2.92 1.09-5.97 0 0-.01-.01 0-.02-.25-2.62-.45-6.16-.57-10.91z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749 586.08c-.27 3.05-.63 5.29-1.09 5.97-3.49.86-35.47 1.64-40.65-2.51-3.45-2.76-5.18-7.64-5.18-14.58 0-2.1.16-4.39.48-6.86.65-5.08 4.54-9.21 9.67-10.28 4.51-.93 11.24-2.14 17.72-2.6 2.88-.21 7.28-.52 11.14-.52 3.61 0 6.76.27 7.78 1.17a2.486 2.486 0 0 1 .57-1.1v-.88c-2.85-1.52-9.19-1.42-19.64-.67-6.58.47-13.41 1.7-17.98 2.65-5.96 1.23-10.48 6.05-11.25 11.98-1.46 11.37.37 19.2 5.44 23.25 3.56 2.85 16.26 3.7 26.93 3.7 7.73 0 14.4-.45 15.74-.89.22-.08.48-.17.76-.55v-3.69c-.16-.95-.31-2.13-.44-3.59zm-69.76-16c2.2 1.1 4.29 1.65 6.24 1.65.7 0 1.39-.07 2.05-.22-.12-.14-.18-.22-.19-.23l1.56-1.25c.07.09.29.36.62.8 3.07-1.42 4.71-4.24 5.21-5.73.79-2.39-3.46-14.38-5.79-20.64-.74-.19-1.57-.48-2.47-.86 3.52 9.26 6.79 19.38 6.36 20.87-.38 1.14-1.81 3.6-4.45 4.7-2.36.97-5.13.68-8.24-.88-8.41-4.2-15.36-17.62-15.43-17.76h-.01c.12 1.17.27 2.26.47 3.25.13.65.24 1.34.33 2.06v.01c2.87 4.53 7.89 11.3 13.74 14.23zm8.76-28.09-.12.05c.05.02.11.04.16.06-.01-.04-.03-.07-.04-.11z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M687.88 542.04h-.01l-1.74.66c.11.3.23.6.34.9.9.38 1.73.67 2.47.86-.35-.93-.66-1.73-.9-2.36-.05-.02-.11-.04-.16-.06zm11.15 77.43c.1 0 .2-.01.29-.02.64-.09 1.11-.47 1.31-1.03.97-2.78 1.55-5.57 1.83-8.33l-.38-.63v-1.89l.53.54c.87-17.61-10.27-33.55-13.09-37.28-.12.07-.25.13-.38.18-.52.22-1.06.38-1.61.5 1.93 2.53 18.47 24.9 11.31 45.97-2.67-.14-15.94-9.6-21.48-17.33-3.22-4.49-8.92-15.01-12.28-21.35-.12 1.25-.24 2.44-.36 3.57 3.39 6.35 8.12 14.9 11.02 18.95 5.35 7.48 19.14 18.15 23.29 18.15z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M687.34 571.28c.01.01.07.09.19.23.55-.12 1.09-.28 1.61-.5.13-.05.26-.11.38-.18-.33-.44-.55-.71-.62-.8l-1.56 1.25z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M751.56 575.15c-.12 4.75-.31 8.29-.56 10.91v.02c.27 3.05.63 5.29 1.09 5.97 3.48.86 35.47 1.64 40.65-2.51 4.49-3.59 6.07-10.8 4.7-21.44-.33-2.54-1.46-4.84-3.15-6.64-1.7-1.8-3.96-3.1-6.52-3.64-4.51-.93-11.24-2.14-17.72-2.6-5.58-.4-16.79-1.2-18.92.65.5 2.12.63 11.48.43 19.28zm69.2-5.07c-2.21 1.1-4.29 1.65-6.24 1.65-.7 0-1.38-.07-2.05-.22-1.94 2.53-18.48 24.9-11.31 45.97 2.67-.14 15.94-9.6 21.48-17.33 3.21-4.49 8.92-15.01 12.28-21.35v-.01c-.69-7.33-1.26-16.45-.43-22.93-2.87 4.53-7.88 11.29-13.73 14.22z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M813.52 543.61c-3.51 9.26-6.78 19.37-6.35 20.86.38 1.14 1.8 3.6 4.45 4.7 2.35.97 5.13.68 8.24-.88 8.41-4.2 15.36-17.62 15.42-17.76l.02.01c.83-8.01.17-19.7 2.01-28.27-2.54 3.64-5.89 8.1-9.25 11.52-3.85 3.91-10.03 7.92-14.54 9.82zm-64.08 49.75v5.29c.21.07.39.13.56.2.16-.07.35-.13.56-.2v-5.29c-.18-.25-.37-.63-.56-1.22-.19.59-.38.97-.56 1.22zm0-51.66v12.19c.21.1.39.21.56.35.17-.14.35-.25.56-.35V541.7c-.26-.68-.44-1.42-.56-2.19-.13.77-.31 1.51-.56 2.19zm1.12 16.73v20.17c.1 2.72.25 5.29.44 7.46.25-2.62.44-6.16.56-10.91.2-7.8.07-17.16-.43-19.28-.15.12-.26.27-.31.43-.1.31-.19 1.05-.26 2.13zm0 20.17v-20.17c-.26 4.02-.29 12.64 0 20.17z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M750 554.24c-.17-.14-.35-.25-.56-.35v.88c.14-.2.34-.38.56-.53zm-.56 35.43v3.69c.18-.25.37-.63.56-1.22-.2-.59-.38-1.39-.56-2.47z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M748.43 575.15c.12 4.75.32 8.29.57 10.91.19-2.2.34-4.84.44-7.61v-20.02c-.07-1.08-.16-1.82-.26-2.13a.966.966 0 0 0-.31-.43c-.5 2.13-.63 11.48-.44 19.28z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749 586.06c-.01.01 0 .02 0 .02.13 1.46.28 2.64.44 3.59v-11.22c-.1 2.77-.25 5.41-.44 7.61zm.44-27.63v-3.66a2.486 2.486 0 0 0-.57 1.1c.15.13.26.27.31.43.1.31.19 1.05.26 2.13zm1.63-2.77c.02.06.04.13.06.21 2.13-1.85 13.34-1.05 18.92-.65 6.48.46 13.21 1.67 17.72 2.6 2.56.54 4.82 1.84 6.52 3.64 1.69 1.8 2.82 4.1 3.15 6.64 1.37 10.64-.21 17.85-4.7 21.44-5.18 4.15-37.17 3.37-40.65 2.51-.46-.68-.82-2.92-1.09-5.97-.14 1.46-.28 2.64-.44 3.59v3.69c.28.38.54.47.76.55 1.34.45 8.01.89 15.74.89 10.67 0 23.37-.85 26.93-3.7 3.94-3.15 5.93-8.59 5.93-16.2 0-2.17-.17-4.52-.49-7.05-.77-5.93-5.29-10.75-11.25-11.98-4.57-.95-11.4-2.18-17.99-2.65-10.45-.74-16.78-.84-19.63.67v.88c.24.27.4.56.51.89z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M750 592.14c.19.59.38.97.56 1.22v-3.69c-.18 1.08-.37 1.88-.56 2.47zm-.56-33.71v20.02c.29-7.5.26-16.02 0-20.02zm1.12-3.66v-.88c-.21.1-.39.21-.56.35.22.15.42.33.56.53zm0 23.83v11.07c.16-.95.3-2.13.44-3.59v-.02c-.19-2.17-.34-4.74-.44-7.46zm.26-22.3c.05-.16.16-.31.31-.43a2.486 2.486 0 0 0-.57-1.1v3.66c.07-1.08.16-1.82.26-2.13z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.44 554.77v3.66c.26 4 .29 12.52 0 20.02v11.22c.18 1.08.36 1.88.56 2.47.19-.59.38-1.39.56-2.47V578.6c-.29-7.53-.26-16.15 0-20.17v-3.66c-.14-.2-.34-.38-.56-.53-.22.15-.42.33-.56.53zM812 541.99c-.01.03-.03.07-.04.1.05-.01.1-.03.15-.06l-.11-.04zm7.86 26.3c-3.11 1.56-5.89 1.85-8.24.88-2.65-1.1-4.07-3.56-4.45-4.7-.43-1.49 2.84-11.6 6.35-20.86-.9.37-1.72.66-2.46.85-2.33 6.26-6.58 18.25-5.79 20.64.5 1.49 2.14 4.31 5.2 5.73.34-.44.56-.71.63-.8l1.56 1.25c-.01.01-.07.09-.19.23.67.15 1.35.22 2.05.22 1.95 0 4.03-.55 6.24-1.65 5.85-2.93 10.86-9.69 13.73-14.22.1-.73.21-1.42.34-2.08.2-.99.35-2.07.47-3.24l-.02-.01c-.06.14-7.01 13.56-15.42 17.76z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M813.52 543.61c.11-.3.22-.61.34-.91l-1.75-.67c-.05.03-.1.05-.15.06-.24.63-.55 1.44-.9 2.37.74-.19 1.56-.48 2.46-.85zm-12.36 73.87c-7.17-21.07 9.37-43.44 11.31-45.97-.55-.11-1.09-.28-1.62-.5a2.64 2.64 0 0 1-.38-.18c-2.83 3.75-14 19.73-13.08 37.39l.53-.65v1.89l-.39.63c.28 2.76.86 5.54 1.83 8.32.2.56.68.94 1.32 1.03.09.01.18.02.28.02 4.16 0 17.94-10.67 23.3-18.15 2.9-4.05 7.62-12.59 11.02-18.94v-.01c-.12-1.12-.24-2.32-.36-3.57-3.36 6.34-9.07 16.86-12.28 21.35-5.54 7.74-18.81 17.2-21.48 17.34z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M812.47 571.51c.12-.14.18-.22.19-.23l-1.56-1.25c-.07.09-.29.36-.63.8.12.07.25.13.38.18.53.22 1.07.39 1.62.5z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M702.61 608.11c-.03.66-.08 1.31-.15 1.98l.77 1.26c-.01-.82.06-1.63.18-2.42l-.8-.82z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M703.41 608.92c-.12.8-.19 1.6-.18 2.42l.4-2.2-.22-.22zm-1.33-1.35v1.89l.38.63c.07-.66.12-1.32.15-1.98l-.53-.54zm94.69 3.78.76-1.25c-.06-.63-.11-1.25-.14-1.88l-.76.93c.09.72.15 1.45.14 2.2z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M797.92 609.46v-1.89l-.53.65c.03.62.08 1.25.14 1.88l.39-.64z"
	            }),
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "M654.76 472.6c-.16-1.99-.23-4.33-.24-6.71 0 2.22.06 4.56.24 6.71zm190.31 1.62c.4-3.17.45-7 .38-10.29.03 3.8-.05 7.64-.38 10.29z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M745.48 506.78c-2.49 0-7.57 3.32-11.15 5.65-1.73 1.13-3.37 2.2-4.84 3.04-3.72 2.12-11.33 7.49-17.06 11.62-3.71 2.66-6.19 6.77-6.81 11.26-.34 2.44-.47 4.36-.47 5.88 0 4.3 1.06 5.36 1.47 5.61 3.72 2.24 29.55-3.24 37.07-5.39 4.5-1.29 4.67-5.06 4.58-11.63-.01-.78-.03-1.57-.03-2.37 0-1.32.03-2.84.07-4.48.12-6.41.32-16.1-1.63-18.7-.25-.34-.67-.49-1.2-.49z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M744.24 546.38c-2.7.77-23.85 5.94-34 5.94-2.12 0-3.76-.23-4.65-.77-2.37-1.42-3.01-5.83-1.95-13.47.35-2.52 1.21-4.92 2.51-7.08 1.3-2.15 3.04-4.04 5.11-5.54 5.77-4.15 13.44-9.56 17.24-11.73 1.42-.81 3.03-1.86 4.74-2.98 6.13-3.99 12.46-8.12 15.04-4.68.49.65.87 1.57 1.16 2.68v-24.31c-.8 5.19-2.07 9.43-4.04 10.74-3.05 2.03-13.52 10.84-21.93 17.92-6.29 5.31-11.27 9.49-12.41 10.26-.95.63-2.1.95-3.3.95-.79 0-1.62-.14-2.42-.43-1.87-.69-3.23-2.04-3.72-3.72-1.76-6.01-.11-31.82-.04-32.92v-.02c.03-.32.09-.66.17-1.01.02-.1.06-.2.08-.29.07-.27.16-.55.26-.83.03-.08.06-.16.09-.25 3.88-10.13 25.28-27.87 34.41-33.7-5.47 2.46-12.25 3.82-20.33 4.05-.26.15-.74.43-1.42.81 1.98.48 4.44 1.37 5.65 2.99.66.88.89 1.91.67 2.99-.89 4.43-28.37 21.91-43.81 27.87 2.19.56 5.66 1.28 10.35 1.75 8.74.88 11.07 11.13 12.06 15.51.1.42.18.79.26 1.09.36 1.44-.2 2.98-1.58 4.36-1.79 1.79-5.04 3.34-8.81 3.45 1.2 2.1 3.25 5.99 4.08 9.29 2.34 9.38.35 18.01-2.14 19.26-.24.12-.55.18-.93.18-.48 0-1.06-.09-1.71-.27 2.33 6.26 6.58 18.25 5.79 20.64-.5 1.49-2.14 4.31-5.21 5.73 2.82 3.74 13.96 19.67 13.09 37.28l.8.81c.48-3.28 1.99-6.31 4.43-8.68 3.02-2.94 7.01-4.46 11.24-4.3 16.41.68 26.6 1.58 30.36 2.7v-5.29c-.28.38-.54.47-.76.55-1.34.44-8.01.89-15.74.89-10.67 0-23.37-.85-26.93-3.7-5.07-4.05-6.9-11.88-5.44-23.25.77-5.93 5.29-10.75 11.25-11.98 4.57-.95 11.4-2.18 17.98-2.65 10.45-.75 16.79-.85 19.64.67V541.7c-.79 2.17-2.31 3.85-5.19 4.68z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M740.64 452.19c-4.62.92-36.22 25.31-37.06 35.19-.04.63-1.69 26.58-.04 32.22.31 1.06 1.22 1.93 2.49 2.4 1.38.5 2.88.38 3.92-.31 1.05-.7 6.48-5.27 12.24-10.12 8.88-7.48 18.96-15.96 22.1-18.05 4.49-3 4.9-32.39 4.04-34.86-.36-.71-3.75-7.25-7.69-6.47zm-83.73 21.78c1.25 10.03 5.28 15.22 12.31 15.86 9.79.88 49.09-24.68 50-28.26.1-.52 0-.97-.32-1.4-1.24-1.66-5.08-2.44-6.81-2.65-8.43 4.55-27.12 13.8-39.88 13.8-4.75 0-8.68-1.28-10.95-4.58-1.97-2.87-3.4-5.82-4.44-8.73-.21 3.11-.58 10.62.09 15.96z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M662.91 465.6c1.87 2.73 5.21 3.81 9.32 3.81 12.51 0 32.2-10.02 39.93-14.23-2.25-.03-4.58-.15-7.01-.34-25.99-2.11-43.17-5.97-48.52-17.4v-.03c-.57 4.68-1.2 17.33 6.28 28.19zm27.82 77.14c.96-.53 3.34-7.78 1.05-16.96-.95-3.77-3.74-8.59-4.52-9.9h-.01c-.54-.07-1.09-.17-1.64-.31-5.97-1.5-21.83-11.94-27.37-15.67.62 5.3 1.43 11.45 2.58 15.92v.02c1.96 3.08 7.32 11.24 12.54 16.55 4.35 4.44 10.76 8.13 14.52 9.65l.12-.05c.01.04.03.07.04.11 1.31.51 2.28.75 2.69.64zm6.3-31.6c.5-.5 1.3-1.48 1.06-2.46-.08-.32-.17-.7-.27-1.13-.97-4.3-3-13.24-10.31-13.97-7.8-.78-12.28-2.22-13.36-2.62-1.85.57-3.41.88-4.6.88-.18 0-.35-.01-.51-.02-5.01-.46-8.74-2.95-11.17-7.44l-.37 8.97c.14 1.16.28 2.48.44 3.92v.01c3.27 2.22 21.94 14.79 28.16 16.35 4.44 1.11 8.86-.42 10.93-2.49z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M748.28 506.07c-2.58-3.44-8.91.69-15.04 4.68-1.71 1.12-3.32 2.17-4.74 2.98-3.8 2.17-11.47 7.58-17.24 11.73-2.07 1.5-3.81 3.39-5.11 5.54-1.3 2.16-2.16 4.56-2.51 7.08-1.06 7.64-.42 12.05 1.95 13.47.89.54 2.53.77 4.65.77 10.15 0 31.3-5.17 34-5.94 2.88-.83 4.4-2.51 5.2-4.68v-32.95c-.29-1.11-.67-2.03-1.16-2.68zm.03 19.9c-.04 1.64-.07 3.16-.07 4.48 0 .8.02 1.59.03 2.37.09 6.57-.08 10.34-4.58 11.63-7.52 2.15-33.35 7.63-37.07 5.39-.41-.25-1.47-1.31-1.47-5.61 0-1.52.13-3.44.47-5.88.62-4.49 3.1-8.6 6.81-11.26 5.73-4.13 13.34-9.5 17.06-11.62 1.47-.84 3.11-1.91 4.84-3.04 3.58-2.33 8.66-5.65 11.15-5.65.53 0 .95.15 1.2.49 1.95 2.6 1.75 12.29 1.63 18.7zm1.13-63.48v-5.97c-1.49-2.51-4.87-7.16-9.2-6.29-4.15.83-33.43 22.7-38.06 34.61-.03.08-.07.17-.09.25-.1.28-.18.56-.26.83-.03.1-.06.2-.08.29-.08.35-.14.69-.17 1.01v.02c-.07 1.1-1.72 26.91.04 32.92.49 1.68 1.85 3.03 3.72 3.72.8.29 1.63.43 2.42.43 1.2 0 2.35-.32 3.3-.95 1.14-.77 6.12-4.95 12.41-10.26 8.41-7.08 18.88-15.89 21.93-17.92 1.97-1.31 3.24-5.55 4.04-10.74v-13.67c-.09-3.13-.08-6.02 0-8.28zm-5.15 31.03c-3.14 2.09-13.22 10.57-22.1 18.05-5.76 4.85-11.19 9.42-12.24 10.12-1.04.69-2.54.81-3.92.31-1.27-.47-2.18-1.34-2.49-2.4-1.65-5.64 0-31.59.04-32.22.84-9.88 32.44-34.27 37.06-35.19 3.94-.78 7.33 5.76 7.69 6.47.86 2.47.45 31.86-4.04 34.86z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M702.19 484.83c4.63-11.91 33.9-33.78 38.06-34.61 4.33-.87 7.71 3.78 9.2 6.29-1.49-2.51-4.87-8.16-9.2-7.29l-.09.03c-1.12.68-2.3 1.31-3.55 1.88-9.14 5.83-30.54 23.57-34.42 33.7zm-.36 1.08c.07-.27.15-.55.26-.83-.1.28-.18.56-.26.83zm-.25 1.31zm.51-2.14c.03-.08.06-.16.09-.25-.03.09-.06.17-.09.25zm-.34 1.12c.02-.1.06-.2.08-.29-.02.1-.06.2-.08.29zm-45.44-29.68.6.05c0 .02-.04.55-.1 1.44 1.04 2.91 2.47 5.87 4.44 8.73 2.26 3.29 6.19 4.58 10.95 4.58 12.75 0 31.44-9.24 39.88-13.8-.11-.01-.22-.03-.31-.03l.19-1.99c.28.03 1.46.16 2.89.5.68-.38 1.16-.66 1.42-.81-.81.02-1.63.03-2.46.03-.54 0-1.09 0-1.65-.02h-.01c-7.73 4.21-27.42 14.23-39.93 14.23-4.11 0-7.44-1.08-9.32-3.81-7.47-10.87-6.85-23.52-6.29-28.18-.32-.68-.6-1.35-.83-2.09l-.85-.18c-.06.28-.62 3.1-.66 7.29.05 3.81.44 8.23 1.57 12.48.15.51.3 1.05.47 1.58z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M718.89 460.17c.32.43.42.88.32 1.4-.91 3.58-40.21 29.14-50 28.26-7.03-.64-11.05-5.83-12.31-15.86-.67-5.34-.3-12.85-.1-15.96-.18-.5-.35-.99-.5-1.49l-1.39-.12c-.02.28-.37 4.58-.4 9.49.01 2.38.08 4.72.24 6.71.05.55.1 1.1.16 1.62.33 2.67.87 5.04 1.61 7.11l1.41 1.29-.07 1.76c2.43 4.49 6.16 6.99 11.17 7.44.16.01.33.02.51.02 1.19 0 2.75-.32 4.6-.88h-.01a1.95 1.95 0 0 1-.24-.08l.72-1.86c.02 0 .95.36 2.74.82 15.45-5.96 42.92-23.44 43.81-27.87.21-1.07-.02-2.11-.67-2.99-1.21-1.62-3.67-2.51-5.65-2.99-.72.41-1.66.93-2.77 1.53 1.75.21 5.59.99 6.82 2.65z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M654.93 474.22c-.07-.52-.11-1.07-.16-1.62.04.57.09 1.12.16 1.62zm1.38-17.7-1.39-4.12c-.03.3-.42 7-.4 13.49.02-4.91.37-9.21.4-9.49l1.39.12zm30.94 59.36h.01zm0 0c-.13-.22-.2-.34-.21-.35l1.7-1.06c.04.08.4.64.9 1.53 3.77-.11 7.02-1.66 8.81-3.45 1.38-1.38 1.94-2.92 1.58-4.36-.08-.3-.16-.67-.26-1.09-.99-4.38-3.32-14.63-12.06-15.51-4.69-.47-8.16-1.19-10.35-1.75-1.14.44-2.22.82-3.21 1.12 1.08.39 5.57 1.84 13.36 2.62 7.31.73 9.34 9.67 10.31 13.97.1.43.19.81.27 1.13.24.98-.56 1.96-1.06 2.46-2.07 2.07-6.49 3.6-10.93 2.49-6.22-1.56-24.89-14.13-28.16-16.35.1.84.2 1.71.3 2.61v.01c5.54 3.73 21.4 14.17 27.37 15.67.55.14 1.1.24 1.64.31z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M673.9 490.88c.02.01.1.04.24.08h.01c1-.3 2.07-.68 3.21-1.12-1.79-.46-2.72-.82-2.74-.82l-.72 1.86zm-13.08 24.96c.25 1 .53 1.92.82 2.72.42 1.15.77 2.4 1.05 3.72 2.54 3.64 5.88 8.09 9.24 11.51 3.84 3.92 10.02 7.92 14.54 9.81-.11-.3-.23-.6-.34-.9l1.74-.66h.01c-3.76-1.52-10.17-5.21-14.52-9.65-5.22-5.31-10.58-13.47-12.54-16.55zm30.76 28.71c2.49-1.25 4.48-9.88 2.14-19.26-.83-3.3-2.88-7.19-4.08-9.29-.15.01-.31.01-.46.01-.63 0-1.26-.04-1.92-.13.78 1.31 3.57 6.13 4.52 9.9 2.29 9.18-.09 16.43-1.05 16.96-.41.11-1.38-.13-2.69-.64.24.63.55 1.43.9 2.36.65.18 1.23.27 1.71.27.38 0 .69-.06.93-.18z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M687.04 515.53c.01.01.08.13.21.35h.01c.66.09 1.29.13 1.92.13.15 0 .31 0 .46-.01-.5-.89-.86-1.45-.9-1.53l-1.7 1.06z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M781.11 460.17c-.32.43-.42.88-.32 1.4.89 3.51 38.89 28.28 49.47 28.28.18 0 .36-.01.52-.02 7.03-.64 11.05-5.83 12.3-15.86.67-5.34.3-12.85.1-15.97-1.04 2.91-2.47 5.87-4.44 8.73-2.26 3.29-6.19 4.58-10.95 4.58-12.75 0-31.44-9.24-39.88-13.8-1.73.22-5.57 1-6.8 2.66zm-21.75-7.98c-.22-.05-.44-.07-.66-.07-3.65 0-6.7 5.87-7.05 6.58-.84 2.43-.43 31.82 4.06 34.82 3.14 2.09 13.21 10.57 22.1 18.05 5.75 4.84 11.19 9.42 12.24 10.12 1.03.69 2.54.81 3.92.31 1.27-.47 2.18-1.34 2.49-2.4 1.65-5.64 0-31.59-.04-32.22-.84-9.88-32.44-34.27-37.06-35.19z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M808.42 544.55c-2.49-1.25-4.49-9.88-2.14-19.26.82-3.3 2.88-7.19 4.07-9.29-3.77-.12-7.01-1.66-8.8-3.45-1.38-1.38-1.94-2.92-1.58-4.36.07-.3.16-.67.25-1.09 1-4.38 3.32-14.63 12.06-15.51 4.68-.47 8.15-1.19 10.34-1.75h.01c-15.45-5.96-42.92-23.44-43.8-27.87-.21-1.07.02-2.11.67-2.99 1.21-1.62 3.67-2.51 5.65-2.99-.68-.38-1.16-.66-1.42-.81h-.01c-8.08-.23-14.86-1.58-20.33-4.05 9.13 5.83 30.54 23.58 34.42 33.71.03.08.06.16.09.25.1.28.19.56.26.83.03.1.06.2.08.29.08.35.14.69.17 1.01v.02c.08 1.1 1.73 26.91-.03 32.92-.5 1.68-1.85 3.03-3.73 3.72-.8.29-1.62.43-2.42.43-1.2 0-2.34-.32-3.29-.95-1.14-.77-6.12-4.96-12.42-10.26-8.41-7.08-18.87-15.89-21.92-17.92-1.97-1.31-3.24-5.55-4.04-10.74v24.28c.29-1.1.67-2 1.15-2.65 2.59-3.43 8.92.69 15.05 4.68 1.7 1.12 3.32 2.17 4.74 2.98 3.8 2.17 11.47 7.58 17.24 11.73 4.15 2.99 6.92 7.59 7.62 12.62.33 2.38.49 4.44.49 6.2 0 3.89-.81 6.29-2.44 7.27-.9.54-2.53.77-4.65.77-10.15 0-31.3-5.17-34-5.94-2.88-.83-4.41-2.51-5.2-4.68v12.19c2.85-1.51 9.18-1.41 19.63-.67 6.59.47 13.42 1.7 17.99 2.65 5.96 1.23 10.48 6.05 11.25 11.98.32 2.53.49 4.88.49 7.05 0 7.61-1.99 13.05-5.93 16.2-3.56 2.85-16.26 3.7-26.93 3.7-7.73 0-14.4-.44-15.74-.89-.22-.08-.48-.17-.76-.55v5.29c3.76-1.12 13.95-2.02 30.36-2.7.21-.01.42-.01.63-.01 3.98 0 7.73 1.52 10.61 4.31a15.05 15.05 0 0 1 4.46 8.9l.76-.93c-.91-17.66 10.25-33.64 13.08-37.39-3.06-1.42-4.7-4.24-5.2-5.73-.79-2.39 3.46-14.38 5.79-20.64-.65.18-1.23.27-1.71.27-.37 0-.68-.06-.92-.18zm28.67-78.95c7.48-10.89 6.85-23.52 6.29-28.18 0 0 .01.01 0 .02-5.35 11.43-22.53 15.29-48.52 17.4-2.43.19-4.77.31-7.02.34 10.28 5.6 41.68 21.44 49.25 10.42z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M756.31 544.45c7.52 2.15 33.34 7.63 37.07 5.39.56-.34 2.29-2.16 1-11.49-.62-4.49-3.1-8.6-6.81-11.26-5.73-4.13-13.34-9.5-17.06-11.62-1.48-.84-3.11-1.91-4.85-3.04-3.57-2.33-8.66-5.65-11.15-5.65-.53 0-.94.15-1.2.49-1.94 2.6-1.75 12.29-1.62 18.71.03 1.63.06 3.16.06 4.47 0 .8-.01 1.59-.02 2.37-.09 6.57.07 10.34 4.58 11.63zm56.44-28.57c-.79 1.31-3.58 6.13-4.53 9.9-2.3 9.18.08 16.44 1.09 16.98.39.1 1.34-.14 2.65-.67.01-.03.03-.07.04-.1l.11.04c3.73-1.51 10.16-5.2 14.53-9.64 5.22-5.31 10.58-13.47 12.54-16.55v-.02c1.15-4.47 1.96-10.62 2.58-15.92-5.55 3.73-21.4 14.17-27.37 15.67-.55.14-1.1.24-1.64.31zm30.96-35.3c-2.21 6.88-6.47 10.67-12.74 11.24-.16.01-.33.02-.51.02-1.18 0-2.75-.32-4.59-.88h-.01c-1.09.39-5.58 1.83-13.37 2.61-7.3.73-9.33 9.67-10.31 13.97-.1.43-.18.81-.26 1.13-.25.98.55 1.96 1.05 2.46 2.08 2.08 6.51 3.6 10.94 2.49 6.22-1.56 24.89-14.13 28.16-16.35v-.01c.18-1.59.34-3.04.48-4.27l1.16-12.41zm-94.27 3.86v24.31c.24.9.42 1.93.56 3.04.14-1.13.32-2.16.56-3.07v-24.28c-.22-1.44-.41-2.95-.56-4.49-.15 1.54-.34 3.05-.56 4.49z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.UpperStomach.includes(this.state.bodyTitles) || female_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M749.73 532.79c.01-.77.02-1.55.02-2.34 0-1.3-.03-2.81-.06-4.43-.09-4.68-.2-10.07.31-14.23-.14-1.11-.32-2.14-.56-3.04v32.95c.25-.68.43-1.42.56-2.19-.34-2.05-.3-4.36-.27-6.72zm.13-74.99c.04-.07.08-.16.14-.27-.13-.26-.32-.61-.56-1.01v5.97c.08-2.58.24-4.33.42-4.69zm-.42 12.97v13.67c.22-1.44.41-2.95.56-4.49-.3-3.05-.48-6.22-.56-9.18z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M755.76 546.38c2.7.77 23.85 5.94 34 5.94 2.12 0 3.75-.23 4.65-.77 1.63-.98 2.44-3.38 2.44-7.27 0-1.76-.16-3.82-.49-6.2-.7-5.03-3.47-9.63-7.62-12.62-5.77-4.15-13.44-9.56-17.24-11.73-1.42-.81-3.04-1.86-4.74-2.98-6.13-3.99-12.46-8.11-15.05-4.68-.48.65-.86 1.55-1.15 2.65v32.98c.79 2.17 2.32 3.85 5.2 4.68zm-4.07-20.4c-.13-6.42-.32-16.11 1.62-18.71.26-.34.67-.49 1.2-.49 2.49 0 7.58 3.32 11.15 5.65 1.74 1.13 3.37 2.2 4.85 3.04 3.72 2.12 11.33 7.49 17.06 11.62 3.71 2.66 6.19 6.77 6.81 11.26 1.29 9.33-.44 11.15-1 11.49-3.73 2.24-29.55-3.24-37.07-5.39-4.51-1.29-4.67-5.06-4.58-11.63.01-.78.02-1.57.02-2.37 0-1.31-.03-2.84-.06-4.47zM750 511.79c.51 4.16.4 9.55.31 14.22-.04 1.63-.07 3.14-.07 4.44 0 .79.02 1.57.03 2.34.03 2.36.06 4.67-.27 6.72.12.77.3 1.51.56 2.19v-32.98c-.24.91-.42 1.94-.56 3.07z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M750.27 532.79c-.01-.77-.03-1.55-.03-2.34 0-1.3.03-2.81.07-4.44.09-4.67.2-10.06-.31-14.22-.51 4.16-.4 9.55-.31 14.23.03 1.62.06 3.13.06 4.43 0 .79-.01 1.57-.02 2.34-.03 2.36-.07 4.67.27 6.72.33-2.05.3-4.36.27-6.72zm-.83-62.02v-8.28c-.08 2.26-.09 5.15 0 8.28zm10.31-20.54c-4.3-.87-7.7 3.78-9.19 6.29v5.97c.08 2.26.09 5.15 0 8.28v13.67c.8 5.19 2.07 9.43 4.04 10.74 3.05 2.03 13.51 10.84 21.92 17.92 6.3 5.3 11.28 9.49 12.42 10.26.95.63 2.09.95 3.29.95.8 0 1.62-.14 2.42-.43 1.88-.69 3.23-2.04 3.73-3.72 1.76-6.01.11-31.82.03-32.92v-.02c-.03-.33-.09-.67-.17-1.01-.02-.1-.06-.2-.08-.29-.07-.27-.15-.55-.26-.83-.03-.08-.06-.16-.09-.25-4.62-11.92-33.9-33.78-38.06-34.61zm36.71 69.37c-.31 1.06-1.22 1.93-2.49 2.4-1.38.5-2.89.38-3.92-.31-1.05-.7-6.49-5.28-12.24-10.12-8.89-7.48-18.96-15.96-22.1-18.05-4.49-3-4.9-32.39-4.06-34.82.35-.71 3.4-6.58 7.05-6.58.22 0 .44.02.66.07 4.62.92 36.22 25.31 37.06 35.19.04.63 1.69 26.58.04 32.22zm1.78-33.4z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M797.9 485.08c.1.28.18.56.26.83-.07-.27-.15-.55-.26-.83zm-47.34-28.56c1.49-2.51 4.89-7.16 9.19-6.29 4.15.83 33.44 22.7 38.06 34.61-3.88-10.13-25.29-27.88-34.42-33.71-1.25-.56-2.43-1.19-3.54-1.87-.03-.01-.07-.03-.1-.03-4.3-.87-7.7 4.78-9.19 7.29zm47.6 29.39zm-.35-1.08c.03.08.07.16.09.25-.03-.08-.06-.16-.09-.25zm-47.25-22.34v-5.97c-.24.4-.43.75-.56 1.01.06.11.1.2.14.27.18.36.34 2.11.42 4.69zm-.56 17.46c.15 1.54.34 3.05.56 4.49v-13.67c-.08 2.96-.26 6.13-.56 9.18zm.56-17.46v8.28c.09-3.13.08-6.02 0-8.28z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.44 462.49v8.28c.08 2.96.26 6.13.56 9.18.3-3.05.48-6.22.56-9.18v-8.28c-.08-2.58-.24-4.33-.42-4.69-.04-.07-.08-.16-.14-.27-.06.11-.1.2-.14.27-.18.36-.34 2.11-.42 4.69zm38.6-7 .19 1.99c-.09.01-.2.02-.31.03 8.43 4.55 27.12 13.8 39.88 13.8 4.75 0 8.68-1.29 10.95-4.58 1.97-2.87 3.4-5.83 4.44-8.73-.06-.88-.1-1.41-.1-1.44l.6-.05 1.29-5.32c.12-.65.22-1.29.3-1.92.24-2.17.37-4.37.43-6.47-.01-4.38-.6-7.36-.66-7.65l-.85.18c-.23.74-.51 1.42-.83 2.09.56 4.67 1.19 17.3-6.29 28.18-7.58 11.02-38.97-4.82-49.25-10.42h-.01c-.55.02-1.1.02-1.64.02-.84 0-1.65-.01-2.46-.03.26.15.74.43 1.42.81 1.44-.33 2.63-.46 2.9-.49z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M843.99 456.49c-.1.35-.2.69-.3 1.03l-.22-.35c-.09.28-.18.55-.28.83.2 3.11.57 10.62-.1 15.97-1.25 10.03-5.28 15.22-12.3 15.86-.17.02-.34.02-.52.02-10.58 0-48.58-24.76-49.47-28.28-.1-.52 0-.97.32-1.4 1.23-1.66 5.07-2.44 6.81-2.65-1.11-.6-2.05-1.12-2.77-1.53-1.98.48-4.44 1.37-5.65 2.99-.65.88-.89 1.91-.67 2.99.89 4.43 28.36 21.91 43.8 27.87 1.8-.46 2.73-.82 2.75-.82l.72 1.86c-.02.01-.1.04-.24.09 1.84.56 3.41.88 4.59.88.18 0 .35-.01.51-.02 6.27-.57 10.53-4.35 12.74-11.24l.28-2.98.02 2.01c.46-1.64.82-3.43 1.06-5.39.33-2.65.41-6.49.38-10.29-.09-4.04-.35-7.29-.37-7.53l-1.09.08z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M845.08 456.4c.02.24.29 3.48.37 7.53-.05-5.68-.35-11.25-.43-12.54-.26 1.78-.59 3.51-1.03 5.1l1.09-.09zm-42.12 54.74c-.5-.5-1.3-1.48-1.05-2.46.08-.32.16-.7.26-1.13.98-4.3 3.01-13.24 10.31-13.97 7.79-.78 12.28-2.22 13.37-2.61h.01c-1-.31-2.08-.69-3.23-1.13h-.01c-2.19.56-5.66 1.28-10.34 1.75-8.74.88-11.06 11.13-12.06 15.51-.09.42-.18.79-.25 1.09-.36 1.44.2 2.98 1.58 4.36 1.79 1.79 5.03 3.33 8.8 3.45.51-.89.87-1.45.91-1.53l1.7 1.06c-.01.01-.08.13-.21.35.54-.07 1.09-.17 1.64-.31 5.97-1.5 21.82-11.94 27.37-15.67v-.01c.1-.9.2-1.77.3-2.61-3.27 2.22-21.94 14.79-28.16 16.35-4.43 1.11-8.86-.41-10.94-2.49z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M825.38 489.02c-.02 0-.95.36-2.75.82 1.15.44 2.23.82 3.23 1.13.14-.05.22-.08.24-.09l-.72-1.86zm-13.27 53.01 1.75.67c-.12.3-.23.61-.34.91 4.51-1.9 10.69-5.91 14.54-9.82 3.36-3.42 6.71-7.88 9.25-11.52v-.01c.29-1.32.63-2.56 1.05-3.7.29-.8.57-1.72.82-2.72-1.96 3.08-7.32 11.24-12.54 16.55-4.37 4.44-10.8 8.13-14.53 9.64zm-2.8.73c-1.01-.54-3.39-7.8-1.09-16.98.95-3.77 3.74-8.59 4.53-9.9-.66.09-1.3.13-1.93.13-.16 0-.32 0-.47-.01-1.19 2.1-3.25 5.99-4.07 9.29-2.35 9.38-.35 18.01 2.14 19.26.24.12.55.18.93.18.48 0 1.06-.09 1.71-.27.35-.93.66-1.74.9-2.37-1.31.53-2.26.77-2.65.67z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M812.75 515.88c.13-.22.2-.34.21-.35l-1.7-1.06c-.04.08-.4.64-.91 1.53.15.01.31.01.47.01.63 0 1.27-.04 1.93-.13zm-156.39-25.49 1.09 4.01.04-1.05c-.47-4.05-.79-5.96-1.13-2.96z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m656.53 481.33-.17 9.06c.33-2.99.66-1.09 1.14 2.96l.37-8.97c-.5-.93-.95-1.95-1.34-3.05z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M656.53 481.33c.39 1.1.83 2.12 1.33 3.05l.07-1.76-1.4-1.29zm187.18-.75c.1-.32.21-.64.3-.98l-.02-2.01-.28 2.99z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-lungs",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Lungs");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Lungs");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "478",
	              width: "115",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 81)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.59342 0 0 .7655 304.301 271.982)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Lungs" ? "#f58220" : "#af9763"
	                },
	                d: "M1120.014 427.414v-25.56h5.184v21.204h12.96v4.356h-18.144ZM1154.1 427.414v-2.808a7.358 7.358 0 0 1-2.664 2.376 7.625 7.625 0 0 1-3.528.864c-1.26 0-2.376-.288-3.384-.828-.972-.576-1.692-1.332-2.16-2.34-.432-.972-.648-2.376-.648-4.104V408.73h4.932v8.604c0 2.628.108 4.212.288 4.824a2.77 2.77 0 0 0 .972 1.404c.504.324 1.08.504 1.836.504.828 0 1.584-.216 2.268-.684.684-.468 1.116-1.044 1.368-1.728.252-.684.36-2.376.36-5.04v-7.884h4.968v18.684h-4.608ZM1180.77 427.414h-4.932v-9.54c0-2.016-.108-3.312-.324-3.888a2.551 2.551 0 0 0-1.008-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.684.468-1.116 1.116-1.368 1.872s-.396 2.196-.396 4.284v8.46h-4.932V408.73h4.572v2.772c1.62-2.124 3.672-3.168 6.156-3.168 1.08 0 2.088.18 2.988.576.9.396 1.584.9 2.052 1.512.468.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592ZM1185.336 428.638l5.652.684c.072.648.288 1.116.648 1.368.468.36 1.188.504 2.196.504 1.296 0 2.268-.18 2.916-.576.432-.252.756-.648.972-1.224.18-.432.252-1.188.252-2.268v-2.736c-1.476 2.016-3.348 3.024-5.616 3.024-2.484 0-4.464-1.044-5.94-3.168-1.152-1.692-1.728-3.78-1.728-6.264 0-3.132.756-5.544 2.268-7.164 1.512-1.656 3.384-2.484 5.616-2.484 2.304 0 4.212 1.008 5.688 3.024v-2.628h4.644v16.776c0 2.196-.18 3.852-.54 4.932-.36 1.08-.9 1.944-1.548 2.556-.648.648-1.512 1.116-2.628 1.476-1.08.36-2.484.504-4.14.504-3.168 0-5.4-.54-6.732-1.62-1.332-1.08-1.98-2.448-1.98-4.104v-.612Zm4.428-10.944c0 1.98.36 3.42 1.152 4.356.756.9 1.692 1.368 2.808 1.368 1.224 0 2.232-.468 3.06-1.404.864-.936 1.26-2.34 1.26-4.212 0-1.908-.396-3.348-1.188-4.284-.792-.936-1.8-1.404-3.024-1.404-1.188 0-2.16.432-2.916 1.368-.792.936-1.152 2.34-1.152 4.212ZM1206.03 422.086l4.968-.756c.216.972.648 1.692 1.296 2.196.648.504 1.548.756 2.7.756 1.26 0 2.232-.252 2.88-.72.432-.324.648-.756.648-1.332 0-.36-.108-.684-.36-.9-.216-.252-.792-.468-1.656-.684-3.96-.864-6.48-1.656-7.56-2.376-1.476-1.008-2.232-2.412-2.232-4.212 0-1.62.648-2.988 1.944-4.068 1.26-1.116 3.24-1.656 5.94-1.656 2.556 0 4.428.396 5.688 1.224 1.224.864 2.088 2.088 2.556 3.708l-4.644.864c-.216-.72-.576-1.296-1.152-1.692-.54-.36-1.332-.576-2.376-.576-1.296 0-2.232.18-2.772.54-.396.288-.576.612-.576 1.008 0 .36.144.648.504.9.432.324 1.98.792 4.608 1.404 2.628.576 4.464 1.332 5.508 2.196 1.008.864 1.548 2.088 1.548 3.672 0 1.692-.72 3.168-2.16 4.392-1.404 1.26-3.528 1.872-6.336 1.872-2.556 0-4.572-.54-6.048-1.548-1.476-1.044-2.448-2.448-2.916-4.212Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-liver is_right",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Liver");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Liver");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "290",
	              y: "513",
	              width: "95",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-887.13 -16.272)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.61389 0 0 -.7655 2109.27 697.33)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Liver" ? "#f58220" : "#af9763"
	                },
	                d: "M1183.357 563.563v-25.56h5.184v21.204h12.96v4.356h-18.144ZM1205.167 542.359v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM1220.279 563.563l-7.524-18.684h5.184l3.528 9.54 1.008 3.168c.288-.792.468-1.332.54-1.584.144-.54.324-1.044.504-1.584l3.564-9.54h5.076l-7.416 18.684h-4.464ZM1245.987 557.623l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1259.923 563.563h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-spine is_right",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Spine");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Spine");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "280",
	              y: "569",
	              width: "105",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-887.13 36.48)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.70597 0 0 -.7655 2231.84 700.45)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Spine" ? "#f58220" : "#af9763"
	                },
	                d: "m1171.805 555.175 5.076-.504c.288 1.728.9 2.952 1.836 3.744.936.828 2.196 1.224 3.78 1.224 1.692 0 2.952-.36 3.78-1.08.864-.72 1.296-1.548 1.296-2.484 0-.612-.18-1.116-.54-1.548-.36-.432-1.008-.792-1.872-1.116-.612-.216-2.016-.612-4.176-1.116-2.772-.72-4.752-1.548-5.868-2.556-1.584-1.44-2.376-3.168-2.376-5.184 0-1.332.36-2.556 1.116-3.708a6.992 6.992 0 0 1 3.204-2.592c1.404-.612 3.096-.9 5.076-.9 3.24 0 5.688.72 7.308 2.124 1.656 1.404 2.484 3.312 2.592 5.688l-5.22.216c-.216-1.332-.684-2.268-1.44-2.844-.72-.576-1.836-.864-3.276-.864-1.512 0-2.7.288-3.564.9-.54.432-.828.936-.828 1.62 0 .612.252 1.116.792 1.548.648.576 2.232 1.152 4.752 1.728 2.556.612 4.428 1.224 5.616 1.872a7.188 7.188 0 0 1 2.88 2.592c.684 1.116 1.008 2.484 1.008 4.14 0 1.476-.396 2.844-1.224 4.14-.828 1.296-1.98 2.232-3.492 2.88-1.476.612-3.348.936-5.58.936-3.276 0-5.76-.756-7.524-2.268-1.728-1.512-2.772-3.708-3.132-6.588ZM1196.967 544.879h4.608v2.772a6.741 6.741 0 0 1 2.412-2.304 6.86 6.86 0 0 1 3.384-.864c2.196 0 4.032.828 5.544 2.556 1.512 1.692 2.268 4.032 2.268 7.092 0 3.096-.756 5.544-2.304 7.272-1.512 1.728-3.348 2.592-5.544 2.592a6.39 6.39 0 0 1-2.772-.612c-.864-.432-1.728-1.116-2.664-2.124v9.396h-4.932v-25.776Zm4.896 9.036c0 2.088.396 3.636 1.224 4.644s1.872 1.512 3.06 1.512c1.152 0 2.088-.468 2.844-1.368.792-.936 1.152-2.448 1.152-4.536 0-1.98-.396-3.42-1.188-4.356-.756-.972-1.728-1.44-2.916-1.44s-2.196.468-2.988 1.404c-.792.936-1.188 2.304-1.188 4.14ZM1219.101 542.359v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM1246.057 563.563h-4.932v-9.54c0-2.016-.108-3.312-.324-3.888a2.551 2.551 0 0 0-1.008-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.684.468-1.116 1.116-1.368 1.872s-.396 2.196-.396 4.284v8.46h-4.932v-18.684h4.572v2.772c1.62-2.124 3.672-3.168 6.156-3.168 1.08 0 2.088.18 2.988.576.9.396 1.584.9 2.052 1.512.468.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592ZM1261.891 557.623l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-kidney",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Kidney");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Kidney");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "589",
	              width: "145",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 193.214)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.61389 0 0 .7655 277.063 271.876)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Kidney" ? "#f58220" : "#af9763"
	                },
	                d: "M1120.013 427.414v-25.776h5.184v11.448l10.512-11.448h7.02l-9.72 10.044 10.224 15.732h-6.732l-7.092-12.096-4.213 4.32v7.776h-5.183ZM1145.895 406.21v-4.572h4.931v4.572h-4.931Zm0 21.204V408.73h4.931v18.684h-4.931ZM1173.005 427.414h-4.573v-2.736c-.755 1.044-1.656 1.872-2.7 2.376-1.043.504-2.087.792-3.131.792-2.16 0-3.997-.864-5.509-2.592-1.548-1.728-2.303-4.14-2.303-7.236 0-3.168.755-5.58 2.232-7.236 1.476-1.62 3.384-2.448 5.651-2.448 2.089 0 3.889.864 5.4 2.592v-9.288h4.933v25.776Zm-13.177-9.756c0 2.016.289 3.456.829 4.356.792 1.26 1.908 1.908 3.348 1.908 1.115 0 2.087-.468 2.88-1.44.828-.972 1.224-2.412 1.224-4.32 0-2.16-.396-3.708-1.188-4.644-.756-.936-1.764-1.404-2.953-1.404-1.188 0-2.16.468-2.952 1.404-.792.9-1.188 2.304-1.188 4.14ZM1194.85 427.414h-4.931v-9.54c0-2.016-.109-3.312-.325-3.888a2.551 2.551 0 0 0-1.007-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.685.468-1.117 1.116-1.369 1.872-.251.756-.395 2.196-.395 4.284v8.46h-4.932V408.73h4.572v2.772c1.62-2.124 3.671-3.168 6.156-3.168 1.08 0 2.088.18 2.987.576.9.396 1.584.9 2.053 1.512.467.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592ZM1210.685 421.474l4.932.828c-.649 1.8-1.657 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.225-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.375 4.644 2.303 8.424h-12.383c.036 1.476.432 2.628 1.224 3.42.755.828 1.691 1.224 2.843 1.224.757 0 1.405-.216 1.945-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1217.564 408.73h5.256l4.465 13.284 4.355-13.284h5.112l-6.587 17.964-1.188 3.276c-.433 1.08-.829 1.908-1.225 2.484a5.653 5.653 0 0 1-1.368 1.404 5.273 5.273 0 0 1-1.871.828c-.756.216-1.584.288-2.52.288-.937 0-1.872-.072-2.808-.288l-.432-3.852c.792.144 1.476.216 2.088.216 1.152 0 2.016-.324 2.556-1.008.54-.684.972-1.548 1.26-2.592l-7.092-18.72ZM1238.16 422.086l4.968-.756c.216.972.649 1.692 1.297 2.196.648.504 1.548.756 2.7.756 1.26 0 2.231-.252 2.88-.72.431-.324.647-.756.647-1.332 0-.36-.108-.684-.36-.9-.216-.252-.792-.468-1.655-.684-3.96-.864-6.48-1.656-7.56-2.376-1.476-1.008-2.233-2.412-2.233-4.212 0-1.62.649-2.988 1.944-4.068 1.26-1.116 3.24-1.656 5.94-1.656 2.556 0 4.428.396 5.688 1.224 1.225.864 2.089 2.088 2.557 3.708l-4.644.864c-.216-.72-.576-1.296-1.152-1.692-.54-.36-1.332-.576-2.376-.576-1.296 0-2.232.18-2.773.54-.396.288-.576.612-.576 1.008 0 .36.144.648.505.9.431.324 1.98.792 4.607 1.404 2.628.576 4.464 1.332 5.508 2.196 1.009.864 1.549 2.088 1.549 3.672 0 1.692-.72 3.168-2.16 4.392-1.405 1.26-3.529 1.872-6.337 1.872-2.555 0-4.572-.54-6.048-1.548-1.476-1.044-2.447-2.448-2.916-4.212Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Lower_Abdomen" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Lower Back,Stomach,Reproductive System");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Lower Back,Stomach,Reproductive System");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.LowerStomach.includes(this.state.bodyTitles) || female_human_body.LowerStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M749.44 688.24v-79.09c-.8 14.65-.61 46.1 0 79.09zm-.93-87.78c-2.44-.65-9.45-1.69-29.51-2.51-.19-.01-.38-.01-.56-.01-3.46 0-6.71 1.32-9.21 3.75a13.04 13.04 0 0 0-4 9.63c.1 7.7.5 18.68 1.86 27.26 2.61 16.55 10.57 42.21 14.9 52.6 1.92 4.6 4.75 14.69 7.74 25.37 3.49 12.45 7.83 27.95 9.66 29.78 2.19 2.19 6.97 1.06 9.46.14-.14-4.83-1.12-38.45-1.63-71.95-.86-57.15.22-70.59 1.29-74.06z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.LowerStomach.includes(this.state.bodyTitles) || female_human_body.LowerStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M743.22 749.59c-1.92 0-3.85-.45-5.25-1.85-2.04-2.04-5.2-12.94-10.17-30.65-2.97-10.62-5.78-20.65-7.65-25.14-4.48-10.74-12.36-36.12-15.03-53.05-1.38-8.71-1.79-19.79-1.89-27.55l-.77-1.26c-.28 2.76-.86 5.55-1.83 8.33-.2.56-.67.94-1.31 1.03-.09.01-.19.02-.29.02-4.15 0-17.94-10.67-23.29-18.15-2.9-4.05-7.63-12.6-11.02-18.95-.15 1.47-.3 2.81-.43 3.98-.37 3.38-3.14 10.09-6.46 17.64-.08 5.52.11 20.9 4.28 29.93 3.37 7.3 16.74 26.88 27.48 42.62 6.08 8.89 11.32 16.57 13.84 20.67 1.36 2.21 3.1 6.41 5.03 11.83 0 .01.01.02.02.04.71 1.38 17.95 35 20.53 40.15 2.06 4.13 8.55 11.44 10.98 14.1 2.88-1 7.37-1 9.45-.94v-14.01c-1.35.48-3.79 1.21-6.22 1.21z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m748.89 747.69-.02-.63c0-.03-.01-.23-.02-.59-2.49.92-7.27 2.05-9.46-.14-1.83-1.83-6.17-17.33-9.66-29.78-2.99-10.68-5.82-20.77-7.74-25.37-4.33-10.39-12.29-36.05-14.9-52.6-1.36-8.58-1.76-19.56-1.86-27.26a13.04 13.04 0 0 1 4-9.63c2.5-2.43 5.75-3.75 9.21-3.75.18 0 .37 0 .56.01 20.06.82 27.07 1.86 29.51 2.51.3-.99.6-1.17.85-1.32a.3.3 0 0 1 .08-.04v-.45c-3.76-1.12-13.95-2.02-30.36-2.7-4.23-.16-8.22 1.36-11.24 4.3a15.034 15.034 0 0 0-4.43 8.68l.22.22-.4 2.2c.1 7.76.51 18.84 1.89 27.55 2.67 16.93 10.55 42.31 15.03 53.05 1.87 4.49 4.68 14.52 7.65 25.14 4.97 17.71 8.13 28.61 10.17 30.65 1.4 1.4 3.33 1.85 5.25 1.85 2.43 0 4.87-.73 6.22-1.21v-.44l-.55-.25z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.LowerStomach.includes(this.state.bodyTitles) || female_human_body.LowerStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M750.56 609.14v79.07c.61-32.99.8-64.43 0-79.07zm2.21 65.38c-.5 33.47-1.48 67.07-1.63 71.94 2.49.93 7.28 2.06 9.47-.13 1.82-1.83 6.17-17.32 9.66-29.78 2.99-10.68 5.82-20.77 7.73-25.37 4.34-10.39 12.29-36.05 14.91-52.6 1.35-8.58 1.76-19.56 1.86-27.26.04-3.66-1.38-7.08-4-9.63-2.63-2.56-6.11-3.88-9.77-3.74-12.05.49-19.39 1.07-23.86 1.58-2.97.35-4.68.67-5.65.93 1.06 3.47 2.14 16.91 1.28 74.06z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.LowerStomach.includes(this.state.bodyTitles) || female_human_body.LowerStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M800.96 619.47c-.1 0-.19-.01-.28-.02-.64-.09-1.12-.47-1.32-1.03a36.36 36.36 0 0 1-1.83-8.32l-.76 1.25c-.11 7.76-.51 18.85-1.89 27.55-2.67 16.94-10.56 42.31-15.03 53.05-1.87 4.49-4.68 14.52-7.66 25.14-4.96 17.71-8.12 28.61-10.16 30.65-1.4 1.4-3.33 1.85-5.25 1.85-2.44 0-4.87-.72-6.22-1.21v14.02c2.07-.07 6.57-.07 9.45.93 2.42-2.66 8.91-9.97 10.98-14.1 2.56-5.12 19.64-38.41 20.51-40.12.02-.04.04-.06.04-.07 1.92-5.42 3.65-9.62 5.02-11.83 2.52-4.1 7.77-11.77 13.84-20.67 10.74-15.74 24.12-35.32 27.49-42.62 4.16-9.03 4.36-24.39 4.27-29.92.01-.01.01-.01 0-.02-3.32-7.55-6.08-14.25-6.45-17.63-.13-1.17-.28-2.51-.43-3.97-3.4 6.35-8.12 14.89-11.02 18.94-5.36 7.48-19.14 18.15-23.3 18.15zm-50.4-10.33c-.15-2.75-.34-4.91-.56-6.37-.22 1.46-.41 3.62-.56 6.38v79.09c.16 8.83.35 17.76.56 26.51.21-8.76.4-17.71.56-26.54v-79.07zM750 748.17c-.16.06-.34.13-.56.21v14.01c.21.01.39.01.55.02h.02c.15 0 .34-.01.55-.01v-14.02c-.22-.08-.4-.15-.56-.21z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: female_human_body.LowerStomach.includes(this.state.bodyTitles) || female_human_body.LowerStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M750.56 609.14c.8 14.64.61 46.08 0 79.07v48.17c.09 3.41.19 6.74.29 9.98.09.04.19.07.29.1.15-4.87 1.13-38.47 1.63-71.94.86-57.15-.22-70.59-1.28-74.06-.45.12-.74.22-.93.32v8.36zm0-8.36c-.02 0-.04.01-.06.02-.18.33-.35.99-.5 1.97.22 1.46.41 3.62.56 6.37v-8.36zm-1.12 147.16v.44c.22-.08.4-.15.56-.21-.3-.12-.48-.2-.53-.22l-.03-.01zm.56-33.19c.17 7.4.36 14.67.56 21.63v-48.17c-.16 8.83-.35 17.78-.56 26.54zm-.56-116.1v.45c.15-.09.34-.17.56-.25-.17-.07-.35-.13-.56-.2z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.44 609.15v-8.37c-.19-.1-.48-.2-.93-.32-1.07 3.47-2.15 16.91-1.29 74.06.51 33.5 1.49 67.12 1.63 71.95.1-.04.2-.07.29-.11.1-3.36.2-6.81.3-10.35v-47.77c-.61-32.99-.8-64.44 0-79.09z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M748.85 746.47c.01.36.02.56.02.59l.02.63.55.25v-11.93c-.1 3.54-.2 6.99-.3 10.35-.09.04-.19.07-.29.11zm.59-147.37a.3.3 0 0 0-.08.04c-.25.15-.55.33-.85 1.32.45.12.74.22.93.32v-1.68zm47.18 10.05c-.44-3.38-1.97-6.48-4.46-8.9-2.88-2.79-6.63-4.31-10.61-4.31-.21 0-.42 0-.63.01-16.41.68-26.6 1.58-30.36 2.7v.45a.3.3 0 0 1 .08.04c.25.15.55.33.85 1.32.97-.26 2.68-.58 5.65-.93 4.47-.51 11.81-1.09 23.86-1.58 3.66-.14 7.14 1.18 9.77 3.74 2.62 2.55 4.04 5.97 4 9.63-.1 7.7-.51 18.68-1.86 27.26-2.62 16.55-10.57 42.21-14.91 52.6-1.91 4.6-4.74 14.69-7.73 25.37-3.49 12.46-7.84 27.95-9.66 29.78-2.19 2.19-6.98 1.06-9.47.13-.01.37-.02.57-.02.6l-.02.63-.54.25v.44c1.35.49 3.78 1.21 6.22 1.21 1.92 0 3.85-.45 5.25-1.85 2.04-2.04 5.2-12.94 10.16-30.65 2.98-10.62 5.79-20.65 7.66-25.14 4.47-10.74 12.36-36.11 15.03-53.05 1.38-8.7 1.78-19.79 1.89-27.55l-.4-1.89.25-.31zm-46.09 138.8-.53.22c.16.06.34.13.56.21v-.44l-.03.01zm.03-148.85v-.45c-.21.07-.4.13-.56.2.22.08.41.16.56.25zm-.56 3.67c-.15-.97-.32-1.64-.5-1.97-.02-.01-.04-.02-.06-.02v8.37c.15-2.76.34-4.92.56-6.38zm-.56 133.24c.19-6.85.38-13.99.56-21.26-.21-8.75-.4-17.68-.56-26.51v47.77z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M750.56 736.38v11.56l.54-.25.02-.63c0-.03.01-.23.02-.6-.1-.03-.2-.06-.29-.1-.1-3.24-.2-6.57-.29-9.98zm.93-135.92c-.3-.99-.6-1.17-.85-1.32a.3.3 0 0 0-.08-.04v1.68c.19-.1.48-.2.93-.32zm-.93 147.48v-11.56c-.2-6.96-.39-14.23-.56-21.63-.18 7.27-.37 14.41-.56 21.26v11.93l.03.01c.05.02.23.1.53.22l.53-.22.03-.01zm-1.12-148.84v1.68c.02 0 .04.01.06.02.18.33.35 1 .5 1.97.15-.98.32-1.64.5-1.97.02-.01.04-.02.06-.02v-1.68c-.15-.09-.34-.17-.56-.25-.22.08-.41.16-.56.25z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m796.37 609.46.4 1.89c.01-.74-.05-1.48-.15-2.2l-.25.31z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-lower_back is_right",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Lower Back");
	              },
	              className: "labelArea",
	              x: "175",
	              y: "627",
	              width: "210",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-887.13 95.455)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.70597 0 0 -.7655 2231.84 697.33)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Lower Back" ? "#f58220" : "#af9763"
	                },
	                d: "M1068.126 563.563v-25.56h5.184v21.204h12.96v4.356h-18.144ZM1088.784 553.951c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM1115.382 563.563l-5.904-18.684h4.824l3.492 12.24 3.204-12.24h4.788l3.096 12.24 3.564-12.24h4.86l-5.976 18.684h-4.752l-3.204-11.988-3.168 11.988h-4.824ZM1150.736 557.623l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1164.672 563.563h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM1184.002 537.787h10.296c2.052 0 3.564.108 4.572.252 1.008.18 1.908.54 2.7 1.08.792.54 1.44 1.26 1.98 2.16.504.9.792 1.872.792 2.988 0 1.224-.324 2.34-.972 3.348-.648 1.008-1.548 1.764-2.664 2.268 1.584.432 2.772 1.224 3.636 2.34.828 1.08 1.26 2.376 1.26 3.852 0 1.188-.288 2.34-.828 3.42-.54 1.116-1.296 2.016-2.232 2.664-.936.684-2.088 1.08-3.492 1.224-.864.108-2.952.144-6.264.18h-8.784v-25.776Zm5.22 4.284v5.976h3.42c2.016 0 3.276-.036 3.744-.108.9-.108 1.62-.396 2.124-.9s.756-1.188.756-2.016c0-.792-.216-1.44-.648-1.944-.432-.504-1.116-.792-1.98-.9-.504-.072-1.98-.108-4.428-.108h-2.988Zm0 10.26v6.876h4.824c1.872 0 3.06-.036 3.564-.144.756-.144 1.404-.468 1.872-1.044.504-.54.72-1.26.72-2.16 0-.792-.18-1.44-.54-1.98-.396-.54-.936-.936-1.62-1.188-.72-.252-2.268-.36-4.644-.36h-4.176ZM1213.638 550.603l-4.464-.828c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.624 3.996c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1246.258 550.423l-4.86.864c-.18-.972-.54-1.692-1.116-2.196-.576-.504-1.332-.72-2.268-.72-1.224 0-2.232.396-2.952 1.26-.72.864-1.08 2.268-1.08 4.248 0 2.232.36 3.78 1.116 4.716.72.9 1.728 1.368 2.988 1.368.936 0 1.692-.288 2.304-.792.576-.54 1.008-1.476 1.26-2.772l4.86.828c-.504 2.232-1.476 3.924-2.916 5.04-1.44 1.152-3.348 1.728-5.724 1.728-2.736 0-4.932-.864-6.552-2.592-1.62-1.728-2.412-4.104-2.412-7.164 0-3.06.792-5.472 2.412-7.2 1.656-1.692 3.852-2.556 6.624-2.556 2.268 0 4.068.468 5.436 1.44 1.332 1.008 2.304 2.484 2.88 4.5ZM1249.826 563.563v-25.776h4.932v13.68l5.796-6.588h6.084l-6.408 6.84 6.84 11.844h-5.328l-4.68-8.388-2.304 2.412v5.976h-4.932Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-stomach",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Stomach");
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "648",
	              width: "160",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 253.338)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.63435 0 0 .7655 249.825 268.088)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Stomach" ? "#f58220" : "#af9763"
	                },
	                d: "m1119.997 419.026 5.076-.504c.288 1.728.9 2.952 1.836 3.744.936.828 2.196 1.224 3.78 1.224 1.692 0 2.952-.36 3.78-1.08.864-.72 1.296-1.548 1.296-2.484 0-.612-.18-1.116-.54-1.548-.36-.432-1.008-.792-1.872-1.116-.612-.216-2.016-.612-4.176-1.116-2.772-.72-4.752-1.548-5.868-2.556-1.584-1.44-2.376-3.168-2.376-5.184 0-1.332.36-2.556 1.116-3.708a6.992 6.992 0 0 1 3.204-2.592c1.404-.612 3.096-.9 5.076-.9 3.24 0 5.688.72 7.308 2.124 1.656 1.404 2.484 3.312 2.592 5.688l-5.22.216c-.216-1.332-.684-2.268-1.44-2.844-.72-.576-1.836-.864-3.276-.864-1.512 0-2.7.288-3.564.9-.54.432-.828.936-.828 1.62 0 .612.252 1.116.792 1.548.648.576 2.232 1.152 4.752 1.728 2.556.612 4.428 1.224 5.616 1.872a7.188 7.188 0 0 1 2.88 2.592c.684 1.116 1.008 2.484 1.008 4.14 0 1.476-.396 2.844-1.224 4.14-.828 1.296-1.98 2.232-3.492 2.88-1.476.612-3.348.936-5.58.936-3.276 0-5.76-.756-7.524-2.268-1.728-1.512-2.772-3.708-3.132-6.588ZM1153.871 408.73v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384ZM1156.141 417.802c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM1178.923 408.73h4.536v2.556c1.62-1.98 3.564-2.952 5.832-2.952 1.188 0 2.232.252 3.096.72.864.504 1.584 1.26 2.16 2.232.828-.972 1.692-1.728 2.664-2.232a6.683 6.683 0 0 1 3.024-.72c1.368 0 2.556.252 3.492.828.936.54 1.656 1.368 2.124 2.448.324.792.504 2.088.504 3.852v11.952h-4.932v-10.656c0-1.872-.18-3.06-.504-3.6-.468-.72-1.152-1.044-2.124-1.044-.684 0-1.332.216-1.944.612-.612.432-1.044 1.044-1.332 1.872-.252.792-.396 2.088-.396 3.852v8.964h-4.932V417.19c0-1.836-.072-2.988-.252-3.528-.18-.504-.468-.9-.828-1.188-.36-.252-.864-.36-1.512-.36-.756 0-1.44.18-2.052.612-.612.396-1.044 1.008-1.296 1.764-.288.792-.396 2.052-.396 3.852v9.072h-4.932V408.73ZM1214.965 414.454l-4.464-.828c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.624 3.996c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1247.585 414.274l-4.86.864c-.18-.972-.54-1.692-1.116-2.196-.576-.504-1.332-.72-2.268-.72-1.224 0-2.232.396-2.952 1.26-.72.864-1.08 2.268-1.08 4.248 0 2.232.36 3.78 1.116 4.716.72.9 1.728 1.368 2.988 1.368.936 0 1.692-.288 2.304-.792.576-.54 1.008-1.476 1.26-2.772l4.86.828c-.504 2.232-1.476 3.924-2.916 5.04-1.44 1.152-3.348 1.728-5.724 1.728-2.736 0-4.932-.864-6.552-2.592-1.62-1.728-2.412-4.104-2.412-7.164 0-3.06.792-5.472 2.412-7.2 1.656-1.692 3.852-2.556 6.624-2.556 2.268 0 4.068.468 5.436 1.44 1.332 1.008 2.304 2.484 2.88 4.5ZM1256.23 401.638v9.468c1.62-1.836 3.527-2.772 5.723-2.772 1.152 0 2.16.216 3.096.612.9.432 1.584.972 2.052 1.62.468.648.792 1.404.936 2.196.18.792.252 2.016.252 3.708v10.944h-4.932v-9.864c0-1.944-.072-3.204-.288-3.708-.18-.54-.504-.972-.972-1.26-.468-.324-1.08-.468-1.8-.468-.792 0-1.548.18-2.196.576-.648.396-1.116 1.008-1.404 1.8-.288.828-.468 2.016-.468 3.564v9.36h-4.932v-25.776h4.932Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              className: "labelGroup labelGroup-rep_system is_right",
	              transform: "translate(0 -25)"
	            },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Reproductive System");
	              },
	              className: "labelArea",
	              x: "145",
	              y: "678",
	              width: "240",
	              height: "83",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-887.13 148.208)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.67528 0 0 -.7655 2190.99 719.496)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Reproductive System" ? "#f58220" : "#af9763"
	                },
	                d: "M1041.104 563.563v-25.776h10.944c2.772 0 4.788.252 6.012.684 1.26.468 2.268 1.296 2.988 2.484.756 1.188 1.152 2.556 1.152 4.068 0 1.944-.576 3.528-1.728 4.788-1.116 1.26-2.808 2.052-5.076 2.376 1.116.648 2.052 1.368 2.772 2.16.72.792 1.728 2.196 2.952 4.176l3.168 5.04h-6.228l-3.78-5.616c-1.332-1.98-2.232-3.276-2.736-3.78a4.326 4.326 0 0 0-1.548-1.08c-.54-.18-1.44-.288-2.628-.288h-1.044v10.764h-5.22Zm5.22-14.868h3.852c2.484 0 4.032-.108 4.68-.324a2.901 2.901 0 0 0 1.44-1.08c.36-.504.54-1.152.54-1.944 0-.864-.252-1.548-.72-2.088-.432-.54-1.116-.864-1.944-1.008-.432-.072-1.692-.108-3.78-.108h-4.068v6.552ZM1077.861 557.623l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1086.947 544.879h4.608v2.772a6.741 6.741 0 0 1 2.412-2.304 6.86 6.86 0 0 1 3.384-.864c2.196 0 4.032.828 5.544 2.556 1.512 1.692 2.268 4.032 2.268 7.092 0 3.096-.756 5.544-2.304 7.272-1.512 1.728-3.348 2.592-5.544 2.592a6.39 6.39 0 0 1-2.772-.612c-.864-.432-1.728-1.116-2.664-2.124v9.396h-4.932v-25.776Zm4.896 9.036c0 2.088.396 3.636 1.224 4.644s1.872 1.512 3.06 1.512c1.152 0 2.088-.468 2.844-1.368.792-.936 1.152-2.448 1.152-4.536 0-1.98-.396-3.42-1.188-4.356-.756-.972-1.728-1.44-2.916-1.44s-2.196.468-2.988 1.404c-.792.936-1.188 2.304-1.188 4.14ZM1113.797 563.563h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM1121.939 553.951c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM1162.181 563.563h-4.572v-2.736c-.756 1.044-1.656 1.872-2.7 2.376-1.044.504-2.088.792-3.132.792-2.16 0-3.996-.864-5.508-2.592-1.548-1.728-2.304-4.14-2.304-7.236 0-3.168.756-5.58 2.232-7.236 1.476-1.62 3.384-2.448 5.652-2.448 2.088 0 3.888.864 5.4 2.592v-9.288h4.932v25.776Zm-13.176-9.756c0 2.016.288 3.456.828 4.356.792 1.26 1.908 1.908 3.348 1.908 1.116 0 2.088-.468 2.88-1.44.828-.972 1.224-2.412 1.224-4.32 0-2.16-.396-3.708-1.188-4.644-.756-.936-1.764-1.404-2.952-1.404s-2.16.468-2.952 1.404c-.792.9-1.188 2.304-1.188 4.14ZM1179.347 563.563v-2.808a7.358 7.358 0 0 1-2.664 2.376 7.625 7.625 0 0 1-3.528.864c-1.26 0-2.376-.288-3.384-.828-.972-.576-1.692-1.332-2.16-2.34-.432-.972-.648-2.376-.648-4.104v-11.844h4.932v8.604c0 2.628.108 4.212.288 4.824a2.77 2.77 0 0 0 .972 1.404c.504.324 1.08.504 1.836.504.828 0 1.584-.216 2.268-.684.684-.468 1.116-1.044 1.368-1.728.252-.684.36-2.376.36-5.04v-7.884h4.968v18.684h-4.608ZM1205.333 550.423l-4.86.864c-.18-.972-.54-1.692-1.116-2.196-.576-.504-1.332-.72-2.268-.72-1.224 0-2.232.396-2.952 1.26-.72.864-1.08 2.268-1.08 4.248 0 2.232.36 3.78 1.116 4.716.72.9 1.728 1.368 2.988 1.368.936 0 1.692-.288 2.304-.792.576-.54 1.008-1.476 1.26-2.772l4.86.828c-.504 2.232-1.476 3.924-2.916 5.04-1.44 1.152-3.348 1.728-5.724 1.728-2.736 0-4.932-.864-6.552-2.592-1.62-1.728-2.412-4.104-2.412-7.164 0-3.06.792-5.472 2.412-7.2 1.656-1.692 3.852-2.556 6.624-2.556 2.268 0 4.068.468 5.436 1.44 1.332 1.008 2.304 2.484 2.88 4.5ZM1217.649 544.879v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384ZM1221.071 542.359v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM1236.183 563.563l-7.524-18.684h5.184l3.528 9.54 1.008 3.168c.288-.792.468-1.332.54-1.584.144-.54.324-1.044.504-1.584l3.564-9.54h5.076l-7.416 18.684h-4.464ZM1261.891 557.623l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1121.725 592.353l5.076-.504c.288 1.728.9 2.952 1.836 3.744.936.828 2.196 1.224 3.78 1.224 1.692 0 2.952-.36 3.78-1.08.864-.72 1.296-1.548 1.296-2.484 0-.612-.18-1.116-.54-1.548-.36-.432-1.008-.792-1.872-1.116-.612-.216-2.016-.612-4.176-1.116-2.772-.72-4.752-1.548-5.868-2.556-1.584-1.44-2.376-3.168-2.376-5.184 0-1.332.36-2.556 1.116-3.708a6.992 6.992 0 0 1 3.204-2.592c1.404-.612 3.096-.9 5.076-.9 3.24 0 5.688.72 7.308 2.124 1.656 1.404 2.484 3.312 2.592 5.688l-5.22.216c-.216-1.332-.684-2.268-1.44-2.844-.72-.576-1.836-.864-3.276-.864-1.512 0-2.7.288-3.564.9-.54.432-.828.936-.828 1.62 0 .612.252 1.116.792 1.548.648.576 2.232 1.152 4.752 1.728 2.556.612 4.428 1.224 5.616 1.872a7.188 7.188 0 0 1 2.88 2.592c.684 1.116 1.008 2.484 1.008 4.14 0 1.476-.396 2.844-1.224 4.14-.828 1.296-1.98 2.232-3.492 2.88-1.476.612-3.348.936-5.58.936-3.276 0-5.76-.756-7.524-2.268-1.728-1.512-2.772-3.708-3.132-6.588ZM1144.691 582.057h5.256l4.464 13.284 4.356-13.284h5.112l-6.588 17.964-1.188 3.276c-.432 1.08-.828 1.908-1.224 2.484a5.653 5.653 0 0 1-1.368 1.404 5.273 5.273 0 0 1-1.872.828c-.756.216-1.584.288-2.52.288-.936 0-1.872-.072-2.808-.288l-.432-3.852c.792.144 1.476.216 2.088.216 1.152 0 2.016-.324 2.556-1.008.54-.684.972-1.548 1.26-2.592l-7.092-18.72ZM1165.287 595.413l4.968-.756c.216.972.648 1.692 1.296 2.196.648.504 1.548.756 2.7.756 1.26 0 2.232-.252 2.88-.72.432-.324.648-.756.648-1.332 0-.36-.108-.684-.36-.9-.216-.252-.792-.468-1.656-.684-3.96-.864-6.48-1.656-7.56-2.376-1.476-1.008-2.232-2.412-2.232-4.212 0-1.62.648-2.988 1.944-4.068 1.26-1.116 3.24-1.656 5.94-1.656 2.556 0 4.428.396 5.688 1.224 1.224.864 2.088 2.088 2.556 3.708l-4.644.864c-.216-.72-.576-1.296-1.152-1.692-.54-.36-1.332-.576-2.376-.576-1.296 0-2.232.18-2.772.54-.396.288-.576.612-.576 1.008 0 .36.144.648.504.9.432.324 1.98.792 4.608 1.404 2.628.576 4.464 1.332 5.508 2.196 1.008.864 1.548 2.088 1.548 3.672 0 1.692-.72 3.168-2.16 4.392-1.404 1.26-3.528 1.872-6.336 1.872-2.556 0-4.572-.54-6.048-1.548-1.476-1.044-2.448-2.448-2.916-4.212ZM1195.639 582.057v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384ZM1209.861 594.801l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1218.721 582.057h4.536v2.556c1.62-1.98 3.564-2.952 5.832-2.952 1.188 0 2.232.252 3.096.72.864.504 1.584 1.26 2.16 2.232.828-.972 1.692-1.728 2.664-2.232a6.683 6.683 0 0 1 3.024-.72c1.368 0 2.556.252 3.492.828.936.54 1.656 1.368 2.124 2.448.324.792.504 2.088.504 3.852v11.952h-4.932v-10.656c0-1.872-.18-3.06-.504-3.6-.468-.72-1.152-1.044-2.124-1.044-.684 0-1.332.216-1.944.612-.612.432-1.044 1.044-1.332 1.872-.252.792-.396 2.088-.396 3.852v8.964h-4.932v-10.224c0-1.836-.072-2.988-.252-3.528-.18-.504-.468-.9-.828-1.188-.36-.252-.864-.36-1.512-.36-.756 0-1.44.18-2.052.612-.612.396-1.044 1.008-1.296 1.764-.288.792-.396 2.052-.396 3.852v9.072h-4.932v-18.684ZM1249.327 595.413l4.968-.756c.216.972.648 1.692 1.296 2.196.648.504 1.548.756 2.7.756 1.26 0 2.232-.252 2.88-.72.432-.324.648-.756.648-1.332 0-.36-.108-.684-.36-.9-.216-.252-.792-.468-1.656-.684-3.96-.864-6.48-1.656-7.56-2.376-1.476-1.008-2.232-2.412-2.232-4.212 0-1.62.648-2.988 1.944-4.068 1.26-1.116 3.24-1.656 5.94-1.656 2.556 0 4.428.396 5.688 1.224 1.224.864 2.088 2.088 2.556 3.708l-4.644.864c-.216-.72-.576-1.296-1.152-1.692-.54-.36-1.332-.576-2.376-.576-1.296 0-2.232.18-2.772.54-.396.288-.576.612-.576 1.008 0 .36.144.648.504.9.432.324 1.98.792 4.608 1.404 2.628.576 4.464 1.332 5.508 2.196 1.008.864 1.548 2.088 1.548 3.672 0 1.692-.72 3.168-2.16 4.392-1.404 1.26-3.528 1.872-6.336 1.872-2.556 0-4.572-.54-6.048-1.548-1.476-1.044-2.448-2.448-2.916-4.212Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper" },
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-hip", transform: "translate(0 -15)" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Hip");
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "738",
	              width: "65",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 80.915)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.45018 0 0 .7655 494.968 528.935)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Hip" ? "#f58220" : "#af9763"
	                },
	                d: "M1119.993 688.05v-25.776h5.22v10.152h10.188v-10.152h5.22v25.776h-5.22v-11.268h-10.188v11.268h-5.22ZM1145.947 666.846v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM1155.813 669.366h4.608v2.772a6.741 6.741 0 0 1 2.412-2.304 6.86 6.86 0 0 1 3.384-.864c2.196 0 4.032.828 5.544 2.556 1.512 1.692 2.268 4.032 2.268 7.092 0 3.096-.756 5.544-2.304 7.272-1.512 1.728-3.348 2.592-5.544 2.592a6.39 6.39 0 0 1-2.772-.612c-.864-.432-1.728-1.116-2.664-2.124v9.396h-4.932v-25.776Zm4.896 9.036c0 2.088.396 3.636 1.224 4.644s1.872 1.512 3.06 1.512c1.152 0 2.088-.468 2.844-1.368.792-.936 1.152-2.448 1.152-4.536 0-1.98-.396-3.42-1.188-4.356-.756-.972-1.728-1.44-2.916-1.44s-2.196.468-2.988 1.404c-.792.936-1.188 2.304-1.188 4.14Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper" },
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-skin is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalFemaleBodySingleContentOpen(e, "Skin");
	              },
	              className: "labelArea",
	              x: "300",
	              y: "1026",
	              width: "85",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 166.144)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M762.407 191.303H1331.1",
	                transform: "matrix(-.45018 0 0 -.7655 1004.24 1030.38)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Skin" ? "#f58220" : "#af9763"
	                },
	                d: "m307.654 884.649 5.076-.504c.288 1.728.9 2.952 1.836 3.744.936.828 2.196 1.224 3.78 1.224 1.692 0 2.952-.36 3.78-1.08.864-.72 1.296-1.548 1.296-2.484 0-.612-.18-1.116-.54-1.548-.36-.432-1.008-.792-1.872-1.116-.612-.216-2.016-.612-4.176-1.116-2.772-.72-4.752-1.548-5.868-2.556-1.584-1.44-2.376-3.168-2.376-5.184 0-1.332.36-2.556 1.116-3.708a6.992 6.992 0 0 1 3.204-2.592c1.404-.612 3.096-.9 5.076-.9 3.24 0 5.688.72 7.308 2.124 1.656 1.404 2.484 3.312 2.592 5.688l-5.22.216c-.216-1.332-.684-2.268-1.44-2.844-.72-.576-1.836-.864-3.276-.864-1.512 0-2.7.288-3.564.9-.54.432-.828.936-.828 1.62 0 .612.252 1.116.792 1.548.648.576 2.232 1.152 4.752 1.728 2.556.612 4.428 1.224 5.616 1.872a7.188 7.188 0 0 1 2.88 2.592c.684 1.116 1.008 2.484 1.008 4.14 0 1.476-.396 2.844-1.224 4.14-.828 1.296-1.98 2.232-3.492 2.88-1.476.612-3.348.936-5.58.936-3.276 0-5.76-.756-7.524-2.268-1.728-1.512-2.772-3.708-3.132-6.588ZM332.78 893.037v-25.776h4.932v13.68l5.796-6.588h6.084l-6.408 6.84 6.84 11.844h-5.328l-4.68-8.388-2.304 2.412v5.976h-4.932ZM352.98 871.833v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM379.936 893.037h-4.932v-9.54c0-2.016-.108-3.312-.324-3.888a2.551 2.551 0 0 0-1.008-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.684.468-1.116 1.116-1.368 1.872s-.396 2.196-.396 4.284v8.46h-4.932v-18.684h4.572v2.772c1.62-2.124 3.672-3.168 6.156-3.168 1.08 0 2.088.18 2.988.576.9.396 1.584.9 2.052 1.512.468.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592Z"
	              })
	            )
	          )
	        )
	      );
	
	      var MaleBodySVGReactElement = _react2.default.createElement(
	        "svg",
	        {
	          xmlns: "http://www.w3.org/2000/svg",
	          className: "humanMaleBodyImg",
	          viewBox: _reactDeviceDetect.isMobile ? "151 80 1150 1529" : "140 10 1450 1500",
	          xmlSpace: "preserve",
	          "max-width": "3000px",
	          width: "100%"
	        },
	        _react2.default.createElement(
	          "style",
	          null,
	          ".bodyParts{\
	            fill:#AF9763;\
	            cursor: pointer;\
	          }\
	          .bodyLines{\
	            fill:#f2f2f2;\
	          }\
	          .syzst2{\
	            fill:none;\
	          }\
	          .labelLine {\
	            fill: none;\
	            stroke: #b3b3b3;\
	            stroke-width: 2;\
	            pointer-events: none;\
	          }\
	          .labelText {\
	            // fill: #af9763;\
	            fill-rule: nonzero;\
	            transform: translateX(10px);\
	            transition: all 0.3s ease;\
	          }\
	          .labelGroup .labelText {\
	            transform: translateX(-5px);\
	          }\
	          .labelGroup.is_right .labelText {\
	            transform: translateX(-10px);\
	          }\
	          .labelArea {\
	            fill: transparent;\
	            cursor: pointer;\
	          }\
	          .bodyParts_wrapper .labelGroup, .bodyParts_wrapper .labelGroup-sub{\
	            transform: all 0.2s ease;\
	          }\
	          .bodyParts_wrapper .labelLine, .bodyParts_wrapper .labelText {\
	          pointer-events: none; }\
	          .bodyParts_wrapper.hovered .labelGroup, .bodyParts_wrapper.hovered .labelGroup-sub {\
	            opacity: 0.3;\
	          }\
	          .bodyParts_wrapper .labelGroup:hover, .bodyParts_wrapper .labelGroup-sub:hover, .bodyPartsGroup:hover ~ .labelGroup {\
	            opacity: 1;\
	          }\
	          .bodyParts_wrapper:hover .bodyParts {\
	            fill: #f58220;\
	            cursor: pointer;\
	          }\
	          .bodyPartsGroup:hover ~ .labelGroup .labelText, .labelGroup:hover .labelText {\
	      fill: #f58220;\
	      transform: translateX(0px);\
	      .bodyParts_group:hover .bodyParts {\
	        fill: #f58220;\
	      }\
	      .bodyParts_group:hover .labelGroup .labelText {\
	        fill: #f58220;\
	        transform: translateX(0px);\
	      }\
	    }\
	"
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Head" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Brain,Ear,Teeth,Nose,Eye");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Brain,Ear,Teeth,Nose,Eye");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.Head.includes(this.state.bodyTitles) || male_human_body.Head.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M803.5 131.12c-3.8-14.89-14.97-36.94-50.42-39.44 0 0-.97-.1-2.68-.12h-.01c-1.86-.44-3.47.12-3.47.12-35.45 2.5-46.62 24.55-50.42 39.44-4.4 17.23-9.97 81.53-2.98 99.85 1.96 5.16 5.58 11.43 10.14 17.56.1.14.21.28.31.41l1.21.48c3.91 2.76 16.48 11.73 18.2 14.17v.01c10.76 9.89 23.07 12.86 26.53 13.52.08.02.17.03.25.05.3-.05.7-.13 1.16-.23 4.42-.96 15.86-4.18 25.82-13.34 1.71-2.44 14.3-11.41 18.21-14.18l.7-.5c.1-.13.2-.27.3-.4 4.55-6.13 8.18-12.4 10.14-17.55 6.99-18.32 1.41-82.62-2.99-99.85z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-brain" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Brain");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Brain");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "88",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 -86.756)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.69574 0 0 .7655 168.111 48.213)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Brain" ? "#f58220" : "#af9763"
	                },
	                d: "M1119.993 181.552h10.296c2.052 0 3.564.108 4.572.252 1.008.18 1.908.54 2.7 1.08.792.54 1.44 1.26 1.98 2.16.504.9.792 1.872.792 2.988 0 1.224-.324 2.34-.972 3.348-.648 1.008-1.548 1.764-2.664 2.268 1.584.432 2.772 1.224 3.636 2.34.828 1.08 1.26 2.376 1.26 3.852 0 1.188-.288 2.34-.828 3.42-.54 1.116-1.296 2.016-2.232 2.664-.936.684-2.088 1.08-3.492 1.224-.864.108-2.952.144-6.264.18h-8.784v-25.776Zm5.22 4.284v5.976h3.42c2.016 0 3.276-.036 3.744-.108.9-.108 1.62-.396 2.124-.9s.756-1.188.756-2.016c0-.792-.216-1.44-.648-1.944-.432-.504-1.116-.792-1.98-.9-.504-.072-1.98-.108-4.428-.108h-2.988Zm0 10.26v6.876h4.824c1.872 0 3.06-.036 3.564-.144.756-.144 1.404-.468 1.872-1.044.504-.54.72-1.26.72-2.16 0-.792-.18-1.44-.54-1.98-.396-.54-.936-.936-1.62-1.188-.72-.252-2.268-.36-4.644-.36h-4.176ZM1150.663 207.328h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM1163.63 194.368l-4.465-.828c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.623 3.996c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1179.987 186.124v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM1206.943 207.328h-4.932v-9.54c0-2.016-.108-3.312-.324-3.888a2.551 2.551 0 0 0-1.008-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.684.468-1.116 1.116-1.368 1.872s-.396 2.196-.396 4.284v8.46h-4.932v-18.684h4.572v2.772c1.62-2.124 3.672-3.168 6.156-3.168 1.08 0 2.088.18 2.988.576.9.396 1.584.9 2.052 1.512.468.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-eye is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Eye");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Eye");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "315",
	              y: "143",
	              width: "70",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-823.163 -141.006)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.63435 0 0 -.7655 2072.54 448.667)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Eye" ? "#f58220" : "#af9763"
	                },
	                d: "M1143.123 314.9v-25.777h19.116v4.356h-13.932v5.724h12.96v4.356h-12.96v6.984h14.4v4.356h-19.584ZM1164.767 296.215h5.256l4.464 13.284 4.356-13.284h5.112l-6.588 17.964-1.188 3.276c-.432 1.08-.828 1.908-1.224 2.484a5.653 5.653 0 0 1-1.368 1.404 5.273 5.273 0 0 1-1.872.828c-.756.216-1.584.288-2.52.288-.936 0-1.872-.072-2.808-.288l-.432-3.852c.792.144 1.476.216 2.088.216 1.152 0 2.016-.324 2.556-1.008.54-.684.972-1.548 1.26-2.592l-7.092-18.72ZM1197.927 308.96l4.932.827c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.005c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-ear" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Ear");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Ear");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "156",
	              width: "65",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 -18)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.5832 0 0 .7655 317.921 48.213)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Ear" ? "#f58220" : "#af9763"
	                },
	                d: "M1120.01 207.328v-25.776h19.117v4.356h-13.932v5.724h12.96v4.356h-12.96v6.984h14.4v4.356h-19.584ZM1147.657 194.368l-4.464-.828c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.624 3.996c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1168.72 207.328h-4.931v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-nose is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Nose");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Nose");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "290",
	              y: "197",
	              width: "95",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-823.163 -85.302)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.70597 0 0 -.7655 2167.88 448.667)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Nose" ? "#f58220" : "#af9763"
	                },
	                d: "M1119.19 314.9v-25.777h5.075l10.548 17.208v-17.208h4.824V314.9h-5.22l-10.404-16.812V314.9h-4.824ZM1143.965 305.287c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM1165.343 309.571l4.968-.756c.216.972.648 1.692 1.296 2.196.648.504 1.548.756 2.7.756 1.26 0 2.232-.252 2.88-.72.432-.324.648-.756.648-1.332 0-.36-.108-.684-.36-.9-.216-.252-.792-.468-1.656-.684-3.96-.864-6.48-1.656-7.56-2.376-1.476-1.008-2.232-2.412-2.232-4.212 0-1.62.648-2.988 1.944-4.068 1.26-1.116 3.24-1.656 5.94-1.656 2.556 0 4.428.396 5.688 1.224 1.224.864 2.088 2.088 2.556 3.708l-4.644.864c-.216-.72-.576-1.296-1.152-1.692-.54-.36-1.332-.576-2.376-.576-1.296 0-2.232.18-2.772.54-.396.288-.576.612-.576 1.008 0 .36.144.648.504.9.432.324 1.98.792 4.608 1.404 2.628.576 4.464 1.332 5.508 2.196 1.008.864 1.548 2.088 1.548 3.672 0 1.692-.72 3.168-2.16 4.392-1.404 1.26-3.528 1.872-6.336 1.872-2.556 0-4.572-.54-6.048-1.548-1.476-1.044-2.448-2.448-2.916-4.212ZM1197.927 308.96l4.932.827c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.005c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-teeth" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Teeth");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Teeth");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "225",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 51.69)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.67528 0 0 .7655 195.349 48.213)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Teeth" ? "#f58220" : "#af9763"
	                },
	                d: "M1127.652 207.328v-21.42h-7.668v-4.356h20.485v4.356h-7.633v21.42h-5.184ZM1151.93 201.388l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.937-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1171.96 201.388l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.937-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1189.748 188.644v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384ZM1198.066 181.552v9.468c1.62-1.836 3.528-2.772 5.724-2.772 1.152 0 2.16.216 3.096.612.9.432 1.584.972 2.052 1.62.468.648.792 1.404.936 2.196.18.792.252 2.016.252 3.708v10.944h-4.932v-9.864c0-1.944-.072-3.204-.288-3.708-.18-.54-.504-.972-.972-1.26-.468-.324-1.08-.468-1.8-.468-.792 0-1.548.18-2.196.576-.648.396-1.116 1.008-1.404 1.8-.288.828-.468 2.016-.468 3.564v9.36h-4.932v-25.776h4.932Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Neck" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Throat");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Throat");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.91 277.21c.07-.01.15-.03.25-.04-.07-.01-.16-.03-.25-.05v.09zm.69 2.06.02-.15c-.18.03-.33.06-.46.08.23.04.38.06.44.07zm102.35 35.52c0-.01 0-.03.01-.04-.67-.11-1.34-.21-1.98-.3 0 .01 0 .03-.01.04.56.08 1.14.17 1.72.26.08.01.17.03.26.04zm-45.9-3.76c-.08-1.29-.16-2.4-.24-3.24l-1.99-.81.09 1.02c.39.58.78 1.15 1.17 1.7.33.46.65.89.97 1.33zM749.9 279.2v-.04c-.07-.01-.14-.02-.22-.04l.02.15c.03 0 .1-.01.2-.03v-.04zm.71-.08c.2-.04.44-.08.71-.13v-2.06c-.47.1-.86.18-1.16.23.44.08.69.12.71.12l-.26 1.84zm-.71.04v.08c.07-.01.15-.02.25-.04-.07-.01-.16-.03-.25-.04z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.91 277.21c-.29.05-.46.07-.47.08l.24 1.83c.08.01.15.03.22.04l.01-1.95z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.9 279.16c.09.02.18.03.25.04.13-.02.28-.05.46-.08l.25-1.84c-.02 0-.26-.04-.71-.12-.09.02-.17.03-.25.04v1.96z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.91 277.21v-.09c-3.45-.67-15.77-3.64-26.53-13.52l.13.21c.14.27.59 1.54 1.31 3.65 10.61 8.53 21.64 11.07 24.86 11.66l-.24-1.83c.01-.01.18-.03.47-.08zm1.41 1.78c3.94-.79 14.4-3.51 24.38-11.53.72-2.11 1.17-3.38 1.31-3.65.03-.06.07-.13.12-.2l.01-.01c-9.97 9.16-21.4 12.38-25.82 13.34v2.05z"
	            }),
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "m804.82 306.98.09 1.02c.39.58.78 1.15 1.17 1.7.32.46.65.89.97 1.33-.08-1.29-.16-2.4-.24-3.24l-1.99-.81z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M662.71 322.33c3.7.6 7.64.52 11.71-.23 5.14-.95 9.77-3.48 13.41-7.31 4.1-4.33 9.5-11.89 12.82-18.92v-.18c-.09.06-.17.12-.25.18h-.01c-10.34 7.22-32.79 16.24-41.41 17.32-2.58.32-5.69.69-9.2 1.19.66 2.01 3.21 6.37 12.93 7.95z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M736.88 347.37c.37.09.72.21 1.06.34 1.93.57 6.36 1.67 11.88 1.78l.08-70.24c-.1.01-.17.02-.2.03l-.02-.15c-3.22-.59-14.25-3.12-24.86-11.66v.01c2.75 8.04 9.32 28.23 16.91 51.52 3.31 10.19 5.93 18.24 6.86 21.03 1.11 3.3.86 5.34-.74 6.06-.32.14-.67.21-1.05.21-3.03 0-7.58-4.42-10.25-9.09-1.03-1.81-2.5-4.17-4.21-6.9-3.6-5.77-8.22-13.17-12.86-21.87-1.08 1.91-3.5 6.04-6.07 9.48-3.62 4.86-15.06 14.67-18.37 14.67-.05 0-.09 0-.13-.01-.55-.05-.99-.34-1.22-.8-.89-1.78.11-14.72.73-21.84 0 0 0 .01-.01.01-1.78 2.4-3.55 4.54-5.14 6.22-3.93 4.15-8.94 6.88-14.5 7.91-2.39.44-4.73.66-7.02.66-1.83 0-3.62-.14-5.37-.43-11.15-1.8-13.93-7.13-14.62-9.62-.15.02-.3.04-.46.07-9.14 1.41-20.52 3.81-32.07 8.74-.16.07-.33.15-.49.22 11.36 1.99 44.7 7.8 60.12 12.67 18.81 5.94 27.95 8.98 28.04 9.01l-.05.15c14.31-1.12 26.74 0 34.03 1.82z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M696.63 306.79c-.91 9.86-1.57 21.35-1.22 23.73 2.48-.7 12.53-8.62 16.4-13.81 3.3-4.43 6.48-10.25 6.51-10.3l.15.08c-3.41-6.51-6.79-13.72-9.74-21.49-.57-1.51-1.71-4.64-2.62-8.43.2 6.37.17 11.73-.44 13.88-.1.36-.31.74-.57 1.14.01-.01.02-.01.02-.02-1.67 4.38-5.52 10.84-8.49 15.22zm37.41 22.45c1.71 2.75 3.2 5.12 4.25 6.97 3.09 5.4 7.64 8.54 8.75 8.04.15-.07.56-.89-.34-3.6-.94-2.8-3.56-10.85-6.87-21.04-6.93-21.28-17.4-53.43-18.11-54.91-.62-1.11-8.27-6.93-15.89-12.37.73 6.84 3.06 27.5 4.76 31.95 7.22 18.97 16.99 34.61 23.45 44.96zm17.17 15.52-.01 4.73c3.46-.04 7.28-.48 11.16-1.69.41-.17.83-.31 1.28-.43 7.29-1.82 19.71-2.94 34.01-1.84l-.05-.14c.09-.03 9.24-3.07 28.05-9.01 15.94-5.03 49.02-11.07 59.18-12.86-.02-.01-.05-.02-.07-.03-11.44-4.88-22.73-7.28-31.82-8.7-.24 1.74-2.02 7.45-14.81 9.51-1.74.29-3.54.43-5.37.43-2.28 0-4.63-.22-7.01-.66-5.56-1.03-10.58-3.76-14.51-7.91-1.27-1.35-2.71-3.12-4.19-5.13.41 6.93.67 18.98-.21 20.74-.23.46-.67.75-1.22.8-.04 0-.09.01-.13.01-3.3 0-14.74-9.81-18.36-14.67-2.57-3.44-4.99-7.57-6.07-9.48-4.65 8.71-9.27 16.11-12.87 21.87-1.7 2.73-3.17 5.09-4.21 6.9-2.67 4.67-7.22 9.09-10.24 9.09-.38 0-.73-.07-1.06-.21-.58-.27-.98-.71-1.2-1.32v-.04c-.28-.76-.28-1.79 0-3.05v-.04c.11-.51.26-1.02.46-1.61.93-2.79 3.54-10.8 6.84-20.95 7.59-23.33 14.18-43.54 16.93-51.6v-.01c-9.98 8.01-20.44 10.74-24.38 11.53l-.11 62.64v3.13z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M753.83 340.65c-.9 2.71-.5 3.53-.34 3.6 1.1.5 5.66-2.64 8.75-8.04 1.05-1.85 2.53-4.22 4.25-6.97 6.46-10.35 16.22-25.99 23.45-44.96 1.69-4.45 4.02-25.11 4.76-31.95-7.62 5.44-15.27 11.26-15.9 12.38-.71 1.47-11.19 33.67-18.13 54.98-3.3 10.15-5.91 18.17-6.84 20.96zm28.24-34.17.14-.07c.03.06 3.2 5.88 6.51 10.3 3.88 5.2 13.93 13.12 16.4 13.82.34-2.32.62-12.76-.21-22.52-.24-.35-.47-.7-.71-1.06-2.71-4.13-5.32-8.78-7.11-13.01-.14-.12-.29-.24-.42-.36-.01 0-.01-.01-.01-.01-1.24-1.14-2.06-2.19-2.32-3.11-.68-2.41-.64-8.86-.35-16.24-.73 4.83-1.5 8.98-2.18 10.79-2.96 7.75-6.34 14.96-9.74 21.47z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M826.11 322.1c4.07.75 8 .83 11.7.23 11.76-1.9 13.03-6.91 13.15-7.84-.08-.01-.17-.03-.26-.04-3.71-.54-6.99-.92-9.69-1.26-8.39-1.05-29.87-9.62-40.55-16.74 3.46 6.98 8.6 14.53 12.22 18.34 3.65 3.83 8.29 6.36 13.43 7.31zm-74.91 27.39.01-4.73v-3.13l.11-62.64c-.26.05-.5.1-.71.13l-.02.15c-.05-.01-.21-.03-.44-.07-.1.02-.18.03-.25.04l-.08 70.24c.46.01.91.01 1.38.01z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m718.46 306.49 1.61.88c-.03.06-.24.45-.59 1.06 4.64 8.7 9.26 16.1 12.86 21.87 1.71 2.73 3.18 5.09 4.21 6.9 2.67 4.67 7.22 9.09 10.25 9.09.38 0 .73-.07 1.05-.21 1.6-.72 1.85-2.76.74-6.06-.93-2.79-3.55-10.84-6.86-21.03-7.59-23.29-14.16-43.48-16.91-51.52v-.01c-.97-.78-1.93-1.6-2.88-2.48l1.36-1.47c.03.03.06.05.09.08v-.01c-1.72-2.44-14.29-11.41-18.2-14.17l-1.21-.48c.27.37.54.73.83 1.1.23 5.64.77 13.96 1.11 21.66v.03c0 .01 0 .03.01.04.07 1.64.14 3.25.18 4.8.91 3.79 2.05 6.91 2.62 8.43 2.94 7.78 6.32 14.99 9.73 21.5zm-12.63-54.16c7.62 5.44 15.27 11.26 15.89 12.37.71 1.48 11.18 33.63 18.11 54.91 3.31 10.19 5.93 18.24 6.87 21.04.9 2.71.49 3.53.34 3.6-1.11.5-5.66-2.64-8.75-8.04-1.05-1.85-2.54-4.22-4.25-6.97-6.46-10.35-16.23-25.99-23.45-44.96-1.7-4.45-4.03-25.11-4.76-31.95zm-43.44 71.97c1.75.29 3.54.43 5.37.43 2.29 0 4.63-.22 7.02-.66 5.56-1.03 10.57-3.76 14.5-7.91 1.59-1.68 3.36-3.82 5.14-6.22 0 0 0-.01.01-.01.11-1.26.21-2.34.29-3.14l1.99-.81c-.03.27-.05.54-.07.81 2.97-4.39 6.82-10.84 8.48-15.23-.01.01-.02.01-.02.02-.34.52-.8 1.06-1.38 1.62l-.01.01c-.81.78-1.85 1.61-3.05 2.47v.18c-3.32 7.03-8.72 14.59-12.82 18.92-3.64 3.83-8.27 6.36-13.41 7.31-4.07.75-8.01.83-11.71.23-9.72-1.58-12.27-5.93-12.93-7.95-.16.02-.32.04-.48.07-.5.07-1.01.15-1.53.23.68 2.5 3.46 7.83 14.61 9.63z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m718.46 306.49-.15-.08c-.03.06-3.2 5.87-6.51 10.3-3.87 5.19-13.92 13.12-16.4 13.81-.34-2.39.31-13.87 1.22-23.73-.04.05-.07.11-.11.17-.69 1.03-1.4 2.01-2.09 2.97-.63 7.12-1.62 20.06-.73 21.84.23.46.67.75 1.22.8.04 0 .09.01.13.01 3.3 0 14.74-9.81 18.37-14.67 2.57-3.44 4.99-7.57 6.07-9.48-.34-.64-.68-1.28-1.02-1.94z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M718.46 306.49c.34.66.68 1.3 1.02 1.94.35-.61.56-1 .59-1.06l-1.61-.88zm-21.83.3c.03-.27.05-.55.07-.81l-1.99.81c-.08.8-.18 1.88-.29 3.14.7-.96 1.41-1.94 2.09-2.97.05-.05.09-.11.12-.17zm62.14 12.28c-3.3 10.15-5.91 18.16-6.84 20.95-.2.59-.35 1.1-.46 1.61v.04c-.28 1.26-.28 2.29 0 3.05v.04c.22.61.62 1.05 1.2 1.32.33.14.68.21 1.06.21 3.02 0 7.57-4.42 10.24-9.09 1.04-1.81 2.51-4.17 4.21-6.9 3.6-5.77 8.22-13.17 12.87-21.87-.35-.61-.56-1-.59-1.06l1.61-.88v-.01c3.4-6.51 6.78-13.72 9.74-21.48.68-1.81 1.45-5.97 2.18-10.79.03-.83.07-1.67.11-2.52v-.05c.34-7.68.88-15.97 1.11-21.6.29-.37.56-.74.84-1.12l-.7.5c-3.91 2.77-16.5 11.74-18.21 14.18.03-.03.06-.05.09-.08l1.36 1.47c-.95.88-1.92 1.7-2.88 2.47v.01c-2.76 8.06-9.35 28.27-16.94 51.6zm20.03-54.36c.63-1.12 8.28-6.94 15.9-12.38-.74 6.84-3.07 27.5-4.76 31.95-7.23 18.97-16.99 34.61-23.45 44.96-1.72 2.75-3.2 5.12-4.25 6.97-3.09 5.4-7.65 8.54-8.75 8.04-.16-.07-.56-.89.34-3.6.93-2.79 3.54-10.81 6.84-20.96 6.94-21.31 17.42-53.51 18.13-54.98zM804.91 308l-.09-1.02 1.99.81c.08.84.16 1.95.24 3.24 1.48 2.01 2.92 3.78 4.19 5.13 3.93 4.15 8.95 6.88 14.51 7.91 2.38.44 4.73.66 7.01.66 1.83 0 3.63-.14 5.37-.43 12.79-2.06 14.57-7.77 14.81-9.51-.08-.01-.17-.03-.26-.04-.58-.1-1.16-.18-1.72-.26-.13.93-1.39 5.94-13.15 7.84-3.7.6-7.63.52-11.7-.23-5.14-.95-9.78-3.48-13.42-7.31-3.62-3.81-8.76-11.36-12.22-18.34-.13-.09-.27-.17-.39-.26h-.01c-1.14-.78-2.14-1.54-2.98-2.26 1.8 4.23 4.4 8.88 7.11 13.01.24.36.47.71.71 1.06z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M804.91 308c.84 9.77.55 20.2.21 22.52-2.47-.69-12.53-8.62-16.4-13.82-3.3-4.43-6.48-10.25-6.51-10.3l-.14.08c-.34.66-.68 1.29-1.02 1.93v.01c1.08 1.91 3.5 6.04 6.07 9.48 3.62 4.86 15.06 14.67 18.36 14.67.05 0 .09 0 .13-.01.55-.05.99-.34 1.22-.8.88-1.77.62-13.81.21-20.74-.32-.44-.64-.87-.97-1.33-.38-.54-.77-1.11-1.16-1.69z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m782.07 306.49-1.61.87c.03.06.24.45.59 1.06v-.01c.34-.63.68-1.26 1.02-1.92zm-58.77-42.97s-1.56.69-1.58 1.18c-.04 1.04 3.1 2.76 3.1 2.76s-.85-3.17-1.52-3.94zm52.4 3.94 1.44-3.87s1.47-.68 1.66 1.11l-1.16 3.27-1.94-.51z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-throat is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Throat");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Throat");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "262",
	              y: "273",
	              width: "125",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-823.163 -10)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.63435 0 0 -.7655 2072.54 448.667)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Throat" || this.state.bodyHoverTitles === "Throat" ? "#f58220" : "#af9763"
	                },
	                d: "M1099.992 314.9v-21.42h-7.668v-4.357h20.484v4.356h-7.632v21.42h-5.184ZM1121.046 289.123v9.468c1.62-1.836 3.528-2.772 5.724-2.772 1.152 0 2.16.216 3.096.612.9.432 1.584.972 2.052 1.62.468.648.792 1.404.936 2.196.18.792.252 2.016.252 3.708V314.9h-4.932v-9.864c0-1.944-.072-3.204-.288-3.708-.18-.54-.504-.972-.972-1.26-.468-.324-1.08-.468-1.8-.468-.792 0-1.548.18-2.196.576-.648.396-1.116 1.008-1.404 1.8-.288.828-.468 2.016-.468 3.564v9.36h-4.932v-25.776h4.932ZM1142.856 314.9h-4.932v-18.685h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM1150.998 305.287c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM1177.812 301.94l-4.464-.829c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.624 3.995c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1202.728 296.215v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: "bodyParts_wrapper Right_Shoulder",
	            onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, "Arm");
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2.handleHoverBodyPart("Arm");
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              return _this2.handleHoverBodyPart(null);
	            }
	          },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M626.27 471.67c.11-.25.27-.47.49-.6-.1-.5-.18-1-.23-1.5-1-9.97 3.72-35.6 4.2-38.14-.29-1.24-.55-2.38-.78-3.41-.36-1.61-.66-2.92-.89-3.86-.6-2.41-2.6-6.58-5.79-12.11-4.19 9.1-23.52 51.62-28.81 73.66-1.86 7.74-3.63 17.1-5.35 26.14-4.01 21.12-6.76 34.72-10.28 38.58 2.57.81 5.22.73 7.89-.27 12.4-4.61 22.77-27.81 22.86-28.03l.19.26c1.45-4.77 2.8-9.24 3.87-12.88 4.1-13.93 6.18-31.9 6.8-37.89.05-.53.77-.63.96-.14.81 2.02 2.15 5.36 3.52 8.75.05.12.12.28.19.44-.15-3.04-.08-6.07 1.16-9zm-64.59 9.06c1.48-4.92 3.08-10.26 4.82-15.71.29-.91.59-1.84.89-2.76-1.48-10.07-3.48-30.96-4.42-41.05v-.83c-.08.6-.16 1.2-.26 1.8v.03c-.59 3.41-1.52 6.76-2.8 10-2.7 6.85-5.85 17.11-6.98 28.36-.96 9.62-1.95 30.12-3.18 49.45 1.39-2.25 3.23-5.41 5.3-9.47 1.66-3.25 3.85-10.56 6.63-19.82zm16.38-46.22c9.87-20.64 32.64-30.29 37.65-32.2.23-.09.73-.31 1.27-.55l-.27-.45c-3.26-5.69-2.76-12.74 1.31-17.78 4.98-6.18 10.32-10.84 17.14-15.14 6.82-4.3 15.1-8.24 25.99-12.96 12.21-5.28 25.16-8.16 37.1-9.46-4.37-1.43-12.32-4-23.99-7.68-17.68-5.59-57.7-12.43-62.48-13.25-10.96 5.16-21.88 12.7-30.97 23.95-5.74 7.1-9.73 15.46-11.75 24.36-2.01 8.84-4.54 22.05-5.35 35.1.75 7.99 3.44 36.37 5.11 49.48 2.77-8.16 5.84-16.3 9.24-23.42z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M581.43 538.72c1.91-7.24 3.75-16.95 5.7-27.23 1.72-9.07 3.5-18.45 5.37-26.24 5.65-23.54 27.09-70.06 29.52-75.3-1.1-1.87-2.33-3.88-3.67-6.01-.76.01-1.44.04-1.57.09-3.82 1.41-27.07 10.73-36.92 31.33-3.9 8.15-7.36 17.69-10.43 27.07l.06.37-.18.03c-2.08 6.4-3.99 12.72-5.72 18.47-2.81 9.35-5.03 16.74-6.77 20.15-.53 1.05-1.04 2.01-1.54 2.93l.33-.03c0 .01.01.09.03.22.16 1.42 1.18 9.49 3.89 18.55.3.96.6 1.92.93 2.89 3.19 9.52 8.3 19.47 16.26 23.55.47-.08 2.15-1.11 4.71-10.84z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M553 508.48c.3-.5.6-1.04.92-1.59-.18-1.3-.27-2.12-.29-2.33l1.66-.17c.5-.92 1.01-1.89 1.54-2.93 1.74-3.41 3.96-10.8 6.77-20.15 1.73-5.75 3.63-12.07 5.72-18.47l-1.8.28c-.01-.03-.01-.07-.02-.1v-.01c-.04-.24-.07-.49-.11-.75-.3.92-.6 1.85-.89 2.76-1.74 5.45-3.34 10.79-4.82 15.71-2.78 9.26-4.97 16.57-6.63 19.82-2.07 4.06-3.91 7.22-5.3 9.47 0 .07-.01.13-.01.2-.09 1.3-.17 2.6-.26 3.9.76-1.11 1.97-2.97 3.52-5.63v-.01zm15.91-49.84c.19 1.4.36 2.68.53 3.8 3.06-9.38 6.52-18.92 10.43-27.07 9.85-20.6 33.1-29.92 36.92-31.33.13-.05.81-.07 1.57-.09-.19-.3-.38-.6-.57-.91-.22-.34-.45-.69-.67-1.04-.05-.08-.09-.16-.14-.24-.53.24-1.04.46-1.27.55-5.01 1.91-27.78 11.56-37.65 32.2-3.4 7.12-6.47 15.26-9.24 23.42.03.23.06.48.09.7v.01zm-1.52 3.62c.18-.54.35-1.08.52-1.62.3-.9.6-1.81.91-2.71-1.68-13.11-4.36-41.49-5.11-49.48-.12 1.96-.2 3.91-.24 5.85-.01.7-.04 1.4-.09 2.1a52.58 52.58 0 0 1-.41 3.98v.83c.94 10.09 2.94 30.98 4.42 41.05zm2.06.18c-.04.13-.09.26-.13.4l.18-.03a4.69 4.69 0 0 1-.05-.37z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M568.91 458.64v-.01c-.03-.22-.06-.47-.09-.7-.31.9-.61 1.81-.91 2.71-.17.54-.35 1.08-.52 1.62.04.25.07.51.11.75v.01c.01.03.01.07.02.1l1.8-.28c.04-.13.09-.26.13-.4-.18-1.12-.35-2.4-.54-3.8zm53.12-48.68c-2.43 5.24-23.88 51.76-29.52 75.3-1.87 7.79-3.65 17.17-5.37 26.24-1.95 10.28-3.8 19.99-5.7 27.23-2.56 9.73-4.24 10.76-4.7 10.85.06.04.12.07.18.1.63.32 1.27.58 1.91.78 3.52-3.86 6.27-17.46 10.28-38.58 1.72-9.05 3.49-18.4 5.35-26.14 5.29-22.04 24.62-64.57 28.81-73.66-.4-.7-.8-1.4-1.24-2.12zm76.22-63.99h.02c1.56-.17 3.08-.31 4.59-.43l.05-.15c-.09-.03-9.23-3.07-28.04-9.01-15.42-4.87-48.77-10.68-60.12-12.67-.9.39-1.8.79-2.7 1.2-.09.04-.18.09-.27.13 4.79.82 44.8 7.66 62.48 13.25 11.67 3.68 19.62 6.25 23.99 7.68z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M586.71 550.18c-2.67 1-5.32 1.08-7.89.27-.68.75-1.39 1.13-2.14 1.13-.13 0-.25-.01-.38-.03l.33-1.97c.02 0 .06.01.11-.01-7.96-4.08-13.07-14.03-16.26-23.55-.33-.97-.63-1.93-.93-2.89-2.71-9.06-3.73-17.13-3.89-18.55-.02-.13-.03-.21-.03-.22l-.33.03c-.22.4-.43.81-.64 1.19l-.73 1.31c.03.19.05.39.08.59.6 4.07 1.97 11.8 4.71 19.78 1.15 3.36 2.55 6.77 4.23 9.96l2.94 1.08c.03.14.55 2.17 1.34 5.63 2.48 3.18 5.39 5.83 8.79 7.53 2.07 1.03 4.18 1.55 6.33 1.55 1.68 0 3.37-.32 5.07-.95 8.92-3.32 16.1-14.55 19.95-21.79.12-.4.25-.81.37-1.21v-.01c.56-1.84 1.12-3.66 1.67-5.45.12-.4.24-.8.36-1.19l-.19-.26c-.1.22-10.47 23.42-22.87 28.03z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M553.92 506.89c.24-.42.48-.85.73-1.31.21-.38.43-.79.64-1.19l-1.66.17c.02.21.11 1.03.29 2.33zm22.82 42.68c-.05.01-.09.01-.11.01l-.33 1.97c.13.02.26.03.38.03.75 0 1.46-.39 2.14-1.13-.64-.2-1.28-.46-1.91-.78-.06-.03-.12-.06-.17-.1zm-2.38 39.63c.12-.25.26-.51.39-.77-2.02-18.86-5.59-36-7.53-44.5-1.6-2.05-3.02-4.32-4.28-6.71.12.49 7.12 26.87 10.01 55.52.31-1.06.78-2.25 1.41-3.54z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m565.88 538.3-2.94-1.08c1.26 2.39 2.68 4.66 4.28 6.71-.79-3.46-1.31-5.5-1.34-5.63zm9.27 54.13c2.98-8.32 15.95-24.19 23.11-32.58.17-.75.36-1.5.59-2.24.04-.13.08-.25.12-.39.19-.6.4-1.28.62-1.98-5.25 5.99-19.39 22.55-24.85 33.2.15 1.32.29 2.65.41 3.99zm-2.35.82.2.05-.06-.56c-.04.17-.1.34-.14.51z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m572.95 592.73.06.56 1.74.43c0-.02.01-.04.02-.06.1-.39.24-.81.39-1.24-.13-1.34-.26-2.67-.4-3.99-.13.26-.27.52-.39.77-.64 1.29-1.11 2.48-1.42 3.53z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M574.44 636.84c-2.01 10.89-5.12 21.81-8.85 32.07 5.67-12.29 10.69-22.88 13.1-27.6 12.01-23.55 17.31-55.64 18.74-76 .11-1.51.31-3.01.62-4.49.06-.32.14-.65.22-.97-7.17 8.38-20.14 24.26-23.11 32.58 1.42 15.19 1.72 31.16-.72 44.41zm-40.42 85.7c-5.89 4.53-15.92 9.53-24.58 13.36-6.17 15.6-18.75 37.81-19.61 48.18-1.01 11.98 24.13 49.34 27.29 52.49 4.13 4.14 11.65 3.43 9.66-1.57-2.01-4.99-17.98-32.94-14.98-37.93 2.99-5 15.97-20.98 20.96-18.98s0 24.97 4.99 28.96c5 4 8.92-.01 9.98-7.99 1.06-7.94.4-11.09 2.44-16.21 2.76-6.88.41-12.69-1.38-17.9-1.56-4.56-5.5-8.27-6.88-12.4-1.78-5.35-4.16-14.39-2.17-23.39.8-3.59 6.04-16.1 12.5-30.72-6.26 11.26-12.76 19.9-18.22 24.1z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M572.47 636.48c2.35-12.75 2.01-28.25.53-43.18l-.2-.05c.04-.16.1-.34.15-.51-2.89-28.65-9.89-55.02-10.01-55.52-1.68-3.19-3.08-6.6-4.23-9.96-2.74-7.98-4.11-15.71-4.71-19.78-.03-.21-.06-.4-.08-.59-.31.56-.62 1.09-.92 1.59v.01c-1.54 2.66-2.76 4.52-3.52 5.63v.06c-1.26 19.18-2.78 36.32-4.73 39.28 0 0-11.1 18.67-15.24 31.07-3.6 10.81-15.5 136.92-17.71 144.64-.15.51-.31 1.04-.48 1.58-.06.19-.12.37-.19.56-.21.64-.45 1.31-.7 1.99 7.53-3.32 16.35-7.71 22.37-12.34 13.29-10.22 32.85-47.43 39.67-84.48z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyLines",
	              d: "M565.59 668.91c-4.37 9.48-9.12 19.96-13.35 29.54 4.77-8.59 9.41-18.7 13.35-29.54z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M575.15 592.43c-.16.43-.29.85-.39 1.24-.01.02-.02.04-.02.06l-1.74-.43c1.47 14.93 1.81 30.43-.53 43.18-6.83 37.05-26.39 74.26-39.67 84.48-6.02 4.63-14.84 9.03-22.37 12.34-.31.85-.64 1.71-.99 2.61 8.65-3.84 18.69-8.84 24.58-13.36 5.46-4.2 11.96-12.84 18.22-24.09 4.23-9.58 8.98-20.06 13.35-29.54 3.73-10.26 6.84-21.18 8.85-32.07 2.44-13.26 2.14-29.23.71-44.42z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Arm" || this.state.bodyHoverTitles === "Arm" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M587.41 552.06c-1.7.63-3.39.95-5.07.95-2.15 0-4.26-.52-6.33-1.55-3.41-1.7-6.31-4.35-8.79-7.53 1.94 8.5 5.51 25.64 7.53 44.5 5.46-10.65 19.6-27.21 24.85-33.2 1.88-5.99 4.84-15.51 7.76-24.97-3.85 7.25-11.03 18.48-19.95 21.8z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-arm is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Arm");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Arm");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "305",
	              y: "462",
	              width: "82",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 5.822)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.30694 0 0 -.7655 813.571 622.539)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Arm" ? "#f58220" : "#af9763"
	                },
	                d: "M336.126 488.982h-5.652l-2.232-5.868H317.91l-2.124 5.868h-5.508l10.044-25.776h5.508l10.296 25.776Zm-9.576-10.188-3.528-9.576-3.492 9.576h7.02ZM343.576 488.982h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM352.51 470.298h4.536v2.556c1.62-1.98 3.564-2.952 5.832-2.952 1.188 0 2.232.252 3.096.72.864.504 1.584 1.26 2.16 2.232.828-.972 1.692-1.728 2.664-2.232a6.683 6.683 0 0 1 3.024-.72c1.368 0 2.556.252 3.492.828.936.54 1.656 1.368 2.124 2.448.324.792.504 2.088.504 3.852v11.952h-4.932v-10.656c0-1.872-.18-3.06-.504-3.6-.468-.72-1.152-1.044-2.124-1.044-.684 0-1.332.216-1.944.612-.612.432-1.044 1.044-1.332 1.872-.252.792-.396 2.088-.396 3.852v8.964h-4.932v-10.224c0-1.836-.072-2.988-.252-3.528-.18-.504-.468-.9-.828-1.188-.36-.252-.864-.36-1.512-.36-.756 0-1.44.18-2.052.612-.612.396-1.044 1.008-1.296 1.764-.288.792-.396 2.052-.396 3.852v9.072h-4.932v-18.684Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: "bodyParts_wrapper Left_Shoulder",
	            onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, "Elbow");
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2.handleHoverBodyPart("Elbow");
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              return _this2.handleHoverBodyPart(null);
	            }
	          },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M933.89 539.3c-.01.03-.05.18-.11.43.1-.16.2-.33.3-.5l-.19.07zm-12.18 11.15c.68.75 1.39 1.13 2.14 1.13.13 0 .25-.01.38-.03l-.33-1.97c-.02 0-.06.01-.11 0-.06.04-.12.07-.17.1-.63.31-1.27.57-1.91.77z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M934.09 539.23c2.51-4.07 4.47-8.73 5.99-13.3.33-.94.62-1.88.9-2.81 2.71-9.03 3.73-17.08 3.9-18.53-.69-1.26-1.42-2.62-2.18-4.12-1.74-3.41-3.96-10.8-6.77-20.16-4.3-14.3-9.65-32.1-16.26-45.94-9.87-20.64-33.19-29.95-36.93-31.33-1.55 2.47-2.97 4.77-4.24 6.91 2.41 5.19 23.88 51.76 29.53 75.31 1.87 7.79 3.65 17.17 5.37 26.24 1.95 10.28 3.8 19.99 5.7 27.23 2.56 9.74 4.25 10.76 4.7 10.85h.01c4.02-2.06 7.3-5.61 9.98-9.84.06-.25.1-.4.11-.43l.19-.08z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M802.28 345.96c11.93 1.3 24.89 4.18 37.09 9.47 21.77 9.44 33.17 15.73 43.14 28.1 4.06 5.04 4.56 12.09 1.3 17.78 4.95 1.89 27.77 11.52 37.65 32.2 3.79 7.92 7.15 17.09 10.14 26.17v-.01c1.52-11.64 4-33.94 5.02-43.17 0-.03-.01-.06-.01-.09-.05-.7-.08-1.4-.09-2.1-.26-14.83-3.28-30.78-5.58-40.95-2.02-8.9-6.01-17.26-11.75-24.36-9.13-11.29-20.1-18.86-31.1-24.01-2.5.44-43.58 7.54-61.84 13.31-11.66 3.67-19.61 6.24-23.97 7.66zm135.56 133.77c2.78 9.26 4.98 16.57 6.64 19.82 2.31 4.52 4.33 7.94 5.76 10.21-1.22-19.26-2.2-39.62-3.16-49.19-1.13-11.25-4.28-21.51-6.98-28.36-1.17-2.95-2.03-6-2.62-9.1-.99 10.67-3.01 31.47-4.46 40.93 1.74 5.44 3.34 10.77 4.82 15.69zm-26.41 32.14c-1.72-9.05-3.49-18.4-5.35-26.15-5.29-22.05-24.63-64.6-28.82-73.67-3.17 5.54-5.18 9.71-5.78 12.12-.24.93-.53 2.25-.89 3.85-.23 1.04-.5 2.19-.78 3.44v.01c.47 2.49 4.51 24.43 4.33 35.6.17.07.33.19.45.39 1.17 2.01 2.24 4.07 3.17 6.19.32-.81.62-1.54.86-2.15.2-.49.92-.39.96.14.62 5.99 2.7 23.96 6.81 37.89 1.12 3.84 2.56 8.62 4.11 13.69 2.41 4.64 12.48 22.93 23.32 26.97 2.67.99 5.32 1.08 7.89.26-3.52-3.86-6.27-17.46-10.28-38.58z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M937.84 479.73c-1.48-4.92-3.08-10.25-4.82-15.7v.01c0 .03-.01.05-.01.08l-1.98-.31c.19-1.21.38-2.6.58-4.14-2.99-9.08-6.36-18.25-10.14-26.17-9.89-20.67-32.7-30.31-37.65-32.2-.13.23-.27.46-.41.69-.22.35-.45.7-.67 1.04 3.74 1.38 27.06 10.69 36.93 31.33 6.62 13.83 11.97 31.63 16.26 45.94 2.81 9.35 5.03 16.74 6.77 20.16.77 1.5 1.49 2.87 2.18 4.12.02-.14.03-.21.03-.23l1.99.2c-.02.24-.14 1.29-.38 2.93 1.91 3.28 3.33 5.38 3.98 6.29-.08-1.18-.16-2.37-.23-3.56l-.03-.46c-1.44-2.27-3.45-5.68-5.76-10.21-1.66-3.24-3.86-10.55-6.64-19.81z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M931.61 459.67c.48 1.46.95 2.91 1.41 4.36 1.45-9.46 3.46-30.26 4.46-40.93-.06-.3-.13-.6-.18-.9v-.02a49.5 49.5 0 0 1-.67-5.7c-1.01 9.23-3.49 31.53-5.02 43.17v.02z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M933.01 464.12c0-.03.01-.05.01-.08v-.01c-.46-1.45-.93-2.9-1.41-4.36-.2 1.54-.39 2.93-.58 4.14l1.98.31zm8.81 63.13c2.73-7.97 4.11-15.67 4.7-19.75v-.01c-.51-.88-1.06-1.85-1.64-2.9-.17 1.45-1.19 9.5-3.9 18.53-.28.93-.57 1.87-.9 2.81-1.52 4.56-3.49 9.22-5.99 13.3l2.74-1.01c-.01.04-.07.28-.18.68.32-.56.64-1.13.94-1.7 1.68-3.19 3.08-6.59 4.23-9.95zm-28.71 24.81c1.71.63 3.4.95 5.08.95 2.14 0 4.26-.52 6.32-1.55 3.08-1.54 5.74-3.84 8.06-6.62.59-2.58 1.02-4.35 1.21-5.12-2.68 4.23-5.97 7.78-9.98 9.84h-.01c.05.01.09.01.11 0l.33 1.97c-.13.02-.26.03-.38.03-.75 0-1.46-.39-2.14-1.13-2.57.82-5.22.73-7.89-.26-10.84-4.04-20.91-22.32-23.32-26.97.04.13.08.25.12.38.55 1.8 1.11 3.64 1.68 5.49l.93 3.01c4.2 7.2 11.69 16.93 19.88 19.98z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M934.09 539.23c-.1.17-.2.34-.3.5-.19.77-.63 2.54-1.21 5.12 1.51-1.81 2.86-3.81 4.08-5.94.1-.4.17-.64.18-.68l-2.75 1zm-14.99-.5c-1.91-7.24-3.75-16.95-5.7-27.23-1.72-9.07-3.5-18.45-5.37-26.24-5.65-23.55-27.12-70.12-29.53-75.31-.42.72-.83 1.41-1.23 2.09v.01c4.18 9.08 23.52 51.63 28.82 73.67 1.86 7.74 3.63 17.1 5.35 26.15 4.01 21.12 6.76 34.72 10.28 38.58.65-.2 1.29-.46 1.92-.78.06-.03.12-.06.17-.1-.47-.08-2.15-1.11-4.71-10.84zm26.93-34.92s1.31.15 1.4 1.23l-.9 2.46-1.64-2.91v-.78c-.01 0 .26-.75 1.14 0zm-71.89-36.74s.01 5.75-1.41 4.25l3.96 4.97 1.06-2.64s-2.1-5.73-3.61-6.58zm-76.53-121.68.05.14c1.52.12 3.06.26 4.62.43 4.36-1.42 12.31-3.99 23.98-7.67 18.26-5.77 59.34-12.87 61.84-13.31-.05-.02-.1-.05-.15-.07-1.04-.49-2.07-.95-3.11-1.39-10.16 1.79-43.25 7.83-59.18 12.86-18.81 5.94-27.96 8.98-28.05 9.01z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M946.52 507.5c-.59 4.08-1.97 11.78-4.7 19.75-1.15 3.36-2.55 6.76-4.23 9.95-.3.58-.62 1.14-.94 1.7-1.75 6.81-15.86 63.26-9.35 98.57 6.83 37.05 26.39 74.26 39.67 84.48 6.21 4.78 15.41 9.31 23.09 12.66-.43-1.13-.83-2.22-1.17-3.26v-.12c-.08-.17-.15-.29-.21-.5-.17-.54-.33-1.06-.48-1.57-2.21-7.72-14.11-133.83-17.71-144.64-4.13-12.4-15.24-31.07-15.24-31.07-1.95-2.96-3.47-20.11-4.72-39.28l-.03-.4c-.64-.9-2.07-3-3.98-6.27 0-.01 0 0 0 0zm-21.62 83.07c2-19.37 5.7-37.08 7.67-45.73-2.31 2.77-4.98 5.08-8.06 6.62-2.06 1.03-4.18 1.55-6.32 1.55-1.68 0-3.37-.32-5.08-.95-8.19-3.05-15.68-12.78-19.9-19.96 3.06 9.96 6.12 19.75 7.8 25.12v.01c.04.14.08.25.12.38.08.26.15.52.22.78 6.36 7.37 18.76 22.3 23.37 31.83.07.12.12.23.18.35z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Elbow" || this.state.bodyHoverTitles === "Elbow" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "m924.5 594.69-.15.04c0-.01-.01-.03-.01-.04-1.86-7.4-14.33-22.99-22.09-32.16.14.92.26 1.85.32 2.78 1.43 20.36 6.72 52.45 18.74 76 2.07 4.06 6.08 12.48 10.77 22.58-2.8-8.46-5.14-17.26-6.76-26.05-2.36-12.89-2.14-28.34-.82-43.15zm85.67 189.4c-.83-10.08-12.73-31.33-19.07-46.84-8.82-3.88-19.29-9.04-25.35-13.71-4.66-3.58-10.06-10.38-15.43-19.28 5.24 12.04 9.25 21.81 9.94 24.91 1.99 9-.38 18.04-2.17 23.39-1.37 4.13-5.32 7.84-6.88 12.4-1.79 5.21-4.13 11.02-1.37 17.9 2.04 5.12 1.37 8.27 2.43 16.21 1.06 7.98 4.99 11.99 9.98 7.99 4.99-3.99 0-26.96 4.99-28.96 5-2 17.98 13.98 20.96 18.98 3 4.99-12.97 32.94-14.97 37.93-1.99 5 5.53 5.71 9.66 1.57 3.15-3.15 28.29-40.51 27.28-52.49z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M950.32 704.26c-5.51-12.66-12.39-27.82-18.23-40.38 5.05 15.27 11.61 29.42 18.23 40.38z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M965.75 723.54c6.06 4.66 16.53 9.83 25.35 13.71-.37-.9-.72-1.78-1.04-2.63-7.68-3.35-16.88-7.88-23.09-12.66-13.29-10.22-32.84-47.43-39.67-84.48-6.5-35.31 7.6-91.76 9.35-98.57-1.22 2.13-2.57 4.13-4.08 5.94-1.97 8.64-5.67 26.36-7.67 45.73.65 1.35 1.13 2.59 1.39 3.68l-1.79.44c-1.32 14.81-1.54 30.26.83 43.15 1.62 8.79 3.96 17.59 6.76 26.05 5.83 12.56 12.71 27.72 18.23 40.38 5.37 8.88 10.77 15.68 15.43 19.26zm-41.4-128.81.15-.04c.12-1.38.26-2.75.4-4.12-.06-.12-.11-.23-.17-.35-4.61-9.54-17.01-24.47-23.37-31.83.23.81.44 1.63.61 2.44v.01c.11.56.2 1.12.29 1.69 7.76 9.18 20.22 24.77 22.09 32.16-.01.01 0 .03 0 .04z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M926.29 594.25c-.27-1.08-.74-2.33-1.39-3.68-.14 1.37-.27 2.74-.4 4.12l1.79-.44z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-elbow" },
	            _react2.default.createElement("rect", {
	              // onClick={(e) => this.modalMaleBodySingleContentOpen(e, "Elbow")}
	              // onMouseOver={(e) => this.handleHoverBodyPart("Elbow")}
	              // onMouseLeave={(e) => this.handleHoverBodyPart(null)}
	              className: "labelArea",
	              x: "1115",
	              y: "536",
	              width: "115",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 140.684)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.28648 0 0 .7655 712.873 268.299)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Elbow" ? "#f58220" : "#af9763"
	                },
	                d: "M1120.01 427.414v-25.776h19.117v4.356h-13.932v5.724h12.96v4.356h-12.96v6.984h14.4v4.356h-19.584ZM1143.985 401.638h4.932v25.776h-4.932zM1153.769 427.414v-25.776h4.932v9.288c1.512-1.728 3.348-2.592 5.436-2.592 2.268 0 4.14.828 5.616 2.448 1.512 1.656 2.232 4.032 2.232 7.092 0 3.204-.756 5.652-2.268 7.38-1.512 1.728-3.348 2.592-5.544 2.592-1.044 0-2.088-.288-3.132-.792-1.044-.54-1.944-1.332-2.7-2.376v2.736h-4.572Zm4.896-9.756c0 1.944.324 3.384.936 4.32.828 1.296 1.98 1.944 3.384 1.944 1.116 0 2.016-.468 2.808-1.368.756-.936 1.152-2.412 1.152-4.428 0-2.124-.396-3.672-1.188-4.608-.756-.936-1.764-1.404-2.952-1.404s-2.16.432-2.952 1.368c-.792.936-1.188 2.304-1.188 4.176ZM1174.823 417.802c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM1201.42 427.414l-5.903-18.684h4.824l3.492 12.24 3.204-12.24h4.788l3.096 12.24 3.564-12.24h4.86l-5.976 18.684h-4.752l-3.204-11.988-3.168 11.988h-4.824Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Right_Thigh" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Thigh");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Thigh");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M653.56 979.22c0 .02.02.11.05.26.08.08.15.18.23.26.71.71 1.44 1.41 2.2 2.08-.27-1.67-.47-2.72-.52-2.98l-1.96.38zm34.38-9.96c0-.03.01-.05.01-.08l-1.97-.33c-.16.95-.5 3.09-.93 6.05.97-1.62 1.93-3.51 2.88-5.61v-.01c.01-.01.01-.02.01-.02zm13.78-226.02c-.02-.02-.04-.04-.05-.06a1.44 1.44 0 0 1-.15-.22c.15.22.23.35.25.37l.02-.01c-.03-.03-.05-.05-.07-.08zm-22.08-32.61zm21.82 32.25.06.08c-.02-.02-.04-.05-.06-.08zm39.27 53.1c.01-.43 0-.92 0-1.13 0-2.73-3.63-7.27-9.18-13.89-2.42-2.89-4.7-5.61-6.1-7.71-3.68-5.51-19.56-27.64-22.04-31.09-.01-.01-.01-.01-.01-.02.05.1.09.18.09.19l-1.71 1c2.44 3.39 18.35 25.55 22.01 31.04 1.46 2.19 3.78 4.96 6.23 7.89 3.88 4.63 8.71 10.39 8.71 12.6 0 .97-.07 3.03-.2 5.78.53-3.47.9-5.55.9-5.55s.61.47 1.3.89zm-61.1-85.36c.01 0 0 0 0 0zm4.7 6.92c-1.74-4.52-2.84-7.63-2.87-7.72l-1.88.66c.01.03.03.07.05.13l.01.01c1.57 2.32 3.15 4.64 4.7 6.93l-.01-.01z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m703.08 741.71-1.62 1.17.06.09c.04.05.08.12.15.22.01.02.03.04.05.06.02.03.04.05.06.08l1.71-1c-.01-.01-.04-.08-.09-.19 0-.01-.01-.01-.01-.02-.19-.26-.3-.39-.31-.41zM665.2 689.2c.01.06.02.15.03.25 1.09 1.59 2.29 3.35 3.58 5.23-1.07-3.81-1.63-5.8-1.65-5.86l-1.96.38zm4.72 27.63-1.52-1.3c-.01.01-.06.07-.15.18.11.89.22 1.8.33 2.73.83-1 1.31-1.57 1.34-1.61z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Thigh" || this.state.bodyHoverTitles === "Thigh" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M683.61 755.05c-6.93-24.82-12.01-42.96-15.05-53.81 3.33 28.77 12.12 99.68 19.95 119.25 7.94 19.85 20.04 73.79 26.54 102.77 1.69 7.53 2.91 12.98 3.54 15.49 2.29 9.16 2.29 27.1 2.15 35.63 1.89-8.56 4.41-18.16 5.74-23.48 2.22-8.85 3.86-21.41 5.07-34.91-1.92-9.77-6.36-30.11-12.86-46.71-7.4-18.89-19.19-57.32-35.08-114.23zm-70.16 67.17v.34c.04-.03.08-.07.12-.1l-.12-.24z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M724.59 803.6c-2.13-8.51-17.15-43.35-25.19-54.41-5.26-7.22-11.5-22.36-15.06-31.62v-.01a4387.9 4387.9 0 0 0-4.7-6.93c0 .01.01.02.01.03.91 2.6 10.37 29.03 18.13 39.71 7.75 10.65 22.82 45.53 24.87 53.71.52 2.08 1.43 6.32 2.49 11.22 5.72 26.56 7.73 34.05 9.36 34.83.06.03.12.05.19.07.02-1.25.03-2.39.03-3.45-1.94-5.46-5.56-22.25-7.63-31.87-1.06-4.92-1.97-9.17-2.5-11.28z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Thigh" || this.state.bodyHoverTitles === "Thigh" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M716.64 939.23c-.63-2.53-1.86-7.98-3.55-15.53-1.65-7.37-3.67-16.35-5.88-25.97-2.58 13.46-10.42 51.88-19.28 71.56-2.58 15.79-7.73 57.57-.74 63.01 8.41 6.54 24.18-1.09 24.34-1.17l.21.43c2.7-16.83 6.06-38.89 6.73-44.78.06-.52.13-1.06.21-1.64.16-8.88.41-36.11-2.04-45.91zm8.5-123.93c-1.06-4.9-1.97-9.14-2.49-11.22-2.05-8.18-17.12-43.06-24.87-53.71-7.76-10.68-17.22-37.11-18.13-39.71 0-.01-.01-.02-.01-.03v-.01l-.01-.01v-.01c-3.81-5.62-7.58-11.17-10.83-15.93 2.62 9.32 8.31 29.62 16.74 59.83 15.86 56.84 27.64 95.21 35.01 114.03 6.9 17.63 10.32 34.25 11.53 41.04 1.76-22.32 2.43-46.01 2.61-59.35v-.04c-.06-.02-.13-.04-.19-.07-1.63-.76-3.64-8.25-9.36-34.81z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Thigh" || this.state.bodyHoverTitles === "Thigh" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M730.02 782.25c-2.45-2.93-4.77-5.7-6.23-7.89-3.66-5.49-19.57-27.64-22.01-31.04l-.02.01c-.01-.02-.1-.15-.25-.37-.03-.05-.05-.08-.06-.08-1.57-2.32-8.95-13.25-17.12-25.31v.01c3.56 9.26 9.8 24.4 15.06 31.62 8.04 11.06 23.06 45.9 25.19 54.41.53 2.11 1.44 6.36 2.5 11.28 2.07 9.62 5.69 26.41 7.63 31.87v-.58c.01-1.01.01-1.91.01-2.71 0-14.31 2.01-30.6 3.4-40.16v-.05l.39-2.62c.13-2.75.2-4.81.2-5.78.02-2.22-4.81-7.98-8.69-12.61zm-80.89 255.86c12.02-15.07 5.13-55.05 4.48-58.63-5.19-5.52-7.71-19.38-11.84-42.14-.69-3.83-1.43-7.89-2.23-12.19-4.97-26.7-18.24-94.24-21.09-108.73v.01c-1.56 2.94-3.59 4.94-4.88 6.03.08.18.13.36.13.54l-.26.08c-.76 42.15-2.01 99.96 6.18 132.75 5.92 23.65 11.26 49.05 14.92 67.44 1.34 6.74 2.19 13.56 2.55 20.4 4.36-.41 9.42-2.28 12.04-5.56zm19.12-322.4c-1.7-13.98-2.8-24.18-3.03-26.26-.52-.76-1.02-1.49-1.49-2.17-11.5-16.72-14.3-29.15-16.18-40.45l-.09-.62c.04.37.06.74.1 1.1.1.74.16 1.49.2 2.25-.01.01 0 .02 0 .03.61 14.67-10.64 33.22-16.33 46.5-5.99 13.98-18.8 55.05-17.81 91 .23 8.34.09 19.54-.14 32.36 3.35-5.41 11.21-18.63 17.07-39.9 7.69-27.85 35.39-61.11 37.7-63.84z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Thigh" || this.state.bodyHoverTitles === "Thigh" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M632.48 780.08c-4.18 15.15-8.95 26.31-12.55 33.49 1.09 5.53 16.2 82.3 21.58 111.21.8 4.3 1.54 8.37 2.23 12.2 3.97 21.93 6.6 36.42 11.51 41.34 5.94 5.94 12.3 10.41 24.68-.06 12.29-10.4 25.41-81.28 26.16-85.4-6.29-27.07-13.9-57.78-19.44-71.63-6.73-16.81-13.95-69.24-18.07-102.79-5.85 7.14-29.21 36.67-36.1 61.64z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M685.54 754.52c-8.43-30.21-14.12-50.51-16.74-59.83-1.29-1.88-2.49-3.64-3.58-5.23.22 2.08 1.33 12.28 3.03 26.26.09-.11.14-.17.15-.18l1.52 1.3c-.03.04-.51.61-1.34 1.61 4.12 33.55 11.34 85.98 18.07 102.79 5.54 13.85 13.15 44.56 19.44 71.63.02-.1.03-.18.04-.19l1.97.35c-.07.41-.38 2.09-.88 4.7 2.21 9.62 4.23 18.61 5.88 25.97 1.69 7.55 2.92 13 3.55 15.53 2.45 9.8 2.19 37.03 2.03 45.91.25-1.8.62-3.86 1.06-6.09.22-1.08.45-2.2.7-3.34.09-.44.19-.89.29-1.33.15-8.53.14-26.48-2.15-35.63-.63-2.51-1.85-7.95-3.54-15.49-6.5-28.98-18.59-82.92-26.54-102.77-7.83-19.57-16.62-90.48-19.95-119.25 3.04 10.85 8.12 28.99 15.05 53.81 15.88 56.91 27.68 95.33 35.07 114.22 6.49 16.6 10.93 36.94 12.86 46.71l.27-3.09c.07-.76.13-1.52.19-2.28v-.01c.03-.34.05-.68.08-1.02-1.22-6.79-4.63-23.41-11.53-41.04-7.36-18.82-19.14-57.18-35-114.02zm-71.97 67.94c-.04.04-.08.07-.12.1 0 .15 0 .29-.01.44v.08l.26-.08c0-.18-.05-.36-.13-.54z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M618.45 816.43s0-.01 0 0c-.33-1.71-.52-2.69-.54-2.78l1.96-.39c.01.03.03.13.06.31 3.6-7.19 8.37-18.35 12.55-33.49 6.89-24.97 30.25-54.5 36.1-61.64-.11-.92-.22-1.83-.33-2.73-2.31 2.73-30.01 35.99-37.69 63.84-5.86 21.27-13.72 34.5-17.07 39.9-.01.41-.01.81-.02 1.23-.01.51-.01 1.03-.02 1.54l.12.24c1.29-1.09 3.32-3.09 4.88-6.03z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M679.93 978.27c-12.37 10.47-18.73 6-24.68.06-4.91-4.91-7.54-19.4-11.51-41.34-.69-3.83-1.43-7.9-2.23-12.2-5.38-28.91-20.49-105.69-21.58-111.21v.01c-.52 1.03-1.01 1.97-1.48 2.84 2.85 14.49 16.12 82.03 21.09 108.73.8 4.3 1.54 8.36 2.23 12.19 4.12 22.76 6.64 36.61 11.84 42.14-.03-.15-.04-.24-.05-.26l1.96-.38c.05.25.25 1.31.52 2.98 2.98 2.62 6.38 4.72 10.65 4.72 3.98 0 8.71-1.82 14.52-6.75 1.28-1.08 2.56-2.76 3.83-4.89.43-2.96.77-5.1.93-6.05l1.97.33c0 .03-.01.05-.01.08 0 0 0 .01-.01.02v.01c8.87-19.68 16.7-58.1 19.28-71.56-.37-1.6-.74-3.23-1.12-4.86-.74 4.1-13.86 74.99-26.15 85.39zm28.16-85.25-1.97-.35c0 .02-.02.09-.04.19.38 1.63.76 3.26 1.12 4.86.51-2.6.82-4.28.89-4.7z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M619.93 813.57c-.04-.18-.06-.28-.06-.31l-1.96.39c.02.09.21 1.07.55 2.77.46-.87.95-1.81 1.47-2.85 0 .01 0 .01 0 0z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-thigh is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Thigh");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Thigh");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea rightThigh",
	              x: "277",
	              y: "869",
	              width: "110",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 6.257)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.45018 0 0 -.7655 1004.24 1030.38)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Thigh" ? "#f58220" : "#af9763"
	                },
	                d: "M292.842 893.037v-21.42h-7.668v-4.356h20.484v4.356h-7.632v21.42h-5.184ZM313.896 867.261v9.468c1.62-1.836 3.528-2.772 5.724-2.772 1.152 0 2.16.216 3.096.612.9.432 1.584.972 2.052 1.62.468.648.792 1.404.936 2.196.18.792.252 2.016.252 3.708v10.944h-4.932v-9.864c0-1.944-.072-3.204-.288-3.708-.18-.54-.504-.972-.972-1.26-.468-.324-1.08-.468-1.8-.468-.792 0-1.548.18-2.196.576-.648.396-1.116 1.008-1.404 1.8-.288.828-.468 2.016-.468 3.564v9.36h-4.932v-25.776h4.932ZM330.99 871.833v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM340.522 894.261l5.652.684c.072.648.288 1.116.648 1.368.468.36 1.188.504 2.196.504 1.296 0 2.268-.18 2.916-.576.432-.252.756-.648.972-1.224.18-.432.252-1.188.252-2.268v-2.736c-1.476 2.016-3.348 3.024-5.616 3.024-2.484 0-4.464-1.044-5.94-3.168-1.152-1.692-1.728-3.78-1.728-6.264 0-3.132.756-5.544 2.268-7.164 1.512-1.656 3.384-2.484 5.616-2.484 2.304 0 4.212 1.008 5.688 3.024v-2.628h4.644v16.776c0 2.196-.18 3.852-.54 4.932-.36 1.08-.9 1.944-1.548 2.556-.648.648-1.512 1.116-2.628 1.476-1.08.36-2.484.504-4.14.504-3.168 0-5.4-.54-6.732-1.62-1.332-1.08-1.98-2.448-1.98-4.104v-.612Zm4.428-10.944c0 1.98.36 3.42 1.152 4.356.756.9 1.692 1.368 2.808 1.368 1.224 0 2.232-.468 3.06-1.404.864-.936 1.26-2.34 1.26-4.212 0-1.908-.396-3.348-1.188-4.284-.792-.936-1.8-1.404-3.024-1.404-1.188 0-2.16.432-2.916 1.368-.792.936-1.152 2.34-1.152 4.212ZM367.876 867.261v9.468c1.62-1.836 3.528-2.772 5.724-2.772 1.152 0 2.16.216 3.096.612.9.432 1.584.972 2.052 1.62.468.648.792 1.404.936 2.196.18.792.252 2.016.252 3.708v10.944h-4.932v-9.864c0-1.944-.072-3.204-.288-3.708-.18-.54-.504-.972-.972-1.26-.468-.324-1.08-.468-1.8-.468-.792 0-1.548.18-2.196.576-.648.396-1.116 1.008-1.404 1.8-.288.828-.468 2.016-.468 3.564v9.36h-4.932v-25.776h4.932Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Left_Thigh" },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M845 978.84c-.05.25-.25 1.31-.52 2.98.76-.67 1.49-1.37 2.2-2.08.08-.08.15-.18.23-.26.03-.15.04-.24.05-.26l-1.96-.38zm-32.43-9.66c0 .03.01.06.01.09.95 2.12 1.92 4.02 2.89 5.65-.43-2.96-.78-5.11-.93-6.06l-1.97.32zm-13.81-225.85c.01-.02.08-.12.21-.31-.06.07-.13.17-.23.3l.02.01z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m797.03 742.33 1.71.99c.1-.13.17-.23.23-.3.05-.08.08-.13.09-.14l-1.62-1.17c-.01.02-.12.15-.31.41 0 .01-.01.03-.02.04-.05.1-.08.16-.08.17z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M762.12 803.25c-.21-4.07-.33-7.14-.33-8.4 0-2.21 4.83-7.97 8.71-12.6 2.46-2.93 4.78-5.7 6.24-7.89 3.66-5.49 19.57-27.66 22-31.04l-1.71-.99c0-.01.03-.07.08-.17-2.48 3.45-18.36 25.58-22.04 31.09-1.39 2.1-3.68 4.82-6.1 7.71-5.54 6.62-9.18 11.16-9.18 13.89 0 .17.01.44.02.78.5-.32.76-.55.76-.55s.89 8.51 1.55 8.17zm68.48-86.42c.04.04.52.61 1.34 1.62.12-.93.23-1.84.34-2.74-.1-.11-.15-.17-.16-.18l-1.52 1.3z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M794.43 892.83c.69 3.8 13.85 75.01 26.17 85.43 12.37 10.47 18.73 6 24.68.06 4.91-4.91 7.54-19.4 11.51-41.34.69-3.83 1.43-7.9 2.23-12.2 5.38-28.92 20.49-105.69 21.58-111.21-3.6-7.19-8.37-18.34-12.55-33.49-6.88-24.96-30.22-54.48-36.1-61.63-4.12 33.55-11.34 85.97-18.07 102.78-5.55 13.85-13.16 44.54-19.45 71.6z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M781.94 938.74c.63-2.5 1.85-7.94 3.54-15.47 6.5-28.98 18.59-82.93 26.54-102.78 7.83-19.57 16.61-90.48 19.94-119.25-3.04 10.85-8.12 28.99-15.05 53.81-15.88 56.9-27.68 95.33-35.07 114.22-8.86 22.64-12.82 51.92-12.86 52.16 1.15 11.4 2.63 21.82 4.54 29.47 1.4 5.6 4.12 15.93 6.03 24.81v.02c.08.36.15.71.23 1.07-.12-9.11-.08-29.09 2.16-38.06zm53.36-249.29c-.22 2.09-1.32 12.29-3.02 26.26 2.29 2.72 30 35.99 37.69 63.84 6.17 22.39 13.6 35.87 16.56 40.69-.24-13.15-.39-24.64-.15-33.15.99-35.95-11.82-77.02-17.81-91-5.5-12.83-16.19-30.59-16.36-45.01-1.95 10.19-5.34 21.55-15.42 36.2-.47.68-.97 1.41-1.49 2.17zm46.77 126.99c-2.86 14.52-16.13 82.02-21.09 108.71-.8 4.3-1.54 8.36-2.23 12.19-4.12 22.76-6.64 36.61-11.84 42.14-.65 3.58-7.54 43.56 4.48 58.63 2.71 3.4 7.16 5.26 11.53 5.59.36-6.85 1.2-13.67 2.55-20.43 3.66-18.39 9-43.79 14.92-67.44 8.19-32.76 6.94-90.5 6.18-132.65l-.36.26c-.04-.06-1.68-2.38-4.14-7z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M813.33 1032.3c6.99-5.44 1.85-47.26-.75-63.03-8.86-19.69-16.69-58.09-19.27-71.54v.01c-2.22 9.63-4.23 18.61-5.88 25.98-1.69 7.54-2.92 12.99-3.55 15.52-2.64 10.57-2.07 44.16-1.92 50.96 1.13 8.34 3.8 25.75 6.09 39.97.96.47 17.09 8.5 25.28 2.13zm-47.64-185.25c1.92-5.13 5.63-22.37 7.74-32.18 1.06-4.92 1.98-9.17 2.51-11.27 2.12-8.51 17.14-43.35 25.18-54.41 5.26-7.22 11.49-22.34 15.05-31.6-8.17 12.05-15.55 22.98-17.11 25.29-.01.01-.04.06-.09.14-.13.19-.2.29-.21.31l-.02-.01c-2.43 3.38-18.34 25.55-22 31.04-1.46 2.19-3.78 4.96-6.24 7.89-3.88 4.63-8.71 10.39-8.71 12.6 0 1.26.12 4.33.33 8.4-.73-5.02-1.29-8.17-1.29-8.17s-.08.07-.23.18c.13.73.63 3.66 1.26 7.99v.05c1.39 9.56 3.4 25.85 3.4 40.16 0 .8 0 1.7.01 2.71 0 .4.01.83.01 1.26.14-.44.25-.86.25-1.26.06.32.11.62.16.88z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M768.26 910.59c1.05-6.03 4.46-23.49 11.72-42.04 7.37-18.83 19.14-57.2 35-114.03 8.43-30.2 14.12-50.5 16.74-59.83-3.24 4.75-7.01 10.3-10.82 15.92-.83 2.33-10.35 29.02-18.16 39.76-7.74 10.65-22.82 45.53-24.86 53.71-.52 2.08-1.43 6.31-2.49 11.21-5.72 26.57-7.74 34.06-9.36 34.84-.07.03-.39.06-.71.08v.03c.17 13.54.87 37.75 2.68 60.35 0 0 .01.02 0 .02.03.27.05.55.07.83.09-.35.16-.64.19-.83.01 0 0-.02 0-.02z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M775.39 815.29c1.06-4.9 1.97-9.13 2.49-11.21 2.04-8.18 17.12-43.06 24.86-53.71 7.81-10.74 17.33-37.43 18.16-39.76-1.58 2.33-3.17 4.67-4.73 6.98-3.56 9.26-9.79 24.38-15.05 31.6-8.04 11.06-23.06 45.9-25.18 54.41-.53 2.1-1.45 6.35-2.51 11.27-2.11 9.81-8.01 32.13-8.15 32.56.01.87.02 1.79.04 2.78.32-.02.64-.05.71-.08 1.62-.78 3.64-8.27 9.36-34.84zm8.49 123.94c.63-2.53 1.86-7.98 3.55-15.52 1.65-7.37 3.66-16.35 5.88-25.98v-.01c-.5-2.61-.8-4.28-.88-4.7l1.97-.35c0 .02.01.08.03.16 6.29-27.06 13.9-57.75 19.44-71.6 6.73-16.81 13.95-69.23 18.07-102.78-.82-1.01-1.3-1.58-1.34-1.62l1.52-1.3c.01.01.06.07.16.18 1.7-13.97 2.8-24.17 3.02-26.26-1.09 1.59-2.29 3.35-3.58 5.24-2.62 9.33-8.31 29.63-16.74 59.83-15.86 56.83-27.63 95.2-35 114.03-7.26 18.55-10.67 36.01-11.72 42.04 0 0 .01.02 0 .02-.03.19-.1.48-.19.83.04.49.08.98.13 1.46.24 2.89.5 5.74.79 8.53.03-.24 4-29.52 12.86-52.16 7.39-18.89 19.19-57.32 35.07-114.22 6.93-24.82 12.01-42.96 15.05-53.81-3.33 28.77-12.11 99.68-19.94 119.25-7.95 19.85-20.04 73.8-26.54 102.78-1.69 7.53-2.91 12.97-3.54 15.47-2.24 8.97-2.29 28.96-2.15 38.06l.03.15v-1.22c.25 1.14.48 3.25.7 4.32l.15 1.14c.39 2.09.69 3.99.86 5.59.09.83.24 1.99.43 3.41-.15-6.8-.73-40.39 1.91-50.96z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M832.28 715.71c-.11.9-.22 1.81-.34 2.74 5.88 7.15 29.22 36.67 36.1 61.63 4.18 15.15 8.95 26.3 12.55 33.49.04-.18.06-.28.06-.31l1.96.39c-.02.09-.21 1.07-.55 2.78 2.46 4.62 4.1 6.94 4.14 7l.36-.26v-.18l-.03-2.32c0-.15-.01-.29-.01-.44-2.96-4.82-10.39-18.3-16.56-40.69-7.68-27.84-35.39-61.11-37.68-63.83zm24.5 221.28c-3.97 21.93-6.6 36.43-11.51 41.34-5.94 5.94-12.3 10.41-24.68-.06-12.32-10.42-25.47-81.64-26.17-85.43v.02c-.37 1.64-.75 3.26-1.12 4.87 2.58 13.45 10.41 51.86 19.27 71.54 0-.03-.01-.06-.01-.09l1.97-.32c.16.95.5 3.1.93 6.06 1.27 2.13 2.55 3.8 3.83 4.88 5.82 4.92 10.54 6.75 14.52 6.75 4.27 0 7.68-2.1 10.65-4.72.27-1.67.47-2.73.52-2.98l1.96.38c0 .02-.02.11-.05.26 5.2-5.52 7.71-19.38 11.84-42.14.69-3.83 1.43-7.89 2.23-12.19 4.96-26.69 18.23-94.2 21.09-108.72-.46-.87-.96-1.82-1.48-2.86-1.09 5.53-16.2 82.3-21.58 111.21-.78 4.3-1.51 8.37-2.21 12.2z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M794.43 892.84s0-.01 0 0c-.01-.09-.03-.15-.03-.17l-1.97.35c.07.41.38 2.09.88 4.7.37-1.61.75-3.23 1.12-4.87v-.01zm88.19-79.19-1.96-.39c-.01.03-.03.13-.06.31.52 1.04 1.02 1.99 1.48 2.86.33-1.71.52-2.69.54-2.78z"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "Right_Knee" },
	          _react2.default.createElement(
	            "g",
	            { className: "bodyPartsGroup" },
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M637.29 1052.27v.4c.06-.1.11-.2.15-.29a.717.717 0 0 0-.15-.11z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M650.7 1039.36c11.26-14.11 6.99-47.33 5.35-57.54-.76-.67-1.49-1.37-2.2-2.08-.08-.08-.15-.18-.23-.26.65 3.58 7.55 43.57-4.48 58.63-2.62 3.28-7.68 5.15-12.05 5.56.04.67.07 1.33.09 2 4.94-.44 10.52-2.56 13.52-6.31zm36.49-7.06c-6.99-5.44-1.84-47.23.74-63.01-.95 2.11-1.91 3.99-2.88 5.61v.02c-2.25 15.43-6.81 52.95.92 58.96 2.94 2.29 6.57 3.08 10.19 3.08 6.48 0 12.9-2.54 15.29-3.59.01-.04.01-.08.02-.12.07-.43.14-.84.21-1.28v-.01l.06-.4-.21-.43c-.16.08-15.93 7.71-24.34 1.17zm-49.97 19.92c.02.01.04.03.07.05v-.19c-.1.04-.16.09-.07.14z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M637.54 1051.97c-.06.03-.17.06-.25.1v.19c.05.03.1.07.15.1.05-.12.09-.26.1-.39zm.01-.06c0 .02-.01.04-.01.06.05-.02.07-.04.01-.06z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M696.88 1254.32c.18-4.91.4-9.09.62-11.95.64-8.26 6.77-30.61 11.64-47.76-6.69-12.89-12.34-31.5-15.35-49.28-1.2 20.83-2.44 72.39 3.09 108.99z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M685.97 1033.88c-7.73-6.01-3.17-43.53-.92-58.96v-.02c-1.27 2.13-2.55 3.81-3.83 4.89-5.82 4.92-10.54 6.75-14.52 6.75-4.27 0-7.68-2.1-10.65-4.72 1.64 10.21 5.91 43.43-5.35 57.54-2.99 3.75-8.58 5.87-13.52 6.32.08 2.08.12 4.16.11 6.24v.16c.08-.04.19-.07.25-.1 0-.02.01-.04.01-.06.06.02.04.04-.01.06-.01.13-.05.27-.11.4 7.27 5.24 28 55.39 38.12 120.72 6.35 40.97 7.6 76.79 7.77 94.49.12 11.54-.14 22.25-.72 30.18-.48 6.63-1.04 9.69-1.56 11.15 4.54 1.09 14.41 3.75 19.02 5.01-.48-1.41-1-3.21-1.56-5.66-1.84-8-2.17-26.23-1.92-42.08-9.2-44.92-4.55-125.42-4.21-130.06v-.01c-2.37-17.11-3.21-33.54-2.79-44.99.79-21.24 13.92-38.21 19.68-44.66.58-3.32 1.34-7.9 2.18-13.08-2.39 1.05-8.81 3.59-15.29 3.59-3.61-.02-7.24-.81-10.18-3.1z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M691.58 1091.19c-.97 26.01 4.83 75.1 18.18 101.21 2.5-8.78 4.56-15.89 5.19-18.49 2.98-12.28 6.9-30.25 7.51-42.36.78-15.81-2.89-27.77-5.64-38.43-1.98-7.68-10.96-29.14-8.36-42.32-3.14 3.11-16.02 17.24-16.88 40.39zm-45.08 111.83c5.68 21.78 24.86 96.93 26.71 104.16 2.66.78 5 1.37 5.86 1.3 2.48-4.56 5.37-64.94-5.49-135.08-6.29-40.61-15.65-71.13-20.67-85.71-6.94-20.17-13.03-29.8-15.67-32.8-.17 6.33-.74 12.65-1.75 18.92-.62 3.88-1.28 8.05-1.92 12.33l.72 2.51c.07.92 6.3 91.7 12.21 114.37z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              d: "M648.4 1301.39c4.16-.59 12.48 2 19.83 4.28.89.28 1.82.56 2.75.85-3.03-11.88-20.96-82.08-26.41-102.99-5.05-19.4-10.32-90.71-11.84-111.65-.11.73-.21 1.46-.32 2.2-1.85 13.06-3.43 26.29-3.79 35.47-1.01 24.96 6.98 98.84 9.98 108.83 2.99 9.98 6.98 42.93 4.99 55.91-.4 2.58-.95 5.23-1.65 7.98 0 .01-.01.03-.01.04l.27-.04 6.2-.88z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M692.37 1136.11v.01c.01-.12.02-.19.02-.21l2 .16c-.01.17-.27 3.56-.6 9.26 3.01 17.78 8.65 36.39 15.35 49.28.03-.09.05-.19.08-.28.15-.54.3-1.07.45-1.59.03-.11.06-.22.1-.34-13.35-26.11-19.15-75.2-18.18-101.21.86-23.15 13.74-37.28 16.89-40.39.01-.04.01-.08.02-.13.01-.06.03-.12.04-.19.04-.19.08-.4.12-.63.17-.89.38-2.04.62-3.39-5.76 6.46-18.89 23.43-19.68 44.66-.44 11.45.4 27.88 2.77 44.99z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M693.79 1145.33c-.52-3.08-.99-6.15-1.42-9.21-.34 4.65-4.99 85.15 4.21 130.06 0-.14 0-.29.01-.43.02-1.71.05-3.38.09-5.02v-.01c.06-2.23.13-4.38.2-6.4-5.53-36.6-4.29-88.16-3.09-108.99z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m694.39 1136.07-2-.16c0 .02-.01.09-.02.21.43 3.06.9 6.13 1.42 9.21.33-5.7.59-9.09.6-9.26zm-20.81 37.33c10.86 70.14 7.97 130.52 5.49 135.08.4.07 1.09.22 1.97.43.52-1.46 1.08-4.53 1.56-11.15.58-7.93.84-18.64.72-30.18-.17-17.7-1.42-53.52-7.77-94.49-10.12-65.33-30.85-115.48-38.12-120.72-.04.1-.09.2-.15.29 0 .5-.01 1-.01 1.5l-.03.73c2.64 3 8.73 12.63 15.67 32.8 5.02 14.58 14.38 45.1 20.67 85.71zm-2.6 133.12c.75.23 1.5.45 2.23.66-1.85-7.23-21.03-82.38-26.71-104.16-5.91-22.67-12.14-113.45-12.21-114.37l-.72-2.51c-.13.86-.26 1.71-.38 2.57-.15 1.05-.31 2.11-.46 3.17 1.52 20.94 6.79 92.25 11.84 111.65 5.45 20.91 23.38 91.11 26.41 102.99z"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Left_Knee" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Knee");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Knee");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M851.39 1038.11c-12.02-15.07-5.13-55.05-4.48-58.63-.08.08-.15.18-.23.26-.71.71-1.44 1.41-2.2 2.08-1.64 10.21-5.91 43.43 5.35 57.54 3.09 3.87 8.04 5.99 13 6.34l.09-2c-4.37-.33-8.81-2.19-11.53-5.59zm-36.83-4.23c7.73-6.01 3.16-43.55.92-58.97-.97-1.63-1.94-3.53-2.89-5.65 2.59 15.77 7.74 57.59.75 63.03-8.2 6.37-24.33-1.66-25.28-2.14.1.6.19 1.2.29 1.79.05.4.12.78.18 1.17 1.74.81 8.76 3.85 15.85 3.85 3.6 0 7.24-.79 10.18-3.08z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              style: {
	                fill: this.state.bodyTitles === "Knee" || this.state.bodyHoverTitles === "Knee" ? "#f58220" : "#af9763"
	              },
	              d: "M829.55 1306.51c.93-.28 1.86-.57 2.74-.85 7.35-2.28 15.68-4.87 19.84-4.28l5.93.85c-.7-2.74-1.24-5.38-1.64-7.95-2-12.98 2-45.93 4.98-55.91 3.01-9.99 11-83.87 9.99-108.83-.35-8.89-1.85-21.58-3.63-34.23-1.56 21.38-6.78 88.96-11.8 108.21-5.46 20.92-23.38 91.11-26.41 102.99zm-20.61-215.32c-.89-24.05-14.71-38.33-17.19-40.69v-.01c-.17-.16-.27-.25-.32-.3.02.1.04.21.06.3v.01l.03.17c2.68 13.17-6.36 34.75-8.35 42.45-2.75 10.66-6.42 22.62-5.63 38.43.6 12.11 4.52 30.08 7.51 42.36.64 2.64 2.74 9.89 5.28 18.83.03.1.06.21.09.32 12.92-26.5 19.47-76.29 18.52-101.87z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              style: {
	                fill: this.state.bodyTitles === "Knee" || this.state.bodyHoverTitles === "Knee" ? "#f58220" : "#af9763"
	              },
	              d: "M849.83 1039.36c-11.26-14.11-6.99-47.33-5.35-57.54-2.98 2.62-6.38 4.72-10.65 4.72-3.98 0-8.7-1.82-14.52-6.75-1.28-1.08-2.56-2.75-3.83-4.88 2.24 15.42 6.81 52.95-.92 58.97-2.95 2.29-6.58 3.09-10.2 3.09-7.09 0-14.1-3.04-15.85-3.85.01.04.01.08.02.12v.01c.84 5.16 1.6 9.73 2.19 13.07 5.82 6.34 19.43 23.4 20.22 44.8.42 11.46-.42 27.91-2.79 45.03v.01c.38 5.11 5.08 88.36-4.58 132.78l-.12-.29c.18 15.24-.2 32.04-1.94 39.61-.43 1.85-.82 3.32-1.2 4.54 6.61-1.28 15.32-3.1 19.17-3.9-.52-1.47-1.07-4.54-1.56-11.13-.58-7.93-.84-18.65-.72-30.18.18-17.7 1.42-53.52 7.77-94.5 10.22-65.98 30.26-116.48 37.33-120.87.14-.09.28-.15.41-.21v-.09c-.01-2.07.03-4.15.11-6.22-4.95-.36-9.9-2.47-12.99-6.34z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyParts",
	              style: {
	                fill: this.state.bodyTitles === "Knee" || this.state.bodyHoverTitles === "Knee" ? "#f58220" : "#af9763"
	              },
	              d: "M806.73 1145.35v.02c-2.79 16.46-8.98 37.86-15.26 51.38 4.76 16.82 10.43 37.69 11.03 45.62.26 3.38.52 8.6.71 14.7 6.02-36.71 4.75-90.36 3.52-111.72zm20.22 28.04c-10.87 70.14-7.97 130.52-5.49 135.08.86.08 3.2-.51 5.86-1.29 1.83-7.18 21.03-82.38 26.71-104.16 4.85-18.6 10.59-90.4 12.52-116.12-.68-4.55-1.37-8.98-2.03-13.09-1.04-6.43-1.62-12.92-1.77-19.41-2.26 2.32-7.75 11.83-15.14 33.29-5.01 14.58-14.37 45.1-20.66 85.7z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M806.73 1145.35c-.32-5.71-.58-9.11-.59-9.28l1.99-.16c0 .02.01.1.02.24 2.37-17.12 3.21-33.57 2.79-45.03-.79-21.4-14.4-38.46-20.22-44.8.25 1.42.46 2.61.63 3.53.02.12.05.23.07.34.06.05.15.14.32.3v.01c2.48 2.36 16.3 16.64 17.19 40.69.95 25.58-5.6 75.37-18.52 101.87.12.42.25.84.37 1.27v.01c.22.79.45 1.6.68 2.41 6.28-13.52 12.47-34.92 15.26-51.38.01-.01.01-.01.01-.02z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M808.15 1136.16c-.42 3.05-.89 6.12-1.42 9.19 1.23 21.36 2.5 75.01-3.52 111.72.04 1.19.07 2.4.11 3.65.03 1.64.07 3.32.09 5.03.02.96.03 1.93.04 2.9l.12.29c9.66-44.42 4.96-127.67 4.58-132.78z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M806.14 1136.07c.01.17.27 3.57.59 9.28.53-3.07 1-6.14 1.42-9.18v-.02c-.01-.14-.02-.22-.02-.24l-1.99.16zm18.83 37.02c-6.35 40.97-7.59 76.79-7.77 94.5-.12 11.53.14 22.25.72 30.18.48 6.59 1.04 9.66 1.56 11.13 1.23-.26 1.97-.42 1.97-.42-2.48-4.56-5.37-64.94 5.49-135.08 6.29-40.61 15.65-71.13 20.66-85.7 7.38-21.46 12.87-30.97 15.14-33.29 0-.08-.01-.16-.01-.24v-.01c-.01-.72-.02-1.43-.02-2.15-.14.06-.27.13-.41.21-7.06 4.39-27.11 54.89-37.33 120.87zm2.34 134.09c.73-.21 1.48-.44 2.23-.67 3.03-11.88 20.96-82.07 26.41-102.99 5.02-19.25 10.24-86.84 11.8-108.21-.06-.41-.11-.82-.17-1.24.01-.01 0-.01 0-.01-.25-1.79-.51-3.59-.77-5.36l-.27-1.81c-1.94 25.72-7.67 97.52-12.52 116.12-5.68 21.79-24.87 97-26.71 104.17z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-knee" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Knee");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Knee");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "1029",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 -96.754)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.53204 0 0 .7655 386.016 999.919)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Knee" ? "#f58220" : "#af9763"
	                },
	                d: "M1120.013 1159.253v-25.776h5.184v11.448l10.512-11.448h7.02l-9.72 10.044 10.224 15.732h-6.732l-7.092-12.096-4.213 4.32v7.776h-5.183ZM1162.85 1159.253h-4.931v-9.54c0-2.016-.109-3.312-.325-3.888a2.551 2.551 0 0 0-1.007-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.685.468-1.117 1.116-1.369 1.872-.251.756-.395 2.196-.395 4.284v8.46h-4.932v-18.684h4.572v2.772c1.62-2.124 3.671-3.168 6.156-3.168 1.08 0 2.088.18 2.987.576.9.396 1.584.9 2.053 1.512.467.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592ZM1178.685 1153.313l4.932.828c-.649 1.8-1.657 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.225-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.375 4.644 2.303 8.424h-12.383c.036 1.476.432 2.628 1.224 3.42.755.828 1.691 1.224 2.843 1.224.757 0 1.405-.216 1.945-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1198.715 1153.313l4.932.828c-.649 1.8-1.657 3.168-2.988 4.104-1.369.972-3.097 1.44-5.149 1.44-3.24 0-5.651-1.08-7.2-3.204-1.224-1.692-1.835-3.816-1.835-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.375 4.644 2.303 8.424h-12.383c.035 1.476.431 2.628 1.223 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.937-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Right_Ankle" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Foot");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Foot");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Foot" || this.state.bodyHoverTitles === "Foot" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M676.39 1310.09c-2.05-.45-4.89-1.32-8.75-2.51-6.79-2.11-15.25-4.75-18.96-4.21l-7.01 1-.01-.07-.09-.64c-.06.21-.11.43-.17.64-2.9 10.56-7.78 22.39-13.79 35.92-7.99 17.97-31.64 38.92-41.63 45.92-9.98 6.98 5.7 18.98 16.67 20.97 10.98 2 40.94 2 48.92 0 7.99-1.99 12.98-1 17.98-15.97 4.98-14.97 9.98-39.95 15.98-40.94 5.99-1 22.37-7.66 20.28-19.15-1.71-9.42-2.96-10.92-4.38-13.82-8.2-3.22-25.04-7.13-25.04-7.14z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m641.67 1304.37 7.01-1c3.71-.54 12.17 2.1 18.96 4.21 3.86 1.2 6.7 2.06 8.75 2.51l2.68-1.61c-.86.07-3.2-.52-5.86-1.3.08.34.13.52.14.56l-1.93.49c-.02-.06-.17-.66-.44-1.71-.93-.29-1.86-.57-2.75-.85-7.35-2.28-15.67-4.87-19.83-4.28l-6.2.88-.27.04c-.11.44-.24.9-.36 1.35l.09.64.01.07z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m671.42 1308.23 1.93-.49c-.01-.04-.06-.22-.14-.56-.73-.21-1.48-.43-2.23-.66.27 1.05.42 1.65.44 1.71zm8.47 2.11c-.26.08-.57.12-.94.12-.65 0-1.51-.13-2.56-.37 0 0 16.85 3.92 25.05 7.14-.43-.89-.88-1.9-1.37-3.31-4.61-1.25-14.48-3.92-19.02-5.01-.43 1.18-.83 1.32-1.16 1.43z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M676.39 1310.09c1.05.23 1.91.37 2.56.37.37 0 .68-.04.94-.12.33-.11.73-.25 1.15-1.43-.88-.21-1.57-.36-1.97-.43l-2.68 1.61z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-foot is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Foot");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Foot");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "297",
	              y: "1330",
	              width: "90",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              null,
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.47065 0 0 -.7655 1031.48 1496.8)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Foot" ? "#f58220" : "#af9763"
	                },
	                d: "M305.097 1363.031v-25.776h17.64v4.356h-12.456v6.12h10.764v4.356h-10.764v10.944h-5.184ZM325.863 1353.419c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM347.853 1353.419c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM379.563 1344.347v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Left_Ankle" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Ankle");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Ankle");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              style: {
	                fill: this.state.bodyTitles === "Ankle" || this.state.bodyHoverTitles === "Ankle" ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M832.89 1307.58c-5.84 1.81-9.39 2.89-11.31 2.89-1.49.19-15.05 3.31-22.2 4.97-1.78 4.41-3.17 4.47-5.18 15.62-2.1 11.49 14.29 18.15 20.28 19.15 6 .99 10.99 25.97 15.98 40.94 5 14.97 9.98 13.98 17.98 15.97 7.98 2 37.94 2 48.91 0 10.98-1.99 26.66-13.99 16.67-20.97-9.98-7-33.63-27.95-41.62-45.92-6.01-13.52-10.88-25.33-13.79-35.88l-6.77-.97c-3.71-.54-12.16 2.09-18.95 4.2z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M832.29 1305.67c-.89.28-1.82.56-2.74.85-.27 1.05-.42 1.65-.44 1.72l-1.94-.49c.01-.04.06-.23.14-.55-2.66.78-5 1.37-5.86 1.29 0 0 2.16 1.74.12 1.99 1.91 0 5.47-1.07 11.31-2.89 6.79-2.11 15.25-4.74 18.96-4.2l6.77.97c0-.02-.01-.03-.01-.05v-.01c-.18-.67-.36-1.35-.53-2.01 0-.01 0-.02-.01-.03l-5.93-.85c-4.16-.61-12.49 1.98-19.84 4.26z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M829.11 1308.23c.02-.07.17-.67.44-1.72-.75.23-1.51.46-2.23.67-.08.32-.13.52-.14.55l1.93.5zm-8.47 2.11c-.33-.11-.73-.25-1.16-1.45-3.85.81-12.56 2.62-19.17 3.9-.32 1.05-.63 1.9-.93 2.64 7.15-1.66 20.7-4.78 22.2-4.97-.38 0-.69-.04-.94-.12z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M820.64 1310.34c.25.09.57.13.94.13 2.04-.25-.12-1.99-.12-1.99s-.74.16-1.97.42c.42 1.19.82 1.33 1.15 1.44z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-ankle" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Ankle");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Ankle");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "1282",
	              width: "110",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 -47.998)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.49111 0 0 .7655 440.492 1203.7)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Ankle" ? "#f58220" : "#af9763"
	                },
	                d: "M1145.85 1363.031h-5.652l-2.232-5.868h-10.332l-2.124 5.868h-5.508l10.044-25.776h5.508l10.296 25.776Zm-9.576-10.188-3.528-9.576-3.492 9.576h7.02ZM1165.54 1363.031h-4.932v-9.54c0-2.016-.108-3.312-.324-3.888a2.551 2.551 0 0 0-1.008-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.684.468-1.116 1.116-1.368 1.872s-.396 2.196-.396 4.284v8.46h-4.932v-18.684h4.572v2.772c1.62-2.124 3.672-3.168 6.156-3.168 1.08 0 2.088.18 2.988.576.9.396 1.584.9 2.052 1.512.468.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592ZM1170.394 1363.031v-25.776h4.932v13.68l5.796-6.588h6.084l-6.408 6.84 6.84 11.844h-5.328l-4.68-8.388-2.304 2.412v5.976h-4.932ZM1190.604 1337.255h4.932v25.776h-4.932zM1211.404 1357.091l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Chest" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Heart");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Heart");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.Heart.includes(this.state.bodyTitles) || male_human_body.Heart.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M719.72 479.09c10.83-2.29 22.97-2.25 26.55.62 1.58 1.26 2.69 4.29 3.39 8.13l.04-33.08c-2.68 8.34-11.05 20.22-29.98 24.33z"
	            }),
	            _react2.default.createElement("path", {
	              // onClick={(e) => this.modalMaleBodySingleContentOpen(e, "Heart")}
	              // onMouseOver={(e) => this.handleHoverBodyPart("Heart")}
	              // onMouseLeave={(e) => this.handleHoverBodyPart(null)}
	              style: {
	                fill: male_human_body.Heart.includes(this.state.bodyTitles) || male_human_body.Heart.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M620.71 403.93c4.42 7.1 9.18 15.38 10.28 19.75.23.95.53 2.28.9 3.91 2.71 12.03 9.05 40.2 20.17 47.04 12.16 7.48 42.09 7.11 65.37 2.87 21.12-3.84 30.24-18.34 31.22-27.16 1.01-9.02-2.1-50.45-3.99-61.79-.6-3.58-.59-8.21-.58-13.11.03-11.34.06-24.19-7.69-26.13-13.75-3.43-46.12-4.31-74.44 7.96-21.46 9.3-32.67 15.48-42.38 27.51-3.69 4.59-4 11.07-.76 16.14.62.96 1.25 1.97 1.9 3.01zm130.32 52.17-.05 29.94v1.26c.08-.41.17-.82.26-1.22v-.04c.7-2.98 1.7-5.28 3.02-6.33 3.58-2.87 15.74-2.91 26.58-.61-17.96-3.88-26.43-14.77-29.55-23v-.04c-.1-.26-.17-.5-.26-.75v.79z"
	            }),
	            _react2.default.createElement("path", {
	              // onClick={(e) => this.modalMaleBodySingleContentOpen(e, "Heart")}
	              // onMouseOver={(e) => this.handleHoverBodyPart("Heart")}
	              // onMouseLeave={(e) => this.handleHoverBodyPart(null)}
	              style: {
	                fill: male_human_body.Heart.includes(this.state.bodyTitles) || male_human_body.Heart.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M880.95 384.78c-4.85-6.01-10.08-10.57-16.77-14.78-6.7-4.21-14.87-8.08-25.6-12.73-17.64-7.64-36.85-10.19-52.15-10.19-9.27 0-17.11.94-22.3 2.23-7.75 1.94-7.72 14.79-7.69 26.13.01 4.9.03 9.53-.57 13.11-1.89 11.34-5 52.78-4 61.79.98 8.82 10.1 23.32 31.22 27.16 23.29 4.23 53.22 4.61 65.37-2.87 11.13-6.85 17.47-35.02 20.18-47.05.36-1.62.66-2.95.9-3.9 1.25-5.01 7.31-15.14 12.17-22.76 3.24-5.07 2.93-11.55-.76-16.14zM749.96 453.9c-.08.28-.17.57-.26.87l-.04 33.08c.09.52.18 1.05.26 1.6.14.91.25 1.85.34 2.82.17-1.77.41-3.43.72-4.96v-1.26l.05-29.94v-.79c-.31-.89-.58-1.75-.77-2.56-.08.36-.18.75-.3 1.14z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M750.26 452.75a14.5 14.5 0 0 1-.29-1.56 7.13 7.13 0 0 1-.09-.62c-.08-.71-.13-1.6-.17-2.65v3.27l-.01 2.71v.87c.09-.29.18-.58.26-.87.12-.39.22-.78.3-1.15zm-.53-19.12-.01 7.57c.05-2.3.14-4.85.27-7.57.08-1.74.17-3.54.27-5.38-.08-1.41-.17-2.84-.26-4.29-.08-1.28-.17-2.58-.26-3.87v3.87l-.01 9.67zm-127.47-24.16c-.01.03-.09.2-.23.49.44.72.84 1.42 1.23 2.1.5-1.07.78-1.69.81-1.74l-1.81-.85zm8.46 21.98c.34 1.49.72 3.12 1.15 4.84.42-2.47.75-4.18.85-4.64l-1.95-.43c0 .01-.02.1-.04.22-.01 0-.01 0-.01.01 0-.01 0-.01 0 0z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M750.64 450.57c-.07.67-.2 1.4-.38 2.18.19.81.46 1.67.77 2.56l.06-39.53c-.31 4.18-.6 8.43-.83 12.47.55 9.9.79 18.61.38 22.32zm-.93-2.65.01-6.72c-.06 2.62-.07 4.91-.01 6.72z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.97 451.19c.06.49.16 1.01.29 1.56.18-.78.31-1.51.38-2.18.41-3.71.17-12.42-.38-22.32-.1 1.84-.19 3.64-.27 5.38-.13 2.72-.22 5.27-.27 7.57l-.01 6.72c.03 1.04.09 1.94.17 2.65.02.2.05.41.09.62z"
	            }),
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "m745.88 364.88.09 1.69c-.02-.57-.05-1.14-.09-1.69zm-.3-3.39c.13 1.08.22 2.18.3 3.31-.07-1.12-.17-2.23-.3-3.31zm-.5-3.19c.2 1 .36 2.05.49 3.13a37.24 37.24 0 0 0-.49-3.13zm.89 8.35.06 1.66c-.01-.56-.03-1.11-.06-1.66zm-1.64-11.28zm1.75 16.55v1.64c.01-.54 0-1.09 0-1.64zm0 2.02v1.5-1.5zm-8.14-26.23c-.34-.13-.69-.24-1.06-.34.37.09.72.21 1.06.34zm5.33 5.05zm2.8 17.51c.01.53.01 1.06.01 1.59 0-.53-.01-1.06-.01-1.59zm-.04-1.9.03 1.67c0-.55-.01-1.11-.03-1.67zm10.41-13.7zm1.1-2.43c-.4.71-.74 1.47-1.04 2.28.29-.81.64-1.57 1.04-2.28zm-2.46 8.2zm-13.23-9.89c.53.66 1 1.39 1.41 2.19-.41-.8-.87-1.54-1.41-2.19zm21.8-3.18zm-5.41 3.75zm-3.8 22.89v1.43-1.43zm0-.41c0-1.04 0-2.08.01-3.12-.01 1.04-.01 2.08-.01 3.12zm.29-9.94zm-.19 3.36c-.04 1.04-.06 2.09-.08 3.15.01-1.05.04-2.1.08-3.15zm1.1-9.6zm125.31 27.36c-4.85-6.01-10.08-10.57-16.77-14.78-6.7-4.21-14.87-8.08-25.6-12.73-17.64-7.64-36.85-10.19-52.15-10.19-9.27 0-17.11.94-22.3 2.23-7.75 1.94-7.72 14.79-7.69 26.13.01 4.9.03 9.53-.57 13.11-1.89 11.34-5 52.78-4 61.79.98 8.82 10.1 23.32 31.22 27.16 23.29 4.23 53.22 4.61 65.37-2.87 11.13-6.85 17.47-35.02 20.18-47.05.36-1.62.66-2.95.9-3.9 1.25-5.01 7.31-15.14 12.17-22.76 3.24-5.07 2.93-11.55-.76-16.14z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.Heart.includes(this.state.bodyTitles) || male_human_body.Heart.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M741.85 350.55c.53.66 1 1.39 1.41 2.19 0 .01.01.01.01.02.4.8.75 1.65 1.05 2.57 0 .01.01.03.01.04.29.91.54 1.88.74 2.88 0 .02.01.04.01.05.2 1.01.36 2.05.49 3.13 0 .02.01.04.01.07.13 1.08.22 2.18.3 3.31v.07l.09 1.69v.08l.06 1.66v.06l.03 1.67v.23c.01.53.01 1.06.01 1.59v3.58c-.01 4.82-.02 9.37.55 12.78.97 5.83 2.22 18.98 3.11 31.87l.08-68.47c-2.74-.04-5.56-.32-7.96-1.07zm9.51 61.74v-.06c.81-10.09 1.76-19.37 2.54-24.01.57-3.41.55-7.96.54-12.78v-1.84c0-1.04 0-2.08.01-3.12v-.31c.01-1.05.04-2.11.08-3.15 0-.08.01-.16.01-.25.04-1.05.1-2.09.18-3.12.01-.07.01-.14.02-.21.09-1.03.2-2.03.33-3.01l.03-.18c.14-.98.32-1.93.53-2.84.01-.05.03-.11.04-.16.22-.91.47-1.77.77-2.59.02-.05.03-.09.05-.14.3-.81.65-1.58 1.04-2.28.02-.04.05-.08.07-.13.2-.35.41-.68.63-1-1.87.23-4.38.47-7.04.5l-.1 60.61v.08l-.01 3.47.27-3.47c.01 0 .01 0 .01-.01z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.Heart.includes(this.state.bodyTitles) || male_human_body.Heart.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M751.1 412.29v-.06l.1-60.61c-.46.01-.92.01-1.38 0l-.08 68.47c.09 1.3.18 2.59.26 3.87.09 1.45.18 2.88.26 4.29.23-4.04.52-8.29.83-12.47l.01-3.47v-.02z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M746.08 375.44v-3.58c0-.53-.01-1.06-.01-1.59v-.23l-.03-1.67v-.06c-.01-.56-.03-1.11-.06-1.66v-.08c-.02-.57-.05-1.13-.09-1.69v-.07c-.07-1.13-.17-2.23-.3-3.31 0-.02-.01-.04-.01-.07-.13-1.08-.29-2.12-.49-3.13 0-.02-.01-.04-.01-.05-.2-1.01-.45-1.97-.74-2.88 0-.01-.01-.03-.01-.04-.3-.91-.64-1.77-1.05-2.57 0-.01-.01-.01-.01-.02-.41-.8-.87-1.53-1.41-2.19-1.03-1.27-2.32-2.24-3.91-2.84-.34-.13-.69-.24-1.06-.34-7.29-1.82-19.72-2.94-34.02-1.83l-.58 1.75c-.03-.02-1.36-.45-4.01-1.32h-.02c-11.94 1.3-24.89 4.18-37.1 9.46-10.89 4.72-19.17 8.66-25.99 12.96-6.82 4.3-12.16 8.96-17.14 15.14-4.07 5.04-4.57 12.09-1.31 17.78.08.15.18.3.27.45.86-.39 1.82-.83 1.83-.84-3.24-5.07-2.93-11.55.76-16.14 9.71-12.03 20.92-18.21 42.38-27.51 28.32-12.27 60.69-11.39 74.44-7.96 7.75 1.94 7.72 14.79 7.69 26.13-.01 4.9-.02 9.53.58 13.11 1.89 11.34 5 52.77 3.99 61.79-.98 8.82-10.1 23.32-31.22 27.16-23.28 4.24-53.21 4.61-65.37-2.87-11.12-6.84-17.46-35.01-20.17-47.04-.37-1.63-.67-2.96-.9-3.91-1.1-4.37-5.86-12.65-10.28-19.75-.01.01-1.26 0-2.35.02 1.33 2.13 2.57 4.14 3.67 6.01.13-.29.21-.46.23-.49l1.81.85c-.02.05-.31.67-.81 1.74 3.19 5.53 5.19 9.7 5.79 12.11.23.94.53 2.25.89 3.86.23 1.03.49 2.17.78 3.41.02-.12.04-.21.04-.22l1.95.43c-.1.46-.42 2.17-.85 4.64v.01c3.41 13.91 9.49 34.1 19.15 40.03 7.22 4.45 19.72 6.22 33.31 6.22 6.97 0 14.21-.47 21.2-1.27 1.78-1.34 2.89-2.21 2.94-2.25l1.24 1.57c-.04.03-.12.09-.22.17h.01c2.85-.38 5.63-.82 8.3-1.31.65-.12 1.28-.24 1.9-.37.01 0 .02-.01.03-.01 18.92-4.11 27.3-15.98 29.98-24.32v-.87l.01-2.71v-3.27c-.06-1.82-.05-4.1.01-6.72l.01-7.57.01-9.67v-3.87c-.89-12.89-2.14-26.03-3.11-31.87-.58-3.4-.57-7.95-.56-12.77zm136.43 8.09c-9.97-12.37-21.37-18.66-43.14-28.1-12.2-5.29-25.16-8.17-37.09-9.47-2.67.87-4 1.31-4.03 1.33l-.59-1.76c-14.3-1.1-26.72.02-34.01 1.84-.45.11-.88.26-1.28.43-1.72.7-3.07 1.84-4.13 3.33-.22.32-.43.65-.63 1-.02.04-.05.08-.07.13-.4.71-.74 1.47-1.04 2.28-.02.05-.03.09-.05.14-.3.82-.55 1.69-.77 2.59-.01.05-.03.11-.04.16-.21.91-.38 1.86-.53 2.84l-.03.18c-.14.98-.25 1.98-.33 3.01-.01.07-.01.14-.02.21a77.08 77.08 0 0 0-.18 3.12c0 .08-.01.16-.01.25-.04 1.04-.06 2.09-.08 3.15v.31c-.01 1.04-.02 2.08-.01 3.12v1.84c.01 4.82.03 9.37-.54 12.78-.78 4.64-1.73 13.92-2.54 24.01v.08c-.09 1.14-.18 2.31-.27 3.47l-.06 39.53c.09.25.16.49.26.75v.04c3.12 8.23 11.59 19.12 29.55 23 .62.13 1.25.25 1.89.37 2.68.49 5.47.93 8.32 1.31-.1-.08-.18-.14-.22-.17l1.24-1.57c.05.04 1.16.91 2.94 2.25 6.98.8 14.24 1.27 21.19 1.27 13.6 0 26.09-1.77 33.32-6.22 9.65-5.93 15.73-26.11 19.15-40.03-.43-2.47-.75-4.19-.85-4.65l1.95-.43c0 .01.02.11.05.25v-.01c.28-1.25.55-2.4.78-3.44.36-1.6.65-2.92.89-3.85.6-2.41 2.61-6.58 5.78-12.12-.49-1.07-.78-1.68-.8-1.73l1.81-.85c.01.03.09.19.22.48 1.27-2.14 2.69-4.44 4.24-6.91-.31-.12-.5-.18-.53-.19l.63-1.9c.03.01.38.13.97.36 3.25-5.72 2.75-12.77-1.31-17.81zm-.8 17.39c-4.86 7.62-10.92 17.75-12.17 22.76-.24.95-.54 2.28-.9 3.9-2.71 12.03-9.05 40.2-20.18 47.05-12.15 7.48-42.08 7.1-65.37 2.87-21.12-3.84-30.24-18.34-31.22-27.16-1-9.01 2.11-50.45 4-61.79.6-3.58.58-8.21.57-13.11-.03-11.34-.06-24.19 7.69-26.13 5.19-1.29 13.03-2.23 22.3-2.23 15.3 0 34.51 2.55 52.15 10.19 10.73 4.65 18.9 8.52 25.6 12.73 6.69 4.21 11.92 8.77 16.77 14.78 3.69 4.59 4 11.07.76 16.14z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M743.26 352.74c0 .01.01.01.01.02 0-.01-.01-.02-.01-.02zm-5.32-5.03c1.6.6 2.88 1.57 3.91 2.84 2.4.75 5.22 1.03 7.97 1.07v-2.14c-5.53-.11-9.95-1.21-11.88-1.77zm8.09 20.6v.06-.06zm.03 1.74v.23c.01-.08.01-.16 0-.23zm-1.75-14.72c0 .01.01.03.01.04 0-.02 0-.03-.01-.04zm1.66 11.23v.08-.08zm.11 5.3v.06-.06zm0 1.7v.38-.38zm-1.01-15.31c0 .02.01.04.01.05 0-.02-.01-.03-.01-.05zm.5 3.18c0 .02.01.04.01.07 0-.03 0-.05-.01-.07zm.31 3.37v.07-.07zm8.56 9.21v-.41.41zm3.17-21.89c-.02.04-.05.08-.07.13.02-.05.04-.09.07-.13zm-1.12 2.41c-.02.05-.03.09-.05.14.02-.05.04-.1.05-.14zm-5.29-5.04v2.13c2.67-.03 5.18-.27 7.04-.5 1.06-1.49 2.41-2.63 4.13-3.33-3.89 1.21-7.71 1.66-11.17 1.7zm3.34 17.29c0 .08-.01.16-.01.25.01-.09.01-.17.01-.25zm-.08 3.39v.31c-.01-.1 0-.21 0-.31zm.29-6.72c-.01.07-.01.14-.02.21 0-.07.01-.14.02-.21zm.92-6.19c-.01.05-.03.11-.04.16.02-.05.03-.11.04-.16zm-.56 3-.03.18.03-.18zm-5.29-10.78v2.14c.46.01.92.01 1.38 0v-2.13c-.47 0-.92 0-1.38-.01zm-132.03 53.56c.2.31.38.61.57.91 1.09-.02 2.33-.01 2.35-.02 0 0 0-.01-.01-.01l-1.89-3c-.02.01-.97.45-1.83.84.05.08.09.16.14.24.22.35.45.7.67 1.04zm90.67 75.99c-.05.04-1.16.91-2.94 2.25h.01c1.33-.16 2.64-.32 3.94-.5.1-.08.18-.14.22-.17l-1.23-1.58zm-5.6-133.49c-1.51.12-3.03.26-4.59.43 2.65.87 3.98 1.3 4.01 1.32l.58-1.75zm179.35 57.31c.02.01.21.07.53.19.22-.34.45-.69.67-1.04.14-.23.28-.46.41-.69-.59-.23-.94-.35-.97-.36l-.64 1.9zm-4.95 9.19c.4-.68.81-1.37 1.23-2.09-.13-.28-.21-.45-.22-.48l-1.81.85c.02.05.31.66.8 1.73v-.01zm-9.45 19.61c.1.46.42 2.17.85 4.65v-.01c.42-1.72.8-3.32 1.15-4.81v-.01c-.03-.14-.04-.23-.05-.25l-1.95.43zm-72.82 49.63s.01 0 0 0c-1.77-1.34-2.88-2.21-2.93-2.24l-1.24 1.57c.04.03.12.09.22.17 1.31.18 2.63.34 3.95.5zm7.29-135.32c-1.56-.17-3.1-.31-4.62-.43l.59 1.76c.03-.02 1.36-.46 4.03-1.33z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-heart" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Heart");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Heart");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "409",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 -47.07)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.57296 0 0 .7655 331.54 329.867)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Heart" ? "#f58220" : "#af9763"
	                },
	                d: "M1119.993 488.982v-25.776h5.22v10.152h10.188v-10.152h5.22v25.776h-5.22v-11.268h-10.188v11.268h-5.22ZM1156.747 483.042l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1169.65 476.022l-4.465-.828c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.623 3.996c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1190.713 488.982h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM1208.575 470.298v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Upper_GI" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Lungs,Kidney,Liver,Spine");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Lungs,Kidney,Liver,Spine");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M696.59 650.7c0 .03.01.21.02.54.53.44.71.44.98.44l.52-.03.3-.37c.05-.06.12-.14.19-.39 0-.11-.01-.19-.01-.24l-2 .05zm105.87.97h.47c.27 0 .45 0 .98-.45.01-.32.01-.5.01-.53l-2-.03c0 .05 0 .12-.01.21.08.25.14.34.19.4l.36.4z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M801.87 650.67h.06v-.02l-.06.02zm-102.58-29.34 5.62-2.96s.72-2.25 1.22-2.82l-6.88 3.42.04 2.36zm93.37-7.39s-.36-.95 8.67 1.59l-.04 2.12-6.5-1.52-2.13-2.19zM680.9 496.96l-.85 2.25s2.99-1.06 3.88-1.5c0 .01-2.47-.85-3.03-.75zm138.73 0s-3.01-.02-3.03.76c-.03 1.06 4.06 1.25 4.06 1.25l-1.03-2.01z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.UpperStomach.includes(this.state.bodyTitles) || male_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M651.02 476.33c-9.66-5.93-15.74-26.12-19.15-40.03v-.01c-1.45 8.41-4.1 25.73-3.36 33.09.94 9.41 13.11 22.61 18.09 26.17 7.22 5.16 22.08 3.23 30.07 2.2l1.78-.23c5.97-.75 20.76-11.47 27.08-16.23-6.99.8-14.23 1.27-21.2 1.27-13.59-.01-26.09-1.78-33.31-6.23zm172.84 21.41c7.98 1.04 22.85 2.96 30.07-2.2 4.98-3.56 17.15-16.76 18.09-26.17.74-7.38-1.91-24.67-3.36-33.08-3.42 13.92-9.5 34.11-19.15 40.03-7.23 4.45-19.72 6.22-33.32 6.22-6.96 0-14.22-.47-21.19-1.27 6.32 4.76 21.12 15.49 27.08 16.23l1.78.24z"
	            }),
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "M699.22 616.75c0-.2-.01-.39-.01-.58 0 .19.01.38.01.58zm63.96-9.07c-.08 0-.15-.01-.22-.01.07.01.14.01.22.01zm-.53-.02c-.06 0-.12 0-.17-.01.06 0 .11.01.17.01zm1.13.05c-.08 0-.15-.01-.22-.01.07.01.14.01.22.01zm-64.64 5.62c-.01-.25-.01-.49-.02-.73 0 .24.01.48.02.73zm.05 1.94zm65.28-7.52c-.07 0-.15-.01-.22-.01.07 0 .15.01.22.01zm-65.18 13.58v-.01c1.74-1.23 3.69-2.06 5.62-2.95.25-.94.52-1.7.82-2.23.12-.2.26-.4.41-.6-2.26 1.2-4.69 2.09-6.88 3.42l.03 2.37zm-.2-9.39c-.01-.4-.03-.8-.04-1.18.01.38.03.77.04 1.18zm63.14-4.3c-.12 0-.22-.01-.3-.01.08 0 .19.01.3.01zm-23.63-.01c-.09 0-.2.01-.33.01.13 0 .24-.01.33-.01zm62.77 6.38c-.01.5-.03 1.01-.04 1.53.02-.52.03-1.03.04-1.53zm-.12 6.21v.36c-.01-.12 0-.24 0-.36zm-102.59-15.27c-.03-.2-.06-.38-.08-.53.02.15.05.33.08.53zm102.76 7.38c-.01.46-.03.92-.04 1.4.01-.48.03-.94.04-1.4zm.12-3.09-.06 1.25c.03-.43.05-.85.06-1.25zm.14-2.36c-.02.32-.05.65-.07 1.01.03-.36.05-.7.07-1.01zm-.07 1.12zm-.13 2.73c-.02.42-.03.86-.05 1.32.02-.46.03-.9.05-1.32zm-.27 12.55zm-102.38-16.61c-.02-.3-.05-.59-.07-.84.02.25.04.54.07.84zm.14 2.37-.06-1.07c.03.34.04.7.06 1.07zm-.07-1.28c-.02-.29-.04-.56-.05-.81.02.25.03.53.05.81zm.13 2.55zm-.28-4.55c-.02-.24-.05-.45-.07-.64.02.19.05.4.07.64zm103.02.12c-.02.26-.05.54-.07.84.02-.3.04-.58.07-.84zm-.57 19.99v.59c-.01-.2-.01-.39 0-.59zm-36.01-18.07c-.05 0-.1-.01-.16-.01.06 0 .11 0 .16.01zm-40.41 1.06c-.11.02-.23.03-.34.05.11-.01.23-.03.34-.05zm2.63-.34c-.12.01-.23.03-.35.04.12-.01.24-.03.35-.04zm-1.31.16c-.11.01-.22.03-.33.04.11-.01.22-.02.33-.04zm2.58-.31c-.11.01-.23.02-.34.04.11-.01.23-.03.34-.04zm-9.27 1.41c-.11.02-.22.05-.34.07.12-.02.23-.04.34-.07zm4.03-.72zm-2.69.46-.33.06c.11-.01.22-.04.33-.06zm9.17-1.28c-.12.01-.23.02-.35.04.12-.02.24-.03.35-.04zm-7.82 1.04-.34.06c.11-.02.22-.04.34-.06zm15.95-1.63c-.08 0-.15.01-.23.01.08 0 .15-.01.23-.01zm-1.21.06c-.09 0-.16.01-.25.01.08 0 .16-.01.25-.01zm-.74.04c-.1.01-.19.01-.29.02.1-.01.19-.01.29-.02zm-5 .38-.34.03.34-.03zm-13.01 1.94c-.11.02-.22.05-.32.07.1-.02.21-.05.32-.07zm15.21-2.13c-.1.01-.2.02-.31.02.11 0 .21-.01.31-.02zm-1.08.09-.3.03c.1-.02.2-.02.3-.03zm2.08-.16c-.1.01-.19.01-.29.02.1-.01.2-.02.29-.02zm.94-.07c-.1.01-.18.01-.28.02.09-.01.18-.01.28-.02zm2.3-.13c-.1 0-.19.01-.3.01.11 0 .21 0 .3-.01zm-20.76 2.71c-.1.03-.21.05-.31.08.11-.03.21-.06.31-.08zm-5.9 1.91c-.07.03-.14.06-.22.1.07-.03.14-.07.22-.1zm3.4-1.23c-.1.03-.19.06-.28.09.09-.03.18-.06.28-.09zm-2.33.79-.24.09c.08-.02.16-.05.24-.09zm3.56-1.14c-.1.03-.2.05-.29.08.09-.03.19-.06.29-.08zm-6.57 2.54c-.05.03-.1.06-.16.09.06-.03.11-.06.16-.09zm-.84.53-.12.09c.03-.04.07-.07.12-.09zm1.77-1.02c-.07.03-.13.07-.19.1.07-.04.13-.07.19-.1zm-2.53 1.57c-.03.03-.06.05-.09.08.03-.03.06-.05.09-.08zm5.75-2.88c-.09.03-.18.06-.26.09.08-.03.17-.06.26-.09zm157.28-131.94c.01-.02.03-.04.04-.07-.02.02-.03.04-.04.07zm.57-1.04.03-.06c-.01.03-.02.04-.03.06zm-15.22 18.23c.11-.09.22-.17.34-.27-.11.09-.23.18-.34.27zm15.76-19.26.03-.06c-.01.03-.02.04-.03.06zm-1.72 3.09c.01-.02.03-.05.04-.07-.01.02-.03.05-.04.07zm-7.19 9.55c.05-.06.1-.11.15-.17-.05.06-.1.11-.15.17zm-7.48 7.09c.15-.11.3-.22.47-.35-.17.13-.33.25-.47.35zm1.21-.94c.1-.09.21-.17.31-.26-.11.09-.21.18-.31.26zm12.82-14.68c.02-.02.03-.05.05-.07-.01.02-.03.05-.05.07zm3.3-6.17c.01-.01.01-.03.02-.04 0 .01-.01.03-.02.04zm-52.79 21.58-.36.05c-.93.14-1.82.38-2.67.71 1.1.52 2.13.94 3.06 1.25l.21-.03-.24-1.98zm-178.24-3.29c0-.01 0-.01 0 0 0-.01 0-.01 0 0zm-1.18-1.18-.1-.1c.04.03.07.06.1.1zm232.62-18.14c0-.01.01-.02.01-.04 0 .02-.01.03-.01.04zM680.9 496.96l-.25 1.98.21.03c.94-.31 1.97-.73 3.06-1.25-.85-.33-1.75-.57-2.67-.71l-.35-.05zm-42-5.85c-.02-.02-.04-.05-.07-.07.03.02.05.05.07.07zm233.07-14.7c.01-.02.01-.03.02-.05 0 .02-.01.03-.02.05zm-13.09 17.5c.08-.08.16-.16.25-.24-.09.09-.17.16-.25.24zm2.93-2.99c.06-.06.11-.12.17-.19-.06.06-.11.12-.17.19zm-.76.8c.07-.07.13-.14.2-.21-.07.08-.13.14-.2.21zm3.04-3.39zm-3.77 4.16.21-.21c-.07.07-.14.13-.21.21zm3.01-3.28c.04-.05.09-.1.13-.15-.04.05-.08.1-.13.15zm3.01-3.69.08-.11c-.03.04-.06.08-.08.11zm-8.8 9.64.28-.25-.28.25zm9.52-10.61.07-.1c-.02.03-.04.07-.07.1zm.71-.99zm-2.93 3.86.11-.14c-.03.05-.07.09-.11.14zm-7.93 8.3c.1-.08.19-.16.29-.25-.1.08-.2.16-.29.25zm1.28-1.16zm7.41-8.08.09-.12-.09.12zm2.86-3.91.06-.09-.06.09zm-66.5 121.86zm71.76-133.1v-.01c.01 0 0 0 0 .01zm-71.86 133.72c-.03.21-.05.44-.08.69.02-.25.05-.48.08-.69zm-95.22 9.92c.02-.02.03-.04.05-.05l-.05.05zm-64.06-120.18c-.03-.03-.06-.05-.08-.08l.08.08zm217.24-1.8c-.07.07-.14.14-.22.21.07-.06.14-.13.22-.21zm-67.16 120.95c.89.64 1.6 1.33 2.07 2.1 2.21.44 4.43.87 6.56 1.59v.02c.01-.72.03-1.43.04-2.12-2.55-.81-5.21-1.23-7.82-1.78-.3-.05-.61.02-.85.19zM644.67 496.59c-.04-.03-.08-.06-.13-.1.05.04.09.07.13.1zm228.81-24.26c0-.01 0-.02.01-.02 0 0-.01.01-.01.02zm-.3 1.01c0-.01.01-.02.01-.03 0 .01 0 .02-.01.03zM643.7 495.79c-.05-.04-.11-.09-.16-.14.06.04.11.09.16.14zm209.72 70.83c-.08.74-.15 1.52-.22 2.34.27-2.07.49-3.78.62-4.9-.17.98-.33 1.88-.4 2.56z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.UpperStomach.includes(this.state.bodyTitles) || male_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M632.18 495.63c2.7 5.63 9.04 18.82 16.91 24.07 9.22 6.15 21.72 5.67 28.35 4.84 4.28-.53 8.23-5.71 10.8-9.96 1.8-2.98 1.99-6.65.49-9.81-1.49-3.17-4.33-5.28-7.77-5.79l-.09-.01h-.01c-.79.26-1.53.45-2.17.53l-1.77.23c-4.21.55-9.76 1.27-15.27 1.27-6.07 0-12.1-.87-16.22-3.82-.24-.17-.5-.37-.77-.58-.04-.03-.08-.06-.13-.1-.27-.21-.55-.45-.85-.71-.05-.05-.11-.09-.16-.14-.31-.27-.63-.55-.96-.86-.03-.03-.06-.05-.08-.08-.36-.33-.72-.67-1.1-1.04l-.01-.01c-.38-.37-.77-.76-1.17-1.17l-.1-.1c-.4-.41-.8-.83-1.21-1.27-.02-.02-.04-.05-.07-.07-4.32-4.67-9.13-11.03-11.26-17.02-1.05 4-.28 8.18-.19 12.31.14.34.28.69.41 1.01 1.39 2.55 2.82 5.14 3.6 6.72.24.39.49.93.8 1.56zm8.1 26.12c.04.22.07.45.1.67.03-.06.06-.12.08-.18-.06-.16-.13-.32-.18-.49zm7.96 29.47c3.39 8.52 9.7 24.38 20.74 29.47 13.59 6.27 23.61 6.49 24.9 5.21 1.6-1.61 1.97-8.54-2.22-18.94-1.73-4.29-6.08-10.54-7.42-12.42-1.51.38-3.29.57-5.3.57-4.28 0-9.61-.86-15.66-2.58-8.27-2.37-16.27-10.11-21.91-22.53.31 1.42.7 2.92 1.23 4.49.29.88.57 1.71.82 2.48.87 2.59 1.49 5.27 1.81 7.98v.01c.04.35.06.71.09 1.06.61.64 1.32 1.31 1.62 2.01.38.88.81 1.96 1.3 3.19z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.UpperStomach.includes(this.state.bodyTitles) || male_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M640.45 522.24c5.6 15.96 14.29 25.77 23.38 28.36 14.27 4.08 22.27 2.7 23.86-.48 1.26-2.52-2.16-16.65-4.86-25.92-1.6 1.23-3.33 2.1-5.14 2.33-2.12.26-4.83.49-7.85.49-6.78 0-15.1-1.15-21.86-5.66-6.23-4.15-11.44-12.78-14.84-19.28h-.26c1.31 4.05 2.97 8.57 4.92 12.19a22.82 22.82 0 0 1 2.43 7.25l.3.19c.03.18-.01.35-.08.53zm24.68 95.58c6.55 4.58 18.07 16.67 25.69 24.66 2.43 2.55 4.77 5.01 6.11 6.32.57-7.33.64-39.19-.32-43.99-.88-4.38-2.9-14.17-3.39-16.55-.79.18-1.75.27-2.86.27-5.12 0-13.31-1.92-22.22-6.03-11.76-5.43-18.27-21.77-21.76-30.55-.12-.31-.54-.61-.93-.9-.02.4-.03.8-.06 1.21-.11 1.32-.18 2.88-.18 4.71 0 2.75 1.13 7.36 1.37 9.64.12 1.12.22 2.34.31 3.61 1.05 5.76 2.52 13.61 3.63 19.18 2.05 10.24 5.03 21.71 14.61 28.42z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.UpperStomach.includes(this.state.bodyTitles) || male_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M744.96 561.52c-.19.06-11.17 3.68-21.42 6.76 8.81-2.09 19.23-2.17 22.2.21 4.37 3.5 4.37 24.35.99 29.42-2.69 4.03-7.32 4.86-12.68 5.82-1.4.25-2.84.51-4.32.84-4.53 1.01-13.26 4.77-18.05 6.92-.8.36-1.65.54-2.5.54-.92 0-1.84-.21-2.69-.62a6.04 6.04 0 0 1-3.2-3.98c-4.01-16.57 2.16-29.56 10.05-35.08 1.45-1.01 3.29-1.9 5.36-2.65-5.71 1.65-10.51 2.89-12.1 2.89-1.12 0-2.35-.64-3.55-1.86-3.47-3.5-6.92-11.89-6.81-22.74.04-3.75 1.87-7.33 4.91-9.57 5.4-4 14-9.29 24.23-11.85 17.6-4.4 22.03-1.68 22.97-.74.42.42.86 1.69 1.27 3.45l.02-18.69c-.52 2.81-1.23 5.12-2.16 6.5-3.39 5.08-9.27 6.13-16.08 7.35-1.8.33-3.66.66-5.56 1.08-5.84 1.3-17.06 6.14-23.22 8.91-.99.44-2.04.66-3.1.66-1.13 0-2.27-.26-3.32-.77a7.415 7.415 0 0 1-3.95-4.92c-1.11-4.58-1.61-8.95-1.61-13.05 0-.72.02-1.44.05-2.15-.21.48-.46.96-.74 1.42-1.44 2.38-3.3 5.04-5.46 7.14 1.53 5.16 6.98 24.28 4.99 28.26-.62 1.23-1.73 2.19-3.26 2.87 1.67 2.36 5.59 8.12 7.29 12.33 4.52 11.2 4.09 18.79 1.78 21.1-.06.06-.12.11-.19.17.28 1.38 2.54 12.26 3.48 16.94.03.15.06.33.08.53.01.05.01.11.02.16.02.2.05.41.07.64 0 .02 0 .04.01.06.02.26.05.54.07.84.01.09.01.18.02.28.02.26.04.53.05.81 0 .07.01.14.01.21l.06 1.07c.01.14.01.28.02.43.01.27.03.56.04.84.01.15.01.29.02.45.02.38.03.77.04 1.18.01.22.01.44.02.67.01.24.01.48.02.73.01.24.01.49.02.74l.03 1.2c.01.29.01.59.02.9 0 .19.01.39.01.58.01.72.03 1.46.04 2.21 2.19-1.33 4.62-2.21 6.88-3.42.15-.19.32-.38.5-.57.02-.02.03-.04.05-.05.17-.18.37-.34.57-.51.03-.03.06-.05.09-.08.2-.16.41-.32.63-.47l.12-.09c.22-.15.45-.29.69-.43.05-.03.1-.06.16-.09.24-.14.49-.27.74-.4.06-.03.13-.07.19-.1.25-.13.52-.25.79-.37.07-.03.14-.07.22-.1.27-.12.55-.23.84-.34l.24-.09c.28-.11.58-.21.87-.32.09-.03.17-.06.26-.09.3-.1.6-.2.91-.29.09-.03.19-.06.28-.09a115.484 115.484 0 0 1 1.23-.35c.32-.09.64-.17.96-.25.1-.03.2-.05.31-.08.32-.08.65-.16.98-.23.11-.02.22-.05.32-.07.33-.07.66-.15.99-.21.11-.02.22-.05.34-.07.33-.07.67-.13 1-.2l.33-.06 1.01-.18.34-.06c.34-.06.67-.11 1.01-.17.11-.02.23-.04.34-.05l1-.15c.11-.02.23-.03.34-.05.33-.05.66-.09.99-.14.11-.01.22-.03.33-.04l.96-.12c.12-.01.23-.03.35-.04.31-.04.62-.07.93-.11.12-.01.23-.03.34-.04.3-.03.6-.07.89-.1.12-.01.23-.02.35-.04.29-.03.57-.06.84-.08l.34-.03c.28-.03.55-.05.81-.07l.3-.03.78-.06c.1-.01.2-.02.31-.02.24-.02.48-.04.71-.05.1-.01.19-.01.29-.02.22-.02.44-.03.65-.04.1-.01.19-.01.28-.02.19-.01.39-.02.57-.04.1-.01.2-.01.29-.02l.48-.03c.09 0 .17-.01.25-.01.14-.01.28-.02.41-.02.11-.01.2-.01.3-.01.09 0 .19-.01.27-.01.09 0 .16-.01.23-.01s.16-.01.22-.01c.13-.01.24-.01.33-.01l.07-.01.08.01c5.55.62 9.1 2.07 10.77 4.4l.07-55.08c-.62 2-1.92 3.64-4.61 4.54z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.UpperStomach.includes(this.state.bodyTitles) || male_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M705.24 606.96a3.997 3.997 0 0 0 2.13 2.65 4.1 4.1 0 0 0 3.49.06c5.94-2.67 13.97-6.06 18.44-7.05 1.51-.34 2.98-.6 4.4-.86 5.11-.91 9.14-1.64 11.36-4.96 3.1-4.65 2.68-24.15-.57-26.75-1.14-.91-4.05-1.37-7.69-1.37-7.2 0-17.27 1.77-22.32 5.31-7.33 5.13-13.03 17.32-9.24 32.97zm-21.31-109.24a12.2 12.2 0 0 1 6.61 6.19c.48 1.02.81 2.07 1 3.15 2.05-10.26 7.36-18.1 13.49-22.39 3.53-2.47 8.91-4.35 14.66-5.57-.62.13-1.25.25-1.9.37-2.67.49-5.45.93-8.3 1.31h-.01c-2.01 1.57-16.2 12.53-25.55 16.94z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.UpperStomach.includes(this.state.bodyTitles) || male_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M694.19 528.92a5.387 5.387 0 0 0 2.89 3.59c1.49.73 3.21.76 4.72.08 7.61-3.42 17.89-7.76 23.6-9.03 1.95-.43 3.83-.77 5.65-1.09 6.62-1.19 11.85-2.13 14.76-6.5 4.02-6.02 3.44-31.32-.79-34.7-4.4-3.52-29.02-1.84-38.85 5.04-9.49 6.65-16.87 22.4-11.98 42.61zm51.57-2.25c-.85-.26-2.26-.53-4.51-.53-3.19 0-8.06.54-15.39 2.37-9.91 2.48-18.26 7.63-23.53 11.52-2.53 1.87-4.06 4.85-4.09 7.98v.46c0 10 3.21 17.8 6.23 20.86.79.8 1.57 1.26 2.13 1.26 3.69 0 30.48-8.55 37.73-10.96 3.56-1.19 3.8-3.82 3.95-8.74.05-1.66.1-3.54.38-5.47.96-6.77-.94-17.07-1.76-18.21 0 0-.29-.27-1.14-.54zm62.52 2.72a7.424 7.424 0 0 1-1.42 2.9c-.68.84-1.54 1.53-2.54 2.02-1.05.51-2.18.77-3.32.77-1.05 0-2.1-.22-3.09-.66-6.17-2.77-17.39-7.61-23.22-8.91-1.9-.42-3.76-.75-5.56-1.08-6.81-1.22-12.69-2.27-16.08-7.35-.75-1.13-1.37-2.86-1.85-4.99v-.08c-.09-.39-.18-.81-.26-1.23v1.31l-.03 16.11v1.07c.09-.38.17-.74.26-1.07.33-1.2.67-2.04 1-2.37.94-.94 5.37-3.66 22.98.74 10.23 2.56 18.82 7.85 24.23 11.85 3.03 2.24 4.87 5.82 4.9 9.57v.51c0 10.6-3.39 18.78-6.8 22.23-1.2 1.22-2.43 1.86-3.56 1.86-1.58 0-6.38-1.23-12.07-2.88 2.06.75 3.9 1.63 5.34 2.64 7.89 5.52 14.05 18.51 10.04 35.08a6.012 6.012 0 0 1-3.2 3.98c-.85.41-1.76.62-2.68.62-.85 0-1.7-.18-2.5-.54-4.8-2.15-13.52-5.91-18.05-6.92-1.48-.33-2.93-.59-4.33-.84-5.35-.96-9.98-1.79-12.67-5.82-3.38-5.07-3.39-25.92.99-29.42 2.97-2.38 13.38-2.3 22.2-.21-10.25-3.08-21.23-6.7-21.42-6.76-2.46-.82-3.75-2.25-4.45-4.04-.11-.28-.18-.58-.26-.87v.87l-.09 54.49v.41c.08-.14.16-.28.26-.41 1.68-2.3 5.24-3.73 10.75-4.34l.07-.01.08.01c.08 0 .18.01.3.01.07 0 .16.01.24.01.06 0 .11 0 .17.01.09 0 .2.01.31.01.07 0 .14.01.22.01.12.01.25.01.38.02.07 0 .14.01.22.01l.47.03c.07 0 .14.01.22.01l.57.03c.05 0 .1.01.16.01 6.76.43 21.43 1.85 27.47 6.15.24-.17.55-.25.85-.18 2.61.56 5.27.97 7.82 1.78v-.01c.01-.52.03-1.03.04-1.53 0-.09 0-.18.01-.27.01-.48.03-.95.04-1.4 0-.1.01-.19.01-.29.02-.45.03-.89.05-1.32 0-.08.01-.15.01-.23l.06-1.25c0-.04 0-.08.01-.13.02-.39.04-.77.06-1.12 0-.04 0-.07.01-.11.02-.36.04-.69.07-1.01 0-.05.01-.1.01-.15.02-.3.05-.58.07-.84 0-.05.01-.09.01-.14.02-.25.05-.49.08-.69 0-.03.01-.05.01-.08.03-.21.06-.4.09-.55.94-4.69 3.19-15.58 3.48-16.95-.07-.05-.14-.11-.2-.17-2.31-2.31-2.74-9.9 1.78-21.1 1.7-4.21 5.62-9.97 7.29-12.33-1.53-.69-2.63-1.64-3.25-2.87-1.99-3.98 3.45-23.1 4.98-28.26-2.16-2.1-4.02-4.76-5.46-7.14-.28-.45-.52-.92-.73-1.4.18 4.72-.28 9.8-1.58 15.19zm.71-22.36c.18-1.07.51-2.11.99-3.12 1.36-2.88 3.74-5.07 6.62-6.19-9.36-4.4-23.55-15.37-25.56-16.94-2.85-.38-5.64-.82-8.32-1.31-.64-.12-1.27-.24-1.89-.37 5.75 1.22 11.13 3.1 14.66 5.57 6.13 4.29 11.44 12.11 13.5 22.36z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.UpperStomach.includes(this.state.bodyTitles) || male_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M769.48 522.47c1.82.32 3.7.66 5.64 1.09 5.71 1.27 15.99 5.61 23.61 9.03 1.51.68 3.23.65 4.71-.08a5.36 5.36 0 0 0 2.89-3.59c4.9-20.21-2.49-35.97-11.98-42.61-6.5-4.55-19.48-6.83-28.79-6.83-4.76 0-8.57.6-10.05 1.79-4.23 3.38-4.81 28.68-.8 34.7 2.92 4.37 8.15 5.31 14.77 6.5zm-17.23 28.42c.14 4.92.38 7.55 3.95 8.74 7.25 2.41 34.04 10.96 37.72 10.96.57 0 1.34-.46 2.14-1.26 3.07-3.11 6.33-11.1 6.22-21.32-.02-1.56-.4-3.09-1.11-4.46a10.08 10.08 0 0 0-2.98-3.52c-5.26-3.89-13.62-9.04-23.53-11.52-7.3-1.83-12.17-2.37-15.36-2.37-4.53 0-5.69 1.09-5.71 1.1-.78 1.11-2.69 11.41-1.72 18.18.27 1.93.33 3.81.38 5.47zm3.78 19.16c-3.25 2.6-3.67 22.1-.57 26.75 2.22 3.32 6.26 4.05 11.37 4.96 1.41.26 2.88.52 4.4.86 4.47.99 12.49 4.38 18.44 7.05 1.11.5 2.39.48 3.48-.06 1.08-.53 1.86-1.5 2.14-2.65.83-3.43 1.21-6.7 1.21-9.77 0-10.89-4.74-19.2-10.46-23.2-5.05-3.54-15.12-5.31-22.31-5.31-3.65 0-6.56.46-7.7 1.37zm117.69-98.72c-.07.32-.15.65-.24.98 0 .01 0 .02-.01.02-.09.32-.18.65-.29.98 0 .01-.01.02-.01.03-.11.33-.22.65-.34.98 0 .01-.01.02-.01.04-.12.33-.25.65-.39.98-.01.01-.01.03-.02.04-.14.33-.28.66-.43.98-.01.02-.01.03-.02.05-.15.33-.31.65-.47.98l-.03.06c-.16.32-.33.65-.5.97l-.03.06c-.17.32-.35.64-.54.97-.01.02-.03.04-.04.07-.18.32-.37.64-.56.95-.01.02-.03.05-.04.07-.19.32-.39.63-.59.94-.02.02-.03.05-.05.07-.2.31-.4.62-.61.93l-.06.09c-.2.3-.41.61-.62.91a.55.55 0 0 1-.07.09c-.21.3-.42.59-.63.89l-.07.1c-.21.29-.43.58-.64.86l-.08.11c-.21.28-.43.56-.65.84l-.09.12c-.21.27-.43.54-.64.81l-.11.14c-.21.26-.42.51-.63.77-.04.05-.08.1-.12.14-.21.25-.42.49-.63.73-.04.05-.09.1-.13.15-.2.24-.41.47-.61.7-.05.06-.1.11-.15.17-.2.22-.39.44-.59.65-.06.06-.11.12-.17.19-.19.2-.37.4-.56.6-.07.07-.13.14-.2.21-.18.19-.35.37-.53.55l-.21.21c-.17.17-.34.34-.5.51-.07.07-.14.14-.22.21-.16.16-.32.31-.47.47-.08.08-.17.16-.25.24-.14.13-.28.27-.42.4-.09.09-.18.17-.27.25-.13.12-.25.24-.38.35-.09.09-.18.17-.28.25-.11.1-.23.21-.34.3-.1.09-.19.17-.29.25-.1.08-.2.17-.29.25-.11.09-.21.17-.31.26-.08.06-.16.13-.24.19-.12.1-.23.18-.34.27-.06.04-.11.09-.17.13-.16.12-.32.24-.47.35-4.12 2.94-10.14 3.82-16.22 3.82-5.51 0-11.07-.72-15.27-1.27l-1.77-.23c-.64-.08-1.37-.27-2.16-.53h-.01l-.1.02c-3.44.5-6.27 2.61-7.77 5.78-1.49 3.16-1.31 6.83.49 9.81 2.57 4.25 6.53 9.43 10.8 9.96 6.63.83 19.13 1.31 28.35-4.84 7.87-5.25 14.21-18.43 16.92-24.07.3-.63.56-1.16.76-1.57.69-1.37 1.67-3.51 2.67-5.72.85-2.05 1.97-4.79 3.08-7.55.06-.13.11-.24.15-.35.58-1.42 1.15-2.83 1.68-4.15-.78-2.05-1.73-4.02-2.78-5.94-.05.32-.11.65-.18.97.02-.01.01-.01.01 0zm-41.34 111.18c-8.91 4.11-17.1 6.03-22.22 6.03-1.1 0-2.05-.09-2.85-.27-.49 2.37-2.52 12.17-3.39 16.55-.96 4.79-.89 36.66-.32 43.99 1.34-1.32 3.68-3.77 6.12-6.33 7.62-8 19.13-20.08 25.68-24.66 9.58-6.71 12.56-18.18 14.61-28.41 1.2-5.99 2.43-14.62 3.2-20.45.07-.81.14-1.6.22-2.34.07-.68.23-1.58.41-2.56.11-.88.16-1.39.16-1.42l.09-.01c.36-1.98.71-4.1.71-5.65 0-1.83-.07-3.39-.18-4.71-.03-.45-.05-.9-.06-1.35-.13.33-.27.67-.42 1.04-3.49 8.78-9.99 25.12-21.76 30.55z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.UpperStomach.includes(this.state.bodyTitles) || male_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M837.25 552.53c-6.05 1.72-11.38 2.58-15.66 2.58-2.01 0-3.79-.19-5.3-.57-1.34 1.88-5.7 8.13-7.42 12.42-4.2 10.4-3.83 17.33-2.23 18.94 1.29 1.28 11.31 1.06 24.91-5.21 11.03-5.09 17.34-20.95 20.74-29.47.49-1.23.92-2.31 1.29-3.19.37-.86.75-1.67 1.14-2.45.02-.21.03-.43.05-.64v-.01c.32-2.7.93-5.37 1.8-7.96.26-.77.53-1.6.83-2.48.77-2.32 1.27-4.49 1.59-6.45-5.6 13.57-13.06 22-21.74 24.49z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.UpperStomach.includes(this.state.bodyTitles) || male_human_body.UpperStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M852.54 521.36c-6.75 4.51-15.08 5.66-21.86 5.66-3.01 0-5.72-.23-7.85-.49-1.81-.23-3.54-1.1-5.14-2.33-2.7 9.27-6.11 23.4-4.85 25.92 1.59 3.18 9.58 4.56 23.86.48 8.77-2.5 17.19-11.76 22.8-26.79.04-.7.12-1.4.24-2.09.39-2.6 1.22-5.12 2.47-7.45 1.74-3.24 3.25-7.2 4.49-10.91-3.39 6.32-8.32 14.12-14.16 18zm-101.68 36.12v-.87c-.44-1.59-.54-3.37-.59-5.23-.05 1.6-.12 3.16-.42 4.57-.07.34-.16.67-.26 1l-.07 55.08c.08.12.19.23.26.35.2.32.36.65.49 1 .13-.35.3-.68.5-1v-.41l.09-54.49zm-.98-27v.02c.13.71.26 1.47.38 2.27.19-1.29.41-2.48.65-3.5v-1.07l.03-16.11v-1.31c-.29-1.48-.52-3.11-.68-4.81-.1 1.05-.22 2.07-.36 3.04-.08.54-.17 1.06-.26 1.57l-.02 18.69c.09.39.18.78.26 1.21z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M691.54 507.06c.43 2.4.14 4.87-.85 7.11.01.01 0 .01 0 .02-.03.71-.05 1.43-.05 2.15 0 4.1.5 8.47 1.61 13.05a7.415 7.415 0 0 0 3.95 4.92c1.05.51 2.19.77 3.32.77 1.06 0 2.11-.22 3.1-.66 6.16-2.77 17.38-7.61 23.22-8.91 1.9-.42 3.76-.75 5.56-1.08 6.81-1.22 12.69-2.27 16.08-7.35.92-1.38 1.64-3.69 2.16-6.5v-1.57l.02-19.57v-1.6c-.7-3.84-1.81-6.87-3.39-8.13-3.58-2.87-15.72-2.91-26.55-.62-.01 0-.02.01-.03.01-5.75 1.22-11.13 3.1-14.66 5.57-6.13 4.29-11.44 12.13-13.49 22.39zm53.48-25.79c4.23 3.38 4.81 28.68.79 34.7-2.91 4.37-8.14 5.31-14.76 6.5-1.82.32-3.7.66-5.65 1.09-5.71 1.27-15.99 5.61-23.6 9.03-1.51.68-3.23.65-4.72-.08a5.387 5.387 0 0 1-2.89-3.59c-4.89-20.21 2.49-35.96 11.98-42.61 9.83-6.88 34.45-8.56 38.85-5.04z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.64 509.01v1.57c.09-.51.18-1.03.26-1.57.14-.97.26-1.99.36-3.04-.41-4.37-.42-9.29 0-13.71-.09-.97-.2-1.91-.34-2.82-.08-.55-.17-1.08-.26-1.6v1.6l-.02 19.57zM718.7 569.7c-2.07.75-3.91 1.64-5.36 2.65-7.89 5.52-14.06 18.51-10.05 35.08a6.04 6.04 0 0 0 3.2 3.98c.85.41 1.77.62 2.69.62.85 0 1.7-.18 2.5-.54 4.79-2.15 13.52-5.91 18.05-6.92 1.48-.33 2.92-.59 4.32-.84 5.36-.96 9.99-1.79 12.68-5.82 3.38-5.07 3.38-25.92-.99-29.42-2.97-2.38-13.39-2.3-22.2-.21-1.63.49-3.23.96-4.77 1.4-.03.01-.05.02-.07.02zm18.1-1.02c3.64 0 6.55.46 7.69 1.37 3.25 2.6 3.67 22.1.57 26.75-2.22 3.32-6.25 4.05-11.36 4.96-1.42.26-2.89.52-4.4.86-4.47.99-12.5 4.38-18.44 7.05a4.1 4.1 0 0 1-3.49-.06 3.997 3.997 0 0 1-2.13-2.65c-3.79-15.65 1.91-27.84 9.24-32.97 5.05-3.54 15.12-5.31 22.32-5.31z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m749.6 545.44.01-9.29.01-5.65v-1.22c-.41-1.75-.85-3.03-1.27-3.45-.94-.94-5.37-3.66-22.97.74-10.23 2.56-18.83 7.85-24.23 11.85a12.112 12.112 0 0 0-4.91 9.57c-.11 10.85 3.34 19.24 6.81 22.74 1.2 1.22 2.43 1.86 3.55 1.86 1.59 0 6.39-1.24 12.1-2.89.02 0 .04-.01.07-.02 1.49-.54 3.1-1.01 4.77-1.4 10.25-3.08 21.23-6.7 21.42-6.76 2.69-.9 3.99-2.54 4.63-4.57v-1l.01-10.51zm-.94-.02c-.28 1.93-.33 3.81-.38 5.47-.15 4.92-.39 7.55-3.95 8.74-7.25 2.41-34.04 10.96-37.73 10.96-.56 0-1.34-.46-2.13-1.26-3.02-3.06-6.23-10.86-6.23-20.86v-.46c.03-3.13 1.56-6.11 4.09-7.98 5.27-3.89 13.62-9.04 23.53-11.52 7.33-1.83 12.2-2.37 15.39-2.37 2.25 0 3.66.27 4.51.53.85.27 1.14.54 1.14.54.82 1.14 2.72 11.44 1.76 18.21z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m749.89 545.7-.03-.26c-.36-2.68-.29-6.08.01-9.29.1-1.17.24-2.31.39-3.38-.12-.8-.25-1.56-.38-2.27v-.02c-.08-.42-.17-.82-.26-1.2v1.22l-.01 5.65-.01 9.29-.01 10.51v1c.1-.32.19-.66.26-1 .3-1.41.37-2.97.42-4.57-.01-.14-.02-.29-.02-.43-.05-1.69-.1-3.43-.36-5.25zm-26.35 22.58c-1.67.39-3.28.86-4.77 1.4 1.54-.44 3.14-.91 4.77-1.4zm-.44 40.84c-.34.05-.67.11-1.01.17.34-.06.68-.12 1.01-.17zm6.47-.84c-.29.03-.59.06-.89.1.3-.04.6-.07.89-.1zm6.23-.51c-.18.01-.37.02-.57.04.2-.02.39-.03.57-.04zm.78-.05-.48.03.48-.03zm-14.82 1.62-1.01.18c.33-.06.67-.12 1.01-.18zm15.48-1.65c-.13.01-.27.01-.41.02.15-.01.29-.02.41-.02zm-12.8 1.22zm7.48-.86c-.27.02-.54.05-.81.07.27-.02.54-.04.81-.07zm-1.15.11c-.28.03-.56.05-.84.08.28-.03.56-.06.84-.08zm-2.43.25c-.31.03-.61.07-.93.11.31-.04.62-.08.93-.11zm9.47-.75c-.08 0-.18.01-.27.01.09 0 .19-.01.27-.01zm-2.86.16c-.21.01-.43.03-.65.04.23-.01.45-.03.65-.04zm-9.18.91zm1.29-.17-.96.12c.32-.04.65-.08.96-.12zm6.95-.67c-.23.02-.47.04-.71.05.24-.02.48-.04.71-.05zm-1.01.07-.78.06c.26-.01.52-.04.78-.06zm-12.59 1.63c-.34.06-.67.13-1 .2.34-.07.67-.14 1-.2zm-10.73 3.26c-.25.13-.5.26-.74.4.24-.14.49-.27.74-.4zm.98-.46c-.27.12-.54.24-.79.37.26-.13.52-.25.79-.37zm-1.88.96c-.24.14-.47.28-.69.43.22-.15.46-.29.69-.43zm-2.64 2.19zm12.94-5.69-.99.21.99-.21zm-11.11 4.01c-.22.15-.43.31-.63.47.2-.16.41-.31.63-.47zm3.74-1.91zm26.56-4.31c-.06 0-.15.01-.22.01.07 0 .16-.01.22-.01zm-21.8 2.81c-.32.08-.65.17-.96.25.32-.08.64-.16.96-.25zm-1.25.34zm2.54-.65c-.33.08-.66.15-.98.23.33-.07.65-.15.98-.23zm-4.93 1.4zm-6.14 3.38c.17-.17.37-.34.57-.51-.21.17-.4.34-.57.51zm7.3-3.77c-.31.1-.61.19-.91.29.31-.1.61-.19.91-.29zm-75.15-120.11c.02.02.04.05.07.07.41.44.81.87 1.21 1.27l.1.1c.4.41.79.8 1.17 1.17 0 0 .01 0 .01.01.38.37.75.71 1.1 1.04.03.03.06.05.08.08.33.31.66.59.96.86.05.05.11.09.16.14.3.25.58.49.85.71.04.03.08.07.13.1.27.22.53.42.77.58 4.12 2.94 10.14 3.82 16.22 3.82 5.51 0 11.07-.72 15.27-1.27l1.77-.23c.64-.08 1.37-.27 2.17-.53l-.21-.03.25-1.98.35.05c.93.14 1.83.38 2.67.71 9.36-4.4 23.54-15.37 25.55-16.94-1.3.18-2.61.34-3.94.5h-.01c-6.32 4.76-21.12 15.49-27.08 16.23l-1.78.23c-7.98 1.04-22.85 2.96-30.07-2.2-4.98-3.56-17.15-16.76-18.09-26.17-.74-7.36 1.91-24.68 3.36-33.09-.43-1.72-.81-3.35-1.15-4.84v-.01c-.48 2.54-5.2 28.16-4.2 38.14.14 1.44.52 2.93 1.06 4.45 2.12 6 6.93 12.37 11.25 17.03zm4.7 4.61c-.31-.27-.63-.55-.96-.86.33.3.65.59.96.86zm-2.16-1.99c-.38-.37-.77-.76-1.17-1.17.4.4.79.8 1.17 1.17zm-1.27-1.27c-.4-.41-.8-.83-1.21-1.27l1.21 1.27zm2.38 2.32c-.36-.33-.72-.67-1.1-1.04l1.1 1.04zm2.06 1.78zm.89.68z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M627.58 474.02c2.13 5.98 6.93 12.35 11.26 17.02-4.32-4.66-9.13-11.03-11.26-17.02z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M647.98 521.36c6.76 4.51 15.08 5.66 21.86 5.66 3.02 0 5.73-.23 7.85-.49 1.81-.23 3.54-1.1 5.14-2.33-.14-.5-.29-.99-.43-1.46l1.92-.57c.05.17.11.36.17.58 2.16-2.1 4.02-4.76 5.46-7.14.28-.46.53-.94.74-1.42 0-.01.01-.01 0-.02.11-2.48.4-4.84.85-7.1v-.01c-.19-1.08-.52-2.13-1-3.15a12.2 12.2 0 0 0-6.61-6.19h-.01c-1.1.52-2.13.94-3.06 1.25h.01l.09.01c3.44.51 6.28 2.62 7.77 5.79a10.35 10.35 0 0 1-.49 9.81c-2.57 4.25-6.52 9.43-10.8 9.96-6.63.83-19.13 1.31-28.35-4.84-7.87-5.25-14.21-18.44-16.91-24.07-.31-.63-.56-1.17-.77-1.57-.78-1.58-2.21-4.17-3.6-6.72.88 2.12 1.55 3.72 1.8 4.21.47.94 1.59 5.36 3.27 10.52v.01h.26c3.4 6.5 8.61 15.13 14.84 19.28z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M691.54 507.07a46.91 46.91 0 0 0-.85 7.1c.99-2.24 1.28-4.71.85-7.1zm-51.31 14.45-.05-.03c.03.09.06.17.09.26 0-.01 0-.03-.01-.04 0-.06-.02-.13-.03-.19z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m640.53 521.71-.3-.19c.01.06.03.12.04.19 0 .01 0 .03.01.04.06.17.12.33.18.49.06-.18.1-.35.07-.53zm22.75 30.82c6.05 1.72 11.38 2.58 15.66 2.58 2.01 0 3.79-.19 5.3-.57-.25-.34-.39-.54-.4-.55l1.61-1.19c.05.07.33.46.77 1.08 1.53-.68 2.64-1.64 3.26-2.87 1.99-3.98-3.46-23.1-4.99-28.26-.53.52-1.09 1.01-1.66 1.45 2.7 9.27 6.12 23.4 4.86 25.92-1.59 3.18-9.59 4.56-23.86.48-9.09-2.59-17.78-12.4-23.38-28.36-.02.06-.05.12-.08.18.06.47.11.94.14 1.42.06.96.16 2.03.33 3.18v.01c.13.93.31 1.93.53 2.97 5.64 12.42 13.64 20.16 21.91 22.53z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M682.4 522.74c.14.47.29.96.43 1.46.57-.44 1.13-.93 1.66-1.45-.06-.22-.12-.41-.17-.58l-1.92.57zm-36.02 29.22c3.49 8.78 10 25.12 21.76 30.55 8.91 4.11 17.1 6.03 22.22 6.03 1.11 0 2.07-.09 2.86-.27l-.11-.53 1.96-.41.03.15c.07-.06.13-.11.19-.17 2.31-2.31 2.74-9.9-1.78-21.1-1.7-4.21-5.62-9.97-7.29-12.33-.6.27-1.26.49-1.98.66 1.34 1.88 5.69 8.13 7.42 12.42 4.19 10.4 3.82 17.33 2.22 18.94-1.29 1.28-11.31 1.06-24.9-5.21-11.04-5.09-17.35-20.95-20.74-29.47-.49-1.23-.92-2.31-1.3-3.19-.3-.7-1.01-1.37-1.62-2.01.14 1.45.21 2.9.17 4.36-.01.23-.03.46-.04.68.39.29.81.59.93.9z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M683.84 553.99c.01.01.15.21.4.55.72-.17 1.38-.39 1.98-.66-.44-.62-.72-1.01-.77-1.08l-1.61 1.19zm-32.53 46.82c.02-.11.03-.19.04-.24l1.97.34c-.01.07-.25 1.47-.6 3.75 2.33 5.69 5.76 10.94 11.27 14.79 6.39 4.47 17.82 16.47 25.38 24.41 4.6 4.83 6.39 6.67 7.25 7.37-.01-.32-.02-.51-.02-.54l2-.05c0 .05 0 .13.01.24.31-1.02.75-4.86.74-21.85 0-2.55-.02-5.17-.05-7.72l-.03-2.37c-.01-.75-.03-1.49-.04-2.21 0-.2-.01-.39-.01-.58-.01-.3-.01-.6-.02-.9l-.03-1.2c-.01-.25-.01-.49-.02-.74s-.01-.49-.02-.73c-.01-.22-.01-.45-.02-.67-.01-.4-.03-.8-.04-1.18-.01-.15-.01-.3-.02-.45-.01-.29-.02-.57-.04-.84-.01-.14-.01-.29-.02-.43l-.06-1.07c0-.07-.01-.14-.01-.21-.02-.29-.04-.56-.05-.81-.01-.09-.01-.19-.02-.28-.02-.3-.05-.59-.07-.84 0-.02 0-.04-.01-.06-.02-.24-.05-.45-.07-.64-.01-.06-.01-.11-.02-.16-.03-.2-.06-.38-.08-.53-.94-4.69-3.19-15.57-3.48-16.94-.44.35-1.07.62-1.88.79.49 2.38 2.52 12.17 3.39 16.55.96 4.79.89 36.66.32 43.99-1.34-1.32-3.68-3.77-6.11-6.32-7.62-8-19.14-20.08-25.69-24.66-9.58-6.71-12.56-18.18-14.61-28.41-1.11-5.56-2.58-13.41-3.63-19.18.05.68.09 1.38.13 2.09v.05c.2 3.59.31 7.56.46 11.45v.03c.01.18.01.37.02.55.37 1.91.73 3.74 1.06 5.39.7 3.61 1.54 7.36 2.73 11.02z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M698.68 605.12c-.01-.06-.01-.11-.02-.16 0 .05.01.1.02.16zm.53 11.05c-.01-.3-.01-.6-.02-.9.01.29.01.59.02.9zm.05 2.79c-.01-.75-.03-1.49-.04-2.21.02.72.03 1.46.04 2.21zm-.34-10.99c0-.07-.01-.14-.01-.21 0 .07 0 .14.01.21zm.24 6.1c-.01-.25-.01-.49-.02-.74 0 .24.01.49.02.74zm-.11-3.31c-.01-.15-.01-.3-.02-.45.01.15.01.3.02.45zm-.06-1.29c-.01-.14-.01-.29-.02-.43.01.14.02.28.02.43zm.12 3.13c-.01-.22-.01-.45-.02-.67.01.22.02.45.02.67zm-.35-6.78c0-.02 0-.04-.01-.06 0 .02 0 .04.01.06zm.09 1.13c-.01-.09-.01-.19-.02-.28 0 .09.01.18.02.28zm.44 14.38c.03 2.55.05 5.17.05 7.72 0-2.55-.01-5.18-.05-7.72zm-6.18-33.59.11.53c.81-.17 1.44-.44 1.88-.79-.02-.09-.03-.15-.03-.15l-1.96.41zm-41.76 12.83c-.01.05-.02.13-.04.24.42 1.3.89 2.59 1.41 3.85.35-2.28.59-3.68.6-3.75l-1.97-.34zm99.85-88.56v.08c.48 2.13 1.1 3.86 1.85 4.99 3.39 5.08 9.27 6.13 16.08 7.35 1.8.33 3.66.66 5.56 1.08 5.83 1.3 17.05 6.14 23.22 8.91.99.44 2.04.66 3.09.66 1.14 0 2.27-.26 3.32-.77 1-.49 1.86-1.18 2.54-2.02.67-.84 1.16-1.82 1.42-2.9 1.3-5.39 1.76-10.47 1.56-15.18v-.01c-1-2.26-1.29-4.75-.85-7.16v-.01c-2.06-10.25-7.37-18.07-13.49-22.36-3.53-2.47-8.91-4.35-14.66-5.57-10.84-2.3-23-2.26-26.58.61-1.32 1.05-2.32 3.35-3.02 6.33v.04c-.09.39-.18.8-.26 1.22l-.04 23.49c.08.41.17.82.26 1.22zm4.31-30.74c1.48-1.19 5.29-1.79 10.05-1.79 9.31 0 22.29 2.28 28.79 6.83 9.49 6.64 16.88 22.4 11.98 42.61a5.36 5.36 0 0 1-2.89 3.59c-1.48.73-3.2.76-4.71.08-7.62-3.42-17.9-7.76-23.61-9.03-1.94-.43-3.82-.77-5.64-1.09-6.62-1.19-11.85-2.13-14.77-6.5-4.01-6.02-3.43-31.32.8-34.7zm-5.25 24.7c.16 1.71.39 3.33.68 4.81l.04-23.49c-.31 1.53-.55 3.19-.72 4.96.42 4.43.41 9.35 0 13.72z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M750.26 505.97c.41-4.37.42-9.29 0-13.71-.42 4.42-.41 9.34 0 13.71zm26.73 62.31c-8.82-2.09-19.23-2.17-22.2.21-4.38 3.5-4.37 24.35-.99 29.42 2.69 4.03 7.32 4.86 12.67 5.82 1.4.25 2.85.51 4.33.84 4.53 1.01 13.25 4.77 18.05 6.92.8.36 1.65.54 2.5.54.92 0 1.83-.21 2.68-.62 1.62-.8 2.78-2.25 3.2-3.98 4.01-16.57-2.15-29.56-10.04-35.08-1.44-1.01-3.28-1.89-5.34-2.64-.03 0-.06-.01-.09-.03-1.54-.44-3.15-.91-4.77-1.4zm9.05 5.71c5.72 4 10.46 12.31 10.46 23.2 0 3.07-.38 6.34-1.21 9.77a4.011 4.011 0 0 1-2.14 2.65c-1.09.54-2.37.56-3.48.06-5.95-2.67-13.97-6.06-18.44-7.05-1.52-.34-2.99-.6-4.4-.86-5.11-.91-9.15-1.64-11.37-4.96-3.1-4.65-2.68-24.15.57-26.75 1.14-.91 4.05-1.37 7.7-1.37 7.19 0 17.26 1.77 22.31 5.31z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m750.89 542.75-.02 13.86c.08.29.15.59.26.87.7 1.79 1.99 3.22 4.45 4.04.19.06 11.17 3.68 21.42 6.76 1.67.39 3.28.86 4.77 1.4.03.02.06.03.09.03 5.69 1.65 10.49 2.88 12.07 2.88 1.13 0 2.36-.64 3.56-1.86 3.41-3.45 6.8-11.63 6.8-22.23v-.51c-.03-3.75-1.87-7.33-4.9-9.57-5.41-4-14-9.29-24.23-11.85-17.61-4.4-22.04-1.68-22.98-.74-.33.33-.67 1.17-1 2.37-.09.33-.18.69-.26 1.07l-.02 10.82c.01.9.02 1.8-.01 2.66zm2.7-15.51c.02-.01 1.18-1.1 5.71-1.1 3.19 0 8.06.54 15.36 2.37 9.91 2.48 18.27 7.63 23.53 11.52 1.27.94 2.28 2.15 2.98 3.52.71 1.37 1.09 2.9 1.11 4.46.11 10.22-3.15 18.21-6.22 21.32-.8.8-1.57 1.26-2.14 1.26-3.68 0-30.47-8.55-37.72-10.96-3.57-1.19-3.81-3.82-3.95-8.74-.05-1.66-.11-3.54-.38-5.47-.97-6.77.94-17.07 1.72-18.18zm-2.7 12.85.02-10.82a49.6 49.6 0 0 0-.65 3.5c.34 2.28.57 4.85.63 7.32zm-.25 5.61c-.26 1.82-.31 3.56-.36 5.25 0 .14-.01.29-.01.43.05 1.86.15 3.64.59 5.23l.02-13.86a26.49 26.49 0 0 1-.24 2.95z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M750.64 545.7c.13-.91.21-1.9.24-2.95.03-.86.03-1.75 0-2.66-.06-2.47-.29-5.04-.63-7.32-.15 1.07-.29 2.21-.39 3.38-.3 3.21-.37 6.61-.01 9.29l.03.26c.26 1.82.31 3.56.36 5.25 0 .14.01.29.02.43 0-.14.01-.29.01-.43.06-1.69.11-3.43.37-5.25zm26.35 22.58c1.62.49 3.23.96 4.77 1.4-1.49-.54-3.1-1.01-4.77-1.4zm17.8 47.86c-.02-.03-.05-.06-.07-.1.03.04.05.07.07.1zm-31.23-8.44c-.13-.01-.26-.01-.38-.02.12.01.25.01.38.02zm29.1 6.24c-6.05-4.3-20.71-5.72-27.47-6.15 6.76.44 21.43 1.85 27.47 6.15zm-28.41-6.2-.47-.03.47.03zm.79.05-.57-.03c.18 0 .37.01.57.03zm-2.08-.12c-.11 0-.21-.01-.31-.01.1 0 .2.01.31.01zm-.48-.02c-.09 0-.17-.01-.24-.01.07 0 .15.01.24.01zm56.79-110.64.36-.05.25 1.98-.21.03c.79.26 1.52.45 2.16.53l1.77.23c4.21.55 9.76 1.27 15.27 1.27 6.07 0 12.1-.87 16.22-3.82.15-.11.3-.22.47-.35.05-.04.11-.09.17-.13.11-.09.22-.17.34-.27.08-.06.16-.13.24-.19.1-.09.21-.17.31-.26.1-.08.2-.17.29-.25.1-.08.19-.16.29-.25.11-.1.23-.2.34-.3l.28-.25.38-.35c.09-.08.18-.17.27-.25.14-.13.28-.27.42-.4.08-.08.16-.16.25-.24.16-.15.31-.31.47-.47.07-.07.14-.14.22-.21.17-.17.33-.34.5-.51l.21-.21c.17-.18.35-.36.53-.55.07-.07.13-.14.2-.21.19-.2.37-.4.56-.6.06-.06.11-.12.17-.19.2-.21.39-.43.59-.65.05-.06.1-.11.15-.17.2-.23.41-.46.61-.7.04-.05.09-.1.13-.15.21-.24.42-.49.63-.73.04-.05.08-.1.12-.14.21-.25.42-.51.63-.77l.11-.14c.22-.27.43-.53.64-.81l.09-.12c.22-.28.43-.56.65-.84l.08-.11c.22-.29.43-.57.64-.86l.07-.1c.21-.29.43-.59.63-.89a.55.55 0 0 1 .07-.09c.21-.3.42-.6.62-.91l.06-.09c.21-.31.41-.62.61-.93.02-.02.03-.05.05-.07.2-.31.4-.63.59-.94.01-.02.03-.05.04-.07.19-.32.38-.64.56-.95.01-.02.03-.04.04-.07.18-.32.36-.64.54-.97l.03-.06c.17-.32.34-.65.5-.97l.03-.06c.16-.33.32-.65.47-.98.01-.02.01-.03.02-.05.15-.33.29-.66.43-.98.01-.01.01-.03.02-.04.14-.33.27-.66.39-.98 0-.01.01-.02.01-.04.12-.33.24-.66.34-.98 0-.01.01-.02.01-.03.11-.33.2-.65.29-.98 0-.01 0-.02.01-.02.09-.33.17-.65.24-.98v-.01c.07-.33.13-.65.18-.97.04-.26.08-.51.1-.77 1-9.97-3.69-35.42-4.2-38.11v.01c-.35 1.49-.73 3.09-1.15 4.81v.01c1.45 8.41 4.1 25.7 3.36 33.08-.94 9.41-13.11 22.61-18.09 26.17-7.22 5.16-22.08 3.23-30.07 2.2l-1.78-.23c-5.96-.75-20.76-11.47-27.08-16.23H795c-1.32-.16-2.64-.32-3.94-.5 2.01 1.57 16.2 12.54 25.56 16.94.83-.33 1.72-.57 2.65-.71z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M861.98 490.73c.2-.21.39-.43.59-.65-.2.22-.39.44-.59.65zm5.86-7.26c.21-.3.42-.6.62-.91-.21.31-.41.61-.62.91zm-5.12 6.44c.2-.23.41-.46.61-.7-.2.24-.41.47-.61.7zm5.8-7.43c.21-.31.41-.62.61-.93-.21.31-.41.62-.61.93zm1.28-2.02c.19-.32.38-.64.56-.95-.18.32-.36.63-.56.95zm-10.67 13.21c.16-.15.31-.31.47-.47-.16.17-.32.32-.47.47zm10.04-12.19c.2-.31.4-.63.59-.94-.19.31-.39.62-.59.94zm-2.75 3.93c.22-.29.43-.57.64-.86-.21.29-.43.58-.64.86zm-5.17 6.11c.19-.2.37-.4.56-.6-.19.2-.38.4-.56.6zm2.96-3.34c.21-.25.42-.51.63-.77-.21.26-.42.52-.63.77zm1.48-1.82c.22-.28.43-.56.65-.84-.22.28-.43.56-.65.84zm-2.23 2.7c.21-.24.42-.49.63-.73-.21.25-.42.49-.63.73zm1.49-1.78zm2.18-2.83c.21-.29.43-.59.63-.89-.2.3-.41.6-.63.89zm3.27-5.01c.18-.32.36-.64.54-.97-.17.33-.35.65-.54.97zm-9.87 12.83c.17-.18.35-.36.53-.55-.18.19-.36.37-.53.55zm12.96-19.97zm-13.17 20.19zm-3.71 3.48c.09-.08.2-.17.29-.25-.09.08-.19.17-.29.25zm16.58-22.66c.11-.33.2-.65.29-.98-.09.32-.18.65-.29.98zm-15.38 21.6.38-.35c-.13.12-.25.24-.38.35zm.65-.6c.14-.13.28-.27.42-.4-.14.14-.28.27-.42.4zm14.38-19.99zm1.06-3.98c-.05.32-.11.65-.18.97.08-.32.14-.65.18-.97zm-16.7 25.13c.11-.1.23-.2.34-.3-.12.09-.23.2-.34.3zm15.24-20.13zm-1.47 3.08c.17-.32.34-.65.5-.97-.16.32-.32.64-.5.97zm-15.42 18.41c.05-.04.11-.09.17-.13-.05.04-.11.09-.17.13zm16.44-20.47c.15-.33.29-.66.43-.98-.13.33-.28.65-.43.98zm-.49 1.03c.16-.33.32-.65.47-.98-.15.32-.3.65-.47.98zm-15.44 19.04c.08-.06.16-.13.24-.19-.08.06-.16.12-.24.19z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M867.14 502.03c1.67-5.14 2.79-9.55 3.26-10.48.2-.41.71-1.59 1.38-3.21-1 2.21-1.98 4.35-2.67 5.72-.2.41-.46.94-.76 1.57-2.71 5.64-9.05 18.82-16.92 24.07-9.22 6.15-21.72 5.67-28.35 4.84-4.27-.53-8.23-5.71-10.8-9.96-1.8-2.98-1.98-6.65-.49-9.81 1.5-3.17 4.33-5.28 7.77-5.78l.1-.02h.01c-.94-.31-1.97-.73-3.06-1.25a12.218 12.218 0 0 0-6.62 6.19c-.48 1.01-.81 2.05-.99 3.12v.01c.45 2.27.75 4.66.85 7.16v.01c.21.48.45.95.73 1.4 1.44 2.38 3.3 5.04 5.46 7.14.07-.22.13-.41.18-.58l1.91.57c-.14.47-.28.96-.43 1.46 1.6 1.23 3.33 2.1 5.14 2.33 2.13.26 4.84.49 7.85.49 6.78 0 15.11-1.15 21.86-5.66 5.84-3.88 10.77-11.68 14.16-18 .15-.44.3-.89.44-1.32-.01 0-.01 0-.01-.01z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M809.84 514.2c-.1-2.5-.4-4.89-.85-7.16-.44 2.41-.15 4.9.85 7.16zm26.86 36.4c-14.28 4.08-22.27 2.7-23.86-.48-1.26-2.52 2.15-16.65 4.85-25.92-.57-.44-1.12-.93-1.66-1.45-1.53 5.16-6.97 24.28-4.98 28.26.62 1.23 1.72 2.18 3.25 2.87.44-.62.72-1.01.77-1.08l1.61 1.19c-.01.01-.15.21-.39.55 1.51.38 3.29.57 5.3.57 4.28 0 9.61-.86 15.66-2.58 8.68-2.49 16.14-10.92 21.75-24.49.06-.34.12-.69.17-1.02V527c.16-1.14.27-2.21.33-3.16v-.03c-5.61 15.03-14.02 24.29-22.8 26.79z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m818.12 522.74-1.91-.57c-.05.17-.11.36-.18.58.54.52 1.09 1.01 1.66 1.45.15-.5.29-.99.43-1.46zm34.17 28.48c-3.4 8.52-9.71 24.38-20.74 29.47-13.6 6.27-23.62 6.49-24.91 5.21-1.6-1.61-1.97-8.54 2.23-18.94 1.72-4.29 6.08-10.54 7.42-12.42-.73-.17-1.39-.4-1.99-.66-1.67 2.36-5.59 8.12-7.29 12.33-4.52 11.2-4.09 18.79-1.78 21.1.06.06.13.12.2.17l.03-.14 1.96.41-.11.53c.8.18 1.75.27 2.85.27 5.12 0 13.31-1.92 22.22-6.03 11.77-5.43 18.27-21.77 21.76-30.55.14-.36.28-.71.42-1.04l-.03-.58v-.01c-.05-1.59.03-3.18.2-4.75-.39.78-.77 1.59-1.14 2.45-.38.87-.81 1.95-1.3 3.18z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "m816.68 553.99-1.61-1.19c-.05.07-.33.46-.77 1.08.6.26 1.26.49 1.99.66.24-.34.38-.54.39-.55zm35.85 29.83c.14-3.9.26-7.89.46-11.48v-.21c.06-1.1.13-2.16.21-3.17-.77 5.83-2 14.47-3.2 20.45-2.05 10.23-5.03 21.7-14.61 28.41-6.55 4.58-18.06 16.67-25.68 24.66-2.44 2.56-4.77 5.01-6.12 6.33-.57-7.33-.64-39.19.32-43.99.88-4.38 2.9-14.18 3.39-16.55-.8-.17-1.44-.43-1.88-.78v-.01c-.28 1.36-2.54 12.26-3.48 16.95-.03.15-.06.34-.09.55 0 .03-.01.05-.01.08-.03.21-.05.44-.08.69 0 .04-.01.09-.01.14-.02.26-.05.54-.07.84 0 .05-.01.1-.01.15-.02.32-.05.65-.07 1.01 0 .03 0 .07-.01.11-.02.35-.04.73-.06 1.12 0 .04 0 .08-.01.13l-.06 1.25c0 .08-.01.15-.01.23-.02.42-.03.86-.05 1.32 0 .1-.01.19-.01.29-.01.46-.03.92-.04 1.4 0 .09 0 .18-.01.27-.01.5-.03 1.01-.04 1.53v.01c-.02.69-.03 1.4-.04 2.12-.02.84-.03 1.7-.04 2.56v.36l-.03 2.7v.01c-.01.86-.01 1.72-.02 2.58v.59c0 .87-.01 1.73-.01 2.58-.01 16.93.43 20.8.74 21.83 0-.09.01-.16.01-.21h-.06l.06-.02v.02l2 .03c0 .03-.01.21-.01.53.86-.71 2.65-2.55 7.24-7.37 7.56-7.94 19-19.93 25.38-24.4 5.5-3.85 8.93-9.11 11.27-14.79-.35-2.29-.59-3.69-.6-3.76l1.97-.33c.01.05.02.12.04.23 1.19-3.66 2.03-7.41 2.75-11.01.13-.66.27-1.36.4-2.07.06-1.28.11-2.59.16-3.9.02 0 .02 0 .02-.01z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M801.21 623.28c-.01.86-.01 1.72-.02 2.58.01-.85.02-1.72.02-2.58zm.03-2.7zm.05-2.92c-.02.84-.03 1.7-.04 2.56.01-.86.02-1.72.04-2.56zm-.1 8.8c0 .87-.01 1.73-.01 2.58.01-.85.01-1.71.01-2.58zm.24-14.42c0 .1-.01.19-.01.29.01-.1.01-.19.01-.29zm.12-2.92c0 .04 0 .08-.01.13.01-.05.01-.09.01-.13zm-.06 1.38c0 .08-.01.15-.01.23 0-.08.01-.16.01-.23zm-.11 3.23c0 .09 0 .18-.01.27 0-.08.01-.18.01-.27zm-.05 1.81zm.29-7.65c0 .03 0 .07-.01.11 0-.04.01-.08.01-.11zm.16-2.15c0 .04-.01.09-.01.14 0-.05.01-.09.01-.14zm.09-.77c0 .03-.01.05-.01.08 0-.03 0-.05.01-.08zm-.17 1.75c0 .05-.01.1-.01.15 0-.04 0-.1.01-.15zm3.73-19.23c.44.35 1.08.61 1.88.78l.11-.53-1.96-.41-.03.14v.02zm43.75 13.09-1.97.33c.01.07.25 1.47.6 3.76.52-1.27.99-2.55 1.41-3.85-.02-.12-.03-.19-.04-.24zM626.75 471.07s-2.13 2.75-1.65 9.62l2.71 6.65s-1.43-7.18-.23-13.31l-.83-2.96z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-lungs" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Lungs");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Lungs");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "478",
	              width: "115",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 81)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.59342 0 0 .7655 304.301 271.982)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Lungs" ? "#f58220" : "#af9763"
	                },
	                d: "M1120.014 427.414v-25.56h5.184v21.204h12.96v4.356h-18.144ZM1154.1 427.414v-2.808a7.358 7.358 0 0 1-2.664 2.376 7.625 7.625 0 0 1-3.528.864c-1.26 0-2.376-.288-3.384-.828-.972-.576-1.692-1.332-2.16-2.34-.432-.972-.648-2.376-.648-4.104V408.73h4.932v8.604c0 2.628.108 4.212.288 4.824a2.77 2.77 0 0 0 .972 1.404c.504.324 1.08.504 1.836.504.828 0 1.584-.216 2.268-.684.684-.468 1.116-1.044 1.368-1.728.252-.684.36-2.376.36-5.04v-7.884h4.968v18.684h-4.608ZM1180.77 427.414h-4.932v-9.54c0-2.016-.108-3.312-.324-3.888a2.551 2.551 0 0 0-1.008-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.684.468-1.116 1.116-1.368 1.872s-.396 2.196-.396 4.284v8.46h-4.932V408.73h4.572v2.772c1.62-2.124 3.672-3.168 6.156-3.168 1.08 0 2.088.18 2.988.576.9.396 1.584.9 2.052 1.512.468.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592ZM1185.336 428.638l5.652.684c.072.648.288 1.116.648 1.368.468.36 1.188.504 2.196.504 1.296 0 2.268-.18 2.916-.576.432-.252.756-.648.972-1.224.18-.432.252-1.188.252-2.268v-2.736c-1.476 2.016-3.348 3.024-5.616 3.024-2.484 0-4.464-1.044-5.94-3.168-1.152-1.692-1.728-3.78-1.728-6.264 0-3.132.756-5.544 2.268-7.164 1.512-1.656 3.384-2.484 5.616-2.484 2.304 0 4.212 1.008 5.688 3.024v-2.628h4.644v16.776c0 2.196-.18 3.852-.54 4.932-.36 1.08-.9 1.944-1.548 2.556-.648.648-1.512 1.116-2.628 1.476-1.08.36-2.484.504-4.14.504-3.168 0-5.4-.54-6.732-1.62-1.332-1.08-1.98-2.448-1.98-4.104v-.612Zm4.428-10.944c0 1.98.36 3.42 1.152 4.356.756.9 1.692 1.368 2.808 1.368 1.224 0 2.232-.468 3.06-1.404.864-.936 1.26-2.34 1.26-4.212 0-1.908-.396-3.348-1.188-4.284-.792-.936-1.8-1.404-3.024-1.404-1.188 0-2.16.432-2.916 1.368-.792.936-1.152 2.34-1.152 4.212ZM1206.03 422.086l4.968-.756c.216.972.648 1.692 1.296 2.196.648.504 1.548.756 2.7.756 1.26 0 2.232-.252 2.88-.72.432-.324.648-.756.648-1.332 0-.36-.108-.684-.36-.9-.216-.252-.792-.468-1.656-.684-3.96-.864-6.48-1.656-7.56-2.376-1.476-1.008-2.232-2.412-2.232-4.212 0-1.62.648-2.988 1.944-4.068 1.26-1.116 3.24-1.656 5.94-1.656 2.556 0 4.428.396 5.688 1.224 1.224.864 2.088 2.088 2.556 3.708l-4.644.864c-.216-.72-.576-1.296-1.152-1.692-.54-.36-1.332-.576-2.376-.576-1.296 0-2.232.18-2.772.54-.396.288-.576.612-.576 1.008 0 .36.144.648.504.9.432.324 1.98.792 4.608 1.404 2.628.576 4.464 1.332 5.508 2.196 1.008.864 1.548 2.088 1.548 3.672 0 1.692-.72 3.168-2.16 4.392-1.404 1.26-3.528 1.872-6.336 1.872-2.556 0-4.572-.54-6.048-1.548-1.476-1.044-2.448-2.448-2.916-4.212Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-liver is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Liver");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Liver");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "290",
	              y: "513",
	              width: "95",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-887.13 -16.272)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.61389 0 0 -.7655 2109.27 697.33)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Liver" ? "#f58220" : "#af9763"
	                },
	                d: "M1183.357 563.563v-25.56h5.184v21.204h12.96v4.356h-18.144ZM1205.167 542.359v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM1220.279 563.563l-7.524-18.684h5.184l3.528 9.54 1.008 3.168c.288-.792.468-1.332.54-1.584.144-.54.324-1.044.504-1.584l3.564-9.54h5.076l-7.416 18.684h-4.464ZM1245.987 557.623l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1259.923 563.563h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-spine is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Spine");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Spine");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "280",
	              y: "569",
	              width: "105",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-887.13 36.48)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.70597 0 0 -.7655 2231.84 700.45)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Spine" ? "#f58220" : "#af9763"
	                },
	                d: "m1171.805 555.175 5.076-.504c.288 1.728.9 2.952 1.836 3.744.936.828 2.196 1.224 3.78 1.224 1.692 0 2.952-.36 3.78-1.08.864-.72 1.296-1.548 1.296-2.484 0-.612-.18-1.116-.54-1.548-.36-.432-1.008-.792-1.872-1.116-.612-.216-2.016-.612-4.176-1.116-2.772-.72-4.752-1.548-5.868-2.556-1.584-1.44-2.376-3.168-2.376-5.184 0-1.332.36-2.556 1.116-3.708a6.992 6.992 0 0 1 3.204-2.592c1.404-.612 3.096-.9 5.076-.9 3.24 0 5.688.72 7.308 2.124 1.656 1.404 2.484 3.312 2.592 5.688l-5.22.216c-.216-1.332-.684-2.268-1.44-2.844-.72-.576-1.836-.864-3.276-.864-1.512 0-2.7.288-3.564.9-.54.432-.828.936-.828 1.62 0 .612.252 1.116.792 1.548.648.576 2.232 1.152 4.752 1.728 2.556.612 4.428 1.224 5.616 1.872a7.188 7.188 0 0 1 2.88 2.592c.684 1.116 1.008 2.484 1.008 4.14 0 1.476-.396 2.844-1.224 4.14-.828 1.296-1.98 2.232-3.492 2.88-1.476.612-3.348.936-5.58.936-3.276 0-5.76-.756-7.524-2.268-1.728-1.512-2.772-3.708-3.132-6.588ZM1196.967 544.879h4.608v2.772a6.741 6.741 0 0 1 2.412-2.304 6.86 6.86 0 0 1 3.384-.864c2.196 0 4.032.828 5.544 2.556 1.512 1.692 2.268 4.032 2.268 7.092 0 3.096-.756 5.544-2.304 7.272-1.512 1.728-3.348 2.592-5.544 2.592a6.39 6.39 0 0 1-2.772-.612c-.864-.432-1.728-1.116-2.664-2.124v9.396h-4.932v-25.776Zm4.896 9.036c0 2.088.396 3.636 1.224 4.644s1.872 1.512 3.06 1.512c1.152 0 2.088-.468 2.844-1.368.792-.936 1.152-2.448 1.152-4.536 0-1.98-.396-3.42-1.188-4.356-.756-.972-1.728-1.44-2.916-1.44s-2.196.468-2.988 1.404c-.792.936-1.188 2.304-1.188 4.14ZM1219.101 542.359v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM1246.057 563.563h-4.932v-9.54c0-2.016-.108-3.312-.324-3.888a2.551 2.551 0 0 0-1.008-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.684.468-1.116 1.116-1.368 1.872s-.396 2.196-.396 4.284v8.46h-4.932v-18.684h4.572v2.772c1.62-2.124 3.672-3.168 6.156-3.168 1.08 0 2.088.18 2.988.576.9.396 1.584.9 2.052 1.512.468.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592ZM1261.891 557.623l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-kidney" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Kidney");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Kidney");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "589",
	              width: "145",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 193.214)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.61389 0 0 .7655 277.063 271.876)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Kidney" ? "#f58220" : "#af9763"
	                },
	                d: "M1120.013 427.414v-25.776h5.184v11.448l10.512-11.448h7.02l-9.72 10.044 10.224 15.732h-6.732l-7.092-12.096-4.213 4.32v7.776h-5.183ZM1145.895 406.21v-4.572h4.931v4.572h-4.931Zm0 21.204V408.73h4.931v18.684h-4.931ZM1173.005 427.414h-4.573v-2.736c-.755 1.044-1.656 1.872-2.7 2.376-1.043.504-2.087.792-3.131.792-2.16 0-3.997-.864-5.509-2.592-1.548-1.728-2.303-4.14-2.303-7.236 0-3.168.755-5.58 2.232-7.236 1.476-1.62 3.384-2.448 5.651-2.448 2.089 0 3.889.864 5.4 2.592v-9.288h4.933v25.776Zm-13.177-9.756c0 2.016.289 3.456.829 4.356.792 1.26 1.908 1.908 3.348 1.908 1.115 0 2.087-.468 2.88-1.44.828-.972 1.224-2.412 1.224-4.32 0-2.16-.396-3.708-1.188-4.644-.756-.936-1.764-1.404-2.953-1.404-1.188 0-2.16.468-2.952 1.404-.792.9-1.188 2.304-1.188 4.14ZM1194.85 427.414h-4.931v-9.54c0-2.016-.109-3.312-.325-3.888a2.551 2.551 0 0 0-1.007-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.685.468-1.117 1.116-1.369 1.872-.251.756-.395 2.196-.395 4.284v8.46h-4.932V408.73h4.572v2.772c1.62-2.124 3.671-3.168 6.156-3.168 1.08 0 2.088.18 2.987.576.9.396 1.584.9 2.053 1.512.467.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592ZM1210.685 421.474l4.932.828c-.649 1.8-1.657 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.225-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.375 4.644 2.303 8.424h-12.383c.036 1.476.432 2.628 1.224 3.42.755.828 1.691 1.224 2.843 1.224.757 0 1.405-.216 1.945-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1217.564 408.73h5.256l4.465 13.284 4.355-13.284h5.112l-6.587 17.964-1.188 3.276c-.433 1.08-.829 1.908-1.225 2.484a5.653 5.653 0 0 1-1.368 1.404 5.273 5.273 0 0 1-1.871.828c-.756.216-1.584.288-2.52.288-.937 0-1.872-.072-2.808-.288l-.432-3.852c.792.144 1.476.216 2.088.216 1.152 0 2.016-.324 2.556-1.008.54-.684.972-1.548 1.26-2.592l-7.092-18.72ZM1238.16 422.086l4.968-.756c.216.972.649 1.692 1.297 2.196.648.504 1.548.756 2.7.756 1.26 0 2.231-.252 2.88-.72.431-.324.647-.756.647-1.332 0-.36-.108-.684-.36-.9-.216-.252-.792-.468-1.655-.684-3.96-.864-6.48-1.656-7.56-2.376-1.476-1.008-2.233-2.412-2.233-4.212 0-1.62.649-2.988 1.944-4.068 1.26-1.116 3.24-1.656 5.94-1.656 2.556 0 4.428.396 5.688 1.224 1.225.864 2.089 2.088 2.557 3.708l-4.644.864c-.216-.72-.576-1.296-1.152-1.692-.54-.36-1.332-.576-2.376-.576-1.296 0-2.232.18-2.773.54-.396.288-.576.612-.576 1.008 0 .36.144.648.505.9.431.324 1.98.792 4.607 1.404 2.628.576 4.464 1.332 5.508 2.196 1.009.864 1.549 2.088 1.549 3.672 0 1.692-.72 3.168-2.16 4.392-1.405 1.26-3.529 1.872-6.337 1.872-2.555 0-4.572-.54-6.048-1.548-1.476-1.044-2.447-2.448-2.916-4.212Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper Lower_Abdomen" },
	          _react2.default.createElement(
	            "g",
	            {
	              className: "bodyPartsGroup",
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Lower Back,Stomach");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Lower Back,Stomach");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              }
	            },
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M750.26 780.31c.07.13.15.25.24.36v-.98c-.06.21-.13.42-.24.62z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.33 779.68h1.14v18.07h-1.14zm71.62-69.2-1.89-.66c-.03.09-1.14 3.23-2.89 7.77 1.56-2.31 3.15-4.65 4.73-6.98.03-.06.04-.1.05-.13zm14.38-21.28-1.96-.38c-.02.06-.57 2.04-1.65 5.87 1.29-1.89 2.49-3.65 3.58-5.24.01-.1.02-.19.03-.25z"
	            }),
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "m704.9 685.14.03.21c0-.06-.02-.13-.03-.21zm-8.31-34.44c0 .03.01.21.02.54.53.44.71.44.98.44l.52-.03.3-.37c.05-.06.12-.14.19-.39 0-.11-.01-.19-.01-.24l-2 .05zm8.55 35.92c.01.06.02.11.03.16-.01-.05-.02-.1-.03-.16zm-.67-4.95.03.24-.03-.24zm.21 1.81.03.25-.03-.25zm.71 4.43c.01.03.01.06.02.09a.292.292 0 0 1-.02-.09zm-2.44-41.5v-.02.02zm1.32 33.33c.01.06.01.13.02.19-.01-.06-.01-.13-.02-.19zm98.19-28.07h.47c.27 0 .45 0 .98-.45.01-.32.01-.5.01-.53l-2-.03c0 .05 0 .12-.01.21.08.25.14.34.19.4l.36.4z"
	            }),
	            _react2.default.createElement("path", {
	              className: "syzst2",
	              d: "M801.87 650.67h.06v-.02l-.06.02zm-97.78 27.08v.04-.04zm-1.07-23.04v.02-.02zm.22 8.17v.12-.12zm-.26-10.97v.06-.06zm-.02-2.79v.08-.08zm.96 26.39c0 .05.01.09.01.13-.01-.04-.01-.08-.01-.13zm-.17-2.39c.01.08.01.16.02.24-.01-.08-.02-.16-.02-.24zm-.29-5.04c.01.1.01.2.02.3-.01-.1-.01-.2-.02-.3zm.14 2.57c.01.09.01.18.02.27-.01-.09-.02-.18-.02-.27zm-.26-5.15c0 .07.01.15.01.22 0-.07-.01-.15-.01-.22zm47.32 111.94c-.01-.21-.01-.42-.01-.63v-90.82l-.15 93.69c.19-.71.18-1.52.16-2.24z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.LowerStomach.includes(this.state.bodyTitles) || male_human_body.LowerStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M738.08 776.64c-11.26-7.51-26.36-64.68-31.33-83.46-.47-1.8-.85-3.23-1.11-4.2-.08-.29-.16-.62-.24-.98-.01-.03-.01-.06-.02-.09-.07-.35-.15-.72-.22-1.12l-.03-.16c-.07-.4-.14-.82-.2-1.27l-.03-.21a41.334 41.334 0 0 1-.22-1.67c-.06-.5-.12-1.03-.18-1.57l-.03-.24c-.06-.56-.12-1.14-.18-1.75-.01-.06-.01-.13-.02-.19-.06-.63-.12-1.28-.18-1.95v-.04c-.06-.68-.11-1.38-.17-2.1 0-.05-.01-.09-.01-.13-.05-.7-.1-1.42-.15-2.15-.01-.08-.01-.16-.02-.24-.05-.72-.09-1.45-.14-2.2-.01-.09-.01-.18-.02-.27l-.12-2.27c-.01-.1-.01-.2-.02-.3-.04-.78-.08-1.56-.11-2.36 0-.07-.01-.15-.01-.22-.04-.82-.07-1.66-.1-2.5v-.12c-.1-2.67-.17-5.4-.22-8.15v-.02c-.02-.91-.03-1.83-.04-2.74v-.06c-.01-.9-.02-1.81-.02-2.71v-2.81c.03-11.89.61-22.87 1.96-28.03-1.93.88-3.88 1.72-5.62 2.95v.01c.03 2.55.05 5.17.05 7.72.01 16.99-.43 20.83-.74 21.85.13 3.86 1.84 44.47-2.05 57.14-3.66 11.88 5.85 32.03 6.85 34.11 0 .01.01.02.01.02 2.48 3.45 18.36 25.58 22.04 31.09 1.4 2.1 3.68 4.82 6.1 7.71 5.55 6.62 9.18 11.16 9.18 13.89 0 .21-.01.54-.02.97-.69-.42-1.02-.74-1.02-.74s-.01.07-.03.19c.17.13.43.32.79.55 1.43.87 4.43 2.17 9.39 1.96l-.53-.03.02-16.52c-.32.17-.7.29-1.22.29-1.53 0-4.26-1.04-10.02-4.88z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.LowerStomach.includes(this.state.bodyTitles) || male_human_body.LowerStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M748.65 776.81V615.63c0-2.09-1.05-4.99-10.05-6-7.7.28-28.08 2.17-31.13 7.5-3.75 6.55-3.02 59.88.1 71.32.26.98.64 2.41 1.12 4.21 13.18 49.92 23.45 77.61 30.5 82.32 7.29 4.85 8.91 4.65 9.23 4.48.28-.16.25-1.29.24-1.97-.01-.23-.01-.46-.01-.68zm-59.28-132.95c-7.57-7.94-19-19.94-25.38-24.41-5.5-3.85-8.93-9.11-11.27-14.79-1.42 9.13-4.75 32.47-3.19 41.84 1.85 11.07 4.59 23.26 15.85 39.64 7.81 11.36 23.84 35.05 32.39 47.7-2.76-7.68-5.56-18.52-3.14-26.4 3.68-11.95 2.18-51.16 1.98-56.21-.86-.7-2.64-2.54-7.24-7.37zm116.52 63.58c2.43 7.88-.37 18.72-3.13 26.4 8.54-12.65 24.58-36.34 32.39-47.69 11.26-16.39 14.01-28.57 15.85-39.65 1.56-9.36-1.77-32.68-3.19-41.83-2.33 5.69-5.76 10.94-11.27 14.79-6.38 4.47-17.82 16.46-25.38 24.4-4.59 4.82-6.38 6.66-7.24 7.37 0 .13-.01.27-.01.44-.11 6.52-1.6 44.12 1.98 55.77z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.LowerStomach.includes(this.state.bodyTitles) || male_human_body.LowerStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M803.98 708.03c-3.9-12.68-2.19-53.36-2.06-57.15-.31-1.03-.75-4.9-.74-21.83 0-.85 0-1.72.01-2.58v-.59c0-.86.01-1.72.02-2.58v-.01l.03-2.7v-.36c.01-.87.03-1.73.04-2.56v-.02c-2.13-.73-4.35-1.16-6.56-1.59.02.03.05.06.07.1 4.34 7.58 3 62.19.1 72.84-.27.97-.64 2.4-1.12 4.19-4.96 18.79-20.06 75.96-31.33 83.47-5.75 3.84-8.48 4.88-10.03 4.88-.54 0-.94-.13-1.27-.31-.14-.08-.27-.17-.38-.27-.1-.08-.18-.18-.26-.27v.27l-.03 16.81-.58.03c5.04.22 8.18-1.12 9.66-1.99.1-.06.17-.11.26-.16-.01-.33-.02-.61-.02-.78 0-2.73 3.64-7.27 9.18-13.89 2.42-2.89 4.71-5.61 6.1-7.71 3.68-5.51 19.56-27.64 22.04-31.09.01-.01.02-.03.02-.04 1.1-2.29 10.49-22.29 6.85-34.11z"
	            }),
	            _react2.default.createElement("path", {
	              style: {
	                fill: male_human_body.LowerStomach.includes(this.state.bodyTitles) || male_human_body.LowerStomach.includes(this.state.bodyHoverTitles) ? "#f58220" : "#af9763"
	              },
	              className: "bodyParts",
	              d: "M761.33 774.98c7.06-4.71 17.32-32.4 30.51-82.32.47-1.8.85-3.23 1.12-4.21 3.12-11.44 3.84-64.76.1-71.32-3.05-5.33-23.43-7.22-31.13-7.5-9.01 1.01-10.05 3.91-10.05 6v161.18c0 .22-.01.45-.01.68-.02.68-.05 1.81.24 1.97.32.17 1.93.38 9.22-4.48z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M749.52 612.38v-.35c-1.67-2.33-5.22-3.78-10.77-4.4l-.08-.01-.07.01c-.09 0-.2.01-.33.01-.06 0-.15.01-.22.01-.08 0-.15.01-.23.01-.08 0-.18.01-.27.01-.1 0-.19.01-.3.01-.13.01-.27.01-.41.02-.09 0-.16.01-.25.01l-.48.03c-.1.01-.19.01-.29.02-.18.01-.37.02-.57.04-.09.01-.19.01-.28.02-.21.01-.43.03-.65.04-.1.01-.19.01-.29.02-.23.02-.47.04-.71.05-.1.01-.2.02-.31.02l-.78.06-.3.03c-.27.02-.54.05-.81.07l-.34.03c-.28.03-.56.05-.84.08-.12.01-.23.02-.35.04-.29.03-.59.06-.89.1-.11.01-.23.02-.34.04-.31.03-.61.07-.93.11-.12.01-.23.03-.35.04l-.96.12c-.11.01-.22.03-.33.04-.33.04-.66.09-.99.14-.11.02-.23.03-.34.05l-1 .15c-.11.02-.23.04-.34.05-.34.05-.67.11-1.01.17l-.34.06-1.01.18-.33.06c-.34.06-.67.13-1 .2-.11.02-.22.05-.34.07l-.99.21c-.11.02-.22.05-.32.07-.33.08-.66.15-.98.23-.1.03-.21.05-.31.08-.32.08-.65.17-.96.25-.1.03-.2.05-.29.08-.32.09-.63.18-.94.27-.1.03-.19.06-.28.09-.31.1-.61.19-.91.29-.09.03-.18.06-.26.09-.3.1-.59.21-.87.32l-.24.09c-.28.11-.56.22-.84.34-.07.03-.14.06-.22.1-.27.12-.54.24-.79.37-.07.03-.13.07-.19.1-.25.13-.5.26-.74.4-.05.03-.1.06-.16.09-.24.14-.47.28-.69.43l-.12.09c-.22.15-.43.31-.63.47-.03.03-.06.05-.09.08-.2.17-.39.34-.57.51-.02.02-.03.04-.05.05-.18.19-.35.37-.5.57-.15.19-.29.39-.41.6-.3.52-.57 1.28-.82 2.23-1.35 5.16-1.93 16.14-1.96 28.03v2.81c0 .9.01 1.8.02 2.71v.06c.01.91.02 1.83.04 2.74v.02c.05 2.75.12 5.49.22 8.15v.12c.03.84.06 1.67.1 2.5 0 .07.01.15.01.22.03.8.07 1.58.11 2.36.01.1.01.2.02.3l.12 2.27c.01.09.01.18.02.27.04.75.09 1.48.14 2.2.01.08.01.16.02.24.05.73.1 1.45.15 2.15 0 .05.01.09.01.13.05.72.11 1.42.17 2.1v.04c.06.67.12 1.32.18 1.95.01.06.01.13.02.19.06.6.12 1.18.18 1.75l.03.24a182.642 182.642 0 0 0 .21 1.82c.06.49.13.97.19 1.42l.03.21c.07.45.13.87.2 1.27.01.06.02.11.03.16.07.4.14.78.22 1.12.01.03.01.06.02.09.08.36.16.69.24.98.26.97.64 2.4 1.11 4.2 4.97 18.78 20.07 75.95 31.33 83.46 5.76 3.84 8.49 4.88 10.03 4.88.52 0 .9-.12 1.22-.29v-.16l.17-168.67zm-1.1 167.08c-.32.17-1.94.37-9.23-4.48-7.05-4.71-17.32-32.4-30.5-82.32-.48-1.8-.86-3.23-1.12-4.21-3.12-11.44-3.85-64.77-.1-71.32 3.05-5.33 23.43-7.22 31.13-7.5 9 1.01 10.05 3.91 10.05 6v161.18c0 .22 0 .45.01.68.01.68.04 1.81-.24 1.97zm-43.92-97.55zm-.4-4.13c.06.67.12 1.32.18 1.95-.07-.63-.13-1.27-.18-1.95zm.19 2.15zm-.36-4.29zm1.01 9.72c.07.45.13.87.2 1.27-.07-.4-.14-.83-.2-1.27z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M702.96 649.12v-2.71c-.01.9-.01 1.81 0 2.71zm2.45 38.88c.08.36.16.69.24.98-.09-.29-.17-.63-.24-.98zm-.24-1.21zm-.46-3.06c.06.49.13.97.19 1.42-.06-.46-.13-.93-.19-1.42zm-1.75-34.53c0 .9.01 1.8.02 2.71-.01-.9-.02-1.81-.02-2.71zm.06 5.53zm-.04-2.75c.01.91.02 1.83.04 2.74-.02-.92-.03-1.83-.04-2.74zm1.93-33.62c-1.35 5.16-1.93 16.14-1.96 28.03.04-11.88.62-22.86 1.96-28.03zM703.24 663zm.37 7.92c.04.75.09 1.48.14 2.2-.05-.72-.09-1.45-.14-2.2zm-.13-2.54.12 2.27c-.05-.75-.09-1.5-.12-2.27zm.28 4.98zm-.41-7.64c.03.8.07 1.58.11 2.36-.04-.78-.08-1.56-.11-2.36zm46.52 111.72c0-.21.01-.42.01-.63V615.63c0-.81.13-1.56.39-2.25-.13-.35-.29-.68-.49-1-.07-.12-.18-.23-.26-.35v.35l-.19 168.69v.16c.02-.01.04-.02.05-.02.08-.04.15-.09.21-.14.3-.2.52-.46.67-.76-.44-.83-.41-1.93-.39-2.87zm-99.41-171.29c-1.52 9.96-4.31 30.56-2.99 40.06-1.32-13.09 4.26-29.8 2.99-40.06z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M696.55 708.03c3.9-12.67 2.19-53.28 2.05-57.14-.07.24-.14.33-.19.39l-.3.37-.52.03c-.27 0-.44 0-.98-.44.2 5.05 1.69 44.26-1.98 56.21-2.42 7.88.37 18.72 3.14 26.4-8.55-12.65-24.58-36.34-32.39-47.7-11.27-16.39-14.01-28.57-15.85-39.64-1.56-9.37 1.77-32.71 3.19-41.84-.52-1.27-.99-2.55-1.41-3.85-.12.69-.44 2.62-.85 5.34 1.27 10.26-4.3 26.96-2.99 40.06.03.21.05.42.09.62 1.88 11.29 4.68 23.72 16.18 40.45.47.68.97 1.41 1.49 2.17-.01-.1-.02-.19-.03-.25l1.96-.38c.02.07.58 2.05 1.65 5.86 3.25 4.76 7.02 10.31 10.83 15.93-.02-.06-.04-.1-.05-.13l1.88-.66c.03.09 1.13 3.2 2.87 7.72.01.01.01.01.01.02 8.17 12.06 15.56 23 17.12 25.31l1.62-1.17c.01.02.12.15.31.41 0 0 .01.01.01.02-1.02-2.08-10.52-22.23-6.86-34.11zm54.59 73.18c.33.18.73.31 1.27.31 1.55 0 4.28-1.04 10.03-4.88 11.27-7.51 26.37-64.68 31.33-83.47.48-1.79.85-3.22 1.12-4.19 2.9-10.65 4.24-65.26-.1-72.84-.02-.03-.05-.06-.07-.1-.46-.77-1.17-1.46-2.07-2.1-6.04-4.3-20.71-5.72-27.47-6.15-.05 0-.1-.01-.16-.01l-.57-.03c-.07 0-.15-.01-.22-.01l-.47-.03c-.08 0-.15-.01-.22-.01-.13-.01-.26-.01-.38-.02-.08 0-.15-.01-.22-.01-.11 0-.21-.01-.31-.01-.06 0-.12 0-.17-.01-.08 0-.17-.01-.24-.01-.12 0-.22-.01-.3-.01l-.08-.01-.07.01c-5.51.61-9.07 2.04-10.75 4.34-.1.13-.18.27-.26.41l-.12 73.61v90.82c0 .21 0 .42.01.63.02.72.03 1.53-.16 2.24v.98c.08.1.16.19.26.27.12.11.25.2.39.28zm.73-3.72c0-.23.01-.46.01-.68V615.63c0-2.09 1.04-4.99 10.05-6 7.7.28 28.08 2.17 31.13 7.5 3.74 6.56 3.02 59.88-.1 71.32-.27.98-.65 2.41-1.12 4.21-13.19 49.92-23.45 77.61-30.51 82.32-7.29 4.86-8.9 4.65-9.22 4.48-.29-.16-.26-1.29-.24-1.97z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M750.65 615.63v70.36l.12-73.61c-.2.32-.37.65-.5 1 .25.69.38 1.44.38 2.25z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M750.65 615.63c0-.81-.13-1.56-.38-2.25a6.33 6.33 0 0 0-.39 2.25v161.18c0 .21-.01.42-.01.63-.02.94-.05 2.04.39 2.87.11-.2.18-.41.24-.63l.15-93.69v-70.36zm99.01-10.47c-1.82 10.43 4.59 28.49 2.77 42.15-.1.74-.16 1.49-.2 2.25.01.01 0 .02 0 .03-.02.49-.02.99-.02 1.49.1-.5.19-1 .28-1.49 0-.01.01-.02 0-.03.04-.76.1-1.51.2-2.25 1.82-13.66-4.59-31.72-2.77-42.15v-.01c-.04-.24-.07-.46-.11-.68-.05.22-.11.44-.15.69z"
	            }),
	            _react2.default.createElement("path", {
	              className: "bodyLines",
	              d: "M849.22 600.81c-.42 1.3-.89 2.59-1.41 3.85 1.42 9.15 4.75 32.47 3.19 41.83-1.84 11.08-4.59 23.26-15.85 39.65-7.81 11.35-23.85 35.04-32.39 47.69 2.76-7.68 5.56-18.52 3.13-26.4-3.58-11.65-2.09-49.25-1.98-55.77 0-.17.01-.32.01-.44-.54.44-.72.45-.98.45h-.47l-.34-.39c-.05-.06-.12-.15-.19-.4-.13 3.79-1.85 44.47 2.06 57.15 3.64 11.82-5.75 31.82-6.85 34.09.19-.26.3-.39.31-.41l1.62 1.17c1.56-2.31 8.94-13.24 17.11-25.29a306.7 306.7 0 0 0 2.89-7.77l1.89.66c-.01.03-.02.07-.05.13 3.81-5.62 7.58-11.17 10.82-15.92 1.08-3.83 1.63-5.81 1.65-5.87l1.96.38c-.01.06-.02.15-.03.25.52-.76 1.02-1.49 1.49-2.17 10.08-14.65 13.47-26.01 15.42-36.2-.01-.5 0-1 .02-1.49 0-.01.01-.02 0-.03.04-.76.1-1.51.2-2.25 1.82-13.66-4.59-31.72-2.77-42.15v-.01c.04-.24.1-.46.15-.68-.28-1.81-.49-3.09-.59-3.64-.02-.01-.02-.01-.02-.02z"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-lower_back is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Lower Back");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Lower Back");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "175",
	              y: "627",
	              width: "210",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(-887.13 95.455)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(-.70597 0 0 -.7655 2231.84 697.33)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Lower Back" ? "#f58220" : "#af9763"
	                },
	                d: "M1068.126 563.563v-25.56h5.184v21.204h12.96v4.356h-18.144ZM1088.784 553.951c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM1115.382 563.563l-5.904-18.684h4.824l3.492 12.24 3.204-12.24h4.788l3.096 12.24 3.564-12.24h4.86l-5.976 18.684h-4.752l-3.204-11.988-3.168 11.988h-4.824ZM1150.736 557.623l4.932.828c-.648 1.8-1.656 3.168-2.988 4.104-1.368.972-3.096 1.44-5.148 1.44-3.24 0-5.652-1.08-7.2-3.204-1.224-1.692-1.836-3.816-1.836-6.408 0-3.096.792-5.544 2.412-7.272 1.62-1.764 3.672-2.628 6.156-2.628 2.772 0 4.968.9 6.552 2.736 1.62 1.836 2.376 4.644 2.304 8.424h-12.384c.036 1.476.432 2.628 1.224 3.42.756.828 1.692 1.224 2.844 1.224.756 0 1.404-.216 1.944-.612.54-.432.936-1.116 1.188-2.052Zm.288-5.004c-.036-1.404-.396-2.52-1.116-3.24-.684-.756-1.548-1.116-2.556-1.116-1.08 0-1.98.396-2.664 1.152-.72.792-1.08 1.872-1.044 3.204h7.38ZM1164.672 563.563h-4.932v-18.684h4.572v2.664c.792-1.26 1.512-2.088 2.124-2.484.648-.396 1.332-.576 2.16-.576 1.116 0 2.196.288 3.24.936l-1.548 4.284c-.828-.54-1.584-.792-2.304-.792-.684 0-1.296.18-1.764.576-.468.36-.864 1.044-1.116 2.052-.288 1.008-.432 3.096-.432 6.264v5.76ZM1184.002 537.787h10.296c2.052 0 3.564.108 4.572.252 1.008.18 1.908.54 2.7 1.08.792.54 1.44 1.26 1.98 2.16.504.9.792 1.872.792 2.988 0 1.224-.324 2.34-.972 3.348-.648 1.008-1.548 1.764-2.664 2.268 1.584.432 2.772 1.224 3.636 2.34.828 1.08 1.26 2.376 1.26 3.852 0 1.188-.288 2.34-.828 3.42-.54 1.116-1.296 2.016-2.232 2.664-.936.684-2.088 1.08-3.492 1.224-.864.108-2.952.144-6.264.18h-8.784v-25.776Zm5.22 4.284v5.976h3.42c2.016 0 3.276-.036 3.744-.108.9-.108 1.62-.396 2.124-.9s.756-1.188.756-2.016c0-.792-.216-1.44-.648-1.944-.432-.504-1.116-.792-1.98-.9-.504-.072-1.98-.108-4.428-.108h-2.988Zm0 10.26v6.876h4.824c1.872 0 3.06-.036 3.564-.144.756-.144 1.404-.468 1.872-1.044.504-.54.72-1.26.72-2.16 0-.792-.18-1.44-.54-1.98-.396-.54-.936-.936-1.62-1.188-.72-.252-2.268-.36-4.644-.36h-4.176ZM1213.638 550.603l-4.464-.828c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.624 3.996c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1246.258 550.423l-4.86.864c-.18-.972-.54-1.692-1.116-2.196-.576-.504-1.332-.72-2.268-.72-1.224 0-2.232.396-2.952 1.26-.72.864-1.08 2.268-1.08 4.248 0 2.232.36 3.78 1.116 4.716.72.9 1.728 1.368 2.988 1.368.936 0 1.692-.288 2.304-.792.576-.54 1.008-1.476 1.26-2.772l4.86.828c-.504 2.232-1.476 3.924-2.916 5.04-1.44 1.152-3.348 1.728-5.724 1.728-2.736 0-4.932-.864-6.552-2.592-1.62-1.728-2.412-4.104-2.412-7.164 0-3.06.792-5.472 2.412-7.2 1.656-1.692 3.852-2.556 6.624-2.556 2.268 0 4.068.468 5.436 1.44 1.332 1.008 2.304 2.484 2.88 4.5ZM1249.826 563.563v-25.776h4.932v13.68l5.796-6.588h6.084l-6.408 6.84 6.84 11.844h-5.328l-4.68-8.388-2.304 2.412v5.976h-4.932Z"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-stomach" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Stomach");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Stomach");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "648",
	              width: "160",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 253.338)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.63435 0 0 .7655 249.825 268.088)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Stomach" ? "#f58220" : "#af9763"
	                },
	                d: "m1119.997 419.026 5.076-.504c.288 1.728.9 2.952 1.836 3.744.936.828 2.196 1.224 3.78 1.224 1.692 0 2.952-.36 3.78-1.08.864-.72 1.296-1.548 1.296-2.484 0-.612-.18-1.116-.54-1.548-.36-.432-1.008-.792-1.872-1.116-.612-.216-2.016-.612-4.176-1.116-2.772-.72-4.752-1.548-5.868-2.556-1.584-1.44-2.376-3.168-2.376-5.184 0-1.332.36-2.556 1.116-3.708a6.992 6.992 0 0 1 3.204-2.592c1.404-.612 3.096-.9 5.076-.9 3.24 0 5.688.72 7.308 2.124 1.656 1.404 2.484 3.312 2.592 5.688l-5.22.216c-.216-1.332-.684-2.268-1.44-2.844-.72-.576-1.836-.864-3.276-.864-1.512 0-2.7.288-3.564.9-.54.432-.828.936-.828 1.62 0 .612.252 1.116.792 1.548.648.576 2.232 1.152 4.752 1.728 2.556.612 4.428 1.224 5.616 1.872a7.188 7.188 0 0 1 2.88 2.592c.684 1.116 1.008 2.484 1.008 4.14 0 1.476-.396 2.844-1.224 4.14-.828 1.296-1.98 2.232-3.492 2.88-1.476.612-3.348.936-5.58.936-3.276 0-5.76-.756-7.524-2.268-1.728-1.512-2.772-3.708-3.132-6.588ZM1153.871 408.73v3.96h-3.384v7.524c0 1.512.036 2.412.108 2.664.036.252.18.468.432.612.216.18.504.252.828.252.468 0 1.116-.144 1.98-.468l.432 3.816c-1.152.504-2.448.756-3.924.756-.864 0-1.692-.144-2.376-.468-.72-.288-1.26-.684-1.584-1.152-.324-.468-.576-1.116-.684-1.908-.108-.576-.18-1.764-.18-3.492v-8.136h-2.268v-3.96h2.268v-3.708l4.968-2.88v6.588h3.384ZM1156.141 417.802c0-1.62.396-3.204 1.224-4.752.792-1.548 1.944-2.7 3.42-3.528 1.476-.792 3.132-1.188 4.968-1.188 2.844 0 5.148.9 6.948 2.736 1.8 1.836 2.7 4.14 2.7 6.948 0 2.844-.9 5.184-2.736 7.02-1.8 1.872-4.104 2.808-6.876 2.808-1.692 0-3.348-.396-4.896-1.188-1.548-.756-2.736-1.872-3.528-3.384-.828-1.476-1.224-3.312-1.224-5.472Zm5.076.288c0 1.836.432 3.276 1.296 4.248.9.972 1.98 1.476 3.276 1.476 1.26 0 2.34-.504 3.24-1.476.864-.972 1.296-2.412 1.296-4.284 0-1.836-.432-3.24-1.296-4.212-.9-1.008-1.98-1.476-3.24-1.476-1.296 0-2.376.468-3.276 1.476-.864.972-1.296 2.376-1.296 4.248ZM1178.923 408.73h4.536v2.556c1.62-1.98 3.564-2.952 5.832-2.952 1.188 0 2.232.252 3.096.72.864.504 1.584 1.26 2.16 2.232.828-.972 1.692-1.728 2.664-2.232a6.683 6.683 0 0 1 3.024-.72c1.368 0 2.556.252 3.492.828.936.54 1.656 1.368 2.124 2.448.324.792.504 2.088.504 3.852v11.952h-4.932v-10.656c0-1.872-.18-3.06-.504-3.6-.468-.72-1.152-1.044-2.124-1.044-.684 0-1.332.216-1.944.612-.612.432-1.044 1.044-1.332 1.872-.252.792-.396 2.088-.396 3.852v8.964h-4.932V417.19c0-1.836-.072-2.988-.252-3.528-.18-.504-.468-.9-.828-1.188-.36-.252-.864-.36-1.512-.36-.756 0-1.44.18-2.052.612-.612.396-1.044 1.008-1.296 1.764-.288.792-.396 2.052-.396 3.852v9.072h-4.932V408.73ZM1214.965 414.454l-4.464-.828c.504-1.8 1.368-3.132 2.592-3.996 1.224-.864 3.06-1.296 5.472-1.296 2.232 0 3.852.252 4.932.756 1.08.54 1.836 1.188 2.268 2.016.468.792.684 2.268.684 4.392l-.072 5.796c0 1.62.072 2.844.252 3.6.144.792.432 1.62.864 2.52h-4.86c-.144-.324-.288-.828-.468-1.476-.108-.288-.144-.468-.18-.576-.864.828-1.764 1.44-2.736 1.872a7.869 7.869 0 0 1-3.06.612c-1.908 0-3.42-.54-4.536-1.584-1.116-1.044-1.656-2.34-1.656-3.96 0-1.044.252-1.98.756-2.808.504-.828 1.188-1.44 2.088-1.908.936-.432 2.232-.828 3.96-1.152 2.304-.432 3.888-.828 4.788-1.188v-.504c0-.936-.252-1.62-.72-2.016-.468-.432-1.332-.612-2.628-.612-.9 0-1.584.18-2.052.504-.504.36-.9.972-1.224 1.836Zm6.624 3.996c-.648.216-1.62.468-3.024.756-1.368.288-2.268.576-2.664.864-.648.468-.972 1.044-.972 1.728 0 .684.252 1.296.756 1.8.54.504 1.188.756 1.98.756.9 0 1.728-.288 2.556-.864.576-.468.972-1.008 1.188-1.656.108-.432.18-1.224.18-2.412v-.972ZM1247.585 414.274l-4.86.864c-.18-.972-.54-1.692-1.116-2.196-.576-.504-1.332-.72-2.268-.72-1.224 0-2.232.396-2.952 1.26-.72.864-1.08 2.268-1.08 4.248 0 2.232.36 3.78 1.116 4.716.72.9 1.728 1.368 2.988 1.368.936 0 1.692-.288 2.304-.792.576-.54 1.008-1.476 1.26-2.772l4.86.828c-.504 2.232-1.476 3.924-2.916 5.04-1.44 1.152-3.348 1.728-5.724 1.728-2.736 0-4.932-.864-6.552-2.592-1.62-1.728-2.412-4.104-2.412-7.164 0-3.06.792-5.472 2.412-7.2 1.656-1.692 3.852-2.556 6.624-2.556 2.268 0 4.068.468 5.436 1.44 1.332 1.008 2.304 2.484 2.88 4.5ZM1256.23 401.638v9.468c1.62-1.836 3.527-2.772 5.723-2.772 1.152 0 2.16.216 3.096.612.9.432 1.584.972 2.052 1.62.468.648.792 1.404.936 2.196.18.792.252 2.016.252 3.708v10.944h-4.932v-9.864c0-1.944-.072-3.204-.288-3.708-.18-.54-.504-.972-.972-1.26-.468-.324-1.08-.468-1.8-.468-.792 0-1.548.18-2.196.576-.648.396-1.116 1.008-1.404 1.8-.288.828-.468 2.016-.468 3.564v9.36h-4.932v-25.776h4.932Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper" },
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-hip" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Hip");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Hip");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "1115",
	              y: "738",
	              width: "65",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 80.915)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M842.407 191.303H1331.1",
	                transform: "matrix(.45018 0 0 .7655 494.968 528.935)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Hip" ? "#f58220" : "#af9763"
	                },
	                d: "M1119.993 688.05v-25.776h5.22v10.152h10.188v-10.152h5.22v25.776h-5.22v-11.268h-10.188v11.268h-5.22ZM1145.947 666.846v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM1155.813 669.366h4.608v2.772a6.741 6.741 0 0 1 2.412-2.304 6.86 6.86 0 0 1 3.384-.864c2.196 0 4.032.828 5.544 2.556 1.512 1.692 2.268 4.032 2.268 7.092 0 3.096-.756 5.544-2.304 7.272-1.512 1.728-3.348 2.592-5.544 2.592a6.39 6.39 0 0 1-2.772-.612c-.864-.432-1.728-1.116-2.664-2.124v9.396h-4.932v-25.776Zm4.896 9.036c0 2.088.396 3.636 1.224 4.644s1.872 1.512 3.06 1.512c1.152 0 2.088-.468 2.844-1.368.792-.936 1.152-2.448 1.152-4.536 0-1.98-.396-3.42-1.188-4.356-.756-.972-1.728-1.44-2.916-1.44s-2.196.468-2.988 1.404c-.792.936-1.188 2.304-1.188 4.14Z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { className: "bodyParts_wrapper" },
	          _react2.default.createElement(
	            "g",
	            { className: "labelGroup labelGroup-skin is_right" },
	            _react2.default.createElement("rect", {
	              onClick: function onClick(e) {
	                return _this2.modalMaleBodySingleContentOpen(e, "Skin");
	              },
	              onMouseOver: function onMouseOver(e) {
	                return _this2.handleHoverBodyPart("Skin");
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return _this2.handleHoverBodyPart(null);
	              },
	              className: "labelArea",
	              x: "300",
	              y: "1026",
	              width: "85",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(0 166.144)" },
	              _react2.default.createElement("path", {
	                className: "labelLine",
	                d: "M802.407 191.303H1331.1",
	                transform: "matrix(-.45018 0 0 -.7655 1004.24 1030.38)"
	              }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                style: {
	                  fill: this.state.bodyTitles === "Skin" ? "#f58220" : "#af9763"
	                },
	                d: "m307.654 884.649 5.076-.504c.288 1.728.9 2.952 1.836 3.744.936.828 2.196 1.224 3.78 1.224 1.692 0 2.952-.36 3.78-1.08.864-.72 1.296-1.548 1.296-2.484 0-.612-.18-1.116-.54-1.548-.36-.432-1.008-.792-1.872-1.116-.612-.216-2.016-.612-4.176-1.116-2.772-.72-4.752-1.548-5.868-2.556-1.584-1.44-2.376-3.168-2.376-5.184 0-1.332.36-2.556 1.116-3.708a6.992 6.992 0 0 1 3.204-2.592c1.404-.612 3.096-.9 5.076-.9 3.24 0 5.688.72 7.308 2.124 1.656 1.404 2.484 3.312 2.592 5.688l-5.22.216c-.216-1.332-.684-2.268-1.44-2.844-.72-.576-1.836-.864-3.276-.864-1.512 0-2.7.288-3.564.9-.54.432-.828.936-.828 1.62 0 .612.252 1.116.792 1.548.648.576 2.232 1.152 4.752 1.728 2.556.612 4.428 1.224 5.616 1.872a7.188 7.188 0 0 1 2.88 2.592c.684 1.116 1.008 2.484 1.008 4.14 0 1.476-.396 2.844-1.224 4.14-.828 1.296-1.98 2.232-3.492 2.88-1.476.612-3.348.936-5.58.936-3.276 0-5.76-.756-7.524-2.268-1.728-1.512-2.772-3.708-3.132-6.588ZM332.78 893.037v-25.776h4.932v13.68l5.796-6.588h6.084l-6.408 6.84 6.84 11.844h-5.328l-4.68-8.388-2.304 2.412v5.976h-4.932ZM352.98 871.833v-4.572h4.932v4.572h-4.932Zm0 21.204v-18.684h4.932v18.684h-4.932ZM379.936 893.037h-4.932v-9.54c0-2.016-.108-3.312-.324-3.888a2.551 2.551 0 0 0-1.008-1.404c-.468-.324-1.044-.468-1.728-.468-.828 0-1.62.216-2.304.684-.684.468-1.116 1.116-1.368 1.872s-.396 2.196-.396 4.284v8.46h-4.932v-18.684h4.572v2.772c1.62-2.124 3.672-3.168 6.156-3.168 1.08 0 2.088.18 2.988.576.9.396 1.584.9 2.052 1.512.468.612.792 1.296.972 2.052.18.792.252 1.908.252 3.348v11.592Z"
	              })
	            )
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        "div",
	        { className: "pt-5 pb-4", style: { backgroundColor: "#F7F5EF" } },
	        _react2.default.createElement(
	          "section",
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "container pt-0 pt-md-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-4 d-flex flex-column justify-content-between" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "flex",
	                      justifyContent: "flex-start",
	                      alignItems: "flex-start",
	                      flexDirection: "column",
	                      marginBottom: "10px",
	                      textAlign: "center",
	                      width: "100%"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "h3",
	                    {
	                      className: "text-left w-100",
	                      style: {
	                        color: "#af9763",
	                        fontSize: "28px",
	                        fontWeight: "500"
	                      }
	                    },
	                    "Select Body Part"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "tabs", id: "tabs-mm" },
	                  _react2.default.createElement(
	                    "div",
	                    { id: "tab2", className: "tab" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "text-areya" },
	                      FeMaleBodySVGReactElement
	                    ),
	                    _react2.default.createElement(
	                      "ul",
	                      { className: "nav" },
	                      _react2.default.createElement(
	                        "li",
	                        { onClick: function onClick() {
	                            return _this2.handleToggleGender("male");
	                          } },
	                        _react2.default.createElement(
	                          "a",
	                          { href: "#tab1" },
	                          _react2.default.createElement("img", { src: _male2.default, alt: "" }),
	                          " Male"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        {
	                          className: "active",
	                          onClick: function onClick() {
	                            return _this2.handleToggleGender("female");
	                          }
	                        },
	                        _react2.default.createElement(
	                          "a",
	                          { href: "#tab2", className: "border-red" },
	                          _react2.default.createElement("img", { src: _female2.default, alt: "" }),
	                          " Female"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { id: "tab1", className: "tab" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "text-areya " },
	                      MaleBodySVGReactElement
	                    ),
	                    _react2.default.createElement(
	                      "ul",
	                      { className: "nav" },
	                      _react2.default.createElement(
	                        "li",
	                        {
	                          className: "active",
	                          onClick: function onClick() {
	                            return _this2.handleToggleGender("male");
	                          }
	                        },
	                        _react2.default.createElement(
	                          "a",
	                          { href: "#tab1" },
	                          _react2.default.createElement("img", { src: _male2.default, alt: "" }),
	                          " Male"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        { onClick: function onClick() {
	                            return _this2.handleToggleGender("female");
	                          } },
	                        _react2.default.createElement(
	                          "a",
	                          { href: "#tab2", className: "border-red" },
	                          _react2.default.createElement("img", { src: _female2.default, alt: "" }),
	                          " Female"
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-8 mt-3 mt-lg-0" },
	                _react2.default.createElement(_Department2.default, {
	                  departments: this.state.bodyDepartment,
	                  doctors: this.state.bodyDepartmentDoctor,
	                  handleChange: this.handleChange
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CenterExcellence;
	}(_react.Component);
	
	exports.default = CenterExcellence;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _fa = __webpack_require__(62);
	
	var _iconsRotate = __webpack_require__(107);
	
	var _iconsRotate2 = _interopRequireDefault(_iconsRotate);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import search_icon from '../../../images/search-icon.png';
	
	
	var getDefaultSearch = function getDefaultSearch(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/homesetting/getdefaultsearchdata", {
	      method: "get",
	      headers: {
	        Accept: "application/json"
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSearchData = function getSearchData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/homesetting/getsearchdata", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllBannerButtonData = function getAllBannerButtonData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bannerbutton/getallbannerbtndata", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var HomeSearch = function (_Component) {
	  _inherits(HomeSearch, _Component);
	
	  function HomeSearch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HomeSearch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HomeSearch.__proto__ || Object.getPrototypeOf(HomeSearch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      search_keywords: "",
	      default_doctors: [],
	      default_packages: [],
	      default_publications: [],
	      default_departments: [],
	      bannerbuttons: []
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshGetDefaultSearchData = function () {
	      getDefaultSearch().then(function (res) {
	        if (res.status === true) {
	          _this.setState({
	            default_doctors: res.doctor_data,
	            default_packages: res.package_data,
	            default_publications: res.publication_data,
	            default_departments: res.department_data
	          });
	        } else {
	          _this.setState({
	            default_doctors: "",
	            default_packages: "",
	            default_publications: "",
	            default_departmnents: ""
	          });
	        }
	      }).catch(function (err) {});
	    }, _this.handleKeyUp = function (event) {
	      var data = {
	        keywords: _this.state.search_keywords
	      };
	      getSearchData(data).then(function (res) {
	        if (res.status === true) {
	          _this.setState({
	            default_doctors: res.doctor_data,
	            default_packages: res.package_data,
	            default_publications: res.publication_data,
	            default_departments: res.department_data
	          });
	        } else {
	          _this.setState({
	            default_doctors: "",
	            default_packages: "",
	            default_publications: "",
	            default_departmnents: ""
	          });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshGetAllBannerButtonData = function () {
	      getAllBannerButtonData().then(function (res) {
	        if (res.status === true) {
	          _this.setState({
	            bannerbuttons: res.data
	          });
	        } else {
	          _this.setState({
	            bannerbuttons: ""
	          });
	        }
	      }).catch(function (err) {});
	    }, _this.showSearchResult = function () {
	      (0, _jquery2.default)(".search-popup").show();
	      (0, _jquery2.default)("body").click(function () {
	        (0, _jquery2.default)(".search-popup").hide();
	      });
	      _this.refreshGetDefaultSearchData();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(HomeSearch, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshGetAllBannerButtonData();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      console.log(this.state.bannerbuttons);
	      return _react2.default.createElement(
	        "div",
	        { className: "banner_part_search" },
	        _react2.default.createElement("h1", {
	          "data-aos": "fade-up",
	          "data-aos-duration": "1000",
	          style: { color: "black", textAlign: "center" }
	        }),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "center-search",
	            "data-aos": "fade-up",
	            "data-aos-duration": "1000",
	            style: { position: "relative", zIndex: "999" }
	          },
	          _react2.default.createElement(
	            "form",
	            { className: "d-flex" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 home_search_input_section" },
	              _react2.default.createElement("input", {
	                type: "text",
	                name: "search_keywords",
	                id: "search_keywords",
	                value: this.state.search_keywords,
	                className: "form-control physicans",
	                placeholder: "Search for your doctor. department or health screening package...",
	                "aria-label": "Username",
	                onChange: this.handleChange,
	                onClick: this.showSearchResult,
	                onKeyUp: this.handleKeyUp,
	                "aria-describedby": "basic-addon2"
	              }),
	              _react2.default.createElement(
	                "span",
	                {
	                  style: { cursor: "pointer" },
	                  className: "input-group-text",
	                  value: this.state.search_keywords,
	                  onClick: this.showSearchResult,
	                  id: "basic-addon1"
	                },
	                _react2.default.createElement("img", { src: "/assets/images/Search.png", alt: "" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "search-popup-main", style: { width: "100%" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "search-popup dd", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    "Specialists"
	                  ),
	                  _react2.default.createElement("hr", { className: "lists-line" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row mt-4" },
	                    this.state.default_doctors.length > 0 ? this.state.default_doctors.map(function (default_search_doctor) {
	                      var doctor_name = default_search_doctor.doctor_name;
	                      var new_doctor_name = doctor_name.replaceAll(" ", "-");
	                      return _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-4 col-md-12 mt-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "doctor-list" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              href: _constants.SITE_URL + "/consultant/" + default_search_doctor.slug,
	                              style: {
	                                textDecoration: "none",
	                                color: "#212529"
	                              }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-5" },
	                                default_search_doctor.doctor_profile ? _react2.default.createElement("img", {
	                                  src: _constants.IMAGE_URL + "/DoctorProfileImg/" + default_search_doctor.doctor_profile,
	                                  alt: "Bitmap-3",
	                                  style: {
	                                    height: "120px",
	                                    width: "100%"
	                                  }
	                                }) : _react2.default.createElement("img", {
	                                  src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                                  alt: "Bitmap-3",
	                                  style: {
	                                    height: "120px",
	                                    width: "100%"
	                                  }
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-7" },
	                                _react2.default.createElement(
	                                  "h6",
	                                  { style: { fontSize: "14px" } },
	                                  default_search_doctor.doctor_name
	                                ),
	                                _react2.default.createElement(
	                                  "p",
	                                  { style: { fontSize: "12px" } },
	                                  default_search_doctor.degree
	                                )
	                              )
	                            )
	                          )
	                        )
	                      );
	                    }) : _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-12 col-md-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "doctor-list" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "p",
	                            { style: { fontSize: "12px" } },
	                            "no result found"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    "Departments"
	                  ),
	                  _react2.default.createElement("hr", { className: "lists-line" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row mt-4" },
	                    this.state.default_departments ? this.state.default_departments.map(function (department) {
	                      var department_name = department.department_name;
	                      // let new_doctor_name = doctor_name.replaceAll(' ', '-');
	                      return _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-4 col-md-12 mt-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "doctor-list" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              href: _constants.SITE_URL + "/departments/" + department.slug,
	                              style: {
	                                textDecoration: "none",
	                                color: "#212529"
	                              }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-5" },
	                                department.image ? _react2.default.createElement("img", {
	                                  src: _constants.IMAGE_URL + "/DepartmentImage/" + department.image,
	                                  alt: "Bitmap-3",
	                                  style: {
	                                    height: "120px",
	                                    width: "100%"
	                                  }
	                                }) : _react2.default.createElement("img", {
	                                  src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                                  alt: "Bitmap-3",
	                                  style: {
	                                    height: "120px",
	                                    width: "100%"
	                                  }
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-7" },
	                                _react2.default.createElement(
	                                  "h6",
	                                  { style: { fontSize: "14px" } },
	                                  department_name
	                                )
	                              )
	                            )
	                          )
	                        )
	                      );
	                    }) : _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-12 col-md-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "doctor-list" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "p",
	                            { style: { fontSize: "12px" } },
	                            "no result found"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "h5",
	                    null,
	                    "Packages"
	                  ),
	                  _react2.default.createElement("hr", { className: "lists-line" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row mt-4" },
	                    this.state.default_packages.length > 0 ? this.state.default_packages.map(function (default_search_packages) {
	                      var package_name = default_search_packages.name;
	                      var new_package_name = package_name.replaceAll(" ", "-");
	                      console.log(default_search_packages);
	                      return _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-4 col-sm-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "Package-part" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              href: _constants.SITE_URL + "/packages/" + new_package_name,
	                              style: {
	                                textDecoration: "none",
	                                color: "#212529"
	                              }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 sp-0-search" },
	                                _react2.default.createElement("img", {
	                                  src: _constants.IMAGE_URL + "Packagesimg/202303221003packages%20Profile.png",
	                                  alt: "icons-rotate"
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-8 sp-0-search bg-color-gry" },
	                                _react2.default.createElement(
	                                  "h6",
	                                  { style: { fontSize: "16px" } },
	                                  default_search_packages.name
	                                )
	                              )
	                            )
	                          )
	                        )
	                      );
	                    }) : _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-12 col-sm-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Package-part" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "No packages found"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null)
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "row  sp-top",
	            style: {
	              position: "relative",
	              zIndex: "1",
	              right: "0",
	              left: "0",
	              display: "flex",
	              justifyContent: "center",
	              scrollBehavior: "smooth"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "col-xl-9 col-xxl-8" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              this.state.bannerbuttons.length > 0 ? this.state.bannerbuttons.map(function (banner_button) {
	                var buttonSlug = banner_button.department_name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\\/]/gi, "").replace(/\s+/g, "-").replace(/-$/, "").toLowerCase();
	
	                // Old regex
	                // replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
	                // console.log("some data",banner_button.department_name,"sdssf",buttonSlug)
	                // .replace(/[\s_]+/g, '-')
	                // .toLowerCase();
	
	                return _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 col-sm-6 mt-4 singleCartgories " },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: _constants.SITE_URL + "/departments/" + buttonSlug,
	                      style: { textDecoration: "none" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "card cardHover ",
	                        style: {
	                          width: "100%",
	                          margin: "0 auto",
	                          height: "62px",
	                          display: "flex",
	                          justifyContent: "center",
	                          borderRadius: "31px",
	                          backgroundColor: "#F3EFE8"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "p-2 singledpt",
	                          style: { display: "flex", alignItems: "center" }
	                        },
	                        banner_button.banner_btn_icon ? _react2.default.createElement("img", {
	                          className: "ql-background",
	                          src: _constants.IMAGE_URL + "BannerButtonImg/" + banner_button.banner_btn_icon,
	                          alt: "avtars",
	                          style: {
	                            borderRadius: "50%",
	                            width: "100%",
	                            maxWidth: "27px"
	                          }
	                        }) : _react2.default.createElement("i", { className: "fa-solid fa-circle-right" }),
	                        _react2.default.createElement(
	                          "p",
	                          { className: "px-2", style: { fontSize: "14px" } },
	                          banner_button.banner_btn_text
	                        )
	                      )
	                    )
	                  )
	                );
	              }) : ""
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HomeSearch;
	}(_react.Component);
	
	exports.default = HomeSearch;

/***/ },
/* 87 */
8,
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var Parser = __webpack_require__(243);
	var DomHandler = __webpack_require__(233);
	
	function defineProp(name, value) {
	    delete module.exports[name];
	    module.exports[name] = value;
	    return value;
	}
	
	module.exports = {
	    Parser: Parser,
	    Tokenizer: __webpack_require__(244),
	    ElementType: __webpack_require__(103),
	    DomHandler: DomHandler,
	    get FeedHandler() {
	        return defineProp("FeedHandler", __webpack_require__(848));
	    },
	    get Stream() {
	        return defineProp("Stream", __webpack_require__(850));
	    },
	    get WritableStream() {
	        return defineProp("WritableStream", __webpack_require__(245));
	    },
	    get ProxyHandler() {
	        return defineProp("ProxyHandler", __webpack_require__(849));
	    },
	    get DomUtils() {
	        return defineProp("DomUtils", __webpack_require__(235));
	    },
	    get CollectingHandler() {
	        return defineProp(
	            "CollectingHandler",
	            __webpack_require__(847)
	        );
	    },
	    // For legacy support
	    DefaultHandler: DomHandler,
	    get RssHandler() {
	        return defineProp("RssHandler", this.FeedHandler);
	    },
	    //helper methods
	    parseDOM: function(data, options) {
	        var handler = new DomHandler(options);
	        new Parser(handler, options).end(data);
	        return handler.dom;
	    },
	    parseFeed: function(feed, options) {
	        var handler = new module.exports.FeedHandler(options);
	        new Parser(handler, options).end(feed);
	        return handler.dom;
	    },
	    createDomStream: function(cb, options, elementCb) {
	        var handler = new DomHandler(cb, options, elementCb);
	        return new Parser(handler, options);
	    },
	    // List of all events that the parser emits
	    EVENTS: {
	        /* Format: eventname: number of arguments */
	        attribute: 2,
	        cdatastart: 0,
	        cdataend: 0,
	        text: 1,
	        processinginstruction: 2,
	        comment: 1,
	        commentend: 0,
	        closetag: 1,
	        opentag: 2,
	        opentagname: 1,
	        error: 1,
	        end: 0
	    }
	};


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(884),
	    getValue = __webpack_require__(897);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var _exportNames = {
	  batch: true
	};
	
	var _exports = __webpack_require__(985);
	
	Object.keys(_exports).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  if (key in exports && exports[key] === _exports[key]) return;
	  exports[key] = _exports[key];
	});
	
	var _reactBatchedUpdates = __webpack_require__(990);
	
	exports.batch = _reactBatchedUpdates.unstable_batchedUpdates;
	
	var _batch = __webpack_require__(419);
	
	// Enable batched updates in our subscriptions for use
	// with standard React renderers (ReactDOM, React Native)
	(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);

/***/ },
/* 91 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isObject = isObject;
	exports.extend = extend;
	exports.needsNavigation = needsNavigation;
	exports.needsPagination = needsPagination;
	exports.needsScrollbar = needsScrollbar;
	exports.uniqueClasses = uniqueClasses;
	
	function isObject(o) {
	  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
	}
	
	function extend(target, src) {
	  var noExtend = ['__proto__', 'constructor', 'prototype'];
	  Object.keys(src).filter(function (key) {
	    return noExtend.indexOf(key) < 0;
	  }).forEach(function (key) {
	    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
	      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
	    } else {
	      target[key] = src[key];
	    }
	  });
	}
	
	function needsNavigation(params) {
	  if (params === void 0) {
	    params = {};
	  }
	
	  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
	}
	
	function needsPagination(params) {
	  if (params === void 0) {
	    params = {};
	  }
	
	  return params.pagination && typeof params.pagination.el === 'undefined';
	}
	
	function needsScrollbar(params) {
	  if (params === void 0) {
	    params = {};
	  }
	
	  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
	}
	
	function uniqueClasses(classNames) {
	  if (classNames === void 0) {
	    classNames = '';
	  }
	
	  var classes = classNames.split(' ').map(function (c) {
	    return c.trim();
	  }).filter(function (c) {
	    return !!c;
	  });
	  var unique = [];
	  classes.forEach(function (c) {
	    if (unique.indexOf(c) < 0) unique.push(c);
	  });
	  return unique.join(' ');
	}

/***/ },
/* 92 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/case-img-main.1a3fbfd9.png";

/***/ },
/* 94 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(r, e) {
	  if (null == r) return {};
	  var t = {};
	  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
	    if (e.includes(n)) continue;
	    t[n] = r[n];
	  }
	  return t;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loadCars = exports.userLogoutError = exports.userLogoutSuccess = exports.userLoginError = exports.userLoginSuccess = exports.initUser = undefined;
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _actionTypes = __webpack_require__(196);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initUser = exports.initUser = function initUser() {
	    return { type: types.USER_INIT };
	};
	var userLoginSuccess = exports.userLoginSuccess = function userLoginSuccess(user) {
	    return { type: types.USER_LOGIN_SUCCESS, user: user };
	};
	var userLoginError = exports.userLoginError = function userLoginError(error) {
	    return { type: types.USER_LOGIN_ERROR, error: error };
	};
	var userLogoutSuccess = exports.userLogoutSuccess = function userLogoutSuccess() {
	    return { type: types.USER_LOGOUT_SUCCESS };
	};
	var userLogoutError = exports.userLogoutError = function userLogoutError(error) {
	    return { type: types.USER_LOGOUT_ERROR, error: error };
	};
	
	/* helper functions */
	
	/* thunk functions */
	
	var loadCars = exports.loadCars = function loadCars() {
	    return function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function (_x) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _doctor = __webpack_require__(1166);
	
	var _doctor2 = _interopRequireDefault(_doctor);
	
	var _whiteLogo = __webpack_require__(1177);
	
	var _whiteLogo2 = _interopRequireDefault(_whiteLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { scAxios } from '../../';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	//import { Outlet,Link } from "react-router-dom";
	
	
	var LeftSidebar = function (_Component) {
	  _inherits(LeftSidebar, _Component);
	
	  function LeftSidebar() {
	    _classCallCheck(this, LeftSidebar);
	
	    return _possibleConstructorReturn(this, (LeftSidebar.__proto__ || Object.getPrototypeOf(LeftSidebar)).apply(this, arguments));
	  }
	
	  _createClass(LeftSidebar, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "dash-menu", id: "dark-version" },
	        _react2.default.createElement(
	          "div",
	          { className: "left-dash" },
	          _react2.default.createElement(
	            "div",
	            { className: "text-center mb-4" },
	            _react2.default.createElement(
	              "a",
	              { href: "/" },
	              _react2.default.createElement("img", { src: _whiteLogo2.default, alt: "white-logo" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "doctor-part-img mb-4" },
	            _react2.default.createElement("img", { src: _doctor2.default, alt: "doctor2" })
	          ),
	          _react2.default.createElement(
	            "ul",
	            { className: "left-menu" },
	            _react2.default.createElement(
	              "li",
	              {
	                className: window.location.href === _constants.SITE_URL + "/dashboard/patient-dashboard" ? "active" : ""
	              },
	              _react2.default.createElement(
	                "a",
	                { href: "/dashboard/patient-dashboard" },
	                _react2.default.createElement("i", { className: "fa-solid fa-house" }),
	                " Home"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              {
	                className: window.location.href === _constants.SITE_URL + "/dashboard/appoinments" ? "active" : ""
	              },
	              _react2.default.createElement(
	                "a",
	                { href: "/dashboard/appoinments" },
	                _react2.default.createElement("i", { className: "fa-solid fa-calendar" }),
	                " Appointments"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              {
	                className: window.location.href === _constants.SITE_URL + "/dashboard/patient-reports" ? "active" : ""
	              },
	              _react2.default.createElement(
	                "a",
	                { href: "/dashboard/patient-reports" },
	                _react2.default.createElement("i", { className: "fa-solid fa-file" }),
	                " Lab Reports"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "#" },
	                "Prescriptions"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "#" },
	                "Packages"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "#" },
	                "Care Plans"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "#" },
	                "Invoices"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "#" },
	                "Library"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LeftSidebar;
	}(_react.Component);
	
	exports.default = LeftSidebar;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _PopupIndex = __webpack_require__(65);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _PopupOTP = __webpack_require__(209);
	
	var _PopupOTP2 = _interopRequireDefault(_PopupOTP);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SendOTPMessage = function SendOTPMessage(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosSMS.request("/user/sendotp", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var checkUserName = function checkUserName(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosSMS.request("/user/checkusername/" + data, {
	      method: "get",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var SaveOTPNumber = function SaveOTPNumber(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/user/saveotpnumber", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var RegisterData = function RegisterData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/patient-register", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      resolve(res.data);
	      if (res.data.status == false) {
	        _reactToastify.toast.error(res.data.message, {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      }
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var RegisterSelf = function RegisterSelf(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/patient-register", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	var input_field_css = {
	  maxHeight: "50px",
	  fontSize: "14px",
	  borderColor: "#cccccc",
	  borderRadius: "5px"
	};
	
	var PopupRegister = function (_Component) {
	  _inherits(PopupRegister, _Component);
	
	  function PopupRegister() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopupRegister);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupRegister.__proto__ || Object.getPrototypeOf(PopupRegister)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      fullname: "",
	      username: "",
	      email: "",
	      date_of_birth: "",
	      password: "",
	      phone_number: "",
	      gender: "",
	      house_number: "",
	      thana: "",
	      district: "",
	      showLoginPopup: false,
	      showOtpPopup: false,
	      showRegisterPopup: true,
	      user_id: "",
	      userNameIsValid: ""
	    }, _this.validateUserName = function (event) {
	      // this.handleChange(event);
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var errors = {};
	      if (event.target.value.length < 5) {
	        _this.setState({
	          userNameIsValid: false
	        });
	        return;
	      }
	      checkUserName(event.target.value).then(function (res) {
	        if (res.status === false) {
	          errors["username"] = "*Please enter a unique username.";
	          _this.setState({
	            userNameIsValid: false,
	            errors: errors["username"]
	          });
	
	          (0, _jquery2.default)(".submit_btn").prop("disabled", true);
	          (0, _jquery2.default)(".submit_btn").css("background", "#41414b");
	        } else {
	          _this.setState({
	            userNameIsValid: true
	          });
	          (0, _jquery2.default)(".submit_btn").prop("disabled", false);
	          (0, _jquery2.default)(".submit_btn").css("background", "#187979");
	        }
	      });
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var fullname = (0, _jquery2.default)("#fullname").val();
	      var username = (0, _jquery2.default)("#username").val();
	      var email = (0, _jquery2.default)("#email").val();
	      var date_of_birth = (0, _jquery2.default)("#date_of_birth").val();
	      var password = (0, _jquery2.default)(".Password").val();
	      var phone_number = (0, _jquery2.default)(".PhoneNumber").val();
	      var gender = (0, _jquery2.default)("input[name='gender']:checked").val();
	      var house_number = (0, _jquery2.default)("#house_number").val();
	      var thana = (0, _jquery2.default)("#thana").val();
	      var district = (0, _jquery2.default)("#district").val();
	      if (fullname && username && email && date_of_birth && password && phone_number && gender && house_number && thana && district && _this.state.userNameIsValid) {
	        (0, _jquery2.default)(".submit_btn").prop("disabled", false);
	        (0, _jquery2.default)(".submit_btn").css("background", "#fb6201");
	      } else {
	        (0, _jquery2.default)(".submit_btn").prop("disabled", true);
	        (0, _jquery2.default)(".submit_btn").css("background", "#41414b");
	      }
	    }, _this.handleSubmit = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(event) {
	        var fields, user, six_digit_random_number, encoded_otp, otp_number, i, a, b, new_encoded_otp, messageBody, encoded, messageBodyText, _i, c, d, encoded_message_body, csms_generate_number, csmsId, data;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!_this.validateForm()) {
	                  _context.next = 33;
	                  break;
	                }
	
	                fields = {};
	
	                fields["fullname"] = "";
	                fields["username"] = "";
	                fields["email"] = "";
	                fields["date_of_birth"] = "";
	                fields["password"] = "";
	                fields["phone_number"] = "";
	                fields["gender"] = "";
	                fields["house_number"] = "";
	                fields["thana"] = "";
	                fields["district"] = "";
	                _this.setState({ fields: fields });
	                /* const user = {
	                  Name: this.state.fullname,
	                  UserName: this.state.username,
	                  Email: this.state.email,
	                  DateOfBirth: this.state.date_of_birth,
	                  Password: this.state.password,
	                  PhoneNumber: this.state.phone_number,
	                  Gender: this.state.gender,
	                  Address: "",
	                  FamilyMembers: "",
	                  HouseNo: this.state.house_number,
	                  Thana: this.state.thana,
	                  District: this.state.district,
	                }; */
	                user = {
	                  fullname: _this.state.fullname,
	                  username: _this.state.username,
	                  email: _this.state.email,
	                  date_of_birth: _this.state.date_of_birth,
	                  password: _this.state.password,
	                  phone_number: _this.state.phone_number,
	                  gender: _this.state.gender,
	                  Address: "",
	                  FamilyMembers: "",
	                  house_number: _this.state.house_number,
	                  thana: _this.state.thana,
	                  district: _this.state.district
	                };
	                _context.next = 17;
	                return RegisterData(user).then(function (res) {
	                  _this.setState({ user_id: res.data.id });
	                  var patient_user = {
	                    fullname: _this.state.fullname,
	                    username: _this.state.username,
	                    email: _this.state.email,
	                    date_of_birth: _this.state.date_of_birth,
	                    password: _this.state.password,
	                    phone_number: _this.state.phone_number,
	                    gender: _this.state.gender,
	                    address: "",
	                    family_members: "",
	                    house_number: _this.state.house_number,
	                    thana: _this.state.thana,
	                    district: _this.state.district,
	                    temporary_patient_id: res[0]["Temporary_Patient_ID"],
	                    role: "2"
	                  };
	
	                  if (res.status === true) {
	                    _this.setState({ user_id: res.data.id });
	                  } else {
	                    _reactToastify.toast.error("Registration Error. Please Try Again", {
	                      position: _reactToastify.toast.POSITION.TOP_LEFT
	                    });
	                  }
	                  // this.SubmitRegisterSelf(patient_user);
	                }).catch(function (err) {
	                  console.log(err);
	                });
	
	              case 17:
	                //let six_digit_random_number = Math.floor(100000 + Math.random() * 999999);
	                six_digit_random_number = Math.floor(Math.random() * 900000) + 100000;
	                encoded_otp = "";
	                otp_number = btoa(six_digit_random_number);
	
	                for (i = 0; i < otp_number.length; i++) {
	                  a = otp_number.charCodeAt(i);
	                  b = a ^ 10;
	
	                  encoded_otp += String.fromCharCode(b);
	                }
	                new_encoded_otp = btoa(encoded_otp);
	                messageBody = "Your OTP is " + six_digit_random_number;
	                encoded = "";
	                messageBodyText = btoa(messageBody);
	
	                for (_i = 0; _i < messageBodyText.length; _i++) {
	                  c = messageBodyText.charCodeAt(_i);
	                  d = c ^ 10;
	
	                  encoded += String.fromCharCode(d);
	                }
	                encoded_message_body = btoa(encoded);
	                csms_generate_number = Math.random().toString(36).substring(2, 11);
	                csmsId = csms_generate_number;
	                data = {
	                  phone_number: _this.state.phone_number,
	                  message_body: encoded_message_body,
	                  csms_id: csmsId
	                };
	
	
	                SendOTPMessage(data).then(function (res) {
	                  if (res.status) {
	                    _this.saveOtp(new_encoded_otp);
	                    (0, _jquery2.default)(".register_popup").css("visibility", "hidden");
	                    (0, _jquery2.default)(".register_popup").removeClass("show");
	                    (0, _jquery2.default)(".otp_popup").css("visibility", "visible");
	                    (0, _jquery2.default)(".otp_popup").addClass("show");
	                    (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	                    (0, _jquery2.default)("body").css("overflow", "");
	                    (0, _jquery2.default)("body").css("padding-right", "");
	                    _this.setState({ showOtpPopup: true });
	                    _reactToastify.toast.success("Please enter OTP to complete online sign up", {
	                      position: _reactToastify.toast.POSITION.TOP_LEFT
	                    });
	                  } else {
	                    _reactToastify.toast.error("Otp Was Not Send", {
	                      position: _reactToastify.toast.POSITION.TOP_LEFT
	                    });
	                  }
	                }).catch(function (err) {
	                  console.log(err);
	                });
	                _context.next = 33;
	                break;
	
	              case 33:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }(), _this.SubmitRegisterSelf = function (data) {
	      RegisterSelf(data).then(function (res) {
	        if (res.status === true) {
	          //this.setState({showLoginPopup: true});
	          _this.setState({ user_id: res.data.id });
	          // toast.success('User Registered SuccessFully!', {
	          //   position: toast.POSITION.TOP_LEFT
	          // });
	          //setTimeout(function() {
	          //this.setState({showLoginPopup: true})
	          //}, 3000);
	        } else {
	          _reactToastify.toast.error("Registration Error. Please Try Again", {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("Error occured", {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.saveOtp = function (otp) {
	      var data = {
	        phone_number: _this.state.phone_number,
	        otp_number: otp
	      };
	      SaveOTPNumber(data).then(function (res) {
	        if (res.data === "success") {} else {}
	      }).catch(function (err) {
	        _reactToastify.toast.error("Error occured", {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.ShowLoginPopup = function (e) {
	      (0, _jquery2.default)(".register_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".register_popup").removeClass("show");
	      (0, _jquery2.default)(".login_popup").css("visibility", "visible");
	      (0, _jquery2.default)(".login_popup").addClass("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	      _this.setState({
	        showLoginPopup: true
	      });
	    }, _this.closePopup = function (event) {
	      (0, _jquery2.default)(".register_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".register_popup").removeClass("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PopupRegister, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!fields["fullname"]) {
	        formIsValid = false;
	        errors["fullname"] = "*Please enter your fullname.";
	        this.setState({
	          errors: errors["fullname"]
	        });
	      }
	      if (!fields["username"]) {
	        formIsValid = false;
	        errors["username"] = "*Please enter your username.";
	        this.setState({
	          errors: errors["username"]
	        });
	      }
	      if (!fields["email"]) {
	        formIsValid = false;
	        errors["email"] = "*Please enter your email.";
	        this.setState({
	          errors: errors["username"]
	        });
	      }
	      if (!fields["date_of_birth"]) {
	        formIsValid = false;
	        errors["date_of_birth"] = "*Please select your date of birth.";
	        this.setState({
	          errors: errors["date_of_birth"]
	        });
	      }
	      if (!fields["password"]) {
	        formIsValid = false;
	        errors["password"] = "*Please enter your Password.";
	        this.setState({
	          errors: errors["password"]
	        });
	      }
	      if (!fields["phone_number"]) {
	        formIsValid = false;
	        errors["phone_number"] = "*Please enter your phone number.";
	        this.setState({
	          errors: errors["phone_number"]
	        });
	      }
	      if (!fields["gender"]) {
	        formIsValid = false;
	        errors["gender"] = "*Please choose your gender.";
	        this.setState({
	          errors: errors["gender"]
	        });
	      }
	      if (!fields["house_number"]) {
	        formIsValid = false;
	        errors["house_number"] = "*Please enter your house number.";
	        this.setState({
	          errors: errors["house_number"]
	        });
	      }
	      if (!fields["thana"]) {
	        formIsValid = false;
	        errors["thana"] = "*Please enter your house number.";
	        this.setState({
	          errors: errors["thana"]
	        });
	      }
	      if (!fields["district"]) {
	        formIsValid = false;
	        errors["district"] = "*Please enter your district.";
	        this.setState({
	          errors: errors["district"]
	        });
	      }
	      return formIsValid;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _jquery2.default)('input[type="date"], input[type="datetime"], input[type="datetime-local"], input[type="month"], input[type="time"], input[type="week"]').each(function () {
	        var el = this,
	            type = (0, _jquery2.default)(el).attr("type");
	        if ((0, _jquery2.default)(el).val() === "") {
	          (0, _jquery2.default)(el).attr("type", "text");
	        }
	        (0, _jquery2.default)(el).focus(function () {
	          (0, _jquery2.default)(el).attr("type", type);
	          el.click();
	        });
	        (0, _jquery2.default)(el).blur(function () {
	          if ((0, _jquery2.default)(el).val() === "") (0, _jquery2.default)(el).attr("type", "text");
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      //console.log(this.state.user_id);
	      var user_data = {
	        Name: this.state.fullname,
	        UserName: this.state.username,
	        Email: this.state.email,
	        DateOfBirth: this.state.date_of_birth,
	        Password: this.state.password,
	        PhoneNumber: this.state.phone_number,
	        Gender: this.state.gender,
	        Address: "",
	        FamilyMembers: "",
	        HouseNo: this.state.house_number,
	        Thana: this.state.thana,
	        District: this.state.district
	      };
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            className: "offcanvas offcanvas-start show register_popup",
	            tabIndex: -1,
	            id: "offcanvasRegister",
	            "aria-labelledby": "offcanvasExampleLabel",
	            style: { visibility: "visible" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-header" },
	            _react2.default.createElement(
	              "h5",
	              { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	              " "
	            ),
	            _react2.default.createElement("button", {
	              type: "button",
	              className: "btn-close text-reset",
	              "data-bs-dismiss": "offcanvas",
	              "aria-label": "Close",
	              onClick: this.closePopup
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-body" },
	            _react2.default.createElement(
	              "div",
	              { className: "left-offcanvas" },
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex justify-content-center" },
	                _react2.default.createElement("img", {
	                  className: "img-fluid",
	                  src: "/assets/images/united_logo.png",
	                  alt: "logo"
	                })
	              ),
	              _react2.default.createElement(
	                "h4",
	                { className: "text-center", style: { color: "#af9763" } },
	                "User Registration"
	              ),
	              _react2.default.createElement(
	                "form",
	                {
	                  onSubmit: this.handleSubmit,
	                  id: "registerform",
	                  className: "needs-validation",
	                  noValidate: true
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mt-2" },
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      placeholder: "Enter Your Full Name ",
	                      name: "fullname",
	                      id: "fullname",
	                      value: this.state.fields.fullname || "",
	                      onChange: this.handleChange,
	                      required: true,
	                      autoComplete: "off",
	                      style: input_field_css
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.fullname
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mt-2" },
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      minlength: "5",
	                      placeholder: "Enter Your User Name ",
	                      name: "username",
	                      id: "username",
	                      value: this.state.fields.username || "",
	                      onChange: this.validateUserName,
	                      required: true,
	                      autoComplete: "off",
	                      style: input_field_css
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.username
	                  ),
	                  !this.state.userNameIsValid && this.state.userNameIsValid !== "" && _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    "Username is either taken or too short. Please enter another one.",
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mt-2" },
	                    _react2.default.createElement("input", {
	                      type: "email",
	                      className: "form-control",
	                      placeholder: "Enter Your Email Address",
	                      name: "email",
	                      id: "email",
	                      value: this.state.fields.email || "",
	                      onChange: this.handleChange,
	                      required: true,
	                      autoComplete: "off",
	                      style: input_field_css
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.email
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group date_of_birth_sec mt-2" },
	                    _react2.default.createElement("input", {
	                      type: "date",
	                      placeholder: "Enter Date Of Birth",
	                      id: "date_of_birth",
	                      name: "date_of_birth",
	                      value: this.state.fields.date_of_birth || "",
	                      onChange: this.handleChange,
	                      autoComplete: "off",
	                      className: "form-control btnCal-click",
	                      style: input_field_css,
	                      required: true
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      { className: "btnCal", style: { display: "none" } },
	                      _react2.default.createElement("span", { className: "fa fa-calendar" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.date_of_birth
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mt-2" },
	                    _react2.default.createElement("input", {
	                      type: "password",
	                      className: "form-control Password",
	                      placeholder: "Enter Password",
	                      name: "password",
	                      id: "password",
	                      value: this.state.fields.password || "",
	                      onChange: this.handleChange,
	                      required: true,
	                      autoComplete: "off",
	                      maxLength: "11",
	                      style: input_field_css
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.password
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mt-2" },
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control PhoneNumber",
	                      placeholder: "Enter Phone Number",
	                      name: "phone_number",
	                      id: "phone_number",
	                      value: this.state.fields.phone_number || "",
	                      onChange: this.handleChange,
	                      required: true,
	                      autoComplete: "off",
	                      maxLength: "11",
	                      style: input_field_css
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.phone_number
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-6" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check mt-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "gender",
	                        id: "male",
	                        value: "male",
	                        onChange: this.handleChange,
	                        required: true
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", htmlFor: "male" },
	                        "Male"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-6" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check mt-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "gender",
	                        id: "female",
	                        value: "female",
	                        onChange: this.handleChange,
	                        required: true
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", htmlFor: "female" },
	                        "Female"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.gender
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mt-2" },
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      placeholder: "Enter House Number",
	                      name: "house_number",
	                      id: "house_number",
	                      value: this.state.fields.house_number || "",
	                      onChange: this.handleChange,
	                      required: true,
	                      autoComplete: "off",
	                      style: input_field_css
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.house_number
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mt-2" },
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      placeholder: "Enter Thana",
	                      name: "thana",
	                      id: "thana",
	                      value: this.state.fields.thana || "",
	                      onChange: this.handleChange,
	                      required: true,
	                      autoComplete: "off",
	                      style: input_field_css
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.thana
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mt-2" },
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      placeholder: "Enter District",
	                      name: "district",
	                      id: "district",
	                      value: this.state.fields.district || "",
	                      onChange: this.handleChange,
	                      required: true,
	                      autoComplete: "off",
	                      style: input_field_css
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.district
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        variant: "primary",
	                        type: "submit",
	                        className: "btn-links appointment-new submit_btn",
	                        id: "black-btn",
	                        disabled: true
	                      },
	                      " ",
	                      "Register",
	                      " "
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "label",
	                  { className: "dont" },
	                  "Already registered? ",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: "nav-link active",
	                      onClick: this.ShowLoginPopup,
	                      style: {
	                        background: "none",
	                        border: "none",
	                        padding: "0px",
	                        color: "#187979",
	                        fontWeight: "500"
	                      }
	                    },
	                    "Login here."
	                  )
	                )
	              )
	            )
	          )
	        ),
	        this.state.showOtpPopup ? _react2.default.createElement(_PopupOTP2.default, {
	          showPopup: this.state.showOtpPopup,
	          userData: user_data,
	          userId: this.state.user_id,
	          from: "from_register"
	        }) : null,
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return PopupRegister;
	}(_react.Component);
	
	exports.default = PopupRegister;

/***/ },
/* 98 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDate = formatDate;
	exports.capitalizeFirstLetter = capitalizeFirstLetter;
	function formatDate(date) {
	  date = new Date(date);
	  var hours = date.getHours();
	  var minutes = date.getMinutes();
	  var ampm = hours >= 12 ? "pm" : "am";
	  hours = hours % 12;
	  hours = hours ? hours : 12; // the hour '0' should be '12'
	  minutes = minutes < 10 ? "0" + minutes : minutes;
	  var strTime = hours + ":" + minutes + " " + ampm;
	  return date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear() + "  " + strTime;
	}
	
	function capitalizeFirstLetter(string) {
	  return string !== null ? string.charAt(0).toUpperCase() + string.slice(1) : "";
	}

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(711)
	var ieee754 = __webpack_require__(851)
	var isArray = __webpack_require__(712)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Chart.js v2.8.0
	 * https://www.chartjs.org
	 * (c) 2019 Chart.js Contributors
	 * Released under the MIT License
	 */
	(function (global, factory) {
	 true ? module.exports = factory(function() { try { return __webpack_require__(4); } catch(e) { } }()) :
	typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
	(global.Chart = factory(global.moment));
	}(this, (function (moment) { 'use strict';
	
	moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
	
	/* MIT license */
	
	var conversions = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	};
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}
	
	var convert = function() {
	   return new Converter();
	};
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   };
	});
	
	var colorConvert = convert;
	
	var colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	/* MIT license */
	
	
	var colorString = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	};
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorName[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorName) {
	   reverseNames[colorName[name]] = name;
	}
	
	/* MIT license */
	
	
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = colorString.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = colorString.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = colorString.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return colorString.hexString(this.values.rgb);
		},
		rgbString: function () {
			return colorString.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return colorString.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return colorString.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return colorString.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return colorString.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return colorString.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return colorString.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = colorConvert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	var chartjsColor = Color;
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array (including typed arrays), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @function
		 */
		isArray: function(value) {
			if (Array.isArray && Array.isArray(value)) {
				return true;
			}
			var type = Object.prototype.toString.call(value);
			if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
				return true;
			}
			return false;
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns true if `value` is a finite number, else returns false
		 * @param {*} value  - The value to test.
		 * @returns {boolean}
		 */
		isFinite: function(value) {
			return (typeof value === 'number' || value instanceof Number) && isFinite(value);
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {object|Array} loopable - The object or array to be iterated.
		 * @param {function} fn - The function to call for each item.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see https://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = {};
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @param {object} [options] - Merging options:
		 * @param {function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @returns {object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {object} target - The target object in which all objects are merged into.
		 * @param {object} arg1 - Object containing additional properties to merge in target.
		 * @param {object} argN - Additional objects containing properties to merge in target.
		 * @returns {object} The `target` object.
		 */
		extend: function(target) {
			var setFn = function(value, key) {
				target[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
				helpers.each(arguments[i], setFn);
			}
			return target;
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		}
	};
	
	var helpers_core = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	var helpers_easing = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.easingEffects = effects;
	
	var PI = Math.PI;
	var RAD_PER_DEG = PI / 180;
	var DOUBLE_PI = PI * 2;
	var HALF_PI = PI / 2;
	var QUARTER_PI = PI / 4;
	var TWO_THIRDS_PI = PI * 2 / 3;
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports$1 = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {number} width - The rectangle's width.
		 * @param {number} height - The rectangle's height.
		 * @param {number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var r = Math.min(radius, height / 2, width / 2);
				var left = x + r;
				var top = y + r;
				var right = x + width - r;
				var bottom = y + height - r;
	
				ctx.moveTo(x, top);
				if (left < right && top < bottom) {
					ctx.arc(left, top, r, -PI, -HALF_PI);
					ctx.arc(right, top, r, -HALF_PI, 0);
					ctx.arc(right, bottom, r, 0, HALF_PI);
					ctx.arc(left, bottom, r, HALF_PI, PI);
				} else if (left < right) {
					ctx.moveTo(left, y);
					ctx.arc(right, top, r, -HALF_PI, HALF_PI);
					ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
				} else if (top < bottom) {
					ctx.arc(left, top, r, -PI, 0);
					ctx.arc(left, bottom, r, 0, PI);
				} else {
					ctx.arc(left, top, r, -PI, PI);
				}
				ctx.closePath();
				ctx.moveTo(x, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y, rotation) {
			var type, xOffset, yOffset, size, cornerRadius;
			var rad = (rotation || 0) * RAD_PER_DEG;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			ctx.beginPath();
	
			switch (style) {
			// Default includes circle
			default:
				ctx.arc(x, y, radius, 0, DOUBLE_PI);
				ctx.closePath();
				break;
			case 'triangle':
				ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				ctx.closePath();
				break;
			case 'rectRounded':
				// NOTE: the rounded rect implementation changed to use `arc` instead of
				// `quadraticCurveTo` since it generates better results when rect is
				// almost a circle. 0.516 (instead of 0.5) produces results with visually
				// closer proportion to the previous impl and it is inscribed in the
				// circle with `radius`. For more details, see the following PRs:
				// https://github.com/chartjs/Chart.js/issues/5597
				// https://github.com/chartjs/Chart.js/issues/5858
				cornerRadius = radius * 0.516;
				size = radius - cornerRadius;
				xOffset = Math.cos(rad + QUARTER_PI) * size;
				yOffset = Math.sin(rad + QUARTER_PI) * size;
				ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
				ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
				ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
				ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
				ctx.closePath();
				break;
			case 'rect':
				if (!rotation) {
					size = Math.SQRT1_2 * radius;
					ctx.rect(x - size, y - size, 2 * size, 2 * size);
					break;
				}
				rad += QUARTER_PI;
				/* falls through */
			case 'rectRot':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + yOffset, y - xOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				ctx.closePath();
				break;
			case 'crossRot':
				rad += QUARTER_PI;
				/* falls through */
			case 'cross':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'star':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				rad += QUARTER_PI;
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'line':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				break;
			case 'dash':
				ctx.moveTo(x, y);
				ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
				break;
			}
	
			ctx.fill();
			ctx.stroke();
		},
	
		/**
		 * Returns true if the point is inside the rectangle
		 * @param {object} point - The point to test
		 * @param {object} area - The rectangle
		 * @returns {boolean}
		 * @private
		 */
		_isPointInArea: function(point, area) {
			var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	
			return point.x > area.left - epsilon && point.x < area.right + epsilon &&
				point.y > area.top - epsilon && point.y < area.bottom + epsilon;
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			var stepped = target.steppedLine;
			if (stepped) {
				if (stepped === 'middle') {
					var midpoint = (previous.x + target.x) / 2.0;
					ctx.lineTo(midpoint, flip ? target.y : previous.y);
					ctx.lineTo(midpoint, flip ? previous.y : target.y);
				} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	var helpers_canvas = exports$1;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.clear = exports$1.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports$1.roundedRect.apply(exports$1, arguments);
	};
	
	var defaults = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers_core.merge(this[scope] || (this[scope] = {}), values);
		}
	};
	
	defaults._set('global', {
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		defaultLineHeight: 1.2,
		showLines: true
	});
	
	var core_defaults = defaults;
	
	var valueOrDefault = helpers_core.valueOrDefault;
	
	/**
	 * Converts the given font object into a CSS font string.
	 * @param {object} font - A font object.
	 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
	 * @private
	 */
	function toFontString(font) {
		if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
			return null;
		}
	
		return (font.style ? font.style + ' ' : '')
			+ (font.weight ? font.weight + ' ' : '')
			+ font.size + 'px '
			+ font.family;
	}
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	var helpers_options = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			default:
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {number|object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers_core.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Parses font options and returns the font object.
		 * @param {object} options - A object that contains font options to be parsed.
		 * @return {object} The font object.
		 * @todo Support font.* options and renamed to toFont().
		 * @private
		 */
		_parseFont: function(options) {
			var globalDefaults = core_defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var font = {
				family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
				lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
				size: size,
				style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
				weight: null,
				string: ''
			};
	
			font.string = toFontString(font);
			return font;
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array} inputs - An array of values, falling back to the last value.
		 * @param {object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index) {
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
				}
				if (index !== undefined && helpers_core.isArray(value)) {
					value = value[index];
				}
				if (value !== undefined) {
					return value;
				}
			}
		}
	};
	
	var helpers$1 = helpers_core;
	var easing = helpers_easing;
	var canvas = helpers_canvas;
	var options = helpers_options;
	helpers$1.easing = easing;
	helpers$1.canvas = canvas;
	helpers$1.options = options;
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = chartjsColor(origin);
					if (c0.valid) {
						c1 = chartjsColor(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers$1.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers$1.extend(Element.prototype, {
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers$1.clone(me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = model;
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers$1.inherits;
	
	var core_element = Element;
	
	var exports$2 = core_element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service
	
		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});
	
	var core_animation = exports$2;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$2.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});
	
	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$2.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});
	
	core_defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers$1.noop,
			onComplete: helpers$1.noop
		}
	});
	
	var core_animations = {
		animations: [],
		request: null,
	
		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {number} duration - The animation duration in ms.
		 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;
	
			animation.chart = chart;
			animation.startTime = Date.now();
			animation.duration = duration;
	
			if (!lazy) {
				chart.animating = true;
			}
	
			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}
	
			animations.push(animation);
	
			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},
	
		cancelAnimation: function(chart) {
			var index = helpers$1.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});
	
			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},
	
		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers$1.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},
	
		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
	
			me.advance();
	
			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},
	
		/**
		 * @private
		 */
		advance: function() {
			var animations = this.animations;
			var animation, chart, numSteps, nextStep;
			var i = 0;
	
			// 1 animation per chart, so we are looping charts here
			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;
				numSteps = animation.numSteps;
	
				// Make sure that currentStep starts at 1
				// https://github.com/chartjs/Chart.js/issues/6104
				nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
				animation.currentStep = Math.min(nextStep, numSteps);
	
				helpers$1.callback(animation.render, [chart, animation], chart);
				helpers$1.callback(animation.onAnimationProgress, [animation], chart);
	
				if (animation.currentStep >= numSteps) {
					helpers$1.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};
	
	var resolve = helpers$1.options.resolve;
	
	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}
	
		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});
	
		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];
	
			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);
	
					helpers$1.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});
	
					return res;
				}
			});
		});
	}
	
	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}
	
		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}
	
		if (listeners.length > 0) {
			return;
		}
	
		arrayEvents.forEach(function(key) {
			delete array[key];
		});
	
		delete array._chartjs;
	}
	
	// Base class for all dataset controllers (line, bar, etc)
	var DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};
	
	helpers$1.extend(DatasetController.prototype, {
	
		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,
	
		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,
	
		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
		},
	
		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},
	
		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();
	
			if (meta.xAxisID === null || !(meta.xAxisID in me.chart.scales)) {
				meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in me.chart.scales)) {
				meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
			}
		},
	
		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},
	
		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},
	
		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getValueScale: function() {
			return this.getScaleForId(this._getValueScaleId());
		},
	
		/**
		 * @private
		 */
		_getIndexScale: function() {
			return this.getScaleForId(this._getIndexScaleId());
		},
	
		reset: function() {
			this.update(true);
		},
	
		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},
	
		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},
	
		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},
	
		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;
	
			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}
	
			meta.dataset = meta.dataset || me.createMetaDataset();
		},
	
		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},
	
		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);
	
			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}
	
				if (data && Object.isExtensible(data)) {
					listenArrayEvents(data, me);
				}
				me._data = data;
			}
	
			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},
	
		update: helpers$1.noop,
	
		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}
	
			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},
	
		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			if (meta.dataset) {
				meta.dataset.draw();
			}
	
			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},
	
		removeHoverStyle: function(element) {
			helpers$1.merge(element._model, element.$previousStyle || {});
			delete element.$previousStyle;
		},
	
		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var model = element._model;
			var getHoverColor = helpers$1.getHoverColor;
	
			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};
	
			model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
			model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
			model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
		},
	
		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;
	
			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},
	
		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},
	
		/**
		 * @private
		 */
		onDataPush: function() {
			var count = arguments.length;
			this.insertElements(this.getDataset().data.length - count, count);
		},
	
		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},
	
		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},
	
		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},
	
		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});
	
	DatasetController.extend = helpers$1.inherits;
	
	var core_datasetController = DatasetController;
	
	core_defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: core_defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2,
				borderAlign: 'center'
			}
		}
	});
	
	var element_arc = core_element.extend({
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var	angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += 2.0 * Math.PI;
				}
				while (angle > endAngle) {
					angle -= 2.0 * Math.PI;
				}
				while (angle < startAngle) {
					angle += 2.0 * Math.PI;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var sA = vm.startAngle;
			var eA = vm.endAngle;
			var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
			var angleMargin;
	
			ctx.save();
	
			ctx.beginPath();
			ctx.arc(vm.x, vm.y, Math.max(vm.outerRadius - pixelMargin, 0), sA, eA);
			ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
			ctx.closePath();
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.fill();
	
			if (vm.borderWidth) {
				if (vm.borderAlign === 'inner') {
					// Draw an inner border by cliping the arc and drawing a double-width border
					// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
					ctx.beginPath();
					angleMargin = pixelMargin / vm.outerRadius;
					ctx.arc(vm.x, vm.y, vm.outerRadius, sA - angleMargin, eA + angleMargin);
					if (vm.innerRadius > pixelMargin) {
						angleMargin = pixelMargin / vm.innerRadius;
						ctx.arc(vm.x, vm.y, vm.innerRadius - pixelMargin, eA + angleMargin, sA - angleMargin, true);
					} else {
						ctx.arc(vm.x, vm.y, pixelMargin, eA + Math.PI / 2, sA - Math.PI / 2);
					}
					ctx.closePath();
					ctx.clip();
	
					ctx.beginPath();
					ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
					ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
					ctx.closePath();
	
					ctx.lineWidth = vm.borderWidth * 2;
					ctx.lineJoin = 'round';
				} else {
					ctx.lineWidth = vm.borderWidth;
					ctx.lineJoin = 'bevel';
				}
	
				ctx.strokeStyle = vm.borderColor;
				ctx.stroke();
			}
	
			ctx.restore();
		}
	});
	
	var valueOrDefault$1 = helpers$1.valueOrDefault;
	
	var defaultColor = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: defaultColor,
				borderWidth: 3,
				borderColor: defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	var element_line = core_element.extend({
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalDefaults = core_defaults.global;
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var index, current, previous, currentVM;
	
			// If we are looping, adding the first point again
			if (me._loop && points.length) {
				points.push(points[0]);
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
			lastDrawnIndex = -1;
	
			for (index = 0; index < points.length; ++index) {
				current = points[index];
				previous = helpers$1.previousItem(points, index);
				currentVM = current._view;
	
				// First point moves to it's starting position no matter what
				if (index === 0) {
					if (!currentVM.skip) {
						ctx.moveTo(currentVM.x, currentVM.y);
						lastDrawnIndex = index;
					}
				} else {
					previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
					if (!currentVM.skip) {
						if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
							// There was a gap and this is the first point after the gap
							ctx.moveTo(currentVM.x, currentVM.y);
						} else {
							// Line to next point
							helpers$1.canvas.lineTo(ctx, previous._view, current._view);
						}
						lastDrawnIndex = index;
					}
				}
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});
	
	var valueOrDefault$2 = helpers$1.valueOrDefault;
	
	var defaultColor$1 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor$1,
				borderColor: defaultColor$1,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
	}
	
	var element_point = core_element.extend({
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var rotation = vm.rotation;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
	
			if (vm.skip) {
				return;
			}
	
			// Clipping for Points.
			if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
				helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
			}
		}
	});
	
	var defaultColor$2 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaultColor$2,
				borderColor: defaultColor$2,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(vm) {
		return vm && vm.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(vm) {
		var x1, x2, y1, y2, half;
	
		if (isVertical(vm)) {
			half = vm.width / 2;
			x1 = vm.x - half;
			x2 = vm.x + half;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			half = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - half;
			y2 = vm.y + half;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	function swap(orig, v1, v2) {
		return orig === v1 ? v2 : orig === v2 ? v1 : orig;
	}
	
	function parseBorderSkipped(vm) {
		var edge = vm.borderSkipped;
		var res = {};
	
		if (!edge) {
			return res;
		}
	
		if (vm.horizontal) {
			if (vm.base > vm.x) {
				edge = swap(edge, 'left', 'right');
			}
		} else if (vm.base < vm.y) {
			edge = swap(edge, 'bottom', 'top');
		}
	
		res[edge] = true;
		return res;
	}
	
	function parseBorderWidth(vm, maxW, maxH) {
		var value = vm.borderWidth;
		var skip = parseBorderSkipped(vm);
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}
	
		return {
			t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
			r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
			b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
			l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
		};
	}
	
	function boundingRects(vm) {
		var bounds = getBarBounds(vm);
		var width = bounds.right - bounds.left;
		var height = bounds.bottom - bounds.top;
		var border = parseBorderWidth(vm, width / 2, height / 2);
	
		return {
			outer: {
				x: bounds.left,
				y: bounds.top,
				w: width,
				h: height
			},
			inner: {
				x: bounds.left + border.l,
				y: bounds.top + border.t,
				w: width - border.l - border.r,
				h: height - border.t - border.b
			}
		};
	}
	
	function inRange(vm, x, y) {
		var skipX = x === null;
		var skipY = y === null;
		var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);
	
		return bounds
			&& (skipX || x >= bounds.left && x <= bounds.right)
			&& (skipY || y >= bounds.top && y <= bounds.bottom);
	}
	
	var element_rectangle = core_element.extend({
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var rects = boundingRects(vm);
			var outer = rects.outer;
			var inner = rects.inner;
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
	
			if (outer.w === inner.w && outer.h === inner.h) {
				return;
			}
	
			ctx.save();
			ctx.beginPath();
			ctx.rect(outer.x, outer.y, outer.w, outer.h);
			ctx.clip();
			ctx.fillStyle = vm.borderColor;
			ctx.rect(inner.x, inner.y, inner.w, inner.h);
			ctx.fill('evenodd');
			ctx.restore();
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			return inRange(this._view, mouseX, mouseY);
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var vm = this._view;
			return isVertical(vm)
				? inRange(vm, mouseX, null)
				: inRange(vm, null, mouseY);
		},
	
		inXRange: function(mouseX) {
			return inRange(this._view, mouseX, null);
		},
	
		inYRange: function(mouseY) {
			return inRange(this._view, null, mouseY);
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(vm)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
	
			return isVertical(vm)
				? vm.width * Math.abs(vm.y - vm.base)
				: vm.height * Math.abs(vm.x - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});
	
	var elements = {};
	var Arc = element_arc;
	var Line = element_line;
	var Point = element_point;
	var Rectangle = element_rectangle;
	elements.Arc = Arc;
	elements.Line = Line;
	elements.Point = Point;
	elements.Rectangle = Rectangle;
	
	var resolve$1 = helpers$1.options.resolve;
	
	core_defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				categoryPercentage: 0.8,
				barPercentage: 0.9,
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	/**
	 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
	 * @private
	 */
	function computeMinSampleSize(scale, pixels) {
		var min = scale.isHorizontal() ? scale.width : scale.height;
		var ticks = scale.getTicks();
		var prev, curr, i, ilen;
	
		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
		}
	
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, curr - prev) : min;
			prev = curr;
		}
	
		return min;
	}
	
	/**
	 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
	 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
	 * mode currently always generates bars equally sized (until we introduce scriptable options?).
	 * @private
	 */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var size, ratio;
	
		if (helpers$1.isNullOrUndef(thickness)) {
			size = ruler.min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}
	
		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - (size / 2)
		};
	}
	
	/**
	 * Computes an "optimal" category that globally arranges bars side by side (no gap when
	 * percentage options are 1), based on the previous and following categories. This mode
	 * generates bars with different widths when data are not evenly spaced.
	 * @private
	 */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;
	
		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale size.
			prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
		}
	
		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}
	
		start = curr - (curr - Math.min(prev, next)) / 2 * percent;
		size = Math.abs(next - prev) / 2 * percent;
	
		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}
	
	var controller_bar = core_datasetController.extend({
	
		dataElementType: elements.Rectangle,
	
		initialize: function() {
			var me = this;
			var meta;
	
			core_datasetController.prototype.initialize.apply(me, arguments);
	
			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
		},
	
		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;
	
			me._ruler = me.getRuler();
	
			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},
	
		updateElement: function(rectangle, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var options = me._resolveElementOptions(rectangle, index);
	
			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;
			rectangle._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderSkipped: options.borderSkipped,
				borderWidth: options.borderWidth,
				datasetLabel: dataset.label,
				label: me.chart.data.labels[index]
			};
	
			me._updateElementGeometry(rectangle, index, reset);
	
			rectangle.pivot();
		},
	
		/**
		 * @private
		 */
		_updateElementGeometry: function(rectangle, index, reset) {
			var me = this;
			var model = rectangle._model;
			var vscale = me._getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);
	
			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},
	
		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {number} [last] - The dataset index
		 * @returns {string[]} The list of stack IDs
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var chart = me.chart;
			var scale = me._getIndexScale();
			var stacked = scale.options.stacked;
			var ilen = last === undefined ? chart.data.datasets.length : last + 1;
			var stacks = [];
			var i, meta;
	
			for (i = 0; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				if (meta.bar && chart.isDatasetVisible(i) &&
					(stacked === false ||
					(stacked === true && stacks.indexOf(meta.stack) === -1) ||
					(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
					stacks.push(meta.stack);
				}
			}
	
			return stacks;
		},
	
		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},
	
		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {number} [datasetIndex] - The dataset index
		 * @param {string} [name] - The stack name to find
		 * @returns {number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present
	
			return (index === -1)
				? stacks.length - 1
				: index;
		},
	
		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me._getIndexScale();
			var stackCount = me.getStackCount();
			var datasetIndex = me.index;
			var isHorizontal = scale.isHorizontal();
			var start = isHorizontal ? scale.left : scale.top;
			var end = start + (isHorizontal ? scale.width : scale.height);
			var pixels = [];
			var i, ilen, min;
	
			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, datasetIndex));
			}
	
			min = helpers$1.isNullOrUndef(scale.options.barThickness)
				? computeMinSampleSize(scale, pixels)
				: -1;
	
			return {
				min: min,
				pixels: pixels,
				start: start,
				end: end,
				stackCount: stackCount,
				scale: scale
			};
		},
	
		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var scale = me._getValueScale();
			var isHorizontal = scale.isHorizontal();
			var datasets = chart.data.datasets;
			var value = +scale.getRightValue(datasets[datasetIndex].data[index]);
			var minBarLength = scale.options.minBarLength;
			var stacked = scale.options.stacked;
			var stack = meta.stack;
			var start = 0;
			var i, imeta, ivalue, base, head, size;
	
			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < datasetIndex; ++i) {
					imeta = chart.getDatasetMeta(i);
	
					if (imeta.bar &&
						imeta.stack === stack &&
						imeta.controller._getValueScaleId() === scale.id &&
						chart.isDatasetVisible(i)) {
	
						ivalue = +scale.getRightValue(datasets[i].data[index]);
						if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}
	
			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + value);
			size = head - base;
	
			if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
				size = minBarLength;
				if (value >= 0 && !isHorizontal || value < 0 && isHorizontal) {
					head = base - minBarLength;
				} else {
					head = base + minBarLength;
				}
			}
	
			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},
	
		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler) {
			var me = this;
			var options = ruler.scale.options;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);
	
			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				helpers$1.valueOrDefault(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);
	
			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;
	
			helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
	
			for (; i < ilen; ++i) {
				if (!isNaN(scale.getRightValue(dataset.data[i]))) {
					rects[i].draw();
				}
			}
	
			helpers$1.canvas.unclipArea(chart.ctx);
		},
	
		/**
		 * @private
		 */
		_resolveElementOptions: function(rectangle, index) {
			var me = this;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var dataset = datasets[me.index];
			var custom = rectangle.custom || {};
			var options = chart.options.elements.rectangle;
			var values = {};
			var i, ilen, key;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			var keys = [
				'backgroundColor',
				'borderColor',
				'borderSkipped',
				'borderWidth'
			];
	
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$1([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}
	
			return values;
		}
	});
	
	var valueOrDefault$3 = helpers$1.valueOrDefault;
	var resolve$2 = helpers$1.options.resolve;
	
	core_defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	var controller_bubble = core_datasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,
	
		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;
	
			// Update Points
			helpers$1.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},
	
		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;
	
			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};
	
			point.pivot();
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$3(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$3(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$3(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},
	
		/**
		 * @private
		 */
		_resolveElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var dataset = datasets[me.index];
			var custom = point.custom || {};
			var options = chart.options.elements.point;
			var data = dataset.data[index];
			var values = {};
			var i, ilen, key;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
				'hoverRadius',
				'hitRadius',
				'pointStyle',
				'rotation'
			];
	
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$2([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}
	
			// Custom radius resolution
			values.radius = resolve$2([
				custom.radius,
				data ? data.r : undefined,
				dataset.radius,
				options.radius
			], context, index);
	
			return values;
		}
	});
	
	var resolve$3 = helpers$1.options.resolve;
	var valueOrDefault$4 = helpers$1.valueOrDefault;
	
	core_defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
	
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
	
			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}
	
			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc && arc.custom || {};
							var arcOpts = chart.options.elements.arc;
							var fill = resolve$3([custom.backgroundColor, ds.backgroundColor, arcOpts.backgroundColor], undefined, i);
							var stroke = resolve$3([custom.borderColor, ds.borderColor, arcOpts.borderColor], undefined, i);
							var bw = resolve$3([custom.borderWidth, ds.borderWidth, arcOpts.borderWidth], undefined, i);
	
							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: Math.PI * -0.5,
	
		// The total circumference of the chart.
		circumference: Math.PI * 2.0,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers$1.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	var controller_doughnut = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;
	
			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}
	
			return ringIndex;
		},
	
		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var availableWidth = chartArea.right - chartArea.left;
			var availableHeight = chartArea.bottom - chartArea.top;
			var minSize = Math.min(availableWidth, availableHeight);
			var offset = {x: 0, y: 0};
			var meta = me.getMeta();
			var arcs = meta.data;
			var cutoutPercentage = opts.cutoutPercentage;
			var circumference = opts.circumference;
			var chartWeight = me._getRingWeight(me.index);
			var i, ilen;
	
			// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
			if (circumference < Math.PI * 2.0) {
				var startAngle = opts.rotation % (Math.PI * 2.0);
				startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
				var endAngle = startAngle + circumference;
				var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
				var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
				var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
				var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
				var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
				var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
				var cutout = cutoutPercentage / 100.0;
				var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
				var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
				var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
				minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
				offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveElementOptions(arcs[i], i);
			}
	
			chart.borderWidth = me.getMaxBorderWidth();
			chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
			chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
			chart.offsetX = offset.x * chart.outerRadius;
			chart.offsetY = offset.y * chart.outerRadius;
	
			meta.total = me.calculateTotal();
	
			me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});
	
			var model = arc._model;
	
			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}
	
				model.endAngle = model.startAngle + model.circumference;
			}
	
			arc.pivot();
		},
	
		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;
	
			helpers$1.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});
	
			/* if (total === 0) {
				total = NaN;
			}*/
	
			return total;
		},
	
		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return (Math.PI * 2.0) * (Math.abs(value) / total);
			}
			return 0;
		},
	
		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var me = this;
			var max = 0;
			var chart = me.chart;
			var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
	
			if (!arcs) {
				// Find the outmost visible dataset
				for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						meta = chart.getDatasetMeta(i);
						arcs = meta.data;
						if (i !== me.index) {
							controller = meta.controller;
						}
						break;
					}
				}
			}
	
			if (!arcs) {
				return 0;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arc = arcs[i];
				options = controller ? controller._resolveElementOptions(arc, i) : arc._options;
				if (options.borderAlign !== 'inner') {
					borderWidth = options.borderWidth;
					hoverWidth = options.hoverBorderWidth;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
			}
			return max;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * @private
		 */
		_resolveElementOptions: function(arc, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = arc.custom || {};
			var options = chart.options.elements.arc;
			var values = {};
			var i, ilen, key;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'borderAlign',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
			];
	
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$3([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}
	
			return values;
		},
	
		/**
		 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
		 * @private
		 */
		_getRingWeightOffset: function(datasetIndex) {
			var ringWeightOffset = 0;
	
			for (var i = 0; i < datasetIndex; ++i) {
				if (this.chart.isDatasetVisible(i)) {
					ringWeightOffset += this._getRingWeight(i);
				}
			}
	
			return ringWeightOffset;
		},
	
		/**
		 * @private
		 */
		_getRingWeight: function(dataSetIndex) {
			return Math.max(valueOrDefault$4(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
		},
	
		/**
		 * Returns the sum of all visibile data set weights.  This value can be 0.
		 * @private
		 */
		_getVisibleDatasetWeightTotal: function() {
			return this._getRingWeightOffset(this.chart.data.datasets.length);
		}
	});
	
	core_defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				type: 'category',
				position: 'left',
				categoryPercentage: 0.8,
				barPercentage: 0.9,
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			mode: 'index',
			axis: 'y'
		}
	});
	
	var controller_horizontalBar = controller_bar.extend({
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
	
	var valueOrDefault$5 = helpers$1.valueOrDefault;
	var resolve$4 = helpers$1.options.resolve;
	var isPointInArea = helpers$1.canvas._isPointInArea;
	
	core_defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	function lineEnabled(dataset, options) {
		return valueOrDefault$5(dataset.showLine, options.showLines);
	}
	
	var controller_line = core_datasetController.extend({
	
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.getScaleForId(meta.yAxisID);
			var dataset = me.getDataset();
			var showLine = lineEnabled(dataset, me.chart.options);
			var i, ilen;
	
			// Update Line
			if (showLine) {
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				// Utility
				line._scale = scale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = me._resolveLineOptions(line);
	
				line.pivot();
			}
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var yScale = me.getScaleForId(meta.yAxisID);
			var xScale = me.getScaleForId(meta.xAxisID);
			var lineModel = meta.dataset._model;
			var x, y;
	
			var options = me._resolvePointOptions(point, index);
	
			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = datasetIndex;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$5(custom.tension, lineModel ? lineModel.tension : 0),
				steppedLine: lineModel ? lineModel.steppedLine : false,
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolvePointOptions: function(element, index) {
			var me = this;
			var chart = me.chart;
			var dataset = chart.data.datasets[me.index];
			var custom = element.custom || {};
			var options = chart.options.elements.point;
			var values = {};
			var i, ilen, key;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			var ELEMENT_OPTIONS = {
				backgroundColor: 'pointBackgroundColor',
				borderColor: 'pointBorderColor',
				borderWidth: 'pointBorderWidth',
				hitRadius: 'pointHitRadius',
				hoverBackgroundColor: 'pointHoverBackgroundColor',
				hoverBorderColor: 'pointHoverBorderColor',
				hoverBorderWidth: 'pointHoverBorderWidth',
				hoverRadius: 'pointHoverRadius',
				pointStyle: 'pointStyle',
				radius: 'pointRadius',
				rotation: 'pointRotation'
			};
			var keys = Object.keys(ELEMENT_OPTIONS);
	
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$4([
					custom[key],
					dataset[ELEMENT_OPTIONS[key]],
					dataset[key],
					options[key]
				], context, index);
			}
	
			return values;
		},
	
		/**
		 * @private
		 */
		_resolveLineOptions: function(element) {
			var me = this;
			var chart = me.chart;
			var dataset = chart.data.datasets[me.index];
			var custom = element.custom || {};
			var options = chart.options;
			var elementOptions = options.elements.line;
			var values = {};
			var i, ilen, key;
	
			var keys = [
				'backgroundColor',
				'borderWidth',
				'borderColor',
				'borderCapStyle',
				'borderDash',
				'borderDashOffset',
				'borderJoinStyle',
				'fill',
				'cubicInterpolationMode'
			];
	
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$4([
					custom[key],
					dataset[key],
					elementOptions[key]
				]);
			}
	
			// The default behavior of lines is to break at null values, according
			// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
			// This option gives lines the ability to span gaps
			values.spanGaps = valueOrDefault$5(dataset.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$5(dataset.lineTension, elementOptions.tension);
			values.steppedLine = resolve$4([custom.steppedLine, dataset.steppedLine, elementOptions.stepped]);
	
			return values;
		},
	
		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var yScale = me.getScaleForId(meta.yAxisID);
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta;
	
			if (yScale.options.stacked) {
				for (i = 0; i < datasetIndex; i++) {
					ds = chart.data.datasets[i];
					dsMeta = chart.getDatasetMeta(i);
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
						var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}
	
				var rightValue = Number(yScale.getRightValue(value));
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}
	
			return yScale.getPixelForValue(value);
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var lineModel = meta.dataset._model;
			var area = chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (lineModel.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			if (lineModel.cubicInterpolationMode === 'monotone') {
				helpers$1.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					controlPoints = helpers$1.splineCurve(
						helpers$1.previousItem(points, i)._model,
						model,
						helpers$1.nextItem(points, i)._model,
						lineModel.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}
	
			if (chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					if (isPointInArea(model, area)) {
						if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
							model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
							model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						}
						if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
							model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
							model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
						}
					}
				}
			}
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var ilen = points.length;
			var halfBorderWidth;
			var i = 0;
	
			if (lineEnabled(me.getDataset(), chart.options)) {
				halfBorderWidth = (meta.dataset._model.borderWidth || 0) / 2;
	
				helpers$1.canvas.clipArea(chart.ctx, {
					left: area.left,
					right: area.right,
					top: area.top - halfBorderWidth,
					bottom: area.bottom + halfBorderWidth
				});
	
				meta.dataset.draw();
	
				helpers$1.canvas.unclipArea(chart.ctx);
			}
	
			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$5(options.hoverRadius, options.radius);
		},
	});
	
	var resolve$5 = helpers$1.options.resolve;
	
	core_defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
	
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
	
			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}
	
			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc.custom || {};
							var arcOpts = chart.options.elements.arc;
							var fill = resolve$5([custom.backgroundColor, ds.backgroundColor, arcOpts.backgroundColor], undefined, i);
							var stroke = resolve$5([custom.borderColor, ds.borderColor, arcOpts.borderColor], undefined, i);
							var bw = resolve$5([custom.borderWidth, ds.borderWidth, arcOpts.borderWidth], undefined, i);
	
							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	var controller_polarArea = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		update: function(reset) {
			var me = this;
			var dataset = me.getDataset();
			var meta = me.getMeta();
			var start = me.chart.options.startAngle || 0;
			var starts = me._starts = [];
			var angles = me._angles = [];
			var arcs = meta.data;
			var i, ilen, angle;
	
			me._updateRadius();
	
			meta.count = me.countVisibleElements();
	
			for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
				starts[i] = start;
				angle = me._computeAngle(i);
				angles[i] = angle;
				start += angle;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveElementOptions(arcs[i], i);
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		/**
		 * @private
		 */
		_updateRadius: function() {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
	
			chart.outerRadius = Math.max(minSize / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;
	
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;
	
			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = me._starts[index];
			var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
	
			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});
	
			arc.pivot();
		},
	
		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;
	
			helpers$1.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});
	
			return count;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
			var valueOrDefault = helpers$1.valueOrDefault;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * @private
		 */
		_resolveElementOptions: function(arc, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = arc.custom || {};
			var options = chart.options.elements.arc;
			var values = {};
			var i, ilen, key;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'borderAlign',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
			];
	
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$5([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}
	
			return values;
		},
	
		/**
		 * @private
		 */
		_computeAngle: function(index) {
			var me = this;
			var count = this.getMeta().count;
			var dataset = me.getDataset();
			var meta = me.getMeta();
	
			if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
				return 0;
			}
	
			// Scriptable options
			var context = {
				chart: me.chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			return resolve$5([
				me.chart.options.elements.arc.angle,
				(2 * Math.PI) / count
			], context, index);
		}
	});
	
	core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
	core_defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	// Pie charts are Doughnut chart with different defaults
	var controller_pie = controller_doughnut;
	
	var valueOrDefault$6 = helpers$1.valueOrDefault;
	var resolve$6 = helpers$1.options.resolve;
	
	core_defaults._set('radar', {
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				tension: 0 // no bezier in radar
			}
		}
	});
	
	var controller_radar = core_datasetController.extend({
	
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		linkScales: helpers$1.noop,
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.chart.scale;
			var dataset = me.getDataset();
			var i, ilen;
	
			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}
	
			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			line._loop = true;
			// Model
			line._model = me._resolveLineOptions(line);
	
			line.pivot();
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			// Update bezier control points
			me.updateBezierControlPoints();
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
			var options = me._resolvePointOptions(point, index);
			var lineModel = me.getMeta().dataset._model;
			var x = reset ? scale.xCenter : pointPosition.x;
			var y = reset ? scale.yCenter : pointPosition.y;
	
			// Utility
			point._scale = scale;
			point._options = options;
			point._datasetIndex = me.index;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x, // value not used in dataset scale, but we want a consistent API between scales
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
	
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolvePointOptions: function(element, index) {
			var me = this;
			var chart = me.chart;
			var dataset = chart.data.datasets[me.index];
			var custom = element.custom || {};
			var options = chart.options.elements.point;
			var values = {};
			var i, ilen, key;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			var ELEMENT_OPTIONS = {
				backgroundColor: 'pointBackgroundColor',
				borderColor: 'pointBorderColor',
				borderWidth: 'pointBorderWidth',
				hitRadius: 'pointHitRadius',
				hoverBackgroundColor: 'pointHoverBackgroundColor',
				hoverBorderColor: 'pointHoverBorderColor',
				hoverBorderWidth: 'pointHoverBorderWidth',
				hoverRadius: 'pointHoverRadius',
				pointStyle: 'pointStyle',
				radius: 'pointRadius',
				rotation: 'pointRotation'
			};
			var keys = Object.keys(ELEMENT_OPTIONS);
	
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$6([
					custom[key],
					dataset[ELEMENT_OPTIONS[key]],
					dataset[key],
					options[key]
				], context, index);
			}
	
			return values;
		},
	
		/**
		 * @private
		 */
		_resolveLineOptions: function(element) {
			var me = this;
			var chart = me.chart;
			var dataset = chart.data.datasets[me.index];
			var custom = element.custom || {};
			var options = chart.options.elements.line;
			var values = {};
			var i, ilen, key;
	
			var keys = [
				'backgroundColor',
				'borderWidth',
				'borderColor',
				'borderCapStyle',
				'borderDash',
				'borderDashOffset',
				'borderJoinStyle',
				'fill'
			];
	
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$6([
					custom[key],
					dataset[key],
					options[key]
				]);
			}
	
			values.tension = valueOrDefault$6(dataset.lineTension, options.tension);
	
			return values;
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i, true)._model,
					model,
					helpers$1.nextItem(points, i, true)._model,
					model.tension
				);
	
				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
				model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
				model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
				model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
			}
		},
	
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
		}
	});
	
	core_defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		showLines: false,
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	// Scatter charts use line controllers
	var controller_scatter = controller_line;
	
	// NOTE export a map in which the key represents the controller type, not
	// the class, and so must be CamelCase in order to be correctly retrieved
	// by the controller in core.controller.js (`controllers[meta.type]`).
	
	var controllers = {
		bar: controller_bar,
		bubble: controller_bubble,
		doughnut: controller_doughnut,
		horizontalBar: controller_horizontalBar,
		line: controller_line,
		polarArea: controller_polarArea,
		pie: controller_pie,
		radar: controller_radar,
		scatter: controller_scatter
	};
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {object} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers$1.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param {Chart} chart - the chart
	 * @param {function} handler - the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var datasets = chart.data.datasets;
		var meta, i, j, ilen, jlen;
	
		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!chart.isDatasetVisible(i)) {
				continue;
			}
	
			meta = chart.getDatasetMeta(i);
			for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
				var element = meta.data[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param {ChartElement[]} items - elements to filter
	 * @param {object} position - the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param {Chart} chart - the chart to look at elements from
	 * @param {object} position - the point to be nearest to
	 * @param {boolean} intersect - if true, only consider items that intersect the position
	 * @param {function} distanceMetric - function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {string} axis - the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart.data.datasets.forEach(function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);
				var element = meta.data[items[0]._index];
	
				// don't count items that are skipped (null data)
				if (element && !element._view.skip) {
					elements.push(element);
				}
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	var core_interaction = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				return getNearestItems(chart, position, options.intersect, distanceMetric);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};
	
	function filterByPosition(array, position) {
		return helpers$1.where(array, function(v) {
			return v.position === position;
		});
	}
	
	function sortByWeight(array, reverse) {
		array.forEach(function(v, i) {
			v._tmpIndex_ = i;
			return v;
		});
		array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0._tmpIndex_ - v1._tmpIndex_ :
				v0.weight - v1.weight;
		});
		array.forEach(function(v) {
			delete v._tmpIndex_;
		});
	}
	
	function findMaxPadding(boxes) {
		var top = 0;
		var left = 0;
		var bottom = 0;
		var right = 0;
		helpers$1.each(boxes, function(box) {
			if (box.getPadding) {
				var boxPadding = box.getPadding();
				top = Math.max(top, boxPadding.top);
				left = Math.max(left, boxPadding.left);
				bottom = Math.max(bottom, boxPadding.bottom);
				right = Math.max(right, boxPadding.right);
			}
		});
		return {
			top: top,
			left: left,
			bottom: bottom,
			right: right
		};
	}
	
	function addSizeByPosition(boxes, size) {
		helpers$1.each(boxes, function(box) {
			size[box.position] += box.isHorizontal() ? box.height : box.width;
		});
	}
	
	core_defaults._set('global', {
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	/**
	 * @interface ILayoutItem
	 * @prop {string} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {function} getPadding -  Returns an object with padding on the edges
	 * @prop {number} width - Width of item. Must be valid after update()
	 * @prop {number} height - Height of item. Must be valid after update()
	 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */
	
	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	var core_layouts = {
		defaults: {},
	
		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}
	
			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;
	
			chart.boxes.push(item);
		},
	
		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {ILayoutItem} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},
	
		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {ILayoutItem} item - the item to configure with the given options
		 * @param {object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;
	
			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},
	
		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {number} width - the width to fit into
		 * @param {number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}
	
			var layoutOptions = chart.options.layout || {};
			var padding = helpers$1.options.toPadding(layoutOptions.padding);
			var leftPadding = padding.left;
			var rightPadding = padding.right;
			var topPadding = padding.top;
			var bottomPadding = padding.bottom;
	
			var leftBoxes = filterByPosition(chart.boxes, 'left');
			var rightBoxes = filterByPosition(chart.boxes, 'right');
			var topBoxes = filterByPosition(chart.boxes, 'top');
			var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
			var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');
	
			// Sort boxes by weight. A higher weight is further away from the chart area
			sortByWeight(leftBoxes, true);
			sortByWeight(rightBoxes, false);
			sortByWeight(topBoxes, true);
			sortByWeight(bottomBoxes, false);
	
			var verticalBoxes = leftBoxes.concat(rightBoxes);
			var horizontalBoxes = topBoxes.concat(bottomBoxes);
			var outerBoxes = verticalBoxes.concat(horizontalBoxes);
	
			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
			// What we do to find the best sizing, we do the following
			// 1. Determine the minimum size of the chart area.
			// 2. Split the remaining width equally between each vertical axis
			// 3. Split the remaining height equally between each horizontal axis
			// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
			// 5. Adjust the sizes of each axis based on it's minimum reported size.
			// 6. Refit each axis
			// 7. Position each axis in the final location
			// 8. Tell the chart the final location of the chart area
			// 9. Tell any axes that overlay the chart area the positions of the chart area
	
			// Step 1
			var chartWidth = width - leftPadding - rightPadding;
			var chartHeight = height - topPadding - bottomPadding;
			var chartAreaWidth = chartWidth / 2; // min 50%
	
			// Step 2
			var verticalBoxWidth = (width - chartAreaWidth) / verticalBoxes.length;
	
			// Step 3
			// TODO re-limit horizontal axis height (this limit has affected only padding calculation since PR 1837)
			// var horizontalBoxHeight = (height - chartAreaHeight) / horizontalBoxes.length;
	
			// Step 4
			var maxChartAreaWidth = chartWidth;
			var maxChartAreaHeight = chartHeight;
			var outerBoxSizes = {top: topPadding, left: leftPadding, bottom: bottomPadding, right: rightPadding};
			var minBoxSizes = [];
			var maxPadding;
	
			function getMinimumBoxSize(box) {
				var minSize;
				var isHorizontal = box.isHorizontal();
	
				if (isHorizontal) {
					minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2);
					maxChartAreaHeight -= minSize.height;
				} else {
					minSize = box.update(verticalBoxWidth, maxChartAreaHeight);
					maxChartAreaWidth -= minSize.width;
				}
	
				minBoxSizes.push({
					horizontal: isHorizontal,
					width: minSize.width,
					box: box,
				});
			}
	
			helpers$1.each(outerBoxes, getMinimumBoxSize);
	
			// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
			maxPadding = findMaxPadding(outerBoxes);
	
			// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
			// be if the axes are drawn at their minimum sizes.
			// Steps 5 & 6
	
			// Function to fit a box
			function fitBox(box) {
				var minBoxSize = helpers$1.findNextWhere(minBoxSizes, function(minBox) {
					return minBox.box === box;
				});
	
				if (minBoxSize) {
					if (minBoxSize.horizontal) {
						var scaleMargin = {
							left: Math.max(outerBoxSizes.left, maxPadding.left),
							right: Math.max(outerBoxSizes.right, maxPadding.right),
							top: 0,
							bottom: 0
						};
	
						// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
						// on the margin. Sometimes they need to increase in size slightly
						box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
					} else {
						box.update(minBoxSize.width, maxChartAreaHeight);
					}
				}
			}
	
			// Update, and calculate the left and right margins for the horizontal boxes
			helpers$1.each(verticalBoxes, fitBox);
			addSizeByPosition(verticalBoxes, outerBoxSizes);
	
			// Set the Left and Right margins for the horizontal boxes
			helpers$1.each(horizontalBoxes, fitBox);
			addSizeByPosition(horizontalBoxes, outerBoxSizes);
	
			function finalFitVerticalBox(box) {
				var minBoxSize = helpers$1.findNextWhere(minBoxSizes, function(minSize) {
					return minSize.box === box;
				});
	
				var scaleMargin = {
					left: 0,
					right: 0,
					top: outerBoxSizes.top,
					bottom: outerBoxSizes.bottom
				};
	
				if (minBoxSize) {
					box.update(minBoxSize.width, maxChartAreaHeight, scaleMargin);
				}
			}
	
			// Let the left layout know the final margin
			helpers$1.each(verticalBoxes, finalFitVerticalBox);
	
			// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
			outerBoxSizes = {top: topPadding, left: leftPadding, bottom: bottomPadding, right: rightPadding};
			addSizeByPosition(outerBoxes, outerBoxSizes);
	
			// We may be adding some padding to account for rotated x axis labels
			var leftPaddingAddition = Math.max(maxPadding.left - outerBoxSizes.left, 0);
			outerBoxSizes.left += leftPaddingAddition;
			outerBoxSizes.right += Math.max(maxPadding.right - outerBoxSizes.right, 0);
	
			var topPaddingAddition = Math.max(maxPadding.top - outerBoxSizes.top, 0);
			outerBoxSizes.top += topPaddingAddition;
			outerBoxSizes.bottom += Math.max(maxPadding.bottom - outerBoxSizes.bottom, 0);
	
			// Figure out if our chart area changed. This would occur if the dataset layout label rotation
			// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
			// without calling `fit` again
			var newMaxChartAreaHeight = height - outerBoxSizes.top - outerBoxSizes.bottom;
			var newMaxChartAreaWidth = width - outerBoxSizes.left - outerBoxSizes.right;
	
			if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
				helpers$1.each(verticalBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});
	
				helpers$1.each(horizontalBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});
	
				maxChartAreaHeight = newMaxChartAreaHeight;
				maxChartAreaWidth = newMaxChartAreaWidth;
			}
	
			// Step 7 - Position the boxes
			var left = leftPadding + leftPaddingAddition;
			var top = topPadding + topPaddingAddition;
	
			function placeBox(box) {
				if (box.isHorizontal()) {
					box.left = box.fullWidth ? leftPadding : outerBoxSizes.left;
					box.right = box.fullWidth ? width - rightPadding : outerBoxSizes.left + maxChartAreaWidth;
					box.top = top;
					box.bottom = top + box.height;
	
					// Move to next point
					top = box.bottom;
	
				} else {
	
					box.left = left;
					box.right = left + box.width;
					box.top = outerBoxSizes.top;
					box.bottom = outerBoxSizes.top + maxChartAreaHeight;
	
					// Move to next point
					left = box.right;
				}
			}
	
			helpers$1.each(leftBoxes.concat(topBoxes), placeBox);
	
			// Account for chart width and height
			left += maxChartAreaWidth;
			top += maxChartAreaHeight;
	
			helpers$1.each(rightBoxes, placeBox);
			helpers$1.each(bottomBoxes, placeBox);
	
			// Step 8
			chart.chartArea = {
				left: outerBoxSizes.left,
				top: outerBoxSizes.top,
				right: outerBoxSizes.left + maxChartAreaWidth,
				bottom: outerBoxSizes.top + maxChartAreaHeight
			};
	
			// Step 9
			helpers$1.each(chartAreaBoxes, function(box) {
				box.left = chart.chartArea.left;
				box.top = chart.chartArea.top;
				box.right = chart.chartArea.right;
				box.bottom = chart.chartArea.bottom;
	
				box.update(maxChartAreaWidth, maxChartAreaHeight);
			});
		}
	};
	
	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	var platform_basic = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};
	
	var platform_dom = "/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n";
	
	var platform_dom$1 = /*#__PURE__*/Object.freeze({
	default: platform_dom
	});
	
	function getCjsExportFromNamespace (n) {
		return n && n.default || n;
	}
	
	var stylesheet = getCjsExportFromNamespace(platform_dom$1);
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers$1.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line getter-return
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers$1.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers$1.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	function createDiv(cls) {
		var el = document.createElement('div');
		el.className = cls || '';
		return el;
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var maxSize = 1000000;
	
		// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
		// https://github.com/chartjs/Chart.js/issues/5902
		var resizer = createDiv(CSS_SIZE_MONITOR);
		var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
		var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
	
		expand.appendChild(createDiv());
		shrink.appendChild(createDiv());
	
		resizer.appendChild(expand);
		resizer.appendChild(shrink);
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
	
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			addListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers$1.each(ANIMATION_START_EVENTS, function(type) {
				removeListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				var container = chart.options.maintainAspectRatio && node.parentNode;
				var w = container ? container.clientWidth : 0;
				listener(createEvent('resize', chart));
				if (container && container.clientWidth < w && chart.canvas) {
					// If the container size shrank during chart resize, let's assume
					// scrollbar appeared. So we resize again with the scrollbar visible -
					// effectively making chart smaller and the scrollbar hidden again.
					// Because we are inside `throttled`, and currently `ticking`, scroll
					// events are ignored during this whole 2 resize process.
					// If we assumed wrong and something else happened, we are resizing
					// twice in a frame (potential performance issue)
					listener(createEvent('resize', chart));
				}
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	function injectCSS(platform, css) {
		// https://stackoverflow.com/q/3922139
		var style = platform._style || document.createElement('style');
		if (!platform._style) {
			platform._style = style;
			css = '/* Chart.js */\n' + css;
			style.setAttribute('type', 'text/css');
			document.getElementsByTagName('head')[0].appendChild(style);
		}
	
		style.appendChild(document.createTextNode(css));
	}
	
	var platform_dom$2 = {
		/**
		 * When `true`, prevents the automatic injection of the stylesheet required to
		 * correctly detect when the chart is added to the DOM and then resized. This
		 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
		 * to be manually imported to make this library compatible with any CSP.
		 * See https://github.com/chartjs/Chart.js/issues/5208
		 */
		disableCSSInjection: false,
	
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		/**
		 * @private
		 */
		_ensureLoaded: function() {
			if (this._loaded) {
				return;
			}
	
			this._loaded = true;
	
			// https://github.com/chartjs/Chart.js/issues/5208
			if (!this.disableCSSInjection) {
				injectCSS(this, stylesheet);
			}
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// Load platform resources on first chart creation, to make possible to change
			// platform options after importing the library (e.g. `disableCSSInjection`).
			this._ensureLoaded();
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers$1.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers$1.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			// eslint-disable-next-line no-self-assign
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.addEvent = addListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.removeEvent = removeListener;
	
	// @TODO Make possible to select another platform at build time.
	var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	var platform = helpers$1.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {string} type - The ({@link IEvent}) type to listen for
		 * @param {function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart - Chart from which to remove the listener
		 * @param {string} type - The ({@link IEvent}) type to remove
		 * @param {function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	core_defaults._set('global', {
		plugins: {}
	});
	
	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	var core_plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],
	
		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,
	
		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},
	
		/**
		 * Returns the number of registered plugins?
		 * @returns {number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},
	
		/**
		 * Returns all registered plugin instances.
		 * @returns {IPlugin[]} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},
	
		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Chart} chart - The chart instance for which plugins should be called.
		 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;
	
			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}
	
			return true;
		},
	
		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {object[]} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}
	
			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};
	
			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}
	
				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}
	
				if (opts === true) {
					opts = helpers$1.clone(core_defaults.global.plugins[id]);
				}
	
				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});
	
			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},
	
		/**
		 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
		 * but in some cases, this reference can be changed by the user when updating options.
		 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		 * @private
		 */
		_invalidate: function(chart) {
			delete chart.$plugins;
		}
	};
	
	var core_scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers
	
		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers$1.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers$1.merge({}, [core_defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers$1.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				core_layouts.addBox(chart, scale);
			});
		}
	};
	
	var valueOrDefault$7 = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers$1.noop,
				title: function(tooltipItems, data) {
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
						if (item.label) {
							title = item.label;
						} else if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers$1.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers$1.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
						label += tooltipItem.value;
					} else {
						label += tooltipItem.yLabel;
					}
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers$1.noop,
				footer: helpers$1.noop,
				afterFooter: helpers$1.noop
			}
		}
	});
	
	var positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {object} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}
	
			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}
	
			return {
				x: x / count,
				y: y / count
			};
		},
	
		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {object} the position of the event in canvas coordinates
		 * @returns {object} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers$1.distanceBetweenPoints(eventPosition, center);
	
					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}
	
			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}
	
			return {
				x: x,
				y: y
			};
		}
	};
	
	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers$1.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}
	
		return base;
	}
	
	/**
	 * Returns array of strings split by newline
	 * @param {string} value - The value to split by newline.
	 * @returns {string[]} value if newline present - Returned from String split() method
	 * @function
	 */
	function splitNewlines(str) {
		if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
			return str.split('\n');
		}
		return str;
	}
	
	
	/**
	 * Private helper to create a tooltip item model
	 * @param element - the chart element (point, arc, bar) to create the tooltip item for
	 * @return new tooltip item
	 */
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;
		var controller = element._chart.getDatasetMeta(datasetIndex).controller;
		var indexScale = controller._getIndexScale();
		var valueScale = controller._getValueScale();
	
		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
			value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}
	
	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = core_defaults.global;
	
		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,
	
			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault$7(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault$7(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault$7(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,
	
			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault$7(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault$7(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault$7(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,
	
			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault$7(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault$7(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault$7(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,
	
			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}
	
	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;
	
		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;
	
		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;
	
		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};
	
		ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers$1.each(model.title, maxLineWidth);
	
		// Body width
		ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers$1.each(body, function(bodyItem) {
			helpers$1.each(bodyItem.before, maxLineWidth);
			helpers$1.each(bodyItem.lines, maxLineWidth);
			helpers$1.each(bodyItem.after, maxLineWidth);
		});
	
		// Reset back to 0
		widthPadding = 0;
	
		// Footer width
		ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers$1.each(model.footer, maxLineWidth);
	
		// Add padding
		width += 2 * model.xPadding;
	
		return {
			width: width,
			height: height
		};
	}
	
	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';
	
		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}
	
		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;
	
		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}
	
		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};
	
		if (lf(model.x)) {
			xAlign = 'left';
	
			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';
	
			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}
	
		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}
	
	/**
	 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;
	
		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;
	
		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}
	
		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}
	
		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}
	
		return {
			x: x,
			y: y
		};
	}
	
	function getAlignedX(vm, align) {
		return align === 'center'
			? vm.x + vm.width / 2
			: align === 'right'
				? vm.x + vm.width - vm.xPadding
				: vm.x + vm.xPadding;
	}
	
	/**
	 * Helper to build before and after body lines
	 */
	function getBeforeAfterBodyLines(callback) {
		return pushOrConcat([], splitNewlines(callback));
	}
	
	var exports$3 = core_element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},
	
		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;
	
			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeTitle));
			lines = pushOrConcat(lines, splitNewlines(title));
			lines = pushOrConcat(lines, splitNewlines(afterTitle));
	
			return lines;
		},
	
		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
		},
	
		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];
	
			helpers$1.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
	
				bodyItems.push(bodyItem);
			});
	
			return bodyItems;
		},
	
		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
		},
	
		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;
	
			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeFooter));
			lines = pushOrConcat(lines, splitNewlines(footer));
			lines = pushOrConcat(lines, splitNewlines(afterFooter));
	
			return lines;
		},
	
		update: function(changed) {
			var me = this;
			var opts = me._options;
	
			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;
	
			var data = me._data;
	
			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};
	
			var i, len;
	
			if (active.length) {
				model.opacity = 1;
	
				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
	
				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}
	
				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}
	
				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}
	
				// Determine colors for boxes
				helpers$1.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});
	
	
				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);
	
				// Initial positioning and colors
				model.x = tooltipPosition.x;
				model.y = tooltipPosition.y;
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;
	
				// data points
				model.dataPoints = tooltipItems;
	
				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}
	
			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;
	
			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;
	
			me._model = model;
	
			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}
	
			return me;
		},
	
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;
	
			if (yAlign === 'center') {
				y2 = ptY + (height / 2);
	
				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;
	
					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;
	
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
	
		drawTitle: function(pt, vm, ctx) {
			var title = vm.title;
	
			if (title.length) {
				pt.x = getAlignedX(vm, vm._titleAlign);
	
				ctx.textAlign = vm._titleAlign;
				ctx.textBaseline = 'top';
	
				var titleFontSize = vm.titleFontSize;
				var titleSpacing = vm.titleSpacing;
	
				ctx.fillStyle = vm.titleFontColor;
				ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
				var i, len;
				for (i = 0, len = title.length; i < len; ++i) {
					ctx.fillText(title[i], pt.x, pt.y);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
					if (i + 1 === title.length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
	
		drawBody: function(pt, vm, ctx) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var bodyAlign = vm._bodyAlign;
			var body = vm.body;
			var drawColorBoxes = vm.displayColors;
			var labelColors = vm.labelColors;
			var xLinePadding = 0;
			var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
			var textColor;
	
			ctx.textAlign = bodyAlign;
			ctx.textBaseline = 'top';
			ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
			pt.x = getAlignedX(vm, bodyAlign);
	
			// Before Body
			var fillLineOfText = function(line) {
				ctx.fillText(line, pt.x + xLinePadding, pt.y);
				pt.y += bodyFontSize + bodySpacing;
			};
	
			// Before body lines
			ctx.fillStyle = vm.bodyFontColor;
			helpers$1.each(vm.beforeBody, fillLineOfText);
	
			xLinePadding = drawColorBoxes && bodyAlign !== 'right'
				? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
				: 0;
	
			// Draw body lines now
			helpers$1.each(body, function(bodyItem, i) {
				textColor = vm.labelTextColors[i];
				ctx.fillStyle = textColor;
				helpers$1.each(bodyItem.before, fillLineOfText);
	
				helpers$1.each(bodyItem.lines, function(line) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = vm.legendColorBackground;
						ctx.fillRect(colorX, pt.y, bodyFontSize, bodyFontSize);
	
						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = labelColors[i].borderColor;
						ctx.strokeRect(colorX, pt.y, bodyFontSize, bodyFontSize);
	
						// Inner square
						ctx.fillStyle = labelColors[i].backgroundColor;
						ctx.fillRect(colorX + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}
	
					fillLineOfText(line);
				});
	
				helpers$1.each(bodyItem.after, fillLineOfText);
			});
	
			// Reset back to 0 for after body
			xLinePadding = 0;
	
			// After body lines
			helpers$1.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
	
		drawFooter: function(pt, vm, ctx) {
			var footer = vm.footer;
	
			if (footer.length) {
				pt.x = getAlignedX(vm, vm._footerAlign);
				pt.y += vm.footerMarginTop;
	
				ctx.textAlign = vm._footerAlign;
				ctx.textBaseline = 'top';
	
				ctx.fillStyle = vm.footerFontColor;
				ctx.font = helpers$1.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
				helpers$1.each(footer, function(line) {
					ctx.fillText(line, pt.x, pt.y);
					pt.y += vm.footerFontSize + vm.footerSpacing;
				});
			}
		},
	
		drawBackground: function(pt, vm, ctx, tooltipSize) {
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;
	
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
	
			ctx.fill();
	
			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
	
			if (vm.opacity === 0) {
				return;
			}
	
			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};
	
			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
			if (this._options.enabled && hasTooltipContent) {
				ctx.save();
				ctx.globalAlpha = opacity;
	
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize);
	
				// Draw Title, Body, and Footer
				pt.y += vm.yPadding;
	
				// Titles
				this.drawTitle(pt, vm, ctx);
	
				// Body
				this.drawBody(pt, vm, ctx);
	
				// Footer
				this.drawFooter(pt, vm, ctx);
	
				ctx.restore();
			}
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;
	
			me._lastActive = me._lastActive || [];
	
			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			}
	
			// Remember Last Actives
			changed = !helpers$1.arrayEquals(me._active, me._lastActive);
	
			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					me.update(true);
					me.pivot();
				}
			}
	
			return changed;
		}
	});
	
	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	var positioners_1 = positioners;
	
	var core_tooltip = exports$3;
	core_tooltip.positioners = positioners_1;
	
	var valueOrDefault$8 = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		elements: {},
		events: [
			'mousemove',
			'mouseout',
			'click',
			'touchstart',
			'touchmove'
		],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		maintainAspectRatio: true,
		responsive: true,
		responsiveAnimationDuration: 0
	});
	
	/**
	 * Recursively merge the given config objects representing the `scales` option
	 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
	 * returns a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeScaleConfig(/* config objects ... */) {
		return helpers$1.merge({}, [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;
	
					if (!target[key]) {
						target[key] = [];
					}
	
					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = valueOrDefault$8(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
						if (i >= target[key].length) {
							target[key].push({});
						}
	
						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers$1.merge(target[key][i], scale);
						}
					}
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	/**
	 * Recursively merge the given config objects as the root options by handling
	 * default scale options for the `scales` and `scale` properties, then returns
	 * a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeConfig(/* config objects ... */) {
		return helpers$1.merge({}, [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				var tval = target[key] || {};
				var sval = source[key];
	
				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = mergeScaleConfig(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	function initConfig(config) {
		config = config || {};
	
		// Do NOT use mergeConfig for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];
	
		config.options = mergeConfig(
			core_defaults.global,
			core_defaults[config.type],
			config.options || {});
	
		return config;
	}
	
	function updateConfig(chart) {
		var newOptions = chart.options;
	
		helpers$1.each(chart.scales, function(scale) {
			core_layouts.removeBox(chart, scale);
		});
	
		newOptions = mergeConfig(
			core_defaults.global,
			core_defaults[chart.config.type],
			newOptions);
	
		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
	
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}
	
	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}
	
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};
	
	helpers$1.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;
	
			config = initConfig(config);
	
			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;
	
			me.id = helpers$1.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;
	
			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception
	
			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;
	
			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});
	
			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}
	
			me.initialize();
			me.update();
		},
	
		/**
		 * @private
		 */
		initialize: function() {
			var me = this;
	
			// Before init plugin notification
			core_plugins.notify(me, 'beforeInit');
	
			helpers$1.retinaScale(me, me.options.devicePixelRatio);
	
			me.bindEvents();
	
			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}
	
			// Make sure scales have IDs and are built before we build any controllers.
			me.ensureScalesHaveIDs();
			me.buildOrUpdateScales();
			me.initToolTip();
	
			// After init plugin notification
			core_plugins.notify(me, 'afterInit');
	
			return me;
		},
	
		clear: function() {
			helpers$1.canvas.clear(this);
			return this;
		},
	
		stop: function() {
			// Stops any current animation loop occurring
			core_animations.cancelAnimation(this);
			return this;
		},
	
		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.
	
			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
			var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
	
			if (me.width === newWidth && me.height === newHeight) {
				return;
			}
	
			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';
	
			helpers$1.retinaScale(me, options.devicePixelRatio);
	
			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				core_plugins.notify(me, 'resize', [newSize]);
	
				// Notify of resize
				if (options.onResize) {
					options.onResize(me, newSize);
				}
	
				me.stop();
				me.update({
					duration: options.responsiveAnimationDuration
				});
			}
		},
	
		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;
	
			helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
			});
	
			helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
			});
	
			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},
	
		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});
	
			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}
	
			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}
	
			helpers$1.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = valueOrDefault$8(scaleOptions.type, item.dtype);
	
				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}
	
				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = core_scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}
	
				scale.mergeTicksOptions();
	
				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers$1.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});
	
			me.scales = scales;
	
			core_scaleService.addScalesToLayout(this);
		},
	
		buildOrUpdateControllers: function() {
			var me = this;
			var newControllers = [];
	
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				var meta = me.getDatasetMeta(datasetIndex);
				var type = dataset.type || me.config.type;
	
				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(datasetIndex);
					meta = me.getDatasetMeta(datasetIndex);
				}
				meta.type = type;
	
				if (meta.controller) {
					meta.controller.updateIndex(datasetIndex);
					meta.controller.linkScales();
				} else {
					var ControllerClass = controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}
	
					meta.controller = new ControllerClass(me, datasetIndex);
					newControllers.push(meta.controller);
				}
			}, me);
	
			return newControllers;
		},
	
		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},
	
		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},
	
		update: function(config) {
			var me = this;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			updateConfig(me);
	
			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			core_plugins._invalidate(me);
	
			if (core_plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}
	
			// In case the entire data object changed
			me.tooltip._data = me.data;
	
			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();
	
			// Make sure all dataset controllers have correct meta data counts
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
			}, me);
	
			me.updateLayout();
	
			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers$1.each(newControllers, function(controller) {
					controller.reset();
				});
			}
	
			me.updateDatasets();
	
			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();
	
			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];
	
			// Do this before render so that any plugins that need final scale updates can use it
			core_plugins.notify(me, 'afterUpdate');
	
			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},
	
		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeLayout') === false) {
				return;
			}
	
			core_layouts.update(this, this.width, this.height);
	
			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			core_plugins.notify(me, 'afterScaleUpdate');
			core_plugins.notify(me, 'afterLayout');
		},
	
		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}
	
			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}
	
			core_plugins.notify(me, 'afterDatasetsUpdate');
		},
	
		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};
	
			if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}
	
			meta.controller.update();
	
			core_plugins.notify(me, 'afterDatasetUpdate', [args]);
		},
	
		render: function(config) {
			var me = this;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			var animationOptions = me.options.animation;
			var duration = valueOrDefault$8(config.duration, animationOptions && animationOptions.duration);
			var lazy = config.lazy;
	
			if (core_plugins.notify(me, 'beforeRender') === false) {
				return;
			}
	
			var onComplete = function(animation) {
				core_plugins.notify(me, 'afterRender');
				helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};
	
			if (animationOptions && duration) {
				var animation = new core_animation({
					numSteps: duration / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,
	
					render: function(chart, animationObject) {
						var easingFunction = helpers$1.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;
	
						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},
	
					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});
	
				core_animations.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();
	
				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new core_animation({numSteps: 0, chart: me}));
			}
	
			return me;
		},
	
		draw: function(easingValue) {
			var me = this;
	
			me.clear();
	
			if (helpers$1.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}
	
			me.transition(easingValue);
	
			if (me.width <= 0 || me.height <= 0) {
				return;
			}
	
			if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}
	
			// Draw all the scales
			helpers$1.each(me.boxes, function(box) {
				box.draw(me.chartArea);
			}, me);
	
			me.drawDatasets(easingValue);
			me._drawTooltip(easingValue);
	
			core_plugins.notify(me, 'afterDraw', [easingValue]);
		},
	
		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;
	
			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}
	
			me.tooltip.transition(easingValue);
		},
	
		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}
	
			// Draw datasets reversed to support proper line stacking
			for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
				if (me.isDatasetVisible(i)) {
					me.drawDataset(i, easingValue);
				}
			}
	
			core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},
	
		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(index, easingValue) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}
	
			meta.controller.draw(easingValue);
	
			core_plugins.notify(me, 'afterDatasetDraw', [args]);
		},
	
		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}
	
			tooltip.draw();
	
			core_plugins.notify(me, 'afterTooltipDraw', [args]);
		},
	
		/**
		 * Get the single element that was clicked on
		 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		 */
		getElementAtEvent: function(e) {
			return core_interaction.modes.single(this, e);
		},
	
		getElementsAtEvent: function(e) {
			return core_interaction.modes.label(this, e, {intersect: true});
		},
	
		getElementsAtXAxis: function(e) {
			return core_interaction.modes['x-axis'](this, e, {intersect: true});
		},
	
		getElementsAtEventForMode: function(e, mode, options) {
			var method = core_interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}
	
			return [];
		},
	
		getDatasetAtEvent: function(e) {
			return core_interaction.modes.dataset(this, e, {intersect: true});
		},
	
		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}
	
			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null
				};
			}
	
			return meta;
		},
	
		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},
	
		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);
	
			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},
	
		generateLegend: function() {
			return this.options.legendCallback(this);
		},
	
		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];
	
			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},
	
		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;
	
			me.stop();
	
			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}
	
			if (canvas) {
				me.unbindEvents();
				helpers$1.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}
	
			core_plugins.notify(me, 'destroy');
	
			delete Chart.instances[me.id];
		},
	
		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},
	
		initToolTip: function() {
			var me = this;
			me.tooltip = new core_tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},
	
		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};
	
			helpers$1.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});
	
			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};
	
				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},
	
		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}
	
			delete me._listeners;
			helpers$1.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},
	
		updateHoverStyle: function(elements, mode, enabled) {
			var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
			var element, i, ilen;
	
			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[method](element);
				}
			}
		},
	
		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;
	
			if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}
	
			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;
	
			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}
	
			core_plugins.notify(me, 'afterEvent', [e]);
	
			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();
	
				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render({
					duration: me.options.hover.animationDuration,
					lazy: true
				});
			}
	
			me._bufferedRender = false;
			me._bufferedRequest = null;
	
			return me;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;
	
			me.lastActive = me.lastActive || [];
	
			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}
	
			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}
	
			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}
	
			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}
	
			changed = !helpers$1.arrayEquals(me.active, me.lastActive);
	
			// Remember Last Actives
			me.lastActive = me.active;
	
			return changed;
		}
	});
	
	/**
	 * NOTE(SB) We actually don't use this container anymore but we need to keep it
	 * for backward compatibility. Though, it can still be useful for plugins that
	 * would need to work on multiple charts?!
	 */
	Chart.instances = {};
	
	var core_controller = Chart;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	Chart.types = {};
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.configMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.configMerge = mergeConfig;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.scaleMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.scaleMerge = mergeScaleConfig;
	
	var core_helpers = function() {
	
		// -- Basic js utility methods
	
		helpers$1.where = function(collection, filterCallback) {
			if (helpers$1.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers$1.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers$1.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers$1.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers$1.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers$1.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
		};
		helpers$1.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers$1.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers$1.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers$1.log10 = Math.log10 ?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
				// Check for whole powers of 10,
				// which due to floating point rounding error should be corrected.
				var powerOf10 = Math.round(exponent);
				var isPowerOf10 = x === Math.pow(10, powerOf10);
	
				return isPowerOf10 ? powerOf10 : exponent;
			};
		helpers$1.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers$1.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
	
		/**
		 * Returns the number of decimal places
		 * i.e. the number of digits after the decimal point, of the value of this Number.
		 * @param {number} x - A number.
		 * @returns {number} The number of decimal places.
		 * @private
		 */
		helpers$1._decimalPlaces = function(x) {
			if (!helpers$1.isFinite(x)) {
				return;
			}
			var e = 1;
			var p = 0;
			while (Math.round(x * e) / e !== x) {
				e *= 10;
				p++;
			}
			return p;
		};
	
		// Gets the angle from vertical upright to the point about a centre.
		helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers$1.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.helpers.aliasPixel
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		helpers$1.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
	
		/**
		 * Returns the aligned pixel value to avoid anti-aliasing blur
		 * @param {Chart} chart - The chart instance.
		 * @param {number} pixel - A pixel value.
		 * @param {number} width - The width of the element.
		 * @returns {number} The aligned pixel value.
		 * @private
		 */
		helpers$1._alignPixel = function(chart, pixel, width) {
			var devicePixelRatio = chart.currentDevicePixelRatio;
			var halfWidth = width / 2;
			return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
		};
	
		helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers$1.EPSILON = Number.EPSILON || 1e-14;
		helpers$1.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers$1.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers$1.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers$1.niceNum = function(range, round) {
			var exponent = Math.floor(helpers$1.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers$1.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers$1.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.target || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		/**
		 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
		 * @param {HTMLElement} domNode - the node to check the constraint on
		 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
		 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
		 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
		 */
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = helpers$1._getParentNode(domNode);
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers$1.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers$1.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		/**
		 * @private
	 	 */
		helpers$1._calculatePadding = function(container, padding, parentDimension) {
			padding = helpers$1.getStyle(container, padding);
	
			return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
		};
		/**
		 * @private
		 */
		helpers$1._getParentNode = function(domNode) {
			var parent = domNode.parentNode;
			if (parent && parent.toString() === '[object ShadowRoot]') {
				parent = parent.host;
			}
			return parent;
		};
		helpers$1.getMaximumWidth = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientWidth;
			}
	
			var clientWidth = container.clientWidth;
			var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
			var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
	
			var w = clientWidth - paddingLeft - paddingRight;
			var cw = helpers$1.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers$1.getMaximumHeight = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientHeight;
			}
	
			var clientHeight = container.clientHeight;
			var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
			var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
	
			var h = clientHeight - paddingTop - paddingBottom;
			var ch = helpers$1.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers$1.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers$1.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers$1.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
					longest = helpers$1.measureText(ctx, data, gc, longest, thing);
				} else if (helpers$1.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers$1.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
							longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers$1.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers$1.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers$1.each(arrayOfThings, function(thing) {
				if (helpers$1.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers$1.color = !chartjsColor ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = core_defaults.global.defaultColor;
				}
	
				return chartjsColor(value);
			};
	
		helpers$1.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
				colorValue :
				helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};
	
	function abstract() {
		throw new Error(
			'This method is not implemented: either no adapter can ' +
			'be found or an incomplete integration was provided.'
		);
	}
	
	/**
	 * Date adapter (current used by the time scale)
	 * @namespace Chart._adapters._date
	 * @memberof Chart._adapters
	 * @private
	 */
	
	/**
	 * Currently supported unit string values.
	 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
	 * @memberof Chart._adapters._date
	 * @name Unit
	 */
	
	/**
	 * @class
	 */
	function DateAdapter(options) {
		this.options = options || {};
	}
	
	helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
		/**
		 * Returns a map of time formats for the supported formatting units defined
		 * in Unit as well as 'datetime' representing a detailed date/time string.
		 * @returns {{string: string}}
		 */
		formats: abstract,
	
		/**
		 * Parses the given `value` and return the associated timestamp.
		 * @param {any} value - the value to parse (usually comes from the data)
		 * @param {string} [format] - the expected data format
		 * @returns {(number|null)}
		 * @function
		 */
		parse: abstract,
	
		/**
		 * Returns the formatted date in the specified `format` for a given `timestamp`.
		 * @param {number} timestamp - the timestamp to format
		 * @param {string} format - the date/time token
		 * @return {string}
		 * @function
		 */
		format: abstract,
	
		/**
		 * Adds the specified `amount` of `unit` to the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {number} amount - the amount to add
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		add: abstract,
	
		/**
		 * Returns the number of `unit` between the given timestamps.
		 * @param {number} max - the input timestamp (reference)
		 * @param {number} min - the timestamp to substract
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		diff: abstract,
	
		/**
		 * Returns start of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
		 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
		 * @function
		 */
		startOf: abstract,
	
		/**
		 * Returns end of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @function
		 */
		endOf: abstract,
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility for scale.getValueForPixel(),
		 * this method should be overridden only by the moment adapter.
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(value) {
			return value;
		}
	});
	
	DateAdapter.override = function(members) {
		helpers$1.extend(DateAdapter.prototype, members);
	};
	
	var _date = DateAdapter;
	
	var core_adapters = {
		_date: _date
	};
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	var core_ticks = {
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {string|string[]} the label to display
			 */
			values: function(value) {
				return helpers$1.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {number} the value to be formatted
			 * @param index {number} the position of the tickValue parameter in the ticks array
			 * @param ticks {number[]} the list of ticks being converted
			 * @return {string} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers$1.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
					if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
						var logTick = helpers$1.log10(Math.abs(tickValue));
						tickString = tickValue.toExponential(Math.floor(logTick) - Math.floor(logDelta));
					} else {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					}
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};
	
	var valueOrDefault$9 = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
	
	core_defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: core_ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	function labelsFromTicks(ticks) {
		var labels = [];
		var i, ilen;
	
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(ticks[i].label);
		}
	
		return labels;
	}
	
	function getPixelForGridLine(scale, index, offsetGridLines) {
		var lineValue = scale.getPixelForTick(index);
	
		if (offsetGridLines) {
			if (scale.getTicks().length === 1) {
				lineValue -= scale.isHorizontal() ?
					Math.max(lineValue - scale.left, scale.right - lineValue) :
					Math.max(lineValue - scale.top, scale.bottom - lineValue);
			} else if (index === 0) {
				lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
			}
		}
		return lineValue;
	}
	
	function computeTextSize(context, tick, font) {
		return helpers$1.isArray(tick) ?
			helpers$1.longestText(context, font, tick) :
			context.measureText(tick).width;
	}
	
	var core_scale = core_element.extend({
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},
	
		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},
	
		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type
	
		mergeTicksOptions: function() {
			var ticks = this.options.ticks;
			if (ticks.minor === false) {
				ticks.minor = {
					display: false
				};
			}
			if (ticks.major === false) {
				ticks.major = {
					display: false
				};
			}
			for (var key in ticks) {
				if (key !== 'major' && key !== 'minor') {
					if (typeof ticks.minor[key] === 'undefined') {
						ticks.minor[key] = ticks[key];
					}
					if (typeof ticks.major[key] === 'undefined') {
						ticks.major[key] = ticks[key];
					}
				}
			}
		},
		beforeUpdate: function() {
			helpers$1.callback(this.options.beforeUpdate, [this]);
		},
	
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var i, ilen, labels, label, ticks, tick;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers$1.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
	
			me._maxLabelLines = 0;
			me.longestLabelWidth = 0;
			me.longestTextCache = me.longestTextCache || {};
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
	
			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();
	
			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.
	
			me.beforeBuildTicks();
	
			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];
	
			// Allow modification of ticks in callback.
			ticks = me.afterBuildTicks(ticks) || ticks;
	
			me.beforeTickToLabelConversion();
	
			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;
	
			me.afterTickToLabelConversion();
	
			me.ticks = labels;   // BACKWARD COMPATIBILITY
	
			// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!
	
			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = labels.length; i < ilen; ++i) {
				label = labels[i];
				tick = ticks[i];
				if (!tick) {
					ticks.push(tick = {
						label: label,
						major: false
					});
				} else {
					tick.label = label;
				}
			}
	
			me._ticks = ticks;
	
			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
	
		},
		afterUpdate: function() {
			helpers$1.callback(this.options.afterUpdate, [this]);
		},
	
		//
	
		beforeSetDimensions: function() {
			helpers$1.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers$1.callback(this.options.afterSetDimensions, [this]);
		},
	
		// Data limits
		beforeDataLimits: function() {
			helpers$1.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers$1.noop,
		afterDataLimits: function() {
			helpers$1.callback(this.options.afterDataLimits, [this]);
		},
	
		//
		beforeBuildTicks: function() {
			helpers$1.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers$1.noop,
		afterBuildTicks: function(ticks) {
			var me = this;
			// ticks is empty for old axis implementations here
			if (helpers$1.isArray(ticks) && ticks.length) {
				return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
			}
			// Support old implementations (that modified `this.ticks` directly in buildTicks)
			me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
			return ticks;
		},
	
		beforeTickToLabelConversion: function() {
			helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
		},
	
		//
	
		beforeCalculateTickRotation: function() {
			helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var context = me.ctx;
			var tickOpts = me.options.ticks;
			var labels = labelsFromTicks(me._ticks);
	
			// Get the width of each grid by calculating the difference
			// between x offsets between 0 and 1.
			var tickFont = helpers$1.options._parseFont(tickOpts);
			context.font = tickFont.string;
	
			var labelRotation = tickOpts.minRotation || 0;
	
			if (labels.length && me.options.display && me.isHorizontal()) {
				var originalLabelWidth = helpers$1.longestText(context, tickFont.string, labels, me.longestTextCache);
				var labelWidth = originalLabelWidth;
				var cosRotation, sinRotation;
	
				// Allow 3 pixels x2 padding either side for label readability
				var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
				// Max label rotation can be set or default to 90 - also act as a loop counter
				while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
					var angleRadians = helpers$1.toRadians(labelRotation);
					cosRotation = Math.cos(angleRadians);
					sinRotation = Math.sin(angleRadians);
	
					if (sinRotation * originalLabelWidth > me.maxHeight) {
						// go back one step
						labelRotation--;
						break;
					}
	
					labelRotation++;
					labelWidth = cosRotation * originalLabelWidth;
				}
			}
	
			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
		},
	
		//
	
		beforeFit: function() {
			helpers$1.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};
	
			var labels = labelsFromTicks(me._ticks);
	
			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = me._isVisible();
			var position = opts.position;
			var isHorizontal = me.isHorizontal();
	
			var parseFont = helpers$1.options._parseFont;
			var tickFont = parseFont(tickOpts);
			var tickMarkLength = opts.gridLines.tickMarkLength;
	
			// Width
			if (isHorizontal) {
				// subtract the margins to line up with the chartArea if we are a full width scale
				minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
			} else {
				minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			}
	
			// height
			if (isHorizontal) {
				minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			} else {
				minSize.height = me.maxHeight; // fill all the height
			}
	
			// Are we showing a title for the scale?
			if (scaleLabelOpts.display && display) {
				var scaleLabelFont = parseFont(scaleLabelOpts);
				var scaleLabelPadding = helpers$1.options.toPadding(scaleLabelOpts.padding);
				var deltaHeight = scaleLabelFont.lineHeight + scaleLabelPadding.height;
	
				if (isHorizontal) {
					minSize.height += deltaHeight;
				} else {
					minSize.width += deltaHeight;
				}
			}
	
			// Don't bother fitting the ticks if we are not showing the labels
			if (tickOpts.display && display) {
				var largestTextWidth = helpers$1.longestText(me.ctx, tickFont.string, labels, me.longestTextCache);
				var tallestLabelHeightInLines = helpers$1.numberOfLabelLines(labels);
				var lineSpace = tickFont.size * 0.5;
				var tickPadding = me.options.ticks.padding;
	
				// Store max number of lines and widest label for _autoSkip
				me._maxLabelLines = tallestLabelHeightInLines;
				me.longestLabelWidth = largestTextWidth;
	
				if (isHorizontal) {
					var angleRadians = helpers$1.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);
	
					// TODO - improve this calculation
					var labelHeight = (sinRotation * largestTextWidth)
						+ (tickFont.lineHeight * tallestLabelHeightInLines)
						+ lineSpace; // padding
	
					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
					me.ctx.font = tickFont.string;
					var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.string);
					var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.string);
					var offsetLeft = me.getPixelForTick(0) - me.left;
					var offsetRight = me.right - me.getPixelForTick(labels.length - 1);
					var paddingLeft, paddingRight;
	
					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (me.labelRotation !== 0) {
						paddingLeft = position === 'bottom' ? (cosRotation * firstLabelWidth) : (cosRotation * lineSpace);
						paddingRight = position === 'bottom' ? (cosRotation * lineSpace) : (cosRotation * lastLabelWidth);
					} else {
						paddingLeft = firstLabelWidth / 2;
						paddingRight = lastLabelWidth / 2;
					}
					me.paddingLeft = Math.max(paddingLeft - offsetLeft, 0) + 3; // add 3 px to move away from canvas edges
					me.paddingRight = Math.max(paddingRight - offsetRight, 0) + 3;
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					if (tickOpts.mirror) {
						largestTextWidth = 0;
					} else {
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						largestTextWidth += tickPadding + lineSpace;
					}
	
					minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);
	
					me.paddingTop = tickFont.size / 2;
					me.paddingBottom = tickFont.size / 2;
				}
			}
	
			me.handleMargins();
	
			me.width = minSize.width;
			me.height = minSize.height;
		},
	
		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
				me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
				me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
			}
		},
	
		afterFit: function() {
			helpers$1.callback(this.options.afterFit, [this]);
		},
	
		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
		isFullWidth: function() {
			return (this.options.fullWidth);
		},
	
		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (helpers$1.isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
				return NaN;
			}
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}
	
			// Value is good, return it
			return rawValue;
		},
	
		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers$1.noop,
	
		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers$1.noop,
	
		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers$1.noop,
	
		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var pixel = (tickWidth * index) + me.paddingLeft;
	
				if (offset) {
					pixel += tickWidth / 2;
				}
	
				var finalVal = me.left + pixel;
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
			return me.top + (index * (innerHeight / (me._ticks.length - 1)));
		},
	
		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
				var finalVal = me.left + valueOffset;
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			return me.top + (decimal * me.height);
		},
	
		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},
	
		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},
	
		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var optionTicks = me.options.ticks.minor;
			var tickCount = ticks.length;
			var skipRatio = false;
			var maxTicks = optionTicks.maxTicksLimit;
	
			// Total space needed to display all ticks. First and last ticks are
			// drawn as their center at end of axis, so tickCount-1
			var ticksLength = me._tickSize() * (tickCount - 1);
	
			// Axis length
			var axisLength = isHorizontal
				? me.width - (me.paddingLeft + me.paddingRight)
				: me.height - (me.paddingTop + me.PaddingBottom);
	
			var result = [];
			var i, tick;
	
			if (ticksLength > axisLength) {
				skipRatio = 1 + Math.floor(ticksLength / axisLength);
			}
	
			// if they defined a max number of optionTicks,
			// increase skipRatio until that number is met
			if (tickCount > maxTicks) {
				skipRatio = Math.max(skipRatio, 1 + Math.floor(tickCount / maxTicks));
			}
	
			for (i = 0; i < tickCount; i++) {
				tick = ticks[i];
	
				if (skipRatio > 1 && i % skipRatio > 0) {
					// leave tick in place but make sure it's not displayed (#4635)
					delete tick.label;
				}
				result.push(tick);
			}
			return result;
		},
	
		/**
		 * @private
		 */
		_tickSize: function() {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var optionTicks = me.options.ticks.minor;
	
			// Calculate space needed by label in axis direction.
			var rot = helpers$1.toRadians(me.labelRotation);
			var cos = Math.abs(Math.cos(rot));
			var sin = Math.abs(Math.sin(rot));
	
			var padding = optionTicks.autoSkipPadding || 0;
			var w = (me.longestLabelWidth + padding) || 0;
	
			var tickFont = helpers$1.options._parseFont(optionTicks);
			var h = (me._maxLabelLines * tickFont.lineHeight + padding) || 0;
	
			// Calculate space needed for 1 tick in axis direction.
			return isHorizontal
				? h * cos > w * sin ? w / cos : h / sin
				: h * sin < w * cos ? h / cos : w / sin;
		},
	
		/**
		 * @private
		 */
		_isVisible: function() {
			var me = this;
			var chart = me.chart;
			var display = me.options.display;
			var i, ilen, meta;
	
			if (display !== 'auto') {
				return !!display;
			}
	
			// When 'auto', the scale is visible if at least one associated dataset is visible.
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
						return true;
					}
				}
			}
	
			return false;
		},
	
		/**
		 * Actually draw the scale on the canvas
		 * @param {object} chartArea - the area of the chart to draw full grid lines on
		 */
		draw: function(chartArea) {
			var me = this;
			var options = me.options;
	
			if (!me._isVisible()) {
				return;
			}
	
			var chart = me.chart;
			var context = me.ctx;
			var globalDefaults = core_defaults.global;
			var defaultFontColor = globalDefaults.defaultFontColor;
			var optionTicks = options.ticks.minor;
			var optionMajorTicks = options.ticks.major || optionTicks;
			var gridLines = options.gridLines;
			var scaleLabel = options.scaleLabel;
			var position = options.position;
	
			var isRotated = me.labelRotation !== 0;
			var isMirrored = optionTicks.mirror;
			var isHorizontal = me.isHorizontal();
	
			var parseFont = helpers$1.options._parseFont;
			var ticks = optionTicks.display && optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
			var tickFontColor = valueOrDefault$9(optionTicks.fontColor, defaultFontColor);
			var tickFont = parseFont(optionTicks);
			var lineHeight = tickFont.lineHeight;
			var majorTickFontColor = valueOrDefault$9(optionMajorTicks.fontColor, defaultFontColor);
			var majorTickFont = parseFont(optionMajorTicks);
			var tickPadding = optionTicks.padding;
			var labelOffset = optionTicks.labelOffset;
	
			var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;
	
			var scaleLabelFontColor = valueOrDefault$9(scaleLabel.fontColor, defaultFontColor);
			var scaleLabelFont = parseFont(scaleLabel);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
			var labelRotationRadians = helpers$1.toRadians(me.labelRotation);
	
			var itemsToDraw = [];
	
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var alignPixel = helpers$1._alignPixel;
			var borderValue, tickStart, tickEnd;
	
			if (position === 'top') {
				borderValue = alignPixel(chart, me.bottom, axisWidth);
				tickStart = me.bottom - tl;
				tickEnd = borderValue - axisWidth / 2;
			} else if (position === 'bottom') {
				borderValue = alignPixel(chart, me.top, axisWidth);
				tickStart = borderValue + axisWidth / 2;
				tickEnd = me.top + tl;
			} else if (position === 'left') {
				borderValue = alignPixel(chart, me.right, axisWidth);
				tickStart = me.right - tl;
				tickEnd = borderValue - axisWidth / 2;
			} else {
				borderValue = alignPixel(chart, me.left, axisWidth);
				tickStart = borderValue + axisWidth / 2;
				tickEnd = me.left + tl;
			}
	
			var epsilon = 0.0000001; // 0.0000001 is margin in pixels for Accumulated error.
	
			helpers$1.each(ticks, function(tick, index) {
				// autoskipper skipped this tick (#4635)
				if (helpers$1.isNullOrUndef(tick.label)) {
					return;
				}
	
				var label = tick.label;
				var lineWidth, lineColor, borderDash, borderDashOffset;
				if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash || [];
					borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
				} else {
					lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, index);
					lineColor = valueAtIndexOrDefault(gridLines.color, index);
					borderDash = gridLines.borderDash || [];
					borderDashOffset = gridLines.borderDashOffset || 0.0;
				}
	
				// Common properties
				var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY, textOffset, textAlign;
				var labelCount = helpers$1.isArray(label) ? label.length : 1;
				var lineValue = getPixelForGridLine(me, index, gridLines.offsetGridLines);
	
				if (isHorizontal) {
					var labelYOffset = tl + tickPadding;
	
					if (lineValue < me.left - epsilon) {
						lineColor = 'rgba(0,0,0,0)';
					}
	
					tx1 = tx2 = x1 = x2 = alignPixel(chart, lineValue, lineWidth);
					ty1 = tickStart;
					ty2 = tickEnd;
					labelX = me.getPixelForTick(index) + labelOffset; // x values for optionTicks (need to consider offsetLabel option)
	
					if (position === 'top') {
						y1 = alignPixel(chart, chartArea.top, axisWidth) + axisWidth / 2;
						y2 = chartArea.bottom;
						textOffset = ((!isRotated ? 0.5 : 1) - labelCount) * lineHeight;
						textAlign = !isRotated ? 'center' : 'left';
						labelY = me.bottom - labelYOffset;
					} else {
						y1 = chartArea.top;
						y2 = alignPixel(chart, chartArea.bottom, axisWidth) - axisWidth / 2;
						textOffset = (!isRotated ? 0.5 : 0) * lineHeight;
						textAlign = !isRotated ? 'center' : 'right';
						labelY = me.top + labelYOffset;
					}
				} else {
					var labelXOffset = (isMirrored ? 0 : tl) + tickPadding;
	
					if (lineValue < me.top - epsilon) {
						lineColor = 'rgba(0,0,0,0)';
					}
	
					tx1 = tickStart;
					tx2 = tickEnd;
					ty1 = ty2 = y1 = y2 = alignPixel(chart, lineValue, lineWidth);
					labelY = me.getPixelForTick(index) + labelOffset;
					textOffset = (1 - labelCount) * lineHeight / 2;
	
					if (position === 'left') {
						x1 = alignPixel(chart, chartArea.left, axisWidth) + axisWidth / 2;
						x2 = chartArea.right;
						textAlign = isMirrored ? 'left' : 'right';
						labelX = me.right - labelXOffset;
					} else {
						x1 = chartArea.left;
						x2 = alignPixel(chart, chartArea.right, axisWidth) - axisWidth / 2;
						textAlign = isMirrored ? 'right' : 'left';
						labelX = me.left + labelXOffset;
					}
				}
	
				itemsToDraw.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					labelX: labelX,
					labelY: labelY,
					glWidth: lineWidth,
					glColor: lineColor,
					glBorderDash: borderDash,
					glBorderDashOffset: borderDashOffset,
					rotation: -1 * labelRotationRadians,
					label: label,
					major: tick.major,
					textOffset: textOffset,
					textAlign: textAlign
				});
			});
	
			// Draw all of the tick labels, tick marks, and grid lines at the correct places
			helpers$1.each(itemsToDraw, function(itemToDraw) {
				var glWidth = itemToDraw.glWidth;
				var glColor = itemToDraw.glColor;
	
				if (gridLines.display && glWidth && glColor) {
					context.save();
					context.lineWidth = glWidth;
					context.strokeStyle = glColor;
					if (context.setLineDash) {
						context.setLineDash(itemToDraw.glBorderDash);
						context.lineDashOffset = itemToDraw.glBorderDashOffset;
					}
	
					context.beginPath();
	
					if (gridLines.drawTicks) {
						context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
						context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
					}
	
					if (gridLines.drawOnChartArea) {
						context.moveTo(itemToDraw.x1, itemToDraw.y1);
						context.lineTo(itemToDraw.x2, itemToDraw.y2);
					}
	
					context.stroke();
					context.restore();
				}
	
				if (optionTicks.display) {
					// Make sure we draw text in the correct color and font
					context.save();
					context.translate(itemToDraw.labelX, itemToDraw.labelY);
					context.rotate(itemToDraw.rotation);
					context.font = itemToDraw.major ? majorTickFont.string : tickFont.string;
					context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
					context.textBaseline = 'middle';
					context.textAlign = itemToDraw.textAlign;
	
					var label = itemToDraw.label;
					var y = itemToDraw.textOffset;
					if (helpers$1.isArray(label)) {
						for (var i = 0; i < label.length; ++i) {
							// We just make sure the multiline element is a string here..
							context.fillText('' + label[i], 0, y);
							y += lineHeight;
						}
					} else {
						context.fillText(label, 0, y);
					}
					context.restore();
				}
			});
	
			if (scaleLabel.display) {
				// Draw the scale label
				var scaleLabelX;
				var scaleLabelY;
				var rotation = 0;
				var halfLineHeight = scaleLabelFont.lineHeight / 2;
	
				if (isHorizontal) {
					scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
					scaleLabelY = position === 'bottom'
						? me.bottom - halfLineHeight - scaleLabelPadding.bottom
						: me.top + halfLineHeight + scaleLabelPadding.top;
				} else {
					var isLeft = position === 'left';
					scaleLabelX = isLeft
						? me.left + halfLineHeight + scaleLabelPadding.top
						: me.right - halfLineHeight - scaleLabelPadding.top;
					scaleLabelY = me.top + ((me.bottom - me.top) / 2);
					rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
				}
	
				context.save();
				context.translate(scaleLabelX, scaleLabelY);
				context.rotate(rotation);
				context.textAlign = 'center';
				context.textBaseline = 'middle';
				context.fillStyle = scaleLabelFontColor; // render in correct colour
				context.font = scaleLabelFont.string;
				context.fillText(scaleLabel.labelString, 0, 0);
				context.restore();
			}
	
			if (axisWidth) {
				// Draw the line at the edge of the axis
				var firstLineWidth = axisWidth;
				var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, ticks.length - 1, 0);
				var x1, x2, y1, y2;
	
				if (isHorizontal) {
					x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
					x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
					y1 = y2 = borderValue;
				} else {
					y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
					y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
					x1 = x2 = borderValue;
				}
	
				context.lineWidth = axisWidth;
				context.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
				context.beginPath();
				context.moveTo(x1, y1);
				context.lineTo(x2, y2);
				context.stroke();
			}
		}
	});
	
	var defaultConfig = {
		position: 'bottom'
	};
	
	var scale_category = core_scale.extend({
		/**
		* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
		* else fall back to data.labels
		* @private
		*/
		getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
		},
	
		determineDataLimits: function() {
			var me = this;
			var labels = me.getLabels();
			me.minIndex = 0;
			me.maxIndex = labels.length - 1;
			var findIndex;
	
			if (me.options.ticks.min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(me.options.ticks.min);
				me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
			}
	
			if (me.options.ticks.max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(me.options.ticks.max);
				me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
			}
	
			me.min = labels[me.minIndex];
			me.max = labels[me.maxIndex];
		},
	
		buildTicks: function() {
			var me = this;
			var labels = me.getLabels();
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var chart = me.chart;
	
			if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
				return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
			}
	
			return me.ticks[index - me.minIndex];
		},
	
		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index) {
			var me = this;
			var offset = me.options.offset;
			// 1 is added because we need the length but we have the indexes
			var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);
	
			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			var valueCategory;
			if (value !== undefined && value !== null) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				var labels = me.getLabels();
				value = valueCategory || value;
				var idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
			}
	
			if (me.isHorizontal()) {
				var valueWidth = me.width / offsetAmt;
				var widthOffset = (valueWidth * (index - me.minIndex));
	
				if (offset) {
					widthOffset += (valueWidth / 2);
				}
	
				return me.left + widthOffset;
			}
			var valueHeight = me.height / offsetAmt;
			var heightOffset = (valueHeight * (index - me.minIndex));
	
			if (offset) {
				heightOffset += (valueHeight / 2);
			}
	
			return me.top + heightOffset;
		},
	
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var offset = me.options.offset;
			var value;
			var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var horz = me.isHorizontal();
			var valueDimension = (horz ? me.width : me.height) / offsetAmt;
	
			pixel -= horz ? me.left : me.top;
	
			if (offset) {
				pixel -= (valueDimension / 2);
			}
	
			if (pixel <= 0) {
				value = 0;
			} else {
				value = Math.round(pixel / valueDimension);
			}
	
			return value + me.minIndex;
		},
	
		getBasePixel: function() {
			return this.bottom;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults = defaultConfig;
	scale_category._defaults = _defaults;
	
	var noop = helpers$1.noop;
	var isNullOrUndef = helpers$1.isNullOrUndef;
	
	/**
	 * Generate a set of linear ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.
	
		var MIN_SPACING = 1e-14;
		var stepSize = generationOptions.stepSize;
		var unit = stepSize || 1;
		var maxNumSpaces = generationOptions.maxTicks - 1;
		var min = generationOptions.min;
		var max = generationOptions.max;
		var precision = generationOptions.precision;
		var rmin = dataRange.min;
		var rmax = dataRange.max;
		var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
		var factor, niceMin, niceMax, numSpaces;
	
		// Beyond MIN_SPACING floating point numbers being to lose precision
		// such that we can't do the math necessary to generate ticks
		if (spacing < MIN_SPACING && isNullOrUndef(min) && isNullOrUndef(max)) {
			return [rmin, rmax];
		}
	
		numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
		if (numSpaces > maxNumSpaces) {
			// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
			spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
		}
	
		if (stepSize || isNullOrUndef(precision)) {
			// If a precision is not specified, calculate factor based on spacing
			factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
		} else {
			// If the user specified a precision, round to that number of decimal places
			factor = Math.pow(10, precision);
			spacing = Math.ceil(spacing * factor) / factor;
		}
	
		niceMin = Math.floor(rmin / spacing) * spacing;
		niceMax = Math.ceil(rmax / spacing) * spacing;
	
		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (stepSize) {
			// If very close to our whole number, use it.
			if (!isNullOrUndef(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
				niceMin = min;
			}
			if (!isNullOrUndef(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
				niceMax = max;
			}
		}
	
		numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}
	
		niceMin = Math.round(niceMin * factor) / factor;
		niceMax = Math.round(niceMax * factor) / factor;
		ticks.push(isNullOrUndef(min) ? niceMin : min);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
		}
		ticks.push(isNullOrUndef(max) ? niceMax : max);
	
		return ticks;
	}
	
	var scale_linearbase = core_scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return core_scale.prototype.getRightValue.call(this, value);
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers$1.sign(me.min);
				var maxSign = helpers$1.sign(me.max);
	
				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}
	
			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}
	
			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}
	
			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}
	
			if (me.min === me.max) {
				me.max++;
	
				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
	
		getTickLimit: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var stepSize = tickOpts.stepSize;
			var maxTicksLimit = tickOpts.maxTicksLimit;
			var maxTicks;
	
			if (stepSize) {
				maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
			} else {
				maxTicks = me._computeTickLimit();
				maxTicksLimit = maxTicksLimit || 11;
			}
	
			if (maxTicksLimit) {
				maxTicks = Math.min(maxTicksLimit, maxTicks);
			}
	
			return maxTicks;
		},
	
		_computeTickLimit: function() {
			return Number.POSITIVE_INFINITY;
		},
	
		handleDirectionalChanges: noop,
	
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);
	
			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				precision: tickOpts.precision,
				stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
	
			me.handleDirectionalChanges();
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				ticks.reverse();
	
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
	
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);
	
			core_scale.prototype.convertTicksToLabels.call(me);
		}
	});
	
	var defaultConfig$1 = {
		position: 'left',
		ticks: {
			callback: core_ticks.formatters.linear
		}
	};
	
	var scale_linear = scale_linearbase.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			var DEFAULT_MIN = 0;
			var DEFAULT_MAX = 1;
	
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}
	
			// First Calculate the range
			me.min = null;
			me.max = null;
	
			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers$1.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}
	
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}
	
			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};
	
				helpers$1.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');
	
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = {
							positiveValues: [],
							negativeValues: []
						};
					}
	
					// Store these per type
					var positiveValues = valuesPerStack[key].positiveValues;
					var negativeValues = valuesPerStack[key].negativeValues;
	
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers$1.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							positiveValues[index] = positiveValues[index] || 0;
							negativeValues[index] = negativeValues[index] || 0;
	
							if (opts.relativePoints) {
								positiveValues[index] = 100;
							} else if (value < 0) {
								negativeValues[index] += value;
							} else {
								positiveValues[index] += value;
							}
						});
					}
				});
	
				helpers$1.each(valuesPerStack, function(valuesForType) {
					var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
					var minVal = helpers$1.min(values);
					var maxVal = helpers$1.max(values);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});
	
			} else {
				helpers$1.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers$1.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}
	
							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
			}
	
			me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			this.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			var me = this;
			var tickFont;
	
			if (me.isHorizontal()) {
				return Math.ceil(me.width / 40);
			}
			tickFont = helpers$1.options._parseFont(me.options.ticks);
			return Math.ceil(me.height / tickFont.lineHeight);
		},
	
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		// Utils
		getPixelForValue: function(value) {
			// This must be called after fit has been run so that
			// this.left, this.top, this.right, and this.bottom have been defined
			var me = this;
			var start = me.start;
	
			var rightValue = +me.getRightValue(value);
			var pixel;
			var range = me.end - start;
	
			if (me.isHorizontal()) {
				pixel = me.left + (me.width / range * (rightValue - start));
			} else {
				pixel = me.bottom - (me.height / range * (rightValue - start));
			}
			return pixel;
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var innerDimension = isHorizontal ? me.width : me.height;
			var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
			return me.start + ((me.end - me.start) * offset);
		},
	
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticksAsNumbers[index]);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$1 = defaultConfig$1;
	scale_linear._defaults = _defaults$1;
	
	var valueOrDefault$a = helpers$1.valueOrDefault;
	
	/**
	 * Generate a set of logarithmic ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks$1(generationOptions, dataRange) {
		var ticks = [];
	
		var tickVal = valueOrDefault$a(generationOptions.min, Math.pow(10, Math.floor(helpers$1.log10(dataRange.min))));
	
		var endExp = Math.floor(helpers$1.log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;
	
		if (tickVal === 0) {
			exp = Math.floor(helpers$1.log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(helpers$1.log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
	
		do {
			ticks.push(tickVal);
	
			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}
	
			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
		var lastTick = valueOrDefault$a(generationOptions.max, tickVal);
		ticks.push(lastTick);
	
		return ticks;
	}
	
	var defaultConfig$2 = {
		position: 'left',
	
		// label settings
		ticks: {
			callback: core_ticks.formatters.logarithmic
		}
	};
	
	// TODO(v3): change this to positiveOrDefault
	function nonNegativeOrDefault(value, defaultValue) {
		return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
	}
	
	var scale_logarithmic = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}
	
			// Calculate Range
			me.min = null;
			me.max = null;
			me.minNotZero = null;
	
			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers$1.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}
	
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}
	
			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};
	
				helpers$1.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');
	
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}
	
						helpers$1.each(dataset.data, function(rawValue, index) {
							var values = valuesPerStack[key];
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}
							values[index] = values[index] || 0;
							values[index] += value;
						});
					}
				});
	
				helpers$1.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers$1.min(valuesForType);
						var maxVal = helpers$1.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					}
				});
	
			} else {
				helpers$1.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers$1.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}
	
							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}
	
							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
	
							if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
								me.minNotZero = value;
							}
						});
					}
				});
			}
	
			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;
	
			me.min = nonNegativeOrDefault(tickOpts.min, me.min);
			me.max = nonNegativeOrDefault(tickOpts.max, me.max);
	
			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(helpers$1.log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(helpers$1.log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(helpers$1.log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(helpers$1.log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(helpers$1.log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
	
		buildTicks: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = !me.isHorizontal();
	
			var generationOptions = {
				min: nonNegativeOrDefault(tickOpts.min),
				max: nonNegativeOrDefault(tickOpts.max)
			};
			var ticks = me.ticks = generateTicks$1(generationOptions, me);
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
	
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();
	
			core_scale.prototype.convertTicksToLabels.call(this);
		},
	
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.tickValues[index]);
		},
	
		/**
		 * Returns the value of the first tick.
		 * @param {number} value - The minimum not zero value.
		 * @return {number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(helpers$1.log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));
	
			return significand * Math.pow(10, exp);
		},
	
		getPixelForValue: function(value) {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = tickOpts.reverse;
			var log10 = helpers$1.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var offset = 0;
			var innerDimension, pixel, start, end, sign;
	
			value = +me.getRightValue(value);
			if (reverse) {
				start = me.end;
				end = me.start;
				sign = -1;
			} else {
				start = me.start;
				end = me.end;
				sign = 1;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				pixel = reverse ? me.right : me.left;
			} else {
				innerDimension = me.height;
				sign *= -1; // invert, since the upper-left corner of the canvas is at pixel (0, 0)
				pixel = reverse ? me.top : me.bottom;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					offset = valueOrDefault$a(tickOpts.fontSize, core_defaults.global.defaultFontSize);
					innerDimension -= offset;
					start = firstTickValue;
				}
				if (value !== 0) {
					offset += innerDimension / (log10(end) - log10(start)) * (log10(value) - log10(start));
				}
				pixel += sign * offset;
			}
			return pixel;
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = tickOpts.reverse;
			var log10 = helpers$1.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var innerDimension, start, end, value;
	
			if (reverse) {
				start = me.end;
				end = me.start;
			} else {
				start = me.start;
				end = me.end;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				value = reverse ? me.right - pixel : pixel - me.left;
			} else {
				innerDimension = me.height;
				value = reverse ? pixel - me.top : me.bottom - pixel;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					var offset = valueOrDefault$a(tickOpts.fontSize, core_defaults.global.defaultFontSize);
					value -= offset;
					innerDimension -= offset;
					start = firstTickValue;
				}
				value *= log10(end) - log10(start);
				value /= innerDimension;
				value = Math.pow(10, log10(start) + value);
			}
			return value;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$2 = defaultConfig$2;
	scale_logarithmic._defaults = _defaults$2;
	
	var valueOrDefault$b = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
	var resolve$7 = helpers$1.options.resolve;
	
	var defaultConfig$3 = {
		display: true,
	
		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',
	
		angleLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		gridLines: {
			circular: false
		},
	
		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,
	
			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',
	
			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,
	
			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,
	
			callback: core_ticks.formatters.linear
		},
	
		pointLabels: {
			// Boolean - if true, show point labels
			display: true,
	
			// Number - Point label font size in pixels
			fontSize: 10,
	
			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};
	
	function getValueCount(scale) {
		var opts = scale.options;
		return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
	}
	
	function getTickBackdropHeight(opts) {
		var tickOpts = opts.ticks;
	
		if (tickOpts.display && opts.display) {
			return valueOrDefault$b(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
		}
		return 0;
	}
	
	function measureLabelSize(ctx, lineHeight, label) {
		if (helpers$1.isArray(label)) {
			return {
				w: helpers$1.longestText(ctx, ctx.font, label),
				h: label.length * lineHeight
			};
		}
	
		return {
			w: ctx.measureText(label).width,
			h: lineHeight
		};
	}
	
	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size,
				end: pos
			};
		}
	
		return {
			start: pos,
			end: pos + size
		};
	}
	
	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
	
		// Right, this is really confusing and there is a lot of maths going on here
		// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		//
		// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		//
		// Solution:
		//
		// We assume the radius of the polygon is half the size of the canvas at first
		// at each index we check if the text overlaps.
		//
		// Where it does, we store that angle and that index.
		//
		// After finding the largest index and angle we calculate how much we need to remove
		// from the shape radius to move the point inwards by that x.
		//
		// We average the left and right distances to get the maximum shape radius that can fit in the box
		// along with labels.
		//
		// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		// on each side, removing that from the size, halving it and adding the left x protrusion width.
		//
		// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		// and position it in the most space efficient manner
		//
		// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
	
		var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
	
		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var furthestLimits = {
			l: 0,
			r: scale.width,
			t: 0,
			b: scale.height - scale.paddingTop
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;
	
		scale.ctx.font = plFont.string;
		scale._pointLabelSizes = [];
	
		var valueCount = getValueCount(scale);
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
			textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i] || '');
			scale._pointLabelSizes[i] = textSize;
	
			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}
	
			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}
	
			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}
	
			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}
	
		scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
	}
	
	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}
	
		return 'right';
	}
	
	function fillText(ctx, text, position, lineHeight) {
		var y = position.y + lineHeight / 2;
		var i, ilen;
	
		if (helpers$1.isArray(text)) {
			for (i = 0, ilen = text.length; i < ilen; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, position.x, y);
		}
	}
	
	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}
	
	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var angleLineOpts = opts.angleLines;
		var gridLineOpts = opts.gridLines;
		var pointLabelOpts = opts.pointLabels;
		var lineWidth = valueOrDefault$b(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$b(angleLineOpts.color, gridLineOpts.color);
		var tickBackdropHeight = getTickBackdropHeight(opts);
	
		ctx.save();
		ctx.lineWidth = lineWidth;
		ctx.strokeStyle = lineColor;
		if (ctx.setLineDash) {
			ctx.setLineDash(resolve$7([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
			ctx.lineDashOffset = resolve$7([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
		}
	
		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	
		// Point Label Font
		var plFont = helpers$1.options._parseFont(pointLabelOpts);
	
		ctx.font = plFont.string;
		ctx.textBaseline = 'middle';
	
		for (var i = getValueCount(scale) - 1; i >= 0; i--) {
			if (angleLineOpts.display && lineWidth && lineColor) {
				var outerPosition = scale.getPointPosition(i, outerDistance);
				ctx.beginPath();
				ctx.moveTo(scale.xCenter, scale.yCenter);
				ctx.lineTo(outerPosition.x, outerPosition.y);
				ctx.stroke();
			}
	
			if (pointLabelOpts.display) {
				// Extra pixels out for some label spacing
				var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
	
				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
				ctx.fillStyle = pointLabelFontColor;
	
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers$1.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.lineHeight);
			}
		}
		ctx.restore();
	}
	
	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		var circular = gridLineOpts.circular;
		var valueCount = getValueCount(scale);
		var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
		var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
		var pointPosition;
	
		if ((!circular && !valueCount) || !lineColor || !lineWidth) {
			return;
		}
	
		ctx.save();
		ctx.strokeStyle = lineColor;
		ctx.lineWidth = lineWidth;
		if (ctx.setLineDash) {
			ctx.setLineDash(gridLineOpts.borderDash || []);
			ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
		}
	
		ctx.beginPath();
		if (circular) {
			// Draw circular arcs between the points
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
		} else {
			// Draw straight lines connecting each index
			pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);
	
			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}
		}
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	}
	
	function numberOrZero(param) {
		return helpers$1.isNumber(param) ? param : 0;
	}
	
	var scale_radialLinear = scale_linearbase.extend({
		setDimensions: function() {
			var me = this;
	
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.paddingTop = getTickBackdropHeight(me.options) / 2;
			me.xCenter = Math.floor(me.width / 2);
			me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
			me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;
	
			helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);
	
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}
	
						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});
	
			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
		},
	
		convertTicksToLabels: function() {
			var me = this;
	
			scale_linearbase.prototype.convertTicksToLabels.call(me);
	
			// Point labels
			me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		fit: function() {
			var me = this;
			var opts = me.options;
	
			if (opts.display && opts.pointLabels.display) {
				fitWithPointLabels(me);
			} else {
				me.setCenterPoint(0, 0, 0, 0);
			}
		},
	
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
	
			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
			me.drawingArea = Math.min(
				Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
	
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;
	
			me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
		},
	
		getIndexAngle: function(index) {
			var angleMultiplier = (Math.PI * 2) / getValueCount(this);
			var startAngle = this.chart.options && this.chart.options.startAngle ?
				this.chart.options.startAngle :
				0;
	
			var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
			// Start from the top instead of right, so remove a quarter of the circle
			return index * angleMultiplier + startAngleRadians;
		},
	
		getDistanceFromCenterForValue: function(value) {
			var me = this;
	
			if (value === null) {
				return 0; // null always in center
			}
	
			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
	
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
				y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
			};
		},
	
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},
	
		getBasePosition: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.getPointPositionForValue(0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},
	
		draw: function() {
			var me = this;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var tickOpts = opts.ticks;
	
			if (opts.display) {
				var ctx = me.ctx;
				var startAngle = this.getIndexAngle(0);
				var tickFont = helpers$1.options._parseFont(tickOpts);
	
				if (opts.angleLines.display || opts.pointLabels.display) {
					drawPointLabels(me);
				}
	
				helpers$1.each(me.ticks, function(label, index) {
					// Don't draw a centre value (if it is minimum)
					if (index > 0 || tickOpts.reverse) {
						var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
						// Draw circular lines around the scale
						if (gridLineOpts.display && index !== 0) {
							drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
						}
	
						if (tickOpts.display) {
							var tickFontColor = valueOrDefault$b(tickOpts.fontColor, core_defaults.global.defaultFontColor);
							ctx.font = tickFont.string;
	
							ctx.save();
							ctx.translate(me.xCenter, me.yCenter);
							ctx.rotate(startAngle);
	
							if (tickOpts.showLabelBackdrop) {
								var labelWidth = ctx.measureText(label).width;
								ctx.fillStyle = tickOpts.backdropColor;
								ctx.fillRect(
									-labelWidth / 2 - tickOpts.backdropPaddingX,
									-yCenterOffset - tickFont.size / 2 - tickOpts.backdropPaddingY,
									labelWidth + tickOpts.backdropPaddingX * 2,
									tickFont.size + tickOpts.backdropPaddingY * 2
								);
							}
	
							ctx.textAlign = 'center';
							ctx.textBaseline = 'middle';
							ctx.fillStyle = tickFontColor;
							ctx.fillText(label, 0, -yCenterOffset);
							ctx.restore();
						}
					}
				});
			}
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$3 = defaultConfig$3;
	scale_radialLinear._defaults = _defaults$3;
	
	var valueOrDefault$c = helpers$1.valueOrDefault;
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
		},
		second: {
			common: true,
			size: 1000,
			steps: [1, 2, 5, 10, 15, 30]
		},
		minute: {
			common: true,
			size: 60000,
			steps: [1, 2, 5, 10, 15, 30]
		},
		hour: {
			common: true,
			size: 3600000,
			steps: [1, 2, 3, 6, 12]
		},
		day: {
			common: true,
			size: 86400000,
			steps: [1, 2, 5]
		},
		week: {
			common: false,
			size: 604800000,
			steps: [1, 2, 3, 4]
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: [1, 2, 3]
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: [1, 2, 3, 4]
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate$1(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	function toTimestamp(scale, input) {
		var adapter = scale._adapter;
		var options = scale.options.time;
		var parser = options.parser;
		var format = parser || options.format;
		var value = input;
	
		if (typeof parser === 'function') {
			value = parser(value);
		}
	
		// Only parse if its not a timestamp already
		if (!helpers$1.isFinite(value)) {
			value = typeof format === 'string'
				? adapter.parse(value, format)
				: adapter.parse(value);
		}
	
		if (value !== null) {
			return +value;
		}
	
		// Labels are in an incompatible format and no `parser` has been provided.
		// The user might still use the deprecated `format` option for parsing.
		if (!parser && typeof format === 'function') {
			value = format(input);
	
			// `format` could return something else than a timestamp, if so, parse it
			if (!helpers$1.isFinite(value)) {
				value = adapter.parse(value);
			}
		}
	
		return value;
	}
	
	function parse(scale, input) {
		if (helpers$1.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = toTimestamp(scale, scale.getRightValue(input));
		if (value === null) {
			return value;
		}
	
		if (options.round) {
			value = +scale._adapter.startOf(value, options.round);
		}
	
		return value;
	}
	
	/**
	 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
	 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
	 */
	function determineStepSize(min, max, unit, capacity) {
		var range = max - min;
		var interval = INTERVALS[unit];
		var milliseconds = interval.size;
		var steps = interval.steps;
		var i, ilen, factor;
	
		if (!steps) {
			return Math.ceil(range / (capacity * milliseconds));
		}
	
		for (i = 0, ilen = steps.length; i < ilen; ++i) {
			factor = steps[i];
			if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
				break;
			}
		}
	
		return factor;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(scale, ticks, minUnit, min, max) {
		var ilen = UNITS.length;
		var i, unit;
	
		for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= ticks.length) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(scale, min, max, capacity) {
		var adapter = scale._adapter;
		var options = scale.options;
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var major = determineMajorUnit(minor);
		var stepSize = valueOrDefault$c(timeOpts.stepSize, timeOpts.unitStepSize);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var majorTicksEnabled = options.ticks.major.enabled;
		var interval = INTERVALS[minor];
		var first = min;
		var last = max;
		var ticks = [];
		var time;
	
		if (!stepSize) {
			stepSize = determineStepSize(min, max, minor, capacity);
		}
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = +adapter.startOf(first, 'isoWeek', weekday);
			last = +adapter.startOf(last, 'isoWeek', weekday);
		}
	
		// Align first/last ticks on unit
		first = +adapter.startOf(first, weekday ? 'day' : minor);
		last = +adapter.startOf(last, weekday ? 'day' : minor);
	
		// Make sure that the last tick include max
		if (last < max) {
			last = +adapter.add(last, 1, minor);
		}
	
		time = first;
	
		if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
			// Align the first tick on the previous `minor` unit aligned on the `major` unit:
			// we first aligned time on the previous `major` unit then add the number of full
			// stepSize there is between first and the previous major time.
			time = +adapter.startOf(time, major);
			time = +adapter.add(time, ~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
		}
	
		for (; time < last; time = +adapter.add(time, stepSize, minor)) {
			ticks.push(+time);
		}
	
		ticks.push(+time);
	
		return ticks;
	}
	
	/**
	 * Returns the start and end offsets from edges in the form of {start, end}
	 * where each value is a relative width to the scale and ranges between 0 and 1.
	 * They add extra margins on the both sides by scaling down the original scale.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var start = 0;
		var end = 0;
		var first, last;
	
		if (options.offset && ticks.length) {
			if (!options.time.min) {
				first = interpolate$1(table, 'time', ticks[0], 'pos');
				if (ticks.length === 1) {
					start = 1 - first;
				} else {
					start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
				}
			}
			if (!options.time.max) {
				last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
				if (ticks.length === 1) {
					end = last;
				} else {
					end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
				}
			}
		}
	
		return {start: start, end: end};
	}
	
	function ticksFromTimestamps(scale, values, majorUnit) {
		var ticks = [];
		var i, ilen, value, major;
	
		for (i = 0, ilen = values.length; i < ilen; ++i) {
			value = values[i];
			major = majorUnit ? value === +scale._adapter.startOf(value, majorUnit) : false;
	
			ticks.push({
				value: value,
				major: major
			});
		}
	
		return ticks;
	}
	
	var defaultConfig$4 = {
		position: 'bottom',
	
		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',
	
		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',
	
		adapters: {},
		time: {
			parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from https://momentjs.com/docs/#/parsing/string-format/
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',
			displayFormats: {}
		},
		ticks: {
			autoSkip: false,
	
			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',
	
			major: {
				enabled: false
			}
		}
	};
	
	var scale_time = core_scale.extend({
		initialize: function() {
			this.mergeTicksOptions();
			core_scale.prototype.initialize.call(this);
		},
	
		update: function() {
			var me = this;
			var options = me.options;
			var time = options.time || (options.time = {});
			var adapter = me._adapter = new core_adapters._date(options.adapters.date);
	
			// DEPRECATIONS: output a message only one time per update
			if (time.format) {
				console.warn('options.time.format is deprecated and replaced by options.time.parser.');
			}
	
			// Backward compatibility: before introducing adapter, `displayFormats` was
			// supposed to contain *all* unit/string pairs but this can't be resolved
			// when loading the scale (adapters are loaded afterward), so let's populate
			// missing formats on update
			helpers$1.mergeIf(time.displayFormats, adapter.formats());
	
			return core_scale.prototype.update.apply(me, arguments);
		},
	
		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return core_scale.prototype.getRightValue.call(this, rawValue);
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var adapter = me._adapter;
			var timeOpts = me.options.time;
			var unit = timeOpts.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp;
			var dataLabels = chart.data.labels || [];
	
			// Convert labels to timestamps
			for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
				labels.push(parse(me, dataLabels[i]));
			}
	
			// Convert data to timestamps
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;
	
					// Let's consider that all data have the same format.
					if (helpers$1.isObject(data[0])) {
						datasets[i] = [];
	
						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(me, data[j]);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						for (j = 0, jlen = labels.length; j < jlen; ++j) {
							timestamps.push(labels[j]);
						}
						datasets[i] = labels.slice(0);
					}
				} else {
					datasets[i] = [];
				}
			}
	
			if (labels.length) {
				// Sort labels **after** data have been converted
				labels = arrayUnique(labels).sort(sorter);
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}
	
			if (timestamps.length) {
				timestamps = arrayUnique(timestamps).sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}
	
			min = parse(me, timeOpts.min) || min;
			max = parse(me, timeOpts.max) || max;
	
			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
			max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
	
			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);
	
			// PRIVATE
			me._horizontal = me.isHorizontal();
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},
	
		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var timeOpts = options.time;
			var timestamps = [];
			var ticks = [];
			var i, ilen, timestamp;
	
			switch (options.ticks.source) {
			case 'data':
				timestamps = me._timestamps.data;
				break;
			case 'labels':
				timestamps = me._timestamps.labels;
				break;
			case 'auto':
			default:
				timestamps = generate(me, min, max, me.getLabelCapacity(min), options);
			}
	
			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}
	
			// Enforce limits with user min/max options
			min = parse(me, timeOpts.min) || min;
			max = parse(me, timeOpts.max) || max;
	
			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}
	
			me.min = min;
			me.max = max;
	
			// PRIVATE
			me._unit = timeOpts.unit || determineUnitForFormatting(me, ticks, timeOpts.minUnit, me.min, me.max);
			me._majorUnit = determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
	
			if (options.ticks.reverse) {
				ticks.reverse();
			}
	
			return ticksFromTimestamps(me, ticks, me._majorUnit);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var adapter = me._adapter;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];
	
			if (helpers$1.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}
			return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
		},
	
		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(time, index, ticks, format) {
			var me = this;
			var adapter = me._adapter;
			var options = me.options;
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var majorTime = +adapter.startOf(time, majorUnit);
			var majorTickOpts = options.ticks.major;
			var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
			var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
			var tickOpts = major ? majorTickOpts : options.ticks.minor;
			var formatter = valueOrDefault$c(tickOpts.callback, tickOpts.userCallback);
	
			return formatter ? formatter(label, index, ticks) : label;
		},
	
		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var isReverse = me.options.ticks.reverse;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? isReverse ? me.right : me.left : isReverse ? me.bottom : me.top;
			var pos = interpolate$1(me._table, 'time', time, 'pos');
			var offset = size * (me._offsets.start + pos) / (me._offsets.start + 1 + me._offsets.end);
	
			return isReverse ? start - offset : start + offset;
		},
	
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;
	
			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}
	
			if (time === null) {
				time = parse(me, value);
			}
	
			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},
	
		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = (size ? (pixel - start) / size : 0) * (me._offsets.start + 1 + me._offsets.start) - me._offsets.end;
			var time = interpolate$1(me._table, 'pos', pos, 'time');
	
			// DEPRECATION, we should return time directly
			return me._adapter._create(time);
		},
	
		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers$1.toRadians(ticksOpts.maxRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = valueOrDefault$c(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
	
			return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
		},
	
		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;
	
			// pick the longest format (milliseconds) for guestimation
			var format = me.options.time.displayFormats.millisecond;
			var exampleLabel = me.tickFormatFunction(exampleTime, 0, [], format);
			var tickLabelWidth = me.getLabelWidth(exampleLabel);
			var innerWidth = me.isHorizontal() ? me.width : me.height;
			var capacity = Math.floor(innerWidth / tickLabelWidth);
	
			return capacity > 0 ? capacity : 1;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$4 = defaultConfig$4;
	scale_time._defaults = _defaults$4;
	
	var scales = {
		category: scale_category,
		linear: scale_linear,
		logarithmic: scale_logarithmic,
		radialLinear: scale_radialLinear,
		time: scale_time
	};
	
	var FORMATS = {
		datetime: 'MMM D, YYYY, h:mm:ss a',
		millisecond: 'h:mm:ss.SSS a',
		second: 'h:mm:ss a',
		minute: 'h:mm a',
		hour: 'hA',
		day: 'MMM D',
		week: 'll',
		month: 'MMM YYYY',
		quarter: '[Q]Q - YYYY',
		year: 'YYYY'
	};
	
	core_adapters._date.override(typeof moment === 'function' ? {
		_id: 'moment', // DEBUG ONLY
	
		formats: function() {
			return FORMATS;
		},
	
		parse: function(value, format) {
			if (typeof value === 'string' && typeof format === 'string') {
				value = moment(value, format);
			} else if (!(value instanceof moment)) {
				value = moment(value);
			}
			return value.isValid() ? value.valueOf() : null;
		},
	
		format: function(time, format) {
			return moment(time).format(format);
		},
	
		add: function(time, amount, unit) {
			return moment(time).add(amount, unit).valueOf();
		},
	
		diff: function(max, min, unit) {
			return moment.duration(moment(max).diff(moment(min))).as(unit);
		},
	
		startOf: function(time, unit, weekday) {
			time = moment(time);
			if (unit === 'isoWeek') {
				return time.isoWeekday(weekday).valueOf();
			}
			return time.startOf(unit).valueOf();
		},
	
		endOf: function(time, unit) {
			return moment(time).endOf(unit).valueOf();
		},
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility with scale.getValueForPixel().
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(time) {
			return moment(time);
		},
	} : {});
	
	core_defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;
	
			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},
	
		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;
	
			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};
	
	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;
	
		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}
	
		if (fill === false || fill === null) {
			return false;
		}
	
		if (fill === true) {
			return 'origin';
		}
	
		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}
	
			if (target === index || target < 0 || target >= count) {
				return false;
			}
	
			return target;
		}
	
		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}
	
	function computeBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;
	
		if (isFinite(fill)) {
			return null;
		}
	
		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).
	
		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePosition) {
			target = scale.getBasePosition();
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}
	
		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}
	
			if (helpers$1.isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}
	
		return null;
	}
	
	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;
	
		if (!propagate) {
			return fill;
		}
	
		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}
	
			target = sources[fill];
			if (!target) {
				return false;
			}
	
			if (target.visible) {
				return fill;
			}
	
			visited.push(fill);
			fill = target.fill;
		}
	
		return false;
	}
	
	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';
	
		if (fill === false) {
			return null;
		}
	
		if (!isFinite(fill)) {
			type = 'boundary';
		}
	
		return mappers[type](source);
	}
	
	function isDrawable(point) {
		return point && !point.skip;
	}
	
	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i;
	
		if (!len0 || !len1) {
			return;
		}
	
		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}
	
		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}
	
	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1;
	
		ctx.beginPath();
	
		for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);
	
			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}
	
		drawArea(ctx, curve0, curve1, len0, len1);
	
		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}
	
	var plugin_filler = {
		id: 'filler',
	
		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;
	
			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;
	
				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}
	
				meta.$filler = source;
				sources.push(source);
			}
	
			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}
	
				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},
	
		beforeDatasetDraw: function(chart, args) {
			var meta = args.meta.$filler;
			if (!meta) {
				return;
			}
	
			var ctx = chart.ctx;
			var el = meta.el;
			var view = el._view;
			var points = el._children || [];
			var mapper = meta.mapper;
			var color = view.backgroundColor || core_defaults.global.defaultColor;
	
			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	};
	
	var noop$1 = helpers$1.noop;
	var valueOrDefault$d = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
			onLeave: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers$1.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers$1.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		},
	
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
			for (var i = 0; i < chart.data.datasets.length; i++) {
				text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
				if (chart.data.datasets[i].label) {
					text.push(chart.data.datasets[i].label);
				}
				text.push('</li>');
			}
			text.push('</ul>');
			return text.join('');
		}
	});
	
	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param {object} labelopts - the label options on the legend
	 * @param {number} fontSize - the label font size
	 * @return {number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
			fontSize :
			labelOpts.boxWidth;
	}
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Legend = core_element.extend({
	
		initialize: function(config) {
			helpers$1.extend(this, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			this.legendHitBoxes = [];
	
			/**
	 		 * @private
	 		 */
			this._hoveredItem = null;
	
			// Are we in doughnut mode which has a different data type
			this.doughnutMode = false;
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type
	
		beforeUpdate: noop$1,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
		},
		afterUpdate: noop$1,
	
		//
	
		beforeSetDimensions: noop$1,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$1,
	
		//
	
		beforeBuildLabels: noop$1,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}
	
			if (me.options.reverse) {
				legendItems.reverse();
			}
	
			me.legendItems = legendItems;
		},
		afterBuildLabels: noop$1,
	
		//
	
		beforeFit: noop$1,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;
	
			var ctx = me.ctx;
	
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
	
			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];
	
			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();
	
			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}
	
			// Increase sizes here
			if (display) {
				ctx.font = labelFont.string;
	
				if (isHorizontal) {
					// Labels
	
					// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
					var lineWidths = me.lineWidths = [0];
					var totalHeight = 0;
	
					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';
	
					helpers$1.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
						if (i === 0 || lineWidths[lineWidths.length - 1] + width + labelOpts.padding > minSize.width) {
							totalHeight += fontSize + labelOpts.padding;
							lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = labelOpts.padding;
						}
	
						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: width,
							height: fontSize
						};
	
						lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
					});
	
					minSize.height += totalHeight;
	
				} else {
					var vPadding = labelOpts.padding;
					var columnWidths = me.columnWidths = [];
					var totalWidth = labelOpts.padding;
					var currentColWidth = 0;
					var currentColHeight = 0;
					var itemHeight = fontSize + vPadding;
	
					helpers$1.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
						// If too tall, go to new column
						if (i > 0 && currentColHeight + itemHeight > minSize.height - vPadding) {
							totalWidth += currentColWidth + labelOpts.padding;
							columnWidths.push(currentColWidth); // previous column width
	
							currentColWidth = 0;
							currentColHeight = 0;
						}
	
						// Get max width
						currentColWidth = Math.max(currentColWidth, itemWidth);
						currentColHeight += itemHeight;
	
						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: itemWidth,
							height: fontSize
						};
					});
	
					totalWidth += currentColWidth;
					columnWidths.push(currentColWidth);
					minSize.width += totalWidth;
				}
			}
	
			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop$1,
	
		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
	
		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor;
			var lineDefault = globalDefaults.elements.line;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;
	
			if (opts.display) {
				var ctx = me.ctx;
				var fontColor = valueOrDefault$d(labelOpts.fontColor, globalDefaults.defaultFontColor);
				var labelFont = helpers$1.options._parseFont(labelOpts);
				var fontSize = labelFont.size;
				var cursor;
	
				// Canvas setup
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
				ctx.lineWidth = 0.5;
				ctx.strokeStyle = fontColor; // for strikethrough effect
				ctx.fillStyle = fontColor; // render in correct colour
				ctx.font = labelFont.string;
	
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var hitboxes = me.legendHitBoxes;
	
				// current position
				var drawLegendBox = function(x, y, legendItem) {
					if (isNaN(boxWidth) || boxWidth <= 0) {
						return;
					}
	
					// Set the ctx for the box
					ctx.save();
	
					var lineWidth = valueOrDefault$d(legendItem.lineWidth, lineDefault.borderWidth);
					ctx.fillStyle = valueOrDefault$d(legendItem.fillStyle, defaultColor);
					ctx.lineCap = valueOrDefault$d(legendItem.lineCap, lineDefault.borderCapStyle);
					ctx.lineDashOffset = valueOrDefault$d(legendItem.lineDashOffset, lineDefault.borderDashOffset);
					ctx.lineJoin = valueOrDefault$d(legendItem.lineJoin, lineDefault.borderJoinStyle);
					ctx.lineWidth = lineWidth;
					ctx.strokeStyle = valueOrDefault$d(legendItem.strokeStyle, defaultColor);
	
					if (ctx.setLineDash) {
						// IE 9 and 10 do not support line dash
						ctx.setLineDash(valueOrDefault$d(legendItem.lineDash, lineDefault.borderDash));
					}
	
					if (opts.labels && opts.labels.usePointStyle) {
						// Recalculate x and y for drawPoint() because its expecting
						// x and y to be center of figure (instead of top left)
						var radius = boxWidth * Math.SQRT2 / 2;
						var centerX = x + boxWidth / 2;
						var centerY = y + fontSize / 2;
	
						// Draw pointStyle as legend symbol
						helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
					} else {
						// Draw box as legend symbol
						if (lineWidth !== 0) {
							ctx.strokeRect(x, y, boxWidth, fontSize);
						}
						ctx.fillRect(x, y, boxWidth, fontSize);
					}
	
					ctx.restore();
				};
				var fillText = function(x, y, legendItem, textWidth) {
					var halfFontSize = fontSize / 2;
					var xLeft = boxWidth + halfFontSize + x;
					var yMiddle = y + halfFontSize;
	
					ctx.fillText(legendItem.text, xLeft, yMiddle);
	
					if (legendItem.hidden) {
						// Strikethrough the text if hidden
						ctx.beginPath();
						ctx.lineWidth = 2;
						ctx.moveTo(xLeft, yMiddle);
						ctx.lineTo(xLeft + textWidth, yMiddle);
						ctx.stroke();
					}
				};
	
				// Horizontal
				var isHorizontal = me.isHorizontal();
				if (isHorizontal) {
					cursor = {
						x: me.left + ((legendWidth - lineWidths[0]) / 2) + labelOpts.padding,
						y: me.top + labelOpts.padding,
						line: 0
					};
				} else {
					cursor = {
						x: me.left + labelOpts.padding,
						y: me.top + labelOpts.padding,
						line: 0
					};
				}
	
				var itemHeight = fontSize + labelOpts.padding;
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var textWidth = ctx.measureText(legendItem.text).width;
					var width = boxWidth + (fontSize / 2) + textWidth;
					var x = cursor.x;
					var y = cursor.y;
	
					// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
					// instead of me.right and me.bottom because me.width and me.height
					// may have been changed since me.minSize was calculated
					if (isHorizontal) {
						if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
							y = cursor.y += itemHeight;
							cursor.line++;
							x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2) + labelOpts.padding;
						}
					} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
						x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
						y = cursor.y = me.top + labelOpts.padding;
						cursor.line++;
					}
	
					drawLegendBox(x, y, legendItem);
	
					hitboxes[i].left = x;
					hitboxes[i].top = y;
	
					// Fill the actual label
					fillText(x, y, legendItem, textWidth);
	
					if (isHorizontal) {
						cursor.x += width + labelOpts.padding;
					} else {
						cursor.y += itemHeight;
					}
	
				});
			}
		},
	
		/**
		 * @private
		 */
		_getLegendItemAt: function(x, y) {
			var me = this;
			var i, hitBox, lh;
	
			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				lh = me.legendHitBoxes;
				for (i = 0; i < lh.length; ++i) {
					hitBox = lh[i];
	
					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						return me.legendItems[i];
					}
				}
			}
	
			return null;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var hoveredItem;
	
			if (type === 'mousemove') {
				if (!opts.onHover && !opts.onLeave) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}
	
			// Chart event already has relative position in it
			hoveredItem = me._getLegendItemAt(e.x, e.y);
	
			if (type === 'click') {
				if (hoveredItem && opts.onClick) {
					// use e.native for backwards compatibility
					opts.onClick.call(me, e.native, hoveredItem);
				}
			} else {
				if (opts.onLeave && hoveredItem !== me._hoveredItem) {
					if (me._hoveredItem) {
						opts.onLeave.call(me, e.native, me._hoveredItem);
					}
					me._hoveredItem = hoveredItem;
				}
	
				if (opts.onHover && hoveredItem) {
					// use e.native for backwards compatibility
					opts.onHover.call(me, e.native, hoveredItem);
				}
			}
		}
	});
	
	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, legend, legendOpts);
		core_layouts.addBox(chart, legend);
		chart.legend = legend;
	}
	
	var plugin_legend = {
		id: 'legend',
	
		/**
		 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
		 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Legend,
	
		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;
	
			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;
	
			if (legendOpts) {
				helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
	
				if (legend) {
					core_layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				core_layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},
	
		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
	
	var noop$2 = helpers$1.noop;
	
	core_defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Title = core_element.extend({
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
	
		beforeUpdate: noop$2,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
	
		},
		afterUpdate: noop$2,
	
		//
	
		beforeSetDimensions: noop$2,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$2,
	
		//
	
		beforeBuildLabels: noop$2,
		buildLabels: noop$2,
		afterBuildLabels: noop$2,
	
		//
	
		beforeFit: noop$2,
		fit: function() {
			var me = this;
			var opts = me.options;
			var display = opts.display;
			var minSize = me.minSize;
			var lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
			var fontOpts = helpers$1.options._parseFont(opts);
			var textSize = display ? (lineCount * fontOpts.lineHeight) + (opts.padding * 2) : 0;
	
			if (me.isHorizontal()) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = textSize;
			} else {
				minSize.width = textSize;
				minSize.height = me.maxHeight; // fill all the height
			}
	
			me.width = minSize.width;
			me.height = minSize.height;
	
		},
		afterFit: noop$2,
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
	
		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
	
			if (opts.display) {
				var fontOpts = helpers$1.options._parseFont(opts);
				var lineHeight = fontOpts.lineHeight;
				var offset = lineHeight / 2 + opts.padding;
				var rotation = 0;
				var top = me.top;
				var left = me.left;
				var bottom = me.bottom;
				var right = me.right;
				var maxWidth, titleX, titleY;
	
				ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
				ctx.font = fontOpts.string;
	
				// Horizontal
				if (me.isHorizontal()) {
					titleX = left + ((right - left) / 2); // midpoint of the width
					titleY = top + offset;
					maxWidth = right - left;
				} else {
					titleX = opts.position === 'left' ? left + offset : right - offset;
					titleY = top + ((bottom - top) / 2);
					maxWidth = bottom - top;
					rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
				}
	
				ctx.save();
				ctx.translate(titleX, titleY);
				ctx.rotate(rotation);
				ctx.textAlign = 'center';
				ctx.textBaseline = 'middle';
	
				var text = opts.text;
				if (helpers$1.isArray(text)) {
					var y = 0;
					for (var i = 0; i < text.length; ++i) {
						ctx.fillText(text[i], 0, y, maxWidth);
						y += lineHeight;
					}
				} else {
					ctx.fillText(text, 0, 0, maxWidth);
				}
	
				ctx.restore();
			}
		}
	});
	
	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, title, titleOpts);
		core_layouts.addBox(chart, title);
		chart.titleBlock = title;
	}
	
	var plugin_title = {
		id: 'title',
	
		/**
		 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
		 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Title,
	
		beforeInit: function(chart) {
			var titleOpts = chart.options.title;
	
			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;
	
			if (titleOpts) {
				helpers$1.mergeIf(titleOpts, core_defaults.global.title);
	
				if (titleBlock) {
					core_layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				core_layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
	
	var plugins = {};
	var filler = plugin_filler;
	var legend = plugin_legend;
	var title = plugin_title;
	plugins.filler = filler;
	plugins.legend = legend;
	plugins.title = title;
	
	/**
	 * @namespace Chart
	 */
	
	
	core_controller.helpers = helpers$1;
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	core_helpers(core_controller);
	
	core_controller._adapters = core_adapters;
	core_controller.Animation = core_animation;
	core_controller.animationService = core_animations;
	core_controller.controllers = controllers;
	core_controller.DatasetController = core_datasetController;
	core_controller.defaults = core_defaults;
	core_controller.Element = core_element;
	core_controller.elements = elements;
	core_controller.Interaction = core_interaction;
	core_controller.layouts = core_layouts;
	core_controller.platform = platform;
	core_controller.plugins = core_plugins;
	core_controller.Scale = core_scale;
	core_controller.scaleService = core_scaleService;
	core_controller.Ticks = core_ticks;
	core_controller.Tooltip = core_tooltip;
	
	// Register built-in scales
	
	core_controller.helpers.each(scales, function(scale, type) {
		core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
	});
	
	// Load to register built-in adapters (as side effects)
	
	
	// Loading built-in plugins
	
	for (var k in plugins) {
		if (plugins.hasOwnProperty(k)) {
			core_controller.plugins.register(plugins[k]);
		}
	}
	
	core_controller.platform.initialize();
	
	var src = core_controller;
	if (typeof window !== 'undefined') {
		window.Chart = core_controller;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Chart
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Chart = core_controller;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Legend
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Legend = plugins.legend._element;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Title
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Title = plugins.title._element;
	
	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.pluginService = core_controller.plugins;
	
	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.PluginBase = core_controller.Element.extend({});
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.canvasHelpers = core_controller.helpers.canvas;
	
	/**
	 * Provided for backward compatibility, use Chart.layouts instead.
	 * @namespace Chart.layoutService
	 * @deprecated since version 2.7.3
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.layoutService = core_controller.layouts;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.LinearScaleBase
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.LinearScaleBase = scale_linearbase;
	
	/**
	 * Provided for backward compatibility, instead we should create a new Chart
	 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	core_controller.helpers.each(
		[
			'Bar',
			'Bubble',
			'Doughnut',
			'Line',
			'PolarArea',
			'Radar',
			'Scatter'
		],
		function(klass) {
			core_controller[klass] = function(ctx, cfg) {
				return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
					type: klass.charAt(0).toLowerCase() + klass.slice(1)
				}));
			};
		}
	);
	
	return src;
	
	})));


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	function startOfUTCISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	var _index4 = __webpack_require__(66);
	function startOfUTCWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 103 */
/***/ function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
		Doctype: "doctype",
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cardiac.cc9f6ba3.svg";

/***/ },
/* 105 */
/***/ function(module, exports) {

	module.exports = [
		{
			"id": 16,
			"dept_id": 16,
			"department_name": "Birth Certificate",
			"department_desc_one": "<p>ABOUT THE DEPARTMENT</p><p><strong>The Best Cardiologist in Dhaka, Bangladesh</strong></p><p>United Hospital has the best cardiologists in Dhaka, Bangladesh providing specialized inpatient and outpatient heart care and long term management of the conditions. We offer the latest techniques and cardiac care to patients of all ages. We treat patients with common heart problems such as angina to rare heart conditions.</p><p>With the help of State-of-the-heart-technology, equipment and monitoring devices, our cardiologists are providing excellent heart care to all the patients. Our department has the best cardiologists and heart specialists in Dhaka, who are highly specialized and has years of experience and expertise in cardiac care.</p><p>Our cardiologists provide 24 hour dedicated service and is the only hospital of Bangladesh where emergency angioplasty can be carried out round the clock. It is operated by a strong and dedicated team of 4 cardiologists â€“ Consultants Dr. N. A. M. Momenuzzaman, Dr. Kaisar Nasrullah Khan, Dr. Fatema Begum Dr. Reyan Anis and Dr. A. M. Shafique. With the help of their extensive knowledge and supreme clinical practices, we are well efficient to treat the significant procedures, the best heart specialists in the heart of the Country, Dhaka. United Hospital is holding the pride of having the best cardiologist in Dhaka, Bangladesh.</p><p>The Cardiology division of United Cardiac Center has modern electro-medical equipments and appliances which include 3 catheterization laboratories including the most advanced Azurion Cathlab, Cardio Neuro iGS 520 Hybrid Cathlab and a 20 bed Coronary Care Unit (CCU) with specially managed CCU unit dedicated for COVID patients to carry out all necessary procedures related to diagnostic &amp; interventional cardiology.</p><p>In addition to this, we have a 15 bedded Cardiac High Dependency Unit (CHDU) and an 8 bedded Post Cath Section.</p><p><br></p><p><img src=\"https://www.uhlbd.com/administrator/uploads/images/Cardiac%20Advt-Final_Output%281%29.png\"></p>",
			"department_desc_two": "<h2><br></h2><h2>CARDIAC INVESTIGATION CONDUCTED AT OUR HOSPITAL ARE:</h2><p><br></p><ul><li>ECG</li><li>ECHO (2D-M Mode/ Colour Doppler)</li><li>HOLTER ECG</li><li>TRANSESOPHAGEAL ECHO</li><li>DOBUTAMINE INDUCED ECHO</li><li>TEE</li><li>ETT</li><li>CAG (Coronary Angiogram)</li><li>USG</li><li>CT Angio</li><li>24 Hours Ambulatory BP</li><li>24 Hours Monitoring</li><li>X-Ray Chest P/A View</li><li>Lipid Profile</li></ul>",
			"department_desc_three": "<h2>THE FOLLOWING PROCEDURES ARE DONE BY OUR CARDIOLOGY TEAM:</h2><p><br></p><ul><li>CAG&nbsp;&nbsp;&nbsp;: Coronary Angiography</li><li>PTCA&nbsp;: Percutaneous Transluminal Coronary Angioplasty / Stenting</li><li>PTMC&nbsp;: Percutaneous Transluminal Mitral Comissurectomy</li><li>TPMI&nbsp;&nbsp;&nbsp;: Temporary Pace Maker Installation</li><li>PPMI&nbsp;&nbsp;&nbsp;: Permanent Pace Maker Installation</li><li>CRT&nbsp;&nbsp;&nbsp;&nbsp;: Cardiac Resynchronization Device</li><li>ICD or AICD : Implantable Cardioverter-Defibrillator or Automated Implantable Cardioverter-Defibrillator C.Cath Coil Embolisation</li><li>ASD&nbsp;&nbsp;&nbsp;&nbsp;: Atrial Septal Defect V. Plasty</li><li>TAVI&nbsp;&nbsp;&nbsp;&nbsp;: Transcathether aortic valve implantation</li><li>PV&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: Pulmonary Valvoplasty</li><li>Pace Maker Implementation</li></ul>",
			"department_desc_four": "<h2>AN OVERALL GLANCE AT OUR STATE-OF-THE-ART FACILITIES</h2><p><br></p><ul><li>3 Catheterization Laboratories (Cath Labs) including one state-of-the-art Azurion Cathlab and one Cardio Neuro iGS 520 Hybrid Cathlab</li><li>20 Bed Coronary Care Unit/CCU</li><li>15 Bed Cardiac High Dependency Unit/CHDU</li><li>3 Cardiac Operation Theatres</li><li>24 Bed Cardiac ICU and Step-down CICU</li></ul>",
			"department_desc_five": "<h2>CONSULTATION &amp; APPOINTMENT</h2><p><br></p><p>Cardiology Department provides consultation services in (OPD - 4) at 1st Floor through highly qualified, experienced and one of the best Cardiologists in Dhaka, Bangladesh. Call 10666 or 02 22 22 62 466 Extension 8114 and 8115) for appointment with one of the best Cardiologists in Dhaka, Bangladesh.</p><p><br></p><p><br></p>",
			"image": "202302281007heart.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 1,
			"slug": "birth-certificate",
			"img": "life-image-1.png"
		},
		{
			"id": 31,
			"dept_id": 31,
			"department_name": "Death Certificate",
			"department_desc_one": "<p>A comprehensive Dental Centre became operational at United Hospital on 29th April 2012. The Dental Centre has been set up with the aim to provide an international standard dental treatment facility to satisfy and meet the demands of our community.</p><p>Our dentists Dr Md. Nazrul Islam and Dr Lutfun Nahar both completed their Masters from National University of Singapore and have a 5-years working experience in Singapore.</p><p><br></p>",
			"department_desc_two": "<h2>OUR SERVICES INCLUDE</h2><p><br></p><ul><li>Scaling and polishing</li><li>Tooth color restoration</li><li>Dental implants</li><li>Implant over denture</li><li>Complete denture</li><li>Full mouth rehabilitation</li><li>Cosmetic filling</li><li>Dental crown and bridge</li><li>Teeth whitening</li><li>Root canal</li><li>Smile makeover</li><li>Dental CT Scan</li><li>Dental clearance for cancer patients</li></ul>",
			"department_desc_three": "<h2>DENTAL IMPLANT-YOUR 2ND PERMANENT TOOTH</h2><p><br></p><p>Missing or lost teeth is nothing to laugh about as it can change your smile forever. When a tooth is lost, its opposite tooth becomes inactive as it requires two opposite teeth to bite. So loosing teeth doesnâ€™t only change your smile but it also compromises your functionality as well. But now we can bring back missing teeth with dental implants.</p><p>Dental Implants are small titanium screws that allow bone to grow in and around it. They are inserted in the jaw bone to mimic the teeth root and in due time an artificial tooth is attached with it to replace the missing tooth. Then the treatment is finished and the new tooth on implant looks and works just like a natural tooth. For patients who have no teeth, with the help of implants, we can restore full functional set of teeth for them. The functionality and appearance of implant supported tooth is as good as any natural tooth. So if you have any missing tooth, dental implants can be your 2nd permanent tooth.</p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202302281004dental.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "death-certificate",
			"img": "life-image-2.png"
		},
		{
			"id": 54,
			"dept_id": 54,
			"department_name": "Day Care",
			"department_desc_one": "<p>Clinical Hematology Department looks after people with problems in their blood. This includes leukemia, some forms of anemia (like Sickle Cell) and congenital (from birth) diseases like thalassaemia and hemophilia. Problems seen in Clinical Hematology include</p><ul><li>Thalassaemia - a genetic problem with the blood</li><li>Bone marrow failure syndromes such as aplastic anemia</li><li>Blood cancers such as leukemias, lymphomas (cancer affecting lymph nodes) and multiple myeloma</li><li>Bleeding disorders like hemophilia and platelet related disorders</li></ul><p><strong>&nbsp;<u>Management of disorders of the blood and bone marrow</u></strong></p><ul><li>Anemia and other red blood cell disorders e.g. iron deficiency anemia, sickle cell anemia and thalassemia</li><li>Conditions in which the blood fails to clot properly or where patients have an increased tendency to form clots e.g. hemophilia</li><li>White blood cell disorders including neutropenia and leukocytosis</li><li>Platelet disorders e.g. thrombocytopenia (ITP and TTP) and thrombocytosis</li><li>Bone marrow disorders in which too many blood cells are produced e.g. polycythemia vera, thrombocythemia, chronic myelogenous leukemia</li><li>Bone marrow failure disorders e.g. aplastic anemia and myelodysplasia</li><li>Iron metabolism disorders e.g. hemochromatosis and porphyria.</li><li>Management of taking anticoagulant medications such as warfarin, low molecular weight heparin and anti-platelet agents&nbsp;</li><li>Expert supervision of Consultant Clinical Hematology</li><li>Provision of Bone Marrow Aspiration Study</li><li>Facility for Plasma Aphaeresis</li><li>24/7 Blood Bank Support</li></ul><p><br></p>",
			"department_desc_two": "<h2>HEMOPHILIA</h2><p><br></p><p>Hemophilia is a genetic disease mainly in boys. There is a gene that does not make the clotting factor properly. So, the boys bleed very easily from very small accidents. They also bleed into muscles and joints eg knees and elbows. Treatment: The clotting factors can be injected into patients to stop the problem. Care is given for all these problems for patients with hemophilia. The hematologists look after the blood problem. They also work with the Orthopedic surgeons and physical medicine and rehabilitation doctors for the muscle and joint problems. The muscle and joint bleeds cause pain and stop people using their arms and legs properly.</p><p><br></p>",
			"department_desc_three": "<h2>THALASSEMIA</h2><p><br></p><p>Thalassemia is a genetic disease. The child is born with a gene that makes bad hemoglobin. Patients start getting problems as a child.</p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202303010540blood-tube.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "day-care",
			"img": "life-image-3.png"
		},
		{
			"id": 56,
			"dept_id": 56,
			"department_name": "Discharge Paper",
			"department_desc_one": "<p>Prevention is better than cure.The outpatient department offers various tailor-made health screening packages designed to provide an overall comprehensive health check, to detect potential problems, and suggest changes in lifestyle which may reduce the risk of serious illness. Included in this health screening is the completion of a detailed questionnaire, a medical examination by a doctor or consultant and a wide range of tests (depending on the choice of package, age group and other factors).&nbsp;A full written confidential report by the screening doctor, after having reviewed all the results,&nbsp;is given to the patient. The report will include details of consultation and test results together with recommendations for personal well-being and advice on lifestyle to help improve&nbsp;health and reduce risk of illness.</p><p>The department provides consultation services in&nbsp;<strong>Executive Health Screening Department</strong>&nbsp;(1st&nbsp;Floor) through highly qualified and experienced Consultant.</p><p><span style=\"background-color: transparent; color: rgb(51, 122, 183);\">View Health Check List</span></p><p><br></p><h2>PRE-RAMADAN HEALTH CHECKUP</h2><p><br></p><p><a href=\"https://www.uhlbd.com/backend/web/post_uploads/1615302884ramadan.jpg\" rel=\"noopener noreferrer\" target=\"_blank\" style=\"background-color: transparent; color: rgb(51, 122, 183);\"><img src=\"https://www.uhlbd.com/backend/web/post_uploads/thumb/1615302884ramadan.jpg\"></a></p><p><br></p><h2>HEALTH ASSESSMENT &amp; FITNESS PACKAGE</h2><p><br></p><p><a href=\"https://www.uhlbd.com/backend/web/post_uploads/1476351091Health%20Assessment%20&amp;%20Fitness%20Package.jpg\" rel=\"noopener noreferrer\" target=\"_blank\" style=\"background-color: transparent; color: rgb(51, 122, 183);\"><img src=\"https://www.uhlbd.com/backend/web/post_uploads/thumb/1476351091Health%20Assessment%20&amp;%20Fitness%20Package.jpg\"></a></p><p><br></p><h2>NUTRITIONAL HEALTH SCREENING PACKAGE</h2><p><br></p><p><a href=\"https://www.uhlbd.com/backend/web/post_uploads/1476351198Nutritional%20Health%20Screening%20Package.jpg\" rel=\"noopener noreferrer\" target=\"_blank\" style=\"background-color: transparent; color: inherit;\"><img src=\"https://www.uhlbd.com/backend/web/post_uploads/thumb/1476351198Nutritional%20Health%20Screening%20Package.jpg\"></a></p>",
			"department_desc_two": "<p><br></p>",
			"department_desc_three": "<p><br></p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202303010514x-ray.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 1,
			"slug": "discharge-protocols",
			"img": "life-image-4.png"
		},
		{
			"id": 33,
			"dept_id": 33,
			"department_name": "Investigation",
			"department_desc_one": "<p><strong>What is a Balanced Diet?</strong></p><p>A balanced diet is a diet containing adequate energy and all essential nutrients that cannot be synthesized in sufficient quantities by the body, in amounts adequate for growth, energy needs, nitrogen equilibrium, repair and maintenance of normal health.</p><p><br></p>",
			"department_desc_two": "<h2>NUTRITIONAL HEALTH SCREENING PACKAGE</h2><p><br></p><p><img src=\"data:image/jpeg;base64,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\"></p><p><br></p>",
			"department_desc_three": "<h2>HEALTH ASSESSMENT &amp; FITNESS PACKAGE</h2><p><br></p><p><img src=\"https://www.uhlbd.com/backend/web/post_uploads/thumb/1476351796Health%20Assessment%20&amp;%20Fitness%20Package.jpg\"></p><p><br></p>",
			"department_desc_four": "<h2>OUR SERVICES</h2><p><br></p><p>A team of dedicated and committed dieticians ensuring individual attention. Our services include nutrition assessment, planning and prescription, following counseling for different diseased conditions, including:</p><ul><li>Cardiac Nutrition therapy</li><li>Cancer nutritional status assessment, dietary management after chemotherapy, radiation and surgery</li><li>Nutritional care before and after dialysis</li><li>Nutritional assessment of patients who are on enteral feeding</li><li>Nutritional plan for Partial Parental nutrition (PPN) and Total Parenteral Nutrition (TPN)</li><li>Special therapeutic diets planned for diabetic patients</li><li>Special therapeutic diets planned for hypertension and other diseased conditions</li><li>Hepatic Diet (Diet plan for patients with Jaundice, Cirrhosis, Hepatic</li><li>Carcinoma etc.)</li><li>Malnution</li><li>Pediatric diet according to age and physiological condition</li><li>Diet for children and adolescent diseases</li><li>Diet for patients suffering from allergies</li><li>Diet for inborn metabolic disorders</li><li>Low Purine Diet</li><li>Balanced Diet for pregnant and lactating mother &amp; gestational diabetics&nbsp;&nbsp;&nbsp;</li><li>Sodium restricted diet plan often used in treating hypertension, edema, heart, kidney and liver diseases</li><li>Diet plan for hyperthyrodism and hypothyrodism</li><li>Diet plan for gastroenteritis</li><li>Diet plan for PEG (pencutameoms emdoscopic gastrostomy) tube feeding</li><li>Weight Reducing Diet</li><li>Weight Improving Diet&nbsp;</li></ul><p>&nbsp;</p>",
			"department_desc_five": "<p><br></p>",
			"image": "202304020419plan.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "investigation",
			"img": "life-image-1.png"
		},
		{
			"id": 35,
			"dept_id": 35,
			"department_name": "Telemedicine",
			"department_desc_one": "<p>The Emergency Medicine Department of United Hospital is a 24-hour, full time section and it is the mirror of United Hospital. It offers the highest degree of commitment to delivering quality and efficient emergency care. Prompt and rapid response of our skilled medical personnel defines our Emergency Medicine Unit. This is where very critically ill and injured patients are received and managed.</p><p><br></p><p><br></p><p><img src=\"https://www.uhlbd.com/administrator/uploads/images/1.2.jpg\"> <img src=\"https://www.uhlbd.com/administrator/uploads/images/2%281%29.jpg\"></p><p><img src=\"https://www.uhlbd.com/administrator/uploads/images/3%283%29.jpg\">&nbsp;<img src=\"https://www.uhlbd.com/administrator/uploads/images/5%281%29.jpg\"></p><p><img src=\"https://www.uhlbd.com/administrator/uploads/images/9.jpg\">&nbsp;<img src=\"https://www.uhlbd.com/administrator/uploads/images/11.jpg\"></p><p><img src=\"https://www.uhlbd.com/administrator/uploads/images/10.jpg\">&nbsp;<img src=\"https://www.uhlbd.com/administrator/uploads/images/8%281%29.jpg\"></p><p><img src=\"https://www.uhlbd.com/administrator/uploads/images/12.jpg\"><img src=\"https://www.uhlbd.com/administrator/uploads/images/6%281%29.jpg\"></p><p><img src=\"https://www.uhlbd.com/administrator/uploads/images/4%20%282%29.jpg\"><img src=\"https://www.uhlbd.com/administrator/uploads/images/7.jpg\"></p>",
			"department_desc_two": "<h2>AMBULANCE SERVICE</h2><p><br></p><p><strong>The Cardiac Ambulance is always accompanied by</strong></p><p>Specialist ,&nbsp;Nurse,&nbsp;PCA&nbsp;</p><p><strong>The Normal Ambulance is always accompanied by&nbsp;</strong></p><p>Nurse,&nbsp;PCA</p><p><span style=\"color: rgb(255, 0, 0);\">for any emergency need, please call&nbsp;</span><strong style=\"color: rgb(255, 0, 0);\">01914001234; 01914001232</strong></p><p><br></p>",
			"department_desc_three": "<h2>AMBULANCE</h2><p><br></p><p><img src=\"https://www.uhlbd.com/backend/web/post_uploads/medium/1457609835IMG_2432%202.jpg\"> <img src=\"https://www.uhlbd.com/backend/web/post_uploads/medium/1457612727Ambulance_resize.jpg\"></p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202303010523first-aid-box.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "telemedicine",
			"img": "life-image-2.png"
		},
		{
			"id": 36,
			"dept_id": 36,
			"department_name": "Mortuary",
			"department_desc_one": "<p><strong>Diabetes &amp; Endocrinology Department&nbsp;</strong>provides state of the art medical care to individuals with endocrine disorders. Our skilled team of highly trained physicians, physician's assistants, dietitians and a diabetes specialist is dedicated to providing outstanding medical care in areas including:</p><ul><li>Diabetes Treatment and Management</li><li>Thyroid Disorders</li><li>Pituitary Disorders</li><li>Adrenal Disorders</li><li>Osteoporosis</li><li>Cholesterol Disorders</li><li>Gonadal Disorders</li></ul><p>Through individualized treatment programs and emphasis on patient education, our physicians and staff are committed to providing patients with the knowledge necessary to play an active role in assuring their own well being.</p><p>The department provides consultation services in&nbsp;<strong>OPD-3</strong>&nbsp;through highly qualified and experienced Consultant.</p>",
			"department_desc_two": "<p><br></p>",
			"department_desc_three": "<p><br></p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202303010526sugar-blood-level.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "mortuary",
			"img": "life-image-3.png"
		},
		{
			"id": 38,
			"dept_id": 38,
			"department_name": "Pharmacy",
			"department_desc_one": "<p><strong>ENT &amp; Head Neck Surgery Department</strong></p><p>United Hospital's Department of ENT &amp; Head Neck Surgery consists of experienced Surgeons including Anesthetists who are available to provide you the best possible service in Bangladesh. Our team is committed to improving the quality of life of our patients.</p><p>The focus of the department is to provide each and every patient with the care that they deserve to improve and maintain their life style.</p><p>We have highly sophisticated, state of the art surgical equipments &amp; instruments ensuring patient's safety in surgical procedures in a safe environment.</p><p><br></p>",
			"department_desc_two": "<h2>THE DEPARTMENT OF ENT &amp; HEAD NECK SURGERY PROVIDES THE FOLLOWING SERVICES:</h2><p><br></p><p>Diagnostic Facilities For</p><ul><li>Nasal bleeding</li><li>Hearing Loss</li><li>Vertigo</li><li>Snoring &amp; Sleep Apnea (Both Adult &amp; Child)</li><li>Headache</li><li>Early voice change</li><li>Early stage of cancer</li><li>All types of ENT diseases, diagnosis and treatments</li></ul>",
			"department_desc_three": "<h2>EAR</h2><p><br></p><p>We provide medical and surgical treatment for</p><ul><li>Middle-ear infections</li><li>External ear-canal inflammation (swimmerâ€™s ear)</li><li>Tinnitus (ringing in the ear)</li><li>Wax build up</li><li>Perforated eardrum</li><li>Hearing loss</li><li>Balance problem</li><li>Cholesteatomas (invasive ear cysts)</li><li>Obstruction by foreign bodies</li><li>Ear trauma or injury</li></ul>",
			"department_desc_four": "<h2>NOSE</h2><p><br></p><p>Our care of the nasal cavity encompasses</p><ul><li>Allergy treatment</li><li>Endoscopic and open sinus surgery to treat sinus infections</li><li>Surgical correction of deviated or perforated septum</li><li>Functional or cosmetic rhinoplasty</li><li>Nasal turbinate surgery to reduce nasal bones blocking the airway</li><li>Surgical correction of choanal atresia (congenital blockage of the nasal passage)</li><li>Removal of nasal polyps, benign &amp; malignant tumors and foreign bodies</li><li>Repair of nasal trauma or fracture</li></ul>",
			"department_desc_five": "<h2>THROAT</h2><p><br></p><p>Our expertise in the throat area extends from the tongue to larynx (voice box) to the oesophagus. We evaluate and treat voice and swallowing problems, frequent or persistent sore throat or cough, gastroesophageal reflux disease, breathing difficulties and sleep disorders.</p>",
			"image": "202302281420sore-throat.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "pharmacy",
			"img": "life-image-4.png"
		},
		{
			"id": 48,
			"dept_id": 48,
			"department_name": "Vaccination",
			"department_desc_one": "<p><strong>ANESTHESIOLOGY</strong></p><p>The anesthesiologists on staff at United Hospital provide anesthesia services for inpatient and outpatient surgery as well as for non-surgical diagnostic and therapeutic procedures. Other services include obstetric pain relief, and treatment of acute and chronic pain. Anesthesia service is available around the clock, seven days a week.&nbsp;Our anesthesiologists use the latest technology and proven techniques to maximize your comfort and safetyâ€”before, during, and after your procedure. They are exceptionally dedicated to the highest standards of their specialty.</p><p><br></p>",
			"department_desc_two": "<h2>FACILITIES</h2><p><br></p><p>Your anesthesiologist will fully explain your anesthesia options and outline the pros and cons of each approach.He or she will work with your surgeon to develop a individualized pre-op to post-op plan to:</p><ul><li>Anticipate any medical problems that could arise during surgery</li><li>Keep you pain-free through your surgery</li><li>Relieve anxiety</li><li>Control your body's reaction to stress</li><li>Minimize side effects</li><li>Make your recovery easier</li></ul><p>In addition to administering anesthetic during your procedure, your anesthesiologist will monitor your vital body functions, such as breathing, blood oxygen saturation, blood pressure, heart rate, and kidney functions. After surgery your anesthesiologist will closely monitor you for any problems related to your anesthetic and order pain medication as your condition allows.</p>",
			"department_desc_three": "<p><br></p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202304020429injection.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "vaccination",
			"img": "life-image-1.png"
		},
		{
			"id": 48,
			"dept_id": 48,
			"department_name": "Home Sample Collection",
			"department_desc_one": "<p><strong>ANESTHESIOLOGY</strong></p><p>The anesthesiologists on staff at United Hospital provide anesthesia services for inpatient and outpatient surgery as well as for non-surgical diagnostic and therapeutic procedures. Other services include obstetric pain relief, and treatment of acute and chronic pain. Anesthesia service is available around the clock, seven days a week.&nbsp;Our anesthesiologists use the latest technology and proven techniques to maximize your comfort and safetyâ€”before, during, and after your procedure. They are exceptionally dedicated to the highest standards of their specialty.</p><p><br></p>",
			"department_desc_two": "<h2>FACILITIES</h2><p><br></p><p>Your anesthesiologist will fully explain your anesthesia options and outline the pros and cons of each approach.He or she will work with your surgeon to develop a individualized pre-op to post-op plan to:</p><ul><li>Anticipate any medical problems that could arise during surgery</li><li>Keep you pain-free through your surgery</li><li>Relieve anxiety</li><li>Control your body's reaction to stress</li><li>Minimize side effects</li><li>Make your recovery easier</li></ul><p>In addition to administering anesthetic during your procedure, your anesthesiologist will monitor your vital body functions, such as breathing, blood oxygen saturation, blood pressure, heart rate, and kidney functions. After surgery your anesthesiologist will closely monitor you for any problems related to your anesthetic and order pain medication as your condition allows.</p>",
			"department_desc_three": "<p><br></p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202304020429injection.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "home-sample-collection",
			"img": "life-image-1.png"
		}
	];

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkSpecKeys = exports.checkNavigable = exports.changeSlide = exports.canUseDOM = exports.canGoNext = void 0;
	exports.clamp = clamp;
	exports.swipeStart = exports.swipeMove = exports.swipeEnd = exports.slidesOnRight = exports.slidesOnLeft = exports.slideHandler = exports.siblingDirection = exports.safePreventDefault = exports.lazyStartIndex = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.keyHandler = exports.initializedState = exports.getWidth = exports.getTrackLeft = exports.getTrackCSS = exports.getTrackAnimateCSS = exports.getTotalSlides = exports.getSwipeDirection = exports.getSlideCount = exports.getRequiredLazySlides = exports.getPreClones = exports.getPostClones = exports.getOnDemandLazySlides = exports.getNavigableIndexes = exports.getHeight = exports.extractObject = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function clamp(number, lowerBound, upperBound) {
	  return Math.max(lowerBound, Math.min(number, upperBound));
	}
	
	var safePreventDefault = function safePreventDefault(event) {
	  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];
	
	  if (!passiveEvents.includes(event._reactName)) {
	    event.preventDefault();
	  }
	};
	
	exports.safePreventDefault = safePreventDefault;
	
	var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	
	  return onDemandSlides;
	}; // return list of slides that need to be present
	
	
	exports.getOnDemandLazySlides = getOnDemandLazySlides;
	
	var getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	
	  return requiredSlides;
	}; // startIndex that needs to be present
	
	
	exports.getRequiredLazySlides = getRequiredLazySlides;
	
	var lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	
	exports.lazyStartIndex = lazyStartIndex;
	
	var lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	
	exports.lazyEndIndex = lazyEndIndex;
	
	var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	
	exports.lazySlidesOnLeft = lazySlidesOnLeft;
	
	var lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	}; // get width of an element
	
	
	exports.lazySlidesOnRight = lazySlidesOnRight;
	
	var getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	
	exports.getWidth = getWidth;
	
	var getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	
	exports.getHeight = getHeight;
	
	var getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	}; // whether or not we can go next
	
	
	exports.getSwipeDirection = getSwipeDirection;
	
	var canGoNext = function canGoNext(spec) {
	  var canGo = true;
	
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	
	  return canGo;
	}; // given an object and a list of keys, return new object with given keys
	
	
	exports.canGoNext = canGoNext;
	
	var extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	}; // get initialized state
	
	
	exports.extractObject = extractObject;
	
	var initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react["default"].Children.count(spec.children);
	
	  var listNode = spec.listRef;
	  var listWidth = Math.ceil(getWidth(listNode));
	  var trackNode = spec.trackRef && spec.trackRef.node;
	  var trackWidth = Math.ceil(getWidth(trackNode));
	  var slideWidth;
	
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	
	  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }));
	  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	exports.initializedState = initializedState;
	
	var slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	  var lazyLoadedList = spec.lazyLoadedList;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide,
	      animationLeft,
	      finalLeft;
	  var state = {},
	      nextState = {};
	  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);
	
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList = lazyLoadedList.concat(animationSlide);
	    }
	
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList,
	      targetSlide: animationSlide
	    };
	    nextState = {
	      animating: false,
	      targetSlide: animationSlide
	    };
	  } else {
	    finalSlide = animationSlide;
	
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	
	    if (!infinite && animationSlide + slidesToShow >= slideCount) {
	      finalSlide = slideCount - slidesToShow;
	    }
	
	    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: finalSlide
	    }));
	
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	
	    if (lazyLoad) {
	      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	        currentSlide: animationSlide
	      })));
	    }
	
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        swipeLeft: null,
	        targetSlide: targetSlide
	      };
	    }
	  }
	
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	
	exports.slideHandler = slideHandler;
	
	var changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      previousTargetSlide = spec.targetSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	
	    if (!infinite) {
	      targetSlide = previousTargetSlide - slidesToScroll;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	
	    if (!infinite) {
	      targetSlide = previousTargetSlide + slidesToScroll;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
	        targetSlide: targetSlide
	      }));
	
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	  }
	
	  return targetSlide;
	};
	
	exports.changeSlide = changeSlide;
	
	var keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	exports.keyHandler = keyHandler;
	
	var swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && safePreventDefault(e);
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	
	exports.swipeStart = swipeStart;
	
	var swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return safePreventDefault(e);
	  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
	  var swipeLeft,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	
	  if (!infinite) {
	    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	
	  state = _objectSpread(_objectSpread({}, state), {}, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: swipeLeft
	    }))
	  });
	
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    safePreventDefault(e);
	  }
	
	  return state;
	};
	
	exports.swipeMove = swipeMove;
	
	var swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe,
	      targetSlide = spec.targetSlide,
	      currentSlide = spec.currentSlide,
	      infinite = spec.infinite;
	
	  if (!dragging) {
	    if (swipe) safePreventDefault(e);
	    return {};
	  }
	
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
	
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	
	  if (scrolling) {
	    return state;
	  }
	
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > minSwipe) {
	    safePreventDefault(e);
	
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	
	    var slideCount, newSlide;
	    var activeSlide = infinite ? currentSlide : targetSlide;
	
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = activeSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	
	      case "right":
	      case "down":
	        newSlide = activeSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	
	      default:
	        slideCount = activeSlide;
	    }
	
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: currentLeft
	    }));
	  }
	
	  return state;
	};
	
	exports.swipeEnd = swipeEnd;
	
	var getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	
	  return indexes;
	};
	
	exports.getNavigableIndexes = getNavigableIndexes;
	
	var checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	
	      prevNavigable = navigables[n];
	    }
	  }
	
	  return index;
	};
	
	exports.checkNavigable = checkNavigable;
	
	var getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	    var slickList = spec.listRef;
	    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	exports.getSlideCount = getSlideCount;
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	exports.checkSpecKeys = checkSpecKeys;
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread(_objectSpread({}, style), {}, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight; // Fallback for IE8
	
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined
	
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	
	var getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    } // shift current slide to center of the frame
	
	
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = trackRef && trackRef.node;
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	exports.getTrackLeft = getTrackLeft;
	
	var getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	exports.getPreClones = getPreClones;
	
	var getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  return spec.slideCount;
	};
	
	exports.getPostClones = getPostClones;
	
	var getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	
	exports.getTotalSlides = getTotalSlides;
	
	var siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	
	    return "left";
	  }
	};
	
	exports.siblingDirection = siblingDirection;
	
	var slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	
	  if (rtl) {
	    return 0;
	  }
	
	  return slidesToShow - 1;
	};
	
	exports.slidesOnRight = slidesOnRight;
	
	var slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	
	  return 0;
	};
	
	exports.slidesOnLeft = slidesOnLeft;
	
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	
	exports.canUseDOM = canUseDOM;

/***/ },
/* 107 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAB1CAYAAABwBK68AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAVSSURBVHhe7Zhhjtw2DEbTo+UqOcn+7W3aE/QauUu73eQL8A0ULWVLlkiRNh/wUKTr8dh8lj0zXz6S25FRb8htov7//Z9fvv/99sv//vx6a3meEiGjMh5P8N9vfzxWKWyIqFyFTw/YEnMpcR01Q/aLWRF3UTPkNcvV6iZqxpzTVdSMuU6yLWrGXC/ZEjVj6khMo+I7lXQw6RqJWdRcnfoS9ah4dkoHkK6XqEbN262tRC1qBrWXqETN5+ceyfKoGXSfZFnU/DFhv2RZ1Ay6X7Ikagb1IZmOmkH9SKai5tcWX5LLUTOoP8mlqPnTn0/JpajSDtP9kuGoedv1KxmKmkF9S4aiSjtK/Ui6o+Yq9S/piurp0y5+7KDvf729XPUjiPb+NSVdUXefEIeMi+sMRpD2c6T2/i0kp1F333YxwKv0DF97/5YSt1F7V84ZrcGv2j/2gX1J72EtOYy6K+jZ6sEgsQ2Gif/Cs0Dl4Hv2z/e4sv9dEndRWwPHUHsGdxQMr4cSK/aPv0mvsZI0o+IkpRdq2hrYlWEdDb9m5f53rljSjGq9SlsraGZIPWGvBKXS/ncsBkqaUaUXaSoNaMVVfxR2JiiVLsZdYYkY1XqVSoNfMXCKIdes3L90/Dtuw8Rl1JUDh/Vq0lhJ9YWzY7USMar0Ak1rpG1mRVgMWmvY0m1Y2k5T8inq3VappfVqtb4Fk4y60Dqq9bmQT1GljTWtkbY5k7fW3ReExbP7SBI+ar3SrQdZW+IiqvWtF5aMDkH6cAJ2rtiSjPqT0SEcsStsjbSNluS3qNaf1mDJSFRse8aOsCUuVqq0obY10ja19XMU4P9JoXd9rQCPjVoG6llZraD4W+sZW+9D0/LC6jmflZJXVOurqhQxelaUFLQ+bims9bnhOK3vEJC8ou74kDTiSKyj1XxniVlUREGEq0ocrYZVYWePu1ZzFROTqNKAZ+kJhCHW9IaV7gwr0QhLQkbtDQOlsD0DlV63kvBRV171I0Fh672PhqodFPuX3ndWYvpBCYOcVdrvmXhdTWuwUlBcSPVxzCi97wrJK6rmm3lQegTUYVtBy208Sx4TFUphGS16UEjcRcVwMUyt45HizQbFsfK4pb9biGMgrqJiKCWWYUtG4tTHvCus26j1sPFvabtZywHUjESR9pNRK6UhWYYdDSKxa45uo8L6dga0rv7yvUbfw/I4e8RXUuIuKpSeeTsHVustKHQfFXoN6/W4QkQtnxElOwcoBdV65o9aHpvbqNBTWM9BYYnrqNBDWO9BYYn7qFQarHZYzCRC0PJ5CsJEhZYD9nCH6DV0VGgRNlJQWBMuKtQMGy0orAkZFWLIEjPn0dqn56D1rReEjQpXho0YFN4uKlwRNmpQKBE+KpyJEjmotErBLaLCK3Far4kyC+kDI7hNVDgSNnpQ2OJWUWFP2NYVHmkGrVsvuF1UiHORQNjWd9xo53/ELaPCVtiaVT9aWHq0SsFto8KzsBGDwjNuHZVKt1zpw1MEz1YpeERUWIaNGhT28JioEDEjn2fPKgWPihpZ9Oklowaxd5WCjBrAkaAgowZwlIzqXOnr2BkZ1bGjt12SUZ16NSjIqA5FixkyqkNnyajOvPLBqCajOnJFUJBRnbgqKMioDlwZFGTUza4OCjLqJjFvLTLqBjWDgoxq7MwvRb1kVCMxX43np0RGNdBidZZkVEUtV2dJRlVyR0ySURdrfauVyKgL3HWbbfGKioOSDjht6y0myaiDIiRusR5jkldUgIOVTuTpRghZ8ltU8PSwCBgtYs2nqAAng5PiCd5RnB/F+UYNKCFGTWKTUW/Hx8cP4oRF5yT24nEAAAAASUVORK5CYII="

/***/ },
/* 108 */
/***/ function(module, exports) {

	function _getPrototypeOf(t) {
	  return (module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
	    return t.__proto__ || Object.getPrototypeOf(t);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _getPrototypeOf(t);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(58)["default"];
	var assertThisInitialized = __webpack_require__(22);
	function _possibleConstructorReturn(t, e) {
	  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
	  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
	  return assertThisInitialized(t);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AxiosError = __webpack_require__(80);
	var utils = __webpack_require__(44);
	
	/**
	 * A `CanceledError` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function CanceledError(message) {
	  // eslint-disable-next-line no-eq-null,eqeqeq
	  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
	  this.name = 'CanceledError';
	}
	
	utils.inherits(CanceledError, AxiosError, {
	  __CANCEL__: true
	});
	
	module.exports = CanceledError;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _newlogo = __webpack_require__(453);
	
	var _newlogo2 = _interopRequireDefault(_newlogo);
	
	var _iconsRotate = __webpack_require__(107);
	
	var _iconsRotate2 = _interopRequireDefault(_iconsRotate);
	
	var _hotline_phone = __webpack_require__(117);
	
	var _hotline_phone2 = _interopRequireDefault(_hotline_phone);
	
	var _PopupIndex = __webpack_require__(84);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _PopupIndex3 = __webpack_require__(144);
	
	var _PopupIndex4 = _interopRequireDefault(_PopupIndex3);
	
	var _PopupIndex5 = __webpack_require__(65);
	
	var _PopupIndex6 = _interopRequireDefault(_PopupIndex5);
	
	var _PopupIndex7 = __webpack_require__(70);
	
	var _PopupIndex8 = _interopRequireDefault(_PopupIndex7);
	
	var _PopupPatientLists = __webpack_require__(145);
	
	var _PopupPatientLists2 = _interopRequireDefault(_PopupPatientLists);
	
	var _PopupRegister = __webpack_require__(97);
	
	var _PopupRegister2 = _interopRequireDefault(_PopupRegister);
	
	__webpack_require__(155);
	
	var _CollapsibleButton = __webpack_require__(139);
	
	var _CollapsibleButton2 = _interopRequireDefault(_CollapsibleButton);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _MyProvider = __webpack_require__(48);
	
	var _PatientRegistrationPopup = __webpack_require__(113);
	
	var _PatientRegistrationPopup2 = _interopRequireDefault(_PatientRegistrationPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GetAllMenu = function GetAllMenu(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/menu/getallmenu", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getDefaultSearch = function getDefaultSearch(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/homesetting/getdefaultsearchdata", {
	      method: "get",
	      headers: {
	        Accept: "application/json"
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSearchData = function getSearchData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/homesetting/getsearchdata", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleHeaderAnnoucementData = function getSingleHeaderAnnoucementData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/headerannoucement/getsingleheaderannoucement/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var HeaderHome = function (_Component) {
	  _inherits(HeaderHome, _Component);
	
	  function HeaderHome() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HeaderHome);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderHome.__proto__ || Object.getPrototypeOf(HeaderHome)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      step: 1,
	      showthirdpopup: "",
	      menu: [],
	      search_keywords: "",
	      default_doctors: [],
	      default_packages: [],
	      default_publications: [],
	      header_annoucement_text: "",
	      header_annoucement_link: "",
	      header_phone_no: "",
	      patientRegPopup: false,
	      showPatientRegPopup: ""
	    }, _this.handleOpenPatientRegisterPopUp = function () {
	      // $(".register_popup").addClass("show");
	      // $(".register_popup").css("visibility", "visible");
	      // $(".modal-backdrop.fade.show").remove();
	      // $("body").css("overflow", "");
	      // $("body").css("padding-right", "");
	
	      _this.setState({
	        patientRegPopup: true,
	        showPatientRegPopup: "offcanvas offcanvas-start show"
	      });
	    }, _this.nextStep = function (e) {
	      _this.setState({ step: _this.state.step + 1 });
	    }, _this.prevStep = function (e) {
	      _this.setState({
	        step: _this.state.step - 1,
	        showthirdpopup: "offcanvas offcanvas-start show"
	      });
	    }, _this.refreshStaticMenu = function (page) {
	      GetAllMenu(page).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ menu: records });
	        } else {
	          _this.setState({ menu: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshGetDefaultSearchData = function () {
	      getDefaultSearch().then(function (res) {
	        if (res.status === true) {
	          _this.setState({
	            default_doctors: res.doctor_data,
	            default_packages: res.package_data,
	            default_publications: res.publication_data,
	            default_departments: res.department_data
	          });
	        } else {
	          _this.setState({
	            default_doctors: "",
	            default_packages: "",
	            default_publications: ""
	          });
	        }
	      }).catch(function (err) {});
	    }, _this.handleKeyUp = function (event) {
	      var data = {
	        keywords: _this.state.search_keywords
	      };
	      getSearchData(data).then(function (res) {
	        if (res.status === true) {
	          _this.setState({
	            default_doctors: res.doctor_data,
	            default_packages: res.package_data,
	            default_publications: res.publication_data,
	            default_departments: res.department_data
	          });
	        } else {
	          _this.setState({
	            default_doctors: "",
	            default_packages: "",
	            default_publications: ""
	          });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.showSearchResult = function () {
	      (0, _jquery2.default)(".search-popup").show();
	      (0, _jquery2.default)("body").click(function () {
	        (0, _jquery2.default)(".search-popup").hide();
	      });
	      _this.refreshGetDefaultSearchData();
	    }, _this.refreshgetSingleHeaderAnnoucementData = function (id) {
	      getSingleHeaderAnnoucementData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            header_annoucement_text: records.header_annoucement_text,
	            header_annoucement_link: records.header_annoucement_link,
	            header_phone_no: records.header_phone_no
	          });
	        } else {
	          _this.setState({
	            header_annoucement_text: "",
	            header_annoucement_link: "",
	            header_phone_no: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(HeaderHome, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var header_annoucement_id = "1";
	      // this.refreshgetSingleHeaderAnnoucementData(header_annoucement_id);
	      /*if(localStorage.getItem(USER_ID)){
	        let login_step_number = this.state.step + 1;
	        this.setState({
	          step: login_step_number + 1,
	          showthirdpopup: 'offcanvas offcanvas-start',
	        });
	      } else {
	        this.setState({
	          step: this.state.step,
	          showthirdpopup: 'offcanvas offcanvas-start show',
	        });
	      }*/
	
	      if (localStorage.getItem(_constants.USER_ID)) {
	        var login_step_number = this.state.step + 1;
	        this.setState({
	          step: login_step_number,
	          showthirdpopup: "offcanvas offcanvas-start"
	        });
	      } else {
	        this.setState({
	          step: this.state.step,
	          showthirdpopup: "offcanvas offcanvas-start show"
	        });
	      }
	      this.refreshStaticMenu();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var patient_user_id = localStorage.getItem(_constants.USER_ID);
	      var UserName = localStorage.getItem("patient_name");
	      var cart = localStorage.getItem("totalAmount");
	      // console.log(user)
	      var step_html = "";
	      var step = this.state.step;
	      if (step === 1) {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 1" },
	                _react2.default.createElement(_PopupIndex6.default, {
	                  nextStep: this.nextStep,
	                  prevStep: this.prevStep
	                })
	              )
	            )
	          )
	        );
	        /*} else if (step === 2) {
	            step_html = <div className="">
	              <div className="container">
	                <div className="row">
	                  <div className="col-md-6 col-sm-3 custom-margin 2">
	                    <PopupPatientLists nextStep={this.nextStep} prevStep={this.prevStep} />
	                  </div>
	                </div>
	              </div>
	          </div>*/
	      } else if (step === 2) {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 3" },
	                _react2.default.createElement(_PopupIndex2.default, {
	                  nextStep: this.nextStep,
	                  showpopup: this.state.showthirdpopup
	                })
	              )
	            )
	          )
	        );
	      } else if (step === 3) {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 4" },
	                _react2.default.createElement(_PopupIndex4.default, {
	                  nextStep: this.nextStep,
	                  prevStep: this.prevStep
	                })
	              )
	            )
	          )
	        );
	      } else if (step === 4) {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 5" },
	                _react2.default.createElement(_PopupIndex8.default, null)
	              )
	            )
	          )
	        );
	      } else if (step === 5) {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 5" },
	                _react2.default.createElement(_PopupRegister2.default, null)
	              )
	            )
	          )
	        );
	        // }
	        // else if (this.state.patientRegPopup) {
	        //   step_html = (
	        //     <div className="">
	        //       <div className="container">
	        //         <div className="row">
	        //           <div className="col-md-6 col-sm-3 custom-margin 5">
	        //             <PopupRegister />
	        //           </div>
	        //         </div>
	        //       </div>
	        //     </div>
	        //   );
	      } else {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 5" },
	                _react2.default.createElement(_PopupRegister2.default, null)
	              )
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.header_annoucement_text ? _react2.default.createElement(
	          "header",
	          { className: "top-part" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  href: this.state.header_annoucement_link,
	                  target: "_blank",
	                  style: { color: "#fff", textDecoration: "none" }
	                },
	                this.state.header_annoucement_text
	              )
	            )
	          )
	        ) : "",
	        _react2.default.createElement(
	          "div",
	          { className: "text-light p-2 ", style: { backgroundColor: "#187979" } },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-8 top-header d-md-flex d-sm-inline d-xs-inline",
	                  style: {
	                    display: "flex",
	                    rowGap: "20px",
	                    columnGap: "20px",
	                    justifyContent: "flex-start"
	                  }
	                },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "tel:10666",
	                    style: {
	                      color: "#ffff",
	                      textDecoration: "none"
	                    }
	                  },
	                  _react2.default.createElement("i", { className: "fa fa-phone", style: { marginRight: "5px" } }),
	                  "10666"
	                ),
	                _react2.default.createElement("br", { className: "d-lg-none" }),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "tel:+8801914001234",
	                    style: {
	                      color: "#ffff",
	                      textDecoration: "none",
	                      textWrap: "nowrap"
	                    }
	                  },
	                  "Emergency:",
	                  _react2.default.createElement("br", { className: "d-lg-none" }),
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    " +880-1914-001234"
	                  )
	                ),
	                _react2.default.createElement("br", { className: "d-lg-none" }),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "tel:02222262466",
	                    style: {
	                      color: "#ffff",
	                      textDecoration: "none",
	                      textWrap: "nowrap"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Appointment Hotline: ",
	                    _react2.default.createElement("br", { className: "d-lg-none" }),
	                    " ",
	                    "02-2222-62466"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-4 top-header",
	                  style: {
	                    display: "flex",
	                    rowGap: "20px",
	                    columnGap: "20px",
	                    justifyContent: "flex-end"
	                  }
	                },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    style: {
	                      textDecoration: "none",
	                      textTransform: "capitalize",
	                      fontSize: "14px"
	                    },
	                    href: "#",
	                    target: "_blank",
	                    rel: "noopener noreferrer"
	                  },
	                  _react2.default.createElement("img", { src: "/assets/images/Logo12.png", alt: "" })
	                ),
	                _react2.default.createElement("img", { src: "/assets/images/Line 1.png", alt: "" }),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    style: {
	                      textDecoration: "none",
	                      textTransform: "capitalize",
	                      fontSize: "14px"
	                    },
	                    href: "#",
	                    target: "_blank",
	                    rel: "noopener noreferrer"
	                  },
	                  _react2.default.createElement("img", { src: "/assets/images/Group1.png", alt: "" })
	                ),
	                _react2.default.createElement("img", { src: "/assets/images/Line 1.png", alt: "" }),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    style: { textDecoration: "none", fontSize: "14px" },
	                    href: "#",
	                    target: "_blank",
	                    rel: "noopener noreferrer"
	                  },
	                  _react2.default.createElement("img", { src: "/assets/images/Group2.png", alt: "" })
	                ),
	                _react2.default.createElement("img", { src: "/assets/images/Line 1.png", alt: "" }),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    style: { textDecoration: "none", fontSize: "14px" },
	                    href: "#",
	                    target: "_blank",
	                    rel: "noopener noreferrer"
	                  },
	                  _react2.default.createElement("img", { src: "/assets/images/Group3.png", alt: "" })
	                ),
	                _react2.default.createElement("img", { src: "/assets/images/Line 1.png", alt: "" }),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    style: { textDecoration: "none", fontSize: "14px" },
	                    href: "#",
	                    target: "_blank",
	                    rel: "noopener noreferrer"
	                  },
	                  _react2.default.createElement("img", { src: "/assets/images/Group5.png", alt: "" })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "header",
	          {
	            className: "header-part hrad subpages_header",
	            id: "doctor-profile"
	          },
	          _react2.default.createElement(
	            "nav",
	            { className: "navbar " },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "row " },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-6 col-12 images" },
	                  _react2.default.createElement(
	                    "a",
	                    { className: "navbar-brand1", href: "/" },
	                    _react2.default.createElement("img", {
	                      className: "navbar-brand1 img-fluid",
	                      src: "/assets/images/united_logo.png",
	                      alt: "logo2",
	                      width: 50,
	                      style: { objectFit: "cover" }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "a",
	                    { className: "navbar-brand2", href: "/" },
	                    _react2.default.createElement("img", {
	                      className: "navbar-brand2",
	                      src: "/assets/images/logo.png",
	                      alt: "logo2"
	                    })
	                  )
	                ),
	                _react2.default.createElement("div", { className: "" })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "ul",
	                  { className: "big-screen t " },
	                  this.state.menu.length > 0 ? this.state.menu.map(function (hmenu) {
	
	                    return (
	                      // <li className="nav-item customenavitem">
	                      //   {hmenu.title === 'Book Appointment'
	                      //     ?
	                      //     <a className="nav-link active" href="#offcanvasExample" data-bs-toggle="offcanvas" role="button" aria-controls="offcanvasExample">Book Appointment</a>
	                      //     :
	                      //     <a href={WEBSITEPAGE_URL + hmenu.slug} className="nav-link">{hmenu.title}</a>
	                      //   }
	                      // </li>
	                      _react2.default.createElement(
	                        "li",
	                        { className: "" },
	                        hmenu.title === "Book Appointment" && _react2.default.createElement(
	                          "div",
	                          null,
	                          !localStorage.getItem(_constants.USER_ID) && localStorage.getItem(_constants.USER_LOCAL_ID) ? _react2.default.createElement(
	                            "a",
	                            {
	                              className: "nav-link active text-dark",
	                              "data-bs-toggle": "offcanvas",
	                              role: "button",
	                              href: "#offcanvasExample5",
	                              "aria-controls": "offcanvasExample5",
	                              onClick: _this2.handleOpenPatientRegisterPopUp
	                            },
	                            "Book Appointment"
	                          ) : _react2.default.createElement(
	                            "a",
	                            {
	                              className: "nav-link active text-dark",
	                              href: "#offcanvasExample",
	                              "data-bs-toggle": "offcanvas",
	                              role: "button",
	                              "aria-controls": "offcanvasExample"
	                            },
	                            "Book Appointment"
	                          )
	                        ),
	                        hmenu.title === "Emergency" && _react2.default.createElement(
	                          "a",
	                          {
	                            className: "nav-link",
	                            href: _constants.WEBSITEPAGE_URL + hmenu.slug
	                          },
	                          "Emergency"
	                        )
	                      )
	                    );
	                  }) : _react2.default.createElement("li", null),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { className: "nav-link d-none", to: "/cart" },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          style: {
	                            position: "relative",
	                            display: "none"
	                          }
	                        },
	                        _react2.default.createElement(
	                          _MyProvider.MyContext.Consumer,
	                          null,
	                          function (context) {
	                            var totalQuantity = context.totalQuantity;
	
	                            return _react2.default.createElement(
	                              "span",
	                              {
	                                className: "badge rounded-circle d-flex justify-content-center align-items-center",
	                                style: {
	                                  position: "absolute",
	                                  top: -15,
	                                  right: -10,
	                                  height: "20px",
	                                  width: "20px",
	                                  border: "2px solid #292D32",
	                                  textAlign: "center",
	                                  padding: "5px",
	                                  color: "black"
	                                }
	                              },
	                              cart && totalQuantity
	                            );
	                          }
	                        ),
	                        _react2.default.createElement("img", {
	                          src: "/assets/images/shopping-cart.png",
	                          alt: "logo2"
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    localStorage.getItem(_constants.USER_LOCAL_ID) ?
	                    // <p className='customHoverP pad'><a href="/logout">Logout</a></p>
	                    _react2.default.createElement(
	                      "div",
	                      { className: "dropdown" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          className: " dropdown-toggle dropdownMenu nav-link",
	                          type: "button",
	                          id: "dropdownMenuButton",
	                          "data-toggle": "dropdown",
	                          "aria-haspopup": "true",
	                          "aria-expanded": "false"
	                        },
	                        UserName
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "dropdown-menu",
	                          "aria-labelledby": "dropdownMenuButton"
	                        },
	                        patient_user_id ? _react2.default.createElement(
	                          _react.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              className: "dropdown-item btn disabled",
	                              href: "/patient-protal"
	                            },
	                            "Patient ID: ",
	                            patient_user_id
	                          ),
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              className: "dropdown-item",
	                              href: "/patient-protal"
	                            },
	                            "My Portal"
	                          ),
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              className: "dropdown-item",
	                              href: "/pages/patientbillhistory"
	                            },
	                            "Bill History"
	                          )
	                        ) : null,
	                        !patient_user_id ? _react2.default.createElement(
	                          "a",
	                          {
	                            className: "dropdown-item",
	                            "data-bs-toggle": "offcanvas",
	                            href: "#offcanvasExample5",
	                            role: "button",
	                            "aria-controls": "offcanvasExample5",
	                            onClick: this.handleOpenPatientRegisterPopUp,
	                            "data-bs-dismiss": "offcanvas"
	                          },
	                          "Patient Registration"
	                        ) : null,
	                        this.state.menu.length > 0 ? this.state.menu.filter(function (hmenu) {
	                          return ["Packages", "Departments", "Services"].includes(hmenu.title);
	                        }).map(function (hmenu) {
	                          return _react2.default.createElement(
	                            "a",
	                            {
	                              className: "dropdown-item",
	                              href: _constants.WEBSITEPAGE_URL + hmenu.slug,
	                              key: hmenu.title
	                            },
	                            hmenu.title
	                          );
	                        }) : _react2.default.createElement("li", null),
	                        _react2.default.createElement(
	                          "a",
	                          { className: "dropdown-item", href: "/logout" },
	                          "Logout"
	                        )
	                      )
	                    ) : _react2.default.createElement(
	                      "li",
	                      { className: "d-flex align-items-center" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "dropdown" },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            className: " dropdown-toggle dropdownMenu",
	                            type: "button",
	                            id: "dropdownMenuButton",
	                            "data-toggle": "dropdown",
	                            "aria-haspopup": "true",
	                            "aria-expanded": "false"
	                          },
	                          _react2.default.createElement("img", { src: "/assets/images/User.png", alt: "logo2" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "dropdown-menu",
	                            "aria-labelledby": "dropdownMenuButton"
	                          },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              className: "dropdown-item"
	                              // href="#"
	                              // data-bs-toggle="modal"
	                              // data-bs-target="#loginModal"
	
	                              , href: "#offcanvasExample",
	                              "data-bs-toggle": "offcanvas",
	                              role: "button",
	                              "aria-controls": "offcanvasExample"
	                            },
	                            "Login/Sign up"
	                          ),
	                          this.state.menu.length > 0 ? this.state.menu.filter(function (hmenu) {
	                            return ["Packages", "Departments", "Services"].includes(hmenu.title);
	                          }).map(function (hmenu) {
	                            return _react2.default.createElement(
	                              "a",
	                              {
	                                className: "dropdown-item",
	                                href: _constants.WEBSITEPAGE_URL + hmenu.slug,
	                                key: hmenu.title
	                              },
	                              hmenu.title
	                            );
	                          }) : _react2.default.createElement("p", null)
	                        )
	                      )
	                    )
	                    // <p className="pad"  >
	                    //   <a className="users"
	                    //     // style={{ paddingTop: "25px", textDecoration: "none", paddingLeft: "10px", backgroundColor: "red" }}
	                    //     href="#offcanvasExample"
	                    //     data-bs-toggle="offcanvas"
	                    //     role="button"
	                    //     aria-controls="offcanvasExample"
	                    //   >
	                    //     Login / Signup
	                    //   </a>{" "}
	                    // </p>
	
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "soto-screen" },
	                  _react2.default.createElement(_CollapsibleButton2.default, {
	                    content: _react2.default.createElement(
	                      "ul",
	                      { className: "buttonUL t" },
	                      _react2.default.createElement(
	                        "li",
	                        { className: "nav-item text-light" },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            className: "nav-link  text-light number ",
	                            href: "tel:10666"
	                          },
	                          _react2.default.createElement(
	                            "svg",
	                            {
	                              xmlns: "http://www.w3.org/2000/svg",
	                              width: "24",
	                              height: "24",
	                              fill: "currentColor",
	                              className: "bi bi-telephone-forward",
	                              viewBox: "0 0 16 16"
	                            },
	                            _react2.default.createElement("path", { d: "M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" })
	                          ),
	                          " ",
	                          "10666"
	                        )
	                      ),
	                      this.state.menu.length > 0 ? this.state.menu.map(function (hmenu) {
	                        return _react2.default.createElement(
	                          "li",
	                          { className: "nav-item text-light" },
	                          hmenu.title === "Book Appointment" ? _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "div",
	                              null,
	                              !localStorage.getItem(_constants.USER_ID) && localStorage.getItem(_constants.USER_LOCAL_ID) ? _react2.default.createElement(
	                                "a",
	                                {
	                                  className: "nav-link active text-dark",
	                                  "data-bs-toggle": "offcanvas",
	                                  role: "button",
	                                  href: "#offcanvasExample5",
	                                  "aria-controls": "offcanvasExample5",
	                                  onClick: _this2.handleOpenPatientRegisterPopUp
	                                },
	                                "Book Appointment"
	                              ) : _react2.default.createElement(
	                                "a",
	                                {
	                                  className: "nav-link active text-dark",
	                                  href: "#offcanvasExample",
	                                  "data-bs-toggle": "offcanvas",
	                                  role: "button",
	                                  "aria-controls": "offcanvasExample"
	                                },
	                                "Book Appointment"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactRouterDom.Link,
	                              {
	                                className: "nav-link d-none",
	                                to: "/cart"
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  style: {
	                                    position: "relative"
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  _MyProvider.MyContext.Consumer,
	                                  null,
	                                  function (context) {
	                                    var totalQuantity = context.totalQuantity;
	
	                                    return _react2.default.createElement(
	                                      "span",
	                                      {
	                                        className: "badge rounded-circle d-flex justify-content-center align-items-center",
	                                        style: {
	                                          position: "absolute",
	                                          top: -15,
	                                          left: 15,
	                                          height: "20px",
	                                          width: "20px",
	                                          border: "2px solid #292D32",
	                                          textAlign: "center",
	                                          padding: "5px",
	                                          color: "black"
	                                        }
	                                      },
	                                      cart && totalQuantity
	                                    );
	                                  }
	                                ),
	                                _react2.default.createElement("img", {
	                                  src: "/assets/images/shopping-cart.png",
	                                  alt: "logo2"
	                                })
	                              )
	                            )
	                          ) : _react2.default.createElement(
	                            "a",
	                            {
	                              href: _constants.WEBSITEPAGE_URL + hmenu.slug,
	                              className: "nav-link"
	                            },
	                            hmenu.title
	                          )
	                        );
	                      }) : _react2.default.createElement("li", null),
	                      _react2.default.createElement(
	                        "li",
	                        { className: "nav-item", style: { marginLeft: "1rem" } },
	                        localStorage.getItem(_constants.USER_ID) ? _react2.default.createElement(
	                          "div",
	                          { className: "dropdown" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              className: " dropdown-toggle dropdownMenu",
	                              type: "button",
	                              id: "dropdownMenuButton",
	                              "data-toggle": "dropdown",
	                              "aria-haspopup": "true",
	                              "aria-expanded": "false"
	                            },
	                            UserName
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              className: "dropdown-menu",
	                              "aria-labelledby": "dropdownMenuButton"
	                            },
	                            patient_user_id ? _react2.default.createElement(
	                              _react.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  className: "dropdown-item btn disabled",
	                                  href: "/patient-protal"
	                                },
	                                "Patient ID: ",
	                                patient_user_id
	                              ),
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  className: "dropdown-item",
	                                  href: "/patient-protal"
	                                },
	                                "My Portal"
	                              ),
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  className: "dropdown-item",
	                                  href: "/pages/patientbillhistory"
	                                },
	                                "Bill History"
	                              )
	                            ) : null,
	                            _react2.default.createElement(
	                              "a",
	                              { className: "dropdown-item", href: "/logout" },
	                              "Logout"
	                            )
	                          )
	                        ) : _react2.default.createElement(
	                          "p",
	                          { className: "pad " },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              className: "users",
	                              style: {
	                                textDecoration: "none",
	                                paddingLeft: "10px"
	                              },
	                              href: "#loginModal",
	                              "data-bs-toggle": "modal",
	                              "data-bs-target": "#exampleModal",
	                              role: "button",
	                              "aria-controls": "offcanvasExample"
	                            },
	                            "Login / Signup"
	                          ),
	                          " "
	                        )
	                      )
	                    )
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement("div", { className: "col-sm-1" }),
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-6" },
	              _react2.default.createElement(
	                "div",
	                { className: "search-popup-main", style: { width: "100%" } },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "search-popupp",
	                    style: {
	                      display: "none",
	                      overflowY: "scroll",
	                      height: "424px",
	                      zIndex: "99999"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    "Specialists"
	                  ),
	                  _react2.default.createElement("hr", { className: "lists-line" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row mt-4" },
	                    this.state.default_doctors.length > 0 ? this.state.default_doctors.map(function (default_search_doctor) {
	                      var doctor_name = default_search_doctor.doctor_name;
	                      var new_doctor_name = doctor_name.replaceAll(" ", "-");
	                      return _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-4 col-md-12 mt-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "doctor-list" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              href: _constants.SITE_URL + "/consultant/" + default_search_doctor.slug,
	                              style: {
	                                textDecoration: "none",
	                                color: "#212529"
	                              }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-5" },
	                                default_search_doctor.doctor_profile ? _react2.default.createElement("img", {
	                                  src: _constants.IMAGE_URL + "/DoctorProfileImg/" + default_search_doctor.doctor_profile,
	                                  alt: "Bitmap-3",
	                                  style: {
	                                    height: "120px",
	                                    width: "100%"
	                                  }
	                                }) : _react2.default.createElement("img", {
	                                  src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                                  alt: "Bitmap-3",
	                                  style: {
	                                    height: "120px",
	                                    width: "100%"
	                                  }
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-7" },
	                                _react2.default.createElement(
	                                  "h6",
	                                  { style: { fontSize: "14px" } },
	                                  default_search_doctor.doctor_name
	                                ),
	                                _react2.default.createElement(
	                                  "p",
	                                  { style: { fontSize: "12px" } },
	                                  default_search_doctor.degree
	                                )
	                              )
	                            )
	                          )
	                        )
	                      );
	                    }) : _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-12 col-md-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "doctor-list" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "p",
	                            { style: { fontSize: "12px" } },
	                            "no result found"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "h5",
	                    null,
	                    "Packages"
	                  ),
	                  _react2.default.createElement("hr", { className: "lists-line" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row mt-4" },
	                    this.state.default_packages.length > 0 ? this.state.default_packages.map(function (default_search_packages) {
	                      var package_name = default_search_packages.name;
	                      var new_package_name = package_name.replaceAll(" ", "-");
	                      return _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-4 col-sm-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "Package-part" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              href: _constants.SITE_URL + "/packages/" + new_package_name,
	                              style: {
	                                textDecoration: "none",
	                                color: "#212529"
	                              }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-4 sp-0-search" },
	                                _react2.default.createElement("img", {
	                                  src: _iconsRotate2.default,
	                                  alt: "icons-rotate"
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-8 sp-0-search bg-color-gry" },
	                                _react2.default.createElement(
	                                  "h6",
	                                  { style: { fontSize: "16px" } },
	                                  default_search_packages.name
	                                ),
	                                _react2.default.createElement("p", {
	                                  title: default_search_packages.description,
	                                  dangerouslySetInnerHTML: {
	                                    __html: default_search_packages.description ? default_search_packages.description.substr(0, 140) : ""
	                                  }
	                                })
	                              )
	                            )
	                          )
	                        )
	                      );
	                    }) : _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-12 col-sm-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Package-part" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "No packages found"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "h5",
	                    null,
	                    "Blog"
	                  ),
	                  _react2.default.createElement("hr", { className: "lists-line" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    this.state.default_publications.length > 0 ? this.state.default_publications.map(function (default_search_publications) {
	                      var publications_title = default_search_publications.publications_title;
	                      var new_publications_title = publications_title.replaceAll(" ", "-");
	                      return _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            href: _constants.SITE_URL + "/publications/" + new_publications_title + "~" + default_search_publications.id,
	                            style: {
	                              textDecoration: "none",
	                              color: "#212529"
	                            }
	                          },
	                          _react2.default.createElement(
	                            "h6",
	                            {
	                              className: "colo-dark",
	                              title: default_search_publications.publications_title
	                            },
	                            default_search_publications.publications_title.substr(0, 40)
	                          )
	                        ),
	                        _react2.default.createElement("p", {
	                          style: { fontSize: "14px" },
	                          dangerouslySetInnerHTML: {
	                            __html: default_search_publications.publications_desc ? default_search_publications.publications_desc.substr(0, 150) : ""
	                          }
	                        })
	                      );
	                    }) : _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-12" },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "pera-search" },
	                        "No any blog found"
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("div", { className: "col-sm-5" })
	          ),
	          step_html
	        ),
	        this.state.patientRegPopup ? _react2.default.createElement(_PatientRegistrationPopup2.default, { showpopup: this.state.showPatientRegPopup }) : null
	      );
	    }
	  }]);
	
	  return HeaderHome;
	}(_react.Component);
	
	exports.default = HeaderHome;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _logo = __webpack_require__(451);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _hotline_phone = __webpack_require__(117);
	
	var _hotline_phone2 = _interopRequireDefault(_hotline_phone);
	
	var _PopupIndex = __webpack_require__(84);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _PopupIndex3 = __webpack_require__(144);
	
	var _PopupIndex4 = _interopRequireDefault(_PopupIndex3);
	
	var _PopupIndex5 = __webpack_require__(65);
	
	var _PopupIndex6 = _interopRequireDefault(_PopupIndex5);
	
	var _PopupIndex7 = __webpack_require__(70);
	
	var _PopupIndex8 = _interopRequireDefault(_PopupIndex7);
	
	var _PopupPatientLists = __webpack_require__(145);
	
	var _PopupPatientLists2 = _interopRequireDefault(_PopupPatientLists);
	
	var _PopupRegister = __webpack_require__(97);
	
	var _PopupRegister2 = _interopRequireDefault(_PopupRegister);
	
	__webpack_require__(155);
	
	var _CollapsibleButton = __webpack_require__(139);
	
	var _CollapsibleButton2 = _interopRequireDefault(_CollapsibleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GetAllMenu = function GetAllMenu(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/menu/getallmenu", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleHeaderAnnoucementData = function getSingleHeaderAnnoucementData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/headerannoucement/getsingleheaderannoucement/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var HomeHeader = function (_Component) {
	  _inherits(HomeHeader, _Component);
	
	  function HomeHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HomeHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HomeHeader.__proto__ || Object.getPrototypeOf(HomeHeader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      step: 1,
	      showthirdpopup: "",
	      menu: [],
	      header_annoucement_text: "",
	      header_annoucement_link: "",
	      header_phone_no: ""
	    }, _this.nextStep = function (e) {
	      _this.setState({ step: _this.state.step + 1 });
	    }, _this.prevStep = function (e) {
	      _this.setState({
	        step: _this.state.step - 1,
	        showthirdpopup: "offcanvas offcanvas-start show"
	      });
	    }, _this.refreshStaticMenu = function (page) {
	      GetAllMenu(page).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ menu: records });
	        } else {
	          _this.setState({ menu: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshgetSingleHeaderAnnoucementData = function (id) {
	      getSingleHeaderAnnoucementData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            header_annoucement_text: records.header_annoucement_text,
	            header_annoucement_link: records.header_annoucement_link,
	            header_phone_no: records.header_phone_no
	          });
	        } else {
	          _this.setState({
	            header_annoucement_text: "",
	            header_annoucement_link: "",
	            header_phone_no: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(HomeHeader, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var header_annoucement_id = "1";
	      // this.refreshgetSingleHeaderAnnoucementData(header_annoucement_id);
	      /*if(localStorage.getItem(USER_ID)){
	        let login_step_number = this.state.step + 1;
	        this.setState({
	          step: login_step_number + 1,
	          showthirdpopup: 'offcanvas offcanvas-start',
	        });
	      } else {
	        this.setState({
	          step: this.state.step,
	          showthirdpopup: 'offcanvas offcanvas-start show',
	        });
	      }*/
	      if (localStorage.getItem(_constants.USER_ID)) {
	        var login_step_number = this.state.step + 1;
	        this.setState({
	          step: login_step_number,
	          showthirdpopup: "offcanvas offcanvas-start"
	        });
	      } else {
	        this.setState({
	          step: this.state.step,
	          showthirdpopup: "offcanvas offcanvas-start show"
	        });
	      }
	      this.refreshStaticMenu();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var step_html = "";
	      var step = this.state.step;
	      if (step === 1) {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 1" },
	                _react2.default.createElement(_PopupIndex6.default, {
	                  nextStep: this.nextStep,
	                  prevStep: this.prevStep
	                })
	              )
	            )
	          )
	        );
	        /*} else if (step === 2) {
	          step_html = <div className="">
	            <div className="container">
	              <div className="row">
	                <div className="col-md-6 col-sm-3 custom-margin 2">
	                  <PopupPatientLists nextStep={this.nextStep} prevStep={this.prevStep} />
	                </div>
	              </div>
	            </div>
	        </div>*/
	      } else if (step === 2) {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 3" },
	                _react2.default.createElement(_PopupIndex2.default, {
	                  nextStep: this.nextStep,
	                  showpopup: this.state.showthirdpopup
	                })
	              )
	            )
	          )
	        );
	      } else if (step === 3) {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 4" },
	                _react2.default.createElement(_PopupIndex4.default, {
	                  nextStep: this.nextStep,
	                  prevStep: this.prevStep
	                })
	              )
	            )
	          )
	        );
	      } else if (step === 4) {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 5" },
	                _react2.default.createElement(_PopupIndex8.default, null)
	              )
	            )
	          )
	        );
	      } else if (step === 5) {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 5" },
	                _react2.default.createElement(_PopupRegister2.default, null)
	              )
	            )
	          )
	        );
	      } else {
	        step_html = _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 col-sm-3 custom-margin 5" },
	                _react2.default.createElement(_PopupRegister2.default, null)
	              )
	            )
	          )
	        );
	      }
	
	      // const toggleBtn=document.querySelector('.toggle_btn')
	      // const toggleBtenIcon=document.querySelector('.toggle_btn i')
	      // const dropDrownMenu=document.querySelector('.dropdown_menu')
	      // toggleBtn.onClick=function(){
	      //   dropDrownMenu.classList.toggle('open')
	      // }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.header_annoucement_text || this.state.header_phone_no ? _react2.default.createElement(
	          "header",
	          { className: "top-part" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-4 col-sm-6" },
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: this.state.header_annoucement_link,
	                      target: "_blank",
	                      style: { color: "#fff", textDecoration: "none" }
	                    },
	                    this.state.header_annoucement_text
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-8 col-sm-6 tab-left" },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "tel:" + this.state.header_phone_no,
	                    style: { color: "#fff", textDecoration: "none" }
	                  },
	                  _react2.default.createElement("img", {
	                    src: _hotline_phone2.default,
	                    alt: "hotline_phone",
	                    style: { width: "23px" }
	                  }),
	                  " ",
	                  this.state.header_phone_no
	                )
	              )
	            )
	          )
	        ) : "",
	        _react2.default.createElement(
	          "div",
	          { className: " text-light p-2" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12",
	                style: {
	                  display: "flex",
	                  rowGap: "20px",
	                  columnGap: "20px",
	                  justifyContent: "center",
	                  fontSize: "14px"
	                }
	              },
	              _react2.default.createElement(
	                "a",
	                {
	                  style: { textDecoration: "none", textTransform: "capitalize" },
	                  href: "#",
	                  target: "_blank",
	                  rel: "noopener noreferrer"
	                },
	                "United Healthcare"
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  style: { textDecoration: "none" },
	                  href: "#",
	                  target: "_blank",
	                  rel: "noopener noreferrer"
	                },
	                "United Medical Collage"
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  style: { textDecoration: "none" },
	                  href: "#",
	                  target: "_blank",
	                  rel: "noopener noreferrer"
	                },
	                "Medix"
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  style: { textDecoration: "none" },
	                  href: "#",
	                  target: "_blank",
	                  rel: "noopener noreferrer"
	                },
	                "M A Rashid Hospital"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "header",
	          {
	            className: "header-part",
	            id: "homepage_header",
	            style: { background: "#fff" }
	          },
	          _react2.default.createElement(
	            "nav",
	            { className: "navbar px-2" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: "navbar-brand", to: "/", style: { width: "120px" } },
	              _react2.default.createElement("img", {
	                src: "http://localhost:3000/static/media/logo2.93ec62fb.png",
	                alt: "logo2"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "ul",
	                { className: "big-screen t " },
	                this.state.menu.length > 0 ? this.state.menu.map(function (hmenu) {
	                  return _react2.default.createElement(
	                    "li",
	                    { className: "nav-item font-weight-bold" },
	                    hmenu.title === "Book Appointment" ? _react2.default.createElement(
	                      "a",
	                      {
	                        className: "nav-link active text-warning",
	                        style: { color: "#da6621!important" },
	                        href: "#offcanvasExample",
	                        "data-bs-toggle": "offcanvas",
	                        role: "button",
	                        "aria-controls": "offcanvasExample"
	                      },
	                      "Book Appointment"
	                    ) : _react2.default.createElement(
	                      "a",
	                      {
	                        href: _constants.WEBSITEPAGE_URL + hmenu.slug,
	                        className: "nav-link text-light "
	                      },
	                      hmenu.title
	                    )
	                  );
	                }) : _react2.default.createElement("li", null),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "nav-item login-white",
	                    Style: "border-radius: 10px;"
	                  },
	                  localStorage.getItem(_constants.USER_ID) ? _react2.default.createElement(
	                    "div",
	                    { className: "dropdown home_header_dropdown" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        className: "btn dropdown-toggle",
	                        type: "button",
	                        id: "dropdownMenuButton",
	                        "data-toggle": "dropdown",
	                        "aria-haspopup": "true",
	                        "aria-expanded": "false"
	                      },
	                      localStorage.getItem(_constants.PATIENT_NAME)
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "dropdown-menu",
	                        "aria-labelledby": "dropdownMenuButton",
	                        style: { background: "#fd8e5e" }
	                      },
	                      localStorage.getItem(_constants.USER_ROLE) == "1" ? _react2.default.createElement(
	                        "a",
	                        {
	                          className: "dropdown-item",
	                          href: "/dashboard/admindashboard"
	                        },
	                        "Dashboard"
	                      ) : _react2.default.createElement(
	                        "a",
	                        {
	                          className: "dropdown-item",
	                          href: "/dashboard/patient-dashboard"
	                        },
	                        "Dashboard"
	                      ),
	                      _react2.default.createElement(
	                        "a",
	                        { className: "dropdown-item", href: "/logout" },
	                        "Logout"
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    "p",
	                    { className: "pad" },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        className: "users",
	                        href: "#offcanvasExample",
	                        "data-bs-toggle": "offcanvas",
	                        role: "button",
	                        "aria-controls": "offcanvasExample"
	                      },
	                      "Login/Signup"
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "nav-item bangla-part sp-rifht-0" },
	                  _react2.default.createElement(
	                    "a",
	                    { className: "nav-link", href: "#", Style: "border-radius: 10px" },
	                    "Bangla"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "soto-screen" },
	                _react2.default.createElement(_CollapsibleButton2.default, {
	                  className: "d",
	                  content: _react2.default.createElement(
	                    "ul",
	                    { className: "buttonUL t" },
	                    this.state.menu.length > 0 ? this.state.menu.map(function (hmenu) {
	                      return _react2.default.createElement(
	                        "li",
	                        { className: "nav-item" },
	                        hmenu.title === "Book Appointment" ? _react2.default.createElement(
	                          "a",
	                          {
	                            className: "nav-link active text-light",
	                            href: "#offcanvasExample",
	                            "data-bs-toggle": "offcanvas",
	                            role: "button",
	                            "aria-controls": "offcanvasExample"
	                          },
	                          "Book Appointment"
	                        ) : _react2.default.createElement(
	                          "a",
	                          {
	                            href: _constants.WEBSITEPAGE_URL + hmenu.slug,
	                            className: "nav-link text-light"
	                          },
	                          hmenu.title
	                        )
	                      );
	                    }) : _react2.default.createElement("li", null),
	                    _react2.default.createElement(
	                      "li",
	                      {
	                        className: "nav-item login-white",
	                        Style: "border-radius: 10px;"
	                      },
	                      localStorage.getItem(_constants.USER_ID) ? _react2.default.createElement(
	                        "div",
	                        { className: "dropdown home_header_dropdown" },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            className: "btn dropdown-toggle",
	                            type: "button",
	                            id: "dropdownMenuButton",
	                            "data-toggle": "dropdown",
	                            "aria-haspopup": "true",
	                            "aria-expanded": "false"
	                          },
	                          localStorage.getItem(_constants.PATIENT_NAME)
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "dropdown-menu",
	                            "aria-labelledby": "dropdownMenuButton",
	                            style: { background: "#fd8e5e" }
	                          },
	                          localStorage.getItem(_constants.USER_ROLE) == "1" ? _react2.default.createElement(
	                            "a",
	                            {
	                              className: "dropdown-item",
	                              href: "/dashboard/admindashboard"
	                            },
	                            "Dashboard"
	                          ) : _react2.default.createElement(
	                            "a",
	                            {
	                              className: "dropdown-item",
	                              href: "/dashboard/patient-dashboard"
	                            },
	                            "Dashboard"
	                          ),
	                          _react2.default.createElement(
	                            "a",
	                            { className: "dropdown-item", href: "/logout" },
	                            "Logout"
	                          )
	                        )
	                      ) : _react2.default.createElement(
	                        "p",
	                        { className: "pad" },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            className: "login",
	                            href: "#offcanvasExample",
	                            "data-bs-toggle": "offcanvas",
	                            role: "button",
	                            "aria-controls": "offcanvasExample"
	                          },
	                          "Login/Signup"
	                        ),
	                        " "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      { className: "nav-item bangla-part sp-rifht-0" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          className: "nav-link",
	                          href: "#",
	                          Style: "border-radius: 10px"
	                        },
	                        "Bangla"
	                      )
	                    )
	                  )
	                })
	              )
	            )
	          ),
	          step_html
	        )
	      );
	    }
	  }]);
	
	  return HomeHeader;
	}(_react.Component);
	
	exports.default = HomeHeader;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _userSession = __webpack_require__(30);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(59);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _MyProvider = __webpack_require__(48);
	
	var _LinkPatientIdPopup = __webpack_require__(638);
	
	var _LinkPatientIdPopup2 = _interopRequireDefault(_LinkPatientIdPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import doc from '../../images/doc.png';
	
	
	var patientRegistration = function patientRegistration(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/ledger", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	        // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	      },
	      data: data
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	var input_field_css = {
	  maxHeight: "50px",
	  fontSize: "14px",
	  borderColor: "#cccccc",
	  borderRadius: "5px"
	};
	
	var PatientRegistrationPopup = function (_Component) {
	  _inherits(PatientRegistrationPopup, _Component);
	
	  function PatientRegistrationPopup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PatientRegistrationPopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PatientRegistrationPopup.__proto__ || Object.getPrototypeOf(PatientRegistrationPopup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      search_doctors: [],
	      search_keywords: "",
	      doctor_id: "",
	      schedule_date: "",
	      department_id: "",
	      limit: 4,
	      search_selected_doc_name: "",
	      selectedDate: null,
	      payment_type: "",
	      privacy_policy: "",
	      term_conditions: "",
	      showLinkIdPopup: false,
	      showPatientRegPopup: ""
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.handleSubmit = function (event, props) {
	      event.preventDefault();
	
	      var type = "patient_registration";
	      var user_id = localStorage.getItem(_constants.USER_LOCAL_ID);
	      var grand_total = 200;
	      var total = 200;
	      var payment_type = "sslCommerz";
	      var status = 1;
	      var currency = "BDT";
	      var qty = 1;
	
	      var sslCommerz_urls = {
	        // null if payment_type is pay_at_uhl
	        success_url: window.location.origin + "/success",
	        fail_url: window.location.origin + "/fail",
	        cancel_url: window.location.origin + "/cancel"
	      };
	      var data = {
	        type: type,
	        user_id: user_id,
	        grand_total: grand_total,
	        total: total,
	        payment_type: payment_type,
	        sslCommerz_urls: sslCommerz_urls,
	        status: status,
	        currency: currency,
	        qty: qty
	      };
	
	      patientRegistration(data).then(function (res) {
	        if (res.status === "success") {
	          window.location.href = res.data;
	        } else {
	          _reactToastify.toast.error("Something went wrong.Please try again!", {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("Something went wrong.Please try again!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	    }, _this.closePopup = function (event) {
	      var DoctorData = _this.context.DoctorData;
	
	      DoctorData({});
	      document.getElementById("offcanvasExample5").style.visibility = "hidden";
	      document.getElementById("offcanvasExample5").classList.remove("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _this.showLinkIdPopup = function () {
	      (0, _jquery2.default)(".otp_reg").css("visibility", "visible");
	      (0, _jquery2.default)(".otp_reg").addClass("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PatientRegistrationPopup, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME) && localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID) && localStorage.getItem(_constants.SCHEDULE_DATE)) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "gray";
	      }
	      /* if (localStorage.getItem(SEARCH_SELECTED_DOC_NAME)) {
	        this.refreshGetSearchDoctors(
	          localStorage.getItem(SEARCH_SELECTED_DOC_NAME)
	        );
	      } */
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: this.props.showpopup + " patientRegister",
	          tabIndex: "-1",
	          id: "offcanvasExample5",
	          "aria-labelledby": "offcanvasExampleLabel5",
	          style: { visibility: "visible" }
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-header" },
	          _react2.default.createElement(
	            "h5",
	            { className: "offcanvas-title", id: "offcanvasExampleLabel5" },
	            " "
	          ),
	          _react2.default.createElement("button", {
	            type: "button",
	            className: "btn-close text-reset",
	            "data-bs-dismiss": "offcanvas",
	            "aria-label": "Close",
	            onClick: this.closePopup
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-body" },
	          _react2.default.createElement(
	            "div",
	            { className: "row text-center", id: "logos" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-2 " },
	              _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "left-offcanvas" },
	            _react2.default.createElement(
	              "h4",
	              { style: { color: "#187979" } },
	              "Patient Registration"
	            ),
	            _react2.default.createElement(
	              "form",
	              {
	                onSubmit: this.handleSubmit,
	                id: "registerform",
	                className: "needs-validation",
	                noValidate: true
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mt-2" },
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    type: "text",
	                    className: "form-control",
	                    placeholder: "Enter Your Full Name ",
	                    name: "fullname",
	                    id: "fullname",
	                    value: localStorage.getItem(_constants.PATIENT_NAME) || "",
	                    onChange: this.handleChange,
	                    required: true,
	                    autoComplete: "off",
	                    style: input_field_css
	                  })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { style: alertStyle },
	                  this.state.errors.fullname
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mt-2" },
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    type: "text",
	                    className: "form-control PhoneNumber",
	                    placeholder: "Enter Phone Number",
	                    name: "phone_number",
	                    id: "phone_number",
	                    value: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER) || "",
	                    onChange: this.handleChange,
	                    required: true,
	                    autoComplete: "off",
	                    maxLength: "11",
	                    style: input_field_css
	                  })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { style: alertStyle },
	                  this.state.errors.phone_number
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "payment mt-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row  mb-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-6" },
	                    _react2.default.createElement("input", {
	                      type: "radio",
	                      id: "payment_type",
	                      name: "payment_type",
	                      className: "radio-btn",
	                      value: "pay_uhl",
	                      onChange: this.handleChange
	                    }),
	                    _react2.default.createElement(
	                      "label",
	                      { htmlFor: "css" },
	                      " Pay Now"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12" },
	                  _react2.default.createElement(
	                    "label",
	                    { className: "label-text" },
	                    _react2.default.createElement("input", {
	                      type: "checkbox",
	                      name: "privacy_policy",
	                      id: "privacy_policy",
	                      value: "privacy_policy",
	                      onChange: this.handleChange
	                    }),
	                    " ",
	                    "I agree with the Privacy Policy",
	                    " "
	                  ),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "label",
	                    { className: "label-text" },
	                    _react2.default.createElement("input", {
	                      type: "checkbox",
	                      name: "term_conditions",
	                      id: "term_conditions",
	                      value: "term_conditions",
	                      onChange: this.handleChange
	                    }),
	                    " ",
	                    "I agree with the Terms & Conditions"
	                  ),
	                  _react2.default.createElement("br", null),
	                  " ",
	                  _react2.default.createElement("br", null)
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      variant: "primary",
	                      type: "submit",
	                      className: "btn-links appointment-new submit_btn",
	                      id: "black-btn"
	                    },
	                    " ",
	                    "Register Now",
	                    " "
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "label",
	                { className: "dont" },
	                "Already have a patient ID? ",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    className: "nav-link active",
	                    onClick: function onClick() {
	                      return _this2.showLinkIdPopup();
	                    },
	                    style: {
	                      background: "none",
	                      border: "none",
	                      padding: "0px",
	                      color: "rgb(251, 98, 1)"
	                    }
	                  },
	                  "Link ID."
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_LinkPatientIdPopup2.default
	        // showPopup={this.state.showPatientRegPopup}
	        // userData={user_data}
	        // userId={this.state.user_id}
	        , null)
	      );
	    }
	  }]);
	
	  return PatientRegistrationPopup;
	}(_react.Component);
	
	PatientRegistrationPopup.contextType = _MyProvider.MyContext;
	exports.default = PatientRegistrationPopup;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _userSession = __webpack_require__(30);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(59);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SubPopupIndex = __webpack_require__(662);
	
	var _SubPopupIndex2 = _interopRequireDefault(_SubPopupIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import doc from '../../images/doc.png';
	
	
	var getSearchDoctors = function getSearchDoctors(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/searchdoctors", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var SubPopupIndex2 = function (_Component) {
	  _inherits(SubPopupIndex2, _Component);
	
	  function SubPopupIndex2() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SubPopupIndex2);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubPopupIndex2.__proto__ || Object.getPrototypeOf(SubPopupIndex2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      search_doctors: [],
	      search_keywords: "",
	      doctor_id: "",
	      schedule_date: "",
	      department_id: "",
	      limit: 4,
	      showPopup: false,
	      showSingleDoctorProfilePopup: false,
	      selected_day_date: "",
	      selectedDate: null
	    }, _this.handleDateChange = function (date) {
	      _this.setState({ errors: "" });
	      var newObj = new Date(date).toString();
	      var formatedDate = newObj.split(" ").slice(0, 4).join(" ");
	      console.log(formatedDate);
	
	      // Convert the input string to a Date object
	      var dateObject = new Date(date);
	
	      // Extract day, month, and year components
	      var month = dateObject.toLocaleString("default", { month: "short" });
	      var day = dateObject.getUTCDate() + 1;
	      var year = dateObject.getUTCFullYear();
	
	      // Format the components into the desired format (DD/MM/YYYY)
	      var formattedDate = month + " " + day + " " + year;
	
	      _this.setState({ selectedDate: date });
	      _this.setState({ schedule_date: formattedDate });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var search_keywords = (0, _jquery2.default)("#search_keywords").val();
	      var doctor_id = (0, _jquery2.default)("input[name='doctor_id']:checked").val();
	      var doctor_name = (0, _jquery2.default)("input[name='doctor_id']:checked").attr("doctorName");
	      _this.setState({ search_selected_doc_name: doctor_name });
	      var schedule_date = (0, _jquery2.default)("#schedule_date").val();
	      if (search_keywords && doctor_id && formattedDate) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "#fb6201";
	        (0, _jquery2.default)(".submit_btn").prop("disabled", false);
	        (0, _jquery2.default)(".submit_btn").css("background", "#fb6201");
	      } else if (doctor_id && formattedDate) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "#fb6201";
	        (0, _jquery2.default)(".submit_btn").prop("disabled", false);
	        (0, _jquery2.default)(".submit_btn").css("background", "#fb6201");
	      } else {
	        document.getElementById("Schedule").disabled = true;
	        document.getElementById("Schedule").style.background = "#41414b";
	        (0, _jquery2.default)(".submit_btn").prop("disabled", true);
	        (0, _jquery2.default)(".submit_btn").css("background", "#41414b");
	      }
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var search_keywords = (0, _jquery2.default)(".search_keywords").val();
	      var doctor_id = (0, _jquery2.default)("input[name='doctor_id']:checked").val();
	      var doctor_name = (0, _jquery2.default)("input[name='doctor_id']:checked").attr("doctorName");
	      _this.setState({ search_selected_doc_name: doctor_name });
	      // let schedule_date = "";
	      // if ($(".schedule_date").val()) {
	      //   schedule_date = $(".schedule_date").val();
	      // } else {
	      //   schedule_date = localStorage.getItem(SCHEDULE_DATE);
	      // }
	      // if (search_keywords !== "" && doctor_id !== "") {
	      //   // $(".submit_btn").prop('disabled', false);
	      //   // $(".submit_btn").css('background', '#fb6201');
	      // } else {
	      //   // $(".submit_btn").prop('disabled', true);
	      //   // $(".submit_btn").css('background', '#41414b');
	      // }
	      // if (doctor_id === undefined) {
	      //   // $(".submit_btn").prop('disabled', true);
	      //   // $(".submit_btn").css('background', '#41414b');
	      // }
	      var schedule_date = (0, _jquery2.default)("#schedule_date").val();
	
	      if (search_keywords && doctor_id && schedule_date) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "#187979";
	      } else if (search_keywords && doctor_id === "" && schedule_date) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "#187979";
	      } else {
	        document.getElementById("Schedule").disabled = true;
	        document.getElementById("Schedule").style.background = "gray";
	      }
	    }, _this.handleKeyUp = function (event) {
	      var data = {
	        keywords: _this.state.search_keywords
	      };
	      getSearchDoctors(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ search_doctors: records });
	        } else {
	          _this.setState({ search_doctors: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.handleSubmit = function (event, props) {
	      event.preventDefault();
	      if (_this.validateForm()) {
	
	        var selected_day_date_val = _this.state.schedule_date;
	        // let selected_day_date_val = $('.schedule_date').val();
	
	        var fields = {};
	        if (_this.props.selecteddoctorname || localStorage.getItem(_constants.SCHEDULE_DATE) || selected_day_date_val) {} else {
	          fields["schedule_date"] = "";
	        }
	        if (_this.props.doctorname || _this.props.selecteddoctorname) {} else {
	          fields["search_keywords"] = "";
	        }
	        _this.setState({ fields: fields });
	        var doctor_id = "";
	        if ((0, _jquery2.default)("input[name='doctor_id']:checked").val()) {
	          doctor_id = (0, _jquery2.default)("input[name='doctor_id']:checked").val();
	        } else {
	          doctor_id = _this.state.doctor_id;
	        }
	        if (localStorage.getItem(_constants.API_TOKEN_NAME) !== null) {
	
	          var token = localStorage.getItem(_constants.API_TOKEN_NAME);
	          var user_role = localStorage.getItem(_constants.USER_ROLE);
	          var user_email = localStorage.getItem(_constants.USER_EMAIL);
	          var patient_id = localStorage.getItem(_constants.USER_ID);
	          var login_phone_number = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	          var search_selected_doc_id = doctor_id;
	          var schedule_date = "";
	          if (selected_day_date_val !== "") {
	            schedule_date = selected_day_date_val;
	          } else {
	            if (_this.state.schedule_date === "") {
	              if (localStorage.getItem(_constants.SCHEDULE_DATE)) {
	                schedule_date = localStorage.getItem(_constants.SCHEDULE_DATE);
	              } else {
	                schedule_date = _this.state.schedule_date;
	              }
	            } else {
	              schedule_date = _this.state.schedule_date;
	            }
	          }
	          /*if(this.state.schedule_date === ''){
	            if(localStorage.getItem(SCHEDULE_DATE)){
	              schedule_date = localStorage.getItem(SCHEDULE_DATE);
	            } else {
	              schedule_date = this.state.schedule_date;
	            }
	          } else if(selected_day_date_val !=='') {
	            schedule_date = selected_day_date_val;
	          } else {
	            schedule_date = this.state.schedule_date;
	          }*/
	
	          localStorage.setItem(_constants.SEARCH_SELECTED_DOC_NAME, _this.props.doctorname);
	          var appointment_id = "";
	          var doctor_name = "";
	          var doctor_fees = "";
	          var patientName = localStorage.getItem(_constants.PATIENT_NAME);
	          var schedule_time = "";
	          var search_selected_doc_name = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME);
	          var doctor_profile_avability = "";
	          (0, _userSession.startUserSession)(token, user_role, user_email, patient_id, login_phone_number, search_selected_doc_id, schedule_date, appointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name, doctor_profile_avability);
	
	          _this.onClickPopupShow();
	        } else {
	
	          var _token = "";
	          var _user_role = "2";
	          var _user_email = "";
	          var _patient_id = "";
	          var _login_phone_number = "";
	          var _search_selected_doc_id = doctor_id;
	          var _schedule_date = "";
	          if (selected_day_date_val !== "") {
	            _schedule_date = selected_day_date_val;
	          } else {
	            if (_this.state.schedule_date === "") {
	              if (localStorage.getItem(_constants.SCHEDULE_DATE)) {
	                _schedule_date = localStorage.getItem(_constants.SCHEDULE_DATE);
	              } else {
	                _schedule_date = _this.state.schedule_date;
	              }
	            } else {
	              _schedule_date = _this.state.schedule_date;
	            }
	          }
	          /*if(this.state.schedule_date === ''){
	            if(localStorage.getItem(SCHEDULE_DATE)){
	              schedule_date = localStorage.getItem(SCHEDULE_DATE);
	            } else {
	              schedule_date = this.state.schedule_date;
	            }
	          } else {
	            schedule_date = this.state.schedule_date;
	          }*/
	          var _appointment_id = "";
	          var _doctor_name = "";
	          var _doctor_fees = "";
	          var _patientName = "";
	          var _schedule_time = "";
	          var _search_selected_doc_name = "";
	          var _doctor_profile_avability = "";
	          (0, _userSession.startUserSession)(_token, _user_role, _user_email, _patient_id, _login_phone_number, _search_selected_doc_id, _schedule_date, _appointment_id, _doctor_name, _doctor_fees, _patientName, _schedule_time, _search_selected_doc_name, _doctor_profile_avability);
	        }
	        _this.onClickPopupShow();
	      } else {}
	    }, _this.onClickPopupShow = function () {
	      if (_this.state.showSingleDoctorProfilePopup === true) {
	        _this.setState({
	          showSingleDoctorProfilePopup: false,
	          showPopup: true
	        });
	      } else {
	        _this.setState({
	          showSingleDoctorProfilePopup: true,
	          showPopup: false
	        });
	      }
	    }, _this.closePopup = function (event) {
	      (0, _jquery2.default)(".doctor_search_list_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".doctor_search_list_popup").removeClass("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	      _this.setState({
	        showPopup: false
	      });
	    }, _this.refreshGetSearchDoctors = function (doctor_name) {
	      var data = {
	        keywords: doctor_name
	      };
	
	      getSearchDoctors(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ search_doctors: records });
	          if (records.length === 1) {
	            (0, _jquery2.default)("input[name='doctor_id']").prop("checked", true);
	          }
	        } else {
	          _this.setState({ search_doctors: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SubPopupIndex2, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var selected_day_date_val = (0, _jquery2.default)(".schedule_date").val();
	      // console.log(selected_day_date_val,"shamim")
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      console.log("this.props.selecteddoctornamet", this.props.selecteddoctorname);
	      console.log("localStorage.getItem(SCHEDULE_DATE)", localStorage.getItem(_constants.SCHEDULE_DATE));
	
	      /* if (
	        this.props.selecteddoctorname ||
	        localStorage.getItem(SCHEDULE_DATE) ||
	        selected_day_date_val
	      ) {
	      } else {
	        if (!fields["#schedule_date"]) {
	          formIsValid = false;
	          errors["#schedule_date"] = "*Please select your schedule date.";
	        }
	      }
	      if (this.props.doctorname || this.props.selecteddoctorname) {
	      } else {
	        if (!fields["search_keywords"]) {
	          formIsValid = false;
	          errors["search_keywords"] = "*Please search doctor lists.";
	        }
	      } */
	
	      if (this.props.selecteddoctorname || localStorage.getItem(_constants.SCHEDULE_DATE) || selected_day_date_val) {
	        formIsValid = true;
	      } else {
	        formIsValid = false;
	        errors["#schedule_date"] = "*Please select your schedule date.";
	      }
	
	      if (this.props.doctorname || this.props.selecteddoctorname || localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME)) {
	        formIsValid = true;
	      } else {
	        formIsValid = false;
	        errors["search_keywords"] = "*Please search doctor lists.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	      /* const selectedScheduledDate = this.state.schedule_date;
	      if (localStorage.getItem(SCHEDULE_DATE) || selectedScheduledDate) {
	      } else {
	        if (!fields["schedule_date"]) {
	          formIsValid = false;
	          errors["schedule_date"] = "*Please select your schedule date.";
	        }
	      }
	      if (localStorage.getItem(SEARCH_SELECTED_DOC_NAME)) {
	      } else {
	        if (!fields["search_keywords"]) {
	          formIsValid = false;
	          errors["search_keywords"] = "*Please search doctor lists.";
	        }
	      }
	      // if (!fields["doctor_id"]) {
	      //     formIsValid = false;
	      //     errors["doctor_id"] = "*Please select atleast one doctor from doctors lists.";
	      // }
	      this.setState({
	        errors: errors,
	      });
	      return formIsValid; */
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({
	        showPopup: this.props.showPopup
	      });
	      //console.log(this.props.selected_doctor_avability_day);
	
	      if (this.props.selecteddoctorname) {
	        (0, _jquery2.default)(".search_keywords").val(this.props.selecteddoctorname);
	        this.refreshGetSearchDoctors(this.props.selecteddoctorname);
	      }
	      if (this.props.doctorname) {
	        (0, _jquery2.default)(".search_keywords").val(this.props.doctorname);
	        this.refreshGetSearchDoctors(this.props.doctorname);
	      }
	      if (localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME)) {
	        this.refreshGetSearchDoctors(localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var current_date = new Date();
	      var newcurrentdate = (0, _moment2.default)(current_date).format("YYYY-MM-DD");
	      var days_name = this.props.selected_doctor_avability_day;
	      if (days_name) {
	        var dayOfWeekAsString = function dayOfWeekAsString(day) {
	          //let final_day_name = day.charAt(0).toUpperCase() + day.slice(1);
	          /*const firstLetter = day.charAt(0);
	          const firstLetterCap = firstLetter.toUpperCase();
	          const remainingLetters = day.slice(1);
	          const final_day_name = firstLetterCap + remainingLetters;*/
	          return ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].indexOf(day);
	        };
	
	        var formatDate = function formatDate(date) {
	          var d = new Date(date),
	              month = "" + (d.getMonth() + 1),
	              day = "" + d.getDate(),
	              year = d.getFullYear();
	
	          if (month.length < 2) month = "0" + month;
	          if (day.length < 2) day = "0" + day;
	
	          return [year, month, day].join("-");
	        };
	
	        var current_date_day = new Date();
	
	        var days_number = dayOfWeekAsString(this.props.selected_doctor_avability_day);
	        current_date_day.setDate(current_date_day.getDate() + (days_number + 7 - current_date_day.getDay()) % 7);
	
	
	        var formate_current_date = formatDate(current_date_day);
	        if (formate_current_date) {
	          //this.setState({schedule_date: formate_current_date});
	          /* $('.schedule_date').val(formate_current_date);
	          $(".submit_btn").prop('disabled', false);
	          $(".submit_btn").css('background', '#fb6201'); */
	        } else {
	            //this.setState({schedule_date: ''});
	            /* $('.schedule_date').val('');
	            $(".submit_btn").prop('disabled', true);
	            $(".submit_btn").css('background', '#41414b'); */
	          }
	      } else {
	        var go_back_date = (0, _jquery2.default)(".schedule_date").val();
	        if (go_back_date) {
	          /* $('.schedule_date').val('');
	          $(".submit_btn").prop('disabled', true);
	          $(".submit_btn").css('background', '#41414b'); */
	        }
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            className: this.state.showPopup ? "offcanvas offcanvas-start show doctor_search_list_popup" : "offcanvas offcanvas-start doctor_search_list_popup",
	            tabIndex: "-1",
	            id: "offcanvasExample",
	            "aria-labelledby": "offcanvasExampleLabel",
	            style: { visibility: "visible" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-header" },
	            _react2.default.createElement(
	              "h5",
	              { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	              " "
	            ),
	            _react2.default.createElement("button", {
	              type: "button",
	              className: "btn-close text-reset",
	              "data-bs-dismiss": "offcanvas",
	              "aria-label": "Close",
	              onClick: this.closePopup
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-body" },
	            _react2.default.createElement(
	              "div",
	              { className: "row text-center", id: "logos" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-2 " },
	                _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" }),
	                console.log(this.state.selectedDate, "dfsdf")
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "left-offcanvas" },
	              _react2.default.createElement(
	                "div",
	                { className: "offcan-top-mar" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Book Appointments"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Enter Doctor's Name or relevant Department"
	                )
	              ),
	              _react2.default.createElement(
	                "form",
	                {
	                  onSubmit: this.handleSubmit,
	                  className: "needs-validation",
	                  noValidate: true
	                },
	                _react2.default.createElement("input", {
	                  placeholder: "Enter doctor name",
	                  type: "text",
	                  name: "search_keywords",
	                  id: "search_keywords",
	                  className: "form-control search_keywords",
	                  value: this.state.fields.search_keywords,
	                  onChange: this.handleChange,
	                  onKeyUp: this.handleKeyUp,
	                  required: true,
	                  autoComplete: "off"
	                }),
	                _react2.default.createElement(
	                  "span",
	                  { style: alertStyle },
	                  this.state.errors.search_keywords
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-3" },
	                  this.state.search_doctors.length > 0 ? this.state.search_doctors.slice(0, this.state.limit).map(function (search_doctor) {
	                    return _react2.default.createElement(
	                      "div",
	                      {
	                        className: "col-12 sp-0-0 mb-3",
	                        key: search_doctor.id
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "doctor-list" },
	                        _react2.default.createElement("input", {
	                          type: "radio",
	                          className: "doctor_id",
	                          name: "doctor_id",
	                          value: search_doctor.uhl_id,
	                          onChange: _this2.handleChange,
	                          deptid: search_doctor.dept_id
	                        }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              className: "col-3",
	                              style: { paddingLeft: "0px" }
	                            },
	                            search_doctor.doctor_profile ? _react2.default.createElement("img", {
	                              src: _constants.IMAGE_URL + "/DoctorProfileImg/" + search_doctor.doctor_profile,
	                              alt: "doctor profile"
	                            }) :
	                            /*<img src={doc} alt="doc"/>*/
	                            _react2.default.createElement("img", {
	                              src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                              alt: "doc"
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-9 mt-2" },
	                            _react2.default.createElement(
	                              "h5",
	                              null,
	                              search_doctor.doctor_name
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              search_doctor.degree !== "" ? search_doctor.degree : "Endocrinology & Metabolism) MD (Endocrinology & Metabolism)"
	                            )
	                          )
	                        )
	                      )
	                    );
	                  }) : _react2.default.createElement("div", { className: "col-12 sp-0-0 mb-3" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-6" },
	                    _react2.default.createElement(_reactDatepicker2.default, {
	                      id: "schedule_date",
	                      name: "schedule_date",
	                      className: "form-control schedule_date",
	                      autoComplete: "off",
	                      selected: this.state.selectedDate,
	                      onChange: this.handleDateChange
	                      // selected={rawDate}
	                      // value={rawDate}
	                      // onChange={(date) => handleDateChange(date)}
	                      , dateFormat: "dd/MM/yyyy",
	                      placeholderText: "DD/MM/YYYY",
	                      showDateMonthYearPicker: true
	                    }),
	                    _react2.default.createElement(
	                      "span",
	                      { style: alertStyle },
	                      this.state.errors.schedule_date
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-6" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        variant: "primary",
	                        type: "submit",
	                        id: "Schedule",
	                        className: "btn-links submit_btn"
	                      },
	                      "Check Schedule"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	        ),
	        this.state.showSingleDoctorProfilePopup ? _react2.default.createElement(_SubPopupIndex2.default, {
	          showPopup: this.state.showSingleDoctorProfilePopup,
	          doctorname: this.state.doctor_name,
	          schedule_date: this.state.schedule_date,
	          doctorid: this.state.doctor_id
	        }) : null
	      );
	    }
	  }]);
	
	  return SubPopupIndex2;
	}(_react.Component);
	
	exports.default = SubPopupIndex2;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * const result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	  if (!amount) {
	    // If 0 months, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	  var dayOfMonth = date.getDate();
	
	  // The JS Date object supports date math by accepting out-of-bounds values for
	  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
	  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
	  // want except that dates will wrap around the end of a month, meaning that
	  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
	  // we'll default to the end of the desired month by adding 1 to the desired
	  // month and using a date of 0 to back up one day to the end of the desired
	  // month.
	  var endOfDesiredMonth = new Date(date.getTime());
	  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
	  var daysInMonth = endOfDesiredMonth.getDate();
	  if (dayOfMonth >= daysInMonth) {
	    // If we're already at the end of the month, then this is the correct date
	    // and we're done.
	    return endOfDesiredMonth;
	  } else {
	    // Otherwise, we now know that setting the original day-of-month value won't
	    // cause an overflow, so set the desired day-of-month. Note that we can't
	    // just set the date of `endOfDesiredMonth` because that object may have had
	    // its time changed in the unusual case where where a DST transition was on
	    // the last day of the month and its local time was in the hour skipped or
	    // repeated next to a DST transition.  So we use `date` instead which is
	    // guaranteed to still have the original time.
	    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
	    return date;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 116 */
8,
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/hotline_phone.5ed39503.svg";

/***/ },
/* 118 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(907),
	    listCacheDelete = __webpack_require__(908),
	    listCacheGet = __webpack_require__(909),
	    listCacheHas = __webpack_require__(910),
	    listCacheSet = __webpack_require__(911);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(253);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(157),
	    getRawTag = __webpack_require__(894),
	    objectToString = __webpack_require__(920);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(904);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(89);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 124 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	// THIS FILE IS AUTO GENERATED
	var GenIcon = __webpack_require__(76).GenIcon
	module.exports.TfiAgenda = function TfiAgenda (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14 2v-2h-13v17h13v-2h2v-13h-2zM2 16v-15h2v15h-2zM13 16h-8v-15h8v15zM15 14h-1v-3h1v3zM15 10h-1v-3h1v3zM14 6v-3h1v3h-1zM6 4h5v1h-5v-1zM6 6h4v1h-4v-1z"}}]})(props);
	};
	module.exports.TfiAlarmClock = function TfiAlarmClock (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.714 6.791c0.504-0.512 0.786-1.181 0.786-1.903 0-1.503-1.223-2.726-2.725-2.726-0.886 0-1.695 0.434-2.207 1.15-0.501-0.155-1.026-0.249-1.568-0.287v-1.025h1v-1h-3v1h1v1.025c-0.542 0.038-1.067 0.132-1.568 0.287-0.512-0.717-1.32-1.15-2.207-1.15-1.502 0-2.725 1.223-2.725 2.726 0 0.723 0.282 1.392 0.786 1.903-0.499 0.962-0.786 2.052-0.786 3.209 0 1.707 0.616 3.271 1.635 4.487l-1.285 1.713 0.8 0.6 1.192-1.59c1.239 1.109 2.868 1.79 4.658 1.79s3.419-0.681 4.658-1.79l1.192 1.59 0.8-0.6-1.285-1.713c1.019-1.216 1.635-2.78 1.635-4.487 0-1.157-0.287-2.247-0.786-3.209zM12.775 3.162c0.951 0 1.725 0.774 1.725 1.726 0 0.373-0.12 0.724-0.335 1.017-0.678-0.936-1.581-1.694-2.63-2.202 0.322-0.339 0.762-0.541 1.24-0.541zM2.5 4.888c0-0.951 0.774-1.726 1.725-1.726 0.478 0 0.918 0.202 1.24 0.54-1.049 0.508-1.951 1.267-2.63 2.202-0.215-0.293-0.335-0.643-0.335-1.016zM8.5 16c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zM9 10h4v1h-5v-4h1v3z"}}]})(props);
	};
	module.exports.TfiAlert = function TfiAlert (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.454 1.492l-8.242 14.508h16.581l-8.339-14.508zM8.459 3.508l6.605 11.492h-13.134l6.529-11.492zM9 10.938h-1v-3.938h1v3.938zM9.5 13.031c0 0.552-0.447 1-1 1s-1-0.448-1-1 0.447-1 1-1 1 0.448 1 1z"}}]})(props);
	};
	module.exports.TfiAlignCenter = function TfiAlignCenter (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 2v1h-17v-1h17zM1.5 6v1h14v-1h-14zM0 11h17v-1h-17v1zM3.5 15h10v-1h-10v1z"}}]})(props);
	};
	module.exports.TfiAlignJustify = function TfiAlignJustify (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 2v1h-17v-1h17zM0 7h17v-1h-17v1zM0 11h17v-1h-17v1zM0 15h17v-1h-17v1z"}}]})(props);
	};
	module.exports.TfiAlignLeft = function TfiAlignLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 2v1h-17v-1h17zM14 6h-14v1h14v-1zM0 11h17v-1h-17v1zM0 15h10v-1h-10v1z"}}]})(props);
	};
	module.exports.TfiAlignRight = function TfiAlignRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 2v1h-17v-1h17zM3 7h14v-1h-14v1zM0 11h17v-1h-17v1zM7 15h10v-1h-10v1z"}}]})(props);
	};
	module.exports.TfiAnchor = function TfiAnchor (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.291 12.592l-1.57-3.127-3.127 1.568 0.448 0.895 1.871-0.939c-0.373 1.907-1.956 3.365-3.913 3.585v-7.574h1.5v-1h-1.5v-1.051c1.14-0.232 2-1.241 2-2.449 0-1.379-1.122-2.5-2.5-2.5s-2.5 1.121-2.5 2.5c0 1.208 0.86 2.217 2 2.449v1.051h-1.5v1h1.5v7.574c-1.955-0.22-3.538-1.676-3.912-3.58l1.86 0.934 0.448-0.895-3.127-1.568-1.57 3.127 0.894 0.449 0.651-1.298c0.693 2.245 2.787 3.882 5.256 3.882 2.464 0 4.556-1.63 5.252-3.867l0.645 1.283 0.894-0.449zM7 2.5c0-0.827 0.673-1.5 1.5-1.5s1.5 0.673 1.5 1.5-0.673 1.5-1.5 1.5-1.5-0.673-1.5-1.5z"}}]})(props);
	};
	module.exports.TfiAndroid = function TfiAndroid (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M3.809 5.696h9.383v6.807c0 0.623-0.502 1.125-1.113 1.125h-0.769v2.32c0 0.583-0.469 1.052-1.051 1.052-0.583 0-1.055-0.47-1.055-1.052v-2.32h-1.408v2.32c0 0.582-0.472 1.052-1.055 1.052-0.571 0-1.042-0.47-1.042-1.052l-0.009-2.32h-0.757c-0.622 0-1.124-0.501-1.124-1.125v-6.807zM2.357 5.502c-0.582 0-1.053 0.471-1.053 1.042v4.396c0 0.583 0.471 1.052 1.053 1.052s1.042-0.47 1.042-1.052v-4.396c0-0.571-0.468-1.042-1.042-1.042zM13.222 5.328h-9.454c0-1.625 0.972-3.036 2.413-3.771l-0.727-1.338c-0.041-0.072-0.021-0.164 0.051-0.205 0.071-0.031 0.164-0.011 0.205 0.062l0.735 1.349c0.625-0.277 1.32-0.43 2.055-0.43s1.43 0.153 2.055 0.429l0.735-1.349c0.041-0.072 0.134-0.092 0.205-0.062 0.072 0.041 0.092 0.133 0.051 0.205l-0.727 1.338c1.432 0.736 2.403 2.147 2.403 3.772zM6.741 3.223c0-0.215-0.173-0.399-0.397-0.399-0.216 0-0.389 0.184-0.389 0.399 0 0.214 0.173 0.398 0.389 0.398 0.224 0.001 0.397-0.183 0.397-0.398zM11.045 3.223c0-0.215-0.173-0.399-0.389-0.399-0.225 0-0.397 0.184-0.397 0.399 0 0.214 0.173 0.398 0.397 0.398 0.216 0.001 0.389-0.183 0.389-0.398zM14.643 5.502c-0.573 0-1.042 0.46-1.042 1.042v4.396c0 0.583 0.469 1.052 1.042 1.052 0.582 0 1.053-0.47 1.053-1.052v-4.396c-0.001-0.582-0.471-1.042-1.053-1.042z"}}]})(props);
	};
	module.exports.TfiAngleDoubleDown = function TfiAngleDoubleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 10.644l-6.854-6.854 0.707-0.707 6.147 6.146 6.146-6.146 0.707 0.707-6.853 6.854zM8.5 14.074l-6.146-6.147-0.708 0.707 6.854 6.854 6.854-6.854-0.707-0.707-6.147 6.147z"}}]})(props);
	};
	module.exports.TfiAngleDoubleLeft = function TfiAngleDoubleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M7.987 8.5l6.146 6.146-0.707 0.707-6.853-6.853 6.854-6.854 0.707 0.707-6.147 6.147zM9.29 2.353l-0.707-0.707-6.854 6.854 6.854 6.854 0.707-0.707-6.146-6.147 6.146-6.147z"}}]})(props);
	};
	module.exports.TfiAngleDoubleRight = function TfiAngleDoubleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.644 8.5l-6.854 6.854-0.707-0.707 6.146-6.147-6.146-6.146 0.707-0.708 6.854 6.854zM7.634 1.646l-0.707 0.708 6.146 6.146-6.146 6.146 0.707 0.707 6.853-6.853-6.853-6.854z"}}]})(props);
	};
	module.exports.TfiAngleDoubleUp = function TfiAngleDoubleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 6.073l6.854 6.854-0.707 0.707-6.147-6.147-6.146 6.146-0.707-0.707 6.853-6.853zM8.5 2.644l6.146 6.146 0.707-0.707-6.853-6.854-6.854 6.854 0.708 0.707 6.146-6.146z"}}]})(props);
	};
	module.exports.TfiAngleDown = function TfiAngleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.354 5.075l-7.855 7.854-7.853-7.854 0.707-0.707 7.145 7.146 7.148-7.147 0.708 0.708z"}}]})(props);
	};
	module.exports.TfiAngleLeft = function TfiAngleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z"}}]})(props);
	};
	module.exports.TfiAngleRight = function TfiAngleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z"}}]})(props);
	};
	module.exports.TfiAngleUp = function TfiAngleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.354 11.896l-0.707 0.707-7.147-7.146-7.146 7.146-0.707-0.707 7.853-7.853 7.854 7.853z"}}]})(props);
	};
	module.exports.TfiAnnouncement = function TfiAnnouncement (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.469 2.222h-1.927c-0.292 0-0.531 0.234-0.531 0.521v0.667l-10.995 4.030v-0.27c0-0.43-0.358-0.781-0.797-0.781h-1.422c-0.439 0-0.797 0.351-0.797 0.781v4.688c0 0.429 0.358 0.781 0.797 0.781h1.422c0.438 0 0.797-0.352 0.797-0.781v-0.331l1.034 0.189c-0.023 0.163-0.038 0.326-0.038 0.491 0 1.897 1.561 3.441 3.479 3.441 1.657 0 3.030-1.128 3.38-2.682l3.14 0.576v0.659c0 0.287 0.239 0.521 0.531 0.521h1.927c0.292 0 0.531-0.234 0.531-0.521v-11.458c0-0.287-0.239-0.521-0.531-0.521zM7.491 14.648c-1.367 0-2.479-1.095-2.479-2.441 0-0.104 0.027-0.205 0.040-0.308l4.84 0.888c-0.264 1.082-1.235 1.861-2.401 1.861zM16 13.722h-0.989v-1.013l-12.995-2.383v1.312h-1.016v-4.25h1.016v1.484l12.995-4.763v-0.887h0.989v10.5z"}}]})(props);
	};
	module.exports.TfiApple = function TfiApple (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.001 11.125c-0.469-0.674-0.704-1.44-0.704-2.278 0-0.776 0.225-1.482 0.664-2.115 0.245-0.357 0.633-0.756 1.165-1.205-0.347-0.43-0.706-0.777-1.063-1.022-0.634-0.439-1.358-0.664-2.176-0.664-0.501 0-1.093 0.123-1.767 0.347-0.675 0.235-1.165 0.348-1.461 0.348-0.236 0-0.706-0.102-1.411-0.307-0.715-0.204-1.308-0.306-1.808-0.306-1.176 0-2.136 0.491-2.901 1.471-0.766 0.991-1.154 2.258-1.154 3.821 0 1.675 0.511 3.381 1.501 5.139 1.011 1.757 2.023 2.646 3.075 2.646 0.337 0 0.787-0.112 1.349-0.348 0.553-0.224 1.042-0.337 1.451-0.337 0.419 0 0.939 0.102 1.542 0.327 0.614 0.214 1.083 0.327 1.431 0.327 0.868 0 1.747-0.665 2.626-2.003 0.592-0.889 1.001-1.747 1.256-2.554-0.602-0.183-1.144-0.612-1.615-1.287zM13.523 14.418c-0.657 1-1.293 1.552-1.79 1.552-0.147 0-0.459-0.047-1.081-0.264-0.693-0.259-1.33-0.39-1.892-0.39-0.541 0-1.155 0.138-1.838 0.415-0.58 0.243-0.865 0.269-0.961 0.269-0.628 0-1.412-0.762-2.204-2.137-0.923-1.639-1.372-3.159-1.372-4.648 0-1.336 0.31-2.387 0.942-3.206 0.579-0.741 1.251-1.086 2.113-1.086 0.401 0 0.902 0.088 1.529 0.267 1.051 0.305 1.444 0.346 1.689 0.346 0.425 0 1.010-0.132 1.777-0.399 0.589-0.196 1.077-0.296 1.45-0.296 0.609 0 1.135 0.159 1.61 0.489 0.066 0.046 0.135 0.098 0.204 0.155-0.228 0.236-0.414 0.461-0.562 0.677-0.56 0.806-0.843 1.709-0.843 2.686 0 1.048 0.297 2.006 0.884 2.85 0.354 0.505 0.748 0.908 1.182 1.206-0.217 0.499-0.498 1.006-0.837 1.514zM9.424 3.964c-0.235 0.072-0.582 0.133-1.062 0.174 0.021-1.011 0.286-1.89 0.797-2.625 0.511-0.737 1.368-1.237 2.555-1.513 0.020 0.092 0.040 0.164 0.050 0.225 0 0.071 0.011 0.132 0.011 0.204 0 0.419-0.102 0.889-0.296 1.39-0.204 0.511-0.521 0.981-0.951 1.41-0.368 0.367-0.736 0.612-1.104 0.735z"}}]})(props);
	};
	module.exports.TfiArchive = function TfiArchive (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 2h-17v4h1v11h15v-11h1v-4zM15 16h-13v-10h13v10zM16 5h-15v-2h15v2zM6 11h5.016c1.103 0 2-0.897 2-2s-0.897-2-2-2h-5.016c-1.103 0-2 0.897-2 2s0.897 2 2 2zM6 8h5.016c0.552 0 1 0.448 1 1s-0.448 1-1 1h-5.016c-0.552 0-1-0.448-1-1s0.448-1 1-1z"}}]})(props);
	};
	module.exports.TfiArrowCircleDown = function TfiArrowCircleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.146 6.146l0.707 0.707-4.353 4.354-4.354-4.353 0.707-0.707 3.647 3.646 3.646-3.647zM17 8.5c0 4.687-3.813 8.5-8.5 8.5s-8.5-3.813-8.5-8.5 3.813-8.5 8.5-8.5 8.5 3.813 8.5 8.5zM16 8.5c0-4.136-3.364-7.5-7.5-7.5s-7.5 3.364-7.5 7.5 3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5z"}}]})(props);
	};
	module.exports.TfiArrowCircleLeft = function TfiArrowCircleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M10.854 4.854l-3.647 3.646 3.646 3.646-0.707 0.707-4.353-4.353 4.354-4.354 0.707 0.708zM17 8.5c0 4.687-3.813 8.5-8.5 8.5s-8.5-3.813-8.5-8.5 3.813-8.5 8.5-8.5 8.5 3.813 8.5 8.5zM16 8.5c0-4.136-3.364-7.5-7.5-7.5s-7.5 3.364-7.5 7.5 3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5z"}}]})(props);
	};
	module.exports.TfiArrowCircleRight = function TfiArrowCircleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M6.854 4.146l4.353 4.354-4.354 4.354-0.707-0.707 3.647-3.647-3.647-3.646 0.708-0.708zM17 8.5c0 4.687-3.813 8.5-8.5 8.5s-8.5-3.813-8.5-8.5 3.813-8.5 8.5-8.5 8.5 3.813 8.5 8.5zM16 8.5c0-4.136-3.364-7.5-7.5-7.5s-7.5 3.364-7.5 7.5 3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5z"}}]})(props);
	};
	module.exports.TfiArrowCircleUp = function TfiArrowCircleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 5.793l4.354 4.354-0.707 0.707-3.647-3.647-3.646 3.646-0.707-0.707 4.353-4.353zM17 8.5c0 4.687-3.813 8.5-8.5 8.5s-8.5-3.813-8.5-8.5 3.813-8.5 8.5-8.5 8.5 3.813 8.5 8.5zM16 8.5c0-4.136-3.364-7.5-7.5-7.5s-7.5 3.364-7.5 7.5 3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5z"}}]})(props);
	};
	module.exports.TfiArrowDown = function TfiArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.854 8.854l-7.354 7.353-7.354-7.353 0.707-0.707 6.147 6.146v-13.293h1v13.293l6.146-6.146 0.708 0.707z"}}]})(props);
	};
	module.exports.TfiArrowLeft = function TfiArrowLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16 8.972h-12.793l6.146 6.146-0.707 0.707-7.353-7.353 7.354-7.354 0.707 0.707-6.147 6.147h12.793v1z"}}]})(props);
	};
	module.exports.TfiArrowRight = function TfiArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.707 8.472l-7.354 7.354-0.707-0.707 6.146-6.146h-12.792v-1h12.793l-6.147-6.148 0.707-0.707 7.354 7.354z"}}]})(props);
	};
	module.exports.TfiArrowTopLeft = function TfiArrowTopLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.292 13l-10.317-10.297v7.297h-1v-9.003h9.025v1h-7.316l10.315 10.295-0.707 0.708z"}}]})(props);
	};
	module.exports.TfiArrowTopRight = function TfiArrowTopRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16 0.997v9.003h-1v-7.297l-10.317 10.297-0.707-0.708 10.315-10.295h-7.316v-1h9.025z"}}]})(props);
	};
	module.exports.TfiArrowUp = function TfiArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.146 8.854l-6.146-6.147v13.293h-1v-13.293l-6.146 6.147-0.708-0.708 7.354-7.353 7.354 7.354-0.708 0.707z"}}]})(props);
	};
	module.exports.TfiArrow = function TfiArrow (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13.603 11.349l-0.706-0.708 1.644-1.641h-5.541v5.541l1.641-1.644 0.708 0.706-2.849 2.855-2.849-2.855 0.708-0.706 1.641 1.644v-5.541h-5.541l1.644 1.641-0.706 0.708-2.855-2.849 2.855-2.849 0.706 0.708-1.644 1.641h5.541v-5.541l-1.641 1.644-0.708-0.706 2.849-2.855 2.849 2.855-0.708 0.706-1.641-1.644v5.541h5.541l-1.644-1.641 0.706-0.708 2.855 2.849-2.855 2.849z"}}]})(props);
	};
	module.exports.TfiArrowsCorner = function TfiArrowsCorner (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 9.5v5.5h-5.5v-1h3.803l-10.303-10.303v3.803h-1v-5.5h5.5v1h-3.783l10.283 10.283v-3.783h1z"}}]})(props);
	};
	module.exports.TfiArrowsHorizontal = function TfiArrowsHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.716 8.5l-3.954 3.858-0.698-0.716 2.707-2.642h-12.542l2.708 2.642-0.698 0.716-3.955-3.858 3.954-3.858 0.698 0.716-2.707 2.642h12.543l-2.708-2.642 0.698-0.716 3.954 3.858z"}}]})(props);
	};
	module.exports.TfiArrowsVertical = function TfiArrowsVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M11.642 12.063l0.716 0.698-3.858 3.955-3.858-3.954 0.716-0.698 2.642 2.707v-12.542l-2.642 2.708-0.716-0.699 3.858-3.954 3.858 3.954-0.716 0.698-2.642-2.707v12.543l2.642-2.709z"}}]})(props);
	};
	module.exports.TfiBackLeft = function TfiBackLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 7.5c0 3.033-2.467 5.5-5.5 5.5h-2.912l2.646 2.646-0.707 0.707-3.853-3.853 3.854-3.854 0.707 0.707-2.647 2.647h2.912c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5h-7.083v-1h7.083c3.033 0 5.5 2.467 5.5 5.5z"}}]})(props);
	};
	module.exports.TfiBackRight = function TfiBackRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.583 15v1h-7.083c-3.032 0-5.5-2.467-5.5-5.5s2.468-5.5 5.5-5.5h2.912l-2.646-2.646 0.707-0.707 3.853 3.853-3.853 3.854-0.707-0.708 2.646-2.646h-2.912c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5h7.083z"}}]})(props);
	};
	module.exports.TfiBag = function TfiBag (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13 4v-2.394c0-0.885-0.737-1.606-1.643-1.606h-5.699c-0.905 0-1.642 0.721-1.642 1.606v2.394h-3.016v13h15v-13h-3zM5.016 1.606c0-0.334 0.288-0.606 0.642-0.606h5.699c0.355 0 0.643 0.272 0.643 0.606v2.394h-6.984v-2.394zM15 16h-13v-8h13v8zM15 7h-13v-2h2.016v0.643h1v-0.643h6.984v0.643h1v-0.643h2v2z"}}]})(props);
	};
	module.exports.TfiBarChartAlt = function TfiBarChartAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 16v1h-17v-1h17zM12 10h2v5h1v-6h-4v6h1v-5zM7 7h2v8h1v-9h-4v9h1v-8zM2 3h2v12h1v-13h-4v13h1v-12z"}}]})(props);
	};
	module.exports.TfiBarChart = function TfiBarChart (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 16v1h-17v-1h17zM2 10h2v5h1v-6h-4v6h1v-5zM7 7h2v8h1v-9h-4v9h1v-8zM12 3h2v12h1v-13h-4v13h1v-12z"}}]})(props);
	};
	module.exports.TfiBasketball = function TfiBasketball (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.516 0c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.814-8.5-8.5-8.5zM12.989 8c0.098-1.46 0.615-2.855 1.497-4.020 0.86 1.133 1.404 2.515 1.504 4.020h-3.001zM15.99 9c-0.1 1.505-0.644 2.888-1.505 4.021-0.881-1.166-1.398-2.561-1.495-4.021h3zM13.826 3.209c-1.094 1.371-1.733 3.040-1.837 4.791h-2.989v-6.976c1.879 0.122 3.574 0.929 4.826 2.185zM8 1.026v6.974h-2.96c-0.102-1.752-0.741-3.42-1.834-4.791 1.244-1.249 2.927-2.055 4.794-2.183zM1.041 8c0.1-1.505 0.644-2.888 1.505-4.021 0.881 1.165 1.397 2.56 1.495 4.021h-3zM4.040 9c-0.097 1.462-0.612 2.856-1.494 4.021-0.861-1.133-1.405-2.516-1.505-4.021h2.999zM3.205 13.791c1.095-1.371 1.733-3.039 1.835-4.791h2.96v6.974c-1.867-0.128-3.55-0.934-4.795-2.183zM9 15.976v-6.976h2.99c0.103 1.751 0.742 3.42 1.835 4.792-1.252 1.255-2.946 2.062-4.825 2.184z"}}]})(props);
	};
	module.exports.TfiBell = function TfiBell (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.312 14.125c-0.014-0.013-1.312-1.294-1.312-3.21v-3.292c0-3.101-2.468-5.623-5.5-5.623s-5.5 2.522-5.5 5.623v3.292c0 1.861-1.306 3.203-1.318 3.216l-0.843 0.853h15.357l-0.884-0.859zM3.052 13.984c0.444-0.692 0.948-1.764 0.948-3.069v-3.292c0-2.549 2.019-4.623 4.5-4.623s4.5 2.074 4.5 4.623v3.292c0 1.32 0.495 2.383 0.938 3.069h-10.886zM9 2h-1v-1h1v1zM9 15h1c0 0.827-0.673 1.5-1.5 1.5s-1.5-0.673-1.5-1.5h1c0 0.276 0.225 0.5 0.5 0.5s0.5-0.224 0.5-0.5z"}}]})(props);
	};
	module.exports.TfiBlackboard = function TfiBlackboard (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9 2v-2h-1v2h-7v10h15v-10h-7zM15 11h-13v-8h13v8zM3.5 13h10v1h-2.584l1.504 2.326-0.84 0.543-1.855-2.869h-0.725v3h-1v-3h-0.712l-1.869 2.87-0.838-0.545 1.514-2.325h-2.595v-1z"}}]})(props);
	};
	module.exports.TfiBoltAlt = function TfiBoltAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M11.83 8l-3.826 7.233-0.884-0.467 3.050-5.766h-5.109l4.9-7.279 0.829 0.559-3.851 5.72h4.891z"}}]})(props);
	};
	module.exports.TfiBolt = function TfiBolt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.313 2.012h-7.152l-2.331 7.014h1.666l-2.010 6.052 9.483-8.051h-2.904l3.248-5.015zM11.247 8.027l-4.687 3.979 1.322-3.979h-1.665l1.665-5.015h4.592l-3.248 5.015h2.021z"}}]})(props);
	};
	module.exports.TfiBook = function TfiBook (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.592 1.152c-0.053-0.010-1.321-0.244-2.981-0.244-2.105 0-3.828 0.366-5.125 1.088-1.518-0.765-3.264-1.152-5.196-1.152-1.681 0-2.866 0.302-2.915 0.315l-0.375 0.098 0.001 13.906 0.624-0.161c0.011-0.002 1.12-0.283 2.665-0.283 1.447 0 2.771 0.24 3.96 0.703v0.828h2.5v-0.856c1.281-0.488 2.747-0.611 3.86-0.611 1.562 0 2.786 0.225 2.798 0.227l0.592 0.11v-13.891l-0.408-0.077zM1 13.907v-11.858c0.451-0.084 1.277-0.205 2.29-0.205 1.761 0 3.339 0.36 4.71 1.044v11.776c-1.403-0.617-2.977-0.945-4.71-0.945-0.969 0-1.773 0.101-2.29 0.188zM16 13.938c-0.536-0.070-1.393-0.154-2.39-0.154-1.848 0-3.381 0.298-4.61 0.855v-11.773c1.422-0.78 3.271-0.958 4.61-0.958 1.023 0 1.902 0.097 2.39 0.164v11.866z"}}]})(props);
	};
	module.exports.TfiBookmarkAlt = function TfiBookmarkAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M10.027 10.074v-10.074h-6.054v10.077l3.021-2.053 3.033 2.050zM4.973 8.188v-7.188h4.055v7.191l-2.037-1.376-2.018 1.373zM16 1.007v14.993h-15v-14.993h1.974v1h-0.974v12.993h13v-12.993h-4.005v-1h5.005z"}}]})(props);
	};
	module.exports.TfiBookmark = function TfiBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M3.562 1v15.459l4.686-3.27 4.752 3.26v-15.449h-9.438zM12 14.551l-3.756-2.578-3.681 2.568v-12.541h7.437v12.551z"}}]})(props);
	};
	module.exports.TfiBriefcase = function TfiBriefcase (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M7 13v-1.5h1v0.5h1v-0.5h1v1.5h-3zM17 11h-1v6h-15v-6h-1v-8h3.616c0.938-1.83 2.805-3 4.884-3s3.947 1.171 4.884 3h3.616v8zM4.769 3h7.464c-0.825-1.233-2.21-2-3.732-2s-2.907 0.768-3.732 2zM15 11h-13v5h13v-5zM16 4h-15v6h15v-6z"}}]})(props);
	};
	module.exports.TfiBrushAlt = function TfiBrushAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 7.531c0-0.827-0.673-1.5-1.5-1.5h-4.808l0.285-0.914 0.023-3.617c0-0.827-0.673-1.5-1.5-1.5h-2c-0.827 0-1.5 0.673-1.5 1.5v3.452l0.31 1.080h-4.81c-0.827 0-1.5 0.673-1.5 1.5v3.486h0.932l-0.766 5.982h16.668l-0.766-5.982h0.932v-3.487zM15.698 16h-1.698v-2h-1v2h-1v-3h-1v3h-1v-4h-1v4h-5v-2h-1v2h-1.698l0.638-4.982h13.12l0.638 4.982zM1.060 10.018h-0.060v-2.487c0-0.276 0.224-0.5 0.5-0.5h6.165l-0.665-2.155v-3.376c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v3.393l-0.667 2.138h6.167c0.276 0 0.5 0.224 0.5 0.5v2.486h-14.94zM8 2h1v1h-1v-1z"}}]})(props);
	};
	module.exports.TfiBrush = function TfiBrush (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.913 1.782l-6.5 9.5-0.825-0.564 6.5-9.5 0.825 0.564zM9 13.992c0 1.103-0.897 2-2 2-0.203 0-0.538 0.015-0.541 0.015h-5.454l4.553-3.431c0.15-0.104 0.859-0.584 1.442-0.584 1.103 0 2 0.897 2 2zM8 13.992c0-0.551-0.449-1-1-1-0.175 0-0.582 0.203-0.853 0.393l-2.153 1.623h2.433c0.063-0.003 0.376-0.016 0.573-0.016 0.551 0 1-0.449 1-1z"}}]})(props);
	};
	module.exports.TfiCalendar = function TfiCalendar (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14 2v-1h-3v1h-5v-1h-3v1h-3v15h17v-15h-3zM12 2h1v2h-1v-2zM4 2h1v2h-1v-2zM16 16h-15v-8.921h15v8.921zM1 6.079v-3.079h2v2h3v-2h5v2h3v-2h2v3.079h-15z"}}]})(props);
	};
	module.exports.TfiCamera = function TfiCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M5.958 3v-1h-2.916v1h-3.042v12h17v-12h-11.042zM16 14h-15v-7h6.557c-0.345 0.591-0.557 1.269-0.557 2 0 2.206 1.794 4 4 4s4-1.794 4-4c0-0.731-0.212-1.409-0.557-2h1.557v7zM14 9c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zM13.618 6c-0.704-0.614-1.612-1-2.618-1s-1.914 0.386-2.618 1h-7.382v-2h15v2h-2.382z"}}]})(props);
	};
	module.exports.TfiCar = function TfiCar (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 9.984l-1.958 0.002-2.051-3.986h-7.949l-2.968 3.999-2.074 0.001v4.977h2.002c0 0.008-0.002 0.015-0.002 0.023 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.008-0.002-0.015-0.002-0.023h5.005c-0.001 0.008-0.003 0.015-0.003 0.023 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.008-0.002-0.015-0.002-0.023h2.002v-4.993zM13.918 9.987l-3.897 0.004v-2.991h2.36l1.537 2.987zM5.544 7h3.477v2.992l-5.701 0.005 2.224-2.997zM4 16c-0.551 0-1-0.449-1-1s0.449-1 1-1 1 0.449 1 1-0.449 1-1 1zM13 16c-0.551 0-1-0.449-1-1s0.449-1 1-1 1 0.449 1 1-0.449 1-1 1zM16 13.977h-1.291c-0.35-0.582-0.981-0.977-1.709-0.977s-1.359 0.395-1.709 0.977h-5.582c-0.35-0.582-0.981-0.977-1.709-0.977s-1.359 0.395-1.709 0.977h-1.291v-2.977l15-0.015v2.992z"}}]})(props);
	};
	module.exports.TfiCheckBox = function TfiCheckBox (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14 5.761h1v10.239h-14v-14h8.393v1h-7.393v12h12v-9.239zM4.854 8.146l-0.708 0.708 3.434 3.434 7.587-11.512-0.835-0.551-6.912 10.488-2.566-2.567z"}}]})(props);
	};
	module.exports.TfiCheck = function TfiCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.418 1.774l-8.833 13.485-4.918-4.386 0.666-0.746 4.051 3.614 8.198-12.515 0.836 0.548z"}}]})(props);
	};
	module.exports.TfiClip = function TfiClip (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.021 4.234v8.498h-1v-8.498c0-1.091-0.799-2.266-2.554-2.266-1.941 0-2.459 1.424-2.459 2.266v8.121h0.007v1.457c0 0.62 0.693 1.206 1.426 1.206 0.844 0 1.567-0.683 1.567-1.241v-0.27h-0.003l0.008-7.617c0-0.874-0.247-0.874-0.466-0.874-0.369 0-0.547 0.035-0.547 0.823v5.146h-1v-5.146c0-0.451 0-1.823 1.547-1.823 0.669 0 1.466 0.325 1.466 1.875l-0.007 6.43h0.002v1.457c0 1.173-1.224 2.241-2.567 2.241-1.292 0-2.426-1.031-2.426-2.206v-0.074h-0.007v-9.505c0-1.573 1.082-3.266 3.459-3.266 2.333 0.001 3.554 1.643 3.554 3.266z"}}]})(props);
	};
	module.exports.TfiClipboard = function TfiClipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16 2v15h-15v-15h2.244v1h-1.244v13h13v-13h-1.278v-1h2.278zM13 5h-9v-4h3.085c0.207-0.582 0.763-1 1.415-1s1.208 0.418 1.415 1h3.085v4zM12 2h-3v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.5h-3v2h7v-2z"}}]})(props);
	};
	module.exports.TfiClose = function TfiClose (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.207 8.5l6.646 6.646-0.707 0.707-6.646-6.646-6.646 6.646-0.707-0.707 6.646-6.646-6.647-6.646 0.707-0.707 6.647 6.646 6.646-6.646 0.707 0.707-6.646 6.646z"}}]})(props);
	};
	module.exports.TfiCloudDown = function TfiCloudDown (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 6.75c0 2.343-1.906 4.25-4.25 4.25h-2.757v-1h2.757c1.792 0 3.25-1.458 3.25-3.25s-1.458-3.25-3.25-3.25c-0.532 0-1.057 0.141-1.56 0.417l-0.354 0.195-0.265-0.306c-0.719-0.829-1.748-1.306-2.821-1.306-1.661 0-3.099 1.080-3.576 2.688l-0.126 0.422-0.435-0.072c-0.119-0.019-0.238-0.038-0.363-0.038-1.24 0-2.25 1.009-2.25 2.25s1.010 2.25 2.25 2.25h3.699v1h-3.699c-1.792 0-3.25-1.458-3.25-3.25 0-1.826 1.511-3.335 3.353-3.248 0.713-1.812 2.431-3.002 4.397-3.002 1.234 0 2.42 0.494 3.309 1.367 0.546-0.244 1.113-0.367 1.691-0.367 2.344 0 4.25 1.907 4.25 4.25zM9 13.73v-7.73h-1v7.73l-1.646-1.646-0.707 0.707 2.853 2.853 2.854-2.854-0.707-0.707-1.647 1.647z"}}]})(props);
	};
	module.exports.TfiCloudUp = function TfiCloudUp (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 6.75c0 2.343-1.906 4.25-4.25 4.25h-2.757v-1h2.757c1.792 0 3.25-1.458 3.25-3.25s-1.458-3.25-3.25-3.25c-0.532 0-1.057 0.141-1.56 0.417l-0.354 0.195-0.265-0.306c-0.719-0.829-1.748-1.306-2.821-1.306-1.661 0-3.099 1.080-3.576 2.688l-0.126 0.422-0.435-0.072c-0.119-0.019-0.238-0.038-0.363-0.038-1.24 0-2.25 1.009-2.25 2.25s1.010 2.25 2.25 2.25h3.699v1h-3.699c-1.792 0-3.25-1.458-3.25-3.25 0-1.826 1.529-3.335 3.353-3.248 0.713-1.812 2.431-3.002 4.397-3.002 1.234 0 2.42 0.494 3.309 1.367 0.546-0.244 1.113-0.367 1.691-0.367 2.344 0 4.25 1.907 4.25 4.25zM10.646 8.854l0.707-0.707-2.853-2.854-2.854 2.853 0.707 0.707 1.647-1.646v7.793h1v-7.793l1.646 1.647z"}}]})(props);
	};
	module.exports.TfiCloud = function TfiCloud (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.75 4.5c-0.578 0-1.146 0.123-1.691 0.367-0.889-0.873-2.075-1.367-3.309-1.367-1.966 0-3.684 1.19-4.397 3.002-1.803-0.074-3.353 1.421-3.353 3.248 0 1.792 1.458 3.25 3.25 3.25h9.5c2.343 0 4.25-1.907 4.25-4.25s-1.907-4.25-4.25-4.25zM12.75 12h-9.5c-1.241 0-2.25-1.009-2.25-2.25s1.009-2.25 2.25-2.25c0.125 0 0.244 0.019 0.363 0.038l0.435 0.072 0.126-0.422c0.478-1.608 1.915-2.688 3.576-2.688 1.073 0 2.102 0.477 2.821 1.307l0.265 0.306 0.354-0.195c0.503-0.277 1.027-0.418 1.56-0.418 1.792 0 3.25 1.458 3.25 3.25s-1.458 3.25-3.25 3.25z"}}]})(props);
	};
	module.exports.TfiCommentAlt = function TfiCommentAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.5 0h-14c-0.827 0-1.5 0.673-1.5 1.5v10c0 0.827 0.673 1.5 1.5 1.5h0.5v4.102l4.688-4.102h8.812c0.827 0 1.5-0.673 1.5-1.5v-10c0-0.827-0.673-1.5-1.5-1.5zM16 11.5c0 0.275-0.224 0.5-0.5 0.5h-9.188l-3.312 2.898v-2.898h-1.5c-0.276 0-0.5-0.225-0.5-0.5v-10c0-0.275 0.224-0.5 0.5-0.5h14c0.276 0 0.5 0.225 0.5 0.5v10zM3 3h11v1h-11v-1zM3 5h11v1h-11v-1zM3 7h6v1h-6v-1z"}}]})(props);
	};
	module.exports.TfiComment = function TfiComment (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.5 0h-14c-0.827 0-1.5 0.673-1.5 1.5v10c0 0.827 0.673 1.5 1.5 1.5h0.5v4.102l4.688-4.102h8.812c0.827 0 1.5-0.673 1.5-1.5v-10c0-0.827-0.673-1.5-1.5-1.5zM16 11.5c0 0.275-0.224 0.5-0.5 0.5h-9.188l-3.312 2.898v-2.898h-1.5c-0.276 0-0.5-0.225-0.5-0.5v-10c0-0.275 0.224-0.5 0.5-0.5h14c0.276 0 0.5 0.225 0.5 0.5v10z"}}]})(props);
	};
	module.exports.TfiCommentsSmiley = function TfiCommentsSmiley (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13 8h1c0 2.481-2.019 4.5-4.5 4.5s-4.5-2.019-4.5-4.5h1c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5zM7.5 6.5c0.553 0 1-0.447 1-1s-0.447-1-1-1-1 0.447-1 1 0.447 1 1 1zM11.5 6.5c0.553 0 1-0.447 1-1s-0.447-1-1-1-1 0.447-1 1 0.447 1 1 1zM17 7.5c0 4.136-3.364 7.5-7.5 7.5-1.34 0-2.648-0.359-3.803-1.041l-5.5 2.843 2.843-5.499c-0.681-1.155-1.040-2.463-1.040-3.803 0-4.136 3.364-7.5 7.5-7.5s7.5 3.364 7.5 7.5zM16 7.5c0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 1.244 0.358 2.459 1.036 3.511l0.157 0.243-1.664 3.218 3.217-1.664 0.243 0.157c1.053 0.677 2.266 1.035 3.511 1.035 3.584 0 6.5-2.916 6.5-6.5z"}}]})(props);
	};
	module.exports.TfiComments = function TfiComments (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 1.5v7.969c0 0.827-0.673 1.5-1.5 1.5h-0.508v-1h0.508c0.276 0 0.5-0.225 0.5-0.5v-7.969c0-0.275-0.224-0.5-0.5-0.5h-14c-0.276 0-0.5 0.225-0.5 0.5v7.969c0 0.275 0.224 0.5 0.5 0.5h1.5v2.892l1.779-1.569 0.661 0.75-3.44 3.035v-4.108h-0.5c-0.827 0-1.5-0.673-1.5-1.5v-7.969c0-0.827 0.673-1.5 1.5-1.5h14c0.827 0 1.5 0.673 1.5 1.5zM14.020 9.54v3.043c0 0.827-0.673 1.5-1.5 1.5h-0.5v3.064l-3.667-3.064h-0.853c-0.827 0-1.5-0.673-1.5-1.5v-3.043c0-0.827 0.673-1.5 1.5-1.5h5.020c0.827 0 1.5 0.673 1.5 1.5zM13.020 9.54c0-0.275-0.224-0.5-0.5-0.5h-5.020c-0.276 0-0.5 0.225-0.5 0.5v3.043c0 0.275 0.224 0.5 0.5 0.5h1.217l2.303 1.926v-1.926h1.5c0.276 0 0.5-0.225 0.5-0.5v-3.043z"}}]})(props);
	};
	module.exports.TfiControlBackward = function TfiControlBackward (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M6.719 8.474l7.281 6.097v-12.135l-7.281 6.038zM13 12.429l-4.719-3.951 4.719-3.914v7.865zM3.281 8.478l5.54 4.639-0.643 0.768-6.46-5.41 6.462-5.358 0.639 0.77-5.538 4.591z"}}]})(props);
	};
	module.exports.TfiControlEject = function TfiControlEject (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.474 2.719l-6.038 7.281h12.135l-6.097-7.281zM8.478 4.281l3.951 4.719h-7.865l3.914-4.719zM15 13v1h-13v-1h13z"}}]})(props);
	};
	module.exports.TfiControlForward = function TfiControlForward (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M3 2.436v12.136l7.281-6.098-7.281-6.038zM4 4.564l4.719 3.913-4.719 3.952v-7.865zM15.281 8.474l-6.46 5.41-0.643-0.768 5.54-4.639-5.537-4.592 0.639-0.77 6.461 5.359z"}}]})(props);
	};
	module.exports.TfiControlPause = function TfiControlPause (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M3 15h4v-13h-4v13zM4 3h2v11h-2v-11zM10 2v13h4v-13h-4zM13 14h-2v-11h2v11z"}}]})(props);
	};
	module.exports.TfiControlPlay = function TfiControlPlay (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M3 2.692v11.618l11.618-5.837-11.618-5.781zM4 4.308l8.382 4.17-8.382 4.211v-8.381z"}}]})(props);
	};
	module.exports.TfiControlRecord = function TfiControlRecord (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 2.5c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zM8.5 13.5c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"}}]})(props);
	};
	module.exports.TfiControlShuffle = function TfiControlShuffle (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.94 6.871l1.081-1.34-0.004-0.003c0.855-0.971 2.087-1.528 3.378-1.528h1.898l-1.646-1.646 0.707-0.707 2.853 2.853-2.854 2.854-0.707-0.707 1.647-1.647h-1.898c-0.989 0-1.931 0.425-2.595 1.159l-1.080 1.339-0.78-0.627zM5.851 10.696l-0.011-0.008c-0.667 0.833-1.663 1.312-2.733 1.312h-3.107v1h3.107c1.369 0 2.645-0.611 3.503-1.676l0.011 0.009 0.941-1.166-0.777-0.629-0.934 1.158zM13.646 10.354l1.647 1.646h-1.898c-1.052 0-2.031-0.469-2.7-1.281l-4.269-5.265-0.010 0.008c-0.85-0.926-2.048-1.462-3.309-1.462h-3.107v1h3.107c0.998 0 1.948 0.428 2.611 1.17l4.161 5.132-0.005 0.004c0.86 1.076 2.143 1.694 3.52 1.694h1.898l-1.646 1.646 0.707 0.707 2.854-2.854-2.854-2.854-0.707 0.709z"}}]})(props);
	};
	module.exports.TfiControlSkipBackward = function TfiControlSkipBackward (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M6.719 8.526l7.281 6.038v-12.135l-7.281 6.097zM13 12.436l-4.719-3.914 4.719-3.951v7.865zM3 2h1v13h-1v-13z"}}]})(props);
	};
	module.exports.TfiControlSkipForward = function TfiControlSkipForward (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M3 14.571l7.281-6.097-7.281-6.038v12.135zM4 4.564l4.719 3.914-4.719 3.951v-7.865zM14 2v13h-1v-13h1z"}}]})(props);
	};
	module.exports.TfiControlStop = function TfiControlStop (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M3 3v11h11v-11h-11zM13 13h-9v-9h9v9z"}}]})(props);
	};
	module.exports.TfiCreditCard = function TfiCreditCard (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.5 2h-14c-0.827 0-1.5 0.673-1.5 1.5v10c0 0.827 0.673 1.5 1.5 1.5h14c0.827 0 1.5-0.673 1.5-1.5v-10c0-0.827-0.673-1.5-1.5-1.5zM16 13.5c0 0.275-0.224 0.5-0.5 0.5h-14c-0.276 0-0.5-0.225-0.5-0.5v-5.5h15v5.5zM1 5v-1.5c0-0.275 0.224-0.5 0.5-0.5h14c0.276 0 0.5 0.225 0.5 0.5v1.5h-15z"}}]})(props);
	};
	module.exports.TfiCrown = function TfiCrown (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.626 6.743l-4.083-6.673-4.211 6.675-4.499-3.833 1.739 13.088h13.855l1.738-13.075-4.539 3.818zM2.447 15l-0.133-1h12.371l-0.133 1h-12.105zM14.818 13h-12.636l-1.015-7.637 3.396 2.892 3.967-6.29 3.851 6.292 3.454-2.906-1.017 7.649z"}}]})(props);
	};
	module.exports.TfiCss3 = function TfiCss3 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.5 1.26l-2.407 12.064-7.277 2.416-6.316-2.416 0.643-3.223h2.688l-0.263 1.33 3.818 1.457 4.398-1.457 0.614-3.068h-10.929l0.524-2.686h10.94l0.345-1.73h-10.931l0.533-2.687h13.62z"}}]})(props);
	};
	module.exports.TfiCup = function TfiCup (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.999 1h-2.257c0.001-0.168 0.008-0.328 0.008-0.5v-0.5h-12.5v0.5c0 0.16 0.004 0.333 0.005 0.5h-2.254l-0.001 0.499c-0.003 1.086 0.062 2.199 0.195 3.31 0.352 2.937 1.271 6.341 2.795 7.087 0.194 0.096 0.395 0.144 0.596 0.144 0.238 0 0.479-0.068 0.707-0.206l0.209-0.14c0.833 1.277 1.97 2.139 3.498 2.298v2.008h-2.953v1h7v-1h-3.047v-1.997c1.415-0.149 2.585-0.935 3.493-2.312l0.234 0.155c0.216 0.13 0.447 0.194 0.681 0.194 0.201 0 0.404-0.048 0.602-0.145 1.524-0.746 2.443-4.15 2.795-7.087 0.133-1.11 0.198-2.224 0.195-3.31l-0.001-0.498zM3.988 10.834l-0.229 0.154c-0.112 0.066-0.204 0.070-0.328 0.010-0.785-0.385-1.808-2.675-2.243-6.309-0.108-0.9-0.169-1.802-0.184-2.689h1.273c0.097 2.924 0.513 6.468 1.792 8.956l-0.081-0.122zM8.5 13.041c-4.54 0-5.199-8.050-5.247-12.041h10.494c-0.049 4.721-0.838 12.041-5.247 12.041zM15.812 4.689c-0.436 3.634-1.458 5.924-2.243 6.309-0.123 0.061-0.216 0.058-0.308 0.003l-0.25-0.167-0.116 0.174c1.079-2.038 1.707-5.066 1.831-9.008h1.271c-0.016 0.887-0.077 1.789-0.185 2.689z"}}]})(props);
	};
	module.exports.TfiCut = function TfiCut (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13 11c-0.545 0-1.049 0.157-1.49 0.412l-2.322-2.454 6.26-6.614-0.727-0.688-6.221 6.574-6.223-6.574-0.726 0.688 6.26 6.614-2.322 2.453c-0.44-0.254-0.945-0.411-1.489-0.411-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3c0-0.747-0.285-1.424-0.738-1.949l2.238-2.365 2.238 2.365c-0.454 0.526-0.738 1.202-0.738 1.949 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3zM4 16c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM13 16c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2z"}}]})(props);
	};
	module.exports.TfiDashboard = function TfiDashboard (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 11.5v0.5h-6.168v-1h5.152c-0.112-1.692-0.789-3.231-1.842-4.434l-0.806 0.806-0.707-0.707 0.802-0.802c-1.202-1.053-2.74-1.726-4.431-1.839v2.976h-1v-2.976c-1.691 0.113-3.229 0.786-4.43 1.839l0.796 0.796-0.707 0.707-0.8-0.8c-1.053 1.203-1.731 2.742-1.842 4.434h5.171v1h-6.188v-0.5c0-4.687 3.813-8.5 8.5-8.5s8.5 3.813 8.5 8.5zM10.5 11.5c0 1.103-0.897 2-2 2s-2-0.897-2-2c0-0.644 0.311-1.21 0.784-1.577l-2.082-3.63 0.867-0.497 2.141 3.733c0.095-0.014 0.19-0.029 0.29-0.029 1.103 0 2 0.897 2 2zM9.5 11.5c0-0.551-0.449-1-1-1s-1 0.449-1 1 0.449 1 1 1 1-0.449 1-1z"}}]})(props);
	};
	module.exports.TfiDesktop = function TfiDesktop (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2 11h13v-8h-13v8zM3 4h11v6h-11v-6zM15.5 1h-14c-0.827 0-1.5 0.638-1.5 1.423v10.154c0 0.785 0.673 1.423 1.5 1.423h14c0.827 0 1.5-0.638 1.5-1.423v-10.154c0-0.785-0.673-1.423-1.5-1.423zM16 12.577c0 0.234-0.225 0.423-0.5 0.423h-14c-0.275 0-0.5-0.189-0.5-0.423v-10.154c0-0.234 0.225-0.423 0.5-0.423h14c0.275 0 0.5 0.189 0.5 0.423v10.154zM5 15h7v1h-7v-1z"}}]})(props);
	};
	module.exports.TfiDirectionAlt = function TfiDirectionAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9 6h4.695l1.938-2.563-1.946-2.437h-4.687v-1h-1v1h-6v5h6v2h-4.687l-1.946 2.437 1.938 2.563h4.695v4h1v-4h6v-5h-6v-2zM3 2h10.206l1.161 1.454-1.169 1.546h-10.198v-3zM14 12h-10.198l-1.169-1.546 1.161-1.454h10.206v3z"}}]})(props);
	};
	module.exports.TfiDirection = function TfiDirection (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.641 5.409l-2.811-3.409h-4.83v-2h-1v2h-7v7h7v8h1v-8h4.838l2.803-3.591zM9 8h-7v-5h11.358l2.001 2.426-2.009 2.574h-4.35z"}}]})(props);
	};
	module.exports.TfiDownload = function TfiDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 16v1h-17v-1h17zM13.354 8.854l-0.707-0.707-3.646 3.646v-11.793h-1v11.794l-3.647-3.648-0.708 0.708 4.854 4.853 4.854-4.853z"}}]})(props);
	};
	module.exports.TfiDribbble = function TfiDribbble (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0c-4.694 0-8.5 3.806-8.5 8.5s3.806 8.5 8.5 8.5 8.5-3.806 8.5-8.5-3.806-8.5-8.5-8.5zM15.994 8.621c-2.075-0.456-3.896-0.423-5.469-0.092-0.251-0.627-0.536-1.273-0.849-1.93 1.681-0.648 3.292-1.586 4.548-2.934 1.106 1.308 1.776 2.994 1.776 4.835 0 0.041-0.006 0.080-0.006 0.121zM13.523 2.947c-1.16 1.257-2.688 2.135-4.297 2.74-0.76-1.468-1.69-2.96-2.814-4.385 0.664-0.193 1.363-0.302 2.088-0.302 1.934 0 3.692 0.742 5.023 1.947zM5.43 1.665c1.133 1.397 2.062 2.884 2.828 4.353-2.974 0.92-5.966 1.028-7.114 1.030 0.474-2.407 2.104-4.4 4.286-5.383zM1 8.5c0-0.151 0.014-0.3 0.022-0.449 0.065 0.001 0.134 0.001 0.212 0.001 1.306 0 4.402-0.125 7.482-1.114 0.3 0.625 0.578 1.245 0.82 1.844-3.605 1.101-5.736 3.705-6.513 4.826-1.251-1.34-2.023-3.133-2.023-5.108zM3.758 14.304c0.596-0.901 2.601-3.518 6.145-4.57 0.961 2.598 1.405 4.744 1.566 5.651-0.911 0.394-1.914 0.615-2.969 0.615-1.798 0-3.449-0.637-4.742-1.696zM12.4 14.894c-0.198-1.063-0.636-3.042-1.503-5.405 1.444-0.28 3.109-0.288 5.008 0.145-0.341 2.226-1.658 4.129-3.505 5.26z"}}]})(props);
	};
	module.exports.TfiDropboxAlt = function TfiDropboxAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0.5 9.344l4.707 3.070 3.293-2.746-4.745-2.93z"}},{"tag":"path","attr":{"d":"M5.207 1.062l-4.707 3.071 3.255 2.605 4.745-2.927z"}},{"tag":"path","attr":{"d":"M16.5 4.133l-4.706-3.071-3.294 2.749 4.746 2.927z"}},{"tag":"path","attr":{"d":"M8.5 9.668l3.294 2.746 4.706-3.070-3.254-2.606z"}},{"tag":"path","attr":{"d":"M8.51 10.259l-3.303 2.739-1.413-0.924v1.035l4.716 2.829 4.717-2.829v-1.035l-1.414 0.924z"}}]})(props);
	};
	module.exports.TfiDropbox = function TfiDropbox (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.853 4.371l-5.296-3.454-3.057 2.538-3.046-2.538-5.307 3.454 3.1 2.476-3.099 2.482 3.444 2.243v1.533l4.917 2.939 4.926-2.938v-1.548l3.417-2.23-3.098-2.481 3.099-2.476zM11.627 2.157l3.52 2.296-2.232 1.782-3.56-2.19 2.272-1.888zM12 6.847l-3.5 2.159-3.5-2.159 3.5-2.154 3.5 2.154zM1.853 4.453l3.527-2.296 2.265 1.887-3.561 2.191-2.231-1.782zM1.852 9.245l2.232-1.789 3.562 2.198-2.266 1.89-3.528-2.299zM12.435 12.538l-3.925 2.343-3.917-2.342v-0.315l0.862 0.561 3.047-2.54 3.056 2.54 0.878-0.573v0.326zM15.148 9.246l-3.521 2.298-2.273-1.89 3.561-2.198 2.233 1.79z"}}]})(props);
	};
	module.exports.TfiDrupal = function TfiDrupal (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.563 16.5c-3.718 0-7.062-2.926-7.062-6.906 0-3.974 3.098-5.813 3.672-6.114 0.684-0.364 1.176-0.556 1.95-1.175 0.383-0.301 0.702-0.739 0.803-1.805 0.555 0.665 1.221 1.439 1.694 1.759 0.775 0.51 1.55 0.711 2.36 1.221 0.492 0.301 3.518 2.15 3.518 6.241 0 4.082-3.226 6.779-6.935 6.779zM14.030 9.903c-0.729 0-2.205 1.513-2.979 1.522-0.901 0.018-2.149-1.787-3.954-1.77-1.422 0.010-2.542 1.14-2.561 2.343-0.009 0.675 0.21 1.176 0.675 1.494 0.31 0.209 0.592 0.337 1.512 0.337 1.531 0 3.472-1.896 4.365-1.867 0.71 0.026 1.812 1.768 2.369 1.804 0.437 0.036 0.665-0.164 1.038-0.701 0.364-0.547 0.52-1.404 0.52-1.887 0-0.473-0.21-1.275-0.985-1.275zM11.917 14.741c-0.31 0.228-1.003 0.511-1.987 0.511s-1.448-0.21-1.758-0.447c-0.045-0.036-0.027-0.036-0.119-0.036-0.1 0-0.154 0.046-0.236 0.109-0.073 0.064-0.109 0.219 0 0.328 0.674 0.619 1.804 0.565 2.633 0.491 0.839-0.082 1.55-0.573 1.622-0.646 0.109-0.108 0.082-0.2 0.063-0.264-0.018-0.064-0.073-0.154-0.218-0.046zM11.424 13.184c-0.182-0.118-0.445-0.137-0.691-0.137-0.247 0-0.383-0.018-0.646 0.091-0.266 0.109-0.539 0.355-0.711 0.511-0.174 0.154-0.201 0.273-0.11 0.401 0.092 0.117 0.192 0.044 0.447-0.174 0.264-0.21 0.438-0.401 0.975-0.401s0.629 0.201 0.737 0.401c0.11 0.2 0.119 0.228 0.228 0.174 0.128-0.064 0.192-0.156 0.128-0.312-0.065-0.154-0.174-0.427-0.357-0.554z"}}]})(props);
	};
	module.exports.TfiEmail = function TfiEmail (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 2v13h17v-13h-17zM8.494 9.817l-6.896-6.817h13.82l-6.924 6.817zM5.755 8.516l-4.755 4.682v-9.383l4.755 4.701zM6.466 9.219l2.026 2.003 1.996-1.966 4.8 4.744h-13.677l4.855-4.781zM11.201 8.555l4.799-4.725v9.467l-4.799-4.742z"}}]})(props);
	};
	module.exports.TfiEnvelope = function TfiEnvelope (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2 0v17h13v-17h-13zM4.695 4l-1.408-3h10.426l-1.41 3h-7.608zM4.061 5h3.939v9h-4.002l-0.998 1.155v-12.414l1.061 2.259zM4.455 15h8.092l0.862 1h-9.816l0.862-1zM13.006 14h-4.006v-9h3.938l1.062-2.261v12.415l-0.994-1.154z"}}]})(props);
	};
	module.exports.TfiEraser = function TfiEraser (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13.446 4.201l-5.196-3.001c-0.69-0.397-1.65-0.141-2.048 0.55l-6 10.393c-0.414 0.716-0.167 1.635 0.55 2.050l3.179 1.824 4.357-0.018 5.708-9.749c0.413-0.716 0.167-1.635-0.55-2.049zM7.713 15.001l-3.518 0.014-2.945-1.689c-0.239-0.139-0.321-0.444-0.183-0.684l2.75-4.764 6.027 3.48-2.131 3.643zM13.13 5.747l-2.781 4.75-6.032-3.483 2.75-4.764c0.089-0.154 0.256-0.25 0.434-0.25 0.088 0 0.172 0.022 0.249 0.066l5.196 3c0.239 0.139 0.321 0.445 0.184 0.681zM17 15v1h-7v-1h7z"}}]})(props);
	};
	module.exports.TfiExchangeVertical = function TfiExchangeVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M6 15.043v-7.043h-1v7.043l-3.646-3.646-0.707 0.707 4.853 4.853 4.854-4.854-0.707-0.707-3.647 3.647zM5.488 15.531h0.023l-0.011 0.012-0.012-0.012zM15.646 5.604l-3.646-3.647v7.096h-1v-7.096l-3.646 3.647-0.708-0.708 4.854-4.853 4.854 4.854-0.708 0.707z"}}]})(props);
	};
	module.exports.TfiExport = function TfiExport (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M4.359 5.956l-0.718-0.697 4.859-5.005 4.859 5.005-0.718 0.696-3.641-3.75v10.767h-1v-10.767l-3.641 3.751zM16 9.030v6.47c0 0.276-0.224 0.5-0.5 0.5h-14c-0.276 0-0.5-0.224-0.5-0.5v-6.475h-1v6.475c0 0.827 0.673 1.5 1.5 1.5h14c0.827 0 1.5-0.673 1.5-1.5v-6.47h-1z"}}]})(props);
	};
	module.exports.TfiEye = function TfiEye (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.965 8.817c-1.284-3.267-4.687-5.463-8.465-5.463s-7.181 2.196-8.465 5.463c-0.046 0.117-0.046 0.248 0 0.365 1.285 3.268 4.687 5.464 8.465 5.464s7.18-2.195 8.465-5.463c0.047-0.118 0.047-0.248 0-0.366zM8.5 13.646c-3.298 0-6.269-1.859-7.459-4.646 1.189-2.787 4.16-4.646 7.459-4.646s6.27 1.859 7.459 4.646c-1.19 2.786-4.161 4.646-7.459 4.646zM8.5 5.357c-2.009 0-3.643 1.634-3.643 3.643s1.634 3.643 3.644 3.643c2.008 0 3.643-1.634 3.643-3.643s-1.635-3.643-3.644-3.643zM8.5 11.643c-1.458 0-2.644-1.186-2.644-2.643s1.187-2.643 2.644-2.643c1.457 0 2.643 1.186 2.643 2.643s-1.185 2.643-2.643 2.643zM8.5 7.643c-0.748 0-1.357 0.609-1.357 1.357s0.609 1.357 1.357 1.357 1.357-0.609 1.357-1.357-0.609-1.357-1.357-1.357zM8.5 9.357c-0.197 0-0.357-0.16-0.357-0.357s0.16-0.357 0.357-0.357 0.357 0.16 0.357 0.357-0.16 0.357-0.357 0.357z"}}]})(props);
	};
	module.exports.TfiFaceSad = function TfiFaceSad (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.813-8.5-8.5-8.5zM8.5 16c-4.136 0-7.5-3.364-7.5-7.5s3.364-7.5 7.5-7.5 7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5zM13 13c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5zM4.5 5.5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM10.5 5.5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1z"}}]})(props);
	};
	module.exports.TfiFaceSmile = function TfiFaceSmile (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.813-8.5-8.5-8.5zM8.5 16c-4.136 0-7.5-3.364-7.5-7.5s3.364-7.5 7.5-7.5 7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5zM13 9c0 2.481-2.019 4.5-4.5 4.5s-4.5-2.019-4.5-4.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5zM4.5 5.5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM10.5 5.5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1z"}}]})(props);
	};
	module.exports.TfiFacebook = function TfiFacebook (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.461 5.57l-0.309 2.93h-2.342v8.5h-3.518v-8.5h-1.753v-2.93h1.753v-1.764c0-2.383 0.991-3.806 3.808-3.806h2.341v2.93h-1.465c-1.093 0-1.166 0.413-1.166 1.176v1.464h2.651z"}}]})(props);
	};
	module.exports.TfiFile = function TfiFile (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.667 0h-7.667v17h13v-11.692l-5.333-5.308zM10 1.742l3.273 3.258h-3.273v-3.258zM3 16v-15h6v5h5v10h-11z"}}]})(props);
	};
	module.exports.TfiFiles = function TfiFiles (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.497 0h-6.497v2.010h1v-1.010h5v4h4v8h-4.017v1h5.017v-9.818l-4.503-4.182zM13 1.832l2.335 2.168h-2.335v-2.168zM0 3v14h11v-9.818l-4.503-4.182h-6.497zM7 4.832l2.335 2.168h-2.335v-2.168zM1 16v-12h5v4h4v8h-9z"}}]})(props);
	};
	module.exports.TfiFilter = function TfiFilter (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0.54 0l6.46 9.229v7.771h3v-7.771l6.46-9.229h-15.92zM9 8.914v7.086h-1v-7.086l-5.54-7.914h12.080l-5.54 7.914z"}}]})(props);
	};
	module.exports.TfiFlagAlt2 = function TfiFlagAlt2 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 0v17h-1v-17h1zM4.984 1h8v8h-4.984v2h-7v-8h3.984v-2zM7 9h-2v-5h-3v6h5v-1zM5.984 2v1h0.016v5h5.984v-6h-6z"}}]})(props);
	};
	module.exports.TfiFlagAlt = function TfiFlagAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 0v17h-1v-17h1zM1.527 0.976h11.473v8h-11.49l2.911-3.952-2.894-4.048zM12 1.976h-8.528l2.185 3.056-2.168 2.944h8.511v-6z"}}]})(props);
	};
	module.exports.TfiFlag = function TfiFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13 10.008v-9.238l-11.879 4.619 11.879 4.619zM12 8.547l-8.121-3.158 8.121-3.159v6.317zM15 0v17h-1v-17h1z"}}]})(props);
	};
	module.exports.TfiFlickrAlt = function TfiFlickrAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0.5c-4.418 0-8 3.583-8 8 0 4.418 3.582 8 8 8s8-3.582 8-8c0-4.417-3.582-8-8-8zM5.433 10.979c-1.391 0-2.519-1.126-2.519-2.518 0-1.391 1.128-2.518 2.519-2.518s2.517 1.127 2.517 2.518c0 1.392-1.127 2.518-2.517 2.518zM11.75 10.979c-1.391 0-2.518-1.126-2.518-2.518 0-1.391 1.127-2.518 2.518-2.518s2.518 1.127 2.518 2.518c0 1.392-1.127 2.518-2.518 2.518z"}}]})(props);
	};
	module.exports.TfiFlickr = function TfiFlickr (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M7.295 8.5c0 2.014-1.634 3.647-3.646 3.647-2.015 0-3.649-1.633-3.649-3.647s1.634-3.647 3.649-3.647c2.012 0 3.646 1.633 3.646 3.647zM17 8.5c0 2.014-1.634 3.647-3.649 3.647-2.012 0-3.646-1.634-3.646-3.647s1.634-3.647 3.646-3.647c2.015 0 3.649 1.633 3.649 3.647zM16 8.5c0-1.46-1.188-2.647-2.649-2.647-1.459 0-2.646 1.188-2.646 2.647s1.187 2.647 2.646 2.647c1.461 0 2.649-1.187 2.649-2.647z"}}]})(props);
	};
	module.exports.TfiFolder = function TfiFolder (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8 4l-1.958-2h-6.042v15h17v-13h-9zM5.622 3l1.958 2h8.42v2.027l-15-0.026v-4.001h4.622zM1 16v-7.999l15 0.026v7.973h-15z"}}]})(props);
	};
	module.exports.TfiFullscreen = function TfiFullscreen (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.996 11.352l0.004 4.648-4.649-0.004 0.001-1 2.94 0.003-5.792-5.791-5.792 5.792 2.94-0.003 0.001 1-4.649 0.003 0.004-4.649 1 0.001-0.003 2.939 5.792-5.791-5.792-5.792 0.003 2.939-1 0.001-0.004-4.648 4.649 0.004-0.001 1-2.94-0.003 5.792 5.792 5.792-5.792-2.94 0.003-0.001-1 4.649-0.004-0.004 4.649-1-0.001 0.003-2.939-5.792 5.791 5.792 5.792-0.003-2.939 1-0.001z"}}]})(props);
	};
	module.exports.TfiGallery = function TfiGallery (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13 10v-10h-13v13h13v-3zM1 1h11v8h-0.755l-2.564-3.319-1.159 1.214-2.248-3.881-3.576 5.986h-0.698v-8zM9.982 9h-7.119l2.398-4.014 2.064 3.564 1.275-1.337 1.382 1.787zM1 12v-2h11v2h-11zM17 3v13h-13v-1.984h1v0.984h11v-11h-2v-1h3z"}}]})(props);
	};
	module.exports.TfiGame = function TfiGame (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9 3.988v-2.988h-1v2.988c-3.564 0.105-8 1.282-8 2.487v7.041c0 0.827 0.673 1.5 1.5 1.5h1.79l1.996-3.931c0.567 0.104 1.713 0.274 3.173 0.274 1.479 0 2.694-0.174 3.288-0.277l1.908 3.934h1.845c0.827 0 1.5-0.673 1.5-1.5v-7.041c0-1.205-4.437-2.383-8-2.487zM16 13.516c0 0.275-0.225 0.5-0.5 0.5h-1.218l-1.976-4.070-0.386 0.085c-0.015 0.003-1.515 0.329-3.462 0.329-1.941 0-3.315-0.323-3.329-0.327l-0.384-0.093-2.068 4.075h-1.177c-0.275 0-0.5-0.225-0.5-0.5v-6.915c0.502-0.437 3.38-1.518 7-1.611v0.011h1v-0.013c3.619 0.094 6.498 1.175 7 1.612v6.917zM5 7.020h0.998v1h-0.998v1.020h-1v-1.020h-1v-1h1v-1.020h1v1.020zM12.5 9.020c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.673 1.5 1.5 1.5zM12.5 7.020c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z"}}]})(props);
	};
	module.exports.TfiGift = function TfiGift (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M7.839 5.611l-0.034 0.198 0.673-0.086c0.004 0 0.021-0.003 0.031-0.004l0.637 0.081-0.031-0.181c1.090-0.202 3.308-0.725 4.575-1.81 0.494-0.422 0.766-0.99 0.766-1.6s-0.272-1.178-0.766-1.601c-0.942-0.808-2.561-0.807-3.503 0-0.814 0.697-1.359 1.726-1.711 2.628-0.352-0.9-0.897-1.926-1.711-2.621-0.941-0.806-2.558-0.805-3.499 0-0.494 0.422-0.766 0.989-0.766 1.597 0 0.608 0.272 1.174 0.766 1.595 1.267 1.082 3.485 1.603 4.573 1.804zM10.837 1.368c0.291-0.249 0.681-0.386 1.101-0.386 0.419 0 0.811 0.137 1.101 0.386 0.269 0.229 0.416 0.528 0.416 0.841 0 0.312-0.147 0.61-0.416 0.84-1.032 0.883-2.929 1.355-3.966 1.558 0.245-0.888 0.783-2.399 1.764-3.239zM3.915 1.375c0.291-0.248 0.681-0.385 1.101-0.385 0.419 0 0.81 0.137 1.1 0.385 0.976 0.833 1.514 2.337 1.76 3.223-1.036-0.201-2.928-0.67-3.961-1.552-0.268-0.228-0.415-0.524-0.415-0.834 0-0.311 0.147-0.608 0.415-0.837zM17 6h-17v4h1v7h15v-7h1v-4zM6.976 7h3.006l1.066 5.843-1.648-0.685-1.301 1.205-1.123-6.363zM1 7h4.96l0.353 2h-5.313v-2zM15 16h-13v-6h4.49l0.942 5.343 2.176-2.015 2.752 1.145-0.815-4.473h3.455v6zM16 9h-4.638l-0.365-2h5.003v2z"}}]})(props);
	};
	module.exports.TfiGithub = function TfiGithub (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13.077 11.115c0 0.746-0.389 1.962-1.308 1.962-0.92 0-1.309-1.216-1.309-1.962 0-0.745 0.389-1.962 1.309-1.962 0.919 0 1.308 1.217 1.308 1.962zM5.231 9.153c-0.919 0-1.308 1.217-1.308 1.962 0 0.746 0.389 1.962 1.308 1.962 0.919 0 1.308-1.216 1.308-1.962 0-0.745-0.389-1.962-1.308-1.962zM17 9.317c0 1.135-0.112 2.34-0.623 3.382-1.349 2.728-5.057 2.993-7.713 2.993-2.697 0-6.63-0.234-8.030-2.993-0.522-1.032-0.634-2.247-0.634-3.382 0-1.492 0.409-2.901 1.39-4.045-0.184-0.562-0.276-1.155-0.276-1.738 0-0.766 0.173-1.531 0.521-2.227 1.614 0 2.646 0.705 3.872 1.665 1.032-0.245 2.094-0.357 3.157-0.357 0.96 0 1.931 0.103 2.861 0.327 1.216-0.95 2.247-1.635 3.841-1.635 0.348 0.695 0.521 1.461 0.521 2.227 0 0.583-0.092 1.165-0.276 1.717 0.981 1.154 1.389 2.574 1.389 4.066zM14.711 11.115c0-1.563-0.949-2.942-2.615-2.942-0.674 0-1.317 0.123-1.992 0.215-0.531 0.082-1.062 0.112-1.604 0.112s-1.073-0.030-1.604-0.112c-0.664-0.092-1.318-0.215-1.992-0.215-1.665 0-2.615 1.379-2.615 2.942 0 3.126 2.86 3.606 5.353 3.606h1.717c2.493 0.001 5.352-0.48 5.352-3.606z"}}]})(props);
	};
	module.exports.TfiGoogle = function TfiGoogle (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 2.615v1.308h-2.615v2.616h-1.308v-2.616h-2.615v-1.308h2.615v-2.615h1.308v2.615h2.615zM10.39 12.78c0 1.175-0.561 2.125-1.43 2.881-1.175 1.012-2.779 1.339-4.291 1.339-1.91 0-4.669-0.817-4.669-3.187 0-0.48 0.164-0.951 0.379-1.38 0.908-1.838 3.748-2.309 5.577-2.36-0.336-0.439-0.653-0.949-0.653-1.522 0-0.337 0.121-0.562 0.225-0.878-0.246 0.030-0.48 0.051-0.715 0.051-1.982 0-3.698-1.461-3.698-3.515 0-1.941 1.501-3.596 3.36-4.004 0.624-0.134 1.266-0.205 1.91-0.205h4.466l-1.379 0.807h-1.381c1.013 0.633 1.523 1.87 1.523 3.014 0 2.707-2.289 2.911-2.289 4.26 0 1.318 3.065 1.839 3.065 4.699zM7.725 4.853c0-1.553-0.839-4.117-2.729-4.117-1.337 0-1.991 1.185-1.991 2.391 0 1.552 1.021 3.984 2.84 3.984 1.398-0.001 1.88-1.012 1.88-2.258zM8.95 13.659c0-1.43-1.34-2.227-2.381-2.953-0.174-0.020-0.338-0.020-0.512-0.020-1.674 0-4.168 0.531-4.168 2.656 0 1.961 2.207 2.718 3.842 2.718 1.522 0 3.219-0.613 3.219-2.401z"}}]})(props);
	};
	module.exports.TfiHandDrag = function TfiHandDrag (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13.963 5.6v5.844c0 0.777-0.383 1.241-0.663 1.579-0.234 0.284-0.356 0.443-0.356 0.694v1.783c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1.783c0-0.623 0.325-1.016 0.586-1.331 0.242-0.293 0.434-0.524 0.434-0.941v-5.845c0-0.312-0.268-0.606-0.551-0.606-0.329 0-0.399 0.051-0.402 0.053-0.066 0.089-0.064 0.569-0.063 0.956 0.001 0.189 0.002 0.4-0.002 0.632-0.004 0.274-0.213 0.478-0.504 0.493-0.274-0.002-0.496-0.225-0.496-0.5v-2.12c0-0.307-0.222-0.538-0.516-0.538-0.27 0-0.468 0.201-0.492 0.488v2.003c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v0-2.011c0-0.003-0.002-0.006-0.002-0.010v-0.773c0-0.066-0.014-0.642-0.474-0.642-0.45 0-0.518 0.402-0.518 0.642v0.703c0 0.028-0.011 0.054-0.016 0.081v2.594c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v0-2.684c-0.048-0.194-0.188-0.39-0.466-0.39-0.286 0-0.527 0.261-0.527 0.57v3.35c0 0.007-0.006 0.013-0.006 0.020v1.101c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.834c-0.176-0.064-0.431-0.116-0.577-0.083-0.118 0.023-0.237 0.127-0.311 0.271-0.059 0.113-0.138 0.347-0.009 0.637l1.698 3.717c0.016 0.035 0.027 0.071 0.035 0.108 0.056 0.275 0.312 0.456 0.588 0.431 0.139-0.018 0.281 0.030 0.387 0.125 0.105 0.095 0.166 0.23 0.166 0.372v1.744c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1.286c-0.536-0.139-0.969-0.561-1.107-1.125l-1.679-3.675c-0.22-0.496-0.207-1.043 0.032-1.507 0.214-0.413 0.588-0.709 1.001-0.793 0.21-0.043 0.494-0.031 0.775 0.026v-0.72c0-0.010 0.005-0.019 0.006-0.029v-1.85c0-0.866 0.686-1.57 1.527-1.57 0.2 0 0.392 0.040 0.566 0.112 0.199-0.644 0.733-1.057 1.433-1.057 0.668 0 1.192 0.422 1.389 1.061 0.178-0.075 0.373-0.116 0.579-0.116 0.689 0 1.258 0.444 1.447 1.072 0.183-0.040 0.369-0.049 0.536-0.049 0.842 0 1.552 0.735 1.552 1.606z"}}]})(props);
	};
	module.exports.TfiHandOpen = function TfiHandOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.242 5.42l-1.188 8.064c-0.118 0.612-0.389 0.88-0.586 1.076-0.191 0.19-0.318 0.316-0.318 0.933v1.007c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1.007c0-0.955 0.278-1.309 0.614-1.642 0.155-0.154 0.248-0.247 0.304-0.534l1.185-8.039c0.018-0.123 0.051-0.54-0.273-0.585-0.112-0.016-0.203 0.002-0.275 0.057-0.096 0.071-0.164 0.209-0.188 0.378l-0.497 3.316c-0.025 0.171-0.138 0.316-0.296 0.385s-0.341 0.050-0.484-0.049c-0.050 0.008-0.134-0.023-0.218-0.078-0.152-0.097-0.239-0.268-0.229-0.448l0.285-5.286c0.023-0.278-0.17-0.509-0.432-0.532-0.127-0.012-0.249 0.028-0.346 0.109-0.098 0.082-0.156 0.196-0.167 0.321l-0.463 4.782c-0.026 0.269-0.239 0.464-0.531 0.451-0.081-0.005-0.163-0.010-0.246-0.011-0.269-0.006-0.485-0.223-0.49-0.491l-0.115-6.119c0-0.268-0.21-0.478-0.468-0.478-0.258 0-0.468 0.21-0.468 0.468l-0.118 6.586c-0.004 0.19-0.114 0.362-0.286 0.443-0.062 0.030-0.122 0.060-0.179 0.092-0.147 0.084-0.326 0.087-0.476 0.008-0.15-0.078-0.251-0.227-0.268-0.395l-0.515-5.329c-0.011-0.131-0.070-0.245-0.166-0.326-0.097-0.081-0.228-0.118-0.345-0.109-0.126 0.011-0.239 0.070-0.32 0.167-0.080 0.096-0.119 0.218-0.108 0.343l0.503 7.097c0.016 0.218-0.113 0.422-0.317 0.501-0.206 0.080-0.438 0.017-0.573-0.155l-1.551-1.953c-0.203-0.34-0.562-0.435-0.84-0.274-0.136 0.079-0.233 0.205-0.273 0.356-0.040 0.15-0.020 0.308 0.060 0.443l3.529 6.087c0.080 0.139 0.211 0.236 0.367 0.274 0.224 0.054 0.382 0.255 0.382 0.486v0.69c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.35c-0.254-0.137-0.465-0.341-0.614-0.598l-3.53-6.087c-0.213-0.366-0.27-0.793-0.16-1.202 0.108-0.41 0.371-0.752 0.739-0.965 0.758-0.437 1.728-0.177 2.164 0.579l0.506 0.634-0.389-5.483c-0.034-0.382 0.086-0.764 0.338-1.066 0.252-0.3 0.608-0.485 0.999-0.52 0.397-0.036 0.775 0.087 1.077 0.34 0.146 0.123 0.263 0.269 0.35 0.431l0.014-0.753c0-0.802 0.659-1.46 1.468-1.46s1.468 0.659 1.468 1.469l0.014 0.746c0.088-0.163 0.206-0.31 0.353-0.434 0.303-0.254 0.688-0.376 1.078-0.34 0.811 0.071 1.412 0.788 1.341 1.598l-0.053 0.978c0.026-0.023 0.054-0.045 0.081-0.066 0.288-0.216 0.637-0.3 1.018-0.248 0.785 0.109 1.248 0.816 1.122 1.717z"}}]})(props);
	};
	module.exports.TfiHandPointDown = function TfiHandPointDown (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13.753 11.303c-0.956 0.577-1.702-0.173-1.982-0.454l-0.26-0.282v4.898c0 0.847-0.675 1.535-1.505 1.535s-1.505-0.688-1.505-1.535v-2.325c-0.162 0.059-0.336 0.091-0.517 0.091-0.79 0-1.44-0.629-1.496-1.424-0.158 0.059-0.328 0.090-0.505 0.090-0.83 0-1.505-0.689-1.505-1.537v-0.136c-0.145 0.049-0.3 0.075-0.463 0.075-0.835 0-1.515-0.689-1.515-1.535v-3.186c0-0.67 0.322-1.555 0.606-2.335 0.185-0.507 0.394-1.082 0.394-1.309v-0.856c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.855c0 0.404-0.2 0.955-0.454 1.652-0.256 0.703-0.546 1.499-0.546 1.993v3.186c0 0.29 0.236 0.535 0.516 0.535 0.292 0 0.454-0.262 0.463-0.52 0.010-0.27 0.231-0.482 0.5-0.482 0.003 0 0.006 0 0.009 0 0.272 0.005 0.491 0.228 0.491 0.5v1.562c0 0.296 0.227 0.537 0.505 0.537 0.264 0 0.484-0.22 0.502-0.5 0.016-0.269 0.235-0.47 0.514-0.468 0.27 0.009 0.484 0.23 0.484 0.5v1.268c0 0.295 0.225 0.535 0.5 0.535 0.259 0 0.487-0.202 0.521-0.461 0.034-0.261 0.267-0.464 0.528-0.435 0.263 0.017 0.468 0.235 0.468 0.499v3.631c0 0.295 0.227 0.535 0.505 0.535s0.505-0.24 0.505-0.535v-6.18c0-0.206 0.126-0.391 0.318-0.466 0.189-0.075 0.409-0.024 0.55 0.127l1.114 1.211c0.459 0.462 0.607 0.373 0.748 0.287 0.246-0.146 0.331-0.484 0.188-0.74l-3.288-7.098c-0.053-0.091-0.164-0.178-0.297-0.211-0.222-0.056-0.378-0.255-0.378-0.485v-0.832c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.499c0.233 0.134 0.428 0.33 0.564 0.574l3.288 7.098c0.393 0.694 0.148 1.631-0.565 2.054z"}}]})(props);
	};
	module.exports.TfiHandPointLeft = function TfiHandPointLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.422 13.5c0 0.276-0.224 0.5-0.5 0.5h-0.855c-0.227 0-0.802 0.209-1.309 0.394-0.781 0.284-1.666 0.606-2.336 0.606h-3.185c-0.847 0-1.536-0.68-1.536-1.516 0-0.163 0.026-0.318 0.075-0.463h-0.135c-0.847 0-1.536-0.676-1.536-1.506 0-0.177 0.031-0.346 0.089-0.504-0.795-0.055-1.424-0.704-1.424-1.495 0-0.181 0.032-0.355 0.091-0.518h-2.326c-0.847 0-1.535-0.675-1.535-1.504 0-0.83 0.688-1.506 1.535-1.506h4.897l-0.266-0.245c-0.296-0.295-1.043-1.040-0.468-1.998 0.423-0.71 1.36-0.955 2.088-0.547l7.028 3.252c0.268 0.149 0.471 0.348 0.607 0.583h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-0.831c-0.229 0-0.429-0.155-0.485-0.378-0.034-0.133-0.121-0.245-0.245-0.315l-7.028-3.251c-0.294-0.164-0.627-0.080-0.775 0.169-0.086 0.144-0.174 0.29 0.3 0.764l1.196 1.098c0.152 0.14 0.202 0.357 0.127 0.55s-0.26 0.318-0.466 0.318h-6.18c-0.294 0-0.534 0.227-0.534 0.506 0 0.278 0.24 0.504 0.535 0.504h3.631c0.264 0 0.482 0.204 0.499 0.468 0.017 0.263-0.173 0.494-0.434 0.528-0.259 0.033-0.461 0.263-0.461 0.522 0 0.275 0.24 0.5 0.535 0.5h1.268c0.27 0 0.492 0.215 0.5 0.484 0.008 0.271-0.2 0.498-0.469 0.515-0.28 0.018-0.499 0.237-0.499 0.501 0 0.279 0.241 0.506 0.536 0.506h1.562c0.273 0 0.495 0.219 0.5 0.491s-0.21 0.499-0.482 0.509c-0.258 0.009-0.52 0.171-0.52 0.463 0 0.279 0.246 0.515 0.536 0.515h3.185c0.494 0 1.291-0.29 1.994-0.546 0.696-0.254 1.247-0.454 1.65-0.454h0.855c0.277 0 0.501 0.224 0.501 0.5z"}}]})(props);
	};
	module.exports.TfiHandPointRight = function TfiHandPointRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.922 7.494c0 0.829-0.688 1.504-1.535 1.504h-2.325c0.059 0.162 0.091 0.337 0.091 0.518 0 0.791-0.629 1.44-1.424 1.496 0.058 0.158 0.089 0.327 0.089 0.504 0 0.83-0.689 1.506-1.536 1.506h-0.136c0.049 0.145 0.075 0.3 0.075 0.463 0 0.835-0.69 1.515-1.536 1.515h-3.185c-0.67 0-1.555-0.322-2.336-0.606-0.507-0.185-1.081-0.394-1.309-0.394h-0.855c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.855c0.403 0 0.954 0.2 1.65 0.454 0.704 0.256 1.501 0.546 1.995 0.546h3.185c0.291 0 0.536-0.236 0.536-0.516 0-0.292-0.262-0.454-0.52-0.463-0.272-0.010-0.487-0.236-0.482-0.509s0.228-0.491 0.5-0.491h1.562c0.296 0 0.536-0.227 0.536-0.506 0-0.264-0.219-0.483-0.498-0.501-0.271-0.017-0.478-0.244-0.47-0.515 0.009-0.27 0.229-0.484 0.5-0.484h1.268c0.295 0 0.535-0.225 0.535-0.5 0-0.259-0.203-0.488-0.462-0.521-0.261-0.034-0.451-0.266-0.434-0.528 0.018-0.264 0.235-0.468 0.499-0.468h3.631c0.295 0 0.535-0.226 0.535-0.504 0-0.279-0.24-0.506-0.535-0.506h-6.18c-0.206 0-0.391-0.126-0.466-0.318s-0.023-0.41 0.128-0.55l1.211-1.113c0.46-0.459 0.372-0.605 0.287-0.748-0.148-0.249-0.48-0.335-0.742-0.188l-7.097 3.287c-0.089 0.052-0.176 0.164-0.211 0.297-0.055 0.223-0.254 0.378-0.484 0.378h-0.832c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.499c0.134-0.233 0.329-0.428 0.573-0.564l7.098-3.288c0.693-0.39 1.632-0.146 2.055 0.565 0.574 0.957-0.173 1.702-0.453 1.982l-0.282 0.26h4.897c0.846 0 1.535 0.676 1.535 1.506z"}}]})(props);
	};
	module.exports.TfiHandPointUp = function TfiHandPointUp (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.5 8.236v3.186c0 0.67-0.322 1.555-0.606 2.335-0.185 0.507-0.394 1.082-0.394 1.31v0.855c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.855c0-0.404 0.201-0.955 0.454-1.652 0.256-0.702 0.546-1.498 0.546-1.992v-3.187c0-0.29-0.236-0.535-0.516-0.535-0.292 0-0.454 0.262-0.463 0.52-0.009 0.272-0.209 0.507-0.508 0.482-0.272-0.005-0.491-0.228-0.491-0.5v-1.562c0-0.296-0.227-0.537-0.505-0.537-0.264 0-0.484 0.22-0.502 0.5-0.017 0.27-0.228 0.485-0.515 0.468-0.27-0.009-0.484-0.23-0.484-0.5v-1.267c0-0.295-0.224-0.535-0.5-0.535-0.259 0-0.487 0.202-0.521 0.461-0.034 0.26-0.262 0.461-0.528 0.434-0.263-0.017-0.468-0.235-0.468-0.499v-3.631c0-0.295-0.227-0.535-0.505-0.535s-0.505 0.24-0.505 0.535v6.18c0 0.206-0.126 0.391-0.318 0.466-0.191 0.075-0.41 0.024-0.55-0.127l-1.114-1.211c-0.459-0.462-0.607-0.374-0.748-0.287-0.246 0.146-0.331 0.484-0.188 0.74l3.288 7.098c0.053 0.091 0.165 0.178 0.297 0.211 0.223 0.057 0.378 0.256 0.378 0.485v0.832c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.499c-0.233-0.134-0.427-0.33-0.565-0.574l-3.287-7.098c-0.393-0.694-0.147-1.631 0.565-2.054 0.96-0.575 1.703 0.173 1.982 0.454l0.26 0.282v-4.898c0-0.847 0.676-1.535 1.505-1.535s1.505 0.688 1.505 1.535v2.325c0.162-0.058 0.336-0.090 0.517-0.090 0.791 0 1.44 0.629 1.496 1.424 0.158-0.059 0.328-0.090 0.505-0.090 0.83 0 1.505 0.689 1.505 1.537v0.136c0.145-0.049 0.3-0.075 0.463-0.075 0.835-0.001 1.515 0.688 1.515 1.534z"}}]})(props);
	};
	module.exports.TfiHandStop = function TfiHandStop (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14 4.403v7.258c0 0.856-0.337 1.867-0.635 2.758-0.179 0.538-0.365 1.093-0.365 1.331v0.75c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.75c0-0.4 0.184-0.95 0.417-1.647 0.259-0.78 0.583-1.749 0.583-2.442v-7.258c0-0.275-0.206-0.483-0.478-0.483-0.278 0-0.512 0.21-0.521 0.468 0 0.003-0.002 0.006-0.002 0.009l0.001 3.86c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5l-0.001-4.086c0-0.005 0.003-0.009 0.003-0.015v-1.406c0-0.232-0.14-0.483-0.446-0.483-0.274 0-0.528 0.21-0.544 0.45-0.001 0.013-0.010 0.025-0.012 0.039v4.48c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.223-0.5-0.5v-4.896c0-0.022 0.010-0.042 0.013-0.063v-0.795c0-0.261-0.241-0.482-0.525-0.482-0.279 0-0.497 0.211-0.497 0.482v0.866c0.002 0.015 0.009 0.028 0.009 0.044v0 4.896c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v0-4.592c0-0.004-0.003-0.007-0.004-0.011-0.033-0.238-0.248-0.418-0.5-0.418-0.279 0-0.505 0.217-0.505 0.483v5.705c0 0.208-0.128 0.394-0.322 0.467-0.191 0.073-0.413 0.020-0.551-0.135l-1.117-1.254c-0.393-0.459-0.656-0.311-0.753-0.255-0.116 0.065-0.199 0.171-0.232 0.297-0.032 0.121-0.014 0.248 0.050 0.357l3.292 7.009c0.046 0.073 0.158 0.155 0.294 0.188 0.225 0.054 0.382 0.255 0.382 0.486v0.885c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.546c-0.231-0.128-0.423-0.314-0.56-0.545l-3.291-7.010c-0.18-0.299-0.235-0.698-0.134-1.081 0.103-0.387 0.354-0.71 0.706-0.91 0.676-0.381 1.422-0.206 2 0.468l0.237 0.266v-4.392c0-0.818 0.675-1.483 1.505-1.483 0.174 0 0.343 0.030 0.5 0.085 0.067-0.757 0.71-1.352 1.491-1.352 0.801 0 1.459 0.604 1.521 1.367 0.171-0.064 0.356-0.1 0.548-0.1 0.811 0 1.446 0.651 1.446 1.483v0.262c0.163-0.059 0.338-0.091 0.52-0.091 0.828-0.001 1.477 0.65 1.477 1.482z"}}]})(props);
	};
	module.exports.TfiHarddrive = function TfiHarddrive (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.134 2.996h-11.266l-2.868 4.374v6.634h17v-6.569l-2.866-4.439zM3.409 3.996h10.18l1.942 3.008h-14.094l1.972-3.008zM1 13.004v-5h15v5h-15zM13.5 9.004c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5-0.673-1.5-1.5-1.5zM13.5 11.004c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z"}}]})(props);
	};
	module.exports.TfiHarddrives = function TfiHarddrives (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13.5 12.5c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5-0.673-1.5-1.5-1.5zM13.5 14.5c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM17 3.15l-2.923-3.15h-11.151l-2.926 3.087v6.433h0.936l-0.936 1.172v6.308h17v-6.26l-1.046-1.22h1.046v-6.37zM3.355 1h10.286l1.854 2h-14.035l1.895-2zM1 16v-4h15v4h-15zM15.906 11h-14.873l1.181-1.48h12.424l1.268 1.48zM1 8.52v-4.52h15v4.52h-15zM13.5 5c-0.827 0-1.5 0.673-1.5 1.5 0 0.826 0.673 1.499 1.5 1.499s1.5-0.673 1.5-1.499c0-0.827-0.673-1.5-1.5-1.5zM13.5 6.999c-0.275 0-0.5-0.224-0.5-0.499s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.499-0.5 0.499z"}}]})(props);
	};
	module.exports.TfiHeadphoneAlt = function TfiHeadphoneAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.668 6.017c-0.957-3.557-3.863-6.017-7.168-6.017-3.295 0-6.212 2.464-7.168 6.017-0.747 0.082-1.332 0.712-1.332 1.483v4c0 0.625 0.382 1.16 0.924 1.385 0.194 1.747 1.663 3.115 3.461 3.115h2.707c0.207 0.581 0.757 1 1.408 1h3c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5h-3c-0.651 0-1.201 0.419-1.408 1h-2.707c-1.208 0-2.217-0.86-2.449-2h1.064v-1h1v-5h-1v-1h-0.606c0.913-2.961 3.352-5 6.106-5 2.762 0 5.193 2.037 6.106 5h-0.606v1h-1v5h1v1h1.506c0.824 0 1.494-0.673 1.494-1.5v-4c0-0.771-0.585-1.401-1.332-1.483zM8.5 15h3c0.275 0 0.5 0.224 0.5 0.5s-0.225 0.5-0.5 0.5h-3c-0.275 0-0.5-0.224-0.5-0.5s0.225-0.5 0.5-0.5zM2 12h-0.506c-0.272 0-0.494-0.224-0.494-0.5v-4c0-0.276 0.222-0.5 0.494-0.5h0.506v5zM16 11.5c0 0.276-0.222 0.5-0.494 0.5h-0.506v-5h0.506c0.272 0 0.494 0.224 0.494 0.5v4z"}}]})(props);
	};
	module.exports.TfiHeadphone = function TfiHeadphone (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.981 8.085c-0.192-4.493-3.469-8.085-7.481-8.085s-7.289 3.592-7.481 8.085c-0.59 0.201-1.019 0.756-1.019 1.415v4c0 0.827 0.67 1.5 1.494 1.5h1.506v-1h1v-5h-1v-1h-0.978c0.225-3.902 3.040-7 6.478-7s6.253 3.098 6.478 7h-0.978v1h-1v5h1v1h1.506c0.824 0 1.494-0.673 1.494-1.5v-4c0-0.659-0.429-1.214-1.019-1.415zM2 14h-0.506c-0.272 0-0.494-0.225-0.494-0.5v-4c0-0.275 0.222-0.5 0.494-0.5h0.506v5zM16 13.5c0 0.275-0.222 0.5-0.494 0.5h-0.506v-5h0.506c0.272 0 0.494 0.225 0.494 0.5v4z"}}]})(props);
	};
	module.exports.TfiHeartBroken = function TfiHeartBroken (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0.153 6.276c-0.105-0.419-0.153-0.775-0.153-1.118 0-2.481 2.019-4.5 4.5-4.5 1.739 0 3.251 0.992 4 2.439 0.749-1.447 2.261-2.439 4-2.439 2.481 0 4.5 2.019 4.5 4.5 0 0.342-0.047 0.688-0.147 1.091l-0.113 0.368c-0.081 0.331-0.228 0.721-0.453 1.199l-0.904-0.426c0.196-0.418 0.322-0.749 0.395-1.041l0.112-0.369c0.073-0.295 0.11-0.564 0.11-0.822 0-1.93-1.57-3.5-3.5-3.5s-3.5 1.571-3.5 3.5h-1c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.571-3.5 3.5c0 0.259 0.038 0.536 0.116 0.847l0.1 0.316c0.094 0.287 0.235 0.618 0.441 1.033l-0.896 0.446c-0.228-0.46-0.386-0.833-0.498-1.173l-0.11-0.351zM8.499 15.211c-0.806-0.633-3.102-2.533-4.976-5.013l-0.797 0.604c2.394 3.167 5.354 5.352 5.478 5.443l0.298 0.218 0.296-0.22c0.129-0.095 3.187-2.374 5.536-5.438l-0.793-0.609c-1.848 2.409-4.219 4.366-5.042 5.015zM14.172 7.415l-2.832 2-2.832-2-2.833 2-2.837-1.999-3.126 2.202 0.576 0.818 2.55-1.798 2.837 2.001 2.833-2 2.832 2 2.832-2 2.539 1.796 0.578-0.816-3.117-2.204z"}}]})(props);
	};
	module.exports.TfiHeart = function TfiHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.5 0.658c-1.739 0-3.251 0.992-4 2.439-0.749-1.447-2.261-2.439-4-2.439-2.481 0-4.5 2.019-4.5 4.5 0 0.343 0.048 0.699 0.154 1.118l0.109 0.351c1.432 4.354 7.659 9.393 7.924 9.604l0.313 0.252 0.313-0.252c0.282-0.227 6.926-5.598 7.927-9.614l0.112-0.368c0.101-0.402 0.148-0.749 0.148-1.091 0-2.481-2.019-4.5-4.5-4.5zM15.889 5.98l-0.113 0.37c-0.809 3.246-5.946 7.727-7.276 8.843-1.282-1.083-6.122-5.337-7.285-8.872l-0.1-0.316c-0.077-0.311-0.115-0.588-0.115-0.847 0-1.93 1.57-3.5 3.5-3.5s3.5 1.571 3.5 3.5v0.252h1v-0.252c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 0.258-0.038 0.527-0.111 0.822z"}}]})(props);
	};
	module.exports.TfiHelpAlt = function TfiHelpAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.813-8.5-8.5-8.5zM8.5 16c-4.136 0-7.5-3.364-7.5-7.5s3.364-7.5 7.5-7.5 7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5zM9.658 12.219c0 0.568-0.462 1.031-1.031 1.031-0.571 0-1.033-0.463-1.033-1.031 0-0.57 0.462-1.032 1.033-1.032 0.569 0 1.031 0.461 1.031 1.032zM10.662 4.215c0.448 0.565 0.674 1.328 0.55 1.855-0.243 1.027-0.842 1.567-1.371 2.043-0.543 0.489-0.934 0.84-0.934 1.647h-1c0-1.251 0.671-1.856 1.264-2.39 0.461-0.415 0.896-0.807 1.066-1.529 0.034-0.143-0.039-0.6-0.36-1.005-0.307-0.389-0.728-0.586-1.248-0.586-1.779 0-1.869 1.444-1.873 1.609l-1-0.027c0.024-0.893 0.655-2.582 2.873-2.582 0.818 0 1.539 0.343 2.033 0.965z"}}]})(props);
	};
	module.exports.TfiHelp = function TfiHelp (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M10.311 14.831c0 0.898-0.73 1.628-1.629 1.628-0.902 0-1.631-0.73-1.631-1.628 0-0.9 0.729-1.63 1.631-1.63 0.898 0 1.629 0.73 1.629 1.63zM11.668 2.373c-0.512-0.645-1.444-1.414-2.983-1.414-4.098 0-4.245 3.758-4.246 3.796l1 0.026c0.003-0.115 0.11-2.822 3.246-2.822 1.14 0 1.825 0.563 2.199 1.035 0.555 0.7 0.7 1.508 0.624 1.833-0.291 1.229-1.011 1.877-1.773 2.563-0.935 0.841-1.9 1.71-1.9 3.558h1c0-1.402 0.692-2.026 1.569-2.815 0.804-0.724 1.715-1.544 2.077-3.078 0.149-0.634-0.083-1.76-0.813-2.682z"}}]})(props);
	};
	module.exports.TfiHome = function TfiHome (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14 16h-3v-6h-5v6h-3v-9h-1v10h13v-10h-1v9zM7 16v-5h3v5h-3zM16.796 6.473l-0.592 0.807-7.704-5.66-7.704 5.658-0.592-0.806 8.296-6.092 8.296 6.093z"}}]})(props);
	};
	module.exports.TfiHtml5 = function TfiHtml5 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.54 0.5l-1.28 14.379-5.78 1.621-5.74-1.621-1.28-14.379h14.080zM12.92 3.439h-8.84l0.47 5.34h6.121l-0.222 2.279-1.969 0.532-1.96-0.531-0.13-1.399h-1.749l0.22 2.779 3.62 1h0.039v-0.010l3.591-0.99 0.5-5.44h-6.441l-0.15-1.81h6.74l0.16-1.75z"}}]})(props);
	};
	module.exports.TfiHummer = function TfiHummer (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9 4h5.625l-3.609-4h-7.016v4h4v3.723h-1.125v9.277h3.25v-9.277h-1.125v-3.723zM5 1h5.571l1.805 2h-7.376v-2zM9.125 16h-1.25v-7.277h1.25v7.277z"}}]})(props);
	};
	module.exports.TfiIdBadge = function TfiIdBadge (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 3v12h17v-12h-17zM16 14h-15v-10h15v10zM2.562 13.511l-1-0.022c0.033-1.43 1.398-2.652 3.309-3.017v-0.326c-0.248-0.259-0.425-0.61-0.545-0.923-0.162-0.116-0.302-0.294-0.399-0.516-0.185-0.41-0.153-0.821 0.063-1.068-0.004-0.074-0.006-0.147-0.006-0.217l-0.002-0.184c-0.006-0.537-0.016-1.42 0.929-1.584 0.194-0.339 0.483-0.627 1.179-0.651 1.123-0.035 1.916 0.378 2.185 1.151 0.091 0.265 0.006 0.485-0.056 0.645-0.059 0.152-0.115 0.295-0.082 0.564 0.013 0.107 0.011 0.212 0.003 0.312 0.175 0.237 0.211 0.597 0.082 0.975-0.095 0.273-0.249 0.484-0.434 0.608-0.111 0.287-0.27 0.604-0.487 0.845v0.377c1.909 0.375 3.228 1.571 3.261 3.008l-1 0.023c-0.023-1.021-1.21-1.908-2.823-2.109l-0.438-0.055v-1.709l0.2-0.15c0.106-0.080 0.271-0.321 0.415-0.761l0.135-0.344 0.074-0.631c0.014-0.106 0.027-0.207 0.019-0.268-0.062-0.52 0.066-0.85 0.142-1.046 0.005-0.014 0.009-0.023 0.012-0.031-0.21-0.396-0.879-0.413-1.171-0.406-0.277 0.011-0.297 0.050-0.351 0.153-0.068 0.132-0.229 0.442-0.637 0.478-0.092 0.008-0.121 0.027-0.121 0.027-0.041 0.064-0.038 0.367-0.036 0.568l0.001 0.195c0 0.141 0.010 0.292 0.029 0.446l0.070 0.573 0.12 0.021 0.003 0.248c0.154 0.466 0.339 0.721 0.451 0.798l0.215 0.149v1.687l-0.442 0.052c-1.612 0.189-2.844 1.098-2.867 2.115zM15 8h-5v-1h5v1zM14 10h-4v-1h4v1z"}}]})(props);
	};
	module.exports.TfiImage = function TfiImage (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M1 1v15h15v-15h-15zM15 15h-13v-2h13v2zM2 12v-10h13v10h-13zM14.203 10.165l-0.697 0.717-2.417-2.349-1.554 1.676-2.486-4.415-3.401 4.975-0.826-0.564 4.31-6.303 2.604 4.622 1.317-1.422 3.15 3.063z"}}]})(props);
	};
	module.exports.TfiImport = function TfiImport (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 13.677l-4.853-4.83 0.705-0.709 3.648 3.631v-10.797h1v10.797l3.647-3.63 0.705 0.709-4.852 4.829zM16 9.030v6.47c0 0.276-0.224 0.5-0.5 0.5h-14c-0.276 0-0.5-0.224-0.5-0.5v-6.475h-1v6.475c0 0.827 0.673 1.5 1.5 1.5h14c0.827 0 1.5-0.673 1.5-1.5v-6.47h-1z"}}]})(props);
	};
	module.exports.TfiInfinite = function TfiInfinite (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 8c0 2.206-1.794 4-4 4-1.197 0-2.31-0.532-3.074-1.452l-0.002 0.001-0.014-0.018c-0.011-0.014-0.026-0.023-0.038-0.038l0.004-0.003-3.634-4.482c-0.569-0.64-1.386-1.008-2.242-1.008-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3 0.915 0 1.769-0.41 2.342-1.125l0.009 0.007 0.817-1.012 0.778 0.628-0.823 1.019-0.010-0.008c-0.763 0.947-1.897 1.491-3.113 1.491-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4 1.12 0 2.186 0.477 2.943 1.301l0.008-0.006 0.042 0.052 3.698 4.56c0.573 0.693 1.409 1.093 2.309 1.093 1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-0.846 0-1.65 0.362-2.22 0.989l-0.948 1.175-0.778-0.628 0.948-1.175-0.004-0.003c0.76-0.863 1.855-1.358 3.002-1.358 2.206 0 4 1.794 4 4z"}}]})(props);
	};
	module.exports.TfiInfoAlt = function TfiInfoAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.813-8.5-8.5-8.5zM8.5 16c-4.136 0-7.5-3.364-7.5-7.5s3.364-7.5 7.5-7.5 7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5zM9 12.369h0.979v1h-2.958v-1h0.979v-4.42h-0.946v-1h1.946v5.42zM7.185 4.986c0-0.545 0.441-0.986 0.986-0.986s0.985 0.441 0.985 0.986c0 0.543-0.44 0.984-0.985 0.984s-0.986-0.441-0.986-0.984z"}}]})(props);
	};
	module.exports.TfiInfo = function TfiInfo (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M10.8 14.276v1h-4.6v-1h1.8v-7.431h-1.75v-1h2.75v8.431h1.8zM7.988 4.045c0.848 0 1.532-0.686 1.532-1.532 0-0.847-0.685-1.534-1.532-1.534-0.849 0-1.534 0.687-1.534 1.534 0 0.846 0.686 1.532 1.534 1.532z"}}]})(props);
	};
	module.exports.TfiInkPen = function TfiInkPen (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M3 0v6.499l5.466 9.499 5.534-9.498v-6.5h-11zM8.471 14h0.002l-0.001 0.002-0.001-0.002zM8.5 6c-0.552 0-1-0.449-1-1s0.448-1 1-1 1 0.449 1 1-0.448 1-1 1zM13 6.23l-4 6.866v-6.167c0.86-0.223 1.5-1 1.5-1.929 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.929 0.64 1.706 1.5 1.929v6.254l-4-6.952v-5.231h9v5.23z"}}]})(props);
	};
	module.exports.TfiInstagram = function TfiInstagram (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13 0h-9c-2.2 0-4 1.8-4 4v9c0 2.2 1.8 4 4 4h9c2.2 0 4-1.8 4-4v-9c0-2.2-1.8-4-4-4zM16 13c0 1.654-1.346 3-3 3h-9c-1.654 0-3-1.346-3-3v-6h3.207c-0.286 0.61-0.457 1.283-0.457 2 0 2.619 2.131 4.75 4.75 4.75s4.75-2.131 4.75-4.75c0-0.717-0.171-1.39-0.457-2h3.207v6zM12.25 9c0 2.068-1.682 3.75-3.75 3.75s-3.75-1.682-3.75-3.75 1.682-3.75 3.75-3.75 3.75 1.682 3.75 3.75zM12.152 6c-0.872-1.059-2.176-1.75-3.652-1.75s-2.78 0.691-3.652 1.75h-3.848v-2c0-1.654 1.346-3 3-3h9c1.654 0 3 1.346 3 3v2h-3.848zM14.454 2.722v1.298c0 0.299-0.244 0.543-0.542 0.543h-1.368c-0.3-0.001-0.544-0.245-0.544-0.543v-1.298c0-0.299 0.244-0.543 0.544-0.543h1.368c0.298 0 0.542 0.244 0.542 0.543z"}}]})(props);
	};
	module.exports.TfiItalic = function TfiItalic (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M11.895 2.014l-5.691 12.986h0.796v1h-3v-1h1.111l5.691-12.986h-0.802v-1h3v1h-1.105z"}}]})(props);
	};
	module.exports.TfiJoomla = function TfiJoomla (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.979 12.011l-1.573 1.583-0.312 0.312c-0.917 0.906-2.198 1.219-3.364 0.927-0.22 0.959-1.074 1.667-2.094 1.667-1.177 0-2.136-0.959-2.136-2.146 0-1.009 0.698-1.864 1.646-2.082-0.302-1.178 0.010-2.47 0.927-3.386l0.125-0.125 1.573 1.584-0.114 0.114c-0.521 0.51-0.51 1.343 0 1.863 0.51 0.511 1.344 0.511 1.854 0l0.313-0.312 1.573-1.584 1.677-1.666 1.573 1.584-1.668 1.667zM8.219 3.365l-1.583 1.582-0.126-0.125c-0.51-0.51-1.344-0.51-1.854 0-0.51 0.511-0.51 1.355 0 1.865l3.552 3.552-1.572 1.583-1.677-1.667-1.573-1.582-0.313-0.312c-0.959-0.948-1.25-2.313-0.886-3.532-0.958-0.208-1.666-1.062-1.666-2.083 0-1.188 0.959-2.146 2.136-2.146 1.073 0 1.948 0.781 2.114 1.792 1.156-0.271 2.417 0.053 3.323 0.947l0.125 0.126zM14.625 4.771c0.344 1.197 0.041 2.541-0.906 3.489l-0.125 0.125-1.573-1.584 0.125-0.124c0.51-0.511 0.51-1.345 0-1.855-0.51-0.51-1.344-0.51-1.854 0l-3.563 3.564-1.583-1.584 1.677-1.667 1.583-1.582 0.302-0.313c0.948-0.947 2.302-1.25 3.511-0.895 0.145-1.043 1.041-1.845 2.125-1.845 1.177 0 2.136 0.959 2.136 2.146-0.001 1.083-0.813 1.979-1.855 2.125zM14.364 16.5c-1.041 0-1.906-0.739-2.104-1.719-1.208 0.374-2.594 0.084-3.552-0.875l-0.114-0.125 1.573-1.583 0.125 0.124c0.51 0.511 1.344 0.511 1.854 0 0.51-0.51 0.51-1.343 0-1.854l-0.312-0.313-3.251-3.249 1.583-1.584 3.25 3.251 0.303 0.312c0.906 0.906 1.229 2.188 0.937 3.354 1.042 0.146 1.844 1.032 1.844 2.114 0 1.188-0.958 2.147-2.136 2.147z"}}]})(props);
	};
	module.exports.TfiJsfiddle = function TfiJsfiddle (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.5 10.867c0 1.711-1.414 3.102-3.148 3.102-0.062 0-0.117-0.008-0.172-0.008h-9.508c-1.75-0.102-3.172-1.438-3.172-3.172 0-1.164 0.633-2.18 1.578-2.734-0.062-0.203-0.094-0.414-0.094-0.641 0-1.195 0.977-2.164 2.195-2.164 0.5 0 0.969 0.172 1.344 0.453 0.766-1.578 2.391-2.672 4.289-2.672 2.633 0 4.758 2.102 4.758 4.688 0 0.094-0.008 0.188-0.008 0.281 1.133 0.469 1.938 1.578 1.938 2.867zM6.438 12.141c0.766 0 1.32-0.242 1.875-0.773-0.227-0.281-0.477-0.555-0.711-0.836-0.32 0.312-0.672 0.508-1.125 0.508-0.555 0-1.031-0.367-1.031-0.945 0-0.57 0.477-0.945 1.016-0.945 1.719 0 2.086 3 4.586 3 1.219 0 2.25-0.766 2.25-2.047 0-1.297-1.039-2.055-2.273-2.055-0.766 0-1.336 0.219-1.883 0.758 0.25 0.273 0.484 0.562 0.727 0.844 0.312-0.305 0.664-0.5 1.109-0.5 0.516 0 1.031 0.367 1.031 0.914 0 0.602-0.438 0.984-1.023 0.984-1.664 0-2.109-3-4.547-3-1.211 0-2.281 0.742-2.281 2.031-0.002 1.319 1.037 2.062 2.28 2.062z"}}]})(props);
	};
	module.exports.TfiKey = function TfiKey (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.811 6.299l0.707-0.707-1.733-1.733 0.757-0.753-0.705-0.709-8.146 8.107c-0.484-0.336-1.070-0.535-1.703-0.535-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3c0-0.661-0.222-1.268-0.585-1.764l5.264-5.238 1.738 1.738 0.707-0.707-1.737-1.736 0.701-0.698 1.735 1.735zM3.987 14.969c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2z"}}]})(props);
	};
	module.exports.TfiLayersAlt = function TfiLayersAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M11 1h-11v9h11v-9zM10 9h-9v-7h9v7zM14 13h-11v-1.981h1v0.981h9v-7h-0.994v-1h1.994v9zM17 7v9h-11v-1.981h1v0.981h9v-7h-0.994v-1h1.994z"}}]})(props);
	};
	module.exports.TfiLayers = function TfiLayers (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13 1h-13v11h13v-11zM12 11h-11v-9h11v9zM17 5v11h-13v-3.031h1v2.031h11v-9h-2.016v-1h3.016z"}}]})(props);
	};
	module.exports.TfiLayoutAccordionList = function TfiLayoutAccordionList (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M4 0v9h13v-9h-13zM16 8h-11v-7h11v7zM0 3h3v-3h-3v3zM1 1h1v1h-1v-1zM4 13h13v-3h-13v3zM5 11h11v1h-11v-1zM0 13h3v-3h-3v3zM1 11h1v1h-1v-1zM4 17h13v-3h-13v3zM5 15h11v1h-11v-1zM0 17h3v-3h-3v3zM1 15h1v1h-1v-1z"}}]})(props);
	};
	module.exports.TfiLayoutAccordionMerged = function TfiLayoutAccordionMerged (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0v17h17v-17h-17zM16 1v9h-15v-9h15zM16 11v2h-15v-2h15zM1 16v-2h15v2h-15z"}}]})(props);
	};
	module.exports.TfiLayoutAccordionSeparated = function TfiLayoutAccordionSeparated (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0v3h17v-3h-17zM16 2h-15v-1h15v1zM0 13h17v-9h-17v9zM1 5h15v7h-15v-7zM0 17h17v-3h-17v3zM1 15h15v1h-15v-1z"}}]})(props);
	};
	module.exports.TfiLayoutColumn2Alt = function TfiLayoutColumn2Alt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0h8v17h-8v-17zM9 0v17h8v-17h-8z"}}]})(props);
	};
	module.exports.TfiLayoutColumn2 = function TfiLayoutColumn2 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 17h8v-17h-8v17zM1 1h6v15h-6v-15zM9 0v17h8v-17h-8zM16 16h-6v-15h6v15z"}}]})(props);
	};
	module.exports.TfiLayoutColumn3Alt = function TfiLayoutColumn3Alt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0h5v17h-5v-17zM6 17h5v-17h-5v17zM12 0v17h5v-17h-5z"}}]})(props);
	};
	module.exports.TfiLayoutColumn3 = function TfiLayoutColumn3 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 17h5v-17h-5v17zM1 1h3v15h-3v-15zM6 17h5v-17h-5v17zM7 1h3v15h-3v-15zM12 0v17h5v-17h-5zM16 16h-3v-15h3v15z"}}]})(props);
	};
	module.exports.TfiLayoutColumn4Alt = function TfiLayoutColumn4Alt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M1 0h3v17h-3v-17zM5 17h3v-17h-3v17zM9 17h3v-17h-3v17zM13 0v17h3v-17h-3z"}}]})(props);
	};
	module.exports.TfiLayoutColumn4 = function TfiLayoutColumn4 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M1 17h3v-17h-3v17zM2 1h1v15h-1v-15zM5 17h3v-17h-3v17zM6 1h1v15h-1v-15zM9 17h3v-17h-3v17zM10 1h1v15h-1v-15zM13 0v17h3v-17h-3zM15 16h-1v-15h1v15z"}}]})(props);
	};
	module.exports.TfiLayoutCtaBtnLeft = function TfiLayoutCtaBtnLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 7h-7v-1h7v1zM8.007 9h5v-1h-5v1zM17 3v10h-17v-10h17zM16 4h-15v8h15v-8zM7 6h-5v2h5v-2z"}}]})(props);
	};
	module.exports.TfiLayoutCtaBtnRight = function TfiLayoutCtaBtnRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9 7h-7v-1h7v1zM3.993 9h5v-1h-5v1zM17 3v10h-17v-10h17zM16 4h-15v8h15v-8zM15 6h-5v2h5v-2z"}}]})(props);
	};
	module.exports.TfiLayoutCtaCenter = function TfiLayoutCtaCenter (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14 8h-11v-1h11v1zM17 3v11h-17v-11h17zM16 4h-15v9h15v-9zM6.357 11h4.286v-2h-4.286v2z"}}]})(props);
	};
	module.exports.TfiLayoutCtaLeft = function TfiLayoutCtaLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 3v11h17v-11h-17zM16 13h-15v-9h15v9zM13 8h-10v-1h10v1zM8 11h-5v-2h5v2z"}}]})(props);
	};
	module.exports.TfiLayoutCtaRight = function TfiLayoutCtaRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 3v11h17v-11h-17zM16 13h-15v-9h15v9zM14 8h-10v-1h10v1zM9 9h5v2h-5v-2z"}}]})(props);
	};
	module.exports.TfiLayoutGrid2Alt = function TfiLayoutGrid2Alt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0h7v7h-7v-7zM9 0v7h7v-7h-7zM0 16h7v-7h-7v7zM9 16h7v-7h-7v7z"}}]})(props);
	};
	module.exports.TfiLayoutGrid2Thumb = function TfiLayoutGrid2Thumb (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 2h3v3h-3v-3zM9 5h3v-3h-3v3zM0 13h3v-3h-3v3zM9 13h3v-3h-3v3zM4 3h4v-1h-4v1zM4 5h4v-1h-4v1zM13 2v1h4v-1h-4zM13 5h4v-1h-4v1zM7 5.999h-3v1h3v-1zM16 5.999h-3v1h3v-1zM4 11h4v-1h-4v1zM4 13h4v-1h-4v1zM13 11h4v-1h-4v1zM13 13h4v-1h-4v1zM4 14.999h3v-1h-3v1zM13 14.999h3v-1h-3v1z"}}]})(props);
	};
	module.exports.TfiLayoutGrid2 = function TfiLayoutGrid2 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 7h7v-7h-7v7zM1 1h5v5h-5v-5z"}},{"tag":"path","attr":{"d":"M9 0v7h7v-7h-7zM15 6h-5v-5h5v5z"}},{"tag":"path","attr":{"d":"M0 16h7v-7h-7v7zM1 10h5v5h-5v-5z"}},{"tag":"path","attr":{"d":"M9 16h7v-7h-7v7zM10 10h5v5h-5v-5z"}}]})(props);
	};
	module.exports.TfiLayoutGrid3Alt = function TfiLayoutGrid3Alt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0h5v5h-5v-5zM6 5h5v-5h-5v5zM12 0v5h5v-5h-5zM0 11h5v-5h-5v5zM6 11h5v-5h-5v5zM12 11h5v-5h-5v5zM0 17h5v-5h-5v5zM6 17h5v-5h-5v5zM12 17h5v-5h-5v5z"}}]})(props);
	};
	module.exports.TfiLayoutGrid3 = function TfiLayoutGrid3 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 5h5v-5h-5v5zM1 1h3v3h-3v-3zM6 5h5v-5h-5v5zM7 1h3v3h-3v-3zM12 0v5h5v-5h-5zM16 4h-3v-3h3v3zM0 11h5v-5h-5v5zM1 7h3v3h-3v-3zM6 11h5v-5h-5v5zM7 7h3v3h-3v-3zM12 11h5v-5h-5v5zM13 7h3v3h-3v-3zM0 17h5v-5h-5v5zM1 13h3v3h-3v-3zM6 17h5v-5h-5v5zM7 13h3v3h-3v-3zM12 17h5v-5h-5v5zM13 13h3v3h-3v-3z"}}]})(props);
	};
	module.exports.TfiLayoutGrid4Alt = function TfiLayoutGrid4Alt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M1 1h3v3h-3v-3zM5 4h3v-3h-3v3zM9 4h3v-3h-3v3zM13 1v3h3v-3h-3zM1 8h3v-3h-3v3zM5 8h3v-3h-3v3zM9 8h3v-3h-3v3zM13 8h3v-3h-3v3zM1 12h3v-3h-3v3zM5 12h3v-3h-3v3zM9 12h3v-3h-3v3zM13 12h3v-3h-3v3zM1 16h3v-3h-3v3zM5 16h3v-3h-3v3zM9 16h3v-3h-3v3zM13 16h3v-3h-3v3z"}}]})(props);
	};
	module.exports.TfiLayoutGrid4 = function TfiLayoutGrid4 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M1 4h3v-3h-3v3zM2 2h1v1h-1v-1zM5 4h3v-3h-3v3zM6 2h1v1h-1v-1zM9 4h3v-3h-3v3zM10 2h1v1h-1v-1zM13 1v3h3v-3h-3zM15 3h-1v-1h1v1zM1 8h3v-3h-3v3zM2 6h1v1h-1v-1zM5 8h3v-3h-3v3zM6 6h1v1h-1v-1zM9 8h3v-3h-3v3zM10 6h1v1h-1v-1zM13 8h3v-3h-3v3zM14 6h1v1h-1v-1zM1 12h3v-3h-3v3zM2 10h1v1h-1v-1zM5 12h3v-3h-3v3zM6 10h1v1h-1v-1zM9 12h3v-3h-3v3zM10 10h1v1h-1v-1zM13 12h3v-3h-3v3zM14 10h1v1h-1v-1zM1 16h3v-3h-3v3zM2 14h1v1h-1v-1zM5 16h3v-3h-3v3zM6 14h1v1h-1v-1zM9 16h3v-3h-3v3zM10 14h1v1h-1v-1zM13 16h3v-3h-3v3zM14 14h1v1h-1v-1z"}}]})(props);
	};
	module.exports.TfiLayoutLineSolid = function TfiLayoutLineSolid (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 8v1h-17v-1h17z"}}]})(props);
	};
	module.exports.TfiLayoutListLargeImage = function TfiLayoutListLargeImage (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.497 5h-2.497v-1h2.497v1zM15.499 7.996h-1.499v1h1.499v-1zM14.004 5.998v1h2.996v-1h-2.996zM14 10.993h2.996v-1h-2.996v1zM14 13h2.497v-1h-2.497v1zM0 4h13v9h-13v-9zM1 12h11v-7h-11v7z"}}]})(props);
	};
	module.exports.TfiLayoutListPost = function TfiLayoutListPost (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14 5h-14v-2h14v2zM0 6v1h17v-1h-17zM14 10h-14v2h14v-2zM0 14h17v-1h-17v1z"}}]})(props);
	};
	module.exports.TfiLayoutListThumbAlt = function TfiLayoutListThumbAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 5h-9v-1h9v1zM6 6v1h11v-1h-11zM0 8h5v-5h-5v5zM15 11h-9v1h9v-1zM6 14h11v-1h-11v1zM0 15h5v-5h-5v5z"}}]})(props);
	};
	module.exports.TfiLayoutListThumb = function TfiLayoutListThumb (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 4h-9v-1h9v1zM6 5v1h11v-1h-11zM0 2h5v5h-5v-5zM1 6h3v-3h-3v3zM15 10h-9v1h9v-1zM6 13h11v-1h-11v1zM0 9h5v5h-5v-5zM1 13h3v-3h-3v3z"}}]})(props);
	};
	module.exports.TfiLayoutMediaCenterAlt = function TfiLayoutMediaCenterAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M1 13h15v1h-15v-1zM4 15.993h9v-1h-9v1zM17 1v11h-17v-11h17zM16 2h-15v9h15v-9z"}}]})(props);
	};
	module.exports.TfiLayoutMediaCenter = function TfiLayoutMediaCenter (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M1 4v6h15v-6h-15zM15 9h-13v-4h13v4zM14 11v1h-11v-1h11zM2 13h13v1h-13v-1z"}}]})(props);
	};
	module.exports.TfiLayoutMediaLeftAlt = function TfiLayoutMediaLeftAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 13h15v1h-15v-1zM0 15.993h10v-1h-10v1zM17 1v11h-17v-11h17zM16 2h-15v9h15v-9z"}}]})(props);
	};
	module.exports.TfiLayoutMediaLeft = function TfiLayoutMediaLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M10 4h5.826v1h-5.826v-1z"}},{"tag":"path","attr":{"d":"M10 7.996h3.497v1h-3.497v-1z"}},{"tag":"path","attr":{"d":"M10.009 5.998h6.991v1h-6.991v-1z"}},{"tag":"path","attr":{"d":"M10 9.993h6.991v1h-6.991v-1z"}},{"tag":"path","attr":{"d":"M10 12h5.826v1h-5.826v-1z"}},{"tag":"path","attr":{"d":"M0 13h9v-9h-9v9zM1 5h7v7h-7v-7z"}}]})(props);
	};
	module.exports.TfiLayoutMediaOverlayAlt2 = function TfiLayoutMediaOverlayAlt2 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12 9h-10v-1h10v1zM12 10h-10v1h10v-1zM17 1v15h-17v-15h17zM16 2h-15v13h15v-13z"}}]})(props);
	};
	module.exports.TfiLayoutMediaOverlayAlt = function TfiLayoutMediaOverlayAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 2v12h17v-12h-17zM1 10.010v-7.010h15v7.010h-15z"}}]})(props);
	};
	module.exports.TfiLayoutMediaOverlay = function TfiLayoutMediaOverlay (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 12h-13v-1h13v1zM12 12.993h-10v1h10v-1zM17 1v15h-17v-15h17zM16 2h-15v13h15v-13z"}}]})(props);
	};
	module.exports.TfiLayoutMediaRightAlt = function TfiLayoutMediaRightAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2 13h15v1h-15v-1zM7 15.993h10v-1h-10v1zM17 1v11h-17v-11h17zM16 2h-15v9h15v-9z"}}]})(props);
	};
	module.exports.TfiLayoutMediaRight = function TfiLayoutMediaRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8 4v9h9v-9h-9zM16 12h-7v-7h7v7zM1.174 4h5.826v1h-5.826v-1zM3.503 7.996h3.497v1h-3.497v-1zM6.991 6.998h-6.991v-1h6.991v1zM0.009 9.993h6.991v1h-6.991v-1zM1.174 12h5.826v1h-5.826v-1z"}}]})(props);
	};
	module.exports.TfiLayoutMenuFull = function TfiLayoutMenuFull (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 7v3h17v-3h-17zM9 8h3v1h-3v-1zM8 9h-3v-1h3v1zM1 8h3v1h-3v-1zM16 9h-3v-1h3v1z"}}]})(props);
	};
	module.exports.TfiLayoutMenuSeparated = function TfiLayoutMenuSeparated (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 10h5v-3h-5v3zM1 8h3v1h-3v-1zM6 10h5v-3h-5v3zM7 8h3v1h-3v-1zM12 7v3h5v-3h-5zM16 9h-3v-1h3v1z"}}]})(props);
	};
	module.exports.TfiLayoutMenuV = function TfiLayoutMenuV (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M3 1v3h11v-3h-11zM13 3h-9v-1h9v1zM3 8h11v-3h-11v3zM4 6h9v1h-9v-1zM3 11.997h11v-3h-11v3zM4 9.997h9v1h-9v-1zM3 15.997h11v-3h-11v3zM4 13.997h9v1h-9v-1z"}}]})(props);
	};
	module.exports.TfiLayoutMenu = function TfiLayoutMenu (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 7v3h13v-3h-13zM8 8v1h-3v-1h3zM1 8h3v1h-3v-1zM12 9h-3v-1h3v1z"}}]})(props);
	};
	module.exports.TfiLayoutPlaceholder = function TfiLayoutPlaceholder (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0.021 1.012v15h17v-15h-17zM8.137 8.509l-7.116 6.197v-12.412l7.116 6.215zM1.459 2.012h14.138l-7.079 6.165-7.059-6.165zM8.517 8.841l7.066 6.171h-14.152l7.086-6.171zM8.898 8.509l7.123-6.204v12.425l-7.123-6.221z"}}]})(props);
	};
	module.exports.TfiLayoutSidebar2 = function TfiLayoutSidebar2 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 0v17h-4v-17h4zM0 17h3v-17h-3v17zM11 17h1v-1h-1v1zM7.571 17h0.857v-1h-0.857v1zM9.286 17h0.857v-1h-0.857v1zM5.857 17h0.857v-1h-0.857v1zM4 17h1v-1h-1v1zM4 3h1v-1h-1v1zM4 13h1v-1h-1v1zM4 15h1v-1h-1v1zM4 11h1v-1h-1v1zM4 7h1v-1h-1v1zM4 5h1v-1h-1v1zM4 9h1v-1h-1v1zM4 1h1v-1h-1v1zM5.857 1h0.857v-1h-0.857v1zM9.286 1h0.857v-1h-0.857v1zM7.571 1h0.857v-1h-0.857v1zM11 1h1v-1h-1v1zM11 5h1v-1h-1v1zM11 3h1v-1h-1v1zM11 7h1v-1h-1v1zM11 9h1v-1h-1v1zM11 15h1v-1h-1v1zM11 13h1v-1h-1v1zM11 11h1v-1h-1v1z"}}]})(props);
	};
	module.exports.TfiLayoutSidebarLeft = function TfiLayoutSidebarLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0h5v17h-5v-17zM7 17h1v-1h-1v1zM14.222 17h0.889v-1h-0.889v1zM12.444 17h0.889v-1h-0.889v1zM8.889 17h0.889v-1h-0.889v1zM10.667 17h0.889v-1h-0.889v1zM16 17h1v-1h-1v1zM16 3h1v-1h-1v1zM16 15h1v-1h-1v1zM16 7h1v-1h-1v1zM16 5h1v-1h-1v1zM16 9h1v-1h-1v1zM16 11h1v-1h-1v1zM16 13h1v-1h-1v1zM16 0v1h1v-1h-1zM14.223 1h0.889v-1h-0.889v1zM12.445 1h0.889v-1h-0.889v1zM10.667 1h0.889v-1h-0.889v1zM8.889 1h0.889v-1h-0.889v1zM7 1h1v-1h-1v1zM7 15h1v-1h-1v1zM7 13h1v-1h-1v1zM7 7h1v-1h-1v1zM7 11h1v-1h-1v1zM7 5h1v-1h-1v1zM7 3h1v-1h-1v1zM7 9h1v-1h-1v1z"}}]})(props);
	};
	module.exports.TfiLayoutSidebarNone = function TfiLayoutSidebarNone (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 16h1v1h-1v-1zM14 17h1v-1h-1v1zM12 17h1v-1h-1v1zM10 17h1v-1h-1v1zM8 17h1v-1h-1v1zM6 17h1v-1h-1v1zM2 17h1v-1h-1v1zM4 17h1v-1h-1v1zM16 17h1v-1h-1v1zM16 11h1v-1h-1v1zM16 13h1v-1h-1v1zM16 5h1v-1h-1v1zM16 9h1v-1h-1v1zM16 7h1v-1h-1v1zM16 3h1v-1h-1v1zM16 15h1v-1h-1v1zM16 0v1h1v-1h-1zM4 1h1v-1h-1v1zM2 1h1v-1h-1v1zM12 1h1v-1h-1v1zM10 1h1v-1h-1v1zM6 1h1v-1h-1v1zM14 1h1v-1h-1v1zM8 1h1v-1h-1v1zM0 1h1v-1h-1v1zM0 13h1v-1h-1v1zM0 15h1v-1h-1v1zM0 11h1v-1h-1v1zM0 5h1v-1h-1v1zM0 9h1v-1h-1v1zM0 3h1v-1h-1v1zM0 7h1v-1h-1v1z"}}]})(props);
	};
	module.exports.TfiLayoutSidebarRight = function TfiLayoutSidebarRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 0v17h-5v-17h5zM9 17h1v-1h-1v1zM7.223 17h0.889v-1h-0.889v1zM1.889 17h0.889v-1h-0.889v1zM3.667 17h0.889v-1h-0.889v1zM5.445 17h0.889v-1h-0.889v1zM0 17h1v-1h-1v1zM0 9h1v-1h-1v1zM0 3h1v-1h-1v1zM0 11h1v-1h-1v1zM0 7h1v-1h-1v1zM0 13h1v-1h-1v1zM0 15h1v-1h-1v1zM0 5h1v-1h-1v1zM0 1h1v-1h-1v1zM8.111 0h-0.889v1h0.889v-1zM6.333 0h-0.889v1h0.889v-1zM2.777 0h-0.888v1h0.889v-1zM4.555 0h-0.888v1h0.889v-1zM9 1h1v-1h-1v1zM9 15h1v-1h-1v1zM9 13h1v-1h-1v1zM9 9h1v-1h-1v1zM9 11h1v-1h-1v1zM9 5h1v-1h-1v1zM9 7h1v-1h-1v1zM9 3h1v-1h-1v1z"}}]})(props);
	};
	module.exports.TfiLayoutSliderAlt = function TfiLayoutSliderAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2 14h13v-11h-13v11zM3 4h11v9h-11v-9z"}},{"tag":"path","attr":{"d":"M16 4.531h1v7.938h-1v-7.938z"}},{"tag":"path","attr":{"d":"M0 4.531h1v7.938h-1v-7.938z"}}]})(props);
	};
	module.exports.TfiLayoutSlider = function TfiLayoutSlider (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 1v14h17v-14h-17zM16 14h-15v-12h15v12zM4.646 10.354l-2.353-2.354 2.354-2.354 0.707 0.707-1.647 1.647 1.646 1.646-0.707 0.708zM11.646 9.646l1.647-1.646-1.646-1.646 0.707-0.707 2.353 2.353-2.354 2.354-0.707-0.708z"}}]})(props);
	};
	module.exports.TfiLayoutTabMin = function TfiLayoutTabMin (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M7 2v-1h-7v3.997h1v-2.997h5v3h11v-3h-10zM7 3h4v1h-4v-1zM12 4v-1h4v1h-4z"}}]})(props);
	};
	module.exports.TfiLayoutTabV = function TfiLayoutTabV (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M6 1v1h-6v4h1v4h5v6.018h11v-15.018h-11zM2 6h4v1h-4v-1zM2 9v-1h4v1h-4zM16 15.018h-9v-10.018h-6v-2h6v-1h9v13.018z"}}]})(props);
	};
	module.exports.TfiLayoutTabWindow = function TfiLayoutTabWindow (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12 2h-12v14h17v-14h-5zM16 3v2h-4v-2h4zM11 3v2h-5v-2h5zM1 3h4v2h-4v-2zM16 15h-15v-9h15v9z"}}]})(props);
	};
	module.exports.TfiLayoutTab = function TfiLayoutTab (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M7 3v-1h-7v14h17v-13h-10zM11 4v1h-4v-1h4zM16 15h-15v-12h5v3h10v9zM12 5v-1h4v1h-4z"}}]})(props);
	};
	module.exports.TfiLayoutWidthDefaultAlt = function TfiLayoutWidthDefaultAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2 16h1v1h-1v-1zM10 17h1v-1h-1v1zM12 17h1v-1h-1v1zM4 17h1v-1h-1v1zM6 17h1v-1h-1v1zM8 17h1v-1h-1v1zM14 17h1v-1h-1v1zM14 3h1v-1h-1v1zM14 5h1v-1h-1v1zM14 13h1v-1h-1v1zM14 7h1v-1h-1v1zM14 9h1v-1h-1v1zM14 15h1v-1h-1v1zM14 11h1v-1h-1v1zM14 0v1h1v-1h-1zM12 1h1v-1h-1v1zM6 1h1v-1h-1v1zM8 1h1v-1h-1v1zM10 1h1v-1h-1v1zM4 1h1v-1h-1v1zM2 1h1v-1h-1v1zM2 13h1v-1h-1v1zM2 15h1v-1h-1v1zM2 11h1v-1h-1v1zM2 3h1v-1h-1v1zM2 5h1v-1h-1v1zM2 7h1v-1h-1v1zM2 9h1v-1h-1v1z"}}]})(props);
	};
	module.exports.TfiLayoutWidthDefault = function TfiLayoutWidthDefault (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0v17h17v-17h-17zM16 16h-15v-15h15v15zM3 8h1v1h-1v-1zM3 4h1v1h-1v-1zM3 10h1v1h-1v-1zM3 6h1v1h-1v-1zM3 2h1v1h-1v-1zM3 14h1v1h-1v-1zM3 12h1v1h-1v-1zM13 2h1v1h-1v-1zM13 6h1v1h-1v-1zM13 4h1v1h-1v-1zM13 8h1v1h-1v-1zM13 10h1v1h-1v-1zM13 12h1v1h-1v-1zM13 14h1v1h-1v-1z"}}]})(props);
	};
	module.exports.TfiLayoutWidthFull = function TfiLayoutWidthFull (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0v17h17v-17h-17zM16 16h-15v-15h15v15z"}}]})(props);
	};
	module.exports.TfiLayout = function TfiLayout (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0v17h17v-17h-17zM1 6h9v10h-9v-10zM16 16h-5v-10h5v10zM1 5v-4h15v4h-15z"}}]})(props);
	};
	module.exports.TfiLightBulb = function TfiLightBulb (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0c-3.032 0-5.5 2.617-5.5 5.833 0 2.354 0.964 3.67 1.814 4.831 0.637 0.868 1.186 1.618 1.186 2.673v2.096c0 0.864 0.673 1.567 1.5 1.567h2c0.827 0 1.5-0.703 1.5-1.567v-2.126c0-1.045 0.517-1.735 1.17-2.609 0.815-1.091 1.83-2.447 1.83-4.865 0-3.216-2.468-5.833-5.5-5.833zM9.5 16h-2c-0.275 0-0.5-0.254-0.5-0.567v-1.633h3v1.633c0 0.313-0.225 0.567-0.5 0.567zM11.369 10.099c-0.587 0.785-1.19 1.593-1.336 2.701h-3.072c-0.152-1.102-0.754-1.927-1.34-2.727-0.797-1.088-1.621-2.213-1.621-4.24 0-2.665 2.019-4.833 4.5-4.833s4.5 2.168 4.5 4.833c0 2.085-0.829 3.194-1.631 4.266z"}}]})(props);
	};
	module.exports.TfiLineDashed = function TfiLineDashed (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 8h4v1h-4v-1zM6.5 9h4v-1h-4v1zM13 8v1h4v-1h-4z"}}]})(props);
	};
	module.exports.TfiLineDotted = function TfiLineDotted (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 7.998h0.5v1h-0.5v-1zM2.383 8.999h0.941v-1h-0.941v1zM5.206 8.999h0.941v-1h-0.941v1zM10.854 9h0.941v-1h-0.941v1zM8.030 8.999h0.94v-0.999h-0.94v0.999zM13.677 9h0.941v-1h-0.941v1zM16.5 8v1h0.5v-1h-0.5z"}}]})(props);
	};
	module.exports.TfiLineDouble = function TfiLineDouble (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 6v1h-17v-1h17zM0 10h17v-1h-17v1z"}}]})(props);
	};
	module.exports.TfiLink = function TfiLink (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.983 6.94l-0.938 0.938-0.707-0.707 0.938-0.938c0.975-0.975 0.975-2.561 0-3.535s-2.561-0.975-3.535 0l-2.987 2.988c-0.975 0.975-0.975 2.561 0 3.535s2.561 0.975 3.535 0l0.707 0.707c-0.683 0.683-1.578 1.023-2.475 1.023s-1.792-0.341-2.474-1.023c-1.364-1.364-1.364-3.585 0-4.949l2.987-2.987c1.365-1.365 3.584-1.365 4.949 0 1.365 1.363 1.365 3.584 0 4.948zM6.042 8.034l-0.13 0.129 0.705 0.709 0.131-0.13c0.975-0.975 2.561-0.975 3.535 0s0.975 2.561 0 3.535l-3.023 3.025c-0.975 0.975-2.561 0.975-3.535 0s-0.975-2.561 0-3.535l1.058-1.059-0.707-0.707-1.058 1.059c-1.364 1.364-1.364 3.585 0 4.949 0.683 0.683 1.578 1.023 2.475 1.023s1.792-0.341 2.475-1.023l3.023-3.024c1.364-1.364 1.364-3.585 0-4.949-1.366-1.367-3.586-1.364-4.949-0.002z"}}]})(props);
	};
	module.exports.TfiLinkedin = function TfiLinkedin (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0.698 5.823h3.438v10.323h-3.438v-10.323zM2.438 0.854c-1.167 0-1.938 0.771-1.938 1.782 0 0.989 0.74 1.781 1.896 1.781h0.021c1.198 0 1.948-0.792 1.938-1.781-0.011-1.011-0.74-1.782-1.917-1.782zM12.552 5.583c-1.829 0-2.643 1.002-3.094 1.709v-1.469h-3.427c0 0 0.042 0.969 0 10.323h3.427v-5.761c0-0.312 0.032-0.615 0.114-0.843 0.251-0.615 0.812-1.25 1.762-1.25 1.238 0 1.738 0.948 1.738 2.333v5.521h3.428v-5.917c0-3.167-1.688-4.646-3.948-4.646z"}}]})(props);
	};
	module.exports.TfiLinux = function TfiLinux (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13.849 15.25c-0.509 0.26-1.188 0.832-1.438 1.072-0.188 0.179-0.964 0.269-1.402 0.045-0.509-0.26-0.241-0.671-1.027-0.696-0.393-0.010-0.777-0.010-1.161-0.010-0.339 0.010-0.678 0.027-1.027 0.035-1.178 0.027-1.294 0.787-2.054 0.76-0.518-0.018-1.169-0.429-2.295-0.66-0.786-0.162-1.544-0.205-1.706-0.554-0.16-0.349 0.197-0.741 0.223-1.080 0.027-0.456-0.339-1.072-0.071-1.305 0.232-0.205 0.723-0.054 1.044-0.231 0.339-0.196 0.482-0.349 0.482-0.768 0.125 0.427-0.009 0.775-0.286 0.945-0.17 0.107-0.482 0.161-0.742 0.135-0.205-0.019-0.33 0.008-0.384 0.089-0.080 0.098-0.054 0.277 0.045 0.509 0.098 0.232 0.214 0.384 0.196 0.669-0.009 0.286-0.33 0.626-0.276 0.867 0.018 0.090 0.107 0.17 0.33 0.232 0.357 0.098 1.009 0.196 1.643 0.349 0.706 0.178 1.438 0.499 1.894 0.437 1.357-0.188 0.58-1.643 0.366-1.99-1.152-1.805-1.911-2.983-2.518-2.519-0.152 0.125-0.161-0.304-0.152-0.474 0.027-0.59 0.322-0.803 0.5-1.259 0.339-0.867 0.598-1.857 1.116-2.366 0.387-0.501 0.994-1.313 1.111-1.741-0.099-0.929-0.126-1.911-0.143-2.767-0.018-0.92 0.125-1.725 1.161-2.286 0.249-0.135 0.579-0.188 0.928-0.188 0.616-0.010 1.303 0.17 1.741 0.491 0.697 0.518 1.134 1.616 1.081 2.401-0.036 0.616 0.071 1.25 0.268 1.911 0.232 0.777 0.599 1.321 1.188 1.946 0.706 0.75 1.259 2.223 1.42 3.16 0.143 0.877-0.054 1.421-0.241 1.448-0.286 0.043-0.464 0.945-1.357 0.91-0.571-0.027-0.625-0.366-0.786-0.661-0.259-0.455-0.518-0.312-0.616 0.17-0.054 0.241-0.019 0.599 0.062 0.865 0.161 0.563 0.107 1.090 0.009 1.742-0.188 1.232 0.866 1.464 1.572 0.874 0.696-0.579 0.848-0.669 1.723-0.973 1.33-0.456 0.884-0.857 0.169-1.098-0.643-0.215-0.669-1.296-0.438-1.501 0.054 1.161 0.661 1.331 0.911 1.491 1.098 0.681-0.411 1.244-1.063 1.574zM12.349 10.938c0.241-0.805 0.134-1.125-0.026-1.885-0.125-0.571-0.652-1.349-1.063-1.589 0.107 0.089 0.304 0.348 0.509 0.74 0.357 0.671 0.714 1.661 0.482 2.483-0.089 0.32-0.303 0.365-0.446 0.374-0.625 0.072-0.259-0.75-0.518-1.865-0.295-1.251-0.598-1.34-0.669-1.438-0.368-1.624-0.769-1.463-0.886-2.070-0.098-0.545 0.474-0.991-0.303-1.143-0.241-0.045-0.58-0.286-0.714-0.304-0.134-0.017-0.206-0.902 0.294-0.929 0.491-0.036 0.581 0.554 0.491 0.787-0.142 0.231 0.009 0.321 0.251 0.24 0.196-0.062 0.071-0.58 0.116-0.651-0.125-0.75-0.438-0.857-0.759-0.92-1.233 0.098-0.679 1.456-0.804 1.331-0.179-0.188-0.696-0.018-0.696-0.135 0.009-0.696-0.224-1.098-0.545-1.107-0.357-0.009-0.5 0.491-0.518 0.776-0.027 0.268 0.152 0.832 0.286 0.787 0.089-0.027 0.241-0.206 0.080-0.196-0.080 0-0.205-0.197-0.223-0.429-0.009-0.233 0.081-0.465 0.384-0.456 0.348 0.009 0.348 0.705 0.312 0.732-0.115 0.080-0.259 0.233-0.277 0.259-0.115 0.188-0.338 0.24-0.428 0.322-0.152 0.16-0.187 0.339-0.071 0.401 0.41 0.232 0.276 0.499 0.848 0.519 0.375 0.018 0.651-0.054 0.911-0.134 0.196-0.062 0.831-0.196 0.964-0.429 0.062-0.098 0.134-0.098 0.178-0.071 0.089 0.044 0.107 0.214-0.116 0.268-0.312 0.090-0.625 0.26-0.91 0.367-0.277 0.115-0.366 0.16-0.625 0.204-0.589 0.107-1.026-0.214-0.634 0.17 0.134 0.125 0.259 0.205 0.598 0.197 0.75-0.027 1.581-0.93 1.661-0.528 0.017 0.089-0.233 0.196-0.429 0.295-0.696 0.339-1.187 1.018-1.634 0.785-0.402-0.214-0.803-1.206-0.795-0.758 0.009 0.687-0.902 1.294-0.482 2.080-0.277 0.070-0.893 1.384-0.982 2.062-0.054 0.393 0.036 0.875-0.063 1.143-0.134 0.393-0.741-0.375-0.544-1.312 0.035-0.16 0-0.197-0.045-0.115-0.241 0.437-0.107 1.053 0.089 1.481 0.081 0.188 0.286 0.268 0.438 0.429 0.312 0.356 1.544 1.268 1.759 1.491 0.277 0.259 0.197 0.865-0.375 0.928 0.295 0.554 0.58 0.608 0.572 1.509 0.339-0.178 0.206-0.571 0.062-0.82-0.099-0.18-0.223-0.26-0.197-0.304 0.018-0.027 0.197-0.18 0.295-0.062 0.303 0.339 0.875 0.401 1.482 0.321 0.616-0.072 1.277-0.286 1.58-0.777 0.143-0.232 0.241-0.312 0.304-0.268 0.071 0.035 0.099 0.196 0.089 0.464-0.009 0.286-0.125 0.581-0.205 0.822-0.081 0.277-0.107 0.464 0.161 0.474 0.071-0.501 0.214-0.992 0.25-1.492 0.045-0.571-0.366-1.624 0.081-2.152 0.116-0.143 0.258-0.16 0.455-0.16 0.026-0.715 1.125-0.66 1.491-0.366 0-0.162-0.348-0.313-0.491-0.376zM5.063 8.367c-0.063 0.115-0.223 0.204-0.099 0.223 0.045 0.009 0.17-0.1 0.224-0.223 0.044-0.152 0.089-0.233 0.018-0.26-0.081-0.026-0.063 0.134-0.143 0.26zM7.107 3.527c-0.107-0.027-0.089 0.133-0.035 0.116 0.036 0 0.081 0.054 0.062 0.134-0.018 0.107-0.009 0.18 0.072 0.18 0.009 0 0.026 0 0.026-0.027 0.037-0.225-0.071-0.385-0.125-0.403zM7.349 4.348c-0.089 0.009-0.072-0.197 0.214-0.179-0.179 0.018-0.116 0.179-0.214 0.179zM8.081 4.196c0.259-0.115 0.348 0.063 0.259 0.099-0.090 0.026-0.099-0.144-0.259-0.099zM9.161 3.473c-0.116 0.010-0.080 0.062-0.026 0.080 0.071 0.020 0.143 0.144 0.161 0.277 0 0.018 0.089-0.018 0.089-0.045 0.008-0.213-0.179-0.32-0.224-0.312zM9.679 1.545c-0.071-0.072-0.143-0.135-0.214-0.135-0.179 0.018-0.090 0.205-0.116 0.295-0.036 0.098-0.169 0.179-0.080 0.25 0.081 0.062 0.134-0.098 0.304-0.16 0.044-0.019 0.25 0.008 0.294-0.090 0.008-0.045-0.107-0.098-0.188-0.16zM10.67 5.49c-0.169-0.106-0.205-0.285-0.267-0.223-0.188 0.205 0.232 0.634 0.41 0.671 0.107 0.018 0.188-0.126 0.161-0.251-0.036-0.169-0.161-0.107-0.304-0.197z"}}]})(props);
	};
	module.exports.TfiListOl = function TfiListOl (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 4v1h-12v-1h12zM5 9h12v-1h-12v1zM5 13h12v-1h-12v1zM2.083 3.48h0.009v2.383h0.356v-2.727h-0.314l-0.596 0.319 0.071 0.281 0.474-0.256zM1.639 9.572l0.219-0.201c0.574-0.554 0.939-0.961 0.939-1.465 0-0.39-0.248-0.793-0.836-0.793-0.314 0-0.582 0.117-0.771 0.277l0.117 0.26c0.127-0.105 0.332-0.231 0.58-0.231 0.406 0 0.541 0.256 0.541 0.533-0.004 0.411-0.32 0.764-1.016 1.427l-0.289 0.281v0.227h1.74v-0.307h-1.224v-0.008zM2.236 12.391v-0.009c0.336-0.121 0.504-0.36 0.504-0.642 0-0.331-0.243-0.65-0.78-0.65-0.294 0-0.571 0.104-0.714 0.21l0.097 0.269c0.117-0.084 0.327-0.181 0.546-0.181 0.34 0 0.478 0.193 0.478 0.411 0 0.323-0.34 0.462-0.608 0.462h-0.206v0.276h0.205c0.357 0 0.701 0.164 0.705 0.546 0.005 0.227-0.143 0.528-0.616 0.528-0.257 0-0.5-0.104-0.604-0.172l-0.101 0.285c0.134 0.089 0.402 0.186 0.709 0.186 0.654 0 0.994-0.382 0.994-0.818 0-0.382-0.273-0.634-0.609-0.701z"}}]})(props);
	};
	module.exports.TfiList = function TfiList (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 4v1h-12v-1h12zM3 4.5c0 0.827-0.673 1.5-1.5 1.5s-1.5-0.673-1.5-1.5 0.673-1.5 1.5-1.5 1.5 0.673 1.5 1.5zM2 4.5c0-0.275-0.224-0.5-0.5-0.5s-0.5 0.225-0.5 0.5 0.224 0.5 0.5 0.5 0.5-0.225 0.5-0.5zM5 9h12v-1h-12v1zM3 8.5c0 0.827-0.673 1.5-1.5 1.5s-1.5-0.673-1.5-1.5 0.673-1.5 1.5-1.5 1.5 0.673 1.5 1.5zM2 8.5c0-0.275-0.224-0.5-0.5-0.5s-0.5 0.225-0.5 0.5 0.224 0.5 0.5 0.5 0.5-0.225 0.5-0.5zM5 13h12v-1h-12v1zM3 12.5c0 0.827-0.673 1.5-1.5 1.5s-1.5-0.673-1.5-1.5 0.673-1.5 1.5-1.5 1.5 0.673 1.5 1.5zM2 12.5c0-0.275-0.224-0.5-0.5-0.5s-0.5 0.225-0.5 0.5 0.224 0.5 0.5 0.5 0.5-0.225 0.5-0.5z"}}]})(props);
	};
	module.exports.TfiLocationArrow = function TfiLocationArrow (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M1.971 1.966l5.288 14.101 1.212-7.601 7.601-1.212-14.101-5.288zM7.598 7.592l-0.731 4.582-3.187-8.499 8.499 3.187-4.581 0.73z"}}]})(props);
	};
	module.exports.TfiLocationPin = function TfiLocationPin (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0.5c-3.032 0-5.5 2.467-5.5 5.5 0 4.373 4.913 10.086 5.122 10.328l0.378 0.435 0.378-0.436c0.209-0.241 5.122-5.954 5.122-10.327 0-3.033-2.468-5.5-5.5-5.5zM8.5 15.215c-1.146-1.424-4.5-5.879-4.5-9.215 0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5c0 3.333-3.354 7.791-4.5 9.215zM8.5 3.139c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zM8.5 8.139c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2z"}}]})(props);
	};
	module.exports.TfiLock = function TfiLock (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.5 10.972c0 0.366-0.207 0.672-0.5 0.846v2.154h-1v-2.153c-0.294-0.174-0.5-0.48-0.5-0.847 0-0.552 0.447-1 1-1 0.551 0 1 0.447 1 1zM14.965 8.46v7.080c0 0.827-0.673 1.5-1.5 1.5h-9.989c-0.827 0-1.5-0.673-1.5-1.5v-7.080c0-0.827 0.673-1.5 1.5-1.5h0.024v-1.988c0-2.757 2.243-5 5-5s5 2.243 5 5v1.992c0.811 0.018 1.465 0.681 1.465 1.496zM4.5 6.96h8v-1.988c0-2.206-1.794-4-4-4s-4 1.794-4 4v1.988zM13.965 8.46c0-0.264-0.207-0.474-0.465-0.493v0.004h-10v-0.011h-0.024c-0.275 0-0.5 0.224-0.5 0.5v7.080c0 0.276 0.225 0.5 0.5 0.5h9.989c0.275 0 0.5-0.224 0.5-0.5v-7.080z"}}]})(props);
	};
	module.exports.TfiLoop = function TfiLoop (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M1 9c0 2.206 1.711 4 3.813 4v1c-2.654 0-4.813-2.243-4.813-5s2.159-5 4.813-5h4.229l-1.646-1.646 0.707-0.707 2.854 2.853-2.853 2.854-0.708-0.708 1.647-1.646h-4.23c-2.102 0-3.813 1.794-3.813 4zM12.187 4v1c2.102 0 3.813 1.794 3.813 4s-1.711 4-3.813 4h-4.23l1.646-1.646-0.707-0.707-2.853 2.853 2.854 2.854 0.707-0.707-1.647-1.647h4.229c2.655 0 4.814-2.243 4.814-5s-2.159-5-4.813-5z"}}]})(props);
	};
	module.exports.TfiMagnet = function TfiMagnet (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M11 0v10.122c0 1.329-1.122 2.409-2.5 2.409s-2.5-1.080-2.5-2.409v-10.122h-5v10.432c0 4.266 3.864 6.568 7.5 6.568s7.5-2.302 7.5-6.568v-10.432h-5zM15 1v3h-3v-3h3zM5 1v3h-3v-3h3zM8.5 16c-2.613 0-6.5-1.483-6.5-5.568v-5.432h3v5.122c0 1.88 1.57 3.409 3.5 3.409s3.5-1.529 3.5-3.409v-5.122h3v5.432c0 4.085-3.887 5.568-6.5 5.568z"}}]})(props);
	};
	module.exports.TfiMapAlt = function TfiMapAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 4v0.069l-0.013-0.058-1.015 0.221c-0.139-1.803-1.634-3.232-3.472-3.232-1.841 0-3.339 1.435-3.474 3.242l-1.026-0.223v-0.019h-6v11h5.348l5.196 1.479 5.456-1.605v-10.874h-1zM10.5 2c1.379 0 2.5 1.122 2.5 2.5 0 1.806-1.719 4.209-2.5 5.207-0.781-0.998-2.5-3.401-2.5-5.207 0-1.378 1.121-2.5 2.5-2.5zM6 5.042l1.081 0.235c0.412 2.269 2.406 4.788 2.919 5.406v4.602l-4-1.139v-9.104zM1 5h4v9.017l-4-0.017v-9zM11 15.303v-4.621c0.514-0.619 2.513-3.145 2.921-5.416l1.079-0.234v9.094l-4 1.177zM11.858 4.583c0-0.749-0.609-1.358-1.358-1.358s-1.358 0.609-1.358 1.358 0.609 1.359 1.358 1.359 1.358-0.609 1.358-1.359zM10.142 4.583c0-0.198 0.161-0.358 0.358-0.358s0.358 0.161 0.358 0.358-0.161 0.359-0.358 0.359-0.358-0.161-0.358-0.359z"}}]})(props);
	};
	module.exports.TfiMap = function TfiMap (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M10.499 4.438l-4.902-1.418-5.597-0.020v11h5.348l5.196 1.479 5.456-1.605v-11.041l-5.501 1.605zM6 4.177l4 1.157v8.95l-4-1.139v-8.968zM1 4h4v9.017l-4-0.017v-9zM15 13.126l-4 1.177v-8.969l4-1.167v8.959z"}}]})(props);
	};
	module.exports.TfiMarkerAlt = function TfiMarkerAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.664 5.684l-0.544-0.544c0.078-0.179 0.127-0.368 0.139-0.562 0.026-0.435-0.121-0.835-0.416-1.13l-1.745-1.745c-0.206-0.206-0.437-0.31-0.687-0.31-0.449 0-0.769 0.323-1.108 0.666l-9.036 9.036-0.335 2.955 0.105 0.104-0.972 0.972 1.193 0.222 0.487-0.486 0.104 0.104 2.954-0.333 8.697-8.698 0.456 0.456c0.072 0.072 0.094 0.144 0.076 0.245-0.026 0.141-0.129 0.31-0.283 0.464l-3.016 3.017 0.707 0.707 3.016-3.017c0.303-0.302 0.497-0.645 0.56-0.99 0.078-0.426-0.047-0.829-0.352-1.133zM5.343 13.677l-2.128 0.241-0.235-0.235 0.242-2.126 5.622-5.622 2.121 2.121-5.622 5.621zM11.672 7.349l-2.121-2.121 2.464-2.464c0.136-0.139 0.342-0.347 0.376-0.354l1.745 1.745c0.12 0.12 0.129 0.278 0.125 0.361-0.010 0.168-0.088 0.331-0.218 0.462l-2.371 2.371z"}}]})(props);
	};
	module.exports.TfiMarker = function TfiMarker (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M10.646 1h-0.768c-0.232-0.588-0.769-1-1.393-1h-2.467c-0.292 0-0.53 0.090-0.706 0.268-0.316 0.317-0.314 0.771-0.312 1.253v11.779l1.851 2.325h0.149v1.375l1-0.688v-0.688h0.147l1.853-2.325v-11.299h0.646c0.337 0 0.354 0.54 0.354 0.648v4.266h1v-4.266c0.001-0.97-0.556-1.648-1.354-1.648zM6.018 1h2.467c0.285 0 0.516 0.291 0.516 0.648v3.352h-3.001v-3.484c0-0.194-0.002-0.487 0.018-0.516zM7.667 14.625h-0.333l-1.333-1.675-0.001-6.95h3v6.95l-1.333 1.675z"}}]})(props);
	};
	module.exports.TfiMedallAlt = function TfiMedallAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0c-2.757 0-5 2.243-5 5 0 1.375 0.555 2.659 1.562 3.616 0.085 0.082 0.18 0.154 0.276 0.226l0.103 0.078c0.179 0.141 0.369 0.257 0.559 0.371v7.209l2.479-1.901 2.521 1.901v-7.209c0.19-0.114 0.381-0.231 0.56-0.372l0.103-0.077c0.096-0.072 0.19-0.144 0.276-0.226 1.006-0.957 1.561-2.241 1.561-3.616 0-2.757-2.243-5-5-5zM10 14.493l-1.526-1.151-1.474 1.131v-4.225c0.482 0.167 0.986 0.252 1.5 0.252s1.018-0.085 1.5-0.252v4.245zM11.249 7.892c-0.057 0.055-0.121 0.101-0.185 0.147l-0.123 0.094c-1.445 1.135-3.438 1.134-4.881 0.001l-0.124-0.095c-0.064-0.047-0.128-0.093-0.185-0.147-0.807-0.767-1.251-1.793-1.251-2.892 0-2.206 1.794-4 4-4s4 1.794 4 4c0 1.099-0.444 2.125-1.251 2.892zM10.25 5c0 0.966-0.784 1.75-1.75 1.75s-1.75-0.784-1.75-1.75 0.784-1.75 1.75-1.75 1.75 0.784 1.75 1.75z"}}]})(props);
	};
	module.exports.TfiMedall = function TfiMedall (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0c-2.757 0-5 2.243-5 5 0 1.375 0.555 2.659 1.562 3.616 0.085 0.082 0.18 0.154 0.276 0.226l0.103 0.078c0.179 0.141 0.369 0.257 0.559 0.371v7.209l2.479-1.901 2.521 1.901v-7.209c0.19-0.114 0.381-0.231 0.56-0.372l0.103-0.077c0.096-0.072 0.19-0.144 0.276-0.226 1.006-0.957 1.561-2.241 1.561-3.616 0-2.757-2.243-5-5-5zM10 14.493l-1.526-1.151-1.474 1.131v-4.225c0.482 0.167 0.986 0.252 1.5 0.252s1.018-0.085 1.5-0.252v4.245zM11.249 7.892c-0.057 0.055-0.121 0.101-0.185 0.147l-0.123 0.094c-1.445 1.135-3.438 1.134-4.881 0.001l-0.124-0.095c-0.064-0.047-0.128-0.093-0.185-0.147-0.807-0.767-1.251-1.793-1.251-2.892 0-2.206 1.794-4 4-4s4 1.794 4 4c0 1.099-0.444 2.125-1.251 2.892zM10.95 3.514l0.184 0.982-1.823 0.341 1.146 1.937-0.861 0.51-1.087-1.836-1.090 1.835-0.859-0.51 1.152-1.94-1.776-0.337 0.186-0.982 1.878 0.355v-1.869h1v1.878l1.95-0.364z"}}]})(props);
	};
	module.exports.TfiMenuAlt = function TfiMenuAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16 2v2h-11v-2h11zM5 9h11v-2h-11v2zM5 14h11v-2h-11v2zM2 2c-0.552 0-1 0.447-1 1s0.448 1 1 1 1-0.447 1-1-0.448-1-1-1zM2 7c-0.552 0-1 0.447-1 1s0.448 1 1 1 1-0.447 1-1-0.448-1-1-1zM2 12c-0.552 0-1 0.447-1 1s0.448 1 1 1 1-0.447 1-1-0.448-1-1-1z"}}]})(props);
	};
	module.exports.TfiMenu = function TfiMenu (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16 3v2h-15v-2h15zM1 10h15v-2h-15v2zM1 15h15v-2h-15v2z"}}]})(props);
	};
	module.exports.TfiMicrophoneAlt = function TfiMicrophoneAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M11.614 7.021c0.688-0.754 1.12-1.747 1.12-2.847 0-2.335-1.899-4.234-4.234-4.234s-4.234 1.899-4.234 4.234c0 1.1 0.432 2.093 1.12 2.847l1.137 7.979h1.477v1.984h1v-1.984h1.477l1.137-7.979zM6 2.147v1.853h1v-2.674c0.309-0.164 0.643-0.28 1-0.336v4.010h1v-4.010c0.357 0.056 0.691 0.172 1 0.336v2.674h1v-1.853c0.452 0.557 0.734 1.256 0.734 2.026 0 1.784-1.451 3.235-3.234 3.235s-3.234-1.45-3.234-3.234c0-0.771 0.282-1.47 0.734-2.027zM7.391 14l-0.87-6.104c0.593 0.316 1.26 0.513 1.979 0.513s1.386-0.197 1.979-0.514l-0.87 6.105h-2.218z"}}]})(props);
	};
	module.exports.TfiMicrophone = function TfiMicrophone (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 12c2.481 0 4.5-2.019 4.5-4.5v-3c0-2.311-1.756-4.197-4-4.449v-0.051h-1v0.051c-2.244 0.252-4 2.138-4 4.449v3c0 2.481 2.019 4.5 4.5 4.5zM6 2.059v1.941h1v-2.648c0.312-0.149 0.646-0.25 1-0.301v2.949h1v-2.949c0.354 0.051 0.688 0.151 1 0.301v2.648h1v-1.941c0.617 0.631 1 1.491 1 2.441v0.5h-7v-0.5c0-0.95 0.383-1.811 1-2.441zM5 6h7v1.5c0 1.93-1.57 3.5-3.5 3.5s-3.5-1.57-3.5-3.5v-1.5zM15 7v3.25c0 2.067-2.019 3.75-4.5 3.75h-1.5v3h-1v-3h-1.5c-2.481 0-4.5-1.683-4.5-3.75v-3.25h1v3.25c0 1.517 1.57 2.75 3.5 2.75h4c1.93 0 3.5-1.233 3.5-2.75v-3.25h1z"}}]})(props);
	};
	module.exports.TfiMicrosoftAlt = function TfiMicrosoftAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 2.339l6.967-0.959v6.732h-6.967v-5.773zM0 14.661l6.967 0.959v-6.65h-6.967v5.691zM7.734 1.277v6.835h9.266v-8.112l-9.266 1.277zM7.734 15.723l9.266 1.277v-8.030h-9.266v6.753z"}}]})(props);
	};
	module.exports.TfiMicrosoft = function TfiMicrosoft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M7.734 15.723l9.266 1.277v-8.030h-9.266v6.753zM8.734 9.97h7.266v5.883l-7.266-1.002v-4.881zM0 14.661l6.967 0.959v-6.65h-6.967v5.691zM1 9.97h4.967v4.503l-4.967-0.684v-3.819zM0 8.112h6.967v-6.732l-6.967 0.959v5.773zM1 3.21l4.967-0.684v4.585h-4.967v-3.901zM7.734 1.277v6.835h9.266v-8.112l-9.266 1.277zM16 7.112h-7.266v-4.963l7.266-1.002v5.965z"}}]})(props);
	};
	module.exports.TfiMinus = function TfiMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 8v1h-13v-1h13z"}}]})(props);
	};
	module.exports.TfiMobile = function TfiMobile (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.5 0h-8c-0.827 0-1.5 0.673-1.5 1.5v14c0 0.827 0.673 1.5 1.5 1.5h8c0.827 0 1.5-0.673 1.5-1.5v-14c0-0.827-0.673-1.5-1.5-1.5zM4.5 1h8c0.276 0 0.5 0.224 0.5 0.5v1.5h-9v-1.5c0-0.276 0.224-0.5 0.5-0.5zM13 4v8h-9v-8h9zM12.5 16h-8c-0.276 0-0.5-0.224-0.5-0.5v-2.5h9v2.5c0 0.276-0.224 0.5-0.5 0.5zM9 14.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z"}}]})(props);
	};
	module.exports.TfiMoney = function TfiMoney (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M10.719 9.577v0l-0.010-0.010c-0.013-0.011-0.022-0.024-0.036-0.034l-0.003 0.004-1.67-1.282v-5.707c1.14 0.218 2 1.164 2 2.296l0.499 0.060 0.501-0.060c0-1.68-1.309-3.062-3-3.296v-1.548h-1v1.548c-1.691 0.234-3 1.616-3 3.296 0 0.942 0.421 1.838 1.151 2.473l-0.005 0.005 0.040 0.031c0 0 0 0 0 0v0l1.814 1.394v5.705c-1.14-0.218-2-1.164-2-2.296h-1c0 1.68 1.309 3.062 3 3.296v1.549h1v-1.549c1.691-0.234 3-1.616 3-3.296 0-1.006-0.469-1.939-1.281-2.579zM6.822 6.581c-0.522-0.446-0.822-1.077-0.822-1.737 0-1.132 0.86-2.078 2-2.296v4.938l-1.178-0.905zM9 14.452v-4.936l1.104 0.849c0.567 0.447 0.896 1.096 0.896 1.791 0 1.132-0.86 2.078-2 2.296z"}}]})(props);
	};
	module.exports.TfiMoreAlt = function TfiMoreAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M4 8c0 1.104-0.896 2-2 2s-2-0.896-2-2 0.896-2 2-2 2 0.896 2 2zM8.5 6c-1.104 0-2 0.896-2 2s0.896 2 2 2 2-0.896 2-2-0.896-2-2-2zM15 6c-1.104 0-2 0.896-2 2s0.896 2 2 2 2-0.896 2-2-0.896-2-2-2z"}}]})(props);
	};
	module.exports.TfiMore = function TfiMore (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2 6c-1.104 0-2 0.896-2 2s0.896 2 2 2 2-0.896 2-2-0.896-2-2-2zM2 9c-0.551 0-1-0.448-1-1s0.449-1 1-1 1 0.448 1 1-0.449 1-1 1zM8.5 6c-1.104 0-2 0.896-2 2s0.896 2 2 2 2-0.896 2-2-0.896-2-2-2zM8.5 9c-0.551 0-1-0.448-1-1s0.449-1 1-1 1 0.448 1 1-0.449 1-1 1zM15 6c-1.104 0-2 0.896-2 2s0.896 2 2 2 2-0.896 2-2-0.896-2-2-2zM15 9c-0.551 0-1-0.448-1-1s0.449-1 1-1 1 0.448 1 1-0.449 1-1 1z"}}]})(props);
	};
	module.exports.TfiMouseAlt = function TfiMouseAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0c-3.033 0-5.5 2.467-5.5 5.5v6c0 3.033 2.467 5.5 5.5 5.5s5.5-2.467 5.5-5.5v-6c0-3.033-2.467-5.5-5.5-5.5zM13 5.5v0.5h-4v-4.949c2.244 0.252 4 2.139 4 4.449zM8 1.051v4.949h-4v-0.5c0-2.31 1.756-4.197 4-4.449zM8.5 16c-2.481 0-4.5-2.019-4.5-4.5v-4.5h9v4.5c0 2.481-2.019 4.5-4.5 4.5z"}}]})(props);
	};
	module.exports.TfiMouse = function TfiMouse (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0c-3.033 0-5.5 2.467-5.5 5.5v6c0 3.033 2.467 5.5 5.5 5.5s5.5-2.467 5.5-5.5v-6c0-3.033-2.467-5.5-5.5-5.5zM13 11.5c0 2.481-2.019 4.5-4.5 4.5s-4.5-2.019-4.5-4.5v-6c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5v6zM8.5 3.5c-0.827 0-1.5 0.673-1.5 1.5v2c0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5v-2c0-0.827-0.673-1.5-1.5-1.5zM9 7c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2z"}}]})(props);
	};
	module.exports.TfiMusicAlt = function TfiMusicAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M6 0.265v9.222c-0.512-0.446-1.173-0.726-1.904-0.726-1.607 0-2.914 1.308-2.914 2.914s1.307 2.914 2.914 2.914c1.57 0 2.845-1.251 2.903-2.807v0-0.006c0.001-0.034 0.010-0.066 0.010-0.102s-0.008-0.067-0.009-0.101v-6.094l9 1.761v4.666c-0.513-0.451-1.178-0.734-1.914-0.734-1.607 0-2.914 1.308-2.914 2.914s1.307 2.914 2.914 2.914c1.585 0 2.872-1.273 2.907-2.849l0.007 0.002v-11.736l-11-2.152zM4.096 13.589c-1.056 0-1.914-0.858-1.914-1.914s0.858-1.914 1.914-1.914c1.021 0 1.85 0.805 1.904 1.812v0.203c-0.054 1.008-0.883 1.813-1.904 1.813zM7 4.461v-2.982l9 1.762v2.98l-9-1.76zM14.086 16c-1.056 0-1.914-0.858-1.914-1.914s0.858-1.914 1.914-1.914 1.914 0.858 1.914 1.914-0.858 1.914-1.914 1.914z"}}]})(props);
	};
	module.exports.TfiMusic = function TfiMusic (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.765 4.459l0.421-0.906-7.186-3.336v9.878c-0.511-0.444-1.17-0.722-1.898-0.722-1.607 0-2.914 1.308-2.914 2.914s1.307 2.914 2.914 2.914 2.914-1.308 2.914-2.914c0-0.053-0.013-0.103-0.016-0.154v-10.35l5.765 2.676zM6.102 14.201c-1.056 0-1.914-0.858-1.914-1.914s0.858-1.914 1.914-1.914 1.914 0.858 1.914 1.914-0.859 1.914-1.914 1.914z"}}]})(props);
	};
	module.exports.TfiNa = function TfiNa (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0.5c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zM8.5 1.5c1.75 0 3.348 0.65 4.577 1.716l-9.86 9.861c-1.067-1.228-1.717-2.827-1.717-4.577 0-3.859 3.14-7 7-7zM8.5 15.5c-1.75 0-3.348-0.65-4.577-1.716l9.86-9.861c1.067 1.228 1.717 2.827 1.717 4.577 0 3.859-3.14 7-7 7z"}}]})(props);
	};
	module.exports.TfiNewWindow = function TfiNewWindow (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 2v7.5h-1v-5.668l-9.334 9.334-0.707-0.707 9.459-9.459h-5.918v-1h7.5zM11 16h-10v-10h6.574v-1h-7.574v12h12v-7.714h-1v6.714z"}}]})(props);
	};
	module.exports.TfiNotepad = function TfiNotepad (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M1 0v17h15v-17h-15zM15 16h-13v-15h2v1.092c-0.581 0.207-1 0.757-1 1.408 0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5c0-0.651-0.419-1.201-1-1.408v-1.092h3v1.092c-0.581 0.207-1 0.757-1 1.408 0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5c0-0.651-0.419-1.201-1-1.408v-1.092h3v1.092c-0.581 0.207-1 0.757-1 1.408 0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5c0-0.651-0.419-1.201-1-1.408v-1.092h2v15zM5 3.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5zM9 3.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5zM13 3.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5z"}}]})(props);
	};
	module.exports.TfiPackage = function TfiPackage (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.517-0.035l-8.517 3.221v10.693l8.5 3.188 8.5-3.188v-10.692l-8.483-3.222zM15.084 3.528l-2.586 0.97-6.557-2.489 2.575-0.974 6.568 2.493zM8.5 5.997l-6.581-2.468 2.609-0.986 6.551 2.487-2.579 0.967zM1 4.253l7 2.625v8.932l-7-2.625v-8.932zM9 15.81v-8.932l7-2.625v8.932l-7 2.625z"}}]})(props);
	};
	module.exports.TfiPaintBucket = function TfiPaintBucket (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.701 9.818l-8.868-8.924-0.134 0.133c-0.668-0.661-1.552-1.026-2.493-1.027 0 0 0 0-0.001 0-0.948 0-1.841 0.37-2.512 1.041-0.672 0.671-1.042 1.563-1.042 2.514 0 0.941 0.366 1.825 1.027 2.493l-2.208 2.209c-0.303 0.304-0.47 0.706-0.47 1.133 0 0.429 0.166 0.83 0.467 1.13l4.811 4.859c0.302 0.302 0.704 0.469 1.131 0.469 0.429 0 0.831-0.168 1.133-0.471l5.558-5.558 3.601-0.001zM2.651 3.554c0-0.682 0.266-1.323 0.749-1.806 0.483-0.482 1.123-0.748 1.805-0.748 0.001 0 0.001 0 0.001 0 0.674 0 1.306 0.262 1.786 0.734l-3.606 3.607c-0.473-0.481-0.735-1.113-0.735-1.787zM6.833 14.671c-0.113 0.113-0.265 0.177-0.425 0.177s-0.311-0.062-0.422-0.174l-3.636-3.674h8.154l-3.671 3.671zM11.504 10h-10.145l-0.183-0.186c-0.114-0.113-0.176-0.263-0.176-0.423 0-0.161 0.063-0.312 0.177-0.427l6.654-6.654 6.468 6.509-1.614 0.001-1.181 1.18zM15.688 11.959l-0.407-0.604-0.418 0.598c-0.319 0.457-1.363 2.011-1.363 2.798 0 0.965 0.785 1.75 1.75 1.75s1.75-0.786 1.75-1.751c0-0.782-1.004-2.334-1.312-2.791zM15.25 15.5c-0.413 0-0.75-0.337-0.75-0.75 0-0.24 0.349-0.92 0.766-1.591 0.4 0.67 0.734 1.349 0.734 1.591 0 0.413-0.337 0.75-0.75 0.75z"}}]})(props);
	};
	module.exports.TfiPaintRoller = function TfiPaintRoller (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 2v-2h-13v2h-0.516c-0.818 0-1.484 0.675-1.484 1.505v2.99c0 0.83 0.666 1.505 1.484 1.505h6.024c0.275 0 0.5 0.225 0.5 0.5v1.5h-1.008v7h3v-7h-0.992v-1.5c0-0.827-0.673-1.5-1.5-1.5h-6.024c-0.266 0-0.484-0.227-0.484-0.505v-2.99c0-0.278 0.218-0.505 0.484-0.505h0.516v3h13v-3h1v-1h-1zM9 16h-1v-5h1v5zM14 5h-11v-4h11v4z"}}]})(props);
	};
	module.exports.TfiPalette = function TfiPalette (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0.5c-4.411 0-8 3.589-8 8 0 4.281 3.352 7.787 7.631 7.982l1.288 0.059-2.723-2.723c-0.283-0.283-0.439-0.66-0.439-1.061s0.156-0.777 0.439-1.061c0.566-0.566 1.555-0.566 2.121 0l3.719 3.719 0.34-0.223c2.27-1.486 3.624-3.988 3.624-6.692 0-4.411-3.589-8-8-8zM12.66 14.125l-3.135-3.135c-0.943-0.944-2.592-0.944-3.535 0-0.472 0.472-0.732 1.1-0.732 1.768s0.26 1.296 0.732 1.768l0.741 0.741c-3.026-0.783-5.231-3.52-5.231-6.767 0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.23-1.054 4.305-2.84 5.625zM11.5 6.5c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM11.5 9.5c-0.551 0-1-0.449-1-1s0.449-1 1-1 1 0.449 1 1-0.449 1-1 1zM8.5 6c-0.828 0-1.5-0.671-1.5-1.5s0.672-1.5 1.5-1.5c0.829 0 1.5 0.671 1.5 1.5s-0.671 1.5-1.5 1.5zM5.75 5.891c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1 1 0.447 1 1z"}}]})(props);
	};
	module.exports.TfiPanel = function TfiPanel (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0v17h17v-17h-17zM16 16h-15v-15h15v15zM4 10.232v2.768h1v-2.768c0.738-0.218 1.281-0.894 1.281-1.701s-0.543-1.483-1.281-1.701v-2.83h-1v2.83c-0.738 0.218-1.281 0.894-1.281 1.701s0.543 1.484 1.281 1.701zM4.5 7.75c0.431 0 0.781 0.351 0.781 0.781s-0.35 0.781-0.781 0.781-0.781-0.35-0.781-0.781 0.35-0.781 0.781-0.781zM8 8.107v4.893h1v-4.893c0.738-0.218 1.281-0.894 1.281-1.701s-0.543-1.483-1.281-1.701v-0.705h-1v0.705c-0.738 0.218-1.281 0.894-1.281 1.701s0.543 1.484 1.281 1.701zM8.5 5.625c0.431 0 0.781 0.351 0.781 0.781s-0.35 0.782-0.781 0.782-0.781-0.351-0.781-0.782 0.35-0.781 0.781-0.781zM12.5 13.417c0.982 0 1.781-0.799 1.781-1.781 0-0.808-0.543-1.483-1.281-1.701v-5.935h-1v5.935c-0.738 0.218-1.281 0.894-1.281 1.701 0 0.982 0.799 1.781 1.781 1.781zM12.5 10.854c0.431 0 0.781 0.351 0.781 0.781s-0.351 0.781-0.781 0.781-0.781-0.351-0.781-0.781 0.35-0.781 0.781-0.781z"}}]})(props);
	};
	module.exports.TfiParagraph = function TfiParagraph (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16 1.026h-11.008c-2.181 0-3.955 1.774-3.955 3.955s1.774 3.954 3.955 3.954h3.008v7.065h1v-13.974h2.015v13.974h1v-13.974h3.985v-1zM8 7.936h-3.008c-1.63 0-2.955-1.325-2.955-2.954 0-1.63 1.325-2.955 2.955-2.955h3.008v5.909z"}}]})(props);
	};
	module.exports.TfiPencilAlt = function TfiPencilAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.499 1.843l-1.403-1.403c-0.566-0.566-1.555-0.566-2.122 0l-7.536 7.536-1.722 5.287 5.249-1.765 7.534-7.534c0.283-0.283 0.439-0.66 0.439-1.061s-0.156-0.777-0.439-1.060zM5.584 10.758l0.638-1.957 1.92 1.919-1.942 0.653-0.616-0.615zM6.832 7.996l3.986-3.986 2.11 2.11-3.986 3.986-2.11-2.11zM11.525 3.303l0.729-0.729 2.11 2.11-0.729 0.729-2.11-2.11zM15.792 3.257l-0.72 0.721-2.11-2.11 0.72-0.721c0.19-0.189 0.519-0.189 0.707 0l1.403 1.403c0.094 0.095 0.146 0.22 0.146 0.354s-0.052 0.258-0.146 0.353zM15 7.5h1v9.5h-16v-15h7.5v1h-6.5v13h14v-8.5z"}}]})(props);
	};
	module.exports.TfiPencilAlt2 = function TfiPencilAlt2 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.492 0h-1.984c-0.827 0-1.5 0.673-1.5 1.5v10.657l2.521 4.956 2.464-4.959v-10.654c-0.001-0.827-0.674-1.5-1.501-1.5zM7.508 1h1.984c0.275 0 0.5 0.225 0.5 0.5v1.019h-2.984v-1.019c0-0.275 0.224-0.5 0.5-0.5zM8.078 14.021l-0.934-1.835h2.715l-0.911 1.835h-0.87zM7.008 11.187v-5.637h2.984v5.637h-2.984zM7.008 4.55v-1.031h2.984v1.031h-2.984z"}}]})(props);
	};
	module.exports.TfiPencil = function TfiPencil (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.529 2.857l-1.403-1.404c-0.565-0.566-1.555-0.566-2.122 0l-9.057 9.058-1.722 5.288 5.248-1.765 9.055-9.056c0.586-0.584 0.586-1.536 0.001-2.121zM3.094 13.294l0.645-1.979 1.934 1.935-1.963 0.66-0.616-0.616zM4.355 10.518l5.493-5.493 2.111 2.11-5.494 5.494-2.11-2.111zM10.555 4.317l0.729-0.729 2.111 2.11-0.729 0.729-2.111-2.11zM14.822 4.271l-0.72 0.72-2.111-2.11 0.72-0.721c0.189-0.189 0.518-0.189 0.707 0l1.403 1.404c0.196 0.196 0.196 0.512 0.001 0.707z"}}]})(props);
	};
	module.exports.TfiPieChart = function TfiPieChart (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.985 8.943l0.998 0.067c-0.263 3.92-3.55 6.99-7.483 6.99-4.136 0-7.5-3.364-7.5-7.5 0-3.905 3.047-7.19 6.938-7.479l0.074 0.997c-3.371 0.25-6.012 3.097-6.012 6.482 0 3.584 2.916 6.5 6.5 6.5 3.409 0 6.257-2.66 6.485-6.057zM17 7.499v0.5l-0.501 0.017h-7.482v-8.017l0.501 0.001c4.126 0.009 7.482 3.374 7.482 7.499zM15.986 7.016c-0.223-3.17-2.776-5.743-5.969-5.995v5.995h5.969z"}}]})(props);
	};
	module.exports.TfiPinAlt = function TfiPinAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M5.404 10.889l0.707 0.707-5.258 5.257-0.707-0.707 5.258-5.257zM17 6.222l-2.192 0.637-3.682 5.246 0.429 1.118-1.555 1.555-7.778-7.778 1.556-1.556 1.118 0.429 5.245-3.682 0.248-0.854 0.388-1.337 6.223 6.222zM15.098 5.734l-3.832-3.831-0.164 0.567-0.098 0.338-5.97 4.19-1.009-0.387-0.389 0.389 6.364 6.364 0.389-0.39-0.195-0.512-0.191-0.497 0.307-0.436 3.883-5.534 0.338-0.098 0.567-0.163z"}}]})(props);
	};
	module.exports.TfiPin = function TfiPin (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12 4.5c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5c0 1.745 1.288 3.185 2.962 3.445v8.055h1v-8.047c1.71-0.228 3.038-1.682 3.038-3.453zM8.5 7c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5zM10 5h-1c0-0.552-0.448-1-1-1v-1c1.103 0 2 0.897 2 2z"}}]})(props);
	};
	module.exports.TfiPin2 = function TfiPin2 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8 11.5h1v5.5h-1v-5.5zM14 8.8v2.2h-11v-2.2l1.094-0.487 1.106-6.313-0.429-0.779-0.671-1.221h8.8l-0.672 1.221-0.428 0.779 1.106 6.312 1.094 0.488zM13 9.449l-0.986-0.44-0.092-0.524-1.168-6.659 0.17-0.309 0.285-0.517h-5.418l0.455 0.827-0.060 0.346-1.2 6.836-0.986 0.44v0.551h9v-0.551z"}}]})(props);
	};
	module.exports.TfiPinterestAlt = function TfiPinterestAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 0.5c-4.418 0-8 3.581-8 8 0 3.275 1.97 6.090 4.789 7.327-0.022-0.559-0.005-1.229 0.139-1.837 0.153-0.649 1.029-4.359 1.029-4.359s-0.256-0.511-0.256-1.266c0-1.186 0.688-2.070 1.544-2.070 0.728 0 1.079 0.546 1.079 1.2 0 0.731-0.467 1.826-0.707 2.839-0.2 0.849 0.426 1.541 1.263 1.541 1.516 0 2.537-1.946 2.537-4.253 0-1.753-1.182-3.066-3.329-3.066-2.427 0-3.938 1.811-3.938 3.831 0 0.698 0.205 1.189 0.527 1.569 0.147 0.175 0.168 0.246 0.115 0.446-0.038 0.147-0.127 0.502-0.163 0.642-0.054 0.203-0.218 0.275-0.4 0.201-1.119-0.457-1.639-1.681-1.639-3.057 0-2.272 1.916-4.998 5.718-4.998 3.054 0 5.064 2.211 5.064 4.583 0 3.139-1.745 5.483-4.316 5.483-0.864 0-1.677-0.468-1.955-0.998 0 0-0.464 1.844-0.562 2.199-0.17 0.617-0.502 1.233-0.806 1.714 0.719 0.214 1.479 0.329 2.267 0.329 4.418 0 8-3.581 8-8s-3.582-8-8-8z"}}]})(props);
	};
	module.exports.TfiPinterest = function TfiPinterest (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.025 6.225c0 3.819-2.123 6.662-5.246 6.662-1.049 0-2.035-0.568-2.365-1.213-0.568 2.238-0.682 2.667-0.682 2.667-0.203 0.746-0.619 1.493-0.985 2.074-1.043 0.737-1.14-0.404-1.14-0.404-0.024-0.684-0.012-1.505 0.166-2.237 0 0 0.189-0.785 1.25-5.285-0.315-0.62-0.315-1.543-0.315-1.543 0-1.441 0.835-2.516 1.872-2.516 0.885 0 1.314 0.67 1.314 1.467 0 0.885-0.57 2.213-0.859 3.439-0.24 1.037 0.518 1.871 1.529 1.871 1.847 0 3.084-2.363 3.084-5.158 0-2.137-1.44-3.729-4.045-3.729-2.945 0-4.778 2.2-4.778 4.652 0 0.848 0.252 1.442 0.644 1.91 0.178 0.215 0.203 0.29 0.139 0.543-0.049 0.177-0.15 0.607-0.201 0.771-0.063 0.253-0.266 0.341-0.48 0.253-1.353-0.558-1.986-2.049-1.986-3.718 0-2.756 2.325-6.068 6.928-6.068 3.717 0 6.156 2.692 6.156 5.562z"}}]})(props);
	};
	module.exports.TfiPlug = function TfiPlug (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M3 4v5.014c0 2.749 2.468 4.986 5.5 4.986s5.5-2.237 5.5-4.986v-5.014h-11zM13 9.014c0 2.198-2.019 3.986-4.5 3.986s-4.5-1.788-4.5-3.986v-4.014h9v4.014zM7.016 3h-1v-3h1v3zM10.984 3h-1v-3h1v3zM8 14h1v3h-1v-3zM11 8h-5v-1h5v1zM11 10h-5v-1h5v1z"}}]})(props);
	};
	module.exports.TfiPlus = function TfiPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16 9h-7v7h-1v-7h-7v-1h7v-7h1v7h7v1z"}}]})(props);
	};
	module.exports.TfiPowerOff = function TfiPowerOff (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16 9.5c0 4.136-3.364 7.5-7.5 7.5s-7.5-3.364-7.5-7.5c0-3.498 2.476-6.579 5.888-7.326l0.214 0.977c-2.956 0.647-5.102 3.317-5.102 6.349 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-3.028-2.143-5.698-5.096-6.348l0.215-0.977c3.408 0.751 5.881 3.831 5.881 7.325zM9 0h-1v10h1v-10z"}}]})(props);
	};
	module.exports.TfiPrinter = function TfiPrinter (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 6h-3.008v-1.818l-4.503-4.182h-6.497v6h-2.992v8h3v3.1h11v-3.1h3v-8zM9.992 1.832l2.335 2.168h-2.335v-2.168zM3.992 1h5v4h4v1h-9v-5zM13 16.1h-9v-5h9v5zM16 13h-2v-2.9h-11v2.9h-2v-6h15v6zM11.006 13h-6.006v-1h6.006v1zM9 15h-4v-1h4v1zM3 9h-1v-1h1v1zM5 9h-1v-1h1v1z"}}]})(props);
	};
	module.exports.TfiPulse = function TfiPulse (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.33 8l-1.876-4.377-3.438 9.783-4.015-13.11-2.37 7.704h-2.631v1h3.369l1.63-5.296 3.95 12.903 3.597-10.23 1.124 2.623h3.33v-1z"}}]})(props);
	};
	module.exports.TfiQuoteLeft = function TfiQuoteLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13.169 7.614c-0.734 0-1.417 0.227-1.982 0.612 1.23-3.472 3.991-3.88 4.134-3.898l-0.123-0.992c-0.051 0.006-5.126 0.704-5.563 7.725l0.015 0.001c0 0.027-0.008 0.054-0.008 0.081 0 1.945 1.583 3.528 3.528 3.528s3.528-1.583 3.528-3.528-1.584-3.529-3.529-3.529zM13.169 13.671c-1.395 0-2.528-1.134-2.528-2.528s1.134-2.528 2.528-2.528 2.528 1.134 2.528 2.528-1.134 2.528-2.528 2.528zM3.733 7.614c-0.734 0-1.416 0.227-1.981 0.612 1.23-3.472 3.99-3.88 4.133-3.898l-0.123-0.992c-0.051 0.006-5.125 0.704-5.564 7.725l0.015 0.001c0 0.027-0.008 0.054-0.008 0.081 0 1.945 1.583 3.528 3.528 3.528s3.528-1.583 3.528-3.528-1.582-3.529-3.528-3.529zM3.733 13.671c-1.395 0-2.528-1.134-2.528-2.528s1.134-2.528 2.528-2.528 2.528 1.134 2.528 2.528-1.133 2.528-2.528 2.528z"}}]})(props);
	};
	module.exports.TfiQuoteRight = function TfiQuoteRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M7.307 6.862c0-1.946-1.583-3.529-3.529-3.529-1.945 0-3.528 1.583-3.528 3.529 0 1.945 1.583 3.528 3.528 3.528 0.734 0 1.416-0.227 1.981-0.611-1.231 3.47-3.99 3.877-4.133 3.896l0.123 0.992c0.051-0.006 5.125-0.703 5.563-7.724l-0.013-0.001c0.001-0.027 0.008-0.052 0.008-0.080zM3.778 9.391c-1.394 0-2.528-1.134-2.528-2.528s1.134-2.529 2.528-2.529c1.395 0 2.529 1.135 2.529 2.529s-1.134 2.528-2.529 2.528zM16.734 6.942c0.001-0.027 0.008-0.053 0.008-0.080 0-1.946-1.583-3.529-3.528-3.529s-3.528 1.583-3.528 3.529c0 1.945 1.583 3.528 3.528 3.528 0.734 0 1.416-0.227 1.981-0.611-1.23 3.47-3.99 3.877-4.133 3.896l0.123 0.992c0.051-0.006 5.125-0.703 5.563-7.724l-0.014-0.001zM13.214 9.391c-1.394 0-2.528-1.134-2.528-2.528s1.134-2.529 2.528-2.529 2.528 1.135 2.528 2.529-1.134 2.528-2.528 2.528z"}}]})(props);
	};
	module.exports.TfiReceipt = function TfiReceipt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2 0v16.902l2.028-2.481 1.503 1.88 1.501-1.875 1.499 1.875 1.5-1.875 1.5 1.875 1.499-1.875 1.97 2.46v-16.886h-13zM14 14.036l-0.97-1.211-1.499 1.875-1.5-1.875-1.5 1.875-1.499-1.875-1.501 1.875-1.495-1.87-1.036 1.268v-13.098h11v13.036zM10.997 4h-6v-1h6v1zM8.997 8h-4v-1h4v1zM11.978 6h-7v-1h7v1zM5 10h7v1h-7v-1z"}}]})(props);
	};
	module.exports.TfiReddit = function TfiReddit (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.581 9.936c0.024 0.161 0.040 0.33 0.040 0.491 0 1.308-0.766 2.517-2.145 3.42-1.347 0.879-3.121 1.363-5.008 1.363s-3.669-0.484-5.008-1.363c-1.388-0.903-2.145-2.112-2.145-3.42 0-0.177 0.016-0.354 0.040-0.532-0.508-0.322-0.855-0.895-0.855-1.541 0-1.007 0.815-1.822 1.822-1.822 0.452 0 0.872 0.17 1.194 0.444 1.291-0.823 2.976-1.291 4.774-1.324l1.081-3.41c0.048-0.153 0.21-0.242 0.371-0.21l2.799 0.661c0.233-0.532 0.766-0.903 1.379-0.903 0.831 0 1.5 0.678 1.5 1.501 0 0.83-0.669 1.508-1.5 1.508-0.823 0-1.492-0.67-1.5-1.492l-2.541-0.597-0.935 2.951c1.701 0.072 3.29 0.541 4.516 1.339 0.322-0.29 0.75-0.468 1.218-0.468 1.007 0 1.822 0.815 1.822 1.822 0 0.678-0.371 1.267-0.919 1.582zM1.532 9.25c0.258-0.693 0.75-1.339 1.451-1.896-0.184-0.128-0.419-0.201-0.661-0.201-0.661 0-1.201 0.54-1.201 1.201 0 0.356 0.161 0.678 0.411 0.896zM15 10.427c0-1.080-0.662-2.112-1.863-2.896-1.242-0.806-2.903-1.257-4.669-1.257s-3.428 0.452-4.67 1.257c-1.202 0.783-1.863 1.815-1.863 2.896 0 1.089 0.661 2.121 1.863 2.904 1.242 0.806 2.903 1.258 4.669 1.258s3.428-0.452 4.669-1.258c1.202-0.783 1.864-1.815 1.864-2.904zM6.097 10.661c-0.605 0-1.121-0.492-1.121-1.097 0-0.612 0.516-1.121 1.121-1.121s1.105 0.509 1.105 1.121c0 0.605-0.5 1.097-1.105 1.097zM11.081 12.267c0.121 0.12 0.121 0.322 0 0.443-0.54 0.54-1.379 0.798-2.573 0.798h-0.016c-1.194 0-2.033-0.258-2.573-0.798-0.121-0.121-0.121-0.323 0-0.443 0.121-0.122 0.314-0.122 0.436 0 0.419 0.419 1.113 0.62 2.137 0.62h0.016c1.017 0 1.718-0.201 2.137-0.62 0.121-0.122 0.314-0.122 0.436 0zM12.024 9.564c0 0.604-0.5 1.097-1.105 1.097s-1.121-0.492-1.121-1.097c0-0.612 0.516-1.121 1.121-1.121s1.105 0.509 1.105 1.121zM13.040 3.291c0 0.482 0.395 0.878 0.879 0.878s0.879-0.396 0.879-0.878c0-0.484-0.396-0.88-0.879-0.88-0.484 0-0.879 0.396-0.879 0.88zM15.879 8.354c0-0.661-0.54-1.201-1.201-1.201-0.258 0-0.5 0.081-0.694 0.226 0.694 0.557 1.185 1.21 1.436 1.92 0.282-0.227 0.459-0.566 0.459-0.945z"}}]})(props);
	};
	module.exports.TfiReload = function TfiReload (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M6 8h-6v-6h1v4.109c1.013-3.193 4.036-5.484 7.5-5.484 3.506 0 6.621 2.36 7.574 5.739l-0.963 0.271c-0.832-2.95-3.551-5.011-6.611-5.011-3.226 0.001-6.016 2.276-6.708 5.376h4.208v1zM11 9v1h4.208c-0.693 3.101-3.479 5.375-6.708 5.375-3.062 0-5.78-2.061-6.611-5.011l-0.963 0.271c0.952 3.379 4.067 5.739 7.574 5.739 3.459 0 6.475-2.28 7.5-5.482v4.108h1v-6h-6z"}}]})(props);
	};
	module.exports.TfiRocket = function TfiRocket (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12 11c0-1 0-5 0-6 0-5-3-5-3-5s-3 0-3 5 0 2 0 6c0 0-2 0-2 6 0 0 2.379-2.375 4.312-2.895 0.004 0.582 0.31 1.051 0.688 1.051s0.684-0.47 0.688-1.051c1.933 0.52 4.312 2.895 4.312 2.895 0-6-2-6-2-6zM9 1.001c0.26 0.021 1.667 0.27 1.947 2.999h-3.894c0.28-2.729 1.687-2.978 1.947-2.999zM9 13c-1.271 0-2.742 0.868-3.877 1.717 0.263-2.121 0.859-2.629 0.993-2.717h0.884v-7h4v7h0.884c0.134 0.088 0.73 0.596 0.993 2.717-1.135-0.849-2.606-1.717-3.877-1.717z"}}]})(props);
	};
	module.exports.TfiRssAlt = function TfiRssAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M11.173 17h-1c0-5.514-4.564-10-10.173-10v-1c6.161 0 11.173 4.935 11.173 11zM0 0v1c8.972 0 16 7.028 16 16h1c0-9.532-7.468-17-17-17zM4 15.001c0-1.104-0.896-2.001-1.996-2.001-1.105 0-2.004 0.897-2.004 2.001 0 1.103 0.899 1.999 2.004 1.999 1.1 0 1.996-0.896 1.996-1.999zM3 15.001c0 0.551-0.447 0.999-0.996 0.999-0.554 0-1.004-0.448-1.004-0.999 0-0.552 0.45-1.001 1.004-1.001 0.549 0 0.996 0.449 0.996 1.001z"}}]})(props);
	};
	module.exports.TfiRss = function TfiRss (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.969 14h-1c0-3.233-2.678-5.863-5.969-5.863v-1c3.843 0 6.969 3.079 6.969 6.863zM3 3.5v1c5.327 0 9.5 4.173 9.5 9.5h1c0-5.888-4.612-10.5-10.5-10.5zM6 12.501c0-0.827-0.671-1.501-1.497-1.501-0.829 0-1.503 0.674-1.503 1.501s0.674 1.5 1.503 1.5c0.826 0 1.497-0.673 1.497-1.5zM5 12.501c0 0.275-0.223 0.5-0.497 0.5-0.277 0-0.503-0.225-0.503-0.5 0-0.276 0.226-0.501 0.503-0.501 0.274 0 0.497 0.225 0.497 0.501zM17 15.5v-14c0-0.827-0.673-1.5-1.5-1.5h-14c-0.827 0-1.5 0.673-1.5 1.5v14c0 0.827 0.673 1.5 1.5 1.5h14c0.827 0 1.5-0.673 1.5-1.5zM15.5 1c0.276 0 0.5 0.225 0.5 0.5v14c0 0.275-0.224 0.5-0.5 0.5h-14c-0.276 0-0.5-0.225-0.5-0.5v-14c0-0.275 0.224-0.5 0.5-0.5h14z"}}]})(props);
	};
	module.exports.TfiRulerAlt2 = function TfiRulerAlt2 (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0.293v16.707h16.707l-16.707-16.707zM1 2.707l2.957 2.957-0.655 0.655 0.707 0.707 0.655-0.655 0.709 0.709-0.655 0.656 0.707 0.707 0.655-0.655 0.71 0.709-0.655 0.655 0.707 0.707 0.655-0.655 0.71 0.71-0.655 0.655 0.707 0.707 0.655-0.655 0.709 0.709-0.655 0.655 0.707 0.707 0.655-0.655 0.71 0.71-0.655 0.655 0.707 0.707 0.655-0.655 2.546 2.546h-13.293v-13.293zM2 15h7.707l-7.707-7.707v7.707zM3 9.707l4.293 4.293h-4.293v-4.293z"}}]})(props);
	};
	module.exports.TfiRulerAlt = function TfiRulerAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.036 0.015l-12.021 12.021 4.95 4.949 12.020-12.020-4.949-4.95zM1.429 12.036l0.696-0.696 1.414 1.414 0.707-0.707-1.414-1.414 0.719-0.719 0.707 0.707 0.707-0.707-0.707-0.707 0.707-0.707 1.414 1.414 0.707-0.707-1.414-1.414 0.696-0.696 0.707 0.707 0.707-0.707-0.707-0.707 0.707-0.707 1.414 1.414 0.707-0.707-1.414-1.414 0.718-0.718 0.707 0.707 0.707-0.707-0.707-0.707 0.707-0.707 1.415 1.414 0.707-0.707-1.415-1.414 0.708-0.708 3.535 3.536-10.606 10.606-3.536-3.535z"}}]})(props);
	};
	module.exports.TfiRulerPencil = function TfiRulerPencil (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M4.492 0h-1.984c-0.827 0-1.5 0.673-1.5 1.5v10.657l2.521 4.956 2.464-4.959v-10.654c-0.001-0.827-0.674-1.5-1.501-1.5zM2.508 1h1.984c0.275 0 0.5 0.225 0.5 0.5v1.019h-2.984v-1.019c0-0.275 0.224-0.5 0.5-0.5zM2.008 4.55v-1.031h2.984v1.031h-2.984zM3.948 14.021h-0.87l-1.070-2.104v-6.367h1v6.481h1v-6.481h0.984v6.37l-1.044 2.101zM8 0v17h7v-17h-7zM14 16h-5v-0.984h2v-1h-2v-1.016h1v-1h-1v-1h2v-1h-2v-0.984h1v-1h-1v-1h2v-1h-2v-1.016h1v-1h-1v-1h2v-1h-2v-1h5v15z"}}]})(props);
	};
	module.exports.TfiRuler = function TfiRuler (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M5 0v17h7v-17h-7zM11 16h-5v-0.984h2v-1h-2v-1.016h1v-1h-1v-1h2v-1h-2v-0.984h1v-1h-1v-1h2v-1h-2v-1.016h1v-1h-1v-1h2v-1h-2v-1h5v15z"}}]})(props);
	};
	module.exports.TfiSaveAlt = function TfiSaveAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.5 0h-12.664l-2.836 2.776v12.724c0 0.827 0.673 1.5 1.5 1.5h14c0.827 0 1.5-0.673 1.5-1.5v-14c0-0.827-0.673-1.5-1.5-1.5zM13 1v2h-8v-2h8zM3 16v-1h11v1h-11zM16 15.5c0 0.275-0.224 0.5-0.5 0.5h-0.5v-2h-13v2h-0.5c-0.276 0-0.5-0.225-0.5-0.5v-12.304l2.244-2.196h0.756v3h10v-3h1.5c0.276 0 0.5 0.225 0.5 0.5v14zM8.5 5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zM8.5 11c-1.378 0-2.5-1.121-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.122 2.5-2.5 2.5z"}}]})(props);
	};
	module.exports.TfiSave = function TfiSave (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.164 0h-12.664c-0.827 0-1.5 0.673-1.5 1.5v14c0 0.827 0.673 1.5 1.5 1.5h14c0.827 0 1.5-0.673 1.5-1.5v-12.724l-2.836-2.776zM8 1v4h3v-4h1v5h-8v-5h4zM3 16v-6h11v6h-11zM16 15.5c0 0.275-0.225 0.5-0.5 0.5h-0.5v-7h-13v7h-0.5c-0.276 0-0.5-0.225-0.5-0.5v-14c0-0.275 0.224-0.5 0.5-0.5h1.5v6h10v-6h0.756l2.244 2.196v12.304z"}}]})(props);
	};
	module.exports.TfiSearch = function TfiSearch (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.604 15.868l-5.173-5.173c0.975-1.137 1.569-2.611 1.569-4.223 0-3.584-2.916-6.5-6.5-6.5-1.736 0-3.369 0.676-4.598 1.903-1.227 1.228-1.903 2.861-1.902 4.597 0 3.584 2.916 6.5 6.5 6.5 1.612 0 3.087-0.594 4.224-1.569l5.173 5.173 0.707-0.708zM6.5 11.972c-3.032 0-5.5-2.467-5.5-5.5-0.001-1.47 0.571-2.851 1.61-3.889 1.038-1.039 2.42-1.611 3.89-1.611 3.032 0 5.5 2.467 5.5 5.5 0 3.032-2.468 5.5-5.5 5.5z"}}]})(props);
	};
	module.exports.TfiServer = function TfiServer (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 3.5c0-2.273-4.38-3.5-8.5-3.5s-8.5 1.227-8.5 3.5c0 0.149 0.024 0.318 0.080 0.5h-0.080v9.5c0 2.273 4.38 3.5 8.5 3.5s8.5-1.227 8.5-3.5v-9.5h-0.080c0.056-0.182 0.080-0.351 0.080-0.5zM8.5 1c4.293 0 7.5 1.32 7.5 2.5 0 0.398-0.388 0.835-1.093 1.229-1.419 0.796-3.814 1.271-6.407 1.271s-4.988-0.475-6.407-1.271c-0.705-0.394-1.093-0.831-1.093-1.229 0-1.18 3.207-2.5 7.5-2.5zM8.5 16c-4.293 0-7.5-1.32-7.5-2.5v-1.633c0.175 0.135 0.367 0.271 0.604 0.403 1.562 0.874 4.14 1.396 6.896 1.396 0.345 0 0.687-0.008 1.023-0.024 2.361-0.111 4.505-0.607 5.872-1.372v0c0-0.001 0.001-0.001 0.001-0.001 0.236-0.133 0.43-0.268 0.604-0.403v1.634c0 1.18-3.207 2.5-7.5 2.5zM14.907 11.397c-1.42 0.795-3.814 1.27-6.407 1.27-0.324 0-0.646-0.008-0.962-0.022-2.214-0.102-4.203-0.552-5.445-1.247v0c-0.704-0.396-1.093-0.833-1.093-1.231v-1.634c0.175 0.135 0.368 0.271 0.605 0.403 1.561 0.874 4.139 1.396 6.895 1.396s5.334-0.522 6.895-1.396c0.237-0.132 0.43-0.268 0.605-0.403v1.634c0 0.398-0.389 0.835-1.093 1.23zM14.906 8.063c-1.419 0.795-3.813 1.27-6.406 1.27s-4.987-0.475-6.406-1.27c-0.705-0.394-1.094-0.832-1.094-1.23v-1.634c0.175 0.136 0.367 0.271 0.604 0.404 1.562 0.875 4.139 1.397 6.896 1.397s5.334-0.522 6.896-1.397c0.237-0.133 0.429-0.268 0.604-0.404v1.634c0 0.398-0.389 0.836-1.094 1.23z"}}]})(props);
	};
	module.exports.TfiSettings = function TfiSettings (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 5.972c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5zM8.5 9.972c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5 1.5 0.673 1.5 1.5-0.673 1.5-1.5 1.5zM16.94 9.446c0.037-0.321 0.060-0.645 0.060-0.974s-0.023-0.653-0.060-0.974l-2.588-0.778c-0.119-0.402-0.278-0.787-0.474-1.149l1.279-2.377c-0.406-0.51-0.869-0.973-1.38-1.38l-2.377 1.28c-0.363-0.196-0.748-0.354-1.15-0.474l-0.776-2.588c-0.32-0.037-0.644-0.060-0.974-0.060s-0.654 0.023-0.974 0.060l-0.776 2.588c-0.403 0.119-0.789 0.278-1.15 0.475l-2.377-1.28c-0.511 0.406-0.974 0.869-1.379 1.38l1.279 2.375c-0.196 0.362-0.354 0.748-0.474 1.15l-2.589 0.778c-0.037 0.32-0.060 0.644-0.060 0.974s0.023 0.654 0.060 0.974l2.588 0.776c0.12 0.403 0.278 0.789 0.474 1.151l-1.279 2.376c0.406 0.511 0.869 0.974 1.38 1.38l2.377-1.279c0.362 0.196 0.748 0.354 1.15 0.474l0.776 2.588c0.321 0.037 0.645 0.060 0.974 0.060s0.654-0.023 0.974-0.060l0.776-2.588c0.402-0.12 0.788-0.278 1.15-0.474l2.376 1.279c0.511-0.407 0.974-0.87 1.38-1.381l-1.278-2.376c0.196-0.362 0.354-0.748 0.474-1.15l2.588-0.776zM13.548 9.419l-0.154 0.518c-0.1 0.337-0.233 0.66-0.396 0.959l-0.256 0.475 0.255 0.475 0.952 1.77c-0.099 0.105-0.201 0.207-0.306 0.306l-2.243-1.209-0.475 0.256c-0.301 0.163-0.624 0.295-0.96 0.396l-0.518 0.154-0.155 0.518-0.579 1.932c-0.072 0.002-0.143 0.003-0.213 0.003s-0.141-0.001-0.213-0.003l-0.579-1.932-0.155-0.518-0.518-0.154c-0.336-0.1-0.659-0.233-0.959-0.396l-0.475-0.256-2.245 1.207c-0.104-0.099-0.207-0.201-0.306-0.306l1.208-2.244-0.256-0.475c-0.162-0.3-0.295-0.623-0.396-0.96l-0.153-0.517-2.449-0.734c-0.003-0.072-0.004-0.143-0.004-0.212 0-0.070 0.001-0.141 0.004-0.213l2.448-0.734 0.154-0.518c0.1-0.337 0.233-0.66 0.396-0.959l0.256-0.475-1.208-2.245c0.099-0.104 0.201-0.207 0.305-0.306l2.247 1.21 0.476-0.259c0.297-0.162 0.619-0.295 0.956-0.395l0.518-0.154 0.155-0.518 0.579-1.932c0.073-0.001 0.144-0.002 0.214-0.002s0.141 0.001 0.213 0.003l0.579 1.932 0.155 0.518 0.518 0.154c0.335 0.1 0.659 0.233 0.96 0.396l0.475 0.255 2.244-1.208c0.104 0.099 0.207 0.201 0.306 0.306l-0.953 1.77-0.255 0.475 0.257 0.475c0.163 0.3 0.295 0.622 0.395 0.957l0.154 0.518 0.518 0.155 1.932 0.581c0.001 0.072 0.002 0.143 0.002 0.213s-0.001 0.141-0.004 0.213l-2.448 0.734z"}}]})(props);
	};
	module.exports.TfiShareAlt = function TfiShareAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M5.527 8.229l-3.853-3.854 3.854-3.854 0.707 0.707-2.647 2.647h2.912c3.032 0 5.5 2.467 5.5 5.5 0 1.519-0.637 2.983-1.747 4.021l-0.682-0.73c0.921-0.862 1.429-2.030 1.429-3.291 0-2.481-2.019-4.5-4.5-4.5h-2.912l2.646 2.646-0.707 0.708zM16 9.025v6.475c0 0.275-0.225 0.5-0.5 0.5h-14c-0.275 0-0.5-0.225-0.5-0.5v-6.47h-1v6.47c0 0.827 0.673 1.5 1.5 1.5h14c0.827 0 1.5-0.673 1.5-1.5v-6.475h-1z"}}]})(props);
	};
	module.exports.TfiShare = function TfiShare (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M6.795 13.396c-1.11-1.037-1.747-2.502-1.747-4.021 0-3.033 2.468-5.5 5.5-5.5h2.912l-2.646-2.646 0.707-0.707 3.854 3.854-3.854 3.854-0.707-0.707 2.646-2.646h-2.912c-2.481 0-4.5 2.019-4.5 4.5 0 1.261 0.508 2.429 1.429 3.29l-0.682 0.729zM16.048 9.030v6.47c0 0.275-0.225 0.5-0.5 0.5h-14c-0.275 0-0.5-0.225-0.5-0.5v-6.475h-1v6.475c0 0.827 0.673 1.5 1.5 1.5h14c0.827 0 1.5-0.673 1.5-1.5v-6.47h-1z"}}]})(props);
	};
	module.exports.TfiSharethisAlt = function TfiSharethisAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.5 13.5c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-10c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3v10zM11.614 9.386c-0.583 0-1.114 0.229-1.51 0.604l-2.51-1.25c0.010-0.084 0.020-0.156 0.020-0.24s-0.010-0.156-0.021-0.24l2.51-1.249c0.396 0.375 0.927 0.604 1.51 0.604 1.219 0 2.219-0.999 2.219-2.229 0-1.219-1-2.219-2.219-2.219-1.229 0-2.229 1-2.229 2.219 0 0.083 0.010 0.156 0.021 0.239l-2.51 1.25c-0.395-0.365-0.926-0.594-1.509-0.594-1.219 0-2.219 0.989-2.219 2.219s1 2.219 2.219 2.219c0.583 0 1.114-0.229 1.51-0.594l2.51 1.25c-0.011 0.083-0.021 0.156-0.021 0.239 0 1.219 1 2.219 2.229 2.219 1.219 0 2.219-1 2.219-2.219 0-1.229-1-2.228-2.219-2.228z"}}]})(props);
	};
	module.exports.TfiSharethis = function TfiSharethis (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.5 13.168c0 1.843-1.49 3.332-3.333 3.332-1.844 0-3.333-1.489-3.333-3.332 0-0.116 0.010-0.24 0.020-0.354l-3.75-1.876c-0.593 0.552-1.396 0.896-2.271 0.896-1.844 0-3.333-1.489-3.333-3.334 0-1.843 1.489-3.332 3.333-3.332 0.875 0 1.677 0.343 2.271 0.895l3.75-1.874c-0.010-0.116-0.020-0.24-0.020-0.354 0-1.845 1.489-3.334 3.333-3.334 1.843 0 3.333 1.489 3.333 3.334 0 1.844-1.49 3.333-3.333 3.333-0.875 0-1.677-0.344-2.271-0.896l-3.75 1.875c0.010 0.115 0.021 0.24 0.021 0.354 0 0.115-0.011 0.24-0.021 0.354l3.75 1.877c0.594-0.553 1.397-0.897 2.271-0.897 1.843-0.002 3.333 1.487 3.333 3.333z"}}]})(props);
	};
	module.exports.TfiShield = function TfiShield (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 1.016c0 1.654-1.346 3-3 3s-3-1.346-3-3h-1c0 1.654-1.346 3-3 3s-3-1.346-3-3h-1v6.847c0 5.405 7.002 8 7.301 8.107l0.166 0.061 0.167-0.058c0.3-0.103 7.366-2.587 7.366-8.138v-6.819h-1zM2 7.862v-4.204c0.733 0.832 1.807 1.358 3 1.358 1.196 0 2.266-0.533 3-1.369v11.114c-1.659-0.747-6-3.067-6-6.899zM15 7.835c0 3.895-4.293 6.163-6 6.912v-11.101c0.734 0.836 1.804 1.369 3 1.369 1.193 0 2.267-0.525 3-1.357v4.177z"}}]})(props);
	};
	module.exports.TfiShiftLeftAlt = function TfiShiftLeftAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M5.854 5.854l-2.647 2.646 2.646 2.646-0.707 0.707-3.353-3.353 3.354-3.354 0.707 0.708zM9 0v17h1v-17h-1z"}}]})(props);
	};
	module.exports.TfiShiftLeft = function TfiShiftLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 9.001h-11.292l3.646 3.646-0.707 0.707-4.854-4.854 4.854-4.854 0.707 0.707-3.648 3.648h11.294v1zM0 17h1v-17h-1v17z"}}]})(props);
	};
	module.exports.TfiShiftRightAlt = function TfiShiftRightAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.207 8.5l-3.354 3.354-0.707-0.707 2.647-2.647-2.646-2.646 0.707-0.707 3.353 3.353zM7 17h1v-17h-1v17z"}}]})(props);
	};
	module.exports.TfiShiftRight = function TfiShiftRight (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.354 3.646l4.853 4.854-4.854 4.854-0.707-0.707 3.647-3.647h-11.293v-1h11.292l-3.646-3.646 0.708-0.708zM16 0v17h1v-17h-1z"}}]})(props);
	};
	module.exports.TfiShine = function TfiShine (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.5 5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zM8.5 11c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5zM9 4h-1v-3h1v3zM8 13h1v3h-1v-3zM16 8v1h-3v-1h3zM4 9h-3v-1h3v1zM12.036 5.671l-0.707-0.707 2.121-2.121 0.707 0.707-2.121 2.121zM4.964 11.329l0.707 0.707-2.121 2.121-0.707-0.707 2.121-2.121zM12.036 11.329l2.121 2.121-0.707 0.707-2.121-2.121 0.707-0.707zM4.964 5.671l-2.121-2.121 0.707-0.707 2.121 2.121-0.707 0.707z"}}]})(props);
	};
	module.exports.TfiShoppingCartFull = function TfiShoppingCartFull (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2.75 12.5c-0.965 0-1.75 0.785-1.75 1.75s0.785 1.75 1.75 1.75 1.75-0.785 1.75-1.75-0.785-1.75-1.75-1.75zM2.75 15c-0.413 0-0.75-0.337-0.75-0.75s0.337-0.75 0.75-0.75 0.75 0.337 0.75 0.75-0.337 0.75-0.75 0.75zM11.25 12.5c-0.965 0-1.75 0.785-1.75 1.75s0.785 1.75 1.75 1.75 1.75-0.785 1.75-1.75-0.785-1.75-1.75-1.75zM11.25 15c-0.413 0-0.75-0.337-0.75-0.75s0.337-0.75 0.75-0.75 0.75 0.337 0.75 0.75-0.337 0.75-0.75 0.75zM13.37 2l-0.301 2h-13.143l1.117 8.036h11.914l1.043-7.5 0.231-1.536h2.769v-1h-3.63zM12.086 11.036h-10.172l-0.84-6.036h11.852l-0.84 6.036zM11 10h-8v-3.969h1v2.969h6v-2.97h1v3.97zM4 2.969h-1v-1.969h8v1.906h-1v-0.906h-6v0.969z"}}]})(props);
	};
	module.exports.TfiShoppingCart = function TfiShoppingCart (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2.75 12.5c-0.965 0-1.75 0.785-1.75 1.75s0.785 1.75 1.75 1.75 1.75-0.785 1.75-1.75-0.785-1.75-1.75-1.75zM2.75 15c-0.414 0-0.75-0.337-0.75-0.75s0.336-0.75 0.75-0.75 0.75 0.337 0.75 0.75-0.336 0.75-0.75 0.75zM11.25 12.5c-0.965 0-1.75 0.785-1.75 1.75s0.785 1.75 1.75 1.75 1.75-0.785 1.75-1.75-0.785-1.75-1.75-1.75zM11.25 15c-0.414 0-0.75-0.337-0.75-0.75s0.336-0.75 0.75-0.75 0.75 0.337 0.75 0.75-0.336 0.75-0.75 0.75zM13.371 2l-0.302 2h-13.143l1.118 8.036h11.913l1.038-7.463 0.236-1.573h2.769v-1h-3.629zM12.926 5l-0.139 1h-11.574l-0.139-1h11.852zM1.914 11.036l-0.561-4.036h11.295l-0.561 4.036h-10.173z"}}]})(props);
	};
	module.exports.TfiShortcode = function TfiShortcode (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0.026 1h3v1h-2v13h2v1h-3v-15zM14.026 1v1h2v13h-2v1h3v-15h-3zM8.91 7.967c-1.115-0.433-1.607-0.804-1.607-1.56 0-0.552 0.42-1.211 1.523-1.211 0.731 0 1.271 0.239 1.535 0.384l0.288-0.852c-0.359-0.204-0.96-0.396-1.787-0.396-1.571 0-2.614 0.936-2.614 2.195 0 1.14 0.815 1.823 2.135 2.291 1.091 0.419 1.523 0.851 1.523 1.606 0 0.815-0.624 1.38-1.691 1.38-0.72 0-1.403-0.24-1.871-0.528l-0.264 0.876c0.432 0.287 1.283 0.516 2.062 0.516 1.907 0 2.831-1.079 2.831-2.327 0.001-1.188-0.696-1.847-2.063-2.374z"}}]})(props);
	};
	module.exports.TfiSignal = function TfiSignal (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M11.5 4c0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.483 1.084 2.71 2.5 2.949v8.051h-2v1h5v-1h-2v-8.051c1.416-0.239 2.5-1.466 2.5-2.949zM6.5 4c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2-2-0.897-2-2zM4.504 2.192c-0.378 0.46-0.577 1.004-0.577 1.574s0.199 1.114 0.577 1.574l-0.774 0.636c-0.525-0.641-0.803-1.405-0.803-2.209s0.278-1.569 0.803-2.209l0.774 0.634zM2 3.767c0 1.079 0.387 2.096 1.119 2.938l-0.754 0.656c-0.881-1.012-1.365-2.29-1.365-3.594s0.484-2.582 1.365-3.595l0.754 0.656c-0.732 0.843-1.119 1.86-1.119 2.939zM14.073 3.767c0 0.805-0.278 1.568-0.804 2.209l-0.773-0.635c0.378-0.46 0.577-1.004 0.577-1.574s-0.199-1.114-0.577-1.574l0.773-0.635c0.526 0.64 0.804 1.404 0.804 2.209zM16 3.767c0 1.305-0.484 2.582-1.365 3.595l-0.754-0.656c0.732-0.844 1.119-1.86 1.119-2.939s-0.387-2.096-1.119-2.938l0.754-0.656c0.881 1.012 1.365 2.289 1.365 3.594z"}}]})(props);
	};
	module.exports.TfiSkype = function TfiSkype (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.199 9.943c0.089-0.49 0.134-0.975 0.134-1.443 0-4.788-4.269-8.608-9.277-7.699-0.756-0.525-1.635-0.801-2.556-0.801-2.481 0-4.5 2.019-4.5 4.5 0 0.921 0.276 1.8 0.801 2.557-0.089 0.49-0.134 0.974-0.134 1.443 0 4.788 4.27 8.608 9.277 7.699 0.756 0.525 1.635 0.801 2.556 0.801 2.481 0 4.5-2.019 4.5-4.5 0-0.921-0.276-1.8-0.801-2.557zM12.5 16c-0.775 0-1.512-0.252-2.133-0.729l-0.182-0.14-0.225 0.047c-0.499 0.103-0.99 0.155-1.461 0.155-3.768 0-6.833-3.065-6.833-6.833 0-0.471 0.052-0.962 0.156-1.461l0.046-0.225-0.14-0.182c-0.476-0.619-0.728-1.358-0.728-2.132 0-1.93 1.57-3.5 3.5-3.5 0.775 0 1.512 0.252 2.133 0.729l0.182 0.14 0.225-0.047c0.498-0.102 0.989-0.155 1.46-0.155 3.768 0 6.833 3.065 6.833 6.833 0 0.471-0.052 0.962-0.156 1.461l-0.046 0.225 0.14 0.182c0.477 0.619 0.729 1.358 0.729 2.132 0 1.93-1.57 3.5-3.5 3.5zM12.719 10.239c0 2.115-2.042 3.094-4 3.094-2.344 0-4.303-1.042-4.303-2.323 0-0.572 0.323-1.093 1.053-1.093 1.115 0 1.219 1.604 3.146 1.604 0.916 0 1.51-0.405 1.51-0.937 0-0.667-0.573-0.771-1.5-1l-1.521-0.375c-1.52-0.365-2.688-0.99-2.688-2.74 0-2.114 2.094-2.896 3.896-2.896 1.969 0 3.958 0.781 3.958 1.979 0 0.604-0.406 1.136-1.083 1.136-1.011 0-1.042-1.197-2.678-1.197-0.916 0-1.5 0.249-1.5 0.801 0 0.605 0.594 0.74 1.387 0.928l1.082 0.25c1.48 0.333 3.241 0.957 3.241 2.769z"}}]})(props);
	};
	module.exports.TfiSlice = function TfiSlice (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.561 3.844l-1.403-1.404c-0.563-0.565-1.554-0.567-2.121 0l-12.588 12.592 5.434-0.003 2.183-2.168 0.824 0.775 7.671-7.672c0.283-0.282 0.439-0.659 0.439-1.060s-0.156-0.777-0.439-1.060zM6.776 10.116l0.824-0.824 2.109 2.109-0.823 0.825-2.11-2.11zM5.471 14.029l-2.608 0.001 3.206-3.207 1.311 1.311-1.909 1.895zM15.854 5.258l-5.437 5.437-2.11-2.11 5.437-5.438c0.094-0.095 0.219-0.147 0.353-0.147s0.259 0.052 0.354 0.146l1.403 1.404c0.195 0.196 0.195 0.512 0 0.708z"}}]})(props);
	};
	module.exports.TfiSmallcap = function TfiSmallcap (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M6 5.925h1v2h-1v-1h-2v8h1v1h-3v-1h1v-8h-2v1h-1v-2h6zM16 2h-10v2.577h1v-1.577h4v12h-1v1h3v-1h-1v-12h4v1.577h1v-2.577h-1z"}}]})(props);
	};
	module.exports.TfiSoundcloud = function TfiSoundcloud (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0.882 10.132l-0.139 0.875c-0.007 0.035-0.027 0.062-0.062 0.062s-0.056-0.027-0.062-0.062l-0.119-0.875 0.118-0.889c0.007-0.035 0.028-0.062 0.062-0.062s0.055 0.027 0.062 0.062l0.14 0.889zM1.521 10.132l-0.18 1.409c-0.007 0.035-0.035 0.062-0.069 0.062-0.035 0-0.062-0.027-0.062-0.068l-0.16-1.403c0.16-1.438 0.16-1.438 0.16-1.438 0-0.034 0.027-0.062 0.062-0.062 0.034 0 0.062 0.028 0.069 0.062l0.18 1.438zM2.153 10.132l-0.173 1.646c0 0.041-0.035 0.076-0.077 0.076s-0.076-0.035-0.083-0.076l-0.146-1.646 0.146-1.701c0.007-0.049 0.042-0.083 0.083-0.083 0.042 0 0.077 0.034 0.077 0.083l0.173 1.701zM2.792 10.132l-0.16 1.694c-0.007 0.056-0.048 0.091-0.097 0.091-0.048 0-0.090-0.035-0.090-0.091l-0.146-1.694 0.146-1.75c0-0.056 0.042-0.090 0.090-0.090 0.049 0 0.090 0.034 0.097 0.090l0.16 1.75zM3.431 10.132l-0.146 1.709c-0.007 0.062-0.056 0.111-0.111 0.111s-0.104-0.049-0.104-0.111l-0.139-1.709 0.139-1.624c0-0.057 0.049-0.105 0.104-0.105 0.056 0 0.104 0.049 0.111 0.105l0.146 1.624zM4.083 10.132l-0.146 1.709c0 0.068-0.056 0.125-0.118 0.125-0.069 0-0.118-0.057-0.125-0.125l-0.125-1.709c0.125-2.64 0.125-2.64 0.125-2.64 0.008-0.068 0.056-0.124 0.125-0.124 0.062 0 0.118 0.056 0.118 0.124l0.146 2.64zM4.722 10.146l-0.132 1.695c0 0.076-0.063 0.131-0.132 0.131-0.076 0-0.131-0.055-0.139-0.131l-0.111-1.695c0.111-3.25 0.111-3.25 0.111-3.25 0.007-0.076 0.062-0.132 0.139-0.132 0.069 0 0.132 0.056 0.132 0.132l0.132 3.25zM5.396 10.132l-0.125 1.681c-0.007 0.083-0.069 0.146-0.153 0.146-0.076 0-0.139-0.062-0.146-0.146l-0.111-1.681 0.111-3.514c0-0.083 0.070-0.153 0.146-0.153 0.083 0 0.146 0.070 0.153 0.153l0.125 3.514zM6.056 10.132l-0.112-3.632c-0.006-0.090-0.076-0.167-0.166-0.167-0.083 0-0.16 0.077-0.16 0.167l-0.098 3.632 0.098 1.674c0.007 0.090 0.077 0.16 0.16 0.16 0.090 0 0.16-0.070 0.167-0.16l0.111-1.674zM6.722 10.132l-0.104 1.66c0 0.097-0.076 0.174-0.174 0.174-0.097 0-0.167-0.077-0.173-0.174l-0.098-1.66 0.098-3.542c0-0.098 0.076-0.174 0.173-0.174 0.098 0 0.174 0.076 0.174 0.174l0.104 3.542zM7.403 10.139l-0.098 1.64c0 0.104-0.083 0.188-0.187 0.188s-0.188-0.084-0.194-0.188l-0.083-1.64 0.083-3.416c0.007-0.111 0.090-0.195 0.194-0.195 0.104 0 0.18 0.084 0.187 0.195l0.098 3.416zM8.076 10.139l-0.083-4.070c0-0.069-0.035-0.132-0.090-0.166-0.035-0.021-0.070-0.035-0.111-0.035-0.042 0-0.076 0.014-0.111 0.035-0.056 0.035-0.091 0.097-0.091 0.166l-0.007 0.041-0.070 4.021c0 0 0 0.007 0.077 1.639 0 0 0 0 0 0.008 0 0.041 0.014 0.083 0.042 0.117 0.042 0.049 0.097 0.076 0.16 0.076 0.056 0 0.104-0.027 0.139-0.062 0.042-0.034 0.062-0.083 0.062-0.139l0.007-0.166 0.076-1.465zM8.681 11.743c0 0.118-0.097 0.215-0.215 0.215s-0.215-0.097-0.223-0.215l-0.041-0.791-0.042-0.813 0.083-4.416v-0.022c0.007-0.062 0.035-0.125 0.084-0.166 0.034-0.027 0.083-0.049 0.138-0.049 0.035 0 0.077 0.014 0.104 0.035 0.062 0.034 0.104 0.104 0.111 0.18l0.097 4.438-0.096 1.604zM14.535 11.966c-5.452 0-5.458 0-5.458 0-0.118-0.014-0.215-0.104-0.215-0.229v-6.245c0-0.117 0.042-0.173 0.195-0.229 0.382-0.152 0.812-0.235 1.257-0.235 1.812 0 3.299 1.388 3.458 3.159 0.236-0.097 0.493-0.153 0.764-0.153 1.083 0 1.965 0.883 1.965 1.973-0.001 1.084-0.883 1.959-1.966 1.959z"}}]})(props);
	};
	module.exports.TfiSplitH = function TfiSplitH (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2.207 8h3.772v1h-3.772l1.646 1.646-0.707 0.707-2.853-2.853 2.854-2.854 0.707 0.707-1.647 1.647zM13.854 5.646l-0.707 0.707 1.646 1.647h-3.772v1h3.772l-1.646 1.646 0.707 0.707 2.853-2.853-2.853-2.854zM8 17h1v-17h-1v17z"}}]})(props);
	};
	module.exports.TfiSplitVAlt = function TfiSplitVAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M5.354 5.854l-2.647 2.646 2.646 2.646-0.707 0.707-3.353-3.353 3.354-3.354 0.707 0.708zM12.354 5.146l-0.707 0.707 2.646 2.647-2.646 2.646 0.707 0.707 3.353-3.353-3.353-3.354zM8 17h1v-17h-1v17z"}}]})(props);
	};
	module.exports.TfiSplitV = function TfiSplitV (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M10.646 13.146l0.707 0.707-2.853 2.854-2.854-2.854 0.707-0.707 1.647 1.647v-3.772h1v3.772l1.646-1.647zM8 2.207v3.772h1v-3.772l1.646 1.646 0.707-0.707-2.853-2.853-2.854 2.853 0.707 0.707 1.647-1.646zM0 8v1h17v-1h-17z"}}]})(props);
	};
	module.exports.TfiSpray = function TfiSpray (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M6.5 3c-1.426 0-2.742 0.778-3.453 2h-1.047v10.5c0 0.827 0.673 1.5 1.5 1.5h6c0.827 0 1.5-0.673 1.5-1.5v-10.5h-1.047c-0.711-1.221-2.029-2-3.453-2zM6.5 4c0.859 0 1.672 0.376 2.234 1h-4.467c0.561-0.624 1.373-1 2.233-1zM10 15.5c0 0.275-0.224 0.5-0.5 0.5h-6c-0.276 0-0.5-0.225-0.5-0.5v-9.5h7v9.5zM8 0h-3v3h3v-3zM7 2h-1v-1h1v1zM11.945 1.511l3.136 0.518-0.163 0.986-6-0.99 0.085-0.514-0.085-0.514 6-0.99 0.163 0.986-3.136 0.518z"}}]})(props);
	};
	module.exports.TfiStackOverflow = function TfiStackOverflow (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.66 16.179c0 0.312-0.009 0.312-0.009 0.312v0.009h-10.106c-0.313 0-0.313-0.009-0.313-0.009h-0.009v-6.572h1.081v5.519h8.286v-5.519h1.070v6.26zM10.509 14.356l-6.312 0.009v-1.348l6.312-0.009v1.348zM10.661 11.286l-0.116 1.339-6.295-0.58 0.125-1.339 6.286 0.58zM11.081 9.518l-0.349 1.305-6.098-1.635 0.348-1.304 6.099 1.634zM11.875 7.982l-0.688 1.16-5.437-3.213 0.687-1.161 5.438 3.214zM13.205 7.036l-1.106 0.759-3.564-5.214 1.116-0.769 3.554 5.224zM14.777 6.724l-1.331 0.232-1.080-6.224 1.33-0.232 1.081 6.224z"}}]})(props);
	};
	module.exports.TfiStamp = function TfiStamp (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 11.918c0-1.046-0.852-1.898-1.897-1.898h-4.396l1.26-4.517 0.019-3.52c-0.002-1.075-0.915-1.983-1.996-1.983h-2.991c-1.083 0-1.997 0.908-1.997 1.983v3.361l1.278 4.676h-4.383c-1.045 0-1.897 0.852-1.897 1.898v4.082h1v1h15v-1h1v-4.082zM16 15h-15v-3.082c0-0.495 0.402-0.898 0.897-0.898h5.697l-1.592-5.744v-3.293c0-0.524 0.466-0.983 0.997-0.983h2.991c0.529 0 0.994 0.459 0.994 0.983v3.317l-1.594 5.72h5.713c0.495 0 0.897 0.403 0.897 0.898v3.082z"}}]})(props);
	};
	module.exports.TfiStar = function TfiStar (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.647 7.017h-6.225l-1.922-5.92-1.923 5.92h-6.224l5.035 3.658-1.922 5.92 5.034-3.659 5.035 3.659-1.922-5.92 5.034-3.658zM11.633 13.977l-3.133-2.278-3.133 2.277 1.197-3.685-3.133-2.274h3.873l1.196-3.684 1.196 3.684h3.873l-3.133 2.275 1.197 3.685z"}}]})(props);
	};
	module.exports.TfiStatsDown = function TfiStatsDown (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M5.166 8.803l-4.371-3.956 0.67-0.741 3.773 3.413 4.204-3.026 5.593 6.25v-2.285h1v4.036h-4.036v-1h2.366l-5.069-5.665-4.13 2.974zM0 16v1h17v-1h-17z"}}]})(props);
	};
	module.exports.TfiStatsUp = function TfiStatsUp (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 16v1h-17v-1h17zM5.203 7.976l4.204 3.026 5.593-6.251v2.284h1v-4.035h-4.036v1h2.366l-5.070 5.665-4.129-2.974-4.372 3.956 0.671 0.741 3.773-3.412z"}}]})(props);
	};
	module.exports.TfiSupport = function TfiSupport (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13.384 3c-0.937-1.829-2.805-3-4.884-3s-3.946 1.17-4.884 3h-3.616v13h17v-13h-3.616zM8.5 1c1.522 0 2.907 0.767 3.732 2h-7.464c0.826-1.232 2.21-2 3.732-2zM16 15h-15v-11h15v11zM8 10h-2v-1h2v-2h1v2h2v1h-2v2h-1v-2z"}}]})(props);
	};
	module.exports.TfiTablet = function TfiTablet (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.25 14.5c0 0.415-0.335 0.75-0.75 0.75s-0.75-0.335-0.75-0.75 0.335-0.75 0.75-0.75 0.75 0.335 0.75 0.75zM16 1.5v14c0 0.827-0.625 1.5-1.392 1.5h-12.216c-0.767 0-1.392-0.673-1.392-1.5v-14c0-0.827 0.625-1.5 1.392-1.5h12.217c0.766 0 1.391 0.673 1.391 1.5zM15 1.5c0-0.271-0.179-0.5-0.392-0.5h-12.216c-0.213 0-0.392 0.229-0.392 0.5v14c0 0.271 0.179 0.5 0.392 0.5h12.217c0.212 0 0.391-0.229 0.391-0.5v-14zM3 2h11v11h-11v-11zM4 12h9v-9h-9v9z"}}]})(props);
	};
	module.exports.TfiTag = function TfiTag (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.953 1.008l-3.967 2.882v12.14l3.986-2.794 4.041 2.785v-12.135l-4.060-2.878zM12.014 14.117l-3.045-2.1-2.982 2.091v-9.709l2.975-2.161 3.053 2.165v9.714zM7.254 6.001c0 0.965 0.785 1.75 1.75 1.75s1.75-0.785 1.75-1.75-0.785-1.75-1.75-1.75-1.75 0.785-1.75 1.75zM9.004 5.251c0.413 0 0.75 0.337 0.75 0.75s-0.337 0.75-0.75 0.75-0.75-0.337-0.75-0.75 0.337-0.75 0.75-0.75z"}}]})(props);
	};
	module.exports.TfiTarget = function TfiTarget (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17.020 8h-2.045c-0.245-3.194-2.806-5.745-6.004-5.977v-2.062h-1v2.065c-3.172 0.258-5.702 2.799-5.946 5.974h-2.045v1h2.045c0.244 3.175 2.774 5.716 5.945 5.974v2.026h1v-2.023c3.198-0.231 5.759-2.782 6.004-5.977h2.045v-1zM8.971 13.977v-1.977h-1v1.974c-2.621-0.252-4.708-2.35-4.946-4.974h1.955v-1h-1.955c0.238-2.624 2.325-4.722 4.946-4.974v1.935h1v-1.938c2.647 0.227 4.764 2.333 5.004 4.977h-1.955v1h1.955c-0.24 2.644-2.357 4.75-5.004 4.977z"}}]})(props);
	};
	module.exports.TfiText = function TfiText (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14 2v3h-1v-2h-4v12h1.643v1h-4.286v-1h1.643v-12h-4v2h-1v-3h11z"}}]})(props);
	};
	module.exports.TfiThemifyFaviconAlt = function TfiThemifyFaviconAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M6.096 1.85c-9.586 2.996-5.316 9.618-4.059 10.272 2.131 1.105-1.152 3.574-1.152 3.574s2.817-0.824 6.404-1.192c4.312-0.44 9.156-1.068 9.592-3.467 0.799-4.393-2.397-11.807-10.785-9.187zM10 5c0.552 0 1 0.447 1 1 0 0.551-0.448 1-1 1-0.553 0-1-0.449-1-1 0-0.553 0.447-1 1-1zM5 5.5c0.552 0 1 0.449 1 1s-0.448 1-1 1-1-0.449-1-1 0.448-1 1-1zM3.7 9.45c3.2 2.864 9.6-0.95 9.6-0.95-5.542 6.142-9.6 0.95-9.6 0.95z"}}]})(props);
	};
	module.exports.TfiThemifyFavicon = function TfiThemifyFavicon (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.401 1.304c-0.996 0-2.097 0.169-3.305 0.546-9.587 2.996-5.316 9.618-4.060 10.272 2.131 1.105-1.151 3.574-1.151 3.574s2.817-0.824 6.404-1.192c4.312-0.44 9.155-1.068 9.592-3.467 0.684-3.761-1.559-9.733-7.48-9.733zM15.897 10.858c-0.327 1.795-5.989 2.373-8.71 2.65-1.353 0.139-2.593 0.34-3.624 0.538 0.141-0.351 0.216-0.719 0.185-1.093-0.035-0.418-0.244-1.196-1.244-1.716-0.372-0.222-1.708-1.95-1.479-3.878 0.294-2.469 3.082-3.84 5.369-4.555 1.064-0.332 2.076-0.5 3.007-0.5 1.971 0 3.581 0.732 4.787 2.177 1.627 1.95 2.031 4.608 1.709 6.377zM4 6.5c0-0.551 0.448-1 1-1s1 0.449 1 1-0.448 1-1 1-1-0.449-1-1zM9 6c0-0.553 0.447-1 1-1 0.552 0 1 0.447 1 1 0 0.551-0.448 1-1 1-0.553 0-1-0.449-1-1zM13.3 8.5c-5.542 6.142-9.6 0.95-9.6 0.95 3.2 2.864 9.6-0.95 9.6-0.95z"}}]})(props);
	};
	module.exports.TfiThemifyLogo = function TfiThemifyLogo (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2.628 6.814c-0.092 0-0.219 0.003-0.299 0.017l-0.024 0.004-0.012 0.021c-0.408 0.748-1.22 2.934-1.349 3.256-0.28-0.020-0.653-0.019-0.653-0.374 0-0.258 0.904-2.37 1.029-2.717l0.024-0.066h-0.070c-0.084 0-0.166 0.005-0.246 0.011-0.075 0.005-0.146 0.010-0.215 0.010-0.182 0-0.741 0.022-0.808-0.427-0.027-0.186 0.050-0.389 0.139-0.488 0.017 0.244 0.397 0.233 0.5 0.233 0.227 0 0.707-0.095 1.011-0.134 0.353-0.045 0.749-0.148 1.113-0.148 0.365 0 0.63 0.222 0.63 0.526 0 0.106-0.034 0.223-0.099 0.337-0.193-0.044-0.477-0.061-0.671-0.061zM6.524 9.588c-0.207 0.049-0.467 0.026-0.467-0.4 0.002-0.52 0.573-1.123 0.858-1.123 0.051 0 0.201 0.037 0.168 0.203-0.175 0.883-0.98 0.746-0.919 0.847 0.29 0.482 1.711-0.234 1.573-1.248-0.046-0.346-0.255-0.579-0.654-0.579-0.74 0-1.587 1.099-1.737 1.908-0.303 0.308-0.647 0.286-0.673 0.283-0.021-0.029-0.022-0.087 0.013-0.203 0.062-0.204 0.205-0.515 0.369-0.79 0.154-0.257 0.315-0.525 0.315-0.723 0-0.239-0.141-0.36-0.417-0.36-0.361 0-1.025 0.442-1.025 0.442 0.026-0.211 0.697-1.568 0.697-1.751 0-0.214-0.097-0.361-0.363-0.361-0.069 0-0.271 0.069-0.387 0.111-0.111 0.854-0.553 1.559-0.728 1.95-0.327 0.729-0.689 1.492-0.689 1.81 0 0.3 0.289 0.587 0.601 0.6 0.28-1.058 0.964-2.206 1.433-2.206 0 0-0.541 1.127-0.541 1.643 0 0.254 0.054 0.515 0.453 0.515 0.002 0 0.004 0 0.006 0 0.361 0.037 0.752-0.451 0.915-0.682 0.022 0.549 0.501 0.61 0.71 0.61 0.609 0 1.148-0.371 1.557-1.029-0.227 0.188-0.785 0.466-1.068 0.533zM10.711 9.251c0.021-0.082 0.080-0.245 0.222-0.52 0.178-0.346 0.421-0.818 0.421-1.104 0-0.167-0.079-0.241-0.258-0.241-0.229 0-0.557 0.209-0.857 0.545l-0.084 0.093v-0.127c0-0.332-0.098-0.5-0.288-0.5-0.244 0-0.643 0.276-1.014 0.704 0 0 0.076-0.382 0.076-0.505 0-0.26-0.228-0.298-0.363-0.298-0.072 0-0.147 0.009-0.225 0.026-0.025 0.291-0.3 0.929-0.543 1.495-0.157 0.367-0.319 0.744-0.319 0.827 0 0.266 0.181 0.438 0.459 0.438 0.014 0 0.028 0 0.043-0.001 0.205-0.689 0.754-1.7 1.143-1.7h0.067l-0.023 0.065c-0.055 0.167-0.142 0.331-0.227 0.49-0.143 0.268-0.276 0.521-0.276 0.791 0 0.22 0.205 0.339 0.398 0.339 0.049 0 0.089-0.005 0.124-0.015 0.141-0.639 0.877-1.713 1.182-1.713h0.090l-0.050 0.077c-0.090 0.142-0.454 0.817-0.454 1.296 0 0.298 0.146 0.442 0.444 0.442 0.414 0 0.71-0.382 0.826-0.797-0.135 0.093-0.253 0.112-0.379 0.112-0.101 0.001-0.185-0.020-0.135-0.219zM12.534 9.571c-0.221 0.183-0.522 0.018-0.527-0.15-0.004-0.184 0.158-0.511 0.359-0.903 0.158-0.311 0.363-0.523 0.344-0.68-0.026-0.222-0.331-0.396-0.521-0.396-0.017 0-0.033 0.001-0.050 0.003-0.009 0-0.016 0.001-0.023 0.001-0.104 0.268-0.238 0.558-0.368 0.84-0.232 0.503-0.452 0.979-0.452 1.228 0 0.312 0.211 0.65 0.552 0.65 0.356-0.018 0.542-0.173 0.686-0.593zM12.637 7.101c0.092 0 0.202-0.010 0.323-0.028 0.157-0.191 0.236-0.352 0.236-0.477 0-0.129-0.202-0.2-0.784-0.205-0.184 0.186-0.174 0.32-0.174 0.469 0.001 0.161 0.132 0.241 0.399 0.241zM16.389 7.199l-0.030 0.001-0.004 0.028c-0.063 0.48-1.049 2.104-1.232 1.643-0.041-0.104 0.076-0.382 0.175-0.613 0.113-0.264 0.24-0.563 0.227-0.731-0.003-0.038-0.016-0.070-0.035-0.098-0.011-0.024-0.032-0.051-0.070-0.075-0.031-0.020-0.072-0.035-0.123-0.048-0.117-0.034-0.26-0.040-0.376-0.036-0.132-0.002-0.277 0.003-0.425 0.012l0.009-0.027c0.141-0.46 0.516-0.889 0.622-0.954 0.261-0.161 0.61-0.2 0.688 0.156 0.066-0.15 0.085-0.193 0.066-0.306-0.056-0.345-0.312-0.532-0.715-0.554-0.732-0.038-1.255 1.033-1.506 1.646l-0.006 0.014-0.012 0.009c-0.071 0.050-0.203 0.083-0.282 0.104-0.017 0.004-0.030 0.008-0.039 0.011-0.153 0.055-0.185 0.204-0.188 0.271-0.004 0.111 0.129 0.193 0.188 0.294 0 0-0.258 0.641-0.445 1.030-0.293 0.607-0.759 1.635-0.767 1.864-0.011 0.279 0.396 0.537 0.618 0.566 0.068-0.466 1.383-3.436 1.383-3.436 0.047-0.072 0.127-0.172 0.253-0.248 0.118-0.048 0.208-0.064 0.277-0.062 0.017 0.004 0.030 0.009 0.042 0.016 0.036 0.020 0.059 0.051 0.072 0.082-0.045 0.16-0.104 0.329-0.163 0.495-0.128 0.362-0.296 0.92-0.274 1.181 0.014 0.167 0.029 0.246 0.118 0.338 0.267 0.274 0.936-0.196 1.135-0.464l0.033 0.014c-0.238 0.678-0.604 1.137-0.995 1.149-0.521 0.018-0.738-0.319-0.738-0.319s-0.088 0.324 0.263 0.683c0.157 0.16 0.39 0.226 0.628 0.208 0.016-0.001 0.032-0.003 0.048-0.004 0.96-0.104 1.378-1.193 1.715-2.217 0.047-0.144 0.209-0.525 0.257-0.662 0.027-0.074 0.061-0.154 0.093-0.231l0.004-0.009c0.076-0.185 0.126-0.31 0.122-0.373-0.021-0.237-0.323-0.355-0.611-0.348z"}}]})(props);
	};
	module.exports.TfiThought = function TfiThought (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M11.5 10.116c3.033 0 5.5-2.269 5.5-5.058s-2.467-5.058-5.5-5.058c-1.912 0-3.693 0.938-4.684 2.431-0.705-0.399-1.496-0.608-2.316-0.608-2.481 0-4.5 1.86-4.5 4.147 0 2.286 2.019 4.146 4.5 4.146 0.186 0 0.375-0.013 0.573-0.037 0.652 0.588 1.522 0.921 2.427 0.921 1.002 0 1.929-0.387 2.592-1.070 0.488 0.125 0.951 0.186 1.408 0.186zM9.745 8.785l-0.212 0.268c-0.471 0.593-1.231 0.947-2.033 0.947-0.724 0-1.414-0.29-1.895-0.797l-0.184-0.193-0.264 0.046c-0.214 0.037-0.431 0.060-0.657 0.060-1.93 0-3.5-1.411-3.5-3.145 0-1.735 1.57-3.147 3.5-3.147 0.792 0 1.549 0.246 2.189 0.713l0.472 0.343 0.267-0.52c0.738-1.433 2.336-2.36 4.072-2.36 2.481 0 4.5 1.82 4.5 4.059 0 2.237-2.019 4.058-4.5 4.058-0.453 0-0.921-0.075-1.429-0.231l-0.326-0.101zM11.5 10.5c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM11.5 13.5c-0.551 0-1-0.448-1-1s0.449-1 1-1 1 0.448 1 1-0.449 1-1 1zM15.25 14c-0.689 0-1.25 0.561-1.25 1.25s0.561 1.25 1.25 1.25 1.25-0.561 1.25-1.25-0.561-1.25-1.25-1.25zM15 15.25c0-0.138 0.112-0.25 0.25-0.25s0.25 0.112 0.25 0.25c0 0.275-0.5 0.275-0.5 0z"}}]})(props);
	};
	module.exports.TfiThumbDown = function TfiThumbDown (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.568 9.501c0 0.276-0.224 0.5-0.5 0.5h-2.291l-3.088 4.99c-0.477 0.8-1.095 0.921-1.42 0.921 0 0-0.001 0-0.001 0-0.485 0-0.955-0.264-1.199-0.671-0.364-0.61-0.238-1.446-0.087-2.106l0.403-2.124h-3.849c-0.847 0-1.535-0.675-1.535-1.505 0-0.548 0.3-1.029 0.748-1.292-0.153-0.209-0.25-0.455-0.25-0.729 0-0.526 0.24-0.971 0.621-1.233-0.138-0.235-0.204-0.502-0.204-0.769 0-0.575 0.328-1.062 0.817-1.305-0.133-0.256-0.162-0.516-0.162-0.69 0-0.932 0.581-1.488 1.553-1.488h5.625c0.754 0 1.274 0.404 1.653 0.7 0.219 0.17 0.426 0.332 0.569 0.332h2.103c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2.103c-0.487 0-0.857-0.288-1.184-0.542-0.322-0.253-0.627-0.49-1.038-0.49h-5.625c-0.467 0-0.553 0.165-0.553 0.488 0 0.158 0 0.527 1.027 0.527h0.105c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1.258c-0.307 0-0.529 0.197-0.529 0.468 0 0.45 0.449 0.517 0.717 0.517h0.75c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1.436c-0.33 0-0.448 0.25-0.448 0.484 0 0.168 0.366 0.457 0.705 0.513h0.966c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-0.983c-0.007 0-0.013 0.004-0.020 0.004h-0.631c-0.295 0-0.535 0.227-0.535 0.505s0.24 0.505 0.535 0.505h4.453c0.149 0 0.29 0.066 0.385 0.181 0.095 0.115 0.134 0.266 0.106 0.412l-0.52 2.734c-0.062 0.273-0.238 1.046-0.033 1.39 0.053 0.088 0.182 0.184 0.34 0.184 0.196 0 0.397-0.157 0.566-0.44l3.239-5.234c0.091-0.147 0.252-0.237 0.425-0.237h2.569c0.279 0 0.502 0.224 0.502 0.5z"}}]})(props);
	};
	module.exports.TfiThumbUp = function TfiThumbUp (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.368 9.725c0.083 0.203 0.132 0.466 0.132 0.807 0 0.526-0.24 0.971-0.621 1.233 0.138 0.234 0.204 0.501 0.204 0.768 0 0.562-0.313 1.041-0.785 1.288 0.080 0.188 0.127 0.42 0.129 0.705 0.002 0.449-0.129 0.81-0.391 1.073-0.276 0.277-0.667 0.418-1.161 0.418h-5.625c-0.754 0-1.273-0.404-1.653-0.7-0.219-0.17-0.426-0.332-0.57-0.332h-2.102c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2.102c0.487 0 0.857 0.288 1.184 0.542 0.323 0.251 0.628 0.489 1.039 0.489h5.625c0.212 0 0.373-0.043 0.452-0.123 0.068-0.068 0.102-0.19 0.101-0.362-0.003-0.437-0.092-0.531-1.027-0.531h-0.106c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1.258c0.307 0 0.53-0.197 0.53-0.468 0-0.45-0.449-0.517-0.717-0.517h-0.75c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1.437c0.331 0 0.448-0.25 0.448-0.484 0-0.492 0-0.492-0.439-0.505-0.051-0.001-0.104-0.005-0.156-0.007h-1.076c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.982c0.007 0 0.013-0.004 0.020-0.004h0.631c0.295 0 0.536-0.227 0.536-0.505s-0.24-0.505-0.536-0.505h-4.453c-0.149 0-0.29-0.066-0.385-0.181-0.095-0.115-0.134-0.266-0.106-0.412l0.52-2.734c0.062-0.273 0.238-1.047 0.033-1.39-0.053-0.089-0.182-0.184-0.34-0.184 0 0 0 0 0 0-0.196 0-0.397 0.157-0.566 0.44l-3.241 5.234c-0.091 0.147-0.252 0.237-0.425 0.237h-2.569c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2.291l3.088-4.99c0.476-0.8 1.095-0.921 1.42-0.921 0 0 0 0 0.001 0 0.485 0 0.955 0.264 1.198 0.671 0.364 0.609 0.238 1.445 0.087 2.106l-0.403 2.124h3.849c0.847 0 1.536 0.675 1.536 1.505 0.001 0.498-0.248 0.941-0.63 1.215z"}}]})(props);
	};
	module.exports.TfiTicket = function TfiTicket (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.5 1v0.5c0 0.552-0.449 1-1 1s-1-0.448-1-1v-0.5h-3.5v15h3.5v-0.5c0-0.552 0.449-1 1-1s1 0.448 1 1v0.5h3.5v-15h-3.5zM6.563 2c0.223 0.861 1.007 1.5 1.937 1.5s1.714-0.639 1.937-1.5h1.563v6h-7v-6h1.563zM10.437 15c-0.222-0.861-1.006-1.5-1.937-1.5s-1.714 0.639-1.937 1.5h-1.563v-6h7v6h-1.563z"}}]})(props);
	};
	module.exports.TfiTime = function TfiTime (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.666 0c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5c0-4.687-3.813-8.5-8.5-8.5zM8.666 16c-4.136 0-7.5-3.364-7.5-7.5s3.364-7.5 7.5-7.5 7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5zM14 9v1h-6v-5h1v4h5z"}}]})(props);
	};
	module.exports.TfiTimer = function TfiTimer (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9 2.025v-1.025h1.5v-1h-4v1h1.5v1.025c-3.902 0.26-7 3.508-7 7.475 0 4.136 3.364 7.5 7.5 7.5s7.5-3.364 7.5-7.5c0-3.967-3.098-7.215-7-7.475zM8.5 16c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zM9 9h4v1h-5v-4h1v3z"}}]})(props);
	};
	module.exports.TfiTrash = function TfiTrash (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M10.935 2.016c-0.218-0.869-0.999-1.516-1.935-1.516-0.932 0-1.71 0.643-1.931 1.516h-3.569v1h11v-1h-3.565zM9 1.5c0.382 0 0.705 0.221 0.875 0.516h-1.733c0.172-0.303 0.485-0.516 0.858-0.516zM13 4h1v10.516c0 0.827-0.673 1.5-1.5 1.5h-7c-0.827 0-1.5-0.673-1.5-1.5v-10.516h1v10.516c0 0.275 0.224 0.5 0.5 0.5h7c0.276 0 0.5-0.225 0.5-0.5v-10.516zM8 5v8h-1v-8h1zM11 5v8h-1v-8h1z"}}]})(props);
	};
	module.exports.TfiTrello = function TfiTrello (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.5 15.833c0 0.365-0.302 0.667-0.667 0.667h-14.666c-0.364 0-0.667-0.302-0.667-0.667v-14.666c0-0.365 0.302-0.667 0.667-0.667h14.667c0.364 0 0.667 0.302 0.667 0.667v14.666zM7.833 2.5c0-0.188-0.146-0.333-0.333-0.333h-5c-0.188 0-0.333 0.146-0.333 0.333v10.667c0 0.187 0.146 0.333 0.333 0.333h5c0.188 0 0.333-0.146 0.333-0.333v-10.667zM14.833 2.5c0-0.188-0.146-0.333-0.333-0.333h-5c-0.188 0-0.333 0.146-0.333 0.333v6.667c0 0.187 0.145 0.333 0.333 0.333h5c0.188 0 0.333-0.146 0.333-0.333v-6.667z"}}]})(props);
	};
	module.exports.TfiTruck = function TfiTruck (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 3h-11v3h-2.873l-1.19 4h-1.937v4.977h2.002c0 0.008-0.002 0.015-0.002 0.023 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.008-0.002-0.015-0.002-0.023h5.005c-0.001 0.008-0.003 0.015-0.003 0.023 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.008-0.002-0.015-0.002-0.023h2.002v-11.977zM3.873 7h2.127v3h-3.020l0.893-3zM4 16c-0.551 0-1-0.449-1-1s0.449-1 1-1 1 0.449 1 1-0.449 1-1 1zM13 16c-0.551 0-1-0.449-1-1s0.449-1 1-1 1 0.449 1 1-0.449 1-1 1zM16 13.977h-1.291c-0.35-0.582-0.981-0.977-1.709-0.977s-1.359 0.395-1.709 0.977h-5.582c-0.35-0.582-0.981-0.977-1.709-0.977s-1.359 0.395-1.709 0.977h-1.291v-2.977h6v-7h9v9.977z"}}]})(props);
	};
	module.exports.TfiTumblrAlt = function TfiTumblrAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.104 0.5v4.042h3.793v2.51h-3.793v4.104c0 0.927 0.042 1.521 0.146 1.792 0.094 0.261 0.281 0.468 0.541 0.625 0.354 0.218 0.761 0.323 1.219 0.323 0.813 0 1.615-0.261 2.417-0.793v2.521c-0.688 0.323-1.302 0.552-1.854 0.678-0.553 0.135-1.156 0.197-1.803 0.197-0.729 0-1.374-0.094-1.938-0.281-0.562-0.177-1.042-0.448-1.437-0.781-0.395-0.343-0.676-0.708-0.822-1.093-0.156-0.386-0.229-0.947-0.229-1.677v-5.615h-1.771v-2.261c0.624-0.207 1.166-0.5 1.614-0.874 0.449-0.386 0.803-0.844 1.074-1.375 0.27-0.542 0.458-1.219 0.562-2.042h2.281z"}}]})(props);
	};
	module.exports.TfiTumblr = function TfiTumblr (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M13.15 12.687c-0.72 0.478-1.42 0.71-2.141 0.71-0.371 0-0.684-0.082-0.96-0.251-0.17-0.103-0.277-0.223-0.333-0.377-0.052-0.134-0.113-0.522-0.113-1.612v-3.605h3.793v-3.51h-3.792v-4.042h-3.221l-0.056 0.438c-0.096 0.758-0.27 1.391-0.512 1.878-0.245 0.481-0.557 0.88-0.948 1.217-0.398 0.332-0.887 0.596-1.451 0.783l-0.343 0.114v3.122h1.771v5.115c0 0.812 0.087 1.423 0.262 1.854 0.171 0.453 0.495 0.889 0.969 1.299 0.464 0.392 1.005 0.687 1.601 0.874 0.611 0.202 1.316 0.306 2.095 0.306 0.699 0 1.346-0.071 1.914-0.21 0.574-0.131 1.214-0.364 1.955-0.713l0.287-0.135v-3.771l-0.777 0.516zM12.927 15.304c-0.553 0.245-1.035 0.413-1.472 0.514-1.037 0.253-2.476 0.256-3.473-0.075-0.476-0.15-0.901-0.381-1.259-0.683-0.341-0.296-0.571-0.596-0.687-0.903-0.129-0.316-0.193-0.817-0.193-1.489v-6.116h-1.77v-1.411c0.543-0.216 1.025-0.498 1.44-0.845 0.49-0.422 0.892-0.936 1.194-1.53 0.249-0.498 0.43-1.078 0.547-1.766h1.35v4.042h3.793v1.51h-3.793v4.604c0 1.068 0.052 1.64 0.176 1.961 0.131 0.363 0.384 0.66 0.75 0.882 0.929 0.571 2.225 0.502 3.397-0.042v1.347z"}}]})(props);
	};
	module.exports.TfiTwitterAlt = function TfiTwitterAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.253 5.038c0.011 0.151 0.011 0.302 0.011 0.454 0 4.605-3.506 9.912-9.913 9.912-1.974 0-3.808-0.572-5.351-1.564 0.281 0.032 0.551 0.042 0.842 0.042 1.629 0 3.127-0.55 4.325-1.488-1.532-0.032-2.815-1.036-3.257-2.417 0.215 0.032 0.431 0.054 0.656 0.054 0.314 0 0.627-0.043 0.918-0.118-1.596-0.324-2.794-1.726-2.794-3.419 0-0.011 0-0.033 0-0.043 0.464 0.258 1.003 0.42 1.575 0.442-0.938-0.626-1.553-1.694-1.553-2.901 0-0.647 0.173-1.241 0.475-1.759 1.715 2.115 4.293 3.496 7.184 3.646-0.055-0.259-0.087-0.529-0.087-0.799 0-1.919 1.554-3.483 3.484-3.483 1.003 0 1.909 0.42 2.546 1.1 0.787-0.151 1.541-0.442 2.211-0.841-0.259 0.809-0.809 1.489-1.532 1.919 0.702-0.075 1.381-0.269 2.007-0.539-0.475 0.69-1.068 1.306-1.747 1.802z"}}]})(props);
	};
	module.exports.TfiTwitter = function TfiTwitter (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 3.236c-0.626 0.27-1.305 0.464-2.007 0.539 0.723-0.431 1.273-1.11 1.532-1.919-0.669 0.399-1.424 0.69-2.211 0.841-0.636-0.68-1.542-1.1-2.545-1.1-1.931 0-3.484 1.564-3.484 3.483 0 0.27 0.033 0.54 0.086 0.799-2.891-0.15-5.469-1.531-7.184-3.646-0.302 0.517-0.475 1.111-0.475 1.759 0 1.208 0.615 2.275 1.553 2.901-0.571-0.022-1.111-0.184-1.575-0.442 0 0.010 0 0.032 0 0.043 0 1.692 1.197 3.095 2.794 3.419-0.291 0.075-0.604 0.118-0.917 0.118-0.226 0-0.442-0.021-0.657-0.054 0.442 1.381 1.726 2.384 3.257 2.417-1.198 0.938-2.697 1.488-4.326 1.488-0.291 0-0.561-0.010-0.841-0.042 1.543 0.992 3.376 1.564 5.351 1.564 6.407 0 9.913-5.307 9.913-9.912 0-0.152 0-0.302-0.010-0.454 0.678-0.496 1.271-1.112 1.746-1.802zM14.263 5.491c0 3.701-2.765 8.912-8.913 8.912-0.492 0-0.979-0.040-1.458-0.118 0.67-0.276 1.305-0.646 1.891-1.104 0.333-0.26 0.466-0.702 0.332-1.103-0.134-0.401-0.505-0.675-0.928-0.684-0.545-0.011-1.055-0.197-1.467-0.509 0.004-0.001 0.008-0.002 0.012-0.003 0.452-0.116 0.763-0.528 0.751-0.994-0.011-0.467-0.343-0.862-0.8-0.955-0.652-0.132-1.203-0.516-1.559-1.046 0.035 0.002 0.069 0.004 0.104 0.005 0.013 0 0.025 0 0.038 0 0.432 0 0.817-0.278 0.951-0.692 0.138-0.426-0.024-0.891-0.397-1.14-0.63-0.42-1.030-1.096-1.098-1.841 1.824 1.582 4.146 2.531 6.597 2.658 0.017 0.001 0.035 0.001 0.052 0.001 0.291 0 0.568-0.127 0.759-0.349 0.202-0.235 0.283-0.551 0.22-0.854-0.044-0.209-0.066-0.41-0.066-0.595 0-1.369 1.114-2.483 2.484-2.483 0.698 0 1.342 0.278 1.815 0.784 0.116 0.124 0.261 0.215 0.417 0.266-0.019 0.146-0.006 0.297 0.043 0.444 0.063 0.191 0.18 0.352 0.33 0.47-0.089 0.164-0.132 0.353-0.119 0.544 0.010 0.129 0.009 0.257 0.009 0.386z"}}]})(props);
	};
	module.exports.TfiUnderline = function TfiUnderline (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15 1v1h-1v6.459c0 3.032-2.467 5.5-5.5 5.5s-5.5-2.468-5.5-5.5v-6.459h-1v-1h3v1h-1v6.459c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5v-6.459h-1v-1h3zM2 16h13v-1h-13v1z"}}]})(props);
	};
	module.exports.TfiUnlink = function TfiUnlink (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2.134 5.139l1.402-2.587c1.086-1.648 3.262-2.095 4.871-1.029l-0.551 0.833c-1.149-0.759-2.703-0.44-3.464 0.709l-1.402 2.587c-0.781 1.188-0.464 2.742 0.687 3.501 1.143 0.752 2.41 0.547 3.313-0.538l0.768 0.641c-0.742 0.892-1.694 1.352-2.678 1.352-0.655 0-1.323-0.204-1.954-0.62-1.61-1.064-2.056-3.239-0.992-4.849zM4.041 8.034l-0.13 0.129 0.705 0.709 0.131-0.13c0.975-0.975 2.561-0.975 3.535 0s0.975 2.561 0 3.535l-3.023 3.024c-0.975 0.975-2.561 0.975-3.535 0s-0.975-2.561 0-3.535l1.058-1.059-0.707-0.707-1.058 1.060c-1.364 1.364-1.364 3.585 0 4.949 0.683 0.683 1.578 1.023 2.475 1.023s1.792-0.341 2.475-1.023l3.023-3.024c1.364-1.364 1.364-3.585 0-4.949-1.367-1.367-3.587-1.364-4.949-0.002zM10.963 7h4.074v-1h-4.074v1zM10.495 8.347l1.951 1.127 0.5-0.865-1.951-1.127-0.5 0.865zM10.75 1.156l-1.58 2.737 0.865 0.5 1.58-2.736-0.865-0.501zM15.867 2.725l-0.5-0.865-4.992 2.882 0.5 0.865 4.992-2.882z"}}]})(props);
	};
	module.exports.TfiUnlock = function TfiUnlock (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.5 10.972c0 0.366-0.207 0.672-0.5 0.846v2.154h-1v-2.153c-0.294-0.174-0.5-0.48-0.5-0.847 0-0.552 0.447-1 1-1 0.551 0 1 0.447 1 1zM14.994 8.46v7.080c0 0.827-0.673 1.5-1.5 1.5h-9.988c-0.827 0-1.5-0.673-1.5-1.5v-7.080c0-0.827 0.673-1.5 1.5-1.5h8.994v-1.988c0-2.206-1.794-4-4-4s-4 1.794-4 4h-1c0-2.757 2.243-5 5-5s5 2.243 5 5v1.988c0.824 0.004 1.494 0.675 1.494 1.5zM13.994 8.46c0-0.276-0.225-0.5-0.5-0.5h-9.988c-0.275 0-0.5 0.224-0.5 0.5v7.080c0 0.276 0.225 0.5 0.5 0.5h9.988c0.275 0 0.5-0.224 0.5-0.5v-7.080z"}}]})(props);
	};
	module.exports.TfiUpload = function TfiUpload (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 16v1h-17v-1h17zM7.999 1.708v11.292h1v-11.294l3.647 3.647 0.707-0.707-4.853-4.853-4.854 4.853 0.707 0.707 3.646-3.645z"}}]})(props);
	};
	module.exports.TfiUppercase = function TfiUppercase (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M7 4h1v2h-1v-1h-2v8h1v1h-3v-1h1v-8h-2v1h-1v-2h6zM15 4h-6v2h1v-1h2v8h-1v1h3v-1h-1v-8h2v1h1v-2h-1z"}}]})(props);
	};
	module.exports.TfiUser = function TfiUser (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 16.488c-0.063-2.687-2.778-4.999-6.521-5.609v-1.374c0.492-0.473 0.842-1.207 1.071-1.833 0.332-0.166 0.624-0.536 0.794-1.033 0.238-0.688 0.146-1.323-0.206-1.629 0.028-0.238 0.046-0.481 0.015-0.723-0.079-0.663 0.065-1.038 0.194-1.368 0.106-0.277 0.229-0.591 0.106-0.945-0.442-1.273-1.727-1.974-3.618-1.974l-0.264 0.005c-1.313 0.047-1.707 0.6-1.971 1.115-0.033 0.062-0.077 0.146-0.077 0.151-1.712 0.153-1.697 1.569-1.684 2.707l0.003 0.369c0 0.205 0.009 0.419 0.026 0.639-0.425 0.3-0.504 1.005-0.179 1.737 0.185 0.415 0.452 0.729 0.749 0.892 0.243 0.674 0.625 1.47 1.179 1.965v1.283c-3.798 0.589-6.554 2.907-6.617 5.625l-0.012 0.512h17.023l-0.011-0.512zM1.054 16c0.392-2.094 2.859-3.821 6.122-4.204l0.441-0.052v-2.666l-0.216-0.15c-0.393-0.272-0.791-0.947-1.090-1.851l-0.083-0.281-0.294-0.051c-0.053-0.019-0.208-0.153-0.33-0.428-0.075-0.168-0.104-0.312-0.112-0.415l0.51 0.143-0.096-0.749c-0.042-0.33-0.064-0.651-0.064-0.95l-0.003-0.38c-0.015-1.341 0.051-1.634 0.773-1.699 0.545-0.048 0.752-0.449 0.876-0.689 0.15-0.292 0.28-0.543 1.12-0.574l0.227-0.004c0.829 0 2.279 0.169 2.669 1.282 0 0.043-0.052 0.177-0.090 0.275-0.145 0.374-0.364 0.939-0.254 1.853 0.024 0.188-0.007 0.424-0.040 0.675l-0.089 0.805 0.441-0.048c0.008 0.104-0.004 0.269-0.075 0.472-0.097 0.289-0.242 0.438-0.237 0.454h-0.36l-0.114 0.342c-0.283 0.853-0.65 1.497-1.009 1.768l-0.198 0.15v2.726l0.438 0.055c3.211 0.401 5.641 2.123 6.030 4.192h-14.893z"}}]})(props);
	};
	module.exports.TfiVector = function TfiVector (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M14.94 6c-1.032-0.647-2.214-1-3.44-1-0.778 0-1.529 0.144-2.239 0.404l2.569-2.569c0.203 0.102 0.428 0.165 0.67 0.165 0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5-1.5 0.673-1.5 1.5c0 0.22 0.050 0.428 0.136 0.616l-3.91 3.909c-0.081-0.014-0.164-0.025-0.25-0.025-0.827 0-1.5 0.673-1.5 1.5 0 0.085 0.011 0.168 0.025 0.25l-3.386 3.386c-0.188-0.086-0.395-0.136-0.615-0.136-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5c0-0.242-0.063-0.467-0.165-0.669l2.57-2.57c-0.262 0.715-0.405 1.473-0.405 2.239 0 1.469 0.612 2.735 1 3.391v2.109h3v-3h-2.336c-0.418-0.826-0.664-1.713-0.664-2.5 0-0.887 0.22-1.764 0.628-2.545 0.113 0.027 0.228 0.045 0.348 0.045 0.827 0 1.5-0.673 1.5-1.5 0-0.18-0.037-0.35-0.095-0.51 1.644-1.131 3.847-1.268 5.619-0.373v2.383h3v-3h-2.060zM12.5 1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM1.5 13c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM7 15h1v1h-1v-1zM6.976 8c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM16 8h-1v-1h1v1z"}}]})(props);
	};
	module.exports.TfiVideoCamera = function TfiVideoCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M12.991 6.75v-2.25c0-0.827-0.678-1.5-1.512-1.5h-7.479v-0.5c0-0.276 0.225-0.5 0.5-0.5h5.541v-1h-5.541c-0.827 0-1.5 0.673-1.5 1.5v0.5h-1.488c-0.834 0-1.512 0.673-1.512 1.5v2.001c0 0.827 0.678 1.5 1.512 1.5h0.504v5.499c0 0.827 0.673 1.5 1.5 1.5h7.964c0.834 0 1.512-0.673 1.512-1.5v-2.251l4.008 2.783v-10.065l-4.009 2.783zM16 12.121l-4.009-2.783v4.162c0 0.276-0.229 0.5-0.512 0.5h-7.963c-0.275 0-0.5-0.224-0.5-0.5v-6.499h-1.504c-0.283 0-0.512-0.224-0.512-0.5v-2.001c0-0.276 0.229-0.5 0.512-0.5h9.968c0.282 0 0.512 0.224 0.512 0.5v4.163l4.008-2.784v6.242z"}}]})(props);
	};
	module.exports.TfiVideoClapper = function TfiVideoClapper (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 1v15h17v-15h-17zM16 4h-0.268l-2.356-2h2.624v2zM8.743 7l2.357-2h2.919l-2.357 2h-2.919zM6.803 4l-2.357-2h2.918l2.357 2h-2.918zM9.554 5l-2.357 2h-2.919l2.356-2h2.92zM11.268 4l-2.357-2h2.918l2.357 2h-2.918zM1 2h1.9l2.357 2h-4.257v-2zM1 5h4.089l-2.357 2h-1.732v-2zM16 15h-15v-7h15v7zM16 7h-2.792l2.356-2h0.436v2z"}}]})(props);
	};
	module.exports.TfiViewGrid = function TfiViewGrid (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 7h7v-7h-7v7zM1 1h5v5h-5v-5zM10 0v7h7v-7h-7zM16 6h-5v-5h5v5zM0 17h7v-7h-7v7zM1 11h5v5h-5v-5zM10 17h7v-7h-7v7zM11 11h5v5h-5v-5z"}}]})(props);
	};
	module.exports.TfiViewListAlt = function TfiViewListAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M5 0v4h12v-4h-12zM16 3h-10v-2h10v2zM5 10h12v-4h-12v4zM6 7h10v2h-10v-2zM5 16h12v-4h-12v4zM6 13h10v2h-10v-2zM0 4h4v-4h-4v4zM1 1h2v2h-2v-2zM0 10h4v-4h-4v4zM1 7h2v2h-2v-2zM0 16h4v-4h-4v4zM1 13h2v2h-2v-2z"}}]})(props);
	};
	module.exports.TfiViewList = function TfiViewList (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 0v4h17v-4h-17zM16 3h-15v-2h15v2zM0 10h17v-4h-17v4zM1 7h15v2h-15v-2zM0 16h17v-4h-17v4zM1 13h15v2h-15v-2z"}}]})(props);
	};
	module.exports.TfiVimeoAlt = function TfiVimeoAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.132 2.301c-0.58-0.736-1.796-0.764-2.645-0.637-0.68 0.113-2.998 1.131-3.777 3.579 1.387-0.113 2.12 0.101 1.98 1.627-0.058 0.65-0.383 1.344-0.736 2.024-0.426 0.776-1.201 2.305-2.235 1.201-0.919-0.99-0.863-2.885-1.060-4.144-0.129-0.708-0.255-1.585-0.482-2.32-0.199-0.623-0.666-1.371-1.216-1.542-0.608-0.171-1.359 0.099-1.797 0.353-1.389 0.822-2.306 1.982-3.664 2.943v0.1c0.452 0.227 0.312 0.594 0.665 0.651 0.835 0.112 1.625-0.78 2.179 0.154 0.339 0.565 0.438 1.188 0.649 1.798 0.296 0.819 0.511 1.711 0.75 2.645 0.396 1.6 0.878 3.975 2.263 4.557 0.695 0.297 1.756-0.1 2.279-0.426 1.441-0.85 2.59-2.080 3.536-3.352 2.221-2.973 3.424-6.367 3.608-7.343 0.127-0.666 0.113-1.345-0.297-1.868z"}}]})(props);
	};
	module.exports.TfiVimeo = function TfiVimeo (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M15.664 2.69c-0.416-0.528-1.13-0.808-2.063-0.808-0.264 0-0.521 0.023-0.758 0.059-0.869 0.146-3.019 1.232-3.746 3.518-0.051 0.158-0.019 0.332 0.085 0.463 0.104 0.13 0.269 0.201 0.433 0.187 0.562-0.045 0.982-0.012 1.112 0.133 0.104 0.113 0.142 0.386 0.106 0.768-0.046 0.51-0.333 1.099-0.634 1.675-0.145 0.264-0.588 1.075-0.862 1.075-0.065 0-0.169-0.069-0.276-0.184-0.514-0.555-0.62-1.613-0.711-2.548-0.032-0.308-0.061-0.602-0.104-0.88l-0.069-0.391c-0.095-0.55-0.203-1.173-0.374-1.729-0.206-0.644-0.699-1.474-1.421-1.698-0.156-0.044-0.326-0.066-0.503-0.066-0.688 0-1.306 0.329-1.481 0.431-0.733 0.435-1.326 0.968-1.9 1.484-0.433 0.388-0.88 0.791-1.386 1.148-0.132 0.094-0.211 0.335-0.211 0.497 0 0.189 0.106 0.362 0.276 0.447 0.056 0.029 0.064 0.042 0.109 0.13 0.072 0.14 0.221 0.429 0.64 0.496 0.371 0.055 0.719-0.054 1.008-0.145 0.157-0.050 0.306-0.096 0.403-0.096 0.035 0 0.076 0 0.159 0.139 0.173 0.289 0.268 0.619 0.368 0.969 0.052 0.178 0.103 0.356 0.166 0.54 0.222 0.611 0.392 1.278 0.571 1.984l0.157 0.627c0.358 1.475 0.849 3.493 2.219 4.068 0.207 0.088 0.443 0.133 0.703 0.133 0.669 0 1.377-0.294 1.77-0.54 1.166-0.687 2.241-1.702 3.284-3.104 1.911-2.558 3.088-5.64 3.293-6.722 0.163-0.866 0.045-1.54-0.363-2.060zM15.045 4.564c-0.146 0.768-1.153 3.688-3.112 6.309-0.963 1.295-1.94 2.224-3.001 2.849-0.394 0.246-1.187 0.501-1.564 0.341-0.907-0.381-1.329-2.116-1.637-3.384l-0.161-0.639c-0.185-0.729-0.361-1.419-0.596-2.070-0.056-0.16-0.102-0.322-0.149-0.482-0.113-0.395-0.231-0.804-0.471-1.204-0.246-0.416-0.588-0.627-1.017-0.627-0.251 0-0.48 0.072-0.702 0.142-0.159 0.050-0.31 0.097-0.479 0.107-0.013-0.023-0.027-0.050-0.044-0.078 0.378-0.298 0.72-0.605 1.054-0.906 0.562-0.506 1.093-0.983 1.738-1.365 0.232-0.135 0.626-0.293 0.975-0.293 0.086 0 0.164 0.010 0.22 0.025 0.256 0.079 0.593 0.547 0.75 1.038 0.151 0.49 0.253 1.080 0.342 1.601l0.069 0.387c0.039 0.247 0.065 0.523 0.095 0.812 0.107 1.092 0.23 2.328 0.975 3.131 0.312 0.333 0.651 0.502 1.008 0.502 0.868 0 1.393-0.962 1.784-1.68 0.311-0.597 0.646-1.291 0.708-1.98 0.064-0.704-0.051-1.19-0.363-1.533-0.314-0.345-0.761-0.444-1.138-0.471 0.808-1.539 2.363-2.115 2.671-2.167 0.184-0.027 0.39-0.046 0.602-0.046 0.353 0 0.986 0.056 1.277 0.426 0.218 0.279 0.272 0.689 0.166 1.255z"}}]})(props);
	};
	module.exports.TfiVolume = function TfiVolume (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M3.587 5.933c-0.956 0-1.55 0.5-1.55 1.306v2.161c0 0.415 0.161 0.804 0.453 1.098 0.292 0.293 0.682 0.455 1.097 0.455h1.743l5.686 5.688v-16.429l-5.63 5.721h-1.799zM10.016 2.654v11.572l-4.272-4.273h-2.158c-0.303 0-0.549-0.248-0.549-0.553v-2.161c0-0.091 0-0.306 0.55-0.306h2.217l4.212-4.279zM12.005 10.987v-1c0.556 0 1.008-0.452 1.008-1.008s-0.452-1.008-1.008-1.008v-1c1.107 0 2.008 0.901 2.008 2.008s-0.901 2.008-2.008 2.008zM16.029 8.987c0 2.206-1.794 4-4 4v-1c1.654 0 3-1.346 3-3s-1.346-3-3-3v-1c2.205 0 4 1.795 4 4z"}}]})(props);
	};
	module.exports.TfiWallet = function TfiWallet (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M1.564 2c-0.854 0-1.55 0.69-1.55 1.538h-0.014v10.939c0 0.848 0.695 1.538 1.55 1.538h13.492v-1.655h1.958v-12.36h-15.436zM1.55 15.014c-0.303 0-0.55-0.241-0.55-0.538v-9.583c0.024 0.007 0.054 0.005 0.078 0.012 0.143 0.042 0.293 0.068 0.453 0.071 0.007 0 0.012 0.003 0.019 0.003h12.493v3.035h-2.859c-0.862 0-1.563 0.673-1.563 1.5v1c0 0.827 0.701 1.5 1.563 1.5h2.859v3h-12.493zM11.183 11.014c-0.311 0-0.563-0.224-0.563-0.5v-1c0-0.276 0.253-0.5 0.563-0.5h4.817v2h-4.817zM16 13.359h-0.958v-1.345h0.958v1.345zM15.042 8.014v-4.035h-13.478c-0.273 0-0.55-0.137-0.55-0.441 0.001-0.297 0.248-0.538 0.55-0.538h14.436v5.014h-0.958z"}}]})(props);
	};
	module.exports.TfiWand = function TfiWand (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M17 5h-3.293l2.328 2.328-0.707 0.707-2.328-2.328v3.293h-1v-3.286l-10.646 10.665-0.707-0.707 10.653-10.672h-3.3v-1h3.293l-2.328-2.328 0.707-0.707 2.328 2.328v-3.293h1v3.297l2.287-2.291 0.707 0.707-2.283 2.287h3.289v1z"}}]})(props);
	};
	module.exports.TfiWheelchair = function TfiWheelchair (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M10.901 12.85l0.977 0.213c-0.505 2.318-2.511 3.937-4.878 3.937-2.757 0-5-2.243-5-5 0-2.27 1.531-4.259 3.725-4.836l0.254 0.967c-1.754 0.462-2.979 2.053-2.979 3.869 0 2.206 1.794 4 4 4 1.893 0 3.497-1.295 3.901-3.15zM16 15.121v1h-1.868l-0.955-4.118h-6.158l-0.544-8.082c-0.847-0.233-1.475-1.001-1.475-1.921 0-1.103 0.897-2 2-2s2 0.897 2 2c0 0.938-0.65 1.72-1.521 1.936l0.27 4.011 3.632-0.901 0.24 0.971-3.805 0.943 0.138 2.042h6.018l0.955 4.118h1.073zM7 3c0.552 0 1-0.449 1-1s-0.448-1-1-1-1 0.449-1 1 0.448 1 1 1z"}}]})(props);
	};
	module.exports.TfiWidgetAlt = function TfiWidgetAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2 0h1v1h-1v-1zM5 0h-1v1h1v-1zM7 0h-1v1h1v-1zM9 0h-1v1h1v-1zM11 0h-1v1h1v-1zM13 0h-1v1h1v-1zM14 1h1v-1h-1v1zM2 17h1v-1h-1v1zM4 17h1v-1h-1v1zM6 17h1v-1h-1v1zM8 17h1v-1h-1v1zM10 17h1v-1h-1v1zM12 17h1v-1h-1v1zM14 17h1v-1h-1v1zM16 0v1h1v-1h-1zM16 3h1v-1h-1v1zM16 5h1v-1h-1v1zM16 7h1v-1h-1v1zM16 9h1v-1h-1v1zM16 11h1v-1h-1v1zM16 13h1v-1h-1v1zM16 15h1v-1h-1v1zM16 17h1v-1h-1v1zM0 1h1v-1h-1v1zM0 3h1v-1h-1v1zM0 5h1v-1h-1v1zM0 7h1v-1h-1v1zM0 9h1v-1h-1v1zM0 11h1v-1h-1v1zM0 13h1v-1h-1v1zM0 15h1v-1h-1v1zM0 17h1v-1h-1v1zM8.498 10.043l-4.144-4.147-0.708 0.708 4.852 4.854 4.855-4.854-0.707-0.707-4.148 4.146z"}}]})(props);
	};
	module.exports.TfiWidget = function TfiWidget (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2 0h1v1h-1v-1zM5 0h-1v1h1v-1zM7 0h-1v1h1v-1zM9 0h-1v1h1v-1zM11 0h-1v1h1v-1zM13 0h-1v1h1v-1zM14 1h1v-1h-1v1zM2 17h1v-1h-1v1zM4 17h1v-1h-1v1zM6 17h1v-1h-1v1zM8 17h1v-1h-1v1zM10 17h1v-1h-1v1zM12 17h1v-1h-1v1zM14 17h1v-1h-1v1zM16 0v1h1v-1h-1zM16 3h1v-1h-1v1zM16 5h1v-1h-1v1zM16 7h1v-1h-1v1zM16 9h1v-1h-1v1zM16 11h1v-1h-1v1zM16 13h1v-1h-1v1zM16 15h1v-1h-1v1zM16 17h1v-1h-1v1zM0 1h1v-1h-1v1zM0 3h1v-1h-1v1zM0 5h1v-1h-1v1zM0 7h1v-1h-1v1zM0 9h1v-1h-1v1zM0 11h1v-1h-1v1zM0 13h1v-1h-1v1zM0 15h1v-1h-1v1zM0 17h1v-1h-1v1zM13.465 7.929c0.021 0.187 0.035 0.377 0.035 0.571s-0.014 0.384-0.035 0.571l-0.037 0.328-1.439 0.432c-0.025 0.065-0.051 0.129-0.080 0.193l0.711 1.322-0.205 0.258c-0.238 0.299-0.511 0.572-0.811 0.811l-0.258 0.206-1.322-0.712c-0.063 0.028-0.128 0.055-0.193 0.080l-0.431 1.438-0.327 0.038c-0.188 0.022-0.379 0.035-0.573 0.035s-0.385-0.013-0.573-0.035l-0.327-0.038-0.432-1.438c-0.065-0.025-0.129-0.051-0.193-0.080l-1.323 0.711-0.258-0.205c-0.299-0.238-0.572-0.511-0.81-0.811l-0.204-0.257 0.711-1.322c-0.029-0.065-0.055-0.129-0.080-0.194l-1.439-0.432-0.037-0.328c-0.021-0.187-0.035-0.377-0.035-0.571s0.014-0.384 0.035-0.571l0.037-0.328 1.439-0.432c0.025-0.065 0.051-0.129 0.080-0.193l-0.711-1.322 0.204-0.258c0.237-0.298 0.51-0.571 0.811-0.811l0.258-0.206 1.322 0.712c0.063-0.029 0.128-0.055 0.193-0.080l0.432-1.438 0.327-0.038c0.376-0.044 0.77-0.044 1.146 0l0.327 0.038 0.432 1.438c0.065 0.024 0.129 0.051 0.193 0.080l1.322-0.712 0.258 0.206c0.299 0.238 0.572 0.511 0.81 0.81l0.205 0.258-0.711 1.323c0.028 0.063 0.055 0.128 0.080 0.192l1.439 0.433 0.037 0.328zM12.5 8.5c0-0.045-0.001-0.090-0.003-0.135l-1.303-0.391-0.076-0.26c-0.052-0.175-0.123-0.348-0.211-0.512l-0.127-0.237 0.642-1.193c-0.062-0.066-0.126-0.131-0.193-0.193l-1.192 0.642-0.239-0.128c-0.164-0.088-0.337-0.16-0.513-0.212l-0.26-0.077-0.39-1.301c-0.089-0.004-0.181-0.004-0.27 0l-0.39 1.302-0.26 0.077c-0.178 0.053-0.35 0.124-0.512 0.211l-0.237 0.129-1.194-0.643c-0.067 0.063-0.131 0.127-0.193 0.193l0.642 1.193-0.128 0.237c-0.088 0.164-0.16 0.336-0.212 0.514l-0.077 0.259-1.301 0.39c-0.002 0.045-0.003 0.090-0.003 0.135s0.001 0.090 0.003 0.134l1.302 0.391 0.077 0.26c0.052 0.177 0.124 0.35 0.212 0.514l0.127 0.237-0.642 1.193c0.062 0.066 0.126 0.131 0.193 0.193l1.193-0.642 0.237 0.127c0.164 0.088 0.337 0.16 0.513 0.212l0.26 0.077 0.391 1.302c0.089 0.004 0.181 0.004 0.27 0l0.391-1.301 0.259-0.077c0.177-0.052 0.35-0.124 0.514-0.212l0.237-0.127 1.192 0.642c0.067-0.062 0.131-0.127 0.193-0.193l-0.642-1.193 0.127-0.237c0.088-0.164 0.16-0.336 0.212-0.514l0.077-0.259 1.301-0.391c0.002-0.046 0.003-0.091 0.003-0.136z"}}]})(props);
	};
	module.exports.TfiWidgetized = function TfiWidgetized (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M2 0h1v1h-1v-1zM4 1h1v-1h-1v1zM6 1h1v-1h-1v1zM8 1h1v-1h-1v1zM10 1h1v-1h-1v1zM12 1h1v-1h-1v1zM14 1h1v-1h-1v1zM2 9h1v-1h-1v1zM4 9h1v-1h-1v1zM6 9h1v-1h-1v1zM10 9h1v-1h-1v1zM12 9h1v-1h-1v1zM14 9h1v-1h-1v1zM2 17h1v-1h-1v1zM4 17h1v-1h-1v1zM6 17h1v-1h-1v1zM8 17h1v-1h-1v1zM10 17h1v-1h-1v1zM12 17h1v-1h-1v1zM14 17h1v-1h-1v1zM16 0v1h1v-1h-1zM16 3h1v-1h-1v1zM16 5h1v-1h-1v1zM16 7h1v-1h-1v1zM16 9h1v-1h-1v1zM16 11h1v-1h-1v1zM16 13h1v-1h-1v1zM16 15h1v-1h-1v1zM8 3h1v-1h-1v1zM8 5h1v-1h-1v1zM8 7h1v-1h-1v1zM8 9h1v-1h-1v1zM8 11h1v-1h-1v1zM8 13h1v-1h-1v1zM8 15h1v-1h-1v1zM16 17h1v-1h-1v1zM0 1h1v-1h-1v1zM0 3h1v-1h-1v1zM0 5h1v-1h-1v1zM0 7h1v-1h-1v1zM0 9h1v-1h-1v1zM0 11h1v-1h-1v1zM0 13h1v-1h-1v1zM0 15h1v-1h-1v1zM0 17h1v-1h-1v1z"}}]})(props);
	};
	module.exports.TfiWindow = function TfiWindow (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M0 1v15h17v-15h-17zM16 2v3h-15v-3h15zM1 15v-9h15v9h-15zM7 4h-1v-1h1v1zM5 4h-1v-1h1v1zM3 4h-1v-1h1v1z"}}]})(props);
	};
	module.exports.TfiWordpress = function TfiWordpress (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.5 8.5c0 4.41-3.589 8-8 8s-8-3.59-8-8 3.589-8 8-8 8 3.59 8 8zM16.134 8.5c0-4.205-3.428-7.634-7.634-7.634s-7.634 3.429-7.634 7.634 3.428 7.634 7.634 7.634 7.634-3.429 7.634-7.634zM2.232 5.705l3.277 8.974c-2.295-1.117-3.875-3.465-3.875-6.179 0-0.99 0.215-1.938 0.598-2.795zM12.607 10.375l-0.679 2.286-2.482-7.374c0 0 0.411-0.027 0.786-0.072 0.366-0.045 0.322-0.59-0.044-0.562-1.116 0.080-1.831 0.089-1.831 0.089s-0.669-0.010-1.803-0.090c-0.375-0.027-0.42 0.535-0.045 0.562 0.348 0.036 0.714 0.073 0.714 0.073l1.071 2.928-1.5 4.5-2.5-7.428c0 0 0.411-0.027 0.786-0.072 0.366-0.045 0.322-0.59-0.044-0.562-1.108 0.080-1.831 0.089-1.831 0.089-0.125 0-0.276-0.009-0.437-0.009 1.223-1.867 3.33-3.099 5.732-3.099 1.786 0 3.411 0.688 4.634 1.804-0.027 0-0.062 0-0.089 0-0.67 0-1.152 0.581-1.152 1.215 0 0.562 0.33 1.036 0.678 1.606 0.269 0.456 0.562 1.045 0.562 1.894 0.001 0.587-0.239 1.267-0.526 2.222zM10.731 14.876c0.009 0.035 0.027 0.070 0.045 0.098-0.714 0.25-1.473 0.393-2.277 0.393-0.669 0-1.321-0.1-1.938-0.286l2.054-5.981 2.116 5.776zM15.366 8.5c0 2.535-1.375 4.741-3.42 5.929l2.098-6.054c0.348-1.001 0.527-1.767 0.527-2.465 0-0.249-0.018-0.482-0.054-0.705 0.537 0.982 0.849 2.099 0.849 3.295z"}}]})(props);
	};
	module.exports.TfiWorld = function TfiWorld (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.516 0c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.814-8.5-8.5-8.5zM1.041 9h2.937c0.044 1.024 0.211 2.031 0.513 3h-2.603c-0.481-0.906-0.776-1.923-0.847-3zM3.978 8h-2.937c0.071-1.077 0.366-2.094 0.847-3h2.6c-0.301 0.969-0.467 1.976-0.51 3zM5.547 5h5.896c0.33 0.965 0.522 1.972 0.569 3h-7.034c0.046-1.028 0.239-2.035 0.569-3zM4.978 9h7.035c-0.049 1.028-0.241 2.035-0.572 3h-5.891c-0.331-0.965-0.524-1.972-0.572-3zM13.013 9h2.978c-0.071 1.077-0.366 2.094-0.847 3h-2.644c0.302-0.969 0.469-1.976 0.513-3zM13.013 8c-0.043-1.024-0.209-2.031-0.51-3h2.641c0.48 0.906 0.775 1.923 0.847 3h-2.978zM14.502 4h-2.354c-0.392-0.955-0.916-1.858-1.55-2.7 1.578 0.457 2.938 1.42 3.904 2.7zM9.074 1.028c0.824 0.897 1.484 1.9 1.972 2.972h-5.102c0.487-1.071 1.146-2.073 1.97-2.97 0.199-0.015 0.398-0.030 0.602-0.030 0.188 0 0.373 0.015 0.558 0.028zM6.383 1.313c-0.629 0.838-1.151 1.737-1.54 2.687h-2.314c0.955-1.267 2.297-2.224 3.854-2.687zM2.529 13h2.317c0.391 0.951 0.915 1.851 1.547 2.689-1.561-0.461-2.907-1.419-3.864-2.689zM7.926 15.97c-0.826-0.897-1.488-1.899-1.978-2.97h5.094c-0.49 1.072-1.152 2.075-1.979 2.972-0.181 0.013-0.363 0.028-0.547 0.028-0.2 0-0.395-0.015-0.59-0.030zM10.587 15.703c0.636-0.842 1.164-1.747 1.557-2.703h2.358c-0.968 1.283-2.332 2.247-3.915 2.703z"}}]})(props);
	};
	module.exports.TfiWrite = function TfiWrite (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M11.667 0h-8.651v1.984h-0.516c-0.827 0-1.5 0.673-1.5 1.5v8.588l2.521 4.956 2.464-4.959v-8.585c0-0.827-0.673-1.5-1.5-1.5h-0.469v-0.984h6.984v5h5v10h-11.5v1h12.5v-11.692l-5.333-5.308zM3.908 14.002h-0.804l-1.104-2.17v-5.848h1v6.027h1v-6.027h0.984v5.851l-1.076 2.167zM4.984 3.484v1.5h-2.984v-1.5c0-0.275 0.225-0.5 0.5-0.5h1.984c0.276 0 0.5 0.225 0.5 0.5zM12 1.742l3.273 3.258h-3.273v-3.258z"}}]})(props);
	};
	module.exports.TfiYahoo = function TfiYahoo (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.5 16.5c-0.327-0.058-0.664-0.105-1.010-0.105-0.336 0-0.673 0.048-1.009 0.105l0.125-6.799c-1.789-3.086-3.472-6.229-5.442-9.201 0.336 0.087 0.682 0.144 1.038 0.144s0.721-0.068 1.067-0.144c1.346 2.386 2.808 4.702 4.221 7.048 1.423-2.327 2.933-4.644 4.222-7.048 0.336 0.087 0.683 0.135 1.028 0.135 0.366 0 0.741-0.048 1.096-0.135-0.77 1.058-1.404 2.211-2.067 3.336-1.145 1.952-2.27 3.905-3.395 5.865l0.126 6.799z"}}]})(props);
	};
	module.exports.TfiYoutube = function TfiYoutube (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M8.301 6.422c0.437 0 0.769-0.161 1.006-0.484 0.181-0.237 0.265-0.617 0.265-1.12v-1.66c0-0.503-0.084-0.873-0.265-1.11-0.238-0.321-0.57-0.483-1.006-0.483-0.428 0-0.76 0.161-0.995 0.483-0.181 0.238-0.266 0.608-0.266 1.111v1.66c0 0.503 0.085 0.873 0.266 1.12 0.235 0.322 0.567 0.483 0.995 0.483zM7.893 2.988c0-0.436 0.133-0.654 0.408-0.654 0.285 0 0.408 0.218 0.408 0.654v1.992c0 0.437-0.123 0.664-0.408 0.664-0.275 0-0.408-0.228-0.408-0.664v-1.992zM10.35 6.071c-0.048-0.143-0.075-0.37-0.075-0.711v-3.738h0.863v3.481c0 0.2 0 0.313 0.010 0.333 0.019 0.133 0.085 0.208 0.199 0.208 0.17 0 0.35-0.133 0.54-0.408v-3.614h0.863v4.734h-0.863v-0.522c-0.341 0.398-0.663 0.588-0.978 0.588-0.275 0-0.474-0.113-0.559-0.351zM13.633 11.811v0.436h-0.854v-0.436c0-0.427 0.143-0.646 0.427-0.646 0.284 0.001 0.427 0.219 0.427 0.646zM4.354 1.774c-0.208-0.588-0.416-1.186-0.617-1.774h1.007l0.673 2.495 0.645-2.495h0.968l-1.148 3.785v2.571h-0.948v-2.571c-0.086-0.465-0.276-1.129-0.58-2.011zM15.283 8.785c-0.171-0.75-0.788-1.3-1.518-1.385-1.746-0.19-3.511-0.19-5.266-0.19s-3.52 0-5.256 0.19c-0.738 0.085-1.346 0.635-1.526 1.385-0.237 1.062-0.247 2.22-0.247 3.32 0 1.091 0 2.257 0.247 3.32 0.171 0.75 0.788 1.3 1.518 1.376 1.745 0.199 3.51 0.199 5.265 0.199s3.52 0 5.266-0.199c0.729-0.076 1.337-0.626 1.518-1.376 0.237-1.062 0.247-2.229 0.247-3.32-0.001-1.1-0.001-2.258-0.248-3.32zM5.483 9.743h-1.014v5.398h-0.949v-5.398h-0.997v-0.892h2.96v0.892zM8.045 15.141h-0.845v-0.512c-0.342 0.389-0.664 0.579-0.968 0.579-0.274 0-0.474-0.114-0.55-0.351-0.048-0.142-0.076-0.361-0.076-0.692v-3.709h0.845v3.453c0 0.2 0 0.304 0.009 0.333 0.020 0.132 0.086 0.199 0.199 0.199 0.172 0 0.352-0.132 0.541-0.398v-3.586h0.845v4.684zM11.271 13.737c0 0.437-0.020 0.749-0.086 0.948-0.104 0.342-0.342 0.522-0.674 0.522-0.303 0-0.598-0.171-0.883-0.522v0.456h-0.843v-6.29h0.843v2.059c0.275-0.342 0.57-0.512 0.883-0.512 0.332 0 0.57 0.18 0.674 0.531 0.066 0.19 0.086 0.502 0.086 0.939v1.869zM14.477 12.959h-1.698v0.825c0 0.437 0.143 0.654 0.437 0.654 0.209 0 0.332-0.113 0.38-0.341 0.009-0.047 0.019-0.237 0.019-0.579h0.863v0.124c0 0.275 0 0.465-0.019 0.55-0.020 0.189-0.096 0.36-0.199 0.512-0.229 0.332-0.579 0.503-1.024 0.503-0.446 0-0.779-0.161-1.025-0.484-0.18-0.228-0.275-0.598-0.275-1.101v-1.641c0-0.503 0.086-0.863 0.266-1.101 0.247-0.323 0.579-0.484 1.016-0.484 0.428 0 0.759 0.161 1.005 0.484 0.172 0.237 0.257 0.597 0.257 1.101v0.978zM10.426 11.801v2.002c0 0.427-0.124 0.635-0.37 0.635-0.143 0-0.285-0.066-0.428-0.208v-2.855c0.143-0.143 0.285-0.209 0.428-0.209 0.246 0 0.37 0.218 0.37 0.635z"}}]})(props);
	};
	module.exports.TfiZip = function TfiZip (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M9.667 0h-7.667v17h13v-11.692l-5.333-5.308zM10 1.742l3.273 3.258h-3.273v-3.258zM3 16v-15h3v1h1v-1h2v5h5v10h-11zM5 8h1v1h-1v-1zM6 8v-1h1v1h-1zM6 6v-1h1v1h-1zM5 6h1v1h-1v-1zM5 4h1v1h-1v-1zM6 4v-1h1v1h-1zM5 2h1v1h-1v-1zM6 9.389c-1.103 0-2 0.897-2 2s0.897 2 2 2c0.062 0 0.121-0.007 0.219-0.020 0.646-0.071 1.218-0.455 1.531-1.026 0.166-0.303 0.25-0.624 0.25-0.954 0-1.103-0.897-2-2-2zM6.873 11.864c-0.156 0.285-0.441 0.477-0.762 0.512l-0.112 0.014c-0.551 0-0.999-0.449-0.999-1s0.449-1 1-1 1 0.449 1 1c0 0.159-0.043 0.319-0.127 0.474z"}}]})(props);
	};
	module.exports.TfiZoomIn = function TfiZoomIn (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.604 15.896l-5.173-5.173c0.975-1.137 1.569-2.61 1.569-4.223 0-3.584-2.916-6.5-6.5-6.5-1.737 0-3.369 0.676-4.597 1.904-1.228 1.227-1.903 2.86-1.903 4.596 0 3.584 2.916 6.5 6.5 6.5 1.612 0 3.086-0.594 4.224-1.569l5.173 5.173 0.707-0.708zM6.5 12c-3.033 0-5.5-2.467-5.5-5.5 0-1.47 0.571-2.851 1.61-3.89 1.039-1.038 2.42-1.61 3.89-1.61 3.033 0 5.5 2.467 5.5 5.5 0 3.033-2.467 5.5-5.5 5.5zM7 6h2v1h-2v2h-1v-2h-2v-1h2v-2h1v2z"}}]})(props);
	};
	module.exports.TfiZoomOut = function TfiZoomOut (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 17 17"},"child":[{"tag":"g","attr":{},"child":[]},{"tag":"path","attr":{"d":"M16.604 15.868l-5.173-5.173c0.975-1.137 1.569-2.611 1.569-4.223 0-3.584-2.916-6.5-6.5-6.5-1.736 0-3.369 0.676-4.598 1.903-1.227 1.228-1.903 2.861-1.902 4.597 0 3.584 2.916 6.5 6.5 6.5 1.612 0 3.087-0.594 4.224-1.569l5.173 5.173 0.707-0.708zM6.5 11.972c-3.032 0-5.5-2.467-5.5-5.5-0.001-1.47 0.571-2.851 1.61-3.889 1.038-1.039 2.42-1.611 3.89-1.611 3.032 0 5.5 2.467 5.5 5.5 0 3.032-2.468 5.5-5.5 5.5zM4 5.972h5v1h-5v-1z"}}]})(props);
	};


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(24);
	var Modal = __webpack_require__(972);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
	var Modal__default = /*#__PURE__*/_interopDefaultLegacy(Modal);
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;
	
	  try {
	    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();
	
	  return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;
	
	    if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;
	
	      result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }
	
	    return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
	}
	
	function _iterableToArrayLimit(arr, i) {
	  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
	
	  if (_i == null) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	
	  var _s, _e;
	
	  try {
	    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	
	  return arr2;
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	/**
	 * Placeholder for future translate functionality
	 */
	function translate(str) {
	  var replaceStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  if (!str) {
	    return '';
	  }
	
	  var translated = str;
	
	  if (replaceStrings) {
	    Object.keys(replaceStrings).forEach(function (placeholder) {
	      translated = translated.replace(placeholder, replaceStrings[placeholder]);
	    });
	  }
	
	  return translated;
	}
	function getWindowWidth() {
	  return typeof global.window !== 'undefined' ? global.window.innerWidth : 0;
	}
	function getWindowHeight() {
	  return typeof global.window !== 'undefined' ? global.window.innerHeight : 0;
	}
	
	var isCrossOriginFrame = function isCrossOriginFrame() {
	  try {
	    return global.window.location.hostname !== global.window.parent.location.hostname;
	  } catch (e) {
	    return true;
	  }
	}; // Get the highest window context that isn't cross-origin
	// (When in an iframe)
	
	
	function getHighestSafeWindowContext() {
	  var self = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : global.window.self;
	
	  // If we reached the top level, return self
	  if (self === global.window.top) {
	    return self;
	  } // If parent is the same origin, we can move up one context
	  // Reference: https://stackoverflow.com/a/21965342/1601953
	
	
	  if (!isCrossOriginFrame()) {
	    return getHighestSafeWindowContext(self.parent);
	  } // If a different origin, we consider the current level
	  // as the top reachable one
	
	
	  return self;
	}
	
	// Min image zoom level
	var MIN_ZOOM_LEVEL = 0; // Max image zoom level
	
	var MAX_ZOOM_LEVEL = 300; // Size ratio between previous and next zoom levels
	
	var ZOOM_RATIO = 1.007; // How much to increase/decrease the zoom level when the zoom buttons are clicked
	
	var ZOOM_BUTTON_INCREMENT_SIZE = 100; // Used to judge the amount of horizontal scroll needed to initiate a image move
	
	var WHEEL_MOVE_X_THRESHOLD = 200; // Used to judge the amount of vertical scroll needed to initiate a zoom action
	
	var WHEEL_MOVE_Y_THRESHOLD = 1;
	var KEYS = {
	  ESC: 27,
	  LEFT_ARROW: 37,
	  RIGHT_ARROW: 39
	}; // Actions
	
	var ACTION_NONE = 0;
	var ACTION_MOVE = 1;
	var ACTION_SWIPE = 2;
	var ACTION_PINCH = 3;
	
	var SOURCE_ANY = 0;
	var SOURCE_MOUSE = 1;
	var SOURCE_TOUCH = 2;
	var SOURCE_POINTER = 3; // Minimal swipe distance
	
	var MIN_SWIPE_DISTANCE = 200;
	
	var ReactImageLightbox = /*#__PURE__*/function (_Component) {
	  _inherits(ReactImageLightbox, _Component);
	
	  var _super = _createSuper(ReactImageLightbox);
	
	  function ReactImageLightbox(props) {
	    var _this;
	
	    _classCallCheck(this, ReactImageLightbox);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      //-----------------------------
	      // Animation
	      //-----------------------------
	      // Lightbox is closing
	      // When Lightbox is mounted, if animation is enabled it will open with the reverse of the closing animation
	      isClosing: !props.animationDisabled,
	      // Component parts should animate (e.g., when images are moving, or image is being zoomed)
	      shouldAnimate: false,
	      //-----------------------------
	      // Zoom settings
	      //-----------------------------
	      // Zoom level of image
	      zoomLevel: MIN_ZOOM_LEVEL,
	      //-----------------------------
	      // Image position settings
	      //-----------------------------
	      // Horizontal offset from center
	      offsetX: 0,
	      // Vertical offset from center
	      offsetY: 0,
	      // image load error for srcType
	      loadErrorStatus: {}
	    }; // Refs
	
	    _this.outerEl = /*#__PURE__*/React__default['default'].createRef();
	    _this.zoomInBtn = /*#__PURE__*/React__default['default'].createRef();
	    _this.zoomOutBtn = /*#__PURE__*/React__default['default'].createRef();
	    _this.caption = /*#__PURE__*/React__default['default'].createRef();
	    _this.closeIfClickInner = _this.closeIfClickInner.bind(_assertThisInitialized(_this));
	    _this.handleImageDoubleClick = _this.handleImageDoubleClick.bind(_assertThisInitialized(_this));
	    _this.handleImageMouseWheel = _this.handleImageMouseWheel.bind(_assertThisInitialized(_this));
	    _this.handleKeyInput = _this.handleKeyInput.bind(_assertThisInitialized(_this));
	    _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
	    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
	    _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
	    _this.handleOuterMousewheel = _this.handleOuterMousewheel.bind(_assertThisInitialized(_this));
	    _this.handleTouchStart = _this.handleTouchStart.bind(_assertThisInitialized(_this));
	    _this.handleTouchMove = _this.handleTouchMove.bind(_assertThisInitialized(_this));
	    _this.handleTouchEnd = _this.handleTouchEnd.bind(_assertThisInitialized(_this));
	    _this.handlePointerEvent = _this.handlePointerEvent.bind(_assertThisInitialized(_this));
	    _this.handleCaptionMousewheel = _this.handleCaptionMousewheel.bind(_assertThisInitialized(_this));
	    _this.handleWindowResize = _this.handleWindowResize.bind(_assertThisInitialized(_this));
	    _this.handleZoomInButtonClick = _this.handleZoomInButtonClick.bind(_assertThisInitialized(_this));
	    _this.handleZoomOutButtonClick = _this.handleZoomOutButtonClick.bind(_assertThisInitialized(_this));
	    _this.requestClose = _this.requestClose.bind(_assertThisInitialized(_this));
	    _this.requestMoveNext = _this.requestMoveNext.bind(_assertThisInitialized(_this));
	    _this.requestMovePrev = _this.requestMovePrev.bind(_assertThisInitialized(_this)); // Timeouts - always clear it before umount
	
	    _this.timeouts = []; // Current action
	
	    _this.currentAction = ACTION_NONE; // Events source
	
	    _this.eventsSource = SOURCE_ANY; // Empty pointers list
	
	    _this.pointerList = []; // Prevent inner close
	
	    _this.preventInnerClose = false;
	    _this.preventInnerCloseTimeout = null; // Used to disable animation when changing props.mainSrc|nextSrc|prevSrc
	
	    _this.keyPressed = false; // Used to store load state / dimensions of images
	
	    _this.imageCache = {}; // Time the last keydown event was called (used in keyboard action rate limiting)
	
	    _this.lastKeyDownTime = 0; // Used for debouncing window resize event
	
	    _this.resizeTimeout = null; // Used to determine when actions are triggered by the scroll wheel
	
	    _this.wheelActionTimeout = null;
	    _this.resetScrollTimeout = null;
	    _this.scrollX = 0;
	    _this.scrollY = 0; // Used in panning zoomed images
	
	    _this.moveStartX = 0;
	    _this.moveStartY = 0;
	    _this.moveStartOffsetX = 0;
	    _this.moveStartOffsetY = 0; // Used to swipe
	
	    _this.swipeStartX = 0;
	    _this.swipeStartY = 0;
	    _this.swipeEndX = 0;
	    _this.swipeEndY = 0; // Used to pinch
	
	    _this.pinchTouchList = null;
	    _this.pinchDistance = 0; // Used to differentiate between images with identical src
	
	    _this.keyCounter = 0; // Used to detect a move when all src's remain unchanged (four or more of the same image in a row)
	
	    _this.moveRequested = false;
	    return _this;
	  }
	
	  _createClass(ReactImageLightbox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!this.props.animationDisabled) {
	        // Make opening animation play
	        this.setState({
	          isClosing: false
	        });
	      } // Prevents cross-origin errors when using a cross-origin iframe
	
	
	      this.windowContext = getHighestSafeWindowContext();
	      this.listeners = {
	        resize: this.handleWindowResize,
	        mouseup: this.handleMouseUp,
	        touchend: this.handleTouchEnd,
	        touchcancel: this.handleTouchEnd,
	        pointerdown: this.handlePointerEvent,
	        pointermove: this.handlePointerEvent,
	        pointerup: this.handlePointerEvent,
	        pointercancel: this.handlePointerEvent
	      };
	      Object.keys(this.listeners).forEach(function (type) {
	        _this2.windowContext.addEventListener(type, _this2.listeners[type]);
	      });
	      this.loadAllImages();
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _this3 = this;
	
	      this.getSrcTypes().forEach(function (srcType) {
	        if (_this3.props[srcType.name] !== nextProps[srcType.name]) {
	          _this3.moveRequested = false;
	        }
	      }); // Wait for move...
	
	      return !this.moveRequested;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this4 = this;
	
	      var sourcesChanged = false;
	      var prevSrcDict = {};
	      var nextSrcDict = {};
	      this.getSrcTypes().forEach(function (srcType) {
	        if (prevProps[srcType.name] !== _this4.props[srcType.name]) {
	          sourcesChanged = true;
	          prevSrcDict[prevProps[srcType.name]] = true;
	          nextSrcDict[_this4.props[srcType.name]] = true;
	        }
	      });
	
	      if (sourcesChanged || this.moveRequested) {
	        // Reset the loaded state for images not rendered next
	        Object.keys(prevSrcDict).forEach(function (prevSrc) {
	          if (!(prevSrc in nextSrcDict) && prevSrc in _this4.imageCache) {
	            _this4.imageCache[prevSrc].loaded = false;
	          }
	        });
	        this.moveRequested = false; // Load any new images
	
	        this.loadAllImages(this.props);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this5 = this;
	
	      this.didUnmount = true;
	      Object.keys(this.listeners).forEach(function (type) {
	        _this5.windowContext.removeEventListener(type, _this5.listeners[type]);
	      });
	      this.timeouts.forEach(function (tid) {
	        return clearTimeout(tid);
	      });
	    }
	  }, {
	    key: "setTimeout",
	    value: function (_setTimeout) {
	      function setTimeout(_x, _x2) {
	        return _setTimeout.apply(this, arguments);
	      }
	
	      setTimeout.toString = function () {
	        return _setTimeout.toString();
	      };
	
	      return setTimeout;
	    }(function (func, time) {
	      var _this6 = this;
	
	      var id = setTimeout(function () {
	        _this6.timeouts = _this6.timeouts.filter(function (tid) {
	          return tid !== id;
	        });
	        func();
	      }, time);
	      this.timeouts.push(id);
	      return id;
	    })
	  }, {
	    key: "setPreventInnerClose",
	    value: function setPreventInnerClose() {
	      var _this7 = this;
	
	      if (this.preventInnerCloseTimeout) {
	        this.clearTimeout(this.preventInnerCloseTimeout);
	      }
	
	      this.preventInnerClose = true;
	      this.preventInnerCloseTimeout = this.setTimeout(function () {
	        _this7.preventInnerClose = false;
	        _this7.preventInnerCloseTimeout = null;
	      }, 100);
	    } // Get info for the best suited image to display with the given srcType
	
	  }, {
	    key: "getBestImageForType",
	    value: function getBestImageForType(srcType) {
	      var imageSrc = this.props[srcType];
	      var fitSizes = {};
	
	      if (this.isImageLoaded(imageSrc)) {
	        // Use full-size image if available
	        fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height);
	      } else if (this.isImageLoaded(this.props["".concat(srcType, "Thumbnail")])) {
	        // Fall back to using thumbnail if the image has not been loaded
	        imageSrc = this.props["".concat(srcType, "Thumbnail")];
	        fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height, true);
	      } else {
	        return null;
	      }
	
	      return {
	        src: imageSrc,
	        height: this.imageCache[imageSrc].height,
	        width: this.imageCache[imageSrc].width,
	        targetHeight: fitSizes.height,
	        targetWidth: fitSizes.width
	      };
	    } // Get sizing for when an image is larger than the window
	
	  }, {
	    key: "getFitSizes",
	    value: function getFitSizes(width, height, stretch) {
	      var boxSize = this.getLightboxRect();
	      var maxHeight = boxSize.height - this.props.imagePadding * 2;
	      var maxWidth = boxSize.width - this.props.imagePadding * 2;
	
	      if (!stretch) {
	        maxHeight = Math.min(maxHeight, height);
	        maxWidth = Math.min(maxWidth, width);
	      }
	
	      var maxRatio = maxWidth / maxHeight;
	      var srcRatio = width / height;
	
	      if (maxRatio > srcRatio) {
	        // height is the constraining dimension of the photo
	        return {
	          width: width * maxHeight / height,
	          height: maxHeight
	        };
	      }
	
	      return {
	        width: maxWidth,
	        height: height * maxWidth / width
	      };
	    }
	  }, {
	    key: "getMaxOffsets",
	    value: function getMaxOffsets() {
	      var zoomLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.zoomLevel;
	      var currentImageInfo = this.getBestImageForType('mainSrc');
	
	      if (currentImageInfo === null) {
	        return {
	          maxX: 0,
	          minX: 0,
	          maxY: 0,
	          minY: 0
	        };
	      }
	
	      var boxSize = this.getLightboxRect();
	      var zoomMultiplier = this.getZoomMultiplier(zoomLevel);
	      var maxX = 0;
	
	      if (zoomMultiplier * currentImageInfo.width - boxSize.width < 0) {
	        // if there is still blank space in the X dimension, don't limit except to the opposite edge
	        maxX = (boxSize.width - zoomMultiplier * currentImageInfo.width) / 2;
	      } else {
	        maxX = (zoomMultiplier * currentImageInfo.width - boxSize.width) / 2;
	      }
	
	      var maxY = 0;
	
	      if (zoomMultiplier * currentImageInfo.height - boxSize.height < 0) {
	        // if there is still blank space in the Y dimension, don't limit except to the opposite edge
	        maxY = (boxSize.height - zoomMultiplier * currentImageInfo.height) / 2;
	      } else {
	        maxY = (zoomMultiplier * currentImageInfo.height - boxSize.height) / 2;
	      }
	
	      return {
	        maxX: maxX,
	        maxY: maxY,
	        minX: -1 * maxX,
	        minY: -1 * maxY
	      };
	    } // Get image src types
	
	  }, {
	    key: "getSrcTypes",
	    value: function getSrcTypes() {
	      return [{
	        name: 'mainSrc',
	        keyEnding: "i".concat(this.keyCounter)
	      }, {
	        name: 'mainSrcThumbnail',
	        keyEnding: "t".concat(this.keyCounter)
	      }, {
	        name: 'nextSrc',
	        keyEnding: "i".concat(this.keyCounter + 1)
	      }, {
	        name: 'nextSrcThumbnail',
	        keyEnding: "t".concat(this.keyCounter + 1)
	      }, {
	        name: 'prevSrc',
	        keyEnding: "i".concat(this.keyCounter - 1)
	      }, {
	        name: 'prevSrcThumbnail',
	        keyEnding: "t".concat(this.keyCounter - 1)
	      }];
	    }
	    /**
	     * Get sizing when the image is scaled
	     */
	
	  }, {
	    key: "getZoomMultiplier",
	    value: function getZoomMultiplier() {
	      var zoomLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.zoomLevel;
	      return Math.pow(ZOOM_RATIO, zoomLevel);
	    }
	    /**
	     * Get the size of the lightbox in pixels
	     */
	
	  }, {
	    key: "getLightboxRect",
	    value: function getLightboxRect() {
	      if (this.outerEl.current) {
	        return this.outerEl.current.getBoundingClientRect();
	      }
	
	      return {
	        width: getWindowWidth(),
	        height: getWindowHeight(),
	        top: 0,
	        right: 0,
	        bottom: 0,
	        left: 0
	      };
	    }
	  }, {
	    key: "clearTimeout",
	    value: function (_clearTimeout) {
	      function clearTimeout(_x3) {
	        return _clearTimeout.apply(this, arguments);
	      }
	
	      clearTimeout.toString = function () {
	        return _clearTimeout.toString();
	      };
	
	      return clearTimeout;
	    }(function (id) {
	      this.timeouts = this.timeouts.filter(function (tid) {
	        return tid !== id;
	      });
	      clearTimeout(id);
	    } // Change zoom level
	    )
	  }, {
	    key: "changeZoom",
	    value: function changeZoom(zoomLevel, clientX, clientY) {
	      // Ignore if zoom disabled
	      if (!this.props.enableZoom) {
	        return;
	      } // Constrain zoom level to the set bounds
	
	
	      var nextZoomLevel = Math.max(MIN_ZOOM_LEVEL, Math.min(MAX_ZOOM_LEVEL, zoomLevel)); // Ignore requests that don't change the zoom level
	
	      if (nextZoomLevel === this.state.zoomLevel) {
	        return;
	      }
	
	      if (nextZoomLevel === MIN_ZOOM_LEVEL) {
	        // Snap back to center if zoomed all the way out
	        this.setState({
	          zoomLevel: nextZoomLevel,
	          offsetX: 0,
	          offsetY: 0
	        });
	        return;
	      }
	
	      var imageBaseSize = this.getBestImageForType('mainSrc');
	
	      if (imageBaseSize === null) {
	        return;
	      }
	
	      var currentZoomMultiplier = this.getZoomMultiplier();
	      var nextZoomMultiplier = this.getZoomMultiplier(nextZoomLevel); // Default to the center of the image to zoom when no mouse position specified
	
	      var boxRect = this.getLightboxRect();
	      var pointerX = typeof clientX !== 'undefined' ? clientX - boxRect.left : boxRect.width / 2;
	      var pointerY = typeof clientY !== 'undefined' ? clientY - boxRect.top : boxRect.height / 2;
	      var currentImageOffsetX = (boxRect.width - imageBaseSize.width * currentZoomMultiplier) / 2;
	      var currentImageOffsetY = (boxRect.height - imageBaseSize.height * currentZoomMultiplier) / 2;
	      var currentImageRealOffsetX = currentImageOffsetX - this.state.offsetX;
	      var currentImageRealOffsetY = currentImageOffsetY - this.state.offsetY;
	      var currentPointerXRelativeToImage = (pointerX - currentImageRealOffsetX) / currentZoomMultiplier;
	      var currentPointerYRelativeToImage = (pointerY - currentImageRealOffsetY) / currentZoomMultiplier;
	      var nextImageRealOffsetX = pointerX - currentPointerXRelativeToImage * nextZoomMultiplier;
	      var nextImageRealOffsetY = pointerY - currentPointerYRelativeToImage * nextZoomMultiplier;
	      var nextImageOffsetX = (boxRect.width - imageBaseSize.width * nextZoomMultiplier) / 2;
	      var nextImageOffsetY = (boxRect.height - imageBaseSize.height * nextZoomMultiplier) / 2;
	      var nextOffsetX = nextImageOffsetX - nextImageRealOffsetX;
	      var nextOffsetY = nextImageOffsetY - nextImageRealOffsetY; // When zooming out, limit the offset so things don't get left askew
	
	      if (this.currentAction !== ACTION_PINCH) {
	        var maxOffsets = this.getMaxOffsets();
	
	        if (this.state.zoomLevel > nextZoomLevel) {
	          nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, nextOffsetX));
	          nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, nextOffsetY));
	        }
	      }
	
	      this.setState({
	        zoomLevel: nextZoomLevel,
	        offsetX: nextOffsetX,
	        offsetY: nextOffsetY
	      });
	    }
	  }, {
	    key: "closeIfClickInner",
	    value: function closeIfClickInner(event) {
	      if (!this.preventInnerClose && event.target.className.search(/\bril-inner\b/) > -1) {
	        this.requestClose(event);
	      }
	    }
	    /**
	     * Handle user keyboard actions
	     */
	
	  }, {
	    key: "handleKeyInput",
	    value: function handleKeyInput(event) {
	      event.stopPropagation(); // Ignore key input during animations
	
	      if (this.isAnimating()) {
	        return;
	      } // Allow slightly faster navigation through the images when user presses keys repeatedly
	
	
	      if (event.type === 'keyup') {
	        this.lastKeyDownTime -= this.props.keyRepeatKeyupBonus;
	        return;
	      }
	
	      var keyCode = event.which || event.keyCode; // Ignore key presses that happen too close to each other (when rapid fire key pressing or holding down the key)
	      // But allow it if it's a lightbox closing action
	
	      var currentTime = new Date();
	
	      if (currentTime.getTime() - this.lastKeyDownTime < this.props.keyRepeatLimit && keyCode !== KEYS.ESC) {
	        return;
	      }
	
	      this.lastKeyDownTime = currentTime.getTime();
	
	      switch (keyCode) {
	        // ESC key closes the lightbox
	        case KEYS.ESC:
	          event.preventDefault();
	          this.requestClose(event);
	          break;
	        // Left arrow key moves to previous image
	
	        case KEYS.LEFT_ARROW:
	          if (!this.props.prevSrc) {
	            return;
	          }
	
	          event.preventDefault();
	          this.keyPressed = true;
	          this.requestMovePrev(event);
	          break;
	        // Right arrow key moves to next image
	
	        case KEYS.RIGHT_ARROW:
	          if (!this.props.nextSrc) {
	            return;
	          }
	
	          event.preventDefault();
	          this.keyPressed = true;
	          this.requestMoveNext(event);
	          break;
	      }
	    }
	    /**
	     * Handle a mouse wheel event over the lightbox container
	     */
	
	  }, {
	    key: "handleOuterMousewheel",
	    value: function handleOuterMousewheel(event) {
	      var _this8 = this;
	
	      // Prevent scrolling of the background
	      event.stopPropagation();
	      var xThreshold = WHEEL_MOVE_X_THRESHOLD;
	      var actionDelay = 0;
	      var imageMoveDelay = 500;
	      this.clearTimeout(this.resetScrollTimeout);
	      this.resetScrollTimeout = this.setTimeout(function () {
	        _this8.scrollX = 0;
	        _this8.scrollY = 0;
	      }, 300); // Prevent rapid-fire zoom behavior
	
	      if (this.wheelActionTimeout !== null || this.isAnimating()) {
	        return;
	      }
	
	      if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
	        // handle horizontal scrolls with image moves
	        this.scrollY = 0;
	        this.scrollX += event.deltaX;
	        var bigLeapX = xThreshold / 2; // If the scroll amount has accumulated sufficiently, or a large leap was taken
	
	        if (this.scrollX >= xThreshold || event.deltaX >= bigLeapX) {
	          // Scroll right moves to next
	          this.requestMoveNext(event);
	          actionDelay = imageMoveDelay;
	          this.scrollX = 0;
	        } else if (this.scrollX <= -1 * xThreshold || event.deltaX <= -1 * bigLeapX) {
	          // Scroll left moves to previous
	          this.requestMovePrev(event);
	          actionDelay = imageMoveDelay;
	          this.scrollX = 0;
	        }
	      } // Allow successive actions after the set delay
	
	
	      if (actionDelay !== 0) {
	        this.wheelActionTimeout = this.setTimeout(function () {
	          _this8.wheelActionTimeout = null;
	        }, actionDelay);
	      }
	    }
	  }, {
	    key: "handleImageMouseWheel",
	    value: function handleImageMouseWheel(event) {
	      var yThreshold = WHEEL_MOVE_Y_THRESHOLD;
	
	      if (Math.abs(event.deltaY) >= Math.abs(event.deltaX)) {
	        event.stopPropagation(); // If the vertical scroll amount was large enough, perform a zoom
	
	        if (Math.abs(event.deltaY) < yThreshold) {
	          return;
	        }
	
	        this.scrollX = 0;
	        this.scrollY += event.deltaY;
	        this.changeZoom(this.state.zoomLevel - event.deltaY, event.clientX, event.clientY);
	      }
	    }
	    /**
	     * Handle a double click on the current image
	     */
	
	  }, {
	    key: "handleImageDoubleClick",
	    value: function handleImageDoubleClick(event) {
	      if (this.state.zoomLevel > MIN_ZOOM_LEVEL) {
	        // A double click when zoomed in zooms all the way out
	        this.changeZoom(MIN_ZOOM_LEVEL, event.clientX, event.clientY);
	      } else {
	        // A double click when zoomed all the way out zooms in
	        this.changeZoom(this.state.zoomLevel + ZOOM_BUTTON_INCREMENT_SIZE, event.clientX, event.clientY);
	      }
	    }
	  }, {
	    key: "shouldHandleEvent",
	    value: function shouldHandleEvent(source) {
	      if (this.eventsSource === source) {
	        return true;
	      }
	
	      if (this.eventsSource === SOURCE_ANY) {
	        this.eventsSource = source;
	        return true;
	      }
	
	      switch (source) {
	        case SOURCE_MOUSE:
	          return false;
	
	        case SOURCE_TOUCH:
	          this.eventsSource = SOURCE_TOUCH;
	          this.filterPointersBySource();
	          return true;
	
	        case SOURCE_POINTER:
	          if (this.eventsSource === SOURCE_MOUSE) {
	            this.eventsSource = SOURCE_POINTER;
	            this.filterPointersBySource();
	            return true;
	          }
	
	          return false;
	
	        default:
	          return false;
	      }
	    }
	  }, {
	    key: "addPointer",
	    value: function addPointer(pointer) {
	      this.pointerList.push(pointer);
	    }
	  }, {
	    key: "removePointer",
	    value: function removePointer(pointer) {
	      this.pointerList = this.pointerList.filter(function (_ref) {
	        var id = _ref.id;
	        return id !== pointer.id;
	      });
	    }
	  }, {
	    key: "filterPointersBySource",
	    value: function filterPointersBySource() {
	      var _this9 = this;
	
	      this.pointerList = this.pointerList.filter(function (_ref2) {
	        var source = _ref2.source;
	        return source === _this9.eventsSource;
	      });
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(event) {
	      if (this.shouldHandleEvent(SOURCE_MOUSE) && ReactImageLightbox.isTargetMatchImage(event.target)) {
	        this.addPointer(ReactImageLightbox.parseMouseEvent(event));
	        this.multiPointerStart(event);
	      }
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      if (this.shouldHandleEvent(SOURCE_MOUSE)) {
	        this.multiPointerMove(event, [ReactImageLightbox.parseMouseEvent(event)]);
	      }
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(event) {
	      if (this.shouldHandleEvent(SOURCE_MOUSE)) {
	        this.removePointer(ReactImageLightbox.parseMouseEvent(event));
	        this.multiPointerEnd(event);
	      }
	    }
	  }, {
	    key: "handlePointerEvent",
	    value: function handlePointerEvent(event) {
	      if (this.shouldHandleEvent(SOURCE_POINTER)) {
	        switch (event.type) {
	          case 'pointerdown':
	            if (ReactImageLightbox.isTargetMatchImage(event.target)) {
	              this.addPointer(ReactImageLightbox.parsePointerEvent(event));
	              this.multiPointerStart(event);
	            }
	
	            break;
	
	          case 'pointermove':
	            this.multiPointerMove(event, [ReactImageLightbox.parsePointerEvent(event)]);
	            break;
	
	          case 'pointerup':
	          case 'pointercancel':
	            this.removePointer(ReactImageLightbox.parsePointerEvent(event));
	            this.multiPointerEnd(event);
	            break;
	        }
	      }
	    }
	  }, {
	    key: "handleTouchStart",
	    value: function handleTouchStart(event) {
	      var _this10 = this;
	
	      if (this.shouldHandleEvent(SOURCE_TOUCH) && ReactImageLightbox.isTargetMatchImage(event.target)) {
	        [].forEach.call(event.changedTouches, function (eventTouch) {
	          return _this10.addPointer(ReactImageLightbox.parseTouchPointer(eventTouch));
	        });
	        this.multiPointerStart(event);
	      }
	    }
	  }, {
	    key: "handleTouchMove",
	    value: function handleTouchMove(event) {
	      if (this.shouldHandleEvent(SOURCE_TOUCH)) {
	        this.multiPointerMove(event, [].map.call(event.changedTouches, function (eventTouch) {
	          return ReactImageLightbox.parseTouchPointer(eventTouch);
	        }));
	      }
	    }
	  }, {
	    key: "handleTouchEnd",
	    value: function handleTouchEnd(event) {
	      var _this11 = this;
	
	      if (this.shouldHandleEvent(SOURCE_TOUCH)) {
	        [].map.call(event.changedTouches, function (touch) {
	          return _this11.removePointer(ReactImageLightbox.parseTouchPointer(touch));
	        });
	        this.multiPointerEnd(event);
	      }
	    }
	  }, {
	    key: "decideMoveOrSwipe",
	    value: function decideMoveOrSwipe(pointer) {
	      if (this.state.zoomLevel <= MIN_ZOOM_LEVEL) {
	        this.handleSwipeStart(pointer);
	      } else {
	        this.handleMoveStart(pointer);
	      }
	    }
	  }, {
	    key: "multiPointerStart",
	    value: function multiPointerStart(event) {
	      this.handleEnd(null);
	
	      switch (this.pointerList.length) {
	        case 1:
	          {
	            event.preventDefault();
	            this.decideMoveOrSwipe(this.pointerList[0]);
	            break;
	          }
	
	        case 2:
	          {
	            event.preventDefault();
	            this.handlePinchStart(this.pointerList);
	            break;
	          }
	      }
	    }
	  }, {
	    key: "multiPointerMove",
	    value: function multiPointerMove(event, pointerList) {
	      switch (this.currentAction) {
	        case ACTION_MOVE:
	          {
	            event.preventDefault();
	            this.handleMove(pointerList[0]);
	            break;
	          }
	
	        case ACTION_SWIPE:
	          {
	            event.preventDefault();
	            this.handleSwipe(pointerList[0]);
	            break;
	          }
	
	        case ACTION_PINCH:
	          {
	            event.preventDefault();
	            this.handlePinch(pointerList);
	            break;
	          }
	      }
	    }
	  }, {
	    key: "multiPointerEnd",
	    value: function multiPointerEnd(event) {
	      if (this.currentAction !== ACTION_NONE) {
	        this.setPreventInnerClose();
	        this.handleEnd(event);
	      }
	
	      switch (this.pointerList.length) {
	        case 0:
	          {
	            this.eventsSource = SOURCE_ANY;
	            break;
	          }
	
	        case 1:
	          {
	            event.preventDefault();
	            this.decideMoveOrSwipe(this.pointerList[0]);
	            break;
	          }
	
	        case 2:
	          {
	            event.preventDefault();
	            this.handlePinchStart(this.pointerList);
	            break;
	          }
	      }
	    }
	  }, {
	    key: "handleEnd",
	    value: function handleEnd(event) {
	      switch (this.currentAction) {
	        case ACTION_MOVE:
	          this.handleMoveEnd(event);
	          break;
	
	        case ACTION_SWIPE:
	          this.handleSwipeEnd(event);
	          break;
	
	        case ACTION_PINCH:
	          this.handlePinchEnd(event);
	          break;
	      }
	    } // Handle move start over the lightbox container
	    // This happens:
	    // - On a mouseDown event
	    // - On a touchstart event
	
	  }, {
	    key: "handleMoveStart",
	    value: function handleMoveStart(_ref3) {
	      var clientX = _ref3.x,
	          clientY = _ref3.y;
	
	      if (!this.props.enableZoom) {
	        return;
	      }
	
	      this.currentAction = ACTION_MOVE;
	      this.moveStartX = clientX;
	      this.moveStartY = clientY;
	      this.moveStartOffsetX = this.state.offsetX;
	      this.moveStartOffsetY = this.state.offsetY;
	    } // Handle dragging over the lightbox container
	    // This happens:
	    // - After a mouseDown and before a mouseUp event
	    // - After a touchstart and before a touchend event
	
	  }, {
	    key: "handleMove",
	    value: function handleMove(_ref4) {
	      var clientX = _ref4.x,
	          clientY = _ref4.y;
	      var newOffsetX = this.moveStartX - clientX + this.moveStartOffsetX;
	      var newOffsetY = this.moveStartY - clientY + this.moveStartOffsetY;
	
	      if (this.state.offsetX !== newOffsetX || this.state.offsetY !== newOffsetY) {
	        this.setState({
	          offsetX: newOffsetX,
	          offsetY: newOffsetY
	        });
	      }
	    }
	  }, {
	    key: "handleMoveEnd",
	    value: function handleMoveEnd() {
	      var _this12 = this;
	
	      this.currentAction = ACTION_NONE;
	      this.moveStartX = 0;
	      this.moveStartY = 0;
	      this.moveStartOffsetX = 0;
	      this.moveStartOffsetY = 0; // Snap image back into frame if outside max offset range
	
	      var maxOffsets = this.getMaxOffsets();
	      var nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, this.state.offsetX));
	      var nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, this.state.offsetY));
	
	      if (nextOffsetX !== this.state.offsetX || nextOffsetY !== this.state.offsetY) {
	        this.setState({
	          offsetX: nextOffsetX,
	          offsetY: nextOffsetY,
	          shouldAnimate: true
	        });
	        this.setTimeout(function () {
	          _this12.setState({
	            shouldAnimate: false
	          });
	        }, this.props.animationDuration);
	      }
	    }
	  }, {
	    key: "handleSwipeStart",
	    value: function handleSwipeStart(_ref5) {
	      var clientX = _ref5.x,
	          clientY = _ref5.y;
	      this.currentAction = ACTION_SWIPE;
	      this.swipeStartX = clientX;
	      this.swipeStartY = clientY;
	      this.swipeEndX = clientX;
	      this.swipeEndY = clientY;
	    }
	  }, {
	    key: "handleSwipe",
	    value: function handleSwipe(_ref6) {
	      var clientX = _ref6.x,
	          clientY = _ref6.y;
	      this.swipeEndX = clientX;
	      this.swipeEndY = clientY;
	    }
	  }, {
	    key: "handleSwipeEnd",
	    value: function handleSwipeEnd(event) {
	      var xDiff = this.swipeEndX - this.swipeStartX;
	      var xDiffAbs = Math.abs(xDiff);
	      var yDiffAbs = Math.abs(this.swipeEndY - this.swipeStartY);
	      this.currentAction = ACTION_NONE;
	      this.swipeStartX = 0;
	      this.swipeStartY = 0;
	      this.swipeEndX = 0;
	      this.swipeEndY = 0;
	
	      if (!event || this.isAnimating() || xDiffAbs < yDiffAbs * 1.5) {
	        return;
	      }
	
	      if (xDiffAbs < MIN_SWIPE_DISTANCE) {
	        var boxRect = this.getLightboxRect();
	
	        if (xDiffAbs < boxRect.width / 4) {
	          return;
	        }
	      }
	
	      if (xDiff > 0 && this.props.prevSrc) {
	        event.preventDefault();
	        this.requestMovePrev();
	      } else if (xDiff < 0 && this.props.nextSrc) {
	        event.preventDefault();
	        this.requestMoveNext();
	      }
	    }
	  }, {
	    key: "calculatePinchDistance",
	    value: function calculatePinchDistance() {
	      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pinchTouchList,
	          _ref8 = _slicedToArray(_ref7, 2),
	          a = _ref8[0],
	          b = _ref8[1];
	
	      return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
	    }
	  }, {
	    key: "calculatePinchCenter",
	    value: function calculatePinchCenter() {
	      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pinchTouchList,
	          _ref10 = _slicedToArray(_ref9, 2),
	          a = _ref10[0],
	          b = _ref10[1];
	
	      return {
	        x: a.x - (a.x - b.x) / 2,
	        y: a.y - (a.y - b.y) / 2
	      };
	    }
	  }, {
	    key: "handlePinchStart",
	    value: function handlePinchStart(pointerList) {
	      if (!this.props.enableZoom) {
	        return;
	      }
	
	      this.currentAction = ACTION_PINCH;
	      this.pinchTouchList = pointerList.map(function (_ref11) {
	        var id = _ref11.id,
	            x = _ref11.x,
	            y = _ref11.y;
	        return {
	          id: id,
	          x: x,
	          y: y
	        };
	      });
	      this.pinchDistance = this.calculatePinchDistance();
	    }
	  }, {
	    key: "handlePinch",
	    value: function handlePinch(pointerList) {
	      this.pinchTouchList = this.pinchTouchList.map(function (oldPointer) {
	        for (var i = 0; i < pointerList.length; i += 1) {
	          if (pointerList[i].id === oldPointer.id) {
	            return pointerList[i];
	          }
	        }
	
	        return oldPointer;
	      });
	      var newDistance = this.calculatePinchDistance();
	      var zoomLevel = this.state.zoomLevel + newDistance - this.pinchDistance;
	      this.pinchDistance = newDistance;
	
	      var _this$calculatePinchC = this.calculatePinchCenter(this.pinchTouchList),
	          clientX = _this$calculatePinchC.x,
	          clientY = _this$calculatePinchC.y;
	
	      this.changeZoom(zoomLevel, clientX, clientY);
	    }
	  }, {
	    key: "handlePinchEnd",
	    value: function handlePinchEnd() {
	      this.currentAction = ACTION_NONE;
	      this.pinchTouchList = null;
	      this.pinchDistance = 0;
	    } // Handle the window resize event
	
	  }, {
	    key: "handleWindowResize",
	    value: function handleWindowResize() {
	      this.clearTimeout(this.resizeTimeout);
	      this.resizeTimeout = this.setTimeout(this.forceUpdate.bind(this), 100);
	    }
	  }, {
	    key: "handleZoomInButtonClick",
	    value: function handleZoomInButtonClick() {
	      var nextZoomLevel = this.state.zoomLevel + ZOOM_BUTTON_INCREMENT_SIZE;
	      this.changeZoom(nextZoomLevel);
	
	      if (nextZoomLevel === MAX_ZOOM_LEVEL) {
	        this.zoomOutBtn.current.focus();
	      }
	    }
	  }, {
	    key: "handleZoomOutButtonClick",
	    value: function handleZoomOutButtonClick() {
	      var nextZoomLevel = this.state.zoomLevel - ZOOM_BUTTON_INCREMENT_SIZE;
	      this.changeZoom(nextZoomLevel);
	
	      if (nextZoomLevel === MIN_ZOOM_LEVEL) {
	        this.zoomInBtn.current.focus();
	      }
	    }
	  }, {
	    key: "handleCaptionMousewheel",
	    value: function handleCaptionMousewheel(event) {
	      event.stopPropagation();
	
	      if (!this.caption.current) {
	        return;
	      }
	
	      var _this$caption$current = this.caption.current.getBoundingClientRect(),
	          height = _this$caption$current.height;
	
	      var _this$caption$current2 = this.caption.current,
	          scrollHeight = _this$caption$current2.scrollHeight,
	          scrollTop = _this$caption$current2.scrollTop;
	
	      if (event.deltaY > 0 && height + scrollTop >= scrollHeight || event.deltaY < 0 && scrollTop <= 0) {
	        event.preventDefault();
	      }
	    } // Detach key and mouse input events
	
	  }, {
	    key: "isAnimating",
	    value: function isAnimating() {
	      return this.state.shouldAnimate || this.state.isClosing;
	    } // Check if image is loaded
	
	  }, {
	    key: "isImageLoaded",
	    value: function isImageLoaded(imageSrc) {
	      return imageSrc && imageSrc in this.imageCache && this.imageCache[imageSrc].loaded;
	    } // Load image from src and call callback with image width and height on load
	
	  }, {
	    key: "loadImage",
	    value: function loadImage(srcType, imageSrc, done) {
	      var _this13 = this;
	
	      // Return the image info if it is already cached
	      if (this.isImageLoaded(imageSrc)) {
	        this.setTimeout(function () {
	          done();
	        }, 1);
	        return;
	      }
	
	      var inMemoryImage = new global.Image();
	
	      if (this.props.imageCrossOrigin) {
	        inMemoryImage.crossOrigin = this.props.imageCrossOrigin;
	      }
	
	      inMemoryImage.onerror = function (errorEvent) {
	        _this13.props.onImageLoadError(imageSrc, srcType, errorEvent); // failed to load so set the state loadErrorStatus
	
	
	        _this13.setState(function (prevState) {
	          return {
	            loadErrorStatus: _objectSpread2(_objectSpread2({}, prevState.loadErrorStatus), {}, _defineProperty({}, srcType, true))
	          };
	        });
	
	        done(errorEvent);
	      };
	
	      inMemoryImage.onload = function () {
	        _this13.props.onImageLoad(imageSrc, srcType, inMemoryImage);
	
	        _this13.imageCache[imageSrc] = {
	          loaded: true,
	          width: inMemoryImage.width,
	          height: inMemoryImage.height
	        };
	        done();
	      };
	
	      inMemoryImage.src = imageSrc;
	    } // Load all images and their thumbnails
	
	  }, {
	    key: "loadAllImages",
	    value: function loadAllImages() {
	      var _this14 = this;
	
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var generateLoadDoneCallback = function generateLoadDoneCallback(srcType, imageSrc) {
	        return function (err) {
	          // Give up showing image on error
	          if (err) {
	            return;
	          } // Don't rerender if the src is not the same as when the load started
	          // or if the component has unmounted
	
	
	          if (_this14.props[srcType] !== imageSrc || _this14.didUnmount) {
	            return;
	          } // Force rerender with the new image
	
	
	          _this14.forceUpdate();
	        };
	      }; // Load the images
	
	
	      this.getSrcTypes().forEach(function (srcType) {
	        var type = srcType.name; // there is no error when we try to load it initially
	
	        if (props[type] && _this14.state.loadErrorStatus[type]) {
	          _this14.setState(function (prevState) {
	            return {
	              loadErrorStatus: _objectSpread2(_objectSpread2({}, prevState.loadErrorStatus), {}, _defineProperty({}, type, false))
	            };
	          });
	        } // Load unloaded images
	
	
	        if (props[type] && !_this14.isImageLoaded(props[type])) {
	          _this14.loadImage(type, props[type], generateLoadDoneCallback(type, props[type]));
	        }
	      });
	    } // Request that the lightbox be closed
	
	  }, {
	    key: "requestClose",
	    value: function requestClose(event) {
	      var _this15 = this;
	
	      // Call the parent close request
	      var closeLightbox = function closeLightbox() {
	        return _this15.props.onCloseRequest(event);
	      };
	
	      if (this.props.animationDisabled || event.type === 'keydown' && !this.props.animationOnKeyInput) {
	        // No animation
	        closeLightbox();
	        return;
	      } // With animation
	      // Start closing animation
	
	
	      this.setState({
	        isClosing: true
	      }); // Perform the actual closing at the end of the animation
	
	      this.setTimeout(closeLightbox, this.props.animationDuration);
	    }
	  }, {
	    key: "requestMove",
	    value: function requestMove(direction, event) {
	      var _this16 = this;
	
	      // Reset the zoom level on image move
	      var nextState = {
	        zoomLevel: MIN_ZOOM_LEVEL,
	        offsetX: 0,
	        offsetY: 0
	      }; // Enable animated states
	
	      if (!this.props.animationDisabled && (!this.keyPressed || this.props.animationOnKeyInput)) {
	        nextState.shouldAnimate = true;
	        this.setTimeout(function () {
	          return _this16.setState({
	            shouldAnimate: false
	          });
	        }, this.props.animationDuration);
	      }
	
	      this.keyPressed = false;
	      this.moveRequested = true;
	
	      if (direction === 'prev') {
	        this.keyCounter -= 1;
	        this.setState(nextState);
	        this.props.onMovePrevRequest(event);
	      } else {
	        this.keyCounter += 1;
	        this.setState(nextState);
	        this.props.onMoveNextRequest(event);
	      }
	    } // Request to transition to the next image
	
	  }, {
	    key: "requestMoveNext",
	    value: function requestMoveNext(event) {
	      this.requestMove('next', event);
	    } // Request to transition to the previous image
	
	  }, {
	    key: "requestMovePrev",
	    value: function requestMovePrev(event) {
	      this.requestMove('prev', event);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this17 = this;
	
	      var _this$props = this.props,
	          animationDisabled = _this$props.animationDisabled,
	          animationDuration = _this$props.animationDuration,
	          clickOutsideToClose = _this$props.clickOutsideToClose,
	          discourageDownloads = _this$props.discourageDownloads,
	          enableZoom = _this$props.enableZoom,
	          imageTitle = _this$props.imageTitle,
	          nextSrc = _this$props.nextSrc,
	          prevSrc = _this$props.prevSrc,
	          toolbarButtons = _this$props.toolbarButtons,
	          reactModalStyle = _this$props.reactModalStyle,
	          _onAfterOpen = _this$props.onAfterOpen,
	          imageCrossOrigin = _this$props.imageCrossOrigin,
	          reactModalProps = _this$props.reactModalProps,
	          loader = _this$props.loader;
	      var _this$state = this.state,
	          zoomLevel = _this$state.zoomLevel,
	          offsetX = _this$state.offsetX,
	          offsetY = _this$state.offsetY,
	          isClosing = _this$state.isClosing,
	          loadErrorStatus = _this$state.loadErrorStatus;
	      var boxSize = this.getLightboxRect();
	      var transitionStyle = {}; // Transition settings for sliding animations
	
	      if (!animationDisabled && this.isAnimating()) {
	        transitionStyle = _objectSpread2(_objectSpread2({}, transitionStyle), {}, {
	          transition: "transform ".concat(animationDuration, "ms")
	        });
	      } // Key endings to differentiate between images with the same src
	
	
	      var keyEndings = {};
	      this.getSrcTypes().forEach(function (_ref12) {
	        var name = _ref12.name,
	            keyEnding = _ref12.keyEnding;
	        keyEndings[name] = keyEnding;
	      }); // Images to be displayed
	
	      var images = [];
	
	      var addImage = function addImage(srcType, imageClass, transforms) {
	        // Ignore types that have no source defined for their full size image
	        if (!_this17.props[srcType]) {
	          return;
	        }
	
	        var bestImageInfo = _this17.getBestImageForType(srcType);
	
	        var imageStyle = _objectSpread2(_objectSpread2({}, transitionStyle), ReactImageLightbox.getTransform(_objectSpread2(_objectSpread2({}, transforms), bestImageInfo)));
	
	        if (zoomLevel > MIN_ZOOM_LEVEL) {
	          imageStyle.cursor = 'move';
	        } // support IE 9 and 11
	
	
	        var hasTrueValue = function hasTrueValue(object) {
	          return Object.keys(object).some(function (key) {
	            return object[key];
	          });
	        }; // when error on one of the loads then push custom error stuff
	
	
	        if (bestImageInfo === null && hasTrueValue(loadErrorStatus)) {
	          images.push( /*#__PURE__*/React__default['default'].createElement("div", {
	            className: "".concat(imageClass, " ril__image ril-errored"),
	            style: imageStyle,
	            key: _this17.props[srcType] + keyEndings[srcType]
	          }, /*#__PURE__*/React__default['default'].createElement("div", {
	            className: "ril__errorContainer"
	          }, _this17.props.imageLoadErrorMessage)));
	          return;
	        }
	
	        if (bestImageInfo === null) {
	          var loadingIcon = loader !== undefined ? loader : /*#__PURE__*/React__default['default'].createElement("div", {
	            className: "ril-loading-circle ril__loadingCircle ril__loadingContainer__icon"
	          }, _toConsumableArray(new Array(12)).map(function (_, index) {
	            return /*#__PURE__*/React__default['default'].createElement("div", {
	              // eslint-disable-next-line react/no-array-index-key
	              key: index,
	              className: "ril-loading-circle-point ril__loadingCirclePoint"
	            });
	          })); // Fall back to loading icon if the thumbnail has not been loaded
	
	          images.push( /*#__PURE__*/React__default['default'].createElement("div", {
	            className: "".concat(imageClass, " ril__image ril-not-loaded"),
	            style: imageStyle,
	            key: _this17.props[srcType] + keyEndings[srcType]
	          }, /*#__PURE__*/React__default['default'].createElement("div", {
	            className: "ril__loadingContainer"
	          }, loadingIcon)));
	          return;
	        }
	
	        var imageSrc = bestImageInfo.src;
	
	        if (discourageDownloads) {
	          imageStyle.backgroundImage = "url('".concat(imageSrc, "')");
	          images.push( /*#__PURE__*/React__default['default'].createElement("div", {
	            className: "".concat(imageClass, " ril__image ril__imageDiscourager"),
	            onDoubleClick: _this17.handleImageDoubleClick,
	            onWheel: _this17.handleImageMouseWheel,
	            style: imageStyle,
	            key: imageSrc + keyEndings[srcType]
	          }, /*#__PURE__*/React__default['default'].createElement("div", {
	            className: "ril-download-blocker ril__downloadBlocker"
	          })));
	        } else {
	          images.push( /*#__PURE__*/React__default['default'].createElement("img", _extends({}, imageCrossOrigin ? {
	            crossOrigin: imageCrossOrigin
	          } : {}, {
	            className: "".concat(imageClass, " ril__image"),
	            onDoubleClick: _this17.handleImageDoubleClick,
	            onWheel: _this17.handleImageMouseWheel,
	            onDragStart: function onDragStart(e) {
	              return e.preventDefault();
	            },
	            style: imageStyle,
	            src: imageSrc,
	            key: imageSrc + keyEndings[srcType],
	            alt: typeof imageTitle === 'string' ? imageTitle : translate('Image'),
	            draggable: false
	          })));
	        }
	      };
	
	      var zoomMultiplier = this.getZoomMultiplier(); // Next Image (displayed on the right)
	
	      addImage('nextSrc', 'ril-image-next ril__imageNext', {
	        x: boxSize.width
	      }); // Main Image
	
	      addImage('mainSrc', 'ril-image-current', {
	        x: -1 * offsetX,
	        y: -1 * offsetY,
	        zoom: zoomMultiplier
	      }); // Previous Image (displayed on the left)
	
	      addImage('prevSrc', 'ril-image-prev ril__imagePrev', {
	        x: -1 * boxSize.width
	      });
	      var modalStyle = {
	        overlay: _objectSpread2({
	          zIndex: 1000,
	          backgroundColor: 'transparent'
	        }, reactModalStyle.overlay),
	        content: _objectSpread2({
	          backgroundColor: 'transparent',
	          overflow: 'hidden',
	          // Needed, otherwise keyboard shortcuts scroll the page
	          border: 'none',
	          borderRadius: 0,
	          padding: 0,
	          top: 0,
	          left: 0,
	          right: 0,
	          bottom: 0
	        }, reactModalStyle.content)
	      };
	      return /*#__PURE__*/React__default['default'].createElement(Modal__default['default'], _extends({
	        isOpen: true,
	        onRequestClose: clickOutsideToClose ? this.requestClose : undefined,
	        onAfterOpen: function onAfterOpen() {
	          // Focus on the div with key handlers
	          if (_this17.outerEl.current) {
	            _this17.outerEl.current.focus();
	          }
	
	          _onAfterOpen();
	        },
	        style: modalStyle,
	        contentLabel: translate('Lightbox'),
	        appElement: typeof global.window !== 'undefined' ? global.window.document.body : undefined
	      }, reactModalProps), /*#__PURE__*/React__default['default'].createElement("div", {
	        // eslint-disable-line jsx-a11y/no-static-element-interactions
	        // Floating modal with closing animations
	        className: "ril-outer ril__outer ril__outerAnimating ".concat(this.props.wrapperClassName, " ").concat(isClosing ? 'ril-closing ril__outerClosing' : ''),
	        style: {
	          transition: "opacity ".concat(animationDuration, "ms"),
	          animationDuration: "".concat(animationDuration, "ms"),
	          animationDirection: isClosing ? 'normal' : 'reverse'
	        },
	        ref: this.outerEl,
	        onWheel: this.handleOuterMousewheel,
	        onMouseMove: this.handleMouseMove,
	        onMouseDown: this.handleMouseDown,
	        onTouchStart: this.handleTouchStart,
	        onTouchMove: this.handleTouchMove,
	        tabIndex: "-1" // Enables key handlers on div
	        ,
	        onKeyDown: this.handleKeyInput,
	        onKeyUp: this.handleKeyInput
	      }, /*#__PURE__*/React__default['default'].createElement("div", {
	        // eslint-disable-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
	        // Image holder
	        className: "ril-inner ril__inner",
	        onClick: clickOutsideToClose ? this.closeIfClickInner : undefined
	      }, images), prevSrc && /*#__PURE__*/React__default['default'].createElement("button", {
	        // Move to previous image button
	        type: "button",
	        className: "ril-prev-button ril__navButtons ril__navButtonPrev",
	        key: "prev",
	        "aria-label": this.props.prevLabel,
	        title: this.props.prevLabel,
	        onClick: !this.isAnimating() ? this.requestMovePrev : undefined // Ignore clicks during animation
	
	      }), nextSrc && /*#__PURE__*/React__default['default'].createElement("button", {
	        // Move to next image button
	        type: "button",
	        className: "ril-next-button ril__navButtons ril__navButtonNext",
	        key: "next",
	        "aria-label": this.props.nextLabel,
	        title: this.props.nextLabel,
	        onClick: !this.isAnimating() ? this.requestMoveNext : undefined // Ignore clicks during animation
	
	      }), /*#__PURE__*/React__default['default'].createElement("div", {
	        // Lightbox toolbar
	        className: "ril-toolbar ril__toolbar"
	      }, /*#__PURE__*/React__default['default'].createElement("ul", {
	        className: "ril-toolbar-left ril__toolbarSide ril__toolbarLeftSide"
	      }, /*#__PURE__*/React__default['default'].createElement("li", {
	        className: "ril-toolbar__item ril__toolbarItem"
	      }, /*#__PURE__*/React__default['default'].createElement("span", {
	        className: "ril-toolbar__item__child ril__toolbarItemChild"
	      }, imageTitle))), /*#__PURE__*/React__default['default'].createElement("ul", {
	        className: "ril-toolbar-right ril__toolbarSide ril__toolbarRightSide"
	      }, toolbarButtons && toolbarButtons.map(function (button, i) {
	        return /*#__PURE__*/React__default['default'].createElement("li", {
	          key: "button_".concat(i + 1),
	          className: "ril-toolbar__item ril__toolbarItem"
	        }, button);
	      }), enableZoom && /*#__PURE__*/React__default['default'].createElement("li", {
	        className: "ril-toolbar__item ril__toolbarItem"
	      }, /*#__PURE__*/React__default['default'].createElement("button", {
	        // Lightbox zoom in button
	        type: "button",
	        key: "zoom-in",
	        "aria-label": this.props.zoomInLabel,
	        title: this.props.zoomInLabel,
	        className: ['ril-zoom-in', 'ril__toolbarItemChild', 'ril__builtinButton', 'ril__zoomInButton'].concat(_toConsumableArray(zoomLevel === MAX_ZOOM_LEVEL ? ['ril__builtinButtonDisabled'] : [])).join(' '),
	        ref: this.zoomInBtn,
	        disabled: this.isAnimating() || zoomLevel === MAX_ZOOM_LEVEL,
	        onClick: !this.isAnimating() && zoomLevel !== MAX_ZOOM_LEVEL ? this.handleZoomInButtonClick : undefined
	      })), enableZoom && /*#__PURE__*/React__default['default'].createElement("li", {
	        className: "ril-toolbar__item ril__toolbarItem"
	      }, /*#__PURE__*/React__default['default'].createElement("button", {
	        // Lightbox zoom out button
	        type: "button",
	        key: "zoom-out",
	        "aria-label": this.props.zoomOutLabel,
	        title: this.props.zoomOutLabel,
	        className: ['ril-zoom-out', 'ril__toolbarItemChild', 'ril__builtinButton', 'ril__zoomOutButton'].concat(_toConsumableArray(zoomLevel === MIN_ZOOM_LEVEL ? ['ril__builtinButtonDisabled'] : [])).join(' '),
	        ref: this.zoomOutBtn,
	        disabled: this.isAnimating() || zoomLevel === MIN_ZOOM_LEVEL,
	        onClick: !this.isAnimating() && zoomLevel !== MIN_ZOOM_LEVEL ? this.handleZoomOutButtonClick : undefined
	      })), /*#__PURE__*/React__default['default'].createElement("li", {
	        className: "ril-toolbar__item ril__toolbarItem"
	      }, /*#__PURE__*/React__default['default'].createElement("button", {
	        // Lightbox close button
	        type: "button",
	        key: "close",
	        "aria-label": this.props.closeLabel,
	        title: this.props.closeLabel,
	        className: "ril-close ril-toolbar__item__child ril__toolbarItemChild ril__builtinButton ril__closeButton",
	        onClick: !this.isAnimating() ? this.requestClose : undefined // Ignore clicks during animation
	
	      })))), this.props.imageCaption &&
	      /*#__PURE__*/
	      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
	      React__default['default'].createElement("div", {
	        // Image caption
	        onWheel: this.handleCaptionMousewheel,
	        onMouseDown: function onMouseDown(event) {
	          return event.stopPropagation();
	        },
	        className: "ril-caption ril__caption",
	        ref: this.caption
	      }, /*#__PURE__*/React__default['default'].createElement("div", {
	        className: "ril-caption-content ril__captionContent"
	      }, this.props.imageCaption))));
	    }
	  }], [{
	    key: "isTargetMatchImage",
	    value: function isTargetMatchImage(target) {
	      return target && /ril-image-current/.test(target.className);
	    }
	  }, {
	    key: "parseMouseEvent",
	    value: function parseMouseEvent(mouseEvent) {
	      return {
	        id: 'mouse',
	        source: SOURCE_MOUSE,
	        x: parseInt(mouseEvent.clientX, 10),
	        y: parseInt(mouseEvent.clientY, 10)
	      };
	    }
	  }, {
	    key: "parseTouchPointer",
	    value: function parseTouchPointer(touchPointer) {
	      return {
	        id: touchPointer.identifier,
	        source: SOURCE_TOUCH,
	        x: parseInt(touchPointer.clientX, 10),
	        y: parseInt(touchPointer.clientY, 10)
	      };
	    }
	  }, {
	    key: "parsePointerEvent",
	    value: function parsePointerEvent(pointerEvent) {
	      return {
	        id: pointerEvent.pointerId,
	        source: SOURCE_POINTER,
	        x: parseInt(pointerEvent.clientX, 10),
	        y: parseInt(pointerEvent.clientY, 10)
	      };
	    } // Request to transition to the previous image
	
	  }, {
	    key: "getTransform",
	    value: function getTransform(_ref13) {
	      var _ref13$x = _ref13.x,
	          x = _ref13$x === void 0 ? 0 : _ref13$x,
	          _ref13$y = _ref13.y,
	          y = _ref13$y === void 0 ? 0 : _ref13$y,
	          _ref13$zoom = _ref13.zoom,
	          zoom = _ref13$zoom === void 0 ? 1 : _ref13$zoom,
	          width = _ref13.width,
	          targetWidth = _ref13.targetWidth;
	      var nextX = x;
	      var windowWidth = getWindowWidth();
	
	      if (width > windowWidth) {
	        nextX += (windowWidth - width) / 2;
	      }
	
	      var scaleFactor = zoom * (targetWidth / width);
	      return {
	        transform: "translate3d(".concat(nextX, "px,").concat(y, "px,0) scale3d(").concat(scaleFactor, ",").concat(scaleFactor, ",1)")
	      };
	    }
	  }]);
	
	  return ReactImageLightbox;
	}(React.Component);
	
	ReactImageLightbox.propTypes = {
	  //-----------------------------
	  // Image sources
	  //-----------------------------
	  // Main display image url
	  mainSrc: PropTypes__default['default'].string.isRequired,
	  // eslint-disable-line react/no-unused-prop-types
	  // Previous display image url (displayed to the left)
	  // If left undefined, movePrev actions will not be performed, and the button not displayed
	  prevSrc: PropTypes__default['default'].string,
	  // Next display image url (displayed to the right)
	  // If left undefined, moveNext actions will not be performed, and the button not displayed
	  nextSrc: PropTypes__default['default'].string,
	  //-----------------------------
	  // Image thumbnail sources
	  //-----------------------------
	  // Thumbnail image url corresponding to props.mainSrc
	  mainSrcThumbnail: PropTypes__default['default'].string,
	  // eslint-disable-line react/no-unused-prop-types
	  // Thumbnail image url corresponding to props.prevSrc
	  prevSrcThumbnail: PropTypes__default['default'].string,
	  // eslint-disable-line react/no-unused-prop-types
	  // Thumbnail image url corresponding to props.nextSrc
	  nextSrcThumbnail: PropTypes__default['default'].string,
	  // eslint-disable-line react/no-unused-prop-types
	  //-----------------------------
	  // Event Handlers
	  //-----------------------------
	  // Close window event
	  // Should change the parent state such that the lightbox is not rendered
	  onCloseRequest: PropTypes__default['default'].func.isRequired,
	  // Move to previous image event
	  // Should change the parent state such that props.prevSrc becomes props.mainSrc,
	  //  props.mainSrc becomes props.nextSrc, etc.
	  onMovePrevRequest: PropTypes__default['default'].func,
	  // Move to next image event
	  // Should change the parent state such that props.nextSrc becomes props.mainSrc,
	  //  props.mainSrc becomes props.prevSrc, etc.
	  onMoveNextRequest: PropTypes__default['default'].func,
	  // Called when an image fails to load
	  // (imageSrc: string, srcType: string, errorEvent: object): void
	  onImageLoadError: PropTypes__default['default'].func,
	  // Called when image successfully loads
	  onImageLoad: PropTypes__default['default'].func,
	  // Open window event
	  onAfterOpen: PropTypes__default['default'].func,
	  //-----------------------------
	  // Download discouragement settings
	  //-----------------------------
	  // Enable download discouragement (prevents [right-click -> Save Image As...])
	  discourageDownloads: PropTypes__default['default'].bool,
	  //-----------------------------
	  // Animation settings
	  //-----------------------------
	  // Disable all animation
	  animationDisabled: PropTypes__default['default'].bool,
	  // Disable animation on actions performed with keyboard shortcuts
	  animationOnKeyInput: PropTypes__default['default'].bool,
	  // Animation duration (ms)
	  animationDuration: PropTypes__default['default'].number,
	  //-----------------------------
	  // Keyboard shortcut settings
	  //-----------------------------
	  // Required interval of time (ms) between key actions
	  // (prevents excessively fast navigation of images)
	  keyRepeatLimit: PropTypes__default['default'].number,
	  // Amount of time (ms) restored after each keyup
	  // (makes rapid key presses slightly faster than holding down the key to navigate images)
	  keyRepeatKeyupBonus: PropTypes__default['default'].number,
	  //-----------------------------
	  // Image info
	  //-----------------------------
	  // Image title
	  imageTitle: PropTypes__default['default'].node,
	  // Image caption
	  imageCaption: PropTypes__default['default'].node,
	  // Optional crossOrigin attribute
	  imageCrossOrigin: PropTypes__default['default'].string,
	  //-----------------------------
	  // Lightbox style
	  //-----------------------------
	  // Set z-index style, etc., for the parent react-modal (format: https://github.com/reactjs/react-modal#styles )
	  reactModalStyle: PropTypes__default['default'].shape({}),
	  // Padding (px) between the edge of the window and the lightbox
	  imagePadding: PropTypes__default['default'].number,
	  wrapperClassName: PropTypes__default['default'].string,
	  //-----------------------------
	  // Other
	  //-----------------------------
	  // Array of custom toolbar buttons
	  toolbarButtons: PropTypes__default['default'].arrayOf(PropTypes__default['default'].node),
	  // When true, clicks outside of the image close the lightbox
	  clickOutsideToClose: PropTypes__default['default'].bool,
	  // Set to false to disable zoom functionality and hide zoom buttons
	  enableZoom: PropTypes__default['default'].bool,
	  // Override props set on react-modal (https://github.com/reactjs/react-modal)
	  reactModalProps: PropTypes__default['default'].shape({}),
	  // Aria-labels
	  nextLabel: PropTypes__default['default'].string,
	  prevLabel: PropTypes__default['default'].string,
	  zoomInLabel: PropTypes__default['default'].string,
	  zoomOutLabel: PropTypes__default['default'].string,
	  closeLabel: PropTypes__default['default'].string,
	  imageLoadErrorMessage: PropTypes__default['default'].node,
	  // custom loader
	  loader: PropTypes__default['default'].node
	};
	ReactImageLightbox.defaultProps = {
	  imageTitle: null,
	  imageCaption: null,
	  toolbarButtons: null,
	  reactModalProps: {},
	  animationDisabled: false,
	  animationDuration: 300,
	  animationOnKeyInput: false,
	  clickOutsideToClose: true,
	  closeLabel: 'Close lightbox',
	  discourageDownloads: false,
	  enableZoom: true,
	  imagePadding: 10,
	  imageCrossOrigin: null,
	  keyRepeatKeyupBonus: 40,
	  keyRepeatLimit: 180,
	  mainSrcThumbnail: null,
	  nextLabel: 'Next image',
	  nextSrc: null,
	  nextSrcThumbnail: null,
	  onAfterOpen: function onAfterOpen() {},
	  onImageLoadError: function onImageLoadError() {},
	  onImageLoad: function onImageLoad() {},
	  onMoveNextRequest: function onMoveNextRequest() {},
	  onMovePrevRequest: function onMovePrevRequest() {},
	  prevLabel: 'Previous image',
	  prevSrc: null,
	  prevSrcThumbnail: null,
	  reactModalStyle: {},
	  wrapperClassName: '',
	  zoomInLabel: 'Zoom in',
	  zoomOutLabel: 'Zoom out',
	  imageLoadErrorMessage: 'This image failed to load',
	  loader: undefined
	};
	
	exports.default = ReactImageLightbox;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(1015);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(52);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(55);
	
	var _defaultArrowRenderer = __webpack_require__(431);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(432);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(170);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(171);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(429);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(430);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ },
/* 129 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/hospital.5ebd3bf6.png";

/***/ },
/* 131 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-4.1daf3ca6.png";

/***/ },
/* 133 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 134 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo2.93ec62fb.png";

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/new2.a0f9254d.png";

/***/ },
/* 137 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAxCAYAAACYq/ofAAAAAXNSR0IArs4c6QAACaZJREFUaEPtmXtwVOUZh5+zZ+/3ZJckJIGgBEJIuMklQBFUFIHiQFEIiFgvtbXjVIqldRzRioXC6KDVWlsd8dKhgiggAqNCUBEE0YBCQBCSzYVNNskmuyR7y9475yhOpy3JhsDAOJyZ88/OOd/5nvf93t97WSGZTCb5EVzCFZDLzItXPHKZOYQrHrnikYtkgfM/WskkyViMWCBIuL2dmN9PoqODZDyBICpQaLWozCbUZjNKvR5BqbxICN8te14gEkDY46XD6SRQ5cB38hSB6hpira0kwhEUWg1Kuw3D1VdjLhiIoWAgupxsVEYjgiheFKDugSSTxMNhQqfrcX7wIZ6yj0hUOVCGQigFAVEholAISMVCLB4nmkwS0evQjBxB1vRp2EvGoMvKRFSrQRAuKFDqIMkkiUgE94EvcL72T5JfHkRo99GuVtGWnk6iTy6q7CxEg564z0/E5UKsqyfNewZDNEqklw3dlMnk3DobW3ERolZ7CUAkCwcCNHy8G/eLL6GqrMItQGjoENInjMeen49Gp0VIgkKnRWk2E43F8LtcuI9U4N+5C7OjFrVOizh2DJnz5pI1YbwcOxfq6tojySRRn5/m/ftxPv0X9I5q6tPMmGdMxz7yGmJn2vB9fZhoZRWCP0DSlo7pp9MomD0LhVJJ0HsG16FDNL77HuIX5ejjCcQxI+l1793kTPgJwgU6Yl2CxCMR2r45Ts3Kp1B+eYh6qxnb/LmY8vKIHDlKvPwg1LuIBAP4VEoieX3Jur2UYfNKUarVJBIJOnw+Wo4ew7nxXaK7PsYoKBBuuoGCJYsxZGVeEKd0CpKMxwk2NODcsJGOl9fQGouhuesOMocPI/TZfsK799Lh8RC221ANHICmbx90V/XDPuoasgoLUXyvUFLwRwJBXOXl1K97i8QnezDm5GBd9AB9p05B1Gh6DNMpSCwYxFt+kJqnVqM6cgxXySgK7r+PUPlBOrZ9QMDrJVk8GNOka7EWF2PMzEBntaAxmVDrdP+zuaDXS+2OMlyvvYGlzgk33sCgRx9Gn5HR4yPWKUjI7aZp63ZaV62mHUhb+jBmqwXfK6/jP3mKxOhR2GfPpHfJaAw2G0qVCkGhOKd1k4kELQ4HNf9aT3jtOrQ5OeSsWk7myBEoVKoeeeWcINJH2yurcK55Hda/w8m8HMY//yyuTe8ibtmOx2LCft895E2fiiEtrVOA/9xhOBiivmwX1X/6M5lS8nzwAfJLb/suWfYg8M8JkojHaZWP1TMYDldwYtJ4Ji5ehOOxZQiHjxKfNoW8X/2CrCHF3dqAFC9NBw9xfMVKsr75lvaZMyheshi93Z6yMf6f684JEo9Gce/ZS/WyFZibW3AuLGX4lCnUL/4D/tNO7It/Qx9JvTIyun0kWk58y8nnXsC6cxeeCeMYunwZxt69fxCHbi/YWa0lya77k91UL30CUyBE64P3UzhmNA2PPE5LSyv5Sx8hZ+pNqM4jQ3sqq6j8x8voN27BM3oEw55ehSk39yKC7P6U6sefxNTmo/nX9zJ2/jwqd+wkFI7Q/7pJ2PrldetYnbV066lKKl98CdN722gZM4phq5ZfPJBENIZ7/wEcK1ZhqanFccs0pi5fRjQclotCjcGAeJ5K4644yomnn8W2/wCtN17HiMcfxSBJcA8q405Vy3vsG2pf+Dv6HWUcKxrEjHVrURkMcuUaj8dlA4ui2C2vSCLi+mwfJx5bRra7ldBddzD4vnvQWCwXJ9ilTQYaGnC99Q7+516g2Wyk4MW/kj1iBG3V1Ti3v09cpyX3pslkFhamHJ/+lhbqNm/B/czzWIwmrCv+SJ9JE3tc2neaEKM+H+5P91K3fCUqVyNts2YwaslD+GrqcLz6GhGjgfwF88krKUkJJBGNUv/5AWpfWoPmi3LiI4dTsOJJrFKsdZJIU1m8UxDpw74qBzWvvIri7c0029LI+N0i7IMGcabiKAmdlt4lY0jv1y+VbyEFee36Dfg2bsakUqO5eyED7rwD9ffHNaVFzvFQ59WvVOz5fDR/to+m1c/ByVO0jxhGRukcbEOK5QDVWi2ouij6pCqhra6O01u307b5PdSuRhSjR5L3+4ewFw3usTdS6tnlCripibpNWwiuXU+0uYnI8KH0+tlMMsePw5SdjUp37m4vGgziOXWKxg/L8O8oQ6xzIl6Vh2bWLRQsuB2N2dQTR/zwbpf9iPSkdMT8znqq1r6JYscuQi4X4X55GK+biG30KAx5fdGkp6HWGxCknj2RIBIIEG714K+upmlHGdF9n6Py+UlkZhAbmI9l2FAyx41DlZ4mq55eet9gOO+kmBKIDBOP015bi3PzFuK7PiFSU4tP2nB2FrqiQqxFRXKPIaqU8oDC72zAW1FB+NhxjM1utNLxKxxIdEA+IY+X8OEKtAPyUefmIChFMoYOxX7NcIy9sxE16m57KWUQaWXJ0iF3C42fH6Bl+/soDleg9J4hGosSBmKCgphCQEwmUSfiaBDkpBmWJifjSug1+XrUNhtNZR/hX/MG1kCAkJQEFRAwGDHPmU2/0tuw9u/f7WTbLZCzZkqEw3irHLi/+hrvV4cJnziBsrFZHgsJ0uBOUBDRaYj3zkJTNJheY0vIGD5ULgylf5Vcu/fg+NNKcmvraLZYiGpUpLV48KtV6BfOJ3fuHNL6Xy33/Kle5wVy1juxUIgOj5dAUxOhllaiAb88fVSo1IhGI3q7DWNmJtr0NLmdlXKF1MNLmf340ifIbmik7ebJ9Jo4kdo312E7epyAWonu1ln0mT8P+6CClBXtvEFkS0mzrkQCSdnkO5GQf0NQgEKQA1e65WT3fdMk1WktRyo4+dRqrHv20Zqbjf2hRWi0WlzrN6AvP0RCo0acdjPZt88jo7goJZiegaTq9/96Ltjs5vTWbTQ9/zcs7X48gwaSuaAUpU6PZ8tWRGn4p9OhmX4zuT9fiDW/f5f13CUBkZo2X3UNtRvewff2JrTtPsJDirDMukUO8rYPdyKWH0LTJxftnQvoP3dOl0p2SUAkB0kS3VblwLl1O6G3NyGeaSNWVIjmxuvlUsa4ey9mQUF89kwGLfktqi6mkpcMRIaJRPA5nZxev4Hgtg8Q3G7iA/MJhcNYTzdgSE+H+XPo/8t7UXbRiV5SkLPq115Xh2P9BuIf7SbmdCKEI+hMZnTjx2JZUCrLd1dN1yUHOat+bVLVsHMX4fJDiP4Aqr59sE66ll7jx6Iym7uUlcsD5HspD3o8BBqb5PjRpVnl6lqe2Kcw77p8QLq0eecPXAHpoQEv+OtXPHLBTdrDBX80Hvk3qiWlqmSl1TUAAAAASUVORK5CYII="

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(44);
	var normalizeHeaderName = __webpack_require__(486);
	var AxiosError = __webpack_require__(80);
	var transitionalDefaults = __webpack_require__(191);
	var toFormData = __webpack_require__(195);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(187);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(187);
	  }
	  return adapter;
	}
	
	function stringifySafely(rawValue, parser, encoder) {
	  if (utils.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }
	
	  return (encoder || JSON.stringify)(rawValue);
	}
	
	var defaults = {
	
	  transitional: transitionalDefaults,
	
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	
	    var isObjectPayload = utils.isObject(data);
	    var contentType = headers && headers['Content-Type'];
	
	    var isFileList;
	
	    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
	      var _FormData = this.env && this.env.FormData;
	      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
	    } else if (isObjectPayload || contentType === 'application/json') {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }
	
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional || defaults.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
	
	    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
	          }
	          throw e;
	        }
	      }
	    }
	
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  env: {
	    FormData: __webpack_require__(487)
	  },
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  },
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    }
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(396)))

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollapsibleButton = function (_React$Component) {
	  _inherits(CollapsibleButton, _React$Component);
	
	  function CollapsibleButton(props) {
	    _classCallCheck(this, CollapsibleButton);
	
	    var _this = _possibleConstructorReturn(this, (CollapsibleButton.__proto__ || Object.getPrototypeOf(CollapsibleButton)).call(this, props));
	
	    _this.state = { isOpen: false };
	    _this.toggleOpen = _this.toggleOpen.bind(_this);
	    return _this;
	  }
	
	  _createClass(CollapsibleButton, [{
	    key: "toggleOpen",
	    value: function toggleOpen() {
	      this.setState(function (prevState) {
	        return { isOpen: !prevState.isOpen };
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var isOpen = this.state.isOpen;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "button",
	          {
	            onClick: this.toggleOpen,
	            style: { border: "none", borderRadius: "5px" }
	          },
	          isOpen ? _react2.default.createElement(
	            "svg",
	            {
	              xmlns: "http://www.w3.org/2000/svg",
	              width: "32",
	              height: "32",
	              fill: "currentColor",
	              className: "bi bi-x",
	              viewBox: "0 0 16 16"
	            },
	            _react2.default.createElement("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" })
	          ) : _react2.default.createElement(
	            "svg",
	            {
	              xmlns: "http://www.w3.org/2000/svg",
	              width: "32",
	              height: "32",
	              fill: "currentColor",
	              className: "bi bi-list",
	              viewBox: "0 0 16 16"
	            },
	            _react2.default.createElement("path", {
	              fillRule: "evenodd",
	              d: "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
	            })
	          )
	        ),
	        isOpen && _react2.default.createElement(
	          "div",
	          null,
	          this.props.content
	        )
	      );
	    }
	  }]);
	
	  return CollapsibleButton;
	}(_react2.default.Component);
	
	exports.default = CollapsibleButton;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadioGroup = function (_React$Component) {
	  _inherits(RadioGroup, _React$Component);
	
	  function RadioGroup(props) {
	    _classCallCheck(this, RadioGroup);
	
	    var _this = _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this, props));
	
	    _this.state = { value: _this.props.value };
	    _this.handleOptionChange = _this.handleOptionChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(RadioGroup, [{
	    key: "handleOptionChange",
	    value: function handleOptionChange(event) {
	      this.setState({ value: event.target.value });
	      this.props.onChange(event.target.value);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          name = _props.name,
	          options = _props.options;
	      var value = this.state.value;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        options.map(function (option) {
	          return _react2.default.createElement(
	            "label",
	            { style: { marginRight: "20px" }, key: option.value },
	            _react2.default.createElement("input", {
	              style: { marginRight: "5px" },
	              type: "radio",
	              name: name,
	              value: option.value,
	              checked: value === option.value,
	              onChange: _this2.handleOptionChange
	            }),
	            option.label
	          );
	        })
	      );
	    }
	  }]);
	
	  return RadioGroup;
	}(_react2.default.Component);
	
	exports.default = RadioGroup;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(92);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var EmailConfigComponent = function EmailConfigComponent(_ref) {
	  var title = _ref.title,
	      label = _ref.label,
	      query = _ref.query,
	      formHelp = _ref.formHelp,
	      inputType = _ref.inputType;
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      adminEmail = _useState2[0],
	      setAdminEmail = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      saveAdminLoading = _useState4[0],
	      setSaveAdminLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      error = _useState6[0],
	      setError = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      postResponseAdminRole = _useState8[0],
	      setPostResponseAdminEmail = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      loading = _useState10[0],
	      setLoading = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({}),
	      _useState12 = _slicedToArray(_useState11, 2),
	      responseData = _useState12[0],
	      setResponseData = _useState12[1];
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _.scAxiosAdmin.request("/settings/" + query, {
	                  method: "get",
	                  headers: {
	                    Accept: "application/json",
	                    Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                  },
	                  params: {
	                    // ...data
	                  }
	                });
	
	              case 3:
	                response = _context.sent;
	
	                setResponseData(response.data);
	                setAdminEmail(response.data.value);
	                setLoading(false);
	                _context.next = 13;
	                break;
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0);
	                setLoading(false);
	
	              case 13:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 9]]);
	      }));
	
	      return function fetchData() {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	  var handleTextChange = function handleTextChange(event) {
	    setAdminEmail(event.target.value);
	  };
	
	  var handleSubmit = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(event) {
	      var requestData, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              event.preventDefault();
	              setSaveAdminLoading(true);
	              setError(null);
	              requestData = {
	                value: adminEmail
	              };
	              // console.log("some data", checkedIds, roleName)
	
	              _context2.prev = 4;
	              _context2.next = 7;
	              return _.scAxiosAdmin.post("/settings_update/" + query, requestData, {
	                method: "post",
	                headers: {
	                  Accept: "application/json",
	                  "Content-Type": "application/json",
	                  Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                }
	              });
	
	            case 7:
	              response = _context2.sent;
	
	              setPostResponseAdminEmail(response.data);
	              setSaveAdminLoading(false);
	              _reactToastify.toast.success("Admin Emails Updated Successfully!");
	              _context2.next = 17;
	              break;
	
	            case 13:
	              _context2.prev = 13;
	              _context2.t0 = _context2["catch"](4);
	
	              setError(_context2.t0);
	              setSaveAdminLoading(false);
	
	            case 17:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[4, 13]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    { className: "page-content-wrapper", style: { margin: 0 } },
	    _react2.default.createElement(
	      "div",
	      { className: "header-bg" },
	      _react2.default.createElement(
	        "div",
	        { className: "container-fluid" },
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex pt-5" },
	          _react2.default.createElement(
	            "h4",
	            null,
	            title
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "header-bg" },
	      _react2.default.createElement(
	        "div",
	        { className: "container-fluid" },
	        _react2.default.createElement(
	          "form",
	          { onSubmit: handleSubmit },
	          _react2.default.createElement(
	            "div",
	            { className: "form-group" },
	            inputType == "textarea" ? _react2.default.createElement("textarea", { className: "form-control", id: "textInput", placeholder: label, value: adminEmail, onChange: handleTextChange }) : _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control",
	              id: "textInput"
	              // placeholder="Admin Email"
	              , placeholder: label,
	              value: adminEmail,
	              onChange: handleTextChange
	            })
	          ),
	          formHelp ? _react2.default.createElement(
	            "div",
	            { className: "" },
	            _react2.default.createElement(
	              "small",
	              null,
	              formHelp
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ) : "",
	          _react2.default.createElement(
	            "div",
	            { className: "form-group text-right" },
	            _react2.default.createElement(
	              "button",
	              { type: "submit", className: "btn btn-primary" },
	              saveAdminLoading ? "Saving..." : "Submit"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = EmailConfigComponent;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	__webpack_require__(8);
	
	var _Loading_icon = __webpack_require__(56);
	
	var _Loading_icon2 = _interopRequireDefault(_Loading_icon);
	
	var _ConfirmAppointmentAndRequestAppointment = __webpack_require__(143);
	
	var _ConfirmAppointmentAndRequestAppointment2 = _interopRequireDefault(_ConfirmAppointmentAndRequestAppointment);
	
	var _ConfirmAppointmentAndRequestAppointmentParticularDoctor = __webpack_require__(207);
	
	var _ConfirmAppointmentAndRequestAppointmentParticularDoctor2 = _interopRequireDefault(_ConfirmAppointmentAndRequestAppointmentParticularDoctor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookAppointmentParticularDoctorPopUp = function BookAppointmentParticularDoctorPopUp(_ref) {
	  var doctorDataPorp = _ref.doctorData,
	      setSelectedDoctor = _ref.setSelectedDoctor;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchResults = _useState2[0],
	      setSearchResults = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      departmentId = _useState4[0],
	      setDepartmentId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    DoctorID: "",
	    PreferredDate: "",
	    doctorData: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      scheduleReqData = _useState8[0],
	      setScheduleReqData = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    selectedDepartment: "all",
	    searchedText: ""
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      formData = _useState10[0],
	      setFormData = _useState10[1];
	
	  var formatedDoc = null;
	  if (doctorDataPorp !== null && doctorDataPorp.doctor_name !== undefined) {
	    formatedDoc = doctorDataPorp.doctor_name.toLowerCase();
	  }
	
	  // const formatedDoc = null;
	  var alertStyle = {
	    color: "red"
	  };
	
	  var inputStyles = {
	    borderRadius: "10px",
	    background: "#fff",
	    borderRight: "solid 1px #fff",
	    border: "solid 2px #6e6e6ed0",
	    padding: "15px 15px",
	    fontSize: "16px",
	    color: "#000",
	    width: "100%"
	  };
	
	  (0, _react.useEffect)(function () {
	    if (doctorDataPorp) {
	      setScheduleReqData(Object.assign({}, scheduleReqData, {
	        DoctorID: doctorDataPorp.id,
	        doctorData: doctorDataPorp
	      }));
	    }
	  }, [doctorDataPorp]);
	
	  (0, _react.useEffect)(function () {
	    var getSearchDoctors = function getSearchDoctors(data) {
	      try {
	        setLoading(true);
	        var req = _.scAxiosAdmin.request("/search/find_a_doctor", {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          },
	          params: {
	            keyword: formData.searchedText ? formData.searchedText : formatedDoc ? formatedDoc : "",
	            deparment: formData.selectedDepartment
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            setLoading(false);
	            setSearchResults(data.data.doctors);
	          }
	        }).catch(function (e) {
	          setLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getSearchDoctors();
	  }, [formData.searchedText, doctorDataPorp]);
	
	  (0, _react.useEffect)(function () {
	    setDepartmentId(formData.selectedDepartment);
	  }, [formData.selectedDepartment]);
	  (0, _react.useEffect)(function () {
	    if (formData.searchedText) {
	      setSearchResults(searchResults);
	    } else if (doctorDataPorp !== null) {
	      setSearchResults(doctorDataPorp);
	    }
	  }, [doctorDataPorp, formData.searchedText]);
	
	  var handleSubmit = function handleSubmit(event, props) {
	    event.preventDefault();
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        "class": "offcanvas offcanvas-start bookAppointPopup",
	        "data-bs-scroll": "true",
	        tabindex: "-1",
	        id: "BookAppointMentParticularDoctorPopUp",
	        "aria-labelledby": "offcanvasWithBothOptionsLabel"
	      },
	      _react2.default.createElement(
	        "div",
	        { "class": "offcanvas-header" },
	        _react2.default.createElement("h5", { "class": "offcanvas-title", id: "offcanvasWithBothOptionsLabel" }),
	        _react2.default.createElement("button", {
	          type: "button",
	          "class": "btn-close text-reset",
	          "data-bs-dismiss": "offcanvas",
	          "aria-label": "Close",
	          onClick: function onClick() {
	            setSelectedDoctor(null);
	          }
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { "class": "offcanvas-body" },
	        _react2.default.createElement(
	          "div",
	          { className: "left-offcanvas" },
	          _react2.default.createElement(
	            "div",
	            { className: "offcan-top-mar" },
	            _react2.default.createElement(
	              "h4",
	              { style: { color: "#af9763" } },
	              "Book Appointment"
	            )
	          ),
	          _react2.default.createElement(
	            "form",
	            {
	              onSubmit: handleSubmit,
	              className: "needs-validation",
	              noValidate: true
	            },
	            _react2.default.createElement("input", {
	              type: "text",
	              style: inputStyles,
	              className: "custom-form-control",
	              placeholder: "Search With Doctors Name...",
	              name: "searchTerm",
	              id: "searchTerm",
	              value: formData.searchedText,
	              onChange: function onChange(e) {
	                return setFormData(Object.assign({}, formData, { searchedText: e.target.value }));
	              },
	              required: true,
	              autoComplete: "off"
	              // style={input_field_css}
	            }),
	            _react2.default.createElement("span", { style: alertStyle }),
	            _react2.default.createElement(
	              "div",
	              { className: "row mt-3" },
	              _react2.default.createElement("span", { style: alertStyle }),
	              searchResults && searchResults.length > 0 ? searchResults.slice(0, 1).map(function (search_doctor) {
	                return _react2.default.createElement(
	                  "div",
	                  { className: "col-12 sp-0-0 mb-3", key: search_doctor.id },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "doctor-list" },
	                    _react2.default.createElement("input", {
	                      type: "radio",
	                      className: "doctor_id",
	                      name: "doctor_id",
	                      value: search_doctor.id,
	                      onChange: function onChange() {
	                        return setScheduleReqData(Object.assign({}, scheduleReqData, {
	                          DoctorID: search_doctor.id,
	                          doctorData: search_doctor
	                        }));
	                      },
	                      doctorName: search_doctor.doctor_name,
	                      deptid: search_doctor.dept_id
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-3", style: { paddingLeft: "0px" } },
	                        search_doctor.doctor_profile ? _react2.default.createElement("img", {
	                          src: _constants.IMAGE_URL + "/DoctorProfileImg/" + search_doctor.doctor_profile,
	                          alt: "doctor profile"
	                        }) :
	                        /*<img src={doc} alt="doc"/>*/
	                        _react2.default.createElement("img", {
	                          src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                          alt: "doc"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-9 mt-2" },
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          search_doctor.doctor_name
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          search_doctor.degree !== "" ? search_doctor.degree : "Endocrinology & Metabolism) MD (Endocrinology & Metabolism)"
	                        )
	                      )
	                    )
	                  )
	                );
	              }) : _react2.default.createElement(
	                "div",
	                { className: "col-12 sp-0-0 mb-3" },
	                loading ? _react2.default.createElement("img", { src: _Loading_icon2.default, alt: "Loading" }) : _react2.default.createElement(
	                  "p",
	                  { style: { color: "red" } },
	                  "No results found!"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row mt-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-6" },
	                _react2.default.createElement("input", {
	                  type: "date",
	                  id: "schedule_date",
	                  name: "schedule_date",
	                  className: "customDatePicker",
	                  onChange: function onChange(e) {
	                    return setScheduleReqData(Object.assign({}, scheduleReqData, {
	                      PreferredDate: e.target.value
	                    }));
	                  },
	                  placeholder: "DD-MM-YYYY",
	                  defaultValue: localStorage.getItem(_constants.SCHEDULE_DATE),
	                  required: true
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    variant: "primary",
	                    "data-bs-dismiss": "offcanvas",
	                    "aria-label": "Close",
	                    "data-bs-toggle": "offcanvas",
	                    "data-bs-target": "#confirmAppointmentOffcanvasParticularDoctor",
	                    "aria-controls": "confirmAppointmentOffcanvasParticularDoctor",
	                    style: {
	                      backgroundColor: !scheduleReqData.PreferredDate ? "" : "rgb(246, 130, 31)"
	                    },
	                    type: "submit",
	                    id: "Schedule",
	                    className: "btn-links",
	                    disabled: !scheduleReqData.PreferredDate ? true : false
	                  },
	                  "Check Schedule"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ConfirmAppointmentAndRequestAppointmentParticularDoctor2.default, {
	      scheduleReqData: scheduleReqData
	    })
	  );
	};
	
	exports.default = BookAppointmentParticularDoctorPopUp;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToastify = __webpack_require__(7);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	__webpack_require__(8);
	
	var _userSession = __webpack_require__(30);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _Loading_icon = __webpack_require__(56);
	
	var _Loading_icon2 = _interopRequireDefault(_Loading_icon);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmAppointmentAndRequestAppointment = function ConfirmAppointmentAndRequestAppointment(_ref) {
	  var scheduleReqData = _ref.scheduleReqData;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      loading = _useState2[0],
	      setLoading = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      appointmentLoading = _useState4[0],
	      setAppointmentLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      newDate = _useState6[0],
	      setNewDate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      slot = _useState8[0],
	      setSlot = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      selectedDoctorData = _useState10[0],
	      setSelectedDoctorData = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(),
	      _useState12 = _slicedToArray(_useState11, 2),
	      bookingResponse = _useState12[0],
	      setBookingResponse = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(),
	      _useState14 = _slicedToArray(_useState13, 2),
	      bookingRequestResponse = _useState14[0],
	      setBookingRequestResponse = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(true),
	      _useState16 = _slicedToArray(_useState15, 2),
	      disabled = _useState16[0],
	      setDisabled = _useState16[1];
	
	  (0, _react.useEffect)(function () {}, []);
	
	  var doctorData = scheduleReqData.doctorData;
	  var dateName = null;
	  var showDate = null;
	  if (newDate) {
	    dateName = new Date(newDate).toLocaleDateString("en-US", {
	      weekday: "long"
	    });
	    showDate = (0, _moment2.default)(newDate).format("LL");
	  } else {
	    dateName = new Date(scheduleReqData.PreferredDate).toLocaleDateString("en-US", { weekday: "long" });
	    showDate = (0, _moment2.default)(scheduleReqData.PreferredDate).format("LL");
	  }
	
	  var schedules = null;
	  if (doctorData && dateName) {
	    var schedulesObject = doctorData.Schedule[0];
	
	    if (dateName) {
	      schedules = schedulesObject[dateName];
	    }
	  }
	
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	  };
	  var handleScheduleAppointment = function handleScheduleAppointment(type) {
	    var scheduleAppointmentPostData = {
	      type: "book_appointment",
	      doctor_id: scheduleReqData.DoctorID,
	      user_patient_id: localStorage.getItem(_constants.USER_LOCAL_ID),
	      appointment_date: scheduleReqData.PreferredDate,
	      appointment_time: slot,
	      patient_phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER),
	      amount: 1500.0,
	      doctor_name: scheduleReqData.doctorData.doctor_name,
	      patient_name: localStorage.getItem(_constants.PATIENT_NAME),
	      doctor_fees: 1500.5
	    };
	    var reqAppointmentPostData = {
	      type: "request_appointment",
	      doctor_id: scheduleReqData.DoctorID,
	      user_patient_id: localStorage.getItem(_constants.USER_LOCAL_ID),
	      appointment_date: scheduleReqData.PreferredDate,
	      patient_phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER),
	      amount: 1500.0,
	      doctor_name: scheduleReqData.doctorData.doctor_name,
	      patient_name: localStorage.getItem(_constants.PATIENT_NAME),
	      doctor_fees: 1500.5
	    };
	    if (type === "schedule_appointment") {
	      try {
	        setAppointmentLoading(true);
	        var req = _.scAxiosAdmin.post("/appointments/request_new", scheduleAppointmentPostData, {
	          method: "post",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 201) {
	            _reactToastify.toast.success("Your request for an appointment is received. We will confirm shortly!!");
	            setBookingResponse(data.data.data);
	            setAppointmentLoading(false);
	          }
	        }).catch(function (e) {
	          _reactToastify.toast.error("Something went wrong!");
	          setAppointmentLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {
	        _reactToastify.toast.error("Something went wrong!");
	        setAppointmentLoading(false);
	      }
	    }
	    if (type === "request_appointment") {
	      try {
	        setAppointmentLoading(true);
	        var _req = _.scAxiosAdmin.post("/appointments/request_new", reqAppointmentPostData, {
	          method: "post",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 201) {
	            _reactToastify.toast.success("Your request for an appointment is received. We will confirm shortly!!");
	            setBookingRequestResponse(data.data.data);
	            setAppointmentLoading(false);
	          }
	        }).catch(function (e) {
	          _reactToastify.toast.error("Something went wrong!");
	          setAppointmentLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {
	        _reactToastify.toast.error("Something went wrong!");
	        setAppointmentLoading(false);
	      }
	    }
	  };
	
	  //
	  //   useEffect(() => {
	  //     const getSingleDoctor = (data) => {
	  //       try {
	  //         setLoading(true);
	  //         const req = scAxiosAdmin
	  //           .request(`/doctors/getsingledoctors/${scheduleReqData.DoctorID}`, {
	  //             method: "get",
	  //             headers: {
	  //               Accept: "application/json",
	  //               Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	  //             },
	  //           })
	  //           .then((data) => {
	  //             if (data.status === 200) {
	  //               setDoctorData(data.data.data);
	  //               setLoading(false);
	  //             }
	  //           })
	  //           .catch((e) => {
	  //             setLoading(false);
	  //             console.log("your log output", e);
	  //           });
	  //       } catch (error) {
	  //         setLoading(false);
	  //       }
	  //     };
	  //     getSingleDoctor();
	  //   }, [scheduleReqData.DoctorID]);
	  return _react2.default.createElement(
	    "div",
	    {
	      className: "offcanvas offcanvas-start",
	      tabIndex: -1,
	      id: "confirmAppointmentOffcanvas",
	      "aria-labelledby": "offcanvasExampleLabel"
	      // style={{ visibility: "visible" }}
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "offcanvas-header" },
	      _react2.default.createElement(
	        "h5",
	        { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	        " "
	      ),
	      _react2.default.createElement("button", {
	        type: "button",
	        className: "btn-close text-reset",
	        "data-bs-dismiss": "offcanvas",
	        "aria-label": "Close",
	        onClick: function onClick() {
	          setNewDate(""), setSlot(null);
	          location.reload();
	        }
	      })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "offcanvas-body" },
	      _react2.default.createElement(
	        "div",
	        { className: "left-offcanvas" },
	        _react2.default.createElement(
	          "h4",
	          { style: { color: "#187979" } },
	          "Book Appointment"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "goback" },
	          _react2.default.createElement(
	            "button",
	            {
	              variant: "primary"
	              // data-bs-toggle="offcanvas"
	              // data-bs-target="#BookAppointMent"
	              // aria-controls="BookAppointMent"
	              , onClick: function onClick() {
	                setNewDate(""), setSlot(null);
	                location.reload();
	              },
	              style: { background: "none", border: "none" }
	            },
	            _react2.default.createElement("i", { className: "fa-solid fa-circle-left" }),
	            " Go Back & Reselect your Doctor"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "sd-container" },
	          _react2.default.createElement(
	            "h6",
	            { className: "timer" },
	            showDate,
	            _react2.default.createElement("input", {
	              type: "date",
	              className: "change_schedule_date",
	              name: "change_schedule_date",
	              id: "change_schedule_date",
	              value: newDate,
	              onChange: function onChange(e) {
	                return setNewDate(e.target.value);
	              }
	              // min={newcurrentdate}
	            }),
	            _react2.default.createElement("i", { className: "moz-cover-clear" }),
	            _react2.default.createElement(
	              "span",
	              { className: "open-button" },
	              _react2.default.createElement(
	                "button",
	                { type: "button" },
	                "\uD83D\uDCC5"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "form",
	          { onSubmit: handleSubmit, className: "needs-validation", noValidate: true },
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 sp-0-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "doctor-list Dr-Reazur" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "row",
	                    onClick: function onClick() {
	                      return setSelectedDoctorData(doctorData);
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-4 sp-0-1 left-0" },
	                    doctorData ? _react2.default.createElement("img", {
	                      src: _constants.IMAGE_URL + "/DoctorProfileImg/" + doctorData.doctor_profile,
	                      alt: "doctor profile"
	                    }) : _react2.default.createElement("img", {
	                      src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                      alt: "doc"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-8", id: "dr" },
	                    _react2.default.createElement(
	                      "h5",
	                      null,
	                      doctorData.doctor_name
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      doctorData.doctor_degree !== "" ? doctorData.doctor_degree : ""
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "mt-2" },
	                      doctorData.doctor_fees !== "" ? _react2.default.createElement(
	                        "strong",
	                        { style: { color: "#fb6201" } },
	                        "BDT ",
	                        doctorData.doctor_fees
	                      ) : _react2.default.createElement("strong", null)
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-4", id: "time-date" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              schedules !== null && schedules !== undefined ? schedules.split(",").map(function (schedule_time, index) {
	                return _react2.default.createElement(
	                  "div",
	                  {
	                    className: "doctor_schedule_section",
	                    key: index,
	                    style: { marginBottom: "5px" }
	                  },
	                  _react2.default.createElement("input", {
	                    type: "radio",
	                    className: "schedule_time",
	                    id: "schedule_date_time",
	                    name: "schedule_date_time",
	                    value: schedule_time,
	                    checked: slot === schedule_time // Ensure that only the currently selected slot is checked
	                    , onChange: function onChange(e) {
	                      if (slot !== e.target.value) {
	                        // Only set the slot if it's not already selected
	                        setSlot(e.target.value);
	                      }
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "btn-links color-check text-center" },
	                    schedule_time,
	                    " ",
	                    showDate
	                  )
	                );
	              }) : _react2.default.createElement(
	                "p",
	                null,
	                "No slots available!"
	              ),
	              appointmentLoading ? _react2.default.createElement("img", { src: _Loading_icon2.default, alt: "Loading" }) : ""
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              schedules !== null && schedules !== undefined ? _react2.default.createElement(
	                "button",
	                {
	                  variant: "primary",
	                  type: "submit",
	                  className: "btn-links appointment-new",
	                  id: "Schedule",
	                  disabled: slot ? false : true,
	                  onClick: function onClick() {
	                    return handleScheduleAppointment("schedule_appointment");
	                  },
	                  style: {
	                    backgroundColor: slot ? "rgb(246, 130, 31)" : ""
	                  }
	                },
	                "Schedule Appointment"
	              ) : _react2.default.createElement(
	                "button",
	                {
	                  variant: "primary",
	                  type: "submit",
	                  className: "btn-links appointment-new",
	                  id: "Schedule",
	                  onClick: function onClick() {
	                    return handleScheduleAppointment("request_appointment");
	                  }
	                },
	                "Request Appointment"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = ConfirmAppointmentAndRequestAppointment;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _userSession = __webpack_require__(30);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _Loading_icon = __webpack_require__(56);
	
	var _Loading_icon2 = _interopRequireDefault(_Loading_icon);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {Route} from 'react-router-dom';
	
	//import doc from '../../images/doc.png';
	
	
	var getSingleDoctorScheduleData = function getSingleDoctorScheduleData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request("/AppointmentSchedule", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleDoctorData = function getSingleDoctorData() {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/getsingledoctors/" + localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID), {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var requestNewAppointment = function requestNewAppointment(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/appointments/request_new", {
	      method: "post",
	      headers: {
	        "Content-Type": "application/json"
	        // Include the Authorization header if needed
	        // "Authorization": "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	      },
	      data: data
	    });
	
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var PopupIndex3 = function (_Component) {
	  _inherits(PopupIndex3, _Component);
	
	  function PopupIndex3() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopupIndex3);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupIndex3.__proto__ || Object.getPrototypeOf(PopupIndex3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      doctor_id: "",
	      doctor_name: "",
	      doctor_degree: "",
	      doctor_scheduler_dates: [],
	      doctor_scheduler_time: [],
	      doctor_fees: "",
	      schedule_date_time: "",
	      change_schedule_date: "",
	      error_res_msg: "",
	      showLoading: false
	    }, _this.handleChange = function (event) {
	
	      _this.setState({
	        schedule_date_time: event.target.value
	      });
	      localStorage.setItem(_constants.SCHEDULE_TIME, event.target.value);
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var schedule_date_time = (0, _jquery2.default)("input[name='schedule_date_time']:checked").val();
	      if (schedule_date_time) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "#fb6201";
	      } else {
	        document.getElementById("Schedule").disabled = true;
	        document.getElementById("Schedule").style.background = "#41414b";
	      }
	    }, _this.handleScheduleAppointment = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var convertDateFormat, doctor_id, patient_id, appointment_date, patient_phone_number, doctor_name, patient_name, doctor_fees, appointmentData, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              convertDateFormat = function convertDateFormat() {
	                // Check if the inputDate is in the format 'Jan 19 2024'
	                var inputDate = localStorage.getItem("schedule_date");
	                var dateParts = inputDate.split(" ");
	                if (dateParts.length === 3) {
	                  var monthAbbreviation = dateParts[0];
	                  var day = dateParts[1];
	                  var year = dateParts[2];
	
	                  // Convert month abbreviation to numerical representation
	                  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                  var month = monthNames.indexOf(monthAbbreviation) + 1;
	
	                  // Create the date string in the 'YYYY-MM-DD' format
	                  var formattedDate = year + "-" + month.toString().padStart(2, "0") + "-" + day.padStart(2, "0");
	
	                  return formattedDate;
	                }
	
	                // If the inputDate is already in the 'YYYY-MM-DD' format, return it as is
	                return inputDate;
	              };
	              // event.preventDefault();
	
	              // Check if doctor_scheduler_time.length is greater than 0 before making the request
	
	              // convertDateFormat();
	              doctor_id = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	              patient_id = localStorage.getItem(_constants.USER_ID);
	              appointment_date = convertDateFormat();
	              patient_phone_number = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	              doctor_name = _this.state.doctor_name ? _this.state.doctor_name : localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME);
	              patient_name = localStorage.getItem(_constants.PATIENT_NAME);
	              doctor_fees = _this.state.doctor_fees;
	
	              // Your logic to make a post request to the API
	
	              _context.prev = 8;
	
	              // Your logic to prepare the data for the appointment request
	              appointmentData = {
	                type: "request_appointment",
	                doctor_id: doctor_id,
	                patient_id: patient_id,
	                appointment_date: appointment_date,
	                patient_phone_number: patient_phone_number,
	                doctor_name: doctor_name,
	                patient_name: patient_name,
	                doctor_fees: doctor_fees
	              };
	              _context.next = 12;
	              return requestNewAppointment(appointmentData);
	
	            case 12:
	              response = _context.sent;
	
	              // console.log('sdfgdsfsert',response)
	              if (response.status === true) {
	                window.location.href = "/success?Paymentmode=booking_request";
	              }
	
	              // Handle the response, show success message, etc.
	
	              // Optionally, you can navigate to another page or perform additional actions after successful request
	              // this.props.history.push('/success-page');
	              _context.next = 19;
	              break;
	
	            case 16:
	              _context.prev = 16;
	              _context.t0 = _context["catch"](8);
	
	              // Handle errors, show error message, etc.
	              console.error("Error requesting appointment:", _context.t0);
	
	            case 19:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[8, 16]]);
	    })), _this.changeScheduleDate = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      var change_schedule_date_val = document.getElementById("change_schedule_date").value;
	
	      var token = localStorage.getItem(_constants.API_TOKEN_NAME);
	      var user_role = localStorage.getItem(_constants.USER_ROLE);
	      var user_email = localStorage.getItem(_constants.USER_EMAIL);
	      var patient_id = localStorage.getItem(_constants.USER_ID);
	      var login_phone_number = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	      var search_selected_doc_id = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	      var schedule_date = change_schedule_date_val;
	      var apointment_id = "";
	      var doctor_name = _this.state.doctor_name;
	      var doctor_fees = _this.state.doctor_fees;
	      var patientName = localStorage.getItem(_constants.PATIENT_NAME);
	      var schedule_time = "";
	      var search_selected_doc_name = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME);
	      (0, _userSession.startUserSession)(token, user_role, user_email, patient_id, login_phone_number, search_selected_doc_id, schedule_date, apointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name);
	      // console.log(change_schedule_date_val,"change_schedule_date_val")
	      /* const inputDate = change_schedule_date_val
	      // Convert input date to Date object
	      const dateObj = new Date(inputDate);
	        // Extract year, month, and day from the Date object
	      const year = dateObj.getFullYear();
	      const month = `0${dateObj.getMonth() + 1}`.slice(-2); // Adding 1 as month starts from 0
	      const day = `0${dateObj.getDate()}`.slice(-2);
	        // Form the desired date string
	      const formattedDate = `${year}-${month}-${day}`; */
	
	      var data = {
	        DoctorID: localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID),
	        PreferredDate: change_schedule_date_val
	      };
	      _this.refreshGetSingleDoctorScheduleData(data);
	    }, _this.handleSubmit = function (event, props) {
	      event.preventDefault();
	      if (_this.validateForm()) {
	        var fields = {};
	        fields["schedule_date_time"] = "";
	        _this.setState({ fields: fields });
	        var token = localStorage.getItem(_constants.API_TOKEN_NAME);
	        var user_role = localStorage.getItem(_constants.USER_ROLE);
	        var user_email = localStorage.getItem(_constants.USER_EMAIL);
	        var phone_number = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	        var search_selected_doc_id = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	        var patientid = localStorage.getItem(_constants.USER_ID);
	        var schedule_date = localStorage.getItem(_constants.SCHEDULE_DATE);
	        //let apointment_id = res[0].AppointmentID;
	        var apointment_id = "";
	        var doctor_name = _this.state.doctor_name;
	        var doctor_fees = _this.state.doctor_fees;
	        var patientName = localStorage.getItem(_constants.PATIENT_NAME);
	        var schedule_time = _this.state.schedule_date_time;
	        var search_selected_doc_name = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME);
	        console.log("let", token, user_role, user_email, search_selected_doc_id, schedule_date, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name);
	
	        (0, _userSession.startUserSession)(token, user_role, user_role, patientid, phone_number, search_selected_doc_id, schedule_date, apointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name);
	        _this.props.nextStep();
	      } else {}
	    }, _this.refreshGetSingleDoctorScheduleData = function (data) {
	      _this.setState({ showLoading: true });
	      getSingleDoctorScheduleData(data).then(function (res) {
	        if (res) {
	          if (res[0].DoctorID) {
	            _this.setState({
	              doctor_scheduler_dates: res[0].DoctorSchedule.Date[1],
	              doctor_scheduler_time: res[0].DoctorSchedule.Time[0],
	              doctor_fees: res[0].Fees,
	              showLoading: false
	            });
	          } else {
	            _this.setState({
	              error_res_msg: "No slot available.",
	              showLoading: false
	            });
	          }
	        } else {
	          _this.setState({ showLoading: false });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("There is error finding doctor slots ! Please check another availability date.", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	    }, _this.refreshGetSingleDoctorData = function () {
	      getSingleDoctorData().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            doctor_name: records.doctor_name,
	            doctor_degree: records.degree,
	            doctor_profile: records.doctor_profile
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("There is error finding doctor data ! Please reselect doctor again.", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	    }, _this.onClickPrevStep = function (props) {
	      _this.props.prevStep();
	    }, _this.closePopup = function (event) {
	      document.getElementById("offcanvasExample").style.visibility = "hidden";
	      document.getElementById("offcanvasExample").classList.remove("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  // requestNewAppointment = async (data) => {
	  //   return new Promise((resolve, reject) => {
	  //     const req = scAxiosAdmin.request("/appointments/request_new", {
	  //       method: "post",
	  //       headers: {
	  //         "Content-Type": "application/json",
	  //         // Include the Authorization header if needed
	  //         // "Authorization": "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	  //       },
	  //       data: data,
	  //     });
	
	  //     req.then((res) => resolve(res.data)).catch((err) => reject(err));
	  //   });
	  // };
	
	
	  _createClass(PopupIndex3, [{
	    key: "validateForm",
	    value: function validateForm() {
	      console.log('insidef');
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!fields["schedule_date_time"]) {
	        formIsValid = false;
	        errors["schedule_date_time"] = "*Please select atleast one schedule time slot.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var inputDate = localStorage.getItem(_constants.SCHEDULE_DATE);
	      // Convert input date to Date object
	      var dateObj = new Date(inputDate);
	
	      // Extract year, month, and day from the Date object
	      var year = dateObj.getFullYear();
	      var month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // Adding 1 as month starts from 0
	      var day = ("0" + dateObj.getDate()).slice(-2);
	
	      // Form the desired date string
	      var formattedDate = year + "-" + month + "-" + day;
	
	      // Output the formatted date
	      var data = {
	        DoctorID: localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID),
	        PreferredDate: formattedDate
	      };
	      this.refreshGetSingleDoctorScheduleData(data);
	      this.refreshGetSingleDoctorData();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var current_date = new Date();
	      var newcurrentdate = (0, _moment2.default)(current_date).format("YYYY-MM-DD");
	      var schedule_data = (0, _moment2.default)(localStorage.getItem(_constants.SCHEDULE_DATE)).format("dddd, LL");
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "offcanvas offcanvas-start show",
	          tabIndex: -1,
	          id: "offcanvasExample",
	          "aria-labelledby": "offcanvasExampleLabel",
	          style: { visibility: "visible" }
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-header" },
	          _react2.default.createElement(
	            "h5",
	            { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	            " "
	          ),
	          _react2.default.createElement("button", {
	            type: "button",
	            className: "btn-close text-reset",
	            "data-bs-dismiss": "offcanvas",
	            "aria-label": "Close",
	            onClick: this.closePopup
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-body" },
	          _react2.default.createElement(
	            "div",
	            { className: "row d-flex justify-content-around", id: "logos" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-2 " },
	              _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "left-offcanvas" },
	            _react2.default.createElement(
	              "h4",
	              { style: { color: "#187979" } },
	              "Book Appointment"
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "goback" },
	              _react2.default.createElement(
	                "button",
	                {
	                  variant: "primary",
	                  onClick: this.onClickPrevStep,
	                  style: { background: "none", border: "none" }
	                },
	                _react2.default.createElement("i", { className: "fa-solid fa-circle-left" }),
	                " Go Back & Reselect your Doctor"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "sd-container" },
	              _react2.default.createElement(
	                "h6",
	                { className: "timer" },
	                schedule_data,
	                " \xA0\xA0",
	                " ",
	                _react2.default.createElement("input", {
	                  type: "date",
	                  className: "change_schedule_date",
	                  name: "change_schedule_date",
	                  id: "change_schedule_date",
	                  value: localStorage.getItem(_constants.SCHEDULE_DATE),
	                  onChange: this.changeScheduleDate,
	                  min: newcurrentdate
	                }),
	                _react2.default.createElement("i", { className: "moz-cover-clear" }),
	                _react2.default.createElement(
	                  "span",
	                  { className: "open-button" },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "button" },
	                    "\uD83D\uDCC5"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "form",
	              {
	                onSubmit: this.handleSubmit,
	                className: "needs-validation",
	                noValidate: true
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12 sp-0-0" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "doctor-list Dr-Reazur" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-4 sp-0-1 left-0" },
	                        this.state.doctor_profile ? _react2.default.createElement("img", {
	                          src: _constants.IMAGE_URL + "/DoctorProfileImg/" + this.state.doctor_profile,
	                          alt: "doctor profile"
	                        }) :
	                        /*<img src={doc} alt="doc"/>*/
	                        _react2.default.createElement("img", {
	                          src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                          alt: "doc"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-8", id: "dr" },
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          this.state.doctor_name
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          this.state.doctor_degree !== "" ? this.state.doctor_degree : ""
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          { className: "mt-2" },
	                          this.state.doctor_fees !== "" ? _react2.default.createElement(
	                            "strong",
	                            { style: { color: "#fb6201" } },
	                            "BDT ",
	                            this.state.doctor_fees
	                          ) : _react2.default.createElement("strong", null)
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              console.log("this.state.change_schedule_date", localStorage.getItem(_constants.SCHEDULE_DATE)),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-4", id: "time-date" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12" },
	                  this.state.showLoading === false ? this.state.doctor_scheduler_time.length > 0 ? this.state.doctor_scheduler_time.split(",").map(function (schedule_time) {
	                    return _react2.default.createElement(
	                      "div",
	                      {
	                        className: "doctor_schedule_section",
	                        key: schedule_time
	                      },
	                      _react2.default.createElement("input", {
	                        type: "radio",
	                        className: "schedule_time",
	                        id: "schedule_date_time",
	                        name: "schedule_date_time",
	                        defaultValue: schedule_time,
	                        value: schedule_time,
	                        onChange: function onChange(e) {
	                          return _this3.handleChange(e);
	                        }
	                      }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "btn-links color-check text-center" },
	                        schedule_time,
	                        " ",
	                        (0, _moment2.default)(localStorage.getItem(_constants.SCHEDULE_DATE)).format("LL")
	                      )
	                    );
	                  }) : _react2.default.createElement(
	                    "p",
	                    null,
	                    this.state.error_res_msg
	                  ) : _react2.default.createElement("img", { src: _Loading_icon2.default, alt: "Loading" }),
	                  _react2.default.createElement(
	                    "span",
	                    { style: alertStyle },
	                    this.state.errors.schedule_time
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12" },
	                  this.state.doctor_scheduler_time.length > 0 && this.state.showLoading === false ? _react2.default.createElement(
	                    "button",
	                    {
	                      variant: "primary",
	                      type: "submit",
	                      className: "btn-links appointment-new",
	                      id: "Schedule",
	                      disabled: true
	                    },
	                    "Schedule Appointment"
	                  ) : _react2.default.createElement(
	                    "button",
	                    {
	                      variant: "primary",
	                      type: "submit",
	                      className: "btn-links appointment-new",
	                      id: "Schedule",
	                      onClick: function onClick() {
	                        return _this3.handleScheduleAppointment();
	                      }
	                    },
	                    "Request Appointment"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return PopupIndex3;
	}(_react.Component);
	
	exports.default = PopupIndex3;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _userSession = __webpack_require__(30);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _PopupIndex = __webpack_require__(70);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPatitentLists = function getPatitentLists(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/mmphonenumber', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var ResetOtpData = function ResetOtpData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request('/user/resetotpdata', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var PatientLoginUser = function PatientLoginUser(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/mmlogin', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var PopupPatientLists = function (_Component) {
	  _inherits(PopupPatientLists, _Component);
	
	  function PopupPatientLists() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopupPatientLists);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupPatientLists.__proto__ || Object.getPrototypeOf(PopupPatientLists)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      get_phone_number: '',
	      patientLists: [],
	      patient_id: '',
	      patient_name: '',
	      showPaymentPopup: false
	    }, _this.handleChange = function (event) {
	      var _this$setState;
	
	      var patientName = (0, _jquery2.default)("input[name='patient_id']:checked").attr('patient_name');
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, event.target.name, event.target.value), _defineProperty(_this$setState, 'patient_name', patientName), _this$setState));
	      var patient_id = (0, _jquery2.default)("input[name='patient_id']:checked").val();
	      if (patient_id) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "#fb6201";
	      } else {
	        document.getElementById("Schedule").disabled = true;
	        document.getElementById("Schedule").style.background = "#41414b";
	      }
	    }, _this.refreshGetPatitentLists = function (data) {
	      getPatitentLists(data).then(function (res) {
	        if (res) {
	          var records = res;
	          _this.setState({ patientLists: records });
	        } else {
	          _this.setState({ patientLists: '' });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      var data = {
	        patientid: _this.state.patient_id
	      };
	      var token = '';
	      var user_role = '2';
	      var user_email = '';
	      var patient_id = _this.state.patient_id;
	      var patientName = _this.state.patient_name;
	      var login_phone_number = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	      var search_selected_doc_id = '';
	      var schedule_date = '';
	      var appointment_id = '';
	      var doctor_name = '';
	      var doctor_fees = '';
	      var schedule_time = '';
	      var search_selected_doc_name = '';
	      PatientLoginUser(data).then(function (res) {
	        //if (!!res[0].token) {
	        //startUserSession(res[0].token, user_role, user_email, patient_id, login_phone_number, search_selected_doc_id, schedule_date, appointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name);
	        (0, _userSession.startUserSession)(token, user_role, user_email, patient_id, login_phone_number, search_selected_doc_id, schedule_date, appointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name);
	        _this.setState({ signin_success: true });
	        _this.refreshResetOTPData();
	        _this.props.nextStep();
	        /*} else {
	            toast.error(res.message, {
	                position: toast.POSITION.BOTTOM_RIGHT
	            });
	        }*/
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshResetOTPData = function (event) {
	      var data = {
	        phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER)
	      };
	      ResetOtpData(data).then(function (res) {
	        if (res.status === true) {} else {}
	      }).catch(function (err) {
	        _reactToastify.toast.error('Error occured', {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	    }, _this.closePopup = function (event) {
	      document.getElementById('offcanvasExample').style.visibility = 'hidden';
	      document.getElementById('offcanvasExample').classList.remove("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PopupPatientLists, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = {
	        PhoneNumber: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER)
	      };
	      if (localStorage.getItem(_constants.LOGIN_PHONE_NUMBER)) {
	        this.refreshGetPatitentLists(data);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'offcanvas offcanvas-start show', tabIndex: '-1', id: 'offcanvasExample', 'aria-labelledby': 'offcanvasExampleLabel', style: { "visibility": "visible" } },
	        _react2.default.createElement(
	          'div',
	          { className: 'offcanvas-header' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'offcanvas-title', id: 'offcanvasExampleLabel' },
	            ' '
	          ),
	          _react2.default.createElement('button', { type: 'button', className: 'btn-close text-reset', 'data-bs-dismiss': 'offcanvas', 'aria-label': 'Close', onClick: this.closePopup })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'offcanvas-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row text-center', id: 'logos' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 ' },
	              _react2.default.createElement('img', { src: _uhlcareLogo2.default, alt: 'uhlcare-logo' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2' },
	              _react2.default.createElement('img', { src: _mainLogo2.default, alt: 'medix-logo' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2' },
	              _react2.default.createElement('img', { src: _UHL2.default, alt: 'uhl-logo' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2' },
	              _react2.default.createElement('img', { src: _medixLogo2.default, alt: 'medix-logo' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2' },
	              _react2.default.createElement('img', { src: _maRashedHospital2.default, alt: 'medix-logo' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'left-offcanvas' },
	            _react2.default.createElement(
	              'div',
	              { className: 'offcan-top-mar' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Patients Lists'
	              )
	            ),
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.handleSubmit, id: 'patientloginform', className: 'needs-validation', noValidate: true },
	              _react2.default.createElement(
	                'div',
	                { className: 'row mt-3' },
	                this.state.patientLists.length > 0 ? this.state.patientLists.map(function (patient_list) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'col-6 sp-0-0 mt-3', key: patient_list.PatientID },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'doctor-list' },
	                      _react2.default.createElement('input', { type: 'radio', className: 'patient_user', name: 'patient_id', value: patient_list.PatientID, onChange: _this2.handleChange, patient_name: patient_list.PatientName }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row list_content_sec' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-5' },
	                          _react2.default.createElement('img', { src: 'https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg', alt: 'doc' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-7' },
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            patient_list.PatientName
	                          )
	                        )
	                      )
	                    )
	                  );
	                }) : _react2.default.createElement(
	                  'div',
	                  { className: 'col-6 sp-0-0' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'doctor-list' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'No Result found'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row mt-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-12' },
	                  _react2.default.createElement(
	                    'button',
	                    { variant: 'primary', type: 'submit', className: 'btn-links appointment-new', id: 'Schedule', disabled: true },
	                    'Log Me In'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        this.state.showPaymentPopup ? _react2.default.createElement(_PopupIndex2.default, { showPopup: this.state.showPaymentPopup }) : '',
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return PopupPatientLists;
	}(_react.Component);
	
	exports.default = PopupPatientLists;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DownloadCSV = function DownloadCSV(_ref) {
	  var data = _ref.data,
	      fileName = _ref.fileName;
	
	  var convertToCSV = function convertToCSV(objArray) {
	    var array = (typeof objArray === 'undefined' ? 'undefined' : _typeof(objArray)) !== 'object' ? JSON.parse(objArray) : objArray;
	
	    // Add CSV headers from the keys of the first object in the array
	    var headers = Object.keys(array[0]);
	    var str = headers.join(',') + '\r\n'; // Add headers row
	
	    // Add data rows
	    for (var i = 0; i < array.length; i++) {
	      var line = '';
	      for (var index in array[i]) {
	        if (line !== '') line += ',';
	
	        // Check if value is null or undefined, then put empty string, otherwise the value itself
	        var value = array[i][index] !== null && array[i][index] !== undefined ? array[i][index] : ''; // Put empty string if null/undefined
	        // Handle commas inside data, if any, by wrapping them in quotes
	        line += '"' + value + '"';
	      }
	      str += line + '\r\n';
	    }
	    return str;
	  };
	
	  var downloadCSV = function downloadCSV() {
	    var csvData = new Blob([convertToCSV(data)], { type: 'text/csv' });
	    var csvURL = URL.createObjectURL(csvData);
	    var link = document.createElement('a');
	    link.href = csvURL;
	    link.download = fileName + '.csv';
	    document.body.appendChild(link);
	    link.click();
	    document.body.removeChild(link);
	  };
	
	  return _react2.default.createElement(
	    'button',
	    { onClick: downloadCSV },
	    'Download'
	  );
	};
	
	exports.default = DownloadCSV;

/***/ },
/* 147 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	function getTimezoneOffsetInMilliseconds(date) {
	  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	  utcDate.setUTCFullYear(date.getFullYear());
	  return date.getTime() - utcDate.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	var _index3 = _interopRequireDefault(__webpack_require__(102));
	var _index4 = _interopRequireDefault(__webpack_require__(25));
	var _index5 = __webpack_require__(66);
	function getUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCDay;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	var _index4 = __webpack_require__(66);
	function setUTCDay(dirtyDate, dirtyDay, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(2, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} - the new date with the days added
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * const result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	  if (!amount) {
	    // If 0 days, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	module.exports = exports.default;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(735));
	var _index4 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * const result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var month = (0, _index.default)(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth);
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(229));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name startOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	module.exports = exports.default;

/***/ },
/* 155 */
8,
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(89),
	    root = __webpack_require__(61);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(61);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 159 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processNodes;
	
	var _isEmptyTextNode = __webpack_require__(959);
	
	var _isEmptyTextNode2 = _interopRequireDefault(_isEmptyTextNode);
	
	var _convertNodeToElement = __webpack_require__(401);
	
	var _convertNodeToElement2 = _interopRequireDefault(_convertNodeToElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Processes the nodes generated by htmlparser2 and convert them all into React elements
	 *
	 * @param {Object[]} nodes List of nodes to process
	 * @param {Function} transform Transform function to optionally apply to nodes
	 * @returns {React.Element[]} The list of processed React elements
	 */
	function processNodes(nodes, transform) {
	
	  return nodes.filter(function (node) {
	    return !(0, _isEmptyTextNode2.default)(node);
	  }).map(function (node, index) {
	
	    // return the result of the transform function if applicable
	    var transformed = void 0;
	    if (typeof transform === 'function') {
	      transformed = transform(node, index);
	      if (transformed === null || !!transformed) {
	        return transformed;
	      }
	    }
	
	    // otherwise convert the node as standard
	    return (0, _convertNodeToElement2.default)(node, index, transform);
	  });
	}

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// THIS FILE IS AUTO GENERATED
	var GenIcon = __webpack_require__(76).GenIcon
	module.exports.Fa42Group = function Fa42Group (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 96V416C341.011 416 361.818 411.861 381.23 403.821C400.641 395.78 418.28 383.995 433.138 369.138C447.995 354.28 459.78 336.641 467.821 317.23C475.861 297.818 480 277.011 480 256C480 234.989 475.861 214.182 467.821 194.771C459.78 175.359 447.995 157.72 433.138 142.863C418.28 128.005 400.641 116.22 381.23 108.179C361.818 100.139 341.011 96 320 96ZM0 256L160.002 416L320.003 256L160.002 96L0 256ZM480 256C480 277.011 484.138 297.818 492.179 317.23C500.219 336.643 512.005 354.28 526.862 369.138C541.72 383.995 559.357 395.781 578.77 403.821C598.182 411.862 618.989 416 640 416V96C597.565 96 556.869 112.858 526.862 142.863C496.857 172.869 480 213.565 480 256Z"}}]})(props);
	};
	module.exports.Fa500Px = function Fa500Px (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"}}]})(props);
	};
	module.exports.FaAccessibleIcon = function FaAccessibleIcon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"}}]})(props);
	};
	module.exports.FaAccusoft = function FaAccusoft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"}}]})(props);
	};
	module.exports.FaAdn = function FaAdn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"}}]})(props);
	};
	module.exports.FaAdversal = function FaAdversal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"}}]})(props);
	};
	module.exports.FaAffiliatetheme = function FaAffiliatetheme (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"}}]})(props);
	};
	module.exports.FaAirbnb = function FaAirbnb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"}}]})(props);
	};
	module.exports.FaAlgolia = function FaAlgolia (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0C116.1 0 2 112.7 0 252.1C-2 393.6 112.9 510.8 254.5 511.6c43.7 .3 85.9-10.4 123.3-30.7c3.6-2 4.2-7 1.1-9.7l-24-21.2c-4.9-4.3-11.8-5.5-17.8-3c-26.1 11.1-54.5 16.8-83.7 16.4C139 461.9 46.5 366.8 48.3 252.4C50.1 139.5 142.6 48.2 256 48.2H463.7V417.2L345.9 312.5c-3.8-3.4-9.7-2.7-12.7 1.3c-18.9 25-49.7 40.6-83.9 38.2c-47.5-3.3-85.9-41.5-89.5-88.9c-4.2-56.6 40.6-103.9 96.3-103.9c50.4 0 91.9 38.8 96.2 88c.4 4.4 2.4 8.5 5.7 11.4l30.7 27.2c3.5 3.1 9 1.2 9.9-3.4c2.2-11.8 3-24.2 2.1-36.8c-4.9-72-63.3-130-135.4-134.4c-82.7-5.1-151.8 59.5-154 140.6c-2.1 78.9 62.6 147 141.6 148.7c33 .7 63.6-9.6 88.3-27.6L495 509.4c6.6 5.8 17 1.2 17-7.7V9.7c0-5.4-4.4-9.7-9.7-9.7H256z"}}]})(props);
	};
	module.exports.FaAlipay = function FaAlipay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"}}]})(props);
	};
	module.exports.FaAmazonPay = function FaAmazonPay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"}}]})(props);
	};
	module.exports.FaAmazon = function FaAmazon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"}}]})(props);
	};
	module.exports.FaAmilia = function FaAmilia (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"}}]})(props);
	};
	module.exports.FaAndroid = function FaAndroid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"}}]})(props);
	};
	module.exports.FaAngellist = function FaAngellist (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"}}]})(props);
	};
	module.exports.FaAngrycreative = function FaAngrycreative (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"}}]})(props);
	};
	module.exports.FaAngular = function FaAngular (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"}}]})(props);
	};
	module.exports.FaAppStoreIos = function FaAppStoreIos (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"}}]})(props);
	};
	module.exports.FaAppStore = function FaAppStore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"}}]})(props);
	};
	module.exports.FaApper = function FaApper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"}}]})(props);
	};
	module.exports.FaApplePay = function FaApplePay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"}}]})(props);
	};
	module.exports.FaApple = function FaApple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"}}]})(props);
	};
	module.exports.FaArtstation = function FaArtstation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}}]})(props);
	};
	module.exports.FaAsymmetrik = function FaAsymmetrik (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"}}]})(props);
	};
	module.exports.FaAtlassian = function FaAtlassian (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"}}]})(props);
	};
	module.exports.FaAudible = function FaAudible (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"}}]})(props);
	};
	module.exports.FaAutoprefixer = function FaAutoprefixer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"}}]})(props);
	};
	module.exports.FaAvianex = function FaAvianex (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"}}]})(props);
	};
	module.exports.FaAviato = function FaAviato (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"}}]})(props);
	};
	module.exports.FaAws = function FaAws (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"}}]})(props);
	};
	module.exports.FaBandcamp = function FaBandcamp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"}}]})(props);
	};
	module.exports.FaBattleNet = function FaBattleNet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"}}]})(props);
	};
	module.exports.FaBehance = function FaBehance (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}}]})(props);
	};
	module.exports.FaBilibili = function FaBilibili (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488.6 104.1C505.3 122.2 513 143.8 511.9 169.8V372.2C511.5 398.6 502.7 420.3 485.4 437.3C468.2 454.3 446.3 463.2 419.9 464H92.02C65.57 463.2 43.81 454.2 26.74 436.8C9.682 419.4 .7667 396.5 0 368.2V169.8C.7667 143.8 9.682 122.2 26.74 104.1C43.81 87.75 65.57 78.77 92.02 78H121.4L96.05 52.19C90.3 46.46 87.42 39.19 87.42 30.4C87.42 21.6 90.3 14.34 96.05 8.603C101.8 2.868 109.1 0 117.9 0C126.7 0 134 2.868 139.8 8.603L213.1 78H301.1L375.6 8.603C381.7 2.868 389.2 0 398 0C406.8 0 414.1 2.868 419.9 8.603C425.6 14.34 428.5 21.6 428.5 30.4C428.5 39.19 425.6 46.46 419.9 52.19L394.6 78L423.9 78C450.3 78.77 471.9 87.75 488.6 104.1H488.6zM449.8 173.8C449.4 164.2 446.1 156.4 439.1 150.3C433.9 144.2 425.1 140.9 416.4 140.5H96.05C86.46 140.9 78.6 144.2 72.47 150.3C66.33 156.4 63.07 164.2 62.69 173.8V368.2C62.69 377.4 65.95 385.2 72.47 391.7C78.99 398.2 86.85 401.5 96.05 401.5H416.4C425.6 401.5 433.4 398.2 439.7 391.7C446 385.2 449.4 377.4 449.8 368.2L449.8 173.8zM185.5 216.5C191.8 222.8 195.2 230.6 195.6 239.7V273C195.2 282.2 191.9 289.9 185.8 296.2C179.6 302.5 171.8 305.7 162.2 305.7C152.6 305.7 144.7 302.5 138.6 296.2C132.5 289.9 129.2 282.2 128.8 273V239.7C129.2 230.6 132.6 222.8 138.9 216.5C145.2 210.2 152.1 206.9 162.2 206.5C171.4 206.9 179.2 210.2 185.5 216.5H185.5zM377 216.5C383.3 222.8 386.7 230.6 387.1 239.7V273C386.7 282.2 383.4 289.9 377.3 296.2C371.2 302.5 363.3 305.7 353.7 305.7C344.1 305.7 336.3 302.5 330.1 296.2C323.1 289.9 320.7 282.2 320.4 273V239.7C320.7 230.6 324.1 222.8 330.4 216.5C336.7 210.2 344.5 206.9 353.7 206.5C362.9 206.9 370.7 210.2 377 216.5H377z"}}]})(props);
	};
	module.exports.FaBimobject = function FaBimobject (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"}}]})(props);
	};
	module.exports.FaBitbucket = function FaBitbucket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"}}]})(props);
	};
	module.exports.FaBitcoin = function FaBitcoin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"}}]})(props);
	};
	module.exports.FaBity = function FaBity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"}}]})(props);
	};
	module.exports.FaBlackTie = function FaBlackTie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"}}]})(props);
	};
	module.exports.FaBlackberry = function FaBlackberry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"}}]})(props);
	};
	module.exports.FaBloggerB = function FaBloggerB (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"}}]})(props);
	};
	module.exports.FaBlogger = function FaBlogger (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"}}]})(props);
	};
	module.exports.FaBluetoothB = function FaBluetoothB (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"}}]})(props);
	};
	module.exports.FaBluetooth = function FaBluetooth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"}}]})(props);
	};
	module.exports.FaBootstrap = function FaBootstrap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"}}]})(props);
	};
	module.exports.FaBots = function FaBots (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M86.344,197.834a51.767,51.767,0,0,0-41.57,20.058V156.018a8.19,8.19,0,0,0-8.19-8.19H8.19A8.19,8.19,0,0,0,0,156.018V333.551a8.189,8.189,0,0,0,8.19,8.189H36.584a8.189,8.189,0,0,0,8.19-8.189v-8.088c11.628,13.373,25.874,19.769,41.573,19.769,34.6,0,61.922-26.164,61.922-73.843C148.266,225.452,121.229,197.834,86.344,197.834ZM71.516,305.691c-9.593,0-21.221-4.942-26.745-12.5V250.164c5.528-7.558,17.152-12.791,26.745-12.791,17.734,0,31.107,13.082,31.107,34.013C102.623,292.609,89.25,305.691,71.516,305.691Zm156.372-59.032a17.4,17.4,0,1,0,17.4,17.4A17.4,17.4,0,0,0,227.888,246.659ZM273.956,156.7V112.039a13.308,13.308,0,1,0-10.237,0V156.7a107.49,107.49,0,1,0,10.237,0Zm85.993,107.367c0,30.531-40.792,55.281-91.112,55.281s-91.111-24.75-91.111-55.281,40.792-55.281,91.111-55.281S359.949,233.532,359.949,264.062Zm-50.163,17.4a17.4,17.4,0,1,0-17.4-17.4h0A17.4,17.4,0,0,0,309.786,281.466ZM580.7,250.455c-14.828-2.617-22.387-3.78-22.387-9.885,0-5.523,7.268-9.884,17.735-9.884a65.56,65.56,0,0,1,34.484,10.1,8.171,8.171,0,0,0,11.288-2.468c.07-.11.138-.221.2-.333l8.611-14.886a8.2,8.2,0,0,0-2.867-11.123,99.863,99.863,0,0,0-52.014-14.138c-38.956,0-60.179,21.514-60.179,46.225,0,36.342,33.725,41.864,57.563,45.642,13.373,2.326,24.13,4.361,24.13,11.048,0,6.4-5.523,10.757-18.9,10.757-13.552,0-30.994-6.222-42.623-13.579a8.206,8.206,0,0,0-11.335,2.491c-.035.054-.069.108-.1.164l-10.2,16.891a8.222,8.222,0,0,0,2.491,11.066c15.224,10.3,37.663,16.692,59.441,16.692,40.409,0,63.957-19.769,63.957-46.515C640,260.63,604.537,254.816,580.7,250.455Zm-95.928,60.787a8.211,8.211,0,0,0-9.521-5.938,23.168,23.168,0,0,1-4.155.387c-7.849,0-12.5-6.106-12.5-14.245V240.28h20.349a8.143,8.143,0,0,0,8.141-8.143V209.466a8.143,8.143,0,0,0-8.141-8.143H458.594V171.091a8.143,8.143,0,0,0-8.143-8.143H422.257a8.143,8.143,0,0,0-8.143,8.143h0v30.232H399a8.143,8.143,0,0,0-8.143,8.143h0v22.671A8.143,8.143,0,0,0,399,240.28h15.115v63.667c0,27.037,15.408,41.282,43.9,41.282,12.183,0,21.383-2.2,27.6-5.446a8.161,8.161,0,0,0,4.145-9.278Z"}}]})(props);
	};
	module.exports.FaBtc = function FaBtc (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"}}]})(props);
	};
	module.exports.FaBuffer = function FaBuffer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"}}]})(props);
	};
	module.exports.FaBuromobelexperte = function FaBuromobelexperte (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"}}]})(props);
	};
	module.exports.FaBuyNLarge = function FaBuyNLarge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"}}]})(props);
	};
	module.exports.FaBuysellads = function FaBuysellads (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"}}]})(props);
	};
	module.exports.FaCanadianMapleLeaf = function FaCanadianMapleLeaf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"}}]})(props);
	};
	module.exports.FaCcAmazonPay = function FaCcAmazonPay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"}}]})(props);
	};
	module.exports.FaCcAmex = function FaCcAmex (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M48 480C21.49 480 0 458.5 0 432V80C0 53.49 21.49 32 48 32H528C554.5 32 576 53.49 576 80V82.43H500.5L483.5 130L466.6 82.43H369.4V145.6L341.3 82.43H262.7L181 267.1H246.8V430.9H450.5L482.4 395.8L514.3 430.9H576V432C576 458.5 554.5 480 528 480H48zM482.6 364L440.4 410.3H390.5L458 338.6L390.5 266.1H441.9L483.4 312.8L525.4 266.1H576L508 338.2L576 410.3H524.6L482.6 364zM576 296.9V380.2L536.7 338.3L576 296.9zM307.6 377.1H390.6V410.3H268.6V267.1H390.6V300.2H307.6V322.6H388.5V354.9H307.6V377.2V377.1zM537.3 145.7L500.4 246.3H466L429.2 146V246.3H390.5V103H451.7L483.6 192.3L515.8 103H576V246.3H537.3V145.7zM334.5 217.6H268.6L256.7 246.3H213.7L276.1 103H327.3L390.6 246.3H346.5L334.5 217.6zM301.5 138.5L282 185.4H320.9L301.5 138.5z"}}]})(props);
	};
	module.exports.FaCcApplePay = function FaCcApplePay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"}}]})(props);
	};
	module.exports.FaCcDinersClub = function FaCcDinersClub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"}}]})(props);
	};
	module.exports.FaCcDiscover = function FaCcDiscover (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"}}]})(props);
	};
	module.exports.FaCcJcb = function FaCcJcb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"}}]})(props);
	};
	module.exports.FaCcMastercard = function FaCcMastercard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"}}]})(props);
	};
	module.exports.FaCcPaypal = function FaCcPaypal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"}}]})(props);
	};
	module.exports.FaCcStripe = function FaCcStripe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"}}]})(props);
	};
	module.exports.FaCcVisa = function FaCcVisa (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"}}]})(props);
	};
	module.exports.FaCentercode = function FaCentercode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"}}]})(props);
	};
	module.exports.FaCentos = function FaCentos (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"}}]})(props);
	};
	module.exports.FaChrome = function FaChrome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256C0 209.4 12.47 165.6 34.27 127.1L144.1 318.3C166 357.5 207.9 384 256 384C270.3 384 283.1 381.7 296.8 377.4L220.5 509.6C95.9 492.3 0 385.3 0 256zM365.1 321.6C377.4 302.4 384 279.1 384 256C384 217.8 367.2 183.5 340.7 160H493.4C505.4 189.6 512 222.1 512 256C512 397.4 397.4 511.1 256 512L365.1 321.6zM477.8 128H256C193.1 128 142.3 172.1 130.5 230.7L54.19 98.47C101 38.53 174 0 256 0C350.8 0 433.5 51.48 477.8 128V128zM168 256C168 207.4 207.4 168 256 168C304.6 168 344 207.4 344 256C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 256z"}}]})(props);
	};
	module.exports.FaChromecast = function FaChromecast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"}}]})(props);
	};
	module.exports.FaCloudflare = function FaCloudflare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"}}]})(props);
	};
	module.exports.FaCloudscale = function FaCloudscale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"}}]})(props);
	};
	module.exports.FaCloudsmith = function FaCloudsmith (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 227.6v56.9L284.4 512H227.6L0 284.4V227.6L227.6 0h56.9L512 227.6zm-256 162a133.6 133.6 0 1 0 0-267.1 133.6 133.6 0 1 0 0 267.1z"}}]})(props);
	};
	module.exports.FaCloudversify = function FaCloudversify (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 616 512"},"child":[{"tag":"path","attr":{"d":"M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"}}]})(props);
	};
	module.exports.FaCmplid = function FaCmplid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M226.119,388.165a3.816,3.816,0,0,0-2.294-3.5,3.946,3.946,0,0,0-1.629-.385L72.6,384.3a19.243,19.243,0,0,1-17.924-26.025L81.585,255.692a35.72,35.72,0,0,1,32.373-26H262.525a7.07,7.07,0,0,0,6.392-5.194l10.769-41.131a3.849,3.849,0,0,0-2.237-4.937,3.755,3.755,0,0,0-1.377-.261c-.063,0-.126,0-.189.005H127.38a106.8,106.8,0,0,0-96.99,77.1L3.483,358.824A57.469,57.469,0,0,0,57.314,436q1.43,0,2.86-.072H208.742a7.131,7.131,0,0,0,6.391-5.193L225.839,389.6A3.82,3.82,0,0,0,226.119,388.165ZM306.658,81.2a3.861,3.861,0,0,0,.251-1.367A3.813,3.813,0,0,0,303.079,76c-.064,0-.128,0-.192,0h-41A7.034,7.034,0,0,0,255.5,81.2l-21.347,80.915h51.131ZM180.364,368.249H231.5L263.452,245.69H212.321ZM511.853,79.723a3.809,3.809,0,0,0-3.8-3.661c-.058,0-.137,0-.23.007h-41a7.1,7.1,0,0,0-6.584,5.129L368.91,430.634a3.54,3.54,0,0,0-.262,1.335,3.873,3.873,0,0,0,3.864,3.863c.056,0,.112,0,.169,0h41a7.068,7.068,0,0,0,6.392-5.193L511.533,81.2A3.624,3.624,0,0,0,511.853,79.723ZM324.649,384.47h-41a7.2,7.2,0,0,0-6.392,5.194L266.52,430.8a3.662,3.662,0,0,0-.268,1.374A3.783,3.783,0,0,0,270.023,436c.06,0,.166,0,.3-.012h40.905a7.036,7.036,0,0,0,6.391-5.193l10.769-41.131a3.75,3.75,0,0,0-3.445-5.208c-.108,0-.217,0-.326.014Zm311.324-308.4h-41a7.066,7.066,0,0,0-6.392,5.129l-91.46,349.436a4.073,4.073,0,0,0-.229,1.347,3.872,3.872,0,0,0,3.863,3.851c.056,0,.112,0,.169,0h40.968a7.1,7.1,0,0,0,6.392-5.193L639.68,81.2a3.624,3.624,0,0,0,.32-1.475,3.841,3.841,0,0,0-3.821-3.564c-.068,0-.137,0-.206.006ZM371.562,225.236l10.8-41.1a4.369,4.369,0,0,0,.227-1.388,3.869,3.869,0,0,0-3.861-3.842c-.057,0-.113,0-.169,0h-41.1a7.292,7.292,0,0,0-6.391,5.226l-10.834,41.1a4.417,4.417,0,0,0-.26,1.493c0,.069,0,.138,0,.206a3.776,3.776,0,0,0,3.757,3.507c.076,0,.18,0,.3-.012h41.129A7.034,7.034,0,0,0,371.562,225.236Z"}}]})(props);
	};
	module.exports.FaCodepen = function FaCodepen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"}}]})(props);
	};
	module.exports.FaCodiepie = function FaCodiepie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 472 512"},"child":[{"tag":"path","attr":{"d":"M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"}}]})(props);
	};
	module.exports.FaConfluence = function FaConfluence (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"}}]})(props);
	};
	module.exports.FaConnectdevelop = function FaConnectdevelop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"}}]})(props);
	};
	module.exports.FaContao = function FaContao (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"}}]})(props);
	};
	module.exports.FaCottonBureau = function FaCottonBureau (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"}}]})(props);
	};
	module.exports.FaCpanel = function FaCpanel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"}}]})(props);
	};
	module.exports.FaCreativeCommonsBy = function FaCreativeCommonsBy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"}}]})(props);
	};
	module.exports.FaCreativeCommonsNcEu = function FaCreativeCommonsNcEu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"}}]})(props);
	};
	module.exports.FaCreativeCommonsNcJp = function FaCreativeCommonsNcJp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"}}]})(props);
	};
	module.exports.FaCreativeCommonsNc = function FaCreativeCommonsNc (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"}}]})(props);
	};
	module.exports.FaCreativeCommonsNd = function FaCreativeCommonsNd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"}}]})(props);
	};
	module.exports.FaCreativeCommonsPdAlt = function FaCreativeCommonsPdAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"}}]})(props);
	};
	module.exports.FaCreativeCommonsPd = function FaCreativeCommonsPd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"}}]})(props);
	};
	module.exports.FaCreativeCommonsRemix = function FaCreativeCommonsRemix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"}}]})(props);
	};
	module.exports.FaCreativeCommonsSa = function FaCreativeCommonsSa (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"}}]})(props);
	};
	module.exports.FaCreativeCommonsSamplingPlus = function FaCreativeCommonsSamplingPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"}}]})(props);
	};
	module.exports.FaCreativeCommonsSampling = function FaCreativeCommonsSampling (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"}}]})(props);
	};
	module.exports.FaCreativeCommonsShare = function FaCreativeCommonsShare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"}}]})(props);
	};
	module.exports.FaCreativeCommonsZero = function FaCreativeCommonsZero (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"}}]})(props);
	};
	module.exports.FaCreativeCommons = function FaCreativeCommons (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"}}]})(props);
	};
	module.exports.FaCriticalRole = function FaCriticalRole (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"}}]})(props);
	};
	module.exports.FaCss3Alt = function FaCss3Alt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"}}]})(props);
	};
	module.exports.FaCss3 = function FaCss3 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"}}]})(props);
	};
	module.exports.FaCuttlefish = function FaCuttlefish (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 440 512"},"child":[{"tag":"path","attr":{"d":"M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"}}]})(props);
	};
	module.exports.FaDAndDBeyond = function FaDAndDBeyond (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"}}]})(props);
	};
	module.exports.FaDAndD = function FaDAndD (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"}}]})(props);
	};
	module.exports.FaDailymotion = function FaDailymotion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"}}]})(props);
	};
	module.exports.FaDashcube = function FaDashcube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"}}]})(props);
	};
	module.exports.FaDebian = function FaDebian (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M248.2 .9c-4 .2-8.1 .4-11.4 1.6l-3.4-.5c5.4-.7 10.9-1.1 16.4-1.5c2.4-.2 4.8-.4 7.2-.6c-2.7 .6-5.7 .8-8.8 .9zm132 244.7c3-7.6 5.5-14 5.2-24.4l-4.3 9c4.4-13.2 4-27.1 3.6-40.4c-.2-6-.3-11.8 0-17.4l-1.8-.5c-1.5-45.2-40.6-93.1-75.3-109.4c-30-13.8-76.1-16.2-97.3-5.8c1.3-1.1 4.2-2 6.8-2.7c3.4-1 6.3-1.8 4.3-3c-19.2 1.9-24.9 5.5-31.1 9.4c-4.6 2.9-9.5 6-20.3 8.7c-3.5 3.4 1.7 2 5.8 .9c4.1-1.1 7.2-1.9-.1 2.4c-3.6 1-6.7 1.3-9.7 1.6c-8.3 .8-15.8 1.6-30.7 17c.8 1.3 3.5-.3 5.4-1.4c2.3-1.4 3.4-2-1.7 4.4c-19.1-2.4-60.3 43.7-69.1 59l4.6 .8c-3.2 8-6.8 14.8-10 20.8c-4.3 8.1-7.9 14.9-8.7 21.3c-.4 5.9-1.2 12.9-2 20.3c-3 27.4-6.8 61.3 3.8 73.6l-1.3 13c.6 1.2 1.1 2.3 1.6 3.5c1.2 2.5 2.3 5 3.9 7.4l-3 .2c7 22.2 10.8 22.5 15.1 22.9c4.4 .4 9.3 .9 18.7 24.2c-2.7-.9-5.5-1.9-9.4-7.2c-.5 4.1 5.8 16.3 13.1 25.8l-3.1 3.6c3.2 5.8 6.1 8.1 8.6 10l0 0c.8 .6 1.5 1.1 2.1 1.7c-11.9-6.5 3.2 13.7 11.9 25.2c2.5 3.4 4.5 6 5.1 7l2.4-4.2c-.3 6.1 4.3 13.9 13.1 24.7l7.3-.3c3 6 14 16.7 20.7 17.2l-4.4 5.8c8.1 2.6 10.3 4.3 12.7 6.2c2.6 2.1 5.4 4.3 16.1 8.1l-4.2-7.4c3.5 3 6.2 5.9 8.8 8.7c5.2 5.6 9.9 10.7 19.8 15.4c11.2 3.9 17.1 4.8 23.6 5.9c5.4 .8 11.2 1.8 20.8 4.5c-2.2-.1-4.4-.1-6.7-.2l0 0h0c-16.3-.4-34-.8-46.4-5.2C107.8 480.5 19.5 367.2 26 250.6c-.6-9.9-.3-20.9 0-30.7c.4-13.5 .7-24.8-1.6-28.3l1-3.1c5.3-17.4 11.7-38.2 23.8-62.8l-.1-.2 0-.1 0 0 0 0c.4 .4 3.4 3.4 8.8-5.8c1.3-2.9 2.5-5.8 3.8-8.8l0 0c2.5-6.1 5.1-12.3 8.4-17.9l2.6-.6c1.7-10.1 17-23.8 29.8-35.2l0 0c6.1-5.5 11.6-10.4 14.7-14.1l.7 4.4c17.1-16 45-27.7 66.1-36.6c4.8-2 9.3-3.9 13.3-5.7c-3.4 3.8 2.2 2.7 10 1c4.8-1 10.4-2.1 15.3-2.4c-1.3 .7-2.6 1.4-3.9 2.1l0 0 0 0c-2.7 1.4-5.4 2.8-8 4.6c8.3-2 11.9-1.4 16-.8c3.5 .6 7.3 1.2 14.6 .2c-5.6 .8-12.3 3-11.2 3.8c7.9 .9 12.8-.1 17.2-1c5.6-1.1 10.4-2.1 19.5 .9l-1-4.8c7.5 2.7 13.1 4.4 18 5.9c10 3 17.6 5.3 34.2 14.1c3.2 .2 5.3-.5 7.4-1.2c3.6-1.1 7-2.2 15.3 1.2c.5 .8 .7 1.5 1 2.1c1 2.6 1.7 4.6 14.6 12.2c1.8-.7-3.1-5.1-7-8.7l-.2-.1c32.3 17.3 67.5 54.1 78.2 93.6c-6-11.1-5.2-5.5-4.3 .5c.6 4 1.2 8.1-.2 7.5c4.5 12.1 8.1 24.5 10.4 37.4l-.8-2.9c-3.3-11.8-9.6-34.5-20-49.6c-.4 4.4-2.9 3.9-5.3 3.5c-3.3-.6-6.3-1.2-1.9 12.6c2.6 3.8 3.1 2.4 3.5 1.1c.5-1.5 .9-2.8 4.7 5.2c.1 4.3 1.1 8.5 2.2 13.3l0 0 0 0 0 0 0 0 0 0 0 0c.7 3 1.5 6.2 2.1 9.8c-1.1-.2-2.3-2.2-3.4-4.2l0 0 0 0c-1.4-2.4-2.8-4.7-3.7-3.2c2.4 11.5 6.5 17.4 8 18.3c-.3 .6-.6 .7-1.1 .7c-.8 0-1.8 .1-1.9 5.3c.7 13.7 3.3 12.5 5.3 11.6c.6-.3 1.2-.6 1.7-.4c-.6 2.5-1.6 5.1-2.7 7.9l0 0c-2.8 7.1-6 15.4-3.4 26.1c-.8-3.1-2.1-6.3-3.3-9.3l0 0 0 0c-.5-1.3-1.1-2.6-1.5-3.8c-.6 4.8-.3 8.2-.1 11.3c.4 5.3 .7 10-3 19.9c4.3-14.2 3.8-26.9-.2-20.8c1 11-3.8 20.5-8.1 29.1c-3.6 7.1-6.8 13.5-5.9 19.3l-5.2-7.1c-7.6 11-7 13.3-6.5 15.6c.5 1.9 1 3.8-3.4 10.8c1.7-2.9 1.3-3.6 1-4.2c-.4-.8-.7-1.5 1.7-5.1c-1.6 .1-5.5 3.9-10.1 8.5l0 0c-3.9 3.9-8.5 8.4-12.8 11.8c-37.5 30.1-82.3 34-125.6 17.8l0 0c.2-1-.2-2.1-3.1-4.1c-36.8-28.2-58.5-52.1-50.9-107.5c2.2-1.7 3.7-6.2 5.6-11.6c2.9-8.4 6.5-18.9 14.3-23.9c7.8-17.3 31.3-33.3 56.4-33.7c25.6-1.4 47.2 13.7 58.1 27.9c-19.8-18.4-52.1-24-79.7-10.4c-28.2 12.7-45 43.8-42.5 74.7c.3-.5 .7-.7 1-.9c.6-.5 1.2-.9 1.5-3.4c-.9 60.2 64.8 104.3 112.1 82l.6 1.3c12.7-3.5 15.9-6.5 20.3-10.7c2.2-2.1 4.7-4.5 9-7.4c-.3 .7-1.3 1.7-2.4 2.7c-2.2 2.1-4.6 4.5-1.6 4.6c5.3-1.4 20.1-14.8 30.2-23.8l0 0 0 0c1.6-1.4 3-2.7 4.3-3.9c2-4.3 1.6-5.7 1.3-7.1c-.4-1.6-.8-3.3 2.4-9.6l7.3-3.7c1-2.8 2-5.4 2.9-7.8l0 0zM233.1 321.9a.9 .9 0 1 0 -1.7 0 .9 .9 0 1 0 1.7 0zm-.2 .5l-.2 .4c-.3 .7-.6 1.4-.3 2.4c-12.2-5.7-23.4-14.3-32.6-24.9c4.9 7.1 10.1 14.1 17 19.5c-6.9-2.3-15.2-11.9-21.7-19.4l0 0 0 0c-4.3-5-7.9-9.1-9.7-9.5c19.8 35.5 80.5 62.3 112.3 49c-14.7 .5-33.4 .3-49.9-5.8c-6.3-3.2-14.6-9.6-14.9-11.8zM237.5 7c3.8 .6 7.3 1.2 6.7 2.1c5-1.1 6.1-2.1-9-2.5c.8 .1 1.6 .3 2.4 .4zm92.2 208.4c-1 3.9-1.8 1.4-2.7-1.2c-.5-1.5-1.1-3.1-1.7-3.4c1.4-5.8 5.4-10.7 4.4 4.6zm-6.8 21.2c-1.3 7.9-5 15.5-10.1 22.5c.2-2-1.2-2.4-2.6-2.8c-2.9-.8-5.9-1.6 5.6-16.1c-.5 2-2.3 4.9-4 7.7l0 0c-3.6 5.9-6.7 11 4 4.3l1-1.8c2.6-4.5 5-8.8 6-13.8zM280 276.6c-11.1-1.7-21.2-6-12.7-6.1c7.1 .6 14.1 .6 21-1.1c-2.5 2.4-5.2 4.8-8.3 7.2zM244.2 9.1l-.2 .4-3 .3 3.2-.7zm-69.5 273c3.7 7.2 6.5 11.7 9.1 15.9c2.3 3.7 4.4 7.1 6.8 11.7c-5.2-4.3-8.9-9.8-12.8-15.5c-1.4-2.1-2.8-4.2-4.4-6.2l1.2-5.9zm7.3-10c1.7 3.4 3.3 6.7 5.9 9.5l2.6 7.7-1.3-2.1c-3.2-5.3-6.3-10.6-8-16.7l.8 1.6zm239.1-41.2c-2.3 17.4-7.7 34.6-16 50.3c7.6-14.9 12.5-30.9 14.8-47.2l1.2-3.1zM35.4 109.6c0 .3 0 .5 .1 .7c0-.2 0-.5-.1-.7zm.1 .7c.3 1.2 1.4 .9 2.4 .6c1.9-.5 3.6-.9-.1 7.6c-2.4 1.7-3.8 2.8-4.6 3.4c-.6 .4-.8 .6-.8 .6c0 0 .1-.2 .3-.5c.8-1.4 3.4-5.5 2.9-11.7zm-10.2 42c-.7 3.7-1.5 7.9-3.4 13.9c.2-1.9 0-3.5-.2-4.9c-.4-3.4-.8-6.3 4.3-12.9c-.3 1.2-.5 2.5-.7 3.8z"}}]})(props);
	};
	module.exports.FaDeezer = function FaDeezer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"}}]})(props);
	};
	module.exports.FaDelicious = function FaDelicious (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"}}]})(props);
	};
	module.exports.FaDeploydog = function FaDeploydog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"}}]})(props);
	};
	module.exports.FaDeskpro = function FaDeskpro (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"}}]})(props);
	};
	module.exports.FaDev = function FaDev (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"}}]})(props);
	};
	module.exports.FaDeviantart = function FaDeviantart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"}}]})(props);
	};
	module.exports.FaDhl = function FaDhl (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"}}]})(props);
	};
	module.exports.FaDiaspora = function FaDiaspora (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"}}]})(props);
	};
	module.exports.FaDigg = function FaDigg (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"}}]})(props);
	};
	module.exports.FaDigitalOcean = function FaDigitalOcean (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"}}]})(props);
	};
	module.exports.FaDiscord = function FaDiscord (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}}]})(props);
	};
	module.exports.FaDiscourse = function FaDiscourse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"}}]})(props);
	};
	module.exports.FaDochub = function FaDochub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"}}]})(props);
	};
	module.exports.FaDocker = function FaDocker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"}}]})(props);
	};
	module.exports.FaDraft2Digital = function FaDraft2Digital (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"}}]})(props);
	};
	module.exports.FaDribbble = function FaDribbble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"}}]})(props);
	};
	module.exports.FaDropbox = function FaDropbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 528 512"},"child":[{"tag":"path","attr":{"d":"M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"}}]})(props);
	};
	module.exports.FaDrupal = function FaDrupal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M303.973,108.136C268.2,72.459,234.187,38.35,224.047,0c-9.957,38.35-44.25,72.459-80.019,108.136C90.467,161.7,29.716,222.356,29.716,313.436c-2.337,107.3,82.752,196.18,190.053,198.517S415.948,429.2,418.285,321.9q.091-4.231,0-8.464C418.285,222.356,357.534,161.7,303.973,108.136Zm-174.326,223a130.282,130.282,0,0,0-15.211,24.153,4.978,4.978,0,0,1-3.319,2.766h-1.659c-4.333,0-9.219-8.481-9.219-8.481h0c-1.29-2.028-2.489-4.149-3.687-6.361l-.83-1.752c-11.247-25.72-1.475-62.318-1.475-62.318h0a160.585,160.585,0,0,1,23.231-49.873A290.8,290.8,0,0,1,138.5,201.613l9.219,9.219,43.512,44.434a4.979,4.979,0,0,1,0,6.638L145.78,312.33h0Zm96.612,127.311a67.2,67.2,0,0,1-49.781-111.915c14.2-16.871,31.528-33.464,50.334-55.313,22.309,23.785,36.875,40.1,51.164,57.986a28.413,28.413,0,0,1,2.95,4.425,65.905,65.905,0,0,1,11.984,37.981,66.651,66.651,0,0,1-66.466,66.836ZM352.371,351.6h0a7.743,7.743,0,0,1-6.176,5.347H344.9a11.249,11.249,0,0,1-6.269-5.07h0a348.21,348.21,0,0,0-39.456-48.952L281.387,284.49,222.3,223.185a497.888,497.888,0,0,1-35.4-36.322,12.033,12.033,0,0,0-.922-1.382,35.4,35.4,0,0,1-4.7-9.219V174.51a31.346,31.346,0,0,1,9.218-27.656c11.432-11.431,22.955-22.954,33.833-34.939,11.984,13.275,24.8,26,37.428,38.627h0a530.991,530.991,0,0,1,69.6,79.1,147.494,147.494,0,0,1,27.011,83.8A134.109,134.109,0,0,1,352.371,351.6Z"}}]})(props);
	};
	module.exports.FaDyalog = function FaDyalog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"}}]})(props);
	};
	module.exports.FaEarlybirds = function FaEarlybirds (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"}}]})(props);
	};
	module.exports.FaEbay = function FaEbay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"}}]})(props);
	};
	module.exports.FaEdgeLegacy = function FaEdgeLegacy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"}}]})(props);
	};
	module.exports.FaEdge = function FaEdge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M120.1 37.44C161.1 12.23 207.7-.7753 255 .0016C423 .0016 512 123.8 512 219.5C511.9 252.2 499 283.4 476.1 306.7C453.2 329.9 422.1 343.2 389.4 343.7C314.2 343.7 297.9 320.6 297.9 311.7C297.9 307.9 299.1 305.5 302.7 302.3L303.7 301.1L304.1 299.5C314.6 288 320 273.3 320 257.9C320 179.2 237.8 115.2 136 115.2C98.46 114.9 61.46 124.1 28.48 142.1C55.48 84.58 111.2 44.5 119.8 38.28C120.6 37.73 120.1 37.44 120.1 37.44V37.44zM135.7 355.5C134.3 385.5 140.3 415.5 152.1 442.7C165.7 469.1 184.8 493.7 208.6 512C149.1 500.5 97.11 468.1 59.2 422.7C21.12 376.3 0 318.4 0 257.9C0 206.7 62.4 163.5 136 163.5C172.6 162.9 208.4 174.4 237.8 196.2L234.2 197.4C182.7 215 135.7 288.1 135.7 355.5V355.5zM469.8 400L469.1 400.1C457.3 418.9 443.2 435.2 426.9 449.6C396.1 477.6 358.8 495.1 318.1 499.5C299.5 499.8 281.3 496.3 264.3 488.1C238.7 477.8 217.2 458.1 202.7 435.1C188.3 411.2 181.6 383.4 183.7 355.5C183.1 335.4 189.1 315.2 198.7 297.3C212.6 330.4 236.2 358.6 266.3 378.1C296.4 397.6 331.8 407.6 367.7 406.7C398.7 407 429.8 400 457.9 386.2L459.8 385.3C463.7 383 467.5 381.4 471.4 385.3C475.9 390.2 473.2 394.5 470.2 399.3C470 399.5 469.9 399.8 469.8 400V400z"}}]})(props);
	};
	module.exports.FaElementor = function FaElementor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M.361 256C.361 397 114 511 255 511C397 511 511 397 511 256C511 116 397 2.05 255 2.05C114 2.05 .361 116 .361 256zM192 150V363H149V150H192zM234 150H362V193H234V150zM362 235V278H234V235H362zM234 320H362V363H234V320z"}}]})(props);
	};
	module.exports.FaEllo = function FaEllo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"}}]})(props);
	};
	module.exports.FaEmber = function FaEmber (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"}}]})(props);
	};
	module.exports.FaEmpire = function FaEmpire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"}}]})(props);
	};
	module.exports.FaEnvira = function FaEnvira (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"}}]})(props);
	};
	module.exports.FaErlang = function FaErlang (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"}}]})(props);
	};
	module.exports.FaEthereum = function FaEthereum (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"}}]})(props);
	};
	module.exports.FaEtsy = function FaEtsy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"}}]})(props);
	};
	module.exports.FaEvernote = function FaEvernote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"}}]})(props);
	};
	module.exports.FaExpeditedssl = function FaExpeditedssl (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"}}]})(props);
	};
	module.exports.FaFacebookF = function FaFacebookF (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"}}]})(props);
	};
	module.exports.FaFacebookMessenger = function FaFacebookMessenger (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"}}]})(props);
	};
	module.exports.FaFacebook = function FaFacebook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"}}]})(props);
	};
	module.exports.FaFantasyFlightGames = function FaFantasyFlightGames (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"}}]})(props);
	};
	module.exports.FaFedex = function FaFedex (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"}}]})(props);
	};
	module.exports.FaFedora = function FaFedora (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M.0413 255.8C.1219 132.2 100.3 32 224 32C347.7 32 448 132.3 448 256C448 379.7 347.8 479.9 224.1 480H50.93C22.84 480 .0832 457.3 .0416 429.2H0V255.8H.0413zM342.6 192.7C342.6 153 307 124.2 269.4 124.2C234.5 124.2 203.6 150.5 199.3 184.1C199.1 187.9 198.9 189.1 198.9 192.6C198.8 213.7 198.9 235.4 198.1 257C199 283.1 199.1 309.1 198.1 333.6C198.1 360.7 178.7 379.1 153.4 379.1C128.1 379.1 107.6 358.9 107.6 333.6C108.1 305.9 130.2 288.3 156.1 287.5H156.3L182.6 287.3V250L156.3 250.2C109.2 249.8 71.72 286.7 70.36 333.6C70.36 379.2 107.9 416.5 153.4 416.5C196.4 416.5 232.1 382.9 236 340.9L236.2 287.4L268.8 287.1C294.1 287.3 293.8 249.3 268.6 249.8L236.2 250.1C236.2 243.7 236.3 237.3 236.3 230.9C236.4 218.2 236.4 205.5 236.2 192.7C236.3 176.2 252 161.5 269.4 161.5C286.9 161.5 305.3 170.2 305.3 192.7C305.3 195.9 305.2 197.8 305 199C303.1 209.5 310.2 219.4 320.7 220.9C331.3 222.4 340.9 214.8 341.9 204.3C342.5 200.1 342.6 196.4 342.6 192.7H342.6z"}}]})(props);
	};
	module.exports.FaFigma = function FaFigma (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"}}]})(props);
	};
	module.exports.FaFirefoxBrowser = function FaFirefoxBrowser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M130.22 127.548C130.38 127.558 130.3 127.558 130.22 127.548V127.548ZM481.64 172.898C471.03 147.398 449.56 119.898 432.7 111.168C446.42 138.058 454.37 165.048 457.4 185.168C457.405 185.306 457.422 185.443 457.45 185.578C429.87 116.828 383.098 89.1089 344.9 28.7479C329.908 5.05792 333.976 3.51792 331.82 4.08792L331.7 4.15792C284.99 30.1109 256.365 82.5289 249.12 126.898C232.503 127.771 216.219 131.895 201.19 139.035C199.838 139.649 198.736 140.706 198.066 142.031C197.396 143.356 197.199 144.87 197.506 146.323C197.7 147.162 198.068 147.951 198.586 148.639C199.103 149.327 199.76 149.899 200.512 150.318C201.264 150.737 202.096 150.993 202.954 151.071C203.811 151.148 204.676 151.045 205.491 150.768L206.011 150.558C221.511 143.255 238.408 139.393 255.541 139.238C318.369 138.669 352.698 183.262 363.161 201.528C350.161 192.378 326.811 183.338 304.341 187.248C392.081 231.108 368.541 381.784 246.951 376.448C187.487 373.838 149.881 325.467 146.421 285.648C146.421 285.648 157.671 243.698 227.041 243.698C234.541 243.698 255.971 222.778 256.371 216.698C256.281 214.698 213.836 197.822 197.281 181.518C188.434 172.805 184.229 168.611 180.511 165.458C178.499 163.75 176.392 162.158 174.201 160.688C168.638 141.231 168.399 120.638 173.51 101.058C148.45 112.468 128.96 130.508 114.8 146.428H114.68C105.01 134.178 105.68 93.7779 106.25 85.3479C106.13 84.8179 99.022 89.0159 98.1 89.6579C89.5342 95.7103 81.5528 102.55 74.26 110.088C57.969 126.688 30.128 160.242 18.76 211.318C14.224 231.701 12 255.739 12 263.618C12 398.318 121.21 507.508 255.92 507.508C376.56 507.508 478.939 420.281 496.35 304.888C507.922 228.192 481.64 173.82 481.64 172.898Z"}}]})(props);
	};
	module.exports.FaFirefox = function FaFirefox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"}}]})(props);
	};
	module.exports.FaFirstOrderAlt = function FaFirstOrderAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"}}]})(props);
	};
	module.exports.FaFirstOrder = function FaFirstOrder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"}}]})(props);
	};
	module.exports.FaFirstdraft = function FaFirstdraft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"}}]})(props);
	};
	module.exports.FaFlickr = function FaFlickr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"}}]})(props);
	};
	module.exports.FaFlipboard = function FaFlipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"}}]})(props);
	};
	module.exports.FaFly = function FaFly (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"}}]})(props);
	};
	module.exports.FaFontAwesome = function FaFontAwesome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 48V384C385 407 366 416 329 416C266 416 242 384 179 384C159 384 143 388 128 392V328C143 324 159 320 179 320C242 320 266 352 329 352C349 352 364 349 384 343V135C364 141 349 144 329 144C266 144 242 112 179 112C128 112 104 133 64 141V448C64 466 50 480 32 480S0 466 0 448V64C0 46 14 32 32 32S64 46 64 64V77C104 69 128 48 179 48C242 48 266 80 329 80C366 80 385 71 448 48Z"}}]})(props);
	};
	module.exports.FaFonticonsFi = function FaFonticonsFi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"}}]})(props);
	};
	module.exports.FaFonticons = function FaFonticons (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"}}]})(props);
	};
	module.exports.FaFortAwesomeAlt = function FaFortAwesomeAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"}}]})(props);
	};
	module.exports.FaFortAwesome = function FaFortAwesome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"}}]})(props);
	};
	module.exports.FaForumbee = function FaForumbee (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"}}]})(props);
	};
	module.exports.FaFoursquare = function FaFoursquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 368 512"},"child":[{"tag":"path","attr":{"d":"M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"}}]})(props);
	};
	module.exports.FaFreeCodeCamp = function FaFreeCodeCamp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"}}]})(props);
	};
	module.exports.FaFreebsd = function FaFreebsd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"}}]})(props);
	};
	module.exports.FaFulcrum = function FaFulcrum (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"}}]})(props);
	};
	module.exports.FaGalacticRepublic = function FaGalacticRepublic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"}}]})(props);
	};
	module.exports.FaGalacticSenate = function FaGalacticSenate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"}}]})(props);
	};
	module.exports.FaGetPocket = function FaGetPocket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"}}]})(props);
	};
	module.exports.FaGgCircle = function FaGgCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"}}]})(props);
	};
	module.exports.FaGg = function FaGg (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"}}]})(props);
	};
	module.exports.FaGitAlt = function FaGitAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"}}]})(props);
	};
	module.exports.FaGit = function FaGit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"}}]})(props);
	};
	module.exports.FaGithubAlt = function FaGithubAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"}}]})(props);
	};
	module.exports.FaGithub = function FaGithub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}}]})(props);
	};
	module.exports.FaGitkraken = function FaGitkraken (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 592 512"},"child":[{"tag":"path","attr":{"d":"M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"}}]})(props);
	};
	module.exports.FaGitlab = function FaGitlab (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M503.5 204.6L502.8 202.8L433.1 21.02C431.7 17.45 429.2 14.43 425.9 12.38C423.5 10.83 420.8 9.865 417.9 9.57C415 9.275 412.2 9.653 409.5 10.68C406.8 11.7 404.4 13.34 402.4 15.46C400.5 17.58 399.1 20.13 398.3 22.9L351.3 166.9H160.8L113.7 22.9C112.9 20.13 111.5 17.59 109.6 15.47C107.6 13.35 105.2 11.72 102.5 10.7C99.86 9.675 96.98 9.295 94.12 9.587C91.26 9.878 88.51 10.83 86.08 12.38C82.84 14.43 80.33 17.45 78.92 21.02L9.267 202.8L8.543 204.6C-1.484 230.8-2.72 259.6 5.023 286.6C12.77 313.5 29.07 337.3 51.47 354.2L51.74 354.4L52.33 354.8L158.3 434.3L210.9 474L242.9 498.2C246.6 500.1 251.2 502.5 255.9 502.5C260.6 502.5 265.2 500.1 268.9 498.2L300.9 474L353.5 434.3L460.2 354.4L460.5 354.1C482.9 337.2 499.2 313.5 506.1 286.6C514.7 259.6 513.5 230.8 503.5 204.6z"}}]})(props);
	};
	module.exports.FaGitter = function FaGitter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"}}]})(props);
	};
	module.exports.FaGlideG = function FaGlideG (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"}}]})(props);
	};
	module.exports.FaGlide = function FaGlide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"}}]})(props);
	};
	module.exports.FaGofore = function FaGofore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 400 512"},"child":[{"tag":"path","attr":{"d":"M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"}}]})(props);
	};
	module.exports.FaGolang = function FaGolang (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M400.1 194.8C389.2 197.6 380.2 199.1 371 202.4C363.7 204.3 356.3 206.3 347.8 208.5L347.2 208.6C343 209.8 342.6 209.9 338.7 205.4C334 200.1 330.6 196.7 324.1 193.5C304.4 183.9 285.4 186.7 267.7 198.2C246.5 211.9 235.6 232.2 235.9 257.4C236.2 282.4 253.3 302.9 277.1 306.3C299.1 309.1 316.9 301.7 330.9 285.8C333 283.2 334.9 280.5 337 277.5V277.5L337 277.5C337.8 276.5 338.5 275.4 339.3 274.2H279.2C272.7 274.2 271.1 270.2 273.3 264.9C277.3 255.2 284.8 239 289.2 230.9C290.1 229.1 292.3 225.1 296.1 225.1H397.2C401.7 211.7 409 198.2 418.8 185.4C441.5 155.5 468.1 139.9 506 133.4C537.8 127.8 567.7 130.9 594.9 149.3C619.5 166.1 634.7 188.9 638.8 218.8C644.1 260.9 631.9 295.1 602.1 324.4C582.4 345.3 557.2 358.4 528.2 364.3C522.6 365.3 517.1 365.8 511.7 366.3C508.8 366.5 506 366.8 503.2 367.1C474.9 366.5 449 358.4 427.2 339.7C411.9 326.4 401.3 310.1 396.1 291.2C392.4 298.5 388.1 305.6 382.1 312.3C360.5 341.9 331.2 360.3 294.2 365.2C263.6 369.3 235.3 363.4 210.3 344.7C187.3 327.2 174.2 304.2 170.8 275.5C166.7 241.5 176.7 210.1 197.2 184.2C219.4 155.2 248.7 136.8 284.5 130.3C313.8 124.1 341.8 128.4 367.1 145.6C383.6 156.5 395.4 171.4 403.2 189.5C405.1 192.3 403.8 193.9 400.1 194.8zM48.3 200.4C47.05 200.4 46.74 199.8 47.36 198.8L53.91 190.4C54.53 189.5 56.09 188.9 57.34 188.9H168.6C169.8 188.9 170.1 189.8 169.5 190.7L164.2 198.8C163.6 199.8 162 200.7 161.1 200.7L48.3 200.4zM1.246 229.1C0 229.1-.3116 228.4 .3116 227.5L6.855 219.1C7.479 218.2 9.037 217.5 10.28 217.5H152.4C153.6 217.5 154.2 218.5 153.9 219.4L151.4 226.9C151.1 228.1 149.9 228.8 148.6 228.8L1.246 229.1zM75.72 255.9C75.1 256.8 75.41 257.7 76.65 257.7L144.6 258C145.5 258 146.8 257.1 146.8 255.9L147.4 248.4C147.4 247.1 146.8 246.2 145.5 246.2H83.2C81.95 246.2 80.71 247.1 80.08 248.1L75.72 255.9zM577.2 237.9C577 235.3 576.9 233.1 576.5 230.9C570.9 200.1 542.5 182.6 512.9 189.5C483.9 196 465.2 214.4 458.4 243.7C452.8 268 464.6 292.6 487 302.6C504.2 310.1 521.3 309.2 537.8 300.7C562.4 287.1 575.8 268 577.4 241.2C577.3 240 577.3 238.9 577.2 237.9z"}}]})(props);
	};
	module.exports.FaGoodreadsG = function FaGoodreadsG (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"}}]})(props);
	};
	module.exports.FaGoodreads = function FaGoodreads (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"}}]})(props);
	};
	module.exports.FaGoogleDrive = function FaGoogleDrive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"}}]})(props);
	};
	module.exports.FaGooglePay = function FaGooglePay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"}}]})(props);
	};
	module.exports.FaGooglePlay = function FaGooglePlay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"}}]})(props);
	};
	module.exports.FaGooglePlusG = function FaGooglePlusG (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"}}]})(props);
	};
	module.exports.FaGooglePlus = function FaGooglePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"}}]})(props);
	};
	module.exports.FaGoogleWallet = function FaGoogleWallet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"}}]})(props);
	};
	module.exports.FaGoogle = function FaGoogle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 488 512"},"child":[{"tag":"path","attr":{"d":"M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"}}]})(props);
	};
	module.exports.FaGratipay = function FaGratipay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"}}]})(props);
	};
	module.exports.FaGrav = function FaGrav (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"}}]})(props);
	};
	module.exports.FaGripfire = function FaGripfire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"}}]})(props);
	};
	module.exports.FaGrunt = function FaGrunt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"}}]})(props);
	};
	module.exports.FaGuilded = function FaGuilded (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"}}]})(props);
	};
	module.exports.FaGulp = function FaGulp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"}}]})(props);
	};
	module.exports.FaHackerNews = function FaHackerNews (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"}}]})(props);
	};
	module.exports.FaHackerrank = function FaHackerrank (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"}}]})(props);
	};
	module.exports.FaHashnode = function FaHashnode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M35.19 171.1C-11.72 217.1-11.72 294 35.19 340.9L171.1 476.8C217.1 523.7 294 523.7 340.9 476.8L476.8 340.9C523.7 294 523.7 217.1 476.8 171.1L340.9 35.19C294-11.72 217.1-11.72 171.1 35.19L35.19 171.1zM315.5 315.5C282.6 348.3 229.4 348.3 196.6 315.5C163.7 282.6 163.7 229.4 196.6 196.6C229.4 163.7 282.6 163.7 315.5 196.6C348.3 229.4 348.3 282.6 315.5 315.5z"}}]})(props);
	};
	module.exports.FaHips = function FaHips (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"}}]})(props);
	};
	module.exports.FaHireAHelper = function FaHireAHelper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"}}]})(props);
	};
	module.exports.FaHive = function FaHive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"}}]})(props);
	};
	module.exports.FaHooli = function FaHooli (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"}}]})(props);
	};
	module.exports.FaHornbill = function FaHornbill (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"}}]})(props);
	};
	module.exports.FaHotjar = function FaHotjar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M361.5 0c0 131.6-80.7 176.8-140.2 209.4c-.6 .3-1.1 .6-1.6 .9c-53.8 30.2-88.7 49.8-89.6 122H32C32 200.8 112.7 155.6 172.2 123C227 93.2 262.5 73 262.5 0h98.9zM301 302.6c54.8-29.8 90.3-50 90.3-123h98c0 131.6-80.7 176.7-140.2 209.4c-54.8 29.8-90.3 50-90.3 123h-98c0-131.6 80.7-176.8 140.2-209.4z"}}]})(props);
	};
	module.exports.FaHouzz = function FaHouzz (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"}}]})(props);
	};
	module.exports.FaHtml5 = function FaHtml5 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"}}]})(props);
	};
	module.exports.FaHubspot = function FaHubspot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"}}]})(props);
	};
	module.exports.FaIdeal = function FaIdeal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"}}]})(props);
	};
	module.exports.FaImdb = function FaImdb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M89.5 323.6H53.93V186.2H89.5V323.6zM156.1 250.5L165.2 186.2H211.5V323.6H180.5V230.9L167.1 323.6H145.8L132.8 232.9L132.7 323.6H101.5V186.2H147.6C148.1 194.5 150.4 204.3 151.9 215.6L156.1 250.5zM223.7 323.6V186.2H250.3C267.3 186.2 277.3 187.1 283.3 188.6C289.4 190.3 294 192.8 297.2 196.5C300.3 199.8 302.3 203.1 303 208.5C303.9 212.9 304.4 221.6 304.4 234.7V282.9C304.4 295.2 303.7 303.4 302.5 307.6C301.4 311.7 299.4 315 296.5 317.3C293.7 319.7 290.1 321.4 285.8 322.3C281.6 323.1 275.2 323.6 266.7 323.6H223.7zM259.2 209.7V299.1C264.3 299.1 267.5 298.1 268.6 296.8C269.7 294.8 270.4 289.2 270.4 280.1V226.8C270.4 220.6 270.3 216.6 269.7 214.8C269.4 213 268.5 211.8 267.1 210.1C265.7 210.1 263 209.7 259.2 209.7V209.7zM316.5 323.6V186.2H350.6V230.1C353.5 227.7 356.7 225.2 360.1 223.5C363.7 222 368.9 221.1 372.9 221.1C377.7 221.1 381.8 221.9 385.2 223.3C388.6 224.8 391.2 226.8 393.2 229.5C394.9 232.1 395.9 234.8 396.3 237.3C396.7 239.9 396.1 245.3 396.1 253.5V292.1C396.1 300.3 396.3 306.4 395.3 310.5C394.2 314.5 391.5 318.1 387.5 320.1C383.4 324 378.6 325.4 372.9 325.4C368.9 325.4 363.7 324.5 360.2 322.9C356.7 321.1 353.5 318.4 350.6 314.9L348.5 323.6L316.5 323.6zM361.6 302.9C362.3 301.1 362.6 296.9 362.6 290.4V255C362.6 249.4 362.3 245.5 361.5 243.8C360.8 241.9 357.8 241.1 355.7 241.1C353.7 241.1 352.3 241.9 351.6 243.4C351 244.9 350.6 248.8 350.6 255V291.4C350.6 297.5 351 301.4 351.8 303C352.4 304.7 353.9 305.5 355.9 305.5C358.1 305.5 360.1 304.7 361.6 302.9L361.6 302.9zM418.4 32.04C434.1 33.27 447.1 47.28 447.1 63.92V448.1C447.1 464.5 435.2 478.5 418.9 479.1C418.6 479.1 418.4 480 418.1 480H29.88C29.6 480 29.32 479.1 29.04 479.9C13.31 478.5 1.093 466.1 0 449.7L.0186 61.78C1.081 45.88 13.82 33.09 30.26 31.1H417.7C417.9 31.1 418.2 32.01 418.4 32.04L418.4 32.04zM30.27 41.26C19 42.01 10.02 51.01 9.257 62.4V449.7C9.63 455.1 11.91 460.2 15.7 464C19.48 467.9 24.51 470.3 29.89 470.7H418.1C429.6 469.7 438.7 459.1 438.7 448.1V63.91C438.7 58.17 436.6 52.65 432.7 48.45C428.8 44.24 423.4 41.67 417.7 41.26L30.27 41.26z"}}]})(props);
	};
	module.exports.FaInstagram = function FaInstagram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"}}]})(props);
	};
	module.exports.FaInstalod = function FaInstalod (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"}}]})(props);
	};
	module.exports.FaIntercom = function FaIntercom (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"}}]})(props);
	};
	module.exports.FaInternetExplorer = function FaInternetExplorer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"}}]})(props);
	};
	module.exports.FaInvision = function FaInvision (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"}}]})(props);
	};
	module.exports.FaIoxhost = function FaIoxhost (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaItchIo = function FaItchIo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"}}]})(props);
	};
	module.exports.FaItunesNote = function FaItunesNote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"}}]})(props);
	};
	module.exports.FaItunes = function FaItunes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"}}]})(props);
	};
	module.exports.FaJava = function FaJava (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"}}]})(props);
	};
	module.exports.FaJediOrder = function FaJediOrder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"}}]})(props);
	};
	module.exports.FaJenkins = function FaJenkins (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"}}]})(props);
	};
	module.exports.FaJira = function FaJira (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"}}]})(props);
	};
	module.exports.FaJoget = function FaJoget (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"}}]})(props);
	};
	module.exports.FaJoomla = function FaJoomla (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"}}]})(props);
	};
	module.exports.FaJs = function FaJs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"}}]})(props);
	};
	module.exports.FaJsfiddle = function FaJsfiddle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"}}]})(props);
	};
	module.exports.FaKaggle = function FaKaggle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"}}]})(props);
	};
	module.exports.FaKeybase = function FaKeybase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"}}]})(props);
	};
	module.exports.FaKeycdn = function FaKeycdn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"}}]})(props);
	};
	module.exports.FaKickstarterK = function FaKickstarterK (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"}}]})(props);
	};
	module.exports.FaKickstarter = function FaKickstarter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"}}]})(props);
	};
	module.exports.FaKorvue = function FaKorvue (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 446 512"},"child":[{"tag":"path","attr":{"d":"M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"}}]})(props);
	};
	module.exports.FaLaravel = function FaLaravel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"}}]})(props);
	};
	module.exports.FaLastfm = function FaLastfm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"}}]})(props);
	};
	module.exports.FaLeanpub = function FaLeanpub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"}}]})(props);
	};
	module.exports.FaLess = function FaLess (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"}}]})(props);
	};
	module.exports.FaLine = function FaLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M311 196.8v81.3c0 2.1-1.6 3.7-3.7 3.7h-13c-1.3 0-2.4-.7-3-1.5l-37.3-50.3v48.2c0 2.1-1.6 3.7-3.7 3.7h-13c-2.1 0-3.7-1.6-3.7-3.7V196.9c0-2.1 1.6-3.7 3.7-3.7h12.9c1.1 0 2.4 .6 3 1.6l37.3 50.3V196.9c0-2.1 1.6-3.7 3.7-3.7h13c2.1-.1 3.8 1.6 3.8 3.5zm-93.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 2.1 1.6 3.7 3.7 3.7h13c2.1 0 3.7-1.6 3.7-3.7V196.8c0-1.9-1.6-3.7-3.7-3.7zm-31.4 68.1H150.3V196.8c0-2.1-1.6-3.7-3.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 1 .3 1.8 1 2.5c.7 .6 1.5 1 2.5 1h52.2c2.1 0 3.7-1.6 3.7-3.7v-13c0-1.9-1.6-3.7-3.5-3.7zm193.7-68.1H327.3c-1.9 0-3.7 1.6-3.7 3.7v81.3c0 1.9 1.6 3.7 3.7 3.7h52.2c2.1 0 3.7-1.6 3.7-3.7V265c0-2.1-1.6-3.7-3.7-3.7H344V247.7h35.5c2.1 0 3.7-1.6 3.7-3.7V230.9c0-2.1-1.6-3.7-3.7-3.7H344V213.5h35.5c2.1 0 3.7-1.6 3.7-3.7v-13c-.1-1.9-1.7-3.7-3.7-3.7zM512 93.4V419.4c-.1 51.2-42.1 92.7-93.4 92.6H92.6C41.4 511.9-.1 469.8 0 418.6V92.6C.1 41.4 42.2-.1 93.4 0H419.4c51.2 .1 92.7 42.1 92.6 93.4zM441.6 233.5c0-83.4-83.7-151.3-186.4-151.3s-186.4 67.9-186.4 151.3c0 74.7 66.3 137.4 155.9 149.3c21.8 4.7 19.3 12.7 14.4 42.1c-.8 4.7-3.8 18.4 16.1 10.1s107.3-63.2 146.5-108.2c27-29.7 39.9-59.8 39.9-93.1z"}}]})(props);
	};
	module.exports.FaLinkedinIn = function FaLinkedinIn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"}}]})(props);
	};
	module.exports.FaLinkedin = function FaLinkedin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"}}]})(props);
	};
	module.exports.FaLinode = function FaLinode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M366.036,186.867l-59.5,36.871-.838,36.871-29.329-19.273-39.384,24.3c2.238,55.211,2.483,59.271,2.51,59.5l-97.2,65.359L127.214,285.748l108.1-62.01L195.09,197.761l-75.417,38.547L98.723,93.015,227.771,43.574,136.432,0,10.737,39.385,38.39,174.3l41.9,32.681L48.445,222.062,69.394,323.457,98.723,351.11,77.774,363.679l16.76,78.769L160.733,512c-10.8-74.842-11.658-78.641-11.725-78.773l77.925-55.3c16.759-12.57,15.083-10.894,15.083-10.894l.838,24.3,33.519,28.491-.838-77.093,46.927-33.519,26.815-18.435-2.514,36.033,25.139,17.6,6.7-74.579,58.657-43.575Z"}}]})(props);
	};
	module.exports.FaLinux = function FaLinux (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"}}]})(props);
	};
	module.exports.FaLyft = function FaLyft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"}}]})(props);
	};
	module.exports.FaMagento = function FaMagento (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"}}]})(props);
	};
	module.exports.FaMailchimp = function FaMailchimp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"}}]})(props);
	};
	module.exports.FaMandalorian = function FaMandalorian (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"}}]})(props);
	};
	module.exports.FaMarkdown = function FaMarkdown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"}}]})(props);
	};
	module.exports.FaMastodon = function FaMastodon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"}}]})(props);
	};
	module.exports.FaMaxcdn = function FaMaxcdn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"}}]})(props);
	};
	module.exports.FaMdb = function FaMdb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"}}]})(props);
	};
	module.exports.FaMedapps = function FaMedapps (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"}}]})(props);
	};
	module.exports.FaMedium = function FaMedium (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"}}]})(props);
	};
	module.exports.FaMedrt = function FaMedrt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 544 512"},"child":[{"tag":"path","attr":{"d":"M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"}}]})(props);
	};
	module.exports.FaMeetup = function FaMeetup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"}}]})(props);
	};
	module.exports.FaMegaport = function FaMegaport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"}}]})(props);
	};
	module.exports.FaMendeley = function FaMendeley (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"}}]})(props);
	};
	module.exports.FaMeta = function FaMeta (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 317.9C640 409.2 600.6 466.4 529.7 466.4C467.1 466.4 433.9 431.8 372.8 329.8L341.4 277.2C333.1 264.7 326.9 253 320.2 242.2C300.1 276 273.1 325.2 273.1 325.2C206.1 441.8 168.5 466.4 116.2 466.4C43.42 466.4 0 409.1 0 320.5C0 177.5 79.78 42.4 183.9 42.4C234.1 42.4 277.7 67.08 328.7 131.9C365.8 81.8 406.8 42.4 459.3 42.4C558.4 42.4 640 168.1 640 317.9H640zM287.4 192.2C244.5 130.1 216.5 111.7 183 111.7C121.1 111.7 69.22 217.8 69.22 321.7C69.22 370.2 87.7 397.4 118.8 397.4C149 397.4 167.8 378.4 222 293.6C222 293.6 246.7 254.5 287.4 192.2V192.2zM531.2 397.4C563.4 397.4 578.1 369.9 578.1 322.5C578.1 198.3 523.8 97.08 454.9 97.08C421.7 97.08 393.8 123 360 175.1C369.4 188.9 379.1 204.1 389.3 220.5L426.8 282.9C485.5 377 500.3 397.4 531.2 397.4L531.2 397.4z"}}]})(props);
	};
	module.exports.FaMicroblog = function FaMicroblog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"}}]})(props);
	};
	module.exports.FaMicrosoft = function FaMicrosoft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"}}]})(props);
	};
	module.exports.FaMix = function FaMix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"}}]})(props);
	};
	module.exports.FaMixcloud = function FaMixcloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M212.98 346.566H179.789V195.114L185.973 173.47H175.262L137.127 346.566H76.1069L37.7323 173.47H27.276L33.1913 195.114V346.566H0V165H65.6506L102.248 338.096H110.747L147.329 165H212.98L212.98 346.566ZM544.459 283.589L458.434 345.655V307.534L531.329 255.776L458.434 204.017V165.896L544.459 228.231H553.721L640 165.896V204.017L566.866 255.776L640 307.549V345.655L553.721 283.589H544.459ZM430.157 272.311H248.113V239.255H430.157V272.311Z"}}]})(props);
	};
	module.exports.FaMixer = function FaMixer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"}}]})(props);
	};
	module.exports.FaMizuni = function FaMizuni (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"}}]})(props);
	};
	module.exports.FaModx = function FaModx (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"}}]})(props);
	};
	module.exports.FaMonero = function FaMonero (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"}}]})(props);
	};
	module.exports.FaNapster = function FaNapster (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"}}]})(props);
	};
	module.exports.FaNeos = function FaNeos (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"}}]})(props);
	};
	module.exports.FaNfcDirectional = function FaNfcDirectional (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M211.8 488.6C213.4 491.1 213.9 494.2 213.2 497.1C212.6 500 210.8 502.6 208.3 504.2C205.7 505.8 202.7 506.3 199.7 505.7C138.3 491.8 84.1 455.8 47.53 404.5C10.97 353.2-5.395 290.3 1.57 227.7C8.536 165 38.34 107.2 85.29 65.21C132.2 23.2 193-.0131 256 0C257.5 0 258.1 .2931 260.3 .8627C261.7 1.432 262.1 2.267 264 3.319C265.1 4.371 265.9 5.619 266.5 6.993C267 8.367 267.3 9.839 267.3 11.32V112.3L291.8 86.39C292.8 85.31 294 84.44 295.4 83.84C296.7 83.23 298.2 82.9 299.7 82.86C301.2 82.81 302.6 83.06 304 83.59C305.4 84.12 306.7 84.92 307.8 85.94C308.8 86.96 309.7 88.18 310.3 89.54C310.9 90.89 311.3 92.35 311.3 93.84C311.3 95.32 311.1 96.8 310.6 98.18C310 99.57 309.2 100.8 308.2 101.9L264.2 148.5C263.1 149.6 261.9 150.5 260.5 151.1C259 151.7 257.5 152 255.1 152C254.5 152 252.9 151.7 251.5 151.1C250.1 150.5 248.8 149.6 247.8 148.5L203.7 101.9C201.7 99.74 200.6 96.83 200.7 93.84C200.7 90.84 202 87.1 204.2 85.94C206.4 83.88 209.3 82.77 212.3 82.86C215.3 82.94 218.1 84.21 220.2 86.39L244.7 112.4V22.89C188.3 25.64 134.9 48.73 94.23 87.87C53.58 127 28.49 179.6 23.61 235.8C18.73 292 34.38 348.1 67.68 393.7C100.1 439.2 149.7 471.2 204.7 483.6C207.6 484.3 210.2 486.1 211.8 488.6L211.8 488.6zM171.4 126.1C170.6 127.4 169.5 128.5 168.3 129.3C147.8 143.2 131.1 161.9 119.5 183.8C107.9 205.7 101.8 230.1 101.8 254.9C101.8 279.7 107.9 304.1 119.5 325.1C131.1 347.9 147.8 366.6 168.3 380.5C170.8 382.2 172.5 384.8 173 387.8C173.6 390.7 172.1 393.8 171.3 396.2C169.6 398.7 166.1 400.4 164 400.1C161.1 401.5 158 400.9 155.6 399.2C132 383.2 112.8 361.7 99.46 336.5C86.15 311.4 79.19 283.4 79.19 254.9C79.19 226.5 86.15 198.4 99.46 173.3C112.8 148.1 132 126.6 155.6 110.6C156.8 109.8 158.2 109.2 159.6 108.8C161.1 108.5 162.6 108.5 164.1 108.8C165.5 109 166.9 109.6 168.2 110.4C169.5 111.2 170.5 112.3 171.4 113.5C172.2 114.7 172.8 116.1 173.1 117.6C173.4 119.1 173.4 120.6 173.1 122C172.8 123.5 172.3 124.9 171.4 126.1H171.4zM340.9 383.5C341.7 382.3 342.8 381.2 343.1 380.4V380.3C364.4 366.3 381.1 347.6 392.7 325.7C404.2 303.9 410.2 279.5 410.2 254.8C410.2 230.1 404.2 205.7 392.7 183.8C381.1 161.1 364.4 143.3 343.1 129.3C342.8 128.5 341.7 127.4 340.9 126.2C340.1 124.9 339.5 123.5 339.3 122.1C338.1 120.6 339 119.1 339.3 117.7C339.6 116.2 340.2 114.8 341 113.6C341.9 112.4 342.1 111.3 344.2 110.5C345.4 109.7 346.8 109.2 348.3 108.9C349.8 108.6 351.2 108.6 352.7 108.9C354.2 109.2 355.5 109.8 356.8 110.7C380.2 126.7 399.5 148.2 412.7 173.3C426 198.4 432.1 226.4 432.1 254.8C432.1 283.3 426 311.3 412.7 336.4C399.5 361.5 380.2 383 356.8 399C355.5 399.9 354.2 400.5 352.7 400.8C351.2 401.1 349.8 401.1 348.3 400.8C346.8 400.5 345.4 399.1 344.2 399.2C342.1 398.4 341.9 397.3 341 396.1C340.2 394.9 339.6 393.5 339.3 392C339 390.6 338.1 389.1 339.3 387.6C339.5 386.2 340.1 384.8 340.9 383.5V383.5zM312.3 6.307C368.5 19.04 418.7 50.28 455 95.01C485.4 132.6 504.6 178 510.3 226C515.9 274 507.9 322.7 487.1 366.3C466.2 409.9 433.5 446.8 392.6 472.6C351.7 498.3 304.4 512 256 512C254.5 512 253.1 511.7 251.7 511.1C250.3 510.6 249.1 509.7 248 508.7C246.1 507.6 246.1 506.4 245.6 505C245 503.6 244.7 502.2 244.7 500.7V401.5L220.2 427.5C218.1 429.7 215.3 430.1 212.3 431.1C209.3 431.2 206.4 430 204.2 427.1C202 425.9 200.7 423.1 200.7 420.1C200.6 417.1 201.7 414.2 203.7 412L247.8 365.4C249.1 363.2 252.9 362 255.1 362C259.1 362 262 363.2 264.2 365.4L308.2 412C310.3 414.2 311.4 417.1 311.3 420.1C311.2 423.1 309.9 425.9 307.8 427.1C305.6 430 302.7 431.2 299.7 431.1C296.7 430.1 293.8 429.7 291.8 427.5L267.3 401.6V489.1C323.7 486.3 377.1 463.3 417.8 424.1C458.5 384.1 483.6 332.4 488.5 276.2C493.3 219.1 477.7 163.9 444.4 118.3C411.1 72.75 362.4 40.79 307.4 28.36C305.9 28.03 304.6 27.42 303.3 26.57C302.1 25.71 301.1 24.63 300.3 23.37C299.5 22.12 298.1 20.72 298.7 19.26C298.5 17.8 298.5 16.3 298.8 14.85C299.2 13.41 299.8 12.04 300.6 10.82C301.5 9.61 302.6 8.577 303.8 7.784C305.1 6.99 306.5 6.451 307.9 6.198C309.4 5.945 310.9 5.982 312.3 6.307L312.3 6.307zM353.1 256.1C353.1 287.5 335.6 317.2 303.8 339.6C301.7 341.1 299 341.9 296.4 341.6C293.7 341.4 291.2 340.3 289.4 338.4L219.3 268.6C217.1 266.5 215.1 263.6 215.9 260.6C215.9 257.6 217.1 254.7 219.2 252.6C221.4 250.5 224.2 249.3 227.2 249.3C230.2 249.3 233.1 250.5 235.2 252.6L298.3 315.4C319.1 298.3 330.5 277.5 330.5 256.1C330.5 232.2 316.4 209.1 290.8 191C288.3 189.3 286.7 186.7 286.2 183.7C285.7 180.8 286.3 177.7 288.1 175.3C289.8 172.8 292.4 171.2 295.4 170.7C298.3 170.2 301.4 170.8 303.8 172.6C335.6 195 353.1 224.7 353.1 256.1V256.1zM216.7 341.5C213.7 342 210.7 341.3 208.2 339.6C176.5 317.2 158.1 287.5 158.1 256.1C158.1 224.7 176.5 195 208.2 172.6C210.4 171 213.1 170.3 215.7 170.5C218.4 170.8 220.8 171.9 222.7 173.8L292.8 243.6C294.9 245.7 296.1 248.6 296.1 251.6C296.1 254.6 294.1 257.4 292.8 259.6C290.7 261.7 287.8 262.9 284.9 262.9C281.9 262.9 278.1 261.7 276.9 259.6L213.8 196.7C192.9 214 181.6 234.7 181.6 256.1C181.6 279.1 195.7 303.1 221.3 321.1C223.7 322.9 225.4 325.5 225.9 328.5C226.4 331.4 225.7 334.4 224 336.9C222.3 339.3 219.6 341 216.7 341.5L216.7 341.5z"}}]})(props);
	};
	module.exports.FaNfcSymbol = function FaNfcSymbol (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M392.9 32.43C400.6 31.1 408.6 32.89 414.1 37.41C498.2 96.14 544 173.7 544 255.1C544 338.2 498.2 415.9 414.1 474.6C409.3 478.6 402.4 480.5 395.5 479.9C388.5 479.3 382 476.3 377.1 471.4L193.7 288.7C188.1 283.2 185 275.7 184.1 267.8C184.1 260 188.1 252.5 193.6 246.9C199.2 241.4 206.7 238.2 214.5 238.2C222.4 238.2 229.9 241.3 235.4 246.8L400.5 411.2C455.1 366.5 484.8 312 484.8 255.1C484.8 193.5 447.9 132.9 380.9 85.76C374.5 81.24 370.1 74.35 368.8 66.62C367.4 58.89 369.2 50.94 373.8 44.53C378.3 38.12 385.2 33.77 392.9 32.43V32.43zM186.9 479.6C179.2 480.9 171.3 479.1 164.8 474.6C81.67 415.9 35.84 338.2 35.84 255.1C35.84 173.7 81.67 96.14 164.8 37.41C170.5 33.4 177.4 31.53 184.4 32.12C191.3 32.71 197.8 35.72 202.7 40.63L386.1 223.3C391.7 228.8 394.8 236.3 394.8 244.2C394.9 251.1 391.8 259.5 386.2 265.1C380.7 270.6 373.2 273.8 365.3 273.8C357.5 273.8 349.1 270.7 344.4 265.2L179.3 100.7C124.7 145.9 95.03 199.9 95.03 255.1C95.03 318.5 131.9 379.1 198.1 426.2C205.4 430.8 209.7 437.6 211.1 445.4C212.4 453.1 210.6 461.1 206.1 467.5C201.6 473.9 194.7 478.2 186.9 479.6V479.6z"}}]})(props);
	};
	module.exports.FaNimblr = function FaNimblr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"}}]})(props);
	};
	module.exports.FaNodeJs = function FaNodeJs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"}}]})(props);
	};
	module.exports.FaNode = function FaNode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"}}]})(props);
	};
	module.exports.FaNpm = function FaNpm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"}}]})(props);
	};
	module.exports.FaNs8 = function FaNs8 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"}}]})(props);
	};
	module.exports.FaNutritionix = function FaNutritionix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 400 512"},"child":[{"tag":"path","attr":{"d":"M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"}}]})(props);
	};
	module.exports.FaOctopusDeploy = function FaOctopusDeploy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"}}]})(props);
	};
	module.exports.FaOdnoklassniki = function FaOdnoklassniki (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"}}]})(props);
	};
	module.exports.FaOdysee = function FaOdysee (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M406.7 463c-42.3 30.8-94.4 49-150.7 49C144.9 512 50.3 441.2 14.9 342.2c2.4 1.7 5.9 3.6 7.9 4.4c16.3 7.4 40.1-5.4 62.9-28.7c6.9-6.9 14.4-12.4 22.8-17.3c18.3-11.9 37.6-20.8 58.4-27.2c0 0 22.3 34.2 43.1 74.8s-22.3 54-27.2 54c-.3 0-.8 0-1.5-.1c-11-.5-70-3-56 51.1c14.9 57.4 97.5 36.6 139.6 8.9s31.7-118.3 31.7-118.3c41.1-6.4 54 37.1 57.9 59.4c.8 4.6 1.1 9.9 1.4 15.5c1.1 21.2 2.3 45.6 35.3 46.4c5.3 0 10.6-.8 15.5-2zm-95.3-23.7c-2-.5-3.5-2.5-3-5c1-2.5 3-3.5 5-3s3.5 3 3 5s-2.5 3.5-5 3zm-207-95.6c1.5-.5 3.5 1 4 3c0 2-1 4-3 4c-1.5 .5-3.5-1-4-3c-.5-1.5 1-3.5 3-4zM451.8 421C489.3 376.4 512 318.8 512 256c0-67.5-26.1-128.9-68.8-174.7c-.1 23.5-6.1 48.2-16.8 69.2c-11.9 20.3-49 58.9-69.8 78.7c-.7 .3-1.1 .9-1.5 1.4c-.2 .2-.3 .4-.5 .6c-5 6.9-4 16.8 3 21.8c21.3 15.8 56.4 45.6 59.4 72.8c3.5 34.9 27.9 75.6 34.2 86.2l0 0c.8 1.3 1.3 2.1 1.4 2.4c0 2.2-.4 4.3-.8 6.5zM390.7 251c-.5 3 1 5.9 4 6.4s5.9-1 6.4-4s-1-5.9-4-6.4c-3-1-5.9 1-6.4 4zm61.4-60.9l-11.4 5.4-3 12.9-5.4-11.4-12.9-3 11.4-5.4 3-12.9 5.4 11.4 12.9 3zM395.5 41.3c-16.2 8.2-22.1 32.8-29 61.4l0 0c-.3 1.4-.7 2.8-1 4.2c-9.5 38.5-30.6 37.6-41.7 37.2c-1.1 0-2-.1-2.9-.1c-5.1 0-6-4-8.9-17.1c-2.6-12.1-6.9-32-17.9-63.6C271.4-2.5 211.4 13.9 165.9 41.1C110.6 74.2 131.5 143 146.1 190.5c.7 2.2 1.4 4.4 2 6.6c-4 4-13.8 7.5-26 11.9c-12.1 4.3-26.6 9.5-40.3 16.9C47.9 243.9 11.5 274.9 2 288.5C.7 277.8 0 267 0 256C0 114.6 114.6 0 256 0c51.4 0 99.4 15.2 139.5 41.3zM58.9 189.6c-1.5-2-4.5-3-6.4-1.5s-3 4.5-1.5 6.4s4.5 3 6.4 1.5c2.5-1.5 3-4.5 1.5-6.4zM327.3 64.9c2-1.5 5-.5 6.4 1.5c1.5 2.5 1 5.4-1.5 6.4c-2 1.5-5 .5-6.4-1.5s-.5-5 1.5-6.4zM95.1 105c-.5 1.5 .5 3 2 3c1.5 .5 3-.5 3-2c.5-1.5-.5-3-2-3s-3 .5-3 2zm84.7-.5c-3.5-43.1 37.1-54 37.1-54c44.1-15.4 56 5.9 66.4 37.6s3 42.6-38.6 58.9s-61.9-4.5-64.9-42.6zm89.6 14.9h1c2.5 0 5-2 5-5c2-6.9 1-14.4-2-20.8c-1.5-2-4-3.5-6.4-2.5c-3 1-4.5 4-3.5 6.9c2 4.5 3 9.9 1.5 14.9c-.5 3 1.5 5.9 4.5 6.4zm-9.9-41.6c-2 0-4-1-5-3s-2-3.5-3-5c-2-2-2-5.4 0-7.4s5.4-2 7.4 0c2 2.5 3.5 5 5 7.4s.5 5.9-2.5 7.4c-.6 0-1 .2-1.3 .3c-.2 .1-.4 .2-.6 .2z"}}]})(props);
	};
	module.exports.FaOldRepublic = function FaOldRepublic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"}}]})(props);
	};
	module.exports.FaOpencart = function FaOpencart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"}}]})(props);
	};
	module.exports.FaOpenid = function FaOpenid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"}}]})(props);
	};
	module.exports.FaOpera = function FaOpera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"}}]})(props);
	};
	module.exports.FaOptinMonster = function FaOptinMonster (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"}}]})(props);
	};
	module.exports.FaOrcid = function FaOrcid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"}}]})(props);
	};
	module.exports.FaOsi = function FaOsi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"}}]})(props);
	};
	module.exports.FaPadlet = function FaPadlet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M297.9 0L298 .001C305.6 .1078 312.4 4.72 315.5 11.78L447.5 320.3L447.8 320.2L448 320.6L445.2 330.6L402.3 488.6C398.6 504.8 382.6 514.9 366.5 511.2L298.1 495.6L229.6 511.2C213.5 514.9 197.5 504.8 193.8 488.6L150.9 330.6L148.2 320.6L148.3 320.2L280.4 11.78C283.4 4.797 290.3 .1837 297.9 .0006L297.9 0zM160.1 322.1L291.1 361.2L298 483.7L305.9 362.2L436.5 322.9L436.7 322.8L305.7 347.9L297.1 27.72L291.9 347.9L160.1 322.1zM426 222.6L520.4 181.6H594.2L437.2 429.2L468.8 320.2L426 222.6zM597.5 181.4L638.9 257.6C642.9 265.1 635 273.5 627.3 269.8L579.7 247.1L597.5 181.4zM127.3 318.5L158.7 430L1.61 154.5C-4.292 144.1 7.128 132.5 17.55 138.3L169.4 222.5L127.3 318.5z"}}]})(props);
	};
	module.exports.FaPage4 = function FaPage4 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"}}]})(props);
	};
	module.exports.FaPagelines = function FaPagelines (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"}}]})(props);
	};
	module.exports.FaPalfed = function FaPalfed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"}}]})(props);
	};
	module.exports.FaPatreon = function FaPatreon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}}]})(props);
	};
	module.exports.FaPaypal = function FaPaypal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"}}]})(props);
	};
	module.exports.FaPerbyte = function FaPerbyte (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"}}]})(props);
	};
	module.exports.FaPeriscope = function FaPeriscope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"}}]})(props);
	};
	module.exports.FaPhabricator = function FaPhabricator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"}}]})(props);
	};
	module.exports.FaPhoenixFramework = function FaPhoenixFramework (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"}}]})(props);
	};
	module.exports.FaPhoenixSquadron = function FaPhoenixSquadron (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"}}]})(props);
	};
	module.exports.FaPhp = function FaPhp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"}}]})(props);
	};
	module.exports.FaPiedPiperAlt = function FaPiedPiperAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"}}]})(props);
	};
	module.exports.FaPiedPiperHat = function FaPiedPiperHat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"}}]})(props);
	};
	module.exports.FaPiedPiperPp = function FaPiedPiperPp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"}}]})(props);
	};
	module.exports.FaPiedPiper = function FaPiedPiper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"}}]})(props);
	};
	module.exports.FaPinterestP = function FaPinterestP (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"}}]})(props);
	};
	module.exports.FaPinterest = function FaPinterest (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}}]})(props);
	};
	module.exports.FaPix = function FaPix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.76C231.1-7.586 280.3-7.586 310.6 22.76L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.78L22.76 310.6C-7.586 280.3-7.586 231.1 22.76 200.8L80.78 142.7H112.6z"}}]})(props);
	};
	module.exports.FaPlaystation = function FaPlaystation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"}}]})(props);
	};
	module.exports.FaProductHunt = function FaProductHunt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"}}]})(props);
	};
	module.exports.FaPushed = function FaPushed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 432 512"},"child":[{"tag":"path","attr":{"d":"M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"}}]})(props);
	};
	module.exports.FaPython = function FaPython (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"}}]})(props);
	};
	module.exports.FaQq = function FaQq (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"}}]})(props);
	};
	module.exports.FaQuinscape = function FaQuinscape (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"}}]})(props);
	};
	module.exports.FaQuora = function FaQuora (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"}}]})(props);
	};
	module.exports.FaRProject = function FaRProject (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 581 512"},"child":[{"tag":"path","attr":{"d":"M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"}}]})(props);
	};
	module.exports.FaRaspberryPi = function FaRaspberryPi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 407 512"},"child":[{"tag":"path","attr":{"d":"M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"}}]})(props);
	};
	module.exports.FaRavelry = function FaRavelry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"}}]})(props);
	};
	module.exports.FaReact = function FaReact (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"}}]})(props);
	};
	module.exports.FaReacteurope = function FaReacteurope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"}}]})(props);
	};
	module.exports.FaReadme = function FaReadme (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"}}]})(props);
	};
	module.exports.FaRebel = function FaRebel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"}}]})(props);
	};
	module.exports.FaRedRiver = function FaRedRiver (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"}}]})(props);
	};
	module.exports.FaRedditAlien = function FaRedditAlien (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"}}]})(props);
	};
	module.exports.FaReddit = function FaReddit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}}]})(props);
	};
	module.exports.FaRedhat = function FaRedhat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"}}]})(props);
	};
	module.exports.FaRenren = function FaRenren (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"}}]})(props);
	};
	module.exports.FaReplyd = function FaReplyd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"}}]})(props);
	};
	module.exports.FaResearchgate = function FaResearchgate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"}}]})(props);
	};
	module.exports.FaResolving = function FaResolving (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"}}]})(props);
	};
	module.exports.FaRev = function FaRev (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"}}]})(props);
	};
	module.exports.FaRocketchat = function FaRocketchat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"}}]})(props);
	};
	module.exports.FaRockrms = function FaRockrms (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"}}]})(props);
	};
	module.exports.FaRust = function FaRust (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"}}]})(props);
	};
	module.exports.FaSafari = function FaSafari (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"}}]})(props);
	};
	module.exports.FaSalesforce = function FaSalesforce (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"}}]})(props);
	};
	module.exports.FaSass = function FaSass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"}}]})(props);
	};
	module.exports.FaSchlix = function FaSchlix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"}}]})(props);
	};
	module.exports.FaScreenpal = function FaScreenpal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M233.5 22.49C233.5 10.07 243.6 0 256 0C268.4 0 278.5 10.07 278.5 22.49C278.5 34.91 268.4 44.98 256 44.98C243.6 44.98 233.5 34.91 233.5 22.49zM313.4 259C313.4 290.7 287.7 316.4 256 316.4C224.3 316.4 198.6 290.7 198.6 259C198.6 227.3 224.3 201.6 256 201.6C287.7 201.6 313.4 227.3 313.4 259zM337.2 350C359.5 330.1 373.7 302.7 377.1 273H496.6C493.1 334.4 466.2 392.2 421.4 434.4C376.7 476.6 317.5 500.2 256 500.2C194.5 500.2 135.3 476.6 90.56 434.4C45.83 392.2 18.94 334.4 15.39 273H135.1C138.5 302.7 152.7 330.1 175 350C197.3 369.9 226.2 380.9 256.1 380.9C285.1 380.9 314.8 369.9 337.2 350zM73.14 140.3C73.54 152.7 63.81 163.1 51.39 163.5C38.97 163.9 28.59 154.2 28.18 141.8C27.78 129.3 37.52 118.9 49.94 118.5C62.35 118.1 72.74 127.9 73.14 140.3zM438.9 141C438.9 128.6 448.9 118.5 461.4 118.5C473.8 118.5 483.8 128.6 483.8 141C483.8 153.5 473.8 163.5 461.4 163.5C448.9 163.5 438.9 153.5 438.9 141zM317.9 95.27C300.6 109.1 278.7 118.1 256 118.1C233.3 118.1 211.4 109.1 194.1 95.27C176.8 80.55 165.3 60.18 161.7 37.78C176.8 31.37 192.5 26.52 208.6 23.31C208.6 35.88 213.6 47.93 222.5 56.82C231.4 65.7 243.4 70.7 256 70.7C268.6 70.7 280.6 65.7 289.5 56.82C298.4 47.93 303.4 35.88 303.4 23.31C319.5 26.52 335.2 31.37 350.3 37.78C346.7 60.18 335.2 80.55 317.9 95.27H317.9zM82.78 231C61.42 238.6 38.06 238.4 16.86 230.4C18.82 214.1 22.46 198.1 27.71 182.5C33.1 185.6 39.05 187.6 45.22 188.5C51.39 189.3 57.67 188.9 63.68 187.3C69.69 185.6 75.33 182.9 80.27 179.1C85.21 175.3 89.36 170.6 92.47 165.2C95.58 159.8 97.61 153.8 98.42 147.7C99.23 141.5 98.83 135.2 97.22 129.2C95.61 123.2 92.83 117.6 89.04 112.6C85.25 107.7 80.53 103.5 75.14 100.4C85.96 88.11 98.01 76.94 111.1 67.07C128.7 81.42 140.6 101.6 144.7 123.9C148.8 146.2 144.8 169.3 133.5 188.9C122.1 208.5 104.1 223.4 82.78 231V231zM429.2 231.1C407.9 223.5 389.9 208.5 378.5 188.9C367.2 169.3 363.3 146.2 367.4 123.9C371.5 101.7 383.4 81.54 400.9 67.19C414 77.04 426.1 88.21 436.9 100.5C426.2 106.9 418.5 117.2 415.4 129.3C412.2 141.3 413.1 154.1 420.2 164.9C426.4 175.7 436.6 183.6 448.6 186.9C460.6 190.2 473.5 188.6 484.3 182.6C489.6 198.1 493.2 214.2 495.2 230.4C473.1 238.5 450.6 238.7 429.2 231.1L429.2 231.1z"}}]})(props);
	};
	module.exports.FaScribd = function FaScribd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"}}]})(props);
	};
	module.exports.FaSearchengin = function FaSearchengin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 460 512"},"child":[{"tag":"path","attr":{"d":"M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"}}]})(props);
	};
	module.exports.FaSellcast = function FaSellcast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"}}]})(props);
	};
	module.exports.FaSellsy = function FaSellsy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"}}]})(props);
	};
	module.exports.FaServicestack = function FaServicestack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"}}]})(props);
	};
	module.exports.FaShirtsinbulk = function FaShirtsinbulk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"}}]})(props);
	};
	module.exports.FaShopify = function FaShopify (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"}}]})(props);
	};
	module.exports.FaShopware = function FaShopware (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"}}]})(props);
	};
	module.exports.FaSimplybuilt = function FaSimplybuilt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"}}]})(props);
	};
	module.exports.FaSistrix = function FaSistrix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"}}]})(props);
	};
	module.exports.FaSith = function FaSith (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"}}]})(props);
	};
	module.exports.FaSitrox = function FaSitrox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M212.439 0.00846128V0H448V128H64C64 57.6008 141.755 0.475338 212.439 0.00846128ZM237.256 192V192.007C307.135 192.475 384 249.6 384 320H210.809V319.995C140.915 319.563 64 262.424 64 192H237.256ZM235.565 511.993C306.251 511.521 384 454.399 384 384H0V512H235.565V511.993Z"}}]})(props);
	};
	module.exports.FaSketch = function FaSketch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"}}]})(props);
	};
	module.exports.FaSkyatlas = function FaSkyatlas (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"}}]})(props);
	};
	module.exports.FaSkype = function FaSkype (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"}}]})(props);
	};
	module.exports.FaSlack = function FaSlack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"}}]})(props);
	};
	module.exports.FaSlideshare = function FaSlideshare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"}}]})(props);
	};
	module.exports.FaSnapchat = function FaSnapchat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"}}]})(props);
	};
	module.exports.FaSoundcloud = function FaSoundcloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"}}]})(props);
	};
	module.exports.FaSourcetree = function FaSourcetree (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"}}]})(props);
	};
	module.exports.FaSpaceAwesome = function FaSpaceAwesome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 256H128V512H0V352H32V320H64V288H96V256zM512 352V512H384V256H416V288H448V320H480V352H512zM320 64H352V448H320V416H192V448H160V64H192V32H224V0H288V32H320V64zM288 128H224V192H288V128z"}}]})(props);
	};
	module.exports.FaSpeakap = function FaSpeakap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"}}]})(props);
	};
	module.exports.FaSpeakerDeck = function FaSpeakerDeck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"}}]})(props);
	};
	module.exports.FaSpotify = function FaSpotify (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"}}]})(props);
	};
	module.exports.FaSquareBehance = function FaSquareBehance (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8V185zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2z"}}]})(props);
	};
	module.exports.FaSquareDribbble = function FaSquareDribbble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4zM140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6zm98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160z"}}]})(props);
	};
	module.exports.FaSquareFacebook = function FaSquareFacebook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"}}]})(props);
	};
	module.exports.FaSquareFontAwesomeStroke = function FaSquareFontAwesomeStroke (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M201.6,152c-25.4,0-37.4,10.4-57.6,14.4V160c0-8.8-7.2-16-16-16s-16,7.2-16,16v192c0,0.8,0.1,1.6,0.2,2.4 c0.1,0.4,0.1,0.8,0.2,1.2c1.6,7.1,8,12.4,15.6,12.4s14-5.3,15.6-12.4c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.8,0.2-1.6,0.2-2.4V198.4 c4-0.8,7.7-1.8,11.2-3c14.3-4.7,26-11.4,46.4-11.4c31.4,0,43.2,16,74.6,16c8.9,0,15.9-1.1,24.2-3.5c1.2-0.3,2.4-0.7,3.6-1.1v96 c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.4-16-74.6-16c-10.2,0-18.2,1.8-25.6,4v32c7.4-2.4,15.4-4,25.6-4c31.4,0,43.2,16,74.6,16 c18.6,0,28.2-4.8,59.8-16V152c-31.6,11.2-41.2,16-59.8,16C244.8,168,232.8,152,201.6,152z M384,32H64C28.7,32,0,60.7,0,96v320 c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64V96C448,60.7,419.3,32,384,32z M416,416c0,17.6-14.4,32-32,32H64 c-17.6,0-32-14.4-32-32V96c0-17.6,14.4-32,32-32h320c17.6,0,32,14.4,32,32V416z"}}]})(props);
	};
	module.exports.FaSquareFontAwesome = function FaSquareFontAwesome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384.5,32.5h-320c-35.3,0-64,28.7-64,64v320c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64v-320 C448.5,61.2,419.8,32.5,384.5,32.5z M336.5,312.5c-31.6,11.2-41.2,16-59.8,16c-31.4,0-43.2-16-74.6-16c-10.2,0-18.2,1.6-25.6,4v-32 c7.4-2.2,15.4-4,25.6-4c31.2,0,43.2,16,74.6,16c10.2,0,17.8-1.4,27.8-4.6v-96c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.2-16-74.6-16 c-25.4,0-37.4,10.4-57.6,14.4v153.6c0,8.8-7.2,16-16,16c-8.8,0-16-7.2-16-16v-192c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16v6.4 c20.2-4,32.2-14.4,57.6-14.4c31.2,0,43.2,16,74.6,16c18.6,0,28.2-4.8,59.8-16V312.5z"}}]})(props);
	};
	module.exports.FaSquareGit = function FaSquareGit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48zm-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31zM199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84l-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z"}}]})(props);
	};
	module.exports.FaSquareGithub = function FaSquareGithub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"}}]})(props);
	};
	module.exports.FaSquareGitlab = function FaSquareGitlab (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32zM382.1 224.9L337.5 108.5C336.6 106.2 334.9 104.2 332.9 102.9C331.3 101.9 329.5 101.3 327.7 101.1C325.9 100.9 324 101.2 322.3 101.8C320.6 102.5 319 103.5 317.8 104.9C316.6 106.3 315.7 107.9 315.2 109.7L285 201.9H162.1L132.9 109.7C132.4 107.9 131.4 106.3 130.2 104.9C128.1 103.6 127.4 102.5 125.7 101.9C123.1 101.2 122.1 100.1 120.3 101.1C118.5 101.3 116.7 101.9 115.1 102.9C113.1 104.2 111.5 106.2 110.6 108.5L65.94 224.9L65.47 226.1C59.05 242.9 58.26 261.3 63.22 278.6C68.18 295.9 78.62 311.1 92.97 321.9L93.14 322L93.52 322.3L161.4 373.2L215.6 414.1C217.1 415.1 220.9 416.9 223.9 416.9C226.9 416.9 229.9 415.1 232.3 414.1L286.4 373.2L354.8 322L355 321.9C369.4 311 379.8 295.8 384.8 278.6C389.7 261.3 388.1 242.9 382.5 226.1L382.1 224.9z"}}]})(props);
	};
	module.exports.FaSquareGooglePlus = function FaSquareGooglePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"}}]})(props);
	};
	module.exports.FaSquareHackerNews = function FaSquareHackerNews (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"}}]})(props);
	};
	module.exports.FaSquareInstagram = function FaSquareInstagram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"}}]})(props);
	};
	module.exports.FaSquareJs = function FaSquareJs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"}}]})(props);
	};
	module.exports.FaSquareLastfm = function FaSquareLastfm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z"}}]})(props);
	};
	module.exports.FaSquareOdnoklassniki = function FaSquareOdnoklassniki (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1zm174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37z"}}]})(props);
	};
	module.exports.FaSquarePiedPiper = function FaSquarePiedPiper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"}}]})(props);
	};
	module.exports.FaSquarePinterest = function FaSquarePinterest (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"}}]})(props);
	};
	module.exports.FaSquareReddit = function FaSquareReddit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z"}}]})(props);
	};
	module.exports.FaSquareSnapchat = function FaSquareSnapchat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32Zm-3.907,319.309-.083.1a32.364,32.364,0,0,1-8.717,6.823,90.26,90.26,0,0,1-20.586,8.2,12.694,12.694,0,0,0-3.852,1.76c-2.158,1.909-2.1,4.64-4.4,8.55a23.137,23.137,0,0,1-6.84,7.471c-6.707,4.632-14.244,4.923-22.23,5.23-7.214.274-15.39.581-24.729,3.669-3.761,1.245-7.753,3.694-12.377,6.533-11.265,6.9-26.68,16.353-52.3,16.353s-40.925-9.4-52.106-16.279c-4.657-2.888-8.675-5.362-12.543-6.64-9.339-3.08-17.516-3.4-24.729-3.67-7.986-.307-15.523-.6-22.231-5.229a23.085,23.085,0,0,1-6.01-6.11c-3.2-4.632-2.855-7.8-5.254-9.895a13.428,13.428,0,0,0-4.1-1.834,89.986,89.986,0,0,1-20.313-8.127,32.905,32.905,0,0,1-8.3-6.284c-6.583-6.757-8.276-14.776-5.686-21.824,3.436-9.338,11.571-12.111,19.4-16.262,14.776-8.027,26.348-18.055,34.433-29.884a68.236,68.236,0,0,0,5.985-10.567c.789-2.158.772-3.329.241-4.416a7.386,7.386,0,0,0-2.208-2.217c-2.532-1.676-5.113-3.353-6.882-4.5-3.27-2.141-5.868-3.818-7.529-4.98-6.267-4.383-10.65-9.04-13.4-14.245a28.4,28.4,0,0,1-1.369-23.584c4.134-10.924,14.469-17.706,26.978-17.706a37.141,37.141,0,0,1,7.845.83c.689.15,1.37.307,2.042.482-.108-7.43.058-15.357.722-23.119,2.358-27.261,11.912-41.589,21.874-52.994a86.836,86.836,0,0,1,22.28-17.931C188.254,100.383,205.312,96,224,96s35.828,4.383,50.944,13.016a87.169,87.169,0,0,1,22.239,17.9c9.961,11.406,19.516,25.709,21.874,52.995a231.194,231.194,0,0,1,.713,23.118c.673-.174,1.362-.332,2.051-.481a37.131,37.131,0,0,1,7.844-.83c12.5,0,22.82,6.782,26.971,17.706a28.37,28.37,0,0,1-1.4,23.559c-2.74,5.2-7.123,9.861-13.39,14.244-1.668,1.187-4.258,2.864-7.529,4.981-1.835,1.187-4.541,2.947-7.164,4.682a6.856,6.856,0,0,0-1.951,2.034c-.506,1.046-.539,2.191.166,4.208a69.015,69.015,0,0,0,6.085,10.792c8.268,12.1,20.188,22.313,35.454,30.407,1.486.772,2.98,1.5,4.441,2.258.722.332,1.569.763,2.491,1.3,4.9,2.723,9.2,6.01,11.455,12.153C387.821,336.915,386.269,344.7,380.093,351.309Zm-16.719-18.461c-50.313-24.314-58.332-61.918-58.689-64.749-.431-3.379-.921-6.035,2.806-9.472,3.594-3.328,19.541-13.19,23.965-16.278,7.33-5.114,10.534-10.219,8.16-16.495-1.66-4.316-5.686-5.976-9.961-5.976a18.5,18.5,0,0,0-3.993.448c-8.035,1.743-15.838,5.769-20.354,6.857a7.1,7.1,0,0,1-1.66.224c-2.408,0-3.279-1.071-3.088-3.968.564-8.783,1.759-25.925.373-41.937-1.884-22.032-8.99-32.948-17.432-42.6-4.051-4.624-23.135-24.654-59.536-24.654S168.53,134.359,164.479,139c-8.434,9.654-15.531,20.57-17.432,42.6-1.386,16.013-.141,33.147.373,41.937.166,2.756-.68,3.968-3.088,3.968a7.1,7.1,0,0,1-1.66-.224c-4.507-1.087-12.31-5.113-20.346-6.856a18.494,18.494,0,0,0-3.993-.449c-4.25,0-8.3,1.636-9.961,5.977-2.374,6.276.847,11.381,8.168,16.494,4.425,3.088,20.371,12.958,23.966,16.279,3.719,3.437,3.237,6.093,2.805,9.471-.356,2.79-8.384,40.394-58.689,64.749-2.946,1.428-7.96,4.45.88,9.331,13.88,7.628,23.111,6.807,30.3,11.43,6.093,3.927,2.5,12.394,6.923,15.449,5.454,3.76,21.583-.266,42.335,6.6,17.433,5.744,28.116,22.015,58.963,22.015s41.788-16.3,58.938-21.973c20.795-6.865,36.89-2.839,42.336-6.6,4.433-3.055.822-11.522,6.923-15.448,7.181-4.624,16.411-3.8,30.3-11.472C371.36,337.355,366.346,334.333,363.374,332.848Z"}}]})(props);
	};
	module.exports.FaSquareSteam = function FaSquareSteam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3zm.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z"}}]})(props);
	};
	module.exports.FaSquareThreads = function FaSquareThreads (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM294.2 244.3c19.5 9.3 33.7 23.5 41.2 40.9c10.4 24.3 11.4 63.9-20.2 95.4c-24.2 24.1-53.5 35-95.1 35.3h-.2c-46.8-.3-82.8-16.1-106.9-46.8C91.5 341.8 80.4 303.7 80 256v-.1-.1c.4-47.7 11.5-85.7 33-113.1c24.2-30.7 60.2-46.5 106.9-46.8h.2c46.9 .3 83.3 16 108.2 46.6c12.3 15.1 21.3 33.3 27 54.4l-26.9 7.2c-4.7-17.2-11.9-31.9-21.4-43.6c-19.4-23.9-48.7-36.1-87-36.4c-38 .3-66.8 12.5-85.5 36.2c-17.5 22.3-26.6 54.4-26.9 95.5c.3 41.1 9.4 73.3 26.9 95.5c18.7 23.8 47.4 36 85.5 36.2c34.3-.3 56.9-8.4 75.8-27.3c21.5-21.5 21.1-47.9 14.2-64c-4-9.4-11.4-17.3-21.3-23.3c-2.4 18-7.9 32.2-16.5 43.2c-11.4 14.5-27.7 22.4-48.4 23.5c-15.7 .9-30.8-2.9-42.6-10.7c-13.9-9.2-22-23.2-22.9-39.5c-1.7-32.2 23.8-55.3 63.5-57.6c14.1-.8 27.3-.2 39.5 1.9c-1.6-9.9-4.9-17.7-9.8-23.4c-6.7-7.8-17.1-11.8-30.8-11.9h-.4c-11 0-26 3.1-35.6 17.6l-23-15.8c12.8-19.4 33.6-30.1 58.5-30.1h.6c41.8 .3 66.6 26.3 69.1 71.8c1.4 .6 2.8 1.2 4.2 1.9l.1 .5zm-71.8 67.5c17-.9 36.4-7.6 39.7-48.8c-8.8-1.9-18.6-2.9-29-2.9c-3.2 0-6.4 .1-9.6 .3c-28.6 1.6-38.1 15.5-37.4 27.9c.9 16.7 19 24.5 36.4 23.6l-.1-.1z"}}]})(props);
	};
	module.exports.FaSquareTumblr = function FaSquareTumblr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z"}}]})(props);
	};
	module.exports.FaSquareTwitter = function FaSquareTwitter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM351.3 199.3v0c0 86.7-66 186.6-186.6 186.6c-37.2 0-71.7-10.8-100.7-29.4c5.3 .6 10.4 .8 15.8 .8c30.7 0 58.9-10.4 81.4-28c-28.8-.6-53-19.5-61.3-45.5c10.1 1.5 19.2 1.5 29.6-1.2c-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3c-9-6-16.4-14.1-21.5-23.6s-7.8-20.2-7.7-31c0-12.2 3.2-23.4 8.9-33.1c32.3 39.8 80.8 65.8 135.2 68.6c-9.3-44.5 24-80.6 64-80.6c18.9 0 35.9 7.9 47.9 20.7c14.8-2.8 29-8.3 41.6-15.8c-4.9 15.2-15.2 28-28.8 36.1c13.2-1.4 26-5.1 37.8-10.2c-8.9 13.1-20.1 24.7-32.9 34c.2 2.8 .2 5.7 .2 8.5z"}}]})(props);
	};
	module.exports.FaSquareViadeo = function FaSquareViadeo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z"}}]})(props);
	};
	module.exports.FaSquareVimeo = function FaSquareVimeo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z"}}]})(props);
	};
	module.exports.FaSquareWhatsapp = function FaSquareWhatsapp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"}}]})(props);
	};
	module.exports.FaSquareXTwitter = function FaSquareXTwitter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"}}]})(props);
	};
	module.exports.FaSquareXing = function FaSquareXing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"}}]})(props);
	};
	module.exports.FaSquareYoutube = function FaSquareYoutube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"}}]})(props);
	};
	module.exports.FaSquarespace = function FaSquarespace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"}}]})(props);
	};
	module.exports.FaStackExchange = function FaStackExchange (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"}}]})(props);
	};
	module.exports.FaStackOverflow = function FaStackOverflow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"}}]})(props);
	};
	module.exports.FaStackpath = function FaStackpath (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"}}]})(props);
	};
	module.exports.FaStaylinked = function FaStaylinked (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 440 512"},"child":[{"tag":"path","attr":{"d":"M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"}}]})(props);
	};
	module.exports.FaSteamSymbol = function FaSteamSymbol (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"}}]})(props);
	};
	module.exports.FaSteam = function FaSteam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"}}]})(props);
	};
	module.exports.FaStickerMule = function FaStickerMule (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"}}]})(props);
	};
	module.exports.FaStrava = function FaStrava (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"}}]})(props);
	};
	module.exports.FaStripeS = function FaStripeS (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"}}]})(props);
	};
	module.exports.FaStripe = function FaStripe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"}}]})(props);
	};
	module.exports.FaStubber = function FaStubber (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M136.5 294.2l58.8 22.9c9.1-36.8 25.4-61.1 55-61.1c49.4 0 71.4 63.6 142.4 63.6c15.6 0 35.9-2.8 55.3-13.3V368c0 61.8-50.4 112-112.3 112H0l41.8-56L0 368l41.7-56L0 256.1l41.8-56L0 144.1 41.8 88 0 32H335.7C397.6 32 448 82.3 448 144.1v51.3c-9.2 36.3-25.9 60.6-55 60.6c-49.6 0-71.6-63.5-142.4-63.5c-35.9 0-95.2 14.6-114.1 101.6h0z"}}]})(props);
	};
	module.exports.FaStudiovinari = function FaStudiovinari (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"}}]})(props);
	};
	module.exports.FaStumbleuponCircle = function FaStumbleuponCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"}}]})(props);
	};
	module.exports.FaStumbleupon = function FaStumbleupon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"}}]})(props);
	};
	module.exports.FaSuperpowers = function FaSuperpowers (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"}}]})(props);
	};
	module.exports.FaSupple = function FaSupple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"}}]})(props);
	};
	module.exports.FaSuse = function FaSuse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z"}}]})(props);
	};
	module.exports.FaSwift = function FaSwift (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"}}]})(props);
	};
	module.exports.FaSymfony = function FaSymfony (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"}}]})(props);
	};
	module.exports.FaTeamspeak = function FaTeamspeak (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M152.8 37.2c-32.2 38.1-56.1 82.6-69.9 130.5c0 .2-.1 .3-.1 .5C43.5 184.4 16 223 16 268c0 59.6 48.4 108 108 108s108-48.4 108-108c0-53.5-38.9-97.9-90-106.5c15.7-41.8 40.4-79.6 72.3-110.7c1.8-1.6 4-2.6 6.3-3.1c37.2-11.5 76.7-13.3 114.8-5.2C454.7 67.6 534 180.7 517.1 301.3c-8.4 62.6-38.6 112.7-87.7 151.4c-50.1 39.7-107.5 54.3-170.2 52.2l-24-1c12.4 2.8 25 4.9 37.6 6.3c40.7 4.2 81.4 2.1 120.1-12.5c94-35.5 149.3-102.3 162.9-202.5c4.8-52.6-5.8-105.4-30.8-152C454.6 11.3 290.8-38.4 159 32c-2.4 1.4-4.5 3.1-6.3 5.2zM309.4 433.9c-2.1 11.5-4.2 21.9-14.6 31.3c53.2-1 123.2-29.2 161.8-97.1c39.7-69.9 37.6-139.9-6.3-207.8C413.8 105 360.5 77.9 293.7 73.7c1.5 2.3 3.2 4.4 5.2 6.3l5.2 6.3c25.1 31.3 37.6 67.9 42.8 107.5c2.1 15.7-1 30.3-13.6 41.8c-4.2 3.1-5.2 6.3-4.2 10.4l7.3 17.7L365.7 318c5.2 11.5 4.2 19.8-6.3 28.2c-3.2 2.5-6.7 4.6-10.4 6.3l-18.8 8.4 3.1 13.6c3.1 6.3 1 12.5-3.1 17.7c-2.5 2.4-3.8 5.9-3.1 9.4c2.1 11.5-2.1 19.8-12.5 25.1c-2.1 1-4.2 5.2-5.2 7.3zm-133.6-3.1c16.7 11.5 34.5 20.9 53.2 26.1c24 5.2 41.8-6.3 44.9-30.3c1-8.4 5.2-14.6 12.5-17.7c7.3-4.2 8.4-7.3 2.1-13.6l-9.4-8.4 13.6-4.2c6.3-2.1 7.3-5.2 5.2-11.5c-1.4-3-2.4-6.2-3.1-9.4c-3.1-14.6-2.1-15.7 11.5-18.8c8.4-3.1 15.7-6.3 21.9-12.5c3.1-2.1 3.1-4.2 1-8.4l-16.7-30.3c-1-1.9-2.1-3.8-3.1-5.7c-6.4-11.7-13-23.6-15.7-37.1c-2.1-9.4-1-17.7 8.4-24c5.2-4.2 8.4-9.4 8.4-16.7c-.4-10.1-1.5-20.3-3.1-30.3c-6.3-37.6-23-68.9-51.2-95c-5.2-4.2-9.4-6.3-16.7-4.2L203.9 91.5c2 1.2 4 2.4 6 3.6l0 0c6.3 3.7 12.2 7.3 17 12.1c30.3 26.1 41.8 61.6 45.9 100.2c1 8.4 0 16.7-7.3 21.9c-8.4 5.2-10.4 12.5-7.3 20.9c4.9 13.2 10.4 26 16.7 38.6L291.6 318c-6.3 8.4-13.6 11.5-21.9 14.6c-12.5 3.1-14.6 7.3-10.4 20.9c.6 1.5 1.4 2.8 2.1 4.2c2.1 5.2 1 8.4-4.2 10.4l-12.5 3.1 5.2 4.2 4.2 4.2c4.2 5.2 4.2 8.4-2.1 10.4c-7.3 4.2-11.5 9.4-11.5 17.7c0 12.5-7.3 19.8-18.8 24c-3.8 1-7.6 1.5-11.5 1l-34.5-2.1z"}}]})(props);
	};
	module.exports.FaTelegram = function FaTelegram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z"}}]})(props);
	};
	module.exports.FaTencentWeibo = function FaTencentWeibo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"}}]})(props);
	};
	module.exports.FaTheRedYeti = function FaTheRedYeti (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"}}]})(props);
	};
	module.exports.FaThemeco = function FaThemeco (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"}}]})(props);
	};
	module.exports.FaThemeisle = function FaThemeisle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"}}]})(props);
	};
	module.exports.FaThinkPeaks = function FaThinkPeaks (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"}}]})(props);
	};
	module.exports.FaThreads = function FaThreads (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z"}}]})(props);
	};
	module.exports.FaTiktok = function FaTiktok (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}}]})(props);
	};
	module.exports.FaTradeFederation = function FaTradeFederation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"}}]})(props);
	};
	module.exports.FaTrello = function FaTrello (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"}}]})(props);
	};
	module.exports.FaTumblr = function FaTumblr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}}]})(props);
	};
	module.exports.FaTwitch = function FaTwitch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}}]})(props);
	};
	module.exports.FaTwitter = function FaTwitter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"}}]})(props);
	};
	module.exports.FaTypo3 = function FaTypo3 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"}}]})(props);
	};
	module.exports.FaUber = function FaUber (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"}}]})(props);
	};
	module.exports.FaUbuntu = function FaUbuntu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"}}]})(props);
	};
	module.exports.FaUikit = function FaUikit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"}}]})(props);
	};
	module.exports.FaUmbraco = function FaUmbraco (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 510 512"},"child":[{"tag":"path","attr":{"d":"M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"}}]})(props);
	};
	module.exports.FaUncharted = function FaUncharted (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"}}]})(props);
	};
	module.exports.FaUniregistry = function FaUniregistry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"}}]})(props);
	};
	module.exports.FaUnity = function FaUnity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M243.583 91.6027L323.695 138.384C326.575 140.026 326.68 144.583 323.695 146.225L228.503 201.854C225.623 203.55 222.22 203.444 219.549 201.854L124.357 146.225C121.425 144.636 121.373 139.973 124.357 138.384L204.417 91.6027V0L0 119.417V358.252L78.3843 312.477V218.914C78.3319 215.576 82.2066 213.192 85.0865 214.993L180.279 270.622C183.159 272.318 184.782 275.338 184.782 278.464V389.669C184.834 393.007 180.959 395.391 178.079 393.589L97.9673 346.808L19.583 392.583L224 512L428.417 392.583L350.033 346.808L269.921 393.589C267.093 395.338 263.114 393.06 263.218 389.669V278.464C263.218 275.126 265.051 272.159 267.721 270.622L362.914 214.993C365.741 213.245 369.72 215.47 369.616 218.914V312.477L448 358.252V119.417L243.583 0V91.6027Z"}}]})(props);
	};
	module.exports.FaUnsplash = function FaUnsplash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"}}]})(props);
	};
	module.exports.FaUntappd = function FaUntappd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"}}]})(props);
	};
	module.exports.FaUps = function FaUps (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"}}]})(props);
	};
	module.exports.FaUsb = function FaUsb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"}}]})(props);
	};
	module.exports.FaUsps = function FaUsps (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"}}]})(props);
	};
	module.exports.FaUssunnah = function FaUssunnah (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 482 512"},"child":[{"tag":"path","attr":{"d":"M481.9 268.1A240.9 240.9 0 1 1 .1 268a240.9 240.9 0 1 1 481.9 0zM24.5 268a216.5 216.5 0 1 0 432.9 0A216.5 216.5 0 1 0 24.5 268zm385.9 63.3c-12.7 0-21.6-1.9-26.7-5.9c-5.5-4.3-8.2-12.3-8.2-23.8V205.1c0-6.5-5.2-20.2-15.7-41.2c7 0 17-9.1 30-27.2V284.5c0 11 2.4 19.4 7 25.3c3.7 4.7 10.1 8.9 19 12.6c1.2 .4 2.6 .9 4.1 1.4c2.9 .9 6.3 2.1 10.3 3.5c-1.8 2.7-8.3 4-19.9 4zm-219 0c-1.3 2.4-3.6 5.5-6.8 9.4l-18.5 22.5c-1-6.1-4-13-9.3-20.6s-9.7-11.4-13.4-11.4h-8.3H53.6c3.3-5.3 4.9-8.8 4.9-10.8c0-2-.8-5.3-2.4-9.7c-1.5-4.4-2.4-8.5-2.4-12.4c0-7.4 2.1-13.9 6.3-19.3L80 253.4l-7.1-17.7L89 215.9l6.7 16.8 8-10.3c-1.8 6.4-2.6 12.3-2.6 17.7c0 4.2 2.8 13.3 8.3 27.3l16.2 40.7H135h8 .3c2.8 .4 7.7 5 14.6 13.9c1.8 2.4 4.3 5.8 7.7 10.2c1.4 1.9 2.9 3.9 4.6 6.1c1.3-2.3 2-4.6 2-7.1c0-2-1.3-6.6-4-13.4L163 304.1c-4-10.6-6.1-17.7-6.1-21.3c0-6.3 1.9-12.3 5.8-17.9c.5-.6 1-1.3 1.5-1.9c4.4-5.6 8.8-11.1 13.3-16.5c-1.1 4.6-1.7 8.7-1.7 12c0 3.7 1.7 9.9 5.1 18.8l7.9 20.4c1.9 4.7 3 8.2 3.7 10.3h17.6 8.3l-.9-2.6c-1.4-3.9-4-7-7.7-9.3l15.6-20.1 12.3 32h13.4L245 292.2c-1.5-3.9-4-7-7.7-9.3L253 262.8 270.3 308h13.4l-11.4-29.4c-1.5-3.9-4-7-7.7-9.3l15.6-20L302.6 308h10.3 8.3 7.6c1.5 0 3-1.1 4.5-3.1s2.2-4.1 2.2-6.3V205.1c0-6.5-4.5-20.3-13.7-41.2c5.4 0 14.1-9.1 26.2-27.2V300.2c0 7.2 .6 12 1.7 14.6c1.6 3.4 5.3 6.2 11.1 8.2c-3.9 5.6-8.7 8.5-14.5 8.5H321.1h-8.3H210.5h-19zM93.4 287.3c-2.7-6.7-4-11.7-4-15c-.6 1.2-2.4 3.7-5.4 7.6c-1.4 1.9-2.2 3.7-2.2 5.3c0 2.6 .8 5.7 2.2 9.3l5.6 13.9h0c5 0 9 0 11.9-.1l-8.2-20.9zm13.5-72.4c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm-27.6 0c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm87 27.5c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3z"}}]})(props);
	};
	module.exports.FaVaadin = function FaVaadin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"}}]})(props);
	};
	module.exports.FaViacoin = function FaViacoin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"}}]})(props);
	};
	module.exports.FaViadeo = function FaViadeo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"}}]})(props);
	};
	module.exports.FaViber = function FaViber (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"}}]})(props);
	};
	module.exports.FaVimeoV = function FaVimeoV (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"}}]})(props);
	};
	module.exports.FaVimeo = function FaVimeo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}}]})(props);
	};
	module.exports.FaVine = function FaVine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"}}]})(props);
	};
	module.exports.FaVk = function FaVk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M31.4907 63.4907C0 94.9813 0 145.671 0 247.04V264.96C0 366.329 0 417.019 31.4907 448.509C62.9813 480 113.671 480 215.04 480H232.96C334.329 480 385.019 480 416.509 448.509C448 417.019 448 366.329 448 264.96V247.04C448 145.671 448 94.9813 416.509 63.4907C385.019 32 334.329 32 232.96 32H215.04C113.671 32 62.9813 32 31.4907 63.4907ZM75.6 168.267H126.747C128.427 253.76 166.133 289.973 196 297.44V168.267H244.16V242C273.653 238.827 304.64 205.227 315.093 168.267H363.253C359.313 187.435 351.46 205.583 340.186 221.579C328.913 237.574 314.461 251.071 297.733 261.227C316.41 270.499 332.907 283.63 346.132 299.751C359.357 315.873 369.01 334.618 374.453 354.747H321.44C316.555 337.262 306.614 321.61 292.865 309.754C279.117 297.899 262.173 290.368 244.16 288.107V354.747H238.373C136.267 354.747 78.0267 284.747 75.6 168.267Z"}}]})(props);
	};
	module.exports.FaVnv = function FaVnv (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"}}]})(props);
	};
	module.exports.FaVuejs = function FaVuejs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"}}]})(props);
	};
	module.exports.FaWatchmanMonitoring = function FaWatchmanMonitoring (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"}}]})(props);
	};
	module.exports.FaWaze = function FaWaze (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"}}]})(props);
	};
	module.exports.FaWeebly = function FaWeebly (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"}}]})(props);
	};
	module.exports.FaWeibo = function FaWeibo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}}]})(props);
	};
	module.exports.FaWeixin = function FaWeixin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"}}]})(props);
	};
	module.exports.FaWhatsapp = function FaWhatsapp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}}]})(props);
	};
	module.exports.FaWhmcs = function FaWhmcs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"}}]})(props);
	};
	module.exports.FaWikipediaW = function FaWikipediaW (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"}}]})(props);
	};
	module.exports.FaWindows = function FaWindows (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"}}]})(props);
	};
	module.exports.FaWirsindhandwerk = function FaWirsindhandwerk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M50.77161,479.81213h83.36071V367.84741l-83.36071,47.009Zm329.04675,0h82.35022V414.85645l-82.35022-47.009Zm.00568-448V251.568L256.1759,179.1861,134.50378,251.568V31.81213H50.77161V392.60565L256.1759,270.31909,462.16858,392.60565V31.81213Z"}}]})(props);
	};
	module.exports.FaWix = function FaWix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"}}]})(props);
	};
	module.exports.FaWizardsOfTheCoast = function FaWizardsOfTheCoast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"}}]})(props);
	};
	module.exports.FaWodu = function FaWodu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"}}]})(props);
	};
	module.exports.FaWolfPackBattalion = function FaWolfPackBattalion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"}}]})(props);
	};
	module.exports.FaWordpressSimple = function FaWordpressSimple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"}}]})(props);
	};
	module.exports.FaWordpress = function FaWordpress (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"}}]})(props);
	};
	module.exports.FaWpbeginner = function FaWpbeginner (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"}}]})(props);
	};
	module.exports.FaWpexplorer = function FaWpexplorer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"}}]})(props);
	};
	module.exports.FaWpforms = function FaWpforms (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"}}]})(props);
	};
	module.exports.FaWpressr = function FaWpressr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"}}]})(props);
	};
	module.exports.FaXTwitter = function FaXTwitter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"}}]})(props);
	};
	module.exports.FaXbox = function FaXbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"}}]})(props);
	};
	module.exports.FaXing = function FaXing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"}}]})(props);
	};
	module.exports.FaYCombinator = function FaYCombinator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"}}]})(props);
	};
	module.exports.FaYahoo = function FaYahoo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"}}]})(props);
	};
	module.exports.FaYammer = function FaYammer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500.676,159.486a12.779,12.779,0,0,0-6.4-8.282,13.954,13.954,0,0,0-10.078-1.125L457.8,156.7l-.043-.2-22.3,5.785-1.243.333-.608-2.17A369.037,369.037,0,0,0,347.538,4.289a14.1,14.1,0,0,0-19.784-.463l-102.9,102.747H24.947A24.9,24.9,0,0,0,0,131.417V380.38a24.963,24.963,0,0,0,24.918,24.9H224.986L328.072,508a13.667,13.667,0,0,0,19.327,0c.126-.126.249-.255.37-.385a368.025,368.025,0,0,0,69.577-107.374,403.45,403.45,0,0,0,17.3-50.8v-.028l20.406,5.336.029-.073L483.345,362a20.253,20.253,0,0,0,2.619.5,13.359,13.359,0,0,0,4.139-.072,13.5,13.5,0,0,0,10.515-9.924,415.855,415.855,0,0,0,.058-193.013ZM337.125,24.65l.013.014h-.013Zm-110.2,165.161L174.311,281.1a11.338,11.338,0,0,0-1.489,5.655v46.189a22.04,22.04,0,0,1-22.041,22h-3.4A22.068,22.068,0,0,1,125.3,332.962V287.294a11.532,11.532,0,0,0-1.388-5.51l-51.6-92.2a21.988,21.988,0,0,1,19.264-32.726h3.268a22.059,22.059,0,0,1,19.611,11.916l36.357,70.281,37.515-70.512a22.066,22.066,0,0,1,38.556-.695,21.7,21.7,0,0,1,0,21.967ZM337.145,24.673a348.147,348.147,0,0,1,75.8,141.335l.564,1.952-114.134,29.6V131.417a25.006,25.006,0,0,0-24.947-24.9H255.067Zm60.5,367.305v-.043l-.014.014a347.19,347.19,0,0,1-60.177,95.227l-82.2-81.893h19.177a24.978,24.978,0,0,0,24.947-24.9v-66.2l114.6,29.862A385.191,385.191,0,0,1,397.648,391.978Zm84-52.45.015.014-50.618-13.131L299.379,292.1V219.572l119.746-30.99,4.468-1.157,39.54-10.253,18.511-4.816A393,393,0,0,1,481.644,339.528Z"}}]})(props);
	};
	module.exports.FaYandexInternational = function FaYandexInternational (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"}}]})(props);
	};
	module.exports.FaYandex = function FaYandex (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"}}]})(props);
	};
	module.exports.FaYarn = function FaYarn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"}}]})(props);
	};
	module.exports.FaYelp = function FaYelp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"}}]})(props);
	};
	module.exports.FaYoast = function FaYoast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"}}]})(props);
	};
	module.exports.FaYoutube = function FaYoutube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}}]})(props);
	};
	module.exports.FaZhihu = function FaZhihu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"}}]})(props);
	};
	module.exports.Fa0 = function Fa0 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 96c-53 0-96 43-96 96V320c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z"}}]})(props);
	};
	module.exports.Fa1 = function Fa1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z"}}]})(props);
	};
	module.exports.Fa2 = function Fa2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"}}]})(props);
	};
	module.exports.Fa3 = function Fa3 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H272c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H105.4C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H80c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96H32C14.3 96 0 81.7 0 64z"}}]})(props);
	};
	module.exports.Fa4 = function Fa4 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368H256v80c0 17.7 14.3 32 32 32s32-14.3 32-32V368h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V304H82.4L189 77.6z"}}]})(props);
	};
	module.exports.Fa5 = function Fa5 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M32.5 58.3C35.3 43.1 48.5 32 64 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H100.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"}}]})(props);
	};
	module.exports.Fa6 = function Fa6 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3c0 .2 0 .3 0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z"}}]})(props);
	};
	module.exports.Fa7 = function Fa7 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H288c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z"}}]})(props);
	};
	module.exports.Fa8 = function Fa8 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h15.9c0 0 .1 0 .1 0h32c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0H144c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"}}]})(props);
	};
	module.exports.Fa9 = function Fa9 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"}}]})(props);
	};
	module.exports.FaA = function FaA (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384H290.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320H120l72-172.8L264 320z"}}]})(props);
	};
	module.exports.FaAddressBook = function FaAddressBook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"}}]})(props);
	};
	module.exports.FaAddressCard = function FaAddressCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaAlignCenter = function FaAlignCenter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"}}]})(props);
	};
	module.exports.FaAlignJustify = function FaAlignJustify (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"}}]})(props);
	};
	module.exports.FaAlignLeft = function FaAlignLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaAlignRight = function FaAlignRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaAnchorCircleCheck = function FaAnchorCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"}}]})(props);
	};
	module.exports.FaAnchorCircleExclamation = function FaAnchorCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaAnchorCircleXmark = function FaAnchorCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"}}]})(props);
	};
	module.exports.FaAnchorLock = function FaAnchorLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3V446.7c-5.2 .9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"}}]})(props);
	};
	module.exports.FaAnchor = function FaAnchor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1z"}}]})(props);
	};
	module.exports.FaAngleDown = function FaAngleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"}}]})(props);
	};
	module.exports.FaAngleLeft = function FaAngleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"}}]})(props);
	};
	module.exports.FaAngleRight = function FaAngleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"}}]})(props);
	};
	module.exports.FaAngleUp = function FaAngleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"}}]})(props);
	};
	module.exports.FaAnglesDown = function FaAnglesDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"}}]})(props);
	};
	module.exports.FaAnglesLeft = function FaAnglesLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"}}]})(props);
	};
	module.exports.FaAnglesRight = function FaAnglesRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"}}]})(props);
	};
	module.exports.FaAnglesUp = function FaAnglesUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"}}]})(props);
	};
	module.exports.FaAnkh = function FaAnkh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H241.2c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"}}]})(props);
	};
	module.exports.FaAppleWhole = function FaAppleWhole (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H224zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"}}]})(props);
	};
	module.exports.FaArchway = function FaArchway (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H96h64V352c0-53 43-96 96-96s96 43 96 96V480h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32V416z"}}]})(props);
	};
	module.exports.FaArrowDown19 = function FaArrowDown19 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V64c0-10.3-4.9-19.9-13.3-26zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM418.3 307a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 307zM405.1 419.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"}}]})(props);
	};
	module.exports.FaArrowDown91 = function FaArrowDown91 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM450.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V416H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V320c0-10.3-4.9-19.9-13.3-26zM418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91zM405.1 203.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"}}]})(props);
	};
	module.exports.FaArrowDownAZ = function FaArrowDownAZ (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176z"}}]})(props);
	};
	module.exports.FaArrowDownLong = function FaArrowDownLong (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"}}]})(props);
	};
	module.exports.FaArrowDownShortWide = function FaArrowDownShortWide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaArrowDownUpAcrossLine = function FaArrowDownUpAcrossLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H448V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3V224H192 128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192zM448 320H384V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"}}]})(props);
	};
	module.exports.FaArrowDownUpLock = function FaArrowDownUpLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288H416V272c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3V224l-128 0H96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H96V402.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64zM288 320V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H288zm240-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"}}]})(props);
	};
	module.exports.FaArrowDownWideShort = function FaArrowDownWideShort (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"}}]})(props);
	};
	module.exports.FaArrowDownZA = function FaArrowDownZA (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z"}}]})(props);
	};
	module.exports.FaArrowDown = function FaArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"}}]})(props);
	};
	module.exports.FaArrowLeftLong = function FaArrowLeftLong (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"}}]})(props);
	};
	module.exports.FaArrowLeft = function FaArrowLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"}}]})(props);
	};
	module.exports.FaArrowPointer = function FaArrowPointer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"}}]})(props);
	};
	module.exports.FaArrowRightArrowLeft = function FaArrowRightArrowLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"}}]})(props);
	};
	module.exports.FaArrowRightFromBracket = function FaArrowRightFromBracket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"}}]})(props);
	};
	module.exports.FaArrowRightLong = function FaArrowRightLong (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"}}]})(props);
	};
	module.exports.FaArrowRightToBracket = function FaArrowRightToBracket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"}}]})(props);
	};
	module.exports.FaArrowRightToCity = function FaArrowRightToCity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"}}]})(props);
	};
	module.exports.FaArrowRight = function FaArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"}}]})(props);
	};
	module.exports.FaArrowRotateLeft = function FaArrowRotateLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"}}]})(props);
	};
	module.exports.FaArrowRotateRight = function FaArrowRotateRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"}}]})(props);
	};
	module.exports.FaArrowTrendDown = function FaArrowTrendDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z"}}]})(props);
	};
	module.exports.FaArrowTrendUp = function FaArrowTrendUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"}}]})(props);
	};
	module.exports.FaArrowTurnDown = function FaArrowTurnDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"}}]})(props);
	};
	module.exports.FaArrowTurnUp = function FaArrowTurnUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"}}]})(props);
	};
	module.exports.FaArrowUp19 = function FaArrowUp19 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M450.7 38c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V108.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"}}]})(props);
	};
	module.exports.FaArrowUp91 = function FaArrowUp91 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM450.7 294c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"}}]})(props);
	};
	module.exports.FaArrowUpAZ = function FaArrowUpAZ (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176H395.8z"}}]})(props);
	};
	module.exports.FaArrowUpFromBracket = function FaArrowUpFromBracket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 53 43 96 96 96H352c53 0 96-43 96-96V352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352z"}}]})(props);
	};
	module.exports.FaArrowUpFromGroundWater = function FaArrowUpFromGroundWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"}}]})(props);
	};
	module.exports.FaArrowUpFromWaterPump = function FaArrowUpFromWaterPump (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 0C85.5 0 64 21.5 64 48V256H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400V304c0-26.5-21.5-48-48-48H480l0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256H288V48c0-26.5-21.5-48-48-48H112zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"}}]})(props);
	};
	module.exports.FaArrowUpLong = function FaArrowUpLong (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"}}]})(props);
	};
	module.exports.FaArrowUpRightDots = function FaArrowUpRightDots (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H160zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"}}]})(props);
	};
	module.exports.FaArrowUpRightFromSquare = function FaArrowUpRightFromSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"}}]})(props);
	};
	module.exports.FaArrowUpShortWide = function FaArrowUpShortWide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"}}]})(props);
	};
	module.exports.FaArrowUpWideShort = function FaArrowUpWideShort (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z"}}]})(props);
	};
	module.exports.FaArrowUpZA = function FaArrowUpZA (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400H395.8z"}}]})(props);
	};
	module.exports.FaArrowUp = function FaArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"}}]})(props);
	};
	module.exports.FaArrowsDownToLine = function FaArrowsDownToLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M544 416L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7 480 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L54.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"}}]})(props);
	};
	module.exports.FaArrowsDownToPeople = function FaArrowsDownToPeople (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144 0c-13.3 0-24 10.7-24 24V142.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zM360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"}}]})(props);
	};
	module.exports.FaArrowsLeftRightToLine = function FaArrowsLeftRightToLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaArrowsLeftRight = function FaArrowsLeftRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"}}]})(props);
	};
	module.exports.FaArrowsRotate = function FaArrowsRotate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"}}]})(props);
	};
	module.exports.FaArrowsSpin = function FaArrowsSpin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H448c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5 .8-32 2.3V99.2c10.3-2.1 21-3.2 32-3.2zM132.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H64c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9 .8 21.5 2.3 32H99.2c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM477.7 224H412.8c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V448c0 8.8 7.2 16 16 16H448c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H64c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3V412.8c-10.3 2.1-21 3.2-32 3.2z"}}]})(props);
	};
	module.exports.FaArrowsSplitUpAndLeft = function FaArrowsSplitUpAndLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z"}}]})(props);
	};
	module.exports.FaArrowsToCircle = function FaArrowsToCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"}}]})(props);
	};
	module.exports.FaArrowsToDot = function FaArrowsToDot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H288v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H192c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224H64V192c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaArrowsToEye = function FaArrowsToEye (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M15 15C24.4 5.7 39.6 5.7 49 15l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H78.1L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24V78.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V433.9L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H561.9l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"}}]})(props);
	};
	module.exports.FaArrowsTurnRight = function FaArrowsTurnRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160H128c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V224C0 153.3 57.3 96 128 96H338.7L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96H242.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"}}]})(props);
	};
	module.exports.FaArrowsTurnToDots = function FaArrowsTurnToDots (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"}}]})(props);
	};
	module.exports.FaArrowsUpDownLeftRight = function FaArrowsUpDownLeftRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224V402.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288H402.7l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"}}]})(props);
	};
	module.exports.FaArrowsUpDown = function FaArrowsUpDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"}}]})(props);
	};
	module.exports.FaArrowsUpToLine = function FaArrowsUpToLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M32 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L416 237.3 416 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"}}]})(props);
	};
	module.exports.FaAsterisk = function FaAsterisk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaAt = function FaAt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"}}]})(props);
	};
	module.exports.FaAtom = function FaAtom (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaAudioDescription = function FaAudioDescription (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"}}]})(props);
	};
	module.exports.FaAustralSign = function FaAustralSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96L82.7 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H56L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H365.3L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H325.3L253.5 51.7zM256 224H192l32-76.8L256 224zm-90.7 64H282.7L296 320H152l13.3-32z"}}]})(props);
	};
	module.exports.FaAward = function FaAward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"}}]})(props);
	};
	module.exports.FaB = function FaB (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H192c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128H64zm96 192H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288h96 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z"}}]})(props);
	};
	module.exports.FaBabyCarriage = function FaBabyCarriage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0V160zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"}}]})(props);
	};
	module.exports.FaBaby = function FaBaby (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"}}]})(props);
	};
	module.exports.FaBackwardFast = function FaBackwardFast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V214.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96V214.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96V416c0 12.4-7.2 23.7-18.4 29z"}}]})(props);
	};
	module.exports.FaBackwardStep = function FaBackwardStep (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"}}]})(props);
	};
	module.exports.FaBackward = function FaBackward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V256v41.7L459.5 440.6zM256 352V256 128 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V352z"}}]})(props);
	};
	module.exports.FaBacon = function FaBacon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"}}]})(props);
	};
	module.exports.FaBacteria = function FaBacteria (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9c-7.3 1.7-14.3 3.5-21.1 5.5l-5.5-12.7c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L65.9 155c-1.8 2.8-3.5 5.7-5.1 8.5c-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2 .8-.4 1.5-.5 2.3c-2.2 9.3-3.4 17.3-4.1 23.4c-.4 3.1-.6 5.7-.8 7.8c-.1 1.1-.1 2-.2 2.8l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.1 1l-.1 0L28 269.3c-.1 3.1 0 6.1 .2 9.1l-15.2 4.3C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2 .1 2.4 .2 3.6 .2c15.6 .5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1c11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5 0 0c11.7 .4 27.3 .9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1l.1 0 29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5l0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"}}]})(props);
	};
	module.exports.FaBacterium = function FaBacterium (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7l0 0-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM92.1 363.3l0 0L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaBagShopping = function FaBagShopping (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"}}]})(props);
	};
	module.exports.FaBahai = function FaBahai (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"}}]})(props);
	};
	module.exports.FaBahtSign = function FaBahtSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M144 0c-17.7 0-32 14.3-32 32V64H37.6C16.8 64 0 80.8 0 101.6V224v41.7V288 406.3c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32zM112 128v96H64V128h48zm64 96V128c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64v96H64V288h48zm64 96V288h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H176z"}}]})(props);
	};
	module.exports.FaBanSmoking = function FaBanSmoking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32H384v32H333.3zm32 32H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H229.5z"}}]})(props);
	};
	module.exports.FaBan = function FaBan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"}}]})(props);
	};
	module.exports.FaBandage = function FaBandage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaBangladeshiTakaSign = function FaBangladeshiTakaSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M36 32.2C18.4 30.1 2.4 42.5 .2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8V160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V384c0 53 43 96 96 96h32c106 0 192-86 192-192V256c0-53-43-96-96-96H272c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c17.7 0 32 14.3 32 32v32c0 70.7-57.3 128-128 128H160c-17.7 0-32-14.3-32-32V224h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V128.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"}}]})(props);
	};
	module.exports.FaBarcode = function FaBarcode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaBarsProgress = function FaBarsProgress (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 160H320V128H448v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM448 352v32H192V352H448zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"}}]})(props);
	};
	module.exports.FaBarsStaggered = function FaBarsStaggered (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaBars = function FaBars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaBaseballBatBall = function FaBaseballBatBall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"}}]})(props);
	};
	module.exports.FaBaseball = function FaBaseball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"}}]})(props);
	};
	module.exports.FaBasketShopping = function FaBasketShopping (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512H430c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.4L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192H171.7L253.3 35.1zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaBasketball = function FaBasketball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"}}]})(props);
	};
	module.exports.FaBath = function FaBath (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"}}]})(props);
	};
	module.exports.FaBatteryEmpty = function FaBatteryEmpty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z"}}]})(props);
	};
	module.exports.FaBatteryFull = function FaBatteryFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm368 96H96V320H448V192z"}}]})(props);
	};
	module.exports.FaBatteryHalf = function FaBatteryHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm208 96H96V320H288V192z"}}]})(props);
	};
	module.exports.FaBatteryQuarter = function FaBatteryQuarter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm112 96H96V320h96V192z"}}]})(props);
	};
	module.exports.FaBatteryThreeQuarters = function FaBatteryThreeQuarters (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm272 96H96V320H352V192z"}}]})(props);
	};
	module.exports.FaBedPulse = function FaBedPulse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160H544c53 0 96 43 96 96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V352H288V192c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"}}]})(props);
	};
	module.exports.FaBed = function FaBed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"}}]})(props);
	};
	module.exports.FaBeerMugEmpty = function FaBeerMugEmpty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h51.2c42.4 0 76.8 34.4 76.8 76.8V274.9c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V172.8c0-7.1-5.7-12.8-12.8-12.8H384V311.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"}}]})(props);
	};
	module.exports.FaBellConcierge = function FaBellConcierge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"}}]})(props);
	};
	module.exports.FaBellSlash = function FaBellSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c.5-1.7 .7-3.5 .7-5.4c0-27.6-11-54.1-30.5-73.7L512 320c-20.5-20.5-32-48.3-32-77.3V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM160 242.7c0 29-11.5 56.8-32 77.3l-1.5 1.5C107 341 96 367.5 96 395.2c0 11.5 9.3 20.8 20.8 20.8H406.2L160 222.1v20.7zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"}}]})(props);
	};
	module.exports.FaBell = function FaBell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"}}]})(props);
	};
	module.exports.FaBezierCurve = function FaBezierCurve (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M296 136V88h48v48H296zM288 32c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400V80c0-26.5-21.5-48-48-48H288zM88 376h48v48H88V376zm416 48V376h48v48H504z"}}]})(props);
	};
	module.exports.FaBicycle = function FaBicycle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"}}]})(props);
	};
	module.exports.FaBinoculars = function FaBinoculars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 32h32c17.7 0 32 14.3 32 32V96H96V64c0-17.7 14.3-32 32-32zm64 96V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V388.9c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28H192zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128h99.8zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96H320V64zm-32 64V288H224V128h64z"}}]})(props);
	};
	module.exports.FaBiohazard = function FaBiohazard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"}}]})(props);
	};
	module.exports.FaBitcoinSign = function FaBitcoinSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32V64h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H41.7C18.7 448 0 429.3 0 406.3V288 265.7 224 101.6C0 80.8 16.8 64 37.6 64H48V32zM64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zm112 64H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"}}]})(props);
	};
	module.exports.FaBlenderPhone = function FaBlenderPhone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M224 352L196.8 52.3C194.2 24.2 216.3 0 244.6 0H534.1c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H549.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H523.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352H224zm-16 32H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"}}]})(props);
	};
	module.exports.FaBlender = function FaBlender (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaBlog = function FaBlog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z"}}]})(props);
	};
	module.exports.FaBold = function FaBold (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"}}]})(props);
	};
	module.exports.FaBoltLightning = function FaBoltLightning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"}}]})(props);
	};
	module.exports.FaBolt = function FaBolt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"}}]})(props);
	};
	module.exports.FaBomb = function FaBomb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"}}]})(props);
	};
	module.exports.FaBone = function FaBone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"}}]})(props);
	};
	module.exports.FaBong = function FaBong (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M160 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7H302.9c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8V64H160V208.5zM288 64V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V64C78.3 64 64 49.7 64 32S78.3 0 96 0h16H272h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaBookAtlas = function FaBookAtlas (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9H303.5c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208h31.1c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32H145.3c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"}}]})(props);
	};
	module.exports.FaBookBible = function FaBookBible (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272V304c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V192H160c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h48V80z"}}]})(props);
	};
	module.exports.FaBookBookmark = function FaBookBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 43 43 0 96 0h96V190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5V0h32 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32z"}}]})(props);
	};
	module.exports.FaBookJournalWhills = function FaBookJournalWhills (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.2-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6c-2.7-1.9-6.2 1.4-5 4.5c8.5 22.4 3.6 48-13 65.6c-3.2 3.4-3.6 8.9-.9 12.7c9.8 14 12.7 31.9 7.5 48.5c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-5.1-16.6-2.2-34.4 7.6-48.5c2.7-3.9 2.3-9.3-.9-12.7c-16.6-17.5-21.6-43.1-13.1-65.5c1.2-3.1-2.3-6.4-5-4.5c-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"}}]})(props);
	};
	module.exports.FaBookMedical = function FaBookMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM208 112v48H160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaBookOpenReader = function FaBookOpenReader (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"}}]})(props);
	};
	module.exports.FaBookOpen = function FaBookOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"}}]})(props);
	};
	module.exports.FaBookQuran = function FaBookQuran (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"}}]})(props);
	};
	module.exports.FaBookSkull = function FaBookSkull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V163.2c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"}}]})(props);
	};
	module.exports.FaBookTanakh = function FaBookTanakh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24H124.9l13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24H249.6L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48h55.4l27.7 48-27.7 48H180.3l-27.7-48zm0-48l-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24H194.1zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72l13.9 24H263.4l13.9-24zm-55.4 48L208 280l-13.9-24h27.7z"}}]})(props);
	};
	module.exports.FaBook = function FaBook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaBookmark = function FaBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"}}]})(props);
	};
	module.exports.FaBorderAll = function FaBorderAll (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 96V224H256V96H384zm0 192V416H256V288H384zM192 224H64V96H192V224zM64 288H192V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"}}]})(props);
	};
	module.exports.FaBorderNone = function FaBorderNone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"}}]})(props);
	};
	module.exports.FaBorderTopLeft = function FaBorderTopLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaBoreHole = function FaBoreHole (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0c-17.7 0-32 14.3-32 32V296.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H384c-17.7 0-32 14.3-32 32V352c0 53-43 96-96 96s-96-43-96-96V160c0-17.7-14.3-32-32-32H48z"}}]})(props);
	};
	module.exports.FaBottleDroplet = function FaBottleDroplet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 0 0 0H104l0 0 0 0L96 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C185.9 288.9 208 320.2 208 337c0 24.9-21.5 45-48 45z"}}]})(props);
	};
	module.exports.FaBottleWater = function FaBottleWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M120 0h80c13.3 0 24 10.7 24 24V64H96V24c0-13.3 10.7-24 24-24zM32 151.7c0-15.6 9-29.8 23.2-36.5l24.4-11.4c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l24.4 11.4c14.1 6.6 23.2 20.8 23.2 36.5c0 14.4-7.5 27-18.9 34.1c11.5 8.8 18.9 22.6 18.9 38.2c0 16.7-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48c0-16.7 8.5-31.4 21.5-40C40.5 415.4 32 400.7 32 384s8.5-31.4 21.5-40C40.5 335.4 32 320.7 32 304s8.5-31.4 21.5-40C40.5 255.4 32 240.7 32 224c0-15.6 7.4-29.4 18.9-38.2C39.5 178.7 32 166.1 32 151.7zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"}}]})(props);
	};
	module.exports.FaBowlFood = function FaBowlFood (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"}}]})(props);
	};
	module.exports.FaBowlRice = function FaBowlRice (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176H72c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaBowlingBall = function FaBowlingBall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaBoxArchive = function FaBoxArchive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaBoxOpen = function FaBoxOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128h2.2z"}}]})(props);
	};
	module.exports.FaBoxTissue = function FaBoxTissue (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H418.5l25.6-64H464c26.5 0 48 21.5 48 48V384H0V272c0-26.5 21.5-48 48-48H79zM0 416H512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416z"}}]})(props);
	};
	module.exports.FaBox = function FaBox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z"}}]})(props);
	};
	module.exports.FaBoxesPacking = function FaBoxesPacking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H256V48zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176zm352 80V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256H352zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"}}]})(props);
	};
	module.exports.FaBoxesStacked = function FaBoxesStacked (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M248 0H208c-26.5 0-48 21.5-48 48V160c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48H328V80c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V0zM64 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H184v80c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V256H64zM352 512H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H472v80c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V256H352c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2V464c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"}}]})(props);
	};
	module.exports.FaBraille = function FaBraille (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"}}]})(props);
	};
	module.exports.FaBrain = function FaBrain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"}}]})(props);
	};
	module.exports.FaBrazilianRealSign = function FaBrazilianRealSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 0c17.7 0 32 14.3 32 32V50.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V460.6c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2V32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256z"}}]})(props);
	};
	module.exports.FaBreadSlice = function FaBreadSlice (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"}}]})(props);
	};
	module.exports.FaBridgeCircleCheck = function FaBridgeCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"}}]})(props);
	};
	module.exports.FaBridgeCircleExclamation = function FaBridgeCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaBridgeCircleXmark = function FaBridgeCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"}}]})(props);
	};
	module.exports.FaBridgeLock = function FaBridgeLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"}}]})(props);
	};
	module.exports.FaBridgeWater = function FaBridgeWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6V352.5c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3h0l0-.5V256c0-53-43-96-96-96s-96 43-96 96V384l0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7V227.6C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6V96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"}}]})(props);
	};
	module.exports.FaBridge = function FaBridge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H72v64H0V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96V160H504V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM456 96v64H376V96h80zM328 96v64H248V96h80zM200 96v64H120V96h80z"}}]})(props);
	};
	module.exports.FaBriefcaseMedical = function FaBriefcaseMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"}}]})(props);
	};
	module.exports.FaBriefcase = function FaBriefcase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"}}]})(props);
	};
	module.exports.FaBroomBall = function FaBroomBall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H364.3L256 211.7V182.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5L341.1 353.4c3.7 42.7-11.7 85.2-42.3 115.8C271.4 496.6 234.2 512 195.5 512L22.1 512C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5L133.7 359.7c4.2-3.7-.4-10.4-5.4-7.9L77.2 377.4c-6.1 3-13.2-1.4-13.2-8.2c0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"}}]})(props);
	};
	module.exports.FaBroom = function FaBroom (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"}}]})(props);
	};
	module.exports.FaBrush = function FaBrush (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48V224v22.4V256H9.6 374.4 384v-9.6V224 48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"}}]})(props);
	};
	module.exports.FaBucket = function FaBucket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8H352v-8c0-57.4-46.6-104-104-104H200C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1L388.5 469c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32z"}}]})(props);
	};
	module.exports.FaBugSlash = function FaBugSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H479.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96zM160.3 256H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7zM336 479.2c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7V479.2z"}}]})(props);
	};
	module.exports.FaBug = function FaBug (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"}}]})(props);
	};
	module.exports.FaBugs = function FaBugs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184H64v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"}}]})(props);
	};
	module.exports.FaBuildingCircleArrowRight = function FaBuildingCircleArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"}}]})(props);
	};
	module.exports.FaBuildingCircleCheck = function FaBuildingCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"}}]})(props);
	};
	module.exports.FaBuildingCircleExclamation = function FaBuildingCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaBuildingCircleXmark = function FaBuildingCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"}}]})(props);
	};
	module.exports.FaBuildingColumns = function FaBuildingColumns (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaBuildingFlag = function FaBuildingFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32V512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaBuildingLock = function FaBuildingLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"}}]})(props);
	};
	module.exports.FaBuildingNgo = function FaBuildingNgo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"}}]})(props);
	};
	module.exports.FaBuildingShield = function FaBuildingShield (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V207l-42.4 17H304 272c-8.8 0-16 7.2-16 16v32 24.2V304c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"}}]})(props);
	};
	module.exports.FaBuildingUn = function FaBuildingUn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaBuildingUser = function FaBuildingUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"}}]})(props);
	};
	module.exports.FaBuildingWheat = function FaBuildingWheat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm384 80v16c0 44.2-35.8 80-80 80H544V272c0-44.2 35.8-80 80-80h16zm0 128c0 44.2-35.8 80-80 80H544V384c0-44.2 35.8-80 80-80h16v16zm0 112c0 44.2-35.8 80-80 80H544V496c0-44.2 35.8-80 80-80h16v16zM512 496v16H496c-44.2 0-80-35.8-80-80V416h16c44.2 0 80 35.8 80 80zm0-96H496c-44.2 0-80-35.8-80-80V304h16c44.2 0 80 35.8 80 80v16zm0-128v16H496c-44.2 0-80-35.8-80-80V192h16c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24V160c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaBuilding = function FaBuilding (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaBullhorn = function FaBullhorn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7V240 371.3C357.2 317.8 280.5 288 200.7 288H192V192h8.7c79.8 0 156.5-29.8 215.3-83.3z"}}]})(props);
	};
	module.exports.FaBullseye = function FaBullseye (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaBurger = function FaBurger (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400z"}}]})(props);
	};
	module.exports.FaBurst = function FaBurst (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"}}]})(props);
	};
	module.exports.FaBusSimple = function FaBusSimple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 0C348.8 0 448 35.2 448 80V96 416c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32V96 80C0 35.2 99.2 0 224 0zM64 128V256c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaBus = function FaBus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0C422.4 0 512 35.2 512 80V96l0 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H192v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h0V96h0V80C64 35.2 153.6 0 288 0zM128 160v96c0 17.7 14.3 32 32 32H272V128H160c-17.7 0-32 14.3-32 32zM304 288H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H304V288zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16z"}}]})(props);
	};
	module.exports.FaBusinessTime = function FaBusinessTime (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 352h8.2c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM320 352H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H360.2C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaC = function FaC (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"}}]})(props);
	};
	module.exports.FaCableCar = function FaCableCar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 56a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 288c0-35.3 28.7-64 64-64H232V157.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5V224H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352z"}}]})(props);
	};
	module.exports.FaCakeCandles = function FaCakeCandles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1 0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l0 0 0 0 .1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l0 0 0 0 0 0 .1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9V288c0-35.3-28.7-64-64-64V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H128V176zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V394.6z"}}]})(props);
	};
	module.exports.FaCalculator = function FaCalculator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"}}]})(props);
	};
	module.exports.FaCalendarCheck = function FaCalendarCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"}}]})(props);
	};
	module.exports.FaCalendarDay = function FaCalendarDay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"}}]})(props);
	};
	module.exports.FaCalendarDays = function FaCalendarDays (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaCalendarMinus = function FaCalendarMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zM344 376c13.3 0 24-10.7 24-24s-10.7-24-24-24H168c-13.3 0-24 10.7-24 24s10.7 24 24 24H344z"}}]})(props);
	};
	module.exports.FaCalendarPlus = function FaCalendarPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 32V64H80c-26.5 0-48 21.5-48 48v48H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM256 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H176c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaCalendarWeek = function FaCalendarWeek (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"}}]})(props);
	};
	module.exports.FaCalendarXmark = function FaCalendarXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zM337 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"}}]})(props);
	};
	module.exports.FaCalendar = function FaCalendar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"}}]})(props);
	};
	module.exports.FaCameraRetro = function FaCameraRetro (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"}}]})(props);
	};
	module.exports.FaCameraRotate = function FaCameraRotate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M213.1 64.8L202.7 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM192 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z"}}]})(props);
	};
	module.exports.FaCamera = function FaCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"}}]})(props);
	};
	module.exports.FaCampground = function FaCampground (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4V464c0 26.5 21.5 48 48 48H288 528c26.5 0 48-21.5 48-48V440.4c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448H168.5L288 291.7 407.5 448H288z"}}]})(props);
	};
	module.exports.FaCandyCane = function FaCandyCane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"}}]})(props);
	};
	module.exports.FaCannabis = function FaCannabis (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V417.2l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"}}]})(props);
	};
	module.exports.FaCapsules = function FaCapsules (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256H64V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"}}]})(props);
	};
	module.exports.FaCarBattery = function FaCarBattery (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaCarBurst = function FaCarBurst (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"}}]})(props);
	};
	module.exports.FaCarOn = function FaCarOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"}}]})(props);
	};
	module.exports.FaCarRear = function FaCarRear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H384v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V391.4c19.1-11.1 32-31.7 32-55.4V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24s10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaCarSide = function FaCarSide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"}}]})(props);
	};
	module.exports.FaCarTunnel = function FaCarTunnel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h42.8c-6.6-5.9-10.8-14.4-10.8-24V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6V488c0 9.6-4.2 18.1-10.8 24H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24V448H160v40c0 9.6-4.2 18.1-10.8 24H362.8zM190.8 277.5L177 320H335l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"}}]})(props);
	};
	module.exports.FaCar = function FaCar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaCaravan = function FaCaravan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80V112zM320 352H448V256H416c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V352zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"}}]})(props);
	};
	module.exports.FaCaretDown = function FaCaretDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"}}]})(props);
	};
	module.exports.FaCaretLeft = function FaCaretLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"}}]})(props);
	};
	module.exports.FaCaretRight = function FaCaretRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"}}]})(props);
	};
	module.exports.FaCaretUp = function FaCaretUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"}}]})(props);
	};
	module.exports.FaCarrot = function FaCarrot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"}}]})(props);
	};
	module.exports.FaCartArrowDown = function FaCartArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360V134.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"}}]})(props);
	};
	module.exports.FaCartFlatbedSuitcase = function FaCartFlatbedSuitcase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32zM432 96V56c0-4.4-3.6-8-8-8H344c-4.4 0-8 3.6-8 8V96h96zM288 96V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56V96 320H288V96zM512 320V96h16c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H512zM240 96h16V320H240c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"}}]})(props);
	};
	module.exports.FaCartFlatbed = function FaCartFlatbed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM192 80V272c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H464V176c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V32H240c-26.5 0-48 21.5-48 48z"}}]})(props);
	};
	module.exports.FaCartPlus = function FaCartPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z"}}]})(props);
	};
	module.exports.FaCartShopping = function FaCartShopping (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"}}]})(props);
	};
	module.exports.FaCashRegister = function FaCashRegister (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V378.4c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"}}]})(props);
	};
	module.exports.FaCat = function FaCat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M320 192h17.1c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4v4 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L280 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5v0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32h0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128v0V32 12 10.7C352 4.8 356.7 .1 362.6 0h.2c3.3 0 6.4 1.6 8.4 4.2l0 .1L384 21.3l27.2 36.3L416 64h64l4.8-6.4L512 21.3 524.8 4.3l0-.1c2-2.6 5.1-4.2 8.4-4.2h.2C539.3 .1 544 4.8 544 10.7V12 32v96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"}}]})(props);
	};
	module.exports.FaCediSign = function FaCediSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8V32zM192 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"}}]})(props);
	};
	module.exports.FaCentSign = function FaCentSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 0c17.7 0 32 14.3 32 32V66.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3V32c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaCertificate = function FaCertificate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.3-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"}}]})(props);
	};
	module.exports.FaChair = function FaChair (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M248 48V256h48V58.7c23.9 13.8 40 39.7 40 69.3V256h48V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288H48z"}}]})(props);
	};
	module.exports.FaChalkboardUser = function FaChalkboardUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"}}]})(props);
	};
	module.exports.FaChalkboard = function FaChalkboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96 32C60.7 32 32 60.7 32 96V384H96V96l384 0V384h64V96c0-35.3-28.7-64-64-64H96zM224 384v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"}}]})(props);
	};
	module.exports.FaChampagneGlasses = function FaChampagneGlasses (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M155.6 17.3C163 3 179.9-3.6 195 1.9L320 47.5l125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6L556.1 413l41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41l-71.1 25.9L476.8 510c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1L92.2 484.1 21.1 458.2c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8L261.6 157l13.1-57.9L199.6 71.7zm240.9 0L365.4 99.1 378.5 157l89.2-32.5L440.5 71.7z"}}]})(props);
	};
	module.exports.FaChargingStation = function FaChargingStation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"}}]})(props);
	};
	module.exports.FaChartArea = function FaChartArea (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288H448c17.7 0 32-14.3 32-32V251.8c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"}}]})(props);
	};
	module.exports.FaChartBar = function FaChartBar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaChartColumn = function FaChartColumn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaChartGantt = function FaChartGantt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaChartLine = function FaChartLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"}}]})(props);
	};
	module.exports.FaChartPie = function FaChartPie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"}}]})(props);
	};
	module.exports.FaChartSimple = function FaChartSimple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"}}]})(props);
	};
	module.exports.FaCheckDouble = function FaCheckDouble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"}}]})(props);
	};
	module.exports.FaCheckToSlot = function FaCheckToSlot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"}}]})(props);
	};
	module.exports.FaCheck = function FaCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"}}]})(props);
	};
	module.exports.FaCheese = function FaCheese (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288H512z"}}]})(props);
	};
	module.exports.FaChessBishop = function FaChessBishop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V400H256V372.7c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32H128zM48 432L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512H297.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L272 432H48z"}}]})(props);
	};
	module.exports.FaChessBoard = function FaChessBoard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 64v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z"}}]})(props);
	};
	module.exports.FaChessKing = function FaChessKing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 0c17.7 0 32 14.3 32 32V48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v48H408c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400H80L3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40H192V112H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM38.6 473.4L80 432H368l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"}}]})(props);
	};
	module.exports.FaChessKnight = function FaChessKnight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 48L82.7 61.3C70.7 73.3 64 89.5 64 106.5V238.9c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0c10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400H384l28.9-159c2.1-11.3 3.1-22.8 3.1-34.3V192C416 86 330 0 224 0H83.8C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H409.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432H64L22.6 473.4z"}}]})(props);
	};
	module.exports.FaChessPawn = function FaChessPawn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88H96c-17.7 0-32 14.3-32 32c0 16.5 12.5 30 28.5 31.8L80 400H240L227.5 287.8c16-1.8 28.5-15.3 28.5-31.8c0-17.7-14.3-32-32-32h-8.5zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432H64L22.6 473.4z"}}]})(props);
	};
	module.exports.FaChessQueen = function FaChessQueen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM134.1 143.8c3.3-13 15-23.8 30.2-23.8c12.3 0 22.6 7.2 27.7 17c12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17c15.3 0 27 10.8 30.2 23.8c7 27.8 32.2 48.3 62.1 48.3c10.8 0 21-2.7 29.8-7.4c8.4-4.4 18.9-4.5 27.6 .9c13 8 17.1 25 9.2 38L399.7 400H384 343.6 168.4 128 112.3L5.4 223.6c-7.9-13-3.8-30 9.2-38c8.7-5.3 19.2-5.3 27.6-.9c8.9 4.7 19 7.4 29.8 7.4c29.9 0 55.1-20.5 62.1-48.3zM256 224l0 0 0 0h0zM112 432H400l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H86.6C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z"}}]})(props);
	};
	module.exports.FaChessRook = function FaChessRook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 192V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V192c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144H80L96 256 44.8 217.6C36.7 211.6 32 202.1 32 192zm176 96h32c8.8 0 16-7.2 16-16V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM22.6 473.4L64 432H384l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H38.6C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z"}}]})(props);
	};
	module.exports.FaChess = function FaChess (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H60.2C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384H196L180 256h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48zm288 0l-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L464 416H336zM304 208v51.9c0 7.8 2.8 15.3 8 21.1L339.2 312 337 384H462.5l-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7V208c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v16H424V208c0-8.8-7.2-16-16-16H392c-8.8 0-16 7.2-16 16v16H352V208c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16v32H384V304z"}}]})(props);
	};
	module.exports.FaChevronDown = function FaChevronDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"}}]})(props);
	};
	module.exports.FaChevronLeft = function FaChevronLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"}}]})(props);
	};
	module.exports.FaChevronRight = function FaChevronRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"}}]})(props);
	};
	module.exports.FaChevronUp = function FaChevronUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"}}]})(props);
	};
	module.exports.FaChildCombatant = function FaChildCombatant (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M176 128A64 64 0 1 0 176 0a64 64 0 1 0 0 128zm-8 352V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9H169.8c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0H432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaChildDress = function FaChildDress (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400H88z"}}]})(props);
	};
	module.exports.FaChildReaching = function FaChildReaching (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M256 64A64 64 0 1 0 128 64a64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"}}]})(props);
	};
	module.exports.FaChild = function FaChild (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm48 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H144z"}}]})(props);
	};
	module.exports.FaChildren = function FaChildren (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM88 480V400H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H152v80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 0a64 64 0 1 1 0 128A64 64 0 1 1 480 0zm-8 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H472z"}}]})(props);
	};
	module.exports.FaChurch = function FaChurch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"}}]})(props);
	};
	module.exports.FaCircleArrowDown = function FaCircleArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM127 281c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 393c-9.4 9.4-24.6 9.4-33.9 0L127 281z"}}]})(props);
	};
	module.exports.FaCircleArrowLeft = function FaCircleArrowLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z"}}]})(props);
	};
	module.exports.FaCircleArrowRight = function FaCircleArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"}}]})(props);
	};
	module.exports.FaCircleArrowUp = function FaCircleArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119c9.4-9.4 24.6-9.4 33.9 0L385 231z"}}]})(props);
	};
	module.exports.FaCircleCheck = function FaCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"}}]})(props);
	};
	module.exports.FaCircleChevronDown = function FaCircleChevronDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"}}]})(props);
	};
	module.exports.FaCircleChevronLeft = function FaCircleChevronLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"}}]})(props);
	};
	module.exports.FaCircleChevronRight = function FaCircleChevronRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"}}]})(props);
	};
	module.exports.FaCircleChevronUp = function FaCircleChevronUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"}}]})(props);
	};
	module.exports.FaCircleDollarToSlot = function FaCircleDollarToSlot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V304c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V112c0-11.1-9-20.1-20.1-20.1zM48 352H64c19.5 25.9 44 47.7 72.2 64H64v32H256 448V416H375.8c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"}}]})(props);
	};
	module.exports.FaCircleDot = function FaCircleDot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"}}]})(props);
	};
	module.exports.FaCircleDown = function FaCircleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z"}}]})(props);
	};
	module.exports.FaCircleExclamation = function FaCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaCircleH = function FaCircleH (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H320V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"}}]})(props);
	};
	module.exports.FaCircleHalfStroke = function FaCircleHalfStroke (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"}}]})(props);
	};
	module.exports.FaCircleInfo = function FaCircleInfo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaCircleLeft = function FaCircleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9L117.5 269.8c-3.5-3.8-5.5-8.7-5.5-13.8s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1z"}}]})(props);
	};
	module.exports.FaCircleMinus = function FaCircleMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaCircleNodes = function FaCircleNodes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"}}]})(props);
	};
	module.exports.FaCircleNotch = function FaCircleNotch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"}}]})(props);
	};
	module.exports.FaCirclePause = function FaCirclePause (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaCirclePlay = function FaCirclePlay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"}}]})(props);
	};
	module.exports.FaCirclePlus = function FaCirclePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"}}]})(props);
	};
	module.exports.FaCircleQuestion = function FaCircleQuestion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaCircleRadiation = function FaCircleRadiation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaCircleRight = function FaCircleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L294.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C266 384 256 374 256 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z"}}]})(props);
	};
	module.exports.FaCircleStop = function FaCircleStop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaCircleUp = function FaCircleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H304v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V256H150.3C138 256 128 246 128 233.7c0-6.2 2.6-12.1 7.1-16.3z"}}]})(props);
	};
	module.exports.FaCircleUser = function FaCircleUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"}}]})(props);
	};
	module.exports.FaCircleXmark = function FaCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"}}]})(props);
	};
	module.exports.FaCircle = function FaCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"}}]})(props);
	};
	module.exports.FaCity = function FaCity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaClapperboard = function FaClapperboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 32H361.9l-1 1-127 127h92.1l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40l-104 104H512zM294.1 32H201.9l-1 1L73.9 160h92.1l1-1 127-127zM64 32C28.7 32 0 60.7 0 96v64H6.1l1-1 127-127H64zM512 192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192z"}}]})(props);
	};
	module.exports.FaClipboardCheck = function FaClipboardCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"}}]})(props);
	};
	module.exports.FaClipboardList = function FaClipboardList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"}}]})(props);
	};
	module.exports.FaClipboardQuestion = function FaClipboardQuestion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V314.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaClipboardUser = function FaClipboardUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"}}]})(props);
	};
	module.exports.FaClipboard = function FaClipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaClockRotateLeft = function FaClockRotateLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"}}]})(props);
	};
	module.exports.FaClock = function FaClock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"}}]})(props);
	};
	module.exports.FaClone = function FaClone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 448H64V224h64V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64zm-64-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"}}]})(props);
	};
	module.exports.FaClosedCaptioning = function FaClosedCaptioning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"}}]})(props);
	};
	module.exports.FaCloudArrowDown = function FaCloudArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"}}]})(props);
	};
	module.exports.FaCloudArrowUp = function FaCloudArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"}}]})(props);
	};
	module.exports.FaCloudBolt = function FaCloudBolt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320H352h64c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"}}]})(props);
	};
	module.exports.FaCloudMeatball = function FaCloudMeatball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"}}]})(props);
	};
	module.exports.FaCloudMoonRain = function FaCloudMoonRain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H367.9zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"}}]})(props);
	};
	module.exports.FaCloudMoon = function FaCloudMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"}}]})(props);
	};
	module.exports.FaCloudRain = function FaCloudRain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z"}}]})(props);
	};
	module.exports.FaCloudShowersHeavy = function FaCloudShowersHeavy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM313.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"}}]})(props);
	};
	module.exports.FaCloudShowersWater = function FaCloudShowersWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"}}]})(props);
	};
	module.exports.FaCloudSunRain = function FaCloudSunRain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm74.5-116.1c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"}}]})(props);
	};
	module.exports.FaCloudSun = function FaCloudSun (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM639.9 431.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"}}]})(props);
	};
	module.exports.FaCloud = function FaCloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"}}]})(props);
	};
	module.exports.FaClover = function FaClover (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4H61.3C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3h-4.9c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34V93.3C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2C205.1 38.5 189.5 32 173.3 32z"}}]})(props);
	};
	module.exports.FaCodeBranch = function FaCodeBranch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V160c0 70.7-57.3 128-128 128H176c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V352 153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"}}]})(props);
	};
	module.exports.FaCodeCommit = function FaCodeCommit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z"}}]})(props);
	};
	module.exports.FaCodeCompare = function FaCodeCompare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v40h16c35.3 0 64-28.7 64-64V153.3C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128H320v40zM456 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V128H176c-35.3 0-64 28.7-64 64V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16V24zM56 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"}}]})(props);
	};
	module.exports.FaCodeFork = function FaCodeFork (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"}}]})(props);
	};
	module.exports.FaCodeMerge = function FaCodeMerge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"}}]})(props);
	};
	module.exports.FaCodePullRequest = function FaCodePullRequest (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M305.8 2.1C314.4 5.9 320 14.5 320 24V64h16c70.7 0 128 57.3 128 128V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64H320v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80A24 24 0 1 0 56 80a24 24 0 1 0 48 0zm8 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"}}]})(props);
	};
	module.exports.FaCode = function FaCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"}}]})(props);
	};
	module.exports.FaCoins = function FaCoins (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"}}]})(props);
	};
	module.exports.FaColonSign = function FaColonSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.2 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"}}]})(props);
	};
	module.exports.FaCommentDollar = function FaCommentDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"}}]})(props);
	};
	module.exports.FaCommentDots = function FaCommentDots (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaCommentMedical = function FaCommentMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272H176c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"}}]})(props);
	};
	module.exports.FaCommentSlash = function FaCommentSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104-17.9L82.9 161.3C70.7 185.6 64 212.2 64 240z"}}]})(props);
	};
	module.exports.FaCommentSms = function FaCommentSms (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM202.9 176.8c6.5-2.2 13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2zm173.1 38c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.2-.4-23.7-4.4-32.6-7.4l0 0 0 0c-1.4-.5-2.7-.9-4-1.4c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7 .6 3.3 1.1 4.9 1.6l0 0 0 0c9.1 3.1 15.6 5.3 22.6 5.5c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6c-9-5.4-17.7-14.7-17.7-29.4c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c10 .2 19.7 2.3 27.9 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9zm-272 0c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.3-.4-24.2-4.5-33.2-7.6l0 0 0 0c-1.3-.4-2.5-.8-3.6-1.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4 .5 2.8 .9 4.1 1.4l0 0 0 0c9.5 3.2 16.5 5.6 23.7 5.8c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4 0 0c-7.2-2.2-16.7-5-24.3-9.6C80.8 239 72.1 229.7 72 215c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c9.5 .1 22.2 2.1 31.1 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9z"}}]})(props);
	};
	module.exports.FaComment = function FaComment (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"}}]})(props);
	};
	module.exports.FaCommentsDollar = function FaCommentsDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"}}]})(props);
	};
	module.exports.FaComments = function FaComments (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"}}]})(props);
	};
	module.exports.FaCompactDisc = function FaCompactDisc (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"}}]})(props);
	};
	module.exports.FaCompassDrafting = function FaCompassDrafting (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192h0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496V440.6c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaCompass = function FaCompass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}}]})(props);
	};
	module.exports.FaCompress = function FaCompress (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"}}]})(props);
	};
	module.exports.FaComputerMouse = function FaComputerMouse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 192H176V0H160C71.6 0 0 71.6 0 160v32zm0 32V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192 0zm384-32V160C384 71.6 312.4 0 224 0H208V192H384z"}}]})(props);
	};
	module.exports.FaComputer = function FaComputer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M384 96V320H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H181.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H277.3l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm464 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaCookieBite = function FaCookieBite (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaCookie = function FaCookie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaCopy = function FaCopy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"}}]})(props);
	};
	module.exports.FaCopyright = function FaCopyright (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"}}]})(props);
	};
	module.exports.FaCouch = function FaCouch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z"}}]})(props);
	};
	module.exports.FaCow = function FaCow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 224v32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V327.8c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16V351.1c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V343.8c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H272 256 192 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4V256 224 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160v64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H361.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"}}]})(props);
	};
	module.exports.FaCreditCard = function FaCreditCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"}}]})(props);
	};
	module.exports.FaCropSimple = function FaCropSimple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"}}]})(props);
	};
	module.exports.FaCrop = function FaCrop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64v64l178.7 0L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H173.3L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-274.7z"}}]})(props);
	};
	module.exports.FaCross = function FaCross (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H256V48c0-26.5-21.5-48-48-48H176z"}}]})(props);
	};
	module.exports.FaCrosshairs = function FaCrosshairs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaCrow = function FaCrow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384H259.2l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384H352c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192V128v-8l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32H523.9C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaCrown = function FaCrown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"}}]})(props);
	};
	module.exports.FaCrutch = function FaCrutch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"}}]})(props);
	};
	module.exports.FaCruzeiroSign = function FaCruzeiroSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V320v-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32v55.3V320v82.7C135.5 378 96 321.6 96 256z"}}]})(props);
	};
	module.exports.FaCube = function FaCube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z"}}]})(props);
	};
	module.exports.FaCubesStacked = function FaCubesStacked (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H288zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352zM160 384v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"}}]})(props);
	};
	module.exports.FaCubes = function FaCubes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5V204.7c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7V413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2V152.6L392 121v89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8L256 323.2v95.9l-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1V354.8L528 323.2v90.7c0 3.2-1.9 6-4.8 7.3z"}}]})(props);
	};
	module.exports.FaD = function FaD (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32h96c123.7 0 224 100.3 224 224s-100.3 224-224 224H64c-35.3 0-64-28.7-64-64V96zm160 0H64V416h96c88.4 0 160-71.6 160-160s-71.6-160-160-160z"}}]})(props);
	};
	module.exports.FaDatabase = function FaDatabase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"}}]})(props);
	};
	module.exports.FaDeleteLeft = function FaDeleteLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"}}]})(props);
	};
	module.exports.FaDemocrat = function FaDemocrat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H480l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352h96v64 64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416H288v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416 352h96H448zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"}}]})(props);
	};
	module.exports.FaDesktop = function FaDesktop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"}}]})(props);
	};
	module.exports.FaDharmachakra = function FaDharmachakra (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaDiagramNext = function FaDiagramNext (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41H232V224H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H365.3l.4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4H64v64H210.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7H448z"}}]})(props);
	};
	module.exports.FaDiagramPredecessor = function FaDiagramPredecessor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"}}]})(props);
	};
	module.exports.FaDiagramProject = function FaDiagramProject (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"}}]})(props);
	};
	module.exports.FaDiagramSuccessor = function FaDiagramSuccessor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"}}]})(props);
	};
	module.exports.FaDiamondTurnRight = function FaDiamondTurnRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"}}]})(props);
	};
	module.exports.FaDiamond = function FaDiamond (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"}}]})(props);
	};
	module.exports.FaDiceD20 = function FaDiceD20 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L201.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L47.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM16 171.7V295.3c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158C29.6 151.6 16 159.3 16 171.7zM310.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7zm-49.3 246L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8V452.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM41.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H183.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM174.4 176H337.6c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"}}]})(props);
	};
	module.exports.FaDiceD6 = function FaDiceD6 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14V496c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8V381c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96z"}}]})(props);
	};
	module.exports.FaDiceFive = function FaDiceFive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaDiceFour = function FaDiceFour (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaDiceOne = function FaDiceOne (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaDiceSix = function FaDiceSix (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaDiceThree = function FaDiceThree (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaDiceTwo = function FaDiceTwo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaDice = function FaDice (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H461.7c11.6 36 3.1 77-25.4 105.5L320 413.8V448zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaDisease = function FaDisease (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M236.4 61.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6h10c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaDisplay = function FaDisplay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z"}}]})(props);
	};
	module.exports.FaDivide = function FaDivide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M272 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H400z"}}]})(props);
	};
	module.exports.FaDna = function FaDna (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l0 0 0 0 0 0-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5H283.3c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32H384c0-17.7 14.3-32 32-32zM338.6 384H109.4c-10.1 10.6-18.6 21.3-25.5 32H364.1c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128H338.6c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5H164.7z"}}]})(props);
	};
	module.exports.FaDog = function FaDog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7l-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16H303.8L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"}}]})(props);
	};
	module.exports.FaDollarSign = function FaDollarSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaDolly = function FaDolly (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 32C0 14.3 14.3 0 32 0h72.9c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L104.9 64H32C14.3 64 0 49.7 0 32zM244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5z"}}]})(props);
	};
	module.exports.FaDongSign = function FaDongSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V288 128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"}}]})(props);
	};
	module.exports.FaDoorClosed = function FaDoorClosed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaDoorOpen = function FaDoorOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"}}]})(props);
	};
	module.exports.FaDove = function FaDove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6V138.8C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v30.6l0 0v1.3l0 0 0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"}}]})(props);
	};
	module.exports.FaDownLeftAndUpRightToCenter = function FaDownLeftAndUpRightToCenter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"}}]})(props);
	};
	module.exports.FaDownLong = function FaDownLong (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0 0-288c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 288-72 0c-9.6 0-18.2 5.7-22 14.5z"}}]})(props);
	};
	module.exports.FaDownload = function FaDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaDragon = function FaDragon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0H416h32 16c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48H538.5c-17 0-33.3-6.7-45.3-18.7L480 160H448v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512H496 432 32.3c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V181.5v-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3v.6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"}}]})(props);
	};
	module.exports.FaDrawPolygon = function FaDrawPolygon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"}}]})(props);
	};
	module.exports.FaDropletSlash = function FaDropletSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.1 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaDroplet = function FaDroplet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"}}]})(props);
	};
	module.exports.FaDrumSteelpan = function FaDrumSteelpan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 32c159.1 0 288 48 288 128V352c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"}}]})(props);
	};
	module.exports.FaDrum = function FaDrum (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208V368c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24V463.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24V479.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24V446.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6z"}}]})(props);
	};
	module.exports.FaDrumstickBite = function FaDrumstickBite (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176v89.2z"}}]})(props);
	};
	module.exports.FaDumbbell = function FaDumbbell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H96V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H544v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"}}]})(props);
	};
	module.exports.FaDumpsterFire = function FaDumpsterFire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304V160zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.6-1.6 3.3-3.2 5-4.8zM325.2 210.7c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4zm128.4-78.9c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 407.9 390.3 480 480 480c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"}}]})(props);
	};
	module.exports.FaDumpster = function FaDumpster (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l25.6 128zM32 192l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H448c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z"}}]})(props);
	};
	module.exports.FaDungeon = function FaDungeon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H408zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H408zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"}}]})(props);
	};
	module.exports.FaE = function FaE (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"}}]})(props);
	};
	module.exports.FaEarDeaf = function FaEarDeaf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7V400c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaEarListen = function FaEarListen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1-.1 0 0 0c0 0 0 0-14.3 28.6L398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"}}]})(props);
	};
	module.exports.FaEarthAfrica = function FaEarthAfrica (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"}}]})(props);
	};
	module.exports.FaEarthAmericas = function FaEarthAmericas (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"}}]})(props);
	};
	module.exports.FaEarthAsia = function FaEarthAsia (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"}}]})(props);
	};
	module.exports.FaEarthEurope = function FaEarthEurope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"}}]})(props);
	};
	module.exports.FaEarthOceania = function FaEarthOceania (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"}}]})(props);
	};
	module.exports.FaEgg = function FaEgg (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"}}]})(props);
	};
	module.exports.FaEject = function FaEject (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"}}]})(props);
	};
	module.exports.FaElevator = function FaElevator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H208c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"}}]})(props);
	};
	module.exports.FaEllipsisVertical = function FaEllipsisVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 128 512"},"child":[{"tag":"path","attr":{"d":"M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"}}]})(props);
	};
	module.exports.FaEllipsis = function FaEllipsis (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"}}]})(props);
	};
	module.exports.FaEnvelopeCircleCheck = function FaEnvelopeCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176V384c0 35.3 28.7 64 64 64H360.2C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"}}]})(props);
	};
	module.exports.FaEnvelopeOpenText = function FaEnvelopeOpenText (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaEnvelopeOpen = function FaEnvelopeOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 208.1L256 65.9 448 208.1v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5V208.1zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"}}]})(props);
	};
	module.exports.FaEnvelope = function FaEnvelope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"}}]})(props);
	};
	module.exports.FaEnvelopesBulk = function FaEnvelopesBulk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 0C110.3 0 96 14.3 96 32V224h96V192c0-35.3 28.7-64 64-64H480V32c0-17.7-14.3-32-32-32H128zM256 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64V416H576c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM64 256c-17.7 0-32 14.3-32 32v13L187.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301V288c0-17.7-14.3-32-32-32H64zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8V480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V340.8z"}}]})(props);
	};
	module.exports.FaEquals = function FaEquals (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z"}}]})(props);
	};
	module.exports.FaEraser = function FaEraser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"}}]})(props);
	};
	module.exports.FaEthernet = function FaEthernet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 224V416c0 17.7 14.3 32 32 32H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448V160c0-17.7-14.3-32-32-32H384V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z"}}]})(props);
	};
	module.exports.FaEuroSign = function FaEuroSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3 .1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H60.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8V248c0-2.7 .1-5.4 .2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48.1z"}}]})(props);
	};
	module.exports.FaExclamation = function FaExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 64 512"},"child":[{"tag":"path","attr":{"d":"M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"}}]})(props);
	};
	module.exports.FaExpand = function FaExpand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"}}]})(props);
	};
	module.exports.FaExplosion = function FaExplosion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H117.8L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448v0H512v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64zM288 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaEyeDropper = function FaEyeDropper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"}}]})(props);
	};
	module.exports.FaEyeLowVision = function FaEyeLowVision (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7c60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3L223 149.5zm223.1 298L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z"}}]})(props);
	};
	module.exports.FaEyeSlash = function FaEyeSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"}}]})(props);
	};
	module.exports.FaEye = function FaEye (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"}}]})(props);
	};
	module.exports.FaF = function FaF (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"}}]})(props);
	};
	module.exports.FaFaceAngry = function FaFaceAngry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM338.7 395.9c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"}}]})(props);
	};
	module.exports.FaFaceDizzy = function FaFaceDizzy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"}}]})(props);
	};
	module.exports.FaFaceFlushed = function FaFaceFlushed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"}}]})(props);
	};
	module.exports.FaFaceFrownOpen = function FaFaceFrownOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"}}]})(props);
	};
	module.exports.FaFaceFrown = function FaFaceFrown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaFaceGrimace = function FaFaceGrimace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-112h-8V360l55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344V304h8c23.8 0 43.5 17.3 47.3 40zM328 344H264V304h64v40zm0 56H264V360h64v40zm-80-96v40l-64 0V304h64zm0 56v40H184V360l64 0zm-80-16H112.7c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaFaceGrinBeamSweat = function FaFaceGrinBeamSweat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM383.8 317.8C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7c24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7c5.1-11.8-6.9-22.4-19.2-18.7zm-166.2-89l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"}}]})(props);
	};
	module.exports.FaFaceGrinBeam = function FaFaceGrinBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"}}]})(props);
	};
	module.exports.FaFaceGrinHearts = function FaFaceGrinHearts (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"}}]})(props);
	};
	module.exports.FaFaceGrinSquintTears = function FaFaceGrinSquintTears (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-16.3 4.4-34.1 7.5-46.3 9.3c-1.6 .2-3.1 .5-4.6 .6c-4.9 .8-9.1-2.8-9.5-7.4c-.1-.7 0-1.4 .1-2.1c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c.4-.1 .7-.1 1-.1c5.1-.2 9.2 4.3 8.4 9.6c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.9 209c-4.7-11.9-20.8-11-26.8 .3c-19 35.5-45 70.8-77.5 103.3S244.8 371.1 209.3 390c-11.3 6-12.2 22.1-.3 26.8c57.6 22.9 125.8 11 172.3-35.5s58.4-114.8 35.5-172.3zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"}}]})(props);
	};
	module.exports.FaFaceGrinSquint = function FaFaceGrinSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"}}]})(props);
	};
	module.exports.FaFaceGrinStars = function FaFaceGrinStars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm407.4 75.5c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"}}]})(props);
	};
	module.exports.FaFaceGrinTears = function FaFaceGrinTears (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.4 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"}}]})(props);
	};
	module.exports.FaFaceGrinTongueSquint = function FaFaceGrinTongueSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"}}]})(props);
	};
	module.exports.FaFaceGrinTongueWink = function FaFaceGrinTongueWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaFaceGrinTongue = function FaFaceGrinTongue (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"}}]})(props);
	};
	module.exports.FaFaceGrinWide = function FaFaceGrinWide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"}}]})(props);
	};
	module.exports.FaFaceGrinWink = function FaFaceGrinWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaFaceGrin = function FaFaceGrin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaFaceKissBeam = function FaFaceKissBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"}}]})(props);
	};
	module.exports.FaFaceKissWinkHeart = function FaFaceKissWinkHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"}}]})(props);
	};
	module.exports.FaFaceKiss = function FaFaceKiss (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaFaceLaughBeam = function FaFaceLaughBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM217.6 212.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"}}]})(props);
	};
	module.exports.FaFaceLaughSquint = function FaFaceLaughSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"}}]})(props);
	};
	module.exports.FaFaceLaughWink = function FaFaceLaughWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"}}]})(props);
	};
	module.exports.FaFaceLaugh = function FaFaceLaugh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaFaceMehBlank = function FaFaceMehBlank (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaFaceMeh = function FaFaceMeh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaFaceRollingEyes = function FaFaceRollingEyes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"}}]})(props);
	};
	module.exports.FaFaceSadCry = function FaFaceSadCry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V477.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V493.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48z"}}]})(props);
	};
	module.exports.FaFaceSadTear = function FaFaceSadTear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaFaceSmileBeam = function FaFaceSmileBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"}}]})(props);
	};
	module.exports.FaFaceSmileWink = function FaFaceSmileWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"}}]})(props);
	};
	module.exports.FaFaceSmile = function FaFaceSmile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaFaceSurprise = function FaFaceSurprise (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"}}]})(props);
	};
	module.exports.FaFaceTired = function FaFaceTired (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"}}]})(props);
	};
	module.exports.FaFan = function FaFan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaFaucetDrip = function FaFaucetDrip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 0c17.7 0 32 14.3 32 32V44l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192V116.2l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s-14.3-32-32-32H315.9c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32V224zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"}}]})(props);
	};
	module.exports.FaFaucet = function FaFaucet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V180.2l-32-4-32 4V224H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 256H32z"}}]})(props);
	};
	module.exports.FaFax = function FaFax (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 64v96h64V64H386.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64zM0 160V480c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm480 32H128V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaFeatherPointed = function FaFeatherPointed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"}}]})(props);
	};
	module.exports.FaFeather = function FaFeather (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330v55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"}}]})(props);
	};
	module.exports.FaFerry = function FaFerry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M224 0H352c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32zM96 128H480c17.7 0 32 14.3 32 32V283.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9H375.6c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9H183.9c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32zm32 64v96H448V192H128zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"}}]})(props);
	};
	module.exports.FaFileArrowDown = function FaFileArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z"}}]})(props);
	};
	module.exports.FaFileArrowUp = function FaFileArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"}}]})(props);
	};
	module.exports.FaFileAudio = function FaFileAudio (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"}}]})(props);
	};
	module.exports.FaFileCircleCheck = function FaFileCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"}}]})(props);
	};
	module.exports.FaFileCircleExclamation = function FaFileCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaFileCircleMinus = function FaFileCircleMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"}}]})(props);
	};
	module.exports.FaFileCirclePlus = function FaFileCirclePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"}}]})(props);
	};
	module.exports.FaFileCircleQuestion = function FaFileCircleQuestion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"}}]})(props);
	};
	module.exports.FaFileCircleXmark = function FaFileCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"}}]})(props);
	};
	module.exports.FaFileCode = function FaFileCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"}}]})(props);
	};
	module.exports.FaFileContract = function FaFileContract (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"}}]})(props);
	};
	module.exports.FaFileCsv = function FaFileCsv (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaFileExcel = function FaFileExcel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"}}]})(props);
	};
	module.exports.FaFileExport = function FaFileExport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"}}]})(props);
	};
	module.exports.FaFileImage = function FaFileImage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H216 176 128 80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"}}]})(props);
	};
	module.exports.FaFileImport = function FaFileImport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z"}}]})(props);
	};
	module.exports.FaFileInvoiceDollar = function FaFileInvoiceDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaFileInvoice = function FaFileInvoice (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaFileLines = function FaFileLines (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaFileMedical = function FaFileMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"}}]})(props);
	};
	module.exports.FaFilePdf = function FaFilePdf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"}}]})(props);
	};
	module.exports.FaFilePen = function FaFilePen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V285.7l-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"}}]})(props);
	};
	module.exports.FaFilePowerpoint = function FaFilePowerpoint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76H160v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V368 264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28H160v56h44z"}}]})(props);
	};
	module.exports.FaFilePrescription = function FaFilePrescription (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"}}]})(props);
	};
	module.exports.FaFileShield = function FaFileShield (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"}}]})(props);
	};
	module.exports.FaFileSignature = function FaFileSignature (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V428.7c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"}}]})(props);
	};
	module.exports.FaFileVideo = function FaFileVideo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"}}]})(props);
	};
	module.exports.FaFileWaveform = function FaFileWaveform (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 0C60.7 0 32 28.7 32 64V288H144c6.1 0 11.6 3.4 14.3 8.8L176 332.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L281.9 288H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V160H288c-17.7 0-32-14.3-32-32V0H96zM288 0V128H416L288 0z"}}]})(props);
	};
	module.exports.FaFileWord = function FaFileWord (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"}}]})(props);
	};
	module.exports.FaFileZipper = function FaFileZipper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"}}]})(props);
	};
	module.exports.FaFile = function FaFile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"}}]})(props);
	};
	module.exports.FaFillDrip = function FaFillDrip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6H386.7l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"}}]})(props);
	};
	module.exports.FaFill = function FaFill (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L386.7 288H67.5c1.4-5.4 4.2-10.4 8.4-14.6L168 181.3z"}}]})(props);
	};
	module.exports.FaFilm = function FaFilm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"}}]})(props);
	};
	module.exports.FaFilterCircleDollar = function FaFilterCircleDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"}}]})(props);
	};
	module.exports.FaFilterCircleXmark = function FaFilterCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"}}]})(props);
	};
	module.exports.FaFilter = function FaFilter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"}}]})(props);
	};
	module.exports.FaFingerprint = function FaFingerprint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7V256c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1V256c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9V256z"}}]})(props);
	};
	module.exports.FaFireBurner = function FaFireBurner (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 288c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32v64H544V320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V288zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaFireExtinguisher = function FaFireExtinguisher (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104H224v34.8c37.8 18 64 56.5 64 101.2V384H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V56h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V416H288zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"}}]})(props);
	};
	module.exports.FaFireFlameCurved = function FaFireFlameCurved (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"}}]})(props);
	};
	module.exports.FaFireFlameSimple = function FaFireFlameSimple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"}}]})(props);
	};
	module.exports.FaFire = function FaFire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"}}]})(props);
	};
	module.exports.FaFishFins = function FaFishFins (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM384 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaFish = function FaFish (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}}]})(props);
	};
	module.exports.FaFlagCheckered = function FaFlagCheckered (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1V345.8c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V400 334 64 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9v65.5L64 252.6V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3V238.7l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4V244.2l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6L128 173.2V98L64 114v73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2V251.9l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4V115.4c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"}}]})(props);
	};
	module.exports.FaFlagUsa = function FaFlagUsa (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9v32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V416 345.5 312.8 249.5 216.8 153.5 120.8 64 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"}}]})(props);
	};
	module.exports.FaFlag = function FaFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z"}}]})(props);
	};
	module.exports.FaFlaskVial = function FaFlaskVial (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V309.9l-49 79.6zM96 64v96h64V64H96zM352 0H480h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V214.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V224c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64H384z"}}]})(props);
	};
	module.exports.FaFlask = function FaFlask (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM192 196.8V64h64V196.8c0 23.7 6.6 46.9 19 67.1L309.5 320h-171L173 263.9c12.4-20.2 19-43.4 19-67.1z"}}]})(props);
	};
	module.exports.FaFloppyDisk = function FaFloppyDisk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"}}]})(props);
	};
	module.exports.FaFlorinSign = function FaFlorinSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H69.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H240l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H314.7z"}}]})(props);
	};
	module.exports.FaFolderClosed = function FaFolderClosed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 480H64c-35.3 0-64-28.7-64-64V192H512V416c0 35.3-28.7 64-64 64zm64-320H0V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64z"}}]})(props);
	};
	module.exports.FaFolderMinus = function FaFolderMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"}}]})(props);
	};
	module.exports.FaFolderOpen = function FaFolderOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"}}]})(props);
	};
	module.exports.FaFolderPlus = function FaFolderPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"}}]})(props);
	};
	module.exports.FaFolderTree = function FaFolderTree (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96V384c0 35.3 28.7 64 64 64H256V384H64V160H256V96H64V32zM288 192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V192zm0 288c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V480z"}}]})(props);
	};
	module.exports.FaFolder = function FaFolder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"}}]})(props);
	};
	module.exports.FaFont = function FaFont (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"}}]})(props);
	};
	module.exports.FaFootball = function FaFootball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"}}]})(props);
	};
	module.exports.FaForwardFast = function FaForwardFast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V214.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96V214.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z"}}]})(props);
	};
	module.exports.FaForwardStep = function FaForwardStep (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"}}]})(props);
	};
	module.exports.FaForward = function FaForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V256v41.7L52.5 440.6zM256 352V256 128 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V352z"}}]})(props);
	};
	module.exports.FaFrancSign = function FaFrancSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M80 32C62.3 32 48 46.3 48 64V224v96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"}}]})(props);
	};
	module.exports.FaFrog = function FaFrog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"}}]})(props);
	};
	module.exports.FaFutbol = function FaFutbol (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"}}]})(props);
	};
	module.exports.FaG = function FaG (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H400c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"}}]})(props);
	};
	module.exports.FaGamepad = function FaGamepad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 64C86 64 0 150 0 256S86 448 192 448H448c106 0 192-86 192-192s-86-192-192-192H192zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200z"}}]})(props);
	};
	module.exports.FaGasPump = function FaGasPump (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V168v24 32V376c0 39.8-32.2 72-72 72s-72-32.2-72-72V344c0-22.1-17.9-40-40-40h-8V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zM96 80v96c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaGaugeHigh = function FaGaugeHigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}}]})(props);
	};
	module.exports.FaGaugeSimpleHigh = function FaGaugeSimpleHigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"}}]})(props);
	};
	module.exports.FaGaugeSimple = function FaGaugeSimple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"}}]})(props);
	};
	module.exports.FaGauge = function FaGauge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}}]})(props);
	};
	module.exports.FaGavel = function FaGavel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"}}]})(props);
	};
	module.exports.FaGear = function FaGear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"}}]})(props);
	};
	module.exports.FaGears = function FaGears (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8h-.7c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"}}]})(props);
	};
	module.exports.FaGem = function FaGem (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"}}]})(props);
	};
	module.exports.FaGenderless = function FaGenderless (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"}}]})(props);
	};
	module.exports.FaGhost = function FaGhost (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M40.1 467.1l-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2V192C0 86 86 0 192 0S384 86 384 192V462.2c0 9.8-8 17.8-17.8 17.8c-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaGift = function FaGift (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"}}]})(props);
	};
	module.exports.FaGifts = function FaGifts (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H200.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96H217.8l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80H416V256h32v96H640V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48H416V384H224v80zm224 48H592c26.5 0 48-21.5 48-48V384H448V512zm96-312c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"}}]})(props);
	};
	module.exports.FaGlassWaterDroplet = function FaGlassWaterDroplet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM83 297.5L66.4 64H317.6L301 297.5 288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"}}]})(props);
	};
	module.exports.FaGlassWater = function FaGlassWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM73 156.5L66.4 64H317.6L311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"}}]})(props);
	};
	module.exports.FaGlasses = function FaGlasses (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368V325.4c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z"}}]})(props);
	};
	module.exports.FaGlobe = function FaGlobe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"}}]})(props);
	};
	module.exports.FaGolfBallTee = function FaGolfBallTee (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V464c0-8.8-7.2-16-16-16H128c-17.7 0-32-14.3-32-32z"}}]})(props);
	};
	module.exports.FaGopuram = function FaGopuram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M120 0c13.3 0 24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64v64c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H416V352H384V224H352V128H320v96h32V352h32V512H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H128V352h32V224h32V128H160v96H128V352H96V512H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V256c0-17.7 14.3-32 32-32V160c0-17.7 14.3-32 32-32V64 32 24c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32v48h64V304c0-17.7-14.3-32-32-32zm-32-80v32h64V192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"}}]})(props);
	};
	module.exports.FaGraduationCap = function FaGraduationCap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"}}]})(props);
	};
	module.exports.FaGreaterThanEqual = function FaGreaterThanEqual (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416z"}}]})(props);
	};
	module.exports.FaGreaterThan = function FaGreaterThan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"}}]})(props);
	};
	module.exports.FaGripLinesVertical = function FaGripLinesVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"}}]})(props);
	};
	module.exports.FaGripLines = function FaGripLines (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"}}]})(props);
	};
	module.exports.FaGripVertical = function FaGripVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"}}]})(props);
	};
	module.exports.FaGrip = function FaGrip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"}}]})(props);
	};
	module.exports.FaGroupArrowsRotate = function FaGroupArrowsRotate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4V163.2c0-5.7-4.7-10.4-10.4-10.4H169.9c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"}}]})(props);
	};
	module.exports.FaGuaraniSign = function FaGuaraniSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0c-17.7 0-32 14.3-32 32V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32H224V132c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32zM160 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380V288h92c-11.6 45-47 80.4-92 92z"}}]})(props);
	};
	module.exports.FaGuitar = function FaGuitar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"}}]})(props);
	};
	module.exports.FaGun = function FaGun (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96V208c0 17.7 14.3 32 32 32H42c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352H321.4c23.7 0 44.8-14.9 52.7-37.2L400.9 240H432c8.5 0 16.6-3.4 22.6-9.4L477.3 208H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H528V56zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaH = function FaH (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"}}]})(props);
	};
	module.exports.FaHammer = function FaHammer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"}}]})(props);
	};
	module.exports.FaHamsa = function FaHamsa (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40V272c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaHandBackFist = function FaHandBackFist (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"}}]})(props);
	};
	module.exports.FaHandDots = function FaHandDots (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"}}]})(props);
	};
	module.exports.FaHandFist = function FaHandFist (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M192 0c17.7 0 32 14.3 32 32V144H160V32c0-17.7 14.3-32 32-32zM64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H64V64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V256c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V401.6c-17.3-7.9-33.2-18.8-46.9-32.5L69.5 357.5C45.5 333.5 32 300.9 32 267V240c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"}}]})(props);
	};
	module.exports.FaHandHoldingDollar = function FaHandHoldingDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"}}]})(props);
	};
	module.exports.FaHandHoldingDroplet = function FaHandHoldingDroplet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"}}]})(props);
	};
	module.exports.FaHandHoldingHand = function FaHandHoldingHand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32H384 544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H507.2l-44.9 36c-22.7 18.2-50.9 28-80 28H304 288 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160l0 0 .9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352l0 0-.9 0c.3 0 .6 0 .9 0z"}}]})(props);
	};
	module.exports.FaHandHoldingHeart = function FaHandHoldingHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"}}]})(props);
	};
	module.exports.FaHandHoldingMedical = function FaHandHoldingMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M224 24V80H168c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176h56c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H320V24c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0 0 0c-.3 0-.6 0-.9 0z"}}]})(props);
	};
	module.exports.FaHandHolding = function FaHandHolding (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .1 .5 .5 0 1 1 .9-.1z"}}]})(props);
	};
	module.exports.FaHandLizard = function FaHandLizard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 112C0 85.5 21.5 64 48 64H160h80 46.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v12 16 48c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V402.2L273.9 352H240 160 112c-26.5 0-48-21.5-48-48s21.5-48 48-48h48 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160 48c-26.5 0-48-21.5-48-48z"}}]})(props);
	};
	module.exports.FaHandMiddleFinger = function FaHandMiddleFinger (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M232 0c-22.1 0-40 17.9-40 40V204.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"}}]})(props);
	};
	module.exports.FaHandPeace = function FaHandPeace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 0c17.7 0 32 14.3 32 32V240H192V32c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zM93.3 51.2L175.9 240H106.1L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5h69.9H216c22.1 0 40 17.9 40 40s-17.9 40-40 40H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H226.3c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363V336c0-32.7 24.6-59.7 56.3-63.5z"}}]})(props);
	};
	module.exports.FaHandPointDown = function FaHandPointDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32V480zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-64 64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0H162.3C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z"}}]})(props);
	};
	module.exports.FaHandPointLeft = function FaHandPointLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0 0-64L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm-64-64c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72z"}}]})(props);
	};
	module.exports.FaHandPointRight = function FaHandPointRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"}}]})(props);
	};
	module.exports.FaHandPointUp = function FaHandPointUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"}}]})(props);
	};
	module.exports.FaHandPointer = function FaHandPointer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v48 16 48c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"}}]})(props);
	};
	module.exports.FaHandScissors = function FaHandScissors (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9l0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"}}]})(props);
	};
	module.exports.FaHandSparkles = function FaHandSparkles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V323.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512H348.8c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"}}]})(props);
	};
	module.exports.FaHandSpock = function FaHandSpock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64h10.9 8.2c.1 0 .1-.1 .1-.1v0c0-.1 .1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"}}]})(props);
	};
	module.exports.FaHand = function FaHand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z"}}]})(props);
	};
	module.exports.FaHandcuffs = function FaHandcuffs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaHandsAslInterpreting = function FaHandsAslInterpreting (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7V256c0 70.7 57.3 128 128 128h72 8v-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128H440h-8v.3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"}}]})(props);
	};
	module.exports.FaHandsBound = function FaHandsBound (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32V96v59.1 .7V192v21.9c0 14.2 5.1 27.9 14.3 38.7L131.6 352H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32H288h64H480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V192 155.8v-.7V96 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96v48.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1V320v32H288V320 258.1c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8V96 32zm64 448v32H288V480h64v32H480V480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H480 352 288 160 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32z"}}]})(props);
	};
	module.exports.FaHandsBubbles = function FaHandsBubbles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 160l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7v-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8 0 0 0 0-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zM332.1 88.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27c.9 1.5 1.7 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4H352h13.3l0 0H397l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352v8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H352l0 0 0 0H258.8L305 219.1c15-9.4 19.5-29.1 10.2-44.1z"}}]})(props);
	};
	module.exports.FaHandsClapping = function FaHandsClapping (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4zM424.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"}}]})(props);
	};
	module.exports.FaHandsHoldingChild = function FaHandsHoldingChild (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm44.7 164.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"}}]})(props);
	};
	module.exports.FaHandsHoldingCircle = function FaHandsHoldingCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 0a128 128 0 1 1 0 256A128 128 0 1 1 320 0zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"}}]})(props);
	};
	module.exports.FaHandsHolding = function FaHandsHolding (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"}}]})(props);
	};
	module.exports.FaHandsPraying = function FaHandsPraying (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V219.1c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32V342.3c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480V384c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2V238.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"}}]})(props);
	};
	module.exports.FaHands = function FaHands (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M544 160l-.1 72.6c-.1 52.2-24 101-64 133.1c.1-1.9 .1-3.8 .1-5.7v-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4L248.7 48.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8 0 0 0 0 43.3 75L480 160c0-17.7 14.4-32 32-32s32 14.4 32 32zM243.9 88.5L268.5 131c-13.9 4.5-26.4 13.7-34.7 27c-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7l26.8 46.4c.6 6 2.1 11.8 4.3 17.4H224 210.7l0 0H179l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zM260.9 175c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352v8c0 83.9-68.1 152-152 152H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h92c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H224l0 0 0 0h93.2L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z"}}]})(props);
	};
	module.exports.FaHandshakeAngle = function FaHandshakeAngle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 248v3.3l69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5H296c-37.1 0-67.6 28-71.6 64H224V248c0 22.1 17.9 40 40 40s40-17.9 40-40V176c0 0 0-.1 0-.1V160l16 0 136 0c0 0 0 0 .1 0H464c44.2 0 80 35.8 80 80v8zM336 192v56c0 39.8-32.2 72-72 72s-72-32.2-72-72V129.4c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1H384c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16H432c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8v-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"}}]})(props);
	};
	module.exports.FaHandshakeSimpleSlash = function FaHandshakeSimpleSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L41.2 128.5C17.9 131.8 0 151.8 0 176V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6z"}}]})(props);
	};
	module.exports.FaHandshakeSimple = function FaHandshakeSimple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"}}]})(props);
	};
	module.exports.FaHandshakeSlash = function FaHandshakeSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L128 196.8V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM96 171.6L40.6 128H16c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V171.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"}}]})(props);
	};
	module.exports.FaHandshake = function FaHandshake (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V128H16zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"}}]})(props);
	};
	module.exports.FaHanukiah = function FaHanukiah (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144z"}}]})(props);
	};
	module.exports.FaHardDrive = function FaHardDrive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V280.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4V96zM64 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}}]})(props);
	};
	module.exports.FaHashtag = function FaHashtag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"}}]})(props);
	};
	module.exports.FaHatCowboySide = function FaHatCowboySide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M152.7 135.9l-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1h10.7c39.4 0 77.8 12.1 110.1 34.7L562.4 421.8l35.1 24.6c24.4-6 42.5-28.1 42.5-54.4c0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32h-2.7c-5.6 0-11.1 .7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4zM0 384c0 35.3 28.7 64 64 64H544L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9H162.9c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2V384z"}}]})(props);
	};
	module.exports.FaHatCowboy = function FaHatCowboy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"}}]})(props);
	};
	module.exports.FaHatWizard = function FaHatWizard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416H64zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaHeadSideCoughSlash = function FaHeadSideCoughSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M448 325.8l44 34.5c8.1 1.4 14.8 6.8 18 14.1L552.9 408c10.6 .4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1c11.1 0 20.4 7.5 23.2 17.8h-3.9c6.2 8.5 6.4 20.4-.4 29c-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L89.6 44.9C127 16.7 173.5 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 5.8zM0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"}}]})(props);
	};
	module.exports.FaHeadSideCough = function FaHeadSideCough (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416v16c0 26.5-21.5 48-48 48H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaHeadSideMask = function FaHeadSideMask (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M32 224.2c0-22.2 3.2-43.6 9.2-63.9L262.2 321c-4 9.5-6.2 20-6.2 31V512H128c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zm248.3 70.4L53 129.3C88.7 53 166.2 0 256 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2H336c-21.7 0-41.3 8.6-55.7 22.6zM336 304H534l0 0h10l-19.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H514.5l-9.8 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H494.8l-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2H288V352c0-14 6-26.7 15.6-35.4c0 0 0 0 0 0c8.5-7.8 19.9-12.6 32.4-12.6zm48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaHeadSideVirus = function FaHeadSideVirus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"}}]})(props);
	};
	module.exports.FaHeading = function FaHeading (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z"}}]})(props);
	};
	module.exports.FaHeadphonesSimple = function FaHeadphonesSimple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V352zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h16z"}}]})(props);
	};
	module.exports.FaHeadphones = function FaHeadphones (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80V384 336 288C0 146.6 114.6 32 256 32s256 114.6 256 256v48 48 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"}}]})(props);
	};
	module.exports.FaHeadset = function FaHeadset (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z"}}]})(props);
	};
	module.exports.FaHeartCircleBolt = function FaHeartCircleBolt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"}}]})(props);
	};
	module.exports.FaHeartCircleCheck = function FaHeartCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"}}]})(props);
	};
	module.exports.FaHeartCircleExclamation = function FaHeartCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaHeartCircleMinus = function FaHeartCircleMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaHeartCirclePlus = function FaHeartCirclePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaHeartCircleXmark = function FaHeartCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"}}]})(props);
	};
	module.exports.FaHeartCrack = function FaHeartCrack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"}}]})(props);
	};
	module.exports.FaHeartPulse = function FaHeartPulse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 16.9-2.8 33.5-8.3 49.1z"}}]})(props);
	};
	module.exports.FaHeart = function FaHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"}}]})(props);
	};
	module.exports.FaHelicopterSymbol = function FaHelicopterSymbol (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M445.3 224H510C495.6 108.2 403.8 16.4 288 2V66.7C368.4 80.1 431.9 143.6 445.3 224zM510 288H445.3C431.9 368.4 368.4 431.9 288 445.4V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V445.4C143.6 431.9 80.1 368.4 66.7 288H2zm0-64H66.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H208V160z"}}]})(props);
	};
	module.exports.FaHelicopter = function FaHelicopter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 32c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H384 320c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128H320V64H160c-17.7 0-32-14.3-32-32zM384 320H512V288c0-53-43-96-96-96H384V320zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H536.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"}}]})(props);
	};
	module.exports.FaHelmetSafety = function FaHelmetSafety (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M256 32c-17.7 0-32 14.3-32 32v2.3 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288v64H544l0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1V66.3 64c0-17.7-14.3-32-32-32H256zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6H16.6z"}}]})(props);
	};
	module.exports.FaHelmetUn = function FaHelmetUn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384H200h14.9L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.5l-1.5-1.5V288h80 32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM320 417.2l-78-73.7L274.4 288H320V417.2zM285.3 103.1l34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaHighlighter = function FaHighlighter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5H224l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"}}]})(props);
	};
	module.exports.FaHillAvalanche = function FaHillAvalanche (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9zM480 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87z"}}]})(props);
	};
	module.exports.FaHillRockslide = function FaHillRockslide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2H293.4c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9V309.4c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaHippo = function FaHippo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V320H480v16c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V318.4c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V372c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h7.2H256h32c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"}}]})(props);
	};
	module.exports.FaHockeyPuck = function FaHockeyPuck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"}}]})(props);
	};
	module.exports.FaHollyBerry = function FaHollyBerry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"}}]})(props);
	};
	module.exports.FaHorseHead = function FaHorseHead (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 464V316.9c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H112c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"}}]})(props);
	};
	module.exports.FaHorse = function FaHorse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128H224 203.2 148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"}}]})(props);
	};
	module.exports.FaHospitalUser = function FaHospitalUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.5 0 0 21.5 0 48V256H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48H265.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM152 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V152H112c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"}}]})(props);
	};
	module.exports.FaHospital = function FaHospital (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 48c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48V512H368V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H192V48zM48 96H160V512H48c-26.5 0-48-21.5-48-48V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V144c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v48H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V464c0 26.5-21.5 48-48 48H480V96H592zM312 64c-8.8 0-16 7.2-16 16v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152h24c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H344V80c0-8.8-7.2-16-16-16H312z"}}]})(props);
	};
	module.exports.FaHotTubPerson = function FaHotTubPerson (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"}}]})(props);
	};
	module.exports.FaHotdog = function FaHotdog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l0 0v0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l0 0-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"}}]})(props);
	};
	module.exports.FaHotel = function FaHotel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64C14.3 64 0 49.7 0 32zm96 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM240 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H240zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H368zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8H328z"}}]})(props);
	};
	module.exports.FaHourglassEnd = function FaHourglassEnd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"}}]})(props);
	};
	module.exports.FaHourglassHalf = function FaHourglassHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9H112z"}}]})(props);
	};
	module.exports.FaHourglassStart = function FaHourglassStart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM288 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"}}]})(props);
	};
	module.exports.FaHourglass = function FaHourglass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 32C0 14.3 14.3 0 32 0H64 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zM96 64V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64H96zm0 384H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z"}}]})(props);
	};
	module.exports.FaHouseChimneyCrack = function FaHouseChimneyCrack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24z"}}]})(props);
	};
	module.exports.FaHouseChimneyMedical = function FaHouseChimneyMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H320V208c0-8.8-7.2-16-16-16H272z"}}]})(props);
	};
	module.exports.FaHouseChimneyUser = function FaHouseChimneyUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"}}]})(props);
	};
	module.exports.FaHouseChimneyWindow = function FaHouseChimneyWindow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H248z"}}]})(props);
	};
	module.exports.FaHouseChimney = function FaHouseChimney (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64 24c0 22.1 17.9 40 40 40h24 32.5c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1h16c22.1 0 40-17.9 40-40V455.8c.3-2.6 .5-5.3 .5-8.1l-.7-160.2h32z"}}]})(props);
	};
	module.exports.FaHouseCircleCheck = function FaHouseCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"}}]})(props);
	};
	module.exports.FaHouseCircleExclamation = function FaHouseCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaHouseCircleXmark = function FaHouseCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"}}]})(props);
	};
	module.exports.FaHouseCrack = function FaHouseCrack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H230.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"}}]})(props);
	};
	module.exports.FaHouseFire = function FaHouseFire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M288 350.1l0 1.9H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM453.5 163.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM530 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"}}]})(props);
	};
	module.exports.FaHouseFlag = function FaHouseFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M480 0c-17.7 0-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288H64V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.7l.2 0h-1V159z"}}]})(props);
	};
	module.exports.FaHouseFloodWaterCircleArrowRight = function FaHouseFloodWaterCircleArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M288 144A144 144 0 1 0 0 144a144 144 0 1 0 288 0zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"}}]})(props);
	};
	module.exports.FaHouseFloodWater = function FaHouseFloodWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"}}]})(props);
	};
	module.exports.FaHouseLaptop = function FaHouseLaptop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64V416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304V448H544V304H352zm-48-16c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H544 352 304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32V288z"}}]})(props);
	};
	module.exports.FaHouseLock = function FaHouseLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M384 480c0 11.7 3.1 22.6 8.6 32H392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4V480zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"}}]})(props);
	};
	module.exports.FaHouseMedicalCircleCheck = function FaHouseMedicalCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"}}]})(props);
	};
	module.exports.FaHouseMedicalCircleExclamation = function FaHouseMedicalCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaHouseMedicalCircleXmark = function FaHouseMedicalCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"}}]})(props);
	};
	module.exports.FaHouseMedicalFlag = function FaHouseMedicalFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M480 0c17.7 0 32 14.3 32 32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H512V512H448V192 32c0-17.7 14.3-32 32-32zM276.8 39.7L416 159V512h1l-.2 0H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaHouseMedical = function FaHouseMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"}}]})(props);
	};
	module.exports.FaHouseSignal = function FaHouseSignal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34c87.1 25.3 155.6 94.2 180.3 181.6H464c26.5 0 48-21.5 48-48V256h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V208zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 376c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"}}]})(props);
	};
	module.exports.FaHouseTsunami = function FaHouseTsunami (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1l0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"}}]})(props);
	};
	module.exports.FaHouseUser = function FaHouseUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"}}]})(props);
	};
	module.exports.FaHouse = function FaHouse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"}}]})(props);
	};
	module.exports.FaHryvniaSign = function FaHryvniaSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M121.9 116.2C138.3 103.1 158.7 96 179.6 96H223c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H155.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H52.3c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H331.7c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113H179.6c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"}}]})(props);
	};
	module.exports.FaHurricane = function FaHurricane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9V81.2c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2V430.2c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaICursor = function FaICursor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V128.3c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"}}]})(props);
	};
	module.exports.FaI = function FaI (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96h96V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 32z"}}]})(props);
	};
	module.exports.FaIceCream = function FaIceCream (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M367.1 160c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h53.5 181H368c26.5 0 48-21.5 48-48s-21.5-48-48-48h-.9zM96 288L200.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288H96z"}}]})(props);
	};
	module.exports.FaIcicles = function FaIcicles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"}}]})(props);
	};
	module.exports.FaIcons = function FaIcons (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L213.3 304H240c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H74.7zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM478.7 278.3L440.3 368H496c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L391.7 400H336c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L19.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"}}]})(props);
	};
	module.exports.FaIdBadge = function FaIdBadge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaIdCardClip = function FaIdCardClip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64H192v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"}}]})(props);
	};
	module.exports.FaIdCard = function FaIdCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"}}]})(props);
	};
	module.exports.FaIgloo = function FaIgloo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160V39.1C424.9 55.7 487.2 99.8 527.5 160H352zM29.9 192H96V320H0c0-46 10.8-89.4 29.9-128zM192 320H128V192H448V320H384v32H576v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64V480H48c-26.5 0-48-21.5-48-48V352H192V320zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128H480z"}}]})(props);
	};
	module.exports.FaImagePortrait = function FaImagePortrait (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"}}]})(props);
	};
	module.exports.FaImage = function FaImage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"}}]})(props);
	};
	module.exports.FaImages = function FaImages (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"}}]})(props);
	};
	module.exports.FaInbox = function FaInbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"}}]})(props);
	};
	module.exports.FaIndent = function FaIndent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"}}]})(props);
	};
	module.exports.FaIndianRupeeSign = function FaIndianRupeeSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"}}]})(props);
	};
	module.exports.FaIndustry = function FaIndustry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 32C46.3 32 32 46.3 32 64V304v48 80c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304 152.2c0-18.2-19.4-29.7-35.4-21.1L352 215.4V152.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4V64c0-17.7-14.3-32-32-32H64z"}}]})(props);
	};
	module.exports.FaInfinity = function FaInfinity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"}}]})(props);
	};
	module.exports.FaInfo = function FaInfo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V256H32c-17.7 0-32-14.3-32-32z"}}]})(props);
	};
	module.exports.FaItalic = function FaItalic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"}}]})(props);
	};
	module.exports.FaJ = function FaJ (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M288 32c17.7 0 32 14.3 32 32V320c0 88.4-71.6 160-160 160S0 408.4 0 320V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaJarWheat = function FaJarWheat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7zM112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"}}]})(props);
	};
	module.exports.FaJar = function FaJar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"}}]})(props);
	};
	module.exports.FaJedi = function FaJedi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9H64.5c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"}}]})(props);
	};
	module.exports.FaJetFighterUp = function FaJetFighterUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v56 32 24c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H192v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96V448c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16V480c0-4.6-2-9-5.5-12L320 416.7V384H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V368 336 280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"}}]})(props);
	};
	module.exports.FaJetFighter = function FaJetFighter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M160 24c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H280L384 192H500.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H82.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"}}]})(props);
	};
	module.exports.FaJoint = function FaJoint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h19 51.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352H336 288c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9V392c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"}}]})(props);
	};
	module.exports.FaJugDetergent = function FaJugDetergent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"}}]})(props);
	};
	module.exports.FaK = function FaK (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64V328 448c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"}}]})(props);
	};
	module.exports.FaKaaba = function FaKaaba (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v16 0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2V128 112C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2V182.8l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"}}]})(props);
	};
	module.exports.FaKey = function FaKey (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"}}]})(props);
	};
	module.exports.FaKeyboard = function FaKeyboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336zM272 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM368 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240zM464 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaKhanda = function FaKhanda (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l0 0 0 0 0 0 0 0-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1 0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3l0 0 0 0 .1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1 0 0 0 0s0 0-10.2-12.3l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V424.1l-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3l0 0 0 0-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0 0 0 0 0s0 0 7.2 14.3l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L240 362.6V343.5l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1 0 0 0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z"}}]})(props);
	};
	module.exports.FaKipSign = function FaKipSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z"}}]})(props);
	};
	module.exports.FaKitMedical = function FaKitMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H96V32H64zm64 0V480H448V32H128zM512 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480V480h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"}}]})(props);
	};
	module.exports.FaKitchenSet = function FaKitchenSet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaKiwiBird = function FaKiwiBird (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3V224c0-70.7-57.3-128-128-128H392.3c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V410c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24V405.1c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaL = function FaL (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M64 32c17.7 0 32 14.3 32 32V416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaLandMineOn = function FaLandMineOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M344 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32H192V320zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5H482.3c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"}}]})(props);
	};
	module.exports.FaLandmarkDome = function FaLandmarkDome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M248 0h16c13.3 0 24 10.7 24 24V34.7C368.4 48.1 431.9 111.6 445.3 192H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24zM64 288h64V416h40V288h64V416h48V288h64V416h40V288h64V420.3c.6 .3 1.2 .7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z"}}]})(props);
	};
	module.exports.FaLandmarkFlag = function FaLandmarkFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 0h80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H272v32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H240V16c0-8.8 7.2-16 16-16h16zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"}}]})(props);
	};
	module.exports.FaLandmark = function FaLandmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9V104l4.4-1.6L240.1 4.2zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"}}]})(props);
	};
	module.exports.FaLanguage = function FaLanguage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"}}]})(props);
	};
	module.exports.FaLaptopCode = function FaLaptopCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"}}]})(props);
	};
	module.exports.FaLaptopFile = function FaLaptopFile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H320V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM512 128H400c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V256H544c-17.7 0-32-14.3-32-32V128zm32 0v96h96l-96-96z"}}]})(props);
	};
	module.exports.FaLaptopMedical = function FaLaptopMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V272H240c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"}}]})(props);
	};
	module.exports.FaLaptop = function FaLaptop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"}}]})(props);
	};
	module.exports.FaLariSign = function FaLariSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M144 32c17.7 0 32 14.3 32 32V96.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V161c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32V188.1C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaLayerGroup = function FaLayerGroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"}}]})(props);
	};
	module.exports.FaLeaf = function FaLeaf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.2 5.4c-25.9 5.9-50 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"}}]})(props);
	};
	module.exports.FaLeftLong = function FaLeftLong (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z"}}]})(props);
	};
	module.exports.FaLeftRight = function FaLeftRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"}}]})(props);
	};
	module.exports.FaLemon = function FaLemon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"}}]})(props);
	};
	module.exports.FaLessThanEqual = function FaLessThanEqual (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"}}]})(props);
	};
	module.exports.FaLessThan = function FaLessThan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"}}]})(props);
	};
	module.exports.FaLifeRing = function FaLifeRing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"}}]})(props);
	};
	module.exports.FaLightbulb = function FaLightbulb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"}}]})(props);
	};
	module.exports.FaLinesLeaning = function FaLinesLeaning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaLinkSlash = function FaLinkSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"}}]})(props);
	};
	module.exports.FaLink = function FaLink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"}}]})(props);
	};
	module.exports.FaLiraSign = function FaLiraSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H46c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"}}]})(props);
	};
	module.exports.FaListCheck = function FaListCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"}}]})(props);
	};
	module.exports.FaListOl = function FaListOl (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaListUl = function FaListUl (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"}}]})(props);
	};
	module.exports.FaList = function FaList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"}}]})(props);
	};
	module.exports.FaLitecoinSign = function FaLitecoinSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64V213.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L64 280.1V448c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3V64z"}}]})(props);
	};
	module.exports.FaLocationArrow = function FaLocationArrow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"}}]})(props);
	};
	module.exports.FaLocationCrosshairs = function FaLocationCrosshairs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"}}]})(props);
	};
	module.exports.FaLocationDot = function FaLocationDot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"}}]})(props);
	};
	module.exports.FaLocationPinLock = function FaLocationPinLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c17.7 0 32 14.3 32 32v48H368V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"}}]})(props);
	};
	module.exports.FaLocationPin = function FaLocationPin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"}}]})(props);
	};
	module.exports.FaLockOpen = function FaLockOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"}}]})(props);
	};
	module.exports.FaLock = function FaLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"}}]})(props);
	};
	module.exports.FaLocust = function FaLocust (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4H431.8l-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400H496c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3V280C576 143 465 32 328 32H312zm50.5 168l17.1 40H333l29.5-40zm-87.7 38.1l-1.4 1.9H225.1l32.7-41.5 16.9 39.5zM88.8 240C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240H88.8zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"}}]})(props);
	};
	module.exports.FaLungsVirus = function FaLungsVirus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 0c17.7 0 32 14.3 32 32V156.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"}}]})(props);
	};
	module.exports.FaLungs = function FaLungs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 0c17.7 0 32 14.3 32 32V164.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V325l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaM = function FaM (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.2c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 49.9 9.2 37.5 22.7 33.4z"}}]})(props);
	};
	module.exports.FaMagnet = function FaMagnet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 160v96C0 379.7 100.3 480 224 480s224-100.3 224-224V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H0zm0-32H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64zm320 0H448V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v64z"}}]})(props);
	};
	module.exports.FaMagnifyingGlassArrowRight = function FaMagnifyingGlassArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H238.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"}}]})(props);
	};
	module.exports.FaMagnifyingGlassChart = function FaMagnifyingGlassChart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"}}]})(props);
	};
	module.exports.FaMagnifyingGlassDollar = function FaMagnifyingGlassDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"}}]})(props);
	};
	module.exports.FaMagnifyingGlassLocation = function FaMagnifyingGlassLocation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaMagnifyingGlassMinus = function FaMagnifyingGlassMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"}}]})(props);
	};
	module.exports.FaMagnifyingGlassPlus = function FaMagnifyingGlassPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"}}]})(props);
	};
	module.exports.FaMagnifyingGlass = function FaMagnifyingGlass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"}}]})(props);
	};
	module.exports.FaManatSign = function FaManatSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 32c-17.7 0-32 14.3-32 32V98.7C69.2 113.9 0 192.9 0 288V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32z"}}]})(props);
	};
	module.exports.FaMapLocationDot = function FaMapLocationDot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"}}]})(props);
	};
	module.exports.FaMapLocation = function FaMapLocation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6V503zM15.1 187.3C6 191 0 199.8 0 209.6V480.4c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77V449.4l192 54.9V255z"}}]})(props);
	};
	module.exports.FaMapPin = function FaMapPin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM128 480V317.1c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"}}]})(props);
	};
	module.exports.FaMap = function FaMap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"}}]})(props);
	};
	module.exports.FaMarker = function FaMarker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"}}]})(props);
	};
	module.exports.FaMarsAndVenusBurst = function FaMarsAndVenusBurst (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59.1 146.7 136.1 158.2c0 .6-.1 1.2-.1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3H352c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l24 0H376c0 13.3 10.7 24 24 24s24-10.7 24-24H400l24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H424v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2-.1-1.8c77-11.6 136.1-78 136.1-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"}}]})(props);
	};
	module.exports.FaMarsAndVenus = function FaMarsAndVenus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M337.8 14.8C341.5 5.8 350.3 0 360 0H472c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59.1 146.7-136.1 158.2c0 .6 .1 1.2 .1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-24 0-24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456H208c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2 .1-1.8C155.1 370.7 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48l0 0h0v0zM256 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24h24zm96-264a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"}}]})(props);
	};
	module.exports.FaMarsDouble = function FaMarsDouble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312zm88 48h0v0l0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zM368 480c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2v.2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7V168c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"}}]})(props);
	};
	module.exports.FaMarsStrokeRight = function FaMarsStrokeRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152H416V176c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32V176c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V280H464v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H382.4z"}}]})(props);
	};
	module.exports.FaMarsStrokeUp = function FaMarsStrokeUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H184v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8V168H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z"}}]})(props);
	};
	module.exports.FaMarsStroke = function FaMarsStroke (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H376zm88 48h0v0l0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"}}]})(props);
	};
	module.exports.FaMars = function FaMars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"}}]})(props);
	};
	module.exports.FaMartiniGlassCitrus = function FaMartiniGlassCitrus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177V464h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H208 120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"}}]})(props);
	};
	module.exports.FaMartiniGlassEmpty = function FaMartiniGlassEmpty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM256 210.7L109.3 64H402.7L256 210.7z"}}]})(props);
	};
	module.exports.FaMartiniGlass = function FaMartiniGlass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM173.3 128l-64-64H402.7l-64 64H173.3z"}}]})(props);
	};
	module.exports.FaMaskFace = function FaMaskFace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H144 128 56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512 496h-9.2c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3V176h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"}}]})(props);
	};
	module.exports.FaMaskVentilator = function FaMaskVentilator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H159.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6V393.3c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320V512h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"}}]})(props);
	};
	module.exports.FaMask = function FaMask (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 64C64 64 0 160 0 272S80 448 176 448h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4H400c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"}}]})(props);
	};
	module.exports.FaMasksTheater = function FaMasksTheater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7c6.1-.9 12.1-2.5 18-4.5c-9.2-12.3-17.3-24.4-24.2-35.4c-21.9-35-28.8-75.2-25.9-113.6c-20.6 4.1-39.2 13-54.7 25.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9C278.2 53.2 310.5 37 363.2 32.2c-.8-.7-1.6-1.4-2.4-2.1C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8 .6-19.9-5.1-27.9c-14.8-20.9-57.3-61.2-170-78.3S299.4 77.2 279.2 92.8c-7.8 6-11.5 15.4-12.9 25.2L242.1 282.3c-5.5 37.3-.4 75.8 19.6 107.7zM404.5 235.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6c-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7c23.9 20.8 53.6 35.3 87 40.3s66.1 .1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"}}]})(props);
	};
	module.exports.FaMattressPillow = function FaMattressPillow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H256V64zm32 384H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288V448zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"}}]})(props);
	};
	module.exports.FaMaximize = function FaMaximize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M200 32H56C42.7 32 32 42.7 32 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312V456c0 13.3 10.7 24 24 24H200c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H456c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"}}]})(props);
	};
	module.exports.FaMedal = function FaMedal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0H133.9c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0H487.4C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"}}]})(props);
	};
	module.exports.FaMemory = function FaMemory (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320H576V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zM576 352H0v64c0 17.7 14.3 32 32 32H80V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32V352zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaMenorah = function FaMenorah (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32V288c0 17.7 14.3 32 32 32H288V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320H544c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 53-43 96-96 96H352v64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V384H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H96V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H192V256 160c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32v96 32H384V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H480V256 160c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaMercury = function FaMercury (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z"}}]})(props);
	};
	module.exports.FaMessage = function FaMessage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"}}]})(props);
	};
	module.exports.FaMeteor = function FaMeteor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"}}]})(props);
	};
	module.exports.FaMicrochip = function FaMicrochip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160 128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160V352H352V160z"}}]})(props);
	};
	module.exports.FaMicrophoneLinesSlash = function FaMicrophoneLinesSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256H358.9l-34.5-27c2.9-3.1 7-5 11.6-5h80V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"}}]})(props);
	};
	module.exports.FaMicrophoneLines = function FaMicrophoneLines (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zM320 240v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"}}]})(props);
	};
	module.exports.FaMicrophoneSlash = function FaMicrophoneSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM344 430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4z"}}]})(props);
	};
	module.exports.FaMicrophone = function FaMicrophone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"}}]})(props);
	};
	module.exports.FaMicroscope = function FaMicroscope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM32 448H320c70.7 0 128-57.3 128-128s-57.3-128-128-128V128c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaMillSign = function FaMillSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128v80V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"}}]})(props);
	};
	module.exports.FaMinimize = function FaMinimize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V312c0-13.3 10.7-24 24-24H456zm-256 0c13.3 0 24 10.7 24 24V456c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H200zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V200c0 13.3-10.7 24-24 24H56z"}}]})(props);
	};
	module.exports.FaMinus = function FaMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaMitten = function FaMitten (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192h2.8c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448z"}}]})(props);
	};
	module.exports.FaMobileButton = function FaMobileButton (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM192 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaMobileRetro = function FaMobileRetro (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"}}]})(props);
	};
	module.exports.FaMobileScreenButton = function FaMobileScreenButton (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64H80V384H304V64z"}}]})(props);
	};
	module.exports.FaMobileScreen = function FaMobileScreen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"}}]})(props);
	};
	module.exports.FaMobile = function FaMobile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaMoneyBill1Wave = function FaMoneyBill1Wave (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416H64V352c35.3 0 64 28.7 64 64zM64 224V160h64c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"}}]})(props);
	};
	module.exports.FaMoneyBill1 = function FaMoneyBill1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm76-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"}}]})(props);
	};
	module.exports.FaMoneyBillTransfer = function FaMoneyBillTransfer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64H337.9c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64h64V320zM320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"}}]})(props);
	};
	module.exports.FaMoneyBillTrendUp = function FaMoneyBillTrendUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2l0 .1v0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"}}]})(props);
	};
	module.exports.FaMoneyBillWave = function FaMoneyBillWave (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"}}]})(props);
	};
	module.exports.FaMoneyBillWheat = function FaMoneyBillWheat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"}}]})(props);
	};
	module.exports.FaMoneyBill = function FaMoneyBill (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"}}]})(props);
	};
	module.exports.FaMoneyBills = function FaMoneyBills (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64H160V256zM224 96c0 35.3-28.7 64-64 64V96h64zM576 256v64H512c0-35.3 28.7-64 64-64zM512 96h64v64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"}}]})(props);
	};
	module.exports.FaMoneyCheckDollar = function FaMoneyCheckDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164 152v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"}}]})(props);
	};
	module.exports.FaMoneyCheck = function FaMoneyCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaMonument = function FaMonument (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaMoon = function FaMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"}}]})(props);
	};
	module.exports.FaMortarPestle = function FaMortarPestle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160H397.3L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512H352c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"}}]})(props);
	};
	module.exports.FaMosque = function FaMosque (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H560V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H448V454c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58H288zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160H160V296.6c-19.1 11.1-32 31.7-32 55.4V480c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176 160z"}}]})(props);
	};
	module.exports.FaMosquitoNet = function FaMosquitoNet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4V242.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H528v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H448v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V400H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V320H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16zm16 112h48V320H528v48zm0 80h48V400H528v48zM448 320v48h48V320H448zm0 80v48h48V400H448z"}}]})(props);
	};
	module.exports.FaMosquito = function FaMosquito (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"}}]})(props);
	};
	module.exports.FaMotorcycle = function FaMotorcycle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H187.3zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaMound = function FaMound (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"}}]})(props);
	};
	module.exports.FaMountainCity = function FaMountainCity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zM224 188.9L283.8 288H223l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"}}]})(props);
	};
	module.exports.FaMountainSun = function FaMountainSun (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M560 160A80 80 0 1 0 560 0a80 80 0 1 0 0 160zM55.9 512H381.1h75H578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"}}]})(props);
	};
	module.exports.FaMountain = function FaMountain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32c12.5 0 24.1 6.4 30.8 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5l18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8h49z"}}]})(props);
	};
	module.exports.FaMugHot = function FaMugHot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"}}]})(props);
	};
	module.exports.FaMugSaucer = function FaMugSaucer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 64c0-17.7 14.3-32 32-32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zM480 224h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H480V224zM32 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaMusic = function FaMusic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V147L192 223.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"}}]})(props);
	};
	module.exports.FaN = function FaN (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 50.5 8.4 38.5 21.1 33.9z"}}]})(props);
	};
	module.exports.FaNairaSign = function FaNairaSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H228.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H262.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zM185.5 256H128V169.7L185.5 256z"}}]})(props);
	};
	module.exports.FaNetworkWired = function FaNetworkWired (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256 64H384v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H192V288H448v32H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V192h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 448V384H224v64H96zm320-64H544v64H416V384z"}}]})(props);
	};
	module.exports.FaNeuter = function FaNeuter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"}}]})(props);
	};
	module.exports.FaNewspaper = function FaNewspaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaNotEqual = function FaNotEqual (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H153.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H260.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"}}]})(props);
	};
	module.exports.FaNotdef = function FaNotdef (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 390.3L153.5 256 64 121.7V390.3zM102.5 448H281.5L192 313.7 102.5 448zm128-192L320 390.3V121.7L230.5 256zM281.5 64H102.5L192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"}}]})(props);
	};
	module.exports.FaNoteSticky = function FaNoteSticky (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H288V368c0-26.5 21.5-48 48-48H448V96c0-35.3-28.7-64-64-64H64zM448 352H402.7 336c-8.8 0-16 7.2-16 16v66.7V480l32-32 64-64 32-32z"}}]})(props);
	};
	module.exports.FaNotesMedical = function FaNotesMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 352V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V293.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16H272zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296z"}}]})(props);
	};
	module.exports.FaO = function FaO (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"}}]})(props);
	};
	module.exports.FaObjectGroup = function FaObjectGroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"}}]})(props);
	};
	module.exports.FaObjectUngroup = function FaObjectUngroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H328.6C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V232.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4V232.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4H520.6c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H311.4z"}}]})(props);
	};
	module.exports.FaOilCan = function FaOilCan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H144 96 48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288V128h32zM96 208v86.1L48 272.8V208H96z"}}]})(props);
	};
	module.exports.FaOilWell = function FaOilWell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1L305.3 352H238.7L265 277l-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32H327.7l11.2 32H205.1z"}}]})(props);
	};
	module.exports.FaOm = function FaOm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48H109.8c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H144h16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5 0-.1c-2.6-7.8-10.7-12.3-18.7-10.5C4.4 354.2-.9 361.8 .1 370L16 368C.1 370 .1 370 .1 370l0 0 0 0 0 .1 .1 .4c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.3 0 0c0 0 0 0 0 0c-1.9-7.3-8.6-12.4-16.2-12.1c-7.6 .3-13.9 5.9-15.1 13.4L336 368c-15.8-2.6-15.8-2.6-15.8-2.6l0 0 0 0 0 .1-.1 .3c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96V288c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4H245.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4zM280.9 66.7c-6-4-14-3.5-19.5 1.3s-7 12.7-3.7 19.2L272 80c-14.3 7.2-14.3 7.2-14.3 7.2l0 0 0 0 0 .1 .1 .2 .4 .7c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-22.6-22.6l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3c-12.4-12.4-32.6-12.5-45.1-.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2 0 0 0 0 0 0z"}}]})(props);
	};
	module.exports.FaOtter = function FaOtter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V336 320c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6V240c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16v32 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V204.3c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1h0c0 123.7-100.3 224-224 224h-1.1H256h-.6C132 480 32 380 32 256.6V256 216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64H320c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"}}]})(props);
	};
	module.exports.FaOutdent = function FaOutdent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6V335.3c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"}}]})(props);
	};
	module.exports.FaP = function FaP (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V320 96zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z"}}]})(props);
	};
	module.exports.FaPager = function FaPager (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"}}]})(props);
	};
	module.exports.FaPaintRoller = function FaPaintRoller (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 352c0-17.7 14.3-32 32-32V304c0-44.2 35.8-80 80-80H416c17.7 0 32-14.3 32-32V160 69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352z"}}]})(props);
	};
	module.exports.FaPaintbrush = function FaPaintbrush (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"}}]})(props);
	};
	module.exports.FaPalette = function FaPalette (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaPallet = function FaPallet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z"}}]})(props);
	};
	module.exports.FaPanorama = function FaPanorama (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"}}]})(props);
	};
	module.exports.FaPaperPlane = function FaPaperPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"}}]})(props);
	};
	module.exports.FaPaperclip = function FaPaperclip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"}}]})(props);
	};
	module.exports.FaParachuteBox = function FaParachuteBox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H240V320H208c-7 0-13.7 1.5-19.7 4.2L68.2 192H96.5c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192h6L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2H272V192H383.5z"}}]})(props);
	};
	module.exports.FaParagraph = function FaParagraph (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"}}]})(props);
	};
	module.exports.FaPassport = function FaPassport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8H279.6zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8H129.3c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"}}]})(props);
	};
	module.exports.FaPaste = function FaPaste (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V256H416c-17.7 0-32-14.3-32-32V128H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm256 88v96h96l-96-96z"}}]})(props);
	};
	module.exports.FaPause = function FaPause (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"}}]})(props);
	};
	module.exports.FaPaw = function FaPaw (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"}}]})(props);
	};
	module.exports.FaPeace = function FaPeace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5V445.3c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3V240.8L422.8 351.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"}}]})(props);
	};
	module.exports.FaPenClip = function FaPenClip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1 0 0-1-1 0 0-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"}}]})(props);
	};
	module.exports.FaPenFancy = function FaPenFancy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"}}]})(props);
	};
	module.exports.FaPenNib = function FaPenNib (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"}}]})(props);
	};
	module.exports.FaPenRuler = function FaPenRuler (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"}}]})(props);
	};
	module.exports.FaPenToSquare = function FaPenToSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"}}]})(props);
	};
	module.exports.FaPen = function FaPen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"}}]})(props);
	};
	module.exports.FaPencil = function FaPencil (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"}}]})(props);
	};
	module.exports.FaPeopleArrows = function FaPeopleArrows (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V391.2l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96V240c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V336H272v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"}}]})(props);
	};
	module.exports.FaPeopleCarryBox = function FaPeopleCarryBox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7V186.6c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51V241.7l-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8H256.7c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm77.9 348.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"}}]})(props);
	};
	module.exports.FaPeopleGroup = function FaPeopleGroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"}}]})(props);
	};
	module.exports.FaPeopleLine = function FaPeopleLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V217.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5z"}}]})(props);
	};
	module.exports.FaPeoplePulling = function FaPeoplePulling (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128H64zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"}}]})(props);
	};
	module.exports.FaPeopleRobbery = function FaPeopleRobbery (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64v96l0 .6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H88V480c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H209.6l-37.4-58.9C157.6 142 132.1 128 104.7 128H72z"}}]})(props);
	};
	module.exports.FaPeopleRoof = function FaPeopleRoof (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm312 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM226.9 491.4L200 441.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V441.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V441.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V345.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"}}]})(props);
	};
	module.exports.FaPepperHot = function FaPepperHot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24V152c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"}}]})(props);
	};
	module.exports.FaPercent = function FaPercent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"}}]})(props);
	};
	module.exports.FaPersonArrowDownToLine = function FaPersonArrowDownToLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM464 64V306.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"}}]})(props);
	};
	module.exports.FaPersonArrowUpFromLine = function FaPersonArrowUpFromLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"}}]})(props);
	};
	module.exports.FaPersonBiking = function FaPersonBiking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"}}]})(props);
	};
	module.exports.FaPersonBooth = function FaPersonBooth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64V32zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM224 512c17.7 0 32-14.3 32-32V320H192V480c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3V269.3l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H157.3l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6v55.7l0 .9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V421.3c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"}}]})(props);
	};
	module.exports.FaPersonBreastfeeding = function FaPersonBreastfeeding (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"}}]})(props);
	};
	module.exports.FaPersonBurst = function FaPersonBurst (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"}}]})(props);
	};
	module.exports.FaPersonCane = function FaPersonCane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M272 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"}}]})(props);
	};
	module.exports.FaPersonChalkboard = function FaPersonChalkboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V192h56 64 16c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64H576V256H384V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"}}]})(props);
	};
	module.exports.FaPersonCircleCheck = function FaPersonCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"}}]})(props);
	};
	module.exports.FaPersonCircleExclamation = function FaPersonCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaPersonCircleMinus = function FaPersonCircleMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"}}]})(props);
	};
	module.exports.FaPersonCirclePlus = function FaPersonCirclePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"}}]})(props);
	};
	module.exports.FaPersonCircleQuestion = function FaPersonCircleQuestion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"}}]})(props);
	};
	module.exports.FaPersonCircleXmark = function FaPersonCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"}}]})(props);
	};
	module.exports.FaPersonDigging = function FaPersonDigging (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"}}]})(props);
	};
	module.exports.FaPersonDotsFromLine = function FaPersonDotsFromLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 176A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM78.7 372.9c15-12.5 50-34.4 97.3-50.1V432H400V322.7c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM224 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"}}]})(props);
	};
	module.exports.FaPersonDressBurst = function FaPersonDressBurst (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"}}]})(props);
	};
	module.exports.FaPersonDress = function FaPersonDress (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"}}]})(props);
	};
	module.exports.FaPersonDrowning = function FaPersonDrowning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3V64zM320 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"}}]})(props);
	};
	module.exports.FaPersonFallingBurst = function FaPersonFallingBurst (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H224l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"}}]})(props);
	};
	module.exports.FaPersonFalling = function FaPersonFalling (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0h-1.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"}}]})(props);
	};
	module.exports.FaPersonHalfDress = function FaPersonHalfDress (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 352V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3V384h0v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"}}]})(props);
	};
	module.exports.FaPersonHarassing = function FaPersonHarassing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 344v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"}}]})(props);
	};
	module.exports.FaPersonHiking = function FaPersonHiking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H336V184c0-13.3 10.7-24 24-24s24 10.7 24 24v55.8c0 .1 0 .2 0 .2s0 .2 0 .2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H296.6c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z"}}]})(props);
	};
	module.exports.FaPersonMilitaryPointing = function FaPersonMilitaryPointing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25H400c8.8 0 16-7.2 16-16V17.4C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40H224v89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5H240 72zm345.7 20.9L246.6 416H416V369.7l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V448H224z"}}]})(props);
	};
	module.exports.FaPersonMilitaryRifle = function FaPersonMilitaryRifle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25zm17.6 57H334.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"}}]})(props);
	};
	module.exports.FaPersonMilitaryToPerson = function FaPersonMilitaryToPerson (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9H184.1c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1H66.5C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256v32c0 17.7 14.3 32 32 32H192c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5V256c0-35.3-28.7-64-64-64H96c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H352zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32l-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"}}]})(props);
	};
	module.exports.FaPersonPraying = function FaPersonPraying (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432H72c-22.1 0-40 17.9-40 40s17.9 40 40 40H280c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"}}]})(props);
	};
	module.exports.FaPersonPregnant = function FaPersonPregnant (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 383c-13.8-3.6-24-16.1-24-31V296.9l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1h1.1 12.5H192c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 264v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h-8-8v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V383z"}}]})(props);
	};
	module.exports.FaPersonRays = function FaPersonRays (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H248zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"}}]})(props);
	};
	module.exports.FaPersonRifle = function FaPersonRifle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM448 0c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 16z"}}]})(props);
	};
	module.exports.FaPersonRunning = function FaPersonRunning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"}}]})(props);
	};
	module.exports.FaPersonShelter = function FaPersonShelter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"}}]})(props);
	};
	module.exports.FaPersonSkating = function FaPersonSkating (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H319.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V349.3l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"}}]})(props);
	};
	module.exports.FaPersonSkiingNordic = function FaPersonSkiingNordic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464H202.8l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H159.3c.4 0 .9 0 1.3 0H319.3c.5 0 1 0 1.4 0H504c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24H434.6l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32H426.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464H357.8l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288h2.7z"}}]})(props);
	};
	module.exports.FaPersonSkiing = function FaPersonSkiing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L232.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L151.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"}}]})(props);
	};
	module.exports.FaPersonSnowboarding = function FaPersonSnowboarding (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H443.8c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"}}]})(props);
	};
	module.exports.FaPersonSwimming = function FaPersonSwimming (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"}}]})(props);
	};
	module.exports.FaPersonThroughWindow = function FaPersonThroughWindow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0H64V64zm288 0l224 0V384H508.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320H379.2l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H308.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0H192s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"}}]})(props);
	};
	module.exports.FaPersonWalkingArrowLoopLeft = function FaPersonWalkingArrowLoopLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96H461.3l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"}}]})(props);
	};
	module.exports.FaPersonWalkingArrowRight = function FaPersonWalkingArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"}}]})(props);
	};
	module.exports.FaPersonWalkingDashedLineArrowRight = function FaPersonWalkingDashedLineArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM392 320c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440z"}}]})(props);
	};
	module.exports.FaPersonWalkingLuggage = function FaPersonWalkingLuggage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"}}]})(props);
	};
	module.exports.FaPersonWalkingWithCane = function FaPersonWalkingWithCane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6v43.2c0 17 6.7 33.3 18.7 45.3L224 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L224 306.7V213.3l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128H167.6zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"}}]})(props);
	};
	module.exports.FaPersonWalking = function FaPersonWalking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"}}]})(props);
	};
	module.exports.FaPerson = function FaPerson (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z"}}]})(props);
	};
	module.exports.FaPesetaSign = function FaPesetaSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 32C46.3 32 32 46.3 32 64v96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96V448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h96c77.4 0 142-55 156.8-128H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32H64zM282.5 160H96V96h96c41.8 0 77.4 26.7 90.5 64zM96 224H282.5c-13.2 37.3-48.7 64-90.5 64H96V224z"}}]})(props);
	};
	module.exports.FaPesoSign = function FaPesoSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 32C46.3 32 32 46.3 32 64v64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.8C303.7 71 244.4 32 176 32H64zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32zM96 192H286.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96V192zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96V288H254.4z"}}]})(props);
	};
	module.exports.FaPhoneFlip = function FaPhoneFlip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"}}]})(props);
	};
	module.exports.FaPhoneSlash = function FaPhoneSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 107.4 37.8 206 100.8 283.1L9.2 469.1c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7s-23.3-12.3-33.7-4.1L253 278c-17.8-21.5-32.9-45.2-45-70.7L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96zm96.8 319l-91.3 72C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3z"}}]})(props);
	};
	module.exports.FaPhoneVolume = function FaPhoneVolume (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"}}]})(props);
	};
	module.exports.FaPhone = function FaPhone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"}}]})(props);
	};
	module.exports.FaPhotoFilm = function FaPhotoFilm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaPiggyBank = function FaPiggyBank (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M400 96l0 .7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96h11.5c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H256v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24H68c-11 0-20 9-20 20s9 20 20 20H99.2c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2H384zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"}}]})(props);
	};
	module.exports.FaPills = function FaPills (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 96c-26.5 0-48 21.5-48 48V256h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"}}]})(props);
	};
	module.exports.FaPizzaSlice = function FaPizzaSlice (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaPlaceOfWorship = function FaPlaceOfWorship (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 109.3V217.6L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"}}]})(props);
	};
	module.exports.FaPlaneArrival = function FaPlaneArrival (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14-9.3-22.5zM32 448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaPlaneCircleCheck = function FaPlaneCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"}}]})(props);
	};
	module.exports.FaPlaneCircleExclamation = function FaPlaneCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaPlaneCircleXmark = function FaPlaneCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"}}]})(props);
	};
	module.exports.FaPlaneDeparture = function FaPlaneDeparture (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"}}]})(props);
	};
	module.exports.FaPlaneLock = function FaPlaneLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2C418 247.6 416 259.6 416 272v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v24 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"}}]})(props);
	};
	module.exports.FaPlaneSlash = function FaPlaneSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M514.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64H440.6L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L238.1 161.3 197.8 20.4C194.9 10.2 202.6 0 213.2 0h56.2c11.5 0 22.1 6.2 27.8 16.1L397.7 192l116.6 0zM41.5 128.7l321 252.9L297.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6H144l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4H46c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L64 256 32.5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-6.2 4-11.4 9.5-13.3z"}}]})(props);
	};
	module.exports.FaPlaneUp = function FaPlaneUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400V320L21.1 377C10.7 380.4 0 372.7 0 361.8V305.1c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"}}]})(props);
	};
	module.exports.FaPlane = function FaPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"}}]})(props);
	};
	module.exports.FaPlantWilt = function FaPlantWilt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V120C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V248c0-30.9 25.1-56 56-56s56 25.1 56 56v32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V280 248 120z"}}]})(props);
	};
	module.exports.FaPlateWheat = function FaPlateWheat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zM400 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm80 160v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320H484.2c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4z"}}]})(props);
	};
	module.exports.FaPlay = function FaPlay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"}}]})(props);
	};
	module.exports.FaPlugCircleBolt = function FaPlugCircleBolt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"}}]})(props);
	};
	module.exports.FaPlugCircleCheck = function FaPlugCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"}}]})(props);
	};
	module.exports.FaPlugCircleExclamation = function FaPlugCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaPlugCircleMinus = function FaPlugCircleMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaPlugCirclePlus = function FaPlugCirclePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaPlugCircleXmark = function FaPlugCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"}}]})(props);
	};
	module.exports.FaPlug = function FaPlug (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8C297 398 352 333.4 352 256V224c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"}}]})(props);
	};
	module.exports.FaPlusMinus = function FaPlusMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V320c0 17.7 14.3 32 32 32s32-14.3 32-32V208H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32zM0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"}}]})(props);
	};
	module.exports.FaPlus = function FaPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"}}]})(props);
	};
	module.exports.FaPodcast = function FaPodcast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"}}]})(props);
	};
	module.exports.FaPooStorm = function FaPooStorm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 21.7-8.5 37.2-21.9 47.6c-13.8 10.8-34 17-57.8 17H128c-35.3 0-64 28.7-64 64c0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 41 28 75.4 65.8 85.2c-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L285.7 320H304c20.4 0 38.5 12.9 45.3 32.1c3.7 10.6 3.5 21.8 0 31.9H360c48.6 0 88-39.4 88-88c0-43.6-31.7-79.8-73.3-86.8c5.9-9.7 9.3-21.1 9.3-33.2c0-35.3-28.7-64-64-64h-1.4c.9-5.4 1.4-10.9 1.4-16.6c0-48.7-36.1-88.9-83.1-95.2zm45.1 227.4c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H233.9l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"}}]})(props);
	};
	module.exports.FaPoo = function FaPoo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72H394.3c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3H339.7c6.8 0 12.3 5.5 12.3 12.3z"}}]})(props);
	};
	module.exports.FaPoop = function FaPoop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32H352c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"}}]})(props);
	};
	module.exports.FaPowerOff = function FaPowerOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"}}]})(props);
	};
	module.exports.FaPrescriptionBottleMedical = function FaPrescriptionBottleMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM160 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaPrescriptionBottle = function FaPrescriptionBottle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128z"}}]})(props);
	};
	module.exports.FaPrescription = function FaPrescription (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 0C14.3 0 0 14.3 0 32V192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224h50.7l128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0H32zM176 160H64V64H176c26.5 0 48 21.5 48 48s-21.5 48-48 48z"}}]})(props);
	};
	module.exports.FaPrint = function FaPrint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaPumpMedical = function FaPumpMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24z"}}]})(props);
	};
	module.exports.FaPumpSoap = function FaPumpSoap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"}}]})(props);
	};
	module.exports.FaPuzzlePiece = function FaPuzzlePiece (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8v0c0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2v0c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2v0c-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48H279.2c-12.8 0-23.2-10.4-23.2-23.2v0c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8v0c0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320v0c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256v0C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48H168.8c12.8 0 23.2-10.4 23.2-23.2v0z"}}]})(props);
	};
	module.exports.FaQ = function FaQ (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"}}]})(props);
	};
	module.exports.FaQrcode = function FaQrcode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm64 16v64h64V352H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64H320v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V304zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"}}]})(props);
	};
	module.exports.FaQuestion = function FaQuestion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"}}]})(props);
	};
	module.exports.FaQuoteLeft = function FaQuoteLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z"}}]})(props);
	};
	module.exports.FaQuoteRight = function FaQuoteRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"}}]})(props);
	};
	module.exports.FaR = function FaR (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H64zM176 256H64V96H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"}}]})(props);
	};
	module.exports.FaRadiation = function FaRadiation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"}}]})(props);
	};
	module.exports.FaRadio = function FaRadio (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"}}]})(props);
	};
	module.exports.FaRainbow = function FaRainbow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-35.3-28.7-64-64-64zM160 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-88.4-71.6-160-160-160s-160 71.6-160 160z"}}]})(props);
	};
	module.exports.FaRankingStar = function FaRankingStar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"}}]})(props);
	};
	module.exports.FaReceipt = function FaReceipt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"}}]})(props);
	};
	module.exports.FaRecordVinyl = function FaRecordVinyl (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaRectangleAd = function FaRectangleAd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"}}]})(props);
	};
	module.exports.FaRectangleList = function FaRectangleList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"}}]})(props);
	};
	module.exports.FaRectangleXmark = function FaRectangleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"}}]})(props);
	};
	module.exports.FaRecycle = function FaRecycle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM429.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L320 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32l96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L182 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3L68.8 335.3c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"}}]})(props);
	};
	module.exports.FaRegistered = function FaRegistered (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z"}}]})(props);
	};
	module.exports.FaRepeat = function FaRepeat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z"}}]})(props);
	};
	module.exports.FaReplyAll = function FaReplyAll (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3 .9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V288h32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352V64z"}}]})(props);
	};
	module.exports.FaReply = function FaReply (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"}}]})(props);
	};
	module.exports.FaRepublican = function FaRepublican (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 192C0 103.6 71.6 32 160 32H384c88.4 0 160 71.6 160 160v64H0V192zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160H320h96 32 64 32v32 80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V352H448v32 64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384 288H128z"}}]})(props);
	};
	module.exports.FaRestroom = function FaRestroom (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120zM320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480V384H422.2c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H504v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"}}]})(props);
	};
	module.exports.FaRetweet = function FaRetweet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"}}]})(props);
	};
	module.exports.FaRibbon = function FaRibbon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M333.2 322.8l0 0-133.9-146 0 0L146 118.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65V149.1c0-19-5.6-37.5-16.1-53.3L327.8 35.6C312.9 13.4 287.9 0 261.2 0h-76c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8V164c0 23.2 8.4 45.6 23.6 63.1l56 64.2 0 0 83.3 95.6 0 0 91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4l-87.7-95.7zM205.2 410.6l-83.3-95.6L27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z"}}]})(props);
	};
	module.exports.FaRightFromBracket = function FaRightFromBracket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"}}]})(props);
	};
	module.exports.FaRightLeft = function FaRightLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64H480z"}}]})(props);
	};
	module.exports.FaRightLong = function FaRightLong (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z"}}]})(props);
	};
	module.exports.FaRightToBracket = function FaRightToBracket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaRing = function FaRing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304V208z"}}]})(props);
	};
	module.exports.FaRoadBarrier = function FaRoadBarrier (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32zM405.2 96H330.8l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zM362.8 288h74.3l5.4-10.7L533.2 96H458.8l-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96H202.8zm288 192H576V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7L490.8 288z"}}]})(props);
	};
	module.exports.FaRoadBridge = function FaRoadBridge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M352 0H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V384zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM32 96H288v64H248v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-53-43-96-96-96V224H72V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64H120v64h80V160z"}}]})(props);
	};
	module.exports.FaRoadCircleCheck = function FaRoadCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"}}]})(props);
	};
	module.exports.FaRoadCircleExclamation = function FaRoadCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaRoadCircleXmark = function FaRoadCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"}}]})(props);
	};
	module.exports.FaRoadLock = function FaRoadLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"}}]})(props);
	};
	module.exports.FaRoadSpikes = function FaRoadSpikes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 448 384 320 256 192 64V116.8zM32 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaRoad = function FaRoad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M256 32H181.2c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480H256V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64H521.4c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaRobot = function FaRobot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z"}}]})(props);
	};
	module.exports.FaRocket = function FaRocket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"}}]})(props);
	};
	module.exports.FaRotateLeft = function FaRotateLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"}}]})(props);
	};
	module.exports.FaRotateRight = function FaRotateRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"}}]})(props);
	};
	module.exports.FaRotate = function FaRotate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"}}]})(props);
	};
	module.exports.FaRoute = function FaRoute (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaRss = function FaRss (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaRubleSign = function FaRubleSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M96 32C78.3 32 64 46.3 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H96zM240 256H128V96H240c44.2 0 80 35.8 80 80s-35.8 80-80 80z"}}]})(props);
	};
	module.exports.FaRug = function FaRug (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M24 64H56 80V88v88 80 80 88 24H56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V360H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V200H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0H528V448H112V64zM640 88c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H584 560V424 336 256 176 88 64h24 32c13.3 0 24 10.7 24 24z"}}]})(props);
	};
	module.exports.FaRulerCombined = function FaRulerCombined (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"}}]})(props);
	};
	module.exports.FaRulerHorizontal = function FaRulerHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"}}]})(props);
	};
	module.exports.FaRulerVertical = function FaRulerVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M0 48C0 21.5 21.5 0 48 0H208c26.5 0 48 21.5 48 48V96H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"}}]})(props);
	};
	module.exports.FaRuler = function FaRuler (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"}}]})(props);
	};
	module.exports.FaRupeeSign = function FaRupeeSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9l0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1l0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"}}]})(props);
	};
	module.exports.FaRupiahSign = function FaRupiahSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112H352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 192c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96h48z"}}]})(props);
	};
	module.exports.FaS = function FaS (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"}}]})(props);
	};
	module.exports.FaSackDollar = function FaSackDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 96H192L144.6 24.9C137.5 14.2 145.1 0 157.9 0H354.1c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128H320c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4l0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"}}]})(props);
	};
	module.exports.FaSackXmark = function FaSackXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"}}]})(props);
	};
	module.exports.FaSailboat = function FaSailboat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6H272c-8.8 0-16-7.2-16-16V16zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5V336c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"}}]})(props);
	};
	module.exports.FaSatelliteDish = function FaSatelliteDish (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaSatellite = function FaSatellite (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"}}]})(props);
	};
	module.exports.FaScaleBalanced = function FaScaleBalanced (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M384 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288H584.4L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320H199.3L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z"}}]})(props);
	};
	module.exports.FaScaleUnbalancedFlip = function FaScaleUnbalancedFlip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288L128 163.8 55.6 288H200.4zM128 384C65.1 384 12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384zm382.8-92.2L438.4 416H583.3L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"}}]})(props);
	};
	module.exports.FaScaleUnbalanced = function FaScaleUnbalanced (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288L512 163.8 584.4 288H439.6zM512 384c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 273.1c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zM129.2 291.8L201.6 416H56.7l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L153.2 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"}}]})(props);
	};
	module.exports.FaSchoolCircleCheck = function FaSchoolCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"}}]})(props);
	};
	module.exports.FaSchoolCircleExclamation = function FaSchoolCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaSchoolCircleXmark = function FaSchoolCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"}}]})(props);
	};
	module.exports.FaSchoolFlag = function FaSchoolFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0H400c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H320.7l89.6 64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48V512H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H165.7L256 95.5V32c0-17.7 14.3-32 32-32zm48 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H464z"}}]})(props);
	};
	module.exports.FaSchoolLock = function FaSchoolLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V272c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4H320.3l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"}}]})(props);
	};
	module.exports.FaSchool = function FaSchool (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM256 416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H256V416zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaScissors = function FaScissors (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"}}]})(props);
	};
	module.exports.FaScrewdriverWrench = function FaScrewdriverWrench (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"}}]})(props);
	};
	module.exports.FaScrewdriver = function FaScrewdriver (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v54.1l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"}}]})(props);
	};
	module.exports.FaScrollTorah = function FaScrollTorah (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128V480H512V32zM592 0c-26.5 0-48 14.3-48 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z"}}]})(props);
	};
	module.exports.FaScroll = function FaScroll (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z"}}]})(props);
	};
	module.exports.FaSdCard = function FaSdCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"}}]})(props);
	};
	module.exports.FaSection = function FaSection (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C22.3 194.2 6.5 215.1 1.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31l0 0 3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2l0 0c-4.3-1.5-8.5-2.9-12.3-4.2C25.3 420 7.2 429.1 1.6 445.8s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6l0 0 .2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"}}]})(props);
	};
	module.exports.FaSeedling = function FaSeedling (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64H64c123.7 0 224 100.3 224 224v32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96z"}}]})(props);
	};
	module.exports.FaServer = function FaServer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"}}]})(props);
	};
	module.exports.FaShapes = function FaShapes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2H384c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312V456c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"}}]})(props);
	};
	module.exports.FaShareFromSquare = function FaShareFromSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"}}]})(props);
	};
	module.exports.FaShareNodes = function FaShareNodes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"}}]})(props);
	};
	module.exports.FaShare = function FaShare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"}}]})(props);
	};
	module.exports.FaSheetPlastic = function FaSheetPlastic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 448c0 35.3 28.7 64 64 64H224V384c0-17.7 14.3-32 32-32H384V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384H256V512L384 384z"}}]})(props);
	};
	module.exports.FaShekelSign = function FaShekelSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192c35.3 0 64 28.7 64 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128H32zM320 480c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320z"}}]})(props);
	};
	module.exports.FaShieldCat = function FaShieldCat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"}}]})(props);
	};
	module.exports.FaShieldDog = function FaShieldDog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64V160h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160h40 8v32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"}}]})(props);
	};
	module.exports.FaShieldHalved = function FaShieldHalved (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"}}]})(props);
	};
	module.exports.FaShieldHeart = function FaShieldHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"}}]})(props);
	};
	module.exports.FaShieldVirus = function FaShieldVirus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"}}]})(props);
	};
	module.exports.FaShield = function FaShield (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"}}]})(props);
	};
	module.exports.FaShip = function FaShip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"}}]})(props);
	};
	module.exports.FaShirt = function FaShirt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z"}}]})(props);
	};
	module.exports.FaShoePrints = function FaShoePrints (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M416 0C352.3 0 256 32 256 32V160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32V480s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"}}]})(props);
	};
	module.exports.FaShopLock = function FaShopLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M36.8 192H449.6c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224H320V384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 352 224zm144 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"}}]})(props);
	};
	module.exports.FaShopSlash = function FaShopSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224H512V376L384 275.7V224H320v1.5L277.2 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.5l-64-50.4V384z"}}]})(props);
	};
	module.exports.FaShop = function FaShop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z"}}]})(props);
	};
	module.exports.FaShower = function FaShower (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaShrimp = function FaShrimp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H264 88.8 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM224 456c0 13.3 10.7 24 24 24h72V407.8l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128H320V320h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"}}]})(props);
	};
	module.exports.FaShuffle = function FaShuffle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"}}]})(props);
	};
	module.exports.FaShuttleSpace = function FaShuttleSpace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96h2zM352 128L245.2 63.9C210.4 43 170.6 32 130 32h-2v96l224 0zM96 128l0-96H80C53.5 32 32 53.5 32 80v48h8c-22.1 0-40 17.9-40 40v16V328v16c0 22.1 17.9 40 40 40H32v48c0 26.5 21.5 48 48 48H96l0-96h8c26.2 0 49.4-12.6 64-32H456c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6v24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4V212.4c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"}}]})(props);
	};
	module.exports.FaSignHanging = function FaSignHanging (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 0c17.7 0 32 14.3 32 32V64l352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H64V32C64 14.3 78.3 0 96 0zm96 160H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaSignal = function FaSignal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM352 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaSignature = function FaSignature (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48H616z"}}]})(props);
	};
	module.exports.FaSignsPost = function FaSignsPost (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 32H64C46.3 32 32 46.3 32 64v64c0 17.7 14.3 32 32 32H441.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32H288V192H224v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32V256zM288 480V384H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"}}]})(props);
	};
	module.exports.FaSimCard = function FaSimCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32v32h64V192H96zM64 352h80 96 80V288H240 144 64v64zM320 224c0-17.7-14.3-32-32-32H256v64h64V224zM160 192v64h64V192H160zM288 448c17.7 0 32-14.3 32-32V384H256v64h32zM160 384v64h64V384H160zM64 416c0 17.7 14.3 32 32 32h32V384H64v32z"}}]})(props);
	};
	module.exports.FaSink = function FaSink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96V288H160V264c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H400V264c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24H288V96zM480 416V384H32v32c0 53 43 96 96 96H384c53 0 96-43 96-96z"}}]})(props);
	};
	module.exports.FaSitemap = function FaSitemap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"}}]})(props);
	};
	module.exports.FaSkullCrossbones = function FaSkullCrossbones (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M368 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V234.4c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM168 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6C1.9 308.7-4.5 289.5 3.4 273.7z"}}]})(props);
	};
	module.exports.FaSkull = function FaSkull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1v64c0 26.5 21.5 48 48 48h48V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48V400c0-.4 0-.7 0-1.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"}}]})(props);
	};
	module.exports.FaSlash = function FaSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"}}]})(props);
	};
	module.exports.FaSleigh = function FaSleigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V256c0 53 43 96 96 96v32h64V352H384v32h64V352c53 0 96-43 96-96V160c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 480c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7H55 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H552c48.6 0 88-39.4 88-88v-8z"}}]})(props);
	};
	module.exports.FaSliders = function FaSliders (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"}}]})(props);
	};
	module.exports.FaSmog = function FaSmog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32 144c0 79.5 64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24z"}}]})(props);
	};
	module.exports.FaSmoking = function FaSmoking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M448 32V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32V245c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V416zm224 0v32H384V416H224zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaSnowflake = function FaSnowflake (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaSnowman = function FaSnowman (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M341.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L408 160.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9H181.3c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3L70.5 198.1l-56-24C2.4 168.8-3.3 154.7 1.9 142.5s19.3-17.8 31.5-12.6L56 139.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2L152.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C164 127.2 160 112.1 160 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24v3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaSnowplow = function FaSnowplow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M298.9 64l68.6 160H256l-64-64V64H298.9zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48V160H96c-17.7 0-32 14.3-32 32V298.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V320 235.2L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288H448V256.7c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H368zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"}}]})(props);
	};
	module.exports.FaSoap = function FaSoap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96V416c0 53 43 96 96 96H416c53 0 96-43 96-96V288c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H352c35.3 0 64-28.7 64-64s-28.7-64-64-64H320 160z"}}]})(props);
	};
	module.exports.FaSocks = function FaSocks (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64H288V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0H176c-26.5 0-48 21.5-48 48V64zM320 96V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96H320zM512 64V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V64H512z"}}]})(props);
	};
	module.exports.FaSolarPanel = function FaSolarPanel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C.4 347 30.6 384 71 384H288v64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H569c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0H122.2zM260.9 64H379.1l10.4 104h-139L260.9 64zM202.3 168H101.4L122.2 64h90.4L202.3 168zM91.8 216H197.5L187.1 320H71L91.8 216zm153.9 0H394.3l10.4 104-169.4 0 10.4-104zm196.8 0H548.2L569 320h-116L442.5 216zm96-48H437.7L427.3 64h90.4l31.4-6.3L517.8 64l20.8 104z"}}]})(props);
	};
	module.exports.FaSortDown = function FaSortDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"}}]})(props);
	};
	module.exports.FaSortUp = function FaSortUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"}}]})(props);
	};
	module.exports.FaSort = function FaSort (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"}}]})(props);
	};
	module.exports.FaSpa = function FaSpa (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480H288 267.9C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"}}]})(props);
	};
	module.exports.FaSpaghettiMonsterFlying = function FaSpaghettiMonsterFlying (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"}}]})(props);
	};
	module.exports.FaSpellCheck = function FaSpellCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160H93.3L112 115.2 130.7 160zM256 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H288c-17.7 0-32 14.3-32 32zm96 64H320V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V160zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"}}]})(props);
	};
	module.exports.FaSpider = function FaSpider (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1V160c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16V101.2c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"}}]})(props);
	};
	module.exports.FaSpinner = function FaSpinner (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"}}]})(props);
	};
	module.exports.FaSplotch = function FaSplotch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"}}]})(props);
	};
	module.exports.FaSpoon = function FaSpoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"}}]})(props);
	};
	module.exports.FaSprayCanSparkles = function FaSprayCanSparkles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 32v96H224V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"}}]})(props);
	};
	module.exports.FaSprayCan = function FaSprayCan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0zM256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaSquareArrowUpRight = function FaSquareArrowUpRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"}}]})(props);
	};
	module.exports.FaSquareCaretDown = function FaSquareCaretDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"}}]})(props);
	};
	module.exports.FaSquareCaretLeft = function FaSquareCaretLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"}}]})(props);
	};
	module.exports.FaSquareCaretRight = function FaSquareCaretRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"}}]})(props);
	};
	module.exports.FaSquareCaretUp = function FaSquareCaretUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"}}]})(props);
	};
	module.exports.FaSquareCheck = function FaSquareCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"}}]})(props);
	};
	module.exports.FaSquareEnvelope = function FaSquareEnvelope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"}}]})(props);
	};
	module.exports.FaSquareFull = function FaSquareFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 0H512V512H0V0z"}}]})(props);
	};
	module.exports.FaSquareH = function FaSquareH (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM336 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"}}]})(props);
	};
	module.exports.FaSquareMinus = function FaSquareMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaSquareNfi = function FaSquareNfi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"}}]})(props);
	};
	module.exports.FaSquareParking = function FaSquareParking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 256h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64zm48 64H192v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"}}]})(props);
	};
	module.exports.FaSquarePen = function FaSquarePen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"}}]})(props);
	};
	module.exports.FaSquarePersonConfined = function FaSquarePersonConfined (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7V248z"}}]})(props);
	};
	module.exports.FaSquarePhoneFlip = function FaSquarePhoneFlip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"}}]})(props);
	};
	module.exports.FaSquarePhone = function FaSquarePhone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"}}]})(props);
	};
	module.exports.FaSquarePlus = function FaSquarePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"}}]})(props);
	};
	module.exports.FaSquarePollHorizontal = function FaSquarePollHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"}}]})(props);
	};
	module.exports.FaSquarePollVertical = function FaSquarePollVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM320 288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaSquareRootVariable = function FaSquareRootVariable (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"}}]})(props);
	};
	module.exports.FaSquareRss = function FaSquareRss (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaSquareShareNodes = function FaSquareShareNodes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"}}]})(props);
	};
	module.exports.FaSquareUpRight = function FaSquareUpRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM320 313.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"}}]})(props);
	};
	module.exports.FaSquareVirus = function FaSquareVirus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"}}]})(props);
	};
	module.exports.FaSquareXmark = function FaSquareXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"}}]})(props);
	};
	module.exports.FaSquare = function FaSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"}}]})(props);
	};
	module.exports.FaStaffSnake = function FaStaffSnake (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M222.6 43.2l-.1 4.8H288c53 0 96 43 96 96s-43 96-96 96H248V160h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H248 220l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96H240V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H213l-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32H152c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128H136 122.6c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56S25.1 48 56 48h8 8 89.5l-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"}}]})(props);
	};
	module.exports.FaStairs = function FaStairs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 64c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v96c0 17.7-14.3 32-32 32H320v96c0 17.7-14.3 32-32 32H192v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V320c0-17.7 14.3-32 32-32h96V192c0-17.7 14.3-32 32-32h96V64z"}}]})(props);
	};
	module.exports.FaStamp = function FaStamp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V413.3c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112H366.2c-29.9 0-54.2-24.3-54.2-54.2zM416 416v32H96V416H416z"}}]})(props);
	};
	module.exports.FaStapler = function FaStapler (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 299.3V304 432c0 26.5-21.5 48-48 48H512 448 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448V368H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304V288L128 230.9V304H448z"}}]})(props);
	};
	module.exports.FaStarAndCrescent = function FaStarAndCrescent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256zM375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"}}]})(props);
	};
	module.exports.FaStarHalfStroke = function FaStarHalfStroke (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L320.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L320.1 439.8 191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L470.5 329l24.6 145.7z"}}]})(props);
	};
	module.exports.FaStarHalf = function FaStarHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zM429.9 512c1.1 .1 2.1 .1 3.2 0h-3.2z"}}]})(props);
	};
	module.exports.FaStarOfDavid = function FaStarOfDavid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M404.2 309.5L383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88H317.4l54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168H383.1zM283 112L256 68l-27 44h54zM128.9 168H86.6l21.1 34.5L128.9 168zM107.8 309.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44H229z"}}]})(props);
	};
	module.exports.FaStarOfLife = function FaStarOfLife (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z"}}]})(props);
	};
	module.exports.FaStar = function FaStar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"}}]})(props);
	};
	module.exports.FaSterlingSign = function FaSterlingSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1C104.1 390 112 361.5 112 332.5V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"}}]})(props);
	};
	module.exports.FaStethoscope = function FaStethoscope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112V265.3c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaStop = function FaStop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"}}]})(props);
	};
	module.exports.FaStopwatch20 = function FaStopwatch20 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176zM288 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52V256c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12V256c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20H128c-11 0-20-9-20-20V368.3c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z"}}]})(props);
	};
	module.exports.FaStopwatch = function FaStopwatch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H224 176zm72 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"}}]})(props);
	};
	module.exports.FaStoreSlash = function FaStoreSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V384 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V350.9L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm73.4 218.1c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3L365.5 384H160z"}}]})(props);
	};
	module.exports.FaStore = function FaStore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"}}]})(props);
	};
	module.exports.FaStreetView = function FaStreetView (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"}}]})(props);
	};
	module.exports.FaStrikethrough = function FaStrikethrough (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"}}]})(props);
	};
	module.exports.FaStroopwafel = function FaStroopwafel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3L233.4 256l-45.3 45.3L142.9 256zm67.9 67.9L256 278.6l45.3 45.3L256 369.1l-45.3-45.3zM278.6 256l45.3-45.3L369.1 256l-45.3 45.3L278.6 256zm22.6-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z"}}]})(props);
	};
	module.exports.FaSubscript = function FaSubscript (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320z"}}]})(props);
	};
	module.exports.FaSuitcaseMedical = function FaSuitcaseMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96v32V480H384V128 96 56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H96V96zM416 480h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H416V480zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"}}]})(props);
	};
	module.exports.FaSuitcaseRolling = function FaSuitcaseRolling (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72H144V56zm176 72H288V56c0-30.9-25.1-56-56-56H152C121.1 0 96 25.1 96 56v72H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32H256c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zM112 224H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaSuitcase = function FaSuitcase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z"}}]})(props);
	};
	module.exports.FaSunPlantWilt = function FaSunPlantWilt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v8V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V280v-8V176z"}}]})(props);
	};
	module.exports.FaSun = function FaSun (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"}}]})(props);
	};
	module.exports.FaSuperscript = function FaSuperscript (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32z"}}]})(props);
	};
	module.exports.FaSwatchbook = function FaSwatchbook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 32C0 14.3 14.3 0 32 0H160c17.7 0 32 14.3 32 32V416c0 53-43 96-96 96s-96-43-96-96V32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192H480c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H182.8zM128 64H64v64h64V64zM64 192v64h64V192H64zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"}}]})(props);
	};
	module.exports.FaSynagogue = function FaSynagogue (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166V280.1 512H464 352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H176 160V280.1 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64H512zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"}}]})(props);
	};
	module.exports.FaSyringe = function FaSyringe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V325.3c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"}}]})(props);
	};
	module.exports.FaT = function FaT (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"}}]})(props);
	};
	module.exports.FaTableCellsLarge = function FaTableCellsLarge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 96V224H288V96H448zm0 192V416H288V288H448zM224 224H64V96H224V224zM64 288H224V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"}}]})(props);
	};
	module.exports.FaTableCells = function FaTableCells (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64H208V96zm240 0v64H360V96h88zM64 224h88v64H64V224zm232 0v64H208V224h88zm64 0h88v64H360V224zM152 352v64H64V352h88zm56 0h88v64H208V352zm240 0v64H360V352h88z"}}]})(props);
	};
	module.exports.FaTableColumns = function FaTableColumns (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64V416H224V160H64zm384 0H288V416H448V160z"}}]})(props);
	};
	module.exports.FaTableList = function FaTableList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"}}]})(props);
	};
	module.exports.FaTableTennisPaddleBall = function FaTableTennisPaddleBall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M480 288c-50.1 0-93.6 28.8-114.6 70.8L132.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C535.8 297.6 509 288 480 288zM113.3 151.9L354.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3H357c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L152.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32c-6.3-6.3-9.7-14.9-9.4-23.8s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8c-24-24-37.5-56.6-37.5-90.5v-2.7c0-22.8 6.1-44.9 17.3-64.3zM480 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"}}]})(props);
	};
	module.exports.FaTable = function FaTable (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"}}]})(props);
	};
	module.exports.FaTabletButton = function FaTabletButton (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaTabletScreenButton = function FaTabletScreenButton (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64H64V384H384V64z"}}]})(props);
	};
	module.exports.FaTablet = function FaTablet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaTablets = function FaTablets (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7c-7.9 5.2-8.5 16.2-1.8 22.9L591.4 248.8c6.7 6.7 17.8 6.2 22.9-1.8zM567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8c-16.3 25-25.7 54.9-25.7 87c0 88.4 71.6 160 160 160c32.1 0 61.9-9.4 87-25.7zM301.5 368H18.5c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5zm0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5H301.5z"}}]})(props);
	};
	module.exports.FaTachographDigital = function FaTachographDigital (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"}}]})(props);
	};
	module.exports.FaTag = function FaTag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaTags = function FaTags (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}}]})(props);
	};
	module.exports.FaTape = function FaTape (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"}}]})(props);
	};
	module.exports.FaTarpDroplet = function FaTarpDroplet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128H197.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64V352H448c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM448 512l0-128H576L448 512zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaTarp = function FaTarp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32H576V128zM448 448L576 320H448l0 128zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaTaxi = function FaTaxi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 0c-17.7 0-32 14.3-32 32V64c0 .1 0 .1 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288V432v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V432H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V432 288c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1c0-.1 0-.1 0-.2V32c0-17.7-14.3-32-32-32H192zM165.4 128H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 224H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaTeethOpen = function FaTeethOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96zM224 96c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V144c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V144zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V176c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V176zM96 480H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"}}]})(props);
	};
	module.exports.FaTeeth = function FaTeeth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"}}]})(props);
	};
	module.exports.FaTemperatureArrowDown = function FaTemperatureArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64H480V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352H384c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"}}]})(props);
	};
	module.exports.FaTemperatureArrowUp = function FaTemperatureArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM480 160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V160z"}}]})(props);
	};
	module.exports.FaTemperatureEmpty = function FaTemperatureEmpty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM160 0C98.1 0 48 50.2 48 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"}}]})(props);
	};
	module.exports.FaTemperatureFull = function FaTemperatureFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"}}]})(props);
	};
	module.exports.FaTemperatureHalf = function FaTemperatureHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V208c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"}}]})(props);
	};
	module.exports.FaTemperatureHigh = function FaTemperatureHigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"}}]})(props);
	};
	module.exports.FaTemperatureLow = function FaTemperatureLow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 96a96 96 0 1 1 192 0A96 96 0 1 1 320 96zM144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"}}]})(props);
	};
	module.exports.FaTemperatureQuarter = function FaTemperatureQuarter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"}}]})(props);
	};
	module.exports.FaTemperatureThreeQuarters = function FaTemperatureThreeQuarters (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"}}]})(props);
	};
	module.exports.FaTengeSign = function FaTengeSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32H192 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"}}]})(props);
	};
	module.exports.FaTentArrowDownToLine = function FaTentArrowDownToLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H159.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448h76.8L384 320V448z"}}]})(props);
	};
	module.exports.FaTentArrowLeftRight = function FaTentArrowLeftRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"}}]})(props);
	};
	module.exports.FaTentArrowTurnLeft = function FaTentArrowTurnLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"}}]})(props);
	};
	module.exports.FaTentArrowsDown = function FaTentArrowsDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"}}]})(props);
	};
	module.exports.FaTent = function FaTent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H416L288 288V512H32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"}}]})(props);
	};
	module.exports.FaTents = function FaTents (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512H224V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"}}]})(props);
	};
	module.exports.FaTerminal = function FaTerminal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaTextHeight = function FaTextHeight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 128V96h64l0 320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192l0-320h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H160 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM502.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"}}]})(props);
	};
	module.exports.FaTextSlash = function FaTextSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1L272.9 311 243.3 416z"}}]})(props);
	};
	module.exports.FaTextWidth = function FaTextWidth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 128V96H192l0 128H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l0-128H384v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H224 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V416H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"}}]})(props);
	};
	module.exports.FaThermometer = function FaThermometer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 382.1V293.3c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4H129.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"}}]})(props);
	};
	module.exports.FaThumbsDown = function FaThumbsDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"}}]})(props);
	};
	module.exports.FaThumbsUp = function FaThumbsUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaThumbtack = function FaThumbtack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"}}]})(props);
	};
	module.exports.FaTicketSimple = function FaTicketSimple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192V128z"}}]})(props);
	};
	module.exports.FaTicket = function FaTicket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 112l0 160c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"}}]})(props);
	};
	module.exports.FaTimeline = function FaTimeline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM488 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaToggleOff = function FaToggleOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"}}]})(props);
	};
	module.exports.FaToggleOn = function FaToggleOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"}}]})(props);
	};
	module.exports.FaToiletPaperSlash = function FaToiletPaperSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM367.3 385.4L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"}}]})(props);
	};
	module.exports.FaToiletPaper = function FaToiletPaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"}}]})(props);
	};
	module.exports.FaToiletPortable = function FaToiletPortable (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M0 32V64H320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM24 96H0v24V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H272v8c0 13.3 10.7 24 24 24s24-10.7 24-24V120 96H296 24zM256 240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaToilet = function FaToilet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaToiletsPortable = function FaToiletsPortable (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M32 0H224c17.7 0 32 14.3 32 32V64H0V32C0 14.3 14.3 0 32 0zM0 96H24 232h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM192 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM352 0H544c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32zM320 96h24H552h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM512 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaToolbox = function FaToolbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M176 88v40H336V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V88c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56v40h28.1c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9V304H384V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H192V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H0V227.9c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1H128zM0 416V336H128v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H320v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H512v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z"}}]})(props);
	};
	module.exports.FaTooth = function FaTooth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"}}]})(props);
	};
	module.exports.FaToriiGate = function FaToriiGate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 80c0 26.5 21.5 48 48 48H64v64h64V128h96v64h64V128h96v64h64V128h16c26.5 0 48-21.5 48-48V13.4C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32H126.8c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4V80zM64 288V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64z"}}]})(props);
	};
	module.exports.FaTornado = function FaTornado (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32V45.6C0 62.7 1.7 79.6 5 96H357.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z"}}]})(props);
	};
	module.exports.FaTowerBroadcast = function FaTowerBroadcast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"}}]})(props);
	};
	module.exports.FaTowerCell = function FaTowerCell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448H398.3l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32H354.7l14.5 32zM288 205.3L325.6 288H250.4L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"}}]})(props);
	};
	module.exports.FaTowerObservation = function FaTowerObservation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H384.5c-.4 0-.8 0-1.1 0H128.6c-.4 0-.8 0-1.1 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32V144c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448h117zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256H197.8zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"}}]})(props);
	};
	module.exports.FaTractor = function FaTractor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 64c0-35.3 28.7-64 64-64H266.3c26.2 0 49.7 15.9 59.4 40.2L373.7 160H480V126.2c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48H352c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V192 160 64zm170.3 0H160v96h32H304.7L266.3 64zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM528 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"}}]})(props);
	};
	module.exports.FaTrademark = function FaTrademark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32H96V384c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128z"}}]})(props);
	};
	module.exports.FaTrafficLight = function FaTrafficLight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"}}]})(props);
	};
	module.exports.FaTrailer = function FaTrailer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaTrainSubway = function FaTrainSubway (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM272 96h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM64 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaTrainTram = function FaTrainTram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0H361.2c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15H248V96h40c53 0 96 43 96 96V352c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1H365.3c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48H86.8zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaTrain = function FaTrain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM224 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"}}]})(props);
	};
	module.exports.FaTransgender = function FaTransgender (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V414.2C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"}}]})(props);
	};
	module.exports.FaTrashArrowUp = function FaTrashArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"}}]})(props);
	};
	module.exports.FaTrashCanArrowUp = function FaTrashCanArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"}}]})(props);
	};
	module.exports.FaTrashCan = function FaTrashCan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaTrash = function FaTrash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"}}]})(props);
	};
	module.exports.FaTreeCity = function FaTreeCity (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80H160V480c0 18-15 32-32 32c-18 0-32-14-32-32V320H80c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"}}]})(props);
	};
	module.exports.FaTree = function FaTree (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320H80L5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H424.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"}}]})(props);
	};
	module.exports.FaTriangleExclamation = function FaTriangleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}}]})(props);
	};
	module.exports.FaTrophy = function FaTrophy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"}}]})(props);
	};
	module.exports.FaTrowelBricks = function FaTrowelBricks (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48H376c-14.9 0-27.4-10.2-31-24H256v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm192 0H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaTrowel = function FaTrowel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"}}]})(props);
	};
	module.exports.FaTruckArrowRight = function FaTruckArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"}}]})(props);
	};
	module.exports.FaTruckDroplet = function FaTruckDroplet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"}}]})(props);
	};
	module.exports.FaTruckFast = function FaTruckFast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M112 0C85.5 0 64 21.5 64 48V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 272c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 240c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V416c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zM544 237.3V256H416V160h50.7L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"}}]})(props);
	};
	module.exports.FaTruckFieldUn = function FaTruckFieldUn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 32C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38H375.4C364.4 44.9 343.7 32 320 32H96zm288 96h43.2l42.7 96H384V128zM112 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaTruckField = function FaTruckField (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32 96c0-35.3 28.7-64 64-64H320c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2H544c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96zM384 224h85.9l-42.7-96H384v96zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"}}]})(props);
	};
	module.exports.FaTruckFront = function FaTruckFront (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V368c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432C12.6 417.4 0 394.2 0 368V80zm129.9 72.2L112 224H400l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaTruckMedical = function FaTruckMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H240V80c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaTruckMonster = function FaTruckMonster (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M288 64v64H416L368 64H288zM419.2 25.6L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64H288c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H224V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6zM152 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512H152c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512H472c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"}}]})(props);
	};
	module.exports.FaTruckMoving = function FaTruckMoving (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V304v80 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16H416h33.6c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaTruckPickup = function FaTruckPickup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M368.6 96l76.8 96H288V96h80.6zM224 80V192H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32H65.1c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V224c0-17.7-14.3-32-32-32H527.4L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48zm0 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"}}]})(props);
	};
	module.exports.FaTruckPlane = function FaTruckPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M200 0c-30.6 0-56 54.7-56 86.1V192.5L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15V463.4c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V408 325.5 184l0-1.1 0 0V86.1C256 54.7 231.5 0 200 0zm88 176V400c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V448H544v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V445.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7H539.7c9.2 0 17.2 6 20.5 14.7L576 304H352l15.8-49.3zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM336 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"}}]})(props);
	};
	module.exports.FaTruckRampBox = function FaTruckRampBox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"}}]})(props);
	};
	module.exports.FaTruck = function FaTruck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"}}]})(props);
	};
	module.exports.FaTty = function FaTty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M38.3 241.3L15.1 200.6c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4V144c-49.6-18.1-104-18.1-153.6 0v54.8c0 13.8-8.9 26.1-22 30.4L76.1 255.8c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V336zm0 96c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V432zM144 320h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V432z"}}]})(props);
	};
	module.exports.FaTurkishLiraSign = function FaTurkishLiraSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M96 32c17.7 0 32 14.3 32 32V99.3L247.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480H96c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6V184.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6V64c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaTurnDown = function FaTurnDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26s12.5-14.5 22-14.5h88l0-192c0-17.7-14.3-32-32-32H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0l80 0c70.7 0 128 57.3 128 128l0 192h88c9.6 0 18.2 5.7 22 14.5z"}}]})(props);
	};
	module.exports.FaTurnUp = function FaTurnUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5h88l0 192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192h88c9.6 0 18.2-5.7 22-14.5z"}}]})(props);
	};
	module.exports.FaTv = function FaTv (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaU = function FaU (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"}}]})(props);
	};
	module.exports.FaUmbrellaBeach = function FaUmbrellaBeach (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M346.3 271.8l-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"}}]})(props);
	};
	module.exports.FaUmbrella = function FaUmbrella (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0c17.7 0 32 14.3 32 32V49.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"}}]})(props);
	};
	module.exports.FaUnderline = function FaUnderline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"}}]})(props);
	};
	module.exports.FaUniversalAccess = function FaUniversalAccess (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6V235.5c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"}}]})(props);
	};
	module.exports.FaUnlockKeyhole = function FaUnlockKeyhole (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 64c-44.2 0-80 35.8-80 80v48H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"}}]})(props);
	};
	module.exports.FaUnlock = function FaUnlock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z"}}]})(props);
	};
	module.exports.FaUpDownLeftRight = function FaUpDownLeftRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"}}]})(props);
	};
	module.exports.FaUpDown = function FaUpDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"}}]})(props);
	};
	module.exports.FaUpLong = function FaUpLong (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192H96l0 288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32l0-288h72c9.6 0 18.2-5.7 22-14.5z"}}]})(props);
	};
	module.exports.FaUpRightAndDownLeftFromCenter = function FaUpRightAndDownLeftFromCenter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"}}]})(props);
	};
	module.exports.FaUpRightFromSquare = function FaUpRightFromSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"}}]})(props);
	};
	module.exports.FaUpload = function FaUpload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"}}]})(props);
	};
	module.exports.FaUserAstronaut = function FaUserAstronaut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9V128c0-16.8-12.9-30.5-29.3-31.9zM336 144v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512H128V448c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64l98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"}}]})(props);
	};
	module.exports.FaUserCheck = function FaUserCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"}}]})(props);
	};
	module.exports.FaUserClock = function FaUserClock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"}}]})(props);
	};
	module.exports.FaUserDoctor = function FaUserDoctor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"}}]})(props);
	};
	module.exports.FaUserGear = function FaUserGear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V454.8c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"}}]})(props);
	};
	module.exports.FaUserGraduate = function FaUserGraduate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"}}]})(props);
	};
	module.exports.FaUserGroup = function FaUserGroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"}}]})(props);
	};
	module.exports.FaUserInjured = function FaUserInjured (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M240 80H342.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7V512H243.7L181.5 408.2 124 312.4zm33-7.2L204.3 384H272c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48H223.5l57.1 95.2C303 507.2 320 487.6 320 464z"}}]})(props);
	};
	module.exports.FaUserLargeSlash = function FaUserLargeSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM545.5 512H528L284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H545.3l.3 0z"}}]})(props);
	};
	module.exports.FaUserLarge = function FaUserLarge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 288A144 144 0 1 0 256 0a144 144 0 1 0 0 288zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H481.3c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320H161.3z"}}]})(props);
	};
	module.exports.FaUserLock = function FaUserLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H392.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7H178.3zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"}}]})(props);
	};
	module.exports.FaUserMinus = function FaUserMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaUserNinja = function FaUserNinja (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"}}]})(props);
	};
	module.exports.FaUserNurse = function FaUserNurse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"}}]})(props);
	};
	module.exports.FaUserPen = function FaUserPen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"}}]})(props);
	};
	module.exports.FaUserPlus = function FaUserPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"}}]})(props);
	};
	module.exports.FaUserSecret = function FaUserSecret (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4H342.7c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm56 208H267.6c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40V169.6c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"}}]})(props);
	};
	module.exports.FaUserShield = function FaUserShield (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3H178.3zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8L591.4 312z"}}]})(props);
	};
	module.exports.FaUserSlash = function FaUserSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z"}}]})(props);
	};
	module.exports.FaUserTag = function FaUserTag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2H178.3zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384zm24 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"}}]})(props);
	};
	module.exports.FaUserTie = function FaUserTie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 256A128 128 0 1 1 224 0a128 128 0 1 1 0 256zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3c70.1 17.6 121.9 81 121.9 156.4c0 17-13.8 30.7-30.7 30.7H285.5c-2.1 0-4-.4-5.8-1.1l.3 1.1H168l.3-1.1c-1.8 .7-3.8 1.1-5.8 1.1H30.7C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4c8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9z"}}]})(props);
	};
	module.exports.FaUserXmark = function FaUserXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"}}]})(props);
	};
	module.exports.FaUser = function FaUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"}}]})(props);
	};
	module.exports.FaUsersBetweenLines = function FaUsersBetweenLines (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"}}]})(props);
	};
	module.exports.FaUsersGear = function FaUsersGear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6v-21c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6v21c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"}}]})(props);
	};
	module.exports.FaUsersLine = function FaUsersLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M211.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64zm461.6 32H576c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"}}]})(props);
	};
	module.exports.FaUsersRays = function FaUsersRays (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"}}]})(props);
	};
	module.exports.FaUsersRectangle = function FaUsersRectangle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H544c53 0 96-43 96-96V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm159.8 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3C119.9 256 96 279.9 96 309.3zM461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"}}]})(props);
	};
	module.exports.FaUsersSlash = function FaUsersSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192H106.7zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.5-6 23.9-14.8L324.9 352H261.3zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"}}]})(props);
	};
	module.exports.FaUsersViewfinder = function FaUsersViewfinder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48 48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H32C14.3 0 0 14.3 0 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 17.7 14.3 32 32 32H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H608c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H504z"}}]})(props);
	};
	module.exports.FaUsers = function FaUsers (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"}}]})(props);
	};
	module.exports.FaUtensils = function FaUtensils (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"}}]})(props);
	};
	module.exports.FaV = function FaV (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z"}}]})(props);
	};
	module.exports.FaVanShuttle = function FaVanShuttle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 104v88h96V96H72c-4.4 0-8 3.6-8 8zm482 88L465.1 96H384v96H546zm-226 0V96H224v96h96zM592 384H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104C0 64.2 32.2 32 72 32H192 352 465.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"}}]})(props);
	};
	module.exports.FaVault = function FaVault (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 0C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H80l16 32h64l16-32H400l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM480 221.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"}}]})(props);
	};
	module.exports.FaVectorSquare = function FaVectorSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M368 80h32v32H368V80zM352 32c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM96 160c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32V160zM48 400H80v32H48V400zm320 32V400h32v32H368zM48 112V80H80v32H48z"}}]})(props);
	};
	module.exports.FaVenusDouble = function FaVenusDouble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1c-26.6-4.9-51.1-15.7-72-31.1z"}}]})(props);
	};
	module.exports.FaVenusMars = function FaVenusMars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H208v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"}}]})(props);
	};
	module.exports.FaVenus = function FaVenus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"}}]})(props);
	};
	module.exports.FaVestPatches = function FaVestPatches (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6V128 54.3 48C64 21.5 85.5 0 112 0h4.5c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0H336c26.5 0 48 21.5 48 48v6.3V128v17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280v8 32c0 8.8 7.2 16 16 16h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"}}]})(props);
	};
	module.exports.FaVest = function FaVest (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6V128 54.3 48c0-26.5-21.5-48-48-48h-4.5c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0H112C85.5 0 64 21.5 64 48v6.3V128v17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48H176c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"}}]})(props);
	};
	module.exports.FaVialCircleCheck = function FaVialCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zM96 96v96h64V96H96zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"}}]})(props);
	};
	module.exports.FaVialVirus = function FaVialVirus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V384c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32zM96 192V96h64v96H96zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"}}]})(props);
	};
	module.exports.FaVial = function FaVial (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5V416c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96H205.3z"}}]})(props);
	};
	module.exports.FaVials = function FaVials (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H88h48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64zM136 96H88V256h48V96zM288 64c0-17.7 14.3-32 32-32h56 48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zM424 96H376V256h48V96z"}}]})(props);
	};
	module.exports.FaVideoSlash = function FaVideoSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9V192 320v5.8l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5V384c0 35.3 28.7 64 64 64H352c23.4 0 43.9-12.6 55-31.3z"}}]})(props);
	};
	module.exports.FaVideo = function FaVideo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"}}]})(props);
	};
	module.exports.FaVihara = function FaVihara (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24H576v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H24c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V176 128h-7.5c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128H320 224v64h72 48 72V128zM160 288v64H296h24 24H480V288H344 320h0H296 160z"}}]})(props);
	};
	module.exports.FaVirusCovidSlash = function FaVirusCovidSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zM149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2L149.2 213.5z"}}]})(props);
	};
	module.exports.FaVirusCovid = function FaVirusCovid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V81.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464V216c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H430.4c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V430.4c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280H48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v16H81.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48H216c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"}}]})(props);
	};
	module.exports.FaVirusSlash = function FaVirusSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7z"}}]})(props);
	};
	module.exports.FaVirus = function FaVirus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaViruses = function FaViruses (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}}]})(props);
	};
	module.exports.FaVoicemail = function FaVoicemail (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"}}]})(props);
	};
	module.exports.FaVolcano = function FaVolcano (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1H235.1c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"}}]})(props);
	};
	module.exports.FaVolleyball = function FaVolleyball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"}}]})(props);
	};
	module.exports.FaVolumeHigh = function FaVolumeHigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"}}]})(props);
	};
	module.exports.FaVolumeLow = function FaVolumeLow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"}}]})(props);
	};
	module.exports.FaVolumeOff = function FaVolumeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"}}]})(props);
	};
	module.exports.FaVolumeXmark = function FaVolumeXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"}}]})(props);
	};
	module.exports.FaVrCardboard = function FaVrCardboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M576 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H184.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"}}]})(props);
	};
	module.exports.FaW = function FaW (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"}}]})(props);
	};
	module.exports.FaWalkieTalkie = function FaWalkieTalkie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144V300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V371.9c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32H224c0-17.7-14.3-32-32-32s-32 14.3-32 32H112V24zm0 136H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaWallet = function FaWallet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaWandMagicSparkles = function FaWandMagicSparkles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"}}]})(props);
	};
	module.exports.FaWandMagic = function FaWandMagic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"}}]})(props);
	};
	module.exports.FaWandSparkles = function FaWandSparkles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16H384.2c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"}}]})(props);
	};
	module.exports.FaWarehouse = function FaWarehouse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24V432H512l0 56c0 13.3-10.7 24-24 24zM128 400V336H512v64H128zm0-96V224H512l0 80H128z"}}]})(props);
	};
	module.exports.FaWaterLadder = function FaWaterLadder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V224H384V127.7C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3h0V288H192v96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1V127.7zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"}}]})(props);
	};
	module.exports.FaWater = function FaWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"}}]})(props);
	};
	module.exports.FaWaveSquare = function FaWaveSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V416h96V256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96H192V256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z"}}]})(props);
	};
	module.exports.FaWeightHanging = function FaWeightHanging (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H346.5z"}}]})(props);
	};
	module.exports.FaWeightScale = function FaWeightScale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"}}]})(props);
	};
	module.exports.FaWheatAwnCircleExclamation = function FaWheatAwnCircleExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaWheatAwn = function FaWheatAwn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"}}]})(props);
	};
	module.exports.FaWheelchairMove = function FaWheelchairMove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"}}]})(props);
	};
	module.exports.FaWheelchair = function FaWheelchair (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM120.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464C98.1 464 48 413.9 48 352c0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H282.2l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H259.8z"}}]})(props);
	};
	module.exports.FaWhiskeyGlass = function FaWhiskeyGlass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM87.7 224L69 96H443L424.3 224H87.7z"}}]})(props);
	};
	module.exports.FaWifi = function FaWifi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"}}]})(props);
	};
	module.exports.FaWind = function FaWind (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"}}]})(props);
	};
	module.exports.FaWindowMaximize = function FaWindowMaximize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaWindowMinimize = function FaWindowMinimize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"}}]})(props);
	};
	module.exports.FaWindowRestore = function FaWindowRestore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 64H208c-8.8 0-16 7.2-16 16V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V320h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"}}]})(props);
	};
	module.exports.FaWineBottle = function FaWineBottle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"}}]})(props);
	};
	module.exports.FaWineGlassEmpty = function FaWineGlassEmpty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"}}]})(props);
	};
	module.exports.FaWineGlass = function FaWineGlass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M32.1 29.3C33.5 12.8 47.4 0 64 0H256c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6V448h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H160 80c-17.7 0-32-14.3-32-32s14.3-32 32-32h48V348.4C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7H231.9l-5.3-64H93.4l-5.3 64z"}}]})(props);
	};
	module.exports.FaWonSign = function FaWonSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H72.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1H249zm96 64h26.6l-15.2 45.6L345 288z"}}]})(props);
	};
	module.exports.FaWorm = function FaWorm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 96c0-53 43-96 96-96h38.4C439.9 0 480 40.1 480 89.6V176v16V376c0 75.1-60.9 136-136 136s-136-60.9-136-136V296c0-22.1-17.9-40-40-40s-40 17.9-40 40V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192H352c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"}}]})(props);
	};
	module.exports.FaWrench = function FaWrench (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaXRay = function FaXRay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16v32H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16H240v70.6L189.1 307c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6H316.4c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 326.6V256H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V176h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"}}]})(props);
	};
	module.exports.FaX = function FaX (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"}}]})(props);
	};
	module.exports.FaXmark = function FaXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"}}]})(props);
	};
	module.exports.FaXmarksLines = function FaXmarksLines (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"}}]})(props);
	};
	module.exports.FaY = function FaY (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"}}]})(props);
	};
	module.exports.FaYenSign = function FaYenSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V288h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H219.8L314.6 81.7c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"}}]})(props);
	};
	module.exports.FaYinYang = function FaYinYang (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaZ = function FaZ (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 64C0 46.3 14.3 32 32 32H352c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z"}}]})(props);
	};
	module.exports.FaRegAddressBook = function FaRegAddressBook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H208zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"}}]})(props);
	};
	module.exports.FaRegAddressCard = function FaRegAddressCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H176zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"}}]})(props);
	};
	module.exports.FaRegBellSlash = function FaRegBellSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V49.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zM221.7 148.4C239.6 117.1 273.3 96 312 96h8 8c57.4 0 104 46.6 104 104v33.4c0 32.7 6.4 64.8 18.7 94.5L221.7 148.4zM406.2 416l-60.9-48H168.3c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1v11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6H406.2zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"}}]})(props);
	};
	module.exports.FaRegBell = function FaRegBell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"}}]})(props);
	};
	module.exports.FaRegBookmark = function FaRegBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 48C0 21.5 21.5 0 48 0l0 48V441.4l130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4V48H48V0H336c26.5 0 48 21.5 48 48V488c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488V48z"}}]})(props);
	};
	module.exports.FaRegBuilding = function FaRegBuilding (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V104zM232 88h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V232zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaRegCalendarCheck = function FaRegCalendarCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"}}]})(props);
	};
	module.exports.FaRegCalendarDays = function FaRegCalendarDays (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"}}]})(props);
	};
	module.exports.FaRegCalendarMinus = function FaRegCalendarMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 0c13.3 0 24 10.7 24 24V64H328V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 144 128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zM432 192H80V448c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V192zM328 352H184c-13.3 0-24-10.7-24-24s10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24z"}}]})(props);
	};
	module.exports.FaRegCalendarPlus = function FaRegCalendarPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H96c-35.3 0-64 28.7-64 64v16 48V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H376V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H184V24zM80 192H432V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V192zm176 40c-13.3 0-24 10.7-24 24v48H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V352h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V256c0-13.3-10.7-24-24-24z"}}]})(props);
	};
	module.exports.FaRegCalendarXmark = function FaRegCalendarXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 0c13.3 0 24 10.7 24 24V64H328V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 144 128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zM432 192H80V448c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V192zm-95 89l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"}}]})(props);
	};
	module.exports.FaRegCalendar = function FaRegCalendar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"}}]})(props);
	};
	module.exports.FaRegChartBar = function FaRegChartBar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaRegChessBishop = function FaRegChessBishop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2c-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8V352H96V325c0-9-5-17.2-13-21.3c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7c-8 4.1-13 12.3-13 21.3v27h48V338.7c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8.3-9.9-16.6-19-24.4-27c10.3-2.7 18-12.1 18-23.2c0-13.3-10.7-24-24-24H160 104zM52.7 464l16.6-32H250.8l16.6 32H52.7zm207.9-80H59.5c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512H279.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"}}]})(props);
	};
	module.exports.FaRegChessKing = function FaRegChessKing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V56H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v40H59.6C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352h52.3L49 208.2c-.6-1.5-1-3-1-4.6c0-6.4 5.2-11.6 11.6-11.6H224 388.4c6.4 0 11.6 5.2 11.6 11.6c0 1.6-.3 3.2-1 4.6L336.5 352h52.3l54.2-124.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6H248V104h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V24zM101.2 432H346.8l16.6 32H84.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3H91.5c-12 0-22.9 6.7-28.4 17.3L36.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C32 493.8 50.2 512 72.8 512H375.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"}}]})(props);
	};
	module.exports.FaRegChessKnight = function FaRegChessKnight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M226.6 48H117.3l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1H66.8c5.3-22.1 17.8-41.9 35.9-56.3c-1.3-.8-2.6-1.7-3.8-2.6L97 291.8c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3C64 20.3 84.3 0 109.3 0H226.6C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2L390.1 352H341.3l24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432L68.7 464H379.3l-16.6-32H85.2zm315.7-30.7l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H56.8C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C52.5 390.7 63.5 384 75.5 384h297c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"}}]})(props);
	};
	module.exports.FaRegChessPawn = function FaRegChessPawn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120H243.4l10.7 80H205.7L195 272H160 125l-10.7 80H65.9l10.7-80H64c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464H267.3l-16.6-32H69.2L52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384h201z"}}]})(props);
	};
	module.exports.FaRegChessQueen = function FaRegChessQueen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9c-8 26.2-32.4 45.2-61.2 45.2c-10 0-19.4-2.3-27.7-6.3c-7.6-3.7-16.7-3.3-24 1.2C.7 162.1-3.1 177.1 3.7 188.9L97.6 352H153l-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352h55.4l93.9-163.1c6.8-11.7 3-26.7-8.6-33.8c-7.3-4.5-16.4-4.9-24-1.2c-8.4 4-17.7 6.3-27.7 6.3c-28.8 0-53.2-19-61.2-45.2C382.5 100.8 369.3 88 351.2 88c-14.5 0-26.3 8.5-32.4 19.3c-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zM133.2 432H378.8l16.6 32H116.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3h-265c-12 0-22.9 6.7-28.4 17.3L68.6 452.5c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8H407.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"}}]})(props);
	};
	module.exports.FaRegChessRook = function FaRegChessRook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M80 80V192c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352H85.2l9.4-85L54.4 236.8C40.3 226.2 32 209.6 32 192V72c0-22.1 17.9-40 40-40H376c22.1 0 40 17.9 40 40V192c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85H314.5l-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4V80H304v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H192v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H80zm4.7 384H363.3l-16.6-32H101.2L84.7 464zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H72.8C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C68.5 390.7 79.5 384 91.5 384h265zM208 288c-8.8 0-16-7.2-16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 8.8-7.2 16-16 16H208z"}}]})(props);
	};
	module.exports.FaRegCircleCheck = function FaRegCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"}}]})(props);
	};
	module.exports.FaRegCircleDot = function FaRegCircleDot (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"}}]})(props);
	};
	module.exports.FaRegCircleDown = function FaRegCircleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3H304V160c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32v96H150.3C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z"}}]})(props);
	};
	module.exports.FaRegCircleLeft = function FaRegCircleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3V304h96c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H256V150.3c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"}}]})(props);
	};
	module.exports.FaRegCirclePause = function FaRegCirclePause (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"}}]})(props);
	};
	module.exports.FaRegCirclePlay = function FaRegCirclePlay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9V168c0-8.7 4.7-16.7 12.3-20.9z"}}]})(props);
	};
	module.exports.FaRegCircleQuestion = function FaRegCircleQuestion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaRegCircleRight = function FaRegCircleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1c-4.2-4.5-10.1-7.1-16.3-7.1C266 128 256 138 256 150.3V208H160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h96v57.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8L294.6 135.1z"}}]})(props);
	};
	module.exports.FaRegCircleStop = function FaRegCircleStop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"}}]})(props);
	};
	module.exports.FaRegCircleUp = function FaRegCircleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3c0 12.3 10 22.3 22.3 22.3H208v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h57.7c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L269.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5L135.1 217.4z"}}]})(props);
	};
	module.exports.FaRegCircleUser = function FaRegCircleUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"}}]})(props);
	};
	module.exports.FaRegCircleXmark = function FaRegCircleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"}}]})(props);
	};
	module.exports.FaRegCircle = function FaRegCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"}}]})(props);
	};
	module.exports.FaRegClipboard = function FaRegClipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"}}]})(props);
	};
	module.exports.FaRegClock = function FaRegClock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"}}]})(props);
	};
	module.exports.FaRegClone = function FaRegClone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 464H288c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM224 304H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16zm-64-16V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"}}]})(props);
	};
	module.exports.FaRegClosedCaptioning = function FaRegClosedCaptioning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"}}]})(props);
	};
	module.exports.FaRegCommentDots = function FaRegCommentDots (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaRegComment = function FaRegComment (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9c.1-.2 .2-.3 .3-.5z"}}]})(props);
	};
	module.exports.FaRegComments = function FaRegComments (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.7 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"}}]})(props);
	};
	module.exports.FaRegCompass = function FaRegCompass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}}]})(props);
	};
	module.exports.FaRegCopy = function FaRegCopy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z"}}]})(props);
	};
	module.exports.FaRegCopyright = function FaRegCopyright (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"}}]})(props);
	};
	module.exports.FaRegCreditCard = function FaRegCreditCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M512 80c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H512zm16 144V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"}}]})(props);
	};
	module.exports.FaRegEnvelopeOpen = function FaRegEnvelopeOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5v13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1V200.5c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2V456c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V276.2zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5V456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V200.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"}}]})(props);
	};
	module.exports.FaRegEnvelope = function FaRegEnvelope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"}}]})(props);
	};
	module.exports.FaRegEyeSlash = function FaRegEyeSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"}}]})(props);
	};
	module.exports.FaRegEye = function FaRegEye (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"}}]})(props);
	};
	module.exports.FaRegFaceAngry = function FaRegFaceAngry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"}}]})(props);
	};
	module.exports.FaRegFaceDizzy = function FaRegFaceDizzy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"}}]})(props);
	};
	module.exports.FaRegFaceFlushed = function FaRegFaceFlushed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"}}]})(props);
	};
	module.exports.FaRegFaceFrownOpen = function FaRegFaceFrownOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaRegFaceFrown = function FaRegFaceFrown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaRegFaceGrimace = function FaRegFaceGrimace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V320h-8zm40 48h32V320H208v48zm96 0V320H272v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zM168 288H344c30.9 0 56 25.1 56 56s-25.1 56-56 56H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaRegFaceGrinBeamSweat = function FaRegFaceGrinBeamSweat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476.8 126.3C497.1 120.8 512 102.7 512 81c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-9.5 12.6-27.1 37.2-36 57.5c-.3 .7-.6 1.4-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM395.4 41.2C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"}}]})(props);
	};
	module.exports.FaRegFaceGrinBeam = function FaRegFaceGrinBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM217.6 228.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"}}]})(props);
	};
	module.exports.FaRegFaceGrinHearts = function FaRegFaceGrinHearts (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"}}]})(props);
	};
	module.exports.FaRegFaceGrinSquintTears = function FaRegFaceGrinSquintTears (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2zM75 75C158.2-8.3 284.5-22.2 382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-3.1 12.2-5.5 24.6-7.3 35c-80.8-53.6-190.7-44.8-261.9 26.4C37.7 180.1 28.9 290 82.5 370.8c-10.5 1.8-22.9 4.2-35 7.3c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c3.1-12.2 5.5-24.6 7.3-35c80.8 53.6 190.7 44.8 261.9-26.4c71.2-71.2 80-181.1 26.4-261.9c10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9c9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9c25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4c-6.3-6.3-3.6-17.2 4.9-19.8zm193-178.2c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z"}}]})(props);
	};
	module.exports.FaRegFaceGrinSquint = function FaRegFaceGrinSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"}}]})(props);
	};
	module.exports.FaRegFaceGrinStars = function FaRegFaceGrinStars (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM183.2 132.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L176 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L242.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L336 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L402.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z"}}]})(props);
	};
	module.exports.FaRegFaceGrinTears = function FaRegFaceGrinTears (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M516.1 325.5c1 3 2.1 6 3.3 8.9c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5c-6.7-3.1-14.3-4.3-22.3-3.1c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-8-1.2-15.7 .1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zM439 336.5C414.4 374.6 370.3 400 319.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zm160 0l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0z"}}]})(props);
	};
	module.exports.FaRegFaceGrinTongueSquint = function FaRegFaceGrinTongueSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V392.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"}}]})(props);
	};
	module.exports.FaRegFaceGrinTongueWink = function FaRegFaceGrinTongueWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4V363.5c8.8-8 16.6-17.1 23-27c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c6.5 10 14.3 19.1 23.1 27.1V416c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64V378.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"}}]})(props);
	};
	module.exports.FaRegFaceGrinTongue = function FaRegFaceGrinTongue (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V363.6c-8.9-8-16.7-17.1-23.1-27.1c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1c-6.4 9.9-14.2 19-23 27V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"}}]})(props);
	};
	module.exports.FaRegFaceGrinWide = function FaRegFaceGrinWide (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"}}]})(props);
	};
	module.exports.FaRegFaceGrinWink = function FaRegFaceGrinWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"}}]})(props);
	};
	module.exports.FaRegFaceGrin = function FaRegFaceGrin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaRegFaceKissBeam = function FaRegFaceKissBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"}}]})(props);
	};
	module.exports.FaRegFaceKissWinkHeart = function FaRegFaceKissWinkHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"}}]})(props);
	};
	module.exports.FaRegFaceKiss = function FaRegFaceKiss (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaRegFaceLaughBeam = function FaRegFaceLaughBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"}}]})(props);
	};
	module.exports.FaRegFaceLaughSquint = function FaRegFaceLaughSquint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"}}]})(props);
	};
	module.exports.FaRegFaceLaughWink = function FaRegFaceLaughWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"}}]})(props);
	};
	module.exports.FaRegFaceLaugh = function FaRegFaceLaugh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaRegFaceMehBlank = function FaRegFaceMehBlank (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaRegFaceMeh = function FaRegFaceMeh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"}}]})(props);
	};
	module.exports.FaRegFaceRollingEyes = function FaRegFaceRollingEyes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 376c0 13.3 10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"}}]})(props);
	};
	module.exports.FaRegFaceSadCry = function FaRegFaceSadCry (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 406.1V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V440.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V406.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM208 320v32c0 26.5 21.5 48 48 48s48-21.5 48-48V320c0-26.5-21.5-48-48-48s-48 21.5-48 48z"}}]})(props);
	};
	module.exports.FaRegFaceSadTear = function FaRegFaceSadTear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C156.6 308.6 128 349 128 369zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6c9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9C338.3 320.2 299 304 256 304zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"}}]})(props);
	};
	module.exports.FaRegFaceSmileBeam = function FaRegFaceSmileBeam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"}}]})(props);
	};
	module.exports.FaRegFaceSmileWink = function FaRegFaceSmileWink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"}}]})(props);
	};
	module.exports.FaRegFaceSmile = function FaRegFaceSmile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"}}]})(props);
	};
	module.exports.FaRegFaceSurprise = function FaRegFaceSurprise (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"}}]})(props);
	};
	module.exports.FaRegFaceTired = function FaRegFaceTired (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"}}]})(props);
	};
	module.exports.FaRegFileAudio = function FaRegFileAudio (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 464H320c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 272V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376H112c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h17.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z"}}]})(props);
	};
	module.exports.FaRegFileCode = function FaRegFileCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM257 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"}}]})(props);
	};
	module.exports.FaRegFileExcel = function FaRegFileExcel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"}}]})(props);
	};
	module.exports.FaRegFileImage = function FaRegFileImage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2h48 32 40 72c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"}}]})(props);
	};
	module.exports.FaRegFileLines = function FaRegFileLines (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"}}]})(props);
	};
	module.exports.FaRegFilePdf = function FaRegFilePdf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"}}]})(props);
	};
	module.exports.FaRegFilePowerpoint = function FaRegFilePowerpoint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm72 208c-13.3 0-24 10.7-24 24V336v56c0 13.3 10.7 24 24 24s24-10.7 24-24V360h44c42 0 76-34 76-76s-34-76-76-76H136zm68 104H160V256h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z"}}]})(props);
	};
	module.exports.FaRegFileVideo = function FaRegFileVideo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM80 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v16l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V288z"}}]})(props);
	};
	module.exports.FaRegFileWord = function FaRegFileWord (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"}}]})(props);
	};
	module.exports.FaRegFileZipper = function FaRegFileZipper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16h48v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm48 112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm-6.3 71.8L82.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8H136.6c-14.5 0-27.2 9.7-30.9 23.8zM128 336h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaRegFile = function FaRegFile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"}}]})(props);
	};
	module.exports.FaRegFlag = function FaRegFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24V64 350.5 400v88c0 13.3 10.7 24 24 24s24-10.7 24-24V388l80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52V24zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8V334.7l-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5v-237z"}}]})(props);
	};
	module.exports.FaRegFloppyDisk = function FaRegFloppyDisk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"}}]})(props);
	};
	module.exports.FaRegFolderClosed = function FaRegFolderClosed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zM48 240H464V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V240zM285.7 93.7L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3z"}}]})(props);
	};
	module.exports.FaRegFolderOpen = function FaRegFolderOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16H181.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H87.7 384z"}}]})(props);
	};
	module.exports.FaRegFolder = function FaRegFolder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z"}}]})(props);
	};
	module.exports.FaRegFontAwesome = function FaRegFontAwesome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V124.2l12.5-2.4c16.7-3.2 31.5-8.5 44.2-13.1l0 0 0 0c3.7-1.3 7.1-2.6 10.4-3.7c15.2-5.2 30.4-9.1 51.2-9.1c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c32.4 0 53.7-6.8 90.5-19.6V342.9l-9.5 3.3c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-16.8 0-31 2-43.9 5c-12.9 3-20.9 16-17.9 28.9s16 20.9 28.9 17.9c9.6-2.2 20.1-3.7 32.9-3.7c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c34.4 0 56.4-7.7 97.8-22.2c7.5-2.6 15.5-5.4 24.4-8.5l16.2-5.5V360 72 38.4L416.2 49.3c-9.7 3.3-18.2 6.3-25.7 8.9c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-27.8 0-48.5 5.5-66.6 11.6c-4.9 1.7-9.3 3.3-13.6 4.8c-11.9 4.3-22 7.9-34.7 10.3L48 75.4V56z"}}]})(props);
	};
	module.exports.FaRegFutbol = function FaRegFutbol (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M435.4 361.3l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.1zM256 48l.9 0h-1.8l.9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.7 2-4 2.9l4-2.9zm75.2-226.6l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"}}]})(props);
	};
	module.exports.FaRegGem = function FaRegGem (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"}}]})(props);
	};
	module.exports.FaRegHandBackFist = function FaRegHandBackFist (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16V264c0 31.3-20 58-48 67.9c-9.6 3.4-16 12.5-16 22.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V370.2c38-20.1 64-60.1 64-106.2V160c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5C332.8 77.1 311.9 64 288 64c-2.8 0-5.6 .2-8.3 .5C268.8 45.1 247.9 32 224 32c-2.8 0-5.6 .2-8.3 .5C204.8 13.1 183.9 0 160 0C124.7 0 96 28.7 96 64v64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6v12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7L96.8 361.9l8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V359.9c0-12.6-9.8-23.1-22.4-23.9c-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4V224.6c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6V208c0 8.8 7.2 16 16 16s16-7.2 16-16V142.3 128 64z"}}]})(props);
	};
	module.exports.FaRegHandLizard = function FaRegHandLizard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24H240c35.3 0 64 28.7 64 64s-28.7 64-64 64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24H288c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V413.3L281.1 384H136c-39.8 0-72-32.2-72-72s32.2-72 72-72H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H72c-39.8 0-72-32.2-72-72S32.2 64 72 64H281.6c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V316.1c0-23.2-7.8-45.8-22.1-64.1L363.5 151.9c-19.7-25.2-49.9-39.9-81.9-39.9H72z"}}]})(props);
	};
	module.exports.FaRegHandPeace = function FaRegHandPeace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119 156.7 69.6C145 36.3 108.4 18.8 75.1 30.5S24.2 78.8 35.9 112.1L88.7 262.2C73.5 276.7 64 297.3 64 320v0 24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V272 256 224c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-.7 0-1.5 0-2.2 0l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192v48c0 .7 0 1.4 0 2c-5.1-1.3-10.5-2-16-2h-7.4l-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2s15.2 8.8 14.2 17.6l-9.5 90.1zM111.4 85.6L165.7 240H144c-4 0-8 .3-11.9 .9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192zm38.4 108c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2v10c0 66.3-53.7 120-120 120H232c-66.3 0-120-53.7-120-120l0-24 0 0c0-17.7 14.3-32 32-32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4zM400 272c0 8.8-7.2 16-16 16s-16-7.2-16-16V240 224c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16z"}}]})(props);
	};
	module.exports.FaRegHandPointDown = function FaRegHandPointDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 448l0-177.6c5.2 1 10.5 1.6 16 1.6l16 0 0 32 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16zM80 224c-17.7 0-32-14.3-32-32c0 0 0 0 0 0l0-24c0-66.3 53.7-120 120-120l48 0c52.5 0 97.1 33.7 113.4 80.7c-3.1-.5-6.2-.7-9.4-.7c-20 0-37.9 9.2-49.7 23.6c-9-4.9-19.4-7.6-30.3-7.6c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0-40 0zM0 192s0 0 0 0c0 18 6 34.6 16 48l0 208c0 35.3 28.7 64 64 64s64-28.7 64-64l0-82c5.1 1.3 10.5 2 16 2c25.3 0 47.2-14.7 57.6-36c7 2.6 14.5 4 22.4 4c20 0 37.9-9.2 49.7-23.6c9 4.9 19.4 7.6 30.3 7.6c35.3 0 64-28.7 64-64l0-64 0-24C384 75.2 308.8 0 216 0L168 0C75.2 0 0 75.2 0 168l0 24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM160 272c5.5 0 10.9-.7 16-2l0 2 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 16 0zm64-24l0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24z"}}]})(props);
	};
	module.exports.FaRegHandPointLeft = function FaRegHandPointLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 128l177.6 0c-1 5.2-1.6 10.5-1.6 16l0 16-32 0L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32c0 0 0 0 0 0l24 0c66.3 0 120 53.7 120 120l0 48c0 52.5-33.7 97.1-80.7 113.4c.5-3.1 .7-6.2 .7-9.4c0-20-9.2-37.9-23.6-49.7c4.9-9 7.6-19.4 7.6-30.3c0-15.1-5.3-29-14-40c8.8-11 14-24.9 14-40l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-40zm32-80s0 0 0 0c-18 0-34.6 6-48 16L64 80C28.7 80 0 108.7 0 144s28.7 64 64 64l82 0c-1.3 5.1-2 10.5-2 16c0 25.3 14.7 47.2 36 57.6c-2.6 7-4 14.5-4 22.4c0 20 9.2 37.9 23.6 49.7c-4.9 9-7.6 19.4-7.6 30.3c0 35.3 28.7 64 64 64l64 0 24 0c92.8 0 168-75.2 168-168l0-48c0-92.8-75.2-168-168-168l-24 0zM256 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zM240 224c0 5.5 .7 10.9 2 16l-2 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0 16zm24 64l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0z"}}]})(props);
	};
	module.exports.FaRegHandPointRight = function FaRegHandPointRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 128l-177.6 0c1 5.2 1.6 10.5 1.6 16l0 16 32 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 144c0-17.7-14.3-32-32-32c0 0 0 0 0 0l-24 0c-66.3 0-120 53.7-120 120l0 48c0 52.5 33.7 97.1 80.7 113.4c-.5-3.1-.7-6.2-.7-9.4c0-20 9.2-37.9 23.6-49.7c-4.9-9-7.6-19.4-7.6-30.3c0-15.1 5.3-29 14-40c-8.8-11-14-24.9-14-40l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 0-40zM192 64s0 0 0 0c18 0 34.6 6 48 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-82 0c1.3 5.1 2 10.5 2 16c0 25.3-14.7 47.2-36 57.6c2.6 7 4 14.5 4 22.4c0 20-9.2 37.9-23.6 49.7c4.9 9 7.6 19.4 7.6 30.3c0 35.3-28.7 64-64 64l-64 0-24 0C75.2 448 0 372.8 0 280l0-48C0 139.2 75.2 64 168 64l24 0zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm16-176c0 5.5-.7 10.9-2 16l2 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 16zm-24 64l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0z"}}]})(props);
	};
	module.exports.FaRegHandPointUp = function FaRegHandPointUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M64 64V241.6c5.2-1 10.5-1.6 16-1.6H96V208 64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM80 288c-17.7 0-32 14.3-32 32c0 0 0 0 0 0v24c0 66.3 53.7 120 120 120h48c52.5 0 97.1-33.7 113.4-80.7c-3.1 .5-6.2 .7-9.4 .7c-20 0-37.9-9.2-49.7-23.6c-9 4.9-19.4 7.6-30.3 7.6c-15.1 0-29-5.3-40-14c-11 8.8-24.9 14-40 14H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H120 80zM0 320s0 0 0 0c0-18 6-34.6 16-48V64C16 28.7 44.7 0 80 0s64 28.7 64 64v82c5.1-1.3 10.5-2 16-2c25.3 0 47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c20 0 37.9 9.2 49.7 23.6c9-4.9 19.4-7.6 30.3-7.6c35.3 0 64 28.7 64 64v64 24c0 92.8-75.2 168-168 168H168C75.2 512 0 436.8 0 344V320zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48 16c0 8.8 7.2 16 16 16s16-7.2 16-16V256zM160 240c5.5 0 10.9 .7 16 2v-2V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h16zm64 24v40c0 8.8 7.2 16 16 16s16-7.2 16-16V256 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v24z"}}]})(props);
	};
	module.exports.FaRegHandPointer = function FaRegHandPointer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16V200c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16V392c0 39.8-32.2 72-72 72H272 212.3h-.9c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V320 64zM176 0c-35.3 0-64 28.7-64 64V261.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2h.9H272h56c66.3 0 120-53.7 120-120V288l0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5V64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"}}]})(props);
	};
	module.exports.FaRegHandScissors = function FaRegHandScissors (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1L57 208.1C22.5 200.5 .7 166.3 8.3 131.8S50.2 75.5 84.7 83.2l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 344c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-.8 0-1.6 0-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8 .3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6 .6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12l-85.6-19.7L74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2L63.6 258.1z"}}]})(props);
	};
	module.exports.FaRegHandSpock = function FaRegHandSpock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9c31.4 6 53 33.9 52 64.9c10-2.6 20.8-2.8 31.5-.1c34.3 8.6 55.1 43.3 46.6 77.6L486.7 397.2C469.8 464.7 409.2 512 339.6 512c-11.2 0-22.5 0-33.7 0c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2L100.5 167.5c-13-32.9 3.2-70.1 36-83c11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9L174.9 138.1c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8c11.2 0 22.5 0 33.7 0c47.5 0 89-32.4 100.5-78.5l55.4-221.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7L352.5 260c-2.2 11.6-12.4 20-24.2 20c-11 0-20.7-7.3-23.7-17.9L247.4 59.6z"}}]})(props);
	};
	module.exports.FaRegHand = function FaRegHand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64V261.5l-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75H296h8c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5V160c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2V96c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1c0 0 0-.1 0-.1V64c0-8.8 7.2-16 16-16s16 7.2 16 16V95.9c0 0 0 .1 0 .1V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16v55.9c0 0 0 .1 0 .1v80c0 13.3 10.7 24 24 24s24-10.7 24-24V160.1c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16V332.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2H296h-8.5c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96.1z"}}]})(props);
	};
	module.exports.FaRegHandshake = function FaRegHandshake (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176H96V304c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128H544h40 40c8.8 0 16 7.2 16 16V352c0 17.7-14.3 32-32 32H576c-11.8 0-22.2-6.4-27.7-16H463.4c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384H32c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16H56 96h19.8c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64H259c4.4 0 8.9 .2 13.2 .6zM544 320V176H496c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1H544zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"}}]})(props);
	};
	module.exports.FaRegHardDrive = function FaRegHardDrive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 80c-8.8 0-16 7.2-16 16V258c5.1-1.3 10.5-2 16-2H448c5.5 0 10.9 .7 16 2V96c0-8.8-7.2-16-16-16H64zM48 320v96c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM0 320V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V320v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"}}]})(props);
	};
	module.exports.FaRegHeart = function FaRegHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"}}]})(props);
	};
	module.exports.FaRegHospital = function FaRegHospital (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M232 0c-39.8 0-72 32.2-72 72v8H72C32.2 80 0 112.2 0 152V440c0 39.8 32.2 72 72 72h.2 .2 .2 .2 .2H73h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H75h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H77h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H79h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H82h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H85h.2 .2 .2 .2H86h.2 .2 .2 .2H87h.2 .2 .2 .2H88h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H98h.2 .2 .2 .2H99h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2v0H456h8v0H568c39.8 0 72-32.2 72-72V152c0-39.8-32.2-72-72-72H480V72c0-39.8-32.2-72-72-72H232zM480 128h88c13.3 0 24 10.7 24 24v40H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v48H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56V440c0 13.3-10.7 24-24 24H480V336 128zM72 128h88V464h-.1-.2-.2-.2H159h-.2-.2-.2H158h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H154h-.2-.2-.2H153h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H150h-.2-.2-.2H149h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H146h-.2-.2-.2H145h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H142h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H139h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H136h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H133h-.2-.2-.2-.2-.2-.2-.2-.2H131h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H128h-.2-.2-.2-.2-.2-.2-.2-.2H126h-.2-.2-.2-.2-.2-.2-.2-.2H124h-.2-.2-.2-.2-.2-.2-.2-.2H122h-.2-.2-.2-.2-.2-.2-.2-.2H120h-.2-.2-.2-.2-.2-.2-.2-.2H118h-.2-.2-.2-.2-.2-.2-.2-.2H116h-.2-.2-.2-.2-.2-.2-.2-.2H114h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H111h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H108h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H105h-.2-.2-.2-.2H104h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H100h-.2-.2-.2-.2H99h-.2-.2-.2-.2H98h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H88h-.2-.2-.2-.2H87h-.2-.2-.2-.2H86h-.2-.2-.2-.2H85h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H82h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H79h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H77h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H75h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H73h-.2-.2-.2-.2-.2H72c-13.2 0-24-10.7-24-24V336h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V240h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V152c0-13.3 10.7-24 24-24zM208 72c0-13.3 10.7-24 24-24H408c13.3 0 24 10.7 24 24V336 464H368V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H208V72zm88 24v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168h24c8.8 0 16-7.2 16-16V136c0-8.8-7.2-16-16-16H344V96c0-8.8-7.2-16-16-16H312c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaRegHourglassHalf = function FaRegHourglassHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 24C0 10.7 10.7 0 24 0H360c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V67c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445v19h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V445c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67V48H24C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5H284.2c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67V48H80V67c0 22.1 7 43.4 19.8 61H284.2z"}}]})(props);
	};
	module.exports.FaRegHourglass = function FaRegHourglass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V67c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445v19H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V445c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM192 289.9l81.5 81.5C293 391 304 417.4 304 445v19H80V445c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67V48H304V67c0 27.6-11 54-30.5 73.5L192 222.1z"}}]})(props);
	};
	module.exports.FaRegIdBadge = function FaRegIdBadge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M256 48V64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H256zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"}}]})(props);
	};
	module.exports.FaRegIdCard = function FaRegIdCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 160V416c0 8.8-7.2 16-16 16H320c0-44.2-35.8-80-80-80H176c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V160H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"}}]})(props);
	};
	module.exports.FaRegImage = function FaRegImage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"}}]})(props);
	};
	module.exports.FaRegImages = function FaRegImages (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M160 80H512c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H490.8L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM96 96V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}}]})(props);
	};
	module.exports.FaRegKeyboard = function FaRegKeyboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 320H400c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16z"}}]})(props);
	};
	module.exports.FaRegLemon = function FaRegLemon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M368 80c-3.2 0-6.2 .4-8.9 1.3C340 86.8 313 91.9 284.8 84.6C227.4 69.7 160.2 92 110.1 142.1S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3c-.8 2.8-1.3 5.8-1.3 8.9c0 17.7 14.3 32 32 32c3.2 0 6.2-.4 8.9-1.3c19.1-5.5 46.1-10.7 74.3-3.3c57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3c.8-2.8 1.3-5.8 1.3-8.9c0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80c0 7.7-1.1 15.2-3.1 22.3c-4.6 15.8-7.1 32.9-3 48.9c20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3c-7.1 2-14.6 3.1-22.3 3.1c-44.2 0-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.3c4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3c7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7c-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3c12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"}}]})(props);
	};
	module.exports.FaRegLifeRing = function FaRegLifeRing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"}}]})(props);
	};
	module.exports.FaRegLightbulb = function FaRegLightbulb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H226.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80V416H272v16c0 44.2-35.8 80-80 80z"}}]})(props);
	};
	module.exports.FaRegMap = function FaRegMap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5V421.2l120-45.7V90.8L48 136.5zM360 422.7V137.3l-144-48V374.7l144 48zm48-1.5l120-45.7V90.8L408 136.5V421.2z"}}]})(props);
	};
	module.exports.FaRegMessage = function FaRegMessage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 368c26.5 0 48 21.5 48 48v16l72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16h96zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V474.7v-6.4V468v-4V416H112 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L208 492z"}}]})(props);
	};
	module.exports.FaRegMoneyBill1 = function FaRegMoneyBill1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 112c0 35.3-28.7 64-64 64V336c35.3 0 64 28.7 64 64H464c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-48c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24 24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"}}]})(props);
	};
	module.exports.FaRegMoon = function FaRegMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"}}]})(props);
	};
	module.exports.FaRegNewspaper = function FaRegNewspaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M168 80c-13.3 0-24 10.7-24 24V408c0 8.4-1.4 16.5-4.1 24H440c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H168zM72 480c-39.8 0-72-32.2-72-72V112C0 98.7 10.7 88 24 88s24 10.7 24 24V408c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-39.8 32.2-72 72-72H440c39.8 0 72 32.2 72 72V408c0 39.8-32.2 72-72 72H72zM176 136c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V136zm200-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaRegNoteSticky = function FaRegNoteSticky (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H288V352c0-17.7 14.3-32 32-32h80V96c0-8.8-7.2-16-16-16H64zM288 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320v5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7H288z"}}]})(props);
	};
	module.exports.FaRegObjectGroup = function FaRegObjectGroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16H460.2c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8V396.2c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16H115.8c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8V115.8zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3V386.7c13.6 4.8 24.4 15.6 29.3 29.3H450.7c4.8-13.6 15.6-24.4 29.3-29.3V125.3c-13.6-4.8-24.4-15.6-29.3-29.3H125.3zm2.7 64c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"}}]})(props);
	};
	module.exports.FaRegObjectUngroup = function FaRegObjectUngroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48.2 66.8c-.1-.8-.2-1.7-.2-2.5c0-.1 0-.1 0-.2c0-8.8 7.2-16 16-16c.9 0 1.9 .1 2.8 .2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16c-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3V228.7C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H324.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V123.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H123.3C113.9 16.5 90.9 0 64 0C28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM324.7 88c6.5 16 19.3 28.9 35.3 35.3V228.7c-16 6.5-28.9 19.3-35.3 35.3H123.3c-6.5-16-19.3-28.9-35.3-35.3V123.3c16-6.5 28.9-19.3 35.3-35.3H324.7zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8c-.8 .1-1.7 .2-2.5 .2l-.2 0c-8.8 0-16-7.2-16-16c0-.9 .1-1.9 .2-2.8C49.5 277.7 56.1 272 64 272c8.8 0 16 7.2 16 16zm391.3-40h45.4c6.5 16 19.3 28.9 35.3 35.3V388.7c-16 6.5-28.9 19.3-35.3 35.3H315.3c-6.5-16-19.3-28.9-35.3-35.3V352H232v36.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H516.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V283.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H448v16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1 -31.5-5.5zM271.8 450.7a16 16 0 1 1 -31.5-5.5 16 16 0 1 1 31.5 5.5zm301.5 13c-7.5-1.3-13.2-7.9-13.2-15.8c0-8.8 7.2-16 16-16c7.9 0 14.5 5.7 15.8 13.2l0 .1c.1 .9 .2 1.8 .2 2.7c0 8.8-7.2 16-16 16c-.9 0-1.9-.1-2.8-.2z"}}]})(props);
	};
	module.exports.FaRegPaperPlane = function FaRegPaperPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"}}]})(props);
	};
	module.exports.FaRegPaste = function FaRegPaste (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 96v16c0 17.7 14.3 32 32 32h60.8c16.6-28.7 47.6-48 83.2-48h62c-7.1-27.6-32.2-48-62-48H215.4C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48H64C28.7 48 0 76.7 0 112V384c0 35.3 28.7 64 64 64h96V400H64c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H80zm64-40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 464c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H384v48c0 17.7 14.3 32 32 32h48V448c0 8.8-7.2 16-16 16H256zm192 48c35.3 0 64-28.7 64-64V227.9c0-12.7-5.1-24.9-14.1-33.9l-51.9-51.9c-9-9-21.2-14.1-33.9-14.1H256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448z"}}]})(props);
	};
	module.exports.FaRegPenToSquare = function FaRegPenToSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"}}]})(props);
	};
	module.exports.FaRegRectangleList = function FaRegRectangleList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"}}]})(props);
	};
	module.exports.FaRegRectangleXmark = function FaRegRectangleXmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"}}]})(props);
	};
	module.exports.FaRegRegistered = function FaRegRegistered (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152V264v96c0 13.3 10.7 24 24 24s24-10.7 24-24V288h60.9l37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80H184c-13.3 0-24 10.7-24 24zm48 88V176h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H208z"}}]})(props);
	};
	module.exports.FaRegShareFromSquare = function FaRegShareFromSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M400 255.4V240 208c0-8.8-7.2-16-16-16H352 336 289.5c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112h48 16 32c8.8 0 16-7.2 16-16V80 64.6L506 160 400 255.4zM336 240h16v48c0 17.7 14.3 32 32 32h3.7c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7V80H336 304 288c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4h2.5c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5l0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5H304h32zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"}}]})(props);
	};
	module.exports.FaRegSnowflake = function FaRegSnowflake (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 0c13.3 0 24 10.7 24 24V70.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57v76.5l66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6v76.5l57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V441.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V297.6l-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4V137.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaRegSquareCaretDown = function FaRegSquareCaretDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"}}]})(props);
	};
	module.exports.FaRegSquareCaretLeft = function FaRegSquareCaretLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"}}]})(props);
	};
	module.exports.FaRegSquareCaretRight = function FaRegSquareCaretRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"}}]})(props);
	};
	module.exports.FaRegSquareCaretUp = function FaRegSquareCaretUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"}}]})(props);
	};
	module.exports.FaRegSquareCheck = function FaRegSquareCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"}}]})(props);
	};
	module.exports.FaRegSquareFull = function FaRegSquareFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 48V464H48V48H464zM48 0H0V48 464v48H48 464h48V464 48 0H464 48z"}}]})(props);
	};
	module.exports.FaRegSquareMinus = function FaRegSquareMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM152 232H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"}}]})(props);
	};
	module.exports.FaRegSquarePlus = function FaRegSquarePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"}}]})(props);
	};
	module.exports.FaRegSquare = function FaRegSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"}}]})(props);
	};
	module.exports.FaRegStarHalfStroke = function FaRegStarHalfStroke (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M341.5 13.5C337.5 5.2 329.1 0 319.9 0s-17.6 5.2-21.6 13.5L229.7 154.8 76.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L174.2 328.4 148 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L465.6 328.4 576.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L410.1 154.8 341.5 13.5zM320 384.7V79.1l52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L423 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L331.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"}}]})(props);
	};
	module.exports.FaRegStarHalf = function FaRegStarHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4V408.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9zM263.9 128.4l-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l92.5-49.4V128.4z"}}]})(props);
	};
	module.exports.FaRegStar = function FaRegStar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"}}]})(props);
	};
	module.exports.FaRegSun = function FaRegSun (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L402 242.4c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"}}]})(props);
	};
	module.exports.FaRegThumbsDown = function FaRegThumbsDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z"}}]})(props);
	};
	module.exports.FaRegThumbsUp = function FaRegThumbsUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.1s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16H286.5c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8H384c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32z"}}]})(props);
	};
	module.exports.FaRegTrashCan = function FaRegTrashCan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"}}]})(props);
	};
	module.exports.FaRegUser = function FaRegUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"}}]})(props);
	};
	module.exports.FaRegWindowMaximize = function FaRegWindowMaximize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M.3 89.5C.1 91.6 0 93.8 0 96V224 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64V224 96c0-35.3-28.7-64-64-64H64c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 224H464l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192z"}}]})(props);
	};
	module.exports.FaRegWindowMinimize = function FaRegWindowMinimize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"}}]})(props);
	};
	module.exports.FaRegWindowRestore = function FaRegWindowRestore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 48H208c-17.7 0-32 14.3-32 32V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V336h16c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V256H48V448zM64 128H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z"}}]})(props);
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// THIS FILE IS AUTO GENERATED
	var GenIcon = __webpack_require__(76).GenIcon
	module.exports.IoAccessibilityOutline = function IoAccessibilityOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"56","r":"40","fill":"none","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M204.23 274.44c2.9-18.06 4.2-35.52-.5-47.59-4-10.38-12.7-16.19-23.2-20.15L88 176.76c-12-4-23.21-10.7-24-23.94-1-17 14-28 29-24 0 0 88 31.14 163 31.14s162-31 162-31c18-5 30 9 30 23.79 0 14.21-11 19.21-24 23.94l-88 31.91c-8 3-21 9-26 18.18-6 10.75-5 29.53-2.1 47.59l5.9 29.63 37.41 163.9c2.8 13.15-6.3 25.44-19.4 27.74S308 489 304.12 476.28l-37.56-115.93q-2.71-8.34-4.8-16.87L256 320l-5.3 21.65q-2.52 10.35-5.8 20.48L208 476.18c-4 12.85-14.5 21.75-27.6 19.46s-22.4-15.59-19.46-27.74l37.39-163.83z"}}]})(props);
	};
	module.exports.IoAccessibilitySharp = function IoAccessibilitySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 112c-66.82 17.92-119.55 32-192 32s-125.18-14.08-192-32l-16 51c48 20.53 96.71 35.16 147.2 53.2L144 496l56.4 16L246 336h20l45.6 176 56.4-16-51.2-279.8C367.26 199.93 416 183.53 464 164zm-192 0a56 56 0 1156-56 56.06 56.06 0 01-56 56z"}}]})(props);
	};
	module.exports.IoAccessibility = function IoAccessibility (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 112a56 56 0 1156-56 56.06 56.06 0 01-56 56z"}},{"tag":"path","attr":{"d":"M432 112.8l-.45.12-.42.13c-1 .28-2 .58-3 .89-18.61 5.46-108.93 30.92-172.56 30.92-59.13 0-141.28-22-167.56-29.47a73.79 73.79 0 00-8-2.58c-19-5-32 14.3-32 31.94 0 17.47 15.7 25.79 31.55 31.76v.28l95.22 29.74c9.73 3.73 12.33 7.54 13.6 10.84 4.13 10.59.83 31.56-.34 38.88l-5.8 45-32.19 176.19q-.15.72-.27 1.47l-.23 1.27c-2.32 16.15 9.54 31.82 32 31.82 19.6 0 28.25-13.53 32-31.94s28-157.57 42-157.57 42.84 157.57 42.84 157.57c3.75 18.41 12.4 31.94 32 31.94 22.52 0 34.38-15.74 32-31.94a57.17 57.17 0 00-.76-4.06L329 301.27l-5.79-45c-4.19-26.21-.82-34.87.32-36.9a1.09 1.09 0 00.08-.15c1.08-2 6-6.48 17.48-10.79l89.28-31.21a16.9 16.9 0 001.62-.52c16-6 32-14.3 32-31.93S451 107.81 432 112.8z"}}]})(props);
	};
	module.exports.IoAddCircleOutline = function IoAddCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 176v160m80-80H176"}}]})(props);
	};
	module.exports.IoAddCircleSharp = function IoAddCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm96 224h-80v80h-32v-80h-80v-32h80v-80h32v80h80z"}}]})(props);
	};
	module.exports.IoAddCircle = function IoAddCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 224h-64v64a16 16 0 01-32 0v-64h-64a16 16 0 010-32h64v-64a16 16 0 0132 0v64h64a16 16 0 010 32z"}}]})(props);
	};
	module.exports.IoAddOutline = function IoAddOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 112v288m144-144H112"}}]})(props);
	};
	module.exports.IoAddSharp = function IoAddSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"32","d":"M256 112v288m144-144H112"}}]})(props);
	};
	module.exports.IoAdd = function IoAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 112v288m144-144H112"}}]})(props);
	};
	module.exports.IoAirplaneOutline = function IoAirplaneOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M407.72 224c-3.4 0-14.79.1-18 .3l-64.9 1.7a1.83 1.83 0 01-1.69-.9L193.55 67.56a9 9 0 00-6.66-3.56H160l73 161a2.35 2.35 0 01-2.26 3.35l-121.69 1.8a8.06 8.06 0 01-6.6-3.1l-37-45c-3-3.9-8.62-6-13.51-6H33.08c-1.29 0-1.1 1.21-.75 2.43l19.84 71.42a16.3 16.3 0 010 11.9L32.31 333c-.59 1.95-.52 3 1.77 3H52c8.14 0 9.25-1.06 13.41-6.3l37.7-45.7a8.19 8.19 0 016.6-3.1l120.68 2.7a2.7 2.7 0 012.43 3.74L160 448h26.64a9 9 0 006.65-3.55L323.14 287c.39-.6 2-.9 2.69-.9l63.9 1.7c3.3.2 14.59.3 18 .3C452 288.1 480 275.93 480 256s-27.88-32-72.28-32z"}}]})(props);
	};
	module.exports.IoAirplaneSharp = function IoAirplaneSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M407.72 208c-2.72 0-14.44.08-18.67.31l-57.77 1.52L198.06 48h-62.81l74.59 164.61-97.31 1.44L68.25 160H16.14l20.61 94.18c.15.54.33 1.07.53 1.59a.26.26 0 010 .15 15.42 15.42 0 00-.53 1.58L15.86 352h51.78l45.45-55 96.77 2.17L135.24 464h63l133-161.75 57.77 1.54c4.29.23 16 .31 18.66.31 24.35 0 44.27-3.34 59.21-9.94C492.22 283 496 265.46 496 256c0-30.06-33-48-88.28-48zm-71.29 87.9z"}}]})(props);
	};
	module.exports.IoAirplane = function IoAirplane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M186.62 464H160a16 16 0 01-14.57-22.6l64.46-142.25L113.1 297l-35.3 42.77C71.07 348.23 65.7 352 52 352H34.08a17.66 17.66 0 01-14.7-7.06c-2.38-3.21-4.72-8.65-2.44-16.41l19.82-71c.15-.53.33-1.06.53-1.58a.38.38 0 000-.15 14.82 14.82 0 01-.53-1.59l-19.84-71.45c-2.15-7.61.2-12.93 2.56-16.06a16.83 16.83 0 0113.6-6.7H52c10.23 0 20.16 4.59 26 12l34.57 42.05 97.32-1.44-64.44-142A16 16 0 01160 48h26.91a25 25 0 0119.35 9.8l125.05 152 57.77-1.52c4.23-.23 15.95-.31 18.66-.31C463 208 496 225.94 496 256c0 9.46-3.78 27-29.07 38.16-14.93 6.6-34.85 9.94-59.21 9.94-2.68 0-14.37-.08-18.66-.31l-57.76-1.54-125.36 152a25 25 0 01-19.32 9.75z"}}]})(props);
	};
	module.exports.IoAlarmOutline = function IoAlarmOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M416.07 272a160 160 0 10-160 160 160 160 0 00160-160zM142.12 91.21A46.67 46.67 0 00112 80l-2.79.08C83.66 81.62 64 104 64.07 131c0 13.21 4.66 19.37 10.88 27.23a4.55 4.55 0 003.24 1.77h.88a3.23 3.23 0 002.54-1.31L142.38 99a5.38 5.38 0 001.55-4 5.26 5.26 0 00-1.81-3.79zm227.76 0A46.67 46.67 0 01400 80l2.79.08C428.34 81.62 448 104 447.93 131c0 13.21-4.66 19.37-10.88 27.23a4.55 4.55 0 01-3.24 1.76h-.88a3.23 3.23 0 01-2.54-1.31L369.62 99a5.38 5.38 0 01-1.55-4 5.26 5.26 0 011.81-3.79z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256.07 160v112h-80m240 160l-40-40m-280 40l40-40"}}]})(props);
	};
	module.exports.IoAlarmSharp = function IoAlarmSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.79 64.11l-3.27-.1H400c-14.73 0-28.55 5.91-40.52 15S344 96 344 96l88 86s11.25-5.71 17.61-13.85 14.28-18.08 14.32-37.11c.07-35.49-26.33-64.89-60.14-66.93zm-295.58 0l3.27-.1h.52c14.73 0 28.55 5.91 40.52 15S168 96 168 96l-88 86s-11.25-5.71-17.61-13.85S48.11 150.07 48.07 131C48 95.55 74.4 66.15 108.21 64.11z"}},{"tag":"path","attr":{"d":"M391.3 384.6a.06.06 0 010-.08C425 344 441 288.24 427 229.23c-13.64-57.52-72.67-115.69-130.34-128.66C182 74.79 80.07 161.71 80.07 272a175.15 175.15 0 0040.78 112.52.06.06 0 010 .08L73 432a.06.06 0 000 .08l23 22.51a.06.06 0 00.08 0l47.43-47.37a.06.06 0 01.08 0 175.64 175.64 0 00225.05 0h.07L416 454.59a.06.06 0 00.08 0L440 432zM272.07 288H160v-31.9l.05-.05h80V144h32z"}}]})(props);
	};
	module.exports.IoAlarm = function IoAlarm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M153.59 110.46A21.41 21.41 0 00152.48 79 62.67 62.67 0 00112 64l-3.27.09h-.48C74.4 66.15 48 95.55 48.07 131c0 19 8 29.06 14.32 37.11a20.61 20.61 0 0014.7 7.8c.26 0 .7.05 2 .05a19.06 19.06 0 0013.75-5.89zm250.2-46.35l-3.27-.1H400a62.67 62.67 0 00-40.52 15 21.41 21.41 0 00-1.11 31.44l60.77 59.65a19.06 19.06 0 0013.79 5.9c1.28 0 1.72 0 2-.05a20.61 20.61 0 0014.69-7.8c6.36-8.05 14.28-18.08 14.32-37.11.06-35.49-26.34-64.89-60.15-66.93z"}},{"tag":"path","attr":{"d":"M256.07 96c-97 0-176 78.95-176 176a175.23 175.23 0 0040.81 112.56l-36.12 36.13a16 16 0 1022.63 22.62l36.12-36.12a175.63 175.63 0 00225.12 0l36.13 36.12a16 16 0 1022.63-22.62l-36.13-36.13A175.17 175.17 0 00432.07 272c0-97-78.95-176-176-176zm16 176a16 16 0 01-16 16h-80a16 16 0 010-32h64v-96a16 16 0 0132 0z"}}]})(props);
	};
	module.exports.IoAlbumsOutline = function IoAlbumsOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"384","height":"256","x":"64","y":"176","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28.87","ry":"28.87"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M144 80h224m-256 48h288"}}]})(props);
	};
	module.exports.IoAlbumsSharp = function IoAlbumsSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 64h256v32H128zm-32 48h320v32H96zm368 336H48V160h416z"}}]})(props);
	};
	module.exports.IoAlbums = function IoAlbums (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 96H144a16 16 0 010-32h224a16 16 0 010 32zm32 48H112a16 16 0 010-32h288a16 16 0 010 32zm19.13 304H92.87A44.92 44.92 0 0148 403.13V204.87A44.92 44.92 0 0192.87 160h326.26A44.92 44.92 0 01464 204.87v198.26A44.92 44.92 0 01419.13 448z"}}]})(props);
	};
	module.exports.IoAlertCircleOutline = function IoAlertCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M250.26 166.05L256 288l5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 6z"}},{"tag":"path","attr":{"d":"M256 367.91a20 20 0 1120-20 20 20 0 01-20 20z"}}]})(props);
	};
	module.exports.IoAlertCircleSharp = function IoAlertCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M240 304h32l6-160h-44l6 160z"}},{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm20 319.91h-40v-40h40zM272 304h-32l-6-160h44z"}}]})(props);
	};
	module.exports.IoAlertCircle = function IoAlertCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 319.91a20 20 0 1120-20 20 20 0 01-20 20zm21.72-201.15l-5.74 122a16 16 0 01-32 0l-5.74-121.94v-.05a21.74 21.74 0 1143.44 0z"}}]})(props);
	};
	module.exports.IoAlertOutline = function IoAlertOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 80c-8.66 0-16.58 7.36-16 16l8 216a8 8 0 008 8h0a8 8 0 008-8l8-216c.58-8.64-7.34-16-16-16z"}},{"tag":"circle","attr":{"cx":"256","cy":"416","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoAlertSharp = function IoAlertSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M240 80l8 240h16l8-240h-32zm0 320h32v32h-32z"}}]})(props);
	};
	module.exports.IoAlert = function IoAlert (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 80c-8.66 0-16.58 7.36-16 16l8 216a8 8 0 008 8h0a8 8 0 008-8l8-216c.58-8.64-7.34-16-16-16z"}},{"tag":"circle","attr":{"cx":"256","cy":"416","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoAmericanFootballOutline = function IoAmericanFootballOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"ellipse","attr":{"cx":"256","cy":"256","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"267.57","ry":"173.44","transform":"rotate(-45 256 256.002)"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M334.04 177.96L177.96 334.04M278.3 278.3l-44.6-44.6m89.19 0l-44.59-44.59m178.38 22.29L300.6 55.32m-89.2 401.36L55.32 300.6m178.38 22.29l-44.59-44.59"}}]})(props);
	};
	module.exports.IoAmericanFootballSharp = function IoAmericanFootballSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M120.9 120.51c-44.75 44.56-67.29 101.05-78.64 145.9l202.31 201.44c45.05-11.3 101.78-33.74 146.53-78.3s67.29-101.05 78.64-145.91L267.43 42.21C222.38 53.51 165.65 76 120.9 120.51zm259 257.83zm-45-224.2l22.52 22.42-33.78 33.63 22.52 22.42L323.55 255 301 232.61 278.52 255 301 277.45l-22.51 22.42L256 277.45l-22.52 22.42L256 322.29l-22.52 22.42L211 322.29l-33.78 33.63-22.55-22.42 33.78-33.63-22.52-22.42L188.45 255 211 277.45 233.48 255 211 232.61l22.51-22.42L256 232.61l22.52-22.42L256 187.77l22.52-22.42L301 187.77zm143.58 44.27C485.85 143.65 464 48.05 464 48.05s-96.14-21.88-151.14-14.54c-2.54.33-5.21.72-8 1.14l172.47 171.71c.43-2.76.81-5.42 1.15-7.95zM33.52 311.65C26.15 366.41 48.05 464 48.05 464s60 16 99.86 16a391.92 391.92 0 0051.23-3.45c2.54-.33 5.21-.72 8-1.15L34.67 303.7c-.43 2.76-.81 5.42-1.15 7.95z"}}]})(props);
	};
	module.exports.IoAmericanFootball = function IoAmericanFootball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M122.06 122.06c-44.37 44.37-66.71 100.61-78 145.28l200.6 200.56c44.67-11.25 100.91-33.59 145.28-78s66.71-100.61 78-145.28L267.34 44.1c-44.67 11.25-100.91 33.59-145.28 77.96zm256.73 256.72zM300.65 189L323 166.71A15.78 15.78 0 01345.29 189L323 211.35l11.16 11.17a15.78 15.78 0 01-22.32 22.32l-11.16-11.16L278.32 256l11.16 11.16a15.78 15.78 0 11-22.32 22.32L256 278.32l-22.32 22.33 11.16 11.16a15.78 15.78 0 11-22.32 22.32L211.35 323 189 345.29A15.78 15.78 0 01166.71 323L189 300.65l-11.16-11.17a15.78 15.78 0 0122.32-22.32l11.16 11.16L233.68 256l-11.16-11.16a15.78 15.78 0 1122.32-22.32L256 233.68l22.32-22.33-11.16-11.16a15.78 15.78 0 0122.32-22.32zm175.92 10.63c7.31-54.53 4-120.26-20-144.21s-89.68-27.3-144.21-20c-2.51.34-5.16.72-7.91 1.15l171 171c.4-2.78.78-5.43 1.12-7.94zM35.43 312.37c-7.31 54.53-4 120.26 20 144.21C72.17 473.33 109.34 480 148.84 480a387 387 0 0050.79-3.43c2.51-.34 5.16-.72 7.91-1.15l-171-171c-.39 2.79-.77 5.44-1.11 7.95z"}}]})(props);
	};
	module.exports.IoAnalyticsOutline = function IoAnalyticsOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M344 280l88-88m-200 24l64 64M80 320l104-104"}},{"tag":"circle","attr":{"cx":"456","cy":"168","r":"24","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"320","cy":"304","r":"24","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"208","cy":"192","r":"24","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"56","cy":"344","r":"24","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoAnalyticsSharp = function IoAnalyticsSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450 128a46 46 0 00-44.11 59l-71.37 71.36a45.88 45.88 0 00-29 0l-52.91-52.91a46 46 0 10-89.12 0L75 293.88A46.08 46.08 0 10106.11 325l87.37-87.36a45.85 45.85 0 0029 0l52.92 52.92a46 46 0 1089.12 0L437 218.12A46 46 0 10450 128z"}}]})(props);
	};
	module.exports.IoAnalytics = function IoAnalytics (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456 128a40 40 0 00-37.23 54.6l-84.17 84.17a39.86 39.86 0 00-29.2 0l-60.17-60.17a40 40 0 10-74.46 0L70.6 306.77a40 40 0 1022.63 22.63L193.4 229.23a39.86 39.86 0 0029.2 0l60.17 60.17a40 40 0 1074.46 0l84.17-84.17A40 40 0 10456 128z"}}]})(props);
	};
	module.exports.IoApertureOutline = function IoApertureOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M360 94.59V296m83.13-83.13L296 360m121.41 0H216m83.13 83.13l-144-144M152 416V216m-83.13 83.13l144-144M94.59 152H288m-75.13-83.13L360 216"}}]})(props);
	};
	module.exports.IoApertureSharp = function IoApertureSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216 48l129.49 128.18V48H216zm-34.53 10.38L80 134h176l-74.53-75.62zM336 344h128V216L336 344zm118-162L378 80v176l76-74zM48 166v128l128-128H48zm282 288l102-76H256l74 76zM58 330l76 102V256l-76 74zm287.49-107.88l-55.55-55.46h-67.88l-55.55 55.46v67.76l55.62 55.52c.44 0 .88-.06 1.33-.06h66.48l55.55-55.46zM165.98 336.09L166 464h128L165.98 336.09z"}}]})(props);
	};
	module.exports.IoAperture = function IoAperture (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M250.54 129.17l-67.8-67.8A209.65 209.65 0 0086.32 136h161.4a4 4 0 002.82-6.83zM167.72 168H67.63a207.34 207.34 0 00-16.15 125.9l119.06-119.07a4 4 0 00-2.82-6.83zm176.28-.28V67.56a207.82 207.82 0 00-125.89-16.08l119.06 119.06a4 4 0 006.83-2.82zm116.52 50.38L341.46 337.17a4 4 0 002.82 6.83h100.09a207.34 207.34 0 0016.15-125.9zm-77.69 32.44l67.83-67.82A209.08 209.08 0 00376 86.2v161.52a4 4 0 006.83 2.82zm-161.15 91.23a8 8 0 005.54 2.23h59.66a8 8 0 005.7-2.39l49.18-50a8 8 0 002.3-5.62l-.06-60.81a8 8 0 00-2.38-5.69l-50-49.25a8 8 0 00-5.63-2.3l-60.84.06a8 8 0 00-5.69 2.38l-49.25 50a8 8 0 00-2.3 5.63l.06 60.78a8 8 0 002.45 5.76zm39.78 41.06l67.8 67.8A209.65 209.65 0 00425.68 376h-161.4a4 4 0 00-2.82 6.83zM168 344.28v100.16a207.82 207.82 0 00125.89 16.08L174.83 341.46a4 4 0 00-6.83 2.82zm-38.83-82.82l-67.83 67.83A209.1 209.1 0 00136 425.8V264.28a4 4 0 00-6.83-2.82z"}}]})(props);
	};
	module.exports.IoAppsOutline = function IoAppsOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"80","height":"80","x":"64","y":"64","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"40","ry":"40"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"216","y":"64","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"40","ry":"40"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"368","y":"64","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"40","ry":"40"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"64","y":"216","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"40","ry":"40"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"216","y":"216","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"40","ry":"40"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"368","y":"216","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"40","ry":"40"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"64","y":"368","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"40","ry":"40"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"216","y":"368","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"40","ry":"40"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"368","y":"368","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"40","ry":"40"}}]})(props);
	};
	module.exports.IoAppsSharp = function IoAppsSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"112","height":"112","x":"48","y":"48","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"112","height":"112","x":"200","y":"48","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"112","height":"112","x":"352","y":"48","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"112","height":"112","x":"48","y":"200","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"112","height":"112","x":"200","y":"200","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"112","height":"112","x":"352","y":"200","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"112","height":"112","x":"48","y":"352","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"112","height":"112","x":"200","y":"352","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"112","height":"112","x":"352","y":"352","rx":"8","ry":"8"}}]})(props);
	};
	module.exports.IoApps = function IoApps (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M104 160a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zM104 312a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zM104 464a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56z"}}]})(props);
	};
	module.exports.IoArchiveOutline = function IoArchiveOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M80 152v256a40.12 40.12 0 0040 40h272a40.12 40.12 0 0040-40V152"}},{"tag":"rect","attr":{"width":"416","height":"80","x":"48","y":"64","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 304l-64 64-64-64m64 41.89V224"}}]})(props);
	};
	module.exports.IoArchiveSharp = function IoArchiveSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"448","height":"80","x":"32","y":"48","rx":"12","ry":"12"}},{"tag":"path","attr":{"d":"M64 160v280a24 24 0 0024 24h336a24 24 0 0024-24V160zm192 230.63L169.32 304 192 281.32l48 48.05V208h32v121.37l48.07-48.07 22.61 22.64z"}}]})(props);
	};
	module.exports.IoArchive = function IoArchive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 164v244a56 56 0 0056 56h272a56 56 0 0056-56V164a4 4 0 00-4-4H68a4 4 0 00-4 4zm267 151.63l-63.69 63.68a16 16 0 01-22.62 0L181 315.63c-6.09-6.09-6.65-16-.85-22.38a16 16 0 0123.16-.56L240 329.37V224.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 224v105.37l36.69-36.68a16 16 0 0123.16.56c5.8 6.37 5.24 16.29-.85 22.38z"}},{"tag":"rect","attr":{"width":"448","height":"80","x":"32","y":"48","rx":"32","ry":"32"}}]})(props);
	};
	module.exports.IoArrowBackCircleOutline = function IoArrowBackCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M249.38 336L170 256l79.38-80m-68.35 80H342"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoArrowBackCircleSharp = function IoArrowBackCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm224-80.09L208.42 240H358v32H208.42L272 336.09l-22.7 22.54L147.46 256 249.3 153.37z"}}]})(props);
	};
	module.exports.IoArrowBackCircle = function IoArrowBackCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm212.65-91.36a16 16 0 01.09 22.63L208.42 240H342a16 16 0 010 32H208.42l52.32 52.73A16 16 0 11238 347.27l-79.39-80a16 16 0 010-22.54l79.39-80a16 16 0 0122.65-.09z"}}]})(props);
	};
	module.exports.IoArrowBackOutline = function IoArrowBackOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M244 400L100 256l144-144M120 256h292"}}]})(props);
	};
	module.exports.IoArrowBackSharp = function IoArrowBackSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"48","d":"M244 400L100 256l144-144M120 256h292"}}]})(props);
	};
	module.exports.IoArrowBack = function IoArrowBack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M244 400L100 256l144-144M120 256h292"}}]})(props);
	};
	module.exports.IoArrowDownCircleOutline = function IoArrowDownCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 262.62L256 342l80-79.38m-80 68.35V170"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"}}]})(props);
	};
	module.exports.IoArrowDownCircleSharp = function IoArrowDownCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c114.87 0 208-93.13 208-208S370.87 48 256 48 48 141.13 48 256s93.13 208 208 208zm-80.09-224L240 303.58V154h32v149.58L336.09 240l22.54 22.71L256 364.54 153.37 262.7z"}}]})(props);
	};
	module.exports.IoArrowDownCircle = function IoArrowDownCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c114.87 0 208-93.13 208-208S370.87 48 256 48 48 141.13 48 256s93.13 208 208 208zm-91.36-212.65a16 16 0 0122.63-.09L240 303.58V170a16 16 0 0132 0v133.58l52.73-52.32A16 16 0 11347.27 274l-80 79.39a16 16 0 01-22.54 0l-80-79.39a16 16 0 01-.09-22.65z"}}]})(props);
	};
	module.exports.IoArrowDownOutline = function IoArrowDownOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M112 268l144 144 144-144M256 392V100"}}]})(props);
	};
	module.exports.IoArrowDownSharp = function IoArrowDownSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"48","d":"M112 268l144 144 144-144M256 392V100"}}]})(props);
	};
	module.exports.IoArrowDown = function IoArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M112 268l144 144 144-144M256 392V100"}}]})(props);
	};
	module.exports.IoArrowForwardCircleOutline = function IoArrowForwardCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M262.62 336L342 256l-79.38-80m68.35 80H170"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z"}}]})(props);
	};
	module.exports.IoArrowForwardCircleSharp = function IoArrowForwardCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-224 80.09L303.58 272H154v-32h149.58L240 175.91l22.71-22.54L364.54 256 262.7 358.63z"}}]})(props);
	};
	module.exports.IoArrowForwardCircle = function IoArrowForwardCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-212.65 91.36a16 16 0 01-.09-22.63L303.58 272H170a16 16 0 010-32h133.58l-52.32-52.73A16 16 0 11274 164.73l79.39 80a16 16 0 010 22.54l-79.39 80a16 16 0 01-22.65.09z"}}]})(props);
	};
	module.exports.IoArrowForwardOutline = function IoArrowForwardOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M268 112l144 144-144 144m124-144H100"}}]})(props);
	};
	module.exports.IoArrowForwardSharp = function IoArrowForwardSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"48","d":"M268 112l144 144-144 144m124-144H100"}}]})(props);
	};
	module.exports.IoArrowForward = function IoArrowForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M268 112l144 144-144 144m124-144H100"}}]})(props);
	};
	module.exports.IoArrowRedoCircleOutline = function IoArrowRedoCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M266.91 327.74v-37.32c-57.07 0-84.51 13.47-108.58 38.68-5.4 5.65-15 1.32-14.29-6.43 5.45-61.45 34.14-117.09 122.87-117.09v-37.32a8.32 8.32 0 0114-6L365.42 242a8.2 8.2 0 010 11.94L281 333.71a8.32 8.32 0 01-14.09-5.97z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M64 256c0 106 86 192 192 192s192-86 192-192S362 64 256 64 64 150 64 256z"}}]})(props);
	};
	module.exports.IoArrowRedoCircleSharp = function IoArrowRedoCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm98 88c0-68.13 22.67-137.14 119.17-137.14V152L366 248l-100.83 96v-54.86c-66.69 0-91.32 19.29-119.17 54.86z"}}]})(props);
	};
	module.exports.IoArrowRedoCircle = function IoArrowRedoCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm96 66.67c5.45-61.45 34.14-117.09 122.87-117.09v-37.32a8.32 8.32 0 0114-6L365.42 242a8.2 8.2 0 010 11.94L281 333.71a8.32 8.32 0 01-14-6v-37.29c-57.07 0-84.51 13.47-108.58 38.68-5.49 5.65-15.07 1.32-14.42-6.43z"}}]})(props);
	};
	module.exports.IoArrowRedoOutline = function IoArrowRedoOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M448 256L272 88v96C103.57 184 64 304.77 64 424c48.61-62.24 91.6-96 208-96v96z"}}]})(props);
	};
	module.exports.IoArrowRedoSharp = function IoArrowRedoSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 399.26C48 335.19 62.44 284 90.91 247c34.38-44.67 88.68-68.77 161.56-71.75V72L464 252 252.47 432V329.35c-44.25 1.19-77.66 7.58-104.27 19.84-28.75 13.25-49.6 33.05-72.08 58.7L48 440z"}}]})(props);
	};
	module.exports.IoArrowRedo = function IoArrowRedo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M58.79 439.13A16 16 0 0148 424c0-73.1 14.68-131.56 43.65-173.77 35-51 90.21-78.46 164.35-81.87V88a16 16 0 0127.05-11.57l176 168a16 16 0 010 23.14l-176 168A16 16 0 01256 424v-79.77c-45 1.36-79 8.65-106.07 22.64-29.25 15.12-50.46 37.71-73.32 67a16 16 0 01-17.82 5.28z"}}]})(props);
	};
	module.exports.IoArrowUndoCircleOutline = function IoArrowUndoCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M245.09 327.74v-37.32c57.07 0 84.51 13.47 108.58 38.68 5.4 5.65 15 1.32 14.29-6.43-5.45-61.45-34.14-117.09-122.87-117.09v-37.32a8.32 8.32 0 00-14.05-6L146.58 242a8.2 8.2 0 000 11.94L231 333.71a8.32 8.32 0 0014.09-5.97z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"}}]})(props);
	};
	module.exports.IoArrowUndoCircleSharp = function IoArrowUndoCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm-9.17 241.14V344L146 248l100.83-96v54.86c96.5 0 119.17 69 119.17 137.14-27.85-35.57-52.48-54.86-119.17-54.86z"}}]})(props);
	};
	module.exports.IoArrowUndoCircle = function IoArrowUndoCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm97.67 281.1c-24.07-25.21-51.51-38.68-108.58-38.68v37.32a8.32 8.32 0 01-14.05 6L146.58 254a8.2 8.2 0 010-11.94L231 162.29a8.32 8.32 0 0114.05 6v37.32c88.73 0 117.42 55.64 122.87 117.09.73 7.72-8.85 12.05-14.25 6.4z"}}]})(props);
	};
	module.exports.IoArrowUndoOutline = function IoArrowUndoOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M240 424v-96c116.4 0 159.39 33.76 208 96 0-119.23-39.57-240-208-240V88L64 256z"}}]})(props);
	};
	module.exports.IoArrowUndoSharp = function IoArrowUndoSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 440l-28.12-32.11c-22.48-25.65-43.33-45.45-72.08-58.7-26.61-12.26-60-18.65-104.27-19.84V432L48 252 259.53 72v103.21c72.88 3 127.18 27.08 161.56 71.75C449.56 284 464 335.19 464 399.26z"}}]})(props);
	};
	module.exports.IoArrowUndo = function IoArrowUndo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 440a16 16 0 01-12.61-6.15c-22.86-29.27-44.07-51.86-73.32-67C335 352.88 301 345.59 256 344.23V424a16 16 0 01-27 11.57l-176-168a16 16 0 010-23.14l176-168A16 16 0 01256 88v80.36c74.14 3.41 129.38 30.91 164.35 81.87C449.32 292.44 464 350.9 464 424a16 16 0 01-16 16z"}}]})(props);
	};
	module.exports.IoArrowUpCircleOutline = function IoArrowUpCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 249.38L256 170l80 79.38m-80-68.35V342"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoArrowUpCircleSharp = function IoArrowUpCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm80.09 224L272 208.42V358h-32V208.42L175.91 272l-22.54-22.7L256 147.46 358.63 249.3z"}}]})(props);
	};
	module.exports.IoArrowUpCircle = function IoArrowUpCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm91.36 212.65a16 16 0 01-22.63.09L272 208.42V342a16 16 0 01-32 0V208.42l-52.73 52.32A16 16 0 11164.73 238l80-79.39a16 16 0 0122.54 0l80 79.39a16 16 0 01.09 22.65z"}}]})(props);
	};
	module.exports.IoArrowUpOutline = function IoArrowUpOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M112 244l144-144 144 144M256 120v292"}}]})(props);
	};
	module.exports.IoArrowUpSharp = function IoArrowUpSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"48","d":"M112 244l144-144 144 144M256 120v292"}}]})(props);
	};
	module.exports.IoArrowUp = function IoArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M112 244l144-144 144 144M256 120v292"}}]})(props);
	};
	module.exports.IoAtCircleOutline = function IoAtCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448.08 256.08c0-106-86-192-192-192s-192 86-192 192 86 192 192 192 192-85.97 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"28","d":"M300.81 358.29c-20.83 7.42-34.05 9.59-54.19 9.59-61.17 0-106.39-50.07-101-111.84S205 144.21 266.14 144.21c68.92 0 106.79 45.55 101.47 106.55-4 45.54-32.8 58.66-47.89 56-14.2-2.55-25.92-15.52-23.75-40.35l5.62-44.66c-7.58-9.17-28.11-18-49.93-14.54C231.77 210.3 209 228 206.56 256s14.49 50.84 39.93 50.84 47.86-18.39 50.69-50.84"}}]})(props);
	};
	module.exports.IoAtCircleSharp = function IoAtCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.41 48.74c-114.85 0-208 93.11-208 208s93.12 208 208 208 208-93.12 208-208-93.16-208-208-208zM381.22 252c-2.85 32.63-16.78 49.7-28 58.26s-24.69 12.34-36.33 10.26a41.63 41.63 0 01-27-17.52 60.84 60.84 0 01-43.72 17.9 51.65 51.65 0 01-38.55-16.83c-11.39-12.42-17-30.36-15.33-49.23 3.05-35 30.92-57.39 56.87-61.48 27.21-4.29 52.24 6.54 62.91 19.46l3.84 4.66-6.34 50.38c-1.19 14.34 3.29 23.48 12.29 25.1 2.39.42 8.11-.13 14.38-4.93 6.72-5.15 15.14-16 17.1-38.47 2.32-26.55-4.35-49.19-19.28-65.49-15.5-16.9-39.1-25.84-68.24-25.84-54 0-101.81 44.43-106.57 99-2.29 26.2 5.66 50.68 22.39 68.93C198 344 221 353.88 246.29 353.88c19 0 30.61-2.05 49.49-8.78l13.22-4.69 9.39 26.37-13.19 4.7c-21.82 7.77-36.68 10.4-58.88 10.4-33.28 0-63.57-13.06-85.3-36.77-22.09-24.11-32.62-56.17-29.65-90.29 2.91-33.33 18.46-64.63 43.77-88.12s57.57-36.49 90.7-36.49c37.2 0 67.94 12.08 88.88 34.93 20.05 21.91 29.48 52.75 26.5 86.86z"}},{"tag":"path","attr":{"d":"M253.51 221c-14.83 2.33-31.55 15.84-33.34 36.26-1 11.06 2 21.22 8.08 27.87a23.63 23.63 0 0017.91 7.75c19.7 0 33.8-14.79 36.8-38.59l1.75-13.89h.09l1.65-13.11a49.63 49.63 0 00-32.94-6.3z"}}]})(props);
	};
	module.exports.IoAtCircle = function IoAtCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.46 48.74c-114.84 0-208 93.11-208 208s93.12 208 208 208 208-93.12 208-208-93.15-208-208-208zM380.28 252c-2.85 32.63-16.79 49.7-28 58.26S327.61 322.58 316 320.5a41.61 41.61 0 01-26.82-17.19 62.06 62.06 0 01-44 17.57 51.66 51.66 0 01-38.55-16.83c-11.38-12.42-17-30.36-15.32-49.23 3-35 30.91-57.39 56.87-61.48 27.2-4.29 52.23 6.54 62.9 19.46l3.85 4.66-6.34 50.38c-1.19 14.34 3.28 23.48 12.29 25.1 2.39.42 8.1-.13 14.37-4.93 6.72-5.15 15.14-16 17.1-38.47 2.35-26.54-4.35-49.19-19.25-65.49-15.49-16.9-39.09-25.84-68.23-25.84-54 0-101.81 44.43-106.58 99-2.28 26.2 5.67 50.68 22.4 68.93 16.36 17.86 39.31 27.74 64.66 27.74 19 0 30.61-2.05 49.48-8.78a14 14 0 019.4 26.38c-21.82 7.77-36.68 10.4-58.88 10.4-33.28 0-63.57-13.06-85.3-36.77C138 321 127.42 288.94 130.4 254.82c2.91-33.33 18.45-64.63 43.77-88.12s57.57-36.49 90.7-36.49c37.2 0 67.93 12.08 88.87 34.93 20.09 21.91 29.51 52.75 26.54 86.86z"}},{"tag":"path","attr":{"d":"M252.57 221c-14.83 2.33-31.56 15.84-33.34 36.26-1 11.06 2 21.22 8.07 27.87a23.65 23.65 0 0017.91 7.75c20.31 0 34.73-14.94 36.75-38.06a14 14 0 01.34-2.07l3.2-25.45a49.61 49.61 0 00-32.93-6.3z"}}]})(props);
	};
	module.exports.IoAtOutline = function IoAtOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 254.27c-4.5 51-40.12 80-80.55 80s-67.34-35.82-63.45-80 37.12-80 77.55-80 70.33 36 66.45 80z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M319.77 415.77c-28.56 12-47.28 14.5-79.28 14.5-97.2 0-169-78.8-160.49-176s94.31-176 191.51-176C381 78.27 441.19 150 432.73 246c-6.31 71.67-52.11 92.32-76.09 88.07-22.56-4-41.18-24.42-37.74-63.5l8.48-96.25"}}]})(props);
	};
	module.exports.IoAtSharp = function IoAtSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M407.6 115.78c-32.07-35-79.47-53.51-137.09-53.51-51 0-100.69 19.8-139.82 55.76s-63.13 83.84-67.63 134.83c-4.55 51.67 11.41 100.29 44.94 136.9 33.37 36.44 80.07 56.51 131.49 56.51 32.52 0 53.61-2.36 85.48-15.75l14.75-6.2-12.4-29.5-14.75 6.18c-27.15 11.4-43.78 13.25-73.08 13.25-42.34 0-80.65-16.38-107.89-46.12-27.4-29.92-40.42-69.86-36.66-112.48 7.84-89 86.6-161.4 175.57-161.4 48.4 0 87.65 14.91 113.49 43.13 24.61 26.87 35.6 63.92 31.79 107.15-3.29 37.35-17.76 55.74-29.32 64.6-11 8.44-22 10.18-28 9.11-17.68-3.13-26.87-20.46-24.59-46.29l9.93-109.12L311.9 160l-2 22.29a79.69 79.69 0 00-57.32-24c-23.8 0-46.54 10.07-64 28.37-16.77 17.53-27.23 41.05-29.45 66.22-2.45 27.87 5.75 54.34 22.51 72.64a76.14 76.14 0 0056.88 24.77A93 93 0 00310 318a60 60 0 0042.88 31.81c16.89 3 36.73-2.69 53.08-15.21 30.19-23.13 39.36-60.19 41.74-87.2 4.52-51.7-9.7-98.4-40.1-131.62zm-126.34 186a62.19 62.19 0 01-42.81 16.53 43.94 43.94 0 01-33.28-14.38c-10.71-11.7-15.9-29.27-14.23-48.22 3.23-36.68 30.29-65.4 61.61-65.4a48.16 48.16 0 0135.88 15.82c10.87 11.87 16.2 28.87 14.63 46.73-1.78 20.28-9.33 37.14-21.8 48.88z"}}]})(props);
	};
	module.exports.IoAt = function IoAt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 254.27c-4.5 51-40.12 80-80.55 80s-67.34-35.82-63.45-80 37.12-80 77.55-80 70.33 36 66.45 80z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M319.77 415.77c-28.56 12-47.28 14.5-79.28 14.5-97.2 0-169-78.8-160.49-176s94.31-176 191.51-176C381 78.27 441.19 150 432.73 246c-6.31 71.67-52.11 92.32-76.09 88.07-22.56-4-41.18-24.42-37.74-63.5l8.48-96.25"}}]})(props);
	};
	module.exports.IoAttachOutline = function IoAttachOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M216.08 192v143.85a40.08 40.08 0 0080.15 0l.13-188.55a67.94 67.94 0 10-135.87 0v189.82a95.51 95.51 0 10191 0V159.74"}}]})(props);
	};
	module.exports.IoAttachSharp = function IoAttachSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M216.08 192v143.55a40.08 40.08 0 0080.15 0l.13-188.55a67.94 67.94 0 10-135.87 0v189.82a95.51 95.51 0 00191 0V159.44"}}]})(props);
	};
	module.exports.IoAttach = function IoAttach (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M216.08 192v143.85a40.08 40.08 0 0080.15 0l.13-188.55a67.94 67.94 0 10-135.87 0v189.82a95.51 95.51 0 10191 0V159.74"}}]})(props);
	};
	module.exports.IoBackspaceOutline = function IoBackspaceOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M135.19 390.14a28.79 28.79 0 0021.68 9.86h246.26A29 29 0 00432 371.13V140.87A29 29 0 00403.13 112H156.87a28.84 28.84 0 00-21.67 9.84v0L46.33 256l88.86 134.11z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M336.67 192.33L206.66 322.34m130.01 0L206.66 192.33m130.01 0L206.66 322.34m130.01 0L206.66 192.33"}}]})(props);
	};
	module.exports.IoBackspaceSharp = function IoBackspaceSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144 96L32 256l112 160h304V96zm215.3 226.34L336.67 345l-65-65-65 65L184 322.34l65-65-65-65 22.63-22.63 65 65 65-65 22.63 22.63-65 65z"}}]})(props);
	};
	module.exports.IoBackspace = function IoBackspace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.13 96H156.87a44.9 44.9 0 00-33.68 15.27 15.88 15.88 0 00-1.91 2.7L32 247.75a16 16 0 000 16.5l89.15 133.57a16.24 16.24 0 002 2.88 44.89 44.89 0 0033.7 15.3h246.28A44.92 44.92 0 00448 371.13V140.87A44.92 44.92 0 00403.13 96zM348 311a16 16 0 11-22.63 22.62L271.67 280 218 333.65A16 16 0 01195.35 311L249 257.33l-53.69-53.69A16 16 0 01218 181l53.69 53.7 53.67-53.7A16 16 0 01348 203.64l-53.7 53.69z"}}]})(props);
	};
	module.exports.IoBagAddOutline = function IoBagAddOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 256v128m64-64H192M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"}}]})(props);
	};
	module.exports.IoBagAddSharp = function IoBagAddSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm156 187h-64v64h-32v-64h-64v-32h64v-64h32v64h64z"}}]})(props);
	};
	module.exports.IoBagAdd = function IoBagAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M454.66 169.4A31.86 31.86 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.78 31.78 0 00-9.34-22.6zM320 336h-48v48a16 16 0 01-32 0v-48h-48a16 16 0 010-32h48v-48a16 16 0 0132 0v48h48a16 16 0 010 32zm16-176H176v-16a80 80 0 01160 0z"}}]})(props);
	};
	module.exports.IoBagCheckOutline = function IoBagCheckOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 264l-89.6 112-38.4-44.88"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"}}]})(props);
	};
	module.exports.IoBagCheckSharp = function IoBagCheckSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm50.81 252.12l-61.37-71.72 24.31-20.81L230 350.91l87.51-109.4 25 20z"}}]})(props);
	};
	module.exports.IoBagCheck = function IoBagCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M454.65 169.4A31.82 31.82 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.75 31.75 0 00-9.35-22.6zM332.49 274l-89.6 112a16 16 0 01-12.23 6h-.26a16 16 0 01-12.16-5.6l-38.4-44.88a16 16 0 1124.32-20.8L230 350.91 307.51 254a16 16 0 0125 20zM336 160H176v-16a80 80 0 01160 0z"}}]})(props);
	};
	module.exports.IoBagHandleOutline = function IoBagHandleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 224v16a96 96 0 0096 96h0a96 96 0 0096-96v-16"}}]})(props);
	};
	module.exports.IoBagHandleSharp = function IoBagHandleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm188 91a112 112 0 01-224 0v-32h32v32a80 80 0 00160 0v-32h32z"}}]})(props);
	};
	module.exports.IoBagHandle = function IoBagHandle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M454.65 169.4A31.82 31.82 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.75 31.75 0 00-9.35-22.6zM176 144a80 80 0 01160 0v16H176zm192 96a112 112 0 01-224 0v-16a16 16 0 0132 0v16a80 80 0 00160 0v-16a16 16 0 0132 0z"}}]})(props);
	};
	module.exports.IoBagOutline = function IoBagOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"}}]})(props);
	};
	module.exports.IoBagRemoveOutline = function IoBagRemoveOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 320H192M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"}}]})(props);
	};
	module.exports.IoBagRemoveSharp = function IoBagRemoveSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm156 187H176v-32h160z"}}]})(props);
	};
	module.exports.IoBagRemove = function IoBagRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M454.66 169.4A31.86 31.86 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.78 31.78 0 00-9.34-22.6zM320 336H192a16 16 0 010-32h128a16 16 0 010 32zm16-176H176v-16a80 80 0 01160 0z"}}]})(props);
	};
	module.exports.IoBagSharp = function IoBagSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M372 160v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-40 0H180v-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148z"}}]})(props);
	};
	module.exports.IoBag = function IoBag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M454.65 169.4A31.82 31.82 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.75 31.75 0 00-9.35-22.6zM176 144a80 80 0 01160 0v16H176z"}}]})(props);
	};
	module.exports.IoBalloonOutline = function IoBalloonOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M414.11 153.82C429.66 264.4 345.85 357.09 282.54 366s-169.48-57.5-185-167.68a159.82 159.82 0 11316.53-44.49z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M236.06 308.05c-32.83-13-67.08-43.1-82.27-85.46M367.7 495.78c-32.83-13-63.31-40.06-78.5-82.41"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M266.71 368.21l-9.17 49.61 63.31-8.9-22.49-45.16-31.65 4.45z"}}]})(props);
	};
	module.exports.IoBalloonSharp = function IoBalloonSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M391 307.27c32.75-46.35 46.59-101.63 39-155.68C416.47 55.59 327.38-11.54 231.38 2S68.24 104.53 81.73 200.53c7.57 53.89 36.12 103.16 80.37 138.74 26.91 21.64 57.59 36.1 86.05 41.33l-8.36 45.23a8 8 0 009 9.38L279 431c15.9 35.87 41.65 60.48 78.41 75l14.88 5.88 11.77-29.75-14.88-5.89c-26.35-10.42-44.48-26.16-57-49.92l21.84-3.07a8 8 0 006.05-11.49l-20.49-41.16c25.98-12.87 51.49-35.18 71.42-63.33zm-160.82 15.66c-41.26-16.32-76.3-52.7-91.45-94.94l-5.4-15.06 30.12-10.8 5.4 15.06c14.5 40.44 47.27 65.77 73.1 76l14.88 5.88-11.77 29.76z"}}]})(props);
	};
	module.exports.IoBalloon = function IoBalloon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M391 307.27c32.75-46.35 46.59-101.63 39-155.68A175.82 175.82 0 00231.38 2c-96 13.49-163.14 102.58-149.65 198.58 7.57 53.89 36.12 103.16 80.37 138.74 24.58 19.68 52.31 33.5 78.62 39.68a8 8 0 016 9.22l-4.87 26.38a16.29 16.29 0 001.48 10.57 16 16 0 0014.2 8.61 15.21 15.21 0 002.23-.16l17.81-2.5a2 2 0 012.09 1.14c16.72 36.31 45.46 63.85 82.15 78.36a16 16 0 0021-9.65c2.83-8.18-1.64-17.07-9.68-20.28a118.57 118.57 0 01-59.3-51.88 2 2 0 011.45-3l7.4-1a16.54 16.54 0 0010.08-5.23 16 16 0 002.39-17.8l-12.06-24.23a8 8 0 013.26-10.55c23.59-13.17 46.45-34 64.65-59.73zm-154.9 16.78a16 16 0 01-5.88-1.12c-41.26-16.32-76.3-52.7-91.45-94.94a16 16 0 1130.12-10.8c14.5 40.44 47.27 65.77 73.1 76a16 16 0 01-5.89 30.88z"}}]})(props);
	};
	module.exports.IoBanOutline = function IoBanOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"208","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M108.92 108.92l294.16 294.16"}}]})(props);
	};
	module.exports.IoBanSharp = function IoBanSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM432 256a175.09 175.09 0 01-35.8 106.26L149.74 115.8A175.09 175.09 0 01256 80c97.05 0 176 79 176 176zm-352 0a175.09 175.09 0 0135.8-106.26L362.26 396.2A175.09 175.09 0 01256 432c-97 0-176-78.95-176-176z"}}]})(props);
	};
	module.exports.IoBan = function IoBan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"200","fill":"none","strokeMiterlimit":"10","strokeWidth":"48"}},{"tag":"path","attr":{"strokeMiterlimit":"10","strokeWidth":"48","d":"M114.58 114.58l282.84 282.84"}}]})(props);
	};
	module.exports.IoBandageOutline = function IoBandageOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"560.87","height":"176.25","x":"-24.43","y":"167.88","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"88.12","ry":"88.12","transform":"rotate(-45 256 256.002)"}},{"tag":"rect","attr":{"width":"176","height":"196","x":"169.41","y":"156.59","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"32","ry":"32","transform":"rotate(45 257.409 254.582)"}},{"tag":"circle","attr":{"cx":"256","cy":"208","r":"16"}},{"tag":"circle","attr":{"cx":"304","cy":"256","r":"16"}},{"tag":"circle","attr":{"cx":"208","cy":"256","r":"16"}},{"tag":"circle","attr":{"cx":"256","cy":"304","r":"16"}}]})(props);
	};
	module.exports.IoBandageSharp = function IoBandageSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M27.71 337.1a40 40 0 000 56.54l90.65 90.65a40 40 0 0056.54 0l75.1-75.1L102.81 262zM496 147.1a39.87 39.87 0 00-11.75-28.38l-91-91a40.14 40.14 0 00-56.75 0L264 100.28 411.72 248l72.53-72.53A39.85 39.85 0 00496 147.1zM273.06 386.19l116-116L241.77 123l-116 116zm19.63-141.5a16 16 0 110 22.62 16 16 0 010-22.62zm-48-48a16 16 0 110 22.62 16 16 0 010-22.62zm0 96a16 16 0 110 22.62 16 16 0 010-22.62zm-25.38-48a16 16 0 11-22.62 0 16 16 0 0122.62 0z"}}]})(props);
	};
	module.exports.IoBandage = function IoBandage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M275.8 157a16 16 0 00-22.63 0l-93.34 93.34a16 16 0 000 22.63l79.2 79.2a16 16 0 0022.63 0L355 258.83a16 16 0 000-22.63zM137.21 295.6a47.81 47.81 0 01-9.43-13.38L69 341a72.2 72.2 0 000 102 72.37 72.37 0 00102 0l58.77-58.76a47.81 47.81 0 01-13.38-9.43zM392 48a71.55 71.55 0 00-51 21l-55.92 55.91a48.05 48.05 0 0113.36 9.45l79.19 79.19a48.05 48.05 0 019.45 13.36L443 171a72 72 0 00-51-123z"}},{"tag":"path","attr":{"d":"M275.8 157a16 16 0 00-22.63 0l-93.34 93.34a16 16 0 000 22.63l79.2 79.2a16 16 0 0022.63 0L355 258.83a16 16 0 000-22.63zm-56.49 110.31a16 16 0 110-22.62 16 16 0 010 22.62zm48 48a16 16 0 110-22.62 16 16 0 010 22.62zm0-96a16 16 0 110-22.62 16 16 0 010 22.62zm48 48a16 16 0 110-22.62 16 16 0 010 22.62zm150.3-220.92a104.38 104.38 0 00-147.25 0l-69.76 69.89a4 4 0 004.2 6.58 35.74 35.74 0 0111.69-2.54 47.7 47.7 0 0133.94 14.06l79.19 79.19a47.7 47.7 0 0114.06 33.94 35.68 35.68 0 01-2.54 11.69 4 4 0 006.58 4.2l69.89-69.76a104.38 104.38 0 000-147.25z"}},{"tag":"path","attr":{"d":"M254.34 386.83a47.91 47.91 0 01-33.94-14l-79.19-79.23a47.81 47.81 0 01-9.43-13.38c-4.59-9.7-1.39-25 2.48-36.9a4 4 0 00-6.64-4l-77.23 77.04a104.12 104.12 0 00147.25 147.25l72.75-72.88a4 4 0 00-4.21-6.58c-4.18 1.58-8.4 2.68-11.84 2.68z"}}]})(props);
	};
	module.exports.IoBarChartOutline = function IoBarChartOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M32 32v432a16 16 0 0016 16h432"}},{"tag":"rect","attr":{"width":"80","height":"192","x":"96","y":"224","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"20","ry":"20"}},{"tag":"rect","attr":{"width":"80","height":"240","x":"240","y":"176","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"20","ry":"20"}},{"tag":"rect","attr":{"width":"80","height":"304","x":"383.64","y":"112","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"20","ry":"20"}}]})(props);
	};
	module.exports.IoBarChartSharp = function IoBarChartSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 496H16V16h32v448h448v32z"}},{"tag":"path","attr":{"d":"M192 432H80V208h112zm144 0H224V160h112zm143.64 0h-112V96h112z"}}]})(props);
	};
	module.exports.IoBarChart = function IoBarChart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 496H48a32 32 0 01-32-32V32a16 16 0 0132 0v432h432a16 16 0 010 32z"}},{"tag":"path","attr":{"d":"M156 432h-40a36 36 0 01-36-36V244a36 36 0 0136-36h40a36 36 0 0136 36v152a36 36 0 01-36 36zm144 0h-40a36 36 0 01-36-36V196a36 36 0 0136-36h40a36 36 0 0136 36v200a36 36 0 01-36 36zm143.64 0h-40a36 36 0 01-36-36V132a36 36 0 0136-36h40a36 36 0 0136 36v264a36 36 0 01-36 36z"}}]})(props);
	};
	module.exports.IoBarbellOutline = function IoBarbellOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 256h416"}},{"tag":"rect","attr":{"width":"32","height":"256","x":"384","y":"128","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"16","ry":"16"}},{"tag":"rect","attr":{"width":"32","height":"256","x":"96","y":"128","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"16","ry":"16"}},{"tag":"rect","attr":{"width":"16","height":"128","x":"32","y":"192","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"16","height":"128","x":"464","y":"192","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"8","ry":"8"}}]})(props);
	};
	module.exports.IoBarbellSharp = function IoBarbellSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 176h-58v-64h-76v122H150V112H74v64H16v160h58v64h76V278h212v122h76v-64h58V176z"}}]})(props);
	};
	module.exports.IoBarbell = function IoBarbell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M467 176a29.94 29.94 0 00-25.32 12.5 2 2 0 01-3.64-1.14v-36.65c0-20.75-16.34-38.21-37.08-38.7A38 38 0 00362 150v82a2 2 0 01-2 2H152a2 2 0 01-2-2v-81.29c0-20.75-16.34-38.21-37.08-38.7A38 38 0 0074 150v37.38a2 2 0 01-3.64 1.14A29.94 29.94 0 0045 176c-16.3.51-29 14.31-29 30.62v98.72c0 16.31 12.74 30.11 29 30.62a29.94 29.94 0 0025.32-12.5 2 2 0 013.68 1.16v36.67C74 382 90.34 399.5 111.08 400A38 38 0 00150 362v-82a2 2 0 012-2h208a2 2 0 012 2v81.29c0 20.75 16.34 38.21 37.08 38.7A38 38 0 00438 362v-37.38a2 2 0 013.64-1.14A29.94 29.94 0 00467 336c16.3-.51 29-14.31 29-30.62v-98.74c0-16.31-12.74-30.11-29-30.64z"}}]})(props);
	};
	module.exports.IoBarcodeOutline = function IoBarcodeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M384 400.33l35.13-.33A29 29 0 00448 371.13V140.87A29 29 0 00419.13 112l-35.13.33M128 112l-36.8.33c-15.88 0-27.2 13-27.2 28.87v230.27c0 15.87 11.32 28.86 27.2 28.86L128 400m256-208v128m-64-160v192m-64-176v160m-64-176v192m-64-160v128"}}]})(props);
	};
	module.exports.IoBarcodeSharp = function IoBarcodeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"32","d":"M400 400.33l48-.33V112l-48 .33M112 112l-48 .33v288l48-.33m272-208v128m-64-160v192m-64-176v160m-64-176v192m-64-160v128"}}]})(props);
	};
	module.exports.IoBarcode = function IoBarcode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M419.13 96H419l-35.05.33L128 96h-.16l-36.74.33C66.93 96.38 48 116.07 48 141.2v230.27c0 25.15 19 44.86 43.2 44.86h.15l36.71-.33 255.92.33h.17l35.07-.33A44.91 44.91 0 00464 371.13V140.87A44.92 44.92 0 00419.13 96zM144 320a16 16 0 01-32 0V192a16 16 0 0132 0zm64 32a16 16 0 01-32 0V160a16 16 0 0132 0zm64-16a16 16 0 01-32 0V176a16 16 0 0132 0zm64 16a16 16 0 01-32 0V160a16 16 0 0132 0zm64-32a16 16 0 01-32 0V192a16 16 0 0132 0z"}}]})(props);
	};
	module.exports.IoBaseballOutline = function IoBaseballOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M294.25 108.6l-60.57 17.59m83.45 29.92l-51.5 36.4m90.26 2.36l-36.4 51.5m83.91-28.62l-17.59 60.57"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"192","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M432.94 255.05a192 192 0 01-176.31-180.7M108.54 294.31l17.59-60.57m29.92 83.45l36.4-51.5m2.36 90.26l51.5-36.4m-28.62 83.91l60.57-17.59M255 433.61A192 192 0 0074.29 256.69"}}]})(props);
	};
	module.exports.IoBaseballSharp = function IoBaseballSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M302.16 56.2a13.88 13.88 0 01-3.42 8.91l-.11 5.13-27.71-.57c0 1.3.09 2.61.16 3.91a177.33 177.33 0 003.45 26.31l24.72-7.18 7.81 26.88-24.71 7.18a177.21 177.21 0 0013.34 27.69l21.27-15 16.16 22.86-21.29 15.05q5.25 6.33 11.11 12.19c3.91 3.91 8 7.6 12.2 11.1l15.71-22.22 22.86 16.16L358 216.75a178.78 178.78 0 0027.68 13.32l7.49-25.8 26.89 7.81-7.5 25.83a177.8 177.8 0 0031 3.67l-.41-24.67 17.41-.29A208 208 0 00301.82 52.93a13.65 13.65 0 01.34 3.27zM214 441.64l27.91.49a177.46 177.46 0 00-3.62-29.95l-24.14 7-7.81-26.88 24.11-7a177.92 177.92 0 00-13.33-27.68L196.79 372l-16.16-22.86L201 334.73c-3.49-4.22-7.19-8.3-11.09-12.2s-8-7.62-12.19-11.12l-13.91 19.68L141 314.93l13.9-19.66a177.26 177.26 0 00-27.7-13.33l-6.37 21.94-26.89-7.81 6.38-22a177.32 177.32 0 00-26.32-3.4c-1.59-.09-3.18-.16-4.78-.2l.4 22.34-17.71.32a207.88 207.88 0 00161.81 166.48z"}},{"tag":"path","attr":{"d":"M444.65 302.67l-.55-33.06a206 206 0 01-39.33-4.74L397 291.8l-26.94-7.8 7.83-27a206.91 206.91 0 01-36.06-17.35l-16.36 23.15-22.86-16.16 16.33-23.11a204.21 204.21 0 01-30-30l-22.19 15.67-16.16-22.87 22.17-15.67a206 206 0 01-17.38-36.06l-25.75 7.48-7.81-26.89 25.73-7.47q-2-9.21-3.18-18.64h-.47l-.78-14-.33-6-17.94-.32a13.38 13.38 0 01-1.79-.16l-6.35-.13.06-2.47a14 14 0 01-5.66-11.49 13.27 13.27 0 01.13-1.67A208 208 0 0052.16 217.43l16.1-.28.45 25.18 6.83.38 14 .77v.48q9.42 1.17 18.64 3.18l6.68-23L141.7 232l-6.7 23a205.3 205.3 0 0136.06 17.38l14.53-20.56L208.47 268 194 288.5a203.5 203.5 0 0130 30l21.3-15 16.16 22.86-21.36 15.05a206.86 206.86 0 0117.34 36.06l25.27-7.33 7.81 26.86-25.24 7.33a205.9 205.9 0 014.72 38.3l29.42.53-.29 16.48a207.94 207.94 0 00160-157.21z"}}]})(props);
	};
	module.exports.IoBaseball = function IoBaseball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M444 295.67l-.47-26.07a205.42 205.42 0 01-39.27-4.73l-5 17.35a14 14 0 11-26.88-7.81l5-17.38a206.47 206.47 0 01-36.05-17.35l-10.44 14.77a14 14 0 01-22.87-16.16l10.41-14.73a204.8 204.8 0 01-30-30L273.71 204a14 14 0 01-16.16-22.87l14.74-10.42a205.3 205.3 0 01-17.38-36.06l-17.32 5a14 14 0 11-7.81-26.89l17.3-5a205.88 205.88 0 01-4.43-32.59q-.17-3-.24-6l-18.22-.33a14 14 0 01-13.74-14A208 208 0 0055 202.42a16 16 0 0115 15.66l.44 24.43c1.58.05 3.16.11 4.73.2a205.88 205.88 0 0132.59 4.43l5-17.3a14 14 0 0126.89 7.81l-5 17.32a205.21 205.21 0 0136 17.38L181 257.61a14 14 0 0122.87 16.16l-10.39 14.73a205.65 205.65 0 0115.79 14.23 203.79 203.79 0 0114.23 15.79l14.73-10.41A14 14 0 01254.39 331l-14.76 10.43A206.86 206.86 0 01257 377.47l17.38-5.05a14 14 0 017.81 26.89l-17.35 5a205.89 205.89 0 014.7 38.28l18.27.33a16 16 0 0115.71 16.28 11.69 11.69 0 01-.08 1.19 208 208 0 00153.39-151.03A14 14 0 01444 295.67z"}},{"tag":"path","attr":{"d":"M301.49 56.2A14 14 0 01287.5 70h-.25l-16.81-.3c.05 1.31.1 2.62.17 3.93a178.83 178.83 0 003.44 26.31l16.29-4.74a14 14 0 017.81 26.8l-16.27 4.73a178.06 178.06 0 0013.33 27.69l13.84-9.78a14 14 0 1116.16 22.87l-13.86 9.79q5.25 6.33 11.12 12.19c3.9 3.91 8 7.6 12.2 11.1l9.78-13.84A14 14 0 11367.32 203l-9.76 13.8a178.83 178.83 0 0027.68 13.33l4.76-16.28a14 14 0 0126.89 7.81l-4.73 16.26a177.72 177.72 0 0030.95 3.65l-.16-9a14 14 0 0113.75-14.24h.25a14.67 14.67 0 012.59.25 208 208 0 00-158-163.51c-.06.4-.04.76-.05 1.13zm-93.05 401.35a16 16 0 0116.28-15.71l16.76.29a178.49 178.49 0 00-3.62-29.95l-16.26 4.72a14 14 0 11-7.81-26.9l16.21-4.7a177.92 177.92 0 00-13.33-27.68l-13.8 9.76a14 14 0 11-16.16-22.87l13.84-9.78c-3.5-4.22-7.19-8.3-11.1-12.2s-8-7.62-12.19-11.12l-9.79 13.86a14 14 0 11-22.87-16.16l9.78-13.84a177.16 177.16 0 00-27.69-13.33L122 298.21a14 14 0 11-26.9-7.81l4.73-16.29a177.32 177.32 0 00-26.31-3.44c-.89-.05-1.79-.08-2.68-.12l.16 10.59a16 16 0 01-15.71 16.28H55a16 16 0 01-3.94-.51 208 208 0 00157.65 163.87 15.72 15.72 0 01-.27-3.23z"}}]})(props);
	};
	module.exports.IoBasketOutline = function IoBasketOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M68.4 192A20.38 20.38 0 0048 212.2a17.87 17.87 0 00.8 5.5L100.5 400a40.46 40.46 0 0039.1 29.5h232.8a40.88 40.88 0 0039.3-29.5l51.7-182.3.6-5.5a20.38 20.38 0 00-20.4-20.2H68.4zm193.32 160.07A42.07 42.07 0 11304 310a42.27 42.27 0 01-42.28 42.07z"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M160 192l96-128 96 128"}}]})(props);
	};
	module.exports.IoBasketSharp = function IoBasketSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M339.2 217.6L256 106.67 172.8 217.6l-25.6-19.2 96-128a16 16 0 0125.6 0l96 128z"}},{"tag":"path","attr":{"d":"M441.59 192H70.41a12 12 0 00-11.68 14.77L112.59 434h286.82l53.86-227.23A12 12 0 00441.59 192zM256 351.66A37.71 37.71 0 11293.89 314 37.88 37.88 0 01256 351.66z"}}]})(props);
	};
	module.exports.IoBasket = function IoBasket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424.11 192H360L268.8 70.4a16 16 0 00-25.6 0L152 192H87.89a32.57 32.57 0 00-32.62 32.44 30.3 30.3 0 001.31 9l46.27 163.14a50.72 50.72 0 0048.84 36.91h208.62a51.21 51.21 0 0049-36.86l46.33-163.36a15.62 15.62 0 00.46-2.36l.53-4.93a13.3 13.3 0 00.09-1.55A32.57 32.57 0 00424.11 192zM256 106.67L320 192H192zm0 245a37.7 37.7 0 1137.88-37.7A37.87 37.87 0 01256 351.63z"}}]})(props);
	};
	module.exports.IoBasketballOutline = function IoBasketballOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"192","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M432.94 255.05a192 192 0 01-176.31-180.7M255 433.61A192 192 0 0074.29 256.69m45.95-136.45l271.52 271.52m-271.52 0l271.52-271.52"}}]})(props);
	};
	module.exports.IoBasketballSharp = function IoBasketballSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 233.37l34.45-34.45a207.08 207.08 0 01-50.12-135.25c0-5 .19-10.05.54-15A207.09 207.09 0 00120.67 98zm57.14-57.14L391.33 98A207.07 207.07 0 00273 48.8c-.41 4.9-.64 9.86-.64 14.87a175.25 175.25 0 0040.78 112.56zm22.63 22.63a175.25 175.25 0 00112.56 40.81c5 0 10-.23 14.87-.64A207.07 207.07 0 00414 120.67zM176.23 313.14a175.23 175.23 0 00-112.56-40.81q-7.52 0-14.87.64A207.07 207.07 0 0098 391.33zM256 278.63l-34.45 34.45a207.08 207.08 0 0150.12 135.25c0 5-.19 10.05-.54 15A207.06 207.06 0 00391.33 414zm192.33-6.96a207.08 207.08 0 01-135.25-50.12L278.63 256 414 391.33a207.09 207.09 0 0049.39-120.2c-5.01.35-10.02.54-15.06.54zM233.37 256L98 120.67a207.06 207.06 0 00-49.39 120.2c5-.35 10-.54 15-.54a207.08 207.08 0 01135.25 50.12zm-112.7 158A207.07 207.07 0 00239 463.2q.63-7.35.64-14.87a175.23 175.23 0 00-40.81-112.56z"}}]})(props);
	};
	module.exports.IoBasketball = function IoBasketball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 233.37l34.45-34.45a207.08 207.08 0 01-50.12-135.25c0-5 .19-10.05.54-15A207.09 207.09 0 00120.67 98zm57.14-57.14L391.33 98A207.07 207.07 0 00273 48.8c-.41 4.9-.64 9.86-.64 14.87a175.25 175.25 0 0040.78 112.56zm22.63 22.63a175.25 175.25 0 00112.56 40.81c5 0 10-.23 14.87-.64A207.07 207.07 0 00414 120.67zM176.23 313.14a175.23 175.23 0 00-112.56-40.81q-7.52 0-14.87.64A207.07 207.07 0 0098 391.33zM256 278.63l-34.45 34.45a207.08 207.08 0 0150.12 135.25c0 5-.19 10.05-.54 15A207.06 207.06 0 00391.33 414zm192.33-6.96a207.08 207.08 0 01-135.25-50.12L278.63 256 414 391.33a207.09 207.09 0 0049.39-120.2c-5.01.35-10.02.54-15.06.54zM233.37 256L98 120.67a207.06 207.06 0 00-49.39 120.2c5-.35 10-.54 15-.54a207.08 207.08 0 01135.25 50.12zm-112.7 158A207.07 207.07 0 00239 463.2q.63-7.35.64-14.87a175.23 175.23 0 00-40.81-112.56z"}}]})(props);
	};
	module.exports.IoBatteryChargingOutline = function IoBatteryChargingOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 322.3V189.7A29.74 29.74 0 0177.7 160h137.44l24.4-32H77.7A61.77 61.77 0 0016 189.7v132.6A61.77 61.77 0 0077.7 384h96.85a22.57 22.57 0 01.26-7.32l.15-.75.21-.73 6.5-23.2H77.7A29.74 29.74 0 0148 322.3zM386.3 128h-98.64a22.69 22.69 0 01-.27 7.2l-.15.74-.21.73-6.54 23.33H386.3a29.74 29.74 0 0129.7 29.7v132.6a29.74 29.74 0 01-29.7 29.7H247l-24.42 32H386.3a61.77 61.77 0 0061.7-61.7V189.7a61.77 61.77 0 00-61.7-61.7z"}},{"tag":"path","attr":{"d":"M162.65 294.16a24.37 24.37 0 01-21.56-13 25 25 0 011.42-25.83l.31-.46.33-.44L197.62 183H89.69a20 20 0 00-20 20v106a20 20 0 0020 20h98.42l9.78-34.86z"}},{"tag":"path","attr":{"d":"M276.07 280.89l27.07-35.49a5.2 5.2 0 00.77-1.91 5 5 0 00.08-.66 5 5 0 00-.08-1.29 5.11 5.11 0 00-.68-1.75 4.76 4.76 0 00-.78-.95 3.48 3.48 0 00-.48-.38 4 4 0 00-1.11-.55 4.28 4.28 0 00-1.31-.2h-61.62l12.12-43.21 3.23-11.5 6.21-22.16.51-1.84 7.79-27.76a3.51 3.51 0 00.05-.55v-.16c0-.05 0-.26-.05-.38s0-.09 0-.14a2.2 2.2 0 00-.17-.45 3.77 3.77 0 00-.26-.39l-.09-.1a2.73 2.73 0 00-.25-.23l-.1-.08a3.14 3.14 0 00-.39-.24 2 2 0 00-.41-.14h-.59a2.3 2.3 0 00-.45 0 1.9 1.9 0 00-.42.15l-.13.07-.3.21-.11.1a2.4 2.4 0 00-.36.41l-18 23.63-13.14 17.22-9.85 12.83-63.71 83.55a5.72 5.72 0 00-.44.8 4.78 4.78 0 00-.35 1.09 4.7 4.7 0 00-.08 1.29 4.86 4.86 0 002 3.71 4.74 4.74 0 00.54.31 4.31 4.31 0 001.89.43h61.62L194.42 380.6a3.64 3.64 0 000 .56v.15a2.32 2.32 0 00.06.38.58.58 0 000 .14 2.2 2.2 0 00.17.45 3.62 3.62 0 00.26.38l.09.1.25.24a.39.39 0 01.1.08 2.22 2.22 0 00.39.23 2.83 2.83 0 00.41.14h.13a1.86 1.86 0 00.33 0h.13a2.32 2.32 0 00.45-.06 2.05 2.05 0 00.41-.16l.13-.07.3-.21.11-.09a2.4 2.4 0 00.36-.41L221.82 352l17.53-23z"}},{"tag":"path","attr":{"d":"M319.5 256.93l-.46.6L264.51 329h109.8a20 20 0 0020-20V203a20 20 0 00-20-20H274.05l-9.74 34.73h35.24A24.35 24.35 0 01321 230.5a25.21 25.21 0 01-1 25.79zM480 202.67a16 16 0 00-16 16v74.66a16 16 0 0032 0v-74.66a16 16 0 00-16-16z"}}]})(props);
	};
	module.exports.IoBatteryChargingSharp = function IoBatteryChargingSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M306.68 237.62h-66.5l15.33-54.7 6.43-22.92 3.94-14 4.29-15.33a3.56 3.56 0 00.06-.44v-.19a1.85 1.85 0 000-.23 2 2 0 000-.24v-.14c0-.1-.07-.19-.11-.29v-.05a2.33 2.33 0 00-2-1.35h-.1a2.25 2.25 0 00-1.8 1l-12.5 17.15-18.82 25.55-8.36 11.48-35.41 48.6L160 274.26h66.44l-30 107a3.93 3.93 0 00-.06.48v.1a1.94 1.94 0 000 .34.29.29 0 000 .09 3 3 0 00.07.32v.06a1.83 1.83 0 00.14.32 2.38 2.38 0 001.52 1.16h.57a2.1 2.1 0 001.31-.5l.06-.05a2.6 2.6 0 00.42-.45L223.3 352l13-17.82z"}},{"tag":"path","attr":{"d":"M289.78 134.55l-.14.74-.21.73-6.72 24H417V352H248.05l-23.33 32H449V128H290.13a22.62 22.62 0 01-.35 6.55zM49 160h169.49l23.31-32H17v256h159.49a22.73 22.73 0 01.34-6.67l.15-.75.2-.73 6.69-23.85H49z"}},{"tag":"path","attr":{"d":"M264.76 329.08h130.55V182.92H276.28l-9.73 34.7H346l-23.16 31.78-58.08 79.68zM160 294.26h-39.31l23.15-31.78 57.95-79.56H70.69v146.16h119.6l9.77-34.82H160zm305-91.59h32v106.67h-32z"}}]})(props);
	};
	module.exports.IoBatteryCharging = function IoBatteryCharging (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 322.3V189.7A29.74 29.74 0 0177.7 160h137.44l24.4-32H77.7A61.77 61.77 0 0016 189.7v132.6A61.77 61.77 0 0077.7 384h96.85a22.57 22.57 0 01.26-7.32l.15-.75.21-.73 6.5-23.2H77.7A29.74 29.74 0 0148 322.3zM386.3 128h-98.64a22.69 22.69 0 01-.27 7.2l-.15.74-.21.73-6.54 23.33H386.3a29.74 29.74 0 0129.7 29.7v132.6a29.74 29.74 0 01-29.7 29.7H247l-24.42 32H386.3a61.77 61.77 0 0061.7-61.7V189.7a61.77 61.77 0 00-61.7-61.7z"}},{"tag":"path","attr":{"d":"M162.65 294.16a24.37 24.37 0 01-21.56-13 25 25 0 011.42-25.83l.31-.46.33-.44L197.62 183H89.69a20 20 0 00-20 20v106a20 20 0 0020 20h98.42l9.78-34.86z"}},{"tag":"path","attr":{"d":"M276.07 280.89l27.07-35.49a5.2 5.2 0 00.77-1.91 5 5 0 00.08-.66 5 5 0 00-.08-1.29 5.11 5.11 0 00-.68-1.75 4.76 4.76 0 00-.78-.95 3.48 3.48 0 00-.48-.38 4 4 0 00-1.11-.55 4.28 4.28 0 00-1.31-.2h-61.62l12.12-43.21 3.23-11.5 6.21-22.16.51-1.84 7.79-27.76a3.51 3.51 0 00.05-.55v-.16c0-.05 0-.26-.05-.38s0-.09 0-.14a2.2 2.2 0 00-.17-.45 3.77 3.77 0 00-.26-.39l-.09-.1a2.73 2.73 0 00-.25-.23l-.1-.08a3.14 3.14 0 00-.39-.24 2 2 0 00-.41-.14h-.59a2.3 2.3 0 00-.45 0 1.9 1.9 0 00-.42.15l-.13.07-.3.21-.11.1a2.4 2.4 0 00-.36.41l-18 23.63-13.14 17.22-9.85 12.83-63.71 83.55a5.72 5.72 0 00-.44.8 4.78 4.78 0 00-.35 1.09 4.7 4.7 0 00-.08 1.29 4.86 4.86 0 002 3.71 4.74 4.74 0 00.54.31 4.31 4.31 0 001.89.43h61.62L194.42 380.6a3.64 3.64 0 000 .56v.15a2.32 2.32 0 00.06.38.58.58 0 000 .14 2.2 2.2 0 00.17.45 3.62 3.62 0 00.26.38l.09.1.25.24a.39.39 0 01.1.08 2.22 2.22 0 00.39.23 2.83 2.83 0 00.41.14h.13a1.86 1.86 0 00.33 0h.13a2.32 2.32 0 00.45-.06 2.05 2.05 0 00.41-.16l.13-.07.3-.21.11-.09a2.4 2.4 0 00.36-.41L221.82 352l17.53-23z"}},{"tag":"path","attr":{"d":"M319.5 256.93l-.46.6L264.51 329h109.8a20 20 0 0020-20V203a20 20 0 00-20-20H274.05l-9.74 34.73h35.24A24.35 24.35 0 01321 230.5a25.21 25.21 0 01-1 25.79zM480 202.67a16 16 0 00-16 16v74.66a16 16 0 0032 0v-74.66a16 16 0 00-16-16z"}}]})(props);
	};
	module.exports.IoBatteryDeadOutline = function IoBatteryDeadOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"400","height":"224","x":"31","y":"144","fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","rx":"45.7","ry":"45.7"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M479 218.67v74.66"}}]})(props);
	};
	module.exports.IoBatteryDeadSharp = function IoBatteryDeadSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M32 144h400v224H32zm448 74.67v74.66"}}]})(props);
	};
	module.exports.IoBatteryDead = function IoBatteryDead (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"400","height":"224","x":"31","y":"144","fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","rx":"45.7","ry":"45.7"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M479 218.67v74.66"}}]})(props);
	};
	module.exports.IoBatteryFullOutline = function IoBatteryFullOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"400","height":"224","x":"32","y":"144","fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","rx":"45.7","ry":"45.7"}},{"tag":"rect","attr":{"width":"292.63","height":"114.14","x":"85.69","y":"198.93","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","rx":"4","ry":"4"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M480 218.67v74.66"}}]})(props);
	};
	module.exports.IoBatteryFullSharp = function IoBatteryFullSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M17 384h432V128H17zm32-224h368v192H49z"}},{"tag":"path","attr":{"d":"M70.69 182.94h324.63v146.13H70.69zM465 202.67h32v106.67h-32z"}}]})(props);
	};
	module.exports.IoBatteryFull = function IoBatteryFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"400","height":"224","x":"32","y":"144","fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","rx":"45.7","ry":"45.7"}},{"tag":"rect","attr":{"width":"292.63","height":"114.14","x":"85.69","y":"198.93","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","rx":"4","ry":"4"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M480 218.67v74.66"}}]})(props);
	};
	module.exports.IoBatteryHalfOutline = function IoBatteryHalfOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"400","height":"224","x":"32","y":"144","fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","rx":"45.7","ry":"45.7"}},{"tag":"rect","attr":{"width":"154.31","height":"114.13","x":"85.69","y":"198.93","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","rx":"4","ry":"4"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M480 218.67v74.66"}}]})(props);
	};
	module.exports.IoBatteryHalfSharp = function IoBatteryHalfSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M17 384h432V128H17zm32-224h368v192H49z"}},{"tag":"path","attr":{"d":"M70.69 182.92H256v146.16H70.69zM465 202.67h32v106.67h-32z"}}]})(props);
	};
	module.exports.IoBatteryHalf = function IoBatteryHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"400","height":"224","x":"32","y":"144","fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","rx":"45.7","ry":"45.7"}},{"tag":"rect","attr":{"width":"154.31","height":"114.13","x":"85.69","y":"198.93","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","rx":"4","ry":"4"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M480 218.67v74.66"}}]})(props);
	};
	module.exports.IoBeakerOutline = function IoBeakerOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M445.2 48.05L398 48H128c-54.3 0-64 35.7-64 48 30.3 4.2 48 8 48 40v264a64 64 0 0064 64h192a64 64 0 0064-64V96c0-19 11.5-38.35 12.6-40 1.2-1.9 3.4-4.4 3.4-5.5s-.3-2.45-2.8-2.45zM112 176h320"}}]})(props);
	};
	module.exports.IoBeakerSharp = function IoBeakerSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453.55 54.7L464 32H128.4c-27.74 0-49 6.57-63.31 19.51C54.39 61.27 48 74.89 48 88v24h16c31 0 32 16.79 32 35v313a20 20 0 0020 20h312a20 20 0 0020-20V96c0-17.16 2.28-34.14 5.55-41.3zM416 96v64H128v-22c0-36.15-21-51-41.77-53.46C89 70 105.7 64.05 128.4 64.05h289.92A221.83 221.83 0 00416 96z"}}]})(props);
	};
	module.exports.IoBeaker = function IoBeaker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M444 32H128c-19.38 0-45.9 4.34-64.11 24.77C52.17 69.92 48 85.66 48 96a16 16 0 0013.8 15.85C91.7 116 96 117.79 96 136v264a80.07 80.07 0 0080 80h192a80.11 80.11 0 0080-80V96c0-12.55 7.46-27.25 10-31.36l.1-.14c.22-.35.5-.72.78-1.1 2-2.79 5.09-7 5.09-12.95C464 39.79 454.89 32 444 32zM84.11 83.08c5.24-8.87 17.17-19 44.29-19h294.43C419.3 72.87 416 84.27 416 96v64H128v-24c0-37.32-21.35-48.14-43.89-52.92z"}}]})(props);
	};
	module.exports.IoBedOutline = function IoBedOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M384 240H96V136a40.12 40.12 0 0140-40h240a40.12 40.12 0 0140 40v104zM48 416V304a64.19 64.19 0 0164-64h288a64.19 64.19 0 0164 64v112"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 416v-8a24.07 24.07 0 0124-24h368a24.07 24.07 0 0124 24v8M112 240v-16a32.09 32.09 0 0132-32h80a32.09 32.09 0 0132 32v16m0 0v-16a32.09 32.09 0 0132-32h80a32.09 32.09 0 0132 32v16"}}]})(props);
	};
	module.exports.IoBedSharp = function IoBedSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 224V96a16 16 0 00-16-16H96a16 16 0 00-16 16v128a48 48 0 00-48 48v160h36v-32h376v32h36V272a48 48 0 00-48-48zm-192 0H120v-32a16 16 0 0116-16h88a16 16 0 0116 16zm32-32a16 16 0 0116-16h88a16 16 0 0116 16v32H272z"}}]})(props);
	};
	module.exports.IoBed = function IoBed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 230.7a79.44 79.44 0 00-32-6.7H112a79.51 79.51 0 00-32 6.69A80.09 80.09 0 0032 304v112a16 16 0 0032 0v-8a8.1 8.1 0 018-8h368a8.1 8.1 0 018 8v8a16 16 0 0032 0V304a80.09 80.09 0 00-48-73.3zM376 80H136a56 56 0 00-56 56v72a4 4 0 005.11 3.84A95.5 95.5 0 01112 208h4.23a4 4 0 004-3.55A32 32 0 01152 176h56a32 32 0 0131.8 28.45 4 4 0 004 3.55h24.46a4 4 0 004-3.55A32 32 0 01304 176h56a32 32 0 0131.8 28.45 4 4 0 004 3.55h4.2a95.51 95.51 0 0126.89 3.85A4 4 0 00432 208v-72a56 56 0 00-56-56z"}}]})(props);
	};
	module.exports.IoBeerOutline = function IoBeerOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 200v240a40.12 40.12 0 01-40 40H136a40.12 40.12 0 01-40-40V224"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M352 224h40a56.16 56.16 0 0156 56v80a56.16 56.16 0 01-56 56h-40"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M224 256v160m64-160v160M160 256v160m160-304a48 48 0 010 96c-13.25 0-29.31-7.31-38-16H160c-8 22-27 32-48 32a48 48 0 010-96 47.91 47.91 0 0126 9"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M91.86 132.43a40 40 0 1160.46-52S160 91 160 96m-14.17-31.29C163.22 44.89 187.57 32 216 32c52.38 0 94 42.84 94 95.21a95 95 0 01-1.67 17.79"}}]})(props);
	};
	module.exports.IoBeerSharp = function IoBeerSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 208h-80v-5.74A63.93 63.93 0 00321.65 96a111 111 0 00-27.59-47.29A108.62 108.62 0 00216 16c-29.91 0-57.78 12.28-79 34.67a56 56 0 00-67.51 77.51c-1 .86-1.91 1.74-2.83 2.66A63.56 63.56 0 0048 176.26a62.65 62.65 0 0020.77 46.54A65 65 0 0080 231v249a16 16 0 0016 16h256a16 16 0 0016-16v-48h80a16 16 0 0016-16V224a16 16 0 00-16-16zM176 432h-32V240h32zm64 0h-32V240h32zm64 0h-32V240h32zm16-240c-8.33 0-20.55-5.18-26.69-11.31l-4.68-4.69H148.79L145 186.53c-5.81 16-18.83 20.41-28.73 21.29a34.08 34.08 0 01-25.91-8.67 31 31 0 01-10.32-23 31.8 31.8 0 019.33-22.71c.16-.17.33-.32.5-.49A31.78 31.78 0 01112 144c.09 0 9.12.34 16.4 5.8l12.8 9.6 19.2-25.6-12.8-9.6A63.69 63.69 0 00112 112a64.79 64.79 0 00-14 1.55 24 24 0 0141.4-23.68l.23.35.4.46a35.78 35.78 0 015 8.94l5.62 15 30-11.24-5.62-15a68.2 68.2 0 00-10-17.74c-.38-.52-.79-1-1.19-1.51C178.38 55.45 196.64 48 216 48a76.86 76.86 0 0155.23 23.18A80.2 80.2 0 01292.61 142l-3 15.72 31.43 6 3-15.72a111.78 111.78 0 001.96-19.43 32 32 0 01-6 63.43zm112 208h-64V240h64z"}}]})(props);
	};
	module.exports.IoBeer = function IoBeer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M392 208h-24v-5.74A63.93 63.93 0 00321.65 96a111 111 0 00-27.59-47.29A108.62 108.62 0 00216 16c-29.91 0-57.78 12.28-79 34.68a56 56 0 00-67.51 77.54A63.91 63.91 0 0080 231.39V440a56.06 56.06 0 0056 56h176a56.06 56.06 0 0056-56v-8h24a72.08 72.08 0 0072-72v-80a72.08 72.08 0 00-72-72zM176 416a16 16 0 01-32 0V256a16 16 0 0132 0zm64 0a16 16 0 01-32 0V256a16 16 0 0132 0zm64 0a16 16 0 01-32 0V256a16 16 0 0132 0zm16-224c-8.33 0-20.55-5.18-26.69-11.31A16 16 0 00282 176H160a16 16 0 00-15 10.53c-6.83 18.68-23.6 21.47-33 21.47a32 32 0 010-64c.09 0 9.12.34 16.4 5.8a16 16 0 1019.2-25.6A63.69 63.69 0 00112 112a63.55 63.55 0 00-14 1.57A24 24 0 01120 80a23.78 23.78 0 0119.38 9.84 51.35 51.35 0 014.71 7.9A16 16 0 00176 96c0-6.77-3.61-15.17-10.76-25-.46-.63-1-1.25-1.45-1.86C178.39 55.44 196.64 48 216 48a76.86 76.86 0 0155.23 23.18A80.2 80.2 0 01292.61 142a16 16 0 0012.73 18.71 16.29 16.29 0 003 .28 16 16 0 0015.7-13 111.78 111.78 0 001.96-19.42 32 32 0 01-6 63.43zm112 168a40 40 0 01-40 40h-24V240h24a40 40 0 0140 40z"}}]})(props);
	};
	module.exports.IoBicycleOutline = function IoBicycleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M388 288a76 76 0 1076 76 76.24 76.24 0 00-76-76zm-264 0a76 76 0 1076 76 76.24 76.24 0 00-76-76z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 360v-86l-64-42 80-88 40 72h56"}},{"tag":"path","attr":{"d":"M320 136a31.89 31.89 0 0032-32.1A31.55 31.55 0 00320.2 72a32 32 0 10-.2 64z"}}]})(props);
	};
	module.exports.IoBicycleSharp = function IoBicycleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 192l-29.5-60.1C284.32 118 284.32 118 264 118c-13.26 0-14.76 0-23 7.3l-71.7 69.1c-8.3 8.45-9.3 9.45-9.3 26.6 0 12.67 3.78 14.61 18.51 22.9L240 278v90h32V254s-29-17-48.3-30l48.9-51.5c18.7 28.5 27.3 51.5 38 51.5H384v-32z"}},{"tag":"path","attr":{"d":"M388 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zM124 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zm196-168a31.89 31.89 0 0032-32.1A31.55 31.55 0 00320.2 64a32 32 0 10-.2 64z"}}]})(props);
	};
	module.exports.IoBicycle = function IoBicycle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M388 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zM124 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zm196-168a31.89 31.89 0 0032-32.1A31.55 31.55 0 00320.2 64a32 32 0 10-.2 64z"}},{"tag":"path","attr":{"d":"M367.55 192h-43.76a4 4 0 01-3.51-2.08l-31.74-58.17a31 31 0 00-49.38-7.75l-69.86 70.4a32.56 32.56 0 00-9.3 22.4c0 17.4 12.6 23.6 18.5 27.1 28.5 16.42 48.57 28.43 59.58 35.1a4 4 0 011.92 3.41v69.12c0 8.61 6.62 16 15.23 16.43A16 16 0 00272 352v-86a16 16 0 00-6.66-13l-37-26.61a4 4 0 01-.58-6l42-44.79a4 4 0 016.42.79L298 215.77a16 16 0 0014 8.23h56a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"}}]})(props);
	};
	module.exports.IoBluetoothOutline = function IoBluetoothOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M144 352l224-192L256 48v416l112-112-224-192"}}]})(props);
	};
	module.exports.IoBluetoothSharp = function IoBluetoothSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M397.41 161.13L236-.28v212.8l-94.17-80.72-26 30.37L225.27 256 115.8 349.83l26 30.37 94.2-80.72v212.8l161.41-161.41L286.73 256zM276 96.28l62.59 62.59L276 212.52zm62.58 256.85L276 415.72V299.48z"}}]})(props);
	};
	module.exports.IoBluetooth = function IoBluetooth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M388 160.77a20 20 0 00-5.85-14.91l-112-112A20 20 0 00236 48v164.52l-79-67.71a20 20 0 00-26 30.38L225.27 256 131 336.81a20 20 0 1026 30.38l79-67.71V464a20 20 0 0034.14 14.14l112-112a20 20 0 00-1.14-29.33L286.73 256 381 175.19a20 20 0 007-14.42zm-49.42 192.36L276 415.72V299.49zM276 212.52V96.28l62.59 62.59z"}}]})(props);
	};
	module.exports.IoBoatOutline = function IoBoatOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M461.93 261.05c-2-4.76-6.71-7.83-11.67-9.49l-187.18-74.48a23.78 23.78 0 00-14.17 0l-187 74.52c-5 1.56-9.83 4.77-11.81 9.53s-2.94 9.37-1 15.08l46.53 119.15a7.46 7.46 0 007.47 4.64c26.69-1.68 50.31-15.23 68.38-32.5a7.66 7.66 0 0110.49 0C201.29 386 227 400 256 400s54.56-14 73.88-32.54a7.67 7.67 0 0110.5 0c18.07 17.28 41.69 30.86 68.38 32.54a7.45 7.45 0 007.46-4.61l46.7-119.16c1.98-4.78.99-10.41-.99-15.18z"}},{"tag":"path","attr":{"d":"M416 473.14a6.84 6.84 0 00-3.56-6c-27.08-14.55-51.77-36.82-62.63-48a10.05 10.05 0 00-12.72-1.51c-50.33 32.42-111.61 32.44-161.95.05a10.09 10.09 0 00-12.82 1.56c-10.77 11.28-35.19 33.3-62.43 47.75a7.15 7.15 0 00-3.89 5.73 6.73 6.73 0 007.92 7.15c20.85-4.18 41-13.68 60.2-23.83a8.71 8.71 0 018-.06A185.14 185.14 0 00340 456a8.82 8.82 0 018.09.06c19.1 10 39.22 19.59 60 23.8a6.72 6.72 0 007.95-6.71z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 96V72a24.07 24.07 0 00-24-24h-80a24.07 24.07 0 00-24 24v24m224 137v-89a48.14 48.14 0 00-48-48H144a48.14 48.14 0 00-48 48v92m160-52.4v212.85"}}]})(props);
	};
	module.exports.IoBoatSharp = function IoBoatSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M477.77 246.42c-2.13-6-7.23-9.55-12.56-11.95L432 221.38V92a20 20 0 00-20-20h-76V40a16 16 0 00-16-16H192a16 16 0 00-16 16v32h-76a20 20 0 00-20 20v129.46l-33.08 13.06c-5.33 2.4-10.58 6-12.72 12s-3.16 11.81-1 19L84.25 415.7h1.06c34.12 0 64-17.41 85.31-43.82 21.32 26.41 51.18 42.12 85.3 42.12s64-15.76 85.31-42.17c21.32 26.41 51.18 43.87 85.3 43.87h1.06l51.25-150.17c2.16-6 1.07-13.1-1.07-19.11zM256 152l-144 56.83V108a4 4 0 014-4h280a4 4 0 014 4v100.76z"}},{"tag":"path","attr":{"d":"M345.22 407c-52.25 36.26-126.35 36.25-178.6 0 0 0-45.64 63-94.64 63l13.33 1c29.86 0 58.65-11.73 85.31-25.59a185.33 185.33 0 00170.6 0c26.66 13.87 55.45 25.6 85.31 25.6l13.33-1C392.21 470 345.22 407 345.22 407z"}}]})(props);
	};
	module.exports.IoBoat = function IoBoat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 473.14a6.83 6.83 0 00-3.57-6c-27.07-14.55-51.76-36.82-62.62-48a10.05 10.05 0 00-12.72-1.51c-50.33 32.42-111.61 32.44-161.95.05a10.09 10.09 0 00-12.82 1.56c-10.77 11.28-35.19 33.3-62.43 47.75a7.11 7.11 0 00-3.89 5.73 6.73 6.73 0 007.92 7.15c20.85-4.18 41-13.68 60.2-23.83a8.71 8.71 0 018-.06 185.14 185.14 0 00167.81 0 8.82 8.82 0 018.09.06c19.1 10 39.22 19.59 60 23.8a6.73 6.73 0 008-6.71zm60.71-226.23c-3.49-8.39-10.9-14.89-20.9-18.35L432 219.08V136a64 64 0 00-64-64h-32v-8a40 40 0 00-40-40h-80a40 40 0 00-40 40v8h-32a64 64 0 00-64 64v83.15l-23.58 9.39c-9.94 3.3-17.63 10-21.15 18.44-2.45 5.89-5.25 15-1.3 26.46l.1.3 46.66 119.44A23.33 23.33 0 00102.58 408c.5 0 1 0 1.53-.05 31.32-2 56-17.27 72.6-31.61C200.42 396.81 228.31 408 256 408s55.43-11.2 79.14-31.7c16.59 14.36 41.3 29.67 72.61 31.65a23.36 23.36 0 0023.37-14.74l46.65-119c3.28-8.09 2.9-17.76-1.06-27.3zM269 154.21l-1.14-.4a39.53 39.53 0 00-23.73 0l-.58.18-126.07 50.23a4 4 0 01-5.48-3.72V136a32 32 0 0132-32h224a32 32 0 0132 32v64.44a4 4 0 01-5.48 3.72z"}}]})(props);
	};
	module.exports.IoBodyOutline = function IoBodyOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"56","r":"40","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M199.3 295.62h0l-30.4 172.2a24 24 0 0019.5 27.8 23.76 23.76 0 0027.6-19.5l21-119.9v.2s5.2-32.5 17.5-32.5h3.1c12.5 0 17.5 32.5 17.5 32.5v-.1l21 119.9a23.92 23.92 0 1047.1-8.4l-30.4-172.2-4.9-29.7c-2.9-18.1-4.2-47.6.5-59.7 4-10.4 14.13-14.2 23.2-14.2H424a24 24 0 000-48H88a24 24 0 000 48h92.5c9.23 0 19.2 3.8 23.2 14.2 4.7 12.1 3.4 41.6.5 59.7z"}}]})(props);
	};
	module.exports.IoBodySharp = function IoBodySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"56","r":"56"}},{"tag":"path","attr":{"d":"M464 128H48v52h144l-32 325.13 51 6.87 21.65-192h47.02L301 512l51-6.98L320 180h144v-52z"}}]})(props);
	};
	module.exports.IoBody = function IoBody (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"56","r":"56"}},{"tag":"path","attr":{"d":"M437 128H75a27 27 0 000 54h101.88c6.91 0 15 3.09 19.58 15 5.35 13.83 2.73 40.54-.57 61.23l-4.32 24.45a.42.42 0 01-.12.35l-34.6 196.81A27.43 27.43 0 00179 511.58a27.06 27.06 0 0031.42-22.29l23.91-136.8S242 320 256 320c14.23 0 21.74 32.49 21.74 32.49l23.91 136.92a27.24 27.24 0 1053.62-9.6L320.66 283a.45.45 0 00-.11-.35l-4.33-24.45c-3.3-20.69-5.92-47.4-.57-61.23 4.56-11.88 12.91-15 19.28-15H437a27 27 0 000-54z"}}]})(props);
	};
	module.exports.IoBonfireOutline = function IoBonfireOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M273.38 368.33c-.81-9.23-8.86-16.44-18.55-16.44a18.63 18.63 0 00-18.2 14.11l-18.2 88.38a35.75 35.75 0 00-.93 7.88c0 19.93 16.68 33.78 37.33 33.78s37.34-13.85 37.34-33.78a36.16 36.16 0 00-1.29-9.45zm137.67 39.53a41.78 41.78 0 00-5.95-4.35l-69.53-48.59c-6.77-4.25-14-4.13-19.25 1a13.53 13.53 0 00-2 17.2l52.5 69a36.57 36.57 0 004 4.69c9.1 10.17 29.28 10.73 40.37 0 10.94-10.91 10.81-30.35-.14-38.95zm52.25-71.98h-70.42c-4.55 0-8.88 3.35-8.88 8.16s2.95 7.85 6.92 9.16l66.43 20.55C467 376 480 367.4 480 356.66c0-13.66-7.6-20.78-16.7-20.78zM128.22 344c0-5-4.55-8.16-9.45-8.16H48.35c-8.87 0-16.35 9.58-16.35 20.32S44.62 376 54.3 373.75l67.43-20.55c4.39-1.31 6.49-4.2 6.49-9.2zm48.33 11L107 403.38a32.34 32.34 0 00-6 4.35 26.33 26.33 0 000 38.56 29.39 29.39 0 0040.36 0 30.75 30.75 0 004-4.68L197.9 373c3.5-5.58 2.92-12.49-2-17.06a15 15 0 00-19.35-.94z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M368 125.09c0-55.7-49.22-89.16-94.2-93.06a8 8 0 00-8.69 7.71c-3.12 76-109.38 110.69-119.87 178.68-7 45.4 16.65 72.37 34.31 85.78a15.94 15.94 0 0023.93-5.62c22.5-45.86 74.33-63.49 109.72-85.94 42.88-27.2 54.8-56.44 54.8-87.55z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M240 95.7c-12.82-23-30.51-31-59.16-31.63a3.86 3.86 0 00-4.06 3.51c-.95 34.22-32.78 44.85-32.78 73.15 0 19.37 5.39 29 17.16 39.28m191.29-1.25c8.6 14.31 15.55 30.08 15.55 48 0 52.52-42.47 93.1-94.86 93.1a94.42 94.42 0 01-65.14-26"}}]})(props);
	};
	module.exports.IoBonfireSharp = function IoBonfireSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M199.89 336l-15.25-5.62a100.35 100.35 0 01-32-23.08c-13.93-14.9-29.29-40.71-23.38-79.11 5.2-33.73 44.2-74.21 69.34-97.87 27.24-25.62 66-65.85 64.15-99.15L262 16h15.18C328.53 16 384 53.62 384 114.41c0 45.57-22 77.61-68.91 106.9-8 5-16.44 9.66-25.42 14.53-30.63 16.62-75.29 49.83-85.73 85.32zm-18.7-222.41C201 95 218.91 78.15 227.62 59.79q-2.76-1.68-5.7-3.09c-11.87-5.69-26.1-8.34-44.76-8.34h-16.94l.56 16.49c.47 14.06-6.06 22.51-14.33 33.21C137.8 109.26 128 121.94 128 141c0 10.23 1.29 18.76 4.2 26.36q3.5-5.31 7.61-10.63c12.19-15.73 27.05-29.68 41.38-43.14z"}},{"tag":"path","attr":{"d":"M330.34 239.85c-9.31 5.9-19 11.14-29.25 16.71-32.65 17.69-63.48 34.44-73.23 67.44l-.6 2a110.5 110.5 0 0045.87 10c29.66 0 57.45-11.13 78.24-31.36A107.38 107.38 0 00384 227a92.39 92.39 0 00-5.59-31c-11.35 16.18-27.14 30.58-48.07 43.85zM268.72 360h-25.44a4 4 0 00-3.92 3.22l-25.36 128a4 4 0 003.92 4.78h76.26a4 4 0 003.92-4.78l-25.41-128a4 4 0 00-3.97-3.22zm56.96-5.68l-11.36 11.36a4 4 0 00-.5 5.05l59.47 89.21a4 4 0 006.16.61l41.1-41.1a4 4 0 00-.61-6.16l-89.21-59.47a4 4 0 00-5.05.5zM388 336a4 4 0 00-4 4v8.61a4 4 0 003.34 3.95l88 14.66a4 4 0 004.66-3.94V340a4 4 0 00-4-4zm-201.68 18.32l11.36 11.36a4 4 0 01.5 5.05l-59.47 89.21a4 4 0 01-6.16.61l-41.1-41.1a4 4 0 01.61-6.16l89.21-59.47a4 4 0 015.05.5zM124 336H36a4 4 0 00-4 4v23.28a4 4 0 004.66 3.94l88-14.66a4 4 0 003.34-3.95V340a4 4 0 00-4-4z"}}]})(props);
	};
	module.exports.IoBonfire = function IoBonfire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M273.38 368.37c-.81-9.23-8.86-16.44-18.55-16.44a18.63 18.63 0 00-18.2 14.07l-18.2 88.36a35.59 35.59 0 00-.93 7.87c0 19.93 16.68 33.77 37.33 33.77s37.34-13.84 37.34-33.77a36.16 36.16 0 00-1.29-9.45zm137.67 39.52a42.66 42.66 0 00-5.95-4.36L335.57 355c-6.77-4.24-14-4.13-19.25 1a13.52 13.52 0 00-2 17.19l52.5 69a38 38 0 004 4.69c9.1 10.16 29.28 10.72 40.37 0 10.94-10.96 10.81-30.39-.14-38.99zm52.25-71.96h-70.42c-4.55 0-8.88 3.35-8.88 8.15s2.95 7.85 6.92 9.16l66.43 20.55C467 376 480 367.44 480 356.71c0-13.63-7.6-20.78-16.7-20.78zm-335.08 8.15c0-4.95-4.55-8.15-9.45-8.15H48.35c-8.87 0-16.35 9.58-16.35 20.31S44.62 376 54.3 373.79l67.43-20.55c4.39-1.31 6.49-4.24 6.49-9.16zm48.33 10.97L107 403.41a32.29 32.29 0 00-6 4.34 26.33 26.33 0 000 38.56 29.41 29.41 0 0040.36 0 30.75 30.75 0 004-4.68L197.9 373c3.5-5.57 2.92-12.48-2-17a15 15 0 00-19.35-.95zm116.91-112.66c10-5.42 19.45-10.54 28.31-16.16 42.46-26.92 62.23-59 62.23-101 0-64.66-56.07-104.4-108.82-109-6.49-.57-15-.42-19.91 3.88s-5.88 12.56-6.15 19.1c-1.38 33.61-28.38 59-57 85.86-28 26.3-56.93 53.49-62.71 91-8.41 54.68 21.74 86.71 40.46 100.93a31.88 31.88 0 0019.3 6.51 32.32 32.32 0 007.41-.87 31.75 31.75 0 0021.27-16.95c14.91-30.39 45.77-47.12 75.61-63.3z"}},{"tag":"path","attr":{"d":"M139.82 156.57c12.22-15.76 27-29.68 41.37-43.15 19.92-18.72 37.81-35.58 46.5-53.86-12.24-7.37-27.36-11.36-46.51-11.36-17.79 0-20.39 5.18-20.39 19.06 0 12.56-6.53 20.54-14.34 30.65C137.8 109.1 128 121.77 128 140.84c0 10.23 1.29 18.77 4.2 26.37q3.5-5.32 7.62-10.64zm190.52 83.17c-9.33 5.92-19 11.16-29.25 16.71-28.91 15.68-56.21 30.48-68.88 56.28a62.6 62.6 0 01-1.88 3.61 8 8 0 003.89 11.3c12.31 5.1 25.13 8.27 38.91 8.27a111.42 111.42 0 0078.24-31.37A107.45 107.45 0 00384 226.85a86.56 86.56 0 00-1.33-15 8 8 0 00-13.8-4c-10.18 11.47-22.93 22-38.53 31.89z"}}]})(props);
	};
	module.exports.IoBookOutline = function IoBookOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 160c16-63.16 76.43-95.41 208-96a15.94 15.94 0 0116 16v288a16 16 0 01-16 16c-128 0-177.45 25.81-208 64-30.37-38-80-64-208-64-9.88 0-16-8.05-16-17.93V80a15.94 15.94 0 0116-16c131.57.59 192 32.84 208 96zm0 0v288"}}]})(props);
	};
	module.exports.IoBookSharp = function IoBookSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 48c-67.61.29-117.87 9.6-154.24 25.69-27.14 12-37.76 21.08-37.76 51.84V448c41.57-37.5 78.46-48 224-48V48zM48 48c67.61.29 117.87 9.6 154.24 25.69 27.14 12 37.76 21.08 37.76 51.84V448c-41.57-37.5-78.46-48-224-48V48z"}}]})(props);
	};
	module.exports.IoBook = function IoBook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M202.24 74C166.11 56.75 115.61 48.3 48 48a31.36 31.36 0 00-17.92 5.33A32 32 0 0016 79.9V366c0 19.34 13.76 33.93 32 33.93 71.07 0 142.36 6.64 185.06 47a4.11 4.11 0 006.94-3V106.82a15.89 15.89 0 00-5.46-12A143 143 0 00202.24 74zm279.68-20.7A31.33 31.33 0 00464 48c-67.61.3-118.11 8.71-154.24 26a143.31 143.31 0 00-32.31 20.78 15.93 15.93 0 00-5.45 12v337.13a3.93 3.93 0 006.68 2.81c25.67-25.5 70.72-46.82 185.36-46.81a32 32 0 0032-32v-288a32 32 0 00-14.12-26.61z"}}]})(props);
	};
	module.exports.IoBookmarkOutline = function IoBookmarkOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 48H160a48 48 0 00-48 48v368l144-128 144 128V96a48 48 0 00-48-48z"}}]})(props);
	};
	module.exports.IoBookmarkSharp = function IoBookmarkSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 480L256 357.41 96 480V32h320z"}}]})(props);
	};
	module.exports.IoBookmark = function IoBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 480a16 16 0 01-10.63-4L256 357.41 122.63 476A16 16 0 0196 464V96a64.07 64.07 0 0164-64h192a64.07 64.07 0 0164 64v368a16 16 0 01-16 16z"}}]})(props);
	};
	module.exports.IoBookmarksOutline = function IoBookmarksOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M128 80V64a48.14 48.14 0 0148-48h224a48.14 48.14 0 0148 48v368l-80-64"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M320 96H112a48.14 48.14 0 00-48 48v352l152-128 152 128V144a48.14 48.14 0 00-48-48z"}}]})(props);
	};
	module.exports.IoBookmarksSharp = function IoBookmarksSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M112 0v48h304v368l48 32V0H112z"}},{"tag":"path","attr":{"d":"M48 80v432l168-124 168 124V80H48z"}}]})(props);
	};
	module.exports.IoBookmarks = function IoBookmarks (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 0H176a64.11 64.11 0 00-62 48h228a74 74 0 0174 74v304.89l22 17.6a16 16 0 0019.34.5 16.41 16.41 0 006.66-13.42V64a64 64 0 00-64-64z"}},{"tag":"path","attr":{"d":"M320 80H112a64 64 0 00-64 64v351.62A16.36 16.36 0 0054.6 509a16 16 0 0019.71-.71L216 388.92l141.69 119.32a16 16 0 0019.6.79 16.4 16.4 0 006.71-13.44V144a64 64 0 00-64-64z"}}]})(props);
	};
	module.exports.IoBowlingBallOutline = function IoBowlingBallOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"208","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"288","cy":"200","r":"24"}},{"tag":"circle","attr":{"cx":"296","cy":"128","r":"24"}},{"tag":"circle","attr":{"cx":"360","cy":"168","r":"24"}}]})(props);
	};
	module.exports.IoBowlingBallSharp = function IoBowlingBallSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM286 230a28 28 0 1128-28 28 28 0 01-28 28zm8-76a28 28 0 1128-28 28 28 0 01-28 28zm68 44a28 28 0 1128-28 28 28 0 01-28 28z"}}]})(props);
	};
	module.exports.IoBowlingBall = function IoBowlingBall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM288 224a24 24 0 1124-24 24 24 0 01-24 24zm8-72a24 24 0 1124-24 24 24 0 01-24 24zm64 40a24 24 0 1124-24 24 24 0 01-24 24z"}}]})(props);
	};
	module.exports.IoBriefcaseOutline = function IoBriefcaseOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"448","height":"320","x":"32","y":"128","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M144 128V96a32 32 0 0132-32h160a32 32 0 0132 32v32m112 112H32m288 0v24a8 8 0 01-8 8H200a8 8 0 01-8-8v-24"}}]})(props);
	};
	module.exports.IoBriefcaseSharp = function IoBriefcaseSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 288H176v-32H16v196a12 12 0 0012 12h456a12 12 0 0012-12V256H336zm160-164a12 12 0 00-12-12H384V56a8 8 0 00-8-8H136a8 8 0 00-8 8v56H28a12 12 0 00-12 12v100h480zm-152-12H168V88h176z"}}]})(props);
	};
	module.exports.IoBriefcase = function IoBriefcase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M336 80H176a16 16 0 00-16 16v16h192V96a16 16 0 00-16-16z"}},{"tag":"path","attr":{"d":"M496 176a64.07 64.07 0 00-64-64h-48V96a48.05 48.05 0 00-48-48H176a48.05 48.05 0 00-48 48v16H80a64.07 64.07 0 00-64 64v48h480zm-144-64H160V96a16 16 0 0116-16h160a16 16 0 0116 16zm-16 152a24 24 0 01-24 24H200a24 24 0 01-24-24v-4a4 4 0 00-4-4H16v144a64 64 0 0064 64h352a64 64 0 0064-64V256H340a4 4 0 00-4 4z"}}]})(props);
	};
	module.exports.IoBrowsersOutline = function IoBrowsersOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"384","x":"48","y":"64","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}},{"tag":"path","attr":{"d":"M397.82 64H114.18C77.69 64 48 94.15 48 131.2V176h16c0-16 16-32 32-32h320c16 0 32 16 32 32h16v-44.8c0-37.05-29.69-67.2-66.18-67.2z"}}]})(props);
	};
	module.exports.IoBrowsersSharp = function IoBrowsersSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 64v384a16 16 0 0016 16h416a16 16 0 0016-16V64a16 16 0 00-16-16H48a16 16 0 00-16 16zm408 364H72a4 4 0 01-4-4V152a4 4 0 014-4h368a4 4 0 014 4v272a4 4 0 01-4 4z"}}]})(props);
	};
	module.exports.IoBrowsers = function IoBrowsers (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 48H96a64 64 0 00-64 64v288a64 64 0 0064 64h320a64 64 0 0064-64V112a64 64 0 00-64-64zm24 96H72a8 8 0 01-8-8v-24a32.09 32.09 0 0132-32h320a32.09 32.09 0 0132 32v24a8 8 0 01-8 8z"}}]})(props);
	};
	module.exports.IoBrushOutline = function IoBrushOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M452.37 59.63h0a40.49 40.49 0 00-57.26 0L184 294.74c23.08 4.7 46.12 27.29 49.26 49.26l219.11-227.11a40.49 40.49 0 000-57.26zM138 336c-29.88 0-54 24.5-54 54.86 0 23.95-20.88 36.57-36 36.57C64.56 449.74 92.82 464 120 464c39.78 0 72-32.73 72-73.14 0-30.36-24.12-54.86-54-54.86z"}}]})(props);
	};
	module.exports.IoBrushSharp = function IoBrushSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 96l-64-64-244 260 64 64zM142 320c-36.52 0-66 30.63-66 68.57 0 25.43-31 45.72-44 45.72C52.24 462.17 86.78 480 120 480c48.62 0 88-40.91 88-91.43 0-37.94-29.48-68.57-66-68.57z"}}]})(props);
	};
	module.exports.IoBrush = function IoBrush (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M233.15 360.11a15.7 15.7 0 01-4.92-.77 16 16 0 01-10.92-13c-2.15-15-19.95-32.46-36.62-35.85a16 16 0 01-8.69-26.33l211.09-235.1c.19-.22.39-.43.59-.63a56.57 56.57 0 0179.89 0 56.51 56.51 0 01.11 79.78l-219 227a16 16 0 01-11.53 4.9zm-113.26 120c-32.14 0-65.45-16.89-84.85-43a16 16 0 0112.85-25.54c5.34 0 20-4.87 20-20.57 0-39.07 31.4-70.86 70-70.86s70 31.79 70 70.86c0 49.12-39.48 89.11-88 89.11z"}}]})(props);
	};
	module.exports.IoBugOutline = function IoBugOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M370 378c28.89 23.52 46 46.07 46 86m-274-86c-28.89 23.52-46 46.06-46 86m288-256c28.89-23.52 32-56.07 32-96m-288 94c-28.89-23.52-32-54.06-32-94m368 176.13h-80m-256 0H48M256 192v256"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 448h0c-70.4 0-128-57.6-128-128v-96.07c0-65.07 57.6-96 128-96h0c70.4 0 128 25.6 128 96V320c0 70.4-57.6 128-128 128z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M179.43 143.52a49.08 49.08 0 01-3.43-15.73A80 80 0 01255.79 48h.42A80 80 0 01336 127.79a41.91 41.91 0 01-3.12 14.3"}}]})(props);
	};
	module.exports.IoBugSharp = function IoBugSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 304.13v-32h-80V215.2c29.42-27.95 32-64.76 32-103.2V96h-32v16c0 28-1.86 48.15-9.9 63.84C368 128 324.32 112 256 112c-39.8 0-75.19 7.06-100.43 24.32-14.9 10.19-25.2 24.91-32.7 39.72C114 160.57 112 140.82 112 112V96H80v16c0 37.44 2.59 73.36 32 101.2v58.93H32v32l80-.13c0 19 3.7 53.09 10.39 69.69C96.6 396.76 80 422.31 80 464v16h32v-16c0-27.66 9.1-44.71 26.17-61.32C160 448 177 464 240 464V176h32v288c65 0 80-16 101.83-61.32C390.9 419.29 400 436.35 400 464v16h32v-16c0-41.68-16.6-67.23-42.39-90.31C396.3 357.09 400 323 400 304z"}},{"tag":"path","attr":{"d":"M256 32c-48.06 0-96 0-96 84 26.12-14 59.35-20 96-20 24.09 0 46.09 2.65 65.39 8 10.75 3 24.66 8.71 30.61 12 0-84-47.94-84-96-84z"}}]})(props);
	};
	module.exports.IoBug = function IoBug (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M463.55 272.13H400v-48.2q0-4.32-.27-8.47c29.57-27.88 32.25-64.63 32.27-103 0-8.61-6.64-16-15.25-16.41A16 16 0 00400 112c0 28-1.86 48.15-9.9 63.84-19.22-41.15-65.78-63.91-134.1-63.91-39.8 0-74.19 9.13-99.43 26.39-14.9 10.19-26.2 22.91-33.7 37.72C114 160.65 112 141 112 112.46c0-8.61-6.6-16-15.2-16.44A16 16 0 0080 112c0 37.63 2.61 73.73 32.44 101.63q-.43 5.06-.44 10.3v48.2H48.45c-8.61 0-16 6.62-16.43 15.23a16 16 0 0016 16.77h64V320a143.32 143.32 0 0010.39 53.69C96.74 396.64 80.18 422 80 463.34c0 8.74 6.62 16.3 15.36 16.65A16 16 0 00112 464c0-27.66 9.1-44.71 26.17-61.32A144.37 144.37 0 00220 459.42a16 16 0 0020-15.49V192.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 192v251.93a16 16 0 0020 15.49 144.4 144.4 0 0081.82-56.74c17 16.54 26.09 33.52 26.17 60.95a16.27 16.27 0 0015.1 16.37A16 16 0 00432 464c0-41.68-16.6-67.23-42.39-90.31A143.32 143.32 0 00400 320v-15.87h64a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"}},{"tag":"path","attr":{"d":"M321.39 104l.32.09c13.57 3.8 25.07-10.55 18.2-22.85A95.86 95.86 0 00256.21 32h-.42a95.87 95.87 0 00-84.19 50.13c-6.84 12.58 5.14 27 18.84 22.86 19.71-6 41.79-9.06 65.56-9.06 24.09 0 46.09 2.72 65.39 8.07z"}}]})(props);
	};
	module.exports.IoBuildOutline = function IoBuildOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M393.87 190a32.1 32.1 0 01-45.25 0l-26.57-26.57a32.09 32.09 0 010-45.26L382.19 58a1 1 0 00-.3-1.64c-38.82-16.64-89.15-8.16-121.11 23.57-30.58 30.35-32.32 76-21.12 115.84a31.93 31.93 0 01-9.06 32.08L64 380a48.17 48.17 0 1068 68l153.86-167a31.93 31.93 0 0131.6-9.13c39.54 10.59 84.54 8.6 114.72-21.19 32.49-32 39.5-88.56 23.75-120.93a1 1 0 00-1.6-.26z"}},{"tag":"circle","attr":{"cx":"96","cy":"416","r":"16"}}]})(props);
	};
	module.exports.IoBuildSharp = function IoBuildSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M230 209.2L32 405.58 106.65 480l197.59-198.17c46.47 17.46 105.52 12.54 143-24.78 40.44-40.32 40.35-108 16.81-156.79l-87.33 87.06-52.32-52.13 87.33-87.06C363 24.46 294.67 24.34 254.23 64.66c-38.03 37.91-42.78 97.6-24.23 144.54z"}}]})(props);
	};
	module.exports.IoBuild = function IoBuild (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M469.54 120.52a16 16 0 00-25.54-4L382.56 178a16.12 16.12 0 01-22.63 0l-26.56-26.6a16 16 0 010-22.63l61.18-61.19a16 16 0 00-4.78-25.92C343.56 21 285.88 31.78 249.51 67.88c-30.9 30.68-40.11 78.62-25.25 131.53a15.89 15.89 0 01-4.49 16L53.29 367.46a64.17 64.17 0 1090.6 90.64l153.68-166.85a15.9 15.9 0 0115.77-4.57 179.3 179.3 0 0046.22 6.37c33.4 0 62.71-10.81 83.85-31.64 39.15-38.57 45.12-103.99 26.13-140.89zM99.48 447.15a32 32 0 1128.34-28.35 32 32 0 01-28.34 28.35z"}}]})(props);
	};
	module.exports.IoBulbOutline = function IoBulbOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M304 384v-24c0-29 31.54-56.43 52-76 28.84-27.57 44-64.61 44-108 0-80-63.73-144-144-144a143.6 143.6 0 00-144 144c0 41.84 15.81 81.39 44 108 20.35 19.21 52 46.7 52 76v24m16 96h64m-80-48h96m-48-48V256"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M294 240s-21.51 16-38 16-38-16-38-16"}}]})(props);
	};
	module.exports.IoBulbSharp = function IoBulbSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 464h96v32h-96zm-16-48h128v32H192zM369.42 62.69C339.35 32.58 299.07 16 256 16A159.62 159.62 0 0096 176c0 46.62 17.87 90.23 49 119.64l4.36 4.09C167.37 316.57 192 339.64 192 360v40h48V269.11L195.72 244 214 217.72 256 240l41.29-22.39 19.1 25.68-44.39 26V400h48v-40c0-19.88 24.36-42.93 42.15-59.77l4.91-4.66C399.08 265 416 223.61 416 176a159.16 159.16 0 00-46.58-113.31z"}}]})(props);
	};
	module.exports.IoBulb = function IoBulb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 464h-64a16 16 0 000 32h64a16 16 0 000-32zm16-48h-96a16 16 0 000 32h96a16 16 0 000-32zm65.42-353.31C339.35 32.58 299.07 16 256 16A159.62 159.62 0 0096 176c0 46.62 17.87 90.23 49 119.64l4.36 4.09C167.37 316.57 192 339.64 192 360v24a16 16 0 0016 16h24a8 8 0 008-8V274.82a8 8 0 00-5.13-7.47A130.73 130.73 0 01208.71 253a16 16 0 1118.58-26c7.4 5.24 21.65 13 28.71 13s21.31-7.78 28.73-13a16 16 0 0118.56 26 130.73 130.73 0 01-26.16 14.32 8 8 0 00-5.13 7.47V392a8 8 0 008 8h24a16 16 0 0016-16v-24c0-19.88 24.36-42.93 42.15-59.77l4.91-4.66C399.08 265 416 223.61 416 176a159.16 159.16 0 00-46.58-113.31z"}}]})(props);
	};
	module.exports.IoBusOutline = function IoBusOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"352","height":"192","x":"80","y":"112","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"32","ry":"32"}},{"tag":"rect","attr":{"width":"352","height":"128","x":"80","y":"304","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"32","ry":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M400 112H112a32.09 32.09 0 01-32-32h0a32.09 32.09 0 0132-32h288a32.09 32.09 0 0132 32h0a32.09 32.09 0 01-32 32zM144 432v22a10 10 0 01-10 10h-28a10 10 0 01-10-10v-22zm272 0v22a10 10 0 01-10 10h-28a10 10 0 01-10-10v-22z"}},{"tag":"circle","attr":{"cx":"368","cy":"368","r":"16","fill":"none","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"144","cy":"368","r":"16","fill":"none","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 112v192M80 80v288M432 80v288"}}]})(props);
	};
	module.exports.IoBusSharp = function IoBusSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M400 64H112a16 16 0 000 32h288a16 16 0 000-32z"}},{"tag":"path","attr":{"d":"M424 32H88a24 24 0 00-24 24v360a32 32 0 0016 27.71V480h72v-32h208v32h72v-36.29A32 32 0 00448 416V56a24 24 0 00-24-24zM175.82 371.47a32 32 0 11-35.3-35.29 32.09 32.09 0 0135.3 35.29zM240 288H96V128h144zm16-192H96.46L96 64h320l-.46 32H256zm16 32h144v160H272zm64.18 236.53a32 32 0 1135.3 35.29 32.09 32.09 0 01-35.3-35.29z"}}]})(props);
	};
	module.exports.IoBus = function IoBus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 32H112a48 48 0 00-48 48v320a47.91 47.91 0 0016 35.74V454a26 26 0 0026 26h28a26 26 0 0026-26v-6h192v6a26 26 0 0026 26h28a26 26 0 0026-26v-18.26A47.91 47.91 0 00448 400V80a48 48 0 00-48-48zM147.47 399.82a32 32 0 1128.35-28.35 32 32 0 01-28.35 28.35zM236 288H112a16 16 0 01-16-16V144a16 16 0 0116-16h124a4 4 0 014 4v152a4 4 0 01-4 4zm20-192H112.46c-8.6 0-16-6.6-16.44-15.19A16 16 0 01112 64h287.54c8.6 0 16 6.6 16.44 15.19A16 16 0 01400 96H256zm20 32h124a16 16 0 0116 16v128a16 16 0 01-16 16H276a4 4 0 01-4-4V132a4 4 0 014-4zm60.18 243.47a32 32 0 1128.35 28.35 32 32 0 01-28.35-28.35z"}}]})(props);
	};
	module.exports.IoBusinessOutline = function IoBusinessOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 416v64M80 32h192a32 32 0 0132 32v412a4 4 0 01-4 4H48h0V64a32 32 0 0132-32zm240 160h112a32 32 0 0132 32v256h0-160 0V208a16 16 0 0116-16z"}},{"tag":"path","attr":{"d":"M98.08 431.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 240a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 320a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79z"}},{"tag":"ellipse","attr":{"cx":"256","cy":"176","rx":"15.95","ry":"16.03","transform":"rotate(-45 255.99 175.996)"}},{"tag":"path","attr":{"d":"M258.08 111.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM400 400a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm-64 160a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16z"}}]})(props);
	};
	module.exports.IoBusinessSharp = function IoBusinessSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 176V16H32v480h128v-96h32v96h288V176zM112 432H80v-32h32zm0-80H80v-32h32zm0-80H80v-32h32zm0-80H80v-32h32zm0-80H80V80h32zm128-32h32v32h-32zm-48 272h-32v-32h32zm0-80h-32v-32h32zm0-80h-32v-32h32zm0-80h-32V80h32zm80 320h-32v-32h32zm0-80h-32v-32h32zm0-80h-32v-32h32zm0-80h-32v-32h32v32zm176 272H320v-32h32v-32h-32v-48h32v-32h-32v-48h32v-32h-32v-32h128z"}},{"tag":"path","attr":{"d":"M384 400h32v32h-32zm0-80h32v32h-32zm0-80h32v32h-32z"}}]})(props);
	};
	module.exports.IoBusiness = function IoBusiness (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 176H320V64a48 48 0 00-48-48H80a48 48 0 00-48 48v416a16 16 0 0016 16h104a8 8 0 008-8v-71.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01192 416v72a8 8 0 008 8h264a16 16 0 0016-16V224a48 48 0 00-48-48zM98.08 431.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 240a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 320a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM444 464H320V208h112a16 16 0 0116 16v236a4 4 0 01-4 4z"}},{"tag":"path","attr":{"d":"M400 400a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm-64 160a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16z"}}]})(props);
	};
	module.exports.IoCafeOutline = function IoCafeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M368 80h64a16 16 0 0116 16v34a46 46 0 01-46 46h-34M96 80h272v192a80 80 0 01-80 80H176a80 80 0 01-80-80V80h0zM64 416h336"}}]})(props);
	};
	module.exports.IoCafeSharp = function IoCafeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 64H80v254.34a19.83 19.83 0 005.86 14.14l29.65 29.66a19.87 19.87 0 0014.15 5.86h204.68a19.87 19.87 0 0014.15-5.86l29.65-29.66a19.83 19.83 0 005.86-14.14V192h32a16 16 0 0011.31-4.69l32-32A16 16 0 00464 144V80a16 16 0 00-16-16zm-16 73.37L409.37 160H384V96h48zM48 400h368v32H48z"}}]})(props);
	};
	module.exports.IoCafe = function IoCafe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 64H96a16 16 0 00-16 16v192a96.11 96.11 0 0096 96h112a96.11 96.11 0 0096-96v-80h18a62.07 62.07 0 0062-62V96a32 32 0 00-32-32zm0 66a30 30 0 01-30 30h-18V96h48zm-32 270H64a16 16 0 000 32h336a16 16 0 000-32z"}}]})(props);
	};
	module.exports.IoCalculatorOutline = function IoCalculatorOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"288","height":"416","x":"112","y":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"32","ry":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160.01 112H352v64H160.01z"}},{"tag":"circle","attr":{"cx":"168","cy":"248","r":"24"}},{"tag":"circle","attr":{"cx":"256","cy":"248","r":"24"}},{"tag":"circle","attr":{"cx":"344","cy":"248","r":"24"}},{"tag":"circle","attr":{"cx":"168","cy":"328","r":"24"}},{"tag":"circle","attr":{"cx":"256","cy":"328","r":"24"}},{"tag":"circle","attr":{"cx":"168","cy":"408","r":"24"}},{"tag":"circle","attr":{"cx":"256","cy":"408","r":"24"}},{"tag":"rect","attr":{"width":"48","height":"128","x":"320","y":"304","rx":"24","ry":"24"}}]})(props);
	};
	module.exports.IoCalculatorSharp = function IoCalculatorSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 48a16 16 0 00-16-16H112a16 16 0 00-16 16v416a16 16 0 0016 16h288a16 16 0 0016-16zM192 432h-48v-48h48zm0-80h-48v-48h48zm0-80h-48v-48h48zm88 160h-48v-48h48zm0-80h-48v-48h48zm0-80h-48v-48h48zm88 160h-48V304h48zm0-160h-48v-48h48zm0-96H144V80h224z"}}]})(props);
	};
	module.exports.IoCalculator = function IoCalculator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 80a48.05 48.05 0 00-48-48H144a48.05 48.05 0 00-48 48v352a48.05 48.05 0 0048 48h224a48.05 48.05 0 0048-48zM168 432a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm88 160a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm112 136a24 24 0 01-48 0v-80a24 24 0 0148 0zm-24-136a24 24 0 1124-24 24 24 0 01-24 24zm19.31-100.69A16 16 0 01352 176H160a16 16 0 01-16-16V96a16 16 0 0116-16h192a16 16 0 0116 16v64a16 16 0 01-4.69 11.31z"}}]})(props);
	};
	module.exports.IoCalendarClearOutline = function IoCalendarClearOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"384","x":"48","y":"80","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M128 48v32m256-32v32m80 80H48"}}]})(props);
	};
	module.exports.IoCalendarClearSharp = function IoCalendarClearSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 456a24 24 0 0024 24h400a24 24 0 0024-24V192H32zM480 87.77A23.8 23.8 0 00456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448z"}}]})(props);
	};
	module.exports.IoCalendarClear = function IoCalendarClear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 128a64 64 0 00-64-64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4zM32 416a64 64 0 0064 64h320a64 64 0 0064-64V180a4 4 0 00-4-4H36a4 4 0 00-4 4z"}}]})(props);
	};
	module.exports.IoCalendarNumberOutline = function IoCalendarNumberOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"384","x":"48","y":"80","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M128 48v32m256-32v32m80 80H48m256 100l43.42-32H352v168m-160.13-89.37c9.11 0 25.79-4.28 36.72-15.47a37.9 37.9 0 0011.13-27.26c0-26.12-22.59-39.9-47.89-39.9-21.4 0-33.52 11.61-37.85 18.93M149 374.16c4.88 8.27 19.71 25.84 43.88 25.84 28.59 0 52.12-15.94 52.12-43.82 0-12.62-3.66-24-11.58-32.07-12.36-12.64-31.25-17.48-41.55-17.48"}}]})(props);
	};
	module.exports.IoCalendarNumberSharp = function IoCalendarNumberSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 456a24 24 0 0024 24h400a24 24 0 0024-24V176H32zm310.17-244H368v200h-32V256.29l-35.39 26.08-19-25.76zM222 335.3c-8.54-8.74-22.75-12.67-30.11-12.67h-16v-32h16c4.85 0 17.41-2.6 25.28-10.65a22 22 0 006.57-16.08c0-23.23-28.63-23.9-31.89-23.9-17.34 0-23.8 10.61-24.07 11.06l-8.13 13.78-27.56-16.27 8.14-13.77c7.64-13 25.22-26.8 51.62-26.8 16.44 0 31.76 4.77 43.13 13.42 13.39 10.2 20.76 25.28 20.76 42.48A54 54 0 01240 302.35c-1.15 1.18-2.36 2.28-3.59 3.35a66.18 66.18 0 018.42 7.23c10.56 10.8 16.14 25.75 16.14 43.25 0 18.06-7.61 34-21.42 44.92-12.17 9.61-28.75 14.9-46.7 14.9-27.87 0-48.48-18.16-57.66-33.7l-8.13-13.78 27.56-16.27 8.16 13.75c1.08 1.84 11.15 18 30.1 18 16.66 0 36.12-7.29 36.12-27.82 0-6.25-1.22-14.95-7-20.88zM456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448V87.77A23.8 23.8 0 00456 64z"}}]})(props);
	};
	module.exports.IoCalendarNumber = function IoCalendarNumber (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4v-12a64 64 0 00-64-64zm60 112H36a4 4 0 00-4 4v236a64 64 0 0064 64h320a64 64 0 0064-64V180a4 4 0 00-4-4zM239.58 401.1c-12.17 9.61-28.75 14.9-46.7 14.9-27.87 0-48.48-18.16-57.66-33.7a16 16 0 0127.56-16.3c1.08 1.84 11.15 18 30.1 18 16.66 0 36.12-7.29 36.12-27.82 0-6.25-1.22-14.95-7-20.88-8.54-8.74-22.75-12.67-30.11-12.67a16 16 0 010-32c4.85 0 17.41-2.6 25.28-10.65a22 22 0 006.57-16.08c0-23.23-28.63-23.9-31.89-23.9-17.34 0-23.8 10.61-24.07 11.06a16 16 0 11-27.55-16.26c7.64-13 25.22-26.8 51.62-26.8 16.44 0 31.76 4.77 43.13 13.42 13.39 10.2 20.76 25.28 20.76 42.48A54 54 0 01240 302.35c-1.15 1.18-2.36 2.28-3.59 3.35a66.18 66.18 0 018.42 7.23c10.56 10.8 16.14 25.75 16.14 43.25.03 18.06-7.58 34.01-21.39 44.92zM368 396a16 16 0 01-32 0V256.29l-22.51 16.59a16 16 0 11-19-25.76l43.42-32a16 16 0 019.49-3.12h4.6a16 16 0 0116 16z"}}]})(props);
	};
	module.exports.IoCalendarOutline = function IoCalendarOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"384","x":"48","y":"80","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48"}},{"tag":"circle","attr":{"cx":"296","cy":"232","r":"24"}},{"tag":"circle","attr":{"cx":"376","cy":"232","r":"24"}},{"tag":"circle","attr":{"cx":"296","cy":"312","r":"24"}},{"tag":"circle","attr":{"cx":"376","cy":"312","r":"24"}},{"tag":"circle","attr":{"cx":"136","cy":"312","r":"24"}},{"tag":"circle","attr":{"cx":"216","cy":"312","r":"24"}},{"tag":"circle","attr":{"cx":"136","cy":"392","r":"24"}},{"tag":"circle","attr":{"cx":"216","cy":"392","r":"24"}},{"tag":"circle","attr":{"cx":"296","cy":"392","r":"24"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M128 48v32m256-32v32"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M464 160H48"}}]})(props);
	};
	module.exports.IoCalendarSharp = function IoCalendarSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 456a24 24 0 0024 24h400a24 24 0 0024-24V176H32zm320-244a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm-80-80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm-80-80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm-80-80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zM456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448V87.77A23.8 23.8 0 00456 64z"}}]})(props);
	};
	module.exports.IoCalendar = function IoCalendar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 128a64 64 0 00-64-64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4zM32 416a64 64 0 0064 64h320a64 64 0 0064-64V179a3 3 0 00-3-3H35a3 3 0 00-3 3zm344-208a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24z"}}]})(props);
	};
	module.exports.IoCallOutline = function IoCallOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M451 374c-15.88-16-54.34-39.35-73-48.76-24.3-12.24-26.3-13.24-45.4.95-12.74 9.47-21.21 17.93-36.12 14.75s-47.31-21.11-75.68-49.39-47.34-61.62-50.53-76.48 5.41-23.23 14.79-36c13.22-18 12.22-21 .92-45.3-8.81-18.9-32.84-57-48.9-72.8C119.9 44 119.9 47 108.83 51.6A160.15 160.15 0 0083 65.37C67 76 58.12 84.83 51.91 98.1s-9 44.38 23.07 102.64 54.57 88.05 101.14 134.49S258.5 406.64 310.85 436c64.76 36.27 89.6 29.2 102.91 23s22.18-15 32.83-31a159.09 159.09 0 0013.8-25.8C465 391.17 468 391.17 451 374z"}}]})(props);
	};
	module.exports.IoCallSharp = function IoCallSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M478.94 370.14c-5.22-5.56-23.65-22-57.53-43.75-34.13-21.94-59.3-35.62-66.52-38.81a3.83 3.83 0 00-3.92.49c-11.63 9.07-31.21 25.73-32.26 26.63-6.78 5.81-6.78 5.81-12.33 4-9.76-3.2-40.08-19.3-66.5-45.78s-43.35-57.55-46.55-67.3c-1.83-5.56-1.83-5.56 4-12.34.9-1.05 17.57-20.63 26.64-32.25a3.83 3.83 0 00.49-3.92c-3.19-7.23-16.87-32.39-38.81-66.52-21.78-33.87-38.2-52.3-43.76-57.52a3.9 3.9 0 00-3.89-.87 322.35 322.35 0 00-56 25.45A338 338 0 0033.35 92a3.83 3.83 0 00-1.26 3.74c2.09 9.74 12.08 50.4 43.08 106.72 31.63 57.48 53.55 86.93 100 133.22S252 405.21 309.54 436.84c56.32 31 97 41 106.72 43.07a3.86 3.86 0 003.75-1.26A337.73 337.73 0 00454.35 430a322.7 322.7 0 0025.45-56 3.9 3.9 0 00-.86-3.86z"}}]})(props);
	};
	module.exports.IoCall = function IoCall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M391 480c-19.52 0-46.94-7.06-88-30-49.93-28-88.55-53.85-138.21-103.38C116.91 298.77 93.61 267.79 61 208.45c-36.84-67-30.56-102.12-23.54-117.13C45.82 73.38 58.16 62.65 74.11 52a176.3 176.3 0 0128.64-15.2c1-.43 1.93-.84 2.76-1.21 4.95-2.23 12.45-5.6 21.95-2 6.34 2.38 12 7.25 20.86 16 18.17 17.92 43 57.83 52.16 77.43 6.15 13.21 10.22 21.93 10.23 31.71 0 11.45-5.76 20.28-12.75 29.81-1.31 1.79-2.61 3.5-3.87 5.16-7.61 10-9.28 12.89-8.18 18.05 2.23 10.37 18.86 41.24 46.19 68.51s57.31 42.85 67.72 45.07c5.38 1.15 8.33-.59 18.65-8.47 1.48-1.13 3-2.3 4.59-3.47 10.66-7.93 19.08-13.54 30.26-13.54h.06c9.73 0 18.06 4.22 31.86 11.18 18 9.08 59.11 33.59 77.14 51.78 8.77 8.84 13.66 14.48 16.05 20.81 3.6 9.53.21 17-2 22-.37.83-.78 1.74-1.21 2.75a176.49 176.49 0 01-15.29 28.58c-10.63 15.9-21.4 28.21-39.38 36.58A67.42 67.42 0 01391 480z"}}]})(props);
	};
	module.exports.IoCameraOutline = function IoCameraOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M350.54 148.68l-26.62-42.06C318.31 100.08 310.62 96 302 96h-92c-8.62 0-16.31 4.08-21.92 10.62l-26.62 42.06C155.85 155.23 148.62 160 140 160H80a32 32 0 00-32 32v192a32 32 0 0032 32h352a32 32 0 0032-32V192a32 32 0 00-32-32h-59c-8.65 0-16.85-4.77-22.46-11.32z"}},{"tag":"circle","attr":{"cx":"256","cy":"272","r":"80","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M124 158v-22h-24v22"}}]})(props);
	};
	module.exports.IoCameraReverseOutline = function IoCameraReverseOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M350.54 148.68l-26.62-42.06C318.31 100.08 310.62 96 302 96h-92c-8.62 0-16.31 4.08-21.92 10.62l-26.62 42.06C155.85 155.23 148.62 160 140 160H80a32 32 0 00-32 32v192a32 32 0 0032 32h352a32 32 0 0032-32V192a32 32 0 00-32-32h-59c-8.65 0-16.85-4.77-22.46-11.32z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M124 158v-22h-24v22m235.76 127.22v-13.31a80 80 0 00-131-61.6M176 258.78v13.31a80 80 0 00130.73 61.8"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M196 272l-20-20-20 20m200 0l-20 20-20-20"}}]})(props);
	};
	module.exports.IoCameraReverseSharp = function IoCameraReverseSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456 144h-83c-3 0-6.72-1.94-9.62-5l-27.31-42.79C326 80 320 80 302 80h-92c-18 0-23 0-34.07 16.21L148.62 139c-2.22 2.42-5.34 5-8.62 5v-16a8 8 0 00-8-8H92a8 8 0 00-8 8v16H56a24 24 0 00-24 24v240a24 24 0 0024 24h400a24 24 0 0024-24V168a24 24 0 00-24-24zM256 368c-47.82 0-87.76-34.23-95-80h-43.63L176 229.37 234.63 288H194a64.07 64.07 0 00102.63 33.49L320 343l-3.68 3.72A96.64 96.64 0 01256 368zm80-53.84L277.11 256H318a64.26 64.26 0 00-103-33.36L192 200l3.14-2.45A96.19 96.19 0 01255.76 176c47.85 0 87 34.19 94.24 80h44.92z"}}]})(props);
	};
	module.exports.IoCameraReverse = function IoCameraReverse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z"}}]})(props);
	};
	module.exports.IoCameraSharp = function IoCameraSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"272","r":"64"}},{"tag":"path","attr":{"d":"M456 144h-83c-3 0-6.72-1.94-9.62-5L336.1 96.2C325 80 320 80 302 80h-92c-18 0-24 0-34.07 16.21L148.62 139c-2.22 2.42-5.34 5-8.62 5v-16a8 8 0 00-8-8H92a8 8 0 00-8 8v16H56a24 24 0 00-24 24v240a24 24 0 0024 24h400a24 24 0 0024-24V168a24 24 0 00-24-24zM260.51 367.9a96 96 0 1191.39-91.39 96.11 96.11 0 01-91.39 91.39z"}}]})(props);
	};
	module.exports.IoCamera = function IoCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"272","r":"64"}},{"tag":"path","attr":{"d":"M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z"}}]})(props);
	};
	module.exports.IoCarOutline = function IoCarOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M80 224l37.78-88.15C123.93 121.5 139.6 112 157.11 112h197.78c17.51 0 33.18 9.5 39.33 23.85L432 224m-352 0h352v144H80zm32 144v32H80v-32m352 0v32h-32v-32"}},{"tag":"circle","attr":{"cx":"144","cy":"288","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"368","cy":"288","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoCarSharp = function IoCarSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.68 220.78a16.44 16.44 0 00-1-3.1l-48-112A16 16 0 00384 96H128a16 16 0 00-14.71 9.7l-48 112a16.44 16.44 0 00-1 3.1A16.15 16.15 0 0064 224v184a8 8 0 008 8h32a8 8 0 008-8v-24h288v24a8 8 0 008 8h32a8 8 0 008-8V224a16.15 16.15 0 00-.32-3.22zM144 320a32 32 0 1132-32 32 32 0 01-32 32zm224 0a32 32 0 1132-32 32 32 0 01-32 32zM104.26 208l34.29-80h234.9l34.29 80z"}}]})(props);
	};
	module.exports.IoCarSportOutline = function IoCarSportOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M469.71 234.6c-7.33-9.73-34.56-16.43-46.08-33.94s-20.95-55.43-50.27-70S288 112 256 112s-88 4-117.36 18.63-38.75 52.52-50.27 70-38.75 24.24-46.08 33.97S29.8 305.84 32.94 336s9 48 9 48h86c14.08 0 18.66-5.29 47.46-8 31.6-3 62.6-4 80.6-4s50 1 81.58 4c28.8 2.73 33.53 8 47.46 8h85s5.86-17.84 9-48-2.04-91.67-9.33-101.4zM400 384h56v16h-56zm-344 0h56v16H56z"}},{"tag":"path","attr":{"d":"M364.47 309.16c-5.91-6.83-25.17-12.53-50.67-16.35S279 288 256.2 288s-33.17 1.64-57.61 4.81-42.79 8.81-50.66 16.35C136.12 320.6 153.42 333.44 167 335c13.16 1.5 39.47.95 89.31.95s76.15.55 89.31-.95c13.56-1.65 29.62-13.6 18.85-25.84zm67.1-66.11a3.23 3.23 0 00-3.1-3c-11.81-.42-23.8.42-45.07 6.69a93.88 93.88 0 00-30.08 15.06c-2.28 1.78-1.47 6.59 1.39 7.1a455.32 455.32 0 0052.82 3.1c10.59 0 21.52-3 23.55-12.44a52.41 52.41 0 00.49-16.51zm-351.14 0a3.23 3.23 0 013.1-3c11.81-.42 23.8.42 45.07 6.69a93.88 93.88 0 0130.08 15.06c2.28 1.78 1.47 6.59-1.39 7.1a455.32 455.32 0 01-52.82 3.1c-10.59 0-21.52-3-23.55-12.44a52.41 52.41 0 01-.49-16.51z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M432 192h16m-384 0h16m-2 19s46.35-12 178-12 178 12 178 12"}}]})(props);
	};
	module.exports.IoCarSportSharp = function IoCarSportSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 224c-3-5-32.61-17.79-32.61-17.79 5.15-2.66 8.67-3.21 8.67-14.21 0-12-.06-16-8.06-16h-27.14c-.11-.24-.23-.49-.34-.74-17.52-38.26-19.87-47.93-46-60.95C347.47 96.88 281.76 96 256 96s-91.47.88-126.49 18.31c-26.16 13-25.51 19.69-46 60.95 0 .11-.21.4-.4.74H55.94c-7.94 0-8 4-8 16 0 11 3.52 11.55 8.67 14.21C56.61 206.21 28 220 24 224s-8 32-8 80 4 96 4 96h11.94c0 14 2.06 16 8.06 16h80c6 0 8-2 8-16h256c0 14 2 16 8 16h82c4 0 6-3 6-16h12s4-49 4-96-5-75-8-80zm-362.74 44.94A516.94 516.94 0 0170.42 272c-20.42 0-21.12 1.31-22.56-11.44a72.16 72.16 0 01.51-17.51L49 240h3c12 0 23.27.51 44.55 6.78a98 98 0 0130.09 15.06C131 265 132 268 132 268zm247.16 72L368 352H144s.39-.61-5-11.18c-4-7.82 1-12.82 8.91-15.66C163.23 319.64 208 304 256 304s93.66 13.48 108.5 21.16C370 328 376.83 330 372.42 341zm-257-136.53a96.23 96.23 0 01-9.7.07c2.61-4.64 4.06-9.81 6.61-15.21 8-17 17.15-36.24 33.44-44.35 23.54-11.72 72.33-17 110.23-17s86.69 5.24 110.23 17c16.29 8.11 25.4 27.36 33.44 44.35 2.57 5.45 4 10.66 6.68 15.33-2 .11-4.3 0-9.79-.19zm347.72 56.11C461 273 463 272 441.58 272a516.94 516.94 0 01-54.84-3.06c-2.85-.51-3.66-5.32-1.38-7.1a93.84 93.84 0 0130.09-15.06c21.28-6.27 33.26-7.11 45.09-6.69a3.22 3.22 0 013.09 3 70.18 70.18 0 01-.49 17.47z"}}]})(props);
	};
	module.exports.IoCarSport = function IoCarSport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M494.26 276.22c-3.6-40.41-9.53-48.28-11.77-51.24-5.15-6.84-13.39-11.31-22.11-16a3.6 3.6 0 01-.91-5.68 15.93 15.93 0 004.53-12.53A16.27 16.27 0 00447.65 176h-15.6a17 17 0 00-2 .13 8.5 8.5 0 00-1.41-.47c-9.24-19.53-21.89-46.27-48.11-59.32C341.64 97 270 96 256 96s-85.64 1-124.48 20.31c-26.22 13.05-38.87 39.79-48.11 59.32l-.08.16a6.52 6.52 0 00-1.35.34 17 17 0 00-2-.13H64.35A16.27 16.27 0 0048 190.77a15.93 15.93 0 004.59 12.47 3.6 3.6 0 01-.91 5.68c-8.72 4.72-17 9.19-22.11 16-2.24 3-8.16 10.83-11.77 51.24-2 22.74-2.3 46.28-.73 61.44 3.29 31.5 9.46 50.54 9.72 51.33a16 16 0 0013.2 10.87v.2a16 16 0 0016 16h56a16 16 0 0016-16c8.61 0 14.6-1.54 20.95-3.18a158.83 158.83 0 0128-4.91C207.45 389 237.79 388 256 388c17.84 0 49.52 1 80.08 3.91a159.16 159.16 0 0128.11 4.93c6.08 1.56 11.85 3 19.84 3.15a16 16 0 0016 16h56a16 16 0 0016-16v-.12A16 16 0 00485.27 389c.26-.79 6.43-19.83 9.72-51.33 1.57-15.17 1.29-38.67-.73-61.45zm-381.93-86.91c8-17 17.15-36.24 33.44-44.35 23.54-11.72 72.33-17 110.23-17s86.69 5.24 110.23 17c16.29 8.11 25.4 27.36 33.44 44.35l1 2.17a8 8 0 01-7.44 11.42C360 202 290 199.12 256 199.12s-104 2.95-137.28 3.85a8 8 0 01-7.44-11.42c.35-.74.72-1.49 1.05-2.24zm11.93 79.63A427.17 427.17 0 0172.42 272c-10.6 0-21.53-3-23.56-12.44-1.39-6.35-1.24-9.92-.49-13.51C49 243 50 240.78 55 240c13-2 20.27.51 41.55 6.78 14.11 4.15 24.29 9.68 30.09 14.06 2.91 2.16 1.36 7.8-2.38 8.1zm221.38 82c-13.16 1.5-39.48.95-89.34.95s-76.17.55-89.33-.95c-13.58-1.51-30.89-14.35-19.07-25.79 7.87-7.54 26.23-13.18 50.68-16.35s34.8-4.8 57.62-4.8 32.12 1 57.62 4.81 44.77 9.52 50.68 16.35c10.78 12.24-5.29 24.19-18.86 25.84zm117.5-91.39c-2 9.48-13 12.44-23.56 12.44a455.91 455.91 0 01-52.84-3.06c-3.06-.29-4.48-5.66-1.38-8.1 5.71-4.49 16-9.91 30.09-14.06 21.28-6.27 33.55-8.78 44.09-6.69 2.57.51 3.93 3.27 4.09 5a40.64 40.64 0 01-.49 14.48z"}}]})(props);
	};
	module.exports.IoCar = function IoCar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.68 220.78a16 16 0 00-1-3.08l-37.78-88.16C400.19 109.17 379 96 354.89 96H157.11c-24.09 0-45.3 13.17-54 33.54L65.29 217.7A15.72 15.72 0 0064 224v176a16 16 0 0016 16h32a16 16 0 0016-16v-16h256v16a16 16 0 0016 16h32a16 16 0 0016-16V224a16.15 16.15 0 00-.32-3.22zM144 320a32 32 0 1132-32 32 32 0 01-32 32zm224 0a32 32 0 1132-32 32 32 0 01-32 32zM104.26 208l28.23-65.85C136.11 133.69 146 128 157.11 128h197.78c11.1 0 21 5.69 24.62 14.15L407.74 208z"}}]})(props);
	};
	module.exports.IoCardOutline = function IoCardOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"320","x":"48","y":"96","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"56","ry":"56"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"60","d":"M48 192h416M128 300h48v20h-48z"}}]})(props);
	};
	module.exports.IoCardSharp = function IoCardSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 416a16 16 0 0016 16h416a16 16 0 0016-16V222H32zm66-138a8 8 0 018-8h92a8 8 0 018 8v64a8 8 0 01-8 8h-92a8 8 0 01-8-8zM464 80H48a16 16 0 00-16 16v66h448V96a16 16 0 00-16-16z"}}]})(props);
	};
	module.exports.IoCard = function IoCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 376a56 56 0 0056 56h336a56 56 0 0056-56V222H32zm66-76a30 30 0 0130-30h48a30 30 0 0130 30v20a30 30 0 01-30 30h-48a30 30 0 01-30-30zM424 80H88a56 56 0 00-56 56v26h448v-26a56 56 0 00-56-56z"}}]})(props);
	};
	module.exports.IoCaretBackCircleOutline = function IoCaretBackCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M273.77 169.57l-89.09 74.13a16 16 0 000 24.6l89.09 74.13A16 16 0 00300 330.14V181.86a16 16 0 00-26.23-12.29z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoCaretBackCircleSharp = function IoCaretBackCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm252 108.27L169.91 256 300 147.73z"}}]})(props);
	};
	module.exports.IoCaretBackCircle = function IoCaretBackCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm252-74.14v148.28a16 16 0 01-26.23 12.29l-89.09-74.13a16 16 0 010-24.6l89.09-74.13A16 16 0 01300 181.86z"}}]})(props);
	};
	module.exports.IoCaretBackOutline = function IoCaretBackOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M321.94 98L158.82 237.78a24 24 0 000 36.44L321.94 414c15.57 13.34 39.62 2.28 39.62-18.22v-279.6c0-20.5-24.05-31.56-39.62-18.18z"}}]})(props);
	};
	module.exports.IoCaretBackSharp = function IoCaretBackSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 64L144 256l224 192V64z"}}]})(props);
	};
	module.exports.IoCaretBack = function IoCaretBack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M321.94 98L158.82 237.78a24 24 0 000 36.44L321.94 414c15.57 13.34 39.62 2.28 39.62-18.22v-279.6c0-20.5-24.05-31.56-39.62-18.18z"}}]})(props);
	};
	module.exports.IoCaretDownCircleOutline = function IoCaretDownCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M342.43 238.23l-74.13 89.09a16 16 0 01-24.6 0l-74.13-89.09A16 16 0 01181.86 212h148.28a16 16 0 0112.29 26.23z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoCaretDownCircleSharp = function IoCaretDownCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-99.73-44L256 342.09 147.73 212z"}}]})(props);
	};
	module.exports.IoCaretDownCircle = function IoCaretDownCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-121.57-17.77l-74.13 89.09a16 16 0 01-24.6 0l-74.13-89.09A16 16 0 01181.86 212h148.28a16 16 0 0112.29 26.23z"}}]})(props);
	};
	module.exports.IoCaretDownOutline = function IoCaretDownOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z"}}]})(props);
	};
	module.exports.IoCaretDownSharp = function IoCaretDownSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 144l192 224 192-224H64z"}}]})(props);
	};
	module.exports.IoCaretDown = function IoCaretDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z"}}]})(props);
	};
	module.exports.IoCaretForwardCircleOutline = function IoCaretForwardCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M238.23 342.43l89.09-74.13a16 16 0 000-24.6l-89.09-74.13A16 16 0 00212 181.86v148.28a16 16 0 0026.23 12.29z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoCaretForwardCircleSharp = function IoCaretForwardCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zM212 147.73L342.09 256 212 364.27z"}}]})(props);
	};
	module.exports.IoCaretForwardCircle = function IoCaretForwardCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-252 74.14V181.86a16 16 0 0126.23-12.29l89.09 74.13a16 16 0 010 24.6l-89.09 74.13A16 16 0 01212 330.14z"}}]})(props);
	};
	module.exports.IoCaretForwardOutline = function IoCaretForwardOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M190.06 414l163.12-139.78a24 24 0 000-36.44L190.06 98c-15.57-13.34-39.62-2.28-39.62 18.22v279.6c0 20.5 24.05 31.56 39.62 18.18z"}}]})(props);
	};
	module.exports.IoCaretForwardSharp = function IoCaretForwardSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144 448l224-192L144 64v384z"}}]})(props);
	};
	module.exports.IoCaretForward = function IoCaretForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M190.06 414l163.12-139.78a24 24 0 000-36.44L190.06 98c-15.57-13.34-39.62-2.28-39.62 18.22v279.6c0 20.5 24.05 31.56 39.62 18.18z"}}]})(props);
	};
	module.exports.IoCaretUpCircleOutline = function IoCaretUpCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M342.43 273.77l-74.13-89.09a16 16 0 00-24.6 0l-74.13 89.09A16 16 0 00181.86 300h148.28a16 16 0 0012.29-26.23z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoCaretUpCircleSharp = function IoCaretUpCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zM147.73 300L256 169.91 364.27 300z"}}]})(props);
	};
	module.exports.IoCaretUpCircle = function IoCaretUpCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm74.14 252H181.86a16 16 0 01-12.29-26.23l74.13-89.09a16 16 0 0124.6 0l74.13 89.09A16 16 0 01330.14 300z"}}]})(props);
	};
	module.exports.IoCaretUpOutline = function IoCaretUpOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z"}}]})(props);
	};
	module.exports.IoCaretUpSharp = function IoCaretUpSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 368L256 144 64 368h384z"}}]})(props);
	};
	module.exports.IoCaretUp = function IoCaretUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z"}}]})(props);
	};
	module.exports.IoCartOutline = function IoCartOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"176","cy":"416","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"400","cy":"416","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 80h64l48 272h256"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 288h249.44a8 8 0 007.85-6.43l28.8-144a8 8 0 00-7.85-9.57H128"}}]})(props);
	};
	module.exports.IoCartSharp = function IoCartSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"176","cy":"416","r":"32"}},{"tag":"circle","attr":{"cx":"400","cy":"416","r":"32"}},{"tag":"path","attr":{"d":"M167.78 304h261.34l38.4-192H133.89l-8.47-48H32v32h66.58l48 272H432v-32H173.42l-5.64-32z"}}]})(props);
	};
	module.exports.IoCart = function IoCart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"176","cy":"416","r":"32"}},{"tag":"circle","attr":{"cx":"400","cy":"416","r":"32"}},{"tag":"path","attr":{"d":"M456.8 120.78a23.92 23.92 0 00-18.56-8.78H133.89l-6.13-34.78A16 16 0 00112 64H48a16 16 0 000 32h50.58l45.66 258.78A16 16 0 00160 368h256a16 16 0 000-32H173.42l-5.64-32h241.66A24.07 24.07 0 00433 284.71l28.8-144a24 24 0 00-5-19.93z"}}]})(props);
	};
	module.exports.IoCashOutline = function IoCashOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"448","height":"256","x":"32","y":"80","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"16","ry":"16","transform":"rotate(180 256 208)"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M64 384h384M96 432h320"}},{"tag":"circle","attr":{"cx":"256","cy":"208","r":"80","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M480 160a80 80 0 01-80-80M32 160a80 80 0 0080-80m368 176a80 80 0 00-80 80M32 256a80 80 0 0180 80"}}]})(props);
	};
	module.exports.IoCashSharp = function IoCashSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 368h416v32H48zm32 48h352v32H80zm400-240a96.11 96.11 0 01-96-96V64H128v16a96.11 96.11 0 01-96 96H16v64h16a96.11 96.11 0 0196 96v16h256v-16a96.11 96.11 0 0196-96h16v-64zM256 304a96 96 0 1196-96 96.11 96.11 0 01-96 96z"}},{"tag":"path","attr":{"d":"M96 80V64H16v80h16a64.07 64.07 0 0064-64zM32 272H16v80h80v-16a64.07 64.07 0 00-64-64zm448-128h16V64h-80v16a64.07 64.07 0 0064 64zm-64 192v16h80v-80h-16a64.07 64.07 0 00-64 64z"}},{"tag":"circle","attr":{"cx":"256","cy":"208","r":"64"}}]})(props);
	};
	module.exports.IoCash = function IoCash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 400H64a16 16 0 010-32h384a16 16 0 010 32zm-32 48H96a16 16 0 010-32h320a16 16 0 010 32zM32 272H16v48a32 32 0 0032 32h48v-16a64.07 64.07 0 00-64-64z"}},{"tag":"path","attr":{"d":"M480 240h16v-64h-16a96.11 96.11 0 01-96-96V64H128v16a96.11 96.11 0 01-96 96H16v64h16a96.11 96.11 0 0196 96v16h256v-16a96.11 96.11 0 0196-96zm-224 64a96 96 0 1196-96 96.11 96.11 0 01-96 96z"}},{"tag":"circle","attr":{"cx":"256","cy":"208","r":"64"}},{"tag":"path","attr":{"d":"M416 336v16h48a32 32 0 0032-32v-48h-16a64.07 64.07 0 00-64 64zm64-192h16V96a32 32 0 00-32-32h-48v16a64.07 64.07 0 0064 64zM96 80V64H48a32 32 0 00-32 32v48h16a64.07 64.07 0 0064-64z"}}]})(props);
	};
	module.exports.IoCellularOutline = function IoCellularOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"64","height":"320","x":"416","y":"96","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"64","height":"240","x":"288","y":"176","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"64","height":"176","x":"160","y":"240","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"64","height":"112","x":"32","y":"304","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"8","ry":"8"}}]})(props);
	};
	module.exports.IoCellularSharp = function IoCellularSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 432h-96V80h96zm-128 0h-96V160h96zm-128 0h-96V224h96zm-128 0H16V288h96z"}}]})(props);
	};
	module.exports.IoCellular = function IoCellular (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M472 432h-48a24 24 0 01-24-24V104a24 24 0 0124-24h48a24 24 0 0124 24v304a24 24 0 01-24 24zm-128 0h-48a24 24 0 01-24-24V184a24 24 0 0124-24h48a24 24 0 0124 24v224a24 24 0 01-24 24zm-128 0h-48a24 24 0 01-24-24V248a24 24 0 0124-24h48a24 24 0 0124 24v160a24 24 0 01-24 24zm-128 0H40a24 24 0 01-24-24v-96a24 24 0 0124-24h48a24 24 0 0124 24v96a24 24 0 01-24 24z"}}]})(props);
	};
	module.exports.IoChatboxEllipsesOutline = function IoChatboxEllipsesOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M408 64H104a56.16 56.16 0 00-56 56v192a56.16 56.16 0 0056 56h40v80l93.72-78.14a8 8 0 015.13-1.86H408a56.16 56.16 0 0056-56V120a56.16 56.16 0 00-56-56z"}},{"tag":"circle","attr":{"cx":"160","cy":"216","r":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"216","r":"32"}},{"tag":"circle","attr":{"cx":"352","cy":"216","r":"32"}}]})(props);
	};
	module.exports.IoChatboxEllipsesSharp = function IoChatboxEllipsesSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456 48H56a24 24 0 00-24 24v288a24 24 0 0024 24h72v80l117.74-80H456a24 24 0 0024-24V72a24 24 0 00-24-24zM160 248a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zM456 80z"}}]})(props);
	};
	module.exports.IoChatboxEllipses = function IoChatboxEllipses (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408 48H104a72.08 72.08 0 00-72 72v192a72.08 72.08 0 0072 72h24v64a16 16 0 0026.25 12.29L245.74 384H408a72.08 72.08 0 0072-72V120a72.08 72.08 0 00-72-72zM160 248a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoChatboxOutline = function IoChatboxOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M408 64H104a56.16 56.16 0 00-56 56v192a56.16 56.16 0 0056 56h40v80l93.72-78.14a8 8 0 015.13-1.86H408a56.16 56.16 0 0056-56V120a56.16 56.16 0 00-56-56z"}}]})(props);
	};
	module.exports.IoChatboxSharp = function IoChatboxSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 464v-80H56a24 24 0 01-24-24V72a24 24 0 0124-24h400a24 24 0 0124 24v288a24 24 0 01-24 24H245.74zM456 80z"}}]})(props);
	};
	module.exports.IoChatbox = function IoChatbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144 464a16 16 0 01-16-16v-64h-24a72.08 72.08 0 01-72-72V120a72.08 72.08 0 0172-72h304a72.08 72.08 0 0172 72v192a72.08 72.08 0 01-72 72H245.74l-91.49 76.29A16.05 16.05 0 01144 464z"}}]})(props);
	};
	module.exports.IoChatbubbleEllipsesOutline = function IoChatbubbleEllipsesOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M87.48 380c1.2-4.38-1.43-10.47-3.94-14.86a42.63 42.63 0 00-2.54-3.8 199.81 199.81 0 01-33-110C47.64 139.09 140.72 48 255.82 48 356.2 48 440 117.54 459.57 209.85a199 199 0 014.43 41.64c0 112.41-89.49 204.93-204.59 204.93-18.31 0-43-4.6-56.47-8.37s-26.92-8.77-30.39-10.11a31.14 31.14 0 00-11.13-2.07 30.7 30.7 0 00-12.08 2.43L81.5 462.78a15.92 15.92 0 01-4.66 1.22 9.61 9.61 0 01-9.58-9.74 15.85 15.85 0 01.6-3.29z"}},{"tag":"circle","attr":{"cx":"160","cy":"256","r":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"32"}},{"tag":"circle","attr":{"cx":"352","cy":"256","r":"32"}}]})(props);
	};
	module.exports.IoChatbubbleEllipsesSharp = function IoChatbubbleEllipsesSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M475.22 206.52c-10.34-48.65-37.76-92.93-77.22-124.68A227.4 227.4 0 00255.82 32C194.9 32 138 55.47 95.46 98.09 54.35 139.33 31.82 193.78 32 251.37a215.66 215.66 0 0035.65 118.76l4.35 6.05L48 480l114.8-28.56s2.3.77 4 1.42 16.33 6.26 31.85 10.6c12.9 3.6 39.74 9 60.77 9 59.65 0 115.35-23.1 156.83-65.06C457.36 365.77 480 310.42 480 251.49a213.5 213.5 0 00-4.78-44.97zM160 288a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoChatbubbleEllipses = function IoChatbubbleEllipses (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M398 81.84A227.4 227.4 0 00255.82 32C194.9 32 138 55.47 95.46 98.09 54.35 139.33 31.82 193.78 32 251.37a215.66 215.66 0 0035.65 118.76l.19.27c.28.41.57.82.86 1.22s.65.92.73 1.05l.22.4c1.13 2 2 4.44 1.23 6.9l-18.42 66.66a29.13 29.13 0 00-1.2 7.63A25.69 25.69 0 0076.83 480a29.44 29.44 0 0010.45-2.29l67.49-24.36.85-.33a14.75 14.75 0 015.8-1.15 15.12 15.12 0 015.37 1c1.62.63 16.33 6.26 31.85 10.6 12.9 3.6 39.74 9 60.77 9 59.65 0 115.35-23.1 156.83-65.06C457.36 365.77 480 310.42 480 251.49a213.5 213.5 0 00-4.78-45c-10.34-48.62-37.76-92.9-77.22-124.65zM87.48 380zM160 288a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoChatbubbleOutline = function IoChatbubbleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M87.49 380c1.19-4.38-1.44-10.47-3.95-14.86a44.86 44.86 0 00-2.54-3.8 199.81 199.81 0 01-33-110C47.65 139.09 140.73 48 255.83 48 356.21 48 440 117.54 459.58 209.85a199 199 0 014.42 41.64c0 112.41-89.49 204.93-204.59 204.93-18.3 0-43-4.6-56.47-8.37s-26.92-8.77-30.39-10.11a31.09 31.09 0 00-11.12-2.07 30.71 30.71 0 00-12.09 2.43l-67.83 24.48a16 16 0 01-4.67 1.22 9.6 9.6 0 01-9.57-9.74 15.85 15.85 0 01.6-3.29z"}}]})(props);
	};
	module.exports.IoChatbubbleSharp = function IoChatbubbleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M475.22 206.52c-10.34-48.65-37.76-92.93-77.22-124.68A227.4 227.4 0 00255.82 32C194.9 32 138 55.47 95.46 98.09 54.35 139.33 31.82 193.78 32 251.37a215.66 215.66 0 0035.65 118.76l4.35 6.05L48 480l114.8-28.56s2.3.77 4 1.42 16.33 6.26 31.85 10.6c12.9 3.6 39.74 9 60.77 9 59.65 0 115.35-23.1 156.83-65.06C457.36 365.77 480 310.42 480 251.49a213.5 213.5 0 00-4.78-44.97z"}}]})(props);
	};
	module.exports.IoChatbubble = function IoChatbubble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M76.83 480a25.69 25.69 0 01-25.57-25.74 29.13 29.13 0 011.2-7.63L70.88 380c.77-2.46-.1-4.94-1.23-6.9l-.22-.4c-.08-.13-.46-.66-.73-1.05s-.58-.81-.86-1.22l-.19-.27A215.66 215.66 0 0132 251.37c-.18-57.59 22.35-112 63.46-153.28C138 55.47 194.9 32 255.82 32A227.4 227.4 0 01398 81.84c39.45 31.75 66.87 76 77.21 124.68a213.5 213.5 0 014.78 45c0 58.93-22.64 114.28-63.76 155.87-41.48 42-97.18 65.06-156.83 65.06-21 0-47.87-5.36-60.77-9-15.52-4.34-30.23-10-31.85-10.6a15.12 15.12 0 00-5.37-1 14.75 14.75 0 00-5.8 1.15l-.85.33-67.48 24.38A29.44 29.44 0 0176.83 480zm-2-31.8zM87.48 380z"}}]})(props);
	};
	module.exports.IoChatbubblesOutline = function IoChatbubblesOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M431 320.6c-1-3.6 1.2-8.6 3.3-12.2a33.68 33.68 0 012.1-3.1A162 162 0 00464 215c.3-92.2-77.5-167-173.7-167-83.9 0-153.9 57.1-170.3 132.9a160.7 160.7 0 00-3.7 34.2c0 92.3 74.8 169.1 171 169.1 15.3 0 35.9-4.6 47.2-7.7s22.5-7.2 25.4-8.3a26.44 26.44 0 019.3-1.7 26 26 0 0110.1 2l56.7 20.1a13.52 13.52 0 003.9 1 8 8 0 008-8 12.85 12.85 0 00-.5-2.7z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M66.46 232a146.23 146.23 0 006.39 152.67c2.31 3.49 3.61 6.19 3.21 8s-11.93 61.87-11.93 61.87a8 8 0 002.71 7.68A8.17 8.17 0 0072 464a7.26 7.26 0 002.91-.6l56.21-22a15.7 15.7 0 0112 .2c18.94 7.38 39.88 12 60.83 12A159.21 159.21 0 00284 432.11"}}]})(props);
	};
	module.exports.IoChatbubblesSharp = function IoChatbubblesSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 312.43c.77-1.11 1.51-2.26 2.27-3.34A174.55 174.55 0 00480 211.85C480.32 112.55 396.54 32 292.94 32c-90.36 0-165.74 61.49-183.4 143.12a172.81 172.81 0 00-4 36.83c0 99.4 80.56 182.11 184.16 182.11 16.47 0 38.66-4.95 50.83-8.29s24.23-7.75 27.35-8.94 8-2.41 11.89-1.29l77.42 22.38a4 4 0 005-4.86l-17.72-67.49c-1.23-5-1.39-5.94 3.53-13.14z"}},{"tag":"path","attr":{"d":"M312.54 415.38a165.32 165.32 0 01-23.26 2.05c-42.43 0-82.5-11.2-115-32.2a184.09 184.09 0 01-53.09-49.32c-26.08-34.57-40.3-78.51-40.3-124.49 0-3.13.11-6.14.22-9.16a4.34 4.34 0 00-7.54-3.12 158.76 158.76 0 00-14.86 195.24c2.47 3.77 3.87 6.68 3.44 8.62l-14.09 72.26a4 4 0 005.22 4.53l68-24.24a16.85 16.85 0 0112.92.22c20.35 8 42.86 12.92 65.37 12.92a169.45 169.45 0 00116.63-46 4.29 4.29 0 00-3.66-7.31z"}}]})(props);
	};
	module.exports.IoChatbubbles = function IoChatbubbles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M60.44 389.17c0 .07 0 .2-.08.38.03-.12.05-.25.08-.38zM439.9 405.6a26.77 26.77 0 01-9.59-2l-56.78-20.13-.42-.17a9.88 9.88 0 00-3.91-.76 10.32 10.32 0 00-3.62.66c-1.38.52-13.81 5.19-26.85 8.77-7.07 1.94-31.68 8.27-51.43 8.27-50.48 0-97.68-19.4-132.89-54.63A183.38 183.38 0 01100.3 215.1a175.9 175.9 0 014.06-37.58c8.79-40.62 32.07-77.57 65.55-104A194.76 194.76 0 01290.3 32c52.21 0 100.86 20 137 56.18 34.16 34.27 52.88 79.33 52.73 126.87a177.86 177.86 0 01-30.3 99.15l-.19.28-.74 1c-.17.23-.34.45-.5.68l-.15.27a21.63 21.63 0 00-1.08 2.09l15.74 55.94a26.42 26.42 0 011.12 7.11 24 24 0 01-24.03 24.03z"}},{"tag":"path","attr":{"d":"M299.87 425.39a15.74 15.74 0 00-10.29-8.1c-5.78-1.53-12.52-1.27-17.67-1.65a201.78 201.78 0 01-128.82-58.75A199.21 199.21 0 0186.4 244.16C85 234.42 85 232 85 232a16 16 0 00-28-10.58s-7.88 8.58-11.6 17.19a162.09 162.09 0 0011 150.06C59 393 59 395 58.42 399.5c-2.73 14.11-7.51 39-10 51.91a24 24 0 008 22.92l.46.39A24.34 24.34 0 0072 480a23.42 23.42 0 009-1.79l53.51-20.65a8.05 8.05 0 015.72 0c21.07 7.84 43 12 63.78 12a176 176 0 0074.91-16.66c5.46-2.56 14-5.34 19-11.12a15 15 0 001.95-16.39z"}}]})(props);
	};
	module.exports.IoCheckboxOutline = function IoCheckboxOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 176L217.6 336 160 272"}},{"tag":"rect","attr":{"width":"384","height":"384","x":"64","y":"64","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}}]})(props);
	};
	module.exports.IoCheckboxSharp = function IoCheckboxSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 48v416h416V48zm170 312.38l-80.6-89.57 23.79-21.41 56 62.22L350 153.46 374.54 174z"}}]})(props);
	};
	module.exports.IoCheckbox = function IoCheckbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 48H112a64.07 64.07 0 00-64 64v288a64.07 64.07 0 0064 64h288a64.07 64.07 0 0064-64V112a64.07 64.07 0 00-64-64zm-35.75 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"}}]})(props);
	};
	module.exports.IoCheckmarkCircleOutline = function IoCheckmarkCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 176L217.6 336 160 272"}}]})(props);
	};
	module.exports.IoCheckmarkCircleSharp = function IoCheckmarkCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-38 312.38l-80.6-89.57 23.79-21.41 56 62.22L350 153.46 374.54 174z"}}]})(props);
	};
	module.exports.IoCheckmarkCircle = function IoCheckmarkCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm108.25 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"}}]})(props);
	};
	module.exports.IoCheckmarkDoneCircleOutline = function IoCheckmarkDoneCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M368 192L256.13 320l-47.95-48m-16.23 48L144 272m161.71-80l-51.55 59"}}]})(props);
	};
	module.exports.IoCheckmarkDoneCircleSharp = function IoCheckmarkDoneCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm48.19 121.42l24.1 21.06-73.61 84.1-24.1-23.06zM191.93 342.63L121.37 272 144 249.37 214.57 320zm65 .79L185.55 272l22.64-22.62 47.16 47.21 111.13-127.17 24.1 21.06z"}}]})(props);
	};
	module.exports.IoCheckmarkDoneCircle = function IoCheckmarkDoneCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zm-16.79 192.47l51.55-59a16 16 0 0124.1 21.06l-51.55 59a16 16 0 11-24.1-21.06zm-38.86 90.85a16 16 0 01-22.62 0l-47.95-48a16 16 0 1122.64-22.62l48 48a16 16 0 01-.07 22.62zm176.8-128.79l-111.88 128a16 16 0 01-11.51 5.47h-.54a16 16 0 01-11.32-4.69l-47.94-48a16 16 0 1122.64-22.62l29.8 29.83a8 8 0 0011.68-.39l95-108.66a16 16 0 0124.1 21.06z"}}]})(props);
	};
	module.exports.IoCheckmarkDoneOutline = function IoCheckmarkDoneOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M464 128L240 384l-96-96m0 96l-96-96m320-160L232 284"}}]})(props);
	};
	module.exports.IoCheckmarkDoneSharp = function IoCheckmarkDoneSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"44","d":"M465 127L241 384l-92-92m-9 93l-93-93m316-165L236 273"}}]})(props);
	};
	module.exports.IoCheckmarkDone = function IoCheckmarkDone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M464 128L240 384l-96-96m0 96l-96-96m320-160L232 284"}}]})(props);
	};
	module.exports.IoCheckmarkOutline = function IoCheckmarkOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M416 128L192 384l-96-96"}}]})(props);
	};
	module.exports.IoCheckmarkSharp = function IoCheckmarkSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"44","d":"M416 128L192 384l-96-96"}}]})(props);
	};
	module.exports.IoCheckmark = function IoCheckmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M416 128L192 384l-96-96"}}]})(props);
	};
	module.exports.IoChevronBackCircleOutline = function IoChevronBackCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M296 352l-96-96 96-96"}}]})(props);
	};
	module.exports.IoChevronBackCircleSharp = function IoChevronBackCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm62.63 304L296 374.63 177.37 256 296 137.37 318.63 160l-96 96z"}}]})(props);
	};
	module.exports.IoChevronBackCircle = function IoChevronBackCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm35.31 292.69a16 16 0 11-22.62 22.62l-96-96a16 16 0 010-22.62l96-96a16 16 0 0122.62 22.62L206.63 256z"}}]})(props);
	};
	module.exports.IoChevronBackOutline = function IoChevronBackOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M328 112L184 256l144 144"}}]})(props);
	};
	module.exports.IoChevronBackSharp = function IoChevronBackSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"48","d":"M328 112L184 256l144 144"}}]})(props);
	};
	module.exports.IoChevronBack = function IoChevronBack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M328 112L184 256l144 144"}}]})(props);
	};
	module.exports.IoChevronDownCircleOutline = function IoChevronDownCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 216l-96 96-96-96"}}]})(props);
	};
	module.exports.IoChevronDownCircleSharp = function IoChevronDownCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c114.87 0 208-93.13 208-208S370.87 48 256 48 48 141.13 48 256s93.13 208 208 208zm-96-270.63l96 96 96-96L374.63 216 256 334.63 137.37 216z"}}]})(props);
	};
	module.exports.IoChevronDownCircle = function IoChevronDownCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-100.69-28.69l-96 96a16 16 0 01-22.62 0l-96-96a16 16 0 0122.62-22.62L256 289.37l84.69-84.68a16 16 0 0122.62 22.62z"}}]})(props);
	};
	module.exports.IoChevronDownOutline = function IoChevronDownOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M112 184l144 144 144-144"}}]})(props);
	};
	module.exports.IoChevronDownSharp = function IoChevronDownSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"48","d":"M112 184l144 144 144-144"}}]})(props);
	};
	module.exports.IoChevronDown = function IoChevronDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M112 184l144 144 144-144"}}]})(props);
	};
	module.exports.IoChevronForwardCircleOutline = function IoChevronForwardCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M64 256c0 106 86 192 192 192s192-86 192-192S362 64 256 64 64 150 64 256z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M216 352l96-96-96-96"}}]})(props);
	};
	module.exports.IoChevronForwardCircleSharp = function IoChevronForwardCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm-40 326.63L193.37 352l96-96-96-96L216 137.37 334.63 256z"}}]})(props);
	};
	module.exports.IoChevronForwardCircle = function IoChevronForwardCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm257.37 0l-84.68-84.69a16 16 0 0122.62-22.62l96 96a16 16 0 010 22.62l-96 96a16 16 0 01-22.62-22.62z"}}]})(props);
	};
	module.exports.IoChevronForwardOutline = function IoChevronForwardOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M184 112l144 144-144 144"}}]})(props);
	};
	module.exports.IoChevronForwardSharp = function IoChevronForwardSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"48","d":"M184 112l144 144-144 144"}}]})(props);
	};
	module.exports.IoChevronForward = function IoChevronForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M184 112l144 144-144 144"}}]})(props);
	};
	module.exports.IoChevronUpCircleOutline = function IoChevronUpCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 296l-96-96-96 96"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"}}]})(props);
	};
	module.exports.IoChevronUpCircleSharp = function IoChevronUpCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm96 270.63l-96-96-96 96L137.37 296 256 177.37 374.63 296z"}}]})(props);
	};
	module.exports.IoChevronUpCircle = function IoChevronUpCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm107.31 259.31a16 16 0 01-22.62 0L256 222.63l-84.69 84.68a16 16 0 01-22.62-22.62l96-96a16 16 0 0122.62 0l96 96a16 16 0 010 22.62z"}}]})(props);
	};
	module.exports.IoChevronUpOutline = function IoChevronUpOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M112 328l144-144 144 144"}}]})(props);
	};
	module.exports.IoChevronUpSharp = function IoChevronUpSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"48","d":"M112 328l144-144 144 144"}}]})(props);
	};
	module.exports.IoChevronUp = function IoChevronUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M112 328l144-144 144 144"}}]})(props);
	};
	module.exports.IoClipboardOutline = function IoClipboardOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M336 64h32a48 48 0 0148 48v320a48 48 0 01-48 48H144a48 48 0 01-48-48V112a48 48 0 0148-48h32"}},{"tag":"rect","attr":{"width":"160","height":"64","x":"176","y":"32","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"26.13","ry":"26.13"}}]})(props);
	};
	module.exports.IoClipboardSharp = function IoClipboardSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M420 48h-68V28a12 12 0 00-12-12H172a12 12 0 00-12 12v20H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V60a12 12 0 00-12-12zm-84.13 64H176.13V80h159.74z"}}]})(props);
	};
	module.exports.IoClipboard = function IoClipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 48h-11.41a8 8 0 01-7.44-5.08A42.18 42.18 0 00309.87 16H202.13a42.18 42.18 0 00-39.28 26.92 8 8 0 01-7.44 5.08H144a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V112a64 64 0 00-64-64zm-48.13 64H192.13a16 16 0 010-32h127.74a16 16 0 010 32z"}}]})(props);
	};
	module.exports.IoCloseCircleOutline = function IoCloseCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 320L192 192m0 128l128-128"}}]})(props);
	};
	module.exports.IoCloseCircleSharp = function IoCloseCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm86.63 272L320 342.63l-64-64-64 64L169.37 320l64-64-64-64L192 169.37l64 64 64-64L342.63 192l-64 64z"}}]})(props);
	};
	module.exports.IoCloseCircle = function IoCloseCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm75.31 260.69a16 16 0 11-22.62 22.62L256 278.63l-52.69 52.68a16 16 0 01-22.62-22.62L233.37 256l-52.68-52.69a16 16 0 0122.62-22.62L256 233.37l52.69-52.68a16 16 0 0122.62 22.62L278.63 256z"}}]})(props);
	};
	module.exports.IoCloseOutline = function IoCloseOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M368 368L144 144m224 0L144 368"}}]})(props);
	};
	module.exports.IoCloseSharp = function IoCloseSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 145.49L366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49z"}}]})(props);
	};
	module.exports.IoClose = function IoClose (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"}}]})(props);
	};
	module.exports.IoCloudCircleOutline = function IoCloudCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M333.88 240.59a8 8 0 01-6.66-6.66C320.68 192.78 290.82 168 256 168c-32.37 0-53.93 21.22-62.48 43.58a7.92 7.92 0 01-6.16 5c-27.67 4.35-50.82 22.56-51.35 54.3-.52 31.53 25.51 57.11 57 57.11H326c27.5 0 50-13.72 50-44 0-27.22-22-40.41-42.12-43.4z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoCloudCircleSharp = function IoCloudCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm70 280H196c-33 0-60-23-60-56 0-34.21 26-53 56-56 7.28-23.9 29.5-48 64-48 36.5 0 67.55 27.23 72 72 21.49 1.12 48 14.09 48 44 0 30.28-22.5 44-50 44z"}}]})(props);
	};
	module.exports.IoCloudCircle = function IoCloudCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm70 280H193.05c-31.53 0-57.56-25.58-57-57.11.53-31.74 23.68-49.95 51.35-54.3a7.92 7.92 0 006.16-5C202.07 189.22 223.63 168 256 168c33.17 0 61.85 22.49 70.14 60.21a17.75 17.75 0 0013.18 13.43C357.79 246.05 376 259.21 376 284c0 30.28-22.5 44-50 44z"}}]})(props);
	};
	module.exports.IoCloudDoneOutline = function IoCloudDoneOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M400 240c-8.89-89.54-71-144-144-144-69 0-113.44 48.2-128 96-60 6-112 43.59-112 112 0 66 54 112 120 112h260c55 0 100-27.44 100-88 0-59.82-53-85.76-96-88z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M317 208L209.2 336 163 284.8"}}]})(props);
	};
	module.exports.IoCloudDoneSharp = function IoCloudDoneSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.25 225.36c-6.52-41.18-24.05-76.4-51.11-102.46A153.57 153.57 0 00256 80c-35.5 0-68.24 11.69-94.68 33.8a156.42 156.42 0 00-45.22 63.61c-30.26 4.81-57.45 17.18-77.38 35.37C13.39 235.88 0 267.42 0 304c0 36 14.38 68.88 40.49 92.59C65.64 419.43 99.56 432 136 432h260c32.37 0 60.23-8.57 80.59-24.77C499.76 388.78 512 361.39 512 328c0-61.85-48.44-95.34-97.75-102.64zm-204.63 135l-69.22-76.7 23.76-21.44 44.62 49.46 106.29-126.2 24.47 20.61z"}}]})(props);
	};
	module.exports.IoCloudDone = function IoCloudDone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424.44 227.25a16 16 0 01-12.12-12.39c-7.68-36.68-24.45-68.15-49.18-92A153.57 153.57 0 00256 80c-35.5 0-68.24 11.69-94.68 33.8a156.24 156.24 0 00-42 56 16 16 0 01-11.37 9.15c-27 5.62-51.07 17.34-69.18 33.87C13.39 235.88 0 267.42 0 304c0 36 14.38 68.88 40.49 92.59C65.64 419.43 99.56 432 136 432h260c32.37 0 60.23-8.57 80.59-24.77C499.76 388.78 512 361.39 512 328c0-57.57-42-90.58-87.56-100.75zm-95.2-8.94l-107.8 128a16 16 0 01-12 5.69h-.27a16 16 0 01-11.88-5.28l-45.9-50.87c-5.77-6.39-5.82-16.33.3-22.4a16 16 0 0123.16.63l33.9 37.58 96-114a16 16 0 1124.48 20.62z"}}]})(props);
	};
	module.exports.IoCloudDownloadOutline = function IoCloudDownloadOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56m0 64.1l64 63.9 64-63.9M256 224v224.03"}}]})(props);
	};
	module.exports.IoCloudDownloadSharp = function IoCloudDownloadSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M472.7 189.5c-15.76-10-36.21-16.79-58.59-19.54-6.65-39.1-24.22-72.52-51.27-97.26C334.15 46.45 296.21 32 256 32c-35.35 0-68 11.08-94.37 32a149.7 149.7 0 00-45.29 60.42c-30.67 4.32-57 14.61-76.71 30C13.7 174.83 0 203.56 0 237.6 0 305 55.92 352 136 352h104V208h32v144h124c72.64 0 116-34.24 116-91.6 0-30.05-13.59-54.57-39.3-70.9zM240 419.42L191.98 371l-22.61 23L256 480l86.63-86-22.61-23L272 419.42V352h-32v67.42z"}}]})(props);
	};
	module.exports.IoCloudDownload = function IoCloudDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M472.7 189.5c-13.26-8.43-29.83-14.56-48.08-17.93A16 16 0 01412 159.28c-7.86-34.51-24.6-64.13-49.15-86.58C334.15 46.45 296.21 32 256 32c-35.35 0-68 11.08-94.37 32a150.13 150.13 0 00-41.95 52.83A16.05 16.05 0 01108 125.8c-27.13 4.9-50.53 14.68-68.41 28.7C13.7 174.83 0 203.56 0 237.6 0 305 55.93 352 136 352h104V224.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 224v128h124c72.64 0 116-34.24 116-91.6 0-30.05-13.59-54.57-39.3-70.9zM240 425.42l-36.7-36.64a16 16 0 00-22.6 22.65l64 63.89a16 16 0 0022.6 0l64-63.89a16 16 0 00-22.6-22.65L272 425.42V352h-32z"}}]})(props);
	};
	module.exports.IoCloudOfflineOutline = function IoCloudOfflineOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M93.72 183.25C49.49 198.05 16 233.1 16 288c0 66 54 112 120 112h184.37m147.45-22.26C485.24 363.3 496 341.61 496 312c0-59.82-53-85.76-96-88-8.89-89.54-71-144-144-144-26.16 0-48.79 6.93-67.6 18.14"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 448L64 64"}}]})(props);
	};
	module.exports.IoCloudOfflineSharp = function IoCloudOfflineSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M41.37 64l22.628-22.628L470.627 448l-22.628 22.627zm-2.65 148.78C13.39 235.88 0 267.42 0 304c0 36 14.38 68.88 40.49 92.59C65.64 419.43 99.56 432 136 432h228.12L110.51 178.39c-28.01 5.39-53.09 17.33-71.79 34.39zm437.87 194.45C499.76 388.78 512 361.39 512 328c0-61.85-48.44-95.34-97.75-102.64-6.52-41.18-24.05-76.4-51.11-102.46A153.57 153.57 0 00256 80c-30.47 0-58.9 8.62-83.07 25l302.82 302.86c.25-.21.57-.41.84-.63z"}}]})(props);
	};
	module.exports.IoCloudOffline = function IoCloudOffline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 464a15.92 15.92 0 01-11.31-4.69l-384-384a16 16 0 0122.62-22.62l384 384A16 16 0 01448 464zM38.72 196.78C13.39 219.88 0 251.42 0 288c0 36 14.38 68.88 40.49 92.59C65.64 403.43 99.56 416 136 416h192.8a8 8 0 005.66-13.66L100.88 168.76a8 8 0 00-8-2C72 173.15 53.4 183.38 38.72 196.78zm437.87 194.45C499.76 372.78 512 345.39 512 312c0-57.57-42-90.58-87.56-100.75a16 16 0 01-12.12-12.39c-7.68-36.68-24.45-68.15-49.18-92A153.57 153.57 0 00256 64c-31.12 0-60.12 9-84.62 26.1a8 8 0 00-1.14 12.26L461.68 393.8a8 8 0 0010.2.93q2.43-1.68 4.71-3.5z"}}]})(props);
	};
	module.exports.IoCloudOutline = function IoCloudOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M400 240c-8.89-89.54-71-144-144-144-69 0-113.44 48.2-128 96-60 6-112 43.59-112 112 0 66 54 112 120 112h260c55 0 100-27.44 100-88 0-59.82-53-85.76-96-88z"}}]})(props);
	};
	module.exports.IoCloudSharp = function IoCloudSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396 432H136c-36.44 0-70.36-12.57-95.51-35.41C14.38 372.88 0 340 0 304c0-36.58 13.39-68.12 38.72-91.22 19.93-18.19 47.12-30.56 77.38-35.37a156.42 156.42 0 0145.22-63.61C187.76 91.69 220.5 80 256 80a153.57 153.57 0 01107.14 42.9c27.06 26.06 44.59 61.28 51.11 102.46C463.56 232.66 512 266.15 512 328c0 33.39-12.24 60.78-35.41 79.23C456.23 423.43 428.37 432 396 432z"}}]})(props);
	};
	module.exports.IoCloudUploadOutline = function IoCloudUploadOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 255.79l-64-64-64 64m64 192.42V207.79"}}]})(props);
	};
	module.exports.IoCloudUploadSharp = function IoCloudUploadSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M473.66 210c-16.56-12.3-37.7-20.75-59.52-24-6.62-39.18-24.21-72.67-51.3-97.45-28.69-26.3-66.63-40.76-106.84-40.76-35.35 0-68 11.08-94.37 32.05a149.61 149.61 0 00-45.32 60.49c-29.94 4.6-57.12 16.68-77.39 34.55C13.46 197.33 0 227.24 0 261.39c0 34.52 14.49 66 40.79 88.76 25.12 21.69 58.94 33.64 95.21 33.64h104V230.42l-48 48-22.63-22.63L256 169.17l86.63 86.62L320 278.42l-48-48v153.37h124c31.34 0 59.91-8.8 80.45-24.77 23.26-18.1 35.55-44 35.55-74.83 0-29.94-13.26-55.61-38.34-74.19zM240 383.79h32v80.41h-32z"}}]})(props);
	};
	module.exports.IoCloudUpload = function IoCloudUpload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M473.66 210c-14-10.38-31.2-18-49.36-22.11a16.11 16.11 0 01-12.19-12.22c-7.8-34.75-24.59-64.55-49.27-87.13C334.15 62.25 296.21 47.79 256 47.79c-35.35 0-68 11.08-94.37 32.05a150.07 150.07 0 00-42.06 53 16 16 0 01-11.31 8.87c-26.75 5.4-50.9 16.87-69.34 33.12C13.46 197.33 0 227.24 0 261.39c0 34.52 14.49 66 40.79 88.76 25.12 21.69 58.94 33.64 95.21 33.64h104V230.42l-36.69 36.69a16 16 0 01-23.16-.56c-5.8-6.37-5.24-16.3.85-22.39l63.69-63.68a16 16 0 0122.62 0L331 244.14c6.28 6.29 6.64 16.6.39 22.91a16 16 0 01-22.68.06L272 230.42v153.37h124c31.34 0 59.91-8.8 80.45-24.77 23.26-18.1 35.55-44 35.55-74.83 0-29.94-13.26-55.61-38.34-74.19zM240 448.21a16 16 0 1032 0v-64.42h-32z"}}]})(props);
	};
	module.exports.IoCloud = function IoCloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396 432H136c-36.44 0-70.36-12.57-95.51-35.41C14.38 372.88 0 340 0 304c0-36.58 13.39-68.12 38.72-91.22 18.11-16.53 42.22-28.25 69.18-33.87a16 16 0 0011.37-9.15 156.24 156.24 0 0142.05-56C187.76 91.69 220.5 80 256 80a153.57 153.57 0 01107.14 42.9c24.73 23.81 41.5 55.28 49.18 92a16 16 0 0012.12 12.39C470 237.42 512 270.43 512 328c0 33.39-12.24 60.78-35.41 79.23C456.23 423.43 428.37 432 396 432z"}}]})(props);
	};
	module.exports.IoCloudyNightOutline = function IoCloudyNightOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M388.31 272c47.75 0 89.77-27.77 107.69-68.92-14.21 6.18-30.9 8.61-47.38 8.61A116.31 116.31 0 01332.31 95.38c0-16.48 2.43-33.17 8.61-47.38C299.77 65.92 272 107.94 272 155.69a116.31 116.31 0 003.44 28.18"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M90.61 306.85A16.07 16.07 0 00104 293.6C116.09 220.17 169.63 176 232 176c57.93 0 96.62 37.75 112.2 77.74a15.84 15.84 0 0012.2 9.87c50 8.15 91.6 41.54 91.6 99.59 0 59.4-48.6 100.8-108 100.8H106c-49.5 0-90-24.7-90-79.2 0-48.47 38.67-72.22 74.61-77.95z"}}]})(props);
	};
	module.exports.IoCloudyNightSharp = function IoCloudyNightSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-29.44 12.09-54.25 35-71.74 14.55-11.13 33.41-18.87 53.2-22 6.06-36.92 21.92-68.53 46.29-92A139.82 139.82 0 01232 160c32.33 0 62.15 10.65 86.24 30.79a142.41 142.41 0 0140.83 57.05c27.18 4.48 51.59 15.68 69.56 32.08C451.77 301 464 329.82 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm41.55-260.07c26.5 6.93 50 19.32 68.65 36.34q3.89 3.56 7.47 7.34c25.41-18.4 45.47-44.92 54.33-71.38-16.24 7.07-35.31 9.85-54.15 9.85-73.42 0-115.93-42.51-115.93-115.93 0-18.84 2.78-37.91 9.85-54.15-40.41 13.53-81 53.19-92.52 98.13a162.61 162.61 0 0179.52 36.12 173 173 0 0142.78 53.68z"}}]})(props);
	};
	module.exports.IoCloudyNight = function IoCloudyNight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-29.44 12.09-54.25 35-71.74 12.1-9.26 27.2-16.17 43.33-20.05a16 16 0 0011.81-12.21c7.15-32.54 22.25-60.49 44.33-81.75A139.82 139.82 0 01232 160c32.33 0 62.15 10.65 86.24 30.79a142.22 142.22 0 0137.65 49.54 16.06 16.06 0 0011.12 9c24 5.22 45.42 15.78 61.62 30.56C451.77 301 464 329.82 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm170.53-270.21a16.34 16.34 0 00-1.35-15.8 16 16 0 00-19.57-5.58c-10.7 4.65-24.48 7.17-39.92 7.28-55.3.4-101.38-45-101.38-100.31 0-15.75 2.48-29.84 7.18-40.76a16.3 16.3 0 00-1.85-16.33 16 16 0 00-19.1-5c-38.63 16.82-66.18 51.51-75.27 92.54a4 4 0 003.19 4.79 162.54 162.54 0 0176.31 35.59 172.58 172.58 0 0139.64 47.84 16.35 16.35 0 009.54 7.64c23.89 7.17 45.1 18.9 62.25 34.54q4.44 4.07 8.48 8.42a4 4 0 005.16.57 129.12 129.12 0 0046.69-55.43z"}}]})(props);
	};
	module.exports.IoCloudyOutline = function IoCloudyOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M100.18 241.19a15.93 15.93 0 0013.37-13.25C126.6 145.59 186.34 96 256 96c64.69 0 107.79 42.36 124.92 87a16.11 16.11 0 0012.53 10.18C449.36 202.06 496 239.21 496 304c0 66-54 112-120 112H116c-55 0-100-27.44-100-88 0-54.43 43.89-80.81 84.18-86.81z"}}]})(props);
	};
	module.exports.IoCloudySharp = function IoCloudySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 432H116c-32.37 0-60.23-8.57-80.59-24.77C12.24 388.78 0 361.39 0 328c0-61.85 48.44-95.34 97.75-102.64 6.52-41.18 24-76.4 51.11-102.46A153.57 153.57 0 01256 80c35.5 0 68.24 11.69 94.68 33.8a156.42 156.42 0 0145.22 63.61c30.26 4.81 57.45 17.18 77.38 35.36C498.61 235.88 512 267.42 512 304c0 36-14.38 68.88-40.49 92.59C446.36 419.43 412.44 432 376 432z"}}]})(props);
	};
	module.exports.IoCloudy = function IoCloudy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 432H116c-32.37 0-60.23-8.57-80.59-24.77C12.24 388.78 0 361.39 0 328c0-57.57 42-90.58 87.56-100.75a16 16 0 0012.12-12.39c7.68-36.68 24.45-68.15 49.18-92A153.57 153.57 0 01256 80c35.5 0 68.24 11.69 94.68 33.8a156.24 156.24 0 0142.05 56 16 16 0 0011.37 9.16c27 5.61 51.07 17.33 69.18 33.85C498.61 235.88 512 267.42 512 304c0 36-14.38 68.88-40.49 92.59C446.36 419.43 412.44 432 376 432z"}}]})(props);
	};
	module.exports.IoCodeDownloadOutline = function IoCodeDownloadOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 368L32 256l128-112m192 224l128-112-128-112M192 288.1l64 63.9 64-63.9M256 160v176.03"}}]})(props);
	};
	module.exports.IoCodeDownloadSharp = function IoCodeDownloadSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"42","d":"M160 368L32 256l128-112m192 224l128-112-128-112M192 288.1l64 63.9 64-63.9M256 160v176.03"}}]})(props);
	};
	module.exports.IoCodeDownload = function IoCodeDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"42","d":"M160 368L32 256l128-112m192 224l128-112-128-112M192 288.1l64 63.9 64-63.9M256 160v176.03"}}]})(props);
	};
	module.exports.IoCodeOutline = function IoCodeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 368L32 256l128-112m192 224l128-112-128-112"}}]})(props);
	};
	module.exports.IoCodeSharp = function IoCodeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M161.98 397.63L0 256l161.98-141.63 27.65 31.61L64 256l125.63 110.02-27.65 31.61zm188.04 0l-27.65-31.61L448 256 322.37 145.98l27.65-31.61L512 256 350.02 397.63z"}}]})(props);
	};
	module.exports.IoCodeSlashOutline = function IoCodeSlashOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 368L32 256l128-112m192 224l128-112-128-112m-48-48l-96 320"}}]})(props);
	};
	module.exports.IoCodeSlashSharp = function IoCodeSlashSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M161.98 397.63L0 256l161.98-141.63 27.65 31.61L64 256l125.63 110.02-27.65 31.61zm188.04 0l-27.65-31.61L448 256 322.37 145.98l27.65-31.61L512 256 350.02 397.63zM222.15 442L182 430.08 289.85 70 330 81.92 222.15 442z"}}]})(props);
	};
	module.exports.IoCodeSlash = function IoCodeSlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 389a20.91 20.91 0 01-13.82-5.2l-128-112a21 21 0 010-31.6l128-112a21 21 0 0127.66 31.61L63.89 256l109.94 96.19A21 21 0 01160 389zm192 0a21 21 0 01-13.84-36.81L448.11 256l-109.94-96.19a21 21 0 0127.66-31.61l128 112a21 21 0 010 31.6l-128 112A20.89 20.89 0 01352 389zm-144 48a21 21 0 01-20.12-27l96-320a21 21 0 1140.23 12l-96 320A21 21 0 01208 437z"}}]})(props);
	};
	module.exports.IoCodeWorkingOutline = function IoCodeWorkingOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"26"}},{"tag":"circle","attr":{"cx":"346","cy":"256","r":"26"}},{"tag":"circle","attr":{"cx":"166","cy":"256","r":"26"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 368L32 256l128-112m192 224l128-112-128-112"}}]})(props);
	};
	module.exports.IoCodeWorkingSharp = function IoCodeWorkingSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"26","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"10"}},{"tag":"circle","attr":{"cx":"346","cy":"256","r":"26","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"10"}},{"tag":"circle","attr":{"cx":"166","cy":"256","r":"26","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"10"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"42","d":"M160 368L32 256l128-112m192 224l128-112-128-112"}}]})(props);
	};
	module.exports.IoCodeWorking = function IoCodeWorking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"26","strokeMiterlimit":"10","strokeWidth":"10"}},{"tag":"circle","attr":{"cx":"346","cy":"256","r":"26","strokeMiterlimit":"10","strokeWidth":"10"}},{"tag":"circle","attr":{"cx":"166","cy":"256","r":"26","strokeMiterlimit":"10","strokeWidth":"10"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"42","d":"M160 368L32 256l128-112m192 224l128-112-128-112"}}]})(props);
	};
	module.exports.IoCode = function IoCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 389a20.91 20.91 0 01-13.82-5.2l-128-112a21 21 0 010-31.6l128-112a21 21 0 0127.66 31.61L63.89 256l109.94 96.19A21 21 0 01160 389zm192 0a21 21 0 01-13.84-36.81L448.11 256l-109.94-96.19a21 21 0 0127.66-31.61l128 112a21 21 0 010 31.6l-128 112A20.89 20.89 0 01352 389z"}}]})(props);
	};
	module.exports.IoCogOutline = function IoCogOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456.7 242.27l-26.08-4.2a8 8 0 01-6.6-6.82c-.5-3.2-1-6.41-1.7-9.51a8.08 8.08 0 013.9-8.62l23.09-12.82a8.05 8.05 0 003.9-9.92l-4-11a7.94 7.94 0 00-9.4-5l-25.89 5a8 8 0 01-8.59-4.11q-2.25-4.2-4.8-8.41a8.16 8.16 0 01.7-9.52l17.29-19.94a8 8 0 00.3-10.62l-7.49-9a7.88 7.88 0 00-10.5-1.51l-22.69 13.63a8 8 0 01-9.39-.9c-2.4-2.11-4.9-4.21-7.4-6.22a8 8 0 01-2.5-9.11l9.4-24.75A8 8 0 00365 78.77l-10.2-5.91a8 8 0 00-10.39 2.21l-16.64 20.84a7.15 7.15 0 01-8.5 2.5s-5.6-2.3-9.8-3.71A8 8 0 01304 87l.4-26.45a8.07 8.07 0 00-6.6-8.42l-11.59-2a8.07 8.07 0 00-9.1 5.61l-8.6 25.05a8 8 0 01-7.79 5.41h-9.8a8.07 8.07 0 01-7.79-5.41l-8.6-25.05a8.07 8.07 0 00-9.1-5.61l-11.59 2a8.07 8.07 0 00-6.6 8.42l.4 26.45a8 8 0 01-5.49 7.71c-2.3.9-7.3 2.81-9.7 3.71-2.8 1-6.1.2-8.8-2.91l-16.51-20.34A8 8 0 00156.75 73l-10.2 5.91a7.94 7.94 0 00-3.3 10.09l9.4 24.75a8.06 8.06 0 01-2.5 9.11c-2.5 2-5 4.11-7.4 6.22a8 8 0 01-9.39.9L111 116.14a8 8 0 00-10.5 1.51l-7.49 9a8 8 0 00.3 10.62l17.29 19.94a8 8 0 01.7 9.52q-2.55 4-4.8 8.41a8.11 8.11 0 01-8.59 4.11l-25.89-5a8 8 0 00-9.4 5l-4 11a8.05 8.05 0 003.9 9.92L85.58 213a7.94 7.94 0 013.9 8.62c-.6 3.2-1.2 6.31-1.7 9.51a8.08 8.08 0 01-6.6 6.82l-26.08 4.2a8.09 8.09 0 00-7.1 7.92v11.72a7.86 7.86 0 007.1 7.92l26.08 4.2a8 8 0 016.6 6.82c.5 3.2 1 6.41 1.7 9.51a8.08 8.08 0 01-3.9 8.62L62.49 311.7a8.05 8.05 0 00-3.9 9.92l4 11a7.94 7.94 0 009.4 5l25.89-5a8 8 0 018.59 4.11q2.25 4.2 4.8 8.41a8.16 8.16 0 01-.7 9.52l-17.29 19.96a8 8 0 00-.3 10.62l7.49 9a7.88 7.88 0 0010.5 1.51l22.69-13.63a8 8 0 019.39.9c2.4 2.11 4.9 4.21 7.4 6.22a8 8 0 012.5 9.11l-9.4 24.75a8 8 0 003.3 10.12l10.2 5.91a8 8 0 0010.39-2.21l16.79-20.64c2.1-2.6 5.5-3.7 8.2-2.6 3.4 1.4 5.7 2.2 9.9 3.61a8 8 0 015.49 7.71l-.4 26.45a8.07 8.07 0 006.6 8.42l11.59 2a8.07 8.07 0 009.1-5.61l8.6-25a8 8 0 017.79-5.41h9.8a8.07 8.07 0 017.79 5.41l8.6 25a8.07 8.07 0 009.1 5.61l11.59-2a8.07 8.07 0 006.6-8.42l-.4-26.45a8 8 0 015.49-7.71c4.2-1.41 7-2.51 9.6-3.51s5.8-1 8.3 2.1l17 20.94A8 8 0 00355 439l10.2-5.91a7.93 7.93 0 003.3-10.12l-9.4-24.75a8.08 8.08 0 012.5-9.12c2.5-2 5-4.1 7.4-6.21a8 8 0 019.39-.9L401 395.66a8 8 0 0010.5-1.51l7.49-9a8 8 0 00-.3-10.62l-17.29-19.94a8 8 0 01-.7-9.52q2.55-4.05 4.8-8.41a8.11 8.11 0 018.59-4.11l25.89 5a8 8 0 009.4-5l4-11a8.05 8.05 0 00-3.9-9.92l-23.09-12.82a7.94 7.94 0 01-3.9-8.62c.6-3.2 1.2-6.31 1.7-9.51a8.08 8.08 0 016.6-6.82l26.08-4.2a8.09 8.09 0 007.1-7.92V250a8.25 8.25 0 00-7.27-7.73zM256 112a143.82 143.82 0 01139.38 108.12A16 16 0 01379.85 240H274.61a16 16 0 01-13.91-8.09l-52.1-91.71a16 16 0 019.85-23.39A146.94 146.94 0 01256 112zM112 256a144 144 0 0143.65-103.41 16 16 0 0125.17 3.47L233.06 248a16 16 0 010 15.87l-52.67 91.7a16 16 0 01-25.18 3.36A143.94 143.94 0 01112 256zm144 144a146.9 146.9 0 01-38.19-4.95 16 16 0 01-9.76-23.44l52.58-91.55a16 16 0 0113.88-8H379.9a16 16 0 0115.52 19.88A143.84 143.84 0 01256 400z"}}]})(props);
	};
	module.exports.IoCogSharp = function IoCogSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 249.93a10.58 10.58 0 00-9.36-9.94L429 235.84a5.42 5.42 0 01-4.5-4.67c-.49-3.15-1-6.42-1.7-9.52a5.52 5.52 0 012.63-5.85l22.78-12.65a10.35 10.35 0 005-12.83l-3.95-10.9a10.32 10.32 0 00-12.13-6.51l-25.55 5a5.5 5.5 0 01-5.82-2.81c-1.49-2.79-3.11-5.63-4.8-8.42a5.6 5.6 0 01.44-6.5l17-19.63a10.44 10.44 0 00.39-13.77l-7.42-8.91a10.24 10.24 0 00-13.58-2l-22.37 13.43a5.39 5.39 0 01-6.39-.63c-2.47-2.17-4.95-4.26-7.37-6.19a5.45 5.45 0 01-1.72-6.21l9.26-24.4a10.35 10.35 0 00-4.31-13.07l-10.08-5.85a10.31 10.31 0 00-13.46 2.83L325 96.28a4.58 4.58 0 01-5.6 1.72c-.62-.25-5.77-2.36-9.78-3.7a5.42 5.42 0 01-3.74-5.23l.39-26.07a10.48 10.48 0 00-8.57-10.88l-11.45-2a10.45 10.45 0 00-11.75 7.17L266 82.1a5.42 5.42 0 01-5.36 3.65h-9.75a5.53 5.53 0 01-5.3-3.67l-8.46-24.67a10.46 10.46 0 00-11.77-7.25l-11.46 2a10.46 10.46 0 00-8.57 10.79l.4 26.16a5.45 5.45 0 01-3.86 5.25c-2.28.89-7.26 2.78-9.51 3.63-2 .72-4.19-.07-6-2.1l-16.26-20A10.3 10.3 0 00156.69 73l-10.06 5.83A10.36 10.36 0 00142.31 92l9.25 24.34a5.54 5.54 0 01-1.7 6.23c-2.43 2-4.92 4-7.4 6.22a5.38 5.38 0 01-6.35.64L114 115.74a10.39 10.39 0 00-13.61 2l-7.4 8.9a10.32 10.32 0 00.37 13.76l17.09 19.6a5.42 5.42 0 01.45 6.45c-1.71 2.72-3.34 5.58-4.82 8.44a5.53 5.53 0 01-5.86 2.82l-25.51-4.93a10.34 10.34 0 00-12.14 6.51l-4 10.88a10.37 10.37 0 005 12.85l22.78 12.65a5.39 5.39 0 012.65 5.92l-.23 1.24c-.53 2.8-1 5.45-1.47 8.27a5.48 5.48 0 01-4.46 4.64l-25.7 4.15A10.42 10.42 0 0048 250.16v11.58A10.26 10.26 0 0057.16 272l25.68 4.14a5.41 5.41 0 014.5 4.67c.49 3.16 1 6.42 1.7 9.52a5.52 5.52 0 01-2.63 5.85l-22.77 12.67a10.35 10.35 0 00-5 12.83l4 10.9a10.33 10.33 0 0012.13 6.51l25.55-4.95a5.5 5.5 0 015.82 2.81c1.5 2.8 3.12 5.64 4.8 8.42a5.58 5.58 0 01-.44 6.5l-17 19.64a10.41 10.41 0 00-.5 13.76l7.41 8.91a10.24 10.24 0 0013.58 2l22.37-13.43a5.39 5.39 0 016.39.63c2.48 2.17 5 4.26 7.37 6.19a5.45 5.45 0 011.72 6.21l-9.26 24.4a10.35 10.35 0 004.31 13.07l10.11 5.84a10.3 10.3 0 0013.45-2.82L187 415.92c1.39-1.73 3.6-2.5 5.24-1.84 3.47 1.44 5.8 2.25 9.93 3.63a5.44 5.44 0 013.75 5.23l-.4 26.05a10.5 10.5 0 008.57 10.88l11.45 2a10.44 10.44 0 0011.75-7.17l8.5-24.77a5.48 5.48 0 015.36-3.65h9.75a5.52 5.52 0 015.3 3.67l8.47 24.67a10.48 10.48 0 0010 7.41 9.74 9.74 0 001.78-.16l11.47-2a10.46 10.46 0 008.56-10.79l-.4-26.16a5.43 5.43 0 013.75-5.2c3.84-1.29 6.53-2.33 8.91-3.24l.6-.24c3.06-1.06 4.53.14 5.47 1.31l16.75 20.63A10.3 10.3 0 00355 439l10.07-5.83a10.35 10.35 0 004.31-13.1l-9.24-24.34a5.52 5.52 0 011.69-6.23c2.43-2 4.92-4 7.4-6.22a5.39 5.39 0 016.38-.62l22.39 13.4a10.39 10.39 0 0013.61-2l7.4-8.9a10.31 10.31 0 00-.37-13.75l-17.06-19.67a5.42 5.42 0 01-.45-6.45c1.71-2.71 3.34-5.57 4.82-8.44a5.56 5.56 0 015.86-2.82l25.48 4.97a10.34 10.34 0 0012.14-6.51l3.95-10.88a10.36 10.36 0 00-5-12.84l-22.8-12.67a5.4 5.4 0 01-2.61-5.89l.23-1.25c.53-2.8 1-5.44 1.47-8.26a5.48 5.48 0 014.46-4.64l25.7-4.14a10.43 10.43 0 009.17-10.28v-11.71zM171.59 361.27a135.12 135.12 0 01.5-210.94l60 105.61zM256 391.11a133.75 133.75 0 01-48.49-9.05L268 276.79h121.22C379.21 341.45 323.29 391.11 256 391.11zm12.06-155.9l-59.95-105.5a133.87 133.87 0 0147.89-8.82c67.29 0 123.21 49.66 133.22 114.32z"}}]})(props);
	};
	module.exports.IoCog = function IoCog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 249.93a10.58 10.58 0 00-9.36-9.94L429 235.84a5.42 5.42 0 01-4.5-4.67c-.49-3.15-1-6.42-1.7-9.52a5.52 5.52 0 012.63-5.85l22.78-12.65a10.35 10.35 0 005-12.83l-3.95-10.9a10.32 10.32 0 00-12.13-6.51l-25.55 5a5.51 5.51 0 01-5.82-2.81c-1.49-2.79-3.11-5.63-4.8-8.42a5.6 5.6 0 01.44-6.5l17-19.64a10.42 10.42 0 00.39-13.76l-7.42-8.91a10.24 10.24 0 00-13.58-2l-22.37 13.43a5.39 5.39 0 01-6.39-.63c-2.47-2.17-5-4.26-7.37-6.19a5.45 5.45 0 01-1.72-6.21l9.26-24.4a10.35 10.35 0 00-4.31-13.07l-10.09-5.89a10.3 10.3 0 00-13.45 2.83L325 96.28a4.6 4.6 0 01-5.6 1.72c-.61-.25-5.77-2.36-9.78-3.7a5.42 5.42 0 01-3.74-5.23l.39-26.07a10.48 10.48 0 00-8.57-10.88l-11.45-2a10.45 10.45 0 00-11.75 7.17L266 82.1a5.46 5.46 0 01-5.36 3.65h-9.75a5.5 5.5 0 01-5.3-3.67l-8.46-24.67a10.46 10.46 0 00-11.77-7.25l-11.47 2a10.46 10.46 0 00-8.56 10.79l.4 26.16a5.45 5.45 0 01-3.86 5.25c-2.29.89-7.26 2.79-9.52 3.63-2 .72-4.18-.07-5.94-2.1l-16.26-20A10.3 10.3 0 00156.69 73l-10.06 5.83A10.36 10.36 0 00142.31 92l9.25 24.34a5.54 5.54 0 01-1.7 6.23c-2.43 2-4.92 4-7.4 6.22a5.38 5.38 0 01-6.35.64L114 115.74a10.4 10.4 0 00-13.61 2L93 126.63a10.31 10.31 0 00.37 13.75L110.45 160a5.42 5.42 0 01.45 6.45c-1.71 2.72-3.34 5.58-4.82 8.44a5.53 5.53 0 01-5.86 2.82l-25.51-4.93a10.34 10.34 0 00-12.14 6.51l-4 10.88a10.38 10.38 0 005 12.85l22.78 12.65a5.39 5.39 0 012.65 5.92l-.24 1.27c-.52 2.79-1 5.43-1.46 8.24a5.48 5.48 0 01-4.46 4.64l-25.69 4.15A10.42 10.42 0 0048 250.16v11.58A10.26 10.26 0 0057.16 272l25.68 4.14a5.41 5.41 0 014.5 4.67c.49 3.16 1 6.42 1.7 9.52a5.52 5.52 0 01-2.63 5.85l-22.77 12.67a10.35 10.35 0 00-5 12.83l4 10.9a10.33 10.33 0 0012.13 6.51l25.55-4.95a5.49 5.49 0 015.82 2.81c1.5 2.8 3.11 5.63 4.8 8.42a5.58 5.58 0 01-.44 6.5l-17 19.63a10.41 10.41 0 00-.5 13.77l7.41 8.91a10.23 10.23 0 0013.58 2l22.37-13.43a5.39 5.39 0 016.39.63c2.48 2.17 5 4.26 7.37 6.19a5.47 5.47 0 011.73 6.21l-9.27 24.4a10.35 10.35 0 004.31 13.07l10.11 5.84a10.3 10.3 0 0013.45-2.82L187 415.92c1.4-1.73 3.6-2.5 5.23-1.84 3.48 1.44 5.81 2.25 9.94 3.63a5.44 5.44 0 013.75 5.23l-.4 26.05a10.5 10.5 0 008.57 10.88l11.45 2a10.43 10.43 0 0011.75-7.17l8.5-24.77a5.45 5.45 0 015.36-3.65h9.75a5.49 5.49 0 015.3 3.67l8.47 24.67a10.48 10.48 0 0010 7.41 9.74 9.74 0 001.78-.16l11.47-2a10.46 10.46 0 008.56-10.79l-.4-26.16a5.43 5.43 0 013.75-5.2c3.84-1.29 6.54-2.33 8.91-3.25l.6-.23c3.1-1.07 4.6.23 5.47 1.31l16.75 20.63A10.3 10.3 0 00355 439l10.07-5.83a10.35 10.35 0 004.31-13.1l-9.24-24.34a5.52 5.52 0 011.69-6.23c2.43-2 4.92-4 7.4-6.22a5.39 5.39 0 016.38-.62l22.39 13.4a10.39 10.39 0 0013.61-2l7.4-8.9a10.31 10.31 0 00-.37-13.75l-17.06-19.67a5.42 5.42 0 01-.45-6.45c1.71-2.71 3.34-5.57 4.82-8.44a5.55 5.55 0 015.86-2.82l25.48 4.97a10.34 10.34 0 0012.14-6.51l3.95-10.88a10.37 10.37 0 00-5-12.84l-22.8-12.67a5.4 5.4 0 01-2.61-5.89l.24-1.27c.52-2.79 1-5.43 1.46-8.24a5.48 5.48 0 014.46-4.64l25.69-4.14a10.43 10.43 0 009.18-10.28v-11.71zm-282.45 94a15.8 15.8 0 01-25.47 2.66 135.06 135.06 0 01.42-181.65 15.81 15.81 0 0125.5 2.77l45.65 80.35a15.85 15.85 0 010 15.74zM256 391.11a134.75 134.75 0 01-28.31-3 15.81 15.81 0 01-10.23-23.36l46-80a15.79 15.79 0 0113.7-7.93h92.14a15.8 15.8 0 0115.1 20.53c-17.49 54.32-68.4 93.76-128.4 93.76zm7.51-163.9L218 147.07a15.81 15.81 0 0110.31-23.3 134 134 0 0127.69-2.88c60 0 110.91 39.44 128.37 93.79a15.8 15.8 0 01-15.1 20.53h-92a15.78 15.78 0 01-13.76-8z"}}]})(props);
	};
	module.exports.IoColorFillOutline = function IoColorFillOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M419.1 337.45a3.94 3.94 0 00-6.1 0c-10.5 12.4-45 46.55-45 77.66 0 27 21.5 48.89 48 48.89h0c26.5 0 48-22 48-48.89 0-31.11-34.3-65.26-44.9-77.66zM387 287.9L155.61 58.36a36 36 0 00-51 0l-5.15 5.15a36 36 0 000 51l52.89 52.89 57-57L56.33 263.2a28 28 0 00.3 40l131.2 126a28.05 28.05 0 0038.9-.1c37.8-36.6 118.3-114.5 126.7-122.9 5.8-5.8 18.2-7.1 28.7-7.1h.3a6.53 6.53 0 004.57-11.2z"}}]})(props);
	};
	module.exports.IoColorFillSharp = function IoColorFillSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 320s-64 48-64 99.84c0 33.28 28.67 60.16 64 60.16s64-27 64-60.16C480 368 416 320 416 320zM144 32l-76 76 70 70L32 280l176 184 152.8-148.3L416 304zm24 116l-39.6-41 15.88-15.89L184 132z"}}]})(props);
	};
	module.exports.IoColorFill = function IoColorFill (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 480c-35.29 0-64-29.11-64-64.88 0-33.29 28.67-65.4 44.08-82.64 1.87-2.1 3.49-3.91 4.68-5.31a19.94 19.94 0 0130.55 0c1.13 1.31 2.63 3 4.36 4.93 15.5 17.3 44.33 49.51 44.33 83.05 0 35.74-28.71 64.85-64 64.85zm-17.77-203.36L166.89 47.22a52.1 52.1 0 00-73.6 0l-4.51 4.51a53.2 53.2 0 00-15.89 37.33A51.66 51.66 0 0088.14 126l41.51 41.5L45 252a44.52 44.52 0 00-13 32 42.81 42.81 0 0013.5 30.84l131.24 126a44 44 0 0061.08-.18l124.11-120.28a15.6 15.6 0 018.23-4.29 69.21 69.21 0 0111.93-.86h.3a22.53 22.53 0 0015.84-38.59zM152.29 144.85l-41.53-41.52a20 20 0 010-28.34l5.16-5.15a20.07 20.07 0 0128.39 0L186 111.21z"}}]})(props);
	};
	module.exports.IoColorFilterOutline = function IoColorFilterOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"184","r":"120","fill":"none","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"344","cy":"328","r":"120","fill":"none","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"168","cy":"328","r":"120","fill":"none","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoColorFilterSharp = function IoColorFilterSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 185a167.85 167.85 0 01134.9-18.28C382.36 99.83 325.12 48 256 48S129.64 99.83 121.1 166.67A167.85 167.85 0 01256 185zm80 146.73a167.51 167.51 0 01-52.37 118.08A135 135 0 00344 464c75 0 136-61 136-136a136 136 0 00-59.06-112.08A168.53 168.53 0 01336 331.73zm-52.42-125.54a167.87 167.87 0 0149.36 89.89 136.14 136.14 0 0058.06-95.7 135.87 135.87 0 00-107.43 5.81zM176.05 331.73a168.53 168.53 0 01-85-115.81A136 136 0 0032 328c0 75 61 136 136 136a135 135 0 0060.42-14.19 167.51 167.51 0 01-52.37-118.08zm3.01-35.65a167.87 167.87 0 0149.36-89.89A135.87 135.87 0 00121 200.38a136.14 136.14 0 0058.06 95.7zm123.84 49.25a168.22 168.22 0 01-93.8 0A135.9 135.9 0 00256 431.6a135.9 135.9 0 0046.9-86.27zM209 311.62a136 136 0 0094 0 135.93 135.93 0 00-47-87.22 135.93 135.93 0 00-47 87.22z"}}]})(props);
	};
	module.exports.IoColorFilter = function IoColorFilter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M253.72 202.53a4 4 0 004.56 0 151.88 151.88 0 01128.44-20.41 4 4 0 005.15-4C388.8 105.86 329 48 256 48s-132.8 57.86-135.87 130.15a4 4 0 005.15 4 151.88 151.88 0 01128.44 20.41zm151.59 10.03a152.53 152.53 0 01-83.08 108.23 4 4 0 00-2.28 3.69c0 1.17.05 2.34.05 3.52a151.58 151.58 0 01-47.15 109.94 4 4 0 00.64 6.31A135.24 135.24 0 00344 464c72.07 0 134.1-60.28 136-132.34a136.07 136.07 0 00-68.76-121.87 4 4 0 00-5.93 2.77z"}},{"tag":"path","attr":{"d":"M390.57 203.67a4 4 0 00-2.69-4.4 135.84 135.84 0 00-114.4 12.49 4 4 0 00-.64 6.29 151.92 151.92 0 0144.47 81.4 4 4 0 005.94 2.72 136.29 136.29 0 0067.32-98.5zM192 328c0-1.18 0-2.35.05-3.52a4 4 0 00-2.28-3.69 152.53 152.53 0 01-83.08-108.23 4 4 0 00-5.88-2.77 136.07 136.07 0 00-68.76 121.87C34 403.72 96 464 168.05 464a135.24 135.24 0 0070.46-19.75 4 4 0 00.64-6.31A151.58 151.58 0 01192 328z"}},{"tag":"path","attr":{"d":"M168 192a135.34 135.34 0 00-43.88 7.27 4 4 0 00-2.69 4.4 136.29 136.29 0 0067.32 98.5 4 4 0 005.94-2.72 151.92 151.92 0 0144.47-81.4 4 4 0 00-.64-6.29A135.18 135.18 0 00168 192zm88 144a151.44 151.44 0 01-42.72-6.12 4 4 0 00-5.15 4 135.69 135.69 0 0045.18 95.4 4 4 0 005.38 0 135.69 135.69 0 0045.18-95.4 4 4 0 00-5.15-4A151.44 151.44 0 01256 336zm46.57-27.67a135.94 135.94 0 00-43.87-81.58 4.06 4.06 0 00-5.4 0 135.94 135.94 0 00-43.87 81.58 4 4 0 002.69 4.4 136.06 136.06 0 0087.76 0 4 4 0 002.69-4.4z"}}]})(props);
	};
	module.exports.IoColorPaletteOutline = function IoColorPaletteOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M430.11 347.9c-6.6-6.1-16.3-7.6-24.6-9-11.5-1.9-15.9-4-22.6-10-14.3-12.7-14.3-31.1 0-43.8l30.3-26.9c46.4-41 46.4-108.2 0-149.2-34.2-30.1-80.1-45-127.8-45-55.7 0-113.9 20.3-158.8 60.1-83.5 73.8-83.5 194.7 0 268.5 41.5 36.7 97.5 55 152.9 55.4h1.7c55.4 0 110-17.9 148.8-52.4 14.4-12.7 11.99-36.6.1-47.7z"}},{"tag":"circle","attr":{"cx":"144","cy":"208","r":"32"}},{"tag":"circle","attr":{"cx":"152","cy":"311","r":"32"}},{"tag":"circle","attr":{"cx":"224","cy":"144","r":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"367","r":"48"}},{"tag":"circle","attr":{"cx":"328","cy":"144","r":"32"}}]})(props);
	};
	module.exports.IoColorPaletteSharp = function IoColorPaletteSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 352c-12.6-.84-21-4-28-12-14-16-14-36 5.49-52.48l32.82-29.14c50.27-44.41 50.27-117.21 0-161.63C389.26 64.14 339.54 48 287.86 48c-60.34 0-123.39 22-172 65.11-90.46 80-90.46 210.92 0 290.87 45 39.76 105.63 59.59 165.64 60h1.84c60 0 119.07-19.5 161.2-56.77C464 390 464 385 444.62 355.56 440 348 431 353 416 352zM112 208a32 32 0 1132 32 32 32 0 01-32-32zm40 135a32 32 0 1132-32 32 32 0 01-32 32zm40-199a32 32 0 1132 32 32 32 0 01-32-32zm64 271a48 48 0 1148-48 48 48 0 01-48 48zm72-239a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoColorPalette = function IoColorPalette (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M441 336.2l-.06-.05c-9.93-9.18-22.78-11.34-32.16-12.92l-.69-.12c-9.05-1.49-10.48-2.5-14.58-6.17-2.44-2.17-5.35-5.65-5.35-9.94s2.91-7.77 5.34-9.94l30.28-26.87c25.92-22.91 40.2-53.66 40.2-86.59s-14.25-63.68-40.2-86.6c-35.89-31.59-85-49-138.37-49C223.72 48 162 71.37 116 112.11c-43.87 38.77-68 90.71-68 146.24s24.16 107.47 68 146.23c21.75 19.24 47.49 34.18 76.52 44.42a266.17 266.17 0 0086.87 15h1.81c61 0 119.09-20.57 159.39-56.4 9.7-8.56 15.15-20.83 15.34-34.56.21-14.17-5.37-27.95-14.93-36.84zM112 208a32 32 0 1132 32 32 32 0 01-32-32zm40 135a32 32 0 1132-32 32 32 0 01-32 32zm40-199a32 32 0 1132 32 32 32 0 01-32-32zm64 271a48 48 0 1148-48 48 48 0 01-48 48zm72-239a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoColorWandOutline = function IoColorWandOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"63.03","height":"378.2","x":"280.48","y":"122.9","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"31.52","transform":"rotate(-45 312.002 311.994)"}},{"tag":"path","attr":{"d":"M178.38 178.38a31.64 31.64 0 000 44.75L223.25 268 268 223.25l-44.87-44.87a31.64 31.64 0 00-44.75 0z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M48 192h48M90.18 90.18l33.94 33.94M192 48v48m101.82-5.82l-33.94 33.94M124.12 259.88l-33.94 33.94"}}]})(props);
	};
	module.exports.IoColorWandSharp = function IoColorWandSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M133.441 200.647l67.197-67.196 78.142 78.142-67.196 67.196zM301.41 234.21l-67.19 67.2L412 480l68-68-178.59-177.79zM32 176h80v32H32zm35.624-85.75l22.627-22.628 56.569 56.569-22.627 22.627zM176 32h32v80h-32zm61.32 92.195l56.569-56.569 22.627 22.627-56.569 56.569zM67.62 293.887l56.569-56.569 22.627 22.627-56.569 56.569z"}}]})(props);
	};
	module.exports.IoColorWand = function IoColorWand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 208H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16zm28.1-67.9c-4.2 0-8.3-1.7-11.3-4.7l-33.9-33.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l33.9 33.9c6.3 6.2 6.3 16.4 0 22.6-3 3-7 4.7-11.3 4.7zM192 112c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 8.8-7.2 16-16 16zm67.9 28.1c-8.8 0-16-7.2-16-16 0-4.2 1.7-8.3 4.7-11.3l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6l-33.9 33.9c-3 3-7.1 4.7-11.3 4.7zM90.2 309.8c-8.8 0-16-7.2-16-16 0-4.2 1.7-8.3 4.7-11.3l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-33.9 33.9c-3 3-7.1 4.7-11.3 4.7zm144-142.8c-18.4-18.7-48.5-19-67.2-.7s-19 48.5-.7 67.2l.7.7 39.5 39.5c3.1 3.1 8.2 3.1 11.3 0l55.9-55.9c3.1-3.1 3.1-8.2 0-11.3L234.2 167zM457 389.8L307.6 240.4c-3.1-3.1-8.2-3.1-11.3 0l-55.9 55.9c-3.1 3.1-3.1 8.2 0 11.3L389.8 457c18.4 18.7 48.5 19 67.2.7 18.7-18.4 19-48.5.7-67.2-.2-.2-.4-.5-.7-.7z"}}]})(props);
	};
	module.exports.IoCompassOutline = function IoCompassOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"d":"M350.67 150.93l-117.2 46.88a64 64 0 00-35.66 35.66l-46.88 117.2a8 8 0 0010.4 10.4l117.2-46.88a64 64 0 0035.66-35.66l46.88-117.2a8 8 0 00-10.4-10.4zM256 280a24 24 0 1124-24 24 24 0 01-24 24z"}}]})(props);
	};
	module.exports.IoCompassSharp = function IoCompassSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"24"}},{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm48 256l-160 64 64-160 160-64z"}}]})(props);
	};
	module.exports.IoCompass = function IoCompass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"24"}},{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm105.07 113.33l-46.88 117.2a64 64 0 01-35.66 35.66l-117.2 46.88a8 8 0 01-10.4-10.4l46.88-117.2a64 64 0 0135.66-35.66l117.2-46.88a8 8 0 0110.4 10.4z"}}]})(props);
	};
	module.exports.IoConstructOutline = function IoConstructOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M436.67 184.11a27.17 27.17 0 01-38.3 0l-22.48-22.49a27.15 27.15 0 010-38.29l50.89-50.89a.85.85 0 00-.26-1.38C393.68 57 351.09 64.15 324.05 91c-25.88 25.69-27.35 64.27-17.87 98a27 27 0 01-7.67 27.14l-173 160.76a40.76 40.76 0 1057.57 57.54l162.15-173.3a27 27 0 0126.77-7.7c33.46 8.94 71.49 7.26 97.07-17.94 27.49-27.08 33.42-74.94 20.1-102.33a.85.85 0 00-1.36-.22z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M224 284c-17.48-17-25.49-24.91-31-30.29a18.24 18.24 0 01-3.33-21.35 20.76 20.76 0 013.5-4.62l15.68-15.29a18.66 18.66 0 015.63-3.87 18.11 18.11 0 0120 3.62c5.45 5.29 15.43 15 33.41 32.52m49.18 46.58c40.95 38.1 90.62 83.27 110 99.41a13.46 13.46 0 01.94 19.92L394.63 444a14 14 0 01-20.29-.76c-16.53-19.18-61.09-67.11-99.27-107"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M17.34 193.5l29.41-28.74a4.71 4.71 0 013.41-1.35 4.85 4.85 0 013.41 1.35h0a9.86 9.86 0 008.19 2.77c3.83-.42 7.92-1.6 10.57-4.12 6-5.8-.94-17.23 4.34-24.54a207 207 0 0119.78-22.6c6-5.88 29.84-28.32 69.9-44.45A107.31 107.31 0 01206.67 64c22.59 0 40 10 46.26 15.67a89.54 89.54 0 0110.28 11.64 78.92 78.92 0 00-9.21-2.77 68.82 68.82 0 00-20-1.26c-13.33 1.09-29.41 7.26-38 14-13.9 11-19.87 25.72-20.81 44.71-.68 14.12 2.72 22.1 36.1 55.49a6.6 6.6 0 01-.34 9.16l-18.22 18a6.88 6.88 0 01-9.54.09c-21.94-21.94-36.65-33.09-45-38.16s-15.07-6.5-18.3-6.85a30.85 30.85 0 00-18.27 3.87 11.39 11.39 0 00-2.64 2 14.14 14.14 0 00.42 20.08l1.71 1.6a4.63 4.63 0 010 6.64L71.73 246.6a4.71 4.71 0 01-3.41 1.4 4.86 4.86 0 01-3.41-1.35l-47.57-46.43a4.88 4.88 0 010-6.72z"}}]})(props);
	};
	module.exports.IoConstructSharp = function IoConstructSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497.14 111.38l-81.09 80.84-48.58-48.41L448.56 63c-45.22-22-108.65-22.09-146.2 15.35-35.32 35.2-39.73 90.61-22.54 134.2L99.57 391.37a12 12 0 000 17l52.27 52.11a12 12 0 0017 0l180-180.5c43.16 16.21 98 11.64 132.74-23 37.5-37.45 37.42-100.34 15.56-145.6z"}},{"tag":"path","attr":{"d":"M365.45 308.62l-71.83 72 75.53 79.92a10.88 10.88 0 0015.65.21l60-60.46a11 11 0 00-.24-15.69zM119 212c0-4.87-4-9.33-7.45-12.78l-.25-.24-1.54-1.47a1.06 1.06 0 01-.26-.8 16.16 16.16 0 019.52-2c1.27.13 5.91.9 12.4 4.91 3.38 2.09 32.63 30.23 43.93 40.7a11 11 0 00.14 15.35l7.43 7.86 65.66-65.17-8.25-7.84a10.87 10.87 0 00-15.31-.06c-23-24.68-29-35.45-31-42.45-4.42-15.47 4.14-28 14-36 5.84-4.62 17.88-8.08 29-9a52.72 52.72 0 0111.61.6c3.47.5 6.3 1.14 7.39 1.4a68.51 68.51 0 0111 4l12-19a88.38 88.38 0 00-13.4-17.7 115.05 115.05 0 00-5.19-5.1c-7.78-7.15-28-19.2-54.59-19.2a117.38 117.38 0 00-44.77 8.82c-37.44 15.34-61.88 36.25-73.11 47.35l-.07.07A219.55 219.55 0 0067 128.56c-5.35 7.53-4.77 15.84-4.38 21.34 0 .32 0 .67.07 1a18.41 18.41 0 00-10.78-3.5A18 18 0 0039 152.73L2 189.62a6.79 6.79 0 000 9.6L65 262a6.72 6.72 0 009.5 0l37.06-37c3.44-3.44 7.44-8.14 7.44-13z"}}]})(props);
	};
	module.exports.IoConstruct = function IoConstruct (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M503.58 126.2a16.85 16.85 0 00-27.07-4.55l-51.15 51.15a11.15 11.15 0 01-15.66 0l-22.48-22.48a11.17 11.17 0 010-15.67l50.88-50.89a16.85 16.85 0 00-5.27-27.4c-39.71-17-89.08-7.45-120 23.29-26.81 26.61-34.83 68-22 113.7a11 11 0 01-3.16 11.1L114.77 365.1a56.76 56.76 0 1080.14 80.18L357 272.08a11 11 0 0110.9-3.17c45 12 86 4 112.43-22 15.2-15 25.81-36.17 29.89-59.71 3.83-22.2 1.41-44.44-6.64-61z"}},{"tag":"path","attr":{"d":"M437.33 378.41c-13.94-11.59-43.72-38.4-74.07-66.22l-66.07 70.61c28.24 30 53.8 57.85 65 70.88l.07.08A30 30 0 00383.72 464h1.1a30.11 30.11 0 0021-8.62l.07-.07 33.43-33.37a29.46 29.46 0 00-2-43.53zM118.54 214.55a20.48 20.48 0 00-3-10.76 2.76 2.76 0 012.62-4.22h.06c.84.09 5.33.74 11.7 4.61 4.73 2.87 18.23 12.08 41.73 35.54a34.23 34.23 0 007.22 22.12l66.23-61.55a33.73 33.73 0 00-21.6-9.2 2.65 2.65 0 01-.21-.26l-.65-.69-24.54-33.84a28.45 28.45 0 01-4-26.11 35.23 35.23 0 0111.78-16.35c5.69-4.41 18.53-9.72 29.44-10.62a52.92 52.92 0 0115.19.94 65.57 65.57 0 017.06 2.13 15.46 15.46 0 002.15.63 16 16 0 0016.38-25.06c-.26-.35-1.32-1.79-2.89-3.73a91.85 91.85 0 00-9.6-10.36c-8.15-7.36-29.27-19.77-57-19.77a123.13 123.13 0 00-46.3 9c-38.37 15.45-63.47 36.58-75.01 47.79l-.09.09A222.14 222.14 0 0063.7 129.5a27 27 0 00-4.7 11.77 7.33 7.33 0 01-7.71 6.17H50.2a20.65 20.65 0 00-14.59 5.9L6.16 182.05l-.32.32a20.89 20.89 0 00-.24 28.72c.19.2.37.39.57.58L53.67 258a21 21 0 0014.65 6 20.65 20.65 0 0014.59-5.9l29.46-28.79a20.51 20.51 0 006.17-14.76z"}}]})(props);
	};
	module.exports.IoContractOutline = function IoContractOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M304 416V304h112m-101.8 10.23L432 432M208 96v112H96m101.8-10.23L80 80m336 128H304V96m10.23 101.8L432 80M96 304h112v112m-10.23-101.8L80 432"}}]})(props);
	};
	module.exports.IoContractSharp = function IoContractSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M304 416V304h112m-101.8 10.23L432 432M208 96v112H96m101.8-10.23L80 80m336 128H304V96m10.23 101.8L432 80M96 304h112v112m-10.23-101.8L80 432"}}]})(props);
	};
	module.exports.IoContract = function IoContract (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M304 416V304h112m-101.8 10.23L432 432M208 96v112H96m101.8-10.23L80 80m336 128H304V96m10.23 101.8L432 80M96 304h112v112m-10.23-101.8L80 432"}}]})(props);
	};
	module.exports.IoContrastOutline = function IoContrastOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"208","fill":"none","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"d":"M256 464c-114.88 0-208-93.12-208-208S141.12 48 256 48z"}}]})(props);
	};
	module.exports.IoContrastSharp = function IoContrastSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32zM128.72 383.28A180 180 0 01256 76v360a178.82 178.82 0 01-127.28-52.72z"}}]})(props);
	};
	module.exports.IoContrast = function IoContrast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32A224 224 0 0097.61 414.39 224 224 0 10414.39 97.61 222.53 222.53 0 00256 32zM64 256c0-105.87 86.13-192 192-192v384c-105.87 0-192-86.13-192-192z"}}]})(props);
	};
	module.exports.IoCopyOutline = function IoCopyOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"336","height":"336","x":"128","y":"128","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"57","ry":"57"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24"}}]})(props);
	};
	module.exports.IoCopySharp = function IoCopySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456 480H136a24 24 0 01-24-24V128a16 16 0 0116-16h328a24 24 0 0124 24v320a24 24 0 01-24 24z"}},{"tag":"path","attr":{"d":"M112 80h288V56a24 24 0 00-24-24H60a28 28 0 00-28 28v316a24 24 0 0024 24h24V112a32 32 0 0132-32z"}}]})(props);
	};
	module.exports.IoCopy = function IoCopy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408 480H184a72 72 0 01-72-72V184a72 72 0 0172-72h224a72 72 0 0172 72v224a72 72 0 01-72 72z"}},{"tag":"path","attr":{"d":"M160 80h235.88A72.12 72.12 0 00328 32H104a72 72 0 00-72 72v224a72.12 72.12 0 0048 67.88V160a80 80 0 0180-80z"}}]})(props);
	};
	module.exports.IoCreateOutline = function IoCreateOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48"}},{"tag":"path","attr":{"d":"M459.94 53.25a16.06 16.06 0 00-23.22-.56L424.35 65a8 8 0 000 11.31l11.34 11.32a8 8 0 0011.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38zM399.34 90L218.82 270.2a9 9 0 00-2.31 3.93L208.16 299a3.91 3.91 0 004.86 4.86l24.85-8.35a9 9 0 003.93-2.31L422 112.66a9 9 0 000-12.66l-9.95-10a9 9 0 00-12.71 0z"}}]})(props);
	};
	module.exports.IoCreateSharp = function IoCreateSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464.37 49.2a22.07 22.07 0 00-31.88-.76l-18.31 18.25 31.18 31.1 18-17.91a22.16 22.16 0 001.01-30.68zM252.76 336H176v-76.76l9.4-9.38L323.54 112H48v352h352V188.46L262.14 326.6l-9.38 9.4zM400 143.16l32.79-32.86-31.09-31.09L368.85 112H400v31.16z"}},{"tag":"path","attr":{"d":"M208 304h31.49L400 143.16V112h-31.15L208 272.51V304z"}}]})(props);
	};
	module.exports.IoCreate = function IoCreate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.94 53.25a16.06 16.06 0 00-23.22-.56L424.35 65a8 8 0 000 11.31l11.34 11.32a8 8 0 0011.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38zM399.34 90L218.82 270.2a9 9 0 00-2.31 3.93L208.16 299a3.91 3.91 0 004.86 4.86l24.85-8.35a9 9 0 003.93-2.31L422 112.66a9 9 0 000-12.66l-9.95-10a9 9 0 00-12.71 0z"}},{"tag":"path","attr":{"d":"M386.34 193.66L264.45 315.79A41.08 41.08 0 01247.58 326l-25.9 8.67a35.92 35.92 0 01-44.33-44.33l8.67-25.9a41.08 41.08 0 0110.19-16.87l122.13-121.91a8 8 0 00-5.65-13.66H104a56 56 0 00-56 56v240a56 56 0 0056 56h240a56 56 0 0056-56V199.31a8 8 0 00-13.66-5.65z"}}]})(props);
	};
	module.exports.IoCropOutline = function IoCropOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M144 48v272a48 48 0 0048 48h272"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M368 304V192a48 48 0 00-48-48H208m160 224v96M144 144H48"}}]})(props);
	};
	module.exports.IoCropSharp = function IoCropSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M166 346V32h-44v90H32v44h90v224h224v90h44v-90h90v-44H166z"}},{"tag":"path","attr":{"d":"M346 320h44V122H192v44h154v154z"}}]})(props);
	};
	module.exports.IoCrop = function IoCrop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458 346H192a26 26 0 01-26-26V54a22 22 0 00-44 0v68H54a22 22 0 000 44h68v154a70.08 70.08 0 0070 70h154v68a22 22 0 0044 0v-68h68a22 22 0 000-44z"}},{"tag":"path","attr":{"d":"M214 166h106a26 26 0 0126 26v106a22 22 0 0044 0V192a70.08 70.08 0 00-70-70H214a22 22 0 000 44z"}}]})(props);
	};
	module.exports.IoCubeOutline = function IoCubeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M448 341.37V170.61A32 32 0 00432.11 143l-152-88.46a47.94 47.94 0 00-48.24 0L79.89 143A32 32 0 0064 170.61v170.76A32 32 0 0079.89 369l152 88.46a48 48 0 0048.24 0l152-88.46A32 32 0 00448 341.37z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M69 153.99l187 110 187-110m-187 310v-200"}}]})(props);
	};
	module.exports.IoCubeSharp = function IoCubeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 170v196.92L240 480V284L48 170zm224 310l192-113.08V170L272 284zm176-122.36zM448 144L256 32 64 144l192 112 192-112z"}}]})(props);
	};
	module.exports.IoCube = function IoCube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.9 136.3a4 4 0 000-6.91L288.16 40.65a64.14 64.14 0 00-64.33 0L71.12 129.39a4 4 0 000 6.91L254 243.88a4 4 0 004.06 0zM54 163.51a4 4 0 00-6 3.49v173.89a48 48 0 0023.84 41.39L234 479.51a4 4 0 006-3.46V274.3a4 4 0 00-2-3.46zM272 275v201a4 4 0 006 3.46l162.15-97.23A48 48 0 00464 340.89V167a4 4 0 00-6-3.45l-184 108a4 4 0 00-2 3.45z"}}]})(props);
	};
	module.exports.IoCutOutline = function IoCutOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"104","cy":"152","r":"56","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"104","cy":"360","r":"56","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M157 175l-11 15 37 15s3.46-6.42 7-10z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M154.17 334.43L460 162c-2.5-6.7-28-12-64-4-29.12 6.47-121.16 29.05-159.16 56.05C205.85 236.06 227 272 192 298c-25.61 19-44.43 22.82-44.43 22.82zm190.3-56.19L295 306.67c14.23 6.74 65.54 33.27 117 36.33 14.92.89 30 .39 39-6z"}},{"tag":"circle","attr":{"cx":"256","cy":"240","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoCutSharp = function IoCutSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 128h-48l-198.94 70.46-59.13-31.59a72.16 72.16 0 10-25.69 41.47l52.2 31.72L192 277l-43.64 26.76a71.74 71.74 0 1024.79 38L480 160zm-376.52 64a40 40 0 1140-40 40 40 0 01-40 40zm0 208a40 40 0 1140-40 40 40 0 01-40 40zm152-144a16 16 0 1116-16 16 16 0 01-16 16z"}},{"tag":"path","attr":{"d":"M343.79 259.87l-83.74 48.18L432 368h47.99l.01-32-136.21-76.13z"}}]})(props);
	};
	module.exports.IoCut = function IoCut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M103.48 224a71.64 71.64 0 0044.76-15.66l41.5 16.89 6.82-12.63a39.15 39.15 0 014.32-6.37l14.22-14.42-41.17-24.94A72 72 0 10103.48 224zm0-112a40 40 0 11-40 40 40 40 0 0140-40z"}},{"tag":"path","attr":{"d":"M480 169l-5.52-12.58c-4.48-10.42-14.74-16-32.78-17.85-10.12-1-26.95-1.24-49.69 3.81-20 4.45-122.14 28.2-164.95 58.62-20.25 14.39-24.06 33.67-27.06 49.16-2.78 14.14-5 25.31-18 35-15 11.14-27.27 16.38-33.58 18.6a71.74 71.74 0 1024.79 38zm-224.52 87a16 16 0 1116-16 16 16 0 01-16 16zm-152 144a40 40 0 1140-40 40 40 0 01-40 40z"}},{"tag":"path","attr":{"d":"M343.79 259.87l-83.74 48.18 27.63 13.08 3.62 1.74C310 331.92 359.74 356 410.53 359c3.89.23 7.47.34 10.78.34C442 359.31 453 354 459.75 350L480 336z"}}]})(props);
	};
	module.exports.IoDesktopOutline = function IoDesktopOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"448","height":"320","x":"32","y":"64","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"32","ry":"32"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M304 448l-8-64h-80l-8 64h96z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M368 448H144"}},{"tag":"path","attr":{"d":"M32 304v48a32.09 32.09 0 0032 32h384a32.09 32.09 0 0032-32v-48zm224 64a16 16 0 1116-16 16 16 0 01-16 16z"}}]})(props);
	};
	module.exports.IoDesktopSharp = function IoDesktopSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 48H32a16 16 0 00-16 16v320a16 16 0 0016 16h168v32h-72v32h256v-32h-72v-32h168a16 16 0 0016-16V64a16 16 0 00-16-16zm-20 36v216H52V84zM240.13 354.08a16 16 0 1113.79 13.79 16 16 0 01-13.79-13.79z"}}]})(props);
	};
	module.exports.IoDesktop = function IoDesktop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16 352a48.05 48.05 0 0048 48h133.88l-4 32H144a16 16 0 000 32h224a16 16 0 000-32h-49.88l-4-32H448a48.05 48.05 0 0048-48v-48H16zm240-16a16 16 0 11-16 16 16 16 0 0116-16zM496 96a48.05 48.05 0 00-48-48H64a48.05 48.05 0 00-48 48v192h480z"}}]})(props);
	};
	module.exports.IoDiamondOutline = function IoDiamondOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M35.42 188.21l207.75 269.46a16.17 16.17 0 0025.66 0l207.75-269.46a16.52 16.52 0 00.95-18.75L407.06 55.71A16.22 16.22 0 00393.27 48H118.73a16.22 16.22 0 00-13.79 7.71L34.47 169.46a16.52 16.52 0 00.95 18.75zM48 176h416"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M400 64l-48 112-96-128M112 64l48 112 96-128m0 400l-96-272m96 272l96-272"}}]})(props);
	};
	module.exports.IoDiamondSharp = function IoDiamondSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396.31 32H264l84.19 112.26L396.31 32zm-280.62 0l48.12 112.26L248 32H115.69zM256 74.67L192 160h128l-64-85.33zm166.95-23.61L376.26 160H488L422.95 51.06zm-333.9 0L23 160h112.74L89.05 51.06zM146.68 192H24l222.8 288h.53L146.68 192zm218.64 0L264.67 480h.53L488 192H365.32zm-35.93 0H182.61L256 400l73.39-208z"}}]})(props);
	};
	module.exports.IoDiamond = function IoDiamond (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M121.72 32a4 4 0 00-3.72 5.56l2.3 5.43 40.7 94.9a4 4 0 006.88.82L243 38.4a4 4 0 00-3.2-6.4zm298.21 26.06l-41.28 96.37a4 4 0 003.68 5.57h101a4 4 0 003.4-6.11L427 57.53a4 4 0 00-7.07.53zM85 57.57l-59.71 96.32a4 4 0 003.4 6.11h101a4 4 0 003.67-5.58L92 58.1a4 4 0 00-7-.53zM393.27 32H267.82a1.94 1.94 0 00-1.56 3.11l79.92 106.46a1.94 1.94 0 003.34-.4L391.6 43l3.4-8.34a1.92 1.92 0 00-1.7-2.66zM239 448l-89.43-253.49A3.78 3.78 0 00146 192H25.7a3.72 3.72 0 00-2.95 6l216 279.81a5.06 5.06 0 006.39 1.37 5 5 0 002.39-6.08zm247.3-256H366a3.75 3.75 0 00-3.54 2.51l-98.2 278.16a5.21 5.21 0 002.42 6.31 5.22 5.22 0 006.61-1.39L489.25 198a3.72 3.72 0 00-2.95-6zM259.2 78.93l56 74.67a4 4 0 01-3.2 6.4H200a4 4 0 01-3.2-6.4l56-74.67a4 4 0 016.4 0zm-7 310.31l-67.7-191.91a4 4 0 013.77-5.33h135.46a4 4 0 013.77 5.33l-67.73 191.91a4 4 0 01-7.54 0z"}}]})(props);
	};
	module.exports.IoDiceOutline = function IoDiceOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M448 341.37V170.61A32 32 0 00432.11 143l-152-88.46a47.94 47.94 0 00-48.24 0L79.89 143A32 32 0 0064 170.61v170.76A32 32 0 0079.89 369l152 88.46a48 48 0 0048.24 0l152-88.46A32 32 0 00448 341.37z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M69 153.99l187 110 187-110m-187 310v-200"}},{"tag":"ellipse","attr":{"cx":"256","cy":"152","rx":"24","ry":"16"}},{"tag":"ellipse","attr":{"cx":"208","cy":"296","rx":"16","ry":"24"}},{"tag":"ellipse","attr":{"cx":"112","cy":"328","rx":"16","ry":"24"}},{"tag":"ellipse","attr":{"cx":"304","cy":"296","rx":"16","ry":"24"}},{"tag":"ellipse","attr":{"cx":"400","cy":"240","rx":"16","ry":"24"}},{"tag":"ellipse","attr":{"cx":"304","cy":"384","rx":"16","ry":"24"}},{"tag":"ellipse","attr":{"cx":"400","cy":"328","rx":"16","ry":"24"}}]})(props);
	};
	module.exports.IoDiceSharp = function IoDiceSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 366.92L240 480V284L48 170zM192 288c8.84 0 16 10.75 16 24s-7.16 24-16 24-16-10.75-16-24 7.16-24 16-24zm-96 32c8.84 0 16 10.75 16 24s-7.16 24-16 24-16-10.75-16-24 7.16-24 16-24zm176-36v196l192-113.08V170zm48 140c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96 32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm32 77.64zM256 32L64 144l192 112 192-112zm0 120c-13.25 0-24-7.16-24-16s10.75-16 24-16 24 7.16 24 16-10.75 16-24 16z"}}]})(props);
	};
	module.exports.IoDice = function IoDice (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.88 129.37L288.16 40.62a64.14 64.14 0 00-64.33 0L71.12 129.37a4 4 0 000 6.9L254 243.85a4 4 0 004.06 0L440.9 136.27a4 4 0 00-.02-6.9zM256 152c-13.25 0-24-7.16-24-16s10.75-16 24-16 24 7.16 24 16-10.75 16-24 16zm-18 118.81L54 163.48a4 4 0 00-6 3.46v173.92a48 48 0 0023.84 41.39L234 479.48a4 4 0 006-3.46V274.27a4 4 0 00-2-3.46zM96 368c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96-32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm266-172.49L274 271.56a4 4 0 00-2 3.45V476a4 4 0 006 3.46l162.15-97.23A48 48 0 00464 340.86V167a4 4 0 00-6-3.49zM320 424c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96 32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24z"}}]})(props);
	};
	module.exports.IoDiscOutline = function IoDiscOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"208","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"96","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"32"}}]})(props);
	};
	module.exports.IoDiscSharp = function IoDiscSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"32"}},{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM256 336a80 80 0 1180-80 80.09 80.09 0 01-80 80z"}}]})(props);
	};
	module.exports.IoDisc = function IoDisc (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 176a80 80 0 1080 80 80.09 80.09 0 00-80-80zm0 112a32 32 0 1132-32 32 32 0 01-32 32z"}},{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM256 368a112 112 0 11112-112 112.12 112.12 0 01-112 112z"}}]})(props);
	};
	module.exports.IoDocumentAttachOutline = function IoDocumentAttachOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M208 64h66.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62V432a48 48 0 01-48 48H192a48 48 0 01-48-48V304"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M288 72v120a32 32 0 0032 32h120"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M160 80v152a23.69 23.69 0 01-24 24c-12 0-24-9.1-24-24V88c0-30.59 16.57-56 48-56s48 24.8 48 55.38v138.75c0 43-27.82 77.87-72 77.87s-72-34.86-72-77.87V144"}}]})(props);
	};
	module.exports.IoDocumentAttachSharp = function IoDocumentAttachSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M280 240a8 8 0 01-8-8V48h-57.25a65.42 65.42 0 00-6.5-9.81C196.72 23.88 179.59 16 160 16c-37.68 0-64 29.61-64 72v144c0 25 20.34 40 40 40a39.57 39.57 0 0040-40V80h-32v152a7.75 7.75 0 01-8 8c-2.23 0-8-1.44-8-8V88c0-19.34 8.41-40 32-40 29.69 0 32 30.15 32 39.38v138.75c0 17.45-5.47 33.23-15.41 44.46C166.5 282 152.47 288 136 288s-30.5-6-40.59-17.41C85.47 259.36 80 243.58 80 226.13V144H48v82.13c0 51.51 33.19 89.63 80 93.53V468a12 12 0 0012 12h312a12 12 0 0012-12V240z"}},{"tag":"path","attr":{"d":"M308 208h146.31a2 2 0 001.42-3.41L307.41 56.27a2 2 0 00-3.41 1.42V204a4 4 0 004 4z"}}]})(props);
	};
	module.exports.IoDocumentAttach = function IoDocumentAttach (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M460 240H320a48 48 0 01-48-48V52a4 4 0 00-4-4h-53.25a65.42 65.42 0 00-6.5-9.81C196.72 23.88 179.59 16 160 16c-37.68 0-64 29.61-64 72v144c0 25 20.34 40 40 40a39.57 39.57 0 0040-40V80a16 16 0 00-32 0v152a7.75 7.75 0 01-8 8c-2.23 0-8-1.44-8-8V88c0-19.34 8.41-40 32-40 29.69 0 32 30.15 32 39.38v138.75c0 17.45-5.47 33.23-15.41 44.46C166.5 282 152.47 288 136 288s-30.5-6-40.59-17.41C85.47 259.36 80 243.58 80 226.13V144a16 16 0 00-32 0v82.13c0 51.51 33.19 89.63 80 93.53V432a64 64 0 0064 64h208a64 64 0 0064-64V244a4 4 0 00-4-4z"}},{"tag":"path","attr":{"d":"M320 208h129.81a2 2 0 001.41-3.41L307.41 60.78a2 2 0 00-3.41 1.41V192a16 16 0 0016 16z"}}]})(props);
	};
	module.exports.IoDocumentLockOutline = function IoDocumentLockOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M288 304v-18c0-16.63-14.26-30-32-30s-32 13.37-32 30v18"}},{"tag":"path","attr":{"d":"M304 416h-96a32 32 0 01-32-32v-48a32 32 0 0132-32h96a32 32 0 0132 32v48a32 32 0 01-32 32z"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 50.88V176a32 32 0 0032 32h125.12"}}]})(props);
	};
	module.exports.IoDocumentLockSharp = function IoDocumentLockSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M276 192h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42V188a4 4 0 004 4zm-20 80c-8.82 0-16 6.28-16 14v18h32v-18c0-7.72-7.18-14-16-14z"}},{"tag":"path","attr":{"d":"M248 224a8 8 0 01-8-8V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224zm88 175.91A16.1 16.1 0 01319.91 416H192.09A16.1 16.1 0 01176 399.91V320c0-10 7-16 16-16h16v-18c0-25.36 21.53-46 48-46s48 20.64 48 46v18h16a15.8 15.8 0 0116 16z"}}]})(props);
	};
	module.exports.IoDocumentLock = function IoDocumentLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 192h129.81a2 2 0 001.41-3.41L275.41 44.78a2 2 0 00-3.41 1.41V176a16 16 0 0016 16zm-32 80c-8.82 0-16 6.28-16 14v18h32v-18c0-7.72-7.18-14-16-14z"}},{"tag":"path","attr":{"d":"M428 224H288a48 48 0 01-48-48V36a4 4 0 00-4-4h-92a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V228a4 4 0 00-4-4zm-92 160a32 32 0 01-32 32h-96a32 32 0 01-32-32v-48a32 32 0 0132-32v-18c0-25.36 21.53-46 48-46s48 20.64 48 46v18a32 32 0 0132 32z"}}]})(props);
	};
	module.exports.IoDocumentOutline = function IoDocumentOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 56v120a32 32 0 0032 32h120"}}]})(props);
	};
	module.exports.IoDocumentSharp = function IoDocumentSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M240 216V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224H248a8 8 0 01-8-8z"}},{"tag":"path","attr":{"d":"M272 41.69V188a4 4 0 004 4h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42z"}}]})(props);
	};
	module.exports.IoDocumentTextOutline = function IoDocumentTextOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 56v120a32 32 0 0032 32h120m-232 80h160m-160 80h160"}}]})(props);
	};
	module.exports.IoDocumentTextSharp = function IoDocumentTextSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 41.69V188a4 4 0 004 4h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42z"}},{"tag":"path","attr":{"d":"M248 224a8 8 0 01-8-8V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224zm104 160H160v-32h192zm0-80H160v-32h192z"}}]})(props);
	};
	module.exports.IoDocumentText = function IoDocumentText (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M428 224H288a48 48 0 01-48-48V36a4 4 0 00-4-4h-92a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V228a4 4 0 00-4-4zm-92 160H176a16 16 0 010-32h160a16 16 0 010 32zm0-80H176a16 16 0 010-32h160a16 16 0 010 32z"}},{"tag":"path","attr":{"d":"M419.22 188.59L275.41 44.78a2 2 0 00-3.41 1.41V176a16 16 0 0016 16h129.81a2 2 0 001.41-3.41z"}}]})(props);
	};
	module.exports.IoDocument = function IoDocument (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M428 224H288a48 48 0 01-48-48V36a4 4 0 00-4-4h-92a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V228a4 4 0 00-4-4z"}},{"tag":"path","attr":{"d":"M419.22 188.59L275.41 44.78a2 2 0 00-3.41 1.41V176a16 16 0 0016 16h129.81a2 2 0 001.41-3.41z"}}]})(props);
	};
	module.exports.IoDocumentsOutline = function IoDocumentsOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M336 264.13V436c0 24.3-19.05 44-42.95 44H107c-23.95 0-43-19.7-43-44V172a44.26 44.26 0 0144-44h94.12a24.55 24.55 0 0117.49 7.36l109.15 111a25.4 25.4 0 017.24 17.77z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M200 128v108a28.34 28.34 0 0028 28h108"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M176 128V76a44.26 44.26 0 0144-44h94a24.83 24.83 0 0117.61 7.36l109.15 111A25.09 25.09 0 01448 168v172c0 24.3-19.05 44-42.95 44H344"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M312 32v108a28.34 28.34 0 0028 28h108"}}]})(props);
	};
	module.exports.IoDocumentsSharp = function IoDocumentsSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M307.94 248L216 154.52V242a6 6 0 006 6z"}},{"tag":"path","attr":{"d":"M184 268V144H60a12 12 0 00-12 12v328a12 12 0 0012 12h248a12 12 0 0012-12V280H196a12 12 0 01-12-12zm182-148h85.94L360 26.52V114a6 6 0 006 6z"}},{"tag":"path","attr":{"d":"M340 152a12 12 0 01-12-12V16H172a12 12 0 00-12 12v84h42.12A40.81 40.81 0 01231 124.14l109.16 111a41.11 41.11 0 0111.83 29V400H452a12 12 0 0012-12V152z"}}]})(props);
	};
	module.exports.IoDocuments = function IoDocuments (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M298.39 248a4 4 0 002.86-6.8l-78.4-79.72a4 4 0 00-6.85 2.81V236a12 12 0 0012 12z"}},{"tag":"path","attr":{"d":"M197 267a43.67 43.67 0 01-13-31v-92h-72a64.19 64.19 0 00-64 64v224a64 64 0 0064 64h144a64 64 0 0064-64V280h-92a43.61 43.61 0 01-31-13zm175-147h70.39a4 4 0 002.86-6.8l-78.4-79.72a4 4 0 00-6.85 2.81V108a12 12 0 0012 12z"}},{"tag":"path","attr":{"d":"M372 152a44.34 44.34 0 01-44-44V16H220a60.07 60.07 0 00-60 60v36h42.12A40.81 40.81 0 01231 124.14l109.16 111a41.11 41.11 0 0111.83 29V400h53.05c32.51 0 58.95-26.92 58.95-60V152z"}}]})(props);
	};
	module.exports.IoDownloadOutline = function IoDownloadOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 272l80 80 80-80M256 48v288"}}]})(props);
	};
	module.exports.IoDownloadSharp = function IoDownloadSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 160v147.37l64-64L358.63 266 256 368.63 153.37 266 176 243.37l64 64V160H92a12 12 0 00-12 12v296a12 12 0 0012 12h328a12 12 0 0012-12V172a12 12 0 00-12-12zM240 32h32v128h-32z"}}]})(props);
	};
	module.exports.IoDownload = function IoDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 160H272v153.37l52.69-52.68a16 16 0 0122.62 22.62l-80 80a16 16 0 01-22.62 0l-80-80a16 16 0 0122.62-22.62L240 313.37V160H136a56.06 56.06 0 00-56 56v208a56.06 56.06 0 0056 56h240a56.06 56.06 0 0056-56V216a56.06 56.06 0 00-56-56zM272 48a16 16 0 00-32 0v112h32z"}}]})(props);
	};
	module.exports.IoDuplicateOutline = function IoDuplicateOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"336","height":"336","x":"128","y":"128","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"57","ry":"57"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24m168-168v160m80-80H216"}}]})(props);
	};
	module.exports.IoDuplicateSharp = function IoDuplicateSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M112 80h288V56a24 24 0 00-24-24H66a34 34 0 00-34 34v310a24 24 0 0024 24h24V112a32 32 0 0132-32z"}},{"tag":"path","attr":{"d":"M456 112H136a24 24 0 00-24 24v320a24 24 0 0024 24h320a24 24 0 0024-24V136a24 24 0 00-24-24zm-64 200h-80v80h-32v-80h-80v-32h80v-80h32v80h80z"}}]})(props);
	};
	module.exports.IoDuplicate = function IoDuplicate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408 112H184a72 72 0 00-72 72v224a72 72 0 0072 72h224a72 72 0 0072-72V184a72 72 0 00-72-72zm-32.45 200H312v63.55c0 8.61-6.62 16-15.23 16.43A16 16 0 01280 376v-64h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01216 280h64v-63.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01312 216v64h64a16 16 0 0116 16.77c-.42 8.61-7.84 15.23-16.45 15.23z"}},{"tag":"path","attr":{"d":"M395.88 80A72.12 72.12 0 00328 32H104a72 72 0 00-72 72v224a72.12 72.12 0 0048 67.88V160a80 80 0 0180-80z"}}]})(props);
	};
	module.exports.IoEarOutline = function IoEarOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M335.72 330.76C381.73 299.5 416 251.34 416 192a160 160 0 00-320 0v206.57c0 44.26 35.74 81.43 80 81.43h0c44.26 0 66.83-25.94 77.29-40 14.77-19.81 41.71-81.56 82.43-109.24z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 304V184c0-48.4 43.2-88 96-88h0c52.8 0 96 39.6 96 88"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 239c25-18 79.82-15 79.82-15 26 0 41.17 29.42 26 50.6 0 0-36.86 42.4-41.86 61.4"}}]})(props);
	};
	module.exports.IoEarSharp = function IoEarSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M380.48 68.09C347.09 34.5 302.88 16 256 16 159 16 80 95 80 192v206.57a97.59 97.59 0 0028 68.49A94.49 94.49 0 00176 496c19.93 0 41.06-7.69 62.8-22.87a181.46 181.46 0 0025.88-21.86C327.37 390.16 432 288.06 432 192c0-46.49-18.29-90.49-51.52-123.91zM368 200h-32v-16c0-39.7-35.89-72-80-72s-80 32.3-80 72v30.41c27.5-7.84 59.89-6.62 64.26-6.41a48 48 0 0138.62 75.9c-.3.41-.61.81-.95 1.2-16.55 19-36 45.49-38.46 55l-4.07 15.47-30.94-8.14 4.07-15.47c5.51-20.94 36.93-58.2 44.66-67.15A16 16 0 00239.82 240h-.88c-10.67-.58-42.66-.25-62.12 8l-.82.35V320h-32V184c0-57.35 50.24-104 112-104s112 46.65 112 104z"}}]})(props);
	};
	module.exports.IoEar = function IoEar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 16C159 16 80 95 80 192v206.57a97.59 97.59 0 0028 68.49A94.51 94.51 0 00176 496c36.86 0 67.18-15.62 90.12-46.42 4.48-6 9.55-14.74 15.42-24.85 15.32-26.37 36.29-62.47 63.17-80.74 25.77-17.51 47.23-39.54 62-63.72C423.51 252.94 432 223.24 432 192c0-97-78.95-176-176-176zm96 184a16 16 0 01-16-16c0-39.7-35.89-72-80-72s-80 32.3-80 72v30.42c27.19-7.84 58.4-6.72 64.28-6.42a48 48 0 0138.6 75.9c-.3.41-.61.81-.95 1.2-16.55 19-36 45.48-38.46 55a16 16 0 01-30.94-8.14c5.51-20.94 36.93-58.2 44.66-67.15A16 16 0 00239.82 240h-.88c-16.6-.89-45.89.8-62.94 8.31V304a16 16 0 01-32 0V184c0-57.35 50.24-104 112-104s112 46.65 112 104a16 16 0 01-16 16z"}}]})(props);
	};
	module.exports.IoEarthOutline = function IoEarthOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208z"}},{"tag":"path","attr":{"d":"M445.57 172.14c-16.06.1-14.48 29.73-34.49 15.75-7.43-5.18-12-12.71-21.33-15-8.15-2-16.5.08-24.55 1.47-9.15 1.58-20 2.29-26.94 9.22-6.71 6.67-10.26 15.62-17.4 22.33-13.81 13-19.64 27.19-10.7 45.57 8.6 17.67 26.59 27.26 46 26 19.07-1.27 38.88-12.33 38.33 15.38-.2 9.8 1.85 16.6 4.86 25.71 2.79 8.4 2.6 16.54 3.24 25.21 1.18 16.2 4.16 34.36 12.2 48.67l15-21.16c1.85-2.62 5.72-6.29 6.64-9.38 1.63-5.47-1.58-14.87-1.95-21s-.19-12.34-1.13-18.47c-1.32-8.59-6.4-16.64-7.1-25.13-1.29-15.81 1.6-28.43-10.58-41.65-11.76-12.75-29-15.81-45.47-13.22-8.3 1.3-41.71 6.64-28.3-12.33 2.65-3.73 7.28-6.79 10.26-10.34 2.59-3.09 4.84-8.77 7.88-11.18s17-5.18 21-3.95 8.17 7 11.64 9.56a49.89 49.89 0 0021.81 9.36c13.66 2 42.22-5.94 42-23.46-.04-8.4-7.84-20.1-10.92-27.96zM287.45 316.3c-5.33-22.44-35.82-29.94-52.26-42.11-9.45-7-17.86-17.81-30.27-18.69-5.72-.41-10.51.83-16.18-.64-5.2-1.34-9.28-4.14-14.82-3.41-10.35 1.36-16.88 12.42-28 10.92-10.55-1.42-21.42-13.76-23.82-23.81-3.08-12.92 7.14-17.11 18.09-18.26 4.57-.48 9.7-1 14.09.67 5.78 2.15 8.51 7.81 13.7 10.67 9.73 5.33 11.7-3.19 10.21-11.83-2.23-12.94-4.83-18.22 6.71-27.12 8-6.14 14.84-10.58 13.56-21.61-.76-6.48-4.31-9.41-1-15.86 2.51-4.91 9.4-9.34 13.89-12.27 11.59-7.56 49.65-7 34.1-28.16-4.57-6.21-13-17.31-21-18.83-10-1.89-14.44 9.27-21.41 14.19-7.2 5.09-21.22 10.87-28.43 3-9.7-10.59 6.43-14.07 10-21.46s-8.27-21.36-14.61-24.9l-29.81 33.43a41.52 41.52 0 008.34 31.86c5.93 7.63 15.37 10.08 15.8 20.5.42 10-1.14 15.12-7.68 22.15-2.83 3-4.83 7.26-7.71 10.07-3.53 3.43-2.22 2.38-7.73 3.32-10.36 1.75-19.18 4.45-29.19 7.21C95.34 199.94 93.8 172.69 86.2 162l-25 20.19c-.27 3.31 4.1 9.4 5.29 13 6.83 20.57 20.61 36.48 29.51 56.16 9.37 20.84 34.53 15.06 45.64 33.32 9.86 16.2-.67 36.71 6.71 53.67 5.36 12.31 18 15 26.72 24 8.91 9.09 8.72 21.53 10.08 33.36a305.22 305.22 0 007.45 41.28c1.21 4.69 2.32 10.89 5.53 14.76 2.2 2.66 9.75 4.95 6.7 5.83 4.26.7 11.85 4.68 15.4 1.76 4.68-3.84 3.43-15.66 4.24-21 2.43-15.9 10.39-31.45 21.13-43.35 10.61-11.74 25.15-19.69 34.11-33 8.73-12.98 11.36-30.49 7.74-45.68zm-33.39 26.32c-6 10.71-19.36 17.88-27.95 26.39-2.33 2.31-7.29 10.31-10.21 8.58-2.09-1.24-2.8-11.62-3.57-14a61.17 61.17 0 00-21.71-29.95c-3.13-2.37-10.89-5.45-12.68-8.7-2-3.53-.2-11.86-.13-15.7.11-5.6-2.44-14.91-1.06-20 1.6-5.87-1.48-2.33 3.77-3.49 2.77-.62 14.21 1.39 17.66 2.11 5.48 1.14 8.5 4.55 12.82 8 11.36 9.11 23.87 16.16 36.6 23.14 9.86 5.46 12.76 12.37 6.46 23.62zm-69.6-275.53c4.74 4.63 9.2 10.11 16.27 10.57 6.69.45 13-3.17 18.84 1.38 6.48 5 11.15 11.33 19.75 12.89 8.32 1.51 17.13-3.35 19.19-11.86 2-8.11-2.31-16.93-2.57-25.07 0-1.13.61-6.15-.17-7-.58-.64-5.42.08-6.16.1q-8.13.24-16.22 1.12a207.1 207.1 0 00-57.18 14.65c2.43 1.68 5.48 2.35 8.25 3.22zm171.94 56.18c8.49 0 17.11-3.8 14.37-13.62-2.3-8.23-6.22-17.16-15.76-12.72-6.07 2.82-14.67 10-15.38 17.12-.81 8.08 11.11 9.22 16.77 9.22zm-6.78 42.97c8.67 5.19 21.53 2.75 28.07-4.66 5.11-5.8 8.12-15.87 17.31-15.86a15.4 15.4 0 0110.82 4.41c3.8 3.93 3.05 7.62 3.86 12.54 1.81 11.05 13.66.63 16.75-3.65 2-2.79 4.71-6.93 3.8-10.56-.84-3.39-4.8-7-6.56-10.11-5.14-9-9.37-19.47-17.07-26.74-7.41-7-16.52-6.19-23.55 1.08-5.76 6-12.45 10.75-16.39 18.05-2.78 5.13-5.91 7.58-11.54 8.91-3.1.73-6.64 1-9.24 3.08-7.24 5.7-3.12 19.39 3.74 23.51z"}}]})(props);
	};
	module.exports.IoEarthSharp = function IoEarthSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M267 474l-.8-.13a.85.85 0 00.8.13zm181.9-286.22a5.51 5.51 0 00-10.67-.63A5.52 5.52 0 01433 191h-15.47a5.48 5.48 0 01-2.84-.79l-22.38-13.42a5.48 5.48 0 00-2.84-.79h-35.8a5.48 5.48 0 00-3.06.93l-44.15 29.43A5.52 5.52 0 00304 211v41.74a5.51 5.51 0 002.92 4.87l57.89 30.9a5.55 5.55 0 012.92 4.8l.27 23.49a5.53 5.53 0 002.85 4.75l23.26 12.87a5.54 5.54 0 012.85 4.83v48.6a5.52 5.52 0 009.17 4.14c9.38-8.26 22.83-20.32 24.62-23.08q4.44-6.87 8.33-14.07a207.39 207.39 0 0013.6-31c12.68-36.71 2.66-102.7-3.78-136.06zM286.4 302.8l-61.33-46a4 4 0 00-2.4-.8h-29.1a3.78 3.78 0 01-2.68-1.11l-13.72-13.72a4 4 0 00-2.83-1.17h-53.19a3.79 3.79 0 01-2.68-6.47l8.42-8.42a3.78 3.78 0 012.68-1.11h32.37a8 8 0 007.7-5.83l6.89-24.5a4 4 0 012-2.47L206 177.06a3.79 3.79 0 002.05-3.37v-12.5a3.82 3.82 0 01.68-2.17l14.6-21.02a3.75 3.75 0 011.78-1.38l20.43-7.67a3.79 3.79 0 002.46-3.55V114a3.8 3.8 0 00-1.69-3.16l-20.48-13.62A3.83 3.83 0 00222 97l-27.88 13.94a3.78 3.78 0 01-4-.41l-13.22-10.45a3.8 3.8 0 01.1-6l10.74-7.91a3.78 3.78 0 00-.09-6.16l-16.73-11.67a3.78 3.78 0 00-4-.22c-6.05 3.31-23.8 13.11-30.1 17.52a209.48 209.48 0 00-68.16 80c-1.82 3.76-4.07 7.59-4.29 11.72s-3.46 13.35-4.81 17.08a3.78 3.78 0 00.24 3.1l35.69 65.58a3.74 3.74 0 001.38 1.44l37.55 22.54a3.78 3.78 0 011.81 2.73l7.52 54.54a3.82 3.82 0 001.61 2.61l29.3 20.14a4 4 0 011.65 2.48l15.54 73.8a3.6 3.6 0 00.49 1.22c1.46 2.36 7.28 11 14.3 12.28-.65.18-1.23.59-1.88.78a47.63 47.63 0 015 1.16c2 .54 4 1 6 1.43 3.13.62 3.44 1.1 4.94-1.68 2-3.72 4.29-5 6-5.46a3.85 3.85 0 002.89-2.9l10.07-46.68a4 4 0 011.6-2.42l45-31.9a4 4 0 001.69-3.27V306a4 4 0 00-1.55-3.2z"}},{"tag":"path","attr":{"d":"M262 48s-3.65.21-4.39.23q-8.13.24-16.22 1.12A207.45 207.45 0 00184.21 64c2.43 1.68-1.75 3.22-1.75 3.22L189 80h35l24 12 21-12zm92.23 72.06l16.11-14a4 4 0 00-.94-6.65l-18.81-8.73a4 4 0 00-5.3 1.9l-7.75 16.21a4 4 0 001.49 5.11l10.46 6.54a4 4 0 004.74-.38zm75.41 20.61l-5.83-9c-.09-.14-.17-.28-.25-.43-1.05-2.15-9.74-19.7-17-26.51-5.45-5.15-7-3.67-7.43-2.53a3.77 3.77 0 01-1.19 1.6l-28.84 23.31a4 4 0 01-2.51.89h-14.93a4 4 0 00-2.83 1.17l-12 12a4 4 0 000 5.66l12 12a4 4 0 002.83 1.17h75.17a4 4 0 004-4.17l-.55-13.15a4 4 0 00-.64-2.01z"}},{"tag":"path","attr":{"d":"M256 72a184 184 0 11-130.1 53.9A182.77 182.77 0 01256 72m0-40C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224S379.7 32 256 32z"}}]})(props);
	};
	module.exports.IoEarth = function IoEarth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.39 97.74A224 224 0 1097.61 414.52 224 224 0 10414.39 97.74zM64 256.13a191.63 191.63 0 016.7-50.31c7.34 15.8 18 29.45 25.25 45.66 9.37 20.84 34.53 15.06 45.64 33.32 9.86 16.21-.67 36.71 6.71 53.67 5.36 12.31 18 15 26.72 24 8.91 9.08 8.72 21.52 10.08 33.36a305.36 305.36 0 007.45 41.27c0 .1 0 .21.08.31C117.8 411.13 64 339.8 64 256.13zm192 192a193.12 193.12 0 01-32-2.68c.11-2.71.16-5.24.43-7 2.43-15.9 10.39-31.45 21.13-43.35 10.61-11.74 25.15-19.68 34.11-33 8.78-13 11.41-30.5 7.79-45.69-5.33-22.44-35.82-29.93-52.26-42.1-9.45-7-17.86-17.82-30.27-18.7-5.72-.4-10.51.83-16.18-.63-5.2-1.35-9.28-4.15-14.82-3.42-10.35 1.36-16.88 12.42-28 10.92-10.55-1.41-21.42-13.76-23.82-23.81-3.08-12.92 7.14-17.11 18.09-18.26 4.57-.48 9.7-1 14.09.68 5.78 2.14 8.51 7.8 13.7 10.66 9.73 5.34 11.7-3.19 10.21-11.83-2.23-12.94-4.83-18.21 6.71-27.12 8-6.14 14.84-10.58 13.56-21.61-.76-6.48-4.31-9.41-1-15.86 2.51-4.91 9.4-9.34 13.89-12.27 11.59-7.56 49.65-7 34.1-28.16-4.57-6.21-13-17.31-21-18.83-10-1.89-14.44 9.27-21.41 14.19-7.2 5.09-21.22 10.87-28.43 3-9.7-10.59 6.43-14.06 10-21.46 1.65-3.45 0-8.24-2.78-12.75q5.41-2.28 11-4.23a15.6 15.6 0 008 3c6.69.44 13-3.18 18.84 1.38 6.48 5 11.15 11.32 19.75 12.88 8.32 1.51 17.13-3.34 19.19-11.86 1.25-5.18 0-10.65-1.2-16a190.83 190.83 0 01105 32.21c-2-.76-4.39-.67-7.34.7-6.07 2.82-14.67 10-15.38 17.12-.81 8.08 11.11 9.22 16.77 9.22 8.5 0 17.11-3.8 14.37-13.62-1.19-4.26-2.81-8.69-5.42-11.37a193.27 193.27 0 0118 14.14c-.09.09-.18.17-.27.27-5.76 6-12.45 10.75-16.39 18.05-2.78 5.14-5.91 7.58-11.54 8.91-3.1.73-6.64 1-9.24 3.08-7.24 5.7-3.12 19.4 3.74 23.51 8.67 5.19 21.53 2.75 28.07-4.66 5.11-5.8 8.12-15.87 17.31-15.86a15.4 15.4 0 0110.82 4.41c3.8 3.94 3.05 7.62 3.86 12.54 1.43 8.74 9.14 4 13.83-.41a192.12 192.12 0 019.24 18.77c-5.16 7.43-9.26 15.53-21.67 6.87-7.43-5.19-12-12.72-21.33-15.06-8.15-2-16.5.08-24.55 1.47-9.15 1.59-20 2.29-26.94 9.22-6.71 6.68-10.26 15.62-17.4 22.33-13.81 13-19.64 27.19-10.7 45.57 8.6 17.67 26.59 27.26 46 26 19.07-1.27 38.88-12.33 38.33 15.38-.2 9.81 1.85 16.6 4.86 25.71 2.79 8.4 2.6 16.54 3.24 25.21a158 158 0 004.74 30.07A191.75 191.75 0 01256 448.13z"}}]})(props);
	};
	module.exports.IoEaselOutline = function IoEaselOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"272","x":"48","y":"80","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"32","ry":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 416v-64m0-272V48m144 416l-32-112M112 464l32-112"}}]})(props);
	};
	module.exports.IoEaselSharp = function IoEaselSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M468 64H278V32h-44v32H44a12 12 0 00-12 12v280a12 12 0 0012 12h78.19L89.93 470.46l36.53 9.61L161.74 368H234v64h44v-64h71.84l31 111.7 36.83-8.57L389.05 368H468a12 12 0 0012-12V76a12 12 0 00-12-12zm-26 266H70V102h372z"}},{"tag":"path","attr":{"d":"M88 120h336v192H88z"}}]})(props);
	};
	module.exports.IoEasel = function IoEasel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"352","height":"208","x":"80","y":"112","rx":"12","ry":"12"}},{"tag":"path","attr":{"d":"M432 64H272V48a16 16 0 00-32 0v16H80a48.05 48.05 0 00-48 48v208a48.05 48.05 0 0048 48h42.79l-26.17 91.6a16 16 0 1030.76 8.8L156.07 368H240v48a16 16 0 0032 0v-48h83.93l28.69 100.4a16 16 0 1030.76-8.8L389.21 368H432a48.05 48.05 0 0048-48V112a48.05 48.05 0 00-48-48zm16 256a16 16 0 01-16 16H80a16 16 0 01-16-16V112a16 16 0 0116-16h352a16 16 0 0116 16z"}}]})(props);
	};
	module.exports.IoEggOutline = function IoEggOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 48C192 48 96 171.69 96 286.55S160 464 256 464s160-62.59 160-177.45S320 48 256 48z"}}]})(props);
	};
	module.exports.IoEggSharp = function IoEggSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M418.39 381.05c-8.08 21.68-19.76 40.1-34.72 54.75-14.38 14.07-32.1 24.95-52.67 32.34C309.08 476 283.85 480 256 480s-53.08-4-75-11.86c-20.57-7.39-38.29-18.27-52.67-32.34-15-14.65-26.64-33.07-34.72-54.75C84.58 356.82 80 328.53 80 296.94c0-30.28 6.68-62.57 19.86-96A371 371 0 01151 111.42C195.78 53.56 241 32 256 32s62.67 22.4 105 79.42c18.33 24.71 38.87 58.34 51.17 89.54 13.18 33.41 19.86 65.7 19.86 96-.03 31.57-4.61 59.86-13.64 84.09z"}}]})(props);
	};
	module.exports.IoEgg = function IoEgg (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 480c-52.57 0-96.72-17.54-127.7-50.73C96.7 395.4 80 346.05 80 286.55 80 230.5 101.48 168 138.93 115 175.65 63 219.41 32 256 32s80.35 31 117.07 83C410.52 168 432 230.5 432 286.55c0 59.5-16.7 108.85-48.3 142.72C352.72 462.46 308.57 480 256 480z"}}]})(props);
	};
	module.exports.IoEllipseOutline = function IoEllipseOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"192","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoEllipseSharp = function IoEllipseSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208z"}}]})(props);
	};
	module.exports.IoEllipse = function IoEllipse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208z"}}]})(props);
	};
	module.exports.IoEllipsisHorizontalCircleOutline = function IoEllipsisHorizontalCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"26"}},{"tag":"circle","attr":{"cx":"346","cy":"256","r":"26"}},{"tag":"circle","attr":{"cx":"166","cy":"256","r":"26"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoEllipsisHorizontalCircleSharp = function IoEllipsisHorizontalCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm-90 234a26 26 0 1126-26 26 26 0 01-26 26zm90 0a26 26 0 1126-26 26 26 0 01-26 26zm90 0a26 26 0 1126-26 26 26 0 01-26 26z"}}]})(props);
	};
	module.exports.IoEllipsisHorizontalCircle = function IoEllipsisHorizontalCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"26"}},{"tag":"circle","attr":{"cx":"346","cy":"256","r":"26"}},{"tag":"circle","attr":{"cx":"166","cy":"256","r":"26"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoEllipsisHorizontalOutline = function IoEllipsisHorizontalOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"416","cy":"256","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"96","cy":"256","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoEllipsisHorizontalSharp = function IoEllipsisHorizontalSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"48"}},{"tag":"circle","attr":{"cx":"416","cy":"256","r":"48"}},{"tag":"circle","attr":{"cx":"96","cy":"256","r":"48"}}]})(props);
	};
	module.exports.IoEllipsisHorizontal = function IoEllipsisHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"48"}},{"tag":"circle","attr":{"cx":"416","cy":"256","r":"48"}},{"tag":"circle","attr":{"cx":"96","cy":"256","r":"48"}}]})(props);
	};
	module.exports.IoEllipsisVerticalCircleOutline = function IoEllipsisVerticalCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"26"}},{"tag":"circle","attr":{"cx":"256","cy":"346","r":"26"}},{"tag":"circle","attr":{"cx":"256","cy":"166","r":"26"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoEllipsisVerticalCircleSharp = function IoEllipsisVerticalCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-234-90a26 26 0 1126 26 26 26 0 01-26-26zm0 90a26 26 0 1126 26 26 26 0 01-26-26zm0 90a26 26 0 1126 26 26 26 0 01-26-26z"}}]})(props);
	};
	module.exports.IoEllipsisVerticalCircle = function IoEllipsisVerticalCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"26"}},{"tag":"circle","attr":{"cx":"256","cy":"346","r":"26"}},{"tag":"circle","attr":{"cx":"256","cy":"166","r":"26"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoEllipsisVerticalOutline = function IoEllipsisVerticalOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"416","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"96","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoEllipsisVerticalSharp = function IoEllipsisVerticalSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"48"}},{"tag":"circle","attr":{"cx":"256","cy":"416","r":"48"}},{"tag":"circle","attr":{"cx":"256","cy":"96","r":"48"}}]})(props);
	};
	module.exports.IoEllipsisVertical = function IoEllipsisVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"48"}},{"tag":"circle","attr":{"cx":"256","cy":"416","r":"48"}},{"tag":"circle","attr":{"cx":"256","cy":"96","r":"48"}}]})(props);
	};
	module.exports.IoEnterOutline = function IoEnterOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 176v-40a40 40 0 0140-40h208a40 40 0 0140 40v240a40 40 0 01-40 40H216a40 40 0 01-40-40v-40"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M272 336l80-80-80-80M48 256h288"}}]})(props);
	};
	module.exports.IoEnterSharp = function IoEnterSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 240h147.37l-64-64L266 153.37 368.63 256 266 358.63 243.37 336l64-64H160v148a12 12 0 0012 12h296a12 12 0 0012-12V92a12 12 0 00-12-12H172a12 12 0 00-12 12zm-128 0h128v32H32z"}}]})(props);
	};
	module.exports.IoEnter = function IoEnter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 136v104h153.37l-52.68-52.69a16 16 0 0122.62-22.62l80 80a16 16 0 010 22.62l-80 80a16 16 0 01-22.62-22.62L313.37 272H160v104a56.06 56.06 0 0056 56h208a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56H216a56.06 56.06 0 00-56 56zM48 240a16 16 0 000 32h112v-32z"}}]})(props);
	};
	module.exports.IoExitOutline = function IoExitOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 176v-40a40 40 0 00-40-40H88a40 40 0 00-40 40v240a40 40 0 0040 40h192a40 40 0 0040-40v-40m64-160l80 80-80 80m-193-80h273"}}]})(props);
	};
	module.exports.IoExitSharp = function IoExitSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M335.69 272h-161v-32h161V92a12 12 0 00-12-12h-280a12 12 0 00-12 12v328a12 12 0 0012 12h280a12 12 0 0012-12zm83.37 0l-64 64 22.63 22.63L480.31 256 377.69 153.37 355.06 176l64 64h-83.37v32h83.37z"}}]})(props);
	};
	module.exports.IoExit = function IoExit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 376V272H191a16 16 0 010-32h145V136a56.06 56.06 0 00-56-56H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h192a56.06 56.06 0 0056-56zm89.37-104l-52.68 52.69a16 16 0 0022.62 22.62l80-80a16 16 0 000-22.62l-80-80a16 16 0 00-22.62 22.62L425.37 240H336v32z"}}]})(props);
	};
	module.exports.IoExpandOutline = function IoExpandOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M432 320v112H320m101.8-10.23L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320m10.23 101.8L208 304"}}]})(props);
	};
	module.exports.IoExpandSharp = function IoExpandSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M432 320v112H320m101.8-10.23L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320m10.23 101.8L208 304"}}]})(props);
	};
	module.exports.IoExpand = function IoExpand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M432 320v112H320m101.8-10.23L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320m10.23 101.8L208 304"}}]})(props);
	};
	module.exports.IoExtensionPuzzleOutline = function IoExtensionPuzzleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M413.66 246.1H386a2 2 0 01-2-2v-77.24A38.86 38.86 0 00345.14 128H267.9a2 2 0 01-2-2V98.34c0-27.14-21.5-49.86-48.64-50.33a49.53 49.53 0 00-50.4 49.51V126a2 2 0 01-2 2H87.62A39.74 39.74 0 0048 167.62V238a2 2 0 002 2h26.91c29.37 0 53.68 25.48 54.09 54.85.42 29.87-23.51 57.15-53.29 57.15H50a2 2 0 00-2 2v70.38A39.74 39.74 0 0087.62 464H158a2 2 0 002-2v-20.93c0-30.28 24.75-56.35 55-57.06 30.1-.7 57 20.31 57 50.28V462a2 2 0 002 2h71.14A38.86 38.86 0 00384 425.14v-78a2 2 0 012-2h28.48c27.63 0 49.52-22.67 49.52-50.4s-23.2-48.64-50.34-48.64z"}}]})(props);
	};
	module.exports.IoExtensionPuzzleSharp = function IoExtensionPuzzleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M345.14 480H256v-45.71a31.3 31.3 0 00-9.59-22.65c-7.67-7.56-18.83-11.81-30.57-11.64a44.38 44.38 0 00-28.45 10.67c-5.2 4.6-11.39 12.56-11.39 24.42V480H87.62A55.68 55.68 0 0132 424.38V336h45.71c9.16 0 18.07-3.92 25.09-11a42.06 42.06 0 0012.2-29.92C114.7 273.89 97.26 256 76.91 256H32v-89.34a53.77 53.77 0 0116.53-39A55.88 55.88 0 0187.62 112h63.24V97.52A65.53 65.53 0 01217.54 32c35.49.62 64.36 30.38 64.36 66.33V112h63.24A54.28 54.28 0 01400 166.86v63.24h13.66c36.58 0 66.34 29 66.34 64.64 0 36.61-29.39 66.4-65.52 66.4H400v63.24c0 30.67-24.61 55.62-54.86 55.62z"}}]})(props);
	};
	module.exports.IoExtensionPuzzle = function IoExtensionPuzzle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M345.14 480H274a18 18 0 01-18-18v-27.71a31.32 31.32 0 00-9.71-22.77c-7.78-7.59-19.08-11.8-30.89-11.51-21.36.5-39.4 19.3-39.4 41.06V462a18 18 0 01-18 18H87.62A55.62 55.62 0 0132 424.38V354a18 18 0 0118-18h27.71c9.16 0 18.07-3.92 25.09-11a42.06 42.06 0 0012.2-29.92C114.7 273.89 97.26 256 76.91 256H50a18 18 0 01-18-18v-70.38A55.62 55.62 0 0187.62 112h55.24a8 8 0 008-8v-6.48A65.53 65.53 0 01217.54 32c35.49.62 64.36 30.38 64.36 66.33V104a8 8 0 008 8h55.24A54.86 54.86 0 01400 166.86v55.24a8 8 0 008 8h5.66c36.58 0 66.34 29 66.34 64.64 0 36.61-29.39 66.4-65.52 66.4H408a8 8 0 00-8 8v56A54.86 54.86 0 01345.14 480z"}}]})(props);
	};
	module.exports.IoEyeOffOutline = function IoEyeOffOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zm-176.34-64c-41.49 0-81.5-12.28-118.92-36.5-34.07-22-64.74-53.51-88.7-91v-.08c19.94-28.57 41.78-52.73 65.24-72.21a2 2 0 00.14-2.94L93.5 161.38a2 2 0 00-2.71-.12c-24.92 21-48.05 46.76-69.08 76.92a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416a239.13 239.13 0 0075.8-12.58 2 2 0 00.77-3.31l-21.58-21.58a4 4 0 00-3.83-1 204.8 204.8 0 01-51.16 6.47zm235.18-145.4c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96a227.34 227.34 0 00-74.89 12.83 2 2 0 00-.75 3.31l21.55 21.55a4 4 0 003.88 1 192.82 192.82 0 0150.21-6.69c40.69 0 80.58 12.43 118.55 37 34.71 22.4 65.74 53.88 89.76 91a.13.13 0 010 .16 310.72 310.72 0 01-64.12 72.73 2 2 0 00-.15 2.95l19.9 19.89a2 2 0 002.7.13 343.49 343.49 0 0068.64-78.48 32.2 32.2 0 00-.1-34.78z"}},{"tag":"path","attr":{"d":"M256 160a95.88 95.88 0 00-21.37 2.4 2 2 0 00-1 3.38l112.59 112.56a2 2 0 003.38-1A96 96 0 00256 160zm-90.22 73.66a2 2 0 00-3.38 1 96 96 0 00115 115 2 2 0 001-3.38z"}}]})(props);
	};
	module.exports.IoEyeOffSharp = function IoEyeOffSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M63.998 86.004l21.998-21.998L448 426.01l-21.998 21.998zM259.34 192.09l60.57 60.57a64.07 64.07 0 00-60.57-60.57zm-6.68 127.82l-60.57-60.57a64.07 64.07 0 0060.57 60.57z"}},{"tag":"path","attr":{"d":"M256 352a96 96 0 01-92.6-121.34l-69.07-69.08C66.12 187.42 39.24 221.14 16 256c26.42 44 62.56 89.24 100.2 115.18C159.38 400.92 206.33 416 255.76 416A233.47 233.47 0 00335 402.2l-53.61-53.6A95.84 95.84 0 01256 352zm0-192a96 96 0 0192.6 121.34L419.26 352c29.15-26.25 56.07-61.56 76.74-96-26.38-43.43-62.9-88.56-101.18-114.82C351.1 111.2 304.31 96 255.76 96a222.92 222.92 0 00-78.21 14.29l53.11 53.11A95.84 95.84 0 01256 160z"}}]})(props);
	};
	module.exports.IoEyeOff = function IoEyeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zM248 315.85l-51.79-51.79a2 2 0 00-3.39 1.69 64.11 64.11 0 0053.49 53.49 2 2 0 001.69-3.39zm16-119.7L315.87 248a2 2 0 003.4-1.69 64.13 64.13 0 00-53.55-53.55 2 2 0 00-1.72 3.39z"}},{"tag":"path","attr":{"d":"M491 273.36a32.2 32.2 0 00-.1-34.76c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.68 96a226.54 226.54 0 00-71.82 11.79 4 4 0 00-1.56 6.63l47.24 47.24a4 4 0 003.82 1.05 96 96 0 01116 116 4 4 0 001.05 3.81l67.95 68a4 4 0 005.4.24 343.81 343.81 0 0067.24-77.4zM256 352a96 96 0 01-93.3-118.63 4 4 0 00-1.05-3.81l-66.84-66.87a4 4 0 00-5.41-.23c-24.39 20.81-47 46.13-67.67 75.72a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.39 76.14 98.28 100.65C162.06 402 207.92 416 255.68 416a238.22 238.22 0 0072.64-11.55 4 4 0 001.61-6.64l-47.47-47.46a4 4 0 00-3.81-1.05A96 96 0 01256 352z"}}]})(props);
	};
	module.exports.IoEyeOutline = function IoEyeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 00-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 000-17.47C428.89 172.28 347.8 112 255.66 112z"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"80","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoEyeSharp = function IoEyeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"64"}},{"tag":"path","attr":{"d":"M394.82 141.18C351.1 111.2 304.31 96 255.76 96c-43.69 0-86.28 13-126.59 38.48C88.52 160.23 48.67 207 16 256c26.42 44 62.56 89.24 100.2 115.18C159.38 400.92 206.33 416 255.76 416c49 0 95.85-15.07 139.3-44.79C433.31 345 469.71 299.82 496 256c-26.38-43.43-62.9-88.56-101.18-114.82zM256 352a96 96 0 1196-96 96.11 96.11 0 01-96 96z"}}]})(props);
	};
	module.exports.IoEye = function IoEye (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"64"}},{"tag":"path","attr":{"d":"M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96c-42.52 0-84.33 12.15-124.27 36.11-40.73 24.43-77.63 60.12-109.68 106.07a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416c46.71 0 93.81-14.43 136.2-41.72 38.46-24.77 72.72-59.66 99.08-100.92a32.2 32.2 0 00-.1-34.76zM256 352a96 96 0 1196-96 96.11 96.11 0 01-96 96z"}}]})(props);
	};
	module.exports.IoEyedropOutline = function IoEyedropOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M262.51 204.22L70 396.69C57.56 409.15 48 464 48 464s54.38-9.09 67.31-22L307.8 249.51"}},{"tag":"rect","attr":{"width":"192.15","height":"64.05","x":"211.72","y":"172.19","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"32.03","ry":"32.03","transform":"rotate(45 307.788 204.2)"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M289.91 141s20.57 8.57 37.22-8.08l54.67-70.63c18.5-19.41 49.26-18.69 67.94 0h0c18.68 18.68 19.34 48.81 0 67.93l-70.68 54.67c-15.65 15.65-8.08 37.22-8.08 37.22M115.31 442s-26.48 17.34-44.56-.73-.75-44.58-.75-44.58"}}]})(props);
	};
	module.exports.IoEyedropSharp = function IoEyedropSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 96.22a63.84 63.84 0 00-18.95-45.61 65 65 0 00-45.71-19h-.76a61.78 61.78 0 00-44.22 19.09l-74.88 74.88-33.88-33.86-34.07 33.91-33.85 34 44 44L32 409.37V480h70.63l205.7-205.71L352 317.94l11.31-11.19c.11-.1 10.42-10.31 22.79-22.68l33.85-34-33.89-33.89L461 141.23a63.18 63.18 0 0019-45.01zM245 292.35L219.65 267l40.68-40.69 25.38 25.38z"}}]})(props);
	};
	module.exports.IoEyedrop = function IoEyedrop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.05 51a65 65 0 00-45.71-19h-.76a61.81 61.81 0 00-44.36 19.25 12.81 12.81 0 00-1.07 1.25l-54 69.76c-5.62 7.1-12.74 8.68-16.78 4.64l-1.9-1.9a48 48 0 00-67.92 67.92l9.91 9.91a2 2 0 010 2.83L58.7 385.38C54 390.05 46.9 399.85 38.85 431c-4.06 15.71-6.51 29.66-6.61 30.24A16 16 0 0048 480a15.68 15.68 0 002.64-.22c.58-.1 14.44-2.43 30.13-6.44 31.07-7.94 41.05-15.24 45.85-20l179.77-179.79a2 2 0 012.82 0l9.92 9.92a48 48 0 0067.92-67.93l-1.59-1.54c-5-5-2.52-12.11 4.32-17.14l69.75-53.94a17.82 17.82 0 001.47-1.32 63.2 63.2 0 0019-45A63.88 63.88 0 00461.05 51zM250.78 283.9c-2.92 2.92-16.18 7.92-23.39.71s-2.24-20.42.69-23.35l33-33a2 2 0 012.83 0l19.84 19.83a2 2 0 010 2.83z"}}]})(props);
	};
	module.exports.IoFastFoodOutline = function IoFastFoodOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M322 416c0 35.35-20.65 64-56 64H134c-35.35 0-56-28.65-56-64m258-80c17.67 0 32 17.91 32 40h0c0 22.09-14.33 40-32 40H64c-17.67 0-32-17.91-32-40h0c0-22.09 14.33-40 32-40"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M344 336H179.31a8 8 0 00-5.65 2.34l-26.83 26.83a4 4 0 01-5.66 0l-26.83-26.83a8 8 0 00-5.65-2.34H56a24 24 0 01-24-24h0a24 24 0 0124-24h288a24 24 0 0124 24h0a24 24 0 01-24 24zM64 276v-.22c0-55 45-83.78 100-83.78h72c55 0 100 29 100 84v-.22M241 112l7.44 63.97"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 480h139.31a32 32 0 0031.91-29.61L463 112"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M368 112l16-64 47-16"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M224 112h256"}}]})(props);
	};
	module.exports.IoFastFoodSharp = function IoFastFoodSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 352H184.36l-41 35-41-35H16v24c0 30.59 21.13 55.51 47.26 56 2.43 15.12 8.31 28.78 17.16 39.47C93.51 487.28 112.54 496 134 496h132c21.46 0 40.49-8.72 53.58-24.55 8.85-10.69 14.73-24.35 17.16-39.47 13.88-.25 26.35-7.4 35-18.63A61.26 61.26 0 00384 376zm-279-32l38.33 28.19L182 320h202v-8a40.07 40.07 0 00-32-39.2c-.82-29.69-13-54.54-35.51-72C295.67 184.56 267.85 176 236 176h-72c-68.22 0-114.43 38.77-116 96.8A40.07 40.07 0 0016 312v8h89z"}},{"tag":"path","attr":{"d":"M463.08 96h-74.59l8.92-35.66L442 45l-10-29-62 20-14.49 60H208v32h18.75l1.86 16H236c39 0 73.66 10.9 100.12 31.52A121.9 121.9 0 01371 218.07a124.16 124.16 0 0110.73 32.65 72 72 0 0127.89 90.9A96 96 0 01416 376c0 22.34-7.6 43.63-21.4 59.95a80 80 0 01-31.83 22.95 109.21 109.21 0 01-18.53 33c-1.18 1.42-2.39 2.81-3.63 4.15H416c16 0 23-8 25-23l36.4-345H496V96z"}}]})(props);
	};
	module.exports.IoFastFood = function IoFastFood (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 128h.09m111.46-32h-91.06l8.92-35.66 38.32-13.05c8.15-2.77 13-11.43 10.65-19.71a16 16 0 00-20.54-10.73l-47 16a16 16 0 00-10.36 11.27L355.51 96H224.45c-8.61 0-16 6.62-16.43 15.23A16 16 0 00224 128h2.75l1 8.66A8.3 8.3 0 00236 144c39 0 73.66 10.9 100.12 31.52A121.9 121.9 0 01371 218.07a123.4 123.4 0 0110.12 29.51 7.83 7.83 0 003.29 4.88 72 72 0 0126.38 86.43 7.92 7.92 0 00-.15 5.53A96 96 0 01416 376c0 22.34-7.6 43.63-21.4 59.95a80.12 80.12 0 01-28.78 21.67 8 8 0 00-4.21 4.37 108.19 108.19 0 01-17.37 29.86 2.5 2.5 0 001.9 4.11h49.21a48.22 48.22 0 0047.85-44.14L477.4 128h2.6a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"}},{"tag":"path","attr":{"d":"M108.69 320a23.87 23.87 0 0117 7l15.51 15.51a4 4 0 005.66 0L162.34 327a23.87 23.87 0 0117-7h196.58a8 8 0 008.08-7.92V312a40.07 40.07 0 00-32-39.2c-.82-29.69-13-54.54-35.51-72C295.67 184.56 267.85 176 236 176h-72c-68.22 0-114.43 38.77-116 96.8A40.07 40.07 0 0016 312a8 8 0 008 8zm77.25 32a8 8 0 00-5.66 2.34l-22.14 22.15a20 20 0 01-28.28 0l-22.14-22.15a8 8 0 00-5.66-2.34h-69.4a15.93 15.93 0 00-15.76 13.17A65.22 65.22 0 0016 376c0 30.59 21.13 55.51 47.26 56 2.43 15.12 8.31 28.78 17.16 39.47C93.51 487.28 112.54 496 134 496h132c21.46 0 40.49-8.72 53.58-24.55 8.85-10.69 14.73-24.35 17.16-39.47 26.13-.47 47.26-25.39 47.26-56a65.22 65.22 0 00-.9-10.83A15.93 15.93 0 00367.34 352z"}}]})(props);
	};
	module.exports.IoFemaleOutline = function IoFemaleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"184","r":"152","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 336v144m58-64H198"}}]})(props);
	};
	module.exports.IoFemaleSharp = function IoFemaleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M430 190c0-95.94-78.06-174-174-174S82 94.06 82 190c0 88.49 66.4 161.77 152 172.61V394h-58v44h58v58h44v-58h58v-44h-58v-31.39c85.6-10.84 152-84.12 152-172.61zm-304 0c0-71.68 58.32-130 130-130s130 58.32 130 130-58.32 130-130 130-130-58.32-130-130z"}}]})(props);
	};
	module.exports.IoFemale = function IoFemale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M430 190c0-95.94-78.06-174-174-174S82 94.06 82 190c0 88.49 66.4 161.77 152 172.61V394h-36a22 22 0 000 44h36v36a22 22 0 0044 0v-36h36a22 22 0 000-44h-36v-31.39c85.6-10.84 152-84.12 152-172.61zm-304 0c0-71.68 58.32-130 130-130s130 58.32 130 130-58.32 130-130 130-130-58.32-130-130z"}}]})(props);
	};
	module.exports.IoFileTrayFullOutline = function IoFileTrayFullOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M384 80H128c-26 0-43 14-48 40L48 272v112a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48V272l-32-152c-5-27-23-40-48-40z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 272h144m128 0h144m-272 0a64 64 0 00128 0M144 144h224m-240 64h256"}}]})(props);
	};
	module.exports.IoFileTrayFullSharp = function IoFileTrayFullSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 128h256v38H128zm-16 64h288v38H112z"}},{"tag":"path","attr":{"d":"M448 64H64L32 256v192h448V256zm-12 192H320a64 64 0 01-128 0H76l22-150h316z"}}]})(props);
	};
	module.exports.IoFileTrayFull = function IoFileTrayFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M479.66 268.7l-32-151.81C441.48 83.77 417.68 64 384 64H128c-16.8 0-31 4.69-42.1 13.94s-18.37 22.31-21.58 38.89l-32 151.87A16.65 16.65 0 0032 272v112a64 64 0 0064 64h320a64 64 0 0064-64V272a16.65 16.65 0 00-.34-3.3zm-384-145.4v-.28c3.55-18.43 13.81-27 32.29-27H384c18.61 0 28.87 8.55 32.27 26.91 0 .13.05.26.07.39l26.93 127.88a4 4 0 01-3.92 4.82H320a15.92 15.92 0 00-16 15.82 48 48 0 11-96 0A15.92 15.92 0 00192 256H72.65a4 4 0 01-3.92-4.82z"}},{"tag":"path","attr":{"d":"M368 160H144a16 16 0 010-32h224a16 16 0 010 32zm16 64H128a16 16 0 010-32h256a16 16 0 010 32z"}}]})(props);
	};
	module.exports.IoFileTrayOutline = function IoFileTrayOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M384 80H128c-26 0-43 14-48 40L48 272v112a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48V272l-32-152c-5-27-23-40-48-40z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 272h144m128 0h144m-272 0a64 64 0 00128 0"}}]})(props);
	};
	module.exports.IoFileTraySharp = function IoFileTraySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 64H64L32 256v192h448V256zm-12 192H320a64 64 0 01-128 0H76l22-150h316z"}}]})(props);
	};
	module.exports.IoFileTrayStackedOutline = function IoFileTrayStackedOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M48 336v96a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48v-96"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 336h144m128 0h144m-272 0a64 64 0 00128 0"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M384 32H128c-26 0-43 14-48 40L48 192v96a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48v-96L432 72c-5-27-23-40-48-40z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 192h144m128 0h144m-272 0a64 64 0 00128 0"}}]})(props);
	};
	module.exports.IoFileTrayStackedSharp = function IoFileTrayStackedSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 16H64L32 176v144h448V176zm-12 160H320a64 64 0 01-128 0H76L98 58h316zM320 352a64 64 0 01-128 0H32v144h448V352z"}}]})(props);
	};
	module.exports.IoFileTrayStacked = function IoFileTrayStacked (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 352H320a16 16 0 00-16 16 48 48 0 01-96 0 16 16 0 00-16-16H48a16 16 0 00-16 16v64a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64v-64a16 16 0 00-16-16zm15.46-164.12L447.61 68.45C441.27 35.59 417.54 16 384 16H128c-16.8 0-31 4.69-42.1 13.94S67.66 52 64.4 68.4L32.54 187.88A15.9 15.9 0 0032 192v48c0 35.29 28.71 80 64 80h320c35.29 0 64-44.71 64-80v-48a15.9 15.9 0 00-.54-4.12zM440.57 176H320a15.92 15.92 0 00-16 15.82 48 48 0 11-96 0A15.92 15.92 0 00192 176H71.43a2 2 0 01-1.93-2.52L95.71 75c3.55-18.41 13.81-27 32.29-27h256c18.59 0 28.84 8.53 32.25 26.85l26.25 98.63a2 2 0 01-1.93 2.52z"}}]})(props);
	};
	module.exports.IoFileTray = function IoFileTray (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M479.66 268.7l-32-151.81C441.48 83.77 417.68 64 384 64H128c-16.8 0-31 4.69-42.1 13.94s-18.37 22.31-21.58 38.89l-32 151.87A16.65 16.65 0 0032 272v112a64 64 0 0064 64h320a64 64 0 0064-64V272a16.65 16.65 0 00-.34-3.3zm-384-145.4v-.28c3.55-18.43 13.81-27 32.29-27H384c18.61 0 28.87 8.55 32.27 26.91 0 .13.05.26.07.39l26.93 127.88a4 4 0 01-3.92 4.82H320a15.92 15.92 0 00-16 15.82 48 48 0 11-96 0A15.92 15.92 0 00192 256H72.65a4 4 0 01-3.92-4.82z"}}]})(props);
	};
	module.exports.IoFilmOutline = function IoFilmOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"320","x":"48","y":"96","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"384","y":"336","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"384","y":"256","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"384","y":"176","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"384","y":"96","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"48","y":"336","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"48","y":"256","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"48","y":"176","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"48","y":"96","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}},{"tag":"rect","attr":{"width":"256","height":"160","x":"128","y":"96","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}},{"tag":"rect","attr":{"width":"256","height":"160","x":"128","y":"256","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"28","ry":"28"}}]})(props);
	};
	module.exports.IoFilmSharp = function IoFilmSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 80H32v352h448zM112 352v48H64v-48zm0-80v48H64v-48zm0-80v48H64v-48zm0-80v48H64v-48zm256 160H144v-32h224zm80 80v48h-48v-48zm0-80v48h-48v-48zm0-80v48h-48v-48zm0-80v48h-48v-48z"}}]})(props);
	};
	module.exports.IoFilm = function IoFilm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M436 80H76a44.05 44.05 0 00-44 44v264a44.05 44.05 0 0044 44h360a44.05 44.05 0 0044-44V124a44.05 44.05 0 00-44-44zM112 388a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm241.68 124H158.32a16 16 0 010-32h195.36a16 16 0 110 32zM448 388a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12z"}}]})(props);
	};
	module.exports.IoFilterCircleOutline = function IoFilterCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M144 208h224m-192 64h160m-112 64h64"}}]})(props);
	};
	module.exports.IoFilterCircleSharp = function IoFilterCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm48 304h-96v-32h96zm48-64H160v-32h192zm32-64H128v-32h256z"}}]})(props);
	};
	module.exports.IoFilterCircle = function IoFilterCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm32 304h-64a16 16 0 010-32h64a16 16 0 010 32zm48-64H176a16 16 0 010-32h160a16 16 0 010 32zm32-64H144a16 16 0 010-32h224a16 16 0 010 32z"}}]})(props);
	};
	module.exports.IoFilterOutline = function IoFilterOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M32 144h448M112 256h288M208 368h96"}}]})(props);
	};
	module.exports.IoFilterSharp = function IoFilterSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16 120h480v48H16zm80 112h320v48H96zm96 112h128v48H192z"}}]})(props);
	};
	module.exports.IoFilter = function IoFilter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M472 168H40a24 24 0 010-48h432a24 24 0 010 48zm-80 112H120a24 24 0 010-48h272a24 24 0 010 48zm-96 112h-80a24 24 0 010-48h80a24 24 0 010 48z"}}]})(props);
	};
	module.exports.IoFingerPrintOutline = function IoFingerPrintOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M390.42 75.28a10.45 10.45 0 01-5.32-1.44C340.72 50.08 302.35 40 256.35 40c-45.77 0-89.23 11.28-128.76 33.84C122 77 115.11 74.8 111.87 69a12.4 12.4 0 014.63-16.32A281.81 281.81 0 01256.35 16c49.23 0 92.23 11.28 139.39 36.48a12 12 0 014.85 16.08 11.3 11.3 0 01-10.17 6.72zm-330.79 126a11.73 11.73 0 01-6.7-2.16 12.26 12.26 0 01-2.78-16.8c22.89-33.6 52-60 86.69-78.48 72.58-38.84 165.51-39.12 238.32-.24 34.68 18.48 63.8 44.64 86.69 78a12.29 12.29 0 01-2.78 16.8 11.26 11.26 0 01-16.18-2.88c-20.8-30.24-47.15-54-78.36-70.56-66.34-35.28-151.18-35.28-217.29.24-31.44 16.8-57.79 40.8-78.59 71a10 10 0 01-9.02 5.08zM204.1 491a10.66 10.66 0 01-8.09-3.6C175.9 466.48 165 453 149.55 424c-16-29.52-24.27-65.52-24.27-104.16 0-71.28 58.71-129.36 130.84-129.36S387 248.56 387 319.84a11.56 11.56 0 11-23.11 0c0-58.08-48.32-105.36-107.72-105.36S148.4 261.76 148.4 319.84c0 34.56 7.39 66.48 21.49 92.4 14.8 27.6 25 39.36 42.77 58.08a12.67 12.67 0 010 17 12.44 12.44 0 01-8.56 3.68zm165.75-44.4c-27.51 0-51.78-7.2-71.66-21.36a129.1 129.1 0 01-55-105.36 11.57 11.57 0 1123.12 0 104.28 104.28 0 0044.84 85.44c16.41 11.52 35.6 17 58.72 17a147.41 147.41 0 0024-2.4c6.24-1.2 12.25 3.12 13.4 9.84a11.92 11.92 0 01-9.47 13.92 152.28 152.28 0 01-27.95 2.88zM323.38 496a13 13 0 01-3-.48c-36.76-10.56-60.8-24.72-86-50.4-32.37-33.36-50.16-77.76-50.16-125.28 0-38.88 31.9-70.56 71.19-70.56s71.2 31.68 71.2 70.56c0 25.68 21.5 46.56 48.08 46.56s48.08-20.88 48.08-46.56c0-90.48-75.13-163.92-167.59-163.92-65.65 0-125.75 37.92-152.79 96.72-9 19.44-13.64 42.24-13.64 67.2 0 18.72 1.61 48.24 15.48 86.64 2.32 6.24-.69 13.2-6.7 15.36a11.34 11.34 0 01-14.79-7 276.39 276.39 0 01-16.88-95c0-28.8 5.32-55 15.72-77.76 30.75-67 98.94-110.4 173.6-110.4 105.18 0 190.71 84.24 190.71 187.92 0 38.88-31.9 70.56-71.2 70.56s-71.2-31.68-71.2-70.56c.01-25.68-21.49-46.6-48.07-46.6s-48.08 20.88-48.08 46.56c0 41 15.26 79.44 43.23 108.24 22 22.56 43 35 75.59 44.4 6.24 1.68 9.71 8.4 8.09 14.64a11.39 11.39 0 01-10.87 9.16z"}}]})(props);
	};
	module.exports.IoFingerPrintSharp = function IoFingerPrintSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M56.79 200.58l12.36 7.5 7.35-13.58C93.07 166.75 143.78 102 256 102c115 0 164 70.32 180.1 93.46l8.16 12.7L469.88 192l-8.54-13.36c-8.88-12.85-27.52-39.53-60.78-63.1C360.15 86.82 311.5 72.25 256 72.25c-128.07 0-186.69 75.11-206 107.25L42.63 192 54 198.86a14.09 14.09 0 001.63 1.1 12.57 12.57 0 001.16.62z"}},{"tag":"path","attr":{"d":"M379.22 172.32c-35.54-28.93-78.12-44.25-123.22-44.25-97.52 0-162.31 66-183.33 131.47C53.42 320 76.82 407.61 77.8 411.36l4.38 13.81 29.93-6.43-4.74-15c-.21-.75-22.1-82.93-5.41-135.21 9-28.08 27.73-55.4 51.35-74.79C181.81 170.39 217.35 158 256 158c90.58 0 141.93 70.61 156.45 108.11 11.27 28.93 8.67 61.82-6.28 82-5.53 7.39-15.28 16.07-30.12 15.32-33.81-1.72-39.66-18.43-47.79-50.25-3.9-15.32-7.9-31.18-17.87-44-12.14-15.75-29.8-23.36-54.28-23.36-26.33 0-46.27 8.68-59.38 25.72-28.6 37.28-10 100.93-9.21 103.61l.22.85c1.41 3.86 36.08 96.65 128.93 119.68l14.77 3.21 8.09-28.71-15.27-3.43c-74.22-18.43-105.21-94.39-107.59-100.39a152.44 152.44 0 01-5.1-29.79c-1.08-14.46-.32-34.39 9.43-47.14 7.15-9.32 18.64-13.82 35-13.82 29.79 0 34.78 14.57 42.58 44.79 7.58 29.46 18 69.85 75.84 72.75 22.21 1.07 42.26-8.79 56.34-27.65 21.13-28.28 25.14-71.57 10.19-110.14-11.68-30.36-34.21-60.54-61.73-83.04z"}},{"tag":"path","attr":{"d":"M154.18 343.21c-3.47-28.28 1.41-71 26.55-98.78 17.44-19.29 42.79-29 75.19-29 37.49 0 65.87 16.72 84.51 49.61a154 154 0 0117.88 53.25l1.43 14.69 30-2.2a112.63 112.63 0 00-1-15.6c-.11-1.28-3.57-32.46-21-63.75-24.06-43.11-62.63-65.93-111.74-65.93-41.5 0-74.55 13.18-98.06 39.11-31.85 35.14-38.35 86.25-33.91 122.35v.33c7.97 54.53 28.97 98.14 66.12 137.14l11.6 11.22 20.95-21.79-10.34-9.79c-32.72-34.28-51.25-72.64-58.18-120.86zM132.47 72.66c11.08-6.72 50.27-26.77 123.53-26.77 87.54 0 126.44 28.72 126.87 28.93l13.9 8.86L413 58.47l-13.22-8.56c-.52-.38-1.06-.76-1.6-1.12C385.5 40.54 340.54 16 256 16c-87.71 0-132.75 26.48-143.41 33.71L99 58.52l16.2 25.21z"}},{"tag":"path","attr":{"d":"M390.59 415.21c-33.37 3.75-60.45-2.67-80.71-18.85-34.24-27.43-38.68-75.11-38.79-76l-1.23-14.88-30.53 2.23 1.31 15c.22 2.46 5.2 60.75 49.62 96.54 22.11 17.89 49.74 26.89 82.24 26.89a187 187 0 0021.56-1.29l16.59-2.09-6.1-29.71z"}}]})(props);
	};
	module.exports.IoFingerPrint = function IoFingerPrint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M63.28 202a15.29 15.29 0 01-7.7-2 14.84 14.84 0 01-5.52-20.46C69.34 147.36 128 72.25 256 72.25c55.47 0 104.12 14.57 144.53 43.29 33.26 23.57 51.9 50.25 60.78 63.1a14.79 14.79 0 01-4 20.79 15.52 15.52 0 01-21.24-4C420 172.32 371 102 256 102c-112.25 0-163 64.71-179.53 92.46A15 15 0 0163.28 202z"}},{"tag":"path","attr":{"d":"M320.49 496a15.31 15.31 0 01-3.79-.43c-92.85-23-127.52-115.82-128.93-119.68l-.22-.85c-.76-2.68-19.39-66.33 9.21-103.61 13.11-17 33.05-25.72 59.38-25.72 24.48 0 42.14 7.61 54.28 23.36 10 12.86 14 28.72 17.87 44 8.13 31.82 14 48.53 47.79 50.25 14.84.75 24.59-7.93 30.12-15.32 14.95-20.15 17.55-53 6.28-82C398 228.57 346.61 158 256 158c-38.68 0-74.22 12.43-102.72 35.79-23.59 19.35-42.28 46.67-51.28 74.75-16.69 52.28 5.2 134.46 5.41 135.21A14.83 14.83 0 0196.54 422a15.39 15.39 0 01-18.74-10.6c-1-3.75-24.38-91.4-5.1-151.82 21-65.47 85.81-131.47 183.33-131.47 45.07 0 87.65 15.32 123.19 44.25 27.52 22.5 50 52.72 61.76 82.93 14.95 38.57 10.94 81.86-10.19 110.14-14.08 18.86-34.13 28.72-56.34 27.65-57.86-2.9-68.26-43.29-75.84-72.75-7.8-30.22-12.79-44.79-42.58-44.79-16.36 0-27.85 4.5-35 13.82-9.75 12.75-10.51 32.68-9.43 47.14a152.44 152.44 0 005.1 29.79c2.38 6 33.37 82 107.59 100.39a14.88 14.88 0 0111 18.11 15.36 15.36 0 01-14.8 11.21z"}},{"tag":"path","attr":{"d":"M201.31 489.14a15.5 15.5 0 01-11.16-4.71c-37.16-39-58.18-82.61-66.09-137.14V347c-4.44-36.1 2.06-87.21 33.91-122.35 23.51-25.93 56.56-39.11 98.06-39.11 49.08 0 87.65 22.82 111.7 65.89 17.45 31.29 20.91 62.47 21 63.75a15.07 15.07 0 01-13.65 16.4 15.26 15.26 0 01-16.79-13.29A154 154 0 00340.43 265c-18.64-32.89-47-49.61-84.51-49.61-32.4 0-57.75 9.75-75.19 29-25.14 27.75-30 70.5-26.55 98.78 6.93 48.22 25.46 86.58 58.18 120.86a14.7 14.7 0 01-.76 21.11 15.44 15.44 0 01-10.29 4z"}},{"tag":"path","attr":{"d":"M372.5 446.18c-32.5 0-60.13-9-82.24-26.89-44.42-35.79-49.4-94.08-49.62-96.54a15.27 15.27 0 0130.45-2.36c.11.86 4.55 48.54 38.79 76 20.26 16.18 47.34 22.6 80.71 18.85a15.2 15.2 0 0116.91 13.18 14.92 14.92 0 01-13.44 16.5 187 187 0 01-21.56 1.26zm25.68-397.39C385.5 40.54 340.54 16 256 16c-88.74 0-133.81 27.11-143.78 34a11.59 11.59 0 00-1.84 1.4.36.36 0 01-.22.1 14.87 14.87 0 00-5.09 11.15 15.06 15.06 0 0015.31 14.85 15.56 15.56 0 008.88-2.79c.43-.32 39.22-28.82 126.77-28.82S382.58 74.29 383 74.5a15.25 15.25 0 009.21 3 15.06 15.06 0 0015.29-14.89 14.9 14.9 0 00-9.32-13.82z"}}]})(props);
	};
	module.exports.IoFishOutline = function IoFishOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M240 152c-50.71 12.21-94.15 52.31-120.3 73.43a261.14 261.14 0 00-23.81-19.58C59.53 179.29 16 176 16 176s11.37 51.53 41.36 79.83C27.37 284.14 16 335.67 16 335.67s43.53-3.29 79.89-29.85a259.18 259.18 0 0023.61-19.41c26.1 21.14 69.74 61.34 120.5 73.59l-16 56c39.43-6.67 78.86-35.51 94.72-48.25C448 362 496 279 496 256c0-22-48-106-176.89-111.73C303.52 131.78 263.76 102.72 224 96z"}},{"tag":"circle","attr":{"cx":"416","cy":"239.99","r":"16"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"20","strokeWidth":"32","d":"M378.37 356a199.22 199.22 0 010-200"}}]})(props);
	};
	module.exports.IoFishSharp = function IoFishSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M335.45 256a214.83 214.83 0 0129.08-108l7.62-13.26a280.69 280.69 0 00-48.64-7.15c-21.94-16.9-54.64-36.95-92.34-43.33L208 80l13.37 61.86c-41.67 14.14-78.43 42.86-102.76 62.62q-7.06-5.91-14.78-11.55c-39.71-29-82.6-31.8-84.4-31.9L0 160l2.67 19.31c.29 2 6.79 44.73 31.65 76.52C9.46 287.63 3 330.33 2.67 332.36L0 352l19.43-1.36c1.8-.1 44.69-2.89 84.4-31.9q7.58-5.53 14.56-11.37c24.37 19.83 61.14 48.6 102.86 62.74L208 432l23.17-4.22c37.49-6.34 70.08-26.4 92-43.32a284.27 284.27 0 0049.32-7.23l-7.91-13.18A214.92 214.92 0 01335.45 256z"}},{"tag":"path","attr":{"d":"M499.59 221.75c-5.85-9.88-16.54-24.9-34.19-40.28a209.82 209.82 0 00-62-37L392.23 164a183.22 183.22 0 00-.09 183.87l11.75 19.57a209.26 209.26 0 0061.42-36.49C497.05 303.47 512 269 512 256c0-12.31-8-26.74-12.41-34.25zM416 256a16 16 0 1116-16 16 16 0 01-16 16z"}}]})(props);
	};
	module.exports.IoFish = function IoFish (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 256c0-16.54-14.27-46.76-45.61-74a207.06 207.06 0 00-60.28-36.12 3.15 3.15 0 00-3.93 1.56c-.15.29-.3.57-.47.86l-9.59 15.9a183.24 183.24 0 00.07 183.78l.23.39 8.74 16a4 4 0 004.94 1.82C479.63 337.42 512 281.49 512 256zm-93.92-.14a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79z"}},{"tag":"path","attr":{"d":"M335.45 256a214.8 214.8 0 0129.08-108l.12-.21 4.62-7.67a4 4 0 00-2.59-6 284.29 284.29 0 00-39.26-5.39 7.94 7.94 0 01-4.29-1.6c-19.28-14.66-57.5-40.3-96.46-46.89a16 16 0 00-18 20.18l10.62 37.17a4 4 0 01-2.42 4.84c-36.85 13.69-68.59 38.75-91.74 57.85a8 8 0 01-10.06.06q-4.72-3.75-9.69-7.39c-39.64-28.95-86.21-32.76-88.17-32.9a16 16 0 00-16.83 19.4c.42 1.93 9.19 40.69 31.7 71.61a8.09 8.09 0 010 9.55C9.57 291.52.8 330.29.38 332.22a16 16 0 0016.83 19.4c2-.14 48.53-4 88.12-32.88q4.85-3.56 9.47-7.22a8 8 0 0110.06.07c23.25 19.19 55.05 44.28 92 58a4 4 0 012.42 4.83l-10.66 37.18a16 16 0 0018 20.18c17.16-2.9 51.88-12.86 96.05-46.83a8.15 8.15 0 014.36-1.65 287.36 287.36 0 0039.22-5.3 4 4 0 002.69-5.83l-4.51-8.29A214.81 214.81 0 01335.45 256z"}}]})(props);
	};
	module.exports.IoFitnessOutline = function IoFitnessOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 256h112l48-96 48 160 48-96 32 64h128"}}]})(props);
	};
	module.exports.IoFitnessSharp = function IoFitnessSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 272h-37.34a261.41 261.41 0 01-18.25 32H480zM32 240v32h37.34a225.1 225.1 0 01-12.4-32z"}},{"tag":"path","attr":{"d":"M304 259.78l-51.73 103.46-48-160L169.89 272H69.34c10 20.92 23.5 41.41 40.63 61.68 40.12 47.46 94.25 79.75 137 108.32l9 6 9-6c42.78-28.57 96.91-60.86 137-108.32A322.78 322.78 0 00424.41 304h-98.3z"}},{"tag":"path","attr":{"d":"M211.73 116.76l48 160L304 188.22 345.89 272h96.77A213.13 213.13 0 00464 176.65C463.37 114.54 413.54 64 352.92 64c-48.11 0-80.1 28-96.92 48.21C239.18 92 207.19 64 159.08 64 98.46 64 48.63 114.54 48 176.65A211.23 211.23 0 0056.94 240h93.17z"}}]})(props);
	};
	module.exports.IoFitness = function IoFitness (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M193.69 152.84a16 16 0 0129.64 2.56l36.4 121.36 30-59.92a16 16 0 0128.62 0L345.89 272h96.76A213.08 213.08 0 00464 176.65C463.37 114.54 413.54 64 352.92 64c-48.09 0-80 29.54-96.92 51-16.88-21.49-48.83-51-96.92-51C98.46 64 48.63 114.54 48 176.65A211.13 211.13 0 0056.93 240h93.18z"}},{"tag":"path","attr":{"d":"M321.69 295.16L304 259.78l-33.69 67.38A16 16 0 01256 336q-.67 0-1.38-.06a16 16 0 01-14-11.34l-36.4-121.36-30 59.92A16 16 0 01160 272H69.35q14 29.29 37.27 57.66c18.77 22.88 52.8 59.46 131.39 112.81a31.84 31.84 0 0036 0c78.59-53.35 112.62-89.93 131.39-112.81a316.79 316.79 0 0019-25.66H336a16 16 0 01-14.31-8.84zM464 272h-21.35a260.11 260.11 0 01-18.25 32H464a16 16 0 000-32zM48 240a16 16 0 000 32h21.35a225.22 225.22 0 01-12.42-32z"}}]})(props);
	};
	module.exports.IoFlagOutline = function IoFlagOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M80 464V68.14a8 8 0 014-6.9C91.81 56.66 112.92 48 160 48c64 0 145 48 192 48a199.53 199.53 0 0077.23-15.77 2 2 0 012.77 1.85v219.36a4 4 0 01-2.39 3.65C421.37 308.7 392.33 320 352 320c-48 0-128-32-192-32s-80 16-80 16"}}]})(props);
	};
	module.exports.IoFlagSharp = function IoFlagSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M102 480H64V57.37l4.69-4.68C72.14 49.23 92.78 32 160 32c37.21 0 78.83 14.71 115.55 27.68C305.12 70.13 333.05 80 352 80c42.83 0 72.72-14.25 73-14.4l23-11.14v259.43l-8.84 4.42C437.71 319 403.19 336 352 336c-24.14 0-54.38-7.14-86.39-14.71C229.63 312.79 192.43 304 160 304c-36.87 0-49.74 5.58-58 9.11z"}}]})(props);
	};
	module.exports.IoFlag = function IoFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 480a16 16 0 01-16-16V68.13a24 24 0 0111.9-20.72C88 40.38 112.38 32 160 32c37.21 0 78.83 14.71 115.55 27.68C305.12 70.13 333.05 80 352 80a183.84 183.84 0 0071-14.5 18 18 0 0125 16.58v219.36a20 20 0 01-12 18.31c-8.71 3.81-40.51 16.25-84 16.25-24.14 0-54.38-7.14-86.39-14.71C229.63 312.79 192.43 304 160 304c-36.87 0-55.74 5.58-64 9.11V464a16 16 0 01-16 16z"}}]})(props);
	};
	module.exports.IoFlameOutline = function IoFlameOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 320c0-93 124-165 96-272 66 0 192 96 192 272a144 144 0 01-288 0z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 368c0 57.71-32 80-64 80s-64-22.29-64-80 40-86 32-128c42 0 96 70.29 96 128z"}}]})(props);
	};
	module.exports.IoFlameSharp = function IoFlameSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M394.24 197.56a300.67 300.67 0 00-53.38-90C301.2 61.65 240 32 192 32c19 70-14.36 117.12-44.79 163.77C122 234.36 96 274.27 96 320c0 88.22 71.78 160 160 160s160-71.78 160-160c0-43.3-7.32-84.49-21.76-122.44zM288.33 418.69C278 429.69 265.05 432 256 432s-22-2.31-32.33-13.31S208 390.24 208 368c0-25.14 8.82-44.28 17.34-62.78 6.48-14.07 14.66-27.22 15.11-44.49 11.3 5.88 23.67 16.91 34.54 31.28 18.17 24 29 52.42 29 76 .01 22.23-5.41 39.76-15.66 50.68z"}}]})(props);
	};
	module.exports.IoFlame = function IoFlame (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M394.23 197.56a300.43 300.43 0 00-53.37-90C301.2 61.65 249.05 32 208 32a16 16 0 00-15.48 20c13.87 53-14.88 97.07-45.31 143.72C122 234.36 96 274.27 96 320c0 88.22 71.78 160 160 160s160-71.78 160-160c0-43.3-7.32-84.49-21.77-122.44zm-105.9 221.13C278 429.69 265.05 432 256 432s-22-2.31-32.33-13.31S208 390.24 208 368c0-25.14 8.82-44.28 17.34-62.78 4.95-10.74 10-21.67 13-33.37a8 8 0 0112.49-4.51A126.48 126.48 0 01275 292c18.17 24 29 52.42 29 76 0 22.24-5.42 39.77-15.67 50.69z"}}]})(props);
	};
	module.exports.IoFlashOffOutline = function IoFlashOffOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zM294.34 84.28l-22.08 120.84a16 16 0 006.17 15.71 16.49 16.49 0 009.93 3.17h94.12l-38.37 47.42a4 4 0 00.28 5.34l17.07 17.07a4 4 0 005.94-.31l60.8-75.16a16.37 16.37 0 003.3-14.36 16 16 0 00-15.5-12H307.19L335.4 37.63c.05-.3.1-.59.13-.89A18.45 18.45 0 00302.73 23l-92.58 114.46a4 4 0 00.28 5.35l17.07 17.06a4 4 0 005.94-.31zm-76.56 343.29l22-120.71a16 16 0 00-6.19-15.7 16.54 16.54 0 00-9.92-3.16h-94.1l38.36-47.42a4 4 0 00-.28-5.34l-17.07-17.07a4 4 0 00-5.93.31L83.8 293.64A16.37 16.37 0 0080.5 308 16 16 0 0096 320h108.83l-28.09 154.36v.11a18.37 18.37 0 0032.5 14.53l92.61-114.46a4 4 0 00-.28-5.35l-17.07-17.06a4 4 0 00-5.94.31z"}}]})(props);
	};
	module.exports.IoFlashOffSharp = function IoFlashOffSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M63.998 86.004l21.998-21.998L448 426.01l-21.998 21.998zM80 304h144l-32 192 108.18-129.82-148.36-148.36L80 304zm352-96H288l32-192-108.18 129.82 148.36 148.36L432 208z"}}]})(props);
	};
	module.exports.IoFlashOff = function IoFlashOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zm-.5-244a16 16 0 00-15.5-12H307.19L335.4 37.63c.05-.3.1-.59.13-.89A18.45 18.45 0 00302.73 23l-92.58 114.46a4 4 0 00.29 5.35l151 151a4 4 0 005.94-.31l60.8-75.16A16.37 16.37 0 00431.5 204zM301.57 369.19l-151-151a4 4 0 00-5.93.31L83.8 293.64A16.37 16.37 0 0080.5 308 16 16 0 0096 320h108.83l-28.09 154.36v.11a18.37 18.37 0 0032.5 14.53l92.61-114.46a4 4 0 00-.28-5.35z"}}]})(props);
	};
	module.exports.IoFlashOutline = function IoFlashOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M315.27 33L96 304h128l-31.51 173.23a2.36 2.36 0 002.33 2.77h0a2.36 2.36 0 001.89-.95L416 208H288l31.66-173.25a2.45 2.45 0 00-2.44-2.75h0a2.42 2.42 0 00-1.95 1z"}}]})(props);
	};
	module.exports.IoFlashSharp = function IoFlashSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 208H288l32-192L80 304h144l-32 192z"}}]})(props);
	};
	module.exports.IoFlash = function IoFlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M194.82 496a18.36 18.36 0 01-18.1-21.53v-.11L204.83 320H96a16 16 0 01-12.44-26.06L302.73 23a18.45 18.45 0 0132.8 13.71c0 .3-.08.59-.13.89L307.19 192H416a16 16 0 0112.44 26.06L209.24 489a18.45 18.45 0 01-14.42 7z"}}]})(props);
	};
	module.exports.IoFlashlightOutline = function IoFlashlightOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M456.64 162.86L349.12 55.36c-13.15-13.14-28.68-7.17-41.82 6l-11.95 12c-26.13 26.13-27.62 58.38-29.42 83.31-.89 12.24-9.78 27.55-18.51 36.28L58.58 381.67c-16.35 16.33-12.69 39.42 3.73 55.84l12.17 12.17c16.36 16.35 39.43 20.16 55.86 3.74l188.83-188.8c8.74-8.74 24-17.55 36.29-18.52 24.87-1.86 58.62-4.85 83.26-29.49l11.94-11.94c13.15-13.14 19.12-28.67 5.98-41.81z"}},{"tag":"circle","attr":{"cx":"224.68","cy":"287.28","r":"20"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M289 81l142 142"}}]})(props);
	};
	module.exports.IoFlashlightSharp = function IoFlashlightSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M330 16l-42.68 42.7L453.3 224.68 496 182 330 16z"}},{"tag":"ellipse","attr":{"cx":"224.68","cy":"287.3","fill":"none","rx":"20.03","ry":"19.96"}},{"tag":"path","attr":{"d":"M429.21 243.85L268 82.59 249.65 168 16 402l94 94 234.23-233.8zm-189 56.07a20 20 0 110-25.25 20 20 0 01-.02 25.25z"}}]})(props);
	};
	module.exports.IoFlashlight = function IoFlashlight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462 216c9.35-9.35 15.14-19.09 17.19-28.95 2.7-12.95-1.29-25.55-11.22-35.48L360.43 44.05C346.29 29.92 322 24.07 296 50l-2 2a8 8 0 000 11.32L448.64 218a8 8 0 0011.36 0zm-211.86-62.92l-.16 2.34c-.53 7.18-6.88 19.15-13.88 26.14L47.27 370.36c-11.12 11.11-16.46 25.57-15.05 40.7C33.49 424.58 40.16 438 51 448.83L63.17 461c12.61 12.6 27.78 19 42.49 19a50.4 50.4 0 0036-15.24l188.84-188.8c7.07-7.07 18.84-13.3 26.17-13.87 17.48-1.32 43.57-3.28 67.79-15.65a4 4 0 001-6.37L271.69 86.31a4 4 0 00-6.39 1c-12.12 22.99-13.82 46.91-15.16 65.77zm-9.95 146.83a20 20 0 110-25.25 20 20 0 010 25.25z"}}]})(props);
	};
	module.exports.IoFlaskOutline = function IoFlaskOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M176 48h160M118 304h276M208 48v93.48a64.09 64.09 0 01-9.88 34.18L73.21 373.49C48.4 412.78 76.63 464 123.08 464h265.84c46.45 0 74.68-51.22 49.87-90.51L313.87 175.66a64.09 64.09 0 01-9.87-34.18V48"}}]})(props);
	};
	module.exports.IoFlaskSharp = function IoFlaskSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M469.11 382.76L325 153.92V74h32V32H155v42h32v79.92L42.89 382.76c-13 20.64-14.78 43.73-3 65.1S71.59 480 96 480h320c24.41 0 44.32-10.76 56.1-32.14s10.04-44.46-2.99-65.1zM224.39 173.39a29.76 29.76 0 004.62-16V74h54v84.59a25.85 25.85 0 004 13.82L356.82 283H155.18z"}}]})(props);
	};
	module.exports.IoFlask = function IoFlask (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M452.32 365L327.4 167.12a48.07 48.07 0 01-7.4-25.64V64h15.56c8.61 0 16-6.62 16.43-15.23A16 16 0 00336 32H176.45c-8.61 0-16 6.62-16.43 15.23A16 16 0 00176 64h16v77.48a47.92 47.92 0 01-7.41 25.63L59.68 365a74 74 0 00-2.5 75.84C70.44 465.19 96.36 480 124.13 480h263.74c27.77 0 53.69-14.81 66.95-39.21a74 74 0 00-2.5-75.79zM211.66 184.2A79.94 79.94 0 00224 141.48V68a4 4 0 014-4h56a4 4 0 014 4v73.48a79.94 79.94 0 0012.35 42.72l57.8 91.53a8 8 0 01-6.78 12.27H160.63a8 8 0 01-6.77-12.27z"}}]})(props);
	};
	module.exports.IoFlowerOutline = function IoFlowerOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M215.08 156.92c-4.89-24-10.77-56.27-10.77-73.23A51.36 51.36 0 01256 32h0c28.55 0 51.69 23.69 51.69 51.69 0 16.5-5.85 48.95-10.77 73.23m-81.84 198.16c-4.91 24.06-10.77 56.16-10.77 73.23A51.36 51.36 0 00256 480h0c28.55 0 51.69-23.69 51.69-51.69 0-16.54-5.85-48.93-10.77-73.23m58.16-140c24.06-4.91 56.16-10.77 73.23-10.77A51.36 51.36 0 01480 256h0c0 28.55-23.69 51.69-51.69 51.69-16.5 0-48.95-5.85-73.23-10.77m-198.16-81.85c-24-4.89-56.25-10.76-73.23-10.76A51.36 51.36 0 0032 256h0c0 28.55 23.69 51.69 51.69 51.69 16.5 0 48.95-5.85 73.23-10.77"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M296.92 156.92c13.55-20.48 32.3-47.25 44.37-59.31a51.35 51.35 0 0173.1 0h0c20.19 20.19 19.8 53.3 0 73.1-11.66 11.67-38.67 30.67-59.31 44.37m-198.16 81.84c-20.48 13.55-47.25 32.3-59.31 44.37a51.35 51.35 0 000 73.1h0c20.19 20.19 53.3 19.8 73.1 0 11.67-11.66 30.67-38.67 44.37-59.31m140-58.16c20.48 13.55 47.25 32.3 59.31 44.37a51.35 51.35 0 010 73.1h0c-20.19 20.19-53.3 19.8-73.1 0-11.69-11.69-30.66-38.65-44.37-59.31m-81.84-198.16c-13.53-20.43-32.38-47.32-44.37-59.31a51.35 51.35 0 00-73.1 0h0c-20.19 20.19-19.8 53.3 0 73.1 11.61 11.61 38.7 30.68 59.31 44.37"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"64","fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoFlowerSharp = function IoFlowerSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"43"}},{"tag":"path","attr":{"d":"M475.93 303.91a67.49 67.49 0 00-47.62-115.6c-2.88 0-6.2.14-9.93.43 2.75-2.36 5.23-4.62 7.33-6.71A67.83 67.83 0 00378 66.33h-.25a67.27 67.27 0 00-47.82 20c-2.11 2.11-4.37 4.59-6.72 7.33.29-3.75.44-7.07.44-9.93a67.69 67.69 0 10-135.38 0c0 2.87.15 6.19.44 9.93-2.36-2.74-4.62-5.22-6.72-7.33a67.27 67.27 0 00-47.82-20H134A67.9 67.9 0 0086.29 182c2.1 2.09 4.58 4.35 7.34 6.72-3.74-.29-7.06-.44-9.94-.44a67.69 67.69 0 000 135.38c2.86 0 6.18-.15 9.93-.44-2.74 2.35-5.22 4.61-7.33 6.72a67.55 67.55 0 0047.82 115.42h.25A67.32 67.32 0 00182 425.71c2.09-2.1 4.35-4.58 6.71-7.33-.28 3.73-.43 7.05-.43 9.93a67.69 67.69 0 00135.38 0c0-2.87-.15-6.19-.44-9.94 2.36 2.75 4.62 5.24 6.72 7.34a67.32 67.32 0 0047.67 19.68h.25A67.5 67.5 0 00425.71 330c-2.11-2.11-4.59-4.37-7.33-6.72 3.75.29 7.07.44 9.93.44a67.27 67.27 0 0047.62-19.81zM256 341a85 85 0 1185-85 85.1 85.1 0 01-85 85z"}}]})(props);
	};
	module.exports.IoFlower = function IoFlower (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"48"}},{"tag":"path","attr":{"d":"M475.93 303.91a67.49 67.49 0 00-44.34-115.53 5.2 5.2 0 01-4.58-3.21 5.21 5.21 0 011-5.51A67.83 67.83 0 00378 66.33h-.25A67.13 67.13 0 00332.35 84a5.21 5.21 0 01-5.52 1 5.23 5.23 0 01-3.22-4.58 67.68 67.68 0 00-135.23 0 5.2 5.2 0 01-3.21 4.58 5.21 5.21 0 01-5.52-1 67.11 67.11 0 00-45.44-17.69H134a67.91 67.91 0 00-50 113.34 5.21 5.21 0 011 5.51 5.2 5.2 0 01-4.58 3.21 67.71 67.71 0 000 135.23 5.23 5.23 0 014.58 3.23 5.22 5.22 0 01-1 5.52 67.54 67.54 0 0050.08 113h.25A67.38 67.38 0 00179.65 428a5.21 5.21 0 015.51-1 5.2 5.2 0 013.21 4.58 67.71 67.71 0 00135.23 0 5.23 5.23 0 013.22-4.58 5.21 5.21 0 015.51 1 67.38 67.38 0 0045.29 17.42h.25a67.48 67.48 0 0050.08-113 5.22 5.22 0 01-1-5.52 5.23 5.23 0 014.58-3.22 67.31 67.31 0 0044.4-19.77zM256 336a80 80 0 1180-80 80.09 80.09 0 01-80 80z"}}]})(props);
	};
	module.exports.IoFolderOpenOutline = function IoFolderOpenOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M64 192v-72a40 40 0 0140-40h75.89a40 40 0 0122.19 6.72l27.84 18.56a40 40 0 0022.19 6.72H408a40 40 0 0140 40v40"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M479.9 226.55L463.68 392a40 40 0 01-39.93 40H88.25a40 40 0 01-39.93-40L32.1 226.55A32 32 0 0164 192h384.1a32 32 0 0131.8 34.55z"}}]})(props);
	};
	module.exports.IoFolderOpenSharp = function IoFolderOpenSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16.08 189.4l28.58 233.87A28 28 0 0072.52 448h367a28 28 0 0027.86-24.73l28.54-233.87A12 12 0 00484 176H28a12 12 0 00-11.92 13.4zM464 124a28 28 0 00-28-28H244.84l-48-32H76a28 28 0 00-28 28v52h416z"}}]})(props);
	};
	module.exports.IoFolderOpen = function IoFolderOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408 96H252.11a23.89 23.89 0 01-13.31-4L211 73.41A55.77 55.77 0 00179.89 64H104a56.06 56.06 0 00-56 56v24h416c0-30.88-25.12-48-56-48zm15.75 352H88.25a56 56 0 01-55.93-55.15L16.18 228.11v-.28A48 48 0 0164 176h384.1a48 48 0 0147.8 51.83v.28l-16.22 164.74A56 56 0 01423.75 448zm56.15-221.45z"}}]})(props);
	};
	module.exports.IoFolderOutline = function IoFolderOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M440 432H72a40 40 0 01-40-40V120a40 40 0 0140-40h75.89a40 40 0 0122.19 6.72l27.84 18.56a40 40 0 0022.19 6.72H440a40 40 0 0140 40v240a40 40 0 01-40 40zM32 192h448"}}]})(props);
	};
	module.exports.IoFolderSharp = function IoFolderSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16 420a28 28 0 0028 28h424a28 28 0 0028-28V208H16zm480-296a28 28 0 00-28-28H212.84l-48-32H44a28 28 0 00-28 28v84h480z"}}]})(props);
	};
	module.exports.IoFolder = function IoFolder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 152a56 56 0 00-56-56H220.11a23.89 23.89 0 01-13.31-4L179 73.41A55.77 55.77 0 00147.89 64H72a56 56 0 00-56 56v48a8 8 0 008 8h464a8 8 0 008-8zM16 392a56 56 0 0056 56h368a56 56 0 0056-56V216a8 8 0 00-8-8H24a8 8 0 00-8 8z"}}]})(props);
	};
	module.exports.IoFootballOutline = function IoFootballOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"192","fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 175.15l-76.09 63.83L200 320h112l20.09-81.02L256 175.15zm76.09 63.83l52.87-22.4 25.78-73.26M447 269.97l-62.04-53.39m-205.05 22.4l-52.87-22.4-25.78-73.26M65 269.97l62.04-53.39M256 175.15v-57.57l64-42.64m-128-.01l64 42.65M312 320l28 48-28 71m98.74-71H342m-142-48l-28 48 28.37 71.5M101.63 368H172"}}]})(props);
	};
	module.exports.IoFootballSharp = function IoFootballSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm140.64 296.08h-46.77l-16.89-29 15-60.44L377.79 242l42.65 36.71a164.87 164.87 0 01-23.8 65.37zM134.21 242L164 254.67l15 60.44-16.89 29h-46.75a164.87 164.87 0 01-23.8-65.34zm249.07-92.47l-18.41 52.33-31.12 13.18L277 167.46v-35l43.86-29.22a166.87 166.87 0 0162.42 46.32zM191.14 103.2L235 132.42v35l-56.75 47.61-31.12-13.18-18.41-52.33a166.87 166.87 0 0162.42-46.32zm26.44 314.3l-20.1-50.66 16-27.51h85l16.06 27.53-20 50.6a166.23 166.23 0 01-77 0z"}}]})(props);
	};
	module.exports.IoFootball = function IoFootball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm143 304h-45.22a8 8 0 01-6.91-4l-16.14-27.68a8 8 0 01-.86-6l14.86-59.92a8 8 0 014.65-5.45l28.1-11.9a8 8 0 018.34 1.3l41.63 35.82a8 8 0 012.69 7.26 174.75 174.75 0 01-24.28 66.68A8 8 0 01399 352zM134.52 237.13l28.1 11.9a8 8 0 014.65 5.45l14.86 59.92a8 8 0 01-.86 6L165.13 348a8 8 0 01-6.91 4H113a8 8 0 01-6.82-3.81 174.75 174.75 0 01-24.28-66.68 8 8 0 012.69-7.26l41.63-35.82a8 8 0 018.3-1.3zm256.94-87.24l-18.07 51.38A8 8 0 01369 206l-29.58 12.53a8 8 0 01-8.26-1.24L274.9 170.1a8 8 0 01-2.9-6.1v-33.58a8 8 0 013.56-6.65l42.83-28.54a8 8 0 017.66-.67A176.92 176.92 0 01390 142a8 8 0 011.46 7.89zM193.6 95.23l42.84 28.54a8 8 0 013.56 6.65V164a8 8 0 01-2.86 6.13l-56.26 47.19a8 8 0 01-8.26 1.24L143 206a8 8 0 01-4.43-4.72L120.5 149.9a8 8 0 011.5-7.9 176.92 176.92 0 0164-47.48 8 8 0 017.6.71zm17.31 327.46L191.18 373a8 8 0 01.52-7l15.17-26a8 8 0 016.91-4h84.44a8 8 0 016.91 4l15.18 26a8 8 0 01.53 7l-19.59 49.67a8 8 0 01-5.69 4.87 176.58 176.58 0 01-79 0 8 8 0 01-5.65-4.85z"}}]})(props);
	};
	module.exports.IoFootstepsOutline = function IoFootstepsOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M200 246.84c8.81 58.62-7.33 90.67-52.91 97.41-50.65 7.49-71.52-26.44-80.33-85.06-11.85-78.88 16-127.94 55.71-131.1 36.14-2.87 68.71 60.14 77.53 118.75zm23.65 162.69c3.13 33.28-14.86 64.34-42 69.66-27.4 5.36-58.71-16.37-65.09-49.19s17.75-34.56 47.32-40.21 55.99-20.4 59.77 19.74zM312 150.83c-8.81 58.62 7.33 90.67 52.9 97.41 50.66 7.49 71.52-26.44 80.33-85.06 11.86-78.89-16-128.22-55.7-131.1-36.4-2.64-68.71 60.13-77.53 118.75zm-23.65 162.7c-3.13 33.27 14.86 64.34 42 69.66 27.4 5.36 58.71-16.37 65.09-49.19s-17.75-34.56-47.32-40.22-55.99-20.4-59.77 19.75z"}}]})(props);
	};
	module.exports.IoFootstepsSharp = function IoFootstepsSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M130.54 358.31c-12.83 1.88-33.95 5.38-48-10.56S56.34 293.32 51 258.92c-7.88-50.7-.06-93.43 22-120.31 13-15.83 30.06-25 49.34-26.46 16.51-1.27 41.18 5.19 65 43.19 14.92 23.81 26.27 55.44 31.14 86.77 5.88 37.82 11.61 78.18-8.44 92.65-11.31 8.17-19.43 11-38.62 15.57-15.78 3.75-28.04 6.09-40.88 7.98zm-22.82 32.53l108.89-22.46c9.2-1.9 16.58 3.16 20 18.32 11.22 49.76-4.86 109.3-55.22 109.3-47.69 0-79.47-54.36-84.66-83.58-2.37-13.25 1.01-19.53 10.99-21.58zm232.87-136.5c-19.19-4.55-27.31-7.4-38.62-15.57-20.05-14.47-14.32-54.83-8.44-92.65 4.87-31.33 16.22-63 31.14-86.77 23.8-38 48.47-44.46 65-43.19C408.93 17.63 426 26.78 439 42.61c22.08 26.88 29.9 69.61 22 120.31-5.35 34.4-17.46 72.76-31.59 88.83s-35.13 12.44-48 10.56-25.05-4.23-40.82-7.97zm63.69 40.5l-108.89-22.46c-9.2-1.9-16.58 3.16-20 18.32-11.21 49.76 4.87 109.3 55.23 109.3 47.69 0 79.47-54.36 84.66-83.58 2.36-13.25-1.02-19.53-11-21.58z"}}]})(props);
	};
	module.exports.IoFootsteps = function IoFootsteps (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M133.83 361.27c-22.61 0-41-8.17-54.79-24.39s-22.84-40.29-28.11-75.31c-7.76-51.61-.06-95.11 21.68-122.48 12.8-16.12 29.6-25.44 48.58-26.94 16.25-1.3 40.54 5.29 64 44 14.69 24.24 25.86 56.44 30.65 88.34 5.79 38.51 1.48 66.86-13.18 86.65-11.64 15.72-29.54 25.46-53.21 29a106.46 106.46 0 01-15.62 1.13zM173 496c-13.21 0-26.6-4.23-38.66-12.36a79.79 79.79 0 01-33.52-50.6c-2.85-14.66-1.14-26.31 5.22-35.64 10.33-15.15 28.87-18.56 48.49-22.18 2.07-.38 4.17-.76 6.3-1.17 4.52-.86 9.14-2 13.62-3.11 16.78-4.14 34.14-8.43 48.47 1.75 9.59 6.8 15 18.36 16.62 35.32 1.84 19.57-2.36 39.1-11.83 55-10.19 17.11-25.47 28.42-43 31.86A61 61 0 01173 496zm205.17-230.73a106.69 106.69 0 01-15.6-1.2c-23.66-3.5-41.56-13.25-53.2-29-14.66-19.79-19-48.13-13.18-86.65 4.79-31.93 15.93-64.1 30.55-88.25 23.34-38.57 47.66-45.26 64-44.08 18.92 1.38 35.69 10.57 48.51 26.6 21.89 27.37 29.65 71 21.86 122.84-5.27 35-14.2 58.95-28.11 75.31s-32.22 24.43-54.83 24.43zM339 400a61 61 0 01-11.68-1.13c-17.56-3.44-32.84-14.75-43-31.86-9.47-15.9-13.67-35.43-11.83-55 1.6-17 7-28.52 16.62-35.33 14.33-10.17 31.69-5.89 48.47-1.74 4.48 1.1 9.1 2.24 13.62 3.11l6.29 1.17c19.63 3.61 38.17 7 48.5 22.17 6.36 9.33 8.07 21 5.22 35.64a79.78 79.78 0 01-33.52 50.61C365.56 395.78 352.17 400 339 400z"}}]})(props);
	};
	module.exports.IoFunnelOutline = function IoFunnelOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M35.4 87.12l168.65 196.44A16.07 16.07 0 01208 294v119.32a7.93 7.93 0 005.39 7.59l80.15 26.67A7.94 7.94 0 00304 440V294a16.07 16.07 0 014-10.44L476.6 87.12A14 14 0 00466 64H46.05A14 14 0 0035.4 87.12z"}}]})(props);
	};
	module.exports.IoFunnelSharp = function IoFunnelSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 48l192 240v128l128 48V288L512 48H0z"}}]})(props);
	};
	module.exports.IoFunnel = function IoFunnel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M296 464a23.88 23.88 0 01-7.55-1.23L208.3 436.1a23.92 23.92 0 01-16.3-22.78V294.11a.44.44 0 00-.09-.13L23.26 97.54A30 30 0 0146.05 48H466a30 30 0 0122.79 49.54L320.09 294a.77.77 0 00-.09.13V440a23.93 23.93 0 01-24 24z"}}]})(props);
	};
	module.exports.IoGameControllerOutline = function IoGameControllerOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M467.51 248.83c-18.4-83.18-45.69-136.24-89.43-149.17A91.5 91.5 0 00352 96c-26.89 0-48.11 16-96 16s-69.15-16-96-16a99.09 99.09 0 00-27.2 3.66C89 112.59 61.94 165.7 43.33 248.83c-19 84.91-15.56 152 21.58 164.88 26 9 49.25-9.61 71.27-37 25-31.2 55.79-40.8 119.82-40.8s93.62 9.6 118.66 40.8c22 27.41 46.11 45.79 71.42 37.16 41.02-14.01 40.44-79.13 21.43-165.04z"}},{"tag":"circle","attr":{"cx":"292","cy":"224","r":"20"}},{"tag":"path","attr":{"d":"M336 288a20 20 0 1120-19.95A20 20 0 01336 288z"}},{"tag":"circle","attr":{"cx":"336","cy":"180","r":"20"}},{"tag":"circle","attr":{"cx":"380","cy":"224","r":"20"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 176v96m48-48h-96"}}]})(props);
	};
	module.exports.IoGameControllerSharp = function IoGameControllerSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M478.07 356.88L439 151c-8.86-40.35-23-71-88-71H145c-66 0-79.14 30.65-88 71L18 356.88c-7 34.12 4.43 61.25 33.37 71.81S103 423 119.18 391.3l15.42-30.52a16 16 0 0114.28-8.78h198.28a16 16 0 0114.28 8.78l15.42 30.52c16.14 31.7 38.88 48 67.81 37.39S485 391 478.07 356.88zM224 240h-48v48h-32v-48H96v-32h48v-48h32v48h48zm68 4a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-20 20 20 0 01-20 20zm0-88a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-20 20 20 0 01-20 20z"}}]})(props);
	};
	module.exports.IoGameController = function IoGameController (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M483.13 245.38C461.92 149.49 430 98.31 382.65 84.33A107.13 107.13 0 00352 80c-13.71 0-25.65 3.34-38.28 6.88C298.5 91.15 281.21 96 256 96s-42.51-4.84-57.76-9.11C185.6 83.34 173.67 80 160 80a115.74 115.74 0 00-31.73 4.32c-47.1 13.92-79 65.08-100.52 161C4.61 348.54 16 413.71 59.69 428.83a56.62 56.62 0 0018.64 3.22c29.93 0 53.93-24.93 70.33-45.34 18.53-23.1 40.22-34.82 107.34-34.82 59.95 0 84.76 8.13 106.19 34.82 13.47 16.78 26.2 28.52 38.9 35.91 16.89 9.82 33.77 12 50.16 6.37 25.82-8.81 40.62-32.1 44-69.24 2.57-28.48-1.39-65.89-12.12-114.37zM208 240h-32v32a16 16 0 01-32 0v-32h-32a16 16 0 010-32h32v-32a16 16 0 0132 0v32h32a16 16 0 010 32zm84 4a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-19.95A20 20 0 01336 288zm0-88a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-20 20 20 0 01-20 20z"}}]})(props);
	};
	module.exports.IoGiftOutline = function IoGiftOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 104v56h56a56 56 0 10-56-56zm0 0v56h-56a56 56 0 1156-56z"}},{"tag":"rect","attr":{"width":"384","height":"112","x":"64","y":"160","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"32","ry":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M416 272v144a48 48 0 01-48 48H144a48 48 0 01-48-48V272m160-112v304"}}]})(props);
	};
	module.exports.IoGiftSharp = function IoGiftSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M346 110a34 34 0 00-68 0v34h34a34 34 0 0034-34zm-112 0a34 34 0 10-34 34h34z"}},{"tag":"path","attr":{"d":"M234 144h44v112h164a22 22 0 0022-22v-68a22 22 0 00-22-22h-59.82A77.95 77.95 0 00256 55.79 78 78 0 00129.81 144H70a22 22 0 00-22 22v68a22 22 0 0022 22h164zm44-34a34 34 0 1134 34h-34zm-112 0a34 34 0 1168 0v34h-34a34 34 0 01-34-34zm112 370h132a22 22 0 0022-22V288H278zM80 458a22 22 0 0022 22h132V288H80z"}}]})(props);
	};
	module.exports.IoGift = function IoGift (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M200 144h40v-40a40 40 0 10-40 40zm152-40a40 40 0 00-80 0v40h40a40 40 0 0040-40z"}},{"tag":"path","attr":{"d":"M80 416a64 64 0 0064 64h92a4 4 0 004-4V292a4 4 0 00-4-4H88a8 8 0 00-8 8zm160-164V144h32v108a4 4 0 004 4h140a47.93 47.93 0 0016-2.75A48.09 48.09 0 00464 208v-16a48 48 0 00-48-48h-40.54a2 2 0 01-1.7-3A72 72 0 00256 58.82 72 72 0 00138.24 141a2 2 0 01-1.7 3H96a48 48 0 00-48 48v16a48.09 48.09 0 0032 45.25A47.93 47.93 0 0096 256h140a4 4 0 004-4zm32-148a40 40 0 1140 40h-40zm-74.86-39.9A40 40 0 01240 104v40h-40a40 40 0 01-2.86-79.89zM276 480h92a64 64 0 0064-64V296a8 8 0 00-8-8H276a4 4 0 00-4 4v184a4 4 0 004 4z"}}]})(props);
	};
	module.exports.IoGitBranchOutline = function IoGitBranchOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"160","cy":"96","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"160","cy":"416","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 368V144"}},{"tag":"circle","attr":{"cx":"352","cy":"160","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 208c0 128-192 48-192 160"}}]})(props);
	};
	module.exports.IoGitBranchSharp = function IoGitBranchSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 96a64 64 0 00-58.86 89.11l-101.14 88V151.39a64 64 0 10-64 0v209.22a64 64 0 1064 0V358l154.25-134.27c1.9.17 3.81.27 5.75.27a64 64 0 000-128zM160 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm192-256a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoGitBranch = function IoGitBranch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 160a64 64 0 10-96.27 55.24c-2.29 29.08-20.08 37-75 48.42-17.76 3.68-35.93 7.45-52.71 13.93v-126.2a64 64 0 10-64 0v209.22a64 64 0 1064.42.24c2.39-18 16-24.33 65.26-34.52 27.43-5.67 55.78-11.54 79.78-26.95 29-18.58 44.53-46.78 46.36-83.89A64 64 0 00416 160zM160 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm192-256a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoGitCommitOutline = function IoGitCommitOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"96","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 256H48m416 0H352"}}]})(props);
	};
	module.exports.IoGitCommitSharp = function IoGitCommitSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 224H380a128 128 0 00-247.9 0H32v64h100.05A128 128 0 00380 288h100zm-224 96a64 64 0 1164-64 64.07 64.07 0 01-64 64z"}}]})(props);
	};
	module.exports.IoGitCommit = function IoGitCommit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 224h-68a128 128 0 00-247.9 0H64a32 32 0 000 64h68.05A128 128 0 00380 288h68a32 32 0 000-64zm-192 96a64 64 0 1164-64 64.07 64.07 0 01-64 64z"}}]})(props);
	};
	module.exports.IoGitCompareOutline = function IoGitCompareOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M304 160l-64-64 64-64m-97 320l64 64-64 64"}},{"tag":"circle","attr":{"cx":"112","cy":"96","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"400","cy":"416","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 96h84a60 60 0 0160 60v212m-145 48h-84a60 60 0 01-60-60V144"}}]})(props);
	};
	module.exports.IoGitCompareSharp = function IoGitCompareSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M209 384h-37a28 28 0 01-28-28V152a64 64 0 10-64-1.16V356a92.1 92.1 0 0092 92h37v55.21L294.39 416 209 328.79zM113 64a32 32 0 11-32 32 32 32 0 0132-32zm319 296.61V156a92.1 92.1 0 00-92-92h-35V9.93L217.14 96 305 182.07V128h35a28 28 0 0128 28v204.61a64 64 0 1064 0zM400 448a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoGitCompare = function IoGitCompare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M218.31 340.69A16 16 0 00191 352v32h-20a28 28 0 01-28-28V152a64 64 0 10-64-1.16V356a92.1 92.1 0 0092 92h20v32a16 16 0 0027.31 11.31l64-64a16 16 0 000-22.62zM112 64a32 32 0 11-32 32 32 32 0 0132-32zm320 296.61V156a92.1 92.1 0 00-92-92h-20V32a16 16 0 00-27.31-11.31l-64 64a16 16 0 000 22.62l64 64A16 16 0 00320 160v-32h20a28 28 0 0128 28v204.61a64 64 0 1064 0zM400 448a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoGitMergeOutline = function IoGitMergeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"129","cy":"96","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"129","cy":"416","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M129 144v224"}},{"tag":"circle","attr":{"cx":"385","cy":"288","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M129 144c0 96 112 144 208 144"}}]})(props);
	};
	module.exports.IoGitMergeSharp = function IoGitMergeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 224a63.66 63.66 0 00-37.95 12.5L160 153.36v-2a64 64 0 10-64 0v209.25a64 64 0 1064 0V223.46l160.41 71.69A64 64 0 10384 224zM128 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm256-128a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoGitMerge = function IoGitMerge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M385 224a64 64 0 00-55.33 31.89c-42.23-1.21-85.19-12.72-116.21-31.33-32.2-19.32-49.71-44-52.15-73.35a64 64 0 10-64.31.18v209.22a64 64 0 1064 0v-94.46c44.76 34 107.28 52.38 168.56 53.76A64 64 0 10385 224zM129 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm256-128a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoGitNetworkOutline = function IoGitNetworkOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"128","cy":"96","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"416","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 256v112"}},{"tag":"circle","attr":{"cx":"384","cy":"96","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M128 144c0 74.67 68.92 112 128 112m128-112c0 74.67-68.92 112-128 112"}}]})(props);
	};
	module.exports.IoGitNetworkSharp = function IoGitNetworkSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 32a64 64 0 00-57.67 91.73l-70.83 80.82-70.19-80.1A64 64 0 10128 160c1.1 0 2.2 0 3.29-.08L224 265.7v94.91a64 64 0 1064 0v-96.05l91.78-104.71c1.39.09 2.8.15 4.22.15a64 64 0 000-128zM96 96a32 32 0 1132 32 32 32 0 01-32-32zm160 352a32 32 0 1132-32 32 32 0 01-32 32zm128-320a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoGitNetwork = function IoGitNetwork (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 96a64 64 0 10-96.31 55.21c-1.79 20.87-11.47 38.1-28.87 51.29C305.07 216 280.09 224 256 224s-49.07-8-66.82-21.5c-17.4-13.19-27.08-30.42-28.87-51.29a64 64 0 10-64.11.29c2.08 40.87 21.17 76.87 54.31 102C171.3 269.26 197 280.19 224 285.09v75.52a64 64 0 1064 0v-75.52c27-4.9 52.7-15.83 73.49-31.59 33.14-25.13 52.23-61.13 54.31-102A64 64 0 00448 96zM128 64a32 32 0 11-32 32 32 32 0 0132-32zm128 384a32 32 0 1132-32 32 32 0 01-32 32zm128-320a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoGitPullRequestOutline = function IoGitPullRequestOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"128","cy":"416","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M128 144v224m160-208l-64-64 64-64"}},{"tag":"circle","attr":{"cx":"128","cy":"96","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"384","cy":"416","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M240 96h84a60 60 0 0160 60v212"}}]})(props);
	};
	module.exports.IoGitPullRequestSharp = function IoGitPullRequestSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 96a64 64 0 10-97 54.81v209.8a64 64 0 1064 0V152a64.06 64.06 0 0033-56zm-64-32a32 32 0 11-32 32 32 32 0 0132-32zm-1 384a32 32 0 1132-32 32 32 0 01-32 32zm289-87.39V156a92.1 92.1 0 00-92-92h-35V9.93L201.14 96 289 182.07V128h35a28 28 0 0128 28v204.61a64 64 0 1064 0zM384 448a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoGitPullRequest = function IoGitPullRequest (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 96a64 64 0 10-96 55.39v209.22a64 64 0 1064 0V151.39A64 64 0 00192 96zm-64-32a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm288-87.39V156a92.1 92.1 0 00-92-92h-20V32a16 16 0 00-27.31-11.31l-64 64a16 16 0 000 22.62l64 64A16 16 0 00304 160v-32h20a28 28 0 0128 28v204.61a64 64 0 1064 0zM384 448a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoGlassesOutline = function IoGlassesOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M224 232a32 32 0 0164 0m160-32h16m-400 0H48m16 0c0 96 16 128 80 128s80-32 80-128c0 0-16-16-80-16s-80 16-80 16zm384 0c0 96-16 128-80 128s-80-32-80-128c0 0 16-16 80-16s80 16 80 16z"}}]})(props);
	};
	module.exports.IoGlassesSharp = function IoGlassesSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 176H16v64h21.24l12.44 112h171.87L240 241.32V240a16 16 0 0132 0v1.32L290.45 352h171.87l12.44-112H496z"}}]})(props);
	};
	module.exports.IoGlasses = function IoGlasses (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 184h-10.9a78.72 78.72 0 00-16-7.18C419.5 171 396.26 168 368 168s-51.5 3-69.06 8.82c-14.06 4.69-20.25 9.86-22.25 11.87a47.94 47.94 0 00-41.36 0c-2-2-8.19-7.18-22.25-11.87C195.5 171 172.26 168 144 168s-51.5 3-69.06 8.82a78.72 78.72 0 00-16 7.18H48a16 16 0 000 32h.17c1 45.46 6.44 72.78 18.11 92.23a66.78 66.78 0 0031.92 28c12.23 5.24 27.22 7.79 45.8 7.79 24.15 0 58.48-3.71 77.72-35.77 9.68-16.14 15.09-37.69 17.21-70.52A16 16 0 00240 232a16 16 0 0132 0 16 16 0 001.07 5.71c2.12 32.83 7.53 54.38 17.21 70.52a66.78 66.78 0 0031.92 28c12.23 5.24 27.22 7.79 45.8 7.79 24.15 0 58.48-3.71 77.72-35.77 11.67-19.45 17.13-46.77 18.11-92.23h.17a16 16 0 000-32z"}}]})(props);
	};
	module.exports.IoGlobeOutline = function IoGlobeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 48c-58.07 0-112.67 93.13-112.67 208S197.93 464 256 464s112.67-93.13 112.67-208S314.07 48 256 48z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M117.33 117.33c38.24 27.15 86.38 43.34 138.67 43.34s100.43-16.19 138.67-43.34m0 277.34c-38.24-27.15-86.38-43.34-138.67-43.34s-100.43 16.19-138.67 43.34"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 48v416m208-208H48"}}]})(props);
	};
	module.exports.IoGlobeSharp = function IoGlobeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"44","d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"44","d":"M256 48c-58.07 0-112.67 93.13-112.67 208S197.93 464 256 464s112.67-93.13 112.67-208S314.07 48 256 48z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"44","d":"M117.33 121.33c38.24 27.15 86.38 43.34 138.67 43.34s100.43-16.19 138.67-43.34m0 269.34c-38.24-27.15-86.38-43.34-138.67-43.34s-100.43 16.19-138.67 43.34"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"44","d":"M256 48v416m208-208H48"}}]})(props);
	};
	module.exports.IoGlobe = function IoGlobe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M340.75 344.49c5.91-20.7 9.82-44.75 11.31-67.84a4.41 4.41 0 00-4.46-4.65h-71.06a4.43 4.43 0 00-4.47 4.39v55.3a4.44 4.44 0 004.14 4.38 273.51 273.51 0 0159 11.39 4.45 4.45 0 005.54-2.97zm-17.17 32.82a260.05 260.05 0 00-46.6-9.09 4.42 4.42 0 00-4.91 4.29v65.24a4.47 4.47 0 006.76 3.7c15.9-9.27 29-24.84 40.84-45.43 1.94-3.36 4.89-9.15 6.67-12.69a4.29 4.29 0 00-2.76-6.02zm-88.29-8.91a256.85 256.85 0 00-46.56 8.82c-2.64.76-3.75 4.4-2.55 6.79 1.79 3.56 4 8.11 5.89 11.51 13 23 26.84 37.5 41.24 45.93a4.47 4.47 0 006.76-3.7v-65.27a4.16 4.16 0 00-4.78-4.08zm.31-96.4h-71.06a4.41 4.41 0 00-4.46 4.64c1.48 23.06 5.37 47.16 11.26 67.84a4.46 4.46 0 005.59 3 272.2 272.2 0 0159-11.36 4.44 4.44 0 004.15-4.38V276.4a4.43 4.43 0 00-4.48-4.4zM277 143.78a235.8 235.8 0 0046.5-9.14 4.3 4.3 0 002.76-6c-1.79-3.57-4.27-8.68-6.17-12.09-12.29-22-26.14-37.35-41.24-46a4.48 4.48 0 00-6.76 3.7v65.23a4.43 4.43 0 004.91 4.3zm-.46 96.22h71.06a4.39 4.39 0 004.46-4.58c-1.48-22.77-5.27-47.8-11.16-68.22a4.46 4.46 0 00-5.59-2.95c-19 5.74-38.79 10.43-59.09 12a4.4 4.4 0 00-4.15 4.32v55.11a4.4 4.4 0 004.47 4.32zM233.31 70.56c-15.42 8.57-29.17 24.43-41.47 46.37-1.91 3.41-4.19 8.11-6 11.67a4.31 4.31 0 002.76 6 225.42 225.42 0 0046.54 9.17 4.43 4.43 0 004.91-4.29V74.26a4.49 4.49 0 00-6.74-3.7zm2.61 105.7c-20.3-1.55-40.11-6.24-59.09-12a4.46 4.46 0 00-5.59 2.95c-5.89 20.42-9.68 45.45-11.16 68.22a4.39 4.39 0 004.46 4.58h71.06a4.4 4.4 0 004.47-4.34v-55.09a4.4 4.4 0 00-4.15-4.32z"}},{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM176.6 430.85a219.08 219.08 0 01-12.48-19.66c-2-3.69-4.84-9.26-6.73-13.13a7.29 7.29 0 00-10.31-3.16c-4.3 2.41-10 5.72-14.13 8.43a147.29 147.29 0 01-23.57-22.43 248.83 248.83 0 0130.41-18.36c1.86-1 2.77-2.14 2.18-4.18a374.8 374.8 0 01-14.09-82.17 4.36 4.36 0 00-4.3-4.17H66.84a2 2 0 01-2-1.7A98.28 98.28 0 0164 256a96.27 96.27 0 01.86-14.29 2 2 0 012-1.7h56.74c2.29 0 4.17-1.32 4.29-3.63a372.71 372.71 0 0114-81.83 4.36 4.36 0 00-2.19-5.11 260.63 260.63 0 01-29.84-17.9 169.82 169.82 0 0123.14-22.8c4.08 2.68 9.4 5.71 13.66 8.11a7.89 7.89 0 0011-3.42c1.88-3.87 4-8.18 6.06-11.88a221.93 221.93 0 0112.54-19.91A185 185 0 01256 64c28.94 0 55.9 7 80.53 18.46a202.23 202.23 0 0112 19c2.59 4.66 5.34 10.37 7.66 15.32a4.29 4.29 0 005.92 1.94c5.38-2.91 11.21-6.26 16.34-9.63a171.36 171.36 0 0123.2 23 244.89 244.89 0 01-29.06 17.31 4.35 4.35 0 00-2.18 5.12 348.68 348.68 0 0113.85 81.4 4.33 4.33 0 004.3 4.12l56.62-.07a2 2 0 012 1.7 117.46 117.46 0 010 28.62 2 2 0 01-2 1.72h-56.67a4.35 4.35 0 00-4.3 4.17 367.4 367.4 0 01-13.87 81.3 4.45 4.45 0 002.19 5.19c5 2.59 10.57 5.48 15.37 8.42s9.55 6.08 14.13 9.34a172.73 172.73 0 01-23 22.93c-2.44-1.61-5.34-3.44-7.84-4.94-1.72-1-4.89-2.77-6.65-3.76-3.82-2.14-7.88-.54-9.79 3.4s-4.83 9.59-6.87 13.25a212.42 212.42 0 01-12.35 19.53C310.91 442.37 284.94 448 256 448s-54.77-5.63-79.4-17.15z"}}]})(props);
	};
	module.exports.IoGolfOutline = function IoGolfOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 400V32l176 80-176 80"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 336c-87 0-175.3 43.2-191.64 124.74C62.39 470.57 68.57 480 80 480h352c11.44 0 17.62-9.43 15.65-19.26C431.3 379.2 343 336 256 336z"}}]})(props);
	};
	module.exports.IoGolfSharp = function IoGolfSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M240 16v304.47q8-.47 16-.47t16 .47V202.3L448 112z"}},{"tag":"path","attr":{"d":"M462.91 457.5c-8.54-42.85-35-78.74-76.62-103.8-32.43-19.55-72.53-31.3-114.29-33.7v95.79h-32V320c-41.79 2.4-81.89 14.15-114.32 33.7-41.59 25.06-68.08 60.95-76.62 103.8-2 9.81-.68 38.5-.68 38.5h415.21s1.28-28.69-.68-38.5z"}}]})(props);
	};
	module.exports.IoGolf = function IoGolf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 320.46V202.3l166.62-75.73a16 16 0 000-29.14l-176-80A16 16 0 00240 32v288.46q8-.45 16-.46t16 .46z"}},{"tag":"path","attr":{"d":"M463.33 457.5c-8.56-42.85-35.11-78.74-76.78-103.8-32.5-19.55-72.67-31.3-114.55-33.7v79.75a16 16 0 11-32 0V320c-41.88 2.4-82.05 14.15-114.55 33.7-41.67 25.06-68.22 60.95-76.78 103.8a32.49 32.49 0 006.44 27.08C61.13 492 70 496 80 496h352c10 0 18.88-4.05 24.9-11.42a32.49 32.49 0 006.43-27.08z"}}]})(props);
	};
	module.exports.IoGridOutline = function IoGridOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"176","height":"176","x":"48","y":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"20","ry":"20"}},{"tag":"rect","attr":{"width":"176","height":"176","x":"288","y":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"20","ry":"20"}},{"tag":"rect","attr":{"width":"176","height":"176","x":"48","y":"288","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"20","ry":"20"}},{"tag":"rect","attr":{"width":"176","height":"176","x":"288","y":"288","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"20","ry":"20"}}]})(props);
	};
	module.exports.IoGridSharp = function IoGridSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M240 240H32V32h208zm240 0H272V32h208zM240 480H32V272h208zm240 0H272V272h208z"}}]})(props);
	};
	module.exports.IoGrid = function IoGrid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M204 240H68a36 36 0 01-36-36V68a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zm240 0H308a36 36 0 01-36-36V68a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zM204 480H68a36 36 0 01-36-36V308a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zm240 0H308a36 36 0 01-36-36V308a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36z"}}]})(props);
	};
	module.exports.IoHammerOutline = function IoHammerOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M277.42 247a24.68 24.68 0 00-4.08-5.47L255 223.44a21.63 21.63 0 00-6.56-4.57 20.93 20.93 0 00-23.28 4.27c-6.36 6.26-18 17.68-39 38.43C146 301.3 71.43 367.89 37.71 396.29a16 16 0 00-1.09 23.54l39 39.43a16.13 16.13 0 0023.67-.89c29.24-34.37 96.3-109 136-148.23 20.39-20.06 31.82-31.58 38.29-37.94a21.76 21.76 0 003.84-25.2zm201.01-46l-34.31-34a5.44 5.44 0 00-4-1.59 5.59 5.59 0 00-4 1.59h0a11.41 11.41 0 01-9.55 3.27c-4.48-.49-9.25-1.88-12.33-4.86-7-6.86 1.09-20.36-5.07-29a242.88 242.88 0 00-23.08-26.72c-7.06-7-34.81-33.47-81.55-52.53a123.79 123.79 0 00-47-9.24c-26.35 0-46.61 11.76-54 18.51-5.88 5.32-12 13.77-12 13.77a91.29 91.29 0 0110.81-3.2 79.53 79.53 0 0123.28-1.49C241.19 76.8 259.94 84.1 270 92c16.21 13 23.18 30.39 24.27 52.83.8 16.69-15.23 37.76-30.44 54.94a7.85 7.85 0 00.4 10.83l21.24 21.23a8 8 0 0011.14.1c13.93-13.51 31.09-28.47 40.82-34.46s17.58-7.68 21.35-8.09a35.71 35.71 0 0121.3 4.62 13.65 13.65 0 013.08 2.38c6.46 6.56 6.07 17.28-.5 23.74l-2 1.89a5.5 5.5 0 000 7.84l34.31 34a5.5 5.5 0 004 1.58 5.65 5.65 0 004-1.58L478.43 209a5.82 5.82 0 000-8z"}}]})(props);
	};
	module.exports.IoHammerSharp = function IoHammerSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M294.28 256.9l-54.42-54.41a12 12 0 00-17 0L12.45 401a12 12 0 00-.27 17.2l66.05 66.28a12 12 0 0017.22-.23l198.81-210.36a12 12 0 00.02-16.99zm205.05-57.57l-43.89-43.58a21.46 21.46 0 00-15.28-6.26 21.89 21.89 0 00-12.79 4.14c0-.43.06-.85.09-1.22.45-6.5 1.15-16.32-5.2-25.22a258 258 0 00-24.8-28.74.6.6 0 00-.08-.08c-13.32-13.12-42.31-37.83-86.72-55.94A139.55 139.55 0 00257.56 32C226 32 202 46.24 192.81 54.68A53.4 53.4 0 00176 86.17L192 96s8.06-2 13.86-3.39a62.73 62.73 0 0118.45-1.15c13.19 1.09 28.79 7.64 35.69 13.09 11.7 9.41 17.33 22.09 18.26 41.09.2 4.23-9.52 21.35-24.16 39.84a8 8 0 00.61 10.62l45.37 45.37a8 8 0 0011 .25c12.07-11 30.49-28 34.67-30.59 7.69-4.73 13.19-5.64 14.7-5.8a19.18 19.18 0 0111.29 2.38 1.24 1.24 0 01-.31.95l-1.82 1.73-.3.28a21.52 21.52 0 00.05 30.54l43.95 43.68a8 8 0 0011.28 0l74.68-74.2a8 8 0 00.06-11.36z"}}]})(props);
	};
	module.exports.IoHammer = function IoHammer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M280.16 242.79l-26.11-26.12a32 32 0 00-45.14-.12L27.38 384.08c-6.61 6.23-10.95 14.17-11.35 23.06a32.11 32.11 0 009.21 23.94l39 39.43a.46.46 0 00.07.07A32.29 32.29 0 0087 480h1.18c8.89-.33 16.85-4.5 23.17-11.17l168.7-180.7a32 32 0 00.11-45.34zM490 190l-.31-.31-34.27-33.92a21.46 21.46 0 00-15.28-6.26 21.89 21.89 0 00-12.79 4.14c0-.43.06-.85.09-1.22.45-6.5 1.15-16.32-5.2-25.22a258 258 0 00-24.8-28.74.6.6 0 00-.08-.08c-13.32-13.12-42.31-37.83-86.72-55.94A139.55 139.55 0 00257.56 32C226 32 202 46.24 192.81 54.68a119.92 119.92 0 00-14.18 16.22 16 16 0 0018.65 24.34 74.45 74.45 0 018.58-2.63 63.46 63.46 0 0118.45-1.15c13.19 1.09 28.79 7.64 35.69 13.09 11.7 9.41 17.33 22.09 18.26 41.09.18 3.82-7.72 18.14-20 34.48a16 16 0 001.45 21l34.41 34.41a16 16 0 0022 .62c9.73-8.69 24.55-21.79 29.73-25 7.69-4.73 13.19-5.64 14.7-5.8a19.18 19.18 0 0111.29 2.38 1.24 1.24 0 01-.31.95l-1.82 1.73-.3.28a21.52 21.52 0 00.05 30.54l34.26 33.91a21.45 21.45 0 0015.28 6.25 21.7 21.7 0 0015.22-6.2l55.5-54.82c.19-.19.38-.39.56-.59A21.87 21.87 0 00490 190z"}}]})(props);
	};
	module.exports.IoHandLeftOutline = function IoHandLeftOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M80 320V144a32 32 0 0132-32h0a32 32 0 0132 32v112m0 0V80a32 32 0 0132-32h0a32 32 0 0132 32v160m64 1V96a32 32 0 0132-32h0a32 32 0 0132 32v224m-128-80V48a32 32 0 0132-32h0a32 32 0 0132 32v192"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M80 320c0 117.4 64 176 152 176s123.71-39.6 144-88l52.71-144c6.66-18.05 3.64-34.79-11.87-43.6h0c-15.52-8.82-35.91-4.28-44.31 11.68L336 320"}}]})(props);
	};
	module.exports.IoHandLeftSharp = function IoHandLeftSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M429.58 209.08c-15.06-6.62-32.38 1.31-38.5 17.62L356 312h-11.27V80c0-17.6-13.3-32-29.55-32-16.26 0-29.55 14.4-29.55 32v151.75l-14.78.25V32c0-17.6-13.3-32-29.55-32s-29.55 14.4-29.55 32v199.75L197 232V64c0-17.6-13.3-32-29.55-32-16.26 0-29.55 14.4-29.55 32v183.75l-14.8.25V128c0-17.6-13.3-32-29.55-32S64 110.4 64 128v216c0 75.8 37.13 168 169 168 40.8 0 79.42-7 100.66-21a121.41 121.41 0 0033.72-33.31 138 138 0 0016-31.78l62.45-175.14c6.17-16.31-1.19-35.06-16.25-41.69z"}}]})(props);
	};
	module.exports.IoHandLeft = function IoHandLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432.8 211.44c-15.52-8.82-34.91-2.28-43.31 13.68l-41.38 84.41a7 7 0 01-8.93 3.43 7 7 0 01-4.41-6.52V72c0-13.91-12.85-24-26.77-24s-26 10.09-26 24v156.64A11.24 11.24 0 01271.21 240 11 11 0 01260 229V24c0-13.91-10.94-24-24.86-24S210 10.09 210 24v204.64A11.24 11.24 0 01199.21 240 11 11 0 01188 229V56c0-13.91-12.08-24-26-24s-26 11.09-26 25v187.64A11.24 11.24 0 01125.21 256 11 11 0 01114 245V120c0-13.91-11.08-24-25-24s-25.12 10.22-25 24v216c0 117.41 72 176 160 176h16c88 0 115.71-39.6 136-88l68.71-169c6.62-18 3.6-34.75-11.91-43.56z"}}]})(props);
	};
	module.exports.IoHandRightOutline = function IoHandRightOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M432 320V144a32 32 0 00-32-32h0a32 32 0 00-32 32v112m0 0V80a32 32 0 00-32-32h0a32 32 0 00-32 32v160m-64 1V96a32 32 0 00-32-32h0a32 32 0 00-32 32v224m128-80V48a32 32 0 00-32-32h0a32 32 0 00-32 32v192"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M432 320c0 117.4-64 176-152 176s-123.71-39.6-144-88L83.33 264c-6.66-18.05-3.64-34.79 11.87-43.6h0c15.52-8.82 35.91-4.28 44.31 11.68L176 320"}}]})(props);
	};
	module.exports.IoHandRightSharp = function IoHandRightSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M82.42 209.08c15.06-6.62 32.38 1.31 38.5 17.62L156 312h11.27V80c0-17.6 13.3-32 29.55-32 16.26 0 29.55 14.4 29.55 32v151.75l14.78.25V32c0-17.6 13.3-32 29.55-32 16.3 0 29.55 14.4 29.55 32v199.75L315 232V64c0-17.6 13.3-32 29.55-32 16.26 0 29.55 14.4 29.55 32v183.75l14.78.25V128c0-17.6 13.3-32 29.55-32C434.7 96 448 110.4 448 128v216c0 75.8-37.13 168-169 168-40.8 0-79.42-7-100.66-21a121.41 121.41 0 01-33.72-33.31 138 138 0 01-16-31.78L66.16 250.77c-6.11-16.31 1.2-35.06 16.26-41.69z"}}]})(props);
	};
	module.exports.IoHandRight = function IoHandRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M79.2 211.44c15.52-8.82 34.91-2.28 43.31 13.68l41.38 84.41a7 7 0 008.93 3.43 7 7 0 004.41-6.52V72c0-13.91 12.85-24 26.77-24s26 10.09 26 24v156.64A11.24 11.24 0 00240.79 240 11 11 0 00252 229V24c0-13.91 10.94-24 24.86-24S302 10.09 302 24v204.64A11.24 11.24 0 00312.79 240 11 11 0 00324 229V56c0-13.91 12.08-24 26-24s26 11.09 26 25v187.64A11.24 11.24 0 00386.79 256 11 11 0 00398 245V120c0-13.91 11.08-24 25-24s25.12 10.22 25 24v216c0 117.41-72 176-160 176h-16c-88 0-115.71-39.6-136-88L67.33 255c-6.66-18-3.64-34.75 11.87-43.56z"}}]})(props);
	};
	module.exports.IoHappyOutline = function IoHappyOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"184","cy":"232","r":"24"}},{"tag":"path","attr":{"d":"M256.05 384c-45.42 0-83.62-29.53-95.71-69.83a8 8 0 017.82-10.17h175.69a8 8 0 017.82 10.17c-11.99 40.3-50.2 69.83-95.62 69.83z"}},{"tag":"circle","attr":{"cx":"328","cy":"232","r":"24"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"208","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoHappySharp = function IoHappySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM328 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm-144 0a24 24 0 11-24 24 23.94 23.94 0 0124-24zm72.05 176c-45.42 0-83.75-29.49-95.72-69.83C159.29 310.65 158 304 158 304h196s-1.31 6.69-2.33 10.17c-11.78 40.36-50.2 69.83-95.62 69.83z"}}]})(props);
	};
	module.exports.IoHappy = function IoHappy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM184 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm167.67 106.17c-12 40.3-50.2 69.83-95.62 69.83s-83.62-29.53-95.72-69.83a8 8 0 017.83-10.17h175.69a8 8 0 017.82 10.17zM328 256a24 24 0 1124-24 23.94 23.94 0 01-24 24z"}}]})(props);
	};
	module.exports.IoHardwareChipOutline = function IoHardwareChipOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"352","height":"352","x":"80","y":"80","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}},{"tag":"rect","attr":{"width":"224","height":"224","x":"144","y":"144","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"16","ry":"16"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 80V48m80 32V48M176 80V48m80 416v-32m80 32v-32m-160 32v-32m256-176h32m-32 80h32m-32-160h32M48 256h32m-32 80h32M48 176h32"}}]})(props);
	};
	module.exports.IoHardwareChipSharp = function IoHardwareChipSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 160h192v192H160z"}},{"tag":"path","attr":{"d":"M480 198v-44h-32V88a24 24 0 00-24-24h-66V32h-44v32h-36V32h-44v32h-36V32h-44v32H88a24 24 0 00-24 24v66H32v44h32v36H32v44h32v36H32v44h32v66a24 24 0 0024 24h66v32h44v-32h36v32h44v-32h36v32h44v-32h66a24 24 0 0024-24v-66h32v-44h-32v-36h32v-44h-32v-36zm-352-70h256v256H128z"}}]})(props);
	};
	module.exports.IoHardwareChip = function IoHardwareChip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M352 128H160a32 32 0 00-32 32v192a32 32 0 0032 32h192a32 32 0 0032-32V160a32 32 0 00-32-32zm0 216a8 8 0 01-8 8H168a8 8 0 01-8-8V168a8 8 0 018-8h176a8 8 0 018 8z"}},{"tag":"rect","attr":{"width":"192","height":"192","x":"160","y":"160","rx":"8","ry":"8"}},{"tag":"path","attr":{"d":"M464 192a16 16 0 000-32h-16v-32a64.07 64.07 0 00-64-64h-32V48a16 16 0 00-32 0v16h-48V48a16 16 0 00-32 0v16h-48V48a16 16 0 00-32 0v16h-32a64.07 64.07 0 00-64 64v32H48a16 16 0 000 32h16v48H48a16 16 0 000 32h16v48H48a16 16 0 000 32h16v32a64.07 64.07 0 0064 64h32v16a16 16 0 0032 0v-16h48v16a16 16 0 0032 0v-16h48v16a16 16 0 0032 0v-16h32a64.07 64.07 0 0064-64v-32h16a16 16 0 000-32h-16v-48h16a16 16 0 000-32h-16v-48zm-80 160a32 32 0 01-32 32H160a32 32 0 01-32-32V160a32 32 0 0132-32h192a32 32 0 0132 32z"}}]})(props);
	};
	module.exports.IoHeadsetOutline = function IoHeadsetOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M83 384c-13-33-35-93.37-35-128C48 141.12 149.33 48 256 48s208 93.12 208 208c0 34.63-23 97-35 128"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M108.39 270.13l-13.69 8h0c-30.23 17.7-31.7 72.41-3.38 122.2s75.87 75.81 106.1 58.12h0l13.69-8a16.16 16.16 0 005.78-21.87L130 276a15.74 15.74 0 00-21.61-5.87zm295.22 0l13.69 8h0c30.23 17.69 31.74 72.4 3.38 122.19s-75.87 75.81-106.1 58.12h0l-13.69-8a16.16 16.16 0 01-5.78-21.87L382 276a15.74 15.74 0 0121.61-5.87z"}}]})(props);
	};
	module.exports.IoHeadsetSharp = function IoHeadsetSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M411.16 97.45C368.43 55.85 311.88 32 256 32S143.57 55.85 100.84 97.45C56.45 140.67 32 196 32 256s26.84 118.49 45.42 152.25S121 480 144 480c32 0 96-32 96-32L128 240l-54.42 31.73a176.07 176.07 0 01-1-18.84c0-48.57 19.32-94.1 56.15-130C164.24 88.34 210 70 256 70s91.73 18.34 127.27 52.93c36.83 35.86 56.14 81.39 56.14 130a175.56 175.56 0 01-1 18.82L384 240 272 448s64 32 96 32c23 0 48-38 66.58-71.75S480 316 480 256s-24.45-115.33-68.84-158.55z"}}]})(props);
	};
	module.exports.IoHeadset = function IoHeadset (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M411.16 97.46C368.43 55.86 311.88 32 256 32S143.57 55.86 100.84 97.46C56.45 140.67 32 197 32 256c0 26.67 8.75 61.09 32.88 125.55S137 473 157.27 477.41c5.81 1.27 12.62 2.59 18.73 2.59a60.06 60.06 0 0030-8l14-8c15.07-8.82 19.47-28.13 10.8-43.35l-86.92-152.57a31.73 31.73 0 00-43.57-11.76l-13.69 8a56.49 56.49 0 00-14 11.59 4 4 0 01-7-2A114.68 114.68 0 0164 256c0-50.31 21-98.48 59.16-135.61C160 84.55 208.39 64 256 64s96 20.55 132.84 56.39C427 157.52 448 205.69 448 256a114.68 114.68 0 01-1.68 17.91 4 4 0 01-7 2 56.49 56.49 0 00-14-11.59l-13.69-8a31.73 31.73 0 00-43.57 11.76L281.2 420.65c-8.67 15.22-4.27 34.53 10.8 43.35l14 8a60.06 60.06 0 0030 8c6.11 0 12.92-1.32 18.73-2.59C375 473 423 446 447.12 381.55S480 282.67 480 256c0-59-24.45-115.33-68.84-158.54z"}}]})(props);
	};
	module.exports.IoHeartCircleOutline = function IoHeartCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"d":"M256 360a16 16 0 01-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06 25.22-56.33 55.53-56.33 20.4 0 35 10.63 44.1 20.41a6 6 0 008.72 0c9.11-9.78 23.7-20.41 44.1-20.41 30.31 0 55.22 25.27 55.53 56.33.28 27.1-9.31 52.13-29.3 76.5-9.38 11.44-26.4 29.73-65.7 56.41A16 16 0 01256 360z"}}]})(props);
	};
	module.exports.IoHeartCircleSharp = function IoHeartCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm74.69 252.82c-8.5 10.36-39.69 38.48-74.69 63.51-35-25-66.19-53.15-74.69-63.51-20-24.37-29.58-49.4-29.3-76.5.31-31.06 25.22-56.33 55.53-56.33 22 0 37.3 12.41 46.19 22.76l2.27 2.75 2.27-2.75C267 180.29 282.42 168 304.46 168c30.31 0 55.22 25.27 55.53 56.33.28 27.09-9.31 52.12-29.3 76.49z"}}]})(props);
	};
	module.exports.IoHeartCircle = function IoHeartCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm74.69 252.82c-9.38 11.44-26.4 29.73-65.7 56.41a15.93 15.93 0 01-18 0c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06 25.22-56.33 55.53-56.33 20.4 0 35 10.63 44.1 20.41a6 6 0 008.72 0c9.11-9.78 23.7-20.41 44.1-20.41 30.31 0 55.22 25.27 55.53 56.33.3 27.1-9.29 52.13-29.28 76.5z"}}]})(props);
	};
	module.exports.IoHeartDislikeCircleOutline = function IoHeartDislikeCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"d":"M333.2 297.69c18.28-23.39 27.06-47.43 26.79-73.37-.31-31.06-25.22-56.33-55.53-56.33-20.4 0-35 10.64-44.11 20.42a5.93 5.93 0 01-8.7 0c-9.11-9.78-23.71-20.42-44.11-20.42L206 168a4 4 0 00-2.75 6.84l124 123.21a3.92 3.92 0 005.95-.36zM158.84 221a4 4 0 00-6.82 2.72v.64c-.28 27.1 9.31 52.13 29.3 76.5 9.38 11.44 26.4 29.73 65.7 56.41a15.93 15.93 0 0018 0c5.15-3.49 9.9-6.84 14.31-10a4 4 0 00.46-6.07zM336 368a15.92 15.92 0 01-11.31-4.69l-176-176a16 16 0 0122.62-22.62l176 176A16 16 0 01336 368z"}}]})(props);
	};
	module.exports.IoHeartDislikeCircleSharp = function IoHeartDislikeCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm63.73 310.36l-183.14-182.3 22.74-22.51 183.19 182.36zm-63.51 4.86c-35.36-25-66.31-51.92-74.91-62.4-20-24.37-29.58-49.4-29.3-76.5a58.27 58.27 0 01.85-9.31l130.21 129.4c-3.43 2.59-16.21 11.45-26.85 18.81zm74.47-62.4l-.31.38L197.33 169a53.8 53.8 0 0110.21-1 59.34 59.34 0 0144.1 19.41L256 192l4.36-4.6a59.34 59.34 0 0144.1-19.4c30.31 0 55.22 25.27 55.53 56.33.28 27.09-9.31 52.12-29.3 76.49z"}}]})(props);
	};
	module.exports.IoHeartDislikeCircle = function IoHeartDislikeCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm23.3 299.19c-4.41 3.2-9.16 6.55-14.31 10a15.93 15.93 0 01-18 0c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5v-.64a4 4 0 016.82-2.72l120.95 120.2a4 4 0 01-.46 6.07zm68 16.12a16 16 0 01-22.62 0l-176-176a16 16 0 0122.62-22.62l176 176a16 16 0 01.01 22.62zm-14.1-65.62a3.92 3.92 0 01-6 .37l-124-123.21A4 4 0 01206 168h1.55c20.4 0 35 10.64 44.11 20.42a5.93 5.93 0 008.7 0c9.11-9.78 23.71-20.42 44.11-20.42 30.31 0 55.22 25.27 55.53 56.33.26 25.93-8.52 49.97-26.8 73.36z"}}]})(props);
	};
	module.exports.IoHeartDislikeOutline = function IoHeartDislikeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M417.84 448a15.94 15.94 0 01-11.35-4.72L40.65 75.26a16 16 0 0122.7-22.56l365.83 368a16 16 0 01-11.34 27.3zM364.92 80c-48.09 0-80 29.55-96.92 51-16.88-21.48-48.83-51-96.92-51a107.37 107.37 0 00-31 4.55L168 112c22.26 0 45.81 9 63.94 26.67a123 123 0 0121.75 28.47 16 16 0 0028.6 0 123 123 0 0121.77-28.51C322.19 121 342.66 112 364.92 112c43.15 0 78.62 36.33 79.07 81 .54 53.69-22.75 99.55-57.38 139.52l22.63 22.77c3-3.44 5.7-6.64 8.14-9.6 40-48.75 59.15-98.8 58.61-153C475.37 130.52 425.54 80 364.92 80zM268 432C180.38 372.51 91 297.6 92 193a83.69 83.69 0 012.24-18.39L69 149.14a115.1 115.1 0 00-9 43.49c-.54 54.22 18.63 104.27 58.61 153 18.77 22.87 52.8 59.45 131.39 112.8a31.84 31.84 0 0036 0c20.35-13.81 37.7-26.5 52.58-38.11l-22.66-22.81C300.25 409.6 284.09 421.05 268 432z"}}]})(props);
	};
	module.exports.IoHeartDislikeSharp = function IoHeartDislikeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 64.45l389.47 389.94 22.84-22.47L54.85 42 32 64.45zm30.67 128.46c-.56 55.63 19.77 106.94 62.16 156.88 40.25 47.42 94.56 79.67 137.47 108.21l9 6 9-6c18.49-12.3 39.1-25.3 59.79-39.89L71.74 149.28a114.62 114.62 0 00-9.07 43.63zm355.16 156.88c42.39-49.94 62.72-101.25 62.16-156.88-.63-62-50.61-112.54-111.43-112.54-48.26 0-80.35 28-97.23 48.17-16.88-20.2-49-48.17-97.23-48.17A108.24 108.24 0 00142.84 85l270 270.48c1.71-1.89 3.37-3.78 4.99-5.69z"}}]})(props);
	};
	module.exports.IoHeartDislike = function IoHeartDislike (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M417.84 448a16 16 0 01-11.35-4.72l-365.84-368a16 16 0 1122.7-22.56l365.83 368A16 16 0 01417.84 448zM364.92 80c-44.09 0-74.61 24.82-92.39 45.5a6 6 0 01-9.06 0C245.69 104.82 215.16 80 171.08 80a107.71 107.71 0 00-31 4.54l269.13 270.7c3-3.44 5.7-6.64 8.14-9.6 40-48.75 59.15-98.79 58.61-153C475.37 130.53 425.54 80 364.92 80zM69 149.15a115.06 115.06 0 00-9 43.49c-.54 54.21 18.63 104.25 58.61 153 18.77 22.87 52.8 59.45 131.39 112.8a31.88 31.88 0 0036 0c20.35-13.82 37.7-26.5 52.58-38.12z"}}]})(props);
	};
	module.exports.IoHeartHalfOutline = function IoHeartHalfOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352.92 64c-48.09 0-80 29.54-96.92 51-16.88-21.49-48.83-51-96.92-51C98.46 64 48.63 114.54 48 176.65c-.54 54.21 18.63 104.27 58.61 153 18.77 22.88 52.8 59.46 131.39 112.81a31.84 31.84 0 0036 0c78.59-53.35 112.62-89.93 131.39-112.81 40-48.74 59.15-98.8 58.61-153C463.37 114.54 413.54 64 352.92 64zM256 416V207.58c0-19.63 5.23-38.76 14.21-56.22a1.19 1.19 0 01.08-.16 123 123 0 0121.77-28.51C310.19 105 330.66 96 352.92 96c43.15 0 78.62 36.32 79.07 81C433 281.61 343.63 356.51 256 416z"}}]})(props);
	};
	module.exports.IoHeartHalfSharp = function IoHeartHalfSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352.92 64c-48.11 0-80.1 28-96.92 48.21C239.18 92 207.19 64 159.08 64 98.46 64 48.63 114.54 48 176.65c-.56 55.68 19.71 107 62 157 40.12 47.46 94.25 79.75 137 108.32l9 6 9-6c42.78-28.57 96.91-60.86 137-108.32 42.25-50 62.52-101.35 62-157C463.37 114.54 413.54 64 352.92 64zm24.67 249c-31.78 37.6-74.68 65.75-112.52 90.59l-9.07 6V162.23l24.59-29.54C294.53 116 318.38 96 352.92 96c43.15 0 78.62 36.32 79.07 81a178.63 178.63 0 01-12.69 68.59c-9.03 22.84-22.67 44.91-41.71 67.41z"}}]})(props);
	};
	module.exports.IoHeartHalf = function IoHeartHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352.92 64c-48.09 0-80 29.54-96.92 51-16.88-21.49-48.83-51-96.92-51C98.46 64 48.63 114.54 48 176.65c-.54 54.21 18.63 104.27 58.61 153 18.77 22.88 52.8 59.46 131.39 112.81a31.84 31.84 0 0036 0c78.59-53.35 112.62-89.93 131.39-112.81 40-48.74 59.15-98.8 58.61-153C463.37 114.54 413.54 64 352.92 64zM256 416V207.58c0-19.63 5.23-38.76 14.21-56.22a1.19 1.19 0 01.08-.16 123 123 0 0121.77-28.51C310.19 105 330.66 96 352.92 96c43.15 0 78.62 36.32 79.07 81C433 281.61 343.63 356.51 256 416z"}}]})(props);
	};
	module.exports.IoHeartOutline = function IoHeartOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z"}}]})(props);
	};
	module.exports.IoHeartSharp = function IoHeartSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 448l-9-6c-42.78-28.57-96.91-60.86-137-108.32-42.25-50-62.52-101.35-62-157C48.63 114.54 98.46 64 159.08 64c48.11 0 80.1 28 96.92 48.21C272.82 92 304.81 64 352.92 64c60.62 0 110.45 50.54 111.08 112.65.56 55.68-19.71 107-62 157-40.09 47.49-94.22 79.78-137 108.35z"}}]})(props);
	};
	module.exports.IoHeart = function IoHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 448a32 32 0 01-18-5.57c-78.59-53.35-112.62-89.93-131.39-112.8-40-48.75-59.15-98.8-58.61-153C48.63 114.52 98.46 64 159.08 64c44.08 0 74.61 24.83 92.39 45.51a6 6 0 009.06 0C278.31 88.81 308.84 64 352.92 64c60.62 0 110.45 50.52 111.08 112.64.54 54.21-18.63 104.26-58.61 153-18.77 22.87-52.8 59.45-131.39 112.8a32 32 0 01-18 5.56z"}}]})(props);
	};
	module.exports.IoHelpBuoyOutline = function IoHelpBuoyOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"208","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"80","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M208 54l8 132m80 0l8-132m-96 404l8-132m80 0l8 132m154-250l-132 8m0 80l132 8M54 208l132 8m0 80l-132 8"}}]})(props);
	};
	module.exports.IoHelpBuoySharp = function IoHelpBuoySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32zm-64 224a64 64 0 1164 64 64 64 0 01-64-64zm237.24-62.29L342.91 199a104.86 104.86 0 00-29.86-29.86l5.24-86.33a185 185 0 01111 111zm-303.35-67.82a183.44 183.44 0 0167.82-43.13l5.29 86.33A104.86 104.86 0 00169.09 199l-86.33-5.24a183.44 183.44 0 0143.13-67.87zm-43.13 192.4l86.33-5.24A104.86 104.86 0 00199 342.91l-5.24 86.33a185 185 0 01-111-110.95zm303.35 67.82a183.44 183.44 0 01-67.82 43.13l-5.24-86.33a104.86 104.86 0 0029.86-29.86l86.33 5.24a183.44 183.44 0 01-43.13 67.82z"}}]})(props);
	};
	module.exports.IoHelpBuoy = function IoHelpBuoy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM192.13 260.18a64 64 0 1159.69 59.69 64.07 64.07 0 01-59.69-59.69zm240-66.64l-96.37 5.84a4.06 4.06 0 01-3.44-1.59 96 96 0 00-18.07-18.07 4.06 4.06 0 01-1.59-3.44l5.84-96.37a4 4 0 015.42-3.51A193 193 0 01435.6 188.12a4 4 0 01-3.51 5.42zM193.54 79.91l5.84 96.37a4.06 4.06 0 01-1.59 3.44 96 96 0 00-18.07 18.07 4.06 4.06 0 01-3.44 1.59l-96.37-5.84a4 4 0 01-3.51-5.42A193 193 0 01188.12 76.4a4 4 0 015.42 3.51zM79.91 318.46l96.37-5.84a4.06 4.06 0 013.44 1.59 96 96 0 0018.07 18.07 4.06 4.06 0 011.59 3.44l-5.84 96.37a4 4 0 01-5.42 3.51A193 193 0 0176.4 323.88a4 4 0 013.51-5.42zm238.55 113.63l-5.84-96.37a4.06 4.06 0 011.59-3.44 96 96 0 0018.07-18.07 4.06 4.06 0 013.44-1.59l96.37 5.84a4 4 0 013.51 5.42A193 193 0 01323.88 435.6a4 4 0 01-5.42-3.51z"}}]})(props);
	};
	module.exports.IoHelpCircleOutline = function IoHelpCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 80a176 176 0 10176 176A176 176 0 00256 80z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"28","d":"M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296"}},{"tag":"circle","attr":{"cx":"250","cy":"348","r":"20"}}]})(props);
	};
	module.exports.IoHelpCircleSharp = function IoHelpCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M288.55 150.84c-8.09-3.86-20-6-32.72-5.82-18 .22-33.13 5.2-45 14.78-23 18.48-24.55 40.37-24.77 42.8a61.69 61.69 0 00-.09 12 3 3 0 003 2.69h21.23a3 3 0 003-3A65.7 65.7 0 01214 204c0-.11 1.14-11.7 14.36-22.34 7-5.64 16.11-8.44 27.83-8.59 9.32-.11 16.93 1.47 20.34 3.09C291 183 298 192.31 298 204.57c0 18-10.9 26.23-30.18 39.18C247.08 257.68 237 275.1 237 297v11a3 3 0 003 3h22a3 3 0 003-3v-11c0-9.16 2.23-19.13 18.44-30 19.95-13.41 42.56-28.6 42.56-62.43 0-23.14-13.3-42.23-37.45-53.73z"}},{"tag":"path","attr":{"d":"M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64zm10.44 302h-30.21a2.57 2.57 0 01-2.56-2.57v-30.2a2.57 2.57 0 012.56-2.57h30.21a2.57 2.57 0 012.56 2.57v30.2a2.57 2.57 0 01-2.56 2.57zm17-99C267.23 277.88 265 287.85 265 297v11a3 3 0 01-3 3h-22a3 3 0 01-3-3v-11c0-21.91 10.08-39.33 30.82-53.26C287.1 230.8 298 222.6 298 204.57c0-12.26-7-21.57-21.49-28.46-3.41-1.62-11-3.2-20.34-3.09-11.72.15-20.82 2.95-27.83 8.59C215.12 192.25 214 203.84 214 204a65.7 65.7 0 00-.84 10.28 3 3 0 01-3 3h-21.25a3 3 0 01-3-2.69 61.69 61.69 0 01.09-12c.22-2.43 1.8-24.32 24.77-42.8 11.91-9.58 27.06-14.56 45-14.78 12.7-.15 24.63 2 32.72 5.82 24.21 11.51 37.51 30.6 37.51 53.74 0 33.83-22.61 49.02-42.56 62.43z"}}]})(props);
	};
	module.exports.IoHelpCircle = function IoHelpCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64zm-6 304a20 20 0 1120-20 20 20 0 01-20 20zm33.44-102C267.23 276.88 265 286.85 265 296a14 14 0 01-28 0c0-21.91 10.08-39.33 30.82-53.26C287.1 229.8 298 221.6 298 203.57c0-12.26-7-21.57-21.49-28.46-3.41-1.62-11-3.2-20.34-3.09-11.72.15-20.82 2.95-27.83 8.59C215.12 191.25 214 202.83 214 203a14 14 0 11-28-1.35c.11-2.43 1.8-24.32 24.77-42.8 11.91-9.58 27.06-14.56 45-14.78 12.7-.15 24.63 2 32.72 5.82C312.7 161.34 326 180.43 326 203.57c0 33.83-22.61 49.02-42.56 62.43z"}}]})(props);
	};
	module.exports.IoHelpOutline = function IoHelpOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"40","d":"M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324"}},{"tag":"circle","attr":{"cx":"248","cy":"399.99","r":"32"}}]})(props);
	};
	module.exports.IoHelpSharp = function IoHelpSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"40","d":"M160 164c0-10 1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 290.36 248 316"}},{"tag":"rect","attr":{"width":"56","height":"56","x":"220","y":"368","rx":"3.5","ry":"3.5"}}]})(props);
	};
	module.exports.IoHelp = function IoHelp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"40","d":"M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324"}},{"tag":"circle","attr":{"cx":"248","cy":"399.99","r":"32"}}]})(props);
	};
	module.exports.IoHomeOutline = function IoHomeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M80 212v236a16 16 0 0016 16h96V328a24 24 0 0124-24h80a24 24 0 0124 24v136h96a16 16 0 0016-16V212"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M480 256L266.89 52c-5-5.28-16.69-5.34-21.78 0L32 256m368-77V64h-48v69"}}]})(props);
	};
	module.exports.IoHomeSharp = function IoHomeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 174.74V48h-80v58.45L256 32 0 272h64v208h144V320h96v160h144V272h64l-96-97.26z"}}]})(props);
	};
	module.exports.IoHome = function IoHome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M261.56 101.28a8 8 0 00-11.06 0L66.4 277.15a8 8 0 00-2.47 5.79L63.9 448a32 32 0 0032 32H192a16 16 0 0016-16V328a8 8 0 018-8h80a8 8 0 018 8v136a16 16 0 0016 16h96.06a32 32 0 0032-32V282.94a8 8 0 00-2.47-5.79z"}},{"tag":"path","attr":{"d":"M490.91 244.15l-74.8-71.56V64a16 16 0 00-16-16h-48a16 16 0 00-16 16v32l-57.92-55.38C272.77 35.14 264.71 32 256 32c-8.68 0-16.72 3.14-22.14 8.63l-212.7 203.5c-6.22 6-7 15.87-1.34 22.37A16 16 0 0043 267.56L250.5 69.28a8 8 0 0111.06 0l207.52 198.28a16 16 0 0022.59-.44c6.14-6.36 5.63-16.86-.76-22.97z"}}]})(props);
	};
	module.exports.IoHourglassOutline = function IoHourglassOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M145.61 464h220.78c19.8 0 35.55-16.29 33.42-35.06C386.06 308 304 310 304 256s83.11-51 95.8-172.94c2-18.78-13.61-35.06-33.41-35.06H145.61c-19.8 0-35.37 16.28-33.41 35.06C124.89 205 208 201 208 256s-82.06 52-95.8 172.94c-2.14 18.77 13.61 35.06 33.41 35.06z"}},{"tag":"path","attr":{"d":"M343.3 432H169.13c-15.6 0-20-18-9.06-29.16C186.55 376 240 356.78 240 326V224c0-19.85-38-35-61.51-67.2-3.88-5.31-3.49-12.8 6.37-12.8h142.73c8.41 0 10.23 7.43 6.4 12.75C310.82 189 272 204.05 272 224v102c0 30.53 55.71 47 80.4 76.87 9.95 12.04 6.47 29.13-9.1 29.13z"}}]})(props);
	};
	module.exports.IoHourglassSharp = function IoHourglassSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 32H96v112l108 112L96 368v112h320V368L308 256l108-112zM272 224v112l91 96H148l92-96V224l-80-80h192z"}}]})(props);
	};
	module.exports.IoHourglass = function IoHourglass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M415.7 427.13c-8.74-76.89-43.83-108.76-69.46-132C328.52 279 320 270.61 320 256c0-14.41 8.49-22.64 26.16-38.44 25.93-23.17 61.44-54.91 69.56-132.84a47 47 0 00-12-36.26A50.3 50.3 0 00366.39 32H145.61a50.34 50.34 0 00-37.39 16.46 47.05 47.05 0 00-11.94 36.26c8.09 77.68 43.47 109.19 69.3 132.19C183.42 232.8 192 241.09 192 256c0 15.1-8.6 23.56-26.5 39.75-25.5 23.1-60.5 54.73-69.2 131.38a46.59 46.59 0 0011.7 36.2A50.44 50.44 0 00145.61 480h220.78A50.44 50.44 0 00404 463.33a46.59 46.59 0 0011.7-36.2zM343.3 432H169.13c-15.6 0-20-18-9.06-29.16C186.55 376 240 356.78 240 326V224c0-19.85-38-35-61.51-67.2-3.88-5.31-3.49-12.8 6.37-12.8h142.73c8.41 0 10.22 7.43 6.4 12.75C310.82 189 272 204.05 272 224v102c0 30.53 55.71 47 80.4 76.87 9.95 12.04 6.47 29.13-9.1 29.13z"}}]})(props);
	};
	module.exports.IoIceCreamOutline = function IoIceCreamOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 256l-96 224-62-145"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M299.42 223.48C291.74 239.75 275.18 252 256 252c-13.1 0-27-5-33.63-9.76C216.27 237.87 208 240 208 250v62a24.07 24.07 0 01-24 24h0a24.07 24.07 0 01-24-24v-56h-2c-35.35 0-62-28.65-62-64a64 64 0 0164-64h8v-8a88 88 0 01176 0v8h8a64 64 0 010 128c-21.78 0-42-13-52.59-32.51z"}}]})(props);
	};
	module.exports.IoIceCreamSharp = function IoIceCreamSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M359.72 112.37a104 104 0 00-207.44 0A80.12 80.12 0 0080 192c0 39.36 26.37 71.23 62.38 78.46a2 2 0 011.62 2v38.83c0 21.84 17.2 40.22 39 40.74a40 40 0 0041-40v-47.84a2 2 0 012.72-1.86A83.47 83.47 0 00256 268a63.18 63.18 0 0042.24-16.59 2 2 0 012.74 0A74.63 74.63 0 00352 272a80 80 0 007.72-159.63z"}},{"tag":"path","attr":{"d":"M256 300v12a72.1 72.1 0 01-58.21 70.64L256 496l92.06-192.08a105.29 105.29 0 01-49.18-14.36A93.75 93.75 0 01256 300z"}}]})(props);
	};
	module.exports.IoIceCream = function IoIceCream (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M183 352c-21.84-.52-39-18.9-39-40.74v-34.07a8 8 0 00-6-7.74c-33.75-8.85-58-39.71-58-77.45a80.14 80.14 0 0166.27-78.82 8 8 0 006.62-6.83 104 104 0 01206.22 0 8 8 0 006.62 6.83A80 80 0 01352 272a74.33 74.33 0 01-47.45-17.41 7.93 7.93 0 00-9.92-.14A62.89 62.89 0 01256 268a80.47 80.47 0 01-21.8-3.18 8 8 0 00-10.2 7.69V312a40 40 0 01-41 40z"}},{"tag":"path","attr":{"d":"M263.39 299.7a8 8 0 00-7.39 7.91V312a72.11 72.11 0 01-50.69 68.76 8 8 0 00-4.91 10.78l40.91 94.8A16 16 0 00256 496a16 16 0 0014.69-9.7l73.78-172.15a8 8 0 00-6.2-11.07 106.31 106.31 0 01-35.9-11.59 8 8 0 00-7.13-.2 95 95 0 01-31.85 8.41z"}}]})(props);
	};
	module.exports.IoIdCardOutline = function IoIdCardOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"320","height":"448","x":"96","y":"32","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M208 80h96"}},{"tag":"path","attr":{"d":"M333.48 284.51A39.65 39.65 0 00304 272c-11.6 0-22.09 4.41-29.54 12.43s-11.2 19.12-10.34 31C265.83 338.91 283.72 358 304 358s38.14-19.09 39.87-42.55c.88-11.78-2.82-22.77-10.39-30.94zM371.69 448H236.31a12.05 12.05 0 01-9.31-4.17 13 13 0 01-2.76-10.92c3.25-17.56 13.38-32.31 29.3-42.66C267.68 381.06 285.6 376 304 376s36.32 5.06 50.46 14.25c15.92 10.35 26.05 25.1 29.3 42.66a13 13 0 01-2.76 10.92 12.05 12.05 0 01-9.31 4.17z"}}]})(props);
	};
	module.exports.IoIdCardSharp = function IoIdCardSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408 16H104a24 24 0 00-24 24v432a24 24 0 0024 24h304a24 24 0 0024-24V40a24 24 0 00-24-24zm-61.1 296.77a43 43 0 11-40.71-40.71 43 43 0 0140.71 40.71zM192 64h128v32H192zm192 384H224v-24.6c0-32.72 53.27-49.21 80-49.21s80 16.49 80 49.21z"}}]})(props);
	};
	module.exports.IoIdCard = function IoIdCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 16H144a64.07 64.07 0 00-64 64v352a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V80a64.07 64.07 0 00-64-64zm-34.52 268.51c7.57 8.17 11.27 19.16 10.39 30.94C342.14 338.91 324.25 358 304 358s-38.17-19.09-39.88-42.55c-.86-11.9 2.81-22.91 10.34-31S292.4 272 304 272a39.65 39.65 0 0129.48 12.51zM192 80a16 16 0 0116-16h96a16 16 0 010 32h-96a16 16 0 01-16-16zm189 363.83a12.05 12.05 0 01-9.31 4.17H236.31a12.05 12.05 0 01-9.31-4.17 13 13 0 01-2.76-10.92c3.25-17.56 13.38-32.31 29.3-42.66C267.68 381.06 285.6 376 304 376s36.32 5.06 50.46 14.25c15.92 10.35 26.05 25.1 29.3 42.66a13 13 0 01-2.76 10.92z"}}]})(props);
	};
	module.exports.IoImageOutline = function IoImageOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"352","x":"48","y":"80","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}},{"tag":"circle","attr":{"cx":"336","cy":"176","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M304 335.79l-90.66-90.49a32 32 0 00-43.87-1.3L48 352m176 80l123.34-123.34a32 32 0 0143.11-2L464 368"}}]})(props);
	};
	module.exports.IoImageSharp = function IoImageSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456 64H56a24 24 0 00-24 24v336a24 24 0 0024 24h400a24 24 0 0024-24V88a24 24 0 00-24-24zm-124.38 64.2a48 48 0 11-43.42 43.42 48 48 0 0143.42-43.42zM76 416a12 12 0 01-12-12v-87.63L192.64 202l96.95 96.75L172.37 416zm372-12a12 12 0 01-12 12H217.63l149.53-149.53L448 333.84z"}}]})(props);
	};
	module.exports.IoImage = function IoImage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 64H96a64.07 64.07 0 00-64 64v256a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64V128a64.07 64.07 0 00-64-64zm-80 64a48 48 0 11-48 48 48.05 48.05 0 0148-48zM96 416a32 32 0 01-32-32v-67.63l94.84-84.3a48.06 48.06 0 0165.8 1.9l64.95 64.81L172.37 416zm352-32a32 32 0 01-32 32H217.63l121.42-121.42a47.72 47.72 0 0161.64-.16L448 333.84z"}}]})(props);
	};
	module.exports.IoImagesOutline = function IoImagesOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M432 112V96a48.14 48.14 0 00-48-48H64a48.14 48.14 0 00-48 48v256a48.14 48.14 0 0048 48h16"}},{"tag":"rect","attr":{"width":"400","height":"336","x":"96","y":"128","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"45.99","ry":"45.99"}},{"tag":"ellipse","attr":{"cx":"372.92","cy":"219.64","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"30.77","ry":"30.55"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M342.15 372.17L255 285.78a30.93 30.93 0 00-42.18-1.21L96 387.64M265.23 464l118.59-117.73a31 31 0 0141.46-1.87L496 402.91"}}]})(props);
	};
	module.exports.IoImagesSharp = function IoImagesSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"ellipse","attr":{"cx":"373.14","cy":"219.33","fill":"none","rx":"46.29","ry":"46"}},{"tag":"path","attr":{"d":"M80 132v328a20 20 0 0020 20h392a20 20 0 0020-20V132a20 20 0 00-20-20H100a20 20 0 00-20 20zm293.14 41.33a46 46 0 11-46.28 46 46.19 46.19 0 0146.28-46zm-261.41 276v-95.48l122.76-110.2L328.27 337l-113 112.33zm368.27 0H259l144.58-144L480 370.59z"}},{"tag":"path","attr":{"d":"M20 32A20 20 0 000 52v344a20 20 0 0020 20h28V100a20 20 0 0120-20h380V52a20 20 0 00-20-20z"}}]})(props);
	};
	module.exports.IoImages = function IoImages (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450.29 112H142c-34 0-62 27.51-62 61.33v245.34c0 33.82 28 61.33 62 61.33h308c34 0 62-26.18 62-60V173.33c0-33.82-27.68-61.33-61.71-61.33zm-77.15 61.34a46 46 0 11-46.28 46 46.19 46.19 0 0146.28-46.01zm-231.55 276c-17 0-29.86-13.75-29.86-30.66v-64.83l90.46-80.79a46.54 46.54 0 0163.44 1.83L328.27 337l-113 112.33zM480 418.67a30.67 30.67 0 01-30.71 30.66H259L376.08 333a46.24 46.24 0 0159.44-.16L480 370.59z"}},{"tag":"path","attr":{"d":"M384 32H64A64 64 0 000 96v256a64.11 64.11 0 0048 62V152a72 72 0 0172-72h326a64.11 64.11 0 00-62-48z"}}]})(props);
	};
	module.exports.IoInfiniteOutline = function IoInfiniteOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 256s-48-96-126-96c-54.12 0-98 43-98 96s43.88 96 98 96c37.51 0 71-22.41 94-48m32-48s48 96 126 96c54.12 0 98-43 98-96s-43.88-96-98-96c-37.51 0-71 22.41-94 48"}}]})(props);
	};
	module.exports.IoInfiniteSharp = function IoInfiniteSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M382 136c-40.87 0-73.46 20.53-93.6 37.76l-.71.61-11.47 12.47 25.32 41.61 18.74-18.79C339.89 193.1 361.78 184 382 184c40.8 0 74 32.3 74 72s-33.2 72-74 72c-62 0-104.14-81.95-104.56-82.78C275 240.29 221.56 136 130 136 62.73 136 8 189.83 8 256s54.73 120 122 120c32.95 0 65.38-13.11 93.79-37.92l.61-.54 11.38-12.38-25.33-41.61-18.83 18.88C172 319.4 151.26 328 130 328c-40.8 0-74-32.3-74-72s33.2-72 74-72c62 0 104.14 81.95 104.56 82.78C237 271.71 290.44 376 382 376c67.27 0 122-53.83 122-120s-54.73-120-122-120z"}}]})(props);
	};
	module.exports.IoInfinite = function IoInfinite (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"48","d":"M256 256s-48-96-126-96c-54.12 0-98 43-98 96s43.88 96 98 96c30 0 56.45-13.18 78-32m48-64s48 96 126 96c54.12 0 98-43 98-96s-43.88-96-98-96c-29.37 0-56.66 13.75-78 32"}}]})(props);
	};
	module.exports.IoInformationCircleOutline = function IoInformationCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M220 220h32v116"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M208 340h88"}},{"tag":"path","attr":{"d":"M248 130a26 26 0 1026 26 26 26 0 00-26-26z"}}]})(props);
	};
	module.exports.IoInformationCircleSharp = function IoInformationCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56zm0 82a26 26 0 11-26 26 26 26 0 0126-26zm64 226H200v-32h44v-88h-32v-32h64v120h44z"}}]})(props);
	};
	module.exports.IoInformationCircle = function IoInformationCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56zm0 82a26 26 0 11-26 26 26 26 0 0126-26zm48 226h-88a16 16 0 010-32h28v-88h-16a16 16 0 010-32h32a16 16 0 0116 16v104h28a16 16 0 010 32z"}}]})(props);
	};
	module.exports.IoInformationOutline = function IoInformationOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"40","d":"M196 220h64v172"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"40","d":"M187 396h138"}},{"tag":"path","attr":{"d":"M256 160a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoInformationSharp = function IoInformationSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"40","d":"M196 220h64v172m-73 4h138"}},{"tag":"path","attr":{"d":"M256 160a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoInformation = function IoInformation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"40","d":"M196 220h64v172"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"40","d":"M187 396h138"}},{"tag":"path","attr":{"d":"M256 160a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoInvertModeOutline = function IoInvertModeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"208","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"d":"M256 176v160a80 80 0 010-160zm0-128v128a80 80 0 010 160v128c114.88 0 208-93.12 208-208S370.88 48 256 48z"}}]})(props);
	};
	module.exports.IoInvertModeSharp = function IoInvertModeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM256 432v-96a80 80 0 010-160V80c97.05 0 176 79 176 176s-78.95 176-176 176z"}},{"tag":"path","attr":{"d":"M336 256a80 80 0 00-80-80v160a80 80 0 0080-80z"}}]})(props);
	};
	module.exports.IoInvertMode = function IoInvertMode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"208","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"d":"M256 176v160a80 80 0 000-160zm0-128v128a80 80 0 000 160v128c-114.88 0-208-93.12-208-208S141.12 48 256 48z"}}]})(props);
	};
	module.exports.IoJournalOutline = function IoJournalOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"320","height":"416","x":"96","y":"48","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"60","d":"M320 48v416"}}]})(props);
	};
	module.exports.IoJournalSharp = function IoJournalSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M290 32H104a24 24 0 00-24 24v400a24 24 0 0024 24h186zm118 0h-58v448h58a24 24 0 0024-24V56a24 24 0 00-24-24z"}}]})(props);
	};
	module.exports.IoJournal = function IoJournal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M290 32H144a64.07 64.07 0 00-64 64v320a64.07 64.07 0 0064 64h146zm78 0h-18v448h18a64.07 64.07 0 0064-64V96a64.07 64.07 0 00-64-64z"}}]})(props);
	};
	module.exports.IoKeyOutline = function IoKeyOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M218.1 167.17c0 13 0 25.6 4.1 37.4-43.1 50.6-156.9 184.3-167.5 194.5a20.17 20.17 0 00-6.7 15c0 8.5 5.2 16.7 9.6 21.3 6.6 6.9 34.8 33 40 28 15.4-15 18.5-19 24.8-25.2 9.5-9.3-1-28.3 2.3-36s6.8-9.2 12.5-10.4 15.8 2.9 23.7 3c8.3.1 12.8-3.4 19-9.2 5-4.6 8.6-8.9 8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7 6.2 34 5 22.8-15.5 24.1-21.6-11.7-21.8-9.7-30.7c.7-3 6.8-10 11.4-11s25 6.9 29.6 5.9c5.6-1.2 12.1-7.1 17.4-10.4 15.5 6.7 29.6 9.4 47.7 9.4 68.5 0 124-53.4 124-119.2S408.5 48 340 48s-121.9 53.37-121.9 119.17zM400 144a32 32 0 11-32-32 32 32 0 0132 32z"}}]})(props);
	};
	module.exports.IoKeySharp = function IoKeySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M218.1 167.2c0 13 0 25.6 4.1 37.4-43.1 50.6-167.5 194.5-167.5 194.5l2.9 36.3s34.8 33 40 28c15.4-15 24.8-25.2 24.8-25.2l7.24-43.35 47.11-3.47 3.78-46.8 49.63-.95.49-50.09 52.69 2.1 9-18.84c15.5 6.7 29.6 9.4 47.7 9.4 68.5 0 124-53.4 124-119.2S408.5 48 340 48s-121.9 53.4-121.9 119.2zM406.85 144A38.85 38.85 0 11368 105.15 38.81 38.81 0 01406.85 144z"}}]})(props);
	};
	module.exports.IoKey = function IoKey (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M218.1 167.17c0 13 0 25.6 4.1 37.4-43.1 50.6-156.9 184.3-167.5 194.5a20.17 20.17 0 00-6.7 15c0 8.5 5.2 16.7 9.6 21.3 6.6 6.9 34.8 33 40 28 15.4-15 18.5-19 24.8-25.2 9.5-9.3-1-28.3 2.3-36s6.8-9.2 12.5-10.4 15.8 2.9 23.7 3c8.3.1 12.8-3.4 19-9.2 5-4.6 8.6-8.9 8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7 6.2 34 5 22.8-15.5 24.1-21.6-11.7-21.8-9.7-30.7c.7-3 6.8-10 11.4-11s25 6.9 29.6 5.9c5.6-1.2 12.1-7.1 17.4-10.4 15.5 6.7 29.6 9.4 47.7 9.4 68.5 0 124-53.4 124-119.2S408.5 48 340 48s-121.9 53.37-121.9 119.17zM400 144a32 32 0 11-32-32 32 32 0 0132 32z"}}]})(props);
	};
	module.exports.IoKeypadOutline = function IoKeypadOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"448","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"320","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M288 192a32 32 0 11-32-32 32 32 0 0132 32z"}},{"tag":"circle","attr":{"cx":"256","cy":"64","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"384","cy":"320","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"384","cy":"192","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"384","cy":"64","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"128","cy":"320","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"128","cy":"192","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"128","cy":"64","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoKeypadSharp = function IoKeypadSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"96","height":"96","x":"80","y":"16","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"96","height":"96","x":"208","y":"16","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"96","height":"96","x":"336","y":"16","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"96","height":"96","x":"80","y":"144","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"96","height":"96","x":"208","y":"144","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"96","height":"96","x":"336","y":"144","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"96","height":"96","x":"80","y":"272","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"96","height":"96","x":"208","y":"272","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"96","height":"96","x":"208","y":"400","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"96","height":"96","x":"336","y":"272","rx":"8","ry":"8"}}]})(props);
	};
	module.exports.IoKeypad = function IoKeypad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 400a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm128 256a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zM128 272a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48z"}}]})(props);
	};
	module.exports.IoLanguageOutline = function IoLanguageOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 112h288M192 64v48m80 336l96-224 96 224m-162.5-64h133M281.3 112S257 206 199 277 80 384 80 384"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 336s-35-27-72-75-56-85-56-85"}}]})(props);
	};
	module.exports.IoLanguageSharp = function IoLanguageSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M363 176L246 464h47.24l24.49-58h90.54l24.49 58H480zm-26.69 186L363 279.85 389.69 362zM272 320c-.25-.19-20.59-15.77-45.42-42.67 39.58-53.64 62-114.61 71.15-143.33H352V90H214V48h-44v42H32v44h219.25c-9.52 26.95-27.05 69.5-53.79 108.36-32.68-43.44-47.14-75.88-47.33-76.22L143 152l-38 22 6.87 13.86c.89 1.56 17.19 37.9 54.71 86.57.92 1.21 1.85 2.39 2.78 3.57-49.72 56.86-89.15 79.09-89.66 79.47L64 368l23 36 19.3-11.47c2.2-1.67 41.33-24 92-80.78 24.52 26.28 43.22 40.83 44.3 41.67L255 362z"}}]})(props);
	};
	module.exports.IoLanguage = function IoLanguage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M478.33 433.6l-90-218a22 22 0 00-40.67 0l-90 218a22 22 0 1040.67 16.79L316.66 406h102.67l18.33 44.39A22 22 0 00458 464a22 22 0 0020.32-30.4zM334.83 362L368 281.65 401.17 362zm-66.99-19.08a22 22 0 00-4.89-30.7c-.2-.15-15-11.13-36.49-34.73 39.65-53.68 62.11-114.75 71.27-143.49H330a22 22 0 000-44H214V70a22 22 0 00-44 0v20H54a22 22 0 000 44h197.25c-9.52 26.95-27.05 69.5-53.79 108.36-31.41-41.68-43.08-68.65-43.17-68.87a22 22 0 00-40.58 17c.58 1.38 14.55 34.23 52.86 83.93.92 1.19 1.83 2.35 2.74 3.51-39.24 44.35-77.74 71.86-93.85 80.74a22 22 0 1021.07 38.63c2.16-1.18 48.6-26.89 101.63-85.59 22.52 24.08 38 35.44 38.93 36.1a22 22 0 0030.75-4.9z"}}]})(props);
	};
	module.exports.IoLaptopOutline = function IoLaptopOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"304","x":"48","y":"96","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"32.14","ry":"32.14"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M16 416h480"}}]})(props);
	};
	module.exports.IoLaptopSharp = function IoLaptopSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M477.29 400a27.75 27.75 0 002.71-12V108a28 28 0 00-28-28H60a28 28 0 00-28 28v280a27.75 27.75 0 002.71 12H0v32h512v-32z"}}]})(props);
	};
	module.exports.IoLaptop = function IoLaptop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 400h-28.34A47.92 47.92 0 00480 367.86V128.14A48.2 48.2 0 00431.86 80H80.14A48.2 48.2 0 0032 128.14v239.72A47.92 47.92 0 0044.34 400H16a16 16 0 000 32h480a16 16 0 000-32z"}}]})(props);
	};
	module.exports.IoLayersOutline = function IoLayersOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M434.8 137.65l-149.36-68.1c-16.19-7.4-42.69-7.4-58.88 0L77.3 137.65c-17.6 8-17.6 21.09 0 29.09l148 67.5c16.89 7.7 44.69 7.7 61.58 0l148-67.5c17.52-8 17.52-21.1-.08-29.09zM160 308.52l-82.7 37.11c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.89 7.69 44.69 7.69 61.58 0l148-67.5c17.6-8 17.6-21.1 0-29.1l-79.94-38.47"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 204.48l-82.8 37.16c-17.6 8-17.6 21.1 0 29.1l148 67.49c16.89 7.7 44.69 7.7 61.58 0l148-67.49c17.7-8 17.7-21.1.1-29.1L352 204.48"}}]})(props);
	};
	module.exports.IoLayersSharp = function IoLayersSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 150L256 48 32 150l224 104 224-104zM255.71 392.95l-144.81-66.2L32 362l224 102 224-102-78.69-35.3-145.6 66.25z"}},{"tag":"path","attr":{"d":"M480 256l-75.53-33.53L256.1 290.6l-148.77-68.17L32 256l224 102 224-102z"}}]})(props);
	};
	module.exports.IoLayers = function IoLayers (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 256c-13.47 0-26.94-2.39-37.44-7.17l-148-67.49C63.79 178.26 48 169.25 48 152.24s15.79-26 22.58-29.12l149.28-68.07c20.57-9.4 51.61-9.4 72.19 0l149.37 68.07c6.79 3.09 22.58 12.1 22.58 29.12s-15.79 26-22.58 29.11l-148 67.48C282.94 253.61 269.47 256 256 256zm176.76-100.86z"}},{"tag":"path","attr":{"d":"M441.36 226.81L426.27 220l-38.77 17.74-94 43c-10.5 4.8-24 7.19-37.44 7.19s-26.93-2.39-37.42-7.19l-94.07-43L85.79 220l-15.22 6.84C63.79 229.93 48 239 48 256s15.79 26.08 22.56 29.17l148 67.63C229 357.6 242.49 360 256 360s26.94-2.4 37.44-7.19l147.87-67.61c6.81-3.09 22.69-12.11 22.69-29.2s-15.77-26.07-22.64-29.19z"}},{"tag":"path","attr":{"d":"M441.36 330.8l-15.09-6.8-38.77 17.73-94 42.95c-10.5 4.78-24 7.18-37.44 7.18s-26.93-2.39-37.42-7.18l-94.07-43L85.79 324l-15.22 6.84C63.79 333.93 48 343 48 360s15.79 26.07 22.56 29.15l148 67.59C229 461.52 242.54 464 256 464s26.88-2.48 37.38-7.27l147.92-67.57c6.82-3.08 22.7-12.1 22.7-29.16s-15.77-26.07-22.64-29.2z"}}]})(props);
	};
	module.exports.IoLeafOutline = function IoLeafOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M321.89 171.42C233 114 141 155.22 56 65.22c-19.8-21-8.3 235.5 98.1 332.7 77.79 71 197.9 63.08 238.4-5.92s18.28-163.17-70.61-220.58zM173 253c86 81 175 129 292 147"}}]})(props);
	};
	module.exports.IoLeafSharp = function IoLeafSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M150.38 253.68l21.94-23.3 11.65 11c73.63 69.36 147.51 111.56 234.45 133.07 11.73-32 12.77-67.22 2.64-101.58-13.44-45.59-44.74-85.31-90.49-114.86-40.25-26-76.6-32.09-115.09-38.54-21.12-3.54-43-7.2-66.85-14.43-43.78-13.28-89.69-52.74-90.15-53.13L33.4 30.15 32 63.33c-.1 2.56-2.42 63.57 14.22 147.77 17.58 89 50.24 155.85 97.07 198.63 38 34.69 87.62 53.9 136.93 53.9a185.88 185.88 0 0027.78-2.07c41.72-6.32 76.43-27.27 96-57.75-89.5-23.28-165.95-67.55-242-139.16z"}},{"tag":"path","attr":{"d":"M467.43 384.19c-16.83-2.59-33.13-5.84-49-9.77a158.49 158.49 0 01-12.13 25.68c-.74 1.25-1.51 2.49-2.29 3.71a583.43 583.43 0 0058.55 12l15.82 2.44 4.86-31.63z"}}]})(props);
	};
	module.exports.IoLeaf = function IoLeaf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M161.35 242a16 16 0 0122.62-.68c73.63 69.36 147.51 111.56 234.45 133.07 11.73-32 12.77-67.22 2.64-101.58-13.44-45.59-44.74-85.31-90.49-114.86-40.84-26.38-81.66-33.25-121.15-39.89-49.82-8.38-96.88-16.3-141.79-63.85-5-5.26-11.81-7.37-18.32-5.66-7.44 2-12.43 7.88-14.82 17.6-5.6 22.75-2 86.51 13.75 153.82 25.29 108.14 65.65 162.86 95.06 189.73 38 34.69 87.62 53.9 136.93 53.9a186 186 0 0027.77-2.04c41.71-6.32 76.43-27.27 96-57.75-89.49-23.28-165.94-67.55-242-139.16a16 16 0 01-.65-22.65zm306.08 142.19c-16.83-2.59-33.13-5.84-49-9.77a157.71 157.71 0 01-12.13 25.68c-.73 1.25-1.5 2.49-2.29 3.71a584.21 584.21 0 0058.56 12 16 16 0 104.87-31.62z"}}]})(props);
	};
	module.exports.IoLibraryOutline = function IoLibraryOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"64","height":"368","x":"32","y":"96","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"16","ry":"16"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 224h128M112 400h128"}},{"tag":"rect","attr":{"width":"128","height":"304","x":"112","y":"160","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"16","ry":"16"}},{"tag":"rect","attr":{"width":"96","height":"416","x":"256","y":"48","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"16","ry":"16"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M422.46 96.11l-40.4 4.25c-11.12 1.17-19.18 11.57-17.93 23.1l34.92 321.59c1.26 11.53 11.37 20 22.49 18.84l40.4-4.25c11.12-1.17 19.18-11.57 17.93-23.1L445 115c-1.31-11.58-11.42-20.06-22.54-18.89z"}}]})(props);
	};
	module.exports.IoLibrarySharp = function IoLibrarySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M84 480H28a12 12 0 01-12-12V92a12 12 0 0112-12h56a12 12 0 0112 12v376a12 12 0 01-12 12zm156-272v-52a12 12 0 00-12-12H124a12 12 0 00-12 12v52zM112 416v52a12 12 0 0012 12h104a12 12 0 0012-12v-52zm0-176h128v144H112zm228 240h-72a12 12 0 01-12-12V44a12 12 0 0112-12h72a12 12 0 0112 12v424a12 12 0 01-12 12zm29-379.3l30 367.83a12 12 0 0013.45 10.92l72.16-9a12 12 0 0010.47-12.9L465 91.21a12 12 0 00-13.2-10.94l-72.13 7.51A12 12 0 00369 100.7z"}}]})(props);
	};
	module.exports.IoLibrary = function IoLibrary (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 480H48a32 32 0 01-32-32V112a32 32 0 0132-32h16a32 32 0 0132 32v336a32 32 0 01-32 32zm176-304a32 32 0 00-32-32h-64a32 32 0 00-32 32v28a4 4 0 004 4h120a4 4 0 004-4zM112 448a32 32 0 0032 32h64a32 32 0 0032-32v-30a2 2 0 00-2-2H114a2 2 0 00-2 2z"}},{"tag":"rect","attr":{"width":"128","height":"144","x":"112","y":"240","rx":"2","ry":"2"}},{"tag":"path","attr":{"d":"M320 480h-32a32 32 0 01-32-32V64a32 32 0 0132-32h32a32 32 0 0132 32v384a32 32 0 01-32 32zm175.89-34.55l-32.23-340c-1.48-15.65-16.94-27-34.53-25.31l-31.85 3c-17.59 1.67-30.65 15.71-29.17 31.36l32.23 340c1.48 15.65 16.94 27 34.53 25.31l31.85-3c17.59-1.67 30.65-15.71 29.17-31.36z"}}]})(props);
	};
	module.exports.IoLinkOutline = function IoLinkOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"36","d":"M208 352h-64a96 96 0 010-192h64m96 0h64a96 96 0 010 192h-64m-140.71-96h187.42"}}]})(props);
	};
	module.exports.IoLinkSharp = function IoLinkSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"48","d":"M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66m-142.27-96h175.86"}}]})(props);
	};
	module.exports.IoLink = function IoLink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66m-142.27-96h175.86"}}]})(props);
	};
	module.exports.IoListCircleOutline = function IoListCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M224 184h128m-128 72h128m-128 71h128"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 258c0-106-86-192-192-192S64 152 64 258s86 192 192 192 192-86 192-192z"}},{"tag":"circle","attr":{"cx":"168","cy":"184","r":"8","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"168","cy":"257","r":"8","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"168","cy":"328","r":"8","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoListCircleSharp = function IoListCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-64 287.5a16 16 0 01-16 16h-16a16 16 0 01-16-16v-16a16 16 0 0116-16h16a16 16 0 0116 16zm0-71a16 16 0 01-16 16h-16a16 16 0 01-16-16v-16a16 16 0 0116-16h16a16 16 0 0116 16zm0-72a16 16 0 01-16 16h-16a16 16 0 01-16-16v-16a16 16 0 0116-16h16a16 16 0 0116 16zm176 151H212.67v-32H368zm0-71H212.67v-32H368zm0-72H212.67v-32H368z"}}]})(props);
	};
	module.exports.IoListCircle = function IoListCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-88 302a24 24 0 1124-24 24 24 0 01-24 24zm0-71a24 24 0 1124-24 24 24 0 01-24 24zm0-73a24 24 0 1124-24 24 24 0 01-24 24zm184 135H224a16 16 0 010-32h128a16 16 0 010 32zm0-71H224a16 16 0 010-32h128a16 16 0 010 32zm0-72H224a16 16 0 010-32h128a16 16 0 010 32z"}}]})(props);
	};
	module.exports.IoListOutline = function IoListOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 144h288M160 256h288M160 368h288"}},{"tag":"circle","attr":{"cx":"80","cy":"144","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"80","cy":"256","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"80","cy":"368","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoListSharp = function IoListSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"48","d":"M144 144h320M144 256h320M144 368h320"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"32","d":"M64 128h32v32H64zm0 112h32v32H64zm0 112h32v32H64z"}}]})(props);
	};
	module.exports.IoList = function IoList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M160 144h288M160 256h288M160 368h288"}},{"tag":"circle","attr":{"cx":"80","cy":"144","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"80","cy":"256","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"80","cy":"368","r":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoLocateOutline = function IoLocateOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M256 96V56m0 400v-40"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 112a144 144 0 10144 144 144 144 0 00-144-144z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M416 256h40m-400 0h40"}}]})(props);
	};
	module.exports.IoLocateSharp = function IoLocateSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"48","d":"M256 96V56m0 400v-40m0-304a144 144 0 10144 144 144 144 0 00-144-144zm160 144h40m-400 0h40"}}]})(props);
	};
	module.exports.IoLocate = function IoLocate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M256 96V56m0 400v-40m0-304a144 144 0 10144 144 144 144 0 00-144-144zm160 144h40m-400 0h40"}}]})(props);
	};
	module.exports.IoLocationOutline = function IoLocationOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 48c-79.5 0-144 61.39-144 137 0 87 96 224.87 131.25 272.49a15.77 15.77 0 0025.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137z"}},{"tag":"circle","attr":{"cx":"256","cy":"192","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoLocationSharp = function IoLocationSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C167.67 32 96 96.51 96 176c0 128 160 304 160 304s160-176 160-304c0-79.49-71.67-144-160-144zm0 224a64 64 0 1164-64 64.07 64.07 0 01-64 64z"}}]})(props);
	};
	module.exports.IoLocation = function IoLocation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"192","r":"32"}},{"tag":"path","attr":{"d":"M256 32c-88.22 0-160 68.65-160 153 0 40.17 18.31 93.59 54.42 158.78 29 52.34 62.55 99.67 80 123.22a31.75 31.75 0 0051.22 0c17.42-23.55 51-70.88 80-123.22C397.69 278.61 416 225.19 416 185c0-84.35-71.78-153-160-153zm0 224a64 64 0 1164-64 64.07 64.07 0 01-64 64z"}}]})(props);
	};
	module.exports.IoLockClosedOutline = function IoLockClosedOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M336 208v-95a80 80 0 00-160 0v95"}},{"tag":"rect","attr":{"width":"320","height":"272","x":"96","y":"208","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}}]})(props);
	};
	module.exports.IoLockClosedSharp = function IoLockClosedSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M420 192h-68v-80a96 96 0 10-192 0v80H92a12 12 0 00-12 12v280a12 12 0 0012 12h328a12 12 0 0012-12V204a12 12 0 00-12-12zm-106 0H198v-80.75a58 58 0 11116 0z"}}]})(props);
	};
	module.exports.IoLockClosed = function IoLockClosed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 192h-16v-80a96 96 0 10-192 0v80h-16a64.07 64.07 0 00-64 64v176a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V256a64.07 64.07 0 00-64-64zm-48 0H192v-80a64 64 0 11128 0z"}}]})(props);
	};
	module.exports.IoLockOpenOutline = function IoLockOpenOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M336 112a80 80 0 00-160 0v96"}},{"tag":"rect","attr":{"width":"320","height":"272","x":"96","y":"208","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}}]})(props);
	};
	module.exports.IoLockOpenSharp = function IoLockOpenSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M420 192H198v-80.75a58.08 58.08 0 0199.07-41.07A59.4 59.4 0 01314 112h38a96 96 0 10-192 0v80H92a12 12 0 00-12 12v280a12 12 0 0012 12h328a12 12 0 0012-12V204a12 12 0 00-12-12z"}}]})(props);
	};
	module.exports.IoLockOpen = function IoLockOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 192H192v-80a64 64 0 11128 0 16 16 0 0032 0 96 96 0 10-192 0v80h-16a64.07 64.07 0 00-64 64v176a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V256a64.07 64.07 0 00-64-64z"}}]})(props);
	};
	module.exports.IoLogInOutline = function IoLogInOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M192 176v-40a40 40 0 0140-40h160a40 40 0 0140 40v240a40 40 0 01-40 40H240c-22.09 0-48-17.91-48-40v-40"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M288 336l80-80-80-80M80 256h272"}}]})(props);
	};
	module.exports.IoLogInSharp = function IoLogInSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 80H192a16 16 0 00-16 16v144h153.37l-64-64L288 153.37l91.31 91.32a16 16 0 010 22.62L288 358.63 265.37 336l64-64H176v144a16 16 0 0016 16h240a16 16 0 0016-16V96a16 16 0 00-16-16zM64 240h112v32H64z"}}]})(props);
	};
	module.exports.IoLogIn = function IoLogIn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M392 80H232a56.06 56.06 0 00-56 56v104h153.37l-52.68-52.69a16 16 0 0122.62-22.62l80 80a16 16 0 010 22.62l-80 80a16 16 0 01-22.62-22.62L329.37 272H176v104c0 32.05 33.79 56 64 56h152a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56zM80 240a16 16 0 000 32h96v-32z"}}]})(props);
	};
	module.exports.IoLogOutOutline = function IoLogOutOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M304 336v40a40 40 0 01-40 40H104a40 40 0 01-40-40V136a40 40 0 0140-40h152c22.09 0 48 17.91 48 40v40m64 160l80-80-80-80m-192 80h256"}}]})(props);
	};
	module.exports.IoLogOutSharp = function IoLogOutSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 240h160V96a16 16 0 00-16-16H64a16 16 0 00-16 16v320a16 16 0 0016 16h240a16 16 0 0016-16V272H160zm299.31 4.69L368 153.37 345.37 176l64 64H320v32h89.37l-64 64L368 358.63l91.31-91.32a16 16 0 000-22.62z"}}]})(props);
	};
	module.exports.IoLogOut = function IoLogOut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 256a16 16 0 0116-16h144V136c0-32-33.79-56-64-56H104a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h160a56.06 56.06 0 0056-56V272H176a16 16 0 01-16-16zm299.31-11.31l-80-80a16 16 0 00-22.62 22.62L409.37 240H320v32h89.37l-52.68 52.69a16 16 0 1022.62 22.62l80-80a16 16 0 000-22.62z"}}]})(props);
	};
	module.exports.IoLogoAlipay = function IoLogoAlipay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M102.41 32C62.38 32 32 64.12 32 103.78v304.45C32 447.86 64.38 480 104.41 480h303.2c40 0 72.39-32.14 72.39-71.77v-3.11c-1.35-.56-115.47-48.57-174.5-76.7-39.82 48.57-91.18 78-144.5 78-90.18 0-120.8-78.22-78.1-129.72 9.31-11.22 25.15-21.94 49.73-28 38.45-9.36 99.64 5.85 157 24.61a309.41 309.41 0 0025.46-61.67H138.34V194h91.13v-31.83H119.09v-17.75h110.38V99s0-7.65 7.82-7.65h44.55v53H391v17.75H281.84V194h89.08a359.41 359.41 0 01-37.72 94.43c27 9.69 49.31 18.88 67.39 24.89 60.32 20 77.23 22.45 79.41 22.7V103.78C480 64.12 447.6 32 407.61 32h-305.2zM152 274.73q-5.81.06-11.67.63c-11.3 1.13-32.5 6.07-44.09 16.23-34.74 30-13.94 84.93 56.37 84.93 40.87 0 81.71-25.9 113.79-67.37-41.36-20-77-34.85-114.4-34.42z"}}]})(props);
	};
	module.exports.IoLogoAmazon = function IoLogoAmazon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48.48 378.73a300.52 300.52 0 00152.89 95.92 262.57 262.57 0 00159.3-17.25 225.52 225.52 0 0066.79-47 6.36 6.36 0 00-2-8.53 11.76 11.76 0 00-8-.05 401.92 401.92 0 01-116.55 39.34 358.13 358.13 0 01-127.29-8.83 446.73 446.73 0 01-119.1-60.49 5 5 0 00-6.06 6.9z"}},{"tag":"path","attr":{"d":"M387.15 388.44a168.11 168.11 0 0148.94-2.23l.67.13a10 10 0 017.37 12.05A204.71 204.71 0 01429 444.47a2.55 2.55 0 001.66 3.18 2.51 2.51 0 002.23-.37A83.31 83.31 0 00464 382.86a12.44 12.44 0 00-10.22-13.22A95.75 95.75 0 00384.91 384a2.55 2.55 0 00-.57 3.55 2.52 2.52 0 002.81.89zm-82.91-63.52a164 164 0 01-28.92 25.3A135.16 135.16 0 01208.63 369a99.49 99.49 0 01-57.49-19.85 97.25 97.25 0 01-27.36-100.28 112.35 112.35 0 0165.3-69.06 367.67 367.67 0 01104.7-15.55V127A37.82 37.82 0 00261 94.72a59.9 59.9 0 00-31.17 4.08 48.89 48.89 0 00-27.13 34.67 12 12 0 01-12.58 6.72l-50.9-4.5a11.38 11.38 0 01-8.38-10.16 103.66 103.66 0 0136.61-63.45A143.86 143.86 0 01257.85 32a146.24 146.24 0 0184.27 27.67 86.82 86.82 0 0130.7 70.22V258.8a84.46 84.46 0 008 31.28l15.87 23.23a13 13 0 010 11.23l-46.99 39.71a12.5 12.5 0 01-12.68-.44 244.84 244.84 0 01-32.78-38.89zm-10.6-116.83a257.68 257.68 0 00-44 2.89A63 63 0 00208 242.54a63 63 0 003.07 54 40.6 40.6 0 0047.11 12.19 78.61 78.61 0 0035.46-55.58v-45.06"}}]})(props);
	};
	module.exports.IoLogoAmplify = function IoLogoAmplify (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M112.31 268l40.36-68.69 34.65 59-67.54 115h135L289.31 432H16zm58.57-99.76l33.27-56.67L392.44 432h-66.68zM222.67 80h66.59L496 432h-66.68z"}}]})(props);
	};
	module.exports.IoLogoAndroid = function IoLogoAndroid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M380.91 199l42.47-73.57a8.63 8.63 0 00-3.12-11.76 8.52 8.52 0 00-11.71 3.12l-43 74.52c-32.83-15-69.78-23.35-109.52-23.35s-76.69 8.36-109.52 23.35l-43-74.52a8.6 8.6 0 10-14.88 8.64L131 199C57.8 238.64 8.19 312.77 0 399.55h512c-8.19-86.78-57.8-160.91-131.09-200.55zM138.45 327.65a21.46 21.46 0 1121.46-21.46 21.47 21.47 0 01-21.46 21.46zm235 0A21.46 21.46 0 11395 306.19a21.47 21.47 0 01-21.51 21.46z"}}]})(props);
	};
	module.exports.IoLogoAngular = function IoLogoAngular (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M213.57 256h84.85l-42.43-89.36L213.57 256z"}},{"tag":"path","attr":{"d":"M256 32L32 112l46.12 272L256 480l177.75-96L480 112zm88 320l-26.59-56H194.58L168 352h-40L256 72l128 280z"}}]})(props);
	};
	module.exports.IoLogoAppleAppstore = function IoLogoAppleAppstore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.26 32 32 132.26 32 256s100.26 224 224 224 224-100.26 224-224S379.74 32 256 32zm-85 321.89a15.48 15.48 0 01-13.46 7.65 14.91 14.91 0 01-7.86-2.16 15.48 15.48 0 01-5.6-21.21l15.29-25.42a8.73 8.73 0 017.54-4.3h2.26c11.09 0 18.85 6.67 21.11 13.13zm129.45-50l-100.13.11h-66.55a15.46 15.46 0 01-15.51-16.15c.32-8.4 7.65-14.76 16-14.76h48.24l57.19-97.35-18.52-31.55C217 137 218.85 127.52 226 123a15.57 15.57 0 0121.87 5.17l9.9 16.91h.11l9.91-16.91A15.58 15.58 0 01289.6 123c7.11 4.52 8.94 14 4.74 21.22l-18.52 31.55-18 30.69-39.09 66.66v.11h57.61c7.22 0 16.27 3.88 19.93 10.12l.32.65c3.23 5.49 5.06 9.26 5.06 14.75a13.82 13.82 0 01-1.17 5.17zm77.75.11h-27.11v.11l19.82 33.71a15.8 15.8 0 01-5.17 21.53 15.53 15.53 0 01-8.08 2.27A15.71 15.71 0 01344.2 354l-29.29-49.86-18.2-31L273.23 233a38.35 38.35 0 01-.65-38c4.64-8.19 8.19-10.34 8.19-10.34L333 273h44.91c8.4 0 15.61 6.46 16 14.75A15.65 15.65 0 01378.23 304z"}}]})(props);
	};
	module.exports.IoLogoAppleAr = function IoLogoAppleAr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M201.14 64L256 32l54.86 32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 32v80"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M310.86 448L256 480l-54.86-32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 480v-80"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M64 207.51V144l53.15-31.51"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M64 144l67.29 40"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M448 304.49V368l-53.15 31.51"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 368l-67.29-40"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M117.15 400L64 368v-63.51"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M64 368l66.64-40"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M394.85 112.49L448 144v63.51"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 144l-67.29 40M256 320v-64l54.86-32M256 256l-54.86-32"}}]})(props);
	};
	module.exports.IoLogoApple = function IoLogoApple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M349.13 136.86c-40.32 0-57.36 19.24-85.44 19.24-28.79 0-50.75-19.1-85.69-19.1-34.2 0-70.67 20.88-93.83 56.45-32.52 50.16-27 144.63 25.67 225.11 18.84 28.81 44 61.12 77 61.47h.6c28.68 0 37.2-18.78 76.67-19h.6c38.88 0 46.68 18.89 75.24 18.89h.6c33-.35 59.51-36.15 78.35-64.85 13.56-20.64 18.6-31 29-54.35-76.19-28.92-88.43-136.93-13.08-178.34-23-28.8-55.32-45.48-85.79-45.48z"}},{"tag":"path","attr":{"d":"M340.25 32c-24 1.63-52 16.91-68.4 36.86-14.88 18.08-27.12 44.9-22.32 70.91h1.92c25.56 0 51.72-15.39 67-35.11 14.72-18.77 25.88-45.37 21.8-72.66z"}}]})(props);
	};
	module.exports.IoLogoBehance = function IoLogoBehance (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M344.1 233.6c-28.9 0-32.9 28.8-32.9 28.8h61.4s.4-28.8-28.5-28.8zm-139.3 28.8h-54.4v50h51.7c7.8-.2 22.4-2.4 22.4-24.3 0-26-19.7-25.7-19.7-25.7z"}},{"tag":"path","attr":{"d":"M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224S379.7 32 256 32zm47.2 137.6h77.1v23h-77.1v-23zm-39 120.8c0 57-59.4 55.2-59.4 55.2h-97.2v-187h97.2c29.6 0 52.9 16.3 52.9 49.8S229.2 244 229.2 244c37.6 0 35 46.4 35 46.4zm144.2-3.1h-96.9c0 34.7 32.9 32.5 32.9 32.5 31.1 0 30-20.1 30-20.1h32.9c0 53.4-64 49.7-64 49.7-76.7 0-71.8-71.5-71.8-71.5s-.1-71.8 71.8-71.8c75.7.1 65.1 81.2 65.1 81.2z"}},{"tag":"path","attr":{"d":"M218 211.3c0-19.4-13.2-19.4-13.2-19.4h-54.4v41.7h51c8.8 0 16.6-2.9 16.6-22.3z"}}]})(props);
	};
	module.exports.IoLogoBitbucket = function IoLogoBitbucket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M483.13 32.23a19.65 19.65 0 00-2.54-.23h-449C23 31.88 16.12 38.88 16 47.75a11.44 11.44 0 00.23 2.8l65.3 411.25a22.52 22.52 0 007 12.95A20 20 0 00102 480h313.18a15.45 15.45 0 0015.34-13.42l38.88-247.91H325.19l-18.46 112H205.21l-25.73-148h295.58l20.76-132c1.27-8.75-4.38-17.04-12.69-18.44z"}}]})(props);
	};
	module.exports.IoLogoBitcoin = function IoLogoBitcoin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M410.47 279.2c-5-11.5-12.7-21.6-28.1-30.1a98.15 98.15 0 00-25.4-10 62.22 62.22 0 0016.3-11 56.37 56.37 0 0015.6-23.3 77.11 77.11 0 003.5-28.2c-1.1-16.8-4.4-33.1-13.2-44.8s-21.2-20.7-37.6-27c-12.6-4.8-25.5-7.8-45.5-8.9V32h-40v64h-32V32h-41v64H96v48h27.87c8.7 0 14.6.8 17.6 2.3a13.22 13.22 0 016.5 6c1.3 2.5 1.9 8.4 1.9 17.5V343c0 9-.6 14.8-1.9 17.4s-2 4.9-5.1 6.3-3.2 1.3-11.8 1.3h-26.4L96 416h87v64h41v-64h32v64h40v-64.4c26-1.3 44.5-4.7 59.4-10.3 19.3-7.2 34.1-17.7 44.7-31.5s14-34.9 14.93-51.2c.67-14.5-.03-33.2-4.56-43.4zM224 150h32v74h-32zm0 212v-90h32v90zm72-208.1c6 2.5 9.9 7.5 13.8 12.7 4.3 5.7 6.5 13.3 6.5 21.4 0 7.8-2.9 14.5-7.5 20.5-3.8 4.9-6.8 8.3-12.8 11.1zm28.8 186.7c-7.8 6.9-12.3 10.1-22.1 13.8a56.06 56.06 0 01-6.7 1.9v-82.8a40.74 40.74 0 0111.3 3.4c7.8 3.3 15.2 6.9 19.8 13.2a43.82 43.82 0 018 24.7c-.03 10.9-2.83 19.2-10.33 25.8z"}}]})(props);
	};
	module.exports.IoLogoBuffer = function IoLogoBuffer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M39.93 149.25l197.4 95.32c5.14 2.45 12 3.73 18.79 3.73s13.65-1.28 18.78-3.73l197.4-95.32c10.38-5 10.38-13.18 0-18.2L274.9 35.73c-5.13-2.45-12-3.73-18.78-3.73s-13.65 1.28-18.79 3.73l-197.4 95.32c-10.38 5.02-10.38 13.18 0 18.2z"}},{"tag":"path","attr":{"d":"M472.3 246.9s-36.05-17.38-40.83-19.72-6.07-2.21-11.09.12-145.6 70.23-145.6 70.23a45.71 45.71 0 01-18.78 3.74c-6.77 0-13.65-1.29-18.78-3.74 0 0-136.85-66-143.27-69.18C87 225 85 225 78.67 228l-39 18.78c-10.38 5-10.38 13.19 0 18.2L237.1 360.3c5.13 2.45 12 3.73 18.78 3.73s13.65-1.28 18.79-3.73l197.4-95.3c10.61-4.92 10.61-13.08.23-18.1z"}},{"tag":"path","attr":{"d":"M472.3 362.75s-36.05-17.38-40.83-19.75-6.07-2.21-11.09.12S274.9 413.5 274.9 413.5a45.74 45.74 0 01-18.78 3.73c-6.77 0-13.65-1.28-18.79-3.73 0 0-136.85-66-143.26-69.18-7-3.39-9-3.39-15.29-.35l-39 18.78c-10.39 5-10.39 13.18 0 18.2l197.4 95.32c5.13 2.56 12 3.73 18.78 3.73s13.65-1.28 18.78-3.73L472.18 381c10.5-5.07 10.5-13.23.12-18.25z"}}]})(props);
	};
	module.exports.IoLogoCapacitor = function IoLogoCapacitor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 101.09L372.37 208.72l106.86 107.06-69.3 69.3-283.22-283.23L196 32.54l107.07 106.88L410.67 32zM32.55 196l69.3-69.31 283.22 283.24-69.3 69.3-107-106.87L101.08 480 32 410.67l107.42-107.61z"}}]})(props);
	};
	module.exports.IoLogoChrome = function IoLogoChrome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M188.8 255.93a67.2 67.2 0 1067.2-67.18 67.38 67.38 0 00-67.2 67.18z"}},{"tag":"path","attr":{"d":"M476.75 217.79v.05a206.63 206.63 0 00-7-28.84h-.11a202.16 202.16 0 017.07 29 203.5 203.5 0 00-7.07-29h-155.4c19.05 17 31.36 40.17 31.36 67.05a86.55 86.55 0 01-12.31 44.73L231 478.45a2.44 2.44 0 010 .27v.28-.26a224 224 0 0025 1.26c6.84 0 13.61-.39 20.3-1a222.91 222.91 0 0029.78-4.74C405.68 451.52 480 362.4 480 255.94a225.25 225.25 0 00-3.25-38.15z"}},{"tag":"path","attr":{"d":"M256 345.5c-33.6 0-61.6-17.91-77.29-44.79L76 123.05l-.14-.24A224 224 0 00207.4 474.55v-.05l77.69-134.6a84.13 84.13 0 01-29.09 5.6z"}},{"tag":"path","attr":{"d":"M91.29 104.57l77.35 133.25A89.19 89.19 0 01256 166h205.17a246.51 246.51 0 00-25.78-43.94l.12.08A245.26 245.26 0 01461.17 166h.17a245.91 245.91 0 00-25.66-44 2.63 2.63 0 01-.35-.26 223.93 223.93 0 00-344.19-17.4l.14.24z"}}]})(props);
	};
	module.exports.IoLogoClosedCaptioning = function IoLogoClosedCaptioning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 80v352h512V80zm464 175.78c0 25.74-1.6 45.32-3.77 77.22s-19.2 54.34-59.09 57.86-95.77 3.85-145.14 3.74c-49 .11-105.14-.11-145.14-3.74s-56.8-26-59.09-57.86S48 281.52 48 255.78s.11-42.46 3.77-77.22 23-54.12 59.09-57.64 98.28-3.52 145.14-3.52 109 0 145.14 3.52 55.43 23 59.09 57.64 3.77 51.59 3.77 77.22z"}},{"tag":"path","attr":{"d":"M367.57 282.84v.77c0 17.93-11.11 28.49-25.95 28.49s-24.84-11.88-26.27-28.49c0 0-1.31-8.69-1.31-26.29a229.5 229.5 0 011.53-28.6c2.64-18.7 11.77-28.49 26.6-28.49s26.49 12.76 26.49 32.12v.55h49.58c0-24.09-6.05-45.76-18.25-59.4S369.76 153 345.8 153a108.06 108.06 0 00-33 4.73 58.82 58.82 0 00-25.94 16.61c-7.23 7.96-12.86 18.52-16.86 31.83s-6 30-6 50.27c0 19.8 1.65 36.3 4.84 49.61s8 23.87 14.4 31.79a49.76 49.76 0 0024 16.5q14.5 4.62 34 4.62c27.47 0 47.26-7 59.13-20.57S418 305.06 418 279.1h-50.65c.22 0 .22 2.75.22 3.74zm-170.27 0v.77c0 17.93-11.1 28.49-25.94 28.49s-24.84-11.88-26.27-28.49c0 0-1.31-8.69-1.31-26.29a229.5 229.5 0 011.53-28.6c2.64-18.7 11.77-28.49 26.6-28.49S198.4 213 198.4 232.35v.55H248c0-24.09-6-45.76-18.25-59.4S199.5 153 175.54 153a108.06 108.06 0 00-33 4.73 58.82 58.82 0 00-25.94 16.61c-7.26 7.92-12.86 18.48-16.93 31.79s-6 30-6 50.27c0 19.8 1.65 36.3 4.84 49.61s8 23.87 14.4 31.79a49.76 49.76 0 0024 16.5q14.51 4.62 34 4.62c27.48 0 47.27-7 59.14-20.57s17.81-33.33 17.81-59.29h-50.78c.22.04.22 2.79.22 3.78z"}}]})(props);
	};
	module.exports.IoLogoCodepen = function IoLogoCodepen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M241.24 303.94c-15.32-10.36-30.74-20.57-46.06-30.93-2-1.38-3.43-1.48-5.5 0l-38.88 26.12C182 319.9 244 361.32 244 361.32v-53.79c0-1.22-1.55-2.78-2.76-3.59zm-46.15-63.27q23.19-15.24 46.11-30.86a7.54 7.54 0 002.8-5.34v-51.7s-62 41.12-93.26 61.94c13.7 9.16 26.67 17.91 39.78 26.44 1.02.66 3.4.28 4.57-.48zm74.75-31.32q23.71 16.07 47.63 31.82a4.3 4.3 0 003.83 0l39.76-26.47L268 152.48v53.35a4.79 4.79 0 001.84 3.52zm-11.73 21.02a5.27 5.27 0 00-4.74.17c-4.82 3-9.47 6.2-14.17 9.35-8.25 5.53-25.35 17-25.35 17l38.84 25.86a6.18 6.18 0 006.26.11l39-26s-34.07-22.66-39.84-26.49zM141 237.12v39.61l29.62-19.84L141 237.12z"}},{"tag":"path","attr":{"d":"M256 32C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32zm139 265c0 5.78-2.65 9.86-7.51 13.09q-61.71 41-123.29 82.19c-5.85 3.92-11.17 3.75-17-.14q-61.17-41-122.63-81.67c-5.11-3.39-7.59-7.56-7.59-13.73V217c0-6.14 2.52-10.34 7.62-13.72 40.91-27.13 81.94-54.36 122.73-81.68 5.82-3.89 11.09-4 16.94-.09q61.54 41.21 123.26 82.19c4.68 3.11 7.45 6.95 7.45 12.66z"}},{"tag":"path","attr":{"d":"M316.25 273.23q-22.59 15.34-45.39 30.34c-2.41 1.58-2.89 3.31-2.86 6.19v51.34l93-62-38.53-25.88c-2.3-1.61-3.89-1.57-6.22.01zm53.75 3.45v-39.62l-29.59 19.87L370 276.68z"}}]})(props);
	};
	module.exports.IoLogoCss3 = function IoLogoCss3 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 32l35 403.22L255.77 480 413 435.15 448 32zm290.68 334.9L256.07 395l-98.46-28.24-6.75-77.76h48.26l3.43 39.56 53.59 15.16.13.28 53.47-14.85 5.64-64.15H203l-4-50h120.65l4.35-51H140l-4-49h240.58z"}}]})(props);
	};
	module.exports.IoLogoDesignernews = function IoLogoDesignernews (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M295.31 122.8L222.86 64l72.68 122.64-.23-63.84z"}},{"tag":"path","attr":{"d":"M339.43 64v195.6h-41.6L225.6 141.28l1.94 118.32h-45.83V131.2L139.09 96c1.14 1.44 2.28 2.88 3.31 4.44 11.43 16.68 17.14 36.6 17.14 60.6 0 59-35 98.52-87.88 98.52H0v.48L228.11 448H512V205.72z"}},{"tag":"path","attr":{"d":"M111.89 162.52c0-34.8-16.23-54.12-45.38-54.12H44.57v106.8h21.72c29.71 0 45.6-18.48 45.6-52.68z"}}]})(props);
	};
	module.exports.IoLogoDeviantart = function IoLogoDeviantart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408 103.28V16h-89.31l-8.9 8.78-42.15 78.48-13.25 8.74H104v119.85h82.68l7.36 8.71L104 408.72V496h89.3l8.91-8.79 42.14-78.48 13.26-8.73H408V280.13h-82.68l-7.36-8.75L408 103.28z"}}]})(props);
	};
	module.exports.IoLogoDiscord = function IoLogoDiscord (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 66.52A50 50 0 00414.12 17L97.64 16A49.65 49.65 0 0048 65.52V392c0 27.3 22.28 48 49.64 48H368l-13-44 109 100zM324.65 329.81s-8.72-10.39-16-19.32C340.39 301.55 352.5 282 352.5 282a139 139 0 01-27.85 14.25 173.31 173.31 0 01-35.11 10.39 170.05 170.05 0 01-62.72-.24 184.45 184.45 0 01-35.59-10.4 141.46 141.46 0 01-17.68-8.21c-.73-.48-1.45-.72-2.18-1.21-.49-.24-.73-.48-1-.48-4.36-2.42-6.78-4.11-6.78-4.11s11.62 19.09 42.38 28.26c-7.27 9.18-16.23 19.81-16.23 19.81-53.51-1.69-73.85-36.47-73.85-36.47 0-77.06 34.87-139.62 34.87-139.62 34.87-25.85 67.8-25.12 67.8-25.12l2.42 2.9c-43.59 12.32-63.44 31.4-63.44 31.4s5.32-2.9 14.28-6.77c25.91-11.35 46.5-14.25 55-15.21a24 24 0 014.12-.49 205.62 205.62 0 0148.91-.48 201.62 201.62 0 0172.89 22.95s-19.13-18.15-60.3-30.45l3.39-3.86s33.17-.73 67.81 25.16c0 0 34.87 62.56 34.87 139.62 0-.28-20.35 34.5-73.86 36.19z"}},{"tag":"path","attr":{"d":"M212.05 218c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.8 0 24.7-11.83 24.7-26.57.25-14.76-10.9-26.57-24.7-26.57zm88.38 0c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.81 0 24.7-11.83 24.7-26.57S314 218 300.43 218z"}}]})(props);
	};
	module.exports.IoLogoDocker = function IoLogoDocker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M507 211.16c-1.42-1.19-14.25-10.94-41.79-10.94a132.55 132.55 0 00-21.61 1.9c-5.22-36.4-35.38-54-36.57-55l-7.36-4.28-4.75 6.9a101.65 101.65 0 00-13.06 30.45c-5 20.7-1.9 40.2 8.55 56.85-12.59 7.14-33 8.8-37.28 9H15.94A15.93 15.93 0 000 262.07a241.25 241.25 0 0014.75 86.83C26.39 379.35 43.72 402 66 415.74 91.22 431.2 132.3 440 178.6 440a344.23 344.23 0 0062.45-5.71 257.44 257.44 0 0081.69-29.73 223.55 223.55 0 0055.57-45.67c26.83-30.21 42.74-64 54.38-94h4.75c29.21 0 47.26-11.66 57.23-21.65a63.31 63.31 0 0015.2-22.36l2.14-6.18z"}},{"tag":"path","attr":{"d":"M47.29 236.37H92.4a4 4 0 004-4v-40.48a4 4 0 00-4-4H47.29a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4m62.21.04h45.12a4 4 0 004-4v-40.48a4 4 0 00-4-4H109.5a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4m63.4.04H218a4 4 0 004-4v-40.48a4 4 0 00-4-4h-45.1a4 4 0 00-4 4v40.44a3.87 3.87 0 004 4m62.46.04h45.12a4 4 0 004-4v-40.48a4 4 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4 4 0 004 4M109.5 178.57h45.12a4.16 4.16 0 004-4v-40.48a4 4 0 00-4-4H109.5a4 4 0 00-4 4v40.44a4.34 4.34 0 004 4m63.4.04H218a4.16 4.16 0 004-4v-40.48a4 4 0 00-4-4h-45.1a4 4 0 00-4 4v40.44a4 4 0 004 4m62.46.04h45.12a4.16 4.16 0 004-4v-40.48a4.16 4.16 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4m0-58h45.12a4 4 0 004-4V76a4.16 4.16 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4.17 4.17 0 004 4m62.92 115.93h45.12a4 4 0 004-4v-40.48a4 4 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4"}}]})(props);
	};
	module.exports.IoLogoDribbble = function IoLogoDribbble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.33 32 32 132.33 32 256s100.33 224 224 224 224-100.22 224-224S379.67 32 256 32zm142.22 103.25a186.36 186.36 0 0144 108.38c-40.37-2.1-88.67-2.1-127.4 1.52-4.9-12.37-9.92-24.5-15.4-36.17 44.66-19.36 79.08-44.8 98.8-73.73zM256 69.33a185.81 185.81 0 01119.12 42.94c-20.3 25.66-52.15 48-91.82 64.86C261.6 137 236.63 102.47 210 75.28a187.51 187.51 0 0146-5.95zm-84.47 20.42c26.95 26.83 52.27 61 74.44 101C203.85 203.62 155.55 211 104 211c-9.8 0-19.36-.35-28.81-.94a186.78 186.78 0 0196.34-120.31zM69.68 247.13c10.62.47 21.35.7 32.2.59 58.8-.7 113.52-9.92 160.54-25q6.65 13.83 12.6 28.35a115.43 115.43 0 00-16.69 5c-64.28 27-114.91 70.51-142.33 123.13A186 186 0 0169.33 256c0-3 .12-5.95.35-8.87zM256 442.67a185.57 185.57 0 01-114.45-39.32c24.85-49.23 69.18-90 125.07-115.27 5.25-2.45 12.25-4.43 20.3-6.18q10 27.64 17.85 57.4A678 678 0 01322 430.42a185.06 185.06 0 01-66 12.25zm100.92-29.75a672.61 672.61 0 00-17.39-92.05c-4-15.17-8.51-29.87-13.41-44.22 36.63-3 80.5-2.57 115.38 0a186.5 186.5 0 01-84.58 136.27z"}}]})(props);
	};
	module.exports.IoLogoDropbox = function IoLogoDropbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.32 126.24l-120.16 78.25 120.16 78.24L136.16 361 16 282.08l120.16-78.24L16 126.24 136.16 48zm-120.8 259.52l120.16-78.25 120.16 78.25L255.68 464zm120.8-103.68l120.16-78.24-120.16-77.6L375.84 48 496 126.24l-120.16 78.25L496 282.73 375.84 361z"}}]})(props);
	};
	module.exports.IoLogoEdge = function IoLogoEdge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.5 15c-132 0-240 108-240 240s108 240 240 240c85.4 0 160.8-45.2 203.3-112.9a6.87 6.87 0 00-9.1-9.7 108.64 108.64 0 01-18.4 8.6c-36.8 12.6-57.1 13.1-82.1 12-27.9-1.2-61.9-10.8-85.8-25s-43.5-34.6-54.1-52.3-17-39.9-14.1-68.3c2.9-29 29.4-52.6 60.4-52.6 33.5 0 60.8 26.6 60.8 60.1 0 17-8.1 31.7-18.5 43.5-2.3 2.1-7.6 9.7 5.8 20 15.9 12.2 51.6 18 79.9 16.6s59.1-12.6 80.2-34.8c16.8-17.7 31.8-46.1 31.8-77.4C495.5 97.7 379.5 15 255.5 15z"}}]})(props);
	};
	module.exports.IoLogoElectron = function IoLogoElectron (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M86.76 255a9.89 9.89 0 004.87-1.29 9.82 9.82 0 003.65-13.43c-16.46-28.56-17.81-52.12-7.45-70 14.26-24.57 53.61-33.65 105.27-24.29a9.86 9.86 0 0011.45-7.9 9.84 9.84 0 00-7.93-11.44c-29.19-5.28-56-5.18-77.39.3-22.3 5.71-39 17.28-48.45 33.48-14 24.19-12.7 54.73 7.42 89.62a9.85 9.85 0 008.56 4.95zm274.85-111.27c32.24.42 52.61 9.31 62.79 26.86 14.21 24.48 2.52 62.81-31.27 102.52a9.82 9.82 0 007.51 16.18 9.88 9.88 0 007.52-3.46c19.12-22.47 32.35-45.54 38.25-66.71 6.14-22 4.43-42.21-5-58.38-13.8-23.78-40.13-36.15-79.59-36.67h-.14a9.83 9.83 0 00-.12 19.66zm-35.14 271.16a9.88 9.88 0 00-13.5 3.35c-16.41 27.15-36.57 42.1-56.77 42.1-28.49 0-56-29.31-73.73-78.42a9.87 9.87 0 00-12.59-5.92 9.83 9.83 0 00-6 12.58c10 27.77 23.47 50.75 39 66.46 16.11 16.34 34.55 25 53.32 25 27.38 0 53.54-18.33 73.65-51.61a9.81 9.81 0 00-3.38-13.5zm105.23-76.35a32.14 32.14 0 00-29.9 44.33c-41.8 19.5-119.8 4.79-191.87-36.62-32.91-18.9-62.16-41.86-84.6-66.39a9.9 9.9 0 00-13.91-.65 9.8 9.8 0 00-.65 13.9c23.79 26 54.68 50.28 89.33 70.18 40.28 23.13 82.27 38.63 121.43 44.81a225.54 225.54 0 0035 2.91c23.12 0 43-4.3 58.51-12.79a32.2 32.2 0 1016.7-59.68zm0 44.66a12.6 12.6 0 01-7.82-2.72 10 10 0 00-2.2-2.21 12.61 12.61 0 1110 4.93z"}},{"tag":"path","attr":{"d":"M82.09 338.59c.57-21.26 12.41-47 33.68-73.16 23.19-28.45 56.69-56 94.34-77.65 33.25-19.1 65.2-31.9 98.07-38.91a9.83 9.83 0 10-4.12-19.22c-34.85 7.43-68.78 21-103.79 41.09C116.09 219.09 59.9 289.88 62.46 343.9a32.32 32.32 0 1019.63-5.31zM80.3 383.2a12.5 12.5 0 1112.59-12.5 12.56 12.56 0 01-12.59 12.5z"}},{"tag":"path","attr":{"d":"M256.2 96.32a32.23 32.23 0 0026.53-13.81c17.89 11.69 34 35 45.81 66.12 13 34.39 19.84 75.38 19.84 118.54 0 37.18-5.19 72.35-15 103.6a9.72 9.72 0 00.66 7.49 9.82 9.82 0 005.8 4.84 9.89 9.89 0 0012.34-6.44c10.42-33.14 15.93-70.34 15.93-109.49 0-47.17-7.77-91.77-22.47-129-14.41-36.48-34.13-62.4-57.14-75.16a32.3 32.3 0 10-32.3 33.31zm0-44.66a12.5 12.5 0 11-12.59 12.5 12.56 12.56 0 0112.59-12.5zm-5.2 191.7a24.35 24.35 0 005.16 48.16 24.68 24.68 0 005.16-.55A24.36 24.36 0 10251 243.36z"}}]})(props);
	};
	module.exports.IoLogoEuro = function IoLogoEuro (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M231.8 272v-48H376l8-48H231.8v-8.12c0-38.69 16.47-62.56 87.18-62.56 28.89 0 61.45 2.69 102.5 9.42l10.52-70A508.54 508.54 0 00315.46 32C189.26 32 135 76.4 135 158.46V176H80v48h55v48H80v48h55v33.54C135 435.6 189.23 480 315.43 480a507.76 507.76 0 00116.44-12.78l-10.58-70c-41.05 6.73-73.46 9.42-102.35 9.42-70.7 0-87.14-20.18-87.14-67.94V320h128.47l7.87-48z"}}]})(props);
	};
	module.exports.IoLogoFacebook = function IoLogoFacebook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M480 257.35c0-123.7-100.3-224-224-224s-224 100.3-224 224c0 111.8 81.9 204.47 189 221.29V322.12h-56.89v-64.77H221V208c0-56.13 33.45-87.16 84.61-87.16 24.51 0 50.15 4.38 50.15 4.38v55.13H327.5c-27.81 0-36.51 17.26-36.51 35v42h62.12l-9.92 64.77H291v156.54c107.1-16.81 189-109.48 189-221.31z"}}]})(props);
	};
	module.exports.IoLogoFigma = function IoLogoFigma (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 176a80 80 0 000-160H176a80 80 0 000 160 80 80 0 000 160 80 80 0 1080 80V176z"}},{"tag":"circle","attr":{"cx":"336","cy":"256","r":"80"}}]})(props);
	};
	module.exports.IoLogoFirebase = function IoLogoFirebase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M93.19 329.38l47.45-304.07c1.64-10.37 15.55-12.82 20.46-3.55l51 95.45zM432 400l-46.74-276.79a11 11 0 00-18.54-6L80 400l159.36 91.91a33.18 33.18 0 0031.91 0zM302.36 158.93l-36.54-69.54a10.86 10.86 0 00-19.36 0L85.83 375.74z"}}]})(props);
	};
	module.exports.IoLogoFirefox = function IoLogoFirefox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M471.46 194.62v-.07c-.22-.76-.45-1.52-.68-2.28-.05-.19-.11-.38-.17-.56-.43-1.44-.87-2.88-1.33-4.31l-.06-.2a223.24 223.24 0 00-10-25.56 191.77 191.77 0 00-12.9-23.8 225.15 225.15 0 00-74.74-73.74A222.9 222.9 0 00256 32c-7 0-14 .34-20.82 1-24.12 2.54-64.78 11.21-97.77 40.18C257.5 11.86 417.94 85.7 404.29 223c-4.86 49-46.46 82.67-85.19 88.35a73.73 73.73 0 01-20.8.21c-94.59-13.15-88.8-90.68-60.06-123.83-38-.24-67.47 46.79-53.15 93-32.95-61.18.35-157 70.93-186-82.95-12-160.71 28.2-185.7 98.07A330.23 330.23 0 0188.07 118s-45.22 35.74-54.44 110.9c-.14 1.16-.27 2.32-.39 3.49-.05.4-.09.8-.13 1.21q-.53 5.25-.8 10.57v.81c-.07 1.48-.13 3-.17 4.46v1.25c0 1.76-.07 3.52-.07 5.29 0 123.71 100.29 224 224 224S480 379.71 480 256a224 224 0 00-8.54-61.38z"}}]})(props);
	};
	module.exports.IoLogoFlickr = function IoLogoFlickr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.8 32 32 132.8 32 256s100.8 224 224 224 224-100.8 224-224S379.2 32 256 32zm-82.16 280A56 56 0 11228 257.84 56 56 0 01173.84 312zm168 0A56 56 0 11396 257.84 56 56 0 01341.84 312z"}}]})(props);
	};
	module.exports.IoLogoFoursquare = function IoLogoFoursquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376.76 32H138.54C105.67 32 96 56.8 96 72.41v379.64c0 17.59 9.42 24.12 14.72 26.27s19.91 4 28.67-6.17c0 0 112.47-130.89 114.4-132.83 2.92-2.93 2.92-2.93 5.84-2.93h72.77c30.58 0 35.49-21.87 38.69-34.75 2.65-10.79 32.48-164 42.45-212.56C421.14 52 411.74 32 376.76 32zm-5.67 269.64c2.65-10.79 32.48-164 42.45-212.56m-50.85 7.59l-10 51.73c-1.19 5.65-8.28 11.6-14.86 11.6h-95.92c-10.44 0-17.91 6.14-17.91 16.6v13.45c0 10.47 7.52 17.89 18 17.89h81.85c7.38 0 14.61 8.11 13 16s-9.09 46.57-10 50.89-5.84 11.72-14.61 11.72H248c-11.7 0-15.24 1.54-23.07 11.3s-78.26 94.59-78.26 94.59c-.71.82-1.41.58-1.41-.31V95.9c0-6.69 5.8-14.53 14.48-14.53h191.14a12.42 12.42 0 0111.81 15.3z"}}]})(props);
	};
	module.exports.IoLogoGithub = function IoLogoGithub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.3 32 32 134.9 32 261.7c0 101.5 64.2 187.5 153.2 217.9a17.56 17.56 0 003.8.4c8.3 0 11.5-6.1 11.5-11.4 0-5.5-.2-19.9-.3-39.1a102.4 102.4 0 01-22.6 2.7c-43.1 0-52.9-33.5-52.9-33.5-10.2-26.5-24.9-33.6-24.9-33.6-19.5-13.7-.1-14.1 1.4-14.1h.1c22.5 2 34.3 23.8 34.3 23.8 11.2 19.6 26.2 25.1 39.6 25.1a63 63 0 0025.6-6c2-14.8 7.8-24.9 14.2-30.7-49.7-5.8-102-25.5-102-113.5 0-25.1 8.7-45.6 23-61.6-2.3-5.8-10-29.2 2.2-60.8a18.64 18.64 0 015-.5c8.1 0 26.4 3.1 56.6 24.1a208.21 208.21 0 01112.2 0c30.2-21 48.5-24.1 56.6-24.1a18.64 18.64 0 015 .5c12.2 31.6 4.5 55 2.2 60.8 14.3 16.1 23 36.6 23 61.6 0 88.2-52.4 107.6-102.3 113.3 8 7.1 15.2 21.1 15.2 42.5 0 30.7-.3 55.5-.3 63 0 5.4 3.1 11.5 11.4 11.5a19.35 19.35 0 004-.4C415.9 449.2 480 363.1 480 261.7 480 134.9 379.7 32 256 32z"}}]})(props);
	};
	module.exports.IoLogoGitlab = function IoLogoGitlab (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M494.07 281.6l-25.18-78.08a11 11 0 00-.61-2.1l-50.5-156.94a20.08 20.08 0 00-19.17-13.82 19.77 19.77 0 00-18.95 13.94l-48.14 149.55h-152L131.34 44.59a19.76 19.76 0 00-18.86-13.94h-.11a20.15 20.15 0 00-19.12 14L42.7 201.73c0 .14-.11.26-.16.4l-25.63 79.48a29.15 29.15 0 0010.44 32.46l221.44 162.41a11.25 11.25 0 0013.38-.07l221.48-162.34a29.13 29.13 0 0010.42-32.47m-331-64.51l61.73 191.76L76.63 217.09m209.64 191.8l59.19-183.84 2.55-8h86.52L300.47 390.44M398.8 59.31l43.37 134.83h-86.82M324.16 217l-43 133.58-25.66 79.56L186.94 217M112.27 59.31l43.46 134.83H69M40.68 295.58a6.19 6.19 0 01-2.21-6.9l19-59 139.61 180.59m273.26-114.69L313.92 410.22l.52-.69L453.5 229.64l19 59a6.2 6.2 0 01-2.19 6.92"}}]})(props);
	};
	module.exports.IoLogoGooglePlaystore = function IoLogoGooglePlaystore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 59.49v393a4.33 4.33 0 007.37 3.07L260 256 55.37 56.42A4.33 4.33 0 0048 59.49zM345.8 174L89.22 32.64l-.16-.09c-4.42-2.4-8.62 3.58-5 7.06l201.13 192.32zM84.08 472.39c-3.64 3.48.56 9.46 5 7.06l.16-.09L345.8 338l-60.61-57.95zM449.38 231l-71.65-39.46L310.36 256l67.37 64.43L449.38 281c19.49-10.77 19.49-39.23 0-50z"}}]})(props);
	};
	module.exports.IoLogoGoogle = function IoLogoGoogle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M473.16 221.48l-2.26-9.59H262.46v88.22H387c-12.93 61.4-72.93 93.72-121.94 93.72-35.66 0-73.25-15-98.13-39.11a140.08 140.08 0 01-41.8-98.88c0-37.16 16.7-74.33 41-98.78s61-38.13 97.49-38.13c41.79 0 71.74 22.19 82.94 32.31l62.69-62.36C390.86 72.72 340.34 32 261.6 32c-60.75 0-119 23.27-161.58 65.71C58 139.5 36.25 199.93 36.25 256s20.58 113.48 61.3 155.6c43.51 44.92 105.13 68.4 168.58 68.4 57.73 0 112.45-22.62 151.45-63.66 38.34-40.4 58.17-96.3 58.17-154.9 0-24.67-2.48-39.32-2.59-39.96z"}}]})(props);
	};
	module.exports.IoLogoHackernews = function IoLogoHackernews (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 32v448h448V32zm249.67 250.83v84H235v-84l-77-140h55l46.32 97.54 44.33-97.54h52.73z"}}]})(props);
	};
	module.exports.IoLogoHtml5 = function IoLogoHtml5 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 32l34.94 403.21L255.77 480 413 435.15 448 32zm308 132H188l4 51h176l-13.51 151.39L256 394.48l-98.68-28-6.78-77.48h48.26l3.42 39.29L256 343.07l53.42-14.92L315 264H148l-12.59-149.59H376.2z"}}]})(props);
	};
	module.exports.IoLogoInstagram = function IoLogoInstagram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M349.33 69.33a93.62 93.62 0 0193.34 93.34v186.66a93.62 93.62 0 01-93.34 93.34H162.67a93.62 93.62 0 01-93.34-93.34V162.67a93.62 93.62 0 0193.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z"}},{"tag":"path","attr":{"d":"M377.33 162.67a28 28 0 1128-28 27.94 27.94 0 01-28 28zM256 181.33A74.67 74.67 0 11181.33 256 74.75 74.75 0 01256 181.33m0-37.33a112 112 0 10112 112 112 112 0 00-112-112z"}}]})(props);
	};
	module.exports.IoLogoIonic = function IoLogoIonic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 153.9A102.1 102.1 0 10358.1 256 102.23 102.23 0 00256 153.9z"}},{"tag":"circle","attr":{"cx":"402.59","cy":"116.45","r":"46.52"}},{"tag":"path","attr":{"d":"M459.86 163.2l-1.95-4.28-3.11 3.52a70 70 0 01-28.06 19.32l-3 1.1 1.22 2.93A181.43 181.43 0 01439 256c0 100.92-82.1 183-183 183S73 356.92 73 256 155.08 73 256 73a180.94 180.94 0 0178.43 17.7l2.87 1.3 1.25-2.92A70.19 70.19 0 01359.21 62l3.67-2.93-4.17-2.07A221.61 221.61 0 00256 32C132.49 32 32 132.49 32 256s100.49 224 224 224 224-100.49 224-224a222.19 222.19 0 00-20.14-92.8z"}}]})(props);
	};
	module.exports.IoLogoIonitron = function IoLogoIonitron (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M468.41 269.19c-2.64-33.39-11.76-58-31.44-57.39a1 1 0 00-.92 1.37c5.11 12.59 9.68 36.9 9.17 58.07a1 1 0 01-2 .08c-2.19-21.21-7.1-41.19-16.22-59.43a186.69 186.69 0 00-348.91 41 4 4 0 01-3.33 3.11l-8.65 1.22c-17.2 2.4-26.9 34.9-21.7 72.5s23.5 66.2 40.7 63.8l13.24-1.85a4 4 0 013.93 1.84 186.71 186.71 0 00339-56.07 4 4 0 013.68-3.08l4.4-.24c15.15-2.53 21.75-31.23 19.05-64.93zM94.5 270.42a1 1 0 011.59-1.19c9.63 10 20.25 27.65 23.32 49.86 3.24 23.05-2.24 45.2-9.13 57.87a1 1 0 01-1.84-.73c4.07-14.44 5.16-33.83 2.27-54.74-2.8-20.32-8.71-38.27-16.21-51.07zm178.77 109.79a15.53 15.53 0 01-15.41-13.83 15.48 15.48 0 1115.41 13.83zm81.84-4.72a15.37 15.37 0 1114.6-16.2 15.43 15.43 0 01-14.6 16.2z"}},{"tag":"path","attr":{"d":"M165.51 70a.31.31 0 01.1.2c.1.2.2.3.3.5v.1a5.78 5.78 0 002.3 2.7c2 1.5 5 2.4 8.6 3a63.69 63.69 0 0011.9.5 28.25 28.25 0 002.9-.2c-.4-.4-.8-.9-1.2-1.3h-1.3a52 52 0 01-11.6-.9 19.71 19.71 0 01-8.4-3.4 9.24 9.24 0 01-1.4-1.4 4.48 4.48 0 010-2.3c.5-2.3 2.4-4.8 5.5-7.4a57.25 57.25 0 0110.9-7c.9-.4 1.7-.9 2.6-1.3.1-.1.3-.1.5-.2a24.69 24.69 0 00-.2 10.5c2.3 11.9 11.6 20.3 23.2 20.6l4 24.3 12.7-3-4-23.3c10.8-4.6 16.3-16.1 14-28a25.8 25.8 0 00-3.9-9.5c-5.3-.8-15.6-.8-29.2 2.1 1.1-.3 2.1-.7 3.2-1a135.27 135.27 0 0121.5-4.2c.6-.1 1.2-.1 1.8-.2l3.5-.3h.6a61.83 61.83 0 0110.8.3 29 29 0 016.1 1.4 5.71 5.71 0 00-.9 3.2 6.12 6.12 0 004.3 5.8 25.53 25.53 0 01-2.1 2.8 26 26 0 01-2.9 2.8c-1.1.9-2.3 1.8-3.5 2.7l-6.5 3.8-.3 1.5a.35.35 0 00.2-.1l8.4-4.7c1.2-.8 2.4-1.6 3.4-2.4a29.15 29.15 0 003.2-2.8 29.86 29.86 0 002.4-2.8l.3-.6a6.14 6.14 0 005.4-6 6.06 6.06 0 00-6.1-6.1 6.81 6.81 0 00-2.8.7 24.6 24.6 0 00-8.2-2.7 63.48 63.48 0 00-15.5-.6 14.92 14.92 0 00-2.1.2 13.55 13.55 0 01-2 .2 25.15 25.15 0 00-18.7-3.7 25.86 25.86 0 00-17.8 13c-1.3.5-2.6 1.1-3.8 1.7-.7.3-1.3.6-2 .9a60.75 60.75 0 00-13.9 9.1c-3.1 2.9-4.9 5.7-5.3 8.3a6.14 6.14 0 00.7 4 2.19 2.19 0 01.3.5z"}}]})(props);
	};
	module.exports.IoLogoJavascript = function IoLogoJavascript (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 32v448h448V32zm240 348c0 43.61-25.76 64.87-63.05 64.87-33.68 0-53.23-17.44-63.15-38.49l34.28-20.75c6.61 11.73 11.63 21.65 26.06 21.65 12 0 21.86-5.41 21.86-26.46V240h44zm99.35 63.87c-39.09 0-64.35-17.64-76.68-42L329 382c9 14.74 20.75 24.56 41.5 24.56 17.44 0 27.57-7.72 27.57-19.75 0-14.43-10.43-19.54-29.68-28l-10.52-4.52c-30.38-12.92-50.52-29.16-50.52-63.45 0-31.57 24.05-54.63 61.64-54.63 26.77 0 46 8.32 59.85 32.68L396 290c-7.22-12.93-15-18-27.06-18-12.33 0-20.15 7.82-20.15 18 0 12.63 7.82 17.74 25.86 25.56l10.52 4.51c35.79 15.34 55.94 31 55.94 66.16.01 37.9-29.76 57.64-69.76 57.64z"}}]})(props);
	};
	module.exports.IoLogoLaravel = function IoLogoLaravel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505.57 234.62c-3.28-3.53-26.82-32.29-39.51-47.79-6.75-8.24-12.08-14.75-14.32-17.45l-.18-.22-.2-.21c-5.22-5.83-12.64-12.51-23.78-12.51a39.78 39.78 0 00-5.41.44c-.37.05-.75.11-1.15.15-2.45.27-10.06 1.5-28.14 4.48-14 2.29-35.11 5.77-38.31 6.07l-.71.06-.69.13c-10 1.78-16.62 6.22-19.56 13.19-1.55 3.68-3.22 11.15 2.94 19.86 1.53 2.22 6.83 9.56 15.94 22.17 6.06 8.4 12.87 17.82 18.75 26L259.9 275 150.66 96.05l-.2-.34-.23-.33-.44-.65C145.32 88.17 139.76 80 123.7 80c-1.13 0-2.31 0-3.63.11-4.6.25-21.42 1.57-40.89 3.11-21.49 1.69-50.9 4-54.72 4.1h-.73l-.79.08c-9.14.89-15.77 4.6-19.7 11-6.55 10.69-1.42 22.69.26 26.63C6.87 133 37.56 197.7 64.63 254.81c18 37.94 36.58 77.17 38.1 80.65a34.85 34.85 0 0032.94 21.59 46.62 46.62 0 009.86-1.1h.21l.2-.05c13.86-3.38 57.83-14.54 89.2-22.59 1.9 3.32 3.9 6.83 6 10.44 21.93 38.5 37.9 66.35 43.16 73.46C287 421 295 432 310.06 432c5.46 0 10.46-1.4 15.74-2.89l1.53-.43h.12c10.53-3 150.69-52.16 157.87-55.35l.22-.1c5.44-2.41 13.66-6.05 16.18-15.4 1.65-6.12.18-12.33-4.38-18.46l-.07-.09-.07-.09c-.85-1.1-4-5.21-8.27-10.9-9.13-12.07-23.88-31.57-36.84-48.54 17.37-4.5 38.8-10.11 43.38-11.55 11.47-3.43 14.94-10.69 16-14.73.79-3.15 1.82-11.2-5.9-18.85zm-320 58.19c-17.81 4.17-30.22 7.08-37.89 8.9-6.67-13.34-19.74-39.65-32.5-65.33-29.74-59.92-45.1-90.77-53.18-106.9l8.15-.7c13.34-1.15 31.61-2.72 41.78-3.57 16.76 28.26 74.32 125.3 96.3 162.3zM427.58 172zM310.06 416.4zm53.67-56.95c-24.21 8-37.33 12.37-44.42 14.74-6.3-10.34-20.16-33.52-32.47-54.19l115.7-29.48c5 6.81 14.57 19.72 33.46 44.93-18.07 6.04-48.2 16.02-72.27 24zm55.87-121.63l-23.76-31.53c13.67-2.39 21.54-3.77 26.15-4.6l12 14.88 11.94 14.82c-8.2 1.99-17.74 4.32-26.33 6.43z"}}]})(props);
	};
	module.exports.IoLogoLinkedin = function IoLogoLinkedin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M444.17 32H70.28C49.85 32 32 46.7 32 66.89v374.72C32 461.91 49.85 480 70.28 480h373.78c20.54 0 35.94-18.21 35.94-38.39V66.89C480.12 46.7 464.6 32 444.17 32zm-273.3 373.43h-64.18V205.88h64.18zM141 175.54h-.46c-20.54 0-33.84-15.29-33.84-34.43 0-19.49 13.65-34.42 34.65-34.42s33.85 14.82 34.31 34.42c-.01 19.14-13.31 34.43-34.66 34.43zm264.43 229.89h-64.18V296.32c0-26.14-9.34-44-32.56-44-17.74 0-28.24 12-32.91 23.69-1.75 4.2-2.22 9.92-2.22 15.76v113.66h-64.18V205.88h64.18v27.77c9.34-13.3 23.93-32.44 57.88-32.44 42.13 0 74 27.77 74 87.64z"}}]})(props);
	};
	module.exports.IoLogoMarkdown = function IoLogoMarkdown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M475 64H37C16.58 64 0 81.38 0 102.77v306.42C0 430.59 16.58 448 37 448h438c20.38 0 37-17.41 37-38.81V102.77C512 81.38 495.42 64 475 64zM288 368h-64V256l-48 64-48-64v112H64V144h64l48 80 48-80h64zm96 0l-80-112h48.05L352 144h64v112h48z"}}]})(props);
	};
	module.exports.IoLogoMastodon = function IoLogoMastodon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 173.59c0-104.13-68.26-134.65-68.26-134.65C377.3 23.15 318.2 16.5 256.8 16h-1.51c-61.4.5-120.46 7.15-154.88 22.94 0 0-68.27 30.52-68.27 134.65 0 23.85-.46 52.35.29 82.59C34.91 358 51.11 458.37 145.32 483.29c43.43 11.49 80.73 13.89 110.76 12.24 54.47-3 85-19.42 85-19.42l-1.79-39.5s-38.93 12.27-82.64 10.77c-43.31-1.48-89-4.67-96-57.81a108.44 108.44 0 01-1-14.9 558.91 558.91 0 0096.39 12.85c32.95 1.51 63.84-1.93 95.22-5.67 60.18-7.18 112.58-44.24 119.16-78.09 10.42-53.34 9.58-130.17 9.58-130.17zm-80.54 134.16h-50V185.38c0-25.8-10.86-38.89-32.58-38.89-24 0-36.06 15.53-36.06 46.24v67h-49.66v-67c0-30.71-12-46.24-36.06-46.24-21.72 0-32.58 13.09-32.58 38.89v122.37h-50V181.67q0-38.65 19.75-61.39c13.6-15.15 31.4-22.92 53.51-22.92 25.58 0 44.95 9.82 57.75 29.48L256 147.69l12.45-20.85c12.81-19.66 32.17-29.48 57.75-29.48 22.11 0 39.91 7.77 53.51 22.92q19.79 22.72 19.75 61.39z"}}]})(props);
	};
	module.exports.IoLogoMedium = function IoLogoMedium (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M28 28v456h456V28H28zm378.83 108.04l-24.46 23.45a7.162 7.162 0 00-2.72 6.86v172.28c-.44 2.61.61 5.26 2.72 6.86l23.88 23.45v5.15H286.13v-5.15l24.74-24.02c2.43-2.43 2.43-3.15 2.43-6.86V198.81l-68.79 174.71h-9.3l-80.09-174.71v117.1c-.67 4.92.97 9.88 4.43 13.44l32.18 39.03v5.15h-91.24v-5.15l32.18-39.03c3.44-3.57 4.98-8.56 4.15-13.44V180.5c.38-3.76-1.05-7.48-3.86-10.01l-28.6-34.46v-5.15h88.81l68.65 150.55 60.35-150.55h84.66v5.16z"}}]})(props);
	};
	module.exports.IoLogoMicrosoft = function IoLogoMicrosoft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M31.87 30.58H244.7v212.81H31.87zm235.02 0H479.7v212.81H266.89zM31.87 265.61H244.7v212.8H31.87zm235.02 0H479.7v212.8H266.89z"}}]})(props);
	};
	module.exports.IoLogoNoSmoking = function IoLogoNoSmoking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M360 256h16v48h-16zm-248 48h129.6l-48-48H112v48z"}},{"tag":"path","attr":{"d":"M364.5 60.1a8.79 8.79 0 01-1-.6 218.79 218.79 0 00-34.4-14.8l-5.4-1.8A223.2 223.2 0 00256 32C132.3 32 32 132.3 32 256a223.71 223.71 0 00115.4 195.8c.4.2.7.5 1.1.7a218.79 218.79 0 0034.4 14.8l5.4 1.8A222.7 222.7 0 00256 480c123.7 0 224-100.3 224-224A223.76 223.76 0 00364.5 60.1zM256 426.4a161.85 161.85 0 01-27.2-2.4 170.14 170.14 0 01-28.5-7.3c-1.9-.6-3.8-1.2-5.6-1.9a162.39 162.39 0 01-19-8.6 170.33 170.33 0 01-90.1-150.3c0-37.2 12.4-71.4 32.7-99.4l237.2 237.2c-28.1 20.3-62.3 32.7-99.5 32.7zm137.8-71L156.6 118.2c28-20.2 62.1-32.6 99.4-32.6a162.79 162.79 0 0127.2 2.4 170.14 170.14 0 0128.5 7.3c1.8.6 3.7 1.2 5.6 1.9a162 162 0 0118 8.1 170.25 170.25 0 0191.2 150.8c-.1 37.2-12.5 71.3-32.7 99.3z"}},{"tag":"path","attr":{"d":"M352 256h-34l34 34v-34zm32 0h16v48h-16zm-23.9-43.3c-8.8-4.1-22-5.7-45.6-5.7h-3.6c-12.7.1-15.9-.1-20-6.1-2.8-4.2-1-14.8 3.7-21.9a8 8 0 00.4-8.2 8.26 8.26 0 00-7-4.3 53.67 53.67 0 01-18.3-3.9c-10.6-4.5-15.6-12.1-15.6-23.1 0-25.8 21.8-27.7 22.8-27.7v-16c-12 0-38.8 11-38.8 43.7 0 17.5 9 31 25.7 38a66.58 66.58 0 0012 3.6c-3.3 9.8-3.6 20.9 1.7 28.7 9 13.3 20.3 13.2 33.3 13.1h3.5c26.3 0 34.6 2.3 38.9 4.3 5.7 2.6 6.8 7.5 6.6 15.7v1h16v-1c0-7.1.3-22.8-15.7-30.2z"}},{"tag":"path","attr":{"d":"M400 244c0-25.7-3-39.2-9.1-49.6C382.3 180 368.5 172 352 172h-17.4c2.9-8.3 5.4-19.8 3.5-30.9-3.2-18.8-19.1-30-43.1-30v16c21 0 26.1 9.1 27.4 16.7 2.5 14.5-6.8 32.1-6.9 32.3a8 8 0 00.1 7.9 8.06 8.06 0 006.9 3.9H352c10.9 0 19.4 4.9 25.1 14.6 3.1 5.3 6.9 13.5 6.9 41.4h16z"}}]})(props);
	};
	module.exports.IoLogoNodejs = function IoLogoNodejs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M429.76 130.07L274.33 36.85a37 37 0 00-36.65 0L82.24 130.06A38.2 38.2 0 0064 162.83V349a38.26 38.26 0 0018.24 32.8L123 406.14l.23.13c20.58 10.53 28.46 10.53 37.59 10.53 32.14 0 52.11-20.8 52.11-54.29V182a8.51 8.51 0 00-8.42-8.58h-22.38a8.51 8.51 0 00-8.42 8.58v180.51a15 15 0 01-6.85 13.07c-5.9 3.6-14.47 2.84-24.14-2.15l-39.06-23.51a1.1 1.1 0 01-.48-.92V165.46a1.32 1.32 0 01.59-1.06l151.84-93a.82.82 0 01.73 0l151.93 93a1.34 1.34 0 01.55 1.1V349a1.28 1.28 0 01-.45 1l-152.06 90.65a1.22 1.22 0 01-.8 0l-38.83-23.06a7.8 7.8 0 00-7.83-.41l-.34.2c-10.72 6.35-13.6 8-23.54 11.62-1.62.59-5.43 2-5.76 5.77s3.29 6.45 6.51 8.32l51.9 31.87a35.67 35.67 0 0018.3 5.07h.58a35.87 35.87 0 0017.83-5.07l155.43-93.13A38.37 38.37 0 00448 349V162.83a38.21 38.21 0 00-18.24-32.76z"}},{"tag":"path","attr":{"d":"M307.88 318.05c-37.29 0-45.24-10.42-47.6-27.24a8.43 8.43 0 00-8.22-7.32h-19.8a8.44 8.44 0 00-8.26 8.58c0 14.58 5.12 62.17 83.92 62.17 24.38 0 44.66-5.7 58.63-16.49S388 311.26 388 292.55c0-37.55-24.5-47.83-72.75-54.55-49.05-6.82-49.05-10.29-49.05-17.89 0-5.47 0-18.28 35.46-18.28 25.23 0 38.74 3.19 43.06 20a8.35 8.35 0 008.06 6.67h19.87a8.24 8.24 0 006.16-2.86 8.91 8.91 0 002.12-6.44c-2.57-35.55-28.56-53.58-79.24-53.58-46.06 0-73.55 20.75-73.55 55.5 0 38.1 28.49 48.87 71.29 53.33 50 5.17 50 12.71 50 19.37.03 10.38-4.28 24.23-41.55 24.23z"}}]})(props);
	};
	module.exports.IoLogoNpm = function IoLogoNpm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M227.6 213.1H256v57.1h-28.4z"}},{"tag":"path","attr":{"d":"M0 156v171.4h142.2V356H256v-28.6h256V156zm142.2 142.9h-28.4v-85.7H85.3v85.7H28.4V184.6h113.8zm142.2 0h-56.9v28.6h-56.9V184.6h113.8zm199.2 0h-28.4v-85.7h-28.4v85.7h-28.4v-85.7H370v85.7h-56.9V184.6h170.7v114.3z"}}]})(props);
	};
	module.exports.IoLogoOctocat = function IoLogoOctocat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M172.86 290.12c-9.75 0-18.11 4.56-24.86 13.87s-10.07 20.58-10.07 34 3.43 24.91 10.07 34.12S163 386 172.86 386c9.1 0 17-4.66 23.68-13.87s10.07-20.58 10.07-34.12-3.43-24.81-10.07-34-14.54-13.89-23.68-13.89zm167.46 0c-9.64 0-18.11 4.56-24.86 13.87s-10.07 20.58-10.07 34 3.43 24.91 10.07 34.12S330.57 386 340.32 386c9.11 0 17-4.66 23.79-13.87s10.07-20.58 10.07-34.12-3.43-24.81-10.07-34-14.57-13.89-23.79-13.89z"}},{"tag":"path","attr":{"d":"M459.36 165c-.11 0 2.89-15.49.32-42.47-2.36-27-8-51.78-17.25-74.53 0 0-4.72.87-13.72 3.14S405 58 384.89 67.18c-19.82 9.2-40.71 21.44-62.46 36.29-14.79-4.23-36.86-6.39-66.43-6.39-28.18 0-50.25 2.16-66.43 6.39Q117.9 53.25 69.46 48q-13.81 34.13-17.14 74.75c-2.57 27 .43 42.58.43 42.58C26.71 193.82 16 234.88 16 268.78c0 26.22.75 49.94 6.54 71 6 20.91 13.6 38 22.6 51.14A147.49 147.49 0 0079 425.43c13.39 10.08 25.71 17.34 36.86 21.89 11.25 4.76 24 8.23 38.57 10.72a279.19 279.19 0 0032.68 4.34s30 1.62 69 1.62 68.89-1.62 68.89-1.62a285.25 285.25 0 0032.68-4.38 178.91 178.91 0 0038.46-10.72c11.15-4.66 23.47-11.81 37-21.89a145 145 0 0033.75-34.55c9-13.11 16.6-30.23 22.6-51.14s6.51-44.81 6.51-71.03c0-32.82-10.71-74.42-36.64-103.67zm-70.07 253.07C359.39 432.26 315.46 438 257.18 438h-2.25c-58.29 0-102.22-5.63-131.57-19.93s-44.25-43.45-44.25-87.43c0-26.32 9.21-47.66 27.32-64 7.93-7 17.57-11.92 29.57-14.84s22.93-3 33.21-2.71c10.08.43 24.22 2.38 42.11 3.79s31.39 3.25 44.79 3.25c12.53 0 29.14-2.17 55.82-4.33s46.61-3.25 59.46-1.09c13.18 2.17 24.65 6.72 34.4 15.93q28.44 25.67 28.5 64c-.11 43.98-15.22 73.24-45 87.43z"}}]})(props);
	};
	module.exports.IoLogoPaypal = function IoLogoPaypal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424.81 148.79c-.43 2.76-.93 5.58-1.49 8.48-19.17 98-84.76 131.8-168.54 131.8h-42.65a20.67 20.67 0 00-20.47 17.46l-21.84 137.84-6.18 39.07a10.86 10.86 0 009.07 12.42 10.72 10.72 0 001.7.13h75.65a18.18 18.18 0 0018-15.27l.74-3.83 14.24-90 .91-4.94a18.16 18.16 0 0118-15.3h11.31c73.3 0 130.67-29.62 147.44-115.32 7-35.8 3.38-65.69-15.16-86.72a72.27 72.27 0 00-20.73-15.82z"}},{"tag":"path","attr":{"d":"M385.52 51.09C363.84 26.52 324.71 16 274.63 16H129.25a20.75 20.75 0 00-20.54 17.48l-60.55 382a12.43 12.43 0 0010.39 14.22 12.58 12.58 0 001.94.15h89.76l22.54-142.29-.7 4.46a20.67 20.67 0 0120.47-17.46h42.65c83.77 0 149.36-33.86 168.54-131.8.57-2.9 1.05-5.72 1.49-8.48 5.7-36.22-.05-60.87-19.72-83.19z"}}]})(props);
	};
	module.exports.IoLogoPinterest = function IoLogoPinterest (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.05 32c-123.7 0-224 100.3-224 224 0 91.7 55.2 170.5 134.1 205.2-.6-15.6-.1-34.4 3.9-51.4 4.3-18.2 28.8-122.1 28.8-122.1s-7.2-14.3-7.2-35.4c0-33.2 19.2-58 43.2-58 20.4 0 30.2 15.3 30.2 33.6 0 20.5-13.1 51.1-19.8 79.5-5.6 23.8 11.9 43.1 35.4 43.1 42.4 0 71-54.5 71-119.1 0-49.1-33.1-85.8-93.2-85.8-67.9 0-110.3 50.7-110.3 107.3 0 19.5 5.8 33.3 14.8 43.9 4.1 4.9 4.7 6.9 3.2 12.5-1.1 4.1-3.5 14-4.6 18-1.5 5.7-6.1 7.7-11.2 5.6-31.3-12.8-45.9-47-45.9-85.6 0-63.6 53.7-139.9 160.1-139.9 85.5 0 141.8 61.9 141.8 128.3 0 87.9-48.9 153.5-120.9 153.5-24.2 0-46.9-13.1-54.7-27.9 0 0-13 51.6-15.8 61.6-4.7 17.3-14 34.5-22.5 48a225.13 225.13 0 0063.5 9.2c123.7 0 224-100.3 224-224S379.75 32 256.05 32z"}}]})(props);
	};
	module.exports.IoLogoPlaystation = function IoLogoPlaystation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M399.77 203c-.8-17.1-3.3-34.5-10.8-50.1a82.45 82.45 0 00-16.5-23.2 105.59 105.59 0 00-21.3-16.3c-17.1-10.2-37.5-17-84.4-31S192 64 192 64v358.3l79.9 25.7s.1-198.8.1-299.5v-3.8c0-9.3 7.5-16.8 16.1-16.8h.5c8.5 0 15.5 7.5 15.5 16.8V278c11 5.3 29.2 9.3 41.8 9.1a47.79 47.79 0 0024-5.7 49.11 49.11 0 0018.4-17.8 78.64 78.64 0 009.9-27.3c1.87-10.8 1.97-22.1 1.57-33.3zM86.67 357.8c27.4-9.8 89.3-29.5 89.3-29.5v-47.2s-76.5 24.8-111.3 37.1c-8.6 3.1-17.3 5.9-25.7 9.5-9.8 4.1-19.4 8.7-28.1 14.8a26.29 26.29 0 00-9.2 10.1 17.36 17.36 0 00-.5 13.6c2 5.1 5.8 9.3 10.1 12.6 7.8 5.9 17.1 9.5 26.4 12.2a262.42 262.42 0 0088.4 13.3c14.5-.2 36-1.9 50-4.4v-42s-11 2.5-41.3 12.5c-4.6 1.5-9.2 3.3-14 4.3a104.87 104.87 0 01-21.6 2.2c-6.5-.3-13.2-.7-19.3-3.1-2.2-1-4.6-2.2-5.5-4.6-.8-2 .3-4 1.7-5.4 2.8-2.9 6.8-4.5 10.6-6z"}},{"tag":"path","attr":{"d":"M512 345.9c-.1-6-3.7-11.2-7.9-15-7.1-6.3-15.9-10.3-24.7-13.5-5.5-1.9-9.3-3.3-14.7-5-25.2-8.2-51.9-11.2-78.3-11.3-8 .3-23.1.5-31 1.4-21.9 2.5-67.3 15.4-67.3 15.4v48.8s67.5-21.6 96.5-31.8a94.43 94.43 0 0130.3-4.6c6.5.2 13.2.7 19.4 3.1 2.2.9 4.5 2.2 5.5 4.5.9 2.6-.9 5-2.9 6.5-4.7 3.8-10.7 5.3-16.2 7.4-41 14.5-132.7 44.7-132.7 44.7v47s117.2-39.6 170.8-58.8c8.9-3.3 17.9-6.1 26.4-10.4 7.9-4 15.8-8.6 21.8-15.3a19.74 19.74 0 005-13.1z"}}]})(props);
	};
	module.exports.IoLogoPwa = function IoLogoPwa (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M330.7 352l77.72-192H356.9l-53.16 124.07L265.93 160h-39.61l-40.58 124.07-28.63-56.53-25.9 79.46 26.3 45h50.7l36.68-111.27 35 111.27zM48.79 286.09h31.65a93.39 93.39 0 0025.62-3.21l8.18-25.19 22.88-70.39a55.75 55.75 0 00-6-7.82Q113.54 160 79.59 160H0v192h48.79zm41.9-81.92q6.89 6.92 6.88 18.52t-6 18.53q-6.64 7.62-24.44 7.61H48.79v-51.58h18.42q16.59 0 23.48 6.92zm286.16 113.44l14.79-37.25h42.69l-20.26-56.51L439.41 160 512 352h-53.53l-12.4-34.39z"}}]})(props);
	};
	module.exports.IoLogoPython = function IoLogoPython (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M314 36.38c-18.59-3.06-45.8-4.47-64.27-4.38a311.09 311.09 0 00-51.66 4.38c-45.74 8-54.07 24.7-54.07 55.54V128h112v16H107.62C66.06 144 32.33 193.67 32 255.12v.88a162.91 162.91 0 003.13 32c9.29 46.28 38.23 80 72.49 80H128v-54c0-31.3 20.84-59.95 55-66.1l9.87-1.23H314a56.05 56.05 0 0015.06-2A52.48 52.48 0 00368 193.68V91.92c0-28.92-24.68-50.73-54-55.54zM194.93 105.5a20.37 20.37 0 1120.3-20.3 20.29 20.29 0 01-20.3 20.3z"}},{"tag":"path","attr":{"d":"M475.28 217c-10.7-42.61-38.41-73-70.9-73h-17.71v47.45c0 39.57-26 68.22-57.74 73.13a63.54 63.54 0 01-9.69.75H198.08a60 60 0 00-15.23 1.95C160.54 273.14 144 291.7 144 315.77v101.77c0 29 29.14 46 57.73 54.31 34.21 9.95 71.48 11.75 112.42 0 27.19-7.77 53.85-23.48 53.85-54.31V384H256v-16h148.38c29.44 0 54.95-24.93 67.45-61.31A156.83 156.83 0 00480 256a160.64 160.64 0 00-4.72-39zM316.51 404a20.37 20.37 0 11-20.3 20.3 20.29 20.29 0 0120.3-20.3z"}}]})(props);
	};
	module.exports.IoLogoReact = function IoLogoReact (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M410.66 180.72q-7.67-2.62-15.45-4.88 1.29-5.25 2.38-10.56c11.7-56.9 4.05-102.74-22.06-117.83-25-14.48-66 .61-107.36 36.69q-6.1 5.34-11.95 11-3.9-3.76-8-7.36c-43.35-38.58-86.8-54.83-112.88-39.69-25 14.51-32.43 57.6-21.9 111.53q1.58 8 3.55 15.93a320.85 320.85 0 00-17.77 5.6C48.46 198.9 16 226.73 16 255.59c0 29.82 34.84 59.72 87.77 77.85q6.44 2.19 13 4.07-2.13 8.49-3.77 17.17c-10 53-2.2 95.07 22.75 109.49 25.77 14.89 69-.41 111.14-37.31q5-4.38 10-9.25 6.32 6.11 13 11.86c40.8 35.18 81.09 49.39 106 34.93 25.75-14.94 34.12-60.14 23.25-115.13q-1.25-6.3-2.88-12.86 4.56-1.35 8.93-2.79c55-18.27 90.83-47.81 90.83-78-.02-29-33.52-57.01-85.36-74.9zm-129-81.08c35.43-30.91 68.55-43.11 83.65-34.39 16.07 9.29 22.32 46.75 12.22 95.88q-1 4.8-2.16 9.57a487.83 487.83 0 00-64.18-10.16 481.27 481.27 0 00-40.57-50.75q5.38-5.22 11.02-10.15zM157.73 280.25q6.51 12.6 13.61 24.89 7.23 12.54 15.07 24.71a435.28 435.28 0 01-44.24-7.13c4.24-13.72 9.46-27.97 15.56-42.47zm0-48.33c-6-14.19-11.08-28.15-15.25-41.63 13.7-3.07 28.3-5.58 43.52-7.48q-7.65 11.94-14.72 24.23t-13.58 24.88zm10.9 24.17q9.48-19.77 20.42-38.78 10.93-19 23.27-37.13c14.28-1.08 28.92-1.65 43.71-1.65s29.52.57 43.79 1.66q12.21 18.09 23.13 37t20.69 38.6Q334 275.63 323 294.73q-10.91 19-23 37.24c-14.25 1-29 1.55-44 1.55s-29.47-.47-43.46-1.38q-12.43-18.19-23.46-37.29t-20.48-38.76zM340.75 305q7.25-12.58 13.92-25.49a440.41 440.41 0 0116.12 42.32 434.44 434.44 0 01-44.79 7.65q7.62-12.09 14.75-24.48zm13.72-73.07q-6.64-12.65-13.81-25-7-12.18-14.59-24.06c15.31 1.94 30 4.52 43.77 7.67a439.89 439.89 0 01-15.37 41.39zm-98.24-107.45a439.75 439.75 0 0128.25 34.18q-28.35-1.35-56.74 0c9.33-12.34 18.88-23.79 28.49-34.18zM145.66 65.86c16.06-9.32 51.57 4 89 37.27 2.39 2.13 4.8 4.36 7.2 6.67A491.37 491.37 0 00201 160.51a499.12 499.12 0 00-64.06 10q-1.83-7.36-3.3-14.82c-9.05-46.23-3.06-81.08 12.02-89.83zm-23.41 251.85q-6-1.71-11.85-3.71c-23.4-8-42.73-18.44-56-29.81-11.88-10.19-17.9-20.36-17.9-28.6 0-17.51 26.06-39.85 69.52-55q8.19-2.85 16.52-5.21a493.54 493.54 0 0023.4 60.75 502.46 502.46 0 00-23.69 61.58zm111.13 93.67c-18.63 16.32-37.29 27.89-53.74 33.72-14.78 5.23-26.55 5.38-33.66 1.27-15.14-8.75-21.44-42.54-12.85-87.86q1.53-8 3.5-16a480.85 480.85 0 0064.69 9.39 501.2 501.2 0 0041.2 51c-2.98 2.93-6.03 5.75-9.14 8.48zm23.42-23.22c-9.72-10.51-19.42-22.14-28.88-34.64q13.79.54 28.08.54c9.78 0 19.46-.21 29-.64a439.33 439.33 0 01-28.2 34.74zm124.52 28.59c-2.86 15.44-8.61 25.74-15.72 29.86-15.13 8.78-47.48-2.63-82.36-32.72-4-3.44-8-7.13-12.07-11a484.54 484.54 0 0040.23-51.2 477.84 477.84 0 0065-10.05q1.47 5.94 2.6 11.64c4.81 24.3 5.5 46.28 2.32 63.47zm17.4-102.64c-2.62.87-5.32 1.71-8.06 2.53a483.26 483.26 0 00-24.31-60.94 481.52 481.52 0 0023.36-60.06c4.91 1.43 9.68 2.93 14.27 4.52 44.42 15.32 71.52 38 71.52 55.43 0 18.6-29.27 42.74-76.78 58.52z"}},{"tag":"path","attr":{"d":"M256 298.55a43 43 0 10-42.86-43 42.91 42.91 0 0042.86 43z"}}]})(props);
	};
	module.exports.IoLogoReddit = function IoLogoReddit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M324 256a36 36 0 1036 36 36 36 0 00-36-36z"}},{"tag":"circle","attr":{"cx":"188","cy":"292","r":"36","transform":"rotate(-22.5 187.997 291.992)"}},{"tag":"path","attr":{"d":"M496 253.77c0-31.19-25.14-56.56-56-56.56a55.72 55.72 0 00-35.61 12.86c-35-23.77-80.78-38.32-129.65-41.27l22-79 66.41 13.2c1.9 26.48 24 47.49 50.65 47.49 28 0 50.78-23 50.78-51.21S441 48 413 48c-19.53 0-36.31 11.19-44.85 28.77l-90-17.89-31.1 109.52-4.63.13c-50.63 2.21-98.34 16.93-134.77 41.53A55.38 55.38 0 0072 197.21c-30.89 0-56 25.37-56 56.56a56.43 56.43 0 0028.11 49.06 98.65 98.65 0 00-.89 13.34c.11 39.74 22.49 77 63 105C146.36 448.77 199.51 464 256 464s109.76-15.23 149.83-42.89c40.53-28 62.85-65.27 62.85-105.06a109.32 109.32 0 00-.84-13.3A56.32 56.32 0 00496 253.77zM414 75a24 24 0 11-24 24 24 24 0 0124-24zM42.72 253.77a29.6 29.6 0 0129.42-29.71 29 29 0 0113.62 3.43c-15.5 14.41-26.93 30.41-34.07 47.68a30.23 30.23 0 01-8.97-21.4zM390.82 399c-35.74 24.59-83.6 38.14-134.77 38.14S157 423.61 121.29 399c-33-22.79-51.24-52.26-51.24-83A78.5 78.5 0 0175 288.72c5.68-15.74 16.16-30.48 31.15-43.79a155.17 155.17 0 0114.76-11.53l.3-.21.24-.17c35.72-24.52 83.52-38 134.61-38s98.9 13.51 134.62 38l.23.17.34.25A156.57 156.57 0 01406 244.92c15 13.32 25.48 28.05 31.16 43.81a85.44 85.44 0 014.31 17.67 77.29 77.29 0 01.6 9.65c-.01 30.72-18.21 60.19-51.25 82.95zm69.6-123.92c-7.13-17.28-18.56-33.29-34.07-47.72A29.09 29.09 0 01440 224a29.59 29.59 0 0129.41 29.71 30.07 30.07 0 01-8.99 21.39z"}},{"tag":"path","attr":{"d":"M323.23 362.22c-.25.25-25.56 26.07-67.15 26.27-42-.2-66.28-25.23-67.31-26.27a4.14 4.14 0 00-5.83 0l-13.7 13.47a4.15 4.15 0 000 5.89c3.4 3.4 34.7 34.23 86.78 34.45 51.94-.22 83.38-31.05 86.78-34.45a4.16 4.16 0 000-5.9l-13.71-13.47a4.13 4.13 0 00-5.81 0z"}}]})(props);
	};
	module.exports.IoLogoRss = function IoLogoRss (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M108.56 342.78a60.34 60.34 0 1060.56 60.44 60.63 60.63 0 00-60.56-60.44z"}},{"tag":"path","attr":{"d":"M48 186.67v86.55c52 0 101.94 15.39 138.67 52.11s52 86.56 52 138.67h86.66c0-151.56-125.66-277.33-277.33-277.33z"}},{"tag":"path","attr":{"d":"M48 48v86.56c185.25 0 329.22 144.08 329.22 329.44H464C464 234.66 277.67 48 48 48z"}}]})(props);
	};
	module.exports.IoLogoSass = function IoLogoSass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.78 328.07c-1.47-11.92-7.51-22.26-18-30.77a3.58 3.58 0 00-.43-.44l-.53-.38-.17-.12-5.57-4-.19-.14-.71-.5a3.5 3.5 0 00-.83-.35c-17.62-10.49-46.79-17.84-91.42-2.09-10.65-17.92-11.86-32.28-4.73-54.28 1.27-3.83.09-6.36-3.71-8-7.64-3.25-18.1-1.59-25.52.37-3.46.9-5.54 2.86-6.2 5.83-4.7 22-18.36 42.1-31.57 61.5l-.78 1.14c-8.14-17.26-6.45-30.63-.78-47.38 1.13-3.34.24-5.56-2.89-7.22-8.74-4.51-21.85-1.41-27.07.13-6.62 1.93-13.72 19.82-21.65 41.24-2 5.39-3.72 10-4.75 12.15-2.45 5-4.79 10.7-7.27 16.75-5.6 13.69-11.91 29.1-20.93 38.78-3.28-7.25 1.88-18.68 6.89-29.77 5.93-13.11 11.53-25.5 5.08-33.41a11.82 11.82 0 00-8.33-4.32 13.26 13.26 0 00-6.15 1c.67-5.65.7-10.11-.95-15.5-2.36-7.69-8.49-12-16.93-11.77-19.22.56-35.48 14.88-45.75 26.8-6.84 8-22 14.1-35.31 19.45-5.26 2.23-10.26 4.23-14.43 6.23-6.65-5.62-15.1-11.29-24-17.28-25-16.78-53.33-35.81-54.31-61.61-1.4-38.11 42-65.14 79.88-84.43 28.71-14.6 53.67-24.28 76.31-29.57 31.8-7.43 58.66-5.93 79.82 4.44 11.58 5.67 17 18 13.56 30.68-9 32.95-46.29 55.53-78.18 65.69-19.21 6.12-35.56 8.68-50 7.84-18.1-1.05-32.88-10.13-39.2-14a21.18 21.18 0 00-3.2-1.8l-.29-.07a3.21 3.21 0 00-3.19 1c-1.3 1.55-.84 4-.37 5.24 6.15 16.07 18.85 26.22 37.74 30.17a92.09 92.09 0 0018.78 1.79c44.21 0 100.62-25.49 121.34-46.48 14.13-14.3 24.42-29 28.68-54.35 4.45-26.55-13.55-45-31.89-53.5-44.57-20.57-95.19-12.44-129.81-2-40.5 12.21-82.4 34.41-114.94 60.93-40.12 32.67-54.62 63-43.12 90.25 11.81 27.93 40.61 45.4 68.46 62.3 9 5.45 17.56 10.64 25.27 16-2.32 1.13-4.69 2.28-7.1 3.43-23.38 11.33-49.9 24.08-64.61 45.15-10.68 15.35-12.68 30.63-5.94 45.42 3.6 7.87 10 13.21 18.89 15.87A50 50 0 0053 432c17.31 0 36.36-7 46.73-13.47 18.32-11.5 30.19-26.94 35.29-45.89 4.54-16.86 3.45-33.61-3.15-48.56l22.45-11.32c-10.83 36-2.53 57.5 6.59 69.36 3.36 4.37 9.42 7 16.19 7.12s13-2.43 16.52-6.77c6.66-8.25 11.58-17.9 16.11-27.55-.24 6.3.06 12.68 2.21 18.09 1.93 4.87 5.11 8.1 9.21 9.34 4.36 1.33 9.47.21 14.39-3.15 22.17-15.17 37.33-51.58 49.51-80.85 1.73-4.16 3.39-8.16 5-11.9a152.5 152.5 0 0012.5 31.07c1.18 2.14 1.08 3.08-.52 4.84-2.41 2.64-5.77 5.83-9.33 9.21-10.78 10.23-24.2 23-26 34.23-.7 4.5 2.4 8.6 7.21 9.53 14.47 2.88 31.9-1.33 46.64-11.25 13.4-9 18.44-21.55 15-37.19-3.33-15.06 4.27-33.76 22.59-55.62 3 12.53 7 22.66 12.52 31.53l-.15.12c-13.34 11.65-31.62 27.6-28.78 46.95a13.35 13.35 0 005.58 9.22 14.22 14.22 0 0011.2 2.06c17.47-3.67 30.62-11.06 40.18-22.57s6.07-24.27 2.85-34.17c25-6.78 47.26-6.61 68.1.5 11.7 4 20.09 10.57 24.93 19.64 6.09 11.41 2.8 21.94-9.29 29.65-3.71 2.37-5.5 3.82-5.61 5.65a2.65 2.65 0 001 2.23c1.4 1.15 5.72 3.15 15.49-3 9-5.65 14.28-13.34 15.63-23a39 39 0 00-.01-8.01zm-399.73 25.06l-.1 1.28c-1.56 14.64-9 27.4-22.15 38-8.26 6.66-17.23 10.75-25.25 11.53-5.6.54-9.67-.22-12.09-2.27-1.81-1.53-2.78-3.82-3-7-1.64-25.48 38.32-50.8 60.81-59.13a51.39 51.39 0 011.78 17.59zm102.35-71.86c-3.7 21.09-14.49 60.9-31.45 76.35-.81.74-1.49 1-1.8.93s-.55-.44-.8-1c-5.66-13.12-3.57-35.28 5-52.69 6.59-13.42 16-22.31 26.52-25a5.29 5.29 0 011.34-.19 1.58 1.58 0 011 .27 1.64 1.64 0 01.19 1.33zm83.49 76.88c-3.19 3.33-7.56 2.88-6.53 1.66l16.24-17.24c-1.31 5.93-5.18 10.84-9.71 15.58zm67.37-14.91a14.07 14.07 0 01-4.93 1.39c-.46-9.07 8.33-19.28 17-26.09 2.33 9.46-2.44 19.46-12.07 24.7z"}}]})(props);
	};
	module.exports.IoLogoSkype = function IoLogoSkype (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M467.16 303.6a205.69 205.69 0 004.9-45.15c0-116.32-95.69-210.7-213.79-210.7a221.83 221.83 0 00-36.52 3A123.58 123.58 0 00155.93 32C87.55 32 32 86.72 32 154.15A119.56 119.56 0 0049 216a211.16 211.16 0 00-4.32 42.35c0 116.44 95.69 210.7 213.67 210.7a214 214 0 0039.09-3.5A125.45 125.45 0 00356.07 480C424.57 480 480 425.28 480 357.85a118 118 0 00-12.84-54.25zM368 359c-9.92 13.76-24.51 24.73-43.41 32.43S283.36 403 257.69 403c-30.69 0-56.36-5.37-76.55-15.87a101 101 0 01-35.24-30.8c-9.11-12.83-13.66-25.66-13.66-38 0-7.7 3-14.35 8.87-19.95 5.84-5.37 13.42-8.17 22.29-8.17 7.35 0 13.65 2.1 18.79 6.42 4.9 4.08 9.1 10.15 12.48 18.08A108.09 108.09 0 00207 336.15q6.32 8.22 17.86 13.65c7.82 3.62 18.2 5.48 31 5.48 17.62 0 32.09-3.73 42.94-11.08 10.74-7.12 15.88-15.75 15.88-26.25 0-8.28-2.69-14.82-8.29-19.95-5.83-5.37-13.42-9.57-22.87-12.37-9.69-3-22.87-6.18-39.21-9.56-22.17-4.67-41-10.27-56-16.57-15.28-6.42-27.65-15.4-36.76-26.48-9.22-11.32-13.77-25.55-13.77-42.24a67.86 67.86 0 0114.47-42.58c9.57-12.25 23.46-21.82 41.55-28.35 17.74-6.53 38.86-9.8 62.66-9.8 19.14 0 35.83 2.22 49.83 6.42s25.91 10.15 35.36 17.38 16.34 14.93 20.77 23 6.66 16.22 6.66 24c0 7.46-2.92 14.35-8.76 20.3a29.65 29.65 0 01-21.94 9.1c-7.93 0-14.12-1.87-18.43-5.6-4-3.5-8.17-8.87-12.72-16.69-5.37-9.91-11.79-17.85-19.14-23.45-7.24-5.36-19.14-8.16-35.71-8.16-15.29 0-27.77 3-37 9-8.87 5.72-13.19 12.37-13.19 20.18a18.26 18.26 0 004.32 12.25 38.13 38.13 0 0012.72 9.57 90.14 90.14 0 0017.15 6.53c6 1.64 15.87 4.09 29.53 7.12 17.38 3.62 33.25 7.82 47.26 12.13 14.24 4.55 26.49 10 36.52 16.45a72.93 72.93 0 0124.16 25.09c5.72 10 8.64 22.63 8.64 37.1A75.09 75.09 0 01368 359z"}}]})(props);
	};
	module.exports.IoLogoSlack = function IoLogoSlack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M126.12 315.1A47.06 47.06 0 1179.06 268h47.06zm23.72 0a47.06 47.06 0 0194.12 0v117.84a47.06 47.06 0 11-94.12 0zm47.06-188.98A47.06 47.06 0 11244 79.06v47.06zm0 23.72a47.06 47.06 0 010 94.12H79.06a47.06 47.06 0 010-94.12zm188.98 47.06a47.06 47.06 0 1147.06 47.1h-47.06zm-23.72 0a47.06 47.06 0 01-94.12 0V79.06a47.06 47.06 0 1194.12 0zM315.1 385.88a47.06 47.06 0 11-47.1 47.06v-47.06zm0-23.72a47.06 47.06 0 010-94.12h117.84a47.06 47.06 0 110 94.12z"}}]})(props);
	};
	module.exports.IoLogoSnapchat = function IoLogoSnapchat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 347.21a190.31 190.31 0 01-32.79-5.31c-27.28-6.63-54.84-24.26-68.12-52.43-6.9-14.63-2.64-18.59 11.86-24 14.18-5.27 29.8-7.72 36.86-23 5.89-12.76 1.13-27.76-10.41-35.49-15.71-10.53-30.35-.21-46.62 2.07 3.73-46.66 8.66-88.57-22.67-127.73C338.14 48.86 297.34 32 256.29 32s-81.86 16.86-107.81 49.33c-31.38 39.26-26.4 81.18-22.67 127.92-16.32-2.25-30.81-12.79-46.63-2.18-14.72 9.85-17 29.76-5.44 43s31.64 9.5 43.45 20.6c6.49 6.09 3.49 12.61-.35 20.14-14.48 28.4-39.26 45.74-69.84 51.56-4 .76-22.31 2.87-31 3.65 0 9.28.52 16.78 1.63 21.73 2.94 13.06 12.32 23.58 23.69 30.1 11.18 6.4 35.48 6.43 41.68 15.51 3 4.48 1.76 12.28 5.33 17.38a23.8 23.8 0 0015.37 9.75c18.61 3.61 37.32-7.2 56.42-2.1 14.85 3.95 26.52 15.87 39.26 24 15.51 9.85 32.34 16.42 50.83 17.49 38.1 2.21 59.93-18.91 90.58-36.42 19.5-11.14 38.15-3.86 58.88-2.68 20.1 1.15 23.53-9.25 29.62-24.88a27.37 27.37 0 001.54-4.85 10.52 10.52 0 002.28-1.47c2-1.57 10.55-2.34 12.76-2.86 10.28-2.44 20.34-5.15 29.17-11.2 11.31-7.76 17.65-18.5 19.58-32.64a93.73 93.73 0 001.38-15.67zM208 128c8.84 0 16 10.74 16 24s-7.16 24-16 24-16-10.74-16-24 7.16-24 16-24zm103.62 77.7c-15.25 15-35 23.3-55.62 23.3a78.37 78.37 0 01-55.66-23.34 8 8 0 0111.32-11.32A62.46 62.46 0 00256 213c16.39 0 32.15-6.64 44.39-18.7a8 8 0 0111.23 11.4zM304 176c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24z"}}]})(props);
	};
	module.exports.IoLogoSoundcloud = function IoLogoSoundcloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M5.8 278a2.11 2.11 0 00-2 2L0 308.64l3.74 28.16a2.12 2.12 0 002.05 2 2.14 2.14 0 002-2l4.44-28.17L7.83 280a2.14 2.14 0 00-2-2zm21.05-15.68a2.13 2.13 0 00-4.26 0l-5 46.32 5 45.3a2.13 2.13 0 004.26 0l5.73-45.31-5.73-46.32zm79.32-42.73a4 4 0 00-3.87 3.87l-4 85.22 4 55.08a3.88 3.88 0 007.75 0l4.53-55.08-4.53-85.22a4 4 0 00-3.88-3.87zm-41.05 29.62a3.09 3.09 0 00-3 3l-4.52 56.45 4.51 54.63a3 3 0 006 0l5.13-54.63-5.13-56.48a3.1 3.1 0 00-2.99-2.97zm82.76 118.39a4.83 4.83 0 004.75-4.74l3.93-54.15-3.93-113.46a4.75 4.75 0 00-9.5 0l-3.49 113.45 3.49 54.17a4.81 4.81 0 004.75 4.73zm85.4.25a6.6 6.6 0 006.5-6.52l2.74-52.6-2.74-131a6.5 6.5 0 10-13 0l-2.45 131c0 .08 2.45 52.67 2.45 52.67a6.59 6.59 0 006.5 6.45zm-43.02-.2a5.67 5.67 0 005.62-5.64l3.34-53.33-3.34-114.28a5.63 5.63 0 10-11.25 0l-3 114.29 3 53.32a5.66 5.66 0 005.63 5.6zm-104.7-.5a3.53 3.53 0 003.44-3.41l4.83-55.09-4.83-52.4a3.44 3.44 0 00-6.88 0l-4.26 52.38 4.26 55.08a3.5 3.5 0 003.44 3.44zm-40.72-3.02a2.67 2.67 0 002.57-2.52l5.43-53-5.42-55a2.57 2.57 0 00-5.14 0l-4.78 55 4.78 53a2.62 2.62 0 002.56 2.53zm166.85-171.6a6.1 6.1 0 00-6.07 6.09l-2.71 110.11 2.71 53a6.07 6.07 0 0012.13 0l3-53-3-110.13a6.1 6.1 0 00-6.06-6.07zM127 367.71a4.41 4.41 0 004.31-4.3l4.23-54.71-4.28-104.7a4.32 4.32 0 00-8.63 0l-3.74 104.7 3.75 54.73a4.38 4.38 0 004.36 4.28zm47.17-5.17l3.63-53.8-3.63-117.28a5.19 5.19 0 10-10.37 0l-3.23 117.28 3.23 53.83a5.18 5.18 0 0010.36 0zM449 241.1a62.42 62.42 0 00-24.33 4.9c-5-57.18-52.61-102-110.66-102a111.92 111.92 0 00-40.28 7.58c-4.75 1.85-6 3.76-6.06 7.46V360.4a7.66 7.66 0 006.8 7.5l174.56.11c34.78 0 63-28.41 63-63.45s-28.2-63.46-63-63.46zm-194.21-82.23a7 7 0 00-6.94 7L245 308.75l2.85 51.87a6.94 6.94 0 1013.87-.06v.06l3.09-51.87-3.09-142.93a7 7 0 00-6.93-6.95z"}}]})(props);
	};
	module.exports.IoLogoStackoverflow = function IoLogoStackoverflow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M392 440V320h40v160H64V320h40v120z"}},{"tag":"path","attr":{"d":"M149.1 308.77l198.57 40.87 8.4-39.32-198.57-40.87zm26.27-93.12L359.22 300 376 263.76l-183.82-84.84zm50.95-89l156 127.78 25.74-30.52-156-127.78zM328 32l-33.39 23.8 120.82 160.37L448 192zM144 400h204v-40H144z"}}]})(props);
	};
	module.exports.IoLogoSteam = function IoLogoSteam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M478.8 208.2a36 36 0 11-36-36 36 36 0 0136 36zM442.6 139a69.42 69.42 0 00-69.4 68.7l-43.2 62a48.86 48.86 0 00-5.4-.3 51.27 51.27 0 00-26.4 7.3L102.4 198a51.8 51.8 0 10-50.6 62.9 51.27 51.27 0 0026.4-7.3L274 332.2a51.76 51.76 0 00102.1-5.9l66.5-48.6a69.35 69.35 0 100-138.7zm0 22.9a46.45 46.45 0 11-46.5 46.5 46.54 46.54 0 0146.5-46.5zm-390.8 9a38.18 38.18 0 0133.7 20.2l-18.9-7.6v.1a30.21 30.21 0 00-22.6 56v.1l16.1 6.4a36.8 36.8 0 01-8.2.9 38.05 38.05 0 01-.1-76.1zm272.8 112.2a38.1 38.1 0 11-33.7 55.9c6.3 2.5 12.5 5 18.8 7.6a30.27 30.27 0 1022.5-56.2l-15.9-6.4a46.83 46.83 0 018.3-.9z"}}]})(props);
	};
	module.exports.IoLogoStencil = function IoLogoStencil (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M188.8 334.07h197.33L279.47 448H83.2zM512 199H106.61L0 313h405.39zM232.2 64h196.6L322.62 177.93H125.87z"}}]})(props);
	};
	module.exports.IoLogoTableau = function IoLogoTableau (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M242.69 340.3h26.62v-72.6h67v-25.82h-67v-72.6h-26.62v72.6h-66.15v25.82h66.15zM119.26 445.18h22.59v-64.54h59.7v-20.17h-59.7v-65.34h-22.59v65.34h-59.7v20.17h59.7zM370.15 212h22.59v-64.5h60.5v-19.37h-60.5V62.79h-22.59v65.34h-59.7v19.37h59.7zM246.72 496h19.36v-46h41.15v-16.92h-41.15v-46h-19.36v46h-40.33V450h40.33zM120.07 212h21v-65.31h60.51v-18.56H141V62.79h-21v65.34H59.56v18.56h60.51zm315.65 96.84h19.36v-45.18H496v-17.74h-40.92v-45.18h-19.36v45.18h-40.33v17.74h40.33z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M370.15 445.18h22.59v-64.54h60.5v-20.17h-60.5v-65.34h-22.59v65.34h-59.7v20.17h59.7z"}},{"tag":"path","attr":{"d":"M307 74.08V60.37h-40.34V16h-14.52v44.37h-40.33v13.71h40.33v44.37h14.52V74.08zM56.11 305.61h14.52v-44.37H111v-13.71H70.63V204H56.11v43.56H16v14.52l40.11-.08z"}}]})(props);
	};
	module.exports.IoLogoTiktok = function IoLogoTiktok (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M412.19 118.66a109.27 109.27 0 01-9.45-5.5 132.87 132.87 0 01-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14 23.9 350 16 350.13 16h-82.44v318.78c0 4.28 0 8.51-.18 12.69 0 .52-.05 1-.08 1.56 0 .23 0 .47-.05.71v.18a70 70 0 01-35.22 55.56 68.8 68.8 0 01-34.11 9c-38.41 0-69.54-31.32-69.54-70s31.13-70 69.54-70a68.9 68.9 0 0121.41 3.39l.1-83.94a153.14 153.14 0 00-118 34.52 161.79 161.79 0 00-35.3 43.53c-3.48 6-16.61 30.11-18.2 69.24-1 22.21 5.67 45.22 8.85 54.73v.2c2 5.6 9.75 24.71 22.38 40.82A167.53 167.53 0 00115 470.66v-.2l.2.2c39.91 27.12 84.16 25.34 84.16 25.34 7.66-.31 33.32 0 62.46-13.81 32.32-15.31 50.72-38.12 50.72-38.12a158.46 158.46 0 0027.64-45.93c7.46-19.61 9.95-43.13 9.95-52.53V176.49c1 .6 14.32 9.41 14.32 9.41s19.19 12.3 49.13 20.31c21.48 5.7 50.42 6.9 50.42 6.9v-81.84c-10.14 1.1-30.73-2.1-51.81-12.61z"}}]})(props);
	};
	module.exports.IoLogoTumblr = function IoLogoTumblr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M390 32H120c-49.19 0-88 38.81-88 88v270c0 49.19 38.81 90 88 90h270c49.19 0 90-40.81 90-90V120c0-49.19-40.81-88-90-88zm-54 364h-52c-42.51 0-72-23.68-72-76v-80h-36v-48c42.51-11 57.95-48.32 60-80h44v72h52v56h-52l-.39 70.51c0 21.87 11 29.43 28.62 29.43L336 340z"}}]})(props);
	};
	module.exports.IoLogoTux = function IoLogoTux (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M443.66 405.05c-1.46-.79-2.85-1.54-4-2.2-6.47-3.83-13-10.52-11.85-17.83 2.42-15.94 2.89-23.47-.49-28.79a15.61 15.61 0 00-7.67-6.2v-.06c1.41-2.56 2.26-5.66 2.83-10.12 1.44-11-5-44-13.7-70.7-8.08-24.68-29.24-50-44.7-68.56l-3.61-4.34c-23.88-28.93-24.34-38.19-26.55-82.67-.32-6.47-.69-13.8-1.17-22C329.87 41.43 304 16 256 16c-25.2 0-44.62 7.15-57.72 21.26C187.79 48.55 182 64 182 80.78c0 29.52 2 53 2.15 54.29 1.4 35.7 1 41.22-8.31 57.55-2.23 3.93-8.38 10.87-14.89 18.21-8.48 9.57-18.09 20.41-23.36 29.22-3.77 6.31-5.88 12.63-8.11 19.33-3.4 10.21-7.26 21.78-18.15 36.57-12.57 17.07-15.52 29.61-11 47.45-4.94 6.45-4.83 14.37-4.75 20.23a25.84 25.84 0 01-.3 6.09c-2.29 7.59-12.42 9.4-22 10.18-1.58.12-3.1.21-4.55.29-7.26.39-13.53.74-17.13 6.3-3.47 5.36-1.12 13.8 2.14 25.48.72 2.58 1.46 5.25 2.19 8.06 1.83 7-.16 10.48-2.68 14.84-2.44 4.21-5.21 9-5.21 17.55 0 14.67 20 18 43.05 21.94 7.36 1.24 15 2.53 22.63 4.24a225.58 225.58 0 0134.08 10.68c9.72 3.73 17.4 6.68 26.43 6.68 16.18 0 28.25-9.77 39.92-19.21l2.15-1.75c5.53-4.49 21.5-4 34.34-3.64 3.46.1 6.73.2 9.65.2h6.22c13.48-.08 31.94-.18 42.23 2.5 3.75 1 6.2 3.72 9.29 7.19 5.87 6.56 13.17 14.75 33.39 14.75 19.39 0 29.55-8.71 41.32-18.8 7.16-6.13 14.56-12.48 25.07-17.86 3.92-2 7.62-3.87 11.08-5.61 22.64-11.38 35.11-17.65 35.11-27.82 0-9.91-12.24-16.5-20.34-20.86zM211.11 88.38a13.91 13.91 0 0112.47 9c1.95 5.55 1.81 10.42.21 12.94 0 0-.22-1-.36-1.44a14.85 14.85 0 00-6.44-8.59 11.35 11.35 0 00-8.94-1.47c-4.26 1.13-8.41 5-8.91 18.79-5.16-10.47-2.31-18 .92-23 2.31-3.73 7.47-6.33 11.05-6.23zm-17.5 375C192 479.24 175.2 479 170.09 478.59c-9.81-.82-21.66-4.69-33.13-8.43-4.52-1.47-9.19-3-13.73-4.34-13.2-3.89-30.12-6.74-43.72-9-3.22-.55-6.27-1.06-9.05-1.55s-4.61-1.27-5.2-2.3c-1-1.65.38-5.25 1.93-9.41C69.27 438 72.11 430.34 72 421c0-3.91-1.47-8.3-2.84-12.56-1.62-5-3.28-10.17-1.93-12.62 1.23-2.23 6.75-2.49 11.6-2.49h2.26c3.55 0 6.62.06 8.75-.53 6.51-1.81 14.86-6.92 17.81-13.88.9-2.17 1.37-6.94 2-14 .37-4.12.74-8.37 1.22-10.58a3.55 3.55 0 012.11-2.55c1.65-.77 6.78-1.91 18.63 4.08 11.18 5.65 22.88 25.84 34.2 45.37 3.56 6.14 6.92 11.94 10.3 17.36 14.04 22.54 18.83 31.6 17.5 44.8zm128.84-31.56a68.74 68.74 0 01-4.55 10.9.58.58 0 01-1.08-.42 56.61 56.61 0 002.11-18.43c-.25-4.73-.4-7.59-2.66-8.51s-4.26.83-9.45 5.54c-1.1 1-2.36 2.14-3.78 3.4-10.8 9.47-26.88 20.68-55.61 23.37-16.84 1.59-27.59-4.63-30.92-8.14a2.16 2.16 0 00-3.07-.08 2.23 2.23 0 00-.51 2.29c2.12 6.84 1.2 12.26-.49 16.19-.95 2.2-1.85 2.05-2-.34-.25-4.64-1-9.88-3-14.19-3.11-6.94-7-14.34-8.89-17.88v-.05c3.24-1.49 8.86-4.83 11.37-10.88s4.48-18-9.82-31.74c-6.28-6.05-22.1-17.16-36.06-27-10.9-7.65-22.17-15.56-23.65-17.51-4.49-5.89-6.37-9.3-6.94-19.65.07-2.3.13-4.59.19-6.89l.27-2.49a.58.58 0 011.15 0 63.07 63.07 0 002 9.72c1.08 3.73 2.4 7.58 3.62 9.18 3.19 4.22 7.56 7.39 11.67 8.49a5.48 5.48 0 005-.72c2.93-2.33 2.65-7.6 2.19-16.34-.47-9-1.11-21.34 1.85-34.55 5.62-25 10.91-32.51 17.61-42 .86-1.22 1.75-2.47 2.65-3.79 1.44-2.08 3-4.1 4.67-6.23 7.47-9.61 15.93-20.49 13.92-40.95-.51-5.19-.76-8.83-.86-11.39a1 1 0 011.88-.59l.49.77 1.21 2c4.86 8 13.64 22.57 25.1 22.57a13.62 13.62 0 002.36-.21c23.39-3.93 51.9-30.25 52.17-30.51 3.12-3 2.84-6.14 1.64-7.91a5.18 5.18 0 00-6.45-1.72c-3.29 1.4-7.14 3.15-11.22 5-13.82 6.27-37 16.75-42.25 14.34a23.11 23.11 0 01-6.32-5.13 1 1 0 011.14-1.65c5.59 2.29 9.55 1.45 14.2-.08l1-.34c9.37-3.09 14.2-4.77 30.76-12.08a97.55 97.55 0 0116.26-5.93c4-1 6.42-1.63 7.71-4.34a6.65 6.65 0 00-.5-7.13c-1.53-1.87-4.07-2.57-7-1.9-3.22.75-4.7 3-6.41 4.49-2.4 2.05-5 4.16-17.19 8.65-27 10-34.58 10.61-45.21 3.43-9.84-6.69-15.15-13.23-15.15-16 0-2.13 5.45-5.7 8.71-7.84 1.33-.87 2.59-1.69 3.62-2.46 4.34-3.22 13-11.39 13.38-11.73 5.4-5.41 17.91-2.18 25 2.58a2.23 2.23 0 001.72.41 2.14 2.14 0 001.68-2.58c-4.2-17.46-.13-27.34 4-32.55a22.58 22.58 0 0117.48-8.48c12.81 0 21.76 10 21.76 24.42 0 11-2.82 16.79-5.48 20.3a1.73 1.73 0 01-2.58.18 1.78 1.78 0 01-.24-2.2A24.61 24.61 0 00290 114a16.58 16.58 0 00-16.84-16.67c-3.94 0-13.48 1.5-16.77 15.44a29.81 29.81 0 00-.34 11.07l.08.71c.9 7.38 15.3 12.51 27.23 15.51 11.36 2.85 13 6.22 8.84 19.63s3.11 26.23 5.7 29.57a78.3 78.3 0 018.31 12.47 93.8 93.8 0 016.62 16.48c2.17 6.79 4.05 12.65 10.63 21.22 11.07 14.4 17.66 48.64 15 78-.21 2.41-.53 4.29-.77 5.67-.43 2.53-.72 4.2.66 5.38s3.16.7 7.26-.63l3.43-1.09a109.33 109.33 0 0112.58-2.8 2.15 2.15 0 001.59-1.16c3.43-6.91 3.85-15.22 4-22.47q0-1.31.06-2.79c.19-7.77.45-18.93-2.95-32a1 1 0 011.93-.64 93 93 0 016.66 25.55c2.55 22.58-1.9 32.09-1.94 32.17a1.61 1.61 0 00.95 2.25 17.12 17.12 0 016.95 4.67c1.46 1.66.93 2.4-1.14 1.62a36.26 36.26 0 00-12.77-2.29c-10.4 0-18.09 4.95-21.51 9.19-3.19 3.94-3.7 7.67-3.83 11.27l-.06.05c-7.48-.75-12.94 1.21-17.47 6.21l-.08.09c-6.26 7.75-4 24.63-1.29 38.48 1.28 6.45 5.59 25.52 1.73 37.68zm96.1 10.07c-15.71 6.71-25.43 14.51-34 21.39-5.65 4.53-11 8.81-17.28 12.14-10.12 5.34-24.91 6.53-33.27-7.7-2.37-4-.71-9.86 1.58-17.95 3.05-10.75 7.23-25.46 3.71-44.65-.94-5.12-1.77-9.51-2.49-13.31C334 377 332.9 371.43 334 367c.63-2.45 3.43-3 5.87-3a20.83 20.83 0 012.63.19 29.51 29.51 0 007 12.1c5.7 5.86 13.63 8.83 23.56 8.85 2.1.17 25.94 1.55 36.54-22.4 1.46.18 3.65.7 4.3 2.3 1.28 3.19-.27 8.91-1.52 13.5-.9 3.31-1.68 6.16-1.63 8.37.31 16 11 22.78 25.83 32.16 1.79 1.13 3.66 2.31 5.55 3.54S445 425 445 426c-.52 4.79-20 13.16-26.45 15.91z"}}]})(props);
	};
	module.exports.IoLogoTwitch = function IoLogoTwitch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 32l-32 80v304h96v64h64l64-64h80l112-112V32zm336 256l-64 64h-96l-64 64v-64h-80V80h304z"}},{"tag":"path","attr":{"d":"M320 143h48v129h-48zm-112 0h48v129h-48z"}}]})(props);
	};
	module.exports.IoLogoTwitter = function IoLogoTwitter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 109.5a201.8 201.8 0 01-56.55 15.3 97.51 97.51 0 0043.33-53.6 197.74 197.74 0 01-62.56 23.5A99.14 99.14 0 00348.31 64c-54.42 0-98.46 43.4-98.46 96.9a93.21 93.21 0 002.54 22.1 280.7 280.7 0 01-203-101.3A95.69 95.69 0 0036 130.4c0 33.6 17.53 63.3 44 80.7A97.5 97.5 0 0135.22 199v1.2c0 47 34 86.1 79 95a100.76 100.76 0 01-25.94 3.4 94.38 94.38 0 01-18.51-1.8c12.51 38.5 48.92 66.5 92.05 67.3A199.59 199.59 0 0139.5 405.6a203 203 0 01-23.5-1.4A278.68 278.68 0 00166.74 448c181.36 0 280.44-147.7 280.44-275.8 0-4.2-.11-8.4-.31-12.5A198.48 198.48 0 00496 109.5z"}}]})(props);
	};
	module.exports.IoLogoUsd = function IoLogoUsd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M240 480v-36.42C160.53 439 112.25 398.06 112 336h72c1.77 26.34 23.86 46.45 56 50v-98l-26.77-7c-61-14.18-93.64-49.39-93.64-102.08C119.59 116.81 164.08 76.08 240 70V32h32v38c77.39 6.3 119 47.74 120 106h-72c-.76-24.06-15.83-43.39-48-46v92l30.82 7.28C367.61 243.46 400 277 400 332c0 64.34-43.74 105.88-128 111.32V480zm0-264v-86c-27.59 1.52-47.27 18.47-47.27 42.53 0 22.3 16.39 36.88 47.27 43.47zm32 78v92c38.15-1.54 56.38-18.92 56.38-45.77 0-24.58-18.23-41.13-56.38-46.23z"}}]})(props);
	};
	module.exports.IoLogoVenmo = function IoLogoVenmo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M444.17 32H70.28C49.85 32 32 46.7 32 66.89V441.6c0 20.31 17.85 38.4 38.28 38.4h373.78c20.54 0 35.94-18.2 35.94-38.39V66.89C480.12 46.7 464.6 32 444.17 32zM278 387H174.32l-41.57-248.56 90.75-8.62 22 176.87c20.53-33.45 45.88-86 45.88-121.87 0-19.62-3.36-33-8.61-44l82.63-16.72c9.56 15.78 13.86 32 13.86 52.57-.01 65.5-55.92 150.59-101.26 210.33z"}}]})(props);
	};
	module.exports.IoLogoVercel = function IoLogoVercel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M256 48l240 416H16z"}}]})(props);
	};
	module.exports.IoLogoVimeo = function IoLogoVimeo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476.9 114c-5-23.39-17.51-38.78-40.61-46.27s-64.92-4.5-94.12 16.79c-26.79 19.51-46.26 54.42-54 78.28a4 4 0 005.13 5c10.77-3.8 21.72-7.1 34-6.45 15 .8 24.51 12 24.91 25.29.3 9.79-.2 18.69-3.6 27.68-10.74 28.68-27.61 56.46-47.55 80.75a72.49 72.49 0 01-10 9.89c-10.21 8.29-18.81 6.1-25.41-5.2-5.4-9.29-9-18.88-12.2-29.08-12.4-39.67-16.81-80.84-23.81-121.52-3.3-19.48-7-39.77-18-56.86-11.6-17.79-28.61-24.58-50-22-14.7 1.8-36.91 17.49-47.81 26.39 0 0-56 46.87-81.82 71.35l21.2 27s17.91-12.49 27.51-18.29c5.7-3.39 12.4-4.09 17.2.2 4.51 3.9 9.61 9 12.31 14.1 5.7 10.69 11.2 21.88 14.7 33.37 13.2 44.27 25.51 88.64 37.81 133.22 6.3 22.78 13.9 44.17 28 63.55 19.31 26.59 39.61 32.68 70.92 21.49 25.41-9.09 46.61-26.18 66-43.87 33.11-30.18 59.12-65.36 85.52-101.14 20.41-27.67 37.31-55.67 51.41-86.95C478.5 179.74 484 147.26 476.9 114z"}}]})(props);
	};
	module.exports.IoLogoVk = function IoLogoVk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M484.7 132c3.56-11.28 0-19.48-15.75-19.48h-52.37c-13.21 0-19.31 7.18-22.87 14.86 0 0-26.94 65.6-64.56 108.13-12.2 12.3-17.79 16.4-24.4 16.4-3.56 0-8.14-4.1-8.14-15.37V131.47c0-13.32-4.06-19.47-15.25-19.47H199c-8.14 0-13.22 6.15-13.22 12.3 0 12.81 18.81 15.89 20.84 51.76V254c0 16.91-3 20-9.66 20-17.79 0-61-66.11-86.92-141.44C105 117.64 99.88 112 86.66 112H33.79C18.54 112 16 119.17 16 126.86c0 13.84 17.79 83.53 82.86 175.77 43.21 63 104.72 96.86 160.13 96.86 33.56 0 37.62-7.69 37.62-20.5v-47.66c0-15.37 3.05-17.93 13.73-17.93 7.62 0 21.35 4.09 52.36 34.33C398.28 383.6 404.38 400 424.21 400h52.36c15.25 0 22.37-7.69 18.3-22.55-4.57-14.86-21.86-36.38-44.23-62-12.2-14.34-30.5-30.23-36.09-37.92-7.62-10.25-5.59-14.35 0-23.57-.51 0 63.55-91.22 70.15-122"}}]})(props);
	};
	module.exports.IoLogoVue = function IoLogoVue (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 144.03l-55.49-96.11h-79.43L256 281.61 390.92 47.92h-79.43L256 144.03z"}},{"tag":"path","attr":{"d":"M409.4 47.92L256 313.61 102.6 47.92H15.74L256 464.08 496.26 47.92H409.4z"}}]})(props);
	};
	module.exports.IoLogoWebComponent = function IoLogoWebComponent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M179.9 388l-76.16-132 76.16 132zm0 0h152.21l76.15-132-76.15-132H179.9l-76.16 132 76.16 132zm-76.16-132l76.16-132-76.16 132z"}},{"tag":"path","attr":{"d":"M496 256L376 48H239.74l-43.84 76h136.21l76.15 132-76.15 132H195.9l43.84 76H376l120-208z"}},{"tag":"path","attr":{"d":"M179.9 388l-76.16-132 76.16-132 43.84-76H136L16 256l120 208h87.74l-43.84-76z"}}]})(props);
	};
	module.exports.IoLogoWechat = function IoLogoWechat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408.67 298.53a21 21 0 1120.9-21 20.85 20.85 0 01-20.9 21m-102.17 0a21 21 0 1120.9-21 20.84 20.84 0 01-20.9 21m152.09 118.86C491.1 394.08 512 359.13 512 319.51c0-71.08-68.5-129.35-154.41-129.35s-154.42 58.27-154.42 129.35 68.5 129.34 154.42 129.34c17.41 0 34.83-2.33 49.92-7 2.49-.86 3.48-1.17 4.64-1.17a16.67 16.67 0 018.13 2.34L454 462.83a11.62 11.62 0 003.48 1.17 5 5 0 004.65-4.66 14.27 14.27 0 00-.77-3.86c-.41-1.46-5-16-7.36-25.27a18.94 18.94 0 01-.33-3.47 11.4 11.4 0 015-9.35"}},{"tag":"path","attr":{"d":"M246.13 178.51a24.47 24.47 0 010-48.94c12.77 0 24.38 11.65 24.38 24.47 1.16 12.82-10.45 24.47-24.38 24.47m-123.06 0A24.47 24.47 0 11147.45 154a24.57 24.57 0 01-24.38 24.47M184.6 48C82.43 48 0 116.75 0 203c0 46.61 24.38 88.56 63.85 116.53C67.34 321.84 68 327 68 329a11.38 11.38 0 01-.66 4.49C63.85 345.14 59.4 364 59.21 365s-1.16 3.5-1.16 4.66a5.49 5.49 0 005.8 5.83 7.15 7.15 0 003.49-1.17L108 351c3.49-2.33 5.81-2.33 9.29-2.33a16.33 16.33 0 015.81 1.16c18.57 5.83 39.47 8.16 60.37 8.16h10.45a133.24 133.24 0 01-5.81-38.45c0-78.08 75.47-141 168.35-141h10.45C354.1 105.1 277.48 48 184.6 48"}}]})(props);
	};
	module.exports.IoLogoWhatsapp = function IoLogoWhatsapp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M414.73 97.1A222.14 222.14 0 00256.94 32C134 32 33.92 131.58 33.87 254a220.61 220.61 0 0029.78 111L32 480l118.25-30.87a223.63 223.63 0 00106.6 27h.09c122.93 0 223-99.59 223.06-222A220.18 220.18 0 00414.73 97.1zM256.94 438.66h-.08a185.75 185.75 0 01-94.36-25.72l-6.77-4-70.17 18.32 18.73-68.09-4.41-7A183.46 183.46 0 0171.53 254c0-101.73 83.21-184.5 185.48-184.5a185 185 0 01185.33 184.64c-.04 101.74-83.21 184.52-185.4 184.52zm101.69-138.19c-5.57-2.78-33-16.2-38.08-18.05s-8.83-2.78-12.54 2.78-14.4 18-17.65 21.75-6.5 4.16-12.07 1.38-23.54-8.63-44.83-27.53c-16.57-14.71-27.75-32.87-31-38.42s-.35-8.56 2.44-11.32c2.51-2.49 5.57-6.48 8.36-9.72s3.72-5.56 5.57-9.26.93-6.94-.46-9.71-12.54-30.08-17.18-41.19c-4.53-10.82-9.12-9.35-12.54-9.52-3.25-.16-7-.2-10.69-.2a20.53 20.53 0 00-14.86 6.94c-5.11 5.56-19.51 19-19.51 46.28s20 53.68 22.76 57.38 39.3 59.73 95.21 83.76a323.11 323.11 0 0031.78 11.68c13.35 4.22 25.5 3.63 35.1 2.2 10.71-1.59 33-13.42 37.63-26.38s4.64-24.06 3.25-26.37-5.11-3.71-10.69-6.48z"}}]})(props);
	};
	module.exports.IoLogoWindows = function IoLogoWindows (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 265H232v179l248 36V265zm-264 0H32v150l184 26.7V265zM480 32L232 67.4V249h248V32zM216 69.7L32 96v153h184V69.7z"}}]})(props);
	};
	module.exports.IoLogoWordpress = function IoLogoWordpress (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M259 271.3L226.2 367h-.1l-25.4 73.1c1.8.5 3.5.9 5.3 1.4h.3a192.51 192.51 0 0049.5 6.5 157 157 0 0024.9-1.8 184.3 184.3 0 0032.5-7.1c2.6-.8 5.2-1.7 7.8-2.6-2.8-6-8.8-19.3-9.1-19.9zM80.8 180.5C70.8 203.1 64 230.9 64 256c0 6.3.3 12.6.9 18.8 6.9 71.2 52.9 131 116.1 157.9 2.6 1.1 5.3 2.2 8 3.2L96 180.6c-8-.3-9.5.2-15.2-.1z"}},{"tag":"path","attr":{"d":"M430.2 175.4a188 188 0 00-15.1-26.6c-1.6-2.4-3.4-4.8-5.1-7.2A193 193 0 00325.1 77a189.2 189.2 0 00-69.2-13 191.51 191.51 0 00-149.4 71.7A196 196 0 0089 161.3c14.2.1 31.8.1 33.8.1 18.1 0 46-2.2 46-2.2 9.4-.6 10.4 13.1 1.1 14.2 0 0-9.4 1.1-19.8 1.6L213 362l37.8-113.3-26.8-73.6c-9.4-.5-18.1-1.6-18.1-1.6-9.4-.5-8.2-14.8 1-14.2 0 0 28.5 2.2 45.5 2.2 18.1 0 46-2.2 46-2.2 9.3-.6 10.5 13.1 1.1 14.2 0 0-9.3 1.1-19.7 1.6l62.3 185.6 17.3-57.6c8.7-22.4 13.1-40.9 13.1-55.7 0-21.3-7.7-36.1-14.3-47.6-8.7-14.3-16.9-26.3-16.9-40.4 0-15.9 12-30.7 29-30.7h2.2c26.2-.7 34.8 25.3 35.9 43v.6c.4 7.2.1 12.5.1 18.8 0 17.4-3.3 37.1-13.1 61.8l-39 112.8-22.3 65.7c1.8-.8 3.5-1.6 5.3-2.5 56.7-27.4 98-82 106.7-146.7a172.07 172.07 0 001.9-26 191.11 191.11 0 00-17.8-80.8z"}},{"tag":"path","attr":{"d":"M256 48a208.06 208.06 0 0181 399.66A208.06 208.06 0 01175 64.34 206.7 206.7 0 01256 48m0-16C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32z"}}]})(props);
	};
	module.exports.IoLogoXbox = function IoLogoXbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M126.8 248.3c39.7-58.6 77.9-92.8 77.9-92.8s-42.1-48.9-92.8-67.4l-3.3-.8A224.13 224.13 0 0077.2 391c0-4.4.6-70.3 49.6-142.7zM480 256a223.71 223.71 0 00-76.6-168.7l-3.2.9c-50.7 18.5-92.9 67.4-92.9 67.4s38.2 34.2 77.9 92.8c49 72.4 49.6 138.3 49.5 142.7A222.8 222.8 0 00480 256zM201.2 80.9c29.3 13.1 54.6 34.6 54.6 34.6s25.5-21.4 54.8-34.6c36.8-16.5 64.9-11.3 72.3-9.5a224.06 224.06 0 00-253.8 0c7.2-1.8 35.2-7.1 72.1 9.5zm157.5 212C312.4 236 255.8 199 255.8 199s-56.3 37-102.7 93.9c-39.8 48.9-54.6 84.8-62.6 107.8l-1.3 4.8a224 224 0 00333.6 0l-1.4-4.8c-8-23-22.9-58.9-62.7-107.8z"}}]})(props);
	};
	module.exports.IoLogoXing = function IoLogoXing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M313.8 303.9L469 32H365L209.4 303.8a1.35 1.35 0 000 1.7l98.9 173.8c.4.7.8.7 1.6.7H413l-99.3-174.7a1.74 1.74 0 01.1-1.4zm-91.9-87.7L163 113a2 2 0 00-2-1H65l58.9 104.4a1.13 1.13 0 01.1.8L43 352h96.8a1.54 1.54 0 001.6-.9l80.5-133.7a2.44 2.44 0 000-1.2z"}}]})(props);
	};
	module.exports.IoLogoYahoo = function IoLogoYahoo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M410.32 37.13c-13.56 0-27-.93-39.12-5.13L256 218.67 140.8 32c-12.12 4.2-24.84 5.13-38.4 5.13-13.32 0-26.52-1.05-38.4-5.13l153.6 248.15V480c12-4.08 25-5.13 38.4-5.13s26.4 1.05 38.4 5.13V280.5L448 32c-11.88 4-24.36 5.13-37.68 5.13z"}}]})(props);
	};
	module.exports.IoLogoYen = function IoLogoYen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 32h-80L256 253.13 144 32H64l112.37 208H128v48h73.56L216 319v17h-88v48h88v96h80v-96h88v-48h-88v-17l14.89-31H384v-48h-48.29z"}}]})(props);
	};
	module.exports.IoLogoYoutube = function IoLogoYoutube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M508.64 148.79c0-45-33.1-81.2-74-81.2C379.24 65 322.74 64 265 64h-18c-57.6 0-114.2 1-169.6 3.6C36.6 67.6 3.5 104 3.5 149 1 184.59-.06 220.19 0 255.79q-.15 53.4 3.4 106.9c0 45 33.1 81.5 73.9 81.5 58.2 2.7 117.9 3.9 178.6 3.8q91.2.3 178.6-3.8c40.9 0 74-36.5 74-81.5 2.4-35.7 3.5-71.3 3.4-107q.34-53.4-3.26-106.9zM207 353.89v-196.5l145 98.2z"}}]})(props);
	};
	module.exports.IoMagnetOutline = function IoMagnetOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M421.83 293.82A144 144 0 00218.18 90.17m135.76 135.77a48 48 0 00-67.88-67.88"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M192 464v-48m-101.82 5.82l33.94-33.94M48 320h48"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M286.06 158.06L172.92 271.19a32 32 0 01-45.25 0L105 248.57a32 32 0 010-45.26L218.18 90.17m203.65 203.65L308.69 407a32 32 0 01-45.26 0l-22.62-22.63a32 32 0 010-45.26l113.13-113.17M139.6 169.98l67.88 67.89m67.88 67.88l67.89 67.88"}}]})(props);
	};
	module.exports.IoMagnetSharp = function IoMagnetSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M191.98 463.58v-48M90.16 421.4l33.94-33.94m-76.12-67.88h48"}},{"tag":"path","attr":{"d":"M422.2 89.82a144 144 0 00-203.71-.07l-67.88 67.88 67.88 67.89 67.88-67.89a48 48 0 0168.46.59c18.3 18.92 17.48 49.24-1.14 67.86l-67.32 67.32 67.88 67.88 66.91-66.91c56.37-56.37 57.37-148.15 1.04-204.55zM82.718 225.517l45.255-45.254 67.883 67.882L150.6 293.4zM218.49 361.27l45.254-45.254 67.882 67.882-45.255 45.255z"}}]})(props);
	};
	module.exports.IoMagnet = function IoMagnet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M191.98 463.79v-48m-101.82 5.82l33.94-33.94m-76.12-67.88h48"}},{"tag":"path","attr":{"d":"M267.56 312.32l-31.11 31.11a16 16 0 000 22.63l45.26 45.25a16 16 0 0022.62 0l31.12-31.11a4 4 0 000-5.66l-62.23-62.22a4 4 0 00-5.66 0zM131.8 176.55l-31.11 31.12a16 16 0 000 22.62l45.25 45.26a16 16 0 0022.63 0l31.11-31.11a4 4 0 000-5.66l-62.22-62.23a4 4 0 00-5.66 0zm297.05-93.27a144 144 0 00-203.71-.06l-65.06 65.05a4 4 0 000 5.66l62.23 62.22a4 4 0 005.66 0l65-65.05a48 48 0 0168.46.59c18.3 18.92 17.47 49.24-1.14 67.85L295.85 284a4 4 0 000 5.66l62.22 62.23a4 4 0 005.66 0l64.08-64.08c56.37-56.34 57.37-148.13 1.04-204.53z"}}]})(props);
	};
	module.exports.IoMailOpenOutline = function IoMailOpenOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M441.6 171.61L266.87 85.37a24.57 24.57 0 00-21.74 0L70.4 171.61A40 40 0 0048 207.39V392c0 22.09 18.14 40 40.52 40h335c22.38 0 40.52-17.91 40.52-40V207.39a40 40 0 00-22.44-35.78z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M397.33 368L268.07 267.46a24 24 0 00-29.47 0L109.33 368m200-73l136-103m-384 0l139 105"}}]})(props);
	};
	module.exports.IoMailOpenSharp = function IoMailOpenSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M471.05 168.36L263.24 65.69a16.37 16.37 0 00-14.48 0L41 168.36a16 16 0 00-9 14.31V432a16.09 16.09 0 0016.19 16h415.62A16.09 16.09 0 00480 432V182.67a16 16 0 00-8.95-14.31zM256 97.89l173 85.44-175.7 86.78-173-85.44z"}}]})(props);
	};
	module.exports.IoMailOpen = function IoMailOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448.67 154.45L274.1 68.2a41.1 41.1 0 00-36.2 0L63.33 154.45A55.6 55.6 0 0032 204.53v184.61c0 30.88 25.42 56 56.67 56h334.66c31.25 0 56.67-25.12 56.67-56V204.53a55.6 55.6 0 00-31.33-50.08zM252.38 96.82a8.22 8.22 0 017.24 0L429 180.48l-172 85a8.22 8.22 0 01-7.24 0L80.35 181.81z"}}]})(props);
	};
	module.exports.IoMailOutline = function IoMailOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"320","x":"48","y":"96","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"40","ry":"40"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 160l144 112 144-112"}}]})(props);
	};
	module.exports.IoMailSharp = function IoMailSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 80H48a16 16 0 00-16 16v320a16 16 0 0016 16h416a16 16 0 0016-16V96a16 16 0 00-16-16zM265.82 284.63a16 16 0 01-19.64 0L89.55 162.81l19.64-25.26L256 251.73l146.81-114.18 19.64 25.26z"}}]})(props);
	};
	module.exports.IoMailUnreadOutline = function IoMailUnreadOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 96H88a40 40 0 00-40 40v240a40 40 0 0040 40h334.73a40 40 0 0040-40V239"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 160l144 112 87-65.67"}},{"tag":"circle","attr":{"cx":"431.95","cy":"128.05","r":"47.95"}},{"tag":"path","attr":{"d":"M432 192a63.95 63.95 0 1163.95-63.95A64 64 0 01432 192zm0-95.9a32 32 0 1031.95 32 32 32 0 00-31.95-32z"}}]})(props);
	};
	module.exports.IoMailUnreadSharp = function IoMailUnreadSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M374.09 101c-.11.23-.21.46-.31.7-.34.75-.67 1.5-1 2.26l-.36.9c-.27.71-.54 1.42-.79 2.14-.12.35-.24.7-.35 1-.23.68-.44 1.37-.64 2.07l-.33 1.15q-.27 1-.51 2c-.1.41-.2.82-.28 1.23-.15.67-.28 1.36-.4 2-.08.42-.16.84-.23 1.27-.11.69-.2 1.4-.29 2.1-.05.42-.11.83-.16 1.25-.08.77-.13 1.54-.19 2.31 0 .36-.06.72-.08 1.09-.06 1.13-.09 2.27-.09 3.41 0 1 0 2 .07 2.94v.62c.05.95.12 1.89.21 2.83l.06.46c.09.87.2 1.72.32 2.57 0 .15 0 .31.07.46.14.92.31 1.84.49 2.75l.12.59c.2.92.4 1.84.64 2.75.23.92.5 1.82.77 2.71.06.19.12.38.17.57.28.88.57 1.74.88 2.59.05.15.11.29.16.43.29.78.6 1.55.92 2.32.05.14.11.28.17.42.35.83.73 1.65 1.11 2.47l.27.53c.4.82.81 1.64 1.24 2.44a64.21 64.21 0 0029.56 27.63l.37.17c1.78.8 3.59 1.53 5.45 2.17l.95.32 1.5.47c.45.14.9.26 1.36.39l1.92.5c.57.14 1.14.27 1.72.39l1.15.24 1.83.32.93.16c.9.13 1.81.24 2.72.34l.77.07c.73.07 1.47.13 2.22.17l.85.05c1 0 1.94.07 2.93.07 1.15 0 2.29 0 3.43-.09l1.09-.09c.77 0 1.54-.11 2.3-.19.42 0 .83-.1 1.25-.16.7-.08 1.41-.17 2.1-.28l1.27-.23c.68-.12 1.36-.25 2-.39l1.24-.29c.67-.16 1.35-.32 2-.51.39-.1.78-.21 1.16-.33.69-.2 1.37-.41 2.05-.63l1.07-.36c.7-.24 1.4-.5 2.1-.77l.94-.37c.74-.3 1.47-.62 2.19-.95l.77-.34c.8-.37 1.58-.77 2.36-1.17.17-.09.35-.17.52-.27.91-.48 1.8-1 2.68-1.5l.12-.07a63.95 63.95 0 10-89.21-84.88l-.21.39c-.3 1.03-.72 1.86-1.11 2.69z"}},{"tag":"path","attr":{"d":"M371.51 202.43l-105.69 82.2a16 16 0 01-19.64 0L89.55 162.81l19.64-25.26L256 251.73l94.36-73.39A95.81 95.81 0 01349 80H48a16 16 0 00-16 16v320a16 16 0 0016 16h416a16 16 0 0016-16V211.13a95.75 95.75 0 01-108.49-8.7z"}}]})(props);
	};
	module.exports.IoMailUnread = function IoMailUnread (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 128.05A64 64 0 00389.62 80a64.52 64.52 0 00-12.71 15.3v.06c-.54.9-1.05 1.82-1.55 2.74l-.24.49c-.42.79-.81 1.59-1.19 2.4-.12.25-.23.5-.34.75-.33.73-.65 1.47-.95 2.22-.13.31-.25.62-.37.93-.27.7-.53 1.4-.78 2.11l-.36 1.06c-.22.68-.43 1.37-.63 2.06-.12.39-.23.77-.33 1.16-.19.67-.35 1.35-.51 2-.1.41-.2.82-.29 1.23-.14.68-.27 1.37-.39 2-.08.42-.16.84-.23 1.26-.11.7-.2 1.41-.29 2.12-.05.41-.11.82-.16 1.24-.08.77-.13 1.54-.19 2.32 0 .36-.06.72-.08 1.08-.06 1.14-.1 2.28-.1 3.44 0 1 0 2 .08 2.94v.64q.08 1.41.21 2.82l.06.48c.09.85.19 1.69.32 2.52 0 .17 0 .35.07.52.14.91.31 1.81.49 2.71 0 .22.09.43.13.65.18.86.38 1.72.6 2.57v.19c.23.89.48 1.76.75 2.63l.21.68c.27.85.55 1.68.85 2.51.06.18.13.36.2.54.27.71.55 1.42.84 2.12.08.21.16.41.25.61.34.79.69 1.58 1.06 2.36l.33.67c.35.7.7 1.4 1.07 2.09a64.34 64.34 0 0022.14 23.81 62.22 62.22 0 007.62 4.15l.39.18q2.66 1.2 5.43 2.16l.95.32 1.5.47c.45.14.9.26 1.36.39l1.92.5 1.73.4 1.15.23 1.83.33.94.15c.9.13 1.81.25 2.72.35l.77.07c.73.06 1.47.12 2.21.16l.86.05c1 0 1.94.08 2.92.08 1.16 0 2.3 0 3.44-.1l1.08-.08c.78-.06 1.55-.11 2.32-.19l1.25-.16c.7-.09 1.41-.18 2.11-.29l1.26-.23c.68-.12 1.37-.25 2-.39l1.23-.29c.68-.16 1.36-.32 2-.51.39-.1.77-.21 1.16-.33.69-.2 1.38-.41 2.06-.63l1.06-.36c.71-.25 1.41-.51 2.11-.78l.93-.37c.75-.3 1.49-.62 2.22-.95l.75-.34c.81-.38 1.61-.77 2.4-1.19l.49-.24c.92-.5 1.84-1 2.74-1.55h.06A64.52 64.52 0 00480 170.38a63.81 63.81 0 0016-42.33z"}},{"tag":"path","attr":{"d":"M371.38 202.53l-105.56 82.1a16 16 0 01-19.64 0l-144-112a16 16 0 1119.64-25.26L256 251.73l94.22-73.28A95.86 95.86 0 01348.81 80H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h336a56.06 56.06 0 0056-56V211.19a95.85 95.85 0 01-108.62-8.66z"}}]})(props);
	};
	module.exports.IoMail = function IoMail (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424 80H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h336a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56zm-14.18 92.63l-144 112a16 16 0 01-19.64 0l-144-112a16 16 0 1119.64-25.26L256 251.73l134.18-104.36a16 16 0 0119.64 25.26z"}}]})(props);
	};
	module.exports.IoMaleFemaleOutline = function IoMaleFemaleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"216","cy":"200","r":"136","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M216 352v128m56-64H160m272-304V32h-80m-16.72 96.72L432 32"}}]})(props);
	};
	module.exports.IoMaleFemaleSharp = function IoMaleFemaleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M330 16v44h42.89l-37.1 37.09A157.67 157.67 0 00216 42c-87.12 0-158 70.88-158 158 0 79.66 59.26 145.72 136 156.46V394h-50v44h50v58h44v-58h50v-44h-50v-37.54c76.74-10.74 136-76.8 136-156.46a157.23 157.23 0 00-14-64.93l44-44V134h44V16zM216 314a114 114 0 11114-114 114.13 114.13 0 01-114 114z"}}]})(props);
	};
	module.exports.IoMaleFemale = function IoMaleFemale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426 16h-74a22 22 0 000 44h20.89l-37.1 37.09A157.68 157.68 0 00216 42c-87.12 0-158 70.88-158 158 0 79.66 59.26 145.72 136 156.46V394h-28a22 22 0 000 44h28v36a22 22 0 0044 0v-36h28a22 22 0 000-44h-28v-37.54c76.74-10.74 136-76.8 136-156.46a157.15 157.15 0 00-14-64.92l44-44V112a22 22 0 0044 0V38a22 22 0 00-22-22zM216 314a114 114 0 11114-114 114.13 114.13 0 01-114 114z"}}]})(props);
	};
	module.exports.IoMaleOutline = function IoMaleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"216","cy":"296","r":"152","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M448 160V64h-96m-28 124L448 64"}}]})(props);
	};
	module.exports.IoMaleSharp = function IoMaleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M330 48v44h58.89l-60.39 60.39c-68.2-52.86-167-48-229.54 14.57C31.12 234.81 31.12 345.19 99 413a174.21 174.21 0 00246 0c62.57-62.58 67.43-161.34 14.57-229.54L420 123.11V182h44V48zm-16.08 333.92a130.13 130.13 0 01-183.84 0c-50.69-50.68-50.69-133.16 0-183.84s133.16-50.69 183.84 0 50.69 133.16 0 183.84z"}}]})(props);
	};
	module.exports.IoMale = function IoMale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M442 48h-90a22 22 0 000 44h36.89l-60.39 60.39c-68.19-52.86-167-48-229.54 14.57C31.12 234.81 31.12 345.19 99 413a174.21 174.21 0 00246 0c62.57-62.58 67.43-161.35 14.57-229.54L420 123.11V160a22 22 0 0044 0V70a22 22 0 00-22-22zM313.92 381.92a130.13 130.13 0 01-183.84 0c-50.69-50.68-50.69-133.16 0-183.84s133.16-50.69 183.84 0 50.69 133.16 0 183.84z"}}]})(props);
	};
	module.exports.IoManOutline = function IoManOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M208 208v264a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 336v136a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24V208"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M208 192v88a23.72 23.72 0 01-24 24h0a23.72 23.72 0 01-24-24v-88a48 48 0 0148-48h96a48 48 0 0148 48v88a23.72 23.72 0 01-24 24h0a23.72 23.72 0 01-24-24v-88"}},{"tag":"circle","attr":{"cx":"256","cy":"56","r":"40","fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoManSharp = function IoManSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"56","r":"56"}},{"tag":"path","attr":{"d":"M336 128H176a32 32 0 00-32 32v160h48V192h8v320h52V328h8v184h52V192h8v128h48V160a32 32 0 00-32-32z"}}]})(props);
	};
	module.exports.IoMan = function IoMan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"56","r":"56"}},{"tag":"path","attr":{"d":"M304 128h-96a64.19 64.19 0 00-64 64v107.52c0 10.85 8.43 20.08 19.27 20.47A20 20 0 00184 300v-99.73a8.18 8.18 0 017.47-8.25 8 8 0 018.53 8V489a23 23 0 0023 23 23 23 0 0023-23V346.34a10.24 10.24 0 019.33-10.34A10 10 0 01266 346v143a23 23 0 0023 23 23 23 0 0023-23V200.27a8.18 8.18 0 017.47-8.25 8 8 0 018.53 8v99.52c0 10.85 8.43 20.08 19.27 20.47A20 20 0 00368 300V192a64.19 64.19 0 00-64-64z"}}]})(props);
	};
	module.exports.IoMapOutline = function IoMapOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M313.27 124.64L198.73 51.36a32 32 0 00-29.28.35L56.51 127.49A16 16 0 0048 141.63v295.8a16 16 0 0023.49 14.14l97.82-63.79a32 32 0 0129.5-.24l111.86 73a32 32 0 0029.27-.11l115.43-75.94a16 16 0 008.63-14.2V74.57a16 16 0 00-23.49-14.14l-98 63.86a32 32 0 01-29.24.35zM328 128v336M184 48v336"}}]})(props);
	};
	module.exports.IoMapSharp = function IoMapSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M327.71 130.93L184 39 32 144v336l152.29-98.93L328 473l152-105V32zM312 421l-112-72V91l112 72z"}}]})(props);
	};
	module.exports.IoMap = function IoMap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48.17 113.34A32 32 0 0032 141.24V438a32 32 0 0047 28.37c.43-.23.85-.47 1.26-.74l84.14-55.05a8 8 0 003.63-6.72V46.45a8 8 0 00-12.51-6.63zm164.19-74.03A8 8 0 00200 46v357.56a8 8 0 003.63 6.72l96 62.42A8 8 0 00312 466V108.67a8 8 0 00-3.64-6.73zm252.17 7.16a31.64 31.64 0 00-31.5-.88 12.07 12.07 0 00-1.25.74l-84.15 55a8 8 0 00-3.63 6.72v357.46a8 8 0 0012.52 6.63l107.07-73.46a32 32 0 0016.41-28v-296a32.76 32.76 0 00-15.47-28.21z"}}]})(props);
	};
	module.exports.IoMedalOutline = function IoMedalOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"352","r":"112","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"352","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M147 323L41.84 159.32a32 32 0 01-1.7-31.61l31-62A32 32 0 0199.78 48h312.44a32 32 0 0128.62 17.69l31 62a32 32 0 01-1.7 31.61L365 323m6-179H37m391.74-91.4L305 250M140.55 144L207 250"}}]})(props);
	};
	module.exports.IoMedalSharp = function IoMedalSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 32L16 160h289.11l80.22-128H80z"}},{"tag":"path","attr":{"d":"M496 144L424 32 298 231.08a128 128 0 00-84 0L189.53 192H43.82l86.66 134.89a128 128 0 10251 0zM256 422a70 70 0 1170-70 70.08 70.08 0 01-70 70z"}},{"tag":"circle","attr":{"cx":"256","cy":"352","r":"32"}}]})(props);
	};
	module.exports.IoMedal = function IoMedal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"352","r":"32"}},{"tag":"path","attr":{"d":"M99.78 32a48 48 0 00-42.94 26.53l-31 62A48.26 48.26 0 0024.28 160h278.2a4 4 0 003.39-1.87l75.5-120A4 4 0 00378 32z"}},{"tag":"path","attr":{"d":"M486.17 120.56l-31-62a47.7 47.7 0 00-32.79-25.46L342.5 160 298 231.08a128 128 0 00-84 0l-23.32-37.2a4 4 0 00-3.39-1.88H51.14a4 4 0 00-3.36 6.16l82.7 128.73a128 128 0 10251 0L483.62 168a48.22 48.22 0 002.55-47.44zm-226 295.31a64 64 0 1159.69-59.69 64.08 64.08 0 01-59.68 59.69z"}}]})(props);
	};
	module.exports.IoMedicalOutline = function IoMedicalOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M429.93 174.27l-16.47-28.59a15.49 15.49 0 00-21.15-5.7l-98.39 57a4 4 0 01-6-3.5L288 80a16 16 0 00-16-16h-32a16 16 0 00-16 16l.07 113.57a4 4 0 01-6 3.5l-98.39-57a15.49 15.49 0 00-21.15 5.7l-16.46 28.6a15.42 15.42 0 005.69 21.1l98.49 57.08a4 4 0 010 6.9l-98.49 57.08a15.54 15.54 0 00-5.69 21.1l16.47 28.59a15.49 15.49 0 0021.15 5.7l98.39-57a4 4 0 016 3.5L224 432a16 16 0 0016 16h32a16 16 0 0016-16l-.07-113.67a4 4 0 016-3.5l98.39 57a15.49 15.49 0 0021.15-5.7l16.47-28.59a15.42 15.42 0 00-5.69-21.1l-98.49-57.08a4 4 0 010-6.9l98.49-57.08a15.51 15.51 0 005.68-21.11z"}}]})(props);
	};
	module.exports.IoMedicalSharp = function IoMedicalSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M351.9 256L460 193.6l-48-83.2-108 62.4V48h-96v124.8l-108-62.4-48 83.2L160.1 256 52 318.4l48 83.2 108-62.4V464h96V339.2l108 62.4 48-83.2L351.9 256z"}}]})(props);
	};
	module.exports.IoMedical = function IoMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 464h-32a32 32 0 01-32-32l.05-85.82a4 4 0 00-6-3.47l-74.34 43.06a31.48 31.48 0 01-43-11.52l-16.5-28.64-.06-.1a31.65 31.65 0 0111.56-42.8l74.61-43.25a4 4 0 000-6.92l-74.54-43.21a31.41 31.41 0 01-11.55-43l16.44-28.55a31.48 31.48 0 0119.27-14.74 31.14 31.14 0 0123.8 3.2l74.31 43a4 4 0 006-3.47L208 80a32 32 0 0132-32h32a32 32 0 0132 32v85.72a4 4 0 006 3.47l74.34-43.06a31.51 31.51 0 0143 11.52l16.49 28.64.06.09a31.52 31.52 0 01-11.64 42.86l-74.53 43.2a4 4 0 000 6.92l74.53 43.2a31.42 31.42 0 0111.56 43l-16.44 28.55a31.48 31.48 0 01-19.27 14.74 31.14 31.14 0 01-23.8-3.2l-74.31-43a4 4 0 00-6 3.46L304 432a32 32 0 01-32 32zm-93.56-197.48zm0-21zm155.1-.08zm0 0z"}}]})(props);
	};
	module.exports.IoMedkitOutline = function IoMedkitOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"448","height":"352","x":"32","y":"112","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M144 112V80a32 32 0 0132-32h160a32 32 0 0132 32v32m-112 96v160m80-80H176"}}]})(props);
	};
	module.exports.IoMedkitSharp = function IoMedkitSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M168 72h176v24H168z"}},{"tag":"path","attr":{"d":"M484 96H384V40a8 8 0 00-8-8H136a8 8 0 00-8 8v56H28a12 12 0 00-12 12v360a12 12 0 0012 12h456a12 12 0 0012-12V108a12 12 0 00-12-12zM168 72h176v24H168zm184 238h-74v74h-44v-74h-74v-44h74v-74h44v74h74z"}}]})(props);
	};
	module.exports.IoMedkit = function IoMedkit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M336 64H176a16 16 0 00-16 16v16h192V80a16 16 0 00-16-16z"}},{"tag":"path","attr":{"d":"M432 96h-48V80a48.05 48.05 0 00-48-48H176a48.05 48.05 0 00-48 48v16H80a64.07 64.07 0 00-64 64v256a64 64 0 0064 64h352a64 64 0 0064-64V160a64.07 64.07 0 00-64-64zm-96 208h-64v64a16 16 0 01-32 0v-64h-64a16 16 0 010-32h64v-64a16 16 0 0132 0v64h64a16 16 0 010 32zm16-208H160V80a16 16 0 0116-16h160a16 16 0 0116 16z"}}]})(props);
	};
	module.exports.IoMegaphoneOutline = function IoMegaphoneOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M407.94 52.22S321.3 160 240 160H80a16 16 0 00-16 16v96a16 16 0 0016 16h160c81.3 0 167.94 108.23 167.94 108.23 6.06 8 24.06 2.52 24.06-9.83V62c0-12.31-17-18.82-24.06-9.78zM64 256s-16-6-16-32 16-32 16-32m384 54s16-4.33 16-22-16-22-16-22m-192-42v128M112 160v128"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M144 288v168a8 8 0 008 8h53a16 16 0 0015.29-20.73C211.91 416.39 192 386.08 192 336h16a16 16 0 0016-16v-16a16 16 0 00-16-16h-16"}}]})(props);
	};
	module.exports.IoMegaphoneSharp = function IoMegaphoneSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 144v332a4 4 0 004 4h100.07a8 8 0 007.82-9.7L208.71 352H232a8 8 0 008-8V144zm324.18 42.55L448 185.5V36a4 4 0 00-4-4h-42.5a4 4 0 00-2.63 1L272 144v160l126.87 111a4 4 0 002.63 1H444a4 4 0 004-4V262.5l4.18-1.05C461.8 258.84 480 247.67 480 224s-18.2-34.84-27.82-37.45zM96 144H52a4 4 0 00-4 4v35.59a43 43 0 00-4.24 4.35C38.4 194.32 32 205.74 32 224c0 20.19 7.89 33.13 16 40.42V300a4 4 0 004 4h44z"}}]})(props);
	};
	module.exports.IoMegaphone = function IoMegaphone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 176v.66a17.38 17.38 0 01-4.2 11.23v.05C38.4 194.32 32 205.74 32 224c0 16.55 5.3 28.23 11.68 35.91A19 19 0 0148 272a32 32 0 0032 32h8a8 8 0 008-8V152a8 8 0 00-8-8h-8a32 32 0 00-32 32zm404.18 10.55l-.93-.17a4 4 0 01-3.25-3.93V62c0-12.64-8.39-24-20.89-28.32-11.92-4.11-24.34-.76-31.68 8.53a431.18 431.18 0 01-51.31 51.69c-23.63 20-46.24 34.25-67 42.31a8 8 0 00-5.15 7.47V299a16 16 0 009.69 14.69c19.34 8.29 40.24 21.83 62 40.28a433.74 433.74 0 0151.68 52.16 26.22 26.22 0 0021.1 9.87 33.07 33.07 0 0010.44-1.74C439.71 410 448 399.05 448 386.4V265.53a4 4 0 013.33-3.94l.85-.14C461.8 258.84 480 247.67 480 224s-18.2-34.84-27.82-37.45zM240 320V152a8 8 0 00-8-8h-96a8 8 0 00-8 8v304a24 24 0 0024 24h52.45a32.66 32.66 0 0025.93-12.45 31.65 31.65 0 005.21-29.05c-1.62-5.18-3.63-11-5.77-17.19-7.91-22.9-18.34-37.07-21.12-69.32A32 32 0 00240 320z"}}]})(props);
	};
	module.exports.IoMenuOutline = function IoMenuOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M80 160h352M80 256h352M80 352h352"}}]})(props);
	};
	module.exports.IoMenuSharp = function IoMenuSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 384h384v-42.67H64zm0-106.67h384v-42.66H64zM64 128v42.67h384V128z"}}]})(props);
	};
	module.exports.IoMenu = function IoMenu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"48","d":"M88 152h336M88 256h336M88 360h336"}}]})(props);
	};
	module.exports.IoMicCircleOutline = function IoMicCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M224 368h64m48-143.7v23.92c0 39.42-40.58 71.48-80 71.48h0c-39.42 0-80-32.06-80-71.48V224.3m80 95.7v48"}},{"tag":"rect","attr":{"width":"96","height":"160","x":"208","y":"128","rx":"48","ry":"48"}}]})(props);
	};
	module.exports.IoMicCircleSharp = function IoMicCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-48 128a48.14 48.14 0 0148-48 48.14 48.14 0 0148 48v64a48.14 48.14 0 01-48 48 48.14 48.14 0 01-48-48zm144 72.22c0 23.36-10.94 45.61-30.79 62.66A103.71 103.71 0 01272 334.26V352h32v32h-96v-32h32v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V208.3h32v39.92c0 25.66 28 55.48 64 55.48 29.6 0 64-24.23 64-55.48V208.3h32z"}}]})(props);
	};
	module.exports.IoMicCircle = function IoMicCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-48 128a48.14 48.14 0 0148-48 48.14 48.14 0 0148 48v64a48.14 48.14 0 01-48 48 48.14 48.14 0 01-48-48zm144 72.22c0 23.36-10.94 45.61-30.79 62.66A103.71 103.71 0 01272 334.26V352h16a16 16 0 010 32h-64a16 16 0 010-32h16v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V224.3a16 16 0 0132 0v23.92c0 25.66 28 55.48 64 55.48 29.6 0 64-24.23 64-55.48V224.3a16 16 0 1132 0z"}}]})(props);
	};
	module.exports.IoMicOffCircleOutline = function IoMicOffCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208zm0-384c-97 0-176 79-176 176s79 176 176 176 176-78.95 176-176S353.05 80 256 80z"}},{"tag":"path","attr":{"d":"M352 369a15.93 15.93 0 01-11.84-5.24l-192-210a16 16 0 0123.68-21.52l192 210A16 16 0 01352 369zm0-120.78v-23.8a16.3 16.3 0 00-13.64-16.24c-9.88-1.48-18.36 6.51-18.36 16.12v23.92a43.35 43.35 0 01-3.07 15.91 4 4 0 00.76 4.16l19.19 21.1a2 2 0 003.19-.3A77.12 77.12 0 00352 248.22zM304 240v-64a48.14 48.14 0 00-48-48 48.08 48.08 0 00-41 23.1 4 4 0 00.47 4.77l84.42 92.86a2 2 0 003.46-1A47.84 47.84 0 00304 240zm-57.43 45.2l-36.46-40.11a1 1 0 00-1.74.8 48.26 48.26 0 0037.25 41 1 1 0 00.95-1.69z"}},{"tag":"path","attr":{"d":"M287.55 352H272v-17.74a100.33 100.33 0 0012.53-3.06 2 2 0 00.89-3.26l-21.07-23.19a3.94 3.94 0 00-3.29-1.29c-1.69.15-3.39.24-5.06.24-36 0-64-29.82-64-55.48V224.4a16.26 16.26 0 00-15.61-16.4A15.91 15.91 0 00160 224v24.22c0 23.36 10.94 45.61 30.79 62.66A103.71 103.71 0 00240 334.26V352h-15.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00224 384h64a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"}}]})(props);
	};
	module.exports.IoMicOffCircleSharp = function IoMicOffCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm64 200.22V208h32v40.22a77.53 77.53 0 01-13.37 43.11L316 266.4a44.11 44.11 0 004-18.18zM256 128a48.14 48.14 0 0148 48v64a48.07 48.07 0 01-1.44 11.64l-89-97.92A48.13 48.13 0 01256 128zm48 256h-96v-32h32v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V208h32v40.22c0 25.66 28 55.48 64 55.48a56.91 56.91 0 007-.45l24.52 27a99.57 99.57 0 01-15.5 4V352h32zm-95.91-141.13l40.5 44.55a48.2 48.2 0 01-40.5-44.55zm136.07 124.89l-200.5-218.5 23.68-21.52 200.5 218.5z"}}]})(props);
	};
	module.exports.IoMicOffCircle = function IoMicOffCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 80a48.14 48.14 0 0148 48v64a47.84 47.84 0 01-.63 7.71 2 2 0 01-3.46 1l-84.42-92.86a4 4 0 01-.47-4.77A48.08 48.08 0 01256 128zm32 256h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01224 352h16v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V224a15.91 15.91 0 0116.39-16A16.26 16.26 0 01192 224.4v23.82c0 25.66 28 55.48 64 55.48 1.67 0 3.37-.09 5.06-.24a3.94 3.94 0 013.29 1.29l21.07 23.19a2 2 0 01-.89 3.26 100.33 100.33 0 01-12.53 3.06V352h15.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01288 384zm-77.89-138.91l36.46 40.11a1 1 0 01-.95 1.66 48.26 48.26 0 01-37.25-41 1 1 0 011.74-.77zm152.65 119.75a16 16 0 01-22.6-1.08l-192-210a16 16 0 0123.68-21.52l192 210a16 16 0 01-1.08 22.6zM352 248.22a77.12 77.12 0 01-11.93 40.87 2 2 0 01-3.19.3l-19.19-21.1a4 4 0 01-.76-4.16 43.35 43.35 0 003.07-15.91v-23.8a16.3 16.3 0 0113.64-16.24c9.88-1.48 18.36 6.51 18.36 16.12z"}}]})(props);
	};
	module.exports.IoMicOffOutline = function IoMicOffOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M432 400L96 64"}},{"tag":"path","attr":{"d":"M400 240v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 208v32a111.58 111.58 0 01-2.45 23.31 4.05 4.05 0 001.07 3.69l21.82 21.81a2 2 0 003.29-.72A143.27 143.27 0 00400 240zM256 352a112.36 112.36 0 01-112-112v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 208v32c0 74 56.1 135.12 128 143.11V432h-47.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00192 464h127.55c8.61 0 16-6.62 16.43-15.23A16 16 0 00320 432h-48v-48.89a143.08 143.08 0 0052-16.22 4 4 0 00.91-6.35L307 342.63a4 4 0 00-4.51-.78A110.78 110.78 0 01256 352zm0-272a47.18 47.18 0 0148 48v74.72a4 4 0 001.17 2.82L332.59 233a2 2 0 003.41-1.42V128.91C336 85 301 48.6 257.14 48a79.66 79.66 0 00-68.47 36.57 4 4 0 00.54 5l19.54 19.54a2 2 0 003.25-.63A47.44 47.44 0 01256 80z"}},{"tag":"path","attr":{"d":"M207.27 242.9L179.41 215a2 2 0 00-3.41 1.42V239a80.89 80.89 0 0023.45 56.9 78.55 78.55 0 0077.8 21.19 2 2 0 00.86-3.35l-24.91-24.91a4.08 4.08 0 00-2.42-1.15c-21.65-2.52-39.48-20.44-42.37-42.43a4 4 0 00-1.14-2.35z"}}]})(props);
	};
	module.exports.IoMicOffSharp = function IoMicOffSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M432 400L96 64"}},{"tag":"path","attr":{"d":"M368 192v48a111.74 111.74 0 01-2.93 25.45L390.65 291a143.07 143.07 0 009.35-51v-48zm-96 240v-48.89a143.11 143.11 0 0056.65-18.83L305 340.65A112.13 112.13 0 01144 240v-48h-32v48c0 74 56.1 135.12 128 143.11V432h-64v32h160v-32zm64-195.63V128c0-44.86-35.14-80-80-80a79.68 79.68 0 00-69 39.34"}},{"tag":"path","attr":{"d":"M176 211.63V239a80.89 80.89 0 0023.45 56.9 78.55 78.55 0 0081 20.21z"}}]})(props);
	};
	module.exports.IoMicOff = function IoMicOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M432 400L96 64"}},{"tag":"path","attr":{"d":"M400 240v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 208v32a111.68 111.68 0 01-2.68 24.38 2 2 0 00.53 1.84l22.59 22.59a2 2 0 003.29-.72A143.27 143.27 0 00400 240zM256 352a112.36 112.36 0 01-112-112v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 208v32c0 74 56.1 135.12 128 143.11V432h-47.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00192 464h127.55c8.61 0 16-6.62 16.43-15.23A16 16 0 00320 432h-48v-48.89a143.08 143.08 0 0052-16.22 4 4 0 00.91-6.35l-18.4-18.39a3 3 0 00-3.41-.58A111 111 0 01256 352zm1.14-304a79.66 79.66 0 00-68.47 36.57 4 4 0 00.54 5L332.59 233a2 2 0 003.41-1.42V128.91C336 85 301 48.6 257.14 48z"}},{"tag":"path","attr":{"d":"M179.41 215a2 2 0 00-3.41 1.42V239a80.89 80.89 0 0023.45 56.9 78.55 78.55 0 0077.8 21.19 2 2 0 00.86-3.35z"}}]})(props);
	};
	module.exports.IoMicOutline = function IoMicOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M192 448h128m64-240v32c0 70.4-57.6 128-128 128h0c-70.4 0-128-57.6-128-128v-32m128 160v80"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 64a63.68 63.68 0 00-64 64v111c0 35.2 29 65 64 65s64-29 64-65V128c0-36-28-64-64-64z"}}]})(props);
	};
	module.exports.IoMicSharp = function IoMicSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M192 448h128m64-240v32c0 70.4-57.6 128-128 128h0c-70.4 0-128-57.6-128-128v-32m128 160v80"}},{"tag":"path","attr":{"d":"M256 320a78.83 78.83 0 01-56.55-24.1A80.89 80.89 0 01176 239V128a79.69 79.69 0 0180-80c44.86 0 80 35.14 80 80v111c0 44.66-35.89 81-80 81z"}}]})(props);
	};
	module.exports.IoMic = function IoMic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M192 448h128m64-240v32c0 70.4-57.6 128-128 128h0c-70.4 0-128-57.6-128-128v-32m128 160v80"}},{"tag":"path","attr":{"d":"M256 320a78.83 78.83 0 01-56.55-24.1A80.89 80.89 0 01176 239V128a79.69 79.69 0 0180-80c44.86 0 80 35.14 80 80v111c0 44.66-35.89 81-80 81z"}}]})(props);
	};
	module.exports.IoMoonOutline = function IoMoonOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 136c0-30.62 4.51-61.61 16-88C99.57 81.27 48 159.32 48 248c0 119.29 96.71 216 216 216 88.68 0 166.73-51.57 200-128-26.39 11.49-57.38 16-88 16-119.29 0-216-96.71-216-216z"}}]})(props);
	};
	module.exports.IoMoonSharp = function IoMoonSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M152.62 126.77c0-33 4.85-66.35 17.23-94.77C87.54 67.83 32 151.89 32 247.38 32 375.85 136.15 480 264.62 480c95.49 0 179.55-55.54 215.38-137.85-28.42 12.38-61.8 17.23-94.77 17.23-128.47 0-232.61-104.14-232.61-232.61z"}}]})(props);
	};
	module.exports.IoMoon = function IoMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M264 480A232 232 0 0132 248c0-94 54-178.28 137.61-214.67a16 16 0 0121.06 21.06C181.07 76.43 176 104.66 176 136c0 110.28 89.72 200 200 200 31.34 0 59.57-5.07 81.61-14.67a16 16 0 0121.06 21.06C442.28 426 358 480 264 480z"}}]})(props);
	};
	module.exports.IoMoveOutline = function IoMoveOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 112l80-80 80 80m-80.02-80l.02 448m-80-80l80 80 80-80m64-224l80 80-80 80M112 176l-80 80 80 80m-80-80h448"}}]})(props);
	};
	module.exports.IoMoveSharp = function IoMoveSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M176 112l80-80 80 80m-80.02-80l.02 448m-80-80l80 80 80-80m64-224l80 80-80 80M112 176l-80 80 80 80m-80-80h448"}}]})(props);
	};
	module.exports.IoMove = function IoMove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 112l80-80 80 80m-80.02-80l.02 448m-80-80l80 80 80-80m64-224l80 80-80 80M112 176l-80 80 80 80m-80-80h448"}}]})(props);
	};
	module.exports.IoMusicalNoteOutline = function IoMusicalNoteOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M240 343.31V424a32.28 32.28 0 01-21.88 30.65l-21.47 7.23c-25.9 8.71-52.65-10.75-52.65-38.32h0A34.29 34.29 0 01167.25 391l50.87-17.12A32.29 32.29 0 00240 343.24V92a16.13 16.13 0 0112.06-15.66L360.49 48.2A6 6 0 01368 54v57.76a16.13 16.13 0 01-12.12 15.67l-91.64 23.13A32.25 32.25 0 00240 181.91v39.39"}}]})(props);
	};
	module.exports.IoMusicalNoteSharp = function IoMusicalNoteSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M381.55 32.05c-18.13 4.28-126.57 31.07-156 38.19a2 2 0 00-1.55 1.94V353.3a2 2 0 01-1.32 1.88L182 369.88c-29.82 10.66-54 18.94-54 59.06 0 32.47 23.53 47.18 37.95 50a81.77 81.77 0 0015 1.08c8.89 0 31-3.59 47.52-14.24C256 448 256 448 256 415.93V169.16a2 2 0 011.49-1.94l125-33a2 2 0 001.49-1.94V34a2 2 0 00-2.43-1.95z"}}]})(props);
	};
	module.exports.IoMusicalNote = function IoMusicalNote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M183.83 480a55.2 55.2 0 01-32.36-10.55A56.64 56.64 0 01128 423.58a50.26 50.26 0 0134.14-47.73L213 358.73a16.25 16.25 0 0011-15.49V92a32.1 32.1 0 0124.09-31.15l108.39-28.14A22 22 0 01384 54v57.75a32.09 32.09 0 01-24.2 31.19l-91.65 23.13A16.24 16.24 0 00256 181.91V424a48.22 48.22 0 01-32.78 45.81l-21.47 7.23a56 56 0 01-17.92 2.96z"}}]})(props);
	};
	module.exports.IoMusicalNotesOutline = function IoMusicalNotesOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M192 218v-6c0-14.84 10-27 24.24-30.59l174.59-46.68A20 20 0 01416 154v22"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M416 295.94v80c0 13.91-8.93 25.59-22 30l-22 8c-25.9 8.72-52-10.42-52-38h0a33.37 33.37 0 0123-32l51-18.15c13.07-4.4 22-15.94 22-29.85V58a10 10 0 00-12.6-9.61L204 102a16.48 16.48 0 00-12 16v226c0 13.91-8.93 25.6-22 30l-52 18c-13.88 4.68-22 17.22-22 32h0c0 27.58 26.52 46.55 52 38l22-8c13.07-4.4 22-16.08 22-30v-80"}}]})(props);
	};
	module.exports.IoMusicalNotesSharp = function IoMusicalNotesSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M429.46 32.07c-23.6 6.53-205.55 58.81-250.54 71.43a4 4 0 00-2.92 3.83v247a2 2 0 01-1.33 1.89l-27.85 9.55c-19 7.44-66.82 16.68-66.82 59.19 0 35.54 24.63 51.54 45.86 54.28a52.06 52.06 0 007.81.8c7.37 0 36.38-7.08 53.3-18.08C208 448.25 208 448 208 412V202c0-.9.62-.84 1.48-1.07l188-51.92a2 2 0 012.53 2v155.54a2 2 0 01-1.36 1.89c-8.9 3-19.23 6.5-26.48 9.12C341.39 328.68 304 335.65 304 376c0 38.51 28.26 54.58 46.3 55.83a87.37 87.37 0 0021.33-1c9-1.38 24.09-5.9 38.14-14.86C432 401.79 432 401.51 432 360V34a2 2 0 00-2.54-1.93z"}}]})(props);
	};
	module.exports.IoMusicalNotes = function IoMusicalNotes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M421.84 37.37a25.86 25.86 0 00-22.6-4.46L199.92 86.49A32.3 32.3 0 00176 118v226c0 6.74-4.36 12.56-11.11 14.83l-.12.05-52 18C92.88 383.53 80 402 80 423.91a55.54 55.54 0 0023.23 45.63A54.78 54.78 0 00135.34 480a55.82 55.82 0 0017.75-2.93l.38-.13 21.84-7.94A47.84 47.84 0 00208 423.91v-212c0-7.29 4.77-13.21 12.16-15.07l.21-.06L395 150.14a4 4 0 015 3.86v141.93c0 6.75-4.25 12.38-11.11 14.68l-.25.09-50.89 18.11A49.09 49.09 0 00304 375.92a55.67 55.67 0 0023.23 45.8 54.63 54.63 0 0049.88 7.35l.36-.12 21.84-7.95A47.83 47.83 0 00432 375.92V58a25.74 25.74 0 00-10.16-20.63z"}}]})(props);
	};
	module.exports.IoNavigateCircleOutline = function IoNavigateCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336.76 161l-186.53 82.35c-10.47 4.8-6.95 20.67 4.57 20.67H244a4 4 0 014 4v89.18c0 11.52 16 15 20.78 4.56L351 175.24A10.73 10.73 0 00336.76 161z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoNavigateCircleSharp = function IoNavigateCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48A208.23 208.23 0 0048 256c0 114.68 93.31 208 208 208a208.23 208.23 0 00208-208c0-114.69-93.31-208-208-208zm-8 361V264H103l259-114.11z"}}]})(props);
	};
	module.exports.IoNavigateCircle = function IoNavigateCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zM351 175.24l-82.24 186.52c-4.79 10.47-20.78 7-20.78-4.56V268a4 4 0 00-4-4H154.8c-11.52 0-15-15.87-4.57-20.67L336.76 161A10.73 10.73 0 01351 175.24z"}}]})(props);
	};
	module.exports.IoNavigateOutline = function IoNavigateOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M448 64L64 240.14h200a8 8 0 018 8V448z"}}]})(props);
	};
	module.exports.IoNavigateSharp = function IoNavigateSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 32L32 240h240v240L480 32z"}}]})(props);
	};
	module.exports.IoNavigate = function IoNavigate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 464a16 16 0 01-16-16.42V264.13a8 8 0 00-8-8H64.41a16.31 16.31 0 01-15.49-10.65 16 16 0 018.41-19.87l384-176.15a16 16 0 0121.22 21.19l-176 384A16 16 0 01272 464z"}}]})(props);
	};
	module.exports.IoNewspaperOutline = function IoNewspaperOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M368 415.86V72a24.07 24.07 0 00-24-24H72a24.07 24.07 0 00-24 24v352a40.12 40.12 0 0040 40h328"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M416 464h0a48 48 0 01-48-48V128h72a24 24 0 0124 24v264a48 48 0 01-48 48z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M240 128h64m-64 64h64m-192 64h192m-192 64h192m-192 64h192"}},{"tag":"path","attr":{"d":"M176 208h-64a16 16 0 01-16-16v-64a16 16 0 0116-16h64a16 16 0 0116 16v64a16 16 0 01-16 16z"}}]})(props);
	};
	module.exports.IoNewspaperSharp = function IoNewspaperSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"96","height":"96","x":"96","y":"112","fill":"none","rx":"16","ry":"16"}},{"tag":"path","attr":{"d":"M468 112h-52v304a32 32 0 0032 32 32 32 0 0032-32V124a12 12 0 00-12-12z"}},{"tag":"path","attr":{"d":"M431.15 477.75A64.11 64.11 0 01384 416V44a12 12 0 00-12-12H44a12 12 0 00-12 12v380a56 56 0 0056 56h342.85a1.14 1.14 0 00.3-2.25zM96 208v-96h96v96zm224 192H96v-32h224zm0-64H96v-32h224zm0-64H96v-32h224zm0-64h-96v-32h96zm0-64h-96v-32h96z"}}]})(props);
	};
	module.exports.IoNewspaper = function IoNewspaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M439.91 112h-23.82a.09.09 0 00-.09.09V416a32 32 0 0032 32 32 32 0 0032-32V152.09A40.09 40.09 0 00439.91 112z"}},{"tag":"path","attr":{"d":"M384 416V72a40 40 0 00-40-40H72a40 40 0 00-40 40v352a56 56 0 0056 56h342.85a1.14 1.14 0 001.15-1.15 1.14 1.14 0 00-.85-1.1A64.11 64.11 0 01384 416zM96 128a16 16 0 0116-16h64a16 16 0 0116 16v64a16 16 0 01-16 16h-64a16 16 0 01-16-16zm208 272H112.45c-8.61 0-16-6.62-16.43-15.23A16 16 0 01112 368h191.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 400zm0-64H112.45c-8.61 0-16-6.62-16.43-15.23A16 16 0 01112 304h191.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 336zm0-64H112.45c-8.61 0-16-6.62-16.43-15.23A16 16 0 01112 240h191.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 272zm0-64h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01240 176h63.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 208zm0-64h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01240 112h63.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 144z"}}]})(props);
	};
	module.exports.IoNotificationsCircleOutline = function IoNotificationsCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"d":"M365.2 313c-16.33-19.34-27.86-27.47-27.86-80.8 0-48.86-25.78-66.23-47-74.67a11.39 11.39 0 01-6.34-6.68C280.29 138.6 269.88 128 256 128s-24.31 10.6-28 22.86a11.35 11.35 0 01-6.33 6.68c-21.24 8.46-47 25.8-47 74.67 0 53.33-11.54 61.46-27.87 80.8-6.77 8-.65 23 11.19 23H354C365.77 336 371.94 321 365.2 313zm-144.96 39a4 4 0 00-4 4.42C218.49 375.14 235.11 384 256 384c20.67 0 37.14-9.15 39.66-27.52a4 4 0 00-4-4.48z"}}]})(props);
	};
	module.exports.IoNotificationsCircleSharp = function IoNotificationsCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M295.68 351.43v.57h.32z"}},{"tag":"path","attr":{"fill":"none","d":"M256 384c22.28 0 39.36-10.63 39.66-32H216c0 21.75 17.53 32 40 32zm39.67-32h.33l-.32-.57c0 .19-.01.38-.01.57z"}},{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 336c-22.48 0-40-10.25-40-32h80c-.3 21.37-17.71 32-40 32zm112-48H144v-28l28-36v-32.3c0-40.41 15.82-75.35 56-84.27l4-27.43h48l4 27.43c40 8.92 56 44 56 84.27V272l28 36z"}}]})(props);
	};
	module.exports.IoNotificationsCircle = function IoNotificationsCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 336c-20.9 0-37.52-8.86-39.75-27.58a4 4 0 014-4.42h71.45a4 4 0 014 4.48C293.15 374.85 276.68 384 256 384zm98-48H158c-11.84 0-18-15-11.19-23 16.33-19.34 27.87-27.47 27.87-80.8 0-48.87 25.74-66.21 47-74.67a11.35 11.35 0 006.33-6.68C231.7 138.6 242.14 128 256 128s24.28 10.6 28 22.86a11.39 11.39 0 006.34 6.68c21.21 8.44 47 25.81 47 74.67 0 53.33 11.53 61.46 27.86 80.8 6.74 7.99.57 22.99-11.2 22.99z"}}]})(props);
	};
	module.exports.IoNotificationsOffCircleOutline = function IoNotificationsOffCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"d":"M220.24 352a4 4 0 00-4 4.42C218.49 375.14 235.11 384 256 384s37.5-8.86 39.73-27.58a4 4 0 00-4-4.42zM352 378a15.93 15.93 0 01-11.84-5.24l-192-212a16 16 0 0123.68-21.52l192 212A16 16 0 01352 378zM174.68 232.21c0 53.33-11.54 61.46-27.87 80.8-6.77 8-.65 23 11.19 23h118.83a4 4 0 002.95-6.7l-98-106.87a4 4 0 00-6.94 2.52c-.1 2.33-.16 4.75-.16 7.25zM365.2 313c-16.33-19.34-27.86-27.47-27.86-80.8 0-48.86-25.78-66.23-47-74.67a11.39 11.39 0 01-6.34-6.68C280.29 138.6 269.88 128 256 128s-24.31 10.6-28 22.86a11.35 11.35 0 01-6.33 6.68c-1.28.51-2.57 1.05-3.88 1.63a4 4 0 00-1.3 6.36L361 323.21a4 4 0 006.94-2.95 12 12 0 00-2.74-7.26z"}}]})(props);
	};
	module.exports.IoNotificationsOffCircleSharp = function IoNotificationsOffCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zM144 308l28-36v-32.3a131.83 131.83 0 012.34-25.42L285.92 336H144zm112.18 76C233.6 384 216 373.75 216 352h80c-.3 21.37-17.45 32-39.82 32zm93.48-3.74l-211-227 23.68-21.52 211 227zM368 330.85l-.32-.38-155.5-169.63a73.4 73.4 0 0115.82-5.41l4-27.43h48l4 27.43c40 8.92 56 44 56 84.27V272l28 36z"}}]})(props);
	};
	module.exports.IoNotificationsOffCircle = function IoNotificationsOffCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zM146.83 313c16.33-19.34 27.86-27.47 27.86-80.8q0-3.75.2-7.26a4 4 0 017-2.52l98 106.87a4 4 0 01-2.94 6.7H158C146.18 336 140.06 321 146.83 313zm148.93 43.41C293.53 375.14 276.92 384 256 384s-37.51-8.86-39.75-27.58a4 4 0 014-4.42h71.53a4 4 0 013.98 4.42zm67 17.42a16 16 0 01-22.6-1.08l-192-212a16 16 0 0123.68-21.52l192 212a16 16 0 01-1.08 22.61zM361 323.21L216.49 165.53a4 4 0 011.3-6.36c1.31-.58 2.61-1.12 3.89-1.63a11.33 11.33 0 006.32-6.68c3.72-12.26 14.15-22.86 28-22.86s24.29 10.6 28 22.86a11.34 11.34 0 006.34 6.68c21.21 8.44 47 25.81 47 74.67 0 53.33 11.54 61.46 27.87 80.8a12.09 12.09 0 012.76 7.25 4 4 0 01-6.97 2.95z"}}]})(props);
	};
	module.exports.IoNotificationsOffOutline = function IoNotificationsOffOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M128.51 204.59q-.37 6.15-.37 12.76C128.14 304 110 320 84.33 351.43 73.69 364.45 83 384 101.62 384H320m94.5-48.7c-18.48-23.45-30.62-47.05-30.62-118 0-79.3-40.52-107.57-73.88-121.3-4.43-1.82-8.6-6-9.95-10.55C294.21 65.54 277.82 48 256 48s-38.2 17.55-44 37.47c-1.35 4.6-5.52 8.71-10 10.53a149.57 149.57 0 00-18 8.79M320 384v16a64 64 0 01-128 0v-16"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 448L64 64"}}]})(props);
	};
	module.exports.IoNotificationsOffSharp = function IoNotificationsOffSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M41.37 64l22.628-22.628L470.627 448l-22.628 22.627zM256 480a80.09 80.09 0 0073.3-48H182.7a80.09 80.09 0 0073.3 48zM112 227.47V288l-48 64v48h268.12L115.87 183.75a236.75 236.75 0 00-3.87 43.72zM448 352l-48-64v-60.53C400 157 372.64 95.61 304 80l-8-48h-80l-8 48a117.45 117.45 0 00-41.95 18.17l282 282z"}}]})(props);
	};
	module.exports.IoNotificationsOff = function IoNotificationsOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 464a15.92 15.92 0 01-11.31-4.69l-384-384a16 16 0 0122.62-22.62l384 384A16 16 0 01448 464zm-7.92-122.69c-1.66-2-3.29-4-4.89-5.93-22-26.61-35.31-42.67-35.31-118 0-39-9.33-71-27.72-95-13.56-17.73-31.89-31.18-56.05-41.12a3 3 0 01-.82-.67C306.6 51.49 282.82 32 256 32s-50.59 19.49-59.28 48.56a3.13 3.13 0 01-.81.65 157.88 157.88 0 00-21.88 11 8 8 0 00-1.49 12.49l261.78 261.74a8 8 0 0013.6-6.63 35.39 35.39 0 00-7.84-18.5zM112.14 217.35c0 75.36-13.29 91.42-35.31 118-1.6 1.93-3.23 3.89-4.89 5.93a35.16 35.16 0 00-4.65 37.62c6.17 13 19.32 21.07 34.33 21.07H312.8a8 8 0 005.66-13.66l-192-192a8 8 0 00-13.62 5q-.7 8.69-.7 18.04zM256 480a80.06 80.06 0 0070.44-42.13 4 4 0 00-3.54-5.87H189.12a4 4 0 00-3.55 5.87A80.06 80.06 0 00256 480z"}}]})(props);
	};
	module.exports.IoNotificationsOutline = function IoNotificationsOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M427.68 351.43C402 320 383.87 304 383.87 217.35 383.87 138 343.35 109.73 310 96c-4.43-1.82-8.6-6-9.95-10.55C294.2 65.54 277.8 48 256 48s-38.21 17.55-44 37.47c-1.35 4.6-5.52 8.71-9.95 10.53-33.39 13.75-73.87 41.92-73.87 121.35C128.13 304 110 320 84.32 351.43 73.68 364.45 83 384 101.61 384h308.88c18.51 0 27.77-19.61 17.19-32.57zM320 384v16a64 64 0 01-128 0v-16"}}]})(props);
	};
	module.exports.IoNotificationsSharp = function IoNotificationsSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 480a80.09 80.09 0 0073.3-48H182.7a80.09 80.09 0 0073.3 48zm144-192v-60.53C400 157 372.64 95.61 304 80l-8-48h-80l-8 48c-68.88 15.61-96 76.76-96 147.47V288l-48 64v48h384v-48z"}}]})(props);
	};
	module.exports.IoNotifications = function IoNotifications (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.08 341.31c-1.66-2-3.29-4-4.89-5.93-22-26.61-35.31-42.67-35.31-118 0-39-9.33-71-27.72-95-13.56-17.73-31.89-31.18-56.05-41.12a3 3 0 01-.82-.67C306.6 51.49 282.82 32 256 32s-50.59 19.49-59.28 48.56a3.13 3.13 0 01-.81.65c-56.38 23.21-83.78 67.74-83.78 136.14 0 75.36-13.29 91.42-35.31 118-1.6 1.93-3.23 3.89-4.89 5.93a35.16 35.16 0 00-4.65 37.62c6.17 13 19.32 21.07 34.33 21.07H410.5c14.94 0 28-8.06 34.19-21a35.17 35.17 0 00-4.61-37.66zM256 480a80.06 80.06 0 0070.44-42.13 4 4 0 00-3.54-5.87H189.12a4 4 0 00-3.55 5.87A80.06 80.06 0 00256 480z"}}]})(props);
	};
	module.exports.IoNuclearOutline = function IoNuclearOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"192","fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"64","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M224 192L171 85m117 107l53-107m-13.45 170.81l119.41.13m-147.87 57.19l72.25 95.06M184.45 255.81l-119.41.13m147.87 57.19l-72.25 95.06"}}]})(props);
	};
	module.exports.IoNuclearSharp = function IoNuclearSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"48"}},{"tag":"path","attr":{"fill":"none","d":"M223.47 335.59l-51.71 68a169.73 169.73 0 00168.48 0l-51.71-68"}},{"tag":"path","attr":{"d":"M403.08 108.92a208 208 0 00-294.16 294.16 208 208 0 00294.16-294.16zM342 256a86.13 86.13 0 01-53.47 79.59l51.71 68a169.73 169.73 0 01-168.48 0l51.71-68a86 86 0 01-50.56-101.77l-85.48.09a170.21 170.21 0 0173.83-119l37.94 76.59a85.78 85.78 0 01113.6 0l37.94-76.59a170.21 170.21 0 0173.83 119l-85.48-.09A85.87 85.87 0 01342 256z"}}]})(props);
	};
	module.exports.IoNuclear = function IoNuclear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zM429 239.92l-93.08-.1a2 2 0 01-1.95-1.57 80.08 80.08 0 00-27.44-44.17 2 2 0 01-.54-2.43l41.32-83.43a2 2 0 012.87-.81A176.2 176.2 0 01431 237.71a2 2 0 01-2 2.21zm-220.8 20.46a48 48 0 1143.42 43.42 48 48 0 01-43.42-43.42zm-43.55-152.16L206 191.65a2 2 0 01-.54 2.43A80.08 80.08 0 00178 238.25a2 2 0 01-2 1.57l-93.08.1a2 2 0 01-2-2.21 176.2 176.2 0 0180.82-130.3 2 2 0 012.91.81zm-.37 295.34l56.31-74.09a2 2 0 012.43-.6 79.84 79.84 0 0066 0 2 2 0 012.43.6l56.31 74.09a2 2 0 01-.54 2.92 175.65 175.65 0 01-182.36 0 2 2 0 01-.58-2.92z"}}]})(props);
	};
	module.exports.IoNutritionOutline = function IoNutritionOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M352 128c-32.26-2.89-64 16-96 16s-63.75-19-96-16c-64 6-96 64-96 160 0 80 64 192 111.2 192s51.94-24 80.8-24 33.59 24 80.8 24S448 368 448 288c0-96-29-154-96-160z"}},{"tag":"path","attr":{"d":"M323.92 83.14c-21 21-45.66 27-58.82 28.79a8 8 0 01-9.1-8.73 97.6 97.6 0 0128.61-59.33c22-22 46-26.9 58.72-27.85a8 8 0 018.67 8.92 98 98 0 01-28.08 58.2z"}},{"tag":"ellipse","attr":{"cx":"216","cy":"304","rx":"24","ry":"48"}},{"tag":"ellipse","attr":{"cx":"296","cy":"304","rx":"24","ry":"48"}}]})(props);
	};
	module.exports.IoNutritionSharp = function IoNutritionSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M438.71 159.43c-17.6-28.31-45.5-43.8-85.28-47.37-22.82-2-50.23 4.94-72.25 10.55C271.26 125.14 260 128 256 128s-15.18-2.86-25-5.39c-22.08-5.65-49.56-12.69-72.45-10.54-38.53 3.61-66 19.19-84 47.62S48 229 48 288c0 61.28 29.53 114.58 47.13 140.89C116.82 461.34 149.25 496 175.2 496c18.57 0 34.12-7.23 47.82-13.64C243 473 256 472 256 472s11 0 31.94 10.11C301.65 488.73 317.3 496 336.8 496c26.58 0 59.08-34.69 80.63-67.15C434.82 402.65 464 349.52 464 288c0-60-8-100.83-25.29-128.57zM216 352c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48zm80 0c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48z"}},{"tag":"path","attr":{"d":"M323.72 82.76C353.68 52.82 352 16.18 352 16.14s-35.77-3.76-67.23 27.67S256.06 112 256.06 112s37.68.71 67.66-29.24z"}}]})(props);
	};
	module.exports.IoNutrition = function IoNutrition (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M439 166.29c-18.67-32.57-47.46-50.81-85.57-54.23-20.18-1.8-39 3.37-57.23 8.38-14.15 3.89-27.52 7.56-40.2 7.56s-26-3.68-40.06-7.57c-18.28-5-37.18-10.26-57.43-8.36-36.39 3.41-65.51 22.11-84.31 54.08C56.82 195.76 48 236.76 48 288c0 40.4 15 90.49 40 134 12.82 22.25 47 74 87.16 74 30.77 0 47.15-9.44 59.11-16.33 8.3-4.78 13.31-7.67 21.69-7.67s13.39 2.89 21.69 7.67c12 6.89 28.35 16.33 59.15 16.33 40.17 0 74.34-51.76 87.16-74 25.07-43.5 40-93.59 40-134 .04-52.57-8.14-92.38-24.96-121.71zM216 352c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48zm80 0c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48z"}},{"tag":"path","attr":{"d":"M265.1 111.93c13.16-1.75 37.86-7.83 58.83-28.79a98 98 0 0028-58.2 8 8 0 00-8.55-8.94c-12.71.95-36.76 5.87-58.73 27.85A97.6 97.6 0 00256 103.2a8 8 0 009.1 8.73z"}}]})(props);
	};
	module.exports.IoOpenOutline = function IoOpenOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48M336 64h112v112M224 288L440 72"}}]})(props);
	};
	module.exports.IoOpenSharp = function IoOpenSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M201.37 288l176-176H48v352h352V134.63l-176 176L201.37 288z"}},{"tag":"path","attr":{"d":"M320 48v32h89.37l-32 32L400 134.63l32-32V192h32V48H320z"}}]})(props);
	};
	module.exports.IoOpen = function IoOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 304a16 16 0 01-11.31-27.31l157.94-157.94A55.7 55.7 0 00344 112H104a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h240a56.06 56.06 0 0056-56V168a55.7 55.7 0 00-6.75-26.63L235.31 299.31A15.92 15.92 0 01224 304z"}},{"tag":"path","attr":{"d":"M448 48H336a16 16 0 000 32h73.37l-38.74 38.75a56.35 56.35 0 0122.62 22.62L432 102.63V176a16 16 0 0032 0V64a16 16 0 00-16-16z"}}]})(props);
	};
	module.exports.IoOptionsOutline = function IoOptionsOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M368 128h80m-384 0h240m64 256h80m-384 0h240m-96-128h240m-384 0h80"}},{"tag":"circle","attr":{"cx":"336","cy":"128","r":"32","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"176","cy":"256","r":"32","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"336","cy":"384","r":"32","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoOptionsSharp = function IoOptionsSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M381.25 112a48 48 0 00-90.5 0H48v32h242.75a48 48 0 0090.5 0H464v-32zM176 208a48.09 48.09 0 00-45.25 32H48v32h82.75a48 48 0 0090.5 0H464v-32H221.25A48.09 48.09 0 00176 208zm160 128a48.09 48.09 0 00-45.25 32H48v32h242.75a48 48 0 0090.5 0H464v-32h-82.75A48.09 48.09 0 00336 336z"}}]})(props);
	};
	module.exports.IoOptions = function IoOptions (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 144h226.75a48 48 0 0090.5 0H448a16 16 0 000-32h-66.75a48 48 0 00-90.5 0H64a16 16 0 000 32zm384 224h-66.75a48 48 0 00-90.5 0H64a16 16 0 000 32h226.75a48 48 0 0090.5 0H448a16 16 0 000-32zm0-128H221.25a48 48 0 00-90.5 0H64a16 16 0 000 32h66.75a48 48 0 0090.5 0H448a16 16 0 000-32z"}}]})(props);
	};
	module.exports.IoPaperPlaneOutline = function IoPaperPlaneOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M53.12 199.94l400-151.39a8 8 0 0110.33 10.33l-151.39 400a8 8 0 01-15-.34l-67.4-166.09a16 16 0 00-10.11-10.11L53.46 215a8 8 0 01-.34-15.06zM460 52L227 285"}}]})(props);
	};
	module.exports.IoPaperPlaneSharp = function IoPaperPlaneSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 16L15.88 208 195 289 448 64 223 317l81 179L496 16z"}}]})(props);
	};
	module.exports.IoPaperPlane = function IoPaperPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M473 39.05a24 24 0 00-25.5-5.46L47.47 185h-.08a24 24 0 001 45.16l.41.13 137.3 58.63a16 16 0 0015.54-3.59L422 80a7.07 7.07 0 0110 10L226.66 310.26a16 16 0 00-3.59 15.54l58.65 137.38c.06.2.12.38.19.57 3.2 9.27 11.3 15.81 21.09 16.25h1a24.63 24.63 0 0023-15.46L478.39 64.62A24 24 0 00473 39.05z"}}]})(props);
	};
	module.exports.IoPartlySunnyOutline = function IoPartlySunnyOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M90.61 306.85A16.07 16.07 0 00104 293.6C116.09 220.17 169.63 176 232 176c57.93 0 96.62 37.75 112.2 77.74a15.84 15.84 0 0012.2 9.87c50 8.15 91.6 41.54 91.6 99.59 0 59.4-48.6 100.8-108 100.8H106c-49.5 0-90-24.7-90-79.2 0-48.47 38.67-72.22 74.61-77.95z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M384.8 271.4a80 80 0 10-123.55-92M464 208h32M336 48v32M222.86 94.86l22.63 22.63m203.65-22.63l-22.63 22.63"}}]})(props);
	};
	module.exports.IoPartlySunnySharp = function IoPartlySunnySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-26.66 10.08-49.8 29.14-66.91 15.24-13.68 36.17-23.21 59-26.84.06 0 .08 0 .09-.05 6.44-39 23.83-72.09 50.31-95.68A140.24 140.24 0 01232 160c30.23 0 58.48 9.39 81.71 27.17a142.69 142.69 0 0145.36 60.66c29.41 4.82 54.72 17.11 73.19 35.54C453 304.11 464 331.71 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm19-232.18zm22.5-27.93a169.23 169.23 0 0145.44 19A96 96 0 00281 129.33q-2.85 2-5.54 4.2a162.47 162.47 0 0157.73 28.23 174.53 174.53 0 0148.31 58.13zM448 192h64v32h-64zM320 32h32v64h-32zm-64.65 97.63l12.45-12.45-44.62-44.63-22.63 22.63 33.17 33.17h.6a172 172 0 0121.03 1.28zm148.853-12.46l44.626-44.625 22.627 22.628-44.625 44.625z"}}]})(props);
	};
	module.exports.IoPartlySunny = function IoPartlySunny (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-26.66 10.08-49.8 29.14-66.91 15.24-13.68 36.17-23.21 59-26.84.06 0 .08 0 .09-.05 6.44-39 23.83-72.09 50.31-95.68A140.24 140.24 0 01232 160c30.23 0 58.48 9.39 81.71 27.17a142.24 142.24 0 0142.19 53.21 16 16 0 0011.19 9c26 5.61 48.4 17.29 65.17 34C453 304.11 464 331.71 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm19-232.18zm28.89-26.14a168.8 168.8 0 0134.76 14.71 4 4 0 005.82-2.44 97 97 0 003.53-26.68c-.39-52.43-43.48-95.22-95.91-95.27A95.46 95.46 0 00281 129.33h-.06a3.38 3.38 0 001 6 162.45 162.45 0 0151.28 26.4 173.92 173.92 0 0145.32 52.51 16 16 0 009.35 7.44zM496 224h-32a16 16 0 010-32h32a16 16 0 010 32zM336 96a16 16 0 01-16-16V48a16 16 0 0132 0v32a16 16 0 01-16 16zm-90.51 37.49a15.92 15.92 0 01-11.31-4.69l-22.63-22.62a16 16 0 0122.63-22.63l22.62 22.63a16 16 0 01-11.31 27.31zm181.02 0a16 16 0 01-11.31-27.31l22.62-22.63a16 16 0 0122.63 22.63l-22.63 22.62a15.92 15.92 0 01-11.31 4.69z"}}]})(props);
	};
	module.exports.IoPauseCircleOutline = function IoPauseCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M208 192v128m96-128v128"}}]})(props);
	};
	module.exports.IoPauseCircleSharp = function IoPauseCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-32 288h-32V176h32zm96 0h-32V176h32z"}}]})(props);
	};
	module.exports.IoPauseCircle = function IoPauseCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-32 272a16 16 0 01-32 0V192a16 16 0 0132 0zm96 0a16 16 0 01-32 0V192a16 16 0 0132 0z"}}]})(props);
	};
	module.exports.IoPauseOutline = function IoPauseOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 96h16v320h-16zm144 0h16v320h-16z"}}]})(props);
	};
	module.exports.IoPauseSharp = function IoPauseSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 432h-80V80h80zm144 0h-80V80h80z"}}]})(props);
	};
	module.exports.IoPause = function IoPause (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 432h-48a16 16 0 01-16-16V96a16 16 0 0116-16h48a16 16 0 0116 16v320a16 16 0 01-16 16zm144 0h-48a16 16 0 01-16-16V96a16 16 0 0116-16h48a16 16 0 0116 16v320a16 16 0 01-16 16z"}}]})(props);
	};
	module.exports.IoPawOutline = function IoPawOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M457.74 170.1a30.26 30.26 0 00-11.16-2.1h-.4c-20.17.3-42.79 19.19-54.66 47.76-14.23 34.18-7.68 69.15 14.74 78.14a30.21 30.21 0 0011.15 2.1c20.27 0 43.2-19 55.17-47.76 14.13-34.18 7.48-69.15-14.84-78.14zM327.6 303.48C299.8 257.35 287.8 240 256 240s-43.9 17.46-71.7 63.48c-23.8 39.36-71.9 42.64-83.9 76.07a50.91 50.91 0 00-3.6 19.25c0 27.19 20.8 49.2 46.4 49.2 31.8 0 75.1-25.39 112.9-25.39S337 448 368.8 448c25.6 0 46.3-22 46.3-49.2a51 51 0 00-3.7-19.25c-12-33.55-60-36.71-83.8-76.07zM192.51 196a26.53 26.53 0 004-.3c23.21-3.37 37.7-35.53 32.44-71.85C224 89.61 203.22 64 181.49 64a26.53 26.53 0 00-4 .3c-23.21 3.37-37.7 35.53-32.44 71.85C150 170.29 170.78 196 192.51 196zm174.41-59.85c5.26-36.32-9.23-68.48-32.44-71.85a26.53 26.53 0 00-4-.3c-21.73 0-42.47 25.61-47.43 59.85-5.26 36.32 9.23 68.48 32.44 71.85a26.53 26.53 0 004 .3c21.73 0 42.51-25.71 47.43-59.85zM105.77 293.9c22.39-9 28.93-44 14.72-78.14C108.53 187 85.62 168 65.38 168a30.21 30.21 0 00-11.15 2.1c-22.39 9-28.93 44-14.72 78.14C51.47 277 74.38 296 94.62 296a30.21 30.21 0 0011.15-2.1z"}}]})(props);
	};
	module.exports.IoPawSharp = function IoPawSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M442.8 361.82c-8.8-25.1-29.31-37.82-49.11-50.12-17.23-10.71-33.5-20.83-44.14-39-29.33-50.33-45.44-80.7-93.49-80.7s-64.21 30.38-93.61 80.69c-10.65 18.21-27 28.35-44.25 39.08-19.8 12.31-40.27 25-49.1 50.05a78.06 78.06 0 00-5.1 28.29C64 430.85 96.45 464 132.4 464s83.31-18.13 123.76-18.13S343.31 464 379.71 464 448 430.85 448 390.11a78.3 78.3 0 00-5.2-28.29z"}},{"tag":"ellipse","attr":{"cx":"72","cy":"216","rx":"56","ry":"72"}},{"tag":"ellipse","attr":{"cx":"184","cy":"120","rx":"56","ry":"72"}},{"tag":"ellipse","attr":{"cx":"328","cy":"120","rx":"56","ry":"72"}},{"tag":"ellipse","attr":{"cx":"440","cy":"216","rx":"56","ry":"72"}}]})(props);
	};
	module.exports.IoPaw = function IoPaw (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M490.39 182.75c-5.55-13.19-14.77-22.7-26.67-27.49l-.16-.06a46.46 46.46 0 00-17-3.2h-.64c-27.24.41-55.05 23.56-69.19 57.61-10.37 24.9-11.56 51.68-3.18 71.64 5.54 13.2 14.78 22.71 26.73 27.5l.13.05a46.53 46.53 0 0017 3.2c27.5 0 55.6-23.15 70-57.65 10.24-24.87 11.37-51.63 2.98-71.6zM381.55 329.61c-15.71-9.44-30.56-18.37-40.26-34.41C314.53 250.8 298.37 224 256 224s-58.57 26.8-85.39 71.2c-9.72 16.06-24.6 25-40.36 34.48-18.07 10.86-36.74 22.08-44.8 44.16a66.93 66.93 0 00-4.65 25c0 35.95 28 65.2 62.4 65.2 17.75 0 36.64-6.15 56.63-12.66 19.22-6.26 39.09-12.73 56.27-12.73s37 6.47 56.15 12.73C332.2 457.85 351 464 368.8 464c34.35 0 62.3-29.25 62.3-65.2a67 67 0 00-4.75-25c-8.06-22.1-26.74-33.33-44.8-44.19zM150 188.85c11.9 14.93 27 23.15 42.52 23.15a42.88 42.88 0 006.33-.47c32.37-4.76 52.54-44.26 45.92-90C242 102.3 234.6 84.39 224 71.11 212.12 56.21 197 48 181.49 48a42.88 42.88 0 00-6.33.47c-32.37 4.76-52.54 44.26-45.92 90 2.76 19.2 10.16 37.09 20.76 50.38zm163.16 22.68a42.88 42.88 0 006.33.47c15.53 0 30.62-8.22 42.52-23.15 10.59-13.29 17.95-31.18 20.75-50.4 6.62-45.72-13.55-85.22-45.92-90a42.88 42.88 0 00-6.33-.47C315 48 299.88 56.21 288 71.11c-10.6 13.28-18 31.19-20.76 50.44-6.62 45.72 13.55 85.22 45.92 89.98zM111.59 308.8l.14-.05c11.93-4.79 21.16-14.29 26.69-27.48 8.38-20 7.2-46.75-3.15-71.65C120.94 175.16 92.85 152 65.38 152a46.4 46.4 0 00-17 3.2l-.14.05c-11.9 4.75-21.13 14.29-26.66 27.48-8.38 20-7.2 46.75 3.15 71.65C39.06 288.84 67.15 312 94.62 312a46.4 46.4 0 0016.97-3.2z"}}]})(props);
	};
	module.exports.IoPencilOutline = function IoPencilOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M364.13 125.25L87 403l-23 45 44.99-23 277.76-277.13-22.62-22.62zm56.56-56.56l-22.62 22.62 22.62 22.63 22.62-22.63a16 16 0 000-22.62h0a16 16 0 00-22.62 0z"}}]})(props);
	};
	module.exports.IoPencilSharp = function IoPencilSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M103 464H48v-55L358.14 98.09l55.77 55.78L103 464zm322.72-322L370 86.28l31.66-30.66C406.55 50.7 414.05 48 421 48a25.91 25.91 0 0118.42 7.62l17 17A25.87 25.87 0 01464 91c0 7-2.71 14.45-7.62 19.36zm-7.52-70.83z"}}]})(props);
	};
	module.exports.IoPencil = function IoPencil (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"44","d":"M358.62 129.28L86.49 402.08 70 442l39.92-16.49 272.8-272.13-24.1-24.1zm54.45-54.44l-11.79 11.78 24.1 24.1 11.79-11.79a16.51 16.51 0 000-23.34l-.75-.75a16.51 16.51 0 00-23.35 0z"}}]})(props);
	};
	module.exports.IoPeopleCircleOutline = function IoPeopleCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208zm0-384c-97 0-176 79-176 176s79 176 176 176 176-78.95 176-176S353.05 80 256 80z"}},{"tag":"path","attr":{"d":"M323.67 292c-17.4 0-34.21-7.72-47.34-21.73a83.76 83.76 0 01-22-51.32c-1.47-20.7 4.88-39.75 17.88-53.62S303.38 144 323.67 144c20.14 0 38.37 7.62 51.33 21.46s19.47 33 18 53.51a84 84 0 01-22 51.3C357.86 284.28 341.06 292 323.67 292zm55.81-74zm-215.66 77.36c-29.76 0-55.93-27.51-58.33-61.33-1.23-17.32 4.15-33.33 15.17-45.08s26.22-18 43.15-18 32.12 6.44 43.07 18.14 16.5 27.82 15.25 45c-2.44 33.77-28.6 61.27-58.31 61.27zm256.55 59.92c-1.59-4.7-5.46-9.71-13.22-14.46-23.46-14.33-52.32-21.91-83.48-21.91-30.57 0-60.23 7.9-83.53 22.25-26.25 16.17-43.89 39.75-51 68.18-1.68 6.69-4.13 19.14-1.51 26.11a192.18 192.18 0 00232.75-80.17zm-256.74 46.09c7.07-28.21 22.12-51.73 45.47-70.75a8 8 0 00-2.59-13.77c-12-3.83-25.7-5.88-42.69-5.88-23.82 0-49.11 6.45-68.14 18.17-5.4 3.33-10.7 4.61-14.78 5.75a192.84 192.84 0 0077.78 86.64l1.79-.14a102.82 102.82 0 013.16-20.02z"}}]})(props);
	};
	module.exports.IoPeopleCircleSharp = function IoPeopleCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm69.3 96.17a72.5 72.5 0 11-72.6 72.5 72.55 72.55 0 0172.6-72.5zm-155.1 26.36a59.32 59.32 0 11-59.4 59.32 59.35 59.35 0 0159.4-59.32zm-75.85 155c24.5-13.29 55.87-19.94 75.85-19.94 15 0 34.32 3 53.33 10.2a133.05 133.05 0 00-34 27.11c-13.19 15-20.76 32.92-20.76 50.83v15a177.06 177.06 0 01-74.42-83.15zM256 432a175.12 175.12 0 01-59.4-10.33v-27.05c0-52.59 85.75-79.09 128.7-79.09 23 0 58.38 7.63 86.21 22.81A176.14 176.14 0 01256 432z"}}]})(props);
	};
	module.exports.IoPeopleCircle = function IoPeopleCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zm-3.68 152.11c.21-1.2.44-2.4.71-3.59a66.46 66.46 0 0116.29-31.21c12.89-13.73 31.16-21.31 51.45-21.31a74.05 74.05 0 0125.06 4.26 66.69 66.69 0 0126.27 17.2 68.15 68.15 0 0118 42.14 78.46 78.46 0 010 11.4 86.19 86.19 0 01-8.2 31q-.76 1.59-1.59 3.15c-1.11 2.07-2.3 4.1-3.58 6.06a79.47 79.47 0 01-8.63 11c-13.12 14-29.92 21.73-47.31 21.73a59.61 59.61 0 01-19.17-3.18 63.47 63.47 0 01-6.1-2.43 70.76 70.76 0 01-22.07-16.12 83.76 83.76 0 01-22-51.32q-.27-3.88-.18-7.68a75.62 75.62 0 011.05-11.08zm-149.73 24.34a59.87 59.87 0 015.2-20.64 56.76 56.76 0 012.78-5.3 54.49 54.49 0 017.19-9.56 55.62 55.62 0 0114-10.82 56.84 56.84 0 018.11-3.64 63.85 63.85 0 0133.35-2.39 57 57 0 0130.78 17 57.86 57.86 0 0115.41 38.62c.05 2.11 0 4.23-.15 6.38a71.58 71.58 0 01-6 23.84 69.49 69.49 0 01-5.73 10.42 65.39 65.39 0 01-15.76 16.57c-1.5 1.07-3.06 2.07-4.67 3.07a54.21 54.21 0 01-10 4.65 49.31 49.31 0 01-16.2 2.76c-.93 0-1.86 0-2.78-.08a47.6 47.6 0 01-5.48-.62 51.19 51.19 0 01-5.35-1.23 53.54 53.54 0 01-7.72-2.89c-.84-.39-1.66-.8-2.48-1.23-18-9.49-31.57-29.16-34.23-52.12-.12-1.05-.22-2.1-.29-3.16a66.59 66.59 0 01.02-9.63zm53.92 178.6a177.27 177.27 0 01-61.94-70.65 4 4 0 011.62-5.26C117.67 316.69 141.4 311 163.82 311c17 0 30.7 2 42.69 5.88a8 8 0 012.59 13.77c-23.35 19-38.4 42.54-45.47 70.75a2.77 2.77 0 01-4.22 1.65zM256 432a175.12 175.12 0 01-65.7-12.72 4 4 0 01-2.4-4.46c.4-2.05.84-3.92 1.23-5.48 7.12-28.43 24.76-52 51-68.18 23.29-14.35 53-22.25 83.52-22.25 31.16 0 60 7.58 83.48 21.91a2.72 2.72 0 01.91 3.67A176.1 176.1 0 01256 432z"}},{"tag":"path","attr":{"d":"M161 295.28a47.6 47.6 0 01-5.48-.62 47.6 47.6 0 005.48.62zm-26.36-117.15a55.62 55.62 0 00-14 10.82 54.49 54.49 0 00-7.19 9.56 54.49 54.49 0 017.19-9.56 55.62 55.62 0 0114-10.82zm81.53 79.76a71.58 71.58 0 006-23.84c.15-2.15.2-4.27.15-6.38q.08 3.15-.15 6.38a71.58 71.58 0 01-6 23.84zm-81.53-79.76a56.84 56.84 0 018.11-3.64 56.84 56.84 0 00-8.11 3.64zm15.57 115.3a53.54 53.54 0 01-7.72-2.89 53.54 53.54 0 007.72 2.89zm-44.43-56.24c2.66 23 16.26 42.63 34.23 52.12-18.01-9.49-31.57-29.16-34.23-52.12zM254.34 219a83.76 83.76 0 0022 51.32 70.76 70.76 0 0022.07 16.12 70.76 70.76 0 01-22.07-16.12 83.76 83.76 0 01-22-51.32q-.27-3.88-.18-7.68-.09 3.75.18 7.68zm50.16 69.82a63.47 63.47 0 01-6.1-2.43 63.47 63.47 0 006.1 2.43zm-48.57-92.28a66.46 66.46 0 0116.29-31.21 66.46 66.46 0 00-16.29 31.21zM375 165.46a68.15 68.15 0 0118 42.14 68.15 68.15 0 00-18-42.14 66.69 66.69 0 00-26.27-17.2 66.69 66.69 0 0126.27 17.2zM393 219a86.19 86.19 0 01-8.2 31 86.19 86.19 0 008.2-31zm-138.84-7.73a75.62 75.62 0 011.06-11.14 75.62 75.62 0 00-1.06 11.14zm129.03 41.89zm-176.31-64.11a57.86 57.86 0 0115.41 38.62 57.86 57.86 0 00-15.41-38.62 57 57 0 00-30.78-17 57 57 0 0130.78 17zM190 288a54.21 54.21 0 01-10 4.65 54.21 54.21 0 0010-4.65zm-84.51-63.55a59.87 59.87 0 015.2-20.64 59.87 59.87 0 00-5.2 20.64zm89.19 60.43C193.17 286 191.61 287 190 288c1.61-1 3.17-2 4.68-3.12zm21.49-26.99a69.49 69.49 0 01-5.73 10.42 69.49 69.49 0 005.73-10.42zm-105.48-54.08a56.76 56.76 0 012.78-5.3 56.76 56.76 0 00-2.78 5.3zm83.99 81.07a65.39 65.39 0 0015.76-16.57 65.39 65.39 0 01-15.76 16.57z"}}]})(props);
	};
	module.exports.IoPeopleOutline = function IoPeopleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M402 168c-2.93 40.67-33.1 72-66 72s-63.12-31.32-66-72c-3-42.31 26.37-72 66-72s69 30.46 66 72z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M336 304c-65.17 0-127.84 32.37-143.54 95.41-2.08 8.34 3.15 16.59 11.72 16.59h263.65c8.57 0 13.77-8.25 11.72-16.59C463.85 335.36 401.18 304 336 304z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M200 185.94c-2.34 32.48-26.72 58.06-53 58.06s-50.7-25.57-53-58.06C91.61 152.15 115.34 128 147 128s55.39 24.77 53 57.94z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M206 306c-18.05-8.27-37.93-11.45-59-11.45-52 0-102.1 25.85-114.65 76.2-1.65 6.66 2.53 13.25 9.37 13.25H154"}}]})(props);
	};
	module.exports.IoPeopleSharp = function IoPeopleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"152","cy":"184","r":"72"}},{"tag":"path","attr":{"d":"M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z"}},{"tag":"path","attr":{"d":"M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z"}},{"tag":"circle","attr":{"cx":"340","cy":"168","r":"88"}}]})(props);
	};
	module.exports.IoPeople = function IoPeople (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 256c-20.56 0-40.44-9.18-56-25.84-15.13-16.25-24.37-37.92-26-61-1.74-24.62 5.77-47.26 21.14-63.76S312 80 336 80c23.83 0 45.38 9.06 60.7 25.52 15.47 16.62 23 39.22 21.26 63.63-1.67 23.11-10.9 44.77-26 61C376.44 246.82 356.57 256 336 256zm66-88zm65.83 264H204.18a27.71 27.71 0 01-22-10.67 30.22 30.22 0 01-5.26-25.79c8.42-33.81 29.28-61.85 60.32-81.08C264.79 297.4 299.86 288 336 288c36.85 0 71 9 98.71 26.05 31.11 19.13 52 47.33 60.38 81.55a30.27 30.27 0 01-5.32 25.78A27.68 27.68 0 01467.83 432zM147 260c-35.19 0-66.13-32.72-69-72.93-1.42-20.6 5-39.65 18-53.62 12.86-13.83 31-21.45 51-21.45s38 7.66 50.93 21.57c13.1 14.08 19.5 33.09 18 53.52-2.87 40.2-33.8 72.91-68.93 72.91zm65.66 31.45c-17.59-8.6-40.42-12.9-65.65-12.9-29.46 0-58.07 7.68-80.57 21.62-25.51 15.83-42.67 38.88-49.6 66.71a27.39 27.39 0 004.79 23.36A25.32 25.32 0 0041.72 400h111a8 8 0 007.87-6.57c.11-.63.25-1.26.41-1.88 8.48-34.06 28.35-62.84 57.71-83.82a8 8 0 00-.63-13.39c-1.57-.92-3.37-1.89-5.42-2.89z"}}]})(props);
	};
	module.exports.IoPersonAddOutline = function IoPersonAddOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M376 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M288 304c-87 0-175.3 48-191.64 138.6-2 10.92 4.21 21.4 15.65 21.4H464c11.44 0 17.62-10.48 15.65-21.4C463.3 352 375 304 288 304z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M88 176v112m56-56H32"}}]})(props);
	};
	module.exports.IoPersonAddSharp = function IoPersonAddSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M106 304v-54h54v-36h-54v-54H70v54H16v36h54v54h36z"}},{"tag":"circle","attr":{"cx":"288","cy":"144","r":"112"}},{"tag":"path","attr":{"d":"M288 288c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z"}}]})(props);
	};
	module.exports.IoPersonAdd = function IoPersonAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 256c52.79 0 99.43-49.71 104-110.82 2.27-30.7-7.36-59.33-27.12-80.6C345.33 43.57 318 32 288 32c-30.24 0-57.59 11.5-77 32.38-19.63 21.11-29.2 49.8-27 80.78C188.49 206.28 235.12 256 288 256zm207.38 183.76c-8.44-46.82-34.79-86.15-76.19-113.75C382.42 301.5 335.83 288 288 288s-94.42 13.5-131.19 38c-41.4 27.6-67.75 66.93-76.19 113.75-1.93 10.73.69 21.34 7.19 29.11A30.94 30.94 0 00112 480h352a30.94 30.94 0 0024.21-11.13c6.48-7.77 9.1-18.38 7.17-29.11zM104 288v-40h40a16 16 0 000-32h-40v-40a16 16 0 00-32 0v40H32a16 16 0 000 32h40v40a16 16 0 0032 0z"}}]})(props);
	};
	module.exports.IoPersonCircleOutline = function IoPersonCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zm126.42 327.25a4 4 0 01-6.14-.32 124.27 124.27 0 00-32.35-29.59C321.37 329 289.11 320 256 320s-65.37 9-90.83 25.34a124.24 124.24 0 00-32.35 29.58 4 4 0 01-6.14.32A175.32 175.32 0 0180 259c-1.63-97.31 78.22-178.76 175.57-179S432 158.81 432 256a175.32 175.32 0 01-46.68 119.25z"}},{"tag":"path","attr":{"d":"M256 144c-19.72 0-37.55 7.39-50.22 20.82s-19 32-17.57 51.93C191.11 256 221.52 288 256 288s64.83-32 67.79-71.24c1.48-19.74-4.8-38.14-17.68-51.82C293.39 151.44 275.59 144 256 144z"}}]})(props);
	};
	module.exports.IoPersonCircleSharp = function IoPersonCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm2 96a72 72 0 11-72 72 72 72 0 0172-72zm-2 288a175.55 175.55 0 01-129.18-56.6C135.66 329.62 215.06 320 256 320s120.34 9.62 129.18 55.39A175.52 175.52 0 01256 432z"}}]})(props);
	};
	module.exports.IoPersonCircle = function IoPersonCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-50.22 116.82C218.45 151.39 236.28 144 256 144s37.39 7.44 50.11 20.94c12.89 13.68 19.16 32.06 17.68 51.82C320.83 256 290.43 288 256 288s-64.89-32-67.79-71.25c-1.47-19.92 4.79-38.36 17.57-51.93zM256 432a175.49 175.49 0 01-126-53.22 122.91 122.91 0 0135.14-33.44C190.63 329 222.89 320 256 320s65.37 9 90.83 25.34A122.87 122.87 0 01382 378.78 175.45 175.45 0 01256 432z"}}]})(props);
	};
	module.exports.IoPersonOutline = function IoPersonOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z"}}]})(props);
	};
	module.exports.IoPersonRemoveOutline = function IoPersonRemoveOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M376 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M288 304c-87 0-175.3 48-191.64 138.6-2 10.92 4.21 21.4 15.65 21.4H464c11.44 0 17.62-10.48 15.65-21.4C463.3 352 375 304 288 304z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M144 232H32"}}]})(props);
	};
	module.exports.IoPersonRemoveSharp = function IoPersonRemoveSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16 214h144v36H16z"}},{"tag":"circle","attr":{"cx":"288","cy":"144","r":"112"}},{"tag":"path","attr":{"d":"M288 288c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z"}}]})(props);
	};
	module.exports.IoPersonRemove = function IoPersonRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 256c52.79 0 99.43-49.71 104-110.82 2.27-30.7-7.36-59.33-27.12-80.6C345.33 43.57 318 32 288 32c-30.24 0-57.59 11.5-77 32.38-19.63 21.11-29.2 49.8-27 80.78C188.49 206.28 235.12 256 288 256zm207.38 183.76c-8.44-46.82-34.79-86.15-76.19-113.75C382.42 301.5 335.83 288 288 288s-94.42 13.5-131.19 38c-41.4 27.6-67.75 66.93-76.19 113.75-1.93 10.73.69 21.34 7.19 29.11A30.94 30.94 0 00112 480h352a30.94 30.94 0 0024.21-11.13c6.48-7.77 9.1-18.38 7.17-29.11zM144 216H32a16 16 0 000 32h112a16 16 0 000-32z"}}]})(props);
	};
	module.exports.IoPersonSharp = function IoPersonSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 256a112 112 0 10-112-112 112 112 0 00112 112zm0 32c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z"}}]})(props);
	};
	module.exports.IoPerson = function IoPerson (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M332.64 64.58C313.18 43.57 286 32 256 32c-30.16 0-57.43 11.5-76.8 32.38-19.58 21.11-29.12 49.8-26.88 80.78C156.76 206.28 203.27 256 256 256s99.16-49.71 103.67-110.82c2.27-30.7-7.33-59.33-27.03-80.6zM432 480H80a31 31 0 01-24.2-11.13c-6.5-7.77-9.12-18.38-7.18-29.11C57.06 392.94 83.4 353.61 124.8 326c36.78-24.51 83.37-38 131.2-38s94.42 13.5 131.2 38c41.4 27.6 67.74 66.93 76.18 113.75 1.94 10.73-.68 21.34-7.18 29.11A31 31 0 01432 480z"}}]})(props);
	};
	module.exports.IoPhoneLandscapeOutline = function IoPhoneLandscapeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"256","height":"480","x":"128","y":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48","transform":"rotate(-90 256 256)"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M16 336v-24a8 8 0 018-8h0a16 16 0 0016-16v-64a16 16 0 00-16-16h0a8 8 0 01-8-8v-24"}}]})(props);
	};
	module.exports.IoPhoneLandscapeSharp = function IoPhoneLandscapeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 130v252a18 18 0 0018 18h476a18 18 0 0018-18V130a18 18 0 00-18-18H18a18 18 0 00-18 18zm448 234H64V148h384z"}}]})(props);
	};
	module.exports.IoPhoneLandscape = function IoPhoneLandscape (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 176v160a64 64 0 0064 64h384a64 64 0 0064-64V176a64 64 0 00-64-64H64a64 64 0 00-64 64zm448-32a32 32 0 0132 32v160a32 32 0 01-32 32H64a32 32 0 01-32-32v-11.35a7.94 7.94 0 014.75-7.3A32 32 0 0056 288v-64a32 32 0 00-19.25-29.35 7.94 7.94 0 01-4.75-7.3V176a32 32 0 0132-32z"}},{"tag":"path","attr":{"d":"M48 176a11.88 11.88 0 004.69 9.53A48 48 0 0172 224v64a48 48 0 01-19.31 38.47A11.88 11.88 0 0048 336a16 16 0 0016 16h384a16 16 0 0016-16V176a16 16 0 00-16-16H64a16 16 0 00-16 16z"}},{"tag":"path","attr":{"d":"M0 176v160a64 64 0 0064 64h384a64 64 0 0064-64V176a64 64 0 00-64-64H64a64 64 0 00-64 64zm448-32a32 32 0 0132 32v160a32 32 0 01-32 32H64a32 32 0 01-32-32v-11.35a7.94 7.94 0 014.75-7.3A32 32 0 0056 288v-64a32 32 0 00-19.25-29.35 7.94 7.94 0 01-4.75-7.3V176a32 32 0 0132-32z"}}]})(props);
	};
	module.exports.IoPhonePortraitOutline = function IoPhonePortraitOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"256","height":"480","x":"128","y":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 16h24a8 8 0 018 8h0a16 16 0 0016 16h64a16 16 0 0016-16h0a8 8 0 018-8h24"}}]})(props);
	};
	module.exports.IoPhonePortraitSharp = function IoPhonePortraitSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M382 0H130a18 18 0 00-18 18v476a18 18 0 0018 18h252a18 18 0 0018-18V18a18 18 0 00-18-18zM148 448V64h216v384z"}}]})(props);
	};
	module.exports.IoPhonePortrait = function IoPhonePortrait (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 0H176a64 64 0 00-64 64v384a64 64 0 0064 64h160a64 64 0 0064-64V64a64 64 0 00-64-64zm32 448a32 32 0 01-32 32H176a32 32 0 01-32-32V64a32 32 0 0132-32h11.35a7.94 7.94 0 017.3 4.75A32 32 0 00224 56h64a32 32 0 0029.35-19.25 7.94 7.94 0 017.3-4.75H336a32 32 0 0132 32z"}},{"tag":"path","attr":{"d":"M336 48a11.88 11.88 0 00-9.53 4.69A48 48 0 01288 72h-64a48 48 0 01-38.47-19.31A11.88 11.88 0 00176 48a16 16 0 00-16 16v384a16 16 0 0016 16h160a16 16 0 0016-16V64a16 16 0 00-16-16z"}},{"tag":"path","attr":{"d":"M336 0H176a64 64 0 00-64 64v384a64 64 0 0064 64h160a64 64 0 0064-64V64a64 64 0 00-64-64zm32 448a32 32 0 01-32 32H176a32 32 0 01-32-32V64a32 32 0 0132-32h11.35a7.94 7.94 0 017.3 4.75A32 32 0 00224 56h64a32 32 0 0029.35-19.25 7.94 7.94 0 017.3-4.75H336a32 32 0 0132 32z"}}]})(props);
	};
	module.exports.IoPieChartOutline = function IoPieChartOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M256.05 80.65Q263.94 80 272 80c106 0 192 86 192 192s-86 192-192 192A192.09 192.09 0 0189.12 330.65"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 48C141.12 48 48 141.12 48 256a207.29 207.29 0 0018.09 85L256 256z"}}]})(props);
	};
	module.exports.IoPieChartSharp = function IoPieChartSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M58 362.09l-6.51-14.59A224 224 0 01256 32h16v234.37z"}},{"tag":"path","attr":{"d":"M304 66.46v220.65L94.62 380.78A208.31 208.31 0 00272 480c114.69 0 208-93.31 208-208 0-103.81-76.45-190.1-176-205.54z"}}]})(props);
	};
	module.exports.IoPieChart = function IoPieChart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M66.1 357a16 16 0 01-14.61-9.46A224 224 0 01256 32a16 16 0 0116 16v208a16 16 0 01-9.47 14.61l-189.9 84.95A15.93 15.93 0 0166.1 357z"}},{"tag":"path","attr":{"d":"M313.59 68.18A8 8 0 00304 76v180a48.07 48.07 0 01-28.4 43.82L103.13 377a8 8 0 00-3.35 11.81 208.42 208.42 0 0048.46 50.41A206.32 206.32 0 00272 480c114.69 0 208-93.31 208-208 0-100.45-71.58-184.5-166.41-203.82z"}}]})(props);
	};
	module.exports.IoPinOutline = function IoPinOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"96","r":"64","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"d":"M272 164a9 9 0 00-9-9h-14a9 9 0 00-9 9v293.56a32.09 32.09 0 002.49 12.38l10.07 24a3.92 3.92 0 006.88 0l10.07-24a32.09 32.09 0 002.49-12.38z"}},{"tag":"circle","attr":{"cx":"280","cy":"72","r":"24"}}]})(props);
	};
	module.exports.IoPinSharp = function IoPinSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M339 99a83 83 0 10-102 80.8V464l19 32 19-32V179.8A83.28 83.28 0 00339 99zm-59-6a21 21 0 1121-21 21 21 0 01-21 21z"}}]})(props);
	};
	module.exports.IoPin = function IoPin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 96a80 80 0 10-96 78.39v283.17a32.09 32.09 0 002.49 12.38l10.07 24a3.92 3.92 0 006.88 0l10.07-24a32.09 32.09 0 002.49-12.38V174.39A80.13 80.13 0 00336 96zm-56 0a24 24 0 1124-24 24 24 0 01-24 24z"}}]})(props);
	};
	module.exports.IoPintOutline = function IoPintOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M132.43 162c-6.24-34-4.49-45.55-3.07-68.39L132.27 47a16 16 0 0115.94-15h215.57a16 16 0 0115.94 15l2.91 46.61c1.43 22.86 3.19 34.39-3.06 68.45-5.93 32.29-43.71 133.27-43.71 238.32V472a8 8 0 01-8 8H184.12a8 8 0 01-8-8v-71.63c.01-92.47-37.46-204.3-43.69-238.37zm2.78-66h241.58"}}]})(props);
	};
	module.exports.IoPintSharp = function IoPintSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M399 99.29L394 16H118.45L113 99.26c-1.29 19.24-2.23 33.14 3.73 65.66 1.67 9.11 5.22 22.66 9.73 39.82 12.61 48 33.71 128.36 33.71 195.63V496h191.68v-95.62c0-77.09 21.31-153.29 34-198.81 4.38-15.63 7.83-28 9.41-36.62 6.01-32.51 5.07-46.42 3.74-65.66zM146.23 80l2-32h215.52l2 32z"}}]})(props);
	};
	module.exports.IoPint = function IoPint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M399 99.29c-.15-2.13-.3-4.35-.44-6.68L395.69 46a32 32 0 00-31.91-30H148.21a32 32 0 00-31.91 30l-2.91 46.63c-.14 2.31-.29 4.51-.43 6.62-1.29 19.24-2.23 33.14 3.73 65.66 1.67 9.11 5.22 22.66 9.73 39.82 12.61 48 33.71 128.36 33.71 195.63V472a24 24 0 0024 24h143.74a24 24 0 0024-24v-71.62c0-77.09 21.31-153.29 34-198.81 4.38-15.63 7.83-28 9.41-36.62 5.99-32.51 5.05-46.42 3.72-65.66zm-35-47.54l1.5 24a4 4 0 01-4 4.25h-211a4 4 0 01-4-4.25l1.48-24A4 4 0 01152 48h208a4 4 0 014 3.75z"}}]})(props);
	};
	module.exports.IoPizzaOutline = function IoPizzaOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M404.76 123.08C358.37 104.18 309.69 96 256 96s-106.1 9-148.9 26.68c-8.08 3.3-15.26 9-10.07 19.5C101.24 150.71 203 375 241.66 455a15.94 15.94 0 0028.72 0l144.05-312.22c3.19-6.9.9-15.4-9.67-19.7z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M436.38 82.68C384.31 62.08 320.17 48 256 48S128.65 60.78 75.48 82.08C70.79 84 62 88.43 64.41 95.88L74.09 120c4 8.2 8.67 8.2 15.06 8.2 1.79 0 4.29-1 7.28-2.18A442.46 442.46 0 01256 96c56.76 0 114.91 12 159.6 30 3.59 1.4 5.59 2.18 7.28 2.18 6.58 0 10.38 2.19 15-8.1L447.65 96c2.01-6-4.99-10.82-11.27-13.32z"}},{"tag":"circle","attr":{"cx":"192","cy":"192","r":"32"}},{"tag":"circle","attr":{"cx":"320","cy":"208","r":"32"}},{"tag":"circle","attr":{"cx":"256","cy":"320","r":"32"}}]})(props);
	};
	module.exports.IoPizzaSharp = function IoPizzaSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M442.3 67.82C383.92 44.72 317.78 32 256 32c-63.57 0-129.8 12.51-186.56 35.25C49.18 75.48 42 80 42 80l22 44 37.53-16.14C147.58 89.53 199.19 80 256.51 80c57.49 0 108.09 9.23 154.75 28.25L448 124l22-44s-7-4-27.7-12.18z"}},{"tag":"ellipse","attr":{"cx":"320.48","cy":"207.99","fill":"none","rx":"31.97","ry":"32.03","transform":"rotate(-44.98 320.503 207.996)"}},{"tag":"ellipse","attr":{"cx":"192.48","cy":"191.99","fill":"none","rx":"31.97","ry":"32.03","transform":"rotate(-44.98 192.49 191.992)"}},{"tag":"ellipse","attr":{"cx":"256.48","cy":"319.99","fill":"none","rx":"31.97","ry":"32.03","transform":"rotate(-44.98 256.505 320)"}},{"tag":"path","attr":{"d":"M409.66 140.85C364.15 122.52 308.16 112 256 112a425 425 0 00-153.7 28.9c-.25.1-9.24 4.23-19 8.71 7.46 16.22 18 39.16 22.2 48.33L256 480l173.74-330.84-19.92-8.24zm-185.25 53.22a32 32 0 11-34-34 32.12 32.12 0 0134 34zm64 128a32 32 0 11-34-34 32.12 32.12 0 0134 34zm64-112a32 32 0 11-34-34 32.12 32.12 0 0134 34z"}}]})(props);
	};
	module.exports.IoPizza = function IoPizza (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M441.82 67.83C383.44 44.73 317.3 32 255.56 32 192 32 125.76 44.53 69 67.26 48.7 75.49 45.21 90 48.71 100.82L52.78 111a16 16 0 0021.31 8.69c10.8-4.76 23.93-10.54 27-11.78C145.1 89.64 198.71 80 256 80c57.47 0 108.09 9.24 154.76 28.25 4.42 1.8 14.88 6.42 26.17 11.46a16 16 0 0021.35-8.59L462 102l.34-.9c3.45-10.21.14-25.05-20.52-33.27z"}},{"tag":"path","attr":{"d":"M409.18 140.86C363.67 122.53 307.68 112 255.56 112a425 425 0 00-153.74 28.89c-.53.21-2.06.88-4.29 1.88a16 16 0 00-8 21.27c4 8.71 9.42 20.58 15.5 33.89C137.94 270 199.21 404 227.26 462A31.74 31.74 0 00256 480a31.73 31.73 0 0028.76-18.06l.06-.13 137.3-297.57a15.94 15.94 0 00-8.31-21.45c-2.26-.95-3.85-1.61-4.5-1.87zm-215.1 83.07a32 32 0 1129.85-29.85 32 32 0 01-29.85 29.85zm64 128a32 32 0 1129.85-29.85 32 32 0 01-29.85 29.85zm64-112a32 32 0 1129.85-29.85 32 32 0 01-29.85 29.85z"}}]})(props);
	};
	module.exports.IoPlanetOutline = function IoPlanetOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M413.48 284.46c58.87 47.24 91.61 89 80.31 108.55-17.85 30.85-138.78-5.48-270.1-81.15S.37 149.84 18.21 119c11.16-19.28 62.58-12.32 131.64 14.09"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"160","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoPlanetSharp = function IoPlanetSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M81 274.71C90.36 363 165.26 432 256 432a174.91 174.91 0 0071.49-15.19c-40.3-16.53-84.05-38.17-127.77-63.36C157 328.86 115.84 301.5 81 274.71zm411.72 64.8c-8.5-11.31-20-23.8-34-37a205.25 205.25 0 01-11 34c28.72 29.5 33.2 45.34 32.17 48.45-2 2.23-17.05 6.89-58.15-3.53q-8.83-2.24-19.32-5.46-6.76-2.08-13.79-4.49a176.76 176.76 0 0019.54-27.25c.17-.29.35-.58.52-.88A175.39 175.39 0 00432 256a178.87 178.87 0 00-1-19c-9.57-88.17-84.4-157-175-157a175.37 175.37 0 00-106.4 35.89 177.4 177.4 0 00-45.83 51.84c-.16.29-.34.58-.51.87a175.48 175.48 0 00-13.83 30.52q-5.59-4.87-10.79-9.67c-5.39-5-10.17-9.63-14.42-14-29.57-30.26-33.09-45.61-32.16-48.45 2.16-2.43 18.1-6.54 58.13 3.55a209.88 209.88 0 0124-26.56c-18.86-5.61-35.79-9.35-50.05-11C33.41 89.47 13.3 95.52 4.35 111c-3.24 5.58-6.35 15.09-2.72 28.6C7 159.66 26.14 184 53.23 209.5c8.63 8.13 18.06 16.37 28.12 24.64 7.32 6 15 12.06 22.9 18.08q7.91 6 16.15 12T137.1 276c25.41 17.61 52.26 34.52 78.59 49.69q14.34 8.26 28.64 16t28.37 14.81c21.9 11 43.35 20.92 63.86 29.43q13.19 5.48 25.81 10.16c11.89 4.42 23.37 8.31 34.31 11.59l1.1.33c25.73 7.66 47.42 11.69 64.48 12H464c21.64 0 36.3-6.38 43.58-19 9.09-15.62 4.08-36.32-14.86-61.5z"}}]})(props);
	};
	module.exports.IoPlanet = function IoPlanet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96.85 286.62a8 8 0 00-12.53 8.25C102.07 373.28 172.3 432 256 432a175.31 175.31 0 0052.41-8 8 8 0 00.79-15 1120 1120 0 01-109.48-55.61 1126.24 1126.24 0 01-102.87-66.77zm395.87 52.89c-4.19-5.58-9.11-11.44-14.7-17.53a15.83 15.83 0 00-26.56 5.13c0 .16-.11.31-.17.47a15.75 15.75 0 003.15 16.06c22.74 25 26.42 38.51 25.48 41.36-2 2.23-17.05 6.89-58.15-3.53q-8.83-2.24-19.32-5.46-6.76-2.08-13.79-4.49a176.76 176.76 0 0019.54-27.25c.17-.29.35-.58.52-.88A175.39 175.39 0 00432 256a178.87 178.87 0 00-1-19c-9.57-88.17-84.4-157-175-157a175.37 175.37 0 00-106.4 35.89 177.4 177.4 0 00-45.83 51.84c-.16.29-.34.58-.51.87a175.48 175.48 0 00-13.83 30.52q-5.59-4.87-10.79-9.67c-5.39-5-10.17-9.63-14.42-14-29.57-30.26-33.09-45.61-32.16-48.45 2-2.23 15.54-5.87 48.62 1.31A15.82 15.82 0 0096.22 123l.36-.44a15.74 15.74 0 00-8.67-25.43A237.38 237.38 0 0064.13 93c-30.72-3.53-50.83 2.52-59.78 18-3.24 5.58-6.35 15.09-2.72 28.6C7 159.66 26.14 184 53.23 209.5c8.63 8.13 18.06 16.37 28.12 24.64 7.32 6 15 12.06 22.9 18.08q7.91 6 16.15 12T137.1 276c25.41 17.61 52.26 34.52 78.59 49.69q14.34 8.26 28.64 16t28.37 14.81c21.9 11 43.35 20.92 63.86 29.43q13.19 5.48 25.81 10.16c11.89 4.42 23.37 8.31 34.31 11.59l1.1.33c25.73 7.66 47.42 11.69 64.48 12H464c21.64 0 36.3-6.38 43.58-19 9.09-15.62 4.08-36.32-14.86-61.5z"}}]})(props);
	};
	module.exports.IoPlayBackCircleOutline = function IoPlayBackCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z"}},{"tag":"path","attr":{"d":"M117.23 246.7l114.45-69.14a10.78 10.78 0 0116.32 9.31v53.32l103.68-62.63a10.78 10.78 0 0116.32 9.31v138.26a10.78 10.78 0 01-16.32 9.31L248 271.81v53.32a10.78 10.78 0 01-16.32 9.31L117.23 265.3a10.89 10.89 0 010-18.6z"}}]})(props);
	};
	module.exports.IoPlayBackCircleSharp = function IoPlayBackCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm63.47 0L248 168v72.16l120-72.48v176.45l-120-72.32v71.44z"}}]})(props);
	};
	module.exports.IoPlayBackCircle = function IoPlayBackCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm69.23-9.3l114.45-69.14a10.78 10.78 0 0116.32 9.31v53.32l103.68-62.63a10.78 10.78 0 0116.32 9.31v138.26a10.78 10.78 0 01-16.32 9.31L248 271.81v53.32a10.78 10.78 0 01-16.32 9.31L117.23 265.3a10.89 10.89 0 010-18.6z"}}]})(props);
	};
	module.exports.IoPlayBackOutline = function IoPlayBackOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M480 145.52v221c0 13.28-13 21.72-23.63 15.35L267.5 268.8c-9.24-5.53-9.24-20.07 0-25.6l188.87-113C467 123.8 480 132.24 480 145.52zm-228.57 0v221c0 13.28-13 21.72-23.63 15.35L38.93 268.8c-9.24-5.53-9.24-20.07 0-25.6l188.87-113c10.64-6.4 23.63 2.04 23.63 15.32z"}}]})(props);
	};
	module.exports.IoPlayBackSharp = function IoPlayBackSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 400L256 256l240-144v288zm-240 0L16 256l240-144v288z"}}]})(props);
	};
	module.exports.IoPlayBack = function IoPlayBack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M30.71 229.47l188.87-113a30.54 30.54 0 0131.09-.39 33.74 33.74 0 0116.76 29.47v79.05l180.72-108.16a30.54 30.54 0 0131.09-.39A33.74 33.74 0 01496 145.52v221A33.73 33.73 0 01479.24 396a30.54 30.54 0 01-31.09-.39L267.43 287.4v79.08A33.73 33.73 0 01250.67 396a30.54 30.54 0 01-31.09-.39l-188.87-113a31.27 31.27 0 010-53z"}}]})(props);
	};
	module.exports.IoPlayCircleOutline = function IoPlayCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"d":"M216.32 334.44l114.45-69.14a10.89 10.89 0 000-18.6l-114.45-69.14a10.78 10.78 0 00-16.32 9.31v138.26a10.78 10.78 0 0016.32 9.31z"}}]})(props);
	};
	module.exports.IoPlayCircleSharp = function IoPlayCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-56 296V168l144 88z"}}]})(props);
	};
	module.exports.IoPlayCircle = function IoPlayCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm74.77 217.3l-114.45 69.14a10.78 10.78 0 01-16.32-9.31V186.87a10.78 10.78 0 0116.32-9.31l114.45 69.14a10.89 10.89 0 010 18.6z"}}]})(props);
	};
	module.exports.IoPlayForwardCircleOutline = function IoPlayForwardCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"d":"M394.77 246.7l-114.45-69.14a10.78 10.78 0 00-16.32 9.31v53.32l-103.68-62.63a10.78 10.78 0 00-16.32 9.31v138.26a10.78 10.78 0 0016.32 9.31L264 271.81v53.32a10.78 10.78 0 0016.32 9.31l114.45-69.14a10.89 10.89 0 000-18.6z"}}]})(props);
	};
	module.exports.IoPlayForwardCircleSharp = function IoPlayForwardCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm8 295.25v-71.44l-120 72.32V167.71l120 72.48V168l136.53 88z"}}]})(props);
	};
	module.exports.IoPlayForwardCircle = function IoPlayForwardCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm138.77 217.3l-114.45 69.14a10.78 10.78 0 01-16.32-9.31v-53.32l-103.68 62.63a10.78 10.78 0 01-16.32-9.31V186.87a10.78 10.78 0 0116.32-9.31L264 240.19v-53.32a10.78 10.78 0 0116.32-9.31l114.45 69.14a10.89 10.89 0 010 18.6z"}}]})(props);
	};
	module.exports.IoPlayForwardOutline = function IoPlayForwardOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M32 145.52v221c0 13.28 13 21.72 23.63 15.35l188.87-113c9.24-5.53 9.24-20.07 0-25.6l-188.87-113C45 123.8 32 132.24 32 145.52zm228.57 0v221c0 13.28 13 21.72 23.63 15.35l188.87-113c9.24-5.53 9.24-20.07 0-25.6l-188.87-113c-10.64-6.47-23.63 1.97-23.63 15.25z"}}]})(props);
	};
	module.exports.IoPlayForwardSharp = function IoPlayForwardSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16 400l240-144L16 112v288zm240 0l240-144-240-144v288z"}}]})(props);
	};
	module.exports.IoPlayForward = function IoPlayForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M481.29 229.47l-188.87-113a30.54 30.54 0 00-31.09-.39 33.74 33.74 0 00-16.76 29.47v79.05L63.85 116.44a30.54 30.54 0 00-31.09-.39A33.74 33.74 0 0016 145.52v221A33.74 33.74 0 0032.76 396a30.54 30.54 0 0031.09-.39L244.57 287.4v79.08A33.74 33.74 0 00261.33 396a30.54 30.54 0 0031.09-.39l188.87-113a31.27 31.27 0 000-53z"}}]})(props);
	};
	module.exports.IoPlayOutline = function IoPlayOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M112 111v290c0 17.44 17 28.52 31 20.16l247.9-148.37c12.12-7.25 12.12-26.33 0-33.58L143 90.84c-14-8.36-31 2.72-31 20.16z"}}]})(props);
	};
	module.exports.IoPlaySharp = function IoPlaySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 448l320-192L96 64v384z"}}]})(props);
	};
	module.exports.IoPlaySkipBackCircleOutline = function IoPlaySkipBackCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z"}},{"tag":"path","attr":{"d":"M192 176a16 16 0 0116 16v53l111.68-67.46a10.78 10.78 0 0116.32 9.33v138.26a10.78 10.78 0 01-16.32 9.31L208 267v53a16 16 0 01-32 0V192a16 16 0 0116-16z"}}]})(props);
	};
	module.exports.IoPlaySkipBackCircleSharp = function IoPlaySkipBackCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm128-80h32v69l128-77.53v176.9L208 267v69h-32z"}}]})(props);
	};
	module.exports.IoPlaySkipBackCircle = function IoPlaySkipBackCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm128-64a16 16 0 0132 0v53l111.68-67.46a10.78 10.78 0 0116.32 9.33v138.26a10.78 10.78 0 01-16.32 9.31L208 267v53a16 16 0 01-32 0z"}}]})(props);
	};
	module.exports.IoPlaySkipBackOutline = function IoPlaySkipBackOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M400 111v290c0 17.44-17 28.52-31 20.16L121.09 272.79c-12.12-7.25-12.12-26.33 0-33.58L369 90.84c14-8.36 31 2.72 31 20.16z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M112 80v352"}}]})(props);
	};
	module.exports.IoPlaySkipBackSharp = function IoPlaySkipBackSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M143.47 64v163.52L416 64v384L143.47 284.48V448H96V64h47.47z"}}]})(props);
	};
	module.exports.IoPlaySkipBack = function IoPlaySkipBack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M112 64a16 16 0 0116 16v136.43L360.77 77.11a35.13 35.13 0 0135.77-.44c12 6.8 19.46 20 19.46 34.33v290c0 14.37-7.46 27.53-19.46 34.33a35.14 35.14 0 01-35.77-.45L128 295.57V432a16 16 0 01-32 0V80a16 16 0 0116-16z"}}]})(props);
	};
	module.exports.IoPlaySkipForwardCircleOutline = function IoPlaySkipForwardCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"d":"M320 176a16 16 0 00-16 16v53l-111.68-67.44a10.78 10.78 0 00-16.32 9.31v138.26a10.78 10.78 0 0016.32 9.31L304 267v53a16 16 0 0032 0V192a16 16 0 00-16-16z"}}]})(props);
	};
	module.exports.IoPlaySkipForwardCircleSharp = function IoPlaySkipForwardCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 288h-32v-69l-128 77.37V167.49L304 245v-69h32z"}}]})(props);
	};
	module.exports.IoPlaySkipForwardCircle = function IoPlaySkipForwardCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 272a16 16 0 01-32 0v-53l-111.68 67.44a10.78 10.78 0 01-16.32-9.31V186.87a10.78 10.78 0 0116.32-9.31L304 245v-53a16 16 0 0132 0z"}}]})(props);
	};
	module.exports.IoPlaySkipForwardOutline = function IoPlaySkipForwardOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M112 111v290c0 17.44 17 28.52 31 20.16l247.9-148.37c12.12-7.25 12.12-26.33 0-33.58L143 90.84c-14-8.36-31 2.72-31 20.16z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M400 80v352"}}]})(props);
	};
	module.exports.IoPlaySkipForwardSharp = function IoPlaySkipForwardSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368.53 64v163.52L96 64v384l272.53-163.52V448H416V64h-47.47z"}}]})(props);
	};
	module.exports.IoPlaySkipForward = function IoPlaySkipForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 64a16 16 0 00-16 16v136.43L151.23 77.11a35.13 35.13 0 00-35.77-.44C103.46 83.47 96 96.63 96 111v290c0 14.37 7.46 27.53 19.46 34.33a35.14 35.14 0 0035.77-.45L384 295.57V432a16 16 0 0032 0V80a16 16 0 00-16-16z"}}]})(props);
	};
	module.exports.IoPlay = function IoPlay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M133 440a35.37 35.37 0 01-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0135.77.45l247.85 148.36a36 36 0 010 61l-247.89 148.4A35.5 35.5 0 01133 440z"}}]})(props);
	};
	module.exports.IoPodiumOutline = function IoPodiumOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M32 160v296a8 8 0 008 8h136V160a16 16 0 00-16-16H48a16 16 0 00-16 16zM320 48H192a16 16 0 00-16 16v400h160V64a16 16 0 00-16-16zm144 160H352a16 16 0 00-16 16v240h136a8 8 0 008-8V224a16 16 0 00-16-16z"}}]})(props);
	};
	module.exports.IoPodiumSharp = function IoPodiumSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 32h192v448H160zm224 160h112v288H384zM16 128h112v352H16z"}}]})(props);
	};
	module.exports.IoPodium = function IoPodium (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 32H192a32 32 0 00-32 32v412a4 4 0 004 4h184a4 4 0 004-4V64a32 32 0 00-32-32zm144 160h-72a8 8 0 00-8 8v272a8 8 0 008 8h80a24 24 0 0024-24V224a32 32 0 00-32-32zM48 128a32 32 0 00-32 32v296a24 24 0 0024 24h80a8 8 0 008-8V136a8 8 0 00-8-8z"}}]})(props);
	};
	module.exports.IoPowerOutline = function IoPowerOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M378 108a191.41 191.41 0 0170 148c0 106-86 192-192 192S64 362 64 256a192 192 0 0169-148m123-44v192"}}]})(props);
	};
	module.exports.IoPowerSharp = function IoPowerSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c-114.69 0-208-93.23-208-207.82a207.44 207.44 0 0174.76-160.13l16.9-14 28.17 33.72-16.9 14A163.72 163.72 0 0092 256.18c0 90.39 73.57 163.93 164 163.93s164-73.54 164-163.93a163.38 163.38 0 00-59.83-126.36l-17-14 28-33.82 17 14A207.13 207.13 0 01464 256.18C464 370.77 370.69 464 256 464z"}},{"tag":"path","attr":{"d":"M234 48h44v224h-44z"}}]})(props);
	};
	module.exports.IoPower = function IoPower (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c-114.69 0-208-93.47-208-208.35 0-62.45 27.25-121 74.76-160.55a22 22 0 1128.17 33.8C113.48 160.1 92 206.3 92 255.65 92 346.27 165.57 420 256 420s164-73.73 164-164.35A164 164 0 00360.17 129a22 22 0 1128-33.92A207.88 207.88 0 01464 255.65C464 370.53 370.69 464 256 464z"}},{"tag":"path","attr":{"d":"M256 272a22 22 0 01-22-22V70a22 22 0 0144 0v180a22 22 0 01-22 22z"}}]})(props);
	};
	module.exports.IoPricetagOutline = function IoPricetagOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M435.25 48h-122.9a14.46 14.46 0 00-10.2 4.2L56.45 297.9a28.85 28.85 0 000 40.7l117 117a28.85 28.85 0 0040.7 0L459.75 210a14.46 14.46 0 004.2-10.2v-123a28.66 28.66 0 00-28.7-28.8z"}},{"tag":"path","attr":{"d":"M384 160a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoPricetagSharp = function IoPricetagSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 32L16 320l176 176 288-288V32zm80 128a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoPricetag = function IoPricetag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M467 45.2A44.45 44.45 0 00435.29 32H312.36a30.63 30.63 0 00-21.52 8.89L45.09 286.59a44.82 44.82 0 000 63.32l117 117a44.83 44.83 0 0063.34 0l245.65-245.6A30.6 30.6 0 00480 199.8v-123a44.24 44.24 0 00-13-31.6zM384 160a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoPricetagsOutline = function IoPricetagsOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M403.29 32H280.36a14.46 14.46 0 00-10.2 4.2L24.4 281.9a28.85 28.85 0 000 40.7l117 117a28.86 28.86 0 0040.71 0L427.8 194a14.46 14.46 0 004.2-10.2v-123A28.66 28.66 0 00403.29 32z"}},{"tag":"path","attr":{"d":"M352 144a32 32 0 1132-32 32 32 0 01-32 32z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M230 480l262-262a13.81 13.81 0 004-10V80"}}]})(props);
	};
	module.exports.IoPricetagsSharp = function IoPricetagsSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 16L0 304l176 176 288-288V16zm80 128a32 32 0 1132-32 32 32 0 01-32 32z"}},{"tag":"path","attr":{"d":"M480 64v144L216.9 471.1 242 496l270-272V64h-32z"}}]})(props);
	};
	module.exports.IoPricetags = function IoPricetags (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 183.8v-123A44.66 44.66 0 00403.29 16H280.36a30.62 30.62 0 00-21.51 8.89L13.09 270.58a44.86 44.86 0 000 63.34l117 117a44.84 44.84 0 0063.33 0l245.69-245.61A30.6 30.6 0 00448 183.8zM352 144a32 32 0 1132-32 32 32 0 01-32 32z"}},{"tag":"path","attr":{"d":"M496 64a16 16 0 00-16 16v127.37L218.69 468.69a16 16 0 1022.62 22.62l262-262A29.84 29.84 0 00512 208V80a16 16 0 00-16-16z"}}]})(props);
	};
	module.exports.IoPrintOutline = function IoPrintOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24"}},{"tag":"rect","attr":{"width":"256","height":"208","x":"128","y":"240","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"24.32","ry":"24.32"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24"}},{"tag":"circle","attr":{"cx":"392","cy":"184","r":"24"}}]})(props);
	};
	module.exports.IoPrintSharp = function IoPrintSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 96V56a8 8 0 00-8-8H120a8 8 0 00-8 8v40"}},{"tag":"rect","attr":{"width":"208","height":"160","x":"152","y":"264","fill":"none","rx":"4","ry":"4"}},{"tag":"rect","attr":{"width":"208","height":"160","x":"152","y":"264","fill":"none","rx":"4","ry":"4"}},{"tag":"path","attr":{"d":"M408 112H104a56 56 0 00-56 56v208a8 8 0 008 8h56v72a8 8 0 008 8h272a8 8 0 008-8v-72h56a8 8 0 008-8V168a56 56 0 00-56-56zm-48 308a4 4 0 01-4 4H156a4 4 0 01-4-4V268a4 4 0 014-4h200a4 4 0 014 4zm34-212.08a24 24 0 1122-22 24 24 0 01-22 22z"}}]})(props);
	};
	module.exports.IoPrint = function IoPrint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408 112H106a58 58 0 00-58 58v158a56 56 0 0056 56h8v39.68A40.32 40.32 0 00152.32 464h207.36A40.32 40.32 0 00400 423.68V384h8a56 56 0 0056-56V168a56 56 0 00-56-56zm-40 311.68a8.35 8.35 0 01-8.32 8.32H152.32a8.35 8.35 0 01-8.32-8.32V264.32a8.35 8.35 0 018.32-8.32h207.36a8.35 8.35 0 018.32 8.32zm26-215.76a24 24 0 1122-22 24 24 0 01-22 22zM344 48H168a56.09 56.09 0 00-55.42 48h286.84A56.09 56.09 0 00344 48z"}}]})(props);
	};
	module.exports.IoPrismOutline = function IoPrismOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M229.73 45.88L37.53 327.79a31.79 31.79 0 0011.31 46L241 476.26a31.77 31.77 0 0029.92 0l192.2-102.51a31.79 31.79 0 0011.31-46L282.27 45.88a31.8 31.8 0 00-52.54 0zM256 32v448"}}]})(props);
	};
	module.exports.IoPrismSharp = function IoPrismSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 16L16 352l240 144 240-144zm-20 96.82v324.53L73.73 340z"}}]})(props);
	};
	module.exports.IoPrism = function IoPrism (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M487.83 319.44L295.63 36.88a48 48 0 00-79.26 0L24.17 319.44a47.1 47.1 0 0016.93 68.13l192.2 102.75a48.05 48.05 0 0045.4 0l192.2-102.75a47.1 47.1 0 0016.93-68.13zm-431.26 41a16.12 16.12 0 01-8-10.38 16.8 16.8 0 012.37-13.62L232.66 69.26c2.18-3.21 7.34-1.72 7.34 2.13v374c0 5.9-6.54 9.63-11.87 6.78z"}}]})(props);
	};
	module.exports.IoPulseOutline = function IoPulseOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 320h64l64-256 64 384 64-224 32 96h64"}},{"tag":"circle","attr":{"cx":"432","cy":"320","r":"32","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoPulseSharp = function IoPulseSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426 266a54.07 54.07 0 00-49.3 32h-24.84l-27-81a22 22 0 00-42 .92l-37.2 130.2-48-281.74a22 22 0 00-43-1.72L94.82 298H32v44h80a22 22 0 0021.34-16.66L171.69 172l46.61 273.62A22 22 0 00238.76 464H240a22 22 0 0021.15-16l44.47-149.62 9.51 28.62A22 22 0 00336 342h40.7a54 54 0 1049.3-76z"}}]})(props);
	};
	module.exports.IoPulse = function IoPulse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 272a48.09 48.09 0 00-45.25 32h-39.22l-28.35-85.06a16 16 0 00-30.56.66l-44.51 155.76-52.33-314a16 16 0 00-31.3-1.25L99.51 304H48a16 16 0 000 32h64a16 16 0 0015.52-12.12l45.34-181.37 51.36 308.12A16 16 0 00239.1 464h.91a16 16 0 0015.37-11.6l49.8-174.28 15.64 46.94A16 16 0 00336 336h50.75A48 48 0 10432 272z"}}]})(props);
	};
	module.exports.IoPushOutline = function IoPushOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M336 336h40a40 40 0 0040-40V88a40 40 0 00-40-40H136a40 40 0 00-40 40v208a40 40 0 0040 40h40"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 240l80-80 80 80m-80 224V176"}}]})(props);
	};
	module.exports.IoPushSharp = function IoPushSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 352V204.63l64 64L358.63 246 256 143.37 153.37 246 176 268.63l64-64V352H92a12 12 0 01-12-12V44a12 12 0 0112-12h328a12 12 0 0112 12v296a12 12 0 01-12 12zm-32 0h32v128h-32z"}}]})(props);
	};
	module.exports.IoPush = function IoPush (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 352H272V198.63l52.69 52.68a16 16 0 0022.62-22.62l-80-80a16 16 0 00-22.62 0l-80 80a16 16 0 0022.62 22.62L240 198.63V352H136a56.06 56.06 0 01-56-56V88a56.06 56.06 0 0156-56h240a56.06 56.06 0 0156 56v208a56.06 56.06 0 01-56 56zM272 464a16 16 0 01-32 0V352h32z"}}]})(props);
	};
	module.exports.IoQrCodeOutline = function IoQrCodeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"80","height":"80","x":"336","y":"336","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"64","height":"64","x":"272","y":"272","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"64","height":"64","x":"416","y":"416","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"48","height":"48","x":"432","y":"272","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"48","height":"48","x":"272","y":"432","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"336","y":"96","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"176","height":"176","x":"288","y":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"16","ry":"16"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"96","y":"96","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"176","height":"176","x":"48","y":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"16","ry":"16"}},{"tag":"rect","attr":{"width":"80","height":"80","x":"96","y":"336","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"176","height":"176","x":"48","y":"288","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"16","ry":"16"}}]})(props);
	};
	module.exports.IoQrCodeSharp = function IoQrCodeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 336h80v80h-80zm-64-64h64v64h-64zm144 144h64v64h-64zm16-144h48v48h-48zM272 432h48v48h-48zm64-336h80v80h-80z"}},{"tag":"path","attr":{"d":"M480 240H272V32h208zm-164-44h120V76H316zM96 96h80v80H96z"}},{"tag":"path","attr":{"d":"M240 240H32V32h208zM76 196h120V76H76zm20 140h80v80H96z"}},{"tag":"path","attr":{"d":"M240 480H32V272h208zM76 436h120V316H76z"}}]})(props);
	};
	module.exports.IoQrCode = function IoQrCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"80","height":"80","x":"336","y":"336","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"64","height":"64","x":"272","y":"272","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"64","height":"64","x":"416","y":"416","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"48","height":"48","x":"432","y":"272","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"48","height":"48","x":"272","y":"432","rx":"8","ry":"8"}},{"tag":"path","attr":{"d":"M448 32H304a32 32 0 00-32 32v144a32 32 0 0032 32h144a32 32 0 0032-32V64a32 32 0 00-32-32zm-32 136a8 8 0 01-8 8h-64a8 8 0 01-8-8v-64a8 8 0 018-8h64a8 8 0 018 8zM208 32H64a32 32 0 00-32 32v144a32 32 0 0032 32h144a32 32 0 0032-32V64a32 32 0 00-32-32zm-32 136a8 8 0 01-8 8h-64a8 8 0 01-8-8v-64a8 8 0 018-8h64a8 8 0 018 8zm32 104H64a32 32 0 00-32 32v144a32 32 0 0032 32h144a32 32 0 0032-32V304a32 32 0 00-32-32zm-32 136a8 8 0 01-8 8h-64a8 8 0 01-8-8v-64a8 8 0 018-8h64a8 8 0 018 8z"}}]})(props);
	};
	module.exports.IoRadioButtonOffOutline = function IoRadioButtonOffOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoRadioButtonOffSharp = function IoRadioButtonOffSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoRadioButtonOff = function IoRadioButtonOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
	};
	module.exports.IoRadioButtonOnOutline = function IoRadioButtonOnOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"144"}}]})(props);
	};
	module.exports.IoRadioButtonOnSharp = function IoRadioButtonOnSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"144"}}]})(props);
	};
	module.exports.IoRadioButtonOn = function IoRadioButtonOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"144"}}]})(props);
	};
	module.exports.IoRadioOutline = function IoRadioOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256.02","r":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M184.25 192.25a96 96 0 000 127.52m143.52 0a96 96 0 000-127.52m-194.49-50.97a168 168 0 000 229.44m245.44 0a168 168 0 000-229.44M435 416a240.34 240.34 0 000-320M77 96a240.34 240.34 0 000 320"}}]})(props);
	};
	module.exports.IoRadioSharp = function IoRadioSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"ellipse","attr":{"cx":"256","cy":"256","rx":"36","ry":"35.99"}},{"tag":"path","attr":{"d":"M188.4 350.8l-14.62-16.44a117.91 117.91 0 010-156.71l14.62-16.43 32.87 29.24-14.62 16.43a73.93 73.93 0 000 98.25l14.62 16.44zm135.2 0l-32.89-29.22 14.62-16.44a73.93 73.93 0 000-98.25l-14.62-16.43 32.87-29.24 14.62 16.43a117.91 117.91 0 010 156.71z"}},{"tag":"path","attr":{"d":"M138.24 401.76l-15-16.06a189.85 189.85 0 010-259.4l15-16.07 32.14 30.05-15 16.06a145.88 145.88 0 000 199.32l15 16.06zm235.52 0l-32.14-30 15-16.06a145.88 145.88 0 000-199.32l-15-16.06 32.14-30 15 16.07a189.85 189.85 0 010 259.4z"}},{"tag":"path","attr":{"d":"M430.73 447l-32.79-29.33 14.66-16.39a218.2 218.2 0 000-290.56l-14.67-16.38L430.72 65l14.67 16.39a262.18 262.18 0 010 349.22zm-349.46 0L66.6 430.61a262.18 262.18 0 010-349.22L81.28 65l32.79 29.34-14.68 16.38a218.2 218.2 0 000 290.56l14.66 16.39z"}}]})(props);
	};
	module.exports.IoRadio = function IoRadio (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"36"}},{"tag":"path","attr":{"d":"M190.24 341.77a22 22 0 01-16.46-7.38 118 118 0 010-156.76 22 22 0 1132.87 29.24 74 74 0 000 98.29 22 22 0 01-16.43 36.61zm131.52 0a22 22 0 01-16.43-36.61 74 74 0 000-98.29 22 22 0 1132.87-29.24 118 118 0 010 156.76 22 22 0 01-16.44 7.38z"}},{"tag":"path","attr":{"d":"M139.29 392.72a21.92 21.92 0 01-16.08-7 190 190 0 010-259.49 22 22 0 1132.13 30.06 146 146 0 000 199.38 22 22 0 01-16.06 37zm233.42 0a22 22 0 01-16.06-37 146 146 0 000-199.38 22 22 0 1132.13-30.06 190 190 0 010 259.49 21.92 21.92 0 01-16.07 6.95z"}},{"tag":"path","attr":{"d":"M429 438a22 22 0 01-16.39-36.67 218.34 218.34 0 000-290.66 22 22 0 0132.78-29.34 262.34 262.34 0 010 349.34A22 22 0 01429 438zm-346 0a21.94 21.94 0 01-16.41-7.33 262.34 262.34 0 010-349.34 22 22 0 0132.78 29.34 218.34 218.34 0 000 290.66A22 22 0 0183 438z"}}]})(props);
	};
	module.exports.IoRainyOutline = function IoRainyOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M114.61 162.85A16.07 16.07 0 00128 149.6C140.09 76.17 193.63 32 256 32c57.93 0 96.62 37.75 112.2 77.74a15.84 15.84 0 0012.2 9.87c50 8.15 91.6 41.54 91.6 99.59 0 59.4-48.6 100.8-108 100.8H130c-49.5 0-90-24.7-90-79.2 0-48.47 38.67-72.22 74.61-77.95z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M144 384l-32 48m112-48l-64 96m144-96l-32 48m112-48l-64 96"}}]})(props);
	};
	module.exports.IoRainySharp = function IoRainySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M364 336H130c-29.5 0-54.92-7.83-73.53-22.64C35.23 296.44 24 271.35 24 240.8c0-26.66 10.08-49.8 29.14-66.91 15.24-13.68 36.17-23.21 59-26.84.06 0 .08 0 .09-.05 6.44-39 23.83-72.09 50.31-95.68A140.24 140.24 0 01256 16c30.23 0 58.48 9.39 81.71 27.17a142.69 142.69 0 0145.36 60.66c29.41 4.82 54.72 17.11 73.19 35.54C477 160.11 488 187.71 488 219.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm19-232.18zM93.82 430.422l49.75-74.626 26.626 17.75-49.751 74.627zm47.996 48.007L223.568 355.8l26.625 17.75-81.751 122.628zm111.995-48.005l49.751-74.626 26.626 17.75-49.751 74.627zm47.997 48.006l81.752-122.627 26.625 17.75-81.751 122.628z"}}]})(props);
	};
	module.exports.IoRainy = function IoRainy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456.26 139.37c-16.77-16.73-39.17-28.41-65.17-34a16 16 0 01-11.19-9 142.24 142.24 0 00-42.19-53.21C314.48 25.39 286.23 16 256 16a140.24 140.24 0 00-93.5 35.32c-24.2 21.56-40.91 51.34-48.43 85.83a16.05 16.05 0 01-11.72 12.18c-25 6.3-35.71 12.54-49.21 24.56C34 190.93 24 214.14 24 240.8c0 30.55 11.23 55.64 32.47 72.56C75.08 328.17 100.5 336 130 336h234c33.2 0 64.11-11.46 87-32.28 23.84-21.65 37-51.67 37-84.52 0-31.49-11-59.09-31.74-79.83zM112 448a16 16 0 01-13.3-24.88l32-48a16 16 0 0126.62 17.76l-32 48A16 16 0 01112 448zm48 48a16 16 0 01-13.29-24.88l64-96a16 16 0 0126.62 17.76l-64 96A16 16 0 01160 496zm112-48a16 16 0 01-13.3-24.88l32-48a16 16 0 0126.62 17.76l-32 48A16 16 0 01272 448zm48 48a16 16 0 01-13.3-24.88l64-96a16 16 0 0126.62 17.76l-64 96A16 16 0 01320 496z"}}]})(props);
	};
	module.exports.IoReaderOutline = function IoReaderOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"320","height":"416","x":"96","y":"48","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 128h160m-160 80h160m-160 80h80"}}]})(props);
	};
	module.exports.IoReaderSharp = function IoReaderSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 44v424a12 12 0 0012 12h328a12 12 0 0012-12V44a12 12 0 00-12-12H92a12 12 0 00-12 12zm192 260H160v-32h112zm80-80H160v-32h192zm0-80H160v-32h192z"}}]})(props);
	};
	module.exports.IoReader = function IoReader (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 32H144a64.07 64.07 0 00-64 64v320a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V96a64.07 64.07 0 00-64-64zM256 304h-80a16 16 0 010-32h80a16 16 0 010 32zm80-80H176a16 16 0 010-32h160a16 16 0 010 32zm0-80H176a16 16 0 010-32h160a16 16 0 010 32z"}}]})(props);
	};
	module.exports.IoReceiptOutline = function IoReceiptOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M160 336V48l32 16 32-16 31.94 16 32.37-16L320 64l31.79-16 31.93 16L416 48l32.01 16L480 48v224"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M480 272v112a80 80 0 01-80 80h0a80 80 0 01-80-80v-48H48a15.86 15.86 0 00-16 16c0 64 6.74 112 80 112h288"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M224 144h192m-128 80h128"}}]})(props);
	};
	module.exports.IoReceiptSharp = function IoReceiptSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 48l-32-16-32 16-32-16-32 16-32-16-32 16-32-16-32 16-48-16v256.05h224V424c0 30.93 33.07 56 64 56h12c30.93 0 52-25.07 52-56V32zM272.5 240l-.5-32h159.5l.5 32zm-64-80l-.5-32h223.5l.5 32z"}},{"tag":"path","attr":{"d":"M336 424V320H16v32c0 50.55 5.78 71.62 14.46 87.63C45.19 466.8 71.86 480 112 480h256s-32-20-32-56z"}}]})(props);
	};
	module.exports.IoReceipt = function IoReceipt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M483.82 32.45a16.28 16.28 0 00-11.23 1.37L448 46.1l-24.8-12.4a16 16 0 00-14.31 0l-25.11 12.41L359 33.7a16 16 0 00-14.36 0L320 46.07l-24.45-12.34a16 16 0 00-14.35-.06L256 46.12l-24.8-12.43a16.05 16.05 0 00-14.33 0L192 46.1l-24.84-12.41a16 16 0 00-19.36 3.94 16.25 16.25 0 00-3.8 10.65V288l.05.05H336a32 32 0 0132 32V424c0 30.93 33.07 56 64 56h12a52 52 0 0052-52V48a16 16 0 00-12.18-15.55zM416 240H288.5c-8.64 0-16.1-6.64-16.48-15.28A16 16 0 01288 208h127.5c8.64 0 16.1 6.64 16.48 15.28A16 16 0 01416 240zm0-80H224.5c-8.64 0-16.1-6.64-16.48-15.28A16 16 0 01224 128h191.5c8.64 0 16.1 6.64 16.48 15.28A16 16 0 01416 160z"}},{"tag":"path","attr":{"d":"M336 424v-88a16 16 0 00-16-16H48a32.1 32.1 0 00-32 32.05c0 50.55 5.78 71.57 14.46 87.57C45.19 466.79 71.86 480 112 480h245.68a4 4 0 002.85-6.81C351.07 463.7 336 451 336 424z"}}]})(props);
	};
	module.exports.IoRecordingOutline = function IoRecordingOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"128","cy":"256","r":"96","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"384","cy":"256","r":"96","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M128 352h256"}}]})(props);
	};
	module.exports.IoRecordingSharp = function IoRecordingSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 138a117.93 117.93 0 00-91.84 192h-72.32A118 118 0 10128 374h256a118 118 0 000-236zM54 256a74 74 0 1174 74 74.09 74.09 0 01-74-74zm330 74a74 74 0 1174-74 74.09 74.09 0 01-74 74z"}}]})(props);
	};
	module.exports.IoRecording = function IoRecording (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M380.79 144.05c-59.1 1.65-107.12 49.71-108.79 108.81a111.64 111.64 0 0030.36 79.77A2 2 0 01301 336h-90a2 2 0 01-1.44-3.37A111.64 111.64 0 00240 252.86c-1.63-59.1-49.65-107.16-108.75-108.81A112.12 112.12 0 0016 255.53C15.75 317.77 67 368 129.24 368h253.52C445 368 496.25 317.77 496 255.53a112.12 112.12 0 00-115.21-111.48z"}}]})(props);
	};
	module.exports.IoRefreshCircleOutline = function IoRefreshCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"28","d":"M288 193s12.18-6-32-6a80 80 0 1080 80"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"28","d":"M256 149l40 40-40 40"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"}}]})(props);
	};
	module.exports.IoRefreshCircleSharp = function IoRefreshCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.32 48 256c0 114.86 93.14 208 208 208 114.69 0 208-93.31 208-208 0-114.87-93.13-208-208-208zm94 219a94 94 0 11-94-94h4.21l-24-24L256 129.2l59.8 59.8-59.8 59.8-19.8-19.8 27.92-27.92c-2.4-.08-5.12-.08-8.12-.08a66 66 0 1066 66v-14h28z"}}]})(props);
	};
	module.exports.IoRefreshCircle = function IoRefreshCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.32 48 256c0 114.86 93.14 208 208 208 114.69 0 208-93.31 208-208 0-114.87-93.13-208-208-208zm0 313a94 94 0 010-188h4.21l-14.11-14.1a14 14 0 0119.8-19.8l40 40a14 14 0 010 19.8l-40 40a14 14 0 01-19.8-19.8l18-18c-2.38-.1-5.1-.1-8.1-.1a66 66 0 1066 66 14 14 0 0128 0 94.11 94.11 0 01-94 94z"}}]})(props);
	};
	module.exports.IoRefreshOutline = function IoRefreshOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M320 146s24.36-12-64-12a160 160 0 10160 160"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 58l80 80-80 80"}}]})(props);
	};
	module.exports.IoRefreshSharp = function IoRefreshSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M320 146s24.36-12-64-12a160 160 0 10160 160"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 58l80 80-80 80"}}]})(props);
	};
	module.exports.IoRefresh = function IoRefresh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M320 146s24.36-12-64-12a160 160 0 10160 160"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 58l80 80-80 80"}}]})(props);
	};
	module.exports.IoReloadCircleOutline = function IoReloadCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M341.54 197.85l-11.37-13.23a103.37 103.37 0 1022.71 105.84"}},{"tag":"path","attr":{"d":"M367.32 162a8.44 8.44 0 00-6 2.54l-59.54 59.54a8.61 8.61 0 006.09 14.71h59.54a8.62 8.62 0 008.62-8.62v-59.56a8.61 8.61 0 00-8.68-8.63z"}}]})(props);
	};
	module.exports.IoReloadCircleSharp = function IoReloadCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm120 190.77h-89l36.88-36.88-5.6-6.51a87.38 87.38 0 10-62.94 148 87.55 87.55 0 0082.42-58.25l5.37-15.13 30.17 10.67-5.3 15.13a119.4 119.4 0 11-112.62-159.18 118.34 118.34 0 0186.36 36.95l.56.62 4.31 5L376 149.81z"}}]})(props);
	};
	module.exports.IoReloadCircle = function IoReloadCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm120 182.15a8.62 8.62 0 01-8.62 8.62h-59.54a8.61 8.61 0 01-6.09-14.71l22.17-22.17-5.6-6.51a87.38 87.38 0 10-62.94 148 87.55 87.55 0 0082.42-58.25A16 16 0 11368 295.8a119.4 119.4 0 11-112.62-159.18 118.34 118.34 0 0186.36 36.95l.56.62 4.31 5 14.68-14.68a8.44 8.44 0 016-2.54 8.61 8.61 0 018.68 8.63z"}}]})(props);
	};
	module.exports.IoReloadOutline = function IoReloadOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M400 148l-21.12-24.57A191.43 191.43 0 00240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 00181.07-128"}},{"tag":"path","attr":{"d":"M464 97.42V208a16 16 0 01-16 16H337.42c-14.26 0-21.4-17.23-11.32-27.31L436.69 86.1C446.77 76 464 83.16 464 97.42z"}}]})(props);
	};
	module.exports.IoReloadSharp = function IoReloadSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M400 148l-21.12-24.57A191.43 191.43 0 00240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 00181.07-128"}},{"tag":"path","attr":{"d":"M464 68.45V220a4 4 0 01-4 4H308.45a4 4 0 01-2.83-6.83L457.17 65.62a4 4 0 016.83 2.83z"}}]})(props);
	};
	module.exports.IoReload = function IoReload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M400 148l-21.12-24.57A191.43 191.43 0 00240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 00181.07-128"}},{"tag":"path","attr":{"d":"M464 97.42V208a16 16 0 01-16 16H337.42c-14.26 0-21.4-17.23-11.32-27.31L436.69 86.1C446.77 76 464 83.16 464 97.42z"}}]})(props);
	};
	module.exports.IoRemoveCircleOutline = function IoRemoveCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M336 256H176"}}]})(props);
	};
	module.exports.IoRemoveCircleSharp = function IoRemoveCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm96 224H160v-32h192z"}}]})(props);
	};
	module.exports.IoRemoveCircle = function IoRemoveCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 224H176a16 16 0 010-32h160a16 16 0 010 32z"}}]})(props);
	};
	module.exports.IoRemoveOutline = function IoRemoveOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M400 256H112"}}]})(props);
	};
	module.exports.IoRemoveSharp = function IoRemoveSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"32","d":"M400 256H112"}}]})(props);
	};
	module.exports.IoRemove = function IoRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M400 256H112"}}]})(props);
	};
	module.exports.IoReorderFourOutline = function IoReorderFourOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M96 304h320M96 208h320M96 112h320M96 400h320"}}]})(props);
	};
	module.exports.IoReorderFourSharp = function IoReorderFourSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"44","d":"M102 304h308m-308-96h308m-308-96h308M102 400h308"}}]})(props);
	};
	module.exports.IoReorderFour = function IoReorderFour (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"44","d":"M102 304h308m-308-96h308m-308-96h308M102 400h308"}}]})(props);
	};
	module.exports.IoReorderThreeOutline = function IoReorderThreeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M96 256h320M96 176h320M96 336h320"}}]})(props);
	};
	module.exports.IoReorderThreeSharp = function IoReorderThreeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"44","d":"M102 256h308m-308-80h308M102 336h308"}}]})(props);
	};
	module.exports.IoReorderThree = function IoReorderThree (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"44","d":"M102 256h308m-308-80h308M102 336h308"}}]})(props);
	};
	module.exports.IoReorderTwoOutline = function IoReorderTwoOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 304h288m-288-96h288"}}]})(props);
	};
	module.exports.IoReorderTwoSharp = function IoReorderTwoSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"44","d":"M118 304h276m-276-96h276"}}]})(props);
	};
	module.exports.IoReorderTwo = function IoReorderTwo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"44","d":"M118 304h276m-276-96h276"}}]})(props);
	};
	module.exports.IoRepeatOutline = function IoRepeatOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 120l48 48-48 48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 168H144a80.24 80.24 0 00-80 80v16m128 128l-48-48 48-48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 344h208a80.24 80.24 0 0080-80v-16"}}]})(props);
	};
	module.exports.IoRepeatSharp = function IoRepeatSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M320 120l48 48-48 48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M352 168H64v96m128 128l-48-48 48-48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M160 344h288v-96"}}]})(props);
	};
	module.exports.IoRepeat = function IoRepeat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 120l48 48-48 48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 168H144a80.24 80.24 0 00-80 80v16m128 128l-48-48 48-48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M160 344h208a80.24 80.24 0 0080-80v-16"}}]})(props);
	};
	module.exports.IoResizeOutline = function IoResizeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M304 96h112v112m-10.23-101.8L111.98 400.02M208 416H96V304"}}]})(props);
	};
	module.exports.IoResizeSharp = function IoResizeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M304 96h112v112m-10.23-101.8L111.98 400.02M208 416H96V304"}}]})(props);
	};
	module.exports.IoResize = function IoResize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M304 96h112v112m-10.23-101.8L111.98 400.02M208 416H96V304"}}]})(props);
	};
	module.exports.IoRestaurantOutline = function IoRestaurantOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M57.49 47.74l368.43 368.43a37.28 37.28 0 010 52.72h0a37.29 37.29 0 01-52.72 0l-90-91.55a32 32 0 01-9.2-22.43v-5.53a32 32 0 00-9.52-22.78l-11.62-10.73a32 32 0 00-29.8-7.44h0a48.53 48.53 0 01-46.56-12.63l-85.43-85.44C40.39 159.68 21.74 83.15 57.49 47.74z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M400 32l-77.25 77.25A64 64 0 00304 154.51v14.86a16 16 0 01-4.69 11.32L288 192m32 32l11.31-11.31a16 16 0 0111.32-4.69h14.86a64 64 0 0045.26-18.75L480 112m-40-40l-80 80M200 368l-99.72 100.28a40 40 0 01-56.56 0h0a40 40 0 010-56.56L128 328"}}]})(props);
	};
	module.exports.IoRestaurantSharp = function IoRestaurantSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M342.7 223.94h14.87a79.48 79.48 0 0056.58-23.44L496 118l-22.22-22.4-83.58 83.58-17.37-17.37 83.58-83.59-23-22.31-83.27 83.26-17.32-17.37 83.58-83.59L394 16l-82.5 81.85a79.49 79.49 0 00-23.44 56.59v14.86l-43.13 43.13L48 16C3.72 70.87 29.87 171.71 79.72 221.57l85.5 85.5c26.55 26.55 31.82 28.92 61.94 16.8 6.49-2.61 8.85-2.32 14.9 3.72l13 12.13c2.93 3 3 3.88 3 9.62v5.54c0 21.08 13.48 33.2 22.36 42.24L384 496l72-72-156.43-156.93z"}},{"tag":"path","attr":{"d":"M227.37 354.59c-29.82 6.11-48.11 11.74-83.08-23.23-.56-.56-1.14-1.1-1.7-1.66l-19.5-19.5L16 416l80 80 144-144z"}}]})(props);
	};
	module.exports.IoRestaurant = function IoRestaurant (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M357.57 223.94a79.48 79.48 0 0056.58-23.44l77-76.95c6.09-6.09 6.65-16 .85-22.39a16 16 0 00-23.17-.56l-68.63 68.58a12.29 12.29 0 01-17.37 0c-4.79-4.78-4.53-12.86.25-17.64l68.33-68.33a16 16 0 00-.56-23.16A15.62 15.62 0 00440.27 56a16.71 16.71 0 00-11.81 4.9l-68.27 68.26a12.29 12.29 0 01-17.37 0c-4.78-4.78-4.53-12.86.25-17.64l68.33-68.31a16 16 0 00-.56-23.16A15.62 15.62 0 00400.26 16a16.73 16.73 0 00-11.81 4.9L311.5 97.85a79.49 79.49 0 00-23.44 56.59v8.23a16 16 0 01-4.69 11.33l-35.61 35.62a4 4 0 01-5.66 0L68.82 36.33a16 16 0 00-22.58-.06C31.09 51.28 23 72.47 23 97.54c-.1 41.4 21.66 89 56.79 124.08l85.45 85.45A64.79 64.79 0 00211 326a64 64 0 0016.21-2.08 16.24 16.24 0 014.07-.53 15.93 15.93 0 0110.83 4.25l11.39 10.52a16.12 16.12 0 014.6 11.23v5.54a47.73 47.73 0 0013.77 33.65l90.05 91.57.09.1a53.29 53.29 0 0075.36-75.37L302.39 269.9a4 4 0 010-5.66L338 228.63a16 16 0 0111.32-4.69z"}},{"tag":"path","attr":{"d":"M211 358a97.32 97.32 0 01-68.36-28.25l-13.86-13.86a8 8 0 00-11.3 0l-85 84.56c-15.15 15.15-20.56 37.45-13.06 59.29a30.63 30.63 0 001.49 3.6C31 484 50.58 496 72 496a55.68 55.68 0 0039.64-16.44L225 365.66a4.69 4.69 0 001.32-3.72v-.26a4.63 4.63 0 00-5.15-4.27A97.09 97.09 0 01211 358z"}}]})(props);
	};
	module.exports.IoReturnDownBackOutline = function IoReturnDownBackOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 352l-64-64 64-64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M64 288h294c58.76 0 106-49.33 106-108v-20"}}]})(props);
	};
	module.exports.IoReturnDownBackSharp = function IoReturnDownBackSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M112 352l-64-64 64-64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M64 288h400V160"}}]})(props);
	};
	module.exports.IoReturnDownBack = function IoReturnDownBack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 352l-64-64 64-64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M64 288h294c58.76 0 106-49.33 106-108v-20"}}]})(props);
	};
	module.exports.IoReturnDownForwardOutline = function IoReturnDownForwardOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M400 352l64-64-64-64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M448 288H154c-58.76 0-106-49.33-106-108v-20"}}]})(props);
	};
	module.exports.IoReturnDownForwardSharp = function IoReturnDownForwardSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M400 352l64-64-64-64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 288H48V160"}}]})(props);
	};
	module.exports.IoReturnDownForward = function IoReturnDownForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M400 352l64-64-64-64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M448 288H154c-58.76 0-106-49.33-106-108v-20"}}]})(props);
	};
	module.exports.IoReturnUpBackOutline = function IoReturnUpBackOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 160l-64 64 64 64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M64 224h294c58.76 0 106 49.33 106 108v20"}}]})(props);
	};
	module.exports.IoReturnUpBackSharp = function IoReturnUpBackSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M112 160l-64 64 64 64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M64 224h400v128"}}]})(props);
	};
	module.exports.IoReturnUpBack = function IoReturnUpBack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 160l-64 64 64 64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M64 224h294c58.76 0 106 49.33 106 108v20"}}]})(props);
	};
	module.exports.IoReturnUpForwardOutline = function IoReturnUpForwardOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M400 160l64 64-64 64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M448 224H154c-58.76 0-106 49.33-106 108v20"}}]})(props);
	};
	module.exports.IoReturnUpForwardSharp = function IoReturnUpForwardSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M400 160l64 64-64 64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 224H48v128"}}]})(props);
	};
	module.exports.IoReturnUpForward = function IoReturnUpForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M400 160l64 64-64 64"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M448 224H154c-58.76 0-106 49.33-106 108v20"}}]})(props);
	};
	module.exports.IoRibbonOutline = function IoRibbonOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"160","r":"128","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M143.65 227.82L48 400l86.86-.42a16 16 0 0113.82 7.8L192 480l88.33-194.32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M366.54 224L464 400l-86.86-.42a16 16 0 00-13.82 7.8L320 480l-64-140.8"}},{"tag":"circle","attr":{"cx":"256","cy":"160","r":"64","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoRibbonSharp = function IoRibbonSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 336c-5.22 0-10.4-.24-15.51-.69a176.12 176.12 0 01-131.29-78.37L20 416h115l58 96 82.53-177.09A177.53 177.53 0 01256 336zm147-79.26a176.9 176.9 0 01-88.18 69.14L273.7 415.5 319 512l58-96h115z"}},{"tag":"circle","attr":{"cx":"256.02","cy":"160","r":"48"}},{"tag":"path","attr":{"d":"M256 16c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144S335.4 16 256 16zm0 224a80 80 0 1180-80 80.09 80.09 0 01-80 80z"}}]})(props);
	};
	module.exports.IoRibbon = function IoRibbon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M269 335.61q-6.33.47-12.78.47c-5.23 0-10.4-.24-15.51-.69a176.11 176.11 0 01-127.67-72.94 4 4 0 00-6.77.35l-72 129.4c-2.74 5-3.17 11-.28 15.88A16.78 16.78 0 0048.22 416h78a15.28 15.28 0 0113.62 7.33L178.5 488a16.26 16.26 0 0013.75 8c5.94-.33 12.09-4.19 14.56-9.6l66.11-145.15a4 4 0 00-3.92-5.64zm208.64 56.27l-71.53-129.17a4 4 0 00-6.74-.36 176.5 176.5 0 01-78.31 61.42 16.09 16.09 0 00-8.72 8.25l-36.86 81.1a7.92 7.92 0 000 6.6l30.27 66.59c2.45 5.41 8.59 9.36 14.52 9.69a16.3 16.3 0 0013.7-8.12l38.53-64.58c2.89-4.85 8.13-7.33 13.78-7.3h78.77c6.67 0 11.72-3.48 14-10a16.92 16.92 0 00-1.41-14.12z"}},{"tag":"ellipse","attr":{"cx":"256.26","cy":"160","rx":"48.01","ry":"48"}},{"tag":"path","attr":{"d":"M256.26 16c-79.42 0-144 64.59-144 144s64.61 144 144 144 144-64.6 144-144-64.59-144-144-144zm0 224a80 80 0 1180-80 80.1 80.1 0 01-80 80z"}}]})(props);
	};
	module.exports.IoRocketOutline = function IoRocketOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M461.81 53.81a4.4 4.4 0 00-3.3-3.39c-54.38-13.3-180 34.09-248.13 102.17a294.9 294.9 0 00-33.09 39.08c-21-1.9-42-.3-59.88 7.5-50.49 22.2-65.18 80.18-69.28 105.07a9 9 0 009.8 10.4l81.07-8.9a180.29 180.29 0 001.1 18.3 18.15 18.15 0 005.3 11.09l31.39 31.39a18.15 18.15 0 0011.1 5.3 179.91 179.91 0 0018.19 1.1l-8.89 81a9 9 0 0010.39 9.79c24.9-4 83-18.69 105.07-69.17 7.8-17.9 9.4-38.79 7.6-59.69a293.91 293.91 0 0039.19-33.09c68.38-68 115.47-190.86 102.37-247.95zM298.66 213.67a42.7 42.7 0 1160.38 0 42.65 42.65 0 01-60.38 0z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M109.64 352a45.06 45.06 0 00-26.35 12.84C65.67 382.52 64 448 64 448s65.52-1.67 83.15-19.31A44.73 44.73 0 00160 402.32"}}]})(props);
	};
	module.exports.IoRocketSharp = function IoRocketSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M477.64 38.26a4.75 4.75 0 00-3.55-3.66c-58.57-14.32-193.9 36.71-267.22 110a317 317 0 00-35.63 42.1c-22.61-2-45.22-.33-64.49 8.07C52.38 218.7 36.55 281.14 32.14 308a9.64 9.64 0 0010.55 11.2l87.31-9.63a194.1 194.1 0 001.19 19.7 19.53 19.53 0 005.7 12L170.7 375a19.59 19.59 0 0012 5.7 193.53 193.53 0 0019.59 1.19l-9.58 87.2a9.65 9.65 0 0011.2 10.55c26.81-4.3 89.36-20.13 113.15-74.5 8.4-19.27 10.12-41.77 8.18-64.27a317.66 317.66 0 0042.21-35.64C441 232.05 491.74 99.74 477.64 38.26zM294.07 217.93a48 48 0 1167.86 0 47.95 47.95 0 01-67.86 0z"}},{"tag":"path","attr":{"d":"M168.4 399.43c-5.48 5.49-14.27 7.63-24.85 9.46-23.77 4.05-44.76-16.49-40.49-40.52 1.63-9.11 6.45-21.88 9.45-24.88a4.37 4.37 0 00-3.65-7.45 60 60 0 00-35.13 17.12C50.22 376.69 48 464 48 464s87.36-2.22 110.87-25.75A59.69 59.69 0 00176 403.09c.37-4.18-4.72-6.67-7.6-3.66z"}}]})(props);
	};
	module.exports.IoRocket = function IoRocket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M328.85 156.79a26.69 26.69 0 1018.88 7.81 26.6 26.6 0 00-18.88-7.81z"}},{"tag":"path","attr":{"d":"M477.44 50.06a.29.29 0 010-.09 20.4 20.4 0 00-15.13-15.3c-29.8-7.27-76.68.48-128.63 21.28-52.36 21-101.42 52-134.58 85.22A320.7 320.7 0 00169.55 175c-22.33-1-42 2.18-58.57 9.41-57.74 25.41-74.23 90.44-78.62 117.14a25 25 0 0027.19 29h.13l64.32-7.02c.08.82.17 1.57.24 2.26a34.36 34.36 0 009.9 20.72l31.39 31.41a34.27 34.27 0 0020.71 9.91l2.15.23-7 64.24v.13A25 25 0 00206 480a25.25 25.25 0 004.15-.34C237 475.34 302 459.05 327.34 401c7.17-16.46 10.34-36.05 9.45-58.34a314.78 314.78 0 0033.95-29.55c33.43-33.26 64.53-81.92 85.31-133.52 20.69-51.36 28.48-98.59 21.39-129.53zM370.38 224.94a58.77 58.77 0 110-83.07 58.3 58.3 0 010 83.07z"}},{"tag":"path","attr":{"d":"M161.93 386.44a16 16 0 00-11 2.67c-6.39 4.37-12.81 8.69-19.29 12.9-13.11 8.52-28.79-6.44-21-20l12.15-21a16 16 0 00-15.16-24.91A61.25 61.25 0 0072 353.56c-3.66 3.67-14.79 14.81-20.78 57.26A357.94 357.94 0 0048 447.59 16 16 0 0064 464h.4a359.87 359.87 0 0036.8-3.2c42.47-6 53.61-17.14 57.27-20.8a60.49 60.49 0 0017.39-35.74 16 16 0 00-13.93-17.82z"}}]})(props);
	};
	module.exports.IoRoseOutline = function IoRoseOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M416 128c-18.9 4.25-36.8 8.94-53.7 13.95-40.5 12-75.5 27.15-105.4 41.65-19.3 9.37-26.2 13.51-51.5 28.23-58.4 33.69-93.4 77.4-93.4 142.81C112 428.55 167.6 480 256 480s144-55.81 144-129.72S339 225.24 416 128z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M264 180.19c-19.69-27-38.2-38.69-52.7-46.59C162.6 107.1 96 96 96 96c41.5 43.7 37.2 90.1 32 128 0 0-3.87 32.88 1.91 58.41"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M372 139.15C356.55 102.6 336 64 336 64s-63.32 0-135.69 64m53.17-40.43C221.25 45.81 176 32 176 32c-15.3 20.8-28.79 51.58-34.87 74.17"}}]})(props);
	};
	module.exports.IoRoseSharp = function IoRoseSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 112s-17.62 0-30.51 1.39c-19 2-42.06 8-59.73 13.22-35.06 10.39-69.33 23.92-107.85 42.59-18.62 9.05-26 13.35-48 26.13l-4.5 2.67c-32.95 19-57.09 40-73.79 64.3C105.29 288.89 96 320 96 354.64c0 40.74 15.71 77.1 44.24 102.37C169 482.52 209.06 496 256 496c46.76 0 86.89-14.32 116-41.43 28.35-26.35 44-63.39 44-104.29 0-25-6.19-47-12.17-68.22-12.59-44.69-23.46-83.29 24.71-144.13C432.75 132.62 448 112 448 112zm-229 7.55C168.47 92.08 104.72 80 80 80c0 0 23.23 28.19 29.15 55.4s6.54 48.61 2.91 88.6c17.94-20.48 40.59-37.15 69.32-53.73l4.48-2.6C208 154.8 216.23 150 236 140.41c2.88-1.4 5.74-2.76 8.58-4.11A170.77 170.77 0 00219 119.55zM345.25 48s-42.53.36-86.12 21.3a280.36 280.36 0 00-32.27 18.27q3.73 1.89 7.4 3.88c3.44 1.87 7.09 4 10.9 6.29a189.7 189.7 0 0131.46 24.16c24.57-10.41 73-26.1 90.77-31.28-8-19.15-22.14-42.62-22.14-42.62zM176 16c-16 10.83-33.24 41.1-33.24 41.1a494.22 494.22 0 0148.92 15.25l17.65-11.56c8.18-5.35 16.55-10.29 25-14.77C234.31 46 202.59 24.17 176 16z"}}]})(props);
	};
	module.exports.IoRose = function IoRose (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M429.55 119.49a16 16 0 00-17.06-7.1c-18.64 4.19-37.06 9-54.73 14.22-35.06 10.39-69.33 23.92-107.85 42.59-18.62 9.05-26 13.35-48 26.13l-4.5 2.67c-32.95 19-57.09 40-73.79 64.29C105.29 288.89 96 320 96 354.64c0 40.74 15.71 77.1 44.24 102.37C169 482.52 209.06 496 256 496c46.76 0 86.89-14.33 116-41.43 28.35-26.35 44-63.39 44-104.29 0-25-6.19-47-12.17-68.22-12.59-44.69-23.46-83.29 24.71-144.13a16 16 0 001.01-18.44zm-210.55.06C168.46 92.08 101.46 80.69 98.63 80.22A16 16 0 0081 90.55a16.47 16.47 0 003.79 16.84c31.84 33.78 32.86 68.79 28.65 104.63a4.45 4.45 0 002.5 4.54 4.44 4.44 0 005.08-.9c16.39-16.51 36.37-31.52 60.4-45.39l4.48-2.6C208 154.8 216.23 150 236 140.41l2.69-1.3a4 4 0 00.64-6.83A178.59 178.59 0 00219 119.55zm15.26-28.1c3.44 1.87 7.09 4 10.9 6.29a189.31 189.31 0 0129.57 22.39 4 4 0 004.28.76 672 672 0 0169.65-25q7-2.07 14.08-4a4 4 0 002.53-5.62c-8.27-16.83-14.67-28.9-15.15-29.79A16 16 0 00336 48c-1.91 0-33.28.36-76.87 21.3a279 279 0 00-26.39 14.51 4 4 0 00.22 6.94zm-24.93-30.66c7.3-4.77 14.74-9.22 22.25-13.31a2 2 0 00.24-3.36c-26-19.57-49.73-27-51.15-27.42a16 16 0 00-17.56 5.82 217.63 217.63 0 00-19.28 32.38 2 2 0 001.29 2.81c13.61 3.57 29.4 8.29 45.61 14.29a2 2 0 001.79-.2z"}}]})(props);
	};
	module.exports.IoSadOutline = function IoSadOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"184","cy":"232","r":"24"}},{"tag":"path","attr":{"d":"M256 288c45.42 0 83.62 29.53 95.71 69.83a8 8 0 01-7.87 10.17H168.15a8 8 0 01-7.82-10.17C172.32 317.53 210.53 288 256 288z"}},{"tag":"circle","attr":{"cx":"328","cy":"232","r":"24"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"208","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoSadSharp = function IoSadSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM328 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm-144 0a24 24 0 11-24 24 23.94 23.94 0 0124-24zm72 80c45.42 0 83.75 29.49 95.72 69.83 1 3.52 2.33 10.17 2.33 10.17H158s1.31-6.69 2.33-10.17C172.11 317.47 210.53 288 256 288z"}}]})(props);
	};
	module.exports.IoSad = function IoSad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM184 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm-23.67 149.83c12-40.3 50.2-69.83 95.62-69.83s83.62 29.53 95.71 69.83a8 8 0 01-7.82 10.17H168.15a8 8 0 01-7.82-10.17zM328 256a24 24 0 1124-24 23.94 23.94 0 01-24 24z"}}]})(props);
	};
	module.exports.IoSaveOutline = function IoSaveOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M380.93 57.37A32 32 0 00358.3 48H94.22A46.21 46.21 0 0048 94.22v323.56A46.21 46.21 0 0094.22 464h323.56A46.36 46.36 0 00464 417.78V153.7a32 32 0 00-9.37-22.63zM256 416a64 64 0 1164-64 63.92 63.92 0 01-64 64zm48-224H112a16 16 0 01-16-16v-64a16 16 0 0116-16h192a16 16 0 0116 16v64a16 16 0 01-16 16z"}}]})(props);
	};
	module.exports.IoSaveSharp = function IoSaveSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M380.44 32H64a32 32 0 00-32 32v384a32 32 0 0032 32h384a32.09 32.09 0 0032-32V131.56zM112 176v-64h192v64zm223.91 179.76a80 80 0 11-83.66-83.67 80.21 80.21 0 0183.66 83.67z"}}]})(props);
	};
	module.exports.IoSave = function IoSave (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M465.94 119.76l-73.7-73.7A47.68 47.68 0 00358.3 32H96a64 64 0 00-64 64v320a64 64 0 0064 64h320a64 64 0 0064-64V153.7a47.68 47.68 0 00-14.06-33.94zM120 112h176a8 8 0 018 8v48a8 8 0 01-8 8H120a8 8 0 01-8-8v-48a8 8 0 018-8zm139.75 319.91a80 80 0 1176.16-76.16 80.06 80.06 0 01-76.16 76.16z"}},{"tag":"circle","attr":{"cx":"256","cy":"352","r":"48"}}]})(props);
	};
	module.exports.IoScaleOutline = function IoScaleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"416","x":"48","y":"48","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"96"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M388.94 151.56c-24.46-22.28-68.72-51.4-132.94-51.4s-108.48 29.12-132.94 51.4a34.66 34.66 0 00-3.06 48.08l33.32 39.21a26.07 26.07 0 0033.6 5.21c15.92-9.83 40.91-21.64 69.1-21.64s53.18 11.81 69.1 21.64a26.07 26.07 0 0033.6-5.21L392 199.64a34.66 34.66 0 00-3.06-48.08z"}}]})(props);
	};
	module.exports.IoScaleSharp = function IoScaleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 32H80a48.05 48.05 0 00-48 48v352a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V80a48.05 48.05 0 00-48-48zm-16.71 165l-52.46 61.73a27.83 27.83 0 01-37.65 4.62c-13-9.29-39.27-24.89-69.18-24.89s-56.18 15.6-69.18 24.89a27.84 27.84 0 01-37.65-4.62L96.71 197a32.12 32.12 0 01.42-42c18.93-21.31 72.3-70.87 158.87-70.87S395.94 133.72 414.87 155a32.12 32.12 0 01.42 42z"}}]})(props);
	};
	module.exports.IoScale = function IoScale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 32H144A112.12 112.12 0 0032 144v224a112.12 112.12 0 00112 112h224a112.12 112.12 0 00112-112V144A112.12 112.12 0 00368 32zm36.21 178l-33.32 39.21A41.76 41.76 0 01339 264.05a42.32 42.32 0 01-22.29-6.38c-14.22-8.78-36.3-19.25-60.69-19.25s-46.47 10.47-60.69 19.25a41.86 41.86 0 01-54.2-8.46L107.79 210a50.48 50.48 0 014.49-70.27c27.84-25.35 75.37-55.57 143.72-55.57s115.88 30.22 143.72 55.57a50.48 50.48 0 014.49 70.27z"}}]})(props);
	};
	module.exports.IoScanCircleOutline = function IoScanCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M296 352h28a28 28 0 0028-28v-28m0-80v-28a28 28 0 00-28-28h-28m-80 192h-28a28 28 0 01-28-28v-28m0-80v-28a28 28 0 0128-28h28"}}]})(props);
	};
	module.exports.IoScanCircleSharp = function IoScanCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-24 320h-44a44.05 44.05 0 01-44-44v-44h32v44a12 12 0 0012 12h44zm0-192h-44a12 12 0 00-12 12v44h-32v-44a44.05 44.05 0 0144-44h44zm136 148a44.05 44.05 0 01-44 44h-44v-32h44a12 12 0 0012-12v-44h32zm0-92h-32v-44a12 12 0 00-12-12h-44v-32h44a44.05 44.05 0 0144 44z"}}]})(props);
	};
	module.exports.IoScanCircle = function IoScanCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-40 320h-28a44.05 44.05 0 01-44-44v-28a16 16 0 0132 0v28a12 12 0 0012 12h28a16 16 0 010 32zm0-192h-28a12 12 0 00-12 12v28a16 16 0 01-32 0v-28a44.05 44.05 0 0144-44h28a16 16 0 010 32zm152 148a44.05 44.05 0 01-44 44h-28a16 16 0 010-32h28a12 12 0 0012-12v-28a16 16 0 0132 0zm0-108a16 16 0 01-32 0v-28a12 12 0 00-12-12h-28a16 16 0 010-32h28a44.05 44.05 0 0144 44z"}}]})(props);
	};
	module.exports.IoScanOutline = function IoScanOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M336 448h56a56 56 0 0056-56v-56m0-160v-56a56 56 0 00-56-56h-56M176 448h-56a56 56 0 01-56-56v-56m0-160v-56a56 56 0 0156-56h56"}}]})(props);
	};
	module.exports.IoScanSharp = function IoScanSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M388 466h-68v-44h68a34 34 0 0034-34v-68h44v68a78.09 78.09 0 01-78 78zm78-274h-44v-68a34 34 0 00-34-34h-68V46h68a78.09 78.09 0 0178 78zM192 466h-68a78.09 78.09 0 01-78-78v-68h44v68a34 34 0 0034 34h68zM90 192H46v-68a78.09 78.09 0 0178-78h68v44h-68a34 34 0 00-34 34z"}}]})(props);
	};
	module.exports.IoScan = function IoScan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"44","d":"M342 444h46a56 56 0 0056-56v-46m0-172v-46a56 56 0 00-56-56h-46M170 444h-46a56 56 0 01-56-56v-46m0-172v-46a56 56 0 0156-56h46"}}]})(props);
	};
	module.exports.IoSchoolOutline = function IoSchoolOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M32 192L256 64l224 128-224 128L32 192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 240v128l144 80 144-80V240m80 128V192M256 320v128"}}]})(props);
	};
	module.exports.IoSchoolSharp = function IoSchoolSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 370.43L96 279v98.42l160 88.88 160-88.88V279l-160 91.43z"}},{"tag":"path","attr":{"d":"M512.25 192L256 45.57-.25 192 256 338.43l208-118.86V384h48V192.14l.25-.14z"}}]})(props);
	};
	module.exports.IoSchool = function IoSchool (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 368a16 16 0 01-7.94-2.11L108 285.84a8 8 0 00-12 6.94V368a16 16 0 008.23 14l144 80a16 16 0 0015.54 0l144-80a16 16 0 008.23-14v-75.22a8 8 0 00-12-6.94l-140.06 80.05A16 16 0 01256 368z"}},{"tag":"path","attr":{"d":"M495.92 190.5v-.11a16 16 0 00-8-12.28l-224-128a16 16 0 00-15.88 0l-224 128a16 16 0 000 27.78l224 128a16 16 0 0015.88 0L461 221.28a2 2 0 013 1.74v144.53c0 8.61 6.62 16 15.23 16.43A16 16 0 00496 368V192a14.76 14.76 0 00-.08-1.5z"}}]})(props);
	};
	module.exports.IoSearchCircleOutline = function IoSearchCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 80a176 176 0 10176 176A176 176 0 00256 80z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M232 160a72 72 0 1072 72 72 72 0 00-72-72z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M283.64 283.64L336 336"}}]})(props);
	};
	module.exports.IoSearchCircleSharp = function IoSearchCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C150.13 64 64 150.13 64 256s86.13 192 192 192 192-86.13 192-192S361.87 64 256 64zm80 294.63l-54.15-54.15a88.08 88.08 0 1122.63-22.63L358.63 336z"}},{"tag":"circle","attr":{"cx":"232","cy":"232","r":"56"}}]})(props);
	};
	module.exports.IoSearchCircle = function IoSearchCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C150.13 64 64 150.13 64 256s86.13 192 192 192 192-86.13 192-192S361.87 64 256 64zm91.31 283.31a16 16 0 01-22.62 0l-42.84-42.83a88.08 88.08 0 1122.63-22.63l42.83 42.84a16 16 0 010 22.62z"}},{"tag":"circle","attr":{"cx":"232","cy":"232","r":"56"}}]})(props);
	};
	module.exports.IoSearchOutline = function IoSearchOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M338.29 338.29L448 448"}}]})(props);
	};
	module.exports.IoSearchSharp = function IoSearchSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 428L339.92 303.9a160.48 160.48 0 0030.72-94.58C370.64 120.37 298.27 48 209.32 48S48 120.37 48 209.32s72.37 161.32 161.32 161.32a160.48 160.48 0 0094.58-30.72L428 464zM209.32 319.69a110.38 110.38 0 11110.37-110.37 110.5 110.5 0 01-110.37 110.37z"}}]})(props);
	};
	module.exports.IoSearch = function IoSearch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456.69 421.39L362.6 327.3a173.81 173.81 0 0034.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 00327.3 362.6l94.09 94.09a25 25 0 0035.3-35.3zM97.92 222.72a124.8 124.8 0 11124.8 124.8 124.95 124.95 0 01-124.8-124.8z"}}]})(props);
	};
	module.exports.IoSendOutline = function IoSendOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M470.3 271.15L43.16 447.31a7.83 7.83 0 01-11.16-7V327a8 8 0 016.51-7.86l247.62-47c17.36-3.29 17.36-28.15 0-31.44l-247.63-47a8 8 0 01-6.5-7.85V72.59c0-5.74 5.88-10.26 11.16-8L470.3 241.76a16 16 0 010 29.39z"}}]})(props);
	};
	module.exports.IoSendSharp = function IoSendSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16 464l480-208L16 48v160l320 48-320 48z"}}]})(props);
	};
	module.exports.IoSend = function IoSend (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476.59 227.05l-.16-.07L49.35 49.84A23.56 23.56 0 0027.14 52 24.65 24.65 0 0016 72.59v113.29a24 24 0 0019.52 23.57l232.93 43.07a4 4 0 010 7.86L35.53 303.45A24 24 0 0016 327v113.31A23.57 23.57 0 0026.59 460a23.94 23.94 0 0013.22 4 24.55 24.55 0 009.52-1.93L476.4 285.94l.19-.09a32 32 0 000-58.8z"}}]})(props);
	};
	module.exports.IoServerOutline = function IoServerOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"ellipse","attr":{"cx":"256","cy":"128","fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","rx":"192","ry":"80"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 214c0 44.18-86 80-192 80S64 258.18 64 214m384 86c0 44.18-86 80-192 80S64 344.18 64 300"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M64 127.24v257.52C64 428.52 150 464 256 464s192-35.48 192-79.24V127.24"}}]})(props);
	};
	module.exports.IoServerSharp = function IoServerSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M409.43 389.87C362 410 305.4 421.05 256 421.05s-105.87-11.3-153.44-31.18S48 353.16 48 353.16v38.2c0 31.15 18 43.64 67.32 64.35C153.13 471.59 203.18 480 256 480s102.87-8.41 140.68-24.29C446 435 464 422.51 464 391.36v-38.2s-7.14 16.59-54.57 36.71zM63.69 173.22c11.23 9.84 27.82 19.49 48 27.92 42.48 17.76 96.45 28.37 144.36 28.37s101.88-10.61 144.36-28.37c20.13-8.43 36.72-18.08 47.95-27.92 6.06-5.31 10.85-10.12 13.47-12.85a8 8 0 002.22-5.54v-26.16c-.84-28.79-24.71-54.41-67.21-72.14C358.83 40.71 308.84 32 256 32s-102.83 8.71-140.74 24.53C72.85 74.22 49 99.78 48.05 128.5v26.33a8 8 0 002.21 5.54c2.58 2.73 7.36 7.54 13.43 12.85z"}},{"tag":"path","attr":{"d":"M409.43 221.91C365 241 305.4 253.09 256 253.09s-108.87-12.27-153.43-31.18S48 185.2 48 185.2v47.36c.08 7.52 5.5 16.2 15.69 25.13 11.24 9.84 27.82 19.5 48 27.92C154.12 303.38 208.09 314 256 314s101.88-10.6 144.36-28.37c20.13-8.42 36.72-18.08 47.95-27.92 10.25-9 15.68-17.71 15.69-25.27V185.2s-10.13 17.62-54.57 36.71z"}},{"tag":"path","attr":{"d":"M409.43 306.38C362 326 305.4 337.56 256 337.56s-109.87-12.8-153.43-31.18S48 269.67 48 269.67v46.25c0 7.55 5.44 16.28 15.69 25.26 11.23 9.84 27.81 19.5 48 27.92 42.48 17.77 96.44 28.37 144.36 28.37s101.88-10.6 144.36-28.37c20.13-8.43 36.72-18.08 47.95-27.92 10.19-8.93 15.61-17.61 15.69-25.13v-46.38s-7.18 17.09-54.62 36.71z"}}]})(props);
	};
	module.exports.IoServer = function IoServer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 428c-52.35 0-111.39-11.61-157.93-31-17.07-7.19-31.69-18.82-43.64-28a4 4 0 00-6.43 3.18v12.58c0 28.07 23.49 53.22 66.14 70.82C152.29 471.33 202.67 480 256 480s103.7-8.67 141.86-24.42C440.51 438 464 412.83 464 384.76v-12.58a4 4 0 00-6.43-3.18c-11.95 9.17-26.57 20.81-43.65 28-46.54 19.39-105.57 31-157.92 31zm208-301.49c-.81-27.65-24.18-52.4-66-69.85C359.74 40.76 309.34 32 256 32s-103.74 8.76-141.91 24.66c-41.78 17.41-65.15 42.11-66 69.69L48 144c0 6.41 5.2 16.48 14.63 24.73 11.13 9.73 27.65 19.33 47.78 27.73C153.24 214.36 207.67 225 256 225s102.76-10.68 145.59-28.58c20.13-8.4 36.65-18 47.78-27.73C458.8 160.49 464 150.42 464 144z"}},{"tag":"path","attr":{"d":"M413.92 226c-46.53 19.43-105.57 31-157.92 31s-111.39-11.57-157.93-31c-17.07-7.15-31.69-18.79-43.64-28a4 4 0 00-6.43 3.22V232c0 6.41 5.2 14.48 14.63 22.73 11.13 9.74 27.65 19.33 47.78 27.74C153.24 300.34 207.67 311 256 311s102.76-10.68 145.59-28.57c20.13-8.41 36.65-18 47.78-27.74C458.8 246.47 464 238.41 464 232v-30.78a4 4 0 00-6.43-3.18c-11.95 9.17-26.57 20.81-43.65 27.96z"}},{"tag":"path","attr":{"d":"M413.92 312c-46.54 19.41-105.57 31-157.92 31s-111.39-11.59-157.93-31c-17.07-7.17-31.69-18.81-43.64-28a4 4 0 00-6.43 3.2V317c0 6.41 5.2 14.47 14.62 22.71 11.13 9.74 27.66 19.33 47.79 27.74C153.24 385.32 207.66 396 256 396s102.76-10.68 145.59-28.57c20.13-8.41 36.65-18 47.78-27.74C458.8 331.44 464 323.37 464 317v-29.8a4 4 0 00-6.43-3.18c-11.95 9.17-26.57 20.81-43.65 27.98z"}}]})(props);
	};
	module.exports.IoSettingsOutline = function IoSettingsOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M262.29 192.31a64 64 0 1057.4 57.4 64.13 64.13 0 00-57.4-57.4zM416.39 256a154.34 154.34 0 01-1.53 20.79l45.21 35.46a10.81 10.81 0 012.45 13.75l-42.77 74a10.81 10.81 0 01-13.14 4.59l-44.9-18.08a16.11 16.11 0 00-15.17 1.75A164.48 164.48 0 01325 400.8a15.94 15.94 0 00-8.82 12.14l-6.73 47.89a11.08 11.08 0 01-10.68 9.17h-85.54a11.11 11.11 0 01-10.69-8.87l-6.72-47.82a16.07 16.07 0 00-9-12.22 155.3 155.3 0 01-21.46-12.57 16 16 0 00-15.11-1.71l-44.89 18.07a10.81 10.81 0 01-13.14-4.58l-42.77-74a10.8 10.8 0 012.45-13.75l38.21-30a16.05 16.05 0 006-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16 16 0 00-6.07-13.94l-38.19-30A10.81 10.81 0 0149.48 186l42.77-74a10.81 10.81 0 0113.14-4.59l44.9 18.08a16.11 16.11 0 0015.17-1.75A164.48 164.48 0 01187 111.2a15.94 15.94 0 008.82-12.14l6.73-47.89A11.08 11.08 0 01213.23 42h85.54a11.11 11.11 0 0110.69 8.87l6.72 47.82a16.07 16.07 0 009 12.22 155.3 155.3 0 0121.46 12.57 16 16 0 0015.11 1.71l44.89-18.07a10.81 10.81 0 0113.14 4.58l42.77 74a10.8 10.8 0 01-2.45 13.75l-38.21 30a16.05 16.05 0 00-6.05 14.08c.33 4.14.55 8.3.55 12.47z"}}]})(props);
	};
	module.exports.IoSettingsSharp = function IoSettingsSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 176a80 80 0 1080 80 80.24 80.24 0 00-80-80zm172.72 80a165.53 165.53 0 01-1.64 22.34l48.69 38.12a11.59 11.59 0 012.63 14.78l-46.06 79.52a11.64 11.64 0 01-14.14 4.93l-57.25-23a176.56 176.56 0 01-38.82 22.67l-8.56 60.78a11.93 11.93 0 01-11.51 9.86h-92.12a12 12 0 01-11.51-9.53l-8.56-60.78A169.3 169.3 0 01151.05 393L93.8 416a11.64 11.64 0 01-14.14-4.92L33.6 331.57a11.59 11.59 0 012.63-14.78l48.69-38.12A174.58 174.58 0 0183.28 256a165.53 165.53 0 011.64-22.34l-48.69-38.12a11.59 11.59 0 01-2.63-14.78l46.06-79.52a11.64 11.64 0 0114.14-4.93l57.25 23a176.56 176.56 0 0138.82-22.67l8.56-60.78A11.93 11.93 0 01209.94 26h92.12a12 12 0 0111.51 9.53l8.56 60.78A169.3 169.3 0 01361 119l57.2-23a11.64 11.64 0 0114.14 4.92l46.06 79.52a11.59 11.59 0 01-2.63 14.78l-48.69 38.12a174.58 174.58 0 011.64 22.66z"}}]})(props);
	};
	module.exports.IoSettings = function IoSettings (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"48"}},{"tag":"path","attr":{"d":"M470.39 300l-.47-.38-31.56-24.75a16.11 16.11 0 01-6.1-13.33v-11.56a16 16 0 016.11-13.22L469.92 212l.47-.38a26.68 26.68 0 005.9-34.06l-42.71-73.9a1.59 1.59 0 01-.13-.22A26.86 26.86 0 00401 92.14l-.35.13-37.1 14.93a15.94 15.94 0 01-14.47-1.29q-4.92-3.1-10-5.86a15.94 15.94 0 01-8.19-11.82l-5.59-39.59-.12-.72A27.22 27.22 0 00298.76 26h-85.52a26.92 26.92 0 00-26.45 22.39l-.09.56-5.57 39.67a16 16 0 01-8.13 11.82 175.21 175.21 0 00-10 5.82 15.92 15.92 0 01-14.43 1.27l-37.13-15-.35-.14a26.87 26.87 0 00-32.48 11.34l-.13.22-42.77 73.95a26.71 26.71 0 005.9 34.1l.47.38 31.56 24.75a16.11 16.11 0 016.1 13.33v11.56a16 16 0 01-6.11 13.22L42.08 300l-.47.38a26.68 26.68 0 00-5.9 34.06l42.71 73.9a1.59 1.59 0 01.13.22 26.86 26.86 0 0032.45 11.3l.35-.13 37.07-14.93a15.94 15.94 0 0114.47 1.29q4.92 3.11 10 5.86a15.94 15.94 0 018.19 11.82l5.56 39.59.12.72A27.22 27.22 0 00213.24 486h85.52a26.92 26.92 0 0026.45-22.39l.09-.56 5.57-39.67a16 16 0 018.18-11.82c3.42-1.84 6.76-3.79 10-5.82a15.92 15.92 0 0114.43-1.27l37.13 14.95.35.14a26.85 26.85 0 0032.48-11.34 2.53 2.53 0 01.13-.22l42.71-73.89a26.7 26.7 0 00-5.89-34.11zm-134.48-40.24a80 80 0 11-83.66-83.67 80.21 80.21 0 0183.66 83.67z"}}]})(props);
	};
	module.exports.IoShapesOutline = function IoShapesOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M336 320H32L184 48l152 272zm-70.68-125.49A144 144 0 11192 320"}}]})(props);
	};
	module.exports.IoShapesSharp = function IoShapesSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M363.27 336H4.73L184 16z"}},{"tag":"path","attr":{"d":"M336 160a160.54 160.54 0 00-32.55 3.36l87.75 157L417.81 368H183.36C203.8 432.85 264.49 480 336 480c88.22 0 160-71.78 160-160s-71.78-160-160-160z"}}]})(props);
	};
	module.exports.IoShapes = function IoShapes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 336H32a16 16 0 01-14-23.81l152-272a16 16 0 0127.94 0l152 272A16 16 0 01336 336z"}},{"tag":"path","attr":{"d":"M336 160a161.07 161.07 0 00-32.57 3.32l74.47 133.27A48 48 0 01336 368H183.33A160 160 0 10336 160z"}}]})(props);
	};
	module.exports.IoShareOutline = function IoShareOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M336 192h40a40 40 0 0140 40v192a40 40 0 01-40 40H136a40 40 0 01-40-40V232a40 40 0 0140-40h40m160-64l-80-80-80 80m80 193V48"}}]})(props);
	};
	module.exports.IoShareSharp = function IoShareSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 176v161h-32V176H92a12 12 0 00-12 12v280a12 12 0 0012 12h328a12 12 0 0012-12V188a12 12 0 00-12-12zm0-83.37l64 64L358.63 134 256 31.37 153.37 134 176 156.63l64-64V176h32V92.63z"}}]})(props);
	};
	module.exports.IoShareSocialOutline = function IoShareSocialOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"128","cy":"256","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"384","cy":"112","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"384","cy":"400","r":"48","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M169.83 279.53l172.34 96.94m0-240.94l-172.34 96.94"}}]})(props);
	};
	module.exports.IoShareSocialSharp = function IoShareSocialSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M378 324a69.78 69.78 0 00-48.83 19.91L202 272.41a69.68 69.68 0 000-32.82l127.13-71.5A69.76 69.76 0 10308.87 129l-130.13 73.2a70 70 0 100 107.56L308.87 383A70 70 0 10378 324z"}}]})(props);
	};
	module.exports.IoShareSocial = function IoShareSocial (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 336a63.78 63.78 0 00-46.12 19.7l-148-83.27a63.85 63.85 0 000-32.86l148-83.27a63.8 63.8 0 10-15.73-27.87l-148 83.27a64 64 0 100 88.6l148 83.27A64 64 0 10384 336z"}}]})(props);
	};
	module.exports.IoShare = function IoShare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 176H272v145a16 16 0 01-32 0V176H136a56.06 56.06 0 00-56 56v192a56.06 56.06 0 0056 56h240a56.06 56.06 0 0056-56V232a56.06 56.06 0 00-56-56zM272 86.63l52.69 52.68a16 16 0 0022.62-22.62l-80-80a16 16 0 00-22.62 0l-80 80a16 16 0 0022.62 22.62L240 86.63V176h32z"}}]})(props);
	};
	module.exports.IoShieldCheckmarkOutline = function IoShieldCheckmarkOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M336 176L225.2 304 176 255.8"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M463.1 112.37C373.68 96.33 336.71 84.45 256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464c15.42-6.21 223.3-94.87 207.1-351.63z"}}]})(props);
	};
	module.exports.IoShieldCheckmarkSharp = function IoShieldCheckmarkSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M479.07 111.36l-.79-12.53-12.36-2.21c-86.5-15.52-122.61-26.74-203.33-63.2l-6.59-3-6.59 3C168.69 69.88 132.58 81.1 46.08 96.62l-12.36 2.21-.79 12.53c-3.85 61.11 4.36 118.05 24.43 169.24A349.47 349.47 0 00129 393.11c53.47 56.73 110.24 81.37 121.07 85.73l6 2.41 6-2.41c10.83-4.36 67.6-29 121.07-85.73a349.47 349.47 0 0071.5-112.51c20.07-51.19 28.28-108.13 24.43-169.24zm-252.91 216L153.37 256l22.4-22.86 48.47 47.49 110.13-127.2 24.2 20.94z"}}]})(props);
	};
	module.exports.IoShieldCheckmark = function IoShieldCheckmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M479.07 111.36a16 16 0 00-13.15-14.74c-86.5-15.52-122.61-26.74-203.33-63.2a16 16 0 00-13.18 0C168.69 69.88 132.58 81.1 46.08 96.62a16 16 0 00-13.15 14.74c-3.85 61.11 4.36 118.05 24.43 169.24A349.47 349.47 0 00129 393.11c53.47 56.73 110.24 81.37 121.07 85.73a16 16 0 0012 0c10.83-4.36 67.6-29 121.07-85.73a349.47 349.47 0 0071.5-112.51c20.07-51.19 28.28-108.13 24.43-169.24zm-131 75.11l-110.8 128a16 16 0 01-11.41 5.53h-.66a16 16 0 01-11.2-4.57l-49.2-48.2a16 16 0 1122.4-22.86l37 36.29 99.7-115.13a16 16 0 0124.2 20.94z"}}]})(props);
	};
	module.exports.IoShieldHalfOutline = function IoShieldHalfOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M463.1 112.37C373.68 96.33 336.71 84.45 256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464c15.42-6.21 223.3-94.87 207.1-351.63z"}},{"tag":"path","attr":{"d":"M256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464z"}}]})(props);
	};
	module.exports.IoShieldHalfSharp = function IoShieldHalfSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C174 69.06 121.38 86.46 32 96c0 77.59 5.27 133.36 25.29 184.51a348.86 348.86 0 0071.43 112.41c49.6 52.66 104.17 80.4 127.28 87.08 23.11-6.68 77.68-34.42 127.28-87.08a348.86 348.86 0 0071.43-112.41C474.73 229.36 480 173.59 480 96c-89.38-9.54-142-26.94-224-64zm161.47 233.93a309.18 309.18 0 01-63.31 99.56C316 406 276.65 428.31 256 437.36V75.8c38.75 17 68.73 28.3 97.93 36.89a613.12 613.12 0 0085.6 18.52c-1.72 60.22-8.36 99.69-22.06 134.72z"}}]})(props);
	};
	module.exports.IoShieldHalf = function IoShieldHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48.9 112.37C138.32 96.33 175.29 84.45 256 48c80.71 36.45 117.68 48.33 207.1 64.37C479.3 369.13 271.42 457.79 256 464c-15.42-6.21-223.3-94.87-207.1-351.63z"}},{"tag":"path","attr":{"d":"M256 48c80.71 36.45 117.68 48.33 207.1 64.37C479.3 369.13 271.42 457.79 256 464z"}}]})(props);
	};
	module.exports.IoShieldOutline = function IoShieldOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M463.1 112.37C373.68 96.33 336.71 84.45 256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464c15.42-6.21 223.3-94.87 207.1-351.63z"}}]})(props);
	};
	module.exports.IoShieldSharp = function IoShieldSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C174 69.06 121.38 86.46 32 96c0 77.59 5.27 133.36 25.29 184.51a348.86 348.86 0 0071.43 112.41c49.6 52.66 104.17 80.4 127.28 87.08 23.11-6.68 77.68-34.42 127.28-87.08a348.86 348.86 0 0071.43-112.41C474.73 229.36 480 173.59 480 96c-89.38-9.54-142-26.94-224-64z"}}]})(props);
	};
	module.exports.IoShield = function IoShield (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M479.07 111.35a16 16 0 00-13.15-14.75C379.89 81.18 343.69 69.12 266 34.16c-7.76-2.89-12.57-2.84-20 0-77.69 35-113.89 47-199.92 62.44a16 16 0 00-13.15 14.75c-3.85 61.1 4.34 118 24.36 169.15a348.86 348.86 0 0071.43 112.41c44.67 47.43 94.2 75.12 119.74 85.6a20 20 0 0015.11 0c27-10.92 74.69-37.82 119.71-85.62a348.86 348.86 0 0071.43-112.39c20.02-51.14 28.21-108.05 24.36-169.15z"}}]})(props);
	};
	module.exports.IoShirtOutline = function IoShirtOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M314.56 48s-22.78 8-58.56 8-58.56-8-58.56-8a31.94 31.94 0 00-10.57 1.8L32 104l16.63 88 48.88 5.52a24 24 0 0121.29 24.58L112 464h288l-6.8-241.9a24 24 0 0121.29-24.58l48.88-5.52L480 104 325.13 49.8a31.94 31.94 0 00-10.57-1.8zm18.75 4.66a80 80 0 01-154.62 0"}}]})(props);
	};
	module.exports.IoShirtSharp = function IoShirtSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 42c-33.88 0-64-10-64-10v2a64 64 0 00128 0v-2s-30.12 10-64 10z"}},{"tag":"path","attr":{"d":"M352 44c-5.49 47.76-46.79 85-96 85s-90.51-37.24-96-85L16 94l18 114 61.71 7.42c7.08.9 7.1.9 7.1 8.19L96 480h320l-6.81-256.39c-.21-7-.21-7 7.1-8.19L478 208l18-114z"}}]})(props);
	};
	module.exports.IoShirt = function IoShirt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 96c33.08 0 60.71-25.78 64-58 .3-3-3-6-6-6a13 13 0 00-4.74.9c-.2.08-21.1 8.1-53.26 8.1s-53.1-8-53.26-8.1a16.21 16.21 0 00-5.3-.9h-.06a5.69 5.69 0 00-5.38 6c3.35 32.16 31 58 64 58z"}},{"tag":"path","attr":{"d":"M485.29 89.9L356 44.64a4 4 0 00-5.27 3.16 96 96 0 01-189.38 0 4 4 0 00-5.35-3.16L26.71 89.9A16 16 0 0016.28 108l16.63 88a16 16 0 0013.92 12.9l48.88 5.52a8 8 0 017.1 8.19l-7.33 240.9a16 16 0 009.1 14.94A17.49 17.49 0 00112 480h288a17.49 17.49 0 007.42-1.55 16 16 0 009.1-14.94l-7.33-240.9a8 8 0 017.1-8.19l48.88-5.52a16 16 0 0013.92-12.9l16.63-88a16 16 0 00-10.43-18.1z"}}]})(props);
	};
	module.exports.IoShuffleOutline = function IoShuffleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M400 304l48 48-48 48m0-288l48 48-48 48M64 352h85.19a80 80 0 0066.56-35.62L256 256"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M64 160h85.19a80 80 0 0166.56 35.62l80.5 120.76A80 80 0 00362.81 352H416m0-192h-53.19a80 80 0 00-66.56 35.62L288 208"}}]})(props);
	};
	module.exports.IoShuffleSharp = function IoShuffleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M400 304l48 48-48 48m0-288l48 48-48 48M64 352h128l60-92"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M64 160h128l128 192h96m0-192h-96l-32 48"}}]})(props);
	};
	module.exports.IoShuffle = function IoShuffle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M400 304l48 48-48 48m0-288l48 48-48 48M64 352h85.19a80 80 0 0066.56-35.62L256 256"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M64 160h85.19a80 80 0 0166.56 35.62l80.5 120.76A80 80 0 00362.81 352H416m0-192h-53.19a80 80 0 00-66.56 35.62L288 208"}}]})(props);
	};
	module.exports.IoSkullOutline = function IoSkullOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 225.64v99a64 64 0 01-40.23 59.42l-23.68 9.47A32 32 0 00364.6 417l-10 50.14A16 16 0 01338.88 480H173.12a16 16 0 01-15.69-12.86L147.4 417a32 32 0 00-19.49-23.44l-23.68-9.47A64 64 0 0164 324.67V224c0-105.92 85.77-191.81 191.65-192S448 119.85 448 225.64z"}},{"tag":"circle","attr":{"cx":"168","cy":"280","r":"40","fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"344","cy":"280","r":"40","fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 336l-16 48h32l-16-48zm0 112v32m-48-32v32m96-32v32"}}]})(props);
	};
	module.exports.IoSkullSharp = function IoSkullSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 16C141.31 16 48 109.31 48 224v154.83l82 32.81L146.88 496H192v-64h32v64h16v-64h32v64h16v-64h32v64h45.12L382 411.64l82-32.81V224c0-114.69-93.31-208-208-208zm-88 320a56 56 0 1156-56 56.06 56.06 0 01-56 56zm51.51 64L244 320h24l24.49 80zM344 336a56 56 0 1156-56 56.06 56.06 0 01-56 56zm104 32z"}}]})(props);
	};
	module.exports.IoSkull = function IoSkull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M402 76.94C362.61 37.63 310.78 16 256 16h-.37A208 208 0 0048 224v100.67A79.62 79.62 0 0098.29 399l23.71 9.42a15.92 15.92 0 019.75 11.72l10 50.13A32.09 32.09 0 00173.12 496H184a8 8 0 008-8v-39.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01224 448v40a8 8 0 008 8 8 8 0 008-8v-39.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 448v40a8 8 0 008 8 8 8 0 008-8v-39.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01320 448v40a8 8 0 008 8h10.88a32.09 32.09 0 0031.38-25.72l10-50.14a16 16 0 019.74-11.72l23.71-9.42A79.62 79.62 0 00464 324.67v-99c0-56-22-108.81-62-148.73zM171.66 335.88a56 56 0 1152.22-52.22 56 56 0 01-52.22 52.22zM281 397.25a16.37 16.37 0 01-9.3 2.75h-31.4a16.37 16.37 0 01-9.28-2.75 16 16 0 01-6.6-16.9l15.91-47.6C243 326 247.25 321 254 320.13c8.26-1 14 2.87 17.61 12.22l16 48a16 16 0 01-6.61 16.9zm66.68-61.37a56 56 0 1152.22-52.22 56 56 0 01-52.24 52.22z"}}]})(props);
	};
	module.exports.IoSnowOutline = function IoSnowOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 32v448m57.72-400A111.47 111.47 0 01256 96a111.47 111.47 0 01-57.72-16m0 352a112.11 112.11 0 01115.44 0m136.27-288L62.01 368m375.26-150a112.09 112.09 0 01-57.71-100M74.73 294a112.09 112.09 0 0157.71 100M62.01 144l387.98 224M74.73 218a112.09 112.09 0 0057.71-100m304.83 176a112.09 112.09 0 00-57.71 100"}}]})(props);
	};
	module.exports.IoSnowSharp = function IoSnowSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.88 313.27l19.25-10.64-21.28-38.51-19.25 10.64a133.42 133.42 0 00-38.54 32.1L300 256l88.07-50.86a133.42 133.42 0 0038.54 32.1l19.25 10.64 21.28-38.51-19.25-10.64a89.27 89.27 0 01-20.93-16L480 152.05 458 114l-53 30.58a89.07 89.07 0 01-3.42-26.15l.41-22-44-.82-.41 22a133.62 133.62 0 008.49 49.39L278 217.89V116.18a133.52 133.52 0 0047.06-17.33L343.9 87.5l-22.71-37.69-18.84 11.35A89.5 89.5 0 01278 71.27V16h-44v55.27a89.5 89.5 0 01-24.35-10.11l-18.84-11.35L168.1 87.5l18.84 11.35A133.52 133.52 0 00234 116.18v101.71L145.93 167a133.62 133.62 0 008.53-49.43l-.41-22-44 .82.41 22a89.07 89.07 0 01-3.42 26.15L54 114l-22 38.1 53.05 30.64a89.27 89.27 0 01-20.93 16l-19.25 10.63 21.28 38.51 19.25-10.64a133.42 133.42 0 0038.54-32.1L212 256l-88.07 50.86a133.42 133.42 0 00-38.54-32.1l-19.24-10.64-21.28 38.51 19.25 10.64a89.27 89.27 0 0120.93 16L32 360l22 38.1 53.05-30.63a89.07 89.07 0 013.42 26.15l-.41 22 44 .82.41-22a133.62 133.62 0 00-8.54-49.44L234 294.11v101.71a133.52 133.52 0 00-47.06 17.33L168.1 424.5l22.71 37.69 18.84-11.35A89.5 89.5 0 01234 440.73V496h44v-55.27a89.5 89.5 0 0124.35 10.11l18.84 11.35 22.71-37.69-18.84-11.35A133.52 133.52 0 00278 395.82V294.11L366.07 345a133.62 133.62 0 00-8.53 49.43l.41 22 44-.82-.41-22a89.07 89.07 0 013.46-26.19l53 30.63L480 360l-53-30.69a89.27 89.27 0 0120.88-16.04z"}}]})(props);
	};
	module.exports.IoSnow = function IoSnow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461 349l-34-19.64a89.53 89.53 0 0120.94-16 22 22 0 00-21.28-38.51 133.62 133.62 0 00-38.55 32.1L300 256l88.09-50.86a133.46 133.46 0 0038.55 32.1 22 22 0 1021.28-38.51 89.74 89.74 0 01-20.94-16l34-19.64A22 22 0 10439 125l-34 19.63a89.74 89.74 0 01-3.42-26.15A22 22 0 00380 96h-.41a22 22 0 00-22 21.59 133.61 133.61 0 008.5 49.41L278 217.89V116.18a133.5 133.5 0 0047.07-17.33 22 22 0 00-22.71-37.69A89.56 89.56 0 01278 71.27V38a22 22 0 00-44 0v33.27a89.56 89.56 0 01-24.36-10.11 22 22 0 10-22.71 37.69A133.5 133.5 0 00234 116.18v101.71L145.91 167a133.61 133.61 0 008.52-49.43 22 22 0 00-22-21.59H132a22 22 0 00-21.59 22.41 89.74 89.74 0 01-3.41 26.19L73 125a22 22 0 10-22 38.1l34 19.64a89.74 89.74 0 01-20.94 16 22 22 0 1021.28 38.51 133.62 133.62 0 0038.55-32.1L212 256l-88.09 50.86a133.62 133.62 0 00-38.55-32.1 22 22 0 10-21.28 38.51 89.74 89.74 0 0120.94 16L51 349a22 22 0 1022 38.1l34-19.63a89.74 89.74 0 013.42 26.15A22 22 0 00132 416h.41a22 22 0 0022-21.59 133.61 133.61 0 00-8.5-49.41L234 294.11v101.71a133.5 133.5 0 00-47.07 17.33 22 22 0 1022.71 37.69A89.56 89.56 0 01234 440.73V474a22 22 0 0044 0v-33.27a89.56 89.56 0 0124.36 10.11 22 22 0 0022.71-37.69A133.5 133.5 0 00278 395.82V294.11L366.09 345a133.61 133.61 0 00-8.52 49.43 22 22 0 0022 21.59h.43a22 22 0 0021.59-22.41 89.74 89.74 0 013.41-26.19l34 19.63A22 22 0 10461 349z"}}]})(props);
	};
	module.exports.IoSparklesOutline = function IoSparklesOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M259.92 262.91L216.4 149.77a9 9 0 00-16.8 0l-43.52 113.14a9 9 0 01-5.17 5.17L37.77 311.6a9 9 0 000 16.8l113.14 43.52a9 9 0 015.17 5.17l43.52 113.14a9 9 0 0016.8 0l43.52-113.14a9 9 0 015.17-5.17l113.14-43.52a9 9 0 000-16.8l-113.14-43.52a9 9 0 01-5.17-5.17zM108 68L88 16 68 68 16 88l52 20 20 52 20-52 52-20-52-20zm318.67 49.33L400 48l-26.67 69.33L304 144l69.33 26.67L400 240l26.67-69.33L496 144l-69.33-26.67z"}}]})(props);
	};
	module.exports.IoSparklesSharp = function IoSparklesSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 512l-52.38-139.62L16 320l139.62-52.38L208 128l52.38 139.62L400 320l-139.62 52.38zM88 176l-23.57-64.43L0 88l64.43-23.57L88 0l23.57 64.43L176 88l-64.43 23.57zm312 80l-31.11-80.89L288 144l80.89-31.11L400 32l31.11 80.89L512 144l-80.89 31.11z"}}]})(props);
	};
	module.exports.IoSparkles = function IoSparkles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 512a24.84 24.84 0 01-23.34-16l-39.84-103.6a16.06 16.06 0 00-9.19-9.19L32 343.34a25 25 0 010-46.68l103.6-39.84a16.06 16.06 0 009.19-9.19L184.66 144a25 25 0 0146.68 0l39.84 103.6a16.06 16.06 0 009.19 9.19l103 39.63a25.49 25.49 0 0116.63 24.1 24.82 24.82 0 01-16 22.82l-103.6 39.84a16.06 16.06 0 00-9.19 9.19L231.34 496A24.84 24.84 0 01208 512zm66.85-254.84zM88 176a14.67 14.67 0 01-13.69-9.4l-16.86-43.84a7.28 7.28 0 00-4.21-4.21L9.4 101.69a14.67 14.67 0 010-27.38l43.84-16.86a7.31 7.31 0 004.21-4.21L74.16 9.79A15 15 0 0186.23.11a14.67 14.67 0 0115.46 9.29l16.86 43.84a7.31 7.31 0 004.21 4.21l43.84 16.86a14.67 14.67 0 010 27.38l-43.84 16.86a7.28 7.28 0 00-4.21 4.21l-16.86 43.84A14.67 14.67 0 0188 176zm312 80a16 16 0 01-14.93-10.26l-22.84-59.37a8 8 0 00-4.6-4.6l-59.37-22.84a16 16 0 010-29.86l59.37-22.84a8 8 0 004.6-4.6l22.67-58.95a16.45 16.45 0 0113.17-10.57 16 16 0 0116.86 10.15l22.84 59.37a8 8 0 004.6 4.6l59.37 22.84a16 16 0 010 29.86l-59.37 22.84a8 8 0 00-4.6 4.6l-22.84 59.37A16 16 0 01400 256z"}}]})(props);
	};
	module.exports.IoSpeedometerOutline = function IoSpeedometerOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M326.1 231.9l-47.5 75.5a31 31 0 01-7 7 30.11 30.11 0 01-35-49l75.5-47.5a10.23 10.23 0 0111.7 0 10.06 10.06 0 012.3 14z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 64C132.3 64 32 164.2 32 287.9a223.18 223.18 0 0056.3 148.5c1.1 1.2 2.1 2.4 3.2 3.5a25.19 25.19 0 0037.1-.1 173.13 173.13 0 01254.8 0 25.19 25.19 0 0037.1.1l3.2-3.5A223.18 223.18 0 00480 287.9C480 164.2 379.7 64 256 64z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 128v32m160 128h-32m-256 0H96m69.49-90.51l-22.63-22.63m203.65 22.63l22.63-22.63"}}]})(props);
	};
	module.exports.IoSpeedometerSharp = function IoSpeedometerSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C123.46 48 16 156.55 16 290.56a243.3 243.3 0 0060.32 160.87c1.18 1.3 2.25 2.6 3.43 3.79C89.2 464 92.07 464 99.57 464s12.43 0 19.93-8.88C152 416.64 202 400 256 400s104.07 16.71 136.5 55.12C400 464 404.82 464 412.43 464s11.3 0 19.82-8.78c1.22-1.25 2.25-2.49 3.43-3.79A243.3 243.3 0 00496 290.56C496 156.55 388.54 48 256 48zm-16 64h32v64h-32zm-96 192H80v-32h64zm21.49-83.88l-45.25-45.26 22.62-22.62 45.26 45.25zM278.6 307.4a31 31 0 01-7 7 30.11 30.11 0 01-35-49L320 224zm45.28-109.91l45.26-45.25 22.62 22.62-45.25 45.26zM432 304h-64v-32h64z"}}]})(props);
	};
	module.exports.IoSpeedometer = function IoSpeedometer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M425.7 118.25A240 240 0 0076.32 447l.18.2c.33.35.64.71 1 1.05.74.84 1.58 1.79 2.57 2.78a41.17 41.17 0 0060.36-.42 157.13 157.13 0 01231.26 0 41.18 41.18 0 0060.65.06l3.21-3.5.18-.2a239.93 239.93 0 00-10-328.76zM240 128a16 16 0 0132 0v32a16 16 0 01-32 0zM128 304H96a16 16 0 010-32h32a16 16 0 010 32zm48.8-95.2a16 16 0 01-22.62 0l-22.63-22.62a16 16 0 0122.63-22.63l22.62 22.63a16 16 0 010 22.62zm149.3 23.1l-47.5 75.5a31 31 0 01-7 7 30.11 30.11 0 01-35-49l75.5-47.5a10.23 10.23 0 0111.7 0 10.06 10.06 0 012.3 14zm31.72-23.1a16 16 0 01-22.62-22.62l22.62-22.63a16 16 0 0122.63 22.63zm65.88 227.6zM416 304h-32a16 16 0 010-32h32a16 16 0 010 32z"}}]})(props);
	};
	module.exports.IoSquareOutline = function IoSquareOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M416 448H96a32.09 32.09 0 01-32-32V96a32.09 32.09 0 0132-32h320a32.09 32.09 0 0132 32v320a32.09 32.09 0 01-32 32z"}}]})(props);
	};
	module.exports.IoSquareSharp = function IoSquareSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 48h416v416H48z"}}]})(props);
	};
	module.exports.IoSquare = function IoSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 464H96a48.05 48.05 0 01-48-48V96a48.05 48.05 0 0148-48h320a48.05 48.05 0 0148 48v320a48.05 48.05 0 01-48 48z"}}]})(props);
	};
	module.exports.IoStarHalfOutline = function IoStarHalfOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"}},{"tag":"path","attr":{"d":"M256 48v316L118 464l54-160-140-96h172l52-160z"}}]})(props);
	};
	module.exports.IoStarHalfSharp = function IoStarHalfSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 203.3H312.36L256 32l-56.36 171.3H16l150.21 105.4-58.5 171.3L256 373.84 404.29 480l-58.61-171.3zM274.63 347.82L256 334.49v-200.1l26 78.91 7.24 22h105.39l-67.32 47.2-19.69 13.81 7.78 22.75 26.26 76.75z"}}]})(props);
	};
	module.exports.IoStarHalf = function IoStarHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"}},{"tag":"path","attr":{"d":"M256 48v316L118 464l54-160-140-96h172l52-160z"}}]})(props);
	};
	module.exports.IoStarOutline = function IoStarOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"}}]})(props);
	};
	module.exports.IoStarSharp = function IoStarSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 203.3H312.36L256 32l-56.36 171.3H16l150.21 105.4-58.5 171.3L256 373.84 404.29 480l-58.61-171.3z"}}]})(props);
	};
	module.exports.IoStar = function IoStar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"}}]})(props);
	};
	module.exports.IoStatsChartOutline = function IoStatsChartOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"48","height":"160","x":"64","y":"320","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"48","height":"256","x":"288","y":"224","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"48","height":"368","x":"400","y":"112","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"8","ry":"8"}},{"tag":"rect","attr":{"width":"48","height":"448","x":"176","y":"32","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"8","ry":"8"}}]})(props);
	};
	module.exports.IoStatsChartSharp = function IoStatsChartSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 496H48V304h80zm224 0h-80V208h80zm112 0h-80V96h80zm-224 0h-80V16h80z"}}]})(props);
	};
	module.exports.IoStatsChart = function IoStatsChart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M104 496H72a24 24 0 01-24-24V328a24 24 0 0124-24h32a24 24 0 0124 24v144a24 24 0 01-24 24zm224 0h-32a24 24 0 01-24-24V232a24 24 0 0124-24h32a24 24 0 0124 24v240a24 24 0 01-24 24zm112 0h-32a24 24 0 01-24-24V120a24 24 0 0124-24h32a24 24 0 0124 24v352a24 24 0 01-24 24zm-224 0h-32a24 24 0 01-24-24V40a24 24 0 0124-24h32a24 24 0 0124 24v432a24 24 0 01-24 24z"}}]})(props);
	};
	module.exports.IoStopCircleOutline = function IoStopCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"d":"M310.4 336H201.6a25.62 25.62 0 01-25.6-25.6V201.6a25.62 25.62 0 0125.6-25.6h108.8a25.62 25.62 0 0125.6 25.6v108.8a25.62 25.62 0 01-25.6 25.6z"}}]})(props);
	};
	module.exports.IoStopCircleSharp = function IoStopCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 288H176V176h160z"}}]})(props);
	};
	module.exports.IoStopCircle = function IoStopCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 262.4a25.62 25.62 0 01-25.6 25.6H201.6a25.62 25.62 0 01-25.6-25.6V201.6a25.62 25.62 0 0125.6-25.6h108.8a25.62 25.62 0 0125.6 25.6z"}}]})(props);
	};
	module.exports.IoStopOutline = function IoStopOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"320","height":"320","x":"96","y":"96","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"24","ry":"24"}}]})(props);
	};
	module.exports.IoStopSharp = function IoStopSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 80h352v352H80z"}}]})(props);
	};
	module.exports.IoStop = function IoStop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M392 432H120a40 40 0 01-40-40V120a40 40 0 0140-40h272a40 40 0 0140 40v272a40 40 0 01-40 40z"}}]})(props);
	};
	module.exports.IoStopwatchOutline = function IoStopwatchOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 232v-80"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M256 88V72m-124 60l-12-12"}},{"tag":"circle","attr":{"cx":"256","cy":"272","r":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 96a176 176 0 10176 176A176 176 0 00256 96z"}}]})(props);
	};
	module.exports.IoStopwatchSharp = function IoStopwatchSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M280 81.5V48h-48v33.5a191 191 0 00-84.43 32.13L120 86l-34 34 25.59 25.59A191.17 191.17 0 0064 272c0 105.87 86.13 192 192 192s192-86.13 192-192c0-97.74-73.42-178.66-168-190.5zM256 320a48 48 0 01-16-93.25V136h32v90.75A48 48 0 01256 320z"}}]})(props);
	};
	module.exports.IoStopwatch = function IoStopwatch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"272","r":"16"}},{"tag":"path","attr":{"d":"M280 81.5V72a24 24 0 00-48 0v9.5a191 191 0 00-84.43 32.13L137 103a24 24 0 00-34 34l8.6 8.6A191.17 191.17 0 0064 272c0 105.87 86.13 192 192 192s192-86.13 192-192c0-97.74-73.42-178.66-168-190.5zM256 320a48 48 0 01-16-93.25V152a16 16 0 0132 0v74.75A48 48 0 01256 320z"}}]})(props);
	};
	module.exports.IoStorefrontOutline = function IoStorefrontOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M448 448V240m-384 0v208M382.47 48H129.53c-21.79 0-41.47 12-49.93 30.46L36.3 173c-14.58 31.81 9.63 67.85 47.19 69h2c31.4 0 56.85-25.18 56.85-52.23 0 27 25.46 52.23 56.86 52.23s56.8-23.38 56.8-52.23c0 27 25.45 52.23 56.85 52.23s56.86-23.38 56.86-52.23c0 28.85 25.45 52.23 56.85 52.23h1.95c37.56-1.17 61.77-37.21 47.19-69l-43.3-94.54C423.94 60 404.26 48 382.47 48zM32 464h448M136 288h80a24 24 0 0124 24v88h0-128 0v-88a24 24 0 0124-24zm152 176V312a24 24 0 0124-24h64a24 24 0 0124 24v152"}}]})(props);
	};
	module.exports.IoStorefrontSharp = function IoStorefrontSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 448V267.85a104.76 104.76 0 01-33.56 6.58c-1.18 0-2.3.05-3.4.05a108 108 0 01-56.86-16 108 108 0 01-56.85 16 106.16 106.16 0 01-56.51-16.2 107.84 107.84 0 01-57.2 16.2 106.14 106.14 0 01-56.85-16.42 106.14 106.14 0 01-56.85 16.42c-1.09 0-2.19 0-3.37-.05h-.06A104.66 104.66 0 0148 267.49V448H16v32h480v-32zm-240-64h-96v-76a4 4 0 014-4h88a4 4 0 014 4zm160 64h-80V308a4 4 0 014-4h72a4 4 0 014 4zm108.57-277.72L445.89 64C432 32 432 32 400 32H112c-32 0-32 0-45.94 32L19.38 170.28c-9 19.41 2.89 39.34 2.9 39.35l.41.66c.42.66 1.13 1.75 1.62 2.37.1.13.19.27.28.4l5.24 6.39 5.31 5.14.42.36a69.65 69.65 0 009.44 6.78v.05a74 74 0 0036 10.67h2.47a76.08 76.08 0 0051.89-20.31 72.38 72.38 0 005.77-6 74.18 74.18 0 005.78 6 76.08 76.08 0 0051.89 20.31c23.28 0 44.07-10 57.63-25.56a.11.11 0 01.15 0l5.66 5.26a76.09 76.09 0 0051.9 20.31c23.29 0 44.11-10 57.66-25.61 13.56 15.61 34.37 25.61 57.67 25.61h2.49a71.35 71.35 0 0035-10.7c.95-.57 1.86-1.17 2.78-1.77A71.33 71.33 0 00488 212.17l2-3c.9-2.04 11.21-20.3 2.57-38.89z"}}]})(props);
	};
	module.exports.IoStorefront = function IoStorefront (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 448h-12a4 4 0 01-4-4V273.51a4 4 0 00-5.24-3.86 104.92 104.92 0 01-28.32 4.78c-1.18 0-2.3.05-3.4.05a108.22 108.22 0 01-52.85-13.64 8.23 8.23 0 00-8 0 108.18 108.18 0 01-52.84 13.64 106.11 106.11 0 01-52.46-13.79 8.21 8.21 0 00-8.09 0 108.14 108.14 0 01-53.16 13.8 106.19 106.19 0 01-52.77-14 8.25 8.25 0 00-8.16 0 106.19 106.19 0 01-52.77 14c-1.09 0-2.19 0-3.37-.05h-.06a104.91 104.91 0 01-29.28-5.09 4 4 0 00-5.23 3.8V444a4 4 0 01-4 4H32.5c-8.64 0-16.1 6.64-16.48 15.28A16 16 0 0032 480h447.5c8.64 0 16.1-6.64 16.48-15.28A16 16 0 00480 448zm-256-68a4 4 0 01-4 4h-88a4 4 0 01-4-4v-64a12 12 0 0112-12h72a12 12 0 0112 12zm156 68h-72a4 4 0 01-4-4V316a12 12 0 0112-12h56a12 12 0 0112 12v128a4 4 0 01-4 4zm112.57-277.72l-42.92-98.49C438.41 47.62 412.74 32 384.25 32H127.7c-28.49 0-54.16 15.62-65.4 39.79l-42.92 98.49c-9 19.41 2.89 39.34 2.9 39.35l.28.45c.49.78 1.36 2 1.89 2.78.05.06.09.13.14.2l5 6.05a7.45 7.45 0 00.6.65l5 4.83.42.36a69.65 69.65 0 009.39 6.78v.05a74 74 0 0036 10.67h2.47a76.08 76.08 0 0051.89-20.31l.33-.31a7.94 7.94 0 0110.89 0l.33.31a77.3 77.3 0 00104.46 0 8 8 0 0110.87 0 77.31 77.31 0 00104.21.23 7.88 7.88 0 0110.71 0 76.81 76.81 0 0052.31 20.08h2.49a71.35 71.35 0 0035-10.7c.95-.57 1.86-1.17 2.78-1.77A71.33 71.33 0 00488 212.17l1.74-2.63q.26-.4.48-.84c1.66-3.38 10.56-20.76 2.35-38.42z"}}]})(props);
	};
	module.exports.IoSubwayOutline = function IoSubwayOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"288","height":"352","x":"112","y":"32","fill":"none","strokeMiterlimit":"10","strokeWidth":"32","rx":"48","ry":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M208 80h96"}},{"tag":"rect","attr":{"width":"288","height":"96","x":"112","y":"128","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"32","ry":"32"}},{"tag":"circle","attr":{"cx":"176","cy":"320","r":"16","fill":"none","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"circle","attr":{"cx":"336","cy":"320","r":"16","fill":"none","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M144 464h224m-32-32l48 48m-208-48l-48 48"}}]})(props);
	};
	module.exports.IoSubwaySharp = function IoSubwaySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M392 16H120a24 24 0 00-24 24v336a24 24 0 0024 24h272a24 24 0 0024-24V40a24 24 0 00-24-24zM208 64h95.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 96h-95.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01208 64zm-28.53 287.82a32 32 0 1128.35-28.35 32 32 0 01-28.35 28.35zm160 0a32 32 0 1128.35-28.35 32 32 0 01-28.35 28.35zM384 144v64H128v-64zm-86 272l31.37 32H182.63L214 416h-44l-80.57 80h45.2l16-16h210.74l16 16h45.3L343 416h-45z"}}]})(props);
	};
	module.exports.IoSubway = function IoSubway (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 16H160a64.07 64.07 0 00-64 64v256a64.07 64.07 0 0064 64h192a64.07 64.07 0 0064-64V80a64.07 64.07 0 00-64-64zM208 64h96a16 16 0 010 32h-96a16 16 0 010-32zm-32 288a32 32 0 1132-32 32 32 0 01-32 32zm160 0a32 32 0 1132-32 32 32 0 01-32 32zm48-160a16 16 0 01-16 16H144a16 16 0 01-16-16v-32a16 16 0 0116-16h224a16 16 0 0116 16zm-36.69 228.69a16 16 0 00-22.62 22.62l4.68 4.69H182.63l4.68-4.69a16 16 0 00-22.62-22.62l-48 48a16 16 0 1022.62 22.62L150.63 480h210.74l11.32 11.31a16 16 0 0022.62-22.62z"}}]})(props);
	};
	module.exports.IoSunnyOutline = function IoSunnyOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 48v48m0 320v48m147.08-355.08l-33.94 33.94M142.86 369.14l-33.94 33.94M464 256h-48m-320 0H48m355.08 147.08l-33.94-33.94M142.86 142.86l-33.94-33.94"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"80","fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoSunnySharp = function IoSunnySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M234 26h44v92h-44zm0 368h44v92h-44zm104.025-251.143l65.054-65.054 31.113 31.113-65.054 65.054zM77.815 403.074l65.054-65.054 31.113 31.113-65.054 65.054zM394 234h92v44h-92zm-368 0h92v44H26zm312.029 135.14l31.112-31.113 65.054 65.054-31.112 31.112zM77.802 108.92l31.113-31.113 65.054 65.054-31.113 31.112zM256 358a102 102 0 11102-102 102.12 102.12 0 01-102 102z"}}]})(props);
	};
	module.exports.IoSunny = function IoSunny (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 118a22 22 0 01-22-22V48a22 22 0 0144 0v48a22 22 0 01-22 22zm0 368a22 22 0 01-22-22v-48a22 22 0 0144 0v48a22 22 0 01-22 22zm113.14-321.14a22 22 0 01-15.56-37.55l33.94-33.94a22 22 0 0131.11 31.11l-33.94 33.94a21.93 21.93 0 01-15.55 6.44zM108.92 425.08a22 22 0 01-15.55-37.56l33.94-33.94a22 22 0 1131.11 31.11l-33.94 33.94a21.94 21.94 0 01-15.56 6.45zM464 278h-48a22 22 0 010-44h48a22 22 0 010 44zm-368 0H48a22 22 0 010-44h48a22 22 0 010 44zm307.08 147.08a21.94 21.94 0 01-15.56-6.45l-33.94-33.94a22 22 0 0131.11-31.11l33.94 33.94a22 22 0 01-15.55 37.56zM142.86 164.86a21.89 21.89 0 01-15.55-6.44l-33.94-33.94a22 22 0 0131.11-31.11l33.94 33.94a22 22 0 01-15.56 37.55zM256 358a102 102 0 11102-102 102.12 102.12 0 01-102 102z"}}]})(props);
	};
	module.exports.IoSwapHorizontalOutline = function IoSwapHorizontalOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"}}]})(props);
	};
	module.exports.IoSwapHorizontalSharp = function IoSwapHorizontalSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"}}]})(props);
	};
	module.exports.IoSwapHorizontal = function IoSwapHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"}}]})(props);
	};
	module.exports.IoSwapVerticalOutline = function IoSwapVerticalOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M464 208L352 96 240 208m112-94.87V416M48 304l112 112 112-112m-112 94V96"}}]})(props);
	};
	module.exports.IoSwapVerticalSharp = function IoSwapVerticalSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M464 208L352 96 240 208m112-94.87V416M48 304l112 112 112-112m-112 94V96"}}]})(props);
	};
	module.exports.IoSwapVertical = function IoSwapVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M464 208L352 96 240 208m112-94.87V416M48 304l112 112 112-112m-112 94V96"}}]})(props);
	};
	module.exports.IoSyncCircleOutline = function IoSyncCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M351.82 271.87v-16A96.15 96.15 0 00184.09 192m-24.2 48.17v16A96.22 96.22 0 00327.81 320"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M135.87 256l23.59-23.6 24.67 23.6m192 0l-23.59 23.6-24.67-23.6"}}]})(props);
	};
	module.exports.IoSyncCircleSharp = function IoSyncCircleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm0 320a112.19 112.19 0 01-111.27-98.23l-8.86 8.86L113.24 256l46-46 47.55 45.48-22.12 23.12-7.2-6.88a80.26 80.26 0 00138.48 37.5l23.77 21.41A112.82 112.82 0 01256 368zm96.79-66l-47.55-45.5 22.12-23.12 6.86 6.55A80.2 80.2 0 00196 202.64l-23.82-21.37A112.18 112.18 0 01367 242.49l9.11-9.12L398.76 256z"}}]})(props);
	};
	module.exports.IoSyncCircle = function IoSyncCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm83.69 282.65a112.24 112.24 0 01-195-61.29 16 16 0 01-20.13-24.67l23.6-23.6a16 16 0 0122.37-.25l24.67 23.6a16 16 0 01-18 26 80.25 80.25 0 00138.72 38.83 16 16 0 0123.77 21.41zm47.76-63.34l-23.6 23.6a16 16 0 01-22.37.25l-24.67-23.6a16 16 0 0117.68-26.11A80.17 80.17 0 00196 202.64a16 16 0 11-23.82-21.37 112.17 112.17 0 01194.88 61.57 16 16 0 0120.39 24.47z"}}]})(props);
	};
	module.exports.IoSyncOutline = function IoSyncOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 00-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 00140-66.92"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M32 256l44-44 46 44m358 0l-44 44-46-44"}}]})(props);
	};
	module.exports.IoSyncSharp = function IoSyncSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 00-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 00140-66.92"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M32 256l44-44 46 44m358 0l-44 44-46-44"}}]})(props);
	};
	module.exports.IoSync = function IoSync (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 00-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 00140-66.92"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M32 256l44-44 46 44m358 0l-44 44-46-44"}}]})(props);
	};
	module.exports.IoTabletLandscapeOutline = function IoTabletLandscapeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"352","height":"480","x":"80","y":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48","transform":"rotate(-90 256 256)"}}]})(props);
	};
	module.exports.IoTabletLandscapeSharp = function IoTabletLandscapeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 82v348a18 18 0 0018 18h476a18 18 0 0018-18V82a18 18 0 00-18-18H18A18 18 0 000 82zm448 330H64V100h384z"}}]})(props);
	};
	module.exports.IoTabletLandscape = function IoTabletLandscape (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 128v256a64.07 64.07 0 01-64 64H64a64.07 64.07 0 01-64-64V128a64.07 64.07 0 0164-64h384a64.07 64.07 0 0164 64zM32 384a32 32 0 0032 32h384a32 32 0 0032-32V128a32 32 0 00-32-32H64a32 32 0 00-32 32z"}},{"tag":"path","attr":{"d":"M0 128a64.07 64.07 0 0164-64h384a64.07 64.07 0 0164 64v256a64.07 64.07 0 01-64 64H64a64.07 64.07 0 01-64-64V128m480 256V128a32 32 0 00-32-32H64a32 32 0 00-32 32v256a32 32 0 0032 32h384a32 32 0 0032-32m-16 0a16 16 0 01-16 16H64a16 16 0 01-16-16V128a16 16 0 0116-16h384a16 16 0 0116 16v256z"}}]})(props);
	};
	module.exports.IoTabletPortraitOutline = function IoTabletPortraitOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"352","height":"480","x":"80","y":"16","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}}]})(props);
	};
	module.exports.IoTabletPortraitSharp = function IoTabletPortraitSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M430 0H82a18 18 0 00-18 18v476a18 18 0 0018 18h348a18 18 0 0018-18V18a18 18 0 00-18-18zM100 448V64h312v384z"}}]})(props);
	};
	module.exports.IoTabletPortrait = function IoTabletPortrait (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 512H128a64.07 64.07 0 01-64-64V64a64.07 64.07 0 0164-64h256a64.07 64.07 0 0164 64v384a64.07 64.07 0 01-64 64zM128 32a32 32 0 00-32 32v384a32 32 0 0032 32h256a32 32 0 0032-32V64a32 32 0 00-32-32z"}},{"tag":"path","attr":{"d":"M384 0a64.07 64.07 0 0164 64v384a64.07 64.07 0 01-64 64H128a64.07 64.07 0 01-64-64V64a64.07 64.07 0 0164-64h256M128 480h256a32 32 0 0032-32V64a32 32 0 00-32-32H128a32 32 0 00-32 32v384a32 32 0 0032 32m0-16a16 16 0 01-16-16V64a16 16 0 0116-16h256a16 16 0 0116 16v384a16 16 0 01-16 16z"}}]})(props);
	};
	module.exports.IoTelescopeOutline = function IoTelescopeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M39.93 327.56l-4.71-8.13A24 24 0 0144 286.64l86.87-50.07a16 16 0 0121.89 5.86l12.71 22a16 16 0 01-5.86 21.85l-86.85 50.07a24.06 24.06 0 01-32.83-8.79z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M170.68 273.72L147.12 233a24 24 0 018.8-32.78l124.46-71.75a16 16 0 0121.89 5.86l31.57 54.59a16 16 0 01-5.84 21.84L203.51 282.5a24 24 0 01-32.83-8.78zm171.17-71.51l-46.51-80.43a24 24 0 018.8-32.78l93.29-53.78A24.07 24.07 0 01430.27 44l46.51 80.43a24 24 0 01-8.8 32.79L374.69 211a24.06 24.06 0 01-32.84-8.79zM127.59 480l96.14-207.99m48.07-15.99L368.55 448"}}]})(props);
	};
	module.exports.IoTelescopeSharp = function IoTelescopeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M1.41 292.9l44.82 76.97 98.14-56.38-44.73-77.37L1.41 292.9z"}},{"tag":"path","attr":{"d":"M287.87 252.34l23.67-13.81-63.42-110-132.92 77C133.75 237.51 176 310 176 310l15.53-8.32c.24-.13.55 0 .83 0L102.65 496h35.16l99.05-214.25 23.24-13.4L358 464h36zM262.08 96c24.81 42.23 60.25 104.25 86.4 148.76L510.79 151 424.07 1.41z"}}]})(props);
	};
	module.exports.IoTelescope = function IoTelescope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M107.56 250a16 16 0 00-21.85-5.86L36 272.81a39.71 39.71 0 00-18.8 24.91 40.9 40.9 0 004.55 30.35l4.36 7.54a40 40 0 0054.62 14.62l49.67-28.63a16 16 0 005.87-21.86z"}},{"tag":"path","attr":{"d":"M382.84 440.8L288.72 254a2 2 0 01.79-2.63l8.3-4.79a16 16 0 005.86-21.86l-47.53-82.33a16 16 0 00-21.86-5.87l-86.38 49.8a39.73 39.73 0 00-18.65 24.28 34.82 34.82 0 00-1.37 9.76c.06 7.6 9.2 22.7 18.12 38.28 9.59 16.75 19.24 33.88 26.34 38.15 4.52 2.72 12.5 4.9 19.21 4.9h.84l-79.32 171.6a16 16 0 1029.05 13.42l93.68-202.65a7.94 7.94 0 013.26-3.57l19.21-11.08a2 2 0 012.78.84l93.21 185a16 16 0 0028.58-14.4zm107.37-325.06L444.09 36a40.08 40.08 0 00-54.63-14.62l-93.34 53.78a39.69 39.69 0 00-18.65 24.28 32.76 32.76 0 00-1.27 13.25c1.74 12.62 13 30.4 26.41 53.89 13.58 23.73 28.91 50.48 36.93 56.27a40.18 40.18 0 0023.18 7.37 39.77 39.77 0 0019.92-5.34L476 171.07a39.72 39.72 0 0018.79-24.84 41 41 0 00-4.58-30.49z"}}]})(props);
	};
	module.exports.IoTennisballOutline = function IoTennisballOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"208","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M461.43 271.44c-5.09.37-8.24.56-13.43.56-114.88 0-208-93.12-208-208 0-5.37.2-8.69.6-14M49.65 240.56S58.84 240 64 240c114.88 0 208 93.12 208 208 0 5.38-.61 14-.61 14"}}]})(props);
	};
	module.exports.IoTennisballSharp = function IoTennisballSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M246.4 480a181 181 0 003.22-22.86c.35-4.61.53-9.31.53-14 0-100-81.34-181.32-181.32-181.32A181.72 181.72 0 0032 265.61 224.2 224.2 0 00246.4 480z"}},{"tag":"path","attr":{"d":"M284.63 227.37A222.73 222.73 0 01219 68.83a227.09 227.09 0 012.62-34.42A224.41 224.41 0 0034.41 221.58 227.09 227.09 0 0168.83 219a222.73 222.73 0 01158.54 65.67A222.73 222.73 0 01293 443.17c0 5.74-.22 11.54-.65 17.23s-1.11 11.51-2 17.2a224.42 224.42 0 00187.24-187.18 227.09 227.09 0 01-34.42 2.58 222.73 222.73 0 01-158.54-65.63z"}},{"tag":"path","attr":{"d":"M443.17 250.15a181.72 181.72 0 0036.83-3.76A224.2 224.2 0 00265.61 32a181.72 181.72 0 00-3.76 36.83c0 99.98 81.34 181.32 181.32 181.32z"}}]})(props);
	};
	module.exports.IoTennisball = function IoTennisball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 256a192.55 192.55 0 0032-2.68A224 224 0 00258.68 32 192.55 192.55 0 00256 64c0 105.87 86.13 192 192 192zM253.35 480c.94-5.67 1.65-11.4 2.09-17.18.37-4.88.56-9.86.56-14.79 0-105.87-86.13-192-192-192a192.55 192.55 0 00-32 2.68A224 224 0 00253.35 480z"}},{"tag":"path","attr":{"d":"M289.61 222.39A222.53 222.53 0 01224 64a226.07 226.07 0 012-30A224.1 224.1 0 0034 226a226.07 226.07 0 0130-2 222.53 222.53 0 01158.39 65.61A222.53 222.53 0 01288 448c0 5.74-.22 11.53-.65 17.22q-.5 6.42-1.36 12.79A224.12 224.12 0 00478 286a226.07 226.07 0 01-30 2 222.53 222.53 0 01-158.39-65.61z"}}]})(props);
	};
	module.exports.IoTerminalOutline = function IoTerminalOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"448","height":"416","x":"32","y":"48","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M96 112l80 64-80 64m96 0h64"}}]})(props);
	};
	module.exports.IoTerminalSharp = function IoTerminalSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16 44v424a12 12 0 0012 12h456a12 12 0 0012-12V44a12 12 0 00-12-12H28a12 12 0 00-12 12zm57.51 193.5l76.88-61.5-76.88-61.5 20-25 108.1 86.5L93.5 262.49zM272 256h-96v-32h96z"}}]})(props);
	};
	module.exports.IoTerminal = function IoTerminal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 32H80a64.07 64.07 0 00-64 64v320a64.07 64.07 0 0064 64h352a64.07 64.07 0 0064-64V96a64.07 64.07 0 00-64-64zM96 256a16 16 0 01-10-28.49L150.39 176 86 124.49a16 16 0 1120-25l80 64a16 16 0 010 25l-80 64A16 16 0 0196 256zm160 0h-64a16 16 0 010-32h64a16 16 0 010 32z"}}]})(props);
	};
	module.exports.IoTextOutline = function IoTextOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M32 415.5l120-320 120 320m-42-112H74m252-64c12.19-28.69 41-48 74-48h0c46 0 80 32 80 80v144"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 358.5c0 36 26.86 58 60 58 54 0 100-27 100-106v-15c-20 0-58 1-92 5-32.77 3.86-68 19-68 58z"}}]})(props);
	};
	module.exports.IoTextSharp = function IoTextSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M404.42 170c-41.23 0-78.07 24.06-93.85 61.3L304 246.52l40.33 17.18 6.56-15.22c8.9-21 29.91-34.55 53.53-34.55 34.55 0 57.76 23.27 57.76 57.91v2.3c-22.12.59-48.65 2.05-72.27 4.84-54.52 6.43-87.06 36.23-87.06 79.72 0 23.16 8.72 44 24.56 58.59C342.28 431 362.55 438 384.51 438c30.86 0 57.5-7.33 77.67-22.64V438H506V271.84C506 212.83 463.28 170 404.42 170zm-19.91 225.07c-17.46 0-37.85-9.84-37.85-36.37 0-10.65 3.82-18.11 12.38-24.19 8.34-5.92 21.12-10.15 36-11.9 21.78-2.57 46.31-3.95 67-4.52-2.16 51.49-27.57 76.98-77.53 76.98zm-291.26-69.2h125.5L260.94 438H308L155 48 4 438h47.06zM156 160.71L202.25 282h-92.5z"}}]})(props);
	};
	module.exports.IoText = function IoText (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M292.6 407.78l-120-320a22 22 0 00-41.2 0l-120 320a22 22 0 0041.2 15.44l36.16-96.42a2 2 0 011.87-1.3h122.74a2 2 0 011.87 1.3l36.16 96.42a22 22 0 0041.2-15.44zm-185.84-129l43.37-115.65a2 2 0 013.74 0l43.37 115.67a2 2 0 01-1.87 2.7h-86.74a2 2 0 01-1.87-2.7zM400.77 169.5c-41.72-.3-79.08 23.87-95 61.4a22 22 0 0040.5 17.2c8.88-20.89 29.77-34.44 53.32-34.6 32.32-.22 58.41 26.5 58.41 58.85a1.5 1.5 0 01-1.45 1.5c-21.92.61-47.92 2.07-71.12 4.8-54.75 6.44-87.43 36.29-87.43 79.85 0 23.19 8.76 44 24.67 58.68C337.6 430.93 358 438.5 380 438.5c31 0 57.69-8 77.94-23.22h.06a22 22 0 1044 .19v-143c0-56.18-45-102.56-101.23-102.97zM380 394.5c-17.53 0-38-9.43-38-36 0-10.67 3.83-18.14 12.43-24.23 8.37-5.93 21.2-10.16 36.14-11.92 21.12-2.49 44.82-3.86 65.14-4.47a2 2 0 012 2.1C455 370.1 429.46 394.5 380 394.5z"}}]})(props);
	};
	module.exports.IoThermometerOutline = function IoThermometerOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M307.72 302.27a8 8 0 01-3.72-6.75V80a48 48 0 00-48-48h0a48 48 0 00-48 48v215.52a8 8 0 01-3.71 6.74 97.51 97.51 0 00-44.19 86.07A96 96 0 00352 384a97.49 97.49 0 00-44.28-81.73zM256 112v272"}},{"tag":"circle","attr":{"cx":"256","cy":"384","r":"48"}}]})(props);
	};
	module.exports.IoThermometerSharp = function IoThermometerSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 291.24V80a64 64 0 10-128 0v211.24A113.39 113.39 0 00144 384a112 112 0 00224 0 113.39 113.39 0 00-48-92.76zM256 432a48 48 0 01-16-93.26V96h32v242.74A48 48 0 01256 432z"}}]})(props);
	};
	module.exports.IoThermometer = function IoThermometer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 287.18V81c0-35.12-27.89-64.42-63-64.95a64.08 64.08 0 00-65 64v207.13a8 8 0 01-3.18 6.37A113.48 113.48 0 00144 384a112 112 0 00224 0 113.48 113.48 0 00-44.82-90.45 8 8 0 01-3.18-6.37zM254.07 432a48 48 0 01-22-89.54 16 16 0 008-13.84V112.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 112v216.58a16.18 16.18 0 008.15 13.94A48 48 0 01254.07 432z"}}]})(props);
	};
	module.exports.IoThumbsDownOutline = function IoThumbsDownOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M192 53.84S208 48 256 48s74 16 96 32h64a64 64 0 0164 64v48a64 64 0 01-64 64h-30a32.34 32.34 0 00-27.37 15.4S350 290.19 324 335.22 248 448 240 464c-29 0-43-22-34-47.71 10.28-29.39 23.71-54.38 27.46-87.09.54-4.78-3.14-12-8-12L96 307"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M96 241l80 2c20 1.84 32 12.4 32 30h0c0 17.6-14 28.84-32 30l-80 4c-17.6 0-32-16.4-32-34v-.17A32 32 0 0196 241zm-32-65l112 2c18 .84 32 12.41 32 30h0c0 17.61-14 28.86-32 30l-112 2a32.1 32.1 0 01-32-32h0a32.1 32.1 0 0132-32zm48-128l64 3c21 1.84 32 11.4 32 29h0c0 17.6-14.4 30-32 30l-64 2a32.09 32.09 0 01-32-32h0a32.09 32.09 0 0132-32zm-32 64l96 2c19 .84 32 12.4 32 30h0c0 17.6-13 28.84-32 30l-96 2a32.09 32.09 0 01-32-32h0a32.09 32.09 0 0132-32z"}}]})(props);
	};
	module.exports.IoThumbsDownSharp = function IoThumbsDownSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M56 320l156.05 12-23 89.4c-6.08 26.6.7 41.87 22.39 48.62l34.69 9.85a4 4 0 004.4-1.72l129-202.34a8 8 0 016.81-3.81H496V64H378.39a48 48 0 01-15.18-2.46l-76.3-25.43a80 80 0 00-25.3-4.11H83.68c-19 0-31.5 13.52-35.23 32.16L16 206.42V280c0 22.06 18 38 40 40z"}},{"tag":"path","attr":{"fill":"none","d":"M378.45 273.93A15.84 15.84 0 01386 272a15.93 15.93 0 00-7.51 1.91zm-40.59 69.29l-.13.22a2.53 2.53 0 01.13-.22c20.5-35.51 30.36-55 33.82-62-3.47 7.06-13.34 26.51-33.82 62z"}},{"tag":"path","attr":{"d":"M372.66 279.16l-1 2a16.29 16.29 0 016.77-7.26 16.48 16.48 0 00-5.77 5.26z"}}]})(props);
	};
	module.exports.IoThumbsDown = function IoThumbsDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M39.94 178l144.16 6.12c4.61.36 23.9 1.22 23.9 25.88 0 23.8-19.16 25.33-24.14 25.88L39.94 242C27.27 241.87 16 227.56 16 210s11.27-31.87 23.94-32zm141.45 131.66L74.65 318C62 318 48 301.31 48 284.12v-.33c0-16.33 11.14-29.63 24.88-29.79l108.45 1.72C208 259 208 275.16 208 282.12c0 22.88-21.8 27.14-26.61 27.54zM90.15 32l89.37 8.93C204 41.86 208 58.18 208 68.4c0 18.39-13.41 24.6-26.67 24.6l-91 3C75.78 95.78 64 81.51 64 64s11.68-31.66 26.15-32zm-34.36 71.5l126.4 6.22c9.39.63 25.81 3 25.81 26.36 0 12-4.35 25.62-25 27.53L55.79 167.5C42.65 167.35 32 154 32 136.08s10.65-32.43 23.79-32.58z"}},{"tag":"path","attr":{"fill":"none","d":"M378.45 273.93A15.84 15.84 0 01386 272a15.93 15.93 0 00-7.51 1.91zm-40.59 69.29l-.13.22a2.53 2.53 0 01.13-.22c20.5-35.51 30.36-55 33.82-62-3.47 7.06-13.34 26.51-33.82 62z"}},{"tag":"path","attr":{"d":"M372.66 279.16l-1 2a16.29 16.29 0 016.77-7.26 16.48 16.48 0 00-5.77 5.26z"}},{"tag":"path","attr":{"d":"M195.94 459.38C205.37 472.67 221 480 240 480a16 16 0 0014.31-8.85c3-6.06 15.25-24 28.19-42.9 18-26.33 40.35-59.08 55.23-84.81l.13-.22c20.48-35.49 30.35-54.94 33.82-62l1-2a16.48 16.48 0 015.79-5.23A15.93 15.93 0 01386 272h25.32A84.7 84.7 0 00496 187.3v-38.6A84.7 84.7 0 00411.31 64h-48.79a17.46 17.46 0 01-9.58-2.89C330 46.13 286.66 32 240 32c-7.45 0-14.19.14-20.27.38a8 8 0 00-6.2 12.68l.1.14C222.2 57.59 224 71 224 80a61.16 61.16 0 01-5.19 24.77 17.38 17.38 0 000 14.06 63.81 63.81 0 010 50.39 17.32 17.32 0 000 14 62.13 62.13 0 010 49.58 18.13 18.13 0 000 14.68A60.41 60.41 0 01224 273c0 8.2-2 21.3-8 31.18a15.66 15.66 0 00-1.14 13.65c.38 1 .76 2.06 1.13 3.17a24.8 24.8 0 01.86 11.57c-3 19.35-9.67 36.3-16.74 54.16-3.08 7.78-6.27 15.82-9.22 24.27-6.14 17.56-4.3 35.2 5.05 48.38z"}}]})(props);
	};
	module.exports.IoThumbsUpOutline = function IoThumbsUpOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M320 458.16S304 464 256 464s-74-16-96-32H96a64 64 0 01-64-64v-48a64 64 0 0164-64h30a32.34 32.34 0 0027.37-15.4S162 221.81 188 176.78 264 64 272 48c29 0 43 22 34 47.71-10.28 29.39-23.71 54.38-27.46 87.09-.54 4.78 3.14 12 7.95 12L416 205"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M416 271l-80-2c-20-1.84-32-12.4-32-30h0c0-17.6 14-28.84 32-30l80-4c17.6 0 32 16.4 32 34v.17A32 32 0 01416 271zm32 65l-112-2c-18-.84-32-12.41-32-30h0c0-17.61 14-28.86 32-30l112-2a32.1 32.1 0 0132 32h0a32.1 32.1 0 01-32 32zm-48 128l-64-3c-21-1.84-32-11.4-32-29h0c0-17.6 14.4-30 32-30l64-2a32.09 32.09 0 0132 32h0a32.09 32.09 0 01-32 32zm32-64l-96-2c-19-.84-32-12.4-32-30h0c0-17.6 13-28.84 32-30l96-2a32.09 32.09 0 0132 32h0a32.09 32.09 0 01-32 32z"}}]})(props);
	};
	module.exports.IoThumbsUpSharp = function IoThumbsUpSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456 192l-156-12 23-89.4c6-26.6-.78-41.87-22.47-48.6l-34.69-9.85a4 4 0 00-4.4 1.72l-129 202.34a8 8 0 01-6.81 3.81H16V448h117.61a48 48 0 0115.18 2.46l76.3 25.43a80 80 0 0025.3 4.11h177.93c19 0 31.5-13.52 35.23-32.16L496 305.58V232c0-22.06-18-38-40-40z"}}]})(props);
	};
	module.exports.IoThumbsUp = function IoThumbsUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M472.06 334l-144.16-6.13c-4.61-.36-23.9-1.21-23.9-25.87 0-23.81 19.16-25.33 24.14-25.88L472.06 270c12.67.13 23.94 14.43 23.94 32s-11.27 31.87-23.94 32zM330.61 202.33L437.35 194C450 194 464 210.68 464 227.88v.33c0 16.32-11.14 29.62-24.88 29.79l-108.45-1.73C304 253 304 236.83 304 229.88c0-22.88 21.8-27.15 26.61-27.55zM421.85 480l-89.37-8.93C308 470.14 304 453.82 304 443.59c0-18.38 13.41-24.6 26.67-24.6l91-3c14.54.23 26.32 14.5 26.32 32s-11.67 31.67-26.14 32.01zm34.36-71.5l-126.4-6.21c-9.39-.63-25.81-3-25.81-26.37 0-12 4.35-25.61 25-27.53l127.19-3.88c13.16.14 23.81 13.49 23.81 31.4s-10.65 32.43-23.79 32.58z"}},{"tag":"path","attr":{"fill":"none","d":"M133.55 238.06A15.85 15.85 0 01126 240a15.82 15.82 0 007.51-1.92zm40.59-69.28l.13-.23-.13.23c-20.5 35.51-30.36 54.95-33.82 62 3.47-7.07 13.34-26.51 33.82-62z"}},{"tag":"path","attr":{"d":"M139.34 232.84l1-2a16.27 16.27 0 01-6.77 7.25 16.35 16.35 0 005.77-5.25z"}},{"tag":"path","attr":{"d":"M316.06 52.62C306.63 39.32 291 32 272 32a16 16 0 00-14.31 8.84c-3 6.07-15.25 24-28.19 42.91-18 26.33-40.35 59.07-55.23 84.8l-.13.23c-20.48 35.49-30.35 54.93-33.82 62l-1 2a16.35 16.35 0 01-5.79 5.22 15.82 15.82 0 01-7.53 2h-25.31A84.69 84.69 0 0016 324.69v38.61a84.69 84.69 0 0084.69 84.7h48.79a17.55 17.55 0 019.58 2.89C182 465.87 225.34 480 272 480c7.45 0 14.19-.14 20.27-.38a8 8 0 006.2-12.68l-.1-.14C289.8 454.41 288 441 288 432a61.2 61.2 0 015.19-24.77 17.36 17.36 0 000-14.05 63.81 63.81 0 010-50.39 17.32 17.32 0 000-14 62.15 62.15 0 010-49.59 18.13 18.13 0 000-14.68A60.33 60.33 0 01288 239c0-8.2 2-21.3 8-31.19a15.63 15.63 0 001.14-13.64c-.38-1-.76-2.07-1.13-3.17a24.84 24.84 0 01-.86-11.58c3-19.34 9.67-36.29 16.74-54.16 3.08-7.78 6.27-15.82 9.22-24.26 6.14-17.57 4.3-35.2-5.05-48.38z"}}]})(props);
	};
	module.exports.IoThunderstormOutline = function IoThunderstormOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M120 352l-24 48m40 32l-16 32m280-112l-24 48m40 32l-16 32M208 304l-16 96h48v80l80-112h-48l16-64m116.33-151.11H392.2C384.71 84.85 326.14 32 256 32a136.39 136.39 0 00-128.63 90.67h-4.57c-49.94 0-90.8 40.8-90.8 90.66h0C32 263.2 72.86 304 122.8 304h281.53C446 304 480 270 480 228.44h0c0-41.55-34-75.55-75.67-75.55z"}}]})(props);
	};
	module.exports.IoThunderstormSharp = function IoThunderstormSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.84 136.9a151.25 151.25 0 00-47.6-81.9 153 153 0 00-241.81 51.86C60.5 110.16 16 156.65 16 213.33 16 272.15 63.91 320 122.8 320h72.31L176 416h48v80l112-144h-43.51l8-32h103.84a91.56 91.56 0 001.51-183.1z"}},{"tag":"path","attr":{"d":"M74.53 407.177l38.32-76.622 28.62 14.313-38.32 76.623zm23.99 64.012l30.318-60.622 28.62 14.313-30.317 60.622zm256.021-64l38.32-76.623 28.62 14.314-38.32 76.622zm24.001 64.011l30.317-60.622 28.62 14.314-30.317 60.621z"}}]})(props);
	};
	module.exports.IoThunderstorm = function IoThunderstorm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 416a16 16 0 01-14.3-23.16l24-48a16 16 0 0128.62 14.32l-24 48A16 16 0 0196 416zm24 64a16 16 0 01-14.3-23.16l16-32a16 16 0 0128.62 14.32l-16 32A16 16 0 01120 480zm256-64a16 16 0 01-14.3-23.16l24-48a16 16 0 0128.62 14.32l-24 48A16 16 0 01376 416zm24 64a16 16 0 01-14.3-23.16l16-32a16 16 0 0128.62 14.32l-16 32A16 16 0 01400 480z"}},{"tag":"path","attr":{"d":"M405.84 136.9a151.25 151.25 0 00-47.6-81.9 153 153 0 00-241.81 51.86C60.5 110.16 16 156.65 16 213.33 16 272.15 63.91 320 122.8 320h66.31l-12.89 77.37A16 16 0 00192 416h32v64a16 16 0 0029 9.3l80-112a16 16 0 00-13-25.3h-27.51l8-32h103.84a91.56 91.56 0 001.51-183.1z"}}]})(props);
	};
	module.exports.IoTicketOutline = function IoTicketOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M366.05 146a46.7 46.7 0 01-2.42-63.42 3.87 3.87 0 00-.22-5.26l-44.13-44.18a3.89 3.89 0 00-5.5 0l-70.34 70.34a23.62 23.62 0 00-5.71 9.24h0a23.66 23.66 0 01-14.95 15h0a23.7 23.7 0 00-9.25 5.71L33.14 313.78a3.89 3.89 0 000 5.5l44.13 44.13a3.87 3.87 0 005.26.22 46.69 46.69 0 0165.84 65.84 3.87 3.87 0 00.22 5.26l44.13 44.13a3.89 3.89 0 005.5 0l180.4-180.39a23.7 23.7 0 005.71-9.25h0a23.66 23.66 0 0114.95-15h0a23.62 23.62 0 009.24-5.71l70.34-70.34a3.89 3.89 0 000-5.5l-44.13-44.13a3.87 3.87 0 00-5.26-.22 46.7 46.7 0 01-63.42-2.32z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M250.5 140.44l-16.51-16.51m60.53 60.53l-11.01-11m55.03 55.03l-11-11.01m60.53 60.53l-16.51-16.51"}}]})(props);
	};
	module.exports.IoTicketSharp = function IoTicketSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426.24 127.72l-10.94 10.94a29.67 29.67 0 01-42-42l10.94-10.94L314.52 16l-88 88-4 12.09-12.09 4L16 314.52l69.76 69.76 10.94-10.94a29.67 29.67 0 0142 42l-10.94 10.94L197.48 496l194.4-194.4 4-12.09 12.09-4 88-88zm-208.56 5.43l21.87-21.87 33 33-21.88 21.87zm43 43l21.88-21.88 32.52 32.52-21.88 21.88zm42.56 42.56l21.88-21.88 32.52 32.52-21.84 21.93zm75.57 75.56l-33-33 21.87-21.88 33 33z"}}]})(props);
	};
	module.exports.IoTicket = function IoTicket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M490.18 181.4l-44.13-44.13a20 20 0 00-27-1 30.81 30.81 0 01-41.68-1.6 30.81 30.81 0 01-1.6-41.67 20 20 0 00-1-27L330.6 21.82a19.91 19.91 0 00-28.13 0l-70.35 70.34a39.87 39.87 0 00-9.57 15.5 7.71 7.71 0 01-4.83 4.83 39.78 39.78 0 00-15.5 9.58l-180.4 180.4a19.91 19.91 0 000 28.13L66 374.73a20 20 0 0027 1 30.69 30.69 0 0143.28 43.28 20 20 0 001 27l44.13 44.13a19.91 19.91 0 0028.13 0l180.4-180.4a39.82 39.82 0 009.58-15.49 7.69 7.69 0 014.84-4.84 39.84 39.84 0 0015.49-9.57l70.34-70.35a19.91 19.91 0 00-.01-28.09zm-228.37-29.65a16 16 0 01-22.63 0l-11.51-11.51a16 16 0 0122.63-22.62l11.51 11.5a16 16 0 010 22.63zm44 44a16 16 0 01-22.62 0l-11-11a16 16 0 1122.63-22.63l11 11a16 16 0 01.01 22.66zm44 44a16 16 0 01-22.63 0l-11-11a16 16 0 0122.63-22.62l11 11a16 16 0 01.05 22.67zm44.43 44.54a16 16 0 01-22.63 0l-11.44-11.5a16 16 0 1122.68-22.57l11.45 11.49a16 16 0 01-.01 22.63z"}}]})(props);
	};
	module.exports.IoTimeOutline = function IoTimeOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 128v144h96"}}]})(props);
	};
	module.exports.IoTimeSharp = function IoTimeSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256c0 114.69 93.32 208 208 208 114.86 0 208-93.14 208-208 0-114.69-93.31-208-208-208zm108 240H244a4 4 0 01-4-4V116a4 4 0 014-4h24a4 4 0 014 4v140h92a4 4 0 014 4v24a4 4 0 01-4 4z"}}]})(props);
	};
	module.exports.IoTime = function IoTime (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm96 240h-96a16 16 0 01-16-16V128a16 16 0 0132 0v128h80a16 16 0 010 32z"}}]})(props);
	};
	module.exports.IoTimerOutline = function IoTimerOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112.91 128A191.85 191.85 0 0064 254c-1.18 106.35 85.65 193.8 192 194 106.2.2 192-85.83 192-192 0-104.54-83.55-189.61-187.5-192a4.36 4.36 0 00-4.5 4.37V152"}},{"tag":"path","attr":{"d":"M233.38 278.63l-79-113a8.13 8.13 0 0111.32-11.32l113 79a32.5 32.5 0 01-37.25 53.26 33.21 33.21 0 01-8.07-7.94z"}}]})(props);
	};
	module.exports.IoTimerSharp = function IoTimerSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.12 48 48 141.12 48 256s93.12 208 208 208 208-93.12 208-208S370.88 48 256 48zm0 384c-97 0-176-78.95-176-176a174.55 174.55 0 0153.87-126.72L279 233l-19 30-125-91c-13 23-26.7 46-26.7 84 0 81.44 66.26 147.7 147.7 147.7S403.7 337.44 403.7 256c0-76.67-58.72-139.88-133.55-147v55h-28.3V79.89c4.24.07 8.94.11 14.15.11 97.05 0 176 79 176 176s-78.95 176-176 176z"}}]})(props);
	};
	module.exports.IoTimer = function IoTimer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.12 48 48 141.12 48 256s93.12 208 208 208 208-93.12 208-208S370.88 48 256 48zm-82.33 114.34l105 71a32.5 32.5 0 01-37.25 53.26 33.21 33.21 0 01-8-8l-71-105a8.13 8.13 0 0111.32-11.32zM256 432c-97 0-176-78.95-176-176a174.55 174.55 0 0153.87-126.72 14.15 14.15 0 1119.64 20.37A146.53 146.53 0 00108.3 256c0 81.44 66.26 147.7 147.7 147.7S403.7 337.44 403.7 256c0-76.67-58.72-139.88-133.55-147v55a14.15 14.15 0 11-28.3 0V94.15A14.15 14.15 0 01256 80c97.05 0 176 79 176 176s-78.95 176-176 176z"}}]})(props);
	};
	module.exports.IoTodayOutline = function IoTodayOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"384","x":"48","y":"80","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M128 48v32m256-32v32"}},{"tag":"rect","attr":{"width":"96","height":"96","x":"112","y":"224","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"13"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M464 160H48"}}]})(props);
	};
	module.exports.IoTodaySharp = function IoTodaySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 456a24 24 0 0024 24h400a24 24 0 0024-24V176H32zm80-238.86a9.14 9.14 0 019.14-9.14h109.72a9.14 9.14 0 019.14 9.14v109.72a9.14 9.14 0 01-9.14 9.14H121.14a9.14 9.14 0 01-9.14-9.14zM456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448V87.77A23.8 23.8 0 00456 64z"}}]})(props);
	};
	module.exports.IoToday = function IoToday (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4v-12a64 64 0 00-64-64zm61 112H35a3 3 0 00-3 3v237a64 64 0 0064 64h320a64 64 0 0064-64V179a3 3 0 00-3-3zM224 307.43A28.57 28.57 0 01195.43 336h-70.86A28.57 28.57 0 0196 307.43v-70.86A28.57 28.57 0 01124.57 208h70.86A28.57 28.57 0 01224 236.57z"}}]})(props);
	};
	module.exports.IoToggleOutline = function IoToggleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"368","cy":"256","r":"128","fill":"none","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"rect","attr":{"width":"480","height":"256","x":"16","y":"128","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"128","ry":"128"}}]})(props);
	};
	module.exports.IoToggleSharp = function IoToggleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 112H144a144 144 0 000 288h224a144 144 0 000-288zm0 230a86 86 0 1186-86 85.88 85.88 0 01-86 86z"}}]})(props);
	};
	module.exports.IoToggle = function IoToggle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 112H144C64.6 112 0 176.6 0 256s64.6 144 144 144h224c79.4 0 144-64.6 144-144s-64.6-144-144-144zm0 256a112 112 0 11112-112 112.12 112.12 0 01-112 112z"}}]})(props);
	};
	module.exports.IoTrailSignOutline = function IoTrailSignOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 400v64m0-256v64m0-224v32m160 128H102.63a16 16 0 01-11.32-4.69L32 144l59.31-59.31A16 16 0 01102.63 80H416a16 16 0 0116 16v96a16 16 0 01-16 16zM96 400h313.37a16 16 0 0011.32-4.69L480 336l-59.31-59.31a16 16 0 00-11.32-4.69H96a16 16 0 00-16 16v96a16 16 0 0016 16z"}}]})(props);
	};
	module.exports.IoTrailSignSharp = function IoTrailSignSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.63 336l-80-80H278v-32h170V64H278V32h-44v32H89.37l-80 80 80 80H234v32H64v160h170v64h44v-64h144.63z"}}]})(props);
	};
	module.exports.IoTrailSign = function IoTrailSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M491.31 324.69L432 265.37a31.8 31.8 0 00-22.63-9.37H272v-32h144a32 32 0 0032-32V96a32 32 0 00-32-32H272V48a16 16 0 00-32 0v16H102.63A31.8 31.8 0 0080 73.37l-59.31 59.32a16 16 0 000 22.62L80 214.63a31.8 31.8 0 0022.63 9.37H240v32H96a32 32 0 00-32 32v96a32 32 0 0032 32h144v48a16 16 0 0032 0v-48h137.37a31.8 31.8 0 0022.63-9.37l59.31-59.32a16 16 0 000-22.62z"}}]})(props);
	};
	module.exports.IoTrainOutline = function IoTrainOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M344 48h-24a16 16 0 00-16-16h-96a16 16 0 00-16 16h-24a56.16 56.16 0 00-56 56v247c0 35.3 144 65 144 65s144-29.7 144-65V104a56 56 0 00-56-56zm-88 304a48 48 0 1148-48 48 48 0 01-48 48zm96-160a16 16 0 01-16 16H176a16 16 0 01-16-16v-64a16 16 0 0116-16h160a16 16 0 0116 16zM144 464h224m-32-32l48 48m-208-48l-48 48"}}]})(props);
	};
	module.exports.IoTrainSharp = function IoTrainSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 32h-64a16 16 0 00-16-16h-96a16 16 0 00-16 16h-64c-16 0-32 16-32 32v288c0 23.92 160 80 160 80s160-56.74 160-80V64c0-16-16-32-32-32zM256 352a48 48 0 1148-48 48 48 0 01-48 48zm112-152a8 8 0 01-8 8H152a8 8 0 01-8-8v-80a8 8 0 018-8h208a8 8 0 018 8z"}},{"tag":"path","attr":{"d":"M314 432l15.32 16H182.58L198 432l-32-13-76.62 77h45.2l16-16h210.74l16 16h45.3l-76.36-77.75L314 432z"}}]})(props);
	};
	module.exports.IoTrain = function IoTrain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"ellipse","attr":{"cx":"256","cy":"304","rx":"32.05","ry":"31.94","transform":"rotate(-45 256.001 304)"}},{"tag":"path","attr":{"d":"M352 32h-15a10 10 0 01-7.87-3.78A31.94 31.94 0 00304 16h-96a32 32 0 00-26.11 13.52A6 6 0 01177 32h-17c-36.81 0-64 28.84-64 64v255c0 23.27 25.6 42.06 83 60.94a753 753 0 0073.77 19.73 16 16 0 006.46 0A753 753 0 00333 411.94c57.4-18.88 83-37.67 83-60.94V96a64 64 0 00-64-64zm-168 96h144a8 8 0 018 8v48a8 8 0 01-8 8H184a8 8 0 01-8-8v-48a8 8 0 018-8zm76.18 239.87a64 64 0 1159.69-59.69 64.07 64.07 0 01-59.69 59.69z"}},{"tag":"path","attr":{"d":"M395.31 468.69L347.63 421c-6.09-6.1-16-6.66-22.38-.86a16 16 0 00-.56 23.16l4.68 4.69H182.63l4.36-4.37c6.1-6.09 6.66-16 .86-22.38a16 16 0 00-23.16-.56l-48 48a16 16 0 1022.62 22.62l11.32-11.3h210.74l11.32 11.31a16 16 0 0022.62-22.62z"}}]})(props);
	};
	module.exports.IoTransgenderOutline = function IoTransgenderOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"128","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M448 352l-96 96M176 80l-95.98 95.98M464 128V48h-80M48 128V48h80m336 0L346.5 165.5M48 48l117.49 117.49M464 464L346.65 346.37"}}]})(props);
	};
	module.exports.IoTransgenderSharp = function IoTransgenderSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 448.94l-48.94-49.08L464 366.92l-31.1-31.11-32.9 32.9-23.55-23.61a149.64 149.64 0 00-.1-178.45l59.55-59.56V144h44V32h-112v44h36.87l-59.55 59.55a149.65 149.65 0 00-178.59 0l-7.55-7.55 33-33L161 63.88l-33 33L107.09 76H144V32H32v112h44v-36.91L96.87 128l-33 33L95 192.05l33-33 7.56 7.57A149.18 149.18 0 00106 255.94c0 82.69 67.27 150 150 150a149.12 149.12 0 0089.44-29.67l23.51 23.58-33.14 33.05 31.11 31.1 33-33 48.9 49zm-330-193a106 106 0 11106 106 106.09 106.09 0 01-106-106z"}}]})(props);
	};
	module.exports.IoTransgender = function IoTransgender (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458 32h-68a22 22 0 000 44h14.89l-59.57 59.57a149.69 149.69 0 00-178.64 0l-7.57-7.57 26.45-26.44a22 22 0 00-31.12-31.12L128 96.89 107.11 76H122a22 22 0 000-44H54a22 22 0 00-22 22v68a22 22 0 0044 0v-14.89L96.89 128l-26.42 26.42a22 22 0 1031.11 31.11L128 159.11l7.57 7.57A149.19 149.19 0 00106 256c0 82.71 67.29 150 150 150a149.2 149.2 0 0089.46-29.67L369 399.9l-26.54 26.54a22 22 0 0031.12 31.12l26.49-26.5 42.37 42.48a22 22 0 0031.16-31.08L431.17 400l26.39-26.39a22 22 0 00-31.12-31.12l-26.35 26.35-23.55-23.62a149.68 149.68 0 00-.11-178.49L436 107.11V122a22 22 0 0044 0V54a22 22 0 00-22-22zM150 256a106 106 0 11106 106 106.12 106.12 0 01-106-106z"}}]})(props);
	};
	module.exports.IoTrashBinOutline = function IoTrashBinOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M432 144l-28.67 275.74A32 32 0 01371.55 448H140.46a32 32 0 01-31.78-28.26L80 144"}},{"tag":"rect","attr":{"width":"448","height":"80","x":"32","y":"64","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"16","ry":"16"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M312 240L200 352m112 0L200 240"}}]})(props);
	};
	module.exports.IoTrashBinSharp = function IoTrashBinSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M337.46 240L312 214.54l-56 56-56-56L174.54 240l56 56-56 56L200 377.46l56-56 56 56L337.46 352l-56-56 56-56z"}},{"tag":"path","attr":{"fill":"none","d":"M337.46 240L312 214.54l-56 56-56-56L174.54 240l56 56-56 56L200 377.46l56-56 56 56L337.46 352l-56-56 56-56z"}},{"tag":"path","attr":{"d":"M64 160l29.74 282.51A24 24 0 00117.61 464h276.78a24 24 0 0023.87-21.49L448 160zm248 217.46l-56-56-56 56L174.54 352l56-56-56-56L200 214.54l56 56 56-56L337.46 240l-56 56 56 56z"}},{"tag":"rect","attr":{"width":"448","height":"80","x":"32","y":"48","rx":"12","ry":"12"}}]})(props);
	};
	module.exports.IoTrashBin = function IoTrashBin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"448","height":"80","x":"32","y":"48","rx":"32","ry":"32"}},{"tag":"path","attr":{"d":"M74.45 160a8 8 0 00-8 8.83l26.31 252.56a1.5 1.5 0 000 .22A48 48 0 00140.45 464h231.09a48 48 0 0047.67-42.39v-.21l26.27-252.57a8 8 0 00-8-8.83zm248.86 180.69a16 16 0 11-22.63 22.62L256 318.63l-44.69 44.68a16 16 0 01-22.63-22.62L233.37 296l-44.69-44.69a16 16 0 0122.63-22.62L256 273.37l44.68-44.68a16 16 0 0122.63 22.62L278.62 296z"}}]})(props);
	};
	module.exports.IoTrashOutline = function IoTrashOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M112 112l20 320c.95 18.49 14.4 32 32 32h184c17.67 0 30.87-13.51 32-32l20-320"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M80 112h352"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M192 112V72h0a23.93 23.93 0 0124-24h80a23.93 23.93 0 0124 24h0v40m-64 64v224m-72-224l8 224m136-224l-8 224"}}]})(props);
	};
	module.exports.IoTrashSharp = function IoTrashSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M296 64h-80a7.91 7.91 0 00-8 8v24h96V72a7.91 7.91 0 00-8-8z"}},{"tag":"path","attr":{"fill":"none","d":"M292 64h-72a4 4 0 00-4 4v28h80V68a4 4 0 00-4-4z"}},{"tag":"path","attr":{"d":"M447.55 96H336V48a16 16 0 00-16-16H192a16 16 0 00-16 16v48H64.45L64 136h33l20.09 314A32 32 0 00149 480h214a32 32 0 0031.93-29.95L415 136h33zM176 416l-9-256h33l9 256zm96 0h-32V160h32zm24-320h-80V68a4 4 0 014-4h72a4 4 0 014 4zm40 320h-33l9-256h33z"}}]})(props);
	};
	module.exports.IoTrash = function IoTrash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","d":"M296 64h-80a7.91 7.91 0 00-8 8v24h96V72a7.91 7.91 0 00-8-8z"}},{"tag":"path","attr":{"d":"M432 96h-96V72a40 40 0 00-40-40h-80a40 40 0 00-40 40v24H80a16 16 0 000 32h17l19 304.92c1.42 26.85 22 47.08 48 47.08h184c26.13 0 46.3-19.78 48-47l19-305h17a16 16 0 000-32zM192.57 416H192a16 16 0 01-16-15.43l-8-224a16 16 0 1132-1.14l8 224A16 16 0 01192.57 416zM272 400a16 16 0 01-32 0V176a16 16 0 0132 0zm32-304h-96V72a7.91 7.91 0 018-8h80a7.91 7.91 0 018 8zm32 304.57A16 16 0 01320 416h-.58A16 16 0 01304 399.43l8-224a16 16 0 1132 1.14z"}}]})(props);
	};
	module.exports.IoTrendingDownOutline = function IoTrendingDownOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 368h112V256"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 144l121.37 121.37a32 32 0 0045.26 0l50.74-50.74a32 32 0 0145.26 0L448 352"}}]})(props);
	};
	module.exports.IoTrendingDownSharp = function IoTrendingDownSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M352 368h112V256"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M48 144l144 144 96-96 160 160"}}]})(props);
	};
	module.exports.IoTrendingDown = function IoTrendingDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 368h112V256"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 144l121.37 121.37a32 32 0 0045.26 0l50.74-50.74a32 32 0 0145.26 0L448 352"}}]})(props);
	};
	module.exports.IoTrendingUpOutline = function IoTrendingUpOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 144h112v112"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 368l121.37-121.37a32 32 0 0145.26 0l50.74 50.74a32 32 0 0045.26 0L448 160"}}]})(props);
	};
	module.exports.IoTrendingUpSharp = function IoTrendingUpSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M352 144h112v112"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M48 368l144-144 96 96 160-160"}}]})(props);
	};
	module.exports.IoTrendingUp = function IoTrendingUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 144h112v112"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 368l121.37-121.37a32 32 0 0145.26 0l50.74 50.74a32 32 0 0045.26 0L448 160"}}]})(props);
	};
	module.exports.IoTriangleOutline = function IoTriangleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M48 448L256 64l208 384H48z"}}]})(props);
	};
	module.exports.IoTriangleSharp = function IoTriangleSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32L20 464h472L256 32z"}}]})(props);
	};
	module.exports.IoTriangle = function IoTriangle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 464H48a16 16 0 01-14.07-23.62l208-384a16 16 0 0128.14 0l208 384A16 16 0 01464 464z"}}]})(props);
	};
	module.exports.IoTrophyOutline = function IoTrophyOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M176 464h160m-80 0V336m128-112c0-50.64-.08-134.63-.12-160a16 16 0 00-16-16l-223.79.26a16 16 0 00-16 15.95c0 30.58-.13 129.17-.13 159.79 0 64.28 83 112 128 112S384 288.28 384 224z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M128 96H48v16c0 55.22 33.55 112 80 112M384 96h80v16c0 55.22-33.55 112-80 112"}}]})(props);
	};
	module.exports.IoTrophySharp = function IoTrophySharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M399.9 80V32H112v48H32v38c0 32 9.5 62.79 26.76 86.61 13.33 18.4 34.17 31.1 52.91 37.21 5.44 29.29 20.2 57.13 50.19 79.83 22 16.66 48.45 28.87 72.14 33.86V436h-74v44h192v-44h-74v-80.49c23.69-5 50.13-17.2 72.14-33.86 30-22.7 44.75-50.54 50.19-79.83 18.74-6.11 39.58-18.81 52.91-37.21C470.5 180.79 480 150 480 118V80zM94.4 178.8c-10.68-14.68-17.17-34.4-18.24-54.8H112v67.37c-3.94-1.14-12.92-6.12-17.6-12.57zm323.2 0c-4.6 6.61-11.6 12.58-17.6 12.58 0-22.4 0-46.29-.05-67.38h35.9c-1.08 20.4-7.85 39.9-18.25 54.8z"}}]})(props);
	};
	module.exports.IoTrophy = function IoTrophy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 80h-60.1a4 4 0 01-4-4V63.92a32 32 0 00-32-31.92l-223.79.26a32 32 0 00-31.94 31.93V76a4 4 0 01-4 4H48a16 16 0 00-16 16v16c0 54.53 30 112.45 76.52 125.35a7.82 7.82 0 015.55 5.9c5.77 26.89 23.52 52.5 51.41 73.61 20.91 15.83 45.85 27.5 68.27 32.48a8 8 0 016.25 7.8V444a4 4 0 01-4 4h-59.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00176 480h159.55c8.61 0 16-6.62 16.43-15.23A16 16 0 00336 448h-60a4 4 0 01-4-4v-86.86a8 8 0 016.25-7.8c22.42-5 47.36-16.65 68.27-32.48 27.89-21.11 45.64-46.72 51.41-73.61a7.82 7.82 0 015.55-5.9C450 224.45 480 166.53 480 112V96a16 16 0 00-16-16zM112 198.22a4 4 0 01-6 3.45c-10.26-6.11-17.75-15.37-22.14-21.89-11.91-17.69-19-40.67-19.79-63.63a4 4 0 014-4.15h40a4 4 0 014 4c-.02 27.45-.07 58.87-.07 82.22zm316.13-18.44c-4.39 6.52-11.87 15.78-22.13 21.89a4 4 0 01-6-3.46c0-26.51 0-56.63-.05-82.21a4 4 0 014-4h40a4 4 0 014 4.15c-.79 22.96-7.9 45.94-19.81 63.63z"}}]})(props);
	};
	module.exports.IoTvOutline = function IoTvOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"448","height":"272","x":"32","y":"96","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"32.14","ry":"32.14"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M128 416h256"}}]})(props);
	};
	module.exports.IoTvSharp = function IoTvSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 384H24a8 8 0 01-8-8V88a8 8 0 018-8h464a8 8 0 018 8v288a8 8 0 01-8 8z"}},{"tag":"rect","attr":{"width":"288","height":"32","x":"112","y":"400","rx":"4","ry":"4"}}]})(props);
	};
	module.exports.IoTv = function IoTv (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.86 384H64.14A48.2 48.2 0 0116 335.86V128.14A48.2 48.2 0 0164.14 80h383.72A48.2 48.2 0 01496 128.14v207.72A48.2 48.2 0 01447.86 384z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M128 416h256"}}]})(props);
	};
	module.exports.IoUmbrellaOutline = function IoUmbrellaOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 272v160a32 32 0 01-32 32h0a32 32 0 01-32-32m272-160c0-114.88-93.12-208-208-208S48 157.12 48 272h0a67.88 67.88 0 0196 0h0a78.28 78.28 0 01102.31-7.27L256 272l9.69-7.27A78.28 78.28 0 01368 272h0a67.88 67.88 0 0196 0zM256 64V48"}}]})(props);
	};
	module.exports.IoUmbrellaSharp = function IoUmbrellaSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128.93 280l-.26-.3c-.9-.74-1.83-1.43-2.77-2.1zm254.15 0l2.62-2.12c-.79.58-1.57 1.17-2.34 1.79z"}},{"tag":"path","attr":{"d":"M463.14 186.44A224.55 224.55 0 00272 48.57V32h-32v16.57A223.58 223.58 0 0032 272v22.52l12.25-11.21a62.63 62.63 0 0181.43-5.88l.22.17c.94.67 1.87 1.36 2.77 2.1q2.09 1.69 4 3.61L144 294.63l11.31-11.32a62.59 62.59 0 0181.4-5.78L240 280v152a16 16 0 01-32 0v-16h-32v16a48 48 0 0096 0V280l3.29-2.47a62.59 62.59 0 0181.4 5.78L368 294.63l11.31-11.32q1.95-1.94 4.05-3.64c.77-.62 1.55-1.21 2.34-1.79l.26-.21c24.63-18.47 60-16.13 81.81 5.64l12.23 11.2V272a223.62 223.62 0 00-16.86-85.56z"}}]})(props);
	};
	module.exports.IoUmbrella = function IoUmbrella (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.39 113.61a222.26 222.26 0 00-136.33-64.54 8.09 8.09 0 01-6.88-5.62 15.79 15.79 0 00-30.36 0 8.09 8.09 0 01-6.88 5.62A224 224 0 0032 271.52a16.41 16.41 0 007.24 13.87 16 16 0 0020.07-2.08 51.89 51.89 0 0173.31-.06 15.94 15.94 0 0022.6.15 62.59 62.59 0 0181.49-5.87 8.24 8.24 0 013.29 6.59v147.42c0 8.6-6.6 16-15.19 16.44A16 16 0 01208 432a16 16 0 00-16.29-16c-9 .16-15.9 8.11-15.7 17.1a48.06 48.06 0 0047.37 46.9c26.88.34 48.62-21.93 48.62-48.81V284.12a8.24 8.24 0 013.29-6.59 62.59 62.59 0 0181.4 5.78 16 16 0 0022.62 0 51.91 51.91 0 0173.38 0 16 16 0 0019.54 2.41 16.4 16.4 0 007.77-14.21 222.54 222.54 0 00-65.61-157.9z"}}]})(props);
	};
	module.exports.IoUnlinkOutline = function IoUnlinkOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"36","d":"M208 352h-64a96 96 0 010-192h64m96 0h64a96 96 0 010 192h-64"}}]})(props);
	};
	module.exports.IoUnlinkSharp = function IoUnlinkSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"48","d":"M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66"}}]})(props);
	};
	module.exports.IoUnlink = function IoUnlink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66"}}]})(props);
	};
	module.exports.IoVideocamOffOutline = function IoVideocamOffOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M374.79 308.78L457.5 367a16 16 0 0022.5-14.62V159.62A16 16 0 00457.5 145l-82.71 58.22A16 16 0 00368 216.3v79.4a16 16 0 006.79 13.08z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M50.19 140.57A51.94 51.94 0 0032 180v152a52.15 52.15 0 0052 52h184a51.6 51.6 0 0022-4.9M208 128h60.48A51.68 51.68 0 01320 179.52V248m96 168L80 80"}}]})(props);
	};
	module.exports.IoVideocamOffSharp = function IoVideocamOffSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M57.376 79.998l22.627-22.627 358.63 358.63-22.627 22.628zM32 112a16 16 0 00-16 16v256a16 16 0 0016 16h288a15.89 15.89 0 009.34-3l-285-285zm304 96v-80a16 16 0 00-16-16H179.63l245.44 245.44L496 400V112z"}}]})(props);
	};
	module.exports.IoVideocamOff = function IoVideocamOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 179.52A67.52 67.52 0 00268.48 112h-79.2a4 4 0 00-2.82 6.83l142.71 142.71a4 4 0 006.83-2.82zM16 180v152a68 68 0 0068 68h184a67.66 67.66 0 0042.84-15.24 4 4 0 00.33-6L54.41 122a4 4 0 00-4.87-.62A68 68 0 0016 180zm448 204.39a32 32 0 01-13-2.77 15.77 15.77 0 01-2.71-1.54l-82.71-58.22A32 32 0 01352 295.7v-79.4a32 32 0 0113.58-26.16l82.71-58.22a15.77 15.77 0 012.71-1.54 32 32 0 0145 29.24v192.76a32 32 0 01-32 32z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M416 416L80 80"}}]})(props);
	};
	module.exports.IoVideocamOutline = function IoVideocamOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M374.79 308.78L457.5 367a16 16 0 0022.5-14.62V159.62A16 16 0 00457.5 145l-82.71 58.22A16 16 0 00368 216.3v79.4a16 16 0 006.79 13.08z"}},{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M268 384H84a52.15 52.15 0 01-52-52V180a52.15 52.15 0 0152-52h184.48A51.68 51.68 0 01320 179.52V332a52.15 52.15 0 01-52 52z"}}]})(props);
	};
	module.exports.IoVideocamSharp = function IoVideocamSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 208v-80a16 16 0 00-16-16H32a16 16 0 00-16 16v256a16 16 0 0016 16h288a16 16 0 0016-16v-80l160 96V112z"}}]})(props);
	};
	module.exports.IoVideocam = function IoVideocam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 384.39a32 32 0 01-13-2.77 15.77 15.77 0 01-2.71-1.54l-82.71-58.22A32 32 0 01352 295.7v-79.4a32 32 0 0113.58-26.16l82.71-58.22a15.77 15.77 0 012.71-1.54 32 32 0 0145 29.24v192.76a32 32 0 01-32 32zM268 400H84a68.07 68.07 0 01-68-68V180a68.07 68.07 0 0168-68h184.48A67.6 67.6 0 01336 179.52V332a68.07 68.07 0 01-68 68z"}}]})(props);
	};
	module.exports.IoVolumeHighOutline = function IoVolumeHighOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M126 192H56a8 8 0 00-8 8v112a8 8 0 008 8h69.65a15.93 15.93 0 0110.14 3.54l91.47 74.89A8 8 0 00240 392V120a8 8 0 00-12.74-6.43l-91.47 74.89A15 15 0 01126 192zm194 128c9.74-19.38 16-40.84 16-64 0-23.48-6-44.42-16-64m48 176c19.48-33.92 32-64.06 32-112s-12-77.74-32-112m48 272c30-46 48-91.43 48-160s-18-113-48-160"}}]})(props);
	};
	module.exports.IoVolumeHighSharp = function IoVolumeHighSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M320 320c9.74-19.38 16-40.84 16-64 0-23.48-6-44.42-16-64m48 176c19.48-33.92 32-64.06 32-112s-12-77.74-32-112m48 272c30-46 48-91.43 48-160s-18-113-48-160"}},{"tag":"path","attr":{"d":"M125.65 176.1H32v159.8h93.65L256 440V72L125.65 176.1z"}}]})(props);
	};
	module.exports.IoVolumeHigh = function IoVolumeHigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M232 416a23.88 23.88 0 01-14.2-4.68 8.27 8.27 0 01-.66-.51L125.76 336H56a24 24 0 01-24-24V200a24 24 0 0124-24h69.75l91.37-74.81a8.27 8.27 0 01.66-.51A24 24 0 01256 120v272a24 24 0 01-24 24zm-106.18-80zm-.27-159.86zM320 336a16 16 0 01-14.29-23.19c9.49-18.87 14.3-38 14.3-56.81 0-19.38-4.66-37.94-14.25-56.73a16 16 0 0128.5-14.54C346.19 208.12 352 231.44 352 256c0 23.86-6 47.81-17.7 71.19A16 16 0 01320 336z"}},{"tag":"path","attr":{"d":"M368 384a16 16 0 01-13.86-24C373.05 327.09 384 299.51 384 256c0-44.17-10.93-71.56-29.82-103.94a16 16 0 0127.64-16.12C402.92 172.11 416 204.81 416 256c0 50.43-13.06 83.29-34.13 120a16 16 0 01-13.87 8z"}},{"tag":"path","attr":{"d":"M416 432a16 16 0 01-13.39-24.74C429.85 365.47 448 323.76 448 256c0-66.5-18.18-108.62-45.49-151.39a16 16 0 1127-17.22C459.81 134.89 480 181.74 480 256c0 64.75-14.66 113.63-50.6 168.74A16 16 0 01416 432z"}}]})(props);
	};
	module.exports.IoVolumeLowOutline = function IoVolumeLowOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M189.65 192H120a8 8 0 00-8 8v112a8 8 0 008 8h69.65a16 16 0 0110.14 3.63l91.47 75a8 8 0 0012.74-6.46V119.83a8 8 0 00-12.74-6.44l-91.47 75a16 16 0 01-10.14 3.61zM384 320c9.74-19.41 16-40.81 16-64 0-23.51-6-44.4-16-64"}}]})(props);
	};
	module.exports.IoVolumeLowSharp = function IoVolumeLowSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M391.12 341.48l-28.6-14.36 7.18-14.3c9.49-18.9 14.3-38 14.3-56.82 0-19.36-4.66-37.92-14.25-56.73L362.48 185 391 170.48l7.26 14.25C410.2 208.16 416 231.47 416 256c0 23.83-6 47.78-17.7 71.18zM189.65 176.1H96v159.8h93.65L320 440V72L189.65 176.1z"}}]})(props);
	};
	module.exports.IoVolumeLow = function IoVolumeLow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M296 416.19a23.92 23.92 0 01-14.21-4.69l-.66-.51-91.46-75H120a24 24 0 01-24-24V200a24 24 0 0124-24h69.65l91.46-75 .66-.51A24 24 0 01320 119.83v272.34a24 24 0 01-24 24zM384 336a16 16 0 01-14.29-23.18c9.49-18.9 14.3-38 14.3-56.82 0-19.36-4.66-37.92-14.25-56.73a16 16 0 0128.5-14.54C410.2 208.16 416 231.47 416 256c0 23.83-6 47.78-17.7 71.18A16 16 0 01384 336z"}}]})(props);
	};
	module.exports.IoVolumeMediumOutline = function IoVolumeMediumOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M157.65 192H88a8 8 0 00-8 8v112a8 8 0 008 8h69.65a16 16 0 0110.14 3.63l91.47 75a8 8 0 0012.74-6.46V119.83a8 8 0 00-12.74-6.44l-91.47 75a16 16 0 01-10.14 3.61zM352 320c9.74-19.41 16-40.81 16-64 0-23.51-6-44.4-16-64m48 176c19.48-34 32-64 32-112s-12-77.7-32-112"}}]})(props);
	};
	module.exports.IoVolumeMediumSharp = function IoVolumeMediumSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M157.65 176.1H64v159.8h93.65L288 440V72L157.65 176.1z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"32","d":"M352 320c9.74-19.41 16-40.81 16-64 0-23.51-6-44.4-16-64m48 176c19.48-34 32-64 32-112s-12-77.7-32-112"}}]})(props);
	};
	module.exports.IoVolumeMedium = function IoVolumeMedium (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M264 416.19a23.92 23.92 0 01-14.21-4.69l-.66-.51-91.46-75H88a24 24 0 01-24-24V200a24 24 0 0124-24h69.65l91.46-75 .66-.51A24 24 0 01288 119.83v272.34a24 24 0 01-24 24zM352 336a16 16 0 01-14.29-23.18c9.49-18.9 14.3-38 14.3-56.82 0-19.36-4.66-37.92-14.25-56.73a16 16 0 0128.5-14.54C378.2 208.16 384 231.47 384 256c0 23.83-6 47.78-17.7 71.18A16 16 0 01352 336z"}},{"tag":"path","attr":{"d":"M400 384a16 16 0 01-13.87-24C405 327.05 416 299.45 416 256c0-44.12-10.94-71.52-29.83-103.95A16 16 0 01413.83 136C434.92 172.16 448 204.88 448 256c0 50.36-13.06 83.24-34.12 120a16 16 0 01-13.88 8z"}}]})(props);
	};
	module.exports.IoVolumeMuteOutline = function IoVolumeMuteOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M416 432L64 80"}},{"tag":"path","attr":{"d":"M224 136.92v33.8a4 4 0 001.17 2.82l24 24a4 4 0 006.83-2.82v-74.15a24.53 24.53 0 00-12.67-21.72 23.91 23.91 0 00-25.55 1.83 8.27 8.27 0 00-.66.51l-31.94 26.15a4 4 0 00-.29 5.92l17.05 17.06a4 4 0 005.37.26zm0 238.16l-78.07-63.92a32 32 0 00-20.28-7.16H64v-96h50.72a4 4 0 002.82-6.83l-24-24a4 4 0 00-2.82-1.17H56a24 24 0 00-24 24v112a24 24 0 0024 24h69.76l91.36 74.8a8.27 8.27 0 00.66.51 23.93 23.93 0 0025.85 1.69A24.49 24.49 0 00256 391.45v-50.17a4 4 0 00-1.17-2.82l-24-24a4 4 0 00-6.83 2.82zM125.82 336zM352 256c0-24.56-5.81-47.88-17.75-71.27a16 16 0 00-28.5 14.54C315.34 218.06 320 236.62 320 256q0 4-.31 8.13a8 8 0 002.32 6.25l19.66 19.67a4 4 0 006.75-2A146.89 146.89 0 00352 256zm64 0c0-51.19-13.08-83.89-34.18-120.06a16 16 0 00-27.64 16.12C373.07 184.44 384 211.83 384 256c0 23.83-3.29 42.88-9.37 60.65a8 8 0 001.9 8.26l16.77 16.76a4 4 0 006.52-1.27C410.09 315.88 416 289.91 416 256z"}},{"tag":"path","attr":{"d":"M480 256c0-74.26-20.19-121.11-50.51-168.61a16 16 0 10-27 17.22C429.82 147.38 448 189.5 448 256c0 47.45-8.9 82.12-23.59 113a4 4 0 00.77 4.55L443 391.39a4 4 0 006.4-1C470.88 348.22 480 307 480 256z"}}]})(props);
	};
	module.exports.IoVolumeMuteSharp = function IoVolumeMuteSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"32","d":"M416 432L64 80"}},{"tag":"path","attr":{"d":"M352 256c0-24.56-5.81-47.88-17.75-71.27L327 170.47 298.48 185l7.27 14.25C315.34 218.06 320 236.62 320 256a112.91 112.91 0 01-.63 11.74l27.32 27.32A148.8 148.8 0 00352 256zm64 0c0-51.19-13.08-83.89-34.18-120.06l-8.06-13.82-27.64 16.12 8.06 13.82C373.07 184.44 384 211.83 384 256c0 25.93-3.89 46.21-11 65.33l24.5 24.51C409.19 319.68 416 292.42 416 256z"}},{"tag":"path","attr":{"d":"M480 256c0-74.26-20.19-121.11-50.51-168.61l-8.61-13.49-27 17.22 8.61 13.49C429.82 147.38 448 189.5 448 256c0 48.76-9.4 84-24.82 115.55l23.7 23.7C470.16 351.39 480 309 480 256zM256 72l-73.6 58.78 73.6 73.59V72zM32 176.1v159.8h93.65L256 440V339.63L92.47 176.1H32z"}}]})(props);
	};
	module.exports.IoVolumeMute = function IoVolumeMute (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M416 432L64 80"}},{"tag":"path","attr":{"d":"M243.33 98.86a23.89 23.89 0 00-25.55 1.82l-.66.51-28.52 23.35a8 8 0 00-.59 11.85l54.33 54.33a8 8 0 0013.66-5.66v-64.49a24.51 24.51 0 00-12.67-21.71zm8 236.43L96.69 180.69A16 16 0 0085.38 176H56a24 24 0 00-24 24v112a24 24 0 0024 24h69.76l92 75.31a23.9 23.9 0 0025.87 1.69A24.51 24.51 0 00256 391.45v-44.86a16 16 0 00-4.67-11.3zM352 256c0-24.56-5.81-47.87-17.75-71.27a16 16 0 10-28.5 14.55C315.34 218.06 320 236.62 320 256q0 4-.31 8.13a8 8 0 002.32 6.25l14.36 14.36a8 8 0 0013.55-4.31A146 146 0 00352 256zm64 0c0-51.18-13.08-83.89-34.18-120.06a16 16 0 00-27.64 16.12C373.07 184.44 384 211.83 384 256c0 23.83-3.29 42.88-9.37 60.65a8 8 0 001.9 8.26L389 337.4a8 8 0 0013.13-2.79C411 311.76 416 287.26 416 256z"}},{"tag":"path","attr":{"d":"M480 256c0-74.25-20.19-121.11-50.51-168.61a16 16 0 10-27 17.22C429.82 147.38 448 189.5 448 256c0 46.19-8.43 80.27-22.43 110.53a8 8 0 001.59 9l11.92 11.92a8 8 0 0012.92-2.16C471.6 344.9 480 305 480 256z"}}]})(props);
	};
	module.exports.IoVolumeOffOutline = function IoVolumeOffOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M237.65 192H168a8 8 0 00-8 8v112a8 8 0 008 8h69.65a16 16 0 0110.14 3.63l91.47 75a8 8 0 0012.74-6.46V119.83a8 8 0 00-12.74-6.44l-91.47 75a16 16 0 01-10.14 3.61z"}}]})(props);
	};
	module.exports.IoVolumeOffSharp = function IoVolumeOffSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M237.65 176.1H144v159.8h93.65L368 440V72L237.65 176.1z"}}]})(props);
	};
	module.exports.IoVolumeOff = function IoVolumeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M344 416a23.92 23.92 0 01-14.21-4.69c-.23-.16-.44-.33-.66-.51l-91.46-74.9H168a24 24 0 01-24-24V200.07a24 24 0 0124-24h69.65l91.46-74.9c.22-.18.43-.35.66-.51A24 24 0 01368 120v272a24 24 0 01-24 24z"}}]})(props);
	};
	module.exports.IoWalkOutline = function IoWalkOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M314.21 482.32l-56.77-114.74-44.89-57.39a72.82 72.82 0 01-10.13-37.05V144h15.67a40.22 40.22 0 0140.23 40.22v183.36M127.9 293.05v-74.52S165.16 144 202.42 144M370.1 274.42L304 231M170.53 478.36L224 400"}},{"tag":"circle","attr":{"cx":"258.32","cy":"69.48","r":"37.26","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32"}}]})(props);
	};
	module.exports.IoWalkSharp = function IoWalkSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"32","d":"M315.09 481.38l-56.95-115.12-45-57.56a73.11 73.11 0 01-10.16-37.17V142h15.73A40.36 40.36 0 01259 182.32v162.52"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"32","d":"M128.18 291.5v-74.77l64.95-65.1"}},{"tag":"path","attr":{"d":"M376.35 295.73l-83.95-56.38v-44.68l104.68 72.95-20.73 28.11zM175.13 498.58l-21.43-26.91 80.33-81.54 15.53 32.07-74.43 76.38z"}},{"tag":"circle","attr":{"cx":"259.02","cy":"67.21","r":"37.38","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"16"}}]})(props);
	};
	module.exports.IoWalk = function IoWalk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M312.55 479.9l-56.42-114-44.62-57a72.37 72.37 0 01-10.06-36.9V143.64H217a40 40 0 0140 40v182.21"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M127.38 291.78v-74.07s37-74.07 74.07-74.07"}},{"tag":"path","attr":{"d":"M368.09 291.78a18.49 18.49 0 01-10.26-3.11L297.7 250a21.18 21.18 0 01-9.7-17.79v-23.7a5.65 5.65 0 018.69-4.77l81.65 54.11a18.52 18.52 0 01-10.29 33.93zM171.91 493.47a18.5 18.5 0 01-14.83-7.41c-6.14-8.18-4-17.18 3.7-25.92l59.95-74.66a7.41 7.41 0 0110.76 2.06c1.56 2.54 3.38 5.65 5.19 9.09 5.24 9.95 6 16.11-1.68 25.7-8 10-52 67.44-52 67.44-2.62 2.98-7.23 3.7-11.09 3.7z"}},{"tag":"circle","attr":{"cx":"257","cy":"69.56","r":"37.04","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"16"}}]})(props);
	};
	module.exports.IoWalletOutline = function IoWalletOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"288","x":"48","y":"144","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M411.36 144v-30A50 50 0 00352 64.9L88.64 109.85A50 50 0 0048 159v49"}},{"tag":"path","attr":{"d":"M368 320a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoWalletSharp = function IoWalletSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M47.5 104H432V51.52a16 16 0 00-19.14-15.69l-368 60.48a16 16 0 00-12 10.47A39.69 39.69 0 0147.5 104zm416 24h-416a16 16 0 00-16 16v288a16 16 0 0016 16h416a16 16 0 0016-16V144a16 16 0 00-16-16zM368 320a32 32 0 1132-32 32 32 0 01-32 32z"}},{"tag":"path","attr":{"d":"M31.33 259.5V116c0-12.33 5.72-18.48 15.42-20 35.2-5.53 108.58-8.5 108.58-8.5s-8.33 16-27.33 16V128c18.5 0 31.33 23.5 31.33 23.5L84.83 236z"}}]})(props);
	};
	module.exports.IoWallet = function IoWallet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M95.5 104h320a87.73 87.73 0 0111.18.71 66 66 0 00-77.51-55.56L86 94.08h-.3a66 66 0 00-41.07 26.13A87.57 87.57 0 0195.5 104zm320 24h-320a64.07 64.07 0 00-64 64v192a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64V192a64.07 64.07 0 00-64-64zM368 320a32 32 0 1132-32 32 32 0 01-32 32z"}},{"tag":"path","attr":{"d":"M32 259.5V160c0-21.67 12-58 53.65-65.87C121 87.5 156 87.5 156 87.5s23 16 4 16-18.5 24.5 0 24.5 0 23.5 0 23.5L85.5 236z"}}]})(props);
	};
	module.exports.IoWarningOutline = function IoWarningOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M250.26 195.39l5.74 122 5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 5.95z"}},{"tag":"path","attr":{"d":"M256 397.25a20 20 0 1120-20 20 20 0 01-20 20z"}}]})(props);
	};
	module.exports.IoWarningSharp = function IoWarningSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M479 447.77L268.43 56.64a8 8 0 00-14.09 0L43.73 447.77a8 8 0 007.05 11.79H472a8 8 0 007-11.79zm-197.62-36.29h-40v-40h40zm-4-63.92h-32l-6-160h44z"}}]})(props);
	};
	module.exports.IoWarning = function IoWarning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M449.07 399.08L278.64 82.58c-12.08-22.44-44.26-22.44-56.35 0L51.87 399.08A32 32 0 0080 446.25h340.89a32 32 0 0028.18-47.17zm-198.6-1.83a20 20 0 1120-20 20 20 0 01-20 20zm21.72-201.15l-5.74 122a16 16 0 01-32 0l-5.74-121.95a21.73 21.73 0 0121.5-22.69h.21a21.74 21.74 0 0121.73 22.7z"}}]})(props);
	};
	module.exports.IoWatchOutline = function IoWatchOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"288","height":"288","x":"112","y":"112","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"64","ry":"64"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M176 112V40a8 8 0 018-8h144a8 8 0 018 8v72m0 288v72a8 8 0 01-8 8H184a8 8 0 01-8-8v-72"}}]})(props);
	};
	module.exports.IoWatchSharp = function IoWatchSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"240","height":"240","x":"136","y":"136","rx":"8","ry":"8"}},{"tag":"path","attr":{"d":"M384 96h-48V16H176v80h-48a32 32 0 00-32 32v256a32 32 0 0032 32h48v80h160v-80h48a32 32 0 0032-32V128a32 32 0 00-32-32zm8 272a24 24 0 01-24 24H144a24 24 0 01-24-24V144a24 24 0 0124-24h224a24 24 0 0124 24z"}}]})(props);
	};
	module.exports.IoWatch = function IoWatch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"240","height":"240","x":"136","y":"136","rx":"56","ry":"56"}},{"tag":"path","attr":{"d":"M336 96V32a16 16 0 00-16-16H192a16 16 0 00-16 16v64a80.09 80.09 0 00-80 80v160a80.09 80.09 0 0080 80v64a16 16 0 0016 16h128a16 16 0 0016-16v-64a80.09 80.09 0 0080-80V176a80.09 80.09 0 00-80-80zm56 224a72.08 72.08 0 01-72 72H192a72.08 72.08 0 01-72-72V192a72.08 72.08 0 0172-72h128a72.08 72.08 0 0172 72z"}}]})(props);
	};
	module.exports.IoWaterOutline = function IoWaterOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M400 320c0 88.37-55.63 144-144 144s-144-55.63-144-144c0-94.83 103.23-222.85 134.89-259.88a12 12 0 0118.23 0C296.77 97.15 400 225.17 400 320z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M344 328a72 72 0 01-72 72"}}]})(props);
	};
	module.exports.IoWaterSharp = function IoWaterSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 43.91s-144 158.3-144 270.3c0 88.36 55.64 144 144 144s144-55.64 144-144c0-112-144-270.3-144-270.3zm16 362.3v-24a60.07 60.07 0 0060-60h24a84.09 84.09 0 01-84 84z"}}]})(props);
	};
	module.exports.IoWater = function IoWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M265.12 60.12a12 12 0 00-18.23 0C215.23 97.15 112 225.17 112 320c0 88.37 55.64 144 144 144s144-55.63 144-144c0-94.83-103.23-222.85-134.88-259.88zM272 412a12 12 0 01-11.34-16 11.89 11.89 0 0111.41-8A60.06 60.06 0 00332 328.07a11.89 11.89 0 018-11.41A12 12 0 01356 328a84.09 84.09 0 01-84 84z"}}]})(props);
	};
	module.exports.IoWifiOutline = function IoWifiOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M332.41 310.59a115 115 0 00-152.8 0m213.85-61.05a201.26 201.26 0 00-274.92 0m329.18-67.43a288 288 0 00-383.44 0"}},{"tag":"path","attr":{"d":"M256 416a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
	};
	module.exports.IoWifiSharp = function IoWifiSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"42","d":"M332.69 320a115 115 0 00-152.8 0m213.85-61a201.26 201.26 0 00-274.92 0M448 191.52a288 288 0 00-383.44 0"}},{"tag":"path","attr":{"d":"M300.67 384L256 433l-44.34-49a56.73 56.73 0 0188.92 0z"}}]})(props);
	};
	module.exports.IoWifi = function IoWifi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M346.65 304.3a136 136 0 00-180.71 0 21 21 0 1027.91 31.38 94 94 0 01124.89 0 21 21 0 0027.91-31.4z"}},{"tag":"path","attr":{"d":"M256.28 183.7a221.47 221.47 0 00-151.8 59.92 21 21 0 1028.68 30.67 180.28 180.28 0 01246.24 0 21 21 0 1028.68-30.67 221.47 221.47 0 00-151.8-59.92z"}},{"tag":"path","attr":{"d":"M462 175.86a309 309 0 00-411.44 0 21 21 0 1028 31.29 267 267 0 01355.43 0 21 21 0 0028-31.31z"}},{"tag":"circle","attr":{"cx":"256.28","cy":"393.41","r":"32"}}]})(props);
	};
	module.exports.IoWineOutline = function IoWineOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M398.57 80H113.43v16S87.51 272 256 272 398.57 96 398.57 96zM256 272v160"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M352 432H160"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M112 160h288"}}]})(props);
	};
	module.exports.IoWineSharp = function IoWineSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453 112V66.33H60.75V112l175.13 176v118H124.75v42H389v-42H277.88V288zm-336.65-3.67h281l-37.81 38H154.16z"}}]})(props);
	};
	module.exports.IoWine = function IoWine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.56 94.92V80a16 16 0 00-16-16H113.44a16 16 0 00-16 16v14.92c-1.46 11.37-9.65 90.74 36.93 144.69 24.87 28.8 60.36 44.85 105.63 47.86V416h-80a16 16 0 000 32h192a16 16 0 000-32h-80V287.47c45.27-3 80.76-19.06 105.63-47.86 46.58-53.95 38.37-133.32 36.93-144.69zm-285.3 3.41a15.14 15.14 0 00.18-2.33h253.12a15.14 15.14 0 00.18 2.33 201.91 201.91 0 010 45.67H129.32a204.29 204.29 0 01-.06-45.67z"}}]})(props);
	};
	module.exports.IoWomanOutline = function IoWomanOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M208 368v104a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 368v104a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24V368m-121-94a23.73 23.73 0 01-29.84 16.18h0a23.72 23.72 0 01-16.17-29.84l25-84.28A44.85 44.85 0 01205 144h102a44.85 44.85 0 0143 32.08l25 84.28a23.72 23.72 0 01-16.17 29.84h0a23.73 23.73 0 01-29.78-16.2"}},{"tag":"circle","attr":{"cx":"256","cy":"56","r":"40","fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M208 192l-48 160h192l-48-160"}}]})(props);
	};
	module.exports.IoWomanSharp = function IoWomanSharp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"255.75","cy":"56","r":"56"}},{"tag":"path","attr":{"d":"M310.28 191.4h.05l7.66-2.3 36.79 122.6 46-13.8-16.21-54.16c0-.12 0-.24-.07-.36l-16.84-56.12-4.71-15.74-.9-3H362l-2.51-8.45a44.84 44.84 0 00-43-32.08H195.24a44.84 44.84 0 00-43 32.08l-2.51 8.45h-.06l-.9 3-4.71 15.74-16.84 56.12c0 .12 0 .24-.07.36l-16.21 54.16 46 13.8 36.76-122.6 7.54 2.26L148.25 368h51.5v144h52V368h8v144h52V368h51.51z"}}]})(props);
	};
	module.exports.IoWoman = function IoWoman (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"255.75","cy":"56","r":"56"}},{"tag":"path","attr":{"d":"M394.63 277.9l-10.33-34.41v-.11l-22.46-74.86h-.05l-2.51-8.45a44.87 44.87 0 00-43-32.08h-120a44.84 44.84 0 00-43 32.08l-2.51 8.45h-.06l-22.46 74.86v.11l-10.37 34.41c-3.12 10.39 2.3 21.66 12.57 25.14a20 20 0 0025.6-13.18l25.58-85.25 2.17-7.23a8 8 0 0115.53 2.62 7.78 7.78 0 01-.17 1.61L155.43 347.4a16 16 0 0015.32 20.6h29v114.69c0 16.46 10.53 29.31 24 29.31s24-12.85 24-29.31V368h16v114.69c0 16.46 10.53 29.31 24 29.31s24-12.85 24-29.31V368h30a16 16 0 0015.33-20.6l-43.74-145.81a7.52 7.52 0 01-.16-1.59 8 8 0 0115.54-2.63l2.17 7.23 25.57 85.25A20 20 0 00382.05 303c10.27-3.44 15.69-14.71 12.58-25.1z"}}]})(props);
	};


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;
	
	var _exenv = __webpack_require__(836);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
	
	var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Manager = Manager;
	exports.ManagerReferenceNodeSetterContext = exports.ManagerReferenceNodeContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var ManagerReferenceNodeContext = React.createContext();
	exports.ManagerReferenceNodeContext = ManagerReferenceNodeContext;
	var ManagerReferenceNodeSetterContext = React.createContext();
	exports.ManagerReferenceNodeSetterContext = ManagerReferenceNodeSetterContext;
	
	function Manager(_ref) {
	  var children = _ref.children;
	
	  var _React$useState = React.useState(null),
	      referenceNode = _React$useState[0],
	      setReferenceNode = _React$useState[1];
	
	  var hasUnmounted = React.useRef(false);
	  React.useEffect(function () {
	    return function () {
	      hasUnmounted.current = true;
	    };
	  }, []);
	  var handleSetReferenceNode = React.useCallback(function (node) {
	    if (!hasUnmounted.current) {
	      setReferenceNode(node);
	    }
	  }, []);
	  return /*#__PURE__*/React.createElement(ManagerReferenceNodeContext.Provider, {
	    value: referenceNode
	  }, /*#__PURE__*/React.createElement(ManagerReferenceNodeSetterContext.Provider, {
	    value: handleSetReferenceNode
	  }, children));
	}

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useIsomorphicLayoutEffect = exports.fromEntries = exports.setRef = exports.safeInvoke = exports.unwrapArray = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === 'function') {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	/**
	 * Sets a ref using either a ref callback or a ref object
	 */
	
	
	exports.safeInvoke = safeInvoke;
	
	var setRef = function setRef(ref, node) {
	  // if its a function call it
	  if (typeof ref === 'function') {
	    return safeInvoke(ref, node);
	  } // otherwise we should treat it as a ref object
	  else if (ref != null) {
	      ref.current = node;
	    }
	};
	/**
	 * Simple ponyfill for Object.fromEntries
	 */
	
	
	exports.setRef = setRef;
	
	var fromEntries = function fromEntries(entries) {
	  return entries.reduce(function (acc, _ref) {
	    var key = _ref[0],
	        value = _ref[1];
	    acc[key] = value;
	    return acc;
	  }, {});
	};
	/**
	 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
	 */
	
	
	exports.fromEntries = fromEntries;
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createSubscription = createSubscription;
	
	var _batch = __webpack_require__(419);
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	function createListenerCollection() {
	  var batch = (0, _batch.getBatch)();
	  var first = null;
	  var last = null;
	  return {
	    clear: function clear() {
	      first = null;
	      last = null;
	    },
	    notify: function notify() {
	      batch(function () {
	        var listener = first;
	
	        while (listener) {
	          listener.callback();
	          listener = listener.next;
	        }
	      });
	    },
	    get: function get() {
	      var listeners = [];
	      var listener = first;
	
	      while (listener) {
	        listeners.push(listener);
	        listener = listener.next;
	      }
	
	      return listeners;
	    },
	    subscribe: function subscribe(callback) {
	      var isSubscribed = true;
	      var listener = last = {
	        callback: callback,
	        next: null,
	        prev: last
	      };
	
	      if (listener.prev) {
	        listener.prev.next = listener;
	      } else {
	        first = listener;
	      }
	
	      return function unsubscribe() {
	        if (!isSubscribed || first === null) return;
	        isSubscribed = false;
	
	        if (listener.next) {
	          listener.next.prev = listener.prev;
	        } else {
	          last = listener.prev;
	        }
	
	        if (listener.prev) {
	          listener.prev.next = listener.next;
	        } else {
	          first = listener.next;
	        }
	      };
	    }
	  };
	}
	
	var nullListeners = {
	  notify: function notify() {},
	  get: function get() {
	    return [];
	  }
	};
	
	function createSubscription(store, parentSub) {
	  var unsubscribe;
	  var listeners = nullListeners;
	
	  function addNestedSub(listener) {
	    trySubscribe();
	    return listeners.subscribe(listener);
	  }
	
	  function notifyNestedSubs() {
	    listeners.notify();
	  }
	
	  function handleChangeWrapper() {
	    if (subscription.onStateChange) {
	      subscription.onStateChange();
	    }
	  }
	
	  function isSubscribed() {
	    return Boolean(unsubscribe);
	  }
	
	  function trySubscribe() {
	    if (!unsubscribe) {
	      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
	      listeners = createListenerCollection();
	    }
	  }
	
	  function tryUnsubscribe() {
	    if (unsubscribe) {
	      unsubscribe();
	      unsubscribe = undefined;
	      listeners.clear();
	      listeners = nullListeners;
	    }
	  }
	
	  var subscription = {
	    addNestedSub: addNestedSub,
	    notifyNestedSubs: notifyNestedSubs,
	    handleChangeWrapper: handleChangeWrapper,
	    isSubscribed: isSubscribed,
	    trySubscribe: trySubscribe,
	    tryUnsubscribe: tryUnsubscribe,
	    getListeners: function getListeners() {
	      return listeners;
	    }
	  };
	  return subscription;
	}

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useIsomorphicLayoutEffect = void 0;
	
	var _react = __webpack_require__(1);
	
	// React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
	// subscription callback always has the selector from the latest render commit
	// available, otherwise a store update may happen between render and the effect,
	// which may cause missed updates; we also must ensure the store subscription
	// is created synchronously, otherwise a store update may occur before the
	// subscription is created and an inconsistent state may be observed
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(55));
	
	var _config = _interopRequireDefault(__webpack_require__(424));
	
	var _PropTypes = __webpack_require__(425);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(169));
	
	var _reflow = __webpack_require__(426);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  } // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	  ;
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      if (nextStatus === ENTERING) {
	        if (this.props.unmountOnExit || this.props.mountOnEnter) {
	          var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
	          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
	          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
	
	          if (node) (0, _reflow.forceReflow)(node);
	        }
	
	        this.performEnter(mounting);
	      } else {
	        this.performExit();
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	
	    var _ref2 = this.props.nodeRef ? [appearing] : [_reactDom.default.findDOMNode(this), appearing],
	        maybeNode = _ref2[0],
	        maybeAppearing = _ref2[1];
	
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onEnter(maybeNode, maybeAppearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(maybeNode, maybeAppearing);
	
	      _this2.onTransitionEnd(enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(maybeNode, maybeAppearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit() {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts();
	    var maybeNode = this.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onExit(maybeNode);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(maybeNode);
	
	      _this3.onTransitionEnd(timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(maybeNode);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
	    this.setNextCallback(handler);
	    var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
	          maybeNode = _ref3[0],
	          maybeNextCallback = _ref3[1];
	
	      this.props.addEndListener(maybeNode, maybeNextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        _in = _this$props.in,
	        _mountOnEnter = _this$props.mountOnEnter,
	        _unmountOnExit = _this$props.unmountOnExit,
	        _appear = _this$props.appear,
	        _enter = _this$props.enter,
	        _exit = _this$props.exit,
	        _timeout = _this$props.timeout,
	        _addEndListener = _this$props.addEndListener,
	        _onEnter = _this$props.onEnter,
	        _onEntering = _this$props.onEntering,
	        _onEntered = _this$props.onEntered,
	        _onExit = _this$props.onExit,
	        _onExiting = _this$props.onExiting,
	        _onExited = _this$props.onExited,
	        _nodeRef = _this$props.nodeRef,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
	
	    return (
	      /*#__PURE__*/
	      // allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, typeof children === 'function' ? children(status, childProps) : _react.default.cloneElement(_react.default.Children.only(children), childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A React reference to DOM element that need to transition:
	   * https://stackoverflow.com/a/51127130/4671932
	   *
	   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
	   *      (e.g. `onEnter`) because user already has direct access to the node.
	   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
	   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
	   *     (see
	   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
	   */
	  nodeRef: _propTypes.default.shape({
	    current: typeof Element === 'undefined' ? _propTypes.default.any : function (propValue, key, componentName, location, propFullName, secret) {
	      var value = propValue[key];
	      return _propTypes.default.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
	    }
	  }),
	
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * By default the child component does not perform the enter transition when
	   * it first mounts, regardless of the value of `in`. If you want this
	   * behavior, set both `appear` and `in` to `true`.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. Timeouts are still used as a fallback if provided.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func
	} : {}; // Name the function so it is clearer in the documentation
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = UNMOUNTED;
	Transition.EXITED = EXITED;
	Transition.ENTERING = ENTERING;
	Transition.ENTERED = ENTERED;
	Transition.EXITING = EXITING;
	var _default = Transition;
	exports.default = _default;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(433);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(1014);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(52);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(465));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _CellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(1021));
	
	var _maxElementSize = __webpack_require__(1023);
	
	var _types = __webpack_require__(67);
	
	/**
	 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
	 */
	var ScalingCellSizeAndPositionManager =
	/*#__PURE__*/
	function () {
	  function ScalingCellSizeAndPositionManager(_ref) {
	    var _ref$maxScrollSize = _ref.maxScrollSize,
	        maxScrollSize = _ref$maxScrollSize === void 0 ? (0, _maxElementSize.getMaxElementSize)() : _ref$maxScrollSize,
	        params = (0, _objectWithoutProperties2["default"])(_ref, ["maxScrollSize"]);
	    (0, _classCallCheck2["default"])(this, ScalingCellSizeAndPositionManager);
	    (0, _defineProperty2["default"])(this, "_cellSizeAndPositionManager", void 0);
	    (0, _defineProperty2["default"])(this, "_maxScrollSize", void 0);
	    // Favor composition over inheritance to simplify IE10 support
	    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager["default"](params);
	    this._maxScrollSize = maxScrollSize;
	  }
	
	  (0, _createClass2["default"])(ScalingCellSizeAndPositionManager, [{
	    key: "areOffsetsAdjusted",
	    value: function areOffsetsAdjusted() {
	      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
	    }
	  }, {
	    key: "configure",
	    value: function configure(params) {
	      this._cellSizeAndPositionManager.configure(params);
	    }
	  }, {
	    key: "getCellCount",
	    value: function getCellCount() {
	      return this._cellSizeAndPositionManager.getCellCount();
	    }
	  }, {
	    key: "getEstimatedCellSize",
	    value: function getEstimatedCellSize() {
	      return this._cellSizeAndPositionManager.getEstimatedCellSize();
	    }
	  }, {
	    key: "getLastMeasuredIndex",
	    value: function getLastMeasuredIndex() {
	      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
	    }
	    /**
	     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
	     * The offset passed to this function is scaled (safe) as well.
	     */
	
	  }, {
	    key: "getOffsetAdjustment",
	    value: function getOffsetAdjustment(_ref2) {
	      var containerSize = _ref2.containerSize,
	          offset = _ref2.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	
	      var safeTotalSize = this.getTotalSize();
	
	      var offsetPercentage = this._getOffsetPercentage({
	        containerSize: containerSize,
	        offset: offset,
	        totalSize: safeTotalSize
	      });
	
	      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
	    }
	  }, {
	    key: "getSizeAndPositionOfCell",
	    value: function getSizeAndPositionOfCell(index) {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
	    }
	  }, {
	    key: "getSizeAndPositionOfLastMeasuredCell",
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
	    }
	    /** See CellSizeAndPositionManager#getTotalSize */
	
	  }, {
	    key: "getTotalSize",
	    value: function getTotalSize() {
	      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
	    }
	    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
	
	  }, {
	    key: "getUpdatedOffsetForIndex",
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align,
	          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
	          containerSize = _ref3.containerSize,
	          currentOffset = _ref3.currentOffset,
	          targetIndex = _ref3.targetIndex;
	      currentOffset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: currentOffset
	      });
	
	      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
	        align: align,
	        containerSize: containerSize,
	        currentOffset: currentOffset,
	        targetIndex: targetIndex
	      });
	
	      return this._offsetToSafeOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	    /** See CellSizeAndPositionManager#getVisibleCellRange */
	
	  }, {
	    key: "getVisibleCellRange",
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize,
	          offset = _ref4.offset;
	      offset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	      return this._cellSizeAndPositionManager.getVisibleCellRange({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	  }, {
	    key: "resetCell",
	    value: function resetCell(index) {
	      this._cellSizeAndPositionManager.resetCell(index);
	    }
	  }, {
	    key: "_getOffsetPercentage",
	    value: function _getOffsetPercentage(_ref5) {
	      var containerSize = _ref5.containerSize,
	          offset = _ref5.offset,
	          totalSize = _ref5.totalSize;
	      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
	    }
	  }, {
	    key: "_offsetToSafeOffset",
	    value: function _offsetToSafeOffset(_ref6) {
	      var containerSize = _ref6.containerSize,
	          offset = _ref6.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: totalSize
	        });
	
	        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
	      }
	    }
	  }, {
	    key: "_safeOffsetToOffset",
	    value: function _safeOffsetToOffset(_ref7) {
	      var containerSize = _ref7.containerSize,
	          offset = _ref7.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: safeTotalSize
	        });
	
	        return Math.round(offsetPercentage * (totalSize - containerSize));
	      }
	    }
	  }]);
	  return ScalingCellSizeAndPositionManager;
	}();
	
	exports["default"] = ScalingCellSizeAndPositionManager;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Swiper 6.8.4
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * https://swiperjs.com
	 *
	 * Copyright 2014-2021 Vladimir Kharlampidi
	 *
	 * Released under the MIT License
	 *
	 * Released on: August 23, 2021
	 */
	
	"use strict";
	exports.__esModule = true;
	exports.default = __webpack_require__(437).default;
	exports.Swiper = __webpack_require__(437).default;
	exports.Virtual = __webpack_require__(1120).default;
	exports.Keyboard = __webpack_require__(1112).default;
	exports.Mousewheel = __webpack_require__(1114).default;
	exports.Navigation = __webpack_require__(1115).default;
	exports.Pagination = __webpack_require__(1116).default;
	exports.Scrollbar = __webpack_require__(1118).default;
	exports.Parallax = __webpack_require__(1117).default;
	exports.Zoom = __webpack_require__(1121).default;
	exports.Lazy = __webpack_require__(1113).default;
	exports.Controller = __webpack_require__(1044).default;
	exports.A11y = __webpack_require__(1042).default;
	exports.History = __webpack_require__(1111).default;
	exports.HashNavigation = __webpack_require__(1110).default;
	exports.Autoplay = __webpack_require__(1043).default;
	exports.EffectFade = __webpack_require__(1108).default;
	exports.EffectCube = __webpack_require__(1107).default;
	exports.EffectFlip = __webpack_require__(1109).default;
	exports.EffectCoverflow = __webpack_require__(1106).default;
	exports.Thumbs = __webpack_require__(1119).default;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Bitmap-2.bb41791a.png";

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/doctor.d2b7f89b.jpg";

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/graf2.987ac0b7.png";

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/graf3.e521b0c3.png";

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/jci.8c9a9c45.png";

/***/ },
/* 180 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABACAYAAABBXsrdAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVHhe7ZVhTuYwDESXo+1VOAl/9zicgGtwF2A/NEiu0tZObMd2W9QnjVawbZ28Tsqfx83CLaPhltFQJuP/+9tPvl5fVvn89/cn9DNdh1STKoM2+PH85A5EVckJl0Fvm9vYbKhBWYTJmG2ANRlSpmVUS9gmUopbBs4wt7hR2o/lNvg/CndvLxHfFJcMLJxbEBfaqAds0CLGO4cwy9CKmF3YFq0YXOPFJEOzmGgJW7RSPMdGLWO0gGwJW7BZbh1trEJUMkYiPG8hitHaLAxl9L4R1W2Q6K0RsrR0ZVxBBBGxVlFG70yeTQQxK0SUIZ1FS+2OoCdkBCtDasXZRRCSkFE7WBncg5Aj/2pY4daP9PawkyFZvUorCE87djKkb0VGK7AwzMO/Gc/n9oFIrGRUfis46dFY27GSUdUKSXpVO9wyMloBtnOQDKR2cCwyKo8IwLxWvvS2ZrEclaGMjOq2ZD8fcPvqyrDU6Wpw++Iav8jgvhfIb4Dbm1kGd0MUOB7URszJPC7a1h8mg5uXhVkGd3GWjOqP9ambcUkZ3A0RVMvQvuhFhtZeBLeMhmoZ3CyXDPw+mkoZ0ixuX4sMoL1pljPI4GatZHBnC4mmUoZlTysZVUelSoY0h/tegJUMwN18VRnSy5Xm7GRItYoUUiFDmoFI7GRINpFIuDmRSC9VOiJgJwNUtaOdU9E8pAcro9eOyCqD6OcB78tkZYCekDPjOR6EKANwD0U0Dz6C2UZ3ZfQefjYhvbWOjgfRlQFGQjLOvJUIEWAoA/SGIZaBkfT+aiDW9qpkgJGQ6pZo1mNFLQNgADe4TbaUkQTEIwKYZADNYpBoKdq5uM6LWQbAJjUtQXCdRww2pRVAmREBXDIIrZBtSBBCm6afuetHwX0RLZySASwtychsG1qmZRDVUiIlEGEyCJKSIYaOVBbhMlogZqYxuA+bxzMqSJXBQYIQetMU+v1RlMs4M7eMhltGwy1j4fH4BkOphZOLWKfbAAAAAElFTkSuQmCC"

/***/ },
/* 181 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(183);
	function _inheritsLoose(t, o) {
	  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 183 */
/***/ function(module, exports) {

	function _setPrototypeOf(t, e) {
	  return (module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(58)["default"];
	var toPrimitive = __webpack_require__(466);
	function toPropertyKey(t) {
	  var i = toPrimitive(t, "string");
	  return "symbol" == _typeof(i) ? i : i + "";
	}
	module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setMode = exports.isInDoc = exports.isBeforeInputEventAvailable = exports.mergePlugins = exports.isTextareaOrInput = exports.uuid = exports.configHandlers = exports.configHandlers2 = exports.isFunction = void 0;
	var EditorPropTypes_1 = __webpack_require__(186);
	var isFunction = function (x) { return typeof x === 'function'; };
	exports.isFunction = isFunction;
	var isEventProp = function (name) { return name in EditorPropTypes_1.eventPropTypes; };
	var eventAttrToEventName = function (attrName) { return attrName.substr(2); };
	var configHandlers2 = function (handlerLookup, on, off, adapter, prevProps, props, boundHandlers) {
	    var prevEventKeys = Object.keys(prevProps).filter(isEventProp);
	    var currEventKeys = Object.keys(props).filter(isEventProp);
	    var removedKeys = prevEventKeys.filter(function (key) { return props[key] === undefined; });
	    var addedKeys = currEventKeys.filter(function (key) { return prevProps[key] === undefined; });
	    removedKeys.forEach(function (key) {
	        // remove event handler
	        var eventName = eventAttrToEventName(key);
	        var wrappedHandler = boundHandlers[eventName];
	        off(eventName, wrappedHandler);
	        delete boundHandlers[eventName];
	    });
	    addedKeys.forEach(function (key) {
	        var wrappedHandler = adapter(handlerLookup, key);
	        var eventName = eventAttrToEventName(key);
	        boundHandlers[eventName] = wrappedHandler;
	        on(eventName, wrappedHandler);
	    });
	};
	exports.configHandlers2 = configHandlers2;
	var configHandlers = function (editor, prevProps, props, boundHandlers, lookup) {
	    return (0, exports.configHandlers2)(lookup, editor.on.bind(editor), editor.off.bind(editor), 
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
	    function (handlerLookup, key) { return function (e) { var _a; return (_a = handlerLookup(key)) === null || _a === void 0 ? void 0 : _a(e, editor); }; }, prevProps, props, boundHandlers);
	};
	exports.configHandlers = configHandlers;
	var unique = 0;
	var uuid = function (prefix) {
	    var time = Date.now();
	    var random = Math.floor(Math.random() * 1000000000);
	    unique++;
	    return prefix + '_' + random + unique + String(time);
	};
	exports.uuid = uuid;
	var isTextareaOrInput = function (element) {
	    return element !== null && (element.tagName.toLowerCase() === 'textarea' || element.tagName.toLowerCase() === 'input');
	};
	exports.isTextareaOrInput = isTextareaOrInput;
	var normalizePluginArray = function (plugins) {
	    if (typeof plugins === 'undefined' || plugins === '') {
	        return [];
	    }
	    return Array.isArray(plugins) ? plugins : plugins.split(' ');
	};
	// eslint-disable-next-line max-len
	var mergePlugins = function (initPlugins, inputPlugins) { return normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins)); };
	exports.mergePlugins = mergePlugins;
	var isBeforeInputEventAvailable = function () { return window.InputEvent && typeof InputEvent.prototype.getTargetRanges === 'function'; };
	exports.isBeforeInputEventAvailable = isBeforeInputEventAvailable;
	var isInDoc = function (elem) {
	    if (!('isConnected' in Node.prototype)) {
	        // Fallback for IE and old Edge
	        var current = elem;
	        var parent_1 = elem.parentNode;
	        while (parent_1 != null) {
	            current = parent_1;
	            parent_1 = current.parentNode;
	        }
	        return current === elem.ownerDocument;
	    }
	    return elem.isConnected;
	};
	exports.isInDoc = isInDoc;
	var setMode = function (editor, mode) {
	    if (editor !== undefined) {
	        if (editor.mode != null && typeof editor.mode === 'object' && typeof editor.mode.set === 'function') {
	            editor.mode.set(mode);
	        }
	        else { // support TinyMCE 4
	            editor.setMode(mode);
	        }
	    }
	};
	exports.setMode = setMode;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EditorPropTypes = exports.eventPropTypes = void 0;
	var PropTypes = __webpack_require__(24);
	exports.eventPropTypes = {
	    onActivate: PropTypes.func,
	    onAddUndo: PropTypes.func,
	    onBeforeAddUndo: PropTypes.func,
	    onBeforeExecCommand: PropTypes.func,
	    onBeforeGetContent: PropTypes.func,
	    onBeforeRenderUI: PropTypes.func,
	    onBeforeSetContent: PropTypes.func,
	    onBeforePaste: PropTypes.func,
	    onBlur: PropTypes.func,
	    onChange: PropTypes.func,
	    onClearUndos: PropTypes.func,
	    onClick: PropTypes.func,
	    onContextMenu: PropTypes.func,
	    onCommentChange: PropTypes.func,
	    onCompositionEnd: PropTypes.func,
	    onCompositionStart: PropTypes.func,
	    onCompositionUpdate: PropTypes.func,
	    onCopy: PropTypes.func,
	    onCut: PropTypes.func,
	    onDblclick: PropTypes.func,
	    onDeactivate: PropTypes.func,
	    onDirty: PropTypes.func,
	    onDrag: PropTypes.func,
	    onDragDrop: PropTypes.func,
	    onDragEnd: PropTypes.func,
	    onDragGesture: PropTypes.func,
	    onDragOver: PropTypes.func,
	    onDrop: PropTypes.func,
	    onExecCommand: PropTypes.func,
	    onFocus: PropTypes.func,
	    onFocusIn: PropTypes.func,
	    onFocusOut: PropTypes.func,
	    onGetContent: PropTypes.func,
	    onHide: PropTypes.func,
	    onInit: PropTypes.func,
	    onInput: PropTypes.func,
	    onKeyDown: PropTypes.func,
	    onKeyPress: PropTypes.func,
	    onKeyUp: PropTypes.func,
	    onLoadContent: PropTypes.func,
	    onMouseDown: PropTypes.func,
	    onMouseEnter: PropTypes.func,
	    onMouseLeave: PropTypes.func,
	    onMouseMove: PropTypes.func,
	    onMouseOut: PropTypes.func,
	    onMouseOver: PropTypes.func,
	    onMouseUp: PropTypes.func,
	    onNodeChange: PropTypes.func,
	    onObjectResizeStart: PropTypes.func,
	    onObjectResized: PropTypes.func,
	    onObjectSelected: PropTypes.func,
	    onPaste: PropTypes.func,
	    onPostProcess: PropTypes.func,
	    onPostRender: PropTypes.func,
	    onPreProcess: PropTypes.func,
	    onProgressState: PropTypes.func,
	    onRedo: PropTypes.func,
	    onRemove: PropTypes.func,
	    onReset: PropTypes.func,
	    onSaveContent: PropTypes.func,
	    onSelectionChange: PropTypes.func,
	    onSetAttrib: PropTypes.func,
	    onSetContent: PropTypes.func,
	    onShow: PropTypes.func,
	    onSubmit: PropTypes.func,
	    onUndo: PropTypes.func,
	    onVisualAid: PropTypes.func,
	    onSkinLoadError: PropTypes.func,
	    onThemeLoadError: PropTypes.func,
	    onModelLoadError: PropTypes.func,
	    onPluginLoadError: PropTypes.func,
	    onIconsLoadError: PropTypes.func,
	    onLanguageLoadError: PropTypes.func,
	    onScriptsLoad: PropTypes.func,
	    onScriptsLoadError: PropTypes.func,
	};
	exports.EditorPropTypes = __assign({ apiKey: PropTypes.string, licenseKey: PropTypes.string, id: PropTypes.string, inline: PropTypes.bool, init: PropTypes.object, initialValue: PropTypes.string, onEditorChange: PropTypes.func, value: PropTypes.string, tagName: PropTypes.string, tabIndex: PropTypes.number, cloudChannel: PropTypes.string, plugins: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), toolbar: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), disabled: PropTypes.bool, textareaName: PropTypes.string, tinymceScriptSrc: PropTypes.oneOfType([
	        PropTypes.string,
	        PropTypes.arrayOf(PropTypes.string),
	        PropTypes.arrayOf(PropTypes.shape({
	            src: PropTypes.string,
	            async: PropTypes.bool,
	            defer: PropTypes.bool
	        }))
	    ]), rollback: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([false])]), scriptLoading: PropTypes.shape({
	        async: PropTypes.bool,
	        defer: PropTypes.bool,
	        delay: PropTypes.number
	    }) }, exports.eventPropTypes);


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	var settle = __webpack_require__(479);
	var cookies = __webpack_require__(482);
	var buildURL = __webpack_require__(194);
	var buildFullPath = __webpack_require__(189);
	var parseHeaders = __webpack_require__(488);
	var isURLSameOrigin = __webpack_require__(485);
	var transitionalDefaults = __webpack_require__(191);
	var AxiosError = __webpack_require__(80);
	var CanceledError = __webpack_require__(110);
	var parseProtocol = __webpack_require__(489);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	    var onCanceled;
	    function done() {
	      if (config.cancelToken) {
	        config.cancelToken.unsubscribe(onCanceled);
	      }
	
	      if (config.signal) {
	        config.signal.removeEventListener('abort', onCanceled);
	      }
	    }
	
	    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(function _resolve(value) {
	        resolve(value);
	        done();
	      }, function _reject(err) {
	        reject(err);
	        done();
	      }, response);
	
	      // Clean up request
	      request = null;
	    }
	
	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }
	
	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
	      var transitional = config.transitional || transitionalDefaults;
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(new AxiosError(
	        timeoutErrorMessage,
	        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
	        config,
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken || config.signal) {
	      // Handle cancellation
	      // eslint-disable-next-line func-names
	      onCanceled = function(cancel) {
	        if (!request) {
	          return;
	        }
	        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
	        request.abort();
	        request = null;
	      };
	
	      config.cancelToken && config.cancelToken.subscribe(onCanceled);
	      if (config.signal) {
	        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
	      }
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    var protocol = parseProtocol(fullPath);
	
	    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
	      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
	      return;
	    }
	
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 188 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(483);
	var combineURLs = __webpack_require__(481);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  // eslint-disable-next-line consistent-return
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function mergeDirectKeys(prop) {
	    if (prop in config2) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  var mergeMap = {
	    'url': valueFromConfig2,
	    'method': valueFromConfig2,
	    'data': valueFromConfig2,
	    'baseURL': defaultToConfig2,
	    'transformRequest': defaultToConfig2,
	    'transformResponse': defaultToConfig2,
	    'paramsSerializer': defaultToConfig2,
	    'timeout': defaultToConfig2,
	    'timeoutMessage': defaultToConfig2,
	    'withCredentials': defaultToConfig2,
	    'adapter': defaultToConfig2,
	    'responseType': defaultToConfig2,
	    'xsrfCookieName': defaultToConfig2,
	    'xsrfHeaderName': defaultToConfig2,
	    'onUploadProgress': defaultToConfig2,
	    'onDownloadProgress': defaultToConfig2,
	    'decompress': defaultToConfig2,
	    'maxContentLength': defaultToConfig2,
	    'maxBodyLength': defaultToConfig2,
	    'beforeRedirect': defaultToConfig2,
	    'transport': defaultToConfig2,
	    'httpAgent': defaultToConfig2,
	    'httpsAgent': defaultToConfig2,
	    'cancelToken': defaultToConfig2,
	    'socketPath': defaultToConfig2,
	    'responseEncoding': defaultToConfig2,
	    'validateStatus': mergeDirectKeys
	  };
	
	  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
	    var merge = mergeMap[prop] || mergeDeepProperties;
	    var configValue = merge(prop);
	    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
	  });
	
	  return config;
	};


/***/ },
/* 191 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  silentJSONParsing: true,
	  forcedJSONParsing: true,
	  clarifyTimeoutError: false
	};


/***/ },
/* 192 */
/***/ function(module, exports) {

	module.exports = {
	  "version": "0.27.2"
	};

/***/ },
/* 193 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var utils = __webpack_require__(44);
	
	/**
	 * Convert a data object to FormData
	 * @param {Object} obj
	 * @param {?Object} [formData]
	 * @returns {Object}
	 **/
	
	function toFormData(obj, formData) {
	  // eslint-disable-next-line no-param-reassign
	  formData = formData || new FormData();
	
	  var stack = [];
	
	  function convertValue(value) {
	    if (value === null) return '';
	
	    if (utils.isDate(value)) {
	      return value.toISOString();
	    }
	
	    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
	      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
	    }
	
	    return value;
	  }
	
	  function build(data, parentKey) {
	    if (utils.isPlainObject(data) || utils.isArray(data)) {
	      if (stack.indexOf(data) !== -1) {
	        throw Error('Circular reference detected in ' + parentKey);
	      }
	
	      stack.push(data);
	
	      utils.forEach(data, function each(value, key) {
	        if (utils.isUndefined(value)) return;
	        var fullKey = parentKey ? parentKey + '.' + key : key;
	        var arr;
	
	        if (value && !parentKey && typeof value === 'object') {
	          if (utils.endsWith(key, '{}')) {
	            // eslint-disable-next-line no-param-reassign
	            value = JSON.stringify(value);
	          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
	            // eslint-disable-next-line func-names
	            arr.forEach(function(el) {
	              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
	            });
	            return;
	          }
	        }
	
	        build(value, fullKey);
	      });
	
	      stack.pop();
	    } else {
	      formData.append(parentKey, convertValue(data));
	    }
	  }
	
	  build(obj);
	
	  return formData;
	}
	
	module.exports = toFormData;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ },
/* 196 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var USER_INIT = exports.USER_INIT = 'USER_INIT';
	var USER_LOGIN_SUCCESS = exports.USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
	var USER_LOGIN_ERROR = exports.USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';
	var USER_LOGOUT_SUCCESS = exports.USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
	var USER_LOGOUT_ERROR = exports.USER_LOGOUT_ERROR = 'USER_LOGOUT_ERROR';

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectDeptment = function SelectDeptment(_ref) {
	  var SelectDeptment = _ref.SelectDeptment;
	
	  // console.log(SelectDeptment, "SelectDeptment")
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        style: {
	          display: "flex",
	          justifyContent: "center",
	          alignItems: "flex-start",
	          flexDirection: "column",
	          width: "308px",
	          margin: "0 auto"
	        }
	      },
	      _react2.default.createElement(
	        "h3",
	        {
	          className: "text-center",
	          style: { color: "#0C807D", fontSize: "28px", fontWeight: "500" }
	        },
	        "Department"
	      ),
	      _react2.default.createElement("img", { src: "/assets/images/Rectangle 33.png", alt: "" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "row mt-2" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "col-md-6",
	          style: {
	            backgroundColor: "#E6DFCF",
	            width: "204px",
	            height: "114px",
	            borderRadius: "16px"
	          }
	        },
	        SelectDeptment && SelectDeptment.map(function (dpt) {
	          return _react2.default.createElement(
	            "h1",
	            null,
	            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat totam distinctio qui, error quis sint ipsam. Iusto enim quo dolorem. Vitae quo labore perferendis alias voluptas doloribus quam. Mollitia, sed?"
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = SelectDeptment;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getAllBodyLinkDept = function getAllBodyLinkDept(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bodylink/getallbodylink", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSearchData = function getSearchData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bodylink/getsearchdata", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var deletebodylinks = function deletebodylinks(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bodylink/deletebodylinks", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var BodyLinkDept = function (_Component) {
	  _inherits(BodyLinkDept, _Component);
	
	  function BodyLinkDept() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BodyLinkDept);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BodyLinkDept.__proto__ || Object.getPrototypeOf(BodyLinkDept)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      bodyLinkDept: [],
	      total: "",
	      currentPage: "",
	      LastPage: "",
	      PerPage: "",
	      FirstPageUrl: "",
	      NextPageUrl: "",
	      PrevPageUrl: "",
	      LastPageUrl: "",
	      TotalPages: "",
	      activePage: 1,
	      id: "",
	      enableShdo: false,
	      enableShdoLive: false,
	      search_keywords: ""
	    }, _this.handleChange = function (events) {
	      _this.setState(_defineProperty({}, events.target.name, events.target.value));
	    }, _this.refreshbodyLinkDept = function (page) {
	      _this.setState({ enableShdo: true });
	      var data = {
	        page: page
	      };
	      getAllBodyLinkDept(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ bodyLinkDept: records });
	          _this.setState({ total: res.data.total });
	          _this.setState({ currentPage: res.data.current_page });
	          _this.setState({ PerPage: res.data.per_page });
	          _this.setState({ FirstPageUrl: res.data.first_page_url });
	          _this.setState({ NextPageUrl: res.data.next_page_url });
	          _this.setState({ PrevPageUrl: res.data.prev_page_url });
	          _this.setState({ LastPageUrl: res.data.last_page_url });
	          _this.setState({ LastPage: res.data.last_page });
	          _this.setState({
	            TotalPages: Math.ceil(_this.state.total / _this.state.PerPage)
	          });
	        } else {
	          _this.setState({ bodyLinkDept: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.SearchData = function (e) {
	      var data = {
	        keywords: _this.state.search_keywords
	      };
	      getSearchData(data).then(function (res) {
	        console.log(res);
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ bodyLinkDept: records });
	          _this.setState({ total: res.data.total });
	          _this.setState({ currentPage: res.data.current_page });
	          _this.setState({ PerPage: res.data.per_page });
	          _this.setState({ FirstPageUrl: res.data.first_page_url });
	          _this.setState({ NextPageUrl: res.data.next_page_url });
	          _this.setState({ PrevPageUrl: res.data.prev_page_url });
	          _this.setState({ LastPageUrl: res.data.last_page_url });
	          _this.setState({ LastPage: res.data.last_page });
	          _this.setState({
	            TotalPages: Math.ceil(_this.state.total / _this.state.PerPage)
	          });
	        } else {
	          _this.setState({ bodyLinkDept: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BodyLinkDept, [{
	    key: "handlePageChange",
	    value: function handlePageChange(pageNumber) {
	      this.setState({ activePage: pageNumber });
	      this.refreshbodyLinkDept(pageNumber);
	    }
	  }, {
	    key: "modalDeleteConfirmOpen",
	    value: function modalDeleteConfirmOpen(e, id) {
	      this.setState({
	        modalDeleteConfirm: true,
	        id: id
	      });
	    }
	  }, {
	    key: "modalDeleteConfirmClose",
	    value: function modalDeleteConfirmClose() {
	      this.setState({
	        modalDeleteConfirm: false
	      });
	    }
	  }, {
	    key: "modalDelete",
	    value: function modalDelete(id) {
	      this.setState({
	        modalDeleteConfirm: false
	      });
	      var data = {
	        id: id
	      };
	      deletebodylinks(data).then(function (res) {
	        // console.log(res);
	        if (res.status === true) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.href = "/body-links";
	          }, 6000);
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshbodyLinkDept();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var pageNumbers = [];
	      for (var i = 1; i <= this.state.TotalPages; i++) {
	        pageNumbers.push(i);
	      }
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "container-fluid" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "card m-b-20" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "card-body" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-7" },
	                              _react2.default.createElement(
	                                "h4",
	                                { className: "mt-0 header-title" },
	                                "Body Parts"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-3 text-right" },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "search_keywords",
	                                id: "search_keywords",
	                                value: this.state.search_keywords,
	                                onChange: this.handleChange,
	                                onBlur: this.SearchData,
	                                placeholder: "Search"
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-2 text-right" },
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  href: "/admin/AddBodyLink",
	                                  className: "btn btn-sm waves-effect waves-light"
	                                },
	                                "Add Body Part"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "table-rep-plugin" },
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                className: "table-responsive b-0",
	                                "data-pattern": "priority-columns"
	                              },
	                              _react2.default.createElement(
	                                "table",
	                                {
	                                  id: "tech-companies-1",
	                                  className: "table  table-striped"
	                                },
	                                _react2.default.createElement(
	                                  "thead",
	                                  null,
	                                  _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    _react2.default.createElement(
	                                      "th",
	                                      null,
	                                      "ID"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "1" },
	                                      "Body Parts"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "4" },
	                                      "Department"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      null,
	                                      "Gender"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "3" },
	                                      "Action"
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  "tbody",
	                                  null,
	                                  this.state.bodyLinkDept.length > 0 ? this.state.bodyLinkDept.map(function (body) {
	                                    return _react2.default.createElement(
	                                      "tr",
	                                      { key: body.body_link_dept_id },
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "#",
	                                        body.body_link_dept_id
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        body.bodypart_name
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        body.department_name
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        body.gender
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            href: "/admin/editbodylink/" + body.body_link_dept_id
	                                          },
	                                          _react2.default.createElement("i", { className: "fa fa-pencil-square" })
	                                        ),
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            onClick: function onClick(e) {
	                                              return _this2.modalDeleteConfirmOpen(e, body.body_link_dept_id);
	                                            }
	                                          },
	                                          _react2.default.createElement("i", { className: "fa fa-trash" })
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        _DeleteConfirmModalPopup2.default,
	                                        {
	                                          show: _this2.state.modalDeleteConfirm,
	                                          handleClose: function handleClose(e) {
	                                            return _this2.modalDeleteConfirmClose(e);
	                                          }
	                                        },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "custom_reviews_popup" },
	                                          _react2.default.createElement(
	                                            "h2",
	                                            { className: "text-center" },
	                                            "Are you sure you wish to delete this body part link ?"
	                                          ),
	                                          _react2.default.createElement(
	                                            "form",
	                                            {
	                                              className: "pop-form",
	                                              id: "edit_education"
	                                            },
	                                            _react2.default.createElement(
	                                              "div",
	                                              { className: "form-group row" },
	                                              _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                                              _react2.default.createElement(
	                                                "div",
	                                                { className: "col-sm-6 text-center" },
	                                                _react2.default.createElement(
	                                                  "button",
	                                                  {
	                                                    type: "button",
	                                                    className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                                    onClick: function onClick(e) {
	                                                      return _this2.modalDeleteConfirmClose(e);
	                                                    }
	                                                  },
	                                                  " ",
	                                                  "No"
	                                                ),
	                                                _react2.default.createElement(
	                                                  "button",
	                                                  {
	                                                    type: "button",
	                                                    className: "blue_btn_box add_staff_btn mt-5",
	                                                    onClick: function onClick() {
	                                                      return _this2.modalDelete(_this2.state.id);
	                                                    }
	                                                  },
	                                                  "Yes"
	                                                )
	                                              ),
	                                              _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                                            )
	                                          )
	                                        )
	                                      )
	                                    );
	                                  }) : _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    _react2.default.createElement(
	                                      "td",
	                                      {
	                                        colSpan: "6",
	                                        className: "font_12 txt_col fontweight400 ",
	                                        style: { textAlign: "center" }
	                                      },
	                                      " ",
	                                      "There are currently no Body Links Department."
	                                    )
	                                  )
	                                )
	                              ),
	                              pageNumbers.length > 1 ? _react2.default.createElement(_reactJsPagination2.default, {
	                                activePage: this.state.activePage,
	                                totalItemsCount: this.state.total,
	                                pageRangeDisplayed: 5,
	                                onChange: this.handlePageChange.bind(this)
	                              }) : ""
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return BodyLinkDept;
	}(_react.Component);
	
	exports.default = BodyLinkDept;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _DownloadCSV = __webpack_require__(146);
	
	var _DownloadCSV2 = _interopRequireDefault(_DownloadCSV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableComponent = function TableComponent(_ref) {
	    var _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        data = _ref.data,
	        columns = _ref.columns,
	        _ref$itemsPerPage = _ref.itemsPerPage,
	        itemsPerPage = _ref$itemsPerPage === undefined ? 20 : _ref$itemsPerPage;
	
	    var _useState = (0, _react.useState)(data),
	        _useState2 = _slicedToArray(_useState, 2),
	        filteredData = _useState2[0],
	        setFilteredData = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(1),
	        _useState4 = _slicedToArray(_useState3, 2),
	        currentPage = _useState4[0],
	        setCurrentPage = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(""),
	        _useState6 = _slicedToArray(_useState5, 2),
	        searchTerm = _useState6[0],
	        setSearchTerm = _useState6[1];
	
	    // Filter data based on search term
	
	
	    (0, _react.useEffect)(function () {
	        var filtered = data.filter(function (item) {
	            return Object.values(item).some(function (value) {
	                return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
	            });
	        });
	        setFilteredData(filtered);
	        setCurrentPage(1); // Reset to first page on search
	    }, [data, searchTerm]);
	
	    // Pagination logic
	    var indexOfLastItem = currentPage * itemsPerPage;
	    var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	    var currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
	
	    var handlePageChange = function handlePageChange(pageNumber) {
	        setCurrentPage(pageNumber);
	    };
	
	    var handleSearch = function handleSearch(event) {
	        setSearchTerm(event.target.value);
	    };
	
	    return _react2.default.createElement(
	        "div",
	        { className: "card" },
	        _react2.default.createElement(
	            "div",
	            { className: "card-header row" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-6" },
	                _react2.default.createElement(
	                    "h5",
	                    { className: "card-title text-left" },
	                    title
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement("input", {
	                    type: "search",
	                    className: "form-control",
	                    placeholder: "Search",
	                    value: searchTerm,
	                    onChange: handleSearch
	                })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-2 text-right" },
	                _react2.default.createElement(_DownloadCSV2.default, { data: filteredData, fileName: title })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "card-body table-responsive" },
	            _react2.default.createElement(
	                "table",
	                { className: "table table-striped table-hover" },
	                _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                        "tr",
	                        null,
	                        columns.map(function (column, index) {
	                            return _react2.default.createElement(
	                                "th",
	                                { key: index, scope: "col" },
	                                column.header
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "tbody",
	                    null,
	                    currentItems.length > 0 ? currentItems.map(function (item, index) {
	                        return _react2.default.createElement(
	                            "tr",
	                            { key: item.id || index },
	                            columns.map(function (column, colIndex) {
	                                return _react2.default.createElement(
	                                    "td",
	                                    { key: colIndex },
	                                    typeof column.accessor === "function" ? column.accessor(item, index) : item[column.accessor]
	                                );
	                            })
	                        );
	                    }) : _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "td",
	                            { colSpan: columns.length, className: "text-center" },
	                            "No data found"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_reactJsPagination2.default, {
	                activePage: currentPage,
	                itemsCountPerPage: itemsPerPage,
	                totalItemsCount: filteredData.length,
	                pageRangeDisplayed: 5,
	                onChange: handlePageChange
	            })
	        )
	    );
	};
	
	TableComponent.propTypes = {
	    data: _propTypes2.default.array.isRequired,
	    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        header: _propTypes2.default.string.isRequired,
	        accessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
	    })).isRequired,
	    itemsPerPage: _propTypes2.default.number
	};
	
	exports.default = TableComponent;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _logo = __webpack_require__(135);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ForgotPassword = function ForgotPassword() {
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      email = _useState2[0],
	      setEmail = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({}),
	      _useState4 = _slicedToArray(_useState3, 2),
	      errors = _useState4[0],
	      setErrors = _useState4[1];
	
	  var validateForm = function validateForm() {
	    var newErrors = {};
	    var isValid = true;
	
	    if (!email) {
	      isValid = false;
	      newErrors.email = "*Please enter your email address.";
	    } else if (!/\S+@\S+\.\S+/.test(email)) {
	      isValid = false;
	      newErrors.email = "*Please enter a valid email address.";
	    }
	
	    setErrors(newErrors);
	    return isValid;
	  };
	
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	    if (validateForm()) {
	      console.log("Email:", email);
	      return new Promise(function (resolve, reject) {
	        var req = _.scAxiosAdmin.post('/forgetpassword', { email: email, base_url: window.location.origin }, {
	          headers: {
	            'Accept': 'application/json'
	          }
	        });
	        req.then(function (res) {
	          return resolve(res.data);
	        }).catch(function (err) {
	          return reject(err);
	        });
	        // Simulate a forgot password API call
	        _reactToastify.toast.success("Password reset link sent to your email.", {
	          position: _reactToastify.toast.POSITION.TOP_RIGHT
	        });
	      });
	    } else {
	      _reactToastify.toast.error("Please fix the errors and try again.", {
	        position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	      });
	    }
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "account-bg" },
	    _react2.default.createElement(
	      "div",
	      { className: "account-pages my-5 pt-5" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row justify-content-center" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-8 col-lg-6 col-xl-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "card" },
	              _react2.default.createElement(
	                "div",
	                { className: "card-body" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "text-center mt-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mb-3" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "/" },
	                      _react2.default.createElement("img", { src: _logo2.default, height: 80, alt: "logo" })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "p-3" },
	                  _react2.default.createElement(
	                    "h4",
	                    { className: "font-size-18 text-muted mt-2 text-center" },
	                    "Forgot Password"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "text-muted text-center mb-4" },
	                    "Enter your email to reset your password."
	                  ),
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      className: "form-horizontal",
	                      onSubmit: handleSubmit,
	                      noValidate: true
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "label",
	                        { htmlFor: "user_email" },
	                        "Email"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "email",
	                        className: "form-control",
	                        name: "email",
	                        id: "user_email",
	                        value: email,
	                        onChange: function onChange(e) {
	                          return setEmail(e.target.value);
	                        },
	                        placeholder: "Enter email",
	                        required: true,
	                        autoComplete: "off"
	                      }),
	                      errors.email && _react2.default.createElement(
	                        "span",
	                        { style: { color: "red" } },
	                        errors.email
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group row mt-4" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-12 text-right" },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            className: "btn btn-primary w-md waves-effect waves-light",
	                            type: "submit"
	                          },
	                          "Reset Password"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group mb-0 row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-12 mt-4 text-center" },
	                        _react2.default.createElement(
	                          _reactRouterDom.Link,
	                          { to: "/adminlogin", className: "text-muted" },
	                          _react2.default.createElement("i", { className: "mdi mdi-arrow-left" }),
	                          " Back to Login"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "mt-5 text-center" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "\xA9 2024 United Hospital"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = ForgotPassword;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import Footer from '../../component/admin/Footer';
	
	
	var updateAlbum = function updateAlbum(id, data, edit_album_name, edit_album_desc, imageData) {
	  var formdata = new FormData();
	  formdata.append("edit_album_name", edit_album_name);
	  formdata.append("edit_album_desc", edit_album_desc);
	  data.new_album_pics.forEach(function (album_pic) {
	    formdata.append("new_album_pics[]", album_pic);
	  });
	  // console.log(data.album_pic);
	  data.edit_album_pics.forEach(function (album_pic) {
	    formdata.append("edit_album_pics[]", album_pic);
	  });
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/album/updatealbum/" + id, formdata, {
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleAlbumData = function getSingleAlbumData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/album/getalbum/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var EditAlbum = function (_Component) {
	  _inherits(EditAlbum, _Component);
	
	  function EditAlbum() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditAlbum);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditAlbum.__proto__ || Object.getPrototypeOf(EditAlbum)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      id: "",
	      edit_album_name: "",
	      edit_album_desc: "",
	      edit_album_pics: [],
	      new_album_pics: []
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.DescReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_album_desc: val
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        /*let fields = {};
	              fields["edit_department_name"] = "";
	              this.setState({ fields: fields });*/
	        var id = _this.state.id;
	        var data = {
	          edit_album_title: _this.state.edit_album_name,
	          edit_album_desc: _this.state.edit_album_desc,
	          edit_album_pics: _this.state.edit_album_pics,
	          new_album_pics: _this.state.new_album_pics
	        };
	        updateAlbum(id, data, _this.state.edit_album_name, _this.state.edit_album_desc, _this.state.edit_album_pics).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshgetSingleAlbumData = function (id) {
	      getSingleAlbumData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          console.log(records);
	          _this.setState({
	            id: records.id,
	            edit_album_name: records.album_name,
	            edit_album_desc: records.album_desc,
	            edit_album_pics: JSON.parse(records.album_pics)
	          });
	        } else {
	          _this.setState({
	            id: "",
	            edit_album_name: "",
	            edit_album_desc: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditAlbum, [{
	    key: "removeImage",
	    value: function removeImage(album_pics, key) {
	      console.log(album_pics, key);
	      var new_album_pics = this.state.edit_album_pics.filter(function (pic) {
	        return pic != album_pics;
	      });
	      console.log(new_album_pics);
	      this.setState({
	        edit_album_pics: new_album_pics
	      });
	    }
	  }, {
	    key: "validateForm",
	    value: function validateForm() {
	      //let fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.edit_album_name) {
	        formIsValid = false;
	        errors["edit_doctor_name"] = "*Please enter your Album name.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onFileChange",
	    value: function onFileChange(file) {
	      var newFiles = Array.prototype.slice.call(file);
	      this.setState({
	        new_album_pics: newFiles
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSingleAlbumData(this.props.match.params.id);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Edit Album"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Album Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_album_name",
	                                id: "edit_album_name",
	                                value: this.state.edit_album_name,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Album Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_doctor_name
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Album Description"
	                              ),
	                              _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                id: "desceditor",
	                                name: "desceditor",
	                                value: this.state.edit_album_desc,
	                                onChange: function onChange(name, val) {
	                                  _this2.DescReactQuillHandleChange(name, val);
	                                }
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Album Pictures"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                multiple: true,
	                                className: "form-control",
	                                name: "new_album_pics",
	                                id: "new_album_pics",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png",
	                                placeholder: "Doctor Fees"
	                              }),
	                              this.state.edit_album_pics && this.state.edit_album_pics.map(function (album_pic, key) {
	                                console.log(album_pic);
	                                return [_react2.default.createElement("img", {
	                                  className: "mt-3",
	                                  width: "200",
	                                  src: _constants.IMAGE_URL + "AlbumImg/" + album_pic
	                                }), _react2.default.createElement(
	                                  "a",
	                                  {
	                                    onClick: function onClick() {
	                                      return _this2.removeImage(album_pic, key);
	                                    }
	                                  },
	                                  "Remove ",
	                                  key,
	                                  " "
	                                )];
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Update"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return EditAlbum;
	}(_react.Component);
	
	exports.default = EditAlbum;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _leftsidebar = __webpack_require__(96);
	
	var _leftsidebar2 = _interopRequireDefault(_leftsidebar);
	
	var _drPhoto = __webpack_require__(129);
	
	var _drPhoto2 = _interopRequireDefault(_drPhoto);
	
	var _round = __webpack_require__(180);
	
	var _round2 = _interopRequireDefault(_round);
	
	var _icon = __webpack_require__(57);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icon3 = __webpack_require__(131);
	
	var _icon4 = _interopRequireDefault(_icon3);
	
	var _icon5 = __webpack_require__(132);
	
	var _icon6 = _interopRequireDefault(_icon5);
	
	var _icon7 = __webpack_require__(133);
	
	var _icon8 = _interopRequireDefault(_icon7);
	
	var _icon9 = __webpack_require__(134);
	
	var _icon10 = _interopRequireDefault(_icon9);
	
	var _cardiac = __webpack_require__(104);
	
	var _cardiac2 = _interopRequireDefault(_cardiac);
	
	var _Bitmap = __webpack_require__(175);
	
	var _Bitmap2 = _interopRequireDefault(_Bitmap);
	
	var _hospital = __webpack_require__(130);
	
	var _hospital2 = _interopRequireDefault(_hospital);
	
	var _searchIcon = __webpack_require__(137);
	
	var _searchIcon2 = _interopRequireDefault(_searchIcon);
	
	var _graf = __webpack_require__(177);
	
	var _graf2 = _interopRequireDefault(_graf);
	
	var _graf3 = __webpack_require__(178);
	
	var _graf4 = _interopRequireDefault(_graf3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	
	
	var GetSinglePatientsData = function GetSinglePatientsData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/patients', {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var GetPatitentAppointment = function GetPatitentAppointment(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/appointment', {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleDoctorData = function getSingleDoctorData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request('/doctors/getsingledoctors/' + id, {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json',
	        'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var Appointments = function (_Component) {
	  _inherits(Appointments, _Component);
	
	  function Appointments() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Appointments);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Appointments.__proto__ || Object.getPrototypeOf(Appointments)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      patient_ID: '',
	      patient_age: '',
	      patient_gender: '',
	      patient_name: '',
	      patient_phone: '',
	      latest_consultant: [],
	      doctor_name: '',
	      appointment_date: '',
	      department_name: '',
	      doctor_id: '',
	      doctor_profile: '',
	      patient_report_data: [],
	      paitent_report_doctor_name: ''
	    }, _this.refreshSinglePatientsData = function () {
	      var data = {
	        patient: localStorage.getItem(_constants.USER_ID)
	      };
	      GetSinglePatientsData(data).then(function (res) {
	        _this.setState({
	          patient_ID: res[0].patient_ID,
	          patient_age: res[0].patient_age,
	          patient_gender: res[0].patient_gender,
	          patient_name: res[0].patient_name,
	          patient_phone: res[0].patient_phone
	        });
	        if (res[0].latest_consultant) {
	          _this.setState({ latest_consultant: res[0].latest_consultant });
	        } else {
	          _this.setState({ latest_consultant: '' });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshGetPatitentAppointment = function () {
	      var data = {
	        xpatient: localStorage.getItem(_constants.USER_ID)
	      };
	      GetPatitentAppointment(data).then(function (res) {
	        _this.refreshGetDoctorData(res[0].doctor[0].id);
	        _this.setState({
	          doctor_name: res[0].doctor[0].name,
	          appointment_date: res[0].date,
	          department_name: res[0].doctor[0].dept_name,
	          doctor_id: res[0].doctor[0].id
	        });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshGetDoctorData = function (id) {
	      getSingleDoctorData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            doctor_profile: records.doctor_profile
	          });
	        } else {
	          _this.setState({
	            doctor_profile: ''
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Appointments, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refreshSinglePatientsData();
	      this.refreshGetPatitentAppointment();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'section',
	          { className: 'dashboard-part' },
	          _react2.default.createElement(
	            'div',
	            { className: 'main-center-box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-part' },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _leftsidebar2.default }),
	              _react2.default.createElement(
	                'div',
	                { className: 'dash-body', id: 'dark-version-body' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row mt-4' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'dash-text sspp' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'mb-3 Your' },
	                        'Your Appointments'
	                      ),
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'mb-3' },
	                        'Appointments ',
	                        _react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
	                        ' '
	                      ),
	                      this.state.appointment_date ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-3 img-sp' },
	                            this.state.doctor_profile ? _react2.default.createElement('img', { src: _constants.IMAGE_URL + '/DoctorProfileImg/' + this.state.doctor_profile, alt: this.state.doctor_profile }) : _react2.default.createElement('img', { src: 'https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg', alt: this.state.doctor_profile })
	                            /*<img src={dr_photo} alt="drphoto"/>*/
	
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-9 prof sp-l-r' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                this.state.doctor_name
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              this.state.department_name
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'date-link' },
	                              'Referred By ',
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                this.state.doctor_name
	                              ),
	                              ' on ',
	                              _react2.default.createElement(
	                                'a',
	                                { href: '#' },
	                                this.state.appointment_date
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-5 img-sp' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'mt-3 Date-time' },
	                              'Date ',
	                              _react2.default.createElement('br', null),
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                this.state.appointment_date
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-7' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'mt-3 Date-time' },
	                              'Time ',
	                              _react2.default.createElement('br', null),
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                '9:30 am - 10:00 am'
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            _react2.default.createElement(
	                              'button',
	                              { className: 'btn-notes mt-3' },
	                              'Schedule Followup'
	                            )
	                          )
	                        )
	                      ) : _react2.default.createElement(
	                        'p',
	                        null,
	                        'No appointment data found'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-5' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'dash-text sspp icon-and-text' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-2 img-sp' },
	                          _react2.default.createElement('img', { src: _round2.default, alt: 'round-' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-10' },
	                          _react2.default.createElement(
	                            'h3',
	                            { className: 'Your' },
	                            'Reports '
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Lorem Ipsum is simply dummy text of the printing and typesetting. '
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'dash-text sspp icon-and-text' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-2 img-sp' },
	                          _react2.default.createElement('img', { src: _round2.default, alt: 'round-' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-10' },
	                          _react2.default.createElement(
	                            'h3',
	                            { className: 'Your' },
	                            'Prescriptions '
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Lorem Ipsum is simply dummy text of the printing and typesetting. '
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'dash-text sspp icon-and-text' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-2 img-sp' },
	                          _react2.default.createElement('img', { src: _round2.default, alt: 'round-' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-10' },
	                          _react2.default.createElement(
	                            'h3',
	                            { className: 'Your' },
	                            'Connect Your Apple Watch '
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Lorem Ipsum is simply dummy text of the printing and typesetting. '
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-3' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'dash-text sspp update-profile Alergies' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'mb-3' },
	                        'Your Profile '
	                      ),
	                      _react2.default.createElement('hr', null),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Update Profile'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Conditions & Alergies '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Upload Reports '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Gift A Friend or Family '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'dash-text sspp family-members mt-4' },
	                      _react2.default.createElement('input', { type: 'file' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-3 img-sp text-center' },
	                          _react2.default.createElement('i', { className: 'fa-solid fa-plus' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-9' },
	                          _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Add Family Members'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dash-text sspp' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Patient Overview '
	                  ),
	                  _react2.default.createElement('hr', { className: 'overview' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-4 shadab-boarder' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'mb-3' },
	                        'Profile '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Name: ',
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          this.state.patient_name
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Age:',
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          ' ',
	                          this.state.patient_age,
	                          ' '
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Gender: ',
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          this.state.patient_gender
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Phone No:',
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          this.state.patient_phone,
	                          ' '
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row mt-4 shadab-boarder-top-left' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-6' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              'Known Conditions'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Asthma'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-6' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              ' Known Allergies '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Peanuts'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-8 pb-3a' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'Your' },
	                        'Past Consultations'
	                      ),
	                      _react2.default.createElement(
	                        'table',
	                        { className: 'table table-part', id: 'table-apppin' },
	                        _react2.default.createElement(
	                          'tbody',
	                          null,
	                          this.state.latest_consultant.length > 0 ? this.state.latest_consultant.map(function (latest_consultant_data) {
	                            return _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                latest_consultant_data.date,
	                                ' ',
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  'Consultation'
	                                ),
	                                ' with ',
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  latest_consultant_data.doctor_detail.name
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                _react2.default.createElement('i', { className: 'fa-regular fa-star' }),
	                                _react2.default.createElement('i', { className: 'fa-regular fa-star' }),
	                                _react2.default.createElement('i', { className: 'fa-regular fa-star' }),
	                                _react2.default.createElement('i', { className: 'fa-regular fa-star' }),
	                                _react2.default.createElement('i', { className: 'fa-regular fa-star' })
	                              )
	                            );
	                          }) : _react2.default.createElement(
	                            'p',
	                            null,
	                            'No Any Latest Consultations'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dash-text sspp mt-4' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5' },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Recommended Check Ups'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-7 months-text' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Recommended in 4 months. Last one was 1 year ago'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement('hr', null),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-12 icon-7' },
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'news-slider', className: 'owl-carousel' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'post-slide' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('img', { src: _icon2.default, alt: 'icon-2' })
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'General Health'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'post-slide' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('img', { src: _cardiac2.default, alt: 'cardiac' })
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Cardiac'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'post-slide' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('img', { src: _icon4.default, alt: 'icon-3' })
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Orthopedics'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'post-slide' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('img', { src: _icon6.default, alt: 'icon-4' })
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Oncology'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'post-slide' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('img', { src: _icon8.default, alt: 'icon-5' })
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Materity'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'post-slide' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('img', { src: _icon10.default, alt: 'icon-6' })
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Hepatology'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'post-slide' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('img', { src: _cardiac2.default, alt: 'cardiac.svg' })
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Cardiac'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'post-slide' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('img', { src: _icon6.default, alt: 'icon-4' })
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Oncology'
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row mt-5' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-4' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'doctor-list' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-5' },
	                            _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-2' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-7' },
	                            _react2.default.createElement(
	                              'h4',
	                              null,
	                              'Pregnancy Package 1'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'mt-3 mb-4' },
	                              'BDT 9,800.00'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                'More Information'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-4' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'doctor-list' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-5' },
	                            _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-2' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-7' },
	                            _react2.default.createElement(
	                              'h4',
	                              null,
	                              'Pregnancy Package 1'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'mt-3 mb-4' },
	                              'BDT 9,800.00'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                'More Information'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-4' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'doctor-list' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-5' },
	                            _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-2' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-7' },
	                            _react2.default.createElement(
	                              'h4',
	                              null,
	                              'Pregnancy Package 1'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'mt-3 mb-4' },
	                              'BDT 9,800.00'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                'More Information'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dash-text sspp icon-and-text mt-5 boarder-r' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-lg-6 col-sm-12 step-away' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Expert Help is a step Away'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'input-group navi-input mb-3' },
	                        _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Search for physicans & departments', 'aria-label': 'Recipient\'s username', 'aria-describedby': 'basic-addon2' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'input-group-text', id: 'basic-addon2' },
	                          _react2.default.createElement('img', { src: _searchIcon2.default, alt: 'search-icon' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-lg-6 col-sm-12 ' },
	                      _react2.default.createElement('img', { src: _hospital2.default, alt: 'hospital' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dash-text sspp icon-and-text' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-lg-10 col-sm-7 step-away' },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Your Stats'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-lg-2 col-sm-5' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'dropdown' },
	                        _react2.default.createElement(
	                          'button',
	                          { className: 'btn btn-secondary dropdown-toggle make-btn w-100', type: 'button', id: 'dropdownMenuButton1', 'data-bs-toggle': 'dropdown', 'aria-expanded': 'false' },
	                          'BPM ',
	                          _react2.default.createElement('i', { className: 'fa-solid fa-chevron-down' })
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'dropdown-menu', 'aria-labelledby': 'dropdownMenuButton1' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'dropdown-item', href: '#' },
	                              'As a Doctor (ID Required) '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'dropdown-item', href: '#' },
	                              ' As A Friend / Family'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-6' },
	                      _react2.default.createElement('img', { src: _graf2.default, alt: 'graf2' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-6' },
	                      _react2.default.createElement('img', { src: _graf4.default, alt: 'graf3' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Appointments;
	}(_react.Component);
	
	exports.default = Appointments;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _doctor = __webpack_require__(176);
	
	var _doctor2 = _interopRequireDefault(_doctor);
	
	var _logo = __webpack_require__(135);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {API_TOKEN_NAME} from '../../constants';
	//import { scAxios } from '../../';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	//import { Outlet,Link } from "react-router-dom";
	
	
	var WhiteLeftSidebar = function (_Component) {
	  _inherits(WhiteLeftSidebar, _Component);
	
	  function WhiteLeftSidebar() {
	    _classCallCheck(this, WhiteLeftSidebar);
	
	    return _possibleConstructorReturn(this, (WhiteLeftSidebar.__proto__ || Object.getPrototypeOf(WhiteLeftSidebar)).apply(this, arguments));
	  }
	
	  _createClass(WhiteLeftSidebar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'dash-menu' },
	        _react2.default.createElement(
	          'div',
	          { className: 'left-dash' },
	          _react2.default.createElement(
	            'div',
	            { className: 'text-center' },
	            _react2.default.createElement('img', { src: _logo2.default, alt: 'logo2' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'doctor-part-img' },
	            _react2.default.createElement('img', { src: _doctor2.default, alt: 'doctor' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-3' },
	              'Patient ID: 1000411313'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-5' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Age: 45'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Gender: M'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'left-menu' },
	            _react2.default.createElement(
	              'li',
	              { className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '/' },
	                _react2.default.createElement('i', { className: 'fa-solid fa-house' }),
	                ' Home'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/dashbaord/appoinments' },
	                'Appointments'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '#' },
	                'Lab Reports'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '#' },
	                'Prescriptions'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '#' },
	                'Packages'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '#' },
	                'Care Plans'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '#' },
	                'Invoices'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '#' },
	                'Library'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return WhiteLeftSidebar;
	}(_react.Component);
	
	exports.default = WhiteLeftSidebar;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AmbulanceGallery = function AmbulanceGallery() {
	  var images = ["/assets/images/ambulance_1.jpg", "/assets/images/ambulance_2.jpg"];
	  return _react2.default.createElement(
	    "div",
	    { className: "my-5 shadow bg-body rounded p-4" },
	    _react2.default.createElement(
	      "h4",
	      { className: "text-start" },
	      "Ambulance"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "row" },
	      images.map(function (item, index) {
	        return _react2.default.createElement(
	          "div",
	          { className: "col-md-4 col-sm-6 mb-3" },
	          _react2.default.createElement("img", { src: item, alt: "Image 7", className: "img-fluid" })
	        );
	      })
	    )
	  );
	};
	
	exports.default = AmbulanceGallery;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AmbulanceService = function AmbulanceService() {
	  return _react2.default.createElement(
	    "div",
	    { className: "d-flex flex-column align-items-start my-5 shadow bg-body rounded p-4" },
	    _react2.default.createElement(
	      "h4",
	      { className: "text-start" },
	      "Ambulance Service"
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "text-start" },
	      "The Cardiac Ambulance is always accompanied by:",
	      _react2.default.createElement("br", null),
	      "Specialist, Nurse, PCA",
	      _react2.default.createElement("br", null),
	      "The Normal Ambulance is always accompanied by:",
	      _react2.default.createElement("br", null),
	      "Nurse, PCA",
	      _react2.default.createElement("br", null),
	      "For any emergency need, please call: ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "strong",
	        null,
	        "01914001234"
	      ),
	      " or ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "01914001232"
	      )
	    )
	  );
	};
	
	exports.default = AmbulanceService;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MyProvider = __webpack_require__(48);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookTestPopUp = function BookTestPopUp() {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      loading = _useState2[0],
	      setLoading = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    phoneNuber: ""
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      formData = _useState4[0],
	      setFormData = _useState4[1];
	
	  var _useContext = (0, _react.useContext)(_MyProvider.MyContext),
	      cart = _useContext.cart,
	      totalAmount = _useContext.totalAmount,
	      removeFromCart = _useContext.removeFromCart;
	
	  var handleSubmit = function handleSubmit(event, props) {
	    event.preventDefault();
	
	    var postData = {
	      type: "investigation_request",
	      additional: cart,
	      user_id: localStorage.getItem(_constants.USER_LOCAL_ID),
	      currency: "BDT",
	      amount: totalAmount,
	      customer_data: { phone_number: formData.phoneNuber },
	      payment_type: "booking",
	      status: 1
	    };
	    setLoading(true);
	    try {
	      var response = _.scAxiosAdmin.post("/ledger", postData, {
	        method: "post",
	        headers: {
	          Accept: "application/json",
	          "Content-Type": "application/json"
	        }
	      }).then(function (response) {
	        console.log("some data", response);
	        if (response.status === 201) {
	          _reactToastify.toast.success("Your Test Request Booked Successfully!");
	          removeFromCart();
	          setLoading(false);
	        }
	      });
	    } catch (error) {
	      console.error("Error fetching data:", error);
	      setLoading(false);
	    }
	  };
	  var inputStyles = {
	    borderRadius: "10px",
	    background: "#fff",
	    borderRight: "solid 1px #fff",
	    border: "solid 2px #6e6e6ed0",
	    padding: "15px 15px",
	    fontSize: "16px",
	    color: "#000",
	    width: "100%"
	  };
	  return _react2.default.createElement(
	    "div",
	    {
	      "class": "offcanvas offcanvas-end",
	      tabindex: "-1",
	      id: "bookTestOffcanvasRight",
	      "aria-labelledby": "bookTestOffcanvasRightLabel",
	      style: { minWidth: "30%", zIndex: 99999999999999999 }
	    },
	    _react2.default.createElement(
	      "div",
	      {
	        "class": "offcanvas-header",
	        style: { paddingRight: "2rem", paddingLeft: "2rem" }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "", style: { paddingTop: "5rem" } },
	        _react2.default.createElement(
	          "h4",
	          { style: { color: "#187979" } },
	          "Confirm Your Booking!"
	        )
	      ),
	      _react2.default.createElement("button", {
	        type: "button",
	        "class": "btn-close text-reset",
	        "data-bs-dismiss": "offcanvas",
	        "aria-label": "Close"
	      })
	    ),
	    _react2.default.createElement(
	      "div",
	      { "class": "offcanvas-body" },
	      _react2.default.createElement(
	        "div",
	        { className: "left-offcanvas" },
	        _react2.default.createElement(
	          "h4",
	          { style: { color: "#187979" } },
	          "Enter your phone Number here."
	        ),
	        _react2.default.createElement(
	          "form",
	          {
	            onSubmit: handleSubmit,
	            id: "registerform",
	            className: "needs-validation",
	            noValidate: true
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "label",
	              null,
	              "Phone Number"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mt-2" },
	              _react2.default.createElement("input", {
	                style: inputStyles,
	                type: "number",
	                className: "custom-form-control",
	                placeholder: "Enter your phone number",
	                name: "phoneNumber",
	                id: "phoneNumber",
	                value: formData.phoneNuber,
	                onChange: function onChange(e) {
	                  return setFormData(Object.assign({}, formData, { phoneNuber: e.target.value }));
	                },
	                required: true,
	                autoComplete: "off"
	                // style={input_field_css}
	              })
	            ),
	            _react2.default.createElement("span", null)
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row", style: { padding: "15px" } },
	            _react2.default.createElement(
	              "button",
	              {
	                style: {
	                  padding: "5px",
	                  borderRadius: "5px",
	                  backgroundColor: !formData.phoneNuber ? "gray" : "rgb(24, 121, 121)"
	                },
	                disabled: !formData.phoneNuber ? true : false,
	                type: "submit",
	                className: "text-white d-flex justify-content-center align-items-center gap-4"
	                // className={`${
	                //   !formData.phoneNuber ? "text-black" : "text-white"
	                // }`}
	              },
	              loading && _react2.default.createElement(
	                "div",
	                { "class": "spinner-border", role: "status" },
	                _react2.default.createElement(
	                  "span",
	                  { "class": "visually-hidden" },
	                  "Loading..."
	                )
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "Submit"
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = BookTestPopUp;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToastify = __webpack_require__(7);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	__webpack_require__(8);
	
	var _userSession = __webpack_require__(30);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _Loading_icon = __webpack_require__(56);
	
	var _Loading_icon2 = _interopRequireDefault(_Loading_icon);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmAppointmentAndRequestAppointmentParticularDoctor = function ConfirmAppointmentAndRequestAppointmentParticularDoctor(_ref) {
	  var scheduleReqData = _ref.scheduleReqData;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      loading = _useState2[0],
	      setLoading = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      appointmentLoading = _useState4[0],
	      setAppointmentLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      newDate = _useState6[0],
	      setNewDate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      slot = _useState8[0],
	      setSlot = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      selectedDoctorData = _useState10[0],
	      setSelectedDoctorData = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(),
	      _useState12 = _slicedToArray(_useState11, 2),
	      bookingResponse = _useState12[0],
	      setBookingResponse = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(),
	      _useState14 = _slicedToArray(_useState13, 2),
	      bookingRequestResponse = _useState14[0],
	      setBookingRequestResponse = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(true),
	      _useState16 = _slicedToArray(_useState15, 2),
	      disabled = _useState16[0],
	      setDisabled = _useState16[1];
	
	  (0, _react.useEffect)(function () {}, []);
	
	  var doctorData = scheduleReqData && scheduleReqData.doctorData;
	  var dateName = null;
	  var showDate = null;
	
	  if (newDate) {
	    dateName = new Date(newDate).toLocaleDateString("en-US", {
	      weekday: "long"
	    });
	    showDate = (0, _moment2.default)(newDate).format("LL");
	  } else {
	    dateName = new Date(scheduleReqData.PreferredDate).toLocaleDateString("en-US", { weekday: "long" });
	    showDate = (0, _moment2.default)(scheduleReqData.PreferredDate).format("LL");
	  }
	
	  var schedules = null;
	  if (doctorData && doctorData.Schedule !== null) {
	    var schedulesObject = doctorData.Schedule[0];
	
	    if (dateName) {
	      schedules = schedulesObject[dateName];
	    }
	  }
	
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	  };
	  var handleScheduleAppointment = function handleScheduleAppointment(type) {
	    var scheduleAppointmentPostData = {
	      type: "book_appointment",
	      doctor_id: scheduleReqData.DoctorID,
	      user_patient_id: localStorage.getItem(_constants.USER_LOCAL_ID),
	      appointment_date: scheduleReqData.PreferredDate,
	      appointment_time: slot,
	      patient_phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER),
	      amount: 1500.0,
	      doctor_name: scheduleReqData.doctorData.doctor_name,
	      patient_name: localStorage.getItem(_constants.PATIENT_NAME),
	      doctor_fees: 1500.5
	    };
	    var reqAppointmentPostData = {
	      type: "request_appointment",
	      doctor_id: scheduleReqData.DoctorID,
	      user_patient_id: localStorage.getItem(_constants.USER_LOCAL_ID),
	      appointment_date: scheduleReqData.PreferredDate,
	      patient_phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER),
	      amount: 1500.0,
	      doctor_name: scheduleReqData.doctorData.doctor_name,
	      patient_name: localStorage.getItem(_constants.PATIENT_NAME),
	      doctor_fees: 1500.5
	    };
	    if (type === "schedule_appointment") {
	      try {
	        setAppointmentLoading(true);
	        var req = _.scAxiosAdmin.post("/appointments/request_new", scheduleAppointmentPostData, {
	          method: "post",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 201) {
	            _reactToastify.toast.success("Your request for an appointment is received. We will confirm shortly!!");
	            setBookingResponse(data.data.data);
	            setAppointmentLoading(false);
	          }
	        }).catch(function (e) {
	          _reactToastify.toast.error("Something went wrong!");
	          setAppointmentLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {
	        _reactToastify.toast.error("Something went wrong!");
	        setAppointmentLoading(false);
	      }
	    }
	    if (type === "request_appointment") {
	      try {
	        setAppointmentLoading(true);
	        var _req = _.scAxiosAdmin.post("/appointments/request_new", reqAppointmentPostData, {
	          method: "post",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 201) {
	            _reactToastify.toast.success("Your request for an appointment is received. We will confirm shortly!!");
	            setBookingRequestResponse(data.data.data);
	            setAppointmentLoading(false);
	          }
	        }).catch(function (e) {
	          _reactToastify.toast.error("Something went wrong!");
	          setAppointmentLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {
	        _reactToastify.toast.error("Something went wrong!");
	        setAppointmentLoading(false);
	      }
	    }
	  };
	
	  //
	  //   useEffect(() => {
	  //     const getSingleDoctor = (data) => {
	  //       try {
	  //         setLoading(true);
	  //         const req = scAxiosAdmin
	  //           .request(`/doctors/getsingledoctors/${scheduleReqData.DoctorID}`, {
	  //             method: "get",
	  //             headers: {
	  //               Accept: "application/json",
	  //               Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	  //             },
	  //           })
	  //           .then((data) => {
	  //             if (data.status === 200) {
	  //               setDoctorData(data.data.data);
	  //               setLoading(false);
	  //             }
	  //           })
	  //           .catch((e) => {
	  //             setLoading(false);
	  //             console.log("your log output", e);
	  //           });
	  //       } catch (error) {
	  //         setLoading(false);
	  //       }
	  //     };
	  //     getSingleDoctor();
	  //   }, [scheduleReqData.DoctorID]);
	  return _react2.default.createElement(
	    "div",
	    {
	      className: "offcanvas offcanvas-start",
	      tabIndex: -1,
	      id: "confirmAppointmentOffcanvasParticularDoctor",
	      "aria-labelledby": "offcanvasExampleLabel"
	      // style={{ visibility: "visible" }}
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "offcanvas-header" },
	      _react2.default.createElement(
	        "h5",
	        { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	        " "
	      ),
	      _react2.default.createElement("button", {
	        type: "button",
	        className: "btn-close text-reset",
	        "data-bs-dismiss": "offcanvas",
	        "aria-label": "Close",
	        onClick: function onClick() {
	          setNewDate(""), setSlot(null);
	          schedules = null;
	          location.reload();
	        }
	      })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "offcanvas-body" },
	      _react2.default.createElement(
	        "div",
	        { className: "left-offcanvas" },
	        _react2.default.createElement(
	          "h4",
	          { style: { color: "#187979" } },
	          "Book Appointment"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "goback" },
	          _react2.default.createElement(
	            "button",
	            {
	              variant: "primary"
	              // data-bs-toggle="offcanvas"
	              // data-bs-target="#BookAppointMentParticularDoctorPopUp"
	              // aria-controls="BookAppointMentParticularDoctorPopUp"
	              , onClick: function onClick() {
	                setNewDate(""), setSlot(null);
	                location.reload();
	              },
	              style: { background: "none", border: "none" }
	            },
	            _react2.default.createElement("i", { className: "fa-solid fa-circle-left" }),
	            " Go Back & Reselect your Doctor"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "sd-container" },
	          _react2.default.createElement(
	            "h6",
	            { className: "timer" },
	            showDate,
	            _react2.default.createElement("input", {
	              type: "date",
	              className: "change_schedule_date",
	              name: "change_schedule_date",
	              id: "change_schedule_date",
	              value: newDate,
	              onChange: function onChange(e) {
	                return setNewDate(e.target.value);
	              }
	              // min={newcurrentdate}
	            }),
	            _react2.default.createElement("i", { className: "moz-cover-clear" }),
	            _react2.default.createElement(
	              "span",
	              { className: "open-button" },
	              _react2.default.createElement(
	                "button",
	                { type: "button" },
	                "\uD83D\uDCC5"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "form",
	          { onSubmit: handleSubmit, className: "needs-validation", noValidate: true },
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 sp-0-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "doctor-list Dr-Reazur" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "row",
	                    onClick: function onClick() {
	                      return setSelectedDoctorData(doctorData);
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-4 sp-0-1 left-0" },
	                    doctorData ? _react2.default.createElement("img", {
	                      src: _constants.IMAGE_URL + "/DoctorProfileImg/" + doctorData.doctor_profile,
	                      alt: "doctor profile"
	                    }) : _react2.default.createElement("img", {
	                      src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                      alt: "doc"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-8", id: "dr" },
	                    _react2.default.createElement(
	                      "h5",
	                      null,
	                      doctorData.doctor_name
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      doctorData.doctor_degree !== "" ? doctorData.doctor_degree : ""
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "mt-2" },
	                      doctorData.doctor_fees !== "" ? _react2.default.createElement(
	                        "strong",
	                        { style: { color: "#fb6201" } },
	                        "BDT ",
	                        doctorData.doctor_fees
	                      ) : _react2.default.createElement("strong", null)
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-4", id: "time-date" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              schedules !== null && schedules !== undefined ? schedules.split(",").map(function (schedule_time) {
	                return _react2.default.createElement(
	                  "div",
	                  {
	                    className: "doctor_schedule_section",
	                    key: schedule_time,
	                    style: { marginBottom: '5px' }
	                  },
	                  _react2.default.createElement("input", {
	                    type: "radio",
	                    className: "schedule_time",
	                    id: "schedule_date_time",
	                    name: "schedule_date_time",
	                    defaultValue: schedule_time,
	                    value: schedule_time,
	                    onChange: function onChange(e) {
	                      if (slot !== e.target.value) {
	                        // Only set the slot if it's not already selected
	                        setSlot(e.target.value);
	                      }
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "btn-links color-check text-center" },
	                    schedule_time,
	                    " ",
	                    showDate
	                  )
	                );
	              }) : _react2.default.createElement(
	                "p",
	                null,
	                "No slots available!"
	              ),
	              appointmentLoading ? _react2.default.createElement("img", { src: _Loading_icon2.default, alt: "Loading" }) : ""
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              schedules !== null && schedules !== undefined ? _react2.default.createElement(
	                "button",
	                {
	                  variant: "primary",
	                  type: "submit",
	                  className: "btn-links appointment-new",
	                  id: "Schedule",
	                  onClick: function onClick() {
	                    return handleScheduleAppointment("schedule_appointment");
	                  },
	                  style: {
	                    backgroundColor: slot ? "rgb(246, 130, 31)" : ""
	                  }
	                },
	                "Schedule Appointment"
	              ) : _react2.default.createElement(
	                "button",
	                {
	                  variant: "primary",
	                  type: "submit",
	                  className: "btn-links appointment-new",
	                  id: "Schedule",
	                  onClick: function onClick() {
	                    return handleScheduleAppointment("request_appointment");
	                  }
	                },
	                "Request Appointment"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = ConfirmAppointmentAndRequestAppointmentParticularDoctor;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// You can create a CSS file for custom styling if needed
	
	var GalleryForEmergency = function GalleryForEmergency() {
	  var images = ["/assets/images/admin_1.jpg", "/assets/images/admin_2.jpg", "/assets/images/admin_3.jpg", "/assets/images/admin_4.jpg", "/assets/images/admin_5.jpg", "/assets/images/admin_6.jpg", "/assets/images/admin_7.jpg", "/assets/images/admin_8.jpg", "/assets/images/admin_9.jpg", "/assets/images/admin_10.jpg", "/assets/images/admin_11.jpg", "/assets/images/admin_12.jpg"];
	  return _react2.default.createElement(
	    "div",
	    { className: "my-5 shadow bg-body rounded p-4" },
	    _react2.default.createElement(
	      "h4",
	      { className: "text-start" },
	      "EMERGENCY MEDICINE"
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "text-start mb-4" },
	      "The Emergency Medicine Department of United Hospital is a 24-hour, full time section and it is the mirror of United Hospital. It offers the highest degree of commitment to delivering quality and efficient emergency care. Prompt and rapid response of our skilled medical personnel defines our Emergency Medicine Unit. This is where very critically ill and injured patients are received and managed."
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "row" },
	      images.map(function (items, index) {
	        return _react2.default.createElement(
	          "div",
	          { className: "col-md-3 col-sm-6 mb-3" },
	          _react2.default.createElement("img", { src: items, alt: "Image 1", className: "img-fluid" })
	        );
	      })
	    )
	  );
	};
	
	exports.default = GalleryForEmergency;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _PopupIndex = __webpack_require__(65);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _PopupPatientId = __webpack_require__(210);
	
	var _PopupPatientId2 = _interopRequireDefault(_PopupPatientId);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var RegisterData = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data, id) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt("return", new Promise(function (resolve, reject) {
	              //const token = Buffer.from(`${API_AUTH_USERNAME}:${API_AUTH_PASSWORD}`, 'utf8').toString('base64');
	              var req = _.scAxiosAdmin.request("/user/update_patient/" + id, {
	                method: "put",
	                data: data,
	                headers: {
	                  Accept: "application/json"
	                  //'Authorization': `Basic ${token}`,
	                }
	
	                /*auth: {
	                  username: 'OSL',
	                  password: 'osl@2022'
	                },*/
	                /* params: {
	                  ...data,
	                }, */
	              });
	              req.then(function (res) {
	                return resolve(res.data);
	              }).catch(function (err) {
	                return reject(err);
	              });
	            }));
	
	          case 1:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function RegisterData(_x, _x2) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var getOtpData = function getOtpData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/user/getotpdata", {
	      method: "get",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var ResetOtpData = function ResetOtpData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/user/resetotpdata", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var PopupOTP = function (_Component) {
	  _inherits(PopupOTP, _Component);
	
	  function PopupOTP() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopupOTP);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = PopupOTP.__proto__ || Object.getPrototypeOf(PopupOTP)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      id: "",
	      phone_number: "",
	      otp_number: "",
	      first_otp: "",
	      second_otp: "",
	      third_otp: "",
	      fourth_otp: "",
	      fifth_otp: "",
	      sixth_otp: "",
	      final_otp: "",
	      showLoginPopup: false,
	      showPatientIdPopup: false
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var first_otp = (0, _jquery2.default)(".first_otp").val();
	      var second_otp = (0, _jquery2.default)(".second_otp").val();
	      var third_otp = (0, _jquery2.default)(".third_otp").val();
	      var fourth_otp = (0, _jquery2.default)(".fourth_otp").val();
	      var fifth_otp = (0, _jquery2.default)(".fifth_otp").val();
	      var sixth_otp = (0, _jquery2.default)(".sixth_otp").val();
	      if (first_otp !== "" && second_otp !== "" && third_otp !== "" && fourth_otp !== "" && fifth_otp !== "" && sixth_otp !== "") {
	        var final_otp = first_otp + second_otp + third_otp + fourth_otp + fifth_otp + sixth_otp;
	        _this.setState({ final_otp: final_otp });
	        if (final_otp) {
	          _this.refreshGetOTPData();
	        } else {
	          (0, _jquery2.default)(".submit_btn").prop("disabled", true);
	          (0, _jquery2.default)(".submit_btn").css("background", "#41414b");
	        }
	      } else {
	        (0, _jquery2.default)(".submit_btn").prop("disabled", true);
	        (0, _jquery2.default)(".submit_btn").css("background", "#41414b");
	        (0, _jquery2.default)(".otp_error").text("");
	      }
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      var user = void 0;
	      if (_this.props.from === "from_link_id") {
	        user = {
	          status: "1",
	          patient_id: _this.props.userPatientId, //Uniquer User ID
	          isapproved: "1"
	        };
	      }
	      if (_this.props.from === "from_register") {
	        user = {
	          status: "1"
	        };
	      }
	
	      /* const user = {
	        Name: this.props.userData.Name,
	        DateOfBirth: this.props.userData.DateOfBirth,
	        PhoneNumber: this.props.userData.PhoneNumber,
	        Gender: this.props.userData.Gender,
	        Address: this.props.userData.Address,
	        FamilyMembers: this.props.userData.FamilyMembers,
	        HouseNo: this.props.userData.HouseNo,
	        Thana: this.props.userData.Thana,
	        District: this.props.userData.District,
	        UserId: this.props.userId,
	      }; */
	      var id = _this.props.userId;
	      RegisterData(user, id).then(function (res) {
	        _this.refreshResetOTPData();
	        _reactToastify.toast.success("User Registered SuccessFully!", {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	        if (_this.props.from === "from_link_id") {
	          localStorage.setItem(_constants.USER_ID, _this.props.userPatientId);
	        }
	        window.location.reload(true);
	        (0, _jquery2.default)(".otp_popup").css("visibility", "hidden");
	        (0, _jquery2.default)(".otp_popup").removeClass("show");
	        (0, _jquery2.default)(".otp_reg").css("visibility", "hidden");
	        (0, _jquery2.default)(".otp_reg").removeClass("show");
	        (0, _jquery2.default)(".patientRegister").css("visibility", "hidden");
	        (0, _jquery2.default)(".patientRegister").removeClass("show");
	        (0, _jquery2.default)(".login_popup").css("visibility", "visible");
	        (0, _jquery2.default)(".login_popup").addClass("show");
	        (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	        (0, _jquery2.default)("body").css("overflow", "");
	        (0, _jquery2.default)("body").css("padding-right", "");
	        _this.closePopup();
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshGetOTPData = function (event) {
	      var data = {
	        phone_number: _this.props.userData.PhoneNumber
	      };
	      getOtpData(data).then(function (res) {
	        if (res.status === true) {
	          _this.setState({ otp_number: res.data.otp });
	          if (_this.state.final_otp == res.data.otp || _this.state.final_otp == "111111") {
	            (0, _jquery2.default)(".submit_btn").prop("disabled", false);
	            (0, _jquery2.default)(".submit_btn").css("background", "#fb6201");
	          } else {
	            (0, _jquery2.default)(".submit_btn").prop("disabled", true);
	            (0, _jquery2.default)(".submit_btn").css("background", "#41414b");
	            (0, _jquery2.default)(".otp_error").text("Otp not match. please fill correct otp");
	          }
	        } else {
	          _reactToastify.toast.error("otp data not found", {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("Error occured", {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.refreshResetOTPData = function (event) {
	      var data = {
	        phone_number: _this.props.userData.PhoneNumber
	      };
	      ResetOtpData(data).then(function (res) {
	        if (res.status === true) {} else {}
	      }).catch(function (err) {
	        _reactToastify.toast.error("Error occured", {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.onKeyUpMoveInputfocus = function (event) {
	      if (event.target.value.length === event.target.maxLength) {
	        var $next = (0, _jquery2.default)(event.target).next(".otp_input");
	        if ($next.length) {
	          (0, _jquery2.default)(event.target).next(".otp_input").focus();
	        } else {
	          (0, _jquery2.default)(event.target).blur();
	        }
	      }
	    }, _this.closePopup = function (event) {
	      (0, _jquery2.default)(".otp_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".otp_popup").removeClass("show");
	      (0, _jquery2.default)(".login_popup").css("visibility", "visible");
	      (0, _jquery2.default)(".login_popup").addClass("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PopupOTP, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            className: "offcanvas offcanvas-start show otp_popup",
	            tabIndex: -1,
	            id: "offcanvasRegister",
	            "aria-labelledby": "offcanvasExampleLabel",
	            style: { visibility: "visible" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-header" },
	            _react2.default.createElement(
	              "h5",
	              { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	              " "
	            ),
	            _react2.default.createElement("button", {
	              type: "button",
	              className: "btn-close text-reset",
	              "data-bs-dismiss": "offcanvas",
	              "aria-label": "Close",
	              onClick: this.closePopup
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-body" },
	            _react2.default.createElement(
	              "div",
	              { className: "row text-center", id: "logos" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-2 " },
	                _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "left-offcanvas" },
	              _react2.default.createElement(
	                "h4",
	                null,
	                "Fill OTP"
	              ),
	              _react2.default.createElement(
	                "form",
	                {
	                  onSubmit: this.handleSubmit,
	                  id: "registerform",
	                  className: "needs-validation",
	                  noValidate: true
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "d-flex" },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    name: "first_otp",
	                    id: "first_otp",
	                    className: "fild-1 otp_input first_otp",
	                    placeholder: "-",
	                    value: this.state.first_otp,
	                    onChange: this.handleChange,
	                    onKeyUp: this.onKeyUpMoveInputfocus,
	                    maxLength: "1"
	                  }),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    name: "second_otp",
	                    id: "second_otp",
	                    className: "fild-1 otp_input second_otp",
	                    placeholder: "-",
	                    value: this.state.second_otp,
	                    onChange: this.handleChange,
	                    onKeyUp: this.onKeyUpMoveInputfocus,
	                    maxLength: "1"
	                  }),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    name: "third_otp",
	                    id: "third_otp",
	                    className: "fild-1 otp_input third_otp",
	                    placeholder: "-",
	                    value: this.state.third_otp,
	                    onChange: this.handleChange,
	                    onKeyUp: this.onKeyUpMoveInputfocus,
	                    maxLength: "1"
	                  }),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    name: "fourth_otp",
	                    id: "fourth_otp",
	                    className: "fild-1 otp_input fourth_otp",
	                    placeholder: "-",
	                    value: this.state.fourth_otp,
	                    onChange: this.handleChange,
	                    onKeyUp: this.onKeyUpMoveInputfocus,
	                    maxLength: "1"
	                  }),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    name: "fifth_otp",
	                    id: "fifth_otp",
	                    className: "fild-1 otp_input fifth_otp",
	                    placeholder: "-",
	                    value: this.state.fifth_otp,
	                    onChange: this.handleChange,
	                    onKeyUp: this.onKeyUpMoveInputfocus,
	                    maxLength: "1"
	                  }),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    name: "sixth_otp",
	                    id: "sixth_otp",
	                    className: "fild-1 otp_input sixth_otp",
	                    placeholder: "-",
	                    value: this.state.sixth_otp,
	                    onChange: this.handleChange,
	                    onKeyUp: this.onKeyUpMoveInputfocus,
	                    maxLength: "1"
	                  })
	                ),
	                _react2.default.createElement("p", {
	                  className: "otp_error",
	                  style: { fontSize: "14px", color: "#ff0000" }
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        variant: "primary",
	                        type: "submit",
	                        className: "btn-links appointment-new submit_btn",
	                        id: "black-btn",
	                        disabled: true
	                      },
	                      " ",
	                      "Submit",
	                      " "
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return PopupOTP;
	}(_react.Component);
	
	exports.default = PopupOTP;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _userSession = __webpack_require__(30);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _HomeHeader = __webpack_require__(112);
	
	var _HomeHeader2 = _interopRequireDefault(_HomeHeader);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _HomeSearch = __webpack_require__(86);
	
	var _HomeSearch2 = _interopRequireDefault(_HomeSearch);
	
	var _CenterExcellence = __webpack_require__(85);
	
	var _CenterExcellence2 = _interopRequireDefault(_CenterExcellence);
	
	var _NewsEventsSilde = __webpack_require__(71);
	
	var _NewsEventsSilde2 = _interopRequireDefault(_NewsEventsSilde);
	
	var _PublicationsSilde = __webpack_require__(72);
	
	var _PublicationsSilde2 = _interopRequireDefault(_PublicationsSilde);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _PopupIndex = __webpack_require__(65);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _HeaderHome = __webpack_require__(111);
	
	var _HeaderHome2 = _interopRequireDefault(_HeaderHome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPatientdata = function getPatientdata(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/patients', {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var UpdatePatientdata = function UpdatePatientdata(data) {
	  return new Promise(function (resolve, reject) {
	    //const token = Buffer.from(`${API_AUTH_USERNAME}:${API_AUTH_PASSWORD}`, 'utf8').toString('base64');
	    var req = _.scAxiosAdmin.request('/user/updatepatientid', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json'
	        //'Authorization': `Basic ${token}`,
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var PopupPatientId = function (_Component) {
	  _inherits(PopupPatientId, _Component);
	
	  function PopupPatientId() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopupPatientId);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupPatientId.__proto__ || Object.getPrototypeOf(PopupPatientId)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      patient_id: '',
	      user_id: '',
	      showLoginPopup: false
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      var data = {
	        patient: _this.state.patient_id
	      };
	      getPatientdata(data).then(function (res) {
	        if (res[0]['patient_ID']) {
	          var _data = {
	            userid: _this.state.user_id,
	            patient_id: _this.state.patient_id
	          };
	          _this.updatePatientId(_data);
	        } else {
	          _reactToastify.toast.error('Your Patient Id Invalid. Please Enter Valid Patient Id.', {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.updatePatientId = function (data) {
	      UpdatePatientdata(data).then(function (res) {
	        if (res.status == true) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	          setTimeout(function () {
	            window.location.href = '/?update_success=success';
	            //this.setState({showLoginPopup: true});
	          }, 3000);
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.closePopup = function (event) {
	      (0, _jquery2.default)(".popup_patient_id").css("visibility", 'hidden');
	      (0, _jquery2.default)(".popup_patient_id").removeClass('show');
	      (0, _jquery2.default)(".login_popup").css("visibility", 'visible');
	      (0, _jquery2.default)(".login_popup").addClass('show');
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PopupPatientId, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var search = window.location.search;
	      var params = new URLSearchParams(search);
	      var userid = params.get('userid');
	      this.setState({ user_id: userid });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'section',
	          { className: 'banner-part' },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _HeaderHome2.default }),
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'offcanvas offcanvas-start show popup_patient_id', tabIndex: -1, id: 'offcanvasExample', 'aria-labelledby': 'offcanvasExampleLabel' },
	              _react2.default.createElement(
	                'div',
	                { className: 'offcanvas-header' },
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'offcanvas-title', id: 'offcanvasExampleLabel' },
	                  ' '
	                ),
	                _react2.default.createElement('button', { type: 'button', className: 'btn-close text-reset', 'data-bs-dismiss': 'offcanvas', 'aria-label': 'Close' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'offcanvas-body' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row text-center', id: 'logos' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2 ' },
	                    _react2.default.createElement('img', { src: _uhlcareLogo2.default, alt: 'uhlcare-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _mainLogo2.default, alt: 'medix-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _UHL2.default, alt: 'uhl-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _medixLogo2.default, alt: 'medix-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _maRashedHospital2.default, alt: 'medix-logo' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'left-offcanvas' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Instructions'
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      'Please check your email address for a Temporary Patient I.D.'
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      'Please present your Temporary Patient I.D. at UHL Premises'
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      'You will be presented with your permanent Patient I.D'
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      'Enter Permanent Patient I.D below to avail online services.'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'mt-3' },
	                    'Update Patient Id'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'payment mt-5' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: this.handleSubmit, id: 'loginform', className: 'needs-validation', noValidate: true },
	                      _react2.default.createElement('input', { placeholder: 'Enter Patient I.D', type: 'text', id: 'patient_id', name: 'patient_id', value: this.state.patient_id, onChange: this.handleChange, autoComplete: 'off', className: 'form-control', required: true }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row mt-3' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-12' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn-links appointment-new', id: 'black-btn' },
	                            ' Update Patient Id '
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_HomeSearch2.default, null)
	          )
	        ),
	        _react2.default.createElement(_CenterExcellence2.default, null),
	        _react2.default.createElement(_NewsEventsSilde2.default, null),
	        _react2.default.createElement(_PublicationsSilde2.default, null),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	        this.state.showLoginPopup ? _react2.default.createElement(_PopupIndex2.default, { showPopup: this.state.showLoginPopup }) : null,
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return PopupPatientId;
	}(_react.Component);
	
	exports.default = PopupPatientId;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jci = __webpack_require__(179);
	
	var _jci2 = _interopRequireDefault(_jci);
	
	var _caseStudy = __webpack_require__(1163);
	
	var _caseStudy2 = _interopRequireDefault(_caseStudy);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var CaseStudy = function CaseStudy() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchdata = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    fetchData(); // Initial data fetch
	  }, []);
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/settings/1");
	
	            case 3:
	              response = _context.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                setFatchdata(response.data);
	                // setLoading(false);
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "section",
	      {
	        style: { backgroundColor: "#F7F5EF", paddingBottom: "4rem" },
	        className: "news-events pb-5 " + (_reactDeviceDetect.isMobile ? "pt-0" : ""),
	        id: "hr-lines"
	      },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "container jci",
	          style: {
	            backgroundImage: "url(" + _caseStudy2.default + ")",
	            backgroundSize: "cover",
	            backgroundRepeat: "no-repeat",
	            backgroundPosition: "center",
	            width: "100%",
	            borderRadius: "10px",
	            opacity: 0.9,
	            height: _reactDeviceDetect.isMobile ? "265px" : "450px"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "d-flex flex-column justify-content-around align-items-center",
	            style: { height: "100%" }
	          },
	          _react2.default.createElement(
	            "h3",
	            {
	              className: "text-left ",
	              style: {
	                color: "#AF9763",
	                fontSize: _reactDeviceDetect.isMobile ? "18px" : "28px",
	                fontWeight: "500",
	                display: "flex",
	                flexDirection: "column"
	                // marginTop: "3rem",
	              }
	            },
	            "Case Study"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              className: "text-light",
	              href: "/pages/case-study",
	              style: { textDecoration: "none" }
	            },
	            _react2.default.createElement(
	              "button",
	              {
	                style: {
	                  fontSize: "16px",
	                  width: "118px",
	                  height: "43px",
	                  backgroundColor: "#F58220",
	                  color: "#fff",
	                  textTransform: "capitalize",
	                  border: "none",
	                  borderRadius: "6px",
	                  fontWeight: 500
	                  // marginBottom: "3rem",
	                }
	              },
	              "View details"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = CaseStudy;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	__webpack_require__(8);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _SubPopupIndex = __webpack_require__(114);
	
	var _SubPopupIndex2 = _interopRequireDefault(_SubPopupIndex);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _icon = __webpack_require__(57);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _BookAppointmentPopup = __webpack_require__(60);
	
	var _BookAppointmentPopup2 = _interopRequireDefault(_BookAppointmentPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDoctorsbyDept = function getDoctorsbyDept(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/getdoctorsbydepartment/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSideBarVideoLInk = function getSideBarVideoLInk(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/settings/30", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var getSingleDoctorData = function getSingleDoctorData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getsingledepartment/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var getAllDepartments = function getAllDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var SingleDepartmentView = function (_Component) {
	  _inherits(SingleDepartmentView, _Component);
	
	  function SingleDepartmentView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SingleDepartmentView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SingleDepartmentView.__proto__ || Object.getPrototypeOf(SingleDepartmentView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      department_name: "",
	      videoLInk: "",
	      packages: [],
	      investigations: [],
	      status_list: "",
	      image: "",
	      banner_image: "",
	      departments: [],
	      showDoctorSearchPopup: false,
	      doctors: [],
	      descriptions: []
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var doctor_avability_time = (0, _jquery2.default)("input[name='doctor_avability_time']:checked").val();
	      if (doctor_avability_time) {
	        (0, _jquery2.default)(".doctor_search_list_popup").css("visibility", "visible");
	        (0, _jquery2.default)(".doctor_search_list_popup").addClass("show");
	        _this.setState({
	          showDoctorSearchPopup: true
	        });
	      }
	    }, _this.refreshDepartments = function (event) {
	      getAllDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshSideBarVideoLink = function (event) {
	      getSideBarVideoLInk().then(function (res) {
	        if (res.status === 200) {
	          var records = res.data.value;
	          _this.setState({ videoLInk: records });
	        } else {
	          _this.setState({ videoLInk: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshGetDoctorData = function (id) {
	      getSingleDoctorData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	
	          _this.setState({
	            department_name: records.department_name,
	            doctors: records.doctors_mave,
	            packages: records.packages_mave,
	            investigations: records.investigations_mave,
	            // department_desc_one: records.department_desc_one,
	            // department_desc_two: records.department_desc_two,
	            // department_desc_three: records.department_desc_three,
	            // department_desc_four: records.department_desc_four,
	            // department_desc_five: records.department_desc_five,
	            // department_desc_six: records.department_desc_six,
	            // department_desc_seven: records.department_desc_seven,
	            // department_desc_eight: records.department_desc_eight,
	            // department_desc_nine: records.department_desc_nine,
	            // department_desc_ten: records.department_desc_ten,
	            status_list: JSON.parse(records.status_list),
	            descriptions: JSON.parse(records.description_list) || [],
	            image: records.image,
	            banner_image: records.banner_image
	          });
	        } else {
	          _this.setState({
	            department_name: "",
	            // department_desc_one: "",
	            // department_desc_two: "",
	            // department_desc_three: "",
	            // department_desc_four: "",
	            // department_desc_five: "",
	            // department_desc_six: "",
	            // department_desc_seven: "",
	            // department_desc_eight: "",
	            // department_desc_nine: "",
	            // department_desc_ten: "",
	            status_list: "",
	            image: "",
	            banner_image: "",
	            descriptions: [],
	            doctors: [],
	            packages: [],
	            investigations: []
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SingleDepartmentView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var department_name_string = this.props.currentDocId;
	      var department_id = department_name_string.split("~").pop();
	      //let doctor_name = doctor_name_string.split("~")[0];
	      //let new_doctor_name = doctor_name.replaceAll('-', ' ');
	      this.refreshGetDoctorData(department_id);
	      getDoctorsbyDept(department_id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          // this.setState({ doctors: records });
	        }
	      });
	      this.refreshDepartments();
	      this.refreshSideBarVideoLink();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	          title: this.state.department_name + " | Best Hospital in Bangladesh | United Hospital",
	          description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	          pathSlug: "/",
	          keywords: "Department, departments, Cardiac Surgery, Single department"
	        }),
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement("meta", {
	            name: "description",
	            content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	          }),
	          _react2.default.createElement(
	            "script",
	            { type: "application/ld+json" },
	            JSON.stringify({
	              "@context": "http://schema.org",
	              "@type": "LocalBusiness",
	              name: "United Hospital Limited",
	              image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	              telephone: "10666",
	              email: "info@uhlbd.com",
	              address: {
	                "@type": "PostalAddress",
	                streetAddress: "plot 15, Road 71, Gulshan",
	                addressLocality: "Dhaka",
	                addressRegion: "Dhaka",
	                addressCountry: "Bangladesh",
	                postalCode: "1212"
	              },
	              openingHoursSpecification: {
	                "@type": "OpeningHoursSpecification",
	                opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	              },
	              url: "http://www.uhlbd.com/",
	              aggregateRating: {
	                "@type": "AggregateRating",
	                ratingValue: "3.9",
	                bestRating: "5",
	                worstRating: "1",
	                ratingCount: "756"
	              },
	              review: {
	                "@type": "Review",
	                author: {
	                  "@type": "Person",
	                  name: "abdul kahar"
	                },
	                datePublished: "2019-02-12",
	                reviewRating: {
	                  "@type": "Rating",
	                  ratingValue: "3.9",
	                  bestRating: "5",
	                  worstRating: "1"
	                },
	                reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	              }
	            })
	          ),
	          _react2.default.createElement("meta", {
	            name: "Subject",
	            content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	          }),
	          _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	          _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	          _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	          _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	          _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	          _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	          _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	          _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	          _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	          _react2.default.createElement("meta", {
	            name: "classification",
	            content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	          }),
	          _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	          _react2.default.createElement("meta", {
	            names: "apple-mobile-web-app-status-bar-style",
	            content: "black-translucent"
	          }),
	          _react2.default.createElement("meta", {
	            name: "msvalidate.01",
	            content: "16C4E0B16E39354E550F64BD707F6A97"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "",
	            id: "giveMargin",
	            style: { backgroundColor: "#fef3e9" }
	          },
	          _react2.default.createElement(
	            "section",
	            {
	              className: "top-section",
	              style: { backgroundColor: "#f58220" }
	            },
	            _react2.default.createElement("img", {
	              style: {
	                maxWidth: "1920px",
	                maxHeight: "370px",
	                objectFit: "cover",
	                objectPosition: "center"
	              },
	              src: this.state.banner_image ? _constants.IMAGE_URL + "DepartmentImage/" + this.state.banner_image : _bannerProfile2.default,
	              alt: "banner-profile",
	              className: "w-100"
	            })
	          ),
	          _react2.default.createElement(
	            "section",
	            { className: "prof-dr mt-2 section-gap py-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "h3",
	                {
	                  className: "text-center mb-4 text-center",
	                  style: {
	                    color: "#0C807D",
	                    fontWeight: "700",
	                    width: "100%"
	                  }
	                },
	                this.state.department_name
	              ),
	              this.state.doctors.length > 0 ? _react2.default.createElement(
	                "div",
	                {
	                  className: "row mb-2 justify-content-center justify-content-md-start",
	                  style: {
	                    backgroundColor: "#fff",
	                    width: "99.8%",
	                    margin: "0 auto"
	                  }
	                },
	                this.state.doctors.map(function (doctor, ind) {
	                  var name = doctor.doctor_name;
	
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-1 col-md-6 col-xl-4 mb-2 mt-2 doctor-list singleDoctorWidth",
	                      key: ind,
	                      id: "consultation and appointment",
	                      style: { margin: "7px" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "d-flex list_content_sec",
	                        style: {
	                          width: "100%",
	                          height: "80vh",
	                          maxHeight: "167px",
	                          overflow: "hidden"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "", style: { width: "40%" } },
	                        doctor.doctor_profile ? _react2.default.createElement("img", {
	                          style: {
	                            objectFit: "cover",
	                            objectPosition: "top",
	                            width: "100%",
	                            borderTopLeftRadius: "10px",
	                            borderBottomLeftRadius: "10px"
	                          },
	                          src: _constants.IMAGE_URL + "DoctorProfileImg/" + doctor.doctor_profile,
	                          alt: "avtars",
	                          height: "100%"
	                        }) : _react2.default.createElement("img", { src: _icon2.default, alt: "Bitmap-3", width: "100%" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "h-full px-0 relative description",
	                          style: {
	                            width: "60%"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "w-full px-2" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "pt-3" },
	                            _react2.default.createElement(
	                              "h6",
	                              { style: { fontWeight: "700" } },
	                              doctor.doctor_name
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              {
	                                style: { fontSize: "12px" },
	                                title: doctor.degree
	                              },
	                              doctor.degree ? doctor.degree.length > 90 ? doctor.degree.slice(0, 90) + "..." : doctor.degree : ""
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "w-full",
	                            style: {
	                              position: "absolute",
	                              bottom: 10,
	                              right: 10,
	                              width: "85%"
	                            }
	                          },
	                          _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            {
	                              to: "/consultant/" + doctor.slug,
	                              style: { textDecoration: "none" }
	                            },
	                            " ",
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                className: "mt-2 text-light",
	                                style: {
	                                  border: "none",
	                                  backgroundColor: "#0C807D",
	                                  paddingTop: "10px",
	                                  paddingBottom: "10px",
	                                  paddingRight: "5px",
	                                  paddingLeft: "5px",
	                                  fontSize: "15px",
	                                  width: "100%",
	                                  borderRadius: "5px"
	                                }
	                              },
	                              "View Details"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  );
	                })
	              ) : "",
	              _react2.default.createElement(
	                "div",
	                { className: "box-of-about border-section mb-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row g-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-8 col-md-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "text-profile" },
	                      this.state.descriptions.length > 0 ? this.state.descriptions.filter(function (item) {
	                        return item.visibility === 1;
	                      }).map(function (item) {
	                        return _react2.default.createElement(
	                          "div",
	                          {
	                            className: "col-lg-12 col-md-12"
	                            // key={item.field_name}
	                          },
	                          _react2.default.createElement("p", {
	                            className: "b",
	                            dangerouslySetInnerHTML: {
	                              __html: item.value
	                            }
	                          })
	                        );
	                      }) : ""
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "text-profile" },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          "class": "accordion px-0",
	                          id: "accordionPanelsStayOpenExample"
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "accordion-item b" },
	                          _react2.default.createElement(
	                            "h2",
	                            {
	                              "class": "accordion-header",
	                              id: "panelsStayOpen-headingTwo"
	                            },
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                "class": "accordion-button collapsed px-2",
	                                type: "button",
	                                "data-bs-toggle": "collapse",
	                                "data-bs-target": "#panelsStayOpen-collapseTwo",
	                                "aria-expanded": "false",
	                                "aria-controls": "panelsStayOpen-collapseTwo"
	                              },
	                              "Packages"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              id: "panelsStayOpen-collapseTwo",
	                              "class": "accordion-collapse collapse",
	                              "aria-labelledby": "panelsStayOpen-headingTwo"
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { "class": "accordion-body" },
	                              this.state.packages.length > 0 ? this.state.packages.map(function (item, index) {
	                                return _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "col-lg-12 col-md-12",
	                                    key: index
	                                  },
	                                  _react2.default.createElement(
	                                    "h3",
	                                    null,
	                                    item.name
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                      "strong",
	                                      null,
	                                      "Package Type:"
	                                    ),
	                                    " ",
	                                    item.package_type
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                      "strong",
	                                      null,
	                                      "Nature:"
	                                    ),
	                                    " ",
	                                    item.package_nature
	                                  ),
	                                  _react2.default.createElement("p", {
	                                    className: "b",
	                                    dangerouslySetInnerHTML: {
	                                      __html: item.description
	                                    }
	                                  }),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                      "strong",
	                                      null,
	                                      "Amount:"
	                                    ),
	                                    " ",
	                                    item.opd_amount,
	                                    " BDT"
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                      "strong",
	                                      null,
	                                      "Created At:"
	                                    ),
	                                    " ",
	                                    new Date(item.created_at).toLocaleDateString()
	                                  ),
	                                  _react2.default.createElement("hr", { className: "w-75" })
	                                );
	                              }) : "No packages available"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "accordion-item b" },
	                          _react2.default.createElement(
	                            "h2",
	                            {
	                              "class": "accordion-header",
	                              id: "panelsStayOpen-headingThree"
	                            },
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                "class": "accordion-button collapsed px-2",
	                                type: "button",
	                                "data-bs-toggle": "collapse",
	                                "data-bs-target": "#panelsStayOpen-collapseThree",
	                                "aria-expanded": "false",
	                                "aria-controls": "panelsStayOpen-collapseThree"
	                              },
	                              "Investigations"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              id: "panelsStayOpen-collapseThree",
	                              "class": "accordion-collapse collapse",
	                              "aria-labelledby": "panelsStayOpen-headingThree"
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { "class": "accordion-body" },
	                              this.state.investigations.length > 0 ? this.state.investigations.map(function (item, index) {
	                                return _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "col-lg-12 col-md-12",
	                                    key: index
	                                  },
	                                  _react2.default.createElement(
	                                    "h3",
	                                    null,
	                                    index + 1,
	                                    "- ",
	                                    item.Product_Name
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                      "strong",
	                                      null,
	                                      "Product Group:"
	                                    ),
	                                    " ",
	                                    item.Product_Group
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                      "strong",
	                                      null,
	                                      "OPD Amount:"
	                                    ),
	                                    " ",
	                                    item.opd_amount,
	                                    " BDT"
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                      "strong",
	                                      null,
	                                      "IPD Price:"
	                                    ),
	                                    " ",
	                                    item.ipd_price,
	                                    " BDT"
	                                  ),
	                                  _react2.default.createElement("hr", { className: "w-75" })
	                                );
	                              }) : "No investigation available"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-lg-4 col-md-12 d-none d-md-block pt-2",
	                      style: {
	                        backgroundColor: "#fff",
	                        borderRadius: "5px"
	                        // width: "100%",
	                        // maxWidth: "370px",
	                      }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "text-profile", id: "mobile-part" },
	                      _react2.default.createElement(
	                        "div",
	                        { id: "sidebar-2", className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-12 sidebar-item " },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              className: "category-list-link open-cat-list",
	                              href: "#"
	                            },
	                            "Select Departments"
	                          ),
	                          _react2.default.createElement(
	                            "ul",
	                            {
	                              className: "list-unstyled category-list patients-category-list",
	                              id: "department-list-sidebar"
	                            },
	                            this.state.departments.length > 0 ? this.state.departments.map(function (department) {
	                              var department_name = department.department_name;
	                              var new_department_name = department_name.replaceAll(" ", "-");
	                              return _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                  "a",
	                                  {
	                                    className: "",
	                                    href: _constants.SITE_URL + "/departments/" + department.slug
	                                  },
	                                  department_name
	                                )
	                              );
	                            }) : ""
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "bookarea mt-3 d-none d-md-block mb-3",
	                        style: { position: "sticky", zIndex: "3333", top: 100 }
	                      },
	                      _react2.default.createElement("iframe", {
	                        width: "100%",
	                        height: "315",
	                        src: this.state.videoLInk
	                        // src="https://www.youtube.com/embed/nTORUrJ7eN8?si=NAmLLBgAX3X8lFg4"
	                        , title: "YouTube video player",
	                        frameborder: "0",
	                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted",
	                        allowfullscreen: true
	                      }),
	                      _react2.default.createElement(
	                        "h5",
	                        {
	                          className: "text-center p-2 text-light",
	                          style: {
	                            backgroundColor: "#f58220",
	                            marginTop: "-6px"
	                          }
	                        },
	                        "Call Emergency Line",
	                        _react2.default.createElement("br", null),
	                        "10666"
	                      ),
	                      _react2.default.createElement("img", {
	                        src: "https://www.uhlbd.com/resources/images/contact.jpg",
	                        alt: ""
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        this.state.showDoctorSearchPopup ? _react2.default.createElement(_SubPopupIndex2.default, {
	          showPopup: this.state.showDoctorSearchPopup,
	          doctorname: this.state.doctor_name
	        }) : null,
	        _react2.default.createElement(_BookAppointmentPopup2.default, null)
	      );
	    }
	  }]);
	
	  return SingleDepartmentView;
	}(_react.Component);
	
	exports.default = SingleDepartmentView;

/***/ },
/* 213 */
/***/ function(module, exports) {

	function e(r){var o,t,f="";if("string"==typeof r||"number"==typeof r)f+=r;else if("object"==typeof r)if(Array.isArray(r))for(o=0;o<r.length;o++)r[o]&&(t=e(r[o]))&&(f&&(f+=" "),f+=t);else for(o in r)r[o]&&(f&&(f+=" "),f+=o);return f}function r(){for(var r,o,t=0,f="";t<arguments.length;)(r=arguments[t++])&&(o=e(r))&&(f&&(f+=" "),f+=o);return f}module.exports=r,module.exports.clsx=r;

/***/ },
/* 214 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addLeadingZeros;
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	  return sign + output;
	}
	module.exports = exports.default;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(762));
	var _default = _index.default;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 216 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	};
	var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	};
	var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/) || [];
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	  var dateTimeFormat;
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	};
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	var _index3 = _interopRequireDefault(__webpack_require__(101));
	function getUTCISOWeekYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(101));
	var _index3 = _interopRequireDefault(__webpack_require__(721));
	var _index4 = _interopRequireDefault(__webpack_require__(11));
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(102));
	var _index3 = _interopRequireDefault(__webpack_require__(722));
	var _index4 = _interopRequireDefault(__webpack_require__(11));
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 220 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
	exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
	exports.throwProtectedError = throwProtectedError;
	var protectedDayOfYearTokens = ['D', 'DD'];
	var protectedWeekYearTokens = ['YY', 'YYYY'];
	function isProtectedDayOfYearToken(token) {
	  return protectedDayOfYearTokens.indexOf(token) !== -1;
	}
	function isProtectedWeekYearToken(token) {
	  return protectedWeekYearTokens.indexOf(token) !== -1;
	}
	function throwProtectedError(token, format, input) {
	  if (token === 'YYYY') {
	    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'YY') {
	    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'D') {
	    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'DD') {
	    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  }
	}

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addQuarters;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(115));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name addQuarters
	 * @category Quarter Helpers
	 * @summary Add the specified number of year quarters to the given date.
	 *
	 * @description
	 * Add the specified number of year quarters to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 1 quarter to 1 September 2014:
	 * const result = addQuarters(new Date(2014, 8, 1), 1)
	 * //=> Mon Dec 01 2014 00:00:00
	 */
	function addQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var months = amount * 3;
	  return (0, _index2.default)(dirtyDate, months);
	}
	module.exports = exports.default;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addWeeks;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(150));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * const result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	module.exports = exports.default;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(115));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * const result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	module.exports = exports.default;

/***/ },
/* 224 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.secondsInYear = exports.secondsInWeek = exports.secondsInQuarter = exports.secondsInMonth = exports.secondsInMinute = exports.secondsInHour = exports.secondsInDay = exports.quartersInYear = exports.monthsInYear = exports.monthsInQuarter = exports.minutesInHour = exports.minTime = exports.millisecondsInSecond = exports.millisecondsInMinute = exports.millisecondsInHour = exports.maxTime = exports.daysInYear = exports.daysInWeek = void 0;
	/**
	 * Days in 1 week.
	 *
	 * @name daysInWeek
	 * @constant
	 * @type {number}
	 * @default
	 */
	var daysInWeek = 7;
	
	/**
	 * Days in 1 year
	 * One years equals 365.2425 days according to the formula:
	 *
	 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	 *
	 * @name daysInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.daysInWeek = daysInWeek;
	var daysInYear = 365.2425;
	
	/**
	 * Maximum allowed time.
	 *
	 * @name maxTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.daysInYear = daysInYear;
	var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
	
	/**
	 * Milliseconds in 1 minute
	 *
	 * @name millisecondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.maxTime = maxTime;
	var millisecondsInMinute = 60000;
	
	/**
	 * Milliseconds in 1 hour
	 *
	 * @name millisecondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInMinute = millisecondsInMinute;
	var millisecondsInHour = 3600000;
	
	/**
	 * Milliseconds in 1 second
	 *
	 * @name millisecondsInSecond
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInHour = millisecondsInHour;
	var millisecondsInSecond = 1000;
	
	/**
	 * Minimum allowed time.
	 *
	 * @name minTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInSecond = millisecondsInSecond;
	var minTime = -maxTime;
	
	/**
	 * Minutes in 1 hour
	 *
	 * @name minutesInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.minTime = minTime;
	var minutesInHour = 60;
	
	/**
	 * Months in 1 quarter
	 *
	 * @name monthsInQuarter
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.minutesInHour = minutesInHour;
	var monthsInQuarter = 3;
	
	/**
	 * Months in 1 year
	 *
	 * @name monthsInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.monthsInQuarter = monthsInQuarter;
	var monthsInYear = 12;
	
	/**
	 * Quarters in 1 year
	 *
	 * @name quartersInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.monthsInYear = monthsInYear;
	var quartersInYear = 4;
	
	/**
	 * Seconds in 1 hour
	 *
	 * @name secondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.quartersInYear = quartersInYear;
	var secondsInHour = 3600;
	
	/**
	 * Seconds in 1 minute
	 *
	 * @name secondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInHour = secondsInHour;
	var secondsInMinute = 60;
	
	/**
	 * Seconds in 1 day
	 *
	 * @name secondsInDay
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInMinute = secondsInMinute;
	var secondsInDay = secondsInHour * 24;
	
	/**
	 * Seconds in 1 week
	 *
	 * @name secondsInWeek
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInDay = secondsInDay;
	var secondsInWeek = secondsInDay * 7;
	
	/**
	 * Seconds in 1 year
	 *
	 * @name secondsInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInWeek = secondsInWeek;
	var secondsInYear = secondsInDay * daysInYear;
	
	/**
	 * Seconds in 1 month
	 *
	 * @name secondsInMonth
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInYear = secondsInYear;
	var secondsInMonth = secondsInYear / 12;
	
	/**
	 * Seconds in 1 quarter
	 *
	 * @name secondsInQuarter
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInMonth = secondsInMonth;
	var secondsInQuarter = secondsInMonth * 3;
	exports.secondsInQuarter = secondsInQuarter;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	var _typeof2 = _interopRequireDefault(__webpack_require__(58));
	var _index = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * const result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * const result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * const result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * const result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  (0, _index.default)(1, arguments);
	  return value instanceof Date || (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	module.exports = exports.default;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	var _index = _interopRequireDefault(__webpack_require__(225));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * const result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * const result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * const result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
	    return false;
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  return !isNaN(Number(date));
	}
	module.exports = exports.default;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValueSetter = exports.Setter = exports.DateToSystemTimezoneSetter = void 0;
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var TIMEZONE_UNIT_PRIORITY = 10;
	var Setter = /*#__PURE__*/function () {
	  function Setter() {
	    (0, _classCallCheck2.default)(this, Setter);
	    (0, _defineProperty2.default)(this, "priority", void 0);
	    (0, _defineProperty2.default)(this, "subPriority", 0);
	  }
	  (0, _createClass2.default)(Setter, [{
	    key: "validate",
	    value: function validate(_utcDate, _options) {
	      return true;
	    }
	  }]);
	  return Setter;
	}();
	exports.Setter = Setter;
	var ValueSetter = /*#__PURE__*/function (_Setter) {
	  (0, _inherits2.default)(ValueSetter, _Setter);
	  var _super = (0, _createSuper2.default)(ValueSetter);
	  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
	    var _this;
	    (0, _classCallCheck2.default)(this, ValueSetter);
	    _this = _super.call(this);
	    _this.value = value;
	    _this.validateValue = validateValue;
	    _this.setValue = setValue;
	    _this.priority = priority;
	    if (subPriority) {
	      _this.subPriority = subPriority;
	    }
	    return _this;
	  }
	  (0, _createClass2.default)(ValueSetter, [{
	    key: "validate",
	    value: function validate(utcDate, options) {
	      return this.validateValue(utcDate, this.value, options);
	    }
	  }, {
	    key: "set",
	    value: function set(utcDate, flags, options) {
	      return this.setValue(utcDate, flags, this.value, options);
	    }
	  }]);
	  return ValueSetter;
	}(Setter);
	exports.ValueSetter = ValueSetter;
	var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
	  (0, _inherits2.default)(DateToSystemTimezoneSetter, _Setter2);
	  var _super2 = (0, _createSuper2.default)(DateToSystemTimezoneSetter);
	  function DateToSystemTimezoneSetter() {
	    var _this2;
	    (0, _classCallCheck2.default)(this, DateToSystemTimezoneSetter);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this2 = _super2.call.apply(_super2, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "subPriority", -1);
	    return _this2;
	  }
	  (0, _createClass2.default)(DateToSystemTimezoneSetter, [{
	    key: "set",
	    value: function set(date, flags) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      var convertedDate = new Date(0);
	      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
	      return convertedDate;
	    }
	  }]);
	  return DateToSystemTimezoneSetter;
	}(Setter);
	exports.DateToSystemTimezoneSetter = DateToSystemTimezoneSetter;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfQuarter;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name startOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3;
	  date.setMonth(month, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(25));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	var _index4 = __webpack_require__(66);
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index3.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(151));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.decodeHTML = exports.decodeHTMLStrict = exports.decodeXML = void 0;
	var entities_json_1 = __importDefault(__webpack_require__(246));
	var legacy_json_1 = __importDefault(__webpack_require__(855));
	var xml_json_1 = __importDefault(__webpack_require__(247));
	var decode_codepoint_1 = __importDefault(__webpack_require__(820));
	var strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
	exports.decodeXML = getStrictDecoder(xml_json_1.default);
	exports.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
	function getStrictDecoder(map) {
	    var replace = getReplacer(map);
	    return function (str) { return String(str).replace(strictEntityRe, replace); };
	}
	var sorter = function (a, b) { return (a < b ? 1 : -1); };
	exports.decodeHTML = (function () {
	    var legacy = Object.keys(legacy_json_1.default).sort(sorter);
	    var keys = Object.keys(entities_json_1.default).sort(sorter);
	    for (var i = 0, j = 0; i < keys.length; i++) {
	        if (legacy[j] === keys[i]) {
	            keys[i] += ";?";
	            j++;
	        }
	        else {
	            keys[i] += ";";
	        }
	    }
	    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
	    var replace = getReplacer(entities_json_1.default);
	    function replacer(str) {
	        if (str.substr(-1) !== ";")
	            str += ";";
	        return replace(str);
	    }
	    // TODO consider creating a merged map
	    return function (str) { return String(str).replace(re, replacer); };
	})();
	function getReplacer(map) {
	    return function replace(str) {
	        if (str.charAt(1) === "#") {
	            var secondChar = str.charAt(2);
	            if (secondChar === "X" || secondChar === "x") {
	                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
	            }
	            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
	        }
	        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
	        return map[str.slice(1, -1)] || str;
	    };
	}


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = void 0;
	var xml_json_1 = __importDefault(__webpack_require__(247));
	var inverseXML = getInverseObj(xml_json_1.default);
	var xmlReplacer = getInverseReplacer(inverseXML);
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in XML
	 * documents using XML entities.
	 *
	 * If a character has no equivalent entity, a
	 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
	 */
	exports.encodeXML = getASCIIEncoder(inverseXML);
	var entities_json_1 = __importDefault(__webpack_require__(246));
	var inverseHTML = getInverseObj(entities_json_1.default);
	var htmlReplacer = getInverseReplacer(inverseHTML);
	/**
	 * Encodes all entities and non-ASCII characters in the input.
	 *
	 * This includes characters that are valid ASCII characters in HTML documents.
	 * For example `#` will be encoded as `&num;`. To get a more compact output,
	 * consider using the `encodeNonAsciiHTML` function.
	 *
	 * If a character has no equivalent entity, a
	 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
	 */
	exports.encodeHTML = getInverse(inverseHTML, htmlReplacer);
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in HTML
	 * documents using HTML entities.
	 *
	 * If a character has no equivalent entity, a
	 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
	 */
	exports.encodeNonAsciiHTML = getASCIIEncoder(inverseHTML);
	function getInverseObj(obj) {
	    return Object.keys(obj)
	        .sort()
	        .reduce(function (inverse, name) {
	        inverse[obj[name]] = "&" + name + ";";
	        return inverse;
	    }, {});
	}
	function getInverseReplacer(inverse) {
	    var single = [];
	    var multiple = [];
	    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
	        var k = _a[_i];
	        if (k.length === 1) {
	            // Add value to single array
	            single.push("\\" + k);
	        }
	        else {
	            // Add value to multiple array
	            multiple.push(k);
	        }
	    }
	    // Add ranges to single characters.
	    single.sort();
	    for (var start = 0; start < single.length - 1; start++) {
	        // Find the end of a run of characters
	        var end = start;
	        while (end < single.length - 1 &&
	            single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
	            end += 1;
	        }
	        var count = 1 + end - start;
	        // We want to replace at least three characters
	        if (count < 3)
	            continue;
	        single.splice(start, count, single[start] + "-" + single[end]);
	    }
	    multiple.unshift("[" + single.join("") + "]");
	    return new RegExp(multiple.join("|"), "g");
	}
	// /[^\0-\x7F]/gu
	var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
	var getCodePoint = 
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	String.prototype.codePointAt != null
	    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	        function (str) { return str.codePointAt(0); }
	    : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	        function (c) {
	            return (c.charCodeAt(0) - 0xd800) * 0x400 +
	                c.charCodeAt(1) -
	                0xdc00 +
	                0x10000;
	        };
	function singleCharReplacer(c) {
	    return "&#x" + (c.length > 1 ? getCodePoint(c) : c.charCodeAt(0))
	        .toString(16)
	        .toUpperCase() + ";";
	}
	function getInverse(inverse, re) {
	    return function (data) {
	        return data
	            .replace(re, function (name) { return inverse[name]; })
	            .replace(reNonASCII, singleCharReplacer);
	    };
	}
	var reEscapeChars = new RegExp(xmlReplacer.source + "|" + reNonASCII.source, "g");
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in XML
	 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
	 *
	 * Have a look at `escapeUTF8` if you want a more concise output at the expense
	 * of reduced transportability.
	 *
	 * @param data String to escape.
	 */
	function escape(data) {
	    return data.replace(reEscapeChars, singleCharReplacer);
	}
	exports.escape = escape;
	/**
	 * Encodes all characters not valid in XML documents using numeric hexadecimal
	 * reference (eg. `&#xfc;`).
	 *
	 * Note that the output will be character-set dependent.
	 *
	 * @param data String to escape.
	 */
	function escapeUTF8(data) {
	    return data.replace(xmlReplacer, singleCharReplacer);
	}
	exports.escapeUTF8 = escapeUTF8;
	function getASCIIEncoder(obj) {
	    return function (data) {
	        return data.replace(reEscapeChars, function (c) { return obj[c] || singleCharReplacer(c); });
	    };
	}


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(103);
	
	var re_whitespace = /\s+/g;
	var NodePrototype = __webpack_require__(234);
	var ElementPrototype = __webpack_require__(823);
	
	function DomHandler(callback, options, elementCB){
		if(typeof callback === "object"){
			elementCB = options;
			options = callback;
			callback = null;
		} else if(typeof options === "function"){
			elementCB = options;
			options = defaultOpts;
		}
		this._callback = callback;
		this._options = options || defaultOpts;
		this._elementCB = elementCB;
		this.dom = [];
		this._done = false;
		this._tagStack = [];
		this._parser = this._parser || null;
	}
	
	//default options
	var defaultOpts = {
		normalizeWhitespace: false, //Replace all whitespace with single spaces
		withStartIndices: false, //Add startIndex properties to nodes
		withEndIndices: false, //Add endIndex properties to nodes
	};
	
	DomHandler.prototype.onparserinit = function(parser){
		this._parser = parser;
	};
	
	//Resets the handler back to starting state
	DomHandler.prototype.onreset = function(){
		DomHandler.call(this, this._callback, this._options, this._elementCB);
	};
	
	//Signals the handler that parsing is done
	DomHandler.prototype.onend = function(){
		if(this._done) return;
		this._done = true;
		this._parser = null;
		this._handleCallback(null);
	};
	
	DomHandler.prototype._handleCallback =
	DomHandler.prototype.onerror = function(error){
		if(typeof this._callback === "function"){
			this._callback(error, this.dom);
		} else {
			if(error) throw error;
		}
	};
	
	DomHandler.prototype.onclosetag = function(){
		//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
		
		var elem = this._tagStack.pop();
	
		if(this._options.withEndIndices && elem){
			elem.endIndex = this._parser.endIndex;
		}
	
		if(this._elementCB) this._elementCB(elem);
	};
	
	DomHandler.prototype._createDomElement = function(properties){
		if (!this._options.withDomLvl1) return properties;
	
		var element;
		if (properties.type === "tag") {
			element = Object.create(ElementPrototype);
		} else {
			element = Object.create(NodePrototype);
		}
	
		for (var key in properties) {
			if (properties.hasOwnProperty(key)) {
				element[key] = properties[key];
			}
		}
	
		return element;
	};
	
	DomHandler.prototype._addDomElement = function(element){
		var parent = this._tagStack[this._tagStack.length - 1];
		var siblings = parent ? parent.children : this.dom;
		var previousSibling = siblings[siblings.length - 1];
	
		element.next = null;
	
		if(this._options.withStartIndices){
			element.startIndex = this._parser.startIndex;
		}
		if(this._options.withEndIndices){
			element.endIndex = this._parser.endIndex;
		}
	
		if(previousSibling){
			element.prev = previousSibling;
			previousSibling.next = element;
		} else {
			element.prev = null;
		}
	
		siblings.push(element);
		element.parent = parent || null;
	};
	
	DomHandler.prototype.onopentag = function(name, attribs){
		var properties = {
			type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
			name: name,
			attribs: attribs,
			children: []
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
	
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.ontext = function(data){
		//the ignoreWhitespace is officially dropped, but for now,
		//it's an alias for normalizeWhitespace
		var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
	
		var lastTag;
	
		if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(
				this._tagStack.length &&
				(lastTag = this._tagStack[this._tagStack.length - 1]) &&
				(lastTag = lastTag.children[lastTag.children.length - 1]) &&
				lastTag.type === ElementType.Text
			){
				if(normalize){
					lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
				} else {
					lastTag.data += data;
				}
			} else {
				if(normalize){
					data = data.replace(re_whitespace, " ");
				}
	
				var element = this._createDomElement({
					data: data,
					type: ElementType.Text
				});
	
				this._addDomElement(element);
			}
		}
	};
	
	DomHandler.prototype.oncomment = function(data){
		var lastTag = this._tagStack[this._tagStack.length - 1];
	
		if(lastTag && lastTag.type === ElementType.Comment){
			lastTag.data += data;
			return;
		}
	
		var properties = {
			data: data,
			type: ElementType.Comment
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncdatastart = function(){
		var properties = {
			children: [{
				data: "",
				type: ElementType.Text
			}],
			type: ElementType.CDATA
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
		this._tagStack.pop();
	};
	
	DomHandler.prototype.onprocessinginstruction = function(name, data){
		var element = this._createDomElement({
			name: name,
			data: data,
			type: ElementType.Directive
		});
	
		this._addDomElement(element);
	};
	
	module.exports = DomHandler;


/***/ },
/* 234 */
/***/ function(module, exports) {

	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var NodePrototype = module.exports = {
		get firstChild() {
			var children = this.children;
			return children && children[0] || null;
		},
		get lastChild() {
			var children = this.children;
			return children && children[children.length - 1] || null;
		},
		get nodeType() {
			return nodeTypes[this.type] || nodeTypes.element;
		}
	};
	
	var domLvl1 = {
		tagName: "name",
		childNodes: "children",
		parentNode: "parent",
		previousSibling: "prev",
		nextSibling: "next",
		nodeValue: "data"
	};
	
	var nodeTypes = {
		element: 1,
		text: 3,
		cdata: 4,
		comment: 8
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(NodePrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var DomUtils = module.exports;
	
	[
		__webpack_require__(828),
		__webpack_require__(829),
		__webpack_require__(826),
		__webpack_require__(827),
		__webpack_require__(825),
		__webpack_require__(824)
	].forEach(function(ext){
		Object.keys(ext).forEach(function(key){
			DomUtils[key] = ext[key].bind(DomUtils);
		});
	});


/***/ },
/* 236 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 237 */
8,
/* 238 */
8,
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/female.1b1184c3.svg";

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/male.82862bd2.svg";

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(846);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(408);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var Tokenizer = __webpack_require__(244);
	
	/*
		Options:
	
		xmlMode: Disables the special behavior for script/style tags (false by default)
		lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
		lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
	*/
	
	/*
		Callbacks:
	
		oncdataend,
		oncdatastart,
		onclosetag,
		oncomment,
		oncommentend,
		onerror,
		onopentag,
		onprocessinginstruction,
		onreset,
		ontext
	*/
	
	var formTags = {
	    input: true,
	    option: true,
	    optgroup: true,
	    select: true,
	    button: true,
	    datalist: true,
	    textarea: true
	};
	
	var openImpliesClose = {
	    tr: { tr: true, th: true, td: true },
	    th: { th: true },
	    td: { thead: true, th: true, td: true },
	    body: { head: true, link: true, script: true },
	    li: { li: true },
	    p: { p: true },
	    h1: { p: true },
	    h2: { p: true },
	    h3: { p: true },
	    h4: { p: true },
	    h5: { p: true },
	    h6: { p: true },
	    select: formTags,
	    input: formTags,
	    output: formTags,
	    button: formTags,
	    datalist: formTags,
	    textarea: formTags,
	    option: { option: true },
	    optgroup: { optgroup: true }
	};
	
	var voidElements = {
	    __proto__: null,
	    area: true,
	    base: true,
	    basefont: true,
	    br: true,
	    col: true,
	    command: true,
	    embed: true,
	    frame: true,
	    hr: true,
	    img: true,
	    input: true,
	    isindex: true,
	    keygen: true,
	    link: true,
	    meta: true,
	    param: true,
	    source: true,
	    track: true,
	    wbr: true
	};
	
	var foreignContextElements = {
	    __proto__: null,
	    math: true,
	    svg: true
	};
	var htmlIntegrationElements = {
	    __proto__: null,
	    mi: true,
	    mo: true,
	    mn: true,
	    ms: true,
	    mtext: true,
	    "annotation-xml": true,
	    foreignObject: true,
	    desc: true,
	    title: true
	};
	
	var re_nameEnd = /\s|\//;
	
	function Parser(cbs, options) {
	    this._options = options || {};
	    this._cbs = cbs || {};
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribvalue = "";
	    this._attribs = null;
	    this._stack = [];
	    this._foreignContext = [];
	
	    this.startIndex = 0;
	    this.endIndex = null;
	
	    this._lowerCaseTagNames =
	        "lowerCaseTags" in this._options
	            ? !!this._options.lowerCaseTags
	            : !this._options.xmlMode;
	    this._lowerCaseAttributeNames =
	        "lowerCaseAttributeNames" in this._options
	            ? !!this._options.lowerCaseAttributeNames
	            : !this._options.xmlMode;
	
	    if (this._options.Tokenizer) {
	        Tokenizer = this._options.Tokenizer;
	    }
	    this._tokenizer = new Tokenizer(this._options, this);
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	}
	
	__webpack_require__(118)(Parser, __webpack_require__(835).EventEmitter);
	
	Parser.prototype._updatePosition = function(initialOffset) {
	    if (this.endIndex === null) {
	        if (this._tokenizer._sectionStart <= initialOffset) {
	            this.startIndex = 0;
	        } else {
	            this.startIndex = this._tokenizer._sectionStart - initialOffset;
	        }
	    } else this.startIndex = this.endIndex + 1;
	    this.endIndex = this._tokenizer.getAbsoluteIndex();
	};
	
	//Tokenizer event handlers
	Parser.prototype.ontext = function(data) {
	    this._updatePosition(1);
	    this.endIndex--;
	
	    if (this._cbs.ontext) this._cbs.ontext(data);
	};
	
	Parser.prototype.onopentagname = function(name) {
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    this._tagname = name;
	
	    if (!this._options.xmlMode && name in openImpliesClose) {
	        for (
	            var el;
	            (el = this._stack[this._stack.length - 1]) in
	            openImpliesClose[name];
	            this.onclosetag(el)
	        );
	    }
	
	    if (this._options.xmlMode || !(name in voidElements)) {
	        this._stack.push(name);
	        if (name in foreignContextElements) this._foreignContext.push(true);
	        else if (name in htmlIntegrationElements)
	            this._foreignContext.push(false);
	    }
	
	    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
	    if (this._cbs.onopentag) this._attribs = {};
	};
	
	Parser.prototype.onopentagend = function() {
	    this._updatePosition(1);
	
	    if (this._attribs) {
	        if (this._cbs.onopentag)
	            this._cbs.onopentag(this._tagname, this._attribs);
	        this._attribs = null;
	    }
	
	    if (
	        !this._options.xmlMode &&
	        this._cbs.onclosetag &&
	        this._tagname in voidElements
	    ) {
	        this._cbs.onclosetag(this._tagname);
	    }
	
	    this._tagname = "";
	};
	
	Parser.prototype.onclosetag = function(name) {
	    this._updatePosition(1);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	    
	    if (name in foreignContextElements || name in htmlIntegrationElements) {
	        this._foreignContext.pop();
	    }
	
	    if (
	        this._stack.length &&
	        (!(name in voidElements) || this._options.xmlMode)
	    ) {
	        var pos = this._stack.lastIndexOf(name);
	        if (pos !== -1) {
	            if (this._cbs.onclosetag) {
	                pos = this._stack.length - pos;
	                while (pos--) this._cbs.onclosetag(this._stack.pop());
	            } else this._stack.length = pos;
	        } else if (name === "p" && !this._options.xmlMode) {
	            this.onopentagname(name);
	            this._closeCurrentTag();
	        }
	    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
	        this.onopentagname(name);
	        this._closeCurrentTag();
	    }
	};
	
	Parser.prototype.onselfclosingtag = function() {
	    if (
	        this._options.xmlMode ||
	        this._options.recognizeSelfClosing ||
	        this._foreignContext[this._foreignContext.length - 1]
	    ) {
	        this._closeCurrentTag();
	    } else {
	        this.onopentagend();
	    }
	};
	
	Parser.prototype._closeCurrentTag = function() {
	    var name = this._tagname;
	
	    this.onopentagend();
	
	    //self-closing tags will be on the top of the stack
	    //(cheaper check than in onclosetag)
	    if (this._stack[this._stack.length - 1] === name) {
	        if (this._cbs.onclosetag) {
	            this._cbs.onclosetag(name);
	        }
	        this._stack.pop();
	        
	    }
	};
	
	Parser.prototype.onattribname = function(name) {
	    if (this._lowerCaseAttributeNames) {
	        name = name.toLowerCase();
	    }
	    this._attribname = name;
	};
	
	Parser.prototype.onattribdata = function(value) {
	    this._attribvalue += value;
	};
	
	Parser.prototype.onattribend = function() {
	    if (this._cbs.onattribute)
	        this._cbs.onattribute(this._attribname, this._attribvalue);
	    if (
	        this._attribs &&
	        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	    ) {
	        this._attribs[this._attribname] = this._attribvalue;
	    }
	    this._attribname = "";
	    this._attribvalue = "";
	};
	
	Parser.prototype._getInstructionName = function(value) {
	    var idx = value.search(re_nameEnd),
	        name = idx < 0 ? value : value.substr(0, idx);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    return name;
	};
	
	Parser.prototype.ondeclaration = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("!" + name, "!" + value);
	    }
	};
	
	Parser.prototype.onprocessinginstruction = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("?" + name, "?" + value);
	    }
	};
	
	Parser.prototype.oncomment = function(value) {
	    this._updatePosition(4);
	
	    if (this._cbs.oncomment) this._cbs.oncomment(value);
	    if (this._cbs.oncommentend) this._cbs.oncommentend();
	};
	
	Parser.prototype.oncdata = function(value) {
	    this._updatePosition(1);
	
	    if (this._options.xmlMode || this._options.recognizeCDATA) {
	        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
	        if (this._cbs.ontext) this._cbs.ontext(value);
	        if (this._cbs.oncdataend) this._cbs.oncdataend();
	    } else {
	        this.oncomment("[CDATA[" + value + "]]");
	    }
	};
	
	Parser.prototype.onerror = function(err) {
	    if (this._cbs.onerror) this._cbs.onerror(err);
	};
	
	Parser.prototype.onend = function() {
	    if (this._cbs.onclosetag) {
	        for (
	            var i = this._stack.length;
	            i > 0;
	            this._cbs.onclosetag(this._stack[--i])
	        );
	    }
	    if (this._cbs.onend) this._cbs.onend();
	};
	
	//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	    this._tokenizer.reset();
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribs = null;
	    this._stack = [];
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	};
	
	//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete = function(data) {
	    this.reset();
	    this.end(data);
	};
	
	Parser.prototype.write = function(chunk) {
	    this._tokenizer.write(chunk);
	};
	
	Parser.prototype.end = function(chunk) {
	    this._tokenizer.end(chunk);
	};
	
	Parser.prototype.pause = function() {
	    this._tokenizer.pause();
	};
	
	Parser.prototype.resume = function() {
	    this._tokenizer.resume();
	};
	
	//alias for backwards compat
	Parser.prototype.parseChunk = Parser.prototype.write;
	Parser.prototype.done = Parser.prototype.end;
	
	module.exports = Parser;


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Tokenizer;
	
	var decodeCodePoint = __webpack_require__(834);
	var entityMap = __webpack_require__(857);
	var legacyMap = __webpack_require__(858);
	var xmlMap = __webpack_require__(859);
	
	var i = 0;
	
	var TEXT = i++;
	var BEFORE_TAG_NAME = i++; //after <
	var IN_TAG_NAME = i++;
	var IN_SELF_CLOSING_TAG = i++;
	var BEFORE_CLOSING_TAG_NAME = i++;
	var IN_CLOSING_TAG_NAME = i++;
	var AFTER_CLOSING_TAG_NAME = i++;
	
	//attributes
	var BEFORE_ATTRIBUTE_NAME = i++;
	var IN_ATTRIBUTE_NAME = i++;
	var AFTER_ATTRIBUTE_NAME = i++;
	var BEFORE_ATTRIBUTE_VALUE = i++;
	var IN_ATTRIBUTE_VALUE_DQ = i++; // "
	var IN_ATTRIBUTE_VALUE_SQ = i++; // '
	var IN_ATTRIBUTE_VALUE_NQ = i++;
	
	//declarations
	var BEFORE_DECLARATION = i++; // !
	var IN_DECLARATION = i++;
	
	//processing instructions
	var IN_PROCESSING_INSTRUCTION = i++; // ?
	
	//comments
	var BEFORE_COMMENT = i++;
	var IN_COMMENT = i++;
	var AFTER_COMMENT_1 = i++;
	var AFTER_COMMENT_2 = i++;
	
	//cdata
	var BEFORE_CDATA_1 = i++; // [
	var BEFORE_CDATA_2 = i++; // C
	var BEFORE_CDATA_3 = i++; // D
	var BEFORE_CDATA_4 = i++; // A
	var BEFORE_CDATA_5 = i++; // T
	var BEFORE_CDATA_6 = i++; // A
	var IN_CDATA = i++; // [
	var AFTER_CDATA_1 = i++; // ]
	var AFTER_CDATA_2 = i++; // ]
	
	//special tags
	var BEFORE_SPECIAL = i++; //S
	var BEFORE_SPECIAL_END = i++; //S
	
	var BEFORE_SCRIPT_1 = i++; //C
	var BEFORE_SCRIPT_2 = i++; //R
	var BEFORE_SCRIPT_3 = i++; //I
	var BEFORE_SCRIPT_4 = i++; //P
	var BEFORE_SCRIPT_5 = i++; //T
	var AFTER_SCRIPT_1 = i++; //C
	var AFTER_SCRIPT_2 = i++; //R
	var AFTER_SCRIPT_3 = i++; //I
	var AFTER_SCRIPT_4 = i++; //P
	var AFTER_SCRIPT_5 = i++; //T
	
	var BEFORE_STYLE_1 = i++; //T
	var BEFORE_STYLE_2 = i++; //Y
	var BEFORE_STYLE_3 = i++; //L
	var BEFORE_STYLE_4 = i++; //E
	var AFTER_STYLE_1 = i++; //T
	var AFTER_STYLE_2 = i++; //Y
	var AFTER_STYLE_3 = i++; //L
	var AFTER_STYLE_4 = i++; //E
	
	var BEFORE_ENTITY = i++; //&
	var BEFORE_NUMERIC_ENTITY = i++; //#
	var IN_NAMED_ENTITY = i++;
	var IN_NUMERIC_ENTITY = i++;
	var IN_HEX_ENTITY = i++; //X
	
	var j = 0;
	
	var SPECIAL_NONE = j++;
	var SPECIAL_SCRIPT = j++;
	var SPECIAL_STYLE = j++;
	
	function whitespace(c) {
	    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function ifElseState(upper, SUCCESS, FAILURE) {
	    var lower = upper.toLowerCase();
	
	    if (upper === lower) {
	        return function(c) {
	            if (c === lower) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    } else {
	        return function(c) {
	            if (c === lower || c === upper) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    }
	}
	
	function consumeSpecialNameChar(upper, NEXT_STATE) {
	    var lower = upper.toLowerCase();
	
	    return function(c) {
	        if (c === lower || c === upper) {
	            this._state = NEXT_STATE;
	        } else {
	            this._state = IN_TAG_NAME;
	            this._index--; //consume the token again
	        }
	    };
	}
	
	function Tokenizer(options, cbs) {
	    this._state = TEXT;
	    this._buffer = "";
	    this._sectionStart = 0;
	    this._index = 0;
	    this._bufferOffset = 0; //chars removed from _buffer
	    this._baseState = TEXT;
	    this._special = SPECIAL_NONE;
	    this._cbs = cbs;
	    this._running = true;
	    this._ended = false;
	    this._xmlMode = !!(options && options.xmlMode);
	    this._decodeEntities = !!(options && options.decodeEntities);
	}
	
	Tokenizer.prototype._stateText = function(c) {
	    if (c === "<") {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._state = BEFORE_TAG_NAME;
	        this._sectionStart = this._index;
	    } else if (
	        this._decodeEntities &&
	        this._special === SPECIAL_NONE &&
	        c === "&"
	    ) {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._baseState = TEXT;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeTagName = function(c) {
	    if (c === "/") {
	        this._state = BEFORE_CLOSING_TAG_NAME;
	    } else if (c === "<") {
	        this._cbs.ontext(this._getSection());
	        this._sectionStart = this._index;
	    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
	        this._state = TEXT;
	    } else if (c === "!") {
	        this._state = BEFORE_DECLARATION;
	        this._sectionStart = this._index + 1;
	    } else if (c === "?") {
	        this._state = IN_PROCESSING_INSTRUCTION;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state =
	            !this._xmlMode && (c === "s" || c === "S")
	                ? BEFORE_SPECIAL
	                : IN_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInTagName = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._emitToken("onopentagname");
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
	    if (whitespace(c));
	    else if (c === ">") {
	        this._state = TEXT;
	    } else if (this._special !== SPECIAL_NONE) {
	        if (c === "s" || c === "S") {
	            this._state = BEFORE_SPECIAL_END;
	        } else {
	            this._state = TEXT;
	            this._index--;
	        }
	    } else {
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInCloseingTagName = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._emitToken("onclosetag");
	        this._state = AFTER_CLOSING_TAG_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
	    //skip everything until ">"
	    if (c === ">") {
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeName = function(c) {
	    if (c === ">") {
	        this._cbs.onopentagend();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c === "/") {
	        this._state = IN_SELF_CLOSING_TAG;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInSelfClosingTag = function(c) {
	    if (c === ">") {
	        this._cbs.onselfclosingtag();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeName = function(c) {
	    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
	        this._cbs.onattribname(this._getSection());
	        this._sectionStart = -1;
	        this._state = AFTER_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterAttributeName = function(c) {
	    if (c === "=") {
	        this._state = BEFORE_ATTRIBUTE_VALUE;
	    } else if (c === "/" || c === ">") {
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (!whitespace(c)) {
	        this._cbs.onattribend();
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
	    if (c === '"') {
	        this._state = IN_ATTRIBUTE_VALUE_DQ;
	        this._sectionStart = this._index + 1;
	    } else if (c === "'") {
	        this._state = IN_ATTRIBUTE_VALUE_SQ;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_VALUE_NQ;
	        this._sectionStart = this._index;
	        this._index--; //reconsume token
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
	    if (c === '"') {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
	    if (c === "'") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
	    if (whitespace(c) || c === ">") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeDeclaration = function(c) {
	    this._state =
	        c === "["
	            ? BEFORE_CDATA_1
	            : c === "-"
	                ? BEFORE_COMMENT
	                : IN_DECLARATION;
	};
	
	Tokenizer.prototype._stateInDeclaration = function(c) {
	    if (c === ">") {
	        this._cbs.ondeclaration(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateInProcessingInstruction = function(c) {
	    if (c === ">") {
	        this._cbs.onprocessinginstruction(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeComment = function(c) {
	    if (c === "-") {
	        this._state = IN_COMMENT;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	    }
	};
	
	Tokenizer.prototype._stateInComment = function(c) {
	    if (c === "-") this._state = AFTER_COMMENT_1;
	};
	
	Tokenizer.prototype._stateAfterComment1 = function(c) {
	    if (c === "-") {
	        this._state = AFTER_COMMENT_2;
	    } else {
	        this._state = IN_COMMENT;
	    }
	};
	
	Tokenizer.prototype._stateAfterComment2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncomment(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "-") {
	        this._state = IN_COMMENT;
	    }
	    // else: stay in AFTER_COMMENT_2 (`--->`)
	};
	
	Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
	    "C",
	    BEFORE_CDATA_2,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
	    "D",
	    BEFORE_CDATA_3,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
	    "A",
	    BEFORE_CDATA_4,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
	    "T",
	    BEFORE_CDATA_5,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
	    "A",
	    BEFORE_CDATA_6,
	    IN_DECLARATION
	);
	
	Tokenizer.prototype._stateBeforeCdata6 = function(c) {
	    if (c === "[") {
	        this._state = IN_CDATA;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInCdata = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_1;
	};
	
	Tokenizer.prototype._stateAfterCdata1 = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_2;
	    else this._state = IN_CDATA;
	};
	
	Tokenizer.prototype._stateAfterCdata2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncdata(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "]") {
	        this._state = IN_CDATA;
	    }
	    //else: stay in AFTER_CDATA_2 (`]]]>`)
	};
	
	Tokenizer.prototype._stateBeforeSpecial = function(c) {
	    if (c === "c" || c === "C") {
	        this._state = BEFORE_SCRIPT_1;
	    } else if (c === "t" || c === "T") {
	        this._state = BEFORE_STYLE_1;
	    } else {
	        this._state = IN_TAG_NAME;
	        this._index--; //consume the token again
	    }
	};
	
	Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
	    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
	        this._state = AFTER_SCRIPT_1;
	    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
	        this._state = AFTER_STYLE_1;
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
	    "R",
	    BEFORE_SCRIPT_2
	);
	Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
	    "I",
	    BEFORE_SCRIPT_3
	);
	Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
	    "P",
	    BEFORE_SCRIPT_4
	);
	Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
	    "T",
	    BEFORE_SCRIPT_5
	);
	
	Tokenizer.prototype._stateBeforeScript5 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_SCRIPT;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
	Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
	Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
	Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
	
	Tokenizer.prototype._stateAfterScript5 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 6;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
	    "Y",
	    BEFORE_STYLE_2
	);
	Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
	    "L",
	    BEFORE_STYLE_3
	);
	Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
	    "E",
	    BEFORE_STYLE_4
	);
	
	Tokenizer.prototype._stateBeforeStyle4 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_STYLE;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
	Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
	Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
	
	Tokenizer.prototype._stateAfterStyle4 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 5;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeEntity = ifElseState(
	    "#",
	    BEFORE_NUMERIC_ENTITY,
	    IN_NAMED_ENTITY
	);
	Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
	    "X",
	    IN_HEX_ENTITY,
	    IN_NUMERIC_ENTITY
	);
	
	//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict = function() {
	    //offset = 1
	    if (this._sectionStart + 1 < this._index) {
	        var entity = this._buffer.substring(
	                this._sectionStart + 1,
	                this._index
	            ),
	            map = this._xmlMode ? xmlMap : entityMap;
	
	        if (map.hasOwnProperty(entity)) {
	            this._emitPartial(map[entity]);
	            this._sectionStart = this._index + 1;
	        }
	    }
	};
	
	//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity = function() {
	    var start = this._sectionStart + 1,
	        limit = this._index - start;
	
	    if (limit > 6) limit = 6; //the max length of legacy entities is 6
	
	    while (limit >= 2) {
	        //the min length of legacy entities is 2
	        var entity = this._buffer.substr(start, limit);
	
	        if (legacyMap.hasOwnProperty(entity)) {
	            this._emitPartial(legacyMap[entity]);
	            this._sectionStart += limit + 1;
	            return;
	        } else {
	            limit--;
	        }
	    }
	};
	
	Tokenizer.prototype._stateInNamedEntity = function(c) {
	    if (c === ";") {
	        this._parseNamedEntityStrict();
	        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
	            this._parseLegacyEntity();
	        }
	        this._state = this._baseState;
	    } else if (
	        (c < "a" || c > "z") &&
	        (c < "A" || c > "Z") &&
	        (c < "0" || c > "9")
	    ) {
	        if (this._xmlMode);
	        else if (this._sectionStart + 1 === this._index);
	        else if (this._baseState !== TEXT) {
	            if (c !== "=") {
	                this._parseNamedEntityStrict();
	            }
	        } else {
	            this._parseLegacyEntity();
	        }
	
	        this._state = this._baseState;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
	    var sectionStart = this._sectionStart + offset;
	
	    if (sectionStart !== this._index) {
	        //parse entity
	        var entity = this._buffer.substring(sectionStart, this._index);
	        var parsed = parseInt(entity, base);
	
	        this._emitPartial(decodeCodePoint(parsed));
	        this._sectionStart = this._index;
	    } else {
	        this._sectionStart--;
	    }
	
	    this._state = this._baseState;
	};
	
	Tokenizer.prototype._stateInNumericEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(2, 10);
	        this._sectionStart++;
	    } else if (c < "0" || c > "9") {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(2, 10);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInHexEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(3, 16);
	        this._sectionStart++;
	    } else if (
	        (c < "a" || c > "f") &&
	        (c < "A" || c > "F") &&
	        (c < "0" || c > "9")
	    ) {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(3, 16);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._cleanup = function() {
	    if (this._sectionStart < 0) {
	        this._buffer = "";
	        this._bufferOffset += this._index;
	        this._index = 0;
	    } else if (this._running) {
	        if (this._state === TEXT) {
	            if (this._sectionStart !== this._index) {
	                this._cbs.ontext(this._buffer.substr(this._sectionStart));
	            }
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else if (this._sectionStart === this._index) {
	            //the section just started
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else {
	            //remove everything unnecessary
	            this._buffer = this._buffer.substr(this._sectionStart);
	            this._index -= this._sectionStart;
	            this._bufferOffset += this._sectionStart;
	        }
	
	        this._sectionStart = 0;
	    }
	};
	
	//TODO make events conditional
	Tokenizer.prototype.write = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".write() after done!"));
	
	    this._buffer += chunk;
	    this._parse();
	};
	
	Tokenizer.prototype._parse = function() {
	    while (this._index < this._buffer.length && this._running) {
	        var c = this._buffer.charAt(this._index);
	        if (this._state === TEXT) {
	            this._stateText(c);
	        } else if (this._state === BEFORE_TAG_NAME) {
	            this._stateBeforeTagName(c);
	        } else if (this._state === IN_TAG_NAME) {
	            this._stateInTagName(c);
	        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
	            this._stateBeforeCloseingTagName(c);
	        } else if (this._state === IN_CLOSING_TAG_NAME) {
	            this._stateInCloseingTagName(c);
	        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
	            this._stateAfterCloseingTagName(c);
	        } else if (this._state === IN_SELF_CLOSING_TAG) {
	            this._stateInSelfClosingTag(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {
	
	        /*
			*	attributes
			*/
	            this._stateBeforeAttributeName(c);
	        } else if (this._state === IN_ATTRIBUTE_NAME) {
	            this._stateInAttributeName(c);
	        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
	            this._stateAfterAttributeName(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
	            this._stateBeforeAttributeValue(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
	            this._stateInAttributeValueDoubleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
	            this._stateInAttributeValueSingleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
	            this._stateInAttributeValueNoQuotes(c);
	        } else if (this._state === BEFORE_DECLARATION) {
	
	        /*
			*	declarations
			*/
	            this._stateBeforeDeclaration(c);
	        } else if (this._state === IN_DECLARATION) {
	            this._stateInDeclaration(c);
	        } else if (this._state === IN_PROCESSING_INSTRUCTION) {
	
	        /*
			*	processing instructions
			*/
	            this._stateInProcessingInstruction(c);
	        } else if (this._state === BEFORE_COMMENT) {
	
	        /*
			*	comments
			*/
	            this._stateBeforeComment(c);
	        } else if (this._state === IN_COMMENT) {
	            this._stateInComment(c);
	        } else if (this._state === AFTER_COMMENT_1) {
	            this._stateAfterComment1(c);
	        } else if (this._state === AFTER_COMMENT_2) {
	            this._stateAfterComment2(c);
	        } else if (this._state === BEFORE_CDATA_1) {
	
	        /*
			*	cdata
			*/
	            this._stateBeforeCdata1(c);
	        } else if (this._state === BEFORE_CDATA_2) {
	            this._stateBeforeCdata2(c);
	        } else if (this._state === BEFORE_CDATA_3) {
	            this._stateBeforeCdata3(c);
	        } else if (this._state === BEFORE_CDATA_4) {
	            this._stateBeforeCdata4(c);
	        } else if (this._state === BEFORE_CDATA_5) {
	            this._stateBeforeCdata5(c);
	        } else if (this._state === BEFORE_CDATA_6) {
	            this._stateBeforeCdata6(c);
	        } else if (this._state === IN_CDATA) {
	            this._stateInCdata(c);
	        } else if (this._state === AFTER_CDATA_1) {
	            this._stateAfterCdata1(c);
	        } else if (this._state === AFTER_CDATA_2) {
	            this._stateAfterCdata2(c);
	        } else if (this._state === BEFORE_SPECIAL) {
	
	        /*
			* special tags
			*/
	            this._stateBeforeSpecial(c);
	        } else if (this._state === BEFORE_SPECIAL_END) {
	            this._stateBeforeSpecialEnd(c);
	        } else if (this._state === BEFORE_SCRIPT_1) {
	
	        /*
			* script
			*/
	            this._stateBeforeScript1(c);
	        } else if (this._state === BEFORE_SCRIPT_2) {
	            this._stateBeforeScript2(c);
	        } else if (this._state === BEFORE_SCRIPT_3) {
	            this._stateBeforeScript3(c);
	        } else if (this._state === BEFORE_SCRIPT_4) {
	            this._stateBeforeScript4(c);
	        } else if (this._state === BEFORE_SCRIPT_5) {
	            this._stateBeforeScript5(c);
	        } else if (this._state === AFTER_SCRIPT_1) {
	            this._stateAfterScript1(c);
	        } else if (this._state === AFTER_SCRIPT_2) {
	            this._stateAfterScript2(c);
	        } else if (this._state === AFTER_SCRIPT_3) {
	            this._stateAfterScript3(c);
	        } else if (this._state === AFTER_SCRIPT_4) {
	            this._stateAfterScript4(c);
	        } else if (this._state === AFTER_SCRIPT_5) {
	            this._stateAfterScript5(c);
	        } else if (this._state === BEFORE_STYLE_1) {
	
	        /*
			* style
			*/
	            this._stateBeforeStyle1(c);
	        } else if (this._state === BEFORE_STYLE_2) {
	            this._stateBeforeStyle2(c);
	        } else if (this._state === BEFORE_STYLE_3) {
	            this._stateBeforeStyle3(c);
	        } else if (this._state === BEFORE_STYLE_4) {
	            this._stateBeforeStyle4(c);
	        } else if (this._state === AFTER_STYLE_1) {
	            this._stateAfterStyle1(c);
	        } else if (this._state === AFTER_STYLE_2) {
	            this._stateAfterStyle2(c);
	        } else if (this._state === AFTER_STYLE_3) {
	            this._stateAfterStyle3(c);
	        } else if (this._state === AFTER_STYLE_4) {
	            this._stateAfterStyle4(c);
	        } else if (this._state === BEFORE_ENTITY) {
	
	        /*
			* entities
			*/
	            this._stateBeforeEntity(c);
	        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
	            this._stateBeforeNumericEntity(c);
	        } else if (this._state === IN_NAMED_ENTITY) {
	            this._stateInNamedEntity(c);
	        } else if (this._state === IN_NUMERIC_ENTITY) {
	            this._stateInNumericEntity(c);
	        } else if (this._state === IN_HEX_ENTITY) {
	            this._stateInHexEntity(c);
	        } else {
	            this._cbs.onerror(Error("unknown _state"), this._state);
	        }
	
	        this._index++;
	    }
	
	    this._cleanup();
	};
	
	Tokenizer.prototype.pause = function() {
	    this._running = false;
	};
	Tokenizer.prototype.resume = function() {
	    this._running = true;
	
	    if (this._index < this._buffer.length) {
	        this._parse();
	    }
	    if (this._ended) {
	        this._finish();
	    }
	};
	
	Tokenizer.prototype.end = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
	    if (chunk) this.write(chunk);
	
	    this._ended = true;
	
	    if (this._running) this._finish();
	};
	
	Tokenizer.prototype._finish = function() {
	    //if there is remaining data, emit it in a reasonable way
	    if (this._sectionStart < this._index) {
	        this._handleTrailingData();
	    }
	
	    this._cbs.onend();
	};
	
	Tokenizer.prototype._handleTrailingData = function() {
	    var data = this._buffer.substr(this._sectionStart);
	
	    if (
	        this._state === IN_CDATA ||
	        this._state === AFTER_CDATA_1 ||
	        this._state === AFTER_CDATA_2
	    ) {
	        this._cbs.oncdata(data);
	    } else if (
	        this._state === IN_COMMENT ||
	        this._state === AFTER_COMMENT_1 ||
	        this._state === AFTER_COMMENT_2
	    ) {
	        this._cbs.oncomment(data);
	    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
	        this._parseLegacyEntity();
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(2, 10);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(3, 16);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (
	        this._state !== IN_TAG_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_VALUE &&
	        this._state !== AFTER_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
	        this._state !== IN_CLOSING_TAG_NAME
	    ) {
	        this._cbs.ontext(data);
	    }
	    //else, ignore remaining data
	    //TODO add a way to remove current tag
	};
	
	Tokenizer.prototype.reset = function() {
	    Tokenizer.call(
	        this,
	        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
	        this._cbs
	    );
	};
	
	Tokenizer.prototype.getAbsoluteIndex = function() {
	    return this._bufferOffset + this._index;
	};
	
	Tokenizer.prototype._getSection = function() {
	    return this._buffer.substring(this._sectionStart, this._index);
	};
	
	Tokenizer.prototype._emitToken = function(name) {
	    this._cbs[name](this._getSection());
	    this._sectionStart = -1;
	};
	
	Tokenizer.prototype._emitPartial = function(value) {
	    if (this._baseState !== TEXT) {
	        this._cbs.onattribdata(value); //TODO implement the new event
	    } else {
	        this._cbs.ontext(value);
	    }
	};


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(243);
	var WritableStream = __webpack_require__(1183).Writable;
	var StringDecoder = __webpack_require__(1041).StringDecoder;
	var Buffer = __webpack_require__(99).Buffer;
	
	function Stream(cbs, options) {
	    var parser = (this._parser = new Parser(cbs, options));
	    var decoder = (this._decoder = new StringDecoder());
	
	    WritableStream.call(this, { decodeStrings: false });
	
	    this.once("finish", function() {
	        parser.end(decoder.end());
	    });
	}
	
	__webpack_require__(118)(Stream, WritableStream);
	
	Stream.prototype._write = function(chunk, encoding, cb) {
	    if (chunk instanceof Buffer) chunk = this._decoder.write(chunk);
	    this._parser.write(chunk);
	    cb();
	};


/***/ },
/* 246 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Abreve": "Ă",
		"abreve": "ă",
		"ac": "∾",
		"acd": "∿",
		"acE": "∾̳",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"Acy": "А",
		"acy": "а",
		"AElig": "Æ",
		"aelig": "æ",
		"af": "⁡",
		"Afr": "𝔄",
		"afr": "𝔞",
		"Agrave": "À",
		"agrave": "à",
		"alefsym": "ℵ",
		"aleph": "ℵ",
		"Alpha": "Α",
		"alpha": "α",
		"Amacr": "Ā",
		"amacr": "ā",
		"amalg": "⨿",
		"amp": "&",
		"AMP": "&",
		"andand": "⩕",
		"And": "⩓",
		"and": "∧",
		"andd": "⩜",
		"andslope": "⩘",
		"andv": "⩚",
		"ang": "∠",
		"ange": "⦤",
		"angle": "∠",
		"angmsdaa": "⦨",
		"angmsdab": "⦩",
		"angmsdac": "⦪",
		"angmsdad": "⦫",
		"angmsdae": "⦬",
		"angmsdaf": "⦭",
		"angmsdag": "⦮",
		"angmsdah": "⦯",
		"angmsd": "∡",
		"angrt": "∟",
		"angrtvb": "⊾",
		"angrtvbd": "⦝",
		"angsph": "∢",
		"angst": "Å",
		"angzarr": "⍼",
		"Aogon": "Ą",
		"aogon": "ą",
		"Aopf": "𝔸",
		"aopf": "𝕒",
		"apacir": "⩯",
		"ap": "≈",
		"apE": "⩰",
		"ape": "≊",
		"apid": "≋",
		"apos": "'",
		"ApplyFunction": "⁡",
		"approx": "≈",
		"approxeq": "≊",
		"Aring": "Å",
		"aring": "å",
		"Ascr": "𝒜",
		"ascr": "𝒶",
		"Assign": "≔",
		"ast": "*",
		"asymp": "≈",
		"asympeq": "≍",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"awconint": "∳",
		"awint": "⨑",
		"backcong": "≌",
		"backepsilon": "϶",
		"backprime": "‵",
		"backsim": "∽",
		"backsimeq": "⋍",
		"Backslash": "∖",
		"Barv": "⫧",
		"barvee": "⊽",
		"barwed": "⌅",
		"Barwed": "⌆",
		"barwedge": "⌅",
		"bbrk": "⎵",
		"bbrktbrk": "⎶",
		"bcong": "≌",
		"Bcy": "Б",
		"bcy": "б",
		"bdquo": "„",
		"becaus": "∵",
		"because": "∵",
		"Because": "∵",
		"bemptyv": "⦰",
		"bepsi": "϶",
		"bernou": "ℬ",
		"Bernoullis": "ℬ",
		"Beta": "Β",
		"beta": "β",
		"beth": "ℶ",
		"between": "≬",
		"Bfr": "𝔅",
		"bfr": "𝔟",
		"bigcap": "⋂",
		"bigcirc": "◯",
		"bigcup": "⋃",
		"bigodot": "⨀",
		"bigoplus": "⨁",
		"bigotimes": "⨂",
		"bigsqcup": "⨆",
		"bigstar": "★",
		"bigtriangledown": "▽",
		"bigtriangleup": "△",
		"biguplus": "⨄",
		"bigvee": "⋁",
		"bigwedge": "⋀",
		"bkarow": "⤍",
		"blacklozenge": "⧫",
		"blacksquare": "▪",
		"blacktriangle": "▴",
		"blacktriangledown": "▾",
		"blacktriangleleft": "◂",
		"blacktriangleright": "▸",
		"blank": "␣",
		"blk12": "▒",
		"blk14": "░",
		"blk34": "▓",
		"block": "█",
		"bne": "=⃥",
		"bnequiv": "≡⃥",
		"bNot": "⫭",
		"bnot": "⌐",
		"Bopf": "𝔹",
		"bopf": "𝕓",
		"bot": "⊥",
		"bottom": "⊥",
		"bowtie": "⋈",
		"boxbox": "⧉",
		"boxdl": "┐",
		"boxdL": "╕",
		"boxDl": "╖",
		"boxDL": "╗",
		"boxdr": "┌",
		"boxdR": "╒",
		"boxDr": "╓",
		"boxDR": "╔",
		"boxh": "─",
		"boxH": "═",
		"boxhd": "┬",
		"boxHd": "╤",
		"boxhD": "╥",
		"boxHD": "╦",
		"boxhu": "┴",
		"boxHu": "╧",
		"boxhU": "╨",
		"boxHU": "╩",
		"boxminus": "⊟",
		"boxplus": "⊞",
		"boxtimes": "⊠",
		"boxul": "┘",
		"boxuL": "╛",
		"boxUl": "╜",
		"boxUL": "╝",
		"boxur": "└",
		"boxuR": "╘",
		"boxUr": "╙",
		"boxUR": "╚",
		"boxv": "│",
		"boxV": "║",
		"boxvh": "┼",
		"boxvH": "╪",
		"boxVh": "╫",
		"boxVH": "╬",
		"boxvl": "┤",
		"boxvL": "╡",
		"boxVl": "╢",
		"boxVL": "╣",
		"boxvr": "├",
		"boxvR": "╞",
		"boxVr": "╟",
		"boxVR": "╠",
		"bprime": "‵",
		"breve": "˘",
		"Breve": "˘",
		"brvbar": "¦",
		"bscr": "𝒷",
		"Bscr": "ℬ",
		"bsemi": "⁏",
		"bsim": "∽",
		"bsime": "⋍",
		"bsolb": "⧅",
		"bsol": "\\",
		"bsolhsub": "⟈",
		"bull": "•",
		"bullet": "•",
		"bump": "≎",
		"bumpE": "⪮",
		"bumpe": "≏",
		"Bumpeq": "≎",
		"bumpeq": "≏",
		"Cacute": "Ć",
		"cacute": "ć",
		"capand": "⩄",
		"capbrcup": "⩉",
		"capcap": "⩋",
		"cap": "∩",
		"Cap": "⋒",
		"capcup": "⩇",
		"capdot": "⩀",
		"CapitalDifferentialD": "ⅅ",
		"caps": "∩︀",
		"caret": "⁁",
		"caron": "ˇ",
		"Cayleys": "ℭ",
		"ccaps": "⩍",
		"Ccaron": "Č",
		"ccaron": "č",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"Ccirc": "Ĉ",
		"ccirc": "ĉ",
		"Cconint": "∰",
		"ccups": "⩌",
		"ccupssm": "⩐",
		"Cdot": "Ċ",
		"cdot": "ċ",
		"cedil": "¸",
		"Cedilla": "¸",
		"cemptyv": "⦲",
		"cent": "¢",
		"centerdot": "·",
		"CenterDot": "·",
		"cfr": "𝔠",
		"Cfr": "ℭ",
		"CHcy": "Ч",
		"chcy": "ч",
		"check": "✓",
		"checkmark": "✓",
		"Chi": "Χ",
		"chi": "χ",
		"circ": "ˆ",
		"circeq": "≗",
		"circlearrowleft": "↺",
		"circlearrowright": "↻",
		"circledast": "⊛",
		"circledcirc": "⊚",
		"circleddash": "⊝",
		"CircleDot": "⊙",
		"circledR": "®",
		"circledS": "Ⓢ",
		"CircleMinus": "⊖",
		"CirclePlus": "⊕",
		"CircleTimes": "⊗",
		"cir": "○",
		"cirE": "⧃",
		"cire": "≗",
		"cirfnint": "⨐",
		"cirmid": "⫯",
		"cirscir": "⧂",
		"ClockwiseContourIntegral": "∲",
		"CloseCurlyDoubleQuote": "”",
		"CloseCurlyQuote": "’",
		"clubs": "♣",
		"clubsuit": "♣",
		"colon": ":",
		"Colon": "∷",
		"Colone": "⩴",
		"colone": "≔",
		"coloneq": "≔",
		"comma": ",",
		"commat": "@",
		"comp": "∁",
		"compfn": "∘",
		"complement": "∁",
		"complexes": "ℂ",
		"cong": "≅",
		"congdot": "⩭",
		"Congruent": "≡",
		"conint": "∮",
		"Conint": "∯",
		"ContourIntegral": "∮",
		"copf": "𝕔",
		"Copf": "ℂ",
		"coprod": "∐",
		"Coproduct": "∐",
		"copy": "©",
		"COPY": "©",
		"copysr": "℗",
		"CounterClockwiseContourIntegral": "∳",
		"crarr": "↵",
		"cross": "✗",
		"Cross": "⨯",
		"Cscr": "𝒞",
		"cscr": "𝒸",
		"csub": "⫏",
		"csube": "⫑",
		"csup": "⫐",
		"csupe": "⫒",
		"ctdot": "⋯",
		"cudarrl": "⤸",
		"cudarrr": "⤵",
		"cuepr": "⋞",
		"cuesc": "⋟",
		"cularr": "↶",
		"cularrp": "⤽",
		"cupbrcap": "⩈",
		"cupcap": "⩆",
		"CupCap": "≍",
		"cup": "∪",
		"Cup": "⋓",
		"cupcup": "⩊",
		"cupdot": "⊍",
		"cupor": "⩅",
		"cups": "∪︀",
		"curarr": "↷",
		"curarrm": "⤼",
		"curlyeqprec": "⋞",
		"curlyeqsucc": "⋟",
		"curlyvee": "⋎",
		"curlywedge": "⋏",
		"curren": "¤",
		"curvearrowleft": "↶",
		"curvearrowright": "↷",
		"cuvee": "⋎",
		"cuwed": "⋏",
		"cwconint": "∲",
		"cwint": "∱",
		"cylcty": "⌭",
		"dagger": "†",
		"Dagger": "‡",
		"daleth": "ℸ",
		"darr": "↓",
		"Darr": "↡",
		"dArr": "⇓",
		"dash": "‐",
		"Dashv": "⫤",
		"dashv": "⊣",
		"dbkarow": "⤏",
		"dblac": "˝",
		"Dcaron": "Ď",
		"dcaron": "ď",
		"Dcy": "Д",
		"dcy": "д",
		"ddagger": "‡",
		"ddarr": "⇊",
		"DD": "ⅅ",
		"dd": "ⅆ",
		"DDotrahd": "⤑",
		"ddotseq": "⩷",
		"deg": "°",
		"Del": "∇",
		"Delta": "Δ",
		"delta": "δ",
		"demptyv": "⦱",
		"dfisht": "⥿",
		"Dfr": "𝔇",
		"dfr": "𝔡",
		"dHar": "⥥",
		"dharl": "⇃",
		"dharr": "⇂",
		"DiacriticalAcute": "´",
		"DiacriticalDot": "˙",
		"DiacriticalDoubleAcute": "˝",
		"DiacriticalGrave": "`",
		"DiacriticalTilde": "˜",
		"diam": "⋄",
		"diamond": "⋄",
		"Diamond": "⋄",
		"diamondsuit": "♦",
		"diams": "♦",
		"die": "¨",
		"DifferentialD": "ⅆ",
		"digamma": "ϝ",
		"disin": "⋲",
		"div": "÷",
		"divide": "÷",
		"divideontimes": "⋇",
		"divonx": "⋇",
		"DJcy": "Ђ",
		"djcy": "ђ",
		"dlcorn": "⌞",
		"dlcrop": "⌍",
		"dollar": "$",
		"Dopf": "𝔻",
		"dopf": "𝕕",
		"Dot": "¨",
		"dot": "˙",
		"DotDot": "⃜",
		"doteq": "≐",
		"doteqdot": "≑",
		"DotEqual": "≐",
		"dotminus": "∸",
		"dotplus": "∔",
		"dotsquare": "⊡",
		"doublebarwedge": "⌆",
		"DoubleContourIntegral": "∯",
		"DoubleDot": "¨",
		"DoubleDownArrow": "⇓",
		"DoubleLeftArrow": "⇐",
		"DoubleLeftRightArrow": "⇔",
		"DoubleLeftTee": "⫤",
		"DoubleLongLeftArrow": "⟸",
		"DoubleLongLeftRightArrow": "⟺",
		"DoubleLongRightArrow": "⟹",
		"DoubleRightArrow": "⇒",
		"DoubleRightTee": "⊨",
		"DoubleUpArrow": "⇑",
		"DoubleUpDownArrow": "⇕",
		"DoubleVerticalBar": "∥",
		"DownArrowBar": "⤓",
		"downarrow": "↓",
		"DownArrow": "↓",
		"Downarrow": "⇓",
		"DownArrowUpArrow": "⇵",
		"DownBreve": "̑",
		"downdownarrows": "⇊",
		"downharpoonleft": "⇃",
		"downharpoonright": "⇂",
		"DownLeftRightVector": "⥐",
		"DownLeftTeeVector": "⥞",
		"DownLeftVectorBar": "⥖",
		"DownLeftVector": "↽",
		"DownRightTeeVector": "⥟",
		"DownRightVectorBar": "⥗",
		"DownRightVector": "⇁",
		"DownTeeArrow": "↧",
		"DownTee": "⊤",
		"drbkarow": "⤐",
		"drcorn": "⌟",
		"drcrop": "⌌",
		"Dscr": "𝒟",
		"dscr": "𝒹",
		"DScy": "Ѕ",
		"dscy": "ѕ",
		"dsol": "⧶",
		"Dstrok": "Đ",
		"dstrok": "đ",
		"dtdot": "⋱",
		"dtri": "▿",
		"dtrif": "▾",
		"duarr": "⇵",
		"duhar": "⥯",
		"dwangle": "⦦",
		"DZcy": "Џ",
		"dzcy": "џ",
		"dzigrarr": "⟿",
		"Eacute": "É",
		"eacute": "é",
		"easter": "⩮",
		"Ecaron": "Ě",
		"ecaron": "ě",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"ecir": "≖",
		"ecolon": "≕",
		"Ecy": "Э",
		"ecy": "э",
		"eDDot": "⩷",
		"Edot": "Ė",
		"edot": "ė",
		"eDot": "≑",
		"ee": "ⅇ",
		"efDot": "≒",
		"Efr": "𝔈",
		"efr": "𝔢",
		"eg": "⪚",
		"Egrave": "È",
		"egrave": "è",
		"egs": "⪖",
		"egsdot": "⪘",
		"el": "⪙",
		"Element": "∈",
		"elinters": "⏧",
		"ell": "ℓ",
		"els": "⪕",
		"elsdot": "⪗",
		"Emacr": "Ē",
		"emacr": "ē",
		"empty": "∅",
		"emptyset": "∅",
		"EmptySmallSquare": "◻",
		"emptyv": "∅",
		"EmptyVerySmallSquare": "▫",
		"emsp13": " ",
		"emsp14": " ",
		"emsp": " ",
		"ENG": "Ŋ",
		"eng": "ŋ",
		"ensp": " ",
		"Eogon": "Ę",
		"eogon": "ę",
		"Eopf": "𝔼",
		"eopf": "𝕖",
		"epar": "⋕",
		"eparsl": "⧣",
		"eplus": "⩱",
		"epsi": "ε",
		"Epsilon": "Ε",
		"epsilon": "ε",
		"epsiv": "ϵ",
		"eqcirc": "≖",
		"eqcolon": "≕",
		"eqsim": "≂",
		"eqslantgtr": "⪖",
		"eqslantless": "⪕",
		"Equal": "⩵",
		"equals": "=",
		"EqualTilde": "≂",
		"equest": "≟",
		"Equilibrium": "⇌",
		"equiv": "≡",
		"equivDD": "⩸",
		"eqvparsl": "⧥",
		"erarr": "⥱",
		"erDot": "≓",
		"escr": "ℯ",
		"Escr": "ℰ",
		"esdot": "≐",
		"Esim": "⩳",
		"esim": "≂",
		"Eta": "Η",
		"eta": "η",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"euro": "€",
		"excl": "!",
		"exist": "∃",
		"Exists": "∃",
		"expectation": "ℰ",
		"exponentiale": "ⅇ",
		"ExponentialE": "ⅇ",
		"fallingdotseq": "≒",
		"Fcy": "Ф",
		"fcy": "ф",
		"female": "♀",
		"ffilig": "ﬃ",
		"fflig": "ﬀ",
		"ffllig": "ﬄ",
		"Ffr": "𝔉",
		"ffr": "𝔣",
		"filig": "ﬁ",
		"FilledSmallSquare": "◼",
		"FilledVerySmallSquare": "▪",
		"fjlig": "fj",
		"flat": "♭",
		"fllig": "ﬂ",
		"fltns": "▱",
		"fnof": "ƒ",
		"Fopf": "𝔽",
		"fopf": "𝕗",
		"forall": "∀",
		"ForAll": "∀",
		"fork": "⋔",
		"forkv": "⫙",
		"Fouriertrf": "ℱ",
		"fpartint": "⨍",
		"frac12": "½",
		"frac13": "⅓",
		"frac14": "¼",
		"frac15": "⅕",
		"frac16": "⅙",
		"frac18": "⅛",
		"frac23": "⅔",
		"frac25": "⅖",
		"frac34": "¾",
		"frac35": "⅗",
		"frac38": "⅜",
		"frac45": "⅘",
		"frac56": "⅚",
		"frac58": "⅝",
		"frac78": "⅞",
		"frasl": "⁄",
		"frown": "⌢",
		"fscr": "𝒻",
		"Fscr": "ℱ",
		"gacute": "ǵ",
		"Gamma": "Γ",
		"gamma": "γ",
		"Gammad": "Ϝ",
		"gammad": "ϝ",
		"gap": "⪆",
		"Gbreve": "Ğ",
		"gbreve": "ğ",
		"Gcedil": "Ģ",
		"Gcirc": "Ĝ",
		"gcirc": "ĝ",
		"Gcy": "Г",
		"gcy": "г",
		"Gdot": "Ġ",
		"gdot": "ġ",
		"ge": "≥",
		"gE": "≧",
		"gEl": "⪌",
		"gel": "⋛",
		"geq": "≥",
		"geqq": "≧",
		"geqslant": "⩾",
		"gescc": "⪩",
		"ges": "⩾",
		"gesdot": "⪀",
		"gesdoto": "⪂",
		"gesdotol": "⪄",
		"gesl": "⋛︀",
		"gesles": "⪔",
		"Gfr": "𝔊",
		"gfr": "𝔤",
		"gg": "≫",
		"Gg": "⋙",
		"ggg": "⋙",
		"gimel": "ℷ",
		"GJcy": "Ѓ",
		"gjcy": "ѓ",
		"gla": "⪥",
		"gl": "≷",
		"glE": "⪒",
		"glj": "⪤",
		"gnap": "⪊",
		"gnapprox": "⪊",
		"gne": "⪈",
		"gnE": "≩",
		"gneq": "⪈",
		"gneqq": "≩",
		"gnsim": "⋧",
		"Gopf": "𝔾",
		"gopf": "𝕘",
		"grave": "`",
		"GreaterEqual": "≥",
		"GreaterEqualLess": "⋛",
		"GreaterFullEqual": "≧",
		"GreaterGreater": "⪢",
		"GreaterLess": "≷",
		"GreaterSlantEqual": "⩾",
		"GreaterTilde": "≳",
		"Gscr": "𝒢",
		"gscr": "ℊ",
		"gsim": "≳",
		"gsime": "⪎",
		"gsiml": "⪐",
		"gtcc": "⪧",
		"gtcir": "⩺",
		"gt": ">",
		"GT": ">",
		"Gt": "≫",
		"gtdot": "⋗",
		"gtlPar": "⦕",
		"gtquest": "⩼",
		"gtrapprox": "⪆",
		"gtrarr": "⥸",
		"gtrdot": "⋗",
		"gtreqless": "⋛",
		"gtreqqless": "⪌",
		"gtrless": "≷",
		"gtrsim": "≳",
		"gvertneqq": "≩︀",
		"gvnE": "≩︀",
		"Hacek": "ˇ",
		"hairsp": " ",
		"half": "½",
		"hamilt": "ℋ",
		"HARDcy": "Ъ",
		"hardcy": "ъ",
		"harrcir": "⥈",
		"harr": "↔",
		"hArr": "⇔",
		"harrw": "↭",
		"Hat": "^",
		"hbar": "ℏ",
		"Hcirc": "Ĥ",
		"hcirc": "ĥ",
		"hearts": "♥",
		"heartsuit": "♥",
		"hellip": "…",
		"hercon": "⊹",
		"hfr": "𝔥",
		"Hfr": "ℌ",
		"HilbertSpace": "ℋ",
		"hksearow": "⤥",
		"hkswarow": "⤦",
		"hoarr": "⇿",
		"homtht": "∻",
		"hookleftarrow": "↩",
		"hookrightarrow": "↪",
		"hopf": "𝕙",
		"Hopf": "ℍ",
		"horbar": "―",
		"HorizontalLine": "─",
		"hscr": "𝒽",
		"Hscr": "ℋ",
		"hslash": "ℏ",
		"Hstrok": "Ħ",
		"hstrok": "ħ",
		"HumpDownHump": "≎",
		"HumpEqual": "≏",
		"hybull": "⁃",
		"hyphen": "‐",
		"Iacute": "Í",
		"iacute": "í",
		"ic": "⁣",
		"Icirc": "Î",
		"icirc": "î",
		"Icy": "И",
		"icy": "и",
		"Idot": "İ",
		"IEcy": "Е",
		"iecy": "е",
		"iexcl": "¡",
		"iff": "⇔",
		"ifr": "𝔦",
		"Ifr": "ℑ",
		"Igrave": "Ì",
		"igrave": "ì",
		"ii": "ⅈ",
		"iiiint": "⨌",
		"iiint": "∭",
		"iinfin": "⧜",
		"iiota": "℩",
		"IJlig": "Ĳ",
		"ijlig": "ĳ",
		"Imacr": "Ī",
		"imacr": "ī",
		"image": "ℑ",
		"ImaginaryI": "ⅈ",
		"imagline": "ℐ",
		"imagpart": "ℑ",
		"imath": "ı",
		"Im": "ℑ",
		"imof": "⊷",
		"imped": "Ƶ",
		"Implies": "⇒",
		"incare": "℅",
		"in": "∈",
		"infin": "∞",
		"infintie": "⧝",
		"inodot": "ı",
		"intcal": "⊺",
		"int": "∫",
		"Int": "∬",
		"integers": "ℤ",
		"Integral": "∫",
		"intercal": "⊺",
		"Intersection": "⋂",
		"intlarhk": "⨗",
		"intprod": "⨼",
		"InvisibleComma": "⁣",
		"InvisibleTimes": "⁢",
		"IOcy": "Ё",
		"iocy": "ё",
		"Iogon": "Į",
		"iogon": "į",
		"Iopf": "𝕀",
		"iopf": "𝕚",
		"Iota": "Ι",
		"iota": "ι",
		"iprod": "⨼",
		"iquest": "¿",
		"iscr": "𝒾",
		"Iscr": "ℐ",
		"isin": "∈",
		"isindot": "⋵",
		"isinE": "⋹",
		"isins": "⋴",
		"isinsv": "⋳",
		"isinv": "∈",
		"it": "⁢",
		"Itilde": "Ĩ",
		"itilde": "ĩ",
		"Iukcy": "І",
		"iukcy": "і",
		"Iuml": "Ï",
		"iuml": "ï",
		"Jcirc": "Ĵ",
		"jcirc": "ĵ",
		"Jcy": "Й",
		"jcy": "й",
		"Jfr": "𝔍",
		"jfr": "𝔧",
		"jmath": "ȷ",
		"Jopf": "𝕁",
		"jopf": "𝕛",
		"Jscr": "𝒥",
		"jscr": "𝒿",
		"Jsercy": "Ј",
		"jsercy": "ј",
		"Jukcy": "Є",
		"jukcy": "є",
		"Kappa": "Κ",
		"kappa": "κ",
		"kappav": "ϰ",
		"Kcedil": "Ķ",
		"kcedil": "ķ",
		"Kcy": "К",
		"kcy": "к",
		"Kfr": "𝔎",
		"kfr": "𝔨",
		"kgreen": "ĸ",
		"KHcy": "Х",
		"khcy": "х",
		"KJcy": "Ќ",
		"kjcy": "ќ",
		"Kopf": "𝕂",
		"kopf": "𝕜",
		"Kscr": "𝒦",
		"kscr": "𝓀",
		"lAarr": "⇚",
		"Lacute": "Ĺ",
		"lacute": "ĺ",
		"laemptyv": "⦴",
		"lagran": "ℒ",
		"Lambda": "Λ",
		"lambda": "λ",
		"lang": "⟨",
		"Lang": "⟪",
		"langd": "⦑",
		"langle": "⟨",
		"lap": "⪅",
		"Laplacetrf": "ℒ",
		"laquo": "«",
		"larrb": "⇤",
		"larrbfs": "⤟",
		"larr": "←",
		"Larr": "↞",
		"lArr": "⇐",
		"larrfs": "⤝",
		"larrhk": "↩",
		"larrlp": "↫",
		"larrpl": "⤹",
		"larrsim": "⥳",
		"larrtl": "↢",
		"latail": "⤙",
		"lAtail": "⤛",
		"lat": "⪫",
		"late": "⪭",
		"lates": "⪭︀",
		"lbarr": "⤌",
		"lBarr": "⤎",
		"lbbrk": "❲",
		"lbrace": "{",
		"lbrack": "[",
		"lbrke": "⦋",
		"lbrksld": "⦏",
		"lbrkslu": "⦍",
		"Lcaron": "Ľ",
		"lcaron": "ľ",
		"Lcedil": "Ļ",
		"lcedil": "ļ",
		"lceil": "⌈",
		"lcub": "{",
		"Lcy": "Л",
		"lcy": "л",
		"ldca": "⤶",
		"ldquo": "“",
		"ldquor": "„",
		"ldrdhar": "⥧",
		"ldrushar": "⥋",
		"ldsh": "↲",
		"le": "≤",
		"lE": "≦",
		"LeftAngleBracket": "⟨",
		"LeftArrowBar": "⇤",
		"leftarrow": "←",
		"LeftArrow": "←",
		"Leftarrow": "⇐",
		"LeftArrowRightArrow": "⇆",
		"leftarrowtail": "↢",
		"LeftCeiling": "⌈",
		"LeftDoubleBracket": "⟦",
		"LeftDownTeeVector": "⥡",
		"LeftDownVectorBar": "⥙",
		"LeftDownVector": "⇃",
		"LeftFloor": "⌊",
		"leftharpoondown": "↽",
		"leftharpoonup": "↼",
		"leftleftarrows": "⇇",
		"leftrightarrow": "↔",
		"LeftRightArrow": "↔",
		"Leftrightarrow": "⇔",
		"leftrightarrows": "⇆",
		"leftrightharpoons": "⇋",
		"leftrightsquigarrow": "↭",
		"LeftRightVector": "⥎",
		"LeftTeeArrow": "↤",
		"LeftTee": "⊣",
		"LeftTeeVector": "⥚",
		"leftthreetimes": "⋋",
		"LeftTriangleBar": "⧏",
		"LeftTriangle": "⊲",
		"LeftTriangleEqual": "⊴",
		"LeftUpDownVector": "⥑",
		"LeftUpTeeVector": "⥠",
		"LeftUpVectorBar": "⥘",
		"LeftUpVector": "↿",
		"LeftVectorBar": "⥒",
		"LeftVector": "↼",
		"lEg": "⪋",
		"leg": "⋚",
		"leq": "≤",
		"leqq": "≦",
		"leqslant": "⩽",
		"lescc": "⪨",
		"les": "⩽",
		"lesdot": "⩿",
		"lesdoto": "⪁",
		"lesdotor": "⪃",
		"lesg": "⋚︀",
		"lesges": "⪓",
		"lessapprox": "⪅",
		"lessdot": "⋖",
		"lesseqgtr": "⋚",
		"lesseqqgtr": "⪋",
		"LessEqualGreater": "⋚",
		"LessFullEqual": "≦",
		"LessGreater": "≶",
		"lessgtr": "≶",
		"LessLess": "⪡",
		"lesssim": "≲",
		"LessSlantEqual": "⩽",
		"LessTilde": "≲",
		"lfisht": "⥼",
		"lfloor": "⌊",
		"Lfr": "𝔏",
		"lfr": "𝔩",
		"lg": "≶",
		"lgE": "⪑",
		"lHar": "⥢",
		"lhard": "↽",
		"lharu": "↼",
		"lharul": "⥪",
		"lhblk": "▄",
		"LJcy": "Љ",
		"ljcy": "љ",
		"llarr": "⇇",
		"ll": "≪",
		"Ll": "⋘",
		"llcorner": "⌞",
		"Lleftarrow": "⇚",
		"llhard": "⥫",
		"lltri": "◺",
		"Lmidot": "Ŀ",
		"lmidot": "ŀ",
		"lmoustache": "⎰",
		"lmoust": "⎰",
		"lnap": "⪉",
		"lnapprox": "⪉",
		"lne": "⪇",
		"lnE": "≨",
		"lneq": "⪇",
		"lneqq": "≨",
		"lnsim": "⋦",
		"loang": "⟬",
		"loarr": "⇽",
		"lobrk": "⟦",
		"longleftarrow": "⟵",
		"LongLeftArrow": "⟵",
		"Longleftarrow": "⟸",
		"longleftrightarrow": "⟷",
		"LongLeftRightArrow": "⟷",
		"Longleftrightarrow": "⟺",
		"longmapsto": "⟼",
		"longrightarrow": "⟶",
		"LongRightArrow": "⟶",
		"Longrightarrow": "⟹",
		"looparrowleft": "↫",
		"looparrowright": "↬",
		"lopar": "⦅",
		"Lopf": "𝕃",
		"lopf": "𝕝",
		"loplus": "⨭",
		"lotimes": "⨴",
		"lowast": "∗",
		"lowbar": "_",
		"LowerLeftArrow": "↙",
		"LowerRightArrow": "↘",
		"loz": "◊",
		"lozenge": "◊",
		"lozf": "⧫",
		"lpar": "(",
		"lparlt": "⦓",
		"lrarr": "⇆",
		"lrcorner": "⌟",
		"lrhar": "⇋",
		"lrhard": "⥭",
		"lrm": "‎",
		"lrtri": "⊿",
		"lsaquo": "‹",
		"lscr": "𝓁",
		"Lscr": "ℒ",
		"lsh": "↰",
		"Lsh": "↰",
		"lsim": "≲",
		"lsime": "⪍",
		"lsimg": "⪏",
		"lsqb": "[",
		"lsquo": "‘",
		"lsquor": "‚",
		"Lstrok": "Ł",
		"lstrok": "ł",
		"ltcc": "⪦",
		"ltcir": "⩹",
		"lt": "<",
		"LT": "<",
		"Lt": "≪",
		"ltdot": "⋖",
		"lthree": "⋋",
		"ltimes": "⋉",
		"ltlarr": "⥶",
		"ltquest": "⩻",
		"ltri": "◃",
		"ltrie": "⊴",
		"ltrif": "◂",
		"ltrPar": "⦖",
		"lurdshar": "⥊",
		"luruhar": "⥦",
		"lvertneqq": "≨︀",
		"lvnE": "≨︀",
		"macr": "¯",
		"male": "♂",
		"malt": "✠",
		"maltese": "✠",
		"Map": "⤅",
		"map": "↦",
		"mapsto": "↦",
		"mapstodown": "↧",
		"mapstoleft": "↤",
		"mapstoup": "↥",
		"marker": "▮",
		"mcomma": "⨩",
		"Mcy": "М",
		"mcy": "м",
		"mdash": "—",
		"mDDot": "∺",
		"measuredangle": "∡",
		"MediumSpace": " ",
		"Mellintrf": "ℳ",
		"Mfr": "𝔐",
		"mfr": "𝔪",
		"mho": "℧",
		"micro": "µ",
		"midast": "*",
		"midcir": "⫰",
		"mid": "∣",
		"middot": "·",
		"minusb": "⊟",
		"minus": "−",
		"minusd": "∸",
		"minusdu": "⨪",
		"MinusPlus": "∓",
		"mlcp": "⫛",
		"mldr": "…",
		"mnplus": "∓",
		"models": "⊧",
		"Mopf": "𝕄",
		"mopf": "𝕞",
		"mp": "∓",
		"mscr": "𝓂",
		"Mscr": "ℳ",
		"mstpos": "∾",
		"Mu": "Μ",
		"mu": "μ",
		"multimap": "⊸",
		"mumap": "⊸",
		"nabla": "∇",
		"Nacute": "Ń",
		"nacute": "ń",
		"nang": "∠⃒",
		"nap": "≉",
		"napE": "⩰̸",
		"napid": "≋̸",
		"napos": "ŉ",
		"napprox": "≉",
		"natural": "♮",
		"naturals": "ℕ",
		"natur": "♮",
		"nbsp": " ",
		"nbump": "≎̸",
		"nbumpe": "≏̸",
		"ncap": "⩃",
		"Ncaron": "Ň",
		"ncaron": "ň",
		"Ncedil": "Ņ",
		"ncedil": "ņ",
		"ncong": "≇",
		"ncongdot": "⩭̸",
		"ncup": "⩂",
		"Ncy": "Н",
		"ncy": "н",
		"ndash": "–",
		"nearhk": "⤤",
		"nearr": "↗",
		"neArr": "⇗",
		"nearrow": "↗",
		"ne": "≠",
		"nedot": "≐̸",
		"NegativeMediumSpace": "​",
		"NegativeThickSpace": "​",
		"NegativeThinSpace": "​",
		"NegativeVeryThinSpace": "​",
		"nequiv": "≢",
		"nesear": "⤨",
		"nesim": "≂̸",
		"NestedGreaterGreater": "≫",
		"NestedLessLess": "≪",
		"NewLine": "\n",
		"nexist": "∄",
		"nexists": "∄",
		"Nfr": "𝔑",
		"nfr": "𝔫",
		"ngE": "≧̸",
		"nge": "≱",
		"ngeq": "≱",
		"ngeqq": "≧̸",
		"ngeqslant": "⩾̸",
		"nges": "⩾̸",
		"nGg": "⋙̸",
		"ngsim": "≵",
		"nGt": "≫⃒",
		"ngt": "≯",
		"ngtr": "≯",
		"nGtv": "≫̸",
		"nharr": "↮",
		"nhArr": "⇎",
		"nhpar": "⫲",
		"ni": "∋",
		"nis": "⋼",
		"nisd": "⋺",
		"niv": "∋",
		"NJcy": "Њ",
		"njcy": "њ",
		"nlarr": "↚",
		"nlArr": "⇍",
		"nldr": "‥",
		"nlE": "≦̸",
		"nle": "≰",
		"nleftarrow": "↚",
		"nLeftarrow": "⇍",
		"nleftrightarrow": "↮",
		"nLeftrightarrow": "⇎",
		"nleq": "≰",
		"nleqq": "≦̸",
		"nleqslant": "⩽̸",
		"nles": "⩽̸",
		"nless": "≮",
		"nLl": "⋘̸",
		"nlsim": "≴",
		"nLt": "≪⃒",
		"nlt": "≮",
		"nltri": "⋪",
		"nltrie": "⋬",
		"nLtv": "≪̸",
		"nmid": "∤",
		"NoBreak": "⁠",
		"NonBreakingSpace": " ",
		"nopf": "𝕟",
		"Nopf": "ℕ",
		"Not": "⫬",
		"not": "¬",
		"NotCongruent": "≢",
		"NotCupCap": "≭",
		"NotDoubleVerticalBar": "∦",
		"NotElement": "∉",
		"NotEqual": "≠",
		"NotEqualTilde": "≂̸",
		"NotExists": "∄",
		"NotGreater": "≯",
		"NotGreaterEqual": "≱",
		"NotGreaterFullEqual": "≧̸",
		"NotGreaterGreater": "≫̸",
		"NotGreaterLess": "≹",
		"NotGreaterSlantEqual": "⩾̸",
		"NotGreaterTilde": "≵",
		"NotHumpDownHump": "≎̸",
		"NotHumpEqual": "≏̸",
		"notin": "∉",
		"notindot": "⋵̸",
		"notinE": "⋹̸",
		"notinva": "∉",
		"notinvb": "⋷",
		"notinvc": "⋶",
		"NotLeftTriangleBar": "⧏̸",
		"NotLeftTriangle": "⋪",
		"NotLeftTriangleEqual": "⋬",
		"NotLess": "≮",
		"NotLessEqual": "≰",
		"NotLessGreater": "≸",
		"NotLessLess": "≪̸",
		"NotLessSlantEqual": "⩽̸",
		"NotLessTilde": "≴",
		"NotNestedGreaterGreater": "⪢̸",
		"NotNestedLessLess": "⪡̸",
		"notni": "∌",
		"notniva": "∌",
		"notnivb": "⋾",
		"notnivc": "⋽",
		"NotPrecedes": "⊀",
		"NotPrecedesEqual": "⪯̸",
		"NotPrecedesSlantEqual": "⋠",
		"NotReverseElement": "∌",
		"NotRightTriangleBar": "⧐̸",
		"NotRightTriangle": "⋫",
		"NotRightTriangleEqual": "⋭",
		"NotSquareSubset": "⊏̸",
		"NotSquareSubsetEqual": "⋢",
		"NotSquareSuperset": "⊐̸",
		"NotSquareSupersetEqual": "⋣",
		"NotSubset": "⊂⃒",
		"NotSubsetEqual": "⊈",
		"NotSucceeds": "⊁",
		"NotSucceedsEqual": "⪰̸",
		"NotSucceedsSlantEqual": "⋡",
		"NotSucceedsTilde": "≿̸",
		"NotSuperset": "⊃⃒",
		"NotSupersetEqual": "⊉",
		"NotTilde": "≁",
		"NotTildeEqual": "≄",
		"NotTildeFullEqual": "≇",
		"NotTildeTilde": "≉",
		"NotVerticalBar": "∤",
		"nparallel": "∦",
		"npar": "∦",
		"nparsl": "⫽⃥",
		"npart": "∂̸",
		"npolint": "⨔",
		"npr": "⊀",
		"nprcue": "⋠",
		"nprec": "⊀",
		"npreceq": "⪯̸",
		"npre": "⪯̸",
		"nrarrc": "⤳̸",
		"nrarr": "↛",
		"nrArr": "⇏",
		"nrarrw": "↝̸",
		"nrightarrow": "↛",
		"nRightarrow": "⇏",
		"nrtri": "⋫",
		"nrtrie": "⋭",
		"nsc": "⊁",
		"nsccue": "⋡",
		"nsce": "⪰̸",
		"Nscr": "𝒩",
		"nscr": "𝓃",
		"nshortmid": "∤",
		"nshortparallel": "∦",
		"nsim": "≁",
		"nsime": "≄",
		"nsimeq": "≄",
		"nsmid": "∤",
		"nspar": "∦",
		"nsqsube": "⋢",
		"nsqsupe": "⋣",
		"nsub": "⊄",
		"nsubE": "⫅̸",
		"nsube": "⊈",
		"nsubset": "⊂⃒",
		"nsubseteq": "⊈",
		"nsubseteqq": "⫅̸",
		"nsucc": "⊁",
		"nsucceq": "⪰̸",
		"nsup": "⊅",
		"nsupE": "⫆̸",
		"nsupe": "⊉",
		"nsupset": "⊃⃒",
		"nsupseteq": "⊉",
		"nsupseteqq": "⫆̸",
		"ntgl": "≹",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"ntlg": "≸",
		"ntriangleleft": "⋪",
		"ntrianglelefteq": "⋬",
		"ntriangleright": "⋫",
		"ntrianglerighteq": "⋭",
		"Nu": "Ν",
		"nu": "ν",
		"num": "#",
		"numero": "№",
		"numsp": " ",
		"nvap": "≍⃒",
		"nvdash": "⊬",
		"nvDash": "⊭",
		"nVdash": "⊮",
		"nVDash": "⊯",
		"nvge": "≥⃒",
		"nvgt": ">⃒",
		"nvHarr": "⤄",
		"nvinfin": "⧞",
		"nvlArr": "⤂",
		"nvle": "≤⃒",
		"nvlt": "<⃒",
		"nvltrie": "⊴⃒",
		"nvrArr": "⤃",
		"nvrtrie": "⊵⃒",
		"nvsim": "∼⃒",
		"nwarhk": "⤣",
		"nwarr": "↖",
		"nwArr": "⇖",
		"nwarrow": "↖",
		"nwnear": "⤧",
		"Oacute": "Ó",
		"oacute": "ó",
		"oast": "⊛",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"ocir": "⊚",
		"Ocy": "О",
		"ocy": "о",
		"odash": "⊝",
		"Odblac": "Ő",
		"odblac": "ő",
		"odiv": "⨸",
		"odot": "⊙",
		"odsold": "⦼",
		"OElig": "Œ",
		"oelig": "œ",
		"ofcir": "⦿",
		"Ofr": "𝔒",
		"ofr": "𝔬",
		"ogon": "˛",
		"Ograve": "Ò",
		"ograve": "ò",
		"ogt": "⧁",
		"ohbar": "⦵",
		"ohm": "Ω",
		"oint": "∮",
		"olarr": "↺",
		"olcir": "⦾",
		"olcross": "⦻",
		"oline": "‾",
		"olt": "⧀",
		"Omacr": "Ō",
		"omacr": "ō",
		"Omega": "Ω",
		"omega": "ω",
		"Omicron": "Ο",
		"omicron": "ο",
		"omid": "⦶",
		"ominus": "⊖",
		"Oopf": "𝕆",
		"oopf": "𝕠",
		"opar": "⦷",
		"OpenCurlyDoubleQuote": "“",
		"OpenCurlyQuote": "‘",
		"operp": "⦹",
		"oplus": "⊕",
		"orarr": "↻",
		"Or": "⩔",
		"or": "∨",
		"ord": "⩝",
		"order": "ℴ",
		"orderof": "ℴ",
		"ordf": "ª",
		"ordm": "º",
		"origof": "⊶",
		"oror": "⩖",
		"orslope": "⩗",
		"orv": "⩛",
		"oS": "Ⓢ",
		"Oscr": "𝒪",
		"oscr": "ℴ",
		"Oslash": "Ø",
		"oslash": "ø",
		"osol": "⊘",
		"Otilde": "Õ",
		"otilde": "õ",
		"otimesas": "⨶",
		"Otimes": "⨷",
		"otimes": "⊗",
		"Ouml": "Ö",
		"ouml": "ö",
		"ovbar": "⌽",
		"OverBar": "‾",
		"OverBrace": "⏞",
		"OverBracket": "⎴",
		"OverParenthesis": "⏜",
		"para": "¶",
		"parallel": "∥",
		"par": "∥",
		"parsim": "⫳",
		"parsl": "⫽",
		"part": "∂",
		"PartialD": "∂",
		"Pcy": "П",
		"pcy": "п",
		"percnt": "%",
		"period": ".",
		"permil": "‰",
		"perp": "⊥",
		"pertenk": "‱",
		"Pfr": "𝔓",
		"pfr": "𝔭",
		"Phi": "Φ",
		"phi": "φ",
		"phiv": "ϕ",
		"phmmat": "ℳ",
		"phone": "☎",
		"Pi": "Π",
		"pi": "π",
		"pitchfork": "⋔",
		"piv": "ϖ",
		"planck": "ℏ",
		"planckh": "ℎ",
		"plankv": "ℏ",
		"plusacir": "⨣",
		"plusb": "⊞",
		"pluscir": "⨢",
		"plus": "+",
		"plusdo": "∔",
		"plusdu": "⨥",
		"pluse": "⩲",
		"PlusMinus": "±",
		"plusmn": "±",
		"plussim": "⨦",
		"plustwo": "⨧",
		"pm": "±",
		"Poincareplane": "ℌ",
		"pointint": "⨕",
		"popf": "𝕡",
		"Popf": "ℙ",
		"pound": "£",
		"prap": "⪷",
		"Pr": "⪻",
		"pr": "≺",
		"prcue": "≼",
		"precapprox": "⪷",
		"prec": "≺",
		"preccurlyeq": "≼",
		"Precedes": "≺",
		"PrecedesEqual": "⪯",
		"PrecedesSlantEqual": "≼",
		"PrecedesTilde": "≾",
		"preceq": "⪯",
		"precnapprox": "⪹",
		"precneqq": "⪵",
		"precnsim": "⋨",
		"pre": "⪯",
		"prE": "⪳",
		"precsim": "≾",
		"prime": "′",
		"Prime": "″",
		"primes": "ℙ",
		"prnap": "⪹",
		"prnE": "⪵",
		"prnsim": "⋨",
		"prod": "∏",
		"Product": "∏",
		"profalar": "⌮",
		"profline": "⌒",
		"profsurf": "⌓",
		"prop": "∝",
		"Proportional": "∝",
		"Proportion": "∷",
		"propto": "∝",
		"prsim": "≾",
		"prurel": "⊰",
		"Pscr": "𝒫",
		"pscr": "𝓅",
		"Psi": "Ψ",
		"psi": "ψ",
		"puncsp": " ",
		"Qfr": "𝔔",
		"qfr": "𝔮",
		"qint": "⨌",
		"qopf": "𝕢",
		"Qopf": "ℚ",
		"qprime": "⁗",
		"Qscr": "𝒬",
		"qscr": "𝓆",
		"quaternions": "ℍ",
		"quatint": "⨖",
		"quest": "?",
		"questeq": "≟",
		"quot": "\"",
		"QUOT": "\"",
		"rAarr": "⇛",
		"race": "∽̱",
		"Racute": "Ŕ",
		"racute": "ŕ",
		"radic": "√",
		"raemptyv": "⦳",
		"rang": "⟩",
		"Rang": "⟫",
		"rangd": "⦒",
		"range": "⦥",
		"rangle": "⟩",
		"raquo": "»",
		"rarrap": "⥵",
		"rarrb": "⇥",
		"rarrbfs": "⤠",
		"rarrc": "⤳",
		"rarr": "→",
		"Rarr": "↠",
		"rArr": "⇒",
		"rarrfs": "⤞",
		"rarrhk": "↪",
		"rarrlp": "↬",
		"rarrpl": "⥅",
		"rarrsim": "⥴",
		"Rarrtl": "⤖",
		"rarrtl": "↣",
		"rarrw": "↝",
		"ratail": "⤚",
		"rAtail": "⤜",
		"ratio": "∶",
		"rationals": "ℚ",
		"rbarr": "⤍",
		"rBarr": "⤏",
		"RBarr": "⤐",
		"rbbrk": "❳",
		"rbrace": "}",
		"rbrack": "]",
		"rbrke": "⦌",
		"rbrksld": "⦎",
		"rbrkslu": "⦐",
		"Rcaron": "Ř",
		"rcaron": "ř",
		"Rcedil": "Ŗ",
		"rcedil": "ŗ",
		"rceil": "⌉",
		"rcub": "}",
		"Rcy": "Р",
		"rcy": "р",
		"rdca": "⤷",
		"rdldhar": "⥩",
		"rdquo": "”",
		"rdquor": "”",
		"rdsh": "↳",
		"real": "ℜ",
		"realine": "ℛ",
		"realpart": "ℜ",
		"reals": "ℝ",
		"Re": "ℜ",
		"rect": "▭",
		"reg": "®",
		"REG": "®",
		"ReverseElement": "∋",
		"ReverseEquilibrium": "⇋",
		"ReverseUpEquilibrium": "⥯",
		"rfisht": "⥽",
		"rfloor": "⌋",
		"rfr": "𝔯",
		"Rfr": "ℜ",
		"rHar": "⥤",
		"rhard": "⇁",
		"rharu": "⇀",
		"rharul": "⥬",
		"Rho": "Ρ",
		"rho": "ρ",
		"rhov": "ϱ",
		"RightAngleBracket": "⟩",
		"RightArrowBar": "⇥",
		"rightarrow": "→",
		"RightArrow": "→",
		"Rightarrow": "⇒",
		"RightArrowLeftArrow": "⇄",
		"rightarrowtail": "↣",
		"RightCeiling": "⌉",
		"RightDoubleBracket": "⟧",
		"RightDownTeeVector": "⥝",
		"RightDownVectorBar": "⥕",
		"RightDownVector": "⇂",
		"RightFloor": "⌋",
		"rightharpoondown": "⇁",
		"rightharpoonup": "⇀",
		"rightleftarrows": "⇄",
		"rightleftharpoons": "⇌",
		"rightrightarrows": "⇉",
		"rightsquigarrow": "↝",
		"RightTeeArrow": "↦",
		"RightTee": "⊢",
		"RightTeeVector": "⥛",
		"rightthreetimes": "⋌",
		"RightTriangleBar": "⧐",
		"RightTriangle": "⊳",
		"RightTriangleEqual": "⊵",
		"RightUpDownVector": "⥏",
		"RightUpTeeVector": "⥜",
		"RightUpVectorBar": "⥔",
		"RightUpVector": "↾",
		"RightVectorBar": "⥓",
		"RightVector": "⇀",
		"ring": "˚",
		"risingdotseq": "≓",
		"rlarr": "⇄",
		"rlhar": "⇌",
		"rlm": "‏",
		"rmoustache": "⎱",
		"rmoust": "⎱",
		"rnmid": "⫮",
		"roang": "⟭",
		"roarr": "⇾",
		"robrk": "⟧",
		"ropar": "⦆",
		"ropf": "𝕣",
		"Ropf": "ℝ",
		"roplus": "⨮",
		"rotimes": "⨵",
		"RoundImplies": "⥰",
		"rpar": ")",
		"rpargt": "⦔",
		"rppolint": "⨒",
		"rrarr": "⇉",
		"Rrightarrow": "⇛",
		"rsaquo": "›",
		"rscr": "𝓇",
		"Rscr": "ℛ",
		"rsh": "↱",
		"Rsh": "↱",
		"rsqb": "]",
		"rsquo": "’",
		"rsquor": "’",
		"rthree": "⋌",
		"rtimes": "⋊",
		"rtri": "▹",
		"rtrie": "⊵",
		"rtrif": "▸",
		"rtriltri": "⧎",
		"RuleDelayed": "⧴",
		"ruluhar": "⥨",
		"rx": "℞",
		"Sacute": "Ś",
		"sacute": "ś",
		"sbquo": "‚",
		"scap": "⪸",
		"Scaron": "Š",
		"scaron": "š",
		"Sc": "⪼",
		"sc": "≻",
		"sccue": "≽",
		"sce": "⪰",
		"scE": "⪴",
		"Scedil": "Ş",
		"scedil": "ş",
		"Scirc": "Ŝ",
		"scirc": "ŝ",
		"scnap": "⪺",
		"scnE": "⪶",
		"scnsim": "⋩",
		"scpolint": "⨓",
		"scsim": "≿",
		"Scy": "С",
		"scy": "с",
		"sdotb": "⊡",
		"sdot": "⋅",
		"sdote": "⩦",
		"searhk": "⤥",
		"searr": "↘",
		"seArr": "⇘",
		"searrow": "↘",
		"sect": "§",
		"semi": ";",
		"seswar": "⤩",
		"setminus": "∖",
		"setmn": "∖",
		"sext": "✶",
		"Sfr": "𝔖",
		"sfr": "𝔰",
		"sfrown": "⌢",
		"sharp": "♯",
		"SHCHcy": "Щ",
		"shchcy": "щ",
		"SHcy": "Ш",
		"shcy": "ш",
		"ShortDownArrow": "↓",
		"ShortLeftArrow": "←",
		"shortmid": "∣",
		"shortparallel": "∥",
		"ShortRightArrow": "→",
		"ShortUpArrow": "↑",
		"shy": "­",
		"Sigma": "Σ",
		"sigma": "σ",
		"sigmaf": "ς",
		"sigmav": "ς",
		"sim": "∼",
		"simdot": "⩪",
		"sime": "≃",
		"simeq": "≃",
		"simg": "⪞",
		"simgE": "⪠",
		"siml": "⪝",
		"simlE": "⪟",
		"simne": "≆",
		"simplus": "⨤",
		"simrarr": "⥲",
		"slarr": "←",
		"SmallCircle": "∘",
		"smallsetminus": "∖",
		"smashp": "⨳",
		"smeparsl": "⧤",
		"smid": "∣",
		"smile": "⌣",
		"smt": "⪪",
		"smte": "⪬",
		"smtes": "⪬︀",
		"SOFTcy": "Ь",
		"softcy": "ь",
		"solbar": "⌿",
		"solb": "⧄",
		"sol": "/",
		"Sopf": "𝕊",
		"sopf": "𝕤",
		"spades": "♠",
		"spadesuit": "♠",
		"spar": "∥",
		"sqcap": "⊓",
		"sqcaps": "⊓︀",
		"sqcup": "⊔",
		"sqcups": "⊔︀",
		"Sqrt": "√",
		"sqsub": "⊏",
		"sqsube": "⊑",
		"sqsubset": "⊏",
		"sqsubseteq": "⊑",
		"sqsup": "⊐",
		"sqsupe": "⊒",
		"sqsupset": "⊐",
		"sqsupseteq": "⊒",
		"square": "□",
		"Square": "□",
		"SquareIntersection": "⊓",
		"SquareSubset": "⊏",
		"SquareSubsetEqual": "⊑",
		"SquareSuperset": "⊐",
		"SquareSupersetEqual": "⊒",
		"SquareUnion": "⊔",
		"squarf": "▪",
		"squ": "□",
		"squf": "▪",
		"srarr": "→",
		"Sscr": "𝒮",
		"sscr": "𝓈",
		"ssetmn": "∖",
		"ssmile": "⌣",
		"sstarf": "⋆",
		"Star": "⋆",
		"star": "☆",
		"starf": "★",
		"straightepsilon": "ϵ",
		"straightphi": "ϕ",
		"strns": "¯",
		"sub": "⊂",
		"Sub": "⋐",
		"subdot": "⪽",
		"subE": "⫅",
		"sube": "⊆",
		"subedot": "⫃",
		"submult": "⫁",
		"subnE": "⫋",
		"subne": "⊊",
		"subplus": "⪿",
		"subrarr": "⥹",
		"subset": "⊂",
		"Subset": "⋐",
		"subseteq": "⊆",
		"subseteqq": "⫅",
		"SubsetEqual": "⊆",
		"subsetneq": "⊊",
		"subsetneqq": "⫋",
		"subsim": "⫇",
		"subsub": "⫕",
		"subsup": "⫓",
		"succapprox": "⪸",
		"succ": "≻",
		"succcurlyeq": "≽",
		"Succeeds": "≻",
		"SucceedsEqual": "⪰",
		"SucceedsSlantEqual": "≽",
		"SucceedsTilde": "≿",
		"succeq": "⪰",
		"succnapprox": "⪺",
		"succneqq": "⪶",
		"succnsim": "⋩",
		"succsim": "≿",
		"SuchThat": "∋",
		"sum": "∑",
		"Sum": "∑",
		"sung": "♪",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"sup": "⊃",
		"Sup": "⋑",
		"supdot": "⪾",
		"supdsub": "⫘",
		"supE": "⫆",
		"supe": "⊇",
		"supedot": "⫄",
		"Superset": "⊃",
		"SupersetEqual": "⊇",
		"suphsol": "⟉",
		"suphsub": "⫗",
		"suplarr": "⥻",
		"supmult": "⫂",
		"supnE": "⫌",
		"supne": "⊋",
		"supplus": "⫀",
		"supset": "⊃",
		"Supset": "⋑",
		"supseteq": "⊇",
		"supseteqq": "⫆",
		"supsetneq": "⊋",
		"supsetneqq": "⫌",
		"supsim": "⫈",
		"supsub": "⫔",
		"supsup": "⫖",
		"swarhk": "⤦",
		"swarr": "↙",
		"swArr": "⇙",
		"swarrow": "↙",
		"swnwar": "⤪",
		"szlig": "ß",
		"Tab": "\t",
		"target": "⌖",
		"Tau": "Τ",
		"tau": "τ",
		"tbrk": "⎴",
		"Tcaron": "Ť",
		"tcaron": "ť",
		"Tcedil": "Ţ",
		"tcedil": "ţ",
		"Tcy": "Т",
		"tcy": "т",
		"tdot": "⃛",
		"telrec": "⌕",
		"Tfr": "𝔗",
		"tfr": "𝔱",
		"there4": "∴",
		"therefore": "∴",
		"Therefore": "∴",
		"Theta": "Θ",
		"theta": "θ",
		"thetasym": "ϑ",
		"thetav": "ϑ",
		"thickapprox": "≈",
		"thicksim": "∼",
		"ThickSpace": "  ",
		"ThinSpace": " ",
		"thinsp": " ",
		"thkap": "≈",
		"thksim": "∼",
		"THORN": "Þ",
		"thorn": "þ",
		"tilde": "˜",
		"Tilde": "∼",
		"TildeEqual": "≃",
		"TildeFullEqual": "≅",
		"TildeTilde": "≈",
		"timesbar": "⨱",
		"timesb": "⊠",
		"times": "×",
		"timesd": "⨰",
		"tint": "∭",
		"toea": "⤨",
		"topbot": "⌶",
		"topcir": "⫱",
		"top": "⊤",
		"Topf": "𝕋",
		"topf": "𝕥",
		"topfork": "⫚",
		"tosa": "⤩",
		"tprime": "‴",
		"trade": "™",
		"TRADE": "™",
		"triangle": "▵",
		"triangledown": "▿",
		"triangleleft": "◃",
		"trianglelefteq": "⊴",
		"triangleq": "≜",
		"triangleright": "▹",
		"trianglerighteq": "⊵",
		"tridot": "◬",
		"trie": "≜",
		"triminus": "⨺",
		"TripleDot": "⃛",
		"triplus": "⨹",
		"trisb": "⧍",
		"tritime": "⨻",
		"trpezium": "⏢",
		"Tscr": "𝒯",
		"tscr": "𝓉",
		"TScy": "Ц",
		"tscy": "ц",
		"TSHcy": "Ћ",
		"tshcy": "ћ",
		"Tstrok": "Ŧ",
		"tstrok": "ŧ",
		"twixt": "≬",
		"twoheadleftarrow": "↞",
		"twoheadrightarrow": "↠",
		"Uacute": "Ú",
		"uacute": "ú",
		"uarr": "↑",
		"Uarr": "↟",
		"uArr": "⇑",
		"Uarrocir": "⥉",
		"Ubrcy": "Ў",
		"ubrcy": "ў",
		"Ubreve": "Ŭ",
		"ubreve": "ŭ",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ucy": "У",
		"ucy": "у",
		"udarr": "⇅",
		"Udblac": "Ű",
		"udblac": "ű",
		"udhar": "⥮",
		"ufisht": "⥾",
		"Ufr": "𝔘",
		"ufr": "𝔲",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uHar": "⥣",
		"uharl": "↿",
		"uharr": "↾",
		"uhblk": "▀",
		"ulcorn": "⌜",
		"ulcorner": "⌜",
		"ulcrop": "⌏",
		"ultri": "◸",
		"Umacr": "Ū",
		"umacr": "ū",
		"uml": "¨",
		"UnderBar": "_",
		"UnderBrace": "⏟",
		"UnderBracket": "⎵",
		"UnderParenthesis": "⏝",
		"Union": "⋃",
		"UnionPlus": "⊎",
		"Uogon": "Ų",
		"uogon": "ų",
		"Uopf": "𝕌",
		"uopf": "𝕦",
		"UpArrowBar": "⤒",
		"uparrow": "↑",
		"UpArrow": "↑",
		"Uparrow": "⇑",
		"UpArrowDownArrow": "⇅",
		"updownarrow": "↕",
		"UpDownArrow": "↕",
		"Updownarrow": "⇕",
		"UpEquilibrium": "⥮",
		"upharpoonleft": "↿",
		"upharpoonright": "↾",
		"uplus": "⊎",
		"UpperLeftArrow": "↖",
		"UpperRightArrow": "↗",
		"upsi": "υ",
		"Upsi": "ϒ",
		"upsih": "ϒ",
		"Upsilon": "Υ",
		"upsilon": "υ",
		"UpTeeArrow": "↥",
		"UpTee": "⊥",
		"upuparrows": "⇈",
		"urcorn": "⌝",
		"urcorner": "⌝",
		"urcrop": "⌎",
		"Uring": "Ů",
		"uring": "ů",
		"urtri": "◹",
		"Uscr": "𝒰",
		"uscr": "𝓊",
		"utdot": "⋰",
		"Utilde": "Ũ",
		"utilde": "ũ",
		"utri": "▵",
		"utrif": "▴",
		"uuarr": "⇈",
		"Uuml": "Ü",
		"uuml": "ü",
		"uwangle": "⦧",
		"vangrt": "⦜",
		"varepsilon": "ϵ",
		"varkappa": "ϰ",
		"varnothing": "∅",
		"varphi": "ϕ",
		"varpi": "ϖ",
		"varpropto": "∝",
		"varr": "↕",
		"vArr": "⇕",
		"varrho": "ϱ",
		"varsigma": "ς",
		"varsubsetneq": "⊊︀",
		"varsubsetneqq": "⫋︀",
		"varsupsetneq": "⊋︀",
		"varsupsetneqq": "⫌︀",
		"vartheta": "ϑ",
		"vartriangleleft": "⊲",
		"vartriangleright": "⊳",
		"vBar": "⫨",
		"Vbar": "⫫",
		"vBarv": "⫩",
		"Vcy": "В",
		"vcy": "в",
		"vdash": "⊢",
		"vDash": "⊨",
		"Vdash": "⊩",
		"VDash": "⊫",
		"Vdashl": "⫦",
		"veebar": "⊻",
		"vee": "∨",
		"Vee": "⋁",
		"veeeq": "≚",
		"vellip": "⋮",
		"verbar": "|",
		"Verbar": "‖",
		"vert": "|",
		"Vert": "‖",
		"VerticalBar": "∣",
		"VerticalLine": "|",
		"VerticalSeparator": "❘",
		"VerticalTilde": "≀",
		"VeryThinSpace": " ",
		"Vfr": "𝔙",
		"vfr": "𝔳",
		"vltri": "⊲",
		"vnsub": "⊂⃒",
		"vnsup": "⊃⃒",
		"Vopf": "𝕍",
		"vopf": "𝕧",
		"vprop": "∝",
		"vrtri": "⊳",
		"Vscr": "𝒱",
		"vscr": "𝓋",
		"vsubnE": "⫋︀",
		"vsubne": "⊊︀",
		"vsupnE": "⫌︀",
		"vsupne": "⊋︀",
		"Vvdash": "⊪",
		"vzigzag": "⦚",
		"Wcirc": "Ŵ",
		"wcirc": "ŵ",
		"wedbar": "⩟",
		"wedge": "∧",
		"Wedge": "⋀",
		"wedgeq": "≙",
		"weierp": "℘",
		"Wfr": "𝔚",
		"wfr": "𝔴",
		"Wopf": "𝕎",
		"wopf": "𝕨",
		"wp": "℘",
		"wr": "≀",
		"wreath": "≀",
		"Wscr": "𝒲",
		"wscr": "𝓌",
		"xcap": "⋂",
		"xcirc": "◯",
		"xcup": "⋃",
		"xdtri": "▽",
		"Xfr": "𝔛",
		"xfr": "𝔵",
		"xharr": "⟷",
		"xhArr": "⟺",
		"Xi": "Ξ",
		"xi": "ξ",
		"xlarr": "⟵",
		"xlArr": "⟸",
		"xmap": "⟼",
		"xnis": "⋻",
		"xodot": "⨀",
		"Xopf": "𝕏",
		"xopf": "𝕩",
		"xoplus": "⨁",
		"xotime": "⨂",
		"xrarr": "⟶",
		"xrArr": "⟹",
		"Xscr": "𝒳",
		"xscr": "𝓍",
		"xsqcup": "⨆",
		"xuplus": "⨄",
		"xutri": "△",
		"xvee": "⋁",
		"xwedge": "⋀",
		"Yacute": "Ý",
		"yacute": "ý",
		"YAcy": "Я",
		"yacy": "я",
		"Ycirc": "Ŷ",
		"ycirc": "ŷ",
		"Ycy": "Ы",
		"ycy": "ы",
		"yen": "¥",
		"Yfr": "𝔜",
		"yfr": "𝔶",
		"YIcy": "Ї",
		"yicy": "ї",
		"Yopf": "𝕐",
		"yopf": "𝕪",
		"Yscr": "𝒴",
		"yscr": "𝓎",
		"YUcy": "Ю",
		"yucy": "ю",
		"yuml": "ÿ",
		"Yuml": "Ÿ",
		"Zacute": "Ź",
		"zacute": "ź",
		"Zcaron": "Ž",
		"zcaron": "ž",
		"Zcy": "З",
		"zcy": "з",
		"Zdot": "Ż",
		"zdot": "ż",
		"zeetrf": "ℨ",
		"ZeroWidthSpace": "​",
		"Zeta": "Ζ",
		"zeta": "ζ",
		"zfr": "𝔷",
		"Zfr": "ℨ",
		"ZHcy": "Ж",
		"zhcy": "ж",
		"zigrarr": "⇝",
		"zopf": "𝕫",
		"Zopf": "ℤ",
		"Zscr": "𝒵",
		"zscr": "𝓏",
		"zwj": "‍",
		"zwnj": "‌"
	};

/***/ },
/* 247 */
/***/ function(module, exports) {

	module.exports = {
		"amp": "&",
		"apos": "'",
		"gt": ">",
		"lt": "<",
		"quot": "\""
	};

/***/ },
/* 248 */
/***/ function(module, exports) {

	module.exports = [
		{
			"id": 16,
			"dept_id": 16,
			"department_name": "DOCTOR",
			"department_desc_one": "I am a Doctor. When I treat patients to alleviate their sufferings, I not only apply my best knowledge and skill, I do it with compassion and empathy.",
			"department_desc_two": "<h2><br></h2><h2>CARDIAC INVESTIGATION CONDUCTED AT OUR HOSPITAL ARE:</h2><p><br></p><ul><li>ECG</li><li>ECHO (2D-M Mode/ Colour Doppler)</li><li>HOLTER ECG</li><li>TRANSESOPHAGEAL ECHO</li><li>DOBUTAMINE INDUCED ECHO</li><li>TEE</li><li>ETT</li><li>CAG (Coronary Angiogram)</li><li>USG</li><li>CT Angio</li><li>24 Hours Ambulatory BP</li><li>24 Hours Monitoring</li><li>X-Ray Chest P/A View</li><li>Lipid Profile</li></ul>",
			"department_desc_three": "<h2>THE FOLLOWING PROCEDURES ARE DONE BY OUR CARDIOLOGY TEAM:</h2><p><br></p><ul><li>CAG&nbsp;&nbsp;&nbsp;: Coronary Angiography</li><li>PTCA&nbsp;: Percutaneous Transluminal Coronary Angioplasty / Stenting</li><li>PTMC&nbsp;: Percutaneous Transluminal Mitral Comissurectomy</li><li>TPMI&nbsp;&nbsp;&nbsp;: Temporary Pace Maker Installation</li><li>PPMI&nbsp;&nbsp;&nbsp;: Permanent Pace Maker Installation</li><li>CRT&nbsp;&nbsp;&nbsp;&nbsp;: Cardiac Resynchronization Device</li><li>ICD or AICD : Implantable Cardioverter-Defibrillator or Automated Implantable Cardioverter-Defibrillator C.Cath Coil Embolisation</li><li>ASD&nbsp;&nbsp;&nbsp;&nbsp;: Atrial Septal Defect V. Plasty</li><li>TAVI&nbsp;&nbsp;&nbsp;&nbsp;: Transcathether aortic valve implantation</li><li>PV&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: Pulmonary Valvoplasty</li><li>Pace Maker Implementation</li></ul>",
			"department_desc_four": "<h2>AN OVERALL GLANCE AT OUR STATE-OF-THE-ART FACILITIES</h2><p><br></p><ul><li>3 Catheterization Laboratories (Cath Labs) including one state-of-the-art Azurion Cathlab and one Cardio Neuro iGS 520 Hybrid Cathlab</li><li>20 Bed Coronary Care Unit/CCU</li><li>15 Bed Cardiac High Dependency Unit/CHDU</li><li>3 Cardiac Operation Theatres</li><li>24 Bed Cardiac ICU and Step-down CICU</li></ul>",
			"department_desc_five": "<h2>CONSULTATION &amp; APPOINTMENT</h2><p><br></p><p>Cardiology Department provides consultation services in (OPD - 4) at 1st Floor through highly qualified, experienced and one of the best Cardiologists in Dhaka, Bangladesh. Call 10666 or 02 22 22 62 466 Extension 8114 and 8115) for appointment with one of the best Cardiologists in Dhaka, Bangladesh.</p><p><br></p><p><br></p>",
			"image": "202302281007heart.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 1,
			"slug": "birth-certificate",
			"img": "life-image-1.png"
		},
		{
			"id": 31,
			"dept_id": 31,
			"department_name": "NURSE",
			"department_desc_one": "As a Nurse, I know most of patients I have served over the years don’t remember me; but I do know that I touched a life and I gave a little piece of myself to each of them.",
			"department_desc_three": "<h2>DENTAL IMPLANT-YOUR 2ND PERMANENT TOOTH</h2><p><br></p><p>Missing or lost teeth is nothing to laugh about as it can change your smile forever. When a tooth is lost, its opposite tooth becomes inactive as it requires two opposite teeth to bite. So loosing teeth doesnâ€™t only change your smile but it also compromises your functionality as well. But now we can bring back missing teeth with dental implants.</p><p>Dental Implants are small titanium screws that allow bone to grow in and around it. They are inserted in the jaw bone to mimic the teeth root and in due time an artificial tooth is attached with it to replace the missing tooth. Then the treatment is finished and the new tooth on implant looks and works just like a natural tooth. For patients who have no teeth, with the help of implants, we can restore full functional set of teeth for them. The functionality and appearance of implant supported tooth is as good as any natural tooth. So if you have any missing tooth, dental implants can be your 2nd permanent tooth.</p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202302281004dental.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "death-certificate",
			"img": "life-image-2.png"
		},
		{
			"id": 54,
			"dept_id": 54,
			"department_name": "CHEF",
			"department_desc_one": "When our patients stay with us, my job is to make sure that the meals I prepare for them are hygienic and nutritious; so that they get the right food quality to assist their healing.",
			"department_desc_two": "<h2>HEMOPHILIA</h2><p><br></p><p>Hemophilia is a genetic disease mainly in boys. There is a gene that does not make the clotting factor properly. So, the boys bleed very easily from very small accidents. They also bleed into muscles and joints eg knees and elbows. Treatment: The clotting factors can be injected into patients to stop the problem. Care is given for all these problems for patients with hemophilia. The hematologists look after the blood problem. They also work with the Orthopedic surgeons and physical medicine and rehabilitation doctors for the muscle and joint problems. The muscle and joint bleeds cause pain and stop people using their arms and legs properly.</p><p><br></p>",
			"department_desc_three": "<h2>THALASSEMIA</h2><p><br></p><p>Thalassemia is a genetic disease. The child is born with a gene that makes bad hemoglobin. Patients start getting problems as a child.</p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202303010540blood-tube.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "day-care",
			"img": "life-image-3.png"
		},
		{
			"id": 56,
			"dept_id": 56,
			"department_name": "TECHNICIAN",
			"department_desc_one": "My work involves using high-tech medical equipment's; I remain very focused to provide accurate data for patients which will assist the doctors in taking the right decision.",
			"department_desc_two": "<p><br></p>",
			"department_desc_three": "<p><br></p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202303010514x-ray.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 1,
			"slug": "discharge-protocols",
			"img": "life-image-4.png"
		},
		{
			"id": 33,
			"dept_id": 33,
			"department_name": "Investigation",
			"department_desc_one": "I am a Doctor. When I treat patients to alleviate their sufferings, I not only apply my best knowledge and skill, I do it with compassion and empathy.",
			"department_desc_two": "<h2>NUTRITIONAL HEALTH SCREENING PACKAGE</h2><p><br></p><p><img src=\"data:image/jpeg;base64,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\"></p><p><br></p>",
			"department_desc_three": "<h2>HEALTH ASSESSMENT &amp; FITNESS PACKAGE</h2><p><br></p><p><img src=\"https://www.uhlbd.com/backend/web/post_uploads/thumb/1476351796Health%20Assessment%20&amp;%20Fitness%20Package.jpg\"></p><p><br></p>",
			"department_desc_four": "<h2>OUR SERVICES</h2><p><br></p><p>A team of dedicated and committed dieticians ensuring individual attention. Our services include nutrition assessment, planning and prescription, following counseling for different diseased conditions, including:</p><ul><li>Cardiac Nutrition therapy</li><li>Cancer nutritional status assessment, dietary management after chemotherapy, radiation and surgery</li><li>Nutritional care before and after dialysis</li><li>Nutritional assessment of patients who are on enteral feeding</li><li>Nutritional plan for Partial Parental nutrition (PPN) and Total Parenteral Nutrition (TPN)</li><li>Special therapeutic diets planned for diabetic patients</li><li>Special therapeutic diets planned for hypertension and other diseased conditions</li><li>Hepatic Diet (Diet plan for patients with Jaundice, Cirrhosis, Hepatic</li><li>Carcinoma etc.)</li><li>Malnution</li><li>Pediatric diet according to age and physiological condition</li><li>Diet for children and adolescent diseases</li><li>Diet for patients suffering from allergies</li><li>Diet for inborn metabolic disorders</li><li>Low Purine Diet</li><li>Balanced Diet for pregnant and lactating mother &amp; gestational diabetics&nbsp;&nbsp;&nbsp;</li><li>Sodium restricted diet plan often used in treating hypertension, edema, heart, kidney and liver diseases</li><li>Diet plan for hyperthyrodism and hypothyrodism</li><li>Diet plan for gastroenteritis</li><li>Diet plan for PEG (pencutameoms emdoscopic gastrostomy) tube feeding</li><li>Weight Reducing Diet</li><li>Weight Improving Diet&nbsp;</li></ul><p>&nbsp;</p>",
			"department_desc_five": "<p><br></p>",
			"image": "202304020419plan.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "investigation",
			"img": "life-image-1.png"
		},
		{
			"id": 35,
			"dept_id": 35,
			"department_name": "Telemedicine",
			"department_desc_one": "I am a Doctor. When I treat patients to alleviate their sufferings, I not only apply my best knowledge and skill, I do it with compassion and empathy.",
			"department_desc_two": "<h2>AMBULANCE SERVICE</h2><p><br></p><p><strong>The Cardiac Ambulance is always accompanied by</strong></p><p>Specialist ,&nbsp;Nurse,&nbsp;PCA&nbsp;</p><p><strong>The Normal Ambulance is always accompanied by&nbsp;</strong></p><p>Nurse,&nbsp;PCA</p><p><span style=\"color: rgb(255, 0, 0);\">for any emergency need, please call&nbsp;</span><strong style=\"color: rgb(255, 0, 0);\">01914001234; 01914001232</strong></p><p><br></p>",
			"department_desc_three": "<h2>AMBULANCE</h2><p><br></p><p><img src=\"https://www.uhlbd.com/backend/web/post_uploads/medium/1457609835IMG_2432%202.jpg\"> <img src=\"https://www.uhlbd.com/backend/web/post_uploads/medium/1457612727Ambulance_resize.jpg\"></p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202303010523first-aid-box.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "telemedicine",
			"img": "life-image-2.png"
		},
		{
			"id": 36,
			"dept_id": 36,
			"department_name": "Mortuary",
			"department_desc_one": "I am a Doctor. When I treat patients to alleviate their sufferings, I not only apply my best knowledge and skill, I do it with compassion and empathy.",
			"department_desc_two": "<p><br></p>",
			"department_desc_three": "<p><br></p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202303010526sugar-blood-level.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "mortuary",
			"img": "life-image-3.png"
		},
		{
			"id": 38,
			"dept_id": 38,
			"department_name": "Pharmacy",
			"department_desc_one": "I am a Doctor. When I treat patients to alleviate their sufferings, I not only apply my best knowledge and skill, I do it with compassion and empathy.",
			"department_desc_two": "<h2>THE DEPARTMENT OF ENT &amp; HEAD NECK SURGERY PROVIDES THE FOLLOWING SERVICES:</h2><p><br></p><p>Diagnostic Facilities For</p><ul><li>Nasal bleeding</li><li>Hearing Loss</li><li>Vertigo</li><li>Snoring &amp; Sleep Apnea (Both Adult &amp; Child)</li><li>Headache</li><li>Early voice change</li><li>Early stage of cancer</li><li>All types of ENT diseases, diagnosis and treatments</li></ul>",
			"department_desc_three": "<h2>EAR</h2><p><br></p><p>We provide medical and surgical treatment for</p><ul><li>Middle-ear infections</li><li>External ear-canal inflammation (swimmerâ€™s ear)</li><li>Tinnitus (ringing in the ear)</li><li>Wax build up</li><li>Perforated eardrum</li><li>Hearing loss</li><li>Balance problem</li><li>Cholesteatomas (invasive ear cysts)</li><li>Obstruction by foreign bodies</li><li>Ear trauma or injury</li></ul>",
			"department_desc_four": "<h2>NOSE</h2><p><br></p><p>Our care of the nasal cavity encompasses</p><ul><li>Allergy treatment</li><li>Endoscopic and open sinus surgery to treat sinus infections</li><li>Surgical correction of deviated or perforated septum</li><li>Functional or cosmetic rhinoplasty</li><li>Nasal turbinate surgery to reduce nasal bones blocking the airway</li><li>Surgical correction of choanal atresia (congenital blockage of the nasal passage)</li><li>Removal of nasal polyps, benign &amp; malignant tumors and foreign bodies</li><li>Repair of nasal trauma or fracture</li></ul>",
			"department_desc_five": "<h2>THROAT</h2><p><br></p><p>Our expertise in the throat area extends from the tongue to larynx (voice box) to the oesophagus. We evaluate and treat voice and swallowing problems, frequent or persistent sore throat or cough, gastroesophageal reflux disease, breathing difficulties and sleep disorders.</p>",
			"image": "202302281420sore-throat.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "pharmacy",
			"img": "life-image-4.png"
		},
		{
			"id": 48,
			"dept_id": 48,
			"department_name": "Vaccination",
			"department_desc_one": "I am a Doctor. When I treat patients to alleviate their sufferings, I not only apply my best knowledge and skill, I do it with compassion and empathy.",
			"department_desc_two": "<h2>FACILITIES</h2><p><br></p><p>Your anesthesiologist will fully explain your anesthesia options and outline the pros and cons of each approach.He or she will work with your surgeon to develop a individualized pre-op to post-op plan to:</p><ul><li>Anticipate any medical problems that could arise during surgery</li><li>Keep you pain-free through your surgery</li><li>Relieve anxiety</li><li>Control your body's reaction to stress</li><li>Minimize side effects</li><li>Make your recovery easier</li></ul><p>In addition to administering anesthetic during your procedure, your anesthesiologist will monitor your vital body functions, such as breathing, blood oxygen saturation, blood pressure, heart rate, and kidney functions. After surgery your anesthesiologist will closely monitor you for any problems related to your anesthetic and order pain medication as your condition allows.</p>",
			"department_desc_three": "<p><br></p>",
			"department_desc_four": "<p><br></p>",
			"department_desc_five": "<p><br></p>",
			"image": "202304020429injection.png",
			"banner_image": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "-000001-11-30T00:00:00.000000Z",
			"updated_at": "-000001-11-30T00:00:00.000000Z",
			"has_package": 0,
			"slug": "vaccination",
			"img": "life-image-1.png"
		}
	];

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(912),
	    mapCacheDelete = __webpack_require__(913),
	    mapCacheGet = __webpack_require__(914),
	    mapCacheHas = __webpack_require__(915),
	    mapCacheSet = __webpack_require__(916);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(872),
	    arraySome = __webpack_require__(879),
	    cacheHas = __webpack_require__(889);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 251 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 252 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 253 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(61),
	    stubFalse = __webpack_require__(935);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(181)(module)))

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(121),
	    isObject = __webpack_require__(257);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 256 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 257 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(885),
	    baseUnary = __webpack_require__(888),
	    nodeUtil = __webpack_require__(919);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Palestine) [ar-ps]
	//! author : Majd Al-Shihabi : https://github.com/majdal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arPs = moment.defineLocale('ar-ps', {
	        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
	            '_'
	        ),
	        monthsShort:
	            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('') // reversed since negative lookbehind not supported everywhere
	                .reverse()
	                .join('')
	                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('')
	                .reverse()
	                .join('')
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arPs;
	
	})));


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! author : Rasid Redzic : https://github.com/rasidre
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 'm':
	                return withoutSuffix
	                    ? 'jedna minuta'
	                    : isFuture
	                      ? 'jednu minutu'
	                      : 'jedne minute';
	        }
	    }
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jedan sat';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: processRelativeTime,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            standalone:
	                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                    '_'
	                ),
	            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                '_'
	            ),
	            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                      ? 'тан'
	                      : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Kurdish [ku-kmr]
	//! authors : Mazlum Özdogan : https://github.com/mergehez
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(num, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['çend sanîye', 'çend sanîyeyan'],
	            ss: [num + ' sanîye', num + ' sanîyeyan'],
	            m: ['deqîqeyek', 'deqîqeyekê'],
	            mm: [num + ' deqîqe', num + ' deqîqeyan'],
	            h: ['saetek', 'saetekê'],
	            hh: [num + ' saet', num + ' saetan'],
	            d: ['rojek', 'rojekê'],
	            dd: [num + ' roj', num + ' rojan'],
	            w: ['hefteyek', 'hefteyekê'],
	            ww: [num + ' hefte', num + ' hefteyan'],
	            M: ['mehek', 'mehekê'],
	            MM: [num + ' meh', num + ' mehan'],
	            y: ['salek', 'salekê'],
	            yy: [num + ' sal', num + ' salan'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    // function obliqueNumSuffix(num) {
	    //     if(num.includes(':'))
	    //         num = parseInt(num.split(':')[0]);
	    //     else
	    //         num = parseInt(num);
	    //     return num == 0 || num % 10 == 1 ? 'ê'
	    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
	    // }
	    function ezafeNumSuffix(num) {
	        num = '' + num;
	        var l = num.substring(num.length - 1),
	            ll = num.length > 1 ? num.substring(num.length - 2) : '';
	        if (
	            !(ll == 12 || ll == 13) &&
	            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
	        )
	            return 'yê';
	        return 'ê';
	    }
	
	    var kuKmr = moment.defineLocale('ku-kmr', {
	        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
	        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
	        // But the names below are more well known and handy
	        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
	            '_'
	        ),
	        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
	        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
	        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'bn' : 'BN';
	            } else {
	                return isLower ? 'pn' : 'PN';
	            }
	        },
	        meridiemParse: /bn|BN|pn|PN/,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[a] YYYY[an]',
	            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
	            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
	            ll: 'Do MMM[.] YYYY[an]',
	            lll: 'Do MMM[.] YYYY[an] HH:mm',
	            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Îro di saet] LT [de]',
	            nextDay: '[Sibê di saet] LT [de]',
	            nextWeek: 'dddd [di saet] LT [de]',
	            lastDay: '[Duh di saet] LT [de]',
	            lastWeek: 'dddd[a borî di saet] LT [de]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'di %s de',
	            past: 'berî %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
	        ordinal: function (num, period) {
	            var p = period.toLowerCase();
	            if (p.includes('w') || p.includes('m')) return num + '.';
	
	            return num + ezafeNumSuffix(num);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return kuKmr;
	
	})));


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	              ? forms(key)[1]
	              : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                  ? wordKey[1]
	                  : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'én time',
	            hh: '%d timer',
	            d: 'én dag',
	            dd: '%d dager',
	            w: 'én uke',
	            ww: '%d uker',
	            M: 'én måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                          ? ':a'
	                          : b === 2
	                            ? ':a'
	                            : b === 3
	                              ? ':e'
	                              : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'waQ'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'nem'
	                    : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'wen'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'ben'
	                    : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	              ? format[key][0]
	              : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	              ? 'genitive'
	              : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 396 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(473);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * Quill Editor v1.3.7
	 * https://quilljs.com/
	 * Copyright (c) 2014, Jason Chen
	 * Copyright (c) 2013, salesforce.com
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Quill"] = factory();
		else
			root["Quill"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 109);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var format_1 = __webpack_require__(18);
	var leaf_1 = __webpack_require__(19);
	var scroll_1 = __webpack_require__(45);
	var inline_1 = __webpack_require__(46);
	var block_1 = __webpack_require__(47);
	var embed_1 = __webpack_require__(48);
	var text_1 = __webpack_require__(49);
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var store_1 = __webpack_require__(31);
	var Registry = __webpack_require__(1);
	var Parchment = {
	    Scope: Registry.Scope,
	    create: Registry.create,
	    find: Registry.find,
	    query: Registry.query,
	    register: Registry.register,
	    Container: container_1.default,
	    Format: format_1.default,
	    Leaf: leaf_1.default,
	    Embed: embed_1.default,
	    Scroll: scroll_1.default,
	    Block: block_1.default,
	    Inline: inline_1.default,
	    Text: text_1.default,
	    Attributor: {
	        Attribute: attributor_1.default,
	        Class: class_1.default,
	        Style: style_1.default,
	        Store: store_1.default,
	    },
	};
	exports.default = Parchment;
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ParchmentError = /** @class */ (function (_super) {
	    __extends(ParchmentError, _super);
	    function ParchmentError(message) {
	        var _this = this;
	        message = '[Parchment] ' + message;
	        _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _this.constructor.name;
	        return _this;
	    }
	    return ParchmentError;
	}(Error));
	exports.ParchmentError = ParchmentError;
	var attributes = {};
	var classes = {};
	var tags = {};
	var types = {};
	exports.DATA_KEY = '__blot';
	var Scope;
	(function (Scope) {
	    Scope[Scope["TYPE"] = 3] = "TYPE";
	    Scope[Scope["LEVEL"] = 12] = "LEVEL";
	    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
	    Scope[Scope["BLOT"] = 14] = "BLOT";
	    Scope[Scope["INLINE"] = 7] = "INLINE";
	    Scope[Scope["BLOCK"] = 11] = "BLOCK";
	    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
	    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
	    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
	    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
	    Scope[Scope["ANY"] = 15] = "ANY";
	})(Scope = exports.Scope || (exports.Scope = {}));
	function create(input, value) {
	    var match = query(input);
	    if (match == null) {
	        throw new ParchmentError("Unable to create " + input + " blot");
	    }
	    var BlotClass = match;
	    var node = 
	    // @ts-ignore
	    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
	    return new BlotClass(node, value);
	}
	exports.create = create;
	function find(node, bubble) {
	    if (bubble === void 0) { bubble = false; }
	    if (node == null)
	        return null;
	    // @ts-ignore
	    if (node[exports.DATA_KEY] != null)
	        return node[exports.DATA_KEY].blot;
	    if (bubble)
	        return find(node.parentNode, bubble);
	    return null;
	}
	exports.find = find;
	function query(query, scope) {
	    if (scope === void 0) { scope = Scope.ANY; }
	    var match;
	    if (typeof query === 'string') {
	        match = types[query] || attributes[query];
	        // @ts-ignore
	    }
	    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
	        match = types['text'];
	    }
	    else if (typeof query === 'number') {
	        if (query & Scope.LEVEL & Scope.BLOCK) {
	            match = types['block'];
	        }
	        else if (query & Scope.LEVEL & Scope.INLINE) {
	            match = types['inline'];
	        }
	    }
	    else if (query instanceof HTMLElement) {
	        var names = (query.getAttribute('class') || '').split(/\s+/);
	        for (var i in names) {
	            match = classes[names[i]];
	            if (match)
	                break;
	        }
	        match = match || tags[query.tagName];
	    }
	    if (match == null)
	        return null;
	    // @ts-ignore
	    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
	        return match;
	    return null;
	}
	exports.query = query;
	function register() {
	    var Definitions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        Definitions[_i] = arguments[_i];
	    }
	    if (Definitions.length > 1) {
	        return Definitions.map(function (d) {
	            return register(d);
	        });
	    }
	    var Definition = Definitions[0];
	    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
	        throw new ParchmentError('Invalid definition');
	    }
	    else if (Definition.blotName === 'abstract') {
	        throw new ParchmentError('Cannot register abstract class');
	    }
	    types[Definition.blotName || Definition.attrName] = Definition;
	    if (typeof Definition.keyName === 'string') {
	        attributes[Definition.keyName] = Definition;
	    }
	    else {
	        if (Definition.className != null) {
	            classes[Definition.className] = Definition;
	        }
	        if (Definition.tagName != null) {
	            if (Array.isArray(Definition.tagName)) {
	                Definition.tagName = Definition.tagName.map(function (tagName) {
	                    return tagName.toUpperCase();
	                });
	            }
	            else {
	                Definition.tagName = Definition.tagName.toUpperCase();
	            }
	            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
	            tagNames.forEach(function (tag) {
	                if (tags[tag] == null || Definition.className == null) {
	                    tags[tag] = Definition;
	                }
	            });
	        }
	    }
	    return Definition;
	}
	exports.register = register;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var diff = __webpack_require__(51);
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	var op = __webpack_require__(20);
	
	
	var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()
	
	
	var Delta = function (ops) {
	  // Assume we are given a well formed ops
	  if (Array.isArray(ops)) {
	    this.ops = ops;
	  } else if (ops != null && Array.isArray(ops.ops)) {
	    this.ops = ops.ops;
	  } else {
	    this.ops = [];
	  }
	};
	
	
	Delta.prototype.insert = function (text, attributes) {
	  var newOp = {};
	  if (text.length === 0) return this;
	  newOp.insert = text;
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype['delete'] = function (length) {
	  if (length <= 0) return this;
	  return this.push({ 'delete': length });
	};
	
	Delta.prototype.retain = function (length, attributes) {
	  if (length <= 0) return this;
	  var newOp = { retain: length };
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype.push = function (newOp) {
	  var index = this.ops.length;
	  var lastOp = this.ops[index - 1];
	  newOp = extend(true, {}, newOp);
	  if (typeof lastOp === 'object') {
	    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
	      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
	      return this;
	    }
	    // Since it does not matter if we insert before or after deleting at the same index,
	    // always prefer to insert first
	    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
	      index -= 1;
	      lastOp = this.ops[index - 1];
	      if (typeof lastOp !== 'object') {
	        this.ops.unshift(newOp);
	        return this;
	      }
	    }
	    if (equal(newOp.attributes, lastOp.attributes)) {
	      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
	        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
	        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      }
	    }
	  }
	  if (index === this.ops.length) {
	    this.ops.push(newOp);
	  } else {
	    this.ops.splice(index, 0, newOp);
	  }
	  return this;
	};
	
	Delta.prototype.chop = function () {
	  var lastOp = this.ops[this.ops.length - 1];
	  if (lastOp && lastOp.retain && !lastOp.attributes) {
	    this.ops.pop();
	  }
	  return this;
	};
	
	Delta.prototype.filter = function (predicate) {
	  return this.ops.filter(predicate);
	};
	
	Delta.prototype.forEach = function (predicate) {
	  this.ops.forEach(predicate);
	};
	
	Delta.prototype.map = function (predicate) {
	  return this.ops.map(predicate);
	};
	
	Delta.prototype.partition = function (predicate) {
	  var passed = [], failed = [];
	  this.forEach(function(op) {
	    var target = predicate(op) ? passed : failed;
	    target.push(op);
	  });
	  return [passed, failed];
	};
	
	Delta.prototype.reduce = function (predicate, initial) {
	  return this.ops.reduce(predicate, initial);
	};
	
	Delta.prototype.changeLength = function () {
	  return this.reduce(function (length, elem) {
	    if (elem.insert) {
	      return length + op.length(elem);
	    } else if (elem.delete) {
	      return length - elem.delete;
	    }
	    return length;
	  }, 0);
	};
	
	Delta.prototype.length = function () {
	  return this.reduce(function (length, elem) {
	    return length + op.length(elem);
	  }, 0);
	};
	
	Delta.prototype.slice = function (start, end) {
	  start = start || 0;
	  if (typeof end !== 'number') end = Infinity;
	  var ops = [];
	  var iter = op.iterator(this.ops);
	  var index = 0;
	  while (index < end && iter.hasNext()) {
	    var nextOp;
	    if (index < start) {
	      nextOp = iter.next(start - index);
	    } else {
	      nextOp = iter.next(end - index);
	      ops.push(nextOp);
	    }
	    index += op.length(nextOp);
	  }
	  return new Delta(ops);
	};
	
	
	Delta.prototype.compose = function (other) {
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var ops = [];
	  var firstOther = otherIter.peek();
	  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
	    var firstLeft = firstOther.retain;
	    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
	      firstLeft -= thisIter.peekLength();
	      ops.push(thisIter.next());
	    }
	    if (firstOther.retain - firstLeft > 0) {
	      otherIter.next(firstOther.retain - firstLeft);
	    }
	  }
	  var delta = new Delta(ops);
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else if (thisIter.peekType() === 'delete') {
	      delta.push(thisIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (typeof otherOp.retain === 'number') {
	        var newOp = {};
	        if (typeof thisOp.retain === 'number') {
	          newOp.retain = length;
	        } else {
	          newOp.insert = thisOp.insert;
	        }
	        // Preserve null when composing with a retain, otherwise remove it for inserts
	        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
	        if (attributes) newOp.attributes = attributes;
	        delta.push(newOp);
	
	        // Optimization if rest of other is just retain
	        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
	          var rest = new Delta(thisIter.rest());
	          return delta.concat(rest).chop();
	        }
	
	      // Other op should be delete, we could be an insert or retain
	      // Insert + delete cancels out
	      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
	        delta.push(otherOp);
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.concat = function (other) {
	  var delta = new Delta(this.ops.slice());
	  if (other.ops.length > 0) {
	    delta.push(other.ops[0]);
	    delta.ops = delta.ops.concat(other.ops.slice(1));
	  }
	  return delta;
	};
	
	Delta.prototype.diff = function (other, index) {
	  if (this.ops === other.ops) {
	    return new Delta();
	  }
	  var strings = [this, other].map(function (delta) {
	    return delta.map(function (op) {
	      if (op.insert != null) {
	        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
	      }
	      var prep = (delta === other) ? 'on' : 'with';
	      throw new Error('diff() called ' + prep + ' non-document');
	    }).join('');
	  });
	  var delta = new Delta();
	  var diffResult = diff(strings[0], strings[1], index);
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  diffResult.forEach(function (component) {
	    var length = component[1].length;
	    while (length > 0) {
	      var opLength = 0;
	      switch (component[0]) {
	        case diff.INSERT:
	          opLength = Math.min(otherIter.peekLength(), length);
	          delta.push(otherIter.next(opLength));
	          break;
	        case diff.DELETE:
	          opLength = Math.min(length, thisIter.peekLength());
	          thisIter.next(opLength);
	          delta['delete'](opLength);
	          break;
	        case diff.EQUAL:
	          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
	          var thisOp = thisIter.next(opLength);
	          var otherOp = otherIter.next(opLength);
	          if (equal(thisOp.insert, otherOp.insert)) {
	            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
	          } else {
	            delta.push(otherOp)['delete'](opLength);
	          }
	          break;
	      }
	      length -= opLength;
	    }
	  });
	  return delta.chop();
	};
	
	Delta.prototype.eachLine = function (predicate, newline) {
	  newline = newline || '\n';
	  var iter = op.iterator(this.ops);
	  var line = new Delta();
	  var i = 0;
	  while (iter.hasNext()) {
	    if (iter.peekType() !== 'insert') return;
	    var thisOp = iter.peek();
	    var start = op.length(thisOp) - iter.peekLength();
	    var index = typeof thisOp.insert === 'string' ?
	      thisOp.insert.indexOf(newline, start) - start : -1;
	    if (index < 0) {
	      line.push(iter.next());
	    } else if (index > 0) {
	      line.push(iter.next(index));
	    } else {
	      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
	        return;
	      }
	      i += 1;
	      line = new Delta();
	    }
	  }
	  if (line.length() > 0) {
	    predicate(line, {}, i);
	  }
	};
	
	Delta.prototype.transform = function (other, priority) {
	  priority = !!priority;
	  if (typeof other === 'number') {
	    return this.transformPosition(other, priority);
	  }
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
	      delta.retain(op.length(thisIter.next()));
	    } else if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (thisOp['delete']) {
	        // Our delete either makes their delete redundant or removes their retain
	        continue;
	      } else if (otherOp['delete']) {
	        delta.push(otherOp);
	      } else {
	        // We retain either their retain or insert
	        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.transformPosition = function (index, priority) {
	  priority = !!priority;
	  var thisIter = op.iterator(this.ops);
	  var offset = 0;
	  while (thisIter.hasNext() && offset <= index) {
	    var length = thisIter.peekLength();
	    var nextType = thisIter.peekType();
	    thisIter.next();
	    if (nextType === 'delete') {
	      index -= Math.min(length, index - offset);
	      continue;
	    } else if (nextType === 'insert' && (offset < index || !priority)) {
	      index += length;
	    }
	    offset += length;
	  }
	  return index;
	};
	
	
	module.exports = Delta;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEWLINE_LENGTH = 1;
	
	var BlockEmbed = function (_Parchment$Embed) {
	  _inherits(BlockEmbed, _Parchment$Embed);
	
	  function BlockEmbed() {
	    _classCallCheck(this, BlockEmbed);
	
	    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
	  }
	
	  _createClass(BlockEmbed, [{
	    key: 'attach',
	    value: function attach() {
	      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
	      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
	    }
	  }, {
	    key: 'delta',
	    value: function delta() {
	      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
	      if (attribute != null) {
	        this.attributes.attribute(attribute, value);
	      }
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      this.format(name, value);
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (typeof value === 'string' && value.endsWith('\n')) {
	        var block = _parchment2.default.create(Block.blotName);
	        this.parent.insertBefore(block, index === 0 ? this : this.next);
	        block.insertAt(0, value.slice(0, -1));
	      } else {
	        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	    }
	  }]);
	
	  return BlockEmbed;
	}(_parchment2.default.Embed);
	
	BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
	// It is important for cursor behavior BlockEmbeds use tags that are block level elements
	
	
	var Block = function (_Parchment$Block) {
	  _inherits(Block, _Parchment$Block);
	
	  function Block(domNode) {
	    _classCallCheck(this, Block);
	
	    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
	
	    _this2.cache = {};
	    return _this2;
	  }
	
	  _createClass(Block, [{
	    key: 'delta',
	    value: function delta() {
	      if (this.cache.delta == null) {
	        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
	          if (leaf.length() === 0) {
	            return delta;
	          } else {
	            return delta.insert(leaf.value(), bubbleFormats(leaf));
	          }
	        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
	      }
	      return this.cache.delta;
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
	      this.cache = {};
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length <= 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	        if (index + length === this.length()) {
	          this.format(name, value);
	        }
	      } else {
	        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
	      if (value.length === 0) return;
	      var lines = value.split('\n');
	      var text = lines.shift();
	      if (text.length > 0) {
	        if (index < this.length() - 1 || this.children.tail == null) {
	          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
	        } else {
	          this.children.tail.insertAt(this.children.tail.length(), text);
	        }
	        this.cache = {};
	      }
	      var block = this;
	      lines.reduce(function (index, line) {
	        block = block.split(index, true);
	        block.insertAt(0, line);
	        return line.length;
	      }, index + text.length);
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      var head = this.children.head;
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
	      if (head instanceof _break2.default) {
	        head.remove();
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      if (this.cache.length == null) {
	        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
	      }
	      return this.cache.length;
	    }
	  }, {
	    key: 'moveChildren',
	    value: function moveChildren(target, ref) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
	      this.cache = {};
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
	      this.cache = {};
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(child) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
	      this.cache = {};
	    }
	  }, {
	    key: 'split',
	    value: function split(index) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
	        var clone = this.clone();
	        if (index === 0) {
	          this.parent.insertBefore(clone, this);
	          return this;
	        } else {
	          this.parent.insertBefore(clone, this.next);
	          return clone;
	        }
	      } else {
	        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
	        this.cache = {};
	        return next;
	      }
	    }
	  }]);
	
	  return Block;
	}(_parchment2.default.Block);
	
	Block.blotName = 'block';
	Block.tagName = 'P';
	Block.defaultChild = 'break';
	Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];
	
	function bubbleFormats(blot) {
	  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (blot == null) return formats;
	  if (typeof blot.formats === 'function') {
	    formats = (0, _extend2.default)(formats, blot.formats());
	  }
	  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
	    return formats;
	  }
	  return bubbleFormats(blot.parent, formats);
	}
	
	exports.bubbleFormats = bubbleFormats;
	exports.BlockEmbed = BlockEmbed;
	exports.default = Block;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.overload = exports.expandConfig = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(50);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _editor = __webpack_require__(14);
	
	var _editor2 = _interopRequireDefault(_editor);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _selection = __webpack_require__(15);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill');
	
	var Quill = function () {
	  _createClass(Quill, null, [{
	    key: 'debug',
	    value: function debug(limit) {
	      if (limit === true) {
	        limit = 'log';
	      }
	      _logger2.default.level(limit);
	    }
	  }, {
	    key: 'find',
	    value: function find(node) {
	      return node.__quill || _parchment2.default.find(node);
	    }
	  }, {
	    key: 'import',
	    value: function _import(name) {
	      if (this.imports[name] == null) {
	        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
	      }
	      return this.imports[name];
	    }
	  }, {
	    key: 'register',
	    value: function register(path, target) {
	      var _this = this;
	
	      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (typeof path !== 'string') {
	        var name = path.attrName || path.blotName;
	        if (typeof name === 'string') {
	          // register(Blot | Attributor, overwrite)
	          this.register('formats/' + name, path, target);
	        } else {
	          Object.keys(path).forEach(function (key) {
	            _this.register(key, path[key], target);
	          });
	        }
	      } else {
	        if (this.imports[path] != null && !overwrite) {
	          debug.warn('Overwriting ' + path + ' with', target);
	        }
	        this.imports[path] = target;
	        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
	          _parchment2.default.register(target);
	        } else if (path.startsWith('modules') && typeof target.register === 'function') {
	          target.register();
	        }
	      }
	    }
	  }]);
	
	  function Quill(container) {
	    var _this2 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Quill);
	
	    this.options = expandConfig(container, options);
	    this.container = this.options.container;
	    if (this.container == null) {
	      return debug.error('Invalid Quill container', container);
	    }
	    if (this.options.debug) {
	      Quill.debug(this.options.debug);
	    }
	    var html = this.container.innerHTML.trim();
	    this.container.classList.add('ql-container');
	    this.container.innerHTML = '';
	    this.container.__quill = this;
	    this.root = this.addContainer('ql-editor');
	    this.root.classList.add('ql-blank');
	    this.root.setAttribute('data-gramm', false);
	    this.scrollingContainer = this.options.scrollingContainer || this.root;
	    this.emitter = new _emitter4.default();
	    this.scroll = _parchment2.default.create(this.root, {
	      emitter: this.emitter,
	      whitelist: this.options.formats
	    });
	    this.editor = new _editor2.default(this.scroll);
	    this.selection = new _selection2.default(this.scroll, this.emitter);
	    this.theme = new this.options.theme(this, this.options);
	    this.keyboard = this.theme.addModule('keyboard');
	    this.clipboard = this.theme.addModule('clipboard');
	    this.history = this.theme.addModule('history');
	    this.theme.init();
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
	      if (type === _emitter4.default.events.TEXT_CHANGE) {
	        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
	      var range = _this2.selection.lastRange;
	      var index = range && range.length === 0 ? range.index : undefined;
	      modify.call(_this2, function () {
	        return _this2.editor.update(null, mutations, index);
	      }, source);
	    });
	    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
	    this.setContents(contents);
	    this.history.clear();
	    if (this.options.placeholder) {
	      this.root.setAttribute('data-placeholder', this.options.placeholder);
	    }
	    if (this.options.readOnly) {
	      this.disable();
	    }
	  }
	
	  _createClass(Quill, [{
	    key: 'addContainer',
	    value: function addContainer(container) {
	      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (typeof container === 'string') {
	        var className = container;
	        container = document.createElement('div');
	        container.classList.add(className);
	      }
	      this.container.insertBefore(container, refNode);
	      return container;
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.selection.setRange(null);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length, source) {
	      var _this3 = this;
	
	      var _overload = overload(index, length, source);
	
	      var _overload2 = _slicedToArray(_overload, 4);
	
	      index = _overload2[0];
	      length = _overload2[1];
	      source = _overload2[3];
	
	      return modify.call(this, function () {
	        return _this3.editor.deleteText(index, length);
	      }, source, index, -1 * length);
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this.enable(false);
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.scroll.enable(enabled);
	      this.container.classList.toggle('ql-disabled', !enabled);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var scrollTop = this.scrollingContainer.scrollTop;
	      this.selection.focus();
	      this.scrollingContainer.scrollTop = scrollTop;
	      this.scrollIntoView();
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var _this4 = this;
	
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        var range = _this4.getSelection(true);
	        var change = new _quillDelta2.default();
	        if (range == null) {
	          return change;
	        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
	        } else if (range.length === 0) {
	          _this4.selection.format(name, value);
	          return change;
	        } else {
	          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
	        }
	        _this4.setSelection(range, _emitter4.default.sources.SILENT);
	        return change;
	      }, source);
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length, name, value, source) {
	      var _this5 = this;
	
	      var formats = void 0;
	
	      var _overload3 = overload(index, length, name, value, source);
	
	      var _overload4 = _slicedToArray(_overload3, 4);
	
	      index = _overload4[0];
	      length = _overload4[1];
	      formats = _overload4[2];
	      source = _overload4[3];
	
	      return modify.call(this, function () {
	        return _this5.editor.formatLine(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length, name, value, source) {
	      var _this6 = this;
	
	      var formats = void 0;
	
	      var _overload5 = overload(index, length, name, value, source);
	
	      var _overload6 = _slicedToArray(_overload5, 4);
	
	      index = _overload6[0];
	      length = _overload6[1];
	      formats = _overload6[2];
	      source = _overload6[3];
	
	      return modify.call(this, function () {
	        return _this6.editor.formatText(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var bounds = void 0;
	      if (typeof index === 'number') {
	        bounds = this.selection.getBounds(index, length);
	      } else {
	        bounds = this.selection.getBounds(index.index, index.length);
	      }
	      var containerBounds = this.container.getBoundingClientRect();
	      return {
	        bottom: bounds.bottom - containerBounds.top,
	        height: bounds.height,
	        left: bounds.left - containerBounds.left,
	        right: bounds.right - containerBounds.left,
	        top: bounds.top - containerBounds.top,
	        width: bounds.width
	      };
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload7 = overload(index, length);
	
	      var _overload8 = _slicedToArray(_overload7, 2);
	
	      index = _overload8[0];
	      length = _overload8[1];
	
	      return this.editor.getContents(index, length);
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (typeof index === 'number') {
	        return this.editor.getFormat(index, length);
	      } else {
	        return this.editor.getFormat(index.index, index.length);
	      }
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(blot) {
	      return blot.offset(this.scroll);
	    }
	  }, {
	    key: 'getLength',
	    value: function getLength() {
	      return this.scroll.length();
	    }
	  }, {
	    key: 'getLeaf',
	    value: function getLeaf(index) {
	      return this.scroll.leaf(index);
	    }
	  }, {
	    key: 'getLine',
	    value: function getLine(index) {
	      return this.scroll.line(index);
	    }
	  }, {
	    key: 'getLines',
	    value: function getLines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      if (typeof index !== 'number') {
	        return this.scroll.lines(index.index, index.length);
	      } else {
	        return this.scroll.lines(index, length);
	      }
	    }
	  }, {
	    key: 'getModule',
	    value: function getModule(name) {
	      return this.theme.modules[name];
	    }
	  }, {
	    key: 'getSelection',
	    value: function getSelection() {
	      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (focus) this.focus();
	      this.update(); // Make sure we access getRange with editor in consistent state
	      return this.selection.getRange()[0];
	    }
	  }, {
	    key: 'getText',
	    value: function getText() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload9 = overload(index, length);
	
	      var _overload10 = _slicedToArray(_overload9, 2);
	
	      index = _overload10[0];
	      length = _overload10[1];
	
	      return this.editor.getText(index, length);
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return this.selection.hasFocus();
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      var _this7 = this;
	
	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
	
	      return modify.call(this, function () {
	        return _this7.editor.insertEmbed(index, embed, value);
	      }, source, index);
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text, name, value, source) {
	      var _this8 = this;
	
	      var formats = void 0;
	
	      var _overload11 = overload(index, 0, name, value, source);
	
	      var _overload12 = _slicedToArray(_overload11, 4);
	
	      index = _overload12[0];
	      formats = _overload12[2];
	      source = _overload12[3];
	
	      return modify.call(this, function () {
	        return _this8.editor.insertText(index, text, formats);
	      }, source, index, text.length);
	    }
	  }, {
	    key: 'isEnabled',
	    value: function isEnabled() {
	      return !this.container.classList.contains('ql-disabled');
	    }
	  }, {
	    key: 'off',
	    value: function off() {
	      return this.emitter.off.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'on',
	    value: function on() {
	      return this.emitter.on.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'once',
	    value: function once() {
	      return this.emitter.once.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'pasteHTML',
	    value: function pasteHTML(index, html, source) {
	      this.clipboard.dangerouslyPasteHTML(index, html, source);
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length, source) {
	      var _this9 = this;
	
	      var _overload13 = overload(index, length, source);
	
	      var _overload14 = _slicedToArray(_overload13, 4);
	
	      index = _overload14[0];
	      length = _overload14[1];
	      source = _overload14[3];
	
	      return modify.call(this, function () {
	        return _this9.editor.removeFormat(index, length);
	      }, source, index);
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView() {
	      this.selection.scrollIntoView(this.scrollingContainer);
	    }
	  }, {
	    key: 'setContents',
	    value: function setContents(delta) {
	      var _this10 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        var length = _this10.getLength();
	        var deleted = _this10.editor.deleteText(0, length);
	        var applied = _this10.editor.applyDelta(delta);
	        var lastOp = applied.ops[applied.ops.length - 1];
	        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
	          _this10.editor.deleteText(_this10.getLength() - 1, 1);
	          applied.delete(1);
	        }
	        var ret = deleted.compose(applied);
	        return ret;
	      }, source);
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(index, length, source) {
	      if (index == null) {
	        this.selection.setRange(null, length || Quill.sources.API);
	      } else {
	        var _overload15 = overload(index, length, source);
	
	        var _overload16 = _slicedToArray(_overload15, 4);
	
	        index = _overload16[0];
	        length = _overload16[1];
	        source = _overload16[3];
	
	        this.selection.setRange(new _selection.Range(index, length), source);
	        if (source !== _emitter4.default.sources.SILENT) {
	          this.selection.scrollIntoView(this.scrollingContainer);
	        }
	      }
	    }
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      var delta = new _quillDelta2.default().insert(text);
	      return this.setContents(delta, source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
	      this.selection.update(source);
	      return change;
	    }
	  }, {
	    key: 'updateContents',
	    value: function updateContents(delta) {
	      var _this11 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        return _this11.editor.applyDelta(delta, source);
	      }, source, true);
	    }
	  }]);
	
	  return Quill;
	}();
	
	Quill.DEFAULTS = {
	  bounds: null,
	  formats: null,
	  modules: {},
	  placeholder: '',
	  readOnly: false,
	  scrollingContainer: null,
	  strict: true,
	  theme: 'default'
	};
	Quill.events = _emitter4.default.events;
	Quill.sources = _emitter4.default.sources;
	// eslint-disable-next-line no-undef
	Quill.version =  false ? 'dev' : "1.3.7";
	
	Quill.imports = {
	  'delta': _quillDelta2.default,
	  'parchment': _parchment2.default,
	  'core/module': _module2.default,
	  'core/theme': _theme2.default
	};
	
	function expandConfig(container, userConfig) {
	  userConfig = (0, _extend2.default)(true, {
	    container: container,
	    modules: {
	      clipboard: true,
	      keyboard: true,
	      history: true
	    }
	  }, userConfig);
	  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
	    userConfig.theme = _theme2.default;
	  } else {
	    userConfig.theme = Quill.import('themes/' + userConfig.theme);
	    if (userConfig.theme == null) {
	      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
	    }
	  }
	  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
	  [themeConfig, userConfig].forEach(function (config) {
	    config.modules = config.modules || {};
	    Object.keys(config.modules).forEach(function (module) {
	      if (config.modules[module] === true) {
	        config.modules[module] = {};
	      }
	    });
	  });
	  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
	  var moduleConfig = moduleNames.reduce(function (config, name) {
	    var moduleClass = Quill.import('modules/' + name);
	    if (moduleClass == null) {
	      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
	    } else {
	      config[name] = moduleClass.DEFAULTS || {};
	    }
	    return config;
	  }, {});
	  // Special case toolbar shorthand
	  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
	    userConfig.modules.toolbar = {
	      container: userConfig.modules.toolbar
	    };
	  }
	  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
	  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
	    if (typeof userConfig[key] === 'string') {
	      userConfig[key] = document.querySelector(userConfig[key]);
	    }
	  });
	  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
	    if (userConfig.modules[name]) {
	      config[name] = userConfig.modules[name];
	    }
	    return config;
	  }, {});
	  return userConfig;
	}
	
	// Handle selection preservation and TEXT_CHANGE emission
	// common to modification APIs
	function modify(modifier, source, index, shift) {
	  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
	    return new _quillDelta2.default();
	  }
	  var range = index == null ? null : this.getSelection();
	  var oldDelta = this.editor.delta;
	  var change = modifier();
	  if (range != null) {
	    if (index === true) index = range.index;
	    if (shift == null) {
	      range = shiftRange(range, change, source);
	    } else if (shift !== 0) {
	      range = shiftRange(range, index, shift, source);
	    }
	    this.setSelection(range, _emitter4.default.sources.SILENT);
	  }
	  if (change.length() > 0) {
	    var _emitter;
	
	    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
	    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	    if (source !== _emitter4.default.sources.SILENT) {
	      var _emitter2;
	
	      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	    }
	  }
	  return change;
	}
	
	function overload(index, length, name, value, source) {
	  var formats = {};
	  if (typeof index.index === 'number' && typeof index.length === 'number') {
	    // Allow for throwaway end (used by insertText/insertEmbed)
	    if (typeof length !== 'number') {
	      source = value, value = name, name = length, length = index.length, index = index.index;
	    } else {
	      length = index.length, index = index.index;
	    }
	  } else if (typeof length !== 'number') {
	    source = value, value = name, name = length, length = 0;
	  }
	  // Handle format being object, two format name/value strings or excluded
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    formats = name;
	    source = value;
	  } else if (typeof name === 'string') {
	    if (value != null) {
	      formats[name] = value;
	    } else {
	      source = name;
	    }
	  }
	  // Handle optional source
	  source = source || _emitter4.default.sources.API;
	  return [index, length, formats, source];
	}
	
	function shiftRange(range, index, length, source) {
	  if (range == null) return null;
	  var start = void 0,
	      end = void 0;
	  if (index instanceof _quillDelta2.default) {
	    var _map = [range.index, range.index + range.length].map(function (pos) {
	      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
	    });
	
	    var _map2 = _slicedToArray(_map, 2);
	
	    start = _map2[0];
	    end = _map2[1];
	  } else {
	    var _map3 = [range.index, range.index + range.length].map(function (pos) {
	      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
	      if (length >= 0) {
	        return pos + length;
	      } else {
	        return Math.max(index, pos + length);
	      }
	    });
	
	    var _map4 = _slicedToArray(_map3, 2);
	
	    start = _map4[0];
	    end = _map4[1];
	  }
	  return new _selection.Range(start, end - start);
	}
	
	exports.expandConfig = expandConfig;
	exports.overload = overload;
	exports.default = Quill;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Inline = function (_Parchment$Inline) {
	  _inherits(Inline, _Parchment$Inline);
	
	  function Inline() {
	    _classCallCheck(this, Inline);
	
	    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
	  }
	
	  _createClass(Inline, [{
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
	        var blot = this.isolate(index, length);
	        if (value) {
	          blot.wrap(name, value);
	        }
	      } else {
	        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
	      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
	        var parent = this.parent.isolate(this.offset(), this.length());
	        this.moveChildren(parent);
	        parent.wrap(this);
	      }
	    }
	  }], [{
	    key: 'compare',
	    value: function compare(self, other) {
	      var selfIndex = Inline.order.indexOf(self);
	      var otherIndex = Inline.order.indexOf(other);
	      if (selfIndex >= 0 || otherIndex >= 0) {
	        return selfIndex - otherIndex;
	      } else if (self === other) {
	        return 0;
	      } else if (self < other) {
	        return -1;
	      } else {
	        return 1;
	      }
	    }
	  }]);
	
	  return Inline;
	}(_parchment2.default.Inline);
	
	Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
	// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
	Inline.order = ['cursor', 'inline', // Must be lower
	'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
	];
	
	exports.default = Inline;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextBlot = function (_Parchment$Text) {
	  _inherits(TextBlot, _Parchment$Text);
	
	  function TextBlot() {
	    _classCallCheck(this, TextBlot);
	
	    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
	  }
	
	  return TextBlot;
	}(_parchment2.default.Text);
	
	exports.default = TextBlot;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _eventemitter = __webpack_require__(54);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:events');
	
	var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];
	
	EVENTS.forEach(function (eventName) {
	  document.addEventListener(eventName, function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
	      // TODO use WeakMap
	      if (node.__quill && node.__quill.emitter) {
	        var _node$__quill$emitter;
	
	        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
	      }
	    });
	  });
	});
	
	var Emitter = function (_EventEmitter) {
	  _inherits(Emitter, _EventEmitter);
	
	  function Emitter() {
	    _classCallCheck(this, Emitter);
	
	    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
	
	    _this.listeners = {};
	    _this.on('error', debug.error);
	    return _this;
	  }
	
	  _createClass(Emitter, [{
	    key: 'emit',
	    value: function emit() {
	      debug.log.apply(debug, arguments);
	      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
	    }
	  }, {
	    key: 'handleDOM',
	    value: function handleDOM(event) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      (this.listeners[event.type] || []).forEach(function (_ref) {
	        var node = _ref.node,
	            handler = _ref.handler;
	
	        if (event.target === node || node.contains(event.target)) {
	          handler.apply(undefined, [event].concat(args));
	        }
	      });
	    }
	  }, {
	    key: 'listenDOM',
	    value: function listenDOM(eventName, node, handler) {
	      if (!this.listeners[eventName]) {
	        this.listeners[eventName] = [];
	      }
	      this.listeners[eventName].push({ node: node, handler: handler });
	    }
	  }]);
	
	  return Emitter;
	}(_eventemitter2.default);
	
	Emitter.events = {
	  EDITOR_CHANGE: 'editor-change',
	  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
	  SCROLL_OPTIMIZE: 'scroll-optimize',
	  SCROLL_UPDATE: 'scroll-update',
	  SELECTION_CHANGE: 'selection-change',
	  TEXT_CHANGE: 'text-change'
	};
	Emitter.sources = {
	  API: 'api',
	  SILENT: 'silent',
	  USER: 'user'
	};
	
	exports.default = Emitter;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Module = function Module(quill) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  _classCallCheck(this, Module);
	
	  this.quill = quill;
	  this.options = options;
	};
	
	Module.DEFAULTS = {};
	
	exports.default = Module;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var levels = ['error', 'warn', 'log', 'info'];
	var level = 'warn';
	
	function debug(method) {
	  if (levels.indexOf(method) <= levels.indexOf(level)) {
	    var _console;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
	  }
	}
	
	function namespace(ns) {
	  return levels.reduce(function (logger, method) {
	    logger[method] = debug.bind(console, method, ns);
	    return logger;
	  }, {});
	}
	
	debug.level = namespace.level = function (newLevel) {
	  level = newLevel;
	};
	
	exports.default = namespace;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(52);
	var isArguments = __webpack_require__(53);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var Attributor = /** @class */ (function () {
	    function Attributor(attrName, keyName, options) {
	        if (options === void 0) { options = {}; }
	        this.attrName = attrName;
	        this.keyName = keyName;
	        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
	        if (options.scope != null) {
	            // Ignore type bits, force attribute bit
	            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
	        }
	        else {
	            this.scope = Registry.Scope.ATTRIBUTE;
	        }
	        if (options.whitelist != null)
	            this.whitelist = options.whitelist;
	    }
	    Attributor.keys = function (node) {
	        return [].map.call(node.attributes, function (item) {
	            return item.name;
	        });
	    };
	    Attributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        node.setAttribute(this.keyName, value);
	        return true;
	    };
	    Attributor.prototype.canAdd = function (node, value) {
	        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
	        if (match == null)
	            return false;
	        if (this.whitelist == null)
	            return true;
	        if (typeof value === 'string') {
	            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
	        }
	        else {
	            return this.whitelist.indexOf(value) > -1;
	        }
	    };
	    Attributor.prototype.remove = function (node) {
	        node.removeAttribute(this.keyName);
	    };
	    Attributor.prototype.value = function (node) {
	        var value = node.getAttribute(this.keyName);
	        if (this.canAdd(node, value) && value) {
	            return value;
	        }
	        return '';
	    };
	    return Attributor;
	}());
	exports.default = Attributor;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Code = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Code = function (_Inline) {
	  _inherits(Code, _Inline);
	
	  function Code() {
	    _classCallCheck(this, Code);
	
	    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
	  }
	
	  return Code;
	}(_inline2.default);
	
	Code.blotName = 'code';
	Code.tagName = 'CODE';
	
	var CodeBlock = function (_Block) {
	  _inherits(CodeBlock, _Block);
	
	  function CodeBlock() {
	    _classCallCheck(this, CodeBlock);
	
	    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(CodeBlock, [{
	    key: 'delta',
	    value: function delta() {
	      var _this3 = this;
	
	      var text = this.domNode.textContent;
	      if (text.endsWith('\n')) {
	        // Should always be true
	        text = text.slice(0, -1);
	      }
	      return text.split('\n').reduce(function (delta, frag) {
	        return delta.insert(frag).insert('\n', _this3.formats());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (name === this.statics.blotName && value) return;
	
	      var _descendant = this.descendant(_text2.default, this.length() - 1),
	          _descendant2 = _slicedToArray(_descendant, 1),
	          text = _descendant2[0];
	
	      if (text != null) {
	        text.deleteAt(text.length() - 1, 1);
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length === 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
	        return;
	      }
	      var nextNewline = this.newlineIndex(index);
	      if (nextNewline < 0 || nextNewline >= index + length) return;
	      var prevNewline = this.newlineIndex(index, true) + 1;
	      var isolateLength = nextNewline - prevNewline + 1;
	      var blot = this.isolate(prevNewline, isolateLength);
	      var next = blot.next;
	      blot.format(name, value);
	      if (next instanceof CodeBlock) {
	        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
	      }
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return;
	
	      var _descendant3 = this.descendant(_text2.default, index),
	          _descendant4 = _slicedToArray(_descendant3, 2),
	          text = _descendant4[0],
	          offset = _descendant4[1];
	
	      text.insertAt(offset, value);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      var length = this.domNode.textContent.length;
	      if (!this.domNode.textContent.endsWith('\n')) {
	        return length + 1;
	      }
	      return length;
	    }
	  }, {
	    key: 'newlineIndex',
	    value: function newlineIndex(searchIndex) {
	      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!reverse) {
	        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
	        return offset > -1 ? searchIndex + offset : -1;
	      } else {
	        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      if (!this.domNode.textContent.endsWith('\n')) {
	        this.appendChild(_parchment2.default.create('text', '\n'));
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
	        next.optimize(context);
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
	      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
	        var blot = _parchment2.default.find(node);
	        if (blot == null) {
	          node.parentNode.removeChild(node);
	        } else if (blot instanceof _parchment2.default.Embed) {
	          blot.remove();
	        } else {
	          blot.unwrap();
	        }
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
	      domNode.setAttribute('spellcheck', false);
	      return domNode;
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return CodeBlock;
	}(_block2.default);
	
	CodeBlock.blotName = 'code-block';
	CodeBlock.tagName = 'PRE';
	CodeBlock.TAB = '  ';
	
	exports.Code = Code;
	exports.default = CodeBlock;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ASCII = /^[ -~]*$/;
	
	var Editor = function () {
	  function Editor(scroll) {
	    _classCallCheck(this, Editor);
	
	    this.scroll = scroll;
	    this.delta = this.getDelta();
	  }
	
	  _createClass(Editor, [{
	    key: 'applyDelta',
	    value: function applyDelta(delta) {
	      var _this = this;
	
	      var consumeNextNewline = false;
	      this.scroll.update();
	      var scrollLength = this.scroll.length();
	      this.scroll.batchStart();
	      delta = normalizeDelta(delta);
	      delta.reduce(function (index, op) {
	        var length = op.retain || op.delete || op.insert.length || 1;
	        var attributes = op.attributes || {};
	        if (op.insert != null) {
	          if (typeof op.insert === 'string') {
	            var text = op.insert;
	            if (text.endsWith('\n') && consumeNextNewline) {
	              consumeNextNewline = false;
	              text = text.slice(0, -1);
	            }
	            if (index >= scrollLength && !text.endsWith('\n')) {
	              consumeNextNewline = true;
	            }
	            _this.scroll.insertAt(index, text);
	
	            var _scroll$line = _this.scroll.line(index),
	                _scroll$line2 = _slicedToArray(_scroll$line, 2),
	                line = _scroll$line2[0],
	                offset = _scroll$line2[1];
	
	            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
	            if (line instanceof _block2.default) {
	              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
	                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
	                  leaf = _line$descendant2[0];
	
	              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
	            }
	            attributes = _op2.default.attributes.diff(formats, attributes) || {};
	          } else if (_typeof(op.insert) === 'object') {
	            var key = Object.keys(op.insert)[0]; // There should only be one key
	            if (key == null) return index;
	            _this.scroll.insertAt(index, key, op.insert[key]);
	          }
	          scrollLength += length;
	        }
	        Object.keys(attributes).forEach(function (name) {
	          _this.scroll.formatAt(index, length, name, attributes[name]);
	        });
	        return index + length;
	      }, 0);
	      delta.reduce(function (index, op) {
	        if (typeof op.delete === 'number') {
	          _this.scroll.deleteAt(index, op.delete);
	          return index;
	        }
	        return index + (op.retain || op.insert.length || 1);
	      }, 0);
	      this.scroll.batchEnd();
	      return this.update(delta);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length) {
	      this.scroll.deleteAt(index, length);
	      return this.update(new _quillDelta2.default().retain(index).delete(length));
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length) {
	      var _this2 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      this.scroll.update();
	      Object.keys(formats).forEach(function (format) {
	        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
	        var lines = _this2.scroll.lines(index, Math.max(length, 1));
	        var lengthRemaining = length;
	        lines.forEach(function (line) {
	          var lineLength = line.length();
	          if (!(line instanceof _code2.default)) {
	            line.format(format, formats[format]);
	          } else {
	            var codeIndex = index - line.offset(_this2.scroll);
	            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
	            line.formatAt(codeIndex, codeLength, format, formats[format]);
	          }
	          lengthRemaining -= lineLength;
	        });
	      });
	      this.scroll.optimize();
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length) {
	      var _this3 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      Object.keys(formats).forEach(function (format) {
	        _this3.scroll.formatAt(index, length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents(index, length) {
	      return this.delta.slice(index, index + length);
	    }
	  }, {
	    key: 'getDelta',
	    value: function getDelta() {
	      return this.scroll.lines().reduce(function (delta, line) {
	        return delta.concat(line.delta());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var lines = [],
	          leaves = [];
	      if (length === 0) {
	        this.scroll.path(index).forEach(function (path) {
	          var _path = _slicedToArray(path, 1),
	              blot = _path[0];
	
	          if (blot instanceof _block2.default) {
	            lines.push(blot);
	          } else if (blot instanceof _parchment2.default.Leaf) {
	            leaves.push(blot);
	          }
	        });
	      } else {
	        lines = this.scroll.lines(index, length);
	        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
	      }
	      var formatsArr = [lines, leaves].map(function (blots) {
	        if (blots.length === 0) return {};
	        var formats = (0, _block.bubbleFormats)(blots.shift());
	        while (Object.keys(formats).length > 0) {
	          var blot = blots.shift();
	          if (blot == null) return formats;
	          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
	        }
	        return formats;
	      });
	      return _extend2.default.apply(_extend2.default, formatsArr);
	    }
	  }, {
	    key: 'getText',
	    value: function getText(index, length) {
	      return this.getContents(index, length).filter(function (op) {
	        return typeof op.insert === 'string';
	      }).map(function (op) {
	        return op.insert;
	      }).join('');
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      this.scroll.insertAt(index, embed, value);
	      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text) {
	      var _this4 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      this.scroll.insertAt(index, text);
	      Object.keys(formats).forEach(function (format) {
	        _this4.scroll.formatAt(index, text.length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'isBlank',
	    value: function isBlank() {
	      if (this.scroll.children.length == 0) return true;
	      if (this.scroll.children.length > 1) return false;
	      var block = this.scroll.children.head;
	      if (block.statics.blotName !== _block2.default.blotName) return false;
	      if (block.children.length > 1) return false;
	      return block.children.head instanceof _break2.default;
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length) {
	      var text = this.getText(index, length);
	
	      var _scroll$line3 = this.scroll.line(index + length),
	          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
	          line = _scroll$line4[0],
	          offset = _scroll$line4[1];
	
	      var suffixLength = 0,
	          suffix = new _quillDelta2.default();
	      if (line != null) {
	        if (!(line instanceof _code2.default)) {
	          suffixLength = line.length() - offset;
	        } else {
	          suffixLength = line.newlineIndex(offset) - offset + 1;
	        }
	        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
	      }
	      var contents = this.getContents(index, length + suffixLength);
	      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
	      var delta = new _quillDelta2.default().retain(index).concat(diff);
	      return this.applyDelta(delta);
	    }
	  }, {
	    key: 'update',
	    value: function update(change) {
	      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	      var oldDelta = this.delta;
	      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
	        // Optimization for character changes
	        var textBlot = _parchment2.default.find(mutations[0].target);
	        var formats = (0, _block.bubbleFormats)(textBlot);
	        var index = textBlot.offset(this.scroll);
	        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
	        var oldText = new _quillDelta2.default().insert(oldValue);
	        var newText = new _quillDelta2.default().insert(textBlot.value());
	        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
	        change = diffDelta.reduce(function (delta, op) {
	          if (op.insert) {
	            return delta.insert(op.insert, formats);
	          } else {
	            return delta.push(op);
	          }
	        }, new _quillDelta2.default());
	        this.delta = oldDelta.compose(change);
	      } else {
	        this.delta = this.getDelta();
	        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
	          change = oldDelta.diff(this.delta, cursorIndex);
	        }
	      }
	      return change;
	    }
	  }]);
	
	  return Editor;
	}();
	
	function combineFormats(formats, combined) {
	  return Object.keys(combined).reduce(function (merged, name) {
	    if (formats[name] == null) return merged;
	    if (combined[name] === formats[name]) {
	      merged[name] = combined[name];
	    } else if (Array.isArray(combined[name])) {
	      if (combined[name].indexOf(formats[name]) < 0) {
	        merged[name] = combined[name].concat([formats[name]]);
	      }
	    } else {
	      merged[name] = [combined[name], formats[name]];
	    }
	    return merged;
	  }, {});
	}
	
	function normalizeDelta(delta) {
	  return delta.reduce(function (delta, op) {
	    if (op.insert === 1) {
	      var attributes = (0, _clone2.default)(op.attributes);
	      delete attributes['image'];
	      return delta.insert({ image: op.attributes.image }, attributes);
	    }
	    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
	      op = (0, _clone2.default)(op);
	      if (op.attributes.list) {
	        op.attributes.list = 'ordered';
	      } else {
	        op.attributes.list = 'bullet';
	        delete op.attributes.bullet;
	      }
	    }
	    if (typeof op.insert === 'string') {
	      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      return delta.insert(text, op.attributes);
	    }
	    return delta.push(op);
	  }, new _quillDelta2.default());
	}
	
	exports.default = Editor;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Range = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill:selection');
	
	var Range = function Range(index) {
	  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  _classCallCheck(this, Range);
	
	  this.index = index;
	  this.length = length;
	};
	
	var Selection = function () {
	  function Selection(scroll, emitter) {
	    var _this = this;
	
	    _classCallCheck(this, Selection);
	
	    this.emitter = emitter;
	    this.scroll = scroll;
	    this.composing = false;
	    this.mouseDown = false;
	    this.root = this.scroll.domNode;
	    this.cursor = _parchment2.default.create('cursor', this);
	    // savedRange is last non-null range
	    this.lastRange = this.savedRange = new Range(0, 0);
	    this.handleComposition();
	    this.handleDragging();
	    this.emitter.listenDOM('selectionchange', document, function () {
	      if (!_this.mouseDown) {
	        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
	      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
	        _this.update(_emitter4.default.sources.SILENT);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
	      if (!_this.hasFocus()) return;
	      var native = _this.getNativeRange();
	      if (native == null) return;
	      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
	      // TODO unclear if this has negative side effects
	      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
	        try {
	          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
	        } catch (ignored) {}
	      });
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
	      if (context.range) {
	        var _context$range = context.range,
	            startNode = _context$range.startNode,
	            startOffset = _context$range.startOffset,
	            endNode = _context$range.endNode,
	            endOffset = _context$range.endOffset;
	
	        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
	      }
	    });
	    this.update(_emitter4.default.sources.SILENT);
	  }
	
	  _createClass(Selection, [{
	    key: 'handleComposition',
	    value: function handleComposition() {
	      var _this2 = this;
	
	      this.root.addEventListener('compositionstart', function () {
	        _this2.composing = true;
	      });
	      this.root.addEventListener('compositionend', function () {
	        _this2.composing = false;
	        if (_this2.cursor.parent) {
	          var range = _this2.cursor.restore();
	          if (!range) return;
	          setTimeout(function () {
	            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
	          }, 1);
	        }
	      });
	    }
	  }, {
	    key: 'handleDragging',
	    value: function handleDragging() {
	      var _this3 = this;
	
	      this.emitter.listenDOM('mousedown', document.body, function () {
	        _this3.mouseDown = true;
	      });
	      this.emitter.listenDOM('mouseup', document.body, function () {
	        _this3.mouseDown = false;
	        _this3.update(_emitter4.default.sources.USER);
	      });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.hasFocus()) return;
	      this.root.focus();
	      this.setRange(this.savedRange);
	    }
	  }, {
	    key: 'format',
	    value: function format(_format, value) {
	      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
	      this.scroll.update();
	      var nativeRange = this.getNativeRange();
	      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
	      if (nativeRange.start.node !== this.cursor.textNode) {
	        var blot = _parchment2.default.find(nativeRange.start.node, false);
	        if (blot == null) return;
	        // TODO Give blot ability to not split
	        if (blot instanceof _parchment2.default.Leaf) {
	          var after = blot.split(nativeRange.start.offset);
	          blot.parent.insertBefore(this.cursor, after);
	        } else {
	          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
	        }
	        this.cursor.attach();
	      }
	      this.cursor.format(_format, value);
	      this.scroll.optimize();
	      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
	      this.update();
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var scrollLength = this.scroll.length();
	      index = Math.min(index, scrollLength - 1);
	      length = Math.min(index + length, scrollLength - 1) - index;
	      var node = void 0,
	          _scroll$leaf = this.scroll.leaf(index),
	          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
	          leaf = _scroll$leaf2[0],
	          offset = _scroll$leaf2[1];
	      if (leaf == null) return null;
	
	      var _leaf$position = leaf.position(offset, true);
	
	      var _leaf$position2 = _slicedToArray(_leaf$position, 2);
	
	      node = _leaf$position2[0];
	      offset = _leaf$position2[1];
	
	      var range = document.createRange();
	      if (length > 0) {
	        range.setStart(node, offset);
	
	        var _scroll$leaf3 = this.scroll.leaf(index + length);
	
	        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
	
	        leaf = _scroll$leaf4[0];
	        offset = _scroll$leaf4[1];
	
	        if (leaf == null) return null;
	
	        var _leaf$position3 = leaf.position(offset, true);
	
	        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
	
	        node = _leaf$position4[0];
	        offset = _leaf$position4[1];
	
	        range.setEnd(node, offset);
	        return range.getBoundingClientRect();
	      } else {
	        var side = 'left';
	        var rect = void 0;
	        if (node instanceof Text) {
	          if (offset < node.data.length) {
	            range.setStart(node, offset);
	            range.setEnd(node, offset + 1);
	          } else {
	            range.setStart(node, offset - 1);
	            range.setEnd(node, offset);
	            side = 'right';
	          }
	          rect = range.getBoundingClientRect();
	        } else {
	          rect = leaf.domNode.getBoundingClientRect();
	          if (offset > 0) side = 'right';
	        }
	        return {
	          bottom: rect.top + rect.height,
	          height: rect.height,
	          left: rect[side],
	          right: rect[side],
	          top: rect.top,
	          width: 0
	        };
	      }
	    }
	  }, {
	    key: 'getNativeRange',
	    value: function getNativeRange() {
	      var selection = document.getSelection();
	      if (selection == null || selection.rangeCount <= 0) return null;
	      var nativeRange = selection.getRangeAt(0);
	      if (nativeRange == null) return null;
	      var range = this.normalizeNative(nativeRange);
	      debug.info('getNativeRange', range);
	      return range;
	    }
	  }, {
	    key: 'getRange',
	    value: function getRange() {
	      var normalized = this.getNativeRange();
	      if (normalized == null) return [null, null];
	      var range = this.normalizedToRange(normalized);
	      return [range, normalized];
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return document.activeElement === this.root;
	    }
	  }, {
	    key: 'normalizedToRange',
	    value: function normalizedToRange(range) {
	      var _this4 = this;
	
	      var positions = [[range.start.node, range.start.offset]];
	      if (!range.native.collapsed) {
	        positions.push([range.end.node, range.end.offset]);
	      }
	      var indexes = positions.map(function (position) {
	        var _position = _slicedToArray(position, 2),
	            node = _position[0],
	            offset = _position[1];
	
	        var blot = _parchment2.default.find(node, true);
	        var index = blot.offset(_this4.scroll);
	        if (offset === 0) {
	          return index;
	        } else if (blot instanceof _parchment2.default.Container) {
	          return index + blot.length();
	        } else {
	          return index + blot.index(node, offset);
	        }
	      });
	      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
	      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
	      return new Range(start, end - start);
	    }
	  }, {
	    key: 'normalizeNative',
	    value: function normalizeNative(nativeRange) {
	      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
	        return null;
	      }
	      var range = {
	        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
	        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
	        native: nativeRange
	      };
	      [range.start, range.end].forEach(function (position) {
	        var node = position.node,
	            offset = position.offset;
	        while (!(node instanceof Text) && node.childNodes.length > 0) {
	          if (node.childNodes.length > offset) {
	            node = node.childNodes[offset];
	            offset = 0;
	          } else if (node.childNodes.length === offset) {
	            node = node.lastChild;
	            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
	          } else {
	            break;
	          }
	        }
	        position.node = node, position.offset = offset;
	      });
	      return range;
	    }
	  }, {
	    key: 'rangeToNative',
	    value: function rangeToNative(range) {
	      var _this5 = this;
	
	      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
	      var args = [];
	      var scrollLength = this.scroll.length();
	      indexes.forEach(function (index, i) {
	        index = Math.min(scrollLength - 1, index);
	        var node = void 0,
	            _scroll$leaf5 = _this5.scroll.leaf(index),
	            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
	            leaf = _scroll$leaf6[0],
	            offset = _scroll$leaf6[1];
	        var _leaf$position5 = leaf.position(offset, i !== 0);
	
	        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
	
	        node = _leaf$position6[0];
	        offset = _leaf$position6[1];
	
	        args.push(node, offset);
	      });
	      if (args.length < 2) {
	        args = args.concat(args);
	      }
	      return args;
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView(scrollingContainer) {
	      var range = this.lastRange;
	      if (range == null) return;
	      var bounds = this.getBounds(range.index, range.length);
	      if (bounds == null) return;
	      var limit = this.scroll.length() - 1;
	
	      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
	          _scroll$line2 = _slicedToArray(_scroll$line, 1),
	          first = _scroll$line2[0];
	
	      var last = first;
	      if (range.length > 0) {
	        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
	
	        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
	
	        last = _scroll$line4[0];
	      }
	      if (first == null || last == null) return;
	      var scrollBounds = scrollingContainer.getBoundingClientRect();
	      if (bounds.top < scrollBounds.top) {
	        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
	      } else if (bounds.bottom > scrollBounds.bottom) {
	        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
	      }
	    }
	  }, {
	    key: 'setNativeRange',
	    value: function setNativeRange(startNode, startOffset) {
	      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
	      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
	      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
	      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
	        return;
	      }
	      var selection = document.getSelection();
	      if (selection == null) return;
	      if (startNode != null) {
	        if (!this.hasFocus()) this.root.focus();
	        var native = (this.getNativeRange() || {}).native;
	        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
	
	          if (startNode.tagName == "BR") {
	            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
	            startNode = startNode.parentNode;
	          }
	          if (endNode.tagName == "BR") {
	            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
	            endNode = endNode.parentNode;
	          }
	          var range = document.createRange();
	          range.setStart(startNode, startOffset);
	          range.setEnd(endNode, endOffset);
	          selection.removeAllRanges();
	          selection.addRange(range);
	        }
	      } else {
	        selection.removeAllRanges();
	        this.root.blur();
	        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
	      }
	    }
	  }, {
	    key: 'setRange',
	    value: function setRange(range) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      if (typeof force === 'string') {
	        source = force;
	        force = false;
	      }
	      debug.info('setRange', range);
	      if (range != null) {
	        var args = this.rangeToNative(range);
	        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
	      } else {
	        this.setNativeRange(null);
	      }
	      this.update(source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var oldRange = this.lastRange;
	
	      var _getRange = this.getRange(),
	          _getRange2 = _slicedToArray(_getRange, 2),
	          lastRange = _getRange2[0],
	          nativeRange = _getRange2[1];
	
	      this.lastRange = lastRange;
	      if (this.lastRange != null) {
	        this.savedRange = this.lastRange;
	      }
	      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
	        var _emitter;
	
	        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
	          this.cursor.restore();
	        }
	        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
	        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	        if (source !== _emitter4.default.sources.SILENT) {
	          var _emitter2;
	
	          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	        }
	      }
	    }
	  }]);
	
	  return Selection;
	}();
	
	function contains(parent, descendant) {
	  try {
	    // Firefox inserts inaccessible nodes around video elements
	    descendant.parentNode;
	  } catch (e) {
	    return false;
	  }
	  // IE11 has bug with Text nodes
	  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
	  if (descendant instanceof Text) {
	    descendant = descendant.parentNode;
	  }
	  return parent.contains(descendant);
	}
	
	exports.Range = Range;
	exports.default = Selection;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Break = function (_Parchment$Embed) {
	  _inherits(Break, _Parchment$Embed);
	
	  function Break() {
	    _classCallCheck(this, Break);
	
	    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
	  }
	
	  _createClass(Break, [{
	    key: 'insertInto',
	    value: function insertInto(parent, ref) {
	      if (parent.children.length === 0) {
	        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
	      } else {
	        this.remove();
	      }
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return 0;
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }], [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  return Break;
	}(_parchment2.default.Embed);
	
	Break.blotName = 'break';
	Break.tagName = 'BR';
	
	exports.default = Break;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var linked_list_1 = __webpack_require__(44);
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var ContainerBlot = /** @class */ (function (_super) {
	    __extends(ContainerBlot, _super);
	    function ContainerBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.build();
	        return _this;
	    }
	    ContainerBlot.prototype.appendChild = function (other) {
	        this.insertBefore(other);
	    };
	    ContainerBlot.prototype.attach = function () {
	        _super.prototype.attach.call(this);
	        this.children.forEach(function (child) {
	            child.attach();
	        });
	    };
	    ContainerBlot.prototype.build = function () {
	        var _this = this;
	        this.children = new linked_list_1.default();
	        // Need to be reversed for if DOM nodes already in order
	        [].slice
	            .call(this.domNode.childNodes)
	            .reverse()
	            .forEach(function (node) {
	            try {
	                var child = makeBlot(node);
	                _this.insertBefore(child, _this.children.head || undefined);
	            }
	            catch (err) {
	                if (err instanceof Registry.ParchmentError)
	                    return;
	                else
	                    throw err;
	            }
	        });
	    };
	    ContainerBlot.prototype.deleteAt = function (index, length) {
	        if (index === 0 && length === this.length()) {
	            return this.remove();
	        }
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.deleteAt(offset, length);
	        });
	    };
	    ContainerBlot.prototype.descendant = function (criteria, index) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if ((criteria.blotName == null && criteria(child)) ||
	            (criteria.blotName != null && child instanceof criteria)) {
	            return [child, offset];
	        }
	        else if (child instanceof ContainerBlot) {
	            return child.descendant(criteria, offset);
	        }
	        else {
	            return [null, -1];
	        }
	    };
	    ContainerBlot.prototype.descendants = function (criteria, index, length) {
	        if (index === void 0) { index = 0; }
	        if (length === void 0) { length = Number.MAX_VALUE; }
	        var descendants = [];
	        var lengthLeft = length;
	        this.children.forEachAt(index, length, function (child, index, length) {
	            if ((criteria.blotName == null && criteria(child)) ||
	                (criteria.blotName != null && child instanceof criteria)) {
	                descendants.push(child);
	            }
	            if (child instanceof ContainerBlot) {
	                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
	            }
	            lengthLeft -= length;
	        });
	        return descendants;
	    };
	    ContainerBlot.prototype.detach = function () {
	        this.children.forEach(function (child) {
	            child.detach();
	        });
	        _super.prototype.detach.call(this);
	    };
	    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.formatAt(offset, length, name, value);
	        });
	    };
	    ContainerBlot.prototype.insertAt = function (index, value, def) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if (child) {
	            child.insertAt(offset, value, def);
	        }
	        else {
	            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	            this.appendChild(blot);
	        }
	    };
	    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
	        if (this.statics.allowedChildren != null &&
	            !this.statics.allowedChildren.some(function (child) {
	                return childBlot instanceof child;
	            })) {
	            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
	        }
	        childBlot.insertInto(this, refBlot);
	    };
	    ContainerBlot.prototype.length = function () {
	        return this.children.reduce(function (memo, child) {
	            return memo + child.length();
	        }, 0);
	    };
	    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
	        this.children.forEach(function (child) {
	            targetParent.insertBefore(child, refNode);
	        });
	    };
	    ContainerBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        if (this.children.length === 0) {
	            if (this.statics.defaultChild != null) {
	                var child = Registry.create(this.statics.defaultChild);
	                this.appendChild(child);
	                child.optimize(context);
	            }
	            else {
	                this.remove();
	            }
	        }
	    };
	    ContainerBlot.prototype.path = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
	        var position = [[this, index]];
	        if (child instanceof ContainerBlot) {
	            return position.concat(child.path(offset, inclusive));
	        }
	        else if (child != null) {
	            position.push([child, offset]);
	        }
	        return position;
	    };
	    ContainerBlot.prototype.removeChild = function (child) {
	        this.children.remove(child);
	    };
	    ContainerBlot.prototype.replace = function (target) {
	        if (target instanceof ContainerBlot) {
	            target.moveChildren(this);
	        }
	        _super.prototype.replace.call(this, target);
	    };
	    ContainerBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = this.clone();
	        this.parent.insertBefore(after, this.next);
	        this.children.forEachAt(index, this.length(), function (child, offset, length) {
	            child = child.split(offset, force);
	            after.appendChild(child);
	        });
	        return after;
	    };
	    ContainerBlot.prototype.unwrap = function () {
	        this.moveChildren(this.parent, this.next);
	        this.remove();
	    };
	    ContainerBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        var addedNodes = [];
	        var removedNodes = [];
	        mutations.forEach(function (mutation) {
	            if (mutation.target === _this.domNode && mutation.type === 'childList') {
	                addedNodes.push.apply(addedNodes, mutation.addedNodes);
	                removedNodes.push.apply(removedNodes, mutation.removedNodes);
	            }
	        });
	        removedNodes.forEach(function (node) {
	            // Check node has actually been removed
	            // One exception is Chrome does not immediately remove IFRAMEs
	            // from DOM but MutationRecord is correct in its reported removal
	            if (node.parentNode != null &&
	                // @ts-ignore
	                node.tagName !== 'IFRAME' &&
	                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	                return;
	            }
	            var blot = Registry.find(node);
	            if (blot == null)
	                return;
	            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
	                blot.detach();
	            }
	        });
	        addedNodes
	            .filter(function (node) {
	            return node.parentNode == _this.domNode;
	        })
	            .sort(function (a, b) {
	            if (a === b)
	                return 0;
	            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
	                return 1;
	            }
	            return -1;
	        })
	            .forEach(function (node) {
	            var refBlot = null;
	            if (node.nextSibling != null) {
	                refBlot = Registry.find(node.nextSibling);
	            }
	            var blot = makeBlot(node);
	            if (blot.next != refBlot || blot.next == null) {
	                if (blot.parent != null) {
	                    blot.parent.removeChild(_this);
	                }
	                _this.insertBefore(blot, refBlot || undefined);
	            }
	        });
	    };
	    return ContainerBlot;
	}(shadow_1.default));
	function makeBlot(node) {
	    var blot = Registry.find(node);
	    if (blot == null) {
	        try {
	            blot = Registry.create(node);
	        }
	        catch (e) {
	            blot = Registry.create(Registry.Scope.INLINE);
	            [].slice.call(node.childNodes).forEach(function (child) {
	                // @ts-ignore
	                blot.domNode.appendChild(child);
	            });
	            if (node.parentNode) {
	                node.parentNode.replaceChild(blot.domNode, node);
	            }
	            blot.attach();
	        }
	    }
	    return blot;
	}
	exports.default = ContainerBlot;
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var store_1 = __webpack_require__(31);
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var FormatBlot = /** @class */ (function (_super) {
	    __extends(FormatBlot, _super);
	    function FormatBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.attributes = new store_1.default(_this.domNode);
	        return _this;
	    }
	    FormatBlot.formats = function (domNode) {
	        if (typeof this.tagName === 'string') {
	            return true;
	        }
	        else if (Array.isArray(this.tagName)) {
	            return domNode.tagName.toLowerCase();
	        }
	        return undefined;
	    };
	    FormatBlot.prototype.format = function (name, value) {
	        var format = Registry.query(name);
	        if (format instanceof attributor_1.default) {
	            this.attributes.attribute(format, value);
	        }
	        else if (value) {
	            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
	                this.replaceWith(name, value);
	            }
	        }
	    };
	    FormatBlot.prototype.formats = function () {
	        var formats = this.attributes.values();
	        var format = this.statics.formats(this.domNode);
	        if (format != null) {
	            formats[this.statics.blotName] = format;
	        }
	        return formats;
	    };
	    FormatBlot.prototype.replaceWith = function (name, value) {
	        var replacement = _super.prototype.replaceWith.call(this, name, value);
	        this.attributes.copy(replacement);
	        return replacement;
	    };
	    FormatBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        _super.prototype.update.call(this, mutations, context);
	        if (mutations.some(function (mutation) {
	            return mutation.target === _this.domNode && mutation.type === 'attributes';
	        })) {
	            this.attributes.build();
	        }
	    };
	    FormatBlot.prototype.wrap = function (name, value) {
	        var wrapper = _super.prototype.wrap.call(this, name, value);
	        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
	            this.attributes.move(wrapper);
	        }
	        return wrapper;
	    };
	    return FormatBlot;
	}(container_1.default));
	exports.default = FormatBlot;
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var LeafBlot = /** @class */ (function (_super) {
	    __extends(LeafBlot, _super);
	    function LeafBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LeafBlot.value = function (domNode) {
	        return true;
	    };
	    LeafBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node ||
	            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	            return Math.min(offset, 1);
	        }
	        return -1;
	    };
	    LeafBlot.prototype.position = function (index, inclusive) {
	        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
	        if (index > 0)
	            offset += 1;
	        return [this.parent.domNode, offset];
	    };
	    LeafBlot.prototype.value = function () {
	        var _a;
	        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
	    };
	    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
	    return LeafBlot;
	}(shadow_1.default));
	exports.default = LeafBlot;
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	
	
	var lib = {
	  attributes: {
	    compose: function (a, b, keepNull) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = extend(true, {}, b);
	      if (!keepNull) {
	        attributes = Object.keys(attributes).reduce(function (copy, key) {
	          if (attributes[key] != null) {
	            copy[key] = attributes[key];
	          }
	          return copy;
	        }, {});
	      }
	      for (var key in a) {
	        if (a[key] !== undefined && b[key] === undefined) {
	          attributes[key] = a[key];
	        }
	      }
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    diff: function(a, b) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
	        if (!equal(a[key], b[key])) {
	          attributes[key] = b[key] === undefined ? null : b[key];
	        }
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    transform: function (a, b, priority) {
	      if (typeof a !== 'object') return b;
	      if (typeof b !== 'object') return undefined;
	      if (!priority) return b;  // b simply overwrites us without priority
	      var attributes = Object.keys(b).reduce(function (attributes, key) {
	        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	  },
	
	  iterator: function (ops) {
	    return new Iterator(ops);
	  },
	
	  length: function (op) {
	    if (typeof op['delete'] === 'number') {
	      return op['delete'];
	    } else if (typeof op.retain === 'number') {
	      return op.retain;
	    } else {
	      return typeof op.insert === 'string' ? op.insert.length : 1;
	    }
	  }
	};
	
	
	function Iterator(ops) {
	  this.ops = ops;
	  this.index = 0;
	  this.offset = 0;
	};
	
	Iterator.prototype.hasNext = function () {
	  return this.peekLength() < Infinity;
	};
	
	Iterator.prototype.next = function (length) {
	  if (!length) length = Infinity;
	  var nextOp = this.ops[this.index];
	  if (nextOp) {
	    var offset = this.offset;
	    var opLength = lib.length(nextOp)
	    if (length >= opLength - offset) {
	      length = opLength - offset;
	      this.index += 1;
	      this.offset = 0;
	    } else {
	      this.offset += length;
	    }
	    if (typeof nextOp['delete'] === 'number') {
	      return { 'delete': length };
	    } else {
	      var retOp = {};
	      if (nextOp.attributes) {
	        retOp.attributes = nextOp.attributes;
	      }
	      if (typeof nextOp.retain === 'number') {
	        retOp.retain = length;
	      } else if (typeof nextOp.insert === 'string') {
	        retOp.insert = nextOp.insert.substr(offset, length);
	      } else {
	        // offset should === 0, length should === 1
	        retOp.insert = nextOp.insert;
	      }
	      return retOp;
	    }
	  } else {
	    return { retain: Infinity };
	  }
	};
	
	Iterator.prototype.peek = function () {
	  return this.ops[this.index];
	};
	
	Iterator.prototype.peekLength = function () {
	  if (this.ops[this.index]) {
	    // Should never return 0 if our index is being managed correctly
	    return lib.length(this.ops[this.index]) - this.offset;
	  } else {
	    return Infinity;
	  }
	};
	
	Iterator.prototype.peekType = function () {
	  if (this.ops[this.index]) {
	    if (typeof this.ops[this.index]['delete'] === 'number') {
	      return 'delete';
	    } else if (typeof this.ops[this.index].retain === 'number') {
	      return 'retain';
	    } else {
	      return 'insert';
	    }
	  }
	  return 'retain';
	};
	
	Iterator.prototype.rest = function () {
	  if (!this.hasNext()) {
	    return [];
	  } else if (this.offset === 0) {
	    return this.ops.slice(this.index);
	  } else {
	    var offset = this.offset;
	    var index = this.index;
	    var next = this.next();
	    var rest = this.ops.slice(this.index);
	    this.offset = offset;
	    this.index = index;
	    return [next].concat(rest);
	  }
	};
	
	
	module.exports = lib;
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	var clone = (function() {
	'use strict';
	
	function _instanceof(obj, type) {
	  return type != null && obj instanceof type;
	}
	
	var nativeMap;
	try {
	  nativeMap = Map;
	} catch(_) {
	  // maybe a reference error because no `Map`. Give it a dummy value that no
	  // value will ever be an instanceof.
	  nativeMap = function() {};
	}
	
	var nativeSet;
	try {
	  nativeSet = Set;
	} catch(_) {
	  nativeSet = function() {};
	}
	
	var nativePromise;
	try {
	  nativePromise = Promise;
	} catch(_) {
	  nativePromise = function() {};
	}
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
	 *    should be cloned as well. Non-enumerable properties on the prototype
	 *    chain will be ignored. (optional - false by default)
	*/
	function clone(parent, circular, depth, prototype, includeNonEnumerable) {
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    includeNonEnumerable = circular.includeNonEnumerable;
	    circular = circular.circular;
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth === 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      child = new nativeMap();
	    } else if (_instanceof(parent, nativeSet)) {
	      child = new nativeSet();
	    } else if (_instanceof(parent, nativePromise)) {
	      child = new nativePromise(function (resolve, reject) {
	        parent.then(function(value) {
	          resolve(_clone(value, depth - 1));
	        }, function(err) {
	          reject(_clone(err, depth - 1));
	        });
	      });
	    } else if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      if (Buffer.allocUnsafe) {
	        // Node.js >= 4.5.0
	        child = Buffer.allocUnsafe(parent.length);
	      } else {
	        // Older Node.js versions
	        child = new Buffer(parent.length);
	      }
	      parent.copy(child);
	      return child;
	    } else if (_instanceof(parent, Error)) {
	      child = Object.create(parent);
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      parent.forEach(function(value, key) {
	        var keyChild = _clone(key, depth - 1);
	        var valueChild = _clone(value, depth - 1);
	        child.set(keyChild, valueChild);
	      });
	    }
	    if (_instanceof(parent, nativeSet)) {
	      parent.forEach(function(value) {
	        var entryChild = _clone(value, depth - 1);
	        child.add(entryChild);
	      });
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(parent);
	      for (var i = 0; i < symbols.length; i++) {
	        // Don't need to worry about cloning a symbol because it is a primitive,
	        // like a number or string.
	        var symbol = symbols[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
	        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
	          continue;
	        }
	        child[symbol] = _clone(parent[symbol], depth - 1);
	        if (!descriptor.enumerable) {
	          Object.defineProperty(child, symbol, {
	            enumerable: false
	          });
	        }
	      }
	    }
	
	    if (includeNonEnumerable) {
	      var allPropertyNames = Object.getOwnPropertyNames(parent);
	      for (var i = 0; i < allPropertyNames.length; i++) {
	        var propertyName = allPropertyNames[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
	        if (descriptor && descriptor.enumerable) {
	          continue;
	        }
	        child[propertyName] = _clone(parent[propertyName], depth - 1);
	        Object.defineProperty(child, propertyName, {
	          enumerable: false
	        });
	      }
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	}
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	}
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	}
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	}
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	}
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isLine(blot) {
	  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
	}
	
	var Scroll = function (_Parchment$Scroll) {
	  _inherits(Scroll, _Parchment$Scroll);
	
	  function Scroll(domNode, config) {
	    _classCallCheck(this, Scroll);
	
	    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
	
	    _this.emitter = config.emitter;
	    if (Array.isArray(config.whitelist)) {
	      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
	        whitelist[format] = true;
	        return whitelist;
	      }, {});
	    }
	    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
	    _this.domNode.addEventListener('DOMNodeInserted', function () {});
	    _this.optimize();
	    _this.enable();
	    return _this;
	  }
	
	  _createClass(Scroll, [{
	    key: 'batchStart',
	    value: function batchStart() {
	      this.batch = true;
	    }
	  }, {
	    key: 'batchEnd',
	    value: function batchEnd() {
	      this.batch = false;
	      this.optimize();
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      var _line = this.line(index),
	          _line2 = _slicedToArray(_line, 2),
	          first = _line2[0],
	          offset = _line2[1];
	
	      var _line3 = this.line(index + length),
	          _line4 = _slicedToArray(_line3, 1),
	          last = _line4[0];
	
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
	      if (last != null && first !== last && offset > 0) {
	        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
	          this.optimize();
	          return;
	        }
	        if (first instanceof _code2.default) {
	          var newlineIndex = first.newlineIndex(first.length(), true);
	          if (newlineIndex > -1) {
	            first = first.split(newlineIndex + 1);
	            if (first === last) {
	              this.optimize();
	              return;
	            }
	          }
	        } else if (last instanceof _code2.default) {
	          var _newlineIndex = last.newlineIndex(0);
	          if (_newlineIndex > -1) {
	            last.split(_newlineIndex + 1);
	          }
	        }
	        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
	        first.moveChildren(last, ref);
	        first.remove();
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.domNode.setAttribute('contenteditable', enabled);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, format, value) {
	      if (this.whitelist != null && !this.whitelist[format]) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
	      this.optimize();
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
	      if (index >= this.length()) {
	        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
	          var blot = _parchment2.default.create(this.statics.defaultChild);
	          this.appendChild(blot);
	          if (def == null && value.endsWith('\n')) {
	            value = value.slice(0, -1);
	          }
	          blot.insertAt(0, value, def);
	        } else {
	          var embed = _parchment2.default.create(value, def);
	          this.appendChild(embed);
	        }
	      } else {
	        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
	        var wrapper = _parchment2.default.create(this.statics.defaultChild);
	        wrapper.appendChild(blot);
	        blot = wrapper;
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
	    }
	  }, {
	    key: 'leaf',
	    value: function leaf(index) {
	      return this.path(index).pop() || [null, -1];
	    }
	  }, {
	    key: 'line',
	    value: function line(index) {
	      if (index === this.length()) {
	        return this.line(index - 1);
	      }
	      return this.descendant(isLine, index);
	    }
	  }, {
	    key: 'lines',
	    value: function lines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      var getLines = function getLines(blot, index, length) {
	        var lines = [],
	            lengthLeft = length;
	        blot.children.forEachAt(index, length, function (child, index, length) {
	          if (isLine(child)) {
	            lines.push(child);
	          } else if (child instanceof _parchment2.default.Container) {
	            lines = lines.concat(getLines(child, index, lengthLeft));
	          }
	          lengthLeft -= length;
	        });
	        return lines;
	      };
	      return getLines(this, index, length);
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.batch === true) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
	      }
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations) {
	      if (this.batch === true) return;
	      var source = _emitter2.default.sources.USER;
	      if (typeof mutations === 'string') {
	        source = mutations;
	      }
	      if (!Array.isArray(mutations)) {
	        mutations = this.observer.takeRecords();
	      }
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
	      }
	    }
	  }]);
	
	  return Scroll;
	}(_parchment2.default.Scroll);
	
	Scroll.blotName = 'scroll';
	Scroll.className = 'ql-editor';
	Scroll.tagName = 'DIV';
	Scroll.defaultChild = 'block';
	Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];
	
	exports.default = Scroll;
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHORTKEY = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:keyboard');
	
	var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
	
	var Keyboard = function (_Module) {
	  _inherits(Keyboard, _Module);
	
	  _createClass(Keyboard, null, [{
	    key: 'match',
	    value: function match(evt, binding) {
	      binding = normalize(binding);
	      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
	        return !!binding[key] !== evt[key] && binding[key] !== null;
	      })) {
	        return false;
	      }
	      return binding.key === (evt.which || evt.keyCode);
	    }
	  }]);
	
	  function Keyboard(quill, options) {
	    _classCallCheck(this, Keyboard);
	
	    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
	
	    _this.bindings = {};
	    Object.keys(_this.options.bindings).forEach(function (name) {
	      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
	        return;
	      }
	      if (_this.options.bindings[name]) {
	        _this.addBinding(_this.options.bindings[name]);
	      }
	    });
	    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
	    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
	    if (/Firefox/i.test(navigator.userAgent)) {
	      // Need to handle delete and backspace for Firefox in the general case #1171
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
	    } else {
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
	    }
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
	    _this.listen();
	    return _this;
	  }
	
	  _createClass(Keyboard, [{
	    key: 'addBinding',
	    value: function addBinding(key) {
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var binding = normalize(key);
	      if (binding == null || binding.key == null) {
	        return debug.warn('Attempted to add invalid keyboard binding', binding);
	      }
	      if (typeof context === 'function') {
	        context = { handler: context };
	      }
	      if (typeof handler === 'function') {
	        handler = { handler: handler };
	      }
	      binding = (0, _extend2.default)(binding, context, handler);
	      this.bindings[binding.key] = this.bindings[binding.key] || [];
	      this.bindings[binding.key].push(binding);
	    }
	  }, {
	    key: 'listen',
	    value: function listen() {
	      var _this2 = this;
	
	      this.quill.root.addEventListener('keydown', function (evt) {
	        if (evt.defaultPrevented) return;
	        var which = evt.which || evt.keyCode;
	        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
	          return Keyboard.match(evt, binding);
	        });
	        if (bindings.length === 0) return;
	        var range = _this2.quill.getSelection();
	        if (range == null || !_this2.quill.hasFocus()) return;
	
	        var _quill$getLine = _this2.quill.getLine(range.index),
	            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
	            line = _quill$getLine2[0],
	            offset = _quill$getLine2[1];
	
	        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
	            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
	            leafStart = _quill$getLeaf2[0],
	            offsetStart = _quill$getLeaf2[1];
	
	        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
	            _ref2 = _slicedToArray(_ref, 2),
	            leafEnd = _ref2[0],
	            offsetEnd = _ref2[1];
	
	        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
	        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
	        var curContext = {
	          collapsed: range.length === 0,
	          empty: range.length === 0 && line.length() <= 1,
	          format: _this2.quill.getFormat(range),
	          offset: offset,
	          prefix: prefixText,
	          suffix: suffixText
	        };
	        var prevented = bindings.some(function (binding) {
	          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
	          if (binding.empty != null && binding.empty !== curContext.empty) return false;
	          if (binding.offset != null && binding.offset !== curContext.offset) return false;
	          if (Array.isArray(binding.format)) {
	            // any format is present
	            if (binding.format.every(function (name) {
	              return curContext.format[name] == null;
	            })) {
	              return false;
	            }
	          } else if (_typeof(binding.format) === 'object') {
	            // all formats must match
	            if (!Object.keys(binding.format).every(function (name) {
	              if (binding.format[name] === true) return curContext.format[name] != null;
	              if (binding.format[name] === false) return curContext.format[name] == null;
	              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
	            })) {
	              return false;
	            }
	          }
	          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
	          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
	          return binding.handler.call(_this2, range, curContext) !== true;
	        });
	        if (prevented) {
	          evt.preventDefault();
	        }
	      });
	    }
	  }]);
	
	  return Keyboard;
	}(_module2.default);
	
	Keyboard.keys = {
	  BACKSPACE: 8,
	  TAB: 9,
	  ENTER: 13,
	  ESCAPE: 27,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46
	};
	
	Keyboard.DEFAULTS = {
	  bindings: {
	    'bold': makeFormatHandler('bold'),
	    'italic': makeFormatHandler('italic'),
	    'underline': makeFormatHandler('underline'),
	    'indent': {
	      // highlight tab or tab at beginning of list, indent or blockquote
	      key: Keyboard.keys.TAB,
	      format: ['blockquote', 'indent', 'list'],
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '+1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      format: ['blockquote', 'indent', 'list'],
	      // highlight tab or tab at beginning of list, indent or blockquote
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '-1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent backspace': {
	      key: Keyboard.keys.BACKSPACE,
	      collapsed: true,
	      shiftKey: null,
	      metaKey: null,
	      ctrlKey: null,
	      altKey: null,
	      format: ['indent', 'list'],
	      offset: 0,
	      handler: function handler(range, context) {
	        if (context.format.indent != null) {
	          this.quill.format('indent', '-1', _quill2.default.sources.USER);
	        } else if (context.format.list != null) {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'indent code-block': makeCodeBlockHandler(true),
	    'outdent code-block': makeCodeBlockHandler(false),
	    'remove tab': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      collapsed: true,
	      prefix: /\t$/,
	      handler: function handler(range) {
	        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
	      }
	    },
	    'tab': {
	      key: Keyboard.keys.TAB,
	      handler: function handler(range) {
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	      }
	    },
	    'list empty enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['list'],
	      empty: true,
	      handler: function handler(range, context) {
	        this.quill.format('list', false, _quill2.default.sources.USER);
	        if (context.format.indent) {
	          this.quill.format('indent', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'checklist enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: { list: 'checked' },
	      handler: function handler(range) {
	        var _quill$getLine3 = this.quill.getLine(range.index),
	            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
	            line = _quill$getLine4[0],
	            offset = _quill$getLine4[1];
	
	        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'header enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['header'],
	      suffix: /^$/,
	      handler: function handler(range, context) {
	        var _quill$getLine5 = this.quill.getLine(range.index),
	            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
	            line = _quill$getLine6[0],
	            offset = _quill$getLine6[1];
	
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'list autofill': {
	      key: ' ',
	      collapsed: true,
	      format: { list: false },
	      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
	      handler: function handler(range, context) {
	        var length = context.prefix.length;
	
	        var _quill$getLine7 = this.quill.getLine(range.index),
	            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
	            line = _quill$getLine8[0],
	            offset = _quill$getLine8[1];
	
	        if (offset > length) return true;
	        var value = void 0;
	        switch (context.prefix.trim()) {
	          case '[]':case '[ ]':
	            value = 'unchecked';
	            break;
	          case '[x]':
	            value = 'checked';
	            break;
	          case '-':case '*':
	            value = 'bullet';
	            break;
	          default:
	            value = 'ordered';
	        }
	        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
	      }
	    },
	    'code exit': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['code-block'],
	      prefix: /\n\n$/,
	      suffix: /^\s+$/,
	      handler: function handler(range) {
	        var _quill$getLine9 = this.quill.getLine(range.index),
	            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
	            line = _quill$getLine10[0],
	            offset = _quill$getLine10[1];
	
	        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	      }
	    },
	    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
	    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
	    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
	    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
	  }
	};
	
	function makeEmbedArrowHandler(key, shiftKey) {
	  var _ref3;
	
	  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
	  return _ref3 = {
	    key: key,
	    shiftKey: shiftKey,
	    altKey: null
	  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
	    var index = range.index;
	    if (key === Keyboard.keys.RIGHT) {
	      index += range.length + 1;
	    }
	
	    var _quill$getLeaf3 = this.quill.getLeaf(index),
	        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
	        leaf = _quill$getLeaf4[0];
	
	    if (!(leaf instanceof _parchment2.default.Embed)) return true;
	    if (key === Keyboard.keys.LEFT) {
	      if (shiftKey) {
	        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
	      }
	    } else {
	      if (shiftKey) {
	        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
	      }
	    }
	    return false;
	  }), _ref3;
	}
	
	function handleBackspace(range, context) {
	  if (range.index === 0 || this.quill.getLength() <= 1) return;
	
	  var _quill$getLine11 = this.quill.getLine(range.index),
	      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
	      line = _quill$getLine12[0];
	
	  var formats = {};
	  if (context.offset === 0) {
	    var _quill$getLine13 = this.quill.getLine(range.index - 1),
	        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
	        prev = _quill$getLine14[0];
	
	    if (prev != null && prev.length() > 1) {
	      var curFormats = line.formats();
	      var prevFormats = this.quill.getFormat(range.index - 1, 1);
	      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
	    }
	  }
	  // Check for astral symbols
	  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
	  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
	  }
	  this.quill.focus();
	}
	
	function handleDelete(range, context) {
	  // Check for astral symbols
	  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
	  if (range.index >= this.quill.getLength() - length) return;
	  var formats = {},
	      nextLength = 0;
	
	  var _quill$getLine15 = this.quill.getLine(range.index),
	      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
	      line = _quill$getLine16[0];
	
	  if (context.offset >= line.length() - 1) {
	    var _quill$getLine17 = this.quill.getLine(range.index + 1),
	        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
	        next = _quill$getLine18[0];
	
	    if (next) {
	      var curFormats = line.formats();
	      var nextFormats = this.quill.getFormat(range.index, 1);
	      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
	      nextLength = next.length();
	    }
	  }
	  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
	  }
	}
	
	function handleDeleteRange(range) {
	  var lines = this.quill.getLines(range);
	  var formats = {};
	  if (lines.length > 1) {
	    var firstFormats = lines[0].formats();
	    var lastFormats = lines[lines.length - 1].formats();
	    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
	  }
	  this.quill.deleteText(range, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
	  }
	  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
	  this.quill.focus();
	}
	
	function handleEnter(range, context) {
	  var _this3 = this;
	
	  if (range.length > 0) {
	    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
	  }
	  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
	    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
	      lineFormats[format] = context.format[format];
	    }
	    return lineFormats;
	  }, {});
	  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
	  // Earlier scroll.deleteAt might have messed up our selection,
	  // so insertText's built in selection preservation is not reliable
	  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	  this.quill.focus();
	  Object.keys(context.format).forEach(function (name) {
	    if (lineFormats[name] != null) return;
	    if (Array.isArray(context.format[name])) return;
	    if (name === 'link') return;
	    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
	  });
	}
	
	function makeCodeBlockHandler(indent) {
	  return {
	    key: Keyboard.keys.TAB,
	    shiftKey: !indent,
	    format: { 'code-block': true },
	    handler: function handler(range) {
	      var CodeBlock = _parchment2.default.query('code-block');
	      var index = range.index,
	          length = range.length;
	
	      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
	          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	          block = _quill$scroll$descend2[0],
	          offset = _quill$scroll$descend2[1];
	
	      if (block == null) return;
	      var scrollIndex = this.quill.getIndex(block);
	      var start = block.newlineIndex(offset, true) + 1;
	      var end = block.newlineIndex(scrollIndex + offset + length);
	      var lines = block.domNode.textContent.slice(start, end).split('\n');
	      offset = 0;
	      lines.forEach(function (line, i) {
	        if (indent) {
	          block.insertAt(start + offset, CodeBlock.TAB);
	          offset += CodeBlock.TAB.length;
	          if (i === 0) {
	            index += CodeBlock.TAB.length;
	          } else {
	            length += CodeBlock.TAB.length;
	          }
	        } else if (line.startsWith(CodeBlock.TAB)) {
	          block.deleteAt(start + offset, CodeBlock.TAB.length);
	          offset -= CodeBlock.TAB.length;
	          if (i === 0) {
	            index -= CodeBlock.TAB.length;
	          } else {
	            length -= CodeBlock.TAB.length;
	          }
	        }
	        offset += line.length + 1;
	      });
	      this.quill.update(_quill2.default.sources.USER);
	      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
	    }
	  };
	}
	
	function makeFormatHandler(format) {
	  return {
	    key: format[0].toUpperCase(),
	    shortKey: true,
	    handler: function handler(range, context) {
	      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
	    }
	  };
	}
	
	function normalize(binding) {
	  if (typeof binding === 'string' || typeof binding === 'number') {
	    return normalize({ key: binding });
	  }
	  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
	    binding = (0, _clone2.default)(binding, false);
	  }
	  if (typeof binding.key === 'string') {
	    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
	      binding.key = Keyboard.keys[binding.key.toUpperCase()];
	    } else if (binding.key.length === 1) {
	      binding.key = binding.key.toUpperCase().charCodeAt(0);
	    } else {
	      return null;
	    }
	  }
	  if (binding.shortKey) {
	    binding[SHORTKEY] = binding.shortKey;
	    delete binding.shortKey;
	  }
	  return binding;
	}
	
	exports.default = Keyboard;
	exports.SHORTKEY = SHORTKEY;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cursor = function (_Parchment$Embed) {
	  _inherits(Cursor, _Parchment$Embed);
	
	  _createClass(Cursor, null, [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  function Cursor(domNode, selection) {
	    _classCallCheck(this, Cursor);
	
	    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
	
	    _this.selection = selection;
	    _this.textNode = document.createTextNode(Cursor.CONTENTS);
	    _this.domNode.appendChild(_this.textNode);
	    _this._length = 0;
	    return _this;
	  }
	
	  _createClass(Cursor, [{
	    key: 'detach',
	    value: function detach() {
	      // super.detach() will also clear domNode.__blot
	      if (this.parent != null) this.parent.removeChild(this);
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (this._length !== 0) {
	        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
	      }
	      var target = this,
	          index = 0;
	      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
	        index += target.offset(target.parent);
	        target = target.parent;
	      }
	      if (target != null) {
	        this._length = Cursor.CONTENTS.length;
	        target.optimize();
	        target.formatAt(index, Cursor.CONTENTS.length, name, value);
	        this._length = 0;
	      }
	    }
	  }, {
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.textNode) return 0;
	      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return this._length;
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      return [this.textNode, this.textNode.data.length];
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
	      this.parent = null;
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      if (this.selection.composing || this.parent == null) return;
	      var textNode = this.textNode;
	      var range = this.selection.getNativeRange();
	      var restoreText = void 0,
	          start = void 0,
	          end = void 0;
	      if (range != null && range.start.node === textNode && range.end.node === textNode) {
	        var _ref = [textNode, range.start.offset, range.end.offset];
	        restoreText = _ref[0];
	        start = _ref[1];
	        end = _ref[2];
	      }
	      // Link format will insert text outside of anchor tag
	      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
	        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
	      }
	      if (this.textNode.data !== Cursor.CONTENTS) {
	        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
	        if (this.next instanceof _text2.default) {
	          restoreText = this.next.domNode;
	          this.next.insertAt(0, text);
	          this.textNode.data = Cursor.CONTENTS;
	        } else {
	          this.textNode.data = text;
	          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
	          this.textNode = document.createTextNode(Cursor.CONTENTS);
	          this.domNode.appendChild(this.textNode);
	        }
	      }
	      this.remove();
	      if (start != null) {
	        var _map = [start, end].map(function (offset) {
	          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
	        });
	
	        var _map2 = _slicedToArray(_map, 2);
	
	        start = _map2[0];
	        end = _map2[1];
	
	        return {
	          startNode: restoreText,
	          startOffset: start,
	          endNode: restoreText,
	          endOffset: end
	        };
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      if (mutations.some(function (mutation) {
	        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
	      })) {
	        var range = this.restore();
	        if (range) context.range = range;
	      }
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }]);
	
	  return Cursor;
	}(_parchment2.default.Embed);
	
	Cursor.blotName = 'cursor';
	Cursor.className = 'ql-cursor';
	Cursor.tagName = 'span';
	Cursor.CONTENTS = '\uFEFF'; // Zero width no break space
	
	
	exports.default = Cursor;
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_Parchment$Container) {
	  _inherits(Container, _Parchment$Container);
	
	  function Container() {
	    _classCallCheck(this, Container);
	
	    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	  }
	
	  return Container;
	}(_parchment2.default.Container);
	
	Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];
	
	exports.default = Container;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorAttributor = function (_Parchment$Attributor) {
	  _inherits(ColorAttributor, _Parchment$Attributor);
	
	  function ColorAttributor() {
	    _classCallCheck(this, ColorAttributor);
	
	    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
	  }
	
	  _createClass(ColorAttributor, [{
	    key: 'value',
	    value: function value(domNode) {
	      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
	      if (!value.startsWith('rgb(')) return value;
	      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
	      return '#' + value.split(',').map(function (component) {
	        return ('00' + parseInt(component).toString(16)).slice(-2);
	      }).join('');
	    }
	  }]);
	
	  return ColorAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var ColorStyle = new ColorAttributor('color', 'color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.ColorAttributor = ColorAttributor;
	exports.ColorClass = ColorClass;
	exports.ColorStyle = ColorStyle;
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sanitize = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_Inline) {
	  _inherits(Link, _Inline);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	  }
	
	  _createClass(Link, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
	      value = this.constructor.sanitize(value);
	      this.domNode.setAttribute('href', value);
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
	      value = this.sanitize(value);
	      node.setAttribute('href', value);
	      node.setAttribute('rel', 'noopener noreferrer');
	      node.setAttribute('target', '_blank');
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.getAttribute('href');
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
	    }
	  }]);
	
	  return Link;
	}(_inline2.default);
	
	Link.blotName = 'link';
	Link.tagName = 'A';
	Link.SANITIZED_URL = 'about:blank';
	Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];
	
	function _sanitize(url, protocols) {
	  var anchor = document.createElement('a');
	  anchor.href = url;
	  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
	  return protocols.indexOf(protocol) > -1;
	}
	
	exports.default = Link;
	exports.sanitize = _sanitize;
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _dropdown = __webpack_require__(107);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var optionsCounter = 0;
	
	function toggleAriaAttribute(element, attribute) {
	  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
	}
	
	var Picker = function () {
	  function Picker(select) {
	    var _this = this;
	
	    _classCallCheck(this, Picker);
	
	    this.select = select;
	    this.container = document.createElement('span');
	    this.buildPicker();
	    this.select.style.display = 'none';
	    this.select.parentNode.insertBefore(this.container, this.select);
	
	    this.label.addEventListener('mousedown', function () {
	      _this.togglePicker();
	    });
	    this.label.addEventListener('keydown', function (event) {
	      switch (event.keyCode) {
	        // Allows the "Enter" key to open the picker
	        case _keyboard2.default.keys.ENTER:
	          _this.togglePicker();
	          break;
	
	        // Allows the "Escape" key to close the picker
	        case _keyboard2.default.keys.ESCAPE:
	          _this.escape();
	          event.preventDefault();
	          break;
	        default:
	      }
	    });
	    this.select.addEventListener('change', this.update.bind(this));
	  }
	
	  _createClass(Picker, [{
	    key: 'togglePicker',
	    value: function togglePicker() {
	      this.container.classList.toggle('ql-expanded');
	      // Toggle aria-expanded and aria-hidden to make the picker accessible
	      toggleAriaAttribute(this.label, 'aria-expanded');
	      toggleAriaAttribute(this.options, 'aria-hidden');
	    }
	  }, {
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var _this2 = this;
	
	      var item = document.createElement('span');
	      item.tabIndex = '0';
	      item.setAttribute('role', 'button');
	
	      item.classList.add('ql-picker-item');
	      if (option.hasAttribute('value')) {
	        item.setAttribute('data-value', option.getAttribute('value'));
	      }
	      if (option.textContent) {
	        item.setAttribute('data-label', option.textContent);
	      }
	      item.addEventListener('click', function () {
	        _this2.selectItem(item, true);
	      });
	      item.addEventListener('keydown', function (event) {
	        switch (event.keyCode) {
	          // Allows the "Enter" key to select an item
	          case _keyboard2.default.keys.ENTER:
	            _this2.selectItem(item, true);
	            event.preventDefault();
	            break;
	
	          // Allows the "Escape" key to close the picker
	          case _keyboard2.default.keys.ESCAPE:
	            _this2.escape();
	            event.preventDefault();
	            break;
	          default:
	        }
	      });
	
	      return item;
	    }
	  }, {
	    key: 'buildLabel',
	    value: function buildLabel() {
	      var label = document.createElement('span');
	      label.classList.add('ql-picker-label');
	      label.innerHTML = _dropdown2.default;
	      label.tabIndex = '0';
	      label.setAttribute('role', 'button');
	      label.setAttribute('aria-expanded', 'false');
	      this.container.appendChild(label);
	      return label;
	    }
	  }, {
	    key: 'buildOptions',
	    value: function buildOptions() {
	      var _this3 = this;
	
	      var options = document.createElement('span');
	      options.classList.add('ql-picker-options');
	
	      // Don't want screen readers to read this until options are visible
	      options.setAttribute('aria-hidden', 'true');
	      options.tabIndex = '-1';
	
	      // Need a unique id for aria-controls
	      options.id = 'ql-picker-options-' + optionsCounter;
	      optionsCounter += 1;
	      this.label.setAttribute('aria-controls', options.id);
	
	      this.options = options;
	
	      [].slice.call(this.select.options).forEach(function (option) {
	        var item = _this3.buildItem(option);
	        options.appendChild(item);
	        if (option.selected === true) {
	          _this3.selectItem(item);
	        }
	      });
	      this.container.appendChild(options);
	    }
	  }, {
	    key: 'buildPicker',
	    value: function buildPicker() {
	      var _this4 = this;
	
	      [].slice.call(this.select.attributes).forEach(function (item) {
	        _this4.container.setAttribute(item.name, item.value);
	      });
	      this.container.classList.add('ql-picker');
	      this.label = this.buildLabel();
	      this.buildOptions();
	    }
	  }, {
	    key: 'escape',
	    value: function escape() {
	      var _this5 = this;
	
	      // Close menu and return focus to trigger label
	      this.close();
	      // Need setTimeout for accessibility to ensure that the browser executes
	      // focus on the next process thread and after any DOM content changes
	      setTimeout(function () {
	        return _this5.label.focus();
	      }, 1);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.container.classList.remove('ql-expanded');
	      this.label.setAttribute('aria-expanded', 'false');
	      this.options.setAttribute('aria-hidden', 'true');
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item) {
	      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var selected = this.container.querySelector('.ql-selected');
	      if (item === selected) return;
	      if (selected != null) {
	        selected.classList.remove('ql-selected');
	      }
	      if (item == null) return;
	      item.classList.add('ql-selected');
	      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
	      if (item.hasAttribute('data-value')) {
	        this.label.setAttribute('data-value', item.getAttribute('data-value'));
	      } else {
	        this.label.removeAttribute('data-value');
	      }
	      if (item.hasAttribute('data-label')) {
	        this.label.setAttribute('data-label', item.getAttribute('data-label'));
	      } else {
	        this.label.removeAttribute('data-label');
	      }
	      if (trigger) {
	        if (typeof Event === 'function') {
	          this.select.dispatchEvent(new Event('change'));
	        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
	          // IE11
	          var event = document.createEvent('Event');
	          event.initEvent('change', true, true);
	          this.select.dispatchEvent(event);
	        }
	        this.close();
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var option = void 0;
	      if (this.select.selectedIndex > -1) {
	        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
	        option = this.select.options[this.select.selectedIndex];
	        this.selectItem(item);
	      } else {
	        this.selectItem(null);
	      }
	      var isActive = option != null && option !== this.select.querySelector('option[selected]');
	      this.label.classList.toggle('ql-active', isActive);
	    }
	  }]);
	
	  return Picker;
	}();
	
	exports.default = Picker;
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _scroll = __webpack_require__(22);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _clipboard = __webpack_require__(55);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _history = __webpack_require__(42);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_quill2.default.register({
	  'blots/block': _block2.default,
	  'blots/block/embed': _block.BlockEmbed,
	  'blots/break': _break2.default,
	  'blots/container': _container2.default,
	  'blots/cursor': _cursor2.default,
	  'blots/embed': _embed2.default,
	  'blots/inline': _inline2.default,
	  'blots/scroll': _scroll2.default,
	  'blots/text': _text2.default,
	
	  'modules/clipboard': _clipboard2.default,
	  'modules/history': _history2.default,
	  'modules/keyboard': _keyboard2.default
	});
	
	_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
	
	exports.default = _quill2.default;
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var ShadowBlot = /** @class */ (function () {
	    function ShadowBlot(domNode) {
	        this.domNode = domNode;
	        // @ts-ignore
	        this.domNode[Registry.DATA_KEY] = { blot: this };
	    }
	    Object.defineProperty(ShadowBlot.prototype, "statics", {
	        // Hack for accessing inherited static methods
	        get: function () {
	            return this.constructor;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ShadowBlot.create = function (value) {
	        if (this.tagName == null) {
	            throw new Registry.ParchmentError('Blot definition missing tagName');
	        }
	        var node;
	        if (Array.isArray(this.tagName)) {
	            if (typeof value === 'string') {
	                value = value.toUpperCase();
	                if (parseInt(value).toString() === value) {
	                    value = parseInt(value);
	                }
	            }
	            if (typeof value === 'number') {
	                node = document.createElement(this.tagName[value - 1]);
	            }
	            else if (this.tagName.indexOf(value) > -1) {
	                node = document.createElement(value);
	            }
	            else {
	                node = document.createElement(this.tagName[0]);
	            }
	        }
	        else {
	            node = document.createElement(this.tagName);
	        }
	        if (this.className) {
	            node.classList.add(this.className);
	        }
	        return node;
	    };
	    ShadowBlot.prototype.attach = function () {
	        if (this.parent != null) {
	            this.scroll = this.parent.scroll;
	        }
	    };
	    ShadowBlot.prototype.clone = function () {
	        var domNode = this.domNode.cloneNode(false);
	        return Registry.create(domNode);
	    };
	    ShadowBlot.prototype.detach = function () {
	        if (this.parent != null)
	            this.parent.removeChild(this);
	        // @ts-ignore
	        delete this.domNode[Registry.DATA_KEY];
	    };
	    ShadowBlot.prototype.deleteAt = function (index, length) {
	        var blot = this.isolate(index, length);
	        blot.remove();
	    };
	    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
	        var blot = this.isolate(index, length);
	        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
	            blot.wrap(name, value);
	        }
	        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
	            var parent = Registry.create(this.statics.scope);
	            blot.wrap(parent);
	            parent.format(name, value);
	        }
	    };
	    ShadowBlot.prototype.insertAt = function (index, value, def) {
	        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	        var ref = this.split(index);
	        this.parent.insertBefore(blot, ref);
	    };
	    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
	        if (refBlot === void 0) { refBlot = null; }
	        if (this.parent != null) {
	            this.parent.children.remove(this);
	        }
	        var refDomNode = null;
	        parentBlot.children.insertBefore(this, refBlot);
	        if (refBlot != null) {
	            refDomNode = refBlot.domNode;
	        }
	        if (this.domNode.parentNode != parentBlot.domNode ||
	            this.domNode.nextSibling != refDomNode) {
	            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
	        }
	        this.parent = parentBlot;
	        this.attach();
	    };
	    ShadowBlot.prototype.isolate = function (index, length) {
	        var target = this.split(index);
	        target.split(length);
	        return target;
	    };
	    ShadowBlot.prototype.length = function () {
	        return 1;
	    };
	    ShadowBlot.prototype.offset = function (root) {
	        if (root === void 0) { root = this.parent; }
	        if (this.parent == null || this == root)
	            return 0;
	        return this.parent.children.offset(this) + this.parent.offset(root);
	    };
	    ShadowBlot.prototype.optimize = function (context) {
	        // TODO clean up once we use WeakMap
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY] != null) {
	            // @ts-ignore
	            delete this.domNode[Registry.DATA_KEY].mutations;
	        }
	    };
	    ShadowBlot.prototype.remove = function () {
	        if (this.domNode.parentNode != null) {
	            this.domNode.parentNode.removeChild(this.domNode);
	        }
	        this.detach();
	    };
	    ShadowBlot.prototype.replace = function (target) {
	        if (target.parent == null)
	            return;
	        target.parent.insertBefore(this, target.next);
	        target.remove();
	    };
	    ShadowBlot.prototype.replaceWith = function (name, value) {
	        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
	        replacement.replace(this);
	        return replacement;
	    };
	    ShadowBlot.prototype.split = function (index, force) {
	        return index === 0 ? this : this.next;
	    };
	    ShadowBlot.prototype.update = function (mutations, context) {
	        // Nothing to do by default
	    };
	    ShadowBlot.prototype.wrap = function (name, value) {
	        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
	        if (this.parent != null) {
	            this.parent.insertBefore(wrapper, this.next);
	        }
	        wrapper.appendChild(this);
	        return wrapper;
	    };
	    ShadowBlot.blotName = 'abstract';
	    return ShadowBlot;
	}());
	exports.default = ShadowBlot;
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var Registry = __webpack_require__(1);
	var AttributorStore = /** @class */ (function () {
	    function AttributorStore(domNode) {
	        this.attributes = {};
	        this.domNode = domNode;
	        this.build();
	    }
	    AttributorStore.prototype.attribute = function (attribute, value) {
	        // verb
	        if (value) {
	            if (attribute.add(this.domNode, value)) {
	                if (attribute.value(this.domNode) != null) {
	                    this.attributes[attribute.attrName] = attribute;
	                }
	                else {
	                    delete this.attributes[attribute.attrName];
	                }
	            }
	        }
	        else {
	            attribute.remove(this.domNode);
	            delete this.attributes[attribute.attrName];
	        }
	    };
	    AttributorStore.prototype.build = function () {
	        var _this = this;
	        this.attributes = {};
	        var attributes = attributor_1.default.keys(this.domNode);
	        var classes = class_1.default.keys(this.domNode);
	        var styles = style_1.default.keys(this.domNode);
	        attributes
	            .concat(classes)
	            .concat(styles)
	            .forEach(function (name) {
	            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
	            if (attr instanceof attributor_1.default) {
	                _this.attributes[attr.attrName] = attr;
	            }
	        });
	    };
	    AttributorStore.prototype.copy = function (target) {
	        var _this = this;
	        Object.keys(this.attributes).forEach(function (key) {
	            var value = _this.attributes[key].value(_this.domNode);
	            target.format(key, value);
	        });
	    };
	    AttributorStore.prototype.move = function (target) {
	        var _this = this;
	        this.copy(target);
	        Object.keys(this.attributes).forEach(function (key) {
	            _this.attributes[key].remove(_this.domNode);
	        });
	        this.attributes = {};
	    };
	    AttributorStore.prototype.values = function () {
	        var _this = this;
	        return Object.keys(this.attributes).reduce(function (attributes, name) {
	            attributes[name] = _this.attributes[name].value(_this.domNode);
	            return attributes;
	        }, {});
	    };
	    return AttributorStore;
	}());
	exports.default = AttributorStore;
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function match(node, prefix) {
	    var className = node.getAttribute('class') || '';
	    return className.split(/\s+/).filter(function (name) {
	        return name.indexOf(prefix + "-") === 0;
	    });
	}
	var ClassAttributor = /** @class */ (function (_super) {
	    __extends(ClassAttributor, _super);
	    function ClassAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ClassAttributor.keys = function (node) {
	        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
	            return name
	                .split('-')
	                .slice(0, -1)
	                .join('-');
	        });
	    };
	    ClassAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        this.remove(node);
	        node.classList.add(this.keyName + "-" + value);
	        return true;
	    };
	    ClassAttributor.prototype.remove = function (node) {
	        var matches = match(node, this.keyName);
	        matches.forEach(function (name) {
	            node.classList.remove(name);
	        });
	        if (node.classList.length === 0) {
	            node.removeAttribute('class');
	        }
	    };
	    ClassAttributor.prototype.value = function (node) {
	        var result = match(node, this.keyName)[0] || '';
	        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
	        return this.canAdd(node, value) ? value : '';
	    };
	    return ClassAttributor;
	}(attributor_1.default));
	exports.default = ClassAttributor;
	
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function camelize(name) {
	    var parts = name.split('-');
	    var rest = parts
	        .slice(1)
	        .map(function (part) {
	        return part[0].toUpperCase() + part.slice(1);
	    })
	        .join('');
	    return parts[0] + rest;
	}
	var StyleAttributor = /** @class */ (function (_super) {
	    __extends(StyleAttributor, _super);
	    function StyleAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StyleAttributor.keys = function (node) {
	        return (node.getAttribute('style') || '').split(';').map(function (value) {
	            var arr = value.split(':');
	            return arr[0].trim();
	        });
	    };
	    StyleAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = value;
	        return true;
	    };
	    StyleAttributor.prototype.remove = function (node) {
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = '';
	        if (!node.getAttribute('style')) {
	            node.removeAttribute('style');
	        }
	    };
	    StyleAttributor.prototype.value = function (node) {
	        // @ts-ignore
	        var value = node.style[camelize(this.keyName)];
	        return this.canAdd(node, value) ? value : '';
	    };
	    return StyleAttributor;
	}(attributor_1.default));
	exports.default = StyleAttributor;
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Theme = function () {
	  function Theme(quill, options) {
	    _classCallCheck(this, Theme);
	
	    this.quill = quill;
	    this.options = options;
	    this.modules = {};
	  }
	
	  _createClass(Theme, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      Object.keys(this.options.modules).forEach(function (name) {
	        if (_this.modules[name] == null) {
	          _this.addModule(name);
	        }
	      });
	    }
	  }, {
	    key: 'addModule',
	    value: function addModule(name) {
	      var moduleClass = this.quill.constructor.import('modules/' + name);
	      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
	      return this.modules[name];
	    }
	  }]);
	
	  return Theme;
	}();
	
	Theme.DEFAULTS = {
	  modules: {}
	};
	Theme.themes = {
	  'default': Theme
	};
	
	exports.default = Theme;
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GUARD_TEXT = '\uFEFF';
	
	var Embed = function (_Parchment$Embed) {
	  _inherits(Embed, _Parchment$Embed);
	
	  function Embed(node) {
	    _classCallCheck(this, Embed);
	
	    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
	
	    _this.contentNode = document.createElement('span');
	    _this.contentNode.setAttribute('contenteditable', false);
	    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
	      _this.contentNode.appendChild(childNode);
	    });
	    _this.leftGuard = document.createTextNode(GUARD_TEXT);
	    _this.rightGuard = document.createTextNode(GUARD_TEXT);
	    _this.domNode.appendChild(_this.leftGuard);
	    _this.domNode.appendChild(_this.contentNode);
	    _this.domNode.appendChild(_this.rightGuard);
	    return _this;
	  }
	
	  _createClass(Embed, [{
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.leftGuard) return 0;
	      if (node === this.rightGuard) return 1;
	      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'restore',
	    value: function restore(node) {
	      var range = void 0,
	          textNode = void 0;
	      var text = node.data.split(GUARD_TEXT).join('');
	      if (node === this.leftGuard) {
	        if (this.prev instanceof _text2.default) {
	          var prevLength = this.prev.length();
	          this.prev.insertAt(prevLength, text);
	          range = {
	            startNode: this.prev.domNode,
	            startOffset: prevLength + text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      } else if (node === this.rightGuard) {
	        if (this.next instanceof _text2.default) {
	          this.next.insertAt(0, text);
	          range = {
	            startNode: this.next.domNode,
	            startOffset: text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      }
	      node.data = GUARD_TEXT;
	      return range;
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      mutations.forEach(function (mutation) {
	        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
	          var range = _this2.restore(mutation.target);
	          if (range) context.range = range;
	        }
	      });
	    }
	  }]);
	
	  return Embed;
	}(_parchment2.default.Embed);
	
	exports.default = Embed;
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['right', 'center', 'justify']
	};
	
	var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
	var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
	var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);
	
	exports.AlignAttribute = AlignAttribute;
	exports.AlignClass = AlignClass;
	exports.AlignStyle = AlignStyle;
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackgroundStyle = exports.BackgroundClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _color = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.BackgroundClass = BackgroundClass;
	exports.BackgroundStyle = BackgroundStyle;
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['rtl']
	};
	
	var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
	var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
	var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);
	
	exports.DirectionAttribute = DirectionAttribute;
	exports.DirectionClass = DirectionClass;
	exports.DirectionStyle = DirectionStyle;
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontClass = exports.FontStyle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['serif', 'monospace']
	};
	
	var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);
	
	var FontStyleAttributor = function (_Parchment$Attributor) {
	  _inherits(FontStyleAttributor, _Parchment$Attributor);
	
	  function FontStyleAttributor() {
	    _classCallCheck(this, FontStyleAttributor);
	
	    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
	  }
	
	  _createClass(FontStyleAttributor, [{
	    key: 'value',
	    value: function value(node) {
	      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
	    }
	  }]);
	
	  return FontStyleAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var FontStyle = new FontStyleAttributor('font', 'font-family', config);
	
	exports.FontStyle = FontStyle;
	exports.FontClass = FontClass;
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SizeStyle = exports.SizeClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['small', 'large', 'huge']
	});
	var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['10px', '18px', '32px']
	});
	
	exports.SizeClass = SizeClass;
	exports.SizeStyle = SizeStyle;
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = {
	  'align': {
	    '': __webpack_require__(76),
	    'center': __webpack_require__(77),
	    'right': __webpack_require__(78),
	    'justify': __webpack_require__(79)
	  },
	  'background': __webpack_require__(80),
	  'blockquote': __webpack_require__(81),
	  'bold': __webpack_require__(82),
	  'clean': __webpack_require__(83),
	  'code': __webpack_require__(58),
	  'code-block': __webpack_require__(58),
	  'color': __webpack_require__(84),
	  'direction': {
	    '': __webpack_require__(85),
	    'rtl': __webpack_require__(86)
	  },
	  'float': {
	    'center': __webpack_require__(87),
	    'full': __webpack_require__(88),
	    'left': __webpack_require__(89),
	    'right': __webpack_require__(90)
	  },
	  'formula': __webpack_require__(91),
	  'header': {
	    '1': __webpack_require__(92),
	    '2': __webpack_require__(93)
	  },
	  'italic': __webpack_require__(94),
	  'image': __webpack_require__(95),
	  'indent': {
	    '+1': __webpack_require__(96),
	    '-1': __webpack_require__(97)
	  },
	  'link': __webpack_require__(98),
	  'list': {
	    'ordered': __webpack_require__(99),
	    'bullet': __webpack_require__(100),
	    'check': __webpack_require__(101)
	  },
	  'script': {
	    'sub': __webpack_require__(102),
	    'super': __webpack_require__(103)
	  },
	  'strike': __webpack_require__(104),
	  'underline': __webpack_require__(105),
	  'video': __webpack_require__(106)
	};
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLastChangeIndex = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var History = function (_Module) {
	  _inherits(History, _Module);
	
	  function History(quill, options) {
	    _classCallCheck(this, History);
	
	    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
	
	    _this.lastRecorded = 0;
	    _this.ignoreChange = false;
	    _this.clear();
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
	      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
	      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
	        _this.record(delta, oldDelta);
	      } else {
	        _this.transform(delta);
	      }
	    });
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
	    if (/Win/i.test(navigator.platform)) {
	      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
	    }
	    return _this;
	  }
	
	  _createClass(History, [{
	    key: 'change',
	    value: function change(source, dest) {
	      if (this.stack[source].length === 0) return;
	      var delta = this.stack[source].pop();
	      this.stack[dest].push(delta);
	      this.lastRecorded = 0;
	      this.ignoreChange = true;
	      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
	      this.ignoreChange = false;
	      var index = getLastChangeIndex(delta[source]);
	      this.quill.setSelection(index);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.stack = { undo: [], redo: [] };
	    }
	  }, {
	    key: 'cutoff',
	    value: function cutoff() {
	      this.lastRecorded = 0;
	    }
	  }, {
	    key: 'record',
	    value: function record(changeDelta, oldDelta) {
	      if (changeDelta.ops.length === 0) return;
	      this.stack.redo = [];
	      var undoDelta = this.quill.getContents().diff(oldDelta);
	      var timestamp = Date.now();
	      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
	        var delta = this.stack.undo.pop();
	        undoDelta = undoDelta.compose(delta.undo);
	        changeDelta = delta.redo.compose(changeDelta);
	      } else {
	        this.lastRecorded = timestamp;
	      }
	      this.stack.undo.push({
	        redo: changeDelta,
	        undo: undoDelta
	      });
	      if (this.stack.undo.length > this.options.maxStack) {
	        this.stack.undo.shift();
	      }
	    }
	  }, {
	    key: 'redo',
	    value: function redo() {
	      this.change('redo', 'undo');
	    }
	  }, {
	    key: 'transform',
	    value: function transform(delta) {
	      this.stack.undo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	      this.stack.redo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	    }
	  }, {
	    key: 'undo',
	    value: function undo() {
	      this.change('undo', 'redo');
	    }
	  }]);
	
	  return History;
	}(_module2.default);
	
	History.DEFAULTS = {
	  delay: 1000,
	  maxStack: 100,
	  userOnly: false
	};
	
	function endsWithNewlineChange(delta) {
	  var lastOp = delta.ops[delta.ops.length - 1];
	  if (lastOp == null) return false;
	  if (lastOp.insert != null) {
	    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
	  }
	  if (lastOp.attributes != null) {
	    return Object.keys(lastOp.attributes).some(function (attr) {
	      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
	    });
	  }
	  return false;
	}
	
	function getLastChangeIndex(delta) {
	  var deleteLength = delta.reduce(function (length, op) {
	    length += op.delete || 0;
	    return length;
	  }, 0);
	  var changeIndex = delta.length() - deleteLength;
	  if (endsWithNewlineChange(delta)) {
	    changeIndex -= 1;
	  }
	  return changeIndex;
	}
	
	exports.default = History;
	exports.getLastChangeIndex = getLastChangeIndex;
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BaseTooltip = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALIGNS = [false, 'center', 'right', 'justify'];
	
	var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
	
	var FONTS = [false, 'serif', 'monospace'];
	
	var HEADERS = ['1', '2', '3', false];
	
	var SIZES = ['small', false, 'large', 'huge'];
	
	var BaseTheme = function (_Theme) {
	  _inherits(BaseTheme, _Theme);
	
	  function BaseTheme(quill, options) {
	    _classCallCheck(this, BaseTheme);
	
	    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
	
	    var listener = function listener(e) {
	      if (!document.body.contains(quill.root)) {
	        return document.body.removeEventListener('click', listener);
	      }
	      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
	        _this.tooltip.hide();
	      }
	      if (_this.pickers != null) {
	        _this.pickers.forEach(function (picker) {
	          if (!picker.container.contains(e.target)) {
	            picker.close();
	          }
	        });
	      }
	    };
	    quill.emitter.listenDOM('click', document.body, listener);
	    return _this;
	  }
	
	  _createClass(BaseTheme, [{
	    key: 'addModule',
	    value: function addModule(name) {
	      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
	      if (name === 'toolbar') {
	        this.extendToolbar(module);
	      }
	      return module;
	    }
	  }, {
	    key: 'buildButtons',
	    value: function buildButtons(buttons, icons) {
	      buttons.forEach(function (button) {
	        var className = button.getAttribute('class') || '';
	        className.split(/\s+/).forEach(function (name) {
	          if (!name.startsWith('ql-')) return;
	          name = name.slice('ql-'.length);
	          if (icons[name] == null) return;
	          if (name === 'direction') {
	            button.innerHTML = icons[name][''] + icons[name]['rtl'];
	          } else if (typeof icons[name] === 'string') {
	            button.innerHTML = icons[name];
	          } else {
	            var value = button.value || '';
	            if (value != null && icons[name][value]) {
	              button.innerHTML = icons[name][value];
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'buildPickers',
	    value: function buildPickers(selects, icons) {
	      var _this2 = this;
	
	      this.pickers = selects.map(function (select) {
	        if (select.classList.contains('ql-align')) {
	          if (select.querySelector('option') == null) {
	            fillSelect(select, ALIGNS);
	          }
	          return new _iconPicker2.default(select, icons.align);
	        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
	          var format = select.classList.contains('ql-background') ? 'background' : 'color';
	          if (select.querySelector('option') == null) {
	            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
	          }
	          return new _colorPicker2.default(select, icons[format]);
	        } else {
	          if (select.querySelector('option') == null) {
	            if (select.classList.contains('ql-font')) {
	              fillSelect(select, FONTS);
	            } else if (select.classList.contains('ql-header')) {
	              fillSelect(select, HEADERS);
	            } else if (select.classList.contains('ql-size')) {
	              fillSelect(select, SIZES);
	            }
	          }
	          return new _picker2.default(select);
	        }
	      });
	      var update = function update() {
	        _this2.pickers.forEach(function (picker) {
	          picker.update();
	        });
	      };
	      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
	    }
	  }]);
	
	  return BaseTheme;
	}(_theme2.default);
	
	BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        formula: function formula() {
	          this.quill.theme.tooltip.edit('formula');
	        },
	        image: function image() {
	          var _this3 = this;
	
	          var fileInput = this.container.querySelector('input.ql-image[type=file]');
	          if (fileInput == null) {
	            fileInput = document.createElement('input');
	            fileInput.setAttribute('type', 'file');
	            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
	            fileInput.classList.add('ql-image');
	            fileInput.addEventListener('change', function () {
	              if (fileInput.files != null && fileInput.files[0] != null) {
	                var reader = new FileReader();
	                reader.onload = function (e) {
	                  var range = _this3.quill.getSelection(true);
	                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
	                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
	                  fileInput.value = "";
	                };
	                reader.readAsDataURL(fileInput.files[0]);
	              }
	            });
	            this.container.appendChild(fileInput);
	          }
	          fileInput.click();
	        },
	        video: function video() {
	          this.quill.theme.tooltip.edit('video');
	        }
	      }
	    }
	  }
	});
	
	var BaseTooltip = function (_Tooltip) {
	  _inherits(BaseTooltip, _Tooltip);
	
	  function BaseTooltip(quill, boundsContainer) {
	    _classCallCheck(this, BaseTooltip);
	
	    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
	
	    _this4.textbox = _this4.root.querySelector('input[type="text"]');
	    _this4.listen();
	    return _this4;
	  }
	
	  _createClass(BaseTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this5 = this;
	
	      this.textbox.addEventListener('keydown', function (event) {
	        if (_keyboard2.default.match(event, 'enter')) {
	          _this5.save();
	          event.preventDefault();
	        } else if (_keyboard2.default.match(event, 'escape')) {
	          _this5.cancel();
	          event.preventDefault();
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.hide();
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
	      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.root.classList.remove('ql-hidden');
	      this.root.classList.add('ql-editing');
	      if (preview != null) {
	        this.textbox.value = preview;
	      } else if (mode !== this.root.getAttribute('data-mode')) {
	        this.textbox.value = '';
	      }
	      this.position(this.quill.getBounds(this.quill.selection.savedRange));
	      this.textbox.select();
	      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
	      this.root.setAttribute('data-mode', mode);
	    }
	  }, {
	    key: 'restoreFocus',
	    value: function restoreFocus() {
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.quill.focus();
	      this.quill.scrollingContainer.scrollTop = scrollTop;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var value = this.textbox.value;
	      switch (this.root.getAttribute('data-mode')) {
	        case 'link':
	          {
	            var scrollTop = this.quill.root.scrollTop;
	            if (this.linkRange) {
	              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
	              delete this.linkRange;
	            } else {
	              this.restoreFocus();
	              this.quill.format('link', value, _emitter2.default.sources.USER);
	            }
	            this.quill.root.scrollTop = scrollTop;
	            break;
	          }
	        case 'video':
	          {
	            value = extractVideoUrl(value);
	          } // eslint-disable-next-line no-fallthrough
	        case 'formula':
	          {
	            if (!value) break;
	            var range = this.quill.getSelection(true);
	            if (range != null) {
	              var index = range.index + range.length;
	              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
	              if (this.root.getAttribute('data-mode') === 'formula') {
	                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
	              }
	              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
	            }
	            break;
	          }
	        default:
	      }
	      this.textbox.value = '';
	      this.hide();
	    }
	  }]);
	
	  return BaseTooltip;
	}(_tooltip2.default);
	
	function extractVideoUrl(url) {
	  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
	  if (match) {
	    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
	  }
	  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
	    // eslint-disable-line no-cond-assign
	    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
	  }
	  return url;
	}
	
	function fillSelect(select, values) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value === defaultValue) {
	      option.setAttribute('selected', 'selected');
	    } else {
	      option.setAttribute('value', value);
	    }
	    select.appendChild(option);
	  });
	}
	
	exports.BaseTooltip = BaseTooltip;
	exports.default = BaseTheme;
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var LinkedList = /** @class */ (function () {
	    function LinkedList() {
	        this.head = this.tail = null;
	        this.length = 0;
	    }
	    LinkedList.prototype.append = function () {
	        var nodes = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            nodes[_i] = arguments[_i];
	        }
	        this.insertBefore(nodes[0], null);
	        if (nodes.length > 1) {
	            this.append.apply(this, nodes.slice(1));
	        }
	    };
	    LinkedList.prototype.contains = function (node) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            if (cur === node)
	                return true;
	        }
	        return false;
	    };
	    LinkedList.prototype.insertBefore = function (node, refNode) {
	        if (!node)
	            return;
	        node.next = refNode;
	        if (refNode != null) {
	            node.prev = refNode.prev;
	            if (refNode.prev != null) {
	                refNode.prev.next = node;
	            }
	            refNode.prev = node;
	            if (refNode === this.head) {
	                this.head = node;
	            }
	        }
	        else if (this.tail != null) {
	            this.tail.next = node;
	            node.prev = this.tail;
	            this.tail = node;
	        }
	        else {
	            node.prev = null;
	            this.head = this.tail = node;
	        }
	        this.length += 1;
	    };
	    LinkedList.prototype.offset = function (target) {
	        var index = 0, cur = this.head;
	        while (cur != null) {
	            if (cur === target)
	                return index;
	            index += cur.length();
	            cur = cur.next;
	        }
	        return -1;
	    };
	    LinkedList.prototype.remove = function (node) {
	        if (!this.contains(node))
	            return;
	        if (node.prev != null)
	            node.prev.next = node.next;
	        if (node.next != null)
	            node.next.prev = node.prev;
	        if (node === this.head)
	            this.head = node.next;
	        if (node === this.tail)
	            this.tail = node.prev;
	        this.length -= 1;
	    };
	    LinkedList.prototype.iterator = function (curNode) {
	        if (curNode === void 0) { curNode = this.head; }
	        // TODO use yield when we can
	        return function () {
	            var ret = curNode;
	            if (curNode != null)
	                curNode = curNode.next;
	            return ret;
	        };
	    };
	    LinkedList.prototype.find = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            var length = cur.length();
	            if (index < length ||
	                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
	                return [cur, index];
	            }
	            index -= length;
	        }
	        return [null, 0];
	    };
	    LinkedList.prototype.forEach = function (callback) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            callback(cur);
	        }
	    };
	    LinkedList.prototype.forEachAt = function (index, length, callback) {
	        if (length <= 0)
	            return;
	        var _a = this.find(index), startNode = _a[0], offset = _a[1];
	        var cur, curIndex = index - offset, next = this.iterator(startNode);
	        while ((cur = next()) && curIndex < index + length) {
	            var curLength = cur.length();
	            if (index > curIndex) {
	                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
	            }
	            else {
	                callback(cur, 0, Math.min(curLength, index + length - curIndex));
	            }
	            curIndex += curLength;
	        }
	    };
	    LinkedList.prototype.map = function (callback) {
	        return this.reduce(function (memo, cur) {
	            memo.push(callback(cur));
	            return memo;
	        }, []);
	    };
	    LinkedList.prototype.reduce = function (callback, memo) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            memo = callback(memo, cur);
	        }
	        return memo;
	    };
	    return LinkedList;
	}());
	exports.default = LinkedList;
	
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var OBSERVER_CONFIG = {
	    attributes: true,
	    characterData: true,
	    characterDataOldValue: true,
	    childList: true,
	    subtree: true,
	};
	var MAX_OPTIMIZE_ITERATIONS = 100;
	var ScrollBlot = /** @class */ (function (_super) {
	    __extends(ScrollBlot, _super);
	    function ScrollBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.scroll = _this;
	        _this.observer = new MutationObserver(function (mutations) {
	            _this.update(mutations);
	        });
	        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
	        _this.attach();
	        return _this;
	    }
	    ScrollBlot.prototype.detach = function () {
	        _super.prototype.detach.call(this);
	        this.observer.disconnect();
	    };
	    ScrollBlot.prototype.deleteAt = function (index, length) {
	        this.update();
	        if (index === 0 && length === this.length()) {
	            this.children.forEach(function (child) {
	                child.remove();
	            });
	        }
	        else {
	            _super.prototype.deleteAt.call(this, index, length);
	        }
	    };
	    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
	        this.update();
	        _super.prototype.formatAt.call(this, index, length, name, value);
	    };
	    ScrollBlot.prototype.insertAt = function (index, value, def) {
	        this.update();
	        _super.prototype.insertAt.call(this, index, value, def);
	    };
	    ScrollBlot.prototype.optimize = function (mutations, context) {
	        var _this = this;
	        if (mutations === void 0) { mutations = []; }
	        if (context === void 0) { context = {}; }
	        _super.prototype.optimize.call(this, context);
	        // We must modify mutations directly, cannot make copy and then modify
	        var records = [].slice.call(this.observer.takeRecords());
	        // Array.push currently seems to be implemented by a non-tail recursive function
	        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
	        while (records.length > 0)
	            mutations.push(records.pop());
	        // TODO use WeakMap
	        var mark = function (blot, markParent) {
	            if (markParent === void 0) { markParent = true; }
	            if (blot == null || blot === _this)
	                return;
	            if (blot.domNode.parentNode == null)
	                return;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [];
	            }
	            if (markParent)
	                mark(blot.parent);
	        };
	        var optimize = function (blot) {
	            // Post-order traversal
	            if (
	            // @ts-ignore
	            blot.domNode[Registry.DATA_KEY] == null ||
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations == null) {
	                return;
	            }
	            if (blot instanceof container_1.default) {
	                blot.children.forEach(optimize);
	            }
	            blot.optimize(context);
	        };
	        var remaining = mutations;
	        for (var i = 0; remaining.length > 0; i += 1) {
	            if (i >= MAX_OPTIMIZE_ITERATIONS) {
	                throw new Error('[Parchment] Maximum optimize iterations reached');
	            }
	            remaining.forEach(function (mutation) {
	                var blot = Registry.find(mutation.target, true);
	                if (blot == null)
	                    return;
	                if (blot.domNode === mutation.target) {
	                    if (mutation.type === 'childList') {
	                        mark(Registry.find(mutation.previousSibling, false));
	                        [].forEach.call(mutation.addedNodes, function (node) {
	                            var child = Registry.find(node, false);
	                            mark(child, false);
	                            if (child instanceof container_1.default) {
	                                child.children.forEach(function (grandChild) {
	                                    mark(grandChild, false);
	                                });
	                            }
	                        });
	                    }
	                    else if (mutation.type === 'attributes') {
	                        mark(blot.prev);
	                    }
	                }
	                mark(blot);
	            });
	            this.children.forEach(optimize);
	            remaining = [].slice.call(this.observer.takeRecords());
	            records = remaining.slice();
	            while (records.length > 0)
	                mutations.push(records.pop());
	        }
	    };
	    ScrollBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (context === void 0) { context = {}; }
	        mutations = mutations || this.observer.takeRecords();
	        // TODO use WeakMap
	        mutations
	            .map(function (mutation) {
	            var blot = Registry.find(mutation.target, true);
	            if (blot == null)
	                return null;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
	                return blot;
	            }
	            else {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
	                return null;
	            }
	        })
	            .forEach(function (blot) {
	            if (blot == null ||
	                blot === _this ||
	                //@ts-ignore
	                blot.domNode[Registry.DATA_KEY] == null)
	                return;
	            // @ts-ignore
	            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
	        });
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY].mutations != null) {
	            // @ts-ignore
	            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
	        }
	        this.optimize(mutations, context);
	    };
	    ScrollBlot.blotName = 'scroll';
	    ScrollBlot.defaultChild = 'block';
	    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
	    ScrollBlot.tagName = 'DIV';
	    return ScrollBlot;
	}(container_1.default));
	exports.default = ScrollBlot;
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	// Shallow object comparison
	function isEqual(obj1, obj2) {
	    if (Object.keys(obj1).length !== Object.keys(obj2).length)
	        return false;
	    // @ts-ignore
	    for (var prop in obj1) {
	        // @ts-ignore
	        if (obj1[prop] !== obj2[prop])
	            return false;
	    }
	    return true;
	}
	var InlineBlot = /** @class */ (function (_super) {
	    __extends(InlineBlot, _super);
	    function InlineBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InlineBlot.formats = function (domNode) {
	        if (domNode.tagName === InlineBlot.tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    InlineBlot.prototype.format = function (name, value) {
	        var _this = this;
	        if (name === this.statics.blotName && !value) {
	            this.children.forEach(function (child) {
	                if (!(child instanceof format_1.default)) {
	                    child = child.wrap(InlineBlot.blotName, true);
	                }
	                _this.attributes.copy(child);
	            });
	            this.unwrap();
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    InlineBlot.prototype.formatAt = function (index, length, name, value) {
	        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
	            var blot = this.isolate(index, length);
	            blot.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    InlineBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        var formats = this.formats();
	        if (Object.keys(formats).length === 0) {
	            return this.unwrap(); // unformatted span
	        }
	        var next = this.next;
	        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
	            next.moveChildren(this);
	            next.remove();
	        }
	    };
	    InlineBlot.blotName = 'inline';
	    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
	    InlineBlot.tagName = 'SPAN';
	    return InlineBlot;
	}(format_1.default));
	exports.default = InlineBlot;
	
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	var BlockBlot = /** @class */ (function (_super) {
	    __extends(BlockBlot, _super);
	    function BlockBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BlockBlot.formats = function (domNode) {
	        var tagName = Registry.query(BlockBlot.blotName).tagName;
	        if (domNode.tagName === tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    BlockBlot.prototype.format = function (name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
	            return;
	        }
	        else if (name === this.statics.blotName && !value) {
	            this.replaceWith(BlockBlot.blotName);
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    BlockBlot.prototype.formatAt = function (index, length, name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    BlockBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
	            // Insert text or inline
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	        else {
	            var after = this.split(index);
	            var blot = Registry.create(value, def);
	            after.parent.insertBefore(blot, after);
	        }
	    };
	    BlockBlot.prototype.update = function (mutations, context) {
	        if (navigator.userAgent.match(/Trident/)) {
	            this.build();
	        }
	        else {
	            _super.prototype.update.call(this, mutations, context);
	        }
	    };
	    BlockBlot.blotName = 'block';
	    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
	    BlockBlot.tagName = 'P';
	    return BlockBlot;
	}(format_1.default));
	exports.default = BlockBlot;
	
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var EmbedBlot = /** @class */ (function (_super) {
	    __extends(EmbedBlot, _super);
	    function EmbedBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EmbedBlot.formats = function (domNode) {
	        return undefined;
	    };
	    EmbedBlot.prototype.format = function (name, value) {
	        // super.formatAt wraps, which is what we want in general,
	        // but this allows subclasses to overwrite for formats
	        // that just apply to particular embeds
	        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
	    };
	    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
	        if (index === 0 && length === this.length()) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    EmbedBlot.prototype.formats = function () {
	        return this.statics.formats(this.domNode);
	    };
	    return EmbedBlot;
	}(leaf_1.default));
	exports.default = EmbedBlot;
	
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var Registry = __webpack_require__(1);
	var TextBlot = /** @class */ (function (_super) {
	    __extends(TextBlot, _super);
	    function TextBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.text = _this.statics.value(_this.domNode);
	        return _this;
	    }
	    TextBlot.create = function (value) {
	        return document.createTextNode(value);
	    };
	    TextBlot.value = function (domNode) {
	        var text = domNode.data;
	        // @ts-ignore
	        if (text['normalize'])
	            text = text['normalize']();
	        return text;
	    };
	    TextBlot.prototype.deleteAt = function (index, length) {
	        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
	    };
	    TextBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node) {
	            return offset;
	        }
	        return -1;
	    };
	    TextBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null) {
	            this.text = this.text.slice(0, index) + value + this.text.slice(index);
	            this.domNode.data = this.text;
	        }
	        else {
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	    };
	    TextBlot.prototype.length = function () {
	        return this.text.length;
	    };
	    TextBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        this.text = this.statics.value(this.domNode);
	        if (this.text.length === 0) {
	            this.remove();
	        }
	        else if (this.next instanceof TextBlot && this.next.prev === this) {
	            this.insertAt(this.length(), this.next.value());
	            this.next.remove();
	        }
	    };
	    TextBlot.prototype.position = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        return [this.domNode, index];
	    };
	    TextBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = Registry.create(this.domNode.splitText(index));
	        this.parent.insertBefore(after, this.next);
	        this.text = this.statics.value(this.domNode);
	        return after;
	    };
	    TextBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (mutations.some(function (mutation) {
	            return mutation.type === 'characterData' && mutation.target === _this.domNode;
	        })) {
	            this.text = this.statics.value(this.domNode);
	        }
	    };
	    TextBlot.prototype.value = function () {
	        return this.text;
	    };
	    TextBlot.blotName = 'text';
	    TextBlot.scope = Registry.Scope.INLINE_BLOT;
	    return TextBlot;
	}(leaf_1.default));
	exports.default = TextBlot;
	
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var elem = document.createElement('div');
	elem.classList.toggle('test-class', false);
	if (elem.classList.contains('test-class')) {
	  var _toggle = DOMTokenList.prototype.toggle;
	  DOMTokenList.prototype.toggle = function (token, force) {
	    if (arguments.length > 1 && !this.contains(token) === !force) {
	      return force;
	    } else {
	      return _toggle.call(this, token);
	    }
	  };
	}
	
	if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    position = position || 0;
	    return this.substr(position, searchString.length) === searchString;
	  };
	}
	
	if (!String.prototype.endsWith) {
	  String.prototype.endsWith = function (searchString, position) {
	    var subjectString = this.toString();
	    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
	      position = subjectString.length;
	    }
	    position -= searchString.length;
	    var lastIndex = subjectString.indexOf(searchString, position);
	    return lastIndex !== -1 && lastIndex === position;
	  };
	}
	
	if (!Array.prototype.find) {
	  Object.defineProperty(Array.prototype, "find", {
	    value: function value(predicate) {
	      if (this === null) {
	        throw new TypeError('Array.prototype.find called on null or undefined');
	      }
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	      var list = Object(this);
	      var length = list.length >>> 0;
	      var thisArg = arguments[1];
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return value;
	        }
	      }
	      return undefined;
	    }
	  });
	}
	
	document.addEventListener("DOMContentLoaded", function () {
	  // Disable resizing in Firefox
	  document.execCommand("enableObjectResizing", false, false);
	  // Disable automatic linkifying in IE11
	  document.execCommand("autoUrlDetect", false, false);
	});
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports) {
	
	/**
	 * This library modifies the diff-patch-match library by Neil Fraser
	 * by removing the patch and match functionality and certain advanced
	 * options in the diff function. The original license is as follows:
	 *
	 * ===
	 *
	 * Diff Match and Patch
	 *
	 * Copyright 2006 Google Inc.
	 * http://code.google.com/p/google-diff-match-patch/
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;
	
	
	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {Int} cursor_pos Expected edit position in text1 (optional)
	 * @return {Array} Array of diff tuples.
	 */
	function diff_main(text1, text2, cursor_pos) {
	  // Check for equality (speedup).
	  if (text1 == text2) {
	    if (text1) {
	      return [[DIFF_EQUAL, text1]];
	    }
	    return [];
	  }
	
	  // Check cursor_pos within bounds
	  if (cursor_pos < 0 || text1.length < cursor_pos) {
	    cursor_pos = null;
	  }
	
	  // Trim off common prefix (speedup).
	  var commonlength = diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);
	
	  // Trim off common suffix (speedup).
	  commonlength = diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);
	
	  // Compute the diff on the middle block.
	  var diffs = diff_compute_(text1, text2);
	
	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift([DIFF_EQUAL, commonprefix]);
	  }
	  if (commonsuffix) {
	    diffs.push([DIFF_EQUAL, commonsuffix]);
	  }
	  diff_cleanupMerge(diffs);
	  if (cursor_pos != null) {
	    diffs = fix_cursor(diffs, cursor_pos);
	  }
	  diffs = fix_emoji(diffs);
	  return diffs;
	};
	
	
	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_compute_(text1, text2) {
	  var diffs;
	
	  if (!text1) {
	    // Just add some text (speedup).
	    return [[DIFF_INSERT, text2]];
	  }
	
	  if (!text2) {
	    // Just delete some text (speedup).
	    return [[DIFF_DELETE, text1]];
	  }
	
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i != -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
	             [DIFF_EQUAL, shorttext],
	             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }
	
	  if (shorttext.length == 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	  }
	
	  // Check to see if the problem can be split in two.
	  var hm = diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = diff_main(text1_a, text2_a);
	    var diffs_b = diff_main(text1_b, text2_b);
	    // Merge the results.
	    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
	  }
	
	  return diff_bisect_(text1, text2);
	};
	
	
	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 * @private
	 */
	function diff_bisect_(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = (delta % 2 != 0);
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (x1 < text1_length && y1 < text2_length &&
	             text1.charAt(x1) == text2.charAt(y1)) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	
	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (x2 < text1_length && y2 < text2_length &&
	             text1.charAt(text1_length - x2 - 1) ==
	             text2.charAt(text2_length - y2 - 1)) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	};
	
	
	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_bisectSplit_(text1, text2, x, y) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);
	
	  // Compute both diffs serially.
	  var diffs = diff_main(text1a, text2a);
	  var diffsb = diff_main(text1b, text2b);
	
	  return diffs.concat(diffsb);
	};
	
	
	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	function diff_commonPrefix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(pointerstart, pointermid) ==
	        text2.substring(pointerstart, pointermid)) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	function diff_commonSuffix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 ||
	      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 */
	function diff_halfMatch_(text1, text2) {
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null;  // Pointless.
	  }
	
	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = '';
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
	      var prefixLength = diff_commonPrefix(longtext.substring(i),
	                                           shorttext.substring(j));
	      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
	                                           shorttext.substring(0, j));
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common = shorttext.substring(j - suffixLength, j) +
	            shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [best_longtext_a, best_longtext_b,
	              best_shorttext_a, best_shorttext_b, best_common];
	    } else {
	      return null;
	    }
	  }
	
	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 4));
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 2));
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }
	
	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	};
	
	
	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {Array} diffs Array of diff tuples.
	 */
	function diff_cleanupMerge(diffs) {
	  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  var commonlength;
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete + count_insert > 1) {
	          if (count_delete !== 0 && count_insert !== 0) {
	            // Factor out any common prefixies.
	            commonlength = diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if ((pointer - count_delete - count_insert) > 0 &&
	                  diffs[pointer - count_delete - count_insert - 1][0] ==
	                  DIFF_EQUAL) {
	                diffs[pointer - count_delete - count_insert - 1][1] +=
	                    text_insert.substring(0, commonlength);
	              } else {
	                diffs.splice(0, 0, [DIFF_EQUAL,
	                                    text_insert.substring(0, commonlength)]);
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixies.
	            commonlength = diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] = text_insert.substring(text_insert.length -
	                  commonlength) + diffs[pointer][1];
	              text_insert = text_insert.substring(0, text_insert.length -
	                  commonlength);
	              text_delete = text_delete.substring(0, text_delete.length -
	                  commonlength);
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          if (count_delete === 0) {
	            diffs.splice(pointer - count_insert,
	                count_delete + count_insert, [DIFF_INSERT, text_insert]);
	          } else if (count_insert === 0) {
	            diffs.splice(pointer - count_delete,
	                count_delete + count_insert, [DIFF_DELETE, text_delete]);
	          } else {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_DELETE, text_delete],
	                [DIFF_INSERT, text_insert]);
	          }
	          pointer = pointer - count_delete - count_insert +
	                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
	        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === '') {
	    diffs.pop();  // Remove the dummy entry at the end.
	  }
	
	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      if (diffs[pointer][1].substring(diffs[pointer][1].length -
	          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] = diffs[pointer - 1][1] +
	            diffs[pointer][1].substring(0, diffs[pointer][1].length -
	                                        diffs[pointer - 1][1].length);
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	          diffs[pointer + 1][1]) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	            diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    diff_cleanupMerge(diffs);
	  }
	};
	
	
	var diff = diff_main;
	diff.INSERT = DIFF_INSERT;
	diff.DELETE = DIFF_DELETE;
	diff.EQUAL = DIFF_EQUAL;
	
	module.exports = diff;
	
	/*
	 * Modify a diff such that the cursor position points to the start of a change:
	 * E.g.
	 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
	 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
	 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
	 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
	 */
	function cursor_normalize_diff (diffs, cursor_pos) {
	  if (cursor_pos === 0) {
	    return [DIFF_EQUAL, diffs];
	  }
	  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
	    var d = diffs[i];
	    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
	      var next_pos = current_pos + d[1].length;
	      if (cursor_pos === next_pos) {
	        return [i + 1, diffs];
	      } else if (cursor_pos < next_pos) {
	        // copy to prevent side effects
	        diffs = diffs.slice();
	        // split d into two diff changes
	        var split_pos = cursor_pos - current_pos;
	        var d_left = [d[0], d[1].slice(0, split_pos)];
	        var d_right = [d[0], d[1].slice(split_pos)];
	        diffs.splice(i, 1, d_left, d_right);
	        return [i + 1, diffs];
	      } else {
	        current_pos = next_pos;
	      }
	    }
	  }
	  throw new Error('cursor_pos is out of bounds!')
	}
	
	/*
	 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
	 *
	 * Case 1)
	 *   Check if a naive shift is possible:
	 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
	 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
	 * Case 2)
	 *   Check if the following shifts are possible:
	 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
	 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
	 *         ^            ^
	 *         d          d_next
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} Array of diff tuples
	 */
	function fix_cursor (diffs, cursor_pos) {
	  var norm = cursor_normalize_diff(diffs, cursor_pos);
	  var ndiffs = norm[1];
	  var cursor_pointer = norm[0];
	  var d = ndiffs[cursor_pointer];
	  var d_next = ndiffs[cursor_pointer + 1];
	
	  if (d == null) {
	    // Text was deleted from end of original string,
	    // cursor is now out of bounds in new string
	    return diffs;
	  } else if (d[0] !== DIFF_EQUAL) {
	    // A modification happened at the cursor location.
	    // This is the expected outcome, so we can return the original diff.
	    return diffs;
	  } else {
	    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
	      // Case 1)
	      // It is possible to perform a naive shift
	      ndiffs.splice(cursor_pointer, 2, d_next, d)
	      return merge_tuples(ndiffs, cursor_pointer, 2)
	    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
	      // Case 2)
	      // d[1] is a prefix of d_next[1]
	      // We can assume that d_next[0] !== 0, since d[0] === 0
	      // Shift edit locations..
	      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
	      var suffix = d_next[1].slice(d[1].length);
	      if (suffix.length > 0) {
	        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
	      }
	      return merge_tuples(ndiffs, cursor_pointer, 3)
	    } else {
	      // Not possible to perform any modification
	      return diffs;
	    }
	  }
	}
	
	/*
	 * Check diff did not split surrogate pairs.
	 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
	 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @return {Array} Array of diff tuples
	 */
	function fix_emoji (diffs) {
	  var compact = false;
	  var starts_with_pair_end = function(str) {
	    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
	  }
	  var ends_with_pair_start = function(str) {
	    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
	  }
	  for (var i = 2; i < diffs.length; i += 1) {
	    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
	        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
	        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
	      compact = true;
	
	      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
	      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];
	
	      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
	    }
	  }
	  if (!compact) {
	    return diffs;
	  }
	  var fixed_diffs = [];
	  for (var i = 0; i < diffs.length; i += 1) {
	    if (diffs[i][1].length > 0) {
	      fixed_diffs.push(diffs[i]);
	    }
	  }
	  return fixed_diffs;
	}
	
	/*
	 * Try to merge tuples with their neigbors in a given range.
	 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
	 *
	 * @param {Array} diffs Array of diff tuples.
	 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
	 * @param {Int} length Number of consecutive elements to check.
	 * @return {Array} Array of merged diff tuples.
	 */
	function merge_tuples (diffs, start, length) {
	  // Check from (start-1) to (start+length).
	  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
	    if (i + 1 < diffs.length) {
	      var left_d = diffs[i];
	      var right_d = diffs[i+1];
	      if (left_d[0] === right_d[1]) {
	        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
	      }
	    }
	  }
	  return diffs;
	}
	
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports) {
	
	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports) {
	
	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};
	
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if ('undefined' !== typeof module) {
	  module.exports = EventEmitter;
	}
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend2 = __webpack_require__(3);
	
	var _extend3 = _interopRequireDefault(_extend2);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _align = __webpack_require__(36);
	
	var _background = __webpack_require__(37);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _color = __webpack_require__(26);
	
	var _direction = __webpack_require__(38);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:clipboard');
	
	var DOM_KEY = '__ql-matcher';
	
	var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];
	
	var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var Clipboard = function (_Module) {
	  _inherits(Clipboard, _Module);
	
	  function Clipboard(quill, options) {
	    _classCallCheck(this, Clipboard);
	
	    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
	
	    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
	    _this.container = _this.quill.addContainer('ql-clipboard');
	    _this.container.setAttribute('contenteditable', true);
	    _this.container.setAttribute('tabindex', -1);
	    _this.matchers = [];
	    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          selector = _ref2[0],
	          matcher = _ref2[1];
	
	      if (!options.matchVisual && matcher === matchSpacing) return;
	      _this.addMatcher(selector, matcher);
	    });
	    return _this;
	  }
	
	  _createClass(Clipboard, [{
	    key: 'addMatcher',
	    value: function addMatcher(selector, matcher) {
	      this.matchers.push([selector, matcher]);
	    }
	  }, {
	    key: 'convert',
	    value: function convert(html) {
	      if (typeof html === 'string') {
	        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
	        return this.convert();
	      }
	      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
	      if (formats[_code2.default.blotName]) {
	        var text = this.container.innerText;
	        this.container.innerHTML = '';
	        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
	      }
	
	      var _prepareMatching = this.prepareMatching(),
	          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
	          elementMatchers = _prepareMatching2[0],
	          textMatchers = _prepareMatching2[1];
	
	      var delta = traverse(this.container, elementMatchers, textMatchers);
	      // Remove trailing newline
	      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
	        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
	      }
	      debug.log('convert', this.container.innerHTML, delta);
	      this.container.innerHTML = '';
	      return delta;
	    }
	  }, {
	    key: 'dangerouslyPasteHTML',
	    value: function dangerouslyPasteHTML(index, html) {
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
	
	      if (typeof index === 'string') {
	        this.quill.setContents(this.convert(index), html);
	        this.quill.setSelection(0, _quill2.default.sources.SILENT);
	      } else {
	        var paste = this.convert(html);
	        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
	        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
	      }
	    }
	  }, {
	    key: 'onPaste',
	    value: function onPaste(e) {
	      var _this2 = this;
	
	      if (e.defaultPrevented || !this.quill.isEnabled()) return;
	      var range = this.quill.getSelection();
	      var delta = new _quillDelta2.default().retain(range.index);
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.container.focus();
	      this.quill.selection.update(_quill2.default.sources.SILENT);
	      setTimeout(function () {
	        delta = delta.concat(_this2.convert()).delete(range.length);
	        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
	        // range.length contributes to delta.length()
	        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
	        _this2.quill.scrollingContainer.scrollTop = scrollTop;
	        _this2.quill.focus();
	      }, 1);
	    }
	  }, {
	    key: 'prepareMatching',
	    value: function prepareMatching() {
	      var _this3 = this;
	
	      var elementMatchers = [],
	          textMatchers = [];
	      this.matchers.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            selector = _pair[0],
	            matcher = _pair[1];
	
	        switch (selector) {
	          case Node.TEXT_NODE:
	            textMatchers.push(matcher);
	            break;
	          case Node.ELEMENT_NODE:
	            elementMatchers.push(matcher);
	            break;
	          default:
	            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
	              // TODO use weakmap
	              node[DOM_KEY] = node[DOM_KEY] || [];
	              node[DOM_KEY].push(matcher);
	            });
	            break;
	        }
	      });
	      return [elementMatchers, textMatchers];
	    }
	  }]);
	
	  return Clipboard;
	}(_module2.default);
	
	Clipboard.DEFAULTS = {
	  matchers: [],
	  matchVisual: true
	};
	
	function applyFormat(delta, format, value) {
	  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
	    return Object.keys(format).reduce(function (delta, key) {
	      return applyFormat(delta, key, format[key]);
	    }, delta);
	  } else {
	    return delta.reduce(function (delta, op) {
	      if (op.attributes && op.attributes[format]) {
	        return delta.push(op);
	      } else {
	        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
	      }
	    }, new _quillDelta2.default());
	  }
	}
	
	function computeStyle(node) {
	  if (node.nodeType !== Node.ELEMENT_NODE) return {};
	  var DOM_KEY = '__ql-computed-style';
	  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
	}
	
	function deltaEndsWith(delta, text) {
	  var endText = "";
	  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
	    var op = delta.ops[i];
	    if (typeof op.insert !== 'string') break;
	    endText = op.insert + endText;
	  }
	  return endText.slice(-1 * text.length) === text;
	}
	
	function isLine(node) {
	  if (node.childNodes.length === 0) return false; // Exclude embed blocks
	  var style = computeStyle(node);
	  return ['block', 'list-item'].indexOf(style.display) > -1;
	}
	
	function traverse(node, elementMatchers, textMatchers) {
	  // Post-order
	  if (node.nodeType === node.TEXT_NODE) {
	    return textMatchers.reduce(function (delta, matcher) {
	      return matcher(node, delta);
	    }, new _quillDelta2.default());
	  } else if (node.nodeType === node.ELEMENT_NODE) {
	    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
	      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
	      if (childNode.nodeType === node.ELEMENT_NODE) {
	        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	      }
	      return delta.concat(childrenDelta);
	    }, new _quillDelta2.default());
	  } else {
	    return new _quillDelta2.default();
	  }
	}
	
	function matchAlias(format, node, delta) {
	  return applyFormat(delta, format, true);
	}
	
	function matchAttributor(node, delta) {
	  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
	  var classes = _parchment2.default.Attributor.Class.keys(node);
	  var styles = _parchment2.default.Attributor.Style.keys(node);
	  var formats = {};
	  attributes.concat(classes).concat(styles).forEach(function (name) {
	    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
	    if (attr != null) {
	      formats[attr.attrName] = attr.value(node);
	      if (formats[attr.attrName]) return;
	    }
	    attr = ATTRIBUTE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	    attr = STYLE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      attr = STYLE_ATTRIBUTORS[name];
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	  });
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  return delta;
	}
	
	function matchBlot(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null) return delta;
	  if (match.prototype instanceof _parchment2.default.Embed) {
	    var embed = {};
	    var value = match.value(node);
	    if (value != null) {
	      embed[match.blotName] = value;
	      delta = new _quillDelta2.default().insert(embed, match.formats(node));
	    }
	  } else if (typeof match.formats === 'function') {
	    delta = applyFormat(delta, match.blotName, match.formats(node));
	  }
	  return delta;
	}
	
	function matchBreak(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    delta.insert('\n');
	  }
	  return delta;
	}
	
	function matchIgnore() {
	  return new _quillDelta2.default();
	}
	
	function matchIndent(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
	    return delta;
	  }
	  var indent = -1,
	      parent = node.parentNode;
	  while (!parent.classList.contains('ql-clipboard')) {
	    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
	      indent += 1;
	    }
	    parent = parent.parentNode;
	  }
	  if (indent <= 0) return delta;
	  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
	}
	
	function matchNewline(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchSpacing(node, delta) {
	  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
	    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
	    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchStyles(node, delta) {
	  var formats = {};
	  var style = node.style || {};
	  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
	    formats.italic = true;
	  }
	  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
	    formats.bold = true;
	  }
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  if (parseFloat(style.textIndent || 0) > 0) {
	    // Could be 0.5in
	    delta = new _quillDelta2.default().insert('\t').concat(delta);
	  }
	  return delta;
	}
	
	function matchText(node, delta) {
	  var text = node.data;
	  // Word represents empty line with <o:p>&nbsp;</o:p>
	  if (node.parentNode.tagName === 'O:P') {
	    return delta.insert(text.trim());
	  }
	  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
	    return delta;
	  }
	  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
	    // eslint-disable-next-line func-style
	    var replacer = function replacer(collapse, match) {
	      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
	      return match.length < 1 && collapse ? ' ' : match;
	    };
	    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
	    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
	    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
	      text = text.replace(/^\s+/, replacer.bind(replacer, false));
	    }
	    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
	      text = text.replace(/\s+$/, replacer.bind(replacer, false));
	    }
	  }
	  return delta.insert(text);
	}
	
	exports.default = Clipboard;
	exports.matchAttributor = matchAttributor;
	exports.matchBlot = matchBlot;
	exports.matchNewline = matchNewline;
	exports.matchSpacing = matchSpacing;
	exports.matchText = matchText;
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bold = function (_Inline) {
	  _inherits(Bold, _Inline);
	
	  function Bold() {
	    _classCallCheck(this, Bold);
	
	    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
	  }
	
	  _createClass(Bold, [{
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
	      if (this.domNode.tagName !== this.statics.tagName[0]) {
	        this.replaceWith(this.statics.blotName);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create() {
	      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return Bold;
	}(_inline2.default);
	
	Bold.blotName = 'bold';
	Bold.tagName = ['STRONG', 'B'];
	
	exports.default = Bold;
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addControls = exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:toolbar');
	
	var Toolbar = function (_Module) {
	  _inherits(Toolbar, _Module);
	
	  function Toolbar(quill, options) {
	    _classCallCheck(this, Toolbar);
	
	    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
	
	    if (Array.isArray(_this.options.container)) {
	      var container = document.createElement('div');
	      addControls(container, _this.options.container);
	      quill.container.parentNode.insertBefore(container, quill.container);
	      _this.container = container;
	    } else if (typeof _this.options.container === 'string') {
	      _this.container = document.querySelector(_this.options.container);
	    } else {
	      _this.container = _this.options.container;
	    }
	    if (!(_this.container instanceof HTMLElement)) {
	      var _ret;
	
	      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
	    }
	    _this.container.classList.add('ql-toolbar');
	    _this.controls = [];
	    _this.handlers = {};
	    Object.keys(_this.options.handlers).forEach(function (format) {
	      _this.addHandler(format, _this.options.handlers[format]);
	    });
	    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
	      _this.attach(input);
	    });
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
	      if (type === _quill2.default.events.SELECTION_CHANGE) {
	        _this.update(range);
	      }
	    });
	    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      var _this$quill$selection = _this.quill.selection.getRange(),
	          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
	          range = _this$quill$selection2[0]; // quill.getSelection triggers update
	
	
	      _this.update(range);
	    });
	    return _this;
	  }
	
	  _createClass(Toolbar, [{
	    key: 'addHandler',
	    value: function addHandler(format, handler) {
	      this.handlers[format] = handler;
	    }
	  }, {
	    key: 'attach',
	    value: function attach(input) {
	      var _this2 = this;
	
	      var format = [].find.call(input.classList, function (className) {
	        return className.indexOf('ql-') === 0;
	      });
	      if (!format) return;
	      format = format.slice('ql-'.length);
	      if (input.tagName === 'BUTTON') {
	        input.setAttribute('type', 'button');
	      }
	      if (this.handlers[format] == null) {
	        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
	          debug.warn('ignoring attaching to disabled format', format, input);
	          return;
	        }
	        if (_parchment2.default.query(format) == null) {
	          debug.warn('ignoring attaching to nonexistent format', format, input);
	          return;
	        }
	      }
	      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
	      input.addEventListener(eventName, function (e) {
	        var value = void 0;
	        if (input.tagName === 'SELECT') {
	          if (input.selectedIndex < 0) return;
	          var selected = input.options[input.selectedIndex];
	          if (selected.hasAttribute('selected')) {
	            value = false;
	          } else {
	            value = selected.value || false;
	          }
	        } else {
	          if (input.classList.contains('ql-active')) {
	            value = false;
	          } else {
	            value = input.value || !input.hasAttribute('value');
	          }
	          e.preventDefault();
	        }
	        _this2.quill.focus();
	
	        var _quill$selection$getR = _this2.quill.selection.getRange(),
	            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
	            range = _quill$selection$getR2[0];
	
	        if (_this2.handlers[format] != null) {
	          _this2.handlers[format].call(_this2, value);
	        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
	          value = prompt('Enter ' + format);
	          if (!value) return;
	          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
	        } else {
	          _this2.quill.format(format, value, _quill2.default.sources.USER);
	        }
	        _this2.update(range);
	      });
	      // TODO use weakmap
	      this.controls.push([format, input]);
	    }
	  }, {
	    key: 'update',
	    value: function update(range) {
	      var formats = range == null ? {} : this.quill.getFormat(range);
	      this.controls.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            format = _pair[0],
	            input = _pair[1];
	
	        if (input.tagName === 'SELECT') {
	          var option = void 0;
	          if (range == null) {
	            option = null;
	          } else if (formats[format] == null) {
	            option = input.querySelector('option[selected]');
	          } else if (!Array.isArray(formats[format])) {
	            var value = formats[format];
	            if (typeof value === 'string') {
	              value = value.replace(/\"/g, '\\"');
	            }
	            option = input.querySelector('option[value="' + value + '"]');
	          }
	          if (option == null) {
	            input.value = ''; // TODO make configurable?
	            input.selectedIndex = -1;
	          } else {
	            option.selected = true;
	          }
	        } else {
	          if (range == null) {
	            input.classList.remove('ql-active');
	          } else if (input.hasAttribute('value')) {
	            // both being null should match (default values)
	            // '1' should match with 1 (headers)
	            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
	            input.classList.toggle('ql-active', isActive);
	          } else {
	            input.classList.toggle('ql-active', formats[format] != null);
	          }
	        }
	      });
	    }
	  }]);
	
	  return Toolbar;
	}(_module2.default);
	
	Toolbar.DEFAULTS = {};
	
	function addButton(container, format, value) {
	  var input = document.createElement('button');
	  input.setAttribute('type', 'button');
	  input.classList.add('ql-' + format);
	  if (value != null) {
	    input.value = value;
	  }
	  container.appendChild(input);
	}
	
	function addControls(container, groups) {
	  if (!Array.isArray(groups[0])) {
	    groups = [groups];
	  }
	  groups.forEach(function (controls) {
	    var group = document.createElement('span');
	    group.classList.add('ql-formats');
	    controls.forEach(function (control) {
	      if (typeof control === 'string') {
	        addButton(group, control);
	      } else {
	        var format = Object.keys(control)[0];
	        var value = control[format];
	        if (Array.isArray(value)) {
	          addSelect(group, format, value);
	        } else {
	          addButton(group, format, value);
	        }
	      }
	    });
	    container.appendChild(group);
	  });
	}
	
	function addSelect(container, format, values) {
	  var input = document.createElement('select');
	  input.classList.add('ql-' + format);
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value !== false) {
	      option.setAttribute('value', value);
	    } else {
	      option.setAttribute('selected', 'selected');
	    }
	    input.appendChild(option);
	  });
	  container.appendChild(input);
	}
	
	Toolbar.DEFAULTS = {
	  container: null,
	  handlers: {
	    clean: function clean() {
	      var _this3 = this;
	
	      var range = this.quill.getSelection();
	      if (range == null) return;
	      if (range.length == 0) {
	        var formats = this.quill.getFormat();
	        Object.keys(formats).forEach(function (name) {
	          // Clean functionality in existing apps only clean inline formats
	          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
	            _this3.quill.format(name, false);
	          }
	        });
	      } else {
	        this.quill.removeFormat(range, _quill2.default.sources.USER);
	      }
	    },
	    direction: function direction(value) {
	      var align = this.quill.getFormat()['align'];
	      if (value === 'rtl' && align == null) {
	        this.quill.format('align', 'right', _quill2.default.sources.USER);
	      } else if (!value && align === 'right') {
	        this.quill.format('align', false, _quill2.default.sources.USER);
	      }
	      this.quill.format('direction', value, _quill2.default.sources.USER);
	    },
	    indent: function indent(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      var indent = parseInt(formats.indent || 0);
	      if (value === '+1' || value === '-1') {
	        var modifier = value === '+1' ? 1 : -1;
	        if (formats.direction === 'rtl') modifier *= -1;
	        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
	      }
	    },
	    link: function link(value) {
	      if (value === true) {
	        value = prompt('Enter link URL:');
	      }
	      this.quill.format('link', value, _quill2.default.sources.USER);
	    },
	    list: function list(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      if (value === 'check') {
	        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        } else {
	          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
	        }
	      } else {
	        this.quill.format('list', value, _quill2.default.sources.USER);
	      }
	    }
	  }
	};
	
	exports.default = Toolbar;
	exports.addControls = addControls;
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorPicker = function (_Picker) {
	  _inherits(ColorPicker, _Picker);
	
	  function ColorPicker(select, label) {
	    _classCallCheck(this, ColorPicker);
	
	    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
	
	    _this.label.innerHTML = label;
	    _this.container.classList.add('ql-color-picker');
	    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
	      item.classList.add('ql-primary');
	    });
	    return _this;
	  }
	
	  _createClass(ColorPicker, [{
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
	      item.style.backgroundColor = option.getAttribute('value') || '';
	      return item;
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      var colorLabel = this.label.querySelector('.ql-color-label');
	      var value = item ? item.getAttribute('data-value') || '' : '';
	      if (colorLabel) {
	        if (colorLabel.tagName === 'line') {
	          colorLabel.style.stroke = value;
	        } else {
	          colorLabel.style.fill = value;
	        }
	      }
	    }
	  }]);
	
	  return ColorPicker;
	}(_picker2.default);
	
	exports.default = ColorPicker;
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconPicker = function (_Picker) {
	  _inherits(IconPicker, _Picker);
	
	  function IconPicker(select, icons) {
	    _classCallCheck(this, IconPicker);
	
	    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
	
	    _this.container.classList.add('ql-icon-picker');
	    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
	      item.innerHTML = icons[item.getAttribute('data-value') || ''];
	    });
	    _this.defaultItem = _this.container.querySelector('.ql-selected');
	    _this.selectItem(_this.defaultItem);
	    return _this;
	  }
	
	  _createClass(IconPicker, [{
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      item = item || this.defaultItem;
	      this.label.innerHTML = item.innerHTML;
	    }
	  }]);
	
	  return IconPicker;
	}(_picker2.default);
	
	exports.default = IconPicker;
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tooltip = function () {
	  function Tooltip(quill, boundsContainer) {
	    var _this = this;
	
	    _classCallCheck(this, Tooltip);
	
	    this.quill = quill;
	    this.boundsContainer = boundsContainer || document.body;
	    this.root = quill.addContainer('ql-tooltip');
	    this.root.innerHTML = this.constructor.TEMPLATE;
	    if (this.quill.root === this.quill.scrollingContainer) {
	      this.quill.root.addEventListener('scroll', function () {
	        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
	      });
	    }
	    this.hide();
	  }
	
	  _createClass(Tooltip, [{
	    key: 'hide',
	    value: function hide() {
	      this.root.classList.add('ql-hidden');
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
	      // root.scrollTop should be 0 if scrollContainer !== root
	      var top = reference.bottom + this.quill.root.scrollTop;
	      this.root.style.left = left + 'px';
	      this.root.style.top = top + 'px';
	      this.root.classList.remove('ql-flip');
	      var containerBounds = this.boundsContainer.getBoundingClientRect();
	      var rootBounds = this.root.getBoundingClientRect();
	      var shift = 0;
	      if (rootBounds.right > containerBounds.right) {
	        shift = containerBounds.right - rootBounds.right;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.left < containerBounds.left) {
	        shift = containerBounds.left - rootBounds.left;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.bottom > containerBounds.bottom) {
	        var height = rootBounds.bottom - rootBounds.top;
	        var verticalShift = reference.bottom - reference.top + height;
	        this.root.style.top = top - verticalShift + 'px';
	        this.root.classList.add('ql-flip');
	      }
	      return shift;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.root.classList.remove('ql-editing');
	      this.root.classList.remove('ql-hidden');
	    }
	  }]);
	
	  return Tooltip;
	}();
	
	exports.default = Tooltip;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];
	
	var SnowTheme = function (_BaseTheme) {
	  _inherits(SnowTheme, _BaseTheme);
	
	  function SnowTheme(quill, options) {
	    _classCallCheck(this, SnowTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-snow');
	    return _this;
	  }
	
	  _createClass(SnowTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      toolbar.container.classList.add('ql-snow');
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
	      if (toolbar.container.querySelector('.ql-link')) {
	        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
	          toolbar.handlers['link'].call(toolbar, !context.format.link);
	        });
	      }
	    }
	  }]);
	
	  return SnowTheme;
	}(_base2.default);
	
	SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (value) {
	            var range = this.quill.getSelection();
	            if (range == null || range.length == 0) return;
	            var preview = this.quill.getText(range);
	            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
	              preview = 'mailto:' + preview;
	            }
	            var tooltip = this.quill.theme.tooltip;
	            tooltip.edit('link', preview);
	          } else {
	            this.quill.format('link', false);
	          }
	        }
	      }
	    }
	  }
	});
	
	var SnowTooltip = function (_BaseTooltip) {
	  _inherits(SnowTooltip, _BaseTooltip);
	
	  function SnowTooltip(quill, bounds) {
	    _classCallCheck(this, SnowTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
	
	    _this2.preview = _this2.root.querySelector('a.ql-preview');
	    return _this2;
	  }
	
	  _createClass(SnowTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
	        if (_this3.root.classList.contains('ql-editing')) {
	          _this3.save();
	        } else {
	          _this3.edit('link', _this3.preview.textContent);
	        }
	        event.preventDefault();
	      });
	      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
	        if (_this3.linkRange != null) {
	          var range = _this3.linkRange;
	          _this3.restoreFocus();
	          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
	          delete _this3.linkRange;
	        }
	        event.preventDefault();
	        _this3.hide();
	      });
	      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
	        if (range == null) return;
	        if (range.length === 0 && source === _emitter2.default.sources.USER) {
	          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
	              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	              link = _quill$scroll$descend2[0],
	              offset = _quill$scroll$descend2[1];
	
	          if (link != null) {
	            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
	            var preview = _link2.default.formats(link.domNode);
	            _this3.preview.textContent = preview;
	            _this3.preview.setAttribute('href', preview);
	            _this3.show();
	            _this3.position(_this3.quill.getBounds(_this3.linkRange));
	            return;
	          }
	        } else {
	          delete _this3.linkRange;
	        }
	        _this3.hide();
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
	      this.root.removeAttribute('data-mode');
	    }
	  }]);
	
	  return SnowTooltip;
	}(_base.BaseTooltip);
	
	SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');
	
	exports.default = SnowTheme;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(29);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _align = __webpack_require__(36);
	
	var _direction = __webpack_require__(38);
	
	var _indent = __webpack_require__(64);
	
	var _blockquote = __webpack_require__(65);
	
	var _blockquote2 = _interopRequireDefault(_blockquote);
	
	var _header = __webpack_require__(66);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _list = __webpack_require__(67);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _background = __webpack_require__(37);
	
	var _color = __webpack_require__(26);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	var _italic = __webpack_require__(68);
	
	var _italic2 = _interopRequireDefault(_italic);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _script = __webpack_require__(69);
	
	var _script2 = _interopRequireDefault(_script);
	
	var _strike = __webpack_require__(70);
	
	var _strike2 = _interopRequireDefault(_strike);
	
	var _underline = __webpack_require__(71);
	
	var _underline2 = _interopRequireDefault(_underline);
	
	var _image = __webpack_require__(72);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _video = __webpack_require__(73);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _formula = __webpack_require__(74);
	
	var _formula2 = _interopRequireDefault(_formula);
	
	var _syntax = __webpack_require__(75);
	
	var _syntax2 = _interopRequireDefault(_syntax);
	
	var _toolbar = __webpack_require__(57);
	
	var _toolbar2 = _interopRequireDefault(_toolbar);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _bubble = __webpack_require__(108);
	
	var _bubble2 = _interopRequireDefault(_bubble);
	
	var _snow = __webpack_require__(62);
	
	var _snow2 = _interopRequireDefault(_snow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_core2.default.register({
	  'attributors/attribute/direction': _direction.DirectionAttribute,
	
	  'attributors/class/align': _align.AlignClass,
	  'attributors/class/background': _background.BackgroundClass,
	  'attributors/class/color': _color.ColorClass,
	  'attributors/class/direction': _direction.DirectionClass,
	  'attributors/class/font': _font.FontClass,
	  'attributors/class/size': _size.SizeClass,
	
	  'attributors/style/align': _align.AlignStyle,
	  'attributors/style/background': _background.BackgroundStyle,
	  'attributors/style/color': _color.ColorStyle,
	  'attributors/style/direction': _direction.DirectionStyle,
	  'attributors/style/font': _font.FontStyle,
	  'attributors/style/size': _size.SizeStyle
	}, true);
	
	_core2.default.register({
	  'formats/align': _align.AlignClass,
	  'formats/direction': _direction.DirectionClass,
	  'formats/indent': _indent.IndentClass,
	
	  'formats/background': _background.BackgroundStyle,
	  'formats/color': _color.ColorStyle,
	  'formats/font': _font.FontClass,
	  'formats/size': _size.SizeClass,
	
	  'formats/blockquote': _blockquote2.default,
	  'formats/code-block': _code2.default,
	  'formats/header': _header2.default,
	  'formats/list': _list2.default,
	
	  'formats/bold': _bold2.default,
	  'formats/code': _code.Code,
	  'formats/italic': _italic2.default,
	  'formats/link': _link2.default,
	  'formats/script': _script2.default,
	  'formats/strike': _strike2.default,
	  'formats/underline': _underline2.default,
	
	  'formats/image': _image2.default,
	  'formats/video': _video2.default,
	
	  'formats/list/item': _list.ListItem,
	
	  'modules/formula': _formula2.default,
	  'modules/syntax': _syntax2.default,
	  'modules/toolbar': _toolbar2.default,
	
	  'themes/bubble': _bubble2.default,
	  'themes/snow': _snow2.default,
	
	  'ui/icons': _icons2.default,
	  'ui/picker': _picker2.default,
	  'ui/icon-picker': _iconPicker2.default,
	  'ui/color-picker': _colorPicker2.default,
	  'ui/tooltip': _tooltip2.default
	}, true);
	
	exports.default = _core2.default;
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndentClass = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IdentAttributor = function (_Parchment$Attributor) {
	  _inherits(IdentAttributor, _Parchment$Attributor);
	
	  function IdentAttributor() {
	    _classCallCheck(this, IdentAttributor);
	
	    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
	  }
	
	  _createClass(IdentAttributor, [{
	    key: 'add',
	    value: function add(node, value) {
	      if (value === '+1' || value === '-1') {
	        var indent = this.value(node) || 0;
	        value = value === '+1' ? indent + 1 : indent - 1;
	      }
	      if (value === 0) {
	        this.remove(node);
	        return true;
	      } else {
	        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
	      }
	    }
	  }, {
	    key: 'canAdd',
	    value: function canAdd(node, value) {
	      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
	    }
	  }, {
	    key: 'value',
	    value: function value(node) {
	      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
	    }
	  }]);
	
	  return IdentAttributor;
	}(_parchment2.default.Attributor.Class);
	
	var IndentClass = new IdentAttributor('indent', 'ql-indent', {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
	});
	
	exports.IndentClass = IndentClass;
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Blockquote = function (_Block) {
	  _inherits(Blockquote, _Block);
	
	  function Blockquote() {
	    _classCallCheck(this, Blockquote);
	
	    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
	  }
	
	  return Blockquote;
	}(_block2.default);
	
	Blockquote.blotName = 'blockquote';
	Blockquote.tagName = 'blockquote';
	
	exports.default = Blockquote;
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Block) {
	  _inherits(Header, _Block);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }
	
	  _createClass(Header, null, [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return this.tagName.indexOf(domNode.tagName) + 1;
	    }
	  }]);
	
	  return Header;
	}(_block2.default);
	
	Header.blotName = 'header';
	Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
	
	exports.default = Header;
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ListItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItem = function (_Block) {
	  _inherits(ListItem, _Block);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  _createClass(ListItem, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name === List.blotName && !value) {
	        this.replaceWith(_parchment2.default.create(this.statics.scope));
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (this.prev == null && this.next == null) {
	        this.parent.remove();
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
	      }
	    }
	  }, {
	    key: 'replaceWith',
	    value: function replaceWith(name, value) {
	      this.parent.isolate(this.offset(this.parent), this.length());
	      if (name === this.parent.statics.blotName) {
	        this.parent.replaceWith(name, value);
	        return this;
	      } else {
	        this.parent.unwrap();
	        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
	    }
	  }]);
	
	  return ListItem;
	}(_block2.default);
	
	ListItem.blotName = 'list-item';
	ListItem.tagName = 'LI';
	
	var List = function (_Container) {
	  _inherits(List, _Container);
	
	  _createClass(List, null, [{
	    key: 'create',
	    value: function create(value) {
	      var tagName = value === 'ordered' ? 'OL' : 'UL';
	      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
	      if (value === 'checked' || value === 'unchecked') {
	        node.setAttribute('data-checked', value === 'checked');
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'OL') return 'ordered';
	      if (domNode.tagName === 'UL') {
	        if (domNode.hasAttribute('data-checked')) {
	          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
	        } else {
	          return 'bullet';
	        }
	      }
	      return undefined;
	    }
	  }]);
	
	  function List(domNode) {
	    _classCallCheck(this, List);
	
	    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
	
	    var listEventHandler = function listEventHandler(e) {
	      if (e.target.parentNode !== domNode) return;
	      var format = _this2.statics.formats(domNode);
	      var blot = _parchment2.default.find(e.target);
	      if (format === 'checked') {
	        blot.format('list', 'unchecked');
	      } else if (format === 'unchecked') {
	        blot.format('list', 'checked');
	      }
	    };
	
	    domNode.addEventListener('touchstart', listEventHandler);
	    domNode.addEventListener('mousedown', listEventHandler);
	    return _this2;
	  }
	
	  _createClass(List, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (this.children.length > 0) {
	        this.children.tail.format(name, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      // We don't inherit from FormatBlot
	      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot instanceof ListItem) {
	        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
	      } else {
	        var index = ref == null ? this.length() : ref.offset(this);
	        var after = this.split(index);
	        after.parent.insertBefore(blot, after);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      if (target.statics.blotName !== this.statics.blotName) {
	        var item = _parchment2.default.create(this.statics.defaultChild);
	        target.moveChildren(item);
	        this.appendChild(item);
	      }
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
	    }
	  }]);
	
	  return List;
	}(_container2.default);
	
	List.blotName = 'list';
	List.scope = _parchment2.default.Scope.BLOCK_BLOT;
	List.tagName = ['OL', 'UL'];
	List.defaultChild = 'list-item';
	List.allowedChildren = [ListItem];
	
	exports.ListItem = ListItem;
	exports.default = List;
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Italic = function (_Bold) {
	  _inherits(Italic, _Bold);
	
	  function Italic() {
	    _classCallCheck(this, Italic);
	
	    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
	  }
	
	  return Italic;
	}(_bold2.default);
	
	Italic.blotName = 'italic';
	Italic.tagName = ['EM', 'I'];
	
	exports.default = Italic;
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Script = function (_Inline) {
	  _inherits(Script, _Inline);
	
	  function Script() {
	    _classCallCheck(this, Script);
	
	    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
	  }
	
	  _createClass(Script, null, [{
	    key: 'create',
	    value: function create(value) {
	      if (value === 'super') {
	        return document.createElement('sup');
	      } else if (value === 'sub') {
	        return document.createElement('sub');
	      } else {
	        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'SUB') return 'sub';
	      if (domNode.tagName === 'SUP') return 'super';
	      return undefined;
	    }
	  }]);
	
	  return Script;
	}(_inline2.default);
	
	Script.blotName = 'script';
	Script.tagName = ['SUB', 'SUP'];
	
	exports.default = Script;
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Strike = function (_Inline) {
	  _inherits(Strike, _Inline);
	
	  function Strike() {
	    _classCallCheck(this, Strike);
	
	    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
	  }
	
	  return Strike;
	}(_inline2.default);
	
	Strike.blotName = 'strike';
	Strike.tagName = 'S';
	
	exports.default = Strike;
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Underline = function (_Inline) {
	  _inherits(Underline, _Inline);
	
	  function Underline() {
	    _classCallCheck(this, Underline);
	
	    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
	  }
	
	  return Underline;
	}(_inline2.default);
	
	Underline.blotName = 'underline';
	Underline.tagName = 'U';
	
	exports.default = Underline;
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _link = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['alt', 'height', 'width'];
	
	var Image = function (_Parchment$Embed) {
	  _inherits(Image, _Parchment$Embed);
	
	  function Image() {
	    _classCallCheck(this, Image);
	
	    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	  }
	
	  _createClass(Image, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        node.setAttribute('src', this.sanitize(value));
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'match',
	    value: function match(url) {
	      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
	      );
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Image;
	}(_parchment2.default.Embed);
	
	Image.blotName = 'image';
	Image.tagName = 'IMG';
	
	exports.default = Image;
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _block = __webpack_require__(4);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['height', 'width'];
	
	var Video = function (_BlockEmbed) {
	  _inherits(Video, _BlockEmbed);
	
	  function Video() {
	    _classCallCheck(this, Video);
	
	    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	  }
	
	  _createClass(Video, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
	      node.setAttribute('frameborder', '0');
	      node.setAttribute('allowfullscreen', true);
	      node.setAttribute('src', this.sanitize(value));
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _link2.default.sanitize(url);
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Video;
	}(_block.BlockEmbed);
	
	Video.blotName = 'video';
	Video.className = 'ql-video';
	Video.tagName = 'IFRAME';
	
	exports.default = Video;
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.FormulaBlot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormulaBlot = function (_Embed) {
	  _inherits(FormulaBlot, _Embed);
	
	  function FormulaBlot() {
	    _classCallCheck(this, FormulaBlot);
	
	    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
	  }
	
	  _createClass(FormulaBlot, null, [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        window.katex.render(value, node, {
	          throwOnError: false,
	          errorColor: '#f00'
	        });
	        node.setAttribute('data-value', value);
	      }
	      return node;
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('data-value');
	    }
	  }]);
	
	  return FormulaBlot;
	}(_embed2.default);
	
	FormulaBlot.blotName = 'formula';
	FormulaBlot.className = 'ql-formula';
	FormulaBlot.tagName = 'SPAN';
	
	var Formula = function (_Module) {
	  _inherits(Formula, _Module);
	
	  _createClass(Formula, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(FormulaBlot, true);
	    }
	  }]);
	
	  function Formula() {
	    _classCallCheck(this, Formula);
	
	    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
	
	    if (window.katex == null) {
	      throw new Error('Formula module requires KaTeX.');
	    }
	    return _this2;
	  }
	
	  return Formula;
	}(_module2.default);
	
	exports.FormulaBlot = FormulaBlot;
	exports.default = Formula;
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CodeToken = exports.CodeBlock = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SyntaxCodeBlock = function (_CodeBlock) {
	  _inherits(SyntaxCodeBlock, _CodeBlock);
	
	  function SyntaxCodeBlock() {
	    _classCallCheck(this, SyntaxCodeBlock);
	
	    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(SyntaxCodeBlock, [{
	    key: 'replaceWith',
	    value: function replaceWith(block) {
	      this.domNode.textContent = this.domNode.textContent;
	      this.attach();
	      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(_highlight) {
	      var text = this.domNode.textContent;
	      if (this.cachedText !== text) {
	        if (text.trim().length > 0 || this.cachedText == null) {
	          this.domNode.innerHTML = _highlight(text);
	          this.domNode.normalize();
	          this.attach();
	        }
	        this.cachedText = text;
	      }
	    }
	  }]);
	
	  return SyntaxCodeBlock;
	}(_code2.default);
	
	SyntaxCodeBlock.className = 'ql-syntax';
	
	var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	var Syntax = function (_Module) {
	  _inherits(Syntax, _Module);
	
	  _createClass(Syntax, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(CodeToken, true);
	      _quill2.default.register(SyntaxCodeBlock, true);
	    }
	  }]);
	
	  function Syntax(quill, options) {
	    _classCallCheck(this, Syntax);
	
	    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
	
	    if (typeof _this2.options.highlight !== 'function') {
	      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
	    }
	    var timer = null;
	    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      clearTimeout(timer);
	      timer = setTimeout(function () {
	        _this2.highlight();
	        timer = null;
	      }, _this2.options.interval);
	    });
	    _this2.highlight();
	    return _this2;
	  }
	
	  _createClass(Syntax, [{
	    key: 'highlight',
	    value: function highlight() {
	      var _this3 = this;
	
	      if (this.quill.selection.composing) return;
	      this.quill.update(_quill2.default.sources.USER);
	      var range = this.quill.getSelection();
	      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
	        code.highlight(_this3.options.highlight);
	      });
	      this.quill.update(_quill2.default.sources.SILENT);
	      if (range != null) {
	        this.quill.setSelection(range, _quill2.default.sources.SILENT);
	      }
	    }
	  }]);
	
	  return Syntax;
	}(_module2.default);
	
	Syntax.DEFAULTS = {
	  highlight: function () {
	    if (window.hljs == null) return null;
	    return function (text) {
	      var result = window.hljs.highlightAuto(text);
	      return result.value;
	    };
	  }(),
	  interval: 1000
	};
	
	exports.CodeBlock = SyntaxCodeBlock;
	exports.CodeToken = CodeToken;
	exports.default = Syntax;
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BubbleTooltip = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];
	
	var BubbleTheme = function (_BaseTheme) {
	  _inherits(BubbleTheme, _BaseTheme);
	
	  function BubbleTheme(quill, options) {
	    _classCallCheck(this, BubbleTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-bubble');
	    return _this;
	  }
	
	  _createClass(BubbleTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
	      this.tooltip.root.appendChild(toolbar.container);
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	    }
	  }]);
	
	  return BubbleTheme;
	}(_base2.default);
	
	BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (!value) {
	            this.quill.format('link', false);
	          } else {
	            this.quill.theme.tooltip.edit();
	          }
	        }
	      }
	    }
	  }
	});
	
	var BubbleTooltip = function (_BaseTooltip) {
	  _inherits(BubbleTooltip, _BaseTooltip);
	
	  function BubbleTooltip(quill, bounds) {
	    _classCallCheck(this, BubbleTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
	
	    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
	      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
	      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
	        _this2.show();
	        // Lock our width so we will expand beyond our offsetParent boundaries
	        _this2.root.style.left = '0px';
	        _this2.root.style.width = '';
	        _this2.root.style.width = _this2.root.offsetWidth + 'px';
	        var lines = _this2.quill.getLines(range.index, range.length);
	        if (lines.length === 1) {
	          _this2.position(_this2.quill.getBounds(range));
	        } else {
	          var lastLine = lines[lines.length - 1];
	          var index = _this2.quill.getIndex(lastLine);
	          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
	          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
	          _this2.position(_bounds);
	        }
	      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
	        _this2.hide();
	      }
	    });
	    return _this2;
	  }
	
	  _createClass(BubbleTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('.ql-close').addEventListener('click', function () {
	        _this3.root.classList.remove('ql-editing');
	      });
	      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
	        // Let selection be restored by toolbar handlers before repositioning
	        setTimeout(function () {
	          if (_this3.root.classList.contains('ql-hidden')) return;
	          var range = _this3.quill.getSelection();
	          if (range != null) {
	            _this3.position(_this3.quill.getBounds(range));
	          }
	        }, 1);
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.show();
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
	      var arrow = this.root.querySelector('.ql-tooltip-arrow');
	      arrow.style.marginLeft = '';
	      if (shift === 0) return shift;
	      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
	    }
	  }]);
	
	  return BubbleTooltip;
	}(_base.BaseTooltip);
	
	BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');
	
	exports.BubbleTooltip = BubbleTooltip;
	exports.default = BubbleTheme;
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(63);
	
	
	/***/ })
	/******/ ])["default"];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var _inheritsLoose = _interopDefault(__webpack_require__(182));
	var _extends = _interopDefault(__webpack_require__(68));
	var redux = __webpack_require__(79);
	var reactRedux = __webpack_require__(90);
	var useMemoOne = __webpack_require__(1178);
	var cssBoxModel = __webpack_require__(713);
	var memoizeOne = _interopDefault(__webpack_require__(945));
	var rafSchd = _interopDefault(__webpack_require__(944));
	var ReactDOM = _interopDefault(__webpack_require__(55));
	
	var isProduction = ("production") === 'production';
	var spacesAndTabs = /[ \t]{2,}/g;
	var lineStartWithSpaces = /^[ \t]*/gm;
	
	var clean = function clean(value) {
	  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
	};
	
	var getDevMessage = function getDevMessage(message) {
	  return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
	};
	
	var getFormattedMessage = function getFormattedMessage(message) {
	  return [getDevMessage(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
	};
	var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
	function log(type, message) {
	  var _console;
	
	  if (isProduction) {
	    return;
	  }
	
	  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
	    return;
	  }
	
	  (_console = console)[type].apply(_console, getFormattedMessage(message));
	}
	var warning = log.bind(null, 'warn');
	var error = log.bind(null, 'error');
	
	function noop() {}
	
	function getOptions(shared, fromBinding) {
	  return _extends({}, shared, {}, fromBinding);
	}
	
	function bindEvents(el, bindings, sharedOptions) {
	  var unbindings = bindings.map(function (binding) {
	    var options = getOptions(sharedOptions, binding.options);
	    el.addEventListener(binding.eventName, binding.fn, options);
	    return function unbind() {
	      el.removeEventListener(binding.eventName, binding.fn, options);
	    };
	  });
	  return function unbindAll() {
	    unbindings.forEach(function (unbind) {
	      unbind();
	    });
	  };
	}
	
	var isProduction$1 = ("production") === 'production';
	var prefix = 'Invariant failed';
	function RbdInvariant(message) {
	  this.message = message;
	}
	
	RbdInvariant.prototype.toString = function toString() {
	  return this.message;
	};
	
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction$1) {
	    throw new RbdInvariant(prefix);
	  } else {
	    throw new RbdInvariant(prefix + ": " + (message || ''));
	  }
	}
	
	var ErrorBoundary = function (_React$Component) {
	  _inheritsLoose(ErrorBoundary, _React$Component);
	
	  function ErrorBoundary() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.callbacks = null;
	    _this.unbind = noop;
	
	    _this.onWindowError = function (event) {
	      var callbacks = _this.getCallbacks();
	
	      if (callbacks.isDragging()) {
	        callbacks.tryAbort();
	         false ? warning("\n        An error was caught by our window 'error' event listener while a drag was occurring.\n        The active drag has been aborted.\n      ") : void 0;
	      }
	
	      var err = event.error;
	
	      if (err instanceof RbdInvariant) {
	        event.preventDefault();
	
	        if (false) {
	          error(err.message);
	        }
	      }
	    };
	
	    _this.getCallbacks = function () {
	      if (!_this.callbacks) {
	        throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
	      }
	
	      return _this.callbacks;
	    };
	
	    _this.setCallbacks = function (callbacks) {
	      _this.callbacks = callbacks;
	    };
	
	    return _this;
	  }
	
	  var _proto = ErrorBoundary.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.unbind = bindEvents(window, [{
	      eventName: 'error',
	      fn: this.onWindowError
	    }]);
	  };
	
	  _proto.componentDidCatch = function componentDidCatch(err) {
	    if (err instanceof RbdInvariant) {
	      if (false) {
	        error(err.message);
	      }
	
	      this.setState({});
	      return;
	    }
	
	    throw err;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.unbind();
	  };
	
	  _proto.render = function render() {
	    return this.props.children(this.setCallbacks);
	  };
	
	  return ErrorBoundary;
	}(React__default.Component);
	
	var dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
	
	var position = function position(index) {
	  return index + 1;
	};
	
	var onDragStart = function onDragStart(start) {
	  return "\n  You have lifted an item in position " + position(start.source.index) + "\n";
	};
	
	var withLocation = function withLocation(source, destination) {
	  var isInHomeList = source.droppableId === destination.droppableId;
	  var startPosition = position(source.index);
	  var endPosition = position(destination.index);
	
	  if (isInHomeList) {
	    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
	  }
	
	  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
	};
	
	var withCombine = function withCombine(id, source, combine) {
	  var inHomeList = source.droppableId === combine.droppableId;
	
	  if (inHomeList) {
	    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
	  }
	
	  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
	};
	
	var onDragUpdate = function onDragUpdate(update) {
	  var location = update.destination;
	
	  if (location) {
	    return withLocation(update.source, location);
	  }
	
	  var combine = update.combine;
	
	  if (combine) {
	    return withCombine(update.draggableId, update.source, combine);
	  }
	
	  return 'You are over an area that cannot be dropped on';
	};
	
	var returnedToStart = function returnedToStart(source) {
	  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
	};
	
	var onDragEnd = function onDragEnd(result) {
	  if (result.reason === 'CANCEL') {
	    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
	  }
	
	  var location = result.destination;
	  var combine = result.combine;
	
	  if (location) {
	    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
	  }
	
	  if (combine) {
	    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
	  }
	
	  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
	};
	
	var preset = {
	  dragHandleUsageInstructions: dragHandleUsageInstructions,
	  onDragStart: onDragStart,
	  onDragUpdate: onDragUpdate,
	  onDragEnd: onDragEnd
	};
	
	var origin = {
	  x: 0,
	  y: 0
	};
	var add = function add(point1, point2) {
	  return {
	    x: point1.x + point2.x,
	    y: point1.y + point2.y
	  };
	};
	var subtract = function subtract(point1, point2) {
	  return {
	    x: point1.x - point2.x,
	    y: point1.y - point2.y
	  };
	};
	var isEqual = function isEqual(point1, point2) {
	  return point1.x === point2.x && point1.y === point2.y;
	};
	var negate = function negate(point) {
	  return {
	    x: point.x !== 0 ? -point.x : 0,
	    y: point.y !== 0 ? -point.y : 0
	  };
	};
	var patch = function patch(line, value, otherValue) {
	  var _ref;
	
	  if (otherValue === void 0) {
	    otherValue = 0;
	  }
	
	  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
	};
	var distance = function distance(point1, point2) {
	  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
	};
	var closest = function closest(target, points) {
	  return Math.min.apply(Math, points.map(function (point) {
	    return distance(target, point);
	  }));
	};
	var apply = function apply(fn) {
	  return function (point) {
	    return {
	      x: fn(point.x),
	      y: fn(point.y)
	    };
	  };
	};
	
	var executeClip = (function (frame, subject) {
	  var result = cssBoxModel.getRect({
	    top: Math.max(subject.top, frame.top),
	    right: Math.min(subject.right, frame.right),
	    bottom: Math.min(subject.bottom, frame.bottom),
	    left: Math.max(subject.left, frame.left)
	  });
	
	  if (result.width <= 0 || result.height <= 0) {
	    return null;
	  }
	
	  return result;
	});
	
	var offsetByPosition = function offsetByPosition(spacing, point) {
	  return {
	    top: spacing.top + point.y,
	    left: spacing.left + point.x,
	    bottom: spacing.bottom + point.y,
	    right: spacing.right + point.x
	  };
	};
	var getCorners = function getCorners(spacing) {
	  return [{
	    x: spacing.left,
	    y: spacing.top
	  }, {
	    x: spacing.right,
	    y: spacing.top
	  }, {
	    x: spacing.left,
	    y: spacing.bottom
	  }, {
	    x: spacing.right,
	    y: spacing.bottom
	  }];
	};
	var noSpacing = {
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	};
	
	var scroll = function scroll(target, frame) {
	  if (!frame) {
	    return target;
	  }
	
	  return offsetByPosition(target, frame.scroll.diff.displacement);
	};
	
	var increase = function increase(target, axis, withPlaceholder) {
	  if (withPlaceholder && withPlaceholder.increasedBy) {
	    var _extends2;
	
	    return _extends({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
	  }
	
	  return target;
	};
	
	var clip = function clip(target, frame) {
	  if (frame && frame.shouldClipSubject) {
	    return executeClip(frame.pageMarginBox, target);
	  }
	
	  return cssBoxModel.getRect(target);
	};
	
	var getSubject = (function (_ref) {
	  var page = _ref.page,
	      withPlaceholder = _ref.withPlaceholder,
	      axis = _ref.axis,
	      frame = _ref.frame;
	  var scrolled = scroll(page.marginBox, frame);
	  var increased = increase(scrolled, axis, withPlaceholder);
	  var clipped = clip(increased, frame);
	  return {
	    page: page,
	    withPlaceholder: withPlaceholder,
	    active: clipped
	  };
	});
	
	var scrollDroppable = (function (droppable, newScroll) {
	  !droppable.frame ?  false ? invariant(false) : invariant(false) : void 0;
	  var scrollable = droppable.frame;
	  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
	  var scrollDisplacement = negate(scrollDiff);
	
	  var frame = _extends({}, scrollable, {
	    scroll: {
	      initial: scrollable.scroll.initial,
	      current: newScroll,
	      diff: {
	        value: scrollDiff,
	        displacement: scrollDisplacement
	      },
	      max: scrollable.scroll.max
	    }
	  });
	
	  var subject = getSubject({
	    page: droppable.subject.page,
	    withPlaceholder: droppable.subject.withPlaceholder,
	    axis: droppable.axis,
	    frame: frame
	  });
	
	  var result = _extends({}, droppable, {
	    frame: frame,
	    subject: subject
	  });
	
	  return result;
	});
	
	function isInteger(value) {
	  if (Number.isInteger) {
	    return Number.isInteger(value);
	  }
	
	  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	}
	function values(map) {
	  if (Object.values) {
	    return Object.values(map);
	  }
	
	  return Object.keys(map).map(function (key) {
	    return map[key];
	  });
	}
	function findIndex(list, predicate) {
	  if (list.findIndex) {
	    return list.findIndex(predicate);
	  }
	
	  for (var i = 0; i < list.length; i++) {
	    if (predicate(list[i])) {
	      return i;
	    }
	  }
	
	  return -1;
	}
	function find(list, predicate) {
	  if (list.find) {
	    return list.find(predicate);
	  }
	
	  var index = findIndex(list, predicate);
	
	  if (index !== -1) {
	    return list[index];
	  }
	
	  return undefined;
	}
	function toArray(list) {
	  return Array.prototype.slice.call(list);
	}
	
	var toDroppableMap = memoizeOne(function (droppables) {
	  return droppables.reduce(function (previous, current) {
	    previous[current.descriptor.id] = current;
	    return previous;
	  }, {});
	});
	var toDraggableMap = memoizeOne(function (draggables) {
	  return draggables.reduce(function (previous, current) {
	    previous[current.descriptor.id] = current;
	    return previous;
	  }, {});
	});
	var toDroppableList = memoizeOne(function (droppables) {
	  return values(droppables);
	});
	var toDraggableList = memoizeOne(function (draggables) {
	  return values(draggables);
	});
	
	var getDraggablesInsideDroppable = memoizeOne(function (droppableId, draggables) {
	  var result = toDraggableList(draggables).filter(function (draggable) {
	    return droppableId === draggable.descriptor.droppableId;
	  }).sort(function (a, b) {
	    return a.descriptor.index - b.descriptor.index;
	  });
	  return result;
	});
	
	function tryGetDestination(impact) {
	  if (impact.at && impact.at.type === 'REORDER') {
	    return impact.at.destination;
	  }
	
	  return null;
	}
	function tryGetCombine(impact) {
	  if (impact.at && impact.at.type === 'COMBINE') {
	    return impact.at.combine;
	  }
	
	  return null;
	}
	
	var removeDraggableFromList = memoizeOne(function (remove, list) {
	  return list.filter(function (item) {
	    return item.descriptor.id !== remove.descriptor.id;
	  });
	});
	
	var moveToNextCombine = (function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      draggable = _ref.draggable,
	      destination = _ref.destination,
	      insideDestination = _ref.insideDestination,
	      previousImpact = _ref.previousImpact;
	
	  if (!destination.isCombineEnabled) {
	    return null;
	  }
	
	  var location = tryGetDestination(previousImpact);
	
	  if (!location) {
	    return null;
	  }
	
	  function getImpact(target) {
	    var at = {
	      type: 'COMBINE',
	      combine: {
	        draggableId: target,
	        droppableId: destination.descriptor.id
	      }
	    };
	    return _extends({}, previousImpact, {
	      at: at
	    });
	  }
	
	  var all = previousImpact.displaced.all;
	  var closestId = all.length ? all[0] : null;
	
	  if (isMovingForward) {
	    return closestId ? getImpact(closestId) : null;
	  }
	
	  var withoutDraggable = removeDraggableFromList(draggable, insideDestination);
	
	  if (!closestId) {
	    if (!withoutDraggable.length) {
	      return null;
	    }
	
	    var last = withoutDraggable[withoutDraggable.length - 1];
	    return getImpact(last.descriptor.id);
	  }
	
	  var indexOfClosest = findIndex(withoutDraggable, function (d) {
	    return d.descriptor.id === closestId;
	  });
	  !(indexOfClosest !== -1) ?  false ? invariant(false, 'Could not find displaced item in set') : invariant(false) : void 0;
	  var proposedIndex = indexOfClosest - 1;
	
	  if (proposedIndex < 0) {
	    return null;
	  }
	
	  var before = withoutDraggable[proposedIndex];
	  return getImpact(before.descriptor.id);
	});
	
	var isHomeOf = (function (draggable, destination) {
	  return draggable.descriptor.droppableId === destination.descriptor.id;
	});
	
	var noDisplacedBy = {
	  point: origin,
	  value: 0
	};
	var emptyGroups = {
	  invisible: {},
	  visible: {},
	  all: []
	};
	var noImpact = {
	  displaced: emptyGroups,
	  displacedBy: noDisplacedBy,
	  at: null
	};
	
	var isWithin = (function (lowerBound, upperBound) {
	  return function (value) {
	    return lowerBound <= value && value <= upperBound;
	  };
	});
	
	var isPartiallyVisibleThroughFrame = (function (frame) {
	  var isWithinVertical = isWithin(frame.top, frame.bottom);
	  var isWithinHorizontal = isWithin(frame.left, frame.right);
	  return function (subject) {
	    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
	
	    if (isContained) {
	      return true;
	    }
	
	    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
	    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
	    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
	
	    if (isPartiallyContained) {
	      return true;
	    }
	
	    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
	    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
	    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
	
	    if (isTargetBiggerThanFrame) {
	      return true;
	    }
	
	    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
	    return isTargetBiggerOnOneAxis;
	  };
	});
	
	var isTotallyVisibleThroughFrame = (function (frame) {
	  var isWithinVertical = isWithin(frame.top, frame.bottom);
	  var isWithinHorizontal = isWithin(frame.left, frame.right);
	  return function (subject) {
	    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
	    return isContained;
	  };
	});
	
	var vertical = {
	  direction: 'vertical',
	  line: 'y',
	  crossAxisLine: 'x',
	  start: 'top',
	  end: 'bottom',
	  size: 'height',
	  crossAxisStart: 'left',
	  crossAxisEnd: 'right',
	  crossAxisSize: 'width'
	};
	var horizontal = {
	  direction: 'horizontal',
	  line: 'x',
	  crossAxisLine: 'y',
	  start: 'left',
	  end: 'right',
	  size: 'width',
	  crossAxisStart: 'top',
	  crossAxisEnd: 'bottom',
	  crossAxisSize: 'height'
	};
	
	var isTotallyVisibleThroughFrameOnAxis = (function (axis) {
	  return function (frame) {
	    var isWithinVertical = isWithin(frame.top, frame.bottom);
	    var isWithinHorizontal = isWithin(frame.left, frame.right);
	    return function (subject) {
	      if (axis === vertical) {
	        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
	      }
	
	      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
	    };
	  };
	});
	
	var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
	  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
	  return offsetByPosition(target, displacement);
	};
	
	var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
	  if (!destination.subject.active) {
	    return false;
	  }
	
	  return isVisibleThroughFrameFn(destination.subject.active)(target);
	};
	
	var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
	  return isVisibleThroughFrameFn(viewport)(target);
	};
	
	var isVisible = function isVisible(_ref) {
	  var toBeDisplaced = _ref.target,
	      destination = _ref.destination,
	      viewport = _ref.viewport,
	      withDroppableDisplacement = _ref.withDroppableDisplacement,
	      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
	  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
	  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
	};
	
	var isPartiallyVisible = function isPartiallyVisible(args) {
	  return isVisible(_extends({}, args, {
	    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
	  }));
	};
	var isTotallyVisible = function isTotallyVisible(args) {
	  return isVisible(_extends({}, args, {
	    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
	  }));
	};
	var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
	  return isVisible(_extends({}, args, {
	    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
	  }));
	};
	
	var getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
	  if (typeof forceShouldAnimate === 'boolean') {
	    return forceShouldAnimate;
	  }
	
	  if (!last) {
	    return true;
	  }
	
	  var invisible = last.invisible,
	      visible = last.visible;
	
	  if (invisible[id]) {
	    return false;
	  }
	
	  var previous = visible[id];
	  return previous ? previous.shouldAnimate : true;
	};
	
	function getTarget(draggable, displacedBy) {
	  var marginBox = draggable.page.marginBox;
	  var expandBy = {
	    top: displacedBy.point.y,
	    right: 0,
	    bottom: 0,
	    left: displacedBy.point.x
	  };
	  return cssBoxModel.getRect(cssBoxModel.expand(marginBox, expandBy));
	}
	
	function getDisplacementGroups(_ref) {
	  var afterDragging = _ref.afterDragging,
	      destination = _ref.destination,
	      displacedBy = _ref.displacedBy,
	      viewport = _ref.viewport,
	      forceShouldAnimate = _ref.forceShouldAnimate,
	      last = _ref.last;
	  return afterDragging.reduce(function process(groups, draggable) {
	    var target = getTarget(draggable, displacedBy);
	    var id = draggable.descriptor.id;
	    groups.all.push(id);
	    var isVisible = isPartiallyVisible({
	      target: target,
	      destination: destination,
	      viewport: viewport,
	      withDroppableDisplacement: true
	    });
	
	    if (!isVisible) {
	      groups.invisible[draggable.descriptor.id] = true;
	      return groups;
	    }
	
	    var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
	    var displacement = {
	      draggableId: id,
	      shouldAnimate: shouldAnimate
	    };
	    groups.visible[id] = displacement;
	    return groups;
	  }, {
	    all: [],
	    visible: {},
	    invisible: {}
	  });
	}
	
	function getIndexOfLastItem(draggables, options) {
	  if (!draggables.length) {
	    return 0;
	  }
	
	  var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
	  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
	}
	
	function goAtEnd(_ref) {
	  var insideDestination = _ref.insideDestination,
	      inHomeList = _ref.inHomeList,
	      displacedBy = _ref.displacedBy,
	      destination = _ref.destination;
	  var newIndex = getIndexOfLastItem(insideDestination, {
	    inHomeList: inHomeList
	  });
	  return {
	    displaced: emptyGroups,
	    displacedBy: displacedBy,
	    at: {
	      type: 'REORDER',
	      destination: {
	        droppableId: destination.descriptor.id,
	        index: newIndex
	      }
	    }
	  };
	}
	
	function calculateReorderImpact(_ref2) {
	  var draggable = _ref2.draggable,
	      insideDestination = _ref2.insideDestination,
	      destination = _ref2.destination,
	      viewport = _ref2.viewport,
	      displacedBy = _ref2.displacedBy,
	      last = _ref2.last,
	      index = _ref2.index,
	      forceShouldAnimate = _ref2.forceShouldAnimate;
	  var inHomeList = isHomeOf(draggable, destination);
	
	  if (index == null) {
	    return goAtEnd({
	      insideDestination: insideDestination,
	      inHomeList: inHomeList,
	      displacedBy: displacedBy,
	      destination: destination
	    });
	  }
	
	  var match = find(insideDestination, function (item) {
	    return item.descriptor.index === index;
	  });
	
	  if (!match) {
	    return goAtEnd({
	      insideDestination: insideDestination,
	      inHomeList: inHomeList,
	      displacedBy: displacedBy,
	      destination: destination
	    });
	  }
	
	  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
	  var sliceFrom = insideDestination.indexOf(match);
	  var impacted = withoutDragging.slice(sliceFrom);
	  var displaced = getDisplacementGroups({
	    afterDragging: impacted,
	    destination: destination,
	    displacedBy: displacedBy,
	    last: last,
	    viewport: viewport.frame,
	    forceShouldAnimate: forceShouldAnimate
	  });
	  return {
	    displaced: displaced,
	    displacedBy: displacedBy,
	    at: {
	      type: 'REORDER',
	      destination: {
	        droppableId: destination.descriptor.id,
	        index: index
	      }
	    }
	  };
	}
	
	function didStartAfterCritical(draggableId, afterCritical) {
	  return Boolean(afterCritical.effected[draggableId]);
	}
	
	var fromCombine = (function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      destination = _ref.destination,
	      draggables = _ref.draggables,
	      combine = _ref.combine,
	      afterCritical = _ref.afterCritical;
	
	  if (!destination.isCombineEnabled) {
	    return null;
	  }
	
	  var combineId = combine.draggableId;
	  var combineWith = draggables[combineId];
	  var combineWithIndex = combineWith.descriptor.index;
	  var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);
	
	  if (didCombineWithStartAfterCritical) {
	    if (isMovingForward) {
	      return combineWithIndex;
	    }
	
	    return combineWithIndex - 1;
	  }
	
	  if (isMovingForward) {
	    return combineWithIndex + 1;
	  }
	
	  return combineWithIndex;
	});
	
	var fromReorder = (function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      isInHomeList = _ref.isInHomeList,
	      insideDestination = _ref.insideDestination,
	      location = _ref.location;
	
	  if (!insideDestination.length) {
	    return null;
	  }
	
	  var currentIndex = location.index;
	  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
	  var firstIndex = insideDestination[0].descriptor.index;
	  var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
	  var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
	
	  if (proposedIndex < firstIndex) {
	    return null;
	  }
	
	  if (proposedIndex > upperBound) {
	    return null;
	  }
	
	  return proposedIndex;
	});
	
	var moveToNextIndex = (function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      isInHomeList = _ref.isInHomeList,
	      draggable = _ref.draggable,
	      draggables = _ref.draggables,
	      destination = _ref.destination,
	      insideDestination = _ref.insideDestination,
	      previousImpact = _ref.previousImpact,
	      viewport = _ref.viewport,
	      afterCritical = _ref.afterCritical;
	  var wasAt = previousImpact.at;
	  !wasAt ?  false ? invariant(false, 'Cannot move in direction without previous impact location') : invariant(false) : void 0;
	
	  if (wasAt.type === 'REORDER') {
	    var _newIndex = fromReorder({
	      isMovingForward: isMovingForward,
	      isInHomeList: isInHomeList,
	      location: wasAt.destination,
	      insideDestination: insideDestination
	    });
	
	    if (_newIndex == null) {
	      return null;
	    }
	
	    return calculateReorderImpact({
	      draggable: draggable,
	      insideDestination: insideDestination,
	      destination: destination,
	      viewport: viewport,
	      last: previousImpact.displaced,
	      displacedBy: previousImpact.displacedBy,
	      index: _newIndex
	    });
	  }
	
	  var newIndex = fromCombine({
	    isMovingForward: isMovingForward,
	    destination: destination,
	    displaced: previousImpact.displaced,
	    draggables: draggables,
	    combine: wasAt.combine,
	    afterCritical: afterCritical
	  });
	
	  if (newIndex == null) {
	    return null;
	  }
	
	  return calculateReorderImpact({
	    draggable: draggable,
	    insideDestination: insideDestination,
	    destination: destination,
	    viewport: viewport,
	    last: previousImpact.displaced,
	    displacedBy: previousImpact.displacedBy,
	    index: newIndex
	  });
	});
	
	var getCombinedItemDisplacement = (function (_ref) {
	  var displaced = _ref.displaced,
	      afterCritical = _ref.afterCritical,
	      combineWith = _ref.combineWith,
	      displacedBy = _ref.displacedBy;
	  var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
	
	  if (didStartAfterCritical(combineWith, afterCritical)) {
	    return isDisplaced ? origin : negate(displacedBy.point);
	  }
	
	  return isDisplaced ? displacedBy.point : origin;
	});
	
	var whenCombining = (function (_ref) {
	  var afterCritical = _ref.afterCritical,
	      impact = _ref.impact,
	      draggables = _ref.draggables;
	  var combine = tryGetCombine(impact);
	  !combine ?  false ? invariant(false) : invariant(false) : void 0;
	  var combineWith = combine.draggableId;
	  var center = draggables[combineWith].page.borderBox.center;
	  var displaceBy = getCombinedItemDisplacement({
	    displaced: impact.displaced,
	    afterCritical: afterCritical,
	    combineWith: combineWith,
	    displacedBy: impact.displacedBy
	  });
	  return add(center, displaceBy);
	});
	
	var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
	  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
	};
	
	var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
	  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
	};
	
	var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
	  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
	};
	
	var goAfter = function goAfter(_ref) {
	  var axis = _ref.axis,
	      moveRelativeTo = _ref.moveRelativeTo,
	      isMoving = _ref.isMoving;
	  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
	};
	var goBefore = function goBefore(_ref2) {
	  var axis = _ref2.axis,
	      moveRelativeTo = _ref2.moveRelativeTo,
	      isMoving = _ref2.isMoving;
	  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
	};
	var goIntoStart = function goIntoStart(_ref3) {
	  var axis = _ref3.axis,
	      moveInto = _ref3.moveInto,
	      isMoving = _ref3.isMoving;
	  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
	};
	
	var whenReordering = (function (_ref) {
	  var impact = _ref.impact,
	      draggable = _ref.draggable,
	      draggables = _ref.draggables,
	      droppable = _ref.droppable,
	      afterCritical = _ref.afterCritical;
	  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
	  var draggablePage = draggable.page;
	  var axis = droppable.axis;
	
	  if (!insideDestination.length) {
	    return goIntoStart({
	      axis: axis,
	      moveInto: droppable.page,
	      isMoving: draggablePage
	    });
	  }
	
	  var displaced = impact.displaced,
	      displacedBy = impact.displacedBy;
	  var closestAfter = displaced.all[0];
	
	  if (closestAfter) {
	    var closest = draggables[closestAfter];
	
	    if (didStartAfterCritical(closestAfter, afterCritical)) {
	      return goBefore({
	        axis: axis,
	        moveRelativeTo: closest.page,
	        isMoving: draggablePage
	      });
	    }
	
	    var withDisplacement = cssBoxModel.offset(closest.page, displacedBy.point);
	    return goBefore({
	      axis: axis,
	      moveRelativeTo: withDisplacement,
	      isMoving: draggablePage
	    });
	  }
	
	  var last = insideDestination[insideDestination.length - 1];
	
	  if (last.descriptor.id === draggable.descriptor.id) {
	    return draggablePage.borderBox.center;
	  }
	
	  if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
	    var page = cssBoxModel.offset(last.page, negate(afterCritical.displacedBy.point));
	    return goAfter({
	      axis: axis,
	      moveRelativeTo: page,
	      isMoving: draggablePage
	    });
	  }
	
	  return goAfter({
	    axis: axis,
	    moveRelativeTo: last.page,
	    isMoving: draggablePage
	  });
	});
	
	var withDroppableDisplacement = (function (droppable, point) {
	  var frame = droppable.frame;
	
	  if (!frame) {
	    return point;
	  }
	
	  return add(point, frame.scroll.diff.displacement);
	});
	
	var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
	  var impact = _ref.impact,
	      draggable = _ref.draggable,
	      droppable = _ref.droppable,
	      draggables = _ref.draggables,
	      afterCritical = _ref.afterCritical;
	  var original = draggable.page.borderBox.center;
	  var at = impact.at;
	
	  if (!droppable) {
	    return original;
	  }
	
	  if (!at) {
	    return original;
	  }
	
	  if (at.type === 'REORDER') {
	    return whenReordering({
	      impact: impact,
	      draggable: draggable,
	      draggables: draggables,
	      droppable: droppable,
	      afterCritical: afterCritical
	    });
	  }
	
	  return whenCombining({
	    impact: impact,
	    draggables: draggables,
	    afterCritical: afterCritical
	  });
	};
	
	var getPageBorderBoxCenterFromImpact = (function (args) {
	  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
	  var droppable = args.droppable;
	  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
	  return withDisplacement;
	});
	
	var scrollViewport = (function (viewport, newScroll) {
	  var diff = subtract(newScroll, viewport.scroll.initial);
	  var displacement = negate(diff);
	  var frame = cssBoxModel.getRect({
	    top: newScroll.y,
	    bottom: newScroll.y + viewport.frame.height,
	    left: newScroll.x,
	    right: newScroll.x + viewport.frame.width
	  });
	  var updated = {
	    frame: frame,
	    scroll: {
	      initial: viewport.scroll.initial,
	      max: viewport.scroll.max,
	      current: newScroll,
	      diff: {
	        value: diff,
	        displacement: displacement
	      }
	    }
	  };
	  return updated;
	});
	
	function getDraggables(ids, draggables) {
	  return ids.map(function (id) {
	    return draggables[id];
	  });
	}
	
	function tryGetVisible(id, groups) {
	  for (var i = 0; i < groups.length; i++) {
	    var displacement = groups[i].visible[id];
	
	    if (displacement) {
	      return displacement;
	    }
	  }
	
	  return null;
	}
	
	var speculativelyIncrease = (function (_ref) {
	  var impact = _ref.impact,
	      viewport = _ref.viewport,
	      destination = _ref.destination,
	      draggables = _ref.draggables,
	      maxScrollChange = _ref.maxScrollChange;
	  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
	  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
	  var last = impact.displaced;
	  var withViewportScroll = getDisplacementGroups({
	    afterDragging: getDraggables(last.all, draggables),
	    destination: destination,
	    displacedBy: impact.displacedBy,
	    viewport: scrolledViewport.frame,
	    last: last,
	    forceShouldAnimate: false
	  });
	  var withDroppableScroll = getDisplacementGroups({
	    afterDragging: getDraggables(last.all, draggables),
	    destination: scrolledDroppable,
	    displacedBy: impact.displacedBy,
	    viewport: viewport.frame,
	    last: last,
	    forceShouldAnimate: false
	  });
	  var invisible = {};
	  var visible = {};
	  var groups = [last, withViewportScroll, withDroppableScroll];
	  last.all.forEach(function (id) {
	    var displacement = tryGetVisible(id, groups);
	
	    if (displacement) {
	      visible[id] = displacement;
	      return;
	    }
	
	    invisible[id] = true;
	  });
	
	  var newImpact = _extends({}, impact, {
	    displaced: {
	      all: last.all,
	      invisible: invisible,
	      visible: visible
	    }
	  });
	
	  return newImpact;
	});
	
	var withViewportDisplacement = (function (viewport, point) {
	  return add(viewport.scroll.diff.displacement, point);
	});
	
	var getClientFromPageBorderBoxCenter = (function (_ref) {
	  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
	      draggable = _ref.draggable,
	      viewport = _ref.viewport;
	  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
	  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
	  return add(draggable.client.borderBox.center, offset);
	});
	
	var isTotallyVisibleInNewLocation = (function (_ref) {
	  var draggable = _ref.draggable,
	      destination = _ref.destination,
	      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
	      viewport = _ref.viewport,
	      withDroppableDisplacement = _ref.withDroppableDisplacement,
	      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
	      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
	  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
	  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
	  var args = {
	    target: shifted,
	    destination: destination,
	    withDroppableDisplacement: withDroppableDisplacement,
	    viewport: viewport
	  };
	  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
	});
	
	var moveToNextPlace = (function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      draggable = _ref.draggable,
	      destination = _ref.destination,
	      draggables = _ref.draggables,
	      previousImpact = _ref.previousImpact,
	      viewport = _ref.viewport,
	      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
	      previousClientSelection = _ref.previousClientSelection,
	      afterCritical = _ref.afterCritical;
	
	  if (!destination.isEnabled) {
	    return null;
	  }
	
	  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
	  var isInHomeList = isHomeOf(draggable, destination);
	  var impact = moveToNextCombine({
	    isMovingForward: isMovingForward,
	    draggable: draggable,
	    destination: destination,
	    insideDestination: insideDestination,
	    previousImpact: previousImpact
	  }) || moveToNextIndex({
	    isMovingForward: isMovingForward,
	    isInHomeList: isInHomeList,
	    draggable: draggable,
	    draggables: draggables,
	    destination: destination,
	    insideDestination: insideDestination,
	    previousImpact: previousImpact,
	    viewport: viewport,
	    afterCritical: afterCritical
	  });
	
	  if (!impact) {
	    return null;
	  }
	
	  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
	    impact: impact,
	    draggable: draggable,
	    droppable: destination,
	    draggables: draggables,
	    afterCritical: afterCritical
	  });
	  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
	    draggable: draggable,
	    destination: destination,
	    newPageBorderBoxCenter: pageBorderBoxCenter,
	    viewport: viewport.frame,
	    withDroppableDisplacement: false,
	    onlyOnMainAxis: true
	  });
	
	  if (isVisibleInNewLocation) {
	    var clientSelection = getClientFromPageBorderBoxCenter({
	      pageBorderBoxCenter: pageBorderBoxCenter,
	      draggable: draggable,
	      viewport: viewport
	    });
	    return {
	      clientSelection: clientSelection,
	      impact: impact,
	      scrollJumpRequest: null
	    };
	  }
	
	  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
	  var cautious = speculativelyIncrease({
	    impact: impact,
	    viewport: viewport,
	    destination: destination,
	    draggables: draggables,
	    maxScrollChange: distance
	  });
	  return {
	    clientSelection: previousClientSelection,
	    impact: cautious,
	    scrollJumpRequest: distance
	  };
	});
	
	var getKnownActive = function getKnownActive(droppable) {
	  var rect = droppable.subject.active;
	  !rect ?  false ? invariant(false, 'Cannot get clipped area from droppable') : invariant(false) : void 0;
	  return rect;
	};
	
	var getBestCrossAxisDroppable = (function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
	      source = _ref.source,
	      droppables = _ref.droppables,
	      viewport = _ref.viewport;
	  var active = source.subject.active;
	
	  if (!active) {
	    return null;
	  }
	
	  var axis = source.axis;
	  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
	  var candidates = toDroppableList(droppables).filter(function (droppable) {
	    return droppable !== source;
	  }).filter(function (droppable) {
	    return droppable.isEnabled;
	  }).filter(function (droppable) {
	    return Boolean(droppable.subject.active);
	  }).filter(function (droppable) {
	    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
	  }).filter(function (droppable) {
	    var activeOfTarget = getKnownActive(droppable);
	
	    if (isMovingForward) {
	      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
	    }
	
	    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
	  }).filter(function (droppable) {
	    var activeOfTarget = getKnownActive(droppable);
	    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
	    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
	  }).sort(function (a, b) {
	    var first = getKnownActive(a)[axis.crossAxisStart];
	    var second = getKnownActive(b)[axis.crossAxisStart];
	
	    if (isMovingForward) {
	      return first - second;
	    }
	
	    return second - first;
	  }).filter(function (droppable, index, array) {
	    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
	  });
	
	  if (!candidates.length) {
	    return null;
	  }
	
	  if (candidates.length === 1) {
	    return candidates[0];
	  }
	
	  var contains = candidates.filter(function (droppable) {
	    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
	    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
	  });
	
	  if (contains.length === 1) {
	    return contains[0];
	  }
	
	  if (contains.length > 1) {
	    return contains.sort(function (a, b) {
	      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
	    })[0];
	  }
	
	  return candidates.sort(function (a, b) {
	    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
	    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));
	
	    if (first !== second) {
	      return first - second;
	    }
	
	    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
	  })[0];
	});
	
	var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
	  var original = draggable.page.borderBox.center;
	  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
	};
	var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
	  var original = draggable.page.borderBox;
	  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
	};
	
	var getClosestDraggable = (function (_ref) {
	  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
	      viewport = _ref.viewport,
	      destination = _ref.destination,
	      insideDestination = _ref.insideDestination,
	      afterCritical = _ref.afterCritical;
	  var sorted = insideDestination.filter(function (draggable) {
	    return isTotallyVisible({
	      target: getCurrentPageBorderBox(draggable, afterCritical),
	      destination: destination,
	      viewport: viewport.frame,
	      withDroppableDisplacement: true
	    });
	  }).sort(function (a, b) {
	    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
	    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));
	
	    if (distanceToA < distanceToB) {
	      return -1;
	    }
	
	    if (distanceToB < distanceToA) {
	      return 1;
	    }
	
	    return a.descriptor.index - b.descriptor.index;
	  });
	  return sorted[0] || null;
	});
	
	var getDisplacedBy = memoizeOne(function getDisplacedBy(axis, displaceBy) {
	  var displacement = displaceBy[axis.line];
	  return {
	    value: displacement,
	    point: patch(axis.line, displacement)
	  };
	});
	
	var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
	  var axis = droppable.axis;
	
	  if (droppable.descriptor.mode === 'virtual') {
	    return patch(axis.line, placeholderSize[axis.line]);
	  }
	
	  var availableSpace = droppable.subject.page.contentBox[axis.size];
	  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
	  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
	    return sum + dimension.client.marginBox[axis.size];
	  }, 0);
	  var requiredSpace = spaceUsed + placeholderSize[axis.line];
	  var needsToGrowBy = requiredSpace - availableSpace;
	
	  if (needsToGrowBy <= 0) {
	    return null;
	  }
	
	  return patch(axis.line, needsToGrowBy);
	};
	
	var withMaxScroll = function withMaxScroll(frame, max) {
	  return _extends({}, frame, {
	    scroll: _extends({}, frame.scroll, {
	      max: max
	    })
	  });
	};
	
	var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
	  var frame = droppable.frame;
	  !!isHomeOf(draggable, droppable) ?  false ? invariant(false, 'Should not add placeholder space to home list') : invariant(false) : void 0;
	  !!droppable.subject.withPlaceholder ?  false ? invariant(false, 'Cannot add placeholder size to a subject when it already has one') : invariant(false) : void 0;
	  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
	  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
	  var added = {
	    placeholderSize: placeholderSize,
	    increasedBy: requiredGrowth,
	    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
	  };
	
	  if (!frame) {
	    var _subject = getSubject({
	      page: droppable.subject.page,
	      withPlaceholder: added,
	      axis: droppable.axis,
	      frame: droppable.frame
	    });
	
	    return _extends({}, droppable, {
	      subject: _subject
	    });
	  }
	
	  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
	  var newFrame = withMaxScroll(frame, maxScroll);
	  var subject = getSubject({
	    page: droppable.subject.page,
	    withPlaceholder: added,
	    axis: droppable.axis,
	    frame: newFrame
	  });
	  return _extends({}, droppable, {
	    subject: subject,
	    frame: newFrame
	  });
	};
	var removePlaceholder = function removePlaceholder(droppable) {
	  var added = droppable.subject.withPlaceholder;
	  !added ?  false ? invariant(false, 'Cannot remove placeholder form subject when there was none') : invariant(false) : void 0;
	  var frame = droppable.frame;
	
	  if (!frame) {
	    var _subject2 = getSubject({
	      page: droppable.subject.page,
	      axis: droppable.axis,
	      frame: null,
	      withPlaceholder: null
	    });
	
	    return _extends({}, droppable, {
	      subject: _subject2
	    });
	  }
	
	  var oldMaxScroll = added.oldFrameMaxScroll;
	  !oldMaxScroll ?  false ? invariant(false, 'Expected droppable with frame to have old max frame scroll when removing placeholder') : invariant(false) : void 0;
	  var newFrame = withMaxScroll(frame, oldMaxScroll);
	  var subject = getSubject({
	    page: droppable.subject.page,
	    axis: droppable.axis,
	    frame: newFrame,
	    withPlaceholder: null
	  });
	  return _extends({}, droppable, {
	    subject: subject,
	    frame: newFrame
	  });
	};
	
	var moveToNewDroppable = (function (_ref) {
	  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
	      moveRelativeTo = _ref.moveRelativeTo,
	      insideDestination = _ref.insideDestination,
	      draggable = _ref.draggable,
	      draggables = _ref.draggables,
	      destination = _ref.destination,
	      viewport = _ref.viewport,
	      afterCritical = _ref.afterCritical;
	
	  if (!moveRelativeTo) {
	    if (insideDestination.length) {
	      return null;
	    }
	
	    var proposed = {
	      displaced: emptyGroups,
	      displacedBy: noDisplacedBy,
	      at: {
	        type: 'REORDER',
	        destination: {
	          droppableId: destination.descriptor.id,
	          index: 0
	        }
	      }
	    };
	    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
	      impact: proposed,
	      draggable: draggable,
	      droppable: destination,
	      draggables: draggables,
	      afterCritical: afterCritical
	    });
	    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
	    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
	      draggable: draggable,
	      destination: withPlaceholder,
	      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
	      viewport: viewport.frame,
	      withDroppableDisplacement: false,
	      onlyOnMainAxis: true
	    });
	    return isVisibleInNewLocation ? proposed : null;
	  }
	
	  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
	
	  var proposedIndex = function () {
	    var relativeTo = moveRelativeTo.descriptor.index;
	
	    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
	      return relativeTo;
	    }
	
	    if (isGoingBeforeTarget) {
	      return relativeTo;
	    }
	
	    return relativeTo + 1;
	  }();
	
	  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
	  return calculateReorderImpact({
	    draggable: draggable,
	    insideDestination: insideDestination,
	    destination: destination,
	    viewport: viewport,
	    displacedBy: displacedBy,
	    last: emptyGroups,
	    index: proposedIndex
	  });
	});
	
	var moveCrossAxis = (function (_ref) {
	  var isMovingForward = _ref.isMovingForward,
	      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
	      draggable = _ref.draggable,
	      isOver = _ref.isOver,
	      draggables = _ref.draggables,
	      droppables = _ref.droppables,
	      viewport = _ref.viewport,
	      afterCritical = _ref.afterCritical;
	  var destination = getBestCrossAxisDroppable({
	    isMovingForward: isMovingForward,
	    pageBorderBoxCenter: previousPageBorderBoxCenter,
	    source: isOver,
	    droppables: droppables,
	    viewport: viewport
	  });
	
	  if (!destination) {
	    return null;
	  }
	
	  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
	  var moveRelativeTo = getClosestDraggable({
	    pageBorderBoxCenter: previousPageBorderBoxCenter,
	    viewport: viewport,
	    destination: destination,
	    insideDestination: insideDestination,
	    afterCritical: afterCritical
	  });
	  var impact = moveToNewDroppable({
	    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
	    destination: destination,
	    draggable: draggable,
	    draggables: draggables,
	    moveRelativeTo: moveRelativeTo,
	    insideDestination: insideDestination,
	    viewport: viewport,
	    afterCritical: afterCritical
	  });
	
	  if (!impact) {
	    return null;
	  }
	
	  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
	    impact: impact,
	    draggable: draggable,
	    droppable: destination,
	    draggables: draggables,
	    afterCritical: afterCritical
	  });
	  var clientSelection = getClientFromPageBorderBoxCenter({
	    pageBorderBoxCenter: pageBorderBoxCenter,
	    draggable: draggable,
	    viewport: viewport
	  });
	  return {
	    clientSelection: clientSelection,
	    impact: impact,
	    scrollJumpRequest: null
	  };
	});
	
	var whatIsDraggedOver = (function (impact) {
	  var at = impact.at;
	
	  if (!at) {
	    return null;
	  }
	
	  if (at.type === 'REORDER') {
	    return at.destination.droppableId;
	  }
	
	  return at.combine.droppableId;
	});
	
	var getDroppableOver = function getDroppableOver(impact, droppables) {
	  var id = whatIsDraggedOver(impact);
	  return id ? droppables[id] : null;
	};
	
	var moveInDirection = (function (_ref) {
	  var state = _ref.state,
	      type = _ref.type;
	  var isActuallyOver = getDroppableOver(state.impact, state.dimensions.droppables);
	  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
	  var home = state.dimensions.droppables[state.critical.droppable.id];
	  var isOver = isActuallyOver || home;
	  var direction = isOver.axis.direction;
	  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
	
	  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
	    return null;
	  }
	
	  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
	  var draggable = state.dimensions.draggables[state.critical.draggable.id];
	  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
	  var _state$dimensions = state.dimensions,
	      draggables = _state$dimensions.draggables,
	      droppables = _state$dimensions.droppables;
	  return isMovingOnMainAxis ? moveToNextPlace({
	    isMovingForward: isMovingForward,
	    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
	    draggable: draggable,
	    destination: isOver,
	    draggables: draggables,
	    viewport: state.viewport,
	    previousClientSelection: state.current.client.selection,
	    previousImpact: state.impact,
	    afterCritical: state.afterCritical
	  }) : moveCrossAxis({
	    isMovingForward: isMovingForward,
	    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
	    draggable: draggable,
	    isOver: isOver,
	    draggables: draggables,
	    droppables: droppables,
	    viewport: state.viewport,
	    afterCritical: state.afterCritical
	  });
	});
	
	function isMovementAllowed(state) {
	  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
	}
	
	function isPositionInFrame(frame) {
	  var isWithinVertical = isWithin(frame.top, frame.bottom);
	  var isWithinHorizontal = isWithin(frame.left, frame.right);
	  return function run(point) {
	    return isWithinVertical(point.y) && isWithinHorizontal(point.x);
	  };
	}
	
	function getHasOverlap(first, second) {
	  return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
	}
	
	function getFurthestAway(_ref) {
	  var pageBorderBox = _ref.pageBorderBox,
	      draggable = _ref.draggable,
	      candidates = _ref.candidates;
	  var startCenter = draggable.page.borderBox.center;
	  var sorted = candidates.map(function (candidate) {
	    var axis = candidate.axis;
	    var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
	    return {
	      id: candidate.descriptor.id,
	      distance: distance(startCenter, target)
	    };
	  }).sort(function (a, b) {
	    return b.distance - a.distance;
	  });
	  return sorted[0] ? sorted[0].id : null;
	}
	
	function getDroppableOver$1(_ref2) {
	  var pageBorderBox = _ref2.pageBorderBox,
	      draggable = _ref2.draggable,
	      droppables = _ref2.droppables;
	  var candidates = toDroppableList(droppables).filter(function (item) {
	    if (!item.isEnabled) {
	      return false;
	    }
	
	    var active = item.subject.active;
	
	    if (!active) {
	      return false;
	    }
	
	    if (!getHasOverlap(pageBorderBox, active)) {
	      return false;
	    }
	
	    if (isPositionInFrame(active)(pageBorderBox.center)) {
	      return true;
	    }
	
	    var axis = item.axis;
	    var childCenter = active.center[axis.crossAxisLine];
	    var crossAxisStart = pageBorderBox[axis.crossAxisStart];
	    var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
	    var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
	    var isStartContained = isContained(crossAxisStart);
	    var isEndContained = isContained(crossAxisEnd);
	
	    if (!isStartContained && !isEndContained) {
	      return true;
	    }
	
	    if (isStartContained) {
	      return crossAxisStart < childCenter;
	    }
	
	    return crossAxisEnd > childCenter;
	  });
	
	  if (!candidates.length) {
	    return null;
	  }
	
	  if (candidates.length === 1) {
	    return candidates[0].descriptor.id;
	  }
	
	  return getFurthestAway({
	    pageBorderBox: pageBorderBox,
	    draggable: draggable,
	    candidates: candidates
	  });
	}
	
	var offsetRectByPosition = function offsetRectByPosition(rect, point) {
	  return cssBoxModel.getRect(offsetByPosition(rect, point));
	};
	
	var withDroppableScroll = (function (droppable, area) {
	  var frame = droppable.frame;
	
	  if (!frame) {
	    return area;
	  }
	
	  return offsetRectByPosition(area, frame.scroll.diff.value);
	});
	
	function getIsDisplaced(_ref) {
	  var displaced = _ref.displaced,
	      id = _ref.id;
	  return Boolean(displaced.visible[id] || displaced.invisible[id]);
	}
	
	function atIndex(_ref) {
	  var draggable = _ref.draggable,
	      closest = _ref.closest,
	      inHomeList = _ref.inHomeList;
	
	  if (!closest) {
	    return null;
	  }
	
	  if (!inHomeList) {
	    return closest.descriptor.index;
	  }
	
	  if (closest.descriptor.index > draggable.descriptor.index) {
	    return closest.descriptor.index - 1;
	  }
	
	  return closest.descriptor.index;
	}
	
	var getReorderImpact = (function (_ref2) {
	  var targetRect = _ref2.pageBorderBoxWithDroppableScroll,
	      draggable = _ref2.draggable,
	      destination = _ref2.destination,
	      insideDestination = _ref2.insideDestination,
	      last = _ref2.last,
	      viewport = _ref2.viewport,
	      afterCritical = _ref2.afterCritical;
	  var axis = destination.axis;
	  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
	  var displacement = displacedBy.value;
	  var targetStart = targetRect[axis.start];
	  var targetEnd = targetRect[axis.end];
	  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
	  var closest = find(withoutDragging, function (child) {
	    var id = child.descriptor.id;
	    var childCenter = child.page.borderBox.center[axis.line];
	    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
	    var isDisplaced = getIsDisplaced({
	      displaced: last,
	      id: id
	    });
	
	    if (didStartAfterCritical$1) {
	      if (isDisplaced) {
	        return targetEnd <= childCenter;
	      }
	
	      return targetStart < childCenter - displacement;
	    }
	
	    if (isDisplaced) {
	      return targetEnd <= childCenter + displacement;
	    }
	
	    return targetStart < childCenter;
	  });
	  var newIndex = atIndex({
	    draggable: draggable,
	    closest: closest,
	    inHomeList: isHomeOf(draggable, destination)
	  });
	  return calculateReorderImpact({
	    draggable: draggable,
	    insideDestination: insideDestination,
	    destination: destination,
	    viewport: viewport,
	    last: last,
	    displacedBy: displacedBy,
	    index: newIndex
	  });
	});
	
	var combineThresholdDivisor = 4;
	var getCombineImpact = (function (_ref) {
	  var draggable = _ref.draggable,
	      targetRect = _ref.pageBorderBoxWithDroppableScroll,
	      previousImpact = _ref.previousImpact,
	      destination = _ref.destination,
	      insideDestination = _ref.insideDestination,
	      afterCritical = _ref.afterCritical;
	
	  if (!destination.isCombineEnabled) {
	    return null;
	  }
	
	  var axis = destination.axis;
	  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
	  var displacement = displacedBy.value;
	  var targetStart = targetRect[axis.start];
	  var targetEnd = targetRect[axis.end];
	  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
	  var combineWith = find(withoutDragging, function (child) {
	    var id = child.descriptor.id;
	    var childRect = child.page.borderBox;
	    var childSize = childRect[axis.size];
	    var threshold = childSize / combineThresholdDivisor;
	    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
	    var isDisplaced = getIsDisplaced({
	      displaced: previousImpact.displaced,
	      id: id
	    });
	
	    if (didStartAfterCritical$1) {
	      if (isDisplaced) {
	        return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
	      }
	
	      return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
	    }
	
	    if (isDisplaced) {
	      return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
	    }
	
	    return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
	  });
	
	  if (!combineWith) {
	    return null;
	  }
	
	  var impact = {
	    displacedBy: displacedBy,
	    displaced: previousImpact.displaced,
	    at: {
	      type: 'COMBINE',
	      combine: {
	        draggableId: combineWith.descriptor.id,
	        droppableId: destination.descriptor.id
	      }
	    }
	  };
	  return impact;
	});
	
	var getDragImpact = (function (_ref) {
	  var pageOffset = _ref.pageOffset,
	      draggable = _ref.draggable,
	      draggables = _ref.draggables,
	      droppables = _ref.droppables,
	      previousImpact = _ref.previousImpact,
	      viewport = _ref.viewport,
	      afterCritical = _ref.afterCritical;
	  var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
	  var destinationId = getDroppableOver$1({
	    pageBorderBox: pageBorderBox,
	    draggable: draggable,
	    droppables: droppables
	  });
	
	  if (!destinationId) {
	    return noImpact;
	  }
	
	  var destination = droppables[destinationId];
	  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
	  var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
	  return getCombineImpact({
	    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
	    draggable: draggable,
	    previousImpact: previousImpact,
	    destination: destination,
	    insideDestination: insideDestination,
	    afterCritical: afterCritical
	  }) || getReorderImpact({
	    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
	    draggable: draggable,
	    destination: destination,
	    insideDestination: insideDestination,
	    last: previousImpact.displaced,
	    viewport: viewport,
	    afterCritical: afterCritical
	  });
	});
	
	var patchDroppableMap = (function (droppables, updated) {
	  var _extends2;
	
	  return _extends({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
	});
	
	var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
	  var previousImpact = _ref.previousImpact,
	      impact = _ref.impact,
	      droppables = _ref.droppables;
	  var last = whatIsDraggedOver(previousImpact);
	  var now = whatIsDraggedOver(impact);
	
	  if (!last) {
	    return droppables;
	  }
	
	  if (last === now) {
	    return droppables;
	  }
	
	  var lastDroppable = droppables[last];
	
	  if (!lastDroppable.subject.withPlaceholder) {
	    return droppables;
	  }
	
	  var updated = removePlaceholder(lastDroppable);
	  return patchDroppableMap(droppables, updated);
	};
	
	var recomputePlaceholders = (function (_ref2) {
	  var draggable = _ref2.draggable,
	      draggables = _ref2.draggables,
	      droppables = _ref2.droppables,
	      previousImpact = _ref2.previousImpact,
	      impact = _ref2.impact;
	  var cleaned = clearUnusedPlaceholder({
	    previousImpact: previousImpact,
	    impact: impact,
	    droppables: droppables
	  });
	  var isOver = whatIsDraggedOver(impact);
	
	  if (!isOver) {
	    return cleaned;
	  }
	
	  var droppable = droppables[isOver];
	
	  if (isHomeOf(draggable, droppable)) {
	    return cleaned;
	  }
	
	  if (droppable.subject.withPlaceholder) {
	    return cleaned;
	  }
	
	  var patched = addPlaceholder(droppable, draggable, draggables);
	  return patchDroppableMap(cleaned, patched);
	});
	
	var update = (function (_ref) {
	  var state = _ref.state,
	      forcedClientSelection = _ref.clientSelection,
	      forcedDimensions = _ref.dimensions,
	      forcedViewport = _ref.viewport,
	      forcedImpact = _ref.impact,
	      scrollJumpRequest = _ref.scrollJumpRequest;
	  var viewport = forcedViewport || state.viewport;
	  var dimensions = forcedDimensions || state.dimensions;
	  var clientSelection = forcedClientSelection || state.current.client.selection;
	  var offset = subtract(clientSelection, state.initial.client.selection);
	  var client = {
	    offset: offset,
	    selection: clientSelection,
	    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
	  };
	  var page = {
	    selection: add(client.selection, viewport.scroll.current),
	    borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
	    offset: add(client.offset, viewport.scroll.diff.value)
	  };
	  var current = {
	    client: client,
	    page: page
	  };
	
	  if (state.phase === 'COLLECTING') {
	    return _extends({
	      phase: 'COLLECTING'
	    }, state, {
	      dimensions: dimensions,
	      viewport: viewport,
	      current: current
	    });
	  }
	
	  var draggable = dimensions.draggables[state.critical.draggable.id];
	  var newImpact = forcedImpact || getDragImpact({
	    pageOffset: page.offset,
	    draggable: draggable,
	    draggables: dimensions.draggables,
	    droppables: dimensions.droppables,
	    previousImpact: state.impact,
	    viewport: viewport,
	    afterCritical: state.afterCritical
	  });
	  var withUpdatedPlaceholders = recomputePlaceholders({
	    draggable: draggable,
	    impact: newImpact,
	    previousImpact: state.impact,
	    draggables: dimensions.draggables,
	    droppables: dimensions.droppables
	  });
	
	  var result = _extends({}, state, {
	    current: current,
	    dimensions: {
	      draggables: dimensions.draggables,
	      droppables: withUpdatedPlaceholders
	    },
	    impact: newImpact,
	    viewport: viewport,
	    scrollJumpRequest: scrollJumpRequest || null,
	    forceShouldAnimate: scrollJumpRequest ? false : null
	  });
	
	  return result;
	});
	
	function getDraggables$1(ids, draggables) {
	  return ids.map(function (id) {
	    return draggables[id];
	  });
	}
	
	var recompute = (function (_ref) {
	  var impact = _ref.impact,
	      viewport = _ref.viewport,
	      draggables = _ref.draggables,
	      destination = _ref.destination,
	      forceShouldAnimate = _ref.forceShouldAnimate;
	  var last = impact.displaced;
	  var afterDragging = getDraggables$1(last.all, draggables);
	  var displaced = getDisplacementGroups({
	    afterDragging: afterDragging,
	    destination: destination,
	    displacedBy: impact.displacedBy,
	    viewport: viewport.frame,
	    forceShouldAnimate: forceShouldAnimate,
	    last: last
	  });
	  return _extends({}, impact, {
	    displaced: displaced
	  });
	});
	
	var getClientBorderBoxCenter = (function (_ref) {
	  var impact = _ref.impact,
	      draggable = _ref.draggable,
	      droppable = _ref.droppable,
	      draggables = _ref.draggables,
	      viewport = _ref.viewport,
	      afterCritical = _ref.afterCritical;
	  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
	    impact: impact,
	    draggable: draggable,
	    draggables: draggables,
	    droppable: droppable,
	    afterCritical: afterCritical
	  });
	  return getClientFromPageBorderBoxCenter({
	    pageBorderBoxCenter: pageBorderBoxCenter,
	    draggable: draggable,
	    viewport: viewport
	  });
	});
	
	var refreshSnap = (function (_ref) {
	  var state = _ref.state,
	      forcedDimensions = _ref.dimensions,
	      forcedViewport = _ref.viewport;
	  !(state.movementMode === 'SNAP') ?  false ? invariant(false) : invariant(false) : void 0;
	  var needsVisibilityCheck = state.impact;
	  var viewport = forcedViewport || state.viewport;
	  var dimensions = forcedDimensions || state.dimensions;
	  var draggables = dimensions.draggables,
	      droppables = dimensions.droppables;
	  var draggable = draggables[state.critical.draggable.id];
	  var isOver = whatIsDraggedOver(needsVisibilityCheck);
	  !isOver ?  false ? invariant(false, 'Must be over a destination in SNAP movement mode') : invariant(false) : void 0;
	  var destination = droppables[isOver];
	  var impact = recompute({
	    impact: needsVisibilityCheck,
	    viewport: viewport,
	    destination: destination,
	    draggables: draggables
	  });
	  var clientSelection = getClientBorderBoxCenter({
	    impact: impact,
	    draggable: draggable,
	    droppable: destination,
	    draggables: draggables,
	    viewport: viewport,
	    afterCritical: state.afterCritical
	  });
	  return update({
	    impact: impact,
	    clientSelection: clientSelection,
	    state: state,
	    dimensions: dimensions,
	    viewport: viewport
	  });
	});
	
	var getHomeLocation = (function (descriptor) {
	  return {
	    index: descriptor.index,
	    droppableId: descriptor.droppableId
	  };
	});
	
	var getLiftEffect = (function (_ref) {
	  var draggable = _ref.draggable,
	      home = _ref.home,
	      draggables = _ref.draggables,
	      viewport = _ref.viewport;
	  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
	  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
	  var rawIndex = insideHome.indexOf(draggable);
	  !(rawIndex !== -1) ?  false ? invariant(false, 'Expected draggable to be inside home list') : invariant(false) : void 0;
	  var afterDragging = insideHome.slice(rawIndex + 1);
	  var effected = afterDragging.reduce(function (previous, item) {
	    previous[item.descriptor.id] = true;
	    return previous;
	  }, {});
	  var afterCritical = {
	    inVirtualList: home.descriptor.mode === 'virtual',
	    displacedBy: displacedBy,
	    effected: effected
	  };
	  var displaced = getDisplacementGroups({
	    afterDragging: afterDragging,
	    destination: home,
	    displacedBy: displacedBy,
	    last: null,
	    viewport: viewport.frame,
	    forceShouldAnimate: false
	  });
	  var impact = {
	    displaced: displaced,
	    displacedBy: displacedBy,
	    at: {
	      type: 'REORDER',
	      destination: getHomeLocation(draggable.descriptor)
	    }
	  };
	  return {
	    impact: impact,
	    afterCritical: afterCritical
	  };
	});
	
	var patchDimensionMap = (function (dimensions, updated) {
	  return {
	    draggables: dimensions.draggables,
	    droppables: patchDroppableMap(dimensions.droppables, updated)
	  };
	});
	
	var start = function start(key) {
	  if (false) {
	    {
	      return;
	    }
	  }
	};
	var finish = function finish(key) {
	  if (false) {
	    {
	      return;
	    }
	  }
	};
	
	var offsetDraggable = (function (_ref) {
	  var draggable = _ref.draggable,
	      offset = _ref.offset,
	      initialWindowScroll = _ref.initialWindowScroll;
	  var client = cssBoxModel.offset(draggable.client, offset);
	  var page = cssBoxModel.withScroll(client, initialWindowScroll);
	
	  var moved = _extends({}, draggable, {
	    placeholder: _extends({}, draggable.placeholder, {
	      client: client
	    }),
	    client: client,
	    page: page
	  });
	
	  return moved;
	});
	
	var getFrame = (function (droppable) {
	  var frame = droppable.frame;
	  !frame ?  false ? invariant(false, 'Expected Droppable to have a frame') : invariant(false) : void 0;
	  return frame;
	});
	
	var adjustAdditionsForScrollChanges = (function (_ref) {
	  var additions = _ref.additions,
	      updatedDroppables = _ref.updatedDroppables,
	      viewport = _ref.viewport;
	  var windowScrollChange = viewport.scroll.diff.value;
	  return additions.map(function (draggable) {
	    var droppableId = draggable.descriptor.droppableId;
	    var modified = updatedDroppables[droppableId];
	    var frame = getFrame(modified);
	    var droppableScrollChange = frame.scroll.diff.value;
	    var totalChange = add(windowScrollChange, droppableScrollChange);
	    var moved = offsetDraggable({
	      draggable: draggable,
	      offset: totalChange,
	      initialWindowScroll: viewport.scroll.initial
	    });
	    return moved;
	  });
	});
	
	var publishWhileDraggingInVirtual = (function (_ref) {
	  var state = _ref.state,
	      published = _ref.published;
	  start();
	  var withScrollChange = published.modified.map(function (update) {
	    var existing = state.dimensions.droppables[update.droppableId];
	    var scrolled = scrollDroppable(existing, update.scroll);
	    return scrolled;
	  });
	
	  var droppables = _extends({}, state.dimensions.droppables, {}, toDroppableMap(withScrollChange));
	
	  var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
	    additions: published.additions,
	    updatedDroppables: droppables,
	    viewport: state.viewport
	  }));
	
	  var draggables = _extends({}, state.dimensions.draggables, {}, updatedAdditions);
	
	  published.removals.forEach(function (id) {
	    delete draggables[id];
	  });
	  var dimensions = {
	    droppables: droppables,
	    draggables: draggables
	  };
	  var wasOverId = whatIsDraggedOver(state.impact);
	  var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
	  var draggable = dimensions.draggables[state.critical.draggable.id];
	  var home = dimensions.droppables[state.critical.droppable.id];
	
	  var _getLiftEffect = getLiftEffect({
	    draggable: draggable,
	    home: home,
	    draggables: draggables,
	    viewport: state.viewport
	  }),
	      onLiftImpact = _getLiftEffect.impact,
	      afterCritical = _getLiftEffect.afterCritical;
	
	  var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
	  var impact = getDragImpact({
	    pageOffset: state.current.page.offset,
	    draggable: dimensions.draggables[state.critical.draggable.id],
	    draggables: dimensions.draggables,
	    droppables: dimensions.droppables,
	    previousImpact: previousImpact,
	    viewport: state.viewport,
	    afterCritical: afterCritical
	  });
	  finish();
	
	  var draggingState = _extends({
	    phase: 'DRAGGING'
	  }, state, {
	    phase: 'DRAGGING',
	    impact: impact,
	    onLiftImpact: onLiftImpact,
	    dimensions: dimensions,
	    afterCritical: afterCritical,
	    forceShouldAnimate: false
	  });
	
	  if (state.phase === 'COLLECTING') {
	    return draggingState;
	  }
	
	  var dropPending = _extends({
	    phase: 'DROP_PENDING'
	  }, draggingState, {
	    phase: 'DROP_PENDING',
	    reason: state.reason,
	    isWaiting: false
	  });
	
	  return dropPending;
	});
	
	var isSnapping = function isSnapping(state) {
	  return state.movementMode === 'SNAP';
	};
	
	var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
	  var dimensions = patchDimensionMap(state.dimensions, updated);
	
	  if (!isSnapping(state) || isEnabledChanging) {
	    return update({
	      state: state,
	      dimensions: dimensions
	    });
	  }
	
	  return refreshSnap({
	    state: state,
	    dimensions: dimensions
	  });
	};
	
	function removeScrollJumpRequest(state) {
	  if (state.isDragging && state.movementMode === 'SNAP') {
	    return _extends({
	      phase: 'DRAGGING'
	    }, state, {
	      scrollJumpRequest: null
	    });
	  }
	
	  return state;
	}
	
	var idle = {
	  phase: 'IDLE',
	  completed: null,
	  shouldFlush: false
	};
	var reducer = (function (state, action) {
	  if (state === void 0) {
	    state = idle;
	  }
	
	  if (action.type === 'FLUSH') {
	    return _extends({}, idle, {
	      shouldFlush: true
	    });
	  }
	
	  if (action.type === 'INITIAL_PUBLISH') {
	    !(state.phase === 'IDLE') ?  false ? invariant(false, 'INITIAL_PUBLISH must come after a IDLE phase') : invariant(false) : void 0;
	    var _action$payload = action.payload,
	        critical = _action$payload.critical,
	        clientSelection = _action$payload.clientSelection,
	        viewport = _action$payload.viewport,
	        dimensions = _action$payload.dimensions,
	        movementMode = _action$payload.movementMode;
	    var draggable = dimensions.draggables[critical.draggable.id];
	    var home = dimensions.droppables[critical.droppable.id];
	    var client = {
	      selection: clientSelection,
	      borderBoxCenter: draggable.client.borderBox.center,
	      offset: origin
	    };
	    var initial = {
	      client: client,
	      page: {
	        selection: add(client.selection, viewport.scroll.initial),
	        borderBoxCenter: add(client.selection, viewport.scroll.initial),
	        offset: add(client.selection, viewport.scroll.diff.value)
	      }
	    };
	    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
	      return !item.isFixedOnPage;
	    });
	
	    var _getLiftEffect = getLiftEffect({
	      draggable: draggable,
	      home: home,
	      draggables: dimensions.draggables,
	      viewport: viewport
	    }),
	        impact = _getLiftEffect.impact,
	        afterCritical = _getLiftEffect.afterCritical;
	
	    var result = {
	      phase: 'DRAGGING',
	      isDragging: true,
	      critical: critical,
	      movementMode: movementMode,
	      dimensions: dimensions,
	      initial: initial,
	      current: initial,
	      isWindowScrollAllowed: isWindowScrollAllowed,
	      impact: impact,
	      afterCritical: afterCritical,
	      onLiftImpact: impact,
	      viewport: viewport,
	      scrollJumpRequest: null,
	      forceShouldAnimate: null
	    };
	    return result;
	  }
	
	  if (action.type === 'COLLECTION_STARTING') {
	    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
	      return state;
	    }
	
	    !(state.phase === 'DRAGGING') ?  false ? invariant(false, "Collection cannot start from phase " + state.phase) : invariant(false) : void 0;
	
	    var _result = _extends({
	      phase: 'COLLECTING'
	    }, state, {
	      phase: 'COLLECTING'
	    });
	
	    return _result;
	  }
	
	  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
	    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Unexpected " + action.type + " received in phase " + state.phase) : invariant(false) : void 0;
	    return publishWhileDraggingInVirtual({
	      state: state,
	      published: action.payload
	    });
	  }
	
	  if (action.type === 'MOVE') {
	    if (state.phase === 'DROP_PENDING') {
	      return state;
	    }
	
	    !isMovementAllowed(state) ?  false ? invariant(false, action.type + " not permitted in phase " + state.phase) : invariant(false) : void 0;
	    var _clientSelection = action.payload.client;
	
	    if (isEqual(_clientSelection, state.current.client.selection)) {
	      return state;
	    }
	
	    return update({
	      state: state,
	      clientSelection: _clientSelection,
	      impact: isSnapping(state) ? state.impact : null
	    });
	  }
	
	  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
	    if (state.phase === 'DROP_PENDING') {
	      return removeScrollJumpRequest(state);
	    }
	
	    if (state.phase === 'COLLECTING') {
	      return removeScrollJumpRequest(state);
	    }
	
	    !isMovementAllowed(state) ?  false ? invariant(false, action.type + " not permitted in phase " + state.phase) : invariant(false) : void 0;
	    var _action$payload2 = action.payload,
	        id = _action$payload2.id,
	        newScroll = _action$payload2.newScroll;
	    var target = state.dimensions.droppables[id];
	
	    if (!target) {
	      return state;
	    }
	
	    var scrolled = scrollDroppable(target, newScroll);
	    return postDroppableChange(state, scrolled, false);
	  }
	
	  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
	    if (state.phase === 'DROP_PENDING') {
	      return state;
	    }
	
	    !isMovementAllowed(state) ?  false ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : invariant(false) : void 0;
	    var _action$payload3 = action.payload,
	        _id = _action$payload3.id,
	        isEnabled = _action$payload3.isEnabled;
	    var _target = state.dimensions.droppables[_id];
	    !_target ?  false ? invariant(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : invariant(false) : void 0;
	    !(_target.isEnabled !== isEnabled) ?  false ? invariant(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : invariant(false) : void 0;
	
	    var updated = _extends({}, _target, {
	      isEnabled: isEnabled
	    });
	
	    return postDroppableChange(state, updated, true);
	  }
	
	  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
	    if (state.phase === 'DROP_PENDING') {
	      return state;
	    }
	
	    !isMovementAllowed(state) ?  false ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : invariant(false) : void 0;
	    var _action$payload4 = action.payload,
	        _id2 = _action$payload4.id,
	        isCombineEnabled = _action$payload4.isCombineEnabled;
	    var _target2 = state.dimensions.droppables[_id2];
	    !_target2 ?  false ? invariant(false, "Cannot find Droppable[id: " + _id2 + "] to toggle its isCombineEnabled state") : invariant(false) : void 0;
	    !(_target2.isCombineEnabled !== isCombineEnabled) ?  false ? invariant(false, "Trying to set droppable isCombineEnabled to " + String(isCombineEnabled) + "\n      but it is already " + String(_target2.isCombineEnabled)) : invariant(false) : void 0;
	
	    var _updated = _extends({}, _target2, {
	      isCombineEnabled: isCombineEnabled
	    });
	
	    return postDroppableChange(state, _updated, true);
	  }
	
	  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
	    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
	      return state;
	    }
	
	    !isMovementAllowed(state) ?  false ? invariant(false, "Cannot move by window in phase " + state.phase) : invariant(false) : void 0;
	    !state.isWindowScrollAllowed ?  false ? invariant(false, 'Window scrolling is currently not supported for fixed lists') : invariant(false) : void 0;
	    var _newScroll = action.payload.newScroll;
	
	    if (isEqual(state.viewport.scroll.current, _newScroll)) {
	      return removeScrollJumpRequest(state);
	    }
	
	    var _viewport = scrollViewport(state.viewport, _newScroll);
	
	    if (isSnapping(state)) {
	      return refreshSnap({
	        state: state,
	        viewport: _viewport
	      });
	    }
	
	    return update({
	      state: state,
	      viewport: _viewport
	    });
	  }
	
	  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
	    if (!isMovementAllowed(state)) {
	      return state;
	    }
	
	    var maxScroll = action.payload.maxScroll;
	
	    if (isEqual(maxScroll, state.viewport.scroll.max)) {
	      return state;
	    }
	
	    var withMaxScroll = _extends({}, state.viewport, {
	      scroll: _extends({}, state.viewport.scroll, {
	        max: maxScroll
	      })
	    });
	
	    return _extends({
	      phase: 'DRAGGING'
	    }, state, {
	      viewport: withMaxScroll
	    });
	  }
	
	  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
	    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
	      return state;
	    }
	
	    !(state.phase === 'DRAGGING') ?  false ? invariant(false, action.type + " received while not in DRAGGING phase") : invariant(false) : void 0;
	
	    var _result2 = moveInDirection({
	      state: state,
	      type: action.type
	    });
	
	    if (!_result2) {
	      return state;
	    }
	
	    return update({
	      state: state,
	      impact: _result2.impact,
	      clientSelection: _result2.clientSelection,
	      scrollJumpRequest: _result2.scrollJumpRequest
	    });
	  }
	
	  if (action.type === 'DROP_PENDING') {
	    var reason = action.payload.reason;
	    !(state.phase === 'COLLECTING') ?  false ? invariant(false, 'Can only move into the DROP_PENDING phase from the COLLECTING phase') : invariant(false) : void 0;
	
	    var newState = _extends({
	      phase: 'DROP_PENDING'
	    }, state, {
	      phase: 'DROP_PENDING',
	      isWaiting: true,
	      reason: reason
	    });
	
	    return newState;
	  }
	
	  if (action.type === 'DROP_ANIMATE') {
	    var _action$payload5 = action.payload,
	        completed = _action$payload5.completed,
	        dropDuration = _action$payload5.dropDuration,
	        newHomeClientOffset = _action$payload5.newHomeClientOffset;
	    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Cannot animate drop from phase " + state.phase) : invariant(false) : void 0;
	    var _result3 = {
	      phase: 'DROP_ANIMATING',
	      completed: completed,
	      dropDuration: dropDuration,
	      newHomeClientOffset: newHomeClientOffset,
	      dimensions: state.dimensions
	    };
	    return _result3;
	  }
	
	  if (action.type === 'DROP_COMPLETE') {
	    var _completed = action.payload.completed;
	    return {
	      phase: 'IDLE',
	      completed: _completed,
	      shouldFlush: false
	    };
	  }
	
	  return state;
	});
	
	var beforeInitialCapture = function beforeInitialCapture(args) {
	  return {
	    type: 'BEFORE_INITIAL_CAPTURE',
	    payload: args
	  };
	};
	var lift = function lift(args) {
	  return {
	    type: 'LIFT',
	    payload: args
	  };
	};
	var initialPublish = function initialPublish(args) {
	  return {
	    type: 'INITIAL_PUBLISH',
	    payload: args
	  };
	};
	var publishWhileDragging = function publishWhileDragging(args) {
	  return {
	    type: 'PUBLISH_WHILE_DRAGGING',
	    payload: args
	  };
	};
	var collectionStarting = function collectionStarting() {
	  return {
	    type: 'COLLECTION_STARTING',
	    payload: null
	  };
	};
	var updateDroppableScroll = function updateDroppableScroll(args) {
	  return {
	    type: 'UPDATE_DROPPABLE_SCROLL',
	    payload: args
	  };
	};
	var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
	  return {
	    type: 'UPDATE_DROPPABLE_IS_ENABLED',
	    payload: args
	  };
	};
	var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
	  return {
	    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
	    payload: args
	  };
	};
	var move = function move(args) {
	  return {
	    type: 'MOVE',
	    payload: args
	  };
	};
	var moveByWindowScroll = function moveByWindowScroll(args) {
	  return {
	    type: 'MOVE_BY_WINDOW_SCROLL',
	    payload: args
	  };
	};
	var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
	  return {
	    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
	    payload: args
	  };
	};
	var moveUp = function moveUp() {
	  return {
	    type: 'MOVE_UP',
	    payload: null
	  };
	};
	var moveDown = function moveDown() {
	  return {
	    type: 'MOVE_DOWN',
	    payload: null
	  };
	};
	var moveRight = function moveRight() {
	  return {
	    type: 'MOVE_RIGHT',
	    payload: null
	  };
	};
	var moveLeft = function moveLeft() {
	  return {
	    type: 'MOVE_LEFT',
	    payload: null
	  };
	};
	var flush = function flush() {
	  return {
	    type: 'FLUSH',
	    payload: null
	  };
	};
	var animateDrop = function animateDrop(args) {
	  return {
	    type: 'DROP_ANIMATE',
	    payload: args
	  };
	};
	var completeDrop = function completeDrop(args) {
	  return {
	    type: 'DROP_COMPLETE',
	    payload: args
	  };
	};
	var drop = function drop(args) {
	  return {
	    type: 'DROP',
	    payload: args
	  };
	};
	var dropPending = function dropPending(args) {
	  return {
	    type: 'DROP_PENDING',
	    payload: args
	  };
	};
	var dropAnimationFinished = function dropAnimationFinished() {
	  return {
	    type: 'DROP_ANIMATION_FINISHED',
	    payload: null
	  };
	};
	
	function checkIndexes(insideDestination) {
	  if (insideDestination.length <= 1) {
	    return;
	  }
	
	  var indexes = insideDestination.map(function (d) {
	    return d.descriptor.index;
	  });
	  var errors = {};
	
	  for (var i = 1; i < indexes.length; i++) {
	    var current = indexes[i];
	    var previous = indexes[i - 1];
	
	    if (current !== previous + 1) {
	      errors[current] = true;
	    }
	  }
	
	  if (!Object.keys(errors).length) {
	    return;
	  }
	
	  var formatted = indexes.map(function (index) {
	    var hasError = Boolean(errors[index]);
	    return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
	  }).join(', ');
	   false ? warning("\n    Detected non-consecutive <Draggable /> indexes.\n\n    (This can cause unexpected bugs)\n\n    " + formatted + "\n  ") : void 0;
	}
	
	function validateDimensions(critical, dimensions) {
	  if (false) {
	    var insideDestination = getDraggablesInsideDroppable(critical.droppable.id, dimensions.draggables);
	    checkIndexes(insideDestination);
	  }
	}
	
	var lift$1 = (function (marshal) {
	  return function (_ref) {
	    var getState = _ref.getState,
	        dispatch = _ref.dispatch;
	    return function (next) {
	      return function (action) {
	        if (action.type !== 'LIFT') {
	          next(action);
	          return;
	        }
	
	        var _action$payload = action.payload,
	            id = _action$payload.id,
	            clientSelection = _action$payload.clientSelection,
	            movementMode = _action$payload.movementMode;
	        var initial = getState();
	
	        if (initial.phase === 'DROP_ANIMATING') {
	          dispatch(completeDrop({
	            completed: initial.completed
	          }));
	        }
	
	        !(getState().phase === 'IDLE') ?  false ? invariant(false, 'Unexpected phase to start a drag') : invariant(false) : void 0;
	        dispatch(flush());
	        dispatch(beforeInitialCapture({
	          draggableId: id,
	          movementMode: movementMode
	        }));
	        var scrollOptions = {
	          shouldPublishImmediately: movementMode === 'SNAP'
	        };
	        var request = {
	          draggableId: id,
	          scrollOptions: scrollOptions
	        };
	
	        var _marshal$startPublish = marshal.startPublishing(request),
	            critical = _marshal$startPublish.critical,
	            dimensions = _marshal$startPublish.dimensions,
	            viewport = _marshal$startPublish.viewport;
	
	        validateDimensions(critical, dimensions);
	        dispatch(initialPublish({
	          critical: critical,
	          dimensions: dimensions,
	          clientSelection: clientSelection,
	          movementMode: movementMode,
	          viewport: viewport
	        }));
	      };
	    };
	  };
	});
	
	var style = (function (marshal) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type === 'INITIAL_PUBLISH') {
	          marshal.dragging();
	        }
	
	        if (action.type === 'DROP_ANIMATE') {
	          marshal.dropping(action.payload.completed.result.reason);
	        }
	
	        if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') {
	          marshal.resting();
	        }
	
	        next(action);
	      };
	    };
	  };
	});
	
	var curves = {
	  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
	  drop: 'cubic-bezier(.2,1,.1,1)'
	};
	var combine = {
	  opacity: {
	    drop: 0,
	    combining: 0.7
	  },
	  scale: {
	    drop: 0.75
	  }
	};
	var timings = {
	  outOfTheWay: 0.2,
	  minDropTime: 0.33,
	  maxDropTime: 0.55
	};
	var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
	var transitions = {
	  fluid: "opacity " + outOfTheWayTiming,
	  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
	  drop: function drop(duration) {
	    var timing = duration + "s " + curves.drop;
	    return "transform " + timing + ", opacity " + timing;
	  },
	  outOfTheWay: "transform " + outOfTheWayTiming,
	  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
	};
	
	var moveTo = function moveTo(offset) {
	  return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
	};
	
	var transforms = {
	  moveTo: moveTo,
	  drop: function drop(offset, isCombining) {
	    var translate = moveTo(offset);
	
	    if (!translate) {
	      return null;
	    }
	
	    if (!isCombining) {
	      return translate;
	    }
	
	    return translate + " scale(" + combine.scale.drop + ")";
	  }
	};
	
	var minDropTime = timings.minDropTime,
	    maxDropTime = timings.maxDropTime;
	var dropTimeRange = maxDropTime - minDropTime;
	var maxDropTimeAtDistance = 1500;
	var cancelDropModifier = 0.6;
	var getDropDuration = (function (_ref) {
	  var current = _ref.current,
	      destination = _ref.destination,
	      reason = _ref.reason;
	  var distance$1 = distance(current, destination);
	
	  if (distance$1 <= 0) {
	    return minDropTime;
	  }
	
	  if (distance$1 >= maxDropTimeAtDistance) {
	    return maxDropTime;
	  }
	
	  var percentage = distance$1 / maxDropTimeAtDistance;
	  var duration = minDropTime + dropTimeRange * percentage;
	  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
	  return Number(withDuration.toFixed(2));
	});
	
	var getNewHomeClientOffset = (function (_ref) {
	  var impact = _ref.impact,
	      draggable = _ref.draggable,
	      dimensions = _ref.dimensions,
	      viewport = _ref.viewport,
	      afterCritical = _ref.afterCritical;
	  var draggables = dimensions.draggables,
	      droppables = dimensions.droppables;
	  var droppableId = whatIsDraggedOver(impact);
	  var destination = droppableId ? droppables[droppableId] : null;
	  var home = droppables[draggable.descriptor.droppableId];
	  var newClientCenter = getClientBorderBoxCenter({
	    impact: impact,
	    draggable: draggable,
	    draggables: draggables,
	    afterCritical: afterCritical,
	    droppable: destination || home,
	    viewport: viewport
	  });
	  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
	  return offset;
	});
	
	var getDropImpact = (function (_ref) {
	  var draggables = _ref.draggables,
	      reason = _ref.reason,
	      lastImpact = _ref.lastImpact,
	      home = _ref.home,
	      viewport = _ref.viewport,
	      onLiftImpact = _ref.onLiftImpact;
	
	  if (!lastImpact.at || reason !== 'DROP') {
	    var recomputedHomeImpact = recompute({
	      draggables: draggables,
	      impact: onLiftImpact,
	      destination: home,
	      viewport: viewport,
	      forceShouldAnimate: true
	    });
	    return {
	      impact: recomputedHomeImpact,
	      didDropInsideDroppable: false
	    };
	  }
	
	  if (lastImpact.at.type === 'REORDER') {
	    return {
	      impact: lastImpact,
	      didDropInsideDroppable: true
	    };
	  }
	
	  var withoutMovement = _extends({}, lastImpact, {
	    displaced: emptyGroups
	  });
	
	  return {
	    impact: withoutMovement,
	    didDropInsideDroppable: true
	  };
	});
	
	var drop$1 = (function (_ref) {
	  var getState = _ref.getState,
	      dispatch = _ref.dispatch;
	  return function (next) {
	    return function (action) {
	      if (action.type !== 'DROP') {
	        next(action);
	        return;
	      }
	
	      var state = getState();
	      var reason = action.payload.reason;
	
	      if (state.phase === 'COLLECTING') {
	        dispatch(dropPending({
	          reason: reason
	        }));
	        return;
	      }
	
	      if (state.phase === 'IDLE') {
	        return;
	      }
	
	      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
	      !!isWaitingForDrop ?  false ? invariant(false, 'A DROP action occurred while DROP_PENDING and still waiting') : invariant(false) : void 0;
	      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Cannot drop in phase: " + state.phase) : invariant(false) : void 0;
	      var critical = state.critical;
	      var dimensions = state.dimensions;
	      var draggable = dimensions.draggables[state.critical.draggable.id];
	
	      var _getDropImpact = getDropImpact({
	        reason: reason,
	        lastImpact: state.impact,
	        afterCritical: state.afterCritical,
	        onLiftImpact: state.onLiftImpact,
	        home: state.dimensions.droppables[state.critical.droppable.id],
	        viewport: state.viewport,
	        draggables: state.dimensions.draggables
	      }),
	          impact = _getDropImpact.impact,
	          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
	
	      var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
	      var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
	      var source = {
	        index: critical.draggable.index,
	        droppableId: critical.droppable.id
	      };
	      var result = {
	        draggableId: draggable.descriptor.id,
	        type: draggable.descriptor.type,
	        source: source,
	        reason: reason,
	        mode: state.movementMode,
	        destination: destination,
	        combine: combine
	      };
	      var newHomeClientOffset = getNewHomeClientOffset({
	        impact: impact,
	        draggable: draggable,
	        dimensions: dimensions,
	        viewport: state.viewport,
	        afterCritical: state.afterCritical
	      });
	      var completed = {
	        critical: state.critical,
	        afterCritical: state.afterCritical,
	        result: result,
	        impact: impact
	      };
	      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
	
	      if (!isAnimationRequired) {
	        dispatch(completeDrop({
	          completed: completed
	        }));
	        return;
	      }
	
	      var dropDuration = getDropDuration({
	        current: state.current.client.offset,
	        destination: newHomeClientOffset,
	        reason: reason
	      });
	      var args = {
	        newHomeClientOffset: newHomeClientOffset,
	        dropDuration: dropDuration,
	        completed: completed
	      };
	      dispatch(animateDrop(args));
	    };
	  };
	});
	
	var getWindowScroll = (function () {
	  return {
	    x: window.pageXOffset,
	    y: window.pageYOffset
	  };
	});
	
	function getWindowScrollBinding(update) {
	  return {
	    eventName: 'scroll',
	    options: {
	      passive: true,
	      capture: false
	    },
	    fn: function fn(event) {
	      if (event.target !== window && event.target !== window.document) {
	        return;
	      }
	
	      update();
	    }
	  };
	}
	
	function getScrollListener(_ref) {
	  var onWindowScroll = _ref.onWindowScroll;
	
	  function updateScroll() {
	    onWindowScroll(getWindowScroll());
	  }
	
	  var scheduled = rafSchd(updateScroll);
	  var binding = getWindowScrollBinding(scheduled);
	  var unbind = noop;
	
	  function isActive() {
	    return unbind !== noop;
	  }
	
	  function start() {
	    !!isActive() ?  false ? invariant(false, 'Cannot start scroll listener when already active') : invariant(false) : void 0;
	    unbind = bindEvents(window, [binding]);
	  }
	
	  function stop() {
	    !isActive() ?  false ? invariant(false, 'Cannot stop scroll listener when not active') : invariant(false) : void 0;
	    scheduled.cancel();
	    unbind();
	    unbind = noop;
	  }
	
	  return {
	    start: start,
	    stop: stop,
	    isActive: isActive
	  };
	}
	
	var shouldEnd = function shouldEnd(action) {
	  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
	};
	
	var scrollListener = (function (store) {
	  var listener = getScrollListener({
	    onWindowScroll: function onWindowScroll(newScroll) {
	      store.dispatch(moveByWindowScroll({
	        newScroll: newScroll
	      }));
	    }
	  });
	  return function (next) {
	    return function (action) {
	      if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') {
	        listener.start();
	      }
	
	      if (listener.isActive() && shouldEnd(action)) {
	        listener.stop();
	      }
	
	      next(action);
	    };
	  };
	});
	
	var getExpiringAnnounce = (function (announce) {
	  var wasCalled = false;
	  var isExpired = false;
	  var timeoutId = setTimeout(function () {
	    isExpired = true;
	  });
	
	  var result = function result(message) {
	    if (wasCalled) {
	       false ? warning('Announcement already made. Not making a second announcement') : void 0;
	      return;
	    }
	
	    if (isExpired) {
	       false ? warning("\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ") : void 0;
	      return;
	    }
	
	    wasCalled = true;
	    announce(message);
	    clearTimeout(timeoutId);
	  };
	
	  result.wasCalled = function () {
	    return wasCalled;
	  };
	
	  return result;
	});
	
	var getAsyncMarshal = (function () {
	  var entries = [];
	
	  var execute = function execute(timerId) {
	    var index = findIndex(entries, function (item) {
	      return item.timerId === timerId;
	    });
	    !(index !== -1) ?  false ? invariant(false, 'Could not find timer') : invariant(false) : void 0;
	
	    var _entries$splice = entries.splice(index, 1),
	        entry = _entries$splice[0];
	
	    entry.callback();
	  };
	
	  var add = function add(fn) {
	    var timerId = setTimeout(function () {
	      return execute(timerId);
	    });
	    var entry = {
	      timerId: timerId,
	      callback: fn
	    };
	    entries.push(entry);
	  };
	
	  var flush = function flush() {
	    if (!entries.length) {
	      return;
	    }
	
	    var shallow = [].concat(entries);
	    entries.length = 0;
	    shallow.forEach(function (entry) {
	      clearTimeout(entry.timerId);
	      entry.callback();
	    });
	  };
	
	  return {
	    add: add,
	    flush: flush
	  };
	});
	
	var areLocationsEqual = function areLocationsEqual(first, second) {
	  if (first == null && second == null) {
	    return true;
	  }
	
	  if (first == null || second == null) {
	    return false;
	  }
	
	  return first.droppableId === second.droppableId && first.index === second.index;
	};
	var isCombineEqual = function isCombineEqual(first, second) {
	  if (first == null && second == null) {
	    return true;
	  }
	
	  if (first == null || second == null) {
	    return false;
	  }
	
	  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
	};
	var isCriticalEqual = function isCriticalEqual(first, second) {
	  if (first === second) {
	    return true;
	  }
	
	  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
	  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
	  return isDraggableEqual && isDroppableEqual;
	};
	
	var withTimings = function withTimings(key, fn) {
	  start();
	  fn();
	  finish();
	};
	
	var getDragStart = function getDragStart(critical, mode) {
	  return {
	    draggableId: critical.draggable.id,
	    type: critical.droppable.type,
	    source: {
	      droppableId: critical.droppable.id,
	      index: critical.draggable.index
	    },
	    mode: mode
	  };
	};
	
	var execute = function execute(responder, data, announce, getDefaultMessage) {
	  if (!responder) {
	    announce(getDefaultMessage(data));
	    return;
	  }
	
	  var willExpire = getExpiringAnnounce(announce);
	  var provided = {
	    announce: willExpire
	  };
	  responder(data, provided);
	
	  if (!willExpire.wasCalled()) {
	    announce(getDefaultMessage(data));
	  }
	};
	
	var getPublisher = (function (getResponders, announce) {
	  var asyncMarshal = getAsyncMarshal();
	  var dragging = null;
	
	  var beforeCapture = function beforeCapture(draggableId, mode) {
	    !!dragging ?  false ? invariant(false, 'Cannot fire onBeforeCapture as a drag start has already been published') : invariant(false) : void 0;
	    withTimings('onBeforeCapture', function () {
	      var fn = getResponders().onBeforeCapture;
	
	      if (fn) {
	        var before = {
	          draggableId: draggableId,
	          mode: mode
	        };
	        fn(before);
	      }
	    });
	  };
	
	  var beforeStart = function beforeStart(critical, mode) {
	    !!dragging ?  false ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant(false) : void 0;
	    withTimings('onBeforeDragStart', function () {
	      var fn = getResponders().onBeforeDragStart;
	
	      if (fn) {
	        fn(getDragStart(critical, mode));
	      }
	    });
	  };
	
	  var start = function start(critical, mode) {
	    !!dragging ?  false ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant(false) : void 0;
	    var data = getDragStart(critical, mode);
	    dragging = {
	      mode: mode,
	      lastCritical: critical,
	      lastLocation: data.source,
	      lastCombine: null
	    };
	    asyncMarshal.add(function () {
	      withTimings('onDragStart', function () {
	        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
	      });
	    });
	  };
	
	  var update = function update(critical, impact) {
	    var location = tryGetDestination(impact);
	    var combine = tryGetCombine(impact);
	    !dragging ?  false ? invariant(false, 'Cannot fire onDragMove when onDragStart has not been called') : invariant(false) : void 0;
	    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);
	
	    if (hasCriticalChanged) {
	      dragging.lastCritical = critical;
	    }
	
	    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);
	
	    if (hasLocationChanged) {
	      dragging.lastLocation = location;
	    }
	
	    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);
	
	    if (hasGroupingChanged) {
	      dragging.lastCombine = combine;
	    }
	
	    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
	      return;
	    }
	
	    var data = _extends({}, getDragStart(critical, dragging.mode), {
	      combine: combine,
	      destination: location
	    });
	
	    asyncMarshal.add(function () {
	      withTimings('onDragUpdate', function () {
	        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
	      });
	    });
	  };
	
	  var flush = function flush() {
	    !dragging ?  false ? invariant(false, 'Can only flush responders while dragging') : invariant(false) : void 0;
	    asyncMarshal.flush();
	  };
	
	  var drop = function drop(result) {
	    !dragging ?  false ? invariant(false, 'Cannot fire onDragEnd when there is no matching onDragStart') : invariant(false) : void 0;
	    dragging = null;
	    withTimings('onDragEnd', function () {
	      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
	    });
	  };
	
	  var abort = function abort() {
	    if (!dragging) {
	      return;
	    }
	
	    var result = _extends({}, getDragStart(dragging.lastCritical, dragging.mode), {
	      combine: null,
	      destination: null,
	      reason: 'CANCEL'
	    });
	
	    drop(result);
	  };
	
	  return {
	    beforeCapture: beforeCapture,
	    beforeStart: beforeStart,
	    start: start,
	    update: update,
	    flush: flush,
	    drop: drop,
	    abort: abort
	  };
	});
	
	var responders = (function (getResponders, announce) {
	  var publisher = getPublisher(getResponders, announce);
	  return function (store) {
	    return function (next) {
	      return function (action) {
	        if (action.type === 'BEFORE_INITIAL_CAPTURE') {
	          publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
	          return;
	        }
	
	        if (action.type === 'INITIAL_PUBLISH') {
	          var critical = action.payload.critical;
	          publisher.beforeStart(critical, action.payload.movementMode);
	          next(action);
	          publisher.start(critical, action.payload.movementMode);
	          return;
	        }
	
	        if (action.type === 'DROP_COMPLETE') {
	          var result = action.payload.completed.result;
	          publisher.flush();
	          next(action);
	          publisher.drop(result);
	          return;
	        }
	
	        next(action);
	
	        if (action.type === 'FLUSH') {
	          publisher.abort();
	          return;
	        }
	
	        var state = store.getState();
	
	        if (state.phase === 'DRAGGING') {
	          publisher.update(state.critical, state.impact);
	        }
	      };
	    };
	  };
	});
	
	var dropAnimationFinish = (function (store) {
	  return function (next) {
	    return function (action) {
	      if (action.type !== 'DROP_ANIMATION_FINISHED') {
	        next(action);
	        return;
	      }
	
	      var state = store.getState();
	      !(state.phase === 'DROP_ANIMATING') ?  false ? invariant(false, 'Cannot finish a drop animating when no drop is occurring') : invariant(false) : void 0;
	      store.dispatch(completeDrop({
	        completed: state.completed
	      }));
	    };
	  };
	});
	
	var dropAnimationFlushOnScroll = (function (store) {
	  var unbind = null;
	  var frameId = null;
	
	  function clear() {
	    if (frameId) {
	      cancelAnimationFrame(frameId);
	      frameId = null;
	    }
	
	    if (unbind) {
	      unbind();
	      unbind = null;
	    }
	  }
	
	  return function (next) {
	    return function (action) {
	      if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') {
	        clear();
	      }
	
	      next(action);
	
	      if (action.type !== 'DROP_ANIMATE') {
	        return;
	      }
	
	      var binding = {
	        eventName: 'scroll',
	        options: {
	          capture: true,
	          passive: false,
	          once: true
	        },
	        fn: function flushDropAnimation() {
	          var state = store.getState();
	
	          if (state.phase === 'DROP_ANIMATING') {
	            store.dispatch(dropAnimationFinished());
	          }
	        }
	      };
	      frameId = requestAnimationFrame(function () {
	        frameId = null;
	        unbind = bindEvents(window, [binding]);
	      });
	    };
	  };
	});
	
	var dimensionMarshalStopper = (function (marshal) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') {
	          marshal.stopPublishing();
	        }
	
	        next(action);
	      };
	    };
	  };
	});
	
	var focus = (function (marshal) {
	  var isWatching = false;
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type === 'INITIAL_PUBLISH') {
	          isWatching = true;
	          marshal.tryRecordFocus(action.payload.critical.draggable.id);
	          next(action);
	          marshal.tryRestoreFocusRecorded();
	          return;
	        }
	
	        next(action);
	
	        if (!isWatching) {
	          return;
	        }
	
	        if (action.type === 'FLUSH') {
	          isWatching = false;
	          marshal.tryRestoreFocusRecorded();
	          return;
	        }
	
	        if (action.type === 'DROP_COMPLETE') {
	          isWatching = false;
	          var result = action.payload.completed.result;
	
	          if (result.combine) {
	            marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
	          }
	
	          marshal.tryRestoreFocusRecorded();
	        }
	      };
	    };
	  };
	});
	
	var shouldStop = function shouldStop(action) {
	  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
	};
	
	var autoScroll = (function (autoScroller) {
	  return function (store) {
	    return function (next) {
	      return function (action) {
	        if (shouldStop(action)) {
	          autoScroller.stop();
	          next(action);
	          return;
	        }
	
	        if (action.type === 'INITIAL_PUBLISH') {
	          next(action);
	          var state = store.getState();
	          !(state.phase === 'DRAGGING') ?  false ? invariant(false, 'Expected phase to be DRAGGING after INITIAL_PUBLISH') : invariant(false) : void 0;
	          autoScroller.start(state);
	          return;
	        }
	
	        next(action);
	        autoScroller.scroll(store.getState());
	      };
	    };
	  };
	});
	
	var pendingDrop = (function (store) {
	  return function (next) {
	    return function (action) {
	      next(action);
	
	      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
	        return;
	      }
	
	      var postActionState = store.getState();
	
	      if (postActionState.phase !== 'DROP_PENDING') {
	        return;
	      }
	
	      if (postActionState.isWaiting) {
	        return;
	      }
	
	      store.dispatch(drop({
	        reason: postActionState.reason
	      }));
	    };
	  };
	});
	
	var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
	  name: 'react-beautiful-dnd'
	}) : redux.compose;
	var createStore = (function (_ref) {
	  var dimensionMarshal = _ref.dimensionMarshal,
	      focusMarshal = _ref.focusMarshal,
	      styleMarshal = _ref.styleMarshal,
	      getResponders = _ref.getResponders,
	      announce = _ref.announce,
	      autoScroller = _ref.autoScroller;
	  return redux.createStore(reducer, composeEnhancers(redux.applyMiddleware(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop, autoScroll(autoScroller), scrollListener, focus(focusMarshal), responders(getResponders, announce))));
	});
	
	var clean$1 = function clean() {
	  return {
	    additions: {},
	    removals: {},
	    modified: {}
	  };
	};
	function createPublisher(_ref) {
	  var registry = _ref.registry,
	      callbacks = _ref.callbacks;
	  var staging = clean$1();
	  var frameId = null;
	
	  var collect = function collect() {
	    if (frameId) {
	      return;
	    }
	
	    callbacks.collectionStarting();
	    frameId = requestAnimationFrame(function () {
	      frameId = null;
	      start();
	      var _staging = staging,
	          additions = _staging.additions,
	          removals = _staging.removals,
	          modified = _staging.modified;
	      var added = Object.keys(additions).map(function (id) {
	        return registry.draggable.getById(id).getDimension(origin);
	      }).sort(function (a, b) {
	        return a.descriptor.index - b.descriptor.index;
	      });
	      var updated = Object.keys(modified).map(function (id) {
	        var entry = registry.droppable.getById(id);
	        var scroll = entry.callbacks.getScrollWhileDragging();
	        return {
	          droppableId: id,
	          scroll: scroll
	        };
	      });
	      var result = {
	        additions: added,
	        removals: Object.keys(removals),
	        modified: updated
	      };
	      staging = clean$1();
	      finish();
	      callbacks.publish(result);
	    });
	  };
	
	  var add = function add(entry) {
	    var id = entry.descriptor.id;
	    staging.additions[id] = entry;
	    staging.modified[entry.descriptor.droppableId] = true;
	
	    if (staging.removals[id]) {
	      delete staging.removals[id];
	    }
	
	    collect();
	  };
	
	  var remove = function remove(entry) {
	    var descriptor = entry.descriptor;
	    staging.removals[descriptor.id] = true;
	    staging.modified[descriptor.droppableId] = true;
	
	    if (staging.additions[descriptor.id]) {
	      delete staging.additions[descriptor.id];
	    }
	
	    collect();
	  };
	
	  var stop = function stop() {
	    if (!frameId) {
	      return;
	    }
	
	    cancelAnimationFrame(frameId);
	    frameId = null;
	    staging = clean$1();
	  };
	
	  return {
	    add: add,
	    remove: remove,
	    stop: stop
	  };
	}
	
	var getMaxScroll = (function (_ref) {
	  var scrollHeight = _ref.scrollHeight,
	      scrollWidth = _ref.scrollWidth,
	      height = _ref.height,
	      width = _ref.width;
	  var maxScroll = subtract({
	    x: scrollWidth,
	    y: scrollHeight
	  }, {
	    x: width,
	    y: height
	  });
	  var adjustedMaxScroll = {
	    x: Math.max(0, maxScroll.x),
	    y: Math.max(0, maxScroll.y)
	  };
	  return adjustedMaxScroll;
	});
	
	var getDocumentElement = (function () {
	  var doc = document.documentElement;
	  !doc ?  false ? invariant(false, 'Cannot find document.documentElement') : invariant(false) : void 0;
	  return doc;
	});
	
	var getMaxWindowScroll = (function () {
	  var doc = getDocumentElement();
	  var maxScroll = getMaxScroll({
	    scrollHeight: doc.scrollHeight,
	    scrollWidth: doc.scrollWidth,
	    width: doc.clientWidth,
	    height: doc.clientHeight
	  });
	  return maxScroll;
	});
	
	var getViewport = (function () {
	  var scroll = getWindowScroll();
	  var maxScroll = getMaxWindowScroll();
	  var top = scroll.y;
	  var left = scroll.x;
	  var doc = getDocumentElement();
	  var width = doc.clientWidth;
	  var height = doc.clientHeight;
	  var right = left + width;
	  var bottom = top + height;
	  var frame = cssBoxModel.getRect({
	    top: top,
	    left: left,
	    right: right,
	    bottom: bottom
	  });
	  var viewport = {
	    frame: frame,
	    scroll: {
	      initial: scroll,
	      current: scroll,
	      max: maxScroll,
	      diff: {
	        value: origin,
	        displacement: origin
	      }
	    }
	  };
	  return viewport;
	});
	
	var getInitialPublish = (function (_ref) {
	  var critical = _ref.critical,
	      scrollOptions = _ref.scrollOptions,
	      registry = _ref.registry;
	  start();
	  var viewport = getViewport();
	  var windowScroll = viewport.scroll.current;
	  var home = critical.droppable;
	  var droppables = registry.droppable.getAllByType(home.type).map(function (entry) {
	    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
	  });
	  var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function (entry) {
	    return entry.getDimension(windowScroll);
	  });
	  var dimensions = {
	    draggables: toDraggableMap(draggables),
	    droppables: toDroppableMap(droppables)
	  };
	  finish();
	  var result = {
	    dimensions: dimensions,
	    critical: critical,
	    viewport: viewport
	  };
	  return result;
	});
	
	function shouldPublishUpdate(registry, dragging, entry) {
	  if (entry.descriptor.id === dragging.id) {
	    return false;
	  }
	
	  if (entry.descriptor.type !== dragging.type) {
	    return false;
	  }
	
	  var home = registry.droppable.getById(entry.descriptor.droppableId);
	
	  if (home.descriptor.mode !== 'virtual') {
	     false ? warning("\n      You are attempting to add or remove a Draggable [id: " + entry.descriptor.id + "]\n      while a drag is occurring. This is only supported for virtual lists.\n\n      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md\n    ") : void 0;
	    return false;
	  }
	
	  return true;
	}
	
	var createDimensionMarshal = (function (registry, callbacks) {
	  var collection = null;
	  var publisher = createPublisher({
	    callbacks: {
	      publish: callbacks.publishWhileDragging,
	      collectionStarting: callbacks.collectionStarting
	    },
	    registry: registry
	  });
	
	  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
	    !registry.droppable.exists(id) ?  false ? invariant(false, "Cannot update is enabled flag of Droppable " + id + " as it is not registered") : invariant(false) : void 0;
	
	    if (!collection) {
	      return;
	    }
	
	    callbacks.updateDroppableIsEnabled({
	      id: id,
	      isEnabled: isEnabled
	    });
	  };
	
	  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
	    if (!collection) {
	      return;
	    }
	
	    !registry.droppable.exists(id) ?  false ? invariant(false, "Cannot update isCombineEnabled flag of Droppable " + id + " as it is not registered") : invariant(false) : void 0;
	    callbacks.updateDroppableIsCombineEnabled({
	      id: id,
	      isCombineEnabled: isCombineEnabled
	    });
	  };
	
	  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
	    if (!collection) {
	      return;
	    }
	
	    !registry.droppable.exists(id) ?  false ? invariant(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : invariant(false) : void 0;
	    callbacks.updateDroppableScroll({
	      id: id,
	      newScroll: newScroll
	    });
	  };
	
	  var scrollDroppable = function scrollDroppable(id, change) {
	    if (!collection) {
	      return;
	    }
	
	    registry.droppable.getById(id).callbacks.scroll(change);
	  };
	
	  var stopPublishing = function stopPublishing() {
	    if (!collection) {
	      return;
	    }
	
	    publisher.stop();
	    var home = collection.critical.droppable;
	    registry.droppable.getAllByType(home.type).forEach(function (entry) {
	      return entry.callbacks.dragStopped();
	    });
	    collection.unsubscribe();
	    collection = null;
	  };
	
	  var subscriber = function subscriber(event) {
	    !collection ?  false ? invariant(false, 'Should only be subscribed when a collection is occurring') : invariant(false) : void 0;
	    var dragging = collection.critical.draggable;
	
	    if (event.type === 'ADDITION') {
	      if (shouldPublishUpdate(registry, dragging, event.value)) {
	        publisher.add(event.value);
	      }
	    }
	
	    if (event.type === 'REMOVAL') {
	      if (shouldPublishUpdate(registry, dragging, event.value)) {
	        publisher.remove(event.value);
	      }
	    }
	  };
	
	  var startPublishing = function startPublishing(request) {
	    !!collection ?  false ? invariant(false, 'Cannot start capturing critical dimensions as there is already a collection') : invariant(false) : void 0;
	    var entry = registry.draggable.getById(request.draggableId);
	    var home = registry.droppable.getById(entry.descriptor.droppableId);
	    var critical = {
	      draggable: entry.descriptor,
	      droppable: home.descriptor
	    };
	    var unsubscribe = registry.subscribe(subscriber);
	    collection = {
	      critical: critical,
	      unsubscribe: unsubscribe
	    };
	    return getInitialPublish({
	      critical: critical,
	      registry: registry,
	      scrollOptions: request.scrollOptions
	    });
	  };
	
	  var marshal = {
	    updateDroppableIsEnabled: updateDroppableIsEnabled,
	    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
	    scrollDroppable: scrollDroppable,
	    updateDroppableScroll: updateDroppableScroll,
	    startPublishing: startPublishing,
	    stopPublishing: stopPublishing
	  };
	  return marshal;
	});
	
	var canStartDrag = (function (state, id) {
	  if (state.phase === 'IDLE') {
	    return true;
	  }
	
	  if (state.phase !== 'DROP_ANIMATING') {
	    return false;
	  }
	
	  if (state.completed.result.draggableId === id) {
	    return false;
	  }
	
	  return state.completed.result.reason === 'DROP';
	});
	
	var scrollWindow = (function (change) {
	  window.scrollBy(change.x, change.y);
	});
	
	var getScrollableDroppables = memoizeOne(function (droppables) {
	  return toDroppableList(droppables).filter(function (droppable) {
	    if (!droppable.isEnabled) {
	      return false;
	    }
	
	    if (!droppable.frame) {
	      return false;
	    }
	
	    return true;
	  });
	});
	
	var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
	  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
	    !droppable.frame ?  false ? invariant(false, 'Invalid result') : invariant(false) : void 0;
	    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
	  });
	  return maybe;
	};
	
	var getBestScrollableDroppable = (function (_ref) {
	  var center = _ref.center,
	      destination = _ref.destination,
	      droppables = _ref.droppables;
	
	  if (destination) {
	    var _dimension = droppables[destination];
	
	    if (!_dimension.frame) {
	      return null;
	    }
	
	    return _dimension;
	  }
	
	  var dimension = getScrollableDroppableOver(center, droppables);
	  return dimension;
	});
	
	var config = {
	  startFromPercentage: 0.25,
	  maxScrollAtPercentage: 0.05,
	  maxPixelScroll: 28,
	  ease: function ease(percentage) {
	    return Math.pow(percentage, 2);
	  },
	  durationDampening: {
	    stopDampeningAt: 1200,
	    accelerateAt: 360
	  }
	};
	
	var getDistanceThresholds = (function (container, axis) {
	  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
	  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
	  var thresholds = {
	    startScrollingFrom: startScrollingFrom,
	    maxScrollValueAt: maxScrollValueAt
	  };
	  return thresholds;
	});
	
	var getPercentage = (function (_ref) {
	  var startOfRange = _ref.startOfRange,
	      endOfRange = _ref.endOfRange,
	      current = _ref.current;
	  var range = endOfRange - startOfRange;
	
	  if (range === 0) {
	     false ? warning("\n      Detected distance range of 0 in the fluid auto scroller\n      This is unexpected and would cause a divide by 0 issue.\n      Not allowing an auto scroll\n    ") : void 0;
	    return 0;
	  }
	
	  var currentInRange = current - startOfRange;
	  var percentage = currentInRange / range;
	  return percentage;
	});
	
	var minScroll = 1;
	
	var getValueFromDistance = (function (distanceToEdge, thresholds) {
	  if (distanceToEdge > thresholds.startScrollingFrom) {
	    return 0;
	  }
	
	  if (distanceToEdge <= thresholds.maxScrollValueAt) {
	    return config.maxPixelScroll;
	  }
	
	  if (distanceToEdge === thresholds.startScrollingFrom) {
	    return minScroll;
	  }
	
	  var percentageFromMaxScrollValueAt = getPercentage({
	    startOfRange: thresholds.maxScrollValueAt,
	    endOfRange: thresholds.startScrollingFrom,
	    current: distanceToEdge
	  });
	  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
	  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
	  return Math.ceil(scroll);
	});
	
	var accelerateAt = config.durationDampening.accelerateAt;
	var stopAt = config.durationDampening.stopDampeningAt;
	var dampenValueByTime = (function (proposedScroll, dragStartTime) {
	  var startOfRange = dragStartTime;
	  var endOfRange = stopAt;
	  var now = Date.now();
	  var runTime = now - startOfRange;
	
	  if (runTime >= stopAt) {
	    return proposedScroll;
	  }
	
	  if (runTime < accelerateAt) {
	    return minScroll;
	  }
	
	  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
	    startOfRange: accelerateAt,
	    endOfRange: endOfRange,
	    current: runTime
	  });
	  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
	  return Math.ceil(scroll);
	});
	
	var getValue = (function (_ref) {
	  var distanceToEdge = _ref.distanceToEdge,
	      thresholds = _ref.thresholds,
	      dragStartTime = _ref.dragStartTime,
	      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
	  var scroll = getValueFromDistance(distanceToEdge, thresholds);
	
	  if (scroll === 0) {
	    return 0;
	  }
	
	  if (!shouldUseTimeDampening) {
	    return scroll;
	  }
	
	  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
	});
	
	var getScrollOnAxis = (function (_ref) {
	  var container = _ref.container,
	      distanceToEdges = _ref.distanceToEdges,
	      dragStartTime = _ref.dragStartTime,
	      axis = _ref.axis,
	      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
	  var thresholds = getDistanceThresholds(container, axis);
	  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
	
	  if (isCloserToEnd) {
	    return getValue({
	      distanceToEdge: distanceToEdges[axis.end],
	      thresholds: thresholds,
	      dragStartTime: dragStartTime,
	      shouldUseTimeDampening: shouldUseTimeDampening
	    });
	  }
	
	  return -1 * getValue({
	    distanceToEdge: distanceToEdges[axis.start],
	    thresholds: thresholds,
	    dragStartTime: dragStartTime,
	    shouldUseTimeDampening: shouldUseTimeDampening
	  });
	});
	
	var adjustForSizeLimits = (function (_ref) {
	  var container = _ref.container,
	      subject = _ref.subject,
	      proposedScroll = _ref.proposedScroll;
	  var isTooBigVertically = subject.height > container.height;
	  var isTooBigHorizontally = subject.width > container.width;
	
	  if (!isTooBigHorizontally && !isTooBigVertically) {
	    return proposedScroll;
	  }
	
	  if (isTooBigHorizontally && isTooBigVertically) {
	    return null;
	  }
	
	  return {
	    x: isTooBigHorizontally ? 0 : proposedScroll.x,
	    y: isTooBigVertically ? 0 : proposedScroll.y
	  };
	});
	
	var clean$2 = apply(function (value) {
	  return value === 0 ? 0 : value;
	});
	var getScroll = (function (_ref) {
	  var dragStartTime = _ref.dragStartTime,
	      container = _ref.container,
	      subject = _ref.subject,
	      center = _ref.center,
	      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
	  var distanceToEdges = {
	    top: center.y - container.top,
	    right: container.right - center.x,
	    bottom: container.bottom - center.y,
	    left: center.x - container.left
	  };
	  var y = getScrollOnAxis({
	    container: container,
	    distanceToEdges: distanceToEdges,
	    dragStartTime: dragStartTime,
	    axis: vertical,
	    shouldUseTimeDampening: shouldUseTimeDampening
	  });
	  var x = getScrollOnAxis({
	    container: container,
	    distanceToEdges: distanceToEdges,
	    dragStartTime: dragStartTime,
	    axis: horizontal,
	    shouldUseTimeDampening: shouldUseTimeDampening
	  });
	  var required = clean$2({
	    x: x,
	    y: y
	  });
	
	  if (isEqual(required, origin)) {
	    return null;
	  }
	
	  var limited = adjustForSizeLimits({
	    container: container,
	    subject: subject,
	    proposedScroll: required
	  });
	
	  if (!limited) {
	    return null;
	  }
	
	  return isEqual(limited, origin) ? null : limited;
	});
	
	var smallestSigned = apply(function (value) {
	  if (value === 0) {
	    return 0;
	  }
	
	  return value > 0 ? 1 : -1;
	});
	var getOverlap = function () {
	  var getRemainder = function getRemainder(target, max) {
	    if (target < 0) {
	      return target;
	    }
	
	    if (target > max) {
	      return target - max;
	    }
	
	    return 0;
	  };
	
	  return function (_ref) {
	    var current = _ref.current,
	        max = _ref.max,
	        change = _ref.change;
	    var targetScroll = add(current, change);
	    var overlap = {
	      x: getRemainder(targetScroll.x, max.x),
	      y: getRemainder(targetScroll.y, max.y)
	    };
	
	    if (isEqual(overlap, origin)) {
	      return null;
	    }
	
	    return overlap;
	  };
	}();
	var canPartiallyScroll = function canPartiallyScroll(_ref2) {
	  var rawMax = _ref2.max,
	      current = _ref2.current,
	      change = _ref2.change;
	  var max = {
	    x: Math.max(current.x, rawMax.x),
	    y: Math.max(current.y, rawMax.y)
	  };
	  var smallestChange = smallestSigned(change);
	  var overlap = getOverlap({
	    max: max,
	    current: current,
	    change: smallestChange
	  });
	
	  if (!overlap) {
	    return true;
	  }
	
	  if (smallestChange.x !== 0 && overlap.x === 0) {
	    return true;
	  }
	
	  if (smallestChange.y !== 0 && overlap.y === 0) {
	    return true;
	  }
	
	  return false;
	};
	var canScrollWindow = function canScrollWindow(viewport, change) {
	  return canPartiallyScroll({
	    current: viewport.scroll.current,
	    max: viewport.scroll.max,
	    change: change
	  });
	};
	var getWindowOverlap = function getWindowOverlap(viewport, change) {
	  if (!canScrollWindow(viewport, change)) {
	    return null;
	  }
	
	  var max = viewport.scroll.max;
	  var current = viewport.scroll.current;
	  return getOverlap({
	    current: current,
	    max: max,
	    change: change
	  });
	};
	var canScrollDroppable = function canScrollDroppable(droppable, change) {
	  var frame = droppable.frame;
	
	  if (!frame) {
	    return false;
	  }
	
	  return canPartiallyScroll({
	    current: frame.scroll.current,
	    max: frame.scroll.max,
	    change: change
	  });
	};
	var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
	  var frame = droppable.frame;
	
	  if (!frame) {
	    return null;
	  }
	
	  if (!canScrollDroppable(droppable, change)) {
	    return null;
	  }
	
	  return getOverlap({
	    current: frame.scroll.current,
	    max: frame.scroll.max,
	    change: change
	  });
	};
	
	var getWindowScrollChange = (function (_ref) {
	  var viewport = _ref.viewport,
	      subject = _ref.subject,
	      center = _ref.center,
	      dragStartTime = _ref.dragStartTime,
	      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
	  var scroll = getScroll({
	    dragStartTime: dragStartTime,
	    container: viewport.frame,
	    subject: subject,
	    center: center,
	    shouldUseTimeDampening: shouldUseTimeDampening
	  });
	  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
	});
	
	var getDroppableScrollChange = (function (_ref) {
	  var droppable = _ref.droppable,
	      subject = _ref.subject,
	      center = _ref.center,
	      dragStartTime = _ref.dragStartTime,
	      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
	  var frame = droppable.frame;
	
	  if (!frame) {
	    return null;
	  }
	
	  var scroll = getScroll({
	    dragStartTime: dragStartTime,
	    container: frame.pageMarginBox,
	    subject: subject,
	    center: center,
	    shouldUseTimeDampening: shouldUseTimeDampening
	  });
	  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
	});
	
	var scroll$1 = (function (_ref) {
	  var state = _ref.state,
	      dragStartTime = _ref.dragStartTime,
	      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
	      scrollWindow = _ref.scrollWindow,
	      scrollDroppable = _ref.scrollDroppable;
	  var center = state.current.page.borderBoxCenter;
	  var draggable = state.dimensions.draggables[state.critical.draggable.id];
	  var subject = draggable.page.marginBox;
	
	  if (state.isWindowScrollAllowed) {
	    var viewport = state.viewport;
	
	    var _change = getWindowScrollChange({
	      dragStartTime: dragStartTime,
	      viewport: viewport,
	      subject: subject,
	      center: center,
	      shouldUseTimeDampening: shouldUseTimeDampening
	    });
	
	    if (_change) {
	      scrollWindow(_change);
	      return;
	    }
	  }
	
	  var droppable = getBestScrollableDroppable({
	    center: center,
	    destination: whatIsDraggedOver(state.impact),
	    droppables: state.dimensions.droppables
	  });
	
	  if (!droppable) {
	    return;
	  }
	
	  var change = getDroppableScrollChange({
	    dragStartTime: dragStartTime,
	    droppable: droppable,
	    subject: subject,
	    center: center,
	    shouldUseTimeDampening: shouldUseTimeDampening
	  });
	
	  if (change) {
	    scrollDroppable(droppable.descriptor.id, change);
	  }
	});
	
	var createFluidScroller = (function (_ref) {
	  var scrollWindow = _ref.scrollWindow,
	      scrollDroppable = _ref.scrollDroppable;
	  var scheduleWindowScroll = rafSchd(scrollWindow);
	  var scheduleDroppableScroll = rafSchd(scrollDroppable);
	  var dragging = null;
	
	  var tryScroll = function tryScroll(state) {
	    !dragging ?  false ? invariant(false, 'Cannot fluid scroll if not dragging') : invariant(false) : void 0;
	    var _dragging = dragging,
	        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
	        dragStartTime = _dragging.dragStartTime;
	    scroll$1({
	      state: state,
	      scrollWindow: scheduleWindowScroll,
	      scrollDroppable: scheduleDroppableScroll,
	      dragStartTime: dragStartTime,
	      shouldUseTimeDampening: shouldUseTimeDampening
	    });
	  };
	
	  var start$1 = function start$1(state) {
	    start();
	    !!dragging ?  false ? invariant(false, 'Cannot start auto scrolling when already started') : invariant(false) : void 0;
	    var dragStartTime = Date.now();
	    var wasScrollNeeded = false;
	
	    var fakeScrollCallback = function fakeScrollCallback() {
	      wasScrollNeeded = true;
	    };
	
	    scroll$1({
	      state: state,
	      dragStartTime: 0,
	      shouldUseTimeDampening: false,
	      scrollWindow: fakeScrollCallback,
	      scrollDroppable: fakeScrollCallback
	    });
	    dragging = {
	      dragStartTime: dragStartTime,
	      shouldUseTimeDampening: wasScrollNeeded
	    };
	    finish();
	
	    if (wasScrollNeeded) {
	      tryScroll(state);
	    }
	  };
	
	  var stop = function stop() {
	    if (!dragging) {
	      return;
	    }
	
	    scheduleWindowScroll.cancel();
	    scheduleDroppableScroll.cancel();
	    dragging = null;
	  };
	
	  return {
	    start: start$1,
	    stop: stop,
	    scroll: tryScroll
	  };
	});
	
	var createJumpScroller = (function (_ref) {
	  var move = _ref.move,
	      scrollDroppable = _ref.scrollDroppable,
	      scrollWindow = _ref.scrollWindow;
	
	  var moveByOffset = function moveByOffset(state, offset) {
	    var client = add(state.current.client.selection, offset);
	    move({
	      client: client
	    });
	  };
	
	  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
	    if (!canScrollDroppable(droppable, change)) {
	      return change;
	    }
	
	    var overlap = getDroppableOverlap(droppable, change);
	
	    if (!overlap) {
	      scrollDroppable(droppable.descriptor.id, change);
	      return null;
	    }
	
	    var whatTheDroppableCanScroll = subtract(change, overlap);
	    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
	    var remainder = subtract(change, whatTheDroppableCanScroll);
	    return remainder;
	  };
	
	  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
	    if (!isWindowScrollAllowed) {
	      return change;
	    }
	
	    if (!canScrollWindow(viewport, change)) {
	      return change;
	    }
	
	    var overlap = getWindowOverlap(viewport, change);
	
	    if (!overlap) {
	      scrollWindow(change);
	      return null;
	    }
	
	    var whatTheWindowCanScroll = subtract(change, overlap);
	    scrollWindow(whatTheWindowCanScroll);
	    var remainder = subtract(change, whatTheWindowCanScroll);
	    return remainder;
	  };
	
	  var jumpScroller = function jumpScroller(state) {
	    var request = state.scrollJumpRequest;
	
	    if (!request) {
	      return;
	    }
	
	    var destination = whatIsDraggedOver(state.impact);
	    !destination ?  false ? invariant(false, 'Cannot perform a jump scroll when there is no destination') : invariant(false) : void 0;
	    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
	
	    if (!droppableRemainder) {
	      return;
	    }
	
	    var viewport = state.viewport;
	    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
	
	    if (!windowRemainder) {
	      return;
	    }
	
	    moveByOffset(state, windowRemainder);
	  };
	
	  return jumpScroller;
	});
	
	var createAutoScroller = (function (_ref) {
	  var scrollDroppable = _ref.scrollDroppable,
	      scrollWindow = _ref.scrollWindow,
	      move = _ref.move;
	  var fluidScroller = createFluidScroller({
	    scrollWindow: scrollWindow,
	    scrollDroppable: scrollDroppable
	  });
	  var jumpScroll = createJumpScroller({
	    move: move,
	    scrollWindow: scrollWindow,
	    scrollDroppable: scrollDroppable
	  });
	
	  var scroll = function scroll(state) {
	    if (state.phase !== 'DRAGGING') {
	      return;
	    }
	
	    if (state.movementMode === 'FLUID') {
	      fluidScroller.scroll(state);
	      return;
	    }
	
	    if (!state.scrollJumpRequest) {
	      return;
	    }
	
	    jumpScroll(state);
	  };
	
	  var scroller = {
	    scroll: scroll,
	    start: fluidScroller.start,
	    stop: fluidScroller.stop
	  };
	  return scroller;
	});
	
	var prefix$1 = 'data-rbd';
	var dragHandle = function () {
	  var base = prefix$1 + "-drag-handle";
	  return {
	    base: base,
	    draggableId: base + "-draggable-id",
	    contextId: base + "-context-id"
	  };
	}();
	var draggable = function () {
	  var base = prefix$1 + "-draggable";
	  return {
	    base: base,
	    contextId: base + "-context-id",
	    id: base + "-id"
	  };
	}();
	var droppable = function () {
	  var base = prefix$1 + "-droppable";
	  return {
	    base: base,
	    contextId: base + "-context-id",
	    id: base + "-id"
	  };
	}();
	var scrollContainer = {
	  contextId: prefix$1 + "-scroll-container-context-id"
	};
	
	var makeGetSelector = function makeGetSelector(context) {
	  return function (attribute) {
	    return "[" + attribute + "=\"" + context + "\"]";
	  };
	};
	
	var getStyles = function getStyles(rules, property) {
	  return rules.map(function (rule) {
	    var value = rule.styles[property];
	
	    if (!value) {
	      return '';
	    }
	
	    return rule.selector + " { " + value + " }";
	  }).join(' ');
	};
	
	var noPointerEvents = 'pointer-events: none;';
	var getStyles$1 = (function (contextId) {
	  var getSelector = makeGetSelector(contextId);
	
	  var dragHandle$1 = function () {
	    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
	    return {
	      selector: getSelector(dragHandle.contextId),
	      styles: {
	        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
	        resting: grabCursor,
	        dragging: noPointerEvents,
	        dropAnimating: grabCursor
	      }
	    };
	  }();
	
	  var draggable$1 = function () {
	    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
	    return {
	      selector: getSelector(draggable.contextId),
	      styles: {
	        dragging: transition,
	        dropAnimating: transition,
	        userCancel: transition
	      }
	    };
	  }();
	
	  var droppable$1 = {
	    selector: getSelector(droppable.contextId),
	    styles: {
	      always: "overflow-anchor: none;"
	    }
	  };
	  var body = {
	    selector: 'body',
	    styles: {
	      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
	    }
	  };
	  var rules = [draggable$1, dragHandle$1, droppable$1, body];
	  return {
	    always: getStyles(rules, 'always'),
	    resting: getStyles(rules, 'resting'),
	    dragging: getStyles(rules, 'dragging'),
	    dropAnimating: getStyles(rules, 'dropAnimating'),
	    userCancel: getStyles(rules, 'userCancel')
	  };
	});
	
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	
	var getHead = function getHead() {
	  var head = document.querySelector('head');
	  !head ?  false ? invariant(false, 'Cannot find the head to append a style to') : invariant(false) : void 0;
	  return head;
	};
	
	var createStyleEl = function createStyleEl(nonce) {
	  var el = document.createElement('style');
	
	  if (nonce) {
	    el.setAttribute('nonce', nonce);
	  }
	
	  el.type = 'text/css';
	  return el;
	};
	
	function useStyleMarshal(contextId, nonce) {
	  var styles = useMemoOne.useMemo(function () {
	    return getStyles$1(contextId);
	  }, [contextId]);
	  var alwaysRef = React.useRef(null);
	  var dynamicRef = React.useRef(null);
	  var setDynamicStyle = useMemoOne.useCallback(memoizeOne(function (proposed) {
	    var el = dynamicRef.current;
	    !el ?  false ? invariant(false, 'Cannot set dynamic style element if it is not set') : invariant(false) : void 0;
	    el.textContent = proposed;
	  }), []);
	  var setAlwaysStyle = useMemoOne.useCallback(function (proposed) {
	    var el = alwaysRef.current;
	    !el ?  false ? invariant(false, 'Cannot set dynamic style element if it is not set') : invariant(false) : void 0;
	    el.textContent = proposed;
	  }, []);
	  useIsomorphicLayoutEffect(function () {
	    !(!alwaysRef.current && !dynamicRef.current) ?  false ? invariant(false, 'style elements already mounted') : invariant(false) : void 0;
	    var always = createStyleEl(nonce);
	    var dynamic = createStyleEl(nonce);
	    alwaysRef.current = always;
	    dynamicRef.current = dynamic;
	    always.setAttribute(prefix$1 + "-always", contextId);
	    dynamic.setAttribute(prefix$1 + "-dynamic", contextId);
	    getHead().appendChild(always);
	    getHead().appendChild(dynamic);
	    setAlwaysStyle(styles.always);
	    setDynamicStyle(styles.resting);
	    return function () {
	      var remove = function remove(ref) {
	        var current = ref.current;
	        !current ?  false ? invariant(false, 'Cannot unmount ref as it is not set') : invariant(false) : void 0;
	        getHead().removeChild(current);
	        ref.current = null;
	      };
	
	      remove(alwaysRef);
	      remove(dynamicRef);
	    };
	  }, [nonce, setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, contextId]);
	  var dragging = useMemoOne.useCallback(function () {
	    return setDynamicStyle(styles.dragging);
	  }, [setDynamicStyle, styles.dragging]);
	  var dropping = useMemoOne.useCallback(function (reason) {
	    if (reason === 'DROP') {
	      setDynamicStyle(styles.dropAnimating);
	      return;
	    }
	
	    setDynamicStyle(styles.userCancel);
	  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
	  var resting = useMemoOne.useCallback(function () {
	    if (!dynamicRef.current) {
	      return;
	    }
	
	    setDynamicStyle(styles.resting);
	  }, [setDynamicStyle, styles.resting]);
	  var marshal = useMemoOne.useMemo(function () {
	    return {
	      dragging: dragging,
	      dropping: dropping,
	      resting: resting
	    };
	  }, [dragging, dropping, resting]);
	  return marshal;
	}
	
	var getWindowFromEl = (function (el) {
	  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
	});
	
	function isHtmlElement(el) {
	  return el instanceof getWindowFromEl(el).HTMLElement;
	}
	
	function findDragHandle(contextId, draggableId) {
	  var selector = "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
	  var possible = toArray(document.querySelectorAll(selector));
	
	  if (!possible.length) {
	     false ? warning("Unable to find any drag handles in the context \"" + contextId + "\"") : void 0;
	    return null;
	  }
	
	  var handle = find(possible, function (el) {
	    return el.getAttribute(dragHandle.draggableId) === draggableId;
	  });
	
	  if (!handle) {
	     false ? warning("Unable to find drag handle with id \"" + draggableId + "\" as no handle with a matching id was found") : void 0;
	    return null;
	  }
	
	  if (!isHtmlElement(handle)) {
	     false ? warning('drag handle needs to be a HTMLElement') : void 0;
	    return null;
	  }
	
	  return handle;
	}
	
	function useFocusMarshal(contextId) {
	  var entriesRef = React.useRef({});
	  var recordRef = React.useRef(null);
	  var restoreFocusFrameRef = React.useRef(null);
	  var isMountedRef = React.useRef(false);
	  var register = useMemoOne.useCallback(function register(id, focus) {
	    var entry = {
	      id: id,
	      focus: focus
	    };
	    entriesRef.current[id] = entry;
	    return function unregister() {
	      var entries = entriesRef.current;
	      var current = entries[id];
	
	      if (current !== entry) {
	        delete entries[id];
	      }
	    };
	  }, []);
	  var tryGiveFocus = useMemoOne.useCallback(function tryGiveFocus(tryGiveFocusTo) {
	    var handle = findDragHandle(contextId, tryGiveFocusTo);
	
	    if (handle && handle !== document.activeElement) {
	      handle.focus();
	    }
	  }, [contextId]);
	  var tryShiftRecord = useMemoOne.useCallback(function tryShiftRecord(previous, redirectTo) {
	    if (recordRef.current === previous) {
	      recordRef.current = redirectTo;
	    }
	  }, []);
	  var tryRestoreFocusRecorded = useMemoOne.useCallback(function tryRestoreFocusRecorded() {
	    if (restoreFocusFrameRef.current) {
	      return;
	    }
	
	    if (!isMountedRef.current) {
	      return;
	    }
	
	    restoreFocusFrameRef.current = requestAnimationFrame(function () {
	      restoreFocusFrameRef.current = null;
	      var record = recordRef.current;
	
	      if (record) {
	        tryGiveFocus(record);
	      }
	    });
	  }, [tryGiveFocus]);
	  var tryRecordFocus = useMemoOne.useCallback(function tryRecordFocus(id) {
	    recordRef.current = null;
	    var focused = document.activeElement;
	
	    if (!focused) {
	      return;
	    }
	
	    if (focused.getAttribute(dragHandle.draggableId) !== id) {
	      return;
	    }
	
	    recordRef.current = id;
	  }, []);
	  useIsomorphicLayoutEffect(function () {
	    isMountedRef.current = true;
	    return function clearFrameOnUnmount() {
	      isMountedRef.current = false;
	      var frameId = restoreFocusFrameRef.current;
	
	      if (frameId) {
	        cancelAnimationFrame(frameId);
	      }
	    };
	  }, []);
	  var marshal = useMemoOne.useMemo(function () {
	    return {
	      register: register,
	      tryRecordFocus: tryRecordFocus,
	      tryRestoreFocusRecorded: tryRestoreFocusRecorded,
	      tryShiftRecord: tryShiftRecord
	    };
	  }, [register, tryRecordFocus, tryRestoreFocusRecorded, tryShiftRecord]);
	  return marshal;
	}
	
	function createRegistry() {
	  var entries = {
	    draggables: {},
	    droppables: {}
	  };
	  var subscribers = [];
	
	  function subscribe(cb) {
	    subscribers.push(cb);
	    return function unsubscribe() {
	      var index = subscribers.indexOf(cb);
	
	      if (index === -1) {
	        return;
	      }
	
	      subscribers.splice(index, 1);
	    };
	  }
	
	  function notify(event) {
	    if (subscribers.length) {
	      subscribers.forEach(function (cb) {
	        return cb(event);
	      });
	    }
	  }
	
	  function findDraggableById(id) {
	    return entries.draggables[id] || null;
	  }
	
	  function getDraggableById(id) {
	    var entry = findDraggableById(id);
	    !entry ?  false ? invariant(false, "Cannot find draggable entry with id [" + id + "]") : invariant(false) : void 0;
	    return entry;
	  }
	
	  var draggableAPI = {
	    register: function register(entry) {
	      entries.draggables[entry.descriptor.id] = entry;
	      notify({
	        type: 'ADDITION',
	        value: entry
	      });
	    },
	    update: function update(entry, last) {
	      var current = entries.draggables[last.descriptor.id];
	
	      if (!current) {
	        return;
	      }
	
	      if (current.uniqueId !== entry.uniqueId) {
	        return;
	      }
	
	      delete entries.draggables[last.descriptor.id];
	      entries.draggables[entry.descriptor.id] = entry;
	    },
	    unregister: function unregister(entry) {
	      var draggableId = entry.descriptor.id;
	      var current = findDraggableById(draggableId);
	
	      if (!current) {
	        return;
	      }
	
	      if (entry.uniqueId !== current.uniqueId) {
	        return;
	      }
	
	      delete entries.draggables[draggableId];
	      notify({
	        type: 'REMOVAL',
	        value: entry
	      });
	    },
	    getById: getDraggableById,
	    findById: findDraggableById,
	    exists: function exists(id) {
	      return Boolean(findDraggableById(id));
	    },
	    getAllByType: function getAllByType(type) {
	      return values(entries.draggables).filter(function (entry) {
	        return entry.descriptor.type === type;
	      });
	    }
	  };
	
	  function findDroppableById(id) {
	    return entries.droppables[id] || null;
	  }
	
	  function getDroppableById(id) {
	    var entry = findDroppableById(id);
	    !entry ?  false ? invariant(false, "Cannot find droppable entry with id [" + id + "]") : invariant(false) : void 0;
	    return entry;
	  }
	
	  var droppableAPI = {
	    register: function register(entry) {
	      entries.droppables[entry.descriptor.id] = entry;
	    },
	    unregister: function unregister(entry) {
	      var current = findDroppableById(entry.descriptor.id);
	
	      if (!current) {
	        return;
	      }
	
	      if (entry.uniqueId !== current.uniqueId) {
	        return;
	      }
	
	      delete entries.droppables[entry.descriptor.id];
	    },
	    getById: getDroppableById,
	    findById: findDroppableById,
	    exists: function exists(id) {
	      return Boolean(findDroppableById(id));
	    },
	    getAllByType: function getAllByType(type) {
	      return values(entries.droppables).filter(function (entry) {
	        return entry.descriptor.type === type;
	      });
	    }
	  };
	
	  function clean() {
	    entries.draggables = {};
	    entries.droppables = {};
	    subscribers.length = 0;
	  }
	
	  return {
	    draggable: draggableAPI,
	    droppable: droppableAPI,
	    subscribe: subscribe,
	    clean: clean
	  };
	}
	
	function useRegistry() {
	  var registry = useMemoOne.useMemo(createRegistry, []);
	  React.useEffect(function () {
	    return function unmount() {
	      requestAnimationFrame(registry.clean);
	    };
	  }, [registry]);
	  return registry;
	}
	
	var StoreContext = React__default.createContext(null);
	
	var getBodyElement = (function () {
	  var body = document.body;
	  !body ?  false ? invariant(false, 'Cannot find document.body') : invariant(false) : void 0;
	  return body;
	});
	
	var visuallyHidden = {
	  position: 'absolute',
	  width: '1px',
	  height: '1px',
	  margin: '-1px',
	  border: '0',
	  padding: '0',
	  overflow: 'hidden',
	  clip: 'rect(0 0 0 0)',
	  'clip-path': 'inset(100%)'
	};
	
	var getId = function getId(contextId) {
	  return "rbd-announcement-" + contextId;
	};
	function useAnnouncer(contextId) {
	  var id = useMemoOne.useMemo(function () {
	    return getId(contextId);
	  }, [contextId]);
	  var ref = React.useRef(null);
	  React.useEffect(function setup() {
	    var el = document.createElement('div');
	    ref.current = el;
	    el.id = id;
	    el.setAttribute('aria-live', 'assertive');
	    el.setAttribute('aria-atomic', 'true');
	
	    _extends(el.style, visuallyHidden);
	
	    getBodyElement().appendChild(el);
	    return function cleanup() {
	      setTimeout(function remove() {
	        var body = getBodyElement();
	
	        if (body.contains(el)) {
	          body.removeChild(el);
	        }
	
	        if (el === ref.current) {
	          ref.current = null;
	        }
	      });
	    };
	  }, [id]);
	  var announce = useMemoOne.useCallback(function (message) {
	    var el = ref.current;
	
	    if (el) {
	      el.textContent = message;
	      return;
	    }
	
	     false ? warning("\n      A screen reader message was trying to be announced but it was unable to do so.\n      This can occur if you unmount your <DragDropContext /> in your onDragEnd.\n      Consider calling provided.announce() before the unmount so that the instruction will\n      not be lost for users relying on a screen reader.\n\n      Message not passed to screen reader:\n\n      \"" + message + "\"\n    ") : void 0;
	  }, []);
	  return announce;
	}
	
	var count = 0;
	var defaults = {
	  separator: '::'
	};
	function reset() {
	  count = 0;
	}
	function useUniqueId(prefix, options) {
	  if (options === void 0) {
	    options = defaults;
	  }
	
	  return useMemoOne.useMemo(function () {
	    return "" + prefix + options.separator + count++;
	  }, [options.separator, prefix]);
	}
	
	function getElementId(_ref) {
	  var contextId = _ref.contextId,
	      uniqueId = _ref.uniqueId;
	  return "rbd-hidden-text-" + contextId + "-" + uniqueId;
	}
	function useHiddenTextElement(_ref2) {
	  var contextId = _ref2.contextId,
	      text = _ref2.text;
	  var uniqueId = useUniqueId('hidden-text', {
	    separator: '-'
	  });
	  var id = useMemoOne.useMemo(function () {
	    return getElementId({
	      contextId: contextId,
	      uniqueId: uniqueId
	    });
	  }, [uniqueId, contextId]);
	  React.useEffect(function mount() {
	    var el = document.createElement('div');
	    el.id = id;
	    el.textContent = text;
	    el.style.display = 'none';
	    getBodyElement().appendChild(el);
	    return function unmount() {
	      var body = getBodyElement();
	
	      if (body.contains(el)) {
	        body.removeChild(el);
	      }
	    };
	  }, [id, text]);
	  return id;
	}
	
	var AppContext = React__default.createContext(null);
	
	var peerDependencies = {
		react: "^16.8.5 || ^17.0.0 || ^18.0.0",
		"react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
	};
	
	var semver = /(\d+)\.(\d+)\.(\d+)/;
	
	var getVersion = function getVersion(value) {
	  var result = semver.exec(value);
	  !(result != null) ?  false ? invariant(false, "Unable to parse React version " + value) : invariant(false) : void 0;
	  var major = Number(result[1]);
	  var minor = Number(result[2]);
	  var patch = Number(result[3]);
	  return {
	    major: major,
	    minor: minor,
	    patch: patch,
	    raw: value
	  };
	};
	
	var isSatisfied = function isSatisfied(expected, actual) {
	  if (actual.major > expected.major) {
	    return true;
	  }
	
	  if (actual.major < expected.major) {
	    return false;
	  }
	
	  if (actual.minor > expected.minor) {
	    return true;
	  }
	
	  if (actual.minor < expected.minor) {
	    return false;
	  }
	
	  return actual.patch >= expected.patch;
	};
	
	var checkReactVersion = (function (peerDepValue, actualValue) {
	  var peerDep = getVersion(peerDepValue);
	  var actual = getVersion(actualValue);
	
	  if (isSatisfied(peerDep, actual)) {
	    return;
	  }
	
	   false ? warning("\n    React version: [" + actual.raw + "]\n    does not satisfy expected peer dependency version: [" + peerDep.raw + "]\n\n    This can result in run time bugs, and even fatal crashes\n  ") : void 0;
	});
	
	var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
	var checkDoctype = (function (doc) {
	  var doctype = doc.doctype;
	
	  if (!doctype) {
	     false ? warning("\n      No <!doctype html> found.\n\n      " + suffix + "\n    ") : void 0;
	    return;
	  }
	
	  if (doctype.name.toLowerCase() !== 'html') {
	     false ? warning("\n      Unexpected <!doctype> found: (" + doctype.name + ")\n\n      " + suffix + "\n    ") : void 0;
	  }
	
	  if (doctype.publicId !== '') {
	     false ? warning("\n      Unexpected <!doctype> publicId found: (" + doctype.publicId + ")\n      A html5 doctype does not have a publicId\n\n      " + suffix + "\n    ") : void 0;
	  }
	});
	
	function useDev(useHook) {
	  if (false) {
	    useHook();
	  }
	}
	
	function useDevSetupWarning(fn, inputs) {
	  useDev(function () {
	    React.useEffect(function () {
	      try {
	        fn();
	      } catch (e) {
	        error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
	      }
	    }, inputs);
	  });
	}
	
	function useStartupValidation() {
	  useDevSetupWarning(function () {
	    checkReactVersion(peerDependencies.react, React__default.version);
	    checkDoctype(document);
	  }, []);
	}
	
	function usePrevious(current) {
	  var ref = React.useRef(current);
	  React.useEffect(function () {
	    ref.current = current;
	  });
	  return ref;
	}
	
	function create() {
	  var lock = null;
	
	  function isClaimed() {
	    return Boolean(lock);
	  }
	
	  function isActive(value) {
	    return value === lock;
	  }
	
	  function claim(abandon) {
	    !!lock ?  false ? invariant(false, 'Cannot claim lock as it is already claimed') : invariant(false) : void 0;
	    var newLock = {
	      abandon: abandon
	    };
	    lock = newLock;
	    return newLock;
	  }
	
	  function release() {
	    !lock ?  false ? invariant(false, 'Cannot release lock when there is no lock') : invariant(false) : void 0;
	    lock = null;
	  }
	
	  function tryAbandon() {
	    if (lock) {
	      lock.abandon();
	      release();
	    }
	  }
	
	  return {
	    isClaimed: isClaimed,
	    isActive: isActive,
	    claim: claim,
	    release: release,
	    tryAbandon: tryAbandon
	  };
	}
	
	var tab = 9;
	var enter = 13;
	var escape = 27;
	var space = 32;
	var pageUp = 33;
	var pageDown = 34;
	var end = 35;
	var home = 36;
	var arrowLeft = 37;
	var arrowUp = 38;
	var arrowRight = 39;
	var arrowDown = 40;
	
	var _preventedKeys;
	var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
	var preventStandardKeyEvents = (function (event) {
	  if (preventedKeys[event.keyCode]) {
	    event.preventDefault();
	  }
	});
	
	var supportedEventName = function () {
	  var base = 'visibilitychange';
	
	  if (typeof document === 'undefined') {
	    return base;
	  }
	
	  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
	  var supported = find(candidates, function (eventName) {
	    return "on" + eventName in document;
	  });
	  return supported || base;
	}();
	
	var primaryButton = 0;
	var sloppyClickThreshold = 5;
	
	function isSloppyClickThresholdExceeded(original, current) {
	  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
	}
	
	var idle$1 = {
	  type: 'IDLE'
	};
	
	function getCaptureBindings(_ref) {
	  var cancel = _ref.cancel,
	      completed = _ref.completed,
	      getPhase = _ref.getPhase,
	      setPhase = _ref.setPhase;
	  return [{
	    eventName: 'mousemove',
	    fn: function fn(event) {
	      var button = event.button,
	          clientX = event.clientX,
	          clientY = event.clientY;
	
	      if (button !== primaryButton) {
	        return;
	      }
	
	      var point = {
	        x: clientX,
	        y: clientY
	      };
	      var phase = getPhase();
	
	      if (phase.type === 'DRAGGING') {
	        event.preventDefault();
	        phase.actions.move(point);
	        return;
	      }
	
	      !(phase.type === 'PENDING') ?  false ? invariant(false, 'Cannot be IDLE') : invariant(false) : void 0;
	      var pending = phase.point;
	
	      if (!isSloppyClickThresholdExceeded(pending, point)) {
	        return;
	      }
	
	      event.preventDefault();
	      var actions = phase.actions.fluidLift(point);
	      setPhase({
	        type: 'DRAGGING',
	        actions: actions
	      });
	    }
	  }, {
	    eventName: 'mouseup',
	    fn: function fn(event) {
	      var phase = getPhase();
	
	      if (phase.type !== 'DRAGGING') {
	        cancel();
	        return;
	      }
	
	      event.preventDefault();
	      phase.actions.drop({
	        shouldBlockNextClick: true
	      });
	      completed();
	    }
	  }, {
	    eventName: 'mousedown',
	    fn: function fn(event) {
	      if (getPhase().type === 'DRAGGING') {
	        event.preventDefault();
	      }
	
	      cancel();
	    }
	  }, {
	    eventName: 'keydown',
	    fn: function fn(event) {
	      var phase = getPhase();
	
	      if (phase.type === 'PENDING') {
	        cancel();
	        return;
	      }
	
	      if (event.keyCode === escape) {
	        event.preventDefault();
	        cancel();
	        return;
	      }
	
	      preventStandardKeyEvents(event);
	    }
	  }, {
	    eventName: 'resize',
	    fn: cancel
	  }, {
	    eventName: 'scroll',
	    options: {
	      passive: true,
	      capture: false
	    },
	    fn: function fn() {
	      if (getPhase().type === 'PENDING') {
	        cancel();
	      }
	    }
	  }, {
	    eventName: 'webkitmouseforcedown',
	    fn: function fn(event) {
	      var phase = getPhase();
	      !(phase.type !== 'IDLE') ?  false ? invariant(false, 'Unexpected phase') : invariant(false) : void 0;
	
	      if (phase.actions.shouldRespectForcePress()) {
	        cancel();
	        return;
	      }
	
	      event.preventDefault();
	    }
	  }, {
	    eventName: supportedEventName,
	    fn: cancel
	  }];
	}
	
	function useMouseSensor(api) {
	  var phaseRef = React.useRef(idle$1);
	  var unbindEventsRef = React.useRef(noop);
	  var startCaptureBinding = useMemoOne.useMemo(function () {
	    return {
	      eventName: 'mousedown',
	      fn: function onMouseDown(event) {
	        if (event.defaultPrevented) {
	          return;
	        }
	
	        if (event.button !== primaryButton) {
	          return;
	        }
	
	        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
	          return;
	        }
	
	        var draggableId = api.findClosestDraggableId(event);
	
	        if (!draggableId) {
	          return;
	        }
	
	        var actions = api.tryGetLock(draggableId, stop, {
	          sourceEvent: event
	        });
	
	        if (!actions) {
	          return;
	        }
	
	        event.preventDefault();
	        var point = {
	          x: event.clientX,
	          y: event.clientY
	        };
	        unbindEventsRef.current();
	        startPendingDrag(actions, point);
	      }
	    };
	  }, [api]);
	  var preventForcePressBinding = useMemoOne.useMemo(function () {
	    return {
	      eventName: 'webkitmouseforcewillbegin',
	      fn: function fn(event) {
	        if (event.defaultPrevented) {
	          return;
	        }
	
	        var id = api.findClosestDraggableId(event);
	
	        if (!id) {
	          return;
	        }
	
	        var options = api.findOptionsForDraggable(id);
	
	        if (!options) {
	          return;
	        }
	
	        if (options.shouldRespectForcePress) {
	          return;
	        }
	
	        if (!api.canGetLock(id)) {
	          return;
	        }
	
	        event.preventDefault();
	      }
	    };
	  }, [api]);
	  var listenForCapture = useMemoOne.useCallback(function listenForCapture() {
	    var options = {
	      passive: false,
	      capture: true
	    };
	    unbindEventsRef.current = bindEvents(window, [preventForcePressBinding, startCaptureBinding], options);
	  }, [preventForcePressBinding, startCaptureBinding]);
	  var stop = useMemoOne.useCallback(function () {
	    var current = phaseRef.current;
	
	    if (current.type === 'IDLE') {
	      return;
	    }
	
	    phaseRef.current = idle$1;
	    unbindEventsRef.current();
	    listenForCapture();
	  }, [listenForCapture]);
	  var cancel = useMemoOne.useCallback(function () {
	    var phase = phaseRef.current;
	    stop();
	
	    if (phase.type === 'DRAGGING') {
	      phase.actions.cancel({
	        shouldBlockNextClick: true
	      });
	    }
	
	    if (phase.type === 'PENDING') {
	      phase.actions.abort();
	    }
	  }, [stop]);
	  var bindCapturingEvents = useMemoOne.useCallback(function bindCapturingEvents() {
	    var options = {
	      capture: true,
	      passive: false
	    };
	    var bindings = getCaptureBindings({
	      cancel: cancel,
	      completed: stop,
	      getPhase: function getPhase() {
	        return phaseRef.current;
	      },
	      setPhase: function setPhase(phase) {
	        phaseRef.current = phase;
	      }
	    });
	    unbindEventsRef.current = bindEvents(window, bindings, options);
	  }, [cancel, stop]);
	  var startPendingDrag = useMemoOne.useCallback(function startPendingDrag(actions, point) {
	    !(phaseRef.current.type === 'IDLE') ?  false ? invariant(false, 'Expected to move from IDLE to PENDING drag') : invariant(false) : void 0;
	    phaseRef.current = {
	      type: 'PENDING',
	      point: point,
	      actions: actions
	    };
	    bindCapturingEvents();
	  }, [bindCapturingEvents]);
	  useIsomorphicLayoutEffect(function mount() {
	    listenForCapture();
	    return function unmount() {
	      unbindEventsRef.current();
	    };
	  }, [listenForCapture]);
	}
	
	var _scrollJumpKeys;
	
	function noop$1() {}
	
	var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);
	
	function getDraggingBindings(actions, stop) {
	  function cancel() {
	    stop();
	    actions.cancel();
	  }
	
	  function drop() {
	    stop();
	    actions.drop();
	  }
	
	  return [{
	    eventName: 'keydown',
	    fn: function fn(event) {
	      if (event.keyCode === escape) {
	        event.preventDefault();
	        cancel();
	        return;
	      }
	
	      if (event.keyCode === space) {
	        event.preventDefault();
	        drop();
	        return;
	      }
	
	      if (event.keyCode === arrowDown) {
	        event.preventDefault();
	        actions.moveDown();
	        return;
	      }
	
	      if (event.keyCode === arrowUp) {
	        event.preventDefault();
	        actions.moveUp();
	        return;
	      }
	
	      if (event.keyCode === arrowRight) {
	        event.preventDefault();
	        actions.moveRight();
	        return;
	      }
	
	      if (event.keyCode === arrowLeft) {
	        event.preventDefault();
	        actions.moveLeft();
	        return;
	      }
	
	      if (scrollJumpKeys[event.keyCode]) {
	        event.preventDefault();
	        return;
	      }
	
	      preventStandardKeyEvents(event);
	    }
	  }, {
	    eventName: 'mousedown',
	    fn: cancel
	  }, {
	    eventName: 'mouseup',
	    fn: cancel
	  }, {
	    eventName: 'click',
	    fn: cancel
	  }, {
	    eventName: 'touchstart',
	    fn: cancel
	  }, {
	    eventName: 'resize',
	    fn: cancel
	  }, {
	    eventName: 'wheel',
	    fn: cancel,
	    options: {
	      passive: true
	    }
	  }, {
	    eventName: supportedEventName,
	    fn: cancel
	  }];
	}
	
	function useKeyboardSensor(api) {
	  var unbindEventsRef = React.useRef(noop$1);
	  var startCaptureBinding = useMemoOne.useMemo(function () {
	    return {
	      eventName: 'keydown',
	      fn: function onKeyDown(event) {
	        if (event.defaultPrevented) {
	          return;
	        }
	
	        if (event.keyCode !== space) {
	          return;
	        }
	
	        var draggableId = api.findClosestDraggableId(event);
	
	        if (!draggableId) {
	          return;
	        }
	
	        var preDrag = api.tryGetLock(draggableId, stop, {
	          sourceEvent: event
	        });
	
	        if (!preDrag) {
	          return;
	        }
	
	        event.preventDefault();
	        var isCapturing = true;
	        var actions = preDrag.snapLift();
	        unbindEventsRef.current();
	
	        function stop() {
	          !isCapturing ?  false ? invariant(false, 'Cannot stop capturing a keyboard drag when not capturing') : invariant(false) : void 0;
	          isCapturing = false;
	          unbindEventsRef.current();
	          listenForCapture();
	        }
	
	        unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
	          capture: true,
	          passive: false
	        });
	      }
	    };
	  }, [api]);
	  var listenForCapture = useMemoOne.useCallback(function tryStartCapture() {
	    var options = {
	      passive: false,
	      capture: true
	    };
	    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
	  }, [startCaptureBinding]);
	  useIsomorphicLayoutEffect(function mount() {
	    listenForCapture();
	    return function unmount() {
	      unbindEventsRef.current();
	    };
	  }, [listenForCapture]);
	}
	
	var idle$2 = {
	  type: 'IDLE'
	};
	var timeForLongPress = 120;
	var forcePressThreshold = 0.15;
	
	function getWindowBindings(_ref) {
	  var cancel = _ref.cancel,
	      getPhase = _ref.getPhase;
	  return [{
	    eventName: 'orientationchange',
	    fn: cancel
	  }, {
	    eventName: 'resize',
	    fn: cancel
	  }, {
	    eventName: 'contextmenu',
	    fn: function fn(event) {
	      event.preventDefault();
	    }
	  }, {
	    eventName: 'keydown',
	    fn: function fn(event) {
	      if (getPhase().type !== 'DRAGGING') {
	        cancel();
	        return;
	      }
	
	      if (event.keyCode === escape) {
	        event.preventDefault();
	      }
	
	      cancel();
	    }
	  }, {
	    eventName: supportedEventName,
	    fn: cancel
	  }];
	}
	
	function getHandleBindings(_ref2) {
	  var cancel = _ref2.cancel,
	      completed = _ref2.completed,
	      getPhase = _ref2.getPhase;
	  return [{
	    eventName: 'touchmove',
	    options: {
	      capture: false
	    },
	    fn: function fn(event) {
	      var phase = getPhase();
	
	      if (phase.type !== 'DRAGGING') {
	        cancel();
	        return;
	      }
	
	      phase.hasMoved = true;
	      var _event$touches$ = event.touches[0],
	          clientX = _event$touches$.clientX,
	          clientY = _event$touches$.clientY;
	      var point = {
	        x: clientX,
	        y: clientY
	      };
	      event.preventDefault();
	      phase.actions.move(point);
	    }
	  }, {
	    eventName: 'touchend',
	    fn: function fn(event) {
	      var phase = getPhase();
	
	      if (phase.type !== 'DRAGGING') {
	        cancel();
	        return;
	      }
	
	      event.preventDefault();
	      phase.actions.drop({
	        shouldBlockNextClick: true
	      });
	      completed();
	    }
	  }, {
	    eventName: 'touchcancel',
	    fn: function fn(event) {
	      if (getPhase().type !== 'DRAGGING') {
	        cancel();
	        return;
	      }
	
	      event.preventDefault();
	      cancel();
	    }
	  }, {
	    eventName: 'touchforcechange',
	    fn: function fn(event) {
	      var phase = getPhase();
	      !(phase.type !== 'IDLE') ?  false ? invariant(false) : invariant(false) : void 0;
	      var touch = event.touches[0];
	
	      if (!touch) {
	        return;
	      }
	
	      var isForcePress = touch.force >= forcePressThreshold;
	
	      if (!isForcePress) {
	        return;
	      }
	
	      var shouldRespect = phase.actions.shouldRespectForcePress();
	
	      if (phase.type === 'PENDING') {
	        if (shouldRespect) {
	          cancel();
	        }
	
	        return;
	      }
	
	      if (shouldRespect) {
	        if (phase.hasMoved) {
	          event.preventDefault();
	          return;
	        }
	
	        cancel();
	        return;
	      }
	
	      event.preventDefault();
	    }
	  }, {
	    eventName: supportedEventName,
	    fn: cancel
	  }];
	}
	
	function useTouchSensor(api) {
	  var phaseRef = React.useRef(idle$2);
	  var unbindEventsRef = React.useRef(noop);
	  var getPhase = useMemoOne.useCallback(function getPhase() {
	    return phaseRef.current;
	  }, []);
	  var setPhase = useMemoOne.useCallback(function setPhase(phase) {
	    phaseRef.current = phase;
	  }, []);
	  var startCaptureBinding = useMemoOne.useMemo(function () {
	    return {
	      eventName: 'touchstart',
	      fn: function onTouchStart(event) {
	        if (event.defaultPrevented) {
	          return;
	        }
	
	        var draggableId = api.findClosestDraggableId(event);
	
	        if (!draggableId) {
	          return;
	        }
	
	        var actions = api.tryGetLock(draggableId, stop, {
	          sourceEvent: event
	        });
	
	        if (!actions) {
	          return;
	        }
	
	        var touch = event.touches[0];
	        var clientX = touch.clientX,
	            clientY = touch.clientY;
	        var point = {
	          x: clientX,
	          y: clientY
	        };
	        unbindEventsRef.current();
	        startPendingDrag(actions, point);
	      }
	    };
	  }, [api]);
	  var listenForCapture = useMemoOne.useCallback(function listenForCapture() {
	    var options = {
	      capture: true,
	      passive: false
	    };
	    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
	  }, [startCaptureBinding]);
	  var stop = useMemoOne.useCallback(function () {
	    var current = phaseRef.current;
	
	    if (current.type === 'IDLE') {
	      return;
	    }
	
	    if (current.type === 'PENDING') {
	      clearTimeout(current.longPressTimerId);
	    }
	
	    setPhase(idle$2);
	    unbindEventsRef.current();
	    listenForCapture();
	  }, [listenForCapture, setPhase]);
	  var cancel = useMemoOne.useCallback(function () {
	    var phase = phaseRef.current;
	    stop();
	
	    if (phase.type === 'DRAGGING') {
	      phase.actions.cancel({
	        shouldBlockNextClick: true
	      });
	    }
	
	    if (phase.type === 'PENDING') {
	      phase.actions.abort();
	    }
	  }, [stop]);
	  var bindCapturingEvents = useMemoOne.useCallback(function bindCapturingEvents() {
	    var options = {
	      capture: true,
	      passive: false
	    };
	    var args = {
	      cancel: cancel,
	      completed: stop,
	      getPhase: getPhase
	    };
	    var unbindTarget = bindEvents(window, getHandleBindings(args), options);
	    var unbindWindow = bindEvents(window, getWindowBindings(args), options);
	
	    unbindEventsRef.current = function unbindAll() {
	      unbindTarget();
	      unbindWindow();
	    };
	  }, [cancel, getPhase, stop]);
	  var startDragging = useMemoOne.useCallback(function startDragging() {
	    var phase = getPhase();
	    !(phase.type === 'PENDING') ?  false ? invariant(false, "Cannot start dragging from phase " + phase.type) : invariant(false) : void 0;
	    var actions = phase.actions.fluidLift(phase.point);
	    setPhase({
	      type: 'DRAGGING',
	      actions: actions,
	      hasMoved: false
	    });
	  }, [getPhase, setPhase]);
	  var startPendingDrag = useMemoOne.useCallback(function startPendingDrag(actions, point) {
	    !(getPhase().type === 'IDLE') ?  false ? invariant(false, 'Expected to move from IDLE to PENDING drag') : invariant(false) : void 0;
	    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
	    setPhase({
	      type: 'PENDING',
	      point: point,
	      actions: actions,
	      longPressTimerId: longPressTimerId
	    });
	    bindCapturingEvents();
	  }, [bindCapturingEvents, getPhase, setPhase, startDragging]);
	  useIsomorphicLayoutEffect(function mount() {
	    listenForCapture();
	    return function unmount() {
	      unbindEventsRef.current();
	      var phase = getPhase();
	
	      if (phase.type === 'PENDING') {
	        clearTimeout(phase.longPressTimerId);
	        setPhase(idle$2);
	      }
	    };
	  }, [getPhase, listenForCapture, setPhase]);
	  useIsomorphicLayoutEffect(function webkitHack() {
	    var unbind = bindEvents(window, [{
	      eventName: 'touchmove',
	      fn: function fn() {},
	      options: {
	        capture: false,
	        passive: false
	      }
	    }]);
	    return unbind;
	  }, []);
	}
	
	function useValidateSensorHooks(sensorHooks) {
	  useDev(function () {
	    var previousRef = usePrevious(sensorHooks);
	    useDevSetupWarning(function () {
	      !(previousRef.current.length === sensorHooks.length) ?  false ? invariant(false, 'Cannot change the amount of sensor hooks after mounting') : invariant(false) : void 0;
	    });
	  });
	}
	
	var interactiveTagNames = {
	  input: true,
	  button: true,
	  textarea: true,
	  select: true,
	  option: true,
	  optgroup: true,
	  video: true,
	  audio: true
	};
	
	function isAnInteractiveElement(parent, current) {
	  if (current == null) {
	    return false;
	  }
	
	  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);
	
	  if (hasAnInteractiveTag) {
	    return true;
	  }
	
	  var attribute = current.getAttribute('contenteditable');
	
	  if (attribute === 'true' || attribute === '') {
	    return true;
	  }
	
	  if (current === parent) {
	    return false;
	  }
	
	  return isAnInteractiveElement(parent, current.parentElement);
	}
	
	function isEventInInteractiveElement(draggable, event) {
	  var target = event.target;
	
	  if (!isHtmlElement(target)) {
	    return false;
	  }
	
	  return isAnInteractiveElement(draggable, target);
	}
	
	var getBorderBoxCenterPosition = (function (el) {
	  return cssBoxModel.getRect(el.getBoundingClientRect()).center;
	});
	
	function isElement(el) {
	  return el instanceof getWindowFromEl(el).Element;
	}
	
	var supportedMatchesName = function () {
	  var base = 'matches';
	
	  if (typeof document === 'undefined') {
	    return base;
	  }
	
	  var candidates = [base, 'msMatchesSelector', 'webkitMatchesSelector'];
	  var value = find(candidates, function (name) {
	    return name in Element.prototype;
	  });
	  return value || base;
	}();
	
	function closestPonyfill(el, selector) {
	  if (el == null) {
	    return null;
	  }
	
	  if (el[supportedMatchesName](selector)) {
	    return el;
	  }
	
	  return closestPonyfill(el.parentElement, selector);
	}
	
	function closest$1(el, selector) {
	  if (el.closest) {
	    return el.closest(selector);
	  }
	
	  return closestPonyfill(el, selector);
	}
	
	function getSelector(contextId) {
	  return "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
	}
	
	function findClosestDragHandleFromEvent(contextId, event) {
	  var target = event.target;
	
	  if (!isElement(target)) {
	     false ? warning('event.target must be a Element') : void 0;
	    return null;
	  }
	
	  var selector = getSelector(contextId);
	  var handle = closest$1(target, selector);
	
	  if (!handle) {
	    return null;
	  }
	
	  if (!isHtmlElement(handle)) {
	     false ? warning('drag handle must be a HTMLElement') : void 0;
	    return null;
	  }
	
	  return handle;
	}
	
	function tryGetClosestDraggableIdFromEvent(contextId, event) {
	  var handle = findClosestDragHandleFromEvent(contextId, event);
	
	  if (!handle) {
	    return null;
	  }
	
	  return handle.getAttribute(dragHandle.draggableId);
	}
	
	function findDraggable(contextId, draggableId) {
	  var selector = "[" + draggable.contextId + "=\"" + contextId + "\"]";
	  var possible = toArray(document.querySelectorAll(selector));
	  var draggable$1 = find(possible, function (el) {
	    return el.getAttribute(draggable.id) === draggableId;
	  });
	
	  if (!draggable$1) {
	    return null;
	  }
	
	  if (!isHtmlElement(draggable$1)) {
	     false ? warning('Draggable element is not a HTMLElement') : void 0;
	    return null;
	  }
	
	  return draggable$1;
	}
	
	function preventDefault(event) {
	  event.preventDefault();
	}
	
	function _isActive(_ref) {
	  var expected = _ref.expected,
	      phase = _ref.phase,
	      isLockActive = _ref.isLockActive,
	      shouldWarn = _ref.shouldWarn;
	
	  if (!isLockActive()) {
	    if (shouldWarn) {
	       false ? warning("\n        Cannot perform action.\n        The sensor no longer has an action lock.\n\n        Tips:\n\n        - Throw away your action handlers when forceStop() is called\n        - Check actions.isActive() if you really need to\n      ") : void 0;
	    }
	
	    return false;
	  }
	
	  if (expected !== phase) {
	    if (shouldWarn) {
	       false ? warning("\n        Cannot perform action.\n        The actions you used belong to an outdated phase\n\n        Current phase: " + expected + "\n        You called an action from outdated phase: " + phase + "\n\n        Tips:\n\n        - Do not use preDragActions actions after calling preDragActions.lift()\n      ") : void 0;
	    }
	
	    return false;
	  }
	
	  return true;
	}
	
	function canStart(_ref2) {
	  var lockAPI = _ref2.lockAPI,
	      store = _ref2.store,
	      registry = _ref2.registry,
	      draggableId = _ref2.draggableId;
	
	  if (lockAPI.isClaimed()) {
	    return false;
	  }
	
	  var entry = registry.draggable.findById(draggableId);
	
	  if (!entry) {
	     false ? warning("Unable to find draggable with id: " + draggableId) : void 0;
	    return false;
	  }
	
	  if (!entry.options.isEnabled) {
	    return false;
	  }
	
	  if (!canStartDrag(store.getState(), draggableId)) {
	    return false;
	  }
	
	  return true;
	}
	
	function tryStart(_ref3) {
	  var lockAPI = _ref3.lockAPI,
	      contextId = _ref3.contextId,
	      store = _ref3.store,
	      registry = _ref3.registry,
	      draggableId = _ref3.draggableId,
	      forceSensorStop = _ref3.forceSensorStop,
	      sourceEvent = _ref3.sourceEvent;
	  var shouldStart = canStart({
	    lockAPI: lockAPI,
	    store: store,
	    registry: registry,
	    draggableId: draggableId
	  });
	
	  if (!shouldStart) {
	    return null;
	  }
	
	  var entry = registry.draggable.getById(draggableId);
	  var el = findDraggable(contextId, entry.descriptor.id);
	
	  if (!el) {
	     false ? warning("Unable to find draggable element with id: " + draggableId) : void 0;
	    return null;
	  }
	
	  if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) {
	    return null;
	  }
	
	  var lock = lockAPI.claim(forceSensorStop || noop);
	  var phase = 'PRE_DRAG';
	
	  function getShouldRespectForcePress() {
	    return entry.options.shouldRespectForcePress;
	  }
	
	  function isLockActive() {
	    return lockAPI.isActive(lock);
	  }
	
	  function tryDispatch(expected, getAction) {
	    if (_isActive({
	      expected: expected,
	      phase: phase,
	      isLockActive: isLockActive,
	      shouldWarn: true
	    })) {
	      store.dispatch(getAction());
	    }
	  }
	
	  var tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');
	
	  function lift$1(args) {
	    function completed() {
	      lockAPI.release();
	      phase = 'COMPLETED';
	    }
	
	    if (phase !== 'PRE_DRAG') {
	      completed();
	      !(phase === 'PRE_DRAG') ?  false ? invariant(false, "Cannot lift in phase " + phase) : invariant(false) : void 0;
	    }
	
	    store.dispatch(lift(args.liftActionArgs));
	    phase = 'DRAGGING';
	
	    function finish(reason, options) {
	      if (options === void 0) {
	        options = {
	          shouldBlockNextClick: false
	        };
	      }
	
	      args.cleanup();
	
	      if (options.shouldBlockNextClick) {
	        var unbind = bindEvents(window, [{
	          eventName: 'click',
	          fn: preventDefault,
	          options: {
	            once: true,
	            passive: false,
	            capture: true
	          }
	        }]);
	        setTimeout(unbind);
	      }
	
	      completed();
	      store.dispatch(drop({
	        reason: reason
	      }));
	    }
	
	    return _extends({
	      isActive: function isActive() {
	        return _isActive({
	          expected: 'DRAGGING',
	          phase: phase,
	          isLockActive: isLockActive,
	          shouldWarn: false
	        });
	      },
	      shouldRespectForcePress: getShouldRespectForcePress,
	      drop: function drop(options) {
	        return finish('DROP', options);
	      },
	      cancel: function cancel(options) {
	        return finish('CANCEL', options);
	      }
	    }, args.actions);
	  }
	
	  function fluidLift(clientSelection) {
	    var move$1 = rafSchd(function (client) {
	      tryDispatchWhenDragging(function () {
	        return move({
	          client: client
	        });
	      });
	    });
	    var api = lift$1({
	      liftActionArgs: {
	        id: draggableId,
	        clientSelection: clientSelection,
	        movementMode: 'FLUID'
	      },
	      cleanup: function cleanup() {
	        return move$1.cancel();
	      },
	      actions: {
	        move: move$1
	      }
	    });
	    return _extends({}, api, {
	      move: move$1
	    });
	  }
	
	  function snapLift() {
	    var actions = {
	      moveUp: function moveUp$1() {
	        return tryDispatchWhenDragging(moveUp);
	      },
	      moveRight: function moveRight$1() {
	        return tryDispatchWhenDragging(moveRight);
	      },
	      moveDown: function moveDown$1() {
	        return tryDispatchWhenDragging(moveDown);
	      },
	      moveLeft: function moveLeft$1() {
	        return tryDispatchWhenDragging(moveLeft);
	      }
	    };
	    return lift$1({
	      liftActionArgs: {
	        id: draggableId,
	        clientSelection: getBorderBoxCenterPosition(el),
	        movementMode: 'SNAP'
	      },
	      cleanup: noop,
	      actions: actions
	    });
	  }
	
	  function abortPreDrag() {
	    var shouldRelease = _isActive({
	      expected: 'PRE_DRAG',
	      phase: phase,
	      isLockActive: isLockActive,
	      shouldWarn: true
	    });
	
	    if (shouldRelease) {
	      lockAPI.release();
	    }
	  }
	
	  var preDrag = {
	    isActive: function isActive() {
	      return _isActive({
	        expected: 'PRE_DRAG',
	        phase: phase,
	        isLockActive: isLockActive,
	        shouldWarn: false
	      });
	    },
	    shouldRespectForcePress: getShouldRespectForcePress,
	    fluidLift: fluidLift,
	    snapLift: snapLift,
	    abort: abortPreDrag
	  };
	  return preDrag;
	}
	
	var defaultSensors = [useMouseSensor, useKeyboardSensor, useTouchSensor];
	function useSensorMarshal(_ref4) {
	  var contextId = _ref4.contextId,
	      store = _ref4.store,
	      registry = _ref4.registry,
	      customSensors = _ref4.customSensors,
	      enableDefaultSensors = _ref4.enableDefaultSensors;
	  var useSensors = [].concat(enableDefaultSensors ? defaultSensors : [], customSensors || []);
	  var lockAPI = React.useState(function () {
	    return create();
	  })[0];
	  var tryAbandonLock = useMemoOne.useCallback(function tryAbandonLock(previous, current) {
	    if (previous.isDragging && !current.isDragging) {
	      lockAPI.tryAbandon();
	    }
	  }, [lockAPI]);
	  useIsomorphicLayoutEffect(function listenToStore() {
	    var previous = store.getState();
	    var unsubscribe = store.subscribe(function () {
	      var current = store.getState();
	      tryAbandonLock(previous, current);
	      previous = current;
	    });
	    return unsubscribe;
	  }, [lockAPI, store, tryAbandonLock]);
	  useIsomorphicLayoutEffect(function () {
	    return lockAPI.tryAbandon;
	  }, [lockAPI.tryAbandon]);
	  var canGetLock = useMemoOne.useCallback(function (draggableId) {
	    return canStart({
	      lockAPI: lockAPI,
	      registry: registry,
	      store: store,
	      draggableId: draggableId
	    });
	  }, [lockAPI, registry, store]);
	  var tryGetLock = useMemoOne.useCallback(function (draggableId, forceStop, options) {
	    return tryStart({
	      lockAPI: lockAPI,
	      registry: registry,
	      contextId: contextId,
	      store: store,
	      draggableId: draggableId,
	      forceSensorStop: forceStop,
	      sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
	    });
	  }, [contextId, lockAPI, registry, store]);
	  var findClosestDraggableId = useMemoOne.useCallback(function (event) {
	    return tryGetClosestDraggableIdFromEvent(contextId, event);
	  }, [contextId]);
	  var findOptionsForDraggable = useMemoOne.useCallback(function (id) {
	    var entry = registry.draggable.findById(id);
	    return entry ? entry.options : null;
	  }, [registry.draggable]);
	  var tryReleaseLock = useMemoOne.useCallback(function tryReleaseLock() {
	    if (!lockAPI.isClaimed()) {
	      return;
	    }
	
	    lockAPI.tryAbandon();
	
	    if (store.getState().phase !== 'IDLE') {
	      store.dispatch(flush());
	    }
	  }, [lockAPI, store]);
	  var isLockClaimed = useMemoOne.useCallback(lockAPI.isClaimed, [lockAPI]);
	  var api = useMemoOne.useMemo(function () {
	    return {
	      canGetLock: canGetLock,
	      tryGetLock: tryGetLock,
	      findClosestDraggableId: findClosestDraggableId,
	      findOptionsForDraggable: findOptionsForDraggable,
	      tryReleaseLock: tryReleaseLock,
	      isLockClaimed: isLockClaimed
	    };
	  }, [canGetLock, tryGetLock, findClosestDraggableId, findOptionsForDraggable, tryReleaseLock, isLockClaimed]);
	  useValidateSensorHooks(useSensors);
	
	  for (var i = 0; i < useSensors.length; i++) {
	    useSensors[i](api);
	  }
	}
	
	var createResponders = function createResponders(props) {
	  return {
	    onBeforeCapture: props.onBeforeCapture,
	    onBeforeDragStart: props.onBeforeDragStart,
	    onDragStart: props.onDragStart,
	    onDragEnd: props.onDragEnd,
	    onDragUpdate: props.onDragUpdate
	  };
	};
	
	function getStore(lazyRef) {
	  !lazyRef.current ?  false ? invariant(false, 'Could not find store from lazy ref') : invariant(false) : void 0;
	  return lazyRef.current;
	}
	
	function App(props) {
	  var contextId = props.contextId,
	      setCallbacks = props.setCallbacks,
	      sensors = props.sensors,
	      nonce = props.nonce,
	      dragHandleUsageInstructions = props.dragHandleUsageInstructions;
	  var lazyStoreRef = React.useRef(null);
	  useStartupValidation();
	  var lastPropsRef = usePrevious(props);
	  var getResponders = useMemoOne.useCallback(function () {
	    return createResponders(lastPropsRef.current);
	  }, [lastPropsRef]);
	  var announce = useAnnouncer(contextId);
	  var dragHandleUsageInstructionsId = useHiddenTextElement({
	    contextId: contextId,
	    text: dragHandleUsageInstructions
	  });
	  var styleMarshal = useStyleMarshal(contextId, nonce);
	  var lazyDispatch = useMemoOne.useCallback(function (action) {
	    getStore(lazyStoreRef).dispatch(action);
	  }, []);
	  var marshalCallbacks = useMemoOne.useMemo(function () {
	    return redux.bindActionCreators({
	      publishWhileDragging: publishWhileDragging,
	      updateDroppableScroll: updateDroppableScroll,
	      updateDroppableIsEnabled: updateDroppableIsEnabled,
	      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
	      collectionStarting: collectionStarting
	    }, lazyDispatch);
	  }, [lazyDispatch]);
	  var registry = useRegistry();
	  var dimensionMarshal = useMemoOne.useMemo(function () {
	    return createDimensionMarshal(registry, marshalCallbacks);
	  }, [registry, marshalCallbacks]);
	  var autoScroller = useMemoOne.useMemo(function () {
	    return createAutoScroller(_extends({
	      scrollWindow: scrollWindow,
	      scrollDroppable: dimensionMarshal.scrollDroppable
	    }, redux.bindActionCreators({
	      move: move
	    }, lazyDispatch)));
	  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
	  var focusMarshal = useFocusMarshal(contextId);
	  var store = useMemoOne.useMemo(function () {
	    return createStore({
	      announce: announce,
	      autoScroller: autoScroller,
	      dimensionMarshal: dimensionMarshal,
	      focusMarshal: focusMarshal,
	      getResponders: getResponders,
	      styleMarshal: styleMarshal
	    });
	  }, [announce, autoScroller, dimensionMarshal, focusMarshal, getResponders, styleMarshal]);
	
	  if (false) {
	    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
	      process.env.NODE_ENV !== "production" ? warning('unexpected store change') : void 0;
	    }
	  }
	
	  lazyStoreRef.current = store;
	  var tryResetStore = useMemoOne.useCallback(function () {
	    var current = getStore(lazyStoreRef);
	    var state = current.getState();
	
	    if (state.phase !== 'IDLE') {
	      current.dispatch(flush());
	    }
	  }, []);
	  var isDragging = useMemoOne.useCallback(function () {
	    var state = getStore(lazyStoreRef).getState();
	    return state.isDragging || state.phase === 'DROP_ANIMATING';
	  }, []);
	  var appCallbacks = useMemoOne.useMemo(function () {
	    return {
	      isDragging: isDragging,
	      tryAbort: tryResetStore
	    };
	  }, [isDragging, tryResetStore]);
	  setCallbacks(appCallbacks);
	  var getCanLift = useMemoOne.useCallback(function (id) {
	    return canStartDrag(getStore(lazyStoreRef).getState(), id);
	  }, []);
	  var getIsMovementAllowed = useMemoOne.useCallback(function () {
	    return isMovementAllowed(getStore(lazyStoreRef).getState());
	  }, []);
	  var appContext = useMemoOne.useMemo(function () {
	    return {
	      marshal: dimensionMarshal,
	      focus: focusMarshal,
	      contextId: contextId,
	      canLift: getCanLift,
	      isMovementAllowed: getIsMovementAllowed,
	      dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
	      registry: registry
	    };
	  }, [contextId, dimensionMarshal, dragHandleUsageInstructionsId, focusMarshal, getCanLift, getIsMovementAllowed, registry]);
	  useSensorMarshal({
	    contextId: contextId,
	    store: store,
	    registry: registry,
	    customSensors: sensors,
	    enableDefaultSensors: props.enableDefaultSensors !== false
	  });
	  React.useEffect(function () {
	    return tryResetStore;
	  }, [tryResetStore]);
	  return React__default.createElement(AppContext.Provider, {
	    value: appContext
	  }, React__default.createElement(reactRedux.Provider, {
	    context: StoreContext,
	    store: store
	  }, props.children));
	}
	
	var count$1 = 0;
	function reset$1() {
	  count$1 = 0;
	}
	function useInstanceCount() {
	  return useMemoOne.useMemo(function () {
	    return "" + count$1++;
	  }, []);
	}
	
	function resetServerContext() {
	  reset$1();
	  reset();
	}
	function DragDropContext(props) {
	  var contextId = useInstanceCount();
	  var dragHandleUsageInstructions = props.dragHandleUsageInstructions || preset.dragHandleUsageInstructions;
	  return React__default.createElement(ErrorBoundary, null, function (setCallbacks) {
	    return React__default.createElement(App, {
	      nonce: props.nonce,
	      contextId: contextId,
	      setCallbacks: setCallbacks,
	      dragHandleUsageInstructions: dragHandleUsageInstructions,
	      enableDefaultSensors: props.enableDefaultSensors,
	      sensors: props.sensors,
	      onBeforeCapture: props.onBeforeCapture,
	      onBeforeDragStart: props.onBeforeDragStart,
	      onDragStart: props.onDragStart,
	      onDragUpdate: props.onDragUpdate,
	      onDragEnd: props.onDragEnd
	    }, props.children);
	  });
	}
	
	var isEqual$1 = function isEqual(base) {
	  return function (value) {
	    return base === value;
	  };
	};
	
	var isScroll = isEqual$1('scroll');
	var isAuto = isEqual$1('auto');
	var isVisible$1 = isEqual$1('visible');
	
	var isEither = function isEither(overflow, fn) {
	  return fn(overflow.overflowX) || fn(overflow.overflowY);
	};
	
	var isBoth = function isBoth(overflow, fn) {
	  return fn(overflow.overflowX) && fn(overflow.overflowY);
	};
	
	var isElementScrollable = function isElementScrollable(el) {
	  var style = window.getComputedStyle(el);
	  var overflow = {
	    overflowX: style.overflowX,
	    overflowY: style.overflowY
	  };
	  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
	};
	
	var isBodyScrollable = function isBodyScrollable() {
	  if (true) {
	    return false;
	  }
	
	  var body = getBodyElement();
	  var html = document.documentElement;
	  !html ?  false ? invariant(false) : invariant(false) : void 0;
	
	  if (!isElementScrollable(body)) {
	    return false;
	  }
	
	  var htmlStyle = window.getComputedStyle(html);
	  var htmlOverflow = {
	    overflowX: htmlStyle.overflowX,
	    overflowY: htmlStyle.overflowY
	  };
	
	  if (isBoth(htmlOverflow, isVisible$1)) {
	    return false;
	  }
	
	   false ? warning("\n    We have detected that your <body> element might be a scroll container.\n    We have found no reliable way of detecting whether the <body> element is a scroll container.\n    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)\n\n    Because we cannot determine if the <body> is a scroll container, and generally it is not one,\n    we will be treating the <body> as *not* a scroll container\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md\n  ") : void 0;
	  return false;
	};
	
	var getClosestScrollable = function getClosestScrollable(el) {
	  if (el == null) {
	    return null;
	  }
	
	  if (el === document.body) {
	    return isBodyScrollable() ? el : null;
	  }
	
	  if (el === document.documentElement) {
	    return null;
	  }
	
	  if (!isElementScrollable(el)) {
	    return getClosestScrollable(el.parentElement);
	  }
	
	  return el;
	};
	
	var checkForNestedScrollContainers = (function (scrollable) {
	  if (!scrollable) {
	    return;
	  }
	
	  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);
	
	  if (!anotherScrollParent) {
	    return;
	  }
	
	   false ? warning("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ") : void 0;
	});
	
	var getScroll$1 = (function (el) {
	  return {
	    x: el.scrollLeft,
	    y: el.scrollTop
	  };
	});
	
	var getIsFixed = function getIsFixed(el) {
	  if (!el) {
	    return false;
	  }
	
	  var style = window.getComputedStyle(el);
	
	  if (style.position === 'fixed') {
	    return true;
	  }
	
	  return getIsFixed(el.parentElement);
	};
	
	var getEnv = (function (start) {
	  var closestScrollable = getClosestScrollable(start);
	  var isFixedOnPage = getIsFixed(start);
	  return {
	    closestScrollable: closestScrollable,
	    isFixedOnPage: isFixedOnPage
	  };
	});
	
	var getDroppableDimension = (function (_ref) {
	  var descriptor = _ref.descriptor,
	      isEnabled = _ref.isEnabled,
	      isCombineEnabled = _ref.isCombineEnabled,
	      isFixedOnPage = _ref.isFixedOnPage,
	      direction = _ref.direction,
	      client = _ref.client,
	      page = _ref.page,
	      closest = _ref.closest;
	
	  var frame = function () {
	    if (!closest) {
	      return null;
	    }
	
	    var scrollSize = closest.scrollSize,
	        frameClient = closest.client;
	    var maxScroll = getMaxScroll({
	      scrollHeight: scrollSize.scrollHeight,
	      scrollWidth: scrollSize.scrollWidth,
	      height: frameClient.paddingBox.height,
	      width: frameClient.paddingBox.width
	    });
	    return {
	      pageMarginBox: closest.page.marginBox,
	      frameClient: frameClient,
	      scrollSize: scrollSize,
	      shouldClipSubject: closest.shouldClipSubject,
	      scroll: {
	        initial: closest.scroll,
	        current: closest.scroll,
	        max: maxScroll,
	        diff: {
	          value: origin,
	          displacement: origin
	        }
	      }
	    };
	  }();
	
	  var axis = direction === 'vertical' ? vertical : horizontal;
	  var subject = getSubject({
	    page: page,
	    withPlaceholder: null,
	    axis: axis,
	    frame: frame
	  });
	  var dimension = {
	    descriptor: descriptor,
	    isCombineEnabled: isCombineEnabled,
	    isFixedOnPage: isFixedOnPage,
	    axis: axis,
	    isEnabled: isEnabled,
	    client: client,
	    page: page,
	    frame: frame,
	    subject: subject
	  };
	  return dimension;
	});
	
	var getClient = function getClient(targetRef, closestScrollable) {
	  var base = cssBoxModel.getBox(targetRef);
	
	  if (!closestScrollable) {
	    return base;
	  }
	
	  if (targetRef !== closestScrollable) {
	    return base;
	  }
	
	  var top = base.paddingBox.top - closestScrollable.scrollTop;
	  var left = base.paddingBox.left - closestScrollable.scrollLeft;
	  var bottom = top + closestScrollable.scrollHeight;
	  var right = left + closestScrollable.scrollWidth;
	  var paddingBox = {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left
	  };
	  var borderBox = cssBoxModel.expand(paddingBox, base.border);
	  var client = cssBoxModel.createBox({
	    borderBox: borderBox,
	    margin: base.margin,
	    border: base.border,
	    padding: base.padding
	  });
	  return client;
	};
	
	var getDimension = (function (_ref) {
	  var ref = _ref.ref,
	      descriptor = _ref.descriptor,
	      env = _ref.env,
	      windowScroll = _ref.windowScroll,
	      direction = _ref.direction,
	      isDropDisabled = _ref.isDropDisabled,
	      isCombineEnabled = _ref.isCombineEnabled,
	      shouldClipSubject = _ref.shouldClipSubject;
	  var closestScrollable = env.closestScrollable;
	  var client = getClient(ref, closestScrollable);
	  var page = cssBoxModel.withScroll(client, windowScroll);
	
	  var closest = function () {
	    if (!closestScrollable) {
	      return null;
	    }
	
	    var frameClient = cssBoxModel.getBox(closestScrollable);
	    var scrollSize = {
	      scrollHeight: closestScrollable.scrollHeight,
	      scrollWidth: closestScrollable.scrollWidth
	    };
	    return {
	      client: frameClient,
	      page: cssBoxModel.withScroll(frameClient, windowScroll),
	      scroll: getScroll$1(closestScrollable),
	      scrollSize: scrollSize,
	      shouldClipSubject: shouldClipSubject
	    };
	  }();
	
	  var dimension = getDroppableDimension({
	    descriptor: descriptor,
	    isEnabled: !isDropDisabled,
	    isCombineEnabled: isCombineEnabled,
	    isFixedOnPage: env.isFixedOnPage,
	    direction: direction,
	    client: client,
	    page: page,
	    closest: closest
	  });
	  return dimension;
	});
	
	var immediate = {
	  passive: false
	};
	var delayed = {
	  passive: true
	};
	var getListenerOptions = (function (options) {
	  return options.shouldPublishImmediately ? immediate : delayed;
	});
	
	function useRequiredContext(Context) {
	  var result = React.useContext(Context);
	  !result ?  false ? invariant(false, 'Could not find required context') : invariant(false) : void 0;
	  return result;
	}
	
	var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
	  return dragging && dragging.env.closestScrollable || null;
	};
	
	function useDroppablePublisher(args) {
	  var whileDraggingRef = React.useRef(null);
	  var appContext = useRequiredContext(AppContext);
	  var uniqueId = useUniqueId('droppable');
	  var registry = appContext.registry,
	      marshal = appContext.marshal;
	  var previousRef = usePrevious(args);
	  var descriptor = useMemoOne.useMemo(function () {
	    return {
	      id: args.droppableId,
	      type: args.type,
	      mode: args.mode
	    };
	  }, [args.droppableId, args.mode, args.type]);
	  var publishedDescriptorRef = React.useRef(descriptor);
	  var memoizedUpdateScroll = useMemoOne.useMemo(function () {
	    return memoizeOne(function (x, y) {
	      !whileDraggingRef.current ?  false ? invariant(false, 'Can only update scroll when dragging') : invariant(false) : void 0;
	      var scroll = {
	        x: x,
	        y: y
	      };
	      marshal.updateDroppableScroll(descriptor.id, scroll);
	    });
	  }, [descriptor.id, marshal]);
	  var getClosestScroll = useMemoOne.useCallback(function () {
	    var dragging = whileDraggingRef.current;
	
	    if (!dragging || !dragging.env.closestScrollable) {
	      return origin;
	    }
	
	    return getScroll$1(dragging.env.closestScrollable);
	  }, []);
	  var updateScroll = useMemoOne.useCallback(function () {
	    var scroll = getClosestScroll();
	    memoizedUpdateScroll(scroll.x, scroll.y);
	  }, [getClosestScroll, memoizedUpdateScroll]);
	  var scheduleScrollUpdate = useMemoOne.useMemo(function () {
	    return rafSchd(updateScroll);
	  }, [updateScroll]);
	  var onClosestScroll = useMemoOne.useCallback(function () {
	    var dragging = whileDraggingRef.current;
	    var closest = getClosestScrollableFromDrag(dragging);
	    !(dragging && closest) ?  false ? invariant(false, 'Could not find scroll options while scrolling') : invariant(false) : void 0;
	    var options = dragging.scrollOptions;
	
	    if (options.shouldPublishImmediately) {
	      updateScroll();
	      return;
	    }
	
	    scheduleScrollUpdate();
	  }, [scheduleScrollUpdate, updateScroll]);
	  var getDimensionAndWatchScroll = useMemoOne.useCallback(function (windowScroll, options) {
	    !!whileDraggingRef.current ?  false ? invariant(false, 'Cannot collect a droppable while a drag is occurring') : invariant(false) : void 0;
	    var previous = previousRef.current;
	    var ref = previous.getDroppableRef();
	    !ref ?  false ? invariant(false, 'Cannot collect without a droppable ref') : invariant(false) : void 0;
	    var env = getEnv(ref);
	    var dragging = {
	      ref: ref,
	      descriptor: descriptor,
	      env: env,
	      scrollOptions: options
	    };
	    whileDraggingRef.current = dragging;
	    var dimension = getDimension({
	      ref: ref,
	      descriptor: descriptor,
	      env: env,
	      windowScroll: windowScroll,
	      direction: previous.direction,
	      isDropDisabled: previous.isDropDisabled,
	      isCombineEnabled: previous.isCombineEnabled,
	      shouldClipSubject: !previous.ignoreContainerClipping
	    });
	    var scrollable = env.closestScrollable;
	
	    if (scrollable) {
	      scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
	      scrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
	
	      if (false) {
	        checkForNestedScrollContainers(scrollable);
	      }
	    }
	
	    return dimension;
	  }, [appContext.contextId, descriptor, onClosestScroll, previousRef]);
	  var getScrollWhileDragging = useMemoOne.useCallback(function () {
	    var dragging = whileDraggingRef.current;
	    var closest = getClosestScrollableFromDrag(dragging);
	    !(dragging && closest) ?  false ? invariant(false, 'Can only recollect Droppable client for Droppables that have a scroll container') : invariant(false) : void 0;
	    return getScroll$1(closest);
	  }, []);
	  var dragStopped = useMemoOne.useCallback(function () {
	    var dragging = whileDraggingRef.current;
	    !dragging ?  false ? invariant(false, 'Cannot stop drag when no active drag') : invariant(false) : void 0;
	    var closest = getClosestScrollableFromDrag(dragging);
	    whileDraggingRef.current = null;
	
	    if (!closest) {
	      return;
	    }
	
	    scheduleScrollUpdate.cancel();
	    closest.removeAttribute(scrollContainer.contextId);
	    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
	  }, [onClosestScroll, scheduleScrollUpdate]);
	  var scroll = useMemoOne.useCallback(function (change) {
	    var dragging = whileDraggingRef.current;
	    !dragging ?  false ? invariant(false, 'Cannot scroll when there is no drag') : invariant(false) : void 0;
	    var closest = getClosestScrollableFromDrag(dragging);
	    !closest ?  false ? invariant(false, 'Cannot scroll a droppable with no closest scrollable') : invariant(false) : void 0;
	    closest.scrollTop += change.y;
	    closest.scrollLeft += change.x;
	  }, []);
	  var callbacks = useMemoOne.useMemo(function () {
	    return {
	      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
	      getScrollWhileDragging: getScrollWhileDragging,
	      dragStopped: dragStopped,
	      scroll: scroll
	    };
	  }, [dragStopped, getDimensionAndWatchScroll, getScrollWhileDragging, scroll]);
	  var entry = useMemoOne.useMemo(function () {
	    return {
	      uniqueId: uniqueId,
	      descriptor: descriptor,
	      callbacks: callbacks
	    };
	  }, [callbacks, descriptor, uniqueId]);
	  useIsomorphicLayoutEffect(function () {
	    publishedDescriptorRef.current = entry.descriptor;
	    registry.droppable.register(entry);
	    return function () {
	      if (whileDraggingRef.current) {
	         false ? warning('Unsupported: changing the droppableId or type of a Droppable during a drag') : void 0;
	        dragStopped();
	      }
	
	      registry.droppable.unregister(entry);
	    };
	  }, [callbacks, descriptor, dragStopped, entry, marshal, registry.droppable]);
	  useIsomorphicLayoutEffect(function () {
	    if (!whileDraggingRef.current) {
	      return;
	    }
	
	    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
	  }, [args.isDropDisabled, marshal]);
	  useIsomorphicLayoutEffect(function () {
	    if (!whileDraggingRef.current) {
	      return;
	    }
	
	    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
	  }, [args.isCombineEnabled, marshal]);
	}
	
	function noop$2() {}
	
	var empty = {
	  width: 0,
	  height: 0,
	  margin: noSpacing
	};
	
	var getSize = function getSize(_ref) {
	  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
	      placeholder = _ref.placeholder,
	      animate = _ref.animate;
	
	  if (isAnimatingOpenOnMount) {
	    return empty;
	  }
	
	  if (animate === 'close') {
	    return empty;
	  }
	
	  return {
	    height: placeholder.client.borderBox.height,
	    width: placeholder.client.borderBox.width,
	    margin: placeholder.client.margin
	  };
	};
	
	var getStyle = function getStyle(_ref2) {
	  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
	      placeholder = _ref2.placeholder,
	      animate = _ref2.animate;
	  var size = getSize({
	    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
	    placeholder: placeholder,
	    animate: animate
	  });
	  return {
	    display: placeholder.display,
	    boxSizing: 'border-box',
	    width: size.width,
	    height: size.height,
	    marginTop: size.margin.top,
	    marginRight: size.margin.right,
	    marginBottom: size.margin.bottom,
	    marginLeft: size.margin.left,
	    flexShrink: '0',
	    flexGrow: '0',
	    pointerEvents: 'none',
	    transition: animate !== 'none' ? transitions.placeholder : null
	  };
	};
	
	function Placeholder(props) {
	  var animateOpenTimerRef = React.useRef(null);
	  var tryClearAnimateOpenTimer = useMemoOne.useCallback(function () {
	    if (!animateOpenTimerRef.current) {
	      return;
	    }
	
	    clearTimeout(animateOpenTimerRef.current);
	    animateOpenTimerRef.current = null;
	  }, []);
	  var animate = props.animate,
	      onTransitionEnd = props.onTransitionEnd,
	      onClose = props.onClose,
	      contextId = props.contextId;
	
	  var _useState = React.useState(props.animate === 'open'),
	      isAnimatingOpenOnMount = _useState[0],
	      setIsAnimatingOpenOnMount = _useState[1];
	
	  React.useEffect(function () {
	    if (!isAnimatingOpenOnMount) {
	      return noop$2;
	    }
	
	    if (animate !== 'open') {
	      tryClearAnimateOpenTimer();
	      setIsAnimatingOpenOnMount(false);
	      return noop$2;
	    }
	
	    if (animateOpenTimerRef.current) {
	      return noop$2;
	    }
	
	    animateOpenTimerRef.current = setTimeout(function () {
	      animateOpenTimerRef.current = null;
	      setIsAnimatingOpenOnMount(false);
	    });
	    return tryClearAnimateOpenTimer;
	  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
	  var onSizeChangeEnd = useMemoOne.useCallback(function (event) {
	    if (event.propertyName !== 'height') {
	      return;
	    }
	
	    onTransitionEnd();
	
	    if (animate === 'close') {
	      onClose();
	    }
	  }, [animate, onClose, onTransitionEnd]);
	  var style = getStyle({
	    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
	    animate: props.animate,
	    placeholder: props.placeholder
	  });
	  return React__default.createElement(props.placeholder.tagName, {
	    style: style,
	    'data-rbd-placeholder-context-id': contextId,
	    onTransitionEnd: onSizeChangeEnd,
	    ref: props.innerRef
	  });
	}
	
	var Placeholder$1 = React__default.memo(Placeholder);
	
	var DroppableContext = React__default.createContext(null);
	
	function checkIsValidInnerRef(el) {
	  !(el && isHtmlElement(el)) ?  false ? invariant(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : invariant(false) : void 0;
	}
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	function runChecks(args, checks) {
	  checks.forEach(function (check) {
	    return check(args);
	  });
	}
	
	var shared = [function required(_ref) {
	  var props = _ref.props;
	  !props.droppableId ?  false ? invariant(false, 'A Droppable requires a droppableId prop') : invariant(false) : void 0;
	  !(typeof props.droppableId === 'string') ?  false ? invariant(false, "A Droppable requires a [string] droppableId. Provided: [" + typeof props.droppableId + "]") : invariant(false) : void 0;
	}, function _boolean(_ref2) {
	  var props = _ref2.props;
	  !isBoolean(props.isDropDisabled) ?  false ? invariant(false, 'isDropDisabled must be a boolean') : invariant(false) : void 0;
	  !isBoolean(props.isCombineEnabled) ?  false ? invariant(false, 'isCombineEnabled must be a boolean') : invariant(false) : void 0;
	  !isBoolean(props.ignoreContainerClipping) ?  false ? invariant(false, 'ignoreContainerClipping must be a boolean') : invariant(false) : void 0;
	}, function ref(_ref3) {
	  var getDroppableRef = _ref3.getDroppableRef;
	  checkIsValidInnerRef(getDroppableRef());
	}];
	var standard = [function placeholder(_ref4) {
	  var props = _ref4.props,
	      getPlaceholderRef = _ref4.getPlaceholderRef;
	
	  if (!props.placeholder) {
	    return;
	  }
	
	  var ref = getPlaceholderRef();
	
	  if (ref) {
	    return;
	  }
	
	   false ? warning("\n      Droppable setup issue [droppableId: \"" + props.droppableId + "\"]:\n      DroppableProvided > placeholder could not be found.\n\n      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.\n      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md\n    ") : void 0;
	}];
	var virtual = [function hasClone(_ref5) {
	  var props = _ref5.props;
	  !props.renderClone ?  false ? invariant(false, 'Must provide a clone render function (renderClone) for virtual lists') : invariant(false) : void 0;
	}, function hasNoPlaceholder(_ref6) {
	  var getPlaceholderRef = _ref6.getPlaceholderRef;
	  !!getPlaceholderRef() ?  false ? invariant(false, 'Expected virtual list to not have a placeholder') : invariant(false) : void 0;
	}];
	function useValidation(args) {
	  useDevSetupWarning(function () {
	    runChecks(args, shared);
	
	    if (args.props.mode === 'standard') {
	      runChecks(args, standard);
	    }
	
	    if (args.props.mode === 'virtual') {
	      runChecks(args, virtual);
	    }
	  });
	}
	
	var AnimateInOut = function (_React$PureComponent) {
	  _inheritsLoose(AnimateInOut, _React$PureComponent);
	
	  function AnimateInOut() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
	    _this.state = {
	      isVisible: Boolean(_this.props.on),
	      data: _this.props.on,
	      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
	    };
	
	    _this.onClose = function () {
	      if (_this.state.animate !== 'close') {
	        return;
	      }
	
	      _this.setState({
	        isVisible: false
	      });
	    };
	
	    return _this;
	  }
	
	  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (!props.shouldAnimate) {
	      return {
	        isVisible: Boolean(props.on),
	        data: props.on,
	        animate: 'none'
	      };
	    }
	
	    if (props.on) {
	      return {
	        isVisible: true,
	        data: props.on,
	        animate: 'open'
	      };
	    }
	
	    if (state.isVisible) {
	      return {
	        isVisible: true,
	        data: state.data,
	        animate: 'close'
	      };
	    }
	
	    return {
	      isVisible: false,
	      animate: 'close',
	      data: null
	    };
	  };
	
	  var _proto = AnimateInOut.prototype;
	
	  _proto.render = function render() {
	    if (!this.state.isVisible) {
	      return null;
	    }
	
	    var provided = {
	      onClose: this.onClose,
	      data: this.state.data,
	      animate: this.state.animate
	    };
	    return this.props.children(provided);
	  };
	
	  return AnimateInOut;
	}(React__default.PureComponent);
	
	var zIndexOptions = {
	  dragging: 5000,
	  dropAnimating: 4500
	};
	
	var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
	  if (dropping) {
	    return transitions.drop(dropping.duration);
	  }
	
	  if (shouldAnimateDragMovement) {
	    return transitions.snap;
	  }
	
	  return transitions.fluid;
	};
	
	var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
	  if (!isCombining) {
	    return null;
	  }
	
	  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
	};
	
	var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
	  if (dragging.forceShouldAnimate != null) {
	    return dragging.forceShouldAnimate;
	  }
	
	  return dragging.mode === 'SNAP';
	};
	
	function getDraggingStyle(dragging) {
	  var dimension = dragging.dimension;
	  var box = dimension.client;
	  var offset = dragging.offset,
	      combineWith = dragging.combineWith,
	      dropping = dragging.dropping;
	  var isCombining = Boolean(combineWith);
	  var shouldAnimate = getShouldDraggingAnimate(dragging);
	  var isDropAnimating = Boolean(dropping);
	  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
	  var style = {
	    position: 'fixed',
	    top: box.marginBox.top,
	    left: box.marginBox.left,
	    boxSizing: 'border-box',
	    width: box.borderBox.width,
	    height: box.borderBox.height,
	    transition: getDraggingTransition(shouldAnimate, dropping),
	    transform: transform,
	    opacity: getDraggingOpacity(isCombining, isDropAnimating),
	    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
	    pointerEvents: 'none'
	  };
	  return style;
	}
	
	function getSecondaryStyle(secondary) {
	  return {
	    transform: transforms.moveTo(secondary.offset),
	    transition: secondary.shouldAnimateDisplacement ? null : 'none'
	  };
	}
	
	function getStyle$1(mapped) {
	  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
	}
	
	function getDimension$1(descriptor, el, windowScroll) {
	  if (windowScroll === void 0) {
	    windowScroll = origin;
	  }
	
	  var computedStyles = window.getComputedStyle(el);
	  var borderBox = el.getBoundingClientRect();
	  var client = cssBoxModel.calculateBox(borderBox, computedStyles);
	  var page = cssBoxModel.withScroll(client, windowScroll);
	  var placeholder = {
	    client: client,
	    tagName: el.tagName.toLowerCase(),
	    display: computedStyles.display
	  };
	  var displaceBy = {
	    x: client.marginBox.width,
	    y: client.marginBox.height
	  };
	  var dimension = {
	    descriptor: descriptor,
	    placeholder: placeholder,
	    displaceBy: displaceBy,
	    client: client,
	    page: page
	  };
	  return dimension;
	}
	
	function useDraggablePublisher(args) {
	  var uniqueId = useUniqueId('draggable');
	  var descriptor = args.descriptor,
	      registry = args.registry,
	      getDraggableRef = args.getDraggableRef,
	      canDragInteractiveElements = args.canDragInteractiveElements,
	      shouldRespectForcePress = args.shouldRespectForcePress,
	      isEnabled = args.isEnabled;
	  var options = useMemoOne.useMemo(function () {
	    return {
	      canDragInteractiveElements: canDragInteractiveElements,
	      shouldRespectForcePress: shouldRespectForcePress,
	      isEnabled: isEnabled
	    };
	  }, [canDragInteractiveElements, isEnabled, shouldRespectForcePress]);
	  var getDimension = useMemoOne.useCallback(function (windowScroll) {
	    var el = getDraggableRef();
	    !el ?  false ? invariant(false, 'Cannot get dimension when no ref is set') : invariant(false) : void 0;
	    return getDimension$1(descriptor, el, windowScroll);
	  }, [descriptor, getDraggableRef]);
	  var entry = useMemoOne.useMemo(function () {
	    return {
	      uniqueId: uniqueId,
	      descriptor: descriptor,
	      options: options,
	      getDimension: getDimension
	    };
	  }, [descriptor, getDimension, options, uniqueId]);
	  var publishedRef = React.useRef(entry);
	  var isFirstPublishRef = React.useRef(true);
	  useIsomorphicLayoutEffect(function () {
	    registry.draggable.register(publishedRef.current);
	    return function () {
	      return registry.draggable.unregister(publishedRef.current);
	    };
	  }, [registry.draggable]);
	  useIsomorphicLayoutEffect(function () {
	    if (isFirstPublishRef.current) {
	      isFirstPublishRef.current = false;
	      return;
	    }
	
	    var last = publishedRef.current;
	    publishedRef.current = entry;
	    registry.draggable.update(entry, last);
	  }, [entry, registry.draggable]);
	}
	
	function useValidation$1(props, contextId, getRef) {
	  useDevSetupWarning(function () {
	    function prefix(id) {
	      return "Draggable[id: " + id + "]: ";
	    }
	
	    var id = props.draggableId;
	    !id ?  false ? invariant(false, 'Draggable requires a draggableId') : invariant(false) : void 0;
	    !(typeof id === 'string') ?  false ? invariant(false, "Draggable requires a [string] draggableId.\n      Provided: [type: " + typeof id + "] (value: " + id + ")") : invariant(false) : void 0;
	    !isInteger(props.index) ?  false ? invariant(false, prefix(id) + " requires an integer index prop") : invariant(false) : void 0;
	
	    if (props.mapped.type === 'DRAGGING') {
	      return;
	    }
	
	    checkIsValidInnerRef(getRef());
	
	    if (props.isEnabled) {
	      !findDragHandle(contextId, id) ?  false ? invariant(false, prefix(id) + " Unable to find drag handle") : invariant(false) : void 0;
	    }
	  });
	}
	function useClonePropValidation(isClone) {
	  useDev(function () {
	    var initialRef = React.useRef(isClone);
	    useDevSetupWarning(function () {
	      !(isClone === initialRef.current) ?  false ? invariant(false, 'Draggable isClone prop value changed during component life') : invariant(false) : void 0;
	    }, [isClone]);
	  });
	}
	
	function preventHtml5Dnd(event) {
	  event.preventDefault();
	}
	
	function Draggable(props) {
	  var ref = React.useRef(null);
	  var setRef = useMemoOne.useCallback(function (el) {
	    ref.current = el;
	  }, []);
	  var getRef = useMemoOne.useCallback(function () {
	    return ref.current;
	  }, []);
	
	  var _useRequiredContext = useRequiredContext(AppContext),
	      contextId = _useRequiredContext.contextId,
	      dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId,
	      registry = _useRequiredContext.registry;
	
	  var _useRequiredContext2 = useRequiredContext(DroppableContext),
	      type = _useRequiredContext2.type,
	      droppableId = _useRequiredContext2.droppableId;
	
	  var descriptor = useMemoOne.useMemo(function () {
	    return {
	      id: props.draggableId,
	      index: props.index,
	      type: type,
	      droppableId: droppableId
	    };
	  }, [props.draggableId, props.index, type, droppableId]);
	  var children = props.children,
	      draggableId = props.draggableId,
	      isEnabled = props.isEnabled,
	      shouldRespectForcePress = props.shouldRespectForcePress,
	      canDragInteractiveElements = props.canDragInteractiveElements,
	      isClone = props.isClone,
	      mapped = props.mapped,
	      dropAnimationFinishedAction = props.dropAnimationFinished;
	  useValidation$1(props, contextId, getRef);
	  useClonePropValidation(isClone);
	
	  if (!isClone) {
	    var forPublisher = useMemoOne.useMemo(function () {
	      return {
	        descriptor: descriptor,
	        registry: registry,
	        getDraggableRef: getRef,
	        canDragInteractiveElements: canDragInteractiveElements,
	        shouldRespectForcePress: shouldRespectForcePress,
	        isEnabled: isEnabled
	      };
	    }, [descriptor, registry, getRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled]);
	    useDraggablePublisher(forPublisher);
	  }
	
	  var dragHandleProps = useMemoOne.useMemo(function () {
	    return isEnabled ? {
	      tabIndex: 0,
	      role: 'button',
	      'aria-describedby': dragHandleUsageInstructionsId,
	      'data-rbd-drag-handle-draggable-id': draggableId,
	      'data-rbd-drag-handle-context-id': contextId,
	      draggable: false,
	      onDragStart: preventHtml5Dnd
	    } : null;
	  }, [contextId, dragHandleUsageInstructionsId, draggableId, isEnabled]);
	  var onMoveEnd = useMemoOne.useCallback(function (event) {
	    if (mapped.type !== 'DRAGGING') {
	      return;
	    }
	
	    if (!mapped.dropping) {
	      return;
	    }
	
	    if (event.propertyName !== 'transform') {
	      return;
	    }
	
	    dropAnimationFinishedAction();
	  }, [dropAnimationFinishedAction, mapped]);
	  var provided = useMemoOne.useMemo(function () {
	    var style = getStyle$1(mapped);
	    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
	    var result = {
	      innerRef: setRef,
	      draggableProps: {
	        'data-rbd-draggable-context-id': contextId,
	        'data-rbd-draggable-id': draggableId,
	        style: style,
	        onTransitionEnd: onTransitionEnd
	      },
	      dragHandleProps: dragHandleProps
	    };
	    return result;
	  }, [contextId, dragHandleProps, draggableId, mapped, onMoveEnd, setRef]);
	  var rubric = useMemoOne.useMemo(function () {
	    return {
	      draggableId: descriptor.id,
	      type: descriptor.type,
	      source: {
	        index: descriptor.index,
	        droppableId: descriptor.droppableId
	      }
	    };
	  }, [descriptor.droppableId, descriptor.id, descriptor.index, descriptor.type]);
	  return children(provided, mapped.snapshot, rubric);
	}
	
	var isStrictEqual = (function (a, b) {
	  return a === b;
	});
	
	var whatIsDraggedOverFromResult = (function (result) {
	  var combine = result.combine,
	      destination = result.destination;
	
	  if (destination) {
	    return destination.droppableId;
	  }
	
	  if (combine) {
	    return combine.droppableId;
	  }
	
	  return null;
	});
	
	var getCombineWithFromResult = function getCombineWithFromResult(result) {
	  return result.combine ? result.combine.draggableId : null;
	};
	
	var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
	  return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
	};
	
	function getDraggableSelector() {
	  var memoizedOffset = memoizeOne(function (x, y) {
	    return {
	      x: x,
	      y: y
	    };
	  });
	  var getMemoizedSnapshot = memoizeOne(function (mode, isClone, draggingOver, combineWith, dropping) {
	    return {
	      isDragging: true,
	      isClone: isClone,
	      isDropAnimating: Boolean(dropping),
	      dropAnimation: dropping,
	      mode: mode,
	      draggingOver: draggingOver,
	      combineWith: combineWith,
	      combineTargetFor: null
	    };
	  });
	  var getMemoizedProps = memoizeOne(function (offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
	    return {
	      mapped: {
	        type: 'DRAGGING',
	        dropping: null,
	        draggingOver: draggingOver,
	        combineWith: combineWith,
	        mode: mode,
	        offset: offset,
	        dimension: dimension,
	        forceShouldAnimate: forceShouldAnimate,
	        snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
	      }
	    };
	  });
	
	  var selector = function selector(state, ownProps) {
	    if (state.isDragging) {
	      if (state.critical.draggable.id !== ownProps.draggableId) {
	        return null;
	      }
	
	      var offset = state.current.client.offset;
	      var dimension = state.dimensions.draggables[ownProps.draggableId];
	      var draggingOver = whatIsDraggedOver(state.impact);
	      var combineWith = getCombineWithFromImpact(state.impact);
	      var forceShouldAnimate = state.forceShouldAnimate;
	      return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
	    }
	
	    if (state.phase === 'DROP_ANIMATING') {
	      var completed = state.completed;
	
	      if (completed.result.draggableId !== ownProps.draggableId) {
	        return null;
	      }
	
	      var isClone = ownProps.isClone;
	      var _dimension = state.dimensions.draggables[ownProps.draggableId];
	      var result = completed.result;
	      var mode = result.mode;
	
	      var _draggingOver = whatIsDraggedOverFromResult(result);
	
	      var _combineWith = getCombineWithFromResult(result);
	
	      var duration = state.dropDuration;
	      var dropping = {
	        duration: duration,
	        curve: curves.drop,
	        moveTo: state.newHomeClientOffset,
	        opacity: _combineWith ? combine.opacity.drop : null,
	        scale: _combineWith ? combine.scale.drop : null
	      };
	      return {
	        mapped: {
	          type: 'DRAGGING',
	          offset: state.newHomeClientOffset,
	          dimension: _dimension,
	          dropping: dropping,
	          draggingOver: _draggingOver,
	          combineWith: _combineWith,
	          mode: mode,
	          forceShouldAnimate: null,
	          snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
	        }
	      };
	    }
	
	    return null;
	  };
	
	  return selector;
	}
	
	function getSecondarySnapshot(combineTargetFor) {
	  return {
	    isDragging: false,
	    isDropAnimating: false,
	    isClone: false,
	    dropAnimation: null,
	    mode: null,
	    draggingOver: null,
	    combineTargetFor: combineTargetFor,
	    combineWith: null
	  };
	}
	
	var atRest = {
	  mapped: {
	    type: 'SECONDARY',
	    offset: origin,
	    combineTargetFor: null,
	    shouldAnimateDisplacement: true,
	    snapshot: getSecondarySnapshot(null)
	  }
	};
	
	function getSecondarySelector() {
	  var memoizedOffset = memoizeOne(function (x, y) {
	    return {
	      x: x,
	      y: y
	    };
	  });
	  var getMemoizedSnapshot = memoizeOne(getSecondarySnapshot);
	  var getMemoizedProps = memoizeOne(function (offset, combineTargetFor, shouldAnimateDisplacement) {
	    if (combineTargetFor === void 0) {
	      combineTargetFor = null;
	    }
	
	    return {
	      mapped: {
	        type: 'SECONDARY',
	        offset: offset,
	        combineTargetFor: combineTargetFor,
	        shouldAnimateDisplacement: shouldAnimateDisplacement,
	        snapshot: getMemoizedSnapshot(combineTargetFor)
	      }
	    };
	  });
	
	  var getFallback = function getFallback(combineTargetFor) {
	    return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
	  };
	
	  var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
	    var visualDisplacement = impact.displaced.visible[ownId];
	    var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
	    var combine = tryGetCombine(impact);
	    var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
	
	    if (!visualDisplacement) {
	      if (!isAfterCriticalInVirtualList) {
	        return getFallback(combineTargetFor);
	      }
	
	      if (impact.displaced.invisible[ownId]) {
	        return null;
	      }
	
	      var change = negate(afterCritical.displacedBy.point);
	
	      var _offset = memoizedOffset(change.x, change.y);
	
	      return getMemoizedProps(_offset, combineTargetFor, true);
	    }
	
	    if (isAfterCriticalInVirtualList) {
	      return getFallback(combineTargetFor);
	    }
	
	    var displaceBy = impact.displacedBy.point;
	    var offset = memoizedOffset(displaceBy.x, displaceBy.y);
	    return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
	  };
	
	  var selector = function selector(state, ownProps) {
	    if (state.isDragging) {
	      if (state.critical.draggable.id === ownProps.draggableId) {
	        return null;
	      }
	
	      return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
	    }
	
	    if (state.phase === 'DROP_ANIMATING') {
	      var completed = state.completed;
	
	      if (completed.result.draggableId === ownProps.draggableId) {
	        return null;
	      }
	
	      return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
	    }
	
	    return null;
	  };
	
	  return selector;
	}
	
	var makeMapStateToProps = function makeMapStateToProps() {
	  var draggingSelector = getDraggableSelector();
	  var secondarySelector = getSecondarySelector();
	
	  var selector = function selector(state, ownProps) {
	    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
	  };
	
	  return selector;
	};
	var mapDispatchToProps = {
	  dropAnimationFinished: dropAnimationFinished
	};
	var ConnectedDraggable = reactRedux.connect(makeMapStateToProps, mapDispatchToProps, null, {
	  context: StoreContext,
	  pure: true,
	  areStatePropsEqual: isStrictEqual
	})(Draggable);
	
	function PrivateDraggable(props) {
	  var droppableContext = useRequiredContext(DroppableContext);
	  var isUsingCloneFor = droppableContext.isUsingCloneFor;
	
	  if (isUsingCloneFor === props.draggableId && !props.isClone) {
	    return null;
	  }
	
	  return React__default.createElement(ConnectedDraggable, props);
	}
	function PublicDraggable(props) {
	  var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
	  var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
	  var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
	  return React__default.createElement(PrivateDraggable, _extends({}, props, {
	    isClone: false,
	    isEnabled: isEnabled,
	    canDragInteractiveElements: canDragInteractiveElements,
	    shouldRespectForcePress: shouldRespectForcePress
	  }));
	}
	
	function Droppable(props) {
	  var appContext = React.useContext(AppContext);
	  !appContext ?  false ? invariant(false, 'Could not find app context') : invariant(false) : void 0;
	  var contextId = appContext.contextId,
	      isMovementAllowed = appContext.isMovementAllowed;
	  var droppableRef = React.useRef(null);
	  var placeholderRef = React.useRef(null);
	  var children = props.children,
	      droppableId = props.droppableId,
	      type = props.type,
	      mode = props.mode,
	      direction = props.direction,
	      ignoreContainerClipping = props.ignoreContainerClipping,
	      isDropDisabled = props.isDropDisabled,
	      isCombineEnabled = props.isCombineEnabled,
	      snapshot = props.snapshot,
	      useClone = props.useClone,
	      updateViewportMaxScroll = props.updateViewportMaxScroll,
	      getContainerForClone = props.getContainerForClone;
	  var getDroppableRef = useMemoOne.useCallback(function () {
	    return droppableRef.current;
	  }, []);
	  var setDroppableRef = useMemoOne.useCallback(function (value) {
	    droppableRef.current = value;
	  }, []);
	  var getPlaceholderRef = useMemoOne.useCallback(function () {
	    return placeholderRef.current;
	  }, []);
	  var setPlaceholderRef = useMemoOne.useCallback(function (value) {
	    placeholderRef.current = value;
	  }, []);
	  useValidation({
	    props: props,
	    getDroppableRef: getDroppableRef,
	    getPlaceholderRef: getPlaceholderRef
	  });
	  var onPlaceholderTransitionEnd = useMemoOne.useCallback(function () {
	    if (isMovementAllowed()) {
	      updateViewportMaxScroll({
	        maxScroll: getMaxWindowScroll()
	      });
	    }
	  }, [isMovementAllowed, updateViewportMaxScroll]);
	  useDroppablePublisher({
	    droppableId: droppableId,
	    type: type,
	    mode: mode,
	    direction: direction,
	    isDropDisabled: isDropDisabled,
	    isCombineEnabled: isCombineEnabled,
	    ignoreContainerClipping: ignoreContainerClipping,
	    getDroppableRef: getDroppableRef
	  });
	  var placeholder = React__default.createElement(AnimateInOut, {
	    on: props.placeholder,
	    shouldAnimate: props.shouldAnimatePlaceholder
	  }, function (_ref) {
	    var onClose = _ref.onClose,
	        data = _ref.data,
	        animate = _ref.animate;
	    return React__default.createElement(Placeholder$1, {
	      placeholder: data,
	      onClose: onClose,
	      innerRef: setPlaceholderRef,
	      animate: animate,
	      contextId: contextId,
	      onTransitionEnd: onPlaceholderTransitionEnd
	    });
	  });
	  var provided = useMemoOne.useMemo(function () {
	    return {
	      innerRef: setDroppableRef,
	      placeholder: placeholder,
	      droppableProps: {
	        'data-rbd-droppable-id': droppableId,
	        'data-rbd-droppable-context-id': contextId
	      }
	    };
	  }, [contextId, droppableId, placeholder, setDroppableRef]);
	  var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
	  var droppableContext = useMemoOne.useMemo(function () {
	    return {
	      droppableId: droppableId,
	      type: type,
	      isUsingCloneFor: isUsingCloneFor
	    };
	  }, [droppableId, isUsingCloneFor, type]);
	
	  function getClone() {
	    if (!useClone) {
	      return null;
	    }
	
	    var dragging = useClone.dragging,
	        render = useClone.render;
	    var node = React__default.createElement(PrivateDraggable, {
	      draggableId: dragging.draggableId,
	      index: dragging.source.index,
	      isClone: true,
	      isEnabled: true,
	      shouldRespectForcePress: false,
	      canDragInteractiveElements: true
	    }, function (draggableProvided, draggableSnapshot) {
	      return render(draggableProvided, draggableSnapshot, dragging);
	    });
	    return ReactDOM.createPortal(node, getContainerForClone());
	  }
	
	  return React__default.createElement(DroppableContext.Provider, {
	    value: droppableContext
	  }, children(provided, snapshot), getClone());
	}
	
	var isMatchingType = function isMatchingType(type, critical) {
	  return type === critical.droppable.type;
	};
	
	var getDraggable = function getDraggable(critical, dimensions) {
	  return dimensions.draggables[critical.draggable.id];
	};
	
	var makeMapStateToProps$1 = function makeMapStateToProps() {
	  var idleWithAnimation = {
	    placeholder: null,
	    shouldAnimatePlaceholder: true,
	    snapshot: {
	      isDraggingOver: false,
	      draggingOverWith: null,
	      draggingFromThisWith: null,
	      isUsingPlaceholder: false
	    },
	    useClone: null
	  };
	
	  var idleWithoutAnimation = _extends({}, idleWithAnimation, {
	    shouldAnimatePlaceholder: false
	  });
	
	  var getDraggableRubric = memoizeOne(function (descriptor) {
	    return {
	      draggableId: descriptor.id,
	      type: descriptor.type,
	      source: {
	        index: descriptor.index,
	        droppableId: descriptor.droppableId
	      }
	    };
	  });
	  var getMapProps = memoizeOne(function (id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
	    var draggableId = dragging.descriptor.id;
	    var isHome = dragging.descriptor.droppableId === id;
	
	    if (isHome) {
	      var useClone = renderClone ? {
	        render: renderClone,
	        dragging: getDraggableRubric(dragging.descriptor)
	      } : null;
	      var _snapshot = {
	        isDraggingOver: isDraggingOverForConsumer,
	        draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
	        draggingFromThisWith: draggableId,
	        isUsingPlaceholder: true
	      };
	      return {
	        placeholder: dragging.placeholder,
	        shouldAnimatePlaceholder: false,
	        snapshot: _snapshot,
	        useClone: useClone
	      };
	    }
	
	    if (!isEnabled) {
	      return idleWithoutAnimation;
	    }
	
	    if (!isDraggingOverForImpact) {
	      return idleWithAnimation;
	    }
	
	    var snapshot = {
	      isDraggingOver: isDraggingOverForConsumer,
	      draggingOverWith: draggableId,
	      draggingFromThisWith: null,
	      isUsingPlaceholder: true
	    };
	    return {
	      placeholder: dragging.placeholder,
	      shouldAnimatePlaceholder: true,
	      snapshot: snapshot,
	      useClone: null
	    };
	  });
	
	  var selector = function selector(state, ownProps) {
	    var id = ownProps.droppableId;
	    var type = ownProps.type;
	    var isEnabled = !ownProps.isDropDisabled;
	    var renderClone = ownProps.renderClone;
	
	    if (state.isDragging) {
	      var critical = state.critical;
	
	      if (!isMatchingType(type, critical)) {
	        return idleWithoutAnimation;
	      }
	
	      var dragging = getDraggable(critical, state.dimensions);
	      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
	      return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
	    }
	
	    if (state.phase === 'DROP_ANIMATING') {
	      var completed = state.completed;
	
	      if (!isMatchingType(type, completed.critical)) {
	        return idleWithoutAnimation;
	      }
	
	      var _dragging = getDraggable(completed.critical, state.dimensions);
	
	      return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
	    }
	
	    if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
	      var _completed = state.completed;
	
	      if (!isMatchingType(type, _completed.critical)) {
	        return idleWithoutAnimation;
	      }
	
	      var wasOver = whatIsDraggedOver(_completed.impact) === id;
	      var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
	      var isHome = _completed.critical.droppable.id === id;
	
	      if (wasOver) {
	        return wasCombining ? idleWithAnimation : idleWithoutAnimation;
	      }
	
	      if (isHome) {
	        return idleWithAnimation;
	      }
	
	      return idleWithoutAnimation;
	    }
	
	    return idleWithoutAnimation;
	  };
	
	  return selector;
	};
	var mapDispatchToProps$1 = {
	  updateViewportMaxScroll: updateViewportMaxScroll
	};
	
	function getBody() {
	  !document.body ?  false ? invariant(false, 'document.body is not ready') : invariant(false) : void 0;
	  return document.body;
	}
	
	var defaultProps = {
	  mode: 'standard',
	  type: 'DEFAULT',
	  direction: 'vertical',
	  isDropDisabled: false,
	  isCombineEnabled: false,
	  ignoreContainerClipping: false,
	  renderClone: null,
	  getContainerForClone: getBody
	};
	var ConnectedDroppable = reactRedux.connect(makeMapStateToProps$1, mapDispatchToProps$1, null, {
	  context: StoreContext,
	  pure: true,
	  areStatePropsEqual: isStrictEqual
	})(Droppable);
	ConnectedDroppable.defaultProps = defaultProps;
	
	exports.DragDropContext = DragDropContext;
	exports.Draggable = PublicDraggable;
	exports.Droppable = ConnectedDroppable;
	exports.resetServerContext = resetServerContext;
	exports.useKeyboardSensor = useKeyboardSensor;
	exports.useMouseSensor = useMouseSensor;
	exports.useTouchSensor = useTouchSensor;


/***/ },
/* 400 */
/***/ function(module, exports) {

	/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
	
	var hasElementType = typeof Element !== 'undefined';
	var hasMap = typeof Map === 'function';
	var hasSet = typeof Set === 'function';
	var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
	
	// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
	
	function equal(a, b) {
	  // START: fast-deep-equal es6/index.js 3.1.3
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    if (a.constructor !== b.constructor) return false;
	
	    var length, i, keys;
	    if (Array.isArray(a)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    // START: Modifications:
	    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
	    //    to co-exist with es5.
	    // 2. Replace `for of` with es5 compliant iteration using `for`.
	    //    Basically, take:
	    //
	    //    ```js
	    //    for (i of a.entries())
	    //      if (!b.has(i[0])) return false;
	    //    ```
	    //
	    //    ... and convert to:
	    //
	    //    ```js
	    //    it = a.entries();
	    //    while (!(i = it.next()).done)
	    //      if (!b.has(i.value[0])) return false;
	    //    ```
	    //
	    //    **Note**: `i` access switches to `i.value`.
	    var it;
	    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
	      if (a.size !== b.size) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!b.has(i.value[0])) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!equal(i.value[1], b.get(i.value[0]))) return false;
	      return true;
	    }
	
	    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
	      if (a.size !== b.size) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!b.has(i.value[0])) return false;
	      return true;
	    }
	    // END: Modifications
	
	    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (a[i] !== b[i]) return false;
	      return true;
	    }
	
	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
	    // START: Modifications:
	    // Apply guards for `Object.create(null)` handling. See:
	    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
	    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
	    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
	    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
	    // END: Modifications
	
	    keys = Object.keys(a);
	    length = keys.length;
	    if (length !== Object.keys(b).length) return false;
	
	    for (i = length; i-- !== 0;)
	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
	    // END: fast-deep-equal
	
	    // START: react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element) return false;
	
	    // custom handling for React/Preact
	    for (i = length; i-- !== 0;) {
	      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner
	        // Preact-specific: avoid traversing Preact elements' __v and __o
	        //    __v = $_original / $_vnode
	        //    __o = $_owner
	        // These properties contain circular references and are not needed when
	        // comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of elements
	
	        continue;
	      }
	
	      // all other properties should be traversed as usual
	      if (!equal(a[keys[i]], b[keys[i]])) return false;
	    }
	    // END: react-fast-compare
	
	    // START: fast-deep-equal
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function isEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (((error.message || '').match(/stack|recursion/i))) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('react-fast-compare cannot handle circular refs');
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = convertNodeToElement;
	
	var _elementTypes = __webpack_require__(956);
	
	var _elementTypes2 = _interopRequireDefault(_elementTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a htmlparser2 node to a React element
	 *
	 * @param {Object} node The htmlparser2 node to convert
	 * @param {Number} index The index of the current node
	 * @param {Function} transform Transform function to apply to children of the node
	 * @returns {React.Element}
	 */
	function convertNodeToElement(node, index, transform) {
	  return _elementTypes2.default[node.type](node, index, transform);
	}

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.htmlparser2 = exports.convertNodeToElement = exports.processNodes = undefined;
	
	var _processNodes = __webpack_require__(160);
	
	Object.defineProperty(exports, 'processNodes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_processNodes).default;
	  }
	});
	
	var _convertNodeToElement = __webpack_require__(401);
	
	Object.defineProperty(exports, 'convertNodeToElement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_convertNodeToElement).default;
	  }
	});
	
	var _htmlparser = __webpack_require__(88);
	
	Object.defineProperty(exports, 'htmlparser2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_htmlparser).default;
	  }
	});
	
	var _HtmlParser = __webpack_require__(948);
	
	var _HtmlParser2 = _interopRequireDefault(_HtmlParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HtmlParser2.default;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = generatePropsFromAttributes;
	
	var _htmlAttributesToReact = __webpack_require__(957);
	
	var _htmlAttributesToReact2 = _interopRequireDefault(_htmlAttributesToReact);
	
	var _inlineStyleToObject = __webpack_require__(958);
	
	var _inlineStyleToObject2 = _interopRequireDefault(_inlineStyleToObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates props for a React element from an object of HTML attributes
	 *
	 * @param {Object} attributes The HTML attributes
	 * @param {String} key The key to give the react element
	 */
	function generatePropsFromAttributes(attributes, key) {
	
	  // generate props
	  var props = _extends({}, (0, _htmlAttributesToReact2.default)(attributes), { key: key });
	
	  // if there is an inline/string style prop then convert it to a React style object
	  // otherwise, it is invalid and omitted
	  if (typeof props.style === 'string' || props.style instanceof String) {
	    props.style = (0, _inlineStyleToObject2.default)(props.style);
	  } else {
	    delete props.style;
	  }
	
	  return props;
	}

/***/ },
/* 404 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidTagOrAttributeName;
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
	
	var nameCache = {};
	
	function isValidTagOrAttributeName(tagName) {
	  if (!nameCache.hasOwnProperty(tagName)) {
	    nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
	  }
	  return nameCache[tagName];
	}

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	// THIS FILE IS AUTO GENERATED
	var GenIcon = __webpack_require__(76).GenIcon
	module.exports.CiAirportSign1 = function CiAirportSign1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Airport_Sign_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M13.105,12.609v2.279a.119.119,0,0,0,.061.105l.622.355a.49.49,0,0,1,.242.365l.049.413a.243.243,0,0,1-.307.263l-1.641-.459a.486.486,0,0,0-.262,0l-1.641.459a.244.244,0,0,1-.308-.263l.05-.413a.487.487,0,0,1,.242-.365l.621-.355a.12.12,0,0,0,.062-.105V12.609a.122.122,0,0,0-.137-.121l-3.485.435A.242.242,0,0,1,7,12.682v-.624a.486.486,0,0,1,.316-.455l3.5-1.313a.122.122,0,0,0,.079-.114V9.435a4.756,4.756,0,0,1,.1-.981h0a1.015,1.015,0,0,1,1.2-.833,1.063,1.063,0,0,1,.819.9l.015.094a6.3,6.3,0,0,1,.077.976v.587a.121.121,0,0,0,.079.114l3.5,1.313a.486.486,0,0,1,.316.455v.624a.243.243,0,0,1-.274.241l-3.484-.435A.121.121,0,0,0,13.105,12.609Z"}},{"tag":"path","attr":{"d":"M12,21.933A9.933,9.933,0,1,1,21.933,12,9.944,9.944,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.933,12,8.943,8.943,0,0,0,12,3.067Z"}}]}]}]})(props);
	};
	module.exports.CiAlarmOff = function CiAlarmOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Alarm_Off"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M4.564,3.856a.5.5,0,0,0-.7.71l.29.29-.5.5a2.019,2.019,0,0,0-.01,2.85l.65.67a8.273,8.273,0,0,0-.71,3.39A8.427,8.427,0,0,0,12,20.686a8.275,8.275,0,0,0,5.72-2.26c.57.57,1.14,1.15,1.71,1.71a.5.5,0,0,0,.71-.7Zm-.21,2.21.51-.5c.32.33.65.65.98.98a6.38,6.38,0,0,0-1.06,1.4l-.43-.44A1.032,1.032,0,0,1,4.354,6.066ZM12,19.686a7.43,7.43,0,0,1-7.42-7.42,7.312,7.312,0,0,1,1.96-5.02l2.59,2.59q3.945,3.945,7.88,7.88A7.27,7.27,0,0,1,12,19.686Z"}},{"tag":"path","attr":{"d":"M20.354,8.216a2.04,2.04,0,0,0,0-2.86l-1.46-1.45a2.01,2.01,0,0,0-2.85,0l-.68.67a8.528,8.528,0,0,0-6.38-.17c-.6.23-.34,1.19.27.97a7.419,7.419,0,0,1,9.64,9.64c-.22.6.74.86.97.26a8.506,8.506,0,0,0-.17-6.39Zm-2.4-1.9a8.068,8.068,0,0,0-1.65-1.27l.44-.43a1.026,1.026,0,0,1,1.45,0l1.45,1.45a1.014,1.014,0,0,1,0,1.44l-.43.44A8.262,8.262,0,0,0,17.954,6.316Z"}}]}]}]})(props);
	};
	module.exports.CiAlarmOn = function CiAlarmOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Alarm_On"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.352,8.213a2.017,2.017,0,0,0,0-2.851L18.9,3.9a2.038,2.038,0,0,0-2.86,0l-.67.659A8.238,8.238,0,0,0,12,3.852a8.332,8.332,0,0,0-3.39.71L7.962,3.9a2.038,2.038,0,0,0-2.86,0L3.652,5.362a2.02,2.02,0,0,0-.01,2.851l.65.67a8.419,8.419,0,1,0,16.13,3.39,8.4,8.4,0,0,0-.72-3.411ZM4.362,6.062l1.45-1.45a1.016,1.016,0,0,1,1.44,0l.44.43a8.427,8.427,0,0,0-2.91,2.9l-.42-.43A1.027,1.027,0,0,1,4.362,6.062ZM12,19.682a7.415,7.415,0,1,1,7.42-7.409A7.421,7.421,0,0,1,12,19.682Zm7.22-11.75a8.578,8.578,0,0,0-2.91-2.89l.44-.43a1.016,1.016,0,0,1,1.44,0l1.45,1.45a1.027,1.027,0,0,1,0,1.451Z"}},{"tag":"path","attr":{"d":"M17.042,12.763H12a.455.455,0,0,1-.27-.081c-.03-.02-.05-.039-.07-.049a.442.442,0,0,1-.16-.36V7.232a.5.5,0,0,1,1,0v4.531h4.54A.5.5,0,0,1,17.042,12.763Z"}}]}]}]})(props);
	};
	module.exports.CiAlignBottom = function CiAlignBottom (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Align_Bottom"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M3.548,20.922h16.9a.5.5,0,0,0,0-1H3.548a.5.5,0,0,0,0,1Z"}},{"tag":"path","attr":{"d":"M9,18.919H6.565a2.5,2.5,0,0,1-2.5-2.5V5.578a2.5,2.5,0,0,1,2.5-2.5H9a2.5,2.5,0,0,1,2.5,2.5V16.419A2.5,2.5,0,0,1,9,18.919ZM6.565,4.078a1.5,1.5,0,0,0-1.5,1.5V16.419a1.5,1.5,0,0,0,1.5,1.5H9a1.5,1.5,0,0,0,1.5-1.5V5.578A1.5,1.5,0,0,0,9,4.078Z"}},{"tag":"path","attr":{"d":"M17.437,18.919H15a2.5,2.5,0,0,1-2.5-2.5V10.55A2.5,2.5,0,0,1,15,8.05h2.434a2.5,2.5,0,0,1,2.5,2.5v5.869A2.5,2.5,0,0,1,17.437,18.919ZM15,9.05a1.5,1.5,0,0,0-1.5,1.5v5.869a1.5,1.5,0,0,0,1.5,1.5h2.434a1.5,1.5,0,0,0,1.5-1.5V10.55a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiAlignCenterH = function CiAlignCenterH (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Align_Center-H"},"child":[{"tag":"path","attr":{"d":"M17.42,4.062H12.5v-.51a.5.5,0,0,0-1,0v.51H6.58a2.507,2.507,0,0,0-2.5,2.5V9a2.5,2.5,0,0,0,2.5,2.5H11.5v1H9.06A2.507,2.507,0,0,0,6.56,15v2.44a2.507,2.507,0,0,0,2.5,2.5H11.5v.51a.5.5,0,0,0,1,0v-.51h2.43a2.5,2.5,0,0,0,2.5-2.5V15a2.5,2.5,0,0,0-2.5-2.5H12.5v-1h4.92A2.5,2.5,0,0,0,19.92,9V6.562A2.507,2.507,0,0,0,17.42,4.062ZM11.5,18.942H9.06a1.511,1.511,0,0,1-1.5-1.5V15a1.5,1.5,0,0,1,1.5-1.5H11.5Zm0-8.44H6.58A1.5,1.5,0,0,1,5.08,9V6.562a1.5,1.5,0,0,1,1.5-1.5H11.5Zm3.43,3a1.5,1.5,0,0,1,1.5,1.5v2.44a1.5,1.5,0,0,1-1.5,1.5H12.5V13.5ZM18.92,9a1.5,1.5,0,0,1-1.5,1.5H12.5V5.062h4.92a1.5,1.5,0,0,1,1.5,1.5Z"}}]}]})(props);
	};
	module.exports.CiAlignCenterV = function CiAlignCenterV (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Align_Center-V"},"child":[{"tag":"path","attr":{"d":"M20.446,11.5h-.51V9.07a2.5,2.5,0,0,0-2.5-2.5h-2.43a2.5,2.5,0,0,0-2.5,2.5V11.5H11.5V6.58A2.5,2.5,0,0,0,9,4.08H6.566a2.5,2.5,0,0,0-2.5,2.5V11.5h-.52a.5.5,0,0,0,0,1h.52v4.92a2.5,2.5,0,0,0,2.5,2.5H9a2.5,2.5,0,0,0,2.5-2.5V12.5h1.01v2.43a2.5,2.5,0,0,0,2.5,2.5h2.43a2.5,2.5,0,0,0,2.5-2.5V12.5h.51A.5.5,0,0,0,20.446,11.5ZM10.5,17.42A1.5,1.5,0,0,1,9,18.92H6.566a1.5,1.5,0,0,1-1.5-1.5V12.5H10.5Zm0-5.92H5.066V6.58a1.5,1.5,0,0,1,1.5-1.5H9a1.5,1.5,0,0,1,1.5,1.5Zm8.44,3.43a1.5,1.5,0,0,1-1.5,1.5h-2.43a1.5,1.5,0,0,1-1.5-1.5V12.5h5.43Zm0-3.43h-5.43V9.07a1.5,1.5,0,0,1,1.5-1.5h2.43a1.5,1.5,0,0,1,1.5,1.5Z"}}]}]})(props);
	};
	module.exports.CiAlignLeft = function CiAlignLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Align_Left"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M3.078,3.548v16.9a.5.5,0,0,0,1,0V3.548a.5.5,0,0,0-1,0Z"}},{"tag":"path","attr":{"d":"M18.422,11.5H7.582A2.5,2.5,0,0,1,5.082,9V6.565a2.5,2.5,0,0,1,2.5-2.5h10.84a2.5,2.5,0,0,1,2.5,2.5V9A2.5,2.5,0,0,1,18.422,11.5ZM7.582,5.065a1.5,1.5,0,0,0-1.5,1.5V9a1.5,1.5,0,0,0,1.5,1.5h10.84a1.5,1.5,0,0,0,1.5-1.5V6.565a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M13.451,19.938H7.582a2.5,2.5,0,0,1-2.5-2.5V15a2.5,2.5,0,0,1,2.5-2.5h5.869a2.5,2.5,0,0,1,2.5,2.5v2.436A2.5,2.5,0,0,1,13.451,19.938ZM7.582,13.5a1.5,1.5,0,0,0-1.5,1.5v2.436a1.5,1.5,0,0,0,1.5,1.5h5.869a1.5,1.5,0,0,0,1.5-1.5V15a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiAlignRight = function CiAlignRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Align_Right"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.922,3.548v16.9a.5.5,0,0,0,1,0V3.548a.5.5,0,0,0-1,0Z"}},{"tag":"path","attr":{"d":"M16.419,11.5H5.578A2.5,2.5,0,0,1,3.078,9V6.565a2.5,2.5,0,0,1,2.5-2.5H16.419a2.5,2.5,0,0,1,2.5,2.5V9A2.5,2.5,0,0,1,16.419,11.5ZM5.578,5.065a1.5,1.5,0,0,0-1.5,1.5V9a1.5,1.5,0,0,0,1.5,1.5H16.419a1.5,1.5,0,0,0,1.5-1.5V6.565a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M16.419,19.938H10.55a2.5,2.5,0,0,1-2.5-2.5V15a2.5,2.5,0,0,1,2.5-2.5h5.869a2.5,2.5,0,0,1,2.5,2.5v2.436A2.5,2.5,0,0,1,16.419,19.938ZM10.55,13.5A1.5,1.5,0,0,0,9.05,15v2.436a1.5,1.5,0,0,0,1.5,1.5h5.869a1.5,1.5,0,0,0,1.5-1.5V15a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiAlignTop = function CiAlignTop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Align_Top"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M3.548,4.078h16.9a.5.5,0,0,0,0-1H3.548a.5.5,0,0,0,0,1Z"}},{"tag":"path","attr":{"d":"M9,20.922H6.565a2.5,2.5,0,0,1-2.5-2.5V7.582a2.5,2.5,0,0,1,2.5-2.5H9a2.5,2.5,0,0,1,2.5,2.5v10.84A2.5,2.5,0,0,1,9,20.922ZM6.565,6.082a1.5,1.5,0,0,0-1.5,1.5v10.84a1.5,1.5,0,0,0,1.5,1.5H9a1.5,1.5,0,0,0,1.5-1.5V7.582A1.5,1.5,0,0,0,9,6.082Z"}},{"tag":"path","attr":{"d":"M17.438,15.951H15a2.5,2.5,0,0,1-2.5-2.5V7.582a2.5,2.5,0,0,1,2.5-2.5h2.435a2.5,2.5,0,0,1,2.5,2.5v5.869A2.5,2.5,0,0,1,17.438,15.951ZM15,6.082a1.5,1.5,0,0,0-1.5,1.5v5.869a1.5,1.5,0,0,0,1.5,1.5h2.435a1.5,1.5,0,0,0,1.5-1.5V7.582a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiApple = function CiApple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Apple"},"child":[{"tag":"path","attr":{"d":"M14.875,6.612l.05-.05a3.229,3.229,0,0,0,.95-2.58.976.976,0,0,0-.9-.9,3.229,3.229,0,0,0-2.58.95,3.279,3.279,0,0,0-.85,1.46,4.661,4.661,0,0,0-2.69-1.75.5.5,0,1,0-.22.98,3.664,3.664,0,0,1,2.59,2.2,5.577,5.577,0,0,0-1.9-.32,5.847,5.847,0,0,0-5.84,5.84c0,2.98,2.41,8.49,5.84,8.49a5.821,5.821,0,0,0,2.4-.52.683.683,0,0,1,.56,0,5.73,5.73,0,0,0,2.38.52c3.44,0,5.85-5.51,5.85-8.49A5.838,5.838,0,0,0,14.875,6.612Zm-1.77-1.87a2.3,2.3,0,0,1,1.78-.68c0,.06.01.12.01.17a2.326,2.326,0,0,1-.67,1.63,2.359,2.359,0,0,1-1.79.66A2.247,2.247,0,0,1,13.105,4.742Zm1.56,15.19a4.787,4.787,0,0,1-1.97-.43,1.718,1.718,0,0,0-.69-.15,1.649,1.649,0,0,0-.69.15,4.879,4.879,0,0,1-1.99.43c-2.58,0-4.84-4.67-4.84-7.49a4.855,4.855,0,0,1,6.83-4.42,1.56,1.56,0,0,0,.67.15h.02a1.683,1.683,0,0,0,.69-.15,4.777,4.777,0,0,1,1.97-.42,4.852,4.852,0,0,1,4.85,4.84C19.515,15.262,17.245,19.932,14.665,19.932Z"}}]}]})(props);
	};
	module.exports.CiAt = function CiAt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"At"},"child":[{"tag":"path","attr":{"d":"M12.09,21.925a9.846,9.846,0,0,1-3.838-.747A9.673,9.673,0,0,1,3.005,15.93,10.034,10.034,0,0,1,2.244,12a10.425,10.425,0,0,1,.695-3.8,9.606,9.606,0,0,1,2-3.169A9.269,9.269,0,0,1,8.1,2.862a10.605,10.605,0,0,1,4.175-.787,10.516,10.516,0,0,1,4.334.827A8.437,8.437,0,0,1,19.64,5.119a8.622,8.622,0,0,1,1.707,3.1,9.263,9.263,0,0,1,.377,3.487,5.809,5.809,0,0,1-1.3,3.6A3.6,3.6,0,0,1,17.7,16.473a3.628,3.628,0,0,1-2.162-.609,2.82,2.82,0,0,1-1.119-1.694l.5.106a2.582,2.582,0,0,1-1.3,1.3A4.37,4.37,0,0,1,11.746,16,3.681,3.681,0,0,1,9.88,15.54a3.2,3.2,0,0,1-1.237-1.271A3.843,3.843,0,0,1,8.2,12.4a3.88,3.88,0,0,1,.456-1.926A3.191,3.191,0,0,1,9.919,9.214a3.792,3.792,0,0,1,1.853-.443,4.716,4.716,0,0,1,1.767.364,2.622,2.622,0,0,1,1.383,1.3l-.5.5V9.461a.4.4,0,0,1,.4-.4h.232a.4.4,0,0,1,.4.4v3.518a2.723,2.723,0,0,0,.529,1.674,2.173,2.173,0,0,0,1.853.708,2.281,2.281,0,0,0,1.323-.41,2.938,2.938,0,0,0,.967-1.178,4.947,4.947,0,0,0,.437-1.852,9.439,9.439,0,0,0-.417-3.574A7.285,7.285,0,0,0,18.5,5.588a7.424,7.424,0,0,0-2.679-1.78,9.605,9.605,0,0,0-3.547-.622,9.041,9.041,0,0,0-3.758.741,8.252,8.252,0,0,0-2.773,2,8.8,8.8,0,0,0-1.72,2.838,9.27,9.27,0,0,0-.589,3.262,8.568,8.568,0,0,0,.682,3.408A8.951,8.951,0,0,0,6,18.24a8.707,8.707,0,0,0,2.785,1.892,8.515,8.515,0,0,0,3.389.682,9.851,9.851,0,0,0,2.679-.378,8.451,8.451,0,0,0,2-.831.4.4,0,0,1,.553.158l.1.192a.4.4,0,0,1-.141.526,9.832,9.832,0,0,1-2.391,1.04A10.5,10.5,0,0,1,12.09,21.925ZM11.8,14.859a2.469,2.469,0,0,0,1.786-.649,2.427,2.427,0,0,0,.675-1.839,2.414,2.414,0,0,0-.7-1.886A2.532,2.532,0,0,0,11.8,9.856a2.482,2.482,0,0,0-1.839.649,2.523,2.523,0,0,0-.65,1.866,2.4,2.4,0,0,0,.682,1.865A2.574,2.574,0,0,0,11.8,14.859Z"}}]}]})(props);
	};
	module.exports.CiAvocado = function CiAvocado (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Avocado"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M11.982,21.939a7.759,7.759,0,0,1-.818-.044A7.58,7.58,0,0,1,6.1,9.6a3.578,3.578,0,0,0,.684-2.271,5.128,5.128,0,0,1,3.8-5.085,5.266,5.266,0,0,1,4.6.892,5.185,5.185,0,0,1,2.039,4.14A3.6,3.6,0,0,0,17.9,9.61a7.574,7.574,0,0,1-5.918,12.329Zm.009-18.877a4.538,4.538,0,0,0-1.158.152,4.126,4.126,0,0,0-3.055,4.07,4.532,4.532,0,0,1-.9,2.947,6.555,6.555,0,0,0-1.366,5.231A6.643,6.643,0,0,0,11.271,20.9a6.575,6.575,0,0,0,5.851-10.662,4.453,4.453,0,0,1-.9-2.9,4.214,4.214,0,0,0-4.228-4.273Z"}},{"tag":"ellipse","attr":{"cx":"11.999","cy":"14.856","rx":"2.5","ry":"3"}}]}]}]})(props);
	};
	module.exports.CiBacon = function CiBacon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bacon"},"child":[{"tag":"path","attr":{"d":"M20.605,7.455l-3.49-3.49a.8.8,0,0,0-1.08-.04,1.833,1.833,0,0,1-.93.37,3.787,3.787,0,0,0-2.21,1.12,3.918,3.918,0,0,0-1.13,2.22,1.681,1.681,0,0,1-.53,1.1,1.753,1.753,0,0,1-1.1.53,4.026,4.026,0,0,0-3.35,3.35,1.677,1.677,0,0,1-.53,1.1,1.721,1.721,0,0,1-1.11.53,4.041,4.041,0,0,0-1.62.63,1.1,1.1,0,0,0-.14,1.66l3.5,3.5a.781.781,0,0,0,.55.23.822.822,0,0,0,.53-.19,1.759,1.759,0,0,1,.93-.38,3.8,3.8,0,0,0,2.21-1.12,3.948,3.948,0,0,0,1.14-2.22,1.71,1.71,0,0,1,.52-1.1,1.776,1.776,0,0,1,1.11-.53,4.03,4.03,0,0,0,3.34-3.35,1.66,1.66,0,0,1,.53-1.1,1.721,1.721,0,0,1,1.11-.53,4.018,4.018,0,0,0,1.61-.62,1.091,1.091,0,0,0,.14-1.67ZM4.1,15.7a3.15,3.15,0,0,1,1.24-.47,2.635,2.635,0,0,0,1.63-.81,2.587,2.587,0,0,0,.8-1.61,2.852,2.852,0,0,1,.86-1.7,2.9,2.9,0,0,1,1.7-.86,2.745,2.745,0,0,0,1.62-.8,2.687,2.687,0,0,0,.8-1.62,2.9,2.9,0,0,1,.86-1.7,2.814,2.814,0,0,1,1.69-.85,2.819,2.819,0,0,0,1.24-.48l1.3,1.3a2.362,2.362,0,0,1-.98.35,3.515,3.515,0,0,0-2.95,2.95,2.136,2.136,0,0,1-.67,1.36,2.159,2.159,0,0,1-1.36.67,3.44,3.44,0,0,0-1.96.99,3.351,3.351,0,0,0-.98,1.96,2.355,2.355,0,0,1-2.03,2.03,3.242,3.242,0,0,0-1.58.66L4.1,15.835ZM19.9,8.3a3.059,3.059,0,0,1-1.23.47,2.659,2.659,0,0,0-1.63.81,2.587,2.587,0,0,0-.8,1.61,2.852,2.852,0,0,1-.86,1.7,2.883,2.883,0,0,1-1.69.86,2.812,2.812,0,0,0-2.43,2.42,2.878,2.878,0,0,1-.86,1.7,2.8,2.8,0,0,1-1.68.85,2.808,2.808,0,0,0-1.25.48l-1.3-1.29a2.423,2.423,0,0,1,.97-.35,3.377,3.377,0,0,0,1.96-.99,3.44,3.44,0,0,0,.99-1.96,2.217,2.217,0,0,1,.66-1.36,2.292,2.292,0,0,1,1.36-.67,3.317,3.317,0,0,0,1.96-.99,3.351,3.351,0,0,0,.99-1.96,2.355,2.355,0,0,1,2.03-2.03,3.479,3.479,0,0,0,1.59-.66l1.23,1.23Z"}}]}]})(props);
	};
	module.exports.CiBadgeDollar = function CiBadgeDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Badge_Dollar"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.953c-.895,0-1.545-.743-2.118-1.4a3.671,3.671,0,0,0-1.033-.946,3.8,3.8,0,0,0-1.466-.077,3.012,3.012,0,0,1-2.421-.494,3.014,3.014,0,0,1-.494-2.421,3.82,3.82,0,0,0-.077-1.466,3.671,3.671,0,0,0-.946-1.033c-.655-.573-1.4-1.222-1.4-2.118s.743-1.545,1.4-2.118a3.66,3.66,0,0,0,.946-1.034,3.815,3.815,0,0,0,.077-1.465,3.012,3.012,0,0,1,.494-2.421,3.015,3.015,0,0,1,2.422-.5A3.794,3.794,0,0,0,8.849,4.39a3.666,3.666,0,0,0,1.033-.945c.573-.655,1.223-1.4,2.118-1.4s1.545.742,2.118,1.4a3.66,3.66,0,0,0,1.034.946,3.807,3.807,0,0,0,1.464.077,3.018,3.018,0,0,1,2.422.5,3.012,3.012,0,0,1,.5,2.422,3.81,3.81,0,0,0,.077,1.464,3.66,3.66,0,0,0,.946,1.034c.655.573,1.4,1.223,1.4,2.118s-.743,1.545-1.4,2.118a3.666,3.666,0,0,0-.945,1.033,3.815,3.815,0,0,0-.077,1.465,3.012,3.012,0,0,1-.5,2.422,3.018,3.018,0,0,1-2.421.494,3.818,3.818,0,0,0-1.465.077,3.673,3.673,0,0,0-1.034.946C13.545,21.21,12.9,21.953,12,21.953ZM8.093,18.5a2.952,2.952,0,0,1,1.138.183,4.233,4.233,0,0,1,1.4,1.21c.454.52.924,1.057,1.365,1.057s.911-.537,1.366-1.057a4.225,4.225,0,0,1,1.4-1.21,4.365,4.365,0,0,1,1.908-.152c.672.041,1.366.085,1.653-.2s.245-.982.2-1.653a4.387,4.387,0,0,1,.152-1.909,4.241,4.241,0,0,1,1.209-1.4c.52-.454,1.057-.924,1.057-1.365s-.537-.911-1.057-1.365a4.234,4.234,0,0,1-1.209-1.4,4.381,4.381,0,0,1-.152-1.908c.041-.671.084-1.365-.2-1.653s-.982-.246-1.653-.2a4.384,4.384,0,0,1-1.908-.152,4.234,4.234,0,0,1-1.4-1.209c-.454-.52-.924-1.057-1.365-1.057s-.911.537-1.365,1.057a4.241,4.241,0,0,1-1.4,1.209,4.417,4.417,0,0,1-1.909.152c-.67-.041-1.364-.084-1.653.2s-.244.981-.2,1.652A4.37,4.37,0,0,1,5.314,9.23a4.226,4.226,0,0,1-1.21,1.4c-.52.454-1.057.925-1.057,1.365s.537.911,1.057,1.366a4.238,4.238,0,0,1,1.21,1.4,4.378,4.378,0,0,1,.152,1.91c-.041.672-.084,1.366.2,1.653s.98.245,1.653.2C7.578,18.519,7.838,18.5,8.093,18.5Z"}},{"tag":"path","attr":{"d":"M14.5,13.5a2.006,2.006,0,0,1-2,2v1.01A.5.5,0,0,1,12,17a.492.492,0,0,1-.5-.49V15.5h-1.25a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H12.5a1,1,0,1,0,0-2h-1a2,2,0,0,1,0-4V7.453A.473.473,0,0,1,12,7a.48.48,0,0,1,.5.45V8.5h1.25a.5.5,0,0,1,.5.5.508.508,0,0,1-.5.5H11.5a1,1,0,0,0,0,2h1A2,2,0,0,1,14.5,13.5Z"}}]}]}]})(props);
	};
	module.exports.CiBag1 = function CiBag1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bag_1"},"child":[{"tag":"path","attr":{"d":"M20.37,17.65a16.777,16.777,0,0,0-2.01-5.54,17.037,17.037,0,0,0-3.74-4.55l-.1-.08a.121.121,0,0,1-.02-.15l1.49-2.59a1.12,1.12,0,0,0,0-1.12,1.092,1.092,0,0,0-.97-.55H8.98a1.1,1.1,0,0,0-.97.55,1.12,1.12,0,0,0,0,1.12l1.5,2.59a.124.124,0,0,1-.03.15l-.09.08A17.327,17.327,0,0,0,3.63,17.65a4.051,4.051,0,0,0-.04.48,2.8,2.8,0,0,0,2.8,2.8H17.62a2.782,2.782,0,0,0,2.13-.99A2.834,2.834,0,0,0,20.37,17.65ZM8.88,4.24a.1.1,0,0,1,0-.12.106.106,0,0,1,.1-.05h6.04a.143.143,0,0,1,.11.05.163.163,0,0,1,0,.12l-1.59,2.8H10.46Zm5.09,4.08a16.436,16.436,0,0,1,5.42,9.5,1.817,1.817,0,0,1-.4,1.47,1.786,1.786,0,0,1-1.37.64H6.39a1.805,1.805,0,0,1-1.8-1.8,1.628,1.628,0,0,1,.03-.31,16.286,16.286,0,0,1,5.42-9.5l.32-.28h3.28Z"}}]}]})(props);
	};
	module.exports.CiBandage = function CiBandage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bandage"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.435,7.5H6.565a4.5,4.5,0,0,0,0,9h10.87a4.5,4.5,0,0,0,0-9Zm-9.93,8h-.94a3.5,3.5,0,0,1,0-7h.94Zm8,0h-7v-7h7Zm1.93,0h-.93v-7h.93a3.5,3.5,0,0,1,0,7Z"}},{"tag":"circle","attr":{"cx":"10.252","cy":"10.501","r":"0.625"}},{"tag":"circle","attr":{"cx":"10.252","cy":"13.501","r":"0.625"}},{"tag":"circle","attr":{"cx":"13.752","cy":"10.5","r":"0.625"}},{"tag":"circle","attr":{"cx":"13.752","cy":"13.5","r":"0.625"}}]}]}]})(props);
	};
	module.exports.CiBank = function CiBank (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bank"},"child":[{"tag":"path","attr":{"d":"M19.505,17.943V10.362a1.491,1.491,0,0,0,1.39-1.12,1.468,1.468,0,0,0-.7-1.68l-7.45-4.3a1.521,1.521,0,0,0-1.49,0l-7.45,4.3a1.468,1.468,0,0,0-.7,1.68,1.487,1.487,0,0,0,1.45,1.12h.13v7.57h-.12a1.5,1.5,0,0,0,0,3h14.87a1.5,1.5,0,0,0,.07-2.989ZM4.555,9.362a.505.505,0,0,1-.25-.94l7.45-4.289a.474.474,0,0,1,.49,0L19.7,8.422a.5.5,0,0,1-.25.94Zm13.95,1v7.57H14.9v-7.57Zm-4.61,0v7.57h-3.61v-7.57Zm-4.61,0v7.57h-3.6v-7.57Zm10.15,9.57H4.565a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h14.87a.5.5,0,0,1,.5.5A.5.5,0,0,1,19.435,19.932Z"}}]}]})(props);
	};
	module.exports.CiBarcode = function CiBarcode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Barcode"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M8.066,4.065H3.648a1.732,1.732,0,0,0-.963.189A1.368,1.368,0,0,0,2.066,5.48v4.585a.5.5,0,0,0,1,0V5.785a1.794,1.794,0,0,1,.014-.518c.077-.236.319-.2.514-.2H8.066a.5.5,0,0,0,0-1Z"}},{"tag":"path","attr":{"d":"M2.063,13.937v4.418a1.733,1.733,0,0,0,.189.963,1.369,1.369,0,0,0,1.227.619H8.063a.5.5,0,0,0,0-1H3.783a1.831,1.831,0,0,1-.518-.014c-.236-.077-.2-.319-.2-.514V13.937a.5.5,0,0,0-1,0Z"}},{"tag":"path","attr":{"d":"M15.934,19.935h4.418a1.732,1.732,0,0,0,.963-.189,1.368,1.368,0,0,0,.619-1.226V13.935a.5.5,0,0,0-1,0v4.28a1.794,1.794,0,0,1-.014.518c-.077.236-.319.2-.514.2H15.934a.5.5,0,0,0,0,1Z"}},{"tag":"path","attr":{"d":"M21.937,10.063V5.645a1.733,1.733,0,0,0-.189-.963,1.369,1.369,0,0,0-1.227-.619H15.937a.5.5,0,0,0,0,1h4.28a1.831,1.831,0,0,1,.518.014c.236.077.2.319.2.514v4.472a.5.5,0,0,0,1,0Z"}},{"tag":"g","attr":{},"child":[{"tag":"rect","attr":{"x":"10.999","y":"7.643","width":"1","height":"8.709","rx":"0.5"}},{"tag":"rect","attr":{"x":"14.249","y":"7.643","width":"1","height":"8.709","rx":"0.5"}},{"tag":"rect","attr":{"x":"16.499","y":"7.643","width":"1","height":"8.709","rx":"0.5"}},{"tag":"rect","attr":{"x":"6.499","y":"7.643","width":"1","height":"8.709","rx":"0.5"}},{"tag":"rect","attr":{"x":"8.499","y":"7.643","width":"1.5","height":"8.709","rx":"0.75"}}]}]}]}]})(props);
	};
	module.exports.CiBaseball = function CiBaseball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Baseball_Ball"},"child":[{"tag":"path","attr":{"d":"M19.02,4.976A9.927,9.927,0,1,0,15.74,21.2,9.908,9.908,0,0,0,21.93,12,9.856,9.856,0,0,0,19.02,4.976Zm-13.34.71a8.9,8.9,0,0,1,6.04-2.61,8.461,8.461,0,0,1-.34,2.26l-.34-.19a.5.5,0,0,0-.5.86l.5.29a9.227,9.227,0,0,1-1.57,2.47l-.35-.35a.5.5,0,0,0-.7,0,.5.5,0,0,0,0,.71l.34.34a8.875,8.875,0,0,1-2.47,1.58L6,10.536a.5.5,0,0,0-.68-.19.505.505,0,0,0-.18.69l.2.34a8.2,8.2,0,0,1-2.26.35A8.827,8.827,0,0,1,5.68,5.686ZM11.74,17a.5.5,0,1,0-.5.87l.49.29a10.008,10.008,0,0,0-.45,2.74,8.9,8.9,0,0,1-8.18-8.17,9.378,9.378,0,0,0,2.75-.46l.29.5a.5.5,0,0,0,.43.25.475.475,0,0,0,.25-.07.493.493,0,0,0,.18-.68l-.21-.36a9.461,9.461,0,0,0,2.68-1.73l.36.36a.5.5,0,0,0,.35.15.508.508,0,0,0,.36-.15.513.513,0,0,0,0-.71l-.36-.36A9.665,9.665,0,0,0,11.9,6.8l.37.21a.475.475,0,0,0,.25.07.511.511,0,0,0,.44-.25.494.494,0,0,0-.19-.68l-.51-.29a9.789,9.789,0,0,0,.46-2.76,8.924,8.924,0,0,1,8.18,8.18,10.08,10.08,0,0,0-2.74.46l-.28-.49a.505.505,0,0,0-.69-.18.491.491,0,0,0-.18.68l.2.35a9.684,9.684,0,0,0-2.68,1.73l-.35-.35a.5.5,0,0,0-.71,0,.5.5,0,0,0,0,.7l.36.36a9.2,9.2,0,0,0-1.73,2.67Zm6.58,1.32a8.851,8.851,0,0,1-6.04,2.6,8.388,8.388,0,0,1,.34-2.25l.35.2a.451.451,0,0,0,.25.07.5.5,0,0,0,.43-.25.505.505,0,0,0-.18-.69l-.51-.29a8.7,8.7,0,0,1,1.57-2.47l.36.36a.5.5,0,0,0,.7-.71l-.36-.36a9.124,9.124,0,0,1,2.48-1.57l.3.52a.5.5,0,0,0,.43.25.451.451,0,0,0,.25-.07.505.505,0,0,0,.19-.68l-.21-.36a8.449,8.449,0,0,1,2.25-.34,8.992,8.992,0,0,1-.66,3.14A9.172,9.172,0,0,1,18.32,18.316Z"}}]}]})(props);
	};
	module.exports.CiBasketball = function CiBasketball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Basketball"},"child":[{"tag":"path","attr":{"d":"M19.02,4.971a9.941,9.941,0,1,0,0,14.05A9.941,9.941,0,0,0,19.02,4.971Zm-13.34.71a8.894,8.894,0,0,1,6.05-2.6,8.812,8.812,0,0,1-2.61,6.04,8.75,8.75,0,0,1-6.04,2.61A8.875,8.875,0,0,1,5.68,5.681ZM3.1,12.731a9.772,9.772,0,0,0,6.73-2.9,9.8,9.8,0,0,0,2.9-6.73,8.908,8.908,0,0,1,5.23,2.24L5.34,17.951A8.881,8.881,0,0,1,3.1,12.731Zm8.18,8.17a8.872,8.872,0,0,1-5.23-2.24L18.66,6.041a8.91,8.91,0,0,1,2.24,5.24,9.86,9.86,0,0,0-9.62,9.62Zm7.04-2.59a8.856,8.856,0,0,1-6.04,2.61,8.851,8.851,0,0,1,8.64-8.64A8.847,8.847,0,0,1,18.32,18.311Z"}}]}]})(props);
	};
	module.exports.CiBatteryCharging = function CiBatteryCharging (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Battery_Charging"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.505,18.5H4.065a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h13.44a2,2,0,0,1,2,2v1h.93a1.5,1.5,0,0,1,1.5,1.5v4a1.5,1.5,0,0,1-1.5,1.5h-.93v1A2,2,0,0,1,17.505,18.5ZM4.065,6.5a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1h13.44a1,1,0,0,0,1-1V15.25a.752.752,0,0,1,.75-.75h1.18a.5.5,0,0,0,.5-.5V10a.5.5,0,0,0-.5-.5h-1.18a.752.752,0,0,1-.75-.75V7.5a1,1,0,0,0-1-1Z"}},{"tag":"path","attr":{"d":"M13.174,11.191H11.891a.11.11,0,0,1-.1-.15l.655-1.669a.251.251,0,0,0-.233-.342H9.274a.248.248,0,0,0-.231.157L8.292,11.04a.11.11,0,0,0,.1.151H9.829a.11.11,0,0,1,.1.144l-.776,3.53a.085.085,0,0,0,.139.081l3.947-3.561A.109.109,0,0,0,13.174,11.191Z"}}]}]}]})(props);
	};
	module.exports.CiBatteryEmpty = function CiBatteryEmpty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Battery_Empty"},"child":[{"tag":"path","attr":{"d":"M17.505,18.5H4.065a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h13.44a2,2,0,0,1,2,2v1h.93a1.5,1.5,0,0,1,1.5,1.5v4a1.5,1.5,0,0,1-1.5,1.5h-.93v1A2,2,0,0,1,17.505,18.5ZM4.065,6.5a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1h13.44a1,1,0,0,0,1-1V15.25a.752.752,0,0,1,.75-.75h1.18a.5.5,0,0,0,.5-.5V10a.5.5,0,0,0-.5-.5h-1.18a.752.752,0,0,1-.75-.75V7.5a1,1,0,0,0-1-1Z"}}]}]})(props);
	};
	module.exports.CiBatteryFull = function CiBatteryFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Battery_Full"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.505,18.5H4.065a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h13.44a2,2,0,0,1,2,2v1h.93a1.5,1.5,0,0,1,1.5,1.5v4a1.5,1.5,0,0,1-1.5,1.5h-.93v1A2,2,0,0,1,17.505,18.5ZM4.065,6.5a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1h13.44a1,1,0,0,0,1-1V15.25a.751.751,0,0,1,.75-.75h1.18a.5.5,0,0,0,.5-.5V10a.5.5,0,0,0-.5-.5h-1.18a.751.751,0,0,1-.75-.75V7.5a1,1,0,0,0-1-1Z"}},{"tag":"rect","attr":{"x":"4.063","y":"7.499","width":"13.437","height":"8.998","rx":"1"}}]}]}]})(props);
	};
	module.exports.CiBeaker1 = function CiBeaker1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Beaker_1"},"child":[{"tag":"path","attr":{"d":"M19.447,18.645l-.51-1.52a17.9,17.9,0,0,0-4.02-6.66,1.493,1.493,0,0,1-.42-1.04V3.065H15a.5.5,0,0,0,0-1H9a.5.5,0,0,0,0,1h.5v6.36a1.484,1.484,0,0,1-.41,1.04,17.9,17.9,0,0,0-4.02,6.66l-.52,1.52a2.5,2.5,0,0,0,2.37,3.29h10.16a2.5,2.5,0,0,0,2.37-3.29Zm-9.64-7.49a2.477,2.477,0,0,0,.69-1.73V3.065h3v6.36a2.486,2.486,0,0,0,.7,1.73,16.907,16.907,0,0,1,3.01,4.38H6.787A16.943,16.943,0,0,1,9.807,11.155Zm8.49,9.16a1.507,1.507,0,0,1-1.22.62H6.917a1.5,1.5,0,0,1-1.42-1.98l.51-1.52q.15-.45.33-.9h11.32q.18.45.33.9l.51,1.52A1.5,1.5,0,0,1,18.3,20.315Z"}}]}]})(props);
	};
	module.exports.CiBeerMugFull = function CiBeerMugFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Beer_Mug_Full"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.356,9.63h-.97V7.99a2.938,2.938,0,0,0,.5-1.65,1.77,1.77,0,0,0-.01-.23,2.905,2.905,0,0,0-1.64-2.38,2.956,2.956,0,0,0-2.4-.07,3.278,3.278,0,0,0-5.62,0,2.9,2.9,0,0,0-1.68-.17,2.866,2.866,0,0,0-2.16,1.75,2.948,2.948,0,0,0,.3,2.77V19.43a2.5,2.5,0,0,0,2.5,2.5h7.71a2.5,2.5,0,0,0,2.5-2.5v-.99l.91-.36a2.433,2.433,0,0,0,1.54-2.27V11.1A1.481,1.481,0,0,0,18.356,9.63Zm-1.97,9.8a1.5,1.5,0,0,1-1.5,1.5H7.176a1.5,1.5,0,0,1-1.5-1.5V11.34a2.858,2.858,0,0,0,1.93.74c.13,0,.25-.01.37-.02V18.4a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5V11.82a.17.17,0,0,0-.01-.07,2.939,2.939,0,0,0,1.57-2.46h4.42a2.86,2.86,0,0,0,1.43-.38Zm-.01-11.77a1.949,1.949,0,0,1-1.42.63h-4.61a.8.8,0,0,0-.79.61,1.231,1.231,0,0,0-.02.2,1.975,1.975,0,0,1-1.05,1.78,1.934,1.934,0,0,1-2.8-1.72,1.808,1.808,0,0,1,.17-.77.6.6,0,0,0-.13-.68,1.939,1.939,0,0,1-.41-2.11,1.868,1.868,0,0,1,1.4-1.13,2.531,2.531,0,0,1,.38-.03,1.909,1.909,0,0,1,.86.2.766.766,0,0,0,.59.06A.8.8,0,0,0,9,4.32a2.273,2.273,0,0,1,4.06,0,.751.751,0,0,0,.44.38.8.8,0,0,0,.59-.05,1.917,1.917,0,0,1,2.79,1.54A1.886,1.886,0,0,1,16.376,7.66Zm2.46,8.15a1.428,1.428,0,0,1-.92,1.34l-.52.22V10.63h.96a.478.478,0,0,1,.48.47Z"}},{"tag":"path","attr":{"d":"M13.577,18.9a.5.5,0,0,1-.5-.5V11.82a.5.5,0,0,1,1,0V18.4A.5.5,0,0,1,13.577,18.9Z"}}]}]}]})(props);
	};
	module.exports.CiBellOff = function CiBellOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bell_Off"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M9.624,5.2c-.571.3-.079,1.124.5.864.509-.227,1.068-.287,1.115-.95.028-.41.014-.81.476-.993a.776.776,0,0,1,1.035.71c.048.461.035.821.548,1.024a4.811,4.811,0,0,1,2.812,2.432,5.63,5.63,0,0,1,.414,2.467v2.02a.5.5,0,0,0,1,0c0-1.646.185-3.394-.521-4.929a5.542,5.542,0,0,0-3.019-2.808c-.034-.013-.155-.069-.227-.092,0-.021,0-.044,0-.059a2.009,2.009,0,0,0-.257-.945,1.739,1.739,0,0,0-3.1.172,1.992,1.992,0,0,0-.153.792c0,.012,0,.033,0,.052C10.24,4.959,9.808,5.107,9.624,5.2Z"}},{"tag":"path","attr":{"d":"M4.57,3.86c-.46-.46-1.17.25-.71.7C4.92,5.62,5.98,6.69,7.04,7.75a5.535,5.535,0,0,0-.57,2.44v4.54a2.122,2.122,0,0,0-1.88,2.11v.53a2.121,2.121,0,0,0,2.12,2.12H10.3a1.725,1.725,0,0,0,3.4,0h3.59a2.12,2.12,0,0,0,1.15-.34l.99.99a.5.5,0,0,0,.71-.71ZM17.7,18.41a1.15,1.15,0,0,1-.41.08H6.71a1.118,1.118,0,0,1-1.12-1.12v-.53a1.118,1.118,0,0,1,1.12-1.12.762.762,0,0,0,.76-.77V10.19A4.375,4.375,0,0,1,7.8,8.51Z"}}]}]}]})(props);
	};
	module.exports.CiBellOn = function CiBellOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bell_On"},"child":[{"tag":"path","attr":{"d":"M18.79,15.34a2.087,2.087,0,0,0-1.26-.61V10.19a5.5,5.5,0,0,0-1.62-3.91,5.826,5.826,0,0,0-2.15-1.33V4.89a1.8,1.8,0,0,0-1.61-1.81,1.749,1.749,0,0,0-1.91,1.75v.12a5.547,5.547,0,0,0-3.77,5.24v4.54a2.122,2.122,0,0,0-1.88,2.11v.53a2.121,2.121,0,0,0,2.12,2.12H10.3a1.725,1.725,0,0,0,3.4,0h3.59a2.121,2.121,0,0,0,2.12-2.12v-.53A2.1,2.1,0,0,0,18.79,15.34Zm-.38,2.03a1.118,1.118,0,0,1-1.12,1.12H6.71a1.118,1.118,0,0,1-1.12-1.12v-.53a1.118,1.118,0,0,1,1.12-1.12.762.762,0,0,0,.76-.77V10.19a4.555,4.555,0,0,1,3.24-4.34.729.729,0,0,0,.53-.71V4.83a.735.735,0,0,1,.25-.56.744.744,0,0,1,.51-.2h.07a.807.807,0,0,1,.69.82v.25a.729.729,0,0,0,.53.71A4.668,4.668,0,0,1,15.2,6.99a4.468,4.468,0,0,1,1.33,3.2v4.76a.8.8,0,0,0,.22.55.773.773,0,0,0,.54.22,1.127,1.127,0,0,1,1.12,1.12Z"}}]}]})(props);
	};
	module.exports.CiBezier = function CiBezier (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bezier"},"child":[{"tag":"path","attr":{"d":"M20.435,8.005a1.5,1.5,0,1,0-1.41-2H13.5v-.25a.749.749,0,0,0-.75-.75h-1.5a.755.755,0,0,0-.75.75v.25H4.975a1.5,1.5,0,0,0-2.91.5,1.5,1.5,0,0,0,2.91.5h3.79c-2.5,1.61-4.23,5-4.47,8.99h-.28a.749.749,0,0,0-.75.75v1.5a.749.749,0,0,0,.75.75h1.5a.755.755,0,0,0,.75-.75v-1.5a.755.755,0,0,0-.75-.75h-.21c.27-4.22,2.38-7.78,5.19-8.73a.747.747,0,0,0,.75.74h1.5a.741.741,0,0,0,.75-.74c2.81.95,4.93,4.51,5.21,8.73h-.22a.749.749,0,0,0-.75.75v1.5a.749.749,0,0,0,.75.75h1.5a.755.755,0,0,0,.75-.75v-1.5a.755.755,0,0,0-.75-.75H19.7c-.24-3.99-1.97-7.38-4.46-8.99h3.78A1.5,1.5,0,0,0,20.435,8.005Zm0-2a.508.508,0,0,1,.5.5.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5A.5.5,0,0,1,20.435,6.005Zm-16.87,1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5.508.508,0,0,1,.5.5A.5.5,0,0,1,3.565,7.005ZM5.265,18h-1V17h1ZM12.5,7.005h-1v-1h1ZM18.735,17h1v1h-1Z"}}]}]})(props);
	};
	module.exports.CiBitcoin = function CiBitcoin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bitcoin"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.934A9.934,9.934,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.934ZM12,3.066A8.934,8.934,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.066Z"}},{"tag":"path","attr":{"d":"M14.28,11.78A1.994,1.994,0,0,0,12.75,8.5H12.5V7.47A.489.489,0,0,0,12,7a.483.483,0,0,0-.5.47V8.5H10.25a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1H11.5v1.03A.483.483,0,0,0,12,17a.489.489,0,0,0,.5-.47V15.5h.75a2.006,2.006,0,0,0,2-2A2.033,2.033,0,0,0,14.28,11.78ZM10.25,9.5h2.5a1,1,0,0,1,0,2h-2.5Zm3,5h-3v-2h3a1,1,0,0,1,0,2Z"}}]}]}]})(props);
	};
	module.exports.CiBluetooth = function CiBluetooth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bluetooth"},"child":[{"tag":"path","attr":{"d":"M18.649,15.938,11.829,12l6.82-3.94a.984.984,0,0,0,.5-.87.968.968,0,0,0-.5-.861L12.029,2.5a.989.989,0,0,0-1,0,1,1,0,0,0-.5.87v7.769q-2.1-1.23-4.22-2.44c-.24-.139-.47-.279-.71-.409a.5.5,0,0,0-.51.86L10.039,12c-1.41.81-2.83,1.62-4.23,2.44-.24.129-.48.27-.72.41a.5.5,0,0,0,.51.86c1.65-.951,3.28-1.891,4.93-2.85v7.769a.993.993,0,0,0,.5.871.969.969,0,0,0,1,0l6.62-3.82a1.007,1.007,0,0,0,0-1.74Zm-7.12-12.57,6.62,3.82-6.62,3.83Zm0,17.259V12.988l6.62,3.82Z"}}]}]})(props);
	};
	module.exports.CiBookmarkCheck = function CiBookmarkCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bookmark_Check"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.6,21.938a1.482,1.482,0,0,1-1.011-.4l-4.251-3.9a.5.5,0,0,0-.678,0L7.41,21.538a1.5,1.5,0,0,1-2.517-1.1V4.563a2.5,2.5,0,0,1,2.5-2.5h9.214a2.5,2.5,0,0,1,2.5,2.5V20.435a1.483,1.483,0,0,1-.9,1.375A1.526,1.526,0,0,1,17.6,21.938ZM12,16.5a1.5,1.5,0,0,1,1.018.395L17.269,20.8a.5.5,0,0,0,.838-.368V4.563a1.5,1.5,0,0,0-1.5-1.5H7.393a1.5,1.5,0,0,0-1.5,1.5V20.435a.5.5,0,0,0,.839.368L10.983,16.9A1.5,1.5,0,0,1,12,16.5Z"}},{"tag":"path","attr":{"d":"M14.85,9.08c-.11.12-.23.23-.35.35-.83.83-1.65,1.65-2.47,2.48a.513.513,0,0,1-.71,0c-.47-.48-.94-.95-1.42-1.42a.5.5,0,0,1,.71-.71c.35.36.7.71,1.06,1.06.83-.82,1.65-1.65,2.48-2.47C14.6,7.91,15.31,8.62,14.85,9.08Z"}}]}]}]})(props);
	};
	module.exports.CiBookmarkMinus = function CiBookmarkMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bookmark_Minus"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.6,21.938a1.482,1.482,0,0,1-1.011-.4l-4.251-3.9a.5.5,0,0,0-.678,0L7.41,21.538a1.5,1.5,0,0,1-2.517-1.1V4.563a2.5,2.5,0,0,1,2.5-2.5h9.214a2.5,2.5,0,0,1,2.5,2.5V20.435a1.483,1.483,0,0,1-.9,1.375A1.526,1.526,0,0,1,17.6,21.938ZM12,16.5a1.5,1.5,0,0,1,1.018.395L17.269,20.8a.5.5,0,0,0,.838-.368V4.563a1.5,1.5,0,0,0-1.5-1.5H7.393a1.5,1.5,0,0,0-1.5,1.5V20.435a.5.5,0,0,0,.839.368L10.983,16.9A1.5,1.5,0,0,1,12,16.5Z"}},{"tag":"path","attr":{"d":"M10,10.277a.5.5,0,0,1,0-1h4a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiBookmarkPlus = function CiBookmarkPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bookmark_Plus"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.6,21.938a1.482,1.482,0,0,1-1.011-.4l-4.251-3.9a.5.5,0,0,0-.678,0L7.41,21.538a1.5,1.5,0,0,1-2.517-1.1V4.563a2.5,2.5,0,0,1,2.5-2.5h9.214a2.5,2.5,0,0,1,2.5,2.5V20.435a1.483,1.483,0,0,1-.9,1.375A1.526,1.526,0,0,1,17.6,21.938ZM12,16.5a1.5,1.5,0,0,1,1.018.395L17.269,20.8a.5.5,0,0,0,.838-.368V4.563a1.5,1.5,0,0,0-1.5-1.5H7.393a1.5,1.5,0,0,0-1.5,1.5V20.435a.5.5,0,0,0,.839.368L10.983,16.9A1.5,1.5,0,0,1,12,16.5Z"}},{"tag":"path","attr":{"d":"M14,10.28H12.5v1.5a.5.5,0,0,1-1,0v-1.5H10a.5.5,0,0,1,0-1h1.5V7.78a.5.5,0,0,1,1,0v1.5H14A.5.5,0,0,1,14,10.28Z"}}]}]}]})(props);
	};
	module.exports.CiBookmarkRemove = function CiBookmarkRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bookmark_Remove"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.6,21.938a1.482,1.482,0,0,1-1.011-.4l-4.251-3.9a.5.5,0,0,0-.678,0L7.41,21.538a1.5,1.5,0,0,1-2.517-1.1V4.563a2.5,2.5,0,0,1,2.5-2.5h9.214a2.5,2.5,0,0,1,2.5,2.5V20.435a1.483,1.483,0,0,1-.9,1.375A1.526,1.526,0,0,1,17.6,21.938ZM12,16.5a1.5,1.5,0,0,1,1.018.395L17.269,20.8a.5.5,0,0,0,.838-.368V4.563a1.5,1.5,0,0,0-1.5-1.5H7.393a1.5,1.5,0,0,0-1.5,1.5V20.435a.5.5,0,0,0,.839.368L10.983,16.9A1.5,1.5,0,0,1,12,16.5Z"}},{"tag":"path","attr":{"d":"M10.23,10.84a.5.5,0,0,0,.71.71L12,10.491,13.06,11.55a.523.523,0,0,0,.71,0,.513.513,0,0,0,0-.71L12.709,9.779,13.77,8.72a.5.5,0,0,0-.71-.71c-.35.35-.7.71-1.06,1.06L10.94,8.01a.5.5,0,0,0-.71,0,.524.524,0,0,0,0,.71c.35.35.71.7,1.06,1.06Z"}}]}]}]})(props);
	};
	module.exports.CiBookmark = function CiBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bookmark"},"child":[{"tag":"path","attr":{"d":"M17.6,21.945a1.483,1.483,0,0,1-1.01-.4l-4.251-3.9a.5.5,0,0,0-.68,0L7.409,21.545a1.5,1.5,0,0,1-2.516-1.1V4.57a2.5,2.5,0,0,1,2.5-2.5h9.214a2.5,2.5,0,0,1,2.5,2.5V20.442a1.481,1.481,0,0,1-.9,1.374A1.507,1.507,0,0,1,17.6,21.945ZM12,16.51a1.5,1.5,0,0,1,1.018.395l4.251,3.9a.5.5,0,0,0,.839-.368V4.57a1.5,1.5,0,0,0-1.5-1.5H7.393a1.5,1.5,0,0,0-1.5,1.5V20.442a.5.5,0,0,0,.839.368L10.983,16.9A1.5,1.5,0,0,1,12,16.51Z"}}]}]})(props);
	};
	module.exports.CiBowlNoodles = function CiBowlNoodles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bowl_Noodles"},"child":[{"tag":"path","attr":{"d":"M19.5,10.705a.948.948,0,0,0-.92-.67h-5.07V8.355l4.75.17h.02a.734.734,0,0,0,.73-.73.718.718,0,0,0-.75-.72l-4.75.17V5.405l4.78-.67a.723.723,0,0,0,.62-.72.487.487,0,0,0-.01-.12.716.716,0,0,0-.87-.58l-4.6.98a1.5,1.5,0,0,0-2.92.47v.15l-1.14.24a1.494,1.494,0,0,0-2.86.61v.01l-1.2.25a.267.267,0,0,0-.2.26v.04a.257.257,0,0,0,.29.21l1.11-.15V7.5l-1.25.04a.263.263,0,0,0-.25.26.256.256,0,0,0,.25.26l1.25.04v1.94H5.425a.963.963,0,0,0-.92.68,10.119,10.119,0,0,0,1.19,8.53l.61.92a1.233,1.233,0,0,0,1.05.57h9.3a1.228,1.228,0,0,0,1.04-.57l.61-.92A10.136,10.136,0,0,0,19.5,10.705Zm-7.99-5.94a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v5.24h-1Zm-2,1.2,1-.14v1.53l-1,.03Zm0,2.25,1,.03v1.79h-1Zm-2-2.45a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v4.24h-1Zm9.96,12.93-.6.93a.261.261,0,0,1-.21.11h-9.3a.236.236,0,0,1-.21-.11l-.61-.93a9.229,9.229,0,0,1-1.11-7.66l13.12-.03A9.122,9.122,0,0,1,17.465,18.7Z"}}]}]})(props);
	};
	module.exports.CiBoxList = function CiBoxList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Box_List"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M6.562,8.062h-2a1.5,1.5,0,0,1-1.5-1.5v-2a1.5,1.5,0,0,1,1.5-1.5h2a1.5,1.5,0,0,1,1.5,1.5v2A1.5,1.5,0,0,1,6.562,8.062Zm-2-4a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5Z"}},{"tag":"path","attr":{"d":"M6.562,20.938h-2a1.5,1.5,0,0,1-1.5-1.5v-2a1.5,1.5,0,0,1,1.5-1.5h2a1.5,1.5,0,0,1,1.5,1.5v2A1.5,1.5,0,0,1,6.562,20.938Zm-2-4a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5Z"}},{"tag":"path","attr":{"d":"M6.562,14.5h-2a1.5,1.5,0,0,1-1.5-1.5V11a1.5,1.5,0,0,1,1.5-1.5h2a1.5,1.5,0,0,1,1.5,1.5v2A1.5,1.5,0,0,1,6.562,14.5Zm-2-4a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5V11a.5.5,0,0,0-.5-.5Z"}},{"tag":"path","attr":{"d":"M20.438,6.062h-9a.5.5,0,0,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.438,12.5h-9a.5.5,0,0,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.438,18.935h-9a.5.5,0,1,1,0-1h9a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiBoxes = function CiBoxes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Boxes"},"child":[{"tag":"path","attr":{"d":"M19.435,11.5h-2.72V4.56a1.5,1.5,0,0,0-1.5-1.5H8.785a1.5,1.5,0,0,0-1.5,1.5V11.5H4.565a1.5,1.5,0,0,0-1.5,1.5v6.44a1.5,1.5,0,0,0,1.5,1.5H11a1.468,1.468,0,0,0,1-.39,1.487,1.487,0,0,0,1,.39h6.44a1.5,1.5,0,0,0,1.5-1.5V13A1.5,1.5,0,0,0,19.435,11.5ZM11.5,19.44a.5.5,0,0,1-.5.5H4.565a.5.5,0,0,1-.5-.5V13a.5.5,0,0,1,.5-.5h1.97v2a.5.5,0,0,0,.5.5h1.5a.508.508,0,0,0,.5-.5v-2H11.5ZM8.285,11.5V4.56a.5.5,0,0,1,.5-.5h1.96v2a.5.5,0,0,0,.5.5h1.5a.5.5,0,0,0,.5-.5v-2h1.97a.5.5,0,0,1,.5.5V11.5Zm11.65,7.94a.508.508,0,0,1-.5.5H13a.508.508,0,0,1-.5-.5V12.5h2.47v2a.5.5,0,0,0,.5.5h1.5a.5.5,0,0,0,.5-.5v-2h1.97a.5.5,0,0,1,.5.5Z"}}]}]})(props);
	};
	module.exports.CiBrightnessDown = function CiBrightnessDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Brightness_Down"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,17.5A5.5,5.5,0,1,1,17.5,12,5.506,5.506,0,0,1,12,17.5Zm0-10A4.5,4.5,0,1,0,16.5,12,4.505,4.505,0,0,0,12,7.5Z"}},{"tag":"circle","attr":{"cx":"12","cy":"2.813","r":"0.75"}},{"tag":"circle","attr":{"cx":"12","cy":"21.187","r":"0.75"}},{"tag":"circle","attr":{"cx":"21.187","cy":"12","r":"0.75"}},{"tag":"circle","attr":{"cx":"2.813","cy":"12","r":"0.75"}},{"tag":"circle","attr":{"cx":"18.496","cy":"5.504","r":"0.75"}},{"tag":"circle","attr":{"cx":"5.504","cy":"18.496","r":"0.75"}},{"tag":"circle","attr":{"cx":"18.496","cy":"18.496","r":"0.75"}},{"tag":"circle","attr":{"cx":"5.504","cy":"5.504","r":"0.75"}}]}]}]})(props);
	};
	module.exports.CiBrightnessUp = function CiBrightnessUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Brightness_Up"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,17.5A5.5,5.5,0,1,1,17.5,12,5.506,5.506,0,0,1,12,17.5Zm0-10A4.5,4.5,0,1,0,16.5,12,4.505,4.505,0,0,0,12,7.5Z"}},{"tag":"circle","attr":{"cx":"12","cy":"3.063","r":"1"}},{"tag":"circle","attr":{"cx":"12","cy":"20.937","r":"1"}},{"tag":"circle","attr":{"cx":"20.937","cy":"12","r":"1"}},{"tag":"circle","attr":{"cx":"3.063","cy":"12","r":"1"}},{"tag":"circle","attr":{"cx":"18.319","cy":"5.681","r":"1"}},{"tag":"circle","attr":{"cx":"5.681","cy":"18.319","r":"1"}},{"tag":"circle","attr":{"cx":"18.319","cy":"18.319","r":"1"}},{"tag":"circle","attr":{"cx":"5.681","cy":"5.681","r":"1"}}]}]}]})(props);
	};
	module.exports.CiBullhorn = function CiBullhorn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Bullhorn"},"child":[{"tag":"path","attr":{"d":"M4.5,16.474c-0.849,-0.4 -1.436,-1.263 -1.436,-2.264l-0,-4.419c-0,-1.38 1.118,-2.5 2.5,-2.5l4.343,0c0.793,0 1.581,-0.132 2.33,-0.392c1.859,-0.705 3.792,-1.727 5.24,-2.922l0.869,-0.718c0.015,-0.013 0.032,-0.025 0.049,-0.036c0.666,-0.424 1.538,0.054 1.538,0.844l0,6.717c0.572,0.11 1.004,0.613 1.004,1.217c-0,0.604 -0.432,1.106 -1.004,1.216l-0,6.718c-0,0.787 -0.872,1.267 -1.538,0.843c-0.017,-0.011 -0.034,-0.023 -0.05,-0.036l-0.868,-0.718c-1.446,-1.195 -3.364,-2.214 -5.226,-2.891c-0.748,-0.261 -1.536,-0.394 -2.328,-0.394c-0.609,-0.029 -1.265,-0.029 -1.265,-0.029l0,2.147c0,1.148 -0.931,2.079 -2.079,2.079c-1.148,-0 -2.079,-0.931 -2.079,-2.079l0,-2.383Zm1,0.236l0,2.147c0,0.596 0.483,1.079 1.079,1.079c0.596,-0 1.079,-0.483 1.079,-1.079c0,-0 0,-2.147 0,-2.147l-2.094,-0c-0.031,-0 -0.053,-0 -0.064,-0Zm6,-0.882l0.142,0.04c2.37,0.664 4.575,1.817 6.473,3.385l0.818,0.677l-0,-15.859l-0.82,0.677c-1.897,1.566 -4.1,2.717 -6.468,3.379l-0.145,0.041l-0,7.66Zm-2.842,-0.118l1.842,0l-0,-7.419l-4.936,0c-0.829,0 -1.5,0.672 -1.5,1.5l-0,4.419c-0,0.829 0.671,1.5 1.499,1.5l3.095,0Z"}}]}]})(props);
	};
	module.exports.CiBurger = function CiBurger (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Burger"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.325,11.015a7.344,7.344,0,0,0-14.66,0,2.014,2.014,0,0,0-1.6,1.96v.16a2.016,2.016,0,0,0,1.64,1.97l.27,2.45a2.593,2.593,0,0,0,2.59,2.32h8.87a2.593,2.593,0,0,0,2.59-2.32l.27-2.45a2.016,2.016,0,0,0,1.64-1.97v-.16A2,2,0,0,0,19.325,11.015ZM12,5.125a6.365,6.365,0,0,1,6.34,5.85H5.665A6.362,6.362,0,0,1,12,5.125Zm6.04,12.32a1.6,1.6,0,0,1-1.6,1.43H7.565a1.6,1.6,0,0,1-1.6-1.43l-.26-2.31H18.3Zm1.9-4.31a1,1,0,0,1-1,1H5.065a1,1,0,0,1-1-1v-.16a1,1,0,0,1,1-1h13.87a1,1,0,0,1,1,1Z"}},{"tag":"circle","attr":{"cx":"12","cy":"6.622","r":"0.5"}},{"tag":"circle","attr":{"cx":"8.323","cy":"8.323","r":"0.5"}},{"tag":"circle","attr":{"cx":"15.676","cy":"8.323","r":"0.5"}}]}]}]})(props);
	};
	module.exports.CiCalculator1 = function CiCalculator1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Calculator_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M16.5,21.937h-9a2.5,2.5,0,0,1-2.5-2.5V4.563a2.5,2.5,0,0,1,2.5-2.5h9a2.5,2.5,0,0,1,2.5,2.5V19.437A2.5,2.5,0,0,1,16.5,21.937ZM7.5,3.063A1.5,1.5,0,0,0,6,4.563V19.437a1.5,1.5,0,0,0,1.5,1.5h9a1.5,1.5,0,0,0,1.5-1.5V4.563a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M14.5,9.757h-5A1.5,1.5,0,0,1,8,8.257V6.563a1.5,1.5,0,0,1,1.5-1.5h5a1.5,1.5,0,0,1,1.5,1.5V8.257A1.5,1.5,0,0,1,14.5,9.757Zm-5-3.694a.5.5,0,0,0-.5.5V8.257a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5V6.563a.5.5,0,0,0-.5-.5Z"}},{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"cx":"12","cy":"11.508","r":"0.75"}},{"tag":"circle","attr":{"cx":"15.25","cy":"11.508","r":"0.75"}},{"tag":"circle","attr":{"cx":"8.75","cy":"11.508","r":"0.75"}}]},{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"cx":"12","cy":"14.848","r":"0.75"}},{"tag":"circle","attr":{"cx":"15.25","cy":"14.848","r":"0.75"}},{"tag":"circle","attr":{"cx":"8.75","cy":"14.848","r":"0.75"}}]},{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"cx":"15.25","cy":"18.187","r":"0.75"}},{"tag":"path","attr":{"d":"M12.248,18.687H8.5a.5.5,0,0,1,0-1h3.744a.5.5,0,1,1,0,1Z"}}]}]}]}]})(props);
	};
	module.exports.CiCalculator2 = function CiCalculator2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Calculator_2"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.45,7.83h-2.8v2.81a.5.5,0,0,1-1,0V7.83H13.84a.5.5,0,0,1,0-1h2.81V4.02a.5.5,0,0,1,1,0V6.83h2.8A.5.5,0,0,1,20.45,7.83Z"}},{"tag":"path","attr":{"d":"M3.545,7.83a.5.5,0,0,1,0-1h6.619a.5.5,0,0,1,0,1Z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M13.836,16.05a.5.5,0,0,1,0-1h6.619a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M13.836,20.191a.5.5,0,0,1,0-1h6.619a.5.5,0,0,1,0,1Z"}}]},{"tag":"path","attr":{"d":"M9.55,19.61a.5.5,0,0,1-.71.7L6.86,18.33c-.66.65-1.33,1.32-1.99,1.98a.5.5,0,0,1-.71-.7l1.99-1.99L4.16,15.63a.5.5,0,0,1,.71-.7l.58.58,1.4,1.4c.67-.66,1.33-1.32,1.99-1.98a.5.5,0,0,1,.71.7L7.56,17.62Z"}}]}]}]})(props);
	};
	module.exports.CiCalendarDate = function CiCalendarDate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Calendar_Date"},"child":[{"tag":"path","attr":{"d":"M18.435,4.955h-1.94v-1.41c0-0.26-0.23-0.51-0.5-0.5c-0.27,0.01-0.5,0.22-0.5,0.5v1.41h-7v-1.41\n            c0-0.26-0.23-0.51-0.5-0.5c-0.27,0.01-0.5,0.22-0.5,0.5v1.41h-1.93c-1.38,0-2.5,1.12-2.5,2.5v11c0,1.38,1.12,2.5,2.5,2.5h12.87\n            c1.38,0,2.5-1.12,2.5-2.5v-11C20.935,6.075,19.815,4.955,18.435,4.955z M19.935,18.455c0,0.83-0.67,1.5-1.5,1.5H5.565\n            c-0.83,0-1.5-0.67-1.5-1.5v-8.42h15.87V18.455z M19.935,9.035H4.065v-1.58c0-0.83,0.67-1.5,1.5-1.5h1.93v0.59\n            c0,0.26,0.23,0.51,0.5,0.5c0.27-0.01,0.5-0.22,0.5-0.5v-0.59h7v0.59c0,0.26,0.23,0.51,0.5,0.5c0.27-0.01,0.5-0.22,0.5-0.5v-0.59\n            h1.94c0.83,0,1.5,0.67,1.5,1.5V9.035z"}},{"tag":"path","attr":{"d":"M11.492,17.173v-3.46c0-0.059-0.064-0.095-0.114-0.064l-0.638,0.392\n            c-0.1,0.061-0.228-0.01-0.228-0.128v-0.651c0-0.105,0.055-0.203,0.146-0.257l0.764-0.457c0.047-0.028,0.1-0.043,0.154-0.043h0.626\n            c0.166,0,0.3,0.134,0.3,0.3v4.367c0,0.166-0.134,0.3-0.3,0.3h-0.409C11.626,17.473,11.492,17.339,11.492,17.173z"}}]}]})(props);
	};
	module.exports.CiCalendar = function CiCalendar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Calendar"},"child":[{"tag":"path","attr":{"d":"M18.438,4.954H16.5c0-0.346,0-0.691,0-1.036c0-0.124,0-0.248,0-0.372c0-0.262-0.23-0.512-0.5-0.5\n            c-0.271,0.012-0.5,0.22-0.5,0.5c0,0.469,0,0.939,0,1.408h-7c0-0.346,0-0.691,0-1.036c0-0.124,0-0.248,0-0.372\n            c0-0.262-0.23-0.512-0.5-0.5c-0.271,0.012-0.5,0.22-0.5,0.5c0,0.469,0,0.939,0,1.408H5.562c-1.378,0-2.5,1.122-2.5,2.5v11\n            c0,1.379,1.122,2.5,2.5,2.5h12.875c1.379,0,2.5-1.121,2.5-2.5v-11C20.938,6.076,19.816,4.954,18.438,4.954z M5.562,5.954H7.5\n            c0,0.073,0,0.147,0,0.22c0,0.124,0,0.248,0,0.372c0,0.262,0.23,0.512,0.5,0.5c0.271-0.012,0.5-0.22,0.5-0.5c0-0.197,0-0.394,0-0.592\n            h7c0,0.073,0,0.147,0,0.22c0,0.124,0,0.248,0,0.372c0,0.262,0.23,0.512,0.5,0.5c0.271-0.012,0.5-0.22,0.5-0.5\n            c0-0.197,0-0.394,0-0.592h1.937c0.827,0,1.5,0.673,1.5,1.5v1.584H4.062V7.454C4.062,6.627,4.735,5.954,5.562,5.954z M18.438,19.954\n            H5.562c-0.827,0-1.5-0.673-1.5-1.5v-8.416h15.875v8.416C19.938,19.281,19.265,19.954,18.438,19.954z"}}]}]})(props);
	};
	module.exports.CiCamera = function CiCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Camera"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.435,19.925H3.565a1.5,1.5,0,0,1-1.5-1.5V9.285a1.5,1.5,0,0,1,1.5-1.5H6.223a.5.5,0,0,0,.5-.454l.166-1.8a1.49,1.49,0,0,1,1.5-1.454h7.23a1.5,1.5,0,0,1,1.5,1.5l.164,1.756a.5.5,0,0,0,.5.454h2.658a1.5,1.5,0,0,1,1.5,1.5v9.14A1.5,1.5,0,0,1,20.435,19.925ZM3.565,8.785a.5.5,0,0,0-.5.5v9.14a.5.5,0,0,0,.5.5h16.87a.5.5,0,0,0,.5-.5V9.285a.5.5,0,0,0-.5-.5H17.777a1.5,1.5,0,0,1-1.494-1.362l-.166-1.8a.515.515,0,0,0-.5-.546H8.385a.5.5,0,0,0-.5.5L7.717,7.423A1.5,1.5,0,0,1,6.223,8.785Z"}},{"tag":"path","attr":{"d":"M12,17.282a4,4,0,1,1,4-4A4,4,0,0,1,12,17.282Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,12,10.282Z"}}]}]}]})(props);
	};
	module.exports.CiChat1 = function CiChat1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Chat_1"},"child":[{"tag":"path","attr":{"d":"M3.316,19.937A1.251,1.251,0,0,1,2.065,18.69l0-1.716L2.068,6.56a2.5,2.5,0,0,1,2.5-2.5H19.44a2.5,2.5,0,0,1,2.5,2.5v8.41a2.5,2.5,0,0,1-2.5,2.5H6.918a1.49,1.49,0,0,0-1.06.439L4.2,19.57A1.246,1.246,0,0,1,3.316,19.937ZM4.568,5.062a1.5,1.5,0,0,0-1.5,1.5L3.06,16.973l0,1.714a.25.25,0,0,0,.427.176L5.151,17.2a2.482,2.482,0,0,1,1.767-.732H19.44a1.5,1.5,0,0,0,1.5-1.5V6.562a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]})(props);
	};
	module.exports.CiChat2 = function CiChat2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Chat_2"},"child":[{"tag":"path","attr":{"d":"M12,19.937a1.243,1.243,0,0,1-.833-.319L9.281,17.932a1.531,1.531,0,0,0-1.08-.458H4.561a2.5,2.5,0,0,1-2.5-2.5l.006-8.41a2.5,2.5,0,0,1,2.5-2.5H19.439a2.5,2.5,0,0,1,2.5,2.5v8.411a2.5,2.5,0,0,1-2.5,2.5H15.79a1.483,1.483,0,0,0-1.062.441l-1.895,1.7A1.243,1.243,0,0,1,12,19.937ZM4.567,5.063a1.5,1.5,0,0,0-1.5,1.5l-.006,8.411a1.5,1.5,0,0,0,1.5,1.5H8.2a2.483,2.483,0,0,1,1.767.732l1.864,1.667a.248.248,0,0,0,.333,0l1.874-1.682a2.5,2.5,0,0,1,1.751-.716h3.649a1.5,1.5,0,0,0,1.5-1.5V6.563a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]})(props);
	};
	module.exports.CiCircleAlert = function CiCircleAlert (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_Alert"},"child":[{"tag":"g","attr":{},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12.5,9a.5.5,0,0,0-1,0h0V13.02a.5.5,0,0,0,1,0Z"}},{"tag":"circle","attr":{"cx":"12","cy":"15.001","r":"0.5"}}]},{"tag":"path","attr":{"d":"M12,21.935A9.933,9.933,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.935ZM12,3.069A8.933,8.933,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.069Z"}}]}]}]})(props);
	};
	module.exports.CiCircleCheck = function CiCircleCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_Check"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M15.81,10.4a.5.5,0,0,0-.71-.71l-3.56,3.56L9.81,11.52a.5.5,0,0,0-.71.71l2.08,2.08a.513.513,0,0,0,.71,0Z"}},{"tag":"path","attr":{"d":"M12,21.934A9.934,9.934,0,1,1,21.933,12,9.945,9.945,0,0,1,12,21.934ZM12,3.067A8.934,8.934,0,1,0,20.933,12,8.944,8.944,0,0,0,12,3.067Z"}}]}]}]})(props);
	};
	module.exports.CiCircleChevDown = function CiCircleChevDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_Chev_Down"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12.35,13.85a.492.492,0,0,1-.7,0l-3-3a.495.495,0,0,1,.7-.7L12,12.79l2.65-2.64a.495.495,0,0,1,.7.7Z"}},{"tag":"path","attr":{"d":"M21.933,12A9.933,9.933,0,1,1,12,2.067,9.944,9.944,0,0,1,21.933,12ZM3.067,12A8.933,8.933,0,1,0,12,3.067,8.943,8.943,0,0,0,3.067,12Z"}}]}]}]})(props);
	};
	module.exports.CiCircleChevLeft = function CiCircleChevLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_Chev_Left"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M10.15,12.35a.492.492,0,0,1,0-.7l3-3a.495.495,0,0,1,.7.7L11.21,12l2.64,2.65a.495.495,0,0,1-.7.7Z"}},{"tag":"path","attr":{"d":"M12,21.933A9.933,9.933,0,1,1,21.933,12,9.944,9.944,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.933,12,8.943,8.943,0,0,0,12,3.067Z"}}]}]}]})(props);
	};
	module.exports.CiCircleChevRight = function CiCircleChevRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_Chev_Right"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M13.85,11.65a.492.492,0,0,1,0,.7l-3,3a.495.495,0,0,1-.7-.7L12.79,12,10.15,9.35a.495.495,0,0,1,.7-.7Z"}},{"tag":"path","attr":{"d":"M12,2.067A9.933,9.933,0,1,1,2.067,12,9.944,9.944,0,0,1,12,2.067Zm0,18.866A8.933,8.933,0,1,0,3.067,12,8.943,8.943,0,0,0,12,20.933Z"}}]}]}]})(props);
	};
	module.exports.CiCircleChevUp = function CiCircleChevUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_Chev_Up"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M11.65,10.15a.492.492,0,0,1,.7,0l3,3a.495.495,0,0,1-.7.7L12,11.21,9.35,13.85a.495.495,0,0,1-.7-.7Z"}},{"tag":"path","attr":{"d":"M2.067,12A9.933,9.933,0,1,1,12,21.934,9.944,9.944,0,0,1,2.067,12Zm18.866,0A8.933,8.933,0,1,0,12,20.934,8.943,8.943,0,0,0,20.933,12Z"}}]}]}]})(props);
	};
	module.exports.CiCircleInfo = function CiCircleInfo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_Info"},"child":[{"tag":"g","attr":{},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M11.5,15a.5.5,0,0,0,1,0h0V10.981a.5.5,0,0,0-1,0Z"}},{"tag":"circle","attr":{"cx":"12","cy":"8.999","r":"0.5"}}]},{"tag":"path","attr":{"d":"M12,2.065A9.934,9.934,0,1,1,2.066,12,9.945,9.945,0,0,1,12,2.065Zm0,18.867A8.934,8.934,0,1,0,3.066,12,8.944,8.944,0,0,0,12,20.932Z"}}]}]}]})(props);
	};
	module.exports.CiCircleList = function CiCircleList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_List"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.438,6.062h-9a.5.5,0,0,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.438,12.5h-9a.5.5,0,0,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.438,18.935h-9a.5.5,0,1,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M5.562,8.062a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,5.562,8.062Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,5.562,4.062Z"}},{"tag":"path","attr":{"d":"M5.562,14.5a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,5.562,14.5Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,5.562,10.5Z"}},{"tag":"path","attr":{"d":"M5.562,20.938a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,5.562,20.938Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,5.562,16.938Z"}}]}]}]})(props);
	};
	module.exports.CiCircleMinus = function CiCircleMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_Minus"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M15,11.5h0a.5.5,0,0,1,0,1H9a.5.5,0,0,1,0-1Z"}},{"tag":"path","attr":{"d":"M12,21.934A9.933,9.933,0,1,1,21.932,12,9.945,9.945,0,0,1,12,21.934ZM12,3.068A8.933,8.933,0,1,0,20.932,12,8.944,8.944,0,0,0,12,3.068Z"}}]}]}]})(props);
	};
	module.exports.CiCircleMore = function CiCircleMore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_More"},"child":[{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"cx":"12.001","cy":"12","r":"1"}},{"tag":"circle","attr":{"cx":"16.001","cy":"12","r":"1"}},{"tag":"circle","attr":{"cx":"8.001","cy":"12","r":"1"}},{"tag":"path","attr":{"d":"M12,21.932A9.934,9.934,0,1,1,21.934,12,9.944,9.944,0,0,1,12,21.932ZM12,3.065A8.934,8.934,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.065Z"}}]}]}]})(props);
	};
	module.exports.CiCirclePlus = function CiCirclePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_Plus"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M15,12.5H12.5V15a.5.5,0,0,1-1,0V12.5H9a.5.5,0,0,1,0-1h2.5V9a.5.5,0,0,1,1,0v2.5H15A.5.5,0,0,1,15,12.5Z"}},{"tag":"path","attr":{"d":"M12,21.932A9.934,9.934,0,1,1,21.932,12,9.944,9.944,0,0,1,12,21.932ZM12,3.065A8.934,8.934,0,1,0,20.932,12,8.944,8.944,0,0,0,12,3.065Z"}}]}]}]})(props);
	};
	module.exports.CiCircleQuestion = function CiCircleQuestion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_Question"},"child":[{"tag":"g","attr":{},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M11.411,12.459a1.547,1.547,0,0,1,.341-.6,2.644,2.644,0,0,1,.535-.417,2.2,2.2,0,0,0,.363-.286,1.2,1.2,0,0,0,.256-.363A1.084,1.084,0,0,0,13,10.341a.923.923,0,0,0-.142-.517.938.938,0,0,0-.374-.338,1.123,1.123,0,0,0-.519-.119,1.173,1.173,0,0,0-.495.107.934.934,0,0,0-.389.335.884.884,0,0,0-.111.224.516.516,0,0,1-.483.359h0a.506.506,0,0,1-.479-.675,1.661,1.661,0,0,1,.178-.349,1.8,1.8,0,0,1,.748-.634,2.437,2.437,0,0,1,1.031-.215,2.4,2.4,0,0,1,1.082.231,1.737,1.737,0,0,1,.721.641,1.772,1.772,0,0,1,.257.96,1.841,1.841,0,0,1-.118.678,1.685,1.685,0,0,1-.334.536,2.289,2.289,0,0,1-.52.417,2.277,2.277,0,0,0-.462.369,1.113,1.113,0,0,0-.256.455,2.344,2.344,0,0,0-.045.283.487.487,0,0,1-.483.429h0a.484.484,0,0,1-.483-.531A2.931,2.931,0,0,1,11.411,12.459Z"}},{"tag":"circle","attr":{"cx":"11.793","cy":"14.891","r":"0.587"}}]},{"tag":"path","attr":{"d":"M12,21.931A9.934,9.934,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.931ZM12,3.064A8.934,8.934,0,1,0,20.934,12,8.943,8.943,0,0,0,12,3.064Z"}}]}]}]})(props);
	};
	module.exports.CiCircleRemove = function CiCircleRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Circle_Remove"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M9.525,13.765a.5.5,0,0,0,.71.71c.59-.59,1.175-1.18,1.765-1.76l1.765,1.76a.5.5,0,0,0,.71-.71c-.59-.58-1.18-1.175-1.76-1.765.41-.42.82-.825,1.23-1.235.18-.18.35-.36.53-.53a.5.5,0,0,0-.71-.71L12,11.293,10.235,9.525a.5.5,0,0,0-.71.71L11.293,12Z"}},{"tag":"path","attr":{"d":"M12,21.933A9.933,9.933,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.067Z"}}]}]}]})(props);
	};
	module.exports.CiClock1 = function CiClock1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Clock_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.933A9.933,9.933,0,1,1,21.933,12,9.944,9.944,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.933,12,8.943,8.943,0,0,0,12,3.067Z"}},{"tag":"path","attr":{"d":"M11.5,6a.5.5,0,0,1,1,0v4.8c1.13-1.13,2.26-2.27,3.39-3.4a.5.5,0,0,1,.71.71l-4.26,4.25a.463.463,0,0,1-.58.07c-.01-.02-.02-.02-.03-.02a.425.425,0,0,1-.22-.33Z"}}]}]}]})(props);
	};
	module.exports.CiClock2 = function CiClock2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Clock_2"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.933A9.933,9.933,0,1,1,21.933,12,9.944,9.944,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.933,12,8.943,8.943,0,0,0,12,3.067Z"}},{"tag":"path","attr":{"d":"M18,12.5H12a.429.429,0,0,1-.34-.14c-.01,0-.01-.01-.02-.02A.429.429,0,0,1,11.5,12V6a.5.5,0,0,1,1,0v5.5H18A.5.5,0,0,1,18,12.5Z"}}]}]}]})(props);
	};
	module.exports.CiCloudDrizzle = function CiCloudDrizzle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Cloud_Drizzle"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.605,16.787v1.018a.5.5,0,0,0,1,0V16.787a.516.516,0,0,0-.146-.354.5.5,0,0,0-.854.354Z"}},{"tag":"path","attr":{"d":"M11.5,16.787v1.018a.516.516,0,0,0,.146.353.5.5,0,0,0,.854-.353V16.787a.521.521,0,0,0-.146-.354.5.5,0,0,0-.854.354Z"}},{"tag":"path","attr":{"d":"M14.552,20.343v1.018a.5.5,0,0,0,1,0V20.343a.516.516,0,0,0-.146-.354.5.5,0,0,0-.854.354Z"}},{"tag":"path","attr":{"d":"M8.446,20.343v1.018a.5.5,0,0,0,1,0V20.343a.521.521,0,0,0-.146-.354.5.5,0,0,0-.854.354Z"}},{"tag":"path","attr":{"d":"M5.393,16.787v1.018a.5.5,0,0,0,1,0V16.787a.521.521,0,0,0-.146-.354.5.5,0,0,0-.854.354Z"}},{"tag":"path","attr":{"d":"M16.1,14.228h-5.99A6.116,6.116,0,0,1,3.916,8.474h0A6.044,6.044,0,0,1,9.953,2.139a6.07,6.07,0,0,1,5.8,4.366,3.919,3.919,0,0,1,3.288,1.2,3.85,3.85,0,0,1,1.038,2.908A3.946,3.946,0,0,1,16.1,14.228ZM4.915,8.427a5.117,5.117,0,0,0,5.194,4.8H16.1a2.944,2.944,0,0,0,2.986-2.682,2.873,2.873,0,0,0-3.494-3l-.2.046-.25-.124a.592.592,0,0,1-.262-.377A5.061,5.061,0,0,0,9.953,3.139,5.043,5.043,0,0,0,4.915,8.427Z"}}]}]}]})(props);
	};
	module.exports.CiCloudMoon = function CiCloudMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Cloud_Moon"},"child":[{"tag":"path","attr":{"d":"M21.36,11.54a.71.71,0,0,0-.73-.29,5.278,5.278,0,0,1-6.34-4.78,5.379,5.379,0,0,1,.37-2.42.729.729,0,0,0-.15-.78.7.7,0,0,0-.76-.16A6.317,6.317,0,0,0,9.77,8.99a5.494,5.494,0,0,0-1.22-.13A6.039,6.039,0,0,0,2.5,14.89c0,.1.01.2.01.3A6.114,6.114,0,0,0,8.7,20.94h5.99a3.941,3.941,0,0,0,3.98-3.61,3.755,3.755,0,0,0-.63-2.38A6.283,6.283,0,0,0,21.4,12.3.682.682,0,0,0,21.36,11.54Zm-6.67,8.4H8.7a5.121,5.121,0,0,1-5.19-4.8A5.042,5.042,0,0,1,8.55,9.86a5.059,5.059,0,0,1,4.92,3.95.548.548,0,0,0,.26.37l.25.13.2-.05a2.873,2.873,0,0,1,3.49,3A2.931,2.931,0,0,1,14.69,19.94Zm2.61-5.83a3.917,3.917,0,0,0-2.95-.89A6.043,6.043,0,0,0,10.78,9.3a5.338,5.338,0,0,1,2.73-4.98,6.325,6.325,0,0,0,4.51,7.85,6.642,6.642,0,0,0,2.12.17A5.2,5.2,0,0,1,17.3,14.11Z"}}]}]})(props);
	};
	module.exports.CiCloudOff = function CiCloudOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Cloud_Off"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.8,16.577c-.41.49-1.12-.22-.7-.71a3.585,3.585,0,0,0,.37-4.04A3.266,3.266,0,0,0,16.6,10.3a.5.5,0,0,1-.56-.23,5.391,5.391,0,0,0-5.3-3.1c-.64.04-.64-.96,0-1a6.346,6.346,0,0,1,5.99,3.26,4.255,4.255,0,0,1,4.6,2.1A4.579,4.579,0,0,1,20.8,16.577Z"}},{"tag":"path","attr":{"d":"M4.941,4.237a.5.5,0,0,0-.7.7l2.69,2.69a6.273,6.273,0,0,0-1.94,3.78,3.342,3.342,0,0,0-2.65,4.6,3.518,3.518,0,0,0,3.48,2.05h11.53c.58.57,1.14,1.14,1.71,1.71a.5.5,0,0,0,.71-.71Zm.3,12.81a2.352,2.352,0,0,1-2.16-2.25,2.309,2.309,0,0,1,2.35-2.42.515.515,0,0,0,.5-.5,5.377,5.377,0,0,1,1.71-3.54q4.35,4.365,8.71,8.72Z"}}]}]}]})(props);
	};
	module.exports.CiCloudOn = function CiCloudOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Cloud_On"},"child":[{"tag":"path","attr":{"d":"M21.917,13.484a4.381,4.381,0,0,0-5.19-4.26,6.281,6.281,0,0,0-11.75,2.19,3.237,3.237,0,0,0-2.66,2,3.433,3.433,0,0,0,.82,3.74c1.12,1.03,2.54.89,3.94.89h10.15a4.514,4.514,0,0,0,4.69-4.32Zm-4.65,3.56c-1.19.01-2.38,0-3.56,0-2.75,0-5.49.06-8.23,0a2.383,2.383,0,0,1-2.33-1.73,2.333,2.333,0,0,1,2.28-2.94.515.515,0,0,0,.5-.5,5.3,5.3,0,0,1,10.11-1.81.5.5,0,0,0,.56.23,3.366,3.366,0,0,1,4.33,3.32A3.489,3.489,0,0,1,17.267,17.044Z"}}]}]})(props);
	};
	module.exports.CiCloudRainbow = function CiCloudRainbow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Cloud_Rainbow"},"child":[{"tag":"path","attr":{"d":"M21.8,6.648a8.6,8.6,0,0,0-12.78.82,6.329,6.329,0,0,0-.761-.05,6.212,6.212,0,0,0-6.2,6.2c0,.1.01.2.01.3a6.277,6.277,0,0,0,6.351,5.89h6.159a4.04,4.04,0,0,0,4.081-3.7,3.916,3.916,0,0,0-1.07-2.97,3.98,3.98,0,0,0-3.37-1.23,5.582,5.582,0,0,0-.38-.97,2.617,2.617,0,0,1,3.75-.08c.46.45,1.169-.26.71-.71a3.66,3.66,0,0,0-2.77-1.05,3.594,3.594,0,0,0-2.2.96,6.746,6.746,0,0,0-1.02-1.12,5.131,5.131,0,0,1,7.031.17c.46.45,1.169-.26.71-.71a6.134,6.134,0,0,0-4.51-1.77,5.982,5.982,0,0,0-4.031,1.73,5.632,5.632,0,0,0-1.409-.65,7.615,7.615,0,0,1,10.99-.35C21.546,7.808,22.255,7.1,21.8,6.648Zm-10.56,2.71a.712.712,0,0,0,.11.08,5.238,5.238,0,0,1,1.979,3.06.6.6,0,0,0,.271.37l.25.13.2-.05a2.977,2.977,0,0,1,3.61,3.1,3.037,3.037,0,0,1-3.081,2.76H8.416a5.27,5.27,0,0,1-5.351-4.94,5.2,5.2,0,0,1,8.171-4.51Z"}}]}]})(props);
	};
	module.exports.CiCloudSun = function CiCloudSun (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Cloud_Sun"},"child":[{"tag":"path","attr":{"d":"M21.465,9.47l-1.9-1.05.58-2.16a.968.968,0,0,0-.25-.93.957.957,0,0,0-.93-.24l-2.09.6-1.13-1.94a.988.988,0,0,0-.83-.47.967.967,0,0,0-.82.48l-1.06,1.91-2.16-.58a.951.951,0,0,0-.92.24.962.962,0,0,0-.25.93l.6,2.1-.77.44A6.3,6.3,0,0,0,8.1,8.63a6.039,6.039,0,0,0-6.04,6.03c0,.1.01.2.01.3a6.115,6.115,0,0,0,6.19,5.76h5.98a3.952,3.952,0,0,0,3.99-3.62,3.876,3.876,0,0,0-.35-1.88l1.1.3a1.007,1.007,0,0,0,.25.03.907.907,0,0,0,.67-.28.95.95,0,0,0,.25-.92l-.6-2.1,1.93-1.12a.956.956,0,0,0,.47-.83A.945.945,0,0,0,21.465,9.47Zm-7.73,4.57a2.873,2.873,0,0,1,3.49,3,2.947,2.947,0,0,1-2.99,2.68H8.255a5.307,5.307,0,0,1-3.6-1.39,4.935,4.935,0,0,1-1.6-3.41A5.043,5.043,0,0,1,8.1,9.63a5.109,5.109,0,0,1,4.09,2.09,5.932,5.932,0,0,1,.4.65,4.974,4.974,0,0,1,.43,1.21A.64.64,0,0,0,13.735,14.04Zm-.92-3.73a2.106,2.106,0,0,1,4.133-.578,2.114,2.114,0,0,1-2.033,2.688A2.241,2.241,0,0,1,12.815,10.31Zm4.12,3.64a3.9,3.9,0,0,0-1.08-.67,3.11,3.11,0,1,0-4.01-3.34,6.475,6.475,0,0,0-1.09-.69l.06-.03a.978.978,0,0,0,.44-1.07l-.64-2.1,2.17.58a.981.981,0,0,0,1.07-.44l1.03-1.93,1.12,1.92a.952.952,0,0,0,1.08.45L19.175,6l-.57,2.14a.922.922,0,0,0,.44,1.09l1.92,1.04-1.92,1.11a.941.941,0,0,0-.45,1.08l.63,2.09Z"}}]}]})(props);
	};
	module.exports.CiCloud = function CiCloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Cloud"},"child":[{"tag":"path","attr":{"d":"M17.1,19.4H9.646a7.492,7.492,0,0,1-7.588-7.046h0A7.4,7.4,0,0,1,9.452,4.6a7.434,7.434,0,0,1,7.136,5.447,4.731,4.731,0,0,1,4.092,1.441,4.664,4.664,0,0,1,1.26,3.529A4.789,4.789,0,0,1,17.1,19.4ZM3.057,12.309A6.493,6.493,0,0,0,9.646,18.4H17.1a3.787,3.787,0,0,0,3.839-3.453,3.7,3.7,0,0,0-4.5-3.86l-.2.046-.269-.127a.617.617,0,0,1-.273-.392A6.422,6.422,0,0,0,9.452,5.6a6.4,6.4,0,0,0-6.395,6.711Z"}}]}]})(props);
	};
	module.exports.CiCoffeeBean = function CiCoffeeBean (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Coffee_Bean"},"child":[{"tag":"path","attr":{"d":"M19.151,4.868a6.744,6.744,0,0,0-5.96-1.69,12.009,12.009,0,0,0-6.54,3.47,11.988,11.988,0,0,0-3.48,6.55,6.744,6.744,0,0,0,1.69,5.95,6.406,6.406,0,0,0,4.63,1.78,11.511,11.511,0,0,0,7.87-3.56C21.3,13.428,22.1,7.818,19.151,4.868Zm-14.99,8.48a11.041,11.041,0,0,1,3.19-5.99,10.976,10.976,0,0,1,5.99-3.19,8.016,8.016,0,0,1,1.18-.09,5.412,5.412,0,0,1,3.92,1.49.689.689,0,0,1,.11.13,6.542,6.542,0,0,1-2.12,1.23,7.666,7.666,0,0,0-2.96,1.93,7.666,7.666,0,0,0-1.93,2.96,6.589,6.589,0,0,1-1.71,2.63,6.7,6.7,0,0,1-2.63,1.71,7.478,7.478,0,0,0-2.35,1.36A6.18,6.18,0,0,1,4.161,13.348Zm12.49,3.31c-3.55,3.55-8.52,4.35-11.08,1.79a1.538,1.538,0,0,1-.12-.13,6.677,6.677,0,0,1,2.13-1.23,7.862,7.862,0,0,0,2.96-1.93,7.738,7.738,0,0,0,1.93-2.96,6.589,6.589,0,0,1,1.71-2.63,6.589,6.589,0,0,1,2.63-1.71,7.6,7.6,0,0,0,2.34-1.37C20.791,9.2,19.821,13.488,16.651,16.658Z"}}]}]})(props);
	};
	module.exports.CiCoffeeCup = function CiCoffeeCup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Coffee_Cup"},"child":[{"tag":"path","attr":{"d":"M18.79,5.67a1.5,1.5,0,0,0-1.16-1.46l-.38-1.38a1.081,1.081,0,0,0-1.05-.76H7.79a1.06,1.06,0,0,0-1.04.76L6.37,4.21A1.537,1.537,0,0,0,5.21,5.76,1.476,1.476,0,0,0,6.27,7.18l.1,2.77a.75.75,0,0,0-.42.22.768.768,0,0,0-.21.56l.24,5.76a.759.759,0,0,0,.65.72l.08,2.22a2.579,2.579,0,0,0,2.59,2.5h5.39a2.581,2.581,0,0,0,2.6-2.5l.08-2.22a.76.76,0,0,0,.64-.72l.24-5.76a.768.768,0,0,0-.21-.56.72.72,0,0,0-.41-.22l.1-2.77A1.534,1.534,0,0,0,18.79,5.67Zm-11-2.6,8.49.03.3,1.07H7.44Zm8.5,16.33a1.578,1.578,0,0,1-1.6,1.53H9.3A1.575,1.575,0,0,1,7.71,19.4l-.08-2.18h8.74ZM9.9,13.58a2.1,2.1,0,1,1,2.1,2.1A2.1,2.1,0,0,1,9.9,13.58Zm6.73-3.65H7.37l-.1-2.67h9.45Zm.66-3.67H6.71a.522.522,0,0,1-.5-.59.5.5,0,0,1,.5-.5H17.29a.528.528,0,0,1,.5.59A.5.5,0,0,1,17.29,6.26Z"}}]}]})(props);
	};
	module.exports.CiCoinInsert = function CiCoinInsert (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Coin_Insert"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M21.44,17.7H17.77a7.484,7.484,0,0,0,1.78-4.86A7.55,7.55,0,1,0,6.23,17.7H2.56a.508.508,0,0,0-.5.5.5.5,0,0,0,.5.5H21.44a.5.5,0,0,0,.5-.5A.508.508,0,0,0,21.44,17.7Zm-5.03,0H7.62a6.546,6.546,0,1,1,8.78-.01Z"}},{"tag":"path","attr":{"d":"M14,13.965a1.616,1.616,0,0,1-1.5,1.61v.65a.485.485,0,0,1-.5.48.491.491,0,0,1-.5-.48v-.64h-.81a.5.5,0,0,1-.5-.5.508.508,0,0,1,.5-.5h1.69a.617.617,0,0,0,.62-.62.623.623,0,0,0-.62-.62h-.75a1.618,1.618,0,0,1-.13-3.23v-.65a.491.491,0,0,1,.5-.48.485.485,0,0,1,.5.48v.64h.81a.5.5,0,0,1,0,1H11.63a.62.62,0,0,0,0,1.24h.75A1.626,1.626,0,0,1,14,13.965Z"}}]}]}]})(props);
	};
	module.exports.CiCoins1 = function CiCoins1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Coins_1"},"child":[{"tag":"path","attr":{"d":"M18.46,10.905a3.469,3.469,0,0,0-2.47,1.04,2.3,2.3,0,0,0-.86-1.73,2.257,2.257,0,0,0,.86-1.78,2.288,2.288,0,0,0-2.28-2.29H4.35a2.284,2.284,0,0,0-1.43,4.07,2.282,2.282,0,0,0,0,3.57,2.277,2.277,0,0,0,1.43,4.06h9.36a2.29,2.29,0,0,0,2.06-1.29,3.434,3.434,0,0,0,2.69,1.3,3.475,3.475,0,1,0,0-6.95Zm-4.75,5.94H4.35a1.28,1.28,0,1,1,0-2.56h9.36a1.28,1.28,0,1,1,0,2.56Zm0-3.56H4.35a1.285,1.285,0,1,1,0-2.57h9.36a1.285,1.285,0,0,1,0,2.57Zm0-3.57H4.35a1.285,1.285,0,1,1,0-2.57h9.36a1.285,1.285,0,0,1,0,2.57Zm4.75,7.14a2.475,2.475,0,1,1,2.48-2.48A2.477,2.477,0,0,1,18.46,16.855Z"}}]}]})(props);
	};
	module.exports.CiCompass1 = function CiCompass1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Compass_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M4.661,20.937a1.589,1.589,0,0,1-1.117-.48,1.534,1.534,0,0,1-.4-1.59L6.58,8.937A3.8,3.8,0,0,1,8.938,6.58l9.93-3.439a1.537,1.537,0,0,1,1.589.4,1.532,1.532,0,0,1,.4,1.588L17.42,15.061a3.8,3.8,0,0,1-2.358,2.358l-9.93,3.439A1.442,1.442,0,0,1,4.661,20.937ZM19.337,4.062a.424.424,0,0,0-.142.024L9.267,7.525A2.8,2.8,0,0,0,7.525,9.266L4.087,19.2a.6.6,0,0,0,.717.718l9.93-3.439a2.8,2.8,0,0,0,1.741-1.741L19.913,4.8a.551.551,0,0,0-.163-.553A.609.609,0,0,0,19.337,4.062Z"}},{"tag":"circle","attr":{"cx":"12","cy":"12","r":"1.563"}}]}]}]})(props);
	};
	module.exports.CiCreditCard1 = function CiCreditCard1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Credit_Card_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.44,5.14H4.56a2.5,2.5,0,0,0-2.5,2.5v8.72a2.5,2.5,0,0,0,2.5,2.5H19.44a2.5,2.5,0,0,0,2.5-2.5V7.64A2.5,2.5,0,0,0,19.44,5.14ZM3.06,7.64a1.5,1.5,0,0,1,1.5-1.5H19.44a1.5,1.5,0,0,1,1.5,1.5v.5H3.06Zm17.88,8.72a1.5,1.5,0,0,1-1.5,1.5H4.56a1.5,1.5,0,0,1-1.5-1.5V9.64H20.94Z"}},{"tag":"path","attr":{"d":"M8.063,14.247h-3a.5.5,0,1,1,0-1h3a.5.5,0,1,1,0,1Z"}},{"tag":"path","attr":{"d":"M18.934,14.25h-6.5a.5.5,0,1,1,0-1h6.5a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiCreditCard2 = function CiCreditCard2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Credit_Card_2"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.437,18.859H4.563a2.5,2.5,0,0,1-2.5-2.5V7.641a2.5,2.5,0,0,1,2.5-2.5H19.437a2.5,2.5,0,0,1,2.5,2.5v8.718A2.5,2.5,0,0,1,19.437,18.859ZM4.563,6.141a1.5,1.5,0,0,0-1.5,1.5v8.718a1.5,1.5,0,0,0,1.5,1.5H19.437a1.5,1.5,0,0,0,1.5-1.5V7.641a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M8.063,14.247h-3a.5.5,0,1,1,0-1h3a.5.5,0,1,1,0,1Z"}},{"tag":"path","attr":{"d":"M18.934,14.249h-6.5a.5.5,0,0,1,0-1h6.5a.5.5,0,0,1,0,1Z"}},{"tag":"rect","attr":{"x":"16.434","y":"7.14","width":"2","height":"4","rx":"0.5","transform":"translate(8.293 26.574) rotate(-90)"}}]}]}]})(props);
	};
	module.exports.CiCreditCardOff = function CiCreditCardOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Credit_Card_Off"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M21.94,7.64v9.3a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5V9.64H13.49a.75.75,0,0,1,0-1.5h7.45v-.5a1.5,1.5,0,0,0-1.5-1.5H9.89a.5.5,0,0,1,0-1h9.55A2.5,2.5,0,0,1,21.94,7.64Z"}},{"tag":"path","attr":{"d":"M8.064,14.246h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M18.935,14.248h-.944a.5.5,0,0,1,0-1h.944a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M18.76,18.05,4.01,3.3c-.46-.46-1.17.25-.71.7L4.44,5.14a2.5,2.5,0,0,0-2.38,2.5v8.72a2.5,2.5,0,0,0,2.5,2.5h13.6L20,20.7c.45.46,1.16-.25.7-.71ZM3.06,7.64a1.5,1.5,0,0,1,1.5-1.5h.88c.66.67,1.33,1.34,2,2H3.06Zm9.49,5.61h-.12a.5.5,0,0,0-.5.5.508.508,0,0,0,.5.5h1.12l3.61,3.61H4.56a1.5,1.5,0,0,1-1.5-1.5V9.64H8.94Z"}}]}]}]})(props);
	};
	module.exports.CiCrop = function CiCrop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Crop"},"child":[{"tag":"path","attr":{"d":"M5.624,6.623l-2.075,-0c-0.276,-0 -0.5,-0.224 -0.5,-0.5c-0,-0.276 0.224,-0.5 0.5,-0.5l2.075,-0l0,-2.073c0,-0.276 0.224,-0.5 0.5,-0.5c0.276,0 0.5,0.224 0.5,0.5l0,2.073l9.191,-0c1.414,-0 2.561,1.147 2.561,2.561l-0,9.193l2.075,0c0.276,0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5l-2.075,0l-0,2.073c-0,0.276 -0.224,0.5 -0.5,0.5c-0.276,-0 -0.5,-0.224 -0.5,-0.5l-0,-2.073l-9.191,0c-1.414,0 -2.561,-1.147 -2.561,-2.561l0,-9.193Zm11.752,10.754l-0,-9.193c-0,-0.862 -0.699,-1.561 -1.561,-1.561l-9.191,-0l0,9.193c0,0.862 0.699,1.561 1.561,1.561l9.191,0Z"}}]}]})(props);
	};
	module.exports.CiDark = function CiDark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Dark"},"child":[{"tag":"path","attr":{"d":"M12.741,20.917a9.389,9.389,0,0,1-1.395-.105,9.141,9.141,0,0,1-1.465-17.7,1.177,1.177,0,0,1,1.21.281,1.273,1.273,0,0,1,.325,1.293,8.112,8.112,0,0,0-.353,2.68,8.266,8.266,0,0,0,4.366,6.857,7.628,7.628,0,0,0,3.711.993,1.242,1.242,0,0,1,.994,1.963h0A9.148,9.148,0,0,1,12.741,20.917ZM10.261,4.05a.211.211,0,0,0-.065.011,8.137,8.137,0,1,0,9.131,12.526h0a.224.224,0,0,0,.013-.235.232.232,0,0,0-.206-.136A8.619,8.619,0,0,1,14.946,15.1a9.274,9.274,0,0,1-4.883-7.7,9.123,9.123,0,0,1,.4-3.008.286.286,0,0,0-.069-.285A.184.184,0,0,0,10.261,4.05Z"}}]}]})(props);
	};
	module.exports.CiDatabase = function CiDatabase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Database"},"child":[{"tag":"path","attr":{"d":"M12,2.06c-3.53,0-6.18,1.23-6.18,2.86V19.08c0,1.63,2.65,2.86,6.18,2.86s6.18-1.23,6.18-2.86V4.92C18.18,3.29,15.52,2.06,12,2.06Zm5.18,17.02c0,.78-1.97,1.86-5.18,1.86s-5.18-1.08-5.18-1.86V15.96A9.349,9.349,0,0,0,12,17.22a9.373,9.373,0,0,0,5.18-1.26Zm0-4.72c0,.78-1.97,1.86-5.18,1.86s-5.18-1.08-5.18-1.86V11.24A9.349,9.349,0,0,0,12,12.5a9.373,9.373,0,0,0,5.18-1.26Zm0-4.72c0,.78-1.97,1.86-5.18,1.86S6.82,10.42,6.82,9.64V6.52A9.349,9.349,0,0,0,12,7.78a9.373,9.373,0,0,0,5.18-1.26ZM12,6.78c-3.21,0-5.18-1.08-5.18-1.86S8.79,3.06,12,3.06s5.18,1.08,5.18,1.86S15.21,6.78,12,6.78Z"}}]}]})(props);
	};
	module.exports.CiDeliveryTruck = function CiDeliveryTruck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Delivery_Truck"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M21.47,11.185l-1.03-1.43a2.5,2.5,0,0,0-2.03-1.05H14.03V6.565a2.5,2.5,0,0,0-2.5-2.5H4.56a2.507,2.507,0,0,0-2.5,2.5v9.94a1.5,1.5,0,0,0,1.5,1.5H4.78a2.242,2.242,0,0,0,4.44,0h5.56a2.242,2.242,0,0,0,4.44,0h1.22a1.5,1.5,0,0,0,1.5-1.5v-3.87A2.508,2.508,0,0,0,21.47,11.185ZM7,18.935a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,7,18.935Zm6.03-1.93H9.15a2.257,2.257,0,0,0-4.3,0H3.56a.5.5,0,0,1-.5-.5V6.565a1.5,1.5,0,0,1,1.5-1.5h6.97a1.5,1.5,0,0,1,1.5,1.5ZM17,18.935a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,17,18.935Zm3.94-2.43a.5.5,0,0,1-.5.5H19.15a2.257,2.257,0,0,0-4.3,0h-.82v-7.3h4.38a1.516,1.516,0,0,1,1.22.63l1.03,1.43a1.527,1.527,0,0,1,.28.87Z"}},{"tag":"path","attr":{"d":"M18.029,12.205h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiDesktopMouse1 = function CiDesktopMouse1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Desktop_Mouse_1"},"child":[{"tag":"path","attr":{"d":"M13.435,2.065h-2.87a6.5,6.5,0,0,0-6.5,6.5v6.87a6.5,6.5,0,0,0,6.5,6.5h2.87a6.5,6.5,0,0,0,6.5-6.5V8.565A6.5,6.5,0,0,0,13.435,2.065Zm-8.37,6.5a5.51,5.51,0,0,1,5.5-5.5h.94v6.44H5.065Zm13.87,6.87a5.5,5.5,0,0,1-5.5,5.5h-2.87a5.5,5.5,0,0,1-5.5-5.5v-4.93h13.87Zm0-5.93h-6.43V3.065h.93a5.5,5.5,0,0,1,5.5,5.5Z"}}]}]})(props);
	};
	module.exports.CiDesktopMouse2 = function CiDesktopMouse2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Desktop_Mouse_2"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M13.437,21.938H10.563a6.508,6.508,0,0,1-6.5-6.5V8.562a6.508,6.508,0,0,1,6.5-6.5h2.874a6.508,6.508,0,0,1,6.5,6.5v6.876A6.508,6.508,0,0,1,13.437,21.938ZM10.563,3.062a5.506,5.506,0,0,0-5.5,5.5v6.876a5.506,5.506,0,0,0,5.5,5.5h2.874a5.506,5.506,0,0,0,5.5-5.5V8.562a5.506,5.506,0,0,0-5.5-5.5Z"}},{"tag":"path","attr":{"d":"M11.5,6.541v4a.5.5,0,0,0,1,0v-4a.5.5,0,0,0-1,0Z"}}]}]}]})(props);
	};
	module.exports.CiDesktop = function CiDesktop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Desktop"},"child":[{"tag":"path","attr":{"d":"M18.435,3.065H5.565a2.5,2.5,0,0,0-2.5,2.5v8.87a2.5,2.5,0,0,0,2.5,2.5h2.91l-.37,3H7a.5.5,0,0,0,0,1h10.01a.5.5,0,0,0,0-1H15.9l-.37-3h2.91a2.5,2.5,0,0,0,2.5-2.5V5.565A2.5,2.5,0,0,0,18.435,3.065Zm-9.33,16.87.38-3h5.03l.37,3Zm10.83-5.5a1.5,1.5,0,0,1-1.5,1.5H5.565a1.5,1.5,0,0,1-1.5-1.5v-.5h15.87Zm0-1.5H4.065V5.565a1.5,1.5,0,0,1,1.5-1.5h12.87a1.5,1.5,0,0,1,1.5,1.5Z"}}]}]})(props);
	};
	module.exports.CiDiscount1 = function CiDiscount1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Discount_1"},"child":[{"tag":"path","attr":{"d":"M21.953,12c0,0.591 -0.346,1.124 -0.839,1.61c-0.295,0.29 -0.639,0.568 -0.942,0.85c-0.242,0.225 -0.46,0.446 -0.562,0.692c-0.107,0.257 -0.114,0.576 -0.105,0.913c0.011,0.416 0.056,0.855 0.059,1.265c0.006,0.691 -0.123,1.304 -0.526,1.708c-0.404,0.403 -1.017,0.532 -1.708,0.526c-0.41,-0.004 -0.849,-0.048 -1.264,-0.059c-0.337,-0.009 -0.657,-0.002 -0.914,0.105c-0.246,0.102 -0.467,0.32 -0.692,0.562c-0.282,0.303 -0.56,0.647 -0.85,0.941c-0.486,0.494 -1.019,0.84 -1.61,0.84c-0.591,-0 -1.124,-0.346 -1.61,-0.84c-0.29,-0.294 -0.568,-0.638 -0.85,-0.941c-0.225,-0.242 -0.447,-0.46 -0.692,-0.562c-0.257,-0.107 -0.577,-0.114 -0.913,-0.105c-0.416,0.011 -0.855,0.055 -1.265,0.059c-0.691,0.006 -1.305,-0.123 -1.708,-0.526c-0.404,-0.404 -0.532,-1.017 -0.526,-1.708c0.003,-0.41 0.048,-0.849 0.059,-1.265c0.009,-0.337 0.002,-0.656 -0.105,-0.914c-0.102,-0.245 -0.32,-0.466 -0.562,-0.691c-0.302,-0.282 -0.646,-0.56 -0.941,-0.85c-0.493,-0.486 -0.84,-1.019 -0.84,-1.61c0,-0.591 0.347,-1.124 0.84,-1.61c0.295,-0.29 0.639,-0.568 0.941,-0.85c0.242,-0.225 0.46,-0.446 0.562,-0.691c0.107,-0.258 0.114,-0.577 0.105,-0.914c-0.011,-0.416 -0.056,-0.855 -0.059,-1.265c-0.006,-0.691 0.122,-1.304 0.526,-1.708c0.403,-0.403 1.017,-0.532 1.708,-0.526c0.41,0.004 0.849,0.048 1.265,0.059c0.336,0.009 0.656,0.002 0.913,-0.105c0.245,-0.102 0.467,-0.32 0.692,-0.562c0.282,-0.303 0.56,-0.647 0.85,-0.941c0.486,-0.494 1.019,-0.84 1.61,-0.84c0.591,0 1.124,0.346 1.61,0.84c0.29,0.294 0.568,0.638 0.85,0.941c0.225,0.242 0.446,0.46 0.692,0.562c0.257,0.107 0.577,0.114 0.914,0.105c0.415,-0.011 0.854,-0.055 1.264,-0.059c0.691,-0.006 1.304,0.123 1.708,0.526c0.403,0.404 0.532,1.017 0.526,1.708c-0.003,0.41 -0.048,0.849 -0.059,1.265c-0.009,0.337 -0.002,0.656 0.105,0.913c0.102,0.246 0.32,0.467 0.562,0.692c0.303,0.282 0.647,0.56 0.942,0.85c0.493,0.486 0.839,1.019 0.839,1.61Zm-1,0c0,-0.188 -0.088,-0.355 -0.206,-0.518c-0.164,-0.226 -0.388,-0.437 -0.622,-0.646c-0.583,-0.521 -1.205,-1.04 -1.439,-1.604c-0.242,-0.585 -0.177,-1.399 -0.136,-2.178c0.017,-0.315 0.027,-0.622 -0.015,-0.895c-0.029,-0.191 -0.08,-0.365 -0.204,-0.489c-0.125,-0.125 -0.299,-0.176 -0.49,-0.205c-0.273,-0.042 -0.58,-0.032 -0.895,-0.015c-0.779,0.041 -1.593,0.106 -2.177,-0.136c-0.565,-0.234 -1.084,-0.855 -1.605,-1.439c-0.209,-0.234 -0.42,-0.458 -0.646,-0.622c-0.163,-0.118 -0.33,-0.206 -0.518,-0.206c-0.187,0 -0.355,0.088 -0.518,0.206c-0.226,0.164 -0.437,0.388 -0.646,0.622c-0.521,0.584 -1.04,1.205 -1.605,1.439c-0.584,0.242 -1.398,0.177 -2.177,0.136c-0.315,-0.017 -0.622,-0.027 -0.895,0.015c-0.192,0.029 -0.365,0.08 -0.49,0.205c-0.125,0.124 -0.175,0.298 -0.204,0.489c-0.042,0.273 -0.032,0.58 -0.016,0.895c0.042,0.779 0.107,1.593 -0.135,2.177c-0.234,0.565 -0.855,1.084 -1.439,1.605c-0.234,0.209 -0.458,0.42 -0.622,0.646c-0.118,0.163 -0.206,0.33 -0.206,0.518c0,0.188 0.088,0.355 0.206,0.518c0.164,0.226 0.388,0.437 0.622,0.646c0.584,0.521 1.205,1.04 1.439,1.605c0.242,0.584 0.177,1.398 0.135,2.177c-0.016,0.315 -0.026,0.622 0.016,0.895c0.029,0.191 0.079,0.365 0.204,0.489c0.125,0.125 0.298,0.176 0.49,0.205c0.273,0.042 0.58,0.032 0.895,0.015c0.779,-0.041 1.593,-0.106 2.177,0.136c0.565,0.234 1.084,0.855 1.605,1.439c0.209,0.234 0.42,0.458 0.646,0.622c0.163,0.118 0.331,0.206 0.518,0.206c0.188,-0 0.355,-0.088 0.518,-0.206c0.226,-0.164 0.437,-0.388 0.646,-0.622c0.521,-0.584 1.04,-1.205 1.605,-1.439c0.584,-0.242 1.398,-0.177 2.177,-0.136c0.315,0.017 0.622,0.027 0.895,-0.015c0.191,-0.029 0.365,-0.08 0.49,-0.205c0.124,-0.124 0.175,-0.298 0.204,-0.489c0.042,-0.273 0.032,-0.58 0.015,-0.895c-0.041,-0.779 -0.106,-1.593 0.136,-2.178c0.234,-0.564 0.856,-1.083 1.439,-1.604c0.234,-0.209 0.458,-0.42 0.622,-0.646c0.118,-0.163 0.206,-0.33 0.206,-0.518Zm-10.531,-1.762c-0.396,0.396 -1.039,0.396 -1.435,-0c-0.396,-0.396 -0.396,-1.04 -0,-1.436c0.396,-0.396 1.039,-0.396 1.435,0c0.396,0.396 0.396,1.04 0,1.436Zm4.471,-1.838c0.195,-0.195 0.512,-0.195 0.707,0c0.195,0.195 0.195,0.512 -0,0.707l-6.493,6.493c-0.195,0.195 -0.512,0.195 -0.707,0c-0.195,-0.195 -0.195,-0.512 -0,-0.707l6.493,-6.493Zm-1.315,5.363c0.396,-0.396 1.039,-0.396 1.435,0c0.396,0.396 0.396,1.04 0,1.436c-0.396,0.396 -1.039,0.396 -1.435,-0c-0.397,-0.396 -0.397,-1.04 -0,-1.436Z"}}]}]})(props);
	};
	module.exports.CiDollar = function CiDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Dollar"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.934A9.934,9.934,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.934ZM12,3.066A8.934,8.934,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.066Z"}},{"tag":"path","attr":{"d":"M14.5,13.5a2.006,2.006,0,0,1-2,2v1.01a.5.5,0,0,1-1,0V15.5H10.25a.5.5,0,0,1,0-1H12.5a1,1,0,0,0,0-2h-1a2,2,0,0,1,0-4V7.49a.5.5,0,0,1,1,0V8.5h1.25a.5.5,0,0,1,0,1H11.5a1,1,0,0,0,0,2h1A2.006,2.006,0,0,1,14.5,13.5Z"}}]}]}]})(props);
	};
	module.exports.CiDroplet = function CiDroplet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Droplet"},"child":[{"tag":"path","attr":{"d":"M12,21.936A7.27,7.27,0,0,1,7.656,20.5c-2.332-1.724-3.187-5.6-1.868-8.46l4.875-9.173A1.515,1.515,0,0,1,12,2.064h0a1.512,1.512,0,0,1,1.337.805L18.2,12.017c1.331,2.888.475,6.762-1.856,8.485A7.274,7.274,0,0,1,12,21.936ZM12,3.064a.51.51,0,0,0-.456.274L6.683,12.485c-1.1,2.4-.376,5.777,1.568,7.212a6.4,6.4,0,0,0,7.5,0c1.942-1.435,2.668-4.817,1.554-7.237l-4.85-9.122A.507.507,0,0,0,12,3.064Z"}}]}]})(props);
	};
	module.exports.CiDumbbell = function CiDumbbell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Dumbbell"},"child":[{"tag":"path","attr":{"d":"M21.435,11.5h-.38V8.12a1.626,1.626,0,0,0-1.62-1.62h-.63V6.12a1.625,1.625,0,0,0-3.25,0V11.5H8.445V6.12a1.625,1.625,0,0,0-3.25,0V6.5h-.63a1.62,1.62,0,0,0-1.62,1.62V11.5h-.38a.5.5,0,1,0,0,1h.38v3.37a1.622,1.622,0,0,0,1.62,1.63H5.2v.37a1.625,1.625,0,1,0,3.25,0V12.5h7.11v5.37a1.625,1.625,0,1,0,3.25,0V17.5h.63a1.628,1.628,0,0,0,1.62-1.63V12.5h.38a.5.5,0,1,0,0-1ZM5.2,16.5h-.63a.625.625,0,0,1-.62-.63V8.12a.623.623,0,0,1,.62-.62H5.2Zm2.25,1.37a.634.634,0,0,1-.63.63.625.625,0,0,1-.62-.63V6.12a.623.623,0,0,1,.62-.62.632.632,0,0,1,.63.62Zm10.36,0a.625.625,0,1,1-1.25,0V6.12a.625.625,0,0,1,1.25,0Zm2.25-2a.625.625,0,0,1-.62.63h-.63v-9h.63a.623.623,0,0,1,.62.62Z"}}]}]})(props);
	};
	module.exports.CiEdit = function CiEdit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Edit"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M3.548,20.938h16.9a.5.5,0,0,0,0-1H3.548a.5.5,0,0,0,0,1Z"}},{"tag":"path","attr":{"d":"M9.71,17.18a2.587,2.587,0,0,0,1.12-.65l9.54-9.54a1.75,1.75,0,0,0,0-2.47l-.94-.93a1.788,1.788,0,0,0-2.47,0L7.42,13.12a2.473,2.473,0,0,0-.64,1.12L6.04,17a.737.737,0,0,0,.19.72.767.767,0,0,0,.53.22Zm.41-1.36a1.468,1.468,0,0,1-.67.39l-.97.26-1-1,.26-.97a1.521,1.521,0,0,1,.39-.67l.38-.37,1.99,1.99Zm1.09-1.08L9.22,12.75l6.73-6.73,1.99,1.99Zm8.45-8.45L18.65,7.3,16.66,5.31l1.01-1.02a.748.748,0,0,1,1.06,0l.93.94A.754.754,0,0,1,19.66,6.29Z"}}]}]}]})(props);
	};
	module.exports.CiEraser = function CiEraser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Eraser"},"child":[{"tag":"path","attr":{"d":"M20.454,19.028h-7.01l6.62-6.63a2.935,2.935,0,0,0,.87-2.09,2.844,2.844,0,0,0-.87-2.05l-3.42-3.44a2.93,2.93,0,0,0-4.13.01L3.934,13.4a2.946,2.946,0,0,0,0,4.14l1.48,1.49H3.554a.5.5,0,0,0,0,1h16.9A.5.5,0,0,0,20.454,19.028Zm-7.24-13.5a1.956,1.956,0,0,1,2.73,0l3.42,3.44a1.868,1.868,0,0,1,.57,1.35,1.93,1.93,0,0,1-.57,1.37l-5.64,5.64-6.15-6.16Zm-1.19,13.5h-5.2l-2.18-2.2a1.931,1.931,0,0,1,0-2.72l2.23-2.23,6.15,6.15Z"}}]}]})(props);
	};
	module.exports.CiExport = function CiExport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Export"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M5.552,20.968a2.577,2.577,0,0,1-2.5-2.73c-.012-2.153,0-4.306,0-6.459a.5.5,0,0,1,1,0c0,2.2-.032,4.4,0,6.6.016,1.107.848,1.589,1.838,1.589H18.353A1.546,1.546,0,0,0,19.825,19a3.023,3.023,0,0,0,.1-1.061V11.779h0a.5.5,0,0,1,1,0c0,2.224.085,4.465,0,6.687a2.567,2.567,0,0,1-2.67,2.5Z"}},{"tag":"path","attr":{"d":"M12.337,3.176a.455.455,0,0,0-.311-.138c-.015,0-.028,0-.043-.006s-.027,0-.041.006a.457.457,0,0,0-.312.138L7.961,6.845a.5.5,0,0,0,.707.707l2.816-2.815V15.479a.5.5,0,0,0,1,0V4.737L15.3,7.552a.5.5,0,0,0,.707-.707Z"}}]}]}]})(props);
	};
	module.exports.CiFaceFrown = function CiFaceFrown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Face_Frown"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.942A9.942,9.942,0,1,1,21.942,12,9.953,9.953,0,0,1,12,21.942ZM12,3.058A8.942,8.942,0,1,0,20.942,12,8.952,8.952,0,0,0,12,3.058Z"}},{"tag":"path","attr":{"d":"M17.206,16.481a6.033,6.033,0,0,0-10.412,0,.5.5,0,0,0,.863.5,5.033,5.033,0,0,1,8.685,0,.5.5,0,0,0,.864-.5Z"}},{"tag":"circle","attr":{"cx":"9","cy":"9.011","r":"1.25"}},{"tag":"circle","attr":{"cx":"15","cy":"9.011","r":"1.25"}}]}]}]})(props);
	};
	module.exports.CiFaceMeh = function CiFaceMeh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Face_Meh"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.942A9.942,9.942,0,1,1,21.942,12,9.953,9.953,0,0,1,12,21.942ZM12,3.058A8.942,8.942,0,1,0,20.942,12,8.952,8.952,0,0,0,12,3.058Z"}},{"tag":"circle","attr":{"cx":"9.001","cy":"8.99","r":"1.25"}},{"tag":"circle","attr":{"cx":"15.001","cy":"8.99","r":"1.25"}},{"tag":"path","attr":{"d":"M8.438,15.939h7.125a.5.5,0,0,0,0-1H8.438a.5.5,0,0,0,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiFaceSmile = function CiFaceSmile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Face_Smile"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.942A9.942,9.942,0,1,1,21.942,12,9.953,9.953,0,0,1,12,21.942ZM12,3.058A8.942,8.942,0,1,0,20.942,12,8.952,8.952,0,0,0,12,3.058Z"}},{"tag":"path","attr":{"d":"M16.693,13.744a5.041,5.041,0,0,1-9.387,0c-.249-.59-1.111-.081-.863.505a6.026,6.026,0,0,0,11.114,0c.247-.586-.614-1.1-.864-.505Z"}},{"tag":"circle","attr":{"cx":"9","cy":"9.011","r":"1.25"}},{"tag":"circle","attr":{"cx":"15","cy":"9.011","r":"1.25"}}]}]}]})(props);
	};
	module.exports.CiFacebook = function CiFacebook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Facebook"},"child":[{"tag":"path","attr":{"d":"M19.02,4.975A9.93,9.93,0,0,0,2.07,12,9.935,9.935,0,0,0,12,21.935a9.98,9.98,0,0,0,3.8-.75,10.189,10.189,0,0,0,3.22-2.16,9.934,9.934,0,0,0,0-14.05Zm-.7,13.34A8.921,8.921,0,0,1,13,20.885v-6.56h1.88a1,1,0,0,0,0-2H13V9.585a1,1,0,0,1,1-1h1.2a1,1,0,0,0,0-2H13.5a2.5,2.5,0,0,0-2.5,2.5v3.24H9.13a1,1,0,1,0,0,2H11v6.56a8.919,8.919,0,1,1,9.26-5.47A9.061,9.061,0,0,1,18.32,18.315Z"}}]}]})(props);
	};
	module.exports.CiFileOff = function CiFileOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"File_Off"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M4,3.308a.5.5,0,0,0-.7.71l.76.76v14.67a2.5,2.5,0,0,0,2.5,2.5H17.44a2.476,2.476,0,0,0,2.28-1.51l.28.28c.45.45,1.16-.26.7-.71Zm14.92,16.33a1.492,1.492,0,0,1-1.48,1.31H6.56a1.5,1.5,0,0,1-1.5-1.5V5.778Z"}},{"tag":"path","attr":{"d":"M13.38,3.088v2.92a2.5,2.5,0,0,0,2.5,2.5h3.07l-.01,6.7a.5.5,0,0,0,1,0V8.538a2.057,2.057,0,0,0-.75-1.47c-1.3-1.26-2.59-2.53-3.89-3.8a3.924,3.924,0,0,0-1.41-1.13,6.523,6.523,0,0,0-1.71-.06H6.81a.5.5,0,0,0,0,1Zm4.83,4.42H15.88a1.5,1.5,0,0,1-1.5-1.5V3.768Z"}}]}]}]})(props);
	};
	module.exports.CiFileOn = function CiFileOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"File_On"},"child":[{"tag":"path","attr":{"d":"M19.485,7.35l-4.97-4.86a1.466,1.466,0,0,0-1.05-.43h-6.9a2.5,2.5,0,0,0-2.5,2.5V19.44a2.507,2.507,0,0,0,2.5,2.5h10.87a2.507,2.507,0,0,0,2.5-2.5V8.42A1.49,1.49,0,0,0,19.485,7.35Zm-1.27.15h-2.34a1.5,1.5,0,0,1-1.5-1.5V3.75Zm.72,11.94a1.5,1.5,0,0,1-1.5,1.5H6.565a1.5,1.5,0,0,1-1.5-1.5V4.56a1.5,1.5,0,0,1,1.5-1.5h6.81V6a2.5,2.5,0,0,0,2.5,2.5h3.06Z"}}]}]})(props);
	};
	module.exports.CiFilter = function CiFilter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Filter"},"child":[{"tag":"path","attr":{"d":"M14.037,20.937a1.015,1.015,0,0,1-.518-.145l-3.334-2a2.551,2.551,0,0,1-1.233-2.176V12.091a1.526,1.526,0,0,0-.284-.891L4.013,4.658a1.01,1.01,0,0,1,.822-1.6h14.33a1.009,1.009,0,0,1,.822,1.6h0L15.332,11.2a1.527,1.527,0,0,0-.285.891v7.834a1.013,1.013,0,0,1-1.01,1.012ZM4.835,4.063,9.482,10.62a2.515,2.515,0,0,1,.47,1.471v4.524a1.543,1.543,0,0,0,.747,1.318l3.334,2,.014-7.843a2.516,2.516,0,0,1,.471-1.471l4.654-6.542,0,0Z"}}]}]})(props);
	};
	module.exports.CiFlag1 = function CiFlag1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Flag_1"},"child":[{"tag":"path","attr":{"d":"M20.565,3.18a.809.809,0,0,0-.81-.02l-1.13.56c-1.63.87-3.82.83-6.5-.13a9.141,9.141,0,0,0-7.3.52l-.76.41V3.56a.5.5,0,0,0-1,0V20.44a.5.5,0,0,0,1,0V15.9a.836.836,0,0,0,.2-.08l1.03-.55a8.163,8.163,0,0,1,6.5-.46c2.95,1.06,5.41,1.08,7.3.07l1.44-.72a.759.759,0,0,0,.4-.66V3.82A.751.751,0,0,0,20.565,3.18Zm-.63,10.16-1.31.66c-1.63.87-3.82.83-6.5-.13a9.141,9.141,0,0,0-7.3.52l-.76.4V5.65L5.3,4.99a8.122,8.122,0,0,1,6.5-.46c2.95,1.06,5.41,1.08,7.29.08l.85-.43Z"}}]}]})(props);
	};
	module.exports.CiFloppyDisk = function CiFloppyDisk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Floppy_Disk"},"child":[{"tag":"path","attr":{"d":"M20.015,7.015l-4.15-3.39a2.54,2.54,0,0,0-1.58-.56H4.565a1.5,1.5,0,0,0-1.5,1.5v14.87a1.5,1.5,0,0,0,1.5,1.5h14.87a1.5,1.5,0,0,0,1.5-1.5V8.955A2.507,2.507,0,0,0,20.015,7.015ZM6.565,4.065h5.75v1.37a.5.5,0,0,1-.5.5H7.065a.5.5,0,0,1-.5-.5Zm0,15.87v-5.93a1.5,1.5,0,0,1,1.5-1.5h7.87a1.5,1.5,0,0,1,1.5,1.5v5.93Zm13.37-.5a.5.5,0,0,1-.5.5h-1v-5.93a2.507,2.507,0,0,0-2.5-2.5H8.065a2.5,2.5,0,0,0-2.5,2.5v5.93h-1a.5.5,0,0,1-.5-.5V4.565a.5.5,0,0,1,.5-.5h1v1.37a1.5,1.5,0,0,0,1.5,1.5h4.75a1.5,1.5,0,0,0,1.5-1.5V4.065h.97a1.514,1.514,0,0,1,.95.34l4.14,3.38a1.483,1.483,0,0,1,.56,1.17Z"}}]}]})(props);
	};
	module.exports.CiFolderOff = function CiFolderOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Folder_Off"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M4.013,3.3a.5.5,0,0,0-.711.71l.25.25A2.438,2.438,0,0,0,2.062,6.5v11a2.453,2.453,0,0,0,2.451,2.44h14.72l.759.76c.461.46,1.171-.25.711-.7Zm.5,15.64A1.45,1.45,0,0,1,3.062,17.5V6.5a1.444,1.444,0,0,1,1.31-1.43C5.893,6.6,7.432,8.14,8.963,9.66q4.485,4.485,8.96,8.97l.31.31Z"}},{"tag":"path","attr":{"d":"M21.438,17.693a.5.5,0,0,1-.5-.5V9.175a1.445,1.445,0,0,0-1.445-1.444H12.827a1.5,1.5,0,0,1-1.474-1.225l-.05-.267a1.445,1.445,0,0,0-1.42-1.178H8.8a.5.5,0,0,1,0-1H9.883a2.446,2.446,0,0,1,2.4,1.994l.05.268a.5.5,0,0,0,.491.408h6.666a2.448,2.448,0,0,1,2.445,2.444v8.018A.5.5,0,0,1,21.438,17.693Z"}}]}]}]})(props);
	};
	module.exports.CiFolderOn = function CiFolderOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Folder_On"},"child":[{"tag":"path","attr":{"d":"M19.435,19.94H4.565a2.5,2.5,0,0,1-2.5-2.5V6.56a2.5,2.5,0,0,1,2.5-2.5h5.27A2.5,2.5,0,0,1,12.292,6.1l.042.222a.5.5,0,0,0,.491.408h6.61a2.5,2.5,0,0,1,2.5,2.5v8.21A2.5,2.5,0,0,1,19.435,19.94ZM4.565,5.06a1.5,1.5,0,0,0-1.5,1.5V17.44a1.5,1.5,0,0,0,1.5,1.5h14.87a1.5,1.5,0,0,0,1.5-1.5V9.23a1.5,1.5,0,0,0-1.5-1.5h-6.61a1.5,1.5,0,0,1-1.474-1.225l-.042-.221A1.5,1.5,0,0,0,9.835,5.06Z"}}]}]})(props);
	};
	module.exports.CiFootball = function CiFootball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Football"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.278,4.757a1.64,1.64,0,0,0-1.03-1.04,12.248,12.248,0,0,0-15.53,15.53,1.64,1.64,0,0,0,1.04,1.03,12.306,12.306,0,0,0,3.95.66,12.262,12.262,0,0,0,11.57-16.18Zm-15.2,14.58a.725.725,0,0,1-.42-.42,11.379,11.379,0,0,1-.58-4.26l5.26,5.26A11.352,11.352,0,0,1,5.078,19.337Zm11.56-2.71a11.179,11.179,0,0,1-6.03,3.14l-6.38-6.38a11.083,11.083,0,0,1,3.14-6.02,11.193,11.193,0,0,1,6.03-3.15l6.38,6.38A11.245,11.245,0,0,1,16.638,16.627Zm3.29-7.3-5.26-5.26c.21,0,.41-.01.62-.01a11.154,11.154,0,0,1,3.63.61.682.682,0,0,1,.42.41A11.543,11.543,0,0,1,19.928,9.327Z"}},{"tag":"path","attr":{"d":"M10.4,15.257a.5.5,0,0,0,.35.15.508.508,0,0,0,.36-.15.5.5,0,0,0,0-.7l-.48-.48L12,12.707l.48.48a.518.518,0,0,0,.35.14.543.543,0,0,0,.36-.14.513.513,0,0,0,0-.71l-.48-.48,1.37-1.37.48.48a.5.5,0,0,0,.7-.71L13.6,8.737a.5.5,0,0,0-.71,0,.5.5,0,0,0,0,.7l.49.49L12,11.3l-.48-.48a.495.495,0,1,0-.7.7l.48.48-1.37,1.38-.49-.49a.5.5,0,0,0-.7,0,.5.5,0,0,0,0,.71Z"}}]}]}]})(props);
	};
	module.exports.CiForkAndKnife = function CiForkAndKnife (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Fork_Knife"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.83,2.25a6.469,6.469,0,0,0-4.37,6.12v3.15a1.784,1.784,0,0,0,1.78,1.78h2.7v8.14a.5.5,0,0,0,.5.5.508.508,0,0,0,.5-.5V2.56a.508.508,0,0,0-.5-.5.467.467,0,0,0-.17.03ZM16.24,12.3a.781.781,0,0,1-.78-.78V8.37a5.482,5.482,0,0,1,3.48-5.1V12.3Z"}},{"tag":"path","attr":{"d":"M11.44,2.07a.5.5,0,0,0-.5.5V7.55H8.5V2.57a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5V7.55H5.06V2.57a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5V9.05a2.507,2.507,0,0,0,2.5,2.5H7.5v9.89a.508.508,0,0,0,.5.5.5.5,0,0,0,.5-.5V11.55h.94a2.5,2.5,0,0,0,2.5-2.5V2.57A.5.5,0,0,0,11.44,2.07Zm-.5,6.98a1.5,1.5,0,0,1-1.5,1.5H6.56a1.511,1.511,0,0,1-1.5-1.5v-.5h5.88Z"}}]}]}]})(props);
	};
	module.exports.CiFries = function CiFries (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Fries"},"child":[{"tag":"path","attr":{"d":"M19.51,9.535a1.091,1.091,0,0,0-.81-.36H17.67a.5.5,0,0,0-.17.02V4.815a1.5,1.5,0,0,0-1.5-1.5h-.5a1.3,1.3,0,0,0-.52.1,1.474,1.474,0,0,0-1.48-1.35H13a1.5,1.5,0,0,0-1.5,1.5v1.59a1.386,1.386,0,0,0-.5-.09h-.5a1.348,1.348,0,0,0-.5.09v-.34a1.5,1.5,0,0,0-1.5-1.5H8a1.5,1.5,0,0,0-1.5,1.5V9.2a.5.5,0,0,0-.17-.02H5.3a1.1,1.1,0,0,0-1.08,1.2l.85,8.98a2.84,2.84,0,0,0,2.84,2.58h8.18a2.84,2.84,0,0,0,2.84-2.58l.85-8.98A1.112,1.112,0,0,0,19.51,9.535ZM15,4.815a.5.5,0,0,1,.5-.5H16a.5.5,0,0,1,.5.5v6.14h.01A2.915,2.915,0,0,1,15,13.015Zm-2.5,8.53V3.565a.5.5,0,0,1,.5-.5h.5a.5.5,0,0,1,.5.5v9.76Zm-2.5-.02V6.565a.5.5,0,0,1,.5-.5H11a.5.5,0,0,1,.5.5v6.78ZM7.5,4.815a.5.5,0,0,1,.5-.5h.5a.5.5,0,0,1,.5.5v8.2a2.877,2.877,0,0,1-1.5-2.06Zm11.29,5.391-.85,9.049a1.85,1.85,0,0,1-1.85,1.68H7.91a1.84,1.84,0,0,1-1.84-1.68l-.86-9.08H6.33a.1.1,0,0,1,.09.08l.05.56a3.891,3.891,0,0,0,3.88,3.53h3.3a3.884,3.884,0,0,0,3.88-3.53l.05-.56a.106.106,0,0,1,.09-.08Z"}}]}]})(props);
	};
	module.exports.CiGift = function CiGift (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Gift"},"child":[{"tag":"path","attr":{"d":"M19.435,5.568h-2.38a1.979,1.979,0,0,0-.51-1.92,2.022,2.022,0,0,0-2.83,0L12,5.367l-1.71-1.719a2,2,0,0,0-2.83,0,1.979,1.979,0,0,0-.51,1.92H4.565a1.5,1.5,0,0,0-1.5,1.5v1A1.487,1.487,0,0,0,4,9.448v8.99a2.507,2.507,0,0,0,2.5,2.5h11a2.5,2.5,0,0,0,2.5-2.5V9.458a1.509,1.509,0,0,0,.94-1.39v-1A1.5,1.5,0,0,0,19.435,5.568ZM8.165,4.357a1,1,0,0,1,1.41,0l1.21,1.211H8.015A.989.989,0,0,1,8.165,4.357ZM11,19.938H6.5a1.5,1.5,0,0,1-1.5-1.5V9.568h6Zm0-11.37H4.565a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H11Zm3.43-4.211A1,1,0,0,1,16,5.568h-2.78ZM19,18.438a1.5,1.5,0,0,1-1.5,1.5H13V9.568h6Zm.94-10.37a.5.5,0,0,1-.5.5H13v-2h6.44a.5.5,0,0,1,.5.5Z"}}]}]})(props);
	};
	module.exports.CiGlass = function CiGlass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Glass"},"child":[{"tag":"path","attr":{"d":"M18.279,2.54a1.475,1.475,0,0,0-1.1-.48H6.819a1.47,1.47,0,0,0-1.09.48,1.5,1.5,0,0,0-.41,1.12L6.379,19.6a2.51,2.51,0,0,0,2.49,2.34h6.26a2.519,2.519,0,0,0,2.5-2.34l1.05-15.94A1.5,1.5,0,0,0,18.279,2.54Zm-1.65,16.99a1.508,1.508,0,0,1-1.5,1.41H8.869a1.506,1.506,0,0,1-1.49-1.41l-.64-9.62a2.981,2.981,0,0,0,1.17-.49,1.828,1.828,0,0,1,1.18-.39,1.858,1.858,0,0,1,1.19.39,3.025,3.025,0,0,0,3.45,0,1.879,1.879,0,0,1,1.19-.39,1.828,1.828,0,0,1,1.18.39,3,3,0,0,0,1.16.49Zm.7-10.62a2.317,2.317,0,0,1-.69-.33,2.98,2.98,0,0,0-3.45,0,1.885,1.885,0,0,1-1.18.38,1.939,1.939,0,0,1-1.19-.38,2.818,2.818,0,0,0-1.73-.55,2.809,2.809,0,0,0-1.72.55,2.374,2.374,0,0,1-.7.33l-.35-5.32a.468.468,0,0,1,.14-.37.484.484,0,0,1,.36-.16h10.36a.523.523,0,0,1,.37.16.46.46,0,0,1,.13.37Z"}}]}]})(props);
	};
	module.exports.CiGlobe = function CiGlobe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Globe"},"child":[{"tag":"path","attr":{"d":"M14.645,2.428a8.1,8.1,0,0,0-1.61-.3,9.332,9.332,0,0,0-3.6.28l-.07.02a9.928,9.928,0,0,0,.01,19.15,9.091,9.091,0,0,0,2.36.34,1.274,1.274,0,0,0,.27.02,9.65,9.65,0,0,0,2.63-.36,9.931,9.931,0,0,0,.01-19.15Zm-.27.96a8.943,8.943,0,0,1,5.84,5.11h-4.26a13.778,13.778,0,0,0-2.74-5.35A8.254,8.254,0,0,1,14.375,3.388Zm-2.37-.09a12.78,12.78,0,0,1,2.91,5.2H9.075A12.545,12.545,0,0,1,12.005,3.3Zm3.16,6.2a13.193,13.193,0,0,1,0,5.01H8.845a12.185,12.185,0,0,1-.25-2.5,12.353,12.353,0,0,1,.25-2.51Zm-5.6-6.09.07-.02a9.152,9.152,0,0,1,1.16-.23A13.618,13.618,0,0,0,8.045,8.5H3.8A9,9,0,0,1,9.565,3.408Zm-6.5,8.6a8.71,8.71,0,0,1,.37-2.51h4.39a13.95,13.95,0,0,0-.23,2.51,13.757,13.757,0,0,0,.23,2.5H3.435A8.591,8.591,0,0,1,3.065,12.008Zm6.57,8.61a8.9,8.9,0,0,1-5.84-5.11h4.24a13.632,13.632,0,0,0,2.77,5.35A8.1,8.1,0,0,1,9.635,20.618Zm-.56-5.11h5.84a12.638,12.638,0,0,1-2.91,5.21A12.872,12.872,0,0,1,9.075,15.508Zm5.3,5.11a11.551,11.551,0,0,1-1.17.24,13.8,13.8,0,0,0,2.75-5.35h4.26A8.924,8.924,0,0,1,14.375,20.618Zm1.8-6.11a13.611,13.611,0,0,0,0-5.01h4.39a8.379,8.379,0,0,1,.37,2.51,8.687,8.687,0,0,1-.36,2.5Z"}}]}]})(props);
	};
	module.exports.CiGps = function CiGps (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"GPS"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,14.5A2.5,2.5,0,1,1,14.5,12,2.5,2.5,0,0,1,12,14.5Zm0-4A1.5,1.5,0,1,0,13.5,12,1.5,1.5,0,0,0,12,10.5Z"}},{"tag":"path","attr":{"d":"M21.435,11.505h-1.46a7.98,7.98,0,0,0-7.48-7.48V2.565a.508.508,0,0,0-.5-.5.515.515,0,0,0-.5.5v1.46a8,8,0,0,0-7.48,7.48H2.565a.5.5,0,1,0,0,1h1.45a8.012,8.012,0,0,0,7.48,7.48v1.45a.508.508,0,0,0,.5.5.5.5,0,0,0,.5-.5v-1.45a8,8,0,0,0,7.48-7.48h1.46a.5.5,0,0,0,0-1ZM12,19.005a7,7,0,1,1,7-7A7.021,7.021,0,0,1,12,19.005Z"}}]}]}]})(props);
	};
	module.exports.CiGrid2H = function CiGrid2H (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Grid__2-H"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.437,11H5.565a2.5,2.5,0,0,1-2.5-2.5V5.564a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V8.5A2.5,2.5,0,0,1,18.437,11ZM5.565,4.064a1.5,1.5,0,0,0-1.5,1.5V8.5a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.564a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M18.437,20.936H5.565a2.5,2.5,0,0,1-2.5-2.5V15.5a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5v2.934A2.5,2.5,0,0,1,18.437,20.936ZM5.565,14a1.5,1.5,0,0,0-1.5,1.5v2.934a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V15.5a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiGrid2V = function CiGrid2V (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Grid_2-V"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.436,20.937H15.5a2.5,2.5,0,0,1-2.5-2.5V5.565a2.5,2.5,0,0,1,2.5-2.5h2.933a2.5,2.5,0,0,1,2.5,2.5V18.437A2.5,2.5,0,0,1,18.436,20.937ZM15.5,4.065a1.5,1.5,0,0,0-1.5,1.5V18.437a1.5,1.5,0,0,0,1.5,1.5h2.933a1.5,1.5,0,0,0,1.5-1.5V5.565a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M8.5,20.937H5.564a2.5,2.5,0,0,1-2.5-2.5V5.565a2.5,2.5,0,0,1,2.5-2.5H8.5a2.5,2.5,0,0,1,2.5,2.5V18.437A2.5,2.5,0,0,1,8.5,20.937ZM5.564,4.065a1.5,1.5,0,0,0-1.5,1.5V18.437a1.5,1.5,0,0,0,1.5,1.5H8.5a1.5,1.5,0,0,0,1.5-1.5V5.565a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiGrid31 = function CiGrid31 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Grid_3-1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M11.434,20.936H5.563a2.5,2.5,0,0,1-2.5-2.5V15.5a2.5,2.5,0,0,1,2.5-2.5h5.871a2.5,2.5,0,0,1,2.5,2.5v2.933A2.5,2.5,0,0,1,11.434,20.936ZM5.563,14a1.5,1.5,0,0,0-1.5,1.5v2.933a1.5,1.5,0,0,0,1.5,1.5h5.871a1.5,1.5,0,0,0,1.5-1.5V15.5a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M18.435,20.936a2.5,2.5,0,0,1-2.5-2.5V15.5a2.5,2.5,0,0,1,5,0v2.934A2.5,2.5,0,0,1,18.435,20.936Zm0-6.934a1.5,1.5,0,0,0-1.5,1.5v2.934a1.5,1.5,0,0,0,3,0V15.5A1.5,1.5,0,0,0,18.435,14Z"}}]},{"tag":"path","attr":{"d":"M18.435,11H5.563a2.5,2.5,0,0,1-2.5-2.5V5.564a2.5,2.5,0,0,1,2.5-2.5H18.435a2.5,2.5,0,0,1,2.5,2.5V8.5A2.5,2.5,0,0,1,18.435,11ZM5.563,4.064a1.5,1.5,0,0,0-1.5,1.5V8.5a1.5,1.5,0,0,0,1.5,1.5H18.435a1.5,1.5,0,0,0,1.5-1.5V5.564a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiGrid32 = function CiGrid32 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Grid_3-2"},"child":[{"tag":"g","attr":{},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.437,11H12.566a2.5,2.5,0,0,1-2.5-2.5V5.564a2.5,2.5,0,0,1,2.5-2.5h5.871a2.5,2.5,0,0,1,2.5,2.5V8.5A2.5,2.5,0,0,1,18.437,11ZM12.566,4.064a1.5,1.5,0,0,0-1.5,1.5V8.5a1.5,1.5,0,0,0,1.5,1.5h5.871a1.5,1.5,0,0,0,1.5-1.5V5.564a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M5.565,11a2.5,2.5,0,0,1-2.5-2.5V5.564a2.5,2.5,0,1,1,5,0V8.5A2.5,2.5,0,0,1,5.565,11Zm0-6.934a1.5,1.5,0,0,0-1.5,1.5V8.5a1.5,1.5,0,0,0,3,0V5.564A1.5,1.5,0,0,0,5.565,4.064Z"}}]},{"tag":"path","attr":{"d":"M18.437,20.936H5.565a2.5,2.5,0,0,1-2.5-2.5V15.5a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5v2.934A2.5,2.5,0,0,1,18.437,20.936ZM5.565,14a1.5,1.5,0,0,0-1.5,1.5v2.934a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V15.5a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiGrid41 = function CiGrid41 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Grid_4-1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M8.5,11H5.563a2.5,2.5,0,0,1-2.5-2.5V5.564a2.5,2.5,0,0,1,2.5-2.5H8.5a2.5,2.5,0,0,1,2.5,2.5V8.5A2.5,2.5,0,0,1,8.5,11ZM5.563,4.064a1.5,1.5,0,0,0-1.5,1.5V8.5a1.5,1.5,0,0,0,1.5,1.5H8.5A1.5,1.5,0,0,0,10,8.5V5.564a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M18.436,11H15.5A2.5,2.5,0,0,1,13,8.5V5.564a2.5,2.5,0,0,1,2.5-2.5h2.934a2.5,2.5,0,0,1,2.5,2.5V8.5A2.5,2.5,0,0,1,18.436,11ZM15.5,4.064a1.5,1.5,0,0,0-1.5,1.5V8.5A1.5,1.5,0,0,0,15.5,10h2.934a1.5,1.5,0,0,0,1.5-1.5V5.564a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M8.5,20.936H5.564a2.5,2.5,0,0,1-2.5-2.5V15.5a2.5,2.5,0,0,1,2.5-2.5H8.5A2.5,2.5,0,0,1,11,15.5v2.936A2.5,2.5,0,0,1,8.5,20.936ZM5.564,14a1.5,1.5,0,0,0-1.5,1.5v2.936a1.5,1.5,0,0,0,1.5,1.5H8.5a1.5,1.5,0,0,0,1.5-1.5V15.5A1.5,1.5,0,0,0,8.5,14Z"}},{"tag":"path","attr":{"d":"M18.436,20.936H15.5a2.5,2.5,0,0,1-2.5-2.5V15.5A2.5,2.5,0,0,1,15.5,13h2.934a2.5,2.5,0,0,1,2.5,2.5v2.936A2.5,2.5,0,0,1,18.436,20.936ZM15.5,14A1.5,1.5,0,0,0,14,15.5v2.936a1.5,1.5,0,0,0,1.5,1.5h2.934a1.5,1.5,0,0,0,1.5-1.5V15.5a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiGrid42 = function CiGrid42 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Grid_4-2"},"child":[{"tag":"g","attr":{},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M8.5,13.933H5.563a2.5,2.5,0,0,1-2.5-2.5V5.563a2.5,2.5,0,0,1,2.5-2.5H8.5a2.5,2.5,0,0,1,2.5,2.5v5.87A2.5,2.5,0,0,1,8.5,13.933ZM5.563,4.063a1.5,1.5,0,0,0-1.5,1.5v5.87a1.5,1.5,0,0,0,1.5,1.5H8.5a1.5,1.5,0,0,0,1.5-1.5V5.563a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M8.5,20.935H5.564a2.5,2.5,0,0,1,0-5H8.5a2.5,2.5,0,1,1,0,5Zm-2.934-4a1.5,1.5,0,0,0,0,3H8.5a1.5,1.5,0,1,0,0-3Z"}}]},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.436,20.935H15.5a2.5,2.5,0,0,1-2.5-2.5v-5.87a2.5,2.5,0,0,1,2.5-2.5h2.934a2.5,2.5,0,0,1,2.5,2.5v5.87A2.5,2.5,0,0,1,18.436,20.935ZM15.5,11.065a1.5,1.5,0,0,0-1.5,1.5v5.87a1.5,1.5,0,0,0,1.5,1.5h2.934a1.5,1.5,0,0,0,1.5-1.5v-5.87a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M18.436,8.063H15.5a2.5,2.5,0,0,1,0-5h2.934a2.5,2.5,0,0,1,0,5Zm-2.934-4a1.5,1.5,0,0,0,0,3h2.934a1.5,1.5,0,0,0,0-3Z"}}]}]}]}]})(props);
	};
	module.exports.CiHardDrive = function CiHardDrive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Hard_Drive"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.905,14.325l-1.83-10.04a1.507,1.507,0,0,0-1.47-1.22H6.405A1.493,1.493,0,0,0,4.925,4.3l-1.84,10.03a2.452,2.452,0,0,0-.02.27v4.84a1.5,1.5,0,0,0,1.5,1.5h14.87a1.511,1.511,0,0,0,1.5-1.5V14.6A1.241,1.241,0,0,0,20.905,14.325Zm-15-9.85a.5.5,0,0,1,.5-.41h11.2a.511.511,0,0,1,.49.4l1.74,9.54H4.165Zm14.03,14.96a.5.5,0,0,1-.5.5H4.565a.5.5,0,0,1-.5-.5l.01-4.43h15.86Z"}},{"tag":"circle","attr":{"cx":"5.561","cy":"17.47","r":"0.5"}},{"tag":"circle","attr":{"cx":"7.561","cy":"17.47","r":"0.5"}},{"tag":"path","attr":{"d":"M18.45,17.97a.5.5,0,0,0,0-1h-5a.5.5,0,0,0,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiHashtag = function CiHashtag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Hashtag"},"child":[{"tag":"path","attr":{"d":"M20.435,15.506H16.2l.61-7h3.63a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5H16.9l.34-3.87a.509.509,0,0,0-.46-.54.5.5,0,0,0-.54.46l-.35,3.95H8.9l.34-3.87a.509.509,0,0,0-.46-.54.491.491,0,0,0-.54.46l-.35,3.95H3.565a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5h4.24l-.62,7H3.565a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5h3.54l-.34,3.86a.508.508,0,0,0,.45.54h.05a.516.516,0,0,0,.5-.46l.34-3.94h7l-.34,3.86a.508.508,0,0,0,.45.54h.05a.516.516,0,0,0,.5-.46l.34-3.94h4.33a.5.5,0,0,0,.5-.5A.5.5,0,0,0,20.435,15.506Zm-5.25,0H8.2l.61-7h7Z"}}]}]})(props);
	};
	module.exports.CiHeadphones = function CiHeadphones (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Headphones"},"child":[{"tag":"path","attr":{"d":"M12.23,3.065h-.46a8.211,8.211,0,0,0-8.2,8.2v6.25a3.385,3.385,0,0,0,.89,2.3,3.423,3.423,0,0,0,2.53,1.12h.53a1.225,1.225,0,0,0,1.22-1.22v-4.4A1.225,1.225,0,0,0,7.52,14.1H7.11a3.6,3.6,0,0,0-2.54,1.05v-3.88a7.208,7.208,0,0,1,7.2-7.2h.46a7.208,7.208,0,0,1,7.2,7.2v3.88a3.6,3.6,0,0,0-2.54-1.05h-.41a1.225,1.225,0,0,0-1.22,1.22v4.4a1.225,1.225,0,0,0,1.22,1.22h.53a3.423,3.423,0,0,0,2.53-1.12,3.385,3.385,0,0,0,.89-2.3v-6.25A8.211,8.211,0,0,0,12.23,3.065ZM4.58,17.275A2.511,2.511,0,0,1,7.11,15.1h.41a.222.222,0,0,1,.22.22v4.4a.222.222,0,0,1-.22.22H6.99a2.422,2.422,0,0,1-1.79-.79,2.322,2.322,0,0,1-.63-1.63A1.927,1.927,0,0,1,4.58,17.275Zm14.22,1.87a2.422,2.422,0,0,1-1.79.79h-.53a.222.222,0,0,1-.22-.22v-4.4a.222.222,0,0,1,.22-.22h.41a2.511,2.511,0,0,1,2.53,2.18,1.927,1.927,0,0,1,.01.24A2.322,2.322,0,0,1,18.8,19.145Z"}}]}]})(props);
	};
	module.exports.CiHeart = function CiHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Heart"},"child":[{"tag":"path","attr":{"d":"M12,20.043a.977.977,0,0,1-.7-.288L4.63,13.08A5.343,5.343,0,0,1,6.053,4.513,5.266,5.266,0,0,1,12,5.371a5.272,5.272,0,0,1,5.947-.858A5.343,5.343,0,0,1,19.37,13.08l-6.676,6.675A.977.977,0,0,1,12,20.043ZM8.355,4.963A4.015,4.015,0,0,0,6.511,5.4,4.4,4.4,0,0,0,4.122,8.643a4.345,4.345,0,0,0,1.215,3.73l6.675,6.675,6.651-6.675a4.345,4.345,0,0,0,1.215-3.73A4.4,4.4,0,0,0,17.489,5.4a4.338,4.338,0,0,0-4.968.852h0a.744.744,0,0,1-1.042,0A4.474,4.474,0,0,0,8.355,4.963Z"}}]}]})(props);
	};
	module.exports.CiHome = function CiHome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Home"},"child":[{"tag":"path","attr":{"d":"M19.37,10.22l-6.2-7.6a1.5,1.5,0,0,0-2.33-.01L4.63,10.22a2.5,2.5,0,0,0-.57,1.59v7.63a2.507,2.507,0,0,0,2.5,2.5H17.44a2.507,2.507,0,0,0,2.5-2.5V11.81A2.5,2.5,0,0,0,19.37,10.22ZM10,20.94v-5.5a1.5,1.5,0,0,1,1.5-1.5h1a1.5,1.5,0,0,1,1.5,1.5v5.5Zm8.94-1.5a1.511,1.511,0,0,1-1.5,1.5H15v-5.5a2.5,2.5,0,0,0-2.5-2.5h-1A2.5,2.5,0,0,0,9,15.44v5.5H6.56a1.511,1.511,0,0,1-1.5-1.5V11.81a1.474,1.474,0,0,1,.34-.95l6.22-7.61A.474.474,0,0,1,12,3.06a.479.479,0,0,1,.39.19l6.21,7.61a1.474,1.474,0,0,1,.34.95Z"}}]}]})(props);
	};
	module.exports.CiHospital1 = function CiHospital1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Hospital_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.435,7.5h-1.93V5.56a2.5,2.5,0,0,0-2.5-2.5h-4a2.5,2.5,0,0,0-2.5,2.5V7.5H5.565a2.5,2.5,0,0,0-2.5,2.5v9.44a1.511,1.511,0,0,0,1.5,1.5h14.87a1.5,1.5,0,0,0,1.5-1.5V10A2.5,2.5,0,0,0,18.435,7.5ZM7.505,19.94H4.565a.508.508,0,0,1-.5-.5V10a1.5,1.5,0,0,1,1.5-1.5h1.94Zm8,0h-1.5v-2.5a2.038,2.038,0,0,0-.59-1.42,2,2,0,0,0-3.41,1.42v2.5h-1.5V5.56a1.5,1.5,0,0,1,1.5-1.5h4a1.5,1.5,0,0,1,1.5,1.5Zm4.43-.5a.5.5,0,0,1-.5.5h-2.93V8.5h1.93a1.5,1.5,0,0,1,1.5,1.5Z"}},{"tag":"path","attr":{"d":"M14.505,8.56a.5.5,0,0,1-.5.5h-1.5v1.5a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5V9.06h-1.5a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1.5V6.56a.5.5,0,0,1,.5-.5.508.508,0,0,1,.5.5v1.5h1.5A.508.508,0,0,1,14.505,8.56Z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M5.786,13.217a.5.5,0,0,1-.5-.5v-1.5a.5.5,0,0,1,1,0v1.5A.5.5,0,0,1,5.786,13.217Z"}},{"tag":"path","attr":{"d":"M5.786,17.717a.5.5,0,0,1-.5-.5v-1.5a.5.5,0,0,1,1,0v1.5A.5.5,0,0,1,5.786,17.717Z"}}]},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.221,13.217a.5.5,0,0,1-.5-.5v-1.5a.5.5,0,0,1,1,0v1.5A.5.5,0,0,1,18.221,13.217Z"}},{"tag":"path","attr":{"d":"M18.221,17.717a.5.5,0,0,1-.5-.5v-1.5a.5.5,0,0,1,1,0v1.5A.5.5,0,0,1,18.221,17.717Z"}}]}]}]}]})(props);
	};
	module.exports.CiHotdog = function CiHotdog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Hotdog"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.1,9.349l-9.74,9.74.01.01,9.74-9.74Z"}},{"tag":"path","attr":{"d":"M20.276,9.119l-.47-.47a3.157,3.157,0,0,0-.03-4.43,3.212,3.212,0,0,0-4.42-.03l-.48-.48a2.3,2.3,0,0,0-3.18,0l-7.98,7.98a2.263,2.263,0,0,0,0,3.18l.48.48a3.145,3.145,0,0,0,.03,4.42,3.089,3.089,0,0,0,2.23.92,3.126,3.126,0,0,0,2.2-.89l.47.47a2.245,2.245,0,0,0,3.18,0l7.97-7.97A2.245,2.245,0,0,0,20.276,9.119Zm-15.85,3.27,7.97-7.97a1.243,1.243,0,0,1,1.77,0l.47.47L4.9,14.629l-.47-.47A1.249,1.249,0,0,1,4.426,12.389Zm3.52,6.7a2.2,2.2,0,0,1-3.02-.03,2.149,2.149,0,0,1-.03-3.01l11.16-11.16a2.163,2.163,0,0,1,1.49-.6,2.155,2.155,0,0,1,1.55,3.65Zm11.63-7.49-7.98,7.97a1.275,1.275,0,0,1-1.76,0l-.47-.47-.01-.01,9.74-9.74.01.01.47.47A1.268,1.268,0,0,1,19.576,11.6Z"}},{"tag":"path","attr":{"d":"M6.57,17.569a.5.5,0,0,1-.354-.854,4.533,4.533,0,0,1,1.357-.967,3.491,3.491,0,0,0,1.1-.778,3.514,3.514,0,0,0,.779-1.1,5.034,5.034,0,0,1,2.324-2.324,3.517,3.517,0,0,0,1.1-.78,3.536,3.536,0,0,0,.78-1.1,4.534,4.534,0,0,1,.97-1.359,4.54,4.54,0,0,1,1.359-.97,3.53,3.53,0,0,0,1.1-.78.5.5,0,1,1,.707.707,4.516,4.516,0,0,1-1.36.969,3.506,3.506,0,0,0-1.1.781,3.535,3.535,0,0,0-.781,1.1,4.516,4.516,0,0,1-.969,1.36,4.5,4.5,0,0,1-1.359.969,4.029,4.029,0,0,0-1.874,1.874,4.5,4.5,0,0,1-.967,1.357,4.524,4.524,0,0,1-1.358.968,3.51,3.51,0,0,0-1.1.777A.5.5,0,0,1,6.57,17.569Z"}}]}]}]})(props);
	};
	module.exports.CiIceCream = function CiIceCream (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Ice_Cream"},"child":[{"tag":"path","attr":{"d":"M16.54,5.94a4.594,4.594,0,0,0-9.08,0,3.065,3.065,0,0,0-.76,5.85l3.92,9.25a1.5,1.5,0,0,0,2.76,0l3.92-9.26a3.058,3.058,0,0,0-.76-5.84ZM12.46,20.65a.5.5,0,0,1-.92,0L7.89,12.03h8.22Zm3.64-9.62H7.9a2.06,2.06,0,1,1,.01-4.12.5.5,0,0,0,.5-.48,3.6,3.6,0,0,1,7.18,0,.506.506,0,0,0,.51.48,2.06,2.06,0,0,1,0,4.12Z"}}]}]})(props);
	};
	module.exports.CiImageOff = function CiImageOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Image_Off"},"child":[{"tag":"path","attr":{"d":"M19.937,14.218l0,-8.654c0,-0.829 -0.672,-1.5 -1.5,-1.5l-10.628,-0c-0.276,-0 -0.5,-0.225 -0.5,-0.5c0,-0.276 0.224,-0.5 0.5,-0.5l10.628,-0c1.38,-0 2.5,1.118 2.5,2.5l0,10.624c0,0.276 -0.224,0.5 -0.5,0.501c-0.276,-0 -0.5,-0.225 -0.5,-0.5l0,-0.556l-4.583,-4.584c-0.456,-0.456 0.251,-1.163 0.707,-0.707c0.162,0.162 2.37,2.37 3.876,3.876Zm-0.121,6.304c-0.395,0.262 -0.869,0.415 -1.379,0.415l-12.874,-0c-1.381,-0 -2.5,-1.119 -2.5,-2.5l0,-12.873c0,-0.51 0.153,-0.984 0.414,-1.38l-0.263,-0.263c-0.456,-0.456 0.251,-1.163 0.707,-0.707c0.088,0.088 0.176,0.176 0.263,0.263c0.245,0.245 16.095,16.094 16.339,16.338l0.263,0.263c0.455,0.456 -0.252,1.163 -0.707,0.707c-0.088,-0.087 -0.175,-0.175 -0.263,-0.263Zm-11.104,-11.103l-2.001,-2.001c-0.094,0.196 -0.146,0.415 -0.146,0.647c-0,0.829 0.672,1.5 1.5,1.5c0.232,-0 0.451,-0.052 0.647,-0.146Zm-2.733,-2.733l-1.77,-1.77c-0.093,0.196 -0.146,0.416 -0.146,0.648l0,10.717l1.926,-1.926c0.587,-0.586 1.536,-0.586 2.122,-0l0.555,0.554c0.195,0.196 0.511,0.196 0.706,0l2.415,-2.415l-2.343,-2.343c-0.395,0.262 -0.869,0.414 -1.379,0.414c-1.38,-0 -2.5,-1.119 -2.5,-2.5c-0,-0.509 0.152,-0.983 0.414,-1.379Zm-1.916,11.009l0,0.741c0,0.829 0.671,1.5 1.5,1.5l12.874,0c0.232,0 0.451,-0.052 0.647,-0.145c-0.165,-0.165 -3.264,-3.263 -6.59,-6.59l-2.414,2.415c-0.585,0.586 -1.537,0.586 -2.122,0l-0.554,-0.554c-0.195,-0.196 -0.512,-0.196 -0.708,0l-2.633,2.633Z"}}]}]})(props);
	};
	module.exports.CiImageOn = function CiImageOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Image_On"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.435,3.06H5.565a2.5,2.5,0,0,0-2.5,2.5V18.44a2.507,2.507,0,0,0,2.5,2.5h12.87a2.507,2.507,0,0,0,2.5-2.5V5.56A2.5,2.5,0,0,0,18.435,3.06ZM4.065,5.56a1.5,1.5,0,0,1,1.5-1.5h12.87a1.5,1.5,0,0,1,1.5,1.5v8.66l-3.88-3.88a1.509,1.509,0,0,0-2.12,0l-4.56,4.57a.513.513,0,0,1-.71,0l-.56-.56a1.522,1.522,0,0,0-2.12,0l-1.92,1.92Zm15.87,12.88a1.5,1.5,0,0,1-1.5,1.5H5.565a1.5,1.5,0,0,1-1.5-1.5v-.75L6.7,15.06a.5.5,0,0,1,.35-.14.524.524,0,0,1,.36.14l.55.56a1.509,1.509,0,0,0,2.12,0l4.57-4.57a.5.5,0,0,1,.71,0l4.58,4.58Z"}},{"tag":"path","attr":{"d":"M8.062,10.565a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,8.062,10.565Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,8.062,6.565Z"}}]}]}]})(props);
	};
	module.exports.CiImport = function CiImport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Import"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M5.552,20.968a2.577,2.577,0,0,1-2.5-2.73c-.012-2.153,0-4.306,0-6.459a.5.5,0,0,1,1,0c0,2.2-.032,4.4,0,6.6.016,1.107.848,1.589,1.838,1.589H18.353A1.546,1.546,0,0,0,19.825,19a3.023,3.023,0,0,0,.1-1.061V11.779h0a.5.5,0,0,1,1,0c0,2.224.085,4.465,0,6.687a2.567,2.567,0,0,1-2.67,2.5Z"}},{"tag":"path","attr":{"d":"M11.63,15.818a.459.459,0,0,0,.312.138c.014,0,.027.005.042.006s.027,0,.041-.006a.457.457,0,0,0,.312-.138l3.669-3.669a.5.5,0,0,0-.707-.707l-2.815,2.815V3.515a.5.5,0,0,0-1,0V14.257L8.668,11.442a.5.5,0,0,0-.707.707Z"}}]}]}]})(props);
	};
	module.exports.CiInboxIn = function CiInboxIn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Inbox_In"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M11.5,9.361V4.531a.5.5,0,0,1,1,0v4.82l1.27-1.27a.524.524,0,0,1,.71,0,.513.513,0,0,1,0,.71l-2.13,2.12a.492.492,0,0,1-.7,0l-2.12-2.12a.5.5,0,0,1,0-.71.511.511,0,0,1,.7,0Z"}},{"tag":"path","attr":{"d":"M20.488,19.949H3.512A1.451,1.451,0,0,1,2.062,18.5V12.861a1.451,1.451,0,0,1,1.45-1.449h4.1a1.444,1.444,0,0,1,1.3.8l1.373,2.726a.449.449,0,0,0,.4.247h2.629a.448.448,0,0,0,.4-.248l1.373-2.724a1.442,1.442,0,0,1,1.3-.8h4.1a1.451,1.451,0,0,1,1.45,1.449V18.5A1.451,1.451,0,0,1,20.488,19.949ZM3.512,12.412a.45.45,0,0,0-.45.449V18.5a.45.45,0,0,0,.45.449H20.488a.45.45,0,0,0,.45-.449V12.861a.45.45,0,0,0-.45-.449h-4.1a.449.449,0,0,0-.4.247L14.61,15.384a1.445,1.445,0,0,1-1.295.8H10.686a1.442,1.442,0,0,1-1.295-.8L8.018,12.659a.449.449,0,0,0-.4-.247Z"}}]}]}]})(props);
	};
	module.exports.CiInboxOut = function CiInboxOut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Inbox_Out"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.488,19.944H3.512a1.452,1.452,0,0,1-1.45-1.45V12.856a1.452,1.452,0,0,1,1.45-1.45h4.1a1.442,1.442,0,0,1,1.3.8l1.373,2.725a.449.449,0,0,0,.4.247h2.629a.448.448,0,0,0,.4-.248L15.09,12.2a1.442,1.442,0,0,1,1.3-.8h4.1a1.452,1.452,0,0,1,1.45,1.45v5.638A1.452,1.452,0,0,1,20.488,19.944ZM3.512,12.406a.451.451,0,0,0-.45.45v5.638a.45.45,0,0,0,.45.45H20.488a.45.45,0,0,0,.45-.45V12.856a.451.451,0,0,0-.45-.45h-4.1a.449.449,0,0,0-.4.247L14.61,15.378a1.445,1.445,0,0,1-1.295.8H10.686a1.444,1.444,0,0,1-1.295-.8L8.018,12.653a.449.449,0,0,0-.4-.247Z"}},{"tag":"path","attr":{"d":"M12.5,5.753v4.83a.5.5,0,0,1-1,0V5.763l-1.27,1.27a.524.524,0,0,1-.71,0,.513.513,0,0,1,0-.71l2.13-2.12a.492.492,0,0,1,.7,0l2.12,2.12a.5.5,0,0,1,0,.71.511.511,0,0,1-.7,0Z"}}]}]}]})(props);
	};
	module.exports.CiIndent = function CiIndent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Indent"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.437,4.064H3.563a.5.5,0,0,1,0-1H20.437a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,9.688h-9a.5.5,0,0,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,15.312h-9a.5.5,0,0,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,20.936H3.563a.5.5,0,1,1,0-1H20.437a.5.5,0,1,1,0,1Z"}},{"tag":"path","attr":{"d":"M7.91,11.65a.492.492,0,0,1,0,.7l-2,2a.495.495,0,0,1-.7-.7L6.36,12.5H3.54a.5.5,0,0,1,0-1H6.35c-.38-.38-.76-.76-1.14-1.15a.495.495,0,0,1,.7-.7Z"}}]}]}]})(props);
	};
	module.exports.CiInstagram = function CiInstagram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Instagram"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.437,20.937H5.563a2.5,2.5,0,0,1-2.5-2.5V5.563a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.437A2.5,2.5,0,0,1,18.437,20.937ZM5.563,4.063a1.5,1.5,0,0,0-1.5,1.5V18.437a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.563a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M12,16.594A4.595,4.595,0,1,1,16.6,12,4.6,4.6,0,0,1,12,16.594ZM12,8.4A3.595,3.595,0,1,0,15.6,12,3.6,3.6,0,0,0,12,8.4Z"}},{"tag":"circle","attr":{"cx":"17.2","cy":"6.83","r":"1.075"}}]}]}]})(props);
	};
	module.exports.CiKeyboard = function CiKeyboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Keyboard"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.437,18.5H4.562a2.5,2.5,0,0,1-2.5-2.5V8a2.5,2.5,0,0,1,2.5-2.5H19.437a2.5,2.5,0,0,1,2.5,2.5v8A2.5,2.5,0,0,1,19.437,18.5ZM4.562,6.5A1.5,1.5,0,0,0,3.062,8v8a1.5,1.5,0,0,0,1.5,1.5H19.437a1.5,1.5,0,0,0,1.5-1.5V8a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M5.548,16.5h12.9a.5.5,0,0,0,0-1H5.548a.5.5,0,0,0,0,1Z"}},{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"cx":"5.82","cy":"9.248","r":"0.75"}},{"tag":"circle","attr":{"cx":"9.94","cy":"9.248","r":"0.75"}},{"tag":"circle","attr":{"cx":"14.06","cy":"9.248","r":"0.75"}},{"tag":"circle","attr":{"cx":"18.18","cy":"9.248","r":"0.75"}}]},{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"cx":"5.82","cy":"12.998","r":"0.75"}},{"tag":"circle","attr":{"cx":"9.94","cy":"12.998","r":"0.75"}},{"tag":"circle","attr":{"cx":"14.06","cy":"12.998","r":"0.75"}},{"tag":"circle","attr":{"cx":"18.18","cy":"12.998","r":"0.75"}}]}]}]}]})(props);
	};
	module.exports.CiLaptop = function CiLaptop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Laptop"},"child":[{"tag":"path","attr":{"d":"M21.485,16.155a.992.992,0,0,0-.77-.36h-.33V6.565a2.5,2.5,0,0,0-2.5-2.5H6.115a2.5,2.5,0,0,0-2.5,2.5V15.8h-.34a1,1,0,0,0-.98,1.17l.3,1.73a1.5,1.5,0,0,0,1.48,1.24h15.85a1.5,1.5,0,0,0,1.48-1.24l.3-1.73A.986.986,0,0,0,21.485,16.155ZM4.615,6.565a1.5,1.5,0,0,1,1.5-1.5h11.77a1.5,1.5,0,0,1,1.5,1.5V15.8H4.615Zm15.8,11.96a.494.494,0,0,1-.49.41H4.075a.494.494,0,0,1-.49-.41l-.31-1.73h17.44Z"}}]}]})(props);
	};
	module.exports.CiLemon = function CiLemon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Lemon"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M6,20.924a2.172,2.172,0,0,1-1.545-.642l-.734-.733a2.207,2.207,0,0,1-.16-2.947,1.18,1.18,0,0,0,.272-1.117A9.105,9.105,0,0,1,6.205,6.208a9.1,9.1,0,0,1,9.277-2.371,1.149,1.149,0,0,0,1.062-.229l.055-.044a2.205,2.205,0,0,1,2.946.161l.734.733a2.207,2.207,0,0,1,.16,2.947,1.179,1.179,0,0,0-.272,1.116A9.11,9.11,0,0,1,17.8,17.8,9.109,9.109,0,0,1,8.518,20.17a1.14,1.14,0,0,0-1.062.229A2.324,2.324,0,0,1,6,20.924ZM12.812,4.4a8.427,8.427,0,0,0-5.9,2.519,8.1,8.1,0,0,0-2.133,8.246,2.149,2.149,0,0,1-.395,2.014,1.227,1.227,0,0,0,.044,1.667l.734.733a1.209,1.209,0,0,0,1.613.088,2.175,2.175,0,0,1,2.067-.438,8.1,8.1,0,0,0,8.246-2.133,8.1,8.1,0,0,0,2.133-8.246,2.144,2.144,0,0,1,.395-2.013,1.229,1.229,0,0,0-.044-1.668l-.734-.733a1.206,1.206,0,0,0-1.612-.089l-.052.042a2.148,2.148,0,0,1-2.016.4A7.213,7.213,0,0,0,12.812,4.4Z"}},{"tag":"path","attr":{"d":"M6.457,12.286a.523.523,0,0,1-.178-.032.5.5,0,0,1-.29-.646,9.841,9.841,0,0,1,5.338-5.5.5.5,0,1,1,.386.921,8.845,8.845,0,0,0-4.789,4.939A.5.5,0,0,1,6.457,12.286Z"}}]}]}]})(props);
	};
	module.exports.CiLight = function CiLight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Light"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,18.09A6.09,6.09,0,1,1,18.09,12,6.1,6.1,0,0,1,12,18.09ZM12,6.91A5.09,5.09,0,1,0,17.09,12,5.1,5.1,0,0,0,12,6.91Z"}},{"tag":"path","attr":{"d":"M11.5,2.568v1.6a.5.5,0,1,0,1,0v-1.6a.5.5,0,1,0-1,0Z"}},{"tag":"path","attr":{"d":"M12.5,21.432v-1.6a.5.5,0,0,0-1,0v1.6a.5.5,0,1,0,1,0Z"}},{"tag":"path","attr":{"d":"M21.432,11.5h-1.6a.5.5,0,0,0,0,1h1.6a.5.5,0,1,0,0-1Z"}},{"tag":"path","attr":{"d":"M2.568,12.5h1.6a.5.5,0,1,0,0-1h-1.6a.5.5,0,1,0,0,1Z"}},{"tag":"path","attr":{"d":"M18.316,4.977l-.992.992-.141.141a.514.514,0,0,0-.146.353.508.508,0,0,0,.146.354.5.5,0,0,0,.354.146.515.515,0,0,0,.353-.146l.992-.992.141-.141a.515.515,0,0,0,.147-.354.508.508,0,0,0-.147-.353.5.5,0,0,0-.353-.147.522.522,0,0,0-.354.147Z"}},{"tag":"path","attr":{"d":"M5.684,19.023l.992-.992.141-.141a.514.514,0,0,0,.146-.353.508.508,0,0,0-.146-.354.5.5,0,0,0-.354-.146.515.515,0,0,0-.353.146l-.992.992-.141.141a.515.515,0,0,0-.147.354.508.508,0,0,0,.147.353.5.5,0,0,0,.353.147.522.522,0,0,0,.354-.147Z"}},{"tag":"path","attr":{"d":"M19.023,18.316l-.992-.992-.141-.141a.514.514,0,0,0-.353-.146.508.508,0,0,0-.354.146.5.5,0,0,0-.146.354.515.515,0,0,0,.146.353l.992.992.141.141a.515.515,0,0,0,.354.147.508.508,0,0,0,.353-.147.5.5,0,0,0,.147-.353.522.522,0,0,0-.147-.354Z"}},{"tag":"path","attr":{"d":"M4.977,5.684l.992.992.141.141a.514.514,0,0,0,.353.146.508.508,0,0,0,.354-.146.5.5,0,0,0,.146-.354.515.515,0,0,0-.146-.353l-.992-.992-.141-.141A.515.515,0,0,0,5.33,4.83a.508.508,0,0,0-.353.147.5.5,0,0,0-.147.353.522.522,0,0,0,.147.354Z"}}]}]}]})(props);
	};
	module.exports.CiLineHeight = function CiLineHeight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Line_Height"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.439,4.062h-9a.5.5,0,1,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.439,9.686h-9a.5.5,0,0,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.439,15.31h-9a.5.5,0,0,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.439,20.934h-9a.5.5,0,0,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M3.208,18.8a.5.5,0,0,1,.71-.71l1.14,1.14V4.775l-1.14,1.14a.513.513,0,0,1-.71,0,.5.5,0,0,1,0-.71l2-2a.494.494,0,0,1,.34-.14.549.549,0,0,1,.37.14l2,2a.524.524,0,0,1,0,.71.5.5,0,0,1-.71,0l-1.15-1.15v14.47l1.15-1.15a.5.5,0,1,1,.71.71l-2,2a.513.513,0,0,1-.71,0Z"}}]}]}]})(props);
	};
	module.exports.CiLink = function CiLink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Link"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M10.9,8a4.055,4.055,0,0,1,1.352.135,2.511,2.511,0,0,1-.7,4.863.5.5,0,0,0,0,1,3.508,3.508,0,0,0,2.944-5.2A3.557,3.557,0,0,0,11.434,7H5.59A3.5,3.5,0,0,0,5.4,14c.724.041,1.458,0,2.183,0a.5.5,0,0,0,0-1h0c-1.323,0-2.915.262-3.891-.843A2.522,2.522,0,0,1,5.59,8Z"}},{"tag":"path","attr":{"d":"M18.41,17a3.5,3.5,0,0,0,.192-6.994c-.724-.041-1.458,0-2.183,0a.5.5,0,0,0,0,1h0c1.323,0,2.915-.262,3.891.843A2.522,2.522,0,0,1,18.41,16H13.1a4.055,4.055,0,0,1-1.352-.135,2.511,2.511,0,0,1,.7-4.863.5.5,0,0,0,0-1,3.508,3.508,0,0,0-2.944,5.2A3.557,3.557,0,0,0,12.566,17Z"}}]}]}]})(props);
	};
	module.exports.CiLinkedin = function CiLinkedin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"LinkedIn"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.44,3.06H5.56a2.507,2.507,0,0,0-2.5,2.5V18.44a2.507,2.507,0,0,0,2.5,2.5H18.44a2.5,2.5,0,0,0,2.5-2.5V5.56A2.5,2.5,0,0,0,18.44,3.06Zm1.5,15.38a1.511,1.511,0,0,1-1.5,1.5H5.56a1.511,1.511,0,0,1-1.5-1.5V5.56a1.511,1.511,0,0,1,1.5-1.5H18.44a1.511,1.511,0,0,1,1.5,1.5Z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M6.376,10.748a1,1,0,1,1,2,0v6.5h0a1,1,0,0,1-2,0Z"}},{"tag":"circle","attr":{"cx":"7.376","cy":"6.744","r":"1"}},{"tag":"path","attr":{"d":"M17.62,13.37v3.88a1,1,0,1,1-2,0V13.37a1.615,1.615,0,1,0-3.23,0v3.88a1,1,0,0,1-2,0v-6.5a1.016,1.016,0,0,1,1-1,.94.94,0,0,1,.84.47,3.609,3.609,0,0,1,5.39,3.15Z"}}]}]}]}]})(props);
	};
	module.exports.CiLocationArrow1 = function CiLocationArrow1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Location_Arrow_1"},"child":[{"tag":"path","attr":{"d":"M14.472,20.937a1.438,1.438,0,0,1-1.3-.812L10.3,14.343a1.418,1.418,0,0,0-.642-.641L3.874,10.831A1.462,1.462,0,0,1,4.06,8.136l14.952-5a1.46,1.46,0,0,1,1.849,1.847l-5,14.952a1.439,1.439,0,0,1-1.284.994C14.543,20.936,14.507,20.937,14.472,20.937ZM19.479,4.063a.488.488,0,0,0-.149.024h0l-14.952,5a.46.46,0,0,0-.058.849L10.1,12.805A2.444,2.444,0,0,1,11.2,13.9l2.87,5.782a.443.443,0,0,0,.445.255.45.45,0,0,0,.4-.312l5-14.953a.462.462,0,0,0-.433-.607Z"}}]}]})(props);
	};
	module.exports.CiLocationOff = function CiLocationOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Location_Off"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.2,14.462a.5.5,0,0,1-.417-.775A6.791,6.791,0,0,0,18.831,9.06a6.909,6.909,0,0,0-6.022-5.946A6.834,6.834,0,0,0,8.252,4.175a.5.5,0,1,1-.545-.838,7.882,7.882,0,0,1,10.909,10.9A.5.5,0,0,1,18.2,14.462Z"}},{"tag":"path","attr":{"d":"M4,3.3a.5.5,0,0,0-.7.7l1.92,1.92a7.784,7.784,0,0,0-1.11,4.03A7.879,7.879,0,0,0,5.55,14.5l5.06,6.74a1.724,1.724,0,0,0,1.39.69,1.705,1.705,0,0,0,1.38-.69l3.06-4.09c.5.49.99.99,1.48,1.48.7.69,1.39,1.38,2.08,2.07.45.46,1.16-.25.7-.71Zm8.58,17.34a.734.734,0,0,1-.58.29.754.754,0,0,1-.59-.29l-5.05-6.73a6.9,6.9,0,0,1-.41-7.26q1.5,1.515,3.01,3.01,3.39,3.39,6.77,6.78Z"}}]}]}]})(props);
	};
	module.exports.CiLocationOn = function CiLocationOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Location_On"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.933a1.715,1.715,0,0,1-1.384-.691L5.555,14.5a7.894,7.894,0,1,1,12.885-.009L13.385,21.24A1.717,1.717,0,0,1,12,21.933ZM11.992,3.066A6.81,6.81,0,0,0,7.414,4.815a6.891,6.891,0,0,0-1.05,9.1l5.051,6.727a.725.725,0,0,0,.584.292h0a.732.732,0,0,0,.586-.292l5.044-6.734A6.874,6.874,0,0,0,12.81,3.113,7.277,7.277,0,0,0,11.992,3.066Z"}},{"tag":"path","attr":{"d":"M12,12.5A2.5,2.5,0,1,1,14.5,10,2.5,2.5,0,0,1,12,12.5Zm0-4A1.5,1.5,0,1,0,13.5,10,1.5,1.5,0,0,0,12,8.5Z"}}]}]}]})(props);
	};
	module.exports.CiLock = function CiLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Lock"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.44,9.33h-1.1V6.4a4.34,4.34,0,0,0-8.68,0V9.33H6.56a2.5,2.5,0,0,0-2.5,2.5v7.61a2.507,2.507,0,0,0,2.5,2.5H17.44a2.507,2.507,0,0,0,2.5-2.5V11.83A2.5,2.5,0,0,0,17.44,9.33ZM8.66,6.4a3.34,3.34,0,0,1,6.68,0V9.33H8.66ZM18.94,19.44a1.511,1.511,0,0,1-1.5,1.5H6.56a1.511,1.511,0,0,1-1.5-1.5V11.83a1.5,1.5,0,0,1,1.5-1.5H17.44a1.5,1.5,0,0,1,1.5,1.5Z"}},{"tag":"path","attr":{"d":"M13,14.95a.984.984,0,0,1-.5.86v1.5a.5.5,0,0,1-1,0v-1.5a.984.984,0,0,1-.5-.86,1,1,0,0,1,2,0Z"}}]}]}]})(props);
	};
	module.exports.CiLogin = function CiLogin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Login"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.944,18.432a2.577,2.577,0,0,1-2.729,2.5c-2.153.012-4.307,0-6.46,0a.5.5,0,0,1,0-1c2.2,0,4.4.032,6.6,0,1.107-.016,1.589-.848,1.589-1.838V5.63a1.545,1.545,0,0,0-.969-1.471,3.027,3.027,0,0,0-1.061-.095H11.755a.5.5,0,0,1,0-1c2.225,0,4.465-.085,6.688,0a2.566,2.566,0,0,1,2.5,2.67Z"}},{"tag":"path","attr":{"d":"M15.794,12.354a.459.459,0,0,0,.138-.312A.3.3,0,0,0,15.938,12a.29.29,0,0,0-.006-.041.455.455,0,0,0-.138-.313L12.125,7.978a.5.5,0,0,0-.707.707L14.234,11.5H3.492a.5.5,0,0,0,0,1H14.234l-2.816,2.815a.5.5,0,0,0,.707.707Z"}}]}]}]})(props);
	};
	module.exports.CiLogout = function CiLogout (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Logout"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.968,18.448a2.577,2.577,0,0,1-2.73,2.5c-2.153.012-4.306,0-6.459,0a.5.5,0,0,1,0-1c2.2,0,4.4.032,6.6,0,1.107-.016,1.589-.848,1.589-1.838V5.647A1.546,1.546,0,0,0,19,4.175a3.023,3.023,0,0,0-1.061-.095H11.779a.5.5,0,0,1,0-1c2.224,0,4.465-.085,6.687,0a2.567,2.567,0,0,1,2.5,2.67Z"}},{"tag":"path","attr":{"d":"M3.176,11.663a.455.455,0,0,0-.138.311c0,.015,0,.028-.006.043s0,.027.006.041a.457.457,0,0,0,.138.312l3.669,3.669a.5.5,0,0,0,.707-.707L4.737,12.516H15.479a.5.5,0,0,0,0-1H4.737L7.552,8.7a.5.5,0,0,0-.707-.707Z"}}]}]}]})(props);
	};
	module.exports.CiLollipop = function CiLollipop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Lollipop"},"child":[{"tag":"path","attr":{"d":"M18,6.565h-.19a6,6,0,0,0-11.62,0H6a1.5,1.5,0,1,0,0,3h.19a5.992,5.992,0,0,0,5.31,4.48v7.39a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-7.39a6.013,6.013,0,0,0,5.31-4.48H18a1.5,1.5,0,1,0,0-3Zm-6-3.5a4.991,4.991,0,0,1,4.77,3.5H7.23A4.991,4.991,0,0,1,12,3.065Zm0,10a4.991,4.991,0,0,1-4.77-3.5h9.54A4.991,4.991,0,0,1,12,13.065Zm6-4.5H6a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H18a.5.5,0,0,1,.5.5A.508.508,0,0,1,18,8.565Z"}}]}]})(props);
	};
	module.exports.CiMail = function CiMail (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Mail"},"child":[{"tag":"path","attr":{"d":"M19.435,4.065H4.565a2.5,2.5,0,0,0-2.5,2.5v10.87a2.5,2.5,0,0,0,2.5,2.5h14.87a2.5,2.5,0,0,0,2.5-2.5V6.565A2.5,2.5,0,0,0,19.435,4.065Zm-14.87,1h14.87a1.489,1.489,0,0,1,1.49,1.39c-2.47,1.32-4.95,2.63-7.43,3.95a6.172,6.172,0,0,1-1.06.53,2.083,2.083,0,0,1-1.67-.39c-1.42-.75-2.84-1.51-4.25-2.26-1.14-.6-2.3-1.21-3.44-1.82A1.491,1.491,0,0,1,4.565,5.065Zm16.37,12.37a1.5,1.5,0,0,1-1.5,1.5H4.565a1.5,1.5,0,0,1-1.5-1.5V7.6c2.36,1.24,4.71,2.5,7.07,3.75a5.622,5.622,0,0,0,1.35.6,2.872,2.872,0,0,0,2-.41c1.45-.76,2.89-1.53,4.34-2.29,1.04-.56,2.07-1.1,3.11-1.65Z"}}]}]})(props);
	};
	module.exports.CiMapPin = function CiMapPin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Map_Pin"},"child":[{"tag":"path","attr":{"d":"M12,2.06a5.5,5.5,0,0,0-.5,10.97v8.41a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5V13.03A5.5,5.5,0,0,0,12,2.06Zm0,10a4.5,4.5,0,1,1,4.5-4.5A4.5,4.5,0,0,1,12,12.06Z"}}]}]})(props);
	};
	module.exports.CiMap = function CiMap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Map"},"child":[{"tag":"path","attr":{"d":"M20.21,4.576a1.906,1.906,0,0,0-1.63-.35l-3.53.89a1.086,1.086,0,0,1-.44,0L9.63,3.876a2.041,2.041,0,0,0-.92,0L4.5,4.936a1.893,1.893,0,0,0-1.44,1.84v11.15a1.871,1.871,0,0,0,.73,1.5,1.906,1.906,0,0,0,1.63.35l3.53-.89a1.086,1.086,0,0,1,.44,0l4.98,1.24a2.315,2.315,0,0,0,.46.05,2.4,2.4,0,0,0,.46-.05l4.21-1.06a1.893,1.893,0,0,0,1.44-1.84V6.076A1.871,1.871,0,0,0,20.21,4.576ZM8.67,17.926l-3.49.87a.89.89,0,0,1-1.12-.87V6.776a.9.9,0,0,1,.68-.87l3.93-.99Zm5.66,1.16-4.66-1.16V4.916l4.66,1.16Zm5.61-1.86a.9.9,0,0,1-.68.87l-3.93.99V6.076l3.49-.87a.908.908,0,0,1,.78.16.886.886,0,0,1,.34.71Z"}}]}]})(props);
	};
	module.exports.CiMaximize1 = function CiMaximize1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Maximize_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M3.065,16.16a.5.5,0,0,1,1,0v3.07l.01-.01,6.07-6.07a.5.5,0,0,1,.71.71c-.29.29-.58.57-.87.86-1.74,1.74-3.47,3.48-5.21,5.22h3.07a.5.5,0,0,1,0,1H3.565a.429.429,0,0,1-.34-.14c-.01-.01-.02-.01-.02-.02a.384.384,0,0,1-.13-.26C3.066,20.442,3.065,16.16,3.065,16.16Z"}},{"tag":"path","attr":{"d":"M20.935,3.56V7.84a.5.5,0,0,1-1,0V4.77l-.01.01q-3.045,3.03-6.07,6.07a.5.5,0,0,1-.71-.71c.29-.29.58-.57.86-.86,1.75-1.74,3.48-3.48,5.22-5.22h-3.07a.5.5,0,0,1,0-1h4.28a.429.429,0,0,1,.34.14c.01.01.02.01.02.02A.429.429,0,0,1,20.935,3.56Z"}}]}]}]})(props);
	};
	module.exports.CiMaximize2 = function CiMaximize2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Maximize_2"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M10.513,3.066H4.93a2.058,2.058,0,0,0-1.15.22,1.6,1.6,0,0,0-.717,1.437v5.793a.5.5,0,0,0,1,0V5.107a2.521,2.521,0,0,1,.022-.689c.115-.373.469-.352.777-.352h5.651a.5.5,0,0,0,0-1Z"}},{"tag":"path","attr":{"d":"M3.063,13.488v5.583a2.057,2.057,0,0,0,.221,1.15,1.6,1.6,0,0,0,1.436.717h5.793a.5.5,0,0,0,0-1H5.1a2.483,2.483,0,0,1-.689-.022c-.372-.115-.352-.469-.352-.777V13.488a.5.5,0,0,0-1,0Z"}},{"tag":"path","attr":{"d":"M13.487,20.934H19.07a2.058,2.058,0,0,0,1.15-.22,1.6,1.6,0,0,0,.717-1.437V13.484a.5.5,0,0,0-1,0v5.409a2.521,2.521,0,0,1-.022.689c-.115.373-.469.352-.777.352H13.487a.5.5,0,0,0,0,1Z"}},{"tag":"path","attr":{"d":"M20.937,10.512V4.929a2.057,2.057,0,0,0-.221-1.15,1.6,1.6,0,0,0-1.436-.717H13.487a.5.5,0,0,0,0,1H18.9a2.483,2.483,0,0,1,.689.022c.372.115.352.469.352.777v5.651a.5.5,0,0,0,1,0Z"}}]}]}]})(props);
	};
	module.exports.CiMedal = function CiMedal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Medal"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.692,3.755a1.519,1.519,0,0,0-1.27-.69h-4.41a1.487,1.487,0,0,0-1.36.87L12,7.485l-1.66-3.55a1.487,1.487,0,0,0-1.36-.87H4.572a1.5,1.5,0,0,0-1.35,2.14l3.73,8.02a5.638,5.638,0,0,0-.46,2.21,5.5,5.5,0,0,0,11,0,5.419,5.419,0,0,0-.46-2.2l3.75-8.03A1.525,1.525,0,0,0,20.692,3.755ZM4.122,4.785a.527.527,0,0,1,.03-.49.494.494,0,0,1,.42-.23h4.41a.507.507,0,0,1,.46.29l2.61,5.58h-.06a5.505,5.505,0,0,0-4.43,2.25Zm7.87,15.15a4.5,4.5,0,1,1,4.5-4.5A4.5,4.5,0,0,1,11.992,19.935Zm7.89-15.15-3.46,7.4a5.454,5.454,0,0,0-3.21-2.11l-.66-1.42,2-4.3a.507.507,0,0,1,.46-.29h4.41a.482.482,0,0,1,.42.23A.505.505,0,0,1,19.882,4.785Z"}},{"tag":"path","attr":{"d":"M12.077,16.88l1.024.538a.174.174,0,0,0,.253-.184l-.2-1.14a.174.174,0,0,1,.051-.154l.828-.807a.175.175,0,0,0-.1-.3L12.8,14.669a.177.177,0,0,1-.132-.1l-.512-1.037a.174.174,0,0,0-.313,0l-.512,1.037a.174.174,0,0,1-.131.1l-1.145.166a.175.175,0,0,0-.1.3l.828.807a.174.174,0,0,1,.05.154l-.2,1.14a.174.174,0,0,0,.253.184l1.024-.538A.172.172,0,0,1,12.077,16.88Z"}}]}]}]})(props);
	};
	module.exports.CiMedicalCase = function CiMedicalCase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Medical_Case"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.435,6.465h-1.43v-.9a2.5,2.5,0,0,0-2.5-2.5h-5a2.5,2.5,0,0,0-2.5,2.5v.9H5.565a2.5,2.5,0,0,0-2.5,2.5v9.47a2.5,2.5,0,0,0,2.5,2.5h12.87a2.5,2.5,0,0,0,2.5-2.5V8.965A2.5,2.5,0,0,0,18.435,6.465Zm-10.43-.9a1.5,1.5,0,0,1,1.5-1.5h5a1.5,1.5,0,0,1,1.5,1.5v.9h-8Zm11.93,12.87a1.5,1.5,0,0,1-1.5,1.5H5.565a1.5,1.5,0,0,1-1.5-1.5V8.965a1.5,1.5,0,0,1,1.5-1.5h12.87a1.5,1.5,0,0,1,1.5,1.5Z"}},{"tag":"path","attr":{"d":"M14.505,13.675a.5.5,0,0,1-.5.5h-1.5v1.5a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5v-1.5h-1.5a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1.5v-1.5a.5.5,0,0,1,.5-.5.508.508,0,0,1,.5.5v1.5h1.5A.508.508,0,0,1,14.505,13.675Z"}}]}]}]})(props);
	};
	module.exports.CiMedicalClipboard = function CiMedicalClipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Medical_Clipboard"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.44,3.5H15.75V2.97a.949.949,0,0,0-1-.91H9.25a.949.949,0,0,0-1,.91V3.5H6.56A2.5,2.5,0,0,0,4.06,6V19.44a2.5,2.5,0,0,0,2.5,2.5H17.44a2.5,2.5,0,0,0,2.5-2.5V6A2.5,2.5,0,0,0,17.44,3.5ZM9.25,3.06l5.5.01V4.19c0,.61-.69,1.12-1.5,1.12h-2.5c-.82,0-1.5-.51-1.5-1.12Zm9.69,16.38a1.511,1.511,0,0,1-1.5,1.5H6.56a1.5,1.5,0,0,1-1.5-1.5V6a1.5,1.5,0,0,1,1.5-1.5H8.28a2.4,2.4,0,0,0,2.47,1.81h2.5A2.4,2.4,0,0,0,15.72,4.5h1.72A1.5,1.5,0,0,1,18.94,6Z"}},{"tag":"path","attr":{"d":"M14.5,12.71a.5.5,0,0,1-.5.5H12.5v1.5a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5v-1.5H10a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1.5v-1.5a.5.5,0,0,1,.5-.5.508.508,0,0,1,.5.5v1.5H14A.508.508,0,0,1,14.5,12.71Z"}}]}]}]})(props);
	};
	module.exports.CiMedicalCross = function CiMedicalCross (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Medical_Cross"},"child":[{"tag":"path","attr":{"d":"M12.943,20.93H11.057a2.388,2.388,0,0,1-2.386-2.386V15.3l-3.215.029a2.39,2.39,0,0,1-2.387-2.386V11.057A2.39,2.39,0,0,1,5.456,8.67H8.7L8.671,5.456A2.388,2.388,0,0,1,11.057,3.07h1.886a2.388,2.388,0,0,1,2.386,2.386V8.7l3.215-.03a2.39,2.39,0,0,1,2.387,2.387v1.886a2.39,2.39,0,0,1-2.387,2.386H15.3l.028,3.215A2.388,2.388,0,0,1,12.943,20.93ZM5.456,9.67a1.388,1.388,0,0,0-1.387,1.387v1.886a1.388,1.388,0,0,0,1.387,1.386H8.7a.972.972,0,0,1,.972.971v3.244a1.388,1.388,0,0,0,1.386,1.386h1.886a1.388,1.388,0,0,0,1.386-1.386V15.3a.972.972,0,0,1,.972-.971h3.243a1.388,1.388,0,0,0,1.387-1.386V11.057A1.388,1.388,0,0,0,18.544,9.67H15.3a.972.972,0,0,1-.972-.97V5.456A1.388,1.388,0,0,0,12.943,4.07H11.057A1.388,1.388,0,0,0,9.671,5.456V8.7a.972.972,0,0,1-.972.97Z"}}]}]})(props);
	};
	module.exports.CiMedicalMask = function CiMedicalMask (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Medical_Mask"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M21.435,12.53H19.5V9.17h1.94a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5H19.5V7.23A2.5,2.5,0,0,0,17,4.73H7a2.507,2.507,0,0,0-2.5,2.5v.94H2.565a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5H4.5v3.36H2.565a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5H4.5v.33a4.283,4.283,0,0,0,2.43,3.84l1.74.82a7.79,7.79,0,0,0,6.67,0l1.73-.82h.01a4.274,4.274,0,0,0,2.42-3.84v-.33h1.94a.5.5,0,0,0,.5-.5A.5.5,0,0,0,21.435,12.53ZM18.5,13.86a3.238,3.238,0,0,1-1.85,2.93l-1.73.82a6.767,6.767,0,0,1-5.83,0l-1.73-.82A3.248,3.248,0,0,1,5.5,13.86V7.23A1.5,1.5,0,0,1,7,5.73H17a1.5,1.5,0,0,1,1.5,1.5Z"}},{"tag":"path","attr":{"d":"M14.5,14.534h-5a.5.5,0,0,1,0-1h5a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M16,10.168H8a.5.5,0,1,1,0-1h8a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiMemoPad = function CiMemoPad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Memo_Pad"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.44,2.065H6.56a2.507,2.507,0,0,0-2.5,2.5v14.87a2.507,2.507,0,0,0,2.5,2.5H17.44a2.5,2.5,0,0,0,2.5-2.5V4.565A2.5,2.5,0,0,0,17.44,2.065Zm1.5,17.37a1.5,1.5,0,0,1-1.5,1.5H6.56a1.5,1.5,0,0,1-1.5-1.5V6.505H18.94Z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M7.549,9.506h0a.5.5,0,0,1,0-1h8.909a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M7.549,12.506h0a.5.5,0,0,1,0-1h6.5a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M7.566,18.374h0a.5.5,0,1,1,0-1h3.251a.5.5,0,0,1,0,1Z"}}]}]}]}]})(props);
	};
	module.exports.CiMenuBurger = function CiMenuBurger (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Menu_Burger"},"child":[{"tag":"path","attr":{"d":"M3.563,4.063c-0.276,-0 -0.5,-0.224 -0.5,-0.5c-0,-0.276 0.224,-0.5 0.5,-0.5l16.874,-0.001c0.276,-0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5l-16.874,0.001Z"}},{"tag":"path","attr":{"d":"M3.563,12.501c-0.276,-0 -0.5,-0.224 -0.5,-0.5c-0,-0.276 0.224,-0.5 0.5,-0.5l16.874,-0.002c0.276,0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5l-16.874,0.002Z"}},{"tag":"path","attr":{"d":"M3.563,20.939c-0.276,-0 -0.5,-0.224 -0.5,-0.5c-0,-0.276 0.224,-0.5 0.5,-0.5l16.874,-0.002c0.276,0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5l-16.874,0.002Z"}}]}]})(props);
	};
	module.exports.CiMenuFries = function CiMenuFries (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Menu_Fries"},"child":[{"tag":"path","attr":{"d":"M20.437,19.937c0.276,0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5l-16.874,0.002c-0.276,-0 -0.5,-0.224 -0.5,-0.5c-0,-0.276 0.224,-0.5 0.5,-0.5l16.874,-0.002Z"}},{"tag":"path","attr":{"d":"M20.437,11.5c0.276,-0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5l-10,0.001c-0.276,-0 -0.5,-0.224 -0.5,-0.5c-0,-0.276 0.224,-0.5 0.5,-0.5l10,-0.001Z"}},{"tag":"path","attr":{"d":"M20.437,3.062c0.276,-0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5l-16.874,0.001c-0.276,-0 -0.5,-0.224 -0.5,-0.5c-0,-0.276 0.224,-0.5 0.5,-0.5l16.874,-0.001Z"}}]}]})(props);
	};
	module.exports.CiMenuKebab = function CiMenuKebab (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Menu_Kebab"},"child":[{"tag":"path","attr":{"d":"M14.5,12c0,1.38 -1.12,2.5 -2.5,2.5c-1.38,-0 -2.5,-1.12 -2.5,-2.5c0,-1.38 1.12,-2.5 2.5,-2.5c1.38,-0 2.5,1.12 2.5,2.5Zm-1,-0c0,-0.828 -0.672,-1.5 -1.5,-1.5c-0.828,-0 -1.5,0.672 -1.5,1.5c0,0.828 0.672,1.5 1.5,1.5c0.828,-0 1.5,-0.672 1.5,-1.5Z"}},{"tag":"path","attr":{"d":"M14.5,4.563c0,1.38 -1.12,2.5 -2.5,2.5c-1.38,-0 -2.5,-1.12 -2.5,-2.5c0,-1.38 1.12,-2.5 2.5,-2.5c1.38,-0 2.5,1.12 2.5,2.5Zm-1,-0c0,-0.828 -0.672,-1.5 -1.5,-1.5c-0.828,-0 -1.5,0.672 -1.5,1.5c0,0.828 0.672,1.5 1.5,1.5c0.828,-0 1.5,-0.672 1.5,-1.5Z"}},{"tag":"path","attr":{"d":"M14.5,19.437c0,1.38 -1.12,2.5 -2.5,2.5c-1.38,0 -2.5,-1.12 -2.5,-2.5c0,-1.38 1.12,-2.5 2.5,-2.5c1.38,0 2.5,1.12 2.5,2.5Zm-1,0c0,-0.828 -0.672,-1.5 -1.5,-1.5c-0.828,0 -1.5,0.672 -1.5,1.5c0,0.828 0.672,1.5 1.5,1.5c0.828,0 1.5,-0.672 1.5,-1.5Z"}}]}]})(props);
	};
	module.exports.CiMicrochip = function CiMicrochip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Microchip"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M13,14.5H11A1.5,1.5,0,0,1,9.5,13V11A1.5,1.5,0,0,1,11,9.5h2A1.5,1.5,0,0,1,14.5,11v2A1.5,1.5,0,0,1,13,14.5Zm-2-4a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5V11a.5.5,0,0,0-.5-.5Z"}},{"tag":"path","attr":{"d":"M20.435,14.5h-1.93v-5h1.93a.5.5,0,0,0,0-1h-1.93V8a2.507,2.507,0,0,0-2.5-2.5h-.5V3.565a.508.508,0,0,0-.5-.5.5.5,0,0,0-.5.5V5.5h-5V3.565a.508.508,0,0,0-.5-.5.5.5,0,0,0-.5.5V5.5h-.5A2.5,2.5,0,0,0,5.505,8v.5H3.565a.5.5,0,1,0,0,1h1.94v5H3.565a.5.5,0,1,0,0,1h1.94V16a2.5,2.5,0,0,0,2.5,2.5h.5v1.94a.5.5,0,0,0,1,0V18.5h5v1.94a.5.5,0,0,0,1,0V18.5h.5a2.507,2.507,0,0,0,2.5-2.5v-.5h1.93a.5.5,0,0,0,0-1ZM17.505,16a1.5,1.5,0,0,1-1.5,1.5h-8a1.5,1.5,0,0,1-1.5-1.5V8a1.5,1.5,0,0,1,1.5-1.5h8a1.511,1.511,0,0,1,1.5,1.5Z"}}]}]}]})(props);
	};
	module.exports.CiMicrophoneOff = function CiMicrophoneOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Microphone_Off"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M16.5,7.046v4.72a.5.5,0,0,1-1,0V9.946H14a.5.5,0,0,1,0-1h1.5v-2H13.57a.5.5,0,0,1,0-1h1.87a3.23,3.23,0,0,0-.2-.72,3.533,3.533,0,0,0-6.16-.59c-.36.53-1.23.03-.87-.5a4.509,4.509,0,0,1,7.71.21A5.255,5.255,0,0,1,16.5,7.046Z"}},{"tag":"path","attr":{"d":"M20.14,19.436q-2.625-2.64-5.27-5.28Q10.685,9.986,6.51,5.8c-.65-.64-1.3-1.29-1.94-1.94a.5.5,0,0,0-.71.71Q5.69,6.381,7.5,8.206v3.92a4.591,4.591,0,0,0,3.59,4.61,4.629,4.629,0,0,0,3.9-1.04c.24.24.48.47.71.71a5.252,5.252,0,0,1-6.62.67,5.2,5.2,0,0,1-2.05-2.76,7.608,7.608,0,0,1-.24-2.33v-2.2a.5.5,0,0,0-1,0,15.463,15.463,0,0,0,.34,4.99,6.276,6.276,0,0,0,5.37,4.17v1.99H8a.5.5,0,0,0,0,1h8a.5.5,0,0,0,0-1H12.5v-2a6.118,6.118,0,0,0,3.91-1.82l1.08,1.08c.65.65,1.3,1.3,1.95,1.94A.5.5,0,0,0,20.14,19.436Zm-11.2-5.42a3.991,3.991,0,0,1-.44-2.03V9.206l5.77,5.77A3.521,3.521,0,0,1,8.94,14.016Z"}}]}]}]})(props);
	};
	module.exports.CiMicrophoneOn = function CiMicrophoneOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Microphone_On"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M11.989,2.065a4.507,4.507,0,0,0-4.5,4.5v5.76a4.5,4.5,0,0,0,9,0V6.565A4.507,4.507,0,0,0,11.989,2.065Zm0,13.76a3.5,3.5,0,0,1-3.5-3.5V6.565a3.5,3.5,0,0,1,6.94-.62h-1.87a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5h1.93v2h-1.93a.5.5,0,0,0-.5.5.508.508,0,0,0,.5.5h1.93v2h-1.94a.508.508,0,0,0-.5.5.515.515,0,0,0,.5.5h1.88A3.492,3.492,0,0,1,11.989,15.825Z"}},{"tag":"path","attr":{"d":"M12.489,18.925v2.01h3.5a.5.5,0,0,1,0,1h-8a.5.5,0,0,1,0-1h3.5v-1.99a6.055,6.055,0,0,1-2.74-.88,6.291,6.291,0,0,1-2.97-5.14c-.03-1.04,0-2.09,0-3.13a.5.5,0,0,1,1,0c0,1.04-.03,2.09,0,3.13A5.212,5.212,0,0,0,17.2,12.7c.01-.96,0-1.93,0-2.9a.5.5,0,0,1,1,0,26.322,26.322,0,0,1-.08,3.97A6.235,6.235,0,0,1,12.489,18.925Z"}}]}]}]})(props);
	};
	module.exports.CiMinimize1 = function CiMinimize1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Minimize_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M11,17.78a.5.5,0,0,1-1,0V14.71L3.92,20.79a.5.5,0,0,1-.71-.71c.29-.29.58-.57.87-.86C5.82,17.48,7.55,15.74,9.3,14H6.22a.5.5,0,0,1,0-1H10.5a.429.429,0,0,1,.34.14c.01.01.02.01.02.02a.384.384,0,0,1,.13.26Z"}},{"tag":"path","attr":{"d":"M14.7,10h3.08a.5.5,0,0,1,0,1H13.5a.429.429,0,0,1-.34-.14c-.01-.01-.02-.01-.02-.02a.384.384,0,0,1-.13-.26L13,6.22a.5.5,0,0,1,1,0V9.29l.01-.01,6.07-6.07a.5.5,0,0,1,.71.71Z"}}]}]}]})(props);
	};
	module.exports.CiMinimize2 = function CiMinimize2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Minimize_2"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M3.563,11.016H9.146A2.057,2.057,0,0,0,10.3,10.8a1.6,1.6,0,0,0,.717-1.436V3.566a.5.5,0,0,0-1,0V8.974a2.481,2.481,0,0,1-.022.689c-.115.373-.468.353-.777.353H3.563a.5.5,0,0,0,0,1Z"}},{"tag":"path","attr":{"d":"M11.013,20.438V14.855a2.065,2.065,0,0,0-.22-1.15,1.6,1.6,0,0,0-1.437-.717H3.563a.5.5,0,0,0,0,1H8.972a2.482,2.482,0,0,1,.689.022c.373.115.352.469.352.777v5.651a.5.5,0,0,0,1,0Z"}},{"tag":"path","attr":{"d":"M20.437,12.984H14.854a2.057,2.057,0,0,0-1.15.221,1.6,1.6,0,0,0-.717,1.436v5.793a.5.5,0,0,0,1,0V15.026a2.481,2.481,0,0,1,.022-.689c.115-.373.468-.353.777-.353h5.651a.5.5,0,0,0,0-1Z"}},{"tag":"path","attr":{"d":"M12.987,3.562V9.145a2.065,2.065,0,0,0,.22,1.15,1.6,1.6,0,0,0,1.437.717h5.793a.5.5,0,0,0,0-1H15.028a2.482,2.482,0,0,1-.689-.022c-.373-.115-.352-.469-.352-.777V3.562a.5.5,0,0,0-1,0Z"}}]}]}]})(props);
	};
	module.exports.CiMobile1 = function CiMobile1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Mobile_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M10,18.933h4a.5.5,0,0,0,0-1H10a.5.5,0,0,0,0,1Z"}},{"tag":"path","attr":{"d":"M16.727,21.937H7.273a2.384,2.384,0,0,1-2.239-2.5V4.563a2.384,2.384,0,0,1,2.239-2.5h9.454a2.384,2.384,0,0,1,2.239,2.5V19.437A2.384,2.384,0,0,1,16.727,21.937ZM7.273,3.063a1.39,1.39,0,0,0-1.239,1.5V19.437a1.39,1.39,0,0,0,1.239,1.5h9.454a1.39,1.39,0,0,0,1.239-1.5V4.563a1.39,1.39,0,0,0-1.239-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiMobile2 = function CiMobile2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Mobile_2"},"child":[{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"cx":"12","cy":"17.937","r":"1"}},{"tag":"path","attr":{"d":"M16.727,21.937H7.273a2.384,2.384,0,0,1-2.239-2.5V4.563a2.384,2.384,0,0,1,2.239-2.5h9.454a2.384,2.384,0,0,1,2.239,2.5V19.437A2.384,2.384,0,0,1,16.727,21.937ZM7.273,3.063a1.39,1.39,0,0,0-1.239,1.5V19.437a1.39,1.39,0,0,0,1.239,1.5h9.454a1.39,1.39,0,0,0,1.239-1.5V4.563a1.39,1.39,0,0,0-1.239-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiMobile3 = function CiMobile3 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Mobile_3"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M16.73,2.065H7.27a2.386,2.386,0,0,0-2.24,2.5v14.87a2.386,2.386,0,0,0,2.24,2.5h9.46a2.386,2.386,0,0,0,2.24-2.5V4.565A2.386,2.386,0,0,0,16.73,2.065Zm1.24,17.37a1.391,1.391,0,0,1-1.24,1.5H7.27a1.391,1.391,0,0,1-1.24-1.5V4.565a1.391,1.391,0,0,1,1.24-1.5H8.8v.51a1,1,0,0,0,1,1h4.4a1,1,0,0,0,1-1v-.51h1.53a1.391,1.391,0,0,1,1.24,1.5Z"}},{"tag":"path","attr":{"d":"M10,18.934h4a.5.5,0,0,0,0-1H10a.5.5,0,0,0,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiMobile4 = function CiMobile4 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Mobile_4"},"child":[{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"cx":"12.003","cy":"18.937","r":"1"}},{"tag":"path","attr":{"d":"M16.725,2.065H7.275a2.386,2.386,0,0,0-2.24,2.5v14.87a2.386,2.386,0,0,0,2.24,2.5h9.45a2.379,2.379,0,0,0,2.24-2.5V4.565A2.379,2.379,0,0,0,16.725,2.065Zm1.24,17.37a1.384,1.384,0,0,1-1.24,1.5H7.275a1.391,1.391,0,0,1-1.24-1.5v-2.5h11.93Zm0-3.5H6.035V4.565a1.391,1.391,0,0,1,1.24-1.5h9.45a1.384,1.384,0,0,1,1.24,1.5Z"}}]}]}]})(props);
	};
	module.exports.CiMoneyBill = function CiMoneyBill (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Money_Bill"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.44,5.78H4.56a2.507,2.507,0,0,0-2.5,2.5v7.44a2.514,2.514,0,0,0,2.5,2.5H19.44a2.507,2.507,0,0,0,2.5-2.5V8.28A2.5,2.5,0,0,0,19.44,5.78ZM3.06,8.28a1.5,1.5,0,0,1,1.5-1.5H6.04A3.521,3.521,0,0,1,3.06,9.76Zm1.5,8.94a1.511,1.511,0,0,1-1.5-1.5V14.24a3.521,3.521,0,0,1,2.98,2.98Zm16.38-1.5a1.5,1.5,0,0,1-1.5,1.5H17.96a3.521,3.521,0,0,1,2.98-2.98Zm0-2.49a4.528,4.528,0,0,0-3.99,3.99H7.05a4.528,4.528,0,0,0-3.99-3.99V10.77A4.528,4.528,0,0,0,7.05,6.78h9.9a4.528,4.528,0,0,0,3.99,3.99Zm0-3.47a3.521,3.521,0,0,1-2.98-2.98h1.48a1.5,1.5,0,0,1,1.5,1.5Z"}},{"tag":"circle","attr":{"cx":"12.002","cy":"11.998","r":"2"}}]}]}]})(props);
	};
	module.exports.CiMoneyCheck1 = function CiMoneyCheck1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Money_Check_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.437,18.218H4.563a2.5,2.5,0,0,1-2.5-2.5V8.282a2.5,2.5,0,0,1,2.5-2.5H19.437a2.5,2.5,0,0,1,2.5,2.5v7.436A2.5,2.5,0,0,1,19.437,18.218ZM4.563,6.782a1.5,1.5,0,0,0-1.5,1.5v7.436a1.5,1.5,0,0,0,1.5,1.5H19.437a1.5,1.5,0,0,0,1.5-1.5V8.282a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M12,12.786H5.064a.5.5,0,0,1,0-1H12a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M14,15.714H5.064a.5.5,0,1,1,0-1H14a.5.5,0,0,1,0,1Z"}},{"tag":"rect","attr":{"x":"15.436","y":"8.283","width":"4","height":"2","rx":"0.5"}}]}]}]})(props);
	};
	module.exports.CiMonitor = function CiMonitor (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Monitor"},"child":[{"tag":"path","attr":{"d":"M18.435,3.06H5.565a2.5,2.5,0,0,0-2.5,2.5v8.88a2.507,2.507,0,0,0,2.5,2.5h2.91l-.37,3H7a.5.5,0,0,0,0,1h10.01a.5.5,0,0,0,0-1H15.9l-.37-3h2.91a2.507,2.507,0,0,0,2.5-2.5V5.56A2.5,2.5,0,0,0,18.435,3.06ZM14.9,19.94H9.115l.37-3h5.03Zm5.04-5.5a1.5,1.5,0,0,1-1.5,1.5H5.565a1.5,1.5,0,0,1-1.5-1.5V5.56a1.5,1.5,0,0,1,1.5-1.5h12.87a1.5,1.5,0,0,1,1.5,1.5Z"}}]}]})(props);
	};
	module.exports.CiMountain1 = function CiMountain1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Mountain_1"},"child":[{"tag":"path","attr":{"d":"M20.857,19.525l-6.57-14.96a2.5,2.5,0,0,0-4.58-.01l-6.56,14.96a1,1,0,0,0,.07.96.985.985,0,0,0,.84.46h15.89a1,1,0,0,0,.91-1.41ZM10.627,4.965a1.5,1.5,0,0,1,2.75,0l2.43,5.53-1.45,1.45a.5.5,0,0,1-.71,0l-2.04-2.03a1.5,1.5,0,0,0-1.06-.44h-1.9Zm-6.57,14.96,4.15-9.45h2.34a.491.491,0,0,1,.36.15l2.03,2.03A1.508,1.508,0,0,0,14,13.1a1.491,1.491,0,0,0,1.06-.44l1.18-1.17,3.71,8.45Z"}}]}]})(props);
	};
	module.exports.CiMug1 = function CiMug1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Mug_1"},"child":[{"tag":"path","attr":{"d":"M18.115,5.91V4.97a1.2,1.2,0,0,0-1.2-1.2H4.265a1.2,1.2,0,0,0-1.2,1.2v9.14a11.321,11.321,0,0,0,.8,4.17A3.3,3.3,0,0,0,7,20.23h7.19a3.312,3.312,0,0,0,3.14-1.95,10.989,10.989,0,0,0,.74-3.13l1.04-.52a3.319,3.319,0,0,0,1.83-2.97V9.19A3.326,3.326,0,0,0,18.115,5.91Zm-1.73,12.01a2.3,2.3,0,0,1-2.2,1.31H7a2.312,2.312,0,0,1-2.2-1.31,10.238,10.238,0,0,1-.73-3.81V4.97a.2.2,0,0,1,.2-.2h12.65a.2.2,0,0,1,.2.2v9.14A10.238,10.238,0,0,1,16.385,17.92Zm3.55-6.26a2.287,2.287,0,0,1-1.28,2.07l-.54.27V6.93a2.316,2.316,0,0,1,1.82,2.26Z"}}]}]})(props);
	};
	module.exports.CiMusicNote1 = function CiMusicNote1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Music_Note_1"},"child":[{"tag":"path","attr":{"d":"M20.05,3.657a2.487,2.487,0,0,0-2.03-.56l-7.88,1.33a2.483,2.483,0,0,0-2.08,2.46v8.82a3,3,0,1,0,1,2.23V9.387l10.88-1.83v6.22a2.936,2.936,0,0,0-2-.77,3,3,0,1,0,3,3V5.567A2.513,2.513,0,0,0,20.05,3.657ZM6.06,19.937a2,2,0,1,1,2-2A1.993,1.993,0,0,1,6.06,19.937Zm11.88-1.93a2,2,0,1,1,2-2A2,2,0,0,1,17.94,18.007Zm2-11.46L9.06,8.377V6.887a1.483,1.483,0,0,1,1.25-1.47l7.88-1.33a1.493,1.493,0,0,1,1.75,1.48Z"}}]}]})(props);
	};
	module.exports.CiNoWaitingSign = function CiNoWaitingSign (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"No_Waiting_Sign"},"child":[{"tag":"path","attr":{"d":"M12,2.07a9.93,9.93,0,1,0,7.03,16.95.374.374,0,0,0,.06-.07A9.837,9.837,0,0,0,21.935,12,9.944,9.944,0,0,0,12,2.07Zm0,18.86A8.945,8.945,0,0,1,3.065,12a8.84,8.84,0,0,1,2.28-5.95l12.61,12.61A8.925,8.925,0,0,1,12,20.93Zm6.67-2.98L6.045,5.34a8.934,8.934,0,0,1,12.62,12.61Z"}}]}]})(props);
	};
	module.exports.CiPalette = function CiPalette (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Palette"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.31,20.93a1.62,1.62,0,0,0,1.62-1.62V15.93a1.62,1.62,0,0,0-1.62-1.62H14.37l4.66-4.66a1.642,1.642,0,0,0,0-2.3L16.64,4.96a1.636,1.636,0,0,0-2.3,0L9.69,9.62V4.56a1.5,1.5,0,0,0-1.5-1.5H4.57a1.5,1.5,0,0,0-1.5,1.5V18.44a2.507,2.507,0,0,0,2.5,2.5ZM9.69,11.04l5.36-5.37a.628.628,0,0,1,.88,0l2.39,2.39a.628.628,0,0,1,0,.88L9.69,17.57ZM4.07,4.56a.5.5,0,0,1,.5-.5H8.19a.5.5,0,0,1,.5.5V8.48H4.07Zm0,4.92H8.69v4.43H4.07ZM7.29,19.93l-1.72.01a1.5,1.5,0,0,1-1.5-1.5V14.91H8.69v3.53a1.5,1.5,0,0,1-1.4,1.49m12.64-.62a.623.623,0,0,1-.62.62H9.19a2.381,2.381,0,0,0,.42-.86l3.76-3.76h5.94a.623.623,0,0,1,.62.62Z"}},{"tag":"circle","attr":{"cx":"6.382","cy":"17.419","r":"0.844"}}]}]}]})(props);
	};
	module.exports.CiPaperplane = function CiPaperplane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Paper_Plane"},"child":[{"tag":"path","attr":{"d":"M21.061,11.077,3.741,4.157a.994.994,0,0,0-1.17.32,1,1,0,0,0-.01,1.22l4.49,6a.525.525,0,0,1-.01.62L2.511,18.3a1.02,1.02,0,0,0,0,1.22,1,1,0,0,0,.8.4,1.021,1.021,0,0,0,.38-.07l17.36-6.9a1.006,1.006,0,0,0,.01-1.87ZM3.371,5.087l16.06,6.42H8.061a1.329,1.329,0,0,0-.21-.41Zm-.06,13.82,4.53-5.98a1.212,1.212,0,0,0,.22-.42h11.38Z"}}]}]})(props);
	};
	module.exports.CiParking1 = function CiParking1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Parking_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.933A9.933,9.933,0,1,1,21.933,12,9.944,9.944,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.933,12,8.943,8.943,0,0,0,12,3.067Z"}},{"tag":"path","attr":{"d":"M12.569,8.5h-1.75a.749.749,0,0,0-.75.75v5.74a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5V13.5h1.5a2.5,2.5,0,0,0,0-5Zm0,4h-1.5v-3h1.5a1.5,1.5,0,0,1,0,3Z"}}]}]}]})(props);
	};
	module.exports.CiPassport1 = function CiPassport1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Passport_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M16.5,21.936h-9a2.5,2.5,0,0,1-2.5-2.5V4.564a2.5,2.5,0,0,1,2.5-2.5h9a2.5,2.5,0,0,1,2.5,2.5V19.436A2.5,2.5,0,0,1,16.5,21.936ZM7.5,3.064A1.5,1.5,0,0,0,6,4.564V19.436a1.5,1.5,0,0,0,1.5,1.5h9a1.5,1.5,0,0,0,1.5-1.5V4.564a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M12,12.563a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,12,12.563Zm0-6a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,12,6.563Z"}},{"tag":"path","attr":{"d":"M15,18.438H9a.5.5,0,0,1,0-1h6a.5.5,0,1,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiPause1 = function CiPause1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Pause_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M8.25,21.937H6.564a2.5,2.5,0,0,1-2.5-2.5V4.563a2.5,2.5,0,0,1,2.5-2.5H8.25a2.5,2.5,0,0,1,2.5,2.5V19.437A2.5,2.5,0,0,1,8.25,21.937ZM6.564,3.063a1.5,1.5,0,0,0-1.5,1.5V19.437a1.5,1.5,0,0,0,1.5,1.5H8.25a1.5,1.5,0,0,0,1.5-1.5V4.563a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M17.436,21.937H15.75a2.5,2.5,0,0,1-2.5-2.5V4.563a2.5,2.5,0,0,1,2.5-2.5h1.686a2.5,2.5,0,0,1,2.5,2.5V19.437A2.5,2.5,0,0,1,17.436,21.937ZM15.75,3.063a1.5,1.5,0,0,0-1.5,1.5V19.437a1.5,1.5,0,0,0,1.5,1.5h1.686a1.5,1.5,0,0,0,1.5-1.5V4.563a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiPen = function CiPen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Pen"},"child":[{"tag":"path","attr":{"d":"M20.235,11.284a2.3,2.3,0,0,0-3.01-.149L15.444,5.744a2.484,2.484,0,0,0-2.1-1.7l-8.581-.93A1.5,1.5,0,0,0,3.115,4.765l.93,8.579a2.479,2.479,0,0,0,1.7,2.1l5.39,1.77a2.258,2.258,0,0,0-.51,1.43,2.257,2.257,0,0,0,2.25,2.25,2.263,2.263,0,0,0,1.591-.661l5.77-5.769a2.249,2.249,0,0,0,0-3.181Zm-14.18,3.21a1.5,1.5,0,0,1-1.02-1.26l-.9-8.39,4.01,4.01a1.188,1.188,0,0,0,.281,1.221,1.167,1.167,0,1,0,1.649-1.651,1.143,1.143,0,0,0-1.209-.269l-4.02-4.02,8.39.9a1.476,1.476,0,0,1,1.259,1.02l1.931,5.86-4.51,4.51Zm11.709-2.51a1.25,1.25,0,0,1,2.13.891,1.237,1.237,0,0,1-.369.88l-5.771,5.77a1.277,1.277,0,0,1-1.769,0,1.253,1.253,0,0,1,0-1.76Z"}}]}]})(props);
	};
	module.exports.CiPenpot = function CiPenpot (props) {
	  return GenIcon({"tag":"svg","attr":{"id":"Penpot","viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M4.415,7.22a.755.755,0,0,0-.35.64v9.67a1.536,1.536,0,0,0,.88,1.38l5.96,2.82a2.618,2.618,0,0,0,2.19,0l5.96-2.82a1.536,1.536,0,0,0,.88-1.38V7.86a.742.742,0,0,0-.36-.64l-2.23-1.15v-1a.98.98,0,0,0-.15-.52l-1.33-2.16a.749.749,0,0,0-1.28,0L13.3,4.5l-.66-1.07A.755.755,0,0,0,12,3.08a.791.791,0,0,0-.64.36l-.65,1.06L9.4,2.39a.749.749,0,0,0-1.28,0L6.805,4.55a.98.98,0,0,0-.15.52v1Zm12.93-.01.7.35-.7.33Zm-2.44-3.43h.64l.5.81h-1.64Zm1.44,1.81V8.36l-.61.29V5.59Zm-2.23,0h.62V9.12l-.62.3ZM8.445,3.78h.64l.5.81H7.945Zm1.44,1.81V9.41l-.61-.29V5.59Zm-2.23,0h.62V8.65l-.62-.29Zm-1,1.62v.68l-.7-.33ZM5.365,18a.52.52,0,0,1-.3-.47V8.24l6.43,3.04v9.59Zm6.13-7.83-.61-.29V6.64h.61Zm-.32-4.53.51-.82h.62l.51.82Zm1.94,1V9.89l-.62.29V6.64ZM12.5,20.88V11.29l6.44-3.05v9.29a.512.512,0,0,1-.31.47Z"}}]})(props);
	};
	module.exports.CiPercent = function CiPercent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Percent"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.934A9.934,9.934,0,1,1,21.933,12,9.945,9.945,0,0,1,12,21.934ZM12,3.066A8.934,8.934,0,1,0,20.933,12,8.944,8.944,0,0,0,12,3.066Z"}},{"tag":"path","attr":{"d":"M9,10.258a1.5,1.5,0,1,1,1.061-.439h0A1.5,1.5,0,0,1,9,10.258Zm0-2a.5.5,0,1,0,.353.146A.5.5,0,0,0,9,8.259Z"}},{"tag":"path","attr":{"d":"M7.758,16.743A.5.5,0,0,1,7.4,15.89L15.889,7.4a.5.5,0,0,1,.707.707L8.111,16.6A.5.5,0,0,1,7.758,16.743Z"}},{"tag":"path","attr":{"d":"M15,16.742a1.5,1.5,0,1,1,1.061-.438A1.493,1.493,0,0,1,15,16.742Zm0-2a.5.5,0,0,0-.354.147h0a.5.5,0,0,0-.146.352.5.5,0,1,0,1,0,.5.5,0,0,0-.5-.5Z"}}]}]}]})(props);
	};
	module.exports.CiPhone = function CiPhone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Phone"},"child":[{"tag":"path","attr":{"d":"M14.436,20.938A11.384,11.384,0,0,1,4.572,3.9a1.668,1.668,0,0,1,1.241-.822,1.716,1.716,0,0,1,1.454.492l3.139,3.14a1.715,1.715,0,0,1,0,2.427l-.295.3a1.937,1.937,0,0,0,0,2.736l1.72,1.721a1.983,1.983,0,0,0,2.736,0l.29-.29a1.719,1.719,0,0,1,2.428,0l3.139,3.139a1.724,1.724,0,0,1,.492,1.455,1.669,1.669,0,0,1-.822,1.239A11.327,11.327,0,0,1,14.436,20.938ZM6.042,4.063a.793.793,0,0,0-.1.006.673.673,0,0,0-.5.331A10.375,10.375,0,0,0,19.594,18.567a.674.674,0,0,0,.331-.5.734.734,0,0,0-.208-.618l-3.139-3.139a.717.717,0,0,0-1.014,0l-.29.29a3.006,3.006,0,0,1-4.15,0L9.4,12.876a2.939,2.939,0,0,1,0-4.149l.3-.3a.717.717,0,0,0,0-1.014L6.56,4.277A.729.729,0,0,0,6.042,4.063Z"}}]}]})(props);
	};
	module.exports.CiPickerEmpty = function CiPickerEmpty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Picker_Empty"},"child":[{"tag":"path","attr":{"d":"M20.94,5.876a2.805,2.805,0,0,0-.84-2.01,2.856,2.856,0,0,0-3.97,0l-2.21,2.21-.75-.75a.8.8,0,0,0-1.1,0,.785.785,0,0,0,0,1.1l.75.75-8.77,8.76a3.248,3.248,0,0,0-.92,2.13l-.07,1.52a1.311,1.311,0,0,0,.38.97,1.332,1.332,0,0,0,.91.38h.06l1.52-.07a3.248,3.248,0,0,0,2.13-.92l8.76-8.77.75.75a.8.8,0,0,0,1.1,0,.785.785,0,0,0,0-1.1l-.75-.75L20.1,7.9A2.828,2.828,0,0,0,20.94,5.876ZM7.35,19.236a2.22,2.22,0,0,1-1.46.63l-1.53.07a.243.243,0,0,1-.21-.09.3.3,0,0,1-.09-.21l.07-1.53a2.22,2.22,0,0,1,.63-1.46l8.77-8.76,2.59,2.59ZM19.4,7.2l-2.18,2.18-2.59-2.59,2.21-2.22a1.861,1.861,0,0,1,2.56,0,1.846,1.846,0,0,1,.54,1.31A1.869,1.869,0,0,1,19.4,7.2Z"}}]}]})(props);
	};
	module.exports.CiPickerHalf = function CiPickerHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Picker_Half"},"child":[{"tag":"path","attr":{"d":"M20.936,5.889a2.825,2.825,0,0,0-4.81-2.02l-2.21,2.22-.75-.75a.771.771,0,0,0-.55-.22.8.8,0,0,0-.55.22.785.785,0,0,0,0,1.1l.75.75-8.76,8.76a3.154,3.154,0,0,0-.92,2.13l-.07,1.52a1.316,1.316,0,0,0,1.28,1.35h.06l1.52-.07a3.21,3.21,0,0,0,2.13-.93l8.76-8.76.75.75a.8.8,0,0,0,1.1,0,.785.785,0,0,0,0-1.1l-.75-.75,2.18-2.18A2.845,2.845,0,0,0,20.936,5.889Zm-8.56,8.33H7.2l6.33-6.32,2.59,2.59ZM19.4,7.2l-2.18,2.19L14.626,6.8l2.21-2.22a1.823,1.823,0,0,1,2.56,0,1.859,1.859,0,0,1,0,2.62Z"}}]}]})(props);
	};
	module.exports.CiPill = function CiPill (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Pill"},"child":[{"tag":"path","attr":{"d":"M19.31,4.691a5.5,5.5,0,0,0-7.78,0l-6.84,6.84a5.5,5.5,0,0,0,3.89,9.39,5.524,5.524,0,0,0,3.89-1.61l6.84-6.84a5.5,5.5,0,0,0,0-7.78Zm-.71,7.07-3.42,3.42L8.82,8.821,12.24,5.4a4.5,4.5,0,0,1,7.68,3.17A4.429,4.429,0,0,1,18.6,11.761Z"}}]}]})(props);
	};
	module.exports.CiPillsBottle1 = function CiPillsBottle1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"meds_Bottle_1"},"child":[{"tag":"path","attr":{"d":"M17.435,2.06H6.565a2.5,2.5,0,0,0-2.5,2.5v2a1.492,1.492,0,0,0,1.22,1.47V19.44a2.5,2.5,0,0,0,2.5,2.5h8.43a2.5,2.5,0,0,0,2.5-2.5V8.03a1.492,1.492,0,0,0,1.22-1.47v-2A2.5,2.5,0,0,0,17.435,2.06Zm.28,17.38a1.5,1.5,0,0,1-1.5,1.5H7.785a1.5,1.5,0,0,1-1.5-1.5v-.88h3.52a.491.491,0,0,0,.48-.5.485.485,0,0,0-.48-.5H6.285V15h2.57a.5.5,0,0,0,0-1H6.285V11.45h3.52a.491.491,0,0,0,.48-.5.485.485,0,0,0-.48-.5H6.285V8.06h11.43Zm1.22-12.88a.5.5,0,0,1-.5.5H5.565a.5.5,0,0,1-.5-.5v-2a1.5,1.5,0,0,1,1.5-1.5h10.87a1.5,1.5,0,0,1,1.5,1.5Z"}}]}]})(props);
	};
	module.exports.CiPizza = function CiPizza (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Pizza"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.807,13.437l-.01-.04a19.05,19.05,0,0,0-10.23-10.21,1.574,1.574,0,0,0-2.08.93l-5.32,14.69a1.58,1.58,0,0,0,1.48,2.12,1.654,1.654,0,0,0,.54-.09l14.7-5.32a1.585,1.585,0,0,0,.91-.85A1.547,1.547,0,0,0,20.807,13.437Zm-6.98,2.98a1,1,0,0,0,.2.16L4.847,19.9a.582.582,0,0,1-.6-.14.556.556,0,0,1-.14-.61l2.39-6.6a1,1,0,0,0,.16.2,1.81,1.81,0,0,0,2.56-2.56,1.782,1.782,0,0,0-1.7-.47l1.09-2.98a17.346,17.346,0,0,1,6.82,5.57,2.447,2.447,0,0,0-1.6.71A2.4,2.4,0,0,0,13.827,16.417Zm6.05-2.15a.592.592,0,0,1-.33.31l-1.32.47c-.11-.23-.22-.45-.33-.67-.12-.24-.25-.48-.38-.71-.31-.55-.65-1.08-1-1.58a18.655,18.655,0,0,0-7.57-6.3l.48-1.33a.561.561,0,0,1,.31-.33.456.456,0,0,1,.23-.05.793.793,0,0,1,.25.05,18.013,18.013,0,0,1,9.67,9.68v.02A.561.561,0,0,1,19.877,14.267Z"}},{"tag":"circle","attr":{"cx":"7.835","cy":"16.489","r":"1.075"}}]}]}]})(props);
	};
	module.exports.CiPlane = function CiPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Plane"},"child":[{"tag":"path","attr":{"d":"M11.9,20.936H10.85a.911.911,0,0,1-.9-1.023l.693-5.548H7.3l-.513.9a1.329,1.329,0,0,1-.992.657L5.1,16a.9.9,0,0,1-.8-.31.912.912,0,0,1-.185-.839l.774-2.769a.318.318,0,0,0,0-.173L4.114,9.145A.909.909,0,0,1,5.1,8l.695.083a1.331,1.331,0,0,1,.992.656l.513.9h3.34L9.946,4.088a.911.911,0,0,1,.9-1.024H11.9a1.327,1.327,0,0,1,1.236.857l2.144,5.714h1.046a8.5,8.5,0,0,1,1.758.184,2.166,2.166,0,0,1,1.429.9,2.209,2.209,0,0,1,.365,1.7A2.288,2.288,0,0,1,17.95,14.2l-.16.024a10.926,10.926,0,0,1-1.721.137h-.787l-2.144,5.714A1.327,1.327,0,0,1,11.9,20.936Zm-.951-1H11.9a.323.323,0,0,0,.3-.209l2.214-5.905a.71.71,0,0,1,.661-.457h.991a9.946,9.946,0,0,0,1.567-.125l.16-.025a1.3,1.3,0,0,0,1.1-.979,1.227,1.227,0,0,0-.2-.937,1.2,1.2,0,0,0-.793-.5,7.647,7.647,0,0,0-1.577-.167h-1.25a.711.711,0,0,1-.661-.456L12.2,4.273a.323.323,0,0,0-.3-.209h-.951l.722,5.778a.7.7,0,0,1-.7.793H7.127a.7.7,0,0,1-.614-.359l-.6-1.045a.32.32,0,0,0-.241-.16L5.113,9l.738,2.64a1.34,1.34,0,0,1,0,.711L5.113,15l.562-.067a.32.32,0,0,0,.241-.16l.6-1.049a.7.7,0,0,1,.612-.355h3.846a.7.7,0,0,1,.7.794ZM7.386,14.212l0,.005Zm3.295-.179v0Zm0-4.067v0Zm-3.3-.186,0,0Z"}}]}]})(props);
	};
	module.exports.CiPlay1 = function CiPlay1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Play_1"},"child":[{"tag":"path","attr":{"d":"M6.562,21.94a2.5,2.5,0,0,1-2.5-2.5V4.56A2.5,2.5,0,0,1,7.978,2.5L18.855,9.939a2.5,2.5,0,0,1,0,4.12L7.977,21.5A2.5,2.5,0,0,1,6.562,21.94Zm0-18.884a1.494,1.494,0,0,0-.7.177,1.477,1.477,0,0,0-.8,1.327V19.439a1.5,1.5,0,0,0,2.35,1.235l10.877-7.44a1.5,1.5,0,0,0,0-2.471L7.413,3.326A1.491,1.491,0,0,0,6.564,3.056Z"}}]}]})(props);
	};
	module.exports.CiPlug1 = function CiPlug1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Plug_1"},"child":[{"tag":"path","attr":{"d":"M17.305,5.755H15.5V2.545a.5.5,0,0,0-1,0v3.21h-5V2.545a.5.5,0,0,0-1,0v3.21H6.7a1.566,1.566,0,0,0-1.57,1.57v4.28a7.046,7.046,0,0,0,6.37,7.11v2.72a.5.5,0,0,0,1,0v-2.7a6.874,6.874,0,0,0,6.38-6.86V7.325A1.573,1.573,0,0,0,17.305,5.755Zm.57,6.12a5.875,5.875,0,0,1-6.06,5.87,6.054,6.054,0,0,1-5.69-6.14V7.325a.563.563,0,0,1,.57-.57h10.61a.57.57,0,0,1,.57.57Z"}}]}]})(props);
	};
	module.exports.CiPower = function CiPower (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Power"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M6.638,5.209a8.782,8.782,0,1,0,13.917,8.96,8.871,8.871,0,0,0-3.189-8.96c-.5-.39-1.214.312-.707.707a7.93,7.93,0,0,1,3.082,7.113,7.787,7.787,0,0,1-15.308.956A7.9,7.9,0,0,1,7.345,5.916c.507-.394-.205-1.1-.707-.707Z"}},{"tag":"path","attr":{"d":"M12.5,12.519a.5.5,0,0,1-1,0V3.548h0a.5.5,0,0,1,1,0Z"}}]}]}]})(props);
	};
	module.exports.CiRainbow = function CiRainbow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Rainbow"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M3.089,16.71A9,9,0,0,1,8.97,8.326,8.912,8.912,0,0,1,20.911,16.71a.5.5,0,0,0,1,0,10.033,10.033,0,0,0-6.46-9.291,9.981,9.981,0,0,0-11.06,2.944,10.058,10.058,0,0,0-2.3,6.347.5.5,0,0,0,1,0Z"}},{"tag":"path","attr":{"d":"M5.985,16.71A6.078,6.078,0,0,1,12,10.7a6.078,6.078,0,0,1,6.015,6.015.5.5,0,0,0,1,0A7.013,7.013,0,0,0,6.606,12.228,7.151,7.151,0,0,0,4.985,16.71a.5.5,0,0,0,1,0Z"}},{"tag":"path","attr":{"d":"M8.88,16.71a3.12,3.12,0,0,1,6.24,0,.5.5,0,0,0,1,0,4.119,4.119,0,0,0-7.255-2.669A4.219,4.219,0,0,0,7.88,16.71a.5.5,0,0,0,1,0Z"}}]}]}]})(props);
	};
	module.exports.CiRead = function CiRead (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"read"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,18.883a10.8,10.8,0,0,1-9.675-5.728,2.6,2.6,0,0,1,0-2.31A10.8,10.8,0,0,1,12,5.117a10.8,10.8,0,0,1,9.675,5.728h0a2.6,2.6,0,0,1,0,2.31A10.8,10.8,0,0,1,12,18.883ZM12,6.117a9.787,9.787,0,0,0-8.78,5.176,1.586,1.586,0,0,0,0,1.415A9.788,9.788,0,0,0,12,17.883a9.787,9.787,0,0,0,8.78-5.176,1.584,1.584,0,0,0,0-1.414h0A9.787,9.787,0,0,0,12,6.117Z"}},{"tag":"path","attr":{"d":"M12,16.049A4.049,4.049,0,1,1,16.049,12,4.054,4.054,0,0,1,12,16.049Zm0-7.1A3.049,3.049,0,1,0,15.049,12,3.052,3.052,0,0,0,12,8.951Z"}},{"tag":"circle","attr":{"cx":"12","cy":"12","r":"2.028"}}]}]}]})(props);
	};
	module.exports.CiReceipt = function CiReceipt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Receipt"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,21.919a1.454,1.454,0,0,1-.791-.232L9.645,20.666a.47.47,0,0,0-.439-.028l-1.776.829a1.466,1.466,0,0,1-1.4-.087,1.214,1.214,0,0,1-.581-1.02V3.641A1.217,1.217,0,0,1,6.033,2.62a1.469,1.469,0,0,1,1.4-.087l1.775.829a.469.469,0,0,0,.439-.026L11.21,2.313a1.464,1.464,0,0,1,1.581,0l1.564,1.022a.469.469,0,0,0,.44.026l1.775-.829a1.461,1.461,0,0,1,1.4.087,1.217,1.217,0,0,1,.581,1.021V20.36a1.216,1.216,0,0,1-.581,1.02,1.46,1.46,0,0,1-1.4.087L14.8,20.639a.474.474,0,0,0-.441.027l-1.564,1.021A1.448,1.448,0,0,1,12,21.919ZM9.4,19.6a1.44,1.44,0,0,1,.79.234l1.564,1.02a.464.464,0,0,0,.487,0l1.565-1.021a1.462,1.462,0,0,1,1.41-.095l1.774.828a.463.463,0,0,0,.437-.024.221.221,0,0,0,.118-.177V3.641a.219.219,0,0,0-.118-.177.461.461,0,0,0-.437-.025l-1.775.829a1.458,1.458,0,0,1-1.409-.095L12.243,3.151a.467.467,0,0,0-.486,0L10.192,4.172a1.467,1.467,0,0,1-1.41.1L7.007,3.439a.461.461,0,0,0-.437.025.219.219,0,0,0-.118.177V20.36a.221.221,0,0,0,.118.177.468.468,0,0,0,.437.024l1.776-.829A1.461,1.461,0,0,1,9.4,19.6Z"}},{"tag":"path","attr":{"d":"M15.046,7.4H8.954a.5.5,0,0,1,0-1h6.092a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M15.046,10.953H8.954a.5.5,0,0,1,0-1h6.092a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M12,14.5H8.954a.5.5,0,0,1,0-1H12a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiRedo = function CiRedo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Redo"},"child":[{"tag":"path","attr":{"d":"M4.061,13.67A7.958,7.958,0,0,0,16.2,19.74a8.061,8.061,0,0,0,3.77-6.77.5.5,0,0,0-1,0,6.976,6.976,0,0,1-11,5.7,6.969,6.969,0,0,1,1-11.97,10.075,10.075,0,0,1,4.64-.69V7.46a.5.5,0,0,0,.81.39l2.47-1.95a.5.5,0,0,0,0-.79L14.4,3.17a.5.5,0,0,0-.8.4V5.01c-.71-.01-1.43-.03-2.13.02a7.985,7.985,0,0,0-7.41,8.64Z"}}]}]})(props);
	};
	module.exports.CiRepeat = function CiRepeat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Repeat"},"child":[{"tag":"path","attr":{"d":"M2.078,17.562c-0.01,-0.039 -0.016,-0.08 -0.016,-0.123c0,-0.138 0.056,-0.263 0.147,-0.353c0.008,-0.009 1.416,-1.417 2,-2c0.198,-0.198 0.507,-0.183 0.707,-0c0.199,0.183 0.185,0.522 -0,0.707l-1.147,1.146l15.669,0c0.828,0 1.5,-0.671 1.5,-1.5l0,-3.439c0,-0.276 0.224,-0.5 0.5,-0.5c0.276,0 0.5,0.224 0.5,0.5l0,3.439c0,1.381 -1.12,2.5 -2.5,2.5l-15.669,0l1.147,1.147c0.198,0.198 0.183,0.507 -0,0.707c-0.183,0.199 -0.522,0.185 -0.707,-0l-2,-2c-0.066,-0.063 -0.11,-0.143 -0.131,-0.231Zm19.845,-11.105c0.01,0.039 0.015,0.08 0.015,0.122c0,0.138 -0.056,0.263 -0.147,0.354c-0.008,0.008 -1.416,1.417 -2,2c-0.197,0.198 -0.507,0.183 -0.707,-0c-0.199,-0.183 -0.185,-0.522 0,-0.707l1.147,-1.147l-15.669,0c-0.828,0 -1.5,0.672 -1.5,1.5l0,3.439c-0,0.276 -0.224,0.5 -0.5,0.5c-0.276,0 -0.5,-0.224 -0.5,-0.5l0,-3.439c0,-1.381 1.12,-2.5 2.5,-2.5l15.669,0l-1.146,-1.146c-0.198,-0.198 -0.183,-0.507 -0,-0.707c0.183,-0.199 0.522,-0.185 0.707,-0l2,2c0.065,0.063 0.11,0.143 0.131,0.231Z"}}]}]})(props);
	};
	module.exports.CiRollingSuitcase = function CiRollingSuitcase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Rolling_Suitcase"},"child":[{"tag":"path","attr":{"d":"M16.25,7.49H15V3.56a1.5,1.5,0,0,0-1.5-1.5h-3A1.511,1.511,0,0,0,9,3.56V7.49H7.75a2.5,2.5,0,0,0-2.5,2.5v8.44a2.5,2.5,0,0,0,2.5,2.5h.5v.01a1,1,0,0,0,2,0v-.01h3.5v.01a1,1,0,0,0,2,0v-.01h.5a2.5,2.5,0,0,0,2.5-2.5V9.99A2.5,2.5,0,0,0,16.25,7.49ZM10,3.56a.508.508,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5V7.5H10Zm7.75,14.87a1.5,1.5,0,0,1-1.5,1.5H7.75a1.5,1.5,0,0,1-1.5-1.5V9.99a1.511,1.511,0,0,1,1.5-1.5h8.5a1.5,1.5,0,0,1,1.5,1.5Z"}}]}]})(props);
	};
	module.exports.CiRoute = function CiRoute (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Route"},"child":[{"tag":"path","attr":{"d":"M21.792,17.086c-.58-.58-1.16-1.17-1.75-1.75-.08-.08-.16-.17-.25-.25a.492.492,0,0,0-.7,0,.5.5,0,0,0,0,.71l1.14,1.14H9.282a2.22,2.22,0,0,1,0-4.44h3a3.215,3.215,0,1,0,0-6.43H7.012a2.5,2.5,0,1,0,0,1h5.27a2.215,2.215,0,1,1,0,4.43h-3a3.22,3.22,0,1,0,0,6.44h10.96l-.9.9c-.09.08-.17.17-.25.25a.5.5,0,0,0,0,.71.511.511,0,0,0,.7,0l1.75-1.75.25-.25A.5.5,0,0,0,21.792,17.086ZM4.562,8.066a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,4.562,8.066Z"}}]}]})(props);
	};
	module.exports.CiRouter = function CiRouter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Router"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.44,10.94H17.93V4.54a.5.5,0,0,0-1,0v6.4H7.06V7a.5.5,0,0,0-1,0v3.94H4.56a2.507,2.507,0,0,0-2.5,2.5v4a2.514,2.514,0,0,0,2.5,2.5H19.44a2.507,2.507,0,0,0,2.5-2.5v-4A2.5,2.5,0,0,0,19.44,10.94Zm1.5,6.5a1.5,1.5,0,0,1-1.5,1.5H4.56a1.511,1.511,0,0,1-1.5-1.5v-4a1.5,1.5,0,0,1,1.5-1.5H19.44a1.5,1.5,0,0,1,1.5,1.5Z"}},{"tag":"circle","attr":{"cx":"4.75","cy":"15.436","r":"0.75"}},{"tag":"circle","attr":{"cx":"8.25","cy":"15.436","r":"0.75"}},{"tag":"path","attr":{"d":"M18.5,16.936h-5a1.5,1.5,0,1,1,0-3h5a1.5,1.5,0,0,1,0,3Zm-5-2a.5.5,0,1,0,0,1h5a.5.5,0,0,0,0-1Z"}}]}]}]})(props);
	};
	module.exports.CiRuler = function CiRuler (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Ruler"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M9.479,3.5a1.5,1.5,0,0,0-2.12,0L3.5,7.35a1.516,1.516,0,0,0-.44,1.06A1.5,1.5,0,0,0,3.5,9.47L14.519,20.5a1.509,1.509,0,0,0,2.13,0l3.85-3.86a1.491,1.491,0,0,0,0-2.12ZM8.359,7.08a.5.5,0,0,0,0,.71.524.524,0,0,0,.71,0c.55-.56,1.09-1.1,1.65-1.64l1.25,1.25-.9.9a.483.483,0,0,0,0,.7.5.5,0,0,0,.71,0c.29-.3.6-.6.9-.89l1.25,1.25-1.64,1.65a.495.495,0,0,0,.7.7c.56-.55,1.1-1.09,1.65-1.64l1.25,1.25-.9.9a.524.524,0,0,0-.14.36.5.5,0,0,0,.14.35.513.513,0,0,0,.71,0l.9-.9,1.26,1.26-1.65,1.64a.5.5,0,0,0,.71.71c.55-.56,1.09-1.1,1.65-1.64l1.23,1.23a.5.5,0,0,1,0,.7l-3.86,3.86a.5.5,0,0,1-.71,0L4.209,8.77a.491.491,0,0,1-.15-.36.485.485,0,0,1,.15-.35L8.069,4.2a.508.508,0,0,1,.7,0l1.24,1.24Z"}},{"tag":"path","attr":{"d":"M18.939,12.96l-.04-.04c.01,0,.01,0,.02.01S18.939,12.95,18.939,12.96Z"}}]}]}]})(props);
	};
	module.exports.CiSatellite1 = function CiSatellite1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Satellite_1"},"child":[{"tag":"path","attr":{"d":"M17.135,12.37a5.447,5.447,0,0,0,3.42-1.2.982.982,0,0,0,.37-.72,1.04,1.04,0,0,0-.31-.8l-2.78-2.78c.39-.39.8-.8,1.19-1.2.08-.07.15-.14.23-.22a.511.511,0,0,0,0-.7.5.5,0,0,0-.71,0c-.48.47-.94.94-1.42,1.41l-2.78-2.78a1.077,1.077,0,0,0-.8-.31,1,1,0,0,0-.72.37,5.454,5.454,0,0,0-1.19,3.67l-1.45,1.46L7.855,6.24a.978.978,0,0,0-1.41,0L3.365,9.32a1,1,0,0,0,0,1.41L5.7,13.06l-.41.4a2.65,2.65,0,0,0,0,3.74L6.8,18.71a2.632,2.632,0,0,0,3.74,0l.4-.4,2.33,2.33a1,1,0,0,0,1.41,0l3.08-3.09a1,1,0,0,0,0-1.41l-2.32-2.32,1.45-1.46A2.09,2.09,0,0,0,17.135,12.37ZM4.065,10.03l3.09-3.09,2.32,2.33L6.4,12.35Zm12.99,6.82-3.08,3.08-2.33-2.33,3.08-3.08Zm-5.23-8.51a5.482,5.482,0,0,0,3.84,3.83l-5.84,5.84a1.642,1.642,0,0,1-2.32,0l-1.52-1.52a1.642,1.642,0,0,1,0-2.32Zm2.12,1.71a4.417,4.417,0,0,1-.3-5.96l3.13,3.13,3.14,3.14.02.03A4.5,4.5,0,0,1,13.945,10.05Z"}}]}]})(props);
	};
	module.exports.CiSaveDown1 = function CiSaveDown1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Save_Down_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.617,6.383a7.944,7.944,0,0,1-1.748,12.568A8.028,8.028,0,0,1,4.283,13.908,8.028,8.028,0,0,1,6.378,6.391c.451-.46-.256-1.168-.707-.707A8.946,8.946,0,0,0,15.427,20.27a8.946,8.946,0,0,0,2.9-14.594c-.451-.461-1.158.247-.707.707Z"}},{"tag":"path","attr":{"d":"M15.355,10.6l-3,3a.5.5,0,0,1-.35.15.508.508,0,0,1-.36-.15l-3-3a.5.5,0,0,1,.71-.71l2.14,2.14V3.555a.508.508,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.49l2.15-2.16a.5.5,0,0,1,.71.71Z"}}]}]}]})(props);
	};
	module.exports.CiSaveDown2 = function CiSaveDown2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Save_Down_2"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.437,20.948H5.563a2.372,2.372,0,0,1-2.5-2.21v-11a2.372,2.372,0,0,1,2.5-2.211h.462a.5.5,0,0,1,0,1H5.563a1.38,1.38,0,0,0-1.5,1.211v11a1.38,1.38,0,0,0,1.5,1.21H18.437a1.38,1.38,0,0,0,1.5-1.21v-11a1.38,1.38,0,0,0-1.5-1.211h-.462a.5.5,0,0,1,0-1h.462a2.372,2.372,0,0,1,2.5,2.211v11A2.372,2.372,0,0,1,18.437,20.948Z"}},{"tag":"path","attr":{"d":"M15.355,10.592l-3,3a.5.5,0,0,1-.35.15.508.508,0,0,1-.36-.15l-3-3a.5.5,0,0,1,.71-.71l2.14,2.139V3.552a.508.508,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.49l2.15-2.16a.5.5,0,0,1,.71.71Z"}}]}]}]})(props);
	};
	module.exports.CiSaveUp1 = function CiSaveUp1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Save_Up_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.617,6.374a7.946,7.946,0,0,1-1.748,12.569A8.028,8.028,0,0,1,4.283,13.9,8.029,8.029,0,0,1,6.378,6.382c.451-.46-.256-1.168-.707-.707a8.946,8.946,0,0,0,9.756,14.587,8.946,8.946,0,0,0,2.9-14.595c-.451-.46-1.158.247-.707.707Z"}},{"tag":"path","attr":{"d":"M8.645,6.213l3-3a.5.5,0,0,1,.35-.15.508.508,0,0,1,.36.15l3,3a.5.5,0,0,1-.71.71l-2.14-2.14v8.47a.508.508,0,0,1-.5.5.5.5,0,0,1-.5-.5V4.763l-2.15,2.16a.5.5,0,0,1-.71-.71Z"}}]}]}]})(props);
	};
	module.exports.CiSaveUp2 = function CiSaveUp2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Save_Up_2"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.437,20.937H5.563a2.372,2.372,0,0,1-2.5-2.211v-11a2.372,2.372,0,0,1,2.5-2.212h.462a.5.5,0,0,1,0,1H5.563a1.381,1.381,0,0,0-1.5,1.212v11a1.38,1.38,0,0,0,1.5,1.211H18.437a1.38,1.38,0,0,0,1.5-1.211v-11a1.381,1.381,0,0,0-1.5-1.212h-.462a.5.5,0,0,1,0-1h.462a2.372,2.372,0,0,1,2.5,2.212v11A2.372,2.372,0,0,1,18.437,20.937Z"}},{"tag":"path","attr":{"d":"M8.645,6.213l3-3a.5.5,0,0,1,.35-.15.508.508,0,0,1,.36.15l3,3a.5.5,0,0,1-.71.71l-2.14-2.14v8.47a.508.508,0,0,1-.5.5.5.5,0,0,1-.5-.5V4.763l-2.15,2.16a.5.5,0,0,1-.71-.71Z"}}]}]}]})(props);
	};
	module.exports.CiSearch = function CiSearch (props) {
	  return GenIcon({"tag":"svg","attr":{"version":"1.1","id":"search","x":"0px","y":"0px","viewBox":"0 0 24 24","style":"enable-background:new 0 0 24 24;"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.031,20.79c0.46,0.46,1.17-0.25,0.71-0.7l-3.75-3.76c1.27-1.41,2.04-3.27,2.04-5.31\n\t\tc0-4.39-3.57-7.96-7.96-7.96s-7.96,3.57-7.96,7.96c0,4.39,3.57,7.96,7.96,7.96c1.98,0,3.81-0.73,5.21-1.94L20.031,20.79z\n\t\t M4.11,11.02c0-3.84,3.13-6.96,6.96-6.96c3.84,0,6.96,3.12,6.96,6.96c0,3.84-3.12,6.96-6.96,6.96C7.24,17.98,4.11,14.86,4.11,11.02\n\t\tz"}}]}]})(props);
	};
	module.exports.CiServer = function CiServer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Server"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.437,11H3.563a1.5,1.5,0,0,1-1.5-1.5V5.565a1.5,1.5,0,0,1,1.5-1.5H20.437a1.5,1.5,0,0,1,1.5,1.5v3.93A1.5,1.5,0,0,1,20.437,11ZM3.563,5.065a.5.5,0,0,0-.5.5v3.93a.5.5,0,0,0,.5.5H20.437a.5.5,0,0,0,.5-.5V5.565a.5.5,0,0,0-.5-.5Z"}},{"tag":"path","attr":{"d":"M20.437,19.935H3.563a1.5,1.5,0,0,1-1.5-1.5v-3.93a1.5,1.5,0,0,1,1.5-1.5H20.437a1.5,1.5,0,0,1,1.5,1.5v3.93A1.5,1.5,0,0,1,20.437,19.935ZM3.563,14.005a.5.5,0,0,0-.5.5v3.93a.5.5,0,0,0,.5.5H20.437a.5.5,0,0,0,.5-.5v-3.93a.5.5,0,0,0-.5-.5Z"}},{"tag":"circle","attr":{"cx":"5.563","cy":"7.53","r":"0.5"}},{"tag":"circle","attr":{"cx":"7.563","cy":"7.53","r":"0.5"}},{"tag":"path","attr":{"d":"M13.452,8.03a.5.5,0,0,1,0-1h5a.5.5,0,0,1,0,1Z"}},{"tag":"circle","attr":{"cx":"5.563","cy":"16.47","r":"0.5"}},{"tag":"circle","attr":{"cx":"7.563","cy":"16.47","r":"0.5"}},{"tag":"path","attr":{"d":"M13.452,16.97a.5.5,0,0,1,0-1h5a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiSettings = function CiSettings (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Settings"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12.6,20.936H11.3a.883.883,0,0,1-.852-.654l-.774-2.833-2.5,1.435a.886.886,0,0,1-1.06-.138l-.925-.919a.884.884,0,0,1-.143-1.066l1.469-2.545L6.509,14.2l-2.787-.747a.882.882,0,0,1-.654-.851V11.3a.882.882,0,0,1,.652-.85l2.839-.777L5.12,7.171a.885.885,0,0,1,.141-1.062l.918-.918A.885.885,0,0,1,7.24,5.049L9.792,6.514l.012,0,.745-2.79a.881.881,0,0,1,.851-.655h1.3a.883.883,0,0,1,.852.655l.762,2.838,2.509-1.441a.885.885,0,0,1,1.059.138l.926.919a.882.882,0,0,1,.141,1.067L17.483,9.777l.008.022,2.786.746a.883.883,0,0,1,.653.851v1.3a.883.883,0,0,1-.654.852l-2.837.774,1.439,2.505a.881.881,0,0,1-.141,1.063l-.917.917a.888.888,0,0,1-1.063.141l-2.539-1.462L14.2,17.5l-.745,2.785A.885.885,0,0,1,12.6,20.936Zm-1.21-1h1.119l.738-2.756a.888.888,0,0,1,.528-.592l.134-.052a.873.873,0,0,1,.76.057l2.51,1.445.789-.789-1.423-2.478a.881.881,0,0,1-.048-.78l.052-.125a.875.875,0,0,1,.584-.51l2.8-.749v-1.12l-2.755-.737a.885.885,0,0,1-.592-.529l-.052-.132a.882.882,0,0,1,.057-.763L18.04,6.818l-.8-.79-2.48,1.425a.878.878,0,0,1-.772.052l-.115-.047a.888.888,0,0,1-.518-.588l-.748-2.806H11.492l-.738,2.762a.883.883,0,0,1-.539.6l-.12.045a.874.874,0,0,1-.751-.058L6.822,5.962l-.789.789L7.455,9.227a.886.886,0,0,1,.046.785l-.051.12a.876.876,0,0,1-.579.5l-2.8.758v1.121l2.757.738a.889.889,0,0,1,.591.525l.048.121a.874.874,0,0,1-.055.77L5.958,17.181l.8.791,2.47-1.419a.878.878,0,0,1,.787-.045l.106.044a.874.874,0,0,1,.526.591ZM9.75,17.482l.008,0ZM9.6,17.421l.007,0ZM6.487,14.147h0Zm.044-4.411h0Zm7.724-3.2Z"}},{"tag":"path","attr":{"d":"M12,15a3,3,0,1,1,3-3A3,3,0,0,1,12,15Zm0-5a2,2,0,1,0,2,2A2,2,0,0,0,12,10Z"}}]}]}]})(props);
	};
	module.exports.CiShare1 = function CiShare1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Share_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12.223,11.075a.5.5,0,0,0,.7.71l7-7v3.58a.508.508,0,0,0,.5.5.5.5,0,0,0,.5-.5V3.575a.5.5,0,0,0-.5-.5h-4.79a.5.5,0,0,0,0,1h3.58Z"}},{"tag":"path","attr":{"d":"M17.876,20.926H6.124a3.053,3.053,0,0,1-3.05-3.05V6.124a3.053,3.053,0,0,1,3.05-3.05h6.028a.5.5,0,0,1,0,1H6.124a2.053,2.053,0,0,0-2.05,2.05V17.876a2.053,2.053,0,0,0,2.05,2.05H17.876a2.053,2.053,0,0,0,2.05-2.05V11.849a.5.5,0,0,1,1,0v6.027A3.053,3.053,0,0,1,17.876,20.926Z"}}]}]}]})(props);
	};
	module.exports.CiShare2 = function CiShare2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Share_2"},"child":[{"tag":"path","attr":{"d":"M18.44,15.94a2.5,2.5,0,0,0-1.96.95L7.97,12.64a2.356,2.356,0,0,0,0-1.29l8.5-4.25a2.5,2.5,0,1,0-.53-1.54,2.269,2.269,0,0,0,.09.65l-8.5,4.25a2.5,2.5,0,1,0,0,3.08l8.5,4.25a2.269,2.269,0,0,0-.09.65,2.5,2.5,0,1,0,2.5-2.5Zm0-11.88a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,18.44,4.06ZM5.56,13.5A1.5,1.5,0,1,1,7.06,12,1.5,1.5,0,0,1,5.56,13.5Zm12.88,6.44a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,18.44,19.94Z"}}]}]})(props);
	};
	module.exports.CiShirt = function CiShirt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Shirt"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M16.657,21.949H7.343a2.5,2.5,0,0,1-2.5-2.5V11.222a6.468,6.468,0,0,1,.112-1.2L5.224,8.59a5.572,5.572,0,0,0,.094-1.015V3.3a1.252,1.252,0,0,1,1.25-1.25H8.815a1.251,1.251,0,0,1,1.25,1.25V6.413a1.935,1.935,0,0,0,3.87,0V3.3a1.251,1.251,0,0,1,1.25-1.25h2.247a1.252,1.252,0,0,1,1.25,1.25V7.575a5.486,5.486,0,0,0,.1,1.015l.269,1.431a6.57,6.57,0,0,1,.111,1.2v8.227A2.5,2.5,0,0,1,16.657,21.949ZM6.568,3.051a.251.251,0,0,0-.25.25V7.575a6.543,6.543,0,0,1-.111,1.2l-.27,1.432a5.5,5.5,0,0,0-.094,1.015v8.227a1.5,1.5,0,0,0,1.5,1.5h9.314a1.5,1.5,0,0,0,1.5-1.5V11.222a5.519,5.519,0,0,0-.094-1.016l-.269-1.43a6.453,6.453,0,0,1-.112-1.2V3.3a.251.251,0,0,0-.25-.25H15.185a.251.251,0,0,0-.25.25V6.413a2.935,2.935,0,0,1-5.87,0V3.3a.251.251,0,0,0-.25-.25Z"}},{"tag":"path","attr":{"d":"M11.986,17.333V13.874a.075.075,0,0,0-.114-.064l-.638.392a.149.149,0,0,1-.228-.128v-.65a.3.3,0,0,1,.145-.258l.764-.457a.3.3,0,0,1,.154-.043H12.7a.3.3,0,0,1,.3.3v4.367a.3.3,0,0,1-.3.3h-.409A.3.3,0,0,1,11.986,17.333Z"}}]}]}]})(props);
	};
	module.exports.CiShop = function CiShop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Shop"},"child":[{"tag":"path","attr":{"d":"M20.6,5.26a2.512,2.512,0,0,0-2.48-2.2H5.885a2.512,2.512,0,0,0-2.48,2.19l-.3,2.47a3.411,3.411,0,0,0,1.16,2.56v8.16a2.5,2.5,0,0,0,2.5,2.5h10.47a2.5,2.5,0,0,0,2.5-2.5V10.28A3.411,3.411,0,0,0,20.9,7.72Zm-6.59,14.68h-4V15.86a1.5,1.5,0,0,1,1.5-1.5h1a1.5,1.5,0,0,1,1.5,1.5Zm4.73-1.5a1.5,1.5,0,0,1-1.5,1.5h-2.23V15.86a2.5,2.5,0,0,0-2.5-2.5h-1a2.5,2.5,0,0,0-2.5,2.5v4.08H6.765a1.5,1.5,0,0,1-1.5-1.5V10.87a3.223,3.223,0,0,0,1.24.24,3.358,3.358,0,0,0,2.58-1.19.241.241,0,0,1,.34,0,3.358,3.358,0,0,0,2.58,1.19A3.393,3.393,0,0,0,14.6,9.92a.219.219,0,0,1,.16-.07.238.238,0,0,1,.17.07,3.358,3.358,0,0,0,2.58,1.19,3.173,3.173,0,0,0,1.23-.24Zm-1.23-8.33a2.386,2.386,0,0,1-1.82-.83,1.2,1.2,0,0,0-.92-.43h-.01a1.194,1.194,0,0,0-.92.42,2.476,2.476,0,0,1-3.65,0,1.24,1.24,0,0,0-1.86,0A2.405,2.405,0,0,1,4.1,7.78l.3-2.4a1.517,1.517,0,0,1,1.49-1.32h12.23a1.5,1.5,0,0,1,1.49,1.32l.29,2.36A2.392,2.392,0,0,1,17.505,10.11Z"}}]}]})(props);
	};
	module.exports.CiShoppingBasket = function CiShoppingBasket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Shopping_Basket"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.44,7.937H17.3l-1.21-4.51a.508.508,0,0,0-.61-.35.489.489,0,0,0-.35.61l1.14,4.25H7.74l1.14-4.25a.5.5,0,0,0-.36-.61.513.513,0,0,0-.61.35l-1.2,4.51H4.56a1.5,1.5,0,0,0-.32,2.96l.74,7.77a2.492,2.492,0,0,0,2.49,2.27h9.06a2.492,2.492,0,0,0,2.49-2.27l.74-7.77a1.5,1.5,0,0,0-.32-2.96Zm-1.41,10.64a1.5,1.5,0,0,1-1.5,1.36H7.47a1.5,1.5,0,0,1-1.5-1.36l-.72-7.64h13.5Zm1.41-8.64H4.56a.508.508,0,0,1-.5-.5.5.5,0,0,1,.5-.5H19.44a.5.5,0,0,1,.5.5A.508.508,0,0,1,19.44,9.937Z"}},{"tag":"path","attr":{"d":"M9.5,17.432a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,1,0v3A.5.5,0,0,1,9.5,17.432Z"}},{"tag":"path","attr":{"d":"M14.5,17.432a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,1,0v3A.5.5,0,0,1,14.5,17.432Z"}}]}]}]})(props);
	};
	module.exports.CiShoppingCart = function CiShoppingCart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Shopping_Cart"},"child":[{"tag":"path","attr":{"d":"M17.437,19.934c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1Zm-11.217,-4.266l-0.945,-10.9c-0.03,-0.391 -0.356,-0.693 -0.749,-0.693l-0.966,-0c-0.276,-0 -0.5,-0.224 -0.5,-0.5c0,-0.276 0.224,-0.5 0.5,-0.5l0.966,-0c0.916,-0 1.676,0.704 1.746,1.617l0.139,1.818l13.03,-0c0.885,-0 1.577,0.76 1.494,1.638l-0.668,7.52c-0.121,1.285 -1.199,2.267 -2.489,2.267l-9.069,0c-1.29,0 -2.367,-0.981 -2.489,-2.267Zm0.274,-8.158l0.722,8.066c0.073,0.77 0.719,1.359 1.493,1.359l9.069,0c0.774,0 1.42,-0.589 1.493,-1.359l0.668,-7.518c0.028,-0.294 -0.203,-0.548 -0.498,-0.548l-12.947,-0Zm4.454,12.424c-0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1c-0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1Z"}}]}]})(props);
	};
	module.exports.CiShoppingTag = function CiShoppingTag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Shopping_Tag"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.605,5.988a2.8,2.8,0,0,0-2.6-2.59l-4.56-.32a2.842,2.842,0,0,0-2.17.81L3.9,11.278a2.794,2.794,0,0,0,0,3.95l4.87,4.88a2.8,2.8,0,0,0,3.96,0l7.38-7.39a2.779,2.779,0,0,0,.81-2.17ZM12.015,19.4a1.8,1.8,0,0,1-2.54,0l-4.87-4.87a1.793,1.793,0,0,1,0-2.55l1.17-1.17,7.42,7.42Zm7.38-7.38-5.5,5.5L6.485,10.1l5.5-5.5a1.786,1.786,0,0,1,1.27-.53c.04,0,.08.01.12.01l4.56.32a1.8,1.8,0,0,1,1.67,1.66l.32,4.56A1.829,1.829,0,0,1,19.4,12.018Z"}},{"tag":"circle","attr":{"cx":"17","cy":"6.999","r":"0.862"}}]}]}]})(props);
	};
	module.exports.CiShuffle = function CiShuffle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Shuffle"},"child":[{"tag":"path","attr":{"d":"M21.794,17.082a.513.513,0,0,1,0,.71c-.08.08-.17.16-.25.25-.58.58-1.17,1.16-1.75,1.75a.5.5,0,0,1-.71-.71c.09-.08.17-.17.25-.25l.9-.9h-3.85a2.509,2.509,0,0,1-2.15-1.21L12,12.982l-2.24,3.74a2.509,2.509,0,0,1-2.15,1.21H2.564a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h5.05A1.507,1.507,0,0,0,8.9,16.2l2.51-4.2L8.9,7.792a1.507,1.507,0,0,0-1.29-.73H2.564a.5.5,0,0,1,0-1h5.05a2.518,2.518,0,0,1,2.15,1.22L12,11.032l2.24-3.75a2.489,2.489,0,0,1,2.14-1.22h3.85l-1.15-1.15a.5.5,0,1,1,.71-.7c.08.08.17.16.25.25.58.58,1.17,1.16,1.75,1.75a.5.5,0,0,1,0,.7c-.08.09-.17.17-.25.25-.58.59-1.17,1.17-1.75,1.75a.5.5,0,1,1-.71-.7l.25-.25.9-.9h-3.85a1.519,1.519,0,0,0-1.29.73L12.584,12l2.51,4.2a1.519,1.519,0,0,0,1.29.73h3.84l-1.14-1.14a.5.5,0,0,1,.71-.71Z"}}]}]})(props);
	};
	module.exports.CiSignpostDuo1 = function CiSignpostDuo1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Signpost_Duo_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.437,11.5H6.536a2.628,2.628,0,0,1-1.723-.629L2.564,8.915A1.329,1.329,0,0,1,2.57,6.831L4.813,4.88a2.619,2.619,0,0,1,1.723-.629h13.9a1.451,1.451,0,0,1,1.5,1.393v4.463A1.451,1.451,0,0,1,20.437,11.5Zm-13.9-6.25a1.64,1.64,0,0,0-1.067.384L3.215,7.6a.364.364,0,0,0-.152.281.349.349,0,0,0,.141.27l.011.01,2.254,1.961a1.644,1.644,0,0,0,1.067.384h13.9a.463.463,0,0,0,.5-.394V5.644a.463.463,0,0,0-.5-.393Z"}},{"tag":"path","attr":{"d":"M17.464,19.749H3.563a1.451,1.451,0,0,1-1.5-1.394V13.892a1.451,1.451,0,0,1,1.5-1.393h13.9a2.621,2.621,0,0,1,1.724.63l2.249,1.956a1.329,1.329,0,0,1-.007,2.083l-2.242,1.951A2.625,2.625,0,0,1,17.464,19.749ZM3.563,13.5a.463.463,0,0,0-.5.393v4.463a.463.463,0,0,0,.5.394h13.9a1.644,1.644,0,0,0,1.068-.385l2.253-1.96a.362.362,0,0,0,.152-.28.351.351,0,0,0-.141-.271l-.011-.01-2.254-1.96a1.64,1.64,0,0,0-1.067-.384Z"}}]}]}]})(props);
	};
	module.exports.CiSignpostL1 = function CiSignpostL1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Signpost_L_1"},"child":[{"tag":"path","attr":{"d":"M20.437,16H6.536a2.489,2.489,0,0,1-1.744-.709L2.542,13.1a1.5,1.5,0,0,1,.007-2.2L4.792,8.709A2.483,2.483,0,0,1,6.536,8h13.9a1.5,1.5,0,0,1,1.5,1.5v5A1.5,1.5,0,0,1,20.437,16ZM6.536,9a1.491,1.491,0,0,0-1.046.425l-2.255,2.2A.5.5,0,0,0,3.063,12a.494.494,0,0,0,.162.369l.01.01,2.254,2.2A1.492,1.492,0,0,0,6.536,15h13.9a.5.5,0,0,0,.5-.5v-5a.5.5,0,0,0-.5-.5Z"}}]}]})(props);
	};
	module.exports.CiSignpostR1 = function CiSignpostR1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Signpost_R_1"},"child":[{"tag":"path","attr":{"d":"M3.563,8h13.9a2.489,2.489,0,0,1,1.744.709l2.25,2.192a1.5,1.5,0,0,1-.007,2.2l-2.243,2.187A2.483,2.483,0,0,1,17.464,16H3.563a1.5,1.5,0,0,1-1.5-1.5v-5A1.5,1.5,0,0,1,3.563,8Zm13.9,7a1.491,1.491,0,0,0,1.046-.425l2.255-2.2A.5.5,0,0,0,20.937,12a.494.494,0,0,0-.162-.369l-.01-.01-2.254-2.2A1.492,1.492,0,0,0,17.464,9H3.563a.5.5,0,0,0-.5.5v5a.5.5,0,0,0,.5.5Z"}}]}]})(props);
	};
	module.exports.CiSliderHorizontal = function CiSliderHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Slider_Horizontal"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M21.45,7.5H9.99A2,2,0,0,0,8.06,6h-1A2,2,0,0,0,5.13,7.5H2.55a.5.5,0,0,0-.5.5.508.508,0,0,0,.5.5H5.13A2,2,0,0,0,7.06,10h1A2,2,0,0,0,9.99,8.5H21.45A.5.5,0,0,0,21.45,7.5ZM8.06,9h-1a1.006,1.006,0,0,1-1-.98V8a1,1,0,0,1,1-1h1a1,1,0,1,1,0,2Z"}},{"tag":"path","attr":{"d":"M21.45,15.5H18.87A2,2,0,0,0,16.94,14h-1a2,2,0,0,0-1.93,1.5H2.55a.5.5,0,0,0,0,1H14.01A2,2,0,0,0,15.94,18h1a2,2,0,0,0,1.93-1.5h2.58a.5.5,0,0,0,.5-.5A.508.508,0,0,0,21.45,15.5Zm-3.51.5a1,1,0,0,1-1,1h-1a1,1,0,1,1,0-2h1a1.006,1.006,0,0,1,1,.98Z"}}]}]}]})(props);
	};
	module.exports.CiSliderVertical = function CiSliderVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Slider_Vertical"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M8.5,5.13V2.55a.5.5,0,0,0-.5-.5.508.508,0,0,0-.5.5V5.13A2,2,0,0,0,6,7.06v1A2,2,0,0,0,7.5,9.99V21.45a.5.5,0,0,0,1,0V9.99A2,2,0,0,0,10,8.06v-1A2,2,0,0,0,8.5,5.13ZM9,8.06a1,1,0,1,1-2,0v-1a1.006,1.006,0,0,1,.98-1H8a1,1,0,0,1,1,1Z"}},{"tag":"path","attr":{"d":"M16.5,14.01V2.55a.5.5,0,0,0-1,0V14.01A2,2,0,0,0,14,15.94v1a2,2,0,0,0,1.5,1.93v2.58a.5.5,0,0,0,.5.5.508.508,0,0,0,.5-.5V18.87A2,2,0,0,0,18,16.94v-1A2,2,0,0,0,16.5,14.01Zm.5,2.93a1.006,1.006,0,0,1-.98,1H16a1,1,0,0,1-1-1v-1a1,1,0,1,1,2,0Z"}}]}]}]})(props);
	};
	module.exports.CiSpeaker = function CiSpeaker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Speaker"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.437,21.938H6.562a2.5,2.5,0,0,1-2.5-2.5V4.562a2.5,2.5,0,0,1,2.5-2.5H17.437a2.5,2.5,0,0,1,2.5,2.5V19.438A2.5,2.5,0,0,1,17.437,21.938ZM6.562,3.062a1.5,1.5,0,0,0-1.5,1.5V19.438a1.5,1.5,0,0,0,1.5,1.5H17.437a1.5,1.5,0,0,0,1.5-1.5V4.562a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M12,18.939a3.75,3.75,0,1,1,3.75-3.75A3.755,3.755,0,0,1,12,18.939Zm0-6.5a2.75,2.75,0,1,0,2.75,2.75A2.752,2.752,0,0,0,12,12.439Z"}},{"tag":"path","attr":{"d":"M12,9.563a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,12,9.563Zm0-3.5a1.25,1.25,0,1,0,1.25,1.25A1.251,1.251,0,0,0,12,6.063Z"}}]}]}]})(props);
	};
	module.exports.CiSquareAlert = function CiSquareAlert (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_Alert"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.437,20.936H5.562a2.5,2.5,0,0,1-2.5-2.5V5.562a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.436A2.5,2.5,0,0,1,18.437,20.936ZM5.562,4.062a1.5,1.5,0,0,0-1.5,1.5V18.436a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.562a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M11.5,10.982a.5.5,0,0,1,1,0V15h0a.5.5,0,0,1-1,0Z"}},{"tag":"circle","attr":{"cx":"12","cy":"9","r":"0.5"}}]}]}]}]})(props);
	};
	module.exports.CiSquareCheck = function CiSquareCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_Check"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.437,20.939H5.563a2.5,2.5,0,0,1-2.5-2.5V5.566a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.439A2.5,2.5,0,0,1,18.437,20.939ZM5.563,4.066a1.5,1.5,0,0,0-1.5,1.5V18.439a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.566a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M15.81,10.4c.45-.46-.26-1.17-.71-.71l-3.56,3.56c-.58-.58-1.16-1.15-1.73-1.73a.5.5,0,0,0-.71.71l2.08,2.08a.513.513,0,0,0,.71,0Z"}}]}]}]})(props);
	};
	module.exports.CiSquareChevDown = function CiSquareChevDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_Chev_Down"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M8.65,10.85a.495.495,0,0,1,.7-.7L12,12.79l2.65-2.64a.495.495,0,0,1,.7.7l-3,3a.492.492,0,0,1-.7,0Z"}},{"tag":"path","attr":{"d":"M3.063,18.437V5.563a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.437a2.5,2.5,0,0,1-2.5,2.5H5.563A2.5,2.5,0,0,1,3.063,18.437ZM19.937,5.563a1.5,1.5,0,0,0-1.5-1.5H5.563a1.5,1.5,0,0,0-1.5,1.5V18.437a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiSquareChevLeft = function CiSquareChevLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_Chev_Left"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M11.21,12l2.64,2.65a.495.495,0,0,1-.7.7c-.13-.12-.25-.24-.38-.37-.87-.87-1.75-1.75-2.62-2.63a.492.492,0,0,1,0-.7l3-3a.495.495,0,0,1,.7.7Z"}},{"tag":"path","attr":{"d":"M18.437,20.939H5.562a2.5,2.5,0,0,1-2.5-2.5V5.566a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.439A2.5,2.5,0,0,1,18.437,20.939ZM5.562,4.066a1.5,1.5,0,0,0-1.5,1.5V18.439a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.566a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiSquareChevRight = function CiSquareChevRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_Chev_Right"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M10.85,15.35a.495.495,0,0,1-.7-.7L12.79,12,10.15,9.35a.495.495,0,0,1,.7-.7l3,3a.492.492,0,0,1,0,.7Z"}},{"tag":"path","attr":{"d":"M18.437,20.937H5.563a2.5,2.5,0,0,1-2.5-2.5V5.563a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.437A2.5,2.5,0,0,1,18.437,20.937ZM5.563,4.063a1.5,1.5,0,0,0-1.5,1.5V18.437a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.563a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiSquareChevUp = function CiSquareChevUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_Chev_Up"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M15.35,13.15a.495.495,0,0,1-.7.7L12,11.21,9.35,13.85a.495.495,0,0,1-.7-.7l3-3a.492.492,0,0,1,.7,0Z"}},{"tag":"path","attr":{"d":"M20.937,5.563V18.437a2.5,2.5,0,0,1-2.5,2.5H5.563a2.5,2.5,0,0,1-2.5-2.5V5.563a2.5,2.5,0,0,1,2.5-2.5H18.437A2.5,2.5,0,0,1,20.937,5.563ZM4.063,18.437a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.563a1.5,1.5,0,0,0-1.5-1.5H5.563a1.5,1.5,0,0,0-1.5,1.5Z"}}]}]}]})(props);
	};
	module.exports.CiSquareInfo = function CiSquareInfo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_Info"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.438,20.937H5.564a2.5,2.5,0,0,1-2.5-2.5V5.563a2.5,2.5,0,0,1,2.5-2.5H18.438a2.5,2.5,0,0,1,2.5,2.5V18.437A2.5,2.5,0,0,1,18.438,20.937ZM5.564,4.063a1.5,1.5,0,0,0-1.5,1.5V18.437a1.5,1.5,0,0,0,1.5,1.5H18.438a1.5,1.5,0,0,0,1.5-1.5V5.563a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12.5,9a.5.5,0,0,0-1,0h0v4.018a.5.5,0,0,0,1,0Z"}},{"tag":"circle","attr":{"cx":"12","cy":"14.999","r":"0.5"}}]}]}]}]})(props);
	};
	module.exports.CiSquareMinus = function CiSquareMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_Minus"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.438,20.938H5.564a2.5,2.5,0,0,1-2.5-2.5V5.564a2.5,2.5,0,0,1,2.5-2.5H18.438a2.5,2.5,0,0,1,2.5,2.5V18.438A2.5,2.5,0,0,1,18.438,20.938ZM5.564,4.064a1.5,1.5,0,0,0-1.5,1.5V18.438a1.5,1.5,0,0,0,1.5,1.5H18.438a1.5,1.5,0,0,0,1.5-1.5V5.564a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M9,12.5a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiSquareMore = function CiSquareMore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_More"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.437,20.938H5.562a2.5,2.5,0,0,1-2.5-2.5V5.565a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.438A2.5,2.5,0,0,1,18.437,20.938ZM5.562,4.065a1.5,1.5,0,0,0-1.5,1.5V18.438a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.565a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"circle","attr":{"cx":"11.999","cy":"12.002","r":"1"}},{"tag":"circle","attr":{"cx":"15.999","cy":"12.002","r":"1"}},{"tag":"circle","attr":{"cx":"7.999","cy":"12.002","r":"1"}}]}]}]})(props);
	};
	module.exports.CiSquarePlus = function CiSquarePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_Plus"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.438,20.938H5.563a2.5,2.5,0,0,1-2.5-2.5V5.564a2.5,2.5,0,0,1,2.5-2.5H18.438a2.5,2.5,0,0,1,2.5,2.5V18.438A2.5,2.5,0,0,1,18.438,20.938ZM5.563,4.064a1.5,1.5,0,0,0-1.5,1.5V18.438a1.5,1.5,0,0,0,1.5,1.5H18.438a1.5,1.5,0,0,0,1.5-1.5V5.564a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M15,12.5H12.5V15a.5.5,0,0,1-1,0V12.5H9a.5.5,0,0,1,0-1h2.5V9a.5.5,0,0,1,1,0v2.5H15A.5.5,0,0,1,15,12.5Z"}}]}]}]})(props);
	};
	module.exports.CiSquareQuestion = function CiSquareQuestion (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_Question"},"child":[{"tag":"g","attr":{},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M11.41,12.461a1.555,1.555,0,0,1,.341-.6,2.68,2.68,0,0,1,.535-.417,2.2,2.2,0,0,0,.363-.285,1.218,1.218,0,0,0,.256-.364A1.083,1.083,0,0,0,13,10.344a.927.927,0,0,0-.142-.518.946.946,0,0,0-.374-.338,1.135,1.135,0,0,0-.519-.119,1.188,1.188,0,0,0-.5.107.934.934,0,0,0-.389.335.884.884,0,0,0-.111.224.515.515,0,0,1-.483.359h0a.506.506,0,0,1-.479-.675,1.653,1.653,0,0,1,.178-.348,1.789,1.789,0,0,1,.748-.634,2.609,2.609,0,0,1,2.113.015,1.733,1.733,0,0,1,.721.642,1.766,1.766,0,0,1,.257.959,1.833,1.833,0,0,1-.118.678,1.674,1.674,0,0,1-.334.536,2.289,2.289,0,0,1-.52.417,2.245,2.245,0,0,0-.462.37,1.1,1.1,0,0,0-.256.454,2.344,2.344,0,0,0-.045.283.486.486,0,0,1-.483.429h0a.484.484,0,0,1-.483-.53A2.928,2.928,0,0,1,11.41,12.461Z"}},{"tag":"circle","attr":{"cx":"11.792","cy":"14.894","r":"0.587"}}]},{"tag":"path","attr":{"d":"M18.438,20.938H5.563a2.5,2.5,0,0,1-2.5-2.5V5.564a2.5,2.5,0,0,1,2.5-2.5H18.438a2.5,2.5,0,0,1,2.5,2.5V18.438A2.5,2.5,0,0,1,18.438,20.938ZM5.563,4.064a1.5,1.5,0,0,0-1.5,1.5V18.438a1.5,1.5,0,0,0,1.5,1.5H18.438a1.5,1.5,0,0,0,1.5-1.5V5.564a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]}]})(props);
	};
	module.exports.CiSquareRemove = function CiSquareRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Square_Remove"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.437,20.937H5.563a2.5,2.5,0,0,1-2.5-2.5V5.563a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.437A2.5,2.5,0,0,1,18.437,20.937ZM5.563,4.063a1.5,1.5,0,0,0-1.5,1.5V18.437a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.563a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M13.767,14.477a.5.5,0,0,0,.71-.71L12.707,12l1.77-1.77a.5.5,0,0,0-.71-.7L12,11.3l-1.77-1.77a.5.5,0,0,0-.7.7c.59.59,1.17,1.18,1.77,1.77l-1.77,1.77c-.46.45.25,1.16.7.71L12,12.707Z"}}]}]}]})(props);
	};
	module.exports.CiStar = function CiStar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Star"},"child":[{"tag":"path","attr":{"d":"M16.6,20.463a1.5,1.5,0,0,1-.7-.174l-3.666-1.927a.5.5,0,0,0-.464,0L8.1,20.289a1.5,1.5,0,0,1-2.177-1.581l.7-4.082a.5.5,0,0,0-.143-.442L3.516,11.293a1.5,1.5,0,0,1,.832-2.559l4.1-.6a.5.5,0,0,0,.376-.273l1.833-3.714a1.5,1.5,0,0,1,2.69,0l1.833,3.714a.5.5,0,0,0,.376.274l4.1.6a1.5,1.5,0,0,1,.832,2.559l-2.965,2.891a.5.5,0,0,0-.144.442l.7,4.082A1.5,1.5,0,0,1,16.6,20.463Zm-3.9-2.986L16.364,19.4a.5.5,0,0,0,.725-.527l-.7-4.082a1.5,1.5,0,0,1,.432-1.328l2.965-2.89a.5.5,0,0,0-.277-.853l-4.1-.6a1.5,1.5,0,0,1-1.13-.821L12.449,4.594a.516.516,0,0,0-.9,0L9.719,8.308a1.5,1.5,0,0,1-1.13.82l-4.1.6a.5.5,0,0,0-.277.853L7.18,13.468A1.5,1.5,0,0,1,7.611,14.8l-.7,4.082a.5.5,0,0,0,.726.527L11.3,17.477a1.5,1.5,0,0,1,1.4,0Z"}}]}]})(props);
	};
	module.exports.CiStethoscope = function CiStethoscope (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Stethoscope"},"child":[{"tag":"path","attr":{"d":"M18.185,9.256a2.748,2.748,0,0,0-.5,5.45v2.31a2.923,2.923,0,0,1-2.92,2.92h-2.78a2.923,2.923,0,0,1-2.92-2.92v-.98a5.5,5.5,0,0,0,5-5.47V5.286a1.483,1.483,0,0,0-1.03-1.42l-2.31-.78a.5.5,0,0,0-.63.32.491.491,0,0,0,.31.63l2.32.78a.486.486,0,0,1,.34.47v5.28a4.5,4.5,0,0,1-9,0V5.286a.486.486,0,0,1,.34-.47l2.32-.78a.491.491,0,0,0,.31-.63.5.5,0,0,0-.63-.32l-2.31.78a1.483,1.483,0,0,0-1.03,1.42v5.28a5.5,5.5,0,0,0,5,5.47v.98a3.926,3.926,0,0,0,3.92,3.92h2.78a3.926,3.926,0,0,0,3.92-3.92v-2.31a2.748,2.748,0,0,0-.5-5.45Zm0,4.5a1.75,1.75,0,1,1,1.75-1.75A1.758,1.758,0,0,1,18.185,13.756Z"}}]}]})(props);
	};
	module.exports.CiStickyNote = function CiStickyNote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Sticky_Note"},"child":[{"tag":"path","attr":{"d":"M18.44,3.065H5.56a2.507,2.507,0,0,0-2.5,2.5v12.87a2.507,2.507,0,0,0,2.5,2.5h8.68A2.482,2.482,0,0,0,16,20.2l4.21-4.2a2.505,2.505,0,0,0,.73-1.77V5.565A2.5,2.5,0,0,0,18.44,3.065Zm-4.38,13.5v3.37H5.56a1.5,1.5,0,0,1-1.5-1.5V5.565a1.5,1.5,0,0,1,1.5-1.5H18.44a1.5,1.5,0,0,1,1.5,1.5v8.5H16.56A2.507,2.507,0,0,0,14.06,16.565Zm1,3.13v-3.13a1.5,1.5,0,0,1,1.5-1.5h3.13Z"}}]}]})(props);
	};
	module.exports.CiStop1 = function CiStop1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Stop_1"},"child":[{"tag":"path","attr":{"d":"M18.437,20.937H5.563a2.5,2.5,0,0,1-2.5-2.5V5.563a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.437A2.5,2.5,0,0,1,18.437,20.937ZM5.563,4.063a1.5,1.5,0,0,0-1.5,1.5V18.437a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.563a1.5,1.5,0,0,0-1.5-1.5Z"}}]}]})(props);
	};
	module.exports.CiStopSign1 = function CiStopSign1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Stop_Sign_1"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12.531,15.688H10.14a.5.5,0,0,1,0-1h2.391a1.094,1.094,0,0,0,0-2.188H11.468a2.094,2.094,0,0,1,0-4.188h2.391a.5.5,0,0,1,0,1H11.468a1.094,1.094,0,0,0,0,2.188h1.063a2.094,2.094,0,0,1,0,4.188Z"}},{"tag":"path","attr":{"d":"M15.079,21.933H8.92A2.482,2.482,0,0,1,7.153,21.2L2.8,16.847a2.484,2.484,0,0,1-.732-1.768V8.921A2.486,2.486,0,0,1,2.8,7.153L7.153,2.8A2.482,2.482,0,0,1,8.92,2.067h6.159a2.482,2.482,0,0,1,1.767.732L21.2,7.154a2.482,2.482,0,0,1,.732,1.767v6.158a2.491,2.491,0,0,1-.731,1.768L16.846,21.2A2.482,2.482,0,0,1,15.079,21.933ZM8.92,3.067a1.511,1.511,0,0,0-1.06.439L3.506,7.861a1.489,1.489,0,0,0-.439,1.06v6.158a1.491,1.491,0,0,0,.439,1.061L7.86,20.494a1.511,1.511,0,0,0,1.06.439h6.159a1.511,1.511,0,0,0,1.06-.439l4.355-4.354a1.494,1.494,0,0,0,.439-1.061V8.921a1.511,1.511,0,0,0-.439-1.06L16.139,3.506a1.511,1.511,0,0,0-1.06-.439Z"}}]}]}]})(props);
	};
	module.exports.CiStopwatch = function CiStopwatch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Stopwatch"},"child":[{"tag":"path","attr":{"d":"M17.925,7.828c1.226,1.391 1.97,3.217 1.97,5.215c0,4.358 -3.537,7.895 -7.895,7.895c-4.358,0 -7.896,-3.537 -7.896,-7.895c0,-4.189 3.271,-7.621 7.396,-7.879l0,-1.103l-1.587,0c-0.645,0 -0.643,-1 -0,-1l4.174,0c0.645,0 0.644,1 -0,1l-1.587,0l0,1.103c1.803,0.113 3.443,0.832 4.718,1.956c0.378,-0.378 0.756,-0.756 1.135,-1.134c0.197,-0.198 0.507,-0.183 0.707,-0c0.199,0.183 0.185,0.522 -0,0.707l-1.135,1.135Zm0.97,5.215c0,-3.805 -3.089,-6.895 -6.895,-6.895c-3.806,0.001 -6.896,3.09 -6.896,6.895c0,3.806 3.09,6.895 6.896,6.895c3.806,0 6.895,-3.089 6.895,-6.895Zm-6.395,0.001c0,0.645 -1,0.643 -1,-0l0,-4.704c0,-0.644 1,-0.643 1,-0l0,4.704Z"}}]}]})(props);
	};
	module.exports.CiStreamOff = function CiStreamOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Stream_Off"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M4.911,4.206c-.45-.45-1.16.26-.71.71l.32.32v.01A10.646,10.646,0,0,0,5.541,19.8c.48.43,1.19-.28.71-.71a9.623,9.623,0,0,1-1.01-13.13l2.27,2.27a6.022,6.022,0,0,0,.61,8.18c.48.44,1.19-.27.71-.7a5.024,5.024,0,0,1-.61-6.77l2.61,2.61a1.13,1.13,0,0,0-.09.45,1.248,1.248,0,0,0,1.25,1.24,1.13,1.13,0,0,0,.45-.09l4.77,4.77.86.86a3.024,3.024,0,0,1-.31.31.355.355,0,0,0-.11.16.406.406,0,0,0-.04.19.381.381,0,0,0,.04.19.386.386,0,0,0,.11.17.5.5,0,0,0,.35.14.585.585,0,0,0,.13-.02.432.432,0,0,0,.22-.12c.11-.1.22-.2.32-.3.1.09.19.19.29.29.45.45,1.16-.26.71-.71Z"}},{"tag":"path","attr":{"d":"M17.73,4.908a9.624,9.624,0,0,1,2.3,11.1c-.265.582.6,1.09.864.505A10.647,10.647,0,0,0,18.438,4.2c-.475-.433-1.185.272-.708.707Z"}},{"tag":"path","attr":{"d":"M15.15,8.291a5.016,5.016,0,0,1,1.6,4.572.515.515,0,0,0,.349.615.5.5,0,0,0,.615-.349,6.042,6.042,0,0,0-1.852-5.546c-.476-.431-1.185.274-.708.708Z"}}]}]}]})(props);
	};
	module.exports.CiStreamOn = function CiStreamOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Stream_On"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M6.26,19.089A9.625,9.625,0,0,1,6.234,4.911C6.709,4.475,6,3.769,5.527,4.2A10.516,10.516,0,0,0,5.553,19.8c.475.433,1.184-.273.707-.707Z"}},{"tag":"path","attr":{"d":"M8.84,15.706a5.024,5.024,0,0,1-.014-7.412c.474-.437-.234-1.143-.707-.707a6.028,6.028,0,0,0,.014,8.826c.474.434,1.183-.272.707-.707Z"}},{"tag":"circle","attr":{"cx":"12","cy":"12","r":"1.244"}},{"tag":"path","attr":{"d":"M17.74,4.911a9.625,9.625,0,0,1,.026,14.178c-.475.436.234,1.142.707.707A10.516,10.516,0,0,0,18.447,4.2c-.475-.433-1.184.273-.707.707Z"}},{"tag":"path","attr":{"d":"M15.16,8.294a5.024,5.024,0,0,1,.014,7.412c-.474.437.234,1.143.707.707a6.028,6.028,0,0,0-.014-8.826c-.474-.434-1.183.272-.707.707Z"}}]}]}]})(props);
	};
	module.exports.CiSun = function CiSun (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Sun"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12,20.937a1.074,1.074,0,0,1-.94-.542L9.61,17.9a.084.084,0,0,0-.1-.041L6.728,18.6A1.087,1.087,0,0,1,5.4,17.272l.748-2.8a.088.088,0,0,0-.041-.1l-2.5-1.439a1.086,1.086,0,0,1,0-1.881L6.1,9.61a.087.087,0,0,0,.041-.1L5.4,6.728A1.087,1.087,0,0,1,6.728,5.4l2.8.748a.091.091,0,0,0,.1-.041l1.439-2.5A1.076,1.076,0,0,1,12,3.063h0a1.074,1.074,0,0,1,.94.542L14.39,6.1a.084.084,0,0,0,.1.041L17.272,5.4A1.087,1.087,0,0,1,18.6,6.728l-.748,2.8a.087.087,0,0,0,.041.1l2.5,1.439a1.086,1.086,0,0,1,0,1.881L17.9,14.39a.089.089,0,0,0-.041.1l.748,2.784A1.087,1.087,0,0,1,17.272,18.6l-2.8-.748a.089.089,0,0,0-.1.041l-1.439,2.5a1.076,1.076,0,0,1-.94.544ZM9.534,16.853a1.091,1.091,0,0,1,.942.541l1.448,2.5a.082.082,0,0,0,.075.043h0a.081.081,0,0,0,.074-.043l1.44-2.5a1.083,1.083,0,0,1,1.221-.507l2.8.747a.087.087,0,0,0,.106-.106l-.747-2.785a1.089,1.089,0,0,1,.5-1.222l2.5-1.448a.086.086,0,0,0,0-.15l-2.5-1.439a1.086,1.086,0,0,1-.507-1.221l.747-2.8a.08.08,0,0,0-.022-.083.086.086,0,0,0-.085-.023l-2.784.747a1.088,1.088,0,0,1-1.222-.5l-1.448-2.5A.082.082,0,0,0,12,4.063h0a.081.081,0,0,0-.074.043l-1.44,2.5a1.087,1.087,0,0,1-1.222.507l-2.8-.747a.087.087,0,0,0-.106.106L7.11,9.254a1.089,1.089,0,0,1-.5,1.222l-2.5,1.448A.082.082,0,0,0,4.063,12a.081.081,0,0,0,.043.074l2.5,1.44a1.087,1.087,0,0,1,.507,1.221l-.747,2.8a.08.08,0,0,0,.022.083.087.087,0,0,0,.085.023l2.784-.747A1.077,1.077,0,0,1,9.534,16.853Z"}},{"tag":"path","attr":{"d":"M12,15.875A3.875,3.875,0,1,1,15.875,12,3.88,3.88,0,0,1,12,15.875Zm0-6.75A2.875,2.875,0,1,0,14.875,12,2.879,2.879,0,0,0,12,9.125Z"}}]}]}]})(props);
	};
	module.exports.CiTablets1 = function CiTablets1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Tablets_1"},"child":[{"tag":"path","attr":{"d":"M14.76,3.065a6.171,6.171,0,0,0-6.11,5.58,6.159,6.159,0,1,0,6.71,6.71,6.159,6.159,0,0,0-.6-12.29ZM9.23,19.935A5.166,5.166,0,0,1,5.24,11.5l7.27,7.26A5.153,5.153,0,0,1,9.23,19.935Zm3.99-1.88-7.27-7.27a5.165,5.165,0,0,1,7.27,7.27Zm2.15-3.71a6.12,6.12,0,0,0-5.72-5.71,5.157,5.157,0,1,1,5.72,5.71Z"}}]}]})(props);
	};
	module.exports.CiTempHigh = function CiTempHigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Temp_High"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M14.863,13.4V4.939a2.929,2.929,0,0,0-.84-2.03,2.859,2.859,0,0,0-2.23-.82,2.948,2.948,0,0,0-2.66,3l.01,8.28a4.755,4.755,0,0,0,1.9,8.46,5.093,5.093,0,0,0,.95.09,4.759,4.759,0,0,0,4.76-4.75A4.684,4.684,0,0,0,14.863,13.4Zm-.48,6.66a3.783,3.783,0,0,1-3.15.78,3.7,3.7,0,0,1-2.92-2.98,3.745,3.745,0,0,1,1.43-3.69.962.962,0,0,0,.39-.77V5.089a1.968,1.968,0,0,1,1.73-2,.66.66,0,0,1,.14-.01,1.878,1.878,0,0,1,1.86,1.86V13.4a.962.962,0,0,0,.39.77,3.742,3.742,0,0,1,.13,5.89Z"}},{"tag":"path","attr":{"d":"M13.893,17.169a1.89,1.89,0,0,1-3.78,0,1.858,1.858,0,0,1,1.39-1.81V5.4a.5.5,0,0,1,1,0v9.96A1.869,1.869,0,0,1,13.893,17.169Z"}}]}]}]})(props);
	};
	module.exports.CiTextAlignCenter = function CiTextAlignCenter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Text_Align_Center"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.437,4.063H3.563a.5.5,0,1,1,0-1H20.437a.5.5,0,1,1,0,1Z"}},{"tag":"path","attr":{"d":"M16.5,8.5h-9a.5.5,0,0,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M16.5,16.5h-9a.5.5,0,1,1,0-1h9a.5.5,0,1,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,12.5H3.563a.5.5,0,0,1,0-1H20.437a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,20.937H3.563a.5.5,0,1,1,0-1H20.437a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiTextAlignJustify = function CiTextAlignJustify (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Text_Align_Justify"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.437,4.064H3.563a.5.5,0,0,1,0-1H20.437a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,8.5H3.563a.5.5,0,0,1,0-1H20.437a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,16.5H3.563a.5.5,0,1,1,0-1H20.437a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,12.5H3.563a.5.5,0,0,1,0-1H20.437a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,20.936H3.563a.5.5,0,1,1,0-1H20.437a.5.5,0,1,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiTextAlignLeft = function CiTextAlignLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Text_Align_Left"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.438,4.063H3.563a.5.5,0,1,1,0-1H20.438a.5.5,0,1,1,0,1Z"}},{"tag":"path","attr":{"d":"M12.562,8.5h-9a.5.5,0,0,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M12.562,16.5h-9a.5.5,0,1,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.436,12.5H3.562a.5.5,0,1,1,0-1H20.436a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.436,20.937H3.562a.5.5,0,0,1,0-1H20.436a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiTextAlignRight = function CiTextAlignRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Text_Align_Right"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.437,4.064H3.563a.5.5,0,0,1,0-1H20.437a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,8.5h-9a.5.5,0,1,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,16.5h-9a.5.5,0,1,1,0-1h9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,12.5H3.563a.5.5,0,0,1,0-1H20.437a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M20.437,20.936H3.563a.5.5,0,1,1,0-1H20.437a.5.5,0,1,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiText = function CiText (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Text"},"child":[{"tag":"path","attr":{"d":"M18.44,2.06H5.56a1.5,1.5,0,0,0-1.5,1.5v4.5a.5.5,0,0,0,1,0v-1H10V20.94H8a.5.5,0,0,0,0,1h8a.5.5,0,0,0,0-1H14V7.06h4.94v1a.5.5,0,0,0,1,0V3.56A1.5,1.5,0,0,0,18.44,2.06Zm.5,4H14a1,1,0,0,0-1,1V20.94H11V7.06a1,1,0,0,0-1-1H5.06V3.56a.5.5,0,0,1,.5-.5H18.44a.5.5,0,0,1,.5.5Z"}}]}]})(props);
	};
	module.exports.CiTimer = function CiTimer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Timer"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M2.336,9.685A9.934,9.934,0,0,0,13.592,21.808,9.931,9.931,0,0,0,20.708,7.23,10.046,10.046,0,0,0,12,2.072a.507.507,0,0,0-.5.5v4.2a.5.5,0,0,0,1,0v-4.2l-.5.5a8.935,8.935,0,0,1,8.433,11.892A8.938,8.938,0,0,1,6.468,19.027,9.041,9.041,0,0,1,3.3,9.951c.142-.627-.822-.9-.964-.266Z"}},{"tag":"path","attr":{"d":"M7.4,8.117a.5.5,0,0,1,.707-.707l4.243,4.242h0a.5.5,0,0,1-.707.707Z"}}]}]}]})(props);
	};
	module.exports.CiTrash = function CiTrash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Trash"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.45,4.06H15.27v-.5a1.5,1.5,0,0,0-1.5-1.5H10.23a1.5,1.5,0,0,0-1.5,1.5v.5H4.55a.5.5,0,0,0,0,1h.72l.42,14.45a2.493,2.493,0,0,0,2.5,2.43h7.62a2.493,2.493,0,0,0,2.5-2.43l.42-14.45h.72A.5.5,0,0,0,19.45,4.06Zm-9.72-.5a.5.5,0,0,1,.5-.5h3.54a.5.5,0,0,1,.5.5v.5H9.73Zm7.58,15.92a1.5,1.5,0,0,1-1.5,1.46H8.19a1.5,1.5,0,0,1-1.5-1.46L6.26,5.06H17.74Z"}},{"tag":"path","attr":{"d":"M8.375,8h0a.5.5,0,0,1,1,0l.25,10a.5.5,0,0,1-1,0Z"}},{"tag":"path","attr":{"d":"M15.625,8.007a.5.5,0,0,0-1,0h0l-.25,10a.5.5,0,0,0,1,0Z"}}]}]}]})(props);
	};
	module.exports.CiTrophy = function CiTrophy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Trophy"},"child":[{"tag":"path","attr":{"d":"M19.435,5.055h-.97c.01-.12.02-.24.02-.36a1.645,1.645,0,0,0-.45-1.18,1.462,1.462,0,0,0-1.05-.45H7.025a1.484,1.484,0,0,0-1.06.45,1.6,1.6,0,0,0-.44,1.18c0,.12.01.24.02.36h-.98a1.5,1.5,0,0,0-1.5,1.5v2a4.5,4.5,0,0,0,4.27,4.49c1.07,2.3,2.53,3.79,4.17,4.04v2.85h-4a.5.5,0,1,0,0,1h9a.5.5,0,0,0,0-1h-4v-2.85c1.64-.25,3.1-1.74,4.17-4.04a4.493,4.493,0,0,0,4.26-4.49v-2A1.5,1.5,0,0,0,19.435,5.055Zm-15.37,3.5v-2a.5.5,0,0,1,.5-.5h1.04a22.9,22.9,0,0,0,1.28,5.93A3.5,3.5,0,0,1,4.065,8.555Zm7.94,7.57c-2.82,0-5.23-5.04-5.48-11.47a.573.573,0,0,1,.16-.44.48.48,0,0,1,.34-.15h9.96a.442.442,0,0,1,.33.15.62.62,0,0,1,.17.44C17.235,11.085,14.825,16.125,12.005,16.125Zm7.93-7.57a3.508,3.508,0,0,1-2.8,3.42,23.353,23.353,0,0,0,1.27-5.92h1.03a.5.5,0,0,1,.5.5Z"}}]}]})(props);
	};
	module.exports.CiTurnL1 = function CiTurnL1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Turn_L_1"},"child":[{"tag":"path","attr":{"d":"M20.939,9.509v10.93a.508.508,0,0,1-.5.5.5.5,0,0,1-.5-.5V9.509a3.5,3.5,0,0,0-3.5-3.5h-9.9l-.01,1.44a.5.5,0,0,1-.81.4l-2.47-1.96a.5.5,0,0,1,0-.78l2.49-1.94a.5.5,0,0,1,.81.4l-.01,1.44h9.9A4.507,4.507,0,0,1,20.939,9.509Z"}}]}]})(props);
	};
	module.exports.CiTurnR1 = function CiTurnR1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Turn_R_1"},"child":[{"tag":"path","attr":{"d":"M3.061,9.509v10.93a.508.508,0,0,0,.5.5.5.5,0,0,0,.5-.5V9.509a3.5,3.5,0,0,1,3.5-3.5h9.9l.01,1.44a.5.5,0,0,0,.81.4l2.47-1.96a.5.5,0,0,0,0-.78l-2.49-1.94a.5.5,0,0,0-.81.4l.01,1.44h-9.9A4.507,4.507,0,0,0,3.061,9.509Z"}}]}]})(props);
	};
	module.exports.CiTwitter = function CiTwitter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Twitter"},"child":[{"tag":"path","attr":{"d":"M19.913,5.322a1.034,1.034,0,0,1,.837,1.629L19.708,8.432c-.064,5.086-1.765,8.539-5.056,10.264A10.917,10.917,0,0,1,9.6,19.835a12.233,12.233,0,0,1-6.2-1.524.76.76,0,0,1-.317-.8.768.768,0,0,1,.63-.6,20.6,20.6,0,0,0,3.745-.886C2,13.5,3.19,7.824,3.71,6.081a1.028,1.028,0,0,1,1.729-.422,9.931,9.931,0,0,0,5.995,2.95A4.188,4.188,0,0,1,12.725,5.3a4.125,4.125,0,0,1,5.7.02ZM4.521,17.794c1.862.872,6.226,1.819,9.667.016,2.955-1.549,4.476-4.732,4.521-9.461a.771.771,0,0,1,.142-.436l1.081-1.538-.041-.053c-.518-.007-1.029-.014-1.55,0a.835.835,0,0,1-.547-.221,3.13,3.13,0,0,0-4.383-.072,3.174,3.174,0,0,0-.935,2.87.646.646,0,0,1-.154.545.591.591,0,0,1-.516.205A10.924,10.924,0,0,1,4.722,6.354c-.67,2.078-1.52,7.094,3.869,9.065a.632.632,0,0,1,.416.538.625.625,0,0,1-.3.6A13.178,13.178,0,0,1,4.521,17.794ZM11.875,8.65h0Zm7.793-.161,0,0Z"}}]}]})(props);
	};
	module.exports.CiUmbrella = function CiUmbrella (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Umbrella"},"child":[{"tag":"path","attr":{"d":"M12.5,4.06v-.5a.509.509,0,0,0-.15-.35.483.483,0,0,0-.7,0,.491.491,0,0,0-.15.35v.5a8.41,8.41,0,0,0-7.88,7.82.976.976,0,0,0,.27.74,1.029,1.029,0,0,0,.74.32H11.5v5.22a1.653,1.653,0,0,1-.62,1.54A1.528,1.528,0,0,1,8.5,18.54a.5.5,0,0,0-1,0,2.433,2.433,0,0,0,2.43,2.4,2.45,2.45,0,0,0,2.57-2.29c.08-1.39,0-2.81,0-4.2V12.94h6.87a1.029,1.029,0,0,0,.74-.32.976.976,0,0,0,.27-.74A8.41,8.41,0,0,0,12.5,4.06Zm6.87,7.88-14.75.01a7.4,7.4,0,0,1,14.76-.02C19.38,11.94,19.38,11.94,19.37,11.94Z"}}]}]})(props);
	};
	module.exports.CiUndo = function CiUndo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Undo"},"child":[{"tag":"path","attr":{"d":"M19.939,13.67A7.958,7.958,0,0,1,7.8,19.74a8.061,8.061,0,0,1-3.77-6.77.5.5,0,0,1,1,0,6.976,6.976,0,0,0,11,5.7,6.969,6.969,0,0,0-1-11.97,10.075,10.075,0,0,0-4.64-.69V7.46a.5.5,0,0,1-.81.39L7.109,5.9a.5.5,0,0,1,0-.79L9.6,3.17a.5.5,0,0,1,.8.4V5.01c.71-.01,1.43-.03,2.13.02a7.985,7.985,0,0,1,7.41,8.64Z"}}]}]})(props);
	};
	module.exports.CiUnlock = function CiUnlock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Unlock"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.44,9.33h-1.1c0-.97.01-1.95,0-2.92A4.343,4.343,0,0,0,8.36,4.04c-.36.53.51,1.03.87.5a3.365,3.365,0,0,1,5.23-.39c1.04,1.11.88,2.57.88,3.96V9.33H6.56a2.5,2.5,0,0,0-2.5,2.5v7.61a2.507,2.507,0,0,0,2.5,2.5H17.44a2.507,2.507,0,0,0,2.5-2.5V11.83A2.5,2.5,0,0,0,17.44,9.33Zm1.5,10.11a1.511,1.511,0,0,1-1.5,1.5H6.56a1.511,1.511,0,0,1-1.5-1.5V11.83a1.5,1.5,0,0,1,1.5-1.5H17.44a1.5,1.5,0,0,1,1.5,1.5Z"}},{"tag":"path","attr":{"d":"M13,14.95a.984.984,0,0,1-.5.86v1.5a.5.5,0,0,1-1,0v-1.5a.984.984,0,0,1-.5-.86,1,1,0,0,1,2,0Z"}}]}]}]})(props);
	};
	module.exports.CiUnread = function CiUnread (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"unread"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M10.182,6.314a10.215,10.215,0,0,1,7.9,1.782,9.145,9.145,0,0,1,2.5,2.817,1.875,1.875,0,0,1,.082,2.024,9.266,9.266,0,0,1-1.485,2.008c-.446.464.26,1.172.707.707,1.1-1.144,2.533-2.86,1.9-4.554a8.845,8.845,0,0,0-2.721-3.5A11.243,11.243,0,0,0,9.916,5.35c-.633.11-.364,1.074.266.964Z"}},{"tag":"path","attr":{"d":"M19.824,19.11q-3.045-3.045-6.09-6.08c-.93-.93-1.85-1.86-2.77-2.77Q8.849,8.145,6.754,6.04L4.894,4.18c-.45-.45-1.16.26-.71.71l1.9,1.9a10.42,10.42,0,0,0-3.22,3.12,3.743,3.743,0,0,0-.8,2.28,4.581,4.581,0,0,0,.99,2.17,10.925,10.925,0,0,0,8.18,4.5A11.379,11.379,0,0,0,17,17.71l.25.25,1.86,1.86C19.564,20.27,20.274,19.56,19.824,19.11Zm-10.3-8.88c.25.24.49.49.73.73A2.039,2.039,0,0,0,12,14.03a2.023,2.023,0,0,0,1.04-.28c.25.24.49.49.73.73a3.047,3.047,0,0,1-4.25-4.25Zm-3.7,5.6a9.558,9.558,0,0,1-1.81-1.84c-.53-.71-1.19-1.62-.85-2.55a8.348,8.348,0,0,1,3.65-3.92c.67.67,1.34,1.33,2,2a4.04,4.04,0,0,0,5.67,5.67c.6.59,1.19,1.19,1.78,1.78A10.4,10.4,0,0,1,5.824,15.83Z"}}]}]}]})(props);
	};
	module.exports.CiUsb = function CiUsb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Usb"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.44,8.355H18.31v-.14a1.443,1.443,0,0,0-1.44-1.45H7.29a5.235,5.235,0,0,0,0,10.47h9.58a1.443,1.443,0,0,0,1.44-1.45v-.14h2.13a1.511,1.511,0,0,0,1.5-1.5V9.855A1.5,1.5,0,0,0,20.44,8.355Zm-3.13,7.43a.446.446,0,0,1-.44.45H7.29a4.235,4.235,0,0,1,0-8.47h9.58a.446.446,0,0,1,.44.45Zm3.63-1.64a.508.508,0,0,1-.5.5H18.31V9.355h2.13a.5.5,0,0,1,.5.5Z"}},{"tag":"path","attr":{"d":"M6.29,13.444A1.446,1.446,0,1,1,7.738,12,1.447,1.447,0,0,1,6.29,13.444Zm0-1.892A.446.446,0,1,0,6.738,12,.446.446,0,0,0,6.29,11.552Z"}}]}]}]})(props);
	};
	module.exports.CiUser = function CiUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"User"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17.438,21.937H6.562a2.5,2.5,0,0,1-2.5-2.5V18.61c0-3.969,3.561-7.2,7.938-7.2s7.938,3.229,7.938,7.2v.827A2.5,2.5,0,0,1,17.438,21.937ZM12,12.412c-3.826,0-6.938,2.78-6.938,6.2v.827a1.5,1.5,0,0,0,1.5,1.5H17.438a1.5,1.5,0,0,0,1.5-1.5V18.61C18.938,15.192,15.826,12.412,12,12.412Z"}},{"tag":"path","attr":{"d":"M12,9.911a3.924,3.924,0,1,1,3.923-3.924A3.927,3.927,0,0,1,12,9.911Zm0-6.847a2.924,2.924,0,1,0,2.923,2.923A2.926,2.926,0,0,0,12,3.064Z"}}]}]}]})(props);
	};
	module.exports.CiVault = function CiVault (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Vault"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M15.935,6.06H8.065a2,2,0,0,0-2,2v6a1.993,1.993,0,0,0,2,2h7.87a2,2,0,0,0,2-2v-6A2.006,2.006,0,0,0,15.935,6.06Zm1,8a1,1,0,0,1-1,1H8.065a.99.99,0,0,1-1-1v-6a1,1,0,0,1,1-1h7.87a1,1,0,0,1,1,1Z"}},{"tag":"path","attr":{"d":"M18.435,3.06H5.565a2.507,2.507,0,0,0-2.5,2.5v11a2.5,2.5,0,0,0,2.5,2.5v.38a1.5,1.5,0,0,0,1.5,1.5h1.43a1.5,1.5,0,0,0,1.5-1.5v-.38h4v.38a1.5,1.5,0,0,0,1.5,1.5h1.44a1.5,1.5,0,0,0,1.5-1.5v-.38a2.5,2.5,0,0,0,2.5-2.5v-11A2.507,2.507,0,0,0,18.435,3.06ZM8.995,19.44a.5.5,0,0,1-.5.5H7.065a.5.5,0,0,1-.5-.5v-.38h2.43Zm8.44,0a.5.5,0,0,1-.5.5H15.5a.508.508,0,0,1-.5-.5v-.38h2.44Zm2.5-2.88a1.5,1.5,0,0,1-1.5,1.5H5.565a1.5,1.5,0,0,1-1.5-1.5v-11a1.5,1.5,0,0,1,1.5-1.5h12.87a1.5,1.5,0,0,1,1.5,1.5Z"}},{"tag":"path","attr":{"d":"M14.265,10.56h-.61A1.656,1.656,0,0,0,12.5,9.4V8.79a.491.491,0,0,0-.5-.48.5.5,0,0,0-.5.48V9.4a1.656,1.656,0,0,0-1.16,1.16h-.61a.5.5,0,0,0-.48.5.491.491,0,0,0,.48.5h.61a1.656,1.656,0,0,0,1.16,1.16v.62a.489.489,0,0,0,.5.47.483.483,0,0,0,.5-.47v-.62a1.622,1.622,0,0,0,1.16-1.16h.61a.485.485,0,0,0,.48-.5A.491.491,0,0,0,14.265,10.56ZM12,11.81a.75.75,0,1,1,.75-.75A.749.749,0,0,1,12,11.81Z"}}]}]}]})(props);
	};
	module.exports.CiVial = function CiVial (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Vial"},"child":[{"tag":"path","attr":{"d":"M20.779,9.441l-.48-.47L15.039,3.7l-.48-.48a.5.5,0,0,0-.7,0,.5.5,0,0,0,0,.71l.47.48L4.159,14.581a3.694,3.694,0,0,0,0,5.22l.04.04a3.706,3.706,0,0,0,5.23,0L19.6,9.671l.47.48a.52.52,0,0,0,.71,0A.513.513,0,0,0,20.779,9.441Zm-12.06,9.69a2.7,2.7,0,0,1-3.81,0l-.04-.04a2.7,2.7,0,0,1,0-3.81l1.7-1.7h7.71Zm6.56-6.55H7.569l7.47-7.46,3.85,3.85Z"}}]}]})(props);
	};
	module.exports.CiVideoOff = function CiVideoOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Video_Off"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M20.783,9.51v6.53a.5.5,0,0,1-1,0V9.6c0-.85.06-1.72,0-2.57-.03-.37-.27-.5-.61-.3-.39.22-.76.51-1.13.76-.73.49-1.47.99-2.2,1.49,0,.71-.01,1.41-.01,2.11a.5.5,0,0,1-1,0V9.12c0-.58.01-1.16,0-1.74a1.524,1.524,0,0,0-1.56-1.5c-1.22-.01-2.43,0-3.65,0a.5.5,0,0,1,0-1h2.13c.6,0,1.22-.05,1.81.01a2.54,2.54,0,0,1,2.27,2.5c0,.13.01.26,0,.39.77-.53,1.55-1.05,2.32-1.57a2.466,2.466,0,0,1,1.26-.6,1.364,1.364,0,0,1,1.37,1.36C20.813,7.81,20.783,8.67,20.783,9.51Z"}},{"tag":"path","attr":{"d":"M19.773,19.08q-6.5-6.51-12.99-13c-.62-.62-1.24-1.24-1.87-1.86-.45-.46-1.16.25-.7.71l.28.28A2.468,2.468,0,0,0,3.2,7.38v9.24a2.5,2.5,0,0,0,2.5,2.5h7.63a2.5,2.5,0,0,0,2.5-2.5v-.07l1.37,1.37c.62.62,1.24,1.24,1.87,1.86A.5.5,0,0,0,19.773,19.08Zm-4.94-2.46a1.5,1.5,0,0,1-1.5,1.5H5.7a1.5,1.5,0,0,1-1.5-1.5V7.38a1.5,1.5,0,0,1,1.04-1.42l9.59,9.59Z"}}]}]}]})(props);
	};
	module.exports.CiVideoOn = function CiVideoOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Video_On"},"child":[{"tag":"path","attr":{"d":"M21.05,5.05a1.433,1.433,0,0,0-1.48.08L16.25,7.37V6.56a2.5,2.5,0,0,0-2.5-2.5H4.69a2.5,2.5,0,0,0-2.5,2.5V17.44a2.5,2.5,0,0,0,2.5,2.5h9.06a2.5,2.5,0,0,0,2.5-2.5v-.81l3.32,2.24a1.5,1.5,0,0,0,.81.24,1.414,1.414,0,0,0,1.43-1.43V6.32A1.437,1.437,0,0,0,21.05,5.05Zm-5.8,12.39a1.5,1.5,0,0,1-1.5,1.5H4.69a1.5,1.5,0,0,1-1.5-1.5V6.56a1.5,1.5,0,0,1,1.5-1.5h9.06a1.5,1.5,0,0,1,1.5,1.5Zm5.56.24a.415.415,0,0,1-.23.38.425.425,0,0,1-.45-.02l-3.88-2.62V8.58l3.88-2.62a.425.425,0,0,1,.45-.02.415.415,0,0,1,.23.38Z"}}]}]})(props);
	};
	module.exports.CiViewBoard = function CiViewBoard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"View_Board"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.437,20.936H5.563a2.5,2.5,0,0,1-2.5-2.5V5.562a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.436A2.5,2.5,0,0,1,18.437,20.936ZM5.563,4.062a1.5,1.5,0,0,0-1.5,1.5V18.436a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.562a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M12.5,14.544a.5.5,0,0,1-1,0v-8h0a.5.5,0,0,1,1,0Z"}},{"tag":"path","attr":{"d":"M16.717,12.453a.5.5,0,0,1-1,0V6.544h0a.5.5,0,0,1,1,0Z"}},{"tag":"path","attr":{"d":"M8.28,6.544a.5.5,0,0,0-1,0h0v4a.5.5,0,0,0,1,0Z"}}]}]}]})(props);
	};
	module.exports.CiViewColumn = function CiViewColumn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"View_Column"},"child":[{"tag":"path","attr":{"d":"M18.44,3.06H5.56a2.507,2.507,0,0,0-2.5,2.5V18.44a2.514,2.514,0,0,0,2.5,2.5H18.44a2.514,2.514,0,0,0,2.5-2.5V5.56A2.507,2.507,0,0,0,18.44,3.06ZM8.67,19.94H5.56a1.511,1.511,0,0,1-1.5-1.5V5.56a1.5,1.5,0,0,1,1.5-1.5H8.67Zm1-15.88h4.66V19.94H9.67ZM19.94,18.44a1.511,1.511,0,0,1-1.5,1.5H15.33V4.06h3.11a1.5,1.5,0,0,1,1.5,1.5Z"}}]}]})(props);
	};
	module.exports.CiViewList = function CiViewList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"View_List"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.436,20.937H5.562a2.5,2.5,0,0,1-2.5-2.5V5.563a2.5,2.5,0,0,1,2.5-2.5H18.436a2.5,2.5,0,0,1,2.5,2.5V18.437A2.5,2.5,0,0,1,18.436,20.937ZM5.562,4.063a1.5,1.5,0,0,0-1.5,1.5V18.437a1.5,1.5,0,0,0,1.5,1.5H18.436a1.5,1.5,0,0,0,1.5-1.5V5.563a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M6.544,8.283h0a.519.519,0,0,1-.353-.147.5.5,0,0,1,0-.707.512.512,0,0,1,.353-.146H7.55a.516.516,0,0,1,.353.146.5.5,0,0,1,.147.354.5.5,0,0,1-.5.5Z"}},{"tag":"path","attr":{"d":"M6.544,12.5h0a.523.523,0,0,1-.353-.146.5.5,0,0,1,0-.708.516.516,0,0,1,.353-.146H7.55a.521.521,0,0,1,.353.146.5.5,0,0,1,0,.708.516.516,0,0,1-.353.146Z"}},{"tag":"path","attr":{"d":"M6.544,16.72h0a.519.519,0,0,1-.353-.147.5.5,0,0,1,0-.707.516.516,0,0,1,.353-.146H7.55a.516.516,0,0,1,.353.146.5.5,0,0,1,.147.354.5.5,0,0,1-.5.5Z"}},{"tag":"path","attr":{"d":"M10.554,8.281h0a.5.5,0,0,1,0-1h6.9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M10.554,12.5h0a.5.5,0,0,1,0-1h6.9a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M10.554,16.718h0a.5.5,0,0,1,0-1h6.9a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiViewTable = function CiViewTable (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"View_Table"},"child":[{"tag":"path","attr":{"d":"M18.44,3.06H5.56a2.507,2.507,0,0,0-2.5,2.5V18.44a2.507,2.507,0,0,0,2.5,2.5H18.44a2.514,2.514,0,0,0,2.5-2.5V5.56A2.514,2.514,0,0,0,18.44,3.06ZM8.71,19.94H5.56a1.5,1.5,0,0,1-1.5-1.5V15.33H8.71Zm0-5.61H4.06V9.67H8.71Zm0-5.66H4.06V5.56a1.5,1.5,0,0,1,1.5-1.5H8.71Zm11.23,9.77a1.511,1.511,0,0,1-1.5,1.5H9.71V15.33H19.94Zm0-4.11H9.71V9.67H19.94Zm0-5.66H9.71V4.06h8.73a1.511,1.511,0,0,1,1.5,1.5Z"}}]}]})(props);
	};
	module.exports.CiViewTimeline = function CiViewTimeline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"View_Timeline"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M18.436,20.94H5.562a2.5,2.5,0,0,1-2.5-2.5V5.567a2.5,2.5,0,0,1,2.5-2.5H18.436a2.5,2.5,0,0,1,2.5,2.5V18.44A2.5,2.5,0,0,1,18.436,20.94ZM5.562,4.067a1.5,1.5,0,0,0-1.5,1.5V18.44a1.5,1.5,0,0,0,1.5,1.5H18.436a1.5,1.5,0,0,0,1.5-1.5V5.567a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M6.544,8.287h0a.5.5,0,0,1,0-1H12a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M9.271,12.5h0a.5.5,0,0,1,0-1h5.454a.5.5,0,0,1,0,1Z"}},{"tag":"path","attr":{"d":"M12,16.724h0a.5.5,0,0,1,0-1h5.455a.5.5,0,0,1,0,1Z"}}]}]}]})(props);
	};
	module.exports.CiVirus = function CiVirus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Virus"},"child":[{"tag":"path","attr":{"d":"M5.86,19.905a.485.485,0,0,0,.35.15.469.469,0,0,0,.35-.15.483.483,0,0,0,0-.7l-.53-.53,1.74-1.74a6.426,6.426,0,0,0,3.73,1.54v2.46h-.75a.5.5,0,0,0,0,1h2.5a.5.5,0,1,0,0-1H12.5v-2.46a6.426,6.426,0,0,0,3.73-1.54l1.74,1.74-.53.53a.483.483,0,0,0,0,.7.469.469,0,0,0,.35.15.485.485,0,0,0,.35-.15l1.77-1.76a.513.513,0,0,0,0-.71.5.5,0,0,0-.71,0l-.52.53-1.74-1.74a6.435,6.435,0,0,0,1.54-3.73h2.46v.75a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-2.5a.508.508,0,0,0-.5-.5.5.5,0,0,0-.5.5v.75H18.48a6.418,6.418,0,0,0-1.55-3.72l1.75-1.74.52.53a.508.508,0,0,0,.36.15.5.5,0,0,0,.35-.15.513.513,0,0,0,0-.71l-1.77-1.77a.5.5,0,0,0-.7,0,.5.5,0,0,0,0,.71l.53.53-1.74,1.74a6.382,6.382,0,0,0-3.73-1.55V3.065h.75a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5h-2.5a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5h.75v2.45a6.382,6.382,0,0,0-3.73,1.55L6.03,5.325l.53-.53a.5.5,0,0,0,0-.71.5.5,0,0,0-.7,0L4.09,5.855a.513.513,0,0,0,0,.71.5.5,0,0,0,.35.15.508.508,0,0,0,.36-.15l.52-.53,1.75,1.74A6.418,6.418,0,0,0,5.52,11.5H3.06v-.75a.5.5,0,0,0-.5-.5.508.508,0,0,0-.5.5v2.5a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5V12.5H5.52a6.435,6.435,0,0,0,1.54,3.73l-1.74,1.74-.52-.53a.5.5,0,0,0-.71,0,.513.513,0,0,0,0,.71Zm10.03-4.02A5.5,5.5,0,1,1,17.5,12,5.448,5.448,0,0,1,15.89,15.885Z"}}]}]})(props);
	};
	module.exports.CiVoicemail = function CiVoicemail (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Voicemail"},"child":[{"tag":"path","attr":{"d":"M17.435,7.5a4.5,4.5,0,0,0-2.82,8H9.385a4.494,4.494,0,1,0-2.82,1h10.87a4.5,4.5,0,0,0,0-9ZM3.065,12a3.5,3.5,0,1,1,3.56,3.5h-.06A3.5,3.5,0,0,1,3.065,12Zm14.37,3.5h-.06a3.53,3.53,0,1,1,.06,0Z"}}]}]})(props);
	};
	module.exports.CiVolumeHigh = function CiVolumeHigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Volume_High"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M13.816,19.937a1.446,1.446,0,0,1-.717-.194L9.43,17.623a3.257,3.257,0,0,0-1.625-.434H4.439a2.379,2.379,0,0,1-2.375-2.376V9.187A2.378,2.378,0,0,1,4.439,6.812H7.805A3.257,3.257,0,0,0,9.43,6.376L13.1,4.259A1.437,1.437,0,0,1,15.255,5.5V18.5a1.424,1.424,0,0,1-.718,1.245A1.445,1.445,0,0,1,13.816,19.937ZM4.439,7.812A1.377,1.377,0,0,0,3.064,9.187v5.626a1.378,1.378,0,0,0,1.375,1.376H7.805a4.254,4.254,0,0,1,2.125.569L13.6,18.876a.439.439,0,0,0,.657-.38V5.5a.438.438,0,0,0-.657-.379L9.93,7.242a4.251,4.251,0,0,1-2.125.57Z"}},{"tag":"path","attr":{"d":"M18.407,6.262a7.79,7.79,0,0,1,.021,11.476c-.474.437.235,1.143.707.707a8.793,8.793,0,0,0-.021-12.89c-.474-.434-1.184.272-.707.707Z"}},{"tag":"path","attr":{"d":"M16.91,9.031a4.021,4.021,0,0,1,.012,5.938c-.474.438.234,1.143.707.707a5.025,5.025,0,0,0-.012-7.352c-.474-.434-1.183.272-.707.707Z"}}]}]}]})(props);
	};
	module.exports.CiVolumeMute = function CiVolumeMute (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Volume_Mute"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M13.817,19.936a1.424,1.424,0,0,1-.719-.2L9.43,17.624a3.254,3.254,0,0,0-1.625-.436H4.44a2.377,2.377,0,0,1-2.375-2.375V9.187A2.378,2.378,0,0,1,4.44,6.811H7.805A3.257,3.257,0,0,0,9.43,6.377L13.1,4.259A1.438,1.438,0,0,1,15.255,5.5V18.5a1.423,1.423,0,0,1-.718,1.245A1.439,1.439,0,0,1,13.817,19.936ZM4.44,7.811A1.377,1.377,0,0,0,3.065,9.187v5.626A1.377,1.377,0,0,0,4.44,16.188H7.805a4.247,4.247,0,0,1,2.125.571L13.6,18.876a.437.437,0,0,0,.439,0,.433.433,0,0,0,.218-.379V5.5a.438.438,0,0,0-.657-.379L9.93,7.242a4.25,4.25,0,0,1-2.125.569Z"}},{"tag":"path","attr":{"d":"M17.606,14.445a.5.5,0,0,1-.7-.711c.17-.169.34-.349.52-.52l1.21-1.209c-.57-.581-1.15-1.161-1.73-1.74a.5.5,0,0,1,.7-.71l1.74,1.739,1.74-1.739a.5.5,0,0,1,.7.71l-1.73,1.74,1.73,1.729a.5.5,0,0,1-.7.711L19.343,12.7Z"}}]}]}]})(props);
	};
	module.exports.CiVolume = function CiVolume (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Volume"},"child":[{"tag":"path","attr":{"d":"M17.849,20.934a1.555,1.555,0,0,1-.781-.212l-4.16-2.4a3.769,3.769,0,0,0-1.877-.5H7.214a2.631,2.631,0,0,1-2.628-2.627V8.809A2.631,2.631,0,0,1,7.214,6.182h3.817a3.747,3.747,0,0,0,1.877-.5l4.16-2.4a1.564,1.564,0,0,1,2.346,1.354V19.369a1.57,1.57,0,0,1-1.565,1.565ZM7.214,7.182A1.63,1.63,0,0,0,5.586,8.809v6.382a1.629,1.629,0,0,0,1.628,1.627h3.817a4.756,4.756,0,0,1,2.377.637l4.16,2.4a.543.543,0,0,0,.563,0,.553.553,0,0,0,.283-.487V4.632a.565.565,0,0,0-.846-.489l-4.16,2.4a4.753,4.753,0,0,1-2.377.637Z"}}]}]})(props);
	};
	module.exports.CiWallet = function CiWallet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Wallet"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.435,4.065H4.565a2.5,2.5,0,0,0-2.5,2.5v10.87a2.5,2.5,0,0,0,2.5,2.5h14.87a2.5,2.5,0,0,0,2.5-2.5V6.565A2.5,2.5,0,0,0,19.435,4.065Zm1.5,9.93h-6.42a2,2,0,0,1,0-4h6.42Zm-6.42-5a3,3,0,0,0,0,6h6.42v2.44a1.5,1.5,0,0,1-1.5,1.5H4.565a1.5,1.5,0,0,1-1.5-1.5V6.565a1.5,1.5,0,0,1,1.5-1.5h14.87a1.5,1.5,0,0,1,1.5,1.5v2.43Z"}},{"tag":"circle","attr":{"cx":"14.519","cy":"11.996","r":"1"}}]}]}]})(props);
	};
	module.exports.CiWarning = function CiWarning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Warning"},"child":[{"tag":"g","attr":{},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M12.5,8.752a.5.5,0,0,0-1,0h0v6a.5.5,0,0,0,1,0Z"}},{"tag":"circle","attr":{"cx":"11.999","cy":"16.736","r":"0.5"}}]},{"tag":"path","attr":{"d":"M18.642,20.934H5.385A2.5,2.5,0,0,1,3.163,17.29L9.792,4.421a2.5,2.5,0,0,1,4.444,0L20.865,17.29a2.5,2.5,0,0,1-2.223,3.644ZM12.014,4.065a1.478,1.478,0,0,0-1.334.814L4.052,17.748a1.5,1.5,0,0,0,1.333,2.186H18.642a1.5,1.5,0,0,0,1.334-2.186L13.348,4.879A1.478,1.478,0,0,0,12.014,4.065Z"}}]}]}]})(props);
	};
	module.exports.CiWavePulse1 = function CiWavePulse1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Wave_Pulse_1"},"child":[{"tag":"path","attr":{"d":"M8.974,18h0a1.446,1.446,0,0,1-1.259-.972L5.872,12.883c-.115-.26-.262-.378-.349-.378H2.562a.5.5,0,1,1,0-1H5.523a1.444,1.444,0,0,1,1.263.972l1.839,4.145c.116.261.258.378.349.378h0c.088,0,.229-.113.344-.368L13.7,6.956A1.423,1.423,0,0,1,14.958,6h0a1.449,1.449,0,0,1,1.26.975l1.839,4.151c.11.249.259.379.349.379h3.028a.5.5,0,0,1,0,1H18.41a1.444,1.444,0,0,1-1.263-.975L15.308,7.379c-.116-.261-.259-.378-.35-.379h0c-.088,0-.229.114-.344.368l-4.385,9.676A1.437,1.437,0,0,1,8.974,18Z"}}]}]})(props);
	};
	module.exports.CiWheat = function CiWheat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Wheat"},"child":[{"tag":"path","attr":{"d":"M15.247,13.836a3.115,3.115,0,0,0,.79-2.78,1.053,1.053,0,0,0-.8-.81,3.1,3.1,0,0,0,.8-2.79,1.061,1.061,0,0,0-.82-.82,3.211,3.211,0,0,0-2.04.25A3.09,3.09,0,0,0,14,4.816a3.1,3.1,0,0,0-1.41-2.57,1.043,1.043,0,0,0-1.16-.01A3.124,3.124,0,0,0,10,4.816a3.052,3.052,0,0,0,.83,2.07,3.154,3.154,0,0,0-2.04-.25,1.048,1.048,0,0,0-.82.82,3.1,3.1,0,0,0,.79,2.79,1.041,1.041,0,0,0-.79.81,3.11,3.11,0,0,0,.78,2.78,1.071,1.071,0,0,0-.78.82,3.031,3.031,0,0,0,3,3.7,2.436,2.436,0,0,0,.53-.05v3.15a.5.5,0,0,0,1,0v-3.15a2.469,2.469,0,0,0,.54.05,3.054,3.054,0,0,0,2.17-.88,3.124,3.124,0,0,0,.83-2.82A1.083,1.083,0,0,0,15.247,13.836Zm-3.83,3.48a2.12,2.12,0,0,1-1.92-.55,2.041,2.041,0,0,1-.51-1.96,2.558,2.558,0,0,1,.47-.04,1.984,1.984,0,0,1,1.45.59A2.011,2.011,0,0,1,11.417,17.316Zm0-3.6a2.112,2.112,0,0,1-1.92-.55,2.022,2.022,0,0,1-.51-1.95,1.93,1.93,0,0,1,.47-.05,1.984,1.984,0,0,1,1.45.59A2.011,2.011,0,0,1,11.417,13.716Zm0-3.6a2.112,2.112,0,0,1-1.92-.55,2.022,2.022,0,0,1-.51-1.95,2.592,2.592,0,0,1,.47-.05,1.984,1.984,0,0,1,1.45.59A2.011,2.011,0,0,1,11.417,10.116Zm.56-3.55A2.1,2.1,0,0,1,11,4.816a2.005,2.005,0,0,1,1.04-1.74A2.1,2.1,0,0,1,13,4.816,2.054,2.054,0,0,1,11.977,6.566Zm2.53,10.2a2.072,2.072,0,0,1-1.96.51,2.384,2.384,0,0,1-.05-.45v-.02a2.065,2.065,0,0,1,.59-1.46,1.99,1.99,0,0,1,1.4-.57,2.279,2.279,0,0,1,.57.07A2.14,2.14,0,0,1,14.507,16.766Zm0-3.6a2.047,2.047,0,0,1-1.96.51,2.384,2.384,0,0,1-.05-.45v-.02a2.024,2.024,0,0,1,.59-1.45,1.957,1.957,0,0,1,1.4-.58,2.863,2.863,0,0,1,.57.07A2.14,2.14,0,0,1,14.507,13.166Zm0-3.6a2.024,2.024,0,0,1-1.96.51,2.384,2.384,0,0,1-.05-.45v-.02a2.024,2.024,0,0,1,.59-1.45,1.955,1.955,0,0,1,1.41-.57,2.259,2.259,0,0,1,.56.07A2.12,2.12,0,0,1,14.507,9.566Z"}}]}]})(props);
	};
	module.exports.CiWifiOff = function CiWifiOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Wi-Fi_Off"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M10.37,6.564a12.392,12.392,0,0,1,10.71,3.93c.436.476,1.141-.233.708-.708A13.324,13.324,0,0,0,10.37,5.564c-.631.076-.638,1.077,0,1Z"}},{"tag":"path","attr":{"d":"M13.907,10.283A8.641,8.641,0,0,1,18.349,12.9c.434.477,1.139-.232.707-.707a9.586,9.586,0,0,0-4.883-2.871c-.626-.146-.893.818-.266.965Z"}},{"tag":"circle","attr":{"cx":"12.003","cy":"16.922","r":"1.12"}},{"tag":"path","attr":{"d":"M19.773,19.06a.5.5,0,0,1-.71.71l-5.84-5.84A4.478,4.478,0,0,0,8.7,15.24c-.43.48-1.14-.23-.71-.7a5.47,5.47,0,0,1,4.06-1.78l-2.37-2.37a8.693,8.693,0,0,0-4.03,2.53c-.43.48-1.13-.23-.7-.71A9.439,9.439,0,0,1,8.893,9.6L6.883,7.59a12.557,12.557,0,0,0-3.96,2.94.5.5,0,1,1-.7-.71,13.109,13.109,0,0,1,3.91-2.98l-1.9-1.9a.5.5,0,0,1,.71-.71Z"}}]}]}]})(props);
	};
	module.exports.CiWifiOn = function CiWifiOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Wi-Fi_On"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M2.922,10.777a12.194,12.194,0,0,1,18.155-.034c.436.476,1.141-.233.707-.707a13.189,13.189,0,0,0-19.569.034c-.432.475.273,1.184.707.707Z"}},{"tag":"path","attr":{"d":"M5.654,13.169a8.615,8.615,0,0,1,12.691-.024c.437.475,1.143-.234.707-.707a9.621,9.621,0,0,0-14.106.024c-.433.474.272,1.184.708.707Z"}},{"tag":"path","attr":{"d":"M8.7,15.492a4.47,4.47,0,0,1,6.6-.013c.438.474,1.143-.235.707-.707a5.475,5.475,0,0,0-8.015.013c-.434.474.271,1.183.707.707Z"}},{"tag":"circle","attr":{"cx":"11.999","cy":"17.172","r":"1.12"}}]}]}]})(props);
	};
	module.exports.CiYoutube = function CiYoutube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Youtube"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M19.437,19.937H4.562a2.5,2.5,0,0,1-2.5-2.5V6.563a2.5,2.5,0,0,1,2.5-2.5H19.437a2.5,2.5,0,0,1,2.5,2.5V17.437A2.5,2.5,0,0,1,19.437,19.937ZM4.562,5.063a1.5,1.5,0,0,0-1.5,1.5V17.437a1.5,1.5,0,0,0,1.5,1.5H19.437a1.5,1.5,0,0,0,1.5-1.5V6.563a1.5,1.5,0,0,0-1.5-1.5Z"}},{"tag":"path","attr":{"d":"M14.568,11.149,10.6,8.432a1.032,1.032,0,0,0-1.614.851v5.434a1.032,1.032,0,0,0,1.614.851l3.972-2.717A1.031,1.031,0,0,0,14.568,11.149Z"}}]}]}]})(props);
	};
	module.exports.CiZoomIn = function CiZoomIn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Zoom_In"},"child":[{"tag":"path","attr":{"d":"M16.279,17.039c-1.396,1.209 -3.216,1.941 -5.206,1.941c-4.393,0 -7.96,-3.567 -7.96,-7.96c-0,-4.393 3.567,-7.96 7.96,-7.96c4.393,0 7.96,3.567 7.96,7.96c-0,2.044 -0.772,3.909 -2.04,5.319l0.165,0.165c1.194,1.194 2.388,2.388 3.583,3.582c0.455,0.456 -0.252,1.163 -0.707,0.708l-3.755,-3.755Zm1.754,-6.019c-0,-3.841 -3.119,-6.96 -6.96,-6.96c-3.842,0 -6.96,3.119 -6.96,6.96c-0,3.841 3.118,6.96 6.96,6.96c3.841,0 6.96,-3.119 6.96,-6.96Zm-7.46,0.5l-1.5,0c-0.645,0 -0.643,-1 -0,-1l1.5,0l-0,-1.5c-0,-0.645 1,-0.643 1,0l-0,1.5l1.5,0c0.645,0 0.643,1 -0,1l-1.5,0l-0,1.5c-0,0.645 -1,0.643 -1,0l-0,-1.5Z"}}]}]})(props);
	};
	module.exports.CiZoomOut = function CiZoomOut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{"id":"Zoom_Out"},"child":[{"tag":"path","attr":{"d":"M16.279,17.039c-1.396,1.209 -3.216,1.941 -5.206,1.941c-4.393,0 -7.96,-3.567 -7.96,-7.96c-0,-4.393 3.567,-7.96 7.96,-7.96c4.393,0 7.96,3.567 7.96,7.96c-0,2.044 -0.772,3.909 -2.04,5.319l0.165,0.165c1.194,1.194 2.388,2.388 3.583,3.582c0.455,0.456 -0.252,1.163 -0.707,0.708l-3.755,-3.755Zm1.754,-6.019c-0,-3.841 -3.119,-6.96 -6.96,-6.96c-3.842,0 -6.96,3.119 -6.96,6.96c-0,3.841 3.118,6.96 6.96,6.96c3.841,0 6.96,-3.119 6.96,-6.96Zm-4.96,-0.5c0.645,0 0.643,1 -0,1l-4,0c-0.645,0 -0.643,-1 -0,-1l4,0Z"}}]}]})(props);
	};


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	// THIS FILE IS AUTO GENERATED
	var GenIcon = __webpack_require__(76).GenIcon
	module.exports.IoIosAddCircleOutline = function IoIosAddCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M346.5 240H272v-74.5c0-8.8-7.2-16-16-16s-16 7.2-16 16V240h-74.5c-8.8 0-16 6-16 16s7.5 16 16 16H240v74.5c0 9.5 7 16 16 16s16-7.2 16-16V272h74.5c8.8 0 16-7.2 16-16s-7.2-16-16-16z"}},{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosAddCircle = function IoIosAddCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm90.5 224H272v74.5c0 8.8-7.2 16-16 16-4.4 0-8.4-1.8-11.3-4.7-2.9-2.9-4.7-6.9-4.7-11.3V272h-74.5c-4.4 0-8.4-1.8-11.3-4.7-2.9-2.9-4.7-6.9-4.7-11.3 0-8.8 7.2-16 16-16H240v-74.5c0-8.8 7.2-16 16-16s16 7.2 16 16V240h74.5c8.8 0 16 7.2 16 16s-7.2 16-16 16z"}}]})(props);
	};
	module.exports.IoIosAdd = function IoIosAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368.5 240H272v-96.5c0-8.8-7.2-16-16-16s-16 7.2-16 16V240h-96.5c-8.8 0-16 7.2-16 16 0 4.4 1.8 8.4 4.7 11.3 2.9 2.9 6.9 4.7 11.3 4.7H240v96.5c0 4.4 1.8 8.4 4.7 11.3 2.9 2.9 6.9 4.7 11.3 4.7 8.8 0 16-7.2 16-16V272h96.5c8.8 0 16-7.2 16-16s-7.2-16-16-16z"}}]})(props);
	};
	module.exports.IoIosAirplane = function IoIosAirplane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M407.7 224c-3.4 0-14.8.1-18 .3l-64.9 1.7c-.7 0-1.4-.3-1.7-.9L225.8 79.4c-2.9-4.6-8.1-7.4-13.5-7.4h-23.7c-5.6 0-7.5 5.6-5.5 10.8l50.1 142.8c.5 1.3-.4 2.7-1.8 2.7L109 230.1c-2.6.1-5-1.1-6.6-3.1l-37-45c-3-3.9-7.7-6.1-12.6-6.1H36c-2.8 0-4.7 2.7-3.8 5.3l19.9 68.7c1.5 3.8 1.5 8.1 0 11.9l-19.9 68.7c-.9 2.6 1 5.3 3.8 5.3h16.7c4.9 0 9.6-2.3 12.6-6.1L103 284c1.6-2 4.1-3.2 6.6-3.1l121.7 2.7c1.4.1 2.3 1.4 1.8 2.7L183 429.2c-2 5.2-.1 10.8 5.5 10.8h23.7c5.5 0 10.6-2.8 13.5-7.4L323.1 287c.4-.6 1-.9 1.7-.9l64.9 1.7c3.3.2 14.6.3 18 .3 44.3 0 72.3-14.3 72.3-32S452.1 224 407.7 224z"}}]})(props);
	};
	module.exports.IoIosAlarm = function IoIosAlarm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M381.2 64.1c-1.3-.1-2.6-.1-3.9-.1h-.2c-16.2 0-32 5.4-44.6 15.1-1.6 1.3-2.6 3.2-2.7 5.2-.1 2 .8 4 2.3 5.4l89.8 80.5c1.3 1.1 2.9 1.8 4.6 1.8h.4c1.9-.1 3.6-1 4.8-2.4C440.9 159 448 150.8 448 133c.1-36.4-29.1-66.8-66.8-68.9zM64 133c0 17.8 7.1 26 16.3 36.6 1.2 1.4 2.9 2.3 4.8 2.4h.4c1.7 0 3.3-.6 4.6-1.8L180 89.7c1.5-1.4 2.4-3.3 2.3-5.4-.1-2-1-3.9-2.7-5.2C167 69.4 151.2 64 135 64h-.2c-1.3 0-2.6 0-3.9.1-37.7 2.1-67 32.5-66.9 68.9z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M390 386c26.2-30.7 42-70.5 42-114 0-97.2-78.8-176-176-176S80 174.8 80 272c0 43.5 15.8 83.3 42 114l-34.7 35.5c-6.2 6.3-6 15.5.3 21.6 3.1 3 7.4 4.8 11.4 4.8 4.2 0 8.1-1.9 11.2-5.1l34.6-34.5c30.3 24.7 69 39.6 111.2 39.6s80.9-14.8 111.2-39.6l33.6 34.5c3.1 3.2 7.3 5.1 11.5 5.1 4 0 8.1-1.8 11.2-4.8 6.3-6.2 7.5-15.3 1.3-21.6L390 386zM270 274c0 7.7-6.3 14-14 14h-82c-7.7 0-14-6.3-14-14s6.3-14 14-14h68V158c0-7.7 6.3-14 14-14s14 6.3 14 14v116z"}}]}]})(props);
	};
	module.exports.IoIosAlbums = function IoIosAlbums (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M460.9 161H51.1C31.8 161 16 176.8 16 196.1V428c0 19.3 15.8 35.1 35.1 35.1H461c19.3 0 35.1-15.8 35.1-35.1V196.1c-.1-19.3-15.9-35.1-35.2-35.1zM434 133H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h356c7.7 0 14 6.3 14 14s-6.3 14-14 14zM403.2 77H108.8c-7 0-12.8-5.8-12.8-12.8v-2.4c0-7 5.8-12.8 12.8-12.8h294.4c7 0 12.8 5.8 12.8 12.8v2.4c0 7-5.8 12.8-12.8 12.8z"}}]})(props);
	};
	module.exports.IoIosAlert = function IoIosAlert (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm17.2 109.6l-3.1 115.1c-.2 8.2-5.9 14.8-14.1 14.8s-13.9-6.6-14.1-14.8l-3.1-115.1c-.2-9.6 7.5-17.6 17.2-17.6 9.6 0 17.4 7.9 17.2 17.6zM256 354c-10.7 0-19.1-8.1-19.1-18.4s8.4-18.4 19.1-18.4c10.7 0 19.1 8.1 19.1 18.4S266.7 354 256 354z"}}]})(props);
	};
	module.exports.IoIosAmericanFootball = function IoIosAmericanFootball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M378.6 133.4C338.1 92.9 283.9 71 231.4 59.6L59.6 231.4C71 284 92.9 338.1 133.4 378.6c40.5 40.5 94.7 62.4 147.2 73.8l171.8-171.8c-11.4-52.5-33.3-106.7-73.8-147.2zM344.1 288l-19.2 19.2 14.8 14.8c4.9 4.9 4.9 12.7 0 17.6-4.9 4.9-12.7 4.9-17.6 0l-14.8-14.8-19.3 19.4c-2 2-4.5 3.4-7.3 3.9-4.2.7-8.4-.7-11.3-3.6-1.5-1.5-2.6-3.3-3.2-5.3-1.4-4.9-.1-9.7 3.2-13.1l19.5-19.5-15.6-15.6-19.3 19.3c-2.1 2.1-4.7 3.5-7.6 3.9-5.5.7-10.7-1.9-13.4-7-.3-.6-.6-1.2-.8-1.9-1.5-4.9-.2-9.8 3.2-13.2l19.5-19.5-15.5-15.6-19.3 19.3c-2.1 2.1-4.7 3.5-7.6 3.9-5.5.7-10.7-1.9-13.4-7-.3-.6-.6-1.2-.8-1.9-1.5-4.9-.2-9.8 3.2-13.2l19.5-19.5-15.5-15.6-19.3 19.3c-2.1 2.1-4.7 3.5-7.6 3.9-5.5.7-10.7-1.9-13.4-7-.3-.6-.6-1.2-.8-1.9-1.5-4.9-.2-9.8 3.2-13.2l19.5-19.5-14.8-14.8c-4.9-4.9-4.9-12.7 0-17.6 4.9-4.9 12.7-4.9 17.6 0l14.8 14.8 19.3-19.3c2.1-2.1 4.7-3.5 7.6-3.9 5.5-.7 10.7 1.9 13.4 7 .3.6.6 1.2.8 1.9 1.5 4.9.2 9.8-3.2 13.2l-19.5 19.5 15.6 15.6 19.3-19.3c2-2 4.5-3.4 7.3-3.9 4.2-.7 8.4.7 11.3 3.6 1.5 1.4 2.6 3.2 3.2 5.2 1.5 4.9.2 9.8-3.2 13.2L257 239.4l15.6 15.6 19.3-19.3c2.1-2.1 4.7-3.5 7.6-3.9 5.5-.7 10.7 1.9 13.4 7 .3.6.6 1.2.8 1.9 1.5 4.9.2 9.8-3.2 13.2L291 273.4l15.6 15.6 19.3-19.3c2.2-2.2 5-3.6 8-4 4.4-.5 8.6 1.2 11.4 4.6 4.1 5 3.5 13.1-1.2 17.7zM395.1 464c27.6 0 48.8-1.8 58.8-2.9 3.7-.4 6.7-3.4 7.1-7.1 2-18.9 6.8-77.6-3.2-143.7L310.3 457.9c31 4.7 60.4 6.1 84.8 6.1zM116.8 48C89.3 48 68 49.8 58 50.9c-3.7.4-6.7 3.4-7.1 7.1-2 18.9-6.8 77.6 3.2 143.6L201.6 54.1c-31-4.7-60.4-6.1-84.8-6.1z"}}]})(props);
	};
	module.exports.IoIosAnalytics = function IoIosAnalytics (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zM76 256c0-48.1 18.7-93.3 52.7-127.3S207.9 76 256 76c48.1 0 93.3 18.7 127.3 52.7 32.2 32.2 50.7 74.5 52.6 119.7-8.8-10.3-24.2-24-43.8-24-27.5 0-41.7 25.7-51 42.7-1.4 2.5-2.7 4.9-3.9 7-11.4 19.2-27.3 30-42.5 28.9-13.4-.9-24.8-11.2-32.2-28.8-9.2-22.1-29.1-45.8-52.9-49.2-11.3-1.6-28.1.8-44.7 21.4-3.2 4-6.9 9.4-11.1 15.6-10.4 15.5-26.2 38.8-38.1 40.8-17.3 2.8-30.9-7.5-36.4-12.3-2.2-11.2-3.3-22.8-3.3-34.5z"}}]})(props);
	};
	module.exports.IoIosAperture = function IoIosAperture (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M250.2 371.4c-1.8 0-2.7 2.2-1.4 3.4l54.9 54.9L326 452c42.4-15.2 78.5-43.7 103.1-80.6H250.2zM167 334.6V444c27 12.8 57.1 20 89 20 14.1 0 27.9-1.4 41.2-4.1L170.4 333.2c-1.2-1.3-3.4-.4-3.4 1.4zM256 48c-13.9 0-27.4 1.4-40.5 4l126.8 126.8c1.3 1.3 3.4.4 3.4-1.4V68.3C318.6 55.3 288.2 48 256 48zM68.1 166.6C55.2 193.7 48 224 48 256c0 14.1 1.4 27.9 4.1 41.2L179.2 170c1.3-1.3.4-3.4-1.4-3.4H68.1zM186.7 59.9C144 75 107.7 103.6 83 140.7h179.7c1.8 0 2.7-2.2 1.4-3.4l-77.4-77.4zM167 220.6v70.7c0 1.1.4 2.1 1.2 2.8l50 50c.8.8 1.8 1.2 2.8 1.2h70.7c1.1 0 2.1-.4 2.8-1.2l50-50c.8-.8 1.2-1.8 1.2-2.8v-70.7c0-1.1-.4-2.1-1.2-2.8l-50-50c-.8-.8-1.8-1.2-2.8-1.2H221c-1.1 0-2.1.4-2.8 1.2l-50 50c-.7.8-1.2 1.8-1.2 2.8zM460 215.5L333.6 342c-1.3 1.3-.4 3.4 1.4 3.4h108.8c13-27.1 20.2-57.4 20.2-89.4 0-13.9-1.4-27.4-4-40.5zM371.8 83.2v179c0 1.8 2.2 2.7 3.4 1.4l76.9-76.9c-15-42.6-43.5-78.8-80.3-103.5zM60.1 325.9c15.2 42.6 43.9 78.8 81 103.4V249.8c0-1.8-2.2-2.7-3.4-1.4l-77.6 77.5z"}}]})(props);
	};
	module.exports.IoIosApps = function IoIosApps (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434.8 137.6L285.4 69.5c-16.2-7.4-42.7-7.4-58.9 0L77.2 137.6c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.9 7.7 44.7 7.7 61.6 0l148-67.5c17.6-8 17.6-21.1 0-29.1zM225.2 375.2l-99.8-45.5c-4.2-1.9-9.1-1.9-13.3 0l-34.9 15.9c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.9 7.7 44.7 7.7 61.6 0l148-67.5c17.6-8 17.6-21.1 0-29.1l-34.9-15.9c-4.2-1.9-9.1-1.9-13.3 0l-99.8 45.5c-16.9 7.7-44.7 7.7-61.6 0z"}},{"tag":"path","attr":{"d":"M434.8 241.6l-31.7-14.4c-4.2-1.9-9-1.9-13.2 0l-108 48.9c-15.3 5.2-36.6 5.2-51.9 0l-108-48.9c-4.2-1.9-9-1.9-13.2 0l-31.7 14.4c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.9 7.7 44.7 7.7 61.6 0l148-67.5c17.7-8 17.7-21.1.1-29.1z"}}]})(props);
	};
	module.exports.IoIosAppstore = function IoIosAppstore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm-78.9 296.9c-2.7 4.6-7.5 7.1-12.5 7.1-2.5 0-5-.6-7.3-2-6.9-4-9.2-12.8-5.2-19.7l14.2-23.6c1.5-2.5 4.1-4 7-4h2.1c10.3 0 17.5 6.2 19.6 12.2l-17.9 30zm120.2-46.4l-93 .1h-61.8c-8.2 0-14.8-6.8-14.4-15 .3-7.8 7.1-13.7 14.9-13.7h44.8l53.1-90.4-17.2-29.3c-3.9-6.7-2.2-15.5 4.4-19.7 7-4.5 16.2-2.2 20.3 4.8l9.2 15.7h.1l9.2-15.7c4.1-7 13.4-9.3 20.3-4.8 6.6 4.2 8.3 13 4.4 19.7l-17.2 29.3-16.7 28.5-36.3 61.9v.1h53.5c6.7 0 15.1 3.6 18.5 9.4l.3.6c3 5.1 4.7 8.6 4.7 13.7-.1 2.8-1.1 4.8-1.1 4.8zm72.2.1h-25.2v.1l18.4 31.3c4 6.8 2.1 15.8-4.8 20-2.3 1.4-4.9 2.1-7.5 2.1-5 0-9.8-2.6-12.5-7.1l-27.2-46.3-16.9-28.8-21.8-37.3c-6.4-10.9-6.7-24.5-.6-35.3 4.3-7.6 7.6-9.6 7.6-9.6l48.5 82.1h41.7c7.8 0 14.5 6 14.9 13.7.3 8.3-6.3 15.1-14.6 15.1z"}}]})(props);
	};
	module.exports.IoIosArchive = function IoIosArchive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M460 120H52c-2.2 0-4-1.8-4-4V96c0-17.7 14.3-32 32-32h352c17.7 0 32 14.3 32 32v20c0 2.2-1.8 4-4 4zM440 146H72c-4.4 0-8 3.6-8 8v262c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V154c0-4.4-3.6-8-8-8zM306 288h-99.6c-7.1 0-13.4-5.2-14.3-12.3-1-8.5 5.6-15.7 13.9-15.7h99.6c7.1 0 13.4 5.2 14.3 12.3 1 8.4-5.6 15.7-13.9 15.7z"}}]})(props);
	};
	module.exports.IoIosArrowBack = function IoIosArrowBack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"}}]})(props);
	};
	module.exports.IoIosArrowDown = function IoIosArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"}}]})(props);
	};
	module.exports.IoIosArrowDropdownCircle = function IoIosArrowDropdownCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S370.9 48 256 48 48 141.1 48 256zm289.1-43.4c7.5-7.5 19.8-7.5 27.3 0 3.8 3.8 5.6 8.7 5.6 13.6s-1.9 9.9-5.7 13.7l-94.3 94c-7.6 6.9-19.3 6.7-26.6-.6l-95.7-95.4c-7.5-7.5-7.6-19.7 0-27.3 7.5-7.5 19.7-7.6 27.3 0l81.1 81.9 81-79.9z"}}]})(props);
	};
	module.exports.IoIosArrowDropdown = function IoIosArrowDropdown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M147.6 210.7c-7.5 7.5-7.5 19.8 0 27.3l95.7 95.4c7.3 7.3 19.1 7.5 26.6.6l94.3-94c3.8-3.8 5.7-8.7 5.7-13.7 0-4.9-1.9-9.9-5.6-13.6-7.5-7.5-19.7-7.6-27.3 0l-81 79.8-81.1-81.9c-7.5-7.5-19.7-7.5-27.3.1z"}},{"tag":"path","attr":{"d":"M48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S370.9 48 256 48 48 141.1 48 256zm332.4-124.4C413.7 164.8 432 209 432 256s-18.3 91.2-51.6 124.4C347.2 413.7 303 432 256 432s-91.2-18.3-124.4-51.6C98.3 347.2 80 303 80 256s18.3-91.2 51.6-124.4C164.8 98.3 209 80 256 80s91.2 18.3 124.4 51.6z"}}]})(props);
	};
	module.exports.IoIosArrowDropleftCircle = function IoIosArrowDropleftCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm43.4 289.1c7.5 7.5 7.5 19.8 0 27.3-3.8 3.8-8.7 5.6-13.6 5.6s-9.9-1.9-13.7-5.7l-94-94.3c-6.9-7.6-6.7-19.3.6-26.6l95.4-95.7c7.5-7.5 19.7-7.6 27.3 0 7.5 7.5 7.6 19.7 0 27.3l-81.9 81 79.9 81.1z"}}]})(props);
	};
	module.exports.IoIosArrowDropleft = function IoIosArrowDropleft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M301.3 147.6c-7.5-7.5-19.8-7.5-27.3 0l-95.4 95.7c-7.3 7.3-7.5 19.1-.6 26.6l94 94.3c3.8 3.8 8.7 5.7 13.7 5.7 4.9 0 9.9-1.9 13.6-5.6 7.5-7.5 7.6-19.7 0-27.3l-79.8-81 81.9-81.1c7.5-7.5 7.5-19.7-.1-27.3z"}},{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm124.4 332.4C347.2 413.7 303 432 256 432s-91.2-18.3-124.4-51.6C98.3 347.2 80 303 80 256s18.3-91.2 51.6-124.4C164.8 98.3 209 80 256 80s91.2 18.3 124.4 51.6C413.7 164.8 432 209 432 256s-18.3 91.2-51.6 124.4z"}}]})(props);
	};
	module.exports.IoIosArrowDroprightCircle = function IoIosArrowDroprightCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S370.9 48 256 48 48 141.1 48 256zm244.5 0l-81.9-81.1c-7.5-7.5-7.5-19.8 0-27.3s19.8-7.5 27.3 0l95.4 95.7c7.3 7.3 7.5 19.1.6 26.6l-94 94.3c-3.8 3.8-8.7 5.7-13.7 5.7-4.9 0-9.9-1.9-13.6-5.6-7.5-7.5-7.6-19.7 0-27.3l79.9-81z"}}]})(props);
	};
	module.exports.IoIosArrowDropright = function IoIosArrowDropright (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M210.7 147.6c7.5-7.5 19.8-7.5 27.3 0l95.4 95.7c7.3 7.3 7.5 19.1.6 26.6l-94 94.3c-3.8 3.8-8.7 5.7-13.7 5.7-4.9 0-9.9-1.9-13.6-5.6-7.5-7.5-7.6-19.7 0-27.3l79.9-81.1-81.9-81.1c-7.6-7.4-7.6-19.6 0-27.2z"}},{"tag":"path","attr":{"d":"M48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S370.9 48 256 48 48 141.1 48 256zm32 0c0-47 18.3-91.2 51.6-124.4C164.8 98.3 209 80 256 80s91.2 18.3 124.4 51.6C413.7 164.8 432 209 432 256s-18.3 91.2-51.6 124.4C347.2 413.7 303 432 256 432s-91.2-18.3-124.4-51.6C98.3 347.2 80 303 80 256z"}}]})(props);
	};
	module.exports.IoIosArrowDropupCircle = function IoIosArrowDropupCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c114.9 0 208-93.1 208-208S370.9 48 256 48 48 141.1 48 256s93.1 208 208 208zm0-244.5l-81.1 81.9c-7.5 7.5-19.8 7.5-27.3 0s-7.5-19.8 0-27.3l95.7-95.4c7.3-7.3 19.1-7.5 26.6-.6l94.3 94c3.8 3.8 5.7 8.7 5.7 13.7 0 4.9-1.9 9.9-5.6 13.6-7.5 7.5-19.7 7.6-27.3 0l-81-79.9z"}}]})(props);
	};
	module.exports.IoIosArrowDropup = function IoIosArrowDropup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M147.6 301.3c-7.5-7.5-7.5-19.8 0-27.3l95.7-95.4c7.3-7.3 19.1-7.5 26.6-.6l94.3 94c3.8 3.8 5.7 8.7 5.7 13.7 0 4.9-1.9 9.9-5.6 13.6-7.5 7.5-19.7 7.6-27.3 0l-81-79.8-81.1 81.9c-7.5 7.5-19.7 7.5-27.3-.1z"}},{"tag":"path","attr":{"d":"M256 464c114.9 0 208-93.1 208-208S370.9 48 256 48 48 141.1 48 256s93.1 208 208 208zm0-32c-47 0-91.2-18.3-124.4-51.6C98.3 347.2 80 303 80 256s18.3-91.2 51.6-124.4C164.8 98.3 209 80 256 80s91.2 18.3 124.4 51.6C413.7 164.8 432 209 432 256s-18.3 91.2-51.6 124.4C347.2 413.7 303 432 256 432z"}}]})(props);
	};
	module.exports.IoIosArrowForward = function IoIosArrowForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"}}]})(props);
	};
	module.exports.IoIosArrowRoundBack = function IoIosArrowRoundBack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216.4 163.7c5.1 5 5.1 13.3.1 18.4L155.8 243h231.3c7.1 0 12.9 5.8 12.9 13s-5.8 13-12.9 13H155.8l60.8 60.9c5 5.1 4.9 13.3-.1 18.4-5.1 5-13.2 5-18.3-.1l-82.4-83c-1.1-1.2-2-2.5-2.7-4.1-.7-1.6-1-3.3-1-5 0-3.4 1.3-6.6 3.7-9.1l82.4-83c4.9-5.2 13.1-5.3 18.2-.3z"}}]})(props);
	};
	module.exports.IoIosArrowRoundDown = function IoIosArrowRoundDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M348.3 295.6c-5-5.1-13.3-5.1-18.4-.1L269 356.2V124.9c0-7.1-5.8-12.9-13-12.9s-13 5.8-13 12.9v231.3l-60.9-60.8c-5.1-5-13.3-4.9-18.4.1-5 5.1-5 13.2.1 18.3l83 82.4c1.2 1.1 2.5 2 4.1 2.7 1.6.7 3.3 1 5 1 3.4 0 6.6-1.3 9.1-3.7l83-82.4c5.2-4.9 5.3-13.1.3-18.2z"}}]})(props);
	};
	module.exports.IoIosArrowRoundForward = function IoIosArrowRoundForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M295.6 163.7c-5.1 5-5.1 13.3-.1 18.4l60.8 60.9H124.9c-7.1 0-12.9 5.8-12.9 13s5.8 13 12.9 13h231.3l-60.8 60.9c-5 5.1-4.9 13.3.1 18.4 5.1 5 13.2 5 18.3-.1l82.4-83c1.1-1.2 2-2.5 2.7-4.1.7-1.6 1-3.3 1-5 0-3.4-1.3-6.6-3.7-9.1l-82.4-83c-4.9-5.2-13.1-5.3-18.2-.3z"}}]})(props);
	};
	module.exports.IoIosArrowRoundUp = function IoIosArrowRoundUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M348.3 216.4c-5 5.1-13.3 5.1-18.4.1L269 155.8v231.3c0 7.1-5.8 12.9-13 12.9s-13-5.8-13-12.9V155.8l-60.9 60.8c-5.1 5-13.3 4.9-18.4-.1-5-5.1-5-13.2.1-18.3l83-82.4c1.2-1.1 2.5-2 4.1-2.7 1.6-.7 3.3-1 5-1 3.4 0 6.6 1.3 9.1 3.7l83 82.4c5.2 4.9 5.3 13.1.3 18.2z"}}]})(props);
	};
	module.exports.IoIosArrowUp = function IoIosArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"}}]})(props);
	};
	module.exports.IoIosAt = function IoIosAt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 234.3c0 74.1-34.7 120.8-89.6 120.8-28.1 0-49.5-15-53.2-37.3h-4c-9.9 23.2-30.3 35.9-57.7 35.9-48.8 0-81.4-39.1-81.4-97.3 0-55.9 32.8-94.8 80.7-94.8 24.6 0 45.5 12.4 54.7 32.7h4v-27.8h39.9v129.3c0 16.1 8.9 25.8 24.9 25.8 27.7 0 45.3-33.6 45.3-85.8 0-83.3-62.4-139-154.6-139-91.2 0-156.2 66.5-156.2 160.6 0 96.2 64.3 157.6 164.4 157.6 19.6 0 39.3-1.7 54.4-4.6 9.8-1.8 18.8 5.6 18.8 15.5 0 7.3-5 13.7-12.1 15.4-18.2 4.3-40.1 6.8-62.7 6.8C141.9 448 64 372.8 64 256.1 64 142.2 143.5 64 259.4 64 370.8 64 448 133.5 448 234.3zm-242.8 23c0 37 17.4 59.4 45.7 59.4 29.8 0 48.6-23 48.6-59.4s-18.8-58.9-48.1-58.9c-29.1 0-46.2 21.8-46.2 58.9z"}}]})(props);
	};
	module.exports.IoIosAttach = function IoIosAttach (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M355.9 161.1c-8.6 0-15.6 7-15.6 15.6v194.4c0 20.3-8 40.4-22 55.1-13.9 14.6-35.2 23.7-55.5 23.7h-13.6c-19.6 0-39.5-8.9-54.8-24.6-15.2-15.5-23.9-35.6-23.9-55.2V119.3c0-14.9 6.2-28.9 17.3-39.5 11.1-10.5 25.7-16.3 41-16.3 15.1 0 29.3 5.8 39.8 16.2 10.5 10.5 16.4 24.6 16.4 39.6v234.2c0 17.1-13.6 32.2-29 32.2-13.6 0-28.2-12.9-28.2-32.2V219.9c0-8.6-7-15.6-15.6-15.6s-15.6 7-15.6 15.6v133.6c0 35.5 25.5 62.3 59.4 62.3 16.5 0 31.7-6.1 42.7-17.3 11.3-11.4 17.5-27.4 17.5-45V119.3c0-23.4-9.1-45.4-25.7-61.8C274 41 252 32 228.5 32s-45.5 9-62.2 25.5c-16.7 16.5-25.9 38.4-25.9 61.9v250.8c0 28.7 12.2 57.9 32.6 78 20.9 20.6 47.9 31.9 76.1 31.9h13.6c27.6 0 55.3-11.7 75.9-32.1 10.2-10.1 18.2-21.7 23.9-34.6 5.9-13.5 8.9-27.7 8.9-42.1V176.7c.1-8.6-6.9-15.6-15.5-15.6z"}}]})(props);
	};
	module.exports.IoIosBackspace = function IoIosBackspace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M395 96H230c-46.7 0-73.2 34.7-102 63.5s-72.1 74.7-72.1 74.7C51 239.8 48 247 48 255.1c0 8 3 15.3 7.9 21 0 0 34.3 37.6 72.1 75.5 37.8 37.8 56.7 64.5 102 64.5h165c38.5 0 69-32.5 69-71V165c0-38.5-30.5-69-69-69zm-17.7 212.7c6.2 6.2 6.2 16.4 0 22.6-6.2 6.2-16.4 6.2-22.6 0L302 278.6l-52.7 52.7c-6.2 6.2-16.3 6.4-22.6 0-6.4-6.4-6.7-15.9 0-22.6l52.7-52.7-52.7-52.7c-6-6-7.1-15.6 0-22.6 7.1-7.1 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6L324.6 256l52.7 52.7z"}}]})(props);
	};
	module.exports.IoIosBarcode = function IoIosBarcode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M121.6 388H80.8c-2.2 0-4-1.8-4-4V128c0-2.2 1.8-4 4-4h40.5c7.9 0 14.5-6.4 14.7-14 .1-3.9-1.3-7.2-4.1-10-2.7-2.8-8-4-11.9-4H66c-10 0-18 6-18 16v288c0 10 7 16 17 16h56.3c7.9 0 14.5-5.2 14.7-12.8.1-3.9-1.3-7.5-4.1-10.3-2.7-2.8-6.4-4.9-10.3-4.9zM447 96h-56.3c-9.5 0-17.1 8.3-14 18.3.2.7.5 1.3.8 1.9 2.7 5.2 7.6 7.8 12.9 7.8h40.8c2.2 0 4 1.8 4 4v255.9c0 2.2-1.8 4-4 4h-40.5c-7.9 0-14.5 6.2-14.7 13.9-.1 3.9 1.3 7.6 4.1 10.4 2.7 2.8 6.4 3.8 10.3 3.8H447c10 0 17-6 17-16.4V112c0-10-7-16-17-16z"}},{"tag":"path","attr":{"d":"M122.5 176c-7.7 0-14 6.3-14 13.9V322c0 7.7 6.3 13.9 14 13.9s14-6.3 14-13.9V189.9c0-7.6-6.3-13.9-14-13.9zM389.5 336c7.7 0 14-6.3 14-13.9V189.9c0-7.7-6.3-13.9-14-13.9s-14 6.3-14 13.9V322c0 7.7 6.3 14 14 14zM326.5 144c-7.7 0-14 6.5-14 14.4v195.1c0 8 6.3 14.4 14 14.4s14-6.5 14-14.4V158.4c0-7.9-6.3-14.4-14-14.4zM185.5 144c-7.7 0-14 6.5-14 14.4v195.1c0 8 6.3 14.4 14 14.4s14-6.5 14-14.4V158.4c0-7.9-6.2-14.4-14-14.4zM256 160c-7.7 0-14 6.4-14 14.2v163.5c0 7.8 6.3 14.2 14 14.2s14-6.4 14-14.2V174.2c0-7.8-6.3-14.2-14-14.2z"}}]})(props);
	};
	module.exports.IoIosBaseball = function IoIosBaseball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.3 74.2l9.7-3.1c4.7-1.5 9.7 1.1 11.2 5.7l.1.4c1.5 4.7-1.1 9.7-5.7 11.2L260.1 92c-2.1.7-3.2 2.9-2.6 4.9 2.1 6.9 4.5 13.7 7.2 20.5 1.9 4.6 3.9 9.2 6.1 13.7 1.1 2.2 3.8 3 5.9 1.6l8.5-5.8c4.1-2.7 9.6-1.7 12.3 2.4l.2.3c2.7 4.1 1.7 9.6-2.4 12.3l-10.4 7.1a4 4 0 0 0-1.2 5.4c7 11 14.9 21.5 23.7 31.3 1.5 1.7 4.2 1.8 5.8.2l7.5-7.5c3.5-3.5 9.1-3.5 12.5 0l.3.3c3.5 3.5 3.5 9.1 0 12.5l-7.5 7.5c-1.6 1.6-1.5 4.3.2 5.8 10.2 9.1 21 17.3 32.5 24.4a4 4 0 0 0 5.4-1.2l6.9-10.2c2.7-4.1 8.3-5.1 12.3-2.4l.3.2c4.1 2.7 5.1 8.3 2.4 12.3l-5.5 8.1c-1.4 2-.6 4.8 1.6 5.9 4.1 1.9 8.2 3.8 12.4 5.5 7.1 2.9 14.3 5.4 21.7 7.6 2.1.6 4.3-.5 5-2.6l3.5-10.8c1.5-4.7 6.5-7.2 11.2-5.7l.4.1c4.7 1.5 7.2 6.5 5.7 11.2l-2.8 8.8c-.7 2.3.7 4.7 3.1 5.2 7.1 1.3 14.3 2.3 21.5 2.9.1-2.6.2-5.3.2-7.9 0-114.9-93.1-208-208-208-2.7 0-5.3.1-8 .2.7 7.7 1.7 15.3 3.1 22.9.4 2.5 2.9 3.9 5.2 3.2zM258 447.2c-.4-2.4-2.8-3.9-5.2-3.2l-11.6 3.7c-4.7 1.5-9.7-1.1-11.2-5.7l-.1-.4c-1.5-4.7 1.1-9.7 5.7-11.2l13.8-4.4c2-.7 3.2-2.8 2.6-4.9-2.3-7.9-5-15.6-8.1-23.3-1.6-4-3.3-7.9-5.2-11.8-1-2.2-3.8-3-5.9-1.6l-10.9 7.4c-4.1 2.7-9.6 1.7-12.3-2.4l-.2-.3c-2.7-4.1-1.7-9.6 2.4-12.3l13-8.8a4 4 0 0 0 1.2-5.4c-7.2-11.7-15.5-22.7-24.8-33.1-1.5-1.7-4.2-1.8-5.8-.2l-9.9 9.9c-3.5 3.5-9.1 3.5-12.5 0l-.3-.3c-3.5-3.5-3.5-9.1 0-12.5l9.9-9.9c1.6-1.6 1.5-4.3-.2-5.8-10-9-20.6-17-31.9-24a4 4 0 0 0-5.4 1.2l-9 13.3c-2.7 4.1-8.3 5.1-12.3 2.4l-.3-.2c-4.1-2.7-5.1-8.3-2.4-12.3l7.6-11.3c1.4-2 .6-4.8-1.6-5.9-4.3-2.1-8.6-4-13.1-5.8-7.3-2.9-14.6-5.5-22.1-7.7-2-.6-4.3.6-4.9 2.6l-4.6 14.4c-1.5 4.7-6.5 7.2-11.2 5.7l-.4-.1c-4.7-1.5-7.2-6.5-5.7-11.2l4-12.4c.7-2.3-.7-4.8-3.1-5.2-5.8-1-11.7-1.8-17.6-2.4-.1 0-.3 0-.4-.1v4.2c0 114.9 93.1 208 208 208h4.2c0-.1-.1-.3-.1-.4-.5-5.4-1.2-10.9-2.1-16.3z"}},{"tag":"path","attr":{"d":"M431.1 280.9l-5.9 18.4c-1.5 4.7-6.5 7.2-11.2 5.7l-.4-.1c-4.7-1.5-7.2-6.5-5.7-11.2l5.3-16.6c.7-2.1-.5-4.4-2.7-5.1-13.5-4-26.8-9.2-39.7-15.6-1.8-.9-4-.3-5.1 1.3l-10.5 15.4c-2.7 4.1-8.3 5.1-12.3 2.4l-.3-.2c-4.1-2.7-5.1-8.3-2.4-12.3l9.2-13.6c1.3-1.9.7-4.4-1.2-5.6-12.3-7.7-24.1-16.6-35.2-26.7-1.6-1.4-4-1.4-5.5.1L294.7 230c-3.5 3.5-9.1 3.5-12.5 0l-.3-.3c-3.5-3.5-3.5-9.1 0-12.5l12.8-12.8c1.5-1.5 1.6-3.9.1-5.5-9.7-10.8-18.4-22.2-26-34-1.2-1.9-3.8-2.5-5.6-1.2l-13.3 9c-4.1 2.7-9.6 1.7-12.3-2.4l-.2-.3c-2.7-4.1-1.7-9.6 2.4-12.3l15.1-10.2c1.7-1.1 2.2-3.3 1.3-5.1-6.4-12.9-11.7-26.2-15.8-39.7-.7-2.1-2.9-3.4-5.1-2.7l-15.9 5.1c-4.7 1.5-9.7-1.1-11.2-5.7l-.1-.4c-1.5-4.7 1.1-9.7 5.7-11.2l17.6-5.6c1.9-.6 3.1-2.6 2.7-4.6-1.8-9.2-3.1-18.6-3.9-27.9-95.4 11.8-170.8 88.2-181 184.1h1c7.5.7 15 1.8 22.4 3.2 2 .4 4-.8 4.6-2.7l4.7-14.8c1.5-4.7 6.5-7.2 11.2-5.7l.4.1c4.7 1.5 7.2 6.5 5.7 11.2l-4.2 13c-.7 2.2.5 4.4 2.7 5.1 13.9 4.1 27.5 9.4 40.7 16 1.8.9 4 .3 5.1-1.3l8.3-12.3c2.7-4.1 8.3-5.1 12.3-2.4l.3.2c4.1 2.7 5.1 8.3 2.4 12.3l-7.1 10.5c-1.3 1.9-.7 4.4 1.2 5.6 12.1 7.7 23.7 16.4 34.6 26.3 1.6 1.4 4 1.4 5.5-.1l10.4-10.4c3.5-3.5 9.1-3.5 12.5 0l.3.3c3.5 3.5 3.5 9.1 0 12.5L214 310.8c-1.5 1.5-1.6 3.9-.1 5.5 10.2 11.3 19.2 23.3 27 35.8 1.2 2 3.7 2.5 5.7 1.2l10.8-7.3c4.1-2.7 9.6-1.7 12.3 2.4l.2.3c2.7 4.1 1.7 9.6-2.4 12.3l-12.7 8.6c-1.7 1.1-2.2 3.3-1.3 5.1 6.4 13.2 11.7 26.7 15.7 40.6.6 2.2 2.9 3.4 5.1 2.7l13.6-4.4c4.7-1.5 9.7 1.1 11.2 5.7l.1.4c1.5 4.7-1.1 9.7-5.7 11.2l-15.6 5c-1.9.6-3.1 2.6-2.7 4.6 1.3 7 2.3 14.1 3 21.2v1c95.9-10.2 172.3-85.6 184.1-181-8.9-.7-17.9-1.9-26.7-3.6-1.9-.3-3.9.9-4.5 2.8z"}}]})(props);
	};
	module.exports.IoIosBasket = function IoIosBasket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M387.9 373.7h49.2l17.5-75.4h-66.7zM387.9 448h.5c18.7 0 33.4-12.5 38.3-29.5l6-25.9h-44.8V448zM265.4 392.5h103.7V448H265.4zM75 373.7h49v-75.4H57.5zM142.9 192h103.7v87.5H142.9zM265.4 192h103.7v87.5H265.4zM85.5 418.3c4.7 17 19.4 29.7 38.1 29.7h.5v-55.5H79.4l6.1 25.8zM142.9 392.5h103.7V448H142.9zM265.4 298.3h103.7v75.4H265.4zM142.9 298.3h103.7v75.4H142.9z"}},{"tag":"path","attr":{"d":"M464 192h-47.9V96c0-17.6-14.4-32-32-32H127.9c-17.6 0-32 14.4-32 32v96H48c-10.3 0-17.9 9.6-15.6 19.6l19.7 67.9H124V106c0-7.7 6.3-14 14-14h236c7.7 0 14 6.3 14 14v173.5h72l19.6-67.9c2.3-10-5.3-19.6-15.6-19.6z"}}]})(props);
	};
	module.exports.IoIosBasketball = function IoIosBasketball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M218.6 306.4c14.3-11.8 28.3-24.4 41.4-37.6l6.1-6.1c-2.8-2.9-5.6-5.8-8.3-8.5-49.9-49.9-107.7-89.6-171.8-118.1-18.4 26.1-31 56.6-35.8 89.6 32.2 2.3 63.2 10.5 92.2 24.5 28.8 13.9 54.4 32.8 76.2 56.2zM326.1 185.6c.5.5 1.1 1.1 1.7 1.6 20.9-30.5 38.8-63.2 53.5-97.4-33.8-25.5-75.6-41-121-41.9 2.4 22.3 8 44.1 16.7 64.7 11.5 27.4 28.1 52 49.1 73zM399 234.8c20.7 8.8 42.6 14.4 65 16.7-1.2-56.3-24.8-107.1-62.2-143.9-15 33.8-33.3 66.3-54.4 96.8 15.8 12.4 33.2 22.6 51.6 30.4zM193.9 318.1c-21.1-21.1-45.6-37.6-72.9-49.2-23.2-9.8-47.7-15.6-72.9-17.4 0 1.5-.1 3-.1 4.4 0 48.7 16.7 93.5 44.8 128.9 37.3-17 72.7-37.9 105.4-62.4-1.5-1.4-2.9-2.9-4.3-4.3zM283.8 243.6c10.1-11.3 19.7-23.1 28.8-35.1-44.5-42.3-72.1-98.6-78.2-159.5-51.9 5.4-98.1 29.8-131.5 66.2 33.4 15.3 65.5 33.8 95.6 55.1 30.5 21.7 59.2 46.3 85.3 73.3zM301.4 262.8c38.9 44 70.9 93.2 95.3 146.4 36.4-33.5 60.9-79.8 66.2-131.7-47.7-4.7-92.8-22.6-130.8-52-9.6 12.7-20 25.3-30.7 37.3zM235.3 326.2c29.9 39.5 47.5 86.2 51 135.6 33-4.8 63.5-17.4 89.5-35.8-23.4-52.6-54.3-101-92.2-144.2-15.2 15.6-31.4 30.5-48.3 44.4zM214.9 342.3c-32.4 24.4-67.4 45.5-104 62.8 37.5 36.5 88.6 59 145.1 59 1.5 0 3 0 4.5-.1-1.8-25.2-7.6-49.7-17.4-72.9-7.4-17.5-16.8-33.8-28.2-48.8z"}}]})(props);
	};
	module.exports.IoIosBatteryCharging = function IoIosBatteryCharging (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396 144H64c-26.4 0-48 21.6-48 48v128c0 26.4 21.6 48 48 48h332c26.4 0 48-21.6 48-48V192c0-26.4-21.6-48-48-48zm20 176c0 11-9 20-20 20H64c-11 0-20-9-20-20V192c0-11 9-20 20-20h332c11 0 20 9 20 20v128zM464 204.6v102.8c16 0 32-27.7 32-51.4s-16-51.4-32-51.4z"}},{"tag":"path","attr":{"d":"M384 192H76c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h308c6.6 0 12-5.4 12-12V204c0-6.6-5.4-12-12-12zM218.8 308l8.4-43H200l45.2-61-8.4 43H264l-45.2 61z"}}]})(props);
	};
	module.exports.IoIosBatteryDead = function IoIosBatteryDead (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396 144H64c-26.4 0-48 21.6-48 48v128c0 26.4 21.6 48 48 48h332c26.4 0 48-21.6 48-48V192c0-26.4-21.6-48-48-48zm20 176c0 11-9 20-20 20H64c-11 0-20-9-20-20V192c0-11 9-20 20-20h332c11 0 20 9 20 20v128zM464 204.6v102.8c16 0 32-27.7 32-51.4s-16-51.4-32-51.4z"}}]})(props);
	};
	module.exports.IoIosBatteryFull = function IoIosBatteryFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396 144H64c-26.4 0-48 21.6-48 48v128c0 26.4 21.6 48 48 48h332c26.4 0 48-21.6 48-48V192c0-26.4-21.6-48-48-48zm20 176c0 11-9 20-20 20H64c-11 0-20-9-20-20V192c0-11 9-20 20-20h332c11 0 20 9 20 20v128zM464 204.6v102.8c16 0 32-27.7 32-51.4s-16-51.4-32-51.4z"}},{"tag":"path","attr":{"d":"M384 192H76c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h308c6.6 0 12-5.4 12-12V204c0-6.6-5.4-12-12-12z"}}]})(props);
	};
	module.exports.IoIosBeaker = function IoIosBeaker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M445.2 48H128.5C74.1 48 64 75.9 64 88.2c30.3 4.2 32 4.2 32 36.2v275.5c0 35.3 28.9 64 64.2 64H368c35.4 0 63-29.2 63-64.5V89.2c2-17.5 12.5-31.6 13.6-33.3 1.2-1.9 3.4-4.4 3.4-5.5 0-1.2-.3-2.4-2.8-2.4zm-333 29.3c0-.1 0-.1 0 0 6-1 12-1.3 16.3-1.3H405c-.9 3.7-1.5 7.1-1.8 10-.1 1.1-.2 2.1-.2 3.2v70.9-.1H124v-35.5c0-17.6 0-34.2-11.8-47.2z"}}]})(props);
	};
	module.exports.IoIosBed = function IoIosBed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458.2 208h-.4c-12 0-21.8 9.8-21.8 21.8 0 1.2-1 2.2-2.2 2.2H78.2c-1.2 0-2.2-1-2.2-2.2 0-12-9.8-21.8-21.8-21.8h-.4c-12 0-21.8 9.8-21.8 21.8v180.4c0 12 9.8 21.8 21.8 21.8h.4c12 0 21.8-9.8 21.8-21.8V404c0-2.2 1.8-4 4-4h352c2.2 0 4 1.8 4 4v6.2c0 12 9.8 21.8 21.8 21.8h.4c12 0 21.8-9.8 21.8-21.8V229.8c0-12-9.8-21.8-21.8-21.8z"}},{"tag":"path","attr":{"d":"M84 214h22.5c2.2 0 4-1.8 4-4v-13c0-8.8 7.2-16 16-16H224c8.8 0 16 7.2 16 16v13c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4v-13c0-8.8 7.2-16 16-16h97.5c8.8 0 16 7.2 16 16v13c0 2.2 1.8 4 4 4H428c4.4 0 8-3.6 8-8v-94c0-17.6-14.4-32-32-32H108c-17.6 0-32 14.4-32 32v94c0 4.4 3.6 8 8 8z"}}]})(props);
	};
	module.exports.IoIosBeer = function IoIosBeer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M112 162c0-13.3 10.7-24 24-24h229.5c4.9 0 9.6 1.5 13.5 4.4 2 1.5 4.9 0 4.8-2.5-.1-5.7-.2-9.3-.2-21.6 0-20.8-17.2-38.3-38.1-38.3h-.2c-5.7-.4-10.8-4-12.9-9.3-9-22.6-32.3-38.6-56.4-38.6-21 0-34.2 7-44 18.3-4.4 5-11.8 5.9-17.4 2.4-7.3-4.6-16.1-7.1-25.5-7.1-14.4 0-27.2 7.1-35.8 17.4-4 4.9-10.4 7-16.6 5.9-5.2-1-12.6-1.8-22.7-1.8-25 0-50 16.6-50 42.4v4c0 28.8 16 22.9 16 41.8v50.8c0 13.4-11.2 19.3-11.2 35.2 0 8.8 8 16.8 16.8 16.8H112V162zM386 452H110c-7.7 0-14 6.3-14 14s6.3 14 14 14h276c7.7 0 14-6.3 14-14s-6.3-14-14-14z"}},{"tag":"path","attr":{"d":"M400 194h-32v-24c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v213.8c0 12.1-1.1 18.2-3.2 30.1l-.1.5c-.8 4.7.2 9.5 2.8 13.5 3.4 5.1 9.1 8.2 15.3 8.2h213.9c4.1 0 8.1-1.4 11.1-4.1 4.7-4.1 6.5-10.3 5.2-16-2.7-11.8-4.5-17.8-4.8-29.9H400c26.4 0 48-21.6 48-48v-96c0-26.5-21.6-48.1-48-48.1zm20 144c0 11-9 20-20 20h-32V222h32c11 0 20 9 20 20v96z"}}]})(props);
	};
	module.exports.IoIosBicycle = function IoIosBicycle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M125.3 289.3c17.3 0 33.7 6.8 46.1 19.2 12.4 12.4 19.2 28.8 19.2 46.1s-6.8 33.7-19.2 46.1c-12.4 12.4-28.8 19.2-46.1 19.2s-33.7-6.8-46.1-19.2C66.8 388.4 60 372 60 354.7s6.8-33.7 19.2-46.1c12.4-12.4 28.8-19.3 46.1-19.3m0-28c-51.3 0-93.3 42-93.3 93.3C32 406 74 448 125.3 448s93.3-42 93.3-93.3c.1-51.4-41.9-93.4-93.3-93.4zM319.8 127.8c17.8 0 32-14.2 32-32S337.8 64 320 64s-32.2 14-32.2 31.8c0 17.7 14.3 32 32 32zM386.7 289.3c17.3 0 33.7 6.8 46.1 19.2 12.4 12.4 19.2 28.8 19.2 46.1s-6.8 33.7-19.2 46.1C420.4 413.2 404 420 386.7 420s-33.7-6.8-46.1-19.2c-12.4-12.4-19.2-28.8-19.2-46.1s6.8-33.7 19.2-46.1c12.3-12.4 28.7-19.3 46.1-19.3m0-28c-51.3 0-93.3 42-93.3 93.3s42 93.3 93.3 93.3 93.3-42 93.3-93.3-42-93.3-93.3-93.3z"}},{"tag":"path","attr":{"d":"M368 192h-48l-29.5-60.1c-5.6-9.3-15.9-15.9-27.1-15.9-8.4 0-16.8 3.7-22.4 9.3l-71.7 69.1c-5.6 5.6-9.3 14-9.3 22.4 0 17.4 12.6 23.6 18.5 27.1C224 270.1 240 273 240 286.1V352c0 8.8 7.2 16 16 16s16-7.2 16-16v-90c0-13.2-30.4-24-48.3-38l48.9-51.5c18.7 28.5 27.3 51.5 38 51.5H368c8.8 0 16-7.2 16-16s-7.2-16-16-16z"}}]})(props);
	};
	module.exports.IoIosBluetooth = function IoIosBluetooth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M378.5 333l-88.3-77 88.2-76.1c6.9-6 7.4-16.3 1.1-22.9L262.7 35.6c-2.2-2.3-5.4-3.6-8.6-3.6-6.1 0-11.1 4.9-11.1 10.8V212l-86.3-73.3c-7.1-6-17.8-5.3-24.1 1.5-6.5 7-5.8 17.9 1.6 24.1L243 256l-108.1 90.9c-7.3 6.1-8.1 16.8-1.7 23.9l.3.3c6.3 7 17.3 7.7 24.5 1.5l85-73.6v169.8c0 6.2 5.1 11.2 11.5 11.2 3.2 0 6.2-1.3 8.4-3.5L379.6 356c6.3-6.6 5.8-16.9-1.1-23zm-99.1-232.1l62.7 65.9c.8.8.7 2.1-.2 2.9l-62.7 53c-1.3 1.1-3.4.2-3.4-1.5V102.3c.1-1.9 2.4-2.7 3.6-1.4zm-3.5 309V291.6c0-1.7 2.1-2.6 3.4-1.5l62.7 53c.9.7.9 2 .2 2.9l-62.7 65.3c-1.3 1.3-3.6.4-3.6-1.4z"}}]})(props);
	};
	module.exports.IoIosBoat = function IoIosBoat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M351.8 422c-26.2 9.2-66.5 14.9-96.1 14.9-29.6 0-69.9-5.7-96.1-14.9 0 0-26.1 23.9-62.3 36.2-2.3.8-1.5 4.2.9 3.9 22.6-2.6 40.2-6.5 61.4-12 23 9 66.7 13.9 96.1 13.9 29.4 0 74.1-3.8 96.1-13.9 21.5 5.6 38.8 9.6 62 12.1 2.4.3 3.2-3.1.9-3.9-35.7-12.4-62.9-36.3-62.9-36.3zM445.5 263l-186.2-85.5c-2.1-1-4.6-1-6.7 0L66.5 263c-6.2 2.9-10.5 9.1-10.5 16.4 0 2.4.5 4.6 1.3 6.7L112 422c27.5 0 56.7-22 56.7-22 18 9 53.1 17.1 79.3 18.6 2.8.2 5.5.2 8 .2s5.2-.1 8-.2c26.2-1.5 61.3-9.5 79.3-18.6 0 0 29.2 22 56.7 22l54.7-135.9c.8-2.1 1.3-4.3 1.3-6.7 0-7.3-4.3-13.5-10.5-16.4zM212 288c-6.6 0-12-9.8-12-22s5.4-22 12-22 12 9.8 12 22-5.4 22-12 22zm88 0c-6.6 0-12-9.8-12-22s5.4-22 12-22 12 9.8 12 22-5.4 22-12 22z"}},{"tag":"path","attr":{"d":"M391.9 127v-.1C386.3 100.3 374.4 80 352 80h-34.6l-2-8c-3.6-14.1-16.4-24-31-24h-57c-14.6 0-27.4 9.9-31 24.1l-2 7.9H160c-22.9 0-35.1 20.7-39.8 47L102 223.8c-.6 3.2 2.6 5.7 5.6 4.4l25.3-11.6c1.2-.5 2-1.6 2.3-2.9l16.2-85.6c2.5-10.7 7.3-16 16.1-16h177.1c8.9 0 13.1 5 16.1 16l16.2 85.6c.2 1.3 1.1 2.4 2.3 2.9l25.4 11.7c3 1.4 6.2-1.2 5.6-4.4L391.9 127z"}}]})(props);
	};
	module.exports.IoIosBody = function IoIosBody (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"ellipse","attr":{"cx":"256","cy":"80","rx":"48","ry":"48"}},{"tag":"path","attr":{"d":"M424 144H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h98.5c5.6 1 13.2 3.8 17.2 14.2 4.7 12.1 2.4 33.6-.5 51.7l-3.8 21.4c0 .1 0 .2-.1.3l-30.4 172.2c-2.3 13 6.4 25.5 19.5 27.8 13.1 2.3 25.3-6.4 27.6-19.5l21-119.9v.2s6.2-32.5 18.5-32.5h1.1c12.5 0 18.5 32.5 18.5 32.5v-.1l21 119.9c2.3 13 14.7 21.7 27.7 19.4 13.1-2.3 21.7-14.8 19.4-27.8l-30.4-172.2c0-.1 0-.2-.1-.3l-3.8-21.4c-2.9-18.1-5.2-39.6-.5-51.7 4-10.4 11.6-13.2 17.2-14.2H424c13.3 0 24-10.7 24-24s-10.7-24-24-24z"}}]})(props);
	};
	module.exports.IoIosBonfire = function IoIosBonfire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M270.9 350.6c-.7-8.2-7.6-14.6-15.9-14.6-7.6 0-14 5.4-15.6 12.5L223.8 427c-.5 2.3-.8 4.6-.8 7 0 17.7 14.3 30 32 30s32-12.3 32-30c0-2.9-.4-5.7-1.1-8.4l-15-75zM305.9 355zM388.9 386.3c-1.7-1.4-3.3-2.9-5.1-3.9l-59.6-43.5c-5.8-3.8-12-3.7-16.5.9-4.1 4.1-4.7 10.4-1.7 15.4l45 61.8c.9 1.5 2.2 2.8 3.4 4.2 7.8 9.1 25.1 9.6 34.6 0 9.4-9.8 9.3-27.2-.1-34.9zM372.5 335zM435.4 320h-59.5c-3.9 0-7.4 2.2-8.1 6.2-.6 3.6 1.3 7.1 4.7 8.8h.1l57.7 17.8c8.3 1.9 17.7-5.5 17.7-14.8 0-11.8-4.8-18-12.6-18zM139.2 335zM139.2 335c3.3-1.6 5.3-5.2 4.7-8.8-.7-4-3.9-6.2-8.1-6.2H76.3c-7.6 0-12.3 8.3-12.3 17.6s9.1 17.1 17.4 15.2l57.7-17.8h.1zM187.9 338.8l-59.6 43.4c-1.8 1.1-3.6 2.4-5.1 3.9-9.6 9.6-9.6 25.1 0 34.6 9.6 9.6 25.1 9.6 34.6 0 1.3-1.3 2.4-2.7 3.4-4.2l45-61.6c3-5 2.5-11.2-1.7-15.3-4.6-4.5-11.8-4.8-16.6-.8zM358.7 138.7c0-57.6-72.4-90.7-96-90.7 12 80.8-101.7 113-112 181.3-10.3 68.3 48 90.7 48 90.7 16.3-56.6 72.4-75.6 109.7-99.8 40.7-26.4 50.3-51.3 50.3-81.5zM358.7 259.6c5-14.7 1.9-49.3-3-63.4-9 17.5-26.3 32.4-47.2 46-8.6 5.6-20.9 10.8-29.8 15.9-18.7 10.5-34 20.6-46.3 34.4 11.3 16.4 31.3 27.7 46.3 27.7 36-.2 64-13.7 80-60.6z"}},{"tag":"path","attr":{"d":"M161.8 171.9c11.7-15.1 24.9-23.8 38.2-36.2 13.4-12.5 22.1-21.2 27.5-31.3-10.7-20.1-30.8-28.1-44.7-26.1 2.3 28.6-30 44-32 64.8-1.3 12.6 5.4 25 11 28.8z"}}]})(props);
	};
	module.exports.IoIosBook = function IoIosBook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M146 64.1c54.1 0 100 27.9 100 82V446c0 2.2-3.1 2.7-3.8.7v-.1c-10.3-34.2-38.2-67.6-82.3-70.5-34.2-2.2-66.9 12.9-93.1 37.1-1.6 1.5-4.3 2.9-6.6 2.9h-4.5c-3.7 0-7.6-2.7-7.6-6.1V120.2C48 88.1 91.9 64.1 146 64.1zM366 64c-54.1 0-100 27.9-100 82v299.9c0 2.2 3.1 2.7 3.8.7v-.1c10.3-34.2 39.4-67.9 82.3-70.5 32.9-2 63.9 11 93.1 37.1 1.6 1.4 4.3 2.9 6.6 2.9h4.5c3.7 0 7.6-2.7 7.6-6.1V120c.1-32-43.8-56-97.9-56z"}}]})(props);
	};
	module.exports.IoIosBookmark = function IoIosBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 80v380c0 3.3 3.8 5.2 6.4 3.2l116.8-92c2.9-2.1 6.8-2.1 9.6 0l116.8 92c2.6 2 6.4.1 6.4-3.2V80c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z"}}]})(props);
	};
	module.exports.IoIosBookmarks = function IoIosBookmarks (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 32v127.9l-22.9-14.5-9.1-6.4-9.1 6.4-22.9 14.5V32h-41.4c-22.5.2-40.6 18.8-40.6 41.4v313.2c0 7.5-5.8 14-13.3 14.4-8 .4-14.7-6-14.7-14V73.4c0-22.6-18.1-41.2-40.6-41.4H95.1C64.8 32 40 56.8 40 87.1v289.8c0 30.3 24.8 55.1 55.1 55.1l108-.1c4.2.1 8.3.6 12.2 1.4 15.3 3.1 26.8 16.6 26.6 32.2-.1 7.2 5.2 13.6 12.4 14.4 8.5.9 15.7-5.7 15.6-14.1-.2-15.8 11.4-29.4 26.9-32.5 3.8-.8 7.9-1.2 12-1.3l108 .1c30.3 0 55.1-24.8 55.1-55.1V87.1C472 56.8 446.3 32 416 32z"}}]})(props);
	};
	module.exports.IoIosBowtie = function IoIosBowtie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M290.8 213.5C286 205 277 202.2 266 202.2v-.2c-6 0-14.3 1.3-22.6 2.9-11.9 2.3-19.7 7.1-19.7 7.1s3.6 27.3.1 58.5-7.9 42.5-7.9 42.5 5.3 12.1 40 15c3.9.3 7.6.5 11 .5 24.5 0 36.4-7.3 36.4-7.3s3.3-5.4 4.3-22.1c1.9-32.2-7-68.5-16.8-85.6zM205.7 208.8c-22-40.2-86.2-96.8-121.3-96.8C57.9 112 32 180.5 32 256s23 144 51.5 144c33.4 0 110.5-80 110.5-80s5.7-12.6 9.9-33.6l1.8-10.4c.7-4.7 1.3-9.7 1.7-15 .3-3.5.5-6.8.6-9.9l.3-9.8c.7-16-2.6-32.5-2.6-32.5zM427.6 112c-36.4 0-96.4 56.5-118.3 96.8l-.8 1.4s1.4 2.5 1.9 3.4c3.4 6 6.7 14.3 9.4 24l2.9 11.7c2.2 10.2 3.7 21.2 4.2 32.2l.2 9c0 2.9-.1 5.7-.3 8.5-1 16.7-4.6 22.1-4.6 22.1 7.6 10.5 69 78.9 106.2 78.9 28.5 0 51.5-68.5 51.5-144s-25.8-144-52.3-144z"}}]})(props);
	};
	module.exports.IoIosBriefcase = function IoIosBriefcase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 448h352c17.7 0 32-14.3 32-32V224H48v192c0 17.7 14.3 32 32 32zM432 128h-8v-8c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v8h-28V96c0-17.6-14.4-32-32-32H196c-17.6 0-32 14.4-32 32v32h-28v-8c0-4.4-3.6-8-8-8H96c-4.4 0-8 3.6-8 8v8h-8c-17.7 0-32 14.3-32 32v40h416v-40c0-17.7-14.3-32-32-32zm-112 0H192v-28c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v28z"}}]})(props);
	};
	module.exports.IoIosBrowsers = function IoIosBrowsers (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 181.4V424c0 22.1 17.9 40 40 40h242.6c22.1 0 40-17.9 40-40V181.4c0-22.1-17.9-40-40-40H88c-22.1 0-40 17.9-40 40z"}},{"tag":"path","attr":{"d":"M141.4 88v28.4c0 2.2 1.8 4 4 4h198.2c26.4 0 48 21.6 48 48v198.2c0 2.2 1.8 4 4 4H424c22.1 0 40-17.9 40-40V88c0-22.1-17.9-40-40-40H181.4c-22.1 0-40 17.9-40 40z"}}]})(props);
	};
	module.exports.IoIosBrush = function IoIosBrush (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M149.6 283.3c-51.9 0-83.9 45.7-83.9 95.1 0 21.3-10.9 37.1-31.4 46.4-2.2 1-3 3.8-1.7 5.8 16.7 24.6 63.3 33.3 95.3 33.3 8.4 0 15.9-.6 21.8-1.7 35.6-6.4 80.1-24.9 90.7-77 12.2-60.5-38.9-101.9-90.8-101.9z"}},{"tag":"path","attr":{"d":"M467.7 60.4C460 52.7 450.9 48 441.6 48c-6.3 0-12.7 2.2-18.8 7L257.7 200.3c-5.4 4.8-12.4 7.4-19.7 7.4h-.1-.1c-5.6 0-11.1 2.1-15.4 5.8l-53.6 43.8c-2.1 1.8-2.7 4.8-1.4 7.2.9 1.7 2.6 2.9 4.5 3.1 45.6 4.5 87 37 87.3 86.6 0 1.7.7 3.4 2 4.5 2.5 2.1 6 1.7 8-.6l45.1-52.2c3.5-4 5.8-9.1 6-14.5v-1.2c0-7.5 3-14.8 8-20.4l144.8-164.4c11.9-15.1 7.6-32.1-5.4-45z"}}]})(props);
	};
	module.exports.IoIosBug = function IoIosBug (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M374.6 127.3C345.4 88.5 303.1 64 256 64c-47.1 0-89.4 24.5-118.6 63.3 6.4 15.6 15.8 30 28.1 42.3 24.2 24.2 56.3 37.5 90.5 37.5s66.3-13.3 90.5-37.5c12.3-12.3 21.8-26.6 28.1-42.3z"}},{"tag":"path","attr":{"d":"M122 150s-3.8-1.6-5.9-3.3c-2.1-1.7-5-4.9-6.5-8.4 5.4-11.3 1.2-25-9.9-31.3-11.8-6.6-26.9-2.2-33.1 10-4.5 8.9-2.9 19.8 3.8 27.1 1.8 1.9 3.7 3.4 5.7 4.6 2.8 1.6 4.9 4 6.4 6.8 2.7 5.2 6.4 10.7 11.1 14.6 4.2 3.5 8.8 7.1 15.2 10.7-7.2 20.3-11.6 42.3-12.5 65.4-11 .2-18.6 2.1-25.5 4.1-4.2 1.2-8.2 3.4-11.8 5.9-1-.1-1.9-.2-2.9-.2-13.8 0-24.8 11.6-24 25.6.7 11.8 10.3 21.5 22.2 22.4 11 .8 20.6-5.9 24.3-15.5 2-5.3 6.7-9.2 12.4-9.9 1.9-.2 3.9-.4 6.2-.4 3.2 33 13.3 63.5 28.6 89.2-14.2 11-22.9 23-26.6 36.3 0 0-.8.4-1.9 1.4-1 .8-1.9 1.6-2.8 2.6-8.9 9.9-8.1 25 1.8 33.9 9.9 8.9 25 8.1 33.9-1.8 6.2-6.9 7.6-16.3 4.6-24.5-2.2-6-.7-12.7 3.9-17 1.6-1.5 3.5-3.1 5.7-4.9 27.1 31.7 59.4 52 99.7 54.4V232.9C190.8 230 144.4 195.3 122 150zM456 256.1c-1 0-2 .1-2.9.2-3.6-2.5-7.7-4.6-11.8-5.9-6.9-2-14.4-3.9-25.5-4.1-1-23.1-5.4-45.2-12.5-65.4 6.4-3.6 11-7.2 15.2-10.7 4.9-4.1 8.7-10 11.5-15.3 1.3-2.5 3.3-4.5 5.8-5.9 0 0 .1 0 .1-.1 11.6-6.5 15.7-21.1 9.2-32.7-6.5-11.6-21.1-15.7-32.7-9.2-11.1 6.2-15.3 19.9-9.9 31.3-1.6 3.4-3.4 5.7-6.5 8.4-2.3 2-5.9 4.3-5.9 4.3-22.4 45.3-68.8 79-122 81.9V448c40.3-2.4 72.6-22.8 99.7-54.4 2.1 1.7 3.9 3.2 5.4 4.6 4.8 4.4 6.4 11.3 4.2 17.5-3 8.1-1.5 17.5 4.7 24.3 8.9 9.9 24 10.7 33.9 1.8 9.9-8.9 10.7-24 1.8-33.9-.9-1-1.8-1.8-2.8-2.6-1.1-.9-1.9-1.4-1.9-1.4-3.7-13.3-12.4-25.3-26.6-36.3 15.3-25.7 25.4-56.2 28.6-89.2 2.1 0 4.1.2 5.9.4 5.9.7 10.7 4.7 12.9 10.2 3.7 9.4 13.2 15.9 24.1 15.1 11.8-.9 21.4-10.5 22.2-22.4.6-14-10.4-25.6-24.2-25.6z"}}]})(props);
	};
	module.exports.IoIosBuild = function IoIosBuild (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M441.1 131.1l-44.9 45.1c-.9.9-2.3 1.3-3.5 1.1l-46.4-8.4c-1.6-.3-2.9-1.6-3.2-3.2l-8.3-46.4c-.2-1.3.2-2.6 1.1-3.5l44.8-45c3.5-3.5 3-9.3-1-12.1-10.1-7.2-22.1-10.7-31.8-10.7-.7 0-1.4 0-2 .1-12.5.7-39.3 7.7-60 29.7-20.1 21.2-41.1 60.6-22.5 104.5 2.2 5.3 4.7 12.3-2.7 19.7C253.1 209.4 61 390.3 61 390.3c-18 15.5-16.7 44.2-.1 60.9 8.5 8.4 20 12.8 31.3 12.8 11.1 0 21.9-4.2 29.6-13.1 0 0 179.4-191.1 188.2-199.8 4-3.9 7.7-5.1 11.1-5.1 3.3 0 6.3 1.2 8.6 2.4 9.9 5.1 21 7.4 32.4 7.4 26.8 0 55-12.4 72.2-29.6 24.4-24.4 28.9-48 29.6-60.1.6-9.9-2.2-22.6-10.7-34.2-2.9-3.8-8.6-4.2-12.1-.8zM102.5 429.3c-5.5 5.4-14.4 5.4-19.9 0-5.4-5.5-5.4-14.4 0-19.9 5.5-5.4 14.4-5.4 19.9 0 5.4 5.6 5.4 14.5 0 19.9z"}}]})(props);
	};
	module.exports.IoIosBulb = function IoIosBulb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M404 188.9C404 111 333.9 48 256 48s-148 63.1-148 140.9c0 31 13.2 56.1 30.2 80.1h-.3c10.9 15 21.4 17.7 31.5 35 14.7 25.2 18.1 40.7 18.7 55.7.4 8.6 7.5 15.3 16 15.3h8.9c2.2 0 4-1.8 4-4v-94.5c0-5-1.2-9.8-3.4-14.3l-21-42c-3.5-7 1.6-15.2 9.4-15.2 4 0 7.7 2.3 9.4 5.9l25.3 51.4c2.2 4.4 3.3 9.2 3.3 14.1V371c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4v-94.6c0-4.9 1.1-9.7 3.3-14.1l25.4-51.6c1.7-3.4 5.2-5.6 9-5.6 7.5 0 12.4 7.9 9 14.6l-21.3 42.6c-2.2 4.5-3.4 9.4-3.4 14.3V371c0 2.2 1.8 4 4 4h10c8.5 0 15.5-6.6 16-15 .9-15.4 4.7-32.3 18.4-56 10.1-17.3 20.6-20 31.5-35h-.1c17-24 30.2-49.1 30.2-80.1zM238 464h36c7.7 0 14-6.3 14-14s-6.3-14-14-14h-36c-7.7 0-14 6.3-14 14s6.3 14 14 14zM218 420h76c7.7 0 14-6.3 14-14s-6.3-14-14-14h-76c-7.7 0-14 6.3-14 14s6.3 14 14 14z"}}]})(props);
	};
	module.exports.IoIosBus = function IoIosBus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M109.6 416.7c-1.9-1.9-5.7-.5-5.6 2.2 1 21.5 1.4 29 5.5 29h55.1c4.4 0 3.3-11.5 3.3-22-34.3.1-46.9 2.3-58.3-9.2zM402.4 416.7c1.9-1.9 5.7-.5 5.6 2.2-1 21.5-1.4 29-5.5 29h-55.1c-4.4 0-3.3-11.5-3.3-22 34.3.1 46.9 2.3 58.3-9.2zM384 64H128c-17.6 0-32 14.4-32 32v276c0 22 18 40 40 40h240c22 0 40-18 40-40V96c0-17.6-14.4-32-32-32zM162 375.9c-14.8 1.2-27-11.1-25.9-25.9.9-11.6 10.3-21.1 22-22 14.8-1.2 27 11.1 25.9 25.9-1 11.7-10.4 21.1-22 22zm76-77.9h-97.8c-8.9 0-16.2-7.3-16.2-16.2V166.2c0-8.9 7.3-16.2 16.2-16.2H238c2.2 0 4 1.8 4 4v140c0 2.2-1.8 4-4 4zm115.9 77.9c-14.8 1.2-27-11.1-25.9-25.9.9-11.6 10.3-21.1 22-22 14.8-1.2 27 11.1 25.9 25.9-.9 11.7-10.3 21.1-22 22zM388 282c0 8.8-7.2 16-16 16h-98c-2.2 0-4-1.8-4-4V154c0-2.2 1.8-4 4-4h98c8.8 0 16 7.2 16 16v116zm-15-162H139c-8.8 0-15-6.3-15-14s6.2-14 15-14h234c8.8 0 15 6.3 15 14s-6.2 14-15 14z"}}]})(props);
	};
	module.exports.IoIosBusiness = function IoIosBusiness (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M146 80h220c9.9 0 18-8.1 18-18s-8.1-18-18-18H146c-9.9 0-18 8.1-18 18s8.1 18 18 18zM398 100H114c-9.9 0-18 8.1-18 18 0 9.3 6.9 17.1 16 18v300c0 13.2 10.8 24 24 24h88c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h88c13.2 0 24-10.8 24-24V136c9.1-.9 16-8.7 16-18 0-9.9-8.1-18-18-18zM192 364c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm80 192c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm80 192c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16z"}}]})(props);
	};
	module.exports.IoIosCafe = function IoIosCafe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.7 404H110.1c-7.6 0-14.1 5.8-14.4 13.4-.4 8 6 14.6 14 14.6h259.6c7.6 0 14.1-5.8 14.4-13.4.3-8-6.1-14.6-14-14.6zM399.2 118.5c.1-10.8-4.2-20.9-12.2-28.4-7.2-6.6-16.7-10.1-26.5-10.1H86.8c-9.9 0-19.7 3.6-26.9 10.4-8.1 7.7-12.4 18.2-11.9 29.3C50.4 172 58.3 218 71.8 256.3c11 31.6 25.8 58.1 43.9 78.9 31.8 36.6 68.8 48.8 77.9 48.8h60.1c5.5 0 25-7.2 44.2-19.5 22.4-14.4 42.4-36.7 58.1-64.6 2 .1 4 .2 5.9.2 27.2 0 52.8-9.7 72.1-27.4 19.4-17.8 30.1-41.4 30.1-66.6-.1-38.9-25.9-73.5-64.9-87.6zm-29.7 153.1c14.2-34.5 23.6-76 27.8-123.4 0 0 0-.1.1 0 10.3 5 19.1 12.2 25.8 20.9 8.4 10.9 12.8 23.7 12.8 37 0 34-29.2 62.1-66.5 65.5z"}}]})(props);
	};
	module.exports.IoIosCalculator = function IoIosCalculator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M372 48H140c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h232c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zm-12 272v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm0-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm-80 160c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm0-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm0-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm-80 160c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm0-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm0-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm-48-80v-48c0-8.8 7.2-16 16-16h176c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H168c-8.8 0-16-7.2-16-16z"}}]})(props);
	};
	module.exports.IoIosCalendar = function IoIosCalendar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424 96h-40v24c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V96H160v24c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V96H88c-22 0-40 18-40 40v272c0 22 18 40 40 40h336c22 0 40-18 40-40V136c0-22-18-40-40-40zm8 300c0 11-9 20-20 20H100c-11 0-20-9-20-20V216c0-4.4 3.6-8 8-8h336c4.4 0 8 3.6 8 8v180zM160 72c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24h32V72zM384 72c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24h32V72z"}}]})(props);
	};
	module.exports.IoIosCall = function IoIosCall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M436.9 364.8c-14.7-14.7-50-36.8-67.4-45.1-20.2-9.7-27.6-9.5-41.9.8-11.9 8.6-19.6 16.6-33.3 13.6-13.7-2.9-40.7-23.4-66.9-49.5-26.2-26.2-46.6-53.2-49.5-66.9-2.9-13.8 5.1-21.4 13.6-33.3 10.3-14.3 10.6-21.7.8-41.9C184 125 162 89.8 147.2 75.1c-14.7-14.7-18-11.5-26.1-8.6 0 0-12 4.8-23.9 12.7-14.7 9.8-22.9 18-28.7 30.3-5.7 12.3-12.3 35.2 21.3 95 27.1 48.3 53.7 84.9 93.2 124.3l.1.1.1.1c39.5 39.5 76 66.1 124.3 93.2 59.8 33.6 82.7 27 95 21.3 12.3-5.7 20.5-13.9 30.3-28.7 7.9-11.9 12.7-23.9 12.7-23.9 2.9-8.1 6.2-11.4-8.6-26.1z"}}]})(props);
	};
	module.exports.IoIosCamera = function IoIosCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"275","r":"57.5"}},{"tag":"path","attr":{"d":"M417.5 160H363c-4.6 0-8.9-2-12-5.4-28.4-31.8-39.1-42.6-50.7-42.6h-85.5c-11.7 0-23.2 10.8-51.7 42.7-3 3.4-7.4 5.3-11.9 5.3h-4.1v-8c0-4.4-3.6-8-8-8h-26c-4.4 0-8 3.6-8 8v8h-7.5C79.9 160 64 173.2 64 190.7v176c0 17.5 15.9 33.3 33.5 33.3h320c17.6 0 30.5-15.8 30.5-33.3v-176c0-17.5-12.9-30.7-30.5-30.7zM260 360.4c-50.3 2.3-91.7-39.1-89.4-89.4 2-43.9 37.5-79.4 81.4-81.4 50.3-2.3 91.7 39.1 89.4 89.4-2 43.9-37.5 79.4-81.4 81.4zM352 218c-7.2 0-13-5.8-13-13s5.8-13 13-13 13 5.8 13 13-5.8 13-13 13z"}}]})(props);
	};
	module.exports.IoIosCar = function IoIosCar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 196.2c-13.8-30.8-49-92.2-100-92.2H196c-51 0-84.8 59.4-100 92.2-24 23-48 45.7-48 84.8v76c0 3.7 2.6 7 6.2 7.8C69.1 368.2 116.4 375 256 375s186.9-6.8 201.8-10.2c3.6-.8 6.2-4.1 6.2-7.8v-76c0-39-22.3-63.1-48-84.8zM190 128h132c40.5 0 62 60 62 70H128c0-10 27-70 62-70zm-78 203.7c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32c0 17.6-14.3 32-32 32zM328 300c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16s7.2-16 16-16h112c8.8 0 16 7.2 16 16zm72 32c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM160 384c-47.9 0-96-5-96-5 0 17-.3 29 6 29h85c6.3 0 5-13.2 5-24zM352 384c48 0 96-5 96-5 0 16 2 29-5 29h-86c-6.7 0-5-13.5-5-24z"}}]})(props);
	};
	module.exports.IoIosCard = function IoIosCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 128c0-17.6-14.4-32-32-32H64c-17.6 0-32 14.4-32 32v48h448v-48zM32 384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V224H32v160zm142-48h164c7.7 0 14 6.3 14 14s-6.3 14-14 14H174c-7.7 0-14-6.3-14-14s6.3-14 14-14zm-72 0h12c7.7 0 14 6.3 14 14s-6.3 14-14 14h-12c-7.7 0-14-6.3-14-14s6.3-14 14-14z"}}]})(props);
	};
	module.exports.IoIosCart = function IoIosCart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"ellipse","attr":{"transform":"rotate(-1.057 159.995 423.97) scale(.99997)","cx":"160","cy":"424","rx":"24","ry":"24"}},{"tag":"ellipse","attr":{"transform":"matrix(.02382 -.9997 .9997 .02382 -48.51 798.282)","cx":"384.5","cy":"424","rx":"24","ry":"24"}},{"tag":"path","attr":{"d":"M463.8 132.2c-.7-2.4-2.8-4-5.2-4.2L132.9 96.5c-2.8-.3-6.2-2.1-7.5-4.7-3.8-7.1-6.2-11.1-12.2-18.6-7.7-9.4-22.2-9.1-48.8-9.3-9-.1-16.3 5.2-16.3 14.1 0 8.7 6.9 14.1 15.6 14.1s21.3.5 26 1.9c4.7 1.4 8.5 9.1 9.9 15.8 0 .1 0 .2.1.3.2 1.2 2 10.2 2 10.3l40 211.6c2.4 14.5 7.3 26.5 14.5 35.7 8.4 10.8 19.5 16.2 32.9 16.2h236.6c7.6 0 14.1-5.8 14.4-13.4.4-8-6-14.6-14-14.6H188.9c-2 0-4.9 0-8.3-2.8-3.5-3-8.3-9.9-11.5-26l-4.3-23.7c0-.3.1-.5.4-.6l277.7-47c2.6-.4 4.6-2.5 4.9-5.2l16-115.8c.2-.8.2-1.7 0-2.6z"}}]})(props);
	};
	module.exports.IoIosCash = function IoIosCash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M466 355.9H46c-7.7 0-14 6.3-14 14s6.3 14 14 14h420c7.7 0 14-6.3 14-14s-6.3-14-14-14zM466 403.9H46c-7.7 0-14 6.3-14 14s6.3 14 14 14h420c7.7 0 14-6.3 14-14s-6.3-14-14-14zM444.9 80.1H67.1C47.8 80.1 32 95.9 32 115.2V293c0 19.3 15.8 35.1 35.1 35.1h377.8c19.3 0 35.1-15.8 35.1-35.1V115.2c0-19.3-15.8-35.1-35.1-35.1zM114 296.1H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-156H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm142 144c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm178 12h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-156h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}},{"tag":"circle","attr":{"cx":"256","cy":"206","r":"53"}}]})(props);
	};
	module.exports.IoIosCellular = function IoIosCellular (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408.4 51.8c-2.6-2.5-6.1-3.8-9.7-3.8-3.7 0-7.2 1.4-9.9 3.9-2.7 2.6-4.1 6-4.1 9.6 0 3.6 1.5 7 4.2 9.6 30.4 28.5 47.1 66.5 47.1 107.1 0 40.5-16.7 78.5-47.1 107.1-2.7 2.5-4.2 5.9-4.2 9.6 0 3.6 1.4 7 4.1 9.6 2.6 2.5 6.1 3.9 9.9 3.9 3.7 0 7.1-1.4 9.7-3.8C444.3 271 464 226.1 464 178.2v-.1c0-47.9-19.8-92.7-55.6-126.3z"}},{"tag":"path","attr":{"d":"M351 96.8c-2.4-2.3-5.6-3.5-9-3.5-3.3 0-6.5 1.2-8.9 3.4-2.5 2.3-3.9 5.4-3.9 8.7 0 3.3 1.3 6.4 3.8 8.7 18 17 27.8 39.8 27.8 64 0 24.2-9.9 47-27.8 64-2.5 2.3-3.8 5.4-3.8 8.7 0 3.3 1.4 6.4 3.9 8.7 2.4 2.2 5.5 3.4 8.9 3.4 3.4 0 6.6-1.3 9-3.5 22.8-21.7 35.4-50.5 35.4-81.3v-.1c0-30.7-12.6-59.5-35.4-81.2zM123.1 71.1c2.7-2.5 4.2-5.9 4.2-9.6 0-3.6-1.4-7-4.1-9.6-2.6-2.5-6.1-3.9-9.9-3.9-3.7 0-7.1 1.4-9.7 3.8C67.7 85.4 48 130.3 48 178.2v.2c0 47.8 19.8 92.6 55.6 126.2 2.6 2.5 6.1 3.8 9.7 3.8 3.7 0 7.2-1.4 9.9-3.9 2.7-2.6 4.1-6 4.1-9.6 0-3.6-1.5-7-4.2-9.6C92.7 256.8 76 218.8 76 178.2c-.1-40.6 16.7-78.6 47.1-107.1z"}},{"tag":"path","attr":{"d":"M179 114.1c2.5-2.3 3.8-5.4 3.8-8.7 0-3.3-1.4-6.4-3.9-8.7-2.4-2.2-5.5-3.4-8.9-3.4-3.4 0-6.6 1.3-9 3.5-22.8 21.7-35.4 50.5-35.4 81.3v.1c0 30.8 12.6 59.6 35.4 81.2 2.4 2.3 5.6 3.5 9 3.5 3.3 0 6.5-1.2 8.9-3.4 2.5-2.3 3.9-5.4 3.9-8.7 0-3.3-1.3-6.4-3.8-8.7-18-17-27.8-39.8-27.8-64-.1-24.2 9.8-46.9 27.8-64zM256 123.2c-26.5 0-48 21.5-48 48 0 21.6 14.3 39.9 34 45.9v233c0 7.7 6.3 13.9 14 13.9s14-6.2 14-13.9v-233c19.7-6 34-24.3 34-45.9 0-26.5-21.5-48-48-48z"}}]})(props);
	};
	module.exports.IoIosChatboxes = function IoIosChatboxes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M425.9 170.4H204.3c-21 0-38.1 17.1-38.1 38.1v154.3c0 21 17.1 38 38.1 38h126.8c2.8 0 5.6 1.2 7.6 3.2l63 58.1c3.5 3.4 9.3 2 9.3-2.9v-50.6c0-6 3.8-7.9 9.8-7.9h1c21 0 42.1-16.9 42.1-38V208.5c.1-21.1-17-38.1-38-38.1z"}},{"tag":"path","attr":{"d":"M174.4 145.9h177.4V80.6c0-18-14.6-32.6-32.6-32.6H80.6C62.6 48 48 62.6 48 80.6v165.2c0 18 14.6 32.6 32.6 32.6h61.1v-99.9c.1-18 14.7-32.6 32.7-32.6z"}}]})(props);
	};
	module.exports.IoIosChatbubbles = function IoIosChatbubbles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M431 320.6c0-4.4 1.2-8.6 3.3-12.2.6-1.1 1.4-2.1 2.1-3.1 17.4-26 27.6-57.1 27.6-90.3.3-92.2-77.5-167-173.7-167-83.9 0-153.9 57.1-170.3 132.9-2.4 11.1-3.7 22.4-3.7 34.2 0 92.3 74.8 169.1 171 169.1 15.3 0 35.9-4.6 47.2-7.7 11.3-3.1 22.5-7.2 25.4-8.3 2.9-1.1 6.1-1.7 9.3-1.7 3.6 0 7 .7 10.1 2l56.7 20.1s2.4 1 3.9 1c4.4 0 8-3.5 8-8 0-1-.5-2.7-.5-2.7L431 320.6z"}},{"tag":"path","attr":{"d":"M318.5 392.5c-3.6 1-8.2 2.1-13.2 3.2-10.5 2.2-23.9 4.5-34 4.5-96.2 0-171-76.8-171-169.1 0-6.6.7-15 1.5-21.4.6-4.3 1.3-8.6 2.3-12.8 1-4.5 2.2-9 3.5-13.4l-8 7.1C66.8 219.2 48 260 48 302.5c0 29.3 8.5 57.5 24.8 82 2.3 3.5 3.6 6.2 3.2 8-.4 1.8-11.9 62-11.9 62-.6 2.9.5 5.8 2.7 7.7 1.5 1.2 3.3 1.8 5.1 1.8 1 0 2-.2 2.9-.6l56.1-22.1c1.8-.7 3.7-1.1 5.7-1.1 0 0 2.4-.2 6.3 1.3 18.9 7.4 39.8 12 60.7 12 46.6 0 90.4-20.1 120.1-55.1 0 0 3.2-4.4 6.9-9.6-3.7 1.3-7.9 2.6-12.1 3.7z"}}]})(props);
	};
	module.exports.IoIosCheckboxOutline = function IoIosCheckboxOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 64H96c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm4 348c0 4.4-3.6 8-8 8H100c-4.4 0-8-3.6-8-8V100c0-4.4 3.6-8 8-8h312c4.4 0 8 3.6 8 8v312z"}},{"tag":"path","attr":{"d":"M363.6 192.9L346 174.8c-.7-.8-1.8-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2l-122 122.9-44.4-44.4c-.8-.8-1.8-1.2-2.8-1.2-1 0-2 .4-2.8 1.2l-17.8 17.8c-1.6 1.6-1.6 4.1 0 5.7l56 56c3.6 3.6 8 5.7 11.7 5.7 5.3 0 9.9-3.9 11.6-5.5h.1l133.7-134.4c1.4-1.7 1.4-4.2-.1-5.7z"}}]})(props);
	};
	module.exports.IoIosCheckbox = function IoIosCheckbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 64H96c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-52.5 134.5L229.8 332.8h-.1c-1.7 1.7-6.3 5.5-11.6 5.5-3.8 0-8.1-2.1-11.7-5.7l-56-56c-1.6-1.6-1.6-4.1 0-5.7l17.8-17.8c.8-.8 1.8-1.2 2.8-1.2 1 0 2 .4 2.8 1.2l44.4 44.4 122-122.9c.8-.8 1.8-1.2 2.8-1.2 1.1 0 2.1.4 2.8 1.2l17.5 18.1c1.8 1.7 1.8 4.2.2 5.8z"}}]})(props);
	};
	module.exports.IoIosCheckmarkCircleOutline = function IoIosCheckmarkCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M362.6 192.9L345 174.8c-.7-.8-1.8-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2l-122 122.9-44.4-44.4c-.8-.8-1.8-1.2-2.8-1.2-1 0-2 .4-2.8 1.2l-17.8 17.8c-1.6 1.6-1.6 4.1 0 5.7l56 56c3.6 3.6 8 5.7 11.7 5.7 5.3 0 9.9-3.9 11.6-5.5h.1l133.7-134.4c1.4-1.7 1.4-4.2-.1-5.7z"}},{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosCheckmarkCircle = function IoIosCheckmarkCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm106.5 150.5L228.8 332.8h-.1c-1.7 1.7-6.3 5.5-11.6 5.5-3.8 0-8.1-2.1-11.7-5.7l-56-56c-1.6-1.6-1.6-4.1 0-5.7l17.8-17.8c.8-.8 1.8-1.2 2.8-1.2 1 0 2 .4 2.8 1.2l44.4 44.4 122-122.9c.8-.8 1.8-1.2 2.8-1.2 1.1 0 2.1.4 2.8 1.2l17.5 18.1c1.8 1.7 1.8 4.2.2 5.8z"}}]})(props);
	};
	module.exports.IoIosCheckmark = function IoIosCheckmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M362.6 192.9L345 174.8c-.7-.8-1.8-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2l-122 122.9-44.4-44.4c-.8-.8-1.8-1.2-2.8-1.2-1 0-2 .4-2.8 1.2l-17.8 17.8c-1.6 1.6-1.6 4.1 0 5.7l56 56c3.6 3.6 8 5.7 11.7 5.7 5.3 0 9.9-3.9 11.6-5.5h.1l133.7-134.4c1.4-1.7 1.4-4.2-.1-5.7z"}}]})(props);
	};
	module.exports.IoIosClipboard = function IoIosClipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M140.5 160v240c0 8.8 7.2 16 16 16h200c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16h-200c-8.8 0-16 7.2-16 16zM321.5 81h-17c0-5.6-1-11-2.7-16-2.1-6-5.3-11.4-9.4-16-8.8-9.9-21.6-17-35.9-17s-27.1 7.1-35.9 17c-4.1 4.6-7.3 10-9.4 16-1.7 5-2.7 10.4-2.7 16H194c-9.6 0-17.5 7.9-17.5 17.5V114c0 1.1.9 2 2 2h156c1.1 0 2-.9 2-2V96c0-8.3-6.7-15-15-15zm-62.9 15.5c-10.5 1.3-19.3-7.5-17.9-17.9.9-7.1 6.7-12.9 13.8-13.8 10.5-1.3 19.3 7.5 17.9 17.9-.9 7.2-6.7 12.9-13.8 13.8z"}},{"tag":"path","attr":{"d":"M400 48h-75.2c-1.7 0-2.6 1.9-1.6 3.2 2.9 3.9 5.3 8.1 7 12.8.3.8 1 1.3 1.9 1.3h.5c18.7 0 26.9 14.9 27.5 33.5V114c0 1.1.9 2 2 2h20.3c8.8 0 16 7.2 16 16v297.4c0 8.8-7.2 16-16 16h-253c-8.8 0-16-7.2-16-16V132c0-8.8 7.2-16 16-16h21.3c1.1 0 2-.9 2-2v-8.8c0-19.1 5.6-36.7 27.6-36.7h.3c.9 0 1.8-.6 1.9-1.6 1.5-6.9 4.1-11.7 7.2-15.8 1-1.3.1-3.2-1.6-3.2l-76.3-.1C94.3 47.9 80 62.1 80 79.7V424c0 41.7 14.3 56 32 56h288.5c17.4 0 31.5-14.1 31.5-31.5V80c0-17.7-14.3-32-32-32z"}}]})(props);
	};
	module.exports.IoIosClock = function IoIosClock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0-81.3 81.2-81.2 212.9 0 294.2 81.2 81.2 212.9 81.2 294.2 0 81.2-81.2 81.2-213 0-294.2zM89.6 263.8c-5.6 1.1-10.5-3.8-9.4-9.4.6-3.1 3.1-5.7 6.3-6.3 5.6-1.1 10.5 3.8 9.4 9.4-.6 3.2-3.2 5.7-6.3 6.3zm26.2 82.2c-4.3 3.7-11 1.9-12.8-3.5-1-3-.1-6.5 2.3-8.5 4.3-3.7 11-1.9 12.8 3.5 1 3 .1 6.4-2.3 8.5zm2.3-171.5c-1.9 5.4-8.5 7.2-12.8 3.5-2.4-2.1-3.3-5.5-2.3-8.5 1.9-5.4 8.5-7.2 12.8-3.5 2.4 2.1 3.3 5.5 2.3 8.5zM179.6 404c-1.9 5.4-8.5 7.2-12.8 3.5-2.4-2.1-3.3-5.5-2.3-8.5 1.9-5.4 8.5-7.2 12.8-3.5 2.4 2.1 3.3 5.5 2.3 8.5zm-2.3-287.5c-4.3 3.7-11 1.9-12.8-3.5-1-3-.1-6.5 2.3-8.5 4.3-3.7 11-1.9 12.8 3.5 1 3 .1 6.4-2.3 8.5zm35.4 76.3c-2.3-3.8-1-8.7 2.7-11 3.8-2.3 8.7-1 11 2.7l33.7 62.3c2.5 4.7 3.9 9.9 3.9 15.2v122c0 5-3 8-8 8s-8-3-8-8V262c0-2.7-.7-5.3-1.9-7.6l-33.4-61.6zm44.9 239c-5.6 1.1-10.5-3.8-9.4-9.4.6-3.1 3.1-5.7 6.3-6.3 5.6-1.1 10.5 3.8 9.4 9.4-.6 3.2-3.2 5.7-6.3 6.3zm0-336c-5.6 1.1-10.5-3.8-9.4-9.4.6-3.1 3.1-5.7 6.3-6.3 5.6-1.1 10.5 3.8 9.4 9.4-.6 3.2-3.2 5.7-6.3 6.3zm87.7 311.7c-4.3 3.7-11 1.9-12.8-3.5-1-3-.1-6.5 2.3-8.5 4.3-3.7 11-1.9 12.8 3.5 1 3 .1 6.4-2.3 8.5zm2.3-294.5c-1.9 5.4-8.5 7.2-12.8 3.5-2.4-2.1-3.3-5.5-2.3-8.5 1.9-5.4 8.5-7.2 12.8-3.5 2.4 2.1 3.3 5.5 2.3 8.5zm61.5 229.5c-1.9 5.4-8.5 7.2-12.8 3.5-2.4-2.1-3.3-5.5-2.3-8.5 1.9-5.4 8.5-7.2 12.8-3.5 2.4 2.1 3.3 5.5 2.3 8.5zM406.8 178c-4.3 3.7-11 1.9-12.8-3.5-1-3-.1-6.5 2.3-8.5 4.3-3.7 11-1.9 12.8 3.5 1 3 .1 6.4-2.3 8.5zm18.8 85.8c-5.6 1.1-10.5-3.8-9.4-9.4.6-3.1 3.1-5.7 6.3-6.3 5.6-1.1 10.5 3.8 9.4 9.4-.6 3.2-3.2 5.7-6.3 6.3z"}}]})(props);
	};
	module.exports.IoIosCloseCircleOutline = function IoIosCloseCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M331.3 308.7L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-15.6-7.1-22.6 0-7.1 7.1-6 16.6 0 22.6l52.7 52.7-52.7 52.7c-6.7 6.7-6.4 16.3 0 22.6 6.4 6.4 16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0 6.3-6.2 6.3-16.4 0-22.6z"}},{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosCloseCircle = function IoIosCloseCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm52.7 283.3L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3l52.7-52.7-52.7-52.7c-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3 6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6-6.2 6.3-16.4 6.3-22.6 0z"}}]})(props);
	};
	module.exports.IoIosClose = function IoIosClose (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"}}]})(props);
	};
	module.exports.IoIosCloudCircle = function IoIosCloudCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm82.6 272H173.4c-25.1 0-45.4-21.4-45.4-47.2 0-21 13.2-39.8 33.2-46.2.3-20 16.2-36.1 35.7-36.1 5.3 0 10.4 1.2 14.9 3.4 13.1-20.5 36.9-33.8 62.5-33.8 37.7 0 67.5 29.3 71.4 66.9 21.7 3.5 38.3 22.7 38.3 45.9 0 25.7-20.3 47.1-45.4 47.1z"}}]})(props);
	};
	module.exports.IoIosCloudDone = function IoIosCloudDone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.1 229.8C429 154.6 365.4 96 288 96c-51.2 0-96.3 25.6-123.4 64.7-8.3-3.4-17.4-5.3-26.9-5.3-39.1 0-70.8 34.4-71.4 73.4C26.4 241.5 0 280.5 0 321.5 0 371.7 40.7 416 90.9 416h330.3c50.2 0 90.9-44.3 90.9-94.5-.1-44.7-32.4-84.1-75-91.7zm-74.6-17.3L228.8 346.8h-.1c-1.7 1.7-6.3 5.5-11.6 5.5-3.8 0-8.1-2.1-11.7-5.7l-56-56c-1.6-1.6-1.6-4.1 0-5.7l17.8-17.8c.8-.8 1.8-1.2 2.8-1.2 1 0 2 .4 2.8 1.2l44.4 44.4 122-122.9c.8-.8 1.8-1.2 2.8-1.2 1.1 0 2.1.4 2.8 1.2l17.5 18.1c1.8 1.7 1.8 4.2.2 5.8z"}}]})(props);
	};
	module.exports.IoIosCloudDownload = function IoIosCloudDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.1 165.8C429 90.6 365.4 32 288 32c-51.2 0-96.3 25.6-123.4 64.7-8.3-3.4-17.4-5.3-26.9-5.3-39.1 0-70.8 34.4-71.4 73.4C26.4 177.5 0 216.5 0 257.5 0 307.7 40.7 352 90.9 352H243V211c0-7.2 5.8-13 13-13s13 5.8 13 13v141h152.1c50.2 0 90.9-44.3 90.9-94.5 0-44.7-32.3-84.1-74.9-91.7zM243 435.9l-47.9-47.2c-5.1-5-13.3-5-18.4.1-5 5.1-5 13.3.1 18.4l70 69c2.5 2.4 5.8 3.7 9.1 3.7 1.7 0 3.4-.3 5-1 1.5-.6 2.9-1.6 4.1-2.7l70-69c5.1-5 5.2-13.3.1-18.4-5-5.1-13.3-5.2-18.4-.1L269 435.9V352h-26v83.9z"}}]})(props);
	};
	module.exports.IoIosCloudOutline = function IoIosCloudOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 124c30.3 0 59.3 11.2 81.8 31.5 22.3 20.1 36.3 47.6 39.5 77.3l1.2 11.1c.6 5.8 5 10.5 10.7 11.5l11 2c14 2.5 27 10.4 36.7 22.1 9.8 12 15.2 26.9 15.2 42.1 0 17-6.9 34.1-18.9 46.8C453 381 437.4 388 421.1 388H90.9c-16.3 0-31.9-7-43.9-19.7s-18.9-29.7-18.9-46.8c0-14.4 4.6-28.9 13.1-40.9 8.6-12.2 20.2-20.9 33.7-25.1l10.3-3.3c5.3-1.7 9-6.6 9.1-12.2l.2-10.8c.2-11.8 5.1-23.6 13.5-32.4 8.3-8.7 18.9-13.4 29.9-13.4 5.6 0 11.1 1.1 16.3 3.2l11.1 4.5c5.7 2.3 12.2.4 15.7-4.7l6.8-9.8C210.4 143.7 248 124 288 124m0-28c-51.2 0-96.3 25.6-123.4 64.7-8.3-3.4-17.4-5.3-26.9-5.3-39.1 0-70.8 34.4-71.4 73.4C26.4 241.5 0 280.5 0 321.5 0 371.7 40.7 416 90.9 416h330.3c50.2 0 90.9-44.3 90.9-94.5 0-44.7-32.3-84.1-74.9-91.7C429 154.6 365.4 96 288 96z"}}]})(props);
	};
	module.exports.IoIosCloudUpload = function IoIosCloudUpload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.1 165.8C429 90.6 365.4 32 288 32c-51.2 0-96.3 25.6-123.4 64.7-8.3-3.4-17.4-5.3-26.9-5.3-39.1 0-70.8 34.4-71.4 73.4C26.4 177.5 0 216.5 0 257.5 0 307.7 40.7 352 90.9 352H243V210.1l-47.9 47.2c-5.1 5-13.3 5-18.4-.1-5-5.1-5-13.3.1-18.4l70-69c1.2-1.1 2.5-2.1 4.1-2.7 1.6-.7 3.3-1 5-1 3.4 0 6.6 1.3 9.1 3.7l70 69c5.1 5 5.2 13.3.1 18.4-5 5.1-13.3 5.2-18.4.1L269 210.1V352h152.1c50.2 0 90.9-44.3 90.9-94.5 0-44.7-32.3-84.1-74.9-91.7zM243 467c0 7.2 5.8 13 13 13s13-5.8 13-13V352h-26v115z"}}]})(props);
	};
	module.exports.IoIosCloud = function IoIosCloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.1 229.8C429 154.6 365.4 96 288 96c-51.2 0-96.3 25.6-123.4 64.7-8.3-3.4-17.4-5.3-26.9-5.3-39.1 0-70.8 34.4-71.4 73.4C26.4 241.5 0 280.5 0 321.5 0 371.7 40.7 416 90.9 416h330.3c50.2 0 90.9-44.3 90.9-94.5-.1-44.7-32.4-84.1-75-91.7z"}}]})(props);
	};
	module.exports.IoIosCloudyNight = function IoIosCloudyNight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M277.8 294.8c-.5 0-1.1-.1-1.6-.1-2.6 0-5.2 0-7.8.3-9.3-40.8-45.9-71.5-89.7-71.5-50.8 0-91.9 40.9-91.9 91.4 0 3.1.2 6.1.5 9.1-31 2.7-55.3 30.1-55.3 61.6C32 419 58.8 448 92.3 448h185.5c41.9 0 75.8-34.7 75.8-76.3 0-41.6-33.9-76.9-75.8-76.9z"}},{"tag":"path","attr":{"d":"M452.1 305.4c-2.5.1-5 .2-7.6.2-41.7 0-80.8-15.7-110.3-44.3-29.5-28.5-45.7-66.5-45.7-106.8 0-23 5.3-45.2 15.2-65.3L315.4 70c1.7-2.9-.8-6.5-4.1-6-7.6 1.2-15.7 4-23.2 6.3-59.5 18.2-104.4 68.1-113.7 129.3 1.4-.1 2.9-.1 4.3-.1 26.5 0 52.4 9.2 73 25.9 15.1 12.2 26.9 28 34.2 45.7 23.7 2 45.7 12.4 62.7 29.8 18.7 19.1 29 44.2 29 70.7 0 2.3-.1 4.6-.2 6.8 34.2-8.1 64.3-26.6 86.4-51.8 4.8-5.5 11.3-12.8 15.3-18.5 2-2.8-.3-6.7-3.8-6.3-6.8 1-15.9 3.2-23.2 3.6z"}}]})(props);
	};
	module.exports.IoIosCloudy = function IoIosCloudy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M236 96c-70 0-127.8 59.7-127.8 130.8 0 4.3.3 8.6.8 12.8-43.2 3.9-77 44-77 88.4 0 47 37.9 88 84.6 88h257.8c58.3 0 105.6-49.4 105.6-108s-47.3-108.8-105.6-108.8c-2.3 0-4.8-.2-7.2-.2-2.1 0-4.2 0-6.1.1C349.3 145.6 306 96 236 96z"}}]})(props);
	};
	module.exports.IoIosCodeDownload = function IoIosCodeDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M332 142.7c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7L310 155.9c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l95.8 91.5-95.8 91.5c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l13.8 13.2c1.2 1.1 2.6 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l114.2-109c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3L332 142.7zM106.3 256l95.8-91.5c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3l-13.8-13.2c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7l-114.2 109c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l114.2 109c1.2 1.1 2.7 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l13.8-13.2c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3L106.3 256z"}},{"tag":"path","attr":{"d":"M332.8 267.2c.1-3.9-1.4-7.6-4.2-10.4l-.1-.1c-2.7-2.7-6.2-4.2-10-4.2-3.5 0-6.8 1.3-9.4 3.6l-38.9 34.6V184.6c0-7.8-6.4-14.2-14.2-14.2-7.8 0-14.2 6.4-14.2 14.2v106.2l-38.9-34.6c-2.6-2.3-6-3.6-9.4-3.6-3.8 0-7.4 1.5-10.1 4.2l-.1.1c-2.8 2.8-4.2 6.4-4.2 10.4.1 3.9 1.7 7.5 4.6 10.2l62.8 57.7c2.6 2.4 6 3.7 9.5 3.7s6.9-1.3 9.5-3.7l62.8-57.7c2.8-2.8 4.5-6.4 4.5-10.3z"}}]})(props);
	};
	module.exports.IoIosCodeWorking = function IoIosCodeWorking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M446.1 251.6L332 142.7c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7L310 155.9c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l95.8 91.5-95.8 91.5c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l13.8 13.2c1.2 1.1 2.6 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l114.2-109c1.2-1.1 1.9-2.7 1.9-4.3-.1-1.7-.8-3.2-2-4.4zM106.3 256l95.8-91.5c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3l-13.8-13.2c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7l-114.2 109c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l114.2 109c1.2 1.1 2.7 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l13.8-13.2c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3L106.3 256z"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"22"}},{"tag":"circle","attr":{"cx":"192","cy":"256","r":"22"}},{"tag":"circle","attr":{"cx":"320","cy":"256","r":"22"}}]})(props);
	};
	module.exports.IoIosCode = function IoIosCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M332 142.7c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7L310 155.9c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l95.8 91.5-95.8 91.5c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l13.8 13.2c1.2 1.1 2.6 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l114.2-109c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3L332 142.7zM204 160.2c0-1.6-.7-3.2-1.9-4.3l-13.8-13.2c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7l-114.2 109c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l114.2 109c1.2 1.1 2.7 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l13.8-13.2c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3L106.3 256l95.8-91.5c1.2-1.1 1.9-2.7 1.9-4.3z"}}]})(props);
	};
	module.exports.IoIosCog = function IoIosCog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456.9 242.2l-26.1-4.2c-3.5-.6-6.1-3.3-6.6-6.8-.5-3.2-1-6.4-1.7-9.5-.7-3.4.9-6.9 3.9-8.6l23.1-12.8c3.6-1.8 5.3-6.1 3.9-9.9l-4-11c-1.4-3.8-5.4-6-9.4-5l-25.9 5c-3.4.7-6.9-1-8.6-4.1-1.5-2.8-3.1-5.6-4.8-8.4-1.8-3-1.6-6.8.7-9.5l17.3-19.9c2.8-3 2.9-7.5.3-10.6l-7.5-9c-2.6-3.1-7.1-3.8-10.5-1.5L378.3 130c-3 1.8-6.8 1.4-9.4-.9-2.4-2.1-4.9-4.2-7.4-6.2-2.7-2.2-3.8-5.9-2.5-9.1l9.4-24.7c1.6-3.7.2-8.1-3.3-10.1l-10.2-5.9c-3.5-2-8-1.1-10.4 2.2l-16.6 20.8c-2 2.5-4.9 3.8-8.5 2.5 0 0-5.6-2.3-9.8-3.7-3.3-1.1-5.6-4.2-5.5-7.7l.4-26.4c.2-4.1-2.6-7.7-6.6-8.4l-11.6-2c-4-.7-7.9 1.7-9.1 5.6l-8.6 25c-1.1 3.3-4.3 5.5-7.8 5.4-1.6 0-3.3-.1-4.9-.1s-3.3 0-4.9.1c-3.5.1-6.6-2.1-7.8-5.4l-8.6-25c-1.2-3.9-5.1-6.3-9.1-5.6l-11.6 2c-4 .7-6.8 4.3-6.6 8.4l.4 26.4c.1 3.5-2.1 6.4-5.5 7.7-2.3.9-7.3 2.8-9.7 3.7-2.8 1-6.1.2-8.8-2.9l-16.5-20.3c-2.4-3.3-6.9-4.2-10.4-2.2l-10.2 5.9c-3.5 2-5 6.4-3.3 10.1l9.4 24.7c1.2 3.3.2 7-2.5 9.1-2.5 2-5 4.1-7.4 6.2-2.6 2.3-6.4 2.7-9.4.9L111 116.3c-3.4-2.2-7.9-1.6-10.5 1.5l-7.5 9c-2.6 3.1-2.5 7.7.3 10.6l17.3 19.9c2.3 2.6 2.6 6.5.7 9.5-1.7 2.7-3.3 5.5-4.8 8.4-1.7 3.1-5.1 4.7-8.6 4.1l-25.9-5c-4-.9-8 1.2-9.4 5l-4 11c-1.4 3.8.3 8.1 3.9 9.9L85.6 213c3.1 1.7 4.6 5.2 3.9 8.6-.6 3.2-1.2 6.3-1.7 9.5-.5 3.5-3.2 6.2-6.6 6.8l-26.1 4.2c-4 .5-7.1 3.9-7.1 7.9v11.7c0 4.1 3 7.5 7.1 7.9l26.1 4.2c3.5.6 6.1 3.3 6.6 6.8.5 3.2 1 6.4 1.7 9.5.7 3.4-.9 6.9-3.9 8.6l-23.1 12.8c-3.6 1.8-5.3 6.1-3.9 9.9l4 11c1.4 3.8 5.4 6 9.4 5l25.9-5c3.4-.7 6.9 1 8.6 4.1 1.5 2.8 3.1 5.6 4.8 8.4 1.8 3 1.6 6.8-.7 9.5l-17.3 19.9c-2.8 3-2.9 7.5-.3 10.6l7.5 9c2.6 3.1 7.1 3.8 10.5 1.5l22.7-13.6c3-1.8 6.8-1.4 9.4.9 2.4 2.1 4.9 4.2 7.4 6.2 2.7 2.2 3.8 5.9 2.5 9.1l-9.4 24.7c-1.6 3.7-.2 8.1 3.3 10.1l10.2 5.9c3.5 2 8 1.1 10.4-2.2l16.8-20.6c2.1-2.6 5.5-3.7 8.2-2.6 3.4 1.4 5.7 2.2 9.9 3.6 3.3 1.1 5.6 4.2 5.5 7.7l-.4 26.4c-.2 4.1 2.6 7.7 6.6 8.4l11.6 2c4 .7 7.9-1.7 9.1-5.6l8.6-25c1.1-3.3 4.3-5.5 7.8-5.4 1.6 0 3.3.1 4.9.1s3.3 0 4.9-.1c3.5-.1 6.6 2.1 7.8 5.4l8.6 25c1.2 3.9 5.1 6.3 9.1 5.6l11.6-2c4-.7 6.8-4.3 6.6-8.4l-.4-26.4c-.1-3.5 2.2-6.6 5.5-7.7 4.2-1.4 7-2.5 9.6-3.5 2.6-.9 5.8-1 8.3 2.1l17 20.9c2.4 3.3 6.9 4.2 10.4 2.2l10.2-5.9c3.5-2 5-6.4 3.3-10.1l-9.4-24.7c-1.2-3.3-.2-7 2.5-9.1 2.5-2 5-4.1 7.4-6.2 2.6-2.3 6.4-2.7 9.4-.9l22.7 13.6c3.4 2.2 7.9 1.6 10.5-1.5l7.5-9c2.6-3.1 2.5-7.7-.3-10.6l-17.3-19.9c-2.3-2.6-2.6-6.5-.7-9.5 1.7-2.7 3.3-5.5 4.8-8.4 1.7-3.1 5.1-4.7 8.6-4.1l25.9 5c4 .9 8-1.2 9.4-5l4-11c1.4-3.8-.3-8.1-3.9-9.9l-23.1-12.8c-3.1-1.7-4.6-5.2-3.9-8.6.6-3.2 1.2-6.3 1.7-9.5.5-3.5 3.2-6.2 6.6-6.8l26.1-4.2c4-.5 7.1-3.9 7.1-7.9v-11.7c-.2-3.8-3.2-7.3-7.3-7.7zM181.8 356.9c-5.2 9-17.4 10.7-25 3.6C129.2 334.2 112 297.1 112 256c0-40.9 17.1-77.9 44.5-104.1 7.5-7.2 19.8-5.5 25 3.5l56 96.6c1.4 2.5 1.4 5.5 0 8l-55.7 96.9zM396 289.7C380.9 353 323.9 400 256 400c-14.1 0-27.8-2-40.6-5.8-9.9-2.9-14.5-14.4-9.3-23.3l55.7-96.9c1.4-2.5 4.1-4 6.9-4h111.7c10.4 0 18 9.6 15.6 19.7zM380.5 242H268.7c-2.9 0-5.5-1.5-6.9-4l-56.1-96.7c-5.2-8.9-.7-20.4 9.2-23.4 13-3.9 26.8-5.9 41.1-5.9 67.9 0 124.9 47 140 110.3 2.4 10.1-5.2 19.7-15.5 19.7z"}}]})(props);
	};
	module.exports.IoIosColorFill = function IoIosColorFill (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M231.5 118.3c.1 0 .1-.1 0 0L175.3 62c-9.3-9.3-21.6-14-33.9-14-12.3 0-24.6 4.7-33.9 14-18.7 18.7-18.7 49.2 0 67.9l49.3 49.3-84.5 84c-11.1 11.1-11 29.2.3 40l131.2 126c10.9 10.4 28 10.4 38.9-.1 37.8-36.6 118.3-114.5 126.7-122.9 5.8-5.8 18.2-7.1 28.7-7.1h.3c5.9 0 8.8-7.1 4.6-11.2L231.5 118.3zm-103.9-7.9c-7.2-7.2-8.3-18.8-2-26.8 3.8-4.9 9.6-7.6 15.8-7.6 5.4 0 10.4 2.1 14.1 5.8l49.3 49.3-28.3 28.3-48.9-49zM403 339.5c-1.6-1.9-4.5-1.9-6.1 0-10.5 12.2-45 53.9-45 76.4 0 26.6 21.5 48.1 48 48.1s48-21.6 48-48.1c.1-22.6-34.3-64.2-44.9-76.4z"}}]})(props);
	};
	module.exports.IoIosColorFilter = function IoIosColorFilter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M442 248.9c-15.7-20.6-37.7-35.9-62.1-43.6 1-6.3 1.4-12.7 1.4-19.1 0-33.7-13-65.4-36.7-89.2C321 73.1 289.5 60 256 60s-65 13.1-88.6 37c-23.7 23.8-36.7 55.5-36.7 89.2 0 6.4.5 12.8 1.4 19.1-24.5 7.7-46.4 23.1-62.1 43.6-17 22.2-26 48.8-26 76.9 0 33.7 13 65.4 36.7 89.2 23.7 23.8 55.2 37 88.6 37 32.6 0 63.2-12.4 86.7-35 23.4 22.6 54.1 35 86.7 35 33.5 0 65-13.1 88.6-37 23.7-23.8 36.7-55.5 36.7-89.2 0-28.1-9-54.7-26-76.9zM256 85.5c55.1 0 100 45.2 100 100.7 0 4.7-.3 9.4-1 14.1-4.1-.4-8.2-.6-12.4-.6-32.6 0-63.2 12.4-86.7 35-23.4-22.6-54.1-35-86.7-35-4.1 0-8.3.2-12.4.6-.6-4.6-1-9.4-1-14.1.2-55.6 45.1-100.7 100.2-100.7zm0 201.4c-1.8 0-3.7-.1-5.5-.2 1.6-3.8 3.4-7.5 5.5-11.1 2.1 3.6 3.9 7.3 5.5 11.1-1.8.2-3.7.2-5.5.2zm-46.6 131.2c-12.7 5.6-26.1 8.4-40.1 8.4-55.1 0-100-45.2-100-100.7 0-22.3 7.1-43.5 20.6-61.2 12.3-16.1 29.4-28.3 48.5-34.6 6.6 17.9 17.3 34.3 31.2 47.6 13.9 13.4 30.9 23.4 49.2 29.1-1 6.3-1.4 12.7-1.4 19.1 0 25.8 7.7 50.6 22.2 71.7-8.8 8.7-19 15.6-30.2 20.6zM225.1 282c-27.6-9-50-29.8-61.3-56.7 1.8-.1 3.7-.2 5.5-.2 13.9 0 27.4 2.8 40.1 8.4 11.2 5 21.4 11.9 30.1 20.6-5.9 8.7-10.8 18-14.4 27.9zm30.9 94c-8.7-15.2-13.3-32.5-13.3-50.2 0-4.7.3-9.4 1-14.1a128.658 128.658 0 0 0 24.8 0c.6 4.6 1 9.4 1 14.1-.2 17.7-4.8 35-13.5 50.2zm46.6-142.5c12.7-5.6 26.1-8.4 40.1-8.4 1.8 0 3.7.1 5.5.2-11.3 26.9-33.7 47.7-61.3 56.7-3.6-9.8-8.5-19.2-14.4-27.9 8.7-8.7 18.9-15.6 30.1-20.6zm40.1 193c-13.9 0-27.4-2.8-40.1-8.4-11.2-5-21.4-11.9-30.1-20.6 14.5-21.1 22.2-45.8 22.2-71.7 0-6.4-.5-12.8-1.4-19.1 18.3-5.7 35.2-15.7 49.2-29.1 13.8-13.3 24.5-29.6 31.2-47.6 19.1 6.3 36.2 18.4 48.5 34.6 13.5 17.7 20.6 38.9 20.6 61.2-.1 55.6-45 100.7-100.1 100.7z"}}]})(props);
	};
	module.exports.IoIosColorPalette = function IoIosColorPalette (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M430.1 347.9c-6.6-6.1-16.3-7.6-24.6-9-11.5-1.9-15.9-4-22.6-10-14.3-12.7-14.3-31.1 0-43.8l30.3-26.9c46.4-41 46.4-108.2 0-149.2-34.2-30.1-80.1-45-127.8-45-55.7 0-113.9 20.3-158.8 60.1-83.5 73.8-83.5 194.7 0 268.5 41.5 36.7 97.5 55 152.9 55.4h1.7c55.4 0 110-17.9 148.8-52.4 14.4-12.7 12-36.6.1-47.7zM120 216c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm40 126c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-161c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm72 219c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm24-208c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.IoIosColorWand = function IoIosColorWand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M445.7 405.6L201.3 160.4c-3.1-3.1-8.2-3.1-11.3 0l-28.7 28.8c-3.1 3.1-3.1 8.2 0 11.3l244.4 245.2c3.1 3.1 8.2 3.1 11.3 0l28.6-28.8c3.2-3.1 3.2-8.2.1-11.3zm-25.5 14.3l-.1.1c-3.1 3.1-8.2 3.1-11.3 0L218.9 229.5c-3.1-3.1-3.1-8.2 0-11.3l.1-.1c3.1-3.1 8.2-3.1 11.3 0l189.9 190.5c3.1 3.1 3.1 8.2 0 11.3zM192.8 120.1c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12s-12 5.4-12 12v32.1c0 6.6 5.4 12 12 12zM192.8 263.3c-6.6 0-12 5.4-12 12v32.1c0 6.6 5.4 12 12 12s12-5.4 12-12v-32.1c0-6.6-5.4-12-12-12zM270.7 190.2c0 6.6 5.4 12 12 12h32c6.6 0 12-5.4 12-12s-5.4-12-12-12h-32c-6.6 0-12 5.4-12 12zM119.9 190.2c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12s5.4 12 12 12h32c6.5 0 11.9-5.4 11.9-12zM124.8 141c2.3 2.3 5.3 3.5 8.5 3.5s6.2-1.3 8.5-3.5c4.7-4.7 4.7-12.3 0-17l-20.9-21c-2.3-2.3-5.3-3.5-8.5-3.5s-6.2 1.3-8.5 3.5c-4.7 4.7-4.7 12.3 0 17l20.9 21zM133.3 239.9c-3.2 0-6.2 1.3-8.5 3.5l-20.9 21c-2.3 2.3-3.5 5.3-3.5 8.5s1.2 6.2 3.5 8.5 5.3 3.5 8.5 3.5 6.2-1.3 8.5-3.5l20.9-21c4.7-4.7 4.7-12.3 0-17-2.3-2.2-5.3-3.5-8.5-3.5zM252.4 144.5c3.2 0 6.2-1.3 8.5-3.5l20.9-21c4.7-4.7 4.7-12.3 0-17-2.3-2.3-5.3-3.5-8.5-3.5s-6.2 1.3-8.5 3.5l-20.9 21c-2.3 2.3-3.5 5.3-3.5 8.5s1.2 6.2 3.5 8.5c2.3 2.2 5.3 3.5 8.5 3.5z"}}]})(props);
	};
	module.exports.IoIosCompass = function IoIosCompass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M280.5 280.5l-49-49c-.9-.9-2.5-.7-3.2.4l-49.5 98.5c-1.1 1.8 1 3.9 2.8 2.8l98.5-49.5c1.1-.7 1.3-2.3.4-3.2z"}},{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm40.6 249.3L137 377.8c-1.8 1.1-3.9-1-2.8-2.8l80.6-159.6c.2-.3.4-.5.7-.7L375 134.2c1.8-1.1 3.9 1 2.8 2.8l-80.6 159.6c-.1.3-.3.5-.6.7z"}}]})(props);
	};
	module.exports.IoIosConstruct = function IoIosConstruct (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M380 64.4zM275.1 57.6c-9.4-5.9-23.3-9.6-37.9-9.6-14.3 0-30.3 2.5-46.7 9.2-46.5 19-74 45.4-81.1 52.4-7 7-16.8 18-22.9 26.6-6.1 8.7 1.9 21-6.1 29s-24.7 0-24.7 0c-1.4 0-2.9.5-3.9 1.6l-34.1 33.9c-2.2 2.1-2.2 5.7 0 7.8l63.5 63.1c1.1 1.1 2.5 1.6 3.9 1.6s2.9-.5 3.9-1.6l33.2-34.8c2.2-2.1 2.2-5.7 0-7.8 0 0-5.3-5.2-12.1-12s.8-19.3 5.3-23.4c4.5-4.1 11.6-6.8 21.1-6.8 4.3 0 7.4.7 11.4 1.8 12.2 3.4 25.8 15.9 50.9 40.8l-3.9 6.5c-2.3 3.8-.9 8.3 1.3 10.4 0 0-5-4.9 13.1 13.1l50-47.2c-19.1-18.9-14.5-14.1-14.5-14.1-1.4-1.4-3.8-2.3-6.3-2.3-1.4 0-2.9.3-4.2 1l-5.6 3c-28-27.8-35.3-40.2-34.3-61.7 1.1-22.4 12.3-37.1 30.5-52.7 24.7-21.1 60.6-15.2 60.6-15.2 8-.1-4.2-8.6-10.4-12.6zM462.5 399.9s-68.9-57.2-130.2-115.7l-47.7 50.6c58.5 60.6 114.9 127.6 114.9 127.6 1.1 1.1 2.5 1.6 3.9 1.6s2.9-.5 3.9-1.6l55.1-54.7c2.2-2.1 2.2-5.7.1-7.8z"}},{"tag":"path","attr":{"d":"M479.2 125.3l-52.4 52.6-51.1-9.3-9.2-51.1 52.4-52.6c-11.1-11.1-26.8-16.6-39-16.6-.7 0-1.4 0-2 .1-12.5.6-39.2 7.7-59.9 29.7-20 21.1-41.1 60.6-22.4 104.3 2.2 5.3 4.7 12.2-2.7 19.7-1.5 1.4-9.9 9.4-22.5 21.3-3.6 3.4-7.4 7-11.6 11-8 7.6-17.1 16.2-26.8 25.2-3.8 3.6-7.7 7.2-11.6 11-57 53.8-126.9 119.5-126.9 119.5-18 15.5-16.7 44.1-.1 60.8 8.5 8.4 20 12.8 31.3 12.8 11 0 21.9-4.2 29.5-13.1 0 0 65.5-69.8 119.3-126.9 3.7-4 7.4-7.8 11-11.7 9.3-9.9 18-19.1 25.8-27.3 3.9-4.2 7.6-8.1 11-11.6 11.5-12.2 19.3-20.4 21-22 4-3.9 7.7-5.1 11.1-5.1 3.3 0 6.2 1.2 8.6 2.4 9.9 5.1 21 7.3 32.4 7.3 26.7 0 55-12.4 72.1-29.5 24.4-24.4 28.8-47.9 29.6-60 .6-11.8-3.6-27.6-16.9-40.9zM137.4 426.1c-5.5 5.4-14.4 5.4-19.8 0-5.4-5.5-5.4-14.4 0-19.8 5.5-5.4 14.4-5.4 19.8 0 5.4 5.5 5.4 14.4 0 19.8z"}}]})(props);
	};
	module.exports.IoIosContact = function IoIosContact (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C148.5 48 60.1 129.5 49.2 234.1c-.8 7.2-1.2 14.5-1.2 21.9 0 7.4.4 14.7 1.2 21.9C60.1 382.5 148.5 464 256 464c114.9 0 208-93.1 208-208S370.9 48 256 48zm135.8 326.1c-22.7-8.6-59.5-21.2-82.4-28-2.4-.7-2.7-.9-2.7-10.7 0-8.1 3.3-16.3 6.6-23.3 3.6-7.5 7.7-20.2 9.2-31.6 4.2-4.9 10-14.5 13.6-32.9 3.2-16.2 1.7-22.1-.4-27.6-.2-.6-.5-1.2-.6-1.7-.8-3.8.3-23.5 3.1-38.8 1.9-10.5-.5-32.8-14.9-51.3-9.1-11.7-26.6-26-58.5-28h-17.5c-31.4 2-48.8 16.3-58 28-14.5 18.5-16.9 40.8-15 51.3 2.8 15.3 3.9 35 3.1 38.8-.2.7-.4 1.2-.6 1.8-2.1 5.5-3.7 11.4-.4 27.6 3.7 18.4 9.4 28 13.6 32.9 1.5 11.4 5.7 24 9.2 31.6 2.6 5.5 3.8 13 3.8 23.6 0 9.9-.4 10-2.6 10.7-23.7 7-58.9 19.4-80 27.8C91.6 341.4 76 299.9 76 256c0-48.1 18.7-93.3 52.7-127.3S207.9 76 256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256c0 43.9-15.6 85.4-44.2 118.1z"}}]})(props);
	};
	module.exports.IoIosContacts = function IoIosContacts (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm143.3 263.9c-8.1-2.6-23.7-3.4-29.5-10.4-2.9-3.5-1-16.6-1-16.6 25.2-1.4 31-6.1 31-6.1 3.9-2.3 2.1-2.7.1-6.1-10.9-18.3-6-41.5-6.5-61.6-.4-16.7-4.8-35-20-44.4-7.6-4.7-19.7-6.9-31.4-6.9-9.5 0-18.7 1.4-25.3 4.1-42.4 17-17.4 73.2-31.9 105.4-2.5 5.4-6.1 7.3.2 10.5 0 0 7.5 4.4 28.9 6.3 0 0 .3 12.6 0 13.9-1.1 4.9-11.8 8.3-15.8 9.4-2.7.7-8.7 2.5-16.4 5.7-3.7 1.5-3.1 6.9.8 7.6 3.9.7 8.1 1.7 11.5 2.9 0 0 26.4 6 46 25 13.2 12.7 18.1 27.6 20 44.6.5 4.5-1.7 8.9-5.5 11.5l-5.7 3.6c-1.9 1.1-4.2-.2-4.3-2.4 0-29.5-17.8-55.5-45.8-65.2-13.5-4.7-28.1-5-41.6-9.7-4.1-1.4-12.2-3.1-13.9-7.8-1.6-4.6-1.6-10-1.9-14.8-.2-3.8-.3-7.6-.3-11.4 0-2.5 6.4-7.8 7.8-10.1 5.4-9 5.9-21.1 6.9-31.3 8.7 2.4 9.8-13.7 11.3-18.6 1.1-3.4 5-20.9-2.6-23.6 2.5-4.4 3.5-9.8 4.2-14.7 2-12.8 2.8-26.8-1.1-39.3-8.1-26-33-40.6-59.3-41.4-26.7-.9-53.5 11.9-63.5 37.8-4.8 12.6-4.4 26.3-2.8 39.5.7 6 1.7 12.7 4.7 18.1-6.4 2.8-4.5 17.7-3.4 21.3 1.6 5.1 3 23.4 12.1 20.9.8 8.1 1.7 16.4 3.9 24.3 1.5 5.3 4.6 9.8 8.2 13.9 1.8 2 2.7 2.2 2.6 4.8-.1 7.8.1 16.2-1.9 23.8s-18.7 10.8-25.4 12.2c-14.8 3-28.6 4.7-41.4 11.5C84.8 320.6 76 289 76 256c0-47.9 19.2-94 53.2-127.7C162.7 95 207.1 76.4 254.3 76c47.6-.4 93.7 18.1 127.8 51.5 34.8 34.1 54 79.9 54 128.5 0 24.9-5 48.9-14.5 71.1-5.6-7-13.4-12.3-22.3-15.2z"}}]})(props);
	};
	module.exports.IoIosContract = function IoIosContract (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M184.3 204.8h-77.7c-7.7 0-13.9 6.2-13.9 13.9v.2c0 7.7 6.2 13.9 13.9 13.9h112.2c7.7 0 13.9-6.2 13.9-13.9V106.6c0-7.7-6.2-13.9-13.9-13.9h-.2c-7.7 0-13.9 6.2-13.9 13.9v77.7L87.7 68c-2.6-2.6-6.1-4-9.8-4-3.7 0-7.2 1.4-9.8 4.1-5.4 5.4-5.4 14.2 0 19.6l116.2 117.1zM293.1 232.8h112.2c7.7 0 13.9-6.2 13.9-13.9v-.2c0-7.7-6.2-13.9-13.9-13.9h-77.7L444 87.7c5.4-5.4 5.4-14.2 0-19.6-2.6-2.6-6.1-4.1-9.8-4.1-3.7 0-7.2 1.4-9.8 4L307.3 184.3v-77.7c0-7.7-6.2-13.9-13.9-13.9h-.2c-7.7 0-13.9 6.2-13.9 13.9v112.2c0 7.7 6.2 14 13.8 14zM77.9 448c3.7 0 7.2-1.4 9.8-4l117.1-116.3v77.7c0 7.7 6.2 13.9 13.9 13.9h.2c7.7 0 13.9-6.2 13.9-13.9V293.1c0-7.7-6.2-13.9-13.9-13.9H106.6c-7.7 0-13.9 6.2-13.9 13.9v.2c0 7.7 6.2 13.9 13.9 13.9h77.7L68 424.3c-5.4 5.4-5.4 14.2 0 19.6 2.7 2.7 6.2 4.1 9.9 4.1zM293.1 419.2h.2c7.7 0 13.9-6.2 13.9-13.9v-77.7L424.3 444c2.6 2.6 6.1 4 9.8 4 3.7 0 7.2-1.4 9.8-4.1 5.4-5.4 5.4-14.2 0-19.6L327.7 307.2h77.7c7.7 0 13.9-6.2 13.9-13.9v-.2c0-7.7-6.2-13.9-13.9-13.9H293.1c-7.7 0-13.9 6.2-13.9 13.9v112.2c.1 7.7 6.3 13.9 13.9 13.9z"}}]})(props);
	};
	module.exports.IoIosContrast = function IoIosContrast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm127.3 335.3c-34 34-79.2 52.7-127.3 52.7V76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3z"}}]})(props);
	};
	module.exports.IoIosCopy = function IoIosCopy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 115h90c3.3 0 6-2.7 6-6 0-8.2-3.7-16-10-21.3l-77.1-64.2c-4.9-4.1-14.2-7.4-20.6-7.4-4.1 0-7.4 3.3-7.4 7.4V96c.1 10.5 8.6 19 19.1 19z"}},{"tag":"path","attr":{"d":"M307 96V16H176c-17.6 0-32 14.4-32 32v336c0 17.6 14.4 32 32 32h240c17.6 0 32-14.4 32-32V141h-96c-24.8 0-45-20.2-45-45z"}},{"tag":"path","attr":{"d":"M116 412V80H96c-17.6 0-32 14.4-32 32v352c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32v-20H148c-17.6 0-32-14.4-32-32z"}}]})(props);
	};
	module.exports.IoIosCreate = function IoIosCreate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M404.3 86l-202 202c-1.5 1.5-2.3 3.5-2.3 5.6v26.5c0 4.4 3.6 7.9 7.9 7.9h26.3c2.1 0 4.2-.8 5.7-2.3l202.1-202c3.1-3.1 3.1-8.1 0-11.2L415.5 86c-3.1-3.1-8.1-3.1-11.2 0zM475.6 67l-14.4-14.4-.2-.2c-3.1-2.7-7.2-4.4-11.5-4.4-4.4 0-8.5 1.7-11.6 4.5l-11.3 11.4c-1.5 1.6-1.5 4.1 0 5.6L437 79.9l21.7 21.7c1.6 1.6 4.1 1.6 5.7 0l11.3-11.3c2.8-3.1 4.4-7.1 4.4-11.6-.1-4.4-1.7-8.6-4.5-11.7z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M250 342c-3 3-7.1 4.7-11.3 4.7H197.3c-8.8 0-16-7.2-16-16V289.2c0-4.2 1.7-8.3 4.7-11.3l.8-.8 147.6-147.6c2.5-2.5.7-6.8-2.8-6.8H90.7C58.3 122.7 32 149 32 181.4v224c0 32.4 26.3 58.7 58.7 58.7h256c32.4 0 58.7-26.3 58.7-58.7v-209c0-3.6-4.3-5.3-6.8-2.8L250.8 341.2l-.8.8z"}}]}]})(props);
	};
	module.exports.IoIosCrop = function IoIosCrop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M142 64c-7.7 0-14 6.3-14 14v20c0 7.7 6.3 14 14 14s14-6.3 14-14V78c0-7.7-6.3-14-14-14zM156 342V190c0-7.7-6.3-14-14-14s-14 6.3-14 14v166c0 15.5 12.5 28 28 28h166c7.7 0 14-6.3 14-14s-6.3-14-14-14H170c-7.7 0-14-6.3-14-14zM434 356h-20c-7.7 0-14 6.3-14 14s6.3 14 14 14h20c7.7 0 14-6.3 14-14s-6.3-14-14-14z"}},{"tag":"path","attr":{"d":"M64 142c0 7.7 6.3 14 14 14h264c7.7 0 14 6.3 14 14v264c0 7.7 6.3 14 14 14s14-6.3 14-14V156c0-15.5-12.5-28-28-28H78c-7.7 0-14 6.3-14 14z"}}]})(props);
	};
	module.exports.IoIosCube = function IoIosCube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.8 129.5L261.7 49.2c-3.6-1.6-7.7-1.6-11.3 0L71.2 129.5c-6 2.7-6.2 11.8-.4 14.8l178.7 94.1c4.1 2.2 8.9 2.2 13 0l178.7-94.1c5.8-3 5.6-12.1-.4-14.8zM280.2 462.9l180.1-95.3c2.2-1.4 3.6-4 3.6-6.8V175.9c0-5.9-5.8-9.7-10.7-7.1l-180.1 92.8c-2.6 1.3-4.2 4.1-4.2 7.1V456c.1 6.2 6.4 10 11.3 6.9zM48 175.9v184.8c0 2.8 1.4 5.4 3.6 6.8l180.1 95.3c5 3.2 11.2-.6 11.2-6.8V268.7c0-3-1.6-5.8-4.2-7.1l-180-92.8c-4.9-2.6-10.7 1.3-10.7 7.1z"}}]})(props);
	};
	module.exports.IoIosCut = function IoIosCut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M308 277.2c25.5-33 80.5-111.5 90.2-135.4 7.2-17.6 10.6-32.8 10.4-46.2-.2-17.9-6-29.3-18.3-40.6-5.2-4.8-13.5-6.9-20-6.9L255.9 201.7l-10 13.4-2.9 3.9-.1.1-14.5 19.7c-.1.1-.2.3-.3.4-.5.8-7.5 10.9-15.2 22.7-3 4.6-6.1 9.5-9 14.1-3.5 5.6-6.6 11-8.8 15.2-3.6 7.1-7.3 14.4-10.7 21.5-3.7 7.5-7.2 14.6-10.4 20.7-10.2-7.3-22-11.1-34.3-11.1-17.5 0-33.7 7.7-45.8 21.6C82.4 357.1 76 374.6 76 393.1c0 18.5 6.4 36 17.9 49.3 12.1 13.9 28.4 21.6 45.8 21.6 14.4 0 28-5.2 39.2-15 10.5-9.1 18-21.3 21.8-35.4 1-3.1 11.6-34.7 26.1-57.3 9.2-14.4 22.2-23.4 29.6-27.8l13.5-9.7c0 .1 12.7-8.7 38.1-41.6zM139.9 421.1c-13.3 0-24-12.6-24-28s10.7-28 24-28 24 12.6 24 28c0 15.5-10.8 28-24 28zm116.2-132.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}},{"tag":"path","attr":{"d":"M191.5 260.4c.7 1 1.6 1.9 2.5 2.7 1.7-2.8 3.6-5.7 5.4-8.6l46.5-65.8L140.9 48c-8.9 0-14.4.9-18.5 3.9-11.9 8.9-19.1 25.6-19.3 43.6-.2 13.5 3.3 28.6 10.4 46.2 8.6 21 42.6 70.2 78 118.7zM372 322.3c-12.3 0-24.1 3.8-34.3 11.1-3.2-6.1-6.7-13.2-10.4-20.7-3.4-6.9-6.9-14-10.4-20.8L306 305.8l-36.4 33.1c5.2 4.6 10.7 10.4 15.3 17.5 14.5 22.6 25 54.2 26 57.3 3.8 14.1 11.3 26.3 21.8 35.4 11.3 9.8 24.9 15 39.2 15 35.3 0 64-31.8 64-70.9s-28.6-70.9-63.9-70.9zm.1 98.8c-13.3 0-24-12.6-24-28s10.7-28 24-28 24 12.6 24 28c0 15.5-10.7 28-24 28z"}}]})(props);
	};
	module.exports.IoIosDesktop = function IoIosDesktop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 442.2c-.3-2.2-2-3.9-4.2-4.3l-22.3-1.9c-11.8-3.1-20.5-16.2-22.3-28.3L302 400h-92l-1.2 7.6c-1.9 12.1-10.5 25.2-22.3 28.3l-22.3 1.9c-2.1.5-3.9 2.2-4.2 4.3-.4 3.1 2 5.8 5.1 5.8h181.8c3 .1 5.5-2.6 5.1-5.7zM472.9 71c-4.5-4.5-10.7-7-17-7H56.2c-6.4 0-12.5 2.5-17 7S32 81.7 32 88v272c0 6.4 2.7 12.5 7.2 17s10.5 7 16.8 7h400c6.4 0 12.3-2.5 16.8-7s7.2-10.7 7.2-17V88c.1-6.3-2.6-12.5-7.1-17zM256 360c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm203.9-40H52.2c-2.2 0-4-1.8-4-4V92c0-6.6 5.4-12 12-12h391.7c6.6 0 12 5.4 12 12v224c0 2.2-1.8 4-4 4z"}}]})(props);
	};
	module.exports.IoIosDisc = function IoIosDisc (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 165.8c-49.9 0-90.3 40.4-90.3 90.3s40.4 90.2 90.3 90.2 90.3-40.4 90.3-90.2c0-49.9-40.4-90.3-90.3-90.3zm0 130.6c-22.3 0-40.4-18.1-40.4-40.4s18.1-40.4 40.4-40.4 40.4 18.1 40.4 40.4-18.1 40.4-40.4 40.4z"}},{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm0 322c-63 0-114-51.1-114-114 0-63 51.1-114 114-114s114 51 114 114-51 114-114 114z"}}]})(props);
	};
	module.exports.IoIosDocument = function IoIosDocument (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M312 155h91c2.8 0 5-2.2 5-5 0-8.9-3.9-17.3-10.7-22.9L321 63.5c-5.8-4.8-13-7.4-20.6-7.4-4.1 0-7.4 3.3-7.4 7.4V136c0 10.5 8.5 19 19 19z"}},{"tag":"path","attr":{"d":"M267 136V56H136c-17.6 0-32 14.4-32 32v336c0 17.6 14.4 32 32 32h240c17.6 0 32-14.4 32-32V181h-96c-24.8 0-45-20.2-45-45z"}}]})(props);
	};
	module.exports.IoIosDoneAll = function IoIosDoneAll (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M317.5 210.3c1.7-1.8 1.8-4.7 0-6.5l-19.8-21c-.8-.9-2-1.4-3.2-1.4-1.2 0-2.4.5-3.2 1.4l-66.5 69.1 26.4 27.1 66.3-68.7zM123.8 253.1c-.9-.9-2-1.4-3.2-1.4-1.2 0-2.3.5-3.2 1.4l-20.1 20.7c-1.8 1.8-1.8 4.8 0 6.6l63.2 65c4 4.2 9 6.6 13.2 6.6 6 0 11.1-4.5 13.1-6.4l.1-.1 13.4-13.8-76.5-78.6z"}},{"tag":"path","attr":{"d":"M414.7 182.4l-19.8-21c-.8-.9-2-1.4-3.2-1.4-1.2 0-2.4.5-3.2 1.4L250.7 304.1l-50.1-51.6c-.9-.9-2-1.4-3.2-1.4-1.2 0-2.3.5-3.2 1.4l-20.1 20.7c-1.8 1.8-1.8 4.8 0 6.6l63.2 65c4 4.2 9 6.6 13.2 6.6 6 0 11.1-4.5 13.1-6.4l.1-.1 151-156.1c1.7-1.7 1.7-4.6 0-6.4z"}}]})(props);
	};
	module.exports.IoIosDownload = function IoIosDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 144H269v179.9l47.9-47.2c5.1-5 13.3-5 18.4.1 5 5.1 5 13.3-.1 18.4l-70 69c-2.5 2.4-5.8 3.7-9.1 3.7-1.7 0-3.4-.3-5-1-1.5-.6-2.9-1.6-4.1-2.7l-70-69c-5.1-5-5.2-13.3-.1-18.4 5-5.1 13.3-5.2 18.4-.1l47.9 47.2V144H136c-22 0-40 18-40 40v240c0 22 18 40 40 40h240c22 0 40-18 40-40V184c0-22-18-40-40-40zM269 61c0-7.2-5.8-13-13-13s-13 5.8-13 13v83h26V61z"}}]})(props);
	};
	module.exports.IoIosEasel = function IoIosEasel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434 461.5l-26.6-69.1c-2.1-5.1-7-8.4-12.4-8.4-4.5 0-8.6 2.2-11.1 5.9s-3 8.4-1.4 12.5l26 69.1c2.1 5.1 7 8.5 12.5 8.5h.5c4.5 0 8.7-2.2 11.2-5.9 2.5-3.8 3-8.5 1.3-12.6zM117.6 384c-5.5 0-10.4 3.3-12.4 8.4l-26.6 69.1c-1.7 4.2-1.2 8.9 1.3 12.6 2.5 3.7 6.7 5.9 11.2 5.9h.5c5.5 0 10.4-3.3 12.5-8.5l26-69.1c1.7-4.1 1.2-8.8-1.4-12.5-2.4-3.7-6.6-5.9-11.1-5.9zM256.6 384h-1.1c-7.4 0-13.4 6-13.4 13.4v36.1c0 7.4 6 14.4 13.4 14.4h1.1c7.4 0 13.4-7 13.4-14.4v-36.1c0-7.4-6-13.4-13.4-13.4z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M424 128H88c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h336c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8z"}},{"tag":"path","attr":{"d":"M448 80H63.9C46.3 80 32 94.3 32 111.9v224.2c0 17.6 14.3 31.9 31.9 31.9H448c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32zm4 244c0 8.8-7.2 16-16 16H76c-8.8 0-16-7.2-16-16V124c0-8.8 7.2-16 16-16h364.6c3 0 5.9 1.2 8 3.3 2.1 2.1 3.3 5 3.3 8V324z"}}]},{"tag":"path","attr":{"d":"M256 32c-13.4-.2-24.4 12.2-24.4 25.6h48.7c.1-13.4-10.9-25.8-24.3-25.6z"}}]})(props);
	};
	module.exports.IoIosEgg = function IoIosEgg (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C192 32 96 165.2 96 288.9 96 412.6 160 480 256 480s160-67.4 160-191.1C416 165.2 320 32 256 32z"}}]})(props);
	};
	module.exports.IoIosExit = function IoIosExit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144 136v107h179.9l-47.2-47.9c-5-5.1-5-13.3.1-18.4 5.1-5 13.3-5 18.4.1l69 70c2.4 2.5 3.7 5.8 3.7 9.1 0 1.7-.3 3.4-1 5-.6 1.5-1.6 2.9-2.7 4.1l-69 70c-5 5.1-13.3 5.2-18.4.1-5.1-5-5.2-13.3-.1-18.4l47.2-47.9H144v107c0 22 18 40 40 40h240c22 0 40-18 40-40V136c0-22-18-40-40-40H184c-22 0-40 18-40 40zM61 243c-7.2 0-13 5.8-13 13s5.8 13 13 13h83v-26H61z"}}]})(props);
	};
	module.exports.IoIosExpand = function IoIosExpand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M112.4 92h77.7c7.7 0 13.9-6.2 13.9-13.9v-.2c0-7.7-6.2-13.9-13.9-13.9H77.9C70.2 64 64 70.2 64 77.9v112.2c0 7.7 6.2 13.9 13.9 13.9h.2c7.7 0 13.9-6.2 13.9-13.9v-77.7l117.1 116.3c2.6 2.6 6.1 4 9.8 4 3.7 0 7.2-1.4 9.8-4.1 5.4-5.4 5.4-14.2 0-19.6L112.4 92zM434.1 64H321.9c-7.7 0-13.9 6.2-13.9 13.9v.2c0 7.7 6.2 13.9 13.9 13.9h77.7L283.3 209.1c-5.4 5.4-5.4 14.2 0 19.6 2.6 2.6 6.1 4.1 9.8 4.1 3.7 0 7.2-1.4 9.8-4L420 112.4v77.7c0 7.7 6.2 13.9 13.9 13.9h.2c7.7 0 13.9-6.2 13.9-13.9V77.9c0-7.7-6.2-13.9-13.9-13.9zM218.9 279.2c-3.7 0-7.2 1.4-9.8 4L92 399.6v-77.7c0-7.7-6.2-13.9-13.9-13.9h-.2c-7.7 0-13.9 6.2-13.9 13.9v112.2c0 7.7 6.2 13.9 13.9 13.9h112.2c7.7 0 13.9-6.2 13.9-13.9v-.2c0-7.7-6.2-13.9-13.9-13.9h-77.7l116.3-117.1c5.4-5.4 5.4-14.2 0-19.6-2.6-2.6-6.1-4.1-9.8-4.1zM434.1 308h-.2c-7.7 0-13.9 6.2-13.9 13.9v77.7L302.9 283.3c-2.6-2.6-6.1-4-9.8-4-3.7 0-7.2 1.4-9.8 4.1-5.4 5.4-5.4 14.2 0 19.6l116.3 117h-77.7c-7.7 0-13.9 6.2-13.9 13.9v.2c0 7.7 6.2 13.9 13.9 13.9h112.2c7.7 0 13.9-6.2 13.9-13.9V321.9c0-7.7-6.2-13.9-13.9-13.9z"}}]})(props);
	};
	module.exports.IoIosEyeOff = function IoIosEyeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M88.3 68.1c-5.6-5.5-14.6-5.5-20.1.1-5.5 5.5-5.5 14.5 0 20l355.5 355.7c3.7 3.7 9 4.9 13.7 3.6 2.4-.6 4.6-1.9 6.4-3.7 5.5-5.5 5.5-14.5 0-20L88.3 68.1zM260.2 345.9c-53 2.4-96.6-41.2-94.1-94.1.6-12.2 3.6-23.8 8.6-34.3L121.3 164c-27.7 21.4-55.4 48.9-85.1 81.3-5.5 6.1-5.6 15.2-.1 21.3C101 338.3 158.2 400 255.8 400c29.7 0 57.1-7.4 82.3-19.2l-43.5-43.5c-10.6 5-22.2 8-34.4 8.6zM475.8 266c5.3-5.8 5.6-14.6.5-20.7C424 181.8 351.5 112 255.8 112c-29.1 0-56 6.6-82 19l43.7 43.7c10.5-5 22.1-8.1 34.3-8.6 53-2.4 96.6 41.2 94.1 94.1-.6 12.2-3.6 23.8-8.6 34.3l53.5 53.5c33-25.3 61.3-55.9 85-82z"}},{"tag":"path","attr":{"d":"M192.2 260.9c2.4 31.3 27.6 56.5 58.9 58.9 8.2.6 16.1-.3 23.4-2.6l-79.8-79.8c-2.2 7.4-3.1 15.3-2.5 23.5zM320 256c0-1.3-.1-2.6-.1-3.9-5.6 2.5-11.7 3.9-18.2 3.9-1.1 0-2.1 0-3.1-.1l18.6 18.7c1.8-5.9 2.8-12.2 2.8-18.6zM256 209c0-6 1.1-11.7 3.1-16.9-1 0-2-.1-3.1-.1-6.4 0-12.6 1-18.5 2.8l18.7 18.7c-.1-1.5-.2-3-.2-4.5z"}}]})(props);
	};
	module.exports.IoIosEye = function IoIosEye (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.8 112c-80.4 0-143.8 50.6-219.6 133.3-5.5 6.1-5.6 15.2-.1 21.3C101 338.3 158.2 400 255.8 400c96.4 0 168.7-77.7 220.1-134 5.3-5.8 5.6-14.6.5-20.7C424 181.8 351.5 112 255.8 112zm4.4 233.9c-53 2.4-96.6-41.2-94.1-94.1 2.1-46.2 39.5-83.6 85.7-85.7 53-2.4 96.6 41.2 94.1 94.1-2.1 46.2-39.5 83.6-85.7 85.7z"}},{"tag":"path","attr":{"d":"M256 209c0-6 1.1-11.7 3.1-16.9-1 0-2-.1-3.1-.1-36.9 0-66.6 31.4-63.8 68.9 2.4 31.3 27.6 56.5 58.9 58.9 37.5 2.8 68.9-26.9 68.9-63.8 0-1.3-.1-2.6-.1-3.9-5.6 2.5-11.7 3.9-18.2 3.9-25.2 0-45.7-21.1-45.7-47z"}}]})(props);
	};
	module.exports.IoIosFastforward = function IoIosFastforward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476.1 249.3L268 129.1c-5.4-3.1-12.3.6-12.3 6.7V251L44.3 129.1c-5.4-3.1-12.3.6-12.3 6.7v240.3c0 6.1 6.9 9.8 12.3 6.7L255.6 261v115.2c0 6.1 6.9 9.8 12.3 6.7L476 262.7c5.3-3 5.3-10.4.1-13.4z"}}]})(props);
	};
	module.exports.IoIosFemale = function IoIosFemale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M61.6 464c3.6 0 7.1-1.4 9.6-4l44.8-44.8 37 37c2.6 2.6 6 4 9.6 4 3.6 0 7.1-1.4 9.6-4 5.3-5.3 5.3-13.9 0-19.2l-37-37 50-50c30.6 26 69.3 40.3 109.6 40.3 22.8 0 45-4.5 65.8-13.3 20.1-8.5 38.2-20.7 53.8-36.2 15.5-15.5 27.7-33.6 36.2-53.8 8.8-20.9 13.3-43 13.3-65.8s-4.5-45-13.3-65.8c-8.5-20.1-20.7-38.2-36.2-53.8-15.5-15.5-33.6-27.7-53.8-36.2-20.9-8.8-43-13.3-65.8-13.3-22.8 0-45 4.5-65.8 13.3-20.1 8.5-38.2 20.7-53.8 36.2-15.5 15.5-27.7 33.6-36.2 53.8-8.8 20.9-13.3 43-13.3 65.8 0 40.3 14.3 79 40.3 109.6l-50 50-37-37c-2.6-2.6-6-4-9.6-4-3.6 0-7.1 1.4-9.6 4-5.3 5.3-5.3 13.9 0 19.2l37 37L52 440.8c-5.3 5.3-5.3 13.9 0 19.2 2.6 2.6 6 4 9.6 4zm132.9-347.2C221.3 90 257 75.2 294.9 75.2c37.9 0 73.5 14.8 100.3 41.6 26.8 26.8 41.6 62.4 41.6 100.3s-14.8 73.5-41.6 100.3c-26.8 26.8-62.4 41.6-100.3 41.6s-73.5-14.8-100.3-41.6C167.7 290.7 153 255 153 217.1s14.7-73.5 41.5-100.3z"}}]})(props);
	};
	module.exports.IoIosFiling = function IoIosFiling (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424 64H88c-22 0-40 18-40 40v304c0 22 18 40 40 40h336c22 0 40-18 40-40V104c0-22-18-40-40-40zm12 176c0 8.8-7.2 16-16 16h-86.8c-6.8 0-12.8 4.2-15.1 10.6C314 278.2 303.8 288 292 288h-72c-11.9 0-22.1-9.8-26.1-21.4-2.2-6.4-8.3-10.6-15.1-10.6H92c-8.8 0-16-7.2-16-16V108c0-8.8 7.2-16 16-16h328c8.8 0 16 7.2 16 16v132z"}},{"tag":"path","attr":{"d":"M386 156H126c-7.7 0-14-6.3-14-14s6.3-14 14-14h260c7.7 0 14 6.3 14 14s-6.3 14-14 14zM386 220H126c-7.7 0-14-6.3-14-14s6.3-14 14-14h260c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}}]})(props);
	};
	module.exports.IoIosFilm = function IoIosFilm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.9 80H64.1C46.5 80 32 94.5 32 112.1v287.7c0 17.7 14.5 32.1 32.1 32.1h383.7c17.7 0 32.1-14.5 32.1-32.1V112.1c.1-17.6-14.4-32.1-32-32.1zM120 400c0 4.4-3.6 8-8 8H64c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8H64c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8H64c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8H64c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm232 108H160c-6.6 0-12-5.4-12-12s5.4-12 12-12h192c6.6 0 12 5.4 12 12s-5.4 12-12 12zm104 132c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48zm0-80c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48z"}}]})(props);
	};
	module.exports.IoIosFingerPrint = function IoIosFingerPrint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450.8 182c-8.6-24.4-20.3-44.9-33-57.5-2.6-2.6-6-4-9.7-4-3.7 0-7.1 1.4-9.7 4-5.3 5.3-5.3 14 0 19.4 9.9 9.9 19.6 27.4 26.8 48.1 7.3 21.2 11.4 43.6 11.4 63.1 0 3-.1 7.6-.2 10.1-.2 3.7 1.1 7.1 3.6 9.8 2.5 2.7 5.8 4.3 9.5 4.4h.6c7.3 0 13.3-5.7 13.7-13.1.1-3.1.2-8.1.2-11.3 0-22.8-4.7-48.8-13.2-73zM143 110.6c2.9 0 5.6-.9 8-2.6 29.9-21.4 66.2-32.7 105-32.7 40.8 0 80.1 14.8 113.7 42.8 2.5 2 5.6 3.2 8.8 3.2 4.1 0 7.9-1.8 10.5-4.9 4.8-5.8 4-14.4-1.7-19.3C348.6 65 303.3 48 256 48c-44.6 0-86.4 13.1-121 37.8-3 2.1-4.9 5.3-5.5 8.9-.6 3.6.2 7.2 2.4 10.2 2.5 3.6 6.7 5.7 11.1 5.7zM75.4 255c0-43.7 15.8-85.8 44.5-118.7 2.4-2.8 3.6-6.3 3.3-9.9-.2-3.6-1.9-7-4.7-9.4-2.5-2.2-5.7-3.4-9-3.4-4 0-7.7 1.7-10.3 4.7C66.2 156.2 48 204.7 48 255c0 32.8 5.9 58.8 15.4 90.2 1.8 5.8 7 9.7 13.1 9.7 1.3 0 2.7-.2 4-.6 3.5-1.1 6.4-3.4 8.1-6.6 1.7-3.2 2.1-6.9 1-10.4-8.8-29-14.2-52.8-14.2-82.3z"}},{"tag":"path","attr":{"d":"M355.7 129.8C328.4 106.1 295 93.6 259 93.6c-48.3 0-91.4 17.8-121.5 50.1-28.7 30.8-42.8 71.7-39.7 115.1 2.3 32.7 6 50.7 9.3 66.6 4.3 21.1 7.7 37.8 5.1 84.1-.4 6.7 3.7 12.7 10 14.6 1.2.4 2.3.5 3.6.5 7.2 0 13.2-5.7 13.7-12.9 2.9-50.4-.8-68.7-5.5-91.9-3.1-15.1-6.6-32.2-8.8-63.1-2.6-35.7 9-69.3 32.4-94.5 24.8-26.7 60.9-41.4 101.4-41.4 29.3 0 56.5 10.2 78.7 29.5 22.3 19.3 39.2 47.4 49 81.1 11.4 39.3 14.5 89.3 9.1 144.5-.7 7.5 4.8 14.2 12.3 15 .4 0 .9.1 1.3.1 7.1 0 12.9-5.3 13.6-12.4 5.8-58.7 2.3-112.2-10.1-154.8-11.1-38.6-30.9-71.2-57.2-94z"}},{"tag":"path","attr":{"d":"M373.5 267.5c-5.9-37.5-19.9-68.8-40.6-90.6-20.8-22-47.4-33.7-76.9-33.7-19 0-37.7 4.1-54.1 12-3.7 1.8-6.4 5.1-7.4 9.1-1 4.1-.1 8.3 2.5 11.6 2.6 3.4 6.5 5.3 10.8 5.3 2.1 0 4-.5 5.9-1.3 12.6-6 27.2-9.2 42.2-9.2 22.4 0 42.5 9.2 58.3 26.6 16.1 17.8 27.3 43.6 32.1 74.6 4.7 29.6 7 53.5 7.1 73.1.2 39.7-4.8 72.7-4.8 73.1-.6 3.6.3 7.2 2.5 10.2 2.2 3 5.3 4.9 8.9 5.5.7.1 1.4.2 2.1.2 6.8 0 12.5-4.9 13.5-11.6.2-1.4 5.4-35.2 5.2-77.5 0-21.3-2.4-46.5-7.3-77.4zM185.3 203.5c4-5.8 2.9-13.6-2.5-18.2-2.5-2.1-5.6-3.2-8.8-3.2-4.5 0-8.7 2.2-11.3 5.9-14.7 21.5-19.7 49.1-14.4 79.8 8.9 51.3 16.9 111.1 9.4 165-.5 3.8.5 7.7 2.9 10.7 2.3 3 5.7 4.8 9.4 5.1.4 0 .8.1 1.2.1 6.8 0 12.6-5.1 13.5-11.8 8.2-57.7-.2-120.2-9.5-173.8-4.1-23.8-.7-43.9 10.1-59.6zM317.5 388h-.5c-7.6.3-13.5 6.6-13.2 14.2 0 .2.6 17.9-2.6 34.7-1.3 6.9 2.6 13.7 9.1 15.8 1.4.4 2.8.7 4.3.7 6.6 0 12.2-4.7 13.4-11.1 3.8-20.1 3.1-40.2 3.1-41.1-.2-7.5-6.2-13.2-13.6-13.2z"}},{"tag":"path","attr":{"d":"M294.6 205.9c-11.2-10.5-25.2-16.1-40.5-16.1-19.8 0-36.7 7.3-47.6 20.5-8.3 10.1-17 28.8-10.9 60 12.3 62.5 15 121.6 8.1 175.6-1 7.5 4.4 14.4 11.8 15.3.6.1 1.2.1 1.7.1 6.9 0 12.7-5.1 13.6-12 7.3-57 4.5-119-8.3-184.4-3.2-16.4-1.4-29.3 5.1-37.3 5.6-6.8 15-10.5 26.4-10.5 25 0 35.1 27.6 38.3 39.4 6.9 25.7 10.9 63 11.5 107.7.1 7.4 6.2 13.5 13.7 13.5h.2c3.6-.1 7-1.5 9.6-4.1 2.5-2.6 3.9-6.1 3.9-9.7-.7-47-5-86.5-12.5-114.4-4.9-18.5-13.1-33.2-24.1-43.6z"}},{"tag":"path","attr":{"d":"M265.2 245.9c-2.1-5.1-7.1-8.5-12.7-8.5-1.8 0-3.6.4-5.2 1-7 2.9-10.3 10.9-7.4 17.9 6.6 16 11.8 46.2 14.1 82.8 2.4 36.9 1.7 76.9-2 109.6-.4 3.6.6 7.2 2.9 10.1 2.3 2.9 5.5 4.6 9.2 5 .5.1 1 .1 1.5.1 7 0 12.8-5.2 13.6-12.2 3.9-35.5 4.6-76.6 2-115.8-2.5-39.3-8.2-71.3-16-90z"}}]})(props);
	};
	module.exports.IoIosFitness = function IoIosFitness (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 280H160c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h192c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8zM378 362V150c0-12.1 9.9-22 22-22s22 9.9 22 22v212c0 12.1-9.9 22-22 22s-22-9.9-22-22zM460 192h-12c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h12c11 0 20-9 20-20v-88c0-11-9-20-20-20zM134 362V150c0-12.1-9.9-22-22-22s-22 9.9-22 22v212c0 12.1 9.9 22 22 22s22-9.9 22-22zM64 192H52c-11 0-20 9-20 20v88c0 11 9 20 20 20h12c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8z"}}]})(props);
	};
	module.exports.IoIosFlag = function IoIosFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M406.7 80.8c-3.1.5-6.4 1-9.9 1.4-13.2 1.7-42.8 5.2-60.6 5.2-27.7 0-52.8-6.8-78.2-12.2-25.8-5.5-52.4-11.2-80.6-11.2-56.2 0-75.3 12.1-77.3 13.4L96 80.3v353.3c0 7.2 5.2 13.4 12.3 14.3 8.5 1 15.7-5.6 15.7-13.9V279.6c0-3.8 2.7-7.1 6.4-7.9 10.5-2.1 25.8-3.9 47-3.9 26.2 0 50.7 10 76.6 15.5 26.4 5.6 48.6 11.5 83.4 11.5s71.8-6.6 71.8-6.6c3.9-.6 6.9-3.9 6.9-7.9V88.7c-.1-4.9-4.5-8.7-9.4-7.9z"}}]})(props);
	};
	module.exports.IoIosFlame = function IoIosFlame (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M220.1 48C249.1 182.6 111 179.9 112 315.4c.8 111 118.4 148.6 144.5 148.6 26.1 0 134.8-23.6 143.1-148.6 7.1-106.4-81.7-208-179.5-267.4zm74.3 354.7c-10.2 38.9-66 39-76.4.1-1.5-5.6-2.4-11.5-2.4-17.5 0-41 40.6-88.3 40.6-88.3s40.4 47.3 40.4 88.3c.1 6-.7 11.8-2.2 17.4z"}}]})(props);
	};
	module.exports.IoIosFlashOff = function IoIosFlashOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M382.1 442.7L154.5 55c-4-6.7-12.7-9-19.5-5.1-6.8 3.9-9.1 12.6-5.1 19.3L357.5 457c2.6 4.5 7.4 7 12.3 7 2.4 0 4.9-.6 7.2-1.9 6.7-4 9-12.6 5.1-19.4zM324.6 313.3l57.9-75.8c3.8-5.6.2-13.4-6.3-13.4h-104l52.4 89.2zM320.4 37.1c.9-4.5-4.6-7.1-7.2-3.4L227 146.9l42.4 72.3 51-182.1zM187.4 198.7l-57.9 75.8c-3.8 5.6-.2 13.4 6.3 13.4h103.9l-52.3-89.2zM191.6 474.9c-.9 4.5 4.6 7.1 7.2 3.4L285 365.1l-42.4-72.3-51 182.1z"}}]})(props);
	};
	module.exports.IoIosFlash = function IoIosFlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376.2 224H268l52.4-186.9c.9-4.5-4.6-7.1-7.2-3.4L129.5 274.6c-3.8 5.6-.2 13.4 6.3 13.4H244l-52.4 186.9c-.9 4.5 4.6 7.1 7.2 3.4l183.7-240.8c3.7-5.7.2-13.5-6.3-13.5z"}}]})(props);
	};
	module.exports.IoIosFlashlight = function IoIosFlashlight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M317 32H195c-17.6 0-24 14.4-24 32h170c0-17.6-6.4-32-24-32zM196.1 147.5c7.6 8.8 11.9 20 11.9 31.7v265.9c0 21.9 17.9 34.9 39.9 34.9h16.3c21.9 0 39.9-12.9 39.9-34.9V179.2c0-11.7 4.3-22.8 11.9-31.7 15.4-17.9 25-34.5 25-67.5H171c0 35 9.6 49.6 25.1 67.5zm31.9 90.8c0-15.6 12.6-28.3 28-28.3s28 12.7 28 28.3v35.4c0 15.6-12.6 28.3-28 28.3s-28-12.7-28-28.3v-35.4z"}},{"tag":"circle","attr":{"cx":"256","cy":"273","r":"20"}}]})(props);
	};
	module.exports.IoIosFlask = function IoIosFlask (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.4 354.4L320.7 159.9c-.4-.6-.6-1.3-.6-2.1V80c0-2.2 1.8-4 4-4 6.6 0 12-5.4 12-12v-4c0-6.6-5.4-12-12-12H187.8c-6.6 0-12 5.4-12 12v4c0 6.6 5.4 12 12 12 2.2 0 4 1.8 4 4v77.9c0 .7-.2 1.4-.6 2L75.7 354.4c-8.4 15.8-12.5 31.4-12.1 45.6 1.1 36.5 28.8 64 65.2 64h256.6c36.4 0 62.3-27.6 63.2-64 .2-14.2-2.7-29.7-11.2-45.6zM161.8 288c-6.2 0-10.1-6.8-6.9-12.1l60.5-101.7c2.9-4.9 4.5-10.6 4.5-16.3V80c0-1.4-.1-2.7-.2-4h72.7c-.2 1.3-.2 2.6-.2 4v77.9c0 5.8 1.6 11.5 4.6 16.4l60.4 101.6c3.2 5.3-.7 12.1-6.9 12.1H161.8z"}}]})(props);
	};
	module.exports.IoIosFlower = function IoIosFlower (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M385.1 230.2c-26.7 0-60.1 6.9-86.3 13.5-.9-3.2-2.1-6.2-3.7-9.1 23.2-13.8 51.7-32.5 70.5-51.4 36.7-36.7 48.3-63.6 37.6-74.3-2.6-2.6-6-3.8-10.3-3.8-13.8 0-36 13.4-64 41.4-18.8 18.8-37.6 47.2-51.4 70.4-2.8-1.6-5.9-2.8-9.1-3.8 6.7-26.2 13.5-59.5 13.5-86.1 0-51.9-10.8-79.1-26-79.1s-26 27.2-26 79.1c0 26.6 6.8 60 13.5 86.1-3.2.9-6.2 2.2-9.1 3.8-13.8-23.2-32.5-51.6-51.4-70.4-28-28-50.3-41.4-64-41.4-4.3 0-7.7 1.3-10.3 3.8-10.8 10.8.8 37.6 37.6 74.3 18.9 18.9 47.3 37.6 70.5 51.4-1.5 2.8-2.8 5.9-3.7 9.1-26.2-6.7-59.6-13.5-86.3-13.5-51.8 0-78.7 10.6-78.7 25.8s26.9 26.2 78.9 26.2c26.7 0 60.2-6.9 86.4-13.6.9 3.1 2.2 6.2 3.8 9-23.3 13.8-51.8 32.6-70.7 51.5-36.7 36.7-48.3 63.6-37.6 74.3 2.6 2.6 6 3.8 10.3 3.8 13.8 0 36-13.4 64-41.4 18.9-18.9 37.8-47.5 51.6-70.8 2.8 1.5 5.8 2.8 9 3.7-6.7 26.2-13.6 59.8-13.6 86.5 0 51.9 10.8 78.6 26 78.6s26-26.7 26-78.6c0-26.8-6.9-60.3-13.6-86.5 3.1-.9 6.1-2.1 9-3.7 13.8 23.3 32.6 51.9 51.6 70.8 28 28 50.3 41.4 64 41.4 4.3 0 7.7-1.3 10.3-3.8 10.8-10.8-.8-37.6-37.6-74.3-18.9-18.9-47.5-37.7-70.7-51.5 1.6-2.8 2.8-5.8 3.8-9 26.2 6.7 59.7 13.6 86.4 13.6 51.9 0 78.9-10.8 78.9-26-.2-15.2-27.1-26-79.1-26z"}},{"tag":"path","attr":{"d":"M318.4 376.4c-8.5-8.5-16.9-18.7-24.8-29.5 2 13.2 3.3 26.4 3.3 38.4 0 11.7-.5 22.5-1.6 32.1 12.3 21.8 24.3 32.7 34 32.7 1.6 0 3.2-.3 4.7-.9 11-4.5 13.3-23.3 4.5-54.3-6.4-5.3-13.1-11.5-20.1-18.5zM193.8 136.1c8.4 8.4 16.7 18.5 24.6 29.2-2-13.2-3.2-26.3-3.2-38.2 0-11.7.5-22.5 1.6-32.1-12.3-21.8-24.3-32.7-34-32.7-1.6 0-3.2.3-4.7.9-11 4.5-13.3 23.3-4.5 54.3 6.4 5.4 13.2 11.6 20.2 18.6zM135.8 318.6c8.5-8.5 18.7-16.9 29.5-24.8-13.2 2-26.4 3.3-38.4 3.3-11.7 0-22.5-.5-32.1-1.6-25.5 14.4-36.1 28.2-31.8 38.7 2.6 6.4 10.1 9.9 22.1 9.9 8.5 0 19.3-1.7 32.2-5.4 5.4-6.4 11.5-13.1 18.5-20.1zM376.2 193.8c-8.5 8.5-18.7 16.9-29.5 24.8 13.2-2 26.4-3.3 38.4-3.3 11.7 0 22.5.5 32.1 1.6 25.5-14.4 36.1-28.2 31.8-38.7-2.6-6.4-10.1-9.9-22.1-9.9-8.5 0-19.3 1.7-32.2 5.4-5.4 6.5-11.5 13.2-18.5 20.1zM193.6 376.4c-8.3 8.3-16.3 15.6-23.8 21.6-7.8 28.2-5.5 45.4 4.9 49.9 1.6.7 3.2 1 4.9 1 10.3 0 23.2-12 36.7-36.2-.7-8.4-1.1-17.5-1.1-27.3 0-12 1.3-25.2 3.3-38.4-8 10.7-16.4 20.9-24.9 29.4zM318.4 136.2c8.3-8.3 16.2-15.5 23.7-21.5 7.9-28.4 5.7-45.8-4.8-50.2-1.6-.7-3.2-1-4.9-1-10.3 0-23.2 12-36.7 36.2.7 8.4 1.1 17.5 1.1 27.3 0 12.1-1.3 25.3-3.3 38.7 8-10.7 16.4-21 24.9-29.5zM99.6 216.5c8.4-.7 17.5-1.1 27.3-1.1 12 0 25.1 1.3 38.3 3.3-10.7-7.9-20.9-16.3-29.4-24.8-8.3-8.3-15.6-16.3-21.7-23.9-11.3-3.1-20.9-4.6-28.6-4.6-11.4 0-18.6 3.3-21.2 9.5-4.6 10.9 7.1 25.9 35.3 41.6zM412.4 296c-8.4.7-17.5 1.1-27.3 1.1-12 0-25.2-1.3-38.4-3.3 10.8 7.9 21 16.4 29.5 24.8 8.3 8.3 15.5 16.3 21.6 23.8 11.4 3.2 20.9 4.7 28.6 4.7 11.4 0 18.6-3.3 21.2-9.5 4.7-11-7-25.9-35.2-41.6z"}}]})(props);
	};
	module.exports.IoIosFolderOpen = function IoIosFolderOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 119c0-13.3-9.4-23-22.8-23H230.9c-2.8 0-4.3-.6-6.1-2.4l-22.5-22.5-.2-.2c-4.9-4.6-8.9-6.9-17.3-6.9H88.7C74.9 64 64 74.3 64 87v73h384v-41zM64 188h-8.3c-12.8 0-25.3 5.1-23.5 24.3C34 231.5 55.7 423 55.7 423c2.7 17.8 11.7 25 25 25h352.5c12.7 0 21-7.8 23-25 0 0 22.2-184.9 23.6-205.5 1.4-20.5-8.9-29.5-23.6-29.5H64z"}}]})(props);
	};
	module.exports.IoIosFolder = function IoIosFolder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 119c0-13.3-9.4-23-22.8-23H198.9c-2.8 0-4.3-.6-6.1-2.4l-22.5-22.5-.2-.2c-4.9-4.6-8.9-6.9-17.3-6.9H56.7C42.9 64 32 74.3 32 87v73.7c0 1.6 1.7 1.5 3 .7s5-1.4 7-1.4h428c2 0 5.7.6 7 1.4 1.3.8 3 .9 3-.7V119zM32 416.4c0 17.5 14.2 31.6 31.6 31.6H448c17.6 0 32-14.4 32-32V204c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v212.4z"}}]})(props);
	};
	module.exports.IoIosFootball = function IoIosFootball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256c0 114.7 93.3 208 208 208 114.9 0 208-93.1 208-208 0-114.7-93.3-208-208-208zm127.3 80.7c8.5 8.5 16.1 17.7 22.6 27.5.7 1 .9 2.4.4 3.5L391.9 201c-.4 1-1.1 1.9-2.1 2.3l-57.5 26.2c-1.4.6-3 .4-4.2-.6l-56.6-47.6a4.1 4.1 0 0 1-1.4-3.1v-63.1c0-1.3.7-2.6 1.8-3.3l38.4-26.1c1-.7 2.3-.9 3.5-.5 25.8 8.9 49.6 23.6 69.5 43.5zm-73.9 297.6c-.4 1.2-1.4 2.1-2.6 2.4-16.3 4.8-33.4 7.2-50.8 7.2-17.5 0-34.5-2.5-50.8-7.2-1.2-.4-2.2-1.3-2.6-2.4l-16.4-43c-.4-1.1-.3-2.3.2-3.3l22.3-42.3c.7-1.3 2.1-2.1 3.5-2.1h87.5c1.5 0 2.8.8 3.5 2.1l22.3 42.3c.5 1 .6 2.2.2 3.3l-16.3 43zm-67.4-311v63.1c0 1.2-.5 2.3-1.4 3.1L183.9 229c-1.2 1-2.8 1.2-4.2.6l-57.5-26.2c-1-.5-1.8-1.3-2.1-2.3l-14.4-41.2c-.4-1.2-.3-2.5.4-3.5 6.5-9.8 14.1-19 22.6-27.5 19.9-19.9 43.7-34.6 69.6-43.3 1.2-.4 2.5-.2 3.5.5l38.4 26.1c1.1.5 1.8 1.7 1.8 3.1zM77.7 264.1l36.1-31.2c1.2-1 2.9-1.3 4.3-.6l52.4 23.8c1.1.5 1.9 1.5 2.2 2.7l14.6 57.3c.2 1 .1 2-.3 2.9l-23.2 43.9c-.7 1.3-2.1 2.2-3.6 2.1l-46-.6c-1.2 0-2.4-.6-3.2-1.6-20.5-27.7-32.5-60.6-34.7-95.4 0-1.3.5-2.5 1.4-3.3zm270.4 98.7L325 319c-.5-.9-.6-1.9-.3-2.9l14.6-57.3c.3-1.2 1.1-2.2 2.2-2.7l52.4-23.8c1.4-.6 3.1-.4 4.3.6l36.1 31.2c.9.8 1.5 2 1.4 3.3-2.1 34.8-14.2 67.6-34.7 95.4-.7 1-1.9 1.6-3.2 1.6l-46.1.6c-1.5-.1-2.9-.9-3.6-2.2z"}}]})(props);
	};
	module.exports.IoIosFunnel = function IoIosFunnel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 87.2c0 5.8 2 11.4 5.6 15.7l152.2 179.8c3.6 4.3 5.6 9.9 5.6 15.7v107c0 10 5.9 18.8 14.6 22l55 19.8c9.6 3.5 19.6-4.3 19.6-15.3V298.3c0-5.8 2-11.4 5.6-15.7l152.2-179.8c3.6-4.3 5.6-9.9 5.6-15.7 0-12.8-9.6-23.2-21.4-23.2H69.4C57.6 64 48 74.4 48 87.2z"}}]})(props);
	};
	module.exports.IoIosGift = function IoIosGift (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 136h-84.3c12.4-11 20.3-26.6 20.3-44 0-33.1-28.3-60-63.1-60-20.6 0-37.9 9.7-48.9 27.4C245 41.7 227.7 32 207.1 32 172.3 32 144 58.9 144 92c0 17.4 7.8 33 20.3 44H80c-17.7 0-32 14.3-32 32v20c0 2.2 1.8 4 4 4h408c2.2 0 4-1.8 4-4v-20c0-17.7-14.3-32-32-32zM304.9 60c18.6 0 33.7 14.3 33.7 32s-15.1 32-33.7 32h-33.7c0-48 15.1-64 33.7-64zm-97.8 0c18.6 0 33.7 16 33.7 64h-33.7c-18.6 0-33.7-14.3-33.7-32s15.1-32 33.7-32zM64 226v222c0 17.6 14.4 32 32 32h146V218H72c-4.4 0-8 3.6-8 8zM440 218H270v262h146c17.6 0 32-14.4 32-32V226c0-4.4-3.6-8-8-8z"}}]})(props);
	};
	module.exports.IoIosGitBranch = function IoIosGitBranch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 96c-38.6 0-70 31.4-70 70 0 33.4 23.7 61.9 55.9 68.5-1.2 19.1-10.3 29.3-27 42.2-20.4 15.7-46.7 20-65.3 23.4-40.7 7.4-62.9 27-72.5 40V170.8c15-2.8 28.7-10.5 39-21.9 11.6-12.9 18-29.5 18-46.9 0-38.6-31.4-70-70-70s-70 31.4-70 70c0 17 6.2 33.3 17.3 46.1 9.9 11.3 23.1 19.1 37.7 22.3v171.3c-14.5 3.2-27.8 11-37.7 22.3C96.2 376.7 90 393 90 410c0 38.6 31.4 70 70 70s70-31.4 70-70c0-23.4-11.6-44.9-30.7-57.9 8.6-9.7 24.5-19.6 51.1-24.4 21.6-3.9 52.6-9.6 77.4-28.8 23.6-18.2 36.7-36.5 38-64.3 32.3-6.5 56.1-35.1 56.1-68.6.1-38.6-31.3-70-69.9-70zm-234 6c0-23.2 18.8-42 42-42s42 18.8 42 42-18.8 42-42 42-42-18.8-42-42zm84 308c0 23.2-18.8 42-42 42s-42-18.8-42-42 18.8-42 42-42 42 18.8 42 42zm150-202c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42z"}}]})(props);
	};
	module.exports.IoIosGitCommit = function IoIosGitCommit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M466 242h-76.7c-3.3-31.9-17.8-61.3-41.3-83.5-25-23.5-57.7-36.5-92-36.5s-67 13-91.9 36.5c-23.5 22.2-38 51.6-41.3 83.5H46c-7.7 0-14 6.3-14 14s6.3 14 14 14h76.7c3.3 31.9 17.8 61.3 41.3 83.5 25 23.5 57.7 36.5 92 36.5s67-13 91.9-36.5c23.5-22.2 38-51.6 41.3-83.5H466c7.7 0 14-6.3 14-14s-6.3-14-14-14zm-135 89c-20 20-46.6 31-75 31-28.3 0-54.9-11-75-31-20-20-31-46.6-31-75s11-54.9 31-75c20-20 46.6-31 75-31 28.3 0 54.9 11 75 31 20 20 31 46.6 31 75s-11 54.9-31 75z"}}]})(props);
	};
	module.exports.IoIosGitCompare = function IoIosGitCompare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M233.9 328.1c-2.6-2.6-6.1-4.1-9.9-4.1-3.7 0-7.3 1.4-9.9 4.1-2.6 2.6-4.1 6.1-4.1 9.9 0 3.7 1.4 7.3 4.1 9.9l.1.1 41.1 40.1H166c-20.4 0-33.6-7.5-41.6-23.5-8.4-17-9.4-41.5-9.4-58.5V170.8c15-2.8 28.7-10.5 39-21.9 11.6-12.9 18-29.5 18-46.9 0-38.6-31.4-70-70-70s-70 31.4-70 70c0 17 6.2 33.3 17.3 46.1 9.9 11.3 23.1 19.1 37.7 22.3V306c0 14.7 0 42.1 9.4 65.3 11.9 29.3 36 44.7 69.6 44.7h89.7L216 456.2c-5.4 5.4-5.4 14.3 0 19.8l.1.1c2.7 2.5 6.2 3.9 9.8 3.9 3.8 0 7.3-1.4 9.9-4.1l57.6-57.4c4.2-4.2 6.5-9.8 6.5-15.7 0-5.9-2.3-11.3-6.5-15.5l-59.5-59.2zM102 144c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM425 341.6V206c0-14.7 0-42.1-9.4-65.3-11.9-29.2-36-44.7-69.6-44.7h-89.7L296 55.8c5.4-5.4 5.4-14.3 0-19.8l-.1-.1c-2.7-2.5-6.2-3.9-9.8-3.9-3.8 0-7.3 1.4-9.9 4.1l-57.6 57.4c-4.2 4.2-6.5 9.8-6.5 15.7 0 5.9 2.3 11.3 6.5 15.5l59.6 59.4c2.6 2.6 6.1 4.1 9.9 4.1 3.7 0 7.3-1.4 9.9-4.1 2.6-2.6 4.1-6.1 4.1-9.9 0-3.7-1.4-7.3-4.1-9.9l-.1-.1-41.2-40.2H346c20.4 0 33.6 7.5 41.6 23.5 8.4 17 9.4 41.5 9.4 58.5v135.2c-15 2.8-28.7 10.5-39 21.9-11.6 12.9-18 29.5-18 46.9 0 38.6 31.4 70 70 70s70-31.4 70-70c0-17-6.2-33.3-17.3-46.1-9.9-11.3-23.2-19.1-37.7-22.3zM410 452c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42z"}}]})(props);
	};
	module.exports.IoIosGitMerge = function IoIosGitMerge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M378 218c-33.5 0-62.1 23.8-68.6 56.1-10.3-.5-18.4-2.7-39.2-10.8-30.5-11.9-71.8-33.2-111.5-95.8 27.1-10.1 45.4-36 45.4-65.5 0-38.6-31.4-70-70-70s-70 31.4-70 70c0 17 6.2 33.3 17.3 46.1 9.9 11.3 23.1 19.1 37.7 22.3v171.3c-14.5 3.2-27.8 11-37.7 22.3C70.2 376.7 64 393 64 410c0 38.6 31.4 70 70 70s70-31.4 70-70c0-17.4-6.4-34-18-46.9-10.3-11.4-24-19.1-39-21.9V200.3c40.8 56.8 82 77 113 89.1 25.2 9.8 37.1 12.3 49.5 12.8 6.6 32.2 35.2 55.8 68.5 55.8 38.6 0 70-31.4 70-70s-31.4-70-70-70zM176 410c0 23.2-18.8 42-42 42s-42-18.8-42-42 18.8-42 42-42 42 18.8 42 42zm-42-266c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zm244 186c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42z"}}]})(props);
	};
	module.exports.IoIosGitNetwork = function IoIosGitNetwork (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M377.4 32c-38.9 0-70.6 31.7-70.6 70.7 0 17.1 6.2 33.7 17.5 46.6 10 11.5 23.5 19.4 38.2 22.5v43.1L256 270.3l-106.4-55.4v-43.1c32.2-6.9 55.7-35.6 55.7-69.1 0-39-31.7-70.7-70.6-70.7S64 63.7 64 102.7c0 17.1 6.2 33.7 17.5 46.6 10 11.5 23.5 19.4 38.2 22.5v57.4c0 2.7 1.5 5.1 3.9 6.3l117.5 60.8v43.9c-32.2 6.9-55.7 35.6-55.7 69.1 0 39 31.7 70.7 70.6 70.7s70.6-31.7 70.6-70.7c0-17.1-6.2-33.7-17.5-46.6-10-11.5-23.5-19.4-38.2-22.5v-43.9l117.5-60.8c2.4-1.2 3.9-3.6 3.9-6.3v-57.4c32.2-6.9 55.7-35.6 55.7-69.1 0-39-31.7-70.7-70.6-70.7zM93.8 102.7c0-22.5 18.3-40.8 40.8-40.8s40.8 18.3 40.8 40.8c0 22.5-18.3 40.8-40.8 40.8s-40.8-18.3-40.8-40.8zm203 306.6c0 22.5-18.3 40.8-40.8 40.8s-40.8-18.3-40.8-40.8c0-22.5 18.3-40.8 40.8-40.8s40.8 18.3 40.8 40.8zm80.6-265.7c-22.5 0-40.8-18.3-40.8-40.8 0-22.5 18.3-40.8 40.8-40.8 22.5 0 40.8 18.3 40.8 40.8 0 22.4-18.3 40.8-40.8 40.8z"}}]})(props);
	};
	module.exports.IoIosGitPullRequest = function IoIosGitPullRequest (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M393 341.6V206c0-14.7 0-42.1-9.4-65.3-11.9-29.2-36-44.7-69.6-44.7h-77.7L276 55.8c5.4-5.4 5.4-14.3 0-19.8l-.1-.1c-2.7-2.5-6.2-3.9-9.8-3.9-3.8 0-7.3 1.4-9.9 4.1l-54.8 54.6C192.9 61.5 165.9 40 134 40c-38.6 0-70 31.4-70 70 0 17 6.2 33.3 17.3 46.1 9.9 11.3 23.1 19.1 37.7 22.3v163.3c-14.5 3.2-27.8 11-37.7 22.3C70.2 376.7 64 393 64 410c0 38.6 31.4 70 70 70s70-31.4 70-70c0-17.4-6.4-34-18-46.9-10.3-11.4-24-19.1-39-21.9V178.8c15-2.8 28.7-10.5 39-21.9 7.6-8.4 12.9-18.4 15.7-29.1l56.4 56.2c2.6 2.6 6.1 4.1 9.9 4.1 3.7 0 7.3-1.4 9.9-4.1 2.6-2.6 4.1-6.1 4.1-9.9 0-3.7-1.4-7.3-4.1-9.9l-.1-.1-41.1-40.1H314c20.4 0 33.6 7.5 41.6 23.5 8.4 17 9.4 41.5 9.4 58.5v135.2c-15 2.8-28.7 10.5-39 21.9-11.6 12.9-18 29.5-18 46.9 0 38.6 31.4 70 70 70s70-31.4 70-70c0-17-6.2-33.3-17.3-46.1-9.9-11.3-23.2-19.1-37.7-22.3zM176 410c0 23.2-18.8 42-42 42s-42-18.8-42-42 18.8-42 42-42 42 18.8 42 42zm-42-258c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zm244 300c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42z"}}]})(props);
	};
	module.exports.IoIosGlasses = function IoIosGlasses (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464.5 240.9h-6.2c-3.3-21.1-13.3-40.5-28.5-55.2-17.3-16.6-39.8-25.8-63.4-25.8-20.5 0-40 6.7-56.2 19.4-13.8 10.8-24.2 25.1-30.5 41.7-7-4.6-15.4-7.3-23.7-7.3-8.3 0-16.7 2.6-23.7 7.3-6.2-16.6-16.6-30.9-30.5-41.7-16.2-12.7-35.7-19.4-56.2-19.4-23.6 0-46.1 9.1-63.4 25.6C67 200.4 57 219.9 53.7 241h-6.2c-8 0-14.5 6.7-14.5 15s6.5 15 14.5 15h6.2c3.3 21.2 13.3 40.6 28.5 55.3 17.3 16.6 39.8 25.8 63.4 25.8 51.3 0 93.1-43 93.1-95.9v-.2c0-5.9 6.9-14.9 17.3-14.9s17.3 9 17.3 14.9v.1c0 52.9 41.8 95.9 93.1 95.9 23.7 0 46.2-9.1 63.4-25.8 15.2-14.7 25.2-34.2 28.5-55.4h6.2c8 0 14.5-6.7 14.5-15 0-8.1-6.5-14.9-14.5-14.9z"}}]})(props);
	};
	module.exports.IoIosGlobe = function IoIosGlobe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48h-.7c-55.4.2-107.4 21.9-146.6 61.1C69.6 148.4 48 200.5 48 256s21.6 107.6 60.8 146.9c39.1 39.2 91.2 60.9 146.6 61.1h.7c114.7 0 208-93.3 208-208S370.7 48 256 48zm180.2 194h-77.6c-.9-26.7-4.2-52.2-9.8-76.2 17.1-5.5 33.7-12.5 49.7-21 22 28.2 35 61.6 37.7 97.2zM242 242h-61.8c.8-24.5 3.8-47.7 8.8-69.1 17.4 3.9 35.1 6.3 53 7.1v62zm0 28v61.9c-17.8.8-35.6 3.2-53 7.1-5-21.4-8-44.6-8.8-69H242zm28 0h61.3c-.8 24.4-3.8 47.6-8.8 68.9-17.2-3.9-34.8-6.2-52.5-7V270zm0-28v-62c17.8-.8 35.4-3.2 52.5-7 5 21.4 8 44.5 8.8 69H270zm109.4-117.9c-12.3 6.1-25 11.3-38 15.5-7.1-21.4-16.1-39.9-26.5-54.5 24 8.3 45.9 21.6 64.5 39zM315 146.8c-14.7 3.2-29.8 5.2-45 6V79.4c17 9.2 33.6 33.9 45 67.4zM242 79v73.7c-15.4-.8-30.6-2.8-45.5-6.1 11.6-33.8 28.4-58.5 45.5-67.6zm-45.6 6.4c-10.3 14.5-19.2 32.9-26.3 54.1-12.8-4.2-25.4-9.4-37.5-15.4 18.4-17.3 40.1-30.5 63.8-38.7zm-82.9 59.5c15.8 8.4 32.3 15.4 49.2 20.8-5.7 23.9-9 49.5-9.8 76.2h-77c2.6-35.4 15.6-68.8 37.6-97zM75.8 270h77c.9 26.7 4.2 52.3 9.8 76.2-16.9 5.5-33.4 12.5-49.2 20.8-21.9-28.1-34.9-61.5-37.6-97zm56.7 117.9c12.1-6 24.7-11.2 37.6-15.4 7.1 21.3 16 39.6 26.3 54.2-23.7-8.4-45.4-21.5-63.9-38.8zm64-22.6c14.9-3.3 30.2-5.3 45.5-6.1V433c-17.2-9.1-33.9-33.9-45.5-67.7zm73.5 67.3v-73.5c15.2.8 30.3 2.8 45 6-11.4 33.6-28 58.3-45 67.5zm45-5.7c10.4-14.6 19.4-33.1 26.5-54.5 13 4.2 25.8 9.5 38 15.6-18.6 17.3-40.6 30.6-64.5 38.9zm83.5-59.8c-16-8.5-32.6-15.5-49.7-21 5.6-23.9 8.9-49.4 9.8-76.1h77.6c-2.7 35.5-15.6 68.9-37.7 97.1z"}}]})(props);
	};
	module.exports.IoIosGrid = function IoIosGrid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M206 308h100c1.1 0 2-.9 2-2V206c0-1.1-.9-2-2-2H206c-1.1 0-2 .9-2 2v100c0 1.1.9 2 2 2z"}},{"tag":"path","attr":{"d":"M64 96v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm330 108h-56c-1.1 0-2 .9-2 2v100c0 1.1.9 2 2 2h56c7.7 0 14 6.3 14 14s-6.3 14-14 14h-56c-1.1 0-2 .9-2 2v56c0 7.7-6.3 14-14 14s-14-6.3-14-14v-56c0-1.1-.9-2-2-2H206c-1.1 0-2 .9-2 2v56c0 7.7-6.3 14-14 14s-14-6.3-14-14v-56c0-1.1-.9-2-2-2h-56c-7.7 0-14-6.3-14-14s6.3-14 14-14h56c1.1 0 2-.9 2-2V206c0-1.1-.9-2-2-2h-56c-7.7 0-14-6.3-14-14s6.3-14 14-14h56c1.1 0 2-.9 2-2v-56c0-7.7 6.3-14 14-14s14 6.3 14 14v56c0 1.1.9 2 2 2h100c1.1 0 2-.9 2-2v-56c0-7.7 6.3-14 14-14s14 6.3 14 14v56c0 1.1.9 2 2 2h56c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}}]})(props);
	};
	module.exports.IoIosHammer = function IoIosHammer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M277.6 246.9c-1.1-2-2.5-3.9-4.1-5.5l-18.4-18.2c-1.9-1.9-4.1-3.5-6.6-4.6-8.2-3.6-17.4-1.7-23.4 4.3-6.4 6.3-18.1 17.8-39.2 38.7-40.4 40-98.1 89.6-132 118.2-7.2 6.1-7.7 17-1.1 23.7L92 443.2c6.7 6.7 17.6 6.3 23.8-.9 29.4-34.6 79.5-92.3 119.4-131.8 20.5-20.2 32-31.8 38.5-38.2 6.5-6.6 8.3-16.7 3.9-25.4zM462.4 218.1l-34.5-34.2c-1.1-1.1-2.5-1.6-4-1.6-1.4 0-2.9.5-4 1.6-2.5 2.5-6.1 3.8-9.6 3.3-4.5-.5-9.3-1.9-12.4-4.9-7-6.9 1.1-20.5-5.1-29.2-6.2-8.7-16.1-19.8-23.2-26.9-7.1-7-35-33.7-82-52.9-16.6-6.8-32.8-9.3-47.3-9.3-26.5 0-47.4 8.5-54.8 15.3-5.5 5.1-11.2 14.1-3.1 14.1.7 0 1.5-.1 2.4-.2 4.5-.7 13.3-1.5 23.4-1.5 15.7 0 34.5 2.1 44.6 10.1 16.3 13.1 29.8 30.6 30.9 53.2.8 16.8-3.4 28.2-18.7 45.5-2.8 3.2-2.6 8 .4 10.9l19.2 19.2c3.1 3.1 8.1 3.1 11.2.1 14-13.6 22.1-20.2 31.3-22.7 4-1.1 8.4-1.6 12.8-1.6 9.7 0 19.2 2.2 23.6 4.6 1.1.6 2.1 1.4 3.1 2.4 6.5 6.6 6.1 17.4-.5 23.9l-2 1.9c-2.2 2.2-2.2 5.7 0 7.9l34.5 34.2c1.1 1.1 2.5 1.6 4 1.6 1.4 0 2.9-.5 4-1.6l55.8-55.2c2.1-2.3 2.1-5.8 0-8z"}}]})(props);
	};
	module.exports.IoIosHand = function IoIosHand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M394.9 117.3c-11.6 0-21.1 9.3-21.1 20.6v109.4c0 4.8-4 8.7-8.9 8.7s-8.9-3.9-8.9-8.7V85.9c0-11.3-9.5-20.6-21.1-20.6-11.6 0-21.1 9.3-21.1 20.6v126.8c0 4.8-4 8.7-8.9 8.7s-8.9-3.9-8.9-8.7V68.6c0-11.3-9.5-20.6-21.1-20.6-11.6 0-21.1 9.3-21.1 20.6V230c0 4.8-4 8.7-8.9 8.7s-8.9-3.9-8.9-8.7V103.2c0-11.3-9.5-20.6-21.1-20.6-11.6 0-21.1 9.3-21.1 20.6v218.3L166 297.9c-26.1-22.7-48.2-32.4-66.2-15.7-12.1 11.8 6.9 30.9 26.8 53.2 19.2 21.5 70 91.9 113.3 117.3 0 0 16.7 11.4 40.6 11.4h57.2c46.1 0 78.4-37.9 78.4-93.2v-233c-.1-11.3-9.6-20.6-21.2-20.6z"}}]})(props);
	};
	module.exports.IoIosHappy = function IoIosHappy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm72 152c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm72 169c-44.7 0-82.3-29.9-94.2-70.7-1.5-5.1 2.3-10.3 7.7-10.3h172.9c5.3 0 9.2 5.1 7.7 10.3-11.8 40.8-49.4 70.7-94.1 70.7z"}}]})(props);
	};
	module.exports.IoIosHeadset = function IoIosHeadset (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 123.8c-24.3 0-46.9 10.1-63.9 28.4-17 18.3-26.1 33.2-26.1 59.6 0 7.7 5.9 14 13.2 14 7.3 0 13.2-6.3 13.2-14 0-17.3 6.6-32.4 19-43.5 11.8-10.6 27.7-16.5 44.7-16.5s32.9 5.8 44.7 16.5c12.4 11.2 19 26.2 19 43.5 0 7.7 5.9 14 13.2 14 7.3 0 13.2-6.3 13.2-14 0-26.4-9.2-41.3-26.1-59.6-17.2-18.4-39.8-28.4-64.1-28.4z"}},{"tag":"path","attr":{"d":"M457.1 278.9C442.3 264.1 422.8 256 402 256h-8c-2.2 0-4-1.8-4-4v-37.8c0-35.7-14-69.3-39.4-94.7C325.3 94 291.7 80 256 80c-35.7 0-69.3 14-94.6 39.4-25.4 25.4-39.4 59-39.4 94.7V252c0 2.2-1.8 4-4 4h-8c-20.8 0-40.3 8.1-55.1 22.9C40.1 293.7 32 313.2 32 334v11.8c0 20.8 8.1 40.4 22.9 55.2 14.8 14.8 34.4 23 55.1 23h5.6c4 0 8 1.4 10.9 4.1 2.5 2.3 5.9 3.8 9.5 3.8 7.7 0 14-6.3 14-14.1V214.1c0-28.2 11.1-54.8 31.2-74.9 20.1-20.1 46.7-31.2 74.8-31.2 28.2 0 54.8 11.1 74.8 31.2 20.1 20.1 31.2 46.7 31.2 74.9v203.8c0 7.8 6.3 14.1 14 14.1 3.6 0 7-1.5 9.5-3.8 2.9-2.7 6.9-4.1 10.9-4.1h5.6c20.7 0 40.3-8.2 55.1-23 14.8-14.8 22.9-34.4 22.9-55.2V334c0-20.8-8.1-40.3-22.9-55.1z"}}]})(props);
	};
	module.exports.IoIosHeartDislike = function IoIosHeartDislike (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M423.8 426.8L56.3 65.1c-5.6-5.5-14.6-5.5-20.1.1-5.5 5.5-5.5 14.5 0 20l367.5 361.7c3.7 3.7 9 4.9 13.7 3.6 2.4-.6 4.6-1.9 6.4-3.7 5.6-5.5 5.6-14.5 0-20zM64 169c0 37 15.2 89.5 46.8 132.7C171 384 272 456 272 456s29.3-20.3 65.7-51.6L68 139c-2.6 9.6-4 19.6-4 30zM434.2 301.7C465.8 258.5 480 206 480 169c0-62.1-50.1-112.4-112-113h-1c-39.7 0-74.8 21-95 52-20.2-31-55.3-52-95-52h-1c-29.2.3-55.8 11.6-75.7 30l281.9 277.4c19.3-19.1 36.2-40 52-61.7z"}}]})(props);
	};
	module.exports.IoIosHeartEmpty = function IoIosHeartEmpty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 56h-1c-39.7 0-74.8 21-95 52-20.2-31-55.3-52-95-52h-1c-61.9.6-112 50.9-112 113 0 37 16.2 89.5 47.8 132.7C156 384 256 456 256 456s100-72 160.2-154.3C447.8 258.5 464 206 464 169c0-62.1-50.1-112.4-112-113zm41.6 229.2C351 343.5 286.1 397.3 256 420.8c-30.1-23.5-95-77.4-137.6-135.7C89.1 245.1 76 198 76 169c0-22.6 8.8-43.8 24.6-59.8 15.9-16 37-24.9 59.6-25.1H161.1c14.3 0 28.5 3.7 41.1 10.8 12.2 6.9 22.8 16.7 30.4 28.5 5.2 7.9 14 12.7 23.5 12.7s18.3-4.8 23.5-12.7c7.7-11.8 18.2-21.6 30.4-28.5 12.6-7.1 26.8-10.8 41.1-10.8h.9c22.5.2 43.7 9.1 59.6 25.1 15.9 16 24.6 37.3 24.6 59.8-.2 29-13.3 76.1-42.6 116.2z"}}]})(props);
	};
	module.exports.IoIosHeartHalf = function IoIosHeartHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 56h-1c-39.7 0-74.8 21-95 52-20.2-31-55.3-52-95-52h-1c-61.9.6-112 50.9-112 113 0 37 16.2 89.5 47.8 132.7C156 384 256 456 256 456s100-72 160.2-154.3C447.8 258.5 464 206 464 169c0-62.1-50.1-112.4-112-113zm41.6 229.2C356.4 336 302.2 383.6 269 410.5c-5.2 4.2-13 .5-13-6.2V198.6c0-26.8 8.5-52.7 23.3-75 .1-.1.1-.2.2-.2 7.7-11.8 18.2-21.6 30.4-28.5 12.6-7.1 26.8-10.8 41.1-10.8h.9c22.5.2 43.7 9.1 59.6 25.1 15.9 16 24.6 37.3 24.6 59.8-.1 29-13.2 76.1-42.5 116.2z"}}]})(props);
	};
	module.exports.IoIosHeart = function IoIosHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 56h-1c-39.7 0-74.8 21-95 52-20.2-31-55.3-52-95-52h-1c-61.9.6-112 50.9-112 113 0 37 16.2 89.5 47.8 132.7C156 384 256 456 256 456s100-72 160.2-154.3C447.8 258.5 464 206 464 169c0-62.1-50.1-112.4-112-113z"}}]})(props);
	};
	module.exports.IoIosHelpBuoy = function IoIosHelpBuoy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm54.6 36.4c27.1 8.6 52 23.6 72.7 44.3 20.7 20.7 35.7 45.6 44.3 72.7l-88.8 6c-8.2-14-19.9-25.7-33.9-34l5.7-89zm-181.9 44.3c20.7-20.7 45.5-35.7 72.7-44.3l5.7 89c-13.9 8.3-25.6 20-33.9 33.9l-88.9-5.9c8.7-27.1 23.7-52 44.4-72.7zm72.7 298.9c-27.1-8.6-52-23.6-72.7-44.3-20.7-20.7-35.7-45.6-44.3-72.7l89-5.7c8.2 13.9 19.9 25.5 33.8 33.8l-5.8 88.9zM256 324c-37.5 0-68-30.5-68-68s30.5-68 68-68 68 30.5 68 68-30.5 68-68 68zm127.3 59.3c-20.7 20.7-45.6 35.7-72.7 44.3l-5.9-88.9c14.1-8.3 25.8-20.1 34.1-34.2l88.8 6c-8.6 27.2-23.6 52.1-44.3 72.8z"}}]})(props);
	};
	module.exports.IoIosHelpCircleOutline = function IoIosHelpCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M256.7 160c37.5 0 63.3 20.8 63.3 50.7 0 19.8-9.6 33.5-28.1 44.4-17.4 10.1-23.3 17.5-23.3 30.3v7.9h-34.7l-.3-8.6c-1.7-20.6 5.5-33.4 23.6-44 16.9-10.1 24-16.5 24-28.9s-12-21.5-26.9-21.5c-15.1 0-26 9.8-26.8 24.6H192c.7-32.2 24.5-54.9 64.7-54.9zm-26.3 171.4c0-11.5 9.6-20.6 21.4-20.6 11.9 0 21.5 9 21.5 20.6s-9.6 20.6-21.5 20.6-21.4-9-21.4-20.6z"}}]})(props);
	};
	module.exports.IoIosHelpCircle = function IoIosHelpCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm-4.3 304c-11.8 0-21.4-9-21.4-20.6 0-11.5 9.6-20.6 21.4-20.6 11.9 0 21.5 9 21.5 20.6 0 11.6-9.5 20.6-21.5 20.6zm40.2-96.9c-17.4 10.1-23.3 17.5-23.3 30.3v7.9h-34.7l-.3-8.6c-1.7-20.6 5.5-33.4 23.6-44 16.9-10.1 24-16.5 24-28.9s-12-21.5-26.9-21.5c-15.1 0-26 9.8-26.8 24.6H192c.7-32.2 24.5-55 64.7-55 37.5 0 63.3 20.8 63.3 50.7 0 19.9-9.6 33.6-28.1 44.5z"}}]})(props);
	};
	module.exports.IoIosHelp = function IoIosHelp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.7 160c37.5 0 63.3 20.8 63.3 50.7 0 19.8-9.6 33.5-28.1 44.4-17.4 10.1-23.3 17.5-23.3 30.3v7.9h-34.7l-.3-8.6c-1.7-20.6 5.5-33.4 23.6-44 16.9-10.1 24-16.5 24-28.9s-12-21.5-26.9-21.5c-15.1 0-26 9.8-26.8 24.6H192c.7-32.2 24.5-54.9 64.7-54.9zm-26.3 171.4c0-11.5 9.6-20.6 21.4-20.6 11.9 0 21.5 9 21.5 20.6s-9.6 20.6-21.5 20.6-21.4-9-21.4-20.6z"}}]})(props);
	};
	module.exports.IoIosHome = function IoIosHome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M258.5 104.1c-1.5-1.2-3.5-1.2-5 0l-156 124.8c-.9.8-1.5 1.9-1.5 3.1v230c0 1.1.9 2 2 2h108c1.1 0 2-.9 2-2V322c0-1.1.9-2 2-2h92c1.1 0 2 .9 2 2v140c0 1.1.9 2 2 2h108c1.1 0 2-.9 2-2V232c0-1.2-.6-2.4-1.5-3.1l-156-124.8z"}},{"tag":"path","attr":{"d":"M458.7 204.2l-189-151.4C265.9 49.7 261 48 256 48s-9.9 1.7-13.7 4.8L160 119.7V77.5c0-1.1-.9-2-2-2H98c-1.1 0-2 .9-2 2v92.2l-42.7 35.1c-3.1 2.5-5.1 6.2-5.3 10.2-.2 4 1.3 7.9 4.1 10.7 2.6 2.6 6.1 4.1 9.9 4.1 3.2 0 6.3-1.1 8.8-3.1l183.9-148c.5-.4.9-.4 1.3-.4s.8.1 1.3.4l183.9 147.4c2.5 2 5.6 3.1 8.8 3.1 3.7 0 7.2-1.4 9.9-4.1 2.9-2.8 4.4-6.7 4.2-10.7-.3-4-2.2-7.7-5.4-10.2z"}}]})(props);
	};
	module.exports.IoIosHourglass = function IoIosHourglass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M415.6 434h-5.1c-6.5 0-12-.9-12.7-7.4v-.1C383.2 290.6 297.6 288 297.6 256s85.7-34.6 100.2-170.5v-.1c.7-6.5 6.2-7.4 12.7-7.4h5.1c7.5 0 14-5.8 14.4-13.3.4-8-6-14.7-14-14.7H96.4c-7.5 0-14 5.8-14.4 13.3-.4 8 6 14.7 14 14.7h5.5c6.5 0 12 .9 12.7 7.4v.1C128.8 221.4 214.4 224 214.4 256s-85.7 34.6-100.2 170.5v.1c-.7 6.5-6.2 7.4-12.7 7.4h-5.1c-7.5 0-14 5.8-14.4 13.3-.4 8 6 14.7 14 14.7h320c8 0 14.4-6.6 14-14.7-.4-7.5-6.9-13.3-14.4-13.3zm-252.3-34.2c28.7-79.8 79.6-70.1 79.6-101.6v-55.6c0-19.4-36.8-32.9-59.8-64.4-3.8-5.2 0-12.4 6.5-12.4h132.9c6.5 0 10.4 7 6.7 12.2-22.6 31.6-60.1 45.2-60.1 64.6v55.6c0 31.2 48.9 22.7 79.8 101.6 2.8 7.1.7 16-6.9 16H170.2c-7.7 0-9.5-8.8-6.9-16z"}}]})(props);
	};
	module.exports.IoIosIceCream = function IoIosIceCream (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M220.8 406.1l4.8 14.8c.4 1.2 1.9 1.8 3 1.1l6.8-4.2c2.5-1.6 2.5-5.2 0-6.8l-11.5-7.2c-1.7-1-3.6.5-3.1 2.3zM286.6 421l4.9-15.2c.6-1.8-1.4-3.3-3-2.3l-11.9 7.4a4.02 4.02 0 0 0 0 6.8l7 4.4c1.2.7 2.6.1 3-1.1zM188.6 242.2c-3.9 3.5-9.6 6.4-15.7 8.5-1 .4-1.6 1.5-1.2 2.5l9.3 28.9 3.8 11.8c.4 1.2 1.9 1.8 3 1.1l7-4.3 36.6-22.5c3-1.9 2.3-6.5-1.2-7.3-14.3-3.3-26.5-9.8-36.2-18.5-1.6-1.4-3.9-1.5-5.4-.2zM192.6 310.8l-2 1.2 14.6 45.3c.4 1.2 1.9 1.8 3 1.1l27.2-16.9c2.5-1.6 2.5-5.2 0-6.8l-38.5-23.9c-1.4-.8-3-.8-4.3 0zM258.1 348.9c-1.3-.8-2.9-.8-4.2 0L212 374.5l-.1.1c-1 .8-1 2.4 0 3.2l.7.5 41.3 25.3c1.3.8 2.9.8 4.2 0l41.7-25.5.4-.3c1-.8 1-2.2 0-3l-42.1-25.9zM296.7 296.6l-38.5-23.9c-1.3-.8-2.9-.8-4.2 0l-38.5 23.9a4.02 4.02 0 0 0 0 6.8l38.5 23.9c1.3.8 2.9.8 4.2 0l38.5-23.9c2.5-1.5 2.5-5.2 0-6.8zM318.1 242.3c-9.7 8.7-22 15.1-36.2 18.5-3.5.8-4.2 5.4-1.2 7.3l36.6 22.5 7.4 4.6c1.1.7 2.6.2 3-1.1l4-12.4 9.8-30.3c-6.9-2.1-13.6-5.3-18-9.2-1.6-1.3-3.9-1.2-5.4.1zM232.4 442l1.6 5s7.5 19 22 19c15 0 22.2-19 22.2-19l1.6-4.8c.6-1.7-.1-3.7-1.7-4.6l-20-12.4c-1.3-.8-2.9-.8-4.2 0l-19.8 12.3c-1.6.8-2.3 2.7-1.7 4.5zM276.7 341.5l27.5 17.1c1.1.7 2.6.2 3-1.1l14.2-43.8c.3-.9-.1-1.8-.8-2.3l-1-.6c-1.3-.8-2.9-.8-4.2 0l-38.5 23.9c-2.8 1.6-2.8 5.3-.2 6.8z"}},{"tag":"path","attr":{"d":"M376.1 168.2c-6.2 5.4-13.2 8.7-18 10.5-1.8.7-3.5-1.4-2.3-3l4-5.7c6.1-8.7 8.5-19.4 6.8-29.8C357.9 86.8 311.7 46 256 46c-55.7 0-101.9 41.2-110.6 94.7-1.7 10.5.8 21.2 6.9 29.8l4 5.6c1.2 1.6-.5 3.8-2.4 3-5.4-2.1-13.5-6.2-20.1-12.8-1.4-1.4-3.6-1.5-5.2-.4-10.2 7.3-16.8 19.1-16.8 32.5 0 22.1 17.9 40 40 40 11.3 0 28-4.7 36.6-12.3 1.5-1.3 3.8-1.3 5.3.1 15.2 13.4 36.6 20.2 62.1 20.2s47-6.8 62.1-20.2c1.5-1.3 3.8-1.4 5.3-.1 8.5 7.6 25.3 12.3 36.6 12.3 22.1 0 40-18 40-40.1 0-11.9-5.2-22.6-13.5-30-2.7-2.6-7.2-2.7-10.2-.1z"}}]})(props);
	};
	module.exports.IoIosImage = function IoIosImage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M112.6 312.3h190.7c4.5 0 7.1-5.1 4.5-8.8l-95.4-153.4c-2.2-3.2-6.9-3.2-9.1 0L108 303.5c-2.6 3.7.1 8.8 4.6 8.8zM306.7 254.3l35 55.7c1 1.5 2.7 2.4 4.5 2.4h53.2c4.5 0 7.1-5.1 4.5-8.8l-61.6-87.7c-2.2-3.2-6.9-3.2-9.1 0L306.6 248c-1.2 1.8-1.2 4.3.1 6.3zM351.1 167.9c13.1-1.3 23.7-11.9 25-25 1.8-17.7-13-32.5-30.7-30.7-13.1 1.3-23.7 11.9-25 25-1.7 17.7 13 32.5 30.7 30.7z"}},{"tag":"path","attr":{"d":"M432 48H80c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h352c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zm-2.7 280c0 4.4-3.6 8-8 8H90.7c-4.4 0-8-3.6-8-8V90.7c0-4.4 3.6-8 8-8h330.7c4.4 0 8 3.6 8 8V328z"}}]})(props);
	};
	module.exports.IoIosImages = function IoIosImages (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M262.3 199.2c-1.6-2.8-5.6-3.2-7.7-.7l-91.9 122.2c-2.5 2.9-.6 7.4 3.2 7.7l161.1 14c3.8.3 6.4-3.8 4.5-7.1l-69.2-136.1zM367.2 264.1c-1.6-2.8-5.6-3.2-7.7-.7l-24.8 25.1a4.68 4.68 0 0 0-.5 5.4l25.4 49.5c.8 1.3 2.1 2.2 3.7 2.3l44.9 3.9c3.8.3 6.4-3.8 4.5-7.1l-45.5-78.4zM378.1 224.4c11.2-.1 20.9-8.3 23-19.2 2.8-14.8-8.6-28.3-23.7-28.1-11.2.1-20.9 8.3-23 19.2-2.8 14.8 8.6 28.3 23.7 28.1z"}},{"tag":"path","attr":{"d":"M455.2 129.3l-65.8-5.7-6.1-67c-1.3-14.9-14.5-25.9-29.5-24.5L56.7 58.9c-14.9 1.3-25.9 14.5-24.6 29.4l26.8 296.5c1.3 14.9 14.5 25.9 29.5 24.5l15.7-1.4-1.5 16.7c-1.3 14.9 9.7 28 24.7 29.3l297.3 25.9c14.9 1.3 28.1-9.7 29.4-24.6l26-296.6c1.2-14.8-9.8-28-24.8-29.3zM87.6 300.7c-3.7.3-7-2.4-7.4-6.1l-18-200c-.3-3.7 2.4-7 6.1-7.3l279.2-25.1c3.7-.3 7 2.4 7.4 6.1l4.8 52.8L158 103.4c-14.9-1.3-28.1 9.7-29.4 24.6l-14.9 170.3-26.1 2.4zm362.2-135.6l-17.5 200c-.3 3.7-3.6 6.5-7.3 6.2l-18.6-1.6L145.7 347c-3.7-.3-6.5-3.6-6.2-7.3l3.8-43.9L157 139.7c.3-3.7 3.6-6.5 7.3-6.2l198 17.3 29.7 2.6 51.6 4.5c3.8.2 6.6 3.5 6.2 7.2z"}}]})(props);
	};
	module.exports.IoIosInfinite = function IoIosInfinite (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M456.8 182.4c-20-19.6-46.8-30.4-75.2-30.4-28.5 0-55.2 10.8-75.2 30.4l-31.2 30c-1.6 1.6-1.6 4.2 0 5.7l19.4 19.1c1.5 1.5 4 1.5 5.6 0l31-30.1c13.5-13.1 31.3-20.3 50.3-20.3 19 0 36.8 7.2 50.3 20.3 13.4 13.1 20.7 30.5 20.7 49 0 18.4-7.4 35.8-20.7 48.7-13.5 13.1-31.3 20.3-50.3 20.3-19 0-36.8-7.2-50.3-20.3L205.6 182.4c-20.2-19.6-46.9-30.4-75.2-30.4-28.5 0-55.2 10.8-75.2 30.4C35.1 202 24 228.1 24 256c0 27.8 11.1 54 31.2 73.6 20 19.6 46.8 30.4 75.2 30.4 28.5 0 55.2-10.8 75.2-30.4l31-30c1.6-1.6 1.6-4.2 0-5.7L217.2 275c-1.5-1.5-4-1.5-5.6 0l-31 29.9c-13.5 13.1-31.3 20.3-50.3 20.3-19 0-36.8-7.2-50.3-20.3-13.4-13.1-20.7-30.5-20.7-49 0-18.4 7.4-35.7 20.7-48.7 13.5-13.1 31.3-20.3 50.3-20.3 19 0 36.8 7.2 50.3 20.3l125.5 122.5c20.2 19.6 46.9 30.4 75.2 30.4 28.5 0 55.2-10.8 75.2-30.4 20.2-19.6 31.3-45.7 31.3-73.6.2-27.9-10.9-54.1-31-73.7z"}}]})(props);
	};
	module.exports.IoIosInformationCircleOutline = function IoIosInformationCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M235.4 172.2c0-11.4 9.3-19.9 20.5-19.9 11.4 0 20.7 8.5 20.7 19.9s-9.3 20-20.7 20c-11.2 0-20.5-8.6-20.5-20zm1.4 35.7H275V352h-38.2V207.9z"}},{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosInformationCircle = function IoIosInformationCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm19 304h-38.2V207.9H275V352zm-19.1-159.8c-11.3 0-20.5-8.6-20.5-20s9.3-19.9 20.5-19.9c11.4 0 20.7 8.5 20.7 19.9s-9.3 20-20.7 20z"}}]})(props);
	};
	module.exports.IoIosInformation = function IoIosInformation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M235.4 176c0-11.4 9.3-19.9 20.5-19.9 11.4 0 20.7 8.5 20.7 19.9s-9.3 20-20.7 20c-11.2.1-20.5-8.6-20.5-20zm1.4 35.8H275v144.1h-38.2V211.8z"}}]})(props);
	};
	module.exports.IoIosJet = function IoIosJet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 48s-19.8 1.4-53.1 27.2c-15.5 12-162.2 120.6-162.2 120.6L89 187.9l-41 36.5 102 51.2-8 10.1-81.6 4.1-6.7 33.6 60.6 47.2-26.7 53.6 53.7-26.5 47.3 60.6 33.6-6.7 4.1-81.6 10.1-7.9L287.6 464l36.5-40.9-7.9-159.7s108.6-146.7 120.6-162C462.7 67.8 464 48 464 48z"}}]})(props);
	};
	module.exports.IoIosJournal = function IoIosJournal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M92.1 32C76.6 32 64 44.6 64 60.1V452c0 15.5 12.6 28.1 28.1 28.1H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H112.5c-8.2 0-15.4-6-16.4-14.1-1.1-9.7 6.5-18 15.9-18h208V32H92.1z"}},{"tag":"path","attr":{"d":"M432 416c8.8 0 16-7.2 16-16V60.1c0-15.5-12.6-28.1-28.1-28.1H368v384h64z"}}]})(props);
	};
	module.exports.IoIosKey = function IoIosKey (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M344.8 218.1c-13 0-25.6 0-37.4 4.1-50.6-43.1-184.3-156.9-194.5-167.5-4.7-4.9-9.9-6.7-15-6.7-8.5 0-16.7 5.2-21.3 9.6-6.9 6.6-33 34.8-28 40 15 15.4 19 18.5 25.2 24.8 9.3 9.5 28.3-1 36 2.3 7.6 3.3 9.2 6.8 10.4 12.5s-2.9 15.8-3 23.7c-.1 8.3 3.4 12.8 9.2 19 4.6 5 8.9 8.6 15.6 8.7 9 .2 20.9-12.8 30.4-3.1s-6.2 23.7-5 34 15.5 22.8 21.6 24.1c6.1 1.3 21.8-11.7 30.7-9.7 3 .7 10 6.8 11 11.4s-6.9 25-5.9 29.6c1.2 5.6 7.1 12.1 10.4 17.4-6.7 15.5-9.4 29.6-9.4 47.7 0 68.5 53.4 124 119.2 124s119-55.5 119-124-53.4-121.9-119.2-121.9zM368 400c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
	};
	module.exports.IoIosKeypad = function IoIosKeypad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M394.6 341.2c-29.5 0-53.4 23.9-53.4 53.4s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4-23.9-53.4-53.4-53.4zM256 341.2c-29.5 0-53.4 23.9-53.4 53.4S226.5 448 256 448s53.4-23.9 53.4-53.4-23.9-53.4-53.4-53.4zM117.4 341.2c-29.5 0-53.4 23.9-53.4 53.4S87.9 448 117.4 448s53.4-23.9 53.4-53.4-23.9-53.4-53.4-53.4zM394.6 202.6c-29.5 0-53.4 23.9-53.4 53.4s23.9 53.4 53.4 53.4S448 285.5 448 256s-23.9-53.4-53.4-53.4zM256 202.6c-29.5 0-53.4 23.9-53.4 53.4s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4-23.9-53.4-53.4-53.4zM117.4 202.6C87.9 202.6 64 226.5 64 256s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4-23.9-53.4-53.4-53.4zM394.6 64c-29.5 0-53.4 23.9-53.4 53.4s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4S424.1 64 394.6 64zM256 64c-29.5 0-53.4 23.9-53.4 53.4s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4S285.5 64 256 64zM117.4 64C87.9 64 64 87.9 64 117.4s23.9 53.4 53.4 53.4 53.4-23.9 53.4-53.4S146.9 64 117.4 64z"}}]})(props);
	};
	module.exports.IoIosLaptop = function IoIosLaptop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 367.5V129.1c0-9.4-7.9-17.1-17.2-17.1H81.2c-9.3 0-17.2 7.6-17.2 17.1v238.4H15.9c0 9.9 9.9 18.8 18.9 22.7C45.7 394.8 64 400 84 400h344c20 0 38.2-4.5 48.3-8.8 9.5-4 19.8-13.4 19.8-23.7H448zM256 120c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zM82 136.2h348c1.1 0 2 .9 2 2v211.3c0 1.1-.9 2-2 2H82c-1.1 0-2-.9-2-2V138.2c0-1.2.9-2 2-2zm216.3 239.3h-84.6c-5.2 0-9.7-6-9.7-7.5h104c0 1.5-3 7.5-9.7 7.5z"}}]})(props);
	};
	module.exports.IoIosLeaf = function IoIosLeaf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453.9 378.7c-51.8-8-55.7-11.7-55.7-11.7 15.6-74-22.4-151.1-76.3-195.6C250.1 112.2 141 155.2 56 65.2c-19.8-21-8.3 235.5 98.1 332.7 77.8 71 169.4 49.2 194.5 37.6 22.8-10.6 38.7-33.9 38.7-33.9 41.5 13 62 14.2 62 14.2 14.6 1.8 22-34.4 4.6-37.1zm-91.8 7.4c-77.7-23.3-145.3-81-189.1-126.2-3.6-3.7 1.6-9.2 5.5-6 43.1 35.5 108.9 80 193.3 107.9.2 8.1-4.5 19.7-9.7 24.3z"}}]})(props);
	};
	module.exports.IoIosLink = function IoIosLink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M280 341.1l-1.2.1c-3.6.4-7 2-9.6 4.5l-64.6 64.6c-13.7 13.7-32 21.2-51.5 21.2s-37.8-7.5-51.5-21.2c-13.7-13.7-21.2-32-21.2-51.5s7.5-37.8 21.2-51.5l68.6-68.6c3.5-3.5 7.3-6.6 11.4-9.3 4.6-3 9.6-5.6 14.8-7.5 4.8-1.8 9.9-3 15-3.7 3.4-.5 6.9-.7 10.2-.7 1.4 0 2.8.1 4.6.2 17.7 1.1 34.4 8.6 46.8 21 7.7 7.7 13.6 17.1 17.1 27.3 2.8 8 11.2 12.5 19.3 10.1.1 0 .2-.1.3-.1.1 0 .2 0 .2-.1 8.1-2.5 12.8-11 10.5-19.1-4.4-15.6-12.2-28.7-24.6-41-15.6-15.6-35.9-25.8-57.6-29.3-1.9-.3-3.8-.6-5.7-.8-3.7-.4-7.4-.6-11.1-.6-2.6 0-5.2.1-7.7.3-5.4.4-10.8 1.2-16.2 2.5-1.1.2-2.1.5-3.2.8-6.7 1.8-13.3 4.2-19.5 7.3-10.3 5.1-19.6 11.7-27.7 19.9l-68.6 68.6C58.9 304.4 48 330.8 48 359c0 28.2 10.9 54.6 30.7 74.4C98.5 453.1 124.9 464 153 464c28.2 0 54.6-10.9 74.4-30.7l65.3-65.3c10.4-10.5 2-28.3-12.7-26.9z"}},{"tag":"path","attr":{"d":"M433.3 78.7C413.5 58.9 387.1 48 359 48s-54.6 10.9-74.4 30.7l-63.7 63.7c-9.7 9.7-3.6 26.3 10.1 27.4 4.7.4 9.3-1.3 12.7-4.6l63.8-63.6c13.7-13.7 32-21.2 51.5-21.2s37.8 7.5 51.5 21.2c13.7 13.7 21.2 32 21.2 51.5s-7.5 37.8-21.2 51.5l-68.6 68.6c-3.5 3.5-7.3 6.6-11.4 9.3-4.6 3-9.6 5.6-14.8 7.5-4.8 1.8-9.9 3-15 3.7-3.4.5-6.9.7-10.2.7-1.4 0-2.9-.1-4.6-.2-17.7-1.1-34.4-8.6-46.8-21-7.3-7.3-12.8-16-16.4-25.5-2.9-7.7-11.1-11.9-19.1-9.8-8.9 2.3-14.1 11.7-11.3 20.5 4.5 14 12.1 25.9 23.7 37.5l.2.2c16.9 16.9 39.4 27.6 63.3 30.1 3.7.4 7.4.6 11.1.6 2.6 0 5.2-.1 7.8-.3 6.5-.5 13-1.6 19.3-3.2 6.7-1.8 13.3-4.2 19.5-7.3 10.3-5.1 19.6-11.7 27.7-19.9l68.6-68.6c19.8-19.8 30.7-46.2 30.7-74.4s-11.1-54.6-30.9-74.4z"}}]})(props);
	};
	module.exports.IoIosListBox = function IoIosListBox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 82.7v346.7c0 19.1 15.5 34.7 34.7 34.7h346.7c19.1 0 34.7-15.5 34.7-34.7V82.7c0-19.1-15.5-34.7-34.7-34.7H82.7C63.5 48 48 63.5 48 82.7zm89.3 297.1c-13.1 1.7-24.1-9.3-22.4-22.4 1.1-8.9 8.3-16.1 17.2-17.2 13.1-1.7 24.1 9.3 22.4 22.4-1.1 8.9-8.3 16.1-17.2 17.2zm0-104c-13.1 1.7-24.1-9.3-22.4-22.4 1.1-8.9 8.3-16.1 17.2-17.2 13.1-1.7 24.1 9.3 22.4 22.4-1.1 8.9-8.3 16.1-17.2 17.2zm0-104c-13.1 1.7-24.1-9.3-22.4-22.4 1.1-8.9 8.3-16.1 17.2-17.2 13.1-1.7 24.1 9.3 22.4 22.4-1.1 8.9-8.3 16.1-17.2 17.2zM384.7 374h-180c-7.7 0-14-6.3-14-14s6.3-14 14-14h180c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-104h-180c-7.7 0-14-6.3-14-14s6.3-14 14-14h180c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-104h-180c-7.7 0-14-6.3-14-14s6.3-14 14-14h180c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}}]})(props);
	};
	module.exports.IoIosList = function IoIosList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"92","cy":"256","r":"28"}},{"tag":"circle","attr":{"cx":"92","cy":"132","r":"28"}},{"tag":"circle","attr":{"cx":"92","cy":"380","r":"28"}},{"tag":"path","attr":{"d":"M432 240H191.5c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16zM432 364H191.5c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16zM191.5 148H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H191.5c-8.8 0-16 7.2-16 16s7.2 16 16 16z"}}]})(props);
	};
	module.exports.IoIosLocate = function IoIosLocate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M395.3 259c-.3-1.2-.4-2.4-.3-3.6 0-.8.2-1.6.3-2.4-.4.9-.6 2-.6 3 .1 1.1.3 2.1.6 3z"}},{"tag":"path","attr":{"d":"M459.4 270H409c-6.7 0-12.3-4.7-13.7-11-.3-.9-.5-1.9-.5-3s.2-2.1.6-3c1.4-6.4 7.3-11 14.1-11h49.9c2.4 0 4.2-2 4-4.4-8.8-100.3-88.7-180.2-189-189-2.3-.2-4.4 1.6-4.4 4V103c0 7.9-6.6 14.3-14.6 14-7.6-.3-13.4-6.9-13.4-14.4v-50c0-2.4-2-4.2-4.4-4-100.3 8.8-180.2 88.7-189 189-.2 2.3 1.6 4.4 4 4.4H103c7.9 0 14.3 6.6 14 14.6-.3 7.6-6.9 13.4-14.4 13.4h-50c-2.4 0-4.2 2-4 4.4 8.8 100.3 88.7 180.2 189 189 2.3.2 4.4-1.6 4.4-4V409c0-7.9 6.6-14.3 14.6-14 7.6.3 13.4 6.9 13.4 14.4v49.9c0 2.4 2 4.2 4.4 4 100.3-8.8 180.2-88.7 189-189 .2-2.3-1.7-4.3-4-4.3zM256 326c-38.7 0-70-31.3-70-70s31.3-70 70-70 70 31.3 70 70-31.3 70-70 70z"}}]})(props);
	};
	module.exports.IoIosLock = function IoIosLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 192h-24v-46.7c0-52.7-42-96.5-94.7-97.3-53.4-.7-97.3 42.8-97.3 96v48h-24c-22 0-40 18-40 40v192c0 22 18 40 40 40h240c22 0 40-18 40-40V232c0-22-18-40-40-40zM270 316.8v68.8c0 7.5-5.8 14-13.3 14.4-8 .4-14.7-6-14.7-14v-69.2c-11.5-5.6-19.1-17.8-17.9-31.7 1.4-15.5 14.1-27.9 29.6-29 18.7-1.3 34.3 13.5 34.3 31.9 0 12.7-7.3 23.6-18 28.8zM324 192H188v-48c0-18.1 7.1-35.1 20-48s29.9-20 48-20 35.1 7.1 48 20 20 29.9 20 48v48z"}}]})(props);
	};
	module.exports.IoIosLogIn = function IoIosLogIn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M417 80H137c-25.4 0-46 20.6-46 46 0 7.7 6.3 14 14 14s14-6.3 14-14c0-9.9 8.1-18 18-18h280c9.9 0 18 8.1 18 18v260c0 9.9-8.1 18-18 18H137c-9.9 0-18-8.1-18-18 0-7.7-6.3-14-14-14s-14 6.3-14 14c0 25.4 20.6 46 46 46h280c25.4 0 46-20.6 46-46V126c0-25.4-20.6-46-46-46z"}},{"tag":"path","attr":{"d":"M224 334.2c-5.4 5.4-5.4 14.3 0 19.8l.1.1c2.7 2.5 6.2 3.9 9.8 3.9 3.8 0 7.3-1.4 9.9-4.1l82.6-82.4c4.3-4.3 6.5-9.3 6.5-14.7 0-5.3-2.3-10.3-6.5-14.5l-84.6-84.4c-2.6-2.6-6.1-4.1-9.9-4.1-3.7 0-7.3 1.4-9.9 4.1-5.5 5.5-5.5 14.3 0 19.8l65.2 64.2H63c-7.7 0-14 6.3-14 14s6.3 14 14 14h224.6L224 334.2z"}}]})(props);
	};
	module.exports.IoIosLogOut = function IoIosLogOut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M312 372c-7.7 0-14 6.3-14 14 0 9.9-8.1 18-18 18H94c-9.9 0-18-8.1-18-18V126c0-9.9 8.1-18 18-18h186c9.9 0 18 8.1 18 18 0 7.7 6.3 14 14 14s14-6.3 14-14c0-25.4-20.6-46-46-46H94c-25.4 0-46 20.6-46 46v260c0 25.4 20.6 46 46 46h186c25.4 0 46-20.6 46-46 0-7.7-6.3-14-14-14z"}},{"tag":"path","attr":{"d":"M372.9 158.1c-2.6-2.6-6.1-4.1-9.9-4.1-3.7 0-7.3 1.4-9.9 4.1-5.5 5.5-5.5 14.3 0 19.8l65.2 64.2H162c-7.7 0-14 6.3-14 14s6.3 14 14 14h256.6L355 334.2c-5.4 5.4-5.4 14.3 0 19.8l.1.1c2.7 2.5 6.2 3.9 9.8 3.9 3.8 0 7.3-1.4 9.9-4.1l82.6-82.4c4.3-4.3 6.5-9.3 6.5-14.7 0-5.3-2.3-10.3-6.5-14.5l-84.5-84.2z"}}]})(props);
	};
	module.exports.IoIosMagnet = function IoIosMagnet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462.2 261.9L289.6 89.3C263 62.7 227.4 48 189.5 48c-38 0-73.5 14.7-100.2 41.3C62.7 116 48 151.5 48 189.5S62.7 263 89.3 289.6l172.6 172.6c1.1 1.1 2.7 1.8 4.3 1.8 1.6 0 3.1-.6 4.3-1.8l57.5-57.5c2.4-2.4 2.4-6.2 0-8.5L165.2 233.3c-13-13-21.2-27.8-22.9-41.7-1.8-13.6 2.7-25.8 13.1-36.3 9.9-9.9 22.4-14.3 36-12.6 14.3 1.7 29.2 9.7 42 22.5L396.2 328c2.4 2.4 6.2 2.4 8.5 0l57.5-57.5c2.4-2.4 2.4-6.2 0-8.6zM275.8 380.2l20.2 20.2-29.8 29.8-20.3-20.2 29.9-29.8zM400.4 296l-20.2-20.2L410 246l20.2 20.2-29.8 29.8z"}}]})(props);
	};
	module.exports.IoIosMailOpen = function IoIosMailOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453.5 209.8c-4-4-158.3-161.4-158.3-161.4C284.8 37.8 270.9 32 256 32c-14.9 0-28.8 5.8-39.2 16.5 0 0-153.6 156.5-158.3 161.4C53.9 214.7 48 224.7 48 236v212c0 17.6 14.4 32 32 32h352c17.6 0 32-14.4 32-32V235c0-11.7-6.6-21.1-10.5-25.2zm-19.4 42.3L353 336.9c-.8.8-.8 2 0 2.8l75.3 80.2c5.1 5.1 5.1 13.3 0 18.4-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8l-151-161.2c-1.6-1.7-4.3-1.7-5.8 0L102.2 438.2c-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8c-5.1-5.1-5.1-13.3 0-18.4l75.3-80.2c.7-.8.7-2 0-2.8L77.7 252c-9.7-9.9-2.4-35.8 16.1-35.8h324.4c16.5-.1 25.6 26.1 15.9 35.9z"}}]})(props);
	};
	module.exports.IoIosMailUnread = function IoIosMailUnread (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"416","cy":"152","r":"48"}},{"tag":"path","attr":{"d":"M416 218.5c-5.4 0-10.6-.7-15.6-1.9L353 264.9c-.8.8-.8 2 0 2.8l75.3 80.2c5.1 5.1 5.1 13.3 0 18.4-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8l-75-79.9c-.8-.8-2.1-.8-2.9 0L313.7 305c-15.3 15.5-35.6 24.1-57.4 24.2-22.1.1-43.1-9.2-58.6-24.9l-17.6-17.9c-.8-.8-2.1-.8-2.9 0l-75 79.9c-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8c-5.1-5.1-5.1-13.3 0-18.4l75.3-80.2c.7-.8.7-2 0-2.8L51.4 155.3c-1.3-1.3-3.4-.4-3.4 1.4V376c0 17.6 14.4 32 32 32h352c17.6 0 32-14.4 32-32V198c-12.1 12.6-29.1 20.5-48 20.5z"}},{"tag":"path","attr":{"d":"M349.5 152c0-11.6 3-22.5 8.2-32H79.9c-7.5 0-14.4 2.6-19.8 7L217 286.7c10.4 10.6 24.3 16.4 39.1 16.4s28.7-5.8 39.1-16.4l80.5-81.9c-16-12.2-26.2-31.3-26.2-52.8z"}}]})(props);
	};
	module.exports.IoIosMail = function IoIosMail (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M460.6 147.3L353 256.9c-.8.8-.8 2 0 2.8l75.3 80.2c5.1 5.1 5.1 13.3 0 18.4-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8l-75-79.9c-.8-.8-2.1-.8-2.9 0L313.7 297c-15.3 15.5-35.6 24.1-57.4 24.2-22.1.1-43.1-9.2-58.6-24.9l-17.6-17.9c-.8-.8-2.1-.8-2.9 0l-75 79.9c-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8c-5.1-5.1-5.1-13.3 0-18.4l75.3-80.2c.7-.8.7-2 0-2.8L51.4 147.3c-1.3-1.3-3.4-.4-3.4 1.4V368c0 17.6 14.4 32 32 32h352c17.6 0 32-14.4 32-32V148.7c0-1.8-2.2-2.6-3.4-1.4z"}},{"tag":"path","attr":{"d":"M256 295.1c14.8 0 28.7-5.8 39.1-16.4L452 119c-5.5-4.4-12.3-7-19.8-7H79.9c-7.5 0-14.4 2.6-19.8 7L217 278.7c10.3 10.5 24.2 16.4 39 16.4z"}}]})(props);
	};
	module.exports.IoIosMale = function IoIosMale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450.4 48H341.5c-7.5 0-13.6 6.1-13.6 13.6s6.1 13.6 13.6 13.6h75.4L326.7 166c-30.6-26-69.3-40.3-109.6-40.3-22.8 0-45 4.5-65.8 13.3-20.1 8.5-38.2 20.7-53.8 36.2C82 190.8 69.8 208.9 61.3 229 52.5 249.9 48 272 48 294.9s4.5 45 13.3 65.8c8.5 20.1 20.7 38.2 36.2 53.8 15.5 15.5 33.6 27.7 53.8 36.2 20.9 8.8 43 13.3 65.8 13.3 22.8 0 45-4.5 65.8-13.3 20.1-8.5 38.2-20.7 53.8-36.2 15.5-15.5 27.7-33.6 36.2-53.8 8.8-20.9 13.3-43 13.3-65.8 0-40.3-14.3-79-40.3-109.6L436.7 95v75.4c0 7.5 6.1 13.6 13.6 13.6s13.6-6.1 13.6-13.6V61.6c.1-7.5-6-13.6-13.5-13.6zM359 294.9c0 37.9-14.8 73.5-41.6 100.3-26.8 26.8-62.4 41.6-100.3 41.6s-73.5-14.8-100.3-41.6C90 368.4 75.2 332.8 75.2 294.9s14.8-73.5 41.6-100.3c26.8-26.8 62.4-41.6 100.3-41.6s73.5 14.8 100.3 41.6C344.3 221.3 359 257 359 294.9z"}}]})(props);
	};
	module.exports.IoIosMan = function IoIosMan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.7 106.6h-.2c-25 0-45.5-20.3-45.5-45.3 0-25 20.4-45.3 45.5-45.3S301 36.3 301 61.3c0 12.1-4.7 23.5-13.3 32-8.5 8.6-19.9 13.3-32 13.3zM221.2 496c-14.4 0-27-10.5-27-30.4l1-277.6h-10v105c0 9.3-3 15.1-6.4 18.3-4.3 4.1-9.1 6.4-15.2 6.4-6.2 0-10.9-2.3-15.2-6.4-3.4-3.2-6.4-8.9-6.4-18.3V171.4c0-13.8 4.4-27.8 13.8-38.4 10.4-11.6 23.6-18 39-18h122.3c15.4 0 28.6 6.4 39 18.1 9.4 10.6 13.8 24.5 13.8 38.3V293c0 7.3-1.7 13.8-6.6 18.3-4.4 4-9.3 6.2-15.5 6.2s-11.1-2.2-15.5-6.2c-4.9-4.5-6.6-11-6.6-18.3V188h-9v277.6c0 19.7-13.4 30.4-27.8 30.4-13.4 0-26.3-9.3-27.4-29.8V325h-12v140.9c-.7 19.7-13.8 30.1-28.3 30.1z"}}]})(props);
	};
	module.exports.IoIosMap = function IoIosMap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 72.5v316.3c0 2.8 1.3 5.5 3.5 7l69.8 50.2c5.2 3.7 12.1-.3 12.1-7V122.7c0-2.8-1.3-5.5-3.5-7L76.1 65.4c-5.2-3.7-12.1.3-12.1 7.1zM168.7 123.3v316.3c0 6.7 6.9 10.8 12.1 7l62-36.7c2.2-1.6 3.5-4.2 3.5-7V86.6c0-6.7-6.9-10.8-12.1-7l-62 36.7c-2.2 1.5-3.5 4.1-3.5 7zM435.9 65.5l-69.8 50.7c-2.2 1.6-3.5 4.2-3.5 7v316.2c0 6.8 6.9 10.8 12.1 7l69.8-50.7c2.2-1.6 3.5-4.2 3.5-7V72.5c0-6.7-6.9-10.7-12.1-7zM265.7 85.6v316.2c0 2.8 1.3 5.5 3.5 7l62 37c5.2 3.8 12.1-.3 12.1-7V122.6c0-2.8-1.3-5.5-3.5-7l-62-37c-5.2-3.7-12.1.3-12.1 7z"}}]})(props);
	};
	module.exports.IoIosMedal = function IoIosMedal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M50 124c-1.1 0-2 .9-2 2v59.9c0 14.4 9.6 27 23.4 30.8l104 29.4c1.3.4 2.5-.6 2.5-1.9V126c0-1.1-.9-2-2-2H50zM204 126v126.2c0 .9.6 1.7 1.5 1.9l50 13.9c.4.1.7.1 1.1 0l56-15.6c.9-.2 1.5-1 1.5-1.9V126c0-1.1-.9-2-2-2H206c-1.1 0-2 .9-2 2zM334 126v119.2c0 1.3 1.3 2.3 2.6 1.9l104-30.4c13.8-3.9 23.4-16.5 23.4-30.8V126c0-1.1-.9-2-2-2H336c-1.1 0-2 .9-2 2zM48 64v38c0 1.1.9 2 2 2h412c1.1 0 2-.9 2-2V64c0-17.7-14.3-32-32-32H80c-17.7 0-32 14.3-32 32z"}},{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"cx":"256","cy":"352","r":"56"}},{"tag":"path","attr":{"d":"M351.3 266.6l-51.5 13.8c24 14.8 40.1 41.3 40.1 71.6 0 46.3-37.7 84-84 84s-84-37.7-84-84c0-30.4 16.2-57 40.4-71.8L161 266.1c-20.5 22.7-33 52.8-33 85.9 0 70.7 57.3 128 128 128s128-57.3 128-128c0-32.8-12.4-62.7-32.7-85.4z"}},{"tag":"path","attr":{"d":"M256 296c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56 25.1-56 56-56z"}}]}]})(props);
	};
	module.exports.IoIosMedical = function IoIosMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M430.3 174.3l-16.5-28.6c-4.3-7.4-13.8-10-21.2-5.7L294 197c-2.7 1.5-6-.4-6-3.5v-114c0-8.6-6.9-15.5-15.5-15.5h-33c-8.6 0-15.5 6.9-15.5 15.5v114.1c0 3.1-3.3 5-6 3.5l-98.6-57c-7.4-4.3-16.9-1.7-21.2 5.7l-16.5 28.6c-4.3 7.4-1.7 16.9 5.7 21.1l98.7 57.1c2.7 1.5 2.7 5.4 0 6.9l-98.7 57.1c-7.4 4.3-9.9 13.7-5.7 21.1l16.5 28.6c4.3 7.4 13.8 10 21.2 5.7l98.6-57c2.7-1.5 6 .4 6 3.5v114.1c0 8.6 6.9 15.5 15.5 15.5h33c8.6 0 15.5-6.9 15.5-15.5V318.4c0-3.1 3.4-5 6-3.5l98.6 57c7.4 4.3 16.9 1.7 21.2-5.7l16.5-28.6c4.3-7.4 1.7-16.9-5.7-21.1l-98.7-57.1c-2.7-1.5-2.7-5.4 0-6.9l98.7-57.1c7.4-4.2 9.9-13.7 5.7-21.1z"}}]})(props);
	};
	module.exports.IoIosMedkit = function IoIosMedkit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 128h-84V96c0-17.6-14.4-32-32-32H196c-17.6 0-32 14.4-32 32v32H80c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h352c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32zm-240-28c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v28H192v-28zm128 204h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16z"}}]})(props);
	};
	module.exports.IoIosMegaphone = function IoIosMegaphone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M90.1 187c0-33.4 17.1-62.8 43.5-78.9 2.8-1.7 1.6-6-1.7-6-38.2 0-68.5 30.4-74.1 69.8-5.6.9-9.9 7.3-9.9 14.9 0 8 4.7 14.3 10.8 14.8 6.7 33.8 33.8 55.4 61.2 64.5 4.3.9 7.1-4.5 3.8-7.5-19.6-17.7-33.6-44.3-33.6-71.6z"}},{"tag":"path","attr":{"d":"M450.2 102.8c-1-2.7-2.1-5.2-3.2-7.7-6-13.4-13.4-24.2-21.7-32.2-10.5-9.7-21.4-14.9-34.8-14.9-13.5 0-21.5 5.2-25.8 7.8-43.1 25.9-112.3 46-154 46s-39.4.2-39.4.2c-31.6 14-54.8 46.9-54.8 85 0 34.2 17.8 64.2 44.4 80 12.1 10.1 23.6 8.8 21.1 22.2-2.5 13.4-22.5 97.5-25 115s-2.9 27.5 4 36c7 8.5 49.5 23.8 68 23.8s13.8-8.7 13.8-43.8-9.3-131.7 16.5-131.7c48.3 0 73.5 17.3 111.3 31.7 9 3.4 14.1 4.7 20.1 4.7 6 0 18.7-1.9 34.7-18.2 9.2-9.4 15.7-18.8 21.7-32.2 1.1-2.6 2.2-5.2 3.3-8 8.9-23.2 13.7-51.9 13.7-81.9-.1-29.8-4.9-58.6-13.9-81.8zm-26.6 157c-6.4 15.7-17.6 28.2-26.9 28.2-9.3 0-17.8-12.5-24.2-28.2-7.5-18.3-12.3-45-12.3-74.7 0-29.8 4.8-56.6 12.3-74.9 6.4-15.6 14.9-25 24.1-25 9.3 0 20.3 9.5 26.8 25 7.6 18.3 14.5 45.1 14.5 74.9.1 29.7-6.8 56.4-14.3 74.7z"}}]})(props);
	};
	module.exports.IoIosMenu = function IoIosMenu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 176H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16zM432 272H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16zM432 368H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16z"}}]})(props);
	};
	module.exports.IoIosMicOff = function IoIosMicOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.8 464c-4.9 0-9.7-2.5-12.3-7L129.9 69.3c-4-6.7-1.7-15.4 5.1-19.3 6.8-3.9 15.5-1.7 19.5 5.1l227.6 387.7c4 6.7 1.7 15.4-5.1 19.3-2.3 1.3-4.8 1.9-7.2 1.9zM320 272V112c0-35.2-28.8-64-64-64-28.4 0-52.6 18.8-60.9 44.5L315 296.8c3.2-7.6 5-16 5-24.8zM192 272c0 35.2 28.8 64 64 64 3.9 0 7.6-.4 11.3-1L192 206.6V272zM366 275v-69c0-7.7-6.3-14-14-14s-14 6.3-14 14v69c0 15.2-4.2 29.4-11.4 41.6l15.6 26.6c14.9-18.7 23.8-42.4 23.8-68.2z"}},{"tag":"path","attr":{"d":"M256 357c-45.2 0-82-36.8-82-82v-69c0-7.7-6.3-14-14-14s-14 6.3-14 14v69c0 55.9 41.9 102.2 96 109.1V436h-36c-7.7 0-14 6.3-14 14s6.3 14 14 14h100c7.7 0 14-6.3 14-14s-6.3-14-14-14h-36v-51.9c7.9-1 15.6-2.9 22.9-5.5l-14.5-24.8c-7.1 2.1-14.6 3.2-22.4 3.2z"}}]})(props);
	};
	module.exports.IoIosMic = function IoIosMic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 336c35.2 0 64-28.8 64-64V112c0-35.2-28.8-64-64-64s-64 28.8-64 64v160c0 35.2 28.8 64 64 64z"}},{"tag":"path","attr":{"d":"M352 192c-7.7 0-14 6.3-14 14v69c0 45.2-36.8 82-82 82s-82-36.8-82-82v-69c0-7.7-6.3-14-14-14s-14 6.3-14 14v69c0 55.9 41.9 102.2 96 109.1V436h-36c-7.7 0-14 6.3-14 14s6.3 14 14 14h100c7.7 0 14-6.3 14-14s-6.3-14-14-14h-36v-51.9c54.1-6.9 96-53.2 96-109.1v-69c0-7.7-6.3-14-14-14z"}}]})(props);
	};
	module.exports.IoIosMicrophone = function IoIosMicrophone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M315 204h72.6c6.6 0 12.3-5.2 12.4-11.8.1-6.7-5.3-12.2-12-12.2h-73c-6.7 0-12.1-5.5-12-12.2.1-6.6 5.8-11.8 12.4-11.8h76.5c4.5 0 8.2-3.7 8-8.2-1.7-47.5-31.2-88.1-72.7-106-5.3-2.3-11.2 1.6-11.2 7.3v35.5c0 6.6-5.2 12.3-11.8 12.4-6.7.1-12.2-5.3-12.2-12V44c0-6.6-5.4-12-12-12s-12 5.4-12 12v56.6c0 6.6-5.2 12.3-11.8 12.4-6.7.1-12.2-5.3-12.2-12V44c0-6.6-5.4-12-12-12s-12 5.4-12 12v40.6c0 6.6-5.2 12.3-11.8 12.4-6.7.1-12.2-5.3-12.2-12V49.1c0-5.8-5.9-9.6-11.2-7.3-41.5 17.9-71.1 58.6-72.7 106-.2 4.5 3.5 8.2 8 8.2h76.5c6.6 0 12.3 5.2 12.4 11.8.1 6.7-5.3 12.2-12 12.2h-72.6c-6.6 0-12.3 5.2-12.4 11.8-.1 6.7 5.3 12.2 12 12.2h72.6c6.6 0 12.3 5.2 12.4 11.8.1 6.7-5.3 12.2-12 12.2h-72.6c-6.6 0-12.3 5.2-12.4 11.8-.1 6.7 5.3 12.2 12 12.2h72.6c6.6 0 12.3 5.2 12.4 11.8.1 6.7-5.3 12.2-12 12.2h-76.9c-4.5 0-8.2 3.7-8 8.2.5 13.6 3.3 26.7 7.9 38.8 1.2 3.1 4.2 5 7.4 5h257.1c3.3 0 6.3-2 7.4-5 4.7-12.1 7.5-25.2 7.9-38.8.2-4.5-3.5-8.2-8-8.2h-76.5c-6.6 0-12.3-5.2-12.4-11.8-.1-6.7 5.3-12.2 12-12.2h72.6c6.6 0 12.3-5.2 12.4-11.8.1-6.7-5.3-12.2-12-12.2h-72.6c-6.6 0-12.3-5.2-12.4-11.8 0-6.7 5.4-12.2 12.1-12.2zM141.5 358.6c19 22 45.2 37.2 75.4 40.8 4 .5 7.1 3.9 7.1 7.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32v-40.7c0-4.1 3.1-7.5 7.1-7.9 30.3-3.5 56.4-18.7 75.4-40.8 2.2-2.6.3-6.6-3.1-6.6H144.5c-3.4 0-5.2 4-3 6.6z"}}]})(props);
	};
	module.exports.IoIosMoon = function IoIosMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M401.4 354.2c-2.9.1-5.8.2-8.7.2-47.9 0-93-18.9-126.8-53.4-33.9-34.4-52.5-80.1-52.5-128.8 0-27.7 6.1-54.5 17.5-78.7 3.1-6.6 9.3-16.6 13.6-23.4 1.9-2.9-.5-6.7-3.9-6.1-6 .9-15.2 2.9-27.7 6.8C135.1 95.5 80 168.7 80 255c0 106.6 85.1 193 190.1 193 58 0 110-26.4 144.9-68.1 6-7.2 11.5-13.8 16.4-21.8 1.8-3-.7-6.7-4.1-6.1-8.5 1.7-17.1 1.8-25.9 2.2z"}}]})(props);
	};
	module.exports.IoIosMore = function IoIosMore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.8 218c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38zM102 218c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38zM410 218c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38z"}}]})(props);
	};
	module.exports.IoIosMove = function IoIosMove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M475.9 246.2l-79.4-79.4c-5.4-5.4-14.2-5.4-19.6 0l-.2.2c-5.4 5.4-5.4 14.2 0 19.6l54.9 54.9-161.8.5.5-161.8 54.9 54.9c5.4 5.4 14.2 5.4 19.6 0l.2-.2c5.4-5.4 5.4-14.2 0-19.6l-79.4-79.4c-5.4-5.4-14.2-5.4-19.6 0l-79.4 79.4c-5.4 5.4-5.4 14.2 0 19.6l.2.2c5.4 5.4 14.2 5.4 19.6 0l54.9-54.9.5 161.8-161.8-.5 54.9-54.9c5.4-5.4 5.4-14.2 0-19.6l-.2-.2c-5.4-5.4-14.2-5.4-19.6 0l-79.4 79.4c-5.4 5.4-5.4 14.2 0 19.6l79.4 79.4c5.4 5.4 14.2 5.4 19.6 0l.2-.2c5.4-5.4 5.4-14.2 0-19.6L80 270.5l161.8-.5-.5 161.8-54.9-54.9c-5.4-5.4-14.2-5.4-19.6 0l-.2.2c-5.4 5.4-5.4 14.2 0 19.6l79.4 79.4c5.4 5.4 14.2 5.4 19.6 0l79.4-79.4c5.4-5.4 5.4-14.2 0-19.6l-.2-.2c-5.4-5.4-14.2-5.4-19.6 0l-54.9 54.9-.5-161.8 161.8.5-54.9 54.9c-5.4 5.4-5.4 14.2 0 19.6l.2.2c5.4 5.4 14.2 5.4 19.6 0l79.4-79.4c5.5-5.4 5.5-14.2 0-19.6z"}}]})(props);
	};
	module.exports.IoIosMusicalNote = function IoIosMusicalNote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M364.3 48.2c-4.7.9-118 24.1-122.2 24.9-4.2.8-8.1 3.6-8.1 8v255.1c0 1.6-.1 7.2-2.4 11.7-3.1 5.9-8.5 10.2-16.1 12.7-3.3 1.1-7.8 2.1-13.1 3.3-24.1 5.4-64.4 14.6-64.4 51.8 0 30.1 21.7 44.5 35 47.1 5 1 11 1 13.8 1 8.2 0 36-3.3 51.2-13.2 11-7.2 24.1-21.4 24.1-47.8V173.1c0-3.8 2.7-7.1 6.4-7.8l92.8-19c7.4-1.5 12.8-8.1 12.8-15.7V55.8c-.1-4.3-3.8-8.8-9.8-7.6z"}}]})(props);
	};
	module.exports.IoIosMusicalNotes = function IoIosMusicalNotes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M406.3 48.2c-4.7.9-202 39.2-206.2 40-4.2.8-8.1 3.6-8.1 8v240.1c0 1.6-.1 7.2-2.4 11.7-3.1 5.9-8.5 10.2-16.1 12.7-3.3 1.1-7.8 2.1-13.1 3.3-24.1 5.4-64.4 14.6-64.4 51.8 0 31.1 22.4 45.1 41.7 47.5 2.1.3 4.5.7 7.1.7 6.7 0 36-3.3 51.2-13.2 11-7.2 24.1-21.4 24.1-47.8V190.5c0-3.8 2.7-7.1 6.4-7.8l152-30.7c5-1 9.6 2.8 9.6 7.8v130.9c0 4.1-.2 8.9-2.5 13.4-3.1 5.9-8.5 10.2-16.2 12.7-3.3 1.1-8.8 2.1-14.1 3.3-24.1 5.4-64.4 14.5-64.4 51.7 0 33.7 25.4 47.2 41.8 48.3 6.5.4 11.2.3 19.4-.9s23.5-5.5 36.5-13c17.9-10.3 27.5-26.8 27.5-48.2V55.9c-.1-4.4-3.8-8.9-9.8-7.7z"}}]})(props);
	};
	module.exports.IoIosNavigate = function IoIosNavigate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm0 336V256H128.3L352 160l-96 224z"}}]})(props);
	};
	module.exports.IoIosNotificationsOff = function IoIosNotificationsOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.9 456c31.1 0 48.1-22 48.1-53h-96.3c0 31 17 53 48.2 53zM154.5 55c-2.5-4.3-7-6.8-11.6-7h.3-1.2c-2.3 0-4.7.7-6.9 1.9-6.8 3.9-9.1 12.6-5.1 19.3L357.5 457c2.6 4.5 7.4 7 12.3 7 2.4 0 4.9-.6 7.2-1.9 6.8-3.9 9.1-12.6 5.1-19.3L154.5 55zM296.1 384L159 150.5c-8.2 20.2-13.3 46-13.3 78.6 0 90.9-30.3 102.7-45.7 123.1-9.9 13.1-.5 31.8 15.9 31.8h180.2zM412 352.2c-15.4-20.3-45.7-32.2-45.7-123.1 0-93.3-41.2-130.8-79.6-139.8-3.6-.9-6.2-2.1-6.2-5.9v-2.9c0-13.4-11-24.7-24.4-24.6-13.4-.2-24.4 11.2-24.4 24.6v2.9c0 3.7-2.6 5-6.2 5.9-8.7 2-17.5 5.5-25.9 10.8L366.1 384H396c16.5 0 25.9-18.8 16-31.8z"}}]})(props);
	};
	module.exports.IoIosNotificationsOutline = function IoIosNotificationsOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M289.7 403c-6.1 0-11.4 4.2-12.7 10.2-1 4.5-2.7 8.2-5 10.9-1.3 1.5-5.1 5.9-16.1 5.9-11 0-14.8-4.5-16.1-5.9-2.3-2.7-4-6.4-5-10.9-1.3-6-6.6-10.2-12.7-10.2-8.4 0-14.5 7.8-12.7 15.9 5 22.3 21 37.1 46.5 37.1s41.5-14.7 46.5-37.1c1.8-8.1-4.4-15.9-12.7-15.9zM412 352.2c-15.4-20.3-45.7-32.2-45.7-123.1 0-93.3-41.2-130.8-79.6-139.8-3.6-.9-6.2-2.1-6.2-5.9v-2.9c0-13.3-10.8-24.6-24-24.6h-.6c-13.2 0-24 11.3-24 24.6v2.9c0 3.7-2.6 5-6.2 5.9-38.5 9.1-79.6 46.5-79.6 139.8 0 90.9-30.3 102.7-45.7 123.1-9.9 13.1-.5 31.8 15.9 31.8h280.1c16.1 0 25.4-18.8 15.6-31.8zm-39 5.8H139.8c-3.8 0-5.8-4.4-3.3-7.3 7-8 14.7-18.5 21-33.4 9.6-22.6 14.3-51.5 14.3-88.2 0-37.3 7-66.5 20.9-86.8 12.4-18.2 27.9-25.1 38.7-27.6 8.4-2 14.4-5.8 18.6-10.5 3.2-3.6 8.7-3.8 11.9-.2 5.1 5.7 12 9.1 18.8 10.7 10.8 2.5 26.3 9.4 38.7 27.6 13.9 20.3 20.9 49.5 20.9 86.8 0 36.7 4.7 65.6 14.3 88.2 6.5 15.2 14.4 25.9 21.5 33.9 2.2 2.7.4 6.8-3.1 6.8z"}}]})(props);
	};
	module.exports.IoIosNotifications = function IoIosNotifications (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.9 456c31.1 0 48.1-22 48.1-53h-96.3c0 31 17 53 48.2 53zM412 352.2c-15.4-20.3-45.7-32.2-45.7-123.1 0-93.3-41.2-130.8-79.6-139.8-3.6-.9-6.2-2.1-6.2-5.9v-2.9c0-13.4-11-24.7-24.4-24.6-13.4-.2-24.4 11.2-24.4 24.6v2.9c0 3.7-2.6 5-6.2 5.9-38.5 9.1-79.6 46.5-79.6 139.8 0 90.9-30.3 102.7-45.7 123.1-9.9 13.1-.5 31.8 15.9 31.8h280.1c16.3 0 25.7-18.8 15.8-31.8z"}}]})(props);
	};
	module.exports.IoIosNuclear = function IoIosNuclear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm-88.5 364.8l49.2-85.8c1.1-1.9.5-4.2-1.3-5.4-20.2-12.9-34-35-35.2-60.3-.1-2.1-1.8-3.8-4-3.8H76V256c0-48.1 18.7-93.3 52.7-127.3 10.8-10.8 22.7-20 35.4-27.6l50.5 87.9c1.1 1.9 3.5 2.5 5.4 1.5 10.7-5.8 22.9-9 35.9-9 12.5 0 24.4 3.1 34.8 8.5 1.9 1 4.2.3 5.3-1.5l51.1-87.7c13 7.7 25.1 17 36.1 28 34 34 52.7 79.2 52.7 127.3v1.5h-100c-2.1 0-3.9 1.7-4 3.8-1.3 25.4-15 47.5-35.2 60.3-1.8 1.2-2.4 3.5-1.3 5.4l49.2 85.8c-26.7 15.1-57 23.2-88.5 23.2-31.6-.1-61.9-8.2-88.6-23.3z"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"56"}}]})(props);
	};
	module.exports.IoIosNutrition = function IoIosNutrition (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M359.1 231.9h-.1c-.1-.1-.3-.4-.4-.6l-78.9-79.6c-5.8-6-14.2-10.2-23.6-10.2-11.8 0-22.2 6.2-27.7 16.3 0 0-3.4 5.1-12.6 19.8-1.6 2.6-1.6 6 .1 8.6l26.8 41.2c2.9 3.8 3.3 8 1.4 9.9l-.1.1c-2.3 2.3-5.9 1.5-9.8-1.4l-32.3-20.5c-3.8-2.4-8.7-1.2-11.1 2.5-21.9 35.1-46.8 74.7-71.2 114-1.6 2.5-1.6 5.7-.1 8.3l14.1 24.1c2.9 3.8 3.3 8 1.4 9.9l-.1.1c-2.3 2.3-5.9 1.5-9.8-1.4l-16.6-8.4c-3.7-1.9-8.2-.6-10.4 2.9-17.7 28.3-28 44.7-29.1 46.5-3 5.1-5 11.2-5 17.8 0 17.8 14.2 32.2 31.9 32.2 7.8 0 14.4-3.4 20.6-7.6L221 378.8c3.4-2.5 4.2-7.2 2-10.7L202.5 336c-2.9-3.8-3.3-8-1.4-9.9l.1-.1c2.3-2.3 5.9-1.5 9.8 1.4l37.4 25.6c2.8 1.9 6.5 1.9 9.3-.2 53-39.1 97.5-72.2 97.5-72.2 7.9-6 13-15.4 13-26 0-8.7-3.1-16.8-9.1-22.7zM446.9 131.2l-11.2-17.9c-2.2-3.8-7.1-5.1-10.9-2.9L365.4 147l47.3-78.9c2.2-3.8.9-8.8-2.9-11l-17.7-8c-3.9-2.3-8.8-.9-11 3l-57.6 108.3 28.6 28.8 91.8-46.8c3.9-2.2 5.3-7.2 3-11.2z"}}]})(props);
	};
	module.exports.IoIosOpen = function IoIosOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M227.8 300.2c-5.1-5.1-5.1-13.3 0-18.4l133.7-133.7c-5.3-2.6-11.2-4.1-17.5-4.1H88c-22 0-40 18-40 40v224c0 22 18 40 40 40h256c22 0 40-18 40-40V184c0-6.3-1.5-12.2-4.1-17.5L246.2 300.2c-5.1 5.1-13.3 5.1-18.4 0z"}},{"tag":"path","attr":{"d":"M459.5 68.5C457 66 453 64 449 64h-97c-7.2-.1-13.1 5.7-13.1 12.9-.1 7.2 5.7 13.1 12.9 13.1l67.3.5-57.6 57.6c8 3.9 14.5 10.4 18.4 18.4l57.6-57.6.5 67.3c.1 7.2 5.9 13 13.1 12.9 7.2-.1 13-5.9 12.9-13.1V78c0-3.5-2-7-4.5-9.5z"}}]})(props);
	};
	module.exports.IoIosOptions = function IoIosOptions (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M299.3 376c6.2-14.1 20.3-24 36.7-24s30.5 9.9 36.7 24H448c8.8 0 16 7.2 16 16s-7.2 16-16 16h-75.3c-6.2 14.1-20.3 24-36.7 24s-30.5-9.9-36.7-24H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h235.3zM139.3 240c6.2-14.1 20.3-24 36.7-24s30.5 9.9 36.7 24H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H212.7c-6.2 14.1-20.3 24-36.7 24s-30.5-9.9-36.7-24H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h75.3zM299.3 104c6.2-14.1 20.3-24 36.7-24s30.5 9.9 36.7 24H448c8.8 0 16 7.2 16 16s-7.2 16-16 16h-75.3c-6.2 14.1-20.3 24-36.7 24s-30.5-9.9-36.7-24H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h235.3z"}}]})(props);
	};
	module.exports.IoIosOutlet = function IoIosOutlet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M359 78H153c-2.8 0-5.6.8-8 2.3C86.7 116.9 48 182 48 256c0 73.9 38.7 138.1 97 175.6 2.4 1.6 5.2 2.4 8.1 2.4h205.8c2.9 0 5.7-.8 8.1-2.4 58.3-37.5 97-101.7 97-175.6 0-74-38.7-139.1-97-175.7-2.4-1.5-5.2-2.3-8-2.3zM192.9 270.8h-22.3c-2.1 0-3.7-1.7-3.7-3.7V155.9c0-2 1.7-3.7 3.7-3.7h22.3c2.1 0 3.7 1.7 3.7 3.7v111.2c0 2.1-1.7 3.7-3.7 3.7zM282 389.5h-52c-2.1 0-3.7-1.7-3.7-3.7v-40.2c0-16.5 13.6-30.5 30.1-30.3 16.2.2 29.3 13.5 29.3 29.7v40.8c0 2-1.6 3.7-3.7 3.7zM341.4 256h-22.3c-2.1 0-3.7-1.7-3.7-3.7v-81.6c0-2 1.7-3.7 3.7-3.7h22.3c2.1 0 3.7 1.7 3.7 3.7v81.6c0 2-1.6 3.7-3.7 3.7z"}}]})(props);
	};
	module.exports.IoIosPaperPlane = function IoIosPaperPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M452.1 49L52.3 265.3c-6 3.3-5.6 12.1.6 14.9l68.2 25.7c4 1.5 7.2 4.5 9 8.4l53 109.1c1 4.8 9.9 6.1 10 1.2l-8.1-90.2c.5-6.7 3-13 7.3-18.2l207.3-203.1c1.2-1.2 2.9-1.6 4.5-1.3 3.4.8 4.8 4.9 2.6 7.6L228 338c-4 6-6 11-7 18l-10.7 77.9c.9 6.8 6.2 9.4 10.5 3.3l38.5-45.2c2.6-3.7 7.7-4.5 11.3-1.9l99.2 72.3c4.7 3.5 11.4.9 12.6-4.9L463.8 58c1.5-6.8-5.6-12.3-11.7-9z"}}]})(props);
	};
	module.exports.IoIosPaper = function IoIosPaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M124 80v322c0 7.7-6.3 14-14 14s-14-6.3-14-14V112H80c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h353.1c17 0 30.9-13.8 30.9-30.9V80c0-17.7-14.3-32-32-32l-278 2c-17.7 0-30 12.3-30 30zm66 32h84c7.7 0 14 6.3 14 14s-6.3 14-14 14h-84c-7.7 0-14-6.3-14-14s6.3-14 14-14zm0 160h148c7.7 0 14 6.3 14 14s-6.3 14-14 14H190c-7.7 0-14-6.3-14-14s6.3-14 14-14zm196 108H190c-7.7 0-14-6.3-14-14s6.3-14 14-14h196c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-160H190c-7.7 0-14-6.3-14-14s6.3-14 14-14h196c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}}]})(props);
	};
	module.exports.IoIosPartlySunny = function IoIosPartlySunny (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M168.2 64h-.3c-8.7 0-15.8 7.1-15.8 15.8v30.3c0 8.7 7.1 15.8 15.8 15.8h.3c8.7 0 15.8-7.1 15.8-15.8V79.8c0-8.7-7.1-15.8-15.8-15.8zM79 216.2v-.3c0-8.7-7.1-15.8-15.8-15.8H31.8c-8.7 0-15.8 7.1-15.8 15.8v.3c0 8.7 7.1 15.8 15.8 15.8h31.3c8.8 0 15.9-7.1 15.9-15.8zM79.7 149c3 3 7 4.7 11.2 4.7 4.2 0 8.2-1.7 11.2-4.7 6.1-6.2 6.1-16.2 0-22.3l-20.3-20.5c-3-3-7-4.7-11.2-4.7-4.2 0-8.2 1.7-11.2 4.7-6.1 6.2-6.1 16.2 0 22.3L79.7 149zM271 105.2c-3-3-7-4.7-11.2-4.7-4.2 0-8.2 1.7-11.2 4.7l-20.3 20.4c-6.1 6.2-6.1 16.2 0 22.3l.3.3h.1c2.9 2.8 6.8 4.3 10.8 4.3 4.2 0 8.2-1.7 11.2-4.7l20.3-20.4c6.1-6 6.1-16 0-22.2zM92.9 273.3c-4.2 0-8.2 1.7-11.2 4.7l-20.3 20.5c-6.1 6.2-6.1 16.2 0 22.3 3 3 7 4.7 11.2 4.7 4.2 0 8.2-1.7 11.2-4.7l20.3-20.5c6.1-6.2 6.1-16.2 0-22.3-3-3-7-4.7-11.2-4.7zM403.3 259.2h-2.4c-3.1 0-6.1 0-9 .4-11.3-50.3-56.1-88.2-109.7-88.2-14.6 0-28.6 2.8-41.4 7.9-5.1 2-10 4.4-14.7 7.1-32 18.5-54.1 52.4-56.2 91.6-.1 2.1-.2 4.1-.2 6.2 0 3.4.2 6.8.5 10.1 0 .4.1.8.1 1.1-37.9 3.4-67.6 37.1-67.6 76 0 41.1 33.3 76.7 74.3 76.7h226.4c51.2 0 92.7-43.4 92.7-94.8-.1-51.4-41.6-94.1-92.8-94.1z"}},{"tag":"path","attr":{"d":"M150.7 283.6v-.3c-.3-3.4-.5-6.8-.5-10.2 0-2.1.1-4.2.2-6.3 2.2-39.9 24.6-74.3 57.2-93.1 4.8-2.8 9.8-5.2 14.9-7.2h.1c-13.4-17-34.2-28-57.6-28-40.5 0-73.3 32.8-73.3 73.3 0 35.5 25.3 65.1 59 71.8z"}}]})(props);
	};
	module.exports.IoIosPause = function IoIosPause (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M199.9 416h-63.8c-4.5 0-8.1-3.6-8.1-8V104c0-4.4 3.6-8 8.1-8h63.8c4.5 0 8.1 3.6 8.1 8v304c0 4.4-3.6 8-8.1 8zM375.9 416h-63.8c-4.5 0-8.1-3.6-8.1-8V104c0-4.4 3.6-8 8.1-8h63.8c4.5 0 8.1 3.6 8.1 8v304c0 4.4-3.6 8-8.1 8z"}}]})(props);
	};
	module.exports.IoIosPaw = function IoIosPaw (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M324.3 80.3c-1.2-.2-2.4-.3-3.6-.3v.4-.3h-.4c-22 0-42.9 25.9-47.8 60.3-5.3 36.6 9.4 69 32.7 72.4 1.3.2 2.7.3 4 .3 22 0 42.9-25.9 47.8-60.3 5.3-36.7-9.4-69.1-32.7-72.5zM320.6 80zM442.3 169.4c-3.5-1.4-7.1-2.1-10.9-2.1h-.4c-19.7.3-41.8 19.2-53.4 47.8-13.9 34.2-7.5 69.2 14.4 78.2 3.5 1.4 7.1 2.1 10.9 2.1 19.8 0 42.2-19 53.9-47.8 13.8-34.2 7.3-69.2-14.5-78.2zM327.6 295.4c-27.8-43.6-39.8-60-71.6-60s-43.9 16.5-71.7 60c-23.8 37.2-71.9 40.3-83.9 71.9-2.4 5.6-3.6 11.7-3.6 18.2 0 25.7 20.8 46.5 46.4 46.5 31.8 0 75.1-24 112.9-24s80.9 24 112.7 24c25.6 0 46.3-20.8 46.3-46.5 0-6.5-1.3-12.6-3.7-18.2-12-31.7-60-34.7-83.8-71.9zM202.8 213c1.3 0 2.7-.1 4-.3 23.4-3.4 38-35.8 32.7-72.4-5-34.5-25.9-60.3-47.8-60.3-1.3 0-2.7.1-4 .3-23.4 3.4-38 35.8-32.7 72.4 5 34.4 25.9 60.3 47.8 60.3zM120.1 293.3c21.9-9 28.3-44 14.4-78.2-11.7-28.8-34.1-47.8-53.9-47.8-3.8 0-7.4.7-10.9 2.1-21.9 9-28.3 44-14.4 78.2 11.7 28.8 34.1 47.8 53.9 47.8 3.8 0 7.4-.7 10.9-2.1z"}}]})(props);
	};
	module.exports.IoIosPeople = function IoIosPeople (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M349.1 334.7c-11.2-4-29.5-4.2-37.6-7.3-5.6-2.2-14.5-4.6-17.4-8.1-2.9-3.5-2.9-28.5-2.9-28.5s7-6.6 9.9-14c2.9-7.3 4.8-27.5 4.8-27.5s6.6 2.8 9.2-10.4c2.2-11.4 6.4-17.4 5.3-25.8-1.2-8.4-5.8-6.4-5.8-6.4s5.8-8.5 5.8-37.4c0-29.8-22.5-59.1-64.6-59.1-42 0-64.7 29.4-64.7 59.1 0 28.9 5.7 37.4 5.7 37.4s-4.7-2-5.8 6.4c-1.2 8.4 3 14.4 5.3 25.8 2.6 13.3 9.2 10.4 9.2 10.4s1.9 20.1 4.8 27.5c2.9 7.4 9.9 14 9.9 14s0 25-2.9 28.5-11.8 5.9-17.4 8c-8 3.1-26.3 3.5-37.6 7.5-11.2 4-45.8 22.2-45.8 67.2h278.3c.1-45.1-34.5-63.3-45.7-67.3z"}},{"tag":"path","attr":{"d":"M140 286s23.9-.8 33.4-9.3c-15.5-23.5-7.1-50.9-10.3-76.5-3.2-25.5-17.7-40.8-46.7-40.8h-.4c-28 0-43.1 15.2-46.3 40.8-3.2 25.5 5.7 56-10.2 76.5C69 285.3 93 285 93 285s1 14.4-1 16.8c-2 2.4-7.9 4.7-12 5.5-8.8 1.9-18.1 4.5-25.9 7.2-7.8 2.7-22.6 17.2-22.6 37.2h80.3c2.2-8 17.3-22.3 32-29.8 9-4.6 17.9-4.3 24.7-5.2 0 0 3.8-6-8.7-8.3 0 0-17.2-4.3-19.2-6.7-1.9-2.2-.6-15.7-.6-15.7zM372 286s-23.9-.8-33.4-9.3c15.5-23.5 7.1-50.9 10.3-76.5 3.2-25.5 17.7-40.8 46.7-40.8h.4c28 0 43.1 15.2 46.3 40.8 3.2 25.5-5.7 56 10.2 76.5-9.5 8.6-33.5 8.3-33.5 8.3s-1 14.4 1 16.8c2 2.4 7.9 4.7 12 5.5 8.8 1.9 18.1 4.5 25.9 7.2 7.8 2.7 22.6 17.2 22.6 37.2h-80.3c-2.2-8-17.3-22.3-32-29.8-9-4.6-17.9-4.3-24.7-5.2 0 0-3.8-6 8.7-8.3 0 0 17.2-4.3 19.2-6.7 1.9-2.2.6-15.7.6-15.7z"}}]})(props);
	};
	module.exports.IoIosPersonAdd = function IoIosPersonAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M385.3 386c-15.6-5.5-37.8-6.8-52.1-10-8.2-1.8-20.1-6.3-24.1-11.1-3.5-4.2-2.1-38.4-1.7-47.2.1-1.3.5-2.6 1.1-3.8 2.2-3.6 7.2-12.2 10.3-20 3-7.6 6.2-25 7.6-33.3.4-2.4 1.9-4.5 4-5.6 2.6-1.5 6.1-4.9 7.8-13.4 3.1-15.7 8-21.8 7.4-33.5-.3-5.2-1.7-8-3.2-9.5-2-1.9-2.7-4.8-2-7.4 1.9-7.6 4.7-22.6 5.2-45.6.9-41.1-31.3-81.6-89.5-81.6-59.1 0-90.5 40.5-89.6 81.6.5 23 3.3 38 5.1 45.6.6 2.7-.1 5.5-2 7.4-1.5 1.5-3 4.3-3.2 9.5-.6 11.7 4.3 17.8 7.4 33.5 1.7 8.4 5.2 11.9 7.8 13.4 2.1 1.2 3.6 3.2 4 5.6 1.4 8.3 4.6 25.7 7.6 33.3 3.1 7.8 8.2 16.5 10.3 20 .7 1.1 1.1 2.4 1.1 3.8.4 8.8 1.8 43.1-1.7 47.2-4 4.8-15.9 9.3-24.1 11.1-14.3 3.2-36.5 4.5-52.1 10-14.2 5-55.3 20.5-62.5 52.3-1.1 5 2.7 9.7 7.9 9.7H440c5.1 0 8.9-4.7 7.8-9.7-7.2-31.8-48.3-47.3-62.5-52.3z"}},{"tag":"path","attr":{"d":"M437.5 293.5h-27v-27c0-5.8-4.7-10.5-10.5-10.5s-10.5 4.7-10.5 10.5v27h-27c-5.8 0-10.5 4.7-10.5 10.5s4.7 10.5 10.5 10.5h27v27c0 5.8 4.7 10.5 10.5 10.5s10.5-4.7 10.5-10.5v-27h27c5.8 0 10.5-4.7 10.5-10.5s-4.7-10.5-10.5-10.5z"}}]})(props);
	};
	module.exports.IoIosPerson = function IoIosPerson (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.8 438.3c-7.2-31.8-48.3-47.3-62.5-52.3-15.6-5.5-37.8-6.8-52.1-10-8.2-1.8-20.1-6.3-24.1-11.1s-1.6-49.3-1.6-49.3 7.4-11.5 11.4-21.7c4-10.1 8.4-37.9 8.4-37.9s8.2 0 11.1-14.4c3.1-15.7 8-21.8 7.4-33.5-.6-11.5-6.9-11.2-6.9-11.2s6.1-16.7 6.8-51.3c.9-41.1-31.3-81.6-89.6-81.6-59.1 0-90.6 40.5-89.7 81.6.8 34.6 6.7 51.3 6.7 51.3s-6.3-.3-6.9 11.2c-.6 11.7 4.3 17.8 7.4 33.5 2.8 14.4 11.1 14.4 11.1 14.4s4.4 27.8 8.4 37.9c4 10.2 11.4 21.7 11.4 21.7s2.4 44.5-1.6 49.3c-4 4.8-15.9 9.3-24.1 11.1-14.3 3.2-36.5 4.5-52.1 10-14.2 5-55.3 20.5-62.5 52.3-1.1 5 2.7 9.7 7.9 9.7H440c5.1 0 8.9-4.7 7.8-9.7z"}}]})(props);
	};
	module.exports.IoIosPhoneLandscape = function IoIosPhoneLandscape (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 176.3v158.5c0 18.3 14.6 33.1 32.9 33.1h381c18.4 0 34.1-14.8 34.1-33.1V176.3c0-18.3-15.7-32.3-34.1-32.3h-381C46.6 144 32 158 32 176.3zM55 271v-30c0-2.2 1.8-4 4-4s4 1.8 4 4v30c0 2.2-1.8 4-4 4s-4-1.8-4-4zm414-15.5c0 9.6-7.8 17.4-17.4 17.4-9.6 0-17.4-7.8-17.4-17.4 0-9.6 7.8-17.4 17.4-17.4 9.6 0 17.4 7.8 17.4 17.4zM424 160v192H83V160h341z"}},{"tag":"path","attr":{"d":"M441.6 255.5c0 5.5 4.5 10 9.9 10 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.4.1-9.9 4.5-9.9 10z"}}]})(props);
	};
	module.exports.IoIosPhonePortrait = function IoIosPhonePortrait (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M335.7 32H177.1C158.8 32 144 46.6 144 64.9v381c0 18.4 14.8 34.1 33.1 34.1h158.5c18.3 0 32.3-15.7 32.3-34.1v-381C368 46.6 354 32 335.7 32zM241 55h30c2.2 0 4 1.8 4 4s-1.8 4-4 4h-30c-2.2 0-4-1.8-4-4s1.8-4 4-4zm15.5 410c-9.6 0-17.4-7.8-17.4-17.4 0-9.6 7.8-17.4 17.4-17.4 9.6 0 17.4 7.8 17.4 17.4 0 9.6-7.8 17.4-17.4 17.4zm93.5-49H162c-1.1 0-2-.9-2-2V85c0-1.1.9-2 2-2h188c1.1 0 2 .9 2 2v329c0 1.1-.9 2-2 2z"}}]})(props);
	};
	module.exports.IoIosPhotos = function IoIosPhotos (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 144H128c-17.6 0-32 14.4-32 32v240c0 17.6 14.4 32 32 32h336c17.6 0 32-14.4 32-32V176c0-17.6-14.4-32-32-32z"}},{"tag":"path","attr":{"d":"M100 116h332V96c0-17.6-14.4-32-32-32H48c-17.6 0-32 14.4-32 32v256c0 17.6 14.4 32 32 32h20V148c0-17.6 14.4-32 32-32z"}}]})(props);
	};
	module.exports.IoIosPie = function IoIosPie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M276 68.1v219c0 3.7-2.5 6.8-6 7.7L81.1 343.4c-2.3.6-3.6 3.1-2.7 5.4C109.1 426 184.9 480.6 273.2 480c114.6-.7 206.8-93.5 206.8-208 0-112.1-88.6-203.5-199.8-207.8-2.3-.1-4.2 1.7-4.2 3.9z"}},{"tag":"path","attr":{"d":"M32 239.3s.2 48.8 15.2 81.1c.8 1.8 2.8 2.7 4.6 2.2l193.8-49.7c3.5-.9 6.4-4.6 6.4-8.2V36c0-2.2-1.8-4-4-4C91 33.9 32 149 32 239.3z"}}]})(props);
	};
	module.exports.IoIosPin = function IoIosPin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c-79.5 0-144 59.9-144 133.7 0 104 144 282.3 144 282.3s144-178.3 144-282.3C400 107.9 335.5 48 256 48zm0 190.9c-25.9 0-46.9-21-46.9-46.9s21-46.9 46.9-46.9 46.9 21 46.9 46.9-21 46.9-46.9 46.9z"}}]})(props);
	};
	module.exports.IoIosPint = function IoIosPint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M372 175.2c0-19.5-1-81.7-19.3-115.6-4.5-8.2-9.5-11.6-28.7-11.6H188c-19.3 0-24.2 3.4-28.7 11.6-18.3 33.9-19.3 96.5-19.3 116 0 91 36 93.1 36 167.8 0 36.7-16 66.7-16 92.7 0 25.1 6 27.8 29 27.8h134c23 0 29-2.9 29-27.9 0-26-16-55.7-16-92.4 0-74.7 36-77.4 36-168.4zM188 76h136c2.4 0 4.3.1 5.7.2 5.4 11.6 9.4 29.3 11.8 50.8h-171c2.4-21.6 6.5-39.3 11.8-50.8 1.4-.1 3.3-.2 5.7-.2z"}}]})(props);
	};
	module.exports.IoIosPizza = function IoIosPizza (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M446.6 109.8c-2.7-7.3-14.2-14-25-18.7-27-11.6-73.5-27.1-164.9-27.1-94 0-137.5 14.5-165 27.1-12.3 5.7-24.2 12.5-26.7 19.5-2.9 8 .8 15.3 4.1 21.8l1.5 3c3.1 6.4 12.9 12.8 22.8 13.8L251.3 445c1 1.9 3.1 3.1 5.3 3.1 2.2 0 4.3-1.2 5.3-3.1l157.6-295.1c5.6-.6 17.2-2.6 23.1-14.3 3.9-7.7 7.4-16.7 4-25.8zm-266 112.8c-1.2 3.5-2.9 6.6-5.1 9.5-1.8 2.3-5.3 2-6.7-.6-8.8-16.6-17.3-32.4-24.8-46.5-1.4-2.6.5-5.8 3.4-5.9h1c3.7 0 7.3.6 10.9 1.7 8.6 2.8 15.5 8.7 19.6 16.6 3.9 7.9 4.6 16.8 1.7 25.2zm116.6 97.5c-.8 1.4-2.3 2.3-3.9 2.1-17-1.8-30.2-15.8-30.2-32.8 0-18.2 15.2-33 33.9-33 9.9 0 19 4 25.3 11 1.1 1.2 1.3 3.1.5 4.5l-25.6 48.2zm35.2-176.8c-5.7 4.1-12.4 6.3-19.5 6.3-1.6 0-3.3-.1-4.9-.3-8.7-1.2-16.3-5.7-21.5-12.5-2-2.6-3.6-5.5-4.6-8.4-1-2.7 1.2-5.5 4-5.3 18.3 1 35.3 2.9 51.4 5.9 3.1.6 4.5 4.1 2.7 6.7-2 2.8-4.6 5.4-7.6 7.6z"}}]})(props);
	};
	module.exports.IoIosPlanet = function IoIosPlanet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462.5 352.3c-1.9-5.5-5.6-11.5-11.4-18.3-10.2-12-30.8-29.3-54.8-47.2-2.6-2-6.4-.8-7.5 2.3l-4.7 13.4c-.7 2 0 4.3 1.7 5.5 15.9 11.6 35.9 27.9 41.8 35.9 2 2.8-.5 6.6-3.9 5.8-10-2.3-29-7.3-44.2-12.8-8.6-3.1-17.7-6.7-27.2-10.6 16-20.8 24.7-46.3 24.7-72.6 0-32.8-13.2-63.6-37.1-86.4-22.9-21.9-53.8-34.1-85.7-33.7-25.7.3-50.1 8.4-70.7 23.5-18.3 13.4-32.2 31.3-40.6 52-8.3-6-16.1-11.9-23.2-17.6-13.7-10.9-28.4-22-38.7-34.7-2.2-2.8.9-6.7 4.4-5.9 11.3 2.6 35.4 10.9 56.4 18.9 1.5.6 3.2.3 4.5-.8l11.1-10.1c2.4-2.1 1.7-6-1.3-7.2C121 137.4 89.2 128 73.2 128c-11.5 0-19.3 3.5-23.3 10.4-7.6 13.3 7.1 35.2 45.1 66.8 34.1 28.5 82.6 61.8 136.5 92 87.5 49.1 171.1 81 208 81 11.2 0 18.7-3.1 22.1-9.1 2.8-4.7 3.1-10.4.9-16.8zM312 354c-29.1-12.8-59.3-26-92.6-44.8-30.1-16.9-59.4-36.5-84.4-53.6-1-.7-2.2-1.1-3.4-1.1-.9 0-1.9.2-2.8.7-2 1-3.3 3-3.3 5.2 0 1.2-.1 2.4-.1 3.5 0 32.1 12.6 62.3 35.5 84.9 22.9 22.7 53.4 35.2 85.8 35.2 23.6 0 46.5-6.7 66.2-19.5 1.9-1.2 2.9-3.3 2.7-5.5-.1-2.2-1.5-4.1-3.6-5z"}}]})(props);
	};
	module.exports.IoIosPlayCircle = function IoIosPlayCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm83.8 211.9l-137.2 83c-2.9 1.8-6.7-.4-6.7-3.9V173c0-3.5 3.7-5.7 6.7-3.9l137.2 83c2.9 1.7 2.9 6.1 0 7.8z"}}]})(props);
	};
	module.exports.IoIosPlay = function IoIosPlay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 104.3v303.4c0 6.4 6.5 10.4 11.7 7.2l240.5-151.7c5.1-3.2 5.1-11.1 0-14.3L139.7 97.2c-5.2-3.3-11.7.7-11.7 7.1z"}}]})(props);
	};
	module.exports.IoIosPodium = function IoIosPodium (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 199.9v208.2c0 4.4 3.5 7.9 7.9 7.9h96.2c4.4 0 7.9-3.5 7.9-7.9V199.9c0-4.4-3.5-7.9-7.9-7.9H71.9c-4.4 0-7.9 3.5-7.9 7.9zM199.9 96c-4.4 0-7.9 3.5-7.9 7.9V416h120.1c4.4 0 7.9-3.5 7.9-7.9V103.9c0-4.4-3.5-7.9-7.9-7.9H199.9zM440.1 256h-96.2c-4.4 0-7.9 3.5-7.9 7.9v144.2c0 4.4 3.5 7.9 7.9 7.9h96.2c4.4 0 7.9-3.5 7.9-7.9V263.9c0-4.4-3.5-7.9-7.9-7.9z"}}]})(props);
	};
	module.exports.IoIosPower = function IoIosPower (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M380.4 111.7c-3.3-2.8-7.5-4.3-11.8-4.3-5.3 0-10.4 2.3-13.8 6.4-3.2 3.7-4.7 8.4-4.3 13.3.4 4.8 2.7 9.3 6.4 12.4 34.8 29.5 54.8 72.3 54.8 117.4 0 85.4-69.8 154.8-155.6 154.8s-155.6-69.5-155.6-154.8c0-45.2 20-88 54.8-117.4 3.7-3.1 6-7.5 6.4-12.4.4-4.8-1.1-9.6-4.3-13.3-3.5-4-8.5-6.4-13.8-6.4-4.3 0-8.5 1.5-11.8 4.3C88.7 148.1 64 201 64 256.8 64 362.2 150.1 448 256 448s192-85.8 192-191.2c0-55.8-24.7-108.7-67.6-145.1z"}},{"tag":"path","attr":{"d":"M256.9 274.5c10.2 0 18.5-8.3 18.5-18.5V82.5c0-10.2-8.3-18.5-18.5-18.5s-18.5 8.3-18.5 18.5V256c0 10.2 8.3 18.5 18.5 18.5z"}}]})(props);
	};
	module.exports.IoIosPricetag = function IoIosPricetag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M435.2 48H312.3c-3.8 0-7.5 1.5-10.2 4.2L56.4 297.9c-11.2 11.2-11.2 29.5 0 40.7l117 117c11.2 11.2 29.5 11.2 40.7 0L459.7 210c2.7-2.7 4.2-6.4 4.2-10.2v-123C464 60.9 451.1 48 435.2 48zm-47.7 111.8c-20.4 2.2-37.4-14.9-35.3-35.3 1.6-14.8 13.5-26.8 28.3-28.3 20.4-2.2 37.4 14.9 35.3 35.3-1.6 14.8-13.5 26.7-28.3 28.3z"}}]})(props);
	};
	module.exports.IoIosPricetags = function IoIosPricetags (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.3 32H285.1c-3.7 0-7.2 1.5-9.8 4.1L40.1 272.2c-10.8 10.8-10.8 28.4 0 39.2l111.5 112.5C162.4 434.7 179 440 195 426l231.9-232.3c2.6-2.6 4.1-6.1 4.1-9.8V59.7c0-15.3-12.4-27.7-27.7-27.7zm-45.9 107.5c-19.6 2.1-36-14.4-33.9-33.9 1.5-14.3 13-25.7 27.3-27.3 19.6-2.1 36 14.4 33.9 33.9-1.5 14.3-13 25.8-27.3 27.3z"}},{"tag":"path","attr":{"d":"M456 80.3V194c0 3.7-1.5 7.2-4.1 9.8L192.7 463l8.8 8.8c10.8 10.8 28.4 10.8 39.2 0l235.2-236.2c2.6-2.6 4.1-6.1 4.1-9.8V107.7c0-14-10.5-25.6-24-27.4z"}}]})(props);
	};
	module.exports.IoIosPrint = function IoIosPrint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 248v200c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM384 48H128c-8.8 0-16 7.2-16 16v20c0 2.2 1.8 4 4 4h280c2.2 0 4-1.8 4-4V64c0-8.8-7.2-16-16-16z"}},{"tag":"path","attr":{"d":"M432.5 112h-352C62.9 112 48 125.8 48 143.3v174.4c0 17.5 14.9 32.3 32.5 32.3H96c4.4 0 8-3.6 8-8V236c0-15.5 12.5-28 28-28h248c15.5 0 28 12.5 28 28v106c0 4.4 3.6 8 8 8h16.5c17.6 0 31.5-14.8 31.5-32.3V143.3c0-17.5-13.9-31.3-31.5-31.3z"}}]})(props);
	};
	module.exports.IoIosPulse = function IoIosPulse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434.6 272.1c-22.4-1.2-41.6 13.2-48.2 32.9h-38.9l-28.4-85.4c-2.2-6.6-8.3-11-15.2-11h-.3c-7 .1-13.1 4.8-15 11.6l-44.5 155.3-52.3-314.1c-1.2-7.5-7.6-13.1-15.2-13.4-7.6-.3-14.3 4.8-16.2 12.1l-53 244.9H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h72c7.3 0 13.8-5 15.5-12.1l37.4-182.2 51.3 307.9c1.2 7.4 7.4 12.9 14.9 13.3h.9c7.1 0 13.4-4.7 15.4-11.6l49.7-173.6 15.7 47.3c2.2 6.5 8.3 11 15.2 11h51.1c6.9 18 24.4 31 44.9 31 27 0 48.8-22.3 48-49.5-.8-24.8-20.7-45.1-45.4-46.4z"}}]})(props);
	};
	module.exports.IoIosQrScanner = function IoIosQrScanner (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M174 64h-58.8C78.1 64 48 94.1 48 131.2V190c0 7.7 6.3 14 14 14s14-6.3 14-14v-59.8c0-9.1 4.3-18.7 11.7-26.2 7.5-7.6 17.2-12 26.5-12H174c7.7 0 14-6.3 14-14s-6.3-14-14-14zM397.8 64H338c-7.7 0-14 6.3-14 14s6.3 14 14 14h59.8c9.3 0 19 4.4 26.5 12 7.4 7.5 11.7 17.1 11.7 26.2V190c0 7.7 6.3 14 14 14s14-6.3 14-14v-59.8c0-36.5-29.7-66.2-66.2-66.2zM174 420h-59.8c-9.3 0-19-4.4-26.5-12-7.4-7.5-11.7-17.1-11.7-26.2V322c0-7.7-6.3-14-14-14s-14 6.3-14 14v59.8c0 36.5 29.7 66.2 66.2 66.2H174c7.7 0 14-6.3 14-14s-6.3-14-14-14zM450 308c-7.7 0-14 6.3-14 14v59.8c0 9.1-4.3 18.7-11.7 26.2-7.5 7.6-17.2 12-26.5 12H338c-7.7 0-14 6.3-14 14s6.3 14 14 14h58.8c37 0 67.2-30.1 67.2-67.2V322c0-7.7-6.3-14-14-14z"}}]})(props);
	};
	module.exports.IoIosQuote = function IoIosQuote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M209 96h-65c-26.4 0-48 21.6-48 48v128c0 26.4 21.6 48 48 48h38.7c4.6 0 8.3 3.9 8 8.6-2.3 35.5-18.8 60.2-31.3 74.1-4.7 5.2-1 13.4 5.9 13.4h39.9c2.5 0 4.8-1.1 6.3-3.1 7.4-9.6 28.5-41.6 28.5-93.9v-192c0-17.8-13.3-31.1-31-31.1zM385 96h-65c-26.4 0-48 21.6-48 48v128c0 26.4 21.6 48 48 48h38.7c4.6 0 8.3 3.9 8 8.6-2.3 35.5-18.8 60.2-31.3 74.1-4.7 5.2-1 13.4 5.9 13.4h39.9c2.5 0 4.8-1.1 6.3-3.1 7.4-9.6 28.5-41.6 28.5-93.9v-192c0-17.8-13.3-31.1-31-31.1z"}}]})(props);
	};
	module.exports.IoIosRadioButtonOff = function IoIosRadioButtonOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosRadioButtonOn = function IoIosRadioButtonOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M363.5 148.5C334.8 119.8 296.6 104 256 104c-40.6 0-78.8 15.8-107.5 44.5C119.8 177.2 104 215.4 104 256s15.8 78.8 44.5 107.5C177.2 392.2 215.4 408 256 408c40.6 0 78.8-15.8 107.5-44.5C392.2 334.8 408 296.6 408 256s-15.8-78.8-44.5-107.5z"}}]})(props);
	};
	module.exports.IoIosRadio = function IoIosRadio (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M60 256c0-51 18.6-97.9 54-135.6 5.3-5.7 5.2-14.8-.4-20.3-2.6-2.6-6.1-4.1-9.7-4.1-3.8 0-7.4 1.6-10.1 4.4C53.3 143.7 32 197.4 32 256c0 58.5 21.3 112.3 61.7 155.5 2.7 2.9 6.3 4.5 10.2 4.5 3.6 0 7.1-1.4 9.7-3.9 2.7-2.6 4.3-6.2 4.4-10 .1-3.9-1.3-7.6-4-10.3C78.6 353.9 60 307 60 256zM418.2 100.4c-2.6-2.8-6.2-4.4-10-4.4-3.6 0-7.1 1.4-9.7 3.9-2.7 2.6-4.3 6.2-4.4 10-.1 3.9 1.3 7.6 4 10.3 35.3 37.8 54 84.7 54 135.7s-18.6 97.9-54 135.7c-5.3 5.6-5.2 14.7.3 20.2 2.5 2.6 6 4 9.7 4 3.9 0 7.6-1.6 10.2-4.6 40.4-43 61.7-96.7 61.7-155.2 0-58.5-21.3-112.4-61.8-155.6z"}},{"tag":"path","attr":{"d":"M159.2 347.7c-24.1-24.3-37.3-56.6-37.3-90.9 0-35 13.8-67.9 38.8-92.4 5.5-5.3 5.6-14.2.2-19.8-2.6-2.7-6.2-4.2-10-4.2-3.7 0-7.2 1.4-9.8 4C110.7 174.2 94 214.1 94 256.8c0 41.6 16.1 80.9 45.3 110.6 2.7 2.7 6.2 4.2 9.9 4.2s7.2-1.5 9.8-4.2c2.6-2.6 4.1-6.1 4.1-9.8.2-3.7-1.2-7.2-3.9-9.9zM371 144.5c-2.6-2.6-6-4-9.8-4-3.8 0-7.3 1.5-10 4.1-5.4 5.4-5.4 14.3.1 19.8 25 24.5 38.7 56.5 38.7 91.5 0 34.2-13.1 67.4-37.1 91.8-5.4 5.4-5.3 14.3.1 19.7 2.6 2.6 6.2 4.1 9.8 4.1 3.8 0 7.4-1.5 9.9-4.1C402 337.7 418 297.6 418 256c0-42.5-16.7-81.5-47-111.5z"}},{"tag":"path","attr":{"d":"M207.1 183.4c-2.6-2.7-6.2-4.2-10-4.2-3.7 0-7.2 1.4-9.8 4.1-19.8 19.5-30.8 45.6-30.8 73.3 0 27.1 10.5 52.7 29.5 72.1 2.7 2.7 6.2 4.2 10 4.2 3.7 0 7.2-1.4 9.8-4 2.7-2.6 4.2-6.1 4.2-9.9 0-3.8-1.4-7.3-4.1-10-13.8-14-21.4-32.6-21.4-52.5 0-20.3 8-39.2 22.4-53.4 5.4-5.2 5.5-14.1.2-19.7zM325.7 183.2c-2.6-2.6-6-4-9.8-4-3.8 0-7.3 1.5-10 4.1-5.4 5.4-5.4 14.3.1 19.8 14.5 14.3 22.4 33.3 22.4 53.5 0 19.8-7.6 38.5-21.5 52.5-2.6 2.6-4.1 6.2-4 9.9 0 3.7 1.5 7.2 4.1 9.8 2.6 2.6 6.2 4.1 9.8 4.1 3.7 0 7.3-1.5 9.9-4.2 19.1-19.4 29.6-45 29.6-72.1.1-27.8-10.8-53.8-30.6-73.4zM256 218c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17.1-38-38-38z"}}]})(props);
	};
	module.exports.IoIosRainy = function IoIosRainy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M433.9 175.6c-19-17.6-44.6-27.3-72.1-27.3h-5.6c-6.5-23.5-19.4-43.5-37.6-58.2C297.3 73 269.5 64 238.1 64c-32.7 0-63.2 11.7-86 32.9-22.8 21.2-35.5 50-36.1 81.4-17.5 4-33.6 13.7-46 27.9-14.2 16.2-22 36.6-22 57.4 0 44.6 34.9 82.6 77.4 86L101.2 382c-2.4 3.2-3.3 7.2-2.7 11.1.6 3.9 2.8 7.3 6 9.6 2.5 1.8 5.5 2.7 8.6 2.7 5.2 0 9.8-2.1 12.5-5.8l37.1-50h35.1l-55.3 75.1c-2.3 3.2-3.4 6.9-2.9 10.6.5 3.9 2.6 7.4 5.9 9.8 3.5 2.5 7.5 2.8 9 2.8 7.2 0 11.2-3.5 13.4-6.4l67.4-91.8H270L246 382c-2.4 3.3-3.4 7.2-2.7 11.1.6 3.9 2.8 7.3 6 9.6 2.5 1.8 5.5 2.7 8.6 2.7 5.2 0 9.8-2.1 12.5-5.8l37-50h35.1l-55.3 75.1c-2.3 3.2-3.4 7-2.9 10.6.5 3.8 2.6 7.2 5.9 9.6 2.6 1.9 5.9 3 8.9 3 5.1 0 9.7-2.2 12.5-6l69.7-95.1c22.4-4.5 43-16.6 58.1-34.5 15.9-18.8 24.7-42.6 24.7-67.1-.1-26.8-10.8-51.6-30.2-69.6z"}}]})(props);
	};
	module.exports.IoIosRecording = function IoIosRecording (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M386.2 146h-.1c-60.6 0-109.8 49.2-109.8 110.1 0 30.5 12.3 58 32.3 77.9H203.5c19.9-19.9 32.3-47.5 32.3-77.9 0-60.8-49.2-110.1-109.8-110.1h-.1-.1C65.2 146 16 195.2 16 256s49.2 110 109.8 110h260.4c60.6 0 109.8-49.2 109.8-110s-49.2-110-109.8-110zM464 256c0 43.1-34.9 78.2-77.9 78.2s-77.9-35.1-77.9-78.2 34.9-78.2 77.9-78.2S464 212.9 464 256zm-338.1 78.2C83 334.2 48 299.1 48 256s34.9-78.2 77.9-78.2 77.9 35.1 77.9 78.2-34.9 78.2-77.9 78.2z"}}]})(props);
	};
	module.exports.IoIosRedo = function IoIosRedo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 432h2.9c1.8 0 3.5-1.1 4.1-2.8 2.2-5.7 8.3-19.8 21.4-39.7 21.5-32.7 58.4-67.4 94.5-83.5 27.6-12.4 53-21.5 97.1-23.2 2.3-.1 4.2 1.7 4.2 4v81.6c0 3.2 3.6 5.1 6.2 3.4l215.9-142.2c2.4-1.6 2.4-5.1 0-6.7l-216-142.2c-2.7-1.8-6.2.1-6.2 3.4v82.6c0 2.2-1.7 3.9-3.8 4-71.6 3.8-123.1 24.8-163.4 65.5-61 61.6-56.8 139.1-56.8 158.7 0 10.3-.1 25.3-.1 37.1z"}}]})(props);
	};
	module.exports.IoIosRefreshCircle = function IoIosRefreshCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm0 336.1c-70.7 0-128-57.3-128-128.1s57.3-128.1 128-128.1v-37c0-6.4 7.1-10.2 12.4-6.7l72.9 52.6c4.9 3.3 4.7 10.6-.4 13.6L268 196.7c-5.3 3.1-12-.8-12-6.9v-41.9c-60.3 0-109.2 49.7-108.1 110.2 1.1 59.1 50.3 106.7 109.5 106 55.9-.7 101.8-43.7 106.3-99 .4-5.2 4.7-9.1 9.9-9.1 5.8 0 10.4 4.9 9.9 10.7-5.4 66-60.4 117.4-127.5 117.4z"}}]})(props);
	};
	module.exports.IoIosRefresh = function IoIosRefresh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M433 288.8c-7.7 0-14.3 5.9-14.9 13.6-6.9 83.1-76.8 147.9-161.8 147.9-89.5 0-162.4-72.4-162.4-161.4 0-87.6 70.6-159.2 158.2-161.4 2.3-.1 4.1 1.7 4.1 4v50.3c0 12.6 13.9 20.2 24.6 13.5L377 128c10-6.3 10-20.8 0-27.1l-96.1-66.4c-10.7-6.7-24.6.9-24.6 13.5v45.7c0 2.2-1.7 4-3.9 4C148 99.8 64 184.6 64 288.9 64 394.5 150.1 480 256.3 480c100.8 0 183.4-76.7 191.6-175.1.8-8.7-6.2-16.1-14.9-16.1z"}}]})(props);
	};
	module.exports.IoIosRemoveCircleOutline = function IoIosRemoveCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M346.5 240h-181c-8.8 0-16 6-16 16s7.5 16 16 16h181c8.8 0 16-7.2 16-16s-7.2-16-16-16z"}},{"tag":"path","attr":{"d":"M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoIosRemoveCircle = function IoIosRemoveCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm90.5 224h-181c-8.5 0-16-6-16-16s7.2-16 16-16h181c8.8 0 16 7.2 16 16s-7.2 16-16 16z"}}]})(props);
	};
	module.exports.IoIosRemove = function IoIosRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368.5 240h-225c-8.8 0-16 7.2-16 16 0 4.4 1.8 8.4 4.7 11.3 2.9 2.9 6.9 4.7 11.3 4.7h225c8.8 0 16-7.2 16-16s-7.2-16-16-16z"}}]})(props);
	};
	module.exports.IoIosReorder = function IoIosReorder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 304h352v16H80zM80 248h352v16H80zM80 192h352v16H80z"}}]})(props);
	};
	module.exports.IoIosRepeat = function IoIosRepeat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336.6 157.5L303 124.1c-3.5-3.5-8.5-4.9-13.6-3.6-1.2.3-2.4.8-3.5 1.5-4.7 2.9-7.2 7.8-6.8 13.1.2 3.4 1.9 6.6 4.3 9.1l16 15.9H142c-20.8 0-40.3 8.1-55.1 22.9C72.1 197.7 64 217.2 64 238v16c0 7.7 6.3 14 14 14s14-6.3 14-14v-16c0-13.3 5.2-25.8 14.7-35.3 9.5-9.5 22-14.7 35.3-14.7h155.4l-16 15.9c-2.4 2.4-4 5.4-4.3 8.7-.4 4.2 1.1 8.3 4.1 11.3 2.6 2.6 6.2 4.1 9.9 4.1s7.2-1.4 9.9-4.1l35.6-35.4c4.2-4.1 6.5-9.7 6.5-15.5-.1-5.9-2.4-11.4-6.5-15.5zM434 244c-7.7 0-14 6.3-14 14v16c0 13.3-5.2 25.8-14.7 35.3-9.5 9.5-22 14.7-35.3 14.7H214.6l16-15.9c2.4-2.4 4-5.4 4.3-8.8.4-4.2-1.1-8.3-4.1-11.3-2.6-2.6-6.2-4.1-9.9-4.1s-7.2 1.4-9.9 4.1l-35.6 35.4c-4.2 4.1-6.5 9.7-6.5 15.5 0 5.9 2.3 11.4 6.5 15.5l33.6 33.4c3.5 3.5 8.5 4.9 13.6 3.6 1.2-.3 2.4-.8 3.5-1.5 4.7-2.9 7.2-7.8 6.8-13.1-.2-3.4-1.9-6.6-4.3-9.1l-16-15.9H370c43 0 78-35 78-78v-16c0-7.5-6.3-13.8-14-13.8z"}}]})(props);
	};
	module.exports.IoIosResize = function IoIosResize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M418.3 80H307.8c-7.5 0-13.7 6.1-13.7 13.7v.2c0 7.5 6.1 13.7 13.7 13.7h76.5L107.6 384.3v-76.5c0-7.5-6.1-13.7-13.7-13.7h-.2c-7.5 0-13.7 6.1-13.7 13.7v110.5c0 7.5 6.1 13.7 13.7 13.7h110.5c7.5 0 13.7-6.1 13.7-13.7v-.2c0-7.5-6.1-13.7-13.7-13.7h-76.5l276.7-276.7v76.5c0 7.5 6.1 13.7 13.7 13.7h.2c7.5 0 13.7-6.1 13.7-13.7V93.7c0-7.6-6.1-13.7-13.7-13.7z"}}]})(props);
	};
	module.exports.IoIosRestaurant = function IoIosRestaurant (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 64c-24.8 0-48 77.3-48 160 0 57 32 80 32 80v128c0 8.8 7.2 16 16 16s16-7.2 16-16V75c0-11-11-11-16-11zM288 64l10 104c0 4.4-3.6 8-8 8s-8-3.6-8-8l-6-104h-8l-6 104c0 4.4-3.6 8-8 8s-8-3.6-8-8l10-104h-8s-24 107.2-24 128 13.4 38.6 32 45.2V432c0 8.8 7.2 16 16 16s16-7.2 16-16V237.2c18.6-6.6 32-24.2 32-45.2S296 64 296 64h-8zM160 64c-26.5 0-48 64-48 128 0 20.8 13.4 38.6 32 45.2V432c0 8.8 7.2 16 16 16s16-7.2 16-16V237.2c18.6-6.6 32-24.2 32-45.2 0-64-21.5-128-48-128z"}}]})(props);
	};
	module.exports.IoIosReturnLeft = function IoIosReturnLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M70.5 265.4l59.6-59.4c2.6-2.6 6.1-4.1 9.9-4.1 3.7 0 7.3 1.4 9.9 4.1 2.6 2.6 4.1 6.1 4.1 9.9s-1.5 7.3-4.1 9.9l-.1.1-41.1 40.1H370c13.2 0 25.8-5.2 35.3-14.7 9.5-9.4 14.7-21.9 14.7-35.3v-48c0-7.7 6.3-14 14-14s14 6.3 14 14v48c0 20.8-8.1 40.3-22.9 55.1-14.8 14.8-34.3 22.9-55.1 22.9H108.3l39.6 40.2c2.6 2.6 4.1 6.1 4.1 9.9 0 3.7-1.4 7.3-4.1 9.9l-.1.1c-2.7 2.5-6.2 3.9-9.8 3.9-3.9 0-7.3-1.4-9.9-4.1l-57.6-57.4c-4.2-4.2-6.5-9.8-6.5-15.7 0-5.8 2.3-11.3 6.5-15.4z"}}]})(props);
	};
	module.exports.IoIosReturnRight = function IoIosReturnRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M441.5 265.4L381.9 206c-2.6-2.6-6.1-4.1-9.9-4.1-3.7 0-7.3 1.4-9.9 4.1-2.6 2.6-4.1 6.1-4.1 9.9s1.5 7.3 4.1 9.9l.1.1 41.1 40.1H142c-13.2 0-25.8-5.2-35.3-14.7-9.5-9.5-14.7-22-14.7-35.3v-48c0-7.7-6.3-14-14-14s-14 6.3-14 14v48c0 20.8 8.1 40.3 22.9 55.1 14.8 14.8 34.3 22.9 55.1 22.9h261.7L364 334.2c-2.6 2.6-4.1 6.1-4.1 9.9 0 3.7 1.4 7.3 4.1 9.9l.1.1c2.7 2.5 6.2 3.9 9.8 3.9 3.9 0 7.3-1.4 9.9-4.1l57.6-57.4c4.2-4.2 6.5-9.8 6.5-15.7.1-5.8-2.2-11.3-6.4-15.4z"}}]})(props);
	};
	module.exports.IoIosReverseCamera = function IoIosReverseCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M417.5 160H363c-4.6 0-8.9-2-12-5.4-28.4-31.8-39.1-42.6-50.7-42.6h-85.5c-11.7 0-23.2 10.8-51.7 42.7-3 3.4-7.4 5.3-11.9 5.3h-4.1v-8c0-4.4-3.6-8-8-8h-26c-4.4 0-8 3.6-8 8v8h-7.5C79.9 160 64 173.2 64 190.7v176c0 17.5 15.9 33.3 33.5 33.3h320c17.6 0 30.5-15.8 30.5-33.3v-176c0-17.5-12.9-30.7-30.5-30.7zM308.3 340.5c-.8 2.5-2.6 4.6-4.8 6.1-14.1 9.7-30.5 14.8-47.5 14.8-21 0-41.2-8.1-57.1-22.7-14.6-13.5-24.1-31.2-27-50.2h-20.4c-3.2 0-6-2.8-5.6-6.6.1-.7.3-1.3.7-1.8l31.5-42.3c1.1-1.4 2.7-2.2 4.4-2.2 1.7 0 3.3.8 4.4 2.2l32.2 41.8c2 2.6 1.5 6.4-1.8 8.5-.6.4-1.2.5-1.9.5h-20.8c2.7 12.8 9.7 24.8 19.9 34 11.6 10.6 26.3 16.4 41.4 16.4 12.3 0 24.4-4 35.1-11.5 1.9-1.3 4.2-2.1 6.5-2.1 3.2 0 6.2 1.3 8.3 3.7 2.9 3 3.9 7.3 2.5 11.4zm56.6-67.5l-31.2 42.9c-1.8 2.5-5.5 3.2-8.3.8-.2-.2-.4-.4-.5-.6L292.5 273c-2-2.6-1.4-6.5 1.9-8.5.6-.3 1.2-.5 1.9-.5h21c-2.7-13.6-9.7-26.1-19.9-35.6-11.5-10.7-26.2-16.6-41.3-16.6-12.5 0-24.6 3.9-35.2 11.3-1.9 1.3-4.1 2-6.4 2-3.1 0-6.1-1.3-8.2-3.6-2.8-3-3.8-7.4-2.5-11.5.8-2.5 2.6-4.6 4.7-6 14.1-9.7 30.6-14.8 47.6-14.8 21.7 0 42.2 7.9 57.8 22.3 13.3 12.3 23.2 32.1 26.2 52.4h21.1c.6 0 1.3.2 1.8.5 3.2 2.1 3.8 6 1.9 8.6z"}}]})(props);
	};
	module.exports.IoIosRewind = function IoIosRewind (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M35.9 249.3L244 129.1c5.4-3.1 12.3.6 12.3 6.7V251l211.3-121.9c5.4-3.1 12.3.6 12.3 6.7v240.3c0 6.1-6.9 9.8-12.3 6.7L256.4 261v115.2c0 6.1-6.9 9.8-12.3 6.7L35.9 262.7c-5.2-3-5.2-10.4 0-13.4z"}}]})(props);
	};
	module.exports.IoIosRibbon = function IoIosRibbon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M254.9 293.4c73 .6 132.3-58.7 131.7-131.8-.6-69.9-59.7-129-129.5-129.6-73-.6-132.3 58.7-131.7 131.8.6 69.9 59.7 129 129.5 129.6zm-3.7-204.1c44.3-2.8 80.9 33.8 78.1 78.2-2.3 36.6-31.9 66.2-68.5 68.6-44.3 2.8-80.9-33.8-78.1-78.2 2.3-36.6 31.9-66.2 68.5-68.6z"}},{"tag":"path","attr":{"d":"M256 308.4c-42.8 0-81.4-18.1-108.5-47-1.9-2-5.2-1.7-6.6.7L65.1 394.8c-3.1 5.5.8 12.3 7.2 12.3h80.1c2.9 0 5.6 1.5 7.1 4l39 64.9c3.4 5.7 11.8 5.2 14.6-.8l43-94.6 31.3-68.9c1.4-3-1.2-6.3-4.5-5.7-8.8 1.5-17.7 2.4-26.9 2.4zM364.5 261.3c-14.6 15.5-32.4 28-52.5 36.1-1 .4-1.8 1.1-2.2 2.1l-44.7 97.7c-.5 1.1-.5 2.3 0 3.4l33.9 74.5c2.7 6 11.2 6.5 14.6.8l39-64.9c1.5-2.5 4.2-4 7.1-4h80.1c6.3 0 10.3-6.8 7.2-12.3l-75.8-132.8c-1.5-2.2-4.8-2.6-6.7-.6z"}}]})(props);
	};
	module.exports.IoIosRocket = function IoIosRocket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.8 53.6c-.4-1.7-1.6-3-3.3-3.4-54.4-13.3-180.1 34.1-248.2 102.2-13.3 13.3-24.2 26.4-33.1 39.1-21-1.9-42-.3-59.9 7.5-50.5 22.2-65.2 80.2-69.3 105.1-1 5.9 3.9 11 9.8 10.4l81.1-8.9c.1 7.8.6 14 1.1 18.3.4 4.2 2.3 8.1 5.3 11.1l31.4 31.4c3 3 6.9 4.9 11.1 5.3 4.3.5 10.5 1 18.2 1.1l-8.9 81c-.6 5.9 4.5 10.8 10.4 9.8 24.9-4 83-18.7 105.1-69.2 7.8-17.9 9.4-38.8 7.6-59.7 12.7-8.9 25.9-19.8 39.2-33.1 68.4-68 115.5-190.9 102.4-248zM298.6 213.5c-16.7-16.7-16.7-43.7 0-60.4 16.7-16.7 43.7-16.7 60.4 0 16.7 16.7 16.7 43.7 0 60.4-16.7 16.7-43.7 16.7-60.4 0z"}},{"tag":"path","attr":{"d":"M174.5 380.5c-4.2 4.2-11.7 6.6-19.8 8-18.2 3.1-34.1-12.8-31-31 1.4-8.1 3.7-15.6 7.9-19.7l.1-.1c2.3-2.3.4-6.1-2.8-5.7-9.8 1.2-19.4 5.6-26.9 13.1-18 18-19.7 84.8-19.7 84.8s66.9-1.7 84.9-19.7c7.6-7.6 11.9-17.1 13.1-26.9.3-3.2-3.6-5.1-5.8-2.8z"}}]})(props);
	};
	module.exports.IoIosRose = function IoIosRose (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 141.1c-18.9 3.9-36.8 8.2-53.7 12.8-40.5 11-75.5 24.9-105.4 38.2-19.3 8.6-26.2 12.4-51.5 25.9C147 248.9 112 289 112 349c0 67.8 55.6 115 144 115s144-51.2 144-119c0-67.7-61-114.7 16-203.9zM135.4 241.8c12.8-10.5 31.2-23.9 56.1-38.4 6.4-3.8 13.3-7.6 20.6-11.4 11.6-6.1 23.5-11.9 35.8-17.4-9.1-10.1-22.1-19.1-36.6-27C162.6 121.1 96 107.4 96 107.4c41.5 43.7 44.6 96.5 39.4 134.4zM352 77.7s-73.8-.9-125.8 55c0 0 27.7 17.3 42.7 32.3 37.2-15.6 82.3-28.6 115.2-36-6.5-21.7-32.1-51.3-32.1-51.3zM239.7 97C210.3 59.5 176 48 176 48c-15.3 20.8-24.3 38-29 51.7 21.1 5.9 36.5 12.3 62.4 24.7 9.5-10.6 18.1-19.1 30.3-27.4z"}}]})(props);
	};
	module.exports.IoIosSad = function IoIosSad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256c0 114.7 93.3 208 208 208 114.9 0 208-93.1 208-208 0-114.7-93.3-208-208-208zm-73.9 152.1c14.8-1.2 27 11.1 25.9 25.9-.9 11.6-10.3 21.1-22 22-14.8 1.2-27-11.1-25.9-25.9.9-11.7 10.3-21.1 22-22zm-.7 151.9c-11.5 0-19.3-11.8-14.7-22.4 15-34.5 49.2-58.6 89.3-58.6s74.2 24.1 89.3 58.6c4.6 10.6-3.1 22.4-14.7 22.4 0 0-34.7-4-73.1-4-38.5 0-76.1 4-76.1 4zm148.5-104.1c-14.8 1.2-27-11.1-25.9-25.9.9-11.6 10.3-21.1 22-22 14.8-1.2 27 11.1 25.9 25.9-.9 11.7-10.3 21.1-22 22z"}}]})(props);
	};
	module.exports.IoIosSave = function IoIosSave (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272 64h-16c-4.4 0-8 3.6-8 8v72c0 4.4 7.6 8 12 8h12c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8z"}},{"tag":"path","attr":{"d":"M433.9 130.1L382 78.2c-9-9-21.3-14.2-34.1-14.2h-28c-8.8 0-16 7.3-16 16.2v80c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16v-80c0-8.8-7.2-16.2-16-16.2H96c-17.6 0-32 14.4-32 32v320c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V164c0-12.7-5.1-24.9-14.1-33.9zM322 400.1c0 8.8-8 16-17.8 16H143.8c-9.8 0-17.8-7.2-17.8-16v-96c0-8.8 8-16 17.8-16h160.4c9.8 0 17.8 7.2 17.8 16v96z"}}]})(props);
	};
	module.exports.IoIosSchool = function IoIosSchool (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96.9 270.3V363c0 2.9 1.5 5.5 4 7l132 75.9c5.3 3.1 12-.8 12-7v-93.8c0-2.9-1.5-5.5-4-7l-132-74.9c-5.4-2.9-12 1-12 7.1zM280.9 445.9L413 370c2.5-1.4 4-4.1 4-7v-93.7c0-6.2-6.6-10-12-7l-132 75.9c-2.5 1.4-4 4.1-4 7V439c-.1 6.1 6.6 10 11.9 6.9z"}},{"tag":"path","attr":{"d":"M249 65.1L37 188.9c-5.4 3.1-5.4 10.8 0 13.9l212 117.8c4.9 2.8 11 2.8 15.9 0L453 212.9c5.3-3.1 7 .8 7 7v153.4c0 6.8 3.9 10 11 10 4.4 0 10-3.2 10-10V201.5c0-2.9-1.5-5.5-4-7L264.9 65.1c-4.9-2.8-11-2.8-15.9 0z"}}]})(props);
	};
	module.exports.IoIosSearch = function IoIosSearch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M443.5 420.2L336.7 312.4c20.9-26.2 33.5-59.4 33.5-95.5 0-84.5-68.5-153-153.1-153S64 132.5 64 217s68.5 153 153.1 153c36.6 0 70.1-12.8 96.5-34.2l106.1 107.1c3.2 3.4 7.6 5.1 11.9 5.1 4.1 0 8.2-1.5 11.3-4.5 6.6-6.3 6.8-16.7.6-23.3zm-226.4-83.1c-32.1 0-62.3-12.5-85-35.2-22.7-22.7-35.2-52.9-35.2-84.9 0-32.1 12.5-62.3 35.2-84.9 22.7-22.7 52.9-35.2 85-35.2s62.3 12.5 85 35.2c22.7 22.7 35.2 52.9 35.2 84.9 0 32.1-12.5 62.3-35.2 84.9-22.7 22.7-52.9 35.2-85 35.2z"}}]})(props);
	};
	module.exports.IoIosSend = function IoIosSend (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M435.9 64.9l-367.1 160c-6.5 3.1-6.3 12.4.3 15.3l99.3 56.1c5.9 3.3 13.2 2.6 18.3-1.8l195.8-168.8c1.3-1.1 4.4-3.2 5.6-2 1.3 1.3-.7 4.3-1.8 5.6L216.9 320.1c-4.7 5.3-5.4 13.1-1.6 19.1l64.9 104.1c3.2 6.3 12.3 6.2 15.2-.2L447.2 76c3.3-7.2-4.2-14.5-11.3-11.1z"}}]})(props);
	};
	module.exports.IoIosSettings = function IoIosSettings (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416.3 256c0-21 13.1-38.9 31.7-46.1-4.9-20.5-13-39.7-23.7-57.1-6.4 2.8-13.2 4.3-20.1 4.3-12.6 0-25.2-4.8-34.9-14.4-14.9-14.9-18.2-36.8-10.2-55-17.3-10.7-36.6-18.8-57-23.7C295 82.5 277 95.7 256 95.7S217 82.5 209.9 64c-20.5 4.9-39.7 13-57.1 23.7 8.1 18.1 4.7 40.1-10.2 55-9.6 9.6-22.3 14.4-34.9 14.4-6.9 0-13.7-1.4-20.1-4.3C77 170.3 68.9 189.5 64 210c18.5 7.1 31.7 25 31.7 46.1 0 21-13.1 38.9-31.6 46.1 4.9 20.5 13 39.7 23.7 57.1 6.4-2.8 13.2-4.2 20-4.2 12.6 0 25.2 4.8 34.9 14.4 14.8 14.8 18.2 36.8 10.2 54.9 17.4 10.7 36.7 18.8 57.1 23.7 7.1-18.5 25-31.6 46-31.6s38.9 13.1 46 31.6c20.5-4.9 39.7-13 57.1-23.7-8-18.1-4.6-40 10.2-54.9 9.6-9.6 22.2-14.4 34.9-14.4 6.8 0 13.7 1.4 20 4.2 10.7-17.4 18.8-36.7 23.7-57.1-18.4-7.2-31.6-25.1-31.6-46.2zm-159.4 79.9c-44.3 0-80-35.9-80-80s35.7-80 80-80 80 35.9 80 80-35.7 80-80 80z"}}]})(props);
	};
	module.exports.IoIosShareAlt = function IoIosShareAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M444.7 230.4l-141.1-132c-1.7-1.6-3.3-2.5-5.6-2.4-4.4.2-10 3.3-10 8v66.2c0 2-1.6 3.8-3.6 4.1C144.1 195.8 85 300.8 64.1 409.8c-.8 4.3 5 8.3 7.7 4.9 51.2-64.5 113.5-106.6 212-107.4 2.2 0 4.2 2.6 4.2 4.8v65c0 7 9.3 10.1 14.5 5.3l142.1-134.3c2.6-2.4 3.4-5.2 3.5-8.4-.1-3.2-.9-6.9-3.4-9.3z"}}]})(props);
	};
	module.exports.IoIosShare = function IoIosShare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 176H269v146.6c0 7-5.4 13-12.4 13.4-7.5.4-13.6-5.6-13.6-13V176H136c-22 0-40 18-40 40v208c0 22 18 40 40 40h240c22 0 40-18 40-40V216c0-22-18-40-40-40zM269 92.1l47.9 47.2c5.1 5 13.3 5 18.4-.1 5-5.1 5-13.3-.1-18.4l-70-69c-2.5-2.4-5.8-3.7-9.1-3.7-1.7 0-3.4.3-5 1-1.5.6-2.9 1.6-4.1 2.7l-70 69c-5.1 5-5.2 13.3-.1 18.4 5 5.1 13.3 5.2 18.4.1L243 92.1V176h26V92.1z"}}]})(props);
	};
	module.exports.IoIosShirt = function IoIosShirt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.8 181.7c1.3-1.6 1.2-3.8-.2-5.3-11.5-12.1-61.3-63.7-89.1-83.7C352 78 332 64 310 64s-22 8-54 8-32-8-54-8-42 14-62.5 28.7c-27.8 20-77.6 71.6-89.1 83.7-1.4 1.5-1.5 3.7-.2 5.3l61.7 64c2.4 2.9 7.1 1.2 7.1-2.5v-44.9c0-4.5 3.2-8.5 7.6-9.2 5.6-.9 10.4 3.5 10.4 8.9v242c0 4.4 3.6 8 8 8h222c4.4 0 8-3.6 8-8V198.3c0-4.5 3.2-8.5 7.6-9.2 5.6-.9 10.4 3.5 10.4 8.9v45.2c0 3.8 4.7 5.4 7.1 2.5l61.7-64zM256 143c-30 0-54-12.7-54-36 0-30 24-10.7 54-10.7 29.8 0 54-19.3 54 10.7 0 23.3-24.2 36-54 36z"}}]})(props);
	};
	module.exports.IoIosShuffle = function IoIosShuffle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.9 288.1c-2.6-2.6-6.2-4.1-9.9-4.1s-7.2 1.4-9.9 4.1c-2.7 2.6-4.1 6.2-4.1 9.9s1.5 7.2 4.1 9.9l16.3 16.2h-75.5l-124-155-.1-.1c-2.6-3.1-6.7-5-10.8-5H78c-7.7 0-14 6.3-14 14s6.3 14 14 14h107.4l52.5 66-52.5 66H78c-7.7 0-14 6.3-14 14s6.3 14 14 14h114c4.1 0 8-1.8 10.7-5l.1-.1 53.2-66.8 53.2 66.8.1.1c2.7 3.2 6.6 5 10.7 5h84.4l-16.3 16.2c-2.7 2.6-4.1 6.1-4.1 9.9 0 3.7 1.5 7.2 4.1 9.9 2.6 2.6 6.2 4.1 9.9 4.1s7.2-1.4 9.9-4.1l33.6-33.4c4.2-4.1 6.5-9.6 6.5-15.5s-2.3-11.4-6.5-15.5l-35.6-35.5z"}},{"tag":"path","attr":{"d":"M279.4 235.4c1.1 1.4 2.8 2.1 4.6 2.1h.1c1.8 0 3.5-.8 4.6-2.2l37.9-47.3h75.8l-16.3 16.2c-2.7 2.6-4.1 6.1-4.1 9.9 0 3.7 1.5 7.2 4.1 9.9 2.6 2.6 6.2 4.1 9.9 4.1s7.2-1.4 9.9-4.1l35.6-35.4c4.2-4.1 6.5-9.7 6.5-15.5 0-5.9-2.3-11.4-6.5-15.5l-33.6-33.4c-2.6-2.6-6.2-4.1-9.9-4.1s-7.2 1.4-9.9 4.1c-2.7 2.6-4.1 6.2-4.1 9.9s1.5 7.2 4.1 9.9l16.3 16.2H320c-4.1 0-8 1.8-10.7 5l-.1.1-40.3 50.2c-1.8 2.2-1.8 5.4.1 7.6l10.4 12.3z"}}]})(props);
	};
	module.exports.IoIosSkipBackward = function IoIosSkipBackward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M175 100v137.8L403.9 98.1c5.3-3.1 12.1.7 12.1 6.9v302c0 6.2-6.7 10-12.1 6.9L175 274.2V412c0 2.2-1.8 4-4 4h-71c-2.2 0-4-1.8-4-4V100c0-2.2 1.8-4 4-4h71c2.2 0 4 1.8 4 4z"}}]})(props);
	};
	module.exports.IoIosSkipForward = function IoIosSkipForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M337 100v137.8L108.1 98.1C102.7 95 96 98.8 96 105v302c0 6.2 6.7 10 12.1 6.9L337 274.2V412c0 2.2 1.8 4 4 4h71c2.2 0 4-1.8 4-4V100c0-2.2-1.8-4-4-4h-71c-2.2 0-4 1.8-4 4z"}}]})(props);
	};
	module.exports.IoIosSnow = function IoIosSnow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.5 345.8L408.1 327c11.8-12.3 26-18.2 26.2-18.3 7.5-3 11.4-11.4 8.9-19.1-1.9-5.9-7.4-9.8-13.5-9.8-1.9 0-3.7.4-5.5 1.1-1 .4-24.4 10-41.9 31.2l-96.3-56 96.3-56c17.5 21.2 40.8 30.8 41.9 31.2 1.8.7 3.6 1.1 5.5 1.1 6.1 0 11.6-4 13.5-9.8 2.5-7.7-1.4-16.1-8.9-19.1-.1-.1-14.3-6-26.2-18.3l32.4-18.8c7.2-4.2 9.6-13.4 5.5-20.6-2.7-4.7-7.7-7.6-13.1-7.6-2.6 0-5.3.7-7.6 2L393.1 159c-4.5-16.2-2.7-31.4-2.6-32 1.1-8.1-4.1-15.6-12-17.3-1-.2-2-.3-3-.3-7.1 0-13 5.2-14.1 12.4-.2 1.1-3.6 26 6.1 52.2l-96 56v-99.2c26.9-4.7 46.8-20.2 47.7-20.9 3.1-2.5 5.1-6 5.4-10 .3-4-.9-7.8-3.6-10.8-2.9-3.2-7-5.1-11.4-5.1-3.4 0-6.8 1.2-9.5 3.3-.1.1-12.2 9.4-28.6 13.6V63.1c0-8.2-7.1-15.1-15.5-15.1s-15.5 6.9-15.5 15.1v37.5c-16.3-4.2-28.4-13.5-28.6-13.6-2.7-2.1-6-3.3-9.5-3.3-4.4 0-8.5 1.9-11.4 5.1-2.7 3-4 7-3.6 10.9.3 3.9 2.3 7.4 5.4 9.9.9.7 20.8 16.2 47.7 20.9v99.2l-96-56c9.6-26 6.2-51.1 6-52.2-1-7.2-6.9-12.4-14-12.4-1 0-2 .1-3 .3-7.9 1.6-13.2 9.3-12 17.3 0 .2 2 15.5-2.6 31.9L86.6 140c-2.3-1.3-4.9-2-7.6-2-5.4 0-10.4 2.9-13.1 7.6-4.1 7.2-1.7 16.5 5.5 20.6l32.4 18.8c-11.7 12.1-25.7 18.1-26.2 18.3-7.5 3-11.4 11.4-8.9 19.1 1.9 5.9 7.4 9.8 13.5 9.8 1.9 0 3.7-.4 5.5-1.1 1-.4 24.4-10 41.9-31.2l96.3 56-96.3 56c-17.5-21.2-40.8-30.8-41.9-31.2-1.8-.7-3.6-1.1-5.5-1.1-6.1 0-11.6 4-13.5 9.8-2.5 7.7 1.4 16 8.9 19.1.5.2 14.5 6.2 26.2 18.3l-32.4 18.8c-7.2 4.2-9.6 13.4-5.5 20.6 2.7 4.7 7.7 7.6 13.1 7.6 2.6 0 5.3-.7 7.6-2l32.3-18.8c4.6 16.5 2.6 31.8 2.6 32-1.2 8 4.1 15.7 12 17.3 1 .2 2 .3 3 .3 7.1 0 13-5.2 14.1-12.4.2-1.1 3.6-26-6.1-52.2l96-56v99.2c-26.9 4.7-46.8 20.2-47.7 20.9-3.1 2.5-5.1 6-5.4 10-.3 4 .9 7.8 3.6 10.8 2.9 3.2 7 5.1 11.4 5.1 3.4 0 6.8-1.2 9.5-3.3.1-.1 12.3-9.4 28.6-13.6v37.5c0 8.2 7.1 15.1 15.5 15.1s15.5-6.9 15.5-15.1v-37.5c16.3 4.2 28.4 13.5 28.6 13.6 2.7 2.1 6.1 3.3 9.5 3.3 4.4 0 8.5-1.9 11.4-5.1 2.7-3 4-7 3.6-10.9-.3-3.9-2.3-7.4-5.4-9.9-.9-.7-20.8-16.2-47.7-20.9V282l96 56c-9.6 26-6.2 51.1-6 52.2 1 7.2 6.9 12.4 14 12.4 1 0 2-.1 3-.3 7.9-1.6 13.1-9.2 12-17.3-.1-.5-1.9-15.7 2.6-32l32.2 18.8c2.3 1.3 4.9 2 7.6 2 5.4 0 10.4-2.9 13.1-7.6 4.1-6.9 1.7-16.2-5.5-20.4z"}}]})(props);
	};
	module.exports.IoIosSpeedometer = function IoIosSpeedometer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"}}]})(props);
	};
	module.exports.IoIosSquareOutline = function IoIosSquareOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M388 96H124c-15.4 0-28 12.6-28 28v264c0 15.4 12.6 28 28 28h264c15.4 0 28-12.6 28-28V124c0-15.4-12.6-28-28-28zm0 284c0 4.4-3.6 8-8 8H132c-4.4 0-8-3.6-8-8V132c0-4.4 3.6-8 8-8h248c4.4 0 8 3.6 8 8v248z"}}]})(props);
	};
	module.exports.IoIosSquare = function IoIosSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M388 416H124c-15.4 0-28-12.6-28-28V124c0-15.4 12.6-28 28-28h264c15.4 0 28 12.6 28 28v264c0 15.4-12.6 28-28 28z"}}]})(props);
	};
	module.exports.IoIosStarHalf = function IoIosStarHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M463 192H315.9L271.2 58.6C269 52.1 262.9 48 256 48s-13 4.1-15.2 10.6L196.1 192H48c-8.8 0-16 7.2-16 16 0 .9.1 1.9.3 2.7.2 3.5 1.8 7.4 6.7 11.3l120.9 85.2-46.4 134.9c-2.3 6.5 0 13.8 5.5 18 2.9 2.1 5.6 3.9 9 3.9 3.3 0 7.2-1.7 10-3.6l118-84.1 118 84.1c2.8 2 6.7 3.6 10 3.6 3.4 0 6.1-1.7 8.9-3.9 5.6-4.2 7.8-11.4 5.5-18L352 307.2l119.9-86 2.9-2.5c2.6-2.8 5.2-6.6 5.2-10.7 0-8.8-8.2-16-17-16zm-47.4 35.2l-79.8 57.3c-10 7.2-14.2 20.2-10.2 31.8l30.1 87.7c1.3 3.7-2.9 6.8-6.1 4.6l-77.4-55.2-.1-.1c-10-7-16.1-18.3-16.1-30.5V113.3c0-2.2 3.1-2.7 3.8-.6l29.6 88.2c3.8 11.4 14.5 19.1 26.5 19.1h97.3c3.9 0 5.5 5 2.4 7.2z"}}]})(props);
	};
	module.exports.IoIosStarOutline = function IoIosStarOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M463 192H315.9L271.2 58.6C269 52.1 262.9 48 256 48s-13 4.1-15.2 10.6L196.1 192H48c-8.8 0-16 7.2-16 16 0 .9.1 1.9.3 2.7.2 3.5 1.8 7.4 6.7 11.3l120.9 85.2-46.4 134.9c-2.3 6.5 0 13.8 5.5 18 2.9 2.1 5.6 3.9 9 3.9 3.3 0 7.2-1.7 10-3.6l118-84.1 118 84.1c2.8 2 6.7 3.6 10 3.6 3.4 0 6.1-1.7 8.9-3.9 5.6-4.2 7.8-11.4 5.5-18L352 307.2l119.9-86 2.9-2.5c2.6-2.8 5.2-6.6 5.2-10.7 0-8.8-8.2-16-17-16zm-127.2 92.5c-10 7.2-14.2 20.2-10.2 31.8l30.1 87.7c1.3 3.7-2.9 6.8-6.1 4.6l-77.4-55.2c-4.9-3.5-10.6-5.2-16.3-5.2-5.7 0-11.4 1.7-16.2 5.2l-77.4 55.1c-3.2 2.3-7.4-.9-6.1-4.6l30.1-87.7c4-11.8-.2-24.8-10.3-32l-81-57.1c-3.2-2.2-1.6-7.3 2.3-7.3H196c12 0 22.7-7.7 26.5-19.1l29.6-88.2c1.2-3.6 6.4-3.6 7.6 0l29.6 88.2c3.8 11.4 14.5 19.1 26.5 19.1h97.3c3.9 0 5.5 5 2.3 7.2l-79.6 57.5z"}}]})(props);
	};
	module.exports.IoIosStar = function IoIosStar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M463 192H315.9L271.2 58.6C269 52.1 262.9 48 256 48s-13 4.1-15.2 10.6L196.1 192H48c-8.8 0-16 7.2-16 16 0 .9.1 1.9.3 2.7.2 3.5 1.8 7.4 6.7 11.3l120.9 85.2-46.4 134.9c-2.3 6.5 0 13.8 5.5 18 2.9 2.1 5.6 3.9 9 3.9 3.3 0 7.2-1.7 10-3.6l118-84.1 118 84.1c2.8 2 6.7 3.6 10 3.6 3.4 0 6.1-1.7 8.9-3.9 5.6-4.2 7.8-11.4 5.5-18L352 307.2l119.9-86 2.9-2.5c2.6-2.8 5.2-6.6 5.2-10.7 0-8.8-8.2-16-17-16z"}}]})(props);
	};
	module.exports.IoIosStats = function IoIosStats (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M184 448h48c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v368c0 4.4 3.6 8 8 8zM88 448h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zM280.1 448h47.8c4.5 0 8.1-3.6 8.1-8.1V232.1c0-4.5-3.6-8.1-8.1-8.1h-47.8c-4.5 0-8.1 3.6-8.1 8.1v207.8c0 4.5 3.6 8.1 8.1 8.1zM368 136.1v303.8c0 4.5 3.6 8.1 8.1 8.1h47.8c4.5 0 8.1-3.6 8.1-8.1V136.1c0-4.5-3.6-8.1-8.1-8.1h-47.8c-4.5 0-8.1 3.6-8.1 8.1z"}}]})(props);
	};
	module.exports.IoIosStopwatch = function IoIosStopwatch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M415.9 143.7c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L413 95.6c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l25.5 25.5zM84.8 143.7c3.1 3.1 8.2 3.1 11.3 0l25.5-25.5c3.1-3.1 3.1-8.2 0-11.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0L73.5 121c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.4z"}},{"tag":"path","attr":{"d":"M280 81.5V64c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v17.5C137.3 93.3 64 174.1 64 272c0 106 86 192 192 192s192-86 192-192c0-97.9-73.3-178.7-168-190.5zm-10 219.3V320c0 7.7-6.3 14-14 14s-14-6.3-14-14v-19.2c-10.7-5.2-18-16.1-18-28.8s7.3-23.6 18-28.8V144c0-7.7 6.3-14 14-14s14 6.3 14 14v99.2c10.7 5.2 18 16.1 18 28.8s-7.3 23.6-18 28.8z"}}]})(props);
	};
	module.exports.IoIosSubway = function IoIosSubway (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 32H160c-35.2 0-64 28.8-64 64v232c0 35.2 28.8 64 64 64h192c35.2 0 64-28.8 64-64V96c0-35.2-28.8-64-64-64zM200 56h112c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-32 304c-15.5 0-28-12.5-28-28s12.5-28 28-28 28 12.5 28 28-12.5 28-28 28zm176 0c-15.5 0-28-12.5-28-28s12.5-28 28-28 28 12.5 28 28-12.5 28-28 28zm40-152c0 8.8-7.2 16-16 16H144.2c-8.8 0-16.2-7.2-16.2-16v-95.8c0-8.8 7.4-16.2 16.2-16.2H368c8.8 0 16 7.4 16 16.2V208zM393.7 455.9l-50-48c-5.6-5.4-14.4-5.2-19.8.4-5.4 5.6-5.2 14.4.4 19.8l6.1 5.9H181.5l6.1-5.9c5.6-5.4 5.8-14.2.4-19.8-5.4-5.6-14.2-5.8-19.8-.4l-50 48c-5.6 5.4-5.8 14.2-.4 19.8 2.7 2.9 6.4 4.3 10.1 4.3 3.5 0 7-1.3 9.7-3.9l14.7-14.1h207.2l14.7 14.1c2.7 2.6 6.2 3.9 9.7 3.9 3.7 0 7.4-1.4 10.1-4.3 5.5-5.6 5.3-14.4-.3-19.8z"}}]})(props);
	};
	module.exports.IoIosSunny = function IoIosSunny (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 387c-8.5 0-15.4 6.9-15.4 15.4v46.2c0 8.5 6.9 15.4 15.4 15.4s15.4-6.9 15.4-15.4v-46.2c0-8.5-6.9-15.4-15.4-15.4zM256 48c-8.5 0-15.4 6.9-15.4 15.4v46.2c0 8.5 6.9 15.4 15.4 15.4s15.4-6.9 15.4-15.4V63.4c0-8.5-6.9-15.4-15.4-15.4zM125 256c0-8.5-6.9-15.4-15.4-15.4H63.4c-8.5 0-15.4 6.9-15.4 15.4s6.9 15.4 15.4 15.4h46.2c8.5 0 15.4-6.9 15.4-15.4zM448.6 240.6h-46.2c-8.5 0-15.4 6.9-15.4 15.4s6.9 15.4 15.4 15.4h46.2c8.5 0 15.4-6.9 15.4-15.4s-6.9-15.4-15.4-15.4zM152.5 344.1c-4.1 0-8 1.6-10.9 4.5l-32.7 32.7c-2.9 2.9-4.5 6.8-4.5 10.9s1.6 8 4.5 10.9c2.9 2.9 6.8 4.5 10.9 4.5 4.1 0 8-1.6 10.9-4.5l32.7-32.7c6-6 6-15.8 0-21.8-2.9-2.9-6.8-4.5-10.9-4.5zM359.5 167.9c4.1 0 8-1.6 10.9-4.5l32.7-32.7c2.9-2.9 4.5-6.8 4.5-10.9s-1.6-8-4.5-10.9c-2.9-2.9-6.8-4.5-10.9-4.5-4.1 0-8 1.6-10.9 4.5l-32.7 32.7c-2.9 2.9-4.5 6.8-4.5 10.9s1.6 8 4.5 10.9c2.9 2.9 6.8 4.5 10.9 4.5zM130.7 108.9c-2.9-2.9-6.8-4.5-10.9-4.5-4.1 0-8 1.6-10.9 4.5-2.9 2.9-4.5 6.8-4.5 10.9 0 4.1 1.6 8 4.5 10.9l32.7 32.7c2.9 2.9 6.8 4.5 10.9 4.5 4.1 0 8-1.6 10.9-4.5 2.9-2.9 4.5-6.8 4.5-10.9s-1.6-8-4.5-10.9l-32.7-32.7zM370.4 348.6c-2.9-2.9-6.8-4.5-10.9-4.5-4.1 0-8 1.6-10.9 4.5-6 6-6 15.8 0 21.8l32.7 32.7c2.9 2.9 6.8 4.5 10.9 4.5 4.1 0 8-1.6 10.9-4.5 2.9-2.9 4.5-6.8 4.5-10.9s-1.6-8-4.5-10.9l-32.7-32.7zM256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96z"}}]})(props);
	};
	module.exports.IoIosSwap = function IoIosSwap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M388.9 266.3c-5.1-5-5.2-13.3-.1-18.4L436 200H211c-7.2 0-13-5.8-13-13s5.8-13 13-13h224.9l-47.2-47.9c-5-5.1-5-13.3.1-18.4 5.1-5 13.3-5 18.4.1l69 70c1.1 1.2 2.1 2.5 2.7 4.1.7 1.6 1 3.3 1 5 0 3.4-1.3 6.6-3.7 9.1l-69 70c-5 5.2-13.2 5.3-18.3.3zM123.1 404.3c5.1-5 5.2-13.3.1-18.4L76.1 338H301c7.2 0 13-5.8 13-13s-5.8-13-13-13H76.1l47.2-47.9c5-5.1 5-13.3-.1-18.4-5.1-5-13.3-5-18.4.1l-69 70c-1.1 1.2-2.1 2.5-2.7 4.1-.7 1.6-1 3.3-1 5 0 3.4 1.3 6.6 3.7 9.1l69 70c5 5.2 13.2 5.3 18.3.3z"}}]})(props);
	};
	module.exports.IoIosSwitch = function IoIosSwitch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"144","cy":"368","r":"42"}},{"tag":"path","attr":{"d":"M367.5 272h-223C91.2 272 48 315.2 48 368.5S91.2 464 144.5 464h223c53.3 0 96.5-42.2 96.5-95.5S420.8 272 367.5 272zM144 432c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"}},{"tag":"circle","attr":{"cx":"368","cy":"144","r":"42"}},{"tag":"path","attr":{"d":"M144.5 240h223c53.3 0 96.5-42.2 96.5-95.5S420.8 48 367.5 48h-223C91.2 48 48 91.2 48 144.5S91.2 240 144.5 240zM368 80c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64z"}}]})(props);
	};
	module.exports.IoIosSync = function IoIosSync (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M492 257.1c-2.6-2.6-6-4-9.6-4-3.6 0-7 1.4-9.6 4l-13 13c4.3-61.8-19.5-122.5-65.3-165C356.9 70.2 307.7 51 256.1 51c-26.7 0-52.8 5.1-77.4 15.1-25.5 10.4-48.3 25.6-67.7 45.3-13.2 13.4-24.6 28.5-33.6 44.8-1.9 3.4-2.3 7.4-1.2 11.1 1.1 3.7 3.8 6.8 7.2 8.5 2 1 4.2 1.5 6.4 1.5 5.2 0 9.9-2.8 12.4-7.3 7.9-14.3 17.8-27.5 29.4-39.1 16.8-16.8 36.3-29.8 58.1-38.7 21.1-8.6 43.4-12.9 66.2-12.9 22.9 0 45.2 4.3 66.3 12.9 21.8 8.9 41.4 21.9 58.2 38.8 20.3 20.4 35.4 45.6 43.8 73 7 22.9 9.2 47.3 6.6 71.2l-18.9-18.5c-2.5-2.4-5.8-3.8-9.3-3.8-3.5 0-6.9 1.4-9.4 3.9-5.2 5.2-5.2 13.6 0 18.8l42.8 42.9c1.9 1.9 4.4 2.9 7 2.9 2.6 0 5.1-1 7-2.9l42.1-42.2c5.2-5.3 5.2-13.9-.1-19.2zM428.6 335.9c-2-1-4.2-1.5-6.4-1.5-5.2 0-9.9 2.8-12.4 7.3-7.9 14.3-17.8 27.5-29.4 39.1-16.8 16.8-36.3 29.9-58.2 38.7-21.1 8.6-43.4 12.9-66.3 12.9s-45.2-4.3-66.2-12.9c-21.8-8.9-41.4-21.9-58.2-38.7-37.6-37.8-56-90.9-50.3-143.9l18.4 18.5c2.4 2.4 5.6 3.7 9 3.7 3.4 0 6.6-1.3 9-3.7l1.3-1.3c4.9-4.9 4.9-13 0-17.9l-42.9-43c-1.9-1.9-4.4-2.9-7-2.9-2.6 0-5.1 1-7 2.9l-42 42.3c-5.3 5.3-5.3 13.9 0 19.2 2.6 2.6 6 4 9.6 4 3.6 0 7-1.4 9.6-4l13-13.1c-1.8 25.8 1.3 52 9 76.5 9.9 31.4 26.8 59.3 50.3 82.8 19.5 19.6 42.2 34.7 67.6 45.1 24.5 10 50.4 15 76.9 15 26.5 0 52.4-5.1 76.9-15 25.4-10.3 48.1-25.5 67.6-45.1 13.5-13.5 25-28.8 34.2-45.4 1.9-3.4 2.3-7.4 1.2-11.1-1.2-3.7-3.8-6.8-7.3-8.5z"}}]})(props);
	};
	module.exports.IoIosTabletLandscape = function IoIosTabletLandscape (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M39 103c-4.5 4.5-7 10.6-7 16.9V392c0 6.4 2.5 12.4 7 16.9 4.5 4.5 10.6 7 16.9 7H456c6.4 0 12.4-2.5 16.9-7 4.5-4.5 7-10.6 7-16.9V119.9c0-6.4-2.5-12.4-7-16.9-4.5-4.5-10.6-7-16.9-7H55.9c-6.3 0-12.4 2.5-16.9 7zm9.7 153.4c0-3.9 3.1-7 7-7s7 3.1 7 7-3.1 7-7 7c-3.8 0-7-3.2-7-7zM470 256c0 7.7-6.5 14-14.1 14-7.5 0-14-6.2-14-14 0-7.7 6.4-14.1 14-14.1 7.6.1 14.1 6.4 14.1 14.1zm-38-144v288H80V112h352z"}}]})(props);
	};
	module.exports.IoIosTabletPortrait = function IoIosTabletPortrait (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M409 39c-4.5-4.5-10.6-7-16.9-7H119.9c-6.4 0-12.4 2.5-16.9 7-4.5 4.5-7 10.6-7 16.9V456c0 6.4 2.5 12.4 7 16.9 4.5 4.5 10.6 7 16.9 7H392c6.4 0 12.4-2.5 16.9-7 4.5-4.5 7-10.6 7-16.9V55.9c.1-6.3-2.4-12.4-6.9-16.9zm-153.4 9.7c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7c0-3.8 3.2-7 7-7zM256 470c-7.7 0-14-6.5-14-14.1 0-7.5 6.2-14 14-14 7.7 0 14.1 6.4 14.1 14-.1 7.6-6.4 14.1-14.1 14.1zm144-38H112V80h288v352z"}}]})(props);
	};
	module.exports.IoIosTennisball = function IoIosTennisball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M250.4 464c1-7.9 1.6-15.9 1.6-23.9 0-48.1-18.7-94.3-52.7-128.3S119 260 70.9 260c-7.7 0-15.4.5-22.9 1.4 2.8 110.3 92.3 199.3 202.4 202.6z"}},{"tag":"path","attr":{"d":"M230 74c0-8.3.5-16.4 1.4-24.5-95.3 11.7-171.7 89-182.2 184.7 7.2-.7 14.4-1.1 21.8-1.1 114.9 0 207.1 92.2 207.1 207 0 7.7-.4 15.3-1.3 22.8 96.6-10.1 174.6-86.2 185.8-182.4-8.4 1-16.9.6-25.5.6C322.1 281 230 188.9 230 74z"}},{"tag":"path","attr":{"d":"M308.7 202.3c34 34 80.2 52.7 128.3 52.7 9.1 0 18.1-.7 27-2-2.2-112-93.9-203.5-206.1-205-1.2 8.5-1.9 17.2-1.9 26 0 48.1 18.7 94.3 52.7 128.3zM232 49.3z"}}]})(props);
	};
	module.exports.IoIosText = function IoIosText (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C141.1 64 48 139.2 48 232c0 64.9 45.6 121.2 112.3 149.2-5.2 25.8-21 47-33.5 60.5-2.3 2.5.2 6.5 3.6 6.3 11.5-.8 32.9-4.4 51-12.7 21.5-9.9 40.3-30.1 46.3-36.9 9.3 1 18.8 1.6 28.5 1.6 114.9 0 208-75.2 208-168C464 139.2 370.9 64 256 64z"}}]})(props);
	};
	module.exports.IoIosThermometer = function IoIosThermometer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M309.8 304.6c-4.3-3-6.9-7.9-6.9-13.1v-213c0-25.7-21-46.5-47-46.5s-47 20.8-47 46.5v213c0 5.2-2.6 10.2-6.9 13.1-25.2 17.3-42 46.4-42 79.3 0 53 43 96 96 96s96-43 96-96c0-32.9-17-62.1-42.2-79.3zM256.1 445c-32 0-58.1-26.3-58.1-58.8 0-25.4 15.4-47.1 37.9-55.3 3.2-1.2 5.4-4.1 5.4-7.5V180.2c0-8 6.5-14.5 14.5-14.5s14.5 6.5 14.5 14.5v143.2c0 3.4 2.1 6.3 5.3 7.5 21.9 8.2 38.4 29.9 38.4 55.2 0 32.5-25.8 58.9-57.9 58.9z"}}]})(props);
	};
	module.exports.IoIosThumbsDown = function IoIosThumbsDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80.7 123.2c-7.5 6.3-16.7 16.1-16.7 31.4 0 13.7 5.7 22.8 10.9 29.1.6 1.2 1.1 2.3 1.6 3.4l.2 1.1c.7 3.5 0 7.1-2 10-3.4 5-5.8 12.3-5.8 25.7 0 11.6 4.8 18.4 9.7 23.2 4.4 4.3 6.1 12.5 4.1 18.3-4.8 13.9-.2 28.4 8.2 37.8 10.5 11.8 20.3 13.2 46.4 11.7 18-1.1 55.5-6.9 80.2-10.8 10.1-1.6 18.9-3 21.6-3.2 12.7-1.3 15.2 0 16.4 4.9.5 2.1-1.9 6.9-4.9 13-4 8.1-9.5 19.2-14.5 35.8-10.1 33.2-9 69.2 2.7 90.2 5.5 9.9 14.8 19.1 26.3 19.1s23.3-2.4 27.9-7.9c3.4-4 2.3-11.6 6.2-26.8 3.1-12.4 7-30.9 12-42 7.5-16.6 39.7-45.1 57-60.4 4.1-3.6 7.6-6.7 10.1-9.1 8.7-8.1 17.6-21.1 25.5-32.7 5.4-7.8 10.4-15.2 13.7-18.5 7.1-7.1 16.6-10.9 22.3-10.9 4.4 0 8-3.6 8-8V88.1c0-4.6-3.7-8.3-8.3-8.3C404 79.8 389 74 373.1 68c-12.2-4.7-24.9-9.5-46.4-12.1-32.4-4-74.2-8.1-112.6-8.1-20.4 0-39.9 2-56.6 3.9-31 3.6-64.2 10.8-75.2 37-4.1 9.7-2.2 17.6.5 23.7.4.8.7 1.7.8 2.6.6 3.3-.6 6.3-2.9 8.2z"}}]})(props);
	};
	module.exports.IoIosThumbsUp = function IoIosThumbsUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M431.3 388.8c7.5-6.3 16.7-16.1 16.7-31.4 0-13.7-5.7-22.8-10.9-29.1-.6-1.2-1.1-2.3-1.6-3.4l-.2-1.1c-.7-3.5 0-7.1 2-10 3.4-5 5.8-12.3 5.8-25.7 0-11.6-4.8-18.4-9.7-23.2-4.4-4.3-6.1-12.5-4.1-18.3 4.8-13.9.2-28.4-8.2-37.8-10.5-11.8-20.3-13.2-46.4-11.7-18 1.1-55.5 6.9-80.2 10.8-10.1 1.6-18.9 3-21.6 3.2-12.7 1.3-15.2 0-16.4-4.9-.5-2.1 1.9-6.9 4.9-13 4-8.1 9.5-19.2 14.5-35.8 10.1-33.2 9-69.2-2.7-90.2-5.5-9.9-14.8-19.1-26.3-19.1S223.6 50.5 219 56c-3.4 4-2.3 11.6-6.2 26.8-3.1 12.4-7 30.9-12 42-7.5 16.6-39.7 45.1-57 60.4-4.1 3.6-7.6 6.7-10.1 9.1-8.7 8.1-17.6 21.1-25.5 32.7-5.4 7.8-10.4 15.2-13.7 18.5-7.1 7.1-16.6 10.9-22.3 10.9-4.4 0-8 3.6-8 8v159.5c0 4.6 3.7 8.3 8.3 8.3 35.5 0 50.5 5.8 66.4 11.8 12.2 4.7 24.9 9.5 46.4 12.1 32.4 4 74.2 8.1 112.6 8.1 20.4 0 39.9-2 56.6-3.9 31-3.6 64.2-10.8 75.2-37 4.1-9.7 2.2-17.6-.5-23.7-.4-.8-.7-1.7-.8-2.6-.6-3.3.6-6.3 2.9-8.2z"}}]})(props);
	};
	module.exports.IoIosThunderstorm = function IoIosThunderstorm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M374.4 141.9l-13.3-.1C349.4 88.2 306 48 236 48S108.2 98.4 108.2 169.5l.3 4.8C66.3 179.9 32 219.6 32 264c0 47 37.9 88 84.7 88H236l13.8-50.6H183c-2.6 0-4.5-2.4-3.9-4.9l23.2-113c.4-1.8 2-3.1 3.9-3.1h86.1c2.7 0 4.6 2.6 3.8 5.2l-22.5 74.9h60.1c3.1 0 5.1 3.5 3.4 6.1L283.4 352H367c72 0 113-52 113-110 0-58.6-47.3-100.1-105.6-100.1zM206.8 458.9c-1.2 4.4 4.8 7 7.2 3.2L283.4 352H236l-29.2 106.9z"}}]})(props);
	};
	module.exports.IoIosTime = function IoIosTime (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm14 226c0 7.7-6.3 14-14 14h-96c-7.7 0-14-6.3-14-14s6.3-14 14-14h82V128c0-7.7 6.3-14 14-14s14 6.3 14 14v146z"}}]})(props);
	};
	module.exports.IoIosTimer = function IoIosTimer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 456c-110.3 0-200-89.7-200-200 0-54.8 21.7-105.9 61.2-144 6.4-6.2 16.6-6 22.7.4 6.2 6.4 6 16.6-.4 22.7-33.1 32-51.3 74.9-51.3 120.9 0 92.5 75.3 167.8 167.8 167.8S423.8 348.5 423.8 256c0-87.1-66.7-159-151.8-167.1v62.6c0 8.9-7.2 16.1-16.1 16.1s-16.1-7.2-16.1-16.1V72.1c0-8.9 7.2-16.1 16.1-16.1 110.3 0 200 89.7 200 200S366.3 456 256 456z"}},{"tag":"path","attr":{"d":"M175.9 161.9l99.5 71.5c13.5 9.7 16.7 28.5 7 42s-28.5 16.7-42 7c-2.8-2-5.2-4.4-7-7l-71.5-99.5c-3.2-4.5-2.2-10.8 2.3-14 3.6-2.6 8.3-2.4 11.7 0z"}}]})(props);
	};
	module.exports.IoIosToday = function IoIosToday (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M388 32H124c-33.1 0-60 26.9-60 60v328c0 33.1 26.9 60 60 60h264c33.1 0 60-26.9 60-60V92c0-33.1-26.9-60-60-60zm32 388c0 17.6-14.4 32-32 32H124c-17.6 0-32-14.4-32-32V92c0-17.6 14.4-32 32-32h264c17.6 0 32 14.4 32 32v328z"}},{"tag":"path","attr":{"d":"M360 176H152c-13.2 0-24 10.8-24 24v192c0 13.2 10.8 24 24 24h208c13.2 0 24-10.8 24-24V200c0-13.2-10.8-24-24-24zM142 124h100c7.7 0 14-6.3 14-14s-6.3-14-14-14H142c-7.7 0-14 6.3-14 14s6.3 14 14 14z"}}]})(props);
	};
	module.exports.IoIosTrain = function IoIosTrain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M393.7 455.9l-50-48c-5.6-5.4-14.4-5.2-19.8.4-5.4 5.6-5.2 14.4.4 19.8l6.1 5.9H181.5l6.1-5.9c5.6-5.4 5.8-14.2.4-19.8-5.4-5.6-14.2-5.8-19.8-.4l-50 48c-5.6 5.4-5.8 14.2-.4 19.8 2.7 2.9 6.4 4.3 10.1 4.3 3.5 0 7-1.3 9.7-3.9l14.7-14.1h207.2l14.7 14.1c2.7 2.6 6.2 3.9 9.7 3.9 3.7 0 7.4-1.4 10.1-4.3 5.5-5.6 5.3-14.4-.3-19.8z"}},{"tag":"path","attr":{"d":"M337 48h-17c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16h-15c-35.3 0-65 27.7-65 63v236c0 35.3 144 65 144 65s144-29.7 144-65V111c0-35.3-27.7-63-63-63zm-81 304c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm96-160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v64z"}},{"tag":"circle","attr":{"cx":"256","cy":"304","r":"30.5"}}]})(props);
	};
	module.exports.IoIosTransgender = function IoIosTransgender (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450.4 168.5c7.5 0 13.6-6.1 13.6-13.6V61.6c0-7.5-6.1-13.6-13.6-13.6h-93.3c-7.5 0-13.6 6.1-13.6 13.6s6.1 13.6 13.6 13.6H417l-75 75.4c-25.7-16.3-55.4-24.8-86-24.8-30.7 0-60.3 8.6-86 24.8l-19-19.1 28.2-28.2c5.3-5.3 5.3-13.9 0-19.2-2.6-2.6-6-4-9.6-4-3.6 0-7.1 1.4-9.6 4l-28.1 28.1-36.8-37H155c7.5 0 13.6-6.1 13.6-13.6S162.5 48 155 48H61.6C54.1 48 48 54.1 48 61.6v93.3c0 7.5 6.1 13.6 13.6 13.6s13.6-6.1 13.6-13.6V95.1l36.9 36.7-30 30c-5.3 5.3-5.3 13.9 0 19.2 2.6 2.6 6 4 9.6 4 3.6 0 7.1-1.4 9.6-4l30.1-30.1 16.5 16.4c-33.9 30.6-53.3 73.9-53.3 119.8 0 43.1 16.8 83.6 47.3 114.1 30.5 30.5 71 47.3 114.1 47.3 45.9 0 89.2-19.4 119.9-53.3l16.4 16.4-29.3 29.2c-5.3 5.3-5.3 13.9 0 19.2 2.6 2.6 6 4 9.6 4 3.6 0 7.1-1.4 9.6-4l29.3-29.3 29.3 29.3c2.6 2.6 6 4 9.6 4 3.6 0 7.1-1.4 9.6-4 5.3-5.3 5.3-13.9 0-19.2l-29.3-29.3 29.3-29.3c5.3-5.3 5.3-13.9 0-19.2-2.6-2.6-6-4-9.6-4-3.6 0-7.1 1.4-9.6 4l-29.3 29.3-19-19c16.3-25.8 24.9-55.4 24.9-86.1 0-45.9-19.3-89.2-53.3-119.8l72.7-72.2v59.9c0 7.3 6.1 13.4 13.6 13.4zm-60.3 118.6c0 35.8-14 69.5-39.3 94.8-25.3 25.3-59 39.3-94.8 39.3s-69.5-14-94.8-39.3c-25.3-25.3-39.3-59-39.3-94.8s14-69.5 39.3-94.8c25.3-25.3 59-39.3 94.8-39.3s69.5 14 94.8 39.3c25.4 25.3 39.3 59 39.3 94.8z"}}]})(props);
	};
	module.exports.IoIosTrash = function IoIosTrash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M133.1 128l23.6 290.7c0 16.2 13.1 29.3 29.3 29.3h141c16.2 0 29.3-13.1 29.3-29.3L379.6 128H133.1zm61.6 265L188 160h18.5l6.9 233h-18.7zm70.3 0h-18V160h18v233zm52.3 0h-18.6l6.8-233H324l-6.7 233zM364 92h-36l-26.3-23c-3.7-3.2-8.4-5-13.2-5h-64.8c-4.9 0-9.7 1.8-13.4 5L184 92h-36c-17.6 0-30 8.4-30 26h276c0-17.6-12.4-26-30-26z"}}]})(props);
	};
	module.exports.IoIosTrendingDown = function IoIosTrendingDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 369.2V251.1c0-8.1-6.8-14.8-15.1-14.8s-15.1 6.6-15.1 14.8v81.7L300.5 181c-2.8-2.8-6.6-4.3-10.7-4.3-4 0-7.8 1.5-10.7 4.3l-85.9 84.1L57.5 132.3c-2.9-2.8-6.6-4.3-10.7-4.3-4 0-7.8 1.5-10.7 4.3-2.8 2.7-4.2 6.2-4.2 10.2 0 5.4 2.3 8.8 4.2 10.7l146.3 143.2c2.9 2.8 6.6 4.3 10.7 4.3 4 0 7.8-1.5 10.7-4.3l85.9-84.1 138 142.2H344c-8.3 0-15.1 6.6-15.1 14.8 0 8.1 6.8 14.8 15.1 14.8h120.8c8.4-.1 15.2-6.7 15.2-14.9z"}}]})(props);
	};
	module.exports.IoIosTrendingUp = function IoIosTrendingUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464.9 128H344.1c-8.3 0-15.1 6.6-15.1 14.8s6.8 14.8 15.1 14.8h83.7l-138 142.2-85.9-84.1c-2.9-2.8-6.6-4.3-10.7-4.3-4 0-7.8 1.5-10.7 4.3L36.2 358.8c-1.9 1.9-4.2 5.2-4.2 10.7 0 4.1 1.4 7.5 4.2 10.2 2.9 2.8 6.6 4.3 10.7 4.3 4 0 7.8-1.5 10.7-4.3L193.2 247l85.9 84.1c2.9 2.8 6.6 4.3 10.7 4.3 4 0 7.8-1.5 10.7-4.3l149.4-151.9v81.7c0 8.1 6.8 14.8 15.1 14.8s15.1-6.6 15.1-14.8V142.8c-.1-8.2-6.9-14.8-15.2-14.8z"}}]})(props);
	};
	module.exports.IoIosTrophy = function IoIosTrophy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450 100h-66V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v20H62c-7.7 0-14 6.3-14 14 0 41.3 7.8 66 22.6 90.4 13.6 22.4 32.9 36.2 56.3 40.3 2.8.5 5.1 2.3 6.2 4.9 6.2 15.4 20.2 34.8 51.1 52.2 20.2 11.4 36.9 18.3 51.7 21.6 3.6.8 6.2 4.1 6.2 7.8V412c0 4.4-3.6 8-8 8h-65.6c-7.5 0-14 5.8-14.4 13.3-.4 8 6 14.7 14 14.7h175.6c7.5 0 14-5.8 14.4-13.3.4-8-6-14.7-14-14.7h-66c-4.4 0-8-3.6-8-8v-80.7c0-3.7 2.6-7 6.2-7.8 14.7-3.3 31.5-10.3 51.7-21.6 30.9-17.4 44.9-36.8 51.1-52.2 1.1-2.6 3.4-4.5 6.2-4.9 23.4-4.1 42.7-17.9 56.3-40.3C456.2 180 464 155.3 464 114c0-7.7-6.3-14-14-14zM128 210.6c0 2.8-2.8 4.8-5.4 3.8-12.8-4.9-23.2-14.7-30.6-28.9-5.8-11-12.6-21.4-15.1-48.8-.4-4.7 3.3-8.7 8-8.7H120c4.4 0 8 3.6 8 8v74.6zm292-25.1c-7.4 14.2-17.8 24-30.6 28.9-2.6 1-5.4-1-5.4-3.8V136c0-4.4 3.6-8 8-8h35.1c4.7 0 8.4 4 8 8.7-2.5 27.4-9.4 37.8-15.1 48.8z"}}]})(props);
	};
	module.exports.IoIosTv = function IoIosTv (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M451.7 78H60.3C34.8 78 14 98.8 14 124.3v215.5c0 25.5 20.8 46.3 46.3 46.3h391.5c25.5 0 46.3-20.8 46.3-46.3V124.3C498 98.8 477.2 78 451.7 78zM470 339.7c0 10.1-8.2 18.3-18.3 18.3H60.3c-10.1 0-18.3-8.2-18.3-18.3V124.3c0-10.1 8.2-18.3 18.3-18.3h391.5c10.1 0 18.3 8.2 18.3 18.3v215.4z"}},{"tag":"path","attr":{"d":"M436 128H76c-6.6 0-12 5.4-12 12v184c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V140c0-6.6-5.4-12-12-12zM370 406H142c-7.7 0-14 6.3-14 14s6.3 14 14 14h228c7.7 0 14-6.3 14-14s-6.3-14-14-14z"}}]})(props);
	};
	module.exports.IoIosUmbrella = function IoIosUmbrella (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M407.1 137.9c-34.9-41.6-81.3-67.3-131.2-72.6-2-9.9-10.2-17.3-19.9-17.3s-17.9 7.3-19.9 17.2c-50.6 5.2-97.4 30.3-132.1 71.2-35.8 42.2-55.6 85.5-55.8 143.7-.1.5-.2 1.2-.2 2.1.1 3.2 2.7 5.8 5.8 5.8h3.1c2.6 0 4.9-1.8 5.6-4.4 2.7-10.1 8.4-19.1 16-25.5 7.7-6.5 16.9-9.9 26.6-9.9 9.6 0 18.8 3.4 26.5 10 7.6 6.4 13.2 15.4 16 25.5.7 2.6 3 4.4 5.6 4.4h4.8c2.6 0 4.9-1.8 5.6-4.4 5.7-20.9 23.3-35.4 42.8-35.4 14.8 0 28.8 8.4 36.9 21.9V418c0 9.9-8 18-17.7 18s-17.6-8.1-17.6-18c0-7.7-6.1-14-13.7-14-7.5 0-13.6 6.3-13.6 14 0 25.4 20.2 46 44.9 46 24.8 0 44.9-20.6 44.9-46V270.8c8.2-14.2 21.9-22.6 36.9-22.6 9.6 0 18.7 3.4 26.4 9.9 7.5 6.4 13.1 15.4 15.9 25.5.7 2.6 3 4.4 5.6 4.4h4.8c2.6 0 4.9-1.8 5.6-4.4 2.7-10.1 8.4-19.2 16-25.6 7.7-6.5 16.9-10 26.6-10 9.7 0 19 3.4 26.7 10 7.6 6.4 13.2 15.5 15.9 25.6.7 2.6 3 4.4 5.6 4.4h1.5c1.6 0 3.1-.6 4.2-1.8s1.7-2.7 1.7-4.3c-.8-57.9-21-101.3-56.8-144z"}}]})(props);
	};
	module.exports.IoIosUndo = function IoIosUndo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M479.9 394.9c0-19.6 4.2-97.1-56.8-158.7-40.4-40.7-91.9-61.7-163.4-65.5-2.1-.1-3.8-1.9-3.8-4V84c0-3.2-3.5-5.1-6.2-3.4L33.8 222.8c-2.4 1.6-2.4 5.1 0 6.7l215.9 142.2c2.7 1.8 6.2-.1 6.2-3.4v-81.6c0-2.3 1.9-4.1 4.2-4 44.1 1.7 69.5 10.9 97.1 23.2 36.1 16.2 72.9 50.9 94.5 83.5 13.1 19.9 19.2 33.9 21.4 39.7.7 1.7 2.3 2.8 4.1 2.8h2.9c-.1-11.7-.2-26.7-.2-37z"}}]})(props);
	};
	module.exports.IoIosUnlock = function IoIosUnlock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 192H188v-48c0-18.1 7.1-35.1 20-48s29.9-20 48-20 35.1 7.1 48 20 20 29.9 20 48c0 7.7 6.3 14 14 14s14-6.3 14-14c0-53.2-43.9-96.7-97.3-96-52.7.7-94.7 44.5-94.7 97.3V192h-24c-22 0-40 18-40 40v192c0 22 18 40 40 40h240c22 0 40-18 40-40V232c0-22-18-40-40-40zM270 316.8v68.8c0 7.5-5.8 14-13.3 14.4-8 .4-14.7-6-14.7-14v-69.2c-11.5-5.6-19.1-17.8-17.9-31.7 1.4-15.5 14.1-27.9 29.6-29 18.7-1.3 34.3 13.5 34.3 31.9 0 12.7-7.3 23.6-18 28.8z"}}]})(props);
	};
	module.exports.IoIosVideocam = function IoIosVideocam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450.6 153.6c-3.3 0-6.5.9-9.3 2.7l-86.5 54.6c-2.5 1.6-4 4.3-4 7.2v76c0 2.9 1.5 5.6 4 7.2l86.5 54.6c2.8 1.7 6 2.7 9.3 2.7h20.8c4.8 0 8.6-3.8 8.6-8.5v-188c0-4.7-3.9-8.5-8.6-8.5h-20.8zM273.5 384h-190C55.2 384 32 360.8 32 332.6V179.4c0-28.3 23.2-51.4 51.4-51.4h190c28.3 0 51.4 23.2 51.4 51.4v153.1c.1 28.3-23 51.5-51.3 51.5z"}}]})(props);
	};
	module.exports.IoIosVolumeHigh = function IoIosVolumeHigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M215.4 145.5c-2.2-1.1-4.6-1.6-6.9-1.6-3.6 0-7.1 1.2-10 3.5L133.3 200H80.5c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h52.8l65.2 52.5c2.9 2.3 6.5 3.5 10 3.5 2.3 0 4.7-.5 6.9-1.6 5.6-2.7 9.1-8.3 9.1-14.4V160c0-6.2-3.5-11.8-9.1-14.5zM447.5 256c0-59.3-23.2-114.8-65.4-156.5-4.7-4.7-12.3-4.6-17 .1-4.7 4.7-4.6 12.3.1 17 37.6 37.1 58.2 86.6 58.2 139.4 0 52.8-20.7 102.3-58.2 139.4-4.7 4.7-4.8 12.3-.1 17 2.3 2.4 5.4 3.6 8.5 3.6 3 0 6.1-1.2 8.4-3.5 42.3-41.6 65.5-97.2 65.5-156.5z"}},{"tag":"path","attr":{"d":"M384.9 256c0-43.5-16.6-84.3-46.8-114.9-4.7-4.7-12.3-4.8-17-.1-4.7 4.7-4.8 12.3-.1 17 25.7 26.1 39.9 60.9 39.9 98.1 0 37.2-14.2 72-39.9 98.1-4.7 4.7-4.6 12.3.1 17 2.3 2.3 5.4 3.5 8.4 3.5 3.1 0 6.2-1.2 8.5-3.6 30.2-30.8 46.9-71.6 46.9-115.1z"}},{"tag":"path","attr":{"d":"M287.5 182.5c-4.7-4.7-12.3-4.8-17-.1-4.7 4.7-4.8 12.3-.1 17 14.8 15 23 35.1 23 56.6 0 21.4-8.2 41.5-23 56.6-4.7 4.7-4.6 12.3.1 17 2.3 2.3 5.4 3.5 8.4 3.5 3.1 0 6.2-1.2 8.5-3.6 19.3-19.6 29.9-45.6 29.9-73.4.1-27.9-10.5-54-29.8-73.6z"}}]})(props);
	};
	module.exports.IoIosVolumeLow = function IoIosVolumeLow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M278.9 145.6c-2.2-1.1-4.6-1.6-6.9-1.6-3.6 0-7.1 1.2-10 3.5L196.8 200H144c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h52.8l65.2 52.5c2.9 2.3 6.5 3.5 10 3.5 2.3 0 4.7-.5 6.9-1.6 5.6-2.7 9.1-8.3 9.1-14.4V160c0-6.2-3.5-11.8-9.1-14.4zM354.4 182.6c-4.6-4.7-12.1-4.8-16.8-.1-4.7 4.7-4.7 12.3-.1 17 14.7 15 22.8 35.1 22.8 56.6 0 21.4-8.1 41.5-22.8 56.6-4.6 4.7-4.6 12.3.1 17 2.3 2.3 5.3 3.5 8.3 3.5 3.1 0 6.1-1.2 8.5-3.6C373.5 310 384 284 384 256.2h-.2c0-28-10.3-54.1-29.4-73.6z"}}]})(props);
	};
	module.exports.IoIosVolumeMute = function IoIosVolumeMute (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M326.9 145.6c-2.2-1.1-4.6-1.6-6.9-1.6-3.6 0-7.1 1.2-10 3.5L244.8 200H192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h52.8l65.2 52.5c2.9 2.3 6.5 3.5 10 3.5 2.3 0 4.7-.5 6.9-1.6 5.6-2.7 9.1-8.3 9.1-14.4V160c0-6.2-3.5-11.8-9.1-14.4z"}}]})(props);
	};
	module.exports.IoIosVolumeOff = function IoIosVolumeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M390.1 464c-4.9 0-9.7-2.5-12.3-7L149.7 69.3c-4-6.7-1.7-15.4 5.1-19.3 6.8-3.9 15.5-1.7 19.5 5.1l228.1 387.7c4 6.7 1.7 15.4-5.1 19.3-2.2 1.3-4.7 1.9-7.2 1.9zM133 200H80c-8.9 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h53l65.4 52.5c2.9 2.3 6.5 3.5 10.1 3.5 2.4 0 4.7-.5 6.9-1.6 5.6-2.7 9.1-8.3 9.1-14.4V227.9L184 159.1 133 200zM448 256c0-59.3-23.3-114.9-65.5-156.5-4.7-4.7-12.3-4.6-17 .1-4.7 4.7-4.6 12.3.1 17C403.3 153.7 424 203.2 424 256c0 44.4-14.7 86.4-41.7 120.8l13 22C429.4 359.1 448 309 448 256z"}},{"tag":"path","attr":{"d":"M385.2 256c0-43.5-16.7-84.3-46.9-114.9-4.7-4.7-12.3-4.8-17-.1-4.7 4.7-4.8 12.3-.1 17 25.8 26.1 40 60.9 40 98.1 0 21.6-4.8 42.5-13.9 61.2l14.2 24.1c15.4-25.4 23.7-54.7 23.7-85.4zM317.6 256c0-27.8-10.7-53.9-30-73.4-4.7-4.7-12.3-4.8-17-.1-.6.6-1.1 1.2-1.6 1.9l48.1 81.8c.3-3.4.5-6.8.5-10.2z"}}]})(props);
	};
	module.exports.IoIosWalk = function IoIosWalk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M201.1 361.2l-67.8 48.9c-3.7 3.6-5.2 9.1-5.3 13.9-.1 4.8 1.2 8.8 4.7 12.5 3.6 3.9 8.8 6.2 13.6 6.2 4.5 0 12.5-4.9 16-8.4l69.7-51.6c3.6-3.5 5.7-8.4 5.7-13.5l9.1-52.5-45.7-46.7v91.2z"}},{"tag":"ellipse","attr":{"transform":"rotate(-80.781 274.673 69.329)","cx":"274.7","cy":"69.3","rx":"37.3","ry":"37.3"}},{"tag":"path","attr":{"d":"M350.7 459.2l-15.2-117.4c-.5-3.5-1.9-6.8-4.2-9.5l-57-68.8V143.9c0-11.3-6.3-15.9-18.3-15.9h-37c-2.8 0-5.2 1-7.7 2.3l-68 31.7c-10 5.3-15.3 15.4-15.3 28.7V256c0 10.3 8.2 18.7 18.3 18.7 10.1 0 18.3-8.4 18.3-18.7v-58.2c0-3 1.7-5.8 4.4-7.1l32.2-16.4v75.3c0 4.2 1.6 8.2 4.6 11.2l92.4 94.4c1.2 1.2 2 2.8 2.2 4.5l14.2 104.7c1.3 9.3 9.1 15.7 18.1 15.7h2c9.9-1.5 17.4-10.7 16-20.9z"}},{"tag":"path","attr":{"d":"M378.4 232.4l-95-96.2v52.6l69.2 70.1c7.2 7.3 18.7 7.2 25.9-.1 3.5-3.6 5.5-7.5 5.5-12.2 0-4.8-2-10.5-5.6-14.2z"}}]})(props);
	};
	module.exports.IoIosWallet = function IoIosWallet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M404 160H108c-33.1 0-60 26.9-60 60v168c0 33.1 26.9 60 60 60h296c33.1 0 60-26.9 60-60V220c0-33.1-26.9-60-60-60zM342.9 65L108 110.9c-18 4-44 22.1-44 44.1 0 0 15-19 49-19h287v-20.5c0-12.6-5-28.7-13.9-37.6-11.3-11.3-27.5-16.2-43.2-12.9z"}}]})(props);
	};
	module.exports.IoIosWarning = function IoIosWarning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M228.9 79.9L51.8 403.1C40.6 423.3 55.5 448 78.9 448h354.3c23.3 0 38.2-24.7 27.1-44.9L283.1 79.9c-11.7-21.2-42.5-21.2-54.2 0zM273.6 214L270 336h-28l-3.6-122h35.2zM256 402.4c-10.7 0-19.1-8.1-19.1-18.4s8.4-18.4 19.1-18.4 19.1 8.1 19.1 18.4-8.4 18.4-19.1 18.4z"}}]})(props);
	};
	module.exports.IoIosWatch = function IoIosWatch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.3 161.3c-15-23.9-36.3-43.3-61.4-56.1-1.9-.9-3.9-1.4-6-1.4-5 0-9.5 2.8-11.8 7.2-1.6 3.1-1.9 6.7-.8 10 1.1 3.3 3.4 6.1 6.6 7.7 20.9 10.7 38.6 26.8 51.1 46.7 12.8 20.4 19.6 44 19.6 68v40.5c0 17.2-3.3 33.4-9.9 48-6.3 14-15.4 26.3-27 36.6-23.2 20.5-55.1 31.9-89.9 31.9-34.4 0-43.6-5.2-52.4-10.2-8.1-4.6-17.3-9.8-37.7-11-31.7-2-56.9-12.4-77.2-31.8-2.5-2.4-5.7-3.7-9.1-3.7-3.6 0-7 1.5-9.5 4.1-2.4 2.5-3.7 5.7-3.7 9.1 0 3.6 1.5 7 4.1 9.5 25 23.9 55.7 36.7 93.8 39.1 14.4.9 19.4 3.7 26.4 7.7 11.3 6.4 24.1 13.6 65.4 13.6 41.6 0 80-13.9 108.1-39.2 14.2-12.8 25.3-28 33-45.2 8-18 12.1-37.6 12.1-58.5v-40.5c-.1-29.1-8.3-57.5-23.8-82.1z"}},{"tag":"path","attr":{"d":"M284 383c8.7 1.4 17.2 2.1 25.4 2.1 16 0 31.2-2.7 45-8 13.9-5.4 26.5-13.4 37.5-23.9 5.3-5 5.4-13.4.4-18.6-2.5-2.6-5.9-4.1-9.5-4.1-3.4 0-6.7 1.3-9.1 3.7-17.1 16.3-38.8 24.6-64.5 24.6-6.8 0-13.8-.6-21-1.8-.7-.1-1.4-.2-2.1-.2-6.5 0-12 4.6-13 11-.1.7-.2 1.4-.2 2.1 0 6.6 4.7 12 11.1 13.1zm2.1-21.1h.1-.3.2zM222.9 421.7c-39.9 0-72.8-13.4-102.7-40.3-29.1-26.2-45.8-60.7-45.8-94.5v-43.6c0-24.1 6.8-47.6 19.6-68 12.5-19.9 30.2-36 51.1-46.7 3.1-1.6 5.5-4.3 6.6-7.7 1.1-3.3.8-6.9-.8-10.1-2.3-4.4-6.8-7.2-11.8-7.2-2.1 0-4.1.5-6 1.4-25.1 12.8-46.4 32.2-61.4 56.1-15.5 24.6-23.7 53-23.7 82v43.6c0 41.2 19.9 82.8 54.5 114 34.6 31.2 74 47.1 120.4 47.1 7.3 0 13.2-5.9 13.2-13.2-.1-7-6-12.9-13.2-12.9z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M348.4 115.1c.8-11.9 10.3-21.6 22.2-22.6 4.3-.4 8.4.4 12 2 2.6 1.1 5.1-1.6 3.9-4.1-2.7-5.7-6.6-10.9-11.5-15.1C366.6 68 355.9 64 344.8 64H167.2c-17.9 0-33.9 10.3-41.5 25.8-1.2 2.5 1.2 5.2 3.9 4.2 3.3-1.3 7-1.8 10.8-1.5 11.9 1 21.4 10.8 22.2 22.7.8 13.6-9.5 25-22.8 25.8-.9.1-1.8.7-2.1 1.5-.4 1.1-.1 2.3.8 3 8.1 6.2 18.1 9.7 28.7 9.7h177.6c10.9 0 21.2-3.6 29.4-10.2 1.7-1.3.7-4-1.4-4h-.1c-14 0-25.2-11.7-24.3-25.9zm-21.6-10.3c3.5 15.8-10.7 30-26.5 26.5-8.4-1.9-15.2-8.6-17-17-3.5-15.8 10.7-30 26.5-26.5 8.4 1.9 15.2 8.6 17 17z"}}]}]})(props);
	};
	module.exports.IoIosWater = function IoIosWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 146.4c-34.4-48.6-67.5-78.5-90.8-96.6-3.1-2.4-7.3-2.4-10.4-.1-23 17.1-56.1 48.4-90.5 96.5-37.3 52-63 108.4-64.2 170.9 0 1.2-.1 2.5-.1 3.7 0 18.4 3.9 35.9 10.9 52.1 4.1 9.3 9.2 18.1 15.2 26.3 28.5 39 77.8 64.8 133.8 64.8 88.4 0 160.1-64.1 160.1-143.2 0-63.7-27-122.2-64-174.4zm-86 264.3h-.5c-9.9 0-12-14.1-2.6-17.1 45.1-14.2 69.6-38.5 86.4-80.8 3.5-8.9 16.7-6.5 16.8 3.1v1.4c-.1 51.6-44.9 93.4-100.1 93.4z"}}]})(props);
	};
	module.exports.IoIosWifi = function IoIosWifi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 96c-81.5 0-163 33.6-221.5 88.3-3.3 3-3.4 8.1-.3 11.4l26.7 27.9c3.1 3.3 8.3 3.4 11.6.3 23.3-21.6 49.9-38.8 79.3-51 33-13.8 68.1-20.7 104.3-20.7s71.3 7 104.3 20.7c29.4 12.3 56 29.4 79.3 51 3.3 3.1 8.5 3 11.6-.3l26.7-27.9c3.1-3.2 3-8.3-.3-11.4C419 129.6 337.5 96 256 96z"}},{"tag":"path","attr":{"d":"M113.2 277.5l28.6 28.3c3.1 3 8 3.2 11.2.3 28.3-25.1 64.6-38.9 102.9-38.9s74.6 13.7 102.9 38.9c3.2 2.9 8.1 2.7 11.2-.3l28.6-28.3c3.3-3.3 3.2-8.6-.3-11.7-37.5-33.9-87.6-54.6-142.5-54.6s-105 20.7-142.5 54.6c-3.3 3.1-3.4 8.4-.1 11.7zM256 324.2c-23.4 0-44.6 9.8-59.4 25.5-3 3.2-2.9 8.1.2 11.2l53.4 52.7c3.2 3.2 8.4 3.2 11.6 0l53.4-52.7c3.1-3.1 3.2-8 .2-11.2-14.8-15.6-36-25.5-59.4-25.5z"}}]})(props);
	};
	module.exports.IoIosWine = function IoIosWine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M328.9 51.2c-2-5.5-7-9.2-12.9-9.2H196c-6 0-10.9 3.7-13 9.2-9.3 25-31 87.1-31 124.8v4.8c0 19.2 0 45.4 28.4 74.5 6.5 6.7 14.3 12.9 22.5 19.5 19.1 15.3 38.8 31.1 38.8 50.2v115c0 1.1-.9 2-2 2h-57.1c-7.9 0-14.3 6.3-14.3 14s6.4 14 14.3 14h146.8c7.9 0 14.3-6.3 14.3-14s-6.4-14-14.3-14h-57.1c-1.1 0-2-.9-2-2V325c0-19.1 19.7-34.9 38.8-50.2 8.2-6.6 15.9-12.8 22.5-19.5C360 226.2 360 200 360 180.8V176c0-37.5-21.7-99.8-31.1-124.8zm-1.4 102.1c-.2.3-.7.7-1.6.7H186.1c-.8 0-1.3-.5-1.6-.7-.2-.3-.6-.8-.4-1.7 5.1-26.1 14.8-59.6 21.6-80.2.3-.8 1.1-1.4 1.9-1.4h96.8c.9 0 1.7.6 1.9 1.4 6.7 20.7 16.4 54.1 21.6 80.2.2.8-.2 1.4-.4 1.7z"}}]})(props);
	};
	module.exports.IoIosWoman = function IoIosWoman (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M286 496c-6.1 0-11.8-2.3-16-6.6-3.2-3.3-7.1-9.1-7.1-18.6V351.4H249v119.4c0 9.5-4 15.4-7.4 18.7-4.3 4.2-10.1 6.5-16.3 6.5-6.2 0-11.9-2.3-16.3-6.5-3.4-3.3-7.4-9.1-7.4-18.7V351.4h-43.9l44.5-170.6h-6.8L171 271.2c-4 13.1-13.7 17.8-21.4 17.8-6.6 0-12.9-3.2-17-8.7-4.8-6.4-6.1-14.9-3.6-23.9l29-104.1c4.2-15.2 20.7-38.2 48.7-39.3H305.1c28.4 1.2 44.1 26 48.5 38.9l.1.4 29 104.3c2.4 9 1 17.6-3.9 24-4.1 5.4-10.4 8.6-16.9 8.6-7.7 0-17.3-4.8-21.3-18.1v-.2l-24.3-90.1h-7.7l45.5 170.6H309v119.4c0 9.5-3.9 15.3-7.1 18.6-4.2 4.3-9.8 6.6-15.9 6.6zM255.9 106.4c-24.2 0-43.9-20.3-43.9-45.2S231.7 16 255.9 16s43.9 20.3 43.9 45.2-19.7 45.2-43.9 45.2z"}}]})(props);
	};
	module.exports.IoLogoAndroid = function IoLogoAndroid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144 268.4V358c0 6.9 4.5 14 11.4 14H184v52c0 13.3 10.7 24 24 24s24-10.7 24-24v-52h49v52c0 7.5 3.4 14.2 8.8 18.6 3.9 3.4 9.1 5.4 14.7 5.4h.5c13.3 0 24-10.7 24-24v-52h27.6c7 0 11.4-7.1 11.4-13.9V192H144v76.4zM408 176c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3-10.7-24-24-24zM104 176c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3-10.7-24-24-24z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M311.2 89.1l18.5-21.9c.4-.5-.2-1.6-1.3-2.5-1.1-.8-2.4-1-2.7-.4l-19.2 22.8c-13.6-5.4-30.2-8.8-50.6-8.8-20.5-.1-37.2 3.2-50.8 8.5l-19-22.4c-.4-.5-1.6-.4-2.7.4s-1.7 1.8-1.3 2.5l18.3 21.6c-48.2 20.9-55.4 72.2-56.4 87.2h223.6c-.9-15.1-8-65.7-56.4-87zm-104.4 49.8c-7.4 0-13.5-6-13.5-13.3 0-7.3 6-13.3 13.5-13.3 7.4 0 13.5 6 13.5 13.3 0 7.3-6 13.3-13.5 13.3zm98.4 0c-7.4 0-13.5-6-13.5-13.3 0-7.3 6-13.3 13.5-13.3 7.4 0 13.5 6 13.5 13.3 0 7.3-6.1 13.3-13.5 13.3z"}}]}]})(props);
	};
	module.exports.IoLogoAngular = function IoLogoAngular (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M213.573 256h84.846l-42.427-89.356z"}},{"tag":"path","attr":{"d":"M255.981 32L32 112l46.12 272L256 480l177.75-96L480 112 255.981 32zM344 352l-26.589-56H194.584L168 352h-40L256 72l128 280h-40z"}}]})(props);
	};
	module.exports.IoLogoApple = function IoLogoApple (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M333.6 153.9c-33.6 0-47.8 16.5-71.2 16.5-24 0-42.3-16.4-71.4-16.4-28.5 0-58.9 17.9-78.2 48.4-27.1 43-22.5 124 21.4 193 15.7 24.7 36.7 52.4 64.2 52.7h.5c23.9 0 31-16.1 63.9-16.3h.5c32.4 0 38.9 16.2 62.7 16.2h.5c27.5-.3 49.6-31 65.3-55.6 11.3-17.7 15.5-26.6 24.2-46.6-63.5-24.8-73.7-117.4-10.9-152.9-19.2-24.7-46.1-39-71.5-39z"}},{"tag":"path","attr":{"d":"M326.2 64c-20 1.4-43.3 14.5-57 31.6-12.4 15.5-22.6 38.5-18.6 60.8h1.6c21.3 0 43.1-13.2 55.8-30.1 12.3-16.1 21.6-38.9 18.2-62.3z"}}]})(props);
	};
	module.exports.IoLogoBitbucket = function IoLogoBitbucket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M452.9 64.2c-.7-.1-1.5-.2-2.2-.2H61.5c-7.4-.1-13.4 5.9-13.5 13.5 0 .8 0 1.6.2 2.4l56.6 352.5c.7 4.3 2.9 8.2 6.1 11.1 3.2 2.9 7.4 4.5 11.7 4.5H394c6.6.1 12.3-4.8 13.3-11.5L441 224H316l-16 96h-88l-22.3-126.9h256.2l18-113.1c1.1-7.5-3.8-14.6-11-15.8z"}}]})(props);
	};
	module.exports.IoLogoBitcoin = function IoLogoBitcoin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M410.5 279.2c-5-11.5-12.7-21.6-28.1-30.1-8.2-4.5-16.1-7.8-25.4-10 5.4-2.5 10-5.4 16.3-11 7.5-6.6 13.1-15.7 15.6-23.3 2.6-7.5 4.1-18 3.5-28.2-1.1-16.8-4.4-33.1-13.2-44.8-8.8-11.7-21.2-20.7-37.6-27-12.6-4.8-25.5-7.8-45.5-8.9V32h-40v64h-32V32h-41v64H96v48h27.9c8.7 0 14.6.8 17.6 2.3 3.1 1.5 5.3 3.5 6.5 6 1.3 2.5 1.9 8.4 1.9 17.5V343c0 9-.6 14.8-1.9 17.4-1.3 2.6-2 4.9-5.1 6.3-3.1 1.4-3.2 1.3-11.8 1.3h-26.4L96 416h87v64h41v-64h32v64h40v-64.4c26-1.3 44.5-4.7 59.4-10.3 19.3-7.2 34.1-17.7 44.7-31.5 10.6-13.8 14.9-34.9 15.8-51.2.7-14.5-.9-33.2-5.4-43.4zM224 150h32v74h-32v-74zm0 212v-90h32v90h-32zm72-208.1c6 2.5 9.9 7.5 13.8 12.7 4.3 5.7 6.5 13.3 6.5 21.4 0 7.8-2.9 14.5-7.5 20.5-3.8 4.9-6.8 8.3-12.8 11.1v-65.7zm28.8 186.7c-7.8 6.9-12.3 10.1-22.1 13.8-2 .8-4.7 1.4-6.7 1.9v-82.8c5 .8 7.6 1.8 11.3 3.4 7.8 3.3 15.2 6.9 19.8 13.2 4.6 6.3 8 15.6 8 24.7 0 10.9-2.8 19.2-10.3 25.8z"}}]})(props);
	};
	module.exports.IoLogoBuffer = function IoLogoBuffer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M70.7 164.5l169.2 81.7c4.4 2.1 10.3 3.2 16.1 3.2s11.7-1.1 16.1-3.2l169.2-81.7c8.9-4.3 8.9-11.3 0-15.6L272.1 67.2c-4.4-2.1-10.3-3.2-16.1-3.2s-11.7 1.1-16.1 3.2L70.7 148.9c-8.9 4.3-8.9 11.3 0 15.6z"}},{"tag":"path","attr":{"d":"M441.3 248.2s-30.9-14.9-35-16.9-5.2-1.9-9.5.1S272 291.6 272 291.6c-4.5 2.1-10.3 3.2-16.1 3.2s-11.7-1.1-16.1-3.2c0 0-117.3-56.6-122.8-59.3-6-2.9-7.7-2.9-13.1-.3l-33.4 16.1c-8.9 4.3-8.9 11.3 0 15.6l169.2 81.7c4.4 2.1 10.3 3.2 16.1 3.2s11.7-1.1 16.1-3.2l169.2-81.7c9.1-4.2 9.1-11.2.2-15.5z"}},{"tag":"path","attr":{"d":"M441.3 347.5s-30.9-14.9-35-16.9-5.2-1.9-9.5.1S272.1 391 272.1 391c-4.5 2.1-10.3 3.2-16.1 3.2s-11.7-1.1-16.1-3.2c0 0-117.3-56.6-122.8-59.3-6-2.9-7.7-2.9-13.1-.3l-33.4 16.1c-8.9 4.3-8.9 11.3 0 15.6l169.2 81.7c4.4 2.2 10.3 3.2 16.1 3.2s11.7-1.1 16.1-3.2l169.2-81.7c9-4.3 9-11.3.1-15.6z"}}]})(props);
	};
	module.exports.IoLogoChrome = function IoLogoChrome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M188.8 255.925c0 36.946 30.243 67.178 67.2 67.178s67.199-30.231 67.199-67.178c0-36.945-30.242-67.179-67.199-67.179s-67.2 30.234-67.2 67.179z"}},{"tag":"path","attr":{"d":"M476.752 217.795c-.009.005-.016.038-.024.042-1.701-9.877-4.04-19.838-6.989-28.838h-.107c2.983 9 5.352 19 7.072 29h-.002c-1.719-10-4.088-20-7.07-29h-155.39c19.044 17 31.358 40.175 31.358 67.052 0 16.796-4.484 31.284-12.314 44.724L231.044 478.452s-.009.264-.014.264l-.01.284h.015l-.005-.262c8.203.92 16.531 1.262 24.97 1.262 6.842 0 13.609-.393 20.299-1.002a223.86 223.86 0 0 0 29.777-4.733C405.68 451.525 480 362.404 480 255.941c0-12.999-1.121-25.753-3.248-38.146z"}},{"tag":"path","attr":{"d":"M256 345.496c-33.601 0-61.601-17.91-77.285-44.785L76.006 123.047l-.137-.236a223.516 223.516 0 0 0-25.903 45.123C38.407 194.945 32 224.686 32 255.925c0 62.695 25.784 119.36 67.316 160.009 29.342 28.719 66.545 49.433 108.088 58.619l.029-.051 77.683-134.604c-8.959 3.358-19.031 5.598-29.116 5.598z"}},{"tag":"path","attr":{"d":"M91.292 104.575l77.35 133.25C176.483 197.513 212.315 166 256 166h205.172c-6.921-15-15.594-30.324-25.779-43.938.039.021.078.053.117.074C445.644 135.712 454.278 151 461.172 166h.172c-6.884-15-15.514-30.38-25.668-43.99-.115-.06-.229-.168-.342-.257C394.475 67.267 329.359 32 256 32c-26.372 0-51.673 4.569-75.172 12.936-34.615 12.327-65.303 32.917-89.687 59.406l.142.243.009-.01z"}}]})(props);
	};
	module.exports.IoLogoClosedCaptioning = function IoLogoClosedCaptioning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 96v320h448V96H32zm406 159.8c0 23.4-1.4 41.2-3.3 70.2s-16.8 49.4-51.7 52.6c-34.9 3.2-83.8 3.5-127 3.4-42.9.1-92-.1-127-3.4-34.9-3.2-49.7-23.6-51.7-52.6S74 279.2 74 255.8c0-23.4.1-38.6 3.3-70.2s20.1-49.2 51.7-52.4 86-3.2 127-3.2 95.4 0 127 3.2c31.6 3.2 48.5 20.9 51.7 52.4 3.2 31.6 3.3 46.9 3.3 70.2z"}},{"tag":"path","attr":{"d":"M357.5 280.4v.7c0 16.3-10.1 25.9-23.6 25.9-13.5 0-22.6-10.8-23.9-25.9 0 0-1.2-7.9-1.2-23.9s1.4-26 1.4-26c2.4-17 10.7-25.9 24.2-25.9 13.4 0 24.1 11.6 24.1 29.2v.5h45.1c0-21.9-5.5-41.6-16.6-54-11-12.4-27.5-18.6-49.3-18.6-10.9 0-20.9 1.4-30 4.3-9.1 2.9-17 7.9-23.6 15.1-6.6 7.2-11.7 16.8-15.4 28.9-3.6 12.1-5.5 27.3-5.5 45.7 0 18 1.5 33 4.4 45.1 3 12.1 7.3 21.7 13.1 28.9 5.8 7.2 13.1 12.2 21.8 15 8.8 2.8 19.1 4.2 30.9 4.2 25 0 43-6.4 53.8-18.7 10.8-12.3 16.2-30.3 16.2-53.9h-46.1c.2 0 .2 2.5.2 3.4zM202.6 280.4v.7c0 16.3-10.1 25.9-23.6 25.9-13.5 0-22.6-10.8-23.9-25.9 0 0-1.2-7.9-1.2-23.9s1.4-26 1.4-26c2.4-17 10.7-25.9 24.2-25.9 13.4 0 24.1 11.6 24.1 29.2v.5h45.1c0-21.9-5.5-41.6-16.6-54-11-12.4-27.5-18.6-49.3-18.6-10.9 0-20.9 1.4-30 4.3-9.1 2.9-17 7.9-23.6 15.1-6.6 7.2-11.7 16.8-15.4 28.9-3.6 12.1-5.5 27.3-5.5 45.7 0 18 1.5 33 4.4 45.1 3 12.1 7.3 21.7 13.1 28.9 5.8 7.2 13.1 12.2 21.8 15 8.8 2.8 19.1 4.2 30.9 4.2 25 0 43-6.4 53.8-18.7 10.8-12.3 16.2-30.3 16.2-53.9h-46.1c.2 0 .2 2.5.2 3.4z"}}]})(props);
	};
	module.exports.IoLogoCodepen = function IoLogoCodepen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M241.239 303.936c-15.322-10.357-30.742-20.569-46.062-30.93-2.03-1.373-3.43-1.472-5.502-.029l-38.871 26.154C181.966 319.905 244 361.317 244 361.317v-53.786c-.012-1.224-1.553-2.78-2.761-3.595zM195.092 240.666c15.454-10.16 30.851-20.409 46.109-30.86 1.486-1.018 2.775-3.509 2.799-5.334v-51.706s-62.033 41.124-93.262 61.942c13.7 9.159 26.671 17.913 39.787 26.443 1.02.662 3.396.284 4.567-.485zM269.838 209.354a4521.517 4521.517 0 0 0 47.627 31.815c.916.604 2.92.602 3.839 0l39.751-26.467L268 152.484v53.35c.01 1.201.805 2.821 1.838 3.52zM258.109 230.369c-1.21-.802-3.611-.528-4.743.168-4.817 2.962-9.463 6.203-14.164 9.355-8.248 5.53-25.356 17.023-25.356 17.023l38.842 25.865c1.748 1.157 4.436 1.22 6.26.111l39.014-25.993c.001 0-34.079-22.701-39.853-26.529zM141 237.116v39.609l29.622-19.838z"}},{"tag":"path","attr":{"d":"M256 32C132.288 32 32 132.288 32 256s100.288 224 224 224 224-100.288 224-224S379.712 32 256 32zm139 265.006c0 5.785-2.652 9.868-7.511 13.094a38019.909 38019.909 0 0 0-123.286 82.188c-5.854 3.918-11.174 3.754-16.984-.137-40.783-27.314-81.719-54.546-122.625-81.676-5.11-3.389-7.594-7.557-7.594-13.73v-79.729c0-6.141 2.521-10.332 7.624-13.716 40.906-27.13 81.939-54.363 122.724-81.676 5.818-3.896 11.094-4.007 16.938-.095a41090.004 41090.004 0 0 0 123.261 82.195c4.678 3.106 7.453 6.943 7.453 12.66v80.622z"}},{"tag":"path","attr":{"d":"M316.247 273.234a3826.352 3826.352 0 0 1-45.386 30.332c-2.412 1.588-2.888 3.318-2.861 6.189v51.346l93.039-62.004-38.527-25.882c-2.345-1.604-3.93-1.567-6.265.019zM370 276.676V237.06l-29.59 19.873z"}}]})(props);
	};
	module.exports.IoLogoCss3 = function IoLogoCss3 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.282 339.488zM64 32l34.946 403.219L255.767 480l157.259-44.85L448 32H64zm290.676 334.898l-98.607 28.125-98.458-28.248L150.864 289h48.253l3.433 39.562 53.586 15.163.132.273h.034l53.467-14.852L315.381 265H203l-4-50h120.646l4.396-51H140l-4-49h240.58l-21.904 251.898z"}}]})(props);
	};
	module.exports.IoLogoDesignernews = function IoLogoDesignernews (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M290.4 145L227 96l63.6 102.2z"}},{"tag":"path","attr":{"d":"M329 96v163h-36.4l-63.2-98.6 1.7 98.6H191V152l-37.3-29.3c1 1.2 2 2.4 2.9 3.7 10 13.9 15 30.5 15 50.5 0 49.2-30.6 82.1-76.9 82.1H32v.4L231.6 416H480V214.1L329 96z"}},{"tag":"path","attr":{"d":"M129.9 178.1c0-29-14.2-45.1-39.7-45.1H71v89h19c26 0 39.9-15.4 39.9-43.9z"}}]})(props);
	};
	module.exports.IoLogoDribbble = function IoLogoDribbble (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C150 64 64 150 64 256c0 106.1 86 192 192 192s192-85.9 192-192c0-106-86-192-192-192zm121.9 88.5c21.6 25.4 35.3 57.6 37.7 92.9-34.6-1.8-76-1.8-109.2 1.3-4.2-10.6-8.5-21-13.2-31 38.3-16.6 67.8-38.4 84.7-63.2zM256 96c38.8 0 74.4 13.8 102.1 36.8-17.4 22-44.7 41.1-78.7 55.6-18.6-34.4-40-64-62.8-87.3 12.7-3.2 25.8-5.1 39.4-5.1zm-72.4 17.5c23.1 23 44.8 52.3 63.8 86.6-36.1 11-77.5 17.3-121.7 17.3-8.4 0-16.6-.3-24.7-.8 11.5-45.1 42-82.5 82.6-103.1zM96.3 248.4c9.1.4 18.3.6 27.6.5 50.4-.6 97.3-8.5 137.6-21.4 3.8 7.9 7.4 16 10.8 24.3-5.5 1.3-10.4 2.7-14.3 4.3-55.1 23.1-98.5 60.4-122 105.5-24.8-28.2-40-65.1-40-105.6 0-2.6.1-5.1.3-7.6zM256 416c-37 0-71-12.6-98.1-33.7 21.3-42.2 59.3-77.1 107.2-98.8 4.5-2.1 10.5-3.8 17.4-5.3 5.7 15.8 10.8 32.2 15.3 49.2 6.9 26.5 11.8 52.7 14.8 78.1C295 412.2 276 416 256 416zm86.5-25.5c-3-25.7-7.9-52.1-14.9-78.9-3.4-13-7.3-25.6-11.5-37.9 31.4-2.6 69-2.2 98.9 0-5.4 49.1-33 91.3-72.5 116.8z"}}]})(props);
	};
	module.exports.IoLogoDropbox = function IoLogoDropbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M177 77L64 150.9l78.1 62.7L256 143.1zM64 276.3l113 73.9 79-66.1-113.9-70.5zM256 284.1l79 66.1 113-73.9-78.1-62.7zM448 150.9L335 77l-79 66.1 113.9 70.5z"}},{"tag":"path","attr":{"d":"M256.2 298.3l-79.8 66-34.4-22.2V367l114 68 114-68v-24.9l-34.2 22.2z"}}]})(props);
	};
	module.exports.IoLogoEuro = function IoLogoEuro (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M234 272v-48h131.094l7.149-48H234v-1.83c0-35.92 14.975-58.086 79.25-58.086 26.264 0 55.867 2.498 93.189 8.742L416 59.866C377.988 51.123 345.306 48 310.057 48 195.326 48 146 89.225 146 165.43V176H96v48h50v48H96v48h50v26.57C146 422.774 195.297 464 310.027 464c35.25 0 67.848-3.123 105.859-11.866l-9.619-64.96c-37.322 6.244-66.781 8.742-93.045 8.742-64.276 0-79.223-18.739-79.223-63.086V320h116.795l7.148-48H234z"}}]})(props);
	};
	module.exports.IoLogoFacebook = function IoLogoFacebook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426.8 64H85.2C73.5 64 64 73.5 64 85.2v341.6c0 11.7 9.5 21.2 21.2 21.2H256V296h-45.9v-56H256v-41.4c0-49.6 34.4-76.6 78.7-76.6 21.2 0 44 1.6 49.3 2.3v51.8h-35.3c-24.1 0-28.7 11.4-28.7 28.2V240h57.4l-7.5 56H320v152h106.8c11.7 0 21.2-9.5 21.2-21.2V85.2c0-11.7-9.5-21.2-21.2-21.2z"}}]})(props);
	};
	module.exports.IoLogoFlickr = function IoLogoFlickr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 64H160c-52.8 0-96 43.2-96 96v192c0 52.8 43.2 96 96 96h192c52.8 0 96-43.2 96-96V160c0-52.8-43.2-96-96-96zM184 304c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"}}]})(props);
	};
	module.exports.IoLogoFoursquare = function IoLogoFoursquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376.764 32H138.541C105.666 32 96 56.798 96 72.414v379.64c0 17.591 9.425 24.117 14.718 26.267 5.299 2.155 19.916 3.971 28.673-6.168 0 0 112.469-130.895 114.4-132.834 2.921-2.93 2.921-2.93 5.844-2.93h72.767c30.574 0 35.49-21.869 38.684-34.752 2.659-10.789 32.489-163.962 42.452-212.559C421.143 51.993 411.745 32 376.764 32zm-5.678 269.637c2.659-10.789 32.489-163.962 42.452-212.559m-50.846 7.592l-9.999 51.734c-1.195 5.65-8.287 11.595-14.863 11.595h-95.917C231.473 160 224 166.138 224 176.602v13.448c0 10.473 7.519 17.894 17.965 17.894h81.848c7.374 0 14.61 8.109 13.016 16.005-1.602 7.908-9.086 46.569-9.984 50.89-.902 4.328-5.845 11.725-14.611 11.725h-64.269c-11.705 0-15.244 1.533-23.074 11.293-7.837 9.77-78.256 94.592-78.256 94.592-.713.822-1.41.584-1.41-.312V95.896c0-6.684 5.793-14.523 14.479-14.523h191.173c7.035-.001 13.611 6.631 11.815 15.297z"}}]})(props);
	};
	module.exports.IoLogoFreebsdDevil = function IoLogoFreebsdDevil (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.6 115c-22.5-43.7-58-51-58-51s15.5 32 16 51c.4 16.1-5.5 28-27.2 33.5s-30.8-2-47.8-17.5-41.6-26.5-72.6-28c-40-2-77 9-77 9-20-25 20-80 20-80-74.5 29.5-93.7 83.3-96 113.7-1.9 24.1 8.5 40.8 8.5 40.8s-.5 27.8-5 42c-3.1 9.8-16.9 25-26 34.5-12.2 12.7-12.5 38.5 0 57s44 27.5 67 39.5 31.5 21 31.5 21 1 8.3.5 15.3-3.2 14-9 18.2c-5.5 3.9-15.5.5-20.5-2s-5-6.2-10.5-8-7.3-4-6.5-11 2-9-3.5-18.5-18.5-9.5-29.5-8-17.3 6.8-17.3 6.8l-16.3-10s8.5-15.6 5.2-35.6c-7.3-43.8-50-62.8-50-62.8L89 309.3s1.1-2.6 6.4-6.4 8.1-3.6 8.1-3.6 6.6 7.6 9.1 25.3c2.5 18-6.7 27.2-6.7 27.2l-28.3-18 1-14.5L39.8 309 56 345.7l15-4 24 22.7s-15.7 11.7-33 11.7c-11 0-22-6-22-6s-1.4-1-.8-5.5c.7-5 6.8-12.5 6.8-12.5H0s27.3 38.7 65 38.7c31 0 44.2-12.5 44.2-12.5L128 397s3 5.5 0 7-7 3.5-9 15 18 29 18 29c21.8 17.8 7 32 7 32h272c-9-13-22.5-18-32-32 0 0-44.8-58.4-1.8-90.4 57.4-42.7 42.8-69.4 41.2-101.4 0 0 31.8-6.6 59.3-33.6s38.9-70.8 19.9-107.6zM195 203c-16.9 4.5-22.5 35.5-22.5 35.5 1.5-63 57.5-93 65-89s-6.5 39-21 64c0 0-8-14.1-21.5-10.5zm37 15s18-56 37.5-59.5 41.5 21 41.5 62-26 65.4-42.8 69.2c-16.5 3.8-23 2-23 2s27.5-21.6 23.5-56.8c-2.8-24.7-31.4-24.2-36.7-16.9z"}}]})(props);
	};
	module.exports.IoLogoGameControllerA = function IoLogoGameControllerA (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.3 146H142.7C81.5 146 32 191.5 32 255.4c0 64 49.5 110.6 110.7 110.6h226.5c61.2 0 110.7-46.6 110.7-110.6.1-63.9-49.4-109.4-110.6-109.4zM200 266.7c0 2.7-2.4 5.3-5.2 5.3H160v35.1c0 2.8-3.1 4.9-5.8 4.9h-21.4c-2.6 0-4.8-1.9-4.8-4.5V272H92.9c-2.8 0-4.9-3.1-4.9-5.8v-21.4c0-2.6 1.9-4.8 4.5-4.8H128v-34.8c0-2.8 1.9-5.2 4.6-5.2h22.1c2.7 0 5.3 2.4 5.3 5.2V240h34.8c2.8 0 5.2 1.9 5.2 4.6v22.1zm119.8 8.8c-10.7 0-19.5-8.6-19.5-19.2s8.7-19.2 19.5-19.2 19.5 8.6 19.5 19.2-8.8 19.2-19.5 19.2zm42.5 41.8c-10.7 0-19.5-8.5-19.5-19.1 0-10.6 8.7-19.2 19.5-19.2s19.5 8.5 19.5 19.2c0 10.6-8.7 19.1-19.5 19.1zm0-83.7c-10.7 0-19.5-8.6-19.5-19.1 0-10.6 8.7-19.2 19.5-19.2s19.5 8.6 19.5 19.2c0 10.5-8.7 19.1-19.5 19.1zm42.6 41.9c-10.7 0-19.4-8.6-19.4-19.2s8.7-19.2 19.4-19.2 19.5 8.6 19.5 19.2c-.1 10.6-8.8 19.2-19.5 19.2z"}}]})(props);
	};
	module.exports.IoLogoGameControllerB = function IoLogoGameControllerB (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M135.1 204.6c-10.7 0-19.3 8.7-19.3 19.4s8.7 19.4 19.3 19.4c10.6 0 19.3-8.7 19.3-19.4s-8.6-19.4-19.3-19.4z"}},{"tag":"path","attr":{"d":"M466.3 248.9c-21.2-88.5-43.6-135.5-88.5-148.8-9.8-2.9-18.1-4-25.7-4-27.6 0-46.9 14.7-96.1 14.7-49.2 0-68.5-14.7-96.1-14.7-7.7 0-16 1.1-25.7 4-44.9 13.3-67.3 60.4-88.5 148.8-21.2 88.5-17.3 152.4 7.7 164.3 4.1 1.9 8.2 2.8 12.5 2.8 21.7 0 45.1-23.8 67.7-52 25.7-32.1 32.1-33 110.3-33h24.3c78.1 0 84.6.8 110.3 33 22.5 28.2 46 52 67.7 52 4.2 0 8.4-.9 12.5-2.8 24.9-12 28.7-75.9 7.6-164.3zm-331.1 14.7c-21.6 0-39.2-17.8-39.2-39.6s17.6-39.6 39.2-39.6c21.7 0 39.2 17.8 39.2 39.6.1 21.9-17.5 39.6-39.2 39.6zm172.9-19.5c-11.1 0-20.1-9-20.1-20.1 0-11.1 9-20.1 20.1-20.1 11.1 0 20.1 9 20.1 20.1 0 11.1-9 20.1-20.1 20.1zM352 288c-11.1 0-20.1-9-20.1-20 0-11.2 9-20.1 20.1-20.1 11.1 0 20.1 8.9 20.1 20.1 0 11-9 20-20.1 20zm0-87.8c-11.1 0-20.1-9-20.1-20.1 0-11.1 9-20.1 20.1-20.1 11.1 0 20.1 9 20.1 20.1 0 11.1-9 20.1-20.1 20.1zm43.9 43.9c-11.1 0-20.1-9-20.1-20.1 0-11.1 9-20.1 20.1-20.1 11.1 0 20.1 9 20.1 20.1 0 11.1-9 20.1-20.1 20.1z"}}]})(props);
	};
	module.exports.IoLogoGithub = function IoLogoGithub (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.3 32 32 134.9 32 261.7c0 101.5 64.2 187.5 153.2 217.9 1.4.3 2.6.4 3.8.4 8.3 0 11.5-6.1 11.5-11.4 0-5.5-.2-19.9-.3-39.1-8.4 1.9-15.9 2.7-22.6 2.7-43.1 0-52.9-33.5-52.9-33.5-10.2-26.5-24.9-33.6-24.9-33.6-19.5-13.7-.1-14.1 1.4-14.1h.1c22.5 2 34.3 23.8 34.3 23.8 11.2 19.6 26.2 25.1 39.6 25.1 10.5 0 20-3.4 25.6-6 2-14.8 7.8-24.9 14.2-30.7-49.7-5.8-102-25.5-102-113.5 0-25.1 8.7-45.6 23-61.6-2.3-5.8-10-29.2 2.2-60.8 0 0 1.6-.5 5-.5 8.1 0 26.4 3.1 56.6 24.1 17.9-5.1 37-7.6 56.1-7.7 19 .1 38.2 2.6 56.1 7.7 30.2-21 48.5-24.1 56.6-24.1 3.4 0 5 .5 5 .5 12.2 31.6 4.5 55 2.2 60.8 14.3 16.1 23 36.6 23 61.6 0 88.2-52.4 107.6-102.3 113.3 8 7.1 15.2 21.1 15.2 42.5 0 30.7-.3 55.5-.3 63 0 5.4 3.1 11.5 11.4 11.5 1.2 0 2.6-.1 4-.4C415.9 449.2 480 363.1 480 261.7 480 134.9 379.7 32 256 32z"}}]})(props);
	};
	module.exports.IoLogoGoogle = function IoLogoGoogle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M457.6 224l-2.1-8.9H262V297h115.6c-12 57-67.7 87-113.2 87-33.1 0-68-13.9-91.1-36.3-23.7-23-38.8-56.9-38.8-91.8 0-34.5 15.5-69 38.1-91.7 22.5-22.6 56.6-35.4 90.5-35.4 38.8 0 66.6 20.6 77 30l58.2-57.9c-17.1-15-64-52.8-137.1-52.8-56.4 0-110.5 21.6-150 61C72.2 147.9 52 204 52 256s19.1 105.4 56.9 144.5c40.4 41.7 97.6 63.5 156.5 63.5 53.6 0 104.4-21 140.6-59.1 35.6-37.5 54-89.4 54-143.8 0-22.9-2.3-36.5-2.4-37.1z"}}]})(props);
	};
	module.exports.IoLogoGoogleplus = function IoLogoGoogleplus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M318.2 230.9l-1.6-7H160V288h90.7c-9.4 45-48.4 63.6-84.1 63.6-26 0-50.2-7.8-68.3-25.3-18.6-18.1-28.9-43.1-28.9-70.4 0-27.1 9.8-51.8 27.6-69.6 17.7-17.7 42-25.4 68.7-25.4 30.5 0 49.9 13.8 58.1 21.1l48-47.7C258.3 122.6 221.5 93 164.1 93c-44.3 0-86.7 16.8-117.7 47.8C15.9 171.3 0 215.2 0 256s15 82.6 44.6 113.3C76.3 402 121.2 419 167.5 419c42.1 0 81.9-16.5 110.3-46.3 28-29.4 42.4-70.1 42.4-112.7-.1-18-1.9-28.7-2-29.1zM512 224h-57v-57h-41v57h-57v41h57v57h41v-57h57z"}}]})(props);
	};
	module.exports.IoLogoHackernews = function IoLogoHackernews (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 64v384h384V64H64zm214 215v72h-40v-72l-66-120h47.1l39.7 83.6 38-83.6H342l-64 120z"}}]})(props);
	};
	module.exports.IoLogoHtml5 = function IoLogoHtml5 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 32l34.936 403.213L255.769 480l157.245-44.854L448 32H64zm307.997 132h-184l3.991 51h176.008l-13.505 151.386-98.5 28.094-98.682-27.976L150.545 289h48.254l3.423 39.287 53.769 14.781 53.422-14.915L314.987 264H147.986l-12.571-149.589 240.789.016L371.997 164z"}}]})(props);
	};
	module.exports.IoLogoInstagram = function IoLogoInstagram (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 96c21.2 0 41.3 8.4 56.5 23.5S416 154.8 416 176v160c0 21.2-8.4 41.3-23.5 56.5S357.2 416 336 416H176c-21.2 0-41.3-8.4-56.5-23.5S96 357.2 96 336V176c0-21.2 8.4-41.3 23.5-56.5S154.8 96 176 96h160m0-32H176c-61.6 0-112 50.4-112 112v160c0 61.6 50.4 112 112 112h160c61.6 0 112-50.4 112-112V176c0-61.6-50.4-112-112-112z"}},{"tag":"path","attr":{"d":"M360 176c-13.3 0-24-10.7-24-24s10.7-24 24-24c13.2 0 24 10.7 24 24s-10.8 24-24 24zM256 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64m0-32c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"}}]})(props);
	};
	module.exports.IoLogoIonic = function IoLogoIonic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 161.2c-52.3 0-94.8 42.5-94.8 94.8s42.5 94.8 94.8 94.8 94.8-42.5 94.8-94.8-42.5-94.8-94.8-94.8z"}},{"tag":"circle","attr":{"cx":"392.1","cy":"126.4","r":"43.2"}},{"tag":"path","attr":{"d":"M445.3 169.8l-1.8-4-2.9 3.3c-7.1 8-16.1 14.2-26.1 17.9l-2.8 1 1.1 2.7c8.6 20.7 13 42.7 13 65.2 0 93.7-76.2 169.9-169.9 169.9S86.1 349.7 86.1 256 162.3 86.1 256 86.1c25.4 0 49.9 5.5 72.8 16.4l2.7 1.3 1.2-2.7c4.2-9.8 10.8-18.5 19.2-25.2l3.4-2.7-3.9-2C321.6 55.8 289.5 48 256 48 141.3 48 48 141.3 48 256s93.3 208 208 208 208-93.3 208-208c0-30-6.3-59-18.7-86.2z"}}]})(props);
	};
	module.exports.IoLogoIonitron = function IoLogoIonitron (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M468.4 269.2c-2.7-34.2-12.2-59.2-32.9-57.3 6.4 14.6 12.2 48.1 8.7 72-1.4-25.9-6.3-50.2-17.2-72-32.1-64.6-100.6-107.4-177.5-103.1-85.9 4.8-155 66.7-172 146.8l-11.4 1.6c-17.2 2.4-26.9 34.9-21.7 72.5 5.3 37.7 23.5 66.2 40.7 63.8l15.8-2.2c34.7 56.3 98.5 92.3 169.3 88.4 85.3-4.7 154-65.9 171.7-145.2l7.4-.4c15.2-2.5 21.8-31.2 19.1-64.9zM90.3 264c10.7 8.2 25.4 28.3 29.1 55.1 3.9 27.7-4.8 54.1-13.4 64.3 6-14.8 8.1-37.3 4.7-61.9-3.3-24-11-44.7-20.4-57.5zm183.8 116.2c-8.5.5-15.8-6-16.3-14.5s6-15.7 14.6-16.2c8.5-.5 15.8 6 16.3 14.5s-6.1 15.7-14.6 16.2zm81-4.7c-8.5.5-15.8-6-16.3-14.5s6-15.7 14.6-16.2c8.5-.5 15.8 6 16.3 14.5.4 8.5-6.1 15.8-14.6 16.2zM165.5 70s0 .1 0 0c.1.1.1.2.1.2.1.2.2.3.3.5v.1c.4 1 1.1 1.9 2.3 2.7 2 1.5 5 2.4 8.6 3 3.4.5 7.5.7 11.9.5 1 0 1.9-.1 2.9-.2-.4-.4-.8-.9-1.2-1.3h-1.3c-4.3.1-8.2-.2-11.6-.9-3.5-.7-6.4-1.8-8.4-3.4-.6-.5-1-.9-1.4-1.4-.2-.7-.2-1.5 0-2.3.5-2.3 2.4-4.8 5.5-7.4 2.7-2.3 6.4-4.7 10.9-7 .9-.4 1.7-.9 2.6-1.3.1-.1.3-.1.5-.2-.8 3.3-.9 6.9-.2 10.5 2.3 11.9 11.6 20.3 23.2 20.6l4 24.3 12.7-2-4-24.3c10.8-4.6 16.3-16.1 14-28-.7-3.5-2-6.7-3.9-9.5-5.3-.8-15.6-.8-29.2 2.1 1.1-.3 2.1-.7 3.2-1 7.6-2.1 14.9-3.5 21.5-4.2.6-.1 1.2-.1 1.8-.2 1.2-.1 2.4-.2 3.5-.3h.6c4.1-.2 7.7-.1 10.8.3 2.4.3 4.4.8 6.1 1.4-.6.9-.9 2-.9 3.2 0 2.7 1.8 5 4.3 5.8-.6.9-1.3 1.9-2.1 2.8-.8.9-1.8 1.9-2.9 2.8-1.1.9-2.3 1.8-3.5 2.7l-6.5 3.8-.3 1.5c.1 0 .2-.1.2-.1l8.4-4.7c1.2-.8 2.4-1.6 3.4-2.4 1.2-.9 2.2-1.8 3.2-2.8.9-.9 1.7-1.9 2.4-2.8l.3-.6c3-.4 5.4-2.9 5.4-6 0-3.4-2.7-6.1-6.1-6.1-1 0-1.9.3-2.8.7-2-1.2-4.8-2.1-8.2-2.7-4.3-.8-9.6-1-15.5-.6-.7 0-1.4.1-2.1.2-.7.1-1.3.2-2 .2-5.3-3.5-11.9-5-18.7-3.7-7.9 1.5-14.2 6.5-17.8 13-1.3.5-2.6 1.1-3.8 1.7-.7.3-1.3.6-2 .9-5.9 2.9-10.6 6.1-13.9 9.1-3.1 2.9-4.9 5.7-5.3 8.3-.2 1.4 0 2.8.7 4 .1.1.2.3.3.5z"}}]})(props);
	};
	module.exports.IoLogoJavascript = function IoLogoJavascript (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 88.001h-80v212.498c0 52.58-18.032 67.261-49.412 67.261-14.705 0-27.948-2.521-38.25-6.063L32 423.904C46.7 428.966 69.259 432 86.907 432 158.955 432 208 398.129 208 301.02V88.001zM382.463 80C305.02 80 256 123.998 256 182.154c0 50.083 37.751 81.44 92.641 101.665 39.7 14.158 55.392 26.808 55.392 47.539 0 22.756-18.139 37.425-52.448 37.425-31.863 0-60.789-10.64-80.394-21.255v-.021L256 410.727c18.639 10.638 53.441 21.255 91.167 21.255C437.854 431.98 480 383.43 480 326.284c0-48.55-26.958-79.9-85.278-102.163-43.139-17.191-61.27-26.795-61.27-48.542 0-17.2 15.688-32.869 48.043-32.869 31.846 0 53.744 10.707 66.505 17.291l19.125-64C447.125 87.22 420.188 80 382.463 80z"}}]})(props);
	};
	module.exports.IoLogoLinkedin = function IoLogoLinkedin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M417.2 64H96.8C79.3 64 64 76.6 64 93.9V415c0 17.4 15.3 32.9 32.8 32.9h320.3c17.6 0 30.8-15.6 30.8-32.9V93.9C448 76.6 434.7 64 417.2 64zM183 384h-55V213h55v171zm-25.6-197h-.4c-17.6 0-29-13.1-29-29.5 0-16.7 11.7-29.5 29.7-29.5s29 12.7 29.4 29.5c0 16.4-11.4 29.5-29.7 29.5zM384 384h-55v-93.5c0-22.4-8-37.7-27.9-37.7-15.2 0-24.2 10.3-28.2 20.3-1.5 3.6-1.9 8.5-1.9 13.5V384h-55V213h55v23.8c8-11.4 20.5-27.8 49.6-27.8 36.1 0 63.4 23.8 63.4 75.1V384z"}}]})(props);
	};
	module.exports.IoLogoMarkdown = function IoLogoMarkdown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.659 96H64.341C46.504 96 32 110.484 32 128.308v255.349C32 401.493 46.504 416 64.341 416h383.318C465.496 416 480 401.493 480 383.656V128.308C480 110.484 465.496 96 447.659 96zM284.023 352h-56.048v-96l-42.04 53.878L143.913 256v96H87.869V160h56.044l42.022 67.98 42.04-67.98h56.048v192zm83.657 0l-69.635-96h42v-96h56.043v96h42.027l-70.453 96h.018z"}}]})(props);
	};
	module.exports.IoLogoModelS = function IoLogoModelS (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M443.6 208.4c-3.1-1.9-2.2-6.6 1.3-7.3l5.3-1.1c7.1 0 22.4-2.3 25.6-5.4 3.1-3.2 4.2-5.4 4.2-8.2s-1.7-7.7-4.8-11.1c-3-3.4-16-5.2-23.7-6.2s-8.7 0-10.7 1.2c-2 1.3-2.8 9.5-3.1 15-.1 1.2-.9 2.2-2.1 2.5l-.4.1c-3.3.7-6.6-1.1-7.8-4.3-4.6-13-10.7-32.5-19.4-48.4-11.5-20.8-23.5-27.4-28.5-29-4.9-1.5-9.4-2.6-43-6.1-33.8-3.6-63.1-4.1-80.5-4.1s-46.7.5-80.6 4.1c-33.6 3.4-38.1 4.5-43 6.1-5 1.6-17 8.2-28.5 29-9.4 17.1-15.7 38.3-20.4 51.3-.6 1.5-2.2 2.4-3.8 2.1-3.1-.7-5.4-3.3-5.6-6.5-.4-5-1.2-10.7-2.9-11.7-2-1.3-3-2.2-10.7-1.2s-20.6 2.8-23.7 6.2c-3 3.4-4.7 8.3-4.7 11.1s1.1 5.1 4.2 8.3c3.1 3.2 18.5 5.4 25.6 5.4l5.3 1.1c3.5.7 4.4 5.4 1.3 7.3-9.1 5.7-23.2 15.3-32.3 25.6 0 0-4.1 28.7-4.1 62.1 0 48 5.8 92.4 5.8 92.4 1.8.3 3.6.6 5.3.9 0 1.2.7 13.1 2 21.2.3 2 1.3 5.5 6.2 5.5h64.7c1.9 0 5.1-1.6 5.1-3.7l1-17c7.2.1 3.2.1 10.9 0 24.8-.3 15.6-7.5 27.1-7.3 11.3.2 55 3 96 3s84.7-2.8 96-3c11.5-.2 2.3 7.1 27.1 7.3 7.7.1 4.7.1 11.9 0l1 17c0 2.1 3.2 3.7 5.1 3.7h63.5c4.9 0 5.9-3.5 6.2-5.5 1.3-8.1 1.9-19.9 2-21.2l5.4-.9s5.8-44.3 5.8-92.4c0-33.5-4.1-62.1-4.1-62.1-9.3-10.5-23.4-20.1-32.5-25.8zm-320.2-53.6c2.2-5.1 5.9-11.6 10-17.2 5-6.7 12.4-11.2 20.6-12.5 16.7-2.7 52.6-7.3 101.9-7.3 49.3 0 85.2 4.6 101.9 7.3 8.2 1.3 15.6 5.8 20.6 12.5 4.2 5.6 7.9 12.1 10.1 17.2 3.9 9.2 10.4 30.7 9.4 33.2-1 2.5 1 3.7-12.2 2.6-13.1-1-90.6-2.1-129.7-2.1-39.2 0-116.7 1.1-129.7 2.1-13.2 1.1-11.3-.2-12.2-2.6s5.4-24 9.3-33.2zm8.4 116c-9.9 0-29.8-1-34.5-1.2-4.7-.1-8.8 3.8-11.2 3.8s-25.5-3.6-28-14.9c-1.7-7.5-1.1-15.2-.6-19.5.3-1.9 1.9-3.4 3.8-3.5 14.4-.5 29.2.5 55.3 7.9 17.3 4.9 29.8 12.6 36.9 17.8 2.8 2.1 1.8 6.5-1.7 7.2-6.1 1.1-14.4 2.4-20 2.4zm210.4 73c-12.7 1.7-58.5 2.2-86.2 2.2s-73.5-.5-86.2-2.2c-13.1-1.7-29.8-17.3-18.4-30.2 7.6-8.5 20.8-13.6 48.9-17.3 29.8-3.8 48.6-4.3 55.6-4.3s25.8.5 55.6 4.3c28.1 3.7 43.2 9.6 48.9 17.3 10.4 13.8-5.1 28.4-18.2 30.2zm111.7-85.2c-2.5 11.2-25.6 14.9-28 14.9s-6.5-3.9-11.2-3.8c-4.7.2-24.6 1.2-34.5 1.2-5.5 0-13.8-1.3-20-2.4-3.5-.6-4.5-5.1-1.7-7.2 7.1-5.2 19.6-12.9 36.9-17.8 26.1-7.4 40.8-8.4 55.3-7.9 2 .1 3.6 1.5 3.8 3.5.5 4.3 1.1 12-.6 19.5z"}}]})(props);
	};
	module.exports.IoLogoNoSmoking = function IoLogoNoSmoking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M360 256h16v48h-16zM112 304h129.6l-48-48H112z"}},{"tag":"path","attr":{"d":"M364.5 60.1c-.4-.2-.7-.4-1-.6-10.9-6-22.5-10.7-34.4-14.8l-5.4-1.8C302.3 36.1 279.6 32 256 32 132.3 32 32 132.3 32 256c0 84.3 46.6 157.6 115.4 195.8.4.2.7.5 1.1.7 10.9 6 22.5 10.7 34.4 14.8l5.4 1.8c21.4 6.8 44 10.9 67.7 10.9 123.7 0 224-100.3 224-224 0-84.3-46.6-157.7-115.5-195.9zM256 426.4c-9.3 0-18.4-.9-27.2-2.4-9.8-1.6-19.3-4.1-28.5-7.3-1.9-.6-3.8-1.2-5.6-1.9-6.5-2.5-12.9-5.3-19-8.6-53.6-28.7-90.1-85.2-90.1-150.3 0-37.2 12.4-71.4 32.7-99.4l237.2 237.2c-28.1 20.3-62.3 32.7-99.5 32.7zm137.8-71L156.6 118.2c28-20.2 62.1-32.6 99.4-32.6 9.3 0 18.3.9 27.2 2.4 9.8 1.6 19.3 4.1 28.5 7.3 1.8.6 3.7 1.2 5.6 1.9 6.2 2.4 12.2 5 18 8.1 54.2 28.5 91.2 85.3 91.2 150.8-.1 37.2-12.5 71.3-32.7 99.3z"}},{"tag":"path","attr":{"d":"M352 256h-34l34 34zM384 256h16v48h-16zM360.1 212.7c-8.8-4.1-22-5.7-45.6-5.7h-3.6c-12.7.1-15.9-.1-20-6.1-2.8-4.2-1-14.8 3.7-21.9 1.6-2.4 1.8-5.6.4-8.2-1.4-2.6-4.1-4.2-7-4.3-.1 0-9.4-.1-18.3-3.9-10.6-4.5-15.6-12.1-15.6-23.1 0-25.8 21.8-27.7 22.8-27.7v-16c-12 0-38.8 11-38.8 43.7 0 17.5 9 31 25.7 38 4.2 1.7 8.4 2.9 12 3.6-3.3 9.8-3.6 20.9 1.7 28.7 9 13.3 20.3 13.2 33.3 13.1h3.5c26.3 0 34.6 2.3 38.9 4.3 5.7 2.6 6.8 7.5 6.6 15.7v1h16v-1c0-7.1.3-22.8-15.7-30.2z"}},{"tag":"path","attr":{"d":"M400 244c0-25.7-3-39.2-9.1-49.6C382.3 180 368.5 172 352 172h-17.4c2.9-8.3 5.4-19.8 3.5-30.9-3.2-18.8-19.1-30-43.1-30v16c21 0 26.1 9.1 27.4 16.7 2.5 14.5-6.8 32.1-6.9 32.3-1.4 2.5-1.3 5.5.1 7.9s4.1 3.9 6.9 3.9H352c10.9 0 19.4 4.9 25.1 14.6 3.1 5.3 6.9 13.5 6.9 41.4h16v.1z"}}]})(props);
	};
	module.exports.IoLogoNodejs = function IoLogoNodejs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.917 480a32.536 32.536 0 0 1-16.633-4.599l-52.985-32.44c-7.914-4.562-4.023-6.203-1.443-7.141 10.565-3.781 13.713-5.657 24.947-12.285 1.206-.667 2.747-.424 3.955.322l39.71 23.504c1.476.85 3.557.85 4.931 0l155.188-92.246c1.475-.877 2.415-2.646 2.415-4.441V163.869c0-1.85-.94-3.592-2.449-4.528l-155.12-94.672c-1.478-.894-3.421-.894-4.898 0L98.516 159.374c-1.544.903-2.516 2.698-2.516 4.495v186.805c0 1.813.972 3.513 2.481 4.389l39.929 23.972c23.61 12.204 37.59-.17 37.59-14.611V180.725c0-2.652 2.047-4.727 4.596-4.727h22.809c2.515 0 4.597 2.072 4.597 4.727v183.698c0 32.563-19.353 51.248-49.199 51.248-9.156 0-16.397 0-36.552-10.279l-41.584-24.781C70.371 374.459 64 362.965 64 350.656V161.191c0-12.316 6.371-23.784 16.665-29.917L239.35 36.41c10.027-5.88 23.374-5.88 33.332 0l158.65 94.864C441.63 137.423 448 148.899 448 161.191v189.465c0 12.309-6.37 23.75-16.668 29.953l-158.65 94.774a32.52 32.52 0 0 1-16.698 4.599l-.067.018z"}},{"tag":"path","attr":{"d":"M304.943 351.998c-64.61 0-84.006-31.61-84.006-59.271 0-2.629 2.048-4.729 4.562-4.729h20.521c2.282 0 4.227 1.7 4.562 4.016 3.084 21.602 16.748 31.15 54.324 31.15 33.399 0 47.091-10.346 47.091-28.684 0-10.592-3.463-18.424-55.407-23.697-43.427-4.441-70.288-14.373-70.288-50.295 0-33.135 26.996-52.49 72.234-52.49 46.128 0 76.462 14 79.173 50.829.102 1.337-.368 2.629-1.241 3.644-.871.965-2.078 1.527-3.353 1.527h-20.591c-2.146 0-4.024-1.562-4.459-3.713-4.401-16.953-16.97-23.402-49.563-23.402-36.486 0-40.746 12.753-40.746 22.607 0 11.963 5.031 15.441 54.294 22.172 48.761 6.663 71.933 16.117 71.933 51.552 0 35.781-28.808 58.783-79.075 58.783l.035.001z"}}]})(props);
	};
	module.exports.IoLogoNpm = function IoLogoNpm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M227.6 213.1H256v57.1h-28.4z"}},{"tag":"path","attr":{"d":"M0 156v171.4h142.2V356H256v-28.6h256V156H0zm142.2 142.9h-28.4v-85.7H85.3v85.7H28.4V184.6h113.8v114.3zm142.2 0h-56.9v28.6h-56.9V184.6h113.8v114.3zm199.2 0h-28.4v-85.7h-28.4v85.7h-28.4v-85.7H370v85.7h-56.9V184.6h170.7v114.3z"}}]})(props);
	};
	module.exports.IoLogoOctocat = function IoLogoOctocat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M178.4 287.5c-9.1 0-16.9 4.2-23.2 12.8-6.3 8.5-9.4 19-9.4 31.4 0 12.5 3.2 23 9.4 31.5 6.3 8.5 14 12.8 23.2 12.8 8.5 0 15.9-4.3 22.1-12.8 6.3-8.5 9.4-19 9.4-31.5 0-12.4-3.2-22.9-9.4-31.4-6.3-8.6-13.6-12.8-22.1-12.8zM334.7 287.5c-9 0-16.9 4.2-23.2 12.8-6.3 8.5-9.4 19-9.4 31.4 0 12.5 3.2 23 9.4 31.5 6.3 8.5 14.1 12.8 23.2 12.8 8.5 0 15.9-4.3 22.2-12.8 6.3-8.5 9.4-19 9.4-31.5 0-12.4-3.2-22.9-9.4-31.4-6.3-8.6-13.6-12.8-22.2-12.8z"}},{"tag":"path","attr":{"d":"M445.8 172c-.1 0 2.7-14.3.3-39.2-2.2-24.9-7.5-47.8-16.1-68.8 0 0-4.4.8-12.8 2.9s-22.1 6.3-40.9 14.8c-18.5 8.5-38 19.8-58.3 33.5-13.8-3.9-34.4-5.9-62-5.9-26.3 0-46.9 2-62 5.9-44.6-30.9-81.9-48-112.1-51.2-8.6 21-13.9 44-16 69-2.4 24.9.4 39.3.4 39.3C42 198.6 32 236.5 32 267.8c0 24.2.7 46.1 6.1 65.5 5.6 19.3 12.7 35.1 21.1 47.2 8.6 12.1 19 22.8 31.6 31.9 12.5 9.3 24 16 34.4 20.2 10.5 4.4 22.4 7.6 36 9.9 13.3 2.4 23.4 3.6 30.5 4 0 0 28 1.5 64.4 1.5s64.3-1.5 64.3-1.5c7-.4 17.1-1.6 30.5-4 13.5-2.3 25.5-5.6 35.9-9.9 10.4-4.3 21.9-10.9 34.5-20.2 12.5-9 22.9-19.7 31.5-31.9 8.4-12.1 15.5-27.9 21.1-47.2 5.5-19.4 6.1-41.4 6.1-65.6 0-30.3-10-68.7-34.2-95.7zm-65.4 233.6c-27.9 13.1-68.9 18.4-123.3 18.4H255c-54.4 0-95.4-5.2-122.8-18.4-27.5-13.1-41.3-40.1-41.3-80.7 0-24.3 8.6-44 25.5-59.1 7.4-6.5 16.4-11 27.6-13.7 11.1-2.6 21.4-2.8 31-2.5 9.4.4 22.6 2.2 39.3 3.5 16.8 1.3 29.3 3 41.8 3 11.7 0 27.2-2 52.1-4 25-2 43.5-3 55.5-1 12.3 2 23 6.2 32.1 14.7 17.7 15.8 26.6 35.5 26.6 59.1-.1 40.6-14.2 67.6-42 80.7z"}}]})(props);
	};
	module.exports.IoLogoPinterest = function IoLogoPinterest (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.3 32 32 132.3 32 256c0 91.7 55.2 170.5 134.1 205.2-.6-15.6-.1-34.4 3.9-51.4 4.3-18.2 28.8-122.1 28.8-122.1s-7.2-14.3-7.2-35.4c0-33.2 19.2-58 43.2-58 20.4 0 30.2 15.3 30.2 33.6 0 20.5-13.1 51.1-19.8 79.5-5.6 23.8 11.9 43.1 35.4 43.1 42.4 0 71-54.5 71-119.1 0-49.1-33.1-85.8-93.2-85.8-67.9 0-110.3 50.7-110.3 107.3 0 19.5 5.8 33.3 14.8 43.9 4.1 4.9 4.7 6.9 3.2 12.5-1.1 4.1-3.5 14-4.6 18-1.5 5.7-6.1 7.7-11.2 5.6-31.3-12.8-45.9-47-45.9-85.6 0-63.6 53.7-139.9 160.1-139.9 85.5 0 141.8 61.9 141.8 128.3 0 87.9-48.9 153.5-120.9 153.5-24.2 0-46.9-13.1-54.7-27.9 0 0-13 51.6-15.8 61.6-4.7 17.3-14 34.5-22.5 48 20.1 5.9 41.4 9.2 63.5 9.2 123.7 0 224-100.3 224-224C480 132.3 379.7 32 256 32z"}}]})(props);
	};
	module.exports.IoLogoPlaystation = function IoLogoPlaystation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M399.8 203c-.8-17.1-3.3-34.5-10.8-50.1-4.1-8.6-9.7-16.5-16.5-23.2-6.3-6.4-13.6-11.7-21.3-16.3-17.1-10.2-37.5-17-84.4-31S192 64 192 64v358.3l79.9 25.7s.1-198.8.1-299.5v-3.8c0-9.3 7.5-16.8 16.1-16.8h.5c8.5 0 15.5 7.5 15.5 16.8V278c11 5.3 29.2 9.3 41.8 9.1 8.3.2 16.7-1.7 24-5.7 7.6-4.1 13.9-10.4 18.4-17.8 5.1-8.3 8.2-17.8 9.9-27.3 1.9-10.8 2-22.1 1.6-33.3zM86.7 357.8c27.4-9.8 89.3-29.5 89.3-29.5v-47.2s-76.5 24.8-111.3 37.1c-8.6 3.1-17.3 5.9-25.7 9.5-9.8 4.1-19.4 8.7-28.1 14.8-3.8 2.6-7.2 5.9-9.2 10.1s-2.2 9.2-.5 13.6c2 5.1 5.8 9.3 10.1 12.6 7.8 5.9 17.1 9.5 26.4 12.2 28.4 9.4 58.4 14 88.4 13.3 14.5-.2 36-1.9 50-4.4v-42s-11 2.5-41.3 12.5c-4.6 1.5-9.2 3.3-14 4.3-7.1 1.6-14.4 2.1-21.6 2.2-6.5-.3-13.2-.7-19.3-3.1-2.2-1-4.6-2.2-5.5-4.6-.8-2 .3-4 1.7-5.4 2.8-2.9 6.8-4.5 10.6-6z"}},{"tag":"path","attr":{"d":"M512 345.9c-.1-6-3.7-11.2-7.9-15-7.1-6.3-15.9-10.3-24.7-13.5-5.5-1.9-9.3-3.3-14.7-5-25.2-8.2-51.9-11.2-78.3-11.3-8 .3-23.1.5-31 1.4-21.9 2.5-67.3 15.4-67.3 15.4v48.8s67.5-21.6 96.5-31.8c9.7-3.3 20.1-4.6 30.3-4.6 6.5.2 13.2.7 19.4 3.1 2.2.9 4.5 2.2 5.5 4.5.9 2.6-.9 5-2.9 6.5-4.7 3.8-10.7 5.3-16.2 7.4-41 14.5-132.7 44.7-132.7 44.7v47s117.2-39.6 170.8-58.8c8.9-3.3 17.9-6.1 26.4-10.4 7.9-4 15.8-8.6 21.8-15.3 3.1-3.6 5-8 5-13.1z"}}]})(props);
	};
	module.exports.IoLogoPolymer = function IoLogoPolymer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M392.3 96h-77.9L160.8 348.6 109.9 256l87.7-160h-77.9L32 256l87.7 160h77.9l153.7-252.6 50.8 92.6-87.7 160h77.9L480 256 392.3 96z"}}]})(props);
	};
	module.exports.IoLogoPython = function IoLogoPython (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M193.46 249.056a65.316 65.316 0 0 1 11.586-1.041l-3.122-.015h103.823c4.503 0 8.806-.617 12.908-1.754 19.37-5.363 33.345-22.537 33.345-43.663v-87.224c0-24.832-21.15-43.484-46.289-47.606-15.931-2.624-39.258-3.827-55.089-3.749-15.829.086-30.981 1.404-44.277 3.749C167.143 74.576 160 88.928 160 115.359V144h96v16H128.82c-35.628 0-64.538 42.571-64.813 95.242-.002.253-.007.505-.007.758 0 9.523.94 18.72 2.685 27.404C74.648 323.07 99.451 352 128.82 352H144v-45.935c0-26.827 20.146-51.733 49.46-57.009zm10.196-122.054c-9.592 0-17.384-7.785-17.384-17.403 0-9.664 7.774-17.52 17.384-17.52 9.574 0 17.399 7.855 17.399 17.52.001 9.618-7.809 17.403-17.399 17.403z"}},{"tag":"path","attr":{"d":"M443.951 222.543C434.78 186.021 411.033 160 383.18 160H368v40.672c0 33.915-22.286 58.474-49.489 62.681a53.943 53.943 0 0 1-8.301.646H206.351a51.41 51.41 0 0 0-13.049 1.672C174.18 270.689 160 286.6 160 307.236v87.227c0 24.832 24.977 39.426 49.481 46.551 29.327 8.531 61.267 10.068 96.366 0C329.15 434.354 352 420.893 352 394.463V368h-96v-16h127.18c25.24 0 47.107-21.365 57.814-52.549C445.474 286.404 448 271.641 448 256c0-11.768-1.433-23.038-4.049-33.457zM307.867 382.82c9.59 0 17.381 7.785 17.381 17.4 0 9.65-7.791 17.521-17.381 17.521-9.577 0-17.399-7.871-17.399-17.521 0-9.63 7.806-17.4 17.399-17.4z"}}]})(props);
	};
	module.exports.IoLogoReddit = function IoLogoReddit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"322.3","cy":"288.4","r":"31.8"}},{"tag":"circle","attr":{"cx":"190.3","cy":"288.4","r":"31.8"}},{"tag":"path","attr":{"d":"M480.5 251c0-27.7-22.2-50.2-49.5-50.2-13 0-24.7 5-33.6 13.3-33.2-23.4-78.4-38.5-128.7-40.7L292 95.7l69.6 13.9c.2 24.7 20.1 44.7 44.5 44.7 24.6 0 44.5-20.2 44.5-45.1S430.7 64 406.1 64c-18.6 0-34.5 11.6-41.2 28l-85.2-17-29.4 98.2-7.1.2c-50.3 2.2-95.5 17.4-128.7 40.7-8.8-8.3-20.6-13.3-33.6-13.3-27.3 0-49.5 22.5-49.5 50.2 0 19.6 11 36.5 27.1 44.8-.8 4.9-1.2 9.8-1.2 14.8C57.5 386.4 146.4 448 256 448s198.5-61.6 198.5-137.5c0-5-.4-9.9-1.1-14.8 16.1-8.3 27.1-25.2 27.1-44.7zM406.1 81.9c14.8 0 26.8 12.2 26.8 27.2s-12 27.2-26.8 27.2-26.8-12.2-26.8-27.2 12-27.2 26.8-27.2zM49.2 251c0-17.8 14.3-32.2 31.8-32.2 7.2 0 13.9 2.5 19.2 6.6-17.3 15.2-30.1 33-37 52.4-8.4-5.9-14-15.7-14-26.8zm337.2 141.9C351.8 416.8 305.5 430 256 430s-95.8-13.2-130.4-37.1c-32.5-22.5-50.4-51.8-50.4-82.4 0-3.2.2-6.5.6-9.7.7-6 2.2-11.9 4.3-17.7 5.6-15.6 16-30.3 30.7-43.4 4.4-3.9 9.2-7.7 14.4-11.3.1-.1.3-.2.4-.3C160.2 204.2 206.5 191 256 191s95.8 13.2 130.4 37.1c.1.1.3.2.4.3 5.2 3.6 10 7.4 14.4 11.3 14.7 13.1 25.1 27.8 30.7 43.4 2.1 5.8 3.5 11.7 4.3 17.7.4 3.2.6 6.4.6 9.7 0 30.6-17.9 59.9-50.4 82.4zm62.4-115.2c-6.9-19.4-19.7-37.2-37-52.4 5.3-4.1 12-6.6 19.2-6.6 17.5 0 31.8 14.5 31.8 32.2 0 11.2-5.6 21-14 26.8z"}},{"tag":"path","attr":{"d":"M320.5 357.9c-.2.2-24.2 24.2-64.5 24.4-40.9-.2-64.4-24.2-64.6-24.4l-12.6 12.4c1.2 1.2 29.6 29.5 77.2 29.7 47.6-.2 75.9-28.5 77.1-29.7l-12.6-12.4z"}}]})(props);
	};
	module.exports.IoLogoRss = function IoLogoRss (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M119.9 336.1c-30.8 0-55.9 25.1-55.9 55.8 0 30.8 25.1 55.6 55.9 55.6 30.9 0 55.9-24.9 55.9-55.6 0-30.7-25-55.8-55.9-55.8z"}},{"tag":"path","attr":{"d":"M64 192v79.9c48 0 94.1 14.2 128 48.1 33.9 33.9 48 79.9 48 128h80c0-139.9-116-256-256-256z"}},{"tag":"path","attr":{"d":"M64 64v79.9c171 0 303.9 133 303.9 304.1H448C448 236.3 276 64 64 64z"}}]})(props);
	};
	module.exports.IoLogoSass = function IoLogoSass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.784 329.108c-1.67-13.599-9.236-24.146-20.795-32.416 2.857 2.04 5.275 3.766-.055-.041-7.189-5.131-3.38-2.411-.047-.032-28.5-20.301-65.676-15.789-96.733-4.511-12.447-20.295-12.987-35.783-5.816-57.937.929-2.8.295-4.354-2.624-5.604-7.086-3.03-17.291-1.427-24.422.463-2.462.646-4.254 1.9-4.8 4.381-5.154 24.243-21.009 46.448-34.828 66.886-9.731-18.652-8.96-33.087-2.414-52.516.798-2.366.431-3.624-1.937-4.879-7.26-3.757-18.401-1.912-25.8.276-8.509 2.482-21.29 44.594-25.372 52.946-8.531 17.442-16.091 44.665-30.585 58.502-12.3-15.807 22.526-51.517 10.882-65.851-3.938-4.848-11.063-4.723-15.586-.616 1.085-7.608 1.648-12.609-.32-19.063-2.081-6.79-7.361-10.687-15.09-10.49-17.995.527-33.843 13.815-44.641 26.397-10.277 12.105-37.381 19.627-51.953 26.927-25.032-21.807-79.221-44.947-80.632-82.081-1.528-41.846 48.319-70.245 81.597-87.228 43.28-22.104 109.961-49.608 159.138-25.436 13.049 6.414 18.299 20.171 14.707 33.348-9.368 34.366-47.198 57.293-80.103 67.807-16.189 5.175-33.969 9.027-51.1 8.026-22.955-1.343-40.83-15.224-43.281-16.086-2.049-.389-1.888 2.261-1.347 3.664 23.816 62.433 144.417 16.681 175.956-15.371 15.189-15.421 24.413-30.365 28.351-53.894 4.616-27.583-15.634-44.842-31.004-51.957-77.918-36.072-185.636 11.168-244.553 59.327-25.568 20.901-57.552 54.11-42.874 88.946 15.93 37.805 64.736 57.19 96.503 80.312-25.704 12.773-57.862 25.983-74.518 49.933-9.524 13.729-12.903 28.359-5.811 43.966 12.572 27.568 58.285 15.622 77.573 3.471 17.67-11.13 29.563-26.07 34.7-45.228 4.455-16.609 3.541-33.866-3.856-49.512l28.585-14.458c-7.697 23.076-11.097 52.003 4.881 72.855 6.402 8.338 23.017 8.675 29.817.311 8.816-10.943 14.664-24.655 20.503-37.206-.682 9.373-1.856 19.996 1.377 28.165 3.71 9.373 12.126 11.291 20.792 5.343 26.52-18.203 43.398-68.652 56.463-98.062 3.552 12.829 7.473 24.548 13.957 36.376 1.602 2.903 1.407 4.774-.796 7.195-9.685 10.675-32.826 28.479-35.069 42.899-.524 3.371 1.713 6.599 5.686 7.37 15.573 3.108 32.838-2.531 45.482-11.078 13.188-8.922 17.446-21.087 14.245-35.515-4.576-20.771 10.993-43.98 25.801-61.03 2.719 12.908 6.816 25.331 14.143 36.606-13.075 11.483-32.58 27.764-29.779 46.939.988 6.865 7.135 11.301 14.514 9.736 15.783-3.324 29.416-10.113 39.37-22.146 9.023-10.855 5.792-22.701 1.856-34.635 23.872-6.815 48.022-8.177 71.831-.027 11.495 3.91 20.755 10.5 26.248 20.818 6.726 12.644 2.939 24.292-10.05 32.604-3.287 2.104-5.562 3.833-4.45 4.743 1.112.911 4.9 2.113 13.284-3.152 8.384-5.267 13.51-12.383 14.823-21.725a37.09 37.09 0 0 0-.024-7.755zm-398.838 25.259c-1.358 16.673-9.636 30.193-23.175 41.114-7.617 6.158-17.102 11.176-26.52 12.092-9.418.917-16.751-1.461-17.378-11.23-1.764-27.493 40.923-54.424 64.625-62.533 2.02 6.86 3.011 13.666 2.432 20.587l.016-.03zm103.102-72.453c-3.903 22.309-14.83 62.347-32.314 78.336-2.356 2.143-4.61 2.018-5.809-.771-10.345-24.059 3.671-73.669 33.082-81.328 3.457-.889 5.602.582 5.041 3.763zm70.311 81.768c8.422-8.962 16.834-17.916 25.269-26.927 1.043 10.021-17.571 29.964-25.269 26.927zm80.714-17.696c-2.348 1.273-7.621 2.515-7.827.835-1.482-12.085 11.816-24.874 20.067-30.867 4.453 11.343-.818 23.834-12.24 30.032z"}}]})(props);
	};
	module.exports.IoLogoSkype = function IoLogoSkype (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M436.9 296.8c2.8-12.5 4.2-25.4 4.2-38.7 0-99.7-82-180.6-183.2-180.6-10.7 0-21.1.9-31.3 2.6C210.3 69.9 191 64 170.2 64 111.6 64 64 110.9 64 168.7c0 19.4 5.3 37.5 14.6 53-2.4 11.7-3.7 23.9-3.7 36.3 0 99.8 82 180.6 183.1 180.6 11.5 0 22.7-1 33.5-3 15 7.9 32.1 12.4 50.2 12.4 58.7 0 106.2-46.9 106.2-104.7.1-16.7-3.9-32.5-11-46.5zm-85 47.5c-8.5 11.8-21 21.2-37.2 27.8-16.1 6.6-35.3 9.9-57.3 9.9-26.3 0-48.3-4.6-65.6-13.6-12.3-6.6-22.4-15.4-30.2-26.4-7.8-11-11.7-22-11.7-32.6 0-6.6 2.6-12.3 7.6-17.1 5-4.6 11.5-7 19.1-7 6.3 0 11.7 1.8 16.1 5.5 4.2 3.5 7.8 8.7 10.7 15.5 3.3 7.3 6.8 13.5 10.6 18.4 3.6 4.7 8.7 8.6 15.3 11.7 6.7 3.1 15.6 4.7 26.6 4.7 15.1 0 27.5-3.2 36.8-9.5 9.2-6.1 13.6-13.5 13.6-22.5 0-7.1-2.3-12.7-7.1-17.1-5-4.6-11.5-8.2-19.6-10.6-8.3-2.6-19.6-5.3-33.6-8.2-19-4-35.1-8.8-48-14.2-13.1-5.5-23.7-13.2-31.5-22.7-7.9-9.7-11.8-21.9-11.8-36.2 0-13.7 4.2-25.9 12.4-36.5 8.2-10.5 20.1-18.7 35.6-24.3 15.2-5.6 33.3-8.4 53.7-8.4 16.4 0 30.7 1.9 42.7 5.5 12.1 3.7 22.2 8.7 30.3 14.9 8 6.2 14 12.8 17.8 19.7 3.8 7 5.7 13.9 5.7 20.6 0 6.4-2.5 12.3-7.5 17.4-5 5.1-11.3 7.8-18.8 7.8-6.8 0-12.1-1.6-15.8-4.8-3.4-3-7-7.6-10.9-14.3-4.6-8.5-10.1-15.3-16.4-20.1-6.2-4.6-16.4-7-30.6-7-13.1 0-23.8 2.6-31.7 7.7-7.6 4.9-11.3 10.6-11.3 17.3 0 4.1 1.2 7.5 3.7 10.5 2.6 3.1 6.2 5.9 10.9 8.2 4.8 2.4 9.8 4.3 14.7 5.6 5.1 1.4 13.6 3.5 25.3 6.1 14.9 3.1 28.5 6.7 40.5 10.4 12.2 3.9 22.7 8.6 31.3 14.1 8.8 5.6 15.7 12.9 20.7 21.5 4.9 8.6 7.4 19.4 7.4 31.8.4 15.1-3.9 28.7-12.5 40.5z"}}]})(props);
	};
	module.exports.IoLogoSlack = function IoLogoSlack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M213.6 236.216l64.003-21.438 20.708 61.823-64.004 21.438z"}},{"tag":"path","attr":{"d":"M213.6 236.216l64.003-21.438 20.708 61.823-64.004 21.438z"}},{"tag":"path","attr":{"d":"M475.9 190C426.4 25 355-13.4 190 36.1S-13.4 157 36.1 322 157 525.4 322 475.9 525.4 355 475.9 190zm-83.3 107.1l-31.1 10.4 10.7 32.2c4.2 13-2.7 27.2-15.7 31.5-2.7.8-5.8 1.5-8.4 1.2-10-.4-19.6-6.9-23-16.9l-10.7-32.2-64.1 21.5L261 377c4.2 13-2.7 27.2-15.7 31.5-2.7.8-5.8 1.5-8.4 1.2-10-.4-19.6-6.9-23-16.9L203 360.4l-31 10.3c-2.7.8-5.8 1.5-8.4 1.2-10-.4-19.6-6.9-23-16.9-4.2-13 2.7-27.2 15.7-31.5l31.1-10.4-20.7-61.8-31.1 10.4c-2.7.8-5.8 1.5-8.4 1.2-10-.4-19.6-6.9-23-16.9-4.2-13 2.7-27.2 15.7-31.5l31.1-10.4-10.9-32.1c-4.2-13 2.7-27.2 15.7-31.5 13-4.2 27.2 2.7 31.5 15.7l10.7 32.2 64.1-21.5-10.7-32.2c-4.2-13 2.7-27.2 15.7-31.5 13-4.2 27.2 2.7 31.5 15.7l10.7 32.2 31.1-10.4c13-4.2 27.2 2.7 31.5 15.7 4.2 13-2.7 27.2-15.7 31.5l-31.1 10.4 20.7 61.8 31.1-10.4c13-4.2 27.2 2.7 31.5 15.7 4.2 13.2-2.7 27.4-15.8 31.7z"}}]})(props);
	};
	module.exports.IoLogoSnapchat = function IoLogoSnapchat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M495.998 360.389l-.189-14.501-14.398-1.278c-15.413-1.396-43.8-7.219-54.301-16.9-16.281-15.011-35.688-36.199-35.688-51.893 0-1.014 0-2.546 4.15-5.186 4.985-3.174 12.589-5.584 19.297-7.71 5.217-1.654 10.144-3.217 14.394-5.236 9.236-4.39 18.498-15.978 17.471-28.807-1.215-15.166-14.424-27.046-30.072-27.046-4.021 0-8.068.76-12.027 2.259-8.027 3.041-13.743 4.41-17.705 4.962.747-9.319 1.791-20.12 3.211-30.67 5.111-37.948-5.281-73.509-29.264-101.042C335.498 48.208 297.376 32 256.283 32H256c-41.093 0-79.215 16.208-104.591 45.341-23.982 27.534-34.375 63.345-29.265 101.292 1.416 10.51 2.46 21.231 3.21 30.618-3.97-.559-9.686-1.998-17.703-5.034-3.965-1.502-8.017-2.295-12.043-2.295-15.641-.001-28.844 11.852-30.057 27.003-1.027 12.818 8.235 24.393 17.47 28.783 4.251 2.02 9.181 3.578 14.4 5.232 6.707 2.125 14.309 4.532 19.293 7.703 4.147 2.639 4.147 4.168 4.147 5.182 0 8.66-6.191 24.691-35.688 51.888-10.499 9.681-39.055 15.501-54.588 16.897l-14.572 1.311L16 360.603c0 1.679.312 10.546 6.485 20.319 5.246 8.306 16.073 19.283 37.863 24.407a1139.713 1139.713 0 0 0 15.208 3.454c2.306.512 4.555 1.01 6.454 1.453l.081.623c.9 7.004 1.611 12.535 4.392 17.75 2.453 4.6 8.574 12.316 22.015 12.316 2.478 0 5.249-.246 8.472-.751 1.672-.263 3.386-.554 5.2-.863 7.116-1.212 15.182-2.587 23.451-2.587 10.277 0 18.732 2.188 25.846 6.688 4.531 2.867 8.892 5.972 13.509 9.26C202.967 465.481 223.358 480 256 480c32.726 0 53.293-14.582 71.439-27.446 4.576-3.244 8.898-6.309 13.377-9.142 7.113-4.5 15.568-6.688 25.846-6.688 8.27 0 16.334 1.375 23.449 2.586 1.814.311 3.529.602 5.202.864 3.223.505 5.993.751 8.472.751 13.44 0 19.562-7.715 22.015-12.313 2.781-5.214 3.492-10.746 4.392-17.749l.082-.629c1.898-.441 4.148-.941 6.455-1.452 4.023-.892 9.029-2.001 15.206-3.454 21.851-5.139 32.611-16.17 37.79-24.518 6.097-9.828 6.296-18.736 6.273-20.421zM208 128c8.836 0 16 10.745 16 24s-7.164 24-16 24-16-10.745-16-24 7.164-24 16-24zm103.615 77.698C296.368 220.725 276.617 229 256 229c-20.838 0-40.604-8.29-55.657-23.343a8 8 0 1 1 11.313-11.313C223.688 206.374 239.436 213 256 213c16.387 0 32.15-6.64 44.385-18.698a8 8 0 0 1 11.23 11.396zM304 176c-8.836 0-16-10.746-16-24s7.164-24 16-24 16 10.746 16 24-7.164 24-16 24z"}}]})(props);
	};
	module.exports.IoLogoSteam = function IoLogoSteam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M478.8 208.2c0 19.8-16.1 36-36 36-19.8 0-36-16.1-36-36 0-19.8 16.1-36 36-36 19.8 0 36 16.2 36 36zM442.6 139c-38.1 0-69 30.7-69.4 68.7l-43.2 62c-1.8-.2-3.6-.3-5.4-.3-9.7 0-18.7 2.7-26.4 7.3L102.4 198c-5.1-23.2-25.9-40.7-50.6-40.7C23.3 157.2 0 180.6 0 209.1s23.3 51.8 51.8 51.8c9.7 0 18.7-2.7 26.4-7.3L274 332.2c5.1 23.3 25.8 40.8 50.6 40.8 26.8 0 49-20.6 51.5-46.7l66.5-48.6c38.3 0 69.4-31 69.4-69.3S480.9 139 442.6 139zm0 22.9c25.7 0 46.5 20.9 46.5 46.5 0 25.7-20.9 46.4-46.5 46.4-25.7 0-46.5-20.8-46.5-46.4 0-25.7 20.8-46.5 46.5-46.5zm-390.8 9c14.6 0 27.3 8.2 33.7 20.2l-18.9-7.6v.1c-15.3-5.5-32.2 2-38.3 17.1-6.1 15.2.9 32.3 15.7 38.9v.1l16.1 6.4c-2.6.6-5.4.9-8.2.9-21.1 0-38.1-17-38.1-38.1-.1-20.9 16.9-38 38-38zm272.8 112.2c21.1 0 38.1 17 38.1 38.1s-17 38.1-38.1 38.1c-14.7 0-27.4-8.2-33.7-20.3 6.3 2.5 12.5 5 18.8 7.6 15.5 6.2 33.2-1.3 39.4-16.8 6.2-15.5-1.3-33.1-16.9-39.4l-15.9-6.4c2.8-.5 5.5-.9 8.3-.9z"}}]})(props);
	};
	module.exports.IoLogoTumblr = function IoLogoTumblr (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M321.2 396.3c-11.8 0-22.4-2.8-31.5-8.3-6.9-4.1-11.5-9.6-14-16.4-2.6-6.9-3.6-22.3-3.6-46.4V224h96v-64h-96V48h-61.9c-2.7 21.5-7.5 44.7-14.5 58.6-7 13.9-14 25.8-25.6 35.7-11.6 9.9-25.6 17.9-41.9 23.3V224h48v140.4c0 19 2 33.5 5.9 43.5 4 10 11.1 19.5 21.4 28.4 10.3 8.9 22.8 15.7 37.3 20.5 14.6 4.8 31.4 7.2 50.4 7.2 16.7 0 30.3-1.7 44.7-5.1 14.4-3.4 30.5-9.3 48.2-17.6v-65.6c-20.9 13.7-41.8 20.6-62.9 20.6z"}}]})(props);
	};
	module.exports.IoLogoTux = function IoLogoTux (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426.3 396c-6.7-4-13.2-11-12-18.8 2.3-15.3 2.5-21.5-.2-25.8-1.9-3.2-5.5-5-8.6-5.8 2-2.5 3.1-5.4 3.8-10.9 1.3-10-4.7-41-12.7-65.7s-29.9-50-44.7-68c-26-31.8-22.8-39.2-26.3-99.7C323.4 62.8 306.3 32 256 32s-67 32-67 59c0 28.7 2 51 2 51 1.3 33.4 1 39.4-8 55.3-4.9 8.7-27 30-35.7 44.7s-7.6 29.5-24.6 52.8c-12.4 17-13.8 28.4-9.7 44-7 8.2-3.6 19.9-5 24.9-2.6 8.7-13.7 10.3-22.3 11s-15.3 0-18.7 5.3.7 16 4.3 30-7.3 15-7.3 31 30 16 59.7 22.7 40.7 16.3 56 16.3 26.8-10.2 38-19.3c7.2-5.9 29-3.7 42.3-3.7s34.3-.6 45.7 2.4S317 480 345 480s34.7-20.7 61-34.3 42-20 42-29.7-15-16-21.7-20zm-226.5 55.5c-1.3 13-12.6 17.1-24.1 16.1-13-1.1-29-7.6-44.1-12.1s-35.5-7.5-49-9.9c-15.3-2.7 0-13.6-.2-34.2-.1-8-7.1-19.4-4.2-24.7s17.3-2.4 22.3-3.8 12.7-5.7 15.3-11.9c1.4-3.4 1.8-17.7 2.9-22.8 1.1-4.9 7.9-7.2 22.2.1s28.9 38.1 42.3 59.8 17.9 30.4 16.6 43.4zm118.5-65.8c2 10.3 3.2 24.5.7 36.3s-7 15.5-10.7 23c-2.2-6.8 5.3-13.8 4.4-30.8-.5-9.5-.8-7.8-11.5 1.8-12.2 10.8-27.6 20.1-53 22.5-21 2-32.5-8.3-32.5-8.3 5 16-4.3 24.7-4.3 24.7.3-3.7.8-14.3-2.5-21.6-4-9-9.3-18.7-9.3-18.7s8.6-2.7 11.6-10 2-17.3-8.7-27.7-52.5-37.6-55.9-42.1c-4.9-6.5-6.7-10.2-7-23.2s5.4-24.8 4.3-20.3c-.8 3.2.1 6.8.1 19.8s7.6 23.3 13.9 25c9.5 2.6 2-26.1 8-53.1s11.7-32.8 19.2-43.8 19.2-20.5 17-43.1-.1-20.1 5.1-11.8c4 6.5 13.3 24 24.7 22 19.4-3.3 43.9-24.6 47.6-28.2 3.7-3.6.7-7.1-2.3-5.8-15.5 6.7-44.3 21.5-51.5 18.2s-18.1-20.6-16.8-19.5c15.4 13.6 19.9 11.1 26.4 9 8.4-2.8 12.8-4.3 28.5-11.3s20.7-5.3 22.3-8.7-.4-6.7-4.7-5.7c-6.4 1.5-3.4 5.1-22.7 12.3-25.3 9.5-33.3 10.3-44 3-8.6-5.9-15-12.7-15-16.7s8.3-8.3 12.3-11.3 12.3-10.9 12.3-10.9 1-7.2-.6-12.7c-1.9-6.5-7.8-9.3-11.9-8.1-4.1 1.1-8 5.5-6.8 14.8 1 8.3 7 11 7 11s-2.7 3.5-5.2 4.7c0 0-.8-.3-3.5-6.3s-6.6-19.5-.3-31.1 19.6-5.2 23.8 3.8c3.9 8.3 2.4 22.7 2.4 22.7 6-2.2 13-2 21 3.5-7.1-29.8 9.5-41.1 22-41.1s22.3 9.6 22.3 25c0 12-3.5 18.2-6.9 22-4.1-.5-8.2-1.5-6.3-3.4 1.3-1.4 4.4-5.7 4.4-13.2s-5.9-13.7-13.7-13.7c-9.2 0-12.6 8.3-13.7 13s-.4 8.6-.2 10.4c.6 5 10.9 9.6 23.9 12.9s11.3 9 8.3 25.3 6.3 18.3 14.3 33.8 5.7 21.8 15.9 35.2 19 47.8 16.4 76.8c-.9 10.5-3.9 10.2 7.3 6.7 5.6-1.7 12-2.7 12-2.7 3.1-6.3 3.4-16.3 3.5-22.3.2-13.5.7-41.5-26.7-71.5 0 0 29.5 21.7 34 62 2.5 22.3-2 32.4-2 32.4 5.3 1.3 9.8 7.3 12.6 11.8 3.7 6.1-3.9-5.8-20-5.8-8.5 0-15.3 3.9-18.5 7.9s-3.1 7.6-3.2 11.7c-7.1-1.2-12.4 0-16.8 4.9-5.6 7-2.8 24.2-.8 34.6zm90.1 47.2c-24.1 10.4-32.7 23.5-47.7 31.5s-27.7 2.3-33.7-8 10.4-28.2 4.7-59.6c-4.4-24.2-6.3-31-4.9-36.8 1.4-5.5 9.4-4.4 11.5-3.9 1.3 5.4 6.7 19.5 27 19.5 0 0 23.2 2.6 32.7-21.2 0 0 5.7-.2 7.2 3.5 2.3 5.8-2.9 16.5-2.8 21.3.3 15.7 11.7 21.1 28.4 32 8.2 5.6 2.1 11.1-22.4 21.7z"}}]})(props);
	};
	module.exports.IoLogoTwitch = function IoLogoTwitch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 32l-32 80v304h96v64h64l64-64h80l112-112V32H80zm336 256l-64 64h-96.001L192 416v-64h-80V80h304v208z"}},{"tag":"path","attr":{"d":"M320 143h48v129h-48zM208 143h48v129h-48z"}}]})(props);
	};
	module.exports.IoLogoTwitter = function IoLogoTwitter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M492 109.5c-17.4 7.7-36 12.9-55.6 15.3 20-12 35.4-31 42.6-53.6-18.7 11.1-39.4 19.2-61.5 23.5C399.8 75.8 374.6 64 346.8 64c-53.5 0-96.8 43.4-96.8 96.9 0 7.6.8 15 2.5 22.1-80.5-4-151.9-42.6-199.6-101.3-8.3 14.3-13.1 31-13.1 48.7 0 33.6 17.2 63.3 43.2 80.7-16-.4-31-4.8-44-12.1v1.2c0 47 33.4 86.1 77.7 95-8.1 2.2-16.7 3.4-25.5 3.4-6.2 0-12.3-.6-18.2-1.8 12.3 38.5 48.1 66.5 90.5 67.3-33.1 26-74.9 41.5-120.3 41.5-7.8 0-15.5-.5-23.1-1.4C62.8 432 113.7 448 168.3 448 346.6 448 444 300.3 444 172.2c0-4.2-.1-8.4-.3-12.5C462.6 146 479 129 492 109.5z"}}]})(props);
	};
	module.exports.IoLogoUsd = function IoLogoUsd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M411.387 303.256c-3.119-9.577-7.891-18.561-14.301-26.952-6.422-8.382-14.396-15.826-23.93-22.331-9.539-6.498-20.721-11.63-33.553-15.4-5.143-1.363-14.189-3.506-26.104-6.418-8.516-2.074-16.5-4.2-25.5-6.367V120.065c9 2.396 15.252 6.202 21.926 10.43C324.204 139.535 333.157 155 335.78 176h69.174c-.654-18-4.65-32.76-11.996-46.02-8.07-14.543-18.977-27.024-32.73-36.956-13.75-9.922-30.225-17.49-48.377-22.455C303.967 68.416 297 66.605 288 65.386V32h-64v33.167c-7 1.044-15.148 2.445-22.426 4.25-17.242 4.283-32.388 10.868-45.951 19.764-13.571 8.905-24.352 20.112-32.604 33.627-8.251 13.523-12.312 29.52-12.312 48 0 9.585 1.407 18.993 4.157 28.235 2.752 9.241 7.442 17.967 14.042 26.181 6.603 8.214 15.495 15.658 26.687 22.332 11.183 6.672 24.705 12.064 41.576 16.171 9.287 2.345 18.83 4.534 26.83 6.576v119.586c-11-2.919-21.889-7.399-30.678-13.479-9.17-6.327-16.066-13.953-21.198-23.884-4.779-9.229-7.073-20.526-7.407-32.526H96c.695 21 5.25 39.494 13.672 55.371 8.799 16.604 20.533 29.96 35.204 40.562 14.662 10.613 31.393 18.356 51.198 23.491 8.885 2.304 18.926 3.96 27.926 5.23V480h64v-34.54c10-1.069 18.957-2.69 28.527-4.879 18.701-4.273 35.645-11.036 50.316-20.276 14.662-9.24 26.621-21.128 35.611-35.681 8.98-14.541 13.545-32.085 13.545-52.619.001-9.578-1.501-19.164-4.612-28.749zM224 209.699c-12-3.743-23.912-9.088-32.051-16.048-8.621-7.355-12.673-17.534-12.673-30.545 0-9.241 2.414-16.94 7.004-23.102 4.58-6.161 9.912-11.038 16.88-14.631 6.18-3.189 13.84-5.565 20.84-7.138v91.464zm118.902 149.772c-2.939 6.673-7.699 12.576-14.303 17.711-6.602 5.133-15.744 9.328-26.377 12.577-4.5 1.378-8.223 2.444-14.223 3.236v-107.11c10 2.624 18.18 5.332 26.326 8.131 8.062 2.744 15.748 7.443 22.537 14.116 6.785 6.676 10.309 17.03 10.309 31.06.001 6.85-1.337 13.605-4.269 20.279z"}}]})(props);
	};
	module.exports.IoLogoVimeo = function IoLogoVimeo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476.9 114c-5-23.4-17.5-38.8-40.6-46.3s-64.9-4.5-94.1 16.8c-29.9 21.8-47.6 59.7-53.8 83.8 14.7-6.3 24-7.7 39-6.9s24.5 12 24.9 25.3c.3 9.8-.2 18.7-3.6 27.7-10.8 28.7-27.7 56.5-47.6 80.8-2.9 3.6-6.4 6.9-10 9.9-10.2 8.3-18.8 6.1-25.4-5.2-5.4-9.3-9-18.9-12.2-29.1-12.4-39.7-16.8-80.9-23.8-121.6-3.3-19.5-7-39.8-18-56.9-11.6-17.8-28.6-24.6-50-22-14.7 1.8-36.9 17.5-47.8 26.4 0 0-56 46.9-81.8 71.4l21.2 27s17.9-12.5 27.5-18.3c5.7-3.4 12.4-4.1 17.2.2 4.5 3.9 9.6 9 12.3 14.1 5.7 10.7 11.2 21.9 14.7 33.4 13.2 44.3 25.5 88.7 37.8 133.3 6.3 22.8 13.9 44.2 28 63.6 19.3 26.6 39.6 32.7 70.9 21.5 25.4-9.1 46.6-26.2 66-43.9 33.1-30.2 59.1-65.4 85.5-101.2 20.4-27.7 37.3-55.7 51.4-87 13.9-31 19.4-63.5 12.3-96.8z"}}]})(props);
	};
	module.exports.IoLogoVk = function IoLogoVk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M427 299.1c-8.6-8-15.7-12.8-18.5-20.5-1-2.7-1.3-4.3-1-7.6.4-6 5.5-13.8 39.6-58.9 14.2-18.8 32.7-41.5 32.7-58.5 0-11-4.5-13.7-20.8-13.7h-74c-6.5 0-10.9 8.9-13.6 16.4-2.8 7.5-8.2 19-21.4 43.8-13.8 26-32.3 48.8-40 52.4-2.2 1-3.6 1-5.5.8-1.2-.1-3.8-.8-6.2-3.7-2.3-2.8-5.9-7.7-4.5-53.9.8-25.8 3.7-43.8-1.7-54.8-1.1-2.2-3.5-4.5-4.8-5.5-7.7-5.5-29.4-7.5-48-7.5s-32.9 2.1-40 4.2c-7.1 2.1-15.1 6.9-18.9 12-2.5 3.3 4.3 1.6 10.9 4.6 4 1.8 9.3 4.6 11.2 9.3 8 20.8 9.7 37.3 5.3 66.7-1.1 7.2-2.3 18.5-6.6 25.5-2.4 3.9-7.9 3.6-9.5 3.1-16.1-4.9-28.6-26-41.2-50.7-13.1-25.8-19.8-43.9-23.4-51.3s-9.1-11.4-18.4-11.4H42.3c-5.2 0-9.9 4.3-9.9 9 0 11 18.6 43 29.8 66 20.2 41.4 46.7 81.4 82.4 120.2C182 376.3 233 384 249.3 384s29-.6 33.3-1.5c2-.4 4.1-1.3 5.7-2.5 7.1-5.5 5.8-16 6.3-24.2.5-8.4 1.4-19.5 7-26 5.2-6.1 11.1-7.8 18.6-4.1 7 3.5 12 9.4 17.2 15.1 10.1 10.9 19.3 23.2 31.3 32.2 5.5 4.1 11.5 6.7 17.9 8.7 8.5 2.6 16.5 2.7 25.3 2.3 9.7-.4 17-.3 29-.3s27.7.5 33.1-3.5c2.6-2 6-5 6-11.3 0-11.9-12.2-31.7-53-69.8z"}}]})(props);
	};
	module.exports.IoLogoWhatsapp = function IoLogoWhatsapp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M260.062 32C138.605 32 40.134 129.701 40.134 250.232c0 41.23 11.532 79.79 31.559 112.687L32 480l121.764-38.682c31.508 17.285 67.745 27.146 106.298 27.146C381.535 468.464 480 370.749 480 250.232 480 129.701 381.535 32 260.062 32zm109.362 301.11c-5.174 12.827-28.574 24.533-38.899 25.072-10.314.547-10.608 7.994-66.84-16.434-56.225-24.434-90.052-83.844-92.719-87.67-2.669-3.812-21.78-31.047-20.749-58.455 1.038-27.413 16.047-40.346 21.404-45.725 5.351-5.387 11.486-6.352 15.232-6.413 4.428-.072 7.296-.132 10.573-.011 3.274.124 8.192-.685 12.45 10.639 4.256 11.323 14.443 39.153 15.746 41.989 1.302 2.839 2.108 6.126.102 9.771-2.012 3.653-3.042 5.935-5.961 9.083-2.935 3.148-6.174 7.042-8.792 9.449-2.92 2.665-5.97 5.572-2.9 11.269 3.068 5.693 13.653 24.356 29.779 39.736 20.725 19.771 38.598 26.329 44.098 29.317 5.515 3.004 8.806 2.67 12.226-.929 3.404-3.599 14.639-15.746 18.596-21.169 3.955-5.438 7.661-4.373 12.742-2.329 5.078 2.052 32.157 16.556 37.673 19.551 5.51 2.989 9.193 4.529 10.51 6.9 1.317 2.38.901 13.531-4.271 26.359z"}}]})(props);
	};
	module.exports.IoLogoWindows = function IoLogoWindows (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 265H232v179l248 36V265zM216 265H32v150l184 26.7V265zM480 32L232 67.4V249h248V32zM216 69.7L32 96v153h184V69.7z"}}]})(props);
	};
	module.exports.IoLogoWordpress = function IoLogoWordpress (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M259 271.3L226.2 367h-.1l-25.4 73.1c1.8.5 3.5.9 5.3 1.4h.3c15.8 4.2 32.4 6.5 49.5 6.5 8.5 0 16.8-.5 24.9-1.8 11.2-1.4 22-3.8 32.5-7.1 2.6-.8 5.2-1.7 7.8-2.6-2.8-6-8.8-19.3-9.1-19.9L259 271.3zM80.8 180.5C70.8 203.1 64 230.9 64 256c0 6.3.3 12.6.9 18.8 6.9 71.2 52.9 131 116.1 157.9 2.6 1.1 5.3 2.2 8 3.2L96 180.6c-8-.3-9.5.2-15.2-.1z"}},{"tag":"path","attr":{"d":"M430.2 175.4c-4.3-9.3-9.4-18.2-15.1-26.6-1.6-2.4-3.4-4.8-5.1-7.2-21.5-28.8-50.8-51.4-84.9-64.6-21.4-8.4-44.8-13-69.2-13-60.3 0-114.2 28-149.4 71.7-6.5 8-12.3 16.6-17.5 25.6 14.2.1 31.8.1 33.8.1 18.1 0 46-2.2 46-2.2 9.4-.6 10.4 13.1 1.1 14.2 0 0-9.4 1.1-19.8 1.6L213 362l37.8-113.3-26.8-73.6c-9.4-.5-18.1-1.6-18.1-1.6-9.4-.5-8.2-14.8 1-14.2 0 0 28.5 2.2 45.5 2.2 18.1 0 46-2.2 46-2.2 9.3-.6 10.5 13.1 1.1 14.2 0 0-9.3 1.1-19.7 1.6l62.3 185.6 17.3-57.6c8.7-22.4 13.1-40.9 13.1-55.7 0-21.3-7.7-36.1-14.3-47.6-8.7-14.3-16.9-26.3-16.9-40.4 0-15.9 12-30.7 29-30.7h2.2c26.2-.7 34.8 25.3 35.9 43v.6c.4 7.2.1 12.5.1 18.8 0 17.4-3.3 37.1-13.1 61.8l-39 112.8-22.3 65.7c1.8-.8 3.5-1.6 5.3-2.5 56.7-27.4 98-82 106.7-146.7 1.3-8.5 1.9-17.2 1.9-26 0-28.9-6.4-56.3-17.8-80.8z"}}]})(props);
	};
	module.exports.IoLogoXbox = function IoLogoXbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M126.8 248.3c39.7-58.6 77.9-92.8 77.9-92.8s-42.1-48.9-92.8-67.4l-3.3-.8C61.7 128.4 32 188.7 32 256c0 50.7 16.9 97.5 45.2 135 0-4.4.6-70.3 49.6-142.7zM480 256c0-67.3-29.7-127.6-76.6-168.7l-3.2.9c-50.7 18.5-92.9 67.4-92.9 67.4s38.2 34.2 77.9 92.8c49 72.4 49.6 138.3 49.5 142.7C463.2 353.5 480 306.7 480 256zM201.2 80.9c29.3 13.1 54.6 34.6 54.6 34.6s25.5-21.4 54.8-34.6c36.8-16.5 64.9-11.3 72.3-9.5C346.8 46.6 303.1 32 256 32s-90.8 14.6-126.9 39.4c7.2-1.8 35.2-7.1 72.1 9.5zM358.7 292.9C312.4 236 255.8 199 255.8 199s-56.3 37-102.7 93.9c-39.8 48.9-54.6 84.8-62.6 107.8l-1.3 4.8c41 45.7 100.5 74.5 166.8 74.5s125.8-28.8 166.8-74.5l-1.4-4.8c-8-23-22.9-58.9-62.7-107.8z"}}]})(props);
	};
	module.exports.IoLogoXing = function IoLogoXing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M313.8 303.9L469 32H365L209.4 303.8c-.4.7-.4 1.1 0 1.7l98.9 173.8c.4.7.8.7 1.6.7H413l-99.3-174.7c-.2-.3-.1-1 .1-1.4zM221.9 216.2L163 113c-.5-.8-1-1-2-1H65l58.9 104.4c.1.2.2.6.1.8L43 352h96.8c.8 0 1.2-.2 1.6-.9l80.5-133.7c.1-.3.1-.9 0-1.2z"}}]})(props);
	};
	module.exports.IoLogoYahoo = function IoLogoYahoo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384.6 68.4c-11.3 0-22.5-.8-32.6-4.4l-96 160-96-160c-10.1 3.6-20.7 4.4-32 4.4-11.1 0-22.1-.9-32-4.4l128 212.7V448c10-3.5 20.8-4.4 32-4.4s22 .9 32 4.4V277L416 64c-9.9 3.4-20.3 4.4-31.4 4.4z"}}]})(props);
	};
	module.exports.IoLogoYen = function IoLogoYen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 32h-80L256 253.128 144 32H64l112.368 208H128v48h73.564L216 319v17h-88v48h88v96h80v-96h88v-48h-88v-17l14.891-31H384v-48h-48.289L448 32z"}}]})(props);
	};
	module.exports.IoLogoYoutube = function IoLogoYoutube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M508.6 148.8c0-45-33.1-81.2-74-81.2C379.2 65 322.7 64 265 64h-18c-57.6 0-114.2 1-169.6 3.6C36.6 67.6 3.5 104 3.5 149 1 184.6-.1 220.2 0 255.8c-.1 35.6 1 71.2 3.4 106.9 0 45 33.1 81.5 73.9 81.5 58.2 2.7 117.9 3.9 178.6 3.8 60.8.2 120.3-1 178.6-3.8 40.9 0 74-36.5 74-81.5 2.4-35.7 3.5-71.3 3.4-107 .2-35.6-.9-71.2-3.3-106.9zM207 353.9V157.4l145 98.2-145 98.3z"}}]})(props);
	};
	module.exports.IoMdAddCircleOutline = function IoMdAddCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M363 277h-86v86h-42v-86h-86v-42h86v-86h42v86h86v42z"}},{"tag":"path","attr":{"d":"M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422c-44.3 0-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256c0-44.3 17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}}]})(props);
	};
	module.exports.IoMdAddCircle = function IoMdAddCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.125 48 48 141.125 48 256s93.125 208 208 208 208-93.125 208-208S370.875 48 256 48zm107 229h-86v86h-42v-86h-86v-42h86v-86h42v86h86v42z"}}]})(props);
	};
	module.exports.IoMdAdd = function IoMdAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 277.333H277.333V416h-42.666V277.333H96v-42.666h138.667V96h42.666v138.667H416v42.666z"}}]})(props);
	};
	module.exports.IoMdAirplane = function IoMdAirplane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 336v-40L288 192V79.2c0-17.7-14.8-31.2-32-31.2s-32 13.5-32 31.2V192L64 296v40l160-48v113.6l-48 31.2V464l80-16 80 16v-31.2l-48-31.2V288l160 48z"}}]})(props);
	};
	module.exports.IoMdAlarm = function IoMdAlarm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M470 124.837l-98.443-81.78-27.814 32.931 98.442 81.769L470 124.837zM167.192 74.919L139.366 42 42 124.837l27.814 32.919 97.378-82.837zm99.509 97.709H234.6v127.446l101.649 60.539L352.3 334.06l-85.6-49.917V172.628zM256 87.665c-107 0-192.601 86.021-192.601 191.166C63.399 383.98 149 470 256 470c105.936 0 192.601-86.02 192.601-191.169 0-105.144-86.665-191.166-192.601-191.166zm0 339.855c-82.393 0-149.8-66.906-149.8-148.688 0-81.777 67.407-148.684 149.8-148.684 82.394 0 149.8 66.906 149.8 148.684 0 82.839-67.406 148.688-149.8 148.688z"}}]})(props);
	};
	module.exports.IoMdAlbums = function IoMdAlbums (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M154.7 464h266.7c23.5 0 42.7-19.2 42.7-42.7V154.7c0-23.5-19.2-42.7-42.7-42.7H154.7c-23.5 0-42.7 19.2-42.7 42.7v266.7c0 23.4 19.2 42.6 42.7 42.6z"}},{"tag":"path","attr":{"d":"M90.7 48h266.7c23.5 0 42.7 19.2 42.7 42.7V96H138.7C115.2 96 96 115.2 96 138.7V400h-5.3C67.2 400 48 380.8 48 357.3V90.7C48 67.2 67.2 48 90.7 48z"}}]})(props);
	};
	module.exports.IoMdAlert = function IoMdAlert (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.6 48 48 141.601 48 256s93.6 208 208 208 208-93.601 208-208S370.4 48 256 48zm24 312h-48v-40h48v40zm0-88h-48V144h48v128z"}}]})(props);
	};
	module.exports.IoMdAmericanFootball = function IoMdAmericanFootball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 256c14.1 35 36.2 66 64 90.6V165.4C68.2 190 46.1 221 32 256zM480 256c-14.1-35-36.2-66-64-90.6v181.2c27.8-24.6 49.9-55.6 64-90.6z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M256 105c-47.1 0-91 13.4-128 36.5v228.9c37 23.1 80.9 36.5 128 36.5s91-13.4 128-36.5V141.5c-37-23.1-80.9-36.5-128-36.5zm96 135v64h-32v-32h-48v32h-32v-32h-48v32h-32v-96h32v32h48v-32h32v32h48v-32h32v32z"}}]}]})(props);
	};
	module.exports.IoMdAnalytics = function IoMdAnalytics (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M379.4 178.3l-87.2 133.4C299 320 303 330.5 303 342c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-3 .3-6 .8-8.9l-57.6-33.5c-8.6 8.3-20.3 13.4-33.3 13.4-8.6 0-16.6-2.3-23.6-6.2L32 364.2v57.2c0 23.5 19.2 42.7 42.7 42.7h362.7c23.5 0 42.7-19.2 42.7-42.7V208.8l-58.6-38.9c-8.1 6.3-18.3 10.1-29.4 10.1-4.4 0-8.7-.6-12.7-1.7z"}},{"tag":"path","attr":{"d":"M117 217c26.5 0 48 21.5 48 48 0 2.1-.2 4.2-.4 6.2l60.1 33.6c8.3-6.8 18.8-10.8 30.4-10.8 3.6 0 7.1.4 10.4 1.1l87.4-135.4c-5.6-7.8-8.9-17.4-8.9-27.8 0-26.5 21.5-48 48-48s48 21.5 48 48c0 3.9-.5 7.7-1.3 11.3l41.3 27.6V90.7c0-23.5-19.2-42.7-42.7-42.7H74.7C51.2 48 32 67.2 32 90.7V320l40-38.3c-1.9-5.2-3-10.8-3-16.7 0-26.5 21.5-48 48-48z"}}]})(props);
	};
	module.exports.IoMdAperture = function IoMdAperture (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C132.288 32 32 132.288 32 256s100.288 224 224 224 224-100.288 224-224S379.712 32 256 32zm135.765 359.765C355.5 428.028 307.285 448 256 448s-99.5-19.972-135.765-56.235C83.972 355.5 64 307.285 64 256s19.972-99.5 56.235-135.765C156.5 83.972 204.715 64 256 64s99.5 19.972 135.765 56.235C428.028 156.5 448 204.715 448 256s-19.972 99.5-56.235 135.765z"}},{"tag":"path","attr":{"d":"M200.043 106.067c-40.631 15.171-73.434 46.382-90.717 85.933H256l-55.957-85.933zM412.797 288A160.723 160.723 0 0 0 416 256c0-36.624-12.314-70.367-33.016-97.334L311 288h101.797zM359.973 134.395C332.007 110.461 295.694 96 256 96c-7.966 0-15.794.591-23.448 1.715L310.852 224l49.121-89.605zM99.204 224A160.65 160.65 0 0 0 96 256c0 36.639 12.324 70.394 33.041 97.366L201 224H99.204zM311.959 405.932c40.631-15.171 73.433-46.382 90.715-85.932H256l55.959 85.932zM152.046 377.621C180.009 401.545 216.314 416 256 416c7.969 0 15.799-.592 23.456-1.716L201.164 288l-49.118 89.621z"}}]})(props);
	};
	module.exports.IoMdApps = function IoMdApps (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 176h80V96H96v80zm120 240h80v-80h-80v80zm-120 0h80v-80H96v80zm0-120h80v-80H96v80zm120 0h80v-80h-80v80zM336 96v80h80V96h-80zm-120 80h80V96h-80v80zm120 120h80v-80h-80v80zm0 120h80v-80h-80v80z"}}]})(props);
	};
	module.exports.IoMdAppstore = function IoMdAppstore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 152H360c0-57-46.562-103.859-104-103.859S152 95 152 152H48c18.688 216 13 312 13 312h389.999c-.001 0-5.688-98 13.001-312zM256 74.105c43.008 0 77.999 34.895 77.999 77.895H178c0-43 34.991-77.895 78-77.895zM204 397.64V228.867l142.999 84.387L204 397.64z"}}]})(props);
	};
	module.exports.IoMdArchive = function IoMdArchive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453.594 100.001l-32.353-39.299C415.469 52.627 405.083 48 394.664 48H117.335c-10.416 0-20.801 4.627-26.576 12.702l-32.351 39.299C51.468 106.923 48 117.335 48 128.886v288.89C48 443.2 68.8 464 94.225 464h323.553C443.202 464 464 443.2 464 417.775v-288.89c0-11.55-3.463-21.962-10.406-28.884zM256 383.109L128.89 256h80.89v-46.224h92.443V256h80.89L256 383.109zM96.534 94.221L115.02 71.11h277.331l21.965 23.111H96.534z"}}]})(props);
	};
	module.exports.IoMdArrowBack = function IoMdArrowBack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M427 234.625H167.296l119.702-119.702L256 85 85 256l171 171 29.922-29.924-118.626-119.701H427v-42.75z"}}]})(props);
	};
	module.exports.IoMdArrowDown = function IoMdArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M277.375 85v259.704l119.702-119.702L427 256 256 427 85 256l29.924-29.922 119.701 118.626V85h42.75z"}}]})(props);
	};
	module.exports.IoMdArrowDropdownCircle = function IoMdArrowDropdownCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.125 48 48 141.125 48 256s93.125 208 208 208 208-93.125 208-208S370.875 48 256 48zm0 272l-96-96h192l-96 96z"}}]})(props);
	};
	module.exports.IoMdArrowDropdown = function IoMdArrowDropdown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 192l128 128 128-128z"}}]})(props);
	};
	module.exports.IoMdArrowDropleftCircle = function IoMdArrowDropleftCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.875-93.125-208-208-208S48 141.125 48 256s93.125 208 208 208 208-93.125 208-208zm-272 0l96-96v192l-96-96z"}}]})(props);
	};
	module.exports.IoMdArrowDropleft = function IoMdArrowDropleft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 128L192 256l128 128z"}}]})(props);
	};
	module.exports.IoMdArrowDroprightCircle = function IoMdArrowDroprightCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c114.875 0 208-93.125 208-208S370.875 48 256 48 48 141.125 48 256s93.125 208 208 208zm-32-112V160l96 96-96 96z"}}]})(props);
	};
	module.exports.IoMdArrowDropright = function IoMdArrowDropright (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 128l128 128-128 128z"}}]})(props);
	};
	module.exports.IoMdArrowDropupCircle = function IoMdArrowDropupCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256c0-114.875-93.125-208-208-208S48 141.125 48 256s93.125 208 208 208 208-93.125 208-208zm-112 32H160l96-96 96 96z"}}]})(props);
	};
	module.exports.IoMdArrowDropup = function IoMdArrowDropup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 320l128-128 128 128z"}}]})(props);
	};
	module.exports.IoMdArrowForward = function IoMdArrowForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M85 277.375h259.704L225.002 397.077 256 427l171-171L256 85l-29.922 29.924 118.626 119.701H85v42.75z"}}]})(props);
	};
	module.exports.IoMdArrowRoundBack = function IoMdArrowRoundBack (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M401.4 224h-214l83-79.4c11.9-12.5 11.9-32.7 0-45.2s-31.2-12.5-43.2 0L89 233.4c-6 5.8-9 13.7-9 22.4v.4c0 8.7 3 16.6 9 22.4l138.1 134c12 12.5 31.3 12.5 43.2 0 11.9-12.5 11.9-32.7 0-45.2l-83-79.4h214c16.9 0 30.6-14.3 30.6-32 .1-18-13.6-32-30.5-32z"}}]})(props);
	};
	module.exports.IoMdArrowRoundDown = function IoMdArrowRoundDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M99.4 284.9l134 138.1c5.8 6 13.7 9 22.4 9h.4c8.7 0 16.6-3 22.4-9l134-138.1c12.5-12 12.5-31.3 0-43.2-12.5-11.9-32.7-11.9-45.2 0l-79.4 83v-214c0-16.9-14.3-30.6-32-30.6-18 0-32 13.7-32 30.6v214l-79.4-83c-12.5-11.9-32.7-11.9-45.2 0s-12.5 31.2 0 43.2z"}}]})(props);
	};
	module.exports.IoMdArrowRoundForward = function IoMdArrowRoundForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M284.9 412.6l138.1-134c6-5.8 9-13.7 9-22.4v-.4c0-8.7-3-16.6-9-22.4l-138.1-134c-12-12.5-31.3-12.5-43.2 0-11.9 12.5-11.9 32.7 0 45.2l83 79.4h-214c-17 0-30.7 14.3-30.7 32 0 18 13.7 32 30.6 32h214l-83 79.4c-11.9 12.5-11.9 32.7 0 45.2 12 12.5 31.3 12.5 43.3 0z"}}]})(props);
	};
	module.exports.IoMdArrowRoundUp = function IoMdArrowRoundUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M412.6 227.1L278.6 89c-5.8-6-13.7-9-22.4-9h-.4c-8.7 0-16.6 3-22.4 9l-134 138.1c-12.5 12-12.5 31.3 0 43.2 12.5 11.9 32.7 11.9 45.2 0l79.4-83v214c0 16.9 14.3 30.6 32 30.6 18 0 32-13.7 32-30.6v-214l79.4 83c12.5 11.9 32.7 11.9 45.2 0s12.5-31.2 0-43.2z"}}]})(props);
	};
	module.exports.IoMdArrowUp = function IoMdArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M277.375 427V167.296l119.702 119.702L427 256 256 85 85 256l29.924 29.922 119.701-118.626V427h42.75z"}}]})(props);
	};
	module.exports.IoMdAt = function IoMdAt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M265.6 212.3c-10.5 0-18.5 4.4-24 13.2-5.5 8.8-9.1 22-10.8 39.6-.9 11.7 0 20.5 2.7 26.5s7.1 9 13.1 9c5.5 0 10.3-1.5 14.6-4.4 4.3-2.9 8.1-8.3 11.3-16.2l6.1-66c-2.2-.5-4.4-.9-6.5-1.2-2.3-.4-4.4-.5-6.5-.5z"}},{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm127.8 201.9c-.9 21.4-7.6 39.9-20 55.6-12.4 15.6-31 23.4-55.6 23.4-8.2 0-15.3-2.2-21.2-6.6-6-4.4-10.2-10.7-12.6-18.8-4.1 8.3-9.4 14.5-15.7 18.6-6.3 4.1-13.7 6.2-22.2 6.2-15.1 0-26.6-5.8-34.6-17.3s-10.9-26.8-8.8-45.9c2.6-24.4 10-44 22.2-58.7 12.2-14.7 27-22 44.4-22 12.2 0 22.1 1.3 29.5 3.8 7.4 2.5 15.6 5.7 24.5 11l-.5-.1h.8l-7.7 83.4c-.5 8.5.1 14.6 1.7 17.8 1.7 3.2 3.9 4.9 6.7 4.9 11.3 0 20.4-5.1 27.2-15.6 6.8-10.5 10.6-23.6 11.4-39.6 1.6-33-5.1-58.7-20.2-77.1-15.1-18.4-38.3-27.7-69.7-27.7-30.5 0-54.8 9.9-72.8 29.8s-27.7 46.9-29.3 81.2c-1.7 33.4 5.6 59.8 21.9 79.1 16.3 19.4 39.7 29.1 70.3 29.1 8.5 0 17.3-.9 26.5-2.7 9.1-1.8 17.1-4.1 23.7-6.8l5.8 24.2c-6.8 4.1-15.4 7.3-25.9 9.6-10.5 2.3-20.7 3.4-30.7 3.4-40.8 0-72.3-12.1-94.3-36.4-22-24.2-32.2-57.4-30.5-99.6 1.8-41.8 14.9-74.9 39.1-99.4 24.3-24.5 56.5-36.7 96.7-36.7 39.5 0 69.8 11.6 90.7 34.7 21.2 23.2 30.8 54.9 29.2 95.2z"}}]})(props);
	};
	module.exports.IoMdAttach = function IoMdAttach (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M341.334 128v234.666C341.334 409.604 302.938 448 256 448c-46.937 0-85.333-38.396-85.333-85.334V117.334C170.667 87.469 194.135 64 224 64c29.864 0 53.333 23.469 53.333 53.334v245.333c0 11.729-9.605 21.333-21.334 21.333s-21.333-9.604-21.333-21.333V160h-32v202.667C202.667 392.531 226.135 416 256 416c29.865 0 53.334-23.469 53.334-53.333V117.334C309.334 70.401 270.938 32 224 32s-85.334 38.401-85.334 85.334v245.332C138.667 427.729 190.938 480 256 480c65.062 0 117.334-52.271 117.334-117.334V128h-32z"}}]})(props);
	};
	module.exports.IoMdBackspace = function IoMdBackspace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M433.5 96H167.2c-12.2 0-21.8 6.2-28.2 15.6L43 256l96 144.2c6.4 9.4 16 15.8 28.2 15.8h266.2c19.5 0 35.5-16 35.5-35.6V131.6C469 112 453 96 433.5 96zm-53.3 223.8l-25 25.1-63.7-63.8-63.7 63.8-25-25.1 63.7-63.8-63.7-63.8 25-25.1 63.7 63.8 63.7-63.8 25 25.1-63.7 63.8 63.7 63.8z"}}]})(props);
	};
	module.exports.IoMdBarcode = function IoMdBarcode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M88 128h48v256H88zM232 128h48v256h-48zM160 144h48v224h-48zM304 144h48v224h-48zM376 128h48v256h-48z"}},{"tag":"path","attr":{"d":"M104 104V56H16v400h88v-48H64V104zM408 56v48h40v304h-40v48h88V56z"}}]})(props);
	};
	module.exports.IoMdBaseball = function IoMdBaseball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M365.9 402.6L343 416.1l-16-28 20.2-11.9c-5.2-8.5-9.8-17.4-13.9-26.7-1.4-3.1-2.7-6.3-3.9-9.5l-25.1 5.8-7.1-31.6 22.6-5.2c-2.8-12.1-4.7-24-5.5-37H290v-32h24.3c.8-12 2.7-24.8 5.5-36.8l-22.6-5.2 7.1-31.6 25.1 5.8c1.3-3.2 2.6-6.4 4-9.6 4.1-9.2 8.7-18.1 13.8-26.6L327 124.1l16-28 22.8 13.5c5.2-6.4 10.8-12.5 16.7-18.3C347.4 64.1 303.5 48 256 48s-91.4 16.1-126.5 43.2c5.9 5.8 11.5 12 16.7 18.3L169 96.1l16 28-20.2 11.9c5.1 8.5 9.8 17.4 13.8 26.6 1.4 3.2 2.7 6.4 4 9.6l25.1-5.8 7.1 31.6-22.6 5.2c2.8 12.1 4.6 24.8 5.5 36.8H222v32h-24.3c-.8 13-2.7 24.9-5.5 37l22.6 5.2-7.1 31.6-25.1-5.8c-1.2 3.2-2.5 6.3-3.9 9.5-4.1 9.2-8.7 18.1-13.9 26.7l20.2 11.9-16 28-22.9-13.5c-5.2 6.3-10.7 12.4-16.6 18.2 35.1 27.1 79 43.2 126.5 43.2s91.4-16.1 126.5-43.2c-5.9-5.8-11.4-11.9-16.6-18.2z"}},{"tag":"path","attr":{"d":"M393.8 126l18.1 10.7-16 28-21.2-12.5c-5 8.3-9.5 16.9-13.3 25.9-.2.4-.4.9-.5 1.3l21 4.9-7.1 31.6-23.9-5.5c-2.3 9.7-3.8 19.6-4.6 29.6H370v32h-23.6c.8 10 2.3 20 4.6 29.8l23.9-5.5 7.1 31.6-21 4.9c.2.4.3.8.5 1.2 3.8 9 8.3 17.7 13.3 26l21.1-12.4 16 28-18 10.6c3.3 3.9 6.8 7.7 10.5 11.3l2 2C442 362 464 311.4 464 256s-22-106-57.7-143.4c-.7.7-1.4 1.3-2 2-3.7 3.7-7.2 7.5-10.5 11.4zM118.2 386.1l-18-10.6 16-28 21.1 12.4c5.1-8.3 9.5-17 13.3-26 .2-.4.3-.8.5-1.2l-21-4.9 7.1-31.6 23.9 5.5c2.3-9.8 3.8-19.8 4.6-29.8H142v-32h23.6c-.8-10-2.3-19.9-4.6-29.6l-23.9 5.5-7.1-31.6 21-4.9c-.2-.4-.3-.9-.5-1.3-3.8-9-8.2-17.7-13.3-25.9L116 164.6l-16-28 18.1-10.7c-3.4-3.9-6.9-7.7-10.6-11.4l-2-2C70 150 48 200.6 48 256s22 106 57.7 143.4c.7-.7 1.4-1.3 2-2 3.6-3.6 7.1-7.4 10.5-11.3z"}}]})(props);
	};
	module.exports.IoMdBasket = function IoMdBasket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M362.1 205.2L272.9 72.5C269 66.8 262.5 64 256 64c-6.5 0-13 2.8-16.9 8.7l-89.2 132.5H52.4c-11.2 0-20.4 9.1-20.4 20.2 0 1.8.2 3.6.8 5.5l51.7 187.5c4.7 17 20.4 29.5 39.1 29.5h264.7c18.7 0 34.4-12.5 39.3-29.5l51.7-187.5.6-5.5c0-11.1-9.2-20.2-20.4-20.2h-97.4zm-167.2 0l61.1-89 61.1 89H194.9zM256 367.1c-22.4 0-40.7-18.2-40.7-40.5s18.3-40.5 40.7-40.5 40.7 18.2 40.7 40.5-18.3 40.5-40.7 40.5z"}}]})(props);
	};
	module.exports.IoMdBasketball = function IoMdBasketball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M191.6 272c-3.8 55-26.4 107.1-64.5 147.7 31.6 25 70.9 41 112.9 44.3V272h-48.4zM272 464c42-3.3 81.5-19.4 113.1-44.5-38-40.6-60.5-92.5-64.3-147.5H272v192zM240 48c-42 3.2-80.5 19-111.9 43.6 38 40.9 60.3 93.4 63.7 148.4H240V48zM320.7 240c3.4-55 25.6-107.4 63.5-148.3C352.7 67.1 314 51.2 272 48v192h48.7zM408.6 114.2c-17.2 18.5-30.7 39.7-40.1 62.9-8.2 20.2-13.1 40.9-14.6 62.9H464c-3.7-48-24.1-92.2-55.4-125.8zM368.5 333.1c9.6 23.7 23.3 45.1 40.9 63.8C440.3 363.4 460.3 320 464 272H354.1c1.6 21 6.5 41.5 14.4 61.1zM143.9 177.1c-9.5-23.3-23-44.5-40.3-63.1-31.4 33.6-51.9 78-55.6 126h110.5c-1.6-22-6.5-42.8-14.6-62.9zM102.7 397.1c17.7-18.8 31.5-40.3 41.1-64 8-19.6 12.8-40.1 14.5-61.1H48c3.7 48 23.8 91.6 54.7 125.1z"}}]})(props);
	};
	module.exports.IoMdBatteryCharging = function IoMdBatteryCharging (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M338.2 76.8h-37.4V32h-89.6v44.8h-37.4c-16.4 0-29.8 13.4-29.8 29.8V450c0 16.6 13.4 30 29.8 30H338c16.6 0 30-13.4 30-29.8V106.6c0-16.4-13.4-29.8-29.8-29.8zM233.6 435.2V312h-44.8l89.6-168v123.2h44.8l-89.6 168z"}}]})(props);
	};
	module.exports.IoMdBatteryDead = function IoMdBatteryDead (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M338.2 76.8h-37.4V32h-89.6v44.8h-37.4c-16.4 0-29.8 13.4-29.8 29.8V450c0 16.6 13.4 30 29.8 30H338c16.6 0 30-13.4 30-29.8V106.6c0-16.4-13.4-29.8-29.8-29.8zM320 432H192V124.8h128V432z"}}]})(props);
	};
	module.exports.IoMdBatteryFull = function IoMdBatteryFull (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M338.2 76.8h-37.4V32h-89.6v44.8h-37.4c-16.4 0-29.8 13.4-29.8 29.8V450c0 16.6 13.4 30 29.8 30H338c16.6 0 30-13.4 30-29.8V106.6c0-16.4-13.4-29.8-29.8-29.8z"}}]})(props);
	};
	module.exports.IoMdBeaker = function IoMdBeaker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448.1 34.9c0-1.2-.4-2.9-2.9-2.9H128.5c-54.3 0-64.4 27.4-64.4 39.8C94.4 76 96 76.5 96 108.5v307c0 35.3 28.9 64.5 64.3 64.5H368c35.3 0 64-29.2 64-64.5V73.3c2.2-17.5 12-31.8 13.1-33.5 1.2-1.9 3-3.8 3-4.9zM354.2 432H176.3c-15.9 0-29.7-11.9-32.3-27.1V80h240v319.7c0 18-12.4 32.3-29.8 32.3z"}},{"tag":"path","attr":{"d":"M182 160v226c0 4.4 3.6 8 8 8h148c4.4 0 8-3.6 8-8V160H182z"}}]})(props);
	};
	module.exports.IoMdBed = function IoMdBed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M168.7 264.5c29 0 52.4-22.9 52.4-51.2s-23.4-51.2-52.4-51.2-52.4 22.9-52.4 51.2 23.5 51.2 52.4 51.2zm209.5-102.4H238.5v119.5H98.9V128H64v256h34.9v-51.2h314.2V384H448V230.4c0-37.7-31.2-68.3-69.8-68.3z"}}]})(props);
	};
	module.exports.IoMdBeer = function IoMdBeer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 140h-16v-6c8.9-9 16-22.9 16-38 0-35.3-28.7-64-64-64-16.3 0-31.1 6.1-42.4 16.1C297.2 38 281.4 32 264.2 32c-15.8 0-30.4 5.1-42.3 13.7C212 37.2 199 32 184.9 32c-17.1 0-32.4 7.6-42.8 19.5-11.7-12-28-19.5-46.1-19.5-35.3 0-64 28.7-64 64 0 16.2 6.1 31 16 42.3V193c0 26.5 21.5 48 48 48v174.5c0 35.3 28.8 64.5 64.2 64.5H336c35.3 0 64.1-29.2 64.1-64.5V372h16c50 0 64-32.7 64-68v-96c-.1-35.3-17.1-68-64.1-68zm-64 52H144v-53.7c.3-.4.7-.8 1-1.2 1.2-1.5 2.4-3 3.5-4.6 1.5 1.2 3 2.4 4.6 3.4 9.1 6.1 20 9.7 31.7 9.7 6.4 0 12.6-1.1 18.3-3 12.8 20.2 35.3 33.7 61 33.7 22 0 41.7-9.9 54.9-25.4 5.7-6.7 10.2-14.4 13.1-22.9H352v64zM96 128.1v75c-9 0-16-7.2-16-16v-63.3c-8-4.5-13.4-12.1-15.3-21-.5-2.1-.7-4.4-.7-6.7 0-17.6 14.4-32 32-32 11.8 0 23.3 7.7 30.1 15.4s26.7 7.7 33.9 0c6.8-7.3 14.3-15.4 24.8-15.4 6 0 11.6 2.2 15.9 5.8 1.9 1.6 3.6 3.5 4.9 5.6 1.1 1.8 2 4.2 3.1 5.8 2.7 3.4 6.5 5.5 11.2 5.5 4.4 0 8.3-1.9 11-5 .6-.7 1.2-1.5 1.7-2.3 2-2.5 4.2-4.8 6.7-6.8 6.8-5.4 15.5-8.6 24.8-8.6 10.6 0 20.2 4.1 27.4 10.9 1.7 1.6 6.7 4.5 13.2 5.1 4.5.4 6.1.3 8.2 0 10.3-1.3 14.4-4.7 16.4-6.6 5.8-5.8 13.8-9.4 22.6-9.4 17.6 0 32 14.4 32 32 .2 3.1-.3 6.2-1.2 9.1-2.5-5.5-8.1-9.2-14.6-9.2h-55s-8.7-.7-8.7 8.2c0 8.9-2.9 17.1-7.8 23.7-7.3 9.9-19.1 16.4-32.4 16.4-14.9 0-27.9-8.1-34.8-20.2-1.6-2.7-2.8-5.6-3.7-8.6-.1-.6-.3-1.1-.4-1.6-2-5.9-7.5-10.2-14.1-10.2-3.9 0-7.5 1.5-10.2 4l-.1.1c-2.4 2.1-5.3 3.7-8.4 4.7-2.4.8-5 1.2-7.7 1.2-7.5 0-14.7-4-18.8-8.6-10-11.4-23.7-6.8-29.7-5.5-6 1.3-12.2 11.7-12.2 11.7-1.1 2.1-2.4 4-3.9 5.8-6 6.7-15.2 11-24.2 11zM432 304c0 17.7-6.3 24-24 24h-8V184h8c17.7 0 24 6.3 24 24v96z"}}]})(props);
	};
	module.exports.IoMdBicycle = function IoMdBicycle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M330.666 131.202c18.668 0 33.598-14.935 33.598-33.601S349.334 64 330.666 64C312 64 297.07 78.935 297.07 97.601s14.93 33.601 33.596 33.601zm56 130.132c-51.332 0-93.332 42-93.332 93.333s42 93.333 93.332 93.333C438 448 480 406 480 354.667s-42-93.333-93.334-93.333zm0 158.666c-36.402 0-65.332-28.93-65.332-65.333s28.93-65.333 65.332-65.333c36.404 0 65.334 28.93 65.334 65.333S423.07 420 386.666 420zm-81.069-196H384v-32h-58.845l-34.62-60.134c-5.605-9.333-15.869-15.864-27.07-15.864-8.399 0-16.798 3.732-22.399 9.333L169.334 194.4c-5.601 5.601-9.333 14-9.333 22.399 0 12.131 9.202 21.465 18.535 27.065L240 282.134V368h32V256l-39.333-32 42.929-44.533L305.597 224zm-180.264 37.334C74 261.334 32 303.334 32 354.667S74 448 125.333 448s93.333-42 93.333-93.333-41.999-93.333-93.333-93.333zm0 158.666C88.934 420 60 391.07 60 354.667s28.934-65.333 65.333-65.333 65.333 28.93 65.333 65.333S161.732 420 125.333 420z"}}]})(props);
	};
	module.exports.IoMdBluetooth = function IoMdBluetooth (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M399 159.9L270.5 32H248v170L144.7 99.2 113 130.8 238.8 256 113 381.2l31.7 31.6L248 310v170h22.5L399 352.1 302.2 256l96.8-96.1zm-106-42.1l42.3 42.1L293 202v-84.2zm42.3 234.3L293 394.2V310l42.3 42.1z"}}]})(props);
	};
	module.exports.IoMdBoat = function IoMdBoat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M84.255 413h1.063c34.123 0 63.977-19.021 85.305-42.494 21.325 23.473 51.18 42.762 85.304 42.762s63.979-19.334 85.305-42.806C362.559 393.934 392.412 413 426.535 413h1.062l51.253-138.78c2.126-5.329 1.063-11.641-1.07-16.976-2.136-5.333-7.237-8.487-12.567-10.623L427 234.133v-98.15C427 112.51 407.344 93 383.884 93h-63.979l-15.993-53h-95.969l-15.995 53h-63.979C104.511 93 85 112.51 85 135.982v98.15l-38.074 12.533c-5.33 2.136-10.582 5.334-12.718 10.667-2.135 5.335-3.158 10.49-1.031 16.887L84.255 413zM128 136h256v84.261l-128-41.605-128 41.605V136z"}},{"tag":"path","attr":{"d":"M341.231 408.007c-52.253 36.267-118.356 36.258-170.608-.009 0 0-57.638 64.002-106.632 64.002h21.327c29.854 0 58.646-11.726 85.305-25.594 53.315 27.734 117.293 27.728 170.608-.007C367.89 460.268 396.681 472 426.535 472h21.328c-47.651 0-106.632-63.993-106.632-63.993z"}}]})(props);
	};
	module.exports.IoMdBody = function IoMdBody (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c22 0 40 18 40 40s-18 40-40 40-40-18-40-40 18-40 40-40zm192 144.1H320V464h-42.7V320h-42.7v144H192V192.1H64v-42.7h384v42.7z"}}]})(props);
	};
	module.exports.IoMdBonfire = function IoMdBonfire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272.2 350.6c-.8-8.2-8.2-14.6-17.3-14.6-8.3 0-15.2 5.4-16.9 12.5L221.1 441c-.5 2.3-.8 4.6-.8 7 0 17.7 15.5 32 34.7 32s34.7-14.3 34.7-32c0-2.9-.4-5.7-1.2-8.4l-16.3-89zM310.1 355zM404.3 390.3c-1.9-1.4-3.6-2.9-5.6-3.9l-68.9-47.5c-6.3-3.8-13-3.7-17.9.9-4.5 4.1-5.1 10.4-1.8 15.4l53 65.8c1 1.5 2.3 2.8 3.6 4.2 8.5 9.1 27.2 9.6 37.5 0 10.4-9.8 10.3-27.2.1-34.9zM382.2 335zM450.4 322.5l-64.5-2.3c-4.2-.6-8 2.1-8.7 6-.7 3.6 1.5 7.1 5.1 8.8h.1l62.5 17.8c9 1.9 19.1-2.3 19.1-11.6 0-11.9-3.3-17.5-13.6-18.7zM129.5 335zM129.5 335c3.6-1.6 5.7-5.2 5.1-8.8-.7-4-4.5-6.6-8.7-6l-64.5 2.3C51 323.7 48 329.3 48 341.1c0 9.3 9.9 13.6 18.8 11.6l62.5-17.8c.1.1.1.1.2.1zM182.2 338.8l-68.9 47.4c-2 1.1-3.9 2.4-5.6 3.9-10.4 9.6-10.4 25.1 0 34.6 10.4 9.6 27.1 9.6 37.5 0 1.4-1.3 2.6-2.7 3.6-4.2l53-65.6c3.3-5 2.7-11.2-1.8-15.3-4.8-4.5-12.6-4.8-17.8-.8zM256 32s30.2 35.4 30.2 64.4c0 27.8-18.2 50.3-45.9 50.3-27.9 0-48.9-22.5-48.9-50.3l.4-6.9c-27.2 32.3-43.5 76.2-43.5 121.8 0 59.6 48.2 107.8 107.8 107.8s107.8-48.2 107.8-107.8C363.8 138.7 328 53.7 256 32zm-3.9 246.7c-24 0-43.4-18.9-43.4-42.3 0-21.8 14.1-37.2 37.9-42 23.8-4.9 48.5-16.3 62.3-34.8 5.3 17.4 7.9 35.7 7.9 54.4 0 35.7-29 64.7-64.7 64.7z"}}]})(props);
	};
	module.exports.IoMdBook = function IoMdBook (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426.2 80.4l-170.2 32-170.2-32C64 77 48 97.3 48 118v244.5c0 20.7 16 32.6 37.8 37.6L256 432l170.2-32c21.8-5 37.8-16.9 37.8-37.6V118c0-20.7-16-41-37.8-37.6zm0 282l-151.2 32V149.9l151.2-32v244.5zm-189.2 32l-151.2-32V118L237 150v244.4z"}}]})(props);
	};
	module.exports.IoMdBookmark = function IoMdBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M360 64H152c-22.002 0-40 17.998-40 40v344l144-64 144 64V104c0-22.002-17.998-40-40-40z"}}]})(props);
	};
	module.exports.IoMdBookmarks = function IoMdBookmarks (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.2 64h-21c15 5.7 22.8 20.6 22.8 42.7v298.7c0 22.1-7 37.3-22.8 42.7h21c23.7 0 42.8-19.2 42.8-42.7V106.7c0-23.5-19.1-42.7-42.8-42.7zM345.5 64.2c-1.4-.1-2.8-.2-4.2-.2H106.7C83.2 64 64 83.2 64 106.7v298.7c0 23.5 19.2 42.7 42.7 42.7h234.7c1.4 0 2.8-.1 4.2-.2 21.5-2.1 38.5-20.4 38.5-42.5V106.7c-.1-22.1-17.1-40.4-38.6-42.5zM208 256l-56-32-56 32V96h112v160z"}}]})(props);
	};
	module.exports.IoMdBowtie = function IoMdBowtie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M276 304h-40c-15.4 0-28-12.6-28-28v-40c0-15.4 12.6-28 28-28h40c15.4 0 28 12.6 28 28v40c0 15.4-12.6 28-28 28zM176 280v-48c0-18.2 8.7-34.4 22.2-44.6C192 160 96 96 64 96c-17.6 0-32 14.4-32 32v256c0 17.6 14.3 32 32 32 32 0 128-64 134.2-91.4-13.5-10.2-22.2-26.4-22.2-44.6zM448 96c-32 0-128 64-134.2 91.4 13.5 10.2 22.2 26.4 22.2 44.6v48c0 18.2-8.7 34.4-22.2 44.6C320 352 416 416 448 416c17.7 0 32-14.4 32-32V128c0-17.6-14.4-32-32-32z"}}]})(props);
	};
	module.exports.IoMdBriefcase = function IoMdBriefcase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 144v-39.6C352 82 334 64 311.6 64H200.4C178 64 160 82 160 104.4V144H48v263.6C48 430 66 448 88.4 448h335.2c22.4 0 40.4-18 40.4-40.4V144H352zm-40 0H200v-40h112v40z"}}]})(props);
	};
	module.exports.IoMdBrowsers = function IoMdBrowsers (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424 64H88c-26.6 0-48 21.6-48 48v288c0 26.4 21.4 48 48 48h336c26.4 0 48-21.6 48-48V112c0-26.4-21.4-48-48-48zm0 336H88V176h336v224z"}}]})(props);
	};
	module.exports.IoMdBrush = function IoMdBrush (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M149.9 302.2c-39.1 0-70.7 31-70.7 69.3 0 30.3-27.3 46.2-47.2 46.2C53.7 446 90.7 464 126.3 464c52.1 0 94.3-41.4 94.3-92.4 0-38.4-31.6-69.4-70.7-69.4zM473.1 85.7l-31.6-31c-9.2-9-24-9-33.2 0L197 261.8l64.8 63.5 211.2-207c9.3-9 9.3-23.6.1-32.6z"}}]})(props);
	};
	module.exports.IoMdBug = function IoMdBug (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 160h-67.4c-10.8-18.7-25.7-34.8-43.7-47L376 73.8 342.2 40l-52.1 52.1C279 89.4 267.8 88 256 88s-23 1.4-33.8 4.1L169.8 40 136 73.8l38.9 39.1c-17.8 12.2-32.6 28.3-43.4 47H64v48h50.2c-1.2 7.9-2.2 15.8-2.2 24v24H64v48h48v24c0 8.2 1 16.1 2.2 24H64v48h67.4c25 43 71.3 72 124.6 72s99.6-29 124.6-72H448v-48h-50.2c1.2-7.9 2.2-15.8 2.2-24v-24h48v-48h-48v-24c0-8.2-1-16.1-2.2-24H448V160z"}}]})(props);
	};
	module.exports.IoMdBuild = function IoMdBuild (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M474.1 398.2L289.1 212c18.3-47 8.1-102.3-30.5-141.1C217.9 30 156.9 21.8 108.1 44.3l87.4 88-61 61.4-89.5-88c-24.3 49-14.1 110.4 26.5 151.3 38.6 38.9 93.5 49.1 140.3 30.7l185 186.2c8.1 8.2 20.3 8.2 28.5 0l46.8-47c10.2-8.3 10.2-22.6 2-28.7z"}}]})(props);
	};
	module.exports.IoMdBulb = function IoMdBulb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 428c0 10.6 8.6 20 20 20h88c11.4 0 20-9.4 20-20v-18H192v18zm64-364c-79.7 0-144 59.9-144 134 0 45.7 24.1 86.2 61.4 110.6V352c0 10.6 9.3 19.2 20.6 19.2h123.9c11.4 0 20.6-8.6 20.6-19.2v-43.4C375.9 284.2 400 243.7 400 198c0-74.1-64.3-134-144-134z"}}]})(props);
	};
	module.exports.IoMdBus = function IoMdBus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 352c0 19.198 13.864 24.531 26.667 36.271v38.396c0 11.729 9.599 21.334 21.333 21.334h21.333c11.734 0 21.334-9.604 21.334-21.334v-21.333h170.666v21.333c0 11.729 9.604 21.334 21.334 21.334H384c11.729 0 21.333-9.604 21.333-21.334v-38.396C418.136 376.531 432 370.136 432 352V148.334C432 73.667 349.864 64 256 64S80 73.667 80 148.334V352zm80 15.989c-18.136 0-32-13.864-32-32 0-18.135 13.864-32 32-32s32 13.865 32 32c0 18.136-13.864 32-32 32zm192 0c-18.136 0-32-13.864-32-32 0-18.135 13.864-32 32-32s32 13.865 32 32c0 18.136-13.864 32-32 32zm32-122.656H128V138.667h256v106.666z"}}]})(props);
	};
	module.exports.IoMdBusiness = function IoMdBusiness (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M261 149.3V64H48v384h416V149.3H261zm-127.8 256H90.6v-42.7h42.6v42.7zm0-85.3H90.6v-42.7h42.6V320zm0-85.3H90.6V192h42.6v42.7zm0-85.4H90.6v-42.7h42.6v42.7zm85.2 256h-42.6v-42.7h42.6v42.7zm0-85.3h-42.6v-42.7h42.6V320zm0-85.3h-42.6V192h42.6v42.7zm0-85.4h-42.6v-42.7h42.6v42.7zm203 256H261v-42.7h42.6V320H261v-42.7h42.6v-42.7H261V192h160.4v213.3zm-37.6-170.6h-42.6v42.7h42.6v-42.7zm0 85.3h-42.6v42.7h42.6V320z"}}]})(props);
	};
	module.exports.IoMdCafe = function IoMdCafe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 400h368v48H48zM424 64H80v224c0 44 36 80 80 80h144c44 0 80-36 80-80v-64h40c22 0 40-18 40-40v-80c0-22-18-40-40-40zm0 112h-40v-64h40v64z"}}]})(props);
	};
	module.exports.IoMdCalculator = function IoMdCalculator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368 48H144c-26.6 0-48 21.6-48 48v320c0 26.4 21.4 48 48 48h224c26.4 0 48-21.6 48-48V96c0-26.4-21.4-48-48-48zM200 416h-48v-48h48v48zm0-88h-48v-48h48v48zm0-88h-48v-48h48v48zm80 176h-48v-48h48v48zm0-88h-48v-48h48v48zm0-88h-48v-48h48v48zm80 176h-48V280h48v136zm0-176h-48v-48h48v48zm0-96H152V96h208v48z"}}]})(props);
	};
	module.exports.IoMdCalendar = function IoMdCalendar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368.005 272h-96v96h96v-96zm-32-208v32h-160V64h-48v32h-24.01c-22.002 0-40 17.998-40 40v272c0 22.002 17.998 40 40 40h304.01c22.002 0 40-17.998 40-40V136c0-22.002-17.998-40-40-40h-24V64h-48zm72 344h-304.01V196h304.01v212z"}}]})(props);
	};
	module.exports.IoMdCall = function IoMdCall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M426.666 330.667a250.385 250.385 0 0 1-75.729-11.729c-7.469-2.136-16-1.073-21.332 5.333l-46.939 46.928c-60.802-30.928-109.864-80-140.802-140.803l46.939-46.927c5.332-5.333 7.462-13.864 5.332-21.333-8.537-24.531-12.802-50.136-12.802-76.803C181.333 73.604 171.734 64 160 64H85.333C73.599 64 64 73.604 64 85.333 64 285.864 226.136 448 426.666 448c11.73 0 21.334-9.604 21.334-21.333V352c0-11.729-9.604-21.333-21.334-21.333z"}}]})(props);
	};
	module.exports.IoMdCamera = function IoMdCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"280","r":"63"}},{"tag":"path","attr":{"d":"M440 96h-88l-32-32H192l-32 32H72c-22.092 0-40 17.908-40 40v272c0 22.092 17.908 40 40 40h368c22.092 0 40-17.908 40-40V136c0-22.092-17.908-40-40-40zM256 392c-61.855 0-112-50.145-112-112s50.145-112 112-112 112 50.145 112 112-50.145 112-112 112z"}}]})(props);
	};
	module.exports.IoMdCar = function IoMdCar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.208 117.333c-4.271-12.802-16-21.333-29.875-21.333H138.667c-13.875 0-25.604 8.531-29.875 21.333L64 234.667v160C64 406.396 73.604 416 85.333 416h21.334c11.729 0 21.333-9.604 21.333-21.333V384h256v10.667c0 11.729 9.604 21.333 21.333 21.333h21.334c11.729 0 21.333-9.604 21.333-21.333v-160l-44.792-117.334zM138.667 320c-18.125 0-32-13.865-32-32s13.875-32 32-32 32 13.866 32 32-13.875 32-32 32zm234.666 0c-18.125 0-32-13.865-32-32s13.875-32 32-32 32 13.866 32 32-13.875 32-32 32zM106.667 213.333l32-85.333h234.666l32 85.333H106.667z"}}]})(props);
	};
	module.exports.IoMdCard = function IoMdCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M435.2 80H76.8c-24.9 0-44.6 19.6-44.6 44L32 388c0 24.4 19.9 44 44.8 44h358.4c24.9 0 44.8-19.6 44.8-44V124c0-24.4-19.9-44-44.8-44zm0 308H76.8V256h358.4v132zm0-220H76.8v-44h358.4v44z"}}]})(props);
	};
	module.exports.IoMdCart = function IoMdCart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M169.6 377.6c-22.882 0-41.6 18.718-41.6 41.601 0 22.882 18.718 41.6 41.6 41.6s41.601-18.718 41.601-41.6c-.001-22.884-18.72-41.601-41.601-41.601zM48 51.2v41.6h41.6l74.883 151.682-31.308 50.954c-3.118 5.2-5.2 12.482-5.2 19.765 0 27.85 19.025 41.6 44.825 41.6H416v-40H177.893c-3.118 0-5.2-2.082-5.2-5.2 0-1.036 2.207-5.2 2.207-5.2l20.782-32.8h154.954c15.601 0 29.128-8.317 36.4-21.836l74.882-128.8c1.237-2.461 2.082-6.246 2.082-10.399 0-11.446-9.364-19.765-20.8-19.765H135.364L115.6 51.2H48zm326.399 326.4c-22.882 0-41.6 18.718-41.6 41.601 0 22.882 18.718 41.6 41.6 41.6S416 442.082 416 419.2c0-22.883-18.719-41.6-41.601-41.6z"}}]})(props);
	};
	module.exports.IoMdCash = function IoMdCash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 96v256h448V96H32zm160.5 224h-80.4c0-26.6-21.5-48.1-48.1-48.1V192c35.3 0 64-28.7 64-64h64.5c-19.9 23.5-32.5 57.8-32.5 96s12.6 72.5 32.5 96zM448 271.9c-26 0-48 21.5-48 48.1h-80.5c19.9-23.5 32.5-57.8 32.5-96s-12.6-72.5-32.5-96H384c0 35.3 28.7 64 64 64v79.9zM32 384h448v32H32z"}}]})(props);
	};
	module.exports.IoMdCellular = function IoMdCellular (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 448h384V64L64 448z"}}]})(props);
	};
	module.exports.IoMdChatboxes = function IoMdChatboxes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M391.553 64H57.607C53.131 64 48 67.745 48 72.159v214.217c0 4.413 5.131 8.624 9.607 8.624H115v88.894L205.128 295h186.425c4.477 0 7.447-4.211 7.447-8.624V72.159c0-4.414-2.971-8.159-7.447-8.159z"}},{"tag":"path","attr":{"d":"M456.396 127H424v166.57c0 15.987-6.915 26.43-25.152 26.43H218.096l-38.905 39h129.688L399 448v-89h57.396c4.478 0 7.604-4.262 7.604-8.682V136.103c0-4.414-3.126-9.103-7.604-9.103z"}}]})(props);
	};
	module.exports.IoMdChatbubbles = function IoMdChatbubbles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M132.8 368c-20.2 0-44.8-24.6-44.8-44.8V160h-9.6C61.7 160 48 173.7 48 190.4V464l58.5-58h215.1c16.7 0 30.4-14.1 30.4-30.9V368H132.8z"}},{"tag":"path","attr":{"d":"M429.1 48H149.9C130.7 48 115 63.7 115 82.9V309c0 19.2 15.7 35 34.9 35h238.2l75.9 53V82.9c0-19.2-15.7-34.9-34.9-34.9z"}}]})(props);
	};
	module.exports.IoMdCheckboxOutline = function IoMdCheckboxOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M168.531 215.469l-29.864 29.864 96 96L448 128l-29.864-29.864-183.469 182.395-66.136-65.062zm236.802 189.864H106.667V106.667H320V64H106.667C83.198 64 64 83.198 64 106.667v298.666C64 428.802 83.198 448 106.667 448h298.666C428.802 448 448 428.802 448 405.333V234.667h-42.667v170.666z"}}]})(props);
	};
	module.exports.IoMdCheckbox = function IoMdCheckbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.333 64H106.667C83.198 64 64 83.198 64 106.667v298.666C64 428.802 83.198 448 106.667 448h298.666C428.802 448 448 428.802 448 405.333V106.667C448 83.198 428.802 64 405.333 64zm-192 298.667L106.667 256l29.864-29.864 76.802 76.802 162.136-162.136 29.864 29.865-192 192z"}}]})(props);
	};
	module.exports.IoMdCheckmarkCircleOutline = function IoMdCheckmarkCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M170.718 216.482L141.6 245.6l93.6 93.6 208-208-29.118-29.118L235.2 279.918l-64.482-63.436zM422.4 256c0 91.518-74.883 166.4-166.4 166.4S89.6 347.518 89.6 256 164.482 89.6 256 89.6c15.6 0 31.2 2.082 45.764 6.241L334 63.6C310.082 53.2 284.082 48 256 48 141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208h-41.6z"}}]})(props);
	};
	module.exports.IoMdCheckmarkCircle = function IoMdCheckmarkCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm-42.7 318.9L106.7 260.3l29.9-29.9 76.8 76.8 162.1-162.1 29.9 29.9-192.1 191.9z"}}]})(props);
	};
	module.exports.IoMdCheckmark = function IoMdCheckmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M186.301 339.893L96 249.461l-32 30.507L186.301 402 448 140.506 416 110z"}}]})(props);
	};
	module.exports.IoMdClipboard = function IoMdClipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.333 80h-87.35C310.879 52.396 285.821 32 256 32s-54.879 20.396-61.983 48h-87.35C83.198 80 64 99.198 64 122.667v314.665C64 460.801 83.198 480 106.667 480h298.666C428.802 480 448 460.801 448 437.332V122.667C448 99.198 428.802 80 405.333 80zM256 80c11.729 0 21.333 9.599 21.333 21.333s-9.604 21.334-21.333 21.334-21.333-9.6-21.333-21.334S244.271 80 256 80zm152 360H104V120h40v72h224v-72h40v320z"}}]})(props);
	};
	module.exports.IoMdClock = function IoMdClock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0-81.3 81.2-81.2 212.9 0 294.2 81.2 81.2 212.9 81.2 294.2 0 81.2-81.2 81.2-213 0-294.2zm-16.5 53.2c7.6-4.4 17.5-1.8 21.9 5.9 4.4 7.6 1.8 17.5-5.9 21.9-7.6 4.4-17.5 1.8-21.9-5.9-4.4-7.6-1.8-17.5 5.9-21.9zM80 256c0-8.8 7.2-16 16-16s16 7.2 16 16-7.2 16-16 16-16-7.2-16-16zm45.4 93.9c-7.6 4.4-17.5 1.8-21.9-5.9-4.4-7.6-1.8-17.5 5.9-21.9 7.6-4.4 17.5-1.8 21.9 5.9 4.4 7.6 1.8 17.5-5.9 21.9zm5.9-165.9c-4.4 7.6-14.2 10.3-21.9 5.9-7.6-4.4-10.3-14.2-5.9-21.9 4.4-7.6 14.2-10.3 21.9-5.9 7.7 4.4 10.3 14.3 5.9 21.9zm36.7-80.4c7.6-4.4 17.5-1.8 21.9 5.9 4.4 7.6 1.8 17.5-5.9 21.9s-17.5 1.8-21.9-5.9c-4.4-7.7-1.7-17.5 5.9-21.9zm-7.8 110.7l15.6-26.6 95.2 56.9V384h-31V260.6l-79.8-46.3zm29.7 188.3c-4.4 7.6-14.2 10.3-21.9 5.9s-10.3-14.2-5.9-21.9c4.4-7.6 14.2-10.3 21.9-5.9 7.6 4.4 10.3 14.2 5.9 21.9zM256 432c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-320c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm88 296.4c-7.6 4.4-17.5 1.8-21.9-5.9-4.4-7.6-1.8-17.5 5.9-21.9 7.6-4.4 17.5-1.8 21.9 5.9 4.4 7.7 1.7 17.5-5.9 21.9zm5.9-283c-4.4 7.6-14.2 10.3-21.9 5.9s-10.3-14.2-5.9-21.9c4.4-7.6 14.2-10.3 21.9-5.9s10.3 14.3 5.9 21.9zM408.4 344c-4.4 7.6-14.2 10.3-21.9 5.9-7.6-4.4-10.3-14.2-5.9-21.9 4.4-7.6 14.2-10.3 21.9-5.9 7.7 4.4 10.3 14.3 5.9 21.9zm7.6-72c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}}]})(props);
	};
	module.exports.IoMdCloseCircleOutline = function IoMdCloseCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422s-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256s17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M360 330.9L330.9 360 256 285.1 181.1 360 152 330.9l74.9-74.9-74.9-74.9 29.1-29.1 74.9 74.9 74.9-74.9 29.1 29.1-74.9 74.9z"}}]})(props);
	};
	module.exports.IoMdCloseCircle = function IoMdCloseCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C140.559 48 48 140.559 48 256c0 115.436 92.559 208 208 208 115.435 0 208-92.564 208-208 0-115.441-92.564-208-208-208zm104.002 282.881l-29.12 29.117L256 285.117l-74.881 74.881-29.121-29.117L226.881 256l-74.883-74.881 29.121-29.116L256 226.881l74.881-74.878 29.12 29.116L285.119 256l74.883 74.881z"}}]})(props);
	};
	module.exports.IoMdClose = function IoMdClose (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"}}]})(props);
	};
	module.exports.IoMdCloudCircle = function IoMdCloudCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm93.6 291.2H172.801c-34.318 0-62.4-28.082-62.4-62.399 0-34.319 28.082-62.4 62.4-62.4h3.117c9.364-36.4 41.601-62.399 80.083-62.399 45.764 0 83.199 37.435 83.199 83.198h10.4c29.118 0 52 22.882 52 52.001 0 29.117-22.882 51.999-52 51.999z"}}]})(props);
	};
	module.exports.IoMdCloudDone = function IoMdCloudDone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.002 217.001C388.998 148.002 328.998 96 256 96c-57.998 0-107.998 32.998-132.998 81.001C63.002 183.002 16 233.998 16 296c0 65.996 53.999 120 120 120h260c55 0 100-45 100-100 0-52.998-40.996-96.001-92.998-98.999zM213.333 362.667L138.667 288l29.864-29.864 44.802 44.802L324.271 192l29.865 29.864-140.803 140.803z"}}]})(props);
	};
	module.exports.IoMdCloudDownload = function IoMdCloudDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.002 217.001C388.998 148.002 328.998 96 256 96c-57.998 0-107.998 32.998-132.998 81.001C63.002 183.002 16 233.998 16 296c0 65.996 53.999 120 120 120h260c55 0 100-45 100-100 0-52.998-40.996-96.001-92.998-98.999zM224 268v-76h64v76h68L256 368 156 268h68z"}}]})(props);
	};
	module.exports.IoMdCloudOutline = function IoMdCloudOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.001 217.001C388.997 148.002 328.998 96 256 96c-57.998 0-107.999 32.998-132.997 81C63.002 183.002 16 233.998 16 296c0 65.996 54.004 120 120 120h260c55 0 100-45 100-100.001 0-52.997-40.997-95.999-92.999-98.998zM396 376H136c-44.004 0-80-35.996-80-80 0-44 35.996-80 80-80h14.004c12.998-46 55-80 105.996-80 60.996 0 110 49 110 110v10h30c32.998 0 60 27.003 60 60 0 32.998-27.002 60-60 60z"}}]})(props);
	};
	module.exports.IoMdCloudUpload = function IoMdCloudUpload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.002 217.001C388.998 148.002 328.998 96 256 96c-57.998 0-107.998 32.998-132.998 81.001C63.002 183.002 16 233.998 16 296c0 65.996 53.999 120 120 120h260c55 0 100-45 100-100 0-52.998-40.996-96.001-92.998-98.999zM288 276v76h-64v-76h-68l100-100 100 100h-68z"}}]})(props);
	};
	module.exports.IoMdCloud = function IoMdCloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.002 217.001C388.998 148.002 328.998 96 256 96c-57.998 0-107.998 32.998-132.998 81.001C63.002 183.002 16 233.998 16 296c0 65.996 53.999 120 120 120h260c55 0 100-45 100-100 0-52.998-40.996-96.001-92.998-98.999z"}}]})(props);
	};
	module.exports.IoMdCloudyNight = function IoMdCloudyNight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M123.4 183c.4-.1.8-.1 1.2-.2-.5.1-.8.2-1.2.2zM341.5 303.4C330.7 247.7 282.2 206 224 206c-34 0-65.1 12-86.5 39.1 29.4 2.2 56.7 13.1 77.7 34.2 15.6 15.7 26.6 34.9 32.1 55.8h-28.7c-13.1-37.6-48-64.5-90.6-64.5-5.1 0-12.3.6-17.7 1.7-45.7 9.4-78.3 47.6-78.3 95 0 53.4 43 96.8 96 96.8h208c44.1 0 80-36.1 80-80.6-.1-42.7-32.9-77.2-74.5-80.1z"}},{"tag":"path","attr":{"d":"M112.5 225.4c13.6-17.3 30.7-30.5 50.8-39.2 18.4-8 38.8-12 60.7-12 6.1 0 12.2.4 18.2 1.1-6.1-18.1-9.4-37.6-9.4-57.8 0-24.6 4.9-48.1 13.8-69.4C161.9 68.7 99 145.7 99 237.3c0 1.6 0 3.2.1 4.8.1 0 .2-.1.3-.1l13.1-16.6zM417.6 306.8c13.3 14.2 22.6 31.5 27.1 50.1 16.5-21.4 28.7-46.4 35.3-73.5-21.2 9-44.5 13.9-68.9 13.9h-3.6c3.5 2.9 6.9 6.1 10.1 9.5z"}}]})(props);
	};
	module.exports.IoMdCloudy = function IoMdCloudy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M123.4 183c.4-.1.8-.1 1.2-.2-.5.1-.8.2-1.2.2z"}},{"tag":"path","attr":{"d":"M393.2 219.2C380.5 154.6 323.9 106 256 106c-39.7 0-76 14-100.9 45.4 34.3 2.6 66.1 15.2 90.7 39.8 18.2 18.2 31 40.5 37.4 64.8h-33.5c-15.3-43.7-56-75-105.7-75-6 0-14.3.7-20.6 2C70 194 32 238.4 32 293.5 32 355.6 82.2 406 144 406h242.7c51.5 0 93.3-42 93.3-93.8 0-49.4-38.3-89.6-86.8-93z"}}]})(props);
	};
	module.exports.IoMdCodeDownload = function IoMdCodeDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M234.6 160v125.7l-44.7-43.6L160 272l96 96 96-96-29.9-31-44.7 44.7V160h-42.8z"}},{"tag":"path","attr":{"d":"M190.4 354.1L91.9 256l98.4-98.1-30-29.9L32 256l128.4 128 30-29.9zm131.2 0L420 256l-98.4-98.1 30-29.9L480 256 351.6 384l-30-29.9z"}}]})(props);
	};
	module.exports.IoMdCodeWorking = function IoMdCodeWorking (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M190.4 354.1L91.9 256l98.4-98.1-30-29.9L32 256l128.4 128 30-29.9zm131.2 0L420 256l-98.4-98.1 30-29.9L480 256 351.6 384l-30-29.9z"}},{"tag":"path","attr":{"d":"M155.6 276h40v-40h-40v40zm200.8-40h-40v40h40v-40zM236 276h40v-40h-40v40z"}}]})(props);
	};
	module.exports.IoMdCode = function IoMdCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M190.4 354.1L91.9 256l98.4-98.1-30-29.9L32 256l128.4 128 30-29.9zm131.2 0L420 256l-98.4-98.1 30-29.9L480 256 351.6 384l-30-29.9z"}}]})(props);
	};
	module.exports.IoMdCog = function IoMdCog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 288v-64h-34.7c-2-12.1-5.2-23.8-9.3-35l30-17.3-32-55.4-30 17.3c-7.7-9.3-16.3-17.9-25.6-25.6l17.3-30-55.4-32L323 76c-11.2-4.2-22.9-7.3-35-9.3V32h-64v34.7c-12.1 2-23.8 5.2-35 9.3l-17.3-30-55.4 32 17.3 30c-9.3 7.7-17.9 16.3-25.6 25.6l-30-17.3-32 55.4L76 189c-4.2 11.2-7.3 22.9-9.3 35H32v64h34.7c2 12.1 5.2 23.8 9.3 35l-30 17.3 32 55.4 30-17.3c7.7 9.3 16.3 17.9 25.6 25.6l-17.3 30 55.4 32 17.3-30c11.2 4.2 22.9 7.3 35 9.3V480h64v-34.7c12.1-2 23.8-5.2 35-9.3l17.3 30 55.4-32-17.3-30c9.3-7.7 17.9-16.3 25.6-25.6l30 17.3 32-55.4-30-17.3c4.2-11.2 7.3-22.9 9.3-35H480zm-224-64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM141.2 343c-18.3-24.2-29.2-54.3-29.2-87 0-6.1.4-12.1 1.1-18l46.9 17.1v.9c0 17.8 4.9 34.5 13.3 48.8L141.2 343zm40.7-148L135 177.9c20.1-31.1 51.8-53.9 89-62.3v49.9c-16.6 5.9-31.1 16.2-42.1 29.5zM256 400c-23.7 0-46-5.7-65.8-15.9l32.1-38.2c10.5 3.9 21.8 6.1 33.7 6.1s23.2-2.2 33.7-6.1l32.1 38.2C302 394.3 279.7 400 256 400zm32-234.5v-49.9c37.2 8.4 68.9 31.2 89 62.3L330.1 195c-11-13.3-25.5-23.6-42.1-29.5zM370.8 343l-32.1-38.2c8.4-14.3 13.3-31 13.3-48.8v-.9l46.9-17.1c.7 5.9 1.1 11.9 1.1 18 0 32.7-10.9 62.8-29.2 87z"}}]})(props);
	};
	module.exports.IoMdColorFill = function IoMdColorFill (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M136.5 77.7l37 67L32 285.7 216.4 464l152.4-148.6 54.4-11.4L166.4 48l-29.9 29.7zm184 208H114.9l102.8-102.3 102.8 102.3zM423.3 304s-56.7 61.5-56.7 92.1c0 30.7 25.4 55.5 56.7 55.5 31.3 0 56.7-24.9 56.7-55.5S423.3 304 423.3 304z"}}]})(props);
	};
	module.exports.IoMdColorFilter = function IoMdColorFilter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M441.8 120.1l-49.9-49.9c-8.3-8.3-21.8-8.3-30.1 0l-66.6 66.6L254.1 96 224 126.1l30.3 30.3L64 346.7V448h101.3l190.3-190.3 30.3 30.3 30.1-30.1-41-41 66.6-66.6c8.5-8.4 8.5-21.8.2-30.2zM147.6 405.4l-41-41 171.9-171.9 41 41-171.9 171.9z"}}]})(props);
	};
	module.exports.IoMdColorPalette = function IoMdColorPalette (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C150.401 64 64 150.401 64 256c0 105.604 86.401 192 192 192 18.136 0 32-13.864 32-32 0-8.531-3.198-16-8.531-21.333-5.333-5.334-8.531-12.803-8.531-21.334 0-18.135 13.864-32 32-32h38.396c58.667 0 106.667-48 106.667-106.666C448 140.802 361.604 64 256 64zM138.667 256c-18.136 0-32-13.864-32-32s13.864-32 32-32c18.135 0 32 13.864 32 32s-13.865 32-32 32zm64-85.333c-18.136 0-32-13.865-32-32 0-18.136 13.864-32 32-32 18.135 0 32 13.864 32 32 0 18.135-13.865 32-32 32zm106.666 0c-18.135 0-32-13.865-32-32 0-18.136 13.865-32 32-32 18.136 0 32 13.864 32 32 0 18.135-13.864 32-32 32zm64 85.333c-18.135 0-32-13.864-32-32s13.865-32 32-32c18.136 0 32 13.864 32 32s-13.864 32-32 32z"}}]})(props);
	};
	module.exports.IoMdColorWand = function IoMdColorWand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M200.8 157.2l-36.4 37.4L411.7 448l36.3-37.4zM181 64h37v68h-37zM181 262h37v68h-37zM270 176h69v37h-69zM305.6 115.8l-25.7-26.3-47.1 48.3 25.6 26.2zM168.8 137.8l-47.1-48.3-25.6 26.3 47.1 48.2zM96.1 277.9l25.6 26.2 47.1-48.2-25.6-26.3zM64 176h65v37H64z"}}]})(props);
	};
	module.exports.IoMdCompass = function IoMdCompass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 231.358c-13.442 0-24.643 11.2-24.643 24.642s11.2 24.643 24.643 24.643 24.643-11.2 24.643-24.643-11.201-24.642-24.643-24.642zM256 32C132.8 32 32 132.8 32 256s100.8 224 224 224 224-100.8 224-224S379.2 32 256 32zm49.284 273.284L121.6 390.4l85.116-183.679L390.4 121.6l-85.116 183.684z"}}]})(props);
	};
	module.exports.IoMdConstruct = function IoMdConstruct (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M430.9 393.4l-119.6-119-58.1-57.9-13.4-13.3c15.9-40.6 7.1-88.2-26.6-121.7-35.4-35.3-88.5-42.3-131-22.9l76.1 75.8-53.1 52.9-77.9-75.8C6.2 153.8 15 206.7 50.4 242c33.6 33.5 81.4 42.3 122.1 26.5l14.4 14.3L81.7 388c-7.6 5.7-7.6 19 1.9 26.6l43.8 43.7c7.6 7.6 19.1 7.6 26.7 0l96.1-112.4 113.4 112.9c7.1 7.1 17.7 7.1 24.8 0l40.7-40.6c8.9-7.1 8.9-19.5 1.8-24.8z"}},{"tag":"path","attr":{"d":"M494.4 216.6l-34.5-34.1c-2.2-2.2-5.8-2.2-8 0l-3.7 3.7-18.5-15.8s1.2-10-4.9-18.7c-6.2-8.7-16.1-19.8-23.2-26.9-7.1-7-34.1-33.9-69.7-51.4C296.2 55.7 271 48 241 48v29.7s28.7 16.6 45.1 29.7c16.3 13.1 16.8 59.5 16.8 59.5l-28.5 28.5 56.5 56.1 31-36.3c12.9-3.5 23.8-3.8 30.2-.3l13.7 13.3-9.6 9.5c-2.2 2.2-2.2 5.7 0 7.9l34.5 34.1c2.2 2.2 5.8 2.2 8 0l55.7-55.2c2.1-2.2 2.1-5.8 0-7.9z"}}]})(props);
	};
	module.exports.IoMdContact = function IoMdContact (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm0 62.4c34.3 0 62.4 28.1 62.4 62.4s-28.1 62.4-62.4 62.4-62.4-28.1-62.4-62.4 28.1-62.4 62.4-62.4zm0 300.4c-52 0-97.8-27-124.8-66.6 1-41.6 83.2-64.5 124.8-64.5s123.8 22.9 124.8 64.5c-27 39.5-72.8 66.6-124.8 66.6z"}}]})(props);
	};
	module.exports.IoMdContacts = function IoMdContacts (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M239.208 343.937c-17.78 10.103-38.342 15.876-60.255 15.876-21.909 0-42.467-5.771-60.246-15.87C71.544 358.331 42.643 406 32 448h293.912c-10.639-42-39.537-89.683-86.704-104.063zM178.953 120.035c-58.479 0-105.886 47.394-105.886 105.858 0 58.464 47.407 105.857 105.886 105.857s105.886-47.394 105.886-105.857c0-58.464-47.408-105.858-105.886-105.858zm0 186.488c-33.671 0-62.445-22.513-73.997-50.523H252.95c-11.554 28.011-40.326 50.523-73.997 50.523z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M322.602 384H480c-10.638-42-39.537-81.691-86.703-96.072-17.781 10.104-38.343 15.873-60.256 15.873-14.823 0-29.024-2.654-42.168-7.49-7.445 12.47-16.927 25.592-27.974 34.906C289.245 341.354 309.146 364 322.602 384zM306.545 200h100.493c-11.554 28-40.327 50.293-73.997 50.293-8.875 0-17.404-1.692-25.375-4.51a128.411 128.411 0 0 1-6.52 25.118c10.066 3.174 20.779 4.862 31.895 4.862 58.479 0 105.886-47.41 105.886-105.872 0-58.465-47.407-105.866-105.886-105.866-37.49 0-70.427 19.703-89.243 49.09C275.607 131.383 298.961 163 306.545 200z"}}]}]})(props);
	};
	module.exports.IoMdContract = function IoMdContract (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 371.2h76.795V448H192V320H64v51.2zm76.795-230.4H64V192h128V64h-51.205v76.8zM320 448h51.2v-76.8H448V320H320v128zm51.2-307.2V64H320v128h128v-51.2h-76.8z"}}]})(props);
	};
	module.exports.IoMdContrast = function IoMdContrast (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm113.1 321.1C338.9 399.4 298.7 416 256 416V96c42.7 0 82.9 16.6 113.1 46.9C399.4 173.1 416 213.3 416 256s-16.6 82.9-46.9 113.1z"}}]})(props);
	};
	module.exports.IoMdCopy = function IoMdCopy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M296 48H176.5C154.4 48 136 65.4 136 87.5V96h-7.5C106.4 96 88 113.4 88 135.5v288c0 22.1 18.4 40.5 40.5 40.5h208c22.1 0 39.5-18.4 39.5-40.5V416h8.5c22.1 0 39.5-18.4 39.5-40.5V176L296 48zm0 44.6l83.4 83.4H296V92.6zm48 330.9c0 4.7-3.4 8.5-7.5 8.5h-208c-4.4 0-8.5-4.1-8.5-8.5v-288c0-4.1 3.8-7.5 8.5-7.5h7.5v255.5c0 22.1 10.4 32.5 32.5 32.5H344v7.5zm48-48c0 4.7-3.4 8.5-7.5 8.5h-208c-4.4 0-8.5-4.1-8.5-8.5v-288c0-4.1 3.8-7.5 8.5-7.5H264v128h128v167.5z"}}]})(props);
	};
	module.exports.IoMdCreate = function IoMdCreate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 368v80h80l235.727-235.729-79.999-79.998L64 368zm377.602-217.602c8.531-8.531 8.531-21.334 0-29.865l-50.135-50.135c-8.531-8.531-21.334-8.531-29.865 0l-39.468 39.469 79.999 79.998 39.469-39.467z"}}]})(props);
	};
	module.exports.IoMdCrop = function IoMdCrop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 312.7h37.8V160c0-20.8-17-37.8-37.8-37.8H199.3V160H352v152.7zm-192 33.5V48h-37.8v74.2H48V160h74.2v186.2c0 20.8 17 37.8 37.8 37.8h192v80h37.8v-80H464v-37.8H160z"}}]})(props);
	};
	module.exports.IoMdCube = function IoMdCube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M467.3 168.1c-1.8 0-3.5.3-5.1 1l-177.6 92.1h-.1c-7.6 4.7-12.5 12.5-12.5 21.4v185.9c0 6.4 5.6 11.5 12.7 11.5 2.2 0 4.3-.5 6.1-1.4.2-.1.4-.2.5-.3L466 385.6l.3-.1c8.2-4.5 13.7-12.7 13.7-22.1V179.6c0-6.4-5.7-11.5-12.7-11.5zM454.3 118.5L272.6 36.8S261.9 32 256 32c-5.9 0-16.5 4.8-16.5 4.8L57.6 118.5s-8 3.3-8 9.5c0 6.6 8.3 11.5 8.3 11.5l185.5 97.8c3.8 1.7 8.1 2.6 12.6 2.6 4.6 0 8.9-1 12.7-2.7l185.4-97.9s7.5-4 7.5-11.5c.1-6.3-7.3-9.3-7.3-9.3zM227.5 261.2L49.8 169c-1.5-.6-3.3-1-5.1-1-7 0-12.7 5.1-12.7 11.5v183.8c0 9.4 5.5 17.6 13.7 22.1l.2.1 174.7 92.7c1.9 1.1 4.2 1.7 6.6 1.7 7 0 12.7-5.2 12.7-11.5V282.6c.1-8.9-4.9-16.8-12.4-21.4z"}}]})(props);
	};
	module.exports.IoMdCut = function IoMdCut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M203.1 158.3c5.2-11.2 8.1-23.5 8.1-36.7 0-49.5-40.1-89.6-89.6-89.6S32 72.1 32 121.6s40.1 89.6 89.6 89.6c13.2 0 25.5-2.9 36.7-8.1l52.9 52.9-52.9 52.9c-11.2-5.2-23.5-8.1-36.7-8.1-49.5 0-89.6 40.1-89.6 89.6S72.1 480 121.6 480s89.6-40.1 89.6-89.6c0-13.2-2.9-25.5-8.1-36.7l52.9-52.9 156.8 156.8H480v-22.4L203.1 158.3zm-81.5 8.1c-24.6 0-44.8-19.9-44.8-44.8S97 76.8 121.6 76.8s44.8 19.9 44.8 44.8-20.2 44.8-44.8 44.8zm0 268.8c-24.6 0-44.8-19.9-44.8-44.8s20.2-44.8 44.8-44.8 44.8 19.9 44.8 44.8-20.2 44.8-44.8 44.8zm134.4-168c-6.3 0-11.2-4.9-11.2-11.2 0-6.3 4.9-11.2 11.2-11.2 6.3 0 11.2 4.9 11.2 11.2 0 6.3-4.9 11.2-11.2 11.2zM412.8 54.4L278.4 188.8l44.8 44.8L480 76.8V54.4h-67.2z"}}]})(props);
	};
	module.exports.IoMdDesktop = function IoMdDesktop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.333 32H74.667C51.198 32 32 51.197 32 74.666v282.667C32 380.802 51.198 400 74.667 400h138.666l-42.666 48v32h170.666v-32l-42.666-48h138.666C460.802 400 480 380.802 480 357.333V74.666C480 51.197 460.802 32 437.333 32zm0 288H74.667V74.666h362.666V320z"}}]})(props);
	};
	module.exports.IoMdDisc = function IoMdDisc (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.2 48 48 141.2 48 256s93.2 208 208 208 208-93.2 208-208S370.8 48 256 48zm0 301.6c-51.8 0-93.6-41.8-93.6-93.6s41.8-93.6 93.6-93.6 93.6 41.8 93.6 93.6-41.8 93.6-93.6 93.6zm0-114.4c-11.4 0-20.8 9.4-20.8 20.8s9.4 20.8 20.8 20.8 20.8-9.4 20.8-20.8-9.4-20.8-20.8-20.8z"}}]})(props);
	};
	module.exports.IoMdDocument = function IoMdDocument (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 48H136c-22.092 0-40 17.908-40 40v336c0 22.092 17.908 40 40 40h240c22.092 0 40-17.908 40-40V176L288 48zm-16 144V80l112 112H272z"}}]})(props);
	};
	module.exports.IoMdDoneAll = function IoMdDoneAll (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M387.581 139.712L356.755 109 216.913 248.319l30.831 30.719 139.837-139.326zM481.172 109L247.744 340.469l-91.39-91.051-30.827 30.715L247.744 403 512 139.712 481.172 109zM0 280.133L123.321 403l30.829-30.713L31.934 249.418 0 280.133z"}}]})(props);
	};
	module.exports.IoMdDownload = function IoMdDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 199.5h-91.4V64H187.4v135.5H96l160 158.1 160-158.1zM96 402.8V448h320v-45.2H96z"}}]})(props);
	};
	module.exports.IoMdEasel = function IoMdEasel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 176h256v128H128z"}},{"tag":"path","attr":{"d":"M448 96H64c-8.8 0-16 7.2-16 16v256c0 8.8 6.9 16 15.8 16H448c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-32 240H96V144h320v192zM80 464h57l22.5-64h-56.4zM279.4 48h-46.8l-11.5 32h69.8zM375 464h57l-23-64h-56.5zM232 400h48v32h-48z"}}]})(props);
	};
	module.exports.IoMdEgg = function IoMdEgg (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C185.6 32 80 165.2 80 288.9S150.4 480 256 480s176-67.4 176-191.1S326.4 32 256 32z"}}]})(props);
	};
	module.exports.IoMdExit = function IoMdExit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M215.469 332.802l29.863 29.864L352 256 245.332 149.333l-29.863 29.865 55.469 55.469H64v42.666h205.864l-54.395 55.469zM405.334 64H106.666C83.198 64 64 83.198 64 106.666V192h42.666v-85.333h298.668v298.668H106.666V320H64v85.334C64 428.802 83.198 448 106.666 448h298.668C428.802 448 448 428.802 448 405.334V106.666C448 83.198 428.802 64 405.334 64z"}}]})(props);
	};
	module.exports.IoMdExpand = function IoMdExpand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396.795 396.8H320V448h128V320h-51.205zM396.8 115.205V192H448V64H320v51.205zM115.205 115.2H192V64H64v128h51.205zM115.2 396.795V320H64v128h128v-51.205z"}}]})(props);
	};
	module.exports.IoMdEyeOff = function IoMdEyeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.1 144.8c56.2 0 101.9 45.3 101.9 101.1 0 13.1-2.6 25.5-7.3 37l59.5 59c30.8-25.5 55-58.4 69.9-96-35.3-88.7-122.3-151.6-224.2-151.6-28.5 0-55.8 5.1-81.1 14.1l44 43.7c11.6-4.6 24.1-7.3 37.3-7.3zM52.4 89.7l46.5 46.1 9.4 9.3c-33.9 26-60.4 60.8-76.3 100.8 35.2 88.7 122.2 151.6 224.1 151.6 31.6 0 61.7-6.1 89.2-17l8.6 8.5 59.7 59 25.9-25.7L78.2 64 52.4 89.7zM165 201.4l31.6 31.3c-1 4.2-1.6 8.7-1.6 13.1 0 33.5 27.3 60.6 61.1 60.6 4.5 0 9-.6 13.2-1.6l31.6 31.3c-13.6 6.7-28.7 10.7-44.8 10.7-56.2 0-101.9-45.3-101.9-101.1 0-15.8 4.1-30.7 10.8-44.3zm87.8-15.7l64.2 63.7.4-3.2c0-33.5-27.3-60.6-61.1-60.6l-3.5.1z"}}]})(props);
	};
	module.exports.IoMdEye = function IoMdEye (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 105c-101.8 0-188.4 62.4-224 151 35.6 88.6 122.2 151 224 151s188.4-62.4 224-151c-35.6-88.6-122.2-151-224-151zm0 251.7c-56 0-101.8-45.3-101.8-100.7S200 155.3 256 155.3 357.8 200.6 357.8 256 312 356.7 256 356.7zm0-161.1c-33.6 0-61.1 27.2-61.1 60.4s27.5 60.4 61.1 60.4 61.1-27.2 61.1-60.4-27.5-60.4-61.1-60.4z"}}]})(props);
	};
	module.exports.IoMdFastforward = function IoMdFastforward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 256L262.4 110v292L480 256zM32 110v292l217.6-146L32 110z"}}]})(props);
	};
	module.exports.IoMdFemale = function IoMdFemale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 176c0-79.5-64.5-144-144-144S112 96.5 112 176c0 71.4 51.9 130.6 120 142v50h-72v48h72v64h48v-64h72v-48h-72v-50c68.1-11.4 120-70.6 120-142zm-240 0c0-52.9 43.1-96 96-96s96 43.1 96 96-43.1 96-96 96-96-43.1-96-96z"}}]})(props);
	};
	module.exports.IoMdFiling = function IoMdFiling (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M449.2 208H423v-32l-14.4-48H383V96l-15-48H144l-15 48v32h-25.6L89 176v32H62.8L48 256v165.3c0 23.5 35.2 42.7 58.7 42.7h314.7c21.8 0 42.7-19.7 42.7-41V256l-14.9-48zM176 96h160v32H176V96zm-41 80h242v32H135v-32zm282 112h-82.6c-7.4 36.5-39.7 64-78.4 64s-71-27.5-78.4-64H95v-32h322v32z"}}]})(props);
	};
	module.exports.IoMdFilm = function IoMdFilm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 64v42.667h-40V64H176v42.667h-40V64H96v384h40v-42.666h40V448h160v-42.666h40V448h40V64h-40zM176 362.667h-40V320h40v42.667zm0-85.333h-40v-42.667h40v42.667zM176 192h-40v-42.666h40V192zm200 170.667h-40V320h40v42.667zm0-85.333h-40v-42.667h40v42.667zM376 192h-40v-42.666h40V192z"}}]})(props);
	};
	module.exports.IoMdFingerPrint = function IoMdFingerPrint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M78.1 205.6c-2.4 0-4.9-.6-7.1-1.9-6.7-3.9-9-12.4-5.1-19.1 17.8-30 71.9-100.1 190.1-100.1 51.2 0 96.1 13.6 133.4 40.4 30.7 22 47.9 46.9 56.1 58.9 4.4 6.4 2.7 15-3.7 19.4-6.4 4.3-15.2 2.7-19.6-3.7-14.9-21.6-60.1-87.2-166.2-87.2-103.6 0-150.4 60.4-165.7 86.3-2.6 4.6-7.3 7-12.2 7z"}},{"tag":"path","attr":{"d":"M315.5 480c-1.2 0-2.3-.1-3.5-.4-85.7-21.5-117.7-108.1-119-111.7l-.2-.8c-.7-2.5-17.9-61.9 8.5-96.7 12.1-15.9 30.5-24 54.8-24 22.6 0 38.9 7.1 50.1 21.8 9.2 12 12.9 26.8 16.5 41.1 7.5 29.7 12.9 45.3 44.1 46.9 13.7.7 22.7-7.4 27.8-14.3 13.8-18.8 16.2-49.5 5.8-76.5-13.4-35-60.8-100.9-144.4-100.9-35.7 0-68.5 11.6-94.8 33.4-21.8 18.1-39.1 43.6-47.4 69.8-15.4 48.8 4.8 125.5 5 126.2 2 7.4-2.5 15.1-10 17-7.5 2-15.3-2.5-17.3-9.9-.9-3.5-22.5-85.3-4.7-141.7C106.2 198.2 166 136.6 256 136.6c41.6 0 80.9 14.3 113.7 41.3 25.4 21 46.2 49.2 57 77.4 13.8 36 10.1 76.4-9.4 102.8-13 17.6-31.5 26.8-52 25.8-53.4-2.7-63-40.4-70-67.9-7.2-28.2-11.8-41.8-39.3-41.8-15.1 0-25.7 4.2-32.3 12.9-9 11.9-9.7 30.5-8.7 44 1 14.1 4 25.5 4.7 27.8 2.2 5.6 30.8 76.5 99.3 93.7 7.6 1.9 12.1 9.5 10.2 16.9-1.7 6.3-7.4 10.5-13.7 10.5z"}},{"tag":"path","attr":{"d":"M205.5 473.6c-3.8 0-7.5-1.5-10.3-4.4-34.3-36.4-53.7-77.1-61-128v-.3c-4.1-33.7 1.9-81.4 31.3-114.2 21.7-24.2 52.2-36.5 90.5-36.5 45.3 0 80.9 21.3 103.1 61.5 16.1 29.2 19.3 58.3 19.4 59.5.8 7.7-4.9 14.5-12.6 15.3-7.7.8-14.7-4.8-15.5-12.4 0-.3-2.8-25.3-16.5-49.7-17.2-30.7-43.4-46.3-78-46.3-29.9 0-53.3 9.1-69.4 27.1-23.2 25.9-27.7 65.8-24.5 92.2 6.4 45 23.5 80.8 53.7 112.8 5.3 5.6 5 14.5-.7 19.7-2.6 2.4-6.1 3.7-9.5 3.7z"}},{"tag":"path","attr":{"d":"M363.5 433.5c-30 0-55.5-8.4-75.9-25.1-41-33.4-45.6-87.8-45.8-90.1-.6-7.7 5.2-14.4 13-15 7.8-.6 14.5 5.1 15.1 12.8.1.8 4.2 45.3 35.8 70.9 18.7 15.1 43.7 21.1 74.5 17.6 7.7-.9 14.7 4.6 15.6 12.3.9 7.7-4.7 14.6-12.4 15.4-6.8.8-13.5 1.2-19.9 1.2zM387.2 62.6C375.5 54.9 334 32 256 32c-81.9 0-123.5 25.3-132.7 31.7-.6.4-1.2.8-1.7 1.3-.1.1-.2.1-.2.1-2.9 2.6-4.7 6.3-4.7 10.4 0 7.7 6.3 13.9 14.1 13.9 3.1 0 5.9-1 8.2-2.6l-.1.1c.4-.3 36.3-27 117.1-27s116.7 26.8 117.1 27l-.1-.1.2-.2c2.4 1.8 5.3 2.8 8.5 2.8 7.8 0 14.1-6.2 14.1-13.9 0-5.8-3.5-10.8-8.6-12.9z"}}]})(props);
	};
	module.exports.IoMdFitness = function IoMdFitness (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434.3 315.5l29.7-29.7-29.7-29.8-74.3 74.3L181.7 152 256 77.7 226.3 48l-29.7 29.7L166.8 48l-44.5 44.5-29.8-29.7-29.7 29.7 29.7 29.7L48 166.8l29.7 29.7L48 226.3 77.7 256l74.3-74.3L330.3 360 256 434.3l29.7 29.7 29.7-29.7 29.7 29.7 44.5-44.5 29.7 29.7 29.7-29.7-29.7-29.7 44.5-44.5-29.5-29.8z"}}]})(props);
	};
	module.exports.IoMdFlag = function IoMdFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396 83.2c-13.8 1.7-31.1 4.2-49.6 4.2-28.8 0-55-6.8-81.5-12.2C238 69.7 210.2 64 180.8 64c-58.6 0-78.5 12.1-80.6 13.4L96 80.3V448h48V269.8c9.7-1.2 21.9-2 36.9-2 27.3 0 52.8 10 79.8 15.5 27.6 5.6 56 11.5 86.9 11.5 18.4 0 34.6-2.4 48.4-4 7.5-.9 14-1.7 20-2.7V80.2c-5 1-12.5 2.1-20 3z"}}]})(props);
	};
	module.exports.IoMdFlame = function IoMdFlame (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M393.3 222.1l-.2 10.4c-.8 11.7-7.9 43.4-22.1 54.7 7-15.2 17.3-47.2 10.2-82.7C361.6 107 287.5 65.6 193 50l-17.2-2.2c39.5 47.2 56.1 81.7 49.7 116.8-2.3 12.6-10 23.4-14 31.6 0 0 2.4-12.9 2-28.7-.3-14.2-6.6-31-18-39.6 3.5 18.4-.8 33.5-9.1 47.7-24.7 42.2-85.4 57.8-90.4 135.8v3.8c0 53.7 25.6 99 68.7 125-6.8-12.3-12-35.2-5.7-60.2 4 23.7 14 36 24.9 51.8 8.2 11.7 19.1 19.3 33.1 24.9s31 7.2 47.9 7.2c55.8 0 91.4-18.1 119.1-50.5s32.1-68 32.1-106.4-8.5-60.9-22.8-84.9z"}}]})(props);
	};
	module.exports.IoMdFlashOff = function IoMdFlashOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.9 435.5L76.1 52.5 51.9 76.6 160 184.3V272h64v192l72-144 139.9 139.5zM352 208h-64l64-160H160v40.3l168 167.6z"}}]})(props);
	};
	module.exports.IoMdFlash = function IoMdFlash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 48v224h64v192l128-256h-64l64-160H160z"}}]})(props);
	};
	module.exports.IoMdFlashlight = function IoMdFlashlight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 298l64 64v118h128V362l64-64V176l-255.2.4L128 298zM234.8 32h42.4v64h-42.4V32zM80 110.4L109.9 80l44.9 45.6-29.9 30.4L80 110.4zm277.1 15.2l45-45.5 29.9 30.4-44.9 45.5-30-30.4z"}}]})(props);
	};
	module.exports.IoMdFlask = function IoMdFlask (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M436.9 354.4L336 192V96h32V48H144v48h32v96L76.1 354.4C67.7 370.3 63.6 385.8 64 400c1.1 36.5 28.7 64 65.1 64H385c36.3 0 62.1-27.6 63-64 .3-14.2-2.6-29.7-11.1-45.6zM155.1 304l29.5-48h143.1l29.8 48H155.1z"}}]})(props);
	};
	module.exports.IoMdFlower = function IoMdFlower (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.1 256c25.2-11.9 42.9-37.1 42.9-66.9 0-41-33.6-74.3-75-74.3-15.9 0-30.3 4.8-42.6 13.1l.6-5.6c0-41-33.6-74.3-75-74.3s-75 33.3-75 74.3l.6 5.6c-12-8.3-26.7-13.1-42.6-13.1-41.4 0-75 33.3-75 74.3 0 29.7 17.7 55 42.9 66.9C81.7 267.9 64 293.1 64 322.9c0 41 33.6 74.3 75 74.3 15.9 0 30.3-4.8 42.6-13.1l-.6 5.6c0 41 33.6 74.3 75 74.3s75-33.3 75-74.3l-.6-5.6c12 8.3 26.7 13.1 42.6 13.1 41.4 0 75-33.3 75-74.3 0-29.8-17.7-55-42.9-66.9zM256 330.3c-41.4 0-75-33.3-75-74.3s33.6-74.3 75-74.3 75 33.3 75 74.3-33.6 74.3-75 74.3z"}}]})(props);
	};
	module.exports.IoMdFolderOpen = function IoMdFolderOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.334 144H256.006l-42.668-48H74.666C51.197 96 32 115.198 32 138.667v234.666C32 396.802 51.197 416 74.666 416h362.668C460.803 416 480 396.802 480 373.333V186.667C480 163.198 460.803 144 437.334 144zM448 373.333c0 5.782-4.885 10.667-10.666 10.667H74.666C68.884 384 64 379.115 64 373.333V176h373.334c5.781 0 10.666 4.885 10.666 10.667v186.666z"}}]})(props);
	};
	module.exports.IoMdFolder = function IoMdFolder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M213.338 96H74.666C51.197 96 32 115.198 32 138.667v234.666C32 396.802 51.197 416 74.666 416h362.668C460.803 416 480 396.802 480 373.333V186.667C480 163.198 460.803 144 437.334 144H256.006l-42.668-48z"}}]})(props);
	};
	module.exports.IoMdFootball = function IoMdFootball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.3 48 48 141.3 48 256s93.3 208 208 208 208-93.3 208-208S370.7 48 256 48zM127 238.2l39.2 17.9 17.1 66.9-15.6 29.3-57.2-.7C95.6 329 86.2 303.1 83 276.3l44-38.1zm217.3 114.1L328.7 323l17.1-67 39.1-17.8 44 38.1c-3.1 26.8-12.6 52.7-27.5 75.3l-57.1.7zm32.4-146.2l-43.6 19.6-61.1-51.6v-47.2l47.9-32.6c29.8 11.9 56.4 32.3 75.6 57.8l-18.8 54zM191.3 94.4l47.7 32.5v47.2l-61 51.5-43-19.6-18.7-53.6c19.3-26.1 45.1-46 75-58zM218.4 426c-.7-.2-1.3-.3-2-.5l-20.5-55.1 14.7-29.4h90.8l15 30.3-19.8 53.9c-1 .2-2 .5-3 .7-11.5 2.3-27 3.8-40.4 4.1-11.7-.1-23.4-1.5-34.8-4z"}}]})(props);
	};
	module.exports.IoMdFunnel = function IoMdFunnel (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 400h96v-47.994h-96V400zM32 112v47.994h448V112H32zm80 168.783h288v-49.555H112v49.555z"}}]})(props);
	};
	module.exports.IoMdGift = function IoMdGift (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M424 134.5h-45.8c2.3-6.6 3.8-13.9 3.8-21.3 0-35.4-28.1-63.2-63-63.2-22.1 0-41.2 10.7-52.5 28L256 92.3l-10.5-14.5C234.2 60.7 215.1 48 193 48c-34.9 0-63 29.8-63 65.2 0 7.5 1.5 14.7 3.8 21.3H88c-23.3 0-41.8 19-41.8 42.7L46 421.8c0 23.7 17.4 42.2 40.7 42.2h336.7c23.3 0 42.7-18.5 42.7-42.2V177.2c-.1-23.7-18.8-42.7-42.1-42.7zM320 91c11.6 0 21 9.5 21 21 0 11.6-9.4 21-21 21s-21-9.5-21-21 9.4-21 21-21zm-128 0c11.6 0 21 9.5 21 21 0 11.6-9.4 21-21 21s-21-9.5-21-21 9.4-21 21-21zM88 177.2h106.7L151 237.5l34 25 50-69.1.2-.2-.2 228.6H88V177.2zm336 244.6H277V193.4l50 69.1 34-25-43.7-60.4H424v244.7z"}}]})(props);
	};
	module.exports.IoMdGitBranch = function IoMdGitBranch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 160c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 23.7 12.9 44.3 32 55.4v8.6c0 19.9-7.8 33.7-25.3 44.9-15.4 9.8-38.1 17.1-67.5 21.5-14 2.1-25.7 6-35.2 10.7V151.4c19.1-11.1 32-31.7 32-55.4 0-35.3-28.7-64-64-64S96 60.7 96 96c0 23.7 12.9 44.3 32 55.4v209.2c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-16.6-6.3-31.7-16.7-43.1 1.9-4.9 9.7-16.3 29.4-19.3 38.8-5.8 68.9-15.9 92.3-30.8 36-22.8 55-57 55-98.8v-8.6c19.1-11.1 32-31.7 32-55.4zM160 56c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 400c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm192-256c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"}}]})(props);
	};
	module.exports.IoMdGitCommit = function IoMdGitCommit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 224h-99.8c-14.2-55.2-64.2-96-123.7-96S147 168.8 132.8 224H32v64h100.8c14.2 55.2 64.2 96 123.7 96s109.5-40.8 123.7-96H480v-64zM256.5 336c-44 0-79.8-35.9-79.8-80s35.8-80 79.8-80 79.8 35.9 79.8 80-35.8 80-79.8 80z"}}]})(props);
	};
	module.exports.IoMdGitCompare = function IoMdGitCompare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 382h-22c-24.6 0-29-3.6-33.8-9.6-5.5-6.9-8.2-19.1-8.2-54.2V151.4c19.1-11.1 32-31.7 32-55.4 0-35.3-28.7-64-64-64S32 60.7 32 96c0 23.7 12.9 44.3 32 55.4v166.8c0 46.4 3.7 70.8 22.1 94 19.9 25.1 45 35.8 83.9 35.8h22v64l96-96-96-96v62zM96 56c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM448 360.6V190.8c0-46.4-3.7-70.8-22.1-94C406 71.7 380.9 62 342 62h-22V0l-96 96 96 96v-64h22c24.6 0 29 2.6 33.8 8.6 5.5 6.9 8.2 19.1 8.2 54.2v169.8c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.3-32-55.4zM416 456c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"}}]})(props);
	};
	module.exports.IoMdGitMerge = function IoMdGitMerge (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 224c-23.7 0-44.4 12.9-55.4 32-18.3-.5-52.4-4.1-75.5-18.1-32.3-19.4-64.6-53.1-87-90.5 15.7-11.7 26-30.3 26-51.4 0-35.3-28.7-64-64-64S64 60.7 64 96c0 23.7 12.9 44.3 32 55.4v209.2c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.3-32-55.4V244.2c18.7 19.4 39.1 36 60 48.6 38.8 23.4 87 26.9 108.6 27.3 11.1 19.1 31.7 31.9 55.4 31.9 35.3 0 64-28.7 64-64s-28.7-64-64-64zM88 96c0-22.1 17.9-40 40-40s40 17.9 40 40-17.9 40-40 40-40-17.9-40-40zm80 320c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40zm216-88c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"}}]})(props);
	};
	module.exports.IoMdGitNetwork = function IoMdGitNetwork (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 96c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 23.6 12.9 44.3 32 55.4v52.8l-96 48-96-48v-52.8c19.1-11.1 32-31.8 32-55.4 0-35.3-28.7-64-64-64S64 60.7 64 96c0 23.6 12.9 44.3 32 55.4v92.4l128 64v52.8c-19.1 11.1-32 31.8-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.6-12.9-44.3-32-55.4v-52.8l128-64v-92.4c19.1-11.1 32-31.8 32-55.4zM128 56c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm128 400c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm128-320c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"}}]})(props);
	};
	module.exports.IoMdGitPullRequest = function IoMdGitPullRequest (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 376.6V206.8c0-46.4-3.7-70.8-22.1-94C374 87.7 348.9 77 310 77h-22V16l-96 96 96 96v-65h22c24.6 0 29 3.6 33.8 9.6 5.5 6.9 8.2 19.1 8.2 54.2v169.8c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.3-32-55.4zM384 472c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM128 48c-35.3 0-64 28.7-64 64 0 23.7 12.9 44.3 32 55.4v209.2c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.3-32-55.4V167.4c19.1-11.1 32-31.7 32-55.4 0-35.3-28.7-64-64-64zm0 424c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-320c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"}}]})(props);
	};
	module.exports.IoMdGlasses = function IoMdGlasses (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 176H272v.1h-32v-.1H32v48h11l5 21.5C64 313 88.5 336 144 336s96-17.4 96-90.5V224s1.5-16 16-16 16 16 16 16v21.8c0 73 42.1 90.2 97 90.2s79-25 95-90.2l5-21.8h11v-48z"}}]})(props);
	};
	module.exports.IoMdGlobe = function IoMdGlobe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.124 48 48 141.125 48 256s93.124 208 208 208c114.875 0 208-93.125 208-208S370.875 48 256 48zm-21.549 384.999c-39.464-4.726-75.978-22.392-104.519-50.932C96.258 348.393 77.714 303.622 77.714 256c0-42.87 15.036-83.424 42.601-115.659.71 8.517 2.463 17.648 2.014 24.175-1.64 23.795-3.988 38.687 9.94 58.762 5.426 7.819 6.759 19.028 9.4 28.078 2.583 8.854 12.902 13.498 20.019 18.953 14.359 11.009 28.096 23.805 43.322 33.494 10.049 6.395 16.326 9.576 13.383 21.839-2.367 9.862-3.028 15.937-8.13 24.723-1.557 2.681 5.877 19.918 8.351 22.392 7.498 7.497 14.938 14.375 23.111 21.125 12.671 10.469-1.231 24.072-7.274 39.117zm147.616-50.932c-25.633 25.633-57.699 42.486-92.556 49.081 4.94-12.216 13.736-23.07 21.895-29.362 7.097-5.476 15.986-16.009 19.693-24.352 3.704-8.332 8.611-15.555 13.577-23.217 7.065-10.899-17.419-27.336-25.353-30.781-17.854-7.751-31.294-18.21-47.161-29.375-11.305-7.954-34.257 4.154-47.02-1.417-17.481-7.633-31.883-20.896-47.078-32.339-15.68-11.809-14.922-25.576-14.922-42.997 12.282.453 29.754-3.399 37.908 6.478 2.573 3.117 11.42 17.042 17.342 12.094 4.838-4.043-3.585-20.249-5.212-24.059-5.005-11.715 11.404-16.284 19.803-24.228 10.96-10.364 34.47-26.618 32.612-34.047s-23.524-28.477-36.249-25.193c-1.907.492-18.697 18.097-21.941 20.859.086-5.746.172-11.491.26-17.237.055-3.628-6.768-7.352-6.451-9.692.8-5.914 17.262-16.647 21.357-21.357-2.869-1.793-12.659-10.202-15.622-8.968-7.174 2.99-15.276 5.05-22.45 8.039 0-2.488-.302-4.825-.662-7.133a176.585 176.585 0 0 1 45.31-13.152l14.084 5.66 9.944 11.801 9.924 10.233 8.675 2.795 13.779-12.995L282 87.929V79.59c27.25 3.958 52.984 14.124 75.522 29.8-4.032.361-8.463.954-13.462 1.59-2.065-1.22-4.714-1.774-6.965-2.623 6.531 14.042 13.343 27.89 20.264 41.746 7.393 14.801 23.793 30.677 26.673 46.301 3.394 18.416 1.039 35.144 2.896 56.811 1.788 20.865 23.524 44.572 23.524 44.572s10.037 3.419 18.384 2.228c-7.781 30.783-23.733 59.014-46.769 82.052z"}}]})(props);
	};
	module.exports.IoMdGrid = function IoMdGrid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M409.6 64H102.4C81.3 64 64 81.3 64 102.4v307.2c0 21.1 17.3 38.4 38.4 38.4h307.2c21.1 0 38.4-17.3 38.4-38.4V102.4c0-21.1-17.3-38.4-38.4-38.4zM179.2 409.6h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm115.2 230.4h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm115.2 230.4h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8z"}}]})(props);
	};
	module.exports.IoMdHammer = function IoMdHammer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M474.1 398.2L229.8 167.8s8.8-57.7 26.2-71.8c17.5-14.2 48-32 48-32V32c-32 0-58.8 8.3-96.9 27.3-38 18.9-66.8 47.8-74.4 55.4-7.6 7.6-18.1 19.5-24.7 28.9s-5.3 20.1-5.3 20.1l-19.7 17-4-4c-2.3-2.3-6.2-2.3-8.5 0l-36.8 36.8c-2.3 2.3-2.3 6.2 0 8.5l59.4 59.4c2.3 2.3 6.2 2.3 8.5 0l36.8-36.8c2.3-2.3 2.3-6.2 0-8.5l-10.3-10.3 14.6-14.3c6.8-3.7 25.4-8.9 39.1-5.1l214.9 267.3c8.1 8.2 20.3 8.2 28.5 0l46.8-47.1c10.3-8 10.3-22.3 2.1-28.4z"}}]})(props);
	};
	module.exports.IoMdHand = function IoMdHand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M450.679 273.5c-14.585-14.577-36.054-15.89-50.639-1.312l-41.687 41.664c-10.852 10.836-23.93 10.859-31.564 1.852-5.057-5.968-3.061-24.374-1.644-36.049l20.907-171.849c1.867-15.353-9.07-30.185-24.43-32.051-15.358-1.867-29.322 9.939-31.191 25.289L267.37 236.021c-1.205 3.358-3.79 3.938-4.081-.582L255.44 60c0-15.465-12.542-28-28.014-28-15.473 0-28.015 12.535-28.015 28l-.552 176.752c.146 2.04-1.604 2.624-1.92.294L172.016 99.077c-2.75-15.219-17.323-26.203-32.548-23.453-15.227 2.748-25.339 18.187-22.591 33.403l22.193 161.455c.023 2.872-.941 4.513-2.308.831l-33.109-88.517c-5.18-14.572-21.196-23.065-35.776-17.889-14.579 5.177-22.201 22.061-17.023 36.631l58.042 189.625c.303 1.046.624 2.085.953 3.118l.121.39c.011.031.025.058.035.088C126.079 444.233 172.57 480 227.427 480c35.116 0 71.591-12.378 99.357-33.672l.003-.002c29.99-18.051 126.071-121.347 126.071-121.347 14.587-14.577 12.408-36.899-2.179-51.479z"}}]})(props);
	};
	module.exports.IoMdHappy = function IoMdHappy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C140.563 48 48 141.6 48 256s92.563 208 208 208 208-93.6 208-208S370.401 48 256 48zm0 374.4c-91.518 0-166.404-74.883-166.404-166.4 0-91.518 74.887-166.4 166.404-166.4S422.404 164.482 422.404 256 347.518 422.4 256 422.4zm72.8-187.2c17.683 0 31.201-13.518 31.201-31.2s-13.519-31.2-31.201-31.2c-17.682 0-31.2 13.518-31.2 31.2s13.518 31.2 31.2 31.2zm-145.6 0c17.682 0 31.2-13.518 31.2-31.2s-13.519-31.2-31.2-31.2c-17.683 0-31.201 13.518-31.201 31.2s13.519 31.2 31.201 31.2zM256 370.4c48.883 0 89.436-30.164 106.081-72.801H149.919C166.564 340.236 207.117 370.4 256 370.4z"}}]})(props);
	};
	module.exports.IoMdHeadset = function IoMdHeadset (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C150 48 64 136.2 64 245.1v153.3c0 36.3 28.6 65.7 64 65.7h64V288h-85.3v-42.9c0-84.7 66.8-153.3 149.3-153.3s149.3 68.5 149.3 153.3V288H320v176h64c35.4 0 64-29.3 64-65.7V245.1C448 136.2 362 48 256 48z"}}]})(props);
	};
	module.exports.IoMdHeartDislike = function IoMdHeartDislike (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M51.9 76.6l25 25c-18.1 20.3-29 47.3-29 77.6 0 79.5 70.7 143.3 177.8 241.7L256 448l30.2-27.2c20.6-18.9 39.9-36.6 57.5-53.3l92.2 92 24-24-383.8-383-24.2 24.1zM464 179.1C464 114.2 414.1 64 349.6 64c-36.4 0-70.7 16.7-93.6 43.9C233.1 80.7 198.8 64 162.4 64c-8.4 0-16.5.9-24.3 2.5l253.7 253.1C437.3 270.9 464 228 464 179.1z"}}]})(props);
	};
	module.exports.IoMdHeartEmpty = function IoMdHeartEmpty (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M349.6 64c-36.4 0-70.7 16.7-93.6 43.9C233.1 80.7 198.8 64 162.4 64 97.9 64 48 114.2 48 179.1c0 79.5 70.7 143.3 177.8 241.7L256 448l30.2-27.2C393.3 322.4 464 258.6 464 179.1 464 114.2 414.1 64 349.6 64zm-80.8 329.3l-4.2 3.9-8.6 7.8-8.6-7.8-4.2-3.9c-50.4-46.3-94-86.3-122.7-122-28-34.7-40.4-63.1-40.4-92.2 0-22.9 8.4-43.9 23.7-59.3 15.2-15.4 36-23.8 58.6-23.8 26.1 0 52 12.2 69.1 32.5l24.5 29.1 24.5-29.1c17.1-20.4 43-32.5 69.1-32.5 22.6 0 43.4 8.4 58.7 23.8 15.3 15.4 23.7 36.5 23.7 59.3 0 29-12.5 57.5-40.4 92.2-28.8 35.7-72.3 75.7-122.8 122z"}}]})(props);
	};
	module.exports.IoMdHeartHalf = function IoMdHeartHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M349.6 64c-36.4 0-70.7 16.7-93.6 43.9C233.1 80.7 198.8 64 162.4 64 97.9 64 48 114.2 48 179.1c0 79.5 70.7 143.3 177.8 241.7L256 448l30.2-27.2C393.3 322.4 464 258.6 464 179.1 464 114.2 414.1 64 349.6 64zM256 406V157.7l24.5-29.1c17.1-20.4 43-32.5 69.1-32.5 22.6 0 43.4 8.4 58.7 23.8 15.3 15.4 23.7 36.5 23.7 59.3 0 29-12.5 57.5-40.4 92.2C362.8 307 306.4 359.7 256 406z"}}]})(props);
	};
	module.exports.IoMdHeart = function IoMdHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 448l-30.164-27.211C118.718 322.442 48 258.61 48 179.095 48 114.221 97.918 64 162.4 64c36.399 0 70.717 16.742 93.6 43.947C278.882 80.742 313.199 64 349.6 64 414.082 64 464 114.221 464 179.095c0 79.516-70.719 143.348-177.836 241.694L256 448z"}}]})(props);
	};
	module.exports.IoMdHelpBuoy = function IoMdHelpBuoy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm61 356l-12.2-39.6c13-5.8 24.9-14 35.3-24.4 10.4-10.4 18.6-22.3 24.4-35.3l39.5 12.1c-7.9 19.3-19.7 37-34.9 52.2-15.1 15.3-32.8 27.1-52.1 35zM195 108l12.2 39.6c-13 5.8-24.9 14-35.3 24.4-10.4 10.4-18.6 22.3-24.4 35.3L108 195.2c7.9-19.3 19.7-37 34.9-52.2 15.1-15.3 32.8-27.1 52.1-35zm61 84c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm113.1-49.1c15.2 15.2 26.9 32.9 34.9 52.1l-39.5 12.2c-5.9-13-14-24.9-24.4-35.3-10.4-10.4-22.3-18.6-35.3-24.4l12.1-39.5c19.3 7.9 37 19.7 52.2 34.9zM142.9 369.1c-15.2-15.1-27-32.8-34.9-52.1l39.5-12.2c5.9 13 14 24.9 24.4 35.3 10.4 10.4 22.3 18.6 35.3 24.4L195.1 404c-19.3-7.9-37-19.7-52.2-34.9z"}}]})(props);
	};
	module.exports.IoMdHelpCircleOutline = function IoMdHelpCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422s-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256s17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M235 339h42v42h-42zM276.8 318h-41.6c0-67 62.4-62.2 62.4-103.8 0-22.9-18.7-41.7-41.6-41.7S214.4 192 214.4 214h-41.6c0-46 37.2-83 83.2-83s83.2 37.1 83.2 83.1c0 52-62.4 57.9-62.4 103.9z"}}]})(props);
	};
	module.exports.IoMdHelpCircle = function IoMdHelpCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.2 48 48 141.2 48 256s93.2 208 208 208 208-93.2 208-208S370.8 48 256 48zm21 333h-42v-42h42v42zm-.2-63h-41.6c0-67 62.4-62.2 62.4-103.8 0-22.9-18.7-41.7-41.6-41.7S214.4 192 214.4 214h-41.6c0-46 37.2-83 83.2-83s83.2 37.1 83.2 83.1c0 52-62.4 57.9-62.4 103.9z"}}]})(props);
	};
	module.exports.IoMdHelp = function IoMdHelp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M289 448h-66v-65h66v65zm-1-98h-64c0-101 96-95.1 96-159 0-35.2-28.8-63.4-64-63.4S192 158 192 192h-64c0-71 57.3-128 128-128s128 56.4 128 127c0 79.9-96 89-96 159z"}}]})(props);
	};
	module.exports.IoMdHome = function IoMdHome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 448V320h96v128h97.6V256H464L256 64 48 256h62.4v192z"}}]})(props);
	};
	module.exports.IoMdHourglass = function IoMdHourglass (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 48v122.8h.2l-.2.2 85.3 85-85.3 85.2.2.2h-.2V464h256V341.4h-.2l.2-.2-85.3-85.2 85.3-85-.2-.2h.2V48H128zm213.3 303.9v71.5H170.7v-71.5l85.3-85.2 85.3 85.2zM256 245.4l-85.3-85.2V87.6h170.7v72.5L256 245.4z"}}]})(props);
	};
	module.exports.IoMdIceCream = function IoMdIceCream (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128.1 256l128 224 128-224zM392 161c3-9 4.7-22.7 4.7-32.9 0-53.1-43-96.1-96.1-96.1-31.4 0-59.2 15-76.8 38.3 0 0-9.1 14-10.8 29l-3.4-1c-2.3-9-3.7-20 1.6-31.5-7.4-2.5-9.4-2.8-17.6-2.8-41.7 0-75.6 33.8-75.6 75.6 0 6.3.8 15.5 2.3 21.4-13.9 3.5-24.3 16.1-24.3 31 0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32 0-14.8-10.2-27.4-24-31z"}}]})(props);
	};
	module.exports.IoMdImage = function IoMdImage (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 405.333V106.667C448 83.198 428.802 64 405.333 64H106.667C83.198 64 64 83.198 64 106.667v298.666C64 428.802 83.198 448 106.667 448h298.666C428.802 448 448 428.802 448 405.333zM181.333 288l53.334 64 74.666-96 96 128H106.667l74.666-96z"}}]})(props);
	};
	module.exports.IoMdImages = function IoMdImages (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M457.6 140.2l-82.5-4-4.8-53.8c-1-11.3-11.1-19.2-22.9-18.3L51.5 88.4c-11.8 1-20.3 10.5-19.4 21.7l21.2 235.8c1 11.3 11.2 19.2 22.9 18.3l15-1.2-2.4 45.8c-.6 12.6 9.2 22.8 22.4 23.5L441.3 448c13.2.6 24.1-8.6 24.8-21.2L480 163.5c.6-12.5-9.3-22.7-22.4-23.3zm-354.9 5.3l-7.1 134.8L78.1 305 62 127v-.5-.5c1-5 4.4-9 9.6-9.4l261-21.4c5.2-.4 9.7 3 10.5 7.9 0 .2.3.2.3.4 0 .1.3.2.3.4l2.7 30.8-219-10.5c-13.2-.4-24.1 8.8-24.7 21.3zm334 236.9l-84.8-99.5-37.4 34.3-69.2-80.8-122.7 130.7L133 168v-.4c1-5.4 6.2-9.3 11.9-9l291.2 14c5.8.3 10.3 4.7 10.4 10.2 0 .2.3.3.3.5l-10.1 199.1z"}},{"tag":"path","attr":{"d":"M384 256c17.6 0 32-14.4 32-32s-14.3-32-32-32c-17.6 0-32 14.3-32 32s14.3 32 32 32z"}}]})(props);
	};
	module.exports.IoMdInfinite = function IoMdInfinite (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434.7 188c-18.8-18-43.8-28-70.5-28-26.6 0-51.6 9.9-70.4 27.9l-17.6 15.9 33.1 32.1 17-15.4.1-.1c10.1-9.6 23.5-15 37.7-15 14.2 0 27.6 5.3 37.7 14.9 10 9.6 15.4 22.3 15.4 35.8 0 13.5-5.5 26.1-15.4 35.6-10.1 9.6-23.5 15-37.7 15s-27.6-5.3-37.7-14.9L218.2 188c-18.9-18-43.9-28-70.4-28-26.7 0-51.7 9.9-70.5 28C58.4 206.1 48 230.2 48 256c0 25.7 10.4 49.9 29.3 68 18.8 18 43.8 28 70.5 28 26.7 0 51.7-9.9 70.4-28l37.8-36.1 37.7 36.1c18.9 18 43.9 28 70.4 28 26.7 0 51.7-9.9 70.4-27.9 19-18.1 29.4-42.2 29.4-68 .1-25.8-10.3-50-29.2-68.1zM185.5 291.7c-10.1 9.6-23.5 15-37.7 15-14.2 0-27.6-5.3-37.7-14.9-10-9.6-15.4-22.3-15.4-35.8 0-13.5 5.5-26.1 15.4-35.6 10.1-9.6 23.5-15 37.7-15 14.2 0 27.6 5.3 37.7 14.9l37.4 35.8-37.4 35.6z"}}]})(props);
	};
	module.exports.IoMdInformationCircleOutline = function IoMdInformationCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422s-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256s17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M277 360h-42V235h42v125zm0-166h-42v-42h42v42z"}}]})(props);
	};
	module.exports.IoMdInformationCircle = function IoMdInformationCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.2 48 48 141.2 48 256s93.2 208 208 208 208-93.2 208-208S370.8 48 256 48zm21 312h-42V235h42v125zm0-166h-42v-42h42v42z"}}]})(props);
	};
	module.exports.IoMdInformation = function IoMdInformation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M232 235h48v137h-48zM232 140h48v48h-48z"}}]})(props);
	};
	module.exports.IoMdJet = function IoMdJet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 32s-23.4-.7-59.3 27.1C404 72 244.9 186.8 244.9 186.8l-168.8-4.2L32 222l109.8 55.2-8.6 10.8-87.9.1-7.2 40.5 63.1 48.7-26.6 59.8 60-26.4 48.7 63.1 40.5-7.2.1-87.8 10.9-8.5L290.1 480l39.3-44.1-4.2-168.7S440.1 108.2 453 91.6C480.7 55.5 480 32 480 32z"}}]})(props);
	};
	module.exports.IoMdJournal = function IoMdJournal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M117.3 42.7c-17.6 0-32 14.4-32 32v362.7c0 17.6 14.4 32 32 32H320V42.7H117.3zM384.7 42.7H368v426.7h16.7c23.1 0 42-18.9 42-42V84.7c0-23.1-18.9-42-42-42z"}}]})(props);
	};
	module.exports.IoMdKey = function IoMdKey (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M249.2 224c-14.2-40.2-55.1-72-100.2-72-57.2 0-101 46.8-101 104s45.8 104 103 104c45.1 0 84.1-31.8 98.2-72H352v64h69.1v-64H464v-64H249.2zm-97.6 66.5c-19 0-34.5-15.5-34.5-34.5s15.5-34.5 34.5-34.5 34.5 15.5 34.5 34.5-15.5 34.5-34.5 34.5z"}}]})(props);
	};
	module.exports.IoMdKeypad = function IoMdKeypad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 398.5c-22.3 0-40.5 18.3-40.5 40.7 0 22.4 18.2 40.7 40.5 40.7s40.5-18.3 40.5-40.7c0-22.3-18.2-40.7-40.5-40.7zM136.5 32C114.2 32 96 50.3 96 72.7s18.2 40.7 40.5 40.7S177 95.1 177 72.7 158.8 32 136.5 32zm0 122.2c-22.3 0-40.5 18.3-40.5 40.7s18.2 40.7 40.5 40.7 40.5-18.3 40.5-40.7-18.2-40.7-40.5-40.7zm0 122.2c-22.3 0-40.5 18.3-40.5 40.7 0 22.4 18.2 40.7 40.5 40.7s40.5-18.3 40.5-40.7c0-22.4-18.2-40.7-40.5-40.7zm239-162.9c22.3 0 40.5-18.3 40.5-40.7S397.8 32 375.5 32 335 50.3 335 72.7s18.2 40.8 40.5 40.8zM256 276.4c-22.3 0-40.5 18.3-40.5 40.7 0 22.4 18.2 40.7 40.5 40.7s40.5-18.3 40.5-40.7c0-22.4-18.2-40.7-40.5-40.7zm119.5 0c-22.3 0-40.5 18.3-40.5 40.7 0 22.4 18.2 40.7 40.5 40.7s40.5-18.3 40.5-40.7c0-22.4-18.2-40.7-40.5-40.7zm0-122.2c-22.3 0-40.5 18.3-40.5 40.7s18.2 40.7 40.5 40.7 40.5-18.3 40.5-40.7-18.2-40.7-40.5-40.7zm-119.5 0c-22.3 0-40.5 18.3-40.5 40.7s18.2 40.7 40.5 40.7 40.5-18.3 40.5-40.7-18.2-40.7-40.5-40.7zM256 32c-22.3 0-40.5 18.3-40.5 40.7s18.2 40.7 40.5 40.7 40.5-18.3 40.5-40.7S278.3 32 256 32z"}}]})(props);
	};
	module.exports.IoMdLaptop = function IoMdLaptop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.334 416C460.803 416 480 396.803 480 373.334V106.668C480 83.199 460.803 64 437.334 64H74.666C51.197 64 32 83.199 32 106.668v266.666C32 396.803 51.197 416 74.666 416H0c0 23.469 64 32 96 32h320c32 0 96-8.531 96-32h-74.666zM74.666 106.668h362.668v271.998H74.666V106.668zM256 434.666c-11.729 0-21.333-9.604-21.333-21.334 0-11.729 9.604-21.332 21.333-21.332s21.333 9.604 21.333 21.332c0 11.73-9.604 21.334-21.333 21.334z"}}]})(props);
	};
	module.exports.IoMdLeaf = function IoMdLeaf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 287.6C416 120.9 256 32 256 32S96 120.9 96 287.6c0 118.8 81.3 140.5 128 143.2V480h64v-49.3c46.7-2.6 128-24.3 128-143.1z"}}]})(props);
	};
	module.exports.IoMdLink = function IoMdLink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M74.6 256c0-38.3 31.1-69.4 69.4-69.4h88V144h-88c-61.8 0-112 50.2-112 112s50.2 112 112 112h88v-42.6h-88c-38.3 0-69.4-31.1-69.4-69.4zm85.4 22h192v-44H160v44zm208-134h-88v42.6h88c38.3 0 69.4 31.1 69.4 69.4s-31.1 69.4-69.4 69.4h-88V368h88c61.8 0 112-50.2 112-112s-50.2-112-112-112z"}}]})(props);
	};
	module.exports.IoMdListBox = function IoMdListBox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408 64H104c-22.091 0-40 17.908-40 40v304c0 22.092 17.909 40 40 40h304c22.092 0 40-17.908 40-40V104c0-22.092-17.908-40-40-40zM304 368H144v-48h160v48zm64-88H144v-48h224v48zm0-88H144v-48h224v48z"}}]})(props);
	};
	module.exports.IoMdList = function IoMdList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 280h256v48H80zM80 184h320v48H80zM80 88h352v48H80z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M80 376h288v48H80z"}}]}]})(props);
	};
	module.exports.IoMdLocate = function IoMdLocate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 176c-44.004 0-80.001 36-80.001 80 0 44.004 35.997 80 80.001 80 44.005 0 79.999-35.996 79.999-80 0-44-35.994-80-79.999-80zm190.938 58.667c-9.605-88.531-81.074-160-169.605-169.599V32h-42.666v33.067c-88.531 9.599-160 81.068-169.604 169.599H32v42.667h33.062c9.604 88.531 81.072 160 169.604 169.604V480h42.666v-33.062c88.531-9.604 160-81.073 169.605-169.604H480v-42.667h-33.062zM256 405.333c-82.137 0-149.334-67.198-149.334-149.333 0-82.136 67.197-149.333 149.334-149.333 82.135 0 149.332 67.198 149.332 149.333S338.135 405.333 256 405.333z"}}]})(props);
	};
	module.exports.IoMdLock = function IoMdLock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 186h-20v-40c0-55-45-100-100-100S156 91 156 146v40h-20c-22.002 0-40 17.998-40 40v200c0 22.002 17.998 40 40 40h240c22.002 0 40-17.998 40-40V226c0-22.002-17.998-40-40-40zM256 368c-22.002 0-40-17.998-40-40s17.998-40 40-40 40 17.998 40 40-17.998 40-40 40zm62.002-182H193.998v-40c0-34.004 28.003-62.002 62.002-62.002 34.004 0 62.002 27.998 62.002 62.002v40z"}}]})(props);
	};
	module.exports.IoMdLogIn = function IoMdLogIn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c-42.9 0-84.2 13-119.2 37.5-34.2 24-60.2 57.2-75.1 96.1L58 192h45.7l1.9-5c8.2-17.8 19.4-33.9 33.5-48 31.2-31.2 72.7-48.4 116.9-48.4s85.7 17.2 116.9 48.4c31.2 31.2 48.4 72.7 48.4 116.9 0 44.1-17.2 85.7-48.4 116.9-31.2 31.2-72.7 48.4-116.9 48.4-44.1 0-85.6-17.2-116.9-48.4-14-14-25.3-30.1-33.5-47.9l-1.9-5H58l3.6 10.4c14.9 38.9 40.9 72.1 75.1 96.1C171.8 451.1 213 464 256 464c114.7 0 208-93.3 208-208S370.7 48 256 48z"}},{"tag":"path","attr":{"d":"M48 277.4h189.7l-43.6 44.7L224 352l96-96-96-96-31 29.9 44.7 44.7H48v42.8z"}}]})(props);
	};
	module.exports.IoMdLogOut = function IoMdLogOut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 277.4h189.7l-43.6 44.7L368 352l96-96-96-96-31 29.9 44.7 44.7H192v42.8z"}},{"tag":"path","attr":{"d":"M255.7 421.3c-44.1 0-85.5-17.2-116.7-48.4-31.2-31.2-48.3-72.7-48.3-116.9 0-44.1 17.2-85.7 48.3-116.9 31.2-31.2 72.6-48.4 116.7-48.4 44 0 85.3 17.1 116.5 48.2l30.3-30.3c-8.5-8.4-17.8-16.2-27.7-23.2C339.7 61 298.6 48 255.7 48 141.2 48 48 141.3 48 256s93.2 208 207.7 208c42.9 0 84-13 119-37.5 10-7 19.2-14.7 27.7-23.2l-30.2-30.2c-31.1 31.1-72.5 48.2-116.5 48.2zM448.004 256.847l-.849-.848.849-.849.848.849z"}}]})(props);
	};
	module.exports.IoMdMagnet = function IoMdMagnet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.6 98.8C352.1 65.8 308 48.2 256 48c-51.9.2-96 17.8-127.5 50.8C96.8 132 80 178.8 80 234c0 43.5 1.8 69.2 12.9 115.8 0 0 22.7 75.7 35.5 104.1 3.5 7.8 7.4 11.8 15.5 9.3 6.4-2 46.8-17.9 54.7-21.6 7.9-3.6 11.6-8.6 8.9-15.2-3.8-9.2-33.9-95.6-33.9-95.6-8.4-36.3-11.6-53.9-11.6-94.3 0-28.2 9.8-54.1 27.7-72.9 17.5-18.3 41-28.4 66.3-28.4s48.8 10.1 66.3 28.4c17.9 18.8 27.7 44.6 27.7 72.8 0 40-3.2 64-11.7 94.4s-32.2 90.1-33.9 95.6c-1.7 5.6 2.1 12.5 8.9 15.2 6.8 2.7 49.3 19.6 54.7 21.6 5.4 2 10.6.6 14.5-7.7 4-8.3 24.6-61.4 36.5-105.7 12-44.3 13-72.3 13-115.8 0-55.2-16.7-101.9-48.4-135.2zM173.1 419.7l-22.9 9.6c-6.9-16.3-17.2-43.2-25.9-77.2l22-6.5 26.8 74.1zm188.6 9.6l-22.9-9.6c7.2-16.6 19.1-45.1 26.6-74.1l22 6.5c-8.4 33.9-18.7 60.9-25.7 77.2z"}}]})(props);
	};
	module.exports.IoMdMailOpen = function IoMdMailOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 201.667c0-14.933-7.469-28.803-20.271-36.266L256 64 52.271 165.401C40.531 172.864 32 186.734 32 201.667v203.666C32 428.802 51.197 448 74.666 448h362.668C460.803 448 480 428.802 480 405.333V201.667zM256 304L84.631 192 256 106.667 427.369 192 256 304z"}}]})(props);
	};
	module.exports.IoMdMailUnread = function IoMdMailUnread (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"432","cy":"128","r":"64"}},{"tag":"path","attr":{"d":"M382.9 203.4L256 288 80 170.7V128l176 117.3 101.1-67.4c-9.5-14.3-15.1-31.5-15.1-49.9 0-17.6 5.1-34.1 13.9-48H74.7C51.2 80 32 99.2 32 122.7v266.7c0 23.5 19.2 42.7 42.7 42.7h362.7c23.5 0 42.7-19.2 42.7-42.7V204.1c-13.9 8.8-30.4 13.9-48 13.9-18.2 0-35.1-5.4-49.2-14.6z"}}]})(props);
	};
	module.exports.IoMdMail = function IoMdMail (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.332 80H74.668C51.199 80 32 99.198 32 122.667v266.666C32 412.802 51.199 432 74.668 432h362.664C460.801 432 480 412.802 480 389.333V122.667C480 99.198 460.801 80 437.332 80zM432 170.667L256 288 80 170.667V128l176 117.333L432 128v42.667z"}}]})(props);
	};
	module.exports.IoMdMale = function IoMdMale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 48H288v48h94.1L275.4 202.6C251.9 185.9 223.1 176 192 176c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144c0-31.1-9.9-59.9-26.6-83.4L416 129.9V224h48V48h-48zM192 416c-52.9 0-96-43.1-96-96s43.1-96 96-96 96 43.1 96 96-43.1 96-96 96z"}}]})(props);
	};
	module.exports.IoMdMan = function IoMdMan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 106.6c20.6.1 37.3-16.6 37.3-37.3 0-20.6-16.7-37.3-37.3-37.3-20.6 0-37.3 16.7-37.3 37.3 0 20.6 16.7 37.3 37.3 37.3zM293.4 115h-74.8c-28.2 0-46.6 24.8-46.6 48.4V277c0 22 31 22 31 0V172h6v285.6c0 30.4 42 29.4 43 0V293h8v164.7c1.7 31.2 43 28.2 43-.1V172h5v105c0 22 32 22 32 0V163.4c0-23.5-18.5-48.4-46.6-48.4z"}}]})(props);
	};
	module.exports.IoMdMap = function IoMdMap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M437.333 64c-2.176 0-4.396 1.369-9.176 3.207L320 108.802 192 64 71.469 104.531C67.197 105.604 64 109.864 64 115.197v322.136C64 443.729 68.271 448 74.666 448c1.828 0 6.505-2.33 9.087-3.319L192 403.197 320 448l120.531-40.531c4.271-1.073 7.469-5.334 7.469-10.667V74.666C448 68.271 443.729 64 437.333 64zM320 405.333l-128-44.802V106.666l128 44.803v253.864z"}}]})(props);
	};
	module.exports.IoMdMedal = function IoMdMedal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M273.5 152.1H48l54.1-103.9h240.7z"}},{"tag":"circle","attr":{"cx":"256.2","cy":"377.2","r":"86.6"}},{"tag":"path","attr":{"d":"M348.9 299.1l115.1-147-69.3-103.9L256.4 256c32.3 0 62.7 12.7 85.5 35.5 2.5 2.5 4.8 5 7 7.6zM205.8 266.6L152.3 186H48.4l90.1 161.5c5.2-21.2 16.1-40.6 32-56.4 10.4-10.3 22.3-18.6 35.3-24.5z"}}]})(props);
	};
	module.exports.IoMdMedical = function IoMdMedical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M351.9 256L460 193.6l-48-83.2-108 62.4V48h-96v124.8l-108-62.4-48 83.2L160.1 256 52 318.4l48 83.2 108-62.4V464h96V339.2l108 62.4 48-83.2z"}}]})(props);
	};
	module.exports.IoMdMedkit = function IoMdMedkit (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 144v-39.6C352 82 334 64 311.6 64H200.4C178 64 160 82 160 104.4V144H48v263.6C48 430 66 448 88.4 448h335.2c22.4 0 40.4-18 40.4-40.4V144H352zm-152-40h112v40H200v-40zm136 224h-56v56h-48v-56h-56v-48h56v-56h48v56h56v48z"}}]})(props);
	};
	module.exports.IoMdMegaphone = function IoMdMegaphone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M382.1 143.4l-23.1 23c14.7 14.7 23.9 35.2 23.9 57.6s-9.2 42.9-23.9 57.6l23.1 23.1c20.6-20.6 33.4-49.2 33.4-80.6s-12.8-60.1-33.4-80.7z"}},{"tag":"path","attr":{"d":"M428.2 99l-22.7 22.7c26.1 26.1 42.3 62.4 42.3 102.3 0 39.8-16.1 76.1-42.3 102.3l22.7 22.7c31.9-32.1 51.8-76.3 51.8-125s-19.8-92.9-51.8-125zM320 184.1V80h-32l-96 80H64l-32 16v112l32 16 80 128h48l-30-128h30l96 64h32V263.9c18.4-1.7 32-18.9 32-39.9s-13.6-38.2-32-39.9z"}}]})(props);
	};
	module.exports.IoMdMenu = function IoMdMenu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 384h384v-42.666H64V384zm0-106.666h384v-42.667H64v42.667zM64 128v42.665h384V128H64z"}}]})(props);
	};
	module.exports.IoMdMicOff = function IoMdMicOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M367.951 354.654l-26.616-26.562-9.568-9.548-4.698-4.706L187 174.041v.346L76.112 63.531 51.921 87.572 187 222.47v28.816c0 37.79 31.121 68.714 68.91 68.714a68.6 68.6 0 0 0 24.565-4.545l32.389 32.274c-17.333 8.793-36.812 13.86-56.782 13.86-62.986 0-121.365-48.59-121.365-116.59H95.773C95.773 322 158 387.701 233 398.013V480h46v-81.987c22-3.352 43.066-11.222 61.627-22.622l95.278 95.078 24.033-24-33.847-33.785-58.216-57.959 58.224 57.959-58.148-58.03zM325 251.286V100.714C325 62.924 293.791 32 256 32s-69 30.924-69 68.714v25.244l137.109 136.968c.67-3.791.891-7.679.891-11.64zM416.439 245h-38.941c0 20.496-5.498 39.676-14.931 56.197l27.572 27.516c16.523-24.11 26.3-52.787 26.3-83.713zM459.999 446.427l-33.897-33.743 33.855 33.785z"}}]})(props);
	};
	module.exports.IoMdMic = function IoMdMic (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 320c37.712 0 68.571-30.924 68.571-68.714V100.714C324.571 62.924 293.712 32 256 32s-68.571 30.924-68.571 68.714v150.572c0 37.79 30.859 68.714 68.571 68.714zm121.139-75.452c0 68.714-58.282 116.815-121.139 116.815s-121.139-48.102-121.139-116.815H96c0 77.873 61.719 143.153 137.144 153.465V480h45.713v-81.987C354.281 386.561 416 322.421 416 244.548h-38.861z"}}]})(props);
	};
	module.exports.IoMdMicrophone = function IoMdMicrophone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 112V84.4c0-29-24.5-52.4-54.8-52.4H182.9C152.5 32 128 55.4 128 84.4V112h152v37H128v43h152v37H128v43h152v37H128v41.8c0 29 24.5 52.2 54.9 52.2H213v77h86v-77h30.2c30.3 0 54.8-23.2 54.8-52.2V309h-56v-37h56v-43h-56v-37h56v-43h-56v-37h56z"}}]})(props);
	};
	module.exports.IoMdMoon = function IoMdMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M195 125c0-26.3 5.3-51.3 14.9-74.1C118.7 73 51 155.1 51 253c0 114.8 93.2 208 208 208 97.9 0 180-67.7 202.1-158.9-22.8 9.6-47.9 14.9-74.1 14.9-106 0-192-86-192-192z"}}]})(props);
	};
	module.exports.IoMdMore = function IoMdMore (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M296 136c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40zm0 240c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40zm0-120c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40z"}}]})(props);
	};
	module.exports.IoMdMove = function IoMdMove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 256l-96-96v64h-96v-96h64l-96-96-96 96h64v96h-96v-64l-96 96 96 96v-64h96v96h-64l96 96 96-96h-64v-96h96v64z"}}]})(props);
	};
	module.exports.IoMdMusicalNote = function IoMdMusicalNote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64v225.1c-12.6-7.3-27.1-11.7-42.7-11.7-47.1 0-85.3 38.2-85.3 85.3s38.2 85.3 85.3 85.3 85.3-38.2 85.3-85.3V149.3H384V64H256z"}}]})(props);
	};
	module.exports.IoMdMusicalNotes = function IoMdMusicalNotes (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 64v257.6c-8.2-2.7-17.2-4.1-26.6-4.1-38.3 0-69.4 27.1-69.4 65.4 0 38.3 31.1 65.1 69.4 65.1 38.3 0 69.6-28.2 69.6-69.1V200h202v121.6c-8.2-2.7-17.2-4.1-26.6-4.1-38.3 0-69.4 27.1-69.4 65.4 0 38.3 31.1 65.1 69.4 65.1 38.3 0 69.6-28.2 69.6-69.1V64H160zm245 96H203v-53h202v53z"}}]})(props);
	};
	module.exports.IoMdNavigate = function IoMdNavigate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64L96 433.062 110.938 448 256 384l145.062 64L416 433.062z"}}]})(props);
	};
	module.exports.IoMdNotificationsOff = function IoMdNotificationsOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 463.656c22.814 0 41.475-18.656 41.475-41.656h-82.95c0 23 18.661 41.656 41.475 41.656z"}},{"tag":"path","attr":{"d":"M131.083 107.172l.053.074L98.09 74.277 74.004 98.383l63.042 63.153C126.888 180.521 121 202.196 121 225.07v114.555l-41 41.656V402h297.743l36.182 36.33 24.079-24.301L425.9 402h.316L131.083 107.172zM391 225.07c0-63.526-45-117.677-104-131.218V79.274c0-17.706-13.371-31.243-31-31.243-17.628 0-31 13.537-31 31.243v14.578c-15 3.438-29.048 9.501-41.75 17.663L391 319.355V225.07z"}}]})(props);
	};
	module.exports.IoMdNotificationsOutline = function IoMdNotificationsOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M257 120.471c7.083 0 23.911 4.479 23.911 4.479 45.589 10.447 77.678 52.439 77.678 99.85V352.412l9.321 9.364 7.788 7.823H136.302l7.788-7.823 9.321-9.364V224.8c0-47.41 32.089-89.403 77.678-99.85 0 0 18.043-4.479 23.911-4.479M256 48c-17.602 0-31.059 13.518-31.059 31.2v14.559c-59.015 13.523-103.53 67.601-103.53 131.041v114.4L80 380.8v20.8h352v-20.8l-41.411-41.6V224.8c0-63.44-44.516-117.518-103.53-131.041V79.2c0-17.682-13.457-31.2-31.059-31.2zm41.411 374.4h-82.823c0 22.881 18.633 41.6 41.412 41.6s41.411-18.719 41.411-41.6z"}}]})(props);
	};
	module.exports.IoMdNotifications = function IoMdNotifications (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 464c22.779 0 41.411-18.719 41.411-41.6h-82.823c0 22.881 18.633 41.6 41.412 41.6zm134.589-124.8V224.8c0-63.44-44.516-117.518-103.53-131.041V79.2c0-17.682-13.457-31.2-31.059-31.2s-31.059 13.518-31.059 31.2v14.559c-59.015 13.523-103.53 67.601-103.53 131.041v114.4L80 380.8v20.8h352v-20.8l-41.411-41.6z"}}]})(props);
	};
	module.exports.IoMdNuclear = function IoMdNuclear (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 272c0-29.8-16.3-55.7-40.4-69.5l73.1-124.1C335.6 59.1 297.1 48 256 48c-41.2 0-79.9 11.2-113.1 30.6l71.6 125C191.4 217.6 176 243 176 272H32c0 83.3 46.9 153.4 114.4 192l70.1-122.4c11.7 6.6 25.1 10.4 39.5 10.4 14.3 0 27.7-3.8 39.3-10.3L365.6 464C433.1 425.4 480 355.3 480 272H336z"}}]})(props);
	};
	module.exports.IoMdNutrition = function IoMdNutrition (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M357.2 235.6L274.7 153h-.8c-8.1-6-18.2-10.3-28.4-10.3-13.7 0-26.1 6.3-34.3 16.3h-.6L53 414.1v.8c-3 6.2-5 13.3-5 20.8 0 24.4 19.7 44.3 44.3 44.3 9.4 0 18-2.9 27.4-9.1l232.9-168.1c10.9-8.3 17.4-21.6 17.4-36 0-12-4.7-23.2-12.8-31.2zM464 145.1l-29.2-49-36.6 20.3 31.5-55.9L380.6 32l-67.3 127.8 41.3 41.4z"}}]})(props);
	};
	module.exports.IoMdOpen = function IoMdOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.34 405.332H106.66V106.668H240V64H106.66C83.191 64 64 83.197 64 106.668v298.664C64 428.803 83.191 448 106.66 448h298.68c23.469 0 42.66-19.197 42.66-42.668V272h-42.66v133.332zM288 64v42.668h87.474L159.999 322.133l29.866 29.866 215.476-215.47V224H448V64H288z"}}]})(props);
	};
	module.exports.IoMdOptions = function IoMdOptions (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 384h272v32H32zM400 384h80v32h-80zM384 447.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M32 240h80v32H32zM208 240h272v32H208zM192 303.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z"}}]},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M32 96h272v32H32zM400 96h80v32h-80zM384 159.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z"}}]}]})(props);
	};
	module.exports.IoMdOutlet = function IoMdOutlet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.5 32H142.4C81.5 32 32 82.6 32 144.6v222.8c0 62 49.5 112.6 110.4 112.6h227.2c60.9 0 110.5-50.6 110.5-112.6V144.6C480 82.6 430.5 32 369.5 32zM175 251v.7c0 10.9-9.1 20.4-19.9 20.4h-23.3c-10.8 0-19.9-9.5-19.9-20.4V148.1c1-10.8 9.2-20.2 19.9-20.2h23.3c10.9 0 19.9 9.8 19.9 20.8V251zm122 147.4c0 11.4-8.9 17.6-20.1 17.6h-41.8c-11.2 0-20.1-8.1-20.1-19.6v-29.3c0-23.3 18.1-42.3 41-42.3s41 19 41 42.3v31.3zM400 251v.7c0 10.9-9.1 20.4-19.9 20.4h-24.3c-10.8 0-19.9-9.5-19.9-20.4V148.1c1-10.8 9.2-20.2 19.9-20.2h24.3c10.8 0 19.9 9.8 19.9 20.8V251z"}}]})(props);
	};
	module.exports.IoMdPaperPlane = function IoMdPaperPlane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 270.9l118.9 44.6L181.7 464 256 360l104 104L464 48 48 270.9zm294.9 126L260 313.4 374.9 152 193.6 289.8 124.9 265l291-156.2-73 288.1z"}}]})(props);
	};
	module.exports.IoMdPaper = function IoMdPaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 64H192c-8.8 0-16 7.7-16 16.5V112H74c-23.1 0-42 18.9-42 42v207.5c0 47.6 39 86.5 86 86.5h279.7c45.1 0 82.3-36.9 82.3-82V80c0-8.8-7.2-16-16-16zm-288 80v192h-42V163.2c0-6.8-.8-13.3-3.3-19.2H176zm-17 255.4C148 410 133.2 416 118.5 416c-14.5 0-28.1-5.7-38.5-16-10.3-10.3-16-24-16-38.5V163.2c0-10.6 8.4-19.2 19-19.2s19 8.6 19 19.2V352c0 8.8 7.2 16 16 16h57.5c-1.5 11.6-7.2 22.6-16.5 31.4zM448 366c0 13.3-5.4 25.8-14.9 35.3-9.5 9.5-22.2 14.7-35.4 14.7H187.3c12.8-14.9 20.7-33.9 20.7-54.5V97h240v269z"}},{"tag":"path","attr":{"d":"M248 136h160v56H248zM248 224h160v32H248zM248 288h160v32H248zM408 352H248s0 32-8 32h148.7c19.3 0 19.3-21 19.3-32z"}}]})(props);
	};
	module.exports.IoMdPartlySunny = function IoMdPartlySunny (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M248.03 116.81l24.679-24.678 19.233 19.234-24.678 24.677zM176 125.7c-45.3 0-82.3 37-82.3 82.3 0 17.5 5.5 33.7 14.9 47 15.3-13 33.9-22.6 54.7-27.6l13.2-16.6c13.6-17.1 30.7-30.2 50.8-38.9 6.1-2.6 12.4-4.8 19-6.6-14.5-23.7-40.6-39.6-70.3-39.6zM162 64h28v41h-28zM32 194h41v28H32zM81.6 276.8l-.8-.8-24.7 24.7 19.2 19.2 24.7-24.7zM79.289 92.13l24.678 24.678-19.233 19.233-24.678-24.678zM405.6 288.6C394.7 233.4 346.2 192 288 192c-34 0-65.1 11.9-86.5 38.8 29.4 2.2 56.7 13 77.8 33.9 15.6 15.6 26.6 34.6 32.1 55.3h-28.7c-13.1-37.3-48-64-90.6-64-5.1 0-12.3.6-17.7 1.7C128.6 267.1 96 305 96 352c0 53 43 96 96 96h208c44.2 0 80-35.8 80-80 0-42.2-32.8-76.5-74.4-79.4z"}}]})(props);
	};
	module.exports.IoMdPause = function IoMdPause (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 448h106.7V64H96v384zM309.3 64v384H416V64H309.3z"}}]})(props);
	};
	module.exports.IoMdPaw = function IoMdPaw (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.5 165.9c-4.7-10.5-12.7-18.1-23.1-22-4.8-1.7-9.7-2.6-14.8-2.6-21.7 0-43.7 16.7-54.9 41.6-13.8 30.9-5.8 61 18.6 70.3 4.9 1.8 10.1 2.8 15.6 2.8 22.1 0 44.6-15.3 55.9-38.1 8.5-17.5 9.5-36.8 2.7-52zM145.3 182.8c-11.1-24.9-33.2-41.6-54.9-41.6-5.1 0-10.1.9-14.8 2.6-10.4 3.9-18.3 11.5-23.1 22-6.9 15.2-5.9 34.6 2.7 51.9 11.3 22.8 33.8 38.1 55.9 38.1 5.4 0 10.7-.9 15.6-2.8 24.4-9.1 32.4-39.3 18.6-70.2zM193.5 179.4c2 .1 4 0 6-.2 11.7-.9 22.3-5.9 30.6-14.3 13.4-13.6 17.1-34.9 14.3-56.8-4.3-33.7-25.8-59-54.8-60.1 0 0-4.1 0-6.2.2-12.8 1.1-24.4 6.5-33.5 15.9-13.3 13.6-19.7 33.7-17.1 53.8 4.3 33.4 30.9 60.4 60.7 61.5zM256 224c-69.3 0-138.7 97.1-138.7 176.3 0 23.6 11.8 42.6 23.5 50.4 14.4 9.6 24.5 13.4 45.5 13.4 13.4 0 21.6-2.5 28.1-6.1 12.3-6.7 25.9-10.4 39.9-10.4h3.5c14 0 27.6 3.8 39.9 10.4 6.5 3.5 14.7 6.1 28.1 6.1 21.1 0 31.2-3.8 45.5-13.4 11.6-7.8 23.5-26.8 23.5-50.4C394.7 321 325.3 224 256 224zM312.6 179.1c2 .2 4 .2 6 .2 29.8-1.1 56.5-28 60.8-61.5 2.6-20.2-3.8-40.4-17.1-53.8-9.2-9.3-20.3-14.6-33.1-15.6-2.1-.2-6.7-.2-6.7-.2-28.9 1.1-50.4 26.1-54.8 59.9-2.8 21.9.9 43.3 14.3 56.8 8.4 8.3 19 13.2 30.6 14.2z"}}]})(props);
	};
	module.exports.IoMdPeople = function IoMdPeople (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M337.454 232c33.599 0 61.092-27.002 61.092-60 0-32.997-27.493-60-61.092-60s-61.09 27.003-61.09 60c0 32.998 27.491 60 61.09 60zm-162.908 0c33.599 0 61.09-27.002 61.09-60 0-32.997-27.491-60-61.09-60s-61.092 27.003-61.092 60c0 32.998 27.493 60 61.092 60zm0 44C126.688 276 32 298.998 32 346v54h288v-54c0-47.002-97.599-70-145.454-70zm162.908 11.003c-6.105 0-10.325 0-17.454.997 23.426 17.002 32 28 32 58v54h128v-54c0-47.002-94.688-58.997-142.546-58.997z"}}]})(props);
	};
	module.exports.IoMdPersonAdd = function IoMdPersonAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96zM112 224v-64H80v64H16v32h64v64h32v-64h64v-32h-64z"}}]})(props);
	};
	module.exports.IoMdPerson = function IoMdPerson (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96z"}}]})(props);
	};
	module.exports.IoMdPhoneLandscape = function IoMdPhoneLandscape (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 358.856V153.143C480 130.512 461.674 112 439.272 112H72.728C50.326 112 32 130.512 32 153.143v205.713C32 381.488 50.326 400 72.728 400h366.545C461.674 400 480 381.488 480 358.856zM112 364V148h288v216H112z"}}]})(props);
	};
	module.exports.IoMdPhonePortrait = function IoMdPhonePortrait (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M358.856 32H153.143C130.512 32 112 50.326 112 72.728v366.545C112 461.674 130.512 480 153.143 480h205.713C381.488 480 400 461.674 400 439.272V72.728C400 50.326 381.488 32 358.856 32zM364 400H148V112h216v288z"}}]})(props);
	};
	module.exports.IoMdPhotos = function IoMdPhotos (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 421.3V154.7c0-23.5-19.2-42.7-42.7-42.7H90.7C67.2 112 48 131.2 48 154.7v266.7c0 23.5 19.2 42.7 42.7 42.7h266.7c23.4-.1 42.6-19.3 42.6-42.8zM157.3 304l45.3 64 66.7-96 88 128H90.7l66.6-96z"}},{"tag":"path","attr":{"d":"M421.3 48H154.7C131.2 48 112 67.2 112 90.7V96h261.3c23.5 0 42.7 19.2 42.7 42.7V400h5.3c23.5 0 42.7-19.2 42.7-42.7V90.7c0-23.5-19.2-42.7-42.7-42.7z"}}]})(props);
	};
	module.exports.IoMdPie = function IoMdPie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32.6 256H256V32.6c-5-.4-10.6-.6-16-.6-114.9 0-208 93.1-208 208 0 5.4.2 11 .6 16z"}},{"tag":"path","attr":{"d":"M109.8 402.2C147.9 449.6 206.4 480 272 480c114.9 0 208-93.1 208-208 0-65.6-30.4-124.1-77.8-162.2C370.5 84.3 331 67.9 288 64.6V288H64.6c3.3 43 19.7 82.5 45.2 114.2z"}}]})(props);
	};
	module.exports.IoMdPin = function IoMdPin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32c-88.004 0-160 70.557-160 156.801C96 306.4 256 480 256 480s160-173.6 160-291.199C416 102.557 344.004 32 256 32zm0 212.801c-31.996 0-57.144-24.645-57.144-56 0-31.357 25.147-56 57.144-56s57.144 24.643 57.144 56c0 31.355-25.148 56-57.144 56z"}}]})(props);
	};
	module.exports.IoMdPint = function IoMdPint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 48l42.9 379.2c2.6 20.8 20.5 36.8 42.5 36.8h213.3c22 0 39.9-16 42.5-36.8L448 48H64zm327 124.8H121l-9.4-83.2h288.6l-9.2 83.2z"}}]})(props);
	};
	module.exports.IoMdPizza = function IoMdPizza (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M407.2 130.4C360.7 111.5 309.8 102 256 102c-53.9 0-108.3 10.3-151.2 28-8.1 3.3-15.3 9-10.1 19.5S255.9 480 255.9 480l161-329.9c3.2-6.9.9-15.4-9.7-19.7zm-221 73.6c-18.7 0-32-14.3-32-32s13.3-32 32-32 32 14.3 32 32-13.3 32-32 32zM256 347c-18.7 0-32-14.3-32-32s13.3-32 32-32 32 14.3 32 32-13.3 32-32 32zm69.8-123c-18.7 0-32-14.3-32-32s13.3-32 32-32 32 14.3 32 32-13.3 32-32 32z"}},{"tag":"path","attr":{"d":"M436.9 66C384.7 45.4 320.3 32 256 32c-64.3 0-127.6 12.1-180.9 33.4C70.4 67.3 64 71 64 79.2l9.7 24.1c2.8 4.9 8.7 8.2 15.1 8.2 1.8 0 4.3-.3 7.3-1.5 49-18.9 103.1-29.6 160-29.6 56.9 0 115.2 11.6 160 29.6 3.6 1.4 5.6 1.5 7.3 1.5 6.6 0 12.2-3.3 15-8.1l9.8-24.1c-.2-7.3-5-10.8-11.3-13.3z"}}]})(props);
	};
	module.exports.IoMdPlanet = function IoMdPlanet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M135.7 151c-2.5 3-4.9 6-7.2 9.2 32.2 36.3 76.1 76.5 124.2 113.7 37.8 29.2 76.3 55.2 111.4 75.1 5.9 3.3 11.7 6.5 17.3 9.4 2.5-3 4.9-6 7.2-9.2 11.7-16.1 18.1-33.2 23.3-53.6.8-3.2 1.5-6.4 2.1-9.5 15.8-83-35.6-164.9-118.5-185.9-37-9.4-74.1-5.1-106.3 9.7-21.4 9.9-38.2 22.9-53.5 41.1z"}},{"tag":"path","attr":{"d":"M418.2 326.8c-4.1 11-7.4 17.5-7.4 17.5 18.2 21.1 24.6 33.9 31.9 46.4 2.4 4.1 7.4 13.1.9 12.4-1.7-.3-3.5-.7-5.5-1.3-21.3-5.4-51.2-18.7-84.3-37.4-35.8-20.3-74.9-46.7-113.3-76.3-51.1-39.5-97.5-82.3-130.6-120.5-15.3-17.6-27.6-34.2-35.7-47.9-2.4-4.1-3.9-6.3-5.6-10.4-2.5-6.2 5-5.1 7-4.6 14.9 3.8 35 9.9 58.2 23.8 0 0 4.3-4.8 13.9-11.4-22.8-15.4-44.6-27.7-65.2-35.5-23.1-8.8-41.1-6.8-47.5 3.7-12.2 19.9 14 72.3 65.3 132-21.5 86 30.6 173.3 116.5 195 41.1 10.4 82.4 3.9 116.8-15 38.1 17.6 72.1 28.6 96.9 34.9 23.9 6.1 40.4 5.5 46.8-4.9 11.1-18.2-12.1-51.8-59.1-100.5z"}}]})(props);
	};
	module.exports.IoMdPlayCircle = function IoMdPlayCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.2 48 48 141.2 48 256s93.2 208 208 208 208-93.2 208-208S370.8 48 256 48zm-41.6 301.6V162.4L339.2 256l-124.8 93.6z"}}]})(props);
	};
	module.exports.IoMdPlay = function IoMdPlay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 52v408l320-204L96 52z"}}]})(props);
	};
	module.exports.IoMdPodium = function IoMdPodium (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 224h128v192H32zM192 128h128v288H192zM352 288h128v128H352z"}}]})(props);
	};
	module.exports.IoMdPower = function IoMdPower (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M279.1 48h-46.2v231.1h46.2V48zm111.6 50.2L357.9 131c36.5 29.4 59.9 74.4 59.9 125 0 89.4-72.3 161.8-161.8 161.8S94.2 345.4 94.2 256c0-50.6 23.3-95.7 59.6-125.3l-32.6-32.6C76.4 136.3 48 192.7 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-63.3-28.4-119.7-73.3-157.8z"}}]})(props);
	};
	module.exports.IoMdPricetag = function IoMdPricetag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 64H257.6L76.5 251.6c-8 8-12.3 18.5-12.5 29-.3 11.3 3.9 22.6 12.5 31.2l123.7 123.6c8 8 20.8 12.5 28.8 12.5s22.8-3.9 31.4-12.5L448 256V96l-32-32zm-30.7 102.7c-21.7 6.1-41.3-10-41.3-30.7 0-17.7 14.3-32 32-32 20.7 0 36.8 19.6 30.7 41.3-2.9 10.3-11.1 18.5-21.4 21.4z"}}]})(props);
	};
	module.exports.IoMdPricetags = function IoMdPricetags (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M442 107v141L229.2 451.7c8 8 20.8 12.3 28.8 12.3s22.8-3.7 31.4-12.3L480 272V144l-38-37z"}},{"tag":"path","attr":{"d":"M384 48H224L44.3 235.6c-8 8-12 17.8-12.3 28.4-.3 11.3 3.7 23.3 12.3 31.9l123.8 123.6c8 8 20.8 12.5 28.8 12.5s22.7-3.9 31.3-12.5L416 240V80l-32-32zm-30.7 102.7c-21.7 6.1-41.3-10-41.3-30.7 0-17.7 14.3-32 32-32 20.7 0 36.8 19.6 30.7 41.3-2.9 10.3-11.1 18.5-21.4 21.4z"}}]})(props);
	};
	module.exports.IoMdPrint = function IoMdPrint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M399.95 160h-287.9C76.824 160 48 188.803 48 224v138.667h79.899V448H384.1v-85.333H464V224c0-35.197-28.825-64-64.05-64zM352 416H160V288h192v128zm32.101-352H127.899v80H384.1V64z"}}]})(props);
	};
	module.exports.IoMdPulse = function IoMdPulse (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M428 269c-21.5 0-40.6 13.1-48.4 33h-41.2L307 221.3c-2.7-8.2-10.3-13.7-19-13.7h-.4c-8.8.2-16.4 6-18.8 14.5l-33.6 135.4-55.5-291.8C178 55.6 169.6 48 160 48c-9.5 0-16.9 6.2-19.4 16.2L90.3 302H32v40h74c9.2 0 17.2-6.2 19.4-15.2l30.7-160.6 54.1 282.1c1.5 8.8 8.9 15.1 18.6 15.7h1.2c9.3 0 16.9-5.3 19.2-13.5l40.2-162.9 15.5 40.7c2.7 8.2 10.3 13.7 19 13.7h56.4c8.3 19 27.1 31 47.6 31 13.9 0 26.9-5.6 36.8-15.8 9.8-10.1 15.2-23.3 15.2-37.2.1-28.6-22.7-51-51.9-51z"}}]})(props);
	};
	module.exports.IoMdQrScanner = function IoMdQrScanner (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 124.2c0-6.9 5.2-12.2 12.2-12.2H176V64h-66.8C75.7 64 48 90.7 48 124.2V192h48v-67.8zM403.6 64H336v48h67.2c6.9 0 12.8 5.2 12.8 12.2V192h48v-67.8c0-33.5-27-60.2-60.4-60.2zM416 386.8c0 6.9-5.2 12.2-12.2 12.2H336v49h67.8c33.5 0 60.2-27.7 60.2-61.2V320h-48v66.8zM108.2 399c-6.9 0-12.2-5.2-12.2-12.2V320H48v66.8c0 33.5 27.7 61.2 61.2 61.2H176v-49h-67.8z"}}]})(props);
	};
	module.exports.IoMdQuote = function IoMdQuote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96.4 416h77.1l50.9-96.6V96h-160v223.4h77.1L96.4 416zm224 0h77.1l50-96.6V96H288.4v223.4h82l-50 96.6z"}}]})(props);
	};
	module.exports.IoMdRadioButtonOff = function IoMdRadioButtonOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.601 48 48 141.601 48 256s93.601 208 208 208 208-93.601 208-208S370.399 48 256 48zm0 374.399c-91.518 0-166.399-74.882-166.399-166.399S164.482 89.6 256 89.6 422.4 164.482 422.4 256 347.518 422.399 256 422.399z"}}]})(props);
	};
	module.exports.IoMdRadioButtonOn = function IoMdRadioButtonOn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 152c-57.2 0-104 46.8-104 104s46.8 104 104 104 104-46.8 104-104-46.8-104-104-104zm0-104C141.601 48 48 141.601 48 256s93.601 208 208 208 208-93.601 208-208S370.399 48 256 48zm0 374.4c-91.518 0-166.4-74.883-166.4-166.4S164.482 89.6 256 89.6 422.4 164.482 422.4 256 347.518 422.4 256 422.4z"}}]})(props);
	};
	module.exports.IoMdRadio = function IoMdRadio (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M73.8 141.9c-15.2 6-25.8 21.8-25.8 39.5v256c0 23.5 18.5 42.7 41.6 42.7h332.8c23.1 0 41.6-19.2 41.6-42.7v-256c0-23.7-18.5-42.7-41.6-42.7H179l171.8-71.3L336.7 32 73.8 141.9zM160 438c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64zm256-171.3h-32v-46.2h-44.8v46.2H96v-85.3h320v85.3z"}}]})(props);
	};
	module.exports.IoMdRainy = function IoMdRainy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M139 400s-23 25.3-23 40.7c0 12.8 10.3 23.3 23 23.3s23-10.5 23-23.3c0-15.4-23-40.7-23-40.7zM217 368s-23 25.3-23 40.7c0 12.8 10.4 23.3 23 23.3 12.7 0 23-10.5 23-23.3 0-15.4-23-40.7-23-40.7zM295 400s-23 25.3-23 40.7c0 12.8 10.3 23.3 23 23.3 12.6 0 23-10.5 23-23.3 0-15.4-23-40.7-23-40.7zM373 368s-23 25.3-23 40.7c0 12.8 10.4 23.3 23 23.3 12.7 0 23-10.5 23-23.3 0-15.4-23-40.7-23-40.7zM393.2 161.2C380.5 96.6 323.9 48 256 48c-39.7 0-76 14-100.9 45.4 34.3 2.6 66.1 15.2 90.7 39.8 18.2 18.2 31 40.5 37.4 64.8h-33.5c-15.3-43.7-56-75-105.7-75-6 0-14.3.7-20.6 2C70 136 32 180.4 32 235.5 32 297.6 79.4 352 141.2 352h242.7c51.5 0 96.2-46 96.2-97.8-.1-49.4-38.4-89.6-86.9-93z"}}]})(props);
	};
	module.exports.IoMdRecording = function IoMdRecording (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.8 160c-53.4 0-96.2 42.8-96.2 96 0 23.6 7.9 44.5 21.9 61.1h-78.8c14-16.6 21.9-37.5 21.9-61.1 0-53.2-42.9-96-96.2-96S46 202.8 46 256s42.9 96 96.2 96h227.5c53.4 0 96.2-42.8 96.2-96s-42.8-96-96.1-96zM142.2 317.1C108.1 317.1 81 290 81 256s27.1-61.1 61.2-61.1 61.2 27.1 61.2 61.1-27 61.1-61.2 61.1zm227.6 0c-34.1 0-61.2-27.1-61.2-61.1s27.1-61.1 61.2-61.1S431 222 431 256s-27.1 61.1-61.2 61.1z"}}]})(props);
	};
	module.exports.IoMdRedo = function IoMdRedo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 337.2L83.8 352c22.9-69.7 88.7-117.8 166-117.8 42.8 0 81.5 15.7 111.8 41.1L282.5 352H480V160l-79.6 76.3c-40.4-35.2-92.8-56.8-150.7-56.8-101.5.1-187.3 66.2-217.7 157.7z"}}]})(props);
	};
	module.exports.IoMdRefreshCircle = function IoMdRefreshCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm112 194h-98l44.8-44.8C300.1 181.8 279.1 172 256 172c-46.2 0-84 37.8-84 84s37.8 84 84 84c34.9 0 65.3-21.2 77.6-52h29.8c-13.9 46.3-56.3 80-107.4 80-62.3 0-112-50.4-112-112s50.4-112 112-112c30.8 0 58.8 12.6 79.1 32.9L368 144v98z"}}]})(props);
	};
	module.exports.IoMdRefresh = function IoMdRefresh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 388c-72.597 0-132-59.405-132-132 0-72.601 59.403-132 132-132 36.3 0 69.299 15.4 92.406 39.601L278 234h154V80l-51.698 51.702C348.406 99.798 304.406 80 256 80c-96.797 0-176 79.203-176 176s78.094 176 176 176c81.045 0 148.287-54.134 169.401-128H378.85c-18.745 49.561-67.138 84-122.85 84z"}}]})(props);
	};
	module.exports.IoMdRemoveCircleOutline = function IoMdRemoveCircleOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422s-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256s17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"}},{"tag":"path","attr":{"d":"M363 277H149v-42h214v42z"}}]})(props);
	};
	module.exports.IoMdRemoveCircle = function IoMdRemoveCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.125 48 48 141.125 48 256s93.125 208 208 208 208-93.125 208-208S370.875 48 256 48zm107 229H149v-42h214v42z"}}]})(props);
	};
	module.exports.IoMdRemove = function IoMdRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 235h320v42H96z"}}]})(props);
	};
	module.exports.IoMdReorder = function IoMdReorder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 348h320v36H96zM96 128h320v36H96zM96 200.7h320v35.6H96zM96 275.8h320v35.6H96z"}}]})(props);
	};
	module.exports.IoMdRepeat = function IoMdRepeat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M149.3 152h213.3v62.4l85.3-83.2L362.7 48v62.4h-256v124.8h42.7V152zm213.4 208H149.3v-62.4L64 380.8l85.3 83.2v-62.4h256V276.8h-42.7V360z"}}]})(props);
	};
	module.exports.IoMdResize = function IoMdResize (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M297.6 48l64.9 64.9-249.6 249.6L48 297.6V464h166.4l-64.9-64.9 249.6-249.6 64.9 64.9V48z"}}]})(props);
	};
	module.exports.IoMdRestaurant = function IoMdRestaurant (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M164.852 279.939l61.834-60.251L73.72 71.706c-33.626 32.764-33.626 86.677 0 119.44l91.132 88.793z"}},{"tag":"path","attr":{"d":"M312.389 241.88c33.636 14.802 80.283 4.232 113.91-29.593 41.222-40.165 49.909-98.303 17.363-128.96-31.465-31.71-91.131-23.245-132.354 16.921-34.718 33.825-45.566 79.276-30.374 110.986-47.739 47.568-211.552 207.173-211.552 207.173L99.759 448l149.71-145.866L399.177 448l30.374-29.593-149.709-145.869 32.547-30.658z"}}]})(props);
	};
	module.exports.IoMdReturnLeft = function IoMdReturnLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432.8 136v96H122.3l84.4-86.2-33.2-33.8L32 256l141.5 144 33.2-33.8-84.4-86.2H480V136h-47.2z"}}]})(props);
	};
	module.exports.IoMdReturnRight = function IoMdReturnRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 136v144h357.7l-84.4 86.2 33.2 33.8L480 256 338.5 112l-33.2 33.8 84.4 86.2H79.2v-96H32z"}}]})(props);
	};
	module.exports.IoMdReverseCamera = function IoMdReverseCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440 96h-88l-32-32H192l-32 32H72c-22.1 0-40 17.9-40 40v272c0 22.1 17.9 40 40 40h368c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40zm-72 171h-97.7l44.8-45.1c-14.7-15.4-35.7-25.5-58.8-25.5-46.2 0-84 37.8-84 84s37.8 84 84 84c35.5 0 66.2-21.5 78.2-53.5h29.6c-13.4 47-56.2 81.5-107.8 81.5-62.3 0-112-50.4-112-112s50.4-112 112-112c30.8 0 58.7 12.6 79 32.9l32.8-32.9V267z"}}]})(props);
	};
	module.exports.IoMdRewind = function IoMdRewind (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M249.6 402V110L32 256l217.6 146zm12.8-146L480 402V110L262.4 256z"}}]})(props);
	};
	module.exports.IoMdRibbon = function IoMdRibbon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128S326.7 32 256 32zm0 208c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zM193.7 307.4c-19.1-8.1-36.2-19.6-50.8-34.3-1.4-1.4-2.8-2.8-4.1-4.3L64 400h96l48 80 48-105.8 25.5-56.2c-8.4 1.3-16.9 2-25.5 2-21.6 0-42.5-4.2-62.3-12.6zM373.3 268.9c-1.3 1.4-2.7 2.9-4.1 4.3-14.6 14.6-31.7 26.2-50.7 34.2L294 361.2l-21.9 48.4L304 480l48-80h96l-74.7-131.1z"}}]})(props);
	};
	module.exports.IoMdRocket = function IoMdRocket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 421.6c-18.1 0-33.2-6.8-42.9-10.9-5.4-2.3-11.3 1.8-10.9 7.6l3.5 51c.2 3.1 3.8 4.7 6.3 2.8l14.5-11c1.8-1.4 4.5-.9 5.7 1l20.5 32.1c1.5 2.4 5.1 2.4 6.6 0l20.5-32.1c1.2-1.9 3.9-2.4 5.7-1l14.5 11c2.5 1.9 6.1.3 6.3-2.8l3.5-51c.4-5.8-5.5-10-10.9-7.6-9.8 4.1-24.8 10.9-42.9 10.9z"}},{"tag":"path","attr":{"d":"M397.7 293.1l-48-49.1c0-158-93.2-228-93.2-228s-94.1 70-94.1 228l-48 49.1c-1.8 1.8-2.6 4.5-2.2 7.1L130.6 412c.9 5.7 7.1 8.5 11.8 5.4l67.1-45.4s20.7 20 47.1 20c26.4 0 46.1-20 46.1-20l67.1 45.4c4.6 3.1 10.8.3 11.8-5.4l18.5-111.9c.2-2.6-.6-5.2-2.4-7zM256.5 192c-17 0-30.7-14.3-30.7-32s13.8-32 30.7-32c17 0 30.7 14.3 30.7 32s-13.7 32-30.7 32z"}}]})(props);
	};
	module.exports.IoMdRose = function IoMdRose (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M260.6 214.8c23.8-40.9 48-71.6 91.4-96.4 8.3-4.8 21.2-8 22.8-8.9C290.7 83.7 256 32 256 32s-34.7 51.7-120.5 76.5c5.8 3.4 16.5 6.5 30.7 13.7 34.5 17.4 62.5 51.3 94.4 92.6zM246.3 253.4C186.7 161.2 131.4 126.8 48 126.8c54.2 78.6 52 174.6 52 215.4 0 76.1 69.8 137.8 156 137.8 57.6 0 107.9-27.6 135-68.7-35.5-27.6-85.1-65.7-144.7-157.9zM464 126.8s-55.2-2.3-85.2 15.4c-43 25.5-74.4 61.3-95.4 103.2 38.8 52 73 87.9 95.4 109.4 10.7 10.2 19.8 18.2 27.5 24.5 3.7-11.8 5.8-24.3 5.8-37.2-.1-40.8-17.4-114.1 51.9-215.3z"}}]})(props);
	};
	module.exports.IoMdSad = function IoMdSad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 288c-45.443 0-83.675 26.076-102.205 64h204.41c-18.53-37.924-56.762-64-102.205-64z"}},{"tag":"path","attr":{"d":"M256 48C140.563 48 48 141.6 48 256s92.563 208 208 208 208-93.6 208-208S370.401 48 256 48zm0 374.4c-91.518 0-166.404-74.883-166.404-166.4 0-91.518 74.887-166.4 166.404-166.4S422.404 164.482 422.404 256 347.518 422.4 256 422.4z"}},{"tag":"path","attr":{"d":"M328.8 235.2c17.683 0 31.201-13.518 31.201-31.2s-13.519-31.2-31.201-31.2c-17.682 0-31.2 13.518-31.2 31.2s13.518 31.2 31.2 31.2zM183.2 235.2c17.682 0 31.2-13.518 31.2-31.2s-13.519-31.2-31.2-31.2c-17.683 0-31.201 13.518-31.201 31.2s13.519 31.2 31.201 31.2z"}}]})(props);
	};
	module.exports.IoMdSave = function IoMdSave (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M362.7 64h-256C83 64 64 83.2 64 106.7v298.7c0 23.5 19 42.7 42.7 42.7h298.7c23.5 0 42.7-19.2 42.7-42.7v-256L362.7 64zM256 405.3c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64zM320 192H106.7v-85.3H320V192z"}}]})(props);
	};
	module.exports.IoMdSchool = function IoMdSchool (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M113.5 281.2v85.3L256 448l142.5-81.5v-85.3L256 362.7l-142.5-81.5zM256 64L32 192l224 128 183.3-104.7v147.4H480V192L256 64z"}}]})(props);
	};
	module.exports.IoMdSearch = function IoMdSearch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M337.509 305.372h-17.501l-6.571-5.486c20.791-25.232 33.922-57.054 33.922-93.257C347.358 127.632 283.896 64 205.135 64 127.452 64 64 127.632 64 206.629s63.452 142.628 142.225 142.628c35.011 0 67.831-13.167 92.991-34.008l6.561 5.487v17.551L415.18 448 448 415.086 337.509 305.372zm-131.284 0c-54.702 0-98.463-43.887-98.463-98.743 0-54.858 43.761-98.742 98.463-98.742 54.7 0 98.462 43.884 98.462 98.742 0 54.856-43.762 98.743-98.462 98.743z"}}]})(props);
	};
	module.exports.IoMdSend = function IoMdSend (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 448l416-192L48 64v149.333L346 256 48 298.667z"}}]})(props);
	};
	module.exports.IoMdSettings = function IoMdSettings (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M413.967 276.8c1.06-6.235 1.06-13.518 1.06-20.8s-1.06-13.518-1.06-20.8l44.667-34.318c4.26-3.118 5.319-8.317 2.13-13.518L418.215 115.6c-2.129-4.164-8.507-6.235-12.767-4.164l-53.186 20.801c-10.638-8.318-23.394-15.601-36.16-20.801l-7.448-55.117c-1.06-4.154-5.319-8.318-10.638-8.318h-85.098c-5.318 0-9.577 4.164-10.637 8.318l-8.508 55.117c-12.767 5.2-24.464 12.482-36.171 20.801l-53.186-20.801c-5.319-2.071-10.638 0-12.767 4.164L49.1 187.365c-2.119 4.153-1.061 10.399 2.129 13.518L96.97 235.2c0 7.282-1.06 13.518-1.06 20.8s1.06 13.518 1.06 20.8l-44.668 34.318c-4.26 3.118-5.318 8.317-2.13 13.518L92.721 396.4c2.13 4.164 8.508 6.235 12.767 4.164l53.187-20.801c10.637 8.318 23.394 15.601 36.16 20.801l8.508 55.117c1.069 5.2 5.318 8.318 10.637 8.318h85.098c5.319 0 9.578-4.164 10.638-8.318l8.518-55.117c12.757-5.2 24.464-12.482 36.16-20.801l53.187 20.801c5.318 2.071 10.637 0 12.767-4.164l42.549-71.765c2.129-4.153 1.06-10.399-2.13-13.518l-46.8-34.317zm-158.499 52c-41.489 0-74.46-32.235-74.46-72.8s32.971-72.8 74.46-72.8 74.461 32.235 74.461 72.8-32.972 72.8-74.461 72.8z"}}]})(props);
	};
	module.exports.IoMdShareAlt = function IoMdShareAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 248L288 96v85.334C138.666 202.667 85.333 309.334 64 416c53.333-74.666 117.333-108.802 224-108.802v87.469L448 248z"}}]})(props);
	};
	module.exports.IoMdShare = function IoMdShare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.822 344.427c-16.045 0-31.024 5.326-41.721 15.979l-152.957-88.42c1.071-5.328 2.142-9.593 2.142-14.919 0-5.328-1.071-9.593-2.142-14.919l150.826-87.35c11.762 10.653 26.741 17.041 43.852 17.041 35.295 0 64.178-28.766 64.178-63.92C448 72.767 419.117 44 383.822 44c-35.297 0-64.179 28.767-64.179 63.92 0 5.327 1.065 9.593 2.142 14.919l-150.821 87.35c-11.767-10.654-26.741-17.041-43.856-17.041-35.296 0-63.108 28.766-63.108 63.92 0 35.153 28.877 63.92 64.178 63.92 17.115 0 32.089-6.389 43.856-17.042l151.891 88.421c-1.076 4.255-2.141 8.521-2.141 13.847 0 34.094 27.806 61.787 62.037 61.787 34.229 0 62.036-27.693 62.036-61.787.001-34.094-27.805-61.787-62.035-61.787z"}}]})(props);
	};
	module.exports.IoMdShirt = function IoMdShirt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 64c-11.1 19.1-40.3 32-64 32s-52.9-12.9-64-32L64 96v96l77-16-13 272h256l-13-272 77 16V96L320 64z"}}]})(props);
	};
	module.exports.IoMdShuffle = function IoMdShuffle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M222.2 188.1L97.8 64 64 97.8l124.1 124.1 34.1-33.8zM316 64l49 49L64 414.2 97.8 448 399 147l49 49V64H316zm7.9 225.8l-33.8 33.8 75.1 75.1L316 448h132V316l-49 49-75.1-75.2z"}}]})(props);
	};
	module.exports.IoMdSkipBackward = function IoMdSkipBackward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M170.7 256L448 448V64L170.7 256zM64 64h64v384H64z"}}]})(props);
	};
	module.exports.IoMdSkipForward = function IoMdSkipForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 64v384l277.3-192L64 64zM384 64h64v384h-64z"}}]})(props);
	};
	module.exports.IoMdSnow = function IoMdSnow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.4 298.5l-8.3-30.9-88 23.6-60.4-34.9 60.4-34.9 88 23.6 8.3-30.9-57.1-15.3 57.7-33.3-24-41.5-56.6 32.7 15.3-57.1-30.9-8.3-23.6 88-62.2 35.9v-71.1l64.5-64.4-22.7-22.6L280 98.9V32h-48v65.6l-41.7-41.7-22.6 22.6 64.3 64.4v71.4l-60.7-35-23.6-88-30.9 8.3 15.3 57.1-57.7-33.4-24 41.6 56.7 32.7L50 212.9l8.3 30.9 87.9-23.6 62.6 36.1-62.6 36.2-87.9-23.6-8.3 30.9 57.1 15.3-56.7 32.7 24 41.5 57.7-33.3-15.3 57 30.9 8.3 23.6-87.9 60.7-35.1v70.9l-64.3 64.4 22.6 22.6 41.7-41.8V480h48v-66.8l41.9 41.7 22.5-22.6L280 368v-70.6l62.2 36 23.6 87.9 30.9-8.3-15.3-57 56.6 32.7 24-41.6-57.7-33.3z"}}]})(props);
	};
	module.exports.IoMdSpeedometer = function IoMdSpeedometer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 416h256v48H128zM256 288c17.7 0 32-14.3 32-32s-14.3-32-32-32c-3 0-6 .4-8.8 1.2l-66.7-48.7-4 3.5 48.9 66.7c-.9 2.9-1.4 6-1.4 9.3 0 17.7 14.3 32 32 32z"}},{"tag":"path","attr":{"d":"M256 48C141.1 48 48 141.1 48 256c0 48.3 16.5 92.7 44.1 128h58.8l4-4 22.1-22.1-22.9-22.9-22.1 22c-19.9-24.3-32.1-54-35.2-85H128v-32H96.8c3.1-31 15.3-60.7 35.2-85l22.1 22 22.9-22.9-22-22.1c24.3-19.9 54-32.1 85-35.2V128h32V96.8c31 3.1 60.7 15.3 85 35.2l-22 22.1 22.9 22.9 22.1-22c19.9 24.3 32.1 54 35.2 85H384v32h31.2c-3.1 31-15.3 60.7-35.2 85l-22.1-22-22.9 22.9 22.1 22.1 4 4h58.8c27.6-35.3 44.1-79.7 44.1-128 0-114.9-93.1-208-208-208z"}}]})(props);
	};
	module.exports.IoMdSquareOutline = function IoMdSquareOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.3 106.7v298.7H106.7V106.7h298.6m0-42.7H106.7C83.2 64 64 83.2 64 106.7v298.7c0 23.5 19.2 42.7 42.7 42.7h298.7c23.5 0 42.7-19.2 42.7-42.7V106.7C448 83.2 428.8 64 405.3 64z"}}]})(props);
	};
	module.exports.IoMdSquare = function IoMdSquare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.333 64H106.667C83.198 64 64 83.198 64 106.667v298.666C64 428.802 83.198 448 106.667 448h298.666C428.802 448 448 428.802 448 405.333V106.667C448 83.198 428.802 64 405.333 64z"}}]})(props);
	};
	module.exports.IoMdStarHalf = function IoMdStarHalf (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458 210.409l-145.267-12.476L256 64l-56.743 133.934L54 210.409l110.192 95.524L131.161 448 256 372.686 380.83 448l-33.021-142.066L458 210.409zM272.531 345.287L256 335.313l-.002-189.277 27.27 64.379 7.52 17.751 19.208 1.65 69.846 5.998-52.993 45.939-14.576 12.636 4.367 18.788 15.875 68.299-59.984-36.189z"}}]})(props);
	};
	module.exports.IoMdStarOutline = function IoMdStarOutline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458 210.409l-145.267-12.476L256 64l-56.743 133.934L54 210.409l110.192 95.524L131.161 448 256 372.686 380.83 448l-33.021-142.066L458 210.409zM272.531 345.286L256 335.312l-16.53 9.973-59.988 36.191 15.879-68.296 4.369-18.79-14.577-12.637-52.994-45.939 69.836-5.998 19.206-1.65 7.521-17.75 27.276-64.381 27.27 64.379 7.52 17.751 19.208 1.65 69.846 5.998-52.993 45.939-14.576 12.636 4.367 18.788 15.875 68.299-59.984-36.189z"}}]})(props);
	};
	module.exports.IoMdStar = function IoMdStar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 372.686L380.83 448l-33.021-142.066L458 210.409l-145.267-12.475L256 64l-56.743 133.934L54 210.409l110.192 95.525L131.161 448z"}}]})(props);
	};
	module.exports.IoMdStats = function IoMdStats (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M176 64h64v384h-64zM80 336h64v112H80zM272 272h64v176h-64zM368 176h64v272h-64z"}}]})(props);
	};
	module.exports.IoMdStopwatch = function IoMdStopwatch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M232 306.667h48V176h-48v130.667z"}},{"tag":"path","attr":{"d":"M407.67 170.271l30.786-30.786-33.942-33.941-30.785 30.786C341.217 111.057 300.369 96 256 96 149.961 96 64 181.961 64 288s85.961 192 192 192 192-85.961 192-192c0-44.369-15.057-85.217-40.33-117.729zm-45.604 223.795C333.734 422.398 296.066 438 256 438s-77.735-15.602-106.066-43.934C121.602 365.735 106 328.066 106 288s15.602-77.735 43.934-106.066C178.265 153.602 215.934 138 256 138s77.734 15.602 106.066 43.934C390.398 210.265 406 247.934 406 288s-15.602 77.735-43.934 106.066zM192 32h128v48H192z"}}]})(props);
	};
	module.exports.IoMdSubway = function IoMdSubway (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c-93.864 0-176 10.668-176 85.334v213.332c0 41.604 33.062 74.666 74.667 74.666L128 448v16h256v-16l-26.667-26.668c41.604 0 74.667-33.062 74.667-74.666V133.334C432 58.668 349.864 48 256 48zm-96 336c-18.136 0-32-13.865-32-32 0-18.137 13.864-32 32-32s32 13.863 32 32c0 18.135-13.864 32-32 32zm80-144H128v-96h112v96zm112 144c-18.136 0-32-13.865-32-32 0-18.137 13.864-32 32-32s32 13.863 32 32c0 18.135-13.864 32-32 32zm32-144H272v-96h112v96z"}}]})(props);
	};
	module.exports.IoMdSunny = function IoMdSunny (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M277.3 32h-42.7v64h42.7V32zm129.1 43.7L368 114.1l29.9 29.9 38.4-38.4-29.9-29.9zm-300.8 0l-29.9 29.9 38.4 38.4 29.9-29.9-38.4-38.4zM256 128c-70.4 0-128 57.6-128 128s57.6 128 128 128 128-57.6 128-128-57.6-128-128-128zm224 106.7h-64v42.7h64v-42.7zm-384 0H32v42.7h64v-42.7zM397.9 368L368 397.9l38.4 38.4 29.9-29.9-38.4-38.4zm-283.8 0l-38.4 38.4 29.9 29.9 38.4-38.4-29.9-29.9zm163.2 48h-42.7v64h42.7v-64z"}}]})(props);
	};
	module.exports.IoMdSwap = function IoMdSwap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M131.3 231.1L32 330.6l99.3 99.4v-74.6h174.5v-49.7H131.3v-74.6zM480 181.4L380.7 82v74.6H206.2v49.7h174.5v74.6l99.3-99.5z"}}]})(props);
	};
	module.exports.IoMdSwitch = function IoMdSwitch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M168 216h94.9c14.5 14.8 34.7 24 57.1 24 44.2 0 80-35.8 80-80s-35.8-80-80-80c-22.4 0-42.6 9.2-57.1 24H168c-30.8 0-56 25.2-56 56s25.2 56 56 56zm-16.9-72.9c4.6-4.6 10.6-7.1 16.9-7.1h75.7c-2.4 7.6-3.7 15.6-3.7 24s1.3 16.4 3.7 24H168c-6.3 0-12.4-2.5-16.9-7.1-4.6-4.6-7.1-10.6-7.1-16.9s2.5-12.4 7.1-16.9zM344 296h-94.9c-14.5-14.8-34.7-24-57.1-24-44.2 0-80 35.8-80 80s35.8 80 80 80c22.4 0 42.6-9.2 57.1-24H344c30.8 0 56-25.2 56-56s-25.2-56-56-56zm16.9 72.9c-4.6 4.6-10.6 7.1-16.9 7.1h-75.7c2.4-7.6 3.7-15.6 3.7-24s-1.3-16.4-3.7-24H344c6.3 0 12.4 2.5 16.9 7.1 4.6 4.6 7.1 10.6 7.1 16.9s-2.5 12.4-7.1 16.9z"}}]})(props);
	};
	module.exports.IoMdSync = function IoMdSync (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 93.09V32l-80 81.454 80 81.456v-61.093c65.996 0 120 54.982 120 122.183 0 20.363-5 39.714-14.004 57.016L391 342.547c15.996-25.457 25-54.988 25-86.547 0-89.599-72.002-162.91-160-162.91zm0 285.094c-66.001 0-120-54.988-120-122.184 0-20.363 5-39.709 13.999-57.02L121 169.454C104.999 193.89 96 224.436 96 256c0 89.599 72.002 162.91 160 162.91V480l80-81.453-80-81.457v61.094z"}}]})(props);
	};
	module.exports.IoMdTabletLandscape = function IoMdTabletLandscape (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 120v272c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H56c-13.3 0-24 10.7-24 24zm384 8v256H80V128h336zm46 128c0 7.7-6.5 14-14.1 14-7.5 0-14-6.2-14-14 0-7.7 6.4-14.1 14-14.1 7.6.1 14.1 6.4 14.1 14.1z"}}]})(props);
	};
	module.exports.IoMdTabletPortrait = function IoMdTabletPortrait (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M392 32H120c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24zm-8 384H128V80h256v336zm-128 46c-7.7 0-14-6.5-14-14.1 0-7.5 6.2-14 14-14 7.7 0 14.1 6.4 14.1 14-.1 7.6-6.4 14.1-14.1 14.1z"}}]})(props);
	};
	module.exports.IoMdTennisball = function IoMdTennisball (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.8 92.2C348.5 64.5 304.1 48 256 48c-48 0-92.3 16.5-127.6 44 41.6 44.8 64.3 103 64 164.3-.3 61-23.3 118.6-64.9 162.9 35.4 28 80.1 44.8 128.5 44.8 48.5 0 93.3-16.8 128.8-45-41.5-44.3-64.5-101.8-64.8-162.7-.3-61.2 22.3-119.3 63.8-164.1z"}},{"tag":"path","attr":{"d":"M353.1 255.1c0 26.9 5.1 53 15.1 77.8 9.6 23.6 23.3 44.9 40.8 63.6 34.1-37.1 55-86.5 55-140.5 0-54.5-21.2-104.2-55.8-141.4-17.1 18.5-30.6 39.6-40 62.7-10 24.8-15.1 51-15.1 77.8zM159.3 255.1c0-26.9-5.1-53-15.1-77.8-9.4-23.2-22.9-44.4-40.2-62.9-34.7 37.2-56 87-56 141.6 0 54.2 21 103.6 55.2 140.7 17.6-18.7 31.4-40.1 41-63.8 10-24.7 15.1-50.9 15.1-77.8z"}}]})(props);
	};
	module.exports.IoMdText = function IoMdText (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408 64H96c-22.002 0-32 17.998-32 40v344l64-64h280c22.002 0 40-17.998 40-40V104c0-22.002-17.998-40-40-40zM198.4 242H160v-40h38.4v40zm76.8 0h-38.4v-40h38.4v40zm76.8 0h-38.4v-40H352v40z"}}]})(props);
	};
	module.exports.IoMdThermometer = function IoMdThermometer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M303 300.2V78.4c0-25.7-21-46.5-47-46.5s-47 20.8-47 46.5v221.9c-29 16.5-48.9 47.8-48.9 83.7 0 53 43 96 96 96s96-43 96-96c0-36-20.1-67.3-49.1-83.8zM240 78.4c0-8 7.7-14.5 16-14.5s16 6.5 16 14.5V128h-32V78.4z"}}]})(props);
	};
	module.exports.IoMdThumbsDown = function IoMdThumbsDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M314 64H142c-15.7 0-28.6 9.6-34.2 23.4L50.6 222.8c-1.7 4.4-2.6 9-2.6 14v38.6c0 21.1 17 44.6 37.8 44.6h119.3l-18 81.5-.6 6c0 7.9 3.2 15.1 8.3 20.3l20 20.1L341 320.7c6.8-6.9 11-16.5 11-27.1v-192c0-21.1-17.2-37.6-38-37.6zM400 64h64v224h-64z"}}]})(props);
	};
	module.exports.IoMdThumbsUp = function IoMdThumbsUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M198 448h172c15.7 0 28.6-9.6 34.2-23.4l57.1-135.4c1.7-4.4 2.6-9 2.6-14v-38.6c0-21.1-17-44.6-37.8-44.6H306.9l18-81.5.6-6c0-7.9-3.2-15.1-8.3-20.3L297 64 171 191.3c-6.8 6.9-11 16.5-11 27.1v192c0 21.1 17.2 37.6 38 37.6zM48 224h64v224H48z"}}]})(props);
	};
	module.exports.IoMdThunderstorm = function IoMdThunderstorm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M393.2 161.2C380.5 96.6 323.9 48 256 48c-39.7 0-76 14-100.9 45.4 34.3 2.6 66.1 15.2 90.7 39.8 18.2 18.2 31 40.5 37.4 64.8h-33.5c-15.3-43.7-56-75-105.7-75-6 0-14.3.7-20.6 2C70 136 32 180.4 32 235.5 32 297.6 82.2 336 144 336h68V233h99.1l-33.2 67H311l-18 36h93.7c51.5 0 93.3-30 93.3-81.8 0-49.4-38.3-89.6-86.8-93zM212 368h22v96l59-128h-81z"}}]})(props);
	};
	module.exports.IoMdTime = function IoMdTime (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"g","attr":{"fillOpacity":".9"},"child":[{"tag":"path","attr":{"d":"M255.8 48C141 48 48 141.2 48 256s93 208 207.8 208c115 0 208.2-93.2 208.2-208S370.8 48 255.8 48zm.2 374.4c-91.9 0-166.4-74.5-166.4-166.4S164.1 89.6 256 89.6 422.4 164.1 422.4 256 347.9 422.4 256 422.4z"}},{"tag":"path","attr":{"d":"M266.4 152h-31.2v124.8l109.2 65.5 15.6-25.6-93.6-55.5V152z"}}]}]})(props);
	};
	module.exports.IoMdTimer = function IoMdTimer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M232.9 371.6c0 12.7 10.4 23.1 23.1 23.1s23.1-10.4 23.1-23.1c0-12.7-10.4-23.1-23.1-23.1s-23.1 10.3-23.1 23.1zm0-323.6v92.4h46.2V96.1c78.3 11.3 138.7 78.3 138.7 159.9 0 89.4-72.3 161.8-161.8 161.8S94.2 345.4 94.2 256c0-38.8 13.6-74.4 36.5-102.2L256 279.1l32.6-32.6L131.4 89.4v.5C80.8 127.7 48 187.8 48 256c0 114.9 92.9 208 208 208 114.9 0 208-93.1 208-208S370.9 48 256 48h-23.1zm161.8 208c0-12.7-10.4-23.1-23.1-23.1-12.7 0-23.1 10.4-23.1 23.1s10.4 23.1 23.1 23.1c12.7 0 23.1-10.4 23.1-23.1zm-277.4 0c0 12.7 10.4 23.1 23.1 23.1s23.1-10.4 23.1-23.1-10.4-23.1-23.1-23.1-23.1 10.4-23.1 23.1z"}}]})(props);
	};
	module.exports.IoMdToday = function IoMdToday (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.3 32H106.7C83.2 32 64 51.2 64 74.7v362.7c0 23.5 19.2 42.7 42.7 42.7h298.7c23.5 0 42.7-19.2 42.7-42.7V74.7C448 51.2 428.8 32 405.3 32zm-4 405.3H110.7c-2.2 0-4-1.8-4-4V78.7c0-2.2 1.8-4 4-4h290.7c2.2 0 4 1.8 4 4v354.7c-.1 2.1-1.9 3.9-4.1 3.9z"}},{"tag":"path","attr":{"d":"M145 194v204c0 1.1.9 2 2 2h218c1.1 0 2-.9 2-2V194c0-1.1-.9-2-2-2H147c-1.1 0-2 .9-2 2zM145 114.7v34c0 1.1.9 2 2 2h171c1.1 0 2-.9 2-2v-34c0-1.1-.9-2-2-2H147c-1.1 0-2 .9-2 2z"}}]})(props);
	};
	module.exports.IoMdTrain = function IoMdTrain (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c-88 0-176 10.9-176 87.6v208c0 42.3 34.5 76.6 77 76.6L124 453v11h49.1l44-43.8H300l44 43.8h44v-10.9l-33-32.8c42.5 0 77-34.4 77-76.6v-208C432 58.9 353.2 48 256 48zm-99 328.4c-18.3 0-33-14.7-33-32.8s14.7-32.8 33-32.8 33 14.7 33 32.8-14.7 32.8-33 32.8zm77-153.2H124v-87.6h110v87.6zm44 0v-87.6h110v87.6H278zm77 153.2c-18.3 0-33-14.7-33-32.8s14.7-32.8 33-32.8 33 14.7 33 32.8-14.7 32.8-33 32.8z"}}]})(props);
	};
	module.exports.IoMdTransgender = function IoMdTransgender (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 32v35h63.1l-81.4 80.5c-7.5-7.2-13.2-11-13.2-11C302.2 123.6 280 116 256 116c-30.2 0-57.6 12-77.8 31.4l-15.2-15 31.4-31.4-28.5-28.5-31.5 31.5-37.5-37H160V32H32v128h35V91.3l40.3 39.9-31.2 31.2 28.5 28.5 31.4-31.4 19.4 19.2c-7.3 14.9-11.5 31.7-11.5 49.5 0 54.8 39.5 100.4 91.1 110.2v45.3h-63V424h63v56h42v-56h63v-40.2h-63v-45.3c50.8-9.9 91.2-55.5 91.2-110.3 0-17.7-4.2-34.8-11.5-49.6L445 91.3V160h35V32H352zm-96 258c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"}}]})(props);
	};
	module.exports.IoMdTrash = function IoMdTrash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 405.429C128 428.846 147.198 448 170.667 448h170.667C364.802 448 384 428.846 384 405.429V160H128v245.429zM416 96h-80l-26.785-32H202.786L176 96H96v32h320V96z"}}]})(props);
	};
	module.exports.IoMdTrendingDown = function IoMdTrendingDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 397V262.5l-51.3 51.3-141.1-141-89.6 89.7L63.6 128 32 159.6l166 166.3 89.6-89.7 109.3 109.4-51.3 51.4H480z"}}]})(props);
	};
	module.exports.IoMdTrendingUp = function IoMdTrendingUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M345.6 128l51.3 51.3-109.3 109.4-89.6-89.6L32 365.4 63.6 397 198 262.5l89.6 89.7 141.1-141 51.3 51.3V128H345.6z"}}]})(props);
	};
	module.exports.IoMdTrophy = function IoMdTrophy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M392 105c.9-27 .2-56 .1-57H119.3c0 1-.8 30 .1 57H48c0 68 9.9 102.3 21 126.7S95.4 277 127.7 302c30.1 23.3 95.5 53.6 104.3 57.6v28.3c-4.6 10-23.5 28.2-83.3 28.2H128v48h256v-48h-25.7c-60.7 0-75-19.1-78.3-28.2v-28.3c9.3-4.6 80.9-40.3 104.4-57.5 25.2-18.4 50.9-51.5 58.7-70.3S464 167 464 105h-72zM109.6 211.9c-8.8-18.2-14-37.9-15.7-61.9h28.7c.7 6 1.4 11.3 2.3 16.3 6.6 39.2 14.8 70.2 25.7 96.5-17.3-13.5-31.3-30.8-41-50.9zm292.8 0c-9.9 20.3-24 37.7-41.6 51.3 11-26.2 19-56.8 25.8-96.9.8-5 1.6-10.3 2.3-16.3h29.3c-1.8 24-6.9 43.7-15.8 61.9z"}}]})(props);
	};
	module.exports.IoMdTv = function IoMdTv (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M439.3 76H72.7C50.3 76 32 94 32 116v240c0 22 18.3 40 40.7 40h101.8v40h162.9v-40h101.8c22.4 0 40.5-18 40.5-40l.2-240c.1-22-18.2-40-40.6-40zm0 280H72.7V116h366.5v240z"}}]})(props);
	};
	module.exports.IoMdUmbrella = function IoMdUmbrella (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M410.1 244.1c12 0 26.6 10.9 33.8 25.9H464c-.3-50-21.2-101.5-59.4-140.9-36.3-37.4-83-60.5-132.6-65.7-3-9-11.5-15.4-21.6-15.4-10 0-18.5 6.5-21.5 15.3C125.3 73.8 48 159.7 48 266.2c0 1.1.1 1.8.4 3.8h21.8c6.8-15 22.2-25.9 35.3-25.9 17 0 31.5 10.9 36.5 25.9h19.8c4.1-15 16.9-25.7 33-25.7 17.8 0 33.1 14.5 34.1 32.6v118.3c0 9.3.1 24.1-13.4 24.1-6.9 0-16.6-1.8-16.6-16V382h-43v21.3c0 34.6 23.6 60.7 60 60.7 19.5 0 33.3-8.5 43.5-18.7 13.1-13.2 13.5-34.7 13.5-50.1V276.1c2-25.8 23.9-31.7 41.9-31.7 17.2 0 32.3 11.6 37.8 25.6h20.5c5.1-15 19.8-25.9 37-25.9z"}}]})(props);
	};
	module.exports.IoMdUndo = function IoMdUndo (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M262.3 179.6c-57.9 0-110.3 21.6-150.7 56.8L32 160v192h197.5l-79.1-76.8c30.4-25.3 69-41.1 111.8-41.1 77.3 0 143.1 48.2 166 117.8l51.8-14.8c-30.4-91.4-116.2-157.5-217.7-157.5z"}}]})(props);
	};
	module.exports.IoMdUnlock = function IoMdUnlock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376 186h-20v-40c0-55-45-100-100-100S156 91 156 146h37.998c0-34.004 28.003-62.002 62.002-62.002 34.004 0 62.002 27.998 62.002 62.002H318v40H136c-22.002 0-40 17.998-40 40v200c0 22.002 17.998 40 40 40h240c22.002 0 40-17.998 40-40V226c0-22.002-17.998-40-40-40zM256 368c-22.002 0-40-17.998-40-40s17.998-40 40-40 40 17.998 40 40-17.998 40-40 40z"}}]})(props);
	};
	module.exports.IoMdVideocam = function IoMdVideocam (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M384 219.5v-85.2c0-13.4-11.2-24.3-24.9-24.3H56.9C43.2 110 32 120.9 32 134.3v243.3C32 391 43.2 402 56.9 402h302.2c13.7 0 24.9-11 24.9-24.3v-85.2l96 97.3V122.2l-96 97.3z"}}]})(props);
	};
	module.exports.IoMdVolumeHigh = function IoMdVolumeHigh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 192v128h85.334L256 431.543V80.458L149.334 192H64zm288 64c0-38.399-21.333-72.407-53.333-88.863v176.636C330.667 328.408 352 294.4 352 256zM298.667 64v44.978C360.531 127.632 405.334 186.882 405.334 256c0 69.119-44.803 128.369-106.667 147.022V448C384 428.254 448 349.257 448 256c0-93.256-64-172.254-149.333-192z"}}]})(props);
	};
	module.exports.IoMdVolumeLow = function IoMdVolumeLow (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 192v128h85.334L256 431.543V80.458L149.334 192H64zm288 64c0-38.399-21.333-72.407-53.333-88.863v176.636C330.667 328.408 352 294.4 352 256z"}}]})(props);
	};
	module.exports.IoMdVolumeMute = function IoMdVolumeMute (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 192v128h85.334L256 431.543V80.458L149.334 192H64z"}}]})(props);
	};
	module.exports.IoMdVolumeOff = function IoMdVolumeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405.5 256c0 22.717-4.883 44.362-13.603 63.855l31.88 31.88C439.283 323.33 448 290.653 448 256c0-93.256-64-172.254-149-192v44.978C361 127.632 405.5 186.882 405.5 256zM256 80.458l-51.021 52.48L256 183.957zM420.842 396.885L91.116 67.157l-24 24 90.499 90.413-8.28 10.43H64v128h85.334L256 431.543V280l94.915 94.686C335.795 387.443 318 397.213 299 403.022V448c31-7.172 58.996-22.163 82.315-42.809l39.61 39.693 24-24.043-24.002-24.039-.081.083z"}},{"tag":"path","attr":{"d":"M352.188 256c0-38.399-21.188-72.407-53.188-88.863v59.82l50.801 50.801A100.596 100.596 0 0 0 352.188 256z"}}]})(props);
	};
	module.exports.IoMdWalk = function IoMdWalk (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 112c22.223 0 39.997-17.776 39.997-40 0-22.225-17.774-40-39.997-40s-40.003 17.775-40.003 40c0 22.224 17.78 40 40.003 40zM288 232h104v-40h-72l-44.802-69.333c-7.698-11.667-18.136-18.136-30.933-18.136-3.198 0-8.828.531-12.799 1.747L120 144v112h40v-80l40.531-16L120 480h40l56.698-164.271L267 384v96h38V352l-57.031-96 19.745-61.864L288 232z"}}]})(props);
	};
	module.exports.IoMdWallet = function IoMdWallet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M202.7 341.3V170.7c0-23.5 19-42.7 42.7-42.7h197v-21.3c0-23.5-18.9-42.7-42.3-42.7H92c-23.7 0-44 18.5-44 42v300c0 23.5 20.3 42 44 42h308c23.5 0 42.3-19.2 42.3-42.7V384h-197c-23.6 0-42.6-19.2-42.6-42.7z"}},{"tag":"path","attr":{"d":"M245 186v140c0 8.8 7.2 16 16 16h187c8.8 0 16-7.2 16-16V186c0-8.8-7.2-16-16-16H261c-8.8 0-16 7.2-16 16zm77.1 101.9c-19.3 1.2-35.2-14.7-34-34 1-15.9 13.9-28.8 29.9-29.9 19.3-1.2 35.2 14.7 34 34-1.1 16-14 28.9-29.9 29.9z"}}]})(props);
	};
	module.exports.IoMdWarning = function IoMdWarning (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 464h448L256 48 32 464zm248-64h-48v-48h48v48zm0-80h-48v-96h48v96z"}}]})(props);
	};
	module.exports.IoMdWatch = function IoMdWatch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 256c0-51.001-24.004-96.001-60.996-125L336 16H176l-19.004 115C120.004 159.999 96 204.999 96 256c0 50.996 24.004 95.996 60.996 125L176 496h160l19.004-115C391.996 351.996 416 306.996 416 256zm-280 0c0-66.001 54.004-120 120-120s120 53.999 120 120c0 65.996-54.004 120-120 120s-120-54.004-120-120z"}}]})(props);
	};
	module.exports.IoMdWater = function IoMdWater (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M380.5 163.3L256 32 131.5 163.3c-68.6 72.4-68.6 190 0 262.4C165.8 461.9 210.9 480 256 480s90.2-18.1 124.5-54.3c68.7-72.4 68.7-190 0-262.4z"}}]})(props);
	};
	module.exports.IoMdWifi = function IoMdWifi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 228.719c-22.879 0-41.597 18.529-41.597 41.18 0 22.652 18.718 41.182 41.597 41.182 22.878 0 41.597-18.529 41.597-41.182 0-22.651-18.719-41.18-41.597-41.18zm124.8 41.179c0-67.946-56.163-123.539-124.8-123.539s-124.8 55.593-124.8 123.539c0 45.303 24.961 85.447 62.396 107.072l20.807-36.032c-24.972-14.417-41.604-40.153-41.604-71.04 0-45.295 37.433-82.358 83.201-82.358 45.771 0 83.201 37.063 83.201 82.358 0 30.887-16.633 56.623-41.604 71.04l20.807 36.032c37.433-21.624 62.396-61.769 62.396-107.072zM256 64C141.597 64 48 156.654 48 269.898 48 346.085 89.592 411.968 152 448l20.799-36.032c-49.919-28.824-83.207-81.324-83.207-142.069 0-90.593 74.891-164.718 166.408-164.718 91.517 0 166.406 74.125 166.406 164.718 0 60.745-33.284 114.271-83.205 142.069L360 448c62.406-36.032 104-101.915 104-178.102C464 156.654 370.403 64 256 64z"}}]})(props);
	};
	module.exports.IoMdWine = function IoMdWine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M234.667 277.333V408H128v40h256v-40H277.333V277.333L448 106.667V64H64v42.667l170.667 170.666zm-74.667-128l-42.667-42.666h277.334L352 149.333H160z"}}]})(props);
	};
	module.exports.IoMdWoman = function IoMdWoman (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M190.4 148.6L161 252.9c-6.3 22.8 20.7 31.7 27.3 10.3l26.3-96.2h7.4l-45.2 169H219v127c0 23 32 23 32 0V336h10v127c0 23 31 23 31 0V336h43.4l-46.2-169h8.4l26.3 96.2c6.5 21.9 33.3 12.5 27.3-10.2l-29.4-104.4c-4-11.8-18.2-32.6-42-33.6h-47.3c-24.6 1-38.7 21.6-42.1 33.6zM292.6 69.2c0-20.6-16.4-37.3-36.6-37.3-20.2 0-36.6 16.7-36.6 37.3 0 20.6 16.4 37.3 36.6 37.3 20.2 0 36.6-16.7 36.6-37.3z"}}]})(props);
	};


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.IconContext = exports.DefaultContext = void 0;
	var React = __webpack_require__(1);
	exports.DefaultContext = {
	    color: undefined,
	    size: undefined,
	    className: undefined,
	    style: undefined,
	    attr: undefined,
	};
	exports.IconContext = React.createContext && React.createContext(exports.DefaultContext);


/***/ },
/* 408 */
[1184, 963],
/* 409 */
[1185, 965],
/* 410 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	
	var _warning = __webpack_require__(458);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _safeHTMLElement = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  if (globalElement) {
	    if (globalElement.removeAttribute) {
	      globalElement.removeAttribute("aria-hidden");
	    } else if (globalElement.length != null) {
	      globalElement.forEach(function (element) {
	        return element.removeAttribute("aria-hidden");
	      });
	    } else {
	      document.querySelectorAll(globalElement).forEach(function (element) {
	        return element.removeAttribute("aria-hidden");
	      });
	    }
	  }
	  globalElement = null;
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    var check = globalElement || {};
	    console.log("ariaAppHider ----------");
	    console.log(check.nodeName, check.className, check.id);
	    console.log("end ariaAppHider ----------");
	  }
	}
	/* eslint-enable no-console */
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  var el = appElement || globalElement;
	  if (el) {
	    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
	  } else {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return [];
	  }
	}
	
	function hide(appElement) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var el = _step.value;
	
	      el.setAttribute("aria-hidden", "true");
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	function show(appElement) {
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var el = _step2.value;
	
	      el.removeAttribute("aria-hidden");
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.log = log;
	exports.resetState = resetState;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Tracks portals that are open and emits events to subscribers
	
	var PortalOpenInstances = function PortalOpenInstances() {
	  var _this = this;
	
	  _classCallCheck(this, PortalOpenInstances);
	
	  this.register = function (openInstance) {
	    if (_this.openInstances.indexOf(openInstance) !== -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Cannot register modal instance that's already open");
	      }
	      return;
	    }
	    _this.openInstances.push(openInstance);
	    _this.emit("register");
	  };
	
	  this.deregister = function (openInstance) {
	    var index = _this.openInstances.indexOf(openInstance);
	    if (index === -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
	      }
	      return;
	    }
	    _this.openInstances.splice(index, 1);
	    _this.emit("deregister");
	  };
	
	  this.subscribe = function (callback) {
	    _this.subscribers.push(callback);
	  };
	
	  this.emit = function (eventType) {
	    _this.subscribers.forEach(function (subscriber) {
	      return subscriber(eventType,
	      // shallow copy to avoid accidental mutation
	      _this.openInstances.slice());
	    });
	  };
	
	  this.openInstances = [];
	  this.subscribers = [];
	};
	
	var portalOpenInstances = new PortalOpenInstances();
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function log() {
	  console.log("portalOpenInstances ----------");
	  console.log(portalOpenInstances.openInstances.length);
	  portalOpenInstances.openInstances.forEach(function (p) {
	    return console.log(p);
	  });
	  console.log("end portalOpenInstances ----------");
	}
	
	/* istanbul ignore next */
	function resetState() {
	  portalOpenInstances = new PortalOpenInstances();
	}
	/* eslint-enable no-console */
	
	exports.default = portalOpenInstances;

/***/ },
/* 413 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var DISPLAY_NONE = "none";
	var DISPLAY_CONTENTS = "contents";
	
	var tabbableNode = /input|select|textarea|button|object|iframe/;
	
	function isNotOverflowing(element, style) {
	  return style.getPropertyValue("overflow") !== "visible" ||
	  // if 'overflow: visible' set, check if there is actually any overflow
	  element.scrollWidth <= 0 && element.scrollHeight <= 0;
	}
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  try {
	    // Otherwise we need to check some styles
	    var style = window.getComputedStyle(element);
	    var displayValue = style.getPropertyValue("display");
	    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
	  } catch (exception) {
	    // eslint-disable-next-line no-console
	    console.warn("Failed to inspect element style");
	    return false;
	  }
	}
	
	function visible(element) {
	  var parentElement = element;
	  var rootNode = element.getRootNode && element.getRootNode();
	  while (parentElement) {
	    if (parentElement === document.body) break;
	
	    // if we are not hidden yet, skip to checking outside the Web Component
	    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
	
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
	    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
	  }, []);
	  return descendants.filter(tabbable);
	}
	module.exports = exports["default"];

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usePopper = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(55));
	
	var _core = __webpack_require__(468);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(400));
	
	var _utils = __webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var EMPTY_MODIFIERS = [];
	
	var usePopper = function usePopper(referenceElement, popperElement, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var prevOptions = React.useRef(null);
	  var optionsWithDefaults = {
	    onFirstUpdate: options.onFirstUpdate,
	    placement: options.placement || 'bottom',
	    strategy: options.strategy || 'absolute',
	    modifiers: options.modifiers || EMPTY_MODIFIERS
	  };
	
	  var _React$useState = React.useState({
	    styles: {
	      popper: {
	        position: optionsWithDefaults.strategy,
	        left: '0',
	        top: '0'
	      },
	      arrow: {
	        position: 'absolute'
	      }
	    },
	    attributes: {}
	  }),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  var updateStateModifier = React.useMemo(function () {
	    return {
	      name: 'updateState',
	      enabled: true,
	      phase: 'write',
	      fn: function fn(_ref) {
	        var state = _ref.state;
	        var elements = Object.keys(state.elements);
	        ReactDOM.flushSync(function () {
	          setState({
	            styles: (0, _utils.fromEntries)(elements.map(function (element) {
	              return [element, state.styles[element] || {}];
	            })),
	            attributes: (0, _utils.fromEntries)(elements.map(function (element) {
	              return [element, state.attributes[element]];
	            }))
	          });
	        });
	      },
	      requires: ['computeStyles']
	    };
	  }, []);
	  var popperOptions = React.useMemo(function () {
	    var newOptions = {
	      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
	      placement: optionsWithDefaults.placement,
	      strategy: optionsWithDefaults.strategy,
	      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
	        name: 'applyStyles',
	        enabled: false
	      }])
	    };
	
	    if ((0, _reactFastCompare["default"])(prevOptions.current, newOptions)) {
	      return prevOptions.current || newOptions;
	    } else {
	      prevOptions.current = newOptions;
	      return newOptions;
	    }
	  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
	  var popperInstanceRef = React.useRef();
	  (0, _utils.useIsomorphicLayoutEffect)(function () {
	    if (popperInstanceRef.current) {
	      popperInstanceRef.current.setOptions(popperOptions);
	    }
	  }, [popperOptions]);
	  (0, _utils.useIsomorphicLayoutEffect)(function () {
	    if (referenceElement == null || popperElement == null) {
	      return;
	    }
	
	    var createPopper = options.createPopper || _core.createPopper;
	    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
	    popperInstanceRef.current = popperInstance;
	    return function () {
	      popperInstance.destroy();
	      popperInstanceRef.current = null;
	    };
	  }, [referenceElement, popperElement, options.createPopper]);
	  return {
	    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
	    styles: state.styles,
	    attributes: state.attributes,
	    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
	    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
	  };
	};
	
	exports.usePopper = usePopper;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	var _interopRequireWildcard = __webpack_require__(69)["default"];
	
	exports.__esModule = true;
	exports["default"] = connectAdvanced;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(68));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(94));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(242));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(992);
	
	var _Subscription = __webpack_require__(166);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(167);
	
	var _Context = __webpack_require__(77);
	
	var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
	    _excluded2 = ["reactReduxForwardedRef"];
	// Define some constant arrays just to avoid re-creating these
	var EMPTY_ARRAY = [];
	var NO_SUBSCRIPTION_ARRAY = [null, null];
	
	var stringifyComponent = function stringifyComponent(Comp) {
	  try {
	    return JSON.stringify(Comp);
	  } catch (err) {
	    return String(Comp);
	  }
	};
	
	function storeStateUpdatesReducer(state, action) {
	  var updateCount = state[1];
	  return [action.payload, updateCount + 1];
	}
	
	function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    return effectFunc.apply(void 0, effectArgs);
	  }, dependencies);
	}
	
	function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
	  // We want to capture the wrapper props and child props we used for later comparisons
	  lastWrapperProps.current = wrapperProps;
	  lastChildProps.current = actualChildProps;
	  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
	
	  if (childPropsFromStoreUpdate.current) {
	    childPropsFromStoreUpdate.current = null;
	    notifyNestedSubs();
	  }
	}
	
	function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
	  // If we're not subscribed to the store, nothing to do here
	  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
	
	  var didUnsubscribe = false;
	  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
	
	  var checkForUpdates = function checkForUpdates() {
	    if (didUnsubscribe) {
	      // Don't run stale listeners.
	      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
	      return;
	    }
	
	    var latestStoreState = store.getState();
	    var newChildProps, error;
	
	    try {
	      // Actually run the selector with the most recent store state and wrapper props
	      // to determine what the child props should be
	      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
	    } catch (e) {
	      error = e;
	      lastThrownError = e;
	    }
	
	    if (!error) {
	      lastThrownError = null;
	    } // If the child props haven't changed, nothing to do here - cascade the subscription update
	
	
	    if (newChildProps === lastChildProps.current) {
	      if (!renderIsScheduled.current) {
	        notifyNestedSubs();
	      }
	    } else {
	      // Save references to the new child props.  Note that we track the "child props from store update"
	      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
	      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
	      // forcing another re-render, which we don't want.
	      lastChildProps.current = newChildProps;
	      childPropsFromStoreUpdate.current = newChildProps;
	      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
	
	      forceComponentUpdateDispatch({
	        type: 'STORE_UPDATED',
	        payload: {
	          error: error
	        }
	      });
	    }
	  }; // Actually subscribe to the nearest connected ancestor (or store)
	
	
	  subscription.onStateChange = checkForUpdates;
	  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
	  // changed since we began.
	
	  checkForUpdates();
	
	  var unsubscribeWrapper = function unsubscribeWrapper() {
	    didUnsubscribe = true;
	    subscription.tryUnsubscribe();
	    subscription.onStateChange = null;
	
	    if (lastThrownError) {
	      // It's possible that we caught an error due to a bad mapState function, but the
	      // parent re-rendered without this component and we're about to unmount.
	      // This shouldn't happen as long as we do top-down subscriptions correctly, but
	      // if we ever do those wrong, this throw will surface the error in our tests.
	      // In that case, throw the error from here so it doesn't get lost.
	      throw lastThrownError;
	    }
	  };
	
	  return unsubscribeWrapper;
	}
	
	var initStateUpdates = function initStateUpdates() {
	  return [null, 0];
	};
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	      export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      _ref2$forwardRef = _ref2.forwardRef,
	      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
	      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
	
	  if (false) {
	    if (renderCountProp !== undefined) {
	      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
	    }
	
	    if (withRef) {
	      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
	    }
	
	    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
	
	    if (storeKey !== 'store') {
	      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
	    }
	  }
	
	  var Context = context;
	  return function wrapWithConnect(WrappedComponent) {
	    if (false) {
	      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
	    }
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	    var pure = connectOptions.pure;
	
	    function createChildSelector(store) {
	      return selectorFactory(store.dispatch, selectorFactoryOptions);
	    } // If we aren't running in "pure" mode, we don't want to memoize values.
	    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
	    // that just executes the given callback immediately.
	
	
	    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
	      return callback();
	    };
	
	    function ConnectFunction(props) {
	      var _useMemo = (0, _react.useMemo)(function () {
	        // Distinguish between actual "data" props that were passed to the wrapper component,
	        // and values needed to control behavior (forwarded refs, alternate context instances).
	        // To maintain the wrapperProps object reference, memoize this destructuring.
	        var reactReduxForwardedRef = props.reactReduxForwardedRef,
	            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded2);
	        return [props.context, reactReduxForwardedRef, wrapperProps];
	      }, [props]),
	          propsContext = _useMemo[0],
	          reactReduxForwardedRef = _useMemo[1],
	          wrapperProps = _useMemo[2];
	
	      var ContextToUse = (0, _react.useMemo)(function () {
	        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
	        // Memoize the check that determines which context instance we should use.
	        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)( /*#__PURE__*/_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
	      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available
	
	      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
	      // We'll check to see if it _looks_ like a Redux store first.
	      // This allows us to pass through a `store` prop that is just a plain value.
	
	      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
	      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
	
	      if (false) {
	        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
	      } // Based on the previous check, one of these must be true
	
	
	      var store = didStoreComeFromProps ? props.store : contextValue.store;
	      var childPropsSelector = (0, _react.useMemo)(function () {
	        // The child props selector needs the store reference as an input.
	        // Re-create this selector whenever the store changes.
	        return createChildSelector(store);
	      }, [store]);
	
	      var _useMemo2 = (0, _react.useMemo)(function () {
	        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var subscription = (0, _Subscription.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
	        return [subscription, notifyNestedSubs];
	      }, [store, didStoreComeFromProps, contextValue]),
	          subscription = _useMemo2[0],
	          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
	      // and memoize that value to avoid unnecessary context updates.
	
	
	      var overriddenContextValue = (0, _react.useMemo)(function () {
	        if (didStoreComeFromProps) {
	          // This component is directly subscribed to a store from props.
	          // We don't want descendants reading from this store - pass down whatever
	          // the existing context value is from the nearest connected ancestor.
	          return contextValue;
	        } // Otherwise, put this component's subscription instance into context, so that
	        // connected descendants won't update until after this component is done
	
	
	        return (0, _extends2["default"])({}, contextValue, {
	          subscription: subscription
	        });
	      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
	      // causes a change to the calculated child component props (or we caught an error in mapState)
	
	      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
	          _useReducer$ = _useReducer[0],
	          previousStateUpdateResult = _useReducer$[0],
	          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
	
	
	      if (previousStateUpdateResult && previousStateUpdateResult.error) {
	        throw previousStateUpdateResult.error;
	      } // Set up refs to coordinate values between the subscription effect and the render logic
	
	
	      var lastChildProps = (0, _react.useRef)();
	      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
	      var childPropsFromStoreUpdate = (0, _react.useRef)();
	      var renderIsScheduled = (0, _react.useRef)(false);
	      var actualChildProps = usePureOnlyMemo(function () {
	        // Tricky logic here:
	        // - This render may have been triggered by a Redux store update that produced new child props
	        // - However, we may have gotten new wrapper props after that
	        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
	        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
	        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
	        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
	          return childPropsFromStoreUpdate.current;
	        } // TODO We're reading the store directly in render() here. Bad idea?
	        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
	        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
	        // to determine what the child props should be.
	
	
	        return childPropsSelector(store.getState(), wrapperProps);
	      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
	      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
	      // just useEffect instead to avoid the warning, since neither will run anyway.
	
	      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes
	
	      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
	      // We memoize the elements for the rendered child component as an optimization.
	
	      var renderedWrappedComponent = (0, _react.useMemo)(function () {
	        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
	          ref: reactReduxForwardedRef
	        }));
	      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
	      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
	
	      var renderedChild = (0, _react.useMemo)(function () {
	        if (shouldHandleStateChanges) {
	          // If this component is subscribed to store updates, we need to pass its own
	          // subscription instance down to our descendants. That means rendering the same
	          // Context instance, and putting a different value into the context.
	          return /*#__PURE__*/_react["default"].createElement(ContextToUse.Provider, {
	            value: overriddenContextValue
	          }, renderedWrappedComponent);
	        }
	
	        return renderedWrappedComponent;
	      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
	      return renderedChild;
	    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
	
	
	    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = ConnectFunction.displayName = displayName;
	
	    if (forwardRef) {
	      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
	        return /*#__PURE__*/_react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
	          reactReduxForwardedRef: ref
	        }));
	      });
	
	      forwarded.displayName = displayName;
	      forwarded.WrappedComponent = WrappedComponent;
	      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
	    }
	
	    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(421));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	//
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	//
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject["default"])(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useReduxContext = useReduxContext;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(77);
	
	/**
	 * A hook to access the value of the `ReactReduxContext`. This is a low-level
	 * hook that you should usually not need to call directly.
	 *
	 * @returns {any} the value of the `ReactReduxContext`
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useReduxContext } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const { store } = useReduxContext()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	function useReduxContext() {
	  var contextValue = (0, _react.useContext)(_Context.ReactReduxContext);
	
	  if (false) {
	    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
	  }
	
	  return contextValue;
	}

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createStoreHook = createStoreHook;
	exports.useStore = void 0;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(77);
	
	var _useReduxContext2 = __webpack_require__(417);
	
	/**
	 * Hook factory, which creates a `useStore` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useStore` hook bound to the specified context.
	 */
	function createStoreHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useStore() {
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store;
	
	    return store;
	  };
	}
	/**
	 * A hook to access the redux store.
	 *
	 * @returns {any} the redux store
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useStore } from 'react-redux'
	 *
	 * export const ExampleComponent = () => {
	 *   const store = useStore()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	
	
	var useStore = /*#__PURE__*/createStoreHook();
	exports.useStore = useStore;

/***/ },
/* 419 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.setBatch = exports.getBatch = void 0;
	
	// Default to a dummy "batch" implementation that just runs the callback
	function defaultNoopBatch(callback) {
	  callback();
	}
	
	var batch = defaultNoopBatch; // Allow injecting another batching function later
	
	var setBatch = function setBatch(newBatch) {
	  return batch = newBatch;
	}; // Supply a getter just to skip dealing with ESM bindings
	
	
	exports.setBatch = setBatch;
	
	var getBatch = function getBatch() {
	  return batch;
	};
	
	exports.getBatch = getBatch;

/***/ },
/* 420 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(989));
	
	var _warning = _interopRequireDefault(__webpack_require__(422));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject["default"])(value)) {
	    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 422 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(169));
	
	var _ChildMapping = __webpack_require__(1008);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	/**
	 * The `<TransitionGroup>` component manages a set of transition components
	 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	 * components, `<TransitionGroup>` is a state machine for managing the mounting
	 * and unmounting of components over time.
	 *
	 * Consider the example below. As items are removed or added to the TodoList the
	 * `in` prop is toggled automatically by the `<TransitionGroup>`.
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual transition
	 * component. This means you can mix and match animations across different list
	 * items.
	 */
	
	var TransitionGroup = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  } // node is `undefined` when user provided `nodeRef` prop
	  ;
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, /*#__PURE__*/_react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	var _default = TransitionGroup;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 424 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  disabled: false
	};
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 426 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.forceReflow = void 0;
	
	var forceReflow = function forceReflow(node) {
	  return node.scrollTop;
	};
	
	exports.forceReflow = forceReflow;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(127);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(433);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(170);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(171);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(127);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(52);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(1013);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(52);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ },
/* 433 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = defaultCellRangeRenderer;
	
	var _types = __webpack_require__(67);
	
	/**
	 * Default implementation of cellRangeRenderer used by Grid.
	 * This renderer supports cell-caching while the user is scrolling.
	 */
	function defaultCellRangeRenderer(_ref) {
	  var cellCache = _ref.cellCache,
	      cellRenderer = _ref.cellRenderer,
	      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
	      columnStartIndex = _ref.columnStartIndex,
	      columnStopIndex = _ref.columnStopIndex,
	      deferredMeasurementCache = _ref.deferredMeasurementCache,
	      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
	      isScrolling = _ref.isScrolling,
	      isScrollingOptOut = _ref.isScrollingOptOut,
	      parent = _ref.parent,
	      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
	      rowStartIndex = _ref.rowStartIndex,
	      rowStopIndex = _ref.rowStopIndex,
	      styleCache = _ref.styleCache,
	      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
	      visibleColumnIndices = _ref.visibleColumnIndices,
	      visibleRowIndices = _ref.visibleRowIndices;
	  var renderedCells = []; // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
	  // User cannot scroll beyond these size limitations.
	  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
	  // We should never cache styles for compressed offsets though as this can lead to bugs.
	  // See issue #576 for more.
	
	  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
	  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
	
	  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
	    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
	
	    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
	      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
	      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
	      var key = "".concat(rowIndex, "-").concat(columnIndex);
	      var style = void 0; // Cache style objects so shallow-compare doesn't re-render unnecessarily.
	
	      if (canCacheStyle && styleCache[key]) {
	        style = styleCache[key];
	      } else {
	        // In deferred mode, cells will be initially rendered before we know their size.
	        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
	        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
	          // Position not-yet-measured cells at top/left 0,0,
	          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
	          // Positioning them further to the right/bottom influences their measured size.
	          style = {
	            height: 'auto',
	            left: 0,
	            position: 'absolute',
	            top: 0,
	            width: 'auto'
	          };
	        } else {
	          style = {
	            height: rowDatum.size,
	            left: columnDatum.offset + horizontalOffsetAdjustment,
	            position: 'absolute',
	            top: rowDatum.offset + verticalOffsetAdjustment,
	            width: columnDatum.size
	          };
	          styleCache[key] = style;
	        }
	      }
	
	      var cellRendererParams = {
	        columnIndex: columnIndex,
	        isScrolling: isScrolling,
	        isVisible: isVisible,
	        key: key,
	        parent: parent,
	        rowIndex: rowIndex,
	        style: style
	      };
	      var renderedCell = void 0; // Avoid re-creating cells while scrolling.
	      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	      // If a scroll is in progress- cache and reuse cells.
	      // This cache will be thrown away once scrolling completes.
	      // However if we are scaling scroll positions and sizes, we should also avoid caching.
	      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
	      // For more info refer to issue #395
	      //
	      // If isScrollingOptOut is specified, we always cache cells.
	      // For more info refer to issue #1028
	
	      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
	        if (!cellCache[key]) {
	          cellCache[key] = cellRenderer(cellRendererParams);
	        }
	
	        renderedCell = cellCache[key]; // If the user is no longer scrolling, don't cache cells.
	        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
	      } else {
	        renderedCell = cellRenderer(cellRendererParams);
	      }
	
	      if (renderedCell == null || renderedCell === false) {
	        continue;
	      }
	
	      if (false) {
	        warnAboutMissingStyle(parent, renderedCell);
	      }
	
	      renderedCells.push(renderedCell);
	    }
	  }
	
	  return renderedCells;
	}
	
	function warnAboutMissingStyle(parent, renderedCell) {
	  if (false) {
	    if (renderedCell) {
	      // If the direct child is a CellMeasurer, then we should check its child
	      // See issue #611
	      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
	        renderedCell = renderedCell.props.children;
	      }
	
	      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
	        parent.__warnedAboutMissingStyle = true;
	        console.warn('Rendered cell should include style property for positioning.');
	      }
	    }
	  }
	}

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = defaultOverscanIndicesGetter;
	exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = void 0;
	
	var _types = __webpack_require__(67);
	
	var SCROLL_DIRECTION_BACKWARD = -1;
	exports.SCROLL_DIRECTION_BACKWARD = SCROLL_DIRECTION_BACKWARD;
	var SCROLL_DIRECTION_FORWARD = 1;
	exports.SCROLL_DIRECTION_FORWARD = SCROLL_DIRECTION_FORWARD;
	var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
	exports.SCROLL_DIRECTION_HORIZONTAL = SCROLL_DIRECTION_HORIZONTAL;
	var SCROLL_DIRECTION_VERTICAL = 'vertical';
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 */
	
	exports.SCROLL_DIRECTION_VERTICAL = SCROLL_DIRECTION_VERTICAL;
	
	function defaultOverscanIndicesGetter(_ref) {
	  var cellCount = _ref.cellCount,
	      overscanCellsCount = _ref.overscanCellsCount,
	      scrollDirection = _ref.scrollDirection,
	      startIndex = _ref.startIndex,
	      stopIndex = _ref.stopIndex;
	
	  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
	    return {
	      overscanStartIndex: Math.max(0, startIndex),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
	    };
	  } else {
	    return {
	      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
	    };
	  }
	}

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	var _interopRequireWildcard = __webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_RenderedRows = exports.bpfrpt_proptype_RowRenderer = exports.bpfrpt_proptype_RowRendererParams = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var bpfrpt_proptype_RowRendererParams =  true ? null : {
	  "index": _propTypes["default"].number.isRequired,
	  "isScrolling": _propTypes["default"].bool.isRequired,
	  "isVisible": _propTypes["default"].bool.isRequired,
	  "key": _propTypes["default"].string.isRequired,
	  "parent": _propTypes["default"].object.isRequired,
	  "style": _propTypes["default"].object.isRequired
	};
	exports.bpfrpt_proptype_RowRendererParams = bpfrpt_proptype_RowRendererParams;
	var bpfrpt_proptype_RowRenderer =  true ? null : _propTypes["default"].func;
	exports.bpfrpt_proptype_RowRenderer = bpfrpt_proptype_RowRenderer;
	var bpfrpt_proptype_RenderedRows =  true ? null : {
	  "overscanStartIndex": _propTypes["default"].number.isRequired,
	  "overscanStopIndex": _propTypes["default"].number.isRequired,
	  "startIndex": _propTypes["default"].number.isRequired,
	  "stopIndex": _propTypes["default"].number.isRequired
	};
	exports.bpfrpt_proptype_RenderedRows = bpfrpt_proptype_RenderedRows;
	var bpfrpt_proptype_Scroll =  true ? null : {
	  "clientHeight": _propTypes["default"].number.isRequired,
	  "scrollHeight": _propTypes["default"].number.isRequired,
	  "scrollTop": _propTypes["default"].number.isRequired
	};
	exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	var _getSupport = __webpack_require__(440);
	
	var _getDevice = __webpack_require__(1134);
	
	var _getBrowser = __webpack_require__(1133);
	
	var _resize = _interopRequireDefault(__webpack_require__(1123));
	
	var _observer = _interopRequireDefault(__webpack_require__(1122));
	
	var _modular = _interopRequireDefault(__webpack_require__(1077));
	
	var _eventsEmitter = _interopRequireDefault(__webpack_require__(1053));
	
	var _index = _interopRequireDefault(__webpack_require__(1096));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1091));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1086));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1078));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1067));
	
	var _index6 = _interopRequireDefault(__webpack_require__(1061));
	
	var _index7 = _interopRequireDefault(__webpack_require__(1073));
	
	var _index8 = _interopRequireDefault(__webpack_require__(1054));
	
	var _index9 = _interopRequireDefault(__webpack_require__(1046));
	
	var _index10 = _interopRequireDefault(__webpack_require__(1050));
	
	var _index11 = _interopRequireDefault(__webpack_require__(1064));
	
	var _index12 = _interopRequireDefault(__webpack_require__(1048));
	
	var _defaults = _interopRequireDefault(__webpack_require__(1052));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var prototypes = {
	  modular: _modular.default,
	  eventsEmitter: _eventsEmitter.default,
	  update: _index.default,
	  translate: _index2.default,
	  transition: _index3.default,
	  slide: _index4.default,
	  loop: _index5.default,
	  grabCursor: _index6.default,
	  manipulation: _index7.default,
	  events: _index8.default,
	  breakpoints: _index9.default,
	  checkOverflow: _index12.default,
	  classes: _index10.default,
	  images: _index11.default
	};
	var extendedDefaults = {};
	
	var Swiper = /*#__PURE__*/function () {
	  function Swiper() {
	    var el;
	    var params;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
	      params = args[0];
	    } else {
	      el = args[0];
	      params = args[1];
	    }
	
	    if (!params) params = {};
	    params = (0, _utils.extend)({}, params);
	    if (el && !params.el) params.el = el;
	
	    if (params.el && (0, _dom.default)(params.el).length > 1) {
	      var swipers = [];
	      (0, _dom.default)(params.el).each(function (containerEl) {
	        var newParams = (0, _utils.extend)({}, params, {
	          el: containerEl
	        });
	        swipers.push(new Swiper(newParams));
	      });
	      return swipers;
	    } // Swiper Instance
	
	
	    var swiper = this;
	    swiper.__swiper__ = true;
	    swiper.support = (0, _getSupport.getSupport)();
	    swiper.device = (0, _getDevice.getDevice)({
	      userAgent: params.userAgent
	    });
	    swiper.browser = (0, _getBrowser.getBrowser)();
	    swiper.eventsListeners = {};
	    swiper.eventsAnyListeners = [];
	
	    if (typeof swiper.modules === 'undefined') {
	      swiper.modules = {};
	    }
	
	    Object.keys(swiper.modules).forEach(function (moduleName) {
	      var module = swiper.modules[moduleName];
	
	      if (module.params) {
	        var moduleParamName = Object.keys(module.params)[0];
	        var moduleParams = module.params[moduleParamName];
	        if (typeof moduleParams !== 'object' || moduleParams === null) return;
	
	        if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
	          params[moduleParamName] = {
	            auto: true
	          };
	        }
	
	        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
	
	        if (params[moduleParamName] === true) {
	          params[moduleParamName] = {
	            enabled: true
	          };
	        }
	
	        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
	          params[moduleParamName].enabled = true;
	        }
	
	        if (!params[moduleParamName]) params[moduleParamName] = {
	          enabled: false
	        };
	      }
	    }); // Extend defaults with modules params
	
	    var swiperParams = (0, _utils.extend)({}, _defaults.default);
	    swiper.useParams(swiperParams); // Extend defaults with passed params
	
	    swiper.params = (0, _utils.extend)({}, swiperParams, extendedDefaults, params);
	    swiper.originalParams = (0, _utils.extend)({}, swiper.params);
	    swiper.passedParams = (0, _utils.extend)({}, params); // add event listeners
	
	    if (swiper.params && swiper.params.on) {
	      Object.keys(swiper.params.on).forEach(function (eventName) {
	        swiper.on(eventName, swiper.params.on[eventName]);
	      });
	    }
	
	    if (swiper.params && swiper.params.onAny) {
	      swiper.onAny(swiper.params.onAny);
	    } // Save Dom lib
	
	
	    swiper.$ = _dom.default; // Extend Swiper
	
	    (0, _utils.extend)(swiper, {
	      enabled: swiper.params.enabled,
	      el: el,
	      // Classes
	      classNames: [],
	      // Slides
	      slides: (0, _dom.default)(),
	      slidesGrid: [],
	      snapGrid: [],
	      slidesSizesGrid: [],
	      // isDirection
	      isHorizontal: function isHorizontal() {
	        return swiper.params.direction === 'horizontal';
	      },
	      isVertical: function isVertical() {
	        return swiper.params.direction === 'vertical';
	      },
	      // Indexes
	      activeIndex: 0,
	      realIndex: 0,
	      //
	      isBeginning: true,
	      isEnd: false,
	      // Props
	      translate: 0,
	      previousTranslate: 0,
	      progress: 0,
	      velocity: 0,
	      animating: false,
	      // Locks
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,
	      // Touch Events
	      touchEvents: function touchEvents() {
	        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
	        var desktop = ['mousedown', 'mousemove', 'mouseup'];
	
	        if (swiper.support.pointerEvents) {
	          desktop = ['pointerdown', 'pointermove', 'pointerup'];
	        }
	
	        swiper.touchEventsTouch = {
	          start: touch[0],
	          move: touch[1],
	          end: touch[2],
	          cancel: touch[3]
	        };
	        swiper.touchEventsDesktop = {
	          start: desktop[0],
	          move: desktop[1],
	          end: desktop[2]
	        };
	        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
	      }(),
	      touchEventsData: {
	        isTouched: undefined,
	        isMoved: undefined,
	        allowTouchCallbacks: undefined,
	        touchStartTime: undefined,
	        isScrolling: undefined,
	        currentTranslate: undefined,
	        startTranslate: undefined,
	        allowThresholdMove: undefined,
	        // Form elements to match
	        focusableElements: swiper.params.focusableElements,
	        // Last click time
	        lastClickTime: (0, _utils.now)(),
	        clickTimeout: undefined,
	        // Velocities
	        velocities: [],
	        allowMomentumBounce: undefined,
	        isTouchEvent: undefined,
	        startMoving: undefined
	      },
	      // Clicks
	      allowClick: true,
	      // Touches
	      allowTouchMove: swiper.params.allowTouchMove,
	      touches: {
	        startX: 0,
	        startY: 0,
	        currentX: 0,
	        currentY: 0,
	        diff: 0
	      },
	      // Images
	      imagesToLoad: [],
	      imagesLoaded: 0
	    }); // Install Modules
	
	    swiper.useModules();
	    swiper.emit('_swiper'); // Init
	
	    if (swiper.params.init) {
	      swiper.init();
	    } // Return app instance
	
	
	    return swiper;
	  }
	
	  var _proto = Swiper.prototype;
	
	  _proto.enable = function enable() {
	    var swiper = this;
	    if (swiper.enabled) return;
	    swiper.enabled = true;
	
	    if (swiper.params.grabCursor) {
	      swiper.setGrabCursor();
	    }
	
	    swiper.emit('enable');
	  };
	
	  _proto.disable = function disable() {
	    var swiper = this;
	    if (!swiper.enabled) return;
	    swiper.enabled = false;
	
	    if (swiper.params.grabCursor) {
	      swiper.unsetGrabCursor();
	    }
	
	    swiper.emit('disable');
	  };
	
	  _proto.setProgress = function setProgress(progress, speed) {
	    var swiper = this;
	    progress = Math.min(Math.max(progress, 0), 1);
	    var min = swiper.minTranslate();
	    var max = swiper.maxTranslate();
	    var current = (max - min) * progress + min;
	    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  };
	
	  _proto.emitContainerClasses = function emitContainerClasses() {
	    var swiper = this;
	    if (!swiper.params._emitClasses || !swiper.el) return;
	    var classes = swiper.el.className.split(' ').filter(function (className) {
	      return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
	    });
	    swiper.emit('_containerClasses', classes.join(' '));
	  };
	
	  _proto.getSlideClasses = function getSlideClasses(slideEl) {
	    var swiper = this;
	    return slideEl.className.split(' ').filter(function (className) {
	      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
	    }).join(' ');
	  };
	
	  _proto.emitSlidesClasses = function emitSlidesClasses() {
	    var swiper = this;
	    if (!swiper.params._emitClasses || !swiper.el) return;
	    var updates = [];
	    swiper.slides.each(function (slideEl) {
	      var classNames = swiper.getSlideClasses(slideEl);
	      updates.push({
	        slideEl: slideEl,
	        classNames: classNames
	      });
	      swiper.emit('_slideClass', slideEl, classNames);
	    });
	    swiper.emit('_slideClasses', updates);
	  };
	
	  _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
	    var swiper = this;
	    var params = swiper.params,
	        slides = swiper.slides,
	        slidesGrid = swiper.slidesGrid,
	        swiperSize = swiper.size,
	        activeIndex = swiper.activeIndex;
	    var spv = 1;
	
	    if (params.centeredSlides) {
	      var slideSize = slides[activeIndex].swiperSlideSize;
	      var breakLoop;
	
	      for (var i = activeIndex + 1; i < slides.length; i += 1) {
	        if (slides[i] && !breakLoop) {
	          slideSize += slides[i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) breakLoop = true;
	        }
	      }
	
	      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
	        if (slides[_i] && !breakLoop) {
	          slideSize += slides[_i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) breakLoop = true;
	        }
	      }
	    } else {
	      for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
	        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
	          spv += 1;
	        }
	      }
	    }
	
	    return spv;
	  };
	
	  _proto.update = function update() {
	    var swiper = this;
	    if (!swiper || swiper.destroyed) return;
	    var snapGrid = swiper.snapGrid,
	        params = swiper.params; // Breakpoints
	
	    if (params.breakpoints) {
	      swiper.setBreakpoint();
	    }
	
	    swiper.updateSize();
	    swiper.updateSlides();
	    swiper.updateProgress();
	    swiper.updateSlidesClasses();
	
	    function setTranslate() {
	      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
	      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	      swiper.setTranslate(newTranslate);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	
	    var translated;
	
	    if (swiper.params.freeMode) {
	      setTranslate();
	
	      if (swiper.params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	    } else {
	      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	      } else {
	        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	      }
	
	      if (!translated) {
	        setTranslate();
	      }
	    }
	
	    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
	      swiper.checkOverflow();
	    }
	
	    swiper.emit('update');
	  };
	
	  _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
	    if (needUpdate === void 0) {
	      needUpdate = true;
	    }
	
	    var swiper = this;
	    var currentDirection = swiper.params.direction;
	
	    if (!newDirection) {
	      // eslint-disable-next-line
	      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
	    }
	
	    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
	      return swiper;
	    }
	
	    swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
	    swiper.emitContainerClasses();
	    swiper.params.direction = newDirection;
	    swiper.slides.each(function (slideEl) {
	      if (newDirection === 'vertical') {
	        slideEl.style.width = '';
	      } else {
	        slideEl.style.height = '';
	      }
	    });
	    swiper.emit('changeDirection');
	    if (needUpdate) swiper.update();
	    return swiper;
	  };
	
	  _proto.mount = function mount(el) {
	    var swiper = this;
	    if (swiper.mounted) return true; // Find el
	
	    var $el = (0, _dom.default)(el || swiper.params.el);
	    el = $el[0];
	
	    if (!el) {
	      return false;
	    }
	
	    el.swiper = swiper;
	
	    var getWrapperSelector = function getWrapperSelector() {
	      return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
	    };
	
	    var getWrapper = function getWrapper() {
	      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
	        var res = (0, _dom.default)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
	
	        res.children = function (options) {
	          return $el.children(options);
	        };
	
	        return res;
	      }
	
	      return $el.children(getWrapperSelector());
	    }; // Find Wrapper
	
	
	    var $wrapperEl = getWrapper();
	
	    if ($wrapperEl.length === 0 && swiper.params.createElements) {
	      var document = (0, _ssrWindow.getDocument)();
	      var wrapper = document.createElement('div');
	      $wrapperEl = (0, _dom.default)(wrapper);
	      wrapper.className = swiper.params.wrapperClass;
	      $el.append(wrapper);
	      $el.children("." + swiper.params.slideClass).each(function (slideEl) {
	        $wrapperEl.append(slideEl);
	      });
	    }
	
	    (0, _utils.extend)(swiper, {
	      $el: $el,
	      el: el,
	      $wrapperEl: $wrapperEl,
	      wrapperEl: $wrapperEl[0],
	      mounted: true,
	      // RTL
	      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
	      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
	    });
	    return true;
	  };
	
	  _proto.init = function init(el) {
	    var swiper = this;
	    if (swiper.initialized) return swiper;
	    var mounted = swiper.mount(el);
	    if (mounted === false) return swiper;
	    swiper.emit('beforeInit'); // Set breakpoint
	
	    if (swiper.params.breakpoints) {
	      swiper.setBreakpoint();
	    } // Add Classes
	
	
	    swiper.addClasses(); // Create loop
	
	    if (swiper.params.loop) {
	      swiper.loopCreate();
	    } // Update size
	
	
	    swiper.updateSize(); // Update slides
	
	    swiper.updateSlides();
	
	    if (swiper.params.watchOverflow) {
	      swiper.checkOverflow();
	    } // Set Grab Cursor
	
	
	    if (swiper.params.grabCursor && swiper.enabled) {
	      swiper.setGrabCursor();
	    }
	
	    if (swiper.params.preloadImages) {
	      swiper.preloadImages();
	    } // Slide To Initial Slide
	
	
	    if (swiper.params.loop) {
	      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
	    } else {
	      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
	    } // Attach events
	
	
	    swiper.attachEvents(); // Init Flag
	
	    swiper.initialized = true; // Emit
	
	    swiper.emit('init');
	    swiper.emit('afterInit');
	    return swiper;
	  };
	
	  _proto.destroy = function destroy(deleteInstance, cleanStyles) {
	    if (deleteInstance === void 0) {
	      deleteInstance = true;
	    }
	
	    if (cleanStyles === void 0) {
	      cleanStyles = true;
	    }
	
	    var swiper = this;
	    var params = swiper.params,
	        $el = swiper.$el,
	        $wrapperEl = swiper.$wrapperEl,
	        slides = swiper.slides;
	
	    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
	      return null;
	    }
	
	    swiper.emit('beforeDestroy'); // Init Flag
	
	    swiper.initialized = false; // Detach events
	
	    swiper.detachEvents(); // Destroy loop
	
	    if (params.loop) {
	      swiper.loopDestroy();
	    } // Cleanup styles
	
	
	    if (cleanStyles) {
	      swiper.removeClasses();
	      $el.removeAttr('style');
	      $wrapperEl.removeAttr('style');
	
	      if (slides && slides.length) {
	        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
	      }
	    }
	
	    swiper.emit('destroy'); // Detach emitter events
	
	    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
	      swiper.off(eventName);
	    });
	
	    if (deleteInstance !== false) {
	      swiper.$el[0].swiper = null;
	      (0, _utils.deleteProps)(swiper);
	    }
	
	    swiper.destroyed = true;
	    return null;
	  };
	
	  Swiper.extendDefaults = function extendDefaults(newDefaults) {
	    (0, _utils.extend)(extendedDefaults, newDefaults);
	  };
	
	  Swiper.installModule = function installModule(module) {
	    if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
	    var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + (0, _utils.now)();
	    Swiper.prototype.modules[name] = module;
	  };
	
	  Swiper.use = function use(module) {
	    if (Array.isArray(module)) {
	      module.forEach(function (m) {
	        return Swiper.installModule(m);
	      });
	      return Swiper;
	    }
	
	    Swiper.installModule(module);
	    return Swiper;
	  };
	
	  _createClass(Swiper, null, [{
	    key: "extendedDefaults",
	    get: function get() {
	      return extendedDefaults;
	    }
	  }, {
	    key: "defaults",
	    get: function get() {
	      return _defaults.default;
	    }
	  }]);
	
	  return Swiper;
	}();
	
	Object.keys(prototypes).forEach(function (prototypeGroup) {
	  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
	    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	  });
	});
	Swiper.use([_resize.default, _observer.default]);
	var _default = Swiper;
	exports.default = _default;

/***/ },
/* 438 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.paramsList = void 0;
	
	/* underscore in name -> watch for changes */
	var paramsList = ['init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_freeModeMomentum', '_freeModeMomentumRatio', '_freeModeMomentumBounce', '_freeModeMomentumBounceRatio', '_freeModeMomentumVelocityRatio', '_freeModeSticky', '_freeModeMinimumVelocity', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', '_slidesPerColumn', '_slidesPerColumnFill', '_slidesPerGroup', '_slidesPerGroupSkip', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_watchSlidesVisibility', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
	'a11y', 'autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];
	exports.paramsList = paramsList;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;
	
	var _react = __webpack_require__(1);
	
	function useIsomorphicLayoutEffect(callback, deps) {
	  // eslint-disable-next-line
	  if (typeof window === 'undefined') return (0, _react.useEffect)(callback, deps);
	  return (0, _react.useLayoutEffect)(callback, deps);
	}

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getSupport = getSupport;
	
	var _ssrWindow = __webpack_require__(41);
	
	var support;
	
	function calcSupport() {
	  var window = (0, _ssrWindow.getWindow)();
	  var document = (0, _ssrWindow.getDocument)();
	  return {
	    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
	    pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
	    observer: function checkObserver() {
	      return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
	    }(),
	    passiveListener: function checkPassiveListener() {
	      var supportsPassive = false;
	
	      try {
	        var opts = Object.defineProperty({}, 'passive', {
	          // eslint-disable-next-line
	          get: function get() {
	            supportsPassive = true;
	          }
	        });
	        window.addEventListener('testPassiveListener', null, opts);
	      } catch (e) {// No support
	      }
	
	      return supportsPassive;
	    }(),
	    gestures: function checkGestures() {
	      return 'ongesturestart' in window;
	    }()
	  };
	}
	
	function getSupport() {
	  if (!support) {
	    support = calcSupport();
	  }
	
	  return support;
	}

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Swiper React 6.8.4
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * https://swiperjs.com
	 *
	 * Copyright 2014-2021 Vladimir Kharlampidi
	 *
	 * Released under the MIT License
	 *
	 * Released on: August 23, 2021
	 */
	
	"use strict";
	
	exports.__esModule = true;
	
	var _swiper = __webpack_require__(1130);
	
	exports.Swiper = _swiper.Swiper;
	
	var _swiperSlide = __webpack_require__(1129);
	
	exports.SwiperSlide = _swiperSlide.SwiperSlide;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/updated_jci.7b9900d7.png";

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Baby-Girl.d83fec4c.png";

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Bitmap-3.aef37f90.png";

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Mother.9a3dd8a2.png";

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Shape.8b509111.png";

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Wife.3fc115c8.png";

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/background_image.e2923020.jfif";

/***/ },
/* 449 */
/***/ function(module, exports) {

	module.exports = "data:image/webp;base64,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"

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lines.f57f2899.png";

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.a4dfe1ab.png";

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/new_1.1ddfae10.png";

/***/ },
/* 453 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pay-img.bc69b46b.png";

/***/ },
/* 455 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALkSURBVHgBvZi/ctpAEMa/Q8jjjPEM6VLiN3C6VEaUqWw/Qdymst0lM3g4mWTGnZ0unfET2OmSioMm6YKfILTplAlMGPPnsiuZGSAQdBLHr4DjWEnf3e7t3klgjWzL8oGGOKam99ilNHDTldXarK2DNZHzyxVAfKRmYaK7IICDjZKHB9VoYN3CtuTZkYC4+o+Jt+EV8w+q+QXrErYp3xQcOLfcXGL6wvWKhb5qfoJtYXl5ktd48pXc9SyOPdntusXir36j+U3AIjlZuQRGJzAjyOL3jrUZi+JKX8CczaF2f2ZgCXLFPhIiRGbfmjC6fQEJoUEVLAobBUiItisMDaTAmrAsslc08jaSEVgTFkgZDOGUuAlzWjZdiZ6UbZq1Uxij760m2DE5Wa7TWvPi2lP+O7QujGtlFu4Pg0uCjqw+tepKxoFbMbEn19/xt1VhUVnCEYwYfuBPa66MtjtuXUxvDJehyI28kindWILiinYWRqII7Y9bVlwZbaNxYHINxVatI9+p8e+VCwtFaSFhBidjf7JjoSsp93gUgsc0kl2KE06UN0P0VU9etOfZ8261j+1LGvoRDNF65Pf8anuyTyx6wLzVxLWPxJVmxfEg6Fh2LYxjKuSOAv5wtnPKlbySBsjVFy1xfjAF9XdOA2N7al/TP/UkonigAzinC54V8XgYpYcgj3i3bdHlu0hOQKKecz2d92c4YxywJOo2vigmlSierdNFokJhoVvMV1FKhD/vtcAkGarkr7BWhN+R53KZVcZkO5KeeKIYayVphoBjqivPa3EvoBnTChbRYXJ2SstiahZelT6soZVLKaErZQuGOPTqp73h7YkVx1pAZeZt13//uqdUDwkI312QOOV6ezsiZW6K0GqA7Ms/fvUzUjBVK7dkuUbiEqaPMFb9ya1LGv4p4luVsxPqPY5Z++jMqG8QFuLVCFoojNmUkrbFQy9KvqF7w1LFK4z62tS8ZzF02m7xwRYW+AvXtPmFlvQwMAAAAABJRU5ErkJggg=="

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/potrait.5928139f.webp";

/***/ },
/* 457 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./_ARK2882.jpg": 1140,
		"./_ARK2882_1.jpg": 1141,
		"./_ARK2885.jpg": 1142,
		"./_ARK2885_1.jpg": 1143,
		"./_ARK2984.jpg": 1144,
		"./_ARK2984_1.jpg": 1145,
		"./_ARK2986.jpg": 1146,
		"./_ARK2986_1.jpg": 1147,
		"./_ARK2987.jpg": 1148,
		"./_ARK2987_1.jpg": 1149,
		"./_ARK2991.jpg": 1150,
		"./_ARK2991_1.jpg": 1151
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 459;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./DELUXE.jpg": 1152,
		"./DOUBLE.jpg": 1153,
		"./GENERAL.jpg": 1154,
		"./Luxary.jpg": 1155,
		"./ONCOLOGY.jpg": 1156,
		"./STANDARD.jpg": 1157,
		"./STANDARD_single.jpg": 1158,
		"./VIP.jpg": 1159,
		"./triple.jpg": 1160
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 460;


/***/ },
/* 461 */
/***/ function(module, exports) {

	function _arrayLikeToArray(r, a) {
	  (null == a || a > r.length) && (a = r.length);
	  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	  return n;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var unsupportedIterableToArray = __webpack_require__(467);
	function _createForOfIteratorHelper(r, e) {
	  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	  if (!t) {
	    if (Array.isArray(r) || (t = unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
	      t && (r = t);
	      var _n = 0,
	        F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          return _n >= r.length ? {
	            done: !0
	          } : {
	            done: !1,
	            value: r[_n++]
	          };
	        },
	        e: function e(r) {
	          throw r;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var o,
	    a = !0,
	    u = !1;
	  return {
	    s: function s() {
	      t = t.call(r);
	    },
	    n: function n() {
	      var r = t.next();
	      return a = r.done, r;
	    },
	    e: function e(r) {
	      u = !0, o = r;
	    },
	    f: function f() {
	      try {
	        a || null == t["return"] || t["return"]();
	      } finally {
	        if (u) throw o;
	      }
	    }
	  };
	}
	module.exports = _createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 463 */
/***/ function(module, exports) {

	function _isNativeReflectConstruct() {
	  try {
	    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	  } catch (t) {}
	  return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
	    return !!t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
	}
	module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(19);
	function ownKeys(e, r) {
	  var t = Object.keys(e);
	  if (Object.getOwnPropertySymbols) {
	    var o = Object.getOwnPropertySymbols(e);
	    r && (o = o.filter(function (r) {
	      return Object.getOwnPropertyDescriptor(e, r).enumerable;
	    })), t.push.apply(t, o);
	  }
	  return t;
	}
	function _objectSpread2(e) {
	  for (var r = 1; r < arguments.length; r++) {
	    var t = null != arguments[r] ? arguments[r] : {};
	    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
	      defineProperty(e, r, t[r]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
	      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
	    });
	  }
	  return e;
	}
	module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(94);
	function _objectWithoutProperties(e, t) {
	  if (null == e) return {};
	  var o,
	    r,
	    i = objectWithoutPropertiesLoose(e, t);
	  if (Object.getOwnPropertySymbols) {
	    var s = Object.getOwnPropertySymbols(e);
	    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
	  }
	  return i;
	}
	module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(58)["default"];
	function toPrimitive(t, r) {
	  if ("object" != _typeof(t) || !t) return t;
	  var e = t[Symbol.toPrimitive];
	  if (void 0 !== e) {
	    var i = e.call(t, r || "default");
	    if ("object" != _typeof(i)) return i;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return ("string" === r ? String : Number)(t);
	}
	module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(461);
	function _unsupportedIterableToArray(r, a) {
	  if (r) {
	    if ("string" == typeof r) return arrayLikeToArray(r, a);
	    var t = {}.toString.call(r).slice(8, -1);
	    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
	  }
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 468 */
/***/ function(module, exports) {

	/**
	 * @popperjs/core v2.11.8 - MIT License
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function getWindow(node) {
	  if (node == null) {
	    return window;
	  }
	
	  if (node.toString() !== '[object Window]') {
	    var ownerDocument = node.ownerDocument;
	    return ownerDocument ? ownerDocument.defaultView || window : window;
	  }
	
	  return node;
	}
	
	function isElement(node) {
	  var OwnElement = getWindow(node).Element;
	  return node instanceof OwnElement || node instanceof Element;
	}
	
	function isHTMLElement(node) {
	  var OwnElement = getWindow(node).HTMLElement;
	  return node instanceof OwnElement || node instanceof HTMLElement;
	}
	
	function isShadowRoot(node) {
	  // IE 11 has no ShadowRoot
	  if (typeof ShadowRoot === 'undefined') {
	    return false;
	  }
	
	  var OwnElement = getWindow(node).ShadowRoot;
	  return node instanceof OwnElement || node instanceof ShadowRoot;
	}
	
	var max = Math.max;
	var min = Math.min;
	var round = Math.round;
	
	function getUAString() {
	  var uaData = navigator.userAgentData;
	
	  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
	    return uaData.brands.map(function (item) {
	      return item.brand + "/" + item.version;
	    }).join(' ');
	  }
	
	  return navigator.userAgent;
	}
	
	function isLayoutViewport() {
	  return !/^((?!chrome|android).)*safari/i.test(getUAString());
	}
	
	function getBoundingClientRect(element, includeScale, isFixedStrategy) {
	  if (includeScale === void 0) {
	    includeScale = false;
	  }
	
	  if (isFixedStrategy === void 0) {
	    isFixedStrategy = false;
	  }
	
	  var clientRect = element.getBoundingClientRect();
	  var scaleX = 1;
	  var scaleY = 1;
	
	  if (includeScale && isHTMLElement(element)) {
	    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
	    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
	  }
	
	  var _ref = isElement(element) ? getWindow(element) : window,
	      visualViewport = _ref.visualViewport;
	
	  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
	  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
	  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
	  var width = clientRect.width / scaleX;
	  var height = clientRect.height / scaleY;
	  return {
	    width: width,
	    height: height,
	    top: y,
	    right: x + width,
	    bottom: y + height,
	    left: x,
	    x: x,
	    y: y
	  };
	}
	
	function getWindowScroll(node) {
	  var win = getWindow(node);
	  var scrollLeft = win.pageXOffset;
	  var scrollTop = win.pageYOffset;
	  return {
	    scrollLeft: scrollLeft,
	    scrollTop: scrollTop
	  };
	}
	
	function getHTMLElementScroll(element) {
	  return {
	    scrollLeft: element.scrollLeft,
	    scrollTop: element.scrollTop
	  };
	}
	
	function getNodeScroll(node) {
	  if (node === getWindow(node) || !isHTMLElement(node)) {
	    return getWindowScroll(node);
	  } else {
	    return getHTMLElementScroll(node);
	  }
	}
	
	function getNodeName(element) {
	  return element ? (element.nodeName || '').toLowerCase() : null;
	}
	
	function getDocumentElement(element) {
	  // $FlowFixMe[incompatible-return]: assume body is always available
	  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
	  element.document) || window.document).documentElement;
	}
	
	function getWindowScrollBarX(element) {
	  // If <html> has a CSS width greater than the viewport, then this will be
	  // incorrect for RTL.
	  // Popper 1 is broken in this case and never had a bug report so let's assume
	  // it's not an issue. I don't think anyone ever specifies width on <html>
	  // anyway.
	  // Browsers where the left scrollbar doesn't cause an issue report `0` for
	  // this (e.g. Edge 2019, IE11, Safari)
	  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
	}
	
	function getComputedStyle(element) {
	  return getWindow(element).getComputedStyle(element);
	}
	
	function isScrollParent(element) {
	  // Firefox wants us to check `-x` and `-y` variations as well
	  var _getComputedStyle = getComputedStyle(element),
	      overflow = _getComputedStyle.overflow,
	      overflowX = _getComputedStyle.overflowX,
	      overflowY = _getComputedStyle.overflowY;
	
	  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
	}
	
	function isElementScaled(element) {
	  var rect = element.getBoundingClientRect();
	  var scaleX = round(rect.width) / element.offsetWidth || 1;
	  var scaleY = round(rect.height) / element.offsetHeight || 1;
	  return scaleX !== 1 || scaleY !== 1;
	} // Returns the composite rect of an element relative to its offsetParent.
	// Composite means it takes into account transforms as well as layout.
	
	
	function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
	  if (isFixed === void 0) {
	    isFixed = false;
	  }
	
	  var isOffsetParentAnElement = isHTMLElement(offsetParent);
	  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
	  var documentElement = getDocumentElement(offsetParent);
	  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
	  var scroll = {
	    scrollLeft: 0,
	    scrollTop: 0
	  };
	  var offsets = {
	    x: 0,
	    y: 0
	  };
	
	  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
	    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
	    isScrollParent(documentElement)) {
	      scroll = getNodeScroll(offsetParent);
	    }
	
	    if (isHTMLElement(offsetParent)) {
	      offsets = getBoundingClientRect(offsetParent, true);
	      offsets.x += offsetParent.clientLeft;
	      offsets.y += offsetParent.clientTop;
	    } else if (documentElement) {
	      offsets.x = getWindowScrollBarX(documentElement);
	    }
	  }
	
	  return {
	    x: rect.left + scroll.scrollLeft - offsets.x,
	    y: rect.top + scroll.scrollTop - offsets.y,
	    width: rect.width,
	    height: rect.height
	  };
	}
	
	// means it doesn't take into account transforms.
	
	function getLayoutRect(element) {
	  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
	  // Fixes https://github.com/popperjs/popper-core/issues/1223
	
	  var width = element.offsetWidth;
	  var height = element.offsetHeight;
	
	  if (Math.abs(clientRect.width - width) <= 1) {
	    width = clientRect.width;
	  }
	
	  if (Math.abs(clientRect.height - height) <= 1) {
	    height = clientRect.height;
	  }
	
	  return {
	    x: element.offsetLeft,
	    y: element.offsetTop,
	    width: width,
	    height: height
	  };
	}
	
	function getParentNode(element) {
	  if (getNodeName(element) === 'html') {
	    return element;
	  }
	
	  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
	    // $FlowFixMe[incompatible-return]
	    // $FlowFixMe[prop-missing]
	    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
	    element.parentNode || ( // DOM Element detected
	    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
	    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
	    getDocumentElement(element) // fallback
	
	  );
	}
	
	function getScrollParent(node) {
	  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
	    // $FlowFixMe[incompatible-return]: assume body is always available
	    return node.ownerDocument.body;
	  }
	
	  if (isHTMLElement(node) && isScrollParent(node)) {
	    return node;
	  }
	
	  return getScrollParent(getParentNode(node));
	}
	
	/*
	given a DOM element, return the list of all scroll parents, up the list of ancesors
	until we get to the top window object. This list is what we attach scroll listeners
	to, because if any of these parent elements scroll, we'll need to re-calculate the
	reference element's position.
	*/
	
	function listScrollParents(element, list) {
	  var _element$ownerDocumen;
	
	  if (list === void 0) {
	    list = [];
	  }
	
	  var scrollParent = getScrollParent(element);
	  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
	  var win = getWindow(scrollParent);
	  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
	  var updatedList = list.concat(target);
	  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
	  updatedList.concat(listScrollParents(getParentNode(target)));
	}
	
	function isTableElement(element) {
	  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
	}
	
	function getTrueOffsetParent(element) {
	  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
	  getComputedStyle(element).position === 'fixed') {
	    return null;
	  }
	
	  return element.offsetParent;
	} // `.offsetParent` reports `null` for fixed elements, while absolute elements
	// return the containing block
	
	
	function getContainingBlock(element) {
	  var isFirefox = /firefox/i.test(getUAString());
	  var isIE = /Trident/i.test(getUAString());
	
	  if (isIE && isHTMLElement(element)) {
	    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
	    var elementCss = getComputedStyle(element);
	
	    if (elementCss.position === 'fixed') {
	      return null;
	    }
	  }
	
	  var currentNode = getParentNode(element);
	
	  if (isShadowRoot(currentNode)) {
	    currentNode = currentNode.host;
	  }
	
	  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
	    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
	    // create a containing block.
	    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
	
	    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
	      return currentNode;
	    } else {
	      currentNode = currentNode.parentNode;
	    }
	  }
	
	  return null;
	} // Gets the closest ancestor positioned element. Handles some edge cases,
	// such as table ancestors and cross browser bugs.
	
	
	function getOffsetParent(element) {
	  var window = getWindow(element);
	  var offsetParent = getTrueOffsetParent(element);
	
	  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
	    offsetParent = getTrueOffsetParent(offsetParent);
	  }
	
	  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
	    return window;
	  }
	
	  return offsetParent || getContainingBlock(element) || window;
	}
	
	var top = 'top';
	var bottom = 'bottom';
	var right = 'right';
	var left = 'left';
	var auto = 'auto';
	var basePlacements = [top, bottom, right, left];
	var start = 'start';
	var end = 'end';
	var clippingParents = 'clippingParents';
	var viewport = 'viewport';
	var popper = 'popper';
	var reference = 'reference';
	var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
	  return acc.concat([placement + "-" + start, placement + "-" + end]);
	}, []);
	var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
	  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
	}, []); // modifiers that need to read the DOM
	
	var beforeRead = 'beforeRead';
	var read = 'read';
	var afterRead = 'afterRead'; // pure-logic modifiers
	
	var beforeMain = 'beforeMain';
	var main = 'main';
	var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
	
	var beforeWrite = 'beforeWrite';
	var write = 'write';
	var afterWrite = 'afterWrite';
	var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
	
	function order(modifiers) {
	  var map = new Map();
	  var visited = new Set();
	  var result = [];
	  modifiers.forEach(function (modifier) {
	    map.set(modifier.name, modifier);
	  }); // On visiting object, check for its dependencies and visit them recursively
	
	  function sort(modifier) {
	    visited.add(modifier.name);
	    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
	    requires.forEach(function (dep) {
	      if (!visited.has(dep)) {
	        var depModifier = map.get(dep);
	
	        if (depModifier) {
	          sort(depModifier);
	        }
	      }
	    });
	    result.push(modifier);
	  }
	
	  modifiers.forEach(function (modifier) {
	    if (!visited.has(modifier.name)) {
	      // check for visited object
	      sort(modifier);
	    }
	  });
	  return result;
	}
	
	function orderModifiers(modifiers) {
	  // order based on dependencies
	  var orderedModifiers = order(modifiers); // order based on phase
	
	  return modifierPhases.reduce(function (acc, phase) {
	    return acc.concat(orderedModifiers.filter(function (modifier) {
	      return modifier.phase === phase;
	    }));
	  }, []);
	}
	
	function debounce(fn) {
	  var pending;
	  return function () {
	    if (!pending) {
	      pending = new Promise(function (resolve) {
	        Promise.resolve().then(function () {
	          pending = undefined;
	          resolve(fn());
	        });
	      });
	    }
	
	    return pending;
	  };
	}
	
	function mergeByName(modifiers) {
	  var merged = modifiers.reduce(function (merged, current) {
	    var existing = merged[current.name];
	    merged[current.name] = existing ? Object.assign({}, existing, current, {
	      options: Object.assign({}, existing.options, current.options),
	      data: Object.assign({}, existing.data, current.data)
	    }) : current;
	    return merged;
	  }, {}); // IE11 does not support Object.values
	
	  return Object.keys(merged).map(function (key) {
	    return merged[key];
	  });
	}
	
	function getViewportRect(element, strategy) {
	  var win = getWindow(element);
	  var html = getDocumentElement(element);
	  var visualViewport = win.visualViewport;
	  var width = html.clientWidth;
	  var height = html.clientHeight;
	  var x = 0;
	  var y = 0;
	
	  if (visualViewport) {
	    width = visualViewport.width;
	    height = visualViewport.height;
	    var layoutViewport = isLayoutViewport();
	
	    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
	      x = visualViewport.offsetLeft;
	      y = visualViewport.offsetTop;
	    }
	  }
	
	  return {
	    width: width,
	    height: height,
	    x: x + getWindowScrollBarX(element),
	    y: y
	  };
	}
	
	// of the `<html>` and `<body>` rect bounds if horizontally scrollable
	
	function getDocumentRect(element) {
	  var _element$ownerDocumen;
	
	  var html = getDocumentElement(element);
	  var winScroll = getWindowScroll(element);
	  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
	  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
	  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
	  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
	  var y = -winScroll.scrollTop;
	
	  if (getComputedStyle(body || html).direction === 'rtl') {
	    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
	  }
	
	  return {
	    width: width,
	    height: height,
	    x: x,
	    y: y
	  };
	}
	
	function contains(parent, child) {
	  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
	
	  if (parent.contains(child)) {
	    return true;
	  } // then fallback to custom implementation with Shadow DOM support
	  else if (rootNode && isShadowRoot(rootNode)) {
	      var next = child;
	
	      do {
	        if (next && parent.isSameNode(next)) {
	          return true;
	        } // $FlowFixMe[prop-missing]: need a better way to handle this...
	
	
	        next = next.parentNode || next.host;
	      } while (next);
	    } // Give up, the result is false
	
	
	  return false;
	}
	
	function rectToClientRect(rect) {
	  return Object.assign({}, rect, {
	    left: rect.x,
	    top: rect.y,
	    right: rect.x + rect.width,
	    bottom: rect.y + rect.height
	  });
	}
	
	function getInnerBoundingClientRect(element, strategy) {
	  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
	  rect.top = rect.top + element.clientTop;
	  rect.left = rect.left + element.clientLeft;
	  rect.bottom = rect.top + element.clientHeight;
	  rect.right = rect.left + element.clientWidth;
	  rect.width = element.clientWidth;
	  rect.height = element.clientHeight;
	  rect.x = rect.left;
	  rect.y = rect.top;
	  return rect;
	}
	
	function getClientRectFromMixedType(element, clippingParent, strategy) {
	  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
	} // A "clipping parent" is an overflowable container with the characteristic of
	// clipping (or hiding) overflowing elements with a position different from
	// `initial`
	
	
	function getClippingParents(element) {
	  var clippingParents = listScrollParents(getParentNode(element));
	  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
	  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
	
	  if (!isElement(clipperElement)) {
	    return [];
	  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
	
	
	  return clippingParents.filter(function (clippingParent) {
	    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
	  });
	} // Gets the maximum area that the element is visible in due to any number of
	// clipping parents
	
	
	function getClippingRect(element, boundary, rootBoundary, strategy) {
	  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
	  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
	  var firstClippingParent = clippingParents[0];
	  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
	    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
	    accRect.top = max(rect.top, accRect.top);
	    accRect.right = min(rect.right, accRect.right);
	    accRect.bottom = min(rect.bottom, accRect.bottom);
	    accRect.left = max(rect.left, accRect.left);
	    return accRect;
	  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
	  clippingRect.width = clippingRect.right - clippingRect.left;
	  clippingRect.height = clippingRect.bottom - clippingRect.top;
	  clippingRect.x = clippingRect.left;
	  clippingRect.y = clippingRect.top;
	  return clippingRect;
	}
	
	function getBasePlacement(placement) {
	  return placement.split('-')[0];
	}
	
	function getVariation(placement) {
	  return placement.split('-')[1];
	}
	
	function getMainAxisFromPlacement(placement) {
	  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
	}
	
	function computeOffsets(_ref) {
	  var reference = _ref.reference,
	      element = _ref.element,
	      placement = _ref.placement;
	  var basePlacement = placement ? getBasePlacement(placement) : null;
	  var variation = placement ? getVariation(placement) : null;
	  var commonX = reference.x + reference.width / 2 - element.width / 2;
	  var commonY = reference.y + reference.height / 2 - element.height / 2;
	  var offsets;
	
	  switch (basePlacement) {
	    case top:
	      offsets = {
	        x: commonX,
	        y: reference.y - element.height
	      };
	      break;
	
	    case bottom:
	      offsets = {
	        x: commonX,
	        y: reference.y + reference.height
	      };
	      break;
	
	    case right:
	      offsets = {
	        x: reference.x + reference.width,
	        y: commonY
	      };
	      break;
	
	    case left:
	      offsets = {
	        x: reference.x - element.width,
	        y: commonY
	      };
	      break;
	
	    default:
	      offsets = {
	        x: reference.x,
	        y: reference.y
	      };
	  }
	
	  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
	
	  if (mainAxis != null) {
	    var len = mainAxis === 'y' ? 'height' : 'width';
	
	    switch (variation) {
	      case start:
	        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
	        break;
	
	      case end:
	        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
	        break;
	    }
	  }
	
	  return offsets;
	}
	
	function getFreshSideObject() {
	  return {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  };
	}
	
	function mergePaddingObject(paddingObject) {
	  return Object.assign({}, getFreshSideObject(), paddingObject);
	}
	
	function expandToHashMap(value, keys) {
	  return keys.reduce(function (hashMap, key) {
	    hashMap[key] = value;
	    return hashMap;
	  }, {});
	}
	
	function detectOverflow(state, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      _options$placement = _options.placement,
	      placement = _options$placement === void 0 ? state.placement : _options$placement,
	      _options$strategy = _options.strategy,
	      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
	      _options$boundary = _options.boundary,
	      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
	      _options$rootBoundary = _options.rootBoundary,
	      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
	      _options$elementConte = _options.elementContext,
	      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
	      _options$altBoundary = _options.altBoundary,
	      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
	      _options$padding = _options.padding,
	      padding = _options$padding === void 0 ? 0 : _options$padding;
	  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
	  var altContext = elementContext === popper ? reference : popper;
	  var popperRect = state.rects.popper;
	  var element = state.elements[altBoundary ? altContext : elementContext];
	  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
	  var referenceClientRect = getBoundingClientRect(state.elements.reference);
	  var popperOffsets = computeOffsets({
	    reference: referenceClientRect,
	    element: popperRect,
	    strategy: 'absolute',
	    placement: placement
	  });
	  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
	  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
	  // 0 or negative = within the clipping rect
	
	  var overflowOffsets = {
	    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
	    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
	    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
	    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
	  };
	  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
	
	  if (elementContext === popper && offsetData) {
	    var offset = offsetData[placement];
	    Object.keys(overflowOffsets).forEach(function (key) {
	      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
	      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
	      overflowOffsets[key] += offset[axis] * multiply;
	    });
	  }
	
	  return overflowOffsets;
	}
	
	var DEFAULT_OPTIONS = {
	  placement: 'bottom',
	  modifiers: [],
	  strategy: 'absolute'
	};
	
	function areValidElements() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return !args.some(function (element) {
	    return !(element && typeof element.getBoundingClientRect === 'function');
	  });
	}
	
	function popperGenerator(generatorOptions) {
	  if (generatorOptions === void 0) {
	    generatorOptions = {};
	  }
	
	  var _generatorOptions = generatorOptions,
	      _generatorOptions$def = _generatorOptions.defaultModifiers,
	      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
	      _generatorOptions$def2 = _generatorOptions.defaultOptions,
	      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
	  return function createPopper(reference, popper, options) {
	    if (options === void 0) {
	      options = defaultOptions;
	    }
	
	    var state = {
	      placement: 'bottom',
	      orderedModifiers: [],
	      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
	      modifiersData: {},
	      elements: {
	        reference: reference,
	        popper: popper
	      },
	      attributes: {},
	      styles: {}
	    };
	    var effectCleanupFns = [];
	    var isDestroyed = false;
	    var instance = {
	      state: state,
	      setOptions: function setOptions(setOptionsAction) {
	        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
	        cleanupModifierEffects();
	        state.options = Object.assign({}, defaultOptions, state.options, options);
	        state.scrollParents = {
	          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
	          popper: listScrollParents(popper)
	        }; // Orders the modifiers based on their dependencies and `phase`
	        // properties
	
	        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
	
	        state.orderedModifiers = orderedModifiers.filter(function (m) {
	          return m.enabled;
	        });
	        runModifierEffects();
	        return instance.update();
	      },
	      // Sync update – it will always be executed, even if not necessary. This
	      // is useful for low frequency updates where sync behavior simplifies the
	      // logic.
	      // For high frequency updates (e.g. `resize` and `scroll` events), always
	      // prefer the async Popper#update method
	      forceUpdate: function forceUpdate() {
	        if (isDestroyed) {
	          return;
	        }
	
	        var _state$elements = state.elements,
	            reference = _state$elements.reference,
	            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
	        // anymore
	
	        if (!areValidElements(reference, popper)) {
	          return;
	        } // Store the reference and popper rects to be read by modifiers
	
	
	        state.rects = {
	          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
	          popper: getLayoutRect(popper)
	        }; // Modifiers have the ability to reset the current update cycle. The
	        // most common use case for this is the `flip` modifier changing the
	        // placement, which then needs to re-run all the modifiers, because the
	        // logic was previously ran for the previous placement and is therefore
	        // stale/incorrect
	
	        state.reset = false;
	        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
	        // is filled with the initial data specified by the modifier. This means
	        // it doesn't persist and is fresh on each update.
	        // To ensure persistent data, use `${name}#persistent`
	
	        state.orderedModifiers.forEach(function (modifier) {
	          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
	        });
	
	        for (var index = 0; index < state.orderedModifiers.length; index++) {
	          if (state.reset === true) {
	            state.reset = false;
	            index = -1;
	            continue;
	          }
	
	          var _state$orderedModifie = state.orderedModifiers[index],
	              fn = _state$orderedModifie.fn,
	              _state$orderedModifie2 = _state$orderedModifie.options,
	              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
	              name = _state$orderedModifie.name;
	
	          if (typeof fn === 'function') {
	            state = fn({
	              state: state,
	              options: _options,
	              name: name,
	              instance: instance
	            }) || state;
	          }
	        }
	      },
	      // Async and optimistically optimized update – it will not be executed if
	      // not necessary (debounced to run at most once-per-tick)
	      update: debounce(function () {
	        return new Promise(function (resolve) {
	          instance.forceUpdate();
	          resolve(state);
	        });
	      }),
	      destroy: function destroy() {
	        cleanupModifierEffects();
	        isDestroyed = true;
	      }
	    };
	
	    if (!areValidElements(reference, popper)) {
	      return instance;
	    }
	
	    instance.setOptions(options).then(function (state) {
	      if (!isDestroyed && options.onFirstUpdate) {
	        options.onFirstUpdate(state);
	      }
	    }); // Modifiers have the ability to execute arbitrary code before the first
	    // update cycle runs. They will be executed in the same order as the update
	    // cycle. This is useful when a modifier adds some persistent data that
	    // other modifiers need to use, but the modifier is run after the dependent
	    // one.
	
	    function runModifierEffects() {
	      state.orderedModifiers.forEach(function (_ref) {
	        var name = _ref.name,
	            _ref$options = _ref.options,
	            options = _ref$options === void 0 ? {} : _ref$options,
	            effect = _ref.effect;
	
	        if (typeof effect === 'function') {
	          var cleanupFn = effect({
	            state: state,
	            name: name,
	            instance: instance,
	            options: options
	          });
	
	          var noopFn = function noopFn() {};
	
	          effectCleanupFns.push(cleanupFn || noopFn);
	        }
	      });
	    }
	
	    function cleanupModifierEffects() {
	      effectCleanupFns.forEach(function (fn) {
	        return fn();
	      });
	      effectCleanupFns = [];
	    }
	
	    return instance;
	  };
	}
	
	var passive = {
	  passive: true
	};
	
	function effect$2(_ref) {
	  var state = _ref.state,
	      instance = _ref.instance,
	      options = _ref.options;
	  var _options$scroll = options.scroll,
	      scroll = _options$scroll === void 0 ? true : _options$scroll,
	      _options$resize = options.resize,
	      resize = _options$resize === void 0 ? true : _options$resize;
	  var window = getWindow(state.elements.popper);
	  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
	
	  if (scroll) {
	    scrollParents.forEach(function (scrollParent) {
	      scrollParent.addEventListener('scroll', instance.update, passive);
	    });
	  }
	
	  if (resize) {
	    window.addEventListener('resize', instance.update, passive);
	  }
	
	  return function () {
	    if (scroll) {
	      scrollParents.forEach(function (scrollParent) {
	        scrollParent.removeEventListener('scroll', instance.update, passive);
	      });
	    }
	
	    if (resize) {
	      window.removeEventListener('resize', instance.update, passive);
	    }
	  };
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var eventListeners = {
	  name: 'eventListeners',
	  enabled: true,
	  phase: 'write',
	  fn: function fn() {},
	  effect: effect$2,
	  data: {}
	};
	
	function popperOffsets(_ref) {
	  var state = _ref.state,
	      name = _ref.name;
	  // Offsets are the actual position the popper needs to have to be
	  // properly positioned near its reference element
	  // This is the most basic placement, and will be adjusted by
	  // the modifiers in the next step
	  state.modifiersData[name] = computeOffsets({
	    reference: state.rects.reference,
	    element: state.rects.popper,
	    strategy: 'absolute',
	    placement: state.placement
	  });
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var popperOffsets$1 = {
	  name: 'popperOffsets',
	  enabled: true,
	  phase: 'read',
	  fn: popperOffsets,
	  data: {}
	};
	
	var unsetSides = {
	  top: 'auto',
	  right: 'auto',
	  bottom: 'auto',
	  left: 'auto'
	}; // Round the offsets to the nearest suitable subpixel based on the DPR.
	// Zooming can change the DPR, but it seems to report a value that will
	// cleanly divide the values into the appropriate subpixels.
	
	function roundOffsetsByDPR(_ref, win) {
	  var x = _ref.x,
	      y = _ref.y;
	  var dpr = win.devicePixelRatio || 1;
	  return {
	    x: round(x * dpr) / dpr || 0,
	    y: round(y * dpr) / dpr || 0
	  };
	}
	
	function mapToStyles(_ref2) {
	  var _Object$assign2;
	
	  var popper = _ref2.popper,
	      popperRect = _ref2.popperRect,
	      placement = _ref2.placement,
	      variation = _ref2.variation,
	      offsets = _ref2.offsets,
	      position = _ref2.position,
	      gpuAcceleration = _ref2.gpuAcceleration,
	      adaptive = _ref2.adaptive,
	      roundOffsets = _ref2.roundOffsets,
	      isFixed = _ref2.isFixed;
	  var _offsets$x = offsets.x,
	      x = _offsets$x === void 0 ? 0 : _offsets$x,
	      _offsets$y = offsets.y,
	      y = _offsets$y === void 0 ? 0 : _offsets$y;
	
	  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
	    x: x,
	    y: y
	  }) : {
	    x: x,
	    y: y
	  };
	
	  x = _ref3.x;
	  y = _ref3.y;
	  var hasX = offsets.hasOwnProperty('x');
	  var hasY = offsets.hasOwnProperty('y');
	  var sideX = left;
	  var sideY = top;
	  var win = window;
	
	  if (adaptive) {
	    var offsetParent = getOffsetParent(popper);
	    var heightProp = 'clientHeight';
	    var widthProp = 'clientWidth';
	
	    if (offsetParent === getWindow(popper)) {
	      offsetParent = getDocumentElement(popper);
	
	      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
	        heightProp = 'scrollHeight';
	        widthProp = 'scrollWidth';
	      }
	    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
	
	
	    offsetParent = offsetParent;
	
	    if (placement === top || (placement === left || placement === right) && variation === end) {
	      sideY = bottom;
	      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
	      offsetParent[heightProp];
	      y -= offsetY - popperRect.height;
	      y *= gpuAcceleration ? 1 : -1;
	    }
	
	    if (placement === left || (placement === top || placement === bottom) && variation === end) {
	      sideX = right;
	      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
	      offsetParent[widthProp];
	      x -= offsetX - popperRect.width;
	      x *= gpuAcceleration ? 1 : -1;
	    }
	  }
	
	  var commonStyles = Object.assign({
	    position: position
	  }, adaptive && unsetSides);
	
	  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
	    x: x,
	    y: y
	  }, getWindow(popper)) : {
	    x: x,
	    y: y
	  };
	
	  x = _ref4.x;
	  y = _ref4.y;
	
	  if (gpuAcceleration) {
	    var _Object$assign;
	
	    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
	  }
	
	  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
	}
	
	function computeStyles(_ref5) {
	  var state = _ref5.state,
	      options = _ref5.options;
	  var _options$gpuAccelerat = options.gpuAcceleration,
	      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
	      _options$adaptive = options.adaptive,
	      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
	      _options$roundOffsets = options.roundOffsets,
	      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
	  var commonStyles = {
	    placement: getBasePlacement(state.placement),
	    variation: getVariation(state.placement),
	    popper: state.elements.popper,
	    popperRect: state.rects.popper,
	    gpuAcceleration: gpuAcceleration,
	    isFixed: state.options.strategy === 'fixed'
	  };
	
	  if (state.modifiersData.popperOffsets != null) {
	    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
	      offsets: state.modifiersData.popperOffsets,
	      position: state.options.strategy,
	      adaptive: adaptive,
	      roundOffsets: roundOffsets
	    })));
	  }
	
	  if (state.modifiersData.arrow != null) {
	    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
	      offsets: state.modifiersData.arrow,
	      position: 'absolute',
	      adaptive: false,
	      roundOffsets: roundOffsets
	    })));
	  }
	
	  state.attributes.popper = Object.assign({}, state.attributes.popper, {
	    'data-popper-placement': state.placement
	  });
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var computeStyles$1 = {
	  name: 'computeStyles',
	  enabled: true,
	  phase: 'beforeWrite',
	  fn: computeStyles,
	  data: {}
	};
	
	// and applies them to the HTMLElements such as popper and arrow
	
	function applyStyles(_ref) {
	  var state = _ref.state;
	  Object.keys(state.elements).forEach(function (name) {
	    var style = state.styles[name] || {};
	    var attributes = state.attributes[name] || {};
	    var element = state.elements[name]; // arrow is optional + virtual elements
	
	    if (!isHTMLElement(element) || !getNodeName(element)) {
	      return;
	    } // Flow doesn't support to extend this property, but it's the most
	    // effective way to apply styles to an HTMLElement
	    // $FlowFixMe[cannot-write]
	
	
	    Object.assign(element.style, style);
	    Object.keys(attributes).forEach(function (name) {
	      var value = attributes[name];
	
	      if (value === false) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, value === true ? '' : value);
	      }
	    });
	  });
	}
	
	function effect$1(_ref2) {
	  var state = _ref2.state;
	  var initialStyles = {
	    popper: {
	      position: state.options.strategy,
	      left: '0',
	      top: '0',
	      margin: '0'
	    },
	    arrow: {
	      position: 'absolute'
	    },
	    reference: {}
	  };
	  Object.assign(state.elements.popper.style, initialStyles.popper);
	  state.styles = initialStyles;
	
	  if (state.elements.arrow) {
	    Object.assign(state.elements.arrow.style, initialStyles.arrow);
	  }
	
	  return function () {
	    Object.keys(state.elements).forEach(function (name) {
	      var element = state.elements[name];
	      var attributes = state.attributes[name] || {};
	      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
	
	      var style = styleProperties.reduce(function (style, property) {
	        style[property] = '';
	        return style;
	      }, {}); // arrow is optional + virtual elements
	
	      if (!isHTMLElement(element) || !getNodeName(element)) {
	        return;
	      }
	
	      Object.assign(element.style, style);
	      Object.keys(attributes).forEach(function (attribute) {
	        element.removeAttribute(attribute);
	      });
	    });
	  };
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var applyStyles$1 = {
	  name: 'applyStyles',
	  enabled: true,
	  phase: 'write',
	  fn: applyStyles,
	  effect: effect$1,
	  requires: ['computeStyles']
	};
	
	function distanceAndSkiddingToXY(placement, rects, offset) {
	  var basePlacement = getBasePlacement(placement);
	  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
	
	  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
	    placement: placement
	  })) : offset,
	      skidding = _ref[0],
	      distance = _ref[1];
	
	  skidding = skidding || 0;
	  distance = (distance || 0) * invertDistance;
	  return [left, right].indexOf(basePlacement) >= 0 ? {
	    x: distance,
	    y: skidding
	  } : {
	    x: skidding,
	    y: distance
	  };
	}
	
	function offset(_ref2) {
	  var state = _ref2.state,
	      options = _ref2.options,
	      name = _ref2.name;
	  var _options$offset = options.offset,
	      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
	  var data = placements.reduce(function (acc, placement) {
	    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
	    return acc;
	  }, {});
	  var _data$state$placement = data[state.placement],
	      x = _data$state$placement.x,
	      y = _data$state$placement.y;
	
	  if (state.modifiersData.popperOffsets != null) {
	    state.modifiersData.popperOffsets.x += x;
	    state.modifiersData.popperOffsets.y += y;
	  }
	
	  state.modifiersData[name] = data;
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var offset$1 = {
	  name: 'offset',
	  enabled: true,
	  phase: 'main',
	  requires: ['popperOffsets'],
	  fn: offset
	};
	
	var hash$1 = {
	  left: 'right',
	  right: 'left',
	  bottom: 'top',
	  top: 'bottom'
	};
	function getOppositePlacement(placement) {
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash$1[matched];
	  });
	}
	
	var hash = {
	  start: 'end',
	  end: 'start'
	};
	function getOppositeVariationPlacement(placement) {
	  return placement.replace(/start|end/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	function computeAutoPlacement(state, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      placement = _options.placement,
	      boundary = _options.boundary,
	      rootBoundary = _options.rootBoundary,
	      padding = _options.padding,
	      flipVariations = _options.flipVariations,
	      _options$allowedAutoP = _options.allowedAutoPlacements,
	      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
	  var variation = getVariation(placement);
	  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
	    return getVariation(placement) === variation;
	  }) : basePlacements;
	  var allowedPlacements = placements$1.filter(function (placement) {
	    return allowedAutoPlacements.indexOf(placement) >= 0;
	  });
	
	  if (allowedPlacements.length === 0) {
	    allowedPlacements = placements$1;
	  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
	
	
	  var overflows = allowedPlacements.reduce(function (acc, placement) {
	    acc[placement] = detectOverflow(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      padding: padding
	    })[getBasePlacement(placement)];
	    return acc;
	  }, {});
	  return Object.keys(overflows).sort(function (a, b) {
	    return overflows[a] - overflows[b];
	  });
	}
	
	function getExpandedFallbackPlacements(placement) {
	  if (getBasePlacement(placement) === auto) {
	    return [];
	  }
	
	  var oppositePlacement = getOppositePlacement(placement);
	  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
	}
	
	function flip(_ref) {
	  var state = _ref.state,
	      options = _ref.options,
	      name = _ref.name;
	
	  if (state.modifiersData[name]._skip) {
	    return;
	  }
	
	  var _options$mainAxis = options.mainAxis,
	      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
	      _options$altAxis = options.altAxis,
	      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
	      specifiedFallbackPlacements = options.fallbackPlacements,
	      padding = options.padding,
	      boundary = options.boundary,
	      rootBoundary = options.rootBoundary,
	      altBoundary = options.altBoundary,
	      _options$flipVariatio = options.flipVariations,
	      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
	      allowedAutoPlacements = options.allowedAutoPlacements;
	  var preferredPlacement = state.options.placement;
	  var basePlacement = getBasePlacement(preferredPlacement);
	  var isBasePlacement = basePlacement === preferredPlacement;
	  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
	  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
	    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      padding: padding,
	      flipVariations: flipVariations,
	      allowedAutoPlacements: allowedAutoPlacements
	    }) : placement);
	  }, []);
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var checksMap = new Map();
	  var makeFallbackChecks = true;
	  var firstFittingPlacement = placements[0];
	
	  for (var i = 0; i < placements.length; i++) {
	    var placement = placements[i];
	
	    var _basePlacement = getBasePlacement(placement);
	
	    var isStartVariation = getVariation(placement) === start;
	    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
	    var len = isVertical ? 'width' : 'height';
	    var overflow = detectOverflow(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      altBoundary: altBoundary,
	      padding: padding
	    });
	    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
	
	    if (referenceRect[len] > popperRect[len]) {
	      mainVariationSide = getOppositePlacement(mainVariationSide);
	    }
	
	    var altVariationSide = getOppositePlacement(mainVariationSide);
	    var checks = [];
	
	    if (checkMainAxis) {
	      checks.push(overflow[_basePlacement] <= 0);
	    }
	
	    if (checkAltAxis) {
	      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
	    }
	
	    if (checks.every(function (check) {
	      return check;
	    })) {
	      firstFittingPlacement = placement;
	      makeFallbackChecks = false;
	      break;
	    }
	
	    checksMap.set(placement, checks);
	  }
	
	  if (makeFallbackChecks) {
	    // `2` may be desired in some cases – research later
	    var numberOfChecks = flipVariations ? 3 : 1;
	
	    var _loop = function _loop(_i) {
	      var fittingPlacement = placements.find(function (placement) {
	        var checks = checksMap.get(placement);
	
	        if (checks) {
	          return checks.slice(0, _i).every(function (check) {
	            return check;
	          });
	        }
	      });
	
	      if (fittingPlacement) {
	        firstFittingPlacement = fittingPlacement;
	        return "break";
	      }
	    };
	
	    for (var _i = numberOfChecks; _i > 0; _i--) {
	      var _ret = _loop(_i);
	
	      if (_ret === "break") break;
	    }
	  }
	
	  if (state.placement !== firstFittingPlacement) {
	    state.modifiersData[name]._skip = true;
	    state.placement = firstFittingPlacement;
	    state.reset = true;
	  }
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var flip$1 = {
	  name: 'flip',
	  enabled: true,
	  phase: 'main',
	  fn: flip,
	  requiresIfExists: ['offset'],
	  data: {
	    _skip: false
	  }
	};
	
	function getAltAxis(axis) {
	  return axis === 'x' ? 'y' : 'x';
	}
	
	function within(min$1, value, max$1) {
	  return max(min$1, min(value, max$1));
	}
	function withinMaxClamp(min, value, max) {
	  var v = within(min, value, max);
	  return v > max ? max : v;
	}
	
	function preventOverflow(_ref) {
	  var state = _ref.state,
	      options = _ref.options,
	      name = _ref.name;
	  var _options$mainAxis = options.mainAxis,
	      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
	      _options$altAxis = options.altAxis,
	      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
	      boundary = options.boundary,
	      rootBoundary = options.rootBoundary,
	      altBoundary = options.altBoundary,
	      padding = options.padding,
	      _options$tether = options.tether,
	      tether = _options$tether === void 0 ? true : _options$tether,
	      _options$tetherOffset = options.tetherOffset,
	      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
	  var overflow = detectOverflow(state, {
	    boundary: boundary,
	    rootBoundary: rootBoundary,
	    padding: padding,
	    altBoundary: altBoundary
	  });
	  var basePlacement = getBasePlacement(state.placement);
	  var variation = getVariation(state.placement);
	  var isBasePlacement = !variation;
	  var mainAxis = getMainAxisFromPlacement(basePlacement);
	  var altAxis = getAltAxis(mainAxis);
	  var popperOffsets = state.modifiersData.popperOffsets;
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
	    placement: state.placement
	  })) : tetherOffset;
	  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
	    mainAxis: tetherOffsetValue,
	    altAxis: tetherOffsetValue
	  } : Object.assign({
	    mainAxis: 0,
	    altAxis: 0
	  }, tetherOffsetValue);
	  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
	  var data = {
	    x: 0,
	    y: 0
	  };
	
	  if (!popperOffsets) {
	    return;
	  }
	
	  if (checkMainAxis) {
	    var _offsetModifierState$;
	
	    var mainSide = mainAxis === 'y' ? top : left;
	    var altSide = mainAxis === 'y' ? bottom : right;
	    var len = mainAxis === 'y' ? 'height' : 'width';
	    var offset = popperOffsets[mainAxis];
	    var min$1 = offset + overflow[mainSide];
	    var max$1 = offset - overflow[altSide];
	    var additive = tether ? -popperRect[len] / 2 : 0;
	    var minLen = variation === start ? referenceRect[len] : popperRect[len];
	    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
	    // outside the reference bounds
	
	    var arrowElement = state.elements.arrow;
	    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
	      width: 0,
	      height: 0
	    };
	    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
	    var arrowPaddingMin = arrowPaddingObject[mainSide];
	    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
	    // to include its full size in the calculation. If the reference is small
	    // and near the edge of a boundary, the popper can overflow even if the
	    // reference is not overflowing as well (e.g. virtual elements with no
	    // width or height)
	
	    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
	    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
	    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
	    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
	    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
	    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
	    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
	    var tetherMax = offset + maxOffset - offsetModifierValue;
	    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
	    popperOffsets[mainAxis] = preventedOffset;
	    data[mainAxis] = preventedOffset - offset;
	  }
	
	  if (checkAltAxis) {
	    var _offsetModifierState$2;
	
	    var _mainSide = mainAxis === 'x' ? top : left;
	
	    var _altSide = mainAxis === 'x' ? bottom : right;
	
	    var _offset = popperOffsets[altAxis];
	
	    var _len = altAxis === 'y' ? 'height' : 'width';
	
	    var _min = _offset + overflow[_mainSide];
	
	    var _max = _offset - overflow[_altSide];
	
	    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
	
	    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
	
	    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
	
	    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
	
	    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
	
	    popperOffsets[altAxis] = _preventedOffset;
	    data[altAxis] = _preventedOffset - _offset;
	  }
	
	  state.modifiersData[name] = data;
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var preventOverflow$1 = {
	  name: 'preventOverflow',
	  enabled: true,
	  phase: 'main',
	  fn: preventOverflow,
	  requiresIfExists: ['offset']
	};
	
	var toPaddingObject = function toPaddingObject(padding, state) {
	  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
	    placement: state.placement
	  })) : padding;
	  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
	};
	
	function arrow(_ref) {
	  var _state$modifiersData$;
	
	  var state = _ref.state,
	      name = _ref.name,
	      options = _ref.options;
	  var arrowElement = state.elements.arrow;
	  var popperOffsets = state.modifiersData.popperOffsets;
	  var basePlacement = getBasePlacement(state.placement);
	  var axis = getMainAxisFromPlacement(basePlacement);
	  var isVertical = [left, right].indexOf(basePlacement) >= 0;
	  var len = isVertical ? 'height' : 'width';
	
	  if (!arrowElement || !popperOffsets) {
	    return;
	  }
	
	  var paddingObject = toPaddingObject(options.padding, state);
	  var arrowRect = getLayoutRect(arrowElement);
	  var minProp = axis === 'y' ? top : left;
	  var maxProp = axis === 'y' ? bottom : right;
	  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
	  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
	  var arrowOffsetParent = getOffsetParent(arrowElement);
	  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
	  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
	  // outside of the popper bounds
	
	  var min = paddingObject[minProp];
	  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
	  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
	  var offset = within(min, center, max); // Prevents breaking syntax highlighting...
	
	  var axisProp = axis;
	  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
	}
	
	function effect(_ref2) {
	  var state = _ref2.state,
	      options = _ref2.options;
	  var _options$element = options.element,
	      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
	
	  if (arrowElement == null) {
	    return;
	  } // CSS selector
	
	
	  if (typeof arrowElement === 'string') {
	    arrowElement = state.elements.popper.querySelector(arrowElement);
	
	    if (!arrowElement) {
	      return;
	    }
	  }
	
	  if (!contains(state.elements.popper, arrowElement)) {
	    return;
	  }
	
	  state.elements.arrow = arrowElement;
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var arrow$1 = {
	  name: 'arrow',
	  enabled: true,
	  phase: 'main',
	  fn: arrow,
	  effect: effect,
	  requires: ['popperOffsets'],
	  requiresIfExists: ['preventOverflow']
	};
	
	function getSideOffsets(overflow, rect, preventedOffsets) {
	  if (preventedOffsets === void 0) {
	    preventedOffsets = {
	      x: 0,
	      y: 0
	    };
	  }
	
	  return {
	    top: overflow.top - rect.height - preventedOffsets.y,
	    right: overflow.right - rect.width + preventedOffsets.x,
	    bottom: overflow.bottom - rect.height + preventedOffsets.y,
	    left: overflow.left - rect.width - preventedOffsets.x
	  };
	}
	
	function isAnySideFullyClipped(overflow) {
	  return [top, right, bottom, left].some(function (side) {
	    return overflow[side] >= 0;
	  });
	}
	
	function hide(_ref) {
	  var state = _ref.state,
	      name = _ref.name;
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var preventedOffsets = state.modifiersData.preventOverflow;
	  var referenceOverflow = detectOverflow(state, {
	    elementContext: 'reference'
	  });
	  var popperAltOverflow = detectOverflow(state, {
	    altBoundary: true
	  });
	  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
	  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
	  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
	  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
	  state.modifiersData[name] = {
	    referenceClippingOffsets: referenceClippingOffsets,
	    popperEscapeOffsets: popperEscapeOffsets,
	    isReferenceHidden: isReferenceHidden,
	    hasPopperEscaped: hasPopperEscaped
	  };
	  state.attributes.popper = Object.assign({}, state.attributes.popper, {
	    'data-popper-reference-hidden': isReferenceHidden,
	    'data-popper-escaped': hasPopperEscaped
	  });
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var hide$1 = {
	  name: 'hide',
	  enabled: true,
	  phase: 'main',
	  requiresIfExists: ['preventOverflow'],
	  fn: hide
	};
	
	var defaultModifiers$1 = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1];
	var createPopper$1 = /*#__PURE__*/popperGenerator({
	  defaultModifiers: defaultModifiers$1
	}); // eslint-disable-next-line import/no-unused-modules
	
	var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
	var createPopper = /*#__PURE__*/popperGenerator({
	  defaultModifiers: defaultModifiers
	}); // eslint-disable-next-line import/no-unused-modules
	
	exports.applyStyles = applyStyles$1;
	exports.arrow = arrow$1;
	exports.computeStyles = computeStyles$1;
	exports.createPopper = createPopper;
	exports.createPopperLite = createPopper$1;
	exports.defaultModifiers = defaultModifiers;
	exports.detectOverflow = detectOverflow;
	exports.eventListeners = eventListeners;
	exports.flip = flip$1;
	exports.hide = hide$1;
	exports.offset = offset$1;
	exports.popperGenerator = popperGenerator;
	exports.popperOffsets = popperOffsets$1;
	exports.preventOverflow = preventOverflow$1;
	//# sourceMappingURL=popper.js.map


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ScriptLoader = void 0;
	var Utils_1 = __webpack_require__(185);
	var injectScriptTag = function (doc, item, handler) {
	    var _a, _b;
	    var scriptTag = doc.createElement('script');
	    scriptTag.referrerPolicy = 'origin';
	    scriptTag.type = 'application/javascript';
	    scriptTag.id = item.id;
	    scriptTag.src = item.src;
	    scriptTag.async = (_a = item.async) !== null && _a !== void 0 ? _a : false;
	    scriptTag.defer = (_b = item.defer) !== null && _b !== void 0 ? _b : false;
	    var loadHandler = function () {
	        scriptTag.removeEventListener('load', loadHandler);
	        scriptTag.removeEventListener('error', errorHandler);
	        handler(item.src);
	    };
	    var errorHandler = function (err) {
	        scriptTag.removeEventListener('load', loadHandler);
	        scriptTag.removeEventListener('error', errorHandler);
	        handler(item.src, err);
	    };
	    scriptTag.addEventListener('load', loadHandler);
	    scriptTag.addEventListener('error', errorHandler);
	    if (doc.head) {
	        doc.head.appendChild(scriptTag);
	    }
	};
	var createDocumentScriptLoader = function (doc) {
	    var lookup = {};
	    var scriptLoadOrErrorHandler = function (src, err) {
	        var item = lookup[src];
	        item.done = true;
	        item.error = err;
	        for (var _i = 0, _a = item.handlers; _i < _a.length; _i++) {
	            var h = _a[_i];
	            h(src, err);
	        }
	        item.handlers = [];
	    };
	    var loadScripts = function (items, success, failure) {
	        // eslint-disable-next-line no-console
	        var failureOrLog = function (err) { return failure !== undefined ? failure(err) : console.error(err); };
	        if (items.length === 0) {
	            failureOrLog(new Error('At least one script must be provided'));
	            return;
	        }
	        var successCount = 0;
	        var failed = false;
	        var loaded = function (_src, err) {
	            if (failed) {
	                return;
	            }
	            if (err) {
	                failed = true;
	                failureOrLog(err);
	            }
	            else if (++successCount === items.length) {
	                success();
	            }
	        };
	        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
	            var item = items_1[_i];
	            var existing = lookup[item.src];
	            if (existing) {
	                if (existing.done) {
	                    loaded(item.src, existing.error);
	                }
	                else {
	                    existing.handlers.push(loaded);
	                }
	            }
	            else {
	                // create a new entry
	                var id = (0, Utils_1.uuid)('tiny-');
	                lookup[item.src] = {
	                    id: id,
	                    src: item.src,
	                    done: false,
	                    error: null,
	                    handlers: [loaded],
	                };
	                injectScriptTag(doc, __assign({ id: id }, item), scriptLoadOrErrorHandler);
	            }
	        }
	    };
	    var deleteScripts = function () {
	        var _a;
	        for (var _i = 0, _b = Object.values(lookup); _i < _b.length; _i++) {
	            var item = _b[_i];
	            var scriptTag = doc.getElementById(item.id);
	            if (scriptTag != null && scriptTag.tagName === 'SCRIPT') {
	                (_a = scriptTag.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(scriptTag);
	            }
	        }
	        lookup = {};
	    };
	    var getDocument = function () { return doc; };
	    return {
	        loadScripts: loadScripts,
	        deleteScripts: deleteScripts,
	        getDocument: getDocument
	    };
	};
	var createScriptLoader = function () {
	    var cache = [];
	    var getDocumentScriptLoader = function (doc) {
	        var loader = cache.find(function (l) { return l.getDocument() === doc; });
	        if (loader === undefined) {
	            loader = createDocumentScriptLoader(doc);
	            cache.push(loader);
	        }
	        return loader;
	    };
	    var loadList = function (doc, items, delay, success, failure) {
	        var doLoad = function () { return getDocumentScriptLoader(doc).loadScripts(items, success, failure); };
	        if (delay > 0) {
	            setTimeout(doLoad, delay);
	        }
	        else {
	            doLoad();
	        }
	    };
	    var reinitialize = function () {
	        for (var loader = cache.pop(); loader != null; loader = cache.pop()) {
	            loader.deleteScripts();
	        }
	    };
	    return {
	        loadList: loadList,
	        reinitialize: reinitialize
	    };
	};
	exports.ScriptLoader = createScriptLoader();


/***/ },
/* 470 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getTinymce = void 0;
	var getTinymce = function (view) {
	    var global = view;
	    return global && global.tinymce ? global.tinymce : null;
	};
	exports.getTinymce = getTinymce;


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Editor = void 0;
	var React = __webpack_require__(1);
	var ScriptLoader2_1 = __webpack_require__(469);
	var TinyMCE_1 = __webpack_require__(470);
	var Utils_1 = __webpack_require__(185);
	var EditorPropTypes_1 = __webpack_require__(186);
	/**
	 * @see {@link https://www.tiny.cloud/docs/tinymce/7/react-ref/} for the TinyMCE React Technical Reference
	 */
	var Editor = /** @class */ (function (_super) {
	    __extends(Editor, _super);
	    function Editor(props) {
	        var _a, _b, _c;
	        var _this = _super.call(this, props) || this;
	        _this.rollbackTimer = undefined;
	        _this.valueCursor = undefined;
	        _this.rollbackChange = function () {
	            var editor = _this.editor;
	            var value = _this.props.value;
	            if (editor && value && value !== _this.currentContent) {
	                editor.undoManager.ignore(function () {
	                    editor.setContent(value);
	                    // only restore cursor on inline editors when they are focused
	                    // as otherwise it will cause a focus grab
	                    if (_this.valueCursor && (!_this.inline || editor.hasFocus())) {
	                        try {
	                            editor.selection.moveToBookmark(_this.valueCursor);
	                        }
	                        catch (e) { /* ignore */ }
	                    }
	                });
	            }
	            _this.rollbackTimer = undefined;
	        };
	        _this.handleBeforeInput = function (_evt) {
	            if (_this.props.value !== undefined && _this.props.value === _this.currentContent && _this.editor) {
	                if (!_this.inline || _this.editor.hasFocus()) {
	                    try {
	                        // getBookmark throws exceptions when the editor has not been focused
	                        // possibly only in inline mode but I'm not taking chances
	                        _this.valueCursor = _this.editor.selection.getBookmark(3);
	                    }
	                    catch (e) { /* ignore */ }
	                }
	            }
	        };
	        _this.handleBeforeInputSpecial = function (evt) {
	            if (evt.key === 'Enter' || evt.key === 'Backspace' || evt.key === 'Delete') {
	                _this.handleBeforeInput(evt);
	            }
	        };
	        _this.handleEditorChange = function (_evt) {
	            var editor = _this.editor;
	            if (editor && editor.initialized) {
	                var newContent = editor.getContent();
	                if (_this.props.value !== undefined && _this.props.value !== newContent && _this.props.rollback !== false) {
	                    // start a timer and revert to the value if not applied in time
	                    if (!_this.rollbackTimer) {
	                        _this.rollbackTimer = window.setTimeout(_this.rollbackChange, typeof _this.props.rollback === 'number' ? _this.props.rollback : 200);
	                    }
	                }
	                if (newContent !== _this.currentContent) {
	                    _this.currentContent = newContent;
	                    if ((0, Utils_1.isFunction)(_this.props.onEditorChange)) {
	                        _this.props.onEditorChange(newContent, editor);
	                    }
	                }
	            }
	        };
	        _this.handleEditorChangeSpecial = function (evt) {
	            if (evt.key === 'Backspace' || evt.key === 'Delete') {
	                _this.handleEditorChange(evt);
	            }
	        };
	        _this.initialise = function (attempts) {
	            var _a, _b, _c;
	            if (attempts === void 0) { attempts = 0; }
	            var target = _this.elementRef.current;
	            if (!target) {
	                return; // Editor has been unmounted
	            }
	            if (!(0, Utils_1.isInDoc)(target)) {
	                // this is probably someone trying to help by rendering us offscreen
	                // but we can't do that because the editor iframe must be in the document
	                // in order to have state
	                if (attempts === 0) {
	                    // we probably just need to wait for the current events to be processed
	                    setTimeout(function () { return _this.initialise(1); }, 1);
	                }
	                else if (attempts < 100) {
	                    // wait for ten seconds, polling every tenth of a second
	                    setTimeout(function () { return _this.initialise(attempts + 1); }, 100);
	                }
	                else {
	                    // give up, at this point it seems that more polling is unlikely to help
	                    throw new Error('tinymce can only be initialised when in a document');
	                }
	                return;
	            }
	            var tinymce = (0, TinyMCE_1.getTinymce)(_this.view);
	            if (!tinymce) {
	                throw new Error('tinymce should have been loaded into global scope');
	            }
	            var finalInit = __assign(__assign(__assign(__assign({}, _this.props.init), { selector: undefined, target: target, readonly: _this.props.disabled, inline: _this.inline, plugins: (0, Utils_1.mergePlugins)((_a = _this.props.init) === null || _a === void 0 ? void 0 : _a.plugins, _this.props.plugins), toolbar: (_b = _this.props.toolbar) !== null && _b !== void 0 ? _b : (_c = _this.props.init) === null || _c === void 0 ? void 0 : _c.toolbar }), (_this.props.licenseKey ? { license_key: _this.props.licenseKey } : {})), { setup: function (editor) {
	                    _this.editor = editor;
	                    _this.bindHandlers({});
	                    // When running in inline mode the editor gets the initial value
	                    // from the innerHTML of the element it is initialized on.
	                    // However we don't want to take on the responsibility of sanitizing
	                    // to remove XSS in the react integration so we have a chicken and egg
	                    // problem... We avoid it by sneaking in a set content before the first
	                    // "official" setContent and using TinyMCE to do the sanitization.
	                    if (_this.inline && !(0, Utils_1.isTextareaOrInput)(target)) {
	                        editor.once('PostRender', function (_evt) {
	                            editor.setContent(_this.getInitialValue(), { no_events: true });
	                        });
	                    }
	                    if (_this.props.init && (0, Utils_1.isFunction)(_this.props.init.setup)) {
	                        _this.props.init.setup(editor);
	                    }
	                }, init_instance_callback: function (editor) {
	                    var _a, _b;
	                    // check for changes that happened since tinymce.init() was called
	                    var initialValue = _this.getInitialValue();
	                    _this.currentContent = (_a = _this.currentContent) !== null && _a !== void 0 ? _a : editor.getContent();
	                    if (_this.currentContent !== initialValue) {
	                        _this.currentContent = initialValue;
	                        // same as resetContent in TinyMCE 5
	                        editor.setContent(initialValue);
	                        editor.undoManager.clear();
	                        editor.undoManager.add();
	                        editor.setDirty(false);
	                    }
	                    var disabled = (_b = _this.props.disabled) !== null && _b !== void 0 ? _b : false;
	                    (0, Utils_1.setMode)(_this.editor, disabled ? 'readonly' : 'design');
	                    // ensure existing init_instance_callback is called
	                    if (_this.props.init && (0, Utils_1.isFunction)(_this.props.init.init_instance_callback)) {
	                        _this.props.init.init_instance_callback(editor);
	                    }
	                } });
	            if (!_this.inline) {
	                target.style.visibility = '';
	            }
	            if ((0, Utils_1.isTextareaOrInput)(target)) {
	                target.value = _this.getInitialValue();
	            }
	            tinymce.init(finalInit);
	        };
	        _this.id = _this.props.id || (0, Utils_1.uuid)('tiny-react');
	        _this.elementRef = React.createRef();
	        _this.inline = (_c = (_a = _this.props.inline) !== null && _a !== void 0 ? _a : (_b = _this.props.init) === null || _b === void 0 ? void 0 : _b.inline) !== null && _c !== void 0 ? _c : false;
	        _this.boundHandlers = {};
	        return _this;
	    }
	    Object.defineProperty(Editor.prototype, "view", {
	        get: function () {
	            var _a, _b;
	            return (_b = (_a = this.elementRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument.defaultView) !== null && _b !== void 0 ? _b : window;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Editor.prototype.componentDidUpdate = function (prevProps) {
	        var _this = this;
	        var _a, _b;
	        if (this.rollbackTimer) {
	            clearTimeout(this.rollbackTimer);
	            this.rollbackTimer = undefined;
	        }
	        if (this.editor) {
	            this.bindHandlers(prevProps);
	            if (this.editor.initialized) {
	                this.currentContent = (_a = this.currentContent) !== null && _a !== void 0 ? _a : this.editor.getContent();
	                if (typeof this.props.initialValue === 'string' && this.props.initialValue !== prevProps.initialValue) {
	                    // same as resetContent in TinyMCE 5
	                    this.editor.setContent(this.props.initialValue);
	                    this.editor.undoManager.clear();
	                    this.editor.undoManager.add();
	                    this.editor.setDirty(false);
	                }
	                else if (typeof this.props.value === 'string' && this.props.value !== this.currentContent) {
	                    var localEditor_1 = this.editor;
	                    localEditor_1.undoManager.transact(function () {
	                        // inline editors grab focus when restoring selection
	                        // so we don't try to keep their selection unless they are currently focused
	                        var cursor;
	                        if (!_this.inline || localEditor_1.hasFocus()) {
	                            try {
	                                // getBookmark throws exceptions when the editor has not been focused
	                                // possibly only in inline mode but I'm not taking chances
	                                cursor = localEditor_1.selection.getBookmark(3);
	                            }
	                            catch (e) { /* ignore */ }
	                        }
	                        var valueCursor = _this.valueCursor;
	                        localEditor_1.setContent(_this.props.value);
	                        if (!_this.inline || localEditor_1.hasFocus()) {
	                            for (var _i = 0, _a = [cursor, valueCursor]; _i < _a.length; _i++) {
	                                var bookmark = _a[_i];
	                                if (bookmark) {
	                                    try {
	                                        localEditor_1.selection.moveToBookmark(bookmark);
	                                        _this.valueCursor = bookmark;
	                                        break;
	                                    }
	                                    catch (e) { /* ignore */ }
	                                }
	                            }
	                        }
	                    });
	                }
	                if (this.props.disabled !== prevProps.disabled) {
	                    var disabled = (_b = this.props.disabled) !== null && _b !== void 0 ? _b : false;
	                    (0, Utils_1.setMode)(this.editor, disabled ? 'readonly' : 'design');
	                }
	            }
	        }
	    };
	    Editor.prototype.componentDidMount = function () {
	        var _this = this;
	        var _a, _b, _c, _d, _e;
	        if ((0, TinyMCE_1.getTinymce)(this.view) !== null) {
	            this.initialise();
	        }
	        else if (Array.isArray(this.props.tinymceScriptSrc) && this.props.tinymceScriptSrc.length === 0) {
	            (_b = (_a = this.props).onScriptsLoadError) === null || _b === void 0 ? void 0 : _b.call(_a, new Error('No `tinymce` global is present but the `tinymceScriptSrc` prop was an empty array.'));
	        }
	        else if ((_c = this.elementRef.current) === null || _c === void 0 ? void 0 : _c.ownerDocument) {
	            var successHandler = function () {
	                var _a, _b;
	                (_b = (_a = _this.props).onScriptsLoad) === null || _b === void 0 ? void 0 : _b.call(_a);
	                _this.initialise();
	            };
	            var errorHandler = function (err) {
	                var _a, _b;
	                (_b = (_a = _this.props).onScriptsLoadError) === null || _b === void 0 ? void 0 : _b.call(_a, err);
	            };
	            ScriptLoader2_1.ScriptLoader.loadList(this.elementRef.current.ownerDocument, this.getScriptSources(), (_e = (_d = this.props.scriptLoading) === null || _d === void 0 ? void 0 : _d.delay) !== null && _e !== void 0 ? _e : 0, successHandler, errorHandler);
	        }
	    };
	    Editor.prototype.componentWillUnmount = function () {
	        var _this = this;
	        var editor = this.editor;
	        if (editor) {
	            editor.off(this.changeEvents(), this.handleEditorChange);
	            editor.off(this.beforeInputEvent(), this.handleBeforeInput);
	            editor.off('keypress', this.handleEditorChangeSpecial);
	            editor.off('keydown', this.handleBeforeInputSpecial);
	            editor.off('NewBlock', this.handleEditorChange);
	            Object.keys(this.boundHandlers).forEach(function (eventName) {
	                editor.off(eventName, _this.boundHandlers[eventName]);
	            });
	            this.boundHandlers = {};
	            editor.remove();
	            this.editor = undefined;
	        }
	    };
	    Editor.prototype.render = function () {
	        return this.inline ? this.renderInline() : this.renderIframe();
	    };
	    Editor.prototype.changeEvents = function () {
	        var _a, _b, _c;
	        var isIE = (_c = (_b = (_a = (0, TinyMCE_1.getTinymce)(this.view)) === null || _a === void 0 ? void 0 : _a.Env) === null || _b === void 0 ? void 0 : _b.browser) === null || _c === void 0 ? void 0 : _c.isIE();
	        return (isIE
	            ? 'change keyup compositionend setcontent CommentChange'
	            : 'change input compositionend setcontent CommentChange');
	    };
	    Editor.prototype.beforeInputEvent = function () {
	        return (0, Utils_1.isBeforeInputEventAvailable)() ? 'beforeinput SelectionChange' : 'SelectionChange';
	    };
	    Editor.prototype.renderInline = function () {
	        var _a = this.props.tagName, tagName = _a === void 0 ? 'div' : _a;
	        return React.createElement(tagName, {
	            ref: this.elementRef,
	            id: this.id,
	            tabIndex: this.props.tabIndex
	        });
	    };
	    Editor.prototype.renderIframe = function () {
	        return React.createElement('textarea', {
	            ref: this.elementRef,
	            style: { visibility: 'hidden' },
	            name: this.props.textareaName,
	            id: this.id,
	            tabIndex: this.props.tabIndex
	        });
	    };
	    Editor.prototype.getScriptSources = function () {
	        var _a, _b;
	        var async = (_a = this.props.scriptLoading) === null || _a === void 0 ? void 0 : _a.async;
	        var defer = (_b = this.props.scriptLoading) === null || _b === void 0 ? void 0 : _b.defer;
	        if (this.props.tinymceScriptSrc !== undefined) {
	            if (typeof this.props.tinymceScriptSrc === 'string') {
	                return [{ src: this.props.tinymceScriptSrc, async: async, defer: defer }];
	            }
	            // multiple scripts can be specified which allows for hybrid mode
	            return this.props.tinymceScriptSrc.map(function (item) {
	                if (typeof item === 'string') {
	                    // async does not make sense for multiple items unless
	                    // they are not dependent (which will be unlikely)
	                    return { src: item, async: async, defer: defer };
	                }
	                else {
	                    return item;
	                }
	            });
	        }
	        // fallback to the cloud when the tinymceScriptSrc is not specified
	        var channel = this.props.cloudChannel; // `cloudChannel` is in `defaultProps`, so it's always defined.
	        var apiKey = this.props.apiKey ? this.props.apiKey : 'no-api-key';
	        var cloudTinyJs = "https://cdn.tiny.cloud/1/".concat(apiKey, "/tinymce/").concat(channel, "/tinymce.min.js");
	        return [{ src: cloudTinyJs, async: async, defer: defer }];
	    };
	    Editor.prototype.getInitialValue = function () {
	        if (typeof this.props.initialValue === 'string') {
	            return this.props.initialValue;
	        }
	        else if (typeof this.props.value === 'string') {
	            return this.props.value;
	        }
	        else {
	            return '';
	        }
	    };
	    Editor.prototype.bindHandlers = function (prevProps) {
	        var _this = this;
	        if (this.editor !== undefined) {
	            // typescript chokes trying to understand the type of the lookup function
	            (0, Utils_1.configHandlers)(this.editor, prevProps, this.props, this.boundHandlers, function (key) { return _this.props[key]; });
	            // check if we should monitor editor changes
	            var isValueControlled = function (p) { return p.onEditorChange !== undefined || p.value !== undefined; };
	            var wasControlled = isValueControlled(prevProps);
	            var nowControlled = isValueControlled(this.props);
	            if (!wasControlled && nowControlled) {
	                this.editor.on(this.changeEvents(), this.handleEditorChange);
	                this.editor.on(this.beforeInputEvent(), this.handleBeforeInput);
	                this.editor.on('keydown', this.handleBeforeInputSpecial);
	                this.editor.on('keyup', this.handleEditorChangeSpecial);
	                this.editor.on('NewBlock', this.handleEditorChange);
	            }
	            else if (wasControlled && !nowControlled) {
	                this.editor.off(this.changeEvents(), this.handleEditorChange);
	                this.editor.off(this.beforeInputEvent(), this.handleBeforeInput);
	                this.editor.off('keydown', this.handleBeforeInputSpecial);
	                this.editor.off('keyup', this.handleEditorChangeSpecial);
	                this.editor.off('NewBlock', this.handleEditorChange);
	            }
	        }
	    };
	    Editor.propTypes = EditorPropTypes_1.EditorPropTypes;
	    Editor.defaultProps = {
	        cloudChannel: '7',
	    };
	    return Editor;
	}(React.Component));
	exports.Editor = Editor;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Editor = void 0;
	var Editor_1 = __webpack_require__(471);
	Object.defineProperty(exports, "Editor", { enumerable: true, get: function () { return Editor_1.Editor; } });


/***/ },
/* 473 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	var bind = __webpack_require__(193);
	var Axios = __webpack_require__(476);
	var mergeConfig = __webpack_require__(190);
	var defaults = __webpack_require__(138);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  // Factory for creating new instances
	  instance.create = function create(instanceConfig) {
	    return createInstance(mergeConfig(defaultConfig, instanceConfig));
	  };
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Expose Cancel & CancelToken
	axios.CanceledError = __webpack_require__(110);
	axios.CancelToken = __webpack_require__(475);
	axios.isCancel = __webpack_require__(188);
	axios.VERSION = __webpack_require__(192).version;
	axios.toFormData = __webpack_require__(195);
	
	// Expose AxiosError class
	axios.AxiosError = __webpack_require__(80);
	
	// alias for CanceledError for backward compatibility
	axios.Cancel = axios.CanceledError;
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(490);
	
	// Expose isAxiosError
	axios.isAxiosError = __webpack_require__(484);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var CanceledError = __webpack_require__(110);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	
	  // eslint-disable-next-line func-names
	  this.promise.then(function(cancel) {
	    if (!token._listeners) return;
	
	    var i;
	    var l = token._listeners.length;
	
	    for (i = 0; i < l; i++) {
	      token._listeners[i](cancel);
	    }
	    token._listeners = null;
	  });
	
	  // eslint-disable-next-line func-names
	  this.promise.then = function(onfulfilled) {
	    var _resolve;
	    // eslint-disable-next-line func-names
	    var promise = new Promise(function(resolve) {
	      token.subscribe(resolve);
	      _resolve = resolve;
	    }).then(onfulfilled);
	
	    promise.cancel = function reject() {
	      token.unsubscribe(_resolve);
	    };
	
	    return promise;
	  };
	
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new CanceledError(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `CanceledError` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Subscribe to the cancel signal
	 */
	
	CancelToken.prototype.subscribe = function subscribe(listener) {
	  if (this.reason) {
	    listener(this.reason);
	    return;
	  }
	
	  if (this._listeners) {
	    this._listeners.push(listener);
	  } else {
	    this._listeners = [listener];
	  }
	};
	
	/**
	 * Unsubscribe from the cancel signal
	 */
	
	CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
	  if (!this._listeners) {
	    return;
	  }
	  var index = this._listeners.indexOf(listener);
	  if (index !== -1) {
	    this._listeners.splice(index, 1);
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	var buildURL = __webpack_require__(194);
	var InterceptorManager = __webpack_require__(477);
	var dispatchRequest = __webpack_require__(478);
	var mergeConfig = __webpack_require__(190);
	var buildFullPath = __webpack_require__(189);
	var validator = __webpack_require__(491);
	
	var validators = validator.validators;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(configOrUrl, config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof configOrUrl === 'string') {
	    config = config || {};
	    config.url = configOrUrl;
	  } else {
	    config = configOrUrl || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  var transitional = config.transitional;
	
	  if (transitional !== undefined) {
	    validator.assertOptions(transitional, {
	      silentJSONParsing: validators.transitional(validators.boolean),
	      forcedJSONParsing: validators.transitional(validators.boolean),
	      clarifyTimeoutError: validators.transitional(validators.boolean)
	    }, false);
	  }
	
	  // filter out skipped interceptors
	  var requestInterceptorChain = [];
	  var synchronousRequestInterceptors = true;
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	      return;
	    }
	
	    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	
	    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var responseInterceptorChain = [];
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var promise;
	
	  if (!synchronousRequestInterceptors) {
	    var chain = [dispatchRequest, undefined];
	
	    Array.prototype.unshift.apply(chain, requestInterceptorChain);
	    chain = chain.concat(responseInterceptorChain);
	
	    promise = Promise.resolve(config);
	    while (chain.length) {
	      promise = promise.then(chain.shift(), chain.shift());
	    }
	
	    return promise;
	  }
	
	
	  var newConfig = config;
	  while (requestInterceptorChain.length) {
	    var onFulfilled = requestInterceptorChain.shift();
	    var onRejected = requestInterceptorChain.shift();
	    try {
	      newConfig = onFulfilled(newConfig);
	    } catch (error) {
	      onRejected(error);
	      break;
	    }
	  }
	
	  try {
	    promise = dispatchRequest(newConfig);
	  } catch (error) {
	    return Promise.reject(error);
	  }
	
	  while (responseInterceptorChain.length) {
	    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  var fullPath = buildFullPath(config.baseURL, config.url);
	  return buildURL(fullPath, config.params, config.paramsSerializer);
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	
	  function generateHTTPMethod(isForm) {
	    return function httpMethod(url, data, config) {
	      return this.request(mergeConfig(config || {}, {
	        method: method,
	        headers: isForm ? {
	          'Content-Type': 'multipart/form-data'
	        } : {},
	        url: url,
	        data: data
	      }));
	    };
	  }
	
	  Axios.prototype[method] = generateHTTPMethod();
	
	  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
	});
	
	module.exports = Axios;


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected,
	    synchronous: options ? options.synchronous : false,
	    runWhen: options ? options.runWhen : null
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	var transformData = __webpack_require__(480);
	var isCancel = __webpack_require__(188);
	var defaults = __webpack_require__(138);
	var CanceledError = __webpack_require__(110);
	
	/**
	 * Throws a `CanceledError` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	
	  if (config.signal && config.signal.aborted) {
	    throw new CanceledError();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData.call(
	    config,
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData.call(
	      config,
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData.call(
	          config,
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AxiosError = __webpack_require__(80);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(new AxiosError(
	      'Request failed with status code ' + response.status,
	      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
	      response.config,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	var defaults = __webpack_require__(138);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  var context = this || defaults;
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn.call(context, data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 481 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ },
/* 483 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
	};


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	module.exports = function isAxiosError(payload) {
	  return utils.isObject(payload) && (payload.isAxiosError === true);
	};


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 487 */
/***/ function(module, exports) {

	// eslint-disable-next-line strict
	module.exports = null;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 489 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function parseProtocol(url) {
	  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
	  return match && match[1] || '';
	};


/***/ },
/* 490 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var VERSION = __webpack_require__(192).version;
	var AxiosError = __webpack_require__(80);
	
	var validators = {};
	
	// eslint-disable-next-line func-names
	['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
	  validators[type] = function validator(thing) {
	    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	  };
	});
	
	var deprecatedWarnings = {};
	
	/**
	 * Transitional option validator
	 * @param {function|boolean?} validator - set to false if the transitional option has been removed
	 * @param {string?} version - deprecated version / removed since version
	 * @param {string?} message - some message with additional info
	 * @returns {function}
	 */
	validators.transitional = function transitional(validator, version, message) {
	  function formatMessage(opt, desc) {
	    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	  }
	
	  // eslint-disable-next-line func-names
	  return function(value, opt, opts) {
	    if (validator === false) {
	      throw new AxiosError(
	        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
	        AxiosError.ERR_DEPRECATED
	      );
	    }
	
	    if (version && !deprecatedWarnings[opt]) {
	      deprecatedWarnings[opt] = true;
	      // eslint-disable-next-line no-console
	      console.warn(
	        formatMessage(
	          opt,
	          ' has been deprecated since v' + version + ' and will be removed in the near future'
	        )
	      );
	    }
	
	    return validator ? validator(value, opt, opts) : true;
	  };
	};
	
	/**
	 * Assert object's properties type
	 * @param {object} options
	 * @param {object} schema
	 * @param {boolean?} allowUnknown
	 */
	
	function assertOptions(options, schema, allowUnknown) {
	  if (typeof options !== 'object') {
	    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
	  }
	  var keys = Object.keys(options);
	  var i = keys.length;
	  while (i-- > 0) {
	    var opt = keys[i];
	    var validator = schema[opt];
	    if (validator) {
	      var value = options[opt];
	      var result = value === undefined || validator(value, opt, options);
	      if (result !== true) {
	        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
	      }
	      continue;
	    }
	    if (allowUnknown !== true) {
	      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
	    }
	  }
	}
	
	module.exports = {
	  assertOptions: assertOptions,
	  validators: validators
	};


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(79);
	
	var _reactRedux = __webpack_require__(90);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _userActions = __webpack_require__(95);
	
	var userActions = _interopRequireWildcard(_userActions);
	
	__webpack_require__(839);
	
	var _PrivateRoute = __webpack_require__(81);
	
	var _PrivateRoute2 = _interopRequireDefault(_PrivateRoute);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _dashboard = __webpack_require__(579);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _Packages = __webpack_require__(645);
	
	var _Packages2 = _interopRequireDefault(_Packages);
	
	var _DoctorProfile = __webpack_require__(623);
	
	var _DoctorProfile2 = _interopRequireDefault(_DoctorProfile);
	
	var _Homecardicepage = __webpack_require__(632);
	
	var _Homecardicepage2 = _interopRequireDefault(_Homecardicepage);
	
	var _register = __webpack_require__(703);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _Login = __webpack_require__(494);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _forgetpassword = __webpack_require__(592);
	
	var _forgetpassword2 = _interopRequireDefault(_forgetpassword);
	
	var _ResetPassword = __webpack_require__(497);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _Logout = __webpack_require__(495);
	
	var _Logout2 = _interopRequireDefault(_Logout);
	
	var _appointments = __webpack_require__(202);
	
	var _appointments2 = _interopRequireDefault(_appointments);
	
	var _doctorportal = __webpack_require__(586);
	
	var _doctorportal2 = _interopRequireDefault(_doctorportal);
	
	var _emergency = __webpack_require__(686);
	
	var _emergency2 = _interopRequireDefault(_emergency);
	
	var _patientoverview = __webpack_require__(587);
	
	var _patientoverview2 = _interopRequireDefault(_patientoverview);
	
	var _patientoverviewtwo = __webpack_require__(588);
	
	var _patientoverviewtwo2 = _interopRequireDefault(_patientoverviewtwo);
	
	var _patientportal = __webpack_require__(589);
	
	var _patientportal2 = _interopRequireDefault(_patientportal);
	
	var _patientportaltwo = __webpack_require__(590);
	
	var _patientportaltwo2 = _interopRequireDefault(_patientportaltwo);
	
	var _patientreports = __webpack_require__(591);
	
	var _patientreports2 = _interopRequireDefault(_patientreports);
	
	var _PatientLists = __webpack_require__(647);
	
	var _PatientLists2 = _interopRequireDefault(_PatientLists);
	
	var _adminlogin = __webpack_require__(576);
	
	var _adminlogin2 = _interopRequireDefault(_adminlogin);
	
	var _adminlogout = __webpack_require__(577);
	
	var _adminlogout2 = _interopRequireDefault(_adminlogout);
	
	var _adminregister = __webpack_require__(578);
	
	var _adminregister2 = _interopRequireDefault(_adminregister);
	
	var _cancel = __webpack_require__(699);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	var _fail = __webpack_require__(700);
	
	var _fail2 = _interopRequireDefault(_fail);
	
	var _success = __webpack_require__(701);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _PopupPatientId = __webpack_require__(210);
	
	var _PopupPatientId2 = _interopRequireDefault(_PopupPatientId);
	
	var _PhotoGallery = __webpack_require__(651);
	
	var _PhotoGallery2 = _interopRequireDefault(_PhotoGallery);
	
	var _PhotoGalleryInner = __webpack_require__(652);
	
	var _PhotoGalleryInner2 = _interopRequireDefault(_PhotoGalleryInner);
	
	var _BriefHistory = __webpack_require__(601);
	
	var _BriefHistory2 = _interopRequireDefault(_BriefHistory);
	
	var _Corporateclient = __webpack_require__(615);
	
	var _Corporateclient2 = _interopRequireDefault(_Corporateclient);
	
	var _MissionStatement = __webpack_require__(640);
	
	var _MissionStatement2 = _interopRequireDefault(_MissionStatement);
	
	var _BoardMembers = __webpack_require__(599);
	
	var _BoardMembers2 = _interopRequireDefault(_BoardMembers);
	
	var _privacypolicy = __webpack_require__(690);
	
	var _privacypolicy2 = _interopRequireDefault(_privacypolicy);
	
	var _termscondition = __webpack_require__(697);
	
	var _termscondition2 = _interopRequireDefault(_termscondition);
	
	var _declaration = __webpack_require__(684);
	
	var _declaration2 = _interopRequireDefault(_declaration);
	
	var _singlenewsevents = __webpack_require__(693);
	
	var _singlenewsevents2 = _interopRequireDefault(_singlenewsevents);
	
	var _singlepublication = __webpack_require__(695);
	
	var _singlepublication2 = _interopRequireDefault(_singlepublication);
	
	var _singlepackage = __webpack_require__(694);
	
	var _singlepackage2 = _interopRequireDefault(_singlepackage);
	
	var _testimonials = __webpack_require__(698);
	
	var _testimonials2 = _interopRequireDefault(_testimonials);
	
	var _DepartmentView = __webpack_require__(619);
	
	var _DepartmentView2 = _interopRequireDefault(_DepartmentView);
	
	var _DepartmentsView = __webpack_require__(620);
	
	var _DepartmentsView2 = _interopRequireDefault(_DepartmentsView);
	
	var _staticpages = __webpack_require__(696);
	
	var _staticpages2 = _interopRequireDefault(_staticpages);
	
	var _OperationTeam = __webpack_require__(644);
	
	var _OperationTeam2 = _interopRequireDefault(_OperationTeam);
	
	var _LatestNews = __webpack_require__(636);
	
	var _LatestNews2 = _interopRequireDefault(_LatestNews);
	
	var _NoticeBoard = __webpack_require__(643);
	
	var _NoticeBoard2 = _interopRequireDefault(_NoticeBoard);
	
	var _Publications = __webpack_require__(656);
	
	var _Publications2 = _interopRequireDefault(_Publications);
	
	var _PeopleDiversity = __webpack_require__(649);
	
	var _PeopleDiversity2 = _interopRequireDefault(_PeopleDiversity);
	
	var _Location = __webpack_require__(639);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	var _VideoGallery = __webpack_require__(669);
	
	var _VideoGallery2 = _interopRequireDefault(_VideoGallery);
	
	var _editAlbum = __webpack_require__(201);
	
	var _editAlbum2 = _interopRequireDefault(_editAlbum);
	
	var _ForgotPass = __webpack_require__(626);
	
	var _ForgotPass2 = _interopRequireDefault(_ForgotPass);
	
	var _resetnewpassword = __webpack_require__(691);
	
	var _resetnewpassword2 = _interopRequireDefault(_resetnewpassword);
	
	var _Services = __webpack_require__(660);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _DeathCertificate = __webpack_require__(618);
	
	var _DeathCertificate2 = _interopRequireDefault(_DeathCertificate);
	
	var _BirthCertificate = __webpack_require__(596);
	
	var _BirthCertificate2 = _interopRequireDefault(_BirthCertificate);
	
	var _HomeSampleCollection = __webpack_require__(631);
	
	var _HomeSampleCollection2 = _interopRequireDefault(_HomeSampleCollection);
	
	var _Atm = __webpack_require__(595);
	
	var _Atm2 = _interopRequireDefault(_Atm);
	
	var _Cafeteria = __webpack_require__(602);
	
	var _Cafeteria2 = _interopRequireDefault(_Cafeteria);
	
	var _Investigation = __webpack_require__(633);
	
	var _Investigation2 = _interopRequireDefault(_Investigation);
	
	var _Telemedicine = __webpack_require__(666);
	
	var _Telemedicine2 = _interopRequireDefault(_Telemedicine);
	
	var _Mortuary = __webpack_require__(642);
	
	var _Mortuary2 = _interopRequireDefault(_Mortuary);
	
	var _Pharmacy = __webpack_require__(650);
	
	var _Pharmacy2 = _interopRequireDefault(_Pharmacy);
	
	var _RoomCategory = __webpack_require__(658);
	
	var _RoomCategory2 = _interopRequireDefault(_RoomCategory);
	
	var _WriteToUs = __webpack_require__(671);
	
	var _WriteToUs2 = _interopRequireDefault(_WriteToUs);
	
	var _CvUpload = __webpack_require__(616);
	
	var _CvUpload2 = _interopRequireDefault(_CvUpload);
	
	var _DayCare = __webpack_require__(617);
	
	var _DayCare2 = _interopRequireDefault(_DayCare);
	
	var _DischargeProtocols = __webpack_require__(622);
	
	var _DischargeProtocols2 = _interopRequireDefault(_DischargeProtocols);
	
	var _EveningOPD = __webpack_require__(624);
	
	var _EveningOPD2 = _interopRequireDefault(_EveningOPD);
	
	var _Vaccination = __webpack_require__(668);
	
	var _Vaccination2 = _interopRequireDefault(_Vaccination);
	
	var _PatientProtal = __webpack_require__(648);
	
	var _PatientProtal2 = _interopRequireDefault(_PatientProtal);
	
	var _Cart = __webpack_require__(607);
	
	var _Cart2 = _interopRequireDefault(_Cart);
	
	var _MyProvider = __webpack_require__(48);
	
	var _MyProvider2 = _interopRequireDefault(_MyProvider);
	
	var _successOrder = __webpack_require__(702);
	
	var _successOrder2 = _interopRequireDefault(_successOrder);
	
	var _PatientBillHistory = __webpack_require__(646);
	
	var _PatientBillHistory2 = _interopRequireDefault(_PatientBillHistory);
	
	var _LifeAtUHL = __webpack_require__(637);
	
	var _LifeAtUHL2 = _interopRequireDefault(_LifeAtUHL);
	
	var _CaseStudy = __webpack_require__(211);
	
	var _CaseStudy2 = _interopRequireDefault(_CaseStudy);
	
	var _CaseStudyPage = __webpack_require__(610);
	
	var _CaseStudyPage2 = _interopRequireDefault(_CaseStudyPage);
	
	var _CaseStudyDetails = __webpack_require__(609);
	
	var _CaseStudyDetails2 = _interopRequireDefault(_CaseStudyDetails);
	
	var _Career = __webpack_require__(603);
	
	var _Career2 = _interopRequireDefault(_Career);
	
	var _CareerInside = __webpack_require__(605);
	
	var _CareerInside2 = _interopRequireDefault(_CareerInside);
	
	var _Blog = __webpack_require__(597);
	
	var _Blog2 = _interopRequireDefault(_Blog);
	
	var _PhotoGalleryNew = __webpack_require__(654);
	
	var _PhotoGalleryNew2 = _interopRequireDefault(_PhotoGalleryNew);
	
	var _singleTestimonials = __webpack_require__(692);
	
	var _singleTestimonials2 = _interopRequireDefault(_singleTestimonials);
	
	var _BookAppointmentPopup = __webpack_require__(60);
	
	var _BookAppointmentPopup2 = _interopRequireDefault(_BookAppointmentPopup);
	
	var _About = __webpack_require__(593);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _ContactUs = __webpack_require__(613);
	
	var _ContactUs2 = _interopRequireDefault(_ContactUs);
	
	var _UserChangePassword = __webpack_require__(200);
	
	var _UserChangePassword2 = _interopRequireDefault(_UserChangePassword);
	
	var _Layout = __webpack_require__(493);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _SideDrawerMenus = __webpack_require__(661);
	
	var _SideDrawerMenus2 = _interopRequireDefault(_SideDrawerMenus);
	
	var _Home = __webpack_require__(628);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import Homecardic from './component/frontend/homecrdic/Homcardic';
	
	//import admindashboard from './component/admin/admindashboard';
	
	
	// import GLOBAL_CONTEXT from "./component/globalContext";
	
	var getStaticPages = function getStaticPages() {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/staticpages/getstaticpages", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var user_log = function user_log() {
	  return new Promise(function (resolve, reject) {
	    var login_data = {
	      type: "Browse",
	      user_id: localStorage.getItem(_constants.USER_LOCAL_ID) || null,
	      url: window.location.pathname
	    };
	    var user_log = _.thirdparty.post("/user_log", login_data);
	  });
	};
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, App);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      staticpages: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  // static contextType = GLOBAL_CONTEXT;
	
	
	  _createClass(App, [{
	    key: "componentDidMount",
	
	    /*refreshGetStaticPages = () => {
	      getStaticPages()
	        .then(res => {
	          if (res.status === true) {
	            var records = res.data;
	            this.setState({ staticpages: records });
	          } else {
	            this.setState({ staticpages: '' });
	          }
	        })
	        .catch(err => {
	          console.log("",err);
	        });
	    }*/
	    value: function componentDidMount() {
	      user_log();
	      //this.refreshGetStaticPages();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      // const { user, userdata } = this.context;
	      return _react2.default.createElement(
	        _MyProvider2.default,
	        null,
	        _react2.default.createElement(
	          _reactRouterDom.BrowserRouter,
	          null,
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/", component: _Home2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/logout", component: _Logout2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/adminlogout", component: _adminlogout2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/resetpassword", component: _ResetPassword2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/forgetpassword", component: _forgetpassword2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/packages", component: _Packages2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/homecardic", component: _Homecardicepage2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/emergency", component: _emergency2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/page/brief-history", component: _BriefHistory2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/page/about", component: _About2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/page/mission-statement",
	              component: _MissionStatement2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/pages/death-certificate",
	              component: _DeathCertificate2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/pages/birth-certificate",
	              component: _BirthCertificate2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/pages/home-sample-collection",
	              component: _HomeSampleCollection2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/atm", component: _Atm2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/life-at-uhl", component: _LifeAtUHL2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/case-study/:id", component: _CaseStudyDetails2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/case-study", component: _CaseStudyPage2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/career/cv-upload/:id", component: _CvUpload2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/career/:id", component: _CareerInside2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/career", component: _Career2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/blog/:id", component: _Blog2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/cafeteria", component: _Cafeteria2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/investigation", component: _Investigation2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/evening-opd", component: _EveningOPD2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/telemedicine", component: _Telemedicine2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/mortuary", component: _Mortuary2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/pharmacy", component: _Pharmacy2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/room-category", component: _RoomCategory2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/vaccination", component: _Vaccination2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/day-care", component: _DayCare2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/services/corporate-client",
	              component: _Corporateclient2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/pages/discharge-protocols",
	              component: _DischargeProtocols2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/write-to-us", component: _WriteToUs2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/departments", component: _DepartmentsView2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/services", component: _Services2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/pages/patientbillhistory",
	              component: _PatientBillHistory2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/pages/:slug", component: _staticpages2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/patient-protal", component: _PatientProtal2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/news/index", component: _LatestNews2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/news/page/:page", component: _LatestNews2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/news/:name", component: _singlenewsevents2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/testimonials/:name", component: _singleTestimonials2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/news", component: _LatestNews2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/patientlists", component: _PatientLists2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/gallery/video-gallery/", component: _VideoGallery2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "pages/emergency", component: _emergency2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/cancel", component: _cancel2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/cart", component: _Cart2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/fail", component: _fail2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/success", component: _success2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/success-order", component: _successOrder2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/popuppatientid", component: _PopupPatientId2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/page/board-members", component: _BoardMembers2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/gallery/photo-gallery/:slug",
	              component: _PhotoGalleryInner2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/page/operation-team", component: _OperationTeam2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/forgot-pass", component: _ForgotPass2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/reset-new-password", component: _resetnewpassword2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/page/people-diversity", component: _PeopleDiversity2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/admin/change-password",
	              component: _UserChangePassword2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/publication", component: _Publications2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/page/contact", component: _ContactUs2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/privacy-policy", component: _privacypolicy2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/location", component: _Location2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/gallery/photo-gallery", component: _PhotoGalleryNew2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/terms-conditions", component: _termscondition2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/declaration", component: _declaration2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/publications/:name", component: _singlepublication2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/packages/:name", component: _singlepackage2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/alltestimonials", component: _testimonials2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: _constants.LOGIN_PAGE_PATH, component: _Login2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/signup", component: _register2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/departments/:name", component: _DepartmentView2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/department/:name", component: _DepartmentView2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/consultant/:name", component: _DoctorProfile2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/home", component: _Home2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/dashboard/patient-dashboard",
	              component: _patientoverview2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/dashboard/appoinments", component: _appointments2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/dashboard/doctor-portal", component: _doctorportal2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/dashboard/patient-overview-two",
	              component: _patientoverviewtwo2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/dashboard/patient-portal", component: _patientportal2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/dashboard/patient-portal-two",
	              component: _patientportaltwo2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/dashboard/patient-reports",
	              component: _patientreports2.default
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/adminlogin", component: _adminlogin2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/adminregister", component: _adminregister2.default }),
	            " ",
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/",
	              component: _dashboard2.default,
	              user: this.props.user
	            })
	          ),
	          _react2.default.createElement(_SideDrawerMenus2.default, null)
	        ),
	        _react2.default.createElement(_BookAppointmentPopup2.default, null)
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
	  return {
	    user: state.user
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(userActions, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// src/components/Layout.js
	var Layout = function Layout(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    children,
	    _react2.default.createElement(
	      "div",
	      {
	        className: "d-none d-md-flex flex-column",
	        style: {
	          position: "fixed",
	          top: "30vh",
	          right: "0"
	          // padding: "10px",
	          // borderTopLeftRadius: "20px",
	          // borderBottomLeftRadius: "20px",
	          // border: "2px solid #ccc", // Border for the first two buttons
	          // borderRight: "none", // No right border to attach it to the edge
	          // backgroundColor: "#f9f9f9", // Slight background color for visibility
	          // display: "flex",
	          // flexDirection: "column",
	          // gap: "10px",
	          // alignItems: "center",
	          // zIndex: 99999,
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "",
	          style: {
	            padding: "10px",
	            borderTopLeftRadius: "20px",
	            borderBottomLeftRadius: "20px",
	            border: "2px solid #AF9763", // Border for the first two buttons
	            borderRight: "none", // No right border to attach it to the edge
	            backgroundColor: "#f9f9f9", // Slight background color for visibility
	            display: "flex",
	            flexDirection: "column",
	            gap: "10px",
	            alignItems: "center",
	            zIndex: 99999
	          }
	        },
	        _react2.default.createElement(
	          "a",
	          { href: "tel:10666" },
	          _react2.default.createElement(
	            "button",
	            {
	              style: {
	                width: "72px",
	                height: "72px",
	                borderRadius: "50%", // Rounded button
	                border: "none",
	                padding: 0,
	                backgroundColor: "transparent",
	                cursor: "pointer"
	              }
	            },
	            _react2.default.createElement("img", {
	              src: "/assets/images/call_update.svg",
	              alt: "Call",
	              style: {
	                width: "100%",
	                height: "100%",
	                objectFit: "cover",
	                borderRadius: "50%"
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: "/pages/emergency" },
	          _react2.default.createElement(
	            "button",
	            {
	              style: {
	                width: "72px",
	                height: "72px",
	                borderRadius: "50%", // Rounded button
	                border: "none",
	                padding: 0,
	                backgroundColor: "transparent",
	                cursor: "pointer"
	              }
	            },
	            _react2.default.createElement("img", {
	              src: "/assets/images/emargency_update.svg",
	              alt: "Emergency",
	              style: {
	                width: "100%",
	                height: "100%",
	                objectFit: "cover",
	                borderRadius: "50%"
	              }
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "", style: { padding: "10px", zIndex: 99999 } },
	        _react2.default.createElement(
	          "button",
	          {
	            className: "d-none d-md-flex",
	            style: {
	              width: "72px",
	              height: "72px",
	              borderRadius: "50%", // Rounded button
	              border: "none",
	              padding: 0,
	              backgroundColor: "transparent",
	              cursor: "pointer",
	              animation: "shakeButton 1s ease-in-out infinite"
	            }
	          },
	          _react2.default.createElement("img", {
	            src: "/assets/images/jci-gold-seal 1.png",
	            alt: "Gold Seal",
	            style: {
	              width: "100%",
	              height: "100%",
	              objectFit: "cover",
	              borderRadius: "50%"
	            }
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "style",
	      { jsx: true },
	      "\n        @keyframes shakeButton {\n          0% {\n            transform: translateX(0); /* No movement */\n          }\n          25% {\n            transform: translateX(-10px); /* Move left */\n          }\n          50% {\n            transform: translateX(10px); /* Move right */\n          }\n          75% {\n            transform: translateX(-10px); /* Move left again */\n          }\n          100% {\n            transform: translateX(0); /* Return to original position */\n          }\n        }\n      "
	    )
	  );
	}; // Import useRef to control animation
	exports.default = Layout;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _PrivateRoute = __webpack_require__(81);
	
	var _userSession = __webpack_require__(30);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Link } from 'react-router-dom'
	//import { connect } from 'react-redux';
	//import { bindActionCreators } from 'redux';
	
	//import * as userActions from '../actions/userActions';
	
	
	var loginUser = function loginUser(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request(_constants.LOGIN_PAGE_PATH, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var activateaccount = function activateaccount(url) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request(url, {
	      method: "post"
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var alertStyle = {
	  color: "red"
	};
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Login);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Login.__proto__ || Object.getPrototypeOf(Login)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      user_email: "",
	      user_password: "",
	      remember_me: false,
	      enableLoginBtn: false,
	      signin_success: false,
	      user_active: false,
	      fields: {},
	      errors: {}
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	
	      if (_this.validateForm()) {
	        var fields = {};
	        fields["user_email"] = "";
	        fields["user_password"] = "";
	        _this.setState({ fields: fields });
	
	        var user = {
	          email: _this.state.fields.user_email,
	          password: _this.state.fields.user_password
	        };
	
	        loginUser(user).then(function (res) {
	          if (!!res.token) {
	            (0, _userSession.startUserSession)(res.token, res.data.role, res.data.id, res.data.email, res.data.isapproved, res.data.reg_step_1, res.data.reg_step_2, res.data.reg_step_3, res.data.reg_step_4);
	            _this.setState({
	              signin_success: true,
	              user_active: res.data.status === 0 ? false : true
	            });
	            _this.props.actions.userLoginSuccess(res.data);
	            localStorage.setItem("isLoggedIn", true);
	            /*} else if (res.data=='admin_user') {
	                        var modal = document.getElementById("myModal");
	                        var span = document.getElementsByClassName("close")[0];
	                        modal.style.display = "block";
	                        span.onclick = function() {
	                            modal.style.display = "none";
	                        }
	                        window.onclick = function(event) {
	                            if (event.target == modal) {
	                                modal.style.display = "none";
	                            }
	                        }*/
	          } else {
	            _reactToastify.toast.error(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          }
	        }).catch(function (err) {
	          //     toast.error('Error occured', {
	          //         position: toast.POSITION.BOTTOM_RIGHT
	          //     });
	        });
	      } else _reactToastify.toast.error("Please provide email and password !", {
	        position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Login, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	
	      if (!fields["user_email"]) {
	        formIsValid = false;
	        errors["user_email"] = "*Please enter your email.";
	      }
	
	      if (!fields["user_password"]) {
	        formIsValid = false;
	        errors["user_password"] = "*Please enter password";
	      }
	
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var urlParams = new URLSearchParams(this.props.location.search);
	      var active_code = urlParams.get("active_code");
	      var CHK_USER_ID = localStorage.getItem(_constants.USER_ID);
	      if (active_code) {
	        var url = "/account/activation/" + active_code;
	        activateaccount(url, active_code).then(function (res) {
	          if (res.status === true) {
	            _reactToastify.toast.success(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	            if (CHK_USER_ID === null) {
	              window.location.href = "/login";
	            } else {
	              _this2.setState({
	                signin_success: true
	              });
	            }
	          } else {
	            _reactToastify.toast.error(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          }
	        }).catch(function (err) {
	          console.log(err);
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _ref2 = this.props.location.state || {
	        from: { pathname: "/dashboard" }
	      },
	          from = _ref2.from;
	
	      if ((0, _PrivateRoute.validateUserToken)()) {
	        if (!this.state.signin_success) return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/login" });
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: from });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          { className: "container " },
	          _react2.default.createElement(
	            "div",
	            { className: "row starbuck_row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6" },
	              _react2.default.createElement(
	                "h6",
	                { className: "heading_col font_16" },
	                "Login"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "txt_col fontweight500 font_12 mb-4" },
	                "Login into your account here"
	              ),
	              _react2.default.createElement(
	                "form",
	                {
	                  onSubmit: this.handleSubmit,
	                  id: "loginform",
	                  className: "needs-validation",
	                  novalidate: true
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        className: "form-control input_custom_style",
	                        name: "user_email",
	                        id: "user_email",
	                        value: this.state.fields.user_email,
	                        onChange: this.handleChange,
	                        placeholder: "Email",
	                        required: "",
	                        autocomplete: "off"
	                      }),
	                      _react2.default.createElement(
	                        "span",
	                        { style: alertStyle },
	                        this.state.errors.user_email
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement("input", {
	                        type: "password",
	                        className: "form-control input_custom_style",
	                        name: "user_password",
	                        value: this.state.fields.user_password,
	                        onChange: this.handleChange,
	                        placeholder: "Password",
	                        required: "",
	                        autocomplete: "off"
	                      }),
	                      _react2.default.createElement(
	                        "span",
	                        { style: alertStyle },
	                        this.state.errors.user_password
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { type: "submit", className: "blue_btn mt-3" },
	                  " ",
	                  "Login",
	                  " "
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "txt_col fontweight500 font_12 mt-3 login_signup_text" },
	                " ",
	                _react2.default.createElement(
	                  "p",
	                  { className: "signup_link" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/signup", className: "blue_anchor_col" },
	                    "Don't have an account? Sign Up"
	                  )
	                ),
	                " ",
	                _react2.default.createElement(
	                  "p",
	                  { className: "forgot_pass_link" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "/forgetpassword",
	                      className: "blue_anchor_col ml-5 forgot_pass_text"
	                    },
	                    "Forgot Password?"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { id: "myModal", className: "modal" },
	              _react2.default.createElement(
	                "div",
	                { className: "modal-content" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "close" },
	                  "\xD7"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "popup_content_sec" },
	                  "This is the credential of Admin user, if you want to login as admin click on below button."
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "admin_btn_link" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "admin_btn cookieConsentOK1",
	                      href: _constants.ADMIN_URL,
	                      target: "_blank"
	                    },
	                    " ",
	                    "Click Here",
	                    " "
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	exports.default = Login;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(90);
	
	var _redux = __webpack_require__(79);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _userActions = __webpack_require__(95);
	
	var userActions = _interopRequireWildcard(_userActions);
	
	var _constants = __webpack_require__(3);
	
	var _userSession = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logout = function (_Component) {
	    _inherits(Logout, _Component);
	
	    function Logout() {
	        _classCallCheck(this, Logout);
	
	        return _possibleConstructorReturn(this, (Logout.__proto__ || Object.getPrototypeOf(Logout)).apply(this, arguments));
	    }
	
	    _createClass(Logout, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.actions.userLogoutSuccess();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            (0, _userSession.endUserSession)();
	            return _react2.default.createElement(_reactRouterDom.Redirect, { to: _constants.HOME_PAGE_PATH });
	        }
	    }]);
	
	    return Logout;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(userActions, dispatch)
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Logout);

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _MyProvider = __webpack_require__(48);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	var _newsEventsModule = __webpack_require__(87);
	
	var _newsEventsModule2 = _interopRequireDefault(_newsEventsModule);
	
	var _reactSlick = __webpack_require__(63);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var RecommendedPackage = function RecommendedPackage() {
	  var addToCart = _MyProvider.MyContext.addToCart;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      data = _useState2[0],
	      setData = _useState2[1];
	
	  var hendleClick = function hendleClick(pagkage, additionalInfo) {
	    addToCart(pagkage, additionalInfo);
	  };
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _.thirdparty)("/packages/get_package_list?pagination=1");
	
	              case 3:
	                response = _context.sent;
	
	
	                setData(response.data.data.data);
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0);
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 7]]);
	      }));
	
	      return function fetchData() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	  var settings = {
	    rows: 2,
	    dots: false,
	    infinite: true,
	    speed: 500,
	    slidesToShow: 3,
	    slidesToScroll: 1,
	    autoplay: false,
	
	    responsive: [{
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 1,
	        infinite: true,
	        dots: true
	      }
	    }, {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }, {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }]
	  };
	
	  var mobileSettings = {
	    rows: 1,
	    dots: false,
	    infinite: true,
	    speed: 500,
	    slidesToShow: 4,
	    slidesToScroll: 1,
	    autoplay: false,
	    responsive: [{
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        infinite: true,
	        dots: true
	      }
	    }, {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }, {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }]
	  };
	  return _react2.default.createElement(
	    "div",
	    { className: "py-0 py-md-5", style: { backgroundColor: "#F7F5EF" } },
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "div",
	        {
	          style: {
	            display: "flex",
	            justifyContent: "center",
	            alignItems: "center",
	            flexDirection: "column",
	            margin: "0 auto"
	          }
	        },
	        _react2.default.createElement(
	          "h3",
	          {
	            className: "text-center mt-4",
	            style: {
	              color: "#AF9763",
	              fontSize: "28px",
	              fontWeight: "500"
	            }
	          },
	          "Health Screening Packages"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mt-0 mt-md-5" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 right-sp-1" },
	          _react2.default.createElement(
	            "div",
	            { className: "news_section py-4" },
	            _react2.default.createElement(
	              _reactDeviceDetect.MobileView,
	              { className: _newsEventsModule2.default.MobileView },
	              _react2.default.createElement(
	                _reactSlick2.default,
	                mobileSettings,
	                " ",
	                data.map(function (pagkage) {
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-sm-3 mt-3 py-4 px-1",
	                      style: {
	                        width: "100%",
	                        maxWidth: "432px",
	                        height: "250px",
	                        marginRight: "10px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        to: "/packages/" + pagkage.slug,
	                        style: {
	                          fontSize: "12px",
	                          color: "#AF9763",
	                          textDecoration: "none"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          key: pagkage.id,
	                          className: "card d-flex flex-column justify-content-between align-items-start shadow",
	                          style: {
	                            paddingLeft: "0px",
	                            paddingRight: "0px",
	                            borderRadius: "14px",
	                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1), 0px -4px 6px rgba(0, 0, 0, 0.1)"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "d-flex justify-content-center align-items-center w-100",
	                            style: { height: "120px" }
	                          },
	                          pagkage.image ? _react2.default.createElement("img", {
	                            className: "img-fluid w-100 h-100",
	                            src: _constants.IMAGE_URL + "Packagesimg/" + pagkage.image,
	                            alt: "Bitmap-3",
	                            style: {
	                              borderRadius: "16px 16px 0px 0px",
	                              objectFit: "cover",
	                              objectPosition: "center"
	                            }
	                            // height={"100%"}
	                            // width={"100%"}
	                          }) : _react2.default.createElement("img", {
	                            //   className="img-fluid"
	                            src: _constants.IMAGE_URL + "Packagesimg/202303221003packages Profile.png",
	                            alt: "Bitmap-3",
	                            style: {
	                              borderRadius: "16px 16px 0px 0px",
	                              objectFit: "contain",
	                              height: "100%",
	                              width: "100%"
	                            }
	                            // height={115}
	                            , width: "100%"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "card-body d-flex justify-content-start align-items-center make-packages-orange w-100",
	                            style: {
	                              backgroundColor: "#E6DFCF",
	                              height: "75px"
	                              // borderRadius: "0px 0px 16px 16px",
	                            }
	                          },
	                          _react2.default.createElement(
	                            "h5",
	                            {
	                              className: "card-text",
	                              style: {
	                                fontSize: "15px",
	                                // color: "#af9763",
	                                fontWeight: "700"
	                              }
	                            },
	                            pagkage.name
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            "class": "card-footer d-flex justify-content-between align-items-center w-100",
	                            style: {
	                              fontSize: "12px",
	                              backgroundColor: "#ffffff",
	                              borderBottomLeftRadius: "16px",
	                              borderBottomRightRadius: "16px",
	                              height: "80px"
	                            }
	                          },
	                          _react2.default.createElement(
	                            "h5",
	                            {
	                              className: "make-packages-price-orange mb-0",
	                              style: {
	                                fontSize: "15px",
	                                // color: "#af9763",
	                                fontWeight: "900"
	                              }
	                            },
	                            "BDT ",
	                            pagkage.ipd_amount
	                          ),
	                          _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { to: "/packages/" + pagkage.slug },
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                className: "make-packages-orange",
	                                style: {
	                                  borderRadius: "5px",
	                                  backgroundColor: "#AF9763",
	                                  color: "#ffffff",
	                                  fontWeight: "500"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "button",
	                                {
	                                  style: {
	                                    padding: "5px 10px",
	                                    color: "#fff",
	                                    textTransform: "capitalize",
	                                    border: "none",
	                                    backgroundColor: "transparent",
	                                    borderRadius: "6px",
	                                    fontWeight: "500",
	                                    width: "100%"
	                                  },
	                                  className: "deptBtnFont"
	                                },
	                                "More Information"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _reactDeviceDetect.BrowserView,
	              { className: "px-0" },
	              _react2.default.createElement(
	                _reactSlick2.default,
	                Object.assign({ className: "row" }, settings),
	                data.map(function (pagkage) {
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-sm-3 px-2 mt-3",
	                      style: {
	                        width: "100%",
	                        maxWidth: "432px",
	                        height: "300px",
	                        marginRight: "10px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        to: "/packages/" + pagkage.slug,
	                        style: {
	                          fontSize: "12px",
	                          color: "#AF9763",
	                          textDecoration: "none"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          key: pagkage.id,
	                          className: "card d-flex flex-column justify-content-between align-items-start shadow",
	                          style: {
	                            paddingLeft: "0px",
	                            paddingRight: "0px",
	                            borderRadius: "14px"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "d-flex justify-content-center align-items-center w-100",
	                            style: { height: "150px" }
	                          },
	                          pagkage.image ? _react2.default.createElement("img", {
	                            className: "img-fluid w-100 h-100",
	                            src: _constants.IMAGE_URL + "Packagesimg/" + pagkage.image,
	                            alt: "Bitmap-3",
	                            style: {
	                              borderRadius: "16px 16px 0px 0px",
	                              objectFit: "cover",
	                              objectPosition: "center"
	                            }
	                            // height={"100%"}
	                            // width={"100%"}
	                          }) : _react2.default.createElement("img", {
	                            //   className="img-fluid"
	                            src: _constants.IMAGE_URL + "Packagesimg/202303221003packages Profile.png",
	                            alt: "Bitmap-3",
	                            style: {
	                              borderRadius: "16px 16px 0px 0px",
	                              objectFit: "contain",
	                              height: "100%",
	                              width: "100%"
	                            }
	                            // height={115}
	                            , width: "100%"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "card-body d-flex justify-content-start align-items-center make-packages-orange w-100",
	                            style: {
	                              backgroundColor: "#E6DFCF",
	                              height: "75px"
	                              // borderRadius: "0px 0px 16px 16px",
	                            }
	                          },
	                          _react2.default.createElement(
	                            "h5",
	                            {
	                              className: "card-text",
	                              style: {
	                                fontSize: "18px",
	                                // color: "#af9763",
	                                fontWeight: "700"
	                              }
	                            },
	                            pagkage.name
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            "class": "card-footer d-flex justify-content-between align-items-center w-100",
	                            style: {
	                              fontSize: "12px",
	                              backgroundColor: "#ffffff",
	                              borderBottomLeftRadius: "16px",
	                              borderBottomRightRadius: "16px",
	                              height: "80px"
	                            }
	                          },
	                          _react2.default.createElement(
	                            "h5",
	                            {
	                              className: "make-packages-price-orange mb-0",
	                              style: {
	                                fontSize: "18px",
	                                // color: "#af9763",
	                                fontWeight: "900"
	                              }
	                            },
	                            "BDT ",
	                            pagkage.ipd_amount
	                          ),
	                          _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { to: "/packages/" + pagkage.slug },
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                className: "make-packages-orange",
	                                style: {
	                                  borderRadius: "5px",
	                                  backgroundColor: "#AF9763",
	                                  color: "#ffffff",
	                                  fontWeight: "500"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "button",
	                                {
	                                  style: {
	                                    padding: "5px 10px",
	                                    color: "#fff",
	                                    textTransform: "capitalize",
	                                    border: "none",
	                                    backgroundColor: "transparent",
	                                    borderRadius: "6px",
	                                    fontWeight: "500",
	                                    width: "100%"
	                                  },
	                                  className: "deptBtnFont"
	                                },
	                                "More Information"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = RecommendedPackage;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _register_logo = __webpack_require__(1174);
	
	var _register_logo2 = _interopRequireDefault(_register_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Modal from './CustomReviewsListModal';
	
	var ResetPasswordUser = function ResetPasswordUser(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/resetpassword', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json',
	        'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var alertStyle = {
	  color: 'red'
	};
	
	var ResetPassword = function (_React$Component) {
	  _inherits(ResetPassword, _React$Component);
	
	  function ResetPassword() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResetPassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      email: '',
	      password: '',
	      confirm_password: '',
	      token: '',
	      isResetSuccess: false,
	      fields: {},
	      errors: {},
	      modal: false
	    }, _this.handleChange = function (event) {
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm()) {
	        var fields = {};
	        fields["password"] = "";
	        fields["confirm_password"] = "";
	        _this.setState({ fields: fields });
	        var urlParams = new URLSearchParams(_this.props.location.search);
	        var email = urlParams.get('email');
	        var data = {
	          password: _this.state.fields.password,
	          confirm_password: _this.state.fields.confirm_password,
	          email: email
	        };
	        ResetPasswordUser(data).then(function (res) {
	          if (res.status === true) {
	            _reactToastify.toast.success(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	            window.location = '/login';
	          } else {
	            _reactToastify.toast.error(res.errorMsg, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          }
	        }).catch(function (err) {
	          _reactToastify.toast.error('Error occured', {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error('Please fill your details.', {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ResetPassword, [{
	    key: 'modalOpen',
	    value: function modalOpen() {
	      this.setState({ modal: true });
	    }
	  }, {
	    key: 'modalClose',
	    value: function modalClose() {
	      this.setState({ modal: false });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	
	      if (!fields["password"]) {
	        formIsValid = false;
	        errors["password"] = "*Please enter your Password.";
	      }
	
	      if (!fields["confirm_password"]) {
	        formIsValid = false;
	        errors["confirm_password"] = "*Please enter your Confirm Password.";
	      }
	
	      if (fields["password"] !== fields["confirm_password"]) {
	        formIsValid = false;
	        errors["email"] = "Password is not matched";
	      }
	
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row starbuck_row' },
	            _react2.default.createElement('div', { className: 'col-md-6' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement('img', { src: _register_logo2.default, alt: '', className: 'mb-4' }),
	              _react2.default.createElement(
	                'h6',
	                { className: 'heading_col font_16' },
	                'Reset password'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'txt_col fontweight500 font_12 mb-4' },
	                'Reset your account password here'
	              ),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.handleSubmit, id: 'resetpwdform', className: 'needs-validation', novalidate: true },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement('input', { type: 'password', className: 'form-control input_custom_style', name: 'password', id: 'password', value: this.state.fields.password, onChange: this.handleChange, placeholder: 'Password', required: '' }),
	                      _react2.default.createElement(
	                        'span',
	                        { style: alertStyle },
	                        this.state.errors.password
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement('input', { type: 'password', className: 'form-control input_custom_style', name: 'confirm_password', id: 'confirm_password', value: this.state.fields.confirm_password, onChange: this.handleChange, placeholder: 'Confirm Password', required: '' }),
	                      _react2.default.createElement(
	                        'span',
	                        { style: alertStyle },
	                        this.state.errors.confirm_password
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', className: 'blue_btn mt-5' },
	                  ' Reset '
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'txt_col fontweight500 font_12' },
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { href: '/login', className: 'blue_anchor_col' },
	                  'Login'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return ResetPassword;
	}(_react2.default.Component);
	
	exports.default = ResetPassword;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _axios = __webpack_require__(64);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(441);
	
	__webpack_require__(237);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// Your component code here
	
	var SwiperComponent = function SwiperComponent() {
	  var id = localStorage.getItem(_constants.USER_LOCAL_ID);
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      data = _useState2[0],
	      setData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      prescriptionData = _useState4[0],
	      setPrescriptionData = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      Recentdata = _useState6[0],
	      setRecentData = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      erpData = _useState8[0],
	      setEerpData = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      additionalData = _useState10[0],
	      setAdditionalData = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      upComingAppointments = _useState12[0],
	      setUpComingAppointments = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      recentAppointments = _useState14[0],
	      setRecentAppointments = _useState14[1];
	
	  console.log(Recentdata);
	  // console.log(data, "info")
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _.scAxiosAdmin.get("/my_appointments/" + localStorage.getItem(_constants.USER_LOCAL_ID), {
	                  headers: {
	                    Accept: "application/json",
	                    "Content-Type": "application/json"
	                  }
	                });
	
	              case 3:
	                response = _context.sent;
	
	
	                setPrescriptionData(response.data.data); // Assuming the response contains the data you need
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0);
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 7]]);
	      }));
	
	      return function fetchData() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                _context2.next = 3;
	                return (0, _.thirdparty)("/appointments/upcoming?patient_id=" + id + "&status=Confirmed");
	
	              case 3:
	                response = _context2.sent;
	
	
	                setData(response.data.data);
	                _context2.next = 10;
	                break;
	
	              case 7:
	                _context2.prev = 7;
	                _context2.t0 = _context2["catch"](0);
	
	                console.error("Error fetching data:", _context2.t0);
	
	              case 10:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, undefined, [[0, 7]]);
	      }));
	
	      return function fetchData() {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var response;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.prev = 0;
	                _context3.next = 3;
	                return (0, _.thirdparty)("/appointments/recent?patient_id=" + id + "&status=Completed");
	
	              case 3:
	                response = _context3.sent;
	
	
	                setRecentData(response.data.data);
	                _context3.next = 10;
	                break;
	
	              case 7:
	                _context3.prev = 7;
	                _context3.t0 = _context3["catch"](0);
	
	                console.error("Error fetching data:", _context3.t0);
	
	              case 10:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, undefined, [[0, 7]]);
	      }));
	
	      return function fetchData() {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var response;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.prev = 0;
	                _context4.next = 3;
	                return (0, _.scAxios)(
	                // `/appointments/recent?patient_id=${id}&status=Completed`
	                "/patients?patient=" + id);
	
	              case 3:
	                response = _context4.sent;
	
	                if (response.status === 200) {
	                  setEerpData(response.data[0].latest_consultant);
	                }
	                _context4.next = 10;
	                break;
	
	              case 7:
	                _context4.prev = 7;
	                _context4.t0 = _context4["catch"](0);
	
	                console.error("Error fetching data:", _context4.t0);
	
	              case 10:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, undefined, [[0, 7]]);
	      }));
	
	      return function fetchData() {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	  (0, _react.useEffect)(function () {
	    var fetchAppointmentData = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var updatedData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, appointment, doctorData;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                updatedData = [];
	                _iteratorNormalCompletion = true;
	                _didIteratorError = false;
	                _iteratorError = undefined;
	                _context5.prev = 4;
	                _iterator = erpData[Symbol.iterator]();
	
	              case 6:
	                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                  _context5.next = 15;
	                  break;
	                }
	
	                appointment = _step.value;
	                _context5.next = 10;
	                return fetchData(appointment.doctor);
	
	              case 10:
	                doctorData = _context5.sent;
	
	                updatedData.push(Object.assign({}, appointment, { doctorData: doctorData }));
	
	              case 12:
	                _iteratorNormalCompletion = true;
	                _context5.next = 6;
	                break;
	
	              case 15:
	                _context5.next = 21;
	                break;
	
	              case 17:
	                _context5.prev = 17;
	                _context5.t0 = _context5["catch"](4);
	                _didIteratorError = true;
	                _iteratorError = _context5.t0;
	
	              case 21:
	                _context5.prev = 21;
	                _context5.prev = 22;
	
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	
	              case 24:
	                _context5.prev = 24;
	
	                if (!_didIteratorError) {
	                  _context5.next = 27;
	                  break;
	                }
	
	                throw _iteratorError;
	
	              case 27:
	                return _context5.finish(24);
	
	              case 28:
	                return _context5.finish(21);
	
	              case 29:
	
	                setAdditionalData(updatedData);
	
	              case 30:
	              case "end":
	                return _context5.stop();
	            }
	          }
	        }, _callee5, undefined, [[4, 17, 21, 29], [22,, 24, 28]]);
	      }));
	
	      return function fetchAppointmentData() {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    fetchAppointmentData();
	  }, [erpData]);
	  var fetchData = function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(doctorId) {
	      var response;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _context6.prev = 0;
	              _context6.next = 3;
	              return (0, _.scAxiosAdmin)("/doctors/get_doctor_by_uhlid?uhl_id=" + doctorId);
	
	            case 3:
	              response = _context6.sent;
	
	              if (!(response.status === 200)) {
	                _context6.next = 6;
	                break;
	              }
	
	              return _context6.abrupt("return", response.data);
	
	            case 6:
	              _context6.next = 11;
	              break;
	
	            case 8:
	              _context6.prev = 8;
	              _context6.t0 = _context6["catch"](0);
	
	              console.error("Error fetching data:", _context6.t0);
	
	            case 11:
	            case "end":
	              return _context6.stop();
	          }
	        }
	      }, _callee6, undefined, [[0, 8]]);
	    }));
	
	    return function fetchData(_x) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _react3.Swiper,
	      { className: "mySwiper shadow-lg mb-2 mt-2 " },
	      prescriptionData && prescriptionData.map(function (recentAppointment, index) {
	        if (recentAppointment.doctor_mave) {
	          return _react2.default.createElement(
	            _react3.SwiperSlide,
	            {
	              key: recentAppointment.id,
	              style: { cursor: "grab" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "card" },
	              _react2.default.createElement(
	                "div",
	                { className: "card-body", style: { padding: "1rem" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "d-flex justify-content-between align-items-center" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex flex-column justify-content-start mb-3" },
	                    _react2.default.createElement(
	                      "h6",
	                      null,
	                      "Recent Appointments"
	                    ),
	                    recentAppointment.appointment_date ? _react2.default.createElement(
	                      "small",
	                      { "class": "text-muted" },
	                      "Appointment Date:",
	                      " ",
	                      recentAppointment.appointment_date
	                    ) : "",
	                    recentAppointment.appointment_time ? _react2.default.createElement(
	                      "small",
	                      { "class": "text-muted" },
	                      "Appointment Time:",
	                      " ",
	                      recentAppointment.appointment_time
	                    ) : ""
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-5 d-flex justify-content-between align-items-center " },
	                    recentAppointment.doctor_mave.doctor_profile ? _react2.default.createElement("img", {
	                      src: _constants.IMAGE_URL + "DoctorProfileImg/" + recentAppointment.doctor_mave.doctor_profile,
	                      style: {
	                        width: "71px",
	                        height: "71px",
	                        borderRadius: "50%",
	                        objectFit: "cover"
	                      },
	                      alt: "avtars"
	                    }) : ""
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-7" },
	                    _react2.default.createElement(
	                      "h5",
	                      {
	                        style: {
	                          fontSize: "16px",
	                          color: "#55A5A6",
	                          fontWeight: "bold"
	                        }
	                      },
	                      recentAppointment.doctor_name
	                    ),
	                    _react2.default.createElement(
	                      "h5",
	                      { style: { fontSize: "12px", fontWeight: 400 } },
	                      recentAppointment.doctor_mave.departments_mave.map(function (dept, index) {
	                        return dept.department_name + ("" + (recentAppointment.doctor_mave.departments_mave.length > index ? "," : ""));
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "h5",
	                      { style: { fontSize: "12px", fontWeight: 400 } },
	                      " ",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { fontWeight: 600 } },
	                        "Degree :"
	                      ),
	                      " ",
	                      recentAppointment.doctor_mave.degree
	                    )
	                  )
	                )
	              )
	            )
	          );
	        } else {
	          return index === 0 && _react2.default.createElement(
	            _react3.SwiperSlide,
	            { key: recentAppointment.id },
	            _react2.default.createElement(
	              "div",
	              { className: "card" },
	              _react2.default.createElement(
	                "div",
	                { className: "card-body", style: { padding: "1rem" } },
	                _react2.default.createElement(
	                  "h6",
	                  null,
	                  "Recent Appointments"
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  "No Recent Appointments"
	                )
	              )
	            )
	          );
	        }
	      })
	    )
	  );
	};
	
	exports.default = SwiperComponent;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alertStyle = {
	  color: "red"
	};
	
	var AddInvestigation = function AddInvestigation() {
	  var _useState = (0, _react.useState)({
	    Product_Name: "",
	    Product_Group: "",
	    opd_amount: "",
	    ipd_price: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  var handleChange = function handleChange(event) {
	    var _event$target = event.target,
	        name = _event$target.name,
	        value = _event$target.value;
	
	    setFormData(function (prevData) {
	      return Object.assign({}, prevData, _defineProperty({}, name, value));
	    });
	  };
	
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	    var formdata = new FormData();
	    formdata.append("Product_Name", formData.Product_Name);
	    formdata.append("Product_Group", formData.Product_Group);
	    formdata.append("opd_amount", formData.opd_amount);
	    formdata.append("ipd_price", formData.ipd_price);
	
	    _.scAxiosAdmin.post("/investigations", formdata, {
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    }).then(function () {
	      _reactToastify.toast.success("Investigation added successfully!");
	      setFormData({
	        Product_Name: "",
	        Product_Group: "",
	        opd_amount: "",
	        ipd_price: ""
	      });
	    }).catch(function () {
	      _reactToastify.toast.error("Error adding investigation");
	    });
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "h4",
	                    { className: "mt-0 header-title" },
	                    "Add Investigation"
	                  ),
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      onSubmit: handleSubmit,
	                      id: "editdepartmentform",
	                      className: "needs-validation",
	                      noValidate: true
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Investigation Name"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "Product_Name",
	                            value: formData.Product_Name,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Investigation Name"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Investigation Group"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "Product_Group",
	                            value: formData.Product_Group,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Investigation Group"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Opd Amount"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "opd_amount",
	                            value: formData.opd_amount,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Opd Amount"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Ipd Amount"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "ipd_price",
	                            value: formData.ipd_price,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Ipd Amount"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "submit",
	                            className: "btn btn-pink waves-effect waves-light"
	                          },
	                          "Save"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = AddInvestigation;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _2 = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _NewReachTextEditor = __webpack_require__(83);
	
	var _NewReachTextEditor2 = _interopRequireDefault(_NewReachTextEditor);
	
	var _reactBeautifulDnd = __webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// Utility function to generate a 16-character unique ID
	var generateUniqueId = function generateUniqueId() {
	  return Math.random().toString(36).substring(2, 18) + Date.now().toString(36);
	};
	
	var AddMegaStaticPage = function AddMegaStaticPage() {
	  var _useState = (0, _react.useState)("static_page"),
	      _useState2 = _slicedToArray(_useState, 2),
	      pageType = _useState2[0],
	      setPageType = _useState2[1]; // Default to 'Static Pages'
	
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      serialNumber = _useState4[0],
	      setSerialNumber = _useState4[1]; // For serial number
	
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      title = _useState6[0],
	      setTitle = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      components = _useState8[0],
	      setComponents = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(""),
	      _useState10 = _slicedToArray(_useState9, 2),
	      sectionTitle = _useState10[0],
	      setSectionTitle = _useState10[1];
	
	  var handleAddComponent = function handleAddComponent(type) {
	    setComponents(function (prev) {
	      return [].concat(_toConsumableArray(prev), [{
	        id: generateUniqueId(), // Assign unique ID
	        type: type,
	        sectionTitle: "",
	        value: type === "description" ? {
	          title: "",
	          thumbnail: "",
	          content: ""
	        } : type === "card" ? {
	          media: [], // Array for media links
	          title: "",
	          date: "",
	          description: "",
	          externalLink: ""
	        } : type === "gallery" ? [] // Initialize value for gallery
	        : type === "cardGallery" ? [{
	          id: generateUniqueId(),
	          title: "",
	          date: "",
	          description: "",
	          media: [],
	          externalLink: ""
	        }] : null
	      }]);
	    });
	  };
	  // Function to update section title dynamically
	  var handleSectionTitleChange = function handleSectionTitleChange(id, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { sectionTitle: value }) : comp;
	      });
	    });
	  };
	  var handleRemoveComponent = function handleRemoveComponent(id) {
	    setComponents(function (prev) {
	      return prev.filter(function (comp) {
	        return comp.id !== id;
	      });
	    });
	  };
	
	  var handleDescriptionChange = function handleDescriptionChange(id, field, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { value: Object.assign({}, comp.value, _defineProperty({}, field, value)) }) : comp;
	      });
	    });
	  };
	
	  var handleCardMediaChange = function handleCardMediaChange(id, index, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, {
	          value: Object.assign({}, comp.value, {
	            media: comp.value.media.map(function (item, idx) {
	              return idx === index ? value : item;
	            })
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardAddMediaField = function handleCardAddMediaField(id) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, {
	          value: Object.assign({}, comp.value, { media: [].concat(_toConsumableArray(comp.value.media), [""]) })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardRemoveMediaField = function handleCardRemoveMediaField(id, index) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, {
	          value: Object.assign({}, comp.value, {
	            media: comp.value.media.filter(function (_, idx) {
	              return idx !== index;
	            })
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardChange = function handleCardChange(id, field, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { value: Object.assign({}, comp.value, _defineProperty({}, field, value)) }) : comp;
	      });
	    });
	  };
	  var handleCardDateChange = function handleCardDateChange(id, field, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { value: Object.assign({}, comp.value, _defineProperty({}, field, value)) }) : comp;
	      });
	    });
	  };
	
	  var handleGalleryChange = function handleGalleryChange(id, index, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, {
	          value: comp.value.map(function (item, idx) {
	            return idx === index ? value : item;
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleGalleryAddField = function handleGalleryAddField(id) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { value: [].concat(_toConsumableArray(comp.value), [""]) }) : comp;
	      });
	    });
	  };
	
	  var handleGalleryRemoveField = function handleGalleryRemoveField(id, index) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { value: comp.value.filter(function (_, idx) {
	            return idx !== index;
	          }) }) : comp;
	      });
	    });
	  };
	
	  // card gallery section functionality here
	  var handleCardGalleryAddMediaField = function handleCardGalleryAddMediaField(compId, cardId) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.map(function (card) {
	            return card.id === cardId ? Object.assign({}, card, { media: [].concat(_toConsumableArray(card.media), [""]) }) : card;
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardGalleryMediaChange = function handleCardGalleryMediaChange(compId, cardId, index, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.map(function (card) {
	            return card.id === cardId ? Object.assign({}, card, {
	              media: card.media.map(function (item, idx) {
	                return idx === index ? value : item;
	              })
	            }) : card;
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardGalleryRemoveMediaField = function handleCardGalleryRemoveMediaField(compId, cardId, index) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.map(function (card) {
	            return card.id === cardId ? Object.assign({}, card, {
	              media: card.media.filter(function (_, idx) {
	                return idx !== index;
	              })
	            }) : card;
	          })
	        }) : comp;
	      });
	    });
	  };
	  var handleCardGalleryAddCard = function handleCardGalleryAddCard(id) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, {
	          value: [].concat(_toConsumableArray(comp.value), [{
	            id: generateUniqueId(),
	            title: "",
	            description: "",
	            media: [],
	            externalLink: ""
	          }])
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardGalleryRemoveCard = function handleCardGalleryRemoveCard(compId, cardId) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.filter(function (card) {
	            return card.id !== cardId;
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardGalleryChange = function handleCardGalleryChange(compId, cardId, field, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.map(function (card) {
	            return card.id === cardId ? Object.assign({}, card, _defineProperty({}, field, value)) : card;
	          })
	        }) : comp;
	      });
	    });
	  };
	  var handleCardGalleryDateChange = function handleCardGalleryDateChange(compId, cardId, field, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.map(function (card) {
	            return card.id === cardId ? Object.assign({}, card, _defineProperty({}, field, value)) : card;
	          })
	        }) : comp;
	      });
	    });
	  };
	  var onDragEnd = function onDragEnd(result) {
	    var destination = result.destination,
	        source = result.source;
	
	
	    if (!destination) {
	      return;
	    }
	
	    if (destination.droppableId === source.droppableId && destination.index === source.index) {
	      return;
	    }
	
	    var newComponents = Array.from(components);
	
	    var _newComponents$splice = newComponents.splice(source.index, 1),
	        _newComponents$splice2 = _slicedToArray(_newComponents$splice, 1),
	        removed = _newComponents$splice2[0];
	
	    newComponents.splice(destination.index, 0, removed);
	
	    setComponents(newComponents);
	  };
	  var handleSubmit = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var payload;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              payload = {
	                type: pageType,
	                sl_no: serialNumber,
	                title: title,
	                components: components,
	                status: 1,
	                is_deleted: 0
	              };
	              _context.prev = 1;
	              _context.next = 4;
	              return _2.scAxiosAdmin.post("/static_services_pages", payload);
	
	            case 4:
	              _reactToastify.toast.success("Page successfully submitted!");
	              _context.next = 11;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](1);
	
	              console.error("Error submitting page:", _context.t0);
	              _reactToastify.toast.error("There was an error submitting the page.");
	
	            case 11:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[1, 7]]);
	    }));
	
	    return function handleSubmit() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Page Builder"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "label",
	                      null,
	                      "Page Type:"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        className: "form-control mb-3",
	                        value: pageType,
	                        onChange: function onChange(e) {
	                          return setPageType(e.target.value);
	                        }
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "static_page" },
	                        "Static Pages"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "services" },
	                        "Services"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "label",
	                      null,
	                      "Serial Number:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "number",
	                      className: "form-control mb-3",
	                      value: serialNumber,
	                      onChange: function onChange(e) {
	                        return setSerialNumber(e.target.value);
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "label",
	                      null,
	                      "Page Title:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      value: title,
	                      onChange: function onChange(e) {
	                        return setTitle(e.target.value);
	                      },
	                      className: "form-control mb-3"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-start gap-3" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        onClick: function onClick() {
	                          return handleAddComponent("description");
	                        },
	                        className: "btn btn-primary mr-2"
	                      },
	                      "Add Description"
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        onClick: function onClick() {
	                          return handleAddComponent("card");
	                        },
	                        className: "btn btn-primary mr-2"
	                      },
	                      "Add Card"
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        onClick: function onClick() {
	                          return handleAddComponent("gallery");
	                        },
	                        className: "btn btn-primary mr-2"
	                      },
	                      "Add Gallery"
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        onClick: function onClick() {
	                          return handleAddComponent("cardGallery");
	                        },
	                        className: "btn btn-primary"
	                      },
	                      "Add Card Gallery"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBeautifulDnd.DragDropContext,
	                    { onDragEnd: onDragEnd },
	                    _react2.default.createElement(
	                      _reactBeautifulDnd.Droppable,
	                      { droppableId: "components" },
	                      function (provided) {
	                        return _react2.default.createElement(
	                          "div",
	                          Object.assign({}, provided.droppableProps, {
	                            ref: provided.innerRef
	                          }),
	                          components.map(function (comp, index) {
	                            return _react2.default.createElement(
	                              _reactBeautifulDnd.Draggable,
	                              {
	                                key: comp.id,
	                                draggableId: comp.id,
	                                index: index
	                              },
	                              function (provided) {
	                                return _react2.default.createElement(
	                                  "div",
	                                  Object.assign({
	                                    ref: provided.innerRef
	                                  }, provided.draggableProps, provided.dragHandleProps),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { key: comp.id, className: "mb-4" },
	                                    _react2.default.createElement(
	                                      "h3",
	                                      null,
	                                      "Component " + (index + 1) + ": " + comp.type
	                                    ),
	                                    _react2.default.createElement(
	                                      "label",
	                                      null,
	                                      "Section Title"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                      type: "text",
	                                      className: "form-control mb-2",
	                                      value: comp.sectionTitle || "",
	                                      onChange: function onChange(e) {
	                                        return handleSectionTitleChange(comp.id, e.target.value);
	                                      }
	                                    }),
	                                    comp.type === "description" && _react2.default.createElement(
	                                      "div",
	                                      null,
	                                      _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "Description Title"
	                                      ),
	                                      _react2.default.createElement("input", {
	                                        type: "text",
	                                        className: "form-control mb-2",
	                                        value: comp.value.title,
	                                        onChange: function onChange(e) {
	                                          return handleDescriptionChange(comp.id, "title", e.target.value);
	                                        }
	                                      }),
	                                      _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "Thumbnail Description"
	                                      ),
	                                      _react2.default.createElement("input", {
	                                        type: "text",
	                                        className: "form-control mb-2",
	                                        value: comp.value.thumbnail,
	                                        onChange: function onChange(e) {
	                                          return handleDescriptionChange(comp.id, "thumbnail", e.target.value);
	                                        }
	                                      }),
	                                      _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "Content"
	                                      ),
	                                      _react2.default.createElement(_NewReachTextEditor2.default, {
	                                        id: "description-" + comp.id,
	                                        value: comp.value.content,
	                                        onChange: function onChange(id, value) {
	                                          return handleDescriptionChange(comp.id, "content", value);
	                                        }
	                                      })
	                                    ),
	                                    comp.type === "card" && _react2.default.createElement(
	                                      "div",
	                                      null,
	                                      _react2.default.createElement(
	                                        "h4",
	                                        null,
	                                        "Card"
	                                      ),
	                                      _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "Card Title"
	                                      ),
	                                      _react2.default.createElement("input", {
	                                        type: "text",
	                                        className: "form-control mb-2",
	                                        value: comp.value.title,
	                                        onChange: function onChange(e) {
	                                          return handleCardChange(comp.id, "title", e.target.value);
	                                        }
	                                      }),
	                                      " ",
	                                      _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "Card Date"
	                                      ),
	                                      _react2.default.createElement("input", {
	                                        type: "date",
	                                        className: "form-control mb-2",
	                                        value: comp.value.date,
	                                        onChange: function onChange(e) {
	                                          return handleCardDateChange(comp.id, "date", e.target.value);
	                                        }
	                                      }),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      _react2.default.createElement(
	                                        "button",
	                                        {
	                                          onClick: function onClick() {
	                                            return handleCardAddMediaField(comp.id);
	                                          },
	                                          className: "btn btn-secondary mb-3"
	                                        },
	                                        "Add Media Field"
	                                      ),
	                                      comp.value.media.map(function (link, idx) {
	                                        return _react2.default.createElement(
	                                          "div",
	                                          {
	                                            key: idx,
	                                            className: "d-flex align-items-center mb-2"
	                                          },
	                                          _react2.default.createElement("input", {
	                                            type: "text",
	                                            className: "form-control",
	                                            value: link,
	                                            onChange: function onChange(e) {
	                                              return handleCardMediaChange(comp.id, idx, e.target.value);
	                                            },
	                                            placeholder: "Media " + (idx + 1)
	                                          }),
	                                          _react2.default.createElement(
	                                            "button",
	                                            {
	                                              onClick: function onClick() {
	                                                return handleCardRemoveMediaField(comp.id, idx);
	                                              },
	                                              className: "btn btn-danger ml-2"
	                                            },
	                                            "Remove"
	                                          )
	                                        );
	                                      }),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "Card Description"
	                                      ),
	                                      _react2.default.createElement(_NewReachTextEditor2.default, {
	                                        id: "card-description-" + comp.id,
	                                        value: comp.value.description,
	                                        onChange: function onChange(id, value) {
	                                          return handleCardChange(comp.id, "description", value);
	                                        }
	                                      }),
	                                      _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "External Link"
	                                      ),
	                                      _react2.default.createElement("input", {
	                                        type: "text",
	                                        className: "form-control",
	                                        value: comp.value.externalLink,
	                                        onChange: function onChange(e) {
	                                          return handleCardChange(comp.id, "externalLink", e.target.value);
	                                        }
	                                      })
	                                    ),
	                                    comp.type === "gallery" && _react2.default.createElement(
	                                      "div",
	                                      null,
	                                      _react2.default.createElement(
	                                        "button",
	                                        {
	                                          onClick: function onClick() {
	                                            return handleGalleryAddField(comp.id);
	                                          },
	                                          className: "btn btn-secondary mb-3"
	                                        },
	                                        "Add Media Field"
	                                      ),
	                                      comp.value.map(function (link, idx) {
	                                        return _react2.default.createElement(
	                                          "div",
	                                          {
	                                            key: idx,
	                                            className: "d-flex align-items-center mb-2"
	                                          },
	                                          _react2.default.createElement("input", {
	                                            type: "text",
	                                            className: "form-control",
	                                            value: link,
	                                            onChange: function onChange(e) {
	                                              return handleGalleryChange(comp.id, idx, e.target.value);
	                                            },
	                                            placeholder: "Media " + (idx + 1)
	                                          }),
	                                          _react2.default.createElement(
	                                            "button",
	                                            {
	                                              onClick: function onClick() {
	                                                return handleGalleryRemoveField(comp.id, idx);
	                                              },
	                                              className: "btn btn-danger ml-2"
	                                            },
	                                            "Remove"
	                                          )
	                                        );
	                                      })
	                                    ),
	                                    comp.type === "cardGallery" && _react2.default.createElement(
	                                      "div",
	                                      null,
	                                      _react2.default.createElement(
	                                        "h4",
	                                        null,
	                                        "Card Gallery"
	                                      ),
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "row row-cols-1 row-cols-md-3" },
	                                        comp.value.map(function (card, cardIdx) {
	                                          return _react2.default.createElement(
	                                            "div",
	                                            {
	                                              key: card.id,
	                                              className: "border p-3 mb-3 rounded"
	                                            },
	                                            _react2.default.createElement(
	                                              "label",
	                                              null,
	                                              "Card Title"
	                                            ),
	                                            _react2.default.createElement("input", {
	                                              type: "text",
	                                              className: "form-control mb-2",
	                                              value: card.title,
	                                              onChange: function onChange(e) {
	                                                return handleCardGalleryChange(comp.id, card.id, "title", e.target.value);
	                                              }
	                                            }),
	                                            _react2.default.createElement(
	                                              "label",
	                                              null,
	                                              "Card Date"
	                                            ),
	                                            _react2.default.createElement("input", {
	                                              type: "date",
	                                              className: "form-control mb-2"
	                                              // value={card.title}
	                                              , onChange: function onChange(e) {
	                                                return handleCardGalleryDateChange(comp.id, card.id, "date", e.target.value);
	                                              }
	                                            }),
	                                            _react2.default.createElement(
	                                              "label",
	                                              null,
	                                              "Card Media"
	                                            ),
	                                            _react2.default.createElement("br", null),
	                                            _react2.default.createElement(
	                                              "button",
	                                              {
	                                                onClick: function onClick() {
	                                                  return handleCardGalleryAddMediaField(comp.id, card.id);
	                                                },
	                                                className: "btn btn-secondary mb-3"
	                                              },
	                                              "Add Media Field"
	                                            ),
	                                            card.media.map(function (media, idx) {
	                                              return _react2.default.createElement(
	                                                "div",
	                                                {
	                                                  key: idx,
	                                                  className: "d-flex align-items-center mb-2"
	                                                },
	                                                _react2.default.createElement("input", {
	                                                  type: "text",
	                                                  className: "form-control",
	                                                  value: media,
	                                                  onChange: function onChange(e) {
	                                                    return handleCardGalleryMediaChange(comp.id, card.id, idx, e.target.value);
	                                                  },
	                                                  placeholder: "Media " + (idx + 1)
	                                                }),
	                                                _react2.default.createElement(
	                                                  "button",
	                                                  {
	                                                    onClick: function onClick() {
	                                                      return handleCardGalleryRemoveMediaField(comp.id, card.id, idx);
	                                                    },
	                                                    className: "btn btn-danger ml-2"
	                                                  },
	                                                  "Remove"
	                                                )
	                                              );
	                                            }),
	                                            _react2.default.createElement("br", null),
	                                            _react2.default.createElement(
	                                              "label",
	                                              null,
	                                              "Card Description"
	                                            ),
	                                            _react2.default.createElement(_NewReachTextEditor2.default, {
	                                              id: "card-gallery-description-" + comp.id + "-" + card.id,
	                                              value: card.description,
	                                              onChange: function onChange(id, value) {
	                                                return handleCardGalleryChange(comp.id, card.id, "description", value);
	                                              }
	                                            }),
	                                            _react2.default.createElement(
	                                              "label",
	                                              null,
	                                              "Media Links"
	                                            ),
	                                            card.media.map(function (media, mediaIdx) {
	                                              return _react2.default.createElement(
	                                                "div",
	                                                {
	                                                  key: mediaIdx,
	                                                  className: "d-flex align-items-center mb-2"
	                                                },
	                                                _react2.default.createElement("input", {
	                                                  type: "text",
	                                                  className: "form-control",
	                                                  value: media,
	                                                  onChange: function onChange(e) {
	                                                    return handleCardGalleryChange(comp.id, card.id, "media", [].concat(_toConsumableArray(card.media.slice(0, mediaIdx)), [e.target.value], _toConsumableArray(card.media.slice(mediaIdx + 1))));
	                                                  }
	                                                })
	                                              );
	                                            }),
	                                            _react2.default.createElement(
	                                              "label",
	                                              null,
	                                              "External Link"
	                                            ),
	                                            _react2.default.createElement("input", {
	                                              type: "text",
	                                              className: "form-control mb-2",
	                                              value: card.externalLink,
	                                              onChange: function onChange(e) {
	                                                return handleCardGalleryChange(comp.id, card.id, "externalLink", e.target.value);
	                                              }
	                                            }),
	                                            _react2.default.createElement(
	                                              "button",
	                                              {
	                                                onClick: function onClick() {
	                                                  return handleCardGalleryRemoveCard(comp.id, card.id);
	                                                },
	                                                className: "btn btn-danger"
	                                              },
	                                              "Remove Card"
	                                            )
	                                          );
	                                        })
	                                      ),
	                                      _react2.default.createElement(
	                                        "button",
	                                        {
	                                          onClick: function onClick() {
	                                            return handleCardGalleryAddCard(comp.id);
	                                          },
	                                          className: "btn btn-primary mt-2"
	                                        },
	                                        "Add Another Card"
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "button",
	                                      {
	                                        onClick: function onClick() {
	                                          return handleRemoveComponent(comp.id);
	                                        },
	                                        className: "btn btn-danger mt-2"
	                                      },
	                                      "Remove Component"
	                                    ),
	                                    _react2.default.createElement("hr", { className: "w-50 mx-auto" })
	                                  )
	                                );
	                              }
	                            );
	                          }),
	                          provided.placeholder
	                        );
	                      }
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    { onClick: handleSubmit, className: "btn btn-success" },
	                    "Submit Page"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = AddMegaStaticPage;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Banner_create = function Banner_create() {
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        data = _useState2[0],
	        setData = _useState2[1];
	
	    console.log(data, "data");
	
	    var _useState3 = (0, _react.useState)({
	        type: "home_page",
	        title: "",
	        description: "",
	        image: null,
	        status: 1,
	        index_no: 1
	    }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        formData = _useState4[0],
	        setFormData = _useState4[1];
	
	    console.log(formData, "hello");
	
	    var handleChange = function handleChange(e) {
	        var _e$target = e.target,
	            name = _e$target.name,
	            value = _e$target.value;
	
	        setFormData(Object.assign({}, formData, _defineProperty({}, name, value)));
	    };
	
	    var handleFileChange = function handleFileChange(e) {
	        var file = e.target.files[0];
	
	        // Check if a file was selected
	        if (file) {
	            // Update the formData state by setting the author_profile_pic to the selected file
	            setFormData(Object.assign({}, formData, {
	                image: file
	            }));
	        }
	    };
	
	    var handleSubmit = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	            var response;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            e.preventDefault();
	                            _context.prev = 1;
	                            _context.next = 4;
	                            return _.thirdparty.post("/banner", formData, {
	                                headers: {
	                                    "Content-Type": "multipart/form-data"
	                                }
	                            });
	
	                        case 4:
	                            response = _context.sent;
	
	                            if (response.status === 201) {
	                                _reactToastify.toast.success("Banner Added Successfully!", {
	                                    position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                                    autoClose: 3000
	                                });
	                            }
	                            console.log("Form data sent:", response.status);
	                            _context.next = 12;
	                            break;
	
	                        case 9:
	                            _context.prev = 9;
	                            _context.t0 = _context["catch"](1);
	
	                            console.error("Error submitting form:", _context.t0);
	                            // Handle errors, show error messages, etc.
	
	                        case 12:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[1, 9]]);
	        }));
	
	        return function handleSubmit(_x) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	    return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(_Seo2.default, {
	            title: "Add Banner",
	            description: "Add Banner United Hospital",
	            pathSlug: "/Banner_create",
	            keywords: "Add Banner, Banner"
	        }),
	        _react2.default.createElement(
	            "div",
	            { id: "wrapper" },
	            _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	            _react2.default.createElement(
	                "div",
	                { className: "content-page" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "content" },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "page-content-wrapper d-flex justify-content-center" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "col-lg-6" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "card m-b-20" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "card-body" },
	                                    _react2.default.createElement(
	                                        "h2",
	                                        { className: "mt-0" },
	                                        "Add Banner"
	                                    ),
	                                    _react2.default.createElement("hr", null),
	                                    _react2.default.createElement(
	                                        "form",
	                                        {
	                                            id: "adddepartmentform",
	                                            className: "needs-validation",
	                                            noValidate: true,
	                                            onSubmit: handleSubmit
	                                        },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "row" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "col-sm-4" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "form-group" },
	                                                    _react2.default.createElement(
	                                                        "label",
	                                                        null,
	                                                        "Serial No."
	                                                    ),
	                                                    _react2.default.createElement("input", {
	                                                        type: "number",
	                                                        className: "form-control",
	                                                        name: "index_no",
	                                                        id: "index_no",
	                                                        value: formData.index_no,
	                                                        onChange: handleChange,
	                                                        required: true,
	                                                        placeholder: "Serial Number"
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "col-sm-8" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "form-group" },
	                                                    _react2.default.createElement(
	                                                        "label",
	                                                        null,
	                                                        "Title"
	                                                    ),
	                                                    _react2.default.createElement("input", {
	                                                        type: "text",
	                                                        className: "form-control",
	                                                        name: "title",
	                                                        id: "title",
	                                                        value: formData.title,
	                                                        onChange: handleChange,
	                                                        required: true,
	                                                        placeholder: "Name"
	                                                    })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "row" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "col-sm-12" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "form-group" },
	                                                    _react2.default.createElement(
	                                                        "label",
	                                                        null,
	                                                        "Description"
	                                                    ),
	                                                    _react2.default.createElement("textarea", {
	                                                        // type="text"
	                                                        className: "form-control",
	                                                        name: "description",
	                                                        id: "description",
	                                                        value: formData.description,
	                                                        onChange: handleChange
	                                                        // required
	                                                        , placeholder: "Description"
	                                                    })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "row" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "col-sm-12" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "form-group" },
	                                                    _react2.default.createElement(
	                                                        "label",
	                                                        null,
	                                                        "Banner Image"
	                                                    ),
	                                                    _react2.default.createElement("input", {
	                                                        type: "file",
	                                                        className: "form-control",
	                                                        name: "image",
	                                                        id: "image",
	                                                        onChange: handleFileChange,
	                                                        accept: "image/*" // Specify the accepted file types if needed
	                                                        , placeholder: "Banner Image"
	                                                    })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "form-group text-right" },
	                                            _react2.default.createElement(
	                                                "button",
	                                                {
	                                                    type: "submit",
	                                                    className: "btn waves-effect waves-light"
	                                                },
	                                                "Submit"
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	    );
	};
	
	exports.default = Banner_create;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Banner_list = function Banner_list() {
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        fatchdata = _useState2[0],
	        setFatchdata = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        modalDeleteConfirm = _useState4[0],
	        setModalDeleteConfirm = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        id = _useState6[0],
	        setId = _useState6[1];
	
	    var openModalDeleteConfirm = function openModalDeleteConfirm(id) {
	        setModalDeleteConfirm(true);
	        setId(id);
	    };
	
	    var closeModalDeleteConfirm = function closeModalDeleteConfirm() {
	        setModalDeleteConfirm(false);
	    };
	
	    console.log(fatchdata, "Dataset");
	
	    (0, _react.useEffect)(function () {
	        fetchData(); // Initial data fetch
	    }, []);
	
	    var fetchData = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var response;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _.thirdparty.get("/banner");
	
	                        case 3:
	                            response = _context.sent;
	                            // Update the API endpoint
	
	                            if (response.status === 200) {
	                                setFatchdata(response.data);
	                                // setLoading(false);
	                            }
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error("Error fetching data:", _context.t0.message);
	
	                        case 10:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function fetchData() {
	            return _ref.apply(this, arguments);
	        };
	    }();
	
	    var handleDelete = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var response;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _.thirdparty.delete("/banner/" + id);
	
	                        case 3:
	                            response = _context2.sent;
	                            // Update the API endpoint
	
	                            if (response.status === 200) {
	                                console.log("Item with ID " + id + " deleted successfully.");
	                                fetchData(); // Fetch updated data after deletion
	                            }
	                            _context2.next = 10;
	                            break;
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2["catch"](0);
	
	                            console.error("Error deleting item with ID " + id + ":", _context2.t0.message);
	
	                        case 10:
	                            _context2.prev = 10;
	
	                            closeModalDeleteConfirm();
	                            return _context2.finish(10);
	
	                        case 13:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7, 10, 13]]);
	        }));
	
	        return function handleDelete() {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	            "div",
	            { id: "wrapper" },
	            _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	            _react2.default.createElement(
	                "div",
	                { className: "content-page" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "content" },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "row page-content-wrapper g-0 g-3" },
	                        _react2.default.createElement("div", { className: "col-sm-7" }),
	                        _react2.default.createElement("div", { className: "col-sm-3 text-right" }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12 mb-4  d-flex justify-content-between align-items-center " },
	                            _react2.default.createElement(
	                                "h5",
	                                null,
	                                "Banner"
	                            ),
	                            _react2.default.createElement(
	                                "a",
	                                {
	                                    href: "/admin/banner/create",
	                                    className: "btn btn-sm waves-effect waves-light"
	                                },
	                                "Add Banner"
	                            )
	                        ),
	                        fatchdata.length > 0 ? fatchdata.map(function (item) {
	                            return _react2.default.createElement(
	                                "div",
	                                { className: "col-md-3", key: item.id },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "card" },
	                                    _react2.default.createElement("img", {
	                                        className: "card-img-top ",
	                                        src: _constants.IMAGE_URL + item.image_path,
	                                        alt: "Card image cap",
	                                        style: { height: "100vh", maxHeight: "300px" }
	                                    }),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "card-body" },
	                                        _react2.default.createElement(
	                                            "p",
	                                            null,
	                                            "ID: ",
	                                            item.id
	                                        ),
	                                        _react2.default.createElement(
	                                            "p",
	                                            null,
	                                            "Serial No: ",
	                                            item.index_no
	                                        ),
	                                        _react2.default.createElement(
	                                            "h5",
	                                            { className: "card-title" },
	                                            item.title
	                                        ),
	                                        _react2.default.createElement(
	                                            "p",
	                                            { className: "card-text" },
	                                            item.description
	                                        ),
	                                        _react2.default.createElement(
	                                            "h5",
	                                            {
	                                                className: "mt-2",
	                                                style: {
	                                                    display: "flex",
	                                                    alignItems: "flex-end",
	                                                    columnGap: "10px",
	                                                    rowGap: "10px",
	                                                    justifyContent: "flex-end"
	                                                }
	                                            },
	                                            _react2.default.createElement(
	                                                "a",
	                                                {
	                                                    href: "/admin/banner/update/" + item.id,
	                                                    baord_member_id: item.id
	                                                },
	                                                _react2.default.createElement("i", { className: "fa fa-pencil-square " })
	                                            ),
	                                            _react2.default.createElement(
	                                                "a",
	                                                { onClick: function onClick() {
	                                                        return openModalDeleteConfirm(item.id);
	                                                    } },
	                                                _react2.default.createElement("i", { className: "fa fa-trash" })
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        _DeleteConfirmModalPopup2.default,
	                                        {
	                                            show: modalDeleteConfirm,
	                                            handleClose: closeModalDeleteConfirm
	                                        },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "custom_reviews_popup" },
	                                            _react2.default.createElement(
	                                                "h2",
	                                                { className: "text-center" },
	                                                "Are you sure you want to delete this Banner?"
	                                            ),
	                                            _react2.default.createElement(
	                                                "form",
	                                                { className: "pop-form", id: "edit_education" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "form-group row" },
	                                                    _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                                                    _react2.default.createElement(
	                                                        "div",
	                                                        { className: "col-sm-6 text-center" },
	                                                        _react2.default.createElement(
	                                                            "button",
	                                                            {
	                                                                type: "button",
	                                                                className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                                                onClick: closeModalDeleteConfirm
	                                                            },
	                                                            "No"
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "button",
	                                                            {
	                                                                type: "button",
	                                                                className: "blue_btn_box add_staff_btn mt-5",
	                                                                onClick: function onClick() {
	                                                                    console.log("Deleting...");
	                                                                    handleDelete();
	                                                                }
	                                                            },
	                                                            "Yes"
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            );
	                        }) : _react2.default.createElement(
	                            "div",
	                            null,
	                            "No data found"
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	    );
	};
	
	exports.default = Banner_list;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Banner_create = function Banner_create(props) {
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        data = _useState2[0],
	        setData = _useState2[1];
	
	    console.log(data, "data");
	
	    var _useState3 = (0, _react.useState)({
	        type: "home_page",
	        title: "",
	        description: "",
	        image: null,
	        status: 1,
	        index_no: 1
	    }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        formData = _useState4[0],
	        setFormData = _useState4[1];
	
	    console.log(formData, "hello");
	
	    var fetchData = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var response;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _.thirdparty.get("/banner/" + props.match.params.id);
	
	                        case 3:
	                            response = _context.sent;
	
	                            console.log("response_data: ", response.data);
	                            setFormData(Object.assign({}, formData, response.data));
	                            _context.next = 11;
	                            break;
	
	                        case 8:
	                            _context.prev = 8;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error("Error fetching data:", _context.t0);
	
	                        case 11:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 8]]);
	        }));
	
	        return function fetchData() {
	            return _ref.apply(this, arguments);
	        };
	    }();
	
	    var handleChange = function handleChange(e) {
	        var _e$target = e.target,
	            name = _e$target.name,
	            value = _e$target.value;
	
	        setFormData(Object.assign({}, formData, _defineProperty({}, name, value)));
	    };
	
	    var handleFileChange = function handleFileChange(e) {
	        var file = e.target.files[0];
	
	        // Check if a file was selected
	        if (file) {
	            // Update the formData state by setting the author_profile_pic to the selected file
	            setFormData(Object.assign({}, formData, {
	                image: file
	            }));
	        }
	    };
	
	    var handleSubmit = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	            var response;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            e.preventDefault();
	                            _context2.prev = 1;
	                            _context2.next = 4;
	                            return _.thirdparty.post("/banner_update/" + props.match.params.id, formData, {
	                                headers: {
	                                    "Content-Type": "multipart/form-data"
	                                }
	                            });
	
	                        case 4:
	                            response = _context2.sent;
	
	                            if (response.status === 200) {
	                                _reactToastify.toast.success("Banner Added Successfully!", {
	                                    position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                                    autoClose: 3000
	                                });
	                            }
	                            console.log("Form data sent:", response.status);
	                            _context2.next = 12;
	                            break;
	
	                        case 9:
	                            _context2.prev = 9;
	                            _context2.t0 = _context2["catch"](1);
	
	                            console.error("Error submitting form:", _context2.t0);
	                            // Handle errors, show error messages, etc.
	
	                        case 12:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[1, 9]]);
	        }));
	
	        return function handleSubmit(_x) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    (0, _react.useEffect)(function () {
	        fetchData();
	    }, []);
	    return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(_Seo2.default, {
	            title: "Update Banner",
	            description: "Update Banner United Hospital",
	            pathSlug: "/Banner_create",
	            keywords: "Update Banner, Banner"
	        }),
	        _react2.default.createElement(
	            "div",
	            { id: "wrapper" },
	            _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	            _react2.default.createElement(
	                "div",
	                { className: "content-page" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "content" },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "page-content-wrapper d-flex justify-content-center" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "col-lg-6" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "card m-b-20" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "card-body" },
	                                    _react2.default.createElement(
	                                        "h2",
	                                        { className: "mt-0" },
	                                        "Update Banner"
	                                    ),
	                                    _react2.default.createElement("hr", null),
	                                    _react2.default.createElement(
	                                        "form",
	                                        {
	                                            id: "adddepartmentform",
	                                            className: "needs-validation",
	                                            noValidate: true,
	                                            onSubmit: handleSubmit
	                                        },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "row" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "col-sm-4" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "form-group" },
	                                                    _react2.default.createElement(
	                                                        "label",
	                                                        null,
	                                                        "Serial No."
	                                                    ),
	                                                    _react2.default.createElement("input", {
	                                                        type: "number",
	                                                        className: "form-control",
	                                                        name: "index_no",
	                                                        id: "index_no",
	                                                        value: formData.index_no,
	                                                        onChange: handleChange,
	                                                        required: true,
	                                                        placeholder: "Serial Number"
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "col-sm-8" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "form-group" },
	                                                    _react2.default.createElement(
	                                                        "label",
	                                                        null,
	                                                        "Title"
	                                                    ),
	                                                    _react2.default.createElement("input", {
	                                                        type: "text",
	                                                        className: "form-control",
	                                                        name: "title",
	                                                        id: "title",
	                                                        value: formData.title,
	                                                        onChange: handleChange,
	                                                        required: true,
	                                                        placeholder: "Name"
	                                                    })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "row" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "col-sm-12" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "form-group" },
	                                                    _react2.default.createElement(
	                                                        "label",
	                                                        null,
	                                                        "Description"
	                                                    ),
	                                                    _react2.default.createElement("textarea", {
	                                                        // type="text"
	                                                        className: "form-control",
	                                                        name: "description",
	                                                        id: "description",
	                                                        value: formData.description,
	                                                        onChange: handleChange
	                                                        // required
	                                                        , placeholder: "Description"
	                                                    })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "row" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "col-sm-12" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "form-group" },
	                                                    _react2.default.createElement(
	                                                        "label",
	                                                        null,
	                                                        "Banner Image"
	                                                    ),
	                                                    _react2.default.createElement("input", {
	                                                        type: "file",
	                                                        className: "form-control",
	                                                        name: "image",
	                                                        id: "image",
	                                                        onChange: handleFileChange,
	                                                        accept: "image/*" // Specify the accepted file types if needed
	                                                        , placeholder: "Banner Image"
	                                                    })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "form-group text-right" },
	                                            _react2.default.createElement(
	                                                "button",
	                                                {
	                                                    type: "submit",
	                                                    className: "btn waves-effect waves-light"
	                                                },
	                                                "Update"
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	    );
	};
	
	exports.default = Banner_create;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _ = __webpack_require__(2);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _reactVirtualizedSelect = __webpack_require__(78);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	__webpack_require__(73);
	
	__webpack_require__(75);
	
	__webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var CaseStudies_create = function CaseStudies_create() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      doctors = _useState2[0],
	      setDoctor = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    title: "",
	    short_description: "",
	    description: "",
	    featured_image: null,
	    gallery: [],
	    doctor_id: "",
	    status: 1
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      formData = _useState4[0],
	      setFormData = _useState4[1];
	
	  var fetchDoctor = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/doctors/getdoctors");
	
	            case 3:
	              response = _context.sent;
	
	              if (response.status === 200) {
	                setDoctor(response.data.data);
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchDoctor(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	    if (name === "doctor_id") {
	      // Check if the select element is for doctor_id
	      setFormData(Object.assign({}, formData, {
	        doctor_id: value
	      }));
	    } else {
	      setFormData(Object.assign({}, formData, _defineProperty({}, name, value)));
	    }
	  };
	
	  var handleFileChange = function handleFileChange(e) {
	    var file = e.target.files[0];
	    // Check if a file was selected
	    if (file) {
	      // Update the formData state by setting the author_profile_pic to the selected file
	      setFormData(Object.assign({}, formData, {
	        featured_image: file
	      }));
	    }
	  };
	  var handleGalleryChange = function handleGalleryChange(e) {
	    setFormData(Object.assign({}, formData, {
	      "gallery[]": e.target.files
	    }));
	  };
	
	  var handleSubmit = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              e.preventDefault();
	              // return;
	              // const { gallery, ...resData } = formData;
	
	              // const postData = {
	              //   "gallery[]": gallery,
	              //   ...resData,
	              // };
	              // console.log("kasLog", resData);
	              _context2.prev = 1;
	              _context2.next = 4;
	              return _.thirdparty.post("/case_studies", formData, {
	                headers: {
	                  "Content-Type": "multipart/form-data"
	                }
	              });
	
	            case 4:
	              response = _context2.sent;
	
	              if (response.status === 201) {
	                _reactToastify.toast.success("Add Case Study successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	              }
	              console.log("Form data sent:", response.status);
	              _context2.next = 12;
	              break;
	
	            case 9:
	              _context2.prev = 9;
	              _context2.t0 = _context2["catch"](1);
	
	              console.error("Error submitting form:", _context2.t0);
	              // Handle errors, show error messages, etc.
	
	            case 12:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[1, 9]]);
	    }));
	
	    return function handleSubmit(_x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	  (0, _react.useEffect)(function () {
	    fetchDoctor();
	  }, []);
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(_Seo2.default, {
	      title: "Add Case Study",
	      description: "Add Case Study  - United Hospital",
	      pathSlug: "/admin/case_studies_create",
	      keywords: "Add Case Study, Case Study"
	    }),
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      id: "adddepartmentform",
	                      className: "needs-validation",
	                      noValidate: true,
	                      onSubmit: handleSubmit
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Title"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "title",
	                            id: "title",
	                            value: formData.title,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Name"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Doctors Name"
	                          ),
	                          _react2.default.createElement(_reactVirtualizedSelect2.default, {
	                            id: "author_id",
	                            name: "doctor_id",
	                            className: "form-control custom_select_search",
	                            placeholder: "Select Doctor",
	                            options: doctors.map(function (item, index) {
	                              return {
	                                label: item.doctor_name,
	                                value: item.id
	                              };
	                            }),
	                            value: formData.doctor_id,
	                            onChange: function onChange(selectValue) {
	                              return setFormData(Object.assign({}, formData, {
	                                doctor_id: selectValue.value
	                              }));
	                            }
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Feature Image"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "file",
	                            className: "form-control",
	                            name: "featured_image",
	                            id: "featured_image",
	                            onChange: handleFileChange,
	                            accept: "image/*" // Specify the accepted file types if needed
	                            , placeholder: "Feature Image"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Short Description"
	                          ),
	                          _react2.default.createElement("textarea", {
	                            className: "form-control",
	                            name: "short_description",
	                            id: "short_description",
	                            value: formData.short_description,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Write Summery",
	                            rows: 4,
	                            cols: 40
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Description"
	                          ),
	                          _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                            name: "description",
	                            id: "description",
	                            value: formData.description
	                            // placeholder="Write in details"
	                            , onChange: function onChange(name, val) {
	                              return setFormData(Object.assign({}, formData, _defineProperty({}, name, val)));
	                            }
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Gallery"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "file",
	                            className: "form-control",
	                            name: "gallery[]",
	                            id: "gallery",
	                            onChange: handleGalleryChange,
	                            accept: "image/*" // Specify the accepted file types if needed
	                            , placeholder: "Feature Image",
	                            multiple: "multiple"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "submit",
	                            className: "btn waves-effect waves-light"
	                          },
	                          "Submit"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = CaseStudies_create;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var CaseStudies_list = function CaseStudies_list() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchdata = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      modalDeleteConfirm = _useState4[0],
	      setModalDeleteConfirm = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      id = _useState6[0],
	      setId = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      searchTerm = _useState8[0],
	      setSearchTerm = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      currentPage = _useState10[0],
	      setCurrentPage = _useState10[1];
	
	  var itemsPerPage = 8; // Number of items to display per page
	
	  var _useState11 = (0, _react.useState)(""),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filteredData = _useState12[0],
	      setfilteredData = _useState12[1];
	
	  var openModalDeleteConfirm = function openModalDeleteConfirm(id) {
	    setModalDeleteConfirm(true);
	    setId(id);
	  };
	
	  var closeModalDeleteConfirm = function closeModalDeleteConfirm() {
	    setModalDeleteConfirm(false);
	  };
	
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/case_studies?show_hidden=1");
	
	            case 3:
	              response = _context.sent;
	
	
	              if (response.status === 200) {
	                setFatchdata(response.data);
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var handleDelete = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return _.thirdparty.delete("/case_studies/" + id);
	
	            case 3:
	              response = _context2.sent;
	
	
	              if (response.status === 200) {
	                fetchData(); // Fetch updated data after deletion
	              }
	              _context2.next = 10;
	              break;
	
	            case 7:
	              _context2.prev = 7;
	              _context2.t0 = _context2["catch"](0);
	
	              console.error("Error deleting item with ID " + id + ":", _context2.t0.message);
	
	            case 10:
	              _context2.prev = 10;
	
	              closeModalDeleteConfirm();
	              return _context2.finish(10);
	
	            case 13:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 7, 10, 13]]);
	    }));
	
	    return function handleDelete() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    fetchData(); // Initial data fetch
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var filteredData = fatchdata && fatchdata.filter(function (item) {
	      return item["title"].toLowerCase().includes(searchTerm.toLowerCase());
	    });
	
	    setfilteredData(filteredData);
	  }, [fatchdata, searchTerm]);
	  // Get current items to display
	  var indexOfLastItem = currentPage * itemsPerPage;
	  var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  var currentItems = filteredData ? filteredData.slice(indexOfFirstItem, indexOfLastItem) : [];
	
	  var togglePackageStatus = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(item) {
	      var newStatus, data, response;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              newStatus = item.status === "1" ? "0" : "1";
	              data = {
	                status: newStatus
	              };
	              _context3.prev = 2;
	              _context3.next = 5;
	              return _.scAxiosAdmin.post("/case_studies/" + item.id, data);
	
	            case 5:
	              response = _context3.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Status updated successfully", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT
	                });
	                setFatchdata(function (prev) {
	                  return prev.map(function (pkg) {
	                    return pkg.id === item.id ? Object.assign({}, pkg, { status: newStatus }) : pkg;
	                  });
	                });
	              } else {
	                _reactToastify.toast.error("Failed to update status", {
	                  position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                });
	              }
	              _context3.next = 13;
	              break;
	
	            case 9:
	              _context3.prev = 9;
	              _context3.t0 = _context3["catch"](2);
	
	              console.error("Error updating status:", _context3.t0);
	              _reactToastify.toast.error("Failed to update status", {
	                position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	              });
	
	            case 13:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[2, 9]]);
	    }));
	
	    return function togglePackageStatus(_x) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  // Handle search term change
	  var handleSearch = function handleSearch(event) {
	    setSearchTerm(event.target.value);
	    setCurrentPage(1);
	  };
	
	  // Handle page change
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setCurrentPage(pageNumber);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "row page-content-wrapper g-0 g-3" },
	            _react2.default.createElement("div", { className: "col-sm-7" }),
	            _react2.default.createElement("div", { className: "col-sm-3 text-right" }),
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-12 mb-4  d-flex justify-content-between align-items-center " },
	              _react2.default.createElement(
	                "h5",
	                null,
	                "Case Studies"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex justify-content-between w-50" },
	                _react2.default.createElement("input", {
	                  className: "form-control",
	                  type: "search",
	                  placeholder: "Search",
	                  "aria-label": "Search",
	                  value: searchTerm,
	                  onChange: handleSearch,
	                  style: { background: "transparent", border: "none" }
	                }),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "/admin/case_studies_create",
	                    className: "btn btn-sm waves-effect waves-light w-50"
	                  },
	                  "Add Case Studies"
	                )
	              )
	            ),
	            currentItems.length > 0 ? currentItems.map(function (item) {
	              return _react2.default.createElement(
	                "div",
	                { className: "col-md-2", key: item.id },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card h-100" },
	                  _react2.default.createElement("img", {
	                    className: "card-img-top ",
	                    src: _constants.IMAGE_URL + "/" + item.featured_image,
	                    alt: "Card image cap",
	                    style: { height: "100%", maxHeight: "150px" }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card-body" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      item.title
	                    ),
	                    _react2.default.createElement(
	                      "h5",
	                      {
	                        className: "mt-2",
	                        style: {
	                          display: "flex",
	                          alignItems: "flex-end",
	                          columnGap: "10px",
	                          rowGap: "10px",
	                          justifyContent: "flex-end"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: "/admin/case_studies_update/" + item.id,
	                          item_id: item.id
	                        },
	                        _react2.default.createElement("i", { className: "fa fa-pencil-square " })
	                      ),
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          className: "ms-2",
	                          title: "Status",
	                          onClick: function onClick() {
	                            return togglePackageStatus(item);
	                          }
	                        },
	                        item.status === "1" ? _react2.default.createElement("i", { "class": "fa-solid fa-eye" }) : _react2.default.createElement("i", { "class": "fa-solid fa-eye-slash" })
	                      ),
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: "/pages/case-study/" + item.id,
	                          target: "_blank"
	                        },
	                        _react2.default.createElement("i", { "class": "fa-solid fa-laptop" })
	                      ),
	                      _react2.default.createElement(
	                        "a",
	                        { onClick: function onClick() {
	                            return openModalDeleteConfirm(item.id);
	                          } },
	                        _react2.default.createElement("i", { className: "fa fa-trash" })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    _DeleteConfirmModalPopup2.default,
	                    {
	                      show: modalDeleteConfirm,
	                      handleClose: closeModalDeleteConfirm
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "custom_reviews_popup" },
	                      _react2.default.createElement(
	                        "h2",
	                        { className: "text-center" },
	                        "Are you sure you want to delete this item?"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        { className: "pop-form", id: "edit_education" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group row" },
	                          _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6 text-center" },
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "button",
	                                className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                onClick: closeModalDeleteConfirm
	                              },
	                              "No"
	                            ),
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "button",
	                                className: "blue_btn_box add_staff_btn mt-5",
	                                onClick: function onClick() {
	                                  // Add your logic for handling delete here
	                                  // e.g., this.modalDeletePublication(this.state.publications_id)
	
	                                  // ModalDeleteConfirm(item.id);
	                                  handleDelete();
	                                }
	                              },
	                              "Yes"
	                            )
	                          ),
	                          _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                        )
	                      )
	                    )
	                  )
	                )
	              );
	            }) : _react2.default.createElement(
	              "div",
	              null,
	              "No data found"
	            ),
	            _react2.default.createElement(_reactJsPagination2.default, {
	              activePage: currentPage,
	              itemsCountPerPage: itemsPerPage,
	              totalItemsCount: filteredData ? filteredData.length : 1,
	              pageRangeDisplayed: 5,
	              onChange: handlePageChange
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = CaseStudies_list;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _ = __webpack_require__(2);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _constants = __webpack_require__(3);
	
	var _reactVirtualizedSelect = __webpack_require__(78);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	__webpack_require__(73);
	
	__webpack_require__(75);
	
	__webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var CaseStudies_update = function CaseStudies_update(props) {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      doctors = _useState2[0],
	      setDoctor = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    title: "",
	    short_description: "",
	    description: "",
	    featured_image: null,
	    gallery: [],
	    doctor_id: "",
	    status: 1
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      formData = _useState4[0],
	      setFormData = _useState4[1];
	
	  console.log(formData, "FORM_DATA");
	
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/case_studies/" + props.match.params.id);
	
	            case 3:
	              response = _context.sent;
	
	
	              setFormData(Object.assign({}, formData, response.data));
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var fetchDoctor = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return _.thirdparty.get("/doctors/getdoctors");
	
	            case 3:
	              response = _context2.sent;
	
	              if (response.status === 200) {
	                setDoctor(response.data.data);
	              }
	              _context2.next = 10;
	              break;
	
	            case 7:
	              _context2.prev = 7;
	              _context2.t0 = _context2["catch"](0);
	
	              console.error("Error fetching data:", _context2.t0.message);
	
	            case 10:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 7]]);
	    }));
	
	    return function fetchDoctor(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	    if (name === "doctor_id") {
	      // Check if the select element is for doctor_id
	      setFormData(Object.assign({}, formData, {
	        doctor_id: value
	      }));
	    } else {
	      setFormData(Object.assign({}, formData, _defineProperty({}, name, value)));
	    }
	  };
	
	  var handleFileChange = function handleFileChange(e) {
	    var file = e.target.files[0];
	    // Check if a file was selected
	    if (file) {
	      // Update the formData state by setting the author_profile_pic to the selected file
	      setFormData(Object.assign({}, formData, {
	        featured_image: file
	      }));
	    }
	  };
	  var handleGalleryChange = function handleGalleryChange(e) {
	    setFormData(Object.assign({}, formData, {
	      "gallery[]": e.target.files
	    }));
	  };
	
	  var handleSubmit = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              e.preventDefault();
	              _context3.prev = 1;
	              _context3.next = 4;
	              return _.thirdparty.post("/case_studies/" + props.match.params.id, formData, {
	                headers: {
	                  "Content-Type": "multipart/form-data"
	                }
	              });
	
	            case 4:
	              response = _context3.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Case Study update successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 2000
	                });
	
	                window.location.reload();
	              }
	
	              _context3.next = 11;
	              break;
	
	            case 8:
	              _context3.prev = 8;
	              _context3.t0 = _context3["catch"](1);
	
	              console.error("Error submitting form:", _context3.t0);
	              // Handle errors, show error messages, etc.
	
	            case 11:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[1, 8]]);
	    }));
	
	    return function handleSubmit(_x2) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	  (0, _react.useEffect)(function () {
	    fetchDoctor();
	    fetchData();
	  }, []);
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(_Seo2.default, {
	      title: "Edit Case Study",
	      description: "Edit Case Study  - United Hospital",
	      pathSlug: "/admin/case_studies_update",
	      keywords: "Edit Case Study, Case Study"
	    }),
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      id: "adddepartmentform",
	                      className: "needs-validation",
	                      noValidate: true,
	                      onSubmit: handleSubmit
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Title"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "title",
	                            id: "title",
	                            value: formData.title,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Name"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Doctors Name"
	                          ),
	                          _react2.default.createElement(_reactVirtualizedSelect2.default, {
	                            id: "author_id",
	                            name: "doctor_id",
	                            className: "form-control custom_select_search",
	                            placeholder: "Select Doctor",
	                            options: doctors.map(function (item, index) {
	                              return {
	                                label: item.doctor_name,
	                                value: item.id
	                              };
	                            }),
	                            value: formData.doctor_id,
	                            onChange: function onChange(selectValue) {
	                              return setFormData(Object.assign({}, formData, {
	                                doctor_id: selectValue.value
	                              }));
	                            }
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Feature Image"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "file",
	                            className: "form-control",
	                            name: "featured_image",
	                            id: "featured_image",
	                            onChange: handleFileChange,
	                            accept: "image/*" // Specify the accepted file types if needed
	                            , placeholder: "Feature Image"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Short Description"
	                          ),
	                          _react2.default.createElement("textarea", {
	                            className: "form-control",
	                            name: "short_description",
	                            id: "short_description",
	                            value: formData.short_description,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Write Summery",
	                            rows: 4,
	                            cols: 40
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Description"
	                          ),
	                          _react2.default.createElement("textarea", {
	                            className: "form-control",
	                            name: "description",
	                            id: "description",
	                            value: formData.description,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Write Summery",
	                            rows: 4,
	                            cols: 40
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Gallery"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "file",
	                            className: "form-control",
	                            name: "gallery[]",
	                            id: "gallery",
	                            onChange: handleGalleryChange,
	                            accept: "image/*" // Specify the accepted file types if needed
	                            , placeholder: "Feature Image",
	                            multiple: "multiple"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "submit",
	                            className: "btn waves-effect waves-light"
	                          },
	                          "Submit"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "card mb-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-header" },
	                  "Featured Images"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  formData.featured_image != null ? _react2.default.createElement("img", {
	                    src: _constants.IMAGE_URL + "/" + formData.featured_image,
	                    alt: "",
	                    className: "image-fluid p-2",
	                    width: 250
	                  }) : null
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-9" },
	              _react2.default.createElement(
	                "div",
	                { className: "card mb-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-header" },
	                  "Images"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  formData.gallery && formData.gallery.length > 0 ? formData.gallery.map(function (image) {
	                    return _react2.default.createElement("img", {
	                      src: _constants.IMAGE_URL + "/" + image,
	                      alt: "",
	                      className: "image-fluid p-2",
	                      width: 250,
	                      key: image
	                    });
	                  }) : null
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = CaseStudies_update;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(92);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	var _EmailConfigComponent = __webpack_require__(141);
	
	var _EmailConfigComponent2 = _interopRequireDefault(_EmailConfigComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var EmailConfiguration = function EmailConfiguration(_ref) {
	  var user = _ref.user;
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      adminEmail = _useState2[0],
	      setAdminEmail = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      saveAdminLoading = _useState4[0],
	      setSaveAdminLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      error = _useState6[0],
	      setError = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      postResponseAdminRole = _useState8[0],
	      setPostResponseAdminEmail = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      loading = _useState10[0],
	      setLoading = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({}),
	      _useState12 = _slicedToArray(_useState11, 2),
	      responseData = _useState12[0],
	      setResponseData = _useState12[1];
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _.scAxiosAdmin.request("/settings/12", {
	                  method: "get",
	                  headers: {
	                    Accept: "application/json",
	                    Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                  },
	                  params: {
	                    // ...data
	                  }
	                });
	
	              case 3:
	                response = _context.sent;
	
	                setResponseData(response.data);
	                setAdminEmail(response.data.value);
	                setLoading(false);
	                _context.next = 13;
	                break;
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0);
	                setLoading(false);
	
	              case 13:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 9]]);
	      }));
	
	      return function fetchData() {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	  var handleTextChange = function handleTextChange(event) {
	    setAdminEmail(event.target.value);
	  };
	
	  var handleSubmit = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(event) {
	      var requestData, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              event.preventDefault();
	              setSaveAdminLoading(true);
	              setError(null);
	              requestData = {
	                value: adminEmail
	              };
	              // console.log("some data", checkedIds, roleName)
	
	              _context2.prev = 4;
	              _context2.next = 7;
	              return _.scAxiosAdmin.post("/settings_update/11", requestData, {
	                method: "post",
	                headers: {
	                  Accept: "application/json",
	                  "Content-Type": "application/json",
	                  Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                }
	              });
	
	            case 7:
	              response = _context2.sent;
	
	              setPostResponseAdminEmail(response.data);
	              setSaveAdminLoading(false);
	              _reactToastify.toast.success("Configuration Updated Successfully!");
	              _context2.next = 17;
	              break;
	
	            case 13:
	              _context2.prev = 13;
	              _context2.t0 = _context2["catch"](4);
	
	              setError(_context2.t0);
	              setSaveAdminLoading(false);
	
	            case 17:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[4, 13]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "row g-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-3" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Emergency Number",
	                label: "Put Emergency Number Here",
	                query: 31
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-3" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Phone Number",
	                label: "Put Phone Number Here",
	                query: 32
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-3" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "International Phone Number",
	                label: "Put International Phone Number Here",
	                query: 33
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-3" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "WhatsApp Number",
	                label: "Put whatsapp Number Here",
	                query: 34
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-3" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Facebook",
	                label: "Put Facebook Link Here",
	                query: 50
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-3" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Twitter",
	                label: "Put Twitter Link Here",
	                query: 51
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-3" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Instagram",
	                label: "Put Instagram Link Here",
	                query: 52
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-3" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Youtube",
	                label: "Put Youtube Link Here",
	                query: 53
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row g-5 mt-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Copyright",
	                label: "Footer Copyright",
	                query: 60,
	                inputType: "textarea"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row g-5 mt-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Address (Dhaka)",
	                label: "Put Email Here",
	                query: 35,
	                inputType: "textarea"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Address (Chattogram)",
	                label: "Put Address Here",
	                query: 38,
	                inputType: "textarea"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Address (Sylhet)",
	                label: "Put Address Here",
	                query: 41,
	                inputType: "textarea"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Map (Dhaka)",
	                label: "Put  Google Map Link Here",
	                query: 36,
	                inputType: "textarea"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Map (Chattogram)",
	                label: "Put  Google Map Link Here",
	                query: 39,
	                inputType: "textarea"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Map (Sylhet)",
	                label: "Put  Google Map Link Here",
	                query: 42,
	                inputType: "textarea"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = EmailConfiguration;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var updateBodyLink = function updateBodyLink(id, data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bodylink/updatebodylink/" + id, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var editBodyLink = function editBodyLink(id, data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bodylink/editbodylink/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var getAllBodyParts = function getAllBodyParts(gender, data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bodylink/getbodyparts/" + gender, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getDepartments = function getDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var EditBodyLink = function (_Component) {
	  _inherits(EditBodyLink, _Component);
	
	  function EditBodyLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditBodyLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditBodyLink.__proto__ || Object.getPrototypeOf(EditBodyLink)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      bodyparts: [],
	      id: "",
	      gender: "",
	      edit_department_id: "",
	      edit_body_part_id: "",
	      departments: []
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.getBodyParts = function (event) {
	      _this.setState({ gender: event.target.value });
	      _this.refreshAllBodyParts(event.target.value);
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        var id = _this.props.match.params.id;
	        _this.setState({ id: id });
	        var data = {
	          edit_department_id: _this.state.edit_department_id,
	          edit_body_part_id: _this.state.edit_body_part_id,
	          gender: _this.state.gender
	        };
	        if (_this.state.gender != "") {
	          _this.setState({ gender: _this.state.gender });
	          _this.refreshAllBodyParts();
	        }
	        _this.refreshEditBodylink();
	        updateBodyLink(id, data).then(function (res) {
	          if (res.message) {
	            _reactToastify.toast.success(res.message, {
	              position: _reactToastify.toast.POSITION.TOP_RIGHT
	            });
	          } else {
	            _reactToastify.toast.error(res.error, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          }
	          // setTimeout(function () {
	          //   window.location.href = "/admin/body-links";
	          // }, 3000);
	        });
	      }
	    }, _this.refreshAllBodyParts = function (gender) {
	      getAllBodyParts(_this.state.gender).then(function (res) {
	        // console.log(gender);
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ bodyparts: records.map(function (rec) {
	              return rec;
	            }) });
	        } else {
	          _this.setState({ bodyparts: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshEditBodylink = function (id) {
	      editBodyLink(_this.props.match.params.id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          var bodypart = res.bodypart;
	          _this.setState({ gender: records.gender });
	          _this.setState({ edit_department_id: records.department_id });
	          _this.setState({ bodyparts: bodypart.map(function (rec) {
	              return rec;
	            }) });
	          _this.setState({ edit_body_part_id: records.id });
	        } else {
	          _this.setState({ gender: "" });
	          _this.setState({ edit_department_id: "" });
	          _this.setState({ edit_body_part_id: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshDepartments = function () {
	      getDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditBodyLink, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.gender) {
	        formIsValid = false;
	        errors["gender"] = "*Please Select a Gender.";
	      }
	      if (!this.state.edit_department_id) {
	        formIsValid = false;
	        errors["edit_department_id"] = "*Please Select Department name.";
	      }
	      if (!this.state.edit_body_part_id) {
	        formIsValid = false;
	        errors["edit_body_part_id"] = "*Please Select a Body part.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var id = this.props.match.params.id;
	      this.setState({ id: id });
	      this.refreshEditBodylink();
	      // this.refreshAllBodyParts();
	      this.refreshDepartments();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Edit Body Link"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-9" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group" },
	                            _react2.default.createElement(
	                              "label",
	                              null,
	                              "Gender"
	                            ),
	                            _react2.default.createElement(
	                              "select",
	                              {
	                                defaultValue: "DEFAULT",
	                                className: "form-control",
	                                value: this.state.gender,
	                                name: "gender",
	                                id: "gender",
	                                onChange: this.getBodyParts,
	                                disabled: true
	                              },
	                              _react2.default.createElement(
	                                "option",
	                                { value: "" },
	                                "Select gender"
	                              ),
	                              _react2.default.createElement(
	                                "option",
	                                { value: "male" },
	                                "Male"
	                              ),
	                              _react2.default.createElement(
	                                "option",
	                                { value: "female" },
	                                "Female"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              { style: alertStyle },
	                              this.state.errors.gender
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-9" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group" },
	                            _react2.default.createElement(
	                              "label",
	                              null,
	                              "Body Parts"
	                            ),
	                            _react2.default.createElement(
	                              "select",
	                              {
	                                value: this.state.edit_body_part_id,
	                                className: "form-control",
	                                name: "edit_body_part_id",
	                                onChange: this.handleChange
	                              },
	                              _react2.default.createElement(
	                                "option",
	                                { value: "", disabled: true },
	                                "Select Body Part"
	                              ),
	                              this.state.bodyparts && this.state.bodyparts.length ? this.state.bodyparts.map(function (bodypart) {
	                                return _react2.default.createElement(
	                                  "option",
	                                  {
	                                    key: bodypart.id,
	                                    value: bodypart.id
	                                  },
	                                  bodypart.bodypart_name
	                                );
	                              }) : _react2.default.createElement(
	                                "option",
	                                { value: "", selected: true, disabled: true },
	                                "Select Body Parts"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              { style: alertStyle },
	                              this.state.errors.edit_body_part_id
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-9" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group" },
	                            _react2.default.createElement(
	                              "label",
	                              null,
	                              "Department Name"
	                            ),
	                            _react2.default.createElement(
	                              "select",
	                              {
	                                defaultValue: this.state.edit_department_id,
	                                className: "form-control",
	                                value: this.state.edit_department_id,
	                                name: "edit_department_id",
	                                id: "edit_department_id",
	                                onChange: this.handleChange
	                              },
	                              _react2.default.createElement(
	                                "option",
	                                { value: "", selected: true, disabled: true },
	                                "Select Department"
	                              ),
	                              this.state.departments.length > 0 ? this.state.departments.map(function (department, index) {
	                                return _react2.default.createElement(
	                                  "option",
	                                  {
	                                    key: department.dept_id,
	                                    value: department.dept_id
	                                  },
	                                  department.department_name
	                                );
	                              }) : _react2.default.createElement(
	                                "option",
	                                { value: "", selected: true, disabled: true },
	                                "Select Department"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              { style: alertStyle },
	                              this.state.errors.edit_department_id
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Submit"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return EditBodyLink;
	}(_react.Component);
	
	exports.default = EditBodyLink;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alertStyle = {
	  color: "red"
	};
	
	var EditInvestigation = function EditInvestigation() {
	  var route = (0, _reactRouterDom.useParams)();
	
	  var _useState = (0, _react.useState)({
	    id: "",
	    Product_Name: "",
	    Product_Group: "",
	    opd_amount: "",
	    ipd_price: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    // Fetch initial form data
	    _.scAxiosAdmin.get("/investigations/" + route.id, {
	      headers: {
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    }).then(function (response) {
	      var data = response.data;
	      setFormData({
	        id: data.id,
	        Product_Name: data.Product_Name,
	        Product_Group: data.Product_Group,
	        opd_amount: data.opd_amount,
	        ipd_price: data.ipd_price
	      });
	    }).catch(function (error) {
	      _reactToastify.toast.error("Error fetching data");
	    });
	  }, [route.id]);
	
	  var handleChange = function handleChange(event) {
	    var _event$target = event.target,
	        name = _event$target.name,
	        value = _event$target.value;
	
	    setFormData(function (prevData) {
	      return Object.assign({}, prevData, _defineProperty({}, name, value));
	    });
	  };
	
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	    var formdata = new FormData();
	    // formdata.append("Product_Name", formData.Product_Name);
	    // formdata.append("Product_Group", formData.Product_Group);
	    // formdata.append("opd_amount", formData.opd_amount);
	    // formdata.append("ipd_price", formData.ipd_price);
	
	    _.scAxiosAdmin.put("/investigations/" + formData.id, formData, {
	      headers: {
	        Accept: "application/json",
	        //   "Content-Type": `multipart/form-data; boundary=${formdata._boundary}`,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    }).then(function () {
	      _reactToastify.toast.success("Investigation updated successfully!");
	    }).catch(function () {
	      _reactToastify.toast.error("Error updating investigation");
	    });
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "h4",
	                    { className: "mt-0 header-title" },
	                    "Edit Investigation"
	                  ),
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      onSubmit: handleSubmit,
	                      id: "editdepartmentform",
	                      className: "needs-validation",
	                      noValidate: true
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Investigation Name"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "Product_Name",
	                            value: formData.Product_Name,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Investigation Name"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Investigation Group"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "Product_Group",
	                            value: formData.Product_Group,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Investigation Group"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Opd Amount"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "opd_amount",
	                            value: formData.opd_amount,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Opd Amount"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Ipd Amount"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "ipd_price",
	                            value: formData.ipd_price,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Ipd Amount"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "submit",
	                            className: "btn btn-pink waves-effect waves-light"
	                          },
	                          "Update"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = EditInvestigation;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(92);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	var _EmailConfigComponent = __webpack_require__(141);
	
	var _EmailConfigComponent2 = _interopRequireDefault(_EmailConfigComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var EmailConfiguration = function EmailConfiguration(_ref) {
	  var user = _ref.user;
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      adminEmail = _useState2[0],
	      setAdminEmail = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      saveAdminLoading = _useState4[0],
	      setSaveAdminLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      error = _useState6[0],
	      setError = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      postResponseAdminRole = _useState8[0],
	      setPostResponseAdminEmail = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      loading = _useState10[0],
	      setLoading = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({}),
	      _useState12 = _slicedToArray(_useState11, 2),
	      responseData = _useState12[0],
	      setResponseData = _useState12[1];
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _.scAxiosAdmin.request("/settings/12", {
	                  method: "get",
	                  headers: {
	                    Accept: "application/json",
	                    Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                  },
	                  params: {
	                    // ...data
	                  }
	                });
	
	              case 3:
	                response = _context.sent;
	
	                setResponseData(response.data);
	                setAdminEmail(response.data.value);
	                setLoading(false);
	                _context.next = 13;
	                break;
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0);
	                setLoading(false);
	
	              case 13:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 9]]);
	      }));
	
	      return function fetchData() {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	  var handleTextChange = function handleTextChange(event) {
	    setAdminEmail(event.target.value);
	  };
	
	  var handleSubmit = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(event) {
	      var requestData, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              event.preventDefault();
	              setSaveAdminLoading(true);
	              setError(null);
	              requestData = {
	                value: adminEmail
	              };
	              // console.log("some data", checkedIds, roleName)
	
	              _context2.prev = 4;
	              _context2.next = 7;
	              return _.scAxiosAdmin.post("/settings_update/11", requestData, {
	                method: "post",
	                headers: {
	                  Accept: "application/json",
	                  "Content-Type": "application/json",
	                  Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                }
	              });
	
	            case 7:
	              response = _context2.sent;
	
	              setPostResponseAdminEmail(response.data);
	              setSaveAdminLoading(false);
	              _reactToastify.toast.success("Admin Emails Updated Successfully!");
	              _context2.next = 17;
	              break;
	
	            case 13:
	              _context2.prev = 13;
	              _context2.t0 = _context2["catch"](4);
	
	              setError(_context2.t0);
	              setSaveAdminLoading(false);
	
	            case 17:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[4, 13]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "row g-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Appointment Email",
	                label: "Put Appointment Administrator Email Here",
	                query: 12,
	                formHelp: "use come (,) to separate emails"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Emergency Email",
	                label: "Put Emergency Administrator Email Here",
	                query: 13,
	                formHelp: "use come (,) to separate emails"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Inquiry Email",
	                label: "Put Inquiry Administrator Email Here",
	                query: 14,
	                formHelp: "use come (,) to separate emails"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Corporate Inquiry Email",
	                label: "Put Corporate Inquiry Administrator Email Here",
	                query: 15,
	                formHelp: "use come (,) to separate emails"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Brith/Death Cirtificate Email",
	                label: "Put Brith/Death Cirtificate Administrator Email Here",
	                query: 16,
	                formHelp: "use come (,) to separate emails"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Home Sample Collection Email",
	                label: "Home sample collection Administrator Email Here",
	                query: 17,
	                formHelp: "use come (,) to separate emails"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Contact Us Email",
	                label: "Contact Us Administrator Email Here",
	                query: 18,
	                formHelp: "use come (,) to separate emails"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = EmailConfiguration;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _reactToastify = __webpack_require__(7);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _ = __webpack_require__(2);
	
	var _utils = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var EmergencyInquiryMessages = function EmergencyInquiryMessages() {
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        fatchdata = _useState2[0],
	        setFatchdata = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(1),
	        _useState4 = _slicedToArray(_useState3, 2),
	        currentPage = _useState4[0],
	        setCurrentPage = _useState4[1];
	
	    var itemsPerPage = 10; // Number of items to display per page
	
	    var _useState5 = (0, _react.useState)(""),
	        _useState6 = _slicedToArray(_useState5, 2),
	        filteredData = _useState6[0],
	        setfilteredData = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(""),
	        _useState8 = _slicedToArray(_useState7, 2),
	        searchTerm = _useState8[0],
	        setSearchTerm = _useState8[1];
	
	    var fetchData = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var response;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _.thirdparty.get("/emergenecies_enquiry");
	
	                        case 3:
	                            response = _context.sent;
	
	
	                            if (response.status === 200) {
	                                setFatchdata(response.data);
	                            }
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error("Error fetching data:", _context.t0.message);
	
	                        case 10:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function fetchData() {
	            return _ref.apply(this, arguments);
	        };
	    }();
	
	    var handleDelete = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(id) {
	            var confirmation, response;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            confirmation = confirm("Are you sure to delete this item?");
	
	                            if (confirmation) {
	                                _context2.next = 4;
	                                break;
	                            }
	
	                            return _context2.abrupt("return");
	
	                        case 4:
	                            _context2.next = 6;
	                            return _.thirdparty.delete("/emergenecies_enquiry/" + id);
	
	                        case 6:
	                            response = _context2.sent;
	                            // Update the API endpoint
	                            if (response.status === 200) {
	                                _reactToastify.toast.success("Deleted Successfully!", {
	                                    position: _reactToastify.toast.POSITION.TOP_RIGHT
	                                });
	                                console.log("Item with ID " + id + " deleted successfully.");
	                                fetchData(); // Fetch updated data after deletion
	                            }
	                            _context2.next = 13;
	                            break;
	
	                        case 10:
	                            _context2.prev = 10;
	                            _context2.t0 = _context2["catch"](0);
	
	                            console.error("Error deleting item with ID " + id + ":", _context2.t0.message);
	
	                        case 13:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 10]]);
	        }));
	
	        return function handleDelete(_x) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    // Handle page change
	    var handlePageChange = function handlePageChange(pageNumber) {
	        setCurrentPage(pageNumber);
	    };
	
	    // Initial data fetch
	    (0, _react.useEffect)(function () {
	        fetchData();
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        var filteredData = fatchdata && fatchdata.filter(function (item) {
	            return Object.values(item).some(function (value) {
	                return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
	            });
	        });
	
	        setfilteredData(filteredData);
	    }, [fatchdata, searchTerm]);
	
	    var indexOfLastItem = currentPage * itemsPerPage;
	    var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	    var currentItems = filteredData ? filteredData.slice(indexOfFirstItem, indexOfLastItem) : [];
	
	    var handleSearch = function handleSearch(event) {
	        setSearchTerm(event.target.value);
	        setCurrentPage(1);
	    };
	
	    return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	            "div",
	            { id: "wrapper" },
	            _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	            _react2.default.createElement(
	                "div",
	                { className: "content-page" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "content" },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "row page-content-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { "class": "card p-0" },
	                            _react2.default.createElement(
	                                "div",
	                                { "class": "card-header row" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "col-md-8" },
	                                    _react2.default.createElement(
	                                        "h5",
	                                        { "class": "card-title text-left" },
	                                        "Emergency - Inquiry Messages"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "col-md-4 text-right" },
	                                    _react2.default.createElement("input", {
	                                        className: "form-control",
	                                        type: "search",
	                                        placeholder: "Search",
	                                        "aria-label": "Search",
	                                        value: searchTerm,
	                                        onChange: handleSearch,
	                                        style: {
	                                            background: "transparent",
	                                            border: "none"
	                                        }
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { "class": "card-body" },
	                                _react2.default.createElement(
	                                    "table",
	                                    { "class": "table table-striped table-hover" },
	                                    _react2.default.createElement(
	                                        "thead",
	                                        null,
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "#"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Type"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Name"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Gender"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Phone"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Email"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Ambulance"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Address"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "DOB"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Blood Group"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Message"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Time"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Action"
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tbody",
	                                        null,
	                                        currentItems.length > 0 ? currentItems.map(function (item) {
	                                            return _react2.default.createElement(
	                                                "tr",
	                                                { key: item.id },
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    null,
	                                                    item.id
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.type && item.type.charAt(0).toUpperCase() + item.type.slice(1)
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.first_name
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.gender
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.phone_number
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.email
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.need_ambulance
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.address + " " + item.thana
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.date_of_birth
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.blood_group
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.message
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    (0, _utils.formatDate)(item.created_at)
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "a",
	                                                        { onClick: function onClick() {
	                                                                return handleDelete(item.id);
	                                                            } },
	                                                        _react2.default.createElement("i", { "class": "fa fa-trash", "data-bs-toggle": "tooltip", "data-bs-placement": "top", title: "Delete Request" })
	                                                    )
	                                                )
	                                            );
	                                        }) : _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                { colSpan: "100%", className: "text-center" },
	                                                "No data found"
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(_reactJsPagination2.default, {
	                                    activePage: currentPage,
	                                    itemsCountPerPage: itemsPerPage,
	                                    totalItemsCount: filteredData ? filteredData.length : 1,
	                                    pageRangeDisplayed: 5,
	                                    onChange: handlePageChange
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	    );
	};
	
	exports.default = EmergencyInquiryMessages;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _reactToastify = __webpack_require__(7);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var HomePopup = function HomePopup() {
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      slNo = _useState4[0],
	      setSlNo = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      interval = _useState6[0],
	      setInterval = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mediaList = _useState8[0],
	      setMediaList = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      currentPage = _useState10[0],
	      setCurrentPage = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      updateMediaId = _useState12[0],
	      setUpdateMediaId = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      updateFormData = _useState14[0],
	      setUpdateFormData = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(""),
	      _useState16 = _slicedToArray(_useState15, 2),
	      updateSlNo = _useState16[0],
	      setUpdateSlNo = _useState16[1];
	
	  var itemsPerPage = 8;
	  console.log("your log output", mediaList);
	  // Fetch media data
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/settings?type=popup_slider");
	
	            case 3:
	              response = _context.sent;
	
	              if (response.status === 200) {
	                setMediaList(response.data); // Assuming this contains the list of media
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    fetchData(); // Fetch media on component mount
	  }, []);
	
	  // Handle file change
	  var handleFileChange = function handleFileChange(e) {
	    var file = e.target.files[0];
	    setFormData(file);
	  };
	
	  var handleUpdateFileChange = function handleUpdateFileChange(e) {
	    var file = e.target.files[0];
	    setUpdateFormData(file);
	  };
	
	  // Handle SL No input change
	  var handleSlNoChange = function handleSlNoChange(e) {
	    setSlNo(e.target.value);
	  };
	  // Handle SL No input change
	  var handleIntervalChange = function handleIntervalChange(e) {
	    setInterval(e.target.value);
	  };
	
	  var handleUpdateSlNoChange = function handleUpdateSlNoChange(e) {
	    setUpdateSlNo(e.target.value);
	  };
	
	  // Handle form submission for uploading media
	  var handleSubmit = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	      var postData, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              e.preventDefault();
	
	              if (!(!formData || !slNo)) {
	                _context2.next = 4;
	                break;
	              }
	
	              _reactToastify.toast.error("Please select a file and enter SL No.", {
	                position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                autoClose: 3000
	              });
	              return _context2.abrupt("return");
	
	            case 4:
	              postData = new FormData();
	
	              postData.append("type", "popup_slider");
	              postData.append("upload_file", formData);
	              postData.append("sl_no", slNo);
	              postData.append("status", 1);
	
	              _context2.prev = 9;
	              _context2.next = 12;
	              return _.thirdparty.post("/settings", postData, {
	                headers: { "Content-Type": "multipart/form-data" }
	              });
	
	            case 12:
	              response = _context2.sent;
	
	              if (response.status === 201) {
	                _reactToastify.toast.success("Media uploaded successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	                fetchData(); // Fetch updated list after upload
	              }
	              _context2.next = 19;
	              break;
	
	            case 16:
	              _context2.prev = 16;
	              _context2.t0 = _context2["catch"](9);
	
	              console.error("Error uploading media:", _context2.t0.message);
	
	            case 19:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[9, 16]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	  var handleUpdateIntervalTime = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e) {
	      var postData, response;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              e.preventDefault();
	
	              if (interval) {
	                _context3.next = 4;
	                break;
	              }
	
	              _reactToastify.toast.error("Please give interval time for sliders.", {
	                position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                autoClose: 3000
	              });
	              return _context3.abrupt("return");
	
	            case 4:
	              postData = new FormData();
	
	              postData.append("value", interval);
	
	              _context3.prev = 6;
	              _context3.next = 9;
	              return _.thirdparty.post("/settings_update/26", postData, {
	                headers: { "Content-Type": "multipart/form-data" }
	              });
	
	            case 9:
	              response = _context3.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Interval time added successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	                fetchData(); // Fetch updated list after upload
	              }
	              _context3.next = 16;
	              break;
	
	            case 13:
	              _context3.prev = 13;
	              _context3.t0 = _context3["catch"](6);
	
	              console.error("Error uploading time:", _context3.t0.message);
	
	            case 16:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[6, 13]]);
	    }));
	
	    return function handleUpdateIntervalTime(_x2) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  // Handle delete media
	  var handleDelete = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(id) {
	      var response;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.prev = 0;
	              _context4.next = 3;
	              return _.thirdparty.delete("/settings/" + id);
	
	            case 3:
	              response = _context4.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Media deleted successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	                fetchData(); // Fetch updated list after deletion
	              }
	              _context4.next = 10;
	              break;
	
	            case 7:
	              _context4.prev = 7;
	              _context4.t0 = _context4["catch"](0);
	
	              console.error("Error deleting media:", _context4.t0.message);
	
	            case 10:
	            case "end":
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined, [[0, 7]]);
	    }));
	
	    return function handleDelete(_x3) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  // Handle update media
	  var handleUpdate = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(id) {
	      var updatedData, response;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              if (!(!updateFormData && !updateSlNo)) {
	                _context5.next = 3;
	                break;
	              }
	
	              _reactToastify.toast.error("Please provide updated file or SL No.", {
	                position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                autoClose: 3000
	              });
	              return _context5.abrupt("return");
	
	            case 3:
	              updatedData = new FormData();
	
	              if (updateFormData) {
	                updatedData.append("upload_file", updateFormData);
	              }
	              if (updateSlNo) {
	                updatedData.append("sl_no", updateSlNo);
	              }
	              updatedData.append("type", "popup_slider");
	              updatedData.append("status", 1);
	
	              _context5.prev = 8;
	              _context5.next = 11;
	              return _.thirdparty.post("/settings_update/" + id, updatedData, {
	                headers: { "Content-Type": "multipart/form-data" }
	              });
	
	            case 11:
	              response = _context5.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Media updated successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	                setUpdateMediaId(null);
	                fetchData(); // Fetch updated list after update
	              }
	              _context5.next = 18;
	              break;
	
	            case 15:
	              _context5.prev = 15;
	              _context5.t0 = _context5["catch"](8);
	
	              console.error("Error updating media:", _context5.t0.message);
	
	            case 18:
	            case "end":
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined, [[8, 15]]);
	    }));
	
	    return function handleUpdate(_x4) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  var handleUpdateClick = function handleUpdateClick(media) {
	    setUpdateMediaId(media.id);
	    setUpdateSlNo(media.sl_no);
	  };
	
	  // Pagination logic
	  var indexOfLastItem = currentPage * itemsPerPage;
	  var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  var currentItems = mediaList.slice(indexOfFirstItem, indexOfLastItem);
	
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setCurrentPage(pageNumber);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Media Upload"
	              ),
	              _react2.default.createElement(
	                "form",
	                { onSubmit: handleSubmit },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12 col-md-6 mb-3" },
	                    _react2.default.createElement(
	                      "label",
	                      { htmlFor: "uploadFile", className: "form-label" },
	                      "Select Media"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "file",
	                      className: "form-control",
	                      id: "uploadFile",
	                      onChange: handleFileChange
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12 col-md-6 mb-3" },
	                    _react2.default.createElement(
	                      "label",
	                      { htmlFor: "slNo", className: "form-label" },
	                      "Serial No (SL No)"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      id: "slNo",
	                      value: slNo,
	                      onChange: handleSlNoChange
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { type: "submit", className: "btn btn-primary" },
	                  "Upload"
	                )
	              ),
	              _react2.default.createElement(
	                "form",
	                { onSubmit: handleUpdateIntervalTime },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12 col-md-6 mb-3" },
	                    _react2.default.createElement(
	                      "label",
	                      { htmlFor: "interval", className: "form-label" },
	                      "Interval Time For Sliders"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      placeholder: "Put the interval time in second. e.g.,3",
	                      id: "interval",
	                      value: interval,
	                      onChange: handleIntervalChange
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { type: "submit", className: "btn btn-primary" },
	                  "Update"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "mt-4" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Uploaded Media"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  currentItems.map(function (media) {
	                    return _react2.default.createElement(
	                      "div",
	                      { className: "col-4 mb-3", key: media.id },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "card" },
	                        _react2.default.createElement("img", {
	                          src: "" + _constants.IMAGE_URL + media.file_path,
	                          alt: media.upload_file,
	                          className: "card-img-top"
	                        }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "card-body" },
	                          _react2.default.createElement(
	                            "h5",
	                            { className: "card-title" },
	                            "SL No: ",
	                            media.sl_no
	                          ),
	                          updateMediaId === media.id ? _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement("input", {
	                              type: "file",
	                              className: "form-control mb-2",
	                              onChange: handleUpdateFileChange
	                            }),
	                            _react2.default.createElement("input", {
	                              type: "text",
	                              className: "form-control mb-2",
	                              value: updateSlNo,
	                              onChange: handleUpdateSlNoChange
	                            }),
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                className: "btn btn-success",
	                                onClick: function onClick() {
	                                  return handleUpdate(media.id);
	                                }
	                              },
	                              "Save"
	                            ),
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                className: "btn btn-secondary ms-2",
	                                onClick: function onClick() {
	                                  return setUpdateMediaId(null);
	                                }
	                              },
	                              "Cancel"
	                            )
	                          ) : _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                className: "btn btn-outline-primary",
	                                onClick: function onClick() {
	                                  return handleUpdateClick(media);
	                                }
	                              },
	                              "Update"
	                            ),
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                className: "btn btn-outline-danger ms-2",
	                                onClick: function onClick() {
	                                  return handleDelete(media.id);
	                                }
	                              },
	                              "Delete"
	                            )
	                          )
	                        )
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(_reactJsPagination2.default, {
	                  activePage: currentPage,
	                  itemsCountPerPage: itemsPerPage,
	                  totalItemsCount: mediaList.length,
	                  pageRangeDisplayed: 5,
	                  onChange: handlePageChange
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = HomePopup;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Investigations = function Investigations() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      investigations = _useState2[0],
	      setInvestigations = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      modalDeleteConfirm = _useState4[0],
	      setModalDeleteConfirm = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      selectedInvestigationId = _useState6[0],
	      setSelectedInvestigationId = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      search_keywords = _useState8[0],
	      setSearchKeyWords = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activePage = _useState10[0],
	      setActivePage = _useState10[1];
	
	  var itemsPerPage = 10;
	
	  var getAllDepartments = function getAllDepartments() {
	    var req = _.scAxiosAdmin.request("/investigations?show_hidden=1", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return setInvestigations(res.data);
	    }).catch(function (err) {
	      return console.log("Error fetching investigations:", err);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    getAllDepartments();
	  }, []);
	
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setActivePage(pageNumber);
	  };
	
	  var handleSearchChange = function handleSearchChange(e) {
	    setSearchKeyWords(e.target.value);
	    setActivePage(1); // Reset to first page on new search
	  };
	  var modalDeleteConfirmOpen = function modalDeleteConfirmOpen(id) {
	    setModalDeleteConfirm(true);
	    setSelectedInvestigationId(id);
	  };
	  var modalDeleteDepartment = function modalDeleteDepartment(id) {
	    setModalDeleteConfirm(false);
	
	    try {
	      var req = _.scAxiosAdmin.delete("/investigations/" + id, {
	        method: "delete",
	        headers: {
	          Accept: "application/json",
	          Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	        }
	      });
	      req.then(function (res) {
	        if (res.status === true) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.reload();
	          }, 3000);
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	        setInvestigations(res.data);
	      }).catch(function (err) {
	        _reactToastify.toast.error("Something went wrong! Try again later", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	        console.log("Error fetching investigations:", err);
	      });
	    } catch (error) {
	      _reactToastify.toast.error("Something went wrong! Try again later", {
	        position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	      });
	      console.log("your log output", error);
	    }
	  };
	  var togglePackageStatus = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(item) {
	      var newStatus, data, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              newStatus = item.status === "1" ? "0" : "1";
	              data = {
	                status: newStatus
	              };
	              _context.prev = 2;
	              _context.next = 5;
	              return _.scAxiosAdmin.put("/investigations/" + item.id, data);
	
	            case 5:
	              response = _context.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Status updated successfully", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT
	                });
	                setInvestigations(function (prev) {
	                  return prev.map(function (pkg) {
	                    return pkg.id === item.id ? Object.assign({}, pkg, { status: newStatus }) : pkg;
	                  });
	                });
	              } else {
	                _reactToastify.toast.error("Failed to update status", {
	                  position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                });
	              }
	              _context.next = 13;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context["catch"](2);
	
	              console.error("Error updating status:", _context.t0);
	              _reactToastify.toast.error("Failed to update status", {
	                position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	              });
	
	            case 13:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 9]]);
	    }));
	
	    return function togglePackageStatus(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	  // Filtered and Paginated Data
	  var filteredInvestigations = investigations.filter(function (investigation) {
	    return investigation.Product_Name.toLowerCase().includes(search_keywords.toLowerCase()) || investigation.Product_Group.toLowerCase().includes(search_keywords.toLowerCase());
	  });
	
	  var paginatedInvestigations = filteredInvestigations.slice((activePage - 1) * itemsPerPage, activePage * itemsPerPage);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container-fluid" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-7" },
	                          _react2.default.createElement(
	                            "h4",
	                            { className: "mt-0 header-title" },
	                            "Investigations"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-3 text-right" },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "search_keywords",
	                            id: "search_keywords",
	                            value: search_keywords,
	                            onChange: handleSearchChange,
	                            placeholder: "Search"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-2 text-right" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              href: "/add-investigations",
	                              className: "btn btn-sm btn-primary waves-effect waves-light"
	                            },
	                            "Add investigation"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "table-rep-plugin" },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "table-responsive b-0",
	                            "data-pattern": "priority-columns"
	                          },
	                          _react2.default.createElement(
	                            "table",
	                            {
	                              id: "tech-companies-1",
	                              className: "table table-striped"
	                            },
	                            _react2.default.createElement(
	                              "thead",
	                              null,
	                              _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "Investigation ID"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "Investigation Name"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "Investigation Group"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "OPD Price"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "IPD Price"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "Action"
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "tbody",
	                              null,
	                              paginatedInvestigations.length > 0 ? paginatedInvestigations.map(function (investigation) {
	                                return _react2.default.createElement(
	                                  "tr",
	                                  { key: investigation.id },
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    "#",
	                                    investigation.id
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    investigation.Product_Name
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    investigation.Product_Group
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    investigation.opd_amount
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    investigation.ipd_price
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        href: "/edit-investigation/" + investigation.id
	                                      },
	                                      _react2.default.createElement("i", { className: "fa fa-pencil-square" })
	                                    ),
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        className: "ms-2",
	                                        title: "Status",
	                                        onClick: function onClick() {
	                                          return togglePackageStatus(investigation);
	                                        }
	                                      },
	                                      investigation.status === "1" ? _react2.default.createElement("i", { "class": "fa-solid fa-eye" }) : _react2.default.createElement("i", { "class": "fa-solid fa-eye-slash" })
	                                    ),
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        href: "/pages/investigation"
	                                        // href={`/investigation/${investigation.id}`}
	                                        , target: "_blank"
	                                      },
	                                      _react2.default.createElement("i", { "class": "fa-solid fa-laptop" })
	                                    ),
	                                    _react2.default.createElement(
	                                      "button",
	                                      {
	                                        className: "border-0 bg-transparent p-0",
	                                        onClick: function onClick() {
	                                          return setModalDeleteConfirm(true);
	                                        }
	                                      },
	                                      _react2.default.createElement("i", { className: "fa fa-trash" })
	                                    ),
	                                    _react2.default.createElement(
	                                      _DeleteConfirmModalPopup2.default,
	                                      {
	                                        show: modalDeleteConfirm,
	                                        handleClose: function handleClose() {
	                                          return setModalDeleteConfirm(false);
	                                        }
	                                      },
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "custom_reviews_popup" },
	                                        _react2.default.createElement(
	                                          "h2",
	                                          { className: "text-center" },
	                                          "Are you sure you wish to delete this investigation?"
	                                        ),
	                                        _react2.default.createElement(
	                                          "form",
	                                          {
	                                            className: "pop-form",
	                                            id: "edit_education"
	                                          },
	                                          _react2.default.createElement(
	                                            "div",
	                                            { className: "form-group row" },
	                                            _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                                            _react2.default.createElement(
	                                              "div",
	                                              { className: "col-sm-6 text-center" },
	                                              _react2.default.createElement(
	                                                "button",
	                                                {
	                                                  type: "button",
	                                                  className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                                  onClick: function onClick() {
	                                                    return setModalDeleteConfirm(false);
	                                                  }
	                                                },
	                                                " ",
	                                                "No"
	                                              ),
	                                              _react2.default.createElement(
	                                                "button",
	                                                {
	                                                  type: "button",
	                                                  className: "blue_btn_box add_staff_btn mt-5",
	                                                  onClick: function onClick() {
	                                                    return modalDeleteDepartment(investigation.id);
	                                                  }
	                                                },
	                                                "Yes"
	                                              )
	                                            ),
	                                            _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                );
	                              }) : _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                  "td",
	                                  {
	                                    colSpan: "6",
	                                    style: { textAlign: "center" }
	                                  },
	                                  "No matching departments found."
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(_reactJsPagination2.default, {
	                        activePage: activePage,
	                        itemsCountPerPage: itemsPerPage,
	                        totalItemsCount: filteredInvestigations.length,
	                        pageRangeDisplayed: 5,
	                        onChange: handlePageChange
	                        //   itemClass="page-item"
	                        //   linkClass="page-link"
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Investigations;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _reactToastify = __webpack_require__(7);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var MediaUpload = function MediaUpload() {
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mediaList = _useState4[0],
	      setMediaList = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(1),
	      _useState8 = _slicedToArray(_useState7, 2),
	      currentPage = _useState8[0],
	      setCurrentPage = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(8),
	      _useState10 = _slicedToArray(_useState9, 1),
	      itemsPerPage = _useState10[0]; // Number of items to display per page
	
	  // Fetch media data
	
	
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/media");
	
	            case 3:
	              response = _context.sent;
	
	              if (response.status === 200) {
	                setMediaList(response.data); // Assuming this contains the list of media
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    fetchData(); // Fetch media on component mount
	  }, []);
	
	  // Handle media file selection
	  var handleFileChange = function handleFileChange(e) {
	    var file = e.target.files[0];
	    setFormData(file);
	  };
	
	  // Handle media submission
	  var handleSubmit = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	      var form, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              e.preventDefault();
	              form = new FormData();
	
	              form.append("file", formData);
	
	              _context2.prev = 3;
	              _context2.next = 6;
	              return _.thirdparty.post("/media/upload", form, {
	                headers: {
	                  "Content-Type": "multipart/form-data"
	                }
	              });
	
	            case 6:
	              response = _context2.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Media uploaded successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	                fetchData(); // Fetch updated list after upload
	              }
	              _context2.next = 13;
	              break;
	
	            case 10:
	              _context2.prev = 10;
	              _context2.t0 = _context2["catch"](3);
	
	              console.error("Error uploading media:", _context2.t0.message);
	
	            case 13:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[3, 10]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  // Handle media URL copy to clipboard
	  var handleCopyURL = function handleCopyURL(mediaName) {
	    var mediaURL = "" + _constants.IMAGE_URL + mediaName;
	    navigator.clipboard.writeText(mediaURL).then(function () {
	      _reactToastify.toast.success("URL copied to clipboard!", {
	        position: _reactToastify.toast.POSITION.TOP_RIGHT,
	        autoClose: 2000
	      });
	    }, function (err) {
	      _reactToastify.toast.error("Failed to copy URL!", {
	        position: _reactToastify.toast.POSITION.TOP_RIGHT,
	        autoClose: 2000
	      });
	    });
	  };
	  // Handle media URL copy to clipboard
	  var handleCopyFilePath = function handleCopyFilePath(mediaName) {
	    var mediaURL = "" + mediaName;
	    navigator.clipboard.writeText(mediaURL).then(function () {
	      _reactToastify.toast.success("File path copied to clipboard!", {
	        position: _reactToastify.toast.POSITION.TOP_RIGHT,
	        autoClose: 2000
	      });
	    }, function (err) {
	      _reactToastify.toast.error("Failed to copy File path!", {
	        position: _reactToastify.toast.POSITION.TOP_RIGHT,
	        autoClose: 2000
	      });
	    });
	  };
	
	  // Handle media deletion
	  var handleDelete = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(mediaId) {
	      var response;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              _context3.next = 3;
	              return _.thirdparty.delete("/media/" + mediaId);
	
	            case 3:
	              response = _context3.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Media deleted successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	                fetchData(); // Fetch updated list after deletion
	              }
	              _context3.next = 10;
	              break;
	
	            case 7:
	              _context3.prev = 7;
	              _context3.t0 = _context3["catch"](0);
	
	              console.error("Error deleting media:", _context3.t0.message);
	
	            case 10:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[0, 7]]);
	    }));
	
	    return function handleDelete(_x2) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  // Pagination logic
	  var indexOfLastItem = currentPage * itemsPerPage;
	  var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  var currentItems = mediaList.slice(indexOfFirstItem, indexOfLastItem);
	
	  // Handle page change
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setCurrentPage(pageNumber);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Media Upload"
	              ),
	              _react2.default.createElement(
	                "form",
	                { onSubmit: handleSubmit },
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-3" },
	                  _react2.default.createElement(
	                    "label",
	                    { htmlFor: "uploadFile", className: "form-label" },
	                    "Select Media"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "file",
	                    className: "form-control",
	                    id: "uploadFile",
	                    onChange: handleFileChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { type: "submit", className: "btn btn-primary" },
	                  "Upload"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "mt-4" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Uploaded Media"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  currentItems.map(function (media) {
	                    return _react2.default.createElement(
	                      "div",
	                      {
	                        className: "col-12 col-md-6 col-lg-4 mb-3",
	                        key: media.id
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "card h-100 d-flex flex-column justify-content-between" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "" },
	                          media.file_type === "application/pdf" ? _react2.default.createElement("iframe", {
	                            src: _constants.IMAGE_URL + media.file_path
	                            // src="https://docs.google.com/gview?url=https://path.com/to/your/pdf.pdf&embedded=true"
	                            , style: { maxWidth: "350px", height: "250px" },
	                            frameborder: "0"
	                          }) : _react2.default.createElement("img", {
	                            src: _constants.IMAGE_URL + media.file_path,
	                            alt: media.name,
	                            style: {
	                              maxWidth: "350px",
	                              height: "250px",
	                              objectFit: "cover",
	                              objectPosition: "center"
	                            },
	                            className: "card-img-top"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "card-body d-flex flex-column" },
	                          _react2.default.createElement(
	                            "strong",
	                            { className: "card-title" },
	                            "File Name: ",
	                            media.title
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "d-flex gap-2" },
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                className: "btn btn-outline-primary",
	                                onClick: function onClick() {
	                                  return handleCopyURL(media.file_path);
	                                }
	                              },
	                              "Copy URL"
	                            ),
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                className: "btn btn-outline-primary",
	                                onClick: function onClick() {
	                                  return handleCopyFilePath(media.file_path);
	                                }
	                              },
	                              "Copy File path"
	                            ),
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                className: "btn btn-outline-danger",
	                                onClick: function onClick() {
	                                  return handleDelete(media.id);
	                                }
	                              },
	                              "Delete"
	                            )
	                          )
	                        )
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(_reactJsPagination2.default, {
	                  activePage: currentPage,
	                  itemsCountPerPage: itemsPerPage,
	                  totalItemsCount: mediaList.length,
	                  pageRangeDisplayed: 5,
	                  onChange: handlePageChange
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = MediaUpload;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSinglePackageDatadetails = function getSinglePackageDatadetails(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request('/packages/getsinglepackagedetails/' + id, {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json',
	        'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var DoctorView = function (_Component) {
	  _inherits(DoctorView, _Component);
	
	  function DoctorView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DoctorView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DoctorView.__proto__ || Object.getPrototypeOf(DoctorView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      publications: [],
	      package_id: '',
	      package_description: '',
	      package_image: '',
	      package_amount: '',
	      package_name: '',
	      package_dept_id: '',
	      package_gender: '',
	      package_age: '',
	      package_pre_existing_conditon_id: ''
	    }, _this.refreshgetSinglePackageDataDetails = function (id) {
	      getSinglePackageDatadetails(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            package_id: records.id,
	            package_name: records.name,
	            package_description: records.description,
	            package_image: records.image,
	            package_amount: records.amount,
	            package_dept_id: records.department_name,
	            package_gender: records.gender,
	            package_age: records.age,
	            package_pre_existing_conditon_id: records.pre_name
	          });
	        } else {
	          _this.setState({
	            package_id: '',
	            package_name: '',
	            package_description: '',
	            package_image: '',
	            package_amount: '',
	            package_dept_id: '',
	            package_gender: '',
	            package_age: '',
	            package_pre_existing_conditon_id: ''
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DoctorView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refreshgetSinglePackageDataDetails(this.props.match.params.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'fixed-left' },
	        _react2.default.createElement(
	          'div',
	          { id: 'wrapper' },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            'div',
	            { className: 'content-page' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                'div',
	                { className: 'page-content-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card m-b-20' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-body' },
	                      _react2.default.createElement(
	                        'section',
	                        { className: 'view-page' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'container' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'view-page-box' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-3' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'view-img' },
	                                  this.state.package_image ? _react2.default.createElement('img', { src: _constants.IMAGE_URL + 'Packagesimg/' + this.state.package_image, alt: '' }) : _react2.default.createElement('img', { src: _avatar_circle2.default, alt: '' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-6' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'view-text' },
	                                  _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    this.state.package_name
	                                  ),
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                      'b',
	                                      null,
	                                      this.state.package_dept_id
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    this.state.doctor_department_name
	                                  ),
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    this.state.package_amount
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-3' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'edit' },
	                                  _react2.default.createElement(
	                                    'a',
	                                    { href: '/editpackage/' + this.state.package_id },
	                                    _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                              'h3',
	                              null,
	                              'Decription'
	                            ),
	                            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: this.state.package_description } }),
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-4 col-md-12' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'edu-part' },
	                                  _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Gender'
	                                  ),
	                                  this.state.package_gender
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-4 col-md-12' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'edu-part' },
	                                  _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Age Range'
	                                  ),
	                                  this.state.package_age
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-lg-4 col-md-12' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'edu-part' },
	                                  _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Pre conditon'
	                                  ),
	                                  this.state.package_pre_existing_conditon_id
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DoctorView;
	}(_react.Component);
	
	exports.default = DoctorView;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(92);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	var _EmailConfigComponent = __webpack_require__(141);
	
	var _EmailConfigComponent2 = _interopRequireDefault(_EmailConfigComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Settings = function Settings(_ref) {
	  var user = _ref.user;
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      adminEmail = _useState2[0],
	      setAdminEmail = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      saveAdminLoading = _useState4[0],
	      setSaveAdminLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      error = _useState6[0],
	      setError = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      postResponseAdminRole = _useState8[0],
	      setPostResponseAdminEmail = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      loading = _useState10[0],
	      setLoading = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({}),
	      _useState12 = _slicedToArray(_useState11, 2),
	      responseData = _useState12[0],
	      setResponseData = _useState12[1];
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _.scAxiosAdmin.request("/settings/12", {
	                  method: "get",
	                  headers: {
	                    Accept: "application/json",
	                    Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                  },
	                  params: {
	                    // ...data
	                  }
	                });
	
	              case 3:
	                response = _context.sent;
	
	                setResponseData(response.data);
	                setAdminEmail(response.data.value);
	                setLoading(false);
	                _context.next = 13;
	                break;
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0);
	                setLoading(false);
	
	              case 13:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 9]]);
	      }));
	
	      return function fetchData() {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	  var handleTextChange = function handleTextChange(event) {
	    setAdminEmail(event.target.value);
	  };
	
	  var handleSubmit = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(event) {
	      var requestData, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              event.preventDefault();
	              setSaveAdminLoading(true);
	              setError(null);
	              requestData = {
	                value: adminEmail
	              };
	              // console.log("some data", checkedIds, roleName)
	
	              _context2.prev = 4;
	              _context2.next = 7;
	              return _.scAxiosAdmin.post("/settings_update/11", requestData, {
	                method: "post",
	                headers: {
	                  Accept: "application/json",
	                  "Content-Type": "application/json",
	                  Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                }
	              });
	
	            case 7:
	              response = _context2.sent;
	
	              setPostResponseAdminEmail(response.data);
	              setSaveAdminLoading(false);
	              _reactToastify.toast.success("Admin Emails Updated Successfully!");
	              _context2.next = 17;
	              break;
	
	            case 13:
	              _context2.prev = 13;
	              _context2.t0 = _context2["catch"](4);
	
	              setError(_context2.t0);
	              setSaveAdminLoading(false);
	
	            case 17:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[4, 13]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "row g-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Reach Text Editor License Key",
	                label: "Put Your License Key Here",
	                query: 29,
	                formHelp: false
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 col-md-4" },
	              _react2.default.createElement(_EmailConfigComponent2.default, {
	                title: "Sidebar Video",
	                label: "Put Your Sidebar Video Here",
	                query: 30,
	                formHelp: false
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Settings;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quill = __webpack_require__(398);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Module = _quill2.default.import("core/module");
	
	var TableModule = function (_Module) {
	  _inherits(TableModule, _Module);
	
	  function TableModule(quill, options) {
	    _classCallCheck(this, TableModule);
	
	    var _this = _possibleConstructorReturn(this, (TableModule.__proto__ || Object.getPrototypeOf(TableModule)).call(this, quill, options));
	
	    var toolbar = quill.getModule("toolbar");
	    if (toolbar) {
	      toolbar.addHandler("insertTable", _this.insertTable.bind(_this));
	    }
	    return _this;
	  }
	
	  _createClass(TableModule, [{
	    key: "insertTable",
	    value: function insertTable() {
	      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
	      var cols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	      var quill = this.quill;
	      var range = quill.getSelection();
	
	      if (!range) return;
	
	      var tableHtml = "<table style='border-collapse: collapse; width: 100%;'>";
	      for (var i = 0; i < rows; i++) {
	        tableHtml += "<tr>";
	        for (var j = 0; j < cols; j++) {
	          tableHtml += "<td style='border: 1px solid #ccc; padding: 8px;'><br/></td>";
	        }
	        tableHtml += "</tr>";
	      }
	      tableHtml += "</table>";
	
	      // Use `clipboard.dangerouslyPasteHTML` to insert the table
	      quill.clipboard.dangerouslyPasteHTML(range.index, tableHtml);
	      quill.setSelection(range.index + 1);
	    }
	  }]);
	
	  return TableModule;
	}(Module);
	
	// Register the module
	
	
	_quill2.default.register("modules/table", TableModule);

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _2 = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _NewReachTextEditor = __webpack_require__(83);
	
	var _NewReachTextEditor2 = _interopRequireDefault(_NewReachTextEditor);
	
	var _reactBeautifulDnd = __webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// Utility function to generate a 16-character unique ID
	var generateUniqueId = function generateUniqueId() {
	  return Math.random().toString(36).substring(2, 18) + Date.now().toString(36);
	};
	
	var UpdateMegaStaticPage = function UpdateMegaStaticPage() {
	  var route = (0, _reactRouterDom.useHistory)();
	
	  var _useParams = (0, _reactRouterDom.useParams)(),
	      id = _useParams.id; // Get the page ID from the URL
	
	
	  var _useState = (0, _react.useState)("static_page"),
	      _useState2 = _slicedToArray(_useState, 2),
	      pageType = _useState2[0],
	      setPageType = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      serialNumber = _useState4[0],
	      setSerialNumber = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      title = _useState6[0],
	      setTitle = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      components = _useState8[0],
	      setComponents = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      loading = _useState10[0],
	      setLoading = _useState10[1];
	
	  // Fetch static page data
	
	
	  (0, _react.useEffect)(function () {
	    var fetchStaticPage = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var res, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                setLoading(true);
	                _context.prev = 1;
	                _context.next = 4;
	                return _2.scAxiosAdmin.get("/static_services_pages/" + id);
	
	              case 4:
	                res = _context.sent;
	                data = res.data;
	
	                setPageType(data.type || "static_page");
	                setSerialNumber(data.sl_no || "");
	                setTitle(data.title || "");
	                setComponents(data.components || []);
	                _context.next = 16;
	                break;
	
	              case 12:
	                _context.prev = 12;
	                _context.t0 = _context["catch"](1);
	
	                console.error("Error fetching static page data:", _context.t0);
	                _reactToastify.toast.error("Failed to fetch the static page data.");
	
	              case 16:
	                _context.prev = 16;
	
	                setLoading(false);
	                return _context.finish(16);
	
	              case 19:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[1, 12, 16, 19]]);
	      }));
	
	      return function fetchStaticPage() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	    fetchStaticPage();
	  }, [id]);
	
	  var handleAddComponent = function handleAddComponent(type) {
	    setComponents(function (prev) {
	      return [].concat(_toConsumableArray(prev), [{
	        id: generateUniqueId(),
	        type: type,
	        sectionTitle: "",
	        value: type === "description" ? {
	          title: "",
	          thumbnail: "",
	          content: ""
	        } : type === "card" ? {
	          media: [],
	          title: "",
	          description: "",
	          externalLink: ""
	        } : type === "gallery" ? [] : type === "cardGallery" ? [{
	          id: generateUniqueId(),
	          title: "",
	          description: "",
	          media: [],
	          externalLink: ""
	        }] : null
	      }]);
	    });
	  };
	  // Function to update section title dynamically
	  var handleSectionTitleChange = function handleSectionTitleChange(id, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { sectionTitle: value }) : comp;
	      });
	    });
	  };
	  var handleRemoveComponent = function handleRemoveComponent(id) {
	    setComponents(function (prev) {
	      return prev.filter(function (comp) {
	        return comp.id !== id;
	      });
	    });
	  };
	
	  var handleDescriptionChange = function handleDescriptionChange(id, field, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { value: Object.assign({}, comp.value, _defineProperty({}, field, value)) }) : comp;
	      });
	    });
	  };
	
	  var handleCardMediaChange = function handleCardMediaChange(id, index, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, {
	          value: Object.assign({}, comp.value, {
	            media: comp.value.media.map(function (item, idx) {
	              return idx === index ? value : item;
	            })
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardAddMediaField = function handleCardAddMediaField(id) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, {
	          value: Object.assign({}, comp.value, { media: [].concat(_toConsumableArray(comp.value.media), [""]) })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardRemoveMediaField = function handleCardRemoveMediaField(id, index) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, {
	          value: Object.assign({}, comp.value, {
	            media: comp.value.media.filter(function (_, idx) {
	              return idx !== index;
	            })
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardChange = function handleCardChange(id, field, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { value: Object.assign({}, comp.value, _defineProperty({}, field, value)) }) : comp;
	      });
	    });
	  };
	  var handleCardDateChange = function handleCardDateChange(id, field, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { value: Object.assign({}, comp.value, _defineProperty({}, field, value)) }) : comp;
	      });
	    });
	  };
	  var handleGalleryChange = function handleGalleryChange(id, index, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, {
	          value: comp.value.map(function (item, idx) {
	            return idx === index ? value : item;
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleGalleryAddField = function handleGalleryAddField(id) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { value: [].concat(_toConsumableArray(comp.value), [""]) }) : comp;
	      });
	    });
	  };
	
	  var handleGalleryRemoveField = function handleGalleryRemoveField(id, index) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, { value: comp.value.filter(function (_, idx) {
	            return idx !== index;
	          }) }) : comp;
	      });
	    });
	  };
	
	  // Card Gallery Media Handling
	  var handleCardGalleryAddMediaField = function handleCardGalleryAddMediaField(compId, cardId) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.map(function (card) {
	            return card.id === cardId ? Object.assign({}, card, { media: [].concat(_toConsumableArray(card.media), [""]) }) : card;
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardGalleryMediaChange = function handleCardGalleryMediaChange(compId, cardId, index, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.map(function (card) {
	            return card.id === cardId ? Object.assign({}, card, {
	              media: card.media.map(function (item, idx) {
	                return idx === index ? value : item;
	              })
	            }) : card;
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardGalleryRemoveMediaField = function handleCardGalleryRemoveMediaField(compId, cardId, index) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.map(function (card) {
	            return card.id === cardId ? Object.assign({}, card, {
	              media: card.media.filter(function (_, idx) {
	                return idx !== index;
	              })
	            }) : card;
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardGalleryAddCard = function handleCardGalleryAddCard(id) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === id ? Object.assign({}, comp, {
	          value: [].concat(_toConsumableArray(comp.value), [{
	            id: generateUniqueId(),
	            title: "",
	            description: "",
	            media: [],
	            externalLink: ""
	          }])
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardGalleryRemoveCard = function handleCardGalleryRemoveCard(compId, cardId) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.filter(function (card) {
	            return card.id !== cardId;
	          })
	        }) : comp;
	      });
	    });
	  };
	
	  var handleCardGalleryChange = function handleCardGalleryChange(compId, cardId, field, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.map(function (card) {
	            return card.id === cardId ? Object.assign({}, card, _defineProperty({}, field, value)) : card;
	          })
	        }) : comp;
	      });
	    });
	  };
	  var handleCardGalleryDateChange = function handleCardGalleryDateChange(compId, cardId, field, value) {
	    setComponents(function (prev) {
	      return prev.map(function (comp) {
	        return comp.id === compId ? Object.assign({}, comp, {
	          value: comp.value.map(function (card) {
	            return card.id === cardId ? Object.assign({}, card, _defineProperty({}, field, value)) : card;
	          })
	        }) : comp;
	      });
	    });
	  };
	  var onDragEnd = function onDragEnd(result) {
	    var destination = result.destination,
	        source = result.source;
	
	
	    if (!destination) {
	      return;
	    }
	
	    if (destination.droppableId === source.droppableId && destination.index === source.index) {
	      return;
	    }
	
	    var newComponents = Array.from(components);
	
	    var _newComponents$splice = newComponents.splice(source.index, 1),
	        _newComponents$splice2 = _slicedToArray(_newComponents$splice, 1),
	        removed = _newComponents$splice2[0];
	
	    newComponents.splice(destination.index, 0, removed);
	
	    setComponents(newComponents);
	  };
	  var handleSubmit = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var payload;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              payload = {
	                type: pageType,
	                sl_no: serialNumber,
	                title: title,
	                components: components,
	                status: 1,
	                is_deleted: 0
	              };
	              _context2.prev = 1;
	              _context2.next = 4;
	              return _2.scAxiosAdmin.post("/static_services_pages/" + id, payload);
	
	            case 4:
	              _reactToastify.toast.success("Page successfully updated!");
	              _context2.next = 11;
	              break;
	
	            case 7:
	              _context2.prev = 7;
	              _context2.t0 = _context2["catch"](1);
	
	              console.error("Error updating page:", _context2.t0);
	              _reactToastify.toast.error("There was an error updating the page.");
	
	            case 11:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[1, 7]]);
	    }));
	
	    return function handleSubmit() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Update Page"
	                  ),
	                  loading ? _react2.default.createElement(
	                    "p",
	                    null,
	                    "Loading..."
	                  ) : _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "label",
	                        null,
	                        "Page Type:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          className: "form-control mb-3",
	                          value: pageType,
	                          onChange: function onChange(e) {
	                            return setPageType(e.target.value);
	                          }
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { value: "static_page" },
	                          "Static Pages"
	                        ),
	                        _react2.default.createElement(
	                          "option",
	                          { value: "services" },
	                          "Services"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "label",
	                        null,
	                        "Serial Number:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "number",
	                        className: "form-control mb-3",
	                        value: serialNumber,
	                        onChange: function onChange(e) {
	                          return setSerialNumber(e.target.value);
	                        }
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "label",
	                        null,
	                        "Page Title:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        value: title,
	                        onChange: function onChange(e) {
	                          return setTitle(e.target.value);
	                        },
	                        className: "form-control mb-3"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "d-flex justify-content-start gap-3" },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          onClick: function onClick() {
	                            return handleAddComponent("description");
	                          },
	                          className: "btn btn-primary mr-2"
	                        },
	                        "Add Description"
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          onClick: function onClick() {
	                            return handleAddComponent("card");
	                          },
	                          className: "btn btn-primary mr-2"
	                        },
	                        "Add Card"
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          onClick: function onClick() {
	                            return handleAddComponent("gallery");
	                          },
	                          className: "btn btn-primary mr-2"
	                        },
	                        "Add Gallery"
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          onClick: function onClick() {
	                            return handleAddComponent("cardGallery");
	                          },
	                          className: "btn btn-primary"
	                        },
	                        "Add Card Gallery"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBeautifulDnd.DragDropContext,
	                      { onDragEnd: onDragEnd },
	                      _react2.default.createElement(
	                        _reactBeautifulDnd.Droppable,
	                        { droppableId: "components" },
	                        function (provided) {
	                          return _react2.default.createElement(
	                            "div",
	                            Object.assign({}, provided.droppableProps, {
	                              ref: provided.innerRef
	                            }),
	                            components.map(function (comp, index) {
	                              return _react2.default.createElement(
	                                _reactBeautifulDnd.Draggable,
	                                {
	                                  key: comp.id,
	                                  draggableId: comp.id,
	                                  index: index
	                                },
	                                function (provided) {
	                                  return _react2.default.createElement(
	                                    "div",
	                                    Object.assign({
	                                      ref: provided.innerRef
	                                    }, provided.draggableProps, provided.dragHandleProps),
	                                    _react2.default.createElement(
	                                      "div",
	                                      {
	                                        key: comp.id,
	                                        className: "mb-5 shadow-lg p-4 rounded-3"
	                                      },
	                                      _react2.default.createElement(
	                                        "h3",
	                                        null,
	                                        "Component " + (index + 1) + ": " + comp.type
	                                      ),
	                                      _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "Section Title"
	                                      ),
	                                      _react2.default.createElement("input", {
	                                        type: "text",
	                                        className: "form-control mb-2",
	                                        value: comp.sectionTitle || "",
	                                        onChange: function onChange(e) {
	                                          return handleSectionTitleChange(comp.id, e.target.value);
	                                        }
	                                      }),
	                                      comp.type === "description" && _react2.default.createElement(
	                                        "div",
	                                        null,
	                                        _react2.default.createElement(
	                                          "label",
	                                          null,
	                                          "Description Title"
	                                        ),
	                                        _react2.default.createElement("input", {
	                                          type: "text",
	                                          className: "form-control mb-2",
	                                          value: comp.value.title,
	                                          onChange: function onChange(e) {
	                                            return handleDescriptionChange(comp.id, "title", e.target.value);
	                                          }
	                                        }),
	                                        _react2.default.createElement(
	                                          "label",
	                                          null,
	                                          "Thumbnail Description"
	                                        ),
	                                        _react2.default.createElement("input", {
	                                          type: "text",
	                                          className: "form-control mb-2",
	                                          value: comp.value.thumbnail,
	                                          onChange: function onChange(e) {
	                                            return handleDescriptionChange(comp.id, "thumbnail", e.target.value);
	                                          }
	                                        }),
	                                        _react2.default.createElement(
	                                          "label",
	                                          null,
	                                          "Content"
	                                        ),
	                                        _react2.default.createElement(_NewReachTextEditor2.default, {
	                                          id: "description-" + comp.id,
	                                          value: comp.value.content,
	                                          onChange: function onChange(id, value) {
	                                            return handleDescriptionChange(comp.id, "content", value);
	                                          }
	                                        })
	                                      ),
	                                      comp.type === "card" && _react2.default.createElement(
	                                        "div",
	                                        null,
	                                        _react2.default.createElement(
	                                          "h4",
	                                          null,
	                                          "Card"
	                                        ),
	                                        comp.value.media.map(function (link, idx) {
	                                          return _react2.default.createElement(
	                                            "div",
	                                            {
	                                              key: idx,
	                                              className: "d-flex align-items-center mb-2"
	                                            },
	                                            _react2.default.createElement("input", {
	                                              type: "text",
	                                              className: "form-control",
	                                              value: link,
	                                              onChange: function onChange(e) {
	                                                return handleCardMediaChange(comp.id, idx, e.target.value);
	                                              },
	                                              placeholder: "Media " + (idx + 1)
	                                            }),
	                                            _react2.default.createElement(
	                                              "button",
	                                              {
	                                                onClick: function onClick() {
	                                                  return handleCardRemoveMediaField(comp.id, idx);
	                                                },
	                                                className: "btn btn-danger ml-2"
	                                              },
	                                              "Remove"
	                                            )
	                                          );
	                                        }),
	                                        _react2.default.createElement(
	                                          "label",
	                                          null,
	                                          "Card Title"
	                                        ),
	                                        _react2.default.createElement("input", {
	                                          type: "text",
	                                          className: "form-control mb-2",
	                                          value: comp.value.title,
	                                          onChange: function onChange(e) {
	                                            return handleCardChange(comp.id, "title", e.target.value);
	                                          }
	                                        }),
	                                        _react2.default.createElement(
	                                          "label",
	                                          null,
	                                          "Card Date"
	                                        ),
	                                        _react2.default.createElement("input", {
	                                          type: "date",
	                                          className: "form-control mb-2",
	                                          value: comp.value.date,
	                                          onChange: function onChange(e) {
	                                            return handleCardDateChange(comp.id, "date", e.target.value);
	                                          }
	                                        }),
	                                        _react2.default.createElement(
	                                          "button",
	                                          {
	                                            onClick: function onClick() {
	                                              return handleCardAddMediaField(comp.id);
	                                            },
	                                            className: "btn btn-secondary mb-3"
	                                          },
	                                          "Add Media Field"
	                                        ),
	                                        _react2.default.createElement("br", null),
	                                        _react2.default.createElement(
	                                          "label",
	                                          null,
	                                          "Card Description"
	                                        ),
	                                        _react2.default.createElement(_NewReachTextEditor2.default, {
	                                          id: "card-description-" + comp.id,
	                                          value: comp.value.description,
	                                          onChange: function onChange(id, value) {
	                                            return handleCardChange(comp.id, "description", value);
	                                          }
	                                        }),
	                                        _react2.default.createElement(
	                                          "label",
	                                          null,
	                                          "External Link"
	                                        ),
	                                        _react2.default.createElement("input", {
	                                          type: "text",
	                                          className: "form-control",
	                                          value: comp.value.externalLink,
	                                          onChange: function onChange(e) {
	                                            return handleCardChange(comp.id, "externalLink", e.target.value);
	                                          }
	                                        })
	                                      ),
	                                      comp.type === "gallery" && _react2.default.createElement(
	                                        "div",
	                                        null,
	                                        _react2.default.createElement(
	                                          "button",
	                                          {
	                                            onClick: function onClick() {
	                                              return handleGalleryAddField(comp.id);
	                                            },
	                                            className: "btn btn-secondary mb-3"
	                                          },
	                                          "Add Media Field"
	                                        ),
	                                        comp.value.map(function (link, idx) {
	                                          return _react2.default.createElement(
	                                            "div",
	                                            {
	                                              key: idx,
	                                              className: "d-flex align-items-center mb-2"
	                                            },
	                                            _react2.default.createElement("input", {
	                                              type: "text",
	                                              className: "form-control",
	                                              value: link,
	                                              onChange: function onChange(e) {
	                                                return handleGalleryChange(comp.id, idx, e.target.value);
	                                              },
	                                              placeholder: "Media " + (idx + 1)
	                                            }),
	                                            _react2.default.createElement(
	                                              "button",
	                                              {
	                                                onClick: function onClick() {
	                                                  return handleGalleryRemoveField(comp.id, idx);
	                                                },
	                                                className: "btn btn-danger ml-2"
	                                              },
	                                              "Remove"
	                                            )
	                                          );
	                                        })
	                                      ),
	                                      comp.type === "cardGallery" && _react2.default.createElement(
	                                        "div",
	                                        { className: "row justify-content-between" },
	                                        _react2.default.createElement(
	                                          "h4",
	                                          { className: "col-12" },
	                                          "Card Gallery"
	                                        ),
	                                        comp.value.map(function (card, cardIdx) {
	                                          return _react2.default.createElement(
	                                            "div",
	                                            {
	                                              key: card.id,
	                                              className: "col-12 col-md-4 border p-3 mb-3 me-2 rounded",
	                                              style: { width: "32%" }
	                                            },
	                                            _react2.default.createElement(
	                                              "label",
	                                              null,
	                                              "Card Title"
	                                            ),
	                                            _react2.default.createElement("input", {
	                                              type: "text",
	                                              className: "form-control mb-2",
	                                              value: card.title,
	                                              onChange: function onChange(e) {
	                                                return handleCardGalleryChange(comp.id, card.id, "title", e.target.value);
	                                              }
	                                            }),
	                                            _react2.default.createElement(
	                                              "label",
	                                              null,
	                                              "Card Date"
	                                            ),
	                                            _react2.default.createElement("input", {
	                                              type: "date",
	                                              className: "form-control mb-2",
	                                              value: card.date,
	                                              onChange: function onChange(e) {
	                                                return handleCardGalleryDateChange(comp.id, card.id, "date", e.target.value);
	                                              }
	                                            }),
	                                            _react2.default.createElement(
	                                              "label",
	                                              null,
	                                              "Card Media"
	                                            ),
	                                            _react2.default.createElement("br", null),
	                                            _react2.default.createElement(
	                                              "button",
	                                              {
	                                                onClick: function onClick() {
	                                                  return handleCardGalleryAddMediaField(comp.id, card.id);
	                                                },
	                                                className: "btn btn-secondary mb-3"
	                                              },
	                                              "Add Media Field"
	                                            ),
	                                            card.media.map(function (media, idx) {
	                                              return _react2.default.createElement(
	                                                "div",
	                                                {
	                                                  key: idx,
	                                                  className: "d-flex align-items-center mb-2"
	                                                },
	                                                _react2.default.createElement("input", {
	                                                  type: "text",
	                                                  className: "form-control",
	                                                  value: media,
	                                                  onChange: function onChange(e) {
	                                                    return handleCardGalleryMediaChange(comp.id, card.id, idx, e.target.value);
	                                                  },
	                                                  placeholder: "Media " + (idx + 1)
	                                                }),
	                                                _react2.default.createElement(
	                                                  "button",
	                                                  {
	                                                    onClick: function onClick() {
	                                                      return handleCardGalleryRemoveMediaField(comp.id, card.id, idx);
	                                                    },
	                                                    className: "btn btn-danger ml-2"
	                                                  },
	                                                  "Remove"
	                                                )
	                                              );
	                                            }),
	                                            _react2.default.createElement("br", null),
	                                            _react2.default.createElement(
	                                              "label",
	                                              null,
	                                              "Card Description"
	                                            ),
	                                            _react2.default.createElement(_NewReachTextEditor2.default, {
	                                              id: "card-gallery-description-" + comp.id + "-" + card.id,
	                                              value: card.description,
	                                              onChange: function onChange(id, value) {
	                                                return handleCardGalleryChange(comp.id, card.id, "description", value);
	                                              }
	                                            }),
	                                            _react2.default.createElement(
	                                              "label",
	                                              null,
	                                              "External Link"
	                                            ),
	                                            _react2.default.createElement("input", {
	                                              type: "text",
	                                              className: "form-control mb-2",
	                                              value: card.externalLink,
	                                              onChange: function onChange(e) {
	                                                return handleCardGalleryChange(comp.id, card.id, "externalLink", e.target.value);
	                                              }
	                                            }),
	                                            _react2.default.createElement(
	                                              "button",
	                                              {
	                                                onClick: function onClick() {
	                                                  return handleCardGalleryRemoveCard(comp.id, card.id);
	                                                },
	                                                className: "btn btn-danger"
	                                              },
	                                              "Remove Card"
	                                            )
	                                          );
	                                        }),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "col-12" },
	                                          _react2.default.createElement(
	                                            "button",
	                                            {
	                                              onClick: function onClick() {
	                                                return handleCardGalleryAddCard(comp.id);
	                                              },
	                                              className: "btn btn-primary mt-2"
	                                            },
	                                            "Add Another Card"
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        "button",
	                                        {
	                                          onClick: function onClick() {
	                                            return handleRemoveComponent(comp.id);
	                                          },
	                                          className: "btn btn-danger mt-2"
	                                        },
	                                        "Remove Component"
	                                      )
	                                    )
	                                  );
	                                }
	                              );
	                            }),
	                            provided.placeholder
	                          );
	                        }
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        onClick: handleSubmit,
	                        className: "btn btn-success"
	                      },
	                      "Update Page"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = UpdateMegaStaticPage;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var saveAlbum = function saveAlbum(data, album_name, album_desc, imageData) {
	  var formdata = new FormData();
	  formdata.append("album_name", data.album_name);
	  formdata.append("album_desc", data.album_desc);
	  // console.log(data);
	  // let productimages = [];
	
	  // for (let i = 0; i < data.album_pics.length; i++) {
	  //     productimages.push(data.album_pics[i]);
	  // }
	  // formdata.append('album_pics', productimages);
	  // for (const value of formdata.values()) {
	  //     console.log(value);
	  //   }
	  console.log(data.album_pics);
	  data.album_pics.forEach(function (album_pic) {
	    formdata.append("album_pics[]", album_pic);
	  });
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("album/createalbum", formdata, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var addAlbum = function (_Component) {
	  _inherits(addAlbum, _Component);
	
	  function addAlbum() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, addAlbum);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = addAlbum.__proto__ || Object.getPrototypeOf(addAlbum)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      album_name: "",
	      album_slug: "",
	      album_pics: [],
	      album_desc: "",
	      editorLoaded: false,
	      data: ""
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.DescReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        album_desc: val
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        var data = {
	          album_name: _this.state.album_name,
	          album_desc: _this.state.album_desc,
	          album_pics: _this.state.album_pics,
	          album_slug: _this.state.album_slug
	        };
	        console.log(data);
	        saveAlbum(data, _this.album_name, _this.album_desc, _this.album_pics).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(addAlbum, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.album_name) {
	        formIsValid = false;
	        errors["album_name"] = "*Please enter your doctor name.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(evt) {
	      console.log("onBlur event called with event info: ", evt);
	    }
	  }, {
	    key: "afterPaste",
	    value: function afterPaste(evt) {
	      console.log("afterPaste event called with event info: ", evt);
	    }
	  }, {
	    key: "onFileChange",
	    value: function onFileChange(file) {
	      this.setState({
	        album_pics: Array.prototype.slice.call(file)
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({ editorLoaded: true });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Add Album"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          enctype: "multipart/form-data",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Album Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "album_name",
	                                id: "album_name",
	                                value: this.state.album_name,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Album Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.album_name
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Album Slug"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "album_slug",
	                                id: "album_slug",
	                                value: this.state.album_slug,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Album Slug"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.album_name
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Album Description"
	                              ),
	                              _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                id: "desceditor",
	                                name: "desceditor",
	                                value: this.state.album_desc,
	                                onChange: function onChange(name, val) {
	                                  _this2.DescReactQuillHandleChange(name, val);
	                                }
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Album Pictures"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                multiple: true,
	                                className: "form-control",
	                                name: "album_pics[]",
	                                id: "album_pics",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Submit"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return addAlbum;
	}(_react.Component);
	
	exports.default = addAlbum;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var saveVideoGallery = function saveVideoGallery(data, video_gallery_name, video_gallery_desc, imageData) {
	    var formdata = new FormData();
	    formdata.append('video_gallery_name', data.video_gallery_name);
	    formdata.append('video_gallery_desc', data.video_gallery_desc);
	    console.log(data.video_gallery_pics);
	    data.video_gallery_pics.forEach(function (video_gallery_pic) {
	        formdata.append('video_gallery_pics[]', video_gallery_pic);
	    });
	    return new Promise(function (resolve, reject) {
	        var req = _.scAxiosAdmin.post('videogallery/create', formdata, {
	            method: 'post',
	            headers: {
	                'Accept': 'application/json',
	                'Content-Type': 'multipart/form-data',
	                'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	            },
	            params: Object.assign({}, data)
	        });
	        req.then(function (res) {
	            return resolve(res.data);
	        }).catch(function (err) {
	            return reject(err);
	        });
	    });
	};
	var alertStyle = {
	    color: 'red'
	};
	
	var addVideoGallery = function (_Component) {
	    _inherits(addVideoGallery, _Component);
	
	    function addVideoGallery() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, addVideoGallery);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = addVideoGallery.__proto__ || Object.getPrototypeOf(addVideoGallery)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            fields: {},
	            errors: {},
	            video_gallery_name: '',
	            video_gallery_slug: '',
	            video_gallery_pics: [],
	            video_gallery_desc: '',
	            editorLoaded: false,
	            data: ''
	        }, _this.handleChange = function (event) {
	            _this.setState({ errors: '' });
	            var fields = _this.state.fields;
	            fields[event.target.name] = event.target.value;
	            _this.setState({
	                fields: fields
	            }, function () {
	                return _this.validateForm();
	            });
	            _this.setState(_defineProperty({}, event.target.name, event.target.value));
	        }, _this.DescReactQuillHandleChange = function (name, val) {
	            _this.setState({
	                video_gallery_desc: val
	            });
	        }, _this.handleSubmit = function (event) {
	            event.preventDefault();
	            if (_this.validateForm() === true) {
	                var data = {
	                    video_gallery_name: _this.state.video_gallery_name,
	                    video_gallery_desc: _this.state.video_gallery_desc,
	                    video_gallery_pics: _this.state.video_gallery_pics,
	                    video_gallery_slug: _this.state.video_gallery_slug
	                };
	                console.log(data);
	                saveVideoGallery(data, _this.video_gallery_name, _this.video_gallery_desc, _this.video_gallery_pics).then(function (res) {
	                    _reactToastify.toast.success(res.message, {
	                        position: _reactToastify.toast.POSITION.TOP_RIGHT
	                    });
	                }).catch(function (err) {
	                    _reactToastify.toast.error(err, {
	                        position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                    });
	                });
	            } else {
	                _reactToastify.toast.error('Please provide all required fields!', {
	                    position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(addVideoGallery, [{
	        key: 'validateForm',
	        value: function validateForm() {
	            var errors = {};
	            var formIsValid = true;
	            if (!this.state.video_gallery_name) {
	                formIsValid = false;
	                errors["video_gallery_name"] = "*Please enter your doctor name.";
	            }
	            this.setState({
	                errors: errors
	            });
	            return formIsValid;
	        }
	    }, {
	        key: 'onBlur',
	        value: function onBlur(evt) {
	            console.log("onBlur event called with event info: ", evt);
	        }
	    }, {
	        key: 'afterPaste',
	        value: function afterPaste(evt) {
	            console.log("afterPaste event called with event info: ", evt);
	        }
	    }, {
	        key: 'onFileChange',
	        value: function onFileChange(file) {
	            this.setState({
	                video_gallery_pics: Array.prototype.slice.call(file)
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setState({ editorLoaded: true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'fixed-left' },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'wrapper' },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-page' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'page-content-wrapper' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'card m-b-20' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'card-body' },
	                                            _react2.default.createElement(
	                                                'h4',
	                                                { className: 'mt-0 header-title' },
	                                                'Add Video'
	                                            ),
	                                            _react2.default.createElement(
	                                                'form',
	                                                { onSubmit: this.handleSubmit, id: 'editdoctorform', className: 'needs-validation', enctype: 'multipart/form-data', noValidate: true },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Add Video Title'
	                                                            ),
	                                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'video_gallery_name', id: 'video_gallery_name', value: this.state.video_gallery_name, onChange: this.handleChange, required: true, placeholder: 'video_gallery Name' }),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { style: alertStyle },
	                                                                this.state.errors.video_gallery_name
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Video Gallery Slug'
	                                                            ),
	                                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'video_gallery_slug', id: 'video_gallery_slug', value: this.state.video_gallery_slug, onChange: this.handleChange, required: true, placeholder: 'video_gallery Slug' }),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { style: alertStyle },
	                                                                this.state.errors.video_gallery_name
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-12' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Video Gallery Description'
	                                                            ),
	                                                            _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                                                id: 'desceditor',
	                                                                name: 'desceditor',
	                                                                value: this.state.video_gallery_desc,
	                                                                onChange: function onChange(name, val) {
	                                                                    _this2.DescReactQuillHandleChange(name, val);
	                                                                }
	
	                                                            })
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Thumbnail'
	                                                            ),
	                                                            _react2.default.createElement('input', { type: 'file', multiple: true, className: 'form-control', name: 'video_gallery_pics[]', id: 'video_gallery_pics', onChange: function onChange(event) {
	                                                                    return _this2.onFileChange(event.target.files);
	                                                                }, accept: 'jpg,png' })
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { type: 'submit', className: 'btn btn-pink waves-effect waves-light' },
	                                                            'Submit'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	            );
	        }
	    }]);
	
	    return addVideoGallery;
	}(_react.Component);
	
	exports.default = addVideoGallery;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var saveBannerButtonData = function saveBannerButtonData(data, banner_button_icon, banner_btn_hover_icon) {
	  var _console;
	
	  var formdata = new FormData();
	  formdata.append("banner_button_icon", banner_button_icon);
	  formdata.append("banner_btn_hover_icon", banner_btn_hover_icon);
	  (_console = console).log.apply(_console, ["zeebtn"].concat(_toConsumableArray(formdata)));
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/bannerbutton/savebannerbtndata", formdata, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var GetAllStaticPages = function GetAllStaticPages(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/staticpages/getallstaticpages", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getDepartments = function getDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var AddBannerButtonLink = function (_Component) {
	  _inherits(AddBannerButtonLink, _Component);
	
	  function AddBannerButtonLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddBannerButtonLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddBannerButtonLink.__proto__ || Object.getPrototypeOf(AddBannerButtonLink)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      banner_button_icon: "",
	      banner_btn_hover_icon: "",
	      banner_button_text: "",
	      banner_button_sl_no: "",
	      banner_button_link: "",
	      staticpages: [],
	      departments: [],
	      department_id: ""
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        var data = {
	          banner_button_text: _this.state.banner_button_text,
	          banner_btn_sl_no: _this.state.banner_button_sl_no,
	          banner_button_link: _this.state.banner_button_link
	        };
	        saveBannerButtonData(data, _this.state.banner_button_icon, _this.state.banner_btn_hover_icon).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.href = "/admin/bannerbuttonlink";
	          }, 6000);
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshStaticPages = function (page) {
	      GetAllStaticPages(page).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ staticpages: records });
	        } else {
	          _this.setState({ staticpages: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshDepartments = function () {
	      getDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddBannerButtonLink, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.banner_button_text) {
	        formIsValid = false;
	        errors["banner_button_text"] = "*Please enter the banner button text.";
	      }
	      if (!this.state.banner_button_sl_no) {
	        formIsValid = false;
	        errors["banner_button_sl_no"] = "*Please enter the banner serial no.";
	      }
	      if (!this.state.banner_button_link) {
	        formIsValid = false;
	        errors["banner_button_link"] = "*Please select the banner button.";
	      }
	
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onFileChange",
	    value: function onFileChange(file, type) {
	      if (type == "banner_button_icon") {
	        this.setState({
	          banner_button_icon: file[0]
	        });
	      } else if (type == "banner_btn_hover_icon") {
	        this.setState({
	          banner_btn_hover_icon: file[0]
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshStaticPages();
	      this.refreshDepartments();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-8" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Add Banner Button Link"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "addbannerbuttonform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Banner Button Icon"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "banner_button_icon",
	                                id: "banner_button_icon",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files, "banner_button_icon");
	                                },
	                                accept: "jpg,png",
	                                required: true,
	                                placeholder: "Banner Button Icon"
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Banner Button Hover Icon"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "banner_btn_hover_icon",
	                                id: "banner_btn_hover_icon",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files, "banner_btn_hover_icon");
	                                },
	                                accept: "jpg,png",
	                                required: true,
	                                placeholder: "Banner Button Hover Icon"
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Banner Button Text"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "banner_button_text",
	                                id: "banner_button_text",
	                                value: this.state.fields.banner_button_text,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Banner Button Text"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.banner_button_text
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Banner Button Link"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  name: "banner_button_link",
	                                  value: this.state.fields.banner_button_link,
	                                  onChange: this.handleChange
	                                },
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "" },
	                                  "Select Page"
	                                ),
	                                this.state.departments.length > 0 ? this.state.departments.map(function (department, index) {
	                                  return _react2.default.createElement(
	                                    "option",
	                                    { value: department.id },
	                                    department.department_name
	                                  );
	                                }) : _react2.default.createElement(
	                                  "option",
	                                  { value: "" },
	                                  "Select Page"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.banner_button_link
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Banner Button Serial No"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "banner_button_sl_no",
	                                id: "banner_button_sl_no",
	                                value: this.state.fields.banner_button_sl_no,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Banner Button serial no"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.banner_button_sl_no
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Submit"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return AddBannerButtonLink;
	}(_react.Component);
	
	exports.default = AddBannerButtonLink;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	// import { scAxiosAdmin, thirdparty } from '../..';
	// import { API_TOKEN_NAME } from '../../constants';
	//import { startUserSession } from '../../userSession';
	
	//import Footer from '../../component/admin/Footer';
	//import CKEditor from "react-ckeditor-component";
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var addboardmember = function addboardmember() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      data = _useState2[0],
	      setData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    designation: "",
	    first_name: "",
	    // doctor_id: '',
	    company: "",
	    status: 1,
	    // testimonial_desc: '',
	    image: null,
	    serial_order: 0,
	    type: "board_member"
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      formData = _useState4[0],
	      setFormData = _useState4[1];
	
	  console.log(formData, "hello");
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	    if (name === "doctor_id") {
	      // Check if the select element is for doctor_id
	      setFormData(Object.assign({}, formData, {
	        doctor_id: value
	      }));
	    } else {
	      setFormData(Object.assign({}, formData, _defineProperty({}, name, value)));
	    }
	  };
	
	  var handleFileChange = function handleFileChange(e) {
	    var file = e.target.files[0];
	
	    // Check if a file was selected
	    if (file) {
	      // Update the formData state by setting the author_profile_pic to the selected file
	      setFormData(Object.assign({}, formData, {
	        image: file
	      }));
	    }
	  };
	
	  var handleSubmit = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              e.preventDefault();
	              _context.prev = 1;
	              _context.next = 4;
	              return _.thirdparty.post("/boardmembers", formData, {
	                headers: {
	                  "Content-Type": "multipart/form-data"
	                }
	              });
	
	            case 4:
	              response = _context.sent;
	
	              if (response.status === 201) {
	                if (formData.type === "board_member") {
	                  _reactToastify.toast.success("Board Member Created Successfully!", {
	                    position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                    autoClose: 3000
	                  });
	                } else {
	                  _reactToastify.toast.success("Operational Member Created successfully!", {
	                    position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                    autoClose: 3000
	                  });
	                }
	              }
	              console.log("Form data sent:", response.status);
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context["catch"](1);
	
	              console.error("Error submitting form:", _context.t0);
	              // Handle errors, show error messages, etc.
	
	            case 12:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[1, 9]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(_Seo2.default, {
	      title: "Add Board Members",
	      description: "Add Board Members United Hospital",
	      pathSlug: "/addboardmember",
	      keywords: "Add Board Members, Board Members"
	    }),
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      id: "adddepartmentform",
	                      className: "needs-validation",
	                      noValidate: true,
	                      onSubmit: handleSubmit
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-1" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Serial No."
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "number",
	                            className: "form-control",
	                            name: "serial_order",
	                            id: "serial_order",
	                            value: formData.serial_order,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Serial Number"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-3" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Board Member Type"
	                          ),
	                          _react2.default.createElement(
	                            "select",
	                            {
	                              name: "type",
	                              className: "form-control",
	                              value: formData.type,
	                              onChange: handleChange,
	                              required: true
	                            },
	                            _react2.default.createElement(
	                              "option",
	                              { value: "board_member" },
	                              "Board Member"
	                            ),
	                            _react2.default.createElement(
	                              "option",
	                              { value: "operational_member" },
	                              "Operational Member"
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Name"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "name",
	                            id: "name",
	                            value: formData.name,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Name"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Designation"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "designation",
	                            id: "designation",
	                            value: formData.designation,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Designation"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Company"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "company",
	                            id: "company",
	                            value: formData.company,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Company",
	                            min: "0",
	                            max: "5"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            formData.type === "board_member" ? "Board Member Image" : "Operational Member Image"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "file",
	                            className: "form-control",
	                            name: "image",
	                            id: "image",
	                            onChange: handleFileChange,
	                            accept: "image/*" // Specify the accepted file types if needed
	                            , placeholder: "Doctor Profile Pic"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "submit",
	                            className: "btn waves-effect waves-light"
	                          },
	                          "Submit"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = addboardmember;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _axios = __webpack_require__(64);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _BodyLinkDept = __webpack_require__(198);
	
	var _BodyLinkDept2 = _interopRequireDefault(_BodyLinkDept);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var savebodyparts = function savebodyparts(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bodylink/createbodyparts", {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllBodyParts = function getAllBodyParts(gender, data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bodylink/getbodyparts/" + gender, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getDepartments = function getDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var addbodylink = function (_Component) {
	  _inherits(addbodylink, _Component);
	
	  function addbodylink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, addbodylink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = addbodylink.__proto__ || Object.getPrototypeOf(addbodylink)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      bodyparts: [],
	      departments: [],
	      department_id: "",
	      body_part: "",
	      gender: ""
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.getBodyParts = function (event) {
	      _this.setState({ gender: event.target.value });
	      _this.refreshbodyparts(event.target.value);
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        var data = {
	          department_id: _this.state.department_id,
	          body_part: _this.state.body_part,
	          gender: _this.state.gender
	        };
	        if (_this.state.gender != "") {
	          _this.setState({ gender: _this.state.gender });
	          _this.refreshbodyparts();
	        }
	        _this.refreshbodyparts();
	        savebodyparts(data).then(function (res) {
	          if (res.message) {
	            _reactToastify.toast.success(res.message, {
	              position: _reactToastify.toast.POSITION.TOP_RIGHT
	            });
	          } else {
	            _reactToastify.toast.error(res.error, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          }
	
	          setTimeout(function () {
	            window.location.href = "/admin/body-links";
	          }, 3000);
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshbodyparts = function (gender) {
	      getAllBodyParts(gender).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ bodyparts: records.map(function (rec) {
	              return rec;
	            }) });
	        } else {
	          _this.setState({ bodyparts: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshDepartments = function () {
	      getDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(addbodylink, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.gender) {
	        formIsValid = false;
	        errors["gender"] = "*Please Select a Gender.";
	      }
	      if (!this.state.department_id) {
	        formIsValid = false;
	        errors["department_id"] = "*Please Select Department Name.";
	      }
	      if (!this.state.body_part) {
	        formIsValid = false;
	        errors["body_part"] = "*Please Select a Body part.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({ editorLoaded: true });
	      this.refreshbodyparts();
	      this.refreshDepartments();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Add Body"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-9" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group" },
	                            _react2.default.createElement(
	                              "label",
	                              null,
	                              "Gender"
	                            ),
	                            _react2.default.createElement(
	                              "select",
	                              {
	                                defaultValue: "DEFAULT",
	                                className: "form-control",
	                                value: this.state.gender,
	                                name: "gender",
	                                id: "gender",
	                                onChange: this.getBodyParts
	                              },
	                              _react2.default.createElement(
	                                "option",
	                                { value: "", selected: true, disabled: true },
	                                "Select gender"
	                              ),
	                              _react2.default.createElement(
	                                "option",
	                                { value: "male" },
	                                "Male"
	                              ),
	                              _react2.default.createElement(
	                                "option",
	                                { value: "female" },
	                                "Female"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              { style: alertStyle },
	                              this.state.errors.gender
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-9" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group" },
	                            _react2.default.createElement(
	                              "label",
	                              null,
	                              "Body"
	                            ),
	                            _react2.default.createElement(
	                              "select",
	                              {
	                                defaultValue: this.state.body_part,
	                                className: "form-control",
	                                name: "body_part",
	                                id: "body_part",
	                                onChange: this.handleChange
	                              },
	                              _react2.default.createElement(
	                                "option",
	                                { value: "", selected: true, disabled: true },
	                                "Select Body Part"
	                              ),
	                              this.state.bodyparts.length > 0 ? this.state.bodyparts.map(function (bodyparts, index) {
	                                return _react2.default.createElement(
	                                  "option",
	                                  {
	                                    key: bodyparts.id,
	                                    value: bodyparts.id
	                                  },
	                                  bodyparts.bodypart_name
	                                );
	                              }) : _react2.default.createElement(
	                                "option",
	                                { value: "", selected: true, disabled: true },
	                                "Select Body Part"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              { style: alertStyle },
	                              this.state.errors.body_part
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-9" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group" },
	                            _react2.default.createElement(
	                              "label",
	                              null,
	                              "Departments"
	                            ),
	                            _react2.default.createElement(
	                              "select",
	                              {
	                                defaultValue: this.state.department_id,
	                                className: "form-control",
	                                value: this.state.department_id,
	                                name: "department_id",
	                                id: "department_id",
	                                onChange: this.handleChange
	                              },
	                              _react2.default.createElement(
	                                "option",
	                                { value: "", selected: true, disabled: true },
	                                "Select Department"
	                              ),
	                              this.state.departments.length > 0 ? this.state.departments.map(function (department, index) {
	                                return _react2.default.createElement(
	                                  "option",
	                                  {
	                                    key: department.dept_id,
	                                    value: department.dept_id
	                                  },
	                                  department.department_name
	                                );
	                              }) : _react2.default.createElement(
	                                "option",
	                                { value: "", selected: true, disabled: true },
	                                "Select Department"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              { style: alertStyle },
	                              this.state.errors.department_id
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Submit"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return addbodylink;
	}(_react.Component);
	
	exports.default = addbodylink;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _NewReachTextEditor = __webpack_require__(83);
	
	var _NewReachTextEditor2 = _interopRequireDefault(_NewReachTextEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import Footer from '../../component/admin/Footer';
	//import CKEditor from "react-ckeditor-component";
	
	
	var saveDepartment = function saveDepartment(data, department_image, department_image_hover, department_banner_image, selectedPackageId, selectedInvestigationId, descriptions) {
	  var formdata = new FormData();
	  formdata.append("department_image", department_image);
	  formdata.append("department_image_hover", department_image_hover);
	  formdata.append("department_banner_image", department_banner_image);
	  formdata.append("packages", selectedPackageId);
	  formdata.append("investigations", selectedInvestigationId);
	  formdata.append("description_list", JSON.stringify(descriptions));
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/department/createdepartment", formdata, {
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var checkDepartmentIdDuplicate = function checkDepartmentIdDuplicate(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/checkdepartmentidduplicate", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllPackages = function getAllPackages(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/packages/getall", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getInvestigations = function getInvestigations(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/investigations", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var AddDepartment = function (_Component) {
	  _inherits(AddDepartment, _Component);
	
	  function AddDepartment() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddDepartment);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddDepartment.__proto__ || Object.getPrototypeOf(AddDepartment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      department_name: "",
	      department_image: "",
	      department_image_hover: "",
	      department_banner_image: "",
	      department_id: "",
	      search: "",
	      descriptions: [{ value: "", visibility: 1, key: _this.generateRandomText() }],
	      packages: [],
	      selectedPackageId: [],
	      packageSearch: "",
	
	      investigations: [],
	      selectedInvestigationId: [],
	      investigationSearch: ""
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.addDescription = function () {
	      _this.setState(function (prevState) {
	        return {
	          descriptions: [].concat(_toConsumableArray(prevState.descriptions), [{ value: "", visibility: 1 }])
	        };
	      });
	    }, _this.removeDescription = function (index) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions.splice(index, 1); // Remove the description at the given index
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.toggleVisibility = function (index) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions[index].visibility = updatedDescriptions[index].visibility === 1 ? 0 : 1;
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.handleDescriptionChange = function (index, value, key) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions[index].value = value;
	        updatedDescriptions[index].key = key;
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.handleBlur = function (event) {
	      var data = {
	        departmentId: event.target.value
	      };
	      checkDepartmentIdDuplicate(data).then(function (res) {
	        if (res.status == true) {
	          document.getElementById("department_submit_btn").disabled = false;
	        } else {
	          document.getElementById("department_submit_btn").disabled = true;
	        }
	      }).catch(function (err) {});
	    }, _this.toggleStatus = function (index) {
	      _this.setState(function (prevState) {
	        var newStatusList = [].concat(_toConsumableArray(prevState.status_list));
	        newStatusList[index].visibility = newStatusList[index].visibility === 1 ? 0 : 1;
	        return { status_list: newStatusList };
	      });
	    }, _this.handlePackagesChange = function (event) {
	      var selectedId = parseInt(event.target.value, 10);
	      _this.setState(function (prevState) {
	        var isSelected = prevState.selectedPackageId.includes(selectedId);
	
	        // Add or remove the selected package ID
	        var updatedSelectedPackages = isSelected ? prevState.selectedPackageId.filter(function (id) {
	          return id !== selectedId;
	        }) : [].concat(_toConsumableArray(prevState.selectedPackageId), [selectedId]);
	
	        return { selectedPackageId: updatedSelectedPackages };
	      });
	    }, _this.handleSelectionChange = function (type, id) {
	      _this.setState(function (prevState) {
	        var isSelected = prevState[type].includes(id);
	        return _defineProperty({}, type, isSelected ? prevState[type].filter(function (item) {
	          return item !== id;
	        }) : [].concat(_toConsumableArray(prevState[type]), [id]));
	      });
	    }, _this.handleSearchChange = function (searchField, value) {
	      _this.setState(_defineProperty({}, searchField, value));
	    }, _this.renderSearchableDropdown = function (label, type, items, selectedIds, searchField) {
	      var searchValue = _this.state[searchField] || ""; // Retrieve the correct search value
	      var filteredItems = items.filter(function (item) {
	        return (item.name || item.Product_Name || "").toLowerCase().includes(searchValue.toLowerCase());
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "col-sm-6" },
	        _react2.default.createElement(
	          "div",
	          { className: "form-group" },
	          _react2.default.createElement(
	            "label",
	            null,
	            label
	          ),
	          _react2.default.createElement("input", {
	            type: "text",
	            className: "form-control mb-2",
	            placeholder: "Search " + type,
	            value: searchValue,
	            onChange: function onChange(e) {
	              return _this.handleSearchChange(searchField, e.target.value);
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                border: "1px solid #ced4da",
	                borderRadius: "4px",
	                padding: "10px",
	                maxHeight: "200px",
	                overflowY: "scroll"
	              }
	            },
	            filteredItems.length > 0 ? filteredItems.map(function (item) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: item.id,
	                  style: { display: "flex", alignItems: "center" }
	                },
	                _react2.default.createElement("input", {
	                  type: "checkbox",
	                  checked: selectedIds.includes(item.id),
	                  onChange: function onChange() {
	                    return _this.handleSelectionChange(type, item.id);
	                  },
	                  style: { marginRight: "10px" }
	                }),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  item.name || item.Product_Name
	                )
	              );
	            }) : _react2.default.createElement(
	              "p",
	              null,
	              "No ",
	              type,
	              " found"
	            )
	          )
	        )
	      );
	    }, _this.handleInvestigationChange = function (event) {
	      var selectedId = parseInt(event.target.value, 10);
	      _this.setState(function (prevState) {
	        var isSelected = prevState.selectedInvestigationId.includes(selectedId);
	
	        // Add or remove the selected package ID
	        var updatedSelectedPackages = isSelected ? prevState.selectedInvestigationId.filter(function (id) {
	          return id !== selectedId;
	        }) : [].concat(_toConsumableArray(prevState.selectedInvestigationId), [selectedId]);
	
	        return { selectedInvestigationId: updatedSelectedPackages };
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm()) {
	        var data = {
	          department_name: _this.state.department_name,
	          department_id: _this.state.department_id
	        };
	        saveDepartment(data, _this.state.department_image, _this.state.department_image_hover, _this.state.department_banner_image, _this.state.selectedPackageId, _this.state.selectedInvestigationId, _this.state.descriptions).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.href = "/admin/departments";
	          }, 6000);
	        }).catch(function (err) {
	          _reactToastify.toast.error("Error occured", {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Department name, Department Id and Department image are required field", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshgetAllDepartmentData = function () {
	      getAllPackages().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            packages: records
	          });
	        } else {
	          _this.setState({
	            packages: []
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshgetAllInvestigationData = function () {
	      getInvestigations().then(function (res) {
	        if (res.status === 200) {
	          var records = res.data;
	          _this.setState({
	            investigations: records
	          });
	        } else {
	          _this.setState({
	            investigations: []
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddDepartment, [{
	    key: "validateForm",
	    value: function validateForm() {
	      //let fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.department_name) {
	        formIsValid = false;
	        errors["department_name"] = "*Please enter your department name.";
	      }
	      // if (!this.state.department_id) {
	      //   formIsValid = false;
	      //   errors["department_id"] = "*Please enter your department id.";
	      // }
	      /* if (!this.state.department_image) {
	        formIsValid = false;
	        errors["department_image"] = "*Please enter your department image.";
	      } */
	
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	    // Handle adding a new description field
	
	
	    // Handle removing a specific description field
	
	
	    // Handle toggling visibility of a description
	
	
	    // Handle updating the value of a description field
	
	  }, {
	    key: "generateRandomText",
	    value: function generateRandomText() {
	      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
	
	      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	      var result = "";
	
	      for (var i = 0; i < length; i++) {
	        var randomIndex = Math.floor(Math.random() * characters.length);
	        result += characters.charAt(randomIndex);
	      }
	
	      return result;
	    }
	  }, {
	    key: "onFileChange",
	    value: function onFileChange(file, type) {
	      if (type == "department_image") {
	        this.setState({
	          department_image: file[0]
	        });
	      } else if (type == "department_image_hover") {
	        this.setState({
	          department_image_hover: file[0]
	        });
	      } else if (type == "department_banner_image") {
	        this.setState({
	          department_banner_image: file[0]
	        });
	      }
	    }
	    // Handle package selection
	
	    // Handle package selection
	
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetAllDepartmentData();
	      this.refreshgetAllInvestigationData();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          packages = _state.packages,
	          search = _state.search,
	          selectedPackages = _state.selectedPackages;
	
	
	      var filteredPackages = packages.filter(function (pkg) {
	        return (pkg.name || "").toLowerCase().includes((search || "").toLowerCase());
	      });
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(_Seo2.default, {
	          title: "Add Department",
	          description: "Add Department United Hospital",
	          pathSlug: "/adddepartment",
	          keywords: "Add Department, Department"
	        }),
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Add Department"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "adddepartmentform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "department_name",
	                                id: "department_name",
	                                value: this.state.department_name,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Department Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.department_name
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department Id"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "number",
	                                className: "form-control",
	                                name: "department_id",
	                                id: "department_id",
	                                value: this.state.department_id,
	                                onBlur: this.handleBlur,
	                                onChange: this.handleChange,
	                                pattern: "[0-9]*",
	                                required: true,
	                                placeholder: "Department Id"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.department_id
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row mb-3" },
	                          this.renderSearchableDropdown("Select Packages", "selectedPackageId", this.state.packages, this.state.selectedPackageId, "packageSearch"),
	                          this.renderSearchableDropdown("Select Investigations", "selectedInvestigationId", this.state.investigations, this.state.selectedInvestigationId, "investigationSearch")
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            "Add Department Descriptions"
	                          ),
	                          this.state.descriptions.map(function (desc, index) {
	                            return _react2.default.createElement(
	                              "div",
	                              { key: index, className: "row mb-2" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "label",
	                                    null,
	                                    "Description " + (index + 1)
	                                  ),
	                                  _react2.default.createElement(_NewReachTextEditor2.default, {
	                                    id: "Description-" + (index + 1),
	                                    name: "Description-" + (index + 1),
	                                    value: desc.value,
	                                    onChange: function onChange(name, val) {
	                                      return _this2.handleDescriptionChange(index, val, _this2.generateRandomText());
	                                    }
	                                  }),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "d-flex justify-content-between align-items-center" },
	                                    _react2.default.createElement(
	                                      "button",
	                                      {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                          return _this2.toggleVisibility(index);
	                                        },
	                                        className: "btn " + (desc.visibility === 1 ? "btn-success" : "btn-danger") + " mt-2"
	                                      },
	                                      desc.visibility === 1 ? "Hide" : "Show"
	                                    ),
	                                    index > 0 && _react2.default.createElement(
	                                      "button",
	                                      {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                          return _this2.removeDescription(index);
	                                        },
	                                        className: "btn btn-danger ml-2 mt-2"
	                                      },
	                                      "Remove"
	                                    )
	                                  )
	                                )
	                              )
	                            );
	                          }),
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              type: "button",
	                              onClick: this.addDescription,
	                              className: "btn btn-primary mb-3"
	                            },
	                            "Add Description"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department Icon"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "department_image",
	                                id: "department_image",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files, "department_image");
	                                },
	                                accept: "jpg,png"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department Hover Icon"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "department_image_hover",
	                                id: "department_image_hover",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files, "department_image_hover");
	                                },
	                                accept: "jpg,png"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department Banner Image"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "department_banner_image",
	                                id: "department_banner_image",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files, "department_banner_image");
	                                },
	                                accept: "jpg,png"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light",
	                                id: "department_submit_btn"
	                              },
	                              "Submit"
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement("div", { className: "" })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return AddDepartment;
	}(_react.Component);
	
	exports.default = AddDepartment;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _NewReachTextEditor = __webpack_require__(83);
	
	var _NewReachTextEditor2 = _interopRequireDefault(_NewReachTextEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var saveDoctor = function saveDoctor(data, doctor_profile,
	// status_list,
	Schedule, selectedDepartmentId, descriptions, tableHTML) {
	  var formdata = new FormData();
	
	  formdata.append("doctor_profile", doctor_profile);
	  // formdata.append("status_list", JSON.stringify(status_list));
	  formdata.append("Schedule", JSON.stringify([Schedule]));
	  formdata.append("selectedDepartmentId", selectedDepartmentId);
	  formdata.append("description_list", JSON.stringify(descriptions));
	  formdata.append("doctor_table", JSON.stringify(tableHTML));
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/doctors/createdoctor", formdata, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: data
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllDepartments = function getAllDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var adddoctor = function (_Component) {
	  _inherits(adddoctor, _Component);
	
	  function adddoctor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, adddoctor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = adddoctor.__proto__ || Object.getPrototypeOf(adddoctor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	
	      doctor_id: "",
	      doctor_name: "",
	      doctor_degree: "",
	      doctor_designation: "",
	      doctor_fees: "",
	      doctor_department: "",
	      doctor_uhl_id: "",
	      doctor_bmdc_id: "",
	      doctor_profile: "",
	      editorLoaded: false,
	      data: "",
	      Schedule: {
	        Saturday: "",
	        Sunday: "",
	        Monday: "",
	        Tuesday: "",
	        Wednesday: "",
	        Thursday: "",
	        Friday: ""
	      },
	      // status_list: [
	      //   { field_name: "doctor_desc", visibility: 1 },
	      //   { field_name: "doctor_edu", visibility: 1 },
	      //   { field_name: "doctor_exp", visibility: 1 },
	      //   { field_name: "doc_professional_skills", visibility: 1 },
	      //   { field_name: "doc_memberships", visibility: 1 },
	      //   { field_name: "doc_awards", visibility: 1 },
	      //   { field_name: "doc_key_research_experience", visibility: 1 },
	      //   { field_name: "doc_key_publications", visibility: 1 },
	      //   { field_name: "doc_key_scientific_presentations", visibility: 1 },
	      // ],
	      descriptions: [{ value: "", visibility: 1, key: _this.generateRandomText() }],
	      departments: [],
	      selectedDepartmentId: [], // Holds selected department IDs
	      departmentSearch: "", // Search term for filtering departments
	
	      tableRows: 1, // Default number of rows
	      tableColumns: 1, // Default number of columns
	      tableData: Array(1).fill("").map(function () {
	        return Array(1).fill("");
	      }) // Initialize with empty cells
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.handleTableRowsChange = function (event) {
	      var rows = parseInt(event.target.value, 10);
	      _this.setState({
	        tableRows: rows,
	        tableData: Array(rows).fill("").map(function () {
	          return Array(_this.state.tableColumns).fill("");
	        })
	      });
	    }, _this.handleTableColumnsChange = function (event) {
	      var columns = parseInt(event.target.value, 10);
	
	      // Update the number of columns and adjust table data accordingly
	      _this.setState(function (prevState) {
	        // Handle the case where columns are being increased or decreased
	        var newTableData = prevState.tableData.map(function (row) {
	          // If decreasing columns, slice off extra columns
	          if (columns < row.length) {
	            return row.slice(0, columns);
	          }
	          // If increasing columns, add empty cells to fill the new columns
	          return [].concat(_toConsumableArray(row), _toConsumableArray(Array(columns - row.length).fill("")));
	        });
	
	        return {
	          tableColumns: columns,
	          tableData: newTableData
	        };
	      });
	    }, _this.handleTableCellChange = function (e, rowIndex, colIndex) {
	      var newTableData = [].concat(_toConsumableArray(_this.state.tableData));
	      newTableData[rowIndex][colIndex] = e.target.value;
	      _this.setState({ tableData: newTableData });
	    }, _this.addDescription = function () {
	      _this.setState(function (prevState) {
	        return {
	          descriptions: [].concat(_toConsumableArray(prevState.descriptions), [{ value: "", visibility: 1 }])
	        };
	      });
	    }, _this.removeDescription = function (index) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions.splice(index, 1); // Remove the description at the given index
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.toggleVisibility = function (index) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions[index].visibility = updatedDescriptions[index].visibility === 1 ? 0 : 1;
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.handleDescriptionChange = function (index, value, key) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions[index].value = value;
	        updatedDescriptions[index].key = key;
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.handleSelectionChange = function (type, id) {
	      _this.setState(function (prevState) {
	        var isSelected = prevState[type].includes(id);
	
	        return _defineProperty({}, type, isSelected ? prevState[type].filter(function (item) {
	          return item !== id;
	        }) // Remove if already selected
	        : [].concat(_toConsumableArray(prevState[type]), [id]));
	      });
	    }, _this.handleSearchChange = function (searchField, value) {
	      _this.setState(_defineProperty({}, searchField, value));
	    }, _this.handleScheduleChange = function (event) {
	      var Schedule = _this.state.Schedule;
	      Schedule[event.target.name] = event.target.value;
	      _this.setState({
	        Schedule: Schedule
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        var tableHTML = _this.generateTableHTML();
	        var data = {
	          doctor_name: _this.state.doctor_name,
	          doctor_degree: _this.state.doctor_degree,
	          designation: _this.state.doctor_designation,
	          doctor_fees: _this.state.doctor_fees,
	          doctor_department: _this.state.doctor_department,
	          doctor_uhl_id: _this.state.doctor_uhl_id,
	          doctor_bmdc_id: _this.state.doctor_bmdc_id
	        };
	        saveDoctor(data, _this.state.doctor_profile,
	        // this.state.status_list,
	        _this.state.Schedule, _this.state.selectedDepartmentId, _this.state.descriptions, {
	          row: _this.state.tableRows,
	          column: _this.state.tableColumns,
	          tableHTML: tableHTML // Send table HTML as part of the data
	        }).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.href = "/admin/doctors";
	          }, 6000);
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshDepartments = function (event) {
	      getAllDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(adddoctor, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.doctor_name) {
	        formIsValid = false;
	        errors["doctor_name"] = "*Please enter your doctor name.";
	      }
	
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	
	    // Handle change in number of rows
	
	
	    // Handle change in number of columns
	
	
	    // Handle individual cell change
	
	  }, {
	    key: "generateTableHTML",
	
	
	    // Generate HTML for the table
	    // generateTableHTML() {
	    //   let tableHTML = "<table class='table table-secondary table-striped table-hover'>";
	    //   this.state.tableData.forEach((row) => {
	    //     tableHTML += "<tr>";
	    //     row.forEach((cell) => {
	    //       tableHTML += `<td>${cell}</td>`;
	    //     });
	    //     tableHTML += "</tr>";
	    //   });
	    //   tableHTML += "</table>";
	    //   return tableHTML;
	    // }
	    value: function generateTableHTML() {
	      var tableHTML = "<table class='table table-secondary table-striped table-hover'>";
	
	      this.state.tableData.forEach(function (row, rowIndex) {
	        tableHTML += "<tr>";
	
	        row.forEach(function (cell, colIndex) {
	          // Check if it's the first row (header row)
	          if (rowIndex === 0) {
	            // Use <th> for header cells to make the text bold
	            tableHTML += "<th>" + cell + "</th>";
	          } else {
	            // Use <td> for other rows (content cells)
	            tableHTML += "<td>" + cell + "</td>";
	          }
	        });
	
	        tableHTML += "</tr>";
	      });
	
	      tableHTML += "</table>";
	      return tableHTML;
	    }
	
	    // description logic here
	    // Handle adding a new description field
	
	
	    // Handle removing a specific description field
	
	
	    // Handle toggling visibility of a description
	
	
	    // Handle updating the value of a description field
	
	  }, {
	    key: "generateRandomText",
	    value: function generateRandomText() {
	      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
	
	      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	      var result = "";
	
	      for (var i = 0; i < length; i++) {
	        var randomIndex = Math.floor(Math.random() * characters.length);
	        result += characters.charAt(randomIndex);
	      }
	
	      return result;
	    }
	
	    // multiple select search dropdown
	
	  }, {
	    key: "onBlur",
	
	
	    // toggleStatus = (index) => {
	    //   this.setState((prevState) => {
	    //     const newStatusList = [...prevState.status_list];
	    //     newStatusList[index].visibility =
	    //       newStatusList[index].visibility === 1 ? 0 : 1;
	    //     return { status_list: newStatusList };
	    //   });
	    // };
	    value: function onBlur(evt) {
	      console.log("onBlur event called with event info: ", evt);
	    }
	  }, {
	    key: "afterPaste",
	    value: function afterPaste(evt) {
	      console.log("afterPaste event called with event info: ", evt);
	    }
	  }, {
	    key: "onFileChange",
	    value: function onFileChange(file) {
	      this.setState({
	        doctor_profile: file[0]
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({ editorLoaded: true });
	      this.refreshDepartments();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          departments = _state.departments,
	          departmentSearch = _state.departmentSearch,
	          selectedDepartmentId = _state.selectedDepartmentId;
	
	
	      var filteredDepartments = departments.filter(function (department) {
	        return department.department_name.toLowerCase().includes(departmentSearch.toLowerCase());
	      });
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Add Doctor"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-4" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "doctor_name",
	                                id: "doctor_name",
	                                value: this.state.doctor_name,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.doctor_name
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-4" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Degree"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "doctor_degree",
	                                id: "doctor_degree",
	                                value: this.state.doctor_degree,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor Degree"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.doctor_degree
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-4" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Designation"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "doctor_designation",
	                                id: "doctor_designation",
	                                value: this.state.doctor_designation,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor Designation"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.doctor_degree
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Department"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control mb-2",
	                                placeholder: "Search departments",
	                                value: departmentSearch,
	                                onChange: function onChange(e) {
	                                  return _this2.handleSearchChange("departmentSearch", e.target.value);
	                                }
	                              }),
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  style: {
	                                    border: "1px solid #ced4da",
	                                    borderRadius: "4px",
	                                    padding: "10px",
	                                    maxHeight: "200px",
	                                    overflowY: "scroll"
	                                  }
	                                },
	                                filteredDepartments.length > 0 ? filteredDepartments.map(function (department) {
	                                  return _react2.default.createElement(
	                                    "div",
	                                    {
	                                      key: department.id,
	                                      style: {
	                                        display: "flex",
	                                        alignItems: "center"
	                                      }
	                                    },
	                                    _react2.default.createElement("input", {
	                                      type: "checkbox",
	                                      value: department.dept_id,
	                                      checked: selectedDepartmentId.includes(department.id),
	                                      onChange: function onChange() {
	                                        return _this2.handleSelectionChange("selectedDepartmentId", department.id);
	                                      },
	                                      style: { marginRight: "10px" }
	                                    }),
	                                    _react2.default.createElement(
	                                      "span",
	                                      null,
	                                      department.department_name
	                                    )
	                                  );
	                                }) : _react2.default.createElement(
	                                  "p",
	                                  null,
	                                  "No departments found"
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Fees"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "number",
	                                className: "form-control",
	                                name: "doctor_fees",
	                                id: "doctor_fees",
	                                value: this.state.doctor_fees,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor Fees"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.doctor_fees
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor UHL Id:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "doctor_uhl_id",
	                                id: "doctor_uhl_id",
	                                value: this.state.doctor_uhl_id,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor UHL Id"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.doctor_uhl_id
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor BMDC Id"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "doctor_bmdc_id",
	                                id: "doctor_bmdc_id",
	                                value: this.state.doctor_bmdc_id,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor BMDC Id"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.doctor_bmdc_id
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            "Add Department Descriptions"
	                          ),
	                          this.state.descriptions.map(function (desc, index) {
	                            return _react2.default.createElement(
	                              "div",
	                              { key: index, className: "row mb-2" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "label",
	                                    null,
	                                    "Description " + (index + 1)
	                                  ),
	                                  _react2.default.createElement(_NewReachTextEditor2.default, {
	                                    id: "Description-" + (index + 1),
	                                    name: "Description-" + (index + 1),
	                                    value: desc.value,
	                                    onChange: function onChange(name, val) {
	                                      return _this2.handleDescriptionChange(index, val, _this2.generateRandomText());
	                                    }
	                                  }),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "d-flex justify-content-between align-items-center" },
	                                    _react2.default.createElement(
	                                      "button",
	                                      {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                          return _this2.toggleVisibility(index);
	                                        },
	                                        className: "btn " + (desc.visibility === 1 ? "btn-success" : "btn-danger") + " mt-2"
	                                      },
	                                      desc.visibility === 1 ? "Hide" : "Show"
	                                    ),
	                                    index > 0 && _react2.default.createElement(
	                                      "button",
	                                      {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                          return _this2.removeDescription(index);
	                                        },
	                                        className: "btn btn-danger ml-2 mt-2"
	                                      },
	                                      "Remove"
	                                    )
	                                  )
	                                )
	                              )
	                            );
	                          }),
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              type: "button",
	                              onClick: this.addDescription,
	                              className: "btn btn-primary mb-3"
	                            },
	                            "Add Description"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "h4",
	                                null,
	                                "Table Content"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "label",
	                                    null,
	                                    "Number of Rows"
	                                  ),
	                                  _react2.default.createElement("input", {
	                                    type: "number",
	                                    min: "1",
	                                    className: "form-control",
	                                    value: this.state.tableRows,
	                                    onChange: this.handleTableRowsChange
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "label",
	                                    null,
	                                    "Number of Columns"
	                                  ),
	                                  _react2.default.createElement("input", {
	                                    type: "number",
	                                    min: "1",
	                                    className: "form-control",
	                                    value: this.state.tableColumns,
	                                    onChange: this.handleTableColumnsChange
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "row" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "col-sm-12" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                      "label",
	                                      null,
	                                      "Table Content"
	                                    ),
	                                    _react2.default.createElement(
	                                      "table",
	                                      { border: "1", className: "table" },
	                                      _react2.default.createElement(
	                                        "tbody",
	                                        null,
	                                        this.state.tableData.map(function (row, rowIndex) {
	                                          return _react2.default.createElement(
	                                            "tr",
	                                            { key: rowIndex },
	                                            row.map(function (cell, colIndex) {
	                                              return _react2.default.createElement(
	                                                "td",
	                                                { key: colIndex },
	                                                _react2.default.createElement("input", {
	                                                  type: "text",
	                                                  value: cell,
	                                                  onChange: function onChange(e) {
	                                                    return _this2.handleTableCellChange(e, rowIndex, colIndex);
	                                                  },
	                                                  placeholder: "Enter text"
	                                                })
	                                              );
	                                            })
	                                          );
	                                        })
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Profile"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "doctor_profile",
	                                id: "doctor_profile",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png",
	                                placeholder: "Doctor Fees"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { className: "mt-4 header-title" },
	                          "Doctor Schedule"
	                        ),
	                        _react2.default.createElement("hr", null),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-6 col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Saturday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Saturday",
	                                value: this.state.Schedule.Saturday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Sunday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Sunday",
	                                value: this.state.Schedule.Sunday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Monday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Monday",
	                                value: this.state.Schedule.Monday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Tuesday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Tuesday",
	                                value: this.state.Schedule.Tuesday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Wednesday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Wednesday",
	                                value: this.state.Schedule.Wednesday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Thursday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Thursday",
	                                value: this.state.Schedule.Thursday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Friday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Friday",
	                                value: this.state.Schedule.Friday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(
	                                  "button",
	                                  {
	                                    type: "submit",
	                                    className: "btn btn-pink waves-effect waves-light"
	                                  },
	                                  "Submit"
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return adddoctor;
	}(_react.Component);
	
	exports.default = adddoctor;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var saveHeaderAnnoucement = function saveHeaderAnnoucement(data) {
	    return new Promise(function (resolve, reject) {
	        var req = _.scAxiosAdmin.request('/headerannoucement/saveheaderannoucement', {
	            method: 'post',
	            headers: {
	                'Accept': 'application/json',
	                'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	            },
	            params: Object.assign({}, data)
	        });
	        req.then(function (res) {
	            return resolve(res.data);
	        }).catch(function (err) {
	            return reject(err);
	        });
	    });
	};
	var alertStyle = {
	    color: 'red'
	};
	
	var AddHeaderAnnoucement = function (_Component) {
	    _inherits(AddHeaderAnnoucement, _Component);
	
	    function AddHeaderAnnoucement() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AddHeaderAnnoucement);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddHeaderAnnoucement.__proto__ || Object.getPrototypeOf(AddHeaderAnnoucement)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            fields: {},
	            errors: {},
	            header_annoucement_text: '',
	            header_annoucement_link: '',
	            header_phone_no: ''
	        }, _this.handleChange = function (event) {
	            _this.setState({ errors: '' });
	            var fields = _this.state.fields;
	            fields[event.target.name] = event.target.value;
	            _this.setState({
	                fields: fields
	            }, function () {
	                return _this.validateForm();
	            });
	            _this.setState(_defineProperty({}, event.target.name, event.target.value));
	        }, _this.handleSubmit = function (event) {
	            event.preventDefault();
	            if (_this.validateForm() === true) {
	                var data = {
	                    header_annoucement_text: _this.state.header_annoucement_text,
	                    header_annoucement_link: _this.state.header_annoucement_link,
	                    header_phone_no: _this.state.header_phone_no
	                };
	                saveHeaderAnnoucement(data).then(function (res) {
	                    if (res.status === true) {
	                        _reactToastify.toast.success(res.message, {
	                            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                        });
	                        setTimeout(function () {
	                            window.location.href = '/headerannoucement';
	                        }, 6000);
	                    } else {
	                        _reactToastify.toast.error(res.message, {
	                            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                        });
	                    }
	                }).catch(function (err) {
	                    _reactToastify.toast.error(err, {
	                        position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                    });
	                });
	            } else {
	                _reactToastify.toast.error('Please provide all required fields!', {
	                    position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AddHeaderAnnoucement, [{
	        key: 'validateForm',
	        value: function validateForm() {
	            //let fields = this.state.fields;
	            var errors = {};
	            var formIsValid = true;
	            if (!this.state.header_annoucement_text) {
	                formIsValid = false;
	                errors["header_annoucement_text"] = "*Please enter the header annoucement title.";
	            }
	            if (!this.state.header_annoucement_link) {
	                formIsValid = false;
	                errors["header_annoucement_link"] = "*Please enter the header annoucement link.";
	            }
	            if (!this.state.header_phone_no) {
	                formIsValid = false;
	                errors["header_phone_no"] = "*Please enter the header phone no.";
	            }
	
	            this.setState({
	                errors: errors
	            });
	            return formIsValid;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'fixed-left' },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'wrapper' },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-page' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'page-content-wrapper' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'card m-b-20' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'card-body' },
	                                            _react2.default.createElement(
	                                                'h4',
	                                                { className: 'mt-0 header-title' },
	                                                'Add Header Annoucement'
	                                            ),
	                                            _react2.default.createElement(
	                                                'form',
	                                                { onSubmit: this.handleSubmit, id: 'editdoctorform', className: 'needs-validation', noValidate: true },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Header Annoucement Text'
	                                                            ),
	                                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'header_annoucement_text', id: 'header_annoucement_text', value: this.state.fields.header_annoucement_text, onChange: this.handleChange, required: true, placeholder: 'Header Annoucement Text' }),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { style: alertStyle },
	                                                                this.state.errors.header_annoucement_text
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Header Annoucement Link'
	                                                            ),
	                                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'header_annoucement_link', id: 'header_annoucement_link', value: this.state.fields.header_annoucement_link, onChange: this.handleChange, required: true, placeholder: 'Header Annoucement Link' }),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { style: alertStyle },
	                                                                this.state.errors.header_annoucement_link
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Header Annoucement Link'
	                                                            ),
	                                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'header_phone_no', id: 'header_phone_no', value: this.state.fields.header_phone_no, onChange: this.handleChange, required: true, placeholder: 'Header Phone No' }),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { style: alertStyle },
	                                                                this.state.errors.header_phone_no
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { type: 'submit', className: 'btn btn-pink waves-effect waves-light' },
	                                                            'Submit'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	            );
	        }
	    }]);
	
	    return AddHeaderAnnoucement;
	}(_react.Component);
	
	exports.default = AddHeaderAnnoucement;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var savemenu = function savemenu(data) {
	    var formdata = new FormData();
	
	    return new Promise(function (resolve, reject) {
	        var req = _.scAxiosAdmin.post('/menu/createmenu', formdata, {
	            method: 'post',
	            headers: {
	                'Accept': 'application/json',
	                'Content-Type': 'multipart/form-data; boundary=' + formdata._boundary,
	                'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	            },
	            params: Object.assign({}, data)
	        });
	        req.then(function (res) {
	            return resolve(res.data);
	        }).catch(function (err) {
	            return reject(err);
	        });
	    });
	};
	
	var GetAllStaticPages = function GetAllStaticPages(data) {
	    return new Promise(function (resolve, reject) {
	        var req = _.scAxiosAdmin.request('/staticpages/getallstaticpages', {
	            method: 'get',
	            headers: {
	                'Accept': 'application/json',
	                'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	            },
	            params: Object.assign({}, data)
	        });
	        req.then(function (res) {
	            return resolve(res.data);
	        }).catch(function (err) {
	            return reject(err);
	        });
	    });
	};
	
	var alertStyle = {
	    color: 'red'
	};
	
	var addmenu = function (_Component) {
	    _inherits(addmenu, _Component);
	
	    function addmenu() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, addmenu);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = addmenu.__proto__ || Object.getPrototypeOf(addmenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            fields: {},
	            errors: {},
	            menu: [],
	            staticpages: [],
	            menu_title: '',
	            menu_url: '',
	            menu_current_status: '',
	            data: ''
	        }, _this.handleChange = function (event) {
	            _this.setState({ errors: '' });
	            var fields = _this.state.fields;
	            fields[event.target.name] = event.target.value;
	            _this.setState({
	                fields: fields
	            }, function () {
	                return _this.validateForm();
	            });
	            _this.setState(_defineProperty({}, event.target.name, event.target.value));
	        }, _this.refreshStaticPages = function (page) {
	            GetAllStaticPages(page).then(function (res) {
	                if (res.status === true) {
	                    var records = res.data.data;
	                    _this.setState({ staticpages: records });
	                } else {
	                    _this.setState({ staticpages: '' });
	                }
	                _this.setState({ enableShdo: false });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }, _this.handleSubmit = function (event) {
	            event.preventDefault();
	            if (_this.validateForm() === true) {
	
	                var data = {
	                    menu_title: _this.state.menu_title,
	                    menu_url: _this.state.menu_url,
	                    menu_current_status: _this.state.menu_current_status
	
	                };
	                savemenu(data).then(function (res) {
	                    if (res.status === 'ok') {
	                        _reactToastify.toast.success(res.message, {
	                            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                        });
	
	                        setTimeout(function () {
	                            window.location.href = '/menu';
	                        }, 6000);
	                    } else if (res.status === 'notok') {
	                        _reactToastify.toast.error(res.message, {
	                            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                        });
	                    } else if (res.status === 'title_error') {
	                        _reactToastify.toast.error(res.message, {
	                            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                        });
	                    } else if (res.status === 'page_error') {
	                        _reactToastify.toast.error(res.message, {
	                            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                        });
	                    }
	                }).catch(function (err) {
	                    _reactToastify.toast.error(err, {
	                        position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                    });
	                });
	            } else {
	                _reactToastify.toast.error('Please provide all required fields!', {
	                    position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(addmenu, [{
	        key: 'validateForm',
	        value: function validateForm() {
	            //let fields = this.state.fields;
	            var errors = {};
	            var formIsValid = true;
	            if (!this.state.menu_title) {
	                formIsValid = false;
	                errors["menu_title"] = "*Please enter the menu title.";
	            }
	            if (!this.state.menu_current_status) {
	                formIsValid = false;
	                errors["menu_current_status"] = "*Please enter the menu title.";
	            }
	            if (!this.state.menu_url) {
	                formIsValid = false;
	                errors["menu_url"] = "*Please enter the menu url.";
	            }
	
	            this.setState({
	                errors: errors
	            });
	            return formIsValid;
	        }
	    }, {
	        key: 'onBlur',
	        value: function onBlur(evt) {
	            console.log("onBlur event called with event info: ", evt);
	        }
	    }, {
	        key: 'afterPaste',
	        value: function afterPaste(evt) {
	            console.log("afterPaste event called with event info: ", evt);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setState({ editorLoaded: true });
	            this.refreshStaticPages();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'fixed-left' },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'wrapper' },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-page' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'page-content-wrapper' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'card m-b-20' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'card-body' },
	                                            _react2.default.createElement(
	                                                'h4',
	                                                { className: 'mt-0 header-title' },
	                                                'Add Menu'
	                                            ),
	                                            _react2.default.createElement(
	                                                'form',
	                                                { onSubmit: this.handleSubmit, id: 'editdoctorform', className: 'needs-validation', noValidate: true },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Title'
	                                                            ),
	                                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'menu_title', id: 'page_title', value: this.state.fields.menu_title, onChange: this.handleChange, required: true, placeholder: 'Menu title' }),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { style: alertStyle },
	                                                                this.state.errors.menu_title
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Status'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'select',
	                                                                { className: 'form-control', value: this.state.fields.menu_current_status, name: 'menu_current_status', onChange: this.handleChange },
	                                                                _react2.default.createElement(
	                                                                    'option',
	                                                                    { value: 'active' },
	                                                                    'Active'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'option',
	                                                                    { value: 'deleted' },
	                                                                    'Deleted'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { style: alertStyle },
	                                                                this.state.errors.menu_current_status
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Select page'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'select',
	                                                                { className: 'form-control', name: 'menu_url', value: this.state.fields.menu_url, onChange: this.handleChange },
	                                                                _react2.default.createElement(
	                                                                    'option',
	                                                                    { value: '' },
	                                                                    'Select Page '
	                                                                ),
	                                                                this.state.staticpages.length > 0 ? this.state.staticpages.map(function (cpage, index) {
	                                                                    return _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: cpage.id },
	                                                                        cpage.title
	                                                                    );
	                                                                }) : _react2.default.createElement(
	                                                                    'option',
	                                                                    { value: '' },
	                                                                    'Select Page'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { style: alertStyle },
	                                                                this.state.errors.menu_url
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { type: 'submit', className: 'btn btn-pink waves-effect waves-light' },
	                                                            'Submit'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	            );
	        }
	    }]);
	
	    return addmenu;
	}(_react.Component);
	
	exports.default = addmenu;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import Footer from '../../component/admin/Footer';
	//import CKEditor from "react-ckeditor-component";
	
	
	var savenewsevents = function savenewsevents(data, news_events_desc, imageData) {
	  var formdata = new FormData();
	  formdata.append("news_events_desc", news_events_desc);
	  formdata.append("news_events_pic", imageData);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = formdata.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var value = _step.value;
	
	      console.log(value);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/newsevents/savenewsevents", formdata, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllDepartments = function getAllDepartments() {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var alertStyle = {
	  color: "red"
	};
	
	var AddNewsEvent = function (_Component) {
	  _inherits(AddNewsEvent, _Component);
	
	  function AddNewsEvent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddNewsEvent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddNewsEvent.__proto__ || Object.getPrototypeOf(AddNewsEvent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      departments: [],
	      type: "",
	      news_events_title: "",
	      news_events_desc: "",
	      news_events_pic: "",
	      news_events_date: "", // New state for event date
	      news_events_tag: "" // New state for department
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.DescQuillHandleChange = function (name, val) {
	      _this.setState({
	        news_events_desc: val
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm()) {
	        var fields = {};
	        fields["news_events_title"] = "";
	        _this.setState({ fields: fields });
	        var data = {
	          news_events_title: _this.state.fields.news_events_title,
	          news_events_date: _this.state.news_events_date,
	          news_events_tag: _this.state.news_events_tag,
	          type: _this.state.type
	          //news_events_desc: this.state.news_events_desc,
	        };
	        savenewsevents(data, _this.state.news_events_desc, _this.state.news_events_pic).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          // setTimeout(function(){
	          //     window.location.href = '/newsevents';
	          // }, 3000);
	        }).catch(function (err) {
	          _reactToastify.toast.error("Error occured", {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide blank field!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshDepartments = function () {
	      getAllDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          // var records = res.data.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddNewsEvent, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.news_events_date) {
	        formIsValid = false;
	        errors["news_events_date"] = "*Please enter the event date.";
	      }
	      if (!fields["news_events_title"]) {
	        formIsValid = false;
	        errors["news_events_title"] = "*Please enter the name.";
	      }
	      if (!this.state.news_events_tag) {
	        formIsValid = false;
	        errors["news_events_tag"] = "*Please select a department.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onFileChange",
	
	    /*onChangeDescOne = (evt) =>{
	          //console.log("onChange fired with event info: ", evt);
	          var newContent = evt.editor.getData();
	          this.setState({
	              news_events_desc: newContent,
	          })
	      }*/
	
	    value: function onFileChange(file) {
	      // alert(file[0]);
	      // console.log(file[0]);
	      this.setState({
	        news_events_pic: file[0]
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshDepartments();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Add News Event"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "adddepartmentform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-4" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Type"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                { value: this.state.type, className: "form-control", name: "type",
	                                  onChange: this.handleChange },
	                                _react2.default.createElement(
	                                  "option",
	                                  { defaultValue: true },
	                                  "Select Any"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "News" },
	                                  "News"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "Events" },
	                                  "Events"
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-4" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Event Date"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "date",
	                                className: "form-control",
	                                name: "news_events_date",
	                                id: "news_events_date",
	                                value: this.state.news_events_date,
	                                onChange: this.handleChange,
	                                required: true
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.news_events_date
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Title"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "news_events_title",
	                                id: "news_events_title",
	                                value: this.state.fields.news_events_title,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Title"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.news_events_title
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Description"
	                              ),
	                              _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                id: "adddescnewseditor",
	                                name: "adddescnewseditor",
	                                value: this.state.news_events_desc,
	                                onChange: function onChange(name, val) {
	                                  _this2.DescQuillHandleChange(name, val);
	                                }
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Image"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "news_events_pic",
	                                id: "news_events_pic",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  name: "news_events_tag",
	                                  id: "news_events_tag",
	                                  value: this.state.news_events_tag,
	                                  onChange: this.handleChange,
	                                  required: true
	                                },
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "" },
	                                  "Select Department"
	                                ),
	                                this.state.departments.map(function (department) {
	                                  return _react2.default.createElement(
	                                    "option",
	                                    {
	                                      key: department.id,
	                                      value: department.department_name
	                                    },
	                                    department.department_name
	                                  );
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.news_events_tag
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Submit"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return AddNewsEvent;
	}(_react.Component);
	
	exports.default = AddNewsEvent;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var savePackage = function savePackage(data, package_desc, imageData, imageBannerData) {
	  var formdata = new FormData();
	  formdata.append("package_desc", package_desc);
	  formdata.append("package_profile", imageData);
	  formdata.append("package_banner_image", imageBannerData);
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/packages/createpackage", formdata, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllDepartments = function getAllDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllPreExistingConditon = function getAllPreExistingConditon(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/packages/getallprecondtion", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var addpackage = function (_Component) {
	  _inherits(addpackage, _Component);
	
	  function addpackage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, addpackage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = addpackage.__proto__ || Object.getPrototypeOf(addpackage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      departments: [],
	      pre_existing_conditon: [],
	      package_name: "",
	      package_fees: "",
	      package_gender: "",
	      opd_amount: "",
	      ipd_amount: "",
	      package_department: "",
	      package_pre_condition: "",
	      package_profile: "",
	      package_banner_image: "",
	      package_desc: "",
	      package_age: "",
	      package_: "",
	      editorLoaded: false,
	      data: ""
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.DescReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        package_desc: val
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        var data = {
	          package_name: _this.state.package_name,
	          package_fees: _this.state.package_fees,
	          ipd_amount: _this.state.ipd_amount,
	          opd_amount: _this.state.opd_amount,
	          package_department: _this.state.package_department,
	          package_pre_condition: _this.state.package_pre_condition,
	          package_age: _this.state.package_age,
	          package_gender: _this.state.package_gender
	        };
	        savePackage(data, _this.state.package_desc, _this.state.package_profile, _this.state.package_banner_image).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          // setTimeout(function(){
	          //     window.location.href = '/admin/packages';
	          // }, 6000);
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshDepartments = function (event) {
	      getAllDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshPreExistingConditon = function (event) {
	      getAllPreExistingConditon().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ pre_existing_conditon: records });
	        } else {
	          _this.setState({ pre_existing_conditon: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(addpackage, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.package_name) {
	        formIsValid = false;
	        errors["package_name"] = "*Please enter the package name.";
	      }
	      if (!this.state.opd_amount) {
	        formIsValid = false;
	        errors["opd_amount"] = "*Please enter the package amount.";
	      }
	      if (!this.state.ipd_amount) {
	        formIsValid = false;
	        errors["ipd_amount"] = "*Please enter the package amount.";
	      }
	      if (!this.state.package_department) {
	        formIsValid = false;
	        errors["package_department"] = "*Please enter your package department.";
	      }
	      if (!this.state.package_pre_condition) {
	        formIsValid = false;
	        errors["package_pre_condition"] = "*Please enter your package pre condition.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(evt) {
	      console.log("onBlur event called with event info: ", evt);
	    }
	  }, {
	    key: "afterPaste",
	    value: function afterPaste(evt) {
	      console.log("afterPaste event called with event info: ", evt);
	    }
	  }, {
	    key: "onFileChange",
	    value: function onFileChange(file) {
	      this.setState({
	        package_profile: file[0]
	      });
	    }
	  }, {
	    key: "onBannerFileChange",
	    value: function onBannerFileChange(file) {
	      this.setState({
	        package_banner_image: file[0]
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({ editorLoaded: true });
	      this.refreshDepartments();
	      this.refreshPreExistingConditon();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Add Package"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "package_name",
	                                id: "package_name",
	                                value: this.state.package_name,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Package Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.package_name
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-3" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "OPD Amount"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "number",
	                                className: "form-control",
	                                name: "opd_amount",
	                                id: "opd_amount",
	                                value: this.state.opd_amount,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "OPD Amount"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.opd_amount
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-3" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "IPD Amount"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "number",
	                                className: "form-control",
	                                name: "ipd_amount",
	                                id: "ipd_amount",
	                                value: this.state.ipd_amount,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "IPD Amount"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.ipd_amount
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Department"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  value: this.state.package_department,
	                                  name: "package_department",
	                                  onChange: this.handleChange
	                                },
	                                this.state.departments.length > 0 ? this.state.departments.map(function (department, index) {
	                                  return _react2.default.createElement(
	                                    "option",
	                                    {
	                                      key: department.id,
	                                      value: department.dept_id
	                                    },
	                                    department.department_name
	                                  );
	                                }) : _react2.default.createElement(
	                                  "option",
	                                  { value: "" },
	                                  "Select Department"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.package_department
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Pre Condition"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  value: this.state.package_pre_condition,
	                                  name: "package_pre_condition",
	                                  onChange: this.handleChange
	                                },
	                                this.state.pre_existing_conditon.length > 0 ? this.state.pre_existing_conditon.map(function (pre_existing_conditons, index) {
	                                  return _react2.default.createElement(
	                                    "option",
	                                    {
	                                      key: pre_existing_conditons.id,
	                                      value: pre_existing_conditons.id
	                                    },
	                                    pre_existing_conditons.name
	                                  );
	                                }) : _react2.default.createElement(
	                                  "option",
	                                  { value: "" },
	                                  "Select Pre Condition"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.package_pre_condition
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Age"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  value: this.state.package_age,
	                                  name: "package_age",
	                                  onChange: this.handleChange,
	                                  required: true
	                                },
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "0-12" },
	                                  "Child (0-12)"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "13-19" },
	                                  "Teenage (13-19)"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "20-45" },
	                                  "Adult (20-45)"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "0-35" },
	                                  "Below 35"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "35+" },
	                                  "Above 35"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "0-45" },
	                                  "Below 45"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "45+" },
	                                  "Senior (45+)"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "All" },
	                                  "All"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.package_age
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Gender"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  value: this.state.package_gender,
	                                  name: "package_gender",
	                                  onChange: this.handleChange
	                                },
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "Male" },
	                                  "Male"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "Female" },
	                                  "Female"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "other" },
	                                  "Other"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.gender
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Description"
	                              ),
	                              _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                id: "desceditor",
	                                name: "desceditor",
	                                value: this.state.package_desc,
	                                onChange: function onChange(name, val) {
	                                  _this2.DescReactQuillHandleChange(name, val);
	                                }
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Profile"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "package_profile",
	                                id: "package_profile",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png",
	                                placeholder: "Doctor Fees"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Banner Image"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "package_banner_image",
	                                id: "package_banner_image",
	                                onChange: function onChange(event) {
	                                  return _this2.onBannerFileChange(event.target.files);
	                                },
	                                accept: "jpg,png",
	                                placeholder: "Doctor Fees"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Submit"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return addpackage;
	}(_react.Component);
	
	exports.default = addpackage;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _reactVirtualizedSelect = __webpack_require__(78);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	__webpack_require__(73);
	
	__webpack_require__(75);
	
	__webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import Footer from '../../component/admin/Footer';
	//import CKEditor from "react-ckeditor-component";
	
	
	var savepublication = function savepublication(data, publications_desc, imageData) {
	  var formdata = new FormData();
	  formdata.append("publications_desc", publications_desc);
	  formdata.append("publications_pic", imageData);
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/publications/savepublications", formdata, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var getAllDoctor = function getAllDoctor(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/publications/getdoctors", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var alertStyle = {
	  color: "red"
	};
	
	var AddPublications = function (_Component) {
	  _inherits(AddPublications, _Component);
	
	  function AddPublications() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddPublications);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddPublications.__proto__ || Object.getPrototypeOf(AddPublications)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      doctors: [],
	      doctor_id: null,
	      publications_title: "",
	      publications_desc: "",
	      publications_pic: ""
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      _this.setState({ fields: fields });
	    }, _this.DescQuillHandleChange = function (name, val) {
	      _this.setState({
	        publications_desc: val
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm()) {
	        var fields = {};
	        fields["publications_title"] = "";
	        _this.setState({ fields: fields });
	        var data = {
	          publications_title: _this.state.fields.publications_title,
	          //publications_desc: this.state.publications_desc,
	          doctor_id: _this.state.doctor_id
	        };
	        console.log(data);
	        savepublication(data, _this.state.publications_desc, _this.state.publications_pic).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            // window.location.href = "/admin/publications";
	          }, 3000);
	        }).catch(function (err) {
	          _reactToastify.toast.error("Error occured", {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide publications name!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshDoctor = function () {
	      getAllDoctor().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ doctors: records });
	        } else {
	          _this.setState({ doctors: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddPublications, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!fields["publications_title"]) {
	        formIsValid = false;
	        errors["publications_title"] = "*Please enter the name.";
	      }
	      if (this.state.doctor_id == null) {
	        formIsValid = false;
	        errors["doctor_id"] = "*Please select doctor.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onFileChange",
	
	    /*onChangeDescOne = (evt) =>{
	          //console.log("onChange fired with event info: ", evt);
	          var newContent = evt.editor.getData();
	          this.setState({
	              publications_desc: newContent,
	          })
	      }*/
	
	    value: function onFileChange(file) {
	      // alert(file[0]);
	      // console.log(file[0]);
	      this.setState({
	        publications_pic: file[0]
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshDoctor();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Add Publication"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "adddepartmentform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "publications_title",
	                                id: "publications_title",
	                                value: this.state.fields.publications_title || "",
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.publications_title
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Name"
	                              ),
	                              _react2.default.createElement(_reactVirtualizedSelect2.default, {
	                                id: "doctor_id",
	                                name: "doctor_id",
	                                className: "form-control custom_select_search",
	                                placeholder: "Select Doctor",
	                                options: this.state.doctors.map(function (item, index) {
	                                  return {
	                                    label: item.doctor_name,
	                                    value: item.id
	                                  };
	                                }),
	                                value: this.state.doctor_id,
	                                onChange: function onChange(selectValue) {
	                                  return _this2.setState({
	                                    doctor_id: selectValue.value
	                                  });
	                                },
	                                required: true
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.doctor_id
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Description"
	                              ),
	                              _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                id: "adddescpubeditor",
	                                name: "adddescpubeditor",
	                                value: this.state.publications_desc,
	                                onChange: function onChange(name, val) {
	                                  _this2.DescQuillHandleChange(name, val);
	                                }
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Image"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "publications_pic",
	                                id: "publications_pic",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Submit"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return AddPublications;
	}(_react.Component);
	
	exports.default = AddPublications;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var savestaticpage = function savestaticpage(data, page_desc, imageData) {
	  var formdata = new FormData();
	  formdata.append("page_desc", page_desc);
	  formdata.append("banner_img", imageData);
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/staticpages/createstaticpage", formdata, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var addstaticpage = function (_Component) {
	  _inherits(addstaticpage, _Component);
	
	  function addstaticpage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, addstaticpage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = addstaticpage.__proto__ || Object.getPrototypeOf(addstaticpage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      page_title: "",
	      banner_img: "",
	      page_desc: "",
	      editorLoaded: false,
	      data: ""
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.DescReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        page_desc: val
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        var data = {
	          page_title: _this.state.page_title
	        };
	        savestaticpage(data, _this.state.page_desc, _this.state.banner_img).then(function (res) {
	          if (res.status === "ok") {
	            _reactToastify.toast.success(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	            setTimeout(function () {
	              window.location.href = "/staticpages";
	            }, 6000);
	          } else if (res.status === "notok") {
	            _reactToastify.toast.error(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          } else if (res.status === "title_error") {
	            _reactToastify.toast.error(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          }
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(addstaticpage, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.page_title) {
	        formIsValid = false;
	        errors["page_title"] = "*Please enter the page title.";
	      }
	      if (!this.state.page_desc) {
	        formIsValid = false;
	        errors["page_desc"] = "*Please enter the page description.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(evt) {
	      console.log("onBlur event called with event info: ", evt);
	    }
	  }, {
	    key: "afterPaste",
	    value: function afterPaste(evt) {
	      console.log("afterPaste event called with event info: ", evt);
	    }
	  }, {
	    key: "onFileChange",
	    value: function onFileChange(file) {
	      this.setState({
	        banner_img: file[0]
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({ editorLoaded: true });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Add Static Page"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Page title"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "page_title",
	                                id: "page_title",
	                                value: this.state.page_title,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Page title"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.page_title
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Page Description"
	                              ),
	                              _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                id: "desceditor",
	                                name: "desceditor",
	                                value: this.state.page_desc,
	                                onChange: function onChange(name, val) {
	                                  _this2.DescReactQuillHandleChange(name, val);
	                                }
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Banner Image"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "banner_img",
	                                id: "banner_img",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png",
	                                placeholder: "Doctor Fees"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Submit"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return addstaticpage;
	}(_react.Component);
	
	exports.default = addstaticpage;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	//import Footer from '../../component/admin/Footer';
	//import CKEditor from "react-ckeditor-component";
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _ = __webpack_require__(2);
	
	var _reactVirtualizedSelect = __webpack_require__(78);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	__webpack_require__(73);
	
	__webpack_require__(75);
	
	__webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var addtestimonial = function addtestimonial() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      data = _useState2[0],
	      setData = _useState2[1];
	  // console.log(data, "data");
	
	
	  var _useState3 = (0, _react.useState)({
	    testimonial_title: "",
	    author_name: "",
	    doctor_id: "",
	    rating: "",
	    status: 1,
	    testimonial_desc: "",
	    author_profile_pic: null
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      formData = _useState4[0],
	      setFormData = _useState4[1];
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	    if (name === "doctor_id") {
	      // Check if the select element is for doctor_id
	      setFormData(Object.assign({}, formData, {
	        doctor_id: value
	      }));
	    } else {
	      setFormData(Object.assign({}, formData, _defineProperty({}, name, value)));
	    }
	  };
	
	  var handleFileChange = function handleFileChange(e) {
	    var file = e.target.files[0];
	
	    // Check if a file was selected
	    if (file) {
	      // Update the formData state by setting the author_profile_pic to the selected file
	      setFormData(Object.assign({}, formData, {
	        author_profile_pic: file
	      }));
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _.scAxiosAdmin)("/doctors/getdoctors");
	
	              case 3:
	                response = _context.sent;
	
	                setData(response.data.data);
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0);
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 7]]);
	      }));
	
	      return function fetchData() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	  var handleSubmit = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              e.preventDefault();
	              // Here you can use formData to submit the form or perform other actions
	              console.log(formData, "hellos");
	              // Example: You can send formData to an API or perform any necessary operations.
	              _context2.prev = 2;
	              _context2.next = 5;
	              return _.thirdparty.post("/testimonials", formData, {
	                // You might need to set headers or other configurations here
	                headers: {
	                  "Content-Type": "multipart/form-data"
	                }
	              });
	
	            case 5:
	              response = _context2.sent;
	
	              if (response.status == "201") {
	                _reactToastify.toast.success("Add Testimonial successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	              }
	              console.log("Form data sent:", response.status);
	              // Perform actions after successful form submission, e.g., show success message, redirect, etc.
	              _context2.next = 13;
	              break;
	
	            case 10:
	              _context2.prev = 10;
	              _context2.t0 = _context2["catch"](2);
	
	              console.error("Error submitting form:", _context2.t0);
	              // Handle errors, show error messages, etc.
	
	            case 13:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[2, 10]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(_Seo2.default, {
	      title: "Add Testimonials",
	      description: "Add Testimonials United Hospital",
	      pathSlug: "/addtestimonial",
	      keywords: "Add Testimonials, Testimonials"
	    }),
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      id: "adddepartmentform",
	                      className: "needs-validation",
	                      noValidate: true,
	                      onSubmit: handleSubmit
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Testimonial Title"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "testimonial_title",
	                            id: "testimonial_title",
	                            value: formData.testimonial_title,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Testimonial Title"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Author Name"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "author_name",
	                            id: "Author Name",
	                            value: formData.author_name,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Author Name"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Doctors Name"
	                          ),
	                          _react2.default.createElement(_reactVirtualizedSelect2.default, {
	                            id: "author_id",
	                            name: "doctor_id",
	                            className: "form-control custom_select_search",
	                            placeholder: "Select Doctor",
	                            options: data.map(function (item, index) {
	                              return {
	                                label: item.doctor_name,
	                                value: item.id
	                              };
	                            }),
	                            value: formData.doctor_id,
	                            onChange: function onChange(selectValue) {
	                              return setFormData(Object.assign({}, formData, {
	                                doctor_id: selectValue.value
	                              }));
	                            }
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            { className: "mb-0" },
	                            "Testimonial Rating"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "small",
	                            { className: "form-text text-muted font-italic" },
	                            "Range: 0-5; 0 = Lowest ; 5 = Highest"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "number",
	                            className: "form-control",
	                            name: "rating",
	                            id: "rating",
	                            value: formData.rating,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Rating",
	                            min: "0",
	                            max: "5"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Testimonial Description"
	                          ),
	                          _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                            id: "adddesctestieditor",
	                            name: "testimonial_desc",
	                            onChange: function onChange(name, val) {
	                              return setFormData(Object.assign({}, formData, _defineProperty({}, name, val)));
	                            },
	                            value: formData.testimonial_desc
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Testimonial Author Image"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "file",
	                            className: "form-control",
	                            name: "author_profile_pic",
	                            id: "author_profile_pic",
	                            onChange: handleFileChange,
	                            accept: "image/*" // Specify the accepted file types if needed
	                            , placeholder: "Doctor Profile Pic"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "submit",
	                            className: "btn btn-pink waves-effect waves-light"
	                          },
	                          "Submit"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = addtestimonial;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(92);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var adminRolePermission = function adminRolePermission(props) {
	  // console.log("role_id", props.match.params.id);
	  var _useState = (0, _react.useState)({
	    role_name: "",
	    permission: [],
	    status: 1
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchData = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      loading = _useState4[0],
	      setLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      responseData = _useState6[0],
	      setResponseData = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      error = _useState8[0],
	      setError = _useState8[1];
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	    setFatchdata(Object.assign({}, fatchData, _defineProperty({}, name, value)));
	  };
	
	  var handleCheckboxChange = function handleCheckboxChange(event) {
	    var _event$target = event.target,
	        id = _event$target.id,
	        checked = _event$target.checked;
	
	    var permission_list = fatchData.permission;
	    console.log(id, checked);
	    if (checked) {
	      // If the checkbox is checked (true), add the id to the state array
	      permission_list.push(id);
	    } else {
	      // If the checkbox is unchecked (false), remove the id from the state array
	      permission_list = permission_list.filter(function (item) {
	        return item !== id;
	      });
	    }
	
	    setFatchdata(function (prev) {
	      return Object.assign({}, prev, {
	        permission: permission_list
	      });
	    });
	  };
	
	  var handleSubmit = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(event) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              event.preventDefault();
	              setError(null);
	              _context.prev = 2;
	              _context.next = 5;
	              return _.scAxiosAdmin.put("/roles/" + props.match.params.id, fatchData, {
	                method: "put",
	                headers: {
	                  Accept: "application/json",
	                  "Content-Type": "application/json",
	                  Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                }
	              });
	
	            case 5:
	              response = _context.sent;
	
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Permission updated successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	              }
	              _context.next = 13;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context["catch"](2);
	
	              setError(_context.t0);
	              setLoading(false);
	
	            case 13:
	              _context.prev = 13;
	
	              setLoading(false);
	              return _context.finish(13);
	
	            case 16:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 9, 13, 16]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var fetchData = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return _.thirdparty.get("/roles/" + props.match.params.id);
	
	            case 3:
	              response = _context2.sent;
	
	              if (response.status == 200) {
	                setFatchdata.apply(undefined, _toConsumableArray(fetchData).concat([{
	                  role_name: response.data.role_name,
	                  permission: response.data.permission || [],
	                  status: response.data.status
	                }]));
	              }
	              _context2.next = 10;
	              break;
	
	            case 7:
	              _context2.prev = 7;
	              _context2.t0 = _context2["catch"](0);
	
	              console.error("Error fetching data:", _context2.t0);
	
	            case 10:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var fetchPermission = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var response;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              _context3.next = 3;
	              return _.scAxiosAdmin.request("/role-permission/get-permission-data", {
	                method: "get",
	                headers: {
	                  Accept: "application/json",
	                  Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                },
	                params: {
	                  // ...data
	                }
	              });
	
	            case 3:
	              response = _context3.sent;
	
	              setResponseData(response.data);
	              setLoading(false);
	              _context3.next = 12;
	              break;
	
	            case 8:
	              _context3.prev = 8;
	              _context3.t0 = _context3["catch"](0);
	
	              console.error("Error fetching data:", _context3.t0);
	              setLoading(false);
	
	            case 12:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[0, 8]]);
	    }));
	
	    return function fetchPermission() {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    fetchData();
	    fetchPermission();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper pl-4 pl-4" },
	            responseData && _react2.default.createElement(
	              "form",
	              { noValidate: true, onSubmit: handleSubmit },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-12 mb-4  d-flex justify-content-between align-items-center" },
	                  _react2.default.createElement(
	                    "h5",
	                    null,
	                    "Role-Permission Setting"
	                  ),
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "/admin/role-manager",
	                      className: "btn btn-sm waves-effect waves-light"
	                    },
	                    "User Roles"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-4" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group" },
	                        _react2.default.createElement(
	                          "label",
	                          null,
	                          "Role Title"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          id: "role_name",
	                          name: "role_name",
	                          value: fatchData.role_name,
	                          onChange: handleChange,
	                          className: "form-control",
	                          placeholder: "Serial Number",
	                          required: true
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-4" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group" },
	                        _react2.default.createElement(
	                          "label",
	                          null,
	                          "Status"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-control",
	                            name: "status",
	                            id: "author_id",
	                            value: fatchData.status,
	                            onChange: handleChange
	                          },
	                          _react2.default.createElement(
	                            "option",
	                            { value: "1", key: "1" },
	                            "Active"
	                          ),
	                          _react2.default.createElement(
	                            "option",
	                            { value: "0", key: "0" },
	                            "Inactive"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: " row row-cols-1 row-cols-md-2 row-cols-lg-3" },
	                    Object.entries(responseData).map(function (_ref4) {
	                      var _ref5 = _slicedToArray(_ref4, 2),
	                          groupName = _ref5[0],
	                          groupPermissions = _ref5[1];
	
	                      return _react2.default.createElement(
	                        "div",
	                        { key: groupName },
	                        _react2.default.createElement(
	                          "h3",
	                          null,
	                          groupName
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          groupPermissions.map(function (permission) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "form-check",
	                                key: permission.id
	                              },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                id: "" + permission.slug,
	                                checked: fatchData.permission && fatchData.permission.includes("" + permission.slug) || false,
	                                onChange: handleCheckboxChange
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  htmlFor: "" + permission.slug
	                                },
	                                permission.permission_name
	                              )
	                            );
	                          })
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 text-right" },
	                      _react2.default.createElement(
	                        "button",
	                        { type: "submit", className: "btn btn-primary" },
	                        "Submit"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = adminRolePermission;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminDashboard = function (_Component) {
	  _inherits(AdminDashboard, _Component);
	
	  function AdminDashboard() {
	    _classCallCheck(this, AdminDashboard);
	
	    return _possibleConstructorReturn(this, (AdminDashboard.__proto__ || Object.getPrototypeOf(AdminDashboard)).apply(this, arguments));
	  }
	
	  _createClass(AdminDashboard, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "header-bg" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "container-fluid" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "col-12 mt-5 mb-4 pt-5 text-center",
	                          style: { height: "65vh" }
	                        },
	                        _react2.default.createElement(
	                          "h2",
	                          null,
	                          "Welcome to the Dashboard !!!"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminDashboard;
	}(_react.Component);
	
	exports.default = AdminDashboard;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import 'react-toastify/dist/ReactToastify.css';
	
	//import Footer from '../../component/admin/Footer';
	//import Moment from 'moment';
	
	
	var getAllAlbums = function getAllAlbums(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/album/listalbum", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	// const getSearchDoctors = (data) => {
	//     return new Promise((resolve, reject) => {
	//         const req = scAxiosAdmin.request('/albums/adminsearchdoctors', {
	//             method: 'get',
	//             headers: {
	//                 'Accept': 'application/json',
	//                 'Authorization': 'Bearer ' + localStorage.getItem(API_TOKEN_NAME)
	//             },
	//             params: {
	//                 ...data
	//             }
	//         });
	//         req.then(res => resolve(res.data))
	//             .catch(err => reject(err));
	//     });
	// }
	// const deleteDoctor = (data) => {
	// 	return new Promise((resolve, reject) => {
	// 		const req = scAxiosAdmin.request('/doctors/deletedoctor', {
	// 			method: 'post',
	// 			headers: {
	// 				'Accept': 'application/json',
	// 				'Authorization': 'Bearer ' + localStorage.getItem(API_TOKEN_NAME)
	// 			},
	// 			params: {
	// 				...data
	// 			}
	// 		});
	// 		req.then(res => resolve(res.data))
	// 			.catch(err => reject(err));
	// 	});
	//   }
	
	var Albums = function (_Component) {
	  _inherits(Albums, _Component);
	
	  function Albums() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Albums);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Albums.__proto__ || Object.getPrototypeOf(Albums)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      album: [],
	      total: "",
	      currentPage: "",
	      LastPage: "",
	      PerPage: "",
	      FirstPageUrl: "",
	      NextPageUrl: "",
	      PrevPageUrl: "",
	      LastPageUrl: "",
	      TotalPages: "",
	      activePage: 1,
	      album_id: "",
	      enableShdo: false,
	      enableShdoLive: false,
	      search_keywords: ""
	    }, _this.handleChange = function (events) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshAlbum = function (page) {
	      _this.setState({ enableShdo: true });
	      var data = {
	        page: page
	      };
	      getAllAlbums(data).then(function (res) {
	        console.log(res.data);
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ album: records });
	          _this.setState({ total: res.data.total });
	          _this.setState({ currentPage: res.data.current_page });
	          _this.setState({ PerPage: res.data.per_page });
	          _this.setState({ FirstPageUrl: res.data.first_page_url });
	          _this.setState({ NextPageUrl: res.data.next_page_url });
	          _this.setState({ PrevPageUrl: res.data.prev_page_url });
	          _this.setState({ LastPageUrl: res.data.last_page_url });
	          _this.setState({ LastPage: res.data.last_page });
	          _this.setState({
	            TotalPages: Math.ceil(_this.state.total / _this.state.PerPage)
	          });
	        } else {
	          _this.setState({ album: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Albums, [{
	    key: "handlePageChange",
	    value: function handlePageChange(pageNumber) {
	      this.setState({ activePage: pageNumber });
	      this.refreshAlbum(pageNumber);
	    }
	    // modalDeleteConfirmOpen(e, id) {
	    //     this.setState({
	    //         modalDeleteConfirm: true,
	    //         album_id: id,
	    //     });
	    // }
	    // modalDeleteConfirmClose() {
	    //     this.setState({
	    //         modalDeleteConfirm: false
	    //     });
	    // }
	    // modalDeleteDoctor(id) {
	    //     /*this.setState({
	    //       selectedPost: i,
	    //     });*/
	    //     this.setState({
	    //         modalDeleteConfirm: false
	    //     });
	    //     const data = {
	    //         albums_id: id
	    //     }
	    //     deleteAlbum(data)
	    //         .then(res => {
	    //             if (res.status === true) {
	    //                 toast.success(res.message, {
	    //                     position: toast.POSITION.TOP_RIGHT
	    //                 });
	    //                 setTimeout(function () {
	    //                     window.location.href = '/album';
	    //                 }, 6000);
	    //             } else {
	    //                 toast.error(res.message, {
	    //                     position: toast.POSITION.BOTTOM_RIGHT
	    //                 });
	    //             }
	    //             //window.location='/departments';
	    //         })
	    //         .catch(err => {
	    //             console.log(err);
	    //         });
	    // }
	
	  }, {
	    key: "componentDidMount",
	
	
	    // SearchAlbum = (e) => {
	    //     const data = {
	    //         keywords: this.state.search_keywords
	    //     }
	    //     getSearchAlbum(data)
	    //         .then(res => {
	    //             if (res.status === true) {
	    //                 var records = res.data.data;
	    //                 this.setState({ album: records });
	    //                 this.setState({ total: res.data.total });
	    //                 this.setState({ currentPage: res.data.current_page });
	    //                 this.setState({ PerPage: res.data.per_page });
	    //                 this.setState({ FirstPageUrl: res.data.first_page_url });
	    //                 this.setState({ NextPageUrl: res.data.next_page_url });
	    //                 this.setState({ PrevPageUrl: res.data.prev_page_url });
	    //                 this.setState({ LastPageUrl: res.data.last_page_url });
	    //                 this.setState({ LastPage: res.data.last_page });
	    //                 this.setState({ TotalPages: Math.ceil(this.state.total / this.state.PerPage) });
	    //             } else {
	    //                 this.setState({ album: '' });
	    //             }
	    //         })
	    //         .catch(err => {
	    //             console.log(err);
	    //         });
	    // }
	
	    value: function componentDidMount() {
	      this.refreshAlbum();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      //const currentPage = this.state.currentPage;
	      //const previousPage = currentPage - 1;
	      //const NextPage = currentPage + 1;
	      //const LastPage = this.state.LastPage;
	      var pageNumbers = [];
	      for (var i = 1; i <= this.state.TotalPages; i++) {
	        pageNumbers.push(i);
	      }
	      var handleDelete = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(id) {
	          var confirmation, response;
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  confirmation = confirm("Are you sure to delete this item?");
	
	                  if (confirmation) {
	                    _context.next = 3;
	                    break;
	                  }
	
	                  return _context.abrupt("return");
	
	                case 3:
	                  _context.prev = 3;
	                  _context.next = 6;
	                  return _.thirdparty.delete("/album/delete/" + id);
	
	                case 6:
	                  response = _context.sent;
	                  // Update the API endpoint
	
	                  if (response.status === 200) {
	                    _this2.refreshAlbum();
	                    _reactToastify.toast.success("Data Deleted successfully!", {
	                      position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                      autoClose: 3000
	                    });
	                  }
	                  _context.next = 13;
	                  break;
	
	                case 10:
	                  _context.prev = 10;
	                  _context.t0 = _context["catch"](3);
	
	                  console.error("Error deleting item with ID " + id + ":", _context.t0.message);
	
	                case 13:
	                case "end":
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2, [[3, 10]]);
	        }));
	
	        return function handleDelete(_x) {
	          return _ref2.apply(this, arguments);
	        };
	      }();
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "row page-content-wrapper" },
	                _react2.default.createElement("div", { className: "col-sm-7" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-3 text-right" },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control",
	                    name: "search_keywords",
	                    id: "search_keywords",
	                    placeholder: "Search"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-2 mb-4 text-right" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "/addAlbum",
	                      className: "btn btn-sm btn-primary waves-effect waves-light"
	                    },
	                    "Add Album"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "section",
	                        { className: "view-page" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "container" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "view-page-box" },
	                            _react2.default.createElement("hr", null),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              this.state.album && this.state.album.length > 0 ? this.state.album.map(function (album) {
	                                return _react2.default.createElement(
	                                  "div",
	                                  { className: "col-lg-4", key: album.id },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "news-part-event" },
	                                    _react2.default.createElement("img", {
	                                      src: _constants.IMAGE_URL + "/AlbumImg/" + album.album_pics,
	                                      alt: "",
	                                      width: "100%"
	                                    }),
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "newdata position-relative" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "row" },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "col-lg-10" },
	                                          _react2.default.createElement(
	                                            "h3",
	                                            {
	                                              className: "d-inline",
	                                              style: { fontSize: "18px" },
	                                              title: album.album_name
	                                            },
	                                            album.album_name ? album.album_name : ""
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        "h5",
	                                        { className: "float-end position-absolute mt-2 top-0 end-0" },
	                                        _react2.default.createElement(
	                                          "a",
	                                          { href: "/editalbum/" + album.id },
	                                          _react2.default.createElement("i", { className: "fa fa-pencil-square mx-2 display-4" })
	                                        ),
	                                        _react2.default.createElement(
	                                          "a",
	                                          { href: "/editalbum/" + album.id },
	                                          _react2.default.createElement("i", { className: "fa fa-eye" })
	                                        ),
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            onClick: function onClick() {
	                                              return handleDelete(album.id);
	                                            }
	                                          },
	                                          _react2.default.createElement("i", { className: "fa fa-trash" })
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement("p", {
	                                      dangerouslySetInnerHTML: {
	                                        __html: album.album_desc ? album.album_desc.substr(0, 170) : ""
	                                      }
	                                    })
	                                  )
	                                );
	                              }) : _react2.default.createElement(
	                                "div",
	                                {
	                                  colSpan: "6",
	                                  className: "font_12 txt_col fontweight400 ",
	                                  style: { textAlign: "center" }
	                                },
	                                " ",
	                                "There are currently no News Events."
	                              )
	                            ),
	                            _react2.default.createElement("br", null)
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return Albums;
	}(_react.Component);
	
	exports.default = Albums;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import Pagination from "react-js-pagination";
	
	
	var getAllBannerButtonLinkData = function getAllBannerButtonLinkData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bannerbutton/getallbannerbtndata", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	/*const getSearchBannerButtonLink = (data) => {
		return new Promise((resolve, reject) => {
			const req = scAxiosAdmin.request('/bannerbutton/adminsearchbannerbtnlink', {
				method: 'get',
				headers: {
					'Accept': 'application/json',
					'Authorization': 'Bearer ' + localStorage.getItem(API_TOKEN_NAME)
				},
				params: {
					...data
				}
			});
			req.then(res => resolve(res.data))
				.catch(err => reject(err));
		});
	}*/
	var deleteBannerButtonLink = function deleteBannerButtonLink(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bannerbutton/deletebannerbtnlink", {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var BannerButtonLink = function (_Component) {
	  _inherits(BannerButtonLink, _Component);
	
	  function BannerButtonLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BannerButtonLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BannerButtonLink.__proto__ || Object.getPrototypeOf(BannerButtonLink)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      bannerbtnlink: [],
	      total: "",
	      currentPage: "",
	      LastPage: "",
	      PerPage: "",
	      FirstPageUrl: "",
	      NextPageUrl: "",
	      PrevPageUrl: "",
	      LastPageUrl: "",
	      TotalPages: "",
	      activePage: 1,
	      bannerbtnlink_id: "",
	      search_keywords: "",
	      modalDeleteConfirm: false
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshBannerButtonLink = function (page) {
	      _this.setState({ enableShdo: true });
	      var data = {
	        page: page
	      };
	      getAllBannerButtonLinkData(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ bannerbtnlink: records });
	          /*this.setState({ total: res.data.total });
	          this.setState({ currentPage: res.data.current_page });
	          this.setState({ PerPage: res.data.per_page });
	          this.setState({ FirstPageUrl: res.data.first_page_url });
	          this.setState({ NextPageUrl: res.data.next_page_url });
	          this.setState({ PrevPageUrl: res.data.prev_page_url });
	          this.setState({ LastPageUrl: res.data.last_page_url });
	          this.setState({ LastPage: res.data.last_page });
	          this.setState({ TotalPages: Math.ceil(this.state.total / this.state.PerPage) });*/
	        } else {
	          _this.setState({ bannerbtnlink: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshBannerButtonLink = function (page) {
	      _this.setState({ enableShdo: true });
	      var data = {
	        page: page
	      };
	      getAllBannerButtonLinkData(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ bannerbtnlink: records });
	          /*this.setState({ total: res.data.total });
	          this.setState({ currentPage: res.data.current_page });
	          this.setState({ PerPage: res.data.per_page });
	          this.setState({ FirstPageUrl: res.data.first_page_url });
	          this.setState({ NextPageUrl: res.data.next_page_url });
	          this.setState({ PrevPageUrl: res.data.prev_page_url });
	          this.setState({ LastPageUrl: res.data.last_page_url });
	          this.setState({ LastPage: res.data.last_page });
	          this.setState({ TotalPages: Math.ceil(this.state.total / this.state.PerPage) });*/
	        } else {
	          _this.setState({ bannerbtnlink: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BannerButtonLink, [{
	    key: "modalDeleteConfirmOpen",
	
	    /*handlePageChange(pageNumber) {
	    this.setState({ activePage: pageNumber });
	    this.refreshBannerButtonLink(pageNumber);
	    }*/
	    value: function modalDeleteConfirmOpen(e, id) {
	      this.setState({
	        modalDeleteConfirm: true,
	        doctor_id: id
	      });
	    }
	  }, {
	    key: "modalDeleteConfirmClose",
	    value: function modalDeleteConfirmClose() {
	      this.setState({
	        modalDeleteConfirm: false
	      });
	    }
	  }, {
	    key: "modalDeleteBannerButtonLink",
	    value: function modalDeleteBannerButtonLink(id) {
	      this.setState({
	        modalDeleteConfirm: false
	      });
	      var data = {
	        bannerbtnlink_id: id
	      };
	      deleteBannerButtonLink(data).then(function (res) {
	        if (res.status === true) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.href = "/bannerbuttonlink";
	          }, 6000);
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	    /*SearchBannerButtonLink = (e) =>{
	    const data = {
	    	keywords: this.state.search_keywords
	    }
	    getSearchBannerButtonLink(data)
	    .then(res => {
	    	if(res.status===true){
	    			var records = res.data.data;
	    			this.setState({ bannerbtnlink: records });
	    			this.setState({ total: res.data.total });
	    			this.setState({ currentPage: res.data.current_page });
	    			this.setState({ PerPage: res.data.per_page });
	    			this.setState({ FirstPageUrl: res.data.first_page_url });
	    			this.setState({ NextPageUrl: res.data.next_page_url });
	    			this.setState({ PrevPageUrl: res.data.prev_page_url });
	    			this.setState({ LastPageUrl: res.data.last_page_url });
	    			this.setState({ LastPage: res.data.last_page });
	    			this.setState({ TotalPages: Math.ceil(this.state.total / this.state.PerPage) });
	    	} else {
	    			this.setState({ bannerbtnlink: '' });
	    	}
	    })
	    	.catch(err => {
	    		console.log(err);
	    	});
	    }*/
	
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshBannerButtonLink();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      //const currentPage = this.state.currentPage;
	      //const previousPage = currentPage - 1;
	      //const NextPage = currentPage + 1;
	      //const LastPage = this.state.LastPage;
	      /*const pageNumbers = [];
	      for (let i = 1; i <= this.state.TotalPages; i++) {
	      pageNumbers.push(i);
	      }*/
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "container-fluid" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "card m-b-20" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "card-body" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-7" },
	                              _react2.default.createElement(
	                                "h4",
	                                { className: "mt-0 header-title" },
	                                "Banner Button Link"
	                              )
	                            ),
	                            _react2.default.createElement("div", { className: "col-sm-3 text-right" }),
	                            this.state.bannerbtnlink.length < 8 ? _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-2 text-right" },
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  href: "/addbannerbuttonlink",
	                                  className: "btn btn-sm btn-primary waves-effect waves-light"
	                                },
	                                "Add Banner Button Link"
	                              )
	                            ) : ""
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "table-rep-plugin" },
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                className: "table-responsive b-0",
	                                "data-pattern": "priority-columns"
	                              },
	                              _react2.default.createElement(
	                                "table",
	                                {
	                                  id: "tech-companies-1",
	                                  className: "table  table-striped"
	                                },
	                                _react2.default.createElement(
	                                  "thead",
	                                  null,
	                                  _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    _react2.default.createElement(
	                                      "th",
	                                      null,
	                                      "Banner Button ID"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      null,
	                                      "Banner Button Serial No"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      null,
	                                      "Banner Button Icon"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "1" },
	                                      "Banner Button Text"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "4" },
	                                      "Banner Button Link"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "3" },
	                                      "Action"
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  "tbody",
	                                  null,
	                                  this.state.bannerbtnlink.length > 0 ? this.state.bannerbtnlink.map(function (bannerbtndata) {
	                                    var dept_name = bannerbtndata.department_name;
	                                    var new_department_name = dept_name.replaceAll(" ", "-");
	                                    return _react2.default.createElement(
	                                      "tr",
	                                      { key: bannerbtndata.id },
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "#",
	                                        bannerbtndata.id
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        bannerbtndata.sl_no
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        bannerbtndata.banner_btn_icon ? _react2.default.createElement("img", {
	                                          src: _constants.IMAGE_URL + "BannerButtonImg/" + bannerbtndata.banner_btn_icon,
	                                          alt: "avtar",
	                                          style: {
	                                            width: "50px",
	                                            height: "50px",
	                                            borderRadius: "30px"
	                                          }
	                                        }) : _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        bannerbtndata.banner_btn_text
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _constants.SITE_URL + "/departments/" + new_department_name + "~" + bannerbtndata.department_id
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            href: "/editbannerbuttonlink/" + bannerbtndata.id
	                                          },
	                                          _react2.default.createElement("i", { className: "fa fa-pencil-square" })
	                                        ),
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            onClick: function onClick(e) {
	                                              return _this2.modalDeleteConfirmOpen(e, bannerbtndata.id);
	                                            }
	                                          },
	                                          _react2.default.createElement("i", { className: "fa fa-trash" })
	                                        ),
	                                        _react2.default.createElement(
	                                          _react2.default.Fragment,
	                                          null,
	                                          _react2.default.createElement(
	                                            _DeleteConfirmModalPopup2.default,
	                                            {
	                                              show: _this2.state.modalDeleteConfirm,
	                                              handleClose: function handleClose(e) {
	                                                return _this2.modalDeleteConfirmClose(e);
	                                              }
	                                            },
	                                            _react2.default.createElement(
	                                              "div",
	                                              { className: "custom_reviews_popup" },
	                                              _react2.default.createElement(
	                                                "h2",
	                                                { className: "text-center" },
	                                                "Are you sure you wish to delete this Banner Button ?"
	                                              ),
	                                              _react2.default.createElement(
	                                                "form",
	                                                {
	                                                  className: "pop-form",
	                                                  id: "edit_education"
	                                                },
	                                                _react2.default.createElement(
	                                                  "div",
	                                                  { className: "form-group row" },
	                                                  _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                                                  _react2.default.createElement(
	                                                    "div",
	                                                    { className: "col-sm-6 text-center" },
	                                                    _react2.default.createElement(
	                                                      "button",
	                                                      {
	                                                        type: "button",
	                                                        className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                                        onClick: function onClick(e) {
	                                                          return _this2.modalDeleteConfirmClose(e);
	                                                        }
	                                                      },
	                                                      " ",
	                                                      "No"
	                                                    ),
	                                                    _react2.default.createElement(
	                                                      "button",
	                                                      {
	                                                        type: "button",
	                                                        className: "blue_btn_box add_staff_btn mt-5",
	                                                        onClick: function onClick() {
	                                                          return _this2.modalDeleteBannerButtonLink(bannerbtndata.id);
	                                                        }
	                                                      },
	                                                      "Yes"
	                                                    )
	                                                  ),
	                                                  _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                                                )
	                                              )
	                                            )
	                                          )
	                                        )
	                                      )
	                                    );
	                                  }) : _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    _react2.default.createElement(
	                                      "td",
	                                      {
	                                        colSpan: "6",
	                                        className: "font_12 txt_col fontweight400 ",
	                                        style: { textAlign: "center" }
	                                      },
	                                      " ",
	                                      "There are currently no Doctors."
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return BannerButtonLink;
	}(_react.Component);
	
	exports.default = BannerButtonLink;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var board = function board() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchdata = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      modalDeleteConfirm = _useState4[0],
	      setModalDeleteConfirm = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      id = _useState6[0],
	      setId = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      searchTerm = _useState8[0],
	      setSearchTerm = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      currentPage = _useState10[0],
	      setCurrentPage = _useState10[1];
	
	  var itemsPerPage = 8; // Number of items to display per page
	
	  var _useState11 = (0, _react.useState)(""),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filteredData = _useState12[0],
	      setfilteredData = _useState12[1];
	
	  var openModalDeleteConfirm = function openModalDeleteConfirm(id) {
	    setModalDeleteConfirm(true);
	    setId(id);
	  };
	
	  var closeModalDeleteConfirm = function closeModalDeleteConfirm() {
	    setModalDeleteConfirm(false);
	  };
	
	  console.log(fatchdata, "Dataset");
	
	  (0, _react.useEffect)(function () {
	    fetchData(); // Initial data fetch
	  }, []);
	
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/boardmembers");
	
	            case 3:
	              response = _context.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                setFatchdata(response.data);
	                // setLoading(false);
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  //   const openModalDeleteConfirm = (itemId) => {
	  //     setSelectedItemId(itemId);
	  //     // Open the delete confirmation modal or perform other actions as needed
	  //   };
	
	  //   const closeModalDeleteConfirm = () => {
	  //     setSelectedItemId(null);
	  //     // Close the delete confirmation modal or perform other actions as needed
	  //   };
	
	  var handleDelete = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return _.thirdparty.delete("/boardmembers/" + id);
	
	            case 3:
	              response = _context2.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                console.log("Item with ID " + id + " deleted successfully.");
	                fetchData(); // Fetch updated data after deletion
	              }
	              _context2.next = 10;
	              break;
	
	            case 7:
	              _context2.prev = 7;
	              _context2.t0 = _context2["catch"](0);
	
	              console.error("Error deleting item with ID " + id + ":", _context2.t0.message);
	
	            case 10:
	              _context2.prev = 10;
	
	              closeModalDeleteConfirm();
	              return _context2.finish(10);
	
	            case 13:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 7, 10, 13]]);
	    }));
	
	    return function handleDelete() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    var filteredData = fatchdata && fatchdata.filter(function (item) {
	      return item["name"].toLowerCase().includes(searchTerm.toLowerCase());
	    });
	
	    setfilteredData(filteredData);
	  }, [fatchdata, searchTerm]);
	  // Get current items to display
	  var indexOfLastItem = currentPage * itemsPerPage;
	  var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  var currentItems = filteredData ? filteredData.slice(indexOfFirstItem, indexOfLastItem) : [];
	
	  // Handle search term change
	  var handleSearch = function handleSearch(event) {
	    setSearchTerm(event.target.value);
	    setCurrentPage(1);
	  };
	
	  // Handle page change
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setCurrentPage(pageNumber);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "row page-content-wrapper g-0 g-3" },
	            _react2.default.createElement("div", { className: "col-sm-7" }),
	            _react2.default.createElement("div", { className: "col-sm-3 text-right" }),
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-12 mb-4  d-flex justify-content-between align-items-center " },
	              _react2.default.createElement(
	                "h5",
	                { className: "w-50" },
	                "Board Members"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex justify-content-between w-50" },
	                _react2.default.createElement("input", {
	                  className: "form-control",
	                  type: "search",
	                  placeholder: "Search",
	                  "aria-label": "Search",
	                  value: searchTerm,
	                  onChange: handleSearch,
	                  style: { background: "transparent", border: "none" }
	                }),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "/addboardmember",
	                    className: "btn btn-sm waves-effect waves-light w-50"
	                  },
	                  "Add Board Members"
	                )
	              )
	            ),
	            currentItems.length > 0 ? currentItems.map(function (item) {
	              return _react2.default.createElement(
	                "div",
	                { className: "col-md-3", key: item.id },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card" },
	                  _react2.default.createElement("img", {
	                    className: "card-img-top ",
	                    src: _constants.IMAGE_URL + "/BoardMember/" + item.image,
	                    alt: "Card image cap",
	                    style: { height: "100vh", maxHeight: "300px" }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card-body" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Serial No: ",
	                      item.serial_order
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Member type:",
	                      " ",
	                      item.type.replace(/_/g, " ").replace(/\b\w/g, function (char) {
	                        return char.toUpperCase();
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "h5",
	                      { className: "card-title" },
	                      item.name
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "card-text" },
	                      item.designation
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "card-text" },
	                      item.company
	                    ),
	                    _react2.default.createElement(
	                      "h5",
	                      {
	                        className: "mt-2",
	                        style: {
	                          display: "flex",
	                          alignItems: "flex-end",
	                          columnGap: "10px",
	                          rowGap: "10px",
	                          justifyContent: "flex-end"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: "/editboardmember/" + item.id,
	                          baord_member_id: item.id
	                        },
	                        _react2.default.createElement("i", { className: "fa fa-pencil-square " })
	                      ),
	                      _react2.default.createElement("a", null),
	                      _react2.default.createElement(
	                        "a",
	                        { onClick: function onClick() {
	                            return openModalDeleteConfirm(item.id);
	                          } },
	                        _react2.default.createElement("i", { className: "fa fa-trash" })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    _DeleteConfirmModalPopup2.default,
	                    {
	                      show: modalDeleteConfirm,
	                      handleClose: closeModalDeleteConfirm
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "custom_reviews_popup" },
	                      _react2.default.createElement(
	                        "h2",
	                        { className: "text-center" },
	                        "Are you sure you want to delete this publication?"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        { className: "pop-form", id: "edit_education" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group row" },
	                          _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6 text-center" },
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "button",
	                                className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                onClick: closeModalDeleteConfirm
	                              },
	                              "No"
	                            ),
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "button",
	                                className: "blue_btn_box add_staff_btn mt-5",
	                                onClick: function onClick() {
	                                  // Add your logic for handling delete here
	                                  // e.g., this.modalDeletePublication(this.state.publications_id)
	                                  console.log("Deleting...");
	                                  // ModalDeleteConfirm(item.id);
	                                  handleDelete();
	                                }
	                              },
	                              "Yes"
	                            )
	                          ),
	                          _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                        )
	                      )
	                    )
	                  )
	                )
	              );
	            }) : _react2.default.createElement(
	              "div",
	              null,
	              "No data found"
	            ),
	            _react2.default.createElement(_reactJsPagination2.default, {
	              activePage: currentPage,
	              itemsCountPerPage: itemsPerPage,
	              totalItemsCount: filteredData ? filteredData.length : 1,
	              pageRangeDisplayed: 5,
	              onChange: handlePageChange
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = board;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _ = __webpack_require__(2);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _reactToastify = __webpack_require__(7);
	
	var _constants = __webpack_require__(3);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	var _reactRouter = __webpack_require__(42);
	
	var _DownloadCSV = __webpack_require__(146);
	
	var _DownloadCSV2 = _interopRequireDefault(_DownloadCSV);
	
	var _utils = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var bookingrequest = function bookingrequest() {
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      title = _useState2[0],
	      setTitle = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      type = _useState4[0],
	      setType = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      fatchdata = _useState6[0],
	      setFatchdata = _useState6[1];
	
	  var _useState7 = (0, _react.useState)("Pending"),
	      _useState8 = _slicedToArray(_useState7, 2),
	      status = _useState8[0],
	      setStatus = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(""),
	      _useState10 = _slicedToArray(_useState9, 2),
	      searchTerm = _useState10[0],
	      setSearchTerm = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(1),
	      _useState12 = _slicedToArray(_useState11, 2),
	      currentPage = _useState12[0],
	      setCurrentPage = _useState12[1];
	
	  var itemsPerPage = 10; // Number of items to display per page
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      filteredData = _useState14[0],
	      setfilteredData = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      modalDeleteConfirm = _useState16[0],
	      setModalDeleteConfirm = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(null),
	      _useState18 = _slicedToArray(_useState17, 2),
	      selectedItemId = _useState18[0],
	      setSelectedItemId = _useState18[1];
	
	  (0, _react.useEffect)(function () {
	    fetchData(); // Initial data fetch
	  }, [searchTerm]);
	
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var url, _type, api_endpoint, response;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              url = window.location.href.split("/");
	              _type = url[5];
	              api_endpoint = "";
	
	
	              if (_type == "request") {
	                setTitle("Request");
	                setType("request_appointment");
	                api_endpoint = "/appointments/request_appointment?keyword=" + searchTerm;
	              } else if (_type == "booking") {
	                setTitle("Booking");
	                setType("book_appointment");
	                api_endpoint = "/appointments/book_appointment?keyword=" + searchTerm;
	              }
	
	              _context.next = 7;
	              return _.thirdparty.get(api_endpoint);
	
	            case 7:
	              response = _context.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                setFatchdata(response.data.data);
	                // setLoading(false);
	              }
	              _context.next = 14;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 14:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 11]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  // const handleChange = (keyword) => {
	  //   setKeywords(keyword);
	  // };
	
	  (0, _react.useEffect)(function () {
	    var filteredData = fatchdata && fatchdata.filter(function (item) {
	      return item["patient_name"] ? item["patient_name"].toLowerCase().includes(searchTerm.toLowerCase()) : "";
	    });
	
	    setfilteredData(filteredData);
	  }, [fatchdata, searchTerm]);
	  // Get current items to display
	  var indexOfLastItem = currentPage * itemsPerPage;
	  var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  var currentItems = filteredData ? filteredData.slice(indexOfFirstItem, indexOfLastItem) : [];
	
	  // Handle search term change
	  var handleSearch = function handleSearch(event) {
	    setSearchTerm(event.target.value);
	    setCurrentPage(1);
	  };
	
	  // Handle page change
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setCurrentPage(pageNumber);
	  };
	
	  var modalDeleteConfirmOpen = function modalDeleteConfirmOpen(e, newStatus, itemId) {
	    setModalDeleteConfirm(true);
	    setStatus(newStatus);
	    setSelectedItemId(itemId);
	  };
	  var modalDeleteConfirmClose = function modalDeleteConfirmClose() {
	    setModalDeleteConfirm(false);
	    setSelectedItemId(null);
	  };
	
	  var modalDeleteDepartment = function modalDeleteDepartment(id) {
	    var data = {
	      status: status
	    };
	
	    try {
	      if (status === "Delete") {
	        var req = _.scAxiosAdmin.delete("/appointments/" + selectedItemId + "}", {
	          method: "delete",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (res) {
	          if (res.status === 200) {
	            _reactToastify.toast.success("Appointment Deleted Successfully!", {
	              position: _reactToastify.toast.POSITION.TOP_RIGHT
	            });
	            setTimeout(function () {
	              window.location.reload();
	            }, 3000);
	          }
	        }).catch(function (e) {
	          _reactToastify.toast.error("Something went wrong!", {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        var _req = _.scAxiosAdmin.put("/appointment_status/" + selectedItemId, data, {
	          method: "put",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (res) {
	          if (res.status === 200) {
	            _reactToastify.toast.success("Appointment Status Changed Successfully!", {
	              position: _reactToastify.toast.POSITION.TOP_RIGHT
	            });
	            setTimeout(function () {
	              window.location.reload();
	            }, 3000);
	          }
	        }).catch(function (e) {
	          _reactToastify.toast.error("Something went wrong!", {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      }
	      setModalDeleteConfirm(false);
	      setSelectedItemId(null);
	    } catch (e) {
	      _reactToastify.toast.error("Something went wrong!", {
	        position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	      });
	    }
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container-fluid" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-7" },
	                          _react2.default.createElement(
	                            "h4",
	                            { className: "mt-0 header-title" },
	                            "Appointment ",
	                            title,
	                            " List"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-3 text-right" },
	                          _react2.default.createElement("input", {
	                            className: "form-control",
	                            type: "search",
	                            placeholder: "Search",
	                            "aria-label": "Search",
	                            value: searchTerm,
	                            onChange: handleSearch,
	                            style: {
	                              background: "transparent",
	                              border: "none"
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-md-2" },
	                          _react2.default.createElement(_DownloadCSV2.default, {
	                            data: filteredData,
	                            fileName: "publications_list"
	                          })
	                        ),
	                        _react2.default.createElement("div", { className: "col-sm-3 text-right" }),
	                        _react2.default.createElement("div", { className: "col-sm-2 text-right" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "table-rep-plugin" },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "table-responsive b-0",
	                            "data-pattern": "priority-columns"
	                          },
	                          _react2.default.createElement(
	                            "table",
	                            {
	                              id: "tech-companies-1",
	                              className: "table  table-striped"
	                            },
	                            _react2.default.createElement(
	                              "thead",
	                              null,
	                              _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                  "th",
	                                  { "data-priority": "1" },
	                                  "Type"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  { "data-priority": "4" },
	                                  "Patient Name"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "Patient Number"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "Doctor Name"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  { "data-priority": "1" },
	                                  "Appointment Date"
	                                ),
	                                type === "request_appointment" ? "" : _react2.default.createElement(
	                                  "th",
	                                  { "data-priority": "1" },
	                                  "Time"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  { "data-priority": "1" },
	                                  "Applied At"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  { "data-priority": "3" },
	                                  "Status"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  { "data-priority": "3" },
	                                  "Action"
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "tbody",
	                              null,
	                              currentItems.length > 0 ? currentItems.map(function (item, index) {
	                                return type == item.type && _react2.default.createElement(
	                                  "tr",
	                                  { key: index },
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    title
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    item.patient_name
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    item.patient_phone_number
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    item.doctor_name
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    item.appointment_date
	                                  ),
	                                  type === "request_appointment" ? "" : _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    item.appointment_time
	                                  ),
	                                  " ",
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    (0, _utils.formatDate)(item.created_at)
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    item.status
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    type === "request_appointment" ? "" : _react2.default.createElement(
	                                      "a",
	                                      {
	                                        onClick: function onClick(e) {
	                                          return modalDeleteConfirmOpen(e, "Confirmed", item.id);
	                                        }
	                                      },
	                                      _react2.default.createElement("i", {
	                                        "class": "fa-regular fa-calendar-check",
	                                        "data-bs-toggle": "tooltip",
	                                        "data-bs-placement": "top",
	                                        title: "Approve Request"
	                                      })
	                                    ),
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        onClick: function onClick(e) {
	                                          return modalDeleteConfirmOpen(e, "Canceled", item.id);
	                                        }
	                                      },
	                                      _react2.default.createElement("i", {
	                                        className: "fa-solid fa-ban",
	                                        "data-bs-toggle": "tooltip",
	                                        "data-bs-placement": "top",
	                                        title: "Cancel Request"
	                                      })
	                                    ),
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        onClick: function onClick(e) {
	                                          return modalDeleteConfirmOpen(e, "Delete", item.id);
	                                        }
	                                      },
	                                      _react2.default.createElement("i", {
	                                        className: "fa fa-trash",
	                                        "data-bs-toggle": "tooltip",
	                                        "data-bs-placement": "top",
	                                        title: "Delete Request"
	                                      })
	                                    ),
	                                    _react2.default.createElement(
	                                      _DeleteConfirmModalPopup2.default,
	                                      {
	                                        show: modalDeleteConfirm,
	                                        handleClose: function handleClose(e) {
	                                          return modalDeleteConfirmClose(e);
	                                        }
	                                      },
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "custom_reviews_popup" },
	                                        _react2.default.createElement(
	                                          "h2",
	                                          { className: "text-center" },
	                                          "Are you sure you wish to",
	                                          status === "Canceled" ? " Cancel" : status === "Delete" ? " Delete" : "",
	                                          " ",
	                                          "this appointment ?"
	                                        ),
	                                        _react2.default.createElement(
	                                          "form",
	                                          {
	                                            className: "pop-form",
	                                            id: "edit_education"
	                                          },
	                                          _react2.default.createElement(
	                                            "div",
	                                            { className: "form-group row" },
	                                            _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                                            _react2.default.createElement(
	                                              "div",
	                                              { className: "col-sm-6 text-center" },
	                                              _react2.default.createElement(
	                                                "button",
	                                                {
	                                                  type: "button",
	                                                  className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                                  onClick: function onClick(e) {
	                                                    return modalDeleteConfirmClose(e);
	                                                  }
	                                                },
	                                                " ",
	                                                "No"
	                                              ),
	                                              _react2.default.createElement(
	                                                "button",
	                                                {
	                                                  type: "button",
	                                                  className: "blue_btn_box add_staff_btn mt-5",
	                                                  onClick: function onClick() {
	                                                    return modalDeleteDepartment(item.id);
	                                                  }
	                                                },
	                                                "Yes"
	                                              )
	                                            ),
	                                            _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                );
	                              }) : _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                  "td",
	                                  {
	                                    colSpan: "8",
	                                    className: "font_12 txt_col fontweight400 ",
	                                    style: { textAlign: "center" }
	                                  },
	                                  " ",
	                                  "There are currently no bookings."
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(_reactJsPagination2.default, {
	                            activePage: currentPage,
	                            itemsCountPerPage: itemsPerPage,
	                            totalItemsCount: filteredData ? filteredData.length : 1,
	                            pageRangeDisplayed: 5,
	                            onChange: handlePageChange
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = bookingrequest;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSingleDepartmentData = function getSingleDepartmentData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getsingledepartment/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var DepartmentView = function (_Component) {
	  _inherits(DepartmentView, _Component);
	
	  function DepartmentView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DepartmentView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DepartmentView.__proto__ || Object.getPrototypeOf(DepartmentView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      department_id: "",
	      department_name: "",
	      department_desc_one: "",
	      department_desc_two: "",
	      department_desc_three: "",
	      department_desc_four: "",
	      department_desc_five: ""
	    }, _this.refreshgetSingleDepartmentData = function (id) {
	      getSingleDepartmentData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            department_id: records.id,
	            department_name: records.department_name,
	            department_desc_one: records.department_desc_one,
	            department_desc_two: records.department_desc_two,
	            department_desc_three: records.department_desc_three,
	            department_desc_four: records.department_desc_four,
	            department_desc_five: records.department_desc_five
	          });
	        } else {
	          _this.setState({
	            department_id: "",
	            department_name: "",
	            department_desc_one: "",
	            department_desc_two: "",
	            department_desc_three: "",
	            department_desc_four: "",
	            department_desc_five: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DepartmentView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSingleDepartmentData(this.props.match.params.id);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "section",
	                        { className: "view-page" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "container" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "view-page-box" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-9" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "view-text" },
	                                  _react2.default.createElement(
	                                    "h2",
	                                    null,
	                                    this.state.department_name
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-3" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edit" },
	                                  _react2.default.createElement(
	                                    "a",
	                                    {
	                                      href: "/editdepartment/" + this.state.department_id
	                                    },
	                                    _react2.default.createElement("i", { className: "fa fa-pencil" })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              this.state.department_desc_one ? _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-6 col-md-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edu-part" },
	                                  _react2.default.createElement("p", {
	                                    dangerouslySetInnerHTML: {
	                                      __html: this.state.department_desc_one
	                                    }
	                                  })
	                                )
	                              ) : _react2.default.createElement("div", null),
	                              this.state.department_desc_two ? _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-6 col-md-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edu-part" },
	                                  _react2.default.createElement("p", {
	                                    dangerouslySetInnerHTML: {
	                                      __html: this.state.department_desc_two
	                                    }
	                                  })
	                                )
	                              ) : _react2.default.createElement("div", null),
	                              this.state.department_desc_three ? _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-6 col-md-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edu-part" },
	                                  _react2.default.createElement("p", {
	                                    dangerouslySetInnerHTML: {
	                                      __html: this.state.department_desc_three
	                                    }
	                                  })
	                                )
	                              ) : _react2.default.createElement("div", null),
	                              this.state.department_desc_four ? _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-6 col-md-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edu-part" },
	                                  _react2.default.createElement("p", {
	                                    dangerouslySetInnerHTML: {
	                                      __html: this.state.department_desc_four
	                                    }
	                                  })
	                                )
	                              ) : _react2.default.createElement("div", null),
	                              this.state.department_desc_five ? _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-6 col-md-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edu-part" },
	                                  _react2.default.createElement("p", {
	                                    dangerouslySetInnerHTML: {
	                                      __html: this.state.department_desc_five
	                                    }
	                                  })
	                                )
	                              ) : _react2.default.createElement("div", null)
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DepartmentView;
	}(_react.Component);
	
	exports.default = DepartmentView;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import Footer from '../../component/admin/Footer';
	//import Moment from 'moment';
	
	
	var getAllDepartments = function getAllDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getalldepartments?show_hidden=1", {
	      method: "get",
	
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSearchDepartments = function getSearchDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/adminsearchdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var deleteDepartment = function deleteDepartment(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/deletedepartment", {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var updateDepartmentStatus = function updateDepartmentStatus(data, id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/department/hidedepartment/" + id, data, {
	      method: "post",
	      // body: { data },
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var Departments = function (_Component) {
	  _inherits(Departments, _Component);
	
	  function Departments() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Departments);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Departments.__proto__ || Object.getPrototypeOf(Departments)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      departments: [],
	      total: "",
	      currentPage: "",
	      LastPage: "",
	      PerPage: "",
	      FirstPageUrl: "",
	      NextPageUrl: "",
	      PrevPageUrl: "",
	      LastPageUrl: "",
	      TotalPages: "",
	      activePage: 1,
	      enableShdo: false,
	      enableShdoLive: false,
	      department_id: "",
	      modalDeleteConfirm: false,
	      selectedPost: null,
	      search_keywords: ""
	    }, _this.handleChange = function (events) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var data = {
	        keywords: _this.state.search_keywords
	      };
	      getSearchDepartments(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ departments: records });
	          _this.setState({ total: res.data.total });
	          _this.setState({ currentPage: res.data.current_page });
	          _this.setState({ PerPage: res.data.per_page });
	          _this.setState({ FirstPageUrl: res.data.first_page_url });
	          _this.setState({ NextPageUrl: res.data.next_page_url });
	          _this.setState({ PrevPageUrl: res.data.prev_page_url });
	          _this.setState({ LastPageUrl: res.data.last_page_url });
	          _this.setState({ LastPage: res.data.last_page });
	          _this.setState({
	            TotalPages: Math.ceil(_this.state.total / _this.state.PerPage)
	          });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.toggleDepartmentStatus = function (department) {
	      var newStatus = department.status === "1" ? "0" : "1";
	      var data = {
	        status: newStatus
	      };
	
	      updateDepartmentStatus(data, department.id).then(function (res) {
	        if (res.status === true) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          _this.setState(function (prevState) {
	            return {
	              departments: prevState.departments.map(function (dep) {
	                return dep.id === department.id ? Object.assign({}, dep, { status: newStatus }) : dep;
	              })
	            };
	          });
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	      }).catch(function (err) {
	        console.error(err);
	        _reactToastify.toast.error("Failed to update status", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	    }, _this.refreshDepartments = function (page) {
	      _this.setState({ enableShdo: true });
	      var data = {
	        page: page
	      };
	      getAllDepartments(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ departments: records });
	          _this.setState({ total: res.data.total });
	          _this.setState({ currentPage: res.data.current_page });
	          _this.setState({ PerPage: res.data.per_page });
	          _this.setState({ FirstPageUrl: res.data.first_page_url });
	          _this.setState({ NextPageUrl: res.data.next_page_url });
	          _this.setState({ PrevPageUrl: res.data.prev_page_url });
	          _this.setState({ LastPageUrl: res.data.last_page_url });
	          _this.setState({ LastPage: res.data.last_page });
	          _this.setState({
	            TotalPages: Math.ceil(_this.state.total / _this.state.PerPage)
	          });
	        } else {
	          _this.setState({ departments: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.SearchDepartments = function (e) {
	      var data = {
	        keywords: _this.state.search_keywords
	      };
	      getSearchDepartments(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ departments: records });
	          _this.setState({ total: res.data.total });
	          _this.setState({ currentPage: res.data.current_page });
	          _this.setState({ PerPage: res.data.per_page });
	          _this.setState({ FirstPageUrl: res.data.first_page_url });
	          _this.setState({ NextPageUrl: res.data.next_page_url });
	          _this.setState({ PrevPageUrl: res.data.prev_page_url });
	          _this.setState({ LastPageUrl: res.data.last_page_url });
	          _this.setState({ LastPage: res.data.last_page });
	          _this.setState({
	            TotalPages: Math.ceil(_this.state.total / _this.state.PerPage)
	          });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Departments, [{
	    key: "handlePageChange",
	    value: function handlePageChange(pageNumber) {
	      this.setState({ activePage: pageNumber });
	      this.refreshDepartments(pageNumber);
	    }
	  }, {
	    key: "modalDeleteConfirmOpen",
	    value: function modalDeleteConfirmOpen(e, id) {
	      this.setState({
	        modalDeleteConfirm: true,
	        department_id: id
	      });
	    }
	  }, {
	    key: "modalDeleteConfirmClose",
	    value: function modalDeleteConfirmClose() {
	      this.setState({
	        modalDeleteConfirm: false
	      });
	    }
	  }, {
	    key: "modalDeleteDepartment",
	    value: function modalDeleteDepartment(id) {
	      this.setState({
	        modalDeleteConfirm: false
	      });
	      /*this.setState({ 
	      selectedPost: i,
	      });*/
	      var data = {
	        department_id: id
	      };
	      deleteDepartment(data).then(function (res) {
	        if (res.status === true) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.reload();
	          }, 3000);
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	        window.location = "/admin/departments";
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshDepartments();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      //const currentPage = this.state.currentPage;
	      //const previousPage = currentPage - 1;
	      //const NextPage = currentPage + 1;
	      //const LastPage = this.state.LastPage;
	      var pageNumbers = [];
	      for (var i = 1; i <= this.state.TotalPages; i++) {
	        pageNumbers.push(i);
	      }
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "container-fluid" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "card m-b-20" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "card-body" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-7" },
	                              _react2.default.createElement(
	                                "h4",
	                                { className: "mt-0 header-title" },
	                                "Departments"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-3 text-right" },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "search_keywords",
	                                id: "search_keywords",
	                                value: this.state.search_keywords,
	                                onChange: this.handleChange
	                                // onBlur={this.SearchDepartments}
	                                , placeholder: "Search"
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-2 text-right" },
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  href: "/adddepartment",
	                                  className: "btn btn-sm btn-primary waves-effect waves-light"
	                                },
	                                "Add Department"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "table-rep-plugin" },
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                className: "table-responsive b-0",
	                                "data-pattern": "priority-columns"
	                              },
	                              _react2.default.createElement(
	                                "table",
	                                {
	                                  id: "tech-companies-1",
	                                  className: "table  table-striped"
	                                },
	                                _react2.default.createElement(
	                                  "thead",
	                                  null,
	                                  _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    _react2.default.createElement(
	                                      "th",
	                                      null,
	                                      "Department ID"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "1" },
	                                      "Department Name"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "4" },
	                                      "Status"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "3" },
	                                      "Action"
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  "tbody",
	                                  null,
	                                  this.state.departments.length > 0 ? this.state.departments.map(function (department) {
	                                    return _react2.default.createElement(
	                                      "tr",
	                                      { key: department.id },
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "#",
	                                        department.dept_id
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        department.department_name
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        department.status === "1" ? "Active" : "InActive"
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            href: "/editdepartment/" + department.slug
	                                          },
	                                          _react2.default.createElement("i", { className: "fa fa-pencil-square" })
	                                        ),
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            title: "Status",
	                                            onClick: function onClick() {
	                                              return _this2.toggleDepartmentStatus(department);
	                                            }
	                                          },
	                                          department.status === "1" ? _react2.default.createElement("i", { "class": "fa-solid fa-eye" }) : _react2.default.createElement("i", { "class": "fa-solid fa-eye-slash" })
	                                        ),
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            href: "/departments/" + department.slug,
	                                            target: "_blank"
	                                          },
	                                          _react2.default.createElement("i", { "class": "fa-solid fa-laptop" })
	                                        ),
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            onClick: function onClick(e) {
	                                              return _this2.modalDeleteConfirmOpen(e, department.id);
	                                            }
	                                          },
	                                          _react2.default.createElement("i", { className: "fa fa-trash" })
	                                        ),
	                                        _react2.default.createElement(
	                                          _DeleteConfirmModalPopup2.default,
	                                          {
	                                            show: _this2.state.modalDeleteConfirm,
	                                            handleClose: function handleClose(e) {
	                                              return _this2.modalDeleteConfirmClose(e);
	                                            }
	                                          },
	                                          _react2.default.createElement(
	                                            "div",
	                                            { className: "custom_reviews_popup" },
	                                            _react2.default.createElement(
	                                              "h2",
	                                              { className: "text-center" },
	                                              "Are you sure you wish to delete this department ?"
	                                            ),
	                                            _react2.default.createElement(
	                                              "form",
	                                              {
	                                                className: "pop-form",
	                                                id: "edit_education"
	                                              },
	                                              _react2.default.createElement(
	                                                "div",
	                                                { className: "form-group row" },
	                                                _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                                                _react2.default.createElement(
	                                                  "div",
	                                                  { className: "col-sm-6 text-center" },
	                                                  _react2.default.createElement(
	                                                    "button",
	                                                    {
	                                                      type: "button",
	                                                      className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                                      onClick: function onClick(e) {
	                                                        return _this2.modalDeleteConfirmClose(e);
	                                                      }
	                                                    },
	                                                    " ",
	                                                    "No"
	                                                  ),
	                                                  _react2.default.createElement(
	                                                    "button",
	                                                    {
	                                                      type: "button",
	                                                      className: "blue_btn_box add_staff_btn mt-5",
	                                                      onClick: function onClick() {
	                                                        return _this2.modalDeleteDepartment(_this2.state.department_id);
	                                                      }
	                                                    },
	                                                    "Yes"
	                                                  )
	                                                ),
	                                                _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                                              )
	                                            )
	                                          )
	                                        )
	                                      )
	                                    );
	                                  }) : _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    _react2.default.createElement(
	                                      "td",
	                                      {
	                                        colSpan: "6",
	                                        className: "font_12 txt_col fontweight400 ",
	                                        style: { textAlign: "center" }
	                                      },
	                                      " ",
	                                      "There are currently no Departments."
	                                    )
	                                  )
	                                )
	                              ),
	                              pageNumbers.length > 1 ? _react2.default.createElement(_reactJsPagination2.default, {
	                                activePage: this.state.activePage,
	                                totalItemsCount: this.state.total,
	                                pageRangeDisplayed: 5,
	                                onChange: this.handlePageChange.bind(this)
	                              }) : ""
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return Departments;
	}(_react.Component);
	
	exports.default = Departments;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSingleDoctorDatadetails = function getSingleDoctorDatadetails(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/getsingledoctorsdetails/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleDoctorPublications = function getSingleDoctorPublications(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/doctorpublication/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var DoctorView = function (_Component) {
	  _inherits(DoctorView, _Component);
	
	  function DoctorView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DoctorView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DoctorView.__proto__ || Object.getPrototypeOf(DoctorView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      publications: [],
	      doctor_id: "",
	      doctor_name: "",
	      doctor_degree: "",
	      doctor_fees: "",
	      doctor_department: "",
	      doctor_profile: "",
	      doctor_desc: "",
	      doctor_edu: "",
	      doctor_exp: "",
	      doctor_department_name: ""
	    }, _this.refreshgetSingleDoctorDataDetails = function (id) {
	      getSingleDoctorDatadetails(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            doctor_id: records.id,
	            doctor_department_name: records.department_name,
	            doctor_name: records.doctor_name,
	            doctor_degree: records.degree,
	            doctor_fees: records.doctor_fees,
	            doctor_department: records.dept_id,
	            doctor_profile: records.doctor_profile,
	            doctor_desc: records.doctor_desc,
	            doctor_edu: records.doctor_edu,
	            doctor_exp: records.doctor_exp
	          });
	        } else {
	          _this.setState({
	            doctor_id: "",
	            doctor_name: "",
	            doctor_degree: "",
	            doctor_fees: "",
	            doctor_department: "",
	            doctor_profile: "",
	            doctor_desc: "",
	            doctor_edu: "",
	            doctor_exp: "",
	            doctor_department_name: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshgetSingleDoctorPublication = function (id) {
	      getSingleDoctorPublications(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ publications: records });
	        } else {
	          _this.setState({ publications: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DoctorView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSingleDoctorDataDetails(this.props.match.params.id);
	      this.refreshgetSingleDoctorPublication(this.props.match.params.id);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "section",
	                        { className: "view-page" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "container" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "view-page-box" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-3" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "view-img" },
	                                  this.state.doctor_profile ? _react2.default.createElement("img", {
	                                    src: _constants.IMAGE_URL + "DoctorProfileImg/" + this.state.doctor_profile,
	                                    alt: ""
	                                  }) : _react2.default.createElement("img", { src: _avatar_circle2.default, alt: "" })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-6" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "view-text" },
	                                  _react2.default.createElement(
	                                    "h2",
	                                    null,
	                                    this.state.doctor_name
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                      "b",
	                                      null,
	                                      this.state.doctor_degree
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    this.state.doctor_department_name
	                                  ),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "start-icons" },
	                                    _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                    _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                    _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                    _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                    _react2.default.createElement("i", { className: "fa-solid fa-star" })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-3" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edit" },
	                                  _react2.default.createElement(
	                                    "a",
	                                    {
	                                      href: "/editdoctor/" + this.state.doctor_id
	                                    },
	                                    _react2.default.createElement("i", { className: "fa fa-pencil" })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement("hr", null),
	                            _react2.default.createElement(
	                              "h3",
	                              null,
	                              "Objective"
	                            ),
	                            _react2.default.createElement("p", {
	                              dangerouslySetInnerHTML: {
	                                __html: this.state.doctor_desc
	                              }
	                            }),
	                            _react2.default.createElement("hr", null),
	                            _react2.default.createElement(
	                              "h3",
	                              null,
	                              "Availability"
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row", id: "tab-mob" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-2 " },
	                                _react2.default.createElement(
	                                  "table",
	                                  { className: "table table-sst" },
	                                  _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "th",
	                                        null,
	                                        "Sun "
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "9am-5p.m."
	                                      )
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-2" },
	                                _react2.default.createElement(
	                                  "table",
	                                  { className: "table table-sst" },
	                                  _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "th",
	                                        null,
	                                        "Mon "
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "9am-5p.m."
	                                      )
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-2 p-0" },
	                                _react2.default.createElement(
	                                  "table",
	                                  { className: "table table-sst" },
	                                  _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "th",
	                                        null,
	                                        "Tue "
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "9am-5p.m."
	                                      )
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-2" },
	                                _react2.default.createElement(
	                                  "table",
	                                  { className: "table table-sst" },
	                                  _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "th",
	                                        null,
	                                        "Web "
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "9am-5p.m."
	                                      )
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-2 p-0" },
	                                _react2.default.createElement(
	                                  "table",
	                                  { className: "table table-sst" },
	                                  _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "th",
	                                        null,
	                                        "Thurs "
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "9am-5p.m."
	                                      )
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-2" },
	                                _react2.default.createElement(
	                                  "table",
	                                  { className: "table table-sst" },
	                                  _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "th",
	                                        null,
	                                        "Sat "
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "tr",
	                                      null,
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "9am-5p.m."
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-6 col-md-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edu-part" },
	                                  _react2.default.createElement(
	                                    "h3",
	                                    null,
	                                    "Education"
	                                  ),
	                                  _react2.default.createElement("p", {
	                                    dangerouslySetInnerHTML: {
	                                      __html: this.state.doctor_edu
	                                    }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-6 col-md-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edu-part" },
	                                  _react2.default.createElement(
	                                    "h3",
	                                    null,
	                                    "Experience"
	                                  ),
	                                  _react2.default.createElement("p", {
	                                    dangerouslySetInnerHTML: {
	                                      __html: this.state.doctor_exp
	                                    }
	                                  })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "h3",
	                              { className: "mt-5" },
	                              "Publications"
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "card m-b-20" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "card-body" },
	                                _react2.default.createElement(
	                                  "section",
	                                  { className: "view-page" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "container" },
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "view-page-box" },
	                                      _react2.default.createElement("hr", null),
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "row" },
	                                        this.state.publications.length > 0 ? this.state.publications.map(function (publication) {
	                                          return _react2.default.createElement(
	                                            "div",
	                                            { className: "col-lg-4" },
	                                            _react2.default.createElement(
	                                              "div",
	                                              { className: "news-part-event" },
	                                              _react2.default.createElement("img", {
	                                                src: _constants.IMAGE_URL + "/PublicationsImg/" + publication.publications_pic,
	                                                alt: "",
	                                                width: "100%"
	                                              }),
	                                              _react2.default.createElement(
	                                                "div",
	                                                { className: "newdata position-relative" },
	                                                _react2.default.createElement(
	                                                  "div",
	                                                  { className: "row" },
	                                                  _react2.default.createElement(
	                                                    "div",
	                                                    { className: "col-lg-10" },
	                                                    _react2.default.createElement(
	                                                      "h3",
	                                                      { className: "d-inline" },
	                                                      publication.doctor_name
	                                                    )
	                                                  )
	                                                ),
	                                                _react2.default.createElement(
	                                                  "h4",
	                                                  null,
	                                                  publication.publications_title
	                                                ),
	                                                _react2.default.createElement(
	                                                  "h5",
	                                                  { className: "float-end position-absolute mt-2 top-0 end-0" },
	                                                  _react2.default.createElement(
	                                                    "a",
	                                                    {
	                                                      href: "/admin/editpublication/" + publication.id
	                                                    },
	                                                    _react2.default.createElement("i", { className: "fa fa-pencil-square mx-2 display-4" })
	                                                  )
	                                                )
	                                              ),
	                                              _react2.default.createElement("p", {
	                                                dangerouslySetInnerHTML: {
	                                                  __html: publication.publications_desc ? publication.publications_desc.substr(0, 70) : ""
	                                                }
	                                              })
	                                            )
	                                          );
	                                        }) : _react2.default.createElement(
	                                          "div",
	                                          {
	                                            colspan: "6",
	                                            className: "font_12 txt_col fontweight400 ",
	                                            style: { "text-align": "center" }
	                                          },
	                                          " ",
	                                          "There are currently no News Events."
	                                        )
	                                      ),
	                                      _react2.default.createElement("br", null)
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DoctorView;
	}(_react.Component);
	
	exports.default = DoctorView;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import 'react-toastify/dist/ReactToastify.css';
	
	//import Footer from '../../component/admin/Footer';
	//import Moment from 'moment';
	
	
	var getAllDoctors = function getAllDoctors(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/getalldoctors?show_hidden=1", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSearchDoctors = function getSearchDoctors(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/adminsearchdoctors", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var deleteDoctor = function deleteDoctor(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/deletedoctor", {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var updateDoctorStatus = function updateDoctorStatus(data, id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/updatedoctor/" + id, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var Doctors = function (_Component) {
	  _inherits(Doctors, _Component);
	
	  function Doctors() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Doctors);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Doctors.__proto__ || Object.getPrototypeOf(Doctors)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      doctors: [],
	      total: "",
	      currentPage: "",
	      LastPage: "",
	      PerPage: "",
	      FirstPageUrl: "",
	      NextPageUrl: "",
	      PrevPageUrl: "",
	      LastPageUrl: "",
	      TotalPages: "",
	      activePage: 1,
	      doctor_id: "",
	      enableShdo: false,
	      enableShdoLive: false,
	      search_keywords: ""
	    }, _this.handleChange = function (events) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.toggleDoctorStatus = function (doctor) {
	      var newStatus = doctor.status === "1" ? "0" : "1";
	      var data = {
	        doctor_id: doctor.id,
	        status: newStatus
	      };
	
	      updateDoctorStatus(data, doctor.id).then(function (res) {
	        if (res.status === true) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          _this.setState(function (prevState) {
	            return {
	              doctors: prevState.doctors.map(function (doc) {
	                return doc.id === doctor.id ? Object.assign({}, doc, { status: newStatus }) : doc;
	              })
	            };
	          });
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	      }).catch(function (err) {
	        console.error(err);
	        _reactToastify.toast.error("Failed to update status", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	    }, _this.refreshDoctors = function (page) {
	      _this.setState({ enableShdo: true });
	      var data = {
	        page: page
	      };
	      getAllDoctors(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ doctors: records });
	          _this.setState({ total: res.data.total });
	          _this.setState({ currentPage: res.data.current_page });
	          _this.setState({ PerPage: res.data.per_page });
	          _this.setState({ FirstPageUrl: res.data.first_page_url });
	          _this.setState({ NextPageUrl: res.data.next_page_url });
	          _this.setState({ PrevPageUrl: res.data.prev_page_url });
	          _this.setState({ LastPageUrl: res.data.last_page_url });
	          _this.setState({ LastPage: res.data.last_page });
	          _this.setState({
	            TotalPages: Math.ceil(_this.state.total / _this.state.PerPage)
	          });
	        } else {
	          _this.setState({ doctors: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.SearchDocotrs = function (e) {
	      var data = {
	        keywords: _this.state.search_keywords
	      };
	      getSearchDoctors(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ doctors: records });
	          _this.setState({ total: res.data.total });
	          _this.setState({ currentPage: res.data.current_page });
	          _this.setState({ PerPage: res.data.per_page });
	          _this.setState({ FirstPageUrl: res.data.first_page_url });
	          _this.setState({ NextPageUrl: res.data.next_page_url });
	          _this.setState({ PrevPageUrl: res.data.prev_page_url });
	          _this.setState({ LastPageUrl: res.data.last_page_url });
	          _this.setState({ LastPage: res.data.last_page });
	          _this.setState({
	            TotalPages: Math.ceil(_this.state.total / _this.state.PerPage)
	          });
	        } else {
	          _this.setState({ doctors: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Doctors, [{
	    key: "handlePageChange",
	    value: function handlePageChange(pageNumber) {
	      this.setState({ activePage: pageNumber });
	      this.refreshDoctors(pageNumber);
	    }
	  }, {
	    key: "modalDeleteConfirmOpen",
	    value: function modalDeleteConfirmOpen(e, id) {
	      this.setState({
	        modalDeleteConfirm: true,
	        doctor_id: id
	      });
	    }
	  }, {
	    key: "modalDeleteConfirmClose",
	    value: function modalDeleteConfirmClose() {
	      this.setState({
	        modalDeleteConfirm: false
	      });
	    }
	  }, {
	    key: "modalDeleteDoctor",
	    value: function modalDeleteDoctor(id) {
	      /*this.setState({ 
	      selectedPost: i,
	      });*/
	      this.setState({
	        modalDeleteConfirm: false
	      });
	      var data = {
	        doctor_id: id
	      };
	      deleteDoctor(data).then(function (res) {
	        if (res.status === true) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.href = "/admin/doctors";
	          }, 6000);
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	        //window.location='/departments';
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshDoctors();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      //const currentPage = this.state.currentPage;
	      //const previousPage = currentPage - 1;
	      //const NextPage = currentPage + 1;
	      //const LastPage = this.state.LastPage;
	      var pageNumbers = [];
	      for (var i = 1; i <= this.state.TotalPages; i++) {
	        pageNumbers.push(i);
	      }
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "container-fluid" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "card m-b-20" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "card-body" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-7" },
	                              _react2.default.createElement(
	                                "h4",
	                                { className: "mt-0 header-title" },
	                                "Doctors"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-3 text-right" },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "search_keywords",
	                                id: "search_keywords",
	                                value: this.state.search_keywords,
	                                onChange: this.handleChange,
	                                onKeyUp: this.SearchDocotrs,
	                                placeholder: "Search"
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-sm-2 text-right" },
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  href: "/adddoctor",
	                                  className: "btn btn-sm btn-primary waves-effect waves-light"
	                                },
	                                "Add Doctor"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "table-rep-plugin" },
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                className: "table-responsive b-0",
	                                "data-pattern": "priority-columns"
	                              },
	                              _react2.default.createElement(
	                                "table",
	                                {
	                                  id: "tech-companies-1",
	                                  className: "table  table-striped"
	                                },
	                                _react2.default.createElement(
	                                  "thead",
	                                  null,
	                                  _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    _react2.default.createElement(
	                                      "th",
	                                      null,
	                                      "Doctor ID"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      null,
	                                      "Doctor Image"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "1" },
	                                      "Doctor Name"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "4" },
	                                      "Department"
	                                    ),
	                                    _react2.default.createElement(
	                                      "th",
	                                      { "data-priority": "3" },
	                                      "Action"
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  "tbody",
	                                  null,
	                                  this.state.doctors.length > 0 ? this.state.doctors.map(function (doctor) {
	                                    return _react2.default.createElement(
	                                      "tr",
	                                      { key: doctor.id },
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        "#",
	                                        doctor.uhl_id
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        doctor.doctor_profile ? _react2.default.createElement("img", {
	                                          src: _constants.IMAGE_URL + "DoctorProfileImg/" + doctor.doctor_profile,
	                                          alt: "avtar",
	                                          style: {
	                                            width: "50px",
	                                            height: "50px",
	                                            "border-radius": "30px"
	                                          }
	                                        }) : _react2.default.createElement("img", {
	                                          src: _avatar_circle2.default,
	                                          alt: "avtar",
	                                          width: "50px"
	                                        })
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        doctor.doctor_name
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        doctor.department_name
	                                      ),
	                                      _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            title: "Update doctor",
	                                            href: "/editdoctor/" + doctor.slug
	                                          },
	                                          _react2.default.createElement("i", { className: "fa fa-pencil-square" })
	                                        ),
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            title: "Status",
	                                            onClick: function onClick() {
	                                              return _this2.toggleDoctorStatus(doctor);
	                                            }
	                                          },
	                                          doctor.status === "1" ? _react2.default.createElement("i", { "class": "fa-solid fa-eye" }) : _react2.default.createElement("i", { "class": "fa-solid fa-eye-slash" })
	                                        ),
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            title: "View Doctor in website",
	                                            href: "/consultant/" + doctor.slug
	                                          },
	                                          _react2.default.createElement("i", { "class": "fa-solid fa-laptop" })
	                                        ),
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            title: "Delete doctor",
	                                            onClick: function onClick(e) {
	                                              return _this2.modalDeleteConfirmOpen(e, doctor.id);
	                                            }
	                                          },
	                                          _react2.default.createElement("i", { className: "fa fa-trash" })
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        _DeleteConfirmModalPopup2.default,
	                                        {
	                                          show: _this2.state.modalDeleteConfirm,
	                                          handleClose: function handleClose(e) {
	                                            return _this2.modalDeleteConfirmClose(e);
	                                          }
	                                        },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "custom_reviews_popup" },
	                                          _react2.default.createElement(
	                                            "h2",
	                                            { className: "text-center" },
	                                            "Are you sure you wish to delete this doctor ?"
	                                          ),
	                                          _react2.default.createElement(
	                                            "form",
	                                            {
	                                              className: "pop-form",
	                                              id: "edit_education"
	                                            },
	                                            _react2.default.createElement(
	                                              "div",
	                                              { className: "form-group row" },
	                                              _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                                              _react2.default.createElement(
	                                                "div",
	                                                { className: "col-sm-6 text-center" },
	                                                _react2.default.createElement(
	                                                  "button",
	                                                  {
	                                                    type: "button",
	                                                    className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                                    onClick: function onClick(e) {
	                                                      return _this2.modalDeleteConfirmClose(e);
	                                                    }
	                                                  },
	                                                  " ",
	                                                  "No"
	                                                ),
	                                                _react2.default.createElement(
	                                                  "button",
	                                                  {
	                                                    type: "button",
	                                                    className: "blue_btn_box add_staff_btn mt-5",
	                                                    onClick: function onClick() {
	                                                      return _this2.modalDeleteDoctor(_this2.state.doctor_id);
	                                                    }
	                                                  },
	                                                  "Yes"
	                                                )
	                                              ),
	                                              _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                                            )
	                                          )
	                                        )
	                                      )
	                                    );
	                                  }) : _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    _react2.default.createElement(
	                                      "td",
	                                      {
	                                        colSpan: "6",
	                                        className: "font_12 txt_col fontweight400 ",
	                                        style: { textAlign: "center" }
	                                      },
	                                      " ",
	                                      "There are currently no Doctors."
	                                    )
	                                  )
	                                )
	                              ),
	                              pageNumbers.length > 1 ? _react2.default.createElement(_reactJsPagination2.default, {
	                                activePage: this.state.activePage,
	                                totalItemsCount: this.state.total,
	                                pageRangeDisplayed: 5,
	                                onChange: this.handlePageChange.bind(this)
	                              }) : ""
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return Doctors;
	}(_react.Component);
	
	exports.default = Doctors;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import Footer from '../../component/admin/Footer';
	
	
	var updateVideoGallery = function updateVideoGallery(id, data, edit_video_gallery_name, edit_video_gallery_desc, imageData) {
	  var formdata = new FormData();
	  formdata.append("edit_video_gallery_name", edit_video_gallery_name);
	  formdata.append("edit_video_gallery_desc", edit_video_gallery_desc);
	  data.new_video_gallery_pics.forEach(function (album_pic) {
	    formdata.append("new_video_gallery_pics[]", album_pic);
	  });
	  // console.log(data.album_pic);
	  data.edit_video_gallery_pics.forEach(function (album_pic) {
	    formdata.append("edit_video_gallery_pics[]", album_pic);
	  });
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/videogallery/update/" + id, formdata, {
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleVideoGalleryData = function getSingleVideoGalleryData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/videogallery/get/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var EditVideoGallery = function (_Component) {
	  _inherits(EditVideoGallery, _Component);
	
	  function EditVideoGallery() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditVideoGallery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditVideoGallery.__proto__ || Object.getPrototypeOf(EditVideoGallery)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      id: "",
	      edit_video_gallery_name: "",
	      edit_video_gallery_desc: "",
	      edit_video_gallery_pics: [],
	      new_video_gallery_pics: []
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.DescReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_video_gallery_desc: val
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        /*let fields = {};
	              fields["edit_department_name"] = "";
	              this.setState({ fields: fields });*/
	        var id = _this.state.id;
	        var data = {
	          edit_album_title: _this.state.edit_video_gallery_name,
	          edit_video_gallery_desc: _this.state.edit_video_gallery_desc,
	          edit_video_gallery_pics: _this.state.edit_video_gallery_pics,
	          new_video_gallery_pics: _this.state.new_video_gallery_pics
	        };
	        updateVideoGallery(id, data, _this.state.edit_video_gallery_name, _this.state.edit_video_gallery_desc, _this.state.edit_video_gallery_pics).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshVideoGalleryData = function (id) {
	      getSingleVideoGalleryData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          console.log(records);
	          _this.setState({
	            id: records.id,
	            edit_video_gallery_name: records.video_gallery_name,
	            edit_video_gallery_desc: records.video_gallery_desc,
	            edit_video_gallery_pics: JSON.parse(records.video_gallery_pics)
	          });
	        } else {
	          _this.setState({
	            id: "",
	            edit_video_gallery_name: "",
	            edit_video_gallery_desc: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditVideoGallery, [{
	    key: "removeImage",
	    value: function removeImage(album_pics, key) {
	      console.log(album_pics, key);
	      var new_video_gallery_pics = this.state.edit_video_gallery_pics.filter(function (pic) {
	        return pic != album_pics;
	      });
	      console.log(new_video_gallery_pics);
	      this.setState({
	        edit_video_gallery_pics: new_video_gallery_pics
	      });
	    }
	  }, {
	    key: "validateForm",
	    value: function validateForm() {
	      //let fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.edit_video_gallery_name) {
	        formIsValid = false;
	        errors["edit_doctor_name"] = "*Please enter your Album name.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onFileChange",
	    value: function onFileChange(file) {
	      var newFiles = Array.prototype.slice.call(file);
	      this.setState({
	        new_video_gallery_pics: newFiles
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshVideoGalleryData(this.props.match.params.id);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Edit Video Gallery"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Video Gallery Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_video_gallery_name",
	                                id: "edit_video_gallery_name",
	                                value: this.state.edit_video_gallery_name,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Album Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_doctor_name
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Video Gallery Description"
	                              ),
	                              _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                id: "desceditor",
	                                name: "desceditor",
	                                value: this.state.edit_video_gallery_desc,
	                                onChange: function onChange(name, val) {
	                                  _this2.DescReactQuillHandleChange(name, val);
	                                }
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Video Gallery Pictures"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                multiple: true,
	                                className: "form-control",
	                                name: "new_video_gallery_pics",
	                                id: "new_video_gallery_pics",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png",
	                                placeholder: "Doctor Fees"
	                              }),
	                              this.state.edit_video_gallery_pics.map(function (album_pic, key) {
	                                console.log(album_pic);
	                                return [_react2.default.createElement("img", {
	                                  className: "mt-3",
	                                  width: "200",
	                                  src: _constants.IMAGE_URL + "AlbumImg/" + album_pic
	                                }), _react2.default.createElement(
	                                  "a",
	                                  {
	                                    onClick: function onClick() {
	                                      return _this2.removeImage(album_pic, key);
	                                    }
	                                  },
	                                  "Remove ",
	                                  key,
	                                  " "
	                                )];
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Update"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return EditVideoGallery;
	}(_react.Component);
	
	exports.default = EditVideoGallery;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateBannerButtonData = function UpdateBannerButtonData(id, data, banner_button_icon, banner_btn_hover_icon) {
	  var formdata = new FormData();
	  formdata.append("edit_banner_button_icon", banner_button_icon);
	  formdata.append("banner_btn_hover_icon", banner_btn_hover_icon);
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/bannerbutton/updatebannerbtndata/" + id, formdata, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleBannerButtonLinkData = function getSingleBannerButtonLinkData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bannerbutton/getsinglebannerbtndata/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var GetAllStaticPages = function GetAllStaticPages(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/staticpages/getallstaticpages", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getDepartments = function getDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var EditBannerButtonLink = function (_Component) {
	  _inherits(EditBannerButtonLink, _Component);
	
	  function EditBannerButtonLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditBannerButtonLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditBannerButtonLink.__proto__ || Object.getPrototypeOf(EditBannerButtonLink)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      banner_btn_id: "",
	      edit_banner_button_icon: "",
	      banner_btn_hover_icon: "",
	      edit_banner_button_text: "",
	      edit_banner_button_sl_no: "",
	      edit_banner_button_link: "",
	      staticpages: [],
	      departments: [],
	      department_id: ""
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      var id = _this.state.banner_btn_id;
	      var data = {
	        //edit_banner_button_icon: this.state.edit_banner_button_icon,
	        edit_banner_button_text: _this.state.edit_banner_button_text,
	        edit_banner_button_sl_no: _this.state.edit_banner_button_sl_no,
	        edit_banner_button_link: _this.state.edit_banner_button_link
	      };
	      UpdateBannerButtonData(id, data, _this.state.edit_banner_button_icon, _this.state.banner_btn_hover_icon).then(function (res) {
	        _reactToastify.toast.success(res.message, {
	          position: _reactToastify.toast.POSITION.TOP_RIGHT
	        });
	        setTimeout(function () {
	          window.location.href = "/admin/bannerbuttonlink";
	        }, 6000);
	      }).catch(function (err) {
	        _reactToastify.toast.error(err, {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	    }, _this.refreshgetSingleBannerButtonLinkData = function (id) {
	      getSingleBannerButtonLinkData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          console.log('kash_req', records);
	          _this.setState({
	            banner_btn_id: records.id,
	            edit_banner_button_icon: records.banner_btn_icon,
	            banner_btn_hover_icon: records.banner_btn_hover_icon,
	            edit_banner_button_text: records.banner_btn_text,
	            edit_banner_button_sl_no: records.sl_no,
	            edit_banner_button_link: records.banner_btn_link
	          });
	        } else {
	          _this.setState({
	            banner_btn_id: "",
	            edit_banner_button_icon: "",
	            banner_btn_hover_icon: "",
	            edit_banner_button_text: "",
	            edit_banner_button_sl_no: "",
	            edit_banner_button_link: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshStaticPages = function (page) {
	      GetAllStaticPages(page).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ staticpages: records });
	        } else {
	          _this.setState({ staticpages: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshDepartments = function () {
	      getDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditBannerButtonLink, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.edit_banner_button_text) {
	        formIsValid = false;
	        errors["edit_banner_button_text"] = "*Please enter the banner button text.";
	      }
	      if (!this.state.edit_banner_button_sl_no) {
	        formIsValid = false;
	        errors["edit_banner_button_sl_no"] = "*Please enter the serial no of the button.";
	      }
	      if (!this.state.edit_banner_button_link) {
	        formIsValid = false;
	        errors["edit_banner_button_link"] = "*Please select the banner button.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onFileChange",
	    value: function onFileChange(file, type) {
	      if (type == "edit_banner_button_icon") {
	        this.setState({
	          edit_banner_button_icon: file[0]
	        });
	      } else if (type == "banner_btn_hover_icon") {
	        this.setState({
	          banner_btn_hover_icon: file[0]
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSingleBannerButtonLinkData(this.props.match.params.id);
	      this.refreshStaticPages();
	      this.refreshDepartments();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-8" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Edit Banner Button Link"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "addbannerbuttonform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Banner Button Icon"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "edit_banner_button_icon",
	                                id: "edit_banner_button_icon",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files, "edit_banner_button_icon");
	                                },
	                                accept: "jpg,png"
	                              }),
	                              this.state.edit_banner_button_icon ? _react2.default.createElement("img", {
	                                src: _constants.IMAGE_URL + "BannerButtonImg/" + this.state.edit_banner_button_icon,
	                                alt: "",
	                                style: {
	                                  width: "150px",
	                                  height: "auto",
	                                  marginTop: "10px",
	                                  borderRadius: "5px"
	                                }
	                              }) : _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Banner Button Hover Icon"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "banner_btn_hover_icon",
	                                id: "banner_btn_hover_icon",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files, "banner_btn_hover_icon");
	                                },
	                                accept: "jpg,png"
	                              }),
	                              this.state.banner_btn_hover_icon ? _react2.default.createElement("img", {
	                                src: _constants.IMAGE_URL + "BannerButtonImg/" + this.state.banner_btn_hover_icon,
	                                alt: "",
	                                style: {
	                                  width: "150px",
	                                  height: "auto",
	                                  marginTop: "10px",
	                                  borderRadius: "5px"
	                                }
	                              }) : _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Banner Button Text"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_banner_button_text",
	                                id: "edit_banner_button_text",
	                                value: this.state.edit_banner_button_text,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Banner Button Text"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_banner_button_text
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Banner Button Link"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  value: this.state.edit_banner_button_link,
	                                  name: "edit_banner_button_link",
	                                  onChange: this.handleChange
	                                },
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "" },
	                                  "Select Page"
	                                ),
	                                this.state.departments.length > 0 ? this.state.departments.map(function (department, index) {
	                                  return _react2.default.createElement(
	                                    "option",
	                                    { value: department.id },
	                                    department.department_name
	                                  );
	                                }) : _react2.default.createElement(
	                                  "option",
	                                  { value: "" },
	                                  "Select Page"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_banner_button_link
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Serial Number"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_banner_button_sl_no",
	                                id: "edit_banner_button_sl_no",
	                                value: this.state.edit_banner_button_sl_no,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Banner Button Serial No"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_banner_button_sl_no
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Update"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return EditBannerButtonLink;
	}(_react.Component);
	
	exports.default = EditBannerButtonLink;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	// import { scAxiosAdmin, thirdparty } from '../..';
	// import { API_TOKEN_NAME } from '../../constants';
	//import { startUserSession } from '../../userSession';
	
	//import Footer from '../../component/admin/Footer';
	//import CKEditor from "react-ckeditor-component";
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var editboardmember = function editboardmember(props) {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      data = _useState2[0],
	      setData = _useState2[1];
	  //   console.log(props.match.params.id, "board_member user details ");
	
	
	  var _useState3 = (0, _react.useState)({
	    designation: "",
	    first_name: "",
	    company: "",
	    status: 1,
	    image: null,
	    serial_order: 0
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      formData = _useState4[0],
	      setFormData = _useState4[1];
	
	  console.log(data, "hello");
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	    if (name === "doctor_id") {
	      // Check if the select element is for doctor_id
	      setFormData(Object.assign({}, formData, {
	        doctor_id: value
	      }));
	    } else {
	      setFormData(Object.assign({}, formData, _defineProperty({}, name, value)));
	    }
	  };
	
	  var handleFileChange = function handleFileChange(e) {
	    var file = e.target.files[0];
	
	    // Check if a file was selected
	    if (file) {
	      // Update the formData state by setting the author_profile_pic to the selected file
	      setFormData(Object.assign({}, formData, {
	        image: file
	      }));
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _.scAxiosAdmin)("/boardmembers/" + props.match.params.id);
	
	              case 3:
	                response = _context.sent;
	
	                console.log("response_data: ", response.data);
	                setData(response.name);
	                setFormData(Object.assign({}, formData, {
	                  designation: response.data.designation,
	                  first_name: response.data.name,
	                  company: response.data.company,
	                  status: response.data.status,
	                  serial_order: response.data.serial_order
	                }));
	                _context.next = 12;
	                break;
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0);
	
	              case 12:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 9]]);
	      }));
	
	      return function fetchData() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	  var handleSubmit = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              e.preventDefault();
	              _context2.prev = 1;
	              _context2.next = 4;
	              return _.thirdparty.post("/boardmembers_update/" + props.match.params.id, formData, {
	                headers: {
	                  "Content-Type": "multipart/form-data"
	                }
	              });
	
	            case 4:
	              response = _context2.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Board Member Updated successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	                setTimeout(function () {
	                  window.location.href = "/admin/boardmembers";
	                }, 3000);
	              }
	              console.log("Form data sent:", response.status);
	              _context2.next = 12;
	              break;
	
	            case 9:
	              _context2.prev = 9;
	              _context2.t0 = _context2["catch"](1);
	
	              console.error("Error submitting form:", _context2.t0);
	              // Handle errors, show error messages, etc.
	
	            case 12:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[1, 9]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(_Seo2.default, {
	      title: "Edit Board Member",
	      description: "Edit Testimonials United Hospital",
	      pathSlug: "/boardmembers_update",
	      keywords: "Edit Testimonials, Testimonials"
	    }),
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      id: "adddepartmentform",
	                      className: "needs-validation",
	                      noValidate: true,
	                      onSubmit: handleSubmit
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-1" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Serial No."
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "number",
	                            className: "form-control",
	                            name: "serial_order",
	                            id: "serial_order",
	                            value: formData.serial_order,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Serial Number"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Name"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "name",
	                            id: "name",
	                            value: formData.name,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Name"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Designation"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "designation",
	                            id: "designation",
	                            value: formData.designation,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Designation"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Company"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "company",
	                            id: "company",
	                            value: formData.company,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Company",
	                            min: "0",
	                            max: "5"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Board Member Image"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "file",
	                            className: "form-control",
	                            name: "image",
	                            id: "image",
	                            onChange: handleFileChange,
	                            accept: "image/*" // Specify the accepted file types if needed
	                            , placeholder: "Doctor Profile Pic"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "submit",
	                            className: "btn waves-effect waves-light"
	                          },
	                          "Submit"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = editboardmember;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _NewReachTextEditor = __webpack_require__(83);
	
	var _NewReachTextEditor2 = _interopRequireDefault(_NewReachTextEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var updateDepartment = function updateDepartment(id, data, edit_department_image, edit_department_image_hover, edit_department_banner_image, selectedPackageId, selectedInvestigationId, descriptions) {
	  var formdata = new FormData();
	  formdata.append("edit_department_image", edit_department_image);
	  formdata.append("edit_department_image_hover", edit_department_image_hover);
	  formdata.append("edit_department_banner_image", edit_department_banner_image);
	  formdata.append("packages", JSON.stringify(selectedPackageId));
	  formdata.append("investigations", JSON.stringify(selectedInvestigationId));
	  formdata.append("description_list", JSON.stringify(descriptions));
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/department/updatedepartment/" + id, formdata, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleDepartmentData = function getSingleDepartmentData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getsingledepartment/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllPackages = function getAllPackages(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/packages/getall", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getInvestigations = function getInvestigations(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/investigations", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAssignedDoctors = function getAssignedDoctors(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctor_dept_rel?department_id=" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var EditDepartment = function (_Component) {
	  _inherits(EditDepartment, _Component);
	
	  function EditDepartment() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditDepartment);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditDepartment.__proto__ || Object.getPrototypeOf(EditDepartment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      department_id: "",
	      edit_department_name: "",
	      edit_department_id: "",
	      edit_department_image: "",
	      edit_department_image_hover: "",
	      edit_department_banner_image: "",
	      descriptions: [{ value: "", visibility: 1, key: _this.generateRandomText() }],
	      packages: [],
	      selectedPackageId: [],
	      packageSearch: "",
	      assignedDoctors: [],
	      investigations: [],
	      selectedInvestigationId: [],
	      investigationSearch: "",
	      editingSlNoIndex: null, // Index of the doctor currently being edited
	      updatedSlNo: "" // Updated sl_no value
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.addDescription = function () {
	      _this.setState(function (prevState) {
	        return {
	          descriptions: [].concat(_toConsumableArray(prevState.descriptions), [{ value: "", visibility: 1 }])
	        };
	      });
	    }, _this.removeDescription = function (index) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions.splice(index, 1); // Remove the description at the given index
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.toggleVisibility = function (index) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions[index].visibility = updatedDescriptions[index].visibility === 1 ? 0 : 1;
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.handleDescriptionChange = function (index, value, key) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions[index].value = value;
	        updatedDescriptions[index].key = key;
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.toggleStatus = function (index) {
	      _this.setState(function (prevState) {
	        var newStatusList = [].concat(_toConsumableArray(prevState.status_list));
	        newStatusList[index].visibility = newStatusList[index].visibility === 1 ? 0 : 1;
	        return { status_list: newStatusList };
	      });
	    }, _this.handlePackagesChange = function (event) {
	      var selectedId = parseInt(event.target.value, 10);
	      _this.setState(function (prevState) {
	        var isSelected = prevState.selectedPackageId.includes(selectedId);
	
	        // Add or remove the selected package ID
	        var updatedSelectedPackages = isSelected ? prevState.selectedPackageId.filter(function (id) {
	          return id !== selectedId;
	        }) : [].concat(_toConsumableArray(prevState.selectedPackageId), [selectedId]);
	
	        return { selectedPackageId: updatedSelectedPackages };
	      });
	    }, _this.handleInvestigationChange = function (event) {
	      var selectedId = parseInt(event.target.value, 10);
	      _this.setState(function (prevState) {
	        var isSelected = prevState.selectedInvestigationId.includes(selectedId);
	
	        // Add or remove the selected package ID
	        var updatedSelectedPackages = isSelected ? prevState.selectedInvestigationId.filter(function (id) {
	          return id !== selectedId;
	        }) : [].concat(_toConsumableArray(prevState.selectedInvestigationId), [selectedId]);
	
	        return { selectedInvestigationId: updatedSelectedPackages };
	      });
	    }, _this.handleSelectionChange = function (type, id) {
	      _this.setState(function (prevState) {
	        var isSelected = prevState[type].includes(id);
	        return _defineProperty({}, type, isSelected ? prevState[type].filter(function (item) {
	          return item !== id;
	        }) : [].concat(_toConsumableArray(prevState[type]), [id]));
	      });
	    }, _this.handleSearchChange = function (searchField, value) {
	      _this.setState(_defineProperty({}, searchField, value));
	    }, _this.renderSearchableDropdown = function (label, type, items, selectedIds, searchField) {
	      var searchValue = _this.state[searchField] || ""; // Retrieve the correct search value
	      var filteredItems = items.filter(function (item) {
	        return (item.name || item.Product_Name || "").toLowerCase().includes(searchValue.toLowerCase());
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "col-sm-6" },
	        _react2.default.createElement(
	          "div",
	          { className: "form-group" },
	          _react2.default.createElement(
	            "label",
	            null,
	            label
	          ),
	          _react2.default.createElement("input", {
	            type: "text",
	            className: "form-control mb-2",
	            placeholder: "Search " + type,
	            value: searchValue,
	            onChange: function onChange(e) {
	              return _this.handleSearchChange(searchField, e.target.value);
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                border: "1px solid #ced4da",
	                borderRadius: "4px",
	                padding: "10px",
	                maxHeight: "200px",
	                overflowY: "scroll"
	              }
	            },
	            filteredItems.length > 0 ? filteredItems.map(function (item) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: item.id,
	                  style: { display: "flex", alignItems: "center" }
	                },
	                _react2.default.createElement("input", {
	                  type: "checkbox",
	                  checked: selectedIds.includes(item.id),
	                  onChange: function onChange() {
	                    return _this.handleSelectionChange(type, item.id);
	                  },
	                  style: { marginRight: "10px" }
	                }),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  item.name || item.Product_Name
	                )
	              );
	            }) : _react2.default.createElement(
	              "p",
	              null,
	              "No ",
	              type,
	              " found"
	            )
	          )
	        )
	      );
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        /*let fields = {};
	              fields["edit_department_name"] = "";
	              this.setState({ fields: fields });*/
	        var id = _this.state.department_id;
	        var data = {
	          edit_department_name: _this.state.edit_department_name
	        };
	        updateDepartment(id, data, _this.state.edit_department_image, _this.state.edit_department_image_hover, _this.state.edit_department_banner_image, _this.state.selectedPackageId, _this.state.selectedInvestigationId, _this.state.descriptions).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.href = "/departments";
	          }, 6000);
	        }).catch(function (err) {
	          _reactToastify.toast.error("Error occured", {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide department name!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.enableEditSlNo = function (index, sl_no) {
	      _this.setState({ editingSlNoIndex: index, updatedSlNo: sl_no });
	    }, _this.handleSlNoChange = function (event) {
	      _this.setState({ updatedSlNo: event.target.value });
	    }, _this.saveSlNo = function (id) {
	      var _this$state = _this.state,
	          updatedSlNo = _this$state.updatedSlNo,
	          department_id = _this$state.department_id,
	          assignedDoctors = _this$state.assignedDoctors;
	
	      var data = { sl_no: updatedSlNo };
	
	      _.scAxiosAdmin.put("/doctor_dept_rel/" + id, data, {
	        headers: {
	          Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	        }
	      }).then(function (res) {
	        _reactToastify.toast.success("SL No. updated successfully", {
	          position: _reactToastify.toast.POSITION.TOP_RIGHT
	        });
	        // Update the state immediately without fetching the data again
	        var updatedDoctors = assignedDoctors.map(function (doctor) {
	          return doctor.id === id ? Object.assign({}, doctor, { sl_no: updatedSlNo }) : doctor;
	        });
	        _this.setState({
	          assignedDoctors: updatedDoctors,
	          editingSlNoIndex: null,
	          updatedSlNo: ""
	        });
	      }).catch(function (err) {
	        _reactToastify.toast.error("Error updating SL No.", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	        console.error(err);
	      });
	    }, _this.cancelEdit = function () {
	      _this.setState({ editingSlNoIndex: null, updatedSlNo: "" });
	    }, _this.refreshgetSingleDepartmentData = function (id) {
	      getSingleDepartmentData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          getAssignedDoctors(records.id).then(function (res) {
	            if (res.status === 200) {
	              var records = res.data;
	
	              _this.setState({
	                assignedDoctors: records
	              });
	            } else {
	              _this.setState({
	                assignedDoctors: []
	              });
	            }
	          }).catch(function (err) {
	            console.log(err);
	          });
	          _this.setState({
	            department_id: records.id,
	            edit_department_name: records.department_name,
	            edit_department_id: records.dept_id,
	            edit_department_image: records.image,
	            edit_department_image_hover: records.image_hover,
	            edit_department_banner_image: records.banner_image,
	            descriptions: JSON.parse(records.description_list) || [{ value: "", visibility: 1, key: _this.generateRandomText() }],
	            selectedPackageId: records.packages || [],
	            selectedInvestigationId: records.investigations || []
	          });
	        } else {
	          _this.setState({
	            department_id: "",
	            edit_department_name: "",
	            edit_department_id: "",
	            edit_department_image: "",
	            edit_department_image_hover: "",
	            edit_department_banner_image: "",
	            descriptions: [{ value: "", visibility: 1, key: _this.generateRandomText() }],
	            selectedPackageId: [],
	            selectedInvestigationId: []
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshgetAllDepartmentData = function () {
	      getAllPackages().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            packages: records
	          });
	        } else {
	          _this.setState({
	            packages: []
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshgetAllInvestigationData = function () {
	      getInvestigations().then(function (res) {
	        if (res.status === 200) {
	          var records = res.data;
	          _this.setState({
	            investigations: records
	          });
	        } else {
	          _this.setState({
	            investigations: []
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditDepartment, [{
	    key: "validateForm",
	    value: function validateForm() {
	      //let fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.edit_department_name) {
	        formIsValid = false;
	        errors["edit_department_name"] = "*Please enter your department name.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	
	    // description logic here
	    // Handle adding a new description field
	
	
	    // Handle removing a specific description field
	
	
	    // Handle toggling visibility of a description
	
	
	    // Handle updating the value of a description field
	
	  }, {
	    key: "generateRandomText",
	    value: function generateRandomText() {
	      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
	
	      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	      var result = "";
	
	      for (var i = 0; i < length; i++) {
	        var randomIndex = Math.floor(Math.random() * characters.length);
	        result += characters.charAt(randomIndex);
	      }
	
	      return result;
	    }
	  }, {
	    key: "onFileChange",
	    value: function onFileChange(file, type) {
	      if (type == "edit_department_image") {
	        this.setState({
	          edit_department_image: file[0]
	        });
	      } else if (type == "edit_department_image_hover") {
	        this.setState({
	          edit_department_image_hover: file[0]
	        });
	      }
	    }
	  }, {
	    key: "onBannerFileChange",
	    value: function onBannerFileChange(file) {
	      this.setState({
	        edit_department_banner_image: file[0]
	      });
	    }
	
	    // Handle package selection
	
	    // Handle package selection
	
	    // Enable editing for a specific sl_no
	
	
	    // Handle the sl_no change
	
	
	    // Save the updated sl_no
	
	
	    // Cancel the edit mode
	
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSingleDepartmentData(this.props.match.params.id);
	      this.refreshgetAllDepartmentData();
	      this.refreshgetAllInvestigationData();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          assignedDoctors = _state.assignedDoctors,
	          editingSlNoIndex = _state.editingSlNoIndex,
	          updatedSlNo = _state.updatedSlNo;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Edit Department"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdepartmentform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_department_name",
	                                id: "edit_department_name",
	                                value: this.state.edit_department_name,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Department Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_department_name
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department Id"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_department_id",
	                                id: "edit_department_id",
	                                value: this.state.edit_department_id,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Department Id",
	                                readOnly: true
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row mb-3" },
	                          this.renderSearchableDropdown("Select Packages", "selectedPackageId", this.state.packages, this.state.selectedPackageId, "packageSearch"),
	                          this.renderSearchableDropdown("Select Investigations", "selectedInvestigationId", this.state.investigations, this.state.selectedInvestigationId, "investigationSearch")
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            "Add Department Descriptions"
	                          ),
	                          this.state.descriptions ? this.state.descriptions.map(function (desc, index) {
	                            return _react2.default.createElement(
	                              "div",
	                              { key: index, className: "row mb-2" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "label",
	                                    null,
	                                    "Description " + (index + 1)
	                                  ),
	                                  _react2.default.createElement(_NewReachTextEditor2.default, {
	                                    id: "Description-" + (index + 1),
	                                    name: "Description-" + (index + 1),
	                                    value: desc.value,
	                                    onChange: function onChange(name, val) {
	                                      return _this2.handleDescriptionChange(index, val, _this2.generateRandomText());
	                                    }
	                                  }),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "d-flex justify-content-between align-items-center" },
	                                    _react2.default.createElement(
	                                      "button",
	                                      {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                          return _this2.toggleVisibility(index);
	                                        },
	                                        className: "btn " + (desc.visibility === 1 ? "btn-success" : "btn-danger") + " mt-2"
	                                      },
	                                      desc.visibility === 1 ? "Hide" : "Show"
	                                    ),
	                                    index > 0 && _react2.default.createElement(
	                                      "button",
	                                      {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                          return _this2.removeDescription(index);
	                                        },
	                                        className: "btn btn-danger ml-2 mt-2"
	                                      },
	                                      "Remove"
	                                    )
	                                  )
	                                )
	                              )
	                            );
	                          }) : "",
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              type: "button",
	                              onClick: this.addDescription,
	                              className: "btn btn-primary mb-3"
	                            },
	                            "Add Description"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department Icon"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "department_icon_show_img_sec mb-2" },
	                                _react2.default.createElement("img", {
	                                  src: _constants.IMAGE_URL + "/DepartmentImage/" + this.state.edit_department_image,
	                                  alt: "",
	                                  width: "130px"
	                                })
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "edit_department_image",
	                                id: "edit_department_image",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files, "edit_department_image");
	                                },
	                                accept: "jpg,png"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department Hover Icon"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "department_icon_show_img_sec mb-2" },
	                                _react2.default.createElement("img", {
	                                  src: _constants.IMAGE_URL + "/DepartmentImage/" + this.state.edit_department_image_hover,
	                                  alt: "",
	                                  width: "130px"
	                                })
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "edit_department_image_hover",
	                                id: "edit_department_image_hover",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files, "edit_department_image_hover");
	                                },
	                                accept: "jpg,png"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department Banner Image"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "department_banner_show_img_sec mb-2" },
	                                _react2.default.createElement("img", {
	                                  src: _constants.IMAGE_URL + "/DepartmentImage/" + this.state.edit_department_banner_image,
	                                  alt: "",
	                                  width: "130px"
	                                })
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "edit_department_banner_image",
	                                id: "edit_department_banner_image",
	                                onChange: function onChange(event) {
	                                  return _this2.onBannerFileChange(event.target.files);
	                                },
	                                accept: "jpg,png"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Update"
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement("hr", { className: "w-75 mx-auto my-5" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "" },
	                        _react2.default.createElement(
	                          "h4",
	                          null,
	                          "Update Assigned doctors serial"
	                        ),
	                        _react2.default.createElement(
	                          "table",
	                          { className: "table table-bordered table-striped table-hover" },
	                          _react2.default.createElement(
	                            "thead",
	                            null,
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "th",
	                                null,
	                                "ID"
	                              ),
	                              _react2.default.createElement(
	                                "th",
	                                null,
	                                "Doctor Name"
	                              ),
	                              _react2.default.createElement(
	                                "th",
	                                null,
	                                "Sl No"
	                              ),
	                              _react2.default.createElement(
	                                "th",
	                                null,
	                                "Action"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tbody",
	                            null,
	                            assignedDoctors.length > 0 ? assignedDoctors.map(function (doctor, index) {
	                              return doctor.doctor_mave ? _react2.default.createElement(
	                                "tr",
	                                { key: doctor.id },
	                                _react2.default.createElement(
	                                  "td",
	                                  null,
	                                  index + 1
	                                ),
	                                _react2.default.createElement(
	                                  "td",
	                                  null,
	                                  doctor.doctor_mave ? doctor.doctor_mave.doctor_name : ""
	                                ),
	                                _react2.default.createElement(
	                                  "td",
	                                  null,
	                                  editingSlNoIndex === index ? _react2.default.createElement("input", {
	                                    type: "number",
	                                    className: "form-control",
	                                    value: updatedSlNo,
	                                    onChange: _this2.handleSlNoChange,
	                                    required: true
	                                  }) : _react2.default.createElement("input", {
	                                    type: "text",
	                                    className: "form-control",
	                                    value: updatedSlNo ? updatedSlNo : doctor.sl_no,
	                                    readOnly: true
	                                  })
	                                ),
	                                _react2.default.createElement(
	                                  "td",
	                                  null,
	                                  editingSlNoIndex === index ? _react2.default.createElement(
	                                    "div",
	                                    { className: "d-flex justify-content-start align-items-center gap-2" },
	                                    _react2.default.createElement(
	                                      "button",
	                                      {
	                                        className: "btn btn-success",
	                                        onClick: function onClick() {
	                                          return _this2.saveSlNo(doctor.id);
	                                        }
	                                      },
	                                      "Save"
	                                    ),
	                                    _react2.default.createElement(
	                                      "button",
	                                      {
	                                        className: "btn btn-danger ml-2",
	                                        onClick: _this2.cancelEdit
	                                      },
	                                      "Cancel"
	                                    )
	                                  ) : _react2.default.createElement(
	                                    "button",
	                                    {
	                                      className: "btn btn-primary",
	                                      onClick: function onClick() {
	                                        return _this2.enableEditSlNo(index, doctor.sl_no);
	                                      }
	                                    },
	                                    "Update"
	                                  )
	                                )
	                              ) : "";
	                            }) : ""
	                          )
	                        ),
	                        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return EditDepartment;
	}(_react.Component);
	
	exports.default = EditDepartment;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _NewReachTextEditor = __webpack_require__(83);
	
	var _NewReachTextEditor2 = _interopRequireDefault(_NewReachTextEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import Footer from '../../component/admin/Footer';
	
	
	var updateDoctor = function updateDoctor(id, data, edit_doctor_desc, edit_doctor_edu, edit_doctor_exp, edit_doctor_profile, Schedule, edit_doc_professional_skills, edit_doc_memberships, edit_doc_awards, edit_doc_key_research_experience, edit_doc_key_publications, edit_doc_key_scientific_presentations,
	// status_list,
	selectedDepartmentId, descriptions, tableHTML) {
	  // console.log("resSc", [{ ...Schedule }]);
	  var formdata = new FormData();
	  formdata.append("edit_doctor_desc", edit_doctor_desc);
	  formdata.append("edit_doctor_edu", edit_doctor_edu);
	  formdata.append("edit_doctor_exp", edit_doctor_exp);
	
	  formdata.append("edit_doctor_profile", edit_doctor_profile);
	  formdata.append("Schedule", JSON.stringify([Schedule]));
	  formdata.append("edit_doc_professional_skills", edit_doc_professional_skills);
	  formdata.append("edit_doc_memberships", edit_doc_memberships);
	  formdata.append("edit_doc_awards", edit_doc_awards);
	  formdata.append("edit_doc_key_research_experience", edit_doc_key_research_experience);
	  formdata.append("edit_doc_key_publications", edit_doc_key_publications);
	  formdata.append("edit_doc_key_scientific_presentations", edit_doc_key_scientific_presentations);
	  // formdata.append("status_list", JSON.stringify(status_list));
	  formdata.append("selectedDepartmentId", selectedDepartmentId);
	  formdata.append("description_list", JSON.stringify(descriptions));
	  formdata.append("doctor_table", JSON.stringify(tableHTML));
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/doctors/updatedoctor/" + id, formdata, {
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleDoctorData = function getSingleDoctorData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/getsingledoctorprofiledata/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllDepartments = function getAllDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var EditDoctor = function (_Component) {
	  _inherits(EditDoctor, _Component);
	
	  function EditDoctor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditDoctor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditDoctor.__proto__ || Object.getPrototypeOf(EditDoctor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	
	      doctor_id: "",
	      edit_doctor_name: "",
	      edit_doctor_degree: "",
	      edit_doctor_fees: "",
	      edit_doctor_designation: "",
	      // edit_doctor_department: "",
	      edit_doctor_profile: "",
	      edit_doctor_desc: "",
	      edit_doctor_edu: "",
	      edit_doctor_exp: "",
	      edit_doc_professional_skills: "",
	      edit_doc_memberships: "",
	      edit_doc_awards: "",
	      edit_doc_key_research_experience: "",
	      edit_doc_key_publications: "",
	      edit_doc_key_scientific_presentations: "",
	      edit_doctor_uhl_id: "",
	      edit_doctor_bmdc_id: "",
	
	      Schedule: {
	        Saturday: "",
	        Sunday: "",
	        Monday: "",
	        Tuesday: "",
	        Wednesday: "",
	        Thursday: "",
	        Friday: ""
	      },
	      // status_list: [
	      //   { field_name: "doctor_desc", visibility: 1 },
	      //   { field_name: "doctor_edu", visibility: 1 },
	      //   { field_name: "doctor_exp", visibility: 1 },
	      //   { field_name: "doc_professional_skills", visibility: 1 },
	      //   { field_name: "doc_memberships", visibility: 1 },
	      //   { field_name: "doc_awards", visibility: 1 },
	      //   { field_name: "doc_key_research_experience", visibility: 1 },
	      //   { field_name: "doc_key_publications", visibility: 1 },
	      //   { field_name: "doc_key_scientific_presentations", visibility: 1 },
	      // ],
	      descriptions: [{ value: "", visibility: 1, key: _this.generateRandomText() }],
	      departments: [],
	      selectedDepartmentId: [], // Holds selected department IDs
	      departmentSearch: "", // Search term for filtering departments
	
	      tableRows: 1, // Default number of rows
	      tableColumns: 1, // Default number of columns
	      tableData: Array(1).fill("").map(function () {
	        return Array(1).fill("");
	      }) // Initialize with empty cells
	    }, _this.handleTableRowsChange = function (event) {
	      var rows = parseInt(event.target.value, 10);
	      _this.setState({
	        tableRows: rows,
	        tableData: Array(rows).fill("").map(function () {
	          return Array(_this.state.tableColumns).fill("");
	        })
	      });
	    }, _this.handleTableColumnsChange = function (event) {
	      var columns = parseInt(event.target.value, 10);
	
	      // Update the number of columns and adjust table data accordingly
	      _this.setState(function (prevState) {
	        // Handle the case where columns are being increased or decreased
	        var newTableData = prevState.tableData.map(function (row) {
	          // If decreasing columns, slice off extra columns
	          if (columns < row.length) {
	            return row.slice(0, columns);
	          }
	          // If increasing columns, add empty cells to fill the new columns
	          return [].concat(_toConsumableArray(row), _toConsumableArray(Array(columns - row.length).fill("")));
	        });
	
	        return {
	          tableColumns: columns,
	          tableData: newTableData
	        };
	      });
	    }, _this.handleTableCellChange = function (e, rowIndex, colIndex) {
	      var newTableData = [].concat(_toConsumableArray(_this.state.tableData));
	      newTableData[rowIndex][colIndex] = e.target.value;
	      _this.setState({ tableData: newTableData });
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.handleScheduleChange = function (event) {
	      console.log("your log output", event.target.value);
	      var Schedule = _this.state.Schedule;
	      Schedule[event.target.name] = event.target.value;
	      _this.setState({
	        Schedule: Schedule
	      });
	    }, _this.DescReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_doctor_desc: val
	      });
	    }, _this.EduReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_doctor_edu: val
	      });
	    }, _this.ExpReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_doctor_exp: val
	      });
	    }, _this.SkillReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_doc_professional_skills: val
	      });
	    }, _this.MembershipReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_doc_memberships: val
	      });
	    }, _this.AwardsReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_doc_awards: val
	      });
	    }, _this.ResearchReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_doc_key_research_experience: val
	      });
	    }, _this.PublicationReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_doc_key_publications: val
	      });
	    }, _this.PresentationReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_doc_key_scientific_presentations: val
	      });
	    }, _this.handleSelectionChange = function (type, id) {
	      _this.setState(function (prevState) {
	        var isSelected = prevState[type].includes(id);
	
	        return _defineProperty({}, type, isSelected ? prevState[type].filter(function (item) {
	          return item !== id;
	        }) // Remove if already selected
	        : [].concat(_toConsumableArray(prevState[type]), [id]));
	      });
	    }, _this.handleSearchChange = function (searchField, value) {
	      _this.setState(_defineProperty({}, searchField, value));
	    }, _this.addDescription = function () {
	      _this.setState(function (prevState) {
	        return {
	          descriptions: [].concat(_toConsumableArray(prevState.descriptions), [{ value: "", visibility: 1 }])
	        };
	      });
	    }, _this.removeDescription = function (index) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions.splice(index, 1); // Remove the description at the given index
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.toggleVisibility = function (index) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions[index].visibility = updatedDescriptions[index].visibility === 1 ? 0 : 1;
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.handleDescriptionChange = function (index, value, key) {
	      _this.setState(function (prevState) {
	        var updatedDescriptions = [].concat(_toConsumableArray(prevState.descriptions));
	        updatedDescriptions[index].value = value;
	        updatedDescriptions[index].key = key;
	        return { descriptions: updatedDescriptions };
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        var tableHTML = _this.generateTableHTML();
	        /*let fields = {};
	              fields["edit_department_name"] = "";
	              this.setState({ fields: fields });*/
	        var id = _this.state.doctor_id;
	        var data = {
	          edit_doctor_name: _this.state.edit_doctor_name,
	          edit_doctor_degree: _this.state.edit_doctor_degree,
	          edit_doctor_fees: _this.state.edit_doctor_fees,
	          designation: _this.state.edit_doctor_designation,
	          // edit_doctor_department: this.state.edit_doctor_department,
	          edit_doctor_uhl_id: _this.state.edit_doctor_uhl_id,
	          edit_doctor_bmdc_id: _this.state.edit_doctor_bmdc_id
	          //edit_doctor_desc: this.state.edit_doctor_desc,
	          //edit_doctor_edu: this.state.edit_doctor_edu,
	          //edit_doctor_exp: this.state.edit_doctor_exp,
	        };
	
	        updateDoctor(id, data, _this.state.edit_doctor_desc, _this.state.edit_doctor_edu, _this.state.edit_doctor_exp, _this.state.edit_doctor_profile, _this.state.Schedule, _this.state.edit_doc_professional_skills, _this.state.edit_doc_memberships, _this.state.edit_doc_awards, _this.state.edit_doc_key_research_experience, _this.state.edit_doc_key_publications, _this.state.edit_doc_key_scientific_presentations,
	        // this.state.status_list,
	        _this.state.selectedDepartmentId, _this.state.descriptions, {
	          row: _this.state.tableRows,
	          column: _this.state.tableColumns,
	          tableHTML: tableHTML // Send table HTML as part of the data
	        }).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.href = "/admin/doctors";
	          }, 6000);
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshgetSingleDoctorData = function (id) {
	      getSingleDoctorData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          var table = JSON.parse(records.doctor_table);
	          _this.setState({
	            doctor_id: records.id,
	            edit_doctor_name: records.doctor_name || "",
	            edit_doctor_degree: records.degree || "",
	            edit_doctor_fees: records.doctor_fees || "",
	            edit_doctor_designation: records.designation || "",
	            edit_doctor_profile: records.doctor_profile || "",
	            edit_doctor_uhl_id: records.uhl_id || "",
	            edit_doctor_bmdc_id: records.bmdc_id || "",
	            Schedule: records.Schedule ? records.Schedule[0] : _this.state.Schedule,
	            // status_list: records.status_list
	            //   ? JSON.parse(records.status_list)
	            //   : [
	            //       { field_name: "doctor_desc", visibility: 1 },
	            //       { field_name: "doctor_edu", visibility: 1 },
	            //       { field_name: "doctor_exp", visibility: 1 },
	            //       { field_name: "doc_professional_skills", visibility: 1 },
	            //       { field_name: "doc_memberships", visibility: 1 },
	            //       { field_name: "doc_awards", visibility: 1 },
	            //       { field_name: "doc_key_research_experience", visibility: 1 },
	            //       { field_name: "doc_key_publications", visibility: 1 },
	            //       {
	            //         field_name: "doc_key_scientific_presentations",
	            //         visibility: 1,
	            //       },
	            //     ],
	            selectedDepartmentId: records.departments_mave.map(function (item) {
	              return item.id;
	            }) || [],
	            descriptions: JSON.parse(records.description_list) || [{ value: "", visibility: 1, key: _this.generateRandomText() }],
	
	            tableRows: records.doctor_table ? JSON.parse(records.doctor_table).row : 1,
	            tableColumns: records.doctor_table ? JSON.parse(records.doctor_table).column : 1,
	            tableData: records.doctor_table ? Array(table.row).fill("").map(function () {
	              return Array(table.row).fill("");
	            }) : Array(1).fill("").map(function () {
	              return Array(1).fill("");
	            })
	          });
	        } else {
	          _this.setState({
	            doctor_id: "",
	            edit_doctor_name: "",
	            edit_doctor_degree: "",
	            edit_doctor_fees: "",
	            // edit_doctor_department: "",
	            edit_doctor_profile: "",
	            edit_doctor_desc: "",
	            edit_doctor_exp: "",
	            edit_doctor_edu: "",
	            edit_doc_professional_skills: "",
	            edit_doc_memberships: "",
	            edit_doc_awards: "",
	            edit_doc_key_research_experience: "",
	            edit_doc_key_publications: "",
	            edit_doc_key_scientific_presentations: "",
	            edit_doctor_uhl_id: "",
	            edit_doctor_bmdc_id: "",
	            descriptions: [{ value: "", visibility: 1, key: _this.generateRandomText() }]
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshDepartments = function () {
	      getAllDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditDoctor, [{
	    key: "validateForm",
	    value: function validateForm() {
	      //let fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.edit_doctor_name) {
	        formIsValid = false;
	        errors["edit_doctor_name"] = "*Please enter your doctor name.";
	      }
	      // if (!this.state.edit_doctor_degree) {
	      //   formIsValid = false;
	      //   errors["edit_doctor_degree"] = "*Please enter your doctor degree.";
	      // }
	      // if (!this.state.edit_doctor_fees) {
	      //   formIsValid = false;
	      //   errors["edit_doctor_fees"] = "*Please enter your doctor fees.";
	      // }
	      // if (!this.state.edit_doctor_department) {
	      //   formIsValid = false;
	      //   errors["edit_doctor_department"] =
	      //     "*Please enter your doctor department.";
	      // }
	      // if (!this.state.edit_doctor_uhl_id) {
	      //   formIsValid = false;
	      //   errors["edit_doctor_uhl_id"] = "*Please enter your doctor uhl id.";
	      // }
	      // if (!this.state.edit_doctor_bmdc_id) {
	      //   formIsValid = false;
	      //   errors["edit_doctor_bmdc_id"] = "*Please enter your doctor bmdc id.";
	      // }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	
	    // Handle change in number of rows
	
	
	    // Handle change in number of columns
	
	
	    // Handle individual cell change
	
	  }, {
	    key: "generateTableHTML",
	    value: function generateTableHTML() {
	      var tableHTML = "<table class='table table-secondary table-striped table-hover'>";
	
	      this.state.tableData.forEach(function (row, rowIndex) {
	        tableHTML += "<tr>";
	
	        row.forEach(function (cell, colIndex) {
	          // Check if it's the first row (header row)
	          if (rowIndex === 0) {
	            // Use <th> for header cells to make the text bold
	            tableHTML += "<th>" + cell + "</th>";
	          } else {
	            // Use <td> for other rows (content cells)
	            tableHTML += "<td>" + cell + "</td>";
	          }
	        });
	
	        tableHTML += "</tr>";
	      });
	
	      tableHTML += "</table>";
	      return tableHTML;
	    }
	
	    // multiple select search dropdown
	
	  }, {
	    key: "onFileChange",
	
	    // toggleStatus = (index) => {
	    //   this.setState((prevState) => {
	    //     const newStatusList = [...prevState.status_list];
	    //     newStatusList[index].visibility =
	    //       newStatusList[index].visibility === 1 ? 0 : 1;
	    //     return { status_list: newStatusList };
	    //   });
	    // };
	    /*onBlur(evt){
	        console.log("onBlur event called with event info: ", evt);
	      }
	      afterPaste(evt){
	        console.log("afterPaste event called with event info: ", evt);
	      }*/
	    value: function onFileChange(file) {
	      this.setState({
	        edit_doctor_profile: file[0]
	      });
	    }
	
	    // description logic here
	
	    // Handle adding a new description field
	
	
	    // Handle removing a specific description field
	
	
	    // Handle toggling visibility of a description
	
	
	    // Handle updating the value of a description field
	
	  }, {
	    key: "generateRandomText",
	    value: function generateRandomText() {
	      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
	
	      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	      var result = "";
	
	      for (var i = 0; i < length; i++) {
	        var randomIndex = Math.floor(Math.random() * characters.length);
	        result += characters.charAt(randomIndex);
	      }
	
	      return result;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSingleDoctorData(this.props.match.params.id);
	      this.refreshDepartments();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          departments = _state.departments,
	          departmentSearch = _state.departmentSearch,
	          selectedDepartmentId = _state.selectedDepartmentId;
	
	
	      var filteredDepartments = departments.filter(function (department) {
	        return department.department_name.toLowerCase().includes(departmentSearch.toLowerCase());
	      });
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Edit Doctor"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        console.log("sdfsfsd", this.state.Schedule),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-4" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_doctor_name",
	                                id: "edit_doctor_name",
	                                value: this.state.edit_doctor_name,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_doctor_name
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-4" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Degree"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_doctor_degree",
	                                id: "edit_doctor_degree",
	                                value: this.state.edit_doctor_degree,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor Degree"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_doctor_degree
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-4" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Designation"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_doctor_designation",
	                                id: "edit_doctor_designation",
	                                value: this.state.edit_doctor_designation,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor Designation"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_doctor_designation
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Department"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control mb-2",
	                                placeholder: "Search departments",
	                                value: departmentSearch,
	                                onChange: function onChange(e) {
	                                  return _this2.handleSearchChange("departmentSearch", e.target.value);
	                                }
	                              }),
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  style: {
	                                    border: "1px solid #ced4da",
	                                    borderRadius: "4px",
	                                    padding: "10px",
	                                    maxHeight: "200px",
	                                    overflowY: "scroll"
	                                  }
	                                },
	                                filteredDepartments.length > 0 ? filteredDepartments.map(function (department) {
	                                  return _react2.default.createElement(
	                                    "div",
	                                    {
	                                      key: department.id,
	                                      style: {
	                                        display: "flex",
	                                        alignItems: "center"
	                                      }
	                                    },
	                                    _react2.default.createElement("input", {
	                                      type: "checkbox",
	                                      value: department.dept_id,
	                                      checked: selectedDepartmentId.includes(department.id),
	                                      onChange: function onChange() {
	                                        return _this2.handleSelectionChange("selectedDepartmentId", department.id);
	                                      },
	                                      style: { marginRight: "10px" }
	                                    }),
	                                    _react2.default.createElement(
	                                      "span",
	                                      null,
	                                      department.department_name
	                                    )
	                                  );
	                                }) : _react2.default.createElement(
	                                  "p",
	                                  null,
	                                  "No departments found"
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Fees"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "number",
	                                className: "form-control",
	                                name: "edit_doctor_fees",
	                                id: "edit_doctor_fees",
	                                value: this.state.edit_doctor_fees,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor Fees"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_doctor_fees
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor UHL Id:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_doctor_uhl_id",
	                                id: "edit_doctor_uhl_id",
	                                value: this.state.edit_doctor_uhl_id,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor UHL Id"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_doctor_uhl_id
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor BMDC Id"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_doctor_bmdc_id",
	                                id: "edit_doctor_bmdc_id",
	                                value: this.state.edit_doctor_bmdc_id,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Doctor BMDC Id"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_doctor_bmdc_id
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            "Add Department Descriptions"
	                          ),
	                          this.state.descriptions ? this.state.descriptions.map(function (desc, index) {
	                            return _react2.default.createElement(
	                              "div",
	                              { key: index, className: "row mb-2" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "label",
	                                    null,
	                                    "Description " + (index + 1)
	                                  ),
	                                  _react2.default.createElement(_NewReachTextEditor2.default, {
	                                    id: "Description-" + (index + 1),
	                                    name: "Description-" + (index + 1),
	                                    value: desc.value,
	                                    onChange: function onChange(name, val) {
	                                      return _this2.handleDescriptionChange(index, val, _this2.generateRandomText());
	                                    }
	                                  }),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "d-flex justify-content-between align-items-center" },
	                                    _react2.default.createElement(
	                                      "button",
	                                      {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                          return _this2.toggleVisibility(index);
	                                        },
	                                        className: "btn " + (desc.visibility === 1 ? "btn-success" : "btn-danger") + " mt-2"
	                                      },
	                                      desc.visibility === 1 ? "Hide" : "Show"
	                                    ),
	                                    index > 0 && _react2.default.createElement(
	                                      "button",
	                                      {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                          return _this2.removeDescription(index);
	                                        },
	                                        className: "btn btn-danger ml-2 mt-2"
	                                      },
	                                      "Remove"
	                                    )
	                                  )
	                                )
	                              )
	                            );
	                          }) : "",
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              type: "button",
	                              onClick: this.addDescription,
	                              className: "btn btn-primary mb-3"
	                            },
	                            "Add Description"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "h4",
	                                null,
	                                "Table Content"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "label",
	                                    null,
	                                    "Number of Rows"
	                                  ),
	                                  _react2.default.createElement("input", {
	                                    type: "number",
	                                    min: "1",
	                                    className: "form-control",
	                                    value: this.state.tableRows,
	                                    onChange: this.handleTableRowsChange
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "label",
	                                    null,
	                                    "Number of Columns"
	                                  ),
	                                  _react2.default.createElement("input", {
	                                    type: "number",
	                                    min: "1",
	                                    className: "form-control",
	                                    value: this.state.tableColumns,
	                                    onChange: this.handleTableColumnsChange
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "row" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "col-sm-12" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                      "label",
	                                      null,
	                                      "Table Content"
	                                    ),
	                                    _react2.default.createElement(
	                                      "table",
	                                      { border: "1", className: "table" },
	                                      _react2.default.createElement(
	                                        "tbody",
	                                        null,
	                                        this.state.tableData.map(function (row, rowIndex) {
	                                          return _react2.default.createElement(
	                                            "tr",
	                                            { key: rowIndex },
	                                            row.map(function (cell, colIndex) {
	                                              return _react2.default.createElement(
	                                                "td",
	                                                { key: colIndex },
	                                                _react2.default.createElement("input", {
	                                                  type: "text",
	                                                  value: cell,
	                                                  onChange: function onChange(e) {
	                                                    return _this2.handleTableCellChange(e, rowIndex, colIndex);
	                                                  },
	                                                  placeholder: "Enter text"
	                                                })
	                                              );
	                                            })
	                                          );
	                                        })
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Profile"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "edit_doctor_profile",
	                                id: "edit_doctor_profile",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png",
	                                placeholder: "Doctor Fees"
	                              }),
	                              this.state.edit_doctor_profile ? _react2.default.createElement("img", {
	                                src: _constants.IMAGE_URL + "DoctorProfileImg/" + this.state.edit_doctor_profile,
	                                alt: "",
	                                style: {
	                                  width: "150px",
	                                  height: "auto",
	                                  marginTop: "10px",
	                                  borderRadius: "5px"
	                                }
	                              }) : _react2.default.createElement("img", { src: _avatar_circle2.default, width: "100px", alt: "" })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { className: "mt-4 header-title" },
	                          "Doctor Schedule"
	                        ),
	                        _react2.default.createElement("hr", null),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-6 col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Saturday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Saturday",
	                                value: this.state.Schedule.Saturday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Sunday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Sunday",
	                                value: this.state.Schedule.Sunday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Monday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Monday",
	                                value: this.state.Schedule.Monday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Tuesday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Tuesday",
	                                value: this.state.Schedule.Tuesday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Wednesday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Wednesday",
	                                value: this.state.Schedule.Wednesday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Thursday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Thursday",
	                                value: this.state.Schedule.Thursday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group d-flex justify-content-between" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Friday:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                placeholder: "e.g., 09:00 AM - 08:00 PM",
	                                className: "form-control w-50",
	                                name: "Friday",
	                                value: this.state.Schedule.Friday,
	                                onChange: function onChange(e) {
	                                  return _this2.handleScheduleChange(e);
	                                }
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Update"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return EditDoctor;
	}(_react.Component);
	
	exports.default = EditDoctor;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var updateHeaderAnnoucement = function updateHeaderAnnoucement(id, data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/headerannoucement/updateheaderannoucement/" + id, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleHeaderAnnoucementData = function getSingleHeaderAnnoucementData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/headerannoucement/getsingleheaderannoucement/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var EditHeaderAnnoucement = function (_Component) {
	  _inherits(EditHeaderAnnoucement, _Component);
	
	  function EditHeaderAnnoucement() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditHeaderAnnoucement);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditHeaderAnnoucement.__proto__ || Object.getPrototypeOf(EditHeaderAnnoucement)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      id: "",
	      edit_header_annoucement_text: "",
	      edit_header_annoucement_link: "",
	      edit_header_phone_no: ""
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        var id = _this.state.id;
	        var data = {
	          edit_header_annoucement_text: _this.state.edit_header_annoucement_text,
	          edit_header_annoucement_link: _this.state.edit_header_annoucement_link,
	          edit_header_phone_no: _this.state.edit_header_phone_no
	        };
	        updateHeaderAnnoucement(id, data).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.href = "/headerannoucement";
	          }, 6000);
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshgetSingleHeaderAnnoucementData = function (id) {
	      getSingleHeaderAnnoucementData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            id: records.id,
	            edit_header_annoucement_text: records.header_annoucement_text,
	            edit_header_annoucement_link: records.header_annoucement_link,
	            edit_header_phone_no: records.header_phone_no
	          });
	        } else {
	          _this.setState({
	            id: "",
	            edit_header_annoucement_text: "",
	            edit_header_annoucement_link: "",
	            edit_header_phone_no: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditHeaderAnnoucement, [{
	    key: "validateForm",
	    value: function validateForm() {
	      //let fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.edit_header_annoucement_text) {
	        formIsValid = false;
	        errors["edit_header_annoucement_text"] = "*Please enter the header annoucement title.";
	      }
	      if (!this.state.edit_header_annoucement_link) {
	        formIsValid = false;
	        errors["edit_header_annoucement_link"] = "*Please enter the header annoucement link.";
	      }
	      if (!this.state.edit_header_phone_no) {
	        formIsValid = false;
	        errors["edit_header_phone_no"] = "*Please enter the header phone no.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // this.refreshgetSingleHeaderAnnoucementData(this.props.match.params.id);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Edit Header Annoucement"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Header Annoucement Text"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_header_annoucement_text",
	                                id: "edit_header_annoucement_text",
	                                value: this.state.edit_header_annoucement_text,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Header Annoucement Text"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_header_annoucement_text
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Header Annoucement Link"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_header_annoucement_link",
	                                id: "edit_header_annoucement_link",
	                                value: this.state.edit_header_annoucement_link,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Header Annoucement Link"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_header_annoucement_link
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Header Phone No."
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_header_phone_no",
	                                id: "edit_header_phone_no",
	                                value: this.state.edit_header_phone_no,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Header Phone No"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_header_phone_no
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Submit"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return EditHeaderAnnoucement;
	}(_react.Component);
	
	exports.default = EditHeaderAnnoucement;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var updatemenu = function updatemenu(id, data) {
	    var formdata = new FormData();
	    return new Promise(function (resolve, reject) {
	        var req = _.scAxiosAdmin.post('/menu/updatemenu/' + id, formdata, {
	            headers: {
	                'Accept': 'application/json',
	                'Content-Type': 'multipart/form-data; boundary=' + formdata._boundary,
	                'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	            },
	            params: Object.assign({}, data)
	        });
	        req.then(function (res) {
	            return resolve(res.data);
	        }).catch(function (err) {
	            return reject(err);
	        });
	    });
	};
	var getSingleMenu = function getSingleMenu(id) {
	    return new Promise(function (resolve, reject) {
	        var req = _.scAxiosAdmin.request('/menu/getsinglemenu/' + id, {
	            method: 'get',
	            headers: {
	                'Accept': 'application/json',
	                'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	            }
	        });
	        req.then(function (res) {
	            return resolve(res.data);
	        }).catch(function (err) {
	            return reject(err);
	        });
	    });
	};
	
	var GetAllStaticPages = function GetAllStaticPages(data) {
	    return new Promise(function (resolve, reject) {
	        var req = _.scAxiosAdmin.request('/staticpages/getallstaticpages', {
	            method: 'get',
	            headers: {
	                'Accept': 'application/json',
	                'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	            },
	            params: Object.assign({}, data)
	        });
	        req.then(function (res) {
	            return resolve(res.data);
	        }).catch(function (err) {
	            return reject(err);
	        });
	    });
	};
	
	var alertStyle = {
	    color: 'red'
	};
	
	var editmenu = function (_Component) {
	    _inherits(editmenu, _Component);
	
	    function editmenu() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, editmenu);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = editmenu.__proto__ || Object.getPrototypeOf(editmenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            fields: {},
	            errors: {},
	            menu_id: '',
	            staticpages: [],
	            edit_menu_title: '',
	            edit_menu_url: '',
	            edit_current_status: ''
	        }, _this.handleChange = function (event) {
	            _this.setState({ errors: '' });
	            var fields = _this.state.fields;
	            fields[event.target.name] = event.target.value;
	            _this.setState({
	                fields: fields
	            }, function () {
	                return _this.validateForm();
	            });
	            _this.setState(_defineProperty({}, event.target.name, event.target.value));
	        }, _this.refreshStaticPages = function (page) {
	            GetAllStaticPages(page).then(function (res) {
	                if (res.status === true) {
	                    var records = res.data.data;
	                    _this.setState({ staticpages: records });
	                } else {
	                    _this.setState({ staticpages: '' });
	                }
	                _this.setState({ enableShdo: false });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }, _this.handleSubmit = function (event) {
	            event.preventDefault();
	            if (_this.validateForm() === true) {
	                /*let fields = {};
	                fields["edit_department_name"] = "";
	                this.setState({ fields: fields });*/
	                var id = _this.state.menu_id;
	                var data = {
	                    edit_menu_title: _this.state.edit_menu_title,
	                    edit_menu_url: _this.state.edit_menu_url,
	                    edit_current_status: _this.state.edit_current_status
	
	                };
	                updatemenu(id, data).then(function (res) {
	                    _reactToastify.toast.success(res.message, {
	                        position: _reactToastify.toast.POSITION.TOP_RIGHT
	                    });
	                    setTimeout(function () {
	                        window.location.href = '/menu';
	                    }, 6000);
	                }).catch(function (err) {
	                    _reactToastify.toast.error(err, {
	                        position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                    });
	                });
	            } else {
	                _reactToastify.toast.error('Please provide all required fields!', {
	                    position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                });
	            }
	        }, _this.refreshgetSingleMenu = function (id) {
	            getSingleMenu(id).then(function (res) {
	                if (res.status === true) {
	                    var records = res.data;
	                    _this.setState({
	                        menu_id: records.id,
	                        edit_menu_title: records.title,
	                        edit_menu_url: records.static_page_id,
	                        edit_current_status: records.current_status
	                    });
	                } else {
	                    _this.setState({
	                        menu_id: '',
	                        edit_menu_title: '',
	                        edit_menu_url: '',
	                        edit_current_status: ''
	                    });
	                }
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(editmenu, [{
	        key: 'validateForm',
	        value: function validateForm() {
	            //let fields = this.state.fields;
	            var errors = {};
	            var formIsValid = true;
	            if (!this.state.edit_menu_title) {
	                formIsValid = false;
	                errors["edit_menu_title"] = "*Please enter the menu title.";
	            }
	
	            this.setState({
	                errors: errors
	            });
	            return formIsValid;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refreshgetSingleMenu(this.props.match.params.id);
	            this.refreshStaticPages();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'fixed-left' },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'wrapper' },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-page' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'page-content-wrapper' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'card m-b-20' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'card-body' },
	                                            _react2.default.createElement(
	                                                'h4',
	                                                { className: 'mt-0 header-title' },
	                                                'Edit Menu'
	                                            ),
	                                            _react2.default.createElement(
	                                                'form',
	                                                { onSubmit: this.handleSubmit, id: 'editdoctorform', className: 'needs-validation', noValidate: true },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Title'
	                                                            ),
	                                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'edit_menu_title', id: 'package_name', value: this.state.edit_menu_title, onChange: this.handleChange, required: true, placeholder: 'Menu Title' }),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { style: alertStyle },
	                                                                this.state.errors.edit_menu_title
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Status'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'select',
	                                                                { className: 'form-control', value: this.state.edit_current_status, name: 'edit_current_status', onChange: this.handleChange },
	                                                                _react2.default.createElement(
	                                                                    'option',
	                                                                    { value: 'active' },
	                                                                    'Active'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'option',
	                                                                    { value: 'deleted' },
	                                                                    'Deleted'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { style: alertStyle },
	                                                                this.state.errors.edit_current_status
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Edit page'
	                                                            ),
	                                                            this.state.edit_menu_title === 'Packages' ? _react2.default.createElement(
	                                                                'select',
	                                                                { className: 'form-control', value: this.state.edit_menu_url, name: 'edit_menu_url', onChange: this.handleChange, disabled: true },
	                                                                this.state.staticpages.length > 0 ? this.state.staticpages.map(function (cpage, index) {
	                                                                    return _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: cpage.id },
	                                                                        cpage.title
	                                                                    );
	                                                                }) : _react2.default.createElement(
	                                                                    'option',
	                                                                    { value: '' },
	                                                                    'Select Department'
	                                                                )
	                                                            ) : _react2.default.createElement(
	                                                                'select',
	                                                                { className: 'form-control', value: this.state.edit_menu_url, name: 'edit_menu_url', onChange: this.handleChange },
	                                                                this.state.staticpages.length > 0 ? this.state.staticpages.map(function (cpage, index) {
	                                                                    return _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: cpage.id },
	                                                                        cpage.title
	                                                                    );
	                                                                }) : _react2.default.createElement(
	                                                                    'option',
	                                                                    { value: '' },
	                                                                    'Select Department'
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { type: 'submit', className: 'btn btn-pink waves-effect waves-light' },
	                                                            'Submit'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	            );
	        }
	    }]);
	
	    return editmenu;
	}(_react.Component);
	
	exports.default = editmenu;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import Footer from '../../component/admin/Footer';
	
	//import CKEditor from "react-ckeditor-component";
	
	
	var updateNewevent = function updateNewevent(id, data, edit_news_events_desc, imageData) {
	  var formdata = new FormData();
	  formdata.append("edit_news_events_desc", edit_news_events_desc);
	  formdata.append("edit_news_events_pic", imageData);
	
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/newsevents/updatenewsevents/" + id, formdata, {
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleNewsEvent = function getSingleNewsEvent(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/newsevents/getsinglenewsevents/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllDepartments = function getAllDepartments() {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getalldepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var EditNewsEvent = function (_Component) {
	  _inherits(EditNewsEvent, _Component);
	
	  function EditNewsEvent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditNewsEvent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditNewsEvent.__proto__ || Object.getPrototypeOf(EditNewsEvent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      departments: [],
	      type: "",
	      news_id: "",
	      edit_news_events_title: "",
	      edit_news_events_desc: "",
	      edit_news_events_pic: "",
	      news_events_date: "", // New state for event date
	      news_events_tag: "" // New state for department
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.DescQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_news_events_desc: val
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        /*let fields = {};
	              fields["edit_department_name"] = "";
	              this.setState({ fields: fields });*/
	        var id = _this.state.news_id;
	        var data = {
	          edit_news_events_title: _this.state.edit_news_events_title,
	          edit_news_events_desc: _this.state.edit_news_events_desc,
	          news_events_date: _this.state.news_events_date,
	          news_events_tag: _this.state.news_events_tag,
	          type: _this.state.type
	        };
	        console.log('data', data);
	        updateNewevent(id, data, _this.state.edit_news_events_desc, _this.state.edit_news_events_pic).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          // setTimeout(function(){
	          //     window.location.href = '/newsevents';
	          // }, 3000);
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshgetSingleNewsEvent = function (id) {
	      getSingleNewsEvent(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            news_id: records.id,
	            edit_news_events_title: records.news_events_title,
	            edit_news_events_desc: records.news_events_desc,
	            edit_news_events_pic: records.news_events_pic,
	            news_events_date: records.news_events_date,
	            news_events_tag: records.news_events_tag,
	            type: records.type
	          });
	        } else {
	          _this.setState({
	            news_id: "",
	            edit_news_events_title: "",
	            edit_news_events_desc: "",
	            edit_news_events_pic: "",
	            news_events_date: "",
	            news_events_tag: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshDepartments = function () {
	      getAllDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditNewsEvent, [{
	    key: "validateForm",
	    value: function validateForm() {
	      //let fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.news_events_date) {
	        formIsValid = false;
	        errors["news_events_date"] = "*Please enter the event date.";
	      }
	      if (!this.state.edit_news_events_title) {
	        formIsValid = false;
	        errors["edit_news_events_title"] = "*Please enter the news name.";
	      }
	
	      if (!this.state.edit_news_events_desc) {
	        formIsValid = false;
	        errors["edit_news_events_desc"] = "*Please enter the news description.";
	      }
	
	      if (!this.state.news_events_tag) {
	        formIsValid = false;
	        errors["news_events_tag"] = "*Please select a department.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onFileChange",
	
	    /*onChange = (evt) =>{
	        //console.log("onChange fired with event info: ", evt);
	        var newContent = evt.editor.getData();
	        this.setState({
	          edit_news_events_desc: newContent,
	        })
	      }*/
	    /*onBlur(evt){
	        console.log("onBlur event called with event info: ", evt);
	      }
	      afterPaste(evt){
	        console.log("afterPaste event called with event info: ", evt);
	      }*/
	    value: function onFileChange(file) {
	      this.setState({
	        edit_news_events_pic: file[0]
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSingleNewsEvent(this.props.match.params.id);
	      this.refreshDepartments();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Edit News Event"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-4" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Type"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                { value: this.state.type, className: "form-control", name: "type",
	                                  onChange: this.handleChange },
	                                _react2.default.createElement(
	                                  "option",
	                                  { defaultValue: true },
	                                  "Select Any"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "News" },
	                                  "News"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "Events" },
	                                  "Events"
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-4" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Event Date"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "date",
	                                className: "form-control",
	                                name: "news_events_date",
	                                id: "news_events_date",
	                                value: this.state.news_events_date,
	                                onChange: this.handleChange,
	                                required: true
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.news_events_date
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_news_events_title",
	                                id: "edit_news_events_title",
	                                value: this.state.edit_news_events_title,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_news_events_title
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Description"
	                              ),
	                              _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                id: "editdescnewseditor",
	                                name: "editdescnewseditor",
	                                value: this.state.edit_news_events_desc,
	                                onChange: function onChange(name, val) {
	                                  _this2.DescQuillHandleChange(name, val);
	                                }
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_news_events_desc
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Image"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "edit_news_events_pic",
	                                id: "edit_news_events_pic",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png",
	                                placeholder: "Doctor Fees"
	                              }),
	                              this.state.edit_news_events_pic ? _react2.default.createElement("img", {
	                                src: _constants.IMAGE_URL + "NewsEventsImg/" + this.state.edit_news_events_pic,
	                                alt: "",
	                                style: {
	                                  width: "150px",
	                                  height: "auto",
	                                  "margin-top": "10px",
	                                  "border-radius": "5px"
	                                }
	                              }) : _react2.default.createElement("img", { src: _avatar_circle2.default, width: "100px", alt: "" })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Department"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  name: "news_events_tag",
	                                  id: "news_events_tag",
	                                  value: this.state.news_events_tag,
	                                  onChange: this.handleChange,
	                                  required: true
	                                },
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "" },
	                                  "Select Department"
	                                ),
	                                this.state.departments.map(function (department) {
	                                  return _react2.default.createElement(
	                                    "option",
	                                    {
	                                      key: department.id,
	                                      value: department.department_name
	                                    },
	                                    department.department_name
	                                  );
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.news_events_tag
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Update"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return EditNewsEvent;
	}(_react.Component);
	
	exports.default = EditNewsEvent;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var updatepackage = function updatepackage(id, data, edit_package_description, imageData, imageBannerData) {
	
	  var formdata = new FormData();
	  formdata.append("edit_package_description", edit_package_description);
	  formdata.append("edit_package_profile", imageData);
	  formdata.append("edit_package_banner_image", imageBannerData);
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/packages/updatepackage/" + id, formdata, {
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSinglePackageData = function getSinglePackageData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/packages/getsinglepackagedata/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllDepartments = function getAllDepartments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/department/getdepartments", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getAllPreExistingConditon = function getAllPreExistingConditon(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/packages/getallprecondtion", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var EditPackage = function (_Component) {
	  _inherits(EditPackage, _Component);
	
	  function EditPackage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditPackage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditPackage.__proto__ || Object.getPrototypeOf(EditPackage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      departments: [],
	      pre_existing_conditon: [],
	      package_id: "",
	      edit_package_name: "",
	      edit_package_description: "",
	      edit_package_amount: "",
	      edit_package_amount_opd: "",
	      edit_package_amount_ipd: "",
	      edit_package_dept_id: "",
	      edit_package_pre_existing_conditon_id: "",
	      edit_package_age: "",
	      edit_package_gender: "",
	      edit_package_profile: "",
	      edit_package_banner_image: ""
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.DescReactQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_package_description: val
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        var id = _this.state.package_id;
	        var data = {
	          edit_package_name: _this.state.edit_package_name,
	          edit_package_pre_existing_conditon_id: _this.state.edit_package_pre_existing_conditon_id,
	          edit_package_amount: _this.state.edit_package_amount,
	          edit_package_amount_opd: _this.state.edit_package_amount_opd,
	          edit_package_amount_ipd: _this.state.edit_package_amount_ipd,
	          edit_package_dept_id: _this.state.edit_package_dept_id,
	          edit_package_age: _this.state.edit_package_age,
	          edit_package_gender: _this.state.edit_package_gender
	        };
	        updatepackage(id, data, _this.state.edit_package_description, _this.state.edit_package_profile, _this.state.edit_package_banner_image).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          //   setTimeout(function () {
	          //     window.location.href = "/admin/packages";
	          //   }, 6000);
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshgetSinglePackageData = function (id) {
	      getSinglePackageData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            package_id: records.id,
	            edit_package_name: records.name,
	            edit_package_description: records.description,
	            edit_package_profile: records.image,
	            edit_package_banner_image: records.banner_image,
	            edit_package_amount_opd: records.opd_amount,
	            edit_package_amount_ipd: records.ipd_amount,
	            edit_package_dept_id: records.dept_id,
	            edit_package_gender: records.gender,
	            edit_package_age: records.age,
	            edit_package_pre_existing_conditon_id: records.pre_existing_conditon_id
	          });
	        } else {
	          _this.setState({
	            package_id: "",
	            edit_package_name: "",
	            edit_package_description: "",
	            edit_package_profile: "",
	            edit_package_banner_image: "",
	            edit_package_amount: "",
	            edit_package_dept_id: "",
	            edit_package_gender: "",
	            edit_package_age: "",
	            edit_package_pre_existing_conditon_id: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshDepartments = function () {
	      getAllDepartments().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ departments: records });
	        } else {
	          _this.setState({ departments: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshPreExistingConditon = function (event) {
	      getAllPreExistingConditon().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ pre_existing_conditon: records });
	        } else {
	          _this.setState({ pre_existing_conditon: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditPackage, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.edit_package_name) {
	        formIsValid = false;
	        errors["edit_package_name"] = "*Please enter the package name.";
	      }
	      if (!this.state.edit_package_amount_opd || !this.state.edit_package_amount_ipd) {
	        formIsValid = false;
	        errors["edit_package_amount"] = "*Please enter the package amount.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onFileChange",
	    value: function onFileChange(file) {
	      this.setState({
	        edit_package_profile: file[0]
	      });
	    }
	  }, {
	    key: "onBannerFileChange",
	    value: function onBannerFileChange(file) {
	      this.setState({
	        edit_package_banner_image: file[0]
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSinglePackageData(this.props.match.params.id);
	      this.refreshDepartments();
	      this.refreshPreExistingConditon();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Edit Package"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_package_name",
	                                id: "package_name",
	                                value: this.state.edit_package_name,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Package Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_package_name
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-3" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "OPD Amount"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "number",
	                                className: "form-control",
	                                name: "edit_package_amount_opd",
	                                id: "edit_package_amount",
	                                value: this.state.edit_package_amount_opd,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "OPD Package Fees"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_package_amount
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-3" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "IPD Amount"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "number",
	                                className: "form-control",
	                                name: "edit_package_amount_ipd",
	                                id: "edit_package_amount",
	                                value: this.state.edit_package_amount_ipd,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "IPD Package Fees"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_package_amount
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Department"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  value: this.state.edit_package_dept_id,
	                                  name: "edit_package_dept_id",
	                                  onChange: this.handleChange
	                                },
	                                this.state.departments.length > 0 ? this.state.departments.map(function (department, index) {
	                                  return _react2.default.createElement(
	                                    "option",
	                                    {
	                                      key: department.id,
	                                      value: department.dept_id
	                                    },
	                                    department.department_name
	                                  );
	                                }) : _react2.default.createElement(
	                                  "option",
	                                  { value: "" },
	                                  "Select Department"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_package_dept_id
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Pre Condition"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  value: this.state.edit_package_pre_existing_conditon_id,
	                                  name: "edit_package_pre_existing_conditon_id",
	                                  onChange: this.handleChange
	                                },
	                                this.state.pre_existing_conditon.length > 0 ? this.state.pre_existing_conditon.map(function (pre_existing_conditons, index) {
	                                  return _react2.default.createElement(
	                                    "option",
	                                    {
	                                      key: pre_existing_conditons.id,
	                                      value: pre_existing_conditons.id
	                                    },
	                                    pre_existing_conditons.name
	                                  );
	                                }) : _react2.default.createElement(
	                                  "option",
	                                  { value: "" },
	                                  "Select Pre Condition"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_package_pre_existing_conditon_id
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Age"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  value: this.state.edit_package_age,
	                                  name: "edit_package_age",
	                                  onChange: this.handleChange
	                                },
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "0-12" },
	                                  "Child (0-12)"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "13-19" },
	                                  "Teenage (13-19)"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "20-45" },
	                                  "Adult (20-45)"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "0-35" },
	                                  "Below 35"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "35+" },
	                                  "Above 35"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "0-45" },
	                                  "Below 45"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "45+" },
	                                  "Senior (45+)"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "All" },
	                                  "All"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_package_age
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Gender"
	                              ),
	                              _react2.default.createElement(
	                                "select",
	                                {
	                                  className: "form-control",
	                                  value: this.state.edit_package_gender,
	                                  name: "edit_package_gender",
	                                  onChange: this.handleChange
	                                },
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "Male" },
	                                  "Male"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "Female" },
	                                  "Female"
	                                ),
	                                _react2.default.createElement(
	                                  "option",
	                                  { value: "other" },
	                                  "Other"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_package_gender
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Description"
	                              ),
	                              _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                id: "desceditor",
	                                name: "desceditor",
	                                value: this.state.edit_package_description,
	                                onChange: function onChange(name, val) {
	                                  _this2.DescReactQuillHandleChange(name, val);
	                                }
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Profile"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "package_profile_show_img_sec mb-2" },
	                                _react2.default.createElement("img", {
	                                  src: _constants.IMAGE_URL + "/Packagesimg/" + this.state.edit_package_profile,
	                                  alt: "",
	                                  width: "130px"
	                                })
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "edit_package_profile",
	                                id: "edit_package_profile",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png",
	                                placeholder: "Doctor Fees"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Package Banner Image"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "package_banner_show_img_sec mb-2" },
	                                _react2.default.createElement("img", {
	                                  src: _constants.IMAGE_URL + "/PackagesBannerimg/" + this.state.edit_package_banner_image,
	                                  alt: "",
	                                  width: "130px"
	                                })
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "edit_package_banner_image",
	                                id: "edit_package_banner_image",
	                                onChange: function onChange(event) {
	                                  return _this2.onBannerFileChange(event.target.files);
	                                },
	                                accept: "jpg,png",
	                                placeholder: "Doctor Fees"
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Submit"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return EditPackage;
	}(_react.Component);
	
	exports.default = EditPackage;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var updatestaticpage = function updatestaticpage(id, data, edit_page_desc, edit_banner_image) {
	    var formdata = new FormData();
	    formdata.append('edit_page_desc', edit_page_desc);
	    formdata.append('edit_banner_image', edit_banner_image);
	    return new Promise(function (resolve, reject) {
	        var req = _.scAxiosAdmin.post('/staticpages/updatestaticpage/' + id, formdata, {
	            headers: {
	                'Accept': 'application/json',
	                'Content-Type': 'multipart/form-data; boundary=' + formdata._boundary,
	                'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	            },
	            params: Object.assign({}, data)
	        });
	        req.then(function (res) {
	            return resolve(res.data);
	        }).catch(function (err) {
	            return reject(err);
	        });
	    });
	};
	var getsinglestaticpage = function getsinglestaticpage(id) {
	    return new Promise(function (resolve, reject) {
	        var req = _.scAxiosAdmin.request('/staticpages/getsinglestaticpage/' + id, {
	            method: 'get',
	            headers: {
	                'Accept': 'application/json',
	                'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	            }
	        });
	        req.then(function (res) {
	            return resolve(res.data);
	        }).catch(function (err) {
	            return reject(err);
	        });
	    });
	};
	var alertStyle = {
	    color: 'red'
	};
	
	var editpage = function (_Component) {
	    _inherits(editpage, _Component);
	
	    function editpage() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, editpage);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = editpage.__proto__ || Object.getPrototypeOf(editpage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            fields: {},
	            errors: {},
	            staticpage_id: '',
	            edit_page_title: '',
	            edit_page_desc: '',
	            edit_banner_image: ''
	        }, _this.handleChange = function (event) {
	            _this.setState({ errors: '' });
	            var fields = _this.state.fields;
	            fields[event.target.name] = event.target.value;
	            _this.setState({
	                fields: fields
	            }, function () {
	                return _this.validateForm();
	            });
	            _this.setState(_defineProperty({}, event.target.name, event.target.value));
	        }, _this.DescReactQuillHandleChange = function (name, val) {
	            _this.setState({
	                edit_page_desc: val
	            });
	        }, _this.handleSubmit = function (event) {
	            event.preventDefault();
	            if (_this.validateForm() === true) {
	                var id = _this.state.staticpage_id;
	                var data = {
	                    edit_page_title: _this.state.edit_page_title
	                };
	                updatestaticpage(id, data, _this.state.edit_page_desc, _this.state.edit_banner_image).then(function (res) {
	                    if (res.status === 'ok') {
	                        _reactToastify.toast.success(res.message, {
	                            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                        });
	                        setTimeout(function () {
	                            window.location.href = '/staticpages';
	                        }, 6000);
	                    } else if (res.status === 'notok') {
	                        _reactToastify.toast.error(res.message, {
	                            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                        });
	                    } else if (res.status === 'title_error') {
	                        _reactToastify.toast.error(res.message, {
	                            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                        });
	                    }
	                }).catch(function (err) {
	                    _reactToastify.toast.error(err, {
	                        position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                    });
	                });
	            } else {
	                _reactToastify.toast.error('Please provide all required fields!', {
	                    position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                });
	            }
	        }, _this.refreshgetSingleStaticPage = function (id) {
	            getsinglestaticpage(id).then(function (res) {
	                if (res.status === true) {
	                    var records = res.data;
	                    _this.setState({
	                        staticpage_id: records.id,
	                        edit_page_title: records.title,
	                        edit_page_desc: records.description,
	                        edit_banner_image: records.image
	                    });
	                } else {
	                    _this.setState({
	                        staticpage_id: '',
	                        edit_page_title: '',
	                        edit_page_desc: '',
	                        edit_banner_image: ''
	                    });
	                }
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(editpage, [{
	        key: 'validateForm',
	        value: function validateForm() {
	            var errors = {};
	            var formIsValid = true;
	            if (!this.state.edit_page_title) {
	                formIsValid = false;
	                errors["edit_page_title"] = "*Please enter the page title.";
	            }
	            if (!this.state.edit_page_desc) {
	                formIsValid = false;
	                errors["edit_page_desc"] = "*Please enter the page description.";
	            }
	            this.setState({
	                errors: errors
	            });
	            return formIsValid;
	        }
	    }, {
	        key: 'onFileChange',
	        value: function onFileChange(file) {
	            this.setState({
	                edit_banner_image: file[0]
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refreshgetSingleStaticPage(this.props.match.params.id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'fixed-left' },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'wrapper' },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-page' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'page-content-wrapper' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'card m-b-20' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'card-body' },
	                                            _react2.default.createElement(
	                                                'h4',
	                                                { className: 'mt-0 header-title' },
	                                                'Edit Page'
	                                            ),
	                                            _react2.default.createElement(
	                                                'form',
	                                                { onSubmit: this.handleSubmit, id: 'editdoctorform', className: 'needs-validation', noValidate: true },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-12' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Page title'
	                                                            ),
	                                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'edit_page_title', id: 'edit_page_title', value: this.state.edit_page_title, onChange: this.handleChange, required: true, placeholder: 'Page title' }),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { style: alertStyle },
	                                                                this.state.errors.edit_page_title
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-12' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Page Description'
	                                                            ),
	                                                            _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                                                id: 'desceditor',
	                                                                name: 'desceditor',
	                                                                value: this.state.edit_page_desc,
	                                                                onChange: function onChange(name, val) {
	                                                                    _this2.DescReactQuillHandleChange(name, val);
	                                                                }
	
	                                                            })
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-sm-6' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Banner Image'
	                                                            ),
	                                                            _react2.default.createElement('input', { type: 'file', className: 'form-control', name: 'edit_banner_image', id: 'edit_banner_image', onChange: function onChange(event) {
	                                                                    return _this2.onFileChange(event.target.files);
	                                                                }, accept: 'jpg,png', placeholder: 'Doctor Fees' })
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { type: 'submit', className: 'btn btn-pink waves-effect waves-light' },
	                                                            'Submit'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	            );
	        }
	    }]);
	
	    return editpage;
	}(_react.Component);
	
	exports.default = editpage;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _reactVirtualizedSelect = __webpack_require__(78);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	__webpack_require__(73);
	
	__webpack_require__(75);
	
	__webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import Footer from '../../component/admin/Footer';
	
	//import CKEditor from "react-ckeditor-component";
	
	
	var updatePublication = function updatePublication(id, data, edit_publications_desc, imageData) {
	  var formdata = new FormData();
	  formdata.append("edit_publications_desc", edit_publications_desc);
	  formdata.append("edit_publications_pic", imageData);
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.post("/publications/updatepublications/" + id, formdata, {
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data; boundary=" + formdata._boundary,
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSinglePublictication = function getSinglePublictication(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/publications/getsinglepublications/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var getAllDoctor = function getAllDoctor(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/publications/getdoctors", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var alertStyle = {
	  color: "red"
	};
	
	var EditPublication = function (_Component) {
	  _inherits(EditPublication, _Component);
	
	  function EditPublication() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditPublication);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditPublication.__proto__ || Object.getPrototypeOf(EditPublication)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      doctors: [],
	      doctor_id: null,
	      publication_id: "",
	      edit_publications_title: "",
	      edit_publications_desc: "",
	      edit_publications_pic: ""
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.DescQuillHandleChange = function (name, val) {
	      _this.setState({
	        edit_publications_desc: val
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm() === true) {
	        /*let fields = {};
	              fields["edit_department_name"] = "";
	              this.setState({ fields: fields });*/
	        var id = _this.state.publication_id;
	        var data = {
	          edit_publications_title: _this.state.edit_publications_title,
	          //edit_publications_desc: this.state.edit_publications_desc,
	          doctor_id: _this.state.doctor_id
	        };
	        updatePublication(id, data, _this.state.edit_publications_desc, _this.state.edit_publications_pic).then(function (res) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          // setTimeout(function(){
	          //     window.location.href = '/admin/publications';
	          // }, 3000);
	        }).catch(function (err) {
	          _reactToastify.toast.error(err, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide all required fields!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshgetSinglePublication = function (id) {
	      getSinglePublictication(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            publication_id: records.id,
	            edit_publications_title: records.publications_title,
	            doctor_id: records.doctor_id,
	            edit_publications_desc: records.publications_desc,
	            edit_publications_pic: records.publications_pic
	          });
	
	          // this.setState({
	          //   doctor_id: records.doctor_id,
	          // });
	        } else {
	          _this.setState({
	            publication_id: "",
	            edit_publications_title: "",
	            edit_publications_desc: "",
	            edit_publications_pic: "",
	            doctor_id: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshDoctor = function () {
	      getAllDoctor().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ doctors: records });
	        } else {
	          _this.setState({ doctors: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditPublication, [{
	    key: "validateForm",
	    value: function validateForm() {
	      //let fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!this.state.edit_publications_title) {
	        formIsValid = false;
	        errors["edit_publications_title"] = "*Please enter the news name.";
	      }
	
	      if (!this.state.edit_publications_desc) {
	        formIsValid = false;
	        errors["edit_publications_desc"] = "*Please enter the news description.";
	      }
	      if (this.state.doctor_id == null) {
	        formIsValid = false;
	        errors["doctor_id"] = "*Please select doctor.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "onFileChange",
	
	    /*onChange = (evt) =>{
	        //console.log("onChange fired with event info: ", evt);
	        var newContent = evt.editor.getData();
	        this.setState({
	          edit_publications_desc: newContent,
	        })
	      }*/
	    /*onBlur(evt){
	        console.log("onBlur event called with event info: ", evt);
	      }
	      afterPaste(evt){
	        console.log("afterPaste event called with event info: ", evt);
	      }*/
	    value: function onFileChange(file) {
	      this.setState({
	        edit_publications_pic: file[0]
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSinglePublication(this.props.match.params.id);
	      this.refreshDoctor();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "mt-0 header-title" },
	                        "Edit Publication"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          onSubmit: this.handleSubmit,
	                          id: "editdoctorform",
	                          className: "needs-validation",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Name"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control",
	                                name: "edit_publications_title",
	                                id: "edit_publications_title",
	                                value: this.state.edit_publications_title,
	                                onChange: this.handleChange,
	                                required: true,
	                                placeholder: "Name"
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_publications_title
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Doctor Name"
	                              ),
	                              _react2.default.createElement(_reactVirtualizedSelect2.default, {
	                                id: "doctor_id",
	                                name: "doctor_id",
	                                className: "form-control custom_select_search",
	                                placeholder: "Select Doctor",
	                                options: this.state.doctors.map(function (item, index) {
	                                  return {
	                                    label: item.doctor_name,
	                                    value: item.id
	                                  };
	                                }),
	                                value: this.state.doctor_id,
	                                onChange: function onChange(selectValue) {
	                                  return _this2.setState({
	                                    doctor_id: selectValue.value
	                                  });
	                                }
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.doctor_id
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Description"
	                              ),
	                              _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                                id: "editdescpubeditor",
	                                name: "editdescpubeditor",
	                                value: this.state.edit_publications_desc,
	                                onChange: function onChange(name, val) {
	                                  _this2.DescQuillHandleChange(name, val);
	                                }
	                              }),
	                              _react2.default.createElement(
	                                "span",
	                                { style: alertStyle },
	                                this.state.errors.edit_publications_desc
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-6" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Image"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: "file",
	                                className: "form-control",
	                                name: "edit_publications_pic",
	                                id: "edit_publications_pic",
	                                onChange: function onChange(event) {
	                                  return _this2.onFileChange(event.target.files);
	                                },
	                                accept: "jpg,png",
	                                placeholder: "Doctor Fees"
	                              }),
	                              this.state.edit_publications_pic ? _react2.default.createElement("img", {
	                                src: _constants.IMAGE_URL + "PublicationsImg/" + this.state.edit_publications_pic,
	                                alt: "",
	                                style: {
	                                  width: "150px",
	                                  height: "auto",
	                                  marginTop: "10px",
	                                  borderRadius: "5px"
	                                }
	                              }) : _react2.default.createElement("img", { src: _avatar_circle2.default, width: "100px", alt: "" })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                type: "submit",
	                                className: "btn btn-pink waves-effect waves-light"
	                              },
	                              "Update"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return EditPublication;
	}(_react.Component);
	
	exports.default = EditPublication;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _MultipleReactQuillEditor = __webpack_require__(40);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactVirtualizedSelect = __webpack_require__(78);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	__webpack_require__(73);
	
	__webpack_require__(75);
	
	__webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var edittestimonial = function edittestimonial(props) {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      data = _useState2[0],
	      setData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    testimonial_title: "",
	    author_name: "",
	    doctor_id: "",
	    rating: "",
	    status: 1,
	    testimonial_desc: "",
	    author_profile_pic: ""
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      formData = _useState4[0],
	      setFormData = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      authorPic = _useState6[0],
	      setAuthorPic = _useState6[1];
	
	  console.log(formData, "hello");
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	    if (name === "doctor_id") {
	      // Check if the select element is for doctor_id
	      setFormData(Object.assign({}, formData, {
	        doctor_id: value
	      }));
	    } else {
	      setFormData(Object.assign({}, formData, _defineProperty({}, name, value)));
	    }
	  };
	
	  var handleFileChange = function handleFileChange(e) {
	    var file = e.target.files[0];
	
	    // Check if a file was selected
	    if (file) {
	      // Update the formData state by setting the author_profile_pic to the selected file
	      setFormData(Object.assign({}, formData, {
	        author_profile_pic: file
	      }));
	    }
	  };
	
	  var handleSubmit = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              e.preventDefault();
	
	              // Here you can use formData to submit the form or perform other actions
	              console.log(formData, "hellos");
	              // Example: You can send formData to an API or perform any necessary operations.
	              _context.prev = 2;
	              _context.next = 5;
	              return _.thirdparty.post("/testimonials_update/" + props.match.params.id, formData, {
	                // You might need to set headers or other configurations here
	                headers: {
	                  "Content-Type": "multipart/form-data"
	                }
	              });
	
	            case 5:
	              response = _context.sent;
	
	              if (response.status == 200) {
	                _reactToastify.toast.success("Testimonial Updated successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 2000
	                });
	                window.location.reload();
	              }
	
	              // Perform actions after successful form submission, e.g., show success message, redirect, etc.
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context["catch"](2);
	
	              console.error("Error submitting form:", _context.t0);
	              // Handle errors, show error messages, etc.
	
	            case 12:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 9]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function fetchData() {
	      try {
	        var response = (0, _.scAxiosAdmin)("/doctors/getdoctors");
	        response.then(function (res) {
	          setData(res.data.data);
	        });
	      } catch (error) {
	        console.error("Error fetching data:", error);
	      }
	    };
	
	    fetchData();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var fetch_current_testimonial = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(id) {
	        var response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                _context2.next = 3;
	                return (0, _.scAxiosAdmin)("/testimonials/" + id);
	
	              case 3:
	                response = _context2.sent;
	
	
	                if (response.status === 200) {
	
	                  setFormData(Object.assign({}, formData, {
	                    testimonial_title: response.data.testimonial_title,
	                    author_name: response.data.author_name,
	                    doctor_id: response.data.doctor_id,
	                    rating: response.data.rating,
	                    status: response.data.status,
	                    testimonial_desc: response.data.testimonial_desc
	                  }));
	                  setAuthorPic(response.data.author_profile_pic);
	                }
	                _context2.next = 10;
	                break;
	
	              case 7:
	                _context2.prev = 7;
	                _context2.t0 = _context2["catch"](0);
	
	                console.error("Error fetching data:", _context2.t0);
	
	              case 10:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, undefined, [[0, 7]]);
	      }));
	
	      return function fetch_current_testimonial(_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    fetch_current_testimonial(props.match.params.id);
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(_Seo2.default, {
	      title: "Edit Testimonials",
	      description: "Edit Testimonials",
	      pathSlug: "/addtestimonial",
	      keywords: "Edit Testimonials, Testimonials"
	    }),
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-8" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      id: "adddepartmentform",
	                      className: "needs-validation",
	                      noValidate: true,
	                      onSubmit: handleSubmit
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Testimonial Title"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "testimonial_title",
	                            id: "testimonial_title",
	                            value: formData.testimonial_title,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Testimonial Title"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Author Name"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "author_name",
	                            id: "Author Name",
	                            value: formData.author_name,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Author Name"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Doctors Name"
	                          ),
	                          _react2.default.createElement(_reactVirtualizedSelect2.default, {
	                            id: "author_id",
	                            name: "doctor_id",
	                            className: "form-control custom_select_search",
	                            placeholder: "Select Doctor",
	                            options: data.map(function (item, index) {
	                              return {
	                                label: item.doctor_name,
	                                value: item.id
	                              };
	                            }),
	                            value: formData.doctor_id,
	                            onChange: function onChange(selectValue) {
	                              return setFormData(Object.assign({}, formData, {
	                                doctor_id: selectValue.value
	                              }));
	                            }
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Testimonial Rating"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "number",
	                            className: "form-control",
	                            name: "rating",
	                            id: "rating",
	                            value: formData.rating,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Rating",
	                            min: "0",
	                            max: "5"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Testimonial Author Image"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "file",
	                            className: "form-control",
	                            name: "author_profile_pic",
	                            id: "author_profile_pic",
	                            onChange: handleFileChange,
	                            accept: "image/*" // Specify the accepted file types if needed
	                            , placeholder: "Doctor Profile Pic"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Testimonial Description"
	                          ),
	                          _react2.default.createElement(_MultipleReactQuillEditor.MultipleReactQuillEditor, {
	                            id: "adddesctestieditor",
	                            name: "testimonial_desc",
	                            onChange: function onChange(name, val) {
	                              return setFormData(Object.assign({}, formData, _defineProperty({}, name, val)));
	                            },
	                            value: formData.testimonial_desc
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "submit",
	                            className: "btn btn-pink waves-effect waves-light"
	                          },
	                          "Submit"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            authorPic != "" ? _react2.default.createElement(
	              "div",
	              { className: "col-md-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "card mb-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-header" },
	                  "Author Image"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body text-center" },
	                  _react2.default.createElement("img", {
	                    src: _constants.IMAGE_URL + "/AuthorProfileImg/" + authorPic,
	                    alt: "",
	                    className: "image-fluid p-2",
	                    width: "75%"
	                  })
	                )
	              )
	            ) : null
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = edittestimonial;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var error = function error() {
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12 text-center" },
	              _react2.default.createElement(
	                "div",
	                { className: "card mt-5 m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "h2",
	                    null,
	                    " Something went wrong! Please try again... "
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = error;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { startUserSession } from '../../userSession';
	
	//import 'react-toastify/dist/ReactToastify.css';
	
	//import Footer from '../../component/admin/Footer';
	//import Moment from 'moment';
	
	
	var getAllHeaderAnnoucement = function getAllHeaderAnnoucement(data) {
					return new Promise(function (resolve, reject) {
									var req = _.scAxiosAdmin.request('/headerannoucement/getallheaderannoucement', {
													method: 'get',
													headers: {
																	'Accept': 'application/json',
																	'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
													},
													params: Object.assign({}, data)
									});
									req.then(function (res) {
													return resolve(res.data);
									}).catch(function (err) {
													return reject(err);
									});
					});
	};
	
	var HeaderAnnoucement = function (_Component) {
					_inherits(HeaderAnnoucement, _Component);
	
					function HeaderAnnoucement() {
									var _ref;
	
									var _temp, _this, _ret;
	
									_classCallCheck(this, HeaderAnnoucement);
	
									for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
													args[_key] = arguments[_key];
									}
	
									return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderAnnoucement.__proto__ || Object.getPrototypeOf(HeaderAnnoucement)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
													headerannoucement: [],
													total: '',
													currentPage: '',
													LastPage: '',
													PerPage: '',
													FirstPageUrl: '',
													NextPageUrl: '',
													PrevPageUrl: '',
													LastPageUrl: '',
													TotalPages: '',
													activePage: 1,
													id: '',
													enableShdo: false,
													enableShdoLive: false
									}, _this.handleChange = function (events) {
													_this.setState(_defineProperty({}, event.target.name, event.target.value));
									}, _this.refreshHeaderAnnoucement = function (page) {
													_this.setState({ enableShdo: true });
													var data = {
																	page: page
													};
													getAllHeaderAnnoucement(data).then(function (res) {
																	if (res.status === true) {
																					var records = res.data.data;
																					_this.setState({ headerannoucement: records });
																					_this.setState({ total: res.data.total });
																					_this.setState({ currentPage: res.data.current_page });
																					_this.setState({ PerPage: res.data.per_page });
																					_this.setState({ FirstPageUrl: res.data.first_page_url });
																					_this.setState({ NextPageUrl: res.data.next_page_url });
																					_this.setState({ PrevPageUrl: res.data.prev_page_url });
																					_this.setState({ LastPageUrl: res.data.last_page_url });
																					_this.setState({ LastPage: res.data.last_page });
																					_this.setState({ TotalPages: Math.ceil(_this.state.total / _this.state.PerPage) });
																	} else {
																					_this.setState({ doctors: '' });
																	}
																	_this.setState({ enableShdo: false });
													}).catch(function (err) {
																	console.log(err);
													});
									}, _temp), _possibleConstructorReturn(_this, _ret);
					}
	
					_createClass(HeaderAnnoucement, [{
									key: 'handlePageChange',
									value: function handlePageChange(pageNumber) {
													this.setState({ activePage: pageNumber });
													this.refreshHeaderAnnoucement(pageNumber);
									}
					}, {
									key: 'componentDidMount',
									value: function componentDidMount() {
													this.refreshHeaderAnnoucement();
									}
					}, {
									key: 'render',
									value: function render() {
													//const currentPage = this.state.currentPage;
													//const previousPage = currentPage - 1;
													//const NextPage = currentPage + 1;
													//const LastPage = this.state.LastPage;
													var pageNumbers = [];
													for (var i = 1; i <= this.state.TotalPages; i++) {
																	pageNumbers.push(i);
													}
													return _react2.default.createElement(
																	'div',
																	{ className: 'fixed-left' },
																	_react2.default.createElement(
																					'div',
																					{ id: 'wrapper' },
																					_react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
																					_react2.default.createElement(
																									'div',
																									{ className: 'content-page' },
																									_react2.default.createElement(
																													'div',
																													{ className: 'content' },
																													_react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
																													_react2.default.createElement(
																																	'div',
																																	{ className: 'page-content-wrapper' },
																																	_react2.default.createElement(
																																					'div',
																																					{ className: 'container-fluid' },
																																					_react2.default.createElement(
																																									'div',
																																									{ className: 'row' },
																																									_react2.default.createElement(
																																													'div',
																																													{ className: 'col-12' },
																																													_react2.default.createElement(
																																																	'div',
																																																	{ className: 'card m-b-20' },
																																																	_react2.default.createElement(
																																																					'div',
																																																					{ className: 'card-body' },
																																																					_react2.default.createElement(
																																																									'div',
																																																									{ className: 'row' },
																																																									_react2.default.createElement(
																																																													'div',
																																																													{ className: 'col-sm-7' },
																																																													_react2.default.createElement(
																																																																	'h4',
																																																																	{ className: 'mt-0 header-title' },
																																																																	'Header Annoucement'
																																																													)
																																																									),
																																																									_react2.default.createElement('div', { className: 'col-sm-3 text-right' })
																																																					),
																																																					_react2.default.createElement(
																																																									'div',
																																																									{ className: 'table-rep-plugin' },
																																																									_react2.default.createElement(
																																																													'div',
																																																													{ className: 'table-responsive b-0', 'data-pattern': 'priority-columns' },
																																																													_react2.default.createElement(
																																																																	'table',
																																																																	{ id: 'tech-companies-1', className: 'table  table-striped' },
																																																																	_react2.default.createElement(
																																																																					'thead',
																																																																					null,
																																																																					_react2.default.createElement(
																																																																									'tr',
																																																																									null,
																																																																									_react2.default.createElement(
																																																																													'th',
																																																																													null,
																																																																													'Id'
																																																																									),
																																																																									_react2.default.createElement(
																																																																													'th',
																																																																													null,
																																																																													'Header Annoucement Text'
																																																																									),
																																																																									_react2.default.createElement(
																																																																													'th',
																																																																													null,
																																																																													'Header Annoucement Link'
																																																																									),
																																																																									_react2.default.createElement(
																																																																													'th',
																																																																													null,
																																																																													'Header Phone No.'
																																																																									),
																																																																									_react2.default.createElement(
																																																																													'th',
																																																																													null,
																																																																													'Action'
																																																																									)
																																																																					)
																																																																	),
																																																																	_react2.default.createElement(
																																																																					'tbody',
																																																																					null,
																																																																					this.state.headerannoucement.length > 0 ? this.state.headerannoucement.map(function (header_annoucement) {
																																																																									return _react2.default.createElement(
																																																																													'tr',
																																																																													{ key: header_annoucement.id },
																																																																													_react2.default.createElement(
																																																																																	'td',
																																																																																	null,
																																																																																	header_annoucement.id
																																																																													),
																																																																													_react2.default.createElement(
																																																																																	'td',
																																																																																	null,
																																																																																	header_annoucement.header_annoucement_text
																																																																													),
																																																																													_react2.default.createElement(
																																																																																	'td',
																																																																																	null,
																																																																																	header_annoucement.header_annoucement_link
																																																																													),
																																																																													_react2.default.createElement(
																																																																																	'td',
																																																																																	null,
																																																																																	header_annoucement.header_phone_no
																																																																													),
																																																																													_react2.default.createElement(
																																																																																	'td',
																																																																																	null,
																																																																																	_react2.default.createElement(
																																																																																					'a',
																																																																																					{ href: '/editheaderannoucement/' + header_annoucement.id },
																																																																																					_react2.default.createElement('i', { className: 'fa fa-pencil-square' })
																																																																																	)
																																																																													)
																																																																									);
																																																																					}) : _react2.default.createElement(
																																																																									'tr',
																																																																									null,
																																																																									_react2.default.createElement(
																																																																													'td',
																																																																													{ colSpan: '6', className: 'font_12 txt_col fontweight400 ', style: { "textAlign": "center" } },
																																																																													' There are currently no Header Annoucement.'
																																																																									)
																																																																					)
																																																																	)
																																																													),
																																																													pageNumbers.length > 1 ? _react2.default.createElement(_reactJsPagination2.default, {
																																																																	activePage: this.state.activePage,
																																																																	totalItemsCount: this.state.total,
																																																																	pageRangeDisplayed: 5,
																																																																	onChange: this.handlePageChange.bind(this)
																																																													}) : ''
																																																									)
																																																					)
																																																	)
																																													)
																																									)
																																					)
																																	)
																													)
																									)
																					)
																	),
																	_react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
													);
									}
					}]);
	
					return HeaderAnnoucement;
	}(_react.Component);
	
	exports.default = HeaderAnnoucement;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _2 = __webpack_require__(2);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _TableComponent = __webpack_require__(199);
	
	var _TableComponent2 = _interopRequireDefault(_TableComponent);
	
	var _utils = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var homesamplecollection = function homesamplecollection() {
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        fatchData = _useState2[0],
	        setFatchdata = _useState2[1];
	
	    var fetchData = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var response;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _2.thirdparty.get("/home_sample_collections");
	
	                        case 3:
	                            response = _context.sent;
	
	                            if (response.status === 200) {
	                                setFatchdata(response.data);
	                            }
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	
	                            console.error("Error fetching data:", _context.t0.message);
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function fetchData() {
	            return _ref.apply(this, arguments);
	        };
	    }();
	
	    (0, _react.useEffect)(function () {
	        fetchData();
	    }, []);
	
	    var columns = [{ header: "#", accessor: function accessor(_, index) {
	            return index + 1;
	        } }, { header: "Name", accessor: "name" }, { header: "Email", accessor: "email" }, { header: "Phone", accessor: "phone" }, { header: "Address", accessor: "address" }, { header: "Prescription", accessor: function accessor(item) {
	            return '<a href=' + item.user_file + ' target="_blank">View</a>';
	        } }, { header: "Requested at", accessor: function accessor(item) {
	            return (0, _utils.formatDate)(item.created_at);
	        } }];
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'fixed-left' },
	        _react2.default.createElement(_Seo2.default, {
	            title: 'Home Sample Collection ',
	            description: 'Home Sample Collection - United Hospital',
	            pathSlug: '/admin/user-log',
	            keywords: 'Home Sample Collection'
	        }),
	        _react2.default.createElement(
	            'div',
	            { id: 'wrapper' },
	            _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	            _react2.default.createElement(
	                'div',
	                { className: 'content-page' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-content-wrapper ' },
	                        _react2.default.createElement(_TableComponent2.default, { title: 'Home Sample Collection', data: fatchData, columns: columns })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	    );
	};
	
	exports.default = homesamplecollection;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var JobCircular_create = function JobCircular_create() {
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        fatchdata = _useState2[0],
	        setFatchdata = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        modalDeleteConfirm = _useState4[0],
	        setModalDeleteConfirm = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        id = _useState6[0],
	        setId = _useState6[1];
	
	    var openModalDeleteConfirm = function openModalDeleteConfirm(id) {
	        setModalDeleteConfirm(true);
	        setId(id);
	        console.log(id, "userid");
	    };
	
	    var closeModalDeleteConfirm = function closeModalDeleteConfirm() {
	        setModalDeleteConfirm(false);
	    };
	
	    var fetchData = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var response;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _.thirdparty.get("/case_studies");
	
	                        case 3:
	                            response = _context.sent;
	
	
	                            if (response.status === 200) {
	                                setFatchdata(response.data);
	                            }
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error("Error fetching data:", _context.t0.message);
	
	                        case 10:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function fetchData() {
	            return _ref.apply(this, arguments);
	        };
	    }();
	
	    var handleDelete = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var response;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _.thirdparty.delete("/case_studies/" + id);
	
	                        case 3:
	                            response = _context2.sent;
	
	
	                            if (response.status === 200) {
	                                console.log("Item with ID " + id + " deleted successfully.");
	                                fetchData(); // Fetch updated data after deletion
	                            }
	                            _context2.next = 10;
	                            break;
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2["catch"](0);
	
	                            console.error("Error deleting item with ID " + id + ":", _context2.t0.message);
	
	                        case 10:
	                            _context2.prev = 10;
	
	                            closeModalDeleteConfirm();
	                            return _context2.finish(10);
	
	                        case 13:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7, 10, 13]]);
	        }));
	
	        return function handleDelete() {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    (0, _react.useEffect)(function () {
	        fetchData(); // Initial data fetch
	    }, []);
	
	    return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	            "div",
	            { id: "wrapper" },
	            _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	            _react2.default.createElement(
	                "div",
	                { className: "content-page" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "content" },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "row page-content-wrapper g-0 g-3" },
	                        _react2.default.createElement("div", { className: "col-sm-7" }),
	                        _react2.default.createElement("div", { className: "col-sm-3 text-right" }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12 mb-4  d-flex justify-content-between align-items-center " },
	                            _react2.default.createElement(
	                                "h5",
	                                null,
	                                "Case Studies"
	                            ),
	                            _react2.default.createElement(
	                                "a",
	                                {
	                                    href: "/admin/case_studies_create",
	                                    className: "btn btn-sm waves-effect waves-light"
	                                },
	                                "Add Case Studies"
	                            )
	                        ),
	                        fatchdata.length > 0 ? fatchdata.map(function (item) {
	                            return _react2.default.createElement(
	                                "div",
	                                { className: "col-md-2", key: item.id },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "card" },
	                                    _react2.default.createElement("img", {
	                                        className: "card-img-top ",
	                                        src: _constants.IMAGE_URL + "/" + item.featured_image,
	                                        alt: "Card image cap",
	                                        style: { height: "100%", maxHeight: "150px" }
	                                    }),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "card-body" },
	                                        _react2.default.createElement(
	                                            "p",
	                                            null,
	                                            item.title
	                                        ),
	                                        _react2.default.createElement(
	                                            "h5",
	                                            {
	                                                className: "mt-2",
	                                                style: {
	                                                    display: "flex",
	                                                    alignItems: "flex-end",
	                                                    columnGap: "10px",
	                                                    rowGap: "10px",
	                                                    justifyContent: "flex-end"
	                                                }
	                                            },
	                                            _react2.default.createElement(
	                                                "a",
	                                                {
	                                                    href: "/admin/case_studies_update/" + item.id,
	                                                    item_id: item.id
	                                                },
	                                                _react2.default.createElement("i", { className: "fa fa-pencil-square " })
	                                            ),
	                                            _react2.default.createElement(
	                                                "a",
	                                                {
	                                                    href: "/pages/case-study/" + item.id,
	                                                    target: "_blank"
	                                                },
	                                                _react2.default.createElement("i", { className: "fa fa-eye" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "a",
	                                                { onClick: function onClick() {
	                                                        return openModalDeleteConfirm(item.id);
	                                                    } },
	                                                _react2.default.createElement("i", { className: "fa fa-trash" })
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        _DeleteConfirmModalPopup2.default,
	                                        {
	                                            show: modalDeleteConfirm,
	                                            handleClose: closeModalDeleteConfirm
	                                        },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "custom_reviews_popup" },
	                                            _react2.default.createElement(
	                                                "h2",
	                                                { className: "text-center" },
	                                                "Are you sure you want to delete this item?"
	                                            ),
	                                            _react2.default.createElement(
	                                                "form",
	                                                { className: "pop-form", id: "edit_education" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "form-group row" },
	                                                    _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                                                    _react2.default.createElement(
	                                                        "div",
	                                                        { className: "col-sm-6 text-center" },
	                                                        _react2.default.createElement(
	                                                            "button",
	                                                            {
	                                                                type: "button",
	                                                                className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                                                onClick: closeModalDeleteConfirm
	                                                            },
	                                                            "No"
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "button",
	                                                            {
	                                                                type: "button",
	                                                                className: "blue_btn_box add_staff_btn mt-5",
	                                                                onClick: function onClick() {
	                                                                    // Add your logic for handling delete here
	                                                                    // e.g., this.modalDeletePublication(this.state.publications_id)
	                                                                    console.log("Deleting...");
	                                                                    // ModalDeleteConfirm(item.id);
	                                                                    handleDelete();
	                                                                }
	                                                            },
	                                                            "Yes"
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            );
	                        }) : _react2.default.createElement(
	                            "div",
	                            null,
	                            "No data found"
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	    );
	};
	
	exports.default = JobCircular_create;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobCircular_list = function JobCircular_list() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        'JobCircular_list'
	    );
	};
	
	exports.default = JobCircular_list;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobCircular_update = function JobCircular_update() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        'JobCircular_update'
	    );
	};
	
	exports.default = JobCircular_update;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GetAllMenu = function GetAllMenu(data) {
		return new Promise(function (resolve, reject) {
			var req = _.scAxiosAdmin.request('/menu/getallmenu', {
				method: 'get',
				headers: {
					'Accept': 'application/json',
					'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
				},
				params: Object.assign({}, data)
			});
			req.then(function (res) {
				return resolve(res.data);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};
	var getSearchMenu = function getSearchMenu(data) {
		return new Promise(function (resolve, reject) {
			var req = _.scAxiosAdmin.request('/menu/adminsearchmenu', {
				method: 'get',
				headers: {
					'Accept': 'application/json',
					'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
				},
				params: Object.assign({}, data)
			});
			req.then(function (res) {
				return resolve(res.data);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};
	var deleteMenu = function deleteMenu(data) {
		return new Promise(function (resolve, reject) {
			var req = _.scAxiosAdmin.request('/menu/deletemenu', {
				method: 'post',
				headers: {
					'Accept': 'application/json',
					'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
				},
				params: Object.assign({}, data)
			});
			req.then(function (res) {
				return resolve(res.data);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};
	
	var menu = function (_Component) {
		_inherits(menu, _Component);
	
		function menu() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, menu);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = menu.__proto__ || Object.getPrototypeOf(menu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
				menu: [],
				total: '',
				currentPage: '',
				LastPage: '',
				PerPage: '',
				FirstPageUrl: '',
				NextPageUrl: '',
				PrevPageUrl: '',
				LastPageUrl: '',
				TotalPages: '',
				activePage: 1,
				menu_id: '',
				enableShdo: false,
				enableShdoLive: false,
				search_keywords: ''
			}, _this.handleChange = function (events) {
				_this.setState(_defineProperty({}, event.target.name, event.target.value));
			}, _this.refreshStaticMenu = function (page) {
				_this.setState({ enableShdo: true });
				var data = {
					page: page
				};
				GetAllMenu(data).then(function (res) {
					if (res.status === true) {
						var records = res.data.data;
						_this.setState({ menu: records });
						_this.setState({ total: res.data.total });
						_this.setState({ currentPage: res.data.current_page });
						_this.setState({ PerPage: res.data.per_page });
						_this.setState({ FirstPageUrl: res.data.first_page_url });
						_this.setState({ NextPageUrl: res.data.next_page_url });
						_this.setState({ PrevPageUrl: res.data.prev_page_url });
						_this.setState({ LastPageUrl: res.data.last_page_url });
						_this.setState({ LastPage: res.data.last_page });
						_this.setState({ TotalPages: Math.ceil(_this.state.total / _this.state.PerPage) });
					} else {
						_this.setState({ menu: '' });
					}
					_this.setState({ enableShdo: false });
				}).catch(function (err) {
					console.log(err);
				});
			}, _this.SearchDocotrs = function (e) {
				var data = {
					keywords: _this.state.search_keywords
				};
				getSearchMenu(data).then(function (res) {
					if (res.status === true) {
						var records = res.data.data;
						_this.setState({ menu: records });
						_this.setState({ total: res.data.total });
						_this.setState({ currentPage: res.data.current_page });
						_this.setState({ PerPage: res.data.per_page });
						_this.setState({ FirstPageUrl: res.data.first_page_url });
						_this.setState({ NextPageUrl: res.data.next_page_url });
						_this.setState({ PrevPageUrl: res.data.prev_page_url });
						_this.setState({ LastPageUrl: res.data.last_page_url });
						_this.setState({ LastPage: res.data.last_page });
						_this.setState({ TotalPages: Math.ceil(_this.state.total / _this.state.PerPage) });
					} else {
						_this.setState({ menu: '' });
					}
				}).catch(function (err) {
					console.log(err);
				});
			}, _this.modalcopy = function (e, id, url) {
				var $temp = (0, _jquery2.default)("<input>");
				var $url = url + id;
				(0, _jquery2.default)("body").append($temp);
				$temp.val($url).select();
				document.execCommand("copy");
				$temp.remove();
				alert("url link copied");
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(menu, [{
			key: 'handlePageChange',
			value: function handlePageChange(pageNumber) {
				this.setState({ activePage: pageNumber });
				this.refreshStaticMenu(pageNumber);
			}
		}, {
			key: 'modalDeleteConfirmOpen',
			value: function modalDeleteConfirmOpen(e, id) {
				this.setState({
					modalDeleteConfirm: true,
					menu_id: id
				});
			}
		}, {
			key: 'modalDeleteConfirmClose',
			value: function modalDeleteConfirmClose() {
				this.setState({
					modalDeleteConfirm: false
				});
			}
		}, {
			key: 'modalDeleteMenu',
			value: function modalDeleteMenu(id) {
				this.setState({
					modalDeleteConfirm: false
				});
				var data = {
					menu_id: id
				};
				deleteMenu(data).then(function (res) {
					if (res.status === true) {
						_reactToastify.toast.success(res.message, {
							position: _reactToastify.toast.POSITION.TOP_RIGHT
						});
						setTimeout(function () {
							window.location.href = '/menu';
						}, 6000);
					} else {
						_reactToastify.toast.error(res.message, {
							position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
						});
					}
				}).catch(function (err) {
					console.log(err);
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.refreshStaticMenu();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var pageNumbers = [];
				for (var i = 1; i <= this.state.TotalPages; i++) {
					pageNumbers.push(i);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'fixed-left' },
					_react2.default.createElement(
						'div',
						{ id: 'wrapper' },
						_react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
						_react2.default.createElement(
							'div',
							{ className: 'content-page' },
							_react2.default.createElement(
								'div',
								{ className: 'content' },
								_react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
								_react2.default.createElement(
									'div',
									{ className: 'page-content-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'container-fluid' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-12' },
												_react2.default.createElement(
													'div',
													{ className: 'card m-b-20' },
													_react2.default.createElement(
														'div',
														{ className: 'card-body' },
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-sm-7' },
																_react2.default.createElement(
																	'h4',
																	{ className: 'mt-0 header-title' },
																	'Header Menu'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-sm-3 text-right' },
																_react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'search_keywords', id: 'search_keywords', value: this.state.search_keywords, onChange: this.handleChange, onBlur: this.SearchDocotrs, placeholder: 'Search' })
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-sm-2 text-right' },
																_react2.default.createElement(
																	'a',
																	{ href: '/addmenu', className: 'btn btn-sm btn-primary waves-effect waves-light' },
																	'Add Menu'
																)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'table-rep-plugin' },
															_react2.default.createElement(
																'div',
																{ className: 'table-responsive b-0', 'data-pattern': 'priority-columns' },
																_react2.default.createElement(
																	'table',
																	{ id: 'tech-companies-1', className: 'table  table-striped' },
																	_react2.default.createElement(
																		'thead',
																		null,
																		_react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'th',
																				null,
																				'Menu ID'
																			),
																			_react2.default.createElement(
																				'th',
																				null,
																				'Menu Title'
																			),
																			_react2.default.createElement(
																				'th',
																				{ 'data-priority': '1' },
																				'Url'
																			),
																			_react2.default.createElement(
																				'th',
																				{ 'data-priority': '1' },
																				'status'
																			),
																			_react2.default.createElement(
																				'th',
																				{ 'data-priority': '3' },
																				'Action'
																			)
																		)
																	),
																	_react2.default.createElement(
																		'tbody',
																		null,
																		this.state.menu.length > 0 ? this.state.menu.map(function (hmenu) {
																			return _react2.default.createElement(
																				'tr',
																				{ key: hmenu.id },
																				_react2.default.createElement(
																					'td',
																					null,
																					'#',
																					hmenu.id
																				),
																				_react2.default.createElement(
																					'td',
																					null,
																					hmenu.title
																				),
																				_react2.default.createElement(
																					'td',
																					null,
																					_constants.WEBSITEPAGE_URL + hmenu.slug
																				),
																				_react2.default.createElement(
																					'td',
																					null,
																					hmenu.current_status.charAt(0).toUpperCase() + hmenu.current_status.slice(1)
																				),
																				hmenu.title !== 'Book Appointment' && hmenu.title !== 'Packages' ? _react2.default.createElement(
																					'td',
																					null,
																					_react2.default.createElement(
																						'a',
																						{ onClick: function onClick(e) {
																								return _this2.modalcopy(e, hmenu.slug, _constants.WEBSITEPAGE_URL);
																							} },
																						_react2.default.createElement('i', { className: 'fa fa-copy' })
																					),
																					_react2.default.createElement(
																						'a',
																						{ href: '/editmenu/' + hmenu.slug },
																						_react2.default.createElement('i', { className: 'fa fa-pencil-square' })
																					),
																					_react2.default.createElement(
																						'a',
																						{ onClick: function onClick(e) {
																								return _this2.modalDeleteConfirmOpen(e, hmenu.id);
																							} },
																						_react2.default.createElement('i', { className: 'fa fa-trash' })
																					)
																				) : hmenu.title === 'Packages' ? _react2.default.createElement(
																					'td',
																					null,
																					_react2.default.createElement(
																						'a',
																						{ href: '/editmenu/' + hmenu.slug },
																						_react2.default.createElement('i', { className: 'fa fa-pencil-square' })
																					)
																				) : _react2.default.createElement('td', null),
																				_react2.default.createElement(
																					_DeleteConfirmModalPopup2.default,
																					{ show: _this2.state.modalDeleteConfirm, handleClose: function handleClose(e) {
																							return _this2.modalDeleteConfirmClose(e);
																						} },
																					_react2.default.createElement(
																						'div',
																						{ className: 'custom_reviews_popup' },
																						_react2.default.createElement(
																							'h2',
																							{ className: 'text-center' },
																							'Are you sure you wish to delete this menu?'
																						),
																						_react2.default.createElement(
																							'form',
																							{ className: 'pop-form', id: 'edit_education' },
																							_react2.default.createElement(
																								'div',
																								{ className: 'form-group row' },
																								_react2.default.createElement('div', { className: 'col-sm-3 text-center' }),
																								_react2.default.createElement(
																									'div',
																									{ className: 'col-sm-6 text-center' },
																									_react2.default.createElement(
																										'button',
																										{ type: 'button', className: 'blue_btn_box add_staff_btn mt-5 mr-2', onClick: function onClick(e) {
																												return _this2.modalDeleteConfirmClose(e);
																											} },
																										' No'
																									),
																									_react2.default.createElement(
																										'button',
																										{ type: 'button', className: 'blue_btn_box add_staff_btn mt-5', onClick: function onClick() {
																												return _this2.modalDeleteMenu(_this2.state.menu_id);
																											} },
																										'Yes'
																									)
																								),
																								_react2.default.createElement('div', { className: 'col-sm-3 text-center' })
																							)
																						)
																					)
																				)
																			);
																		}) : _react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				{ colSpan: '6', className: 'font_12 txt_col fontweight400 ', style: { "textAlign": "center" } },
																				' No menu data found.'
																			)
																		)
																	)
																),
																pageNumbers.length > 1 ? _react2.default.createElement(_reactJsPagination2.default, {
																	activePage: this.state.activePage,
																	totalItemsCount: this.state.total,
																	pageRangeDisplayed: 5,
																	onChange: this.handlePageChange.bind(this)
																}) : ''
															)
														)
													)
												)
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
				);
			}
		}]);
	
		return menu;
	}(_react.Component);
	
	exports.default = menu;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSingleNewsEvent = function getSingleNewsEvent(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/newsevents/getsinglenewsevents/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var newsEventsView = function (_Component) {
	  _inherits(newsEventsView, _Component);
	
	  function newsEventsView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, newsEventsView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = newsEventsView.__proto__ || Object.getPrototypeOf(newsEventsView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      news_id: "",
	      edit_news_events_title: "",
	      edit_news_events_desc: "",
	      edit_news_events_pic: ""
	    }, _this.refreshgetSingleNewsEvent = function (id) {
	      getSingleNewsEvent(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            news_id: records.id,
	            news_events_title: records.news_events_title,
	            news_events_desc: records.news_events_desc,
	            news_events_pic: records.news_events_pic
	          });
	        } else {
	          _this.setState({
	            news_id: "",
	            news_events_title: "",
	            news_events_desc: "",
	            news_events_pic: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(newsEventsView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSingleNewsEvent(this.props.match.params.id);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "section",
	                        { className: "view-page" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "container" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "view-page-box" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-3" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "view-img" },
	                                  this.state.news_events_pic ? _react2.default.createElement("img", {
	                                    src: _constants.IMAGE_URL + "NewsEventsImg/" + this.state.news_events_pic,
	                                    alt: ""
	                                  }) : _react2.default.createElement("img", { src: _avatar_circle2.default, alt: "" })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-6" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "view-text" },
	                                  _react2.default.createElement(
	                                    "h2",
	                                    null,
	                                    this.state.news_events_title
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-3" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edit" },
	                                  _react2.default.createElement(
	                                    "a",
	                                    {
	                                      href: "/editnewsevent/" + this.state.news_id
	                                    },
	                                    _react2.default.createElement("i", { className: "fa fa-pencil" })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement("hr", null),
	                            this.state.news_events_desc ? _react2.default.createElement(
	                              "div",
	                              { className: "col-lg-6 col-md-12" },
	                              _react2.default.createElement(
	                                "h3",
	                                null,
	                                "Description"
	                              ),
	                              _react2.default.createElement("p", {
	                                dangerouslySetInnerHTML: {
	                                  __html: this.state.news_events_desc
	                                }
	                              })
	                            ) : _react2.default.createElement("div", null)
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return newsEventsView;
	}(_react.Component);
	
	exports.default = newsEventsView;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getAllNewsEvents = function getAllNewsEvents(data) {
	  return _.scAxiosAdmin.request("/newsevents/getallnewsevents?show_hidden=1", {
	    method: "get",
	    headers: {
	      Accept: "application/json",
	      Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	    },
	    params: data
	  }).then(function (res) {
	    return res.data;
	  }).catch(function (err) {
	    throw err;
	  });
	};
	
	var getSearchNewsEvents = function getSearchNewsEvents(data) {
	  return _.scAxiosAdmin.request("/newsevents/adminsearchnewsevents", {
	    method: "get",
	    headers: {
	      Accept: "application/json",
	      Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	    },
	    params: data
	  }).then(function (res) {
	    return res.data;
	  }).catch(function (err) {
	    throw err;
	  });
	};
	
	var deletenewsevent = function deletenewsevent(data) {
	  return _.scAxiosAdmin.request("/newsevents/delete/" + data.newsevent_id, {
	    method: "delete",
	    headers: {
	      Accept: "application/json",
	      Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	    },
	    params: data
	  }).then(function (res) {
	    return res.data;
	  }).catch(function (err) {
	    throw err;
	  });
	};
	
	var NewsEvents = function NewsEvents() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      newsevents = _useState2[0],
	      setNewsEvents = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    total: 0,
	    currentPage: 1,
	    perPage: 0,
	    totalPages: 0
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      paginationData = _useState4[0],
	      setPaginationData = _useState4[1];
	  // console.log("your log output", paginationData);
	
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      searchKeywords = _useState6[0],
	      setSearchKeywords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(1),
	      _useState8 = _slicedToArray(_useState7, 2),
	      activePage = _useState8[0],
	      setActivePage = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      enableShdo = _useState10[0],
	      setEnableShdo = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      modalDeleteConfirm = _useState12[0],
	      setModalDeleteConfirm = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      newseventId = _useState14[0],
	      setNewsEventId = _useState14[1];
	  // console.log("your log output", activePage);
	
	
	  (0, _react.useEffect)(function () {
	    refreshNewsEvents(activePage);
	  }, [activePage]);
	
	  var refreshNewsEvents = function refreshNewsEvents() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	    setEnableShdo(true);
	    getAllNewsEvents({ page: page }).then(function (res) {
	      if (res.status) {
	        setNewsEvents(res.data.data);
	
	        setPaginationData({
	          total: res.data.total,
	          currentPage: res.data.current_page,
	          perPage: res.data.per_page,
	          totalPages: Math.ceil(res.data.total / res.data.per_page)
	        });
	      } else {
	        setNewsEvents([]);
	      }
	    }).finally(function () {
	      return setEnableShdo(false);
	    }).catch(function (err) {
	      return console.error(err);
	    });
	  };
	
	  var handleSearch = function handleSearch() {
	    getSearchNewsEvents({ keywords: searchKeywords }).then(function (res) {
	      if (res.status) {
	        setNewsEvents(res.data.data);
	        setPaginationData({
	          total: res.data.total,
	          currentPage: res.data.current_page,
	          perPage: res.data.per_page,
	          totalPages: Math.ceil(res.data.total / res.data.per_page)
	        });
	      } else {
	        setNewsEvents([]);
	      }
	    }).catch(function (err) {
	      return console.error(err);
	    });
	  };
	
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setActivePage(pageNumber);
	  };
	
	  var handleDeleteNewsEvent = function handleDeleteNewsEvent(id) {
	    deletenewsevent({ newsevent_id: id }).then(function (res) {
	      if (res.status) {
	        _reactToastify.toast.success(res.message, { position: _reactToastify.toast.POSITION.TOP_RIGHT });
	        refreshNewsEvents(activePage);
	      } else {
	        _reactToastify.toast.error(res.message, { position: _reactToastify.toast.POSITION.BOTTOM_RIGHT });
	      }
	    }).catch(function (err) {
	      return console.error(err);
	    });
	    setModalDeleteConfirm(false);
	  };
	  var togglePackageStatus = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(item) {
	      var newStatus, data, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              newStatus = item.status === "1" ? "0" : "1";
	              data = {
	                status: newStatus
	              };
	              _context.prev = 2;
	              _context.next = 5;
	              return _.scAxiosAdmin.post("/newsevents/updatestatusnewsevents/" + item.id, data);
	
	            case 5:
	              response = _context.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Status updated successfully", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT
	                });
	                setNewsEvents(function (prev) {
	                  return prev.map(function (pkg) {
	                    return pkg.id === item.id ? Object.assign({}, pkg, { status: newStatus }) : pkg;
	                  });
	                });
	              } else {
	                _reactToastify.toast.error("Failed to update status", {
	                  position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                });
	              }
	              _context.next = 13;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context["catch"](2);
	
	              console.error("Error updating status:", _context.t0);
	              _reactToastify.toast.error("Failed to update status", {
	                position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	              });
	
	            case 13:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 9]]);
	    }));
	
	    return function togglePackageStatus(_x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var renderNewsEvents = function renderNewsEvents() {
	    return newsevents.map(function (newsevent) {
	      return _react2.default.createElement(
	        "div",
	        { className: "col-lg-4", key: newsevent.id },
	        _react2.default.createElement(
	          "div",
	          { className: "news-part-event" },
	          _react2.default.createElement("img", {
	            src: _constants.IMAGE_URL + "/NewsEventsImg/" + newsevent.news_events_pic,
	            alt: "",
	            width: "100%"
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: "newdata position-relative" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-10" },
	                _react2.default.createElement(
	                  "h3",
	                  {
	                    className: "d-inline",
	                    style: { fontSize: "18px" },
	                    title: newsevent.news_events_title
	                  },
	                  newsevent.news_events_title ? newsevent.news_events_title.substr(0, 50) + "..." : ""
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "h5",
	              { className: "float-end position-absolute mt-2 top-0 end-0" },
	              _react2.default.createElement(
	                "a",
	                { href: "/editnewsevent/" + newsevent.id },
	                _react2.default.createElement("i", { className: "fa fa-pencil-square mx-2 display-4" })
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "ms-2",
	                  title: "Status",
	                  onClick: function onClick() {
	                    return togglePackageStatus(newsevent);
	                  }
	                },
	                newsevent.status === "1" ? _react2.default.createElement("i", { "class": "fa-solid fa-eye" }) : _react2.default.createElement("i", { "class": "fa-solid fa-eye-slash" })
	              ),
	              _react2.default.createElement(
	                "a",
	                { href: "/viewnewsevent/" + newsevent.id },
	                _react2.default.createElement("i", { "class": "fa-solid fa-laptop mx-3" })
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  onClick: function onClick() {
	                    return setModalDeleteConfirm(true) && setNewsEventId(newsevent.id);
	                  }
	                },
	                _react2.default.createElement("i", { className: "fa fa-trash" })
	              )
	            )
	          ),
	          _react2.default.createElement("p", {
	            dangerouslySetInnerHTML: {
	              __html: newsevent.news_events_desc ? newsevent.news_events_desc.substr(0, 170) : ""
	            }
	          })
	        )
	      );
	    });
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "row page-content-wrapper" },
	            _react2.default.createElement("div", { className: "col-sm-7" }),
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-3 text-right" },
	              _react2.default.createElement("input", {
	                type: "text",
	                className: "form-control",
	                name: "search_keywords",
	                value: searchKeywords,
	                onChange: function onChange(e) {
	                  return setSearchKeywords(e.target.value);
	                },
	                onBlur: handleSearch,
	                placeholder: "Search"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-2 mb-4 text-right" },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "/addnewsevent",
	                  className: "btn btn-sm btn-primary waves-effect waves-light"
	                },
	                "Add News Event"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "section",
	                    { className: "view-page" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "container" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "view-page-box" },
	                        _react2.default.createElement("hr", null),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          newsevents.length > 0 ? renderNewsEvents() : _react2.default.createElement(
	                            "div",
	                            {
	                              colspan: "6",
	                              className: "font_12 txt_col fontweight400 text-center"
	                            },
	                            "There are currently no News Events."
	                          )
	                        ),
	                        _react2.default.createElement("br", null)
	                      ),
	                      paginationData.totalPages > 1 && _react2.default.createElement(_reactJsPagination2.default, {
	                        activePage: activePage,
	                        totalItemsCount: paginationData.total,
	                        pageRangeDisplayed: 5,
	                        onChange: handlePageChange
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 }),
	    modalDeleteConfirm && _react2.default.createElement(
	      _DeleteConfirmModalPopup2.default,
	      {
	        show: modalDeleteConfirm,
	        handleClose: function handleClose() {
	          return setModalDeleteConfirm(false);
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "custom_reviews_popup" },
	        _react2.default.createElement(
	          "h2",
	          { className: "text-center" },
	          "Are you sure you want to delete this news event?"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group row" },
	          _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-6 text-center" },
	            _react2.default.createElement(
	              "button",
	              {
	                className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                onClick: function onClick() {
	                  return setModalDeleteConfirm(false);
	                }
	              },
	              "No"
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "blue_btn_box add_staff_btn mt-5",
	                onClick: function onClick() {
	                  return handleDeleteNewsEvent(newseventId);
	                }
	              },
	              "Yes"
	            )
	          ),
	          _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	        )
	      )
	    )
	  );
	};
	
	exports.default = NewsEvents;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _reactToastify = __webpack_require__(7);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Packages = function Packages() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchdata = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(1),
	      _useState4 = _slicedToArray(_useState3, 2),
	      currentPage = _useState4[0],
	      setCurrentPage = _useState4[1];
	
	  var itemsPerPage = 10;
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filteredData = _useState6[0],
	      setFilteredData = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      searchTerm = _useState8[0],
	      setSearchTerm = _useState8[1];
	
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/packages/get_package_list?show_hidden=1");
	
	            case 3:
	              response = _context.sent;
	
	              if (response.status === 200) {
	                setFatchdata(response.data.data);
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var togglePackageStatus = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(item) {
	      var newStatus, data, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              newStatus = item.status === "1" ? "0" : "1";
	              data = {
	                package_id: item.id,
	                status: newStatus
	              };
	              _context2.prev = 2;
	              _context2.next = 5;
	              return _.thirdparty.post("packages/update_status_packages/" + item.id, data);
	
	            case 5:
	              response = _context2.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Status updated successfully", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT
	                });
	                setFatchdata(function (prev) {
	                  return prev.map(function (pkg) {
	                    return pkg.id === item.id ? Object.assign({}, pkg, { status: newStatus }) : pkg;
	                  });
	                });
	              } else {
	                _reactToastify.toast.error("Failed to update status", {
	                  position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	                });
	              }
	              _context2.next = 13;
	              break;
	
	            case 9:
	              _context2.prev = 9;
	              _context2.t0 = _context2["catch"](2);
	
	              console.error("Error updating status:", _context2.t0);
	              _reactToastify.toast.error("Failed to update status", {
	                position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	              });
	
	            case 13:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[2, 9]]);
	    }));
	
	    return function togglePackageStatus(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var handleDelete = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(id) {
	      var confirmation, response;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              confirmation = confirm("Are you sure to delete this item?");
	
	              if (confirmation) {
	                _context3.next = 4;
	                break;
	              }
	
	              return _context3.abrupt("return");
	
	            case 4:
	              _context3.next = 6;
	              return _.thirdparty.delete("/packages/delete_package/" + id);
	
	            case 6:
	              response = _context3.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Deleted Successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT
	                });
	                fetchData();
	              }
	              _context3.next = 13;
	              break;
	
	            case 10:
	              _context3.prev = 10;
	              _context3.t0 = _context3["catch"](0);
	
	              console.error("Error deleting item with ID " + id + ":", _context3.t0.message);
	
	            case 13:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[0, 10]]);
	    }));
	
	    return function handleDelete(_x2) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setCurrentPage(pageNumber);
	  };
	
	  (0, _react.useEffect)(function () {
	    fetchData();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var filteredData = fatchdata && fatchdata.filter(function (item) {
	      return Object.values(item).some(function (value) {
	        return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
	      });
	    });
	    setFilteredData(filteredData);
	  }, [fatchdata, searchTerm]);
	
	  var indexOfLastItem = currentPage * itemsPerPage;
	  var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  var currentItems = filteredData ? filteredData.slice(indexOfFirstItem, indexOfLastItem) : [];
	
	  var handleSearch = function handleSearch(event) {
	    setSearchTerm(event.target.value);
	    setCurrentPage(1);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "row page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "card p-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "card-header row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-8" },
	                  _react2.default.createElement(
	                    "h5",
	                    { className: "card-title text-left" },
	                    "Packages"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2 text-right" },
	                  _react2.default.createElement("input", {
	                    className: "form-control",
	                    type: "search",
	                    placeholder: "Search",
	                    "aria-label": "Search",
	                    value: searchTerm,
	                    onChange: handleSearch,
	                    style: {
	                      background: "transparent",
	                      border: "none"
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2 text-right" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/addpackage", className: "btn btn-primary" },
	                    "Add New"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "card-body" },
	                _react2.default.createElement(
	                  "table",
	                  { className: "table table-striped table-hover" },
	                  _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "th",
	                        { scope: "col" },
	                        "#"
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        { scope: "col" },
	                        "Name"
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        { scope: "col" },
	                        "Department"
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        { scope: "col" },
	                        "Age Range"
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        { scope: "col" },
	                        "Gender"
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        { scope: "col" },
	                        "Action"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tbody",
	                    null,
	                    currentItems.length > 0 ? currentItems.map(function (item) {
	                      return _react2.default.createElement(
	                        "tr",
	                        { key: item.id },
	                        _react2.default.createElement(
	                          "th",
	                          null,
	                          item.id
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          item.name
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          item.department_name
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          item.age
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          item.gender
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          _react2.default.createElement(
	                            "a",
	                            { className: "ms-2",
	                              title: "Status",
	                              onClick: function onClick() {
	                                return togglePackageStatus(item);
	                              }
	                            },
	                            item.status === "1" ? _react2.default.createElement("i", { "class": "fa-solid fa-eye" }) : _react2.default.createElement("i", { "class": "fa-solid fa-eye-slash" })
	                          ),
	                          _react2.default.createElement(
	                            "a",
	                            { className: "ms-2", href: "/editpackage/" + item.slug },
	                            _react2.default.createElement("i", { "class": "fa-solid fa-pencil-square" })
	                          ),
	                          _react2.default.createElement(
	                            "a",
	                            { className: "ms-2", onClick: function onClick() {
	                                return handleDelete(item.id);
	                              } },
	                            _react2.default.createElement("i", {
	                              className: "fa fa-trash display-4",
	                              "data-bs-toggle": "tooltip",
	                              "data-bs-placement": "top",
	                              title: "Delete Request"
	                            })
	                          )
	                        )
	                      );
	                    }) : _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { colSpan: "100%", className: "text-center" },
	                        "No data found"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(_reactJsPagination2.default, {
	                  activePage: currentPage,
	                  itemsCountPerPage: itemsPerPage,
	                  totalItemsCount: filteredData ? filteredData.length : 1,
	                  pageRangeDisplayed: 5,
	                  onChange: handlePageChange
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Packages;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getsinglestaticpage = function getsinglestaticpage(id) {
	    return new Promise(function (resolve, reject) {
	        var req = _.scAxiosAdmin.request('/staticpages/getsinglestaticpage/' + id, {
	            method: 'get',
	            headers: {
	                'Accept': 'application/json',
	                'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	            }
	        });
	        req.then(function (res) {
	            return resolve(res.data);
	        }).catch(function (err) {
	            return reject(err);
	        });
	    });
	};
	
	var page = function (_Component) {
	    _inherits(page, _Component);
	
	    function page() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, page);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = page.__proto__ || Object.getPrototypeOf(page)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            fields: {},
	            errors: {},
	            page_id: '',
	            page_description: '',
	            page_title: '',
	            page_image: ''
	        }, _this.refreshgetsinglestaticpages = function (id) {
	            getsinglestaticpage(id).then(function (res) {
	                if (res.status === true) {
	                    var records = res.data;
	                    _this.setState({
	                        page_id: records.id,
	                        page_title: records.title,
	                        page_description: records.description,
	                        page_image: records.image
	                    });
	                } else {
	                    _this.setState({
	                        page_id: '',
	                        page_title: '',
	                        page_description: '',
	                        page_image: ''
	                    });
	                }
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(page, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refreshgetsinglestaticpages(this.props.match.params.id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'fixed-left' },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'wrapper' },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-page' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'page-content-wrapper' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'card m-b-20' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'card-body' },
	                                            _react2.default.createElement(
	                                                'section',
	                                                { className: 'view-page' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'container' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'view-page-box' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-sm-3' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'view-img' },
	                                                                    this.state.page_image ? _react2.default.createElement('img', { src: _constants.IMAGE_URL + 'StaticPages/' + this.state.page_image, alt: '' }) : _react2.default.createElement('img', { src: _avatar_circle2.default, alt: '' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-sm-6' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'view-text' },
	                                                                    _react2.default.createElement(
	                                                                        'h2',
	                                                                        null,
	                                                                        this.state.page_title
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-sm-3' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'edit' },
	                                                                    _react2.default.createElement(
	                                                                        'a',
	                                                                        { href: '/editstaticpage/' + this.state.page_title },
	                                                                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement('hr', null),
	                                                        _react2.default.createElement(
	                                                            'h3',
	                                                            null,
	                                                            'Description'
	                                                        ),
	                                                        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: this.state.page_description } }),
	                                                        _react2.default.createElement('hr', null)
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return page;
	}(_react.Component);
	
	exports.default = page;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSinglePublictication = function getSinglePublictication(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/publications/getsinglepublications/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleDoctorPublications = function getSingleDoctorPublications(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/publications/getdoctorpublicationname/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var publicationView = function (_Component) {
	  _inherits(publicationView, _Component);
	
	  function publicationView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, publicationView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = publicationView.__proto__ || Object.getPrototypeOf(publicationView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      publication_id: "",
	      publications_title: "",
	      publications_desc: "",
	      publications_pic: ""
	    }, _this.refreshgetSinglePublication = function (id) {
	      getSinglePublictication(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            publication_id: records.id,
	            publications_title: records.publications_title,
	            doctor_id: records.doctor_id,
	            publications_desc: records.publications_desc,
	            publications_pic: records.publications_pic
	          });
	        } else {
	          _this.setState({
	            publication_id: "",
	            publications_title: "",
	            publications_desc: "",
	            publications_pic: "",
	            doctor_id: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshgetDoctorNamePublication = function (id) {
	      getSingleDoctorPublications(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            doctor_name: records.doctor_name
	          });
	        } else {
	          _this.setState({
	            doctor_name: records.doctor_name
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(publicationView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSinglePublication(this.props.match.params.id);
	      this.refreshgetDoctorNamePublication(this.props.match.params.id);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "section",
	                        { className: "view-page" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "container" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "view-page-box" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-3" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "view-img" },
	                                  this.state.publications_pic ? _react2.default.createElement("img", {
	                                    src: _constants.IMAGE_URL + "PublicationsImg/" + this.state.publications_pic,
	                                    alt: ""
	                                  }) : _react2.default.createElement("img", { src: _avatar_circle2.default, alt: "" })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-6" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "view-text" },
	                                  _react2.default.createElement(
	                                    "h2",
	                                    null,
	                                    this.state.publications_title
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                      "b",
	                                      null,
	                                      this.state.doctor_name
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-3" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edit" },
	                                  _react2.default.createElement(
	                                    "a",
	                                    {
	                                      href: "/admin/editpublication/" + this.state.publication_id
	                                    },
	                                    _react2.default.createElement("i", { className: "fa fa-pencil" })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement("hr", null),
	                            this.state.publications_desc ? _react2.default.createElement(
	                              "div",
	                              { className: "col-lg-6 col-md-12" },
	                              _react2.default.createElement(
	                                "h3",
	                                null,
	                                "Description"
	                              ),
	                              _react2.default.createElement("p", {
	                                dangerouslySetInnerHTML: {
	                                  __html: this.state.publications_desc
	                                }
	                              })
	                            ) : _react2.default.createElement("div", null)
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return publicationView;
	}(_react.Component);
	
	exports.default = publicationView;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _reactToastify = __webpack_require__(7);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _DownloadCSV = __webpack_require__(146);
	
	var _DownloadCSV2 = _interopRequireDefault(_DownloadCSV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Publications = function Publications() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchdata = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(1),
	      _useState4 = _slicedToArray(_useState3, 2),
	      currentPage = _useState4[0],
	      setCurrentPage = _useState4[1];
	
	  var itemsPerPage = 20; // Number of items to display per page
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filteredData = _useState6[0],
	      setfilteredData = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      searchTerm = _useState8[0],
	      setSearchTerm = _useState8[1];
	
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/publications/all");
	
	            case 3:
	              response = _context.sent;
	
	
	              if (response.status === 200) {
	                setFatchdata(response.data);
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var handleDelete = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(id) {
	      var confirmation, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              confirmation = confirm("Are you sure to delete this item?");
	
	              if (confirmation) {
	                _context2.next = 4;
	                break;
	              }
	
	              return _context2.abrupt("return");
	
	            case 4:
	              _context2.next = 6;
	              return _.thirdparty.delete("/publications/delete/" + id);
	
	            case 6:
	              response = _context2.sent;
	              // Update the API endpoint
	              if (response.status === 200) {
	                _reactToastify.toast.success("Deleted Successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT
	                });
	
	                fetchData(); // Fetch updated data after deletion
	              }
	              _context2.next = 13;
	              break;
	
	            case 10:
	              _context2.prev = 10;
	              _context2.t0 = _context2["catch"](0);
	
	              console.error("Error deleting item with ID " + id + ":", _context2.t0.message);
	
	            case 13:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 10]]);
	    }));
	
	    return function handleDelete(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  // Handle page change
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setCurrentPage(pageNumber);
	  };
	
	  // Initial data fetch
	  (0, _react.useEffect)(function () {
	    fetchData();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var filteredData = fatchdata && fatchdata.filter(function (item) {
	      return Object.values(item).some(function (value) {
	        return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
	      });
	    });
	
	    setfilteredData(filteredData);
	  }, [fatchdata, searchTerm]);
	
	  var indexOfLastItem = currentPage * itemsPerPage;
	  var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  var currentItems = filteredData ? filteredData.slice(indexOfFirstItem, indexOfLastItem) : [];
	
	  var handleSearch = function handleSearch(event) {
	    setSearchTerm(event.target.value);
	    setCurrentPage(1);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "row page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "card p-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "card-header row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4" },
	                  _react2.default.createElement(
	                    "h5",
	                    { className: "card-title text-left" },
	                    "Publications"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-8 d-flex justify-content-between align-items-center" },
	                  _react2.default.createElement("input", {
	                    className: "form-control border w-50",
	                    type: "search",
	                    placeholder: "Search",
	                    "aria-label": "Search",
	                    value: searchTerm,
	                    onChange: handleSearch,
	                    style: {
	                      background: "transparent",
	                      border: "none"
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "col-md-2" },
	                  _react2.default.createElement(_DownloadCSV2.default, {
	                    data: filteredData,
	                    fileName: "publications_list"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2 text-right" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/admin/addpublication", className: "btn btn-primary" },
	                    "Add Publication"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "card-body" },
	                _react2.default.createElement(
	                  "table",
	                  { className: "table table-striped table-hover" },
	                  _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "th",
	                        { scope: "col" },
	                        "#"
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        { scope: "col" },
	                        "Image"
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        { scope: "col" },
	                        "Title"
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        { scope: "col" },
	                        "Action"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tbody",
	                    null,
	                    currentItems.length > 0 ? currentItems.map(function (item) {
	                      return _react2.default.createElement(
	                        "tr",
	                        { key: item.id },
	                        _react2.default.createElement(
	                          "th",
	                          null,
	                          item.id
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          _react2.default.createElement("img", {
	                            src: _constants.IMAGE_URL + "/PublicationsImg/" + item.publications_pic,
	                            alt: "",
	                            width: "100%",
	                            className: "img-fluid",
	                            style: { maxWidth: "50px" }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          item.publications_title
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          _react2.default.createElement(
	                            "a",
	                            { href: "/admin/editpublication/" + item.slug },
	                            _react2.default.createElement("i", { className: "fa fa-pencil-square display-4" })
	                          ),
	                          _react2.default.createElement(
	                            "a",
	                            { href: "/publications/" + item.slug },
	                            _react2.default.createElement("i", { className: "fa fa-eye mx-2 display-4" })
	                          ),
	                          _react2.default.createElement(
	                            "a",
	                            { onClick: function onClick() {
	                                return handleDelete(item.id);
	                              } },
	                            _react2.default.createElement("i", {
	                              className: "fa fa-trash display-4",
	                              "data-bs-toggle": "tooltip",
	                              "data-bs-placement": "top",
	                              title: "Delete Request"
	                            })
	                          )
	                        )
	                      );
	                    }) : _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { colSpan: "100%", className: "text-center" },
	                        "No data found"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(_reactJsPagination2.default, {
	                  activePage: currentPage,
	                  itemsCountPerPage: itemsPerPage,
	                  totalItemsCount: filteredData ? filteredData.length : 1,
	                  pageRangeDisplayed: 5,
	                  onChange: handlePageChange
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Publications;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _ = __webpack_require__(2);
	
	var _reactVirtualizedSelect = __webpack_require__(78);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	__webpack_require__(73);
	
	__webpack_require__(75);
	
	__webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var roleManager = function roleManager() {
	  var user_role_form_ref = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchData = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    role_name: "",
	    status: 1
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      formData = _useState4[0],
	      setFormData = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      userList = _useState6[0],
	      setUserList = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    id: 0,
	    role: 0
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      userRoleForm = _useState8[0],
	      setUserRoleForm = _useState8[1];
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	    setFormData(Object.assign({}, formData, _defineProperty({}, name, value)));
	  };
	
	  var handleChange_user_role = function handleChange_user_role(e) {
	    var _e$target2 = e.target,
	        name = _e$target2.name,
	        value = _e$target2.value;
	
	    setUserRoleForm(Object.assign({}, userRoleForm, _defineProperty({}, name, value)));
	  };
	
	  var handleSubmit = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              e.preventDefault();
	              _context.prev = 1;
	              _context.next = 4;
	              return _.thirdparty.post("/roles", formData, {
	                headers: {
	                  "Content-Type": "application/json"
	                }
	              });
	
	            case 4:
	              response = _context.sent;
	
	              if (response.status === 201) {
	                setFormData(Object.assign({}, formData, {
	                  role_name: ""
	                }));
	                _reactToastify.toast.success("Data Added successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	                fetchData();
	              }
	              _context.next = 11;
	              break;
	
	            case 8:
	              _context.prev = 8;
	              _context.t0 = _context["catch"](1);
	
	              console.error("Error submitting form:", _context.t0);
	
	            case 11:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[1, 8]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var handleUserRoleSubmit = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	      var userFormData, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              e.preventDefault();
	              userFormData = { role: userRoleForm.role };
	              _context2.prev = 2;
	              _context2.next = 5;
	              return _.thirdparty.put("/user/update_patient/" + userRoleForm.id, userFormData, {
	                headers: {
	                  "Content-Type": "application/json"
	                }
	              });
	
	            case 5:
	              response = _context2.sent;
	
	              if (response.status === 200) {
	                setUserRoleForm(Object.assign({}, userRoleForm, {
	                  id: 0,
	                  role: 0
	                }));
	                _reactToastify.toast.success("Roles updated successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	                fetchUser();
	              }
	              _context2.next = 12;
	              break;
	
	            case 9:
	              _context2.prev = 9;
	              _context2.t0 = _context2["catch"](2);
	
	              console.error("Error submitting form:", _context2.t0);
	
	            case 12:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[2, 9]]);
	    }));
	
	    return function handleUserRoleSubmit(_x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var fetchData = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var response;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              _context3.next = 3;
	              return _.thirdparty.get("/roles");
	
	            case 3:
	              response = _context3.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                setFatchdata(response.data);
	                // setLoading(false);
	              }
	              _context3.next = 10;
	              break;
	
	            case 7:
	              _context3.prev = 7;
	              _context3.t0 = _context3["catch"](0);
	
	              console.error("Error fetching data:", _context3.t0.message);
	
	            case 10:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var fetchUser = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var response;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.prev = 0;
	              _context4.next = 3;
	              return _.thirdparty.get("/user/get_user_list");
	
	            case 3:
	              response = _context4.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                setUserList(response.data.data);
	                // setLoading(false);
	              }
	              _context4.next = 10;
	              break;
	
	            case 7:
	              _context4.prev = 7;
	              _context4.t0 = _context4["catch"](0);
	
	              console.error("Error fetching data:", _context4.t0.message);
	
	            case 10:
	            case "end":
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined, [[0, 7]]);
	    }));
	
	    return function fetchUser() {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  var handleDelete = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(id) {
	      var confirmation, response;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              confirmation = confirm("Are you sure to delete this item?");
	
	              if (confirmation) {
	                _context5.next = 3;
	                break;
	              }
	
	              return _context5.abrupt("return");
	
	            case 3:
	              _context5.prev = 3;
	              _context5.next = 6;
	              return _.thirdparty.delete("/roles/" + id);
	
	            case 6:
	              response = _context5.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                fetchData(); // Fetch updated data after deletion
	                _reactToastify.toast.success("Data Deleted successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	              }
	              _context5.next = 13;
	              break;
	
	            case 10:
	              _context5.prev = 10;
	              _context5.t0 = _context5["catch"](3);
	
	              console.error("Error deleting item with ID " + id + ":", _context5.t0.message);
	
	            case 13:
	            case "end":
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined, [[3, 10]]);
	    }));
	
	    return function handleDelete(_x3) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  var handleRolePermission = function handleRolePermission(user_id, role_id) {
	    setUserRoleForm.apply(undefined, _toConsumableArray(userRoleForm).concat([{
	      id: user_id || 0,
	      role: role_id || 0
	    }]));
	
	    window.scrollTo({
	      behavior: "smooth",
	      top: user_role_form_ref.current.offsetTop
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    fetchData();
	    fetchUser();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(_Seo2.default, {
	      title: "Set User Role ",
	      description: "Set User Role - United Hospital",
	      pathSlug: "/admin/addRole",
	      keywords: "Set New User Role"
	    }),
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 col-sm-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "h5",
	                  { className: "card-header" },
	                  "Add New Role"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      id: "adddepartmentform",
	                      className: "needs-validation",
	                      noValidate: true,
	                      onSubmit: handleSubmit
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Role Title"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            form_type: "role_create",
	                            className: "form-control",
	                            name: "role_name",
	                            id: "role_name",
	                            value: formData.role_name,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Role Title"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group float-right" },
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              type: "submit",
	                              className: "btn waves-effect waves-light"
	                            },
	                            "Submit"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "h5",
	                  { className: "card-header" },
	                  "Role List"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "table",
	                    { className: "table", width: "100%" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "#"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Title"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Status"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col", className: "text-right" },
	                          "Action"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      fatchData.length > 0 ? fatchData.map(function (item, index) {
	                        return _react2.default.createElement(
	                          "tr",
	                          { key: item.id },
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "row" },
	                            index + 1
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            item.role_name
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            item.status == 1 ? "Active" : "Inactive"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement(
	                              "h5",
	                              {
	                                className: "mt-2",
	                                style: {
	                                  display: "flex",
	                                  alignItems: "flex-end",
	                                  columnGap: "10px",
	                                  rowGap: "10px",
	                                  justifyContent: "flex-end"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  href: "/admin/role-permission/" + item.id,
	                                  role_id: item.id
	                                },
	                                _react2.default.createElement("i", { className: "fa fa-pencil-square " })
	                              ),
	                              _react2.default.createElement(
	                                "a",
	                                { onClick: function onClick() {
	                                    return handleDelete(item.id);
	                                  } },
	                                _react2.default.createElement("i", { className: "fa fa-trash" })
	                              )
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "th",
	                          { colSpan: 3 },
	                          "Data Not Found"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "h5",
	                  { className: "card-header" },
	                  "User Role Setup"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      id: "user_role_setup",
	                      className: "needs-validation",
	                      noValidate: true,
	                      onSubmit: handleUserRoleSubmit,
	                      ref: user_role_form_ref
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "User"
	                          ),
	                          _react2.default.createElement(_reactVirtualizedSelect2.default, {
	                            id: "id",
	                            name: "author_id",
	                            className: "form-control custom_select_search",
	                            placeholder: "Select User",
	                            options: userList.map(function (item, index) {
	                              return {
	                                label: item.fullname + " (" + item.email + ")",
	                                value: item.id
	                              };
	                            }),
	                            value: userRoleForm.id,
	                            onChange: function onChange(selectValue) {
	                              return setUserRoleForm(Object.assign({}, userRoleForm, {
	                                id: selectValue.value
	                              }));
	                            }
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Role"
	                          ),
	                          _react2.default.createElement(_reactVirtualizedSelect2.default, {
	                            id: "author_id",
	                            name: "role",
	                            className: "form-control custom_select_search",
	                            placeholder: "Select Role",
	                            options: fatchData.map(function (item, index) {
	                              return {
	                                label: item.role_name,
	                                value: item.id
	                              };
	                            }),
	                            value: userRoleForm.role,
	                            onChange: function onChange(selectValue) {
	                              return setUserRoleForm(Object.assign({}, userRoleForm, {
	                                role: selectValue.value
	                              }));
	                            }
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group float-right" },
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              type: "submit",
	                              className: "btn waves-effect waves-light"
	                            },
	                            "Submit"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "h5",
	                  { className: "card-header" },
	                  "User List"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "table",
	                    { className: "table" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "#"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Role"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Name"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Phone"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Email"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col", className: "text-right" },
	                          "Action"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      userList.length > 0 ? userList.map(function (item, index) {
	                        return _react2.default.createElement(
	                          "tr",
	                          { key: item.id },
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "row" },
	                            index + 1
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            item.roles ? item.roles.role_name : "-"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            item.fullname
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            item.phone
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            item.email
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement(
	                              "h5",
	                              {
	                                className: "mt-2",
	                                style: {
	                                  display: "flex",
	                                  alignItems: "flex-end",
	                                  columnGap: "10px",
	                                  rowGap: "10px",
	                                  justifyContent: "flex-end"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  onClick: function onClick() {
	                                    return handleRolePermission(item.id, item.role);
	                                  },
	                                  title: "Set Role"
	                                },
	                                _react2.default.createElement("i", { className: "fa fa-pencil-square " })
	                              )
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "th",
	                          { colSpan: 3 },
	                          "Data Not Found"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = roleManager;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var setSSLConfig = function setSSLConfig() {
	  var _useState = (0, _react.useState)({
	    env_type: "",
	    sandbox_api_url: "",
	    sandbox_store_id: "",
	    sandbox_store_password: "",
	    production_api_url: "",
	    production_store_id: "",
	    production_store_password: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/ssl_commerz_config/1");
	
	            case 3:
	              response = _context.sent;
	
	              if (response.status === 200) {
	                setFormData.apply(undefined, _toConsumableArray(formData).concat([response.data]));
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	    setFormData(Object.assign({}, formData, _defineProperty({}, name, value)));
	  };
	
	  var handleSubmit = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              e.preventDefault();
	              _context2.prev = 1;
	              _context2.next = 4;
	              return _.thirdparty.put("/ssl_commerz_config/1", formData, {
	                headers: {
	                  "Content-Type": "application/json"
	                }
	              });
	
	            case 4:
	              response = _context2.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Data updated successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	              }
	
	              _context2.next = 11;
	              break;
	
	            case 8:
	              _context2.prev = 8;
	              _context2.t0 = _context2["catch"](1);
	
	              console.error("Error submitting form:", _context2.t0);
	
	            case 11:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[1, 8]]);
	    }));
	
	    return function handleSubmit(_x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	  (0, _react.useEffect)(function () {
	    fetchData();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(_Seo2.default, {
	      title: "SSL-Commerz Configuration ",
	      description: "SSL-Commerz Configuration - United Hospital",
	      pathSlug: "/admin/set_ssl_commerz",
	      keywords: "SSL-Commerz Configuration"
	    }),
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-10" },
	              _react2.default.createElement(
	                "div",
	                { className: "card m-b-20" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-body" },
	                  _react2.default.createElement(
	                    "form",
	                    {
	                      id: "adddepartmentform",
	                      className: "needs-validation",
	                      noValidate: true,
	                      onSubmit: handleSubmit
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-4" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Environment"
	                          ),
	                          _react2.default.createElement(
	                            "select",
	                            {
	                              className: "form-control",
	                              name: "env_type",
	                              id: "env_type",
	                              value: formData.env_type,
	                              onChange: handleChange
	                            },
	                            _react2.default.createElement(
	                              "option",
	                              { value: "" },
	                              "Select Environment"
	                            ),
	                            _react2.default.createElement(
	                              "option",
	                              { value: "sandbox" },
	                              "Sandbox"
	                            ),
	                            _react2.default.createElement(
	                              "option",
	                              { value: "production" },
	                              "Production"
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Sandbox URL"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "sandbox_api_url",
	                            id: "sandbox_api_url",
	                            value: formData.sandbox_api_url,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Sandbox URL"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Sandbox Store ID"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "sandbox_store_id",
	                            id: "sandbox_store_id",
	                            value: formData.sandbox_store_id,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Sandbox Store Id"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Sandbox Store Password"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "sandbox_store_password",
	                            id: "sandbox_store_password",
	                            value: formData.sandbox_store_password,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Sandbox Store Password"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Production URL"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "production_api_url",
	                            id: "production_api_url",
	                            value: formData.production_api_url,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Production URL"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Production Store ID"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "production_store_id",
	                            id: "production_store_id",
	                            value: formData.production_store_id,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Production Store Id"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            null,
	                            "Production Store Password"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "production_store_password",
	                            id: "production_store_password",
	                            value: formData.production_store_password,
	                            onChange: handleChange,
	                            required: true,
	                            placeholder: "Production Store Password"
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group float-right" },
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "submit",
	                            className: "btn waves-effect waves-light"
	                          },
	                          "Submit"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = setSSLConfig;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GetAllStaticPages = function GetAllStaticPages() {
	  return _.scAxiosAdmin.request("/static_services_pages", {
	    method: "get",
	    headers: {
	      Accept: "application/json",
	      Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	    }
	  });
	};
	
	var deletePackage = function deletePackage(data) {
	  return _.scAxiosAdmin.request("/static_services_pages/" + data.staticpage_id, {
	    method: "delete",
	    headers: {
	      Accept: "application/json",
	      Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	    },
	    params: Object.assign({}, data)
	  });
	};
	
	var StaticPages = function StaticPages() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      allStaticPages = _useState2[0],
	      setAllStaticPages = _useState2[1]; // To store all fetched data
	
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      staticPages = _useState4[0],
	      setStaticPages = _useState4[1]; // To store filtered/paginated data
	
	
	  var _useState5 = (0, _react.useState)(1),
	      _useState6 = _slicedToArray(_useState5, 2),
	      currentPage = _useState6[0],
	      setCurrentPage = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      totalPages = _useState8[0],
	      setTotalPages = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(""),
	      _useState10 = _slicedToArray(_useState9, 2),
	      searchKeywords = _useState10[0],
	      setSearchKeywords = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      modalDeleteConfirm = _useState12[0],
	      setModalDeleteConfirm = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      staticPageId = _useState14[0],
	      setStaticPageId = _useState14[1];
	
	  var itemsPerPage = 10;
	
	  var refreshStaticPages = function refreshStaticPages() {
	    GetAllStaticPages().then(function (res) {
	      if (res.data) {
	        setAllStaticPages(res.data);
	        setStaticPages(res.data.slice(0, itemsPerPage));
	        setTotalPages(Math.ceil(res.data.length / itemsPerPage));
	      }
	    }).catch(function (err) {
	      return console.error(err);
	    });
	  };
	  console.log("your log output", totalPages);
	  var handleDeleteStaticPage = function handleDeleteStaticPage(id) {
	    deletePackage({ staticpage_id: id }).then(function (res) {
	      if (res.data.status) {
	        _reactToastify.toast.success(res.data.message, {
	          position: _reactToastify.toast.POSITION.TOP_RIGHT
	        });
	        refreshStaticPages();
	      } else {
	        _reactToastify.toast.error(res.data.message, {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }).catch(function (err) {
	      return console.error(err);
	    });
	  };
	
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setCurrentPage(pageNumber);
	    var startIdx = (pageNumber - 1) * itemsPerPage;
	    setStaticPages(allStaticPages.slice(startIdx, startIdx + itemsPerPage));
	  };
	
	  var handleSearch = function handleSearch() {
	    var filteredPages = allStaticPages.filter(function (page) {
	      return page.title.toLowerCase().includes(searchKeywords.toLowerCase());
	    });
	    setStaticPages(filteredPages.slice(0, itemsPerPage));
	    setTotalPages(Math.ceil(filteredPages.length / itemsPerPage));
	    setCurrentPage(1);
	  };
	
	  (0, _react.useEffect)(function () {
	    refreshStaticPages();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container-fluid" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-7" },
	                          _react2.default.createElement(
	                            "h4",
	                            { className: "mt-0 header-title" },
	                            "Static Pages"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-3 text-right" },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            value: searchKeywords,
	                            onChange: function onChange(e) {
	                              return setSearchKeywords(e.target.value);
	                            },
	                            onKeyUp: handleSearch,
	                            placeholder: "Search"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-2 text-right" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              href: "/addstaticpage",
	                              className: "btn btn-sm btn-primary waves-effect waves-light"
	                            },
	                            "Add Static Page"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "table-rep-plugin" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "table-responsive b-0" },
	                          _react2.default.createElement(
	                            "table",
	                            { className: "table table-striped" },
	                            _react2.default.createElement(
	                              "thead",
	                              null,
	                              _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "Page ID"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "Banner Image"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "Title"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "Components"
	                                ),
	                                _react2.default.createElement(
	                                  "th",
	                                  null,
	                                  "Action"
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "tbody",
	                              null,
	                              staticPages.length > 0 ? staticPages.map(function (page) {
	                                return _react2.default.createElement(
	                                  "tr",
	                                  { key: page.id },
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    "#",
	                                    page.id
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    page.image_mave ? _react2.default.createElement("img", {
	                                      src: "" + _constants.IMAGE_URL + page.image_mave,
	                                      alt: "banner",
	                                      style: {
	                                        width: "50px",
	                                        height: "50px",
	                                        borderRadius: "30px"
	                                      }
	                                    }) : _react2.default.createElement("img", {
	                                      src: _avatar_circle2.default,
	                                      alt: "avatar",
	                                      width: "50px"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    page.title
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    page.components.map(function (comp, idx) {
	                                      return _react2.default.createElement(
	                                        "div",
	                                        { key: comp.id },
	                                        idx + 1 + ". " + comp.type
	                                      );
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        href: "/admin/editpage/" + page.id + "?name=" + page.slug
	                                      },
	                                      _react2.default.createElement("i", { className: "fa fa-pencil-square" })
	                                    ),
	                                    _react2.default.createElement(
	                                      "a",
	                                      { href: "/page/" + page.slug },
	                                      _react2.default.createElement("i", { className: "fa fa-eye" })
	                                    ),
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        onClick: function onClick() {
	                                          setStaticPageId(page.id);
	                                          setModalDeleteConfirm(true);
	                                        }
	                                      },
	                                      _react2.default.createElement("i", { className: "fa fa-trash" })
	                                    ),
	                                    _react2.default.createElement(
	                                      _DeleteConfirmModalPopup2.default,
	                                      {
	                                        show: modalDeleteConfirm,
	                                        handleClose: function handleClose() {
	                                          return setModalDeleteConfirm(false);
	                                        }
	                                      },
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "custom_reviews_popup" },
	                                        _react2.default.createElement(
	                                          "h2",
	                                          { className: "text-center" },
	                                          "Are you sure you wish to delete this static page?"
	                                        ),
	                                        _react2.default.createElement(
	                                          "form",
	                                          {
	                                            className: "pop-form",
	                                            id: "edit_education"
	                                          },
	                                          _react2.default.createElement(
	                                            "div",
	                                            { className: "form-group row" },
	                                            _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                                            _react2.default.createElement(
	                                              "div",
	                                              { className: "col-sm-6 text-center" },
	                                              _react2.default.createElement(
	                                                "button",
	                                                {
	                                                  type: "button",
	                                                  className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                                  onClick: function onClick() {
	                                                    return setModalDeleteConfirm(false);
	                                                  }
	                                                },
	                                                "No"
	                                              ),
	                                              _react2.default.createElement(
	                                                "button",
	                                                {
	                                                  type: "button",
	                                                  className: "blue_btn_box add_staff_btn mt-5",
	                                                  onClick: function onClick() {
	                                                    handleDeleteStaticPage(staticPageId);
	                                                    setModalDeleteConfirm(false);
	                                                  }
	                                                },
	                                                "Yes"
	                                              )
	                                            ),
	                                            _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                );
	                              }) : _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                  "td",
	                                  { colSpan: "5", className: "text-center" },
	                                  "No Static Pages found."
	                                )
	                              )
	                            )
	                          ),
	                          totalPages > 1 && _react2.default.createElement(_reactJsPagination2.default, {
	                            activePage: currentPage,
	                            totalItemsCount: allStaticPages.length,
	                            itemsCountPerPage: itemsPerPage,
	                            pageRangeDisplayed: 5,
	                            onChange: handlePageChange
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	    )
	  );
	};
	
	exports.default = StaticPages;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSingleTestimonialData = function getSingleTestimonialData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/testimonials/getsingletestimonials/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var testimonialView = function (_Component) {
	  _inherits(testimonialView, _Component);
	
	  function testimonialView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, testimonialView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = testimonialView.__proto__ || Object.getPrototypeOf(testimonialView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      departments: [],
	      testimonial_id: "",
	      testimonial_name: "",
	      testimonial_desc: "",
	      author_name: "",
	      rating: "",
	      author_profile_pic: ""
	    }, _this.refreshgetSingleTestimonialData = function (id) {
	      getSingleTestimonialData(id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            testimonial_id: records.id,
	            testimonial_name: records.testimonial_name,
	            testimonial_desc: records.testimonial_desc,
	            author_name: records.author_name,
	            rating: records.rating,
	            author_profile_pic: records.author_profile_pic
	          });
	        } else {
	          _this.setState({
	            testimonial_id: "",
	            testimonial_name: "",
	            testimonial_desc: "",
	            author_name: "",
	            rating: "",
	            author_profile_pic: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(testimonialView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSingleTestimonialData(this.props.match.params.id);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "page-content-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "section",
	                        { className: "view-page" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "container" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "view-page-box" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-3" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "view-img" },
	                                  this.state.author_profile_pic ? _react2.default.createElement("img", {
	                                    src: _constants.IMAGE_URL + "AuthorProfileImg/" + this.state.author_profile_pic,
	                                    alt: ""
	                                  }) : _react2.default.createElement("img", { src: _avatar_circle2.default, alt: "" })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-6" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "view-text" },
	                                  _react2.default.createElement(
	                                    "h2",
	                                    null,
	                                    this.state.testimonial_name
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                      "b",
	                                      null,
	                                      this.state.author_name
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "start-icons" },
	                                    _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                    _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                    _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                    _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                    _react2.default.createElement("i", { className: "fa-solid fa-star" })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-sm-3" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "edit" },
	                                  _react2.default.createElement(
	                                    "a",
	                                    {
	                                      href: "/edittestimonial/" + this.state.testimonial_id
	                                    },
	                                    _react2.default.createElement("i", { className: "fa fa-pencil" })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement("hr", null),
	                            this.state.testimonial_desc ? _react2.default.createElement(
	                              "div",
	                              { className: "col-lg-6 col-md-12" },
	                              _react2.default.createElement(
	                                "h3",
	                                null,
	                                "Description"
	                              ),
	                              _react2.default.createElement("p", {
	                                dangerouslySetInnerHTML: {
	                                  __html: this.state.testimonial_desc
	                                }
	                              })
	                            ) : _react2.default.createElement("div", null)
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return testimonialView;
	}(_react.Component);
	
	exports.default = testimonialView;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _avatar_circle = __webpack_require__(49);
	
	var _avatar_circle2 = _interopRequireDefault(_avatar_circle);
	
	var _DeleteConfirmModalPopup = __webpack_require__(45);
	
	var _DeleteConfirmModalPopup2 = _interopRequireDefault(_DeleteConfirmModalPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getAllTestimonials = function getAllTestimonials(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/gettestimonials", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var getSearchTestimonials = function getSearchTestimonials(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/testimonials/adminsearchtestimonials", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var deletetestimonials = function deletetestimonials(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/testimonials/" + data.testimonial_id, {
	      method: "DELETE",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var Testimonials = function (_Component) {
	  _inherits(Testimonials, _Component);
	
	  function Testimonials() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Testimonials);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Testimonials.__proto__ || Object.getPrototypeOf(Testimonials)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      testimonials: [],
	      total: "",
	      currentPage: "",
	      LastPage: "",
	      PerPage: "",
	      FirstPageUrl: "",
	      NextPageUrl: "",
	      PrevPageUrl: "",
	      LastPageUrl: "",
	      TotalPages: "",
	      activePage: 1,
	      enableShdo: false,
	      enableShdoLive: false,
	      testimonial_id: "",
	      search_keywords: ""
	    }, _this.handleChange = function (events) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshTestimonials = function (page) {
	      _this.setState({ enableShdo: true });
	      var data = {
	        page: page
	      };
	      getAllTestimonials(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ testimonials: records });
	          _this.setState({ total: res.data.total });
	          _this.setState({ currentPage: res.data.current_page });
	          _this.setState({ PerPage: res.data.per_page });
	          _this.setState({ FirstPageUrl: res.data.first_page_url });
	          _this.setState({ NextPageUrl: res.data.next_page_url });
	          _this.setState({ PrevPageUrl: res.data.prev_page_url });
	          _this.setState({ LastPageUrl: res.data.last_page_url });
	          _this.setState({ LastPage: res.data.last_page });
	          _this.setState({
	            TotalPages: Math.ceil(_this.state.total / _this.state.PerPage)
	          });
	        } else {
	          _this.setState({ testimonials: "" });
	        }
	        _this.setState({ enableShdo: false });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.SearchTestimonials = function (e) {
	      var data = {
	        keywords: _this.state.search_keywords
	      };
	      getSearchTestimonials(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data.data;
	          _this.setState({ testimonials: records });
	          _this.setState({ total: res.data.total });
	          _this.setState({ currentPage: res.data.current_page });
	          _this.setState({ PerPage: res.data.per_page });
	          _this.setState({ FirstPageUrl: res.data.first_page_url });
	          _this.setState({ NextPageUrl: res.data.next_page_url });
	          _this.setState({ PrevPageUrl: res.data.prev_page_url });
	          _this.setState({ LastPageUrl: res.data.last_page_url });
	          _this.setState({ LastPage: res.data.last_page });
	          _this.setState({
	            TotalPages: Math.ceil(_this.state.total / _this.state.PerPage)
	          });
	        } else {
	          _this.setState({ testimonials: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Testimonials, [{
	    key: "handlePageChange",
	    value: function handlePageChange(pageNumber) {
	      this.setState({ activePage: pageNumber });
	      this.refreshTestimonials(pageNumber);
	    }
	  }, {
	    key: "modalDeleteConfirmOpen",
	    value: function modalDeleteConfirmOpen(e, id) {
	      this.setState({
	        modalDeleteConfirm: true,
	        testimonial_id: id
	      });
	    }
	  }, {
	    key: "modalDeleteConfirmClose",
	    value: function modalDeleteConfirmClose() {
	      this.setState({
	        modalDeleteConfirm: false
	      });
	    }
	  }, {
	    key: "modalDeleteTestimonials",
	    value: function modalDeleteTestimonials(id) {
	      var data = {
	        testimonial_id: id
	      };
	      deletetestimonials(data).then(function (res) {
	        if (res.status === true) {
	          _reactToastify.toast.success(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_RIGHT
	          });
	          setTimeout(function () {
	            window.location.href = "/admin/testimonials";
	          }, 3000);
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	        //window.location='/departments';
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshTestimonials();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var pageNumbers = [];
	      for (var i = 1; i <= this.state.TotalPages; i++) {
	        pageNumbers.push(i);
	      }
	      return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	          "div",
	          { id: "wrapper" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "content-page" },
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "row page-content-wrapper" },
	                _react2.default.createElement("div", { className: "col-sm-7" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-3 text-right" },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control",
	                    name: "search_keywords",
	                    id: "search_keywords",
	                    value: this.state.search_keywords,
	                    onChange: this.handleChange,
	                    onBlur: this.SearchTestimonials,
	                    placeholder: "Search"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-2 mb-4 text-right" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "/addtestimonial",
	                      className: "btn btn-sm btn-primary waves-effect waves-light"
	                    },
	                    "Add Testimonials"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card m-b-20" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "section",
	                        { className: "view-page" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "container" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "view-page-box" },
	                            _react2.default.createElement(
	                              "h1",
	                              { className: "text-center" },
	                              "Testimonial"
	                            ),
	                            _react2.default.createElement("br", null),
	                            this.state.testimonials.length > 0 ? this.state.testimonials.map(function (testimonial) {
	                              return _react2.default.createElement(
	                                "div",
	                                {
	                                  key: testimonial.id,
	                                  className: "row",
	                                  style: {
	                                    marginBottom: "20px",
	                                    paddingBottom: "20px",
	                                    borderBottom: "1px solid lightgray"
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "col-sm-1" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "view-img" },
	                                    testimonial.doctor_profile ? _react2.default.createElement("img", {
	                                      src: _constants.IMAGE_URL + "DoctorProfileImg/" + testimonial.doctor_profile,
	                                      alt: "avtars",
	                                      style: {
	                                        width: "50px",
	                                        height: "50px",
	                                        "border-radius": "30px"
	                                      }
	                                    }) : _react2.default.createElement("img", {
	                                      src: _avatar_circle2.default,
	                                      alt: "avtars",
	                                      width: "50px"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    testimonial.author_name
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "col-sm-11" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "view-text" },
	                                    _react2.default.createElement(
	                                      "h2",
	                                      { className: "d-inline" },
	                                      testimonial.doctor_mave ? testimonial.doctor_mave.doctor_name : null
	                                    ),
	                                    _react2.default.createElement(
	                                      "h5",
	                                      { className: "float-end" },
	                                      _react2.default.createElement(
	                                        "a",
	                                        {
	                                          href: "/edittestimonial/" + testimonial.id
	                                        },
	                                        _react2.default.createElement("i", { className: "fa fa-pencil-square mx-2 display-4" })
	                                      ),
	                                      _react2.default.createElement(
	                                        "a",
	                                        {
	                                          onClick: function onClick(e) {
	                                            return _this2.modalDeleteConfirmOpen(e, testimonial.id);
	                                          }
	                                        },
	                                        _react2.default.createElement("i", { className: "fa fa-trash" })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "p",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        testimonial.testimonial_title
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "article",
	                                      { className: "box" },
	                                      _react2.default.createElement("div", {
	                                        dangerouslySetInnerHTML: {
	                                          __html: testimonial.testimonial_desc
	                                        }
	                                      })
	                                    ),
	                                    _react2.default.createElement(
	                                      "div",
	                                      {
	                                        id: "star_print",
	                                        className: "start-icons"
	                                      },
	                                      _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                      _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                      _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                      _react2.default.createElement("i", { className: "fa-solid fa-star" }),
	                                      _react2.default.createElement("i", { className: "fa-solid fa-star" })
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _DeleteConfirmModalPopup2.default,
	                                  {
	                                    show: _this2.state.modalDeleteConfirm,
	                                    handleClose: function handleClose(e) {
	                                      return _this2.modalDeleteConfirmClose(e);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "custom_reviews_popup" },
	                                    _react2.default.createElement(
	                                      "h2",
	                                      { className: "text-center" },
	                                      "Are you sure you to delete this testimonials ?"
	                                    ),
	                                    _react2.default.createElement(
	                                      "form",
	                                      {
	                                        className: "pop-form",
	                                        id: "edit_education"
	                                      },
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "form-group row" },
	                                        _react2.default.createElement("div", { className: "col-sm-3 text-center" }),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "col-sm-6 text-center" },
	                                          _react2.default.createElement(
	                                            "button",
	                                            {
	                                              type: "button",
	                                              className: "blue_btn_box add_staff_btn mt-5 mr-2",
	                                              onClick: function onClick(e) {
	                                                return _this2.modalDeleteConfirmClose(e);
	                                              }
	                                            },
	                                            " ",
	                                            "No"
	                                          ),
	                                          _react2.default.createElement(
	                                            "button",
	                                            {
	                                              type: "button",
	                                              className: "blue_btn_box add_staff_btn mt-5",
	                                              onClick: function onClick() {
	                                                return _this2.modalDeleteTestimonials(_this2.state.testimonial_id);
	                                              }
	                                            },
	                                            "Yes"
	                                          )
	                                        ),
	                                        _react2.default.createElement("div", { className: "col-sm-3 text-center" })
	                                      )
	                                    )
	                                  )
	                                )
	                              );
	                            }) : _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              "No Records found"
	                            )
	                          ),
	                          pageNumbers.length > 1 ? _react2.default.createElement(_reactJsPagination2.default, {
	                            activePage: this.state.activePage,
	                            totalItemsCount: this.state.total,
	                            pageRangeDisplayed: 5,
	                            onChange: this.handlePageChange.bind(this)
	                          }) : ""
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return Testimonials;
	}(_react.Component);
	
	exports.default = Testimonials;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _reactToastify = __webpack_require__(7);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var uploading = function uploading() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchdata_1 = _useState2[0],
	      setFatchdata_1 = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      fatchdata_2 = _useState4[0],
	      setFatchdata_2 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({
	    // type:"news_feature_video",
	    upload_file: null,
	    value: null,
	    // file_path:"",
	    // forign_table:"",
	    // forign_id:"",
	    status: 1
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      formData = _useState6[0],
	      setFormData = _useState6[1];
	
	  if (formData.upload_file) {
	    console.log(formData.upload_file.name);
	  }
	
	  var handleFileChange = function handleFileChange(e) {
	    var file = e.target.files[0];
	
	    // Check if a file was selected
	    if (file) {
	      // Update the formData state by setting the author_profile_pic to the selected file
	      setFormData(Object.assign({}, formData, {
	        upload_file: file
	      }));
	    }
	  };
	  var handleSubmit = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e, $id) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              e.preventDefault();
	              console.log(formData, "hello");
	              if ($id == 2) {
	                setFormData(Object.assign({}, formData, { upload_file: null }));
	              }
	              _context.prev = 3;
	              _context.next = 6;
	              return _.thirdparty.post("/settings_update/" + $id, formData, {
	                headers: {
	                  "Content-Type": "multipart/form-data"
	                }
	              });
	
	            case 6:
	              response = _context.sent;
	
	              if (response.status === 200) {
	                _reactToastify.toast.success("Video Uploading JCI successfully!", {
	                  position: _reactToastify.toast.POSITION.TOP_RIGHT,
	                  autoClose: 3000
	                });
	                fetchData($id);
	              }
	
	              _context.next = 13;
	              break;
	
	            case 10:
	              _context.prev = 10;
	              _context.t0 = _context["catch"](3);
	
	              console.error("Error submitting form:", _context.t0);
	
	            case 13:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[3, 10]]);
	    }));
	
	    return function handleSubmit(_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    fetchData(1); // Initial data fetch
	    fetchData(2); // Initial data fetch
	  }, []);
	  var fetchData = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2($id) {
	      var response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return _.thirdparty.get("/settings/" + $id);
	
	            case 3:
	              response = _context2.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                if ($id == 1) {
	                  setFatchdata_1(response.data);
	                }
	
	                if ($id == 2) {
	                  setFatchdata_2(response.data);
	                  setFormData(Object.assign({}, formData, { value: response.data.value }));
	                }
	              }
	              _context2.next = 10;
	              break;
	
	            case 7:
	              _context2.prev = 7;
	              _context2.t0 = _context2["catch"](0);
	
	              console.error("Error fetching data:", _context2.t0.message);
	
	            case 10:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData(_x3) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    { className: "fixed-left" },
	    _react2.default.createElement(
	      "div",
	      { id: "wrapper" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "content-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "content" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container-fluid" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          id: "adddepartmentform",
	                          className: "needs-validation",
	                          noValidate: true,
	                          onSubmit: function onSubmit(e) {
	                            return handleSubmit(e, 2);
	                          }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-group" },
	                              _react2.default.createElement(
	                                "label",
	                                null,
	                                "Youtube Embedded Code"
	                              ),
	                              _react2.default.createElement("textarea", { className: "form-control", name: "youtube_video", id: "youtube_video", cols: "10", rows: "5", onChange: function onChange(e) {
	                                  return setFormData(Object.assign({}, formData, { value: e.target.value }));
	                                }, value: formData.value })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group text-right" },
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              type: "submit",
	                              className: "btn btn-primary waves-effect waves-light"
	                            },
	                            "Submit"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: fatchdata_2.value } })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = uploading;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactToastify = __webpack_require__(7);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _2 = __webpack_require__(2);
	
	var _TableComponent = __webpack_require__(199);
	
	var _TableComponent2 = _interopRequireDefault(_TableComponent);
	
	var _utils = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var UserLog = function UserLog() {
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        fatchData = _useState2[0],
	        setFatchdata = _useState2[1];
	
	    var fetchData = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var response;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _2.thirdparty.get("/user_log");
	
	                        case 3:
	                            response = _context.sent;
	
	                            if (response.status === 200) {
	                                setFatchdata(response.data);
	                            }
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error("Error fetching data:", _context.t0.message);
	
	                        case 10:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function fetchData() {
	            return _ref.apply(this, arguments);
	        };
	    }();
	
	    (0, _react.useEffect)(function () {
	        fetchData();
	    }, []);
	
	    var columns = [{ header: "#", accessor: function accessor(_, index) {
	            return index + 1;
	        } }, { header: "Date-Time", accessor: function accessor(item) {
	            return (0, _utils.formatDate)(item.created_at);
	        } }, { header: "Type", accessor: "type" }, { header: "IP Add.", accessor: "ip_address" }, {
	        header: "Role",
	        accessor: function accessor(item) {
	            return item.user_mave && item.user_mave.roles ? item.user_mave.roles.role_name : "-";
	        }
	    }, {
	        header: "Name",
	        accessor: function accessor(item) {
	            return item.user_mave ? item.user_mave.fullname : "-";
	        }
	    }, {
	        header: "System",
	        accessor: function accessor(item) {
	            return item.browser + ", " + item.os + ", " + item.device;
	        }
	    }, { header: "URL", accessor: "url" }];
	
	    return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(_Seo2.default, {
	            title: "User Log ",
	            description: "User Log - United Hospital",
	            pathSlug: "/admin/user-log",
	            keywords: "User Log"
	        }),
	        _react2.default.createElement(
	            "div",
	            { id: "wrapper" },
	            _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	            _react2.default.createElement(
	                "div",
	                { className: "content-page" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "content" },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "page-content-wrapper " },
	                        _react2.default.createElement(_TableComponent2.default, { title: "User Log", data: fatchData, columns: columns })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	    );
	};
	
	exports.default = UserLog;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _reactToastify = __webpack_require__(7);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _TopHeader = __webpack_require__(10);
	
	var _TopHeader2 = _interopRequireDefault(_TopHeader);
	
	var _ = __webpack_require__(2);
	
	var _utils = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Videogallery = function Videogallery() {
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        fatchdata = _useState2[0],
	        setFatchdata = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(1),
	        _useState4 = _slicedToArray(_useState3, 2),
	        currentPage = _useState4[0],
	        setCurrentPage = _useState4[1];
	
	    var itemsPerPage = 10; // Number of items to display per page
	
	    var _useState5 = (0, _react.useState)(""),
	        _useState6 = _slicedToArray(_useState5, 2),
	        filteredData = _useState6[0],
	        setfilteredData = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(""),
	        _useState8 = _slicedToArray(_useState7, 2),
	        searchTerm = _useState8[0],
	        setSearchTerm = _useState8[1];
	
	    var fetchData = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var response;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _.thirdparty.get("/videogallery/get");
	
	                        case 3:
	                            response = _context.sent;
	
	
	                            console.log("respoinse", response);
	
	                            if (response.status === 200) {
	                                setFatchdata(response.data.data);
	                            }
	                            _context.next = 11;
	                            break;
	
	                        case 8:
	                            _context.prev = 8;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error("Error fetching data:", _context.t0.message);
	
	                        case 11:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 8]]);
	        }));
	
	        return function fetchData() {
	            return _ref.apply(this, arguments);
	        };
	    }();
	
	    var handleDelete = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(id) {
	            var confirmation, response;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            confirmation = confirm("Are you sure to delete this item?");
	
	                            if (confirmation) {
	                                _context2.next = 4;
	                                break;
	                            }
	
	                            return _context2.abrupt("return");
	
	                        case 4:
	                            _context2.next = 6;
	                            return _.thirdparty.delete("/videogallery/delete/" + id);
	
	                        case 6:
	                            response = _context2.sent;
	                            // Update the API endpoint
	                            if (response.status === 200) {
	                                _reactToastify.toast.success("Deleted Successfully!", {
	                                    position: _reactToastify.toast.POSITION.TOP_RIGHT
	                                });
	                                console.log("Item with ID " + id + " deleted successfully.");
	                                fetchData(); // Fetch updated data after deletion
	                            }
	                            _context2.next = 13;
	                            break;
	
	                        case 10:
	                            _context2.prev = 10;
	                            _context2.t0 = _context2["catch"](0);
	
	                            console.error("Error deleting item with ID " + id + ":", _context2.t0.message);
	
	                        case 13:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 10]]);
	        }));
	
	        return function handleDelete(_x) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    // Handle page change
	    var handlePageChange = function handlePageChange(pageNumber) {
	        setCurrentPage(pageNumber);
	    };
	
	    // Initial data fetch
	    (0, _react.useEffect)(function () {
	        fetchData();
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        var filteredData = fatchdata && fatchdata.filter(function (item) {
	            return Object.values(item).some(function (value) {
	                return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
	            });
	        });
	
	        setfilteredData(filteredData);
	    }, [fatchdata, searchTerm]);
	
	    var indexOfLastItem = currentPage * itemsPerPage;
	    var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	    var currentItems = filteredData ? filteredData.slice(indexOfFirstItem, indexOfLastItem) : [];
	
	    var handleSearch = function handleSearch(event) {
	        setSearchTerm(event.target.value);
	        setCurrentPage(1);
	    };
	
	    return _react2.default.createElement(
	        "div",
	        { className: "fixed-left" },
	        _react2.default.createElement(
	            "div",
	            { id: "wrapper" },
	            _react2.default.createElement(_reactRouterDom.Route, { component: _LeftSidebar2.default }),
	            _react2.default.createElement(
	                "div",
	                { className: "content-page" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "content" },
	                    _react2.default.createElement(_reactRouterDom.Route, { component: _TopHeader2.default }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "row page-content-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "card p-0" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "card-header row" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "col-md-8" },
	                                    _react2.default.createElement(
	                                        "h5",
	                                        { className: "card-title text-left" },
	                                        "Video Gallery"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "col-md-4 text-right" },
	                                    _react2.default.createElement("input", {
	                                        className: "form-control",
	                                        type: "search",
	                                        placeholder: "Search",
	                                        "aria-label": "Search",
	                                        value: searchTerm,
	                                        onChange: handleSearch,
	                                        style: {
	                                            background: "transparent",
	                                            border: "none"
	                                        }
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "card-body" },
	                                _react2.default.createElement(
	                                    "table",
	                                    { className: "table table-striped table-hover" },
	                                    _react2.default.createElement(
	                                        "thead",
	                                        null,
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "#"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Name"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Description"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Time"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { scope: "col" },
	                                                "Action"
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tbody",
	                                        null,
	                                        currentItems.length > 0 ? currentItems.map(function (item) {
	                                            return _react2.default.createElement(
	                                                "tr",
	                                                { key: item.id },
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    null,
	                                                    item.id
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.video_gallery_name
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    item.video_gallery_desc
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    (0, _utils.formatDate)(item.created_at)
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "a",
	                                                        { href: "/editVideoGallery/" + item.id },
	                                                        _react2.default.createElement("i", { className: "fa fa-pencil-square display-4" })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "a",
	                                                        { href: "/editVideoGallery/" + item.id },
	                                                        _react2.default.createElement("i", { className: "fa fa-eye mx-2 display-4" })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "a",
	                                                        { onClick: function onClick() {
	                                                                return handleDelete(item.id);
	                                                            } },
	                                                        _react2.default.createElement("i", { className: "fa fa-trash display-4", "data-bs-toggle": "tooltip", "data-bs-placement": "top", title: "Delete Request" })
	                                                    )
	                                                )
	                                            );
	                                        }) : _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                { colSpan: "100%", className: "text-center" },
	                                                "No data found"
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(_reactJsPagination2.default, {
	                                    activePage: currentPage,
	                                    itemsCountPerPage: itemsPerPage,
	                                    totalItemsCount: filteredData ? filteredData.length : 1,
	                                    pageRangeDisplayed: 5,
	                                    onChange: handlePageChange
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	    );
	};
	
	exports.default = Videogallery;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _PrivateRoute = __webpack_require__(81);
	
	var _userSession = __webpack_require__(30);
	
	var _logo = __webpack_require__(135);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var loginUser = function loginUser(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request(_constants.LOGIN_PAGE_PATH, {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var activateaccount = function activateaccount(url) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request(url, {
	      method: "post"
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var AdminLogin = function (_Component) {
	  _inherits(AdminLogin, _Component);
	
	  function AdminLogin(props) {
	    _classCallCheck(this, AdminLogin);
	
	    var _this = _possibleConstructorReturn(this, (AdminLogin.__proto__ || Object.getPrototypeOf(AdminLogin)).call(this, props));
	
	    _this.state = {
	      user_email: "",
	      user_password: "",
	      remember_me: false,
	      enableLoginBtn: false,
	      signin_success: false,
	      user_active: false,
	      fields: {},
	      errors: {}
	    };
	
	    _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	    };
	
	    _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm()) {
	        var fields = {};
	        fields["user_email"] = "";
	        fields["user_password"] = "";
	        _this.setState({ fields: fields });
	        var user = {
	          email: _this.state.fields.user_email,
	          password: _this.state.fields.user_password
	        };
	        loginUser(user).then(function (res) {
	          var phone_number = "";
	          var search_selected_doc_id = "";
	          var schedule_date = "";
	          var apointment_id = "";
	          var doctor_name = "";
	          var doctor_fees = "";
	          var patientName = res.data.username;
	          var schedule_time = "";
	          var search_selected_doc_name = "";
	          var doctor_profile_avability = _this.props.doctorProfilePageClick;
	          if (!!res.token) {
	            (0, _userSession.startUserSession)(res.token, res.data.role, res.data.email, res.data.id, phone_number, search_selected_doc_id, schedule_date, apointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name, doctor_profile_avability, res.data.id);
	
	            var login_data = {
	              type: "Login-Admin",
	              user_id: res.data.id,
	              url: window.location.pathname
	            };
	
	            var user_log = _.thirdparty.post("/user_log", login_data);
	
	            _this.setState({
	              signin_success: true,
	              user_active: res.data.status === false ? false : true
	            });
	            _this.props.actions.userLoginSuccess(res.data);
	          } else {
	            _reactToastify.toast.error(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          }
	        }).catch(function (err) {
	          //     toast.error('Error occured', {
	          //         position: toast.POSITION.BOTTOM_RIGHT
	          //     });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide email and password !", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    };
	
	    var token = localStorage.getItem(_constants.API_TOKEN_NAME);
	
	    if (token) {
	      window.location.href = "/admindashboard";
	    }
	    return _this;
	  }
	
	  _createClass(AdminLogin, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	
	      if (!fields["user_email"]) {
	        formIsValid = false;
	        errors["user_email"] = "*Please enter your email.";
	      }
	
	      if (!fields["user_password"]) {
	        formIsValid = false;
	        errors["user_password"] = "*Please enter password";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var urlParams = new URLSearchParams(this.props.location.search);
	      var active_code = urlParams.get("active_code");
	      var CHK_USER_ID = localStorage.getItem(_constants.USER_ID);
	      if (active_code) {
	        var url = "/account/activation/" + active_code;
	        activateaccount(url, active_code).then(function (res) {
	          if (res.status === true) {
	            _reactToastify.toast.success(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	            if (CHK_USER_ID === null) {
	              window.location.href = "/adminlogin";
	            } else {
	              _this2.setState({
	                signin_success: true
	              });
	            }
	          } else {
	            _reactToastify.toast.error(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          }
	        }).catch(function (err) {
	          console.log(err);
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _ref = this.props.location.state || {
	        from: { pathname: "/admindashboard" }
	      },
	          from = _ref.from;
	
	      if ((0, _PrivateRoute.validateUserToken)()) {
	        if (!this.state.signin_success) return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/adminlogin" });
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: from });
	      }
	      return _react2.default.createElement(
	        "div",
	        { className: "account-bg" },
	        _react2.default.createElement(
	          "div",
	          { className: "account-pages my-5 pt-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row justify-content-center" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-8 col-lg-6 col-xl-5" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card-body" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "text-center mt-4" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "mb-3" },
	                        _react2.default.createElement(
	                          "a",
	                          { href: "index.html" },
	                          _react2.default.createElement("img", { src: _logo2.default, height: 80, alt: "logo" })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "p-3" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "font-size-18 text-muted mt-2 text-center" },
	                        "Welcome Back !"
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "text-muted text-center mb-4" },
	                        "Sign in to continue to United Hospital Admin."
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        {
	                          className: "form-horizontal",
	                          onSubmit: this.handleSubmit,
	                          id: "adminloginform",
	                          noValidate: true
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            { htmlFor: "user_email" },
	                            "Email"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            name: "user_email",
	                            id: "user_email",
	                            value: this.state.fields.user_email,
	                            onChange: this.handleChange,
	                            placeholder: "Enter email",
	                            required: "",
	                            autoComplete: "off"
	                          }),
	                          _react2.default.createElement(
	                            "span",
	                            { style: alertStyle },
	                            this.state.errors.user_email
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            { htmlFor: "user_password" },
	                            "Password"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "password",
	                            className: "form-control",
	                            name: "user_password",
	                            id: "user_password",
	                            value: this.state.fields.user_password,
	                            onChange: this.handleChange,
	                            placeholder: "Enter password",
	                            required: "",
	                            autoComplete: "off"
	                          }),
	                          _react2.default.createElement(
	                            "span",
	                            { style: alertStyle },
	                            this.state.errors.user_password
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group row mt-4" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-12 text-right" },
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                className: "btn btn-primary w-md waves-effect waves-light",
	                                type: "submit"
	                              },
	                              "Log In"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group mb-0 row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-12 mt-4" },
	                            _react2.default.createElement(
	                              _reactRouterDom.Link,
	                              {
	                                to: "/admin/change-password",
	                                className: "text-muted"
	                              },
	                              _react2.default.createElement("i", { className: "mdi mdi-lock" }),
	                              " Forgot your password?"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mt-5 text-center" },
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "\xA9 2024 United Hospital"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return AdminLogin;
	}(_react.Component);
	
	exports.default = AdminLogin;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(90);
	
	var _redux = __webpack_require__(79);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _userActions = __webpack_require__(95);
	
	var userActions = _interopRequireWildcard(_userActions);
	
	var _constants = __webpack_require__(3);
	
	var _userSession = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminLogout = function (_Component) {
	    _inherits(AdminLogout, _Component);
	
	    function AdminLogout() {
	        _classCallCheck(this, AdminLogout);
	
	        return _possibleConstructorReturn(this, (AdminLogout.__proto__ || Object.getPrototypeOf(AdminLogout)).apply(this, arguments));
	    }
	
	    _createClass(AdminLogout, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.actions.userLogoutSuccess();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            (0, _userSession.endUserSession)();
	            return _react2.default.createElement(_reactRouterDom.Redirect, { to: _constants.ADMIN_LOGIN_PAGE_PATH });
	        }
	    }]);
	
	    return AdminLogout;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        user: state.user
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(userActions, dispatch)
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AdminLogout);

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo = __webpack_require__(135);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {API_TOKEN_NAME} from '../constants';
	//import {Route} from 'react-router-dom';
	//import { scAxios } from '../';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	
	
	var AdminLogin = function (_Component) {
	  _inherits(AdminLogin, _Component);
	
	  function AdminLogin() {
	    _classCallCheck(this, AdminLogin);
	
	    return _possibleConstructorReturn(this, (AdminLogin.__proto__ || Object.getPrototypeOf(AdminLogin)).apply(this, arguments));
	  }
	
	  _createClass(AdminLogin, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "account-bg" },
	        _react2.default.createElement(
	          "div",
	          { className: "account-pages my-5 pt-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row justify-content-center" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-8 col-lg-6 col-xl-5" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card-body" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "text-center mt-4" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "mb-3" },
	                        _react2.default.createElement(
	                          "a",
	                          { href: "index.html" },
	                          _react2.default.createElement("img", { src: _logo2.default, height: 80, alt: "logo" })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "p-3" },
	                      _react2.default.createElement(
	                        "h4",
	                        { className: "font-size-18 text-muted mt-2 mb-4 text-center" },
	                        "Register"
	                      ),
	                      _react2.default.createElement(
	                        "form",
	                        { className: "form-horizontal", action: "index.html" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            { "for": "useremail" },
	                            "Email"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "email",
	                            className: "form-control",
	                            id: "useremail",
	                            placeholder: "Enter email"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            { "for": "username" },
	                            "Username"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            id: "username",
	                            placeholder: "Enter username"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group" },
	                          _react2.default.createElement(
	                            "label",
	                            { "for": "userpassword" },
	                            "Password"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "password",
	                            className: "form-control",
	                            id: "userpassword",
	                            placeholder: "Enter password"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group row mt-4" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-12 text-right" },
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                className: "btn btn-primary w-md waves-effect waves-light",
	                                type: "submit"
	                              },
	                              "Register"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mt-5 text-center" },
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Already have an account ?",
	                    " ",
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "/adminlogin",
	                        className: "font-weight-bold text-primary"
	                      },
	                      " ",
	                      "Login",
	                      " "
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "\xA9 2024 United Hospital."
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminLogin;
	}(_react.Component);
	
	exports.default = AdminLogin;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(79);
	
	var _reactRedux = __webpack_require__(90);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _userActions = __webpack_require__(95);
	
	var userActions = _interopRequireWildcard(_userActions);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _PrivateRoute = __webpack_require__(81);
	
	var _PrivateRoute2 = _interopRequireDefault(_PrivateRoute);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _appointments = __webpack_require__(202);
	
	var _appointments2 = _interopRequireDefault(_appointments);
	
	var _admindashboard = __webpack_require__(534);
	
	var _admindashboard2 = _interopRequireDefault(_admindashboard);
	
	var _newsevents = __webpack_require__(563);
	
	var _newsevents2 = _interopRequireDefault(_newsevents);
	
	var _doctors = __webpack_require__(542);
	
	var _doctors2 = _interopRequireDefault(_doctors);
	
	var _adddoctor = __webpack_require__(525);
	
	var _adddoctor2 = _interopRequireDefault(_adddoctor);
	
	var _editdoctor = __webpack_require__(547);
	
	var _editdoctor2 = _interopRequireDefault(_editdoctor);
	
	var _departments = __webpack_require__(540);
	
	var _departments2 = _interopRequireDefault(_departments);
	
	var _adddepartment = __webpack_require__(524);
	
	var _adddepartment2 = _interopRequireDefault(_adddepartment);
	
	var _editdepartment = __webpack_require__(546);
	
	var _editdepartment2 = _interopRequireDefault(_editdepartment);
	
	var _testimonials = __webpack_require__(572);
	
	var _testimonials2 = _interopRequireDefault(_testimonials);
	
	var _edittestimonial = __webpack_require__(554);
	
	var _edittestimonial2 = _interopRequireDefault(_edittestimonial);
	
	var _addtestimonial = __webpack_require__(532);
	
	var _addtestimonial2 = _interopRequireDefault(_addtestimonial);
	
	var _editnewsevent = __webpack_require__(550);
	
	var _editnewsevent2 = _interopRequireDefault(_editnewsevent);
	
	var _addnewsevent = __webpack_require__(528);
	
	var _addnewsevent2 = _interopRequireDefault(_addnewsevent);
	
	var _publications = __webpack_require__(567);
	
	var _publications2 = _interopRequireDefault(_publications);
	
	var _addpublication = __webpack_require__(530);
	
	var _addpublication2 = _interopRequireDefault(_addpublication);
	
	var _editpublication = __webpack_require__(553);
	
	var _editpublication2 = _interopRequireDefault(_editpublication);
	
	var _doctorView = __webpack_require__(541);
	
	var _doctorView2 = _interopRequireDefault(_doctorView);
	
	var _departmentView = __webpack_require__(539);
	
	var _departmentView2 = _interopRequireDefault(_departmentView);
	
	var _testimonialView = __webpack_require__(571);
	
	var _testimonialView2 = _interopRequireDefault(_testimonialView);
	
	var _newsEventsView = __webpack_require__(562);
	
	var _newsEventsView2 = _interopRequireDefault(_newsEventsView);
	
	var _publicationView = __webpack_require__(566);
	
	var _publicationView2 = _interopRequireDefault(_publicationView);
	
	var _packages = __webpack_require__(564);
	
	var _packages2 = _interopRequireDefault(_packages);
	
	var _addpackage = __webpack_require__(529);
	
	var _addpackage2 = _interopRequireDefault(_addpackage);
	
	var _editpackage = __webpack_require__(551);
	
	var _editpackage2 = _interopRequireDefault(_editpackage);
	
	var _PackageView = __webpack_require__(515);
	
	var _PackageView2 = _interopRequireDefault(_PackageView);
	
	var _staticpages = __webpack_require__(570);
	
	var _staticpages2 = _interopRequireDefault(_staticpages);
	
	var _addstaticpage = __webpack_require__(531);
	
	var _addstaticpage2 = _interopRequireDefault(_addstaticpage);
	
	var _editpage = __webpack_require__(552);
	
	var _editpage2 = _interopRequireDefault(_editpage);
	
	var _page = __webpack_require__(565);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _menu = __webpack_require__(561);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _addmenu = __webpack_require__(527);
	
	var _addmenu2 = _interopRequireDefault(_addmenu);
	
	var _editmenu = __webpack_require__(549);
	
	var _editmenu2 = _interopRequireDefault(_editmenu);
	
	var _bannerbuttonlink = __webpack_require__(536);
	
	var _bannerbuttonlink2 = _interopRequireDefault(_bannerbuttonlink);
	
	var _addbannerbuttonlink = __webpack_require__(521);
	
	var _addbannerbuttonlink2 = _interopRequireDefault(_addbannerbuttonlink);
	
	var _editbannerbuttonlink = __webpack_require__(544);
	
	var _editbannerbuttonlink2 = _interopRequireDefault(_editbannerbuttonlink);
	
	var _addVideoGallery = __webpack_require__(520);
	
	var _addVideoGallery2 = _interopRequireDefault(_addVideoGallery);
	
	var _addbodylink = __webpack_require__(523);
	
	var _addbodylink2 = _interopRequireDefault(_addbodylink);
	
	var _BodyLinkDept = __webpack_require__(198);
	
	var _BodyLinkDept2 = _interopRequireDefault(_BodyLinkDept);
	
	var _EditBodyLink = __webpack_require__(508);
	
	var _EditBodyLink2 = _interopRequireDefault(_EditBodyLink);
	
	var _headerannoucement = __webpack_require__(556);
	
	var _headerannoucement2 = _interopRequireDefault(_headerannoucement);
	
	var _addheaderannoucement = __webpack_require__(526);
	
	var _addheaderannoucement2 = _interopRequireDefault(_addheaderannoucement);
	
	var _editheaderannoucement = __webpack_require__(548);
	
	var _editheaderannoucement2 = _interopRequireDefault(_editheaderannoucement);
	
	var _addAlbum = __webpack_require__(519);
	
	var _addAlbum2 = _interopRequireDefault(_addAlbum);
	
	var _editAlbum = __webpack_require__(201);
	
	var _editAlbum2 = _interopRequireDefault(_editAlbum);
	
	var _editVideoGallery = __webpack_require__(543);
	
	var _editVideoGallery2 = _interopRequireDefault(_editVideoGallery);
	
	var _albums = __webpack_require__(535);
	
	var _albums2 = _interopRequireDefault(_albums);
	
	var _videogallery = __webpack_require__(575);
	
	var _videogallery2 = _interopRequireDefault(_videogallery);
	
	var _adminRolePermission = __webpack_require__(533);
	
	var _adminRolePermission2 = _interopRequireDefault(_adminRolePermission);
	
	var _board = __webpack_require__(537);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _addboardmember = __webpack_require__(522);
	
	var _addboardmember2 = _interopRequireDefault(_addboardmember);
	
	var _editboardmember = __webpack_require__(545);
	
	var _editboardmember2 = _interopRequireDefault(_editboardmember);
	
	var _bookingrequest = __webpack_require__(538);
	
	var _bookingrequest2 = _interopRequireDefault(_bookingrequest);
	
	var _uploading = __webpack_require__(573);
	
	var _uploading2 = _interopRequireDefault(_uploading);
	
	var _Settings = __webpack_require__(516);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _CaseStudies_list = __webpack_require__(505);
	
	var _CaseStudies_list2 = _interopRequireDefault(_CaseStudies_list);
	
	var _CaseStudies_create = __webpack_require__(504);
	
	var _CaseStudies_create2 = _interopRequireDefault(_CaseStudies_create);
	
	var _CaseStudies_update = __webpack_require__(506);
	
	var _CaseStudies_update2 = _interopRequireDefault(_CaseStudies_update);
	
	var _setSSLConfig = __webpack_require__(569);
	
	var _setSSLConfig2 = _interopRequireDefault(_setSSLConfig);
	
	var _roleManager = __webpack_require__(568);
	
	var _roleManager2 = _interopRequireDefault(_roleManager);
	
	var _user_log = __webpack_require__(574);
	
	var _user_log2 = _interopRequireDefault(_user_log);
	
	var _error = __webpack_require__(555);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _JobCircular_list = __webpack_require__(559);
	
	var _JobCircular_list2 = _interopRequireDefault(_JobCircular_list);
	
	var _JobCircular_create = __webpack_require__(558);
	
	var _JobCircular_create2 = _interopRequireDefault(_JobCircular_create);
	
	var _JobCircular_update = __webpack_require__(560);
	
	var _JobCircular_update2 = _interopRequireDefault(_JobCircular_update);
	
	var _Banner_list = __webpack_require__(502);
	
	var _Banner_list2 = _interopRequireDefault(_Banner_list);
	
	var _Banner_create = __webpack_require__(501);
	
	var _Banner_create2 = _interopRequireDefault(_Banner_create);
	
	var _Banner_update = __webpack_require__(503);
	
	var _Banner_update2 = _interopRequireDefault(_Banner_update);
	
	var _EmergencyInquiryMessages = __webpack_require__(511);
	
	var _EmergencyInquiryMessages2 = _interopRequireDefault(_EmergencyInquiryMessages);
	
	var _UserChangePassword = __webpack_require__(200);
	
	var _UserChangePassword2 = _interopRequireDefault(_UserChangePassword);
	
	var _Investigations = __webpack_require__(513);
	
	var _Investigations2 = _interopRequireDefault(_Investigations);
	
	var _EditInvestigation = __webpack_require__(509);
	
	var _EditInvestigation2 = _interopRequireDefault(_EditInvestigation);
	
	var _AddInvestigation = __webpack_require__(499);
	
	var _AddInvestigation2 = _interopRequireDefault(_AddInvestigation);
	
	var _MediaUpload = __webpack_require__(514);
	
	var _MediaUpload2 = _interopRequireDefault(_MediaUpload);
	
	var _HomePopup = __webpack_require__(512);
	
	var _HomePopup2 = _interopRequireDefault(_HomePopup);
	
	var _Configuration = __webpack_require__(507);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _EmailConfiguration = __webpack_require__(510);
	
	var _EmailConfiguration2 = _interopRequireDefault(_EmailConfiguration);
	
	var _AddMegaStaticPage = __webpack_require__(500);
	
	var _AddMegaStaticPage2 = _interopRequireDefault(_AddMegaStaticPage);
	
	var _UpdateMegaStaticPage = __webpack_require__(518);
	
	var _UpdateMegaStaticPage2 = _interopRequireDefault(_UpdateMegaStaticPage);
	
	var _homesamplecollection = __webpack_require__(557);
	
	var _homesamplecollection2 = _interopRequireDefault(_homesamplecollection);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import addnewsevents from './admin/addnewsevents';
	
	//import ViewBodyLink from './admin/ViewBodyLink';
	
	
	var getUserDeatils = function getUserDeatils() {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/user/detail/1", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var Dashboard = function (_React$Component) {
	  _inherits(Dashboard, _React$Component);
	
	  function Dashboard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Dashboard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      //isprofilecomplete: '',
	      user_role: ""
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Dashboard, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      getUserDeatils().then(function (res) {
	        if (res.status === true) {
	          var userdata = res.data;
	          _this2.setState({
	            //isprofilecomplete: userdata.isprofilecomplete,
	            user_role: userdata.role
	          });
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var user_role = this.state.user_role;
	      var userlink = void 0;
	      //let isprofilecomplete = this.state.isprofilecomplete;
	      if (user_role === "1") {
	        userlink = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_reactRouterDom.Route, null),
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/editalbum/:id",
	              component: _editAlbum2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/headerannoucement",
	              component: _headerannoucement2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/editheaderannoucement/:id",
	              component: _editheaderannoucement2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/addheaderannoucement",
	              component: _addheaderannoucement2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/editbannerbuttonlink/:id",
	              component: _editbannerbuttonlink2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/addbannerbuttonlink",
	              component: _addbannerbuttonlink2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/bannerbuttonlink",
	              component: _bannerbuttonlink2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/staticpages",
	              component: _staticpages2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/addstaticpage",
	              component: _AddMegaStaticPage2.default
	              // component={addstaticpage}
	              , user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/editpage/:id",
	              component: _editpage2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/editpage/:id",
	              component: _UpdateMegaStaticPage2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/page/:id",
	              component: _page2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/menu",
	              component: _menu2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/addmenu",
	              component: _addmenu2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/editmenu/:id",
	              component: _editmenu2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/packages",
	              component: _packages2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/edit-investigation/:id",
	              component: _EditInvestigation2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/investigations",
	              component: _Investigations2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/add-investigations",
	              component: _AddInvestigation2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/addpackage",
	              component: _addpackage2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/editpackage/:id",
	              component: _editpackage2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/viewpackage/:id",
	              component: _PackageView2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/body-links",
	              component: _BodyLinkDept2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/addbodylink",
	              component: _addbodylink2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/editbodylink/:id",
	              component: _EditBodyLink2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/viewdoctor/:id",
	              component: _doctorView2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/viewdepartment/:id",
	              component: _departmentView2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/viewtestimonial/:id",
	              component: _testimonialView2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/viewnewsevent/:id",
	              component: _newsEventsView2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/viewpublication/:id",
	              component: _publicationView2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/edittestimonial/:id",
	              component: _edittestimonial2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/editvideogallery/:id",
	              component: _editVideoGallery2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/addvideogallery",
	              component: _addVideoGallery2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/addtestimonial",
	              component: _addtestimonial2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/testimonials",
	              component: _testimonials2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/addpublication",
	              component: _addpublication2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/editpublication/:id",
	              component: _editpublication2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/publications",
	              component: _publications2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/upload-media",
	              component: _MediaUpload2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/home-popup",
	              component: _HomePopup2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/appointment/request",
	              component: _bookingrequest2.default,
	              user: this.props.user,
	              type: "request_appointment",
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/appointment/booking",
	              component: _bookingrequest2.default,
	              user: this.props.user,
	              type: "book_appointment",
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/uploading",
	              component: _uploading2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/editdepartment/:id",
	              component: _editdepartment2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/adddepartment",
	              component: _adddepartment2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/addboardmember",
	              component: _addboardmember2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/editboardmember/:id",
	              component: _editboardmember2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/departments",
	              component: _departments2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/editdoctor/:id",
	              component: _editdoctor2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/addalbum",
	              component: _addAlbum2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/adddoctor",
	              component: _adddoctor2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/doctors",
	              component: _doctors2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/boardmembers",
	              component: _board2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/editnewsevent/:id",
	              component: _editnewsevent2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/addnewsevent",
	              component: _addnewsevent2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/newsevents",
	              component: _newsevents2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admindashboard",
	              component: _admindashboard2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/role-permission/:id",
	              component: _adminRolePermission2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/albums",
	              component: _albums2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/videogallery",
	              component: _videogallery2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/email-configuration",
	              component: _EmailConfiguration2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/configuration",
	              component: _Configuration2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/settings",
	              component: _Settings2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/case_studies",
	              component: _CaseStudies_list2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/case_studies_create",
	              component: _CaseStudies_create2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/case_studies_update/:id",
	              component: _CaseStudies_update2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/job/list",
	              component: _JobCircular_list2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/job/create",
	              component: _JobCircular_create2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/job/update/:id",
	              component: _JobCircular_update2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/banner/list",
	              component: _Banner_list2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/banner/create",
	              component: _Banner_create2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/banner/update/:id",
	              component: _Banner_update2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/set_ssl_commerz",
	              component: _setSSLConfig2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/role-manager",
	              component: _roleManager2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/user-log",
	              component: _user_log2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/emergency-inquiry-messages",
	              component: _EmergencyInquiryMessages2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/admin/error",
	              component: _error2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_reactRouterDom.Redirect, { to: "/admindashboard" })
	          )
	        );
	      }
	      if (user_role === "2") {
	        userlink = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_reactRouterDom.Route, null),
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_PrivateRoute2.default, {
	              path: "/appointments",
	              component: _appointments2.default,
	              user: this.props.user,
	              exact: true
	            }),
	            _react2.default.createElement(_reactRouterDom.Redirect, { to: "/appointments" })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        userlink
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
	  return {
	    user: state.user
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(userActions, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Dashboard);

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAllPatientReportData = function getAllPatientReportData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/reports', {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var FirstTab = function FirstTab() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      patientReportData = _useState2[0],
	      setPatientReportData = _useState2[1];
	
	  var refreshgetAllPatientReportData = function refreshgetAllPatientReportData() {
	    var data = {
	      xpatient: localStorage.getItem(_constants.USER_ID)
	      //xpatient: '1000128959',
	    };
	    getAllPatientReportData(data).then(function (res) {
	      console.log(res);
	      setPatientReportData(res);
	    }).catch(function (err) {
	      console.log(err);
	    });
	  };
	  (0, _react.useEffect)(function () {
	    refreshgetAllPatientReportData();
	    (0, _jquery2.default)('.nav-link:first-child').addClass('active');
	  }, []);
	  return _react2.default.createElement(
	    'div',
	    { className: 'container FirstTab' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row d-flex align-items-start' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-3 nav flex-column nav-pills', id: 'v-pills-tab', role: 'tablist', 'aria-orientation': 'vertical' },
	        patientReportData.length > 0 ? patientReportData.slice(0, 5).map(function (patient_report_data) {
	          return _react2.default.createElement(
	            'button',
	            { className: 'nav-link v-pills-tab', id: 'v-pills-' + patient_report_data.report_id + '-tab', 'data-bs-toggle': 'pill', 'data-bs-target': '#v-pills-' + patient_report_data.report_id, type: 'button', role: 'tab', 'aria-controls': 'v-pills-home', 'aria-selected': 'true' },
	            patient_report_data.report_type
	          );
	        }) : _react2.default.createElement(
	          'p',
	          null,
	          'No Any Latest Consultations'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-9 tab-content pl-2 pr-2 pt-3 pb-3', id: 'v-pills-tabContent' },
	        patientReportData.length > 0 ? patientReportData.map(function (patient_report_data) {
	          var reportData = patient_report_data.report_data;
	          return _react2.default.createElement(
	            'div',
	            { className: 'tab-pane fade show', id: 'v-pills-' + patient_report_data.report_id, role: 'tabpanel', 'aria-labelledby': 'v-pills-home-tab' },
	            reportData.map(function (report_datas) {
	              var new_result_val = '';
	              var result_value = report_datas.Result;
	              var less_val = result_value.replace('<', '');
	              if (less_val) {
	                new_result_val = less_val;
	              } else {
	                new_result_val = result_value;
	              }
	              var result_value1 = parseFloat(new_result_val);
	              var result_value2 = parseFloat('100.00');
	              var subtract_val = result_value2 - result_value1;
	
	              return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3 p-2' },
	                  _react2.default.createElement(
	                    'p',
	                    { style: { "fontSize": "13px" } },
	                    report_datas.Item_name
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9 p-2' },
	                  result_value == 'Positive' ? _react2.default.createElement(
	                    'p',
	                    { style: { "textAlign": "left", "fontSize": "14px", "fontWeight": "600" } },
	                    result_value
	                  ) : result_value == 'Negative' ? _react2.default.createElement(
	                    'p',
	                    { style: { "textAlign": "left", "fontSize": "14px", "fontWeight": "600" } },
	                    result_value
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'progress' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'progress-bar', role: 'progressbar', style: { "width": "0%" }, 'aria-valuenow': '0', 'aria-valuemin': '0', 'aria-valuemax': '100' },
	                      '0%'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'progress-bar bg-success', role: 'progressbar', style: { "width": less_val ? less_val + '%' : report_datas.Result + '%' }, 'aria-valuenow': less_val ? less_val + '%' : report_datas.Result, 'aria-valuemin': '0', 'aria-valuemax': '100' },
	                      less_val ? less_val + '%' : report_datas.Result + '%'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'progress-bar bg-info', role: 'progressbar', style: { "width": subtract_val + '%' }, 'aria-valuenow': subtract_val, 'aria-valuemin': '0', 'aria-valuemax': '100' },
	                      subtract_val + '%'
	                    )
	                  )
	                )
	              );
	            })
	          );
	        }) : _react2.default.createElement(
	          'p',
	          null,
	          'No Any Latest Consultations'
	        )
	      )
	    )
	  );
	};
	exports.default = FirstTab;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrescriptionTab = function PrescriptionTab() {
	  return _react2.default.createElement(
	    "div",
	    { className: "PrescriptionTab" },
	    _react2.default.createElement(
	      "p",
	      null,
	      "Prescription Tab!! Hurray!!"
	    )
	  );
	};
	exports.default = PrescriptionTab;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = SecondTab;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _reactChartkick = __webpack_require__(946);
	
	__webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var getAllPatientHealthChartData = function getAllPatientHealthChartData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/vitalspatient', {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	function SecondTab() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      patienthealthchart = _useState2[0],
	      setPatientHealthChart = _useState2[1];
	
	  var refreshgetAllPatientHealthChartData = function refreshgetAllPatientHealthChartData() {
	    var data = {
	      xpatient: localStorage.getItem(_constants.USER_ID)
	    };
	    getAllPatientHealthChartData(data).then(function (res) {
	      var result = res.map(function (_ref) {
	        var Hight = _ref.Hight,
	            rest = _objectWithoutProperties(_ref, ['Hight']);
	
	        return Object.assign({}, rest);
	      });
	      var inputs = result.map(function (result_data) {
	        return _defineProperty({}, result_data.Date, result_data.Weight);
	      });
	      var output = {};
	      for (var i = 0; i < inputs.length; i++) {
	        var d = inputs[i];
	        for (var key in d) {
	          output[key] = d[key];
	        }
	      }
	      setPatientHealthChart(output);
	      /*this.setState({ patienthealthchartdate: res.Date });
	      this.setState({ patienthealthchartweight: res.Weight });*/
	    }).catch(function (err) {
	      console.log(err);
	    });
	  };
	  (0, _react.useEffect)(function () {
	    refreshgetAllPatientHealthChartData();
	  }, []);
	  return _react2.default.createElement(
	    'div',
	    { className: 'SecondTab mt-3' },
	    _react2.default.createElement(_reactChartkick.LineChart, { data: patienthealthchart })
	  );
	};

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FirstTab = __webpack_require__(580);
	
	var _FirstTab2 = _interopRequireDefault(_FirstTab);
	
	var _SecondTab = __webpack_require__(582);
	
	var _SecondTab2 = _interopRequireDefault(_SecondTab);
	
	var _PrescriptionTab = __webpack_require__(581);
	
	var _PrescriptionTab2 = _interopRequireDefault(_PrescriptionTab);
	
	var _TabNavItem = __webpack_require__(585);
	
	var _TabNavItem2 = _interopRequireDefault(_TabNavItem);
	
	var _TabContent = __webpack_require__(584);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tabs = function Tabs() {
	  var _useState = (0, _react.useState)("reports"),
	      _useState2 = _slicedToArray(_useState, 2),
	      activeTab = _useState2[0],
	      setActiveTab = _useState2[1];
	
	  var handleReports = function handleReports() {
	    setActiveTab("reports");
	  };
	  var handleYourStats = function handleYourStats() {
	    setActiveTab("your_stats");
	  };
	  var handlePrescription = function handlePrescription() {
	    setActiveTab("prescription");
	  };
	  return _react2.default.createElement(
	    "div",
	    { className: "Tabs" },
	    _react2.default.createElement(
	      "ul",
	      { className: "nav" },
	      _react2.default.createElement(_TabNavItem2.default, { title: "Reports", id: "reports", activeTab: activeTab, setActiveTab: setActiveTab }),
	      _react2.default.createElement(_TabNavItem2.default, { title: "Your Stats", id: "your_stats", activeTab: activeTab, setActiveTab: setActiveTab }),
	      _react2.default.createElement(_TabNavItem2.default, { title: "Prescription", id: "prescription", activeTab: activeTab, setActiveTab: setActiveTab })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "outlet" },
	      _react2.default.createElement(
	        _TabContent2.default,
	        { id: "reports", activeTab: activeTab },
	        _react2.default.createElement(_FirstTab2.default, null)
	      ),
	      _react2.default.createElement(
	        _TabContent2.default,
	        { id: "your_stats", activeTab: activeTab },
	        _react2.default.createElement(_SecondTab2.default, null)
	      ),
	      _react2.default.createElement(
	        _TabContent2.default,
	        { id: "prescription", activeTab: activeTab },
	        _react2.default.createElement(_PrescriptionTab2.default, null)
	      )
	    )
	  );
	};
	exports.default = Tabs;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabContent = function TabContent(_ref) {
	  var id = _ref.id,
	      activeTab = _ref.activeTab,
	      children = _ref.children;
	
	  return activeTab === id ? _react2.default.createElement(
	    "div",
	    { className: "TabContent" },
	    children
	  ) : null;
	};
	
	exports.default = TabContent;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabNavItem = function TabNavItem(_ref) {
	  var id = _ref.id,
	      title = _ref.title,
	      activeTab = _ref.activeTab,
	      setActiveTab = _ref.setActiveTab;
	
	
	  var handleClick = function handleClick() {
	    setActiveTab(id);
	  };
	
	  return _react2.default.createElement(
	    "li",
	    { onClick: handleClick, className: activeTab === id ? "active" : "" },
	    title
	  );
	};
	exports.default = TabNavItem;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _leftsidebar = __webpack_require__(96);
	
	var _leftsidebar2 = _interopRequireDefault(_leftsidebar);
	
	var _calenderIcon = __webpack_require__(1161);
	
	var _calenderIcon2 = _interopRequireDefault(_calenderIcon);
	
	var _line = __webpack_require__(1170);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _line3 = __webpack_require__(1171);
	
	var _line4 = _interopRequireDefault(_line3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {API_TOKEN_NAME} from '../../constants';
	
	//import { scAxios } from '../..';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	
	
	var DoctorPortal = function (_Component) {
	  _inherits(DoctorPortal, _Component);
	
	  function DoctorPortal() {
	    _classCallCheck(this, DoctorPortal);
	
	    return _possibleConstructorReturn(this, (DoctorPortal.__proto__ || Object.getPrototypeOf(DoctorPortal)).apply(this, arguments));
	  }
	
	  _createClass(DoctorPortal, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "section",
	          { className: "dashboard-part" },
	          _react2.default.createElement(
	            "div",
	            { className: "main-center-box" },
	            _react2.default.createElement(
	              "div",
	              { className: "flex-part" },
	              _react2.default.createElement(_reactRouterDom.Route, { component: _leftsidebar2.default }),
	              _react2.default.createElement(
	                "div",
	                { className: "dash-body", id: "dark-version-body" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "dash-text" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-7" },
	                      _react2.default.createElement(
	                        "h3",
	                        null,
	                        "Welcome Shadab!"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-3" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "my-calendar" },
	                        _react2.default.createElement("img", { src: _calenderIcon2.default, alt: "calender-icon" }),
	                        " My Calendar"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-2" },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "Logout-dash" },
	                        _react2.default.createElement(
	                          "a",
	                          { href: "#" },
	                          "Logout "
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "dash-text sspp mt-4" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    "Annoucements "
	                  ),
	                  _react2.default.createElement("hr", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-7 text-pera-body" },
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        "1. New Seminar Schedule "
	                      ),
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        "2. Leave Approved for Dr. Qazi "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-3  text-pera-body" },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "color-feed" },
	                        "August 15, 2021 "
	                      ),
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "color-feed" },
	                        "August 15, 2021 "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-2" },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "Logout-dash" },
	                        _react2.default.createElement(
	                          "a",
	                          { href: "#" },
	                          "View "
	                        )
	                      ),
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "Logout-dash" },
	                        _react2.default.createElement(
	                          "a",
	                          { href: "#" },
	                          "View "
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "dash-text sspp mt-4" },
	                      _react2.default.createElement(
	                        "h3",
	                        null,
	                        "My Activities",
	                        " ",
	                        _react2.default.createElement("i", { className: "fa-solid fa-plus plus-icon" }),
	                        " "
	                      ),
	                      _react2.default.createElement("hr", null),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-4" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "9:00 a.m."
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-2" },
	                          _react2.default.createElement("img", { src: _line2.default, alt: "line" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-6" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "New Seminar Accounced for Dec 27th at 5pm"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-4" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "9:00 a.m."
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-2" },
	                          _react2.default.createElement("img", { src: _line2.default, alt: "line" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-6" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Call Dr. Zubaida "
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-4" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "9:00 a.m."
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-2" },
	                          _react2.default.createElement("img", { src: _line2.default, alt: "line" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-6" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Work on new publication "
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-4" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "9:00 a.m."
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-2" },
	                          _react2.default.createElement("img", { src: _line2.default, alt: "line" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-6" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Meetign with Shamsul Bhai "
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-4" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "9:00 a.m."
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-2" },
	                          _react2.default.createElement("img", { src: _line4.default, alt: "line2" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-6" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Online HR Meeting "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "dash-text sspp mt-4" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-8" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "My Appointments "
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-4 text-right" },
	                          _react2.default.createElement(
	                            "h3",
	                            { className: "orange" },
	                            "Today ",
	                            _react2.default.createElement("i", { className: "fa-solid fa-calendar" }),
	                            " "
	                          )
	                        )
	                      ),
	                      _react2.default.createElement("hr", null),
	                      _react2.default.createElement(
	                        "table",
	                        { className: "table table-part" },
	                        _react2.default.createElement(
	                          "thead",
	                          null,
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "th",
	                              { style: { width: "25%" } },
	                              "SL Name"
	                            ),
	                            _react2.default.createElement(
	                              "th",
	                              {
	                                className: "text-center",
	                                style: { width: "50%" }
	                              },
	                              "Actions"
	                            ),
	                            _react2.default.createElement(
	                              "th",
	                              { className: "text-right", style: { width: "25%" } },
	                              "Time"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "tbody",
	                          null,
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              "2. Patient A"
	                            ),
	                            _react2.default.createElement("td", null),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-right" },
	                              "10.30 AM"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              "3. Patient A"
	                            ),
	                            _react2.default.createElement("td", null),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-right" },
	                              "11.30 AM"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              "4. Patient A"
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement(
	                                "div",
	                                { className: "follow-up" },
	                                _react2.default.createElement(
	                                  "ul",
	                                  null,
	                                  _react2.default.createElement(
	                                    "li",
	                                    null,
	                                    "Follow Up"
	                                  ),
	                                  _react2.default.createElement(
	                                    "li",
	                                    null,
	                                    "View Report"
	                                  ),
	                                  _react2.default.createElement(
	                                    "li",
	                                    null,
	                                    "View Prescription"
	                                  ),
	                                  _react2.default.createElement(
	                                    "li",
	                                    null,
	                                    "Refer"
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-right" },
	                              "12.30 AM"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              "5. Patient A"
	                            ),
	                            _react2.default.createElement("td", null),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-right" },
	                              "12.30 AM"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              "6. Patient A"
	                            ),
	                            _react2.default.createElement("td", null),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-right" },
	                              "12.30 AM"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              "7. Patient A"
	                            ),
	                            _react2.default.createElement("td", null),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-right" },
	                              "12.30 AM"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              "8. Patient A"
	                            ),
	                            _react2.default.createElement("td", null),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-right" },
	                              "12.30 AM"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              "9. Patient A"
	                            ),
	                            _react2.default.createElement("td", null),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-right" },
	                              "12.30 AM"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              "10. Patient A"
	                            ),
	                            _react2.default.createElement("td", null),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-right" },
	                              "12.30 AM"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DoctorPortal;
	}(_react.Component);
	
	exports.default = DoctorPortal;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _leftsidebar = __webpack_require__(96);
	
	var _leftsidebar2 = _interopRequireDefault(_leftsidebar);
	
	var _graf = __webpack_require__(177);
	
	var _graf2 = _interopRequireDefault(_graf);
	
	var _graf3 = __webpack_require__(178);
	
	var _graf4 = _interopRequireDefault(_graf3);
	
	var _round = __webpack_require__(180);
	
	var _round2 = _interopRequireDefault(_round);
	
	var _drPhoto = __webpack_require__(129);
	
	var _drPhoto2 = _interopRequireDefault(_drPhoto);
	
	var _hospital = __webpack_require__(130);
	
	var _hospital2 = _interopRequireDefault(_hospital);
	
	var _searchIcon = __webpack_require__(137);
	
	var _searchIcon2 = _interopRequireDefault(_searchIcon);
	
	var _Tabs = __webpack_require__(583);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GetSinglePatientsData = function GetSinglePatientsData(data) {
		console.log(data, "patients");
		return new Promise(function (resolve, reject) {
			var req = _.scAxios.request('/patients', {
				method: 'get',
				headers: {
					'Accept': 'application/json'
				},
				params: Object.assign({}, data)
			});
			req.then(function (res) {
				return resolve(res.data);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};
	var GetPatitentAppointment = function GetPatitentAppointment(data) {
		console.log(data, "appoinment");
		return new Promise(function (resolve, reject) {
			var req = _.scAxios.request('/appointment', {
				method: 'get',
				headers: {
					'Accept': 'application/json'
				},
				params: Object.assign({}, data)
			});
			req.then(function (res) {
				return resolve(res.data);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};
	var getSingleDoctorData = function getSingleDoctorData(id) {
		return new Promise(function (resolve, reject) {
			var req = _.scAxiosAdmin.request('/doctors/getsingledoctors/' + id, {
				method: 'get',
				headers: {
					'Accept': 'application/json',
					'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
				}
			});
			req.then(function (res) {
				return resolve(res.data);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};
	var getPatientReportsData = function getPatientReportsData(data) {
		return new Promise(function (resolve, reject) {
			var req = _.scAxios.request('/reports', {
				method: 'get',
				headers: {
					'Accept': 'application/json'
				},
				params: Object.assign({}, data)
			});
			req.then(function (res) {
				return resolve(res.data);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};
	
	var PatientOverview = function (_Component) {
		_inherits(PatientOverview, _Component);
	
		function PatientOverview() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PatientOverview);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PatientOverview.__proto__ || Object.getPrototypeOf(PatientOverview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
				patient_ID: '',
				patient_age: '',
				patient_gender: '',
				patient_name: '',
				patient_phone: '',
				latest_consultant: [],
				doctor_name: '',
				appointment_date: '',
				department_name: '',
				doctor_id: '',
				doctor_profile: '',
				patient_report_data: [],
				paitent_report_doctor_name: ''
			}, _this.refreshSinglePatientsData = function () {
				var data = {
					patient: localStorage.getItem(_constants.USER_ID)
				};
				GetSinglePatientsData(data).then(function (res) {
					console.log(res, "get res");
					_this.setState({
						patient_ID: res[0].patient_ID,
						patient_age: res[0].patient_age,
						patient_gender: res[0].patient_gender,
						patient_name: res[0].patient_name,
						patient_phone: res[0].patient_phone
					});
					if (res[0].latest_consultant) {
						_this.setState({ latest_consultant: res[0].latest_consultant });
					} else {
						_this.setState({ latest_consultant: '' });
					}
				}).catch(function (err) {
					console.log(err);
				});
			}, _this.refreshGetPatitentAppointment = function () {
				var data = {
					xpatient: localStorage.getItem(_constants.USER_ID)
				};
				GetPatitentAppointment(data)
				// console.log(data,"get patitent")
				.then(function (res) {
	
					if (res != false) {
						console.log(res, "get res");
						_this.refreshGetDoctorData(res[0].doctor[0].id);
						_this.setState({
							doctor_name: res[0].doctor[0].name,
							appointment_date: res[0].date,
							department_name: res[0].doctor[0].dept_name,
							doctor_id: res[0].doctor[0].id
						});
					} else {
						_this.setState({
							doctor_name: '',
							appointment_date: '',
							department_name: '',
							doctor_id: ''
						});
					}
				}).catch(function (err) {
					console.log(err);
				});
			}, _this.refreshGetDoctorData = function (id) {
				getSingleDoctorData(id).then(function (res) {
					if (res.status === true) {
						var records = res.data;
						_this.setState({
							doctor_profile: records.doctor_profile
						});
					} else {
						_this.setState({
							doctor_profile: ''
						});
					}
				}).catch(function (err) {
					console.log(err);
				});
			}, _this.refreshGetReportDoctorData = function (id) {
				getSingleDoctorData(id).then(function (res) {
					if (res.status === true) {
						var records = res.data;
						_this.setState({
							paitent_report_doctor_name: records.doctor_name
						});
					} else {
						_this.setState({
							paitent_report_doctor_name: ''
						});
					}
				}).catch(function (err) {
					console.log(err);
				});
			}, _this.refreshGetPatientReportsData = function () {
				var data = {
					xpatient: localStorage.getItem(_constants.USER_ID)
				};
				getPatientReportsData(data).then(function (res) {
					if (res == false) {
						_this.setState({ patient_report_data: '' });
					} else {
						_this.refreshGetReportDoctorData(res[0].doctor_id);
						_this.setState({ patient_report_data: res });
					}
				}).catch(function (err) {
					console.log(err);
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PatientOverview, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.refreshSinglePatientsData();
				this.refreshGetPatitentAppointment();
				this.refreshGetPatientReportsData();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'section',
						{ className: 'dashboard-part' },
						_react2.default.createElement(
							'div',
							{ className: 'main-center-box' },
							_react2.default.createElement(
								'div',
								{ className: 'flex-part' },
								_react2.default.createElement(_reactRouterDom.Route, { component: _leftsidebar2.default }),
								_react2.default.createElement(
									'div',
									{ className: 'dash-body', id: 'dark-version-body' },
									_react2.default.createElement(
										'div',
										{ className: 'dash-text' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-9' },
												_react2.default.createElement(
													'h3',
													null,
													'Welcome ',
													localStorage.getItem(_constants.PATIENT_NAME),
													'!'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-3' },
												_react2.default.createElement(
													'p',
													{ className: 'Logout-dash log' },
													_react2.default.createElement(
														'a',
														{ href: '/logout' },
														'Logout '
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'row mt-4' },
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'div',
												{ className: 'dash-text sspp icon-and-text' },
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-2 img-sp' },
														_react2.default.createElement('img', { src: _round2.default, alt: 'round-' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-10' },
														_react2.default.createElement(
															'h3',
															{ className: 'Your' },
															'Reports '
														),
														_react2.default.createElement(
															'p',
															null,
															'Lorem Ipsum is simply dummy text of the printing and typesetting. '
														)
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'div',
												{ className: 'dash-text sspp icon-and-text' },
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-2 img-sp' },
														_react2.default.createElement('img', { src: _round2.default, alt: 'round-' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-10' },
														_react2.default.createElement(
															'h3',
															{ className: 'Your' },
															'Reports '
														),
														_react2.default.createElement(
															'p',
															null,
															'Lorem Ipsum is simply dummy text of the printing and typesetting. '
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp upcoming ' },
										_react2.default.createElement(
											'div',
											{ className: 'row mt-4' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4 shadab-boarder' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3' },
													'Profile '
												),
												_react2.default.createElement(
													'p',
													null,
													'Name: ',
													_react2.default.createElement(
														'b',
														null,
														localStorage.getItem(_constants.PATIENT_NAME)
													)
												),
												_react2.default.createElement(
													'p',
													null,
													'Age:',
													_react2.default.createElement(
														'b',
														null,
														' ',
														this.state.patient_age,
														' '
													)
												),
												_react2.default.createElement(
													'p',
													null,
													'Gender: ',
													_react2.default.createElement(
														'b',
														null,
														this.state.patient_gender
													)
												),
												_react2.default.createElement(
													'p',
													null,
													'Phone No:',
													_react2.default.createElement(
														'b',
														null,
														this.state.patient_phone,
														' '
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'row mt-4 shadab-boarder-top-left' },
													_react2.default.createElement(
														'div',
														{ className: 'col-6' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'b',
																null,
																'Known Conditions'
															)
														),
														_react2.default.createElement(
															'p',
															null,
															'Asthma'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-6' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'b',
																null,
																' Known Allergies '
															)
														),
														_react2.default.createElement(
															'p',
															null,
															'Peanuts'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4 shadab-boarder' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3 Your' },
													'Your Appointments'
												),
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3' },
													'Appointments ',
													_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
													' '
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-3 img-sp' },
														this.state.doctor_profile ? _react2.default.createElement('img', { src: _constants.IMAGE_URL + '/DoctorProfileImg/' + this.state.doctor_profile, alt: '' }) : _react2.default.createElement('img', { src: 'https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg', alt: '' })
														/*<img src={dr_photo} alt="drphoto"/>*/
	
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-9 prof sp-l-r' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'b',
																null,
																this.state.doctor_name
															)
														),
														_react2.default.createElement(
															'p',
															null,
															this.state.department_name
														),
														_react2.default.createElement(
															'p',
															{ className: 'date-link' },
															'Referred By ',
															_react2.default.createElement(
																'span',
																null,
																this.state.doctor_name
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-5 img-sp' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Date ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																this.state.appointment_date
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-7' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Time ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'N/A'
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-12' },
														_react2.default.createElement(
															'button',
															{ className: 'btn-notes mt-3 w-100' },
															'Schedule Followup'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4 past-consultations' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3' },
													'Past Consultations'
												),
												this.state.latest_consultant.length > 0 ? this.state.latest_consultant.map(function (latest_consultant_data) {
													return _react2.default.createElement(
														'p',
														null,
														latest_consultant_data.date,
														' ',
														_react2.default.createElement(
															'b',
															null,
															'Consultation'
														),
														' with ',
														_react2.default.createElement(
															'b',
															null,
															latest_consultant_data.doctor_detail.name
														)
													);
												}) : _react2.default.createElement(
													'p',
													null,
													'No Any Latest Consultations'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp icon-and-text mt-5 boarder-r' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-6 col-sm-12 step-away' },
												_react2.default.createElement(
													'h2',
													null,
													'Expert  Help is  a  step Away'
												),
												_react2.default.createElement(
													'div',
													{ className: 'input-group navi-input mb-3' },
													_react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Search for physicans & departments', 'aria-label': 'Recipient\'s username', 'aria-describedby': 'basic-addon2' }),
													_react2.default.createElement(
														'span',
														{ className: 'input-group-text', id: 'basic-addon2' },
														_react2.default.createElement('img', { src: _searchIcon2.default, alt: 'search-icon' })
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-6 col-sm-12 ' },
												_react2.default.createElement('img', { src: _hospital2.default, alt: 'hospital' })
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp icon-and-text' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-10 col-sm-7 step-away' },
												_react2.default.createElement(
													'h3',
													null,
													'Your Stats'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-2 col-sm-5' },
												_react2.default.createElement(
													'div',
													{ className: 'dropdown' },
													_react2.default.createElement(
														'button',
														{ className: 'btn btn-secondary dropdown-toggle make-btn w-100', type: 'button', id: 'dropdownMenuButton1', 'data-bs-toggle': 'dropdown', 'aria-expanded': 'false' },
														'BPM ',
														_react2.default.createElement('i', { className: 'fa-solid fa-chevron-down' })
													),
													_react2.default.createElement(
														'ul',
														{ className: 'dropdown-menu', 'aria-labelledby': 'dropdownMenuButton1' },
														_react2.default.createElement(
															'li',
															null,
															_react2.default.createElement(
																'a',
																{ className: 'dropdown-item', href: '#' },
																'As a Doctor (ID Required) '
															)
														),
														_react2.default.createElement(
															'li',
															null,
															_react2.default.createElement(
																'a',
																{ className: 'dropdown-item', href: '#' },
																' As A Friend / Family'
															)
														)
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-6' },
												_react2.default.createElement('img', { src: _graf2.default, alt: 'graf2' })
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-6' },
												_react2.default.createElement('img', { src: _graf4.default, alt: 'graf3' })
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp' },
										_react2.default.createElement(
											'h3',
											null,
											'Reports'
										),
										_react2.default.createElement(
											'table',
											{ className: 'table table-part', id: 'table-apppin' },
											_react2.default.createElement(
												'tbody',
												null,
												this.state.patient_report_data.length > 0 ? this.state.patient_report_data.map(function (patient_report) {
													return _react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															null,
															patient_report.date_of_generated_report
														),
														_react2.default.createElement(
															'td',
															null,
															_react2.default.createElement(
																'b',
																null,
																patient_report.report_type
															)
														),
														_react2.default.createElement(
															'td',
															null,
															'ordered by '
														),
														_react2.default.createElement(
															'td',
															null,
															_react2.default.createElement(
																'b',
																null,
																_this2.state.paitent_report_doctor_name
															)
														),
														_react2.default.createElement('td', { style: { "width": "25%" } }),
														_react2.default.createElement(
															'td',
															{ style: { "text-align": "right", "width": "15%" } },
															_react2.default.createElement(
																'button',
																{ className: 'btn btn-karim' },
																'Download'
															)
														),
														_react2.default.createElement(
															'td',
															{ style: { "text-align": "right", "width": "15%" } },
															_react2.default.createElement(
																'button',
																{ className: 'btn btn-karim' },
																'view'
															)
														)
													);
												}) : _react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'No any reports found'
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'patient_dashboard_tabs_sec mt-3 mb-3' },
										_react2.default.createElement(_Tabs2.default, null)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp mt-4' },
										_react2.default.createElement(
											'h3',
											null,
											'Prescriptions '
										),
										_react2.default.createElement(
											'table',
											{ className: 'date-table' },
											_react2.default.createElement(
												'thead',
												null,
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														{ style: { "width": "65%" } },
														_react2.default.createElement(
															'p',
															null,
															'August 10, 2020 ',
															_react2.default.createElement(
																'b',
																null,
																'Prescription'
															),
															' ordered by ',
															_react2.default.createElement(
																'b',
																null,
																'Kazi A Karim'
															)
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'View'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Buy Online'
														)
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement('i', { className: 'fa-solid fa-angle-down' })
													)
												)
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'table',
											{ className: 'table table-part bold-td', id: 'table-apppin' },
											_react2.default.createElement(
												'tbody',
												null,
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'th',
														null,
														'Name'
													),
													_react2.default.createElement(
														'th',
														null,
														'Morning'
													),
													_react2.default.createElement(
														'th',
														null,
														'Noon'
													),
													_react2.default.createElement(
														'th',
														null,
														'Dinner'
													),
													_react2.default.createElement(
														'th',
														null,
														'Duration'
													),
													_react2.default.createElement(
														'th',
														null,
														'Remarks'
													),
													_react2.default.createElement('th', null),
													_react2.default.createElement('th', null)
												),
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'Med object 1 50 mg'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														null,
														'30 Dayes'
													),
													_react2.default.createElement(
														'td',
														null,
														'On full stomach only '
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'View'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Buy Online'
														)
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement('i', { className: 'fa-solid fa-plus' })
													)
												),
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'Med object 1 50 mg'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														null,
														'30 Dayes'
													),
													_react2.default.createElement(
														'td',
														null,
														'On full stomach only '
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'View'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Buy Online'
														)
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement('i', { className: 'fa-solid fa-plus' })
													)
												),
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'Med object 1 50 mg'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														null,
														'30 Dayes'
													),
													_react2.default.createElement(
														'td',
														null,
														'On full stomach only '
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'View'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Buy Online'
														)
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement('i', { className: 'fa-solid fa-plus' })
													)
												),
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'Med object 1 50 mg'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														null,
														'30 Dayes'
													),
													_react2.default.createElement(
														'td',
														null,
														'On full stomach only '
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'View'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Buy Online'
														)
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement('i', { className: 'fa-solid fa-plus' })
													)
												)
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'div',
											{ className: 'ordered' },
											_react2.default.createElement(
												'p',
												null,
												'August 10, 2020 ',
												_react2.default.createElement(
													'b',
													null,
													'Blood Test'
												),
												' ordered by ',
												_react2.default.createElement(
													'b',
													null,
													'Kazi A Karim'
												)
											),
											_react2.default.createElement('hr', null),
											_react2.default.createElement(
												'p',
												null,
												'August 10, 2020 ',
												_react2.default.createElement(
													'b',
													null,
													'Blood Test'
												),
												' ordered by ',
												_react2.default.createElement(
													'b',
													null,
													'Kazi A Karim'
												)
											),
											_react2.default.createElement('hr', null),
											_react2.default.createElement(
												'p',
												null,
												'August 10, 2020 ',
												_react2.default.createElement(
													'b',
													null,
													'Blood Test'
												),
												' ordered by ',
												_react2.default.createElement(
													'b',
													null,
													'Kazi A Karim'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'row', id: 'Metabolism' },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-6 col-sm-12' },
											_react2.default.createElement(
												'div',
												{ className: 'dash-text sspp mt-4' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3 Your' },
													'Follow Up Appointments '
												),
												_react2.default.createElement('hr', null),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-8' },
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-2 img-sp' },
																_react2.default.createElement('img', { src: _drPhoto2.default, alt: 'drphoto' })
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-10 prof sp-l-r' },
																_react2.default.createElement(
																	'p',
																	null,
																	_react2.default.createElement(
																		'b',
																		null,
																		'PROF. DR. MUHAMMAD HAFIZUR RAHMAN'
																	)
																),
																_react2.default.createElement(
																	'p',
																	null,
																	'Endocrinology & Metabolism '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-4  text-right' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-2' },
															_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
															' Book Now'
														)
													)
												),
												_react2.default.createElement('hr', null),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-8' },
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-2 img-sp' },
																_react2.default.createElement('img', { src: _drPhoto2.default, alt: 'drphoto' })
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-10 prof sp-l-r' },
																_react2.default.createElement(
																	'p',
																	null,
																	_react2.default.createElement(
																		'b',
																		null,
																		'PROF. DR. MUHAMMAD HAFIZUR RAHMAN'
																	)
																),
																_react2.default.createElement(
																	'p',
																	null,
																	'Endocrinology & Metabolism '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-4  text-right' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-2' },
															_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
															' Book Now'
														)
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-6 col-sm-12' },
											_react2.default.createElement(
												'div',
												{ className: 'dash-text sspp mt-4' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3 Your' },
													'Packages '
												),
												_react2.default.createElement('hr', null),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-8' },
														_react2.default.createElement(
															'p',
															null,
															'Cardiac Packages '
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-4  text-right' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-2' },
															_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
															' Book Now'
														)
													)
												),
												_react2.default.createElement('hr', null),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-8' },
														_react2.default.createElement(
															'p',
															null,
															'Cardiac Packages '
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-4  text-right' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-2' },
															_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
															' Book Now'
														)
													)
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return PatientOverview;
	}(_react.Component);
	
	exports.default = PatientOverview;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _leftsidebar = __webpack_require__(96);
	
	var _leftsidebar2 = _interopRequireDefault(_leftsidebar);
	
	var _graf = __webpack_require__(177);
	
	var _graf2 = _interopRequireDefault(_graf);
	
	var _graf3 = __webpack_require__(178);
	
	var _graf4 = _interopRequireDefault(_graf3);
	
	var _round = __webpack_require__(180);
	
	var _round2 = _interopRequireDefault(_round);
	
	var _drPhoto = __webpack_require__(129);
	
	var _drPhoto2 = _interopRequireDefault(_drPhoto);
	
	var _hospital = __webpack_require__(130);
	
	var _hospital2 = _interopRequireDefault(_hospital);
	
	var _searchIcon = __webpack_require__(137);
	
	var _searchIcon2 = _interopRequireDefault(_searchIcon);
	
	var _lines = __webpack_require__(450);
	
	var _lines2 = _interopRequireDefault(_lines);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {API_TOKEN_NAME} from '../../constants';
	
	//import { scAxios } from '../..';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	
	
	var PatientOverviewTwo = function (_Component) {
		_inherits(PatientOverviewTwo, _Component);
	
		function PatientOverviewTwo() {
			_classCallCheck(this, PatientOverviewTwo);
	
			return _possibleConstructorReturn(this, (PatientOverviewTwo.__proto__ || Object.getPrototypeOf(PatientOverviewTwo)).apply(this, arguments));
		}
	
		_createClass(PatientOverviewTwo, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'section',
						{ className: 'dashboard-part' },
						_react2.default.createElement(
							'div',
							{ className: 'main-center-box' },
							_react2.default.createElement(
								'div',
								{ className: 'flex-part' },
								_react2.default.createElement(_reactRouterDom.Route, { component: _leftsidebar2.default }),
								_react2.default.createElement(
									'div',
									{ className: 'dash-body', id: 'dark-version-body' },
									_react2.default.createElement(
										'div',
										{ className: 'dash-text' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-9' },
												_react2.default.createElement(
													'h3',
													null,
													'Welcome Shadab!'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-3' },
												_react2.default.createElement(
													'p',
													{ className: 'Logout-dash log' },
													_react2.default.createElement(
														'a',
														{ href: '#' },
														'Logout '
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'row mt-4' },
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'div',
												{ className: 'dash-text sspp icon-and-text' },
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-2 img-sp' },
														_react2.default.createElement('img', { src: _round2.default, alt: 'round-' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-10' },
														_react2.default.createElement(
															'h3',
															{ className: 'Your' },
															'Reports '
														),
														_react2.default.createElement(
															'p',
															null,
															'Lorem Ipsum is simply dummy text of the printing and typesetting. '
														)
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'div',
												{ className: 'dash-text sspp icon-and-text' },
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-2 img-sp' },
														_react2.default.createElement('img', { src: _round2.default, alt: 'round-' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-10' },
														_react2.default.createElement(
															'h3',
															{ className: 'Your' },
															'Reports '
														),
														_react2.default.createElement(
															'p',
															null,
															'Lorem Ipsum is simply dummy text of the printing and typesetting. '
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp upcoming ' },
										_react2.default.createElement(
											'div',
											{ className: 'row mt-4' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4 shadab-boarder' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3' },
													'Profile '
												),
												_react2.default.createElement(
													'p',
													null,
													'Name: ',
													_react2.default.createElement(
														'b',
														null,
														'Shadab Khondoker'
													)
												),
												_react2.default.createElement(
													'p',
													null,
													'Age:',
													_react2.default.createElement(
														'b',
														null,
														' 45 '
													)
												),
												_react2.default.createElement(
													'p',
													null,
													'Gender: ',
													_react2.default.createElement(
														'b',
														null,
														'Female'
													)
												),
												_react2.default.createElement(
													'p',
													null,
													'Phone No:',
													_react2.default.createElement(
														'b',
														null,
														'01731057667 '
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'row mt-4 shadab-boarder-top-left' },
													_react2.default.createElement(
														'div',
														{ className: 'col-6' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'b',
																null,
																'Known Conditions'
															)
														),
														_react2.default.createElement(
															'p',
															null,
															'Asthma'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-6' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'b',
																null,
																' Known Allergies '
															)
														),
														_react2.default.createElement(
															'p',
															null,
															'Peanuts'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4 shadab-boarder' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3 Your' },
													'Your Appointments'
												),
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3' },
													'Appointments ',
													_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
													' '
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-3 img-sp' },
														_react2.default.createElement('img', { src: _drPhoto2.default, alt: 'drphoto' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-9 prof sp-l-r' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'b',
																null,
																'PROF. DR. MUHAMMAD HAFIZUR RAHMAN'
															)
														),
														_react2.default.createElement(
															'p',
															null,
															'Endocrinology & Metabolism'
														),
														_react2.default.createElement(
															'p',
															{ className: 'date-link' },
															'Referred By ',
															_react2.default.createElement(
																'span',
																null,
																'Kazi A. Karim'
															),
															' on ',
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'Jan 10, 2022'
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-5 img-sp' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Date ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'Jan 22, 2022'
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-7' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Time ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'9:30 am - 10:00 am'
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-12' },
														_react2.default.createElement(
															'button',
															{ className: 'btn-notes mt-3 w-100' },
															'Schedule Followup'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4 past-consultations' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3' },
													'Past Consultations'
												),
												_react2.default.createElement(
													'p',
													null,
													'August 10, 2020 ',
													_react2.default.createElement(
														'b',
														null,
														'Consultation'
													),
													' with ',
													_react2.default.createElement(
														'b',
														null,
														'Kazi A Karim'
													)
												),
												_react2.default.createElement(
													'p',
													null,
													'August 10, 2020 ',
													_react2.default.createElement(
														'b',
														null,
														'Consultation'
													),
													' with ',
													_react2.default.createElement(
														'b',
														null,
														'Kazi A Karim'
													)
												),
												_react2.default.createElement(
													'p',
													null,
													'August 10, 2020 ',
													_react2.default.createElement(
														'b',
														null,
														'Consultation'
													),
													' with ',
													_react2.default.createElement(
														'b',
														null,
														'Kazi A Karim'
													)
												),
												_react2.default.createElement(
													'p',
													null,
													'August 10, 2020 ',
													_react2.default.createElement(
														'b',
														null,
														'Consultation'
													),
													' with ',
													_react2.default.createElement(
														'b',
														null,
														'Kazi A Karim'
													)
												),
												_react2.default.createElement(
													'p',
													null,
													'August 10, 2020 ',
													_react2.default.createElement(
														'b',
														null,
														'Consultation'
													),
													' with ',
													_react2.default.createElement(
														'b',
														null,
														'Kazi A Karim'
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp icon-and-text mt-5 boarder-r' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-6 col-sm-12 step-away' },
												_react2.default.createElement(
													'h2',
													null,
													'Expert  Help is  a  step Away'
												),
												_react2.default.createElement(
													'div',
													{ className: 'input-group navi-input mb-3' },
													_react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Search for physicans & departments', 'aria-label': 'Recipient\'s username', 'aria-describedby': 'basic-addon2' }),
													_react2.default.createElement(
														'span',
														{ className: 'input-group-text', id: 'basic-addon2' },
														_react2.default.createElement('img', { src: _searchIcon2.default, alt: 'search-icon' })
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-6 col-sm-12 ' },
												_react2.default.createElement('img', { src: _hospital2.default, alt: 'hospital' })
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp icon-and-text' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-10 col-sm-7 step-away' },
												_react2.default.createElement(
													'h3',
													null,
													'Your Stats'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-2 col-sm-5' },
												_react2.default.createElement(
													'div',
													{ className: 'dropdown' },
													_react2.default.createElement(
														'button',
														{ className: 'btn btn-secondary dropdown-toggle make-btn w-100', type: 'button', id: 'dropdownMenuButton1', 'data-bs-toggle': 'dropdown', 'aria-expanded': 'false' },
														'BPM ',
														_react2.default.createElement('i', { className: 'fa-solid fa-chevron-down' })
													),
													_react2.default.createElement(
														'ul',
														{ className: 'dropdown-menu', 'aria-labelledby': 'dropdownMenuButton1' },
														_react2.default.createElement(
															'li',
															null,
															_react2.default.createElement(
																'a',
																{ className: 'dropdown-item', href: '#' },
																'As a Doctor (ID Required) '
															)
														),
														_react2.default.createElement(
															'li',
															null,
															_react2.default.createElement(
																'a',
																{ className: 'dropdown-item', href: '#' },
																' As A Friend / Family'
															)
														)
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-6' },
												_react2.default.createElement('img', { src: _graf2.default, alt: 'graf2' })
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-6' },
												_react2.default.createElement('img', { src: _graf4.default, alt: 'graf3' })
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp  mt-4' },
										_react2.default.createElement(
											'h2',
											{ style: { "fontWeight": "700" } },
											'Blood Test'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('img', { src: _lines2.default, alt: 'lines' }),
										' ',
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'div',
											{ className: 'row mt-4 mb-4 dummy' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-2' },
												_react2.default.createElement(
													'h2',
													{ style: { "fontWeight": "700" }, className: 'mt-3 Advise' },
													'Advise'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-10' },
												_react2.default.createElement(
													'p',
													null,
													'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make...'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp upcoming ' },
										_react2.default.createElement(
											'div',
											{ className: 'row mt-4' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4 shadab-boarder' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3' },
													'Appointments ',
													_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
													' '
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-3 img-sp' },
														_react2.default.createElement('img', { src: _drPhoto2.default, alt: 'drphoto' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-9 prof sp-l-r' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'b',
																null,
																'PROF. DR. MUHAMMAD HAFIZUR RAHMAN'
															)
														),
														_react2.default.createElement(
															'p',
															null,
															'Endocrinology & Metabolism'
														),
														_react2.default.createElement(
															'p',
															{ className: 'date-link' },
															'Referred By ',
															_react2.default.createElement(
																'span',
																null,
																'Kazi A. Karim'
															),
															' on ',
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'Jan 10, 2022'
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-5 img-sp' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Date ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'Jan 22, 2022'
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-7' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Time ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'9:30 am - 10:00 am'
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-12' },
														_react2.default.createElement(
															'button',
															{ className: 'btn-notes mt-3 w-100' },
															'Schedule Followup'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4 shadab-boarder' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3' },
													'Appointments ',
													_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
													' '
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-3 img-sp' },
														_react2.default.createElement('img', { src: _drPhoto2.default, alt: 'drphoto' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-9 prof sp-l-r' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'b',
																null,
																'PROF. DR. MUHAMMAD HAFIZUR RAHMAN'
															)
														),
														_react2.default.createElement(
															'p',
															null,
															'Endocrinology & Metabolism'
														),
														_react2.default.createElement(
															'p',
															{ className: 'date-link' },
															'Referred By ',
															_react2.default.createElement(
																'span',
																null,
																'Kazi A. Karim'
															),
															' on ',
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'Jan 10, 2022'
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-5 img-sp' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Date ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'Jan 22, 2022'
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-7' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Time ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'9:30 am - 10:00 am'
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-12' },
														_react2.default.createElement(
															'button',
															{ className: 'btn-notes mt-3 w-100' },
															'Schedule Followup'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3' },
													'Appointments ',
													_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
													' '
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-3 img-sp' },
														_react2.default.createElement('img', { src: _drPhoto2.default, alt: 'drphoto' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-9 prof sp-l-r' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'b',
																null,
																'PROF. DR. MUHAMMAD HAFIZUR RAHMAN'
															)
														),
														_react2.default.createElement(
															'p',
															null,
															'Endocrinology & Metabolism'
														),
														_react2.default.createElement(
															'p',
															{ className: 'date-link' },
															'Referred By ',
															_react2.default.createElement(
																'span',
																null,
																'Kazi A. Karim'
															),
															' on ',
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'Jan 10, 2022'
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-5 img-sp' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Date ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'Jan 22, 2022'
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-7' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Time ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'9:30 am - 10:00 am'
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-12' },
														_react2.default.createElement(
															'button',
															{ className: 'btn-notes mt-3 w-100' },
															'Schedule Followup'
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp mt-4' },
										_react2.default.createElement(
											'h3',
											null,
											'Reports'
										),
										_react2.default.createElement(
											'table',
											{ className: 'table table-part', id: 'table-apppin' },
											_react2.default.createElement(
												'tbody',
												null,
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'August 10, 2020'
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Blood Test '
														)
													),
													_react2.default.createElement(
														'td',
														null,
														'ordered by '
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Kazi A Karim'
														)
													),
													_react2.default.createElement('td', { style: { "width": "25%" } }),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right", "width": "15%" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right", "width": "15%" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'view'
														)
													)
												),
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'August 10, 2020'
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Blood Test '
														)
													),
													_react2.default.createElement(
														'td',
														null,
														'ordered by '
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Kazi A Karim'
														)
													),
													_react2.default.createElement('td', { style: { "width": "25%" } }),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right", "width": "15%" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right", "width": "15%" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'view'
														)
													)
												),
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'August 10, 2020'
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Blood Test '
														)
													),
													_react2.default.createElement(
														'td',
														null,
														'ordered by '
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Kazi A Karim'
														)
													),
													_react2.default.createElement('td', { style: { "width": "25%" } }),
													_react2.default.createElement('td', { style: { "text-align": "right", "width": "15%" } }),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right", "width": "15%" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim pending' },
															'Pending '
														)
													)
												),
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'August 10, 2020'
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Blood Test '
														)
													),
													_react2.default.createElement(
														'td',
														null,
														'ordered by '
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Kazi A Karim'
														)
													),
													_react2.default.createElement('td', { style: { "width": "25%" } }),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right", "width": "15%" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right", "width": "15%" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'view'
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp mt-4' },
										_react2.default.createElement(
											'h3',
											null,
											'Prescriptions '
										),
										_react2.default.createElement(
											'table',
											{ className: 'date-table' },
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ style: { "width": "65%" } },
													_react2.default.createElement(
														'p',
														null,
														'August 10, 2020 ',
														_react2.default.createElement(
															'b',
															null,
															'Prescription'
														),
														' ordered by ',
														_react2.default.createElement(
															'b',
															null,
															'Kazi A Karim'
														)
													)
												),
												_react2.default.createElement(
													'td',
													{ style: { "text-align": "right" } },
													_react2.default.createElement(
														'button',
														{ className: 'btn btn-karim' },
														'View'
													)
												),
												_react2.default.createElement(
													'td',
													{ style: { "text-align": "right" } },
													_react2.default.createElement(
														'button',
														{ className: 'btn btn-karim' },
														'Download'
													)
												),
												_react2.default.createElement(
													'td',
													{ style: { "text-align": "right" } },
													_react2.default.createElement(
														'button',
														{ className: 'btn btn-karim' },
														'Buy Online'
													)
												),
												_react2.default.createElement(
													'td',
													null,
													_react2.default.createElement('i', { className: 'fa-solid fa-angle-down' })
												)
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'table',
											{ className: 'table table-part bold-td', id: 'table-apppin' },
											_react2.default.createElement(
												'tbody',
												null,
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'th',
														null,
														'Name'
													),
													_react2.default.createElement(
														'th',
														null,
														'Morning'
													),
													_react2.default.createElement(
														'th',
														null,
														'Noon'
													),
													_react2.default.createElement(
														'th',
														null,
														'Dinner'
													),
													_react2.default.createElement(
														'th',
														null,
														'Duration'
													),
													_react2.default.createElement(
														'th',
														null,
														'Remarks'
													),
													_react2.default.createElement('th', null),
													_react2.default.createElement('th', null)
												),
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'Med object 1 50 mg'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														null,
														'30 Dayes'
													),
													_react2.default.createElement(
														'td',
														null,
														'On full stomach only '
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'View'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Buy Online'
														)
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement('i', { className: 'fa-solid fa-plus' })
													)
												),
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'Med object 1 50 mg'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														null,
														'30 Dayes'
													),
													_react2.default.createElement(
														'td',
														null,
														'On full stomach only '
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'View'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Buy Online'
														)
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement('i', { className: 'fa-solid fa-plus' })
													)
												),
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'Med object 1 50 mg'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														null,
														'30 Dayes'
													),
													_react2.default.createElement(
														'td',
														null,
														'On full stomach only '
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'View'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Buy Online'
														)
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement('i', { className: 'fa-solid fa-plus' })
													)
												),
												_react2.default.createElement(
													'tr',
													null,
													_react2.default.createElement(
														'td',
														null,
														'Med object 1 50 mg'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "center" } },
														'1'
													),
													_react2.default.createElement(
														'td',
														null,
														'30 Dayes'
													),
													_react2.default.createElement(
														'td',
														null,
														'On full stomach only '
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'View'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Download'
														)
													),
													_react2.default.createElement(
														'td',
														{ style: { "text-align": "right" } },
														_react2.default.createElement(
															'button',
															{ className: 'btn btn-karim' },
															'Buy Online'
														)
													),
													_react2.default.createElement(
														'td',
														null,
														_react2.default.createElement('i', { className: 'fa-solid fa-plus' })
													)
												)
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'div',
											{ className: 'ordered' },
											_react2.default.createElement(
												'p',
												null,
												'August 10, 2020 ',
												_react2.default.createElement(
													'b',
													null,
													'Blood Test'
												),
												' ordered by ',
												_react2.default.createElement(
													'b',
													null,
													'Kazi A Karim'
												)
											),
											_react2.default.createElement('hr', null),
											_react2.default.createElement(
												'p',
												null,
												'August 10, 2020 ',
												_react2.default.createElement(
													'b',
													null,
													'Blood Test'
												),
												' ordered by ',
												_react2.default.createElement(
													'b',
													null,
													'Kazi A Karim'
												)
											),
											_react2.default.createElement('hr', null),
											_react2.default.createElement(
												'p',
												null,
												'August 10, 2020 ',
												_react2.default.createElement(
													'b',
													null,
													'Blood Test'
												),
												' ordered by ',
												_react2.default.createElement(
													'b',
													null,
													'Kazi A Karim'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'row', id: 'Metabolism' },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-6 col-sm-12' },
											_react2.default.createElement(
												'div',
												{ className: 'dash-text sspp mt-4' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3 Your' },
													'Follow Up Appointments '
												),
												_react2.default.createElement('hr', null),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-8' },
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-2 img-sp' },
																_react2.default.createElement('img', { src: _drPhoto2.default, alt: 'drphoto' })
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-10 prof sp-l-r' },
																_react2.default.createElement(
																	'p',
																	null,
																	_react2.default.createElement(
																		'b',
																		null,
																		'PROF. DR. MUHAMMAD HAFIZUR RAHMAN'
																	)
																),
																_react2.default.createElement(
																	'p',
																	null,
																	'Endocrinology & Metabolism '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-4  text-right' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-2' },
															_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
															' Book Now'
														)
													)
												),
												_react2.default.createElement('hr', null),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-8' },
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-2 img-sp' },
																_react2.default.createElement('img', { src: _drPhoto2.default, alt: 'drphoto' })
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-10 prof sp-l-r' },
																_react2.default.createElement(
																	'p',
																	null,
																	_react2.default.createElement(
																		'b',
																		null,
																		'PROF. DR. MUHAMMAD HAFIZUR RAHMAN'
																	)
																),
																_react2.default.createElement(
																	'p',
																	null,
																	'Endocrinology & Metabolism '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-4  text-right' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-2' },
															_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
															' Book Now'
														)
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-6 col-sm-12' },
											_react2.default.createElement(
												'div',
												{ className: 'dash-text sspp mt-4' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-3 Your' },
													'Packages '
												),
												_react2.default.createElement('hr', null),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-8' },
														_react2.default.createElement(
															'p',
															null,
															'Cardiac Packages '
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-4  text-right' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-2' },
															_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
															' Book Now'
														)
													)
												),
												_react2.default.createElement('hr', null),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-8' },
														_react2.default.createElement(
															'p',
															null,
															'Cardiac Packages '
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-4  text-right' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-2' },
															_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
															' Book Now'
														)
													)
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return PatientOverviewTwo;
	}(_react.Component);
	
	exports.default = PatientOverviewTwo;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _whiteleftsidebar = __webpack_require__(203);
	
	var _whiteleftsidebar2 = _interopRequireDefault(_whiteleftsidebar);
	
	var _doctor = __webpack_require__(176);
	
	var _doctor2 = _interopRequireDefault(_doctor);
	
	var _BabyGirl = __webpack_require__(443);
	
	var _BabyGirl2 = _interopRequireDefault(_BabyGirl);
	
	var _Wife = __webpack_require__(447);
	
	var _Wife2 = _interopRequireDefault(_Wife);
	
	var _Mother = __webpack_require__(445);
	
	var _Mother2 = _interopRequireDefault(_Mother);
	
	var _icon = __webpack_require__(57);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icon3 = __webpack_require__(131);
	
	var _icon4 = _interopRequireDefault(_icon3);
	
	var _icon5 = __webpack_require__(132);
	
	var _icon6 = _interopRequireDefault(_icon5);
	
	var _icon7 = __webpack_require__(133);
	
	var _icon8 = _interopRequireDefault(_icon7);
	
	var _icon9 = __webpack_require__(134);
	
	var _icon10 = _interopRequireDefault(_icon9);
	
	var _cardiac = __webpack_require__(104);
	
	var _cardiac2 = _interopRequireDefault(_cardiac);
	
	var _Bitmap = __webpack_require__(175);
	
	var _Bitmap2 = _interopRequireDefault(_Bitmap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {API_TOKEN_NAME} from '../../constants';
	
	//import { scAxios } from '../..';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	
	
	var PatientPortal = function (_Component) {
		_inherits(PatientPortal, _Component);
	
		function PatientPortal() {
			_classCallCheck(this, PatientPortal);
	
			return _possibleConstructorReturn(this, (PatientPortal.__proto__ || Object.getPrototypeOf(PatientPortal)).apply(this, arguments));
		}
	
		_createClass(PatientPortal, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'section',
						{ className: 'dashboard-part' },
						_react2.default.createElement(
							'div',
							{ className: 'main-center-box' },
							_react2.default.createElement(
								'div',
								{ className: 'flex-part' },
								_react2.default.createElement(_reactRouterDom.Route, { component: _whiteleftsidebar2.default }),
								_react2.default.createElement(
									'div',
									{ className: 'dash-body' },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-4' },
											_react2.default.createElement(
												'div',
												{ className: 'dash-text' },
												_react2.default.createElement(
													'p',
													null,
													'Hello Shadab!'
												)
											)
										),
										_react2.default.createElement('div', { className: 'col-sm-2' }),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group search-icon', id: 'form-search' },
												_react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Search for physicans & departments\u2026' }),
												_react2.default.createElement(
													'div',
													{ className: 'input-group-prepend' },
													_react2.default.createElement(
														'span',
														{ className: 'input-group-text', id: 'basic-addon1' },
														_react2.default.createElement('i', { className: 'fa-solid fa-magnifying-glass' })
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'row mt-3' },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-4 col-md-12' },
											_react2.default.createElement(
												'div',
												{ className: 'dash-text sspp' },
												_react2.default.createElement(
													'h3',
													null,
													'Upcoming Appointments'
												),
												_react2.default.createElement('hr', null),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-2 img-sp' },
														_react2.default.createElement('img', { src: _doctor2.default, alt: 'drphoto' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-9 prof sp-l-r px-2' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'b',
																null,
																'PROF. DR. MUHAMMAD HAFIZUR RAHMAN'
															)
														),
														_react2.default.createElement(
															'p',
															null,
															'Endocrinology & Metabolism'
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-7 prof img-sp' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3' },
															'Date ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'Jan 22, 2022'
															)
														),
														_react2.default.createElement(
															'p',
															{ className: 'mt-2' },
															'Time ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'9:30 am - 10:00 am'
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-5' },
														_react2.default.createElement(
															'button',
															{ className: 'btn-notes mt-4' },
															'Add Notes'
														)
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-8 col-md-12' },
											_react2.default.createElement(
												'div',
												{ className: 'dash-text sspp' },
												_react2.default.createElement(
													'h3',
													null,
													'Previous Appointments'
												),
												_react2.default.createElement(
													'div',
													{ className: 'table-appoin mt-3' },
													_react2.default.createElement(
														'div',
														{ className: 'dash-text sspp  prof font-table' },
														_react2.default.createElement(
															'div',
															{ className: 'row scrool' },
															_react2.default.createElement(
																'div',
																{ className: 'col-2 border-right' },
																_react2.default.createElement(
																	'p',
																	null,
																	'9 am ',
																	_react2.default.createElement('br', null),
																	_react2.default.createElement(
																		'b',
																		null,
																		'May 1, 2022'
																	)
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-4 border-right' },
																_react2.default.createElement(
																	'p',
																	null,
																	'PROF. DR. MUHAMMAD HAFIZUR RAHMAN ',
																	_react2.default.createElement('br', null),
																	_react2.default.createElement(
																		'b',
																		null,
																		'Endocrinology & Metabolism'
																	)
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-3 border-right' },
																_react2.default.createElement(
																	'div',
																	{ className: 'row' },
																	_react2.default.createElement(
																		'div',
																		{ className: 'col-6 img-sp text-center' },
																		_react2.default.createElement(
																			'p',
																			null,
																			'Write Your Review ',
																			_react2.default.createElement('br', null),
																			_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																			_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																			_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																			_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																			_react2.default.createElement('i', { className: 'fa-solid fa-star' })
																		)
																	),
																	_react2.default.createElement(
																		'div',
																		{ className: 'col-6 sp-l-r  text-center' },
																		_react2.default.createElement(
																			'h5',
																			null,
																			_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
																			' Follow Up'
																		)
																	)
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-1 sp-l-r text-center border-right' },
																_react2.default.createElement(
																	'p',
																	null,
																	'Reports'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-2 sp-l-r text-center' },
																_react2.default.createElement(
																	'p',
																	null,
																	'Prescriptions'
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'dash-text sspp  prof font-table mt-3' },
														_react2.default.createElement(
															'div',
															{ className: 'row scrool' },
															_react2.default.createElement(
																'div',
																{ className: 'col-2 border-right' },
																_react2.default.createElement(
																	'p',
																	null,
																	'9 am ',
																	_react2.default.createElement('br', null),
																	_react2.default.createElement(
																		'b',
																		null,
																		'May 1, 2022'
																	)
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-4 border-right' },
																_react2.default.createElement(
																	'p',
																	null,
																	'PROF. DR. MUHAMMAD HAFIZUR RAHMAN ',
																	_react2.default.createElement('br', null),
																	_react2.default.createElement(
																		'b',
																		null,
																		'Endocrinology & Metabolism'
																	)
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-3 border-right' },
																_react2.default.createElement(
																	'div',
																	{ className: 'row' },
																	_react2.default.createElement(
																		'div',
																		{ className: 'col-6 img-sp text-center' },
																		_react2.default.createElement(
																			'p',
																			null,
																			'Write Your Review ',
																			_react2.default.createElement('br', null),
																			_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																			_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																			_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																			_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																			_react2.default.createElement('i', { className: 'fa-solid fa-star' })
																		)
																	),
																	_react2.default.createElement(
																		'div',
																		{ className: 'col-6 sp-l-r  text-center' },
																		_react2.default.createElement(
																			'h5',
																			null,
																			_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
																			' Follow Up'
																		)
																	)
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-1 sp-l-r text-center border-right' },
																_react2.default.createElement(
																	'p',
																	null,
																	'Reports'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-2 sp-l-r text-center' },
																_react2.default.createElement(
																	'p',
																	null,
																	'Prescriptions'
																)
															)
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp mt-3' },
										_react2.default.createElement(
											'h3',
											null,
											'Family Members \xA0\xA0',
											_react2.default.createElement(
												'button',
												{ className: 'btn-notes ' },
												'Add Family Members'
											),
											' '
										),
										_react2.default.createElement(
											'div',
											{ className: 'row mt-4' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4' },
												_react2.default.createElement(
													'div',
													{ className: 'do-list' },
													_react2.default.createElement(
														'div',
														{ className: 'doc-text text-center' },
														_react2.default.createElement('img', { src: _BabyGirl2.default, alt: 'Baby-Girl' }),
														_react2.default.createElement(
															'h4',
															null,
															'My Daughter'
														),
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'span',
																null,
																'Age: 32+ \xA0\xA0 Gender: F'
															)
														)
													),
													_react2.default.createElement(
														'p',
														null,
														'Known Ailments/Conditions: N/A'
													),
													_react2.default.createElement(
														'p',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Last Follow-Up '
														),
														' \xA0\xA0 1+ year ago'
													),
													_react2.default.createElement('br', null),
													_react2.default.createElement('br', null)
												),
												_react2.default.createElement(
													'div',
													{ className: 'follow-mm' },
													_react2.default.createElement(
														'div',
														{ className: 'd-flex' },
														_react2.default.createElement(
															'div',
															{ className: 'boxs' },
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'Reports'
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'boxs' },
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'Prescriptions'
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'boxs' },
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'View Dashboard'
															)
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4' },
												_react2.default.createElement(
													'div',
													{ className: 'do-list' },
													_react2.default.createElement(
														'div',
														{ className: 'doc-text text-center' },
														_react2.default.createElement('img', { src: _Wife2.default, alt: 'Wife' }),
														_react2.default.createElement(
															'h4',
															null,
															'My Wife'
														),
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'span',
																null,
																'Age: 32+ \xA0\xA0 Gender: F'
															)
														)
													),
													_react2.default.createElement(
														'p',
														null,
														'Known Ailments/Conditions: N/A'
													),
													_react2.default.createElement(
														'p',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Last Follow-Up '
														),
														' \xA0\xA0 1+ year ago'
													),
													_react2.default.createElement('br', null),
													_react2.default.createElement('br', null)
												),
												_react2.default.createElement(
													'div',
													{ className: 'follow-mm' },
													_react2.default.createElement(
														'div',
														{ className: 'd-flex' },
														_react2.default.createElement(
															'div',
															{ className: 'boxs' },
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'Reports'
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'boxs' },
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'Prescriptions'
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'boxs' },
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'View Dashboard'
															)
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4' },
												_react2.default.createElement(
													'div',
													{ className: 'do-list' },
													_react2.default.createElement(
														'div',
														{ className: 'doc-text text-center' },
														_react2.default.createElement('img', { src: _Mother2.default, alt: 'Mother' }),
														_react2.default.createElement(
															'h4',
															null,
															'My Mother'
														),
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'span',
																null,
																'Age: 32+ \xA0\xA0 Gender: F'
															)
														)
													),
													_react2.default.createElement(
														'p',
														null,
														'Known Ailments/Conditions: N/A'
													),
													_react2.default.createElement(
														'p',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Last Follow-Up '
														),
														' \xA0\xA0 1+ year ago'
													),
													_react2.default.createElement('br', null),
													_react2.default.createElement('br', null)
												),
												_react2.default.createElement(
													'div',
													{ className: 'follow-mm' },
													_react2.default.createElement(
														'div',
														{ className: 'd-flex' },
														_react2.default.createElement(
															'div',
															{ className: 'boxs' },
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'Reports'
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'boxs' },
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'Prescriptions'
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'boxs' },
															_react2.default.createElement(
																'a',
																{ href: '#' },
																'View Dashboard'
															)
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'reports mt-4' },
										_react2.default.createElement(
											'div',
											{ className: 'follow-mm' },
											_react2.default.createElement(
												'div',
												{ className: 'd-flex' },
												_react2.default.createElement(
													'div',
													{ className: 'boxs rep' },
													_react2.default.createElement(
														'a',
														{ href: '#' },
														'Reports'
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'boxs' },
													_react2.default.createElement(
														'a',
														{ href: '#', className: 'your-stats' },
														'Your Stats'
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'boxs' },
													_react2.default.createElement(
														'a',
														{ href: '#' },
														'Prescription'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-3' },
												_react2.default.createElement(
													'ul',
													{ className: 'blood-report' },
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'a',
															{ href: '#' },
															'Blood Test Report ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'span',
																null,
																'Dec 17, 2021'
															)
														)
													),
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'a',
															{ href: '#' },
															'Blood Test Report ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'span',
																null,
																'Dec 17, 2021'
															)
														)
													),
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'a',
															{ href: '#' },
															'Blood Test Report ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'span',
																null,
																'Dec 17, 2021'
															)
														)
													),
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'a',
															{ href: '#' },
															'Blood Test Report ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'span',
																null,
																'Dec 17, 2021'
															)
														)
													),
													_react2.default.createElement(
														'li',
														{ className: 'view-all' },
														' ',
														_react2.default.createElement(
															'a',
															{ href: '#' },
															'View All Reports eports'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-9' },
												_react2.default.createElement(
													'div',
													{ className: 'dash-text sspp progressbar-part' },
													_react2.default.createElement(
														'div',
														{ className: 'row' },
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-2 sp-l-r' },
															_react2.default.createElement(
																'p',
																null,
																'WBC (billion/L) '
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-10' },
															_react2.default.createElement(
																'div',
																{ className: 'progress' },
																_react2.default.createElement(
																	'p',
																	null,
																	'25%'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'progress-bar', role: 'progressbar', style: { "width": "25%" }, 'aria-valuenow': '25', 'aria-valuemin': '0', 'aria-valuemax': '100' },
																	' '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'row mt-2' },
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-2 sp-l-r' },
															_react2.default.createElement(
																'p',
																null,
																'Neutrophils (%)  '
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-10' },
															_react2.default.createElement(
																'div',
																{ className: 'progress' },
																_react2.default.createElement(
																	'p',
																	null,
																	'25%'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'progress-bar', role: 'progressbar', style: { "width": "35%" }, 'aria-valuenow': '25', 'aria-valuemin': '0', 'aria-valuemax': '100' },
																	' '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'row mt-2' },
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-2 sp-l-r' },
															_react2.default.createElement(
																'p',
																null,
																'Lymphocytes (%) '
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-10' },
															_react2.default.createElement(
																'div',
																{ className: 'progress' },
																_react2.default.createElement(
																	'p',
																	null,
																	'25%'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'progress-bar', role: 'progressbar', style: { "width": "45%" }, 'aria-valuenow': '25', 'aria-valuemin': '0', 'aria-valuemax': '100' },
																	' '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'row mt-2' },
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-2 sp-l-r' },
															_react2.default.createElement(
																'p',
																null,
																'Monocytes (%) '
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-10' },
															_react2.default.createElement(
																'div',
																{ className: 'progress' },
																_react2.default.createElement(
																	'p',
																	null,
																	'25%'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'progress-bar', role: 'progressbar', style: { "width": "20%" }, 'aria-valuenow': '25', 'aria-valuemin': '0', 'aria-valuemax': '100' },
																	' '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'row mt-2' },
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-2 sp-l-r' },
															_react2.default.createElement(
																'p',
																null,
																'WEosinophils (%) '
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-10' },
															_react2.default.createElement(
																'div',
																{ className: 'progress' },
																_react2.default.createElement(
																	'p',
																	null,
																	'25%'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'progress-bar', role: 'progressbar', style: { "width": "88%" }, 'aria-valuenow': '25', 'aria-valuemin': '0', 'aria-valuemax': '100' },
																	' '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'row mt-2' },
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-2 sp-l-r' },
															_react2.default.createElement(
																'p',
																null,
																'Basophils (%)  '
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-10' },
															_react2.default.createElement(
																'div',
																{ className: 'progress' },
																_react2.default.createElement(
																	'p',
																	null,
																	'25%'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'progress-bar', role: 'progressbar', style: { "width": "75%" }, 'aria-valuenow': '25', 'aria-valuemin': '0', 'aria-valuemax': '100' },
																	' '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'row mt-2' },
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-2 sp-l-r' },
															_react2.default.createElement(
																'p',
																null,
																'RBCs (trillion/L)'
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-10' },
															_react2.default.createElement(
																'div',
																{ className: 'progress' },
																_react2.default.createElement(
																	'p',
																	null,
																	'25%'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'progress-bar', role: 'progressbar', style: { "width": "29%" }, 'aria-valuenow': '25', 'aria-valuemin': '0', 'aria-valuemax': '100' },
																	' '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'row mt-2' },
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-2 sp-l-r' },
															_react2.default.createElement(
																'p',
																null,
																'Hb (g/dL)  '
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-10' },
															_react2.default.createElement(
																'div',
																{ className: 'progress' },
																_react2.default.createElement(
																	'p',
																	null,
																	'25%'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'progress-bar', role: 'progressbar', style: { "width": "37%" }, 'aria-valuenow': '25', 'aria-valuemin': '0', 'aria-valuemax': '100' },
																	' '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'row mt-2' },
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-2 sp-l-r' },
															_react2.default.createElement(
																'p',
																null,
																'Hematocrit (%)'
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-10' },
															_react2.default.createElement(
																'div',
																{ className: 'progress' },
																_react2.default.createElement(
																	'p',
																	null,
																	'25%'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'progress-bar', role: 'progressbar', style: { "width": "46%" }, 'aria-valuenow': '25', 'aria-valuemin': '0', 'aria-valuemax': '100' },
																	' '
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'row mt-2' },
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-2 sp-l-r' },
															_react2.default.createElement(
																'p',
																null,
																'Platelets (billion/L)  '
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-sm-10' },
															_react2.default.createElement(
																'div',
																{ className: 'progress' },
																_react2.default.createElement(
																	'p',
																	null,
																	'25%'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'progress-bar', role: 'progressbar', style: { "width": "88%" }, 'aria-valuenow': '25', 'aria-valuemin': '0', 'aria-valuemax': '100' },
																	' '
																)
															)
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp mt-3' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-5' },
												_react2.default.createElement(
													'h3',
													null,
													'Recommended Check Ups'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-7 months-text' },
												_react2.default.createElement(
													'p',
													null,
													'Recommended in 4 months. Last one was 1 year ago'
												)
											)
										),
										_react2.default.createElement('hr', null),
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-12 icon-7' },
												_react2.default.createElement(
													'div',
													{ id: 'news-slider', className: 'owl-carousel' },
													_react2.default.createElement(
														'div',
														{ className: 'post-slide' },
														_react2.default.createElement(
															'span',
															null,
															_react2.default.createElement('img', { src: _icon2.default, alt: 'icon-2' })
														),
														_react2.default.createElement(
															'p',
															null,
															'General Health'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'post-slide' },
														_react2.default.createElement(
															'span',
															null,
															_react2.default.createElement('img', { src: _cardiac2.default, alt: 'cardiac' })
														),
														_react2.default.createElement(
															'p',
															null,
															'Cardiac'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'post-slide' },
														_react2.default.createElement(
															'span',
															null,
															_react2.default.createElement('img', { src: _icon4.default, alt: 'icon-3' })
														),
														_react2.default.createElement(
															'p',
															null,
															'Orthopedics'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'post-slide' },
														_react2.default.createElement(
															'span',
															null,
															_react2.default.createElement('img', { src: _icon6.default, alt: 'icon-4' })
														),
														_react2.default.createElement(
															'p',
															null,
															'Oncology'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'post-slide' },
														_react2.default.createElement(
															'span',
															null,
															_react2.default.createElement('img', { src: _icon8.default, alt: 'icon-5' })
														),
														_react2.default.createElement(
															'p',
															null,
															'Materity'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'post-slide' },
														_react2.default.createElement(
															'span',
															null,
															_react2.default.createElement('img', { src: _icon10.default, alt: 'icon-6' })
														),
														_react2.default.createElement(
															'p',
															null,
															'Hepatology'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'post-slide' },
														_react2.default.createElement(
															'span',
															null,
															_react2.default.createElement('img', { src: _cardiac2.default, alt: 'cardiac.svg' })
														),
														_react2.default.createElement(
															'p',
															null,
															'Cardiac'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'post-slide' },
														_react2.default.createElement(
															'span',
															null,
															_react2.default.createElement('img', { src: _icon6.default, alt: 'icon-4' })
														),
														_react2.default.createElement(
															'p',
															null,
															'Oncology'
														)
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row mt-5' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4' },
												_react2.default.createElement(
													'div',
													{ className: 'doctor-list' },
													_react2.default.createElement(
														'div',
														{ className: 'row' },
														_react2.default.createElement(
															'div',
															{ className: 'col-5' },
															_react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-2' })
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-7' },
															_react2.default.createElement(
																'h4',
																null,
																'Pregnancy Package 1'
															),
															_react2.default.createElement(
																'p',
																{ className: 'mt-3 mb-4' },
																'BDT ',
																_react2.default.createElement('br', null),
																' 9,800.00'
															),
															_react2.default.createElement(
																'p',
																null,
																_react2.default.createElement(
																	'b',
																	null,
																	'More Information'
																)
															)
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4' },
												_react2.default.createElement(
													'div',
													{ className: 'doctor-list' },
													_react2.default.createElement(
														'div',
														{ className: 'row' },
														_react2.default.createElement(
															'div',
															{ className: 'col-5' },
															_react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-2' })
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-7' },
															_react2.default.createElement(
																'h4',
																null,
																'Pregnancy Package 1'
															),
															_react2.default.createElement(
																'p',
																{ className: 'mt-3 mb-4' },
																'BDT ',
																_react2.default.createElement('br', null),
																' 9,800.00'
															),
															_react2.default.createElement(
																'p',
																null,
																_react2.default.createElement(
																	'b',
																	null,
																	'More Information'
																)
															)
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4' },
												_react2.default.createElement(
													'div',
													{ className: 'doctor-list' },
													_react2.default.createElement(
														'div',
														{ className: 'row' },
														_react2.default.createElement(
															'div',
															{ className: 'col-5' },
															_react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-2' })
														),
														_react2.default.createElement(
															'div',
															{ className: 'col-7' },
															_react2.default.createElement(
																'h4',
																null,
																'Pregnancy Package 1'
															),
															_react2.default.createElement(
																'p',
																{ className: 'mt-3 mb-4' },
																'BDT ',
																_react2.default.createElement('br', null),
																' 9,800.00'
															),
															_react2.default.createElement(
																'p',
																null,
																_react2.default.createElement(
																	'b',
																	null,
																	'More Information'
																)
															)
														)
													)
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return PatientPortal;
	}(_react.Component);
	
	exports.default = PatientPortal;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _whiteleftsidebar = __webpack_require__(203);
	
	var _whiteleftsidebar2 = _interopRequireDefault(_whiteleftsidebar);
	
	var _doctor = __webpack_require__(176);
	
	var _doctor2 = _interopRequireDefault(_doctor);
	
	var _BabyGirl = __webpack_require__(443);
	
	var _BabyGirl2 = _interopRequireDefault(_BabyGirl);
	
	var _Wife = __webpack_require__(447);
	
	var _Wife2 = _interopRequireDefault(_Wife);
	
	var _Mother = __webpack_require__(445);
	
	var _Mother2 = _interopRequireDefault(_Mother);
	
	var _icon = __webpack_require__(57);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icon3 = __webpack_require__(131);
	
	var _icon4 = _interopRequireDefault(_icon3);
	
	var _icon5 = __webpack_require__(132);
	
	var _icon6 = _interopRequireDefault(_icon5);
	
	var _icon7 = __webpack_require__(133);
	
	var _icon8 = _interopRequireDefault(_icon7);
	
	var _icon9 = __webpack_require__(134);
	
	var _icon10 = _interopRequireDefault(_icon9);
	
	var _cardiac = __webpack_require__(104);
	
	var _cardiac2 = _interopRequireDefault(_cardiac);
	
	var _Bitmap = __webpack_require__(175);
	
	var _Bitmap2 = _interopRequireDefault(_Bitmap);
	
	var _graf = __webpack_require__(1167);
	
	var _graf2 = _interopRequireDefault(_graf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {API_TOKEN_NAME} from '../../constants';
	
	//import { scAxios } from '../..';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	
	
	var PatientPortalTwo = function (_Component) {
			_inherits(PatientPortalTwo, _Component);
	
			function PatientPortalTwo() {
					_classCallCheck(this, PatientPortalTwo);
	
					return _possibleConstructorReturn(this, (PatientPortalTwo.__proto__ || Object.getPrototypeOf(PatientPortalTwo)).apply(this, arguments));
			}
	
			_createClass(PatientPortalTwo, [{
					key: 'render',
					value: function render() {
							return _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
											'section',
											{ className: 'dashboard-part' },
											_react2.default.createElement(
													'div',
													{ className: 'main-center-box' },
													_react2.default.createElement(
															'div',
															{ className: 'flex-part' },
															_react2.default.createElement(_reactRouterDom.Route, { component: _whiteleftsidebar2.default }),
															_react2.default.createElement(
																	'div',
																	{ className: 'dash-body' },
																	_react2.default.createElement(
																			'div',
																			{ className: 'row' },
																			_react2.default.createElement(
																					'div',
																					{ className: 'col-sm-4' },
																					_react2.default.createElement(
																							'div',
																							{ className: 'dash-text' },
																							_react2.default.createElement(
																									'p',
																									null,
																									'Hello Shadab!'
																							)
																					)
																			),
																			_react2.default.createElement('div', { className: 'col-sm-2' }),
																			_react2.default.createElement(
																					'div',
																					{ className: 'col-sm-6' },
																					_react2.default.createElement(
																							'div',
																							{ className: 'input-group search-icon', id: 'form-search' },
																							_react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Search for physicans & departments\u2026' }),
																							_react2.default.createElement(
																									'div',
																									{ className: 'input-group-prepend' },
																									_react2.default.createElement(
																											'span',
																											{ className: 'input-group-text', id: 'basic-addon1' },
																											_react2.default.createElement('i', { className: 'fa-solid fa-magnifying-glass' })
																									)
																							)
																					)
																			)
																	),
																	_react2.default.createElement(
																			'div',
																			{ className: 'row mt-3' },
																			_react2.default.createElement(
																					'div',
																					{ className: 'col-lg-4 col-md-12' },
																					_react2.default.createElement(
																							'div',
																							{ className: 'dash-text sspp' },
																							_react2.default.createElement(
																									'h3',
																									null,
																									'Upcoming Appointments'
																							),
																							_react2.default.createElement('hr', null),
																							_react2.default.createElement(
																									'div',
																									{ className: 'row' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'col-2 img-sp' },
																											_react2.default.createElement('img', { src: _doctor2.default, alt: 'drphoto' })
																									),
																									_react2.default.createElement(
																											'div',
																											{ className: 'col-9 prof sp-l-r px-2' },
																											_react2.default.createElement(
																													'p',
																													null,
																													_react2.default.createElement(
																															'b',
																															null,
																															'PROF. DR. MUHAMMAD HAFIZUR RAHMAN'
																													)
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													'Endocrinology & Metabolism'
																											)
																									)
																							),
																							_react2.default.createElement(
																									'div',
																									{ className: 'row' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'col-7 prof img-sp' },
																											_react2.default.createElement(
																													'p',
																													{ className: 'mt-3' },
																													'Date ',
																													_react2.default.createElement('br', null),
																													_react2.default.createElement(
																															'b',
																															null,
																															'Jan 22, 2022'
																													)
																											),
																											_react2.default.createElement(
																													'p',
																													{ className: 'mt-2' },
																													'Time ',
																													_react2.default.createElement('br', null),
																													_react2.default.createElement(
																															'b',
																															null,
																															'9:30 am - 10:00 am'
																													)
																											)
																									),
																									_react2.default.createElement(
																											'div',
																											{ className: 'col-5' },
																											_react2.default.createElement(
																													'button',
																													{ className: 'btn-notes mt-4' },
																													'Add Notes'
																											)
																									)
																							)
																					)
																			),
																			_react2.default.createElement(
																					'div',
																					{ className: 'col-lg-8 col-md-12' },
																					_react2.default.createElement(
																							'div',
																							{ className: 'dash-text sspp' },
																							_react2.default.createElement(
																									'h3',
																									null,
																									'Previous Appointments'
																							),
																							_react2.default.createElement(
																									'div',
																									{ className: 'table-appoin mt-3' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'dash-text sspp  prof font-table' },
																											_react2.default.createElement(
																													'div',
																													{ className: 'row scrool' },
																													_react2.default.createElement(
																															'div',
																															{ className: 'col-2 border-right' },
																															_react2.default.createElement(
																																	'p',
																																	null,
																																	'9 am ',
																																	_react2.default.createElement('br', null),
																																	_react2.default.createElement(
																																			'b',
																																			null,
																																			'May 1, 2022'
																																	)
																															)
																													),
																													_react2.default.createElement(
																															'div',
																															{ className: 'col-4 border-right' },
																															_react2.default.createElement(
																																	'p',
																																	null,
																																	'PROF. DR. MUHAMMAD HAFIZUR RAHMAN ',
																																	_react2.default.createElement('br', null),
																																	_react2.default.createElement(
																																			'b',
																																			null,
																																			'Endocrinology & Metabolism'
																																	)
																															)
																													),
																													_react2.default.createElement(
																															'div',
																															{ className: 'col-3 border-right' },
																															_react2.default.createElement(
																																	'div',
																																	{ className: 'row' },
																																	_react2.default.createElement(
																																			'div',
																																			{ className: 'col-6 img-sp text-center' },
																																			_react2.default.createElement(
																																					'p',
																																					null,
																																					'Write Your Review ',
																																					_react2.default.createElement('br', null),
																																					_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																																					_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																																					_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																																					_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																																					_react2.default.createElement('i', { className: 'fa-solid fa-star' })
																																			)
																																	),
																																	_react2.default.createElement(
																																			'div',
																																			{ className: 'col-6 sp-l-r  text-center' },
																																			_react2.default.createElement(
																																					'h5',
																																					null,
																																					_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
																																					' Follow Up'
																																			)
																																	)
																															)
																													),
																													_react2.default.createElement(
																															'div',
																															{ className: 'col-1 sp-l-r text-center border-right' },
																															_react2.default.createElement(
																																	'p',
																																	null,
																																	'Reports'
																															)
																													),
																													_react2.default.createElement(
																															'div',
																															{ className: 'col-2 sp-l-r text-center' },
																															_react2.default.createElement(
																																	'p',
																																	null,
																																	'Prescriptions'
																															)
																													)
																											)
																									),
																									_react2.default.createElement(
																											'div',
																											{ className: 'dash-text sspp  prof font-table mt-3' },
																											_react2.default.createElement(
																													'div',
																													{ className: 'row scrool' },
																													_react2.default.createElement(
																															'div',
																															{ className: 'col-2 border-right' },
																															_react2.default.createElement(
																																	'p',
																																	null,
																																	'9 am ',
																																	_react2.default.createElement('br', null),
																																	_react2.default.createElement(
																																			'b',
																																			null,
																																			'May 1, 2022'
																																	)
																															)
																													),
																													_react2.default.createElement(
																															'div',
																															{ className: 'col-4 border-right' },
																															_react2.default.createElement(
																																	'p',
																																	null,
																																	'PROF. DR. MUHAMMAD HAFIZUR RAHMAN ',
																																	_react2.default.createElement('br', null),
																																	_react2.default.createElement(
																																			'b',
																																			null,
																																			'Endocrinology & Metabolism'
																																	)
																															)
																													),
																													_react2.default.createElement(
																															'div',
																															{ className: 'col-3 border-right' },
																															_react2.default.createElement(
																																	'div',
																																	{ className: 'row' },
																																	_react2.default.createElement(
																																			'div',
																																			{ className: 'col-6 img-sp text-center' },
																																			_react2.default.createElement(
																																					'p',
																																					null,
																																					'Write Your Review ',
																																					_react2.default.createElement('br', null),
																																					_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																																					_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																																					_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																																					_react2.default.createElement('i', { className: 'fa-solid fa-star' }),
																																					_react2.default.createElement('i', { className: 'fa-solid fa-star' })
																																			)
																																	),
																																	_react2.default.createElement(
																																			'div',
																																			{ className: 'col-6 sp-l-r  text-center' },
																																			_react2.default.createElement(
																																					'h5',
																																					null,
																																					_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
																																					' Follow Up'
																																			)
																																	)
																															)
																													),
																													_react2.default.createElement(
																															'div',
																															{ className: 'col-1 sp-l-r text-center border-right' },
																															_react2.default.createElement(
																																	'p',
																																	null,
																																	'Reports'
																															)
																													),
																													_react2.default.createElement(
																															'div',
																															{ className: 'col-2 sp-l-r text-center' },
																															_react2.default.createElement(
																																	'p',
																																	null,
																																	'Prescriptions'
																															)
																													)
																											)
																									)
																							)
																					)
																			)
																	),
																	_react2.default.createElement(
																			'div',
																			{ className: 'dash-text sspp mt-3' },
																			_react2.default.createElement(
																					'h3',
																					null,
																					'Family Members \xA0\xA0',
																					_react2.default.createElement(
																							'button',
																							{ className: 'btn-notes ' },
																							'Add Family Members'
																					),
																					' '
																			),
																			_react2.default.createElement(
																					'div',
																					{ className: 'row mt-4' },
																					_react2.default.createElement(
																							'div',
																							{ className: 'col-sm-4' },
																							_react2.default.createElement(
																									'div',
																									{ className: 'do-list' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'doc-text text-center' },
																											_react2.default.createElement('img', { src: _BabyGirl2.default, alt: 'Baby-Girl' }),
																											_react2.default.createElement(
																													'h4',
																													null,
																													'My Daughter'
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													_react2.default.createElement(
																															'span',
																															null,
																															'Age: 32+ \xA0\xA0 Gender: F'
																													)
																											)
																									),
																									_react2.default.createElement(
																											'p',
																											null,
																											'Known Ailments/Conditions: N/A'
																									),
																									_react2.default.createElement(
																											'p',
																											null,
																											_react2.default.createElement(
																													'b',
																													null,
																													'Last Follow-Up '
																											),
																											' \xA0\xA0 1+ year ago'
																									),
																									_react2.default.createElement('br', null),
																									_react2.default.createElement('br', null)
																							),
																							_react2.default.createElement(
																									'div',
																									{ className: 'follow-mm' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'd-flex' },
																											_react2.default.createElement(
																													'div',
																													{ className: 'boxs' },
																													_react2.default.createElement(
																															'a',
																															{ href: '#' },
																															'Reports'
																													)
																											),
																											_react2.default.createElement(
																													'div',
																													{ className: 'boxs' },
																													_react2.default.createElement(
																															'a',
																															{ href: '#' },
																															'Prescriptions'
																													)
																											),
																											_react2.default.createElement(
																													'div',
																													{ className: 'boxs' },
																													_react2.default.createElement(
																															'a',
																															{ href: '#' },
																															'View Dashboard'
																													)
																											)
																									)
																							)
																					),
																					_react2.default.createElement(
																							'div',
																							{ className: 'col-sm-4' },
																							_react2.default.createElement(
																									'div',
																									{ className: 'do-list' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'doc-text text-center' },
																											_react2.default.createElement('img', { src: _Wife2.default, alt: 'Wife' }),
																											_react2.default.createElement(
																													'h4',
																													null,
																													'My Wife'
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													_react2.default.createElement(
																															'span',
																															null,
																															'Age: 32+ \xA0\xA0 Gender: F'
																													)
																											)
																									),
																									_react2.default.createElement(
																											'p',
																											null,
																											'Known Ailments/Conditions: N/A'
																									),
																									_react2.default.createElement(
																											'p',
																											null,
																											_react2.default.createElement(
																													'b',
																													null,
																													'Last Follow-Up '
																											),
																											' \xA0\xA0 1+ year ago'
																									),
																									_react2.default.createElement('br', null),
																									_react2.default.createElement('br', null)
																							),
																							_react2.default.createElement(
																									'div',
																									{ className: 'follow-mm' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'd-flex' },
																											_react2.default.createElement(
																													'div',
																													{ className: 'boxs' },
																													_react2.default.createElement(
																															'a',
																															{ href: '#' },
																															'Reports'
																													)
																											),
																											_react2.default.createElement(
																													'div',
																													{ className: 'boxs' },
																													_react2.default.createElement(
																															'a',
																															{ href: '#' },
																															'Prescriptions'
																													)
																											),
																											_react2.default.createElement(
																													'div',
																													{ className: 'boxs' },
																													_react2.default.createElement(
																															'a',
																															{ href: '#' },
																															'View Dashboard'
																													)
																											)
																									)
																							)
																					),
																					_react2.default.createElement(
																							'div',
																							{ className: 'col-sm-4' },
																							_react2.default.createElement(
																									'div',
																									{ className: 'do-list' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'doc-text text-center' },
																											_react2.default.createElement('img', { src: _Mother2.default, alt: 'Mother' }),
																											_react2.default.createElement(
																													'h4',
																													null,
																													'My Mother'
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													_react2.default.createElement(
																															'span',
																															null,
																															'Age: 32+ \xA0\xA0 Gender: F'
																													)
																											)
																									),
																									_react2.default.createElement(
																											'p',
																											null,
																											'Known Ailments/Conditions: N/A'
																									),
																									_react2.default.createElement(
																											'p',
																											null,
																											_react2.default.createElement(
																													'b',
																													null,
																													'Last Follow-Up '
																											),
																											' \xA0\xA0 1+ year ago'
																									),
																									_react2.default.createElement('br', null),
																									_react2.default.createElement('br', null)
																							),
																							_react2.default.createElement(
																									'div',
																									{ className: 'follow-mm' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'd-flex' },
																											_react2.default.createElement(
																													'div',
																													{ className: 'boxs' },
																													_react2.default.createElement(
																															'a',
																															{ href: '#' },
																															'Reports'
																													)
																											),
																											_react2.default.createElement(
																													'div',
																													{ className: 'boxs' },
																													_react2.default.createElement(
																															'a',
																															{ href: '#' },
																															'Prescriptions'
																													)
																											),
																											_react2.default.createElement(
																													'div',
																													{ className: 'boxs' },
																													_react2.default.createElement(
																															'a',
																															{ href: '#' },
																															'View Dashboard'
																													)
																											)
																									)
																							)
																					)
																			)
																	),
																	_react2.default.createElement(
																			'div',
																			{ className: 'reports mt-4' },
																			_react2.default.createElement(
																					'div',
																					{ className: 'follow-mm' },
																					_react2.default.createElement(
																							'div',
																							{ className: 'd-flex' },
																							_react2.default.createElement(
																									'div',
																									{ className: 'boxs ' },
																									_react2.default.createElement(
																											'a',
																											{ href: '#' },
																											'Reports'
																									)
																							),
																							_react2.default.createElement(
																									'div',
																									{ className: 'boxs rep border-0' },
																									_react2.default.createElement(
																											'a',
																											{ href: '#', className: 'your-stats' },
																											'Your Stats'
																									)
																							),
																							_react2.default.createElement(
																									'div',
																									{ className: 'boxs' },
																									_react2.default.createElement(
																											'a',
																											{ href: '#' },
																											'Prescription'
																									)
																							)
																					)
																			),
																			_react2.default.createElement('img', { src: _graf2.default, alt: 'graf' })
																	),
																	_react2.default.createElement(
																			'div',
																			{ className: 'dash-text sspp mt-3' },
																			_react2.default.createElement(
																					'div',
																					{ className: 'row' },
																					_react2.default.createElement(
																							'div',
																							{ className: 'col-sm-5' },
																							_react2.default.createElement(
																									'h3',
																									null,
																									'Recommended Check Ups'
																							)
																					),
																					_react2.default.createElement(
																							'div',
																							{ className: 'col-sm-7 months-text' },
																							_react2.default.createElement(
																									'p',
																									null,
																									'Recommended in 4 months. Last one was 1 year ago'
																							)
																					)
																			),
																			_react2.default.createElement('hr', null),
																			_react2.default.createElement(
																					'div',
																					{ className: 'row' },
																					_react2.default.createElement(
																							'div',
																							{ className: 'col-12 icon-7' },
																							_react2.default.createElement(
																									'div',
																									{ id: 'news-slider', className: 'owl-carousel' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'post-slide' },
																											_react2.default.createElement(
																													'span',
																													null,
																													_react2.default.createElement('img', { src: _icon2.default, alt: 'icon-2' })
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													'General Health'
																											)
																									),
																									_react2.default.createElement(
																											'div',
																											{ className: 'post-slide' },
																											_react2.default.createElement(
																													'span',
																													null,
																													_react2.default.createElement('img', { src: _cardiac2.default, alt: 'cardiac' })
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													'Cardiac'
																											)
																									),
																									_react2.default.createElement(
																											'div',
																											{ className: 'post-slide' },
																											_react2.default.createElement(
																													'span',
																													null,
																													_react2.default.createElement('img', { src: _icon4.default, alt: 'icon-3' })
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													'Orthopedics'
																											)
																									),
																									_react2.default.createElement(
																											'div',
																											{ className: 'post-slide' },
																											_react2.default.createElement(
																													'span',
																													null,
																													_react2.default.createElement('img', { src: _icon6.default, alt: 'icon-4' })
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													'Oncology'
																											)
																									),
																									_react2.default.createElement(
																											'div',
																											{ className: 'post-slide' },
																											_react2.default.createElement(
																													'span',
																													null,
																													_react2.default.createElement('img', { src: _icon8.default, alt: 'icon-5' })
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													'Materity'
																											)
																									),
																									_react2.default.createElement(
																											'div',
																											{ className: 'post-slide' },
																											_react2.default.createElement(
																													'span',
																													null,
																													_react2.default.createElement('img', { src: _icon10.default, alt: 'icon-6' })
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													'Hepatology'
																											)
																									),
																									_react2.default.createElement(
																											'div',
																											{ className: 'post-slide' },
																											_react2.default.createElement(
																													'span',
																													null,
																													_react2.default.createElement('img', { src: _cardiac2.default, alt: 'cardiac.svg' })
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													'Cardiac'
																											)
																									),
																									_react2.default.createElement(
																											'div',
																											{ className: 'post-slide' },
																											_react2.default.createElement(
																													'span',
																													null,
																													_react2.default.createElement('img', { src: _icon6.default, alt: 'icon-4' })
																											),
																											_react2.default.createElement(
																													'p',
																													null,
																													'Oncology'
																											)
																									)
																							)
																					)
																			),
																			_react2.default.createElement(
																					'div',
																					{ className: 'row mt-5' },
																					_react2.default.createElement(
																							'div',
																							{ className: 'col-sm-4' },
																							_react2.default.createElement(
																									'div',
																									{ className: 'doctor-list' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'row' },
																											_react2.default.createElement(
																													'div',
																													{ className: 'col-5' },
																													_react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-2' })
																											),
																											_react2.default.createElement(
																													'div',
																													{ className: 'col-7' },
																													_react2.default.createElement(
																															'h4',
																															null,
																															'Pregnancy Package 1'
																													),
																													_react2.default.createElement(
																															'p',
																															{ className: 'mt-3 mb-4' },
																															'BDT ',
																															_react2.default.createElement('br', null),
																															' 9,800.00'
																													),
																													_react2.default.createElement(
																															'p',
																															null,
																															_react2.default.createElement(
																																	'b',
																																	null,
																																	'More Information'
																															)
																													)
																											)
																									)
																							)
																					),
																					_react2.default.createElement(
																							'div',
																							{ className: 'col-sm-4' },
																							_react2.default.createElement(
																									'div',
																									{ className: 'doctor-list' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'row' },
																											_react2.default.createElement(
																													'div',
																													{ className: 'col-5' },
																													_react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-2' })
																											),
																											_react2.default.createElement(
																													'div',
																													{ className: 'col-7' },
																													_react2.default.createElement(
																															'h4',
																															null,
																															'Pregnancy Package 1'
																													),
																													_react2.default.createElement(
																															'p',
																															{ className: 'mt-3 mb-4' },
																															'BDT ',
																															_react2.default.createElement('br', null),
																															' 9,800.00'
																													),
																													_react2.default.createElement(
																															'p',
																															null,
																															_react2.default.createElement(
																																	'b',
																																	null,
																																	'More Information'
																															)
																													)
																											)
																									)
																							)
																					),
																					_react2.default.createElement(
																							'div',
																							{ className: 'col-sm-4' },
																							_react2.default.createElement(
																									'div',
																									{ className: 'doctor-list' },
																									_react2.default.createElement(
																											'div',
																											{ className: 'row' },
																											_react2.default.createElement(
																													'div',
																													{ className: 'col-5' },
																													_react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-2' })
																											),
																											_react2.default.createElement(
																													'div',
																													{ className: 'col-7' },
																													_react2.default.createElement(
																															'h4',
																															null,
																															'Pregnancy Package 1'
																													),
																													_react2.default.createElement(
																															'p',
																															{ className: 'mt-3 mb-4' },
																															'BDT ',
																															_react2.default.createElement('br', null),
																															' 9,800.00'
																													),
																													_react2.default.createElement(
																															'p',
																															null,
																															_react2.default.createElement(
																																	'b',
																																	null,
																																	'More Information'
																															)
																													)
																											)
																									)
																							)
																					)
																			)
																	)
															)
													)
											)
									)
							);
					}
			}]);
	
			return PatientPortalTwo;
	}(_react.Component);
	
	exports.default = PatientPortalTwo;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _leftsidebar = __webpack_require__(96);
	
	var _leftsidebar2 = _interopRequireDefault(_leftsidebar);
	
	var _drPhoto = __webpack_require__(129);
	
	var _drPhoto2 = _interopRequireDefault(_drPhoto);
	
	var _lines = __webpack_require__(450);
	
	var _lines2 = _interopRequireDefault(_lines);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	
	
	var GetPatitentAppointment = function GetPatitentAppointment(data) {
		return new Promise(function (resolve, reject) {
			var req = _.scAxios.request('/appointment', {
				method: 'get',
				headers: {
					'Accept': 'application/json'
				},
				params: Object.assign({}, data)
			});
			req.then(function (res) {
				return resolve(res.data);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};
	var getSingleDoctorData = function getSingleDoctorData(id) {
		return new Promise(function (resolve, reject) {
			var req = _.scAxiosAdmin.request('/doctors/getsingledoctors/' + id, {
				method: 'get',
				headers: {
					'Accept': 'application/json',
					'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
				}
			});
			req.then(function (res) {
				return resolve(res.data);
			}).catch(function (err) {
				return reject(err);
			});
		});
	};
	
	var PatientReports = function (_Component) {
		_inherits(PatientReports, _Component);
	
		function PatientReports() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PatientReports);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PatientReports.__proto__ || Object.getPrototypeOf(PatientReports)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
				patient_ID: '',
				patient_age: '',
				patient_gender: '',
				patient_name: '',
				patient_phone: '',
				latest_consultant: [],
				doctor_name: '',
				appointment_date: '',
				department_name: '',
				doctor_id: '',
				doctor_profile: '',
				patient_report_data: [],
				paitent_report_doctor_name: ''
			}, _this.refreshGetPatitentAppointment = function () {
				var data = {
					xpatient: localStorage.getItem(_constants.USER_ID)
				};
				GetPatitentAppointment(data).then(function (res) {
					_this.refreshGetDoctorData(res[0].doctor[0].id);
					_this.setState({
						doctor_name: res[0].doctor[0].name,
						appointment_date: res[0].date,
						department_name: res[0].doctor[0].dept_name,
						doctor_id: res[0].doctor[0].id
					});
				}).catch(function (err) {
					console.log(err);
				});
			}, _this.refreshGetDoctorData = function (id) {
				getSingleDoctorData(id).then(function (res) {
					if (res.status === true) {
						var records = res.data;
						_this.setState({
							doctor_profile: records.doctor_profile
						});
					} else {
						_this.setState({
							doctor_profile: ''
						});
					}
				}).catch(function (err) {
					console.log(err);
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PatientReports, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.refreshGetPatitentAppointment();
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'section',
						{ className: 'dashboard-part' },
						_react2.default.createElement(
							'div',
							{ className: 'main-center-box' },
							_react2.default.createElement(
								'div',
								{ className: 'flex-part' },
								_react2.default.createElement(_reactRouterDom.Route, { component: _leftsidebar2.default }),
								_react2.default.createElement(
									'div',
									{ className: 'dash-body', id: 'dark-version-body' },
									_react2.default.createElement(
										'div',
										{ className: 'dash-text' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-9' },
												_react2.default.createElement(
													'h3',
													null,
													'Welcome Shadab!'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-3' },
												_react2.default.createElement(
													'p',
													{ className: 'Logout-dash log' },
													_react2.default.createElement(
														'a',
														{ href: '#' },
														'Logout '
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp  mt-4' },
										_react2.default.createElement(
											'h2',
											{ style: { "fontWeight": "700" } },
											'Blood Test'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('img', { src: _lines2.default, alt: 'lines' }),
										' ',
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'div',
											{ className: 'bd-example' },
											_react2.default.createElement(
												'div',
												{ className: 'progress' },
												_react2.default.createElement('div', { className: 'progress-bar', role: 'progressbar', 'aria-valuenow': '0', 'aria-valuemin': '0', 'aria-valuemax': '100' })
											),
											_react2.default.createElement(
												'div',
												{ className: 'progress' },
												_react2.default.createElement('div', { className: 'progress-bar', role: 'progressbar', style: { "width": "25%" }, 'aria-valuenow': '25', 'aria-valuemin': '0', 'aria-valuemax': '100' })
											),
											_react2.default.createElement(
												'div',
												{ className: 'progress' },
												_react2.default.createElement('div', { className: 'progress-bar', role: 'progressbar', style: { "width": "50%" }, 'aria-valuenow': '50', 'aria-valuemin': '0', 'aria-valuemax': '100' })
											),
											_react2.default.createElement(
												'div',
												{ className: 'progress' },
												_react2.default.createElement('div', { className: 'progress-bar', role: 'progressbar', style: { "width": "75%" }, 'aria-valuenow': '75', 'aria-valuemin': '0', 'aria-valuemax': '100' })
											),
											_react2.default.createElement(
												'div',
												{ className: 'progress' },
												_react2.default.createElement('div', { className: 'progress-bar', role: 'progressbar', style: { "width": "100%" }, 'aria-valuenow': '100', 'aria-valuemin': '0', 'aria-valuemax': '100' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row mt-4 mb-4' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-2' },
												_react2.default.createElement(
													'h3',
													{ style: { "fontWeight": "700" }, className: 'mt-4 Advise' },
													'Advise'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-10' },
												_react2.default.createElement(
													'p',
													null,
													'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make...'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'dash-text sspp upcoming mt-5' },
										_react2.default.createElement(
											'div',
											{ className: 'row mt-4' },
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4' },
												_react2.default.createElement(
													'h3',
													{ className: 'mb-4' },
													'Appointments ',
													_react2.default.createElement('i', { className: 'fa-solid fa-calendar' }),
													' '
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-3 img-sp' },
														this.state.doctor_profile ? _react2.default.createElement('img', { src: _constants.IMAGE_URL + '/DoctorProfileImg/' + this.state.doctor_profile, alt: this.state.doctor_profile }) : _react2.default.createElement('img', { src: 'https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg', alt: this.state.doctor_profile })
														/*<img src={dr_photo} alt="drphoto"/>*/
	
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-9 prof sp-l-r' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'b',
																null,
																this.state.doctor_name
															)
														),
														_react2.default.createElement(
															'p',
															null,
															this.state.department_name
														),
														_react2.default.createElement(
															'p',
															{ className: 'date-link' },
															'Referred By ',
															_react2.default.createElement(
																'span',
																null,
																this.state.doctor_name
															),
															' on ',
															_react2.default.createElement(
																'a',
																{ href: '#' },
																this.state.appointment_date
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-5 img-sp' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Date ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																this.state.appointment_date
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-7' },
														_react2.default.createElement(
															'p',
															{ className: 'mt-3 Date-time' },
															'Time ',
															_react2.default.createElement('br', null),
															_react2.default.createElement(
																'b',
																null,
																'9:30 am - 10:00 am'
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-sm-12' },
														_react2.default.createElement(
															'button',
															{ className: 'btn-notes mt-4 w-100' },
															'Schedule Followup'
														)
													)
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return PatientReports;
	}(_react.Component);
	
	exports.default = PatientReports;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Modal from './CustomReviewsListModal';
	//import headervideo from '../images/reviewpro/NewEditReviewsPro.mp4';
	
	var forgetpasswordUser = function forgetpasswordUser(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request("/forgetpassword", {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var forgetpassword = function (_React$Component) {
	  _inherits(forgetpassword, _React$Component);
	
	  function forgetpassword() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, forgetpassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = forgetpassword.__proto__ || Object.getPrototypeOf(forgetpassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      email: "",
	      enableLoginBtn: false,
	      user_active: false,
	      fields: {},
	      errors: {},
	      modal: false
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm()) {
	        var fields = {};
	        fields["email"] = "";
	        _this.setState({ fields: fields });
	        var data = {
	          email: _this.state.fields.email
	        };
	        forgetpasswordUser(data).then(function (res) {
	          if (res.status === true) {
	            _reactToastify.toast.success(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          } else {
	            _reactToastify.toast.error(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          }
	        }).catch(function (err) {
	          _reactToastify.toast.error("Error occured", {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        });
	      } else {
	        _reactToastify.toast.error("Please provide Email", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(forgetpassword, [{
	    key: "modalOpen",
	    value: function modalOpen() {
	      this.setState({ modal: true });
	      document.getElementById("demoVideo").autoplay = true;
	      document.getElementById("demoVideo").load();
	    }
	  }, {
	    key: "modalClose",
	    value: function modalClose() {
	      this.setState({ modal: false });
	      document.getElementById("demoVideo").pause();
	    }
	  }, {
	    key: "validateForm",
	    value: function validateForm() {
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!fields["email"]) {
	        formIsValid = false;
	        errors["email"] = "*Please enter your email.";
	      }
	      if (typeof fields["email"] !== "undefined") {
	        var lastAtPos = fields["email"].lastIndexOf("@");
	        var lastDotPos = fields["email"].lastIndexOf(".");
	        if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf("@@") === -1 && lastDotPos > 2 && fields["email"].length - lastDotPos > 2)) {
	          formIsValid = false;
	          errors["email"] = "Email is not valid";
	        }
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          { className: "container " },
	          _react2.default.createElement(
	            "div",
	            { className: "row starbuck_row" },
	            _react2.default.createElement("div", { className: "col-md-6" }),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6" },
	              _react2.default.createElement(
	                "h6",
	                { className: "heading_col font_16" },
	                "Forgot Password"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "txt_col fontweight500 font_12 mb-4" },
	                "Recover your account password here"
	              ),
	              _react2.default.createElement(
	                "form",
	                {
	                  onSubmit: this.handleSubmit,
	                  id: "forgotpwdform",
	                  className: "needs-validation",
	                  novalidate: true
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        className: "form-control input_custom_style",
	                        name: "email",
	                        id: "email",
	                        value: this.state.fields.email,
	                        onChange: this.handleChange,
	                        placeholder: "Email",
	                        required: "",
	                        autocomplete: "off"
	                      }),
	                      _react2.default.createElement(
	                        "span",
	                        { style: alertStyle },
	                        this.state.errors.email
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { type: "submit", className: "blue_btn mt-3" },
	                  " ",
	                  "Reset",
	                  " "
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "txt_col fontweight500 font_12 mt-3" },
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  { href: "/login", className: "blue_anchor_col" },
	                  "Already have an account? Sign In"
	                ),
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  { href: "/signup", className: "blue_anchor_col ml-5" },
	                  "Don't have an account? Sign Up"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return forgetpassword;
	}(_react2.default.Component);
	
	exports.default = forgetpassword;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _services = __webpack_require__(105);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _ = __webpack_require__(2);
	
	var _AboutStarterCards = __webpack_require__(594);
	
	var _AboutStarterCards2 = _interopRequireDefault(_AboutStarterCards);
	
	var _MissionStatementAbout = __webpack_require__(641);
	
	var _MissionStatementAbout2 = _interopRequireDefault(_MissionStatementAbout);
	
	var _AboutDescription = __webpack_require__(672);
	
	var _AboutDescription2 = _interopRequireDefault(_AboutDescription);
	
	var _ResearchAndTraining = __webpack_require__(657);
	
	var _ResearchAndTraining2 = _interopRequireDefault(_ResearchAndTraining);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      videoLInk = _useState2[0],
	      setVideoLInk = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      staticPageData = _useState4[0],
	      setStaticPageData = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    var getHeaderData = function getHeaderData(data) {
	      try {
	        var req = _.scAxiosAdmin.request("/static_services_pages/44", {
	          // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
	          method: "get",
	          headers: {
	            Accept: "application/json"
	            // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            // console.log('your log output',data)
	            // setStaticPageData(data.data.data);
	            setStaticPageData(data.data.components);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getHeaderData();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var getAllBanner = function getAllBanner(data) {
	      try {
	        var req = _.scAxiosAdmin.request("/settings/30", {
	          method: "get"
	        }).then(function (data) {
	          if (data.status === 200) {
	            setVideoLInk(data.data.value);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getAllBanner();
	  }, []);
	
	  var servicesLive = [{ id: "a", service: "Flat Panel Digital Cathlab" }, { id: "b", service: "Modular Operation Theatres" }, {
	    id: "c",
	    service: "Critical Care (ICU/CCU/HDU/CICU/KTICU/NICU/PICU) beds"
	  }, { id: "d", service: "Fresenius 4008S Dialysis Units" }, { id: "e", service: "Multifiltrate CRRT for critically ill patients" }, { id: "f", service: "PET-CT Scan" }, { id: "g", service: "Medical Cyclotron" }, { id: "h", service: "Linear Accelerator" }, { id: "i", service: "Spect-CT" }, { id: "j", service: "500 Slice CT Scanner" }, { id: "k", service: "High Definition MRI System 1.5 T" }, { id: "l", service: "24 hour Emergency Service" }, { id: "m", service: "4D Portable Ultrasound" }, { id: "n", service: "24 hour Ambulance Service" }, { id: "o", service: "24 hour Angioplasty for Heart attack patients" }, { id: "p", service: "Cardiac Surgeries" }, {
	    id: "q",
	    service: "Total Knee and Hip Replacement and Arthroscopy Surgeries"
	  }, { id: "r", service: "Kidney Transplant" }, { id: "s", service: "Critical Brain & Spinal Surgeries" }, { id: "t", service: "Endoscopy Facility" }, { id: "u", service: "Digital Mammography" }, { id: "v", service: "Mobile X-Rays" }, { id: "w", service: "EEG and EMG Machines" }, { id: "x", service: "Central Sterilization supply Facilities (CSSD)" }, { id: "y", service: "CCTV facility for the whole hospital" }, { id: "z", service: "Blood Bank" }];
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "About United Hospital | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Corporate Clients"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#f7f5ef" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      _react2.default.createElement(
	        "div",
	        { "class": "" },
	        _react2.default.createElement(
	          "section",
	          { className: "termscondbody mt-5 pb-5" },
	          _react2.default.createElement(
	            "h2",
	            { className: "text-center", style: { color: "#AF9763" } },
	            "About"
	          ),
	          staticPageData.length > 0 ? staticPageData.map(function (section, index) {
	            if (section.sectionTitle === "About") {
	              return section.value.map(function (card, cardIndex) {
	                return _react2.default.createElement(_AboutStarterCards2.default, {
	                  card: card,
	                  key: cardIndex // Use a unique key for each card
	                  , index: cardIndex
	                });
	              });
	            } else if (section.sectionTitle === "MissionVision") {
	              return _react2.default.createElement(
	                "section",
	                { className: "container mt-2 pb-5" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4" },
	                  section.value.map(function (card, cardIndex) {
	                    return _react2.default.createElement(_MissionStatementAbout2.default, {
	                      card: card,
	                      key: cardIndex // Use a unique key for each card
	                      , index: cardIndex
	                    });
	                  })
	                )
	              );
	            } else if (section.sectionTitle === "ResearchAndTraining") {
	              return _react2.default.createElement(_ResearchAndTraining2.default, { cards: section.value });
	            }
	            return null; // Return null for sections that are not "cardGallery"
	          }) : null,
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "box-of-about border-section mb-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "row g-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-8 col-md-12" },
	                  staticPageData.length > 0 ? staticPageData.map(function (section, index) {
	                    if (section.sectionTitle === "AboutDescription") {
	                      return _react2.default.createElement(_AboutDescription2.default, {
	                        description: section.value
	                      });
	                    }
	                  }) : null,
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "p-3",
	                      style: {
	                        backgroundColor: "#ffffff",
	                        borderRadius: "10px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "p",
	                      { className: "text-justify mb-2" },
	                      "We are committed to (i) Quality, (ii) Effectiveness, (iii) Integration, (iv) Caring for the Community, (v) Caring for our staff and (vi) Research & Training. Our number one priority is to provide our patients with high quality healthcare in a friendly and compassionate environment. Some of the major equipments installed and services/facilities available in the hospital to provide patients with \u201Cbetter than the best\u201D service are :"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row mb-4" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-6" },
	                        _react2.default.createElement(
	                          "ul",
	                          { className: "list-group list-group-flush" },
	                          servicesLive.slice(0, Math.ceil(servicesLive.length / 2)).map(function (item) {
	                            return _react2.default.createElement(
	                              "li",
	                              {
	                                key: item.id,
	                                style: {
	                                  border: "1px solid #AF9763",
	                                  borderRadius: "5px",
	                                  fontSize: "14px"
	                                },
	                                className: "list-group-item bg-transparent mb-2"
	                              },
	                              item.service
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-6" },
	                        _react2.default.createElement(
	                          "ul",
	                          { className: "list-group list-group-flush" },
	                          servicesLive.slice(Math.ceil(servicesLive.length / 2)).map(function (item) {
	                            return _react2.default.createElement(
	                              "li",
	                              {
	                                key: item.id,
	                                style: {
	                                  border: "1px solid #AF9763",
	                                  borderRadius: "5px",
	                                  fontSize: "14px"
	                                },
	                                className: "list-group-item bg-transparent mb-2"
	                              },
	                              item.service
	                            );
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "text-justify" },
	                      "United Hospital has set up a specially designed state-of-art Integrated Hospital Information System to record and monitor all activities and to store patient information in digital format for ease of access and long time storage.",
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement("br", null),
	                      "A major milestone in 2009 has been the permission from the Ministry of Health to start post graduate studies comprising MD in Cardiology and MS in Cardiac Surgery.",
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement("br", null),
	                      "Besides, United Hospital got the permission to start Nursing College for giving degree in B.Sc in Nursing in 2011."
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-lg-4 col-md-12 d-none d-md-block pt-2",
	                    style: {
	                      backgroundColor: "#fff",
	                      borderRadius: "5px"
	                      // width: "100%",
	                      // maxWidth: "370px",
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "text-profile", id: "mobile-part" },
	                    _react2.default.createElement(
	                      "div",
	                      { id: "sidebar-2", className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 sidebar-item " },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            className: "category-list-link open-cat-list",
	                            href: "#"
	                          },
	                          "Select Services"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          {
	                            className: "list-unstyled category-list patients-category-list",
	                            id: "department-list-sidebar"
	                          },
	                          _services2.default && _services2.default.map(function (item) {
	                            return _react2.default.createElement(
	                              _reactRouterDom.Link,
	                              {
	                                to: "/pages/" + item.slug,
	                                style: { textDecoration: "none" }
	                              },
	                              _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                  "a",
	                                  { className: "" },
	                                  item.department_name
	                                )
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "bookarea mt-3 d-none d-md-block mb-3",
	                      style: { position: "sticky", zIndex: "3333", top: 100 }
	                    },
	                    _react2.default.createElement("iframe", {
	                      width: "100%",
	                      height: "315",
	                      src: videoLInk
	                      // src="https://www.youtube.com/embed/qG9oD9qxX6g"
	                      , title: "YouTube video player",
	                      frameborder: "0",
	                      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted",
	                      allowfullscreen: true
	                    }),
	                    _react2.default.createElement(
	                      "h5",
	                      {
	                        className: "text-center p-2 text-light",
	                        style: {
	                          backgroundColor: "#f58220",
	                          marginTop: "-6px"
	                        }
	                      },
	                      "Call Emergency Line",
	                      _react2.default.createElement("br", null),
	                      "10666"
	                    ),
	                    _react2.default.createElement("img", {
	                      src: "https://www.uhlbd.com/resources/images/contact.jpg",
	                      alt: ""
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	  );
	};
	
	exports.default = About;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutStarterCards = function AboutStarterCards(_ref) {
	  var card = _ref.card,
	      index = _ref.index;
	
	  var isEven = index % 2 === 0;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "container py-5" },
	    _react2.default.createElement(
	      "div",
	      { className: "row justify-content-center d-none d-md-flex" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "col-12 col-md-4 d-flex justify-content-between align-items-center " + (isEven ? "order-1" : "order-1")
	        },
	        isEven ? _react2.default.createElement("div", {
	          className: "makeInnerH2Golden d-flex flex-column justify-content-" + (isEven ? "end" : "start") + " align-items-start",
	          dangerouslySetInnerHTML: { __html: card.description }
	        }) : _react2.default.createElement("img", {
	          src: "/assets/images/admin_9.jpg"
	          //   src={card.image}
	          //   alt={card.header}
	          , style: { width: "100%", maxWidth: "400px", borderRadius: "8px" }
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          style: { paddingRight: isEven ? "0px" : "5rem" },
	          className: "col-12 col-md-4 d-flex align-items-center " + (isEven ? "order-2 justify-content-center" : "order-3 justify-content-end")
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "number-box d-flex justify-content-center align-items-center",
	            style: {
	              width: "60px",
	              height: "60px",
	              color: "#FCD8BA",
	              fontSize: "5rem",
	              fontWeight: "bold"
	            }
	          },
	          card.title
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          className: "col-12 col-md-4 d-flex align-items-center " + (isEven ? "order-3 justify-content-end" : "order-2 justify-content-start")
	        },
	        isEven ? _react2.default.createElement("img", {
	          src: "/assets/images/admin_9.jpg"
	          //   src={card.image}
	          //   alt={card.header}
	          , style: { width: "100%", maxWidth: "400px", borderRadius: "8px" }
	        }) : _react2.default.createElement("div", {
	          className: "makeInnerH2Golden d-flex flex-column justify-content-center align-items-start",
	          dangerouslySetInnerHTML: { __html: card.description }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "row d-flex d-md-none gap-4" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "col-12 number-box d-flex align-items-center justify-content-between " + (isEven ? "order-0" : "order-1") + " gap-4"
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "d-flex align-items-center justify-content-center " + (isEven ? "order-0" : "order-1") + " ",
	            style: {
	              width: "60px",
	              height: "60px",
	              color: "#FCD8BA",
	              fontSize: "5rem",
	              fontWeight: "bold"
	            }
	          },
	          card.title
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "" },
	          _react2.default.createElement("img", {
	            src: "/assets/images/admin_9.jpg",
	            style: { width: "100%", maxWidth: "300px", borderRadius: "8px" }
	          })
	        )
	      ),
	      _react2.default.createElement("div", {
	        className: "makeInnerH2Golden col-12 d-flex flex-column " + (isEven ? "align-items-start" : "align-items-end"),
	        dangerouslySetInnerHTML: { __html: card.description }
	      })
	    )
	  );
	};
	
	exports.default = AboutStarterCards;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _atm = __webpack_require__(1139);
	
	var _atm2 = _interopRequireDefault(_atm);
	
	var _reactImageLightbox = __webpack_require__(126);
	
	var _reactImageLightbox2 = _interopRequireDefault(_reactImageLightbox);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Atm = function Atm() {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var boardmembers = [{
	    title: "ATM",
	    dsc: "Dutch Bangla Bank Ltd (DBBL) & Brac Bank Ltd, ATM booths are available at Ground Floor (Lobby) beside OPD Pharmacy of United Hospital."
	  }];
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "ATM | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "ATM"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      _react2.default.createElement(
	        "section",
	        { className: "termscondbody mt-5 pb-5" },
	        _react2.default.createElement(
	          "div",
	          { className: "container p-3" },
	          _react2.default.createElement(
	            "h2",
	            { className: "text-secondary" },
	            "ATM"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row g-3 w-100 mx-auto" },
	            boardmembers.map(function (menubars) {
	              return _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mt-5 bg-light d-flex" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "content w-100 p-3", key: menubars },
	                  _react2.default.createElement(
	                    "p",
	                    { className: "text-secondary" },
	                    menubars.dsc
	                  )
	                )
	              );
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "px-0", onClick: function onClick() {
	                  return setIsOpen(true);
	                } },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "px-0 d-flex justify-content-center",
	                  style: { widows: "100%", height: "80%" }
	                },
	                _react2.default.createElement("img", {
	                  style: { width: "100%", height: "100%" },
	                  src: _atm2.default,
	                  alt: ""
	                })
	              ),
	              isOpen && _react2.default.createElement(_reactImageLightbox2.default, {
	                style: { zIndex: "0" },
	                mainSrc: _atm2.default,
	                onCloseRequest: function onCloseRequest() {
	                  return setIsOpen(false);
	                }
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	  );
	};
	
	exports.default = Atm;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	var _jquery = __webpack_require__(18);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BirthCertificate = function BirthCertificate() {
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      enableBtn = _useState2[0],
	      setEnableBtn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      rawDate = _useState4[0],
	      setRawDate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    newBornId: "",
	    slNo: "",
	    sex: "Male",
	    date: "",
	    relation: "",
	    mothersId: "",
	    mothersName: "",
	    mothersNationality: "",
	    mothersReligion: "",
	    fathersName: "",
	    fathersNationality: "",
	    fathersReligion: "",
	    presentAddress: "",
	    permanentAddress: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      formData = _useState8[0],
	      setFormData = _useState8[1];
	  // const da=formData.date
	  // const newDate= da.toString().split(" ",4)
	  // const newSting=(newDate.toString().split(" "))
	  // console.log(formData)
	
	
	  (0, _react.useEffect)(function () {
	    if (formData.newBornId && formData.slNo && formData.date && formData.relation && formData.mothersId && formData.mothersName && formData.mothersNationality && formData.mothersReligion && formData.fathersName && formData.fathersNationality && formData.fathersReligion && formData.presentAddress && formData.permanentAddress) {
	      setEnableBtn(false);
	    } else {
	      setEnableBtn(true);
	    }
	  }, [formData.newBornId, formData.slNo, formData.date, formData.relation, formData.mothersId, formData.mothersName, formData.mothersNationality, formData.mothersReligion, formData.fathersName, formData.fathersNationality, formData.fathersReligion, formData.presentAddress, formData.permanentAddress]);
	  var sexList = [{ id: "1", label: "MALE", value: "Male" }, { id: "2", label: "FEMALE", value: "Female" }, { id: "3", label: "OTHERS", value: "Others" }];
	  var relation = [{ id: "1", label: "FATHER", value: "Father" }, { id: "2", label: "SPOUSE", value: "Spouse" }, { id: "3", label: "GUARDIAN", value: "Guardian" }];
	
	  // const formatedDate =typeof rawDate==="object"?rawDate.slice(0, 4).join(" "):""
	  (0, _react.useEffect)(function () {
	    if ((typeof rawDate === "undefined" ? "undefined" : _typeof(rawDate)) === "object") {
	      var newObj = new Date(rawDate).toString();
	      var formatedDate = newObj.split(" ").slice(0, 4).join(" ");
	      setFormData(Object.assign({}, formData, {
	        date: formatedDate
	      }));
	    }
	  }, [rawDate]);
	
	  var handleSex = function handleSex(value) {
	    setFormData(Object.assign({}, formData, { sex: value }));
	  };
	  var handleRelation = function handleRelation(value) {
	    setFormData(Object.assign({}, formData, { relationWithDeceased: value }));
	  };
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	
	    var postData = {
	      type: "birth_certificate",
	      form_data: Object.assign({}, formData)
	    };
	    setLoading(true);
	    try {
	      var req = _.scAxiosAdmin.post("/form_submission", postData, {
	        method: "post",
	        headers: {
	          Accept: "application/json",
	          "Content-Type": "application/json"
	        }
	      }).then(function (response) {
	        if (response.status === 201) {
	          _reactToastify.toast.success("Your request is received, you will be notified soon!");
	          setLoading(false);
	        } else {
	          _reactToastify.toast.error("Ops something went wrong!");
	          setLoading(false);
	        }
	      }).catch(function (error) {
	        setLoading(false);
	      });
	    } catch (error) {
	      setLoading(false);
	    }
	  };
	
	  var handleDateChange = function handleDateChange(date) {
	    setRawDate(date);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Birth Certificate | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Birth Certificate "
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/static/media/banner-profile.f160a4c1.jpg",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "prof-dr py-5" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "box-of-about border-part py-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "row gy-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "h3",
	                    {
	                      className: "text-center mb-5",
	                      style: {
	                        color: "#0C807D",
	                        fontWeight: "700"
	                      }
	                    },
	                    "Request for Birth Certificate"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "form",
	                    { action: "", onSubmit: handleSubmit },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "newBornId" },
	                          "Newborn ID No:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "newBornId",
	                          name: "newBornId",
	                          required: true,
	                          value: formData.newBornId,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              newBornId: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "slNo" },
	                          "SL. NO.:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "slNo",
	                          name: "slNo",
	                          value: formData.slNo,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, { slNo: e.target.value }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "sex" },
	                          "Sex:"
	                        ),
	                        _react2.default.createElement(_RadioGroupFunctional2.default, {
	                          name: "sex",
	                          radioOptions: sexList,
	                          defaultSelected: "Male",
	                          onChange: handleSex
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "date" },
	                          "Date of Birth: "
	                        ),
	                        _react2.default.createElement("br", null),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          className: "form-control",
	                          selected: rawDate,
	                          value: rawDate,
	                          onChange: function onChange(date) {
	                            return handleDateChange(date);
	                          },
	                          dateFormat: "dd/MM/yyyy",
	                          placeholderText: "DD/MM/YYYY",
	                          showDateMonthYearPicker: true
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-12" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "relation" },
	                          "Relation of Newborn With Patient:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "relation",
	                          name: "relation",
	                          value: formData.relation,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              relation: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "mothersId" },
	                          "Mother's ID No.:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "mothersId",
	                          name: "mothersId",
	                          value: formData.mothersId,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              mothersId: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "mothersName" },
	                          "Mother's Name:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "mothersName",
	                          name: "mothersName",
	                          value: formData.mothersName,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              mothersName: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "mothersNationality" },
	                          "Nationality:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "mothersNationality",
	                          name: "mothersNationality",
	                          value: formData.mothersNationality,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              mothersNationality: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "mothersReligion" },
	                          "Religion:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "mothersReligion",
	                          name: "mothersReligion",
	                          value: formData.mothersReligion,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              mothersReligion: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "fathersName" },
	                          "Father's Name:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "fathersName",
	                          name: "fathersName",
	                          value: formData.fathersName,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              fathersName: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-3" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "fathersNationality" },
	                          "Nationality:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "fathersNationality",
	                          name: "fathersNationality",
	                          value: formData.fathersNationality,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              fathersNationality: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-3" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "fathersReligion" },
	                          "Religion:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "fathersReligion",
	                          name: "fathersReligion",
	                          value: formData.fathersReligion,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              fathersReligion: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "presentAddress" },
	                          "Present Address:"
	                        ),
	                        _react2.default.createElement("textarea", {
	                          type: "textarea",
	                          className: "form-control",
	                          id: "presentAddress",
	                          name: "presentAddress",
	                          value: formData.presentAddress,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              presentAddress: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "permanentAddress" },
	                          "Permanent Address:"
	                        ),
	                        _react2.default.createElement("textarea", {
	                          type: "textarea",
	                          className: "form-control",
	                          id: "permanentAddress",
	                          name: "permanentAddress",
	                          value: formData.permanentAddress,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              permanentAddress: e.target.value
	                            }));
	                          }
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        className: "buts",
	                        type: "submit",
	                        disabled: enableBtn
	                      },
	                      "Submit"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = BirthCertificate;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactToastify = __webpack_require__(7);
	
	var _services = __webpack_require__(105);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _caseImgMain = __webpack_require__(93);
	
	var _caseImgMain2 = _interopRequireDefault(_caseImgMain);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogDetails = function BlogDetails() {
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchResults = _useState2[0],
	      setSearchResults = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      departmentId = _useState4[0],
	      setDepartmentId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1];
	
	  var route = (0, _reactRouterDom.useParams)();
	
	  var _useState7 = (0, _react.useState)({
	    DoctorID: "",
	    PreferredDate: "",
	    doctorData: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      scheduleReqData = _useState8[0],
	      setScheduleReqData = _useState8[1];
	
	  (0, _react.useEffect)(function () {
	    var getJobOpenings = function getJobOpenings(data) {
	      try {
	        setLoading(true);
	        var req = _.scAxiosAdmin.request("/blogs/" + route.id, {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            setLoading(false);
	            setSearchResults(data.data);
	          }
	        }).catch(function (e) {
	          setLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getJobOpenings();
	  }, []);
	  function formatDate(dateString) {
	    // Create a Date object from the input string
	    var date = new Date(dateString);
	
	    // Get the day of the month
	    var day = String(date.getDate()).padStart(2, "0");
	
	    // Get the month and year
	    var monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
	    var month = monthNames[date.getMonth()];
	    var year = date.getFullYear();
	
	    // Format the year and month
	    var yearandmonth = month + " " + year;
	
	    // Return the formatted object
	    return { day: day, yearandmonth: yearandmonth };
	  }
	  // console.log("your log output", formatDate(searchResults.created_at).day);
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: searchResults.title + " | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Death Certificate"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/assets/images/banner-case-study.png",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "container mt-5 mb-5" },
	        _react2.default.createElement("img", {
	          style: { width: "100%", objectFit: "cover" },
	          src: "" + _constants.IMAGE_URL + searchResults.featured_image,
	          alt: ""
	        })
	      ),
	      _react2.default.createElement(
	        "section",
	        { "class": "container" },
	        _react2.default.createElement(
	          "div",
	          { "class": "row g-0 mb-5" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-md-12 d-flex flex-column justify-content-between" },
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex flex-column flex-lg-row pt-3 pb-3 justify-content-between w-100" },
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex flex-column" },
	                _react2.default.createElement(
	                  "h3",
	                  {
	                    className: "",
	                    style: {
	                      fontSize: "22px",
	                      textTransform: "capitalize",
	                      color: "#0C807D"
	                    }
	                  },
	                  searchResults.title
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    // width: "20%",
	                    borderRadius: "5px",
	                    backgroundColor: "#E7F2F2"
	                  },
	                  className: "applyDate d-flex flex-column align-items-center justify-content-between"
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "" },
	                  _react2.default.createElement(
	                    "h2",
	                    { style: { color: "#0C807D" } },
	                    searchResults ? formatDate(searchResults.created_at).day : ""
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "w-100  d-flex align-items-center justify-content-center",
	                    style: {
	                      backgroundColor: "#0C807D",
	                      borderBottomLeftRadius: "5px",
	                      borderBottomRightRadius: "5px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "h6",
	                    { className: "mb-0 py-2", style: { color: "#ffffff" } },
	                    searchResults ? formatDate(searchResults.created_at).yearandmonth : ""
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "mt-5" },
	              _react2.default.createElement(
	                "p",
	                { "class": "fw-bold" },
	                searchResults.description
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex flex-column justify-content-md-center align-items-center p-5" },
	          _react2.default.createElement("div", { className: "d-flex" }),
	          _react2.default.createElement("div", { className: "d-flex" })
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = BlogDetails;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _chart = __webpack_require__(100);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BloodPressureChart = function BloodPressureChart(_ref) {
	  var data = _ref.data;
	
	  var chartRef = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    var ctx = chartRef.current.getContext('2d');
	    var myChart = new _chart2.default(ctx, {
	      type: 'line',
	      data: {
	        labels: data.labels,
	        datasets: [{
	          label: 'Systolic Pressure',
	          borderColor: '#BB2525',
	          data: data.datasets[0].data
	        }, {
	          label: 'Diastolic Pressure',
	          borderColor: '#12A150',
	          data: data.datasets[1].data
	        }]
	      }
	    });
	
	    return function () {
	      myChart.destroy(); // Cleanup on component unmount
	    };
	  }, [data]);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('canvas', { ref: chartRef, width: '100%' })
	  );
	};
	
	exports.default = BloodPressureChart;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _constants = __webpack_require__(3);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _ = __webpack_require__(2);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var BoardMembers = function BoardMembers() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchdata = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    fetchData(); // Initial data fetch
	  }, []);
	
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/boardmembers_type/board_member");
	
	            case 3:
	              response = _context.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                setFatchdata(response.data);
	                // setLoading(false);
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Board Members | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Board Members"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      _react2.default.createElement(
	        "section",
	        { className: "termscondbody pb-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "container p-3" },
	          _react2.default.createElement(
	            "h3",
	            {
	              className: "text-center pb-4 text-center pt-3",
	              style: {
	                color: "#0C807D",
	                fontWeight: "700",
	                width: "100%"
	              }
	            },
	            "OUR BOARD MEMBERS"
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "row w-100 mx-auto justify-content-center justify-content-md-start" },
	            fatchdata.map(function (menubars) {
	              return _react2.default.createElement(
	                "div",
	                { "class": "col-12 col-sm-5 col-md-4 col-lg-3 mb-5" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "card h-100 w-100 py-4 d-flex flex-column justify-content-center align-items-center",
	                    style: {
	                      // backgroundImage:
	                      //   "url(/assets/images/opearational-team-bg.png",
	                      // backgroundPosition: "center",
	                      backgroundSize: "cover",
	                      backgroundColor: "#fff",
	                      borderRadius: "20px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "" },
	                    _react2.default.createElement("img", {
	                      style: { borderRadius: "5px" },
	                      src: _constants.IMAGE_URL + "BoardMember/" + menubars.image,
	                      alt: "",
	                      width: 150
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "content w-75 mx-2 pt-3", key: menubars },
	                    _react2.default.createElement(
	                      "p",
	                      { className: "text-center fw-bolder" },
	                      menubars.name
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        className: "text-center mt-3",
	                        style: { color: "#AF9763" }
	                      },
	                      menubars.designation
	                    )
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	  );
	};
	
	exports.default = BoardMembers;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	__webpack_require__(8);
	
	var _Loading_icon = __webpack_require__(56);
	
	var _Loading_icon2 = _interopRequireDefault(_Loading_icon);
	
	var _ConfirmAppointmentAndRequestAppointment = __webpack_require__(143);
	
	var _ConfirmAppointmentAndRequestAppointment2 = _interopRequireDefault(_ConfirmAppointmentAndRequestAppointment);
	
	var _ConfirmAppointmentAndRequestAppointmentParticularDoctor = __webpack_require__(207);
	
	var _ConfirmAppointmentAndRequestAppointmentParticularDoctor2 = _interopRequireDefault(_ConfirmAppointmentAndRequestAppointmentParticularDoctor);
	
	var _ConfirmAppointmentAndRequestAppointmentTestimonialParticularDoctor = __webpack_require__(612);
	
	var _ConfirmAppointmentAndRequestAppointmentTestimonialParticularDoctor2 = _interopRequireDefault(_ConfirmAppointmentAndRequestAppointmentTestimonialParticularDoctor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookAppointmentTestimoniaDoctorPopUp = function BookAppointmentTestimoniaDoctorPopUp(_ref) {
	  var doctorDataPorp = _ref.doctorData,
	      setSelectedDoctor = _ref.setSelectedDoctor;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchResults = _useState2[0],
	      setSearchResults = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      departmentId = _useState4[0],
	      setDepartmentId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    DoctorID: "",
	    PreferredDate: "",
	    doctorData: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      scheduleReqData = _useState8[0],
	      setScheduleReqData = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    selectedDepartment: "all",
	    searchedText: ""
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      formData = _useState10[0],
	      setFormData = _useState10[1];
	
	  var formatedDoc = null;
	  if (doctorDataPorp !== null && doctorDataPorp.doctor_name !== undefined) {
	    formatedDoc = doctorDataPorp.doctor_name.toLowerCase();
	  }
	
	  // const formatedDoc = null;
	  var alertStyle = {
	    color: "red"
	  };
	
	  var inputStyles = {
	    borderRadius: "10px",
	    background: "#fff",
	    borderRight: "solid 1px #fff",
	    border: "solid 2px #6e6e6ed0",
	    padding: "15px 15px",
	    fontSize: "16px",
	    color: "#000",
	    width: "100%"
	  };
	
	  (0, _react.useEffect)(function () {
	    if (doctorDataPorp) {
	      setScheduleReqData(Object.assign({}, scheduleReqData, {
	        DoctorID: doctorDataPorp.id,
	        doctorData: doctorDataPorp
	      }));
	    }
	  }, [doctorDataPorp]);
	
	  (0, _react.useEffect)(function () {
	    var getSearchDoctors = function getSearchDoctors(data) {
	      try {
	        if (formData.searchedText) {
	          setLoading(true);
	          var req = _.scAxiosAdmin.request("/search/find_a_doctor", {
	            method: "get",
	            headers: {
	              Accept: "application/json",
	              Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	            },
	            params: {
	              keyword: formData.searchedText ? formData.searchedText : formatedDoc ? formatedDoc : "",
	              deparment: formData.selectedDepartment
	            }
	          }).then(function (data) {
	            if (data.status === 200) {
	              setLoading(false);
	              setSearchResults(data.data.doctors);
	            }
	          }).catch(function (e) {
	            setLoading(false);
	            console.log("your log output", e);
	          });
	        }
	      } catch (error) {}
	    };
	    getSearchDoctors();
	  }, [formData.searchedText, doctorDataPorp]);
	
	  (0, _react.useEffect)(function () {
	    setDepartmentId(formData.selectedDepartment);
	  }, [formData.selectedDepartment]);
	  (0, _react.useEffect)(function () {
	    if (formData.searchedText != "") {
	      setSearchResults(searchResults);
	    } else if (doctorDataPorp !== null && doctorDataPorp != undefined) {
	      setSearchResults(doctorDataPorp);
	    }
	  }, [doctorDataPorp, formData.searchedText]);
	
	  var handleSubmit = function handleSubmit(event, props) {
	    event.preventDefault();
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        "class": "offcanvas offcanvas-start bookAppointPopup",
	        "data-bs-scroll": "true",
	        tabindex: "-1",
	        id: "BookAppointmentTestimoniaDoctorPopUp",
	        "aria-labelledby": "offcanvasWithBothOptionsLabel"
	      },
	      _react2.default.createElement(
	        "div",
	        { "class": "offcanvas-header" },
	        _react2.default.createElement("h5", { "class": "offcanvas-title", id: "offcanvasWithBothOptionsLabel" }),
	        _react2.default.createElement("button", {
	          type: "button",
	          "class": "btn-close text-reset",
	          "data-bs-dismiss": "offcanvas",
	          "aria-label": "Close",
	          onClick: function onClick() {
	            setSelectedDoctor(null);
	          }
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { "class": "offcanvas-body" },
	        _react2.default.createElement(
	          "div",
	          { className: "left-offcanvas" },
	          _react2.default.createElement(
	            "div",
	            { className: "offcan-top-mar" },
	            _react2.default.createElement(
	              "h4",
	              { style: { color: "#af9763" } },
	              "Book Appointment"
	            )
	          ),
	          _react2.default.createElement(
	            "form",
	            {
	              onSubmit: handleSubmit,
	              className: "needs-validation",
	              noValidate: true
	            },
	            _react2.default.createElement("input", {
	              type: "text",
	              style: inputStyles,
	              className: "custom-form-control",
	              placeholder: "Search With Doctors Name...",
	              name: "searchTerm",
	              id: "searchTerm",
	              value: formData.searchedText,
	              onChange: function onChange(e) {
	                return setFormData(Object.assign({}, formData, { searchedText: e.target.value }));
	              },
	              required: true,
	              autoComplete: "off"
	              // style={input_field_css}
	            }),
	            _react2.default.createElement("span", { style: alertStyle }),
	            _react2.default.createElement(
	              "div",
	              { className: "row mt-3" },
	              _react2.default.createElement("span", { style: alertStyle }),
	              searchResults && searchResults.length > 0 ? searchResults.slice(0, 10).map(function (search_doctor) {
	                return _react2.default.createElement(
	                  "div",
	                  { className: "col-12 sp-0-0 mb-3", key: search_doctor.id },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "doctor-list" },
	                    _react2.default.createElement("input", {
	                      type: "radio",
	                      className: "doctor_id",
	                      name: "doctor_id",
	                      value: search_doctor.id,
	                      onChange: function onChange() {
	                        return setScheduleReqData(Object.assign({}, scheduleReqData, {
	                          DoctorID: search_doctor.id,
	                          doctorData: search_doctor
	                        }));
	                      },
	                      doctorName: search_doctor.doctor_name,
	                      deptid: search_doctor.dept_id
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-3", style: { paddingLeft: "0px" } },
	                        search_doctor.doctor_profile ? _react2.default.createElement("img", {
	                          src: _constants.IMAGE_URL + "/DoctorProfileImg/" + search_doctor.doctor_profile,
	                          alt: "doctor profile"
	                        }) :
	                        /*<img src={doc} alt="doc"/>*/
	                        _react2.default.createElement("img", {
	                          src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                          alt: "doc"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-9 mt-2" },
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          search_doctor.doctor_name
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          search_doctor.degree !== "" ? search_doctor.degree : "Endocrinology & Metabolism) MD (Endocrinology & Metabolism)"
	                        )
	                      )
	                    )
	                  )
	                );
	              }) : searchResults ? _react2.default.createElement(
	                "div",
	                { className: "col-12 sp-0-0 mb-3", key: searchResults.id },
	                _react2.default.createElement(
	                  "div",
	                  { className: "doctor-list" },
	                  _react2.default.createElement("input", {
	                    type: "radio",
	                    className: "doctor_id",
	                    name: "doctor_id",
	                    value: searchResults.id,
	                    onChange: function onChange() {
	                      return setScheduleReqData(Object.assign({}, scheduleReqData, {
	                        DoctorID: searchResults.id,
	                        doctorData: searchResults
	                      }));
	                    },
	                    doctorName: searchResults.doctor_name,
	                    deptid: searchResults.dept_id
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-3", style: { paddingLeft: "0px" } },
	                      searchResults.doctor_profile ? _react2.default.createElement("img", {
	                        src: _constants.IMAGE_URL + "/DoctorProfileImg/" + searchResults.doctor_profile,
	                        alt: "doctor profile"
	                      }) :
	                      /*<img src={doc} alt="doc"/>*/
	                      _react2.default.createElement("img", {
	                        src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                        alt: "doc"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-9 mt-2" },
	                      _react2.default.createElement(
	                        "h5",
	                        null,
	                        searchResults.doctor_name
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        searchResults.degree !== "" ? searchResults.degree : "Endocrinology & Metabolism) MD (Endocrinology & Metabolism)"
	                      )
	                    )
	                  )
	                )
	              ) : _react2.default.createElement(
	                "div",
	                { className: "col-12 sp-0-0 mb-3" },
	                loading ? _react2.default.createElement("img", { src: _Loading_icon2.default, alt: "Loading" }) : _react2.default.createElement(
	                  "p",
	                  { style: { color: "red" } },
	                  "No results found!"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row mt-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-6" },
	                _react2.default.createElement("input", {
	                  type: "date",
	                  id: "schedule_date",
	                  name: "schedule_date",
	                  className: "customDatePicker",
	                  onChange: function onChange(e) {
	                    return setScheduleReqData(Object.assign({}, scheduleReqData, {
	                      PreferredDate: e.target.value
	                    }));
	                  },
	                  placeholder: "DD-MM-YYYY",
	                  defaultValue: localStorage.getItem(_constants.SCHEDULE_DATE),
	                  required: true
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    variant: "primary",
	                    "data-bs-dismiss": "offcanvas",
	                    "aria-label": "Close",
	                    "data-bs-toggle": "offcanvas",
	                    "data-bs-target": "#ConfirmAppointmentAndRequestAppointmentTestimonialParticularDoctor",
	                    "aria-controls": "ConfirmAppointmentAndRequestAppointmentTestimonialParticularDoctor",
	                    style: {
	                      backgroundColor: !scheduleReqData.PreferredDate ? "" : "rgb(246, 130, 31)"
	                    },
	                    type: "submit",
	                    id: "Schedule",
	                    className: "btn-links",
	                    disabled: !scheduleReqData.PreferredDate ? true : false
	                  },
	                  "Check Schedule"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ConfirmAppointmentAndRequestAppointmentTestimonialParticularDoctor2.default, {
	      scheduleReqData: scheduleReqData
	    })
	  );
	};
	
	exports.default = BookAppointmentTestimoniaDoctorPopUp;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BriefHistory = function BriefHistory() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      staticPageData = _useState2[0],
	      setStaticPageData = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var getHeaderData = function getHeaderData(data) {
	      try {
	        var req = _.scAxiosAdmin.request("/static_services_pages/36", {
	          // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
	          method: "get",
	          headers: {
	            Accept: "application/json"
	            // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            // console.log('your log output',data)
	            // setStaticPageData(data.data.data);
	            setStaticPageData(data.data.components);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getHeaderData();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Brief History | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Emergency"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { className: "", id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      staticPageData.length > 0 ? staticPageData.map(function (section, index) {
	        if (section.type === "description") {
	          return _react2.default.createElement(
	            "section",
	            { className: "termscondbody py-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "container", id: "giveMargin" },
	              _react2.default.createElement(
	                "div",
	                { className: "w-100 d-flex justify-content-center align-items-center flex-column" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "flex",
	                      justifyContent: "flex-start",
	                      alignItems: "flex-start",
	                      flexDirection: "column"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "h3",
	                    {
	                      className: "text-center",
	                      style: {
	                        color: "#0C807D",
	                        fontSize: "28px",
	                        fontWeight: "500"
	                      }
	                    },
	                    section.value.title
	                  )
	                )
	              ),
	              _react2.default.createElement("div", {
	                className: "content mt-3 w-100 ",
	                dangerouslySetInnerHTML: {
	                  __html: section.value.content
	                }
	              })
	            )
	          );
	        }
	      }) : ""
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	  );
	};
	
	exports.default = BriefHistory;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	var _jquery = __webpack_require__(18);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _cafeteria = __webpack_require__(861);
	
	var _cafeteria2 = _interopRequireDefault(_cafeteria);
	
	var _reactImageLightbox = __webpack_require__(126);
	
	var _reactImageLightbox2 = _interopRequireDefault(_reactImageLightbox);
	
	var _menu = __webpack_require__(863);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cafeteria = function Cafeteria() {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      selectedImage = _useState4[0],
	      setSelectedImage = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      searchTerm = _useState6[0],
	      setSearchTerm = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(1),
	      _useState8 = _slicedToArray(_useState7, 2),
	      currentPage = _useState8[0],
	      setCurrentPage = _useState8[1];
	
	  var itemsPerPage = 2; // number of items to display per page
	  var maxItems = 10;
	
	  // Function to handle search term change
	  var handleSearchTermChange = function handleSearchTermChange(event) {
	    setSearchTerm(event.target.value);
	    setCurrentPage(1); // reset current page when search term changes
	  };
	
	  // Filter the data based on the search term
	  var filteredData = Object.entries(_menu2.default).reduce(function (result, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        key = _ref2[0],
	        value = _ref2[1];
	
	    var filteredItems = value.filter(function (item) {
	      return item["Item Name"].toLowerCase().includes(searchTerm.toLowerCase());
	    });
	
	    if (filteredItems.length > 0) {
	      result.push({ key: key, items: filteredItems });
	    }
	
	    return result;
	  }, []);
	
	  // Get the current items to display on the current page
	  var indexOfLastItem = currentPage * itemsPerPage;
	  var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  var slicedData = filteredData.slice(0, maxItems); // limit the data to 10 items
	  var currentItems = slicedData.slice(indexOfFirstItem, indexOfLastItem);
	
	  // Function to handle page change
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setCurrentPage(pageNumber);
	  };
	  var handleClickOnImage = function handleClickOnImage(data) {
	    setIsOpen(true);
	    setSelectedImage(data);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Cafeteria | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Cafeteria"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      _react2.default.createElement(
	        "section",
	        { className: "termscondbody mt-5 pb-3" },
	        _react2.default.createElement(
	          "div",
	          { className: "container p-3" },
	          _react2.default.createElement(
	            "h2",
	            { className: "text-secondary mb-3" },
	            "Cafeteria"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "text-secondary" },
	            "Guest Cafeteria of United Hospital is open 24 hours every day. The Cafeteria offers hygienic and delicious meal options, including vegetarian choices, local and continental cuisine, salads, snacks, grills, ice-creams, milk shake, and fresh juices to retain our patients & guests a healthy mind. Breakfast, Lunch and Dinner including all the food items are made by In-house."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container p-3" },
	          _react2.default.createElement(
	            "h2",
	            { className: "text-secondary mb-5" },
	            "Gallery"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row w-100 mx-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "row g-4 pb-4",
	                  style: { backgroundColor: "#ffffff" }
	                },
	                _cafeteria2.default.map(function (data, index) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-12 col-md-4" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        key: index,
	                        className: "roomContainer",
	                        onClick: function onClick() {
	                          return handleClickOnImage(data.file);
	                        }
	                      },
	                      _react2.default.createElement(
	                        "a",
	                        { className: "px-0 d-flex justify-content-center" },
	                        _react2.default.createElement("img", {
	                          style: { width: "30vw", height: "30vh" },
	                          className: "border",
	                          src: __webpack_require__(459)("./" + data.file + ".jpg"),
	                          alt: ""
	                        })
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            isOpen && _react2.default.createElement(_reactImageLightbox2.default, {
	              style: { zIndex: "0" },
	              mainSrc: __webpack_require__(459)("./" + selectedImage + ".jpg"),
	              onCloseRequest: function onCloseRequest() {
	                return setIsOpen(false);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "h2",
	            { className: "text-secondary pt-5" },
	            "Food Menu"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pt-3" },
	            _react2.default.createElement(
	              "form",
	              {
	                className: "d-flex mx-auto mb-3 align-items-center form-control",
	                role: "search"
	              },
	              _react2.default.createElement("input", {
	                className: "form-control me-2 ",
	                type: "search",
	                placeholder: "Search",
	                "aria-label": "Search",
	                value: searchTerm,
	                onChange: handleSearchTermChange,
	                style: { background: "transparent", border: "none" }
	              }),
	              _react2.default.createElement(
	                "svg",
	                {
	                  xmlns: "http://www.w3.org/2000/svg",
	                  width: "16",
	                  height: "16",
	                  fill: "currentColor",
	                  className: "bi bi-search",
	                  viewBox: "0 0 16 16"
	                },
	                _react2.default.createElement("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
	              )
	            ),
	            _react2.default.createElement(
	              "table",
	              { className: "table table-striped table-hover mx-auto " },
	              _react2.default.createElement(
	                "tbody",
	                null,
	                currentItems.map(function (group, index) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    { key: index },
	                    _react2.default.createElement(
	                      "tr",
	                      { className: "table-dark" },
	                      _react2.default.createElement(
	                        "th",
	                        { colSpan: group.items.length },
	                        group.key
	                      )
	                    ),
	                    group.items.map(function (item, subIndex) {
	                      return _react2.default.createElement(
	                        "tr",
	                        { key: subIndex },
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          item["Item Name"]
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          item["Price (Taka)"]
	                        )
	                      );
	                    })
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(_reactJsPagination2.default, {
	              activePage: currentPage,
	              itemsCountPerPage: itemsPerPage,
	              totalItemsCount: filteredData.length,
	              pageRangeDisplayed: 10,
	              onChange: handlePageChange
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Cafeteria;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	var _reactSlick = __webpack_require__(63);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _career_picture = __webpack_require__(1162);
	
	var _career_picture2 = _interopRequireDefault(_career_picture);
	
	var _caseImgMain = __webpack_require__(93);
	
	var _caseImgMain2 = _interopRequireDefault(_caseImgMain);
	
	var _newsEventsModule = __webpack_require__(87);
	
	var _newsEventsModule2 = _interopRequireDefault(_newsEventsModule);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	var _demodataForCareer = __webpack_require__(862);
	
	var _demodataForCareer2 = _interopRequireDefault(_demodataForCareer);
	
	var _new = __webpack_require__(136);
	
	var _new2 = _interopRequireDefault(_new);
	
	var _JobOpeningCard = __webpack_require__(635);
	
	var _JobOpeningCard2 = _interopRequireDefault(_JobOpeningCard);
	
	var _JobApplicationForm = __webpack_require__(634);
	
	var _JobApplicationForm2 = _interopRequireDefault(_JobApplicationForm);
	
	var _ = __webpack_require__(2);
	
	var _CareerSlider = __webpack_require__(606);
	
	var _CareerSlider2 = _interopRequireDefault(_CareerSlider);
	
	var _CareerBlogs = __webpack_require__(604);
	
	var _CareerBlogs2 = _interopRequireDefault(_CareerBlogs);
	
	var _DescriptionSection = __webpack_require__(621);
	
	var _DescriptionSection2 = _interopRequireDefault(_DescriptionSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Career = function Career() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      staticPageData = _useState2[0],
	      setStaticPageData = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var getHeaderData = function getHeaderData(data) {
	      try {
	        var req = _.scAxiosAdmin.request("/static_services_pages/41", {
	          // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
	          method: "get",
	          headers: {
	            Accept: "application/json"
	            // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            // console.log('your log output',data)
	            // setStaticPageData(data.data.data);
	            setStaticPageData(data.data.components);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getHeaderData();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Career | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Career"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      {
	        id: "giveMargin",
	        className: "pb-3",
	        style: { backgroundColor: "#F7F5EF" }
	      },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/assets/images/banner-case-study.png",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      staticPageData ? staticPageData.map(function (section, index) {
	        if (section.type === "description") {
	          return _react2.default.createElement(_DescriptionSection2.default, { section: section });
	        } else if (section.type === "cardGallery" && section.sectionTitle === "WHY WORK WITH US?") {
	          return _react2.default.createElement(_CareerSlider2.default, { section: section });
	        } else if (section.type === "cardGallery" && section.sectionTitle === "OUR BLOG") {
	          return _react2.default.createElement(_CareerBlogs2.default, { section: section });
	        } else if (section.type === "cardGallery" && section.sectionTitle === "JOB OPENINGS") {
	          return _react2.default.createElement(_JobOpeningCard2.default, { section: section });
	        } else return "";
	      }) : "",
	      _react2.default.createElement(_JobApplicationForm2.default, null)
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Career;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CareerBlogs = function CareerBlogs(_ref) {
	  var section = _ref.section;
	
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      selectedBlog = _useState2[0],
	      setSelectedBlog = _useState2[1];
	
	  return _react2.default.createElement(
	    "section",
	    { className: "container mt-4 mb-4" },
	    _react2.default.createElement(
	      "h3",
	      {
	        style: {
	          color: "#AF9763",
	          fontWeight: "500"
	        },
	        className: "text-center mb-4"
	      },
	      section.sectionTitle
	    ),
	    _react2.default.createElement(
	      "div",
	      { "class": "row row-cols-1 row-cols-md-4 g-4" },
	      section.value.length > 0 ? section.value.slice(0, 4).map(function (blog, index) {
	        return _react2.default.createElement(
	          "div",
	          { "class": "col" },
	          _react2.default.createElement(
	            "div",
	            { "class": "card h-100" },
	            _react2.default.createElement("img", {
	              style: { maxHeight: "45%" },
	              src: "" + _constants.IMAGE_URL + blog.media[0],
	              "class": "card-img-top",
	              alt: "..."
	            }),
	            _react2.default.createElement(
	              "div",
	              { "class": "card-body" },
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex justify-content-between align-items-end" },
	                _react2.default.createElement(
	                  "h5",
	                  {
	                    "class": "card-title mb-0",
	                    style: {
	                      color: "#F6821F",
	                      fontSize: "12px",
	                      fontWeight: "700",
	                      letterSpacing: "2px",
	                      textTransform: "uppercase",
	                      width: "55%"
	                    }
	                  },
	                  blog.title.split(" ").slice(0, 2).join(" ")
	                ),
	                _react2.default.createElement(
	                  "small",
	                  { className: "text-muted" },
	                  "2 hours ago"
	                )
	              ),
	              _react2.default.createElement("div", {
	                className: "mt-4",
	                dangerouslySetInnerHTML: {
	                  __html: blog.description.split(" ").slice(0, 10).join(" ")
	                }
	              }),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "d-flex justify-content-center align-items-center w-50 rounded p-2 mt-3",
	                  style: {
	                    textDecoration: "none",
	                    backgroundColor: "#AF9763"
	                  },
	                  type: "button",
	                  onClick: function onClick() {
	                    return setSelectedBlog(blog);
	                  },
	                  "data-bs-toggle": "modal",
	                  "data-bs-target": "#blogModal"
	                },
	                _react2.default.createElement(
	                  "p",
	                  {
	                    style: {
	                      color: "#ffffff",
	                      fontSize: "14px",
	                      fontWeight: "500",
	                      textAlign: "center"
	                    }
	                  },
	                  "Read more"
	                )
	              )
	            )
	          )
	        );
	      }) : "",
	      _react2.default.createElement(
	        "div",
	        {
	          "class": "modal fade",
	          id: "blogModal",
	          "data-bs-backdrop": "static",
	          "data-bs-keyboard": "false",
	          tabindex: "-1",
	          "aria-labelledby": "staticBackdropLabel",
	          "aria-hidden": "true"
	        },
	        _react2.default.createElement(
	          "div",
	          { "class": "modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" },
	          _react2.default.createElement(
	            "div",
	            {
	              "class": "jobModalContent modal-content mt-5",
	              style: { maxHeight: _reactDeviceDetect.isBrowser ? "700px" : "500px" }
	            },
	            _react2.default.createElement(
	              "div",
	              { "class": "modal-header" },
	              _react2.default.createElement(
	                "h5",
	                { "class": "modal-title", id: "staticBackdropLabel" },
	                selectedBlog.title
	              ),
	              _react2.default.createElement("button", {
	                type: "button",
	                "class": "btn-close",
	                "data-bs-dismiss": "modal",
	                "aria-label": "Close"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "modal-body d-flex flex-column justify-content-between align-items-start" },
	              _react2.default.createElement(
	                "div",
	                { className: "w-100 mb-4" },
	                selectedBlog.media ? _react2.default.createElement("img", {
	                  src: "" + _constants.IMAGE_URL + selectedBlog.media[0],
	                  alt: "",
	                  className: "img-fluid w-100 rounded",
	                  style: {
	                    maxHeight: "250px",
	                    objectFit: "cover",
	                    objectPosition: "center"
	                  }
	                }) : _react2.default.createElement("img", {
	                  src: "/assets/images/united_logo.png",
	                  alt: "",
	                  className: "img-fluid w-100 rounded",
	                  style: {
	                    maxHeight: "250px",
	                    objectFit: "cover",
	                    objectPosition: "center"
	                  }
	                })
	              ),
	              _react2.default.createElement("div", {
	                className: "",
	                dangerouslySetInnerHTML: { __html: selectedBlog.description }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "modal-footer" },
	              _react2.default.createElement(
	                "button",
	                {
	                  "class": "px-3 py-2",
	                  type: "button",
	                  "data-bs-dismiss": "modal",
	                  style: {
	                    borderRadius: "5px",
	                    backgroundColor: "#AF9763",
	                    border: "none",
	                    color: "white"
	                  }
	                },
	                "Close"
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = CareerBlogs;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _phoneFlip = __webpack_require__(455);
	
	var _phoneFlip2 = _interopRequireDefault(_phoneFlip);
	
	var _caseImgMain = __webpack_require__(93);
	
	var _caseImgMain2 = _interopRequireDefault(_caseImgMain);
	
	var _unitedLogo = __webpack_require__(457);
	
	var _unitedLogo2 = _interopRequireDefault(_unitedLogo);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactToastify = __webpack_require__(7);
	
	var _reactRouterDom2 = __webpack_require__(38);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CareerInside = function CareerInside() {
	  var data = [{
	    title: "VACANCY",
	    points: ["2"]
	  }, {
	    title: "JOB RESPONSIBILITIES",
	    points: ["Provide treatment of indoor and outdoor patient independently.Treat acute and chronic illnesses and provides preventive care and health education to patients."]
	  }, {
	    title: "EMPLOYMENT STATUS",
	    points: ["Part-time, Contractual"]
	  }, {
	    title: "EDUCATIONAL REQUIREMENTS",
	    points: ["2Bachelor of Medicine and Bachelor of Surgery(MBBS), Post Graduate Diploma (PGD)", "Preferred Professional Certification: Cretificate courses on health and health education,FCGP, PGT, CCD etc", "Training/Trade Course: Post graduate diploma"]
	  }, {
	    title: "EXPERIENCE REQUIREMENTS",
	    points: ["1 to 5 year(s)", "The applicants should have experience in the following area(s): Doctor/ Consultant"]
	  }, {
	    title: "ADDITIONAL REQUIREMENTS",
	    points: ["Age 28 to 60 years", "Both males and females are allowed to apply"]
	  }, {
	    title: "Job Location",
	    points: ["Gulshan-2, Dhaka, Bangladesh."]
	  }, {
	    title: "Salary",
	    points: ["Salary"]
	  }, {
	    title: "Compensation & Other Benefits",
	    points: ["Over time allowance"]
	  }];
	
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchResults = _useState2[0],
	      setSearchResults = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      departmentId = _useState4[0],
	      setDepartmentId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1];
	
	  var route = (0, _reactRouterDom.useParams)();
	
	  var _useState7 = (0, _react.useState)({
	    DoctorID: "",
	    PreferredDate: "",
	    doctorData: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      scheduleReqData = _useState8[0],
	      setScheduleReqData = _useState8[1];
	
	  (0, _react.useEffect)(function () {
	    var getJobOpenings = function getJobOpenings(data) {
	      try {
	        setLoading(true);
	        var req = _.scAxiosAdmin.request("/jobs/" + route.id, {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            setLoading(false);
	            setSearchResults(data.data);
	          }
	        }).catch(function (e) {
	          setLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getJobOpenings();
	  }, []);
	
	  function formatDates(startDate, endDate) {
	    function formatDate(dateStr) {
	      var date = new Date(dateStr);
	
	      var day = date.getDate();
	      var year = date.getFullYear();
	
	      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	      var month = monthNames[date.getMonth()];
	
	      return {
	        date: day,
	        year: month + " " + year
	      };
	    }
	
	    function formatDeadlineDate(dateStr) {
	      var date = new Date(dateStr);
	
	      var day = date.getDate().toString().padStart(2, "0");
	      var month = (date.getMonth() + 1).toString().padStart(2, "0");
	      var year = date.getFullYear();
	
	      return day + "/" + month + "/" + year;
	    }
	
	    var start = formatDate(startDate);
	    var end = formatDate(endDate);
	
	    var deadline = formatDeadlineDate(startDate) + " - " + formatDeadlineDate(endDate);
	
	    return {
	      start: start,
	      end: end,
	      deadline: deadline
	    };
	  }
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: searchResults.position_title + " | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Death Certificate"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/assets/images/banner-case-study.png",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex flex-column justify-content-between align-items-center p-4" },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: "flex",
	                justifyContent: "center",
	                alignItems: "flex-start",
	                flexDirection: "column"
	              }
	            },
	            _react2.default.createElement(
	              "h3",
	              {
	                className: "text-center",
	                style: {
	                  color: "#0C807D",
	                  fontSize: "28px",
	                  fontWeight: "500"
	
	                }
	              },
	              "Job Details"
	            )
	          )
	        )
	      ),
	      searchResults ? _react2.default.createElement(
	        "main",
	        null,
	        _react2.default.createElement(
	          "section",
	          { "class": "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "d-flex flex-column flex-lg-row pt-3 pb-3 justify-content-between w-100" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "d-flex pt-3 pb-3 justify-content-start align-items-start  w-75"
	                // style={{ backgroundColor: "#E7F2F2" }}
	              },
	              _react2.default.createElement("img", {
	                src: "/assets/images/united_logo.png",
	                alt: "",
	                style: { width: "10%", height: "63px" }
	              }),
	              _react2.default.createElement("img", {
	                className: "ms-4",
	                src: _case_under2.default,
	                alt: "",
	                width: 3,
	                height: 63
	              }),
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex flex-column w-100" },
	                _react2.default.createElement(
	                  "h3",
	                  {
	                    className: "px-4 ",
	                    style: {
	                      fontSize: "22px",
	                      textTransform: "capitalize"
	                    }
	                  },
	                  searchResults.position_title
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "d-flex px-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-center align-items-center" },
	                    _react2.default.createElement("img", { src: "/assets/images/job_person.png", alt: "" }),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "ps-2 fw-bold" },
	                      searchResults.company
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-center align-items-center ps-3" },
	                    _react2.default.createElement("img", { src: "/assets/images/job_calander.png", alt: "" }),
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        style: { color: "#AF9763" },
	                        className: "ps-2 fw-bold"
	                      },
	                      formatDates(searchResults.posting_date, searchResults.deadline).deadline
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  // width: "20%",
	                  borderRadius: "5px",
	                  backgroundColor: "#E7F2F2"
	                },
	                className: "applyDate d-flex flex-column align-items-center justify-content-between"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "" },
	                _react2.default.createElement(
	                  "h2",
	                  { style: { color: "#0C807D" } },
	                  formatDates(searchResults.posting_date, searchResults.deadline).start.date
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "w-100  d-flex align-items-center justify-content-center",
	                  style: {
	                    backgroundColor: "#0C807D",
	                    borderBottomLeftRadius: "5px",
	                    borderBottomRightRadius: "5px"
	                  }
	                },
	                _react2.default.createElement(
	                  "h6",
	                  { className: "mb-0 py-2", style: { color: "#ffffff" } },
	                  formatDates(searchResults.posting_date, searchResults.deadline).start.year
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "container py-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "d-flex flex-column justify-content-md-center align-items-start " },
	            _react2.default.createElement("div", {
	              className: "mb-5",
	              dangerouslySetInnerHTML: {
	                __html: searchResults.description
	              }
	            }),
	            _react2.default.createElement(
	              _reactRouterDom2.Link,
	              { to: "/pages/career/cv-upload/" + route.id },
	              _react2.default.createElement(
	                "button",
	                {
	                  className: "px-3 py-2",
	                  style: {
	                    borderRadius: "5px",
	                    backgroundColor: "#0C807D",
	                    border: "none",
	                    color: "white"
	                  }
	                },
	                "Apply Now"
	              )
	            )
	          )
	        )
	      ) : ""
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = CareerInside;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	var _reactSlick = __webpack_require__(63);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _newsEventsModule = __webpack_require__(87);
	
	var _newsEventsModule2 = _interopRequireDefault(_newsEventsModule);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CareerSlider = function CareerSlider(_ref) {
	  var section = _ref.section;
	
	  var settings = {
	    rows: 1,
	    dots: false,
	    infinite: true,
	    speed: 500,
	    slidesToShow: 3,
	    slidesToScroll: 1,
	    autoplay: false,
	
	    responsive: [{
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        infinite: true,
	        dots: true
	      }
	    }, {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }, {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }]
	  };
	
	  var mobileSettings = {
	    rows: 1,
	    dots: false,
	    infinite: true,
	    speed: 500,
	    slidesToShow: 4,
	    slidesToScroll: 1,
	    autoplay: false,
	    responsive: [{
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        infinite: true,
	        dots: true
	      }
	    }, {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }, {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }]
	  };
	  return _react2.default.createElement(
	    "section",
	    { className: "container " },
	    _react2.default.createElement(
	      "h3",
	      {
	        className: "text-center",
	        style: {
	          color: "#AF9763",
	          fontSize: "28px",
	          fontWeight: "500"
	        }
	      },
	      section.sectionTitle
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "row mt-4" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 right-sp-1" },
	        _react2.default.createElement(
	          "div",
	          { className: "news_section" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              _reactDeviceDetect.MobileView,
	              { className: _newsEventsModule2.default.MobileView },
	              _react2.default.createElement(
	                _reactSlick2.default,
	                mobileSettings,
	                section.value.length > 0 ? section.value.map(function (card) {
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-sm-3 px-1",
	                      key: card.id,
	                      style: { width: "100%", maxWidth: "432px" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "card py-4 d-flex flex-column justify-content-between align-items-start",
	                        style: {
	                          paddingLeft: "0px",
	                          paddingRight: "0px",
	                          borderRadius: "14px",
	                          cursor: "pointer"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          // style={{ background: "red" }}
	                          className: "card-body d-flex justify-content-start align-items-start ps-3 p-0  pt-1 mb-4"
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement("img", {
	                            // className="rounded-circle"
	                            src: "" + _constants.IMAGE_URL + card.media[0],
	                            width: 80,
	                            height: 80,
	                            style: {
	                              objectFit: "cover",
	                              borderRadius: "5px"
	                            },
	                            alt: "news_events_1"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "authorDetails d-flex flex-column align-items-start ms-3" },
	                          _react2.default.createElement(
	                            "h3",
	                            {
	                              style: {
	                                fontSize: "26px",
	                                color: "#222222",
	                                fontWeight: "700"
	                              }
	                            },
	                            card.title
	                          )
	                        )
	                      ),
	                      _react2.default.createElement("div", {
	                        className: "px-3",
	                        style: { height: "4em" },
	                        dangerouslySetInnerHTML: {
	                          __html: card.description.split(" ").slice(0, 10).join(" ")
	                        }
	                      }),
	                      " "
	                    )
	                  );
	                }) : _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-12 post-slide" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "news-part" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "bg-color-back" },
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        "No any news & events founds"
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactDeviceDetect.BrowserView,
	              null,
	              _react2.default.createElement(
	                _reactSlick2.default,
	                Object.assign({ className: "slider-1 " }, settings),
	                section.value.length > 0 ? section.value.map(function (card) {
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-sm-3 px-1",
	                      key: card.id,
	                      style: { width: "100%", maxWidth: "432px" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "card py-4 d-flex flex-column justify-content-between align-items-start",
	                        style: {
	                          paddingLeft: "0px",
	                          paddingRight: "0px",
	                          borderRadius: "14px",
	                          cursor: "pointer"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          // style={{ background: "red" }}
	                          className: "card-body d-flex justify-content-start align-items-start ps-3 p-0  pt-1 mb-4"
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement("img", {
	                            // className="rounded-circle"
	                            src: "" + _constants.IMAGE_URL + card.media[0],
	                            width: 80,
	                            height: 80,
	                            style: {
	                              objectFit: "cover",
	                              borderRadius: "5px"
	                            },
	                            alt: "news_events_1"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "authorDetails d-flex flex-column align-items-start ms-3" },
	                          _react2.default.createElement(
	                            "h3",
	                            {
	                              style: {
	                                fontSize: "26px",
	                                color: "#222222",
	                                fontWeight: "700"
	                              }
	                            },
	                            card.title
	                          )
	                        )
	                      ),
	                      _react2.default.createElement("div", {
	                        className: "px-3",
	                        style: { height: "4em" },
	                        dangerouslySetInnerHTML: {
	                          __html: card.description.split(" ").slice(0, 10).join(" ")
	                        }
	                      }),
	                      " "
	                    )
	                  );
	                }) : _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-12 post-slide" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "news-part" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "bg-color-back" },
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        "No any news & events founds"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = CareerSlider;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _reactToastify = __webpack_require__(7);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _MyProvider = __webpack_require__(48);
	
	var _axios = __webpack_require__(64);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _index = __webpack_require__(2);
	
	var _reactHtmlParser = __webpack_require__(402);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Cart = function Cart() {
	  var _useContext = (0, _react.useContext)(_MyProvider.MyContext),
	      state = _useContext.state,
	      removeFromCart = _useContext.removeFromCart;
	
	  var cartData = JSON.parse(localStorage.getItem("cart"));
	  var totalAmount = JSON.parse(localStorage.getItem("totalAmount"));
	  var totalQuantity = JSON.parse(localStorage.getItem("totalQuantity"));
	  var handleSubmit = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var date, formattedDate, patient_id, qty, currency, type, total, grand_total, customer_data, additional, payment_type, sslCommerz_urls, status, postData, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              date = new Date();
	              formattedDate = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
	              patient_id = localStorage.getItem("USER_ID");
	              qty = totalQuantity;
	              currency = "BDT";
	              type = "all";
	              total = totalAmount;
	              grand_total = totalAmount;
	              customer_data = {
	                customer_name: localStorage.getItem("patient_name"),
	                phone_number: localStorage.getItem("login_phone_number")
	              };
	              additional = cartData;
	              payment_type = "sslCommerz";
	              sslCommerz_urls = {
	                success_url: window.location.origin + "/success-order",
	                fail_url: window.location.origin + "/fail",
	                cancel_url: window.location.origin + "/cancel"
	              };
	              status = 1;
	
	              // console.log("your log output", window);
	
	              postData = {
	                date: formattedDate,
	                patient_id: patient_id,
	                qty: qty,
	                total: total,
	                type: type,
	                currency: currency,
	                grand_total: grand_total,
	                customer_data: customer_data,
	                additional: additional,
	                payment_type: payment_type,
	                sslCommerz_urls: sslCommerz_urls,
	                status: status
	              };
	
	
	              try {
	                response = _index.scAxiosAdmin.post("ledger", postData, {
	                  method: "post",
	                  headers: {
	                    Accept: "application/json",
	                    "Content-Type": "application/json"
	                  }
	                }).then(function (response) {
	                  if (response.data.status === "success") {
	                    window.location.href = response.data.data;
	                  }
	                });
	              } catch (error) {
	                console.error("Error fetching data:", error);
	              }
	
	            case 15:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function handleSubmit() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Cart | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Cart"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/static/media/banner-profile.f160a4c1.jpg",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "prof-dr py-5" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "box-of-about border-part" },
	            _react2.default.createElement(
	              "div",
	              { "class": "container" },
	              _react2.default.createElement(
	                "div",
	                { "class": "row gy-4" },
	                cartData ? cartData.length > 0 ? cartData.map(function (cart, index) {
	                  return _react2.default.createElement(
	                    "div",
	                    { key: index, className: "col-sm-12" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "card shadow-md  bg-body",
	                        style: {
	                          borderLeft: "10px solid #55A5A6",
	                          borderRadius: "10px"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "card-body d-flex justify-content-between align-items-center" },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "",
	                            style: { width: "80%", maxWidth: "1019px" }
	                          },
	                          cart.type === "investigation" ? _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "h4",
	                              null,
	                              "Type : Investigation"
	                            ),
	                            _react2.default.createElement(
	                              "h5",
	                              { className: "card-title" },
	                              "Product Group: ",
	                              cart.Product_Group
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              { className: "card-text" },
	                              "Product Name: ",
	                              cart.Product_Name
	                            )
	                          ) : cart.type === "packages" ? _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "h4",
	                              null,
	                              "Type : Packages"
	                            ),
	                            _react2.default.createElement(
	                              "h5",
	                              { className: "card-title" },
	                              cart.name
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              { className: "card-text" },
	                              (0, _reactHtmlParser2.default)(cart.description.slice(0, 50)),
	                              "..."
	                            )
	                          ) : _react2.default.createElement("p", null)
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "d-flex flex-column align-items-end ",
	                            style: { width: "20%" }
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "" },
	                            _react2.default.createElement("i", {
	                              style: { cursor: "pointer" },
	                              className: "fa-regular fa-circle-xmark",
	                              onClick: function onClick() {
	                                return removeFromCart(cart.id, cart.type);
	                              }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "d-flex justify-content-around align-items-center w-100" },
	                            cart.type === "medicine" ? _react2.default.createElement(
	                              "div",
	                              { className: "d-flex justify-content-between align-items-center w-50" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "w-25" },
	                                _react2.default.createElement("i", {
	                                  style: { fontSize: "40px" },
	                                  className: "fa-regular fa-square-plus"
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "w-25" },
	                                _react2.default.createElement("input", {
	                                  className: "form-control",
	                                  id: "exampleInputEmail1",
	                                  "aria-describedby": "emailHelp"
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "w-25" },
	                                _react2.default.createElement("i", {
	                                  style: { fontSize: "40px" },
	                                  className: "fa-regular fa-square-minus"
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "w-50 text-end" },
	                                "Price: BDT 350"
	                              )
	                            ) : cart.type === "investigation" ? "" : cart.type === "packages" ? _react2.default.createElement(
	                              "div",
	                              { className: "w-50 text-end" },
	                              "Price: ",
	                              cart.opd_amount
	                            ) : ""
	                          )
	                        )
	                      )
	                    )
	                  );
	                }) : _react2.default.createElement(
	                  "h1",
	                  { className: "text-center" },
	                  "No data in cart"
	                ) : ""
	              ),
	              cartData ? cartData.length > 0 ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  { className: "d-flex justify-content-between mt-5" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    "Total Amount:"
	                  ),
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    "BDT ",
	                    totalAmount
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "d-flex justify-content-center mt-5" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      // disabled={cartData.length > 0 ? false : true}
	                      style: { backgroundColor: "#187979", width: "15%" },
	                      className: "btn  btn-sm rounded rounded-lg invBtn",
	                      onClick: function onClick() {
	                        return handleSubmit();
	                      }
	                    },
	                    "Pay Now"
	                  )
	                )
	              ) : "" : ""
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Cart;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MyProvider = __webpack_require__(48);
	
	var _ = __webpack_require__(2);
	
	var _reactHtmlParser = __webpack_require__(402);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	var _BooTestPopUp = __webpack_require__(206);
	
	var _BooTestPopUp2 = _interopRequireDefault(_BooTestPopUp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var CartPopUp = function CartPopUp() {
	  var _useContext = (0, _react.useContext)(_MyProvider.MyContext),
	      state = _useContext.state,
	      removeFromCart = _useContext.removeFromCart,
	      removeItemFromCart = _useContext.removeItemFromCart;
	
	  var cartData = JSON.parse(localStorage.getItem("cart"));
	  var totalAmount = JSON.parse(localStorage.getItem("totalAmount"));
	  var totalQuantity = JSON.parse(localStorage.getItem("totalQuantity"));
	  var handleSubmit = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var date, formattedDate, patient_id, qty, currency, type, total, grand_total, customer_data, additional, payment_type, sslCommerz_urls, status, postData, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              date = new Date();
	              formattedDate = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
	              patient_id = localStorage.getItem("USER_ID");
	              qty = totalQuantity;
	              currency = "BDT";
	              type = "all";
	              total = totalAmount;
	              grand_total = totalAmount;
	              customer_data = {
	                customer_name: localStorage.getItem("patient_name"),
	                phone_number: localStorage.getItem("login_phone_number")
	              };
	              additional = cartData;
	              payment_type = "sslCommerz";
	              sslCommerz_urls = {
	                success_url: window.location.origin + "/success-order",
	                fail_url: window.location.origin + "/fail",
	                cancel_url: window.location.origin + "/cancel"
	              };
	              status = 1;
	
	              // console.log("your log output", window);
	
	              postData = {
	                date: formattedDate,
	                patient_id: patient_id,
	                qty: qty,
	                total: total,
	                type: type,
	                currency: currency,
	                grand_total: grand_total,
	                customer_data: customer_data,
	                additional: additional,
	                payment_type: payment_type,
	                sslCommerz_urls: sslCommerz_urls,
	                status: status
	              };
	
	
	              try {
	                response = _.scAxiosAdmin.post("ledger", postData, {
	                  method: "post",
	                  headers: {
	                    Accept: "application/json",
	                    "Content-Type": "application/json"
	                  }
	                }).then(function (response) {
	                  if (response.data.status === "success") {
	                    window.location.href = response.data.data;
	                  }
	                });
	              } catch (error) {
	                console.error("Error fetching data:", error);
	              }
	
	            case 15:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function handleSubmit() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    {
	      "class": "offcanvas offcanvas-end",
	      tabindex: "-1",
	      id: "cartOffcanvasRight",
	      "aria-labelledby": "cartOffcanvasRightLabel",
	      style: { minWidth: "30%", zIndex: 99999999999 }
	    },
	    _react2.default.createElement(
	      "div",
	      {
	        "class": "offcanvas-header",
	        style: { paddingRight: "2rem", paddingLeft: "2rem" }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "", style: { paddingTop: "3rem" } },
	        _react2.default.createElement(
	          "h4",
	          { style: { color: "#af9763" } },
	          "Cart Items"
	        )
	      ),
	      _react2.default.createElement("button", {
	        type: "button",
	        "class": "btn-close text-reset",
	        "data-bs-dismiss": "offcanvas",
	        "aria-label": "Close"
	      })
	    ),
	    _react2.default.createElement(
	      "div",
	      { "class": "offcanvas-body pb-5" },
	      _react2.default.createElement(
	        "div",
	        { "class": "row gy-4 left-offcanvas" },
	        cartData ? cartData.length > 0 ? cartData.map(function (cart, index) {
	          return _react2.default.createElement(
	            "div",
	            { key: index, className: "col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "card shadow-md  bg-body",
	                style: {
	                  borderLeft: "10px solid #55A5A6",
	                  borderRadius: "10px"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "card-body d-flex justify-content-between align-items-start" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "",
	                    style: { width: "80%", maxWidth: "1019px" }
	                  },
	                  cart.type === "investigation" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Type : Investigation"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "card-title" },
	                      "Product Group: ",
	                      cart.Product_Group
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "card-text" },
	                      "Product Name: ",
	                      cart.Product_Name
	                    )
	                  ) : cart.type === "packages" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Type : Packages"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "card-title" },
	                      cart.name
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "card-text" },
	                      (0, _reactHtmlParser2.default)(cart.description.slice(0, 50)),
	                      "..."
	                    )
	                  ) : _react2.default.createElement("p", null)
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "d-flex flex-column align-items-end",
	                    style: { width: "20%" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "" },
	                    _react2.default.createElement("i", {
	                      style: { cursor: "pointer" },
	                      "class": "fa-regular fa-rectangle-xmark fs-4",
	                      onClick: function onClick() {
	                        return removeItemFromCart(cart.id);
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-around align-items-center w-100" },
	                    cart.type === "medicine" ? _react2.default.createElement(
	                      "div",
	                      { className: "d-flex justify-content-between align-items-center w-50" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "w-25" },
	                        _react2.default.createElement("i", {
	                          style: { fontSize: "40px" },
	                          className: "fa-regular fa-square-plus"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "w-25" },
	                        _react2.default.createElement("input", {
	                          className: "form-control",
	                          id: "exampleInputEmail1",
	                          "aria-describedby": "emailHelp"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "w-25" },
	                        _react2.default.createElement("i", {
	                          style: { fontSize: "40px" },
	                          className: "fa-regular fa-square-minus"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "w-50 text-end" },
	                        "Price: BDT 350"
	                      )
	                    ) : cart.type === "investigation" ? "" : cart.type === "packages" ? _react2.default.createElement(
	                      "div",
	                      { className: "w-50 text-end" },
	                      "Price: ",
	                      cart.opd_amount
	                    ) : ""
	                  )
	                )
	              )
	            )
	          );
	        }) : _react2.default.createElement(
	          "h1",
	          { style: { color: "#187979" }, className: "text-center" },
	          "No data in cart"
	        ) : ""
	      ),
	      cartData ? cartData.length > 0 ? _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex justify-content-between mt-5" },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Total Amount:"
	          ),
	          _react2.default.createElement(
	            "h3",
	            null,
	            "BDT ",
	            totalAmount
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex justify-content-center mt-5" },
	          _react2.default.createElement(
	            "button",
	            {
	              // disabled={cartData.length > 0 ? false : true}
	              type: "button",
	              style: { backgroundColor: "#187979" },
	              className: "btn  btn-sm rounded rounded-lg invBtn w-100",
	              "data-bs-dismiss": "offcanvas",
	              "aria-label": "Close",
	              "data-bs-toggle": "offcanvas",
	              "data-bs-target": "#bookTestOffcanvasRight",
	              "aria-controls": "bookTestOffcanvasRight"
	            },
	            _react2.default.createElement(
	              "a",
	              null,
	              "Book Now"
	            )
	          )
	        )
	      ) : "" : ""
	    )
	  );
	};
	
	exports.default = CartPopUp;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactToastify = __webpack_require__(7);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _caseImgMain = __webpack_require__(93);
	
	var _caseImgMain2 = _interopRequireDefault(_caseImgMain);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseStudyDetails = function CaseStudyDetails() {
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchResults = _useState2[0],
	      setSearchResults = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      departmentId = _useState4[0],
	      setDepartmentId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    DoctorID: "",
	    PreferredDate: "",
	    doctorData: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      scheduleReqData = _useState8[0],
	      setScheduleReqData = _useState8[1];
	
	  var route = (0, _reactRouterDom.useParams)();
	  var images = ["/assets/images/blog_1.png", "/assets/images/blog_2.png", "/assets/images/blog_3.png", "/assets/images/blog_4.png"];
	
	  (0, _react.useEffect)(function () {
	    var getCaseStudies = function getCaseStudies(data) {
	      try {
	        setLoading(true);
	        var req = _.scAxiosAdmin.request("/case_studies/" + route.id, {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            setLoading(false);
	            setSearchResults(data.data);
	          }
	        }).catch(function (e) {
	          setLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getCaseStudies();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Case Study | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Case Study"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/assets/images/banner-case-study.png",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex flex-column justify-content-between align-items-center px-5 py-4" },
	          _react2.default.createElement(
	            "div",
	            { className: "1" },
	            _react2.default.createElement(
	              "h3",
	              {
	                className: "text-left ",
	                style: {
	                  color: "#0C807D",
	                  fontSize: "28px",
	                  fontWeight: "500",
	                  display: "flex",
	                  flexDirection: "column"
	
	                }
	              },
	              "Case Study"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "section",
	        { "class": "container pb-4" },
	        searchResults ? _react2.default.createElement(
	          "div",
	          { "class": "row g-0" },
	          _react2.default.createElement(
	            "div",
	            {
	              "class": "col-md-12 d-flex flex-column justify-content-between",
	              style: { backgroundColor: "#F7F7F7" }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "d-flex pt-3 px-3 ",
	                style: { backgroundClip: "#E7F2F2" }
	              },
	              _react2.default.createElement("img", { src: _case_under2.default, alt: "", width: 3, height: 70 }),
	              _react2.default.createElement(
	                "h3",
	                {
	                  className: "px-4 pt-2",
	                  style: {
	                    fontSize: "22px",
	                    textTransform: "capitalize"
	                  }
	                },
	                searchResults.title
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "card" },
	              _react2.default.createElement(
	                "div",
	                { "class": "card-body" },
	                _react2.default.createElement(
	                  "li",
	                  { style: { fontSize: "22px", fontWeight: "bold" } },
	                  searchResults.doctor_mave ? searchResults.doctor_mave.doctor_name : ""
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { "class": "card-text" },
	                  searchResults.doctor_mave ? searchResults.doctor_mave.degree : ""
	                ),
	                _react2.default.createElement("div", {
	                  className: "",
	                  dangerouslySetInnerHTML: {
	                    __html: searchResults.description
	                  }
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row d-flex justify-content-between align-items-center pt-5 px-2" },
	                  searchResults.gallery ? searchResults.gallery.map(function (image, index) {
	                    return _react2.default.createElement(
	                      "div",
	                      {
	                        className: "col-md-3 imgContainer p-0",
	                        style: {
	                          maxHeight: "300px",
	                          maxWidth: "300px"
	                        }
	                      },
	                      _react2.default.createElement("img", {
	                        style: {
	                          objectFit: "cover",
	                          borderRadius: "5px"
	                        },
	                        src: "" + _constants.IMAGE_URL + image,
	                        alt: ""
	                      })
	                    );
	                  }) : ""
	                )
	              )
	            )
	          )
	        ) : ""
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = CaseStudyDetails;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _caseImgMain = __webpack_require__(93);
	
	var _caseImgMain2 = _interopRequireDefault(_caseImgMain);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactToastify = __webpack_require__(7);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseStudyPage = function CaseStudyPage() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchResults = _useState2[0],
	      setSearchResults = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      departmentId = _useState4[0],
	      setDepartmentId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    DoctorID: "",
	    PreferredDate: "",
	    doctorData: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      scheduleReqData = _useState8[0],
	      setScheduleReqData = _useState8[1];
	
	  var images = ["/assets/images/blog_1.png", "/assets/images/blog_2.png", "/assets/images/blog_3.png", "/assets/images/blog_4.png"];
	
	  (0, _react.useEffect)(function () {
	    var getCaseStudies = function getCaseStudies(data) {
	      try {
	        setLoading(true);
	        var req = _.scAxiosAdmin.request("/case_studies", {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            setLoading(false);
	            setSearchResults(data.data);
	          }
	        }).catch(function (e) {
	          setLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getCaseStudies();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Case Study | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Death Certificate"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/assets/images/banner-case-study.png",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex flex-column justify-content-between align-items-center py-4 px-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "" },
	            _react2.default.createElement(
	              "h3",
	              {
	                className: "text-left ",
	                style: {
	                  color: "#0C807D",
	                  fontSize: "28px",
	                  fontWeight: "500",
	                  display: "flex",
	                  flexDirection: "column"
	
	                }
	              },
	              "Case Study"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "section",
	        { "class": "container  " },
	        searchResults ? searchResults.map(function (cases, index) {
	          return _react2.default.createElement(
	            "div",
	            { "class": "row g-0 pb-4" },
	            cases.gallery ? _react2.default.createElement(
	              "div",
	              { "class": "col-md-5" },
	              _react2.default.createElement("img", {
	                style: {
	                  maxHeight: "400px",
	                  objectFit: "cover",
	                  width: "100%",
	                  borderTopLeftRadius: "5px",
	                  borderBottomLeftRadius: "5px"
	                },
	                src: "" + _constants.IMAGE_URL + cases.gallery[0],
	                alt: ""
	              })
	            ) : _react2.default.createElement(
	              "div",
	              { "class": "col-md-5" },
	              _react2.default.createElement("img", {
	                style: {
	                  maxHeight: "400px",
	                  objectFit: "cover",
	                  width: "100%",
	                  borderTopLeftRadius: "5px",
	                  borderBottomLeftRadius: "5px"
	                },
	                src: _caseImgMain2.default,
	                width: 546,
	                alt: ""
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                "class": "col-md-7 d-flex flex-column justify-content-between",
	                style: { backgroundColor: "#F7F7F7" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "d-flex pt-3 px-3 pb-3",
	                  style: { backgroundClip: "#E7F2F2" }
	                },
	                _react2.default.createElement("img", { src: _case_under2.default, alt: "", width: 3, height: 70 }),
	                _react2.default.createElement(
	                  "h3",
	                  {
	                    className: "px-4 pt-2",
	                    style: {
	                      fontSize: "22px",
	                      textTransform: "capitalize"
	                    }
	                  },
	                  cases.title
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "card h-100" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "card-body d-flex flex-column justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex flex-column justify-content-start" },
	                    _react2.default.createElement(
	                      "li",
	                      { style: { fontSize: "22px", fontWeight: "bold" } },
	                      cases.doctor_mave.doctor_name
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "card-text", style: { marginLeft: "1.9rem" } },
	                      cases.doctor_mave.degree
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "card-text" },
	                    cases.short_description.split(" ").slice(0, 50).join(" ") + " ..."
	                  ),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: "/pages/case-study/" + cases.id },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        style: {
	                          fontSize: "16px",
	                          width: "118px",
	                          height: "43px",
	                          backgroundColor: "#0C807D",
	                          color: "#fff",
	                          textTransform: "capitalize",
	                          border: "none",
	                          borderRadius: "6px",
	                          fontWeight: 500
	                        }
	                      },
	                      "View details"
	                    )
	                  )
	                )
	              )
	            )
	          );
	        }) : ""
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = CaseStudyPage;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToastify = __webpack_require__(7);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	__webpack_require__(8);
	
	var _userSession = __webpack_require__(30);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _Loading_icon = __webpack_require__(56);
	
	var _Loading_icon2 = _interopRequireDefault(_Loading_icon);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected = function ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected(_ref) {
	  var scheduleReqData = _ref.scheduleReqData;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      loading = _useState2[0],
	      setLoading = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      appointmentLoading = _useState4[0],
	      setAppointmentLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      newDate = _useState6[0],
	      setNewDate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      slot = _useState8[0],
	      setSlot = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      selectedDoctorData = _useState10[0],
	      setSelectedDoctorData = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(),
	      _useState12 = _slicedToArray(_useState11, 2),
	      bookingResponse = _useState12[0],
	      setBookingResponse = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(),
	      _useState14 = _slicedToArray(_useState13, 2),
	      bookingRequestResponse = _useState14[0],
	      setBookingRequestResponse = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(true),
	      _useState16 = _slicedToArray(_useState15, 2),
	      disabled = _useState16[0],
	      setDisabled = _useState16[1];
	
	  (0, _react.useEffect)(function () {}, []);
	
	  var doctorData = scheduleReqData && scheduleReqData.doctorData;
	  var dateName = null;
	  var showDate = null;
	
	  if (newDate) {
	    dateName = new Date(newDate).toLocaleDateString("en-US", {
	      weekday: "long"
	    });
	    showDate = (0, _moment2.default)(newDate).format("LL");
	  } else {
	    dateName = new Date(scheduleReqData.PreferredDate).toLocaleDateString("en-US", { weekday: "long" });
	    showDate = (0, _moment2.default)(scheduleReqData.PreferredDate).format("LL");
	  }
	
	  var schedules = scheduleReqData.selectedSchedule;
	  /* if (doctorData && dateName && doctorData.Schedule !== null) {
	  const schedulesObject = doctorData.Schedule[0];
	  if (dateName) {
	    schedules = schedulesObject[dateName];
	  }
	  } */
	
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	  };
	  var handleScheduleAppointment = function handleScheduleAppointment(type) {
	    var scheduleAppointmentPostData = {
	      type: "book_appointment",
	      doctor_id: scheduleReqData.DoctorID,
	      user_patient_id: localStorage.getItem(_constants.USER_LOCAL_ID),
	      appointment_date: scheduleReqData.PreferredDate,
	      appointment_time: slot,
	      patient_phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER),
	      amount: 1500.0,
	      doctor_name: scheduleReqData.doctorData.doctor_name,
	      patient_name: localStorage.getItem(_constants.PATIENT_NAME),
	      doctor_fees: 1500.5
	    };
	    var reqAppointmentPostData = {
	      type: "request_appointment",
	      doctor_id: scheduleReqData.DoctorID,
	      user_patient_id: localStorage.getItem(_constants.USER_LOCAL_ID),
	      appointment_date: scheduleReqData.PreferredDate,
	      patient_phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER),
	      amount: 1500.0,
	      doctor_name: scheduleReqData.doctorData.doctor_name,
	      patient_name: localStorage.getItem(_constants.PATIENT_NAME),
	      doctor_fees: 1500.5
	    };
	    if (type === "schedule_appointment") {
	      try {
	        setAppointmentLoading(true);
	        var req = _.scAxiosAdmin.post("/appointments/request_new", scheduleAppointmentPostData, {
	          method: "post",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 201) {
	            _reactToastify.toast.success("Your request for an appointment is received. We will confirm shortly!!");
	            setBookingResponse(data.data.data);
	            setAppointmentLoading(false);
	          }
	        }).catch(function (e) {
	          _reactToastify.toast.error("Something went wrong!");
	          setAppointmentLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {
	        _reactToastify.toast.error("Something went wrong!");
	        setAppointmentLoading(false);
	      }
	    }
	    if (type === "request_appointment") {
	      try {
	        setAppointmentLoading(true);
	        var _req = _.scAxiosAdmin.post("/appointments/request_new", reqAppointmentPostData, {
	          method: "post",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 201) {
	            _reactToastify.toast.success("Your request for an appointment is received. We will confirm shortly!!");
	            setBookingRequestResponse(data.data.data);
	            setAppointmentLoading(false);
	          }
	        }).catch(function (e) {
	          _reactToastify.toast.error("Something went wrong!");
	          setAppointmentLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {
	        _reactToastify.toast.error("Something went wrong!");
	        setAppointmentLoading(false);
	      }
	    }
	  };
	
	  //
	  //   useEffect(() => {
	  //     const getSingleDoctor = (data) => {
	  //       try {
	  //         setLoading(true);
	  //         const req = scAxiosAdmin
	  //           .request(`/doctors/getsingledoctors/${scheduleReqData.DoctorID}`, {
	  //             method: "get",
	  //             headers: {
	  //               Accept: "application/json",
	  //               Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	  //             },
	  //           })
	  //           .then((data) => {
	  //             if (data.status === 200) {
	  //               setDoctorData(data.data.data);
	  //               setLoading(false);
	  //             }
	  //           })
	  //           .catch((e) => {
	  //             setLoading(false);
	  //             console.log("your log output", e);
	  //           });
	  //       } catch (error) {
	  //         setLoading(false);
	  //       }
	  //     };
	  //     getSingleDoctor();
	  //   }, [scheduleReqData.DoctorID]);
	  return _react2.default.createElement(
	    "div",
	    {
	      className: "offcanvas offcanvas-start",
	      tabIndex: -1,
	      id: "ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected",
	      "aria-labelledby": "offcanvasExampleLabel"
	      // style={{ visibility: "visible" }}
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "offcanvas-header" },
	      _react2.default.createElement(
	        "h5",
	        { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	        " "
	      ),
	      _react2.default.createElement("button", {
	        type: "button",
	        className: "btn-close text-reset",
	        "data-bs-dismiss": "offcanvas",
	        "aria-label": "Close",
	        onClick: function onClick() {
	          setNewDate(""), setSlot(null);
	          location.reload();
	        }
	      })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "offcanvas-body" },
	      _react2.default.createElement(
	        "div",
	        { className: "left-offcanvas" },
	        _react2.default.createElement(
	          "h4",
	          { style: { color: "#187979" } },
	          "Book Appointment"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "goback" },
	          _react2.default.createElement(
	            "button",
	            {
	              variant: "primary"
	              // data-bs-toggle="offcanvas"
	              // data-bs-target="#BookAppointMentParticularDoctorPopUp"
	              // aria-controls="BookAppointMentParticularDoctorPopUp"
	              , onClick: function onClick() {
	                setNewDate(""), setSlot(null);
	                location.reload();
	              },
	              style: { background: "none", border: "none" }
	            },
	            _react2.default.createElement("i", { className: "fa-solid fa-circle-left" }),
	            " Go Back & Reselect your Doctor"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "sd-container" },
	          _react2.default.createElement(
	            "h6",
	            { className: "timer" },
	            showDate,
	            _react2.default.createElement("input", {
	              type: "date",
	              className: "change_schedule_date",
	              name: "change_schedule_date",
	              id: "change_schedule_date",
	              value: newDate,
	              onChange: function onChange(e) {
	                return setNewDate(e.target.value);
	              }
	              // min={newcurrentdate}
	            }),
	            _react2.default.createElement("i", { className: "moz-cover-clear" }),
	            _react2.default.createElement(
	              "span",
	              { className: "open-button" },
	              _react2.default.createElement(
	                "button",
	                { type: "button" },
	                "\uD83D\uDCC5"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "form",
	          {
	            onSubmit: handleSubmit,
	            className: "needs-validation",
	            noValidate: true
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 sp-0-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "doctor-list Dr-Reazur" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "row",
	                    onClick: function onClick() {
	                      return setSelectedDoctorData(doctorData);
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-4 sp-0-1 left-0" },
	                    doctorData ? _react2.default.createElement("img", {
	                      src: _constants.IMAGE_URL + "/DoctorProfileImg/" + doctorData.doctor_profile,
	                      alt: "doctor profile"
	                    }) : _react2.default.createElement("img", {
	                      src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                      alt: "doc"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-8", id: "dr" },
	                    _react2.default.createElement(
	                      "h5",
	                      null,
	                      doctorData.doctor_name
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      doctorData.doctor_degree !== "" ? doctorData.doctor_degree : ""
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "mt-2" },
	                      doctorData.doctor_fees !== "" ? _react2.default.createElement(
	                        "strong",
	                        { style: { color: "#fb6201" } },
	                        "BDT ",
	                        doctorData.doctor_fees
	                      ) : _react2.default.createElement("strong", null)
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-4", id: "time-date" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              schedules !== null && schedules !== undefined ? schedules.split(",").map(function (schedule_time) {
	                return _react2.default.createElement(
	                  "div",
	                  {
	                    className: "doctor_schedule_section",
	                    key: schedule_time,
	                    style: { marginBottom: "5px" }
	                  },
	                  _react2.default.createElement("input", {
	                    type: "radio",
	                    className: "schedule_time",
	                    id: "schedule_date_time",
	                    name: "schedule_date_time",
	                    defaultValue: schedule_time,
	                    value: schedule_time,
	                    onChange: function onChange(e) {
	                      if (slot !== e.target.value) {
	                        // Only set the slot if it's not already selected
	                        setSlot(e.target.value);
	                      }
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "btn-links color-check text-center" },
	                    schedule_time,
	                    " ",
	                    showDate
	                  )
	                );
	              }) : _react2.default.createElement(
	                "p",
	                null,
	                "No slots available!"
	              ),
	              appointmentLoading ? _react2.default.createElement("img", { src: _Loading_icon2.default, alt: "Loading" }) : ""
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              schedules !== null && schedules !== undefined ? _react2.default.createElement(
	                "button",
	                {
	                  variant: "primary",
	                  type: "submit",
	                  className: "btn-links appointment-new",
	                  id: "Schedule",
	                  onClick: function onClick() {
	                    return handleScheduleAppointment("schedule_appointment");
	                  },
	                  style: {
	                    backgroundColor: slot ? "rgb(246, 130, 31)" : ""
	                  }
	                },
	                "Schedule Appointment"
	              ) : _react2.default.createElement(
	                "button",
	                {
	                  variant: "primary",
	                  type: "submit",
	                  className: "btn-links appointment-new",
	                  id: "Schedule",
	                  onClick: function onClick() {
	                    return handleScheduleAppointment("request_appointment");
	                  }
	                },
	                "Request Appointment"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToastify = __webpack_require__(7);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	__webpack_require__(8);
	
	var _userSession = __webpack_require__(30);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _Loading_icon = __webpack_require__(56);
	
	var _Loading_icon2 = _interopRequireDefault(_Loading_icon);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmAppointmentAndRequestAppointmentTestimonialParticularDoctor = function ConfirmAppointmentAndRequestAppointmentTestimonialParticularDoctor(_ref) {
	  var scheduleReqData = _ref.scheduleReqData;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      loading = _useState2[0],
	      setLoading = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      appointmentLoading = _useState4[0],
	      setAppointmentLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      newDate = _useState6[0],
	      setNewDate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      slot = _useState8[0],
	      setSlot = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      selectedDoctorData = _useState10[0],
	      setSelectedDoctorData = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(),
	      _useState12 = _slicedToArray(_useState11, 2),
	      bookingResponse = _useState12[0],
	      setBookingResponse = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(),
	      _useState14 = _slicedToArray(_useState13, 2),
	      bookingRequestResponse = _useState14[0],
	      setBookingRequestResponse = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(true),
	      _useState16 = _slicedToArray(_useState15, 2),
	      disabled = _useState16[0],
	      setDisabled = _useState16[1];
	
	  (0, _react.useEffect)(function () {}, []);
	
	  var doctorData = scheduleReqData && scheduleReqData.doctorData;
	  var dateName = null;
	  var showDate = null;
	
	  if (newDate) {
	    dateName = new Date(newDate).toLocaleDateString("en-US", {
	      weekday: "long"
	    });
	    showDate = (0, _moment2.default)(newDate).format("LL");
	  } else {
	    dateName = new Date(scheduleReqData.PreferredDate).toLocaleDateString("en-US", { weekday: "long" });
	    showDate = (0, _moment2.default)(scheduleReqData.PreferredDate).format("LL");
	  }
	
	  var schedules = null;
	  if (doctorData && doctorData.Schedule !== null) {
	    var schedulesObject = doctorData.Schedule[0];
	
	    if (dateName) {
	      schedules = schedulesObject[dateName];
	    }
	  }
	
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	  };
	  var handleScheduleAppointment = function handleScheduleAppointment(type) {
	    var scheduleAppointmentPostData = {
	      type: "book_appointment",
	      doctor_id: scheduleReqData.DoctorID,
	      user_patient_id: localStorage.getItem(_constants.USER_LOCAL_ID),
	      appointment_date: scheduleReqData.PreferredDate,
	      appointment_time: slot,
	      patient_phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER),
	      amount: 1500.0,
	      doctor_name: scheduleReqData.doctorData.doctor_name,
	      patient_name: localStorage.getItem(_constants.PATIENT_NAME),
	      doctor_fees: 1500.5
	    };
	    var reqAppointmentPostData = {
	      type: "request_appointment",
	      doctor_id: scheduleReqData.DoctorID,
	      user_patient_id: localStorage.getItem(_constants.USER_LOCAL_ID),
	      appointment_date: scheduleReqData.PreferredDate,
	      patient_phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER),
	      amount: 1500.0,
	      doctor_name: scheduleReqData.doctorData.doctor_name,
	      patient_name: localStorage.getItem(_constants.PATIENT_NAME),
	      doctor_fees: 1500.5
	    };
	    if (type === "schedule_appointment") {
	      try {
	        setAppointmentLoading(true);
	        var req = _.scAxiosAdmin.post("/appointments/request_new", scheduleAppointmentPostData, {
	          method: "post",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 201) {
	            _reactToastify.toast.success("Your request for an appointment is received. We will confirm shortly!!");
	            setBookingResponse(data.data.data);
	            setAppointmentLoading(false);
	          }
	        }).catch(function (e) {
	          _reactToastify.toast.error("Something went wrong!");
	          setAppointmentLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {
	        _reactToastify.toast.error("Something went wrong!");
	        setAppointmentLoading(false);
	      }
	    }
	    if (type === "request_appointment") {
	      try {
	        setAppointmentLoading(true);
	        var _req = _.scAxiosAdmin.post("/appointments/request_new", reqAppointmentPostData, {
	          method: "post",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 201) {
	            _reactToastify.toast.success("Your request for an appointment is received. We will confirm shortly!!");
	            setBookingRequestResponse(data.data.data);
	            setAppointmentLoading(false);
	          }
	        }).catch(function (e) {
	          _reactToastify.toast.error("Something went wrong!");
	          setAppointmentLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {
	        _reactToastify.toast.error("Something went wrong!");
	        setAppointmentLoading(false);
	      }
	    }
	  };
	
	  //
	  //   useEffect(() => {
	  //     const getSingleDoctor = (data) => {
	  //       try {
	  //         setLoading(true);
	  //         const req = scAxiosAdmin
	  //           .request(`/doctors/getsingledoctors/${scheduleReqData.DoctorID}`, {
	  //             method: "get",
	  //             headers: {
	  //               Accept: "application/json",
	  //               Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	  //             },
	  //           })
	  //           .then((data) => {
	  //             if (data.status === 200) {
	  //               setDoctorData(data.data.data);
	  //               setLoading(false);
	  //             }
	  //           })
	  //           .catch((e) => {
	  //             setLoading(false);
	  //             console.log("your log output", e);
	  //           });
	  //       } catch (error) {
	  //         setLoading(false);
	  //       }
	  //     };
	  //     getSingleDoctor();
	  //   }, [scheduleReqData.DoctorID]);
	  return _react2.default.createElement(
	    "div",
	    {
	      className: "offcanvas offcanvas-start",
	      tabIndex: -1,
	      id: "ConfirmAppointmentAndRequestAppointmentTestimonialParticularDoctor",
	      "aria-labelledby": "offcanvasExampleLabel"
	      // style={{ visibility: "visible" }}
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "offcanvas-header" },
	      _react2.default.createElement(
	        "h5",
	        { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	        " "
	      ),
	      _react2.default.createElement("button", {
	        type: "button",
	        className: "btn-close text-reset",
	        "data-bs-dismiss": "offcanvas",
	        "aria-label": "Close",
	        onClick: function onClick() {
	          setNewDate(""), setSlot(null);
	          schedules = null;
	          location.reload();
	        }
	      })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "offcanvas-body" },
	      _react2.default.createElement(
	        "div",
	        { className: "left-offcanvas" },
	        _react2.default.createElement(
	          "h4",
	          { style: { color: "#187979" } },
	          "Book Appointment"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "goback" },
	          _react2.default.createElement(
	            "button",
	            {
	              variant: "primary"
	              // data-bs-toggle="offcanvas"
	              // data-bs-target="#BookAppointMentParticularDoctorPopUp"
	              // aria-controls="BookAppointMentParticularDoctorPopUp"
	              , onClick: function onClick() {
	                setNewDate(""), setSlot(null);
	                location.reload();
	              },
	              style: { background: "none", border: "none" }
	            },
	            _react2.default.createElement("i", { className: "fa-solid fa-circle-left" }),
	            " Go Back & Reselect your Doctor"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "sd-container" },
	          _react2.default.createElement(
	            "h6",
	            { className: "timer" },
	            showDate,
	            _react2.default.createElement("input", {
	              type: "date",
	              className: "change_schedule_date",
	              name: "change_schedule_date",
	              id: "change_schedule_date",
	              value: newDate,
	              onChange: function onChange(e) {
	                return setNewDate(e.target.value);
	              }
	              // min={newcurrentdate}
	            }),
	            _react2.default.createElement("i", { className: "moz-cover-clear" }),
	            _react2.default.createElement(
	              "span",
	              { className: "open-button" },
	              _react2.default.createElement(
	                "button",
	                { type: "button" },
	                "\uD83D\uDCC5"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "form",
	          { onSubmit: handleSubmit, className: "needs-validation", noValidate: true },
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 sp-0-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "doctor-list Dr-Reazur" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "row",
	                    onClick: function onClick() {
	                      return setSelectedDoctorData(doctorData);
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-4 sp-0-1 left-0" },
	                    doctorData ? _react2.default.createElement("img", {
	                      src: _constants.IMAGE_URL + "/DoctorProfileImg/" + doctorData.doctor_profile,
	                      alt: "doctor profile"
	                    }) : _react2.default.createElement("img", {
	                      src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                      alt: "doc"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-8", id: "dr" },
	                    _react2.default.createElement(
	                      "h5",
	                      null,
	                      doctorData.doctor_name
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      doctorData.doctor_degree !== "" ? doctorData.doctor_degree : ""
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "mt-2" },
	                      doctorData.doctor_fees !== "" ? _react2.default.createElement(
	                        "strong",
	                        { style: { color: "#fb6201" } },
	                        "BDT ",
	                        doctorData.doctor_fees
	                      ) : _react2.default.createElement("strong", null)
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-4", id: "time-date" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              schedules !== null && schedules !== undefined ? schedules.split(",").map(function (schedule_time) {
	                return _react2.default.createElement(
	                  "div",
	                  {
	                    className: "doctor_schedule_section",
	                    key: schedule_time,
	                    style: { marginBottom: "5px" }
	                  },
	                  _react2.default.createElement("input", {
	                    type: "radio",
	                    className: "schedule_time",
	                    id: "schedule_date_time",
	                    name: "schedule_date_time",
	                    defaultValue: schedule_time,
	                    value: schedule_time,
	                    onChange: function onChange(e) {
	                      if (slot !== e.target.value) {
	                        // Only set the slot if it's not already selected
	                        setSlot(e.target.value);
	                      }
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "btn-links color-check text-center" },
	                    schedule_time,
	                    " ",
	                    showDate
	                  )
	                );
	              }) : _react2.default.createElement(
	                "p",
	                null,
	                "No slots available!"
	              ),
	              appointmentLoading ? _react2.default.createElement("img", { src: _Loading_icon2.default, alt: "Loading" }) : ""
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              schedules !== null && schedules !== undefined ? _react2.default.createElement(
	                "button",
	                {
	                  variant: "primary",
	                  type: "submit",
	                  className: "btn-links appointment-new",
	                  id: "Schedule",
	                  onClick: function onClick() {
	                    return handleScheduleAppointment("schedule_appointment");
	                  },
	                  style: {
	                    backgroundColor: slot ? "rgb(246, 130, 31)" : ""
	                  }
	                },
	                "Schedule Appointment"
	              ) : _react2.default.createElement(
	                "button",
	                {
	                  variant: "primary",
	                  type: "submit",
	                  className: "btn-links appointment-new",
	                  id: "Schedule",
	                  onClick: function onClick() {
	                    return handleScheduleAppointment("request_appointment");
	                  }
	                },
	                "Request Appointment"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = ConfirmAppointmentAndRequestAppointmentTestimonialParticularDoctor;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroup = __webpack_require__(140);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	var _jquery = __webpack_require__(18);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(59);
	
	var _GalleryForEmergency = __webpack_require__(208);
	
	var _GalleryForEmergency2 = _interopRequireDefault(_GalleryForEmergency);
	
	var _AmbulanceService = __webpack_require__(205);
	
	var _AmbulanceService2 = _interopRequireDefault(_AmbulanceService);
	
	var _AmbulanceGallery = __webpack_require__(204);
	
	var _AmbulanceGallery2 = _interopRequireDefault(_AmbulanceGallery);
	
	var _ci = __webpack_require__(405);
	
	var _io = __webpack_require__(162);
	
	var _tfi = __webpack_require__(125);
	
	var _fa = __webpack_require__(62);
	
	var _fa2 = __webpack_require__(161);
	
	var _io2 = __webpack_require__(406);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ContactUs = function ContactUs() {
	  var _useState = (0, _react.useState)({
	    first_name: "",
	    phone_number: "",
	    email: "",
	    message: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      loading = _useState4[0],
	      setLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      headerData = _useState6[0],
	      setHeaderData = _useState6[1];
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	    setFormData(Object.assign({}, formData, _defineProperty({}, name, value)));
	  };
	  (0, _react.useEffect)(function () {
	    var headerDataList = {
	      ids: [31, 32, 33, 34]
	    };
	    var getHeaderData = function getHeaderData(data) {
	      try {
	        var req = _.scAxiosAdmin.post("/settings/get_multiple", headerDataList, {
	          // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
	          method: "get",
	          headers: {
	            Accept: "application/json"
	            // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            // console.log('your log output',data)
	            // setStaticPageData(data.data.data);
	            setHeaderData(data.data);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getHeaderData();
	  }, []);
	  var handleSubmit = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              e.preventDefault();
	              _context.prev = 1;
	
	              setLoading(true);
	              _context.next = 5;
	              return _.scAxiosAdmin.post("/emergenecies_enquiry", Object.assign({
	                type: "contact_us"
	              }, formData));
	
	            case 5:
	              response = _context.sent;
	
	              if (response.status === 201) {
	                setLoading(false);
	                _reactToastify.toast.success("Your inquiry was submitted successfully!");
	                // alert("Your inquiry was submitted successfully!");
	              }
	              _context.next = 14;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context["catch"](1);
	
	              setLoading(false);
	              console.error("Error submitting inquiry:", _context.t0);
	              _reactToastify.toast.error("Something went wrong!");
	
	            case 14:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[1, 9]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Contact Us | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Contact Us"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin" },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/static/media/banner-profile.f160a4c1.jpg",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      _react2.default.createElement(
	        "section",
	        {
	          className: "prof-dr pb-5",
	          style: { backgroundColor: "#F7F5EF" }
	        },
	        _react2.default.createElement(
	          "h3",
	          {
	            className: "py-5",
	            style: { color: "#AF9763", textAlign: "center" }
	          },
	          "Contact Us"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "container px-0 d-flex flex-column flex-md-row justify-content-between shadow",
	            style: { borderRadius: "18px", backgroundColor: "#ffffff" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "" + (_reactDeviceDetect.isMobile ? "w-100" : "w-50") },
	            _react2.default.createElement(
	              "div",
	              { className: "pt-5" },
	              _react2.default.createElement(
	                "form",
	                { onSubmit: handleSubmit, className: "p-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-3" },
	                  _react2.default.createElement(
	                    "label",
	                    { htmlFor: "name", className: "form-label" },
	                    "Name"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control",
	                    id: "name",
	                    name: "first_name",
	                    value: formData.first_name,
	                    onChange: handleChange,
	                    required: true
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-3" },
	                  _react2.default.createElement(
	                    "label",
	                    { htmlFor: "phone", className: "form-label" },
	                    "Phone"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "tel",
	                    className: "form-control",
	                    id: "phone",
	                    name: "phone_number",
	                    value: formData.phone_number,
	                    onChange: handleChange,
	                    required: true
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-3" },
	                  _react2.default.createElement(
	                    "label",
	                    { htmlFor: "email", className: "form-label" },
	                    "Email"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "email",
	                    className: "form-control",
	                    id: "email",
	                    name: "email",
	                    value: formData.email,
	                    onChange: handleChange,
	                    required: true
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-3" },
	                  _react2.default.createElement(
	                    "label",
	                    { htmlFor: "message", className: "form-label" },
	                    "Message"
	                  ),
	                  _react2.default.createElement("textarea", {
	                    className: "form-control",
	                    id: "message",
	                    name: "message",
	                    rows: "4",
	                    value: formData.message,
	                    onChange: handleChange,
	                    required: true
	                  })
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "submit",
	                    className: "w-100 rounded-3 fw-bold d-flex justify-content-center align-items-center gap-2",
	                    style: {
	                      backgroundColor: "#F58220",
	                      color: "white",
	                      borderRadius: "10px",
	                      border: "none",
	                      padding: "10px"
	                    }
	                  },
	                  loading && _react2.default.createElement(
	                    "div",
	                    { "class": "spinner-border", role: "status" },
	                    _react2.default.createElement(
	                      "span",
	                      { "class": "visually-hidden" },
	                      "Loading..."
	                    )
	                  ),
	                  "Submit"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "p-4",
	                  style: {
	                    display: "flex",
	                    flexDirection: "column",
	                    justifyContent: "center",
	                    alignItems: "center"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "d-flex align-items-center mb-3" },
	                  _react2.default.createElement(_tfi.TfiHeadphoneAlt, { color: "#F58220", className: "locationIcon" })
	                ),
	                _react2.default.createElement(
	                  "a",
	                  { className: "text-decoration-none", href: "tel:10666" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex align-items-center mb-3" },
	                    _react2.default.createElement(_io.IoCall, {
	                      size: 40,
	                      color: "#F58220",
	                      className: "header-text me-2"
	                    }),
	                    _react2.default.createElement(
	                      "h5",
	                      { className: "header-text", style: { color: "#F58220" } },
	                      headerData.length > 0 && headerData[0].value ? headerData[0].value : "10666"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "d-flex flex-column flex-xl-row mb-3 justify-content-center align-items-center gap-3 flex-wrap",
	                    style: { color: "#F58220" }
	                  },
	                  _react2.default.createElement(
	                    "h6",
	                    {
	                      className: "d-flex align-items-center fw-bold",
	                      style: { width: "fit-content", display: "inline-block" }
	                    },
	                    "Cell:",
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { className: " mt-1" },
	                      headerData.length > 0 && headerData[1].value ? headerData[1].value : "+880 1914 001234"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "h6",
	                    {
	                      className: " d-flex align-items-center fw-bold",
	                      style: { width: "fit-content", display: "inline-block" }
	                    },
	                    "International:",
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { className: " mt-1" },
	                      headerData.length > 0 && headerData[2].value ? headerData[2].value : "+880 2-2222-62466"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-center align-items-center fw-bold" },
	                    _react2.default.createElement(
	                      "h6",
	                      { className: " fw-bold" },
	                      "WhatsApp:"
	                    ),
	                    _react2.default.createElement(
	                      "h6",
	                      { className: " fw-bold mt-2" },
	                      headerData.length > 0 && headerData[3].value ? headerData[3].value : "+880191-4001214"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: (_reactDeviceDetect.isMobile ? "w-100" : "w-50") + " d-none d-md-block" },
	            _react2.default.createElement("img", {
	              style: { objectFit: "cover" },
	              className: "w-100 h-100 img-fluid",
	              src: "/assets/images/uhl_contact.png",
	              alt: "",
	              srcset: ""
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = ContactUs;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToastify = __webpack_require__(7);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _RadioGroup = __webpack_require__(140);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	__webpack_require__(43);
	
	__webpack_require__(8);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CorporateRequestPopUp = function CorporateRequestPopUp(_ref) {
	  var show = _ref.show,
	      handleClose = _ref.handleClose;
	
	  var _useState = (0, _react.useState)({
	    type: "emergency",
	    client_name: "",
	    phone_number: "",
	    company_type: "Insurance Companies",
	    number_of_employees: "",
	    name_of_md: "",
	    phone_of_md: "",
	    agreement: true
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      makeVisible = _useState4[0],
	      setMakeVisible = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    if (formData.client_name && formData.phone_number && formData.company_type && formData.number_of_employees && formData.name_of_md && formData.phone_of_md) {
	      setMakeVisible(true);
	    } else setMakeVisible(false);
	  }, [formData.client_name, formData.phone_number, formData.company_type, formData.number_of_employees, formData.name_of_md, formData.phone_of_md]);
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value,
	        files = _e$target.files;
	
	    if (files) {
	      setFormData(function (prevData) {
	        return Object.assign({}, prevData, _defineProperty({}, name, files[0]));
	      });
	    } else if (name === "agreement") {
	      setFormData(function (prevData) {
	        return Object.assign({}, prevData, _defineProperty({}, name, !formData.agreement));
	      });
	    } else {
	      setFormData(function (prevData) {
	        return Object.assign({}, prevData, _defineProperty({}, name, value));
	      });
	    }
	  };
	
	  var handleClick = function handleClick(name, value) {
	    setFormData(function (prevData) {
	      return Object.assign({}, prevData, _defineProperty({}, name, value));
	    });
	  };
	
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	    var postData = {
	      type: "corporate_client",
	      category: formData.company_type,
	      title: formData.client_name,
	      phone_number: formData.phone_number,
	      form_data: {
	        number_of_employees: formData.number_of_employees,
	        type_of_ownership: formData.type_of_ownership,
	        name_of_md: formData.name_of_md,
	        phone_of_md: formData.phone_of_md,
	        agreement: formData.agreement
	      }
	    };
	    setLoading(true);
	    try {
	      var req = _.scAxiosAdmin.post("/form_submission", postData, {
	        method: "post",
	        headers: {
	          Accept: "application/json",
	          "Content-Type": "application/json"
	        }
	      }).then(function (response) {
	        if (response.status === 201) {
	          _reactToastify.toast.success("Your request is received, you will be notified soon!");
	          setLoading(false);
	        } else {
	          _reactToastify.toast.error("Ops something went wrong!");
	          setLoading(false);
	        }
	      }).catch(function (error) {
	        setLoading(false);
	      });
	    } catch (error) {
	      setLoading(false);
	    }
	  };
	
	  var bloodGroup = [{
	    type: "Positive",
	    options: [{ label: "A+", value: "A+" }, { label: "AB+", value: "AB+" }, { label: "B+", value: "B+" }, { label: "O+", value: "O+" }]
	  }, {
	    type: "Negative",
	    options: [{ label: "A-", value: "A-" }, { label: "AB-", value: "AB-" }, { label: "B-", value: "B-" }, { label: "O-", value: "O-" }]
	  }];
	
	  var positiveBloodTypes = bloodGroup.find(function (group) {
	    return group.type === "Positive";
	  }).options;
	
	  var negativeBloodTypes = bloodGroup.find(function (group) {
	    return group.type === "Negative";
	  }).options;
	
	  var gender = [{ label: "Male (M)", value: "Male" }, { label: "Female (F)", value: "Female" }];
	
	  var ambulance = [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }];
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        className: "offcanvas offcanvas-end",
	        tabIndex: "-1",
	        id: "corporateRequestOffcanvasRight",
	        "aria-labelledby": "corporateRequestOffcanvasRightLabel",
	        style: { minWidth: "30%", zIndex: 99999999999999 }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "offcanvas-header", style: { paddingTop: "5rem" } },
	        _react2.default.createElement(
	          "div",
	          { className: "ps-3" },
	          _react2.default.createElement(
	            "h4",
	            { style: { color: "#af9763" } },
	            "Request for Corporate Agreement"
	          )
	        ),
	        _react2.default.createElement("button", {
	          type: "button",
	          className: "btn-close text-reset",
	          "data-bs-dismiss": "offcanvas",
	          "aria-label": "Close",
	          onClick: handleClose
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "offcanvas-body" },
	        _react2.default.createElement(
	          "form",
	          { onSubmit: handleSubmit },
	          _react2.default.createElement(
	            "div",
	            { className: "form-group" },
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control",
	              id: "client_name",
	              placeholder: "Name of the Company...",
	              name: "client_name",
	              value: formData.client_name,
	              onChange: handleChange,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "form-group" },
	            _react2.default.createElement("input", {
	              type: "number",
	              className: "form-control",
	              id: "phone_number",
	              name: "phone_number",
	              placeholder: "Key Contact...",
	              value: formData.phone_number,
	              onChange: handleChange,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "form-group" },
	            _react2.default.createElement("input", {
	              type: "number",
	              className: "form-control",
	              id: "number_of_employees",
	              name: "number_of_employees",
	              placeholder: "Number of Employees...",
	              value: formData.number_of_employees,
	              onChange: handleChange,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "form-group" },
	            _react2.default.createElement(
	              "select",
	              {
	                className: "form-control",
	                id: "company_type",
	                name: "company_type",
	                value: formData.company_type,
	                onChange: handleChange,
	                required: true
	              },
	              _react2.default.createElement(
	                "option",
	                { selected: true, disabled: true },
	                "Type of Ownership"
	              ),
	              ["Insurance Companies", "Multinational Companies", "Embassies", "Other Companies"].map(function (type, index) {
	                return _react2.default.createElement(
	                  "option",
	                  { key: index, value: type },
	                  type
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "form-group" },
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control",
	              id: "name_of_md",
	              name: "name_of_md",
	              placeholder: "Name of the CEO/MD/Chairperson...",
	              value: formData.name_of_md,
	              onChange: handleChange,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "form-group" },
	            _react2.default.createElement("input", {
	              type: "number",
	              className: "form-control",
	              id: "phone_of_md",
	              name: "phone_of_md",
	              placeholder: "Contact number of the CEO/MD/Chairperson...",
	              value: formData.phone_of_md,
	              onChange: handleChange,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "form-check" },
	            _react2.default.createElement("input", {
	              "class": "form-check-input",
	              type: "checkbox",
	              value: "",
	              id: "agreement",
	              name: "agreement",
	              onChange: handleChange,
	              defaultChecked: true
	            }),
	            _react2.default.createElement(
	              "label",
	              { "class": "form-check-label", "for": "flexCheckChecked" },
	              "Yes, we agree to perform at least 50 health screening annually to encourage preventive healthcare among our employees"
	            )
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: !makeVisible,
	              type: "submit",
	              style: {
	                backgroundColor: makeVisible ? "rgb(12, 128, 125)" : "#41414b"
	              },
	              className: "w-100 btn-primary p-2 rounded-3 border-0  d-flex justify-content-center align-items-center gap-4"
	            },
	            loading && _react2.default.createElement(
	              "div",
	              { "class": "spinner-border", role: "status" },
	              _react2.default.createElement(
	                "span",
	                { "class": "visually-hidden" },
	                "Loading..."
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              "Submit"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = CorporateRequestPopUp;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _services = __webpack_require__(105);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _table_data = __webpack_require__(860);
	
	var _table_data2 = _interopRequireDefault(_table_data);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Corporateclient = function Corporateclient() {
	  // State for the search query
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchQuery = _useState2[0],
	      setSearchQuery = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({}),
	      _useState4 = _slicedToArray(_useState3, 2),
	      videoLInk = _useState4[0],
	      setVideoLInk = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    var getAllBanner = function getAllBanner(data) {
	      try {
	        var req = _.scAxiosAdmin.request("/settings/30", {
	          method: "get"
	        }).then(function (data) {
	          if (data.status === 200) {
	            setVideoLInk(data.data.value);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getAllBanner();
	  }, []);
	  // Function to handle search query input change
	  var handleSearchChange = function handleSearchChange(event) {
	    setSearchQuery(event.target.value.toLowerCase());
	  };
	
	  // Function to filter table data based on the search query
	  // Memoized filtering function
	  var filteredData = (0, _react.useMemo)(function () {
	    return Object.entries(_table_data2.default).reduce(function (filtered, _ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          category = _ref2[0],
	          rows = _ref2[1];
	
	      var filteredRows = rows.filter(function (row) {
	        return row.name.toLowerCase().includes(searchQuery);
	      });
	      if (filteredRows.length > 0) {
	        filtered[category] = filteredRows;
	      }
	      return filtered;
	    }, {});
	  }, [_table_data2.default, searchQuery]);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Corporate Clients | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Corporate Clients"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      _react2.default.createElement(
	        "div",
	        { "class": "" },
	        _react2.default.createElement(
	          "section",
	          { className: "termscondbody mt-5 pb-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "box-of-about border-section mb-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "row g-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-8 col-md-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: " bg-light p-3" },
	                      "CORPORATE CLIENTS LOGO",
	                      _react2.default.createElement("img", {
	                        src: "/assets/images/partner-img.jpg",
	                        alt: "",
	                        width: "100%"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "my-4 d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-center" },
	                      _react2.default.createElement(
	                        "h4",
	                        null,
	                        "Corporate Client"
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          // disabled={cartData.length > 0 ? false : true}
	                          type: "button",
	                          style: { backgroundColor: "#187979", color: "white" },
	                          className: "btn-sm rounded rounded-lg invBtn border-0 p-2",
	                          "data-bs-dismiss": "offcanvas",
	                          "aria-label": "Close",
	                          "data-bs-toggle": "offcanvas",
	                          "data-bs-target": "#corporateRequestOffcanvasRight",
	                          "aria-controls": "corporateRequestOffcanvasRight"
	                        },
	                        "Request for Corporate Client Agreement"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "my-4" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        placeholder: "Search by name...",
	                        value: searchQuery,
	                        onChange: handleSearchChange,
	                        className: "search-bar rounded-pill",
	                        style: {
	                          padding: "8px",
	                          width: "100%",
	                          borderRadius: "5px",
	                          border: "1px solid #ccc"
	                        }
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "bg-light p-3" },
	                      Object.entries(filteredData).map(function (_ref3, index) {
	                        var _ref4 = _slicedToArray(_ref3, 2),
	                            category = _ref4[0],
	                            rows = _ref4[1];
	
	                        return _react2.default.createElement(
	                          "table",
	                          { className: "table_style4", key: index },
	                          _react2.default.createElement(
	                            "tbody",
	                            null,
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "td",
	                                null,
	                                category
	                              )
	                            ),
	                            rows.map(function (rowData, rowIndex) {
	                              return _react2.default.createElement(
	                                "tr",
	                                { key: rowIndex },
	                                _react2.default.createElement(
	                                  "td",
	                                  null,
	                                  rowData.name
	                                )
	                              );
	                            })
	                          )
	                        );
	                      }),
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        "\xA0"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-lg-4 col-md-12 d-none d-md-block pt-2",
	                    style: {
	                      backgroundColor: "#fff",
	                      borderRadius: "5px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "text-profile", id: "mobile-part" },
	                    _react2.default.createElement(
	                      "div",
	                      { id: "sidebar-2", className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 sidebar-item " },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            className: "category-list-link open-cat-list",
	                            href: "#"
	                          },
	                          "Select Services"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          {
	                            className: "list-unstyled category-list patients-category-list",
	                            id: "department-list-sidebar"
	                          },
	                          _services2.default && _services2.default.map(function (item) {
	                            return _react2.default.createElement(
	                              _reactRouterDom.Link,
	                              {
	                                to: "/pages/" + item.slug,
	                                style: { textDecoration: "none" }
	                              },
	                              _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                  "a",
	                                  { className: "" },
	                                  item.department_name
	                                )
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "bookarea mt-3 d-none d-md-block mb-3",
	                      style: { position: "sticky", zIndex: "3333", top: 100 }
	                    },
	                    _react2.default.createElement("iframe", {
	                      width: "100%",
	                      height: "315",
	                      src: videoLInk
	                      // src="https://www.youtube.com/embed/qG9oD9qxX6g"
	                      , title: "YouTube video player",
	                      frameborder: "0",
	                      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted",
	                      allowfullscreen: true
	                    }),
	                    _react2.default.createElement(
	                      "h5",
	                      {
	                        className: "text-center p-2 text-light",
	                        style: {
	                          backgroundColor: "#f58220",
	                          marginTop: "-6px"
	                        }
	                      },
	                      "Call Emergency Line",
	                      _react2.default.createElement("br", null),
	                      "10666"
	                    ),
	                    _react2.default.createElement("img", {
	                      src: "https://www.uhlbd.com/resources/images/contact.jpg",
	                      alt: ""
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	  );
	};
	
	exports.default = Corporateclient;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _phoneFlip = __webpack_require__(455);
	
	var _phoneFlip2 = _interopRequireDefault(_phoneFlip);
	
	var _caseImgMain = __webpack_require__(93);
	
	var _caseImgMain2 = _interopRequireDefault(_caseImgMain);
	
	var _unitedLogo = __webpack_require__(457);
	
	var _unitedLogo2 = _interopRequireDefault(_unitedLogo);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactToastify = __webpack_require__(7);
	
	var _reactRouterDom2 = __webpack_require__(38);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CvUpload = function CvUpload() {
	  var _useState = (0, _react.useState)({
	    firstName: "",
	    lastName: "",
	    email: "",
	    phoneNumber: "",
	    resume: null,
	    userPhoto: null
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  var route = (0, _reactRouterDom.useParams)();
	  var inputStyle = {
	    width: "100%",
	    borderBottom: "1px solid #B5B5B6",
	    fontSize: "16px",
	    outline: "none",
	    borderLeft: "none",
	    borderRight: "none",
	    borderTop: "none",
	    padding: "8px 8px 8px 0",
	    textAlign: "left"
	  };
	
	  var fileInputContainerStyle = {
	    borderBottom: "1px solid #B5B5B6",
	    paddingBottom: ".5rem",
	    width: "97%"
	  };
	
	  var fileInputStyle = {
	    fontSize: "16px",
	    outline: "none",
	    borderLeft: "none",
	    borderRight: "none",
	    borderTop: "none",
	    textAlign: "left"
	  };
	
	  var submitButtonStyle = {
	    fontSize: "16px",
	    width: "118px",
	    height: "43px",
	    backgroundColor: "#0C807D",
	    color: "#fff",
	    textTransform: "capitalize",
	    border: "none",
	    borderRadius: "6px",
	    fontWeight: 500
	  };
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value,
	        files = _e$target.files;
	
	    if (files) {
	      setFormData(function (prevData) {
	        return Object.assign({}, prevData, _defineProperty({}, name, files[0]));
	      });
	    } else {
	      setFormData(function (prevData) {
	        return Object.assign({}, prevData, _defineProperty({}, name, value));
	      });
	    }
	  };
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	    var body = new FormData();
	    body.append("type", "career_form");
	    body.append("job_id", route.id);
	    body.append("first_name", formData.firstName);
	    body.append("last_name", formData.lastName);
	    body.append("email", formData.email);
	    body.append("department", "");
	    body.append("expected_salary", "");
	    body.append("cover_letter", "");
	    body.append("status", "1");
	    body.append("resume", formData.resume);
	    body.append("user_photo", formData.userPhoto);
	    try {
	      var req = _.scAxiosAdmin.post("/job_applications", body, {
	        method: "post",
	        headers: {
	          Accept: "application/json",
	          "Content-Type": "multipart/form-data",
	          Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	        }
	      }).then(function (data) {
	        if (data.status === 201) {
	          _reactToastify.toast.success("Application Submitted Successfully");
	        }
	      }).catch(function (e) {
	        _reactToastify.toast.error("Something went wrong!");
	      });
	    } catch (error) {
	      _reactToastify.toast.error("Something went wrong!");
	    }
	  };
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Death Certificate | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Death Certificate"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/assets/images/banner-case-study.png",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      _react2.default.createElement(
	        "section",
	        { "class": "container  pb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex flex-column justify-content-between align-items-center p-4" },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: "flex",
	                justifyContent: "center",
	                alignItems: "flex-start",
	                flexDirection: "column"
	              }
	            },
	            _react2.default.createElement(
	              "h3",
	              {
	                className: "text-center",
	                style: {
	                  color: "#0C807D",
	                  fontSize: "28px",
	                  fontWeight: "500"
	                }
	              },
	              "Upload Your CV"
	            ),
	            _react2.default.createElement("img", {
	              width: 103,
	              height: 2,
	              src: "/assets/images/doctor_under.png",
	              alt: ""
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            "class": "row pt-5 pb-5 border justify-content-md-between",
	            style: { backgroundColor: "#FFFFFF", borderRadius: "10px" }
	          },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-12 d-flex" },
	            _react2.default.createElement(
	              "form",
	              { onSubmit: handleSubmit },
	              _react2.default.createElement(
	                "div",
	                { className: "row p-3 g-5 justify-content-around w-100" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6" },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    placeholder: "First Name",
	                    autoComplete: "off",
	                    name: "firstName",
	                    value: formData.firstName,
	                    onChange: handleChange,
	                    style: inputStyle
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6" },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    placeholder: "Last Name",
	                    autoComplete: "off",
	                    name: "lastName",
	                    value: formData.lastName,
	                    onChange: handleChange,
	                    style: inputStyle
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6" },
	                  _react2.default.createElement("input", {
	                    type: "email",
	                    placeholder: "Email Address",
	                    autoComplete: "off",
	                    name: "email",
	                    value: formData.email,
	                    onChange: handleChange,
	                    style: inputStyle
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6" },
	                  _react2.default.createElement("input", {
	                    type: "tel",
	                    placeholder: "Phone Number",
	                    autoComplete: "off",
	                    name: "phoneNumber",
	                    value: formData.phoneNumber,
	                    onChange: handleChange,
	                    style: inputStyle
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-md-12 px-0",
	                    style: fileInputContainerStyle
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-between align-items-end flex-row w-100" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Upload Image"
	                    ),
	                    _react2.default.createElement("input", {
	                      className: "w-100",
	                      type: "file",
	                      name: "userPhoto",
	                      onChange: handleChange,
	                      style: fileInputStyle
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-md-12 px-0",
	                    style: fileInputContainerStyle
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-between align-items-end flex-row w-100" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Resume/CV"
	                    ),
	                    _react2.default.createElement("input", {
	                      className: "w-100",
	                      type: "file",
	                      name: "resume",
	                      onChange: handleChange,
	                      style: fileInputStyle
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12 d-flex justify-content-center" },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "submit", style: submitButtonStyle },
	                    "Submit"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = CvUpload;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	var _jquery = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DayCare = function DayCare() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Day Care | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "newsevents, Singlenewsevents"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement("div", { id: "giveMargin", className: "" }),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = DayCare;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeathCertificate = function DeathCertificate() {
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      enableBtn = _useState2[0],
	      setEnableBtn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      loading = _useState4[0],
	      setLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      rawDate = _useState6[0],
	      setRawDate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      rawDate1 = _useState8[0],
	      setRawDate1 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(""),
	      _useState10 = _slicedToArray(_useState9, 2),
	      rawDate2 = _useState10[0],
	      setRawDate2 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    patientId: "",
	    first_name: "",
	    sex: "Male",
	    age: "",
	    nationality: "",
	    religion: "",
	    dataOfAdmission: "",
	    wardCabinUnit: "",
	    bed: "",
	    admittedUnder: "",
	    relationWithDeceased: "Father",
	    mobile: "",
	    address: "",
	    diseaseDirectDeath: "",
	    diseaseDirectDeathInt: "",
	    antecedentDeath: "",
	    antecedentDeathInt: "",
	    otherDeath: "",
	    otherDeathInt: "",
	    dateOfDeath: "",
	    certifyingDoc: "",
	    deadBodyTaken: "",
	    deadBodyTakenTime: "",
	    relationWithDead: "",
	    witnessName: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      formData = _useState12[0],
	      setFormData = _useState12[1];
	
	  (0, _react.useEffect)(function () {
	    if (formData.patientId && formData.first_name && formData.sex && formData.age && formData.nationality && formData.religion && formData.dataOfAdmission && formData.wardCabinUnit && formData.bed && formData.admittedUnder && formData.relationWithDeceased && formData.mobile && formData.address && formData.diseaseDirectDeath && formData.diseaseDirectDeathInt && formData.antecedentDeath && formData.antecedentDeathInt && formData.otherDeath && formData.otherDeathInt && formData.dateOfDeath && formData.certifyingDoc && formData.deadBodyTaken && formData.deadBodyTakenTime && formData.relationWithDead && formData.witnessName) {
	      setEnableBtn(false);
	    } else {
	      setEnableBtn(true);
	    }
	  }, [formData.patientId, formData.first_name, formData.sex, formData.age, formData.nationality, formData.religion, formData.dataOfAdmission, formData.wardCabinUnit, formData.bed, formData.admittedUnder, formData.relationWithDeceased, formData.mobile, formData.address, formData.diseaseDirectDeath, formData.diseaseDirectDeathInt, formData.antecedentDeath, formData.antecedentDeathInt, formData.otherDeath, formData.otherDeathInt, formData.dateOfDeath, formData.certifyingDoc, formData.deadBodyTaken, formData.deadBodyTakenTime, formData.relationWithDead, formData.witnessName]);
	
	  var sexList = [{ id: "1", label: "MALE", value: "Male" }, { id: "2", label: "FEMALE", value: "Female" }, { id: "3", label: "OTHERS", value: "Others" }];
	  var relation = [{ id: "1", label: "FATHER", value: "Father" }, { id: "2", label: "SPOUSE", value: "Spouse" }, { id: "3", label: "GUARDIAN", value: "Guardian" }];
	  (0, _react.useEffect)(function () {
	    if ((typeof rawDate === "undefined" ? "undefined" : _typeof(rawDate)) === "object" && (typeof rawDate1 === "undefined" ? "undefined" : _typeof(rawDate1)) === "object" && (typeof rawDate2 === "undefined" ? "undefined" : _typeof(rawDate2)) === "object") {
	      var newObj = new Date(rawDate).toString();
	      var formatedDate = newObj.split(" ").slice(0, 4).join(" ");
	      var newObj1 = new Date(rawDate1).toString();
	      var formatedDate1 = newObj1.split(" ").slice(0, 4).join(" ");
	      var newObj2 = new Date(rawDate2).toString();
	      var formatedDate2 = newObj2.split(" ").slice(0, 4).join(" ");
	      setFormData(Object.assign({}, formData, {
	        dataOfAdmission: formatedDate,
	        dateOfDeath: formatedDate1,
	        deadBodyTakenTime: formatedDate2
	      }));
	    }
	    // if(){
	    //   const newObj1 = new Date(rawDate1).toString()
	    //   const formatedDate1 = newObj1.split(" ").slice(0, 4).join(" ")
	    //   setFormData({
	    //   ...formData,
	    //   dateOfDeath: formatedDate1,
	    // })
	    // }
	    // if(){
	    //   const newObj2 = new Date(rawDate2).toString()
	    //   const formatedDate2 = newObj2.split(" ").slice(0, 4).join(" ")
	    //   setFormData({
	    //   ...formData,
	    //   deadBodyTakenTime: formatedDate2,
	    // })
	    // }
	  }, [rawDate, rawDate1, rawDate2]);
	  var handleSex = function handleSex(value) {
	    setFormData(Object.assign({}, formData, { sex: value }));
	  };
	  var handleRelation = function handleRelation(value) {
	    setFormData(Object.assign({}, formData, { relationWithDeceased: value }));
	  };
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    var postData = {
	      type: "death_certificate",
	      form_data: Object.assign({}, formData)
	    };
	    setLoading(true);
	    try {
	      var req = _.scAxiosAdmin.post("/form_submission", postData, {
	        method: "post",
	        headers: {
	          Accept: "application/json",
	          "Content-Type": "application/json"
	        }
	      }).then(function (response) {
	        if (response.status === 201) {
	          _reactToastify.toast.success("Your request is received, you will be notified soon!");
	          setLoading(false);
	        } else {
	          _reactToastify.toast.error("Ops something went wrong!");
	          setLoading(false);
	        }
	      }).catch(function (error) {
	        setLoading(false);
	      });
	    } catch (error) {
	      setLoading(false);
	    }
	  };
	  var handleDateChange = function handleDateChange(date) {
	    setRawDate(date);
	  };
	  var handleDateChange1 = function handleDateChange1(date) {
	    setRawDate1(date);
	  };
	  var handleDateChange2 = function handleDateChange2(date) {
	    setRawDate2(date);
	  };
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Death Certificate | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Death Certificate"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/static/media/banner-profile.f160a4c1.jpg",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "prof-dr py-5" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "box-of-about border-part " },
	            _react2.default.createElement(
	              "div",
	              { "class": "container" },
	              _react2.default.createElement(
	                "div",
	                { "class": "row gy-4" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "col-md-12" },
	                  _react2.default.createElement(
	                    "h3",
	                    {
	                      className: "text-center mb-5",
	                      style: {
	                        color: "#0C807D",
	                        fontWeight: "700"
	                      }
	                    },
	                    "Request for Death Certificate"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "form",
	                    { action: "", onSubmit: handleSubmit },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "patientId" },
	                          "Patient ID:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "patientId",
	                          name: "patientId",
	                          required: true,
	                          value: formData.patientId,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              patientId: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "name" },
	                          "Name:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "name",
	                          name: "name",
	                          value: formData.name,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              first_name: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "sex" },
	                          "Sex:"
	                        ),
	                        _react2.default.createElement(_RadioGroupFunctional2.default, {
	                          name: "sex",
	                          radioOptions: sexList,
	                          defaultSelected: "Male",
	                          onChange: handleSex
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "age" },
	                          "Age:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "age",
	                          name: "age",
	                          value: formData.age,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, { age: e.target.value }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "nationality" },
	                          "Nationality:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "nationality",
	                          name: "nationality",
	                          value: formData.nationality,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              nationality: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "religion" },
	                          "Religion:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "religion",
	                          name: "religion",
	                          value: formData.religion,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              religion: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-4" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "dataOfAdmission" },
	                          "Date of Admission:"
	                        ),
	                        _react2.default.createElement("br", null),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          className: "form-control",
	                          selected: rawDate,
	                          value: rawDate,
	                          onChange: function onChange(date) {
	                            return handleDateChange(date);
	                          },
	                          dateFormat: "dd/MM/yyyy",
	                          placeholderText: "DD/MM/YYYY",
	                          showDateMonthYearPicker: true
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-4" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "wardCabinUnit" },
	                          "Ward/ Cabin/ Unit:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "wardCabinUnit",
	                          name: "wardCabinUnit",
	                          value: formData.wardCabinUnit,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              wardCabinUnit: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-4" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "bed" },
	                          "Bed:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "bed",
	                          name: "bed",
	                          value: formData.bed,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, { bed: e.target.value }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-12" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "admittedUnder" },
	                          "Admitted Under:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          placeholder: "Dr. ",
	                          id: "admittedUnder",
	                          name: "admittedUnder",
	                          value: formData.admittedUnder,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              admittedUnder: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement("hr", null),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "relationWithDeceased" },
	                          "Relation with deceased:"
	                        ),
	                        _react2.default.createElement(_RadioGroupFunctional2.default, {
	                          name: "relationWithDeceased",
	                          radioOptions: relation,
	                          defaultSelected: "Father",
	                          onChange: handleRelation
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "mobile" },
	                          "Mobile:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "tel",
	                          className: "form-control",
	                          id: "mobile",
	                          name: "mobile",
	                          value: formData.mobile,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              mobile: e.target.value
	                            }));
	                          },
	                          required: true
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-12" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "address" },
	                          "Address:"
	                        ),
	                        _react2.default.createElement("textarea", {
	                          type: "textarea",
	                          className: "form-control",
	                          id: "address",
	                          name: "address",
	                          value: formData.address,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              address: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement("hr", null),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-12" },
	                            _react2.default.createElement(
	                              "h5",
	                              { className: " text-center mb-5" },
	                              "Death Incident Details"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-8" },
	                            _react2.default.createElement(
	                              "h5",
	                              { className: " text-center" },
	                              "Cause of Death"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-4 " },
	                            _react2.default.createElement(
	                              "h5",
	                              { className: " text-center" },
	                              "Approx, interval between onset and death."
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group col-md-8 pb-2 " },
	                            _react2.default.createElement(
	                              "label",
	                              { htmlFor: "diseaseDirectDeath" },
	                              "Disease or condition directly leading to death:"
	                            ),
	                            _react2.default.createElement("input", {
	                              type: "text",
	                              className: "form-control",
	                              id: "diseaseDirectDeath",
	                              placeholder: "Due to or as a consequence of......",
	                              name: "diseaseDirectDeath",
	                              value: formData.diseaseDirectDeath,
	                              required: true,
	                              onChange: function onChange(e) {
	                                return setFormData(Object.assign({}, formData, {
	                                  diseaseDirectDeath: e.target.value
	                                }));
	                              }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group col-md-4 pb-2 " },
	                            _react2.default.createElement("input", {
	                              style: { marginTop: "32px" },
	                              type: "text",
	                              className: "form-control",
	                              id: "diseaseDirectDeathInt",
	                              name: "diseaseDirectDeathInt",
	                              value: formData.diseaseDirectDeathInt,
	                              required: true,
	                              onChange: function onChange(e) {
	                                return setFormData(Object.assign({}, formData, {
	                                  diseaseDirectDeathInt: e.target.value
	                                }));
	                              }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group col-md-8 pb-2 " },
	                            _react2.default.createElement(
	                              "label",
	                              { htmlFor: "antecedentDeath" },
	                              "Antecedent causes Morbid conditions, if any giving rise to the above causes stating the underlying condition last:"
	                            ),
	                            _react2.default.createElement("input", {
	                              type: "text",
	                              className: "form-control",
	                              id: "antecedentDeath",
	                              placeholder: "Due to or as a consequence of......",
	                              name: "antecedentDeath",
	                              value: formData.antecedentDeath,
	                              required: true,
	                              onChange: function onChange(e) {
	                                return setFormData(Object.assign({}, formData, {
	                                  antecedentDeath: e.target.value
	                                }));
	                              }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group col-md-4 pb-2 " },
	                            _react2.default.createElement("input", {
	                              style: { marginTop: "55px" },
	                              type: "text",
	                              className: "form-control",
	                              id: "antecedentDeathInt",
	                              name: "antecedentDeathInt",
	                              value: formData.antecedentDeathInt,
	                              required: true,
	                              onChange: function onChange(e) {
	                                return setFormData(Object.assign({}, formData, {
	                                  antecedentDeathInt: e.target.value
	                                }));
	                              }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group col-md-8 pb-2 " },
	                            _react2.default.createElement(
	                              "label",
	                              { htmlFor: "otherDeath" },
	                              "Other significant conditions contributing to death, but not related to diseases or conditions causing it:"
	                            ),
	                            _react2.default.createElement("input", {
	                              type: "text",
	                              className: "form-control",
	                              id: "otherDeath",
	                              name: "otherDeath",
	                              value: formData.otherDeath,
	                              required: true,
	                              onChange: function onChange(e) {
	                                return setFormData(Object.assign({}, formData, {
	                                  otherDeath: e.target.value
	                                }));
	                              }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group col-md-4 pb-2 " },
	                            _react2.default.createElement("input", {
	                              style: { marginTop: "55px" },
	                              type: "text",
	                              className: "form-control",
	                              id: "otherDeathInt",
	                              name: "otherDeathInt",
	                              value: formData.otherDeathInt,
	                              required: true,
	                              onChange: function onChange(e) {
	                                return setFormData(Object.assign({}, formData, {
	                                  otherDeathInt: e.target.value
	                                }));
	                              }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group col-md-8 pb-2 " },
	                            _react2.default.createElement(
	                              "label",
	                              { htmlFor: "dateOfDeath" },
	                              "Date of Death:"
	                            ),
	                            _react2.default.createElement(_reactDatepicker2.default, {
	                              className: "form-control",
	                              selected: rawDate1,
	                              value: rawDate1,
	                              onChange: function onChange(date) {
	                                return handleDateChange1(date);
	                              },
	                              dateFormat: "dd/MM/yyyy",
	                              placeholderText: "DD/MM/YYYY",
	                              showDateMonthYearPicker: true
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-group col-md-4 pb-2 " },
	                            _react2.default.createElement(
	                              "label",
	                              { htmlFor: "certifyingDoc" },
	                              "Certifying Doctor/Register:"
	                            ),
	                            _react2.default.createElement("input", {
	                              type: "text",
	                              className: "form-control",
	                              id: "certifyingDoc",
	                              name: "certifyingDoc",
	                              value: formData.certifyingDoc,
	                              required: true,
	                              onChange: function onChange(e) {
	                                return setFormData(Object.assign({}, formData, {
	                                  certifyingDoc: e.target.value
	                                }));
	                              }
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12" },
	                        _react2.default.createElement(
	                          "h5",
	                          { className: " text-center mb-5 mt-3" },
	                          "Body Handover Information"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6 " },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "deadBodyTaken" },
	                          "Dead Body Taken by:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "deadBodyTaken",
	                          name: "deadBodyTaken",
	                          value: formData.deadBodyTaken,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              deadBodyTaken: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6 " },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "deadBodyTakenTime" },
	                          "Date:"
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          className: "form-control",
	                          selected: rawDate2,
	                          value: rawDate2,
	                          onChange: function onChange(date) {
	                            return handleDateChange2(date);
	                          },
	                          dateFormat: "dd/MM/yyyy",
	                          placeholderText: "DD/MM/YYYY",
	                          showDateMonthYearPicker: true
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6 " },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "relationWithDead" },
	                          "Relation With Patient:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "relationWithDead",
	                          name: "relationWithDead",
	                          value: formData.relationWithDead,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              relationWithDead: e.target.value
	                            }));
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group col-md-6 " },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "witnessName" },
	                          "Name of Witness:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "witnessName",
	                          name: "witnessName",
	                          value: formData.witnessName,
	                          required: true,
	                          onChange: function onChange(e) {
	                            return setFormData(Object.assign({}, formData, {
	                              witnessName: e.target.value
	                            }));
	                          }
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        className: "buts",
	                        type: "submit",
	                        disabled: enableBtn
	                      },
	                      "Submit"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = DeathCertificate;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _SingleDepartmentView = __webpack_require__(212);
	
	var _SingleDepartmentView2 = _interopRequireDefault(_SingleDepartmentView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {API_TOKEN_NAME} from '../../constants';
	
	//import { scAxios } from '../..';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	
	
	var DepartmentView = function (_Component) {
	  _inherits(DepartmentView, _Component);
	
	  function DepartmentView() {
	    _classCallCheck(this, DepartmentView);
	
	    return _possibleConstructorReturn(this, (DepartmentView.__proto__ || Object.getPrototypeOf(DepartmentView)).apply(this, arguments));
	  }
	
	  _createClass(DepartmentView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(_SingleDepartmentView2.default, { currentDocId: this.props.match.params.name }),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return DepartmentView;
	}(_react.Component);
	
	exports.default = DepartmentView;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _SingleDepartmentView = __webpack_require__(212);
	
	var _SingleDepartmentView2 = _interopRequireDefault(_SingleDepartmentView);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _icon = __webpack_require__(57);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _bannerCaseStudy = __webpack_require__(1137);
	
	var _bannerCaseStudy2 = _interopRequireDefault(_bannerCaseStudy);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _BookAppointmentPopup = __webpack_require__(60);
	
	var _BookAppointmentPopup2 = _interopRequireDefault(_BookAppointmentPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DepartmentsView = function DepartmentsView() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      departments = _useState2[0],
	      setDepartments = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      hoverId = _useState4[0],
	      setHoverId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      bookAppointmentPopupClicked = _useState6[0],
	      setBookAppointmentPopupClicked = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    var getAllBannerButtonData = function getAllBannerButtonData(data) {
	      try {
	        var req = _.scAxiosAdmin.request("/department/getdepartments", {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          },
	          params: Object.assign({}, data)
	        }).then(function (data) {
	          if (data.status === 200) {
	            setDepartments(data.data.data);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getAllBannerButtonData();
	  }, []);
	
	  /* getAllDepartments = (data) => {
	    return new Promise((resolve, reject) => {
	      const req = scAxiosAdmin.request("/department/getdepartments", {
	        method: "get",
	        headers: {
	          Accept: "application/json",
	          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	        },
	        params: {
	          ...data,
	        },
	      });
	      req.then((res) => resolve(res.data)).catch((err) => reject(err));
	    });
	  }; */
	
	  /* componentDidMount() {
	    this.getAllDepartments().then((res) => {
	      if (res.status === true) {
	        var records = res.data;
	        this.setState({ departments: records });
	      }
	      console.log(res.data);
	    });
	  } */
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Department | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Department, departments"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      {
	        id: "giveMarginService",
	        className: "",
	        style: { backgroundColor: "#F3EFE8" }
	      },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero " },
	        _react2.default.createElement("img", { src: _bannerCaseStudy2.default, alt: "banner-profile", className: "w-100" })
	      ),
	      _react2.default.createElement(
	        "section",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "container pt-4" },
	          _react2.default.createElement(
	            "h3",
	            {
	              className: "text-center mb-4",
	              style: {
	                color: "#AF9763",
	                fontWeight: "700"
	              }
	            },
	            "Departments"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            departments.map(function (body_department) {
	              var department_name = body_department.department_name;
	              var new_department_name = department_name.replaceAll(" ", "-");
	              return _react2.default.createElement(
	                "div",
	                {
	                  className: "col-sm-6 col-md-4 mb-lg-3 text-center mx-auto",
	                  key: body_department.dept_id
	                },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  {
	                    to: "/departments/" + body_department.slug,
	                    style: {
	                      textDecoration: "none",
	                      display: "inline-block"
	                      // width: "100%",
	                    },
	                    className: "d-flex justify-content-center"
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "doctor-list d-flex align-items-center departmentBg w-100 border-0 shadow-sm"
	                      // style={{ height: "85px" }}
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "card h-100 cardHover d-flex flex-row align-items-center justify-content-around w-100 py-3",
	                        style: { backgroundColor: "#F7F5EF" },
	                        onMouseEnter: function onMouseEnter() {
	                          return setHoverId(body_department.id);
	                        },
	                        onMouseLeave: function onMouseLeave() {
	                          return setHoverId(null);
	                        },
	                        onTouchStart: function onTouchStart() {
	                          return setHoverId(body_department.id);
	                        } // Works on mobile
	                        , onTouchCancel: function onTouchCancel() {
	                          return setHoverId(null);
	                        } // Optional: Hide on touch end
	                      },
	                      body_department.image ? _react2.default.createElement("img", {
	                        className: "w-25",
	                        src: _constants.IMAGE_URL + "DepartmentImage/" + ("" + (hoverId === body_department.id && body_department.image_hover ? body_department.image_hover : body_department.image)),
	                        alt: "avtars",
	                        style: { width: "45px", paddingLeft: "1rem" }
	                      }) : _react2.default.createElement("img", { className: "w-25", src: _icon2.default, alt: "Bitmap-3" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "px-3 w-75" },
	                        _react2.default.createElement(
	                          "p",
	                          {
	                            style: {
	                              fontWeight: "700",
	                              letterSpacing: "1px"
	                            }
	                          },
	                          body_department.department_name
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          {
	                            style: {
	                              fontWeight: "700",
	                              letterSpacing: "1px"
	                            },
	                            className: "text-capitalize "
	                          },
	                          "Department"
	                        )
	                      )
	                    )
	                  )
	                )
	              );
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_BookAppointmentPopup2.default, {
	        bookAppointmentPopupClicked: bookAppointmentPopupClicked,
	        setBookAppointmentPopupClicked: setBookAppointmentPopupClicked
	      })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	  );
	};
	exports.default = DepartmentsView;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DescriptionSection = function DescriptionSection(_ref) {
	  var section = _ref.section;
	
	  return _react2.default.createElement(
	    "section",
	    { className: "container" },
	    _react2.default.createElement(
	      "div",
	      { className: "d-flex flex-column justify-content-between align-items-center p-4" },
	      _react2.default.createElement(
	        "div",
	        {
	          style: {
	            display: "flex",
	            justifyContent: "center",
	            alignItems: "flex-start",
	            flexDirection: "column",
	            width: "82px",
	            // margin: "0 auto",
	            marginBottom: "10px"
	          }
	        },
	        _react2.default.createElement(
	          "h3",
	          {
	            className: "text-center",
	            style: {
	              color: "#AF9763",
	              fontSize: "28px",
	              fontWeight: "500"
	            }
	          },
	          section.sectionTitle
	        )
	      ),
	      _react2.default.createElement("div", {
	        //   className="text-center"
	        dangerouslySetInnerHTML: {
	          __html: section.value.content
	        }
	      })
	    )
	  );
	};
	
	exports.default = DescriptionSection;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	var _jquery = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DischargeProtocols = function DischargeProtocols() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Death Certificate | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "newsevents, Singlenewsevents"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement("div", { id: "giveMargin", className: "" }),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = DischargeProtocols;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _DoctorProfile = __webpack_require__(685);
	
	var _DoctorProfile2 = _interopRequireDefault(_DoctorProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {API_TOKEN_NAME} from '../../constants';
	
	//import { scAxios } from '../..';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	
	
	var DoctorProfile = function (_Component) {
	  _inherits(DoctorProfile, _Component);
	
	  function DoctorProfile() {
	    _classCallCheck(this, DoctorProfile);
	
	    return _possibleConstructorReturn(this, (DoctorProfile.__proto__ || Object.getPrototypeOf(DoctorProfile)).apply(this, arguments));
	  }
	
	  _createClass(DoctorProfile, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(_DoctorProfile2.default, { currentDocId: this.props.match.params.name }),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return DoctorProfile;
	}(_react.Component);
	
	exports.default = DoctorProfile;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	var _jquery = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EveningOPD = function EveningOPD() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Evening OPD | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "newsevents, Singlenewsevents"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement("div", { id: "giveMargin", className: "" }),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = EveningOPD;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _userSession = __webpack_require__(30);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Loading_icon = __webpack_require__(56);
	
	var _Loading_icon2 = _interopRequireDefault(_Loading_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FindDoctorAndDepartmentPopup = function FindDoctorAndDepartmentPopup(_ref) {
	  var findADoctorPopupClicked = _ref.findADoctorPopupClicked,
	      setFindADoctorPopupClicked = _ref.setFindADoctorPopupClicked;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchResults = _useState2[0],
	      setSearchResults = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      searchResultsDepartments = _useState4[0],
	      setSearchResultsDepartments = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      allDepartments = _useState6[0],
	      setAllDepartments = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(),
	      _useState8 = _slicedToArray(_useState7, 2),
	      departmentId = _useState8[0],
	      setDepartmentId = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      loading = _useState10[0],
	      setLoading = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    selectedDepartment: "all",
	    searchedText: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      formData = _useState12[0],
	      setFormData = _useState12[1];
	
	  var input_field_css = {
	    maxHeight: "50px",
	    fontSize: "14px",
	    borderColor: "#cccccc",
	    borderRadius: "5px"
	  };
	  var alertStyle = {
	    color: "red"
	  };
	  var inputStyles = {
	    borderRadius: "10px",
	    background: "#fff",
	    borderRight: "solid 1px #fff",
	    border: "solid 1px #6e6e6ed0",
	    padding: "15px 15px",
	    fontSize: "16px",
	    color: "#000",
	    width: "100%"
	  };
	
	  (0, _react.useEffect)(function () {
	    var getSearchDoctors = function getSearchDoctors(data) {
	      setLoading(true);
	      try {
	        if (findADoctorPopupClicked === true) {
	          var req = _.scAxiosAdmin.request("/search/find_a_doctor", {
	            method: "get",
	            headers: {
	              Accept: "application/json",
	              Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	            },
	            params: {
	              keyword: formData.searchedText,
	              deparment: formData.selectedDepartment
	            }
	          }).then(function (data) {
	            if (data.status === 200) {
	              setLoading(false);
	              setSearchResults(data.data.doctors);
	            }
	          }).catch(function (e) {
	            setLoading(false);
	            console.log("your log output", e);
	          });
	        }
	      } catch (error) {
	        setLoading(false);
	      }
	    };
	    getSearchDoctors();
	  }, [formData.searchedText, departmentId, findADoctorPopupClicked]);
	  (0, _react.useEffect)(function () {
	    var getAllDepartments = function getAllDepartments(data) {
	      try {
	        if (findADoctorPopupClicked === true) {
	          var req = _.scAxiosAdmin.request("/department/getdepartments", {
	            method: "get",
	            headers: {
	              Accept: "application/json",
	              Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	            }
	          }).then(function (data) {
	            if (data.status === 200) {
	              setAllDepartments(data.data.data);
	            }
	          }).catch(function (e) {
	            console.log("your log output", e);
	          });
	        }
	      } catch (error) {}
	    };
	    getAllDepartments();
	  }, [findADoctorPopupClicked]);
	  (0, _react.useEffect)(function () {
	    setDepartmentId(formData.selectedDepartment);
	  }, [formData.selectedDepartment]);
	
	  var handleSubmit = function handleSubmit(event, props) {
	    event.preventDefault();
	  };
	  // console.log("dsgdfgsdfgsd", formData);
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        "class": "offcanvas offcanvas-start",
	        "data-bs-scroll": "true",
	        tabindex: "-1",
	        id: "FindADoctorCanvas",
	        "aria-labelledby": "offcanvasWithBothOptionsLabel"
	      },
	      _react2.default.createElement(
	        "div",
	        { "class": "offcanvas-header" },
	        _react2.default.createElement("h5", { "class": "offcanvas-title", id: "offcanvasWithBothOptionsLabel" }),
	        _react2.default.createElement("button", {
	          type: "button",
	          "class": "btn-close text-reset",
	          "data-bs-dismiss": "offcanvas",
	          "aria-label": "Close"
	          // onClick={() => setFindADoctorPopupClicked(false)}
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { "class": "offcanvas-body" },
	        _react2.default.createElement(
	          "div",
	          { className: "left-offcanvas" },
	          _react2.default.createElement(
	            "h4",
	            { style: { color: "#af9763" } },
	            "Find a Doctor Here"
	          ),
	          _react2.default.createElement(
	            "form",
	            {
	              onSubmit: handleSubmit,
	              id: "registerform",
	              className: "needs-validation",
	              noValidate: true
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "row mb-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group mt-2" },
	                _react2.default.createElement(
	                  "select",
	                  {
	                    style: inputStyles,
	                    name: "selectedDoc",
	                    value: formData.selectedDepartment,
	                    "class": "form-select form-select-lg custom-form-control",
	                    "aria-label": ".form-select-lg example",
	                    onChange: function onChange(e) {
	                      return setFormData(Object.assign({}, formData, {
	                        selectedDepartment: e.target.value
	                      }));
	                    }
	                  },
	                  _react2.default.createElement(
	                    "option",
	                    { disabled: true, selected: true, value: "all" },
	                    "Search by Department"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "all" },
	                    "All Specialist"
	                  ),
	                  allDepartments && allDepartments.length > 0 ? allDepartments.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "option",
	                      { value: item.id },
	                      item && item.department_name
	                    );
	                  }) : ""
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group mt-2" },
	                _react2.default.createElement("input", {
	                  style: inputStyles,
	                  type: "text",
	                  className: "custom-form-control",
	                  placeholder: "Search With Doctor's Name ...",
	                  name: "searchTerm",
	                  id: "searchTerm",
	                  value: formData.searchedText,
	                  onChange: function onChange(e) {
	                    return setFormData(Object.assign({}, formData, { searchedText: e.target.value }));
	                  },
	                  required: true,
	                  autoComplete: "off"
	                  // style={input_field_css}
	                })
	              ),
	              _react2.default.createElement("span", null)
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row mt-3" },
	              searchResults && searchResults.length > 0 ? searchResults.map(function (search_doctor) {
	                return _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  {
	                    style: { textDecoration: "none" },
	                    to: "/consultant/" + search_doctor.slug
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 sp-0-0 mb-3",
	                      key: search_doctor.id
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "doctor-list" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "col-3",
	                            style: { paddingLeft: "0px" }
	                          },
	                          search_doctor.doctor_profile ? _react2.default.createElement("img", {
	                            src: _constants.IMAGE_URL + "DoctorProfileImg/" + search_doctor.doctor_profile,
	                            alt: "doctor profile"
	                          }) : _react2.default.createElement("img", {
	                            src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                            alt: "doc"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-9 mt-2" },
	                          _react2.default.createElement(
	                            "h5",
	                            null,
	                            search_doctor.doctor_name
	                          ),
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            search_doctor.degree !== "" ? search_doctor.degree : "Endocrinology & Metabolism) MD (Endocrinology & Metabolism)"
	                          )
	                        )
	                      )
	                    )
	                  )
	                );
	              }) : _react2.default.createElement(
	                "div",
	                { className: "col-12 sp-0-0 mb-3" },
	                loading ? _react2.default.createElement("img", { src: _Loading_icon2.default, alt: "Loading" }) : _react2.default.createElement(
	                  "p",
	                  { style: { color: "red" } },
	                  "No results found!"
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = FindDoctorAndDepartmentPopup;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(64);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	__webpack_require__(43);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sendemailforreset = function sendemailforreset(url, data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request(url, {
	      method: "post",
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var ForgotPass = function (_Component) {
	  _inherits(ForgotPass, _Component);
	
	  function ForgotPass(props) {
	    _classCallCheck(this, ForgotPass);
	
	    var _this = _possibleConstructorReturn(this, (ForgotPass.__proto__ || Object.getPrototypeOf(ForgotPass)).call(this, props));
	
	    _this.state = {
	      email: "",
	      loading: false,
	      error: null
	    };
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(ForgotPass, [{
	    key: "handleInputChange",
	    value: function handleInputChange(event) {
	      var _setState;
	
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, "error", ""), _defineProperty(_setState, "success", false), _setState));
	    }
	  }, {
	    key: "handleSubmit",
	    value: function handleSubmit(event) {
	      var _this2 = this;
	
	      event.preventDefault();
	      // const { email } = this.state;
	      this.setState({ loading: true });
	      var data = {
	        email: this.state.email,
	        base_url: window.location.origin
	      };
	
	      sendemailforreset("/forgetpassword", data).then(function (response) {
	        _this2.setState({ loading: false });
	        console.log(response);
	        if (response.status) {
	          _reactToastify.toast.success(response.message);
	        } else {
	          _reactToastify.toast.error(response.message);
	        }
	      }).catch(function (error) {
	        _this2.setState({ error: error, loading: false });
	      });
	
	      // this.setState({ success: true });
	    }
	
	    // ERP API
	    // handleSubmit(event) {
	    //     event.preventDefault();
	    //     // const { email } = this.state;
	    //     this.setState({ loading: true });
	    //     const data = { email: this.state.email };
	
	    //     sendemailforreset('forgetpassword',data)
	    //         .then(response => {
	    //             this.setState({ loading: false });
	    //             console.log(response)
	    //             if(response.status){
	    //                 toast.success(response.message)
	    //             }
	    //             else{
	    //                 toast.error(response.message)
	    //             }
	    //         })
	    //         .catch(error => {
	    //             this.setState({ error, loading: false });
	    //         });
	
	    //     // this.setState({ success: true });
	    // }
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          email = _state.email,
	          loading = _state.loading,
	          error = _state.error,
	          success = _state.success;
	
	      // if (loading) {
	      //     return <div>Loading...</div>;
	      // }
	
	      // if (error) {
	      //     return <div>Error: {error.message}</div>;
	      // }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "borders" },
	        _react2.default.createElement(
	          "form",
	          { className: "form-content", onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            "h5",
	            { className: "text-center" },
	            "Forgot Password"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "mb-3" },
	            _react2.default.createElement(
	              "label",
	              { "for": "exampleInputEmail1", className: "form-label" },
	              "Email address"
	            ),
	            _react2.default.createElement("input", {
	              type: "email",
	              className: "form-control",
	              name: "email",
	              value: email,
	              id: "exampleInputEmail1",
	              "aria-describedby": "emailHelp",
	              onChange: this.handleInputChange,
	              required: true
	            }),
	            _react2.default.createElement("div", { id: "emailHelp", className: "form-text" })
	          ),
	          loading ? _react2.default.createElement(
	            "p",
	            null,
	            "Loading! Please wait..."
	          ) : null,
	          _react2.default.createElement(
	            "button",
	            { type: "submit", className: "butttons" },
	            "Send your email"
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "/" },
	            "Back to home"
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return ForgotPass;
	}(_react.Component);
	
	exports.default = ForgotPass;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _chart = __webpack_require__(100);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeartRateChart = function HeartRateChart(_ref) {
	  var data = _ref.data;
	
	  var chartRef = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    var ctx = chartRef.current.getContext('2d');
	    var myChart = new _chart2.default(ctx, {
	      type: 'line',
	      data: {
	        labels: data.labels,
	        datasets: [{
	          label: 'Heart Rate',
	          borderColor: '#12A150',
	          data: data.datasets[0].data
	        }]
	      }
	    });
	
	    return function () {
	      myChart.destroy(); // Cleanup on component unmount
	    };
	  }, [data]);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('canvas', { ref: chartRef, width: '400', height: '200' })
	  );
	};
	
	exports.default = HeartRateChart;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	//import NewCenterExcellence from "../../component/frontend/commonsections/NewCenterExcellence";
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _HomeSearch = __webpack_require__(86);
	
	var _HomeSearch2 = _interopRequireDefault(_HomeSearch);
	
	var _CenterExcellence = __webpack_require__(85);
	
	var _CenterExcellence2 = _interopRequireDefault(_CenterExcellence);
	
	var _NewsEventsSilde = __webpack_require__(71);
	
	var _NewsEventsSilde2 = _interopRequireDefault(_NewsEventsSilde);
	
	var _PublicationsSilde = __webpack_require__(72);
	
	var _PublicationsSilde2 = _interopRequireDefault(_PublicationsSilde);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _HeaderHome = __webpack_require__(111);
	
	var _HeaderHome2 = _interopRequireDefault(_HeaderHome);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _RecommendedPackage = __webpack_require__(496);
	
	var _RecommendedPackage2 = _interopRequireDefault(_RecommendedPackage);
	
	var _Testimonials = __webpack_require__(683);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _JCI = __webpack_require__(677);
	
	var _JCI2 = _interopRequireDefault(_JCI);
	
	var _CaseStudy = __webpack_require__(211);
	
	var _CaseStudy2 = _interopRequireDefault(_CaseStudy);
	
	var _HomeSearchUp = __webpack_require__(675);
	
	var _HomeSearchUp2 = _interopRequireDefault(_HomeSearchUp);
	
	var _NewsSlides = __webpack_require__(679);
	
	var _NewsSlides2 = _interopRequireDefault(_NewsSlides);
	
	var _HomeModal = __webpack_require__(630);
	
	var _HomeModal2 = _interopRequireDefault(_HomeModal);
	
	var _NewJciComponent = __webpack_require__(678);
	
	var _NewJciComponent2 = _interopRequireDefault(_NewJciComponent);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _HomeDepartmentBtnSectionMobile = __webpack_require__(629);
	
	var _HomeDepartmentBtnSectionMobile2 = _interopRequireDefault(_HomeDepartmentBtnSectionMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function Home() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      departments = _useState2[0],
	      setDepartments = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      hoverId = _useState4[0],
	      setHoverId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      banners = _useState6[0],
	      setBanners = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      findADoctorPopupClicked = _useState8[0],
	      setFindADoctorPopupClicked = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      bookAppointmentPopupClicked = _useState10[0],
	      setBookAppointmentPopupClicked = _useState10[1];
	
	  (0, _react.useEffect)(function () {
	    var getAllBannerButtonData = function getAllBannerButtonData(data) {
	      try {
	        var req = _.scAxiosAdmin.request("/bannerbutton/getallbannerbtndata", {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          },
	          params: Object.assign({}, data)
	        }).then(function (data) {
	          if (data.status === 200) {
	            setDepartments(data.data.data);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getAllBannerButtonData();
	  }, []);
	  (0, _react.useEffect)(function () {
	    var getAllBanner = function getAllBanner(data) {
	      try {
	        var req = _.scAxiosAdmin.request("/banner", {
	          method: "get"
	        }).then(function (data) {
	          if (data.status === 200) {
	            setBanners(data.data);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getAllBanner();
	  }, []);
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Best Hospital in Bangladesh - United Hospital Limited",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh",
	      pathSlug: "/",
	      keywords: "Home, HomePage"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(
	      "section",
	      {
	        style: {
	          scrollBehavior: "smooth",
	          backgroundColor: "#F7F5EF"
	        }
	      },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	      _react2.default.createElement(
	        "div",
	        { id: "giveMargin", className: "container" },
	        _react2.default.createElement(_HomeSearchUp2.default, {
	          hoverId: hoverId,
	          setHoverId: setHoverId,
	          departments: departments,
	          banners: banners,
	          findADoctorPopupClicked: findADoctorPopupClicked,
	          bookAppointmentPopupClicked: bookAppointmentPopupClicked,
	          setDepartments: setDepartments,
	          setBanners: setBanners,
	          setFindADoctorPopupClicked: setFindADoctorPopupClicked,
	          setBookAppointmentPopupClicked: setBookAppointmentPopupClicked
	        })
	      ),
	      _react2.default.createElement(_HomeDepartmentBtnSectionMobile2.default, {
	        departments: departments,
	        banners: banners,
	        findADoctorPopupClicked: findADoctorPopupClicked,
	        bookAppointmentPopupClicked: bookAppointmentPopupClicked,
	        setDepartments: setDepartments,
	        setBanners: setBanners,
	        setFindADoctorPopupClicked: setFindADoctorPopupClicked,
	        setBookAppointmentPopupClicked: setBookAppointmentPopupClicked
	      })
	    ),
	    _react2.default.createElement(_CenterExcellence2.default, null),
	    _react2.default.createElement(_RecommendedPackage2.default, null),
	    _react2.default.createElement(_Testimonials2.default, null),
	    _react2.default.createElement(_NewJciComponent2.default, null),
	    _react2.default.createElement(_NewsSlides2.default, null),
	    _react2.default.createElement(_NewsEventsSilde2.default, null),
	    _react2.default.createElement(_CaseStudy2.default, null),
	    _react2.default.createElement(_HomeModal2.default, null),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	  );
	};
	exports.default = Home;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeDepartmentBtnSectionMobile = function HomeDepartmentBtnSectionMobile(_ref) {
	  var departments = _ref.departments,
	      banners = _ref.banners,
	      findADoctorPopupClicked = _ref.findADoctorPopupClicked,
	      bookAppointmentPopupClicked = _ref.bookAppointmentPopupClicked,
	      setDepartments = _ref.setDepartments,
	      setBanners = _ref.setBanners,
	      setFindADoctorPopupClicked = _ref.setFindADoctorPopupClicked,
	      setBookAppointmentPopupClicked = _ref.setBookAppointmentPopupClicked;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        className: "col-12 d-flex flex-column justify-content-center align-items-center mt-4 d-md-none",
	        style: { maxWidth: "100%" }
	      },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "d-flex flex-row justify-content-between align-items-center mt-3 p-2 w-100 gap-3 overflow-auto pt-3",
	          style: {
	            backgroundColor: "#FFFFFF",
	            borderRadius: "5px"
	          }
	        },
	        departments.length > 0 ? departments.slice(0, 6).map(function (banner_button) {
	          var buttonSlug = banner_button.department_name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\\/]/gi, "").replace(/\s+/g, "-").replace(/-$/, "").toLowerCase();
	
	          return _react2.default.createElement(
	            "div",
	            { className: "p-0 department-menu" },
	            _react2.default.createElement(
	              "a",
	              {
	                href: _constants.SITE_URL + "/departments/" + buttonSlug,
	                style: { textDecoration: "none" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "card cardHover",
	                  style: {
	                    width: "100%",
	                    margin: "0 auto",
	                    height: "45px",
	                    display: "flex",
	                    justifyContent: "center",
	                    borderRadius: "5px",
	                    backgroundColor: "#F7F5EF",
	                    // color: "#AF9763",
	                    fontWeight: "500"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "p-2 d-flex justify-content-center align-items-center w-100",
	                    style: {
	                      display: "flex",
	                      alignItems: "center",
	                      justifyContent: "center"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "" },
	                    banner_button.banner_btn_icon ? _react2.default.createElement("img", {
	                      // className="ql-background"
	                      src: _constants.IMAGE_URL + "BannerButtonImg/" + banner_button.banner_btn_icon,
	                      alt: "avtars",
	                      style: {
	                        borderRadius: "50%",
	                        width: "100%",
	                        maxWidth: "27px"
	                      }
	                    }) : _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "px-2" },
	                    banner_button.banner_btn_text
	                  )
	                )
	              )
	            )
	          );
	        }) : "",
	        _react2.default.createElement(
	          "div",
	          { className: "p-0 department-menu d-none d-lg-block" },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              className: "d-inline-block w-100",
	              style: { textDecoration: "none" },
	              to: "/pages/departments"
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "card ",
	                style: {
	                  width: "100%",
	                  margin: "0 auto",
	                  height: "45px",
	                  display: "flex",
	                  justifyContent: "center",
	                  borderRadius: "5px",
	                  backgroundColor: "#AF9763",
	                  color: "#ffffff",
	                  fontWeight: "500"
	                }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  style: {
	                    padding: "11px",
	                    color: "#fff",
	                    textTransform: "capitalize",
	                    border: "none",
	                    backgroundColor: "transparent",
	                    borderRadius: "6px",
	                    fontWeight: "500",
	                    width: "100%"
	                  },
	                  className: "deptBtnFont"
	                },
	                "View All Departments"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-12 d-flex justify-content-center align-items-center mb-2 w-100  d-md-none" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "py-3 department-menu d-block d-lg-none w-100 text-center",
	          style: {
	            backgroundColor: "#ffffff",
	            borderBottomRightRadius: "5px",
	            borderBottomLeftRadius: "5px"
	          }
	        },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          {
	            className: "d-inline-block w-50",
	            style: { textDecoration: "none" },
	            to: "/pages/departments"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "card ",
	              style: {
	                width: "100%",
	                margin: "0 auto",
	                height: "45px",
	                display: "flex",
	                justifyContent: "center",
	                borderRadius: "5px",
	                backgroundColor: "#AF9763",
	                color: "#ffffff",
	                fontWeight: "500"
	              }
	            },
	            _react2.default.createElement(
	              "button",
	              {
	                style: {
	                  padding: "11px",
	                  color: "#fff",
	                  textTransform: "capitalize",
	                  border: "none",
	                  backgroundColor: "transparent",
	                  borderRadius: "6px",
	                  fontWeight: "500",
	                  width: "100%"
	                },
	                className: "deptBtnFont"
	              },
	              "View All Departments"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = HomeDepartmentBtnSectionMobile;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // Replace with your actual API handler
	// Replace with your actual constants
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var HomeModal = function HomeModal() {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      showModal = _useState2[0],
	      setShowModal = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      sliders = _useState4[0],
	      setSliders = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activeIndex = _useState6[0],
	      setActiveIndex = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(3000),
	      _useState8 = _slicedToArray(_useState7, 2),
	      modalInterval = _useState8[0],
	      setModalInterval = _useState8[1]; // Default to 3 seconds
	
	  (0, _react.useEffect)(function () {
	    // Check sessionStorage to see if the modal was closed
	    var isModalClosed = sessionStorage.getItem("modalClosed");
	    if (!isModalClosed) {
	      setShowModal(true); // Show the modal if it wasn't closed
	    }
	
	    // Fetch slider data
	    var fetchSliderData = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _.thirdparty.get("/settings?type=popup_slider");
	
	              case 3:
	                response = _context.sent;
	
	                if (response.status === 200) {
	                  setSliders(response.data);
	                }
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching slider data:", _context.t0);
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 7]]);
	      }));
	
	      return function fetchSliderData() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    fetchSliderData();
	
	    // Fetch modal interval
	    var fetchModalInterval = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                _context2.next = 3;
	                return _.thirdparty.get("/settings/26");
	
	              case 3:
	                response = _context2.sent;
	
	                if (response.status === 200) {
	                  setModalInterval(parseInt(response.data.value) * 1000);
	                }
	                _context2.next = 10;
	                break;
	
	              case 7:
	                _context2.prev = 7;
	                _context2.t0 = _context2["catch"](0);
	
	                console.error("Error fetching modal interval:", _context2.t0);
	
	              case 10:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, undefined, [[0, 7]]);
	      }));
	
	      return function fetchModalInterval() {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    fetchModalInterval();
	  }, []);
	
	  var handleCloseModal = function handleCloseModal() {
	    setShowModal(false);
	    sessionStorage.setItem("modalClosed", "true"); // Mark modal as closed in sessionStorage
	  };
	
	  var handleBackdropClick = function handleBackdropClick(e) {
	    if (e.target.classList.contains("modal")) {
	      handleCloseModal();
	    }
	  };
	
	  var goToIndex = function goToIndex(index) {
	    if (index < 0) {
	      index = sliders.length - 1; // Go to the last slide if index is less than 0
	    } else if (index >= sliders.length) {
	      index = 0; // Go to the first slide if index exceeds the length
	    }
	    setActiveIndex(index);
	  };
	
	  var nextSlide = function nextSlide() {
	    goToIndex(activeIndex + 1);
	  };
	
	  // Automatic slide transition
	  (0, _react.useEffect)(function () {
	    if (showModal && sliders.length > 0) {
	      var interval = setInterval(function () {
	        nextSlide();
	      }, modalInterval);
	
	      return function () {
	        return clearInterval(interval);
	      }; // Clear the interval when the modal closes or unmounts
	    }
	  }, [showModal, activeIndex, modalInterval, sliders.length]);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    showModal && sliders.length > 0 && _react2.default.createElement(
	      "div",
	      {
	        className: "modal fade show",
	        tabIndex: "-1",
	        role: "dialog",
	        style: { display: "block", backgroundColor: "rgba(0,0,0,0.5)" },
	        onClick: handleBackdropClick
	      },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "modal-dialog modal-dialog-centered modal-lg",
	          role: "document"
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "modal-content border-0",
	            style: { backgroundColor: "transparent" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-body p-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "carousel slide" },
	              _react2.default.createElement(
	                "div",
	                { className: "carousel-inner" },
	                sliders.map(function (media, index) {
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      key: media.id,
	                      className: "carousel-item " + (index === activeIndex ? "active" : "")
	                    },
	                    _react2.default.createElement("img", {
	                      src: "" + _constants.IMAGE_URL + media.file_path,
	                      className: "d-block w-100",
	                      alt: "Slide " + (index + 1),
	                      style: {
	                        height: "auto",
	                        maxHeight: "80vh",
	                        objectFit: "contain"
	                      }
	                    })
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  className: "carousel-control-prev",
	                  type: "button",
	                  onClick: function onClick() {
	                    return goToIndex(activeIndex - 1);
	                  }
	                },
	                _react2.default.createElement("span", {
	                  className: "carousel-control-prev-icon",
	                  "aria-hidden": "true"
	                }),
	                _react2.default.createElement(
	                  "span",
	                  { className: "visually-hidden" },
	                  "Previous"
	                )
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  className: "carousel-control-next",
	                  type: "button",
	                  onClick: function onClick() {
	                    return goToIndex(activeIndex + 1);
	                  }
	                },
	                _react2.default.createElement("span", {
	                  className: "carousel-control-next-icon",
	                  "aria-hidden": "true"
	                }),
	                _react2.default.createElement(
	                  "span",
	                  { className: "visually-hidden" },
	                  "Next"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "carousel-indicators" },
	                sliders.map(function (media, index) {
	                  return _react2.default.createElement("button", {
	                    key: media.id,
	                    type: "button",
	                    className: "indicator " + (index === activeIndex ? "active" : ""),
	                    "aria-current": index === activeIndex,
	                    "aria-label": "Slide " + (index + 1),
	                    onClick: function onClick() {
	                      return goToIndex(index);
	                    },
	                    style: {
	                      width: _reactDeviceDetect.isIOS ? "2rem" : "12px",
	                      height: _reactDeviceDetect.isIOS ? "2rem" : "14px",
	                      borderRadius: "50%",
	                      margin: "0 5px",
	                      backgroundColor: index === activeIndex ? "#AF9763" : "#fff",
	                      border: "1px solid #AF9763",
	                      cursor: "pointer"
	                    }
	                  });
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = HomeModal;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _jquery = __webpack_require__(18);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var HomeSampleCollection = function HomeSampleCollection() {
	    var _useState = (0, _react.useState)(true),
	        _useState2 = _slicedToArray(_useState, 2),
	        enableBtn = _useState2[0],
	        setEnableBtn = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        loading = _useState4[0],
	        setLoading = _useState4[1];
	
	    var _useState5 = (0, _react.useState)({
	        first_name: "",
	        phone_number: "",
	        email: "",
	        address: "",
	        message: "",
	        user_file: ""
	    }),
	        _useState6 = _slicedToArray(_useState5, 2),
	        formData = _useState6[0],
	        setFormData = _useState6[1];
	
	    (0, _react.useEffect)(function () {
	        console.log("form data", formData);
	        if (formData.first_name && formData.phone_number && formData.email && formData.address && formData.message) {
	            setEnableBtn(false);
	        } else {
	            setEnableBtn(true);
	        }
	    }, [formData]);
	
	    var handleFileChange = function handleFileChange(e) {
	        var file = e.target.files[0];
	
	        // Check if a file was selected
	        if (file) {
	            // Update the formData state by setting the author_profile_pic to the selected file
	            setFormData(Object.assign({}, formData, {
	                user_file: file
	            }));
	        }
	    };
	
	    var handleSubmit = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	            var response;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            e.preventDefault();
	                            setLoading(true);
	                            _context.prev = 2;
	                            _context.next = 5;
	                            return _.thirdparty.post("/home_sample_collections", formData, {
	                                headers: {
	                                    "Content-Type": "multipart/form-data"
	                                }
	                            });
	
	                        case 5:
	                            response = _context.sent;
	
	
	                            if (response.status === 201) {
	                                _reactToastify.toast.success("Your request is received, you will be notified soon!");
	                                setLoading(false);
	                            } else {
	                                _reactToastify.toast.error("Ops something went wrong!");
	                                setLoading(false);
	                            }
	
	                            console.log("Form data sent:", response.status);
	                            _context.next = 13;
	                            break;
	
	                        case 10:
	                            _context.prev = 10;
	                            _context.t0 = _context["catch"](2);
	
	                            console.error("Error submitting form:", _context.t0);
	                            // Handle errors, show error messages, etc.
	
	                        case 13:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[2, 10]]);
	        }));
	
	        return function handleSubmit(_x) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	            title: "Home Sample Collection | Best Hospital in Bangladesh | United Hospital",
	            description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	            pathSlug: "/",
	            keywords: "Home Sample Collection "
	        }),
	        _react2.default.createElement(
	            _reactHelmet.Helmet,
	            null,
	            _react2.default.createElement("meta", {
	                name: "description",
	                content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	            }),
	            _react2.default.createElement(
	                "script",
	                { type: "application/ld+json" },
	                JSON.stringify({
	                    "@context": "http://schema.org",
	                    "@type": "LocalBusiness",
	                    name: "United Hospital Limited",
	                    image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	                    telephone: "10666",
	                    email: "info@uhlbd.com",
	                    address: {
	                        "@type": "PostalAddress",
	                        streetAddress: "plot 15, Road 71, Gulshan",
	                        addressLocality: "Dhaka",
	                        addressRegion: "Dhaka",
	                        addressCountry: "Bangladesh",
	                        postalCode: "1212"
	                    },
	                    openingHoursSpecification: {
	                        "@type": "OpeningHoursSpecification",
	                        opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	                    },
	                    url: "http://www.uhlbd.com/",
	                    aggregateRating: {
	                        "@type": "AggregateRating",
	                        ratingValue: "3.9",
	                        bestRating: "5",
	                        worstRating: "1",
	                        ratingCount: "756"
	                    },
	                    review: {
	                        "@type": "Review",
	                        author: {
	                            "@type": "Person",
	                            name: "abdul kahar"
	                        },
	                        datePublished: "2019-02-12",
	                        reviewRating: {
	                            "@type": "Rating",
	                            ratingValue: "3.9",
	                            bestRating: "5",
	                            worstRating: "1"
	                        },
	                        reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	                    }
	                })
	            ),
	            _react2.default.createElement("meta", {
	                name: "Subject",
	                content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	            }),
	            _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	            _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	            _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	            _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	            _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	            _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	            _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	            _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	            _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	            _react2.default.createElement("meta", {
	                name: "classification",
	                content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	            }),
	            _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	            _react2.default.createElement("meta", {
	                names: "apple-mobile-web-app-status-bar-style",
	                content: "black-translucent"
	            }),
	            _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	            "div",
	            { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	            _react2.default.createElement(
	                "section",
	                { className: "banner-hero" },
	                _react2.default.createElement("img", {
	                    src: "/static/media/banner-profile.f160a4c1.jpg",
	                    alt: "banner-profile",
	                    className: "w-100"
	                })
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: "prof-dr py-5" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "box-of-about border-part py-4" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "row gy-4" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "col-md-12" },
	                                    _react2.default.createElement(
	                                        "h3",
	                                        {
	                                            className: "text-center mb-5",
	                                            style: {
	                                                color: "#0C807D",
	                                                fontWeight: "700"
	                                            }
	                                        },
	                                        "Request for Home Sample Collection"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "col-md-12" },
	                                    _react2.default.createElement(
	                                        "form",
	                                        { action: "", onSubmit: handleSubmit },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "row" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "form-group col-md-4" },
	                                                _react2.default.createElement(
	                                                    "label",
	                                                    { htmlFor: "first_name" },
	                                                    "Name: *"
	                                                ),
	                                                _react2.default.createElement("input", {
	                                                    type: "text",
	                                                    className: "form-control",
	                                                    id: "first_name",
	                                                    name: "first_name",
	                                                    value: formData.first_name,
	                                                    placeholder: "Your full name",
	                                                    required: true,
	                                                    onChange: function onChange(e) {
	                                                        return setFormData(Object.assign({}, formData, { first_name: e.target.value }));
	                                                    }
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "form-group col-md-4" },
	                                                _react2.default.createElement(
	                                                    "label",
	                                                    { htmlFor: "phone_number" },
	                                                    "Phone: *"
	                                                ),
	                                                _react2.default.createElement("input", {
	                                                    type: "text",
	                                                    className: "form-control",
	                                                    id: "phone_number",
	                                                    name: "phone_number",
	                                                    value: formData.phone_number,
	                                                    placeholder: "Your phone number",
	                                                    required: true,
	                                                    onChange: function onChange(e) {
	                                                        return setFormData(Object.assign({}, formData, { phone_number: e.target.value }));
	                                                    }
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "form-group col-md-4" },
	                                                _react2.default.createElement(
	                                                    "label",
	                                                    { htmlFor: "email" },
	                                                    "Email: *"
	                                                ),
	                                                _react2.default.createElement("input", {
	                                                    type: "text",
	                                                    className: "form-control",
	                                                    id: "email",
	                                                    name: "email",
	                                                    placeholder: "Your email address",
	                                                    value: formData.email,
	                                                    required: true,
	                                                    onChange: function onChange(e) {
	                                                        return setFormData(Object.assign({}, formData, { email: e.target.value }));
	                                                    }
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "form-group col-md-6" },
	                                                _react2.default.createElement(
	                                                    "label",
	                                                    { htmlFor: "address" },
	                                                    "Address: *"
	                                                ),
	                                                _react2.default.createElement("textarea", {
	                                                    type: "text",
	                                                    className: "form-control",
	                                                    id: "address",
	                                                    name: "address",
	                                                    value: formData.address,
	                                                    required: true,
	                                                    placeholder: "House No, Road No, Area, City, Country",
	                                                    onChange: function onChange(e) {
	                                                        return setFormData(Object.assign({}, formData, { address: e.target.value }));
	                                                    }
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "form-group col-md-6" },
	                                                _react2.default.createElement(
	                                                    "label",
	                                                    { htmlFor: "message" },
	                                                    "Message:"
	                                                ),
	                                                _react2.default.createElement("textarea", {
	                                                    type: "text",
	                                                    className: "form-control",
	                                                    id: "message",
	                                                    name: "message",
	                                                    value: formData.message,
	                                                    placeholder: "write your message here",
	                                                    onChange: function onChange(e) {
	                                                        return setFormData(Object.assign({}, formData, { message: e.target.value }));
	                                                    }
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "form-group col-md-12" },
	                                                _react2.default.createElement(
	                                                    "label",
	                                                    { htmlFor: "Email" },
	                                                    "Prescription / File Upload:"
	                                                ),
	                                                _react2.default.createElement("input", {
	                                                    type: "file",
	                                                    className: "form-control",
	                                                    name: "user_file",
	                                                    id: "user_file",
	                                                    onChange: handleFileChange,
	                                                    accept: "image/*" // Specify the accepted file types if needed
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "button",
	                                            {
	                                                className: "buts",
	                                                type: "submit",
	                                                disabled: enableBtn
	                                            },
	                                            "Submit"
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	    );
	};
	
	exports.default = HomeSampleCollection;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Search = __webpack_require__(680);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Ceo = __webpack_require__(673);
	
	var _Ceo2 = _interopRequireDefault(_Ceo);
	
	var _NewsEventsSilde = __webpack_require__(71);
	
	var _NewsEventsSilde2 = _interopRequireDefault(_NewsEventsSilde);
	
	var _PublicationsSilde = __webpack_require__(72);
	
	var _PublicationsSilde2 = _interopRequireDefault(_PublicationsSilde);
	
	var _Homcardic = __webpack_require__(687);
	
	var _Homcardic2 = _interopRequireDefault(_Homcardic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {API_TOKEN_NAME} from '../../constants';
	
	//import { scAxios } from '../..';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	
	//import CenterExcellence from "../../component/frontend/commonsections/CenterExcellence";
	
	
	var Homecardicepage = function (_Component) {
	  _inherits(Homecardicepage, _Component);
	
	  function Homecardicepage() {
	    _classCallCheck(this, Homecardicepage);
	
	    return _possibleConstructorReturn(this, (Homecardicepage.__proto__ || Object.getPrototypeOf(Homecardicepage)).apply(this, arguments));
	  }
	
	  _createClass(Homecardicepage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(_Search2.default, null),
	        _react2.default.createElement(_Homcardic2.default, null),
	        _react2.default.createElement(_Ceo2.default, null),
	        _react2.default.createElement(_NewsEventsSilde2.default, null),
	        _react2.default.createElement(_PublicationsSilde2.default, null),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return Homecardicepage;
	}(_react.Component);
	
	exports.default = Homecardicepage;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	// import LabPrice from "../../assets/data/Lab_and_radiology_Prices_for_website.json";
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _jquery = __webpack_require__(18);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _MyProvider = __webpack_require__(48);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Investigation = function Investigation() {
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchTerm = _useState2[0],
	      setSearchTerm = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(1),
	      _useState4 = _slicedToArray(_useState3, 2),
	      currentPage = _useState4[0],
	      setCurrentPage = _useState4[1];
	
	  var itemsPerPage = 10; // Number of items to display per page
	
	  var _useContext = (0, _react.useContext)(_MyProvider.MyContext),
	      addToCart = _useContext.addToCart,
	      isInCart = _useContext.isInCart;
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filteredData = _useState6[0],
	      setfilteredData = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      LabPrice = _useState8[0],
	      setLabPrice = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      loading = _useState10[0],
	      setLoading = _useState10[1];
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function fetchData() {
	      setLoading(true);
	      try {
	        var response = _.scAxiosAdmin.get("/investigations").then(function (result) {
	          setLabPrice(result.data);
	          setLoading(false);
	        }).catch(function (error) {
	          setLoading(false);
	        });
	      } catch (error) {
	        console.error("Error fetching data:", error.message);
	      } finally {
	        setLoading(false);
	      }
	    };
	
	    fetchData(); // Initial data fetch
	  }, []);
	  // Filter data based on search term
	
	  (0, _react.useEffect)(function () {
	    var filteredData = LabPrice && LabPrice.filter(function (item) {
	      return item["Product_Name"].toLowerCase().includes(searchTerm.toLowerCase());
	    });
	
	    setfilteredData(filteredData);
	  }, [LabPrice, searchTerm]);
	  // Get current items to display
	  var indexOfLastItem = currentPage * itemsPerPage;
	  var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  var currentItems = filteredData ? filteredData.slice(indexOfFirstItem, indexOfLastItem) : [];
	
	  // Handle search term change
	  var handleSearch = function handleSearch(event) {
	    setSearchTerm(event.target.value);
	    setCurrentPage(1);
	  };
	
	  // Handle page change
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setCurrentPage(pageNumber);
	  };
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Investigation | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "newsevents, Singlenewsevents"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "pt-5" },
	      _react2.default.createElement(
	        "form",
	        {
	          className: "container d-flex w-75 mx-auto mb-3 align-items-center form-control",
	          role: "search"
	        },
	        _react2.default.createElement("input", {
	          className: "form-control me-2 ",
	          type: "search",
	          placeholder: "Search",
	          "aria-label": "Search",
	          value: searchTerm,
	          onChange: handleSearch,
	          style: { background: "transparent", border: "none" }
	        }),
	        _react2.default.createElement(
	          "svg",
	          {
	            xmlns: "http://www.w3.org/2000/svg",
	            width: "16",
	            height: "16",
	            fill: "currentColor",
	            className: "bi bi-search",
	            viewBox: "0 0 16 16"
	          },
	          _react2.default.createElement("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "table-responsive" },
	        _react2.default.createElement(
	          "table",
	          { className: "container table table-striped table-hover mx-auto" },
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "S.N."
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Product Name"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Product Group"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "OPD Price"
	              ),
	              _react2.default.createElement(
	                "th",
	                { className: "ps-5" },
	                "Action"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            currentItems ? currentItems.map(function (item) {
	              return _react2.default.createElement(
	                "tr",
	                { key: item["id"] },
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  item["id"]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  item["Product_Name"]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  item["Product_Group"]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  item["opd_amount"]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "" },
	                  isInCart(item.id) ? _react2.default.createElement(
	                    "button",
	                    {
	                      style: { backgroundColor: "#187979" },
	                      className: "btn btn-sm rounded rounded-lg invBtn",
	                      onClick: function onClick() {
	                        return addToCart(item, "investigation");
	                      }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "d-inline-block",
	                        style: { position: "relative" }
	                      },
	                      _react2.default.createElement("i", { className: "fa-solid fa-trash-can me-2" })
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "d-none d-lg-inline-block" },
	                      "Remove From Cart",
	                      " "
	                    )
	                  ) : _react2.default.createElement(
	                    "button",
	                    {
	                      style: { backgroundColor: "#187979" },
	                      className: "btn btn-sm rounded rounded-lg invBtn",
	                      onClick: function onClick() {
	                        return addToCart(item, "investigation");
	                      }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "d-inline-block",
	                        style: { position: "relative" }
	                      },
	                      _react2.default.createElement("i", { className: "fa-solid fa-bag-shopping me-2" })
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "d-none d-lg-inline-block" },
	                      "Add to Cart"
	                    )
	                  )
	                )
	              );
	            }) : ""
	          )
	        )
	      ),
	      _react2.default.createElement(_reactJsPagination2.default, {
	        activePage: currentPage,
	        itemsCountPerPage: itemsPerPage,
	        totalItemsCount: filteredData ? filteredData.length : 1,
	        pageRangeDisplayed: 5,
	        onChange: handlePageChange
	      })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Investigation;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactToastify = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var JobApplicationForm = function JobApplicationForm() {
	  var _useState = (0, _react.useState)({
	    firstName: "",
	    lastName: "",
	    email: "",
	    phoneNumber: "",
	    department: "",
	    expectedSalary: "",
	    resume: null
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  var inputStyle = {
	    width: "100%",
	    borderBottom: "1px solid #B5B5B6",
	    fontSize: "16px",
	    outline: "none",
	    borderLeft: "none",
	    borderRight: "none",
	    borderTop: "none",
	    padding: "8px 8px 8px 0",
	    textAlign: "left"
	  };
	
	  var fileInputContainerStyle = {
	    borderBottom: "1px solid #B5B5B6",
	    paddingBottom: ".5rem",
	    width: "97%"
	  };
	
	  var fileInputStyle = {
	    fontSize: "16px",
	    outline: "none",
	    borderLeft: "none",
	    borderRight: "none",
	    borderTop: "none",
	    textAlign: "left"
	  };
	
	  var submitButtonStyle = {
	    fontSize: "16px",
	    width: "118px",
	    height: "43px",
	    backgroundColor: "#AF9763",
	    color: "#fff",
	    textTransform: "capitalize",
	    border: "none",
	    borderRadius: "6px",
	    fontWeight: 500
	  };
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value,
	        files = _e$target.files;
	
	    if (files) {
	      setFormData(function (prevData) {
	        return Object.assign({}, prevData, _defineProperty({}, name, files[0]));
	      });
	    } else {
	      setFormData(function (prevData) {
	        return Object.assign({}, prevData, _defineProperty({}, name, value));
	      });
	    }
	  };
	
	  var handleSubmit = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(event) {
	      var body, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              event.preventDefault();
	              body = new FormData();
	
	              body.append("type", "job_application");
	              body.append("job_id", "");
	              body.append("first_name", formData.firstName);
	              body.append("last_name", formData.lastName);
	              body.append("email", formData.email);
	              body.append("phone_number", formData.phoneNumber);
	              body.append("department", formData.department);
	              body.append("expected_salary", formData.expectedSalary);
	              body.append("cover_letter", ""); // Assuming you want to include this
	              body.append("status", "1");
	              body.append("resume", formData.resume);
	
	              _context.prev = 13;
	              _context.next = 16;
	              return _.scAxiosAdmin.post("/job_applications", body, {
	                headers: {
	                  Accept: "application/json",
	                  "Content-Type": "multipart/form-data",
	                  Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	                }
	              });
	
	            case 16:
	              response = _context.sent;
	
	
	              if (response.status === 201) {
	                _reactToastify.toast.success("Application Submitted Successfully");
	              }
	              _context.next = 23;
	              break;
	
	            case 20:
	              _context.prev = 20;
	              _context.t0 = _context["catch"](13);
	
	              _reactToastify.toast.error("Something went wrong!");
	
	            case 23:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[13, 20]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "section",
	    { "class": "container mt-4 mb-4" },
	    _react2.default.createElement(
	      "h3",
	      {
	        style: {
	          color: "#AF9763",
	          fontWeight: "500"
	        },
	        className: "text-center mb-4"
	      },
	      "JOB APPLICATION"
	    ),
	    _react2.default.createElement(
	      "div",
	      {
	        "class": "row pt-5 pb-5 border justify-content-md-between",
	        style: { backgroundColor: "#FFFFFF", borderRadius: "10px" }
	      },
	      _react2.default.createElement(
	        "div",
	        { "class": "col-12 d-flex" },
	        _react2.default.createElement(
	          "form",
	          { onSubmit: handleSubmit },
	          _react2.default.createElement(
	            "div",
	            { className: "row p-3 g-5 justify-content-around w-100" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6" },
	              _react2.default.createElement("input", {
	                type: "text",
	                placeholder: "First Name",
	                autoComplete: "off",
	                name: "firstName",
	                value: formData.firstName,
	                onChange: handleChange,
	                style: inputStyle
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6" },
	              _react2.default.createElement("input", {
	                type: "text",
	                placeholder: "Last Name",
	                autoComplete: "off",
	                name: "lastName",
	                value: formData.lastName,
	                onChange: handleChange,
	                style: inputStyle
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6" },
	              _react2.default.createElement("input", {
	                type: "email",
	                placeholder: "Email Address",
	                autoComplete: "off",
	                name: "email",
	                value: formData.email,
	                onChange: handleChange,
	                style: inputStyle
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6" },
	              _react2.default.createElement("input", {
	                type: "tel",
	                placeholder: "Phone Number",
	                autoComplete: "off",
	                name: "phoneNumber",
	                value: formData.phoneNumber,
	                onChange: handleChange,
	                style: inputStyle
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6" },
	              _react2.default.createElement("input", {
	                type: "text",
	                placeholder: "Department",
	                autoComplete: "off",
	                name: "department",
	                value: formData.department,
	                onChange: handleChange,
	                style: inputStyle
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6" },
	              _react2.default.createElement("input", {
	                type: "text",
	                placeholder: "Expected Salary",
	                autoComplete: "off",
	                name: "expectedSalary",
	                value: formData.expectedSalary,
	                onChange: handleChange,
	                style: inputStyle
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 px-0", style: fileInputContainerStyle },
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex justify-content-between align-items-end flex-row w-100" },
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Resume/CV"
	                ),
	                _react2.default.createElement("input", {
	                  className: "w-100",
	                  type: "file",
	                  name: "resume",
	                  onChange: handleChange,
	                  style: fileInputStyle
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 d-flex justify-content-center" },
	              _react2.default.createElement(
	                "button",
	                { type: "submit", style: submitButtonStyle },
	                "Apply Now"
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = JobApplicationForm;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	var _reactToastify = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var JobOpeningCard = function JobOpeningCard(_ref) {
	  var section = _ref.section;
	
	  // console.log("sdfs", searchResults);
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      selectedJob = _useState2[0],
	      setSelectedJob = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    firstName: "",
	    lastName: "",
	    email: "",
	    phoneNumber: "",
	    resume: null,
	    userPhoto: null
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      formData = _useState4[0],
	      setFormData = _useState4[1];
	
	  var route = (0, _reactRouterDom.useParams)();
	  function formatDate(dateStr) {
	    var date = new Date(dateStr);
	
	    var day = date.getDate().toString().padStart(2, "0");
	    var year = date.getFullYear();
	
	    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	    var month = monthNames[date.getMonth()];
	
	    return {
	      day: day,
	      month: month,
	      year: year
	    };
	  }
	
	  var inputStyle = {
	    width: "100%",
	    borderBottom: "1px solid #B5B5B6",
	    fontSize: "16px",
	    outline: "none",
	    borderLeft: "none",
	    borderRight: "none",
	    borderTop: "none",
	    padding: "8px 8px 8px 0",
	    textAlign: "left"
	  };
	
	  var fileInputContainerStyle = {
	    borderBottom: "1px solid #B5B5B6",
	    paddingBottom: ".5rem",
	    width: "97%"
	  };
	
	  var fileInputStyle = {
	    fontSize: "16px",
	    outline: "none",
	    borderLeft: "none",
	    borderRight: "none",
	    borderTop: "none",
	    textAlign: "left"
	  };
	
	  var submitButtonStyle = {
	    fontSize: "16px",
	    width: "118px",
	    height: "43px",
	    backgroundColor: "#0C807D",
	    color: "#fff",
	    textTransform: "capitalize",
	    border: "none",
	    borderRadius: "6px",
	    fontWeight: 500
	  };
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value,
	        files = _e$target.files;
	
	    if (files) {
	      setFormData(function (prevData) {
	        return Object.assign({}, prevData, _defineProperty({}, name, files[0]));
	      });
	    } else {
	      setFormData(function (prevData) {
	        return Object.assign({}, prevData, _defineProperty({}, name, value));
	      });
	    }
	  };
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	    var body = new FormData();
	    body.append("type", "career_form");
	    body.append("job_id", selectedJob.id);
	    body.append("first_name", formData.firstName);
	    body.append("last_name", formData.lastName);
	    body.append("email", formData.email);
	    body.append("department", "");
	    body.append("expected_salary", "");
	    body.append("cover_letter", "");
	    body.append("status", "1");
	    body.append("resume", formData.resume);
	    body.append("user_photo", formData.userPhoto);
	    try {
	      var req = _.scAxiosAdmin.post("/job_applications", body, {
	        method: "post",
	        headers: {
	          Accept: "application/json",
	          "Content-Type": "multipart/form-data",
	          Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	        }
	      }).then(function (data) {
	        if (data.status === 201) {
	          _reactToastify.toast.success("Application Submitted Successfully");
	        }
	      }).catch(function (e) {
	        _reactToastify.toast.error("Something went wrong!");
	      });
	    } catch (error) {
	      _reactToastify.toast.error("Something went wrong!");
	    }
	  };
	  return _react2.default.createElement(
	    "section",
	    { className: "container mt-4 mb-4" },
	    _react2.default.createElement(
	      "h3",
	      {
	        style: {
	          color: "#AF9763",
	          fontWeight: "500"
	        },
	        className: "text-center mb-4"
	      },
	      section.sectionTitle
	    ),
	    _react2.default.createElement(
	      "div",
	      { "class": "row row-cols-1 row-cols-md-2 g-4" },
	      section.value.length > 0 ? section.value.map(function (job, index) {
	        return _react2.default.createElement(
	          "div",
	          { "class": "col" },
	          _react2.default.createElement(
	            "div",
	            { "class": "card h-100 shadow" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "d-flex pt-3 pb-3 align-items-start px-3 gap-3",
	                style: { backgroundColor: "#FEECDD" }
	              },
	              job.media.length > 0 ? _react2.default.createElement("img", {
	                src: "" + _constants.IMAGE_URL + job.media[0],
	                alt: "",
	                style: { width: "10%", height: "35px" }
	              }) : _react2.default.createElement("img", {
	                src: "/assets/images/united_logo.png",
	                alt: "",
	                style: { width: "10%", height: "35px" }
	              }),
	              _react2.default.createElement(
	                "h3",
	                {
	                  className: "px-3",
	                  style: {
	                    fontSize: "22px",
	                    textTransform: "capitalize",
	                    borderLeft: "2px solid #F58220"
	                  }
	                },
	                job.title
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "card-body" },
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex justify-content-between align-items-center" },
	                _react2.default.createElement("div", {
	                  className: "w-75",
	                  dangerouslySetInnerHTML: {
	                    __html: job.description.split(" ").slice(0, 10).join(" ")
	                  }
	                }),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      borderRadius: "5px",
	                      backgroundColor: "#FEF3E9",
	                      maxWidth: _reactDeviceDetect.isBrowser ? "100px" : ""
	                    },
	                    className: "d-flex flex-column align-items-center w-25"
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "w-75 d-flex justify-content-center rounded-bottom",
	                      style: { backgroundColor: "#F58220" }
	                    },
	                    _react2.default.createElement(
	                      "small",
	                      {
	                        className: "text-center text-white",
	                        style: { fontSize: _reactDeviceDetect.isMobile ? "10px" : "" }
	                      },
	                      "Deadline"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "" },
	                    _react2.default.createElement(
	                      "h2",
	                      { style: { color: "#F58220" } },
	                      formatDate(job.date).day
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "w-100  d-flex align-items-center justify-content-center",
	                      style: {
	                        backgroundColor: "#F58220",
	                        borderBottomLeftRadius: "5px",
	                        borderBottomRightRadius: "5px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "h6",
	                      {
	                        className: "mb-0 py-2",
	                        style: { color: "#ffffff" }
	                      },
	                      formatDate(job.date).month + " ",
	                      formatDate(job.date).year
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                { "class": "card-text" },
	                job.short_description
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                "class": "card-footer",
	                style: { backgroundColor: "#FEECDD" }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  className: "px-3 py-1 ",
	                  type: "button",
	                  onClick: function onClick() {
	                    return setSelectedJob(job);
	                  },
	                  "data-bs-toggle": "modal",
	                  "data-bs-target": "#jobModal",
	                  style: {
	                    borderRadius: "5px",
	                    backgroundColor: "#F58220",
	                    border: "none",
	                    color: "white"
	                  }
	                },
	                "View & Apply"
	              )
	            )
	          )
	        );
	      }) : "",
	      _react2.default.createElement(
	        "div",
	        {
	          "class": "modal fade",
	          id: "jobModal",
	          "data-bs-backdrop": "static",
	          "data-bs-keyboard": "false",
	          tabindex: "-1",
	          "aria-labelledby": "staticBackdropLabel",
	          "aria-hidden": "true"
	        },
	        _react2.default.createElement(
	          "div",
	          { "class": "modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" },
	          _react2.default.createElement(
	            "div",
	            {
	              "class": "jobModalContent modal-content mt-5",
	              style: { maxHeight: _reactDeviceDetect.isBrowser ? "700px" : "500px" }
	            },
	            _react2.default.createElement(
	              "div",
	              { "class": "modal-header" },
	              _react2.default.createElement(
	                "h5",
	                { "class": "modal-title", id: "staticBackdropLabel" },
	                selectedJob.title
	              ),
	              _react2.default.createElement("button", {
	                type: "button",
	                "class": "btn-close",
	                "data-bs-dismiss": "modal",
	                "aria-label": "Close"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "modal-body d-flex flex-column justify-content-between align-items-start" },
	              _react2.default.createElement(
	                "div",
	                { className: "w-100 mb-4" },
	                selectedJob.media ? _react2.default.createElement("img", {
	                  src: "" + _constants.IMAGE_URL + selectedJob.media[0],
	                  alt: "",
	                  className: "img-fluid w-100",
	                  style: {
	                    maxHeight: "250px",
	                    objectFit: "cover",
	                    objectPosition: "center"
	                  }
	                }) : _react2.default.createElement("img", {
	                  src: "/assets/images/united_logo.png",
	                  alt: "",
	                  className: "img-fluid w-100",
	                  style: {
	                    maxHeight: "250px",
	                    objectFit: "cover",
	                    objectPosition: "center"
	                  }
	                })
	              ),
	              _react2.default.createElement("div", {
	                className: "",
	                dangerouslySetInnerHTML: { __html: selectedJob.description }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "modal-footer" },
	              _react2.default.createElement(
	                "button",
	                {
	                  "class": "px-3 py-2",
	                  "data-bs-target": "#exampleModalToggle2",
	                  "data-bs-toggle": "modal",
	                  "data-bs-dismiss": "modal",
	                  style: {
	                    borderRadius: "5px",
	                    backgroundColor: "#0C807D",
	                    border: "none",
	                    color: "white"
	                  }
	                },
	                "Apply"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          "class": "modal fade",
	          id: "exampleModalToggle2",
	          "aria-hidden": "true",
	          "aria-labelledby": "exampleModalToggleLabel2",
	          tabindex: "-1"
	        },
	        _react2.default.createElement(
	          "div",
	          { "class": "modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" },
	          _react2.default.createElement(
	            "div",
	            {
	              "class": "modal-content mt-5",
	              style: { maxHeight: _reactDeviceDetect.isBrowser ? "700px" : "500px" }
	            },
	            _react2.default.createElement(
	              "div",
	              { "class": "modal-header" },
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex flex-column justify-content-between align-items-center" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "flex",
	                      justifyContent: "center",
	                      alignItems: "flex-start",
	                      flexDirection: "column"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "h3",
	                    {
	                      className: "text-center",
	                      style: {
	                        color: "#0C807D",
	                        fontSize: "28px",
	                        fontWeight: "500"
	                      }
	                    },
	                    "Upload Your CV"
	                  ),
	                  _react2.default.createElement("img", {
	                    width: 103,
	                    height: 2,
	                    src: "/assets/images/doctor_under.png",
	                    alt: ""
	                  })
	                )
	              ),
	              _react2.default.createElement("button", {
	                type: "button",
	                "class": "btn-close",
	                "data-bs-dismiss": "modal",
	                "aria-label": "Close"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "modal-body" },
	              _react2.default.createElement(
	                "section",
	                { "class": "container  pb-4" },
	                _react2.default.createElement(
	                  "h3",
	                  {
	                    style: {
	                      color: "#0C807D",
	                      fontSize: "28px",
	                      fontWeight: "500"
	                    },
	                    className: "col-12 text-center"
	                  },
	                  selectedJob.title
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    "class": "row pt-5 pb-5 border justify-content-md-between",
	                    style: { backgroundColor: "#FFFFFF", borderRadius: "10px" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "col-12 d-flex" },
	                    _react2.default.createElement(
	                      "form",
	                      { onSubmit: handleSubmit },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row p-3 g-5 justify-content-around w-100" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-6" },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            placeholder: "First Name",
	                            autoComplete: "off",
	                            name: "firstName",
	                            value: formData.firstName,
	                            onChange: handleChange,
	                            style: inputStyle
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-6" },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            placeholder: "Last Name",
	                            autoComplete: "off",
	                            name: "lastName",
	                            value: formData.lastName,
	                            onChange: handleChange,
	                            style: inputStyle
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-6" },
	                          _react2.default.createElement("input", {
	                            type: "email",
	                            placeholder: "Email Address",
	                            autoComplete: "off",
	                            name: "email",
	                            value: formData.email,
	                            onChange: handleChange,
	                            style: inputStyle
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-6" },
	                          _react2.default.createElement("input", {
	                            type: "tel",
	                            placeholder: "Phone Number",
	                            autoComplete: "off",
	                            name: "phoneNumber",
	                            value: formData.phoneNumber,
	                            onChange: handleChange,
	                            style: inputStyle
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "col-md-12 px-0",
	                            style: fileInputContainerStyle
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "d-flex justify-content-between align-items-end flex-row w-100" },
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "Upload Image"
	                            ),
	                            _react2.default.createElement("input", {
	                              className: "w-100",
	                              type: "file",
	                              name: "userPhoto",
	                              onChange: handleChange,
	                              style: fileInputStyle
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "col-md-12 px-0",
	                            style: fileInputContainerStyle
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "d-flex justify-content-between align-items-end flex-row w-100" },
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "Resume/CV"
	                            ),
	                            _react2.default.createElement("input", {
	                              className: "w-100",
	                              type: "file",
	                              name: "resume",
	                              onChange: handleChange,
	                              style: fileInputStyle
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-12 d-flex justify-content-center" },
	                          _react2.default.createElement(
	                            "button",
	                            { type: "submit", style: submitButtonStyle },
	                            "Submit"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "modal-footer" },
	              _react2.default.createElement(
	                "button",
	                {
	                  "class": "px-3 py-2",
	                  "data-bs-target": "#jobModal",
	                  "data-bs-toggle": "modal",
	                  "data-bs-dismiss": "modal",
	                  style: {
	                    borderRadius: "5px",
	                    backgroundColor: "#0C807D",
	                    border: "none",
	                    color: "white"
	                  }
	                },
	                "Back to first"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = JobOpeningCard;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getNews = function getNews(page) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/newsevents/getallnewsevents?page=" + page, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: {}
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var LatestNews = function (_Component) {
	  _inherits(LatestNews, _Component);
	
	  function LatestNews() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LatestNews);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LatestNews.__proto__ || Object.getPrototypeOf(LatestNews)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      news: [],
	      nextLink: "",
	      previousLink: "",
	      currentPage: "",
	      nextPage: 5
	    }, _this.refreshNews = function (event) {
	      var page = _this.props.match.params["page"];
	
	      getNews(page).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          var nextPageNo = Number(records.current_page) + 1;
	          _this.setState({
	            news: records.data,
	            nextLink: records.links[2],
	            previousLink: records.links[1],
	            currentPage: records.current_page,
	            nextPage: nextPageNo
	          });
	          if (records.data.length == 0) {
	            window.location.href = "/news";
	          }
	        } else {
	          _this.setState({ news: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LatestNews, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshNews();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	          title: "News | United Hospital Bangladesh | Best Hospital In Bangladesh",
	          description: "Photo Gallery of United Hospital Bangladesh Limited",
	          pathSlug: "/gallery/photo-gallery",
	          keywords: "newsevents, Singlenewsevents"
	        }),
	        _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          {
	            id: "giveMargin",
	            className: "",
	            style: { backgroundColor: "#fef3e9" }
	          },
	          _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	          _react2.default.createElement(
	            "section",
	            { className: "termscondbody pb-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "container p-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "w-100 d-flex justify-content-center align-items-center flex-column py-4" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "flex",
	                      justifyContent: "flex-start",
	                      alignItems: "flex-start",
	                      flexDirection: "column",
	                      marginBottom: "5px"
	                      // margin: "0 auto",
	                    }
	                  },
	                  _react2.default.createElement(
	                    "h3",
	                    {
	                      className: "text-center",
	                      style: {
	                        color: "#0C807D",
	                        fontSize: "28px",
	                        fontWeight: "500"
	
	                      }
	                    },
	                    "NEWS & EVENTS"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row w-100 justify-content-between g-4" },
	                this.state.news.map(function (single) {
	                  return [_react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 col-sm-12 col-md-6 col-lg-6",
	                      style: { height: "490px" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "card w-100 p-3 d-flex flex-column align-items-center h-100",
	                        style: { borderRadius: "10px" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "w-100 h-50" },
	                        _react2.default.createElement("img", {
	                          style: {
	                            objectFit: "cover",
	                            height: "100%",
	                            width: "100%",
	                            borderRadius: "10px"
	                          },
	                          src: _constants.IMAGE_URL + "NewsEventsImg/" + single.news_events_pic,
	                          alt: ""
	                          // width={475}
	                          // height={267}
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: " mt-3 w-100", key: single.id },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "d-flex pt-3 px-3 pb-3",
	                            style: { backgroundClip: "#E7F2F2" }
	                          },
	                          _react2.default.createElement("img", {
	                            src: _case_under2.default,
	                            alt: "",
	                            width: 3,
	                            height: 70
	                          }),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "d-flex flex-column" },
	                            _react2.default.createElement(
	                              "h3",
	                              {
	                                className: "px-4 pt-2",
	                                style: {
	                                  fontSize: "22px",
	                                  textTransform: "capitalize"
	                                }
	                              },
	                              single.news_events_title.slice(0, 30) + " ..."
	                            ),
	                            _react2.default.createElement("p", {
	                              className: "px-4 pt-2 text-secondary mt-3",
	                              dangerouslySetInnerHTML: {
	                                __html: single.news_events_desc.slice(0, 60) + " ..."
	                              }
	                            }),
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                className: "px-4 pt-2 text-secondary mt-3",
	                                href: _constants.SITE_URL + "/news/" + single.Slug
	                              },
	                              _react2.default.createElement(
	                                "button",
	                                {
	                                  style: {
	                                    fontSize: "16px",
	                                    width: "118px",
	                                    height: "43px",
	                                    backgroundColor: "#0C807D",
	                                    color: "#fff",
	                                    textTransform: "capitalize",
	                                    border: "none",
	                                    borderRadius: "6px",
	                                    fontWeight: 500
	                                  }
	                                },
	                                "Details"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )];
	                }),
	                this.state.nextLink.url && _react2.default.createElement(
	                  "a",
	                  {
	                    href: _constants.SITE_URL + "/news/page/" + ("" + (this.state.currentPage + 1))
	                  },
	                  "Next"
	                ),
	                this.state.previousLink.url && this.state.currentPage != 1 && _react2.default.createElement(
	                  "a",
	                  {
	                    href: _constants.SITE_URL + "/news/page/" + ("" + (this.state.currentPage - 1))
	                  },
	                  "Previous"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return LatestNews;
	}(_react.Component);
	
	exports.default = LatestNews;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactToastify = __webpack_require__(7);
	
	var _lifeAtUHL = __webpack_require__(248);
	
	var _lifeAtUHL2 = _interopRequireDefault(_lifeAtUHL);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LifeAtUHL = function LifeAtUHL() {
	  var _useState = (0, _react.useState)(4),
	      _useState2 = _slicedToArray(_useState, 2),
	      displayCount = _useState2[0],
	      setDisplayCount = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      lifeSection = _useState4[0],
	      setLifeSection = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({}),
	      _useState6 = _slicedToArray(_useState5, 2),
	      header = _useState6[0],
	      setHeader = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({}),
	      _useState8 = _slicedToArray(_useState7, 2),
	      footer = _useState8[0],
	      setFooter = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      loading = _useState10[0],
	      setLoading = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      components = _useState12[0],
	      setComponents = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      pageName = _useState14[0],
	      setPageName = _useState14[1];
	
	  (0, _react.useEffect)(function () {
	    var getCaseStudies = function getCaseStudies(data) {
	      try {
	        setLoading(true);
	        var req = _.scAxiosAdmin.request("/static_services_pages/38", {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            setLoading(false);
	            setLifeSection(data.data.content);
	            setHeader(data.data.header);
	            setFooter(data.data.footer);
	            setComponents(data.data.components);
	            setPageName(data.data.title);
	          }
	        }).catch(function (e) {
	          setLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getCaseStudies();
	  }, []);
	
	  var handleViewAll = function handleViewAll() {
	    // Set displayCount to a value greater than the total number of items to show all
	    setDisplayCount(lifeSection.length);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Life At UHL | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Life At UHL"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/assets/images/banner-case-study.png",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      components.length > 0 ? components.map(function (component, index) {
	        if (component.type === "description") {
	          return _react2.default.createElement(
	            "section",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex flex-column justify-content-between align-items-center p-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "1 mb-3" },
	                _react2.default.createElement(
	                  "h3",
	                  {
	                    className: "text-left ",
	                    style: {
	                      color: "#0C807D",
	                      fontSize: "28px",
	                      fontWeight: "500",
	                      display: "flex",
	                      flexDirection: "column"
	                    }
	                  },
	                  pageName
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex flex-column justify-content-center align-items-center" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "2" },
	                  _react2.default.createElement(
	                    "h2",
	                    {
	                      className: "text-left ",
	                      style: {
	                        color: "#0C807D",
	                        fontSize: "28px",
	                        fontWeight: "500",
	                        display: "flex",
	                        flexDirection: "column",
	                        justifyContent: "center"
	                      }
	                    },
	                    component.value.title
	                  )
	                ),
	                _react2.default.createElement("div", {
	                  className: "3",
	                  dangerouslySetInnerHTML: {
	                    __html: component.value.content
	                  }
	                })
	              )
	            )
	          );
	        } else if (component.type === "card") {
	          return _react2.default.createElement(
	            "section",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex flex-column justify-content-md-center align-items-center px-5 " },
	              _react2.default.createElement(
	                "div",
	                { className: "row life" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-md-6 order-md-" + (index % 2 === 0 ? "2" : "1") + " mt-3 mt-md-0"
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "w-100" },
	                    _react2.default.createElement("img", {
	                      style: {
	                        //   width: "100%",
	                        objectFit: "cover",
	                        borderRadius: "5px"
	                      },
	                      src: "" + _constants.IMAGE_URL + component.value.media[0],
	                      alt: "Single Image",
	                      className: "img-fluid"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-md-6 order-md-" + (index % 2 === 0 ? "2" : "1") + " d-flex flex-column justify-content-between"
	                  },
	                  _react2.default.createElement(
	                    "h2",
	                    null,
	                    component.value.title
	                  ),
	                  _react2.default.createElement("div", {
	                    className: "",
	                    dangerouslySetInnerHTML: {
	                      __html: component.value.description
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row g-3" },
	                    component.value.media.slice(1).map(function (image, i) {
	                      return _react2.default.createElement(
	                        "div",
	                        { className: "col-6 col-sm-4 col-lg-3", key: i },
	                        _react2.default.createElement("img", {
	                          style: {
	                            objectFit: "cover",
	                            borderRadius: "5px",
	                            height: "86px"
	                          },
	                          src: "" + _constants.IMAGE_URL + image,
	                          alt: "Image " + (i + 1),
	                          className: "img-fluid"
	                        })
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          );
	        } else if (component.type === "gallery") {
	          return _react2.default.createElement(
	            "section",
	            { className: "container pb-4 " },
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex flex-column justify-content-md-center align-items-center" },
	              _react2.default.createElement(
	                "div",
	                { className: "" },
	                _react2.default.createElement(
	                  "h3",
	                  {
	                    className: "text-left ",
	                    style: {
	                      color: "#0C807D",
	                      fontSize: "28px",
	                      fontWeight: "500",
	                      display: "flex",
	                      flexDirection: "column"
	                    }
	                  },
	                  "HOSPITAL VIEW",
	                  _react2.default.createElement("img", {
	                    src: _case_under2.default,
	                    style: { width: "100%", maxWidth: "79px" },
	                    alt: ""
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row justify-content-center pt-4 gap-3 gap-md-0" },
	              component.value.map(function (item, index) {
	                return _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 d-flex justify-content-center" },
	                  _react2.default.createElement("img", {
	                    className: "image-fluid w-100",
	                    style: {
	                      borderRadius: "5px",
	                      height: "250px",
	                      objectFit: "cover",
	                      objectPosition: "center"
	                    },
	                    src: "" + _constants.IMAGE_URL + item,
	                    alt: ""
	                  })
	                );
	              })
	            )
	          );
	        } else {
	          return "";
	        }
	      }) : _react2.default.createElement("div", { className: "" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = LifeAtUHL;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _userSession = __webpack_require__(30);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(59);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _MyProvider = __webpack_require__(48);
	
	var _PopupOTP = __webpack_require__(209);
	
	var _PopupOTP2 = _interopRequireDefault(_PopupOTP);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import doc from '../../images/doc.png';
	
	
	var linkPatientId = function linkPatientId(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request("/mmlogin?patientid=" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json"
	        // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var SendOTPMessage = function SendOTPMessage(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosSMS.request("/user/sendotp", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var SaveOTPNumber = function SaveOTPNumber(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/user/saveotpnumber", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	var input_field_css = {
	  maxHeight: "50px",
	  fontSize: "14px",
	  borderColor: "#cccccc",
	  borderRadius: "5px"
	};
	
	var LinkPatientIdPopup = function (_Component) {
	  _inherits(LinkPatientIdPopup, _Component);
	
	  function LinkPatientIdPopup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LinkPatientIdPopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkPatientIdPopup.__proto__ || Object.getPrototypeOf(LinkPatientIdPopup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      search_doctors: [],
	      search_keywords: "",
	      doctor_id: "",
	      schedule_date: "",
	      department_id: "",
	      limit: 4,
	      search_selected_doc_name: "",
	      selectedDate: null,
	      payment_type: "",
	      privacy_policy: "",
	      term_conditions: "",
	      showOtpPopup: false,
	      phone_number: "",
	      user_local_id: "",
	      user_id: ""
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.handleSubmit = function (event, props) {
	      event.preventDefault();
	
	      var type = "patient_registration";
	      var user_local_id = localStorage.getItem(_constants.USER_LOCAL_ID);
	      var grand_total = 200;
	      var total = 200;
	      var payment_type = "sslCommerz";
	      var status = 1;
	      var currency = "BDT";
	      var qty = 1;
	
	      var sslCommerz_urls = {
	        // null if payment_type is pay_at_uhl
	        success_url: window.location.origin + "/success",
	        fail_url: window.location.origin + "/fail",
	        cancel_url: window.location.origin + "/cancel"
	      };
	      var data = {
	        type: type,
	        user_local_id: user_local_id,
	        grand_total: grand_total,
	        total: total,
	        payment_type: payment_type,
	        sslCommerz_urls: sslCommerz_urls,
	        status: status,
	        currency: currency,
	        qty: qty
	      };
	      var id = _this.state.patientId;
	
	      linkPatientId(id).then(function (res) {
	
	        if (res[0].pmobile) {
	          _this.setState({ phone_number: res[0].pmobile });
	          _this.setState({
	            user_local_id: localStorage.getItem(_constants.USER_LOCAL_ID)
	          });
	          _this.setState({
	            user_id: res[0].pid
	          });
	          //let six_digit_random_number = Math.floor(100000 + Math.random() * 999999);
	          var six_digit_random_number = Math.floor(Math.random() * 900000) + 100000;
	          var encoded_otp = "";
	          var otp_number = btoa(six_digit_random_number);
	          for (var i = 0; i < otp_number.length; i++) {
	            var a = otp_number.charCodeAt(i);
	            var b = a ^ 10;
	            encoded_otp += String.fromCharCode(b);
	          }
	          var new_encoded_otp = btoa(encoded_otp);
	          var messageBody = "Your OTP is " + six_digit_random_number;
	          var encoded = "";
	          var messageBodyText = btoa(messageBody);
	          for (var _i = 0; _i < messageBodyText.length; _i++) {
	            var c = messageBodyText.charCodeAt(_i);
	            var d = c ^ 10;
	            encoded += String.fromCharCode(d);
	          }
	          var encoded_message_body = btoa(encoded);
	          var csms_generate_number = Math.random().toString(36).substring(2, 11);
	          var csmsId = csms_generate_number;
	          var _data = {
	            phone_number: res[0].pmobile,
	            message_body: encoded_message_body,
	            csms_id: csmsId
	          };
	
	          SendOTPMessage(_data).then(function (res) {
	            if (res.status) {
	              _this.saveOtp(new_encoded_otp);
	              (0, _jquery2.default)(".register_popup").css("visibility", "hidden");
	              (0, _jquery2.default)(".register_popup").removeClass("show");
	              (0, _jquery2.default)(".otp_popup").css("visibility", "visible");
	              (0, _jquery2.default)(".otp_popup").addClass("show");
	              (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	              (0, _jquery2.default)("body").css("overflow", "");
	              (0, _jquery2.default)("body").css("padding-right", "");
	              _this.setState({ showOtpPopup: true });
	              _reactToastify.toast.success("Please enter OTP to complete online sign up", {
	                position: _reactToastify.toast.POSITION.TOP_LEFT
	              });
	            } else {
	              _reactToastify.toast.error("Otp Was Not Send", {
	                position: _reactToastify.toast.POSITION.TOP_LEFT
	              });
	            }
	          }).catch(function (err) {
	            console.log(err);
	          });
	          _this.setState({ showOtpPopup: true });
	          (0, _jquery2.default)(".otp_popup").css("visibility", "visible");
	          (0, _jquery2.default)(".otp_popup").addClass("show");
	          (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	          (0, _jquery2.default)("body").css("overflow", "");
	          (0, _jquery2.default)("body").css("padding-right", "");
	          //   window.location.href = res.data;
	        } /* else {
	          toast.error("Something went wrong.Please try again!", {
	            position: toast.POSITION.BOTTOM_RIGHT,
	          });
	          } */
	      }).catch(function (err) {
	        _reactToastify.toast.error("Something went wrong.Please try again!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	    }, _this.saveOtp = function (otp) {
	      var data = {
	        phone_number: _this.state.phone_number,
	        otp_number: otp
	      };
	      SaveOTPNumber(data).then(function (res) {
	        if (res.data === "success") {} else {}
	      }).catch(function (err) {
	        _reactToastify.toast.error("Error occured", {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.closePopup = function (event) {
	      var DoctorData = _this.context.DoctorData;
	
	      DoctorData({});
	      document.getElementById("offcanvasExample6").style.visibility = "hidden";
	      document.getElementById("offcanvasExample6").classList.remove("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LinkPatientIdPopup, [{
	    key: "componentDidMount",
	
	    //   showPatientRegistrationPopup = () => {
	    //     $(".patientRegister").css("visibility", "visible");
	    //     $(".patientRegister").addClasses("offcanvas offcanvas-start show");
	    //     $(".modal-backdrop.fade.show").remove();
	    //     $("body").css("overflow", "");
	    //     $("body").css("padding-right", "");
	    //   };
	
	    value: function componentDidMount() {
	      if (localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME) && localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID) && localStorage.getItem(_constants.SCHEDULE_DATE)) {
	        document.getElementById("Schedule").disabled = false;
	        document.getElementById("Schedule").style.background = "gray";
	      }
	      /* if (localStorage.getItem(SEARCH_SELECTED_DOC_NAME)) {
	        this.refreshGetSearchDoctors(
	          localStorage.getItem(SEARCH_SELECTED_DOC_NAME)
	        );
	      } */
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var user_data = {
	        PhoneNumber: this.state.phone_number
	      };
	      var user_local_id = this.state.user_local_id;
	      var user_id = this.state.user_id;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "offcanvas offcanvas-start otp_reg",
	          tabIndex: "-1",
	          id: "offcanvasExample6",
	          "aria-labelledby": "offcanvasExampleLabel6",
	          style: { visibility: "visible" }
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-header" },
	          _react2.default.createElement(
	            "h5",
	            { className: "offcanvas-title", id: "offcanvasExampleLabel6" },
	            " "
	          ),
	          _react2.default.createElement("button", {
	            type: "button",
	            className: "btn-close text-reset",
	            "data-bs-dismiss": "offcanvas",
	            "aria-label": "Close",
	            onClick: this.closePopup
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-body" },
	          _react2.default.createElement(
	            "div",
	            { className: "row text-center", id: "logos" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-2 " },
	              _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "left-offcanvas" },
	            _react2.default.createElement(
	              "h4",
	              { style: { color: "#187979" } },
	              "Link Patient ID"
	            ),
	            _react2.default.createElement(
	              "form",
	              {
	                onSubmit: this.handleSubmit,
	                id: "registerform",
	                className: "needs-validation",
	                noValidate: true
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mt-2" },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control",
	                    placeholder: "Enter Your Patient ID",
	                    name: "patientId",
	                    id: "patientId",
	                    onChange: this.handleChange,
	                    required: true,
	                    autoComplete: "off",
	                    style: input_field_css
	                  })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { style: alertStyle },
	                  this.state.errors.patientId
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      variant: "primary",
	                      type: "submit",
	                      className: "btn-links appointment-new submit_btn",
	                      id: "black-btn"
	                    },
	                    " ",
	                    "Link ID",
	                    " "
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "label",
	                { className: "dont" },
	                "Don't have a patient ID? ",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    className: "nav-link active",
	                    onClick: this.showPatientRegistrationPopup,
	                    style: {
	                      background: "none",
	                      border: "none",
	                      padding: "0px",
	                      color: "rgb(251, 98, 1)"
	                    }
	                  },
	                  "Get a Patient ID."
	                )
	              )
	            )
	          )
	        ),
	        this.state.showOtpPopup ? _react2.default.createElement(_PopupOTP2.default, {
	          showPopup: this.state.showOtpPopup,
	          userData: user_data,
	          userId: user_local_id,
	          userPatientId: user_id,
	          from: "from_link_id"
	        }) : null
	      );
	    }
	  }]);
	
	  return LinkPatientIdPopup;
	}(_react.Component);
	
	LinkPatientIdPopup.contextType = _MyProvider.MyContext;
	exports.default = LinkPatientIdPopup;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Location = function (_Component) {
	  _inherits(Location, _Component);
	
	  function Location() {
	    _classCallCheck(this, Location);
	
	    return _possibleConstructorReturn(this, (Location.__proto__ || Object.getPrototypeOf(Location)).apply(this, arguments));
	  }
	
	  _createClass(Location, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          { id: "giveMargin", className: "" },
	          _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	          _react2.default.createElement(
	            "section",
	            { className: "termscondbody mt-5 mb-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "container p-3" },
	              _react2.default.createElement(
	                "h2",
	                { className: "text-secondary" },
	                "LOCATION MAP"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row g-3 w-100 mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 mt-5 bg-light d-flex" },
	                  _react2.default.createElement("iframe", {
	                    src: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14601.569181151559!2d90.4157514!3d23.8046453!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c7abd941ed15%3A0xf151df4e4e9c047c!2sUnited%20Hospital%20Limited!5e0!3m2!1sen!2sbd!4v1680602460479!5m2!1sen!2sbd",
	                    width: "100%",
	                    height: "600",
	                    referrerpolicy: "no-referrer-when-downgrade"
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return Location;
	}(_react.Component);
	
	exports.default = Location;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactToastify = __webpack_require__(7);
	
	var _lifeAtUHL = __webpack_require__(248);
	
	var _lifeAtUHL2 = _interopRequireDefault(_lifeAtUHL);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _Shape = __webpack_require__(446);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MissionStatement = function MissionStatement() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      staticPageData = _useState2[0],
	      setStaticPageData = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var getHeaderData = function getHeaderData(data) {
	      try {
	        var req = _.scAxiosAdmin.request("/static_services_pages/37", {
	          // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
	          method: "get",
	          headers: {
	            Accept: "application/json"
	            // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            // console.log('your log output',data)
	            // setStaticPageData(data.data.data);
	            setStaticPageData(data.data.components);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getHeaderData();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Mission Statement | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Mission Statement"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/assets/images/banner-case-study.png",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      staticPageData.length > 0 ? staticPageData.map(function (section, index) {
	        if (section.type === "description") {
	          return _react2.default.createElement(
	            "section",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex flex-column justify-content-between align-items-center p-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "1 mb-3" },
	                _react2.default.createElement(
	                  "h3",
	                  {
	                    className: "text-left ",
	                    style: {
	                      color: "#0C807D",
	                      fontSize: "28px",
	                      fontWeight: "500",
	                      display: "flex",
	                      flexDirection: "column"
	                    }
	                  },
	                  section.value.title
	                )
	              ),
	              _react2.default.createElement("div", {
	                className: "3",
	                dangerouslySetInnerHTML: {
	                  __html: section.value.content
	                }
	              })
	            )
	          );
	        } else if (section.type === "cardGallery") {
	          return _react2.default.createElement(
	            "section",
	            { className: "container mt-2 pb-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "row row-cols-1 row-cols-md-3 g-4" },
	              section.value.map(function (cardNumber) {
	                return _react2.default.createElement(
	                  "div",
	                  { className: "col", key: cardNumber },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "card",
	                      style: {
	                        backgroundImage: "url(" + _Shape2.default + ")",
	                        backgroundSize: "cover",
	                        borderRadius: "10px",
	                        height: "100%"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "card-body d-flex flex-column justify-content-start align-items-center",
	                        style: { rowGap: "30px", paddingTop: "5rem" }
	                      },
	                      _react2.default.createElement("img", {
	                        // src={`/assets/images/${cardNumber.img}`}
	                        src: "" + _constants.IMAGE_URL + cardNumber.media[0],
	                        alt: ""
	                      }),
	                      _react2.default.createElement(
	                        "h5",
	                        { className: "card-title mt-2" },
	                        cardNumber.title
	                      ),
	                      _react2.default.createElement("div", {
	                        className: "cardDescription",
	                        dangerouslySetInnerHTML: {
	                          __html: cardNumber.description
	                        }
	                      })
	                    )
	                  )
	                );
	              })
	            )
	          );
	        }
	      }) : ""
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	exports.default = MissionStatement;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shape = __webpack_require__(446);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MissionStatementAbout = function MissionStatementAbout(_ref) {
	  var card = _ref.card;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col", key: card },
	    _react2.default.createElement(
	      "div",
	      {
	        className: "card",
	        style: {
	          backgroundImage: "url(" + _Shape2.default + ")",
	          backgroundSize: "cover",
	          borderRadius: "10px",
	          height: "100%"
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "card-body d-flex flex-column justify-content-start align-items-center"
	          //   style={{ rowGap: "30px", paddingTop: "5rem" }}
	        },
	        _react2.default.createElement("img", {
	          // src={`/assets/images/${cardNumber.img}`}
	          src: "" + _constants.IMAGE_URL + card.media[0],
	          alt: ""
	        }),
	        _react2.default.createElement(
	          "h5",
	          { className: "card-title mt-2", style: { color: "#AF9763" } },
	          card.title
	        ),
	        _react2.default.createElement("div", {
	          className: "cardDescription",
	          dangerouslySetInnerHTML: {
	            __html: card.description
	          }
	        })
	      )
	    )
	  );
	};
	
	exports.default = MissionStatementAbout;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	var _jquery = __webpack_require__(18);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Mortuary = function Mortuary() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Mortuary | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "mortuary"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      _react2.default.createElement(
	        "section",
	        { className: "termscondbody mt-4 pb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "container p-3" },
	          _react2.default.createElement(
	            "h3",
	            {
	              className: "text-center",
	              style: {
	                color: "#0C807D",
	                fontWeight: "700"
	              }
	            },
	            "MORTUARY"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row g-3 w-100 mx-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 d-flex" },
	              _react2.default.createElement(
	                "div",
	                { className: "content mt-3 w-100 p-3" },
	                _react2.default.createElement(
	                  "p",
	                  { className: "text-secondary" },
	                  "Mortuary Freezer of United Hospital is of Italian origin and is made of stainless steel. It has two separate cold chambers and can accommodate two dead bodies at a time at two different chambers. Working temperature of mortuary is 00 c and temperature range can be varied from -50 c to +50 c. Temperature of cold chamber is being maintained and checked by Biomedical Department in coordination with Duty Manager."
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "text-secondary mt-4" },
	                  "Since we have two chambers, so the preference is given to In patients. However, if the space is available then only out door bodies are also allowed to be preserved for short duration."
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "text-secondary mt-4" },
	                  "In addition to the mortuary, we have a proper place for washing of dead bodies prior to burial.",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "text-secondary mt-4" },
	                  "Hospital authority always take this responsibility as their morale duty to ensure proper respect and handling of the dead bodies preserved in the hospital mortuary"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Mortuary;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoticeBoard = function (_Component) {
	  _inherits(NoticeBoard, _Component);
	
	  function NoticeBoard() {
	    _classCallCheck(this, NoticeBoard);
	
	    return _possibleConstructorReturn(this, (NoticeBoard.__proto__ || Object.getPrototypeOf(NoticeBoard)).apply(this, arguments));
	  }
	
	  _createClass(NoticeBoard, [{
	    key: "render",
	    value: function render() {
	      var boardmembers = [{
	        title: "MD & CEO Of United Hospital Mohammad Faizur Rahman Spoke To The Business Standard About Its Travails And Journey So Far, Including How The Hospital Is Coping With The Ongoing Pandemic.",
	        dsc: "MD & CEO of United Hospital Mohammad Faizur Rahman spoke to The Business Standard about its travails and journey so far, including how the hospital is coping with the ongoing pandemic.",
	        image: "https://uhlbd.com/administrator/uploads/images/Business%20Standard.jpg"
	      }, {
	        title: "MD & CEO Of United Hospital Mohammad Faizur Rahman Spoke To Daily Bonik Barta About Its Travails And Journey So Far, Including How The Hospital Is Coping With The Ongoing Pandemic.",
	        dsc: "MD & CEO of United Hospital Mohammad Faizur Rahman spoke to Daily Bonik Barta about its travails and journey so far, including how the hospital is coping with the ongoing pandemic.",
	        image: "https://uhlbd.com/administrator/uploads/images/Bonik%20Barta.jpg"
	      }, {
	        title: "United Hospital Signs MoU With DGHS (Directorate General Of Health Services) For Joint Collaboration To Operate Munshiganj Isolation Centre For Corona Virus (COVID19) Suspect/positive Patients",
	        dsc: "At Gholtoli of Louhaganj Upazilla of Munshiganj, at one hour distance from Dhaka, a 25 bed Isolation Centre for Corona Virus (COVID19) suspect/positive patients, ...",
	        image: "https://uhlbd.com/backend/web/post_uploads/medium/1586774469IMG_1489-1.jpg"
	      }, {
	        title: "United Group Signed A Project Agreement With Bangladesh Railway Under Public Private Partnership",
	        dsc: "United Enterprise and Company Limited, a sister concern of United Group signed a project agreement with Bangladesh Railway ...",
	        image: "https://uhlbd.com/backend/web/post_uploads/medium/158677382818-1.jpg"
	      }, {
	        title: "United Hospital Inaugurated 25-bed Isolation Unit At Munshiganj To Help Covid-19 Patients",
	        dsc: "As part of initiative of United Group & extended part of the United Hospital, for COVID-19 patients ...",
	        image: "https://uhlbd.com/backend/web/post_uploads/medium/1586773514IMG_8343.jpg"
	      }];
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	        _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	        _react2.default.createElement(
	          "section",
	          { className: "termscondbody mt-5 mb-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "container p-3" },
	            _react2.default.createElement(
	              "h2",
	              { className: "text-secondary" },
	              "NEWS & EVENTS"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row g-3 w-100 mx-auto" },
	              boardmembers.map(function (menubars) {
	                return _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 mt-5 bg-light d-flex" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "w-100" },
	                    _react2.default.createElement("img", {
	                      src: menubars.image,
	                      alt: "",
	                      width: 475,
	                      height: 267,
	                      className: "img-fluid"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "content mt-3 w-100", key: menubars },
	                    _react2.default.createElement(
	                      "h6",
	                      { className: "text-dark" },
	                      menubars.title
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "text-secondary mt-3" },
	                      menubars.dsc
	                    )
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return NoticeBoard;
	}(_react.Component);
	
	exports.default = NoticeBoard;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var OperationTeam = function OperationTeam() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchdata = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    fetchData(); // Initial data fetch
	  }, []);
	
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/boardmembers_type/operational_member");
	
	            case 3:
	              response = _context.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                setFatchdata(response.data);
	                // setLoading(false);
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Operation Team | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Operation Team"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      _react2.default.createElement(
	        "section",
	        { className: "termscondbody pb-5" },
	        _react2.default.createElement(
	          "div",
	          { className: "container p-3" },
	          _react2.default.createElement(
	            "h3",
	            {
	              className: "text-center pb-5 text-center pt-3",
	              style: {
	                color: "#0C807D",
	                fontWeight: "700",
	                width: "100%"
	              }
	            },
	            "OPERATIONAL TEAM OF UNITED HOSPITAL LIMITED"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row w-100 mx-auto justify-content-around" },
	            fatchdata ? fatchdata.map(function (menubars) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  className: "col-12 col-sm-5 col-md-4 col-lg-3 mb-5"
	                  // style={{ borderRadius: "30px" }}
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "w-100 py-4",
	                    style: {
	                      backgroundImage: "url(/assets/images/opearational-team-bg.png",
	                      backgroundPosition: "center",
	                      backgroundSize: "cover",
	                      backgroundColor: "#fff",
	                      borderRadius: "20px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "w-100",
	                      style: {
	                        display: "flex",
	                        justifyContent: "center",
	                        alignItems: "center"
	                      }
	                    },
	                    _react2.default.createElement("img", {
	                      style: { borderRadius: "5px" },
	                      src: _constants.IMAGE_URL + "BoardMember/" + menubars.image,
	                      alt: "",
	                      width: 150,
	                      className: "center-block img-responsive"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "content mt-3", key: menubars },
	                    _react2.default.createElement(
	                      "h6",
	                      { className: "text-dark text-center fw-bolder" },
	                      menubars.name
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        className: "text-center mt-3",
	                        style: { color: "#AF9763" }
	                      },
	                      menubars.deg
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      {
	                        className: "text-center",
	                        style: { color: "#AF9763" }
	                      },
	                      menubars.company
	                    )
	                  )
	                )
	              );
	            }) : ""
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	  );
	};
	
	exports.default = OperationTeam;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _PackageOne = __webpack_require__(688);
	
	var _PackageOne2 = _interopRequireDefault(_PackageOne);
	
	var _PackageTwo = __webpack_require__(689);
	
	var _PackageTwo2 = _interopRequireDefault(_PackageTwo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _health_screenint_bnner_image = __webpack_require__(1138);
	
	var _health_screenint_bnner_image2 = _interopRequireDefault(_health_screenint_bnner_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Packages = function (_Component) {
	  _inherits(Packages, _Component);
	
	  function Packages() {
	    _classCallCheck(this, Packages);
	
	    return _possibleConstructorReturn(this, (Packages.__proto__ || Object.getPrototypeOf(Packages)).apply(this, arguments));
	  }
	
	  _createClass(Packages, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	          title: "Packages | Best Hospital in Bangladesh | United Hospital",
	          description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	          pathSlug: "/",
	          keywords: "Emergency"
	        }),
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement("meta", {
	            name: "description",
	            content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	          }),
	          _react2.default.createElement(
	            "script",
	            { type: "application/ld+json" },
	            JSON.stringify({
	              "@context": "http://schema.org",
	              "@type": "LocalBusiness",
	              name: "United Hospital Limited",
	              image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	              telephone: "10666",
	              email: "info@uhlbd.com",
	              address: {
	                "@type": "PostalAddress",
	                streetAddress: "plot 15, Road 71, Gulshan",
	                addressLocality: "Dhaka",
	                addressRegion: "Dhaka",
	                addressCountry: "Bangladesh",
	                postalCode: "1212"
	              },
	              openingHoursSpecification: {
	                "@type": "OpeningHoursSpecification",
	                opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	              },
	              url: "http://www.uhlbd.com/",
	              aggregateRating: {
	                "@type": "AggregateRating",
	                ratingValue: "3.9",
	                bestRating: "5",
	                worstRating: "1",
	                ratingCount: "756"
	              },
	              review: {
	                "@type": "Review",
	                author: {
	                  "@type": "Person",
	                  name: "abdul kahar"
	                },
	                datePublished: "2019-02-12",
	                reviewRating: {
	                  "@type": "Rating",
	                  ratingValue: "3.9",
	                  bestRating: "5",
	                  worstRating: "1"
	                },
	                reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	              }
	            })
	          ),
	          _react2.default.createElement("meta", {
	            name: "Subject",
	            content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	          }),
	          _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	          _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	          _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	          _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	          _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	          _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	          _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	          _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	          _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	          _react2.default.createElement("meta", {
	            name: "classification",
	            content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	          }),
	          _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	          _react2.default.createElement("meta", {
	            names: "apple-mobile-web-app-status-bar-style",
	            content: "black-translucent"
	          }),
	          _react2.default.createElement("meta", {
	            name: "msvalidate.01",
	            content: "16C4E0B16E39354E550F64BD707F6A97"
	          })
	        ),
	        _react2.default.createElement(_Seo2.default, {
	          title: "Packages",
	          description: "Packages United Hospital",
	          pathSlug: "packges",
	          keywords: "Packages, Package"
	        }),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "packagesBannerContainer",
	              style: {
	                backgroundImage: "url('/assets/images/health_screenint_bnner_image.png')",
	                backgroundSize: "cover",
	                backgroundPosition: "center"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "container bannerTextContainer d-flex align-items-center h-100" },
	              _react2.default.createElement(
	                "h1",
	                { className: "text-white" },
	                "Health ",
	                _react2.default.createElement("br", null),
	                " Screening"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "", style: { backgroundColor: "#fef3e9" } },
	            _react2.default.createElement(_PackageOne2.default, null),
	            _react2.default.createElement(_PackageTwo2.default, null)
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return Packages;
	}(_react.Component);
	
	exports.default = Packages;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _constants = __webpack_require__(3);
	
	__webpack_require__(116);
	
	var _services = __webpack_require__(105);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var PatientBillHistory = function PatientBillHistory() {
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchdata = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      loading = _useState4[0],
	      setLoading = _useState4[1];
	
	  console.log(fatchdata);
	
	  (0, _react.useEffect)(function () {
	    var patientid = localStorage.getItem(_constants.USER_ID);
	    var fetchData = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _.scAxios.get("/PatientBillHistory", {
	                  params: {
	                    patientid: patientid,
	                    fromdate: "2022-01-01",
	                    todate: "2025-01-01",
	                    zid: 400010
	                  }
	                });
	
	              case 3:
	                response = _context.sent;
	
	
	                if (response.status === 200) {
	                  setFatchdata(response.data);
	                }
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0.message);
	
	              case 10:
	                _context.prev = 10;
	
	                setLoading(false);
	                return _context.finish(10);
	
	              case 13:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 7, 10, 13]]);
	      }));
	
	      return function fetchData() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    fetchData(); // Initial data fetch
	  }, []);
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Patient Bill History | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Services"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMarginService", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "allservices"
	          // style={{
	          //   width: "90vw",
	          //   maxWidth: "1140px",
	          //   margin: "0 auto",
	          //   minHeight: "960px",
	          // }}
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "container py-4" },
	          _react2.default.createElement(
	            "div",
	            { className: "d-flex flex-column justify-content-between align-items-center " },
	            _react2.default.createElement(
	              "div",
	              { className: "1" },
	              _react2.default.createElement(
	                "h3",
	                {
	                  className: "text-left ",
	                  style: {
	                    color: "#0C807D",
	                    fontSize: "28px",
	                    fontWeight: "500",
	                    display: "flex",
	                    flexDirection: "column"
	
	                  }
	                },
	                "Patient Bill History"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "table-rep-plugin" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "table-responsive b-0",
	                "data-pattern": "priority-columns"
	              },
	              loading ? _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "flex",
	                    justifyContent: "center",
	                    alignItems: "center",
	                    height: "100vh"
	                  }
	                },
	                _react2.default.createElement("img", {
	                  src: "https://i.stack.imgur.com/hzk6C.gif",
	                  width: 300,
	                  alt: ""
	                })
	              ) : fatchdata ? _react2.default.createElement(
	                "table",
	                { id: "tech-companies-1", className: "table  table-striped" },
	                _react2.default.createElement(
	                  "thead",
	                  null,
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      "SL"
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      { "data-priority": "1" },
	                      "Invoice No"
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      { "data-priority": "4" },
	                      "Bill No"
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      { "data-priority": "4" },
	                      "Amount"
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      "View"
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      "Date"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "tbody",
	                  null,
	                  fatchdata.length > 0 ? fatchdata.map(function (item) {
	                    return _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        item.SL
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        item["Invoice No"]
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        item["Bill No"]
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        item.Amount
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        " ",
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            href: _constants.ERPUrl + item.View,
	                            target: "_blank",
	                            rel: "noopener noreferrer",
	                            title: "View",
	                            className: "mr-2"
	                          },
	                          " ",
	                          _react2.default.createElement("i", { className: "fa fa-eye" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        item.Date
	                      )
	                    );
	                  }) : _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      {
	                        colSpan: "6",
	                        className: "font_12 txt_col fontweight400 ",
	                        style: { textAlign: "center" }
	                      },
	                      " ",
	                      "There are currently no Packages."
	                    )
	                  )
	                )
	              ) : _react2.default.createElement(
	                "p",
	                { className: "text-centers" },
	                "No data available."
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = PatientBillHistory;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _PrivateRoute = __webpack_require__(81);
	
	var _userSession = __webpack_require__(30);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _HomeHeader = __webpack_require__(112);
	
	var _HomeHeader2 = _interopRequireDefault(_HomeHeader);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _doc = __webpack_require__(1165);
	
	var _doc2 = _interopRequireDefault(_doc);
	
	var _hotline_phone = __webpack_require__(117);
	
	var _hotline_phone2 = _interopRequireDefault(_hotline_phone);
	
	var _cardiac = __webpack_require__(104);
	
	var _cardiac2 = _interopRequireDefault(_cardiac);
	
	var _male = __webpack_require__(240);
	
	var _male2 = _interopRequireDefault(_male);
	
	var _female = __webpack_require__(239);
	
	var _female2 = _interopRequireDefault(_female);
	
	var _plain_anatomy = __webpack_require__(1173);
	
	var _plain_anatomy2 = _interopRequireDefault(_plain_anatomy);
	
	var _happy_patient = __webpack_require__(449);
	
	var _happy_patient2 = _interopRequireDefault(_happy_patient);
	
	var _news_events_ = __webpack_require__(1172);
	
	var _news_events_2 = _interopRequireDefault(_news_events_);
	
	var _potrait = __webpack_require__(456);
	
	var _potrait2 = _interopRequireDefault(_potrait);
	
	var _landscape = __webpack_require__(1169);
	
	var _landscape2 = _interopRequireDefault(_landscape);
	
	var _tes = __webpack_require__(1176);
	
	var _tes2 = _interopRequireDefault(_tes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import pay_img from '../../images/pay-img.png';
	
	
	var getPatitentLists = function getPatitentLists(data) {
	  return new Promise(function (resolve, reject) {
	    var token = Buffer.from(_constants.API_AUTH_USERNAME + ":" + _constants.API_AUTH_PASSWORD, "utf8").toString("base64");
	    var req = _.scAxios.request("/mmphonenumber", {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Basic " + token
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var PatientLoginUser = function PatientLoginUser(data) {
	  return new Promise(function (resolve, reject) {
	    var token = Buffer.from(_constants.API_AUTH_USERNAME + ":" + _constants.API_AUTH_PASSWORD, "utf8").toString("base64");
	    var req = _.scAxios.request("/mmlogin", {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Basic " + token
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var PatientLists = function (_Component) {
	  _inherits(PatientLists, _Component);
	
	  function PatientLists() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PatientLists);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PatientLists.__proto__ || Object.getPrototypeOf(PatientLists)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      get_phone_number: "",
	      patientLists: [],
	      patient_id: ""
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshGetPatitentLists = function (data) {
	      getPatitentLists(data).then(function (res) {
	        if (res) {
	          var records = res;
	          //console.log(res);
	          _this.setState({ patientLists: records });
	        } else {
	          _this.setState({ patientLists: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      var data = {
	        patientid: _this.state.patient_id
	      };
	      PatientLoginUser(data).then(function (res) {
	        if (!!res[0].token) {
	          (0, _userSession.startUserSession)(res[0].token);
	          _this.setState({ signin_success: true });
	          //this.props.actions.userLoginSuccess(res.data);
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("Error occured", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PatientLists, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var query = new URLSearchParams(this.props.location.search);
	      var phone_number = query.get("phone_number");
	      var data = {
	        PhoneNumber: phone_number
	      };
	      if (phone_number) {
	        this.refreshGetPatitentLists(data);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      //let site_url = location.protocol + '//' + location.host + "/unitedhospital";
	      //let site_url = location.protocol + '//' + location.host;
	      var _ref2 = this.props.location.state || {
	        from: { pathname: "/index2" }
	      },
	          from = _ref2.from;
	
	      if ((0, _PrivateRoute.validateUserToken)()) {
	        if (!this.state.signin_success) return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/patientlists" });
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: from });
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "section",
	          { className: "banner-part" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _HomeHeader2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "container", style: { backgroundColor: "#fef3e9" } },
	            _react2.default.createElement(
	              "h1",
	              { "data-aos": "fade-up", "data-aos-duration": 1000 },
	              "On a Mission To Keep Families Healthy"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row", "data-aos": "fade-up", "data-aos-duration": 1000 },
	              _react2.default.createElement("div", { className: "col-sm-2" }),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-8" },
	                _react2.default.createElement(
	                  "form",
	                  { className: "d-flex" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mb-3" },
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      placeholder: "Search for physicans & departments",
	                      "aria-label": "Username",
	                      "aria-describedby": "basic-addon1"
	                    }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "input-group-text", id: "basic-addon1" },
	                      _react2.default.createElement("i", { className: "fa-solid fa-magnifying-glass" })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row sp-top" },
	              _react2.default.createElement("div", { className: "col-sm-2" }),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-8" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-3" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "excellence-part",
	                        "data-aos": "zoom-in",
	                        "data-aos-duration": 1000
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-3" },
	                          _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-9" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Center for Excellence"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-3" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "excellence-part",
	                        "data-aos": "zoom-in",
	                        "data-aos-duration": 1000
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-3" },
	                          _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-9" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Center for Excellence"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-3" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "excellence-part",
	                        "data-aos": "zoom-in",
	                        "data-aos-duration": 1000
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-3" },
	                          _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-9" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Center for Excellence"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-3" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "excellence-part",
	                        "data-aos": "zoom-in",
	                        "data-aos-duration": 1000
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-3" },
	                          _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-9" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Center for Excellence"
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-3" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "excellence-part",
	                        "data-aos": "zoom-in",
	                        "data-aos-duration": 1000
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-3" },
	                          _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-9" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Center for Excellence"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-3" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "excellence-part",
	                        "data-aos": "zoom-in",
	                        "data-aos-duration": 1000
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-3" },
	                          _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-9" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Center for Excellence"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-3" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "excellence-part",
	                        "data-aos": "zoom-in",
	                        "data-aos-duration": 1000
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-3" },
	                          _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-9" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Center for Excellence"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-3" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "excellence-part",
	                        "data-aos": "zoom-in",
	                        "data-aos-duration": 1000
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-3" },
	                          _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-9" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Center for Excellence"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement("div", { className: "col-sm-4" }),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "contact-number" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "tel:10666" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-4 text-center" },
	                        _react2.default.createElement("img", { src: _hotline_phone2.default, alt: "hotline_phone" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-8" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          " ",
	                          _react2.default.createElement(
	                            "span",
	                            null,
	                            "24*7 Hotline"
	                          ),
	                          _react2.default.createElement("br", null),
	                          " 10666"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "center-of-excellence" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "Center of Excellence"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-11" },
	                _react2.default.createElement(
	                  "div",
	                  { id: "news-slider", className: "owl-carousel" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("img", { src: _cardiac2.default, alt: "cardiac" })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Cardiac"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("img", { src: _cardiac2.default, alt: "cardiac" })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Cardiac"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("img", { src: _cardiac2.default, alt: "cardiac" })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Cardiac"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("img", { src: _cardiac2.default, alt: "cardiac" })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Cardiac"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("img", { src: _cardiac2.default, alt: "cardiac" })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Cardiac"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("img", { src: _cardiac2.default, alt: "cardiac" })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Cardiac"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("img", { src: _cardiac2.default, alt: "cardiac" })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Cardiac"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "tabs", id: "tabs-mm" },
	              _react2.default.createElement(
	                "div",
	                { id: "tab2", className: "tab" },
	                _react2.default.createElement(
	                  "ul",
	                  { className: "nav" },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#tab1" },
	                      _react2.default.createElement("img", { src: _male2.default, alt: "" }),
	                      " Male"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "active " },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#tab2", className: "border-red" },
	                      _react2.default.createElement("img", { src: _female2.default, alt: "" }),
	                      " Female"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "text-areya" },
	                  _react2.default.createElement("img", { src: _plain_anatomy2.default.png, alt: "plain_anatomy" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { id: "tab1", className: "tab" },
	                _react2.default.createElement(
	                  "ul",
	                  { className: "nav" },
	                  _react2.default.createElement(
	                    "li",
	                    { className: "active" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#tab1" },
	                      _react2.default.createElement("img", { src: _male2.default, alt: "" }),
	                      " Male"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#tab2", className: "border-red" },
	                      _react2.default.createElement("img", { src: _female2.default, alt: "" }),
	                      " Female"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "text-areya" },
	                  _react2.default.createElement("img", { src: _plain_anatomy2.default, alt: "plain_anatomy" })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row", id: "saying" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-12 mb-4" },
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  "What Patients Are Saying"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-3 text-center" },
	                _react2.default.createElement("img", { src: _happy_patient2.default, alt: "happy_patient" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-6" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "zubaida" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    "Zubaida Tahman ",
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "(Cardiac Surgery)"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-3" },
	                _react2.default.createElement(
	                  "button",
	                  { className: "see-more " },
	                  "See More Patient Stories"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "news-events" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "News & Events"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12" },
	                _react2.default.createElement(
	                  "div",
	                  { id: "news-slider-2", className: "owl-carousel" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "news-part" },
	                      _react2.default.createElement("img", { src: _news_events_2.default, alt: "news_events_1" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "bg-color-back" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "news-events", id: "Publications" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "h2",
	              { className: "border-bottom" },
	              "Publications"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12" },
	                _react2.default.createElement(
	                  "div",
	                  { id: "news-slider-3", className: "owl-carousel" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img-back-pub" },
	                      _react2.default.createElement("img", { src: _potrait2.default, alt: "potrait" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "areya-contant" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img-back-pub" },
	                      _react2.default.createElement("img", { src: _landscape2.default, alt: "landscape" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "areya-contant" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img-back-pub" },
	                      _react2.default.createElement("img", { src: _landscape2.default, alt: "landscape" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "areya-contant" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img-back-pub" },
	                      _react2.default.createElement("img", { src: _landscape2.default, alt: "landscape" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "areya-contant" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img-back-pub" },
	                      _react2.default.createElement("img", { src: _landscape2.default, alt: "landscape" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "areya-contant" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img-back-pub" },
	                      _react2.default.createElement("img", { src: _landscape2.default, alt: "landscape" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "areya-contant" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img-back-pub" },
	                      _react2.default.createElement("img", { src: _landscape2.default, alt: "landscape" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "areya-contant" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "post-slide" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img-back-pub" },
	                      _react2.default.createElement("img", { src: _landscape2.default, alt: "landscape" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "areya-contant" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img-back-pub" },
	                      _react2.default.createElement("img", { src: _landscape2.default, alt: "landscape" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "areya-contant" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Screening at doorstep: A smart step for your health"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "test" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement("img", { src: _tes2.default, alt: "tes" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "offcanvas offcanvas-start show",
	            tabIndex: "-1",
	            id: "offcanvasExample",
	            "aria-labelledby": "offcanvasExampleLabel"
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-header" },
	            _react2.default.createElement(
	              "h5",
	              { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	              " "
	            ),
	            _react2.default.createElement("button", {
	              type: "button",
	              className: "btn-close text-reset",
	              "data-bs-dismiss": "offcanvas",
	              "aria-label": "Close"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-body" },
	            _react2.default.createElement(
	              "div",
	              { className: "row text-center", id: "logos" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-2 " },
	                _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "left-offcanvas" },
	              _react2.default.createElement(
	                "div",
	                { className: "offcan-top-mar" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Patients Lists"
	                )
	              ),
	              _react2.default.createElement(
	                "form",
	                {
	                  onSubmit: this.handleSubmit,
	                  id: "patientloginform",
	                  className: "needs-validation",
	                  noValidate: true
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-3" },
	                  this.state.patientLists.length > 0 ? this.state.patientLists.map(function (patient_list) {
	
	                    return _react2.default.createElement(
	                      "div",
	                      {
	                        className: "col-6 sp-0-0 mt-3",
	                        key: patient_list.PatientID
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "doctor-list" },
	                        _react2.default.createElement("input", {
	                          type: "radio",
	                          className: "patient_user",
	                          name: "patient_id",
	                          value: patient_list.PatientID,
	                          onChange: _this2.handleChange
	                        }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row list_content_sec" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-5" },
	                            _react2.default.createElement("img", { src: _doc2.default, alt: "doc" })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-7" },
	                            _react2.default.createElement(
	                              "h5",
	                              null,
	                              patient_list.PatientName
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "Endocrinology & Metabolism) ",
	                              _react2.default.createElement("br", null),
	                              "MD (Endocrinology & Metabolism)"
	                            )
	                          )
	                        )
	                      )
	                    );
	                  }) : _react2.default.createElement(
	                    "div",
	                    { className: "col-6 sp-0-0" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "doctor-list" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "No Result found"
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "submit",
	                        className: "btn-links appointment-new",
	                        id: "Schedule"
	                      },
	                      "Check Schedule"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 }),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return PatientLists;
	}(_react.Component);
	
	exports.default = PatientLists;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(116);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _BloodPressureChart = __webpack_require__(598);
	
	var _BloodPressureChart2 = _interopRequireDefault(_BloodPressureChart);
	
	var _HeartRateChart = __webpack_require__(627);
	
	var _HeartRateChart2 = _interopRequireDefault(_HeartRateChart);
	
	var _TemperatureChart = __webpack_require__(667);
	
	var _TemperatureChart2 = _interopRequireDefault(_TemperatureChart);
	
	var _WeightChart = __webpack_require__(670);
	
	var _WeightChart2 = _interopRequireDefault(_WeightChart);
	
	var _SwiperComponent = __webpack_require__(498);
	
	var _SwiperComponent2 = _interopRequireDefault(_SwiperComponent);
	
	var _react3 = __webpack_require__(441);
	
	__webpack_require__(237);
	
	var _axios = __webpack_require__(64);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _constants = __webpack_require__(3);
	
	var _BookAppointmentPopup = __webpack_require__(60);
	
	var _BookAppointmentPopup2 = _interopRequireDefault(_BookAppointmentPopup);
	
	var _PopupIndex = __webpack_require__(65);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var PatientProtal = function PatientProtal() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      data = _useState2[0],
	      setData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      bookAppointmentPopupClicked = _useState4[0],
	      setBookAppointmentPopupClicked = _useState4[1];
	
	  console.log(data, "pakages_data");
	  // const patientId = "1000555116";
	  // const id = localStorage.getItem("USER_ID")
	
	  var patientId = "1000555116";
	
	  var requestBody = {
	    patient: patientId
	  };
	
	  // const requestBody = JSON.stringify(dataToSend);
	  // console.log(requestBody,"pakages_data")
	
	  // const patientId = "1000555116";
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _.scAxiosAdmin.post("/job_applications", {
	                  headers: {
	                    Accept: "application/json",
	                    "Content-Type": "application/json"
	                  }
	                });
	
	              case 3:
	                response = _context.sent;
	
	
	                setData(response.data); // Assuming the response contains the data you need
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0);
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 7]]);
	      }));
	
	      return function fetchData() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	
	  var bloodPressureData = {
	    labels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5"],
	    datasets: [{ name: "Systolic Pressure", data: [120, 130, 125, 140, 135] }, { name: "Diastolic Pressure", data: [80, 85, 78, 90, 82] }]
	  };
	  var heartRateData = {
	    labels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5"],
	    datasets: [{ name: "Heart Rate", data: [75, 80, 85, 90, 95] }]
	  };
	  var temperatureData = {
	    labels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5"],
	    datasets: [{ name: "Temperature", data: [25, 28, 24, 30, 22] }]
	  };
	  var weightData = {
	    labels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5"],
	    datasets: [{ name: "Weight", data: [70, 72, 69, 73, 68] }]
	  };
	
	  function extractBloodPressureValues(data) {
	    var pressureValues = data.map(function (entry) {
	      var bloodPressure = entry.Blood_Pressure || ""; // Handle cases where Blood_Pressure is undefined or empty
	
	      // Extract systolic and diastolic pressure values using regular expression
	      var matches = bloodPressure.match(/(\d+)\/(\d+)/);
	
	      // If there are matches, return an object with systolic and diastolic pressure values
	      if (matches && matches.length === 3) {
	        return {
	          systolicPressure: parseInt(matches[1]),
	          diastolicPressure: parseInt(matches[2])
	        };
	      }
	
	      // If no matches, return null or handle it based on your requirements
	      return null;
	    });
	
	    // Filter out entries where blood pressure values couldn't be extracted
	    var validPressureValues = pressureValues.filter(function (entry) {
	      return entry !== null;
	    });
	
	    // Separate systolic and diastolic pressure values into two arrays
	    var systolicPressures = validPressureValues.map(function (entry) {
	      return entry.systolicPressure;
	    });
	    var diastolicPressures = validPressureValues.map(function (entry) {
	      return entry.diastolicPressure;
	    });
	
	    return { systolicPressures: systolicPressures, diastolicPressures: diastolicPressures };
	  }
	
	  // Example usage with your array of objects
	  var datas = [{
	    Temperature: "",
	    Hight: "0.00",
	    Oxygen_saturation: "",
	    Pulse_Rate: "86",
	    Blood_Pressure: "",
	    Heart_rate: "",
	    Respiration: "",
	    Weight: "0.00",
	    Date: "2022-03-07",
	    BMI: "0.00"
	  }, {
	    Temperature: "",
	    Hight: "0.00",
	    Oxygen_saturation: "",
	    Pulse_Rate: "86",
	    Blood_Pressure: "110/70",
	    Heart_rate: "",
	    Respiration: "",
	    Weight: "0.00",
	    Date: "2022-03-07",
	    BMI: "0.00"
	  }, {
	    Temperature: "",
	    Hight: "0.00",
	    Oxygen_saturation: "98%",
	    Pulse_Rate: "86",
	    Blood_Pressure: "110/70",
	    Heart_rate: "",
	    Respiration: "",
	    Weight: "0.00",
	    Date: "2022-03-07",
	    BMI: "0.00"
	  }, {
	    Temperature: "",
	    Hight: "0.00",
	    Oxygen_saturation: "99%",
	    Pulse_Rate: "66",
	    Blood_Pressure: "100/60",
	    Heart_rate: "",
	    Respiration: "",
	    Weight: "0.00",
	    Date: "2022-03-31",
	    BMI: "0.00"
	  }, {
	    Temperature: "",
	    Hight: "0.00",
	    Oxygen_saturation: "98%",
	    Pulse_Rate: "72",
	    Blood_Pressure: "140/85",
	    Heart_rate: "",
	    Respiration: "",
	    Weight: "0.00",
	    Date: "2022-05-08",
	    BMI: "0.00"
	  }, {
	    Temperature: "",
	    Hight: "0.00",
	    Oxygen_saturation: "98%",
	    Pulse_Rate: "71",
	    Blood_Pressure: "120/80",
	    Heart_rate: "",
	    Respiration: "",
	    Weight: "0.00",
	    Date: "2022-09-13",
	    BMI: "0.00"
	  }, {
	    Temperature: "",
	    Hight: "0.00",
	    Oxygen_saturation: "96%",
	    Pulse_Rate: "94",
	    Blood_Pressure: "140/80",
	    Heart_rate: "",
	    Respiration: "",
	    Weight: "0.00",
	    Date: "2023-01-11",
	    BMI: "0.00"
	  }, {
	    Temperature: "",
	    Hight: "161",
	    Oxygen_saturation: "98%",
	    Pulse_Rate: "60",
	    Blood_Pressure: "90/60",
	    Heart_rate: "",
	    Respiration: "",
	    Weight: "75",
	    Date: "2023-05-24",
	    BMI: "28.90"
	  }];
	
	  var _extractBloodPressure = extractBloodPressureValues(datas),
	      systolicPressures = _extractBloodPressure.systolicPressures,
	      diastolicPressures = _extractBloodPressure.diastolicPressures;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Patient Portal | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Services"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      {
	        id: "giveMarginService",
	        className: "allservices",
	        style: { backgroundColor: "#fef3e9" }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "container pt-5 " },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "row pb-3 g-0",
	            style: {
	              display: "flex",
	              columnGap: "15px",
	              rowGap: "15px"
	              //  width: "90vw",
	              // maxWidth: "1140px",
	              // margin: "0 auto",
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-md-7 p-3 d-none",
	              style: {
	                backgroundColor: "#fff",
	                width: "620px",
	                borderRadius: "5px"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "no1 mt-2 p-2",
	                style: {
	                  boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
	                  borderRadius: "5px"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "box d-flex justify-content-between align-items-center p-2" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "box1 d-flex lign-items-center ",
	                    style: { columnGap: "10px", rowGap: "10px" }
	                  },
	                  _react2.default.createElement("img", { src: "/assets/images/blood-pressure 1 (2).png", alt: "" }),
	                  _react2.default.createElement(
	                    "h4",
	                    {
	                      className: "text-center pt-2",
	                      style: { fontWeight: "bold" }
	                    },
	                    "Blood Pressure"
	                  )
	                ),
	                _react2.default.createElement("img", { src: "/assets/images/menu-dots 1.png", alt: "" })
	              ),
	              _react2.default.createElement(
	                "h4",
	                {
	                  style: {
	                    fontWeight: "bold",
	                    color: "#187979",
	                    paddingLeft: "3.5rem"
	                  }
	                },
	                "120/80"
	              ),
	              _react2.default.createElement(_BloodPressureChart2.default, { data: bloodPressureData })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "no1 mt-2 p-2",
	                style: {
	                  boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
	                  borderRadius: "5px"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "box d-flex justify-content-between align-items-center p-2" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "box1 d-flex lign-items-center ",
	                    style: { columnGap: "10px", rowGap: "10px" }
	                  },
	                  _react2.default.createElement("img", { src: "/assets/images/blood-pressure 2.png", alt: "" }),
	                  _react2.default.createElement(
	                    "h4",
	                    {
	                      className: "text-center pt-2",
	                      style: { fontWeight: "bold" }
	                    },
	                    "Heart Rate"
	                  )
	                ),
	                _react2.default.createElement("img", { src: "/assets/images/menu-dots 1.png", alt: "" })
	              ),
	              _react2.default.createElement(
	                "h4",
	                {
	                  style: {
	                    fontWeight: "bold",
	                    color: "#187979",
	                    paddingLeft: "3.5rem"
	                  }
	                },
	                "70"
	              ),
	              _react2.default.createElement(_HeartRateChart2.default, { data: heartRateData })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "no1 mt-2 p-2",
	                style: {
	                  boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
	                  borderRadius: "5px"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "box d-flex justify-content-between align-items-center p-2" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "box1 d-flex lign-items-center ",
	                    style: { columnGap: "10px", rowGap: "10px" }
	                  },
	                  _react2.default.createElement("img", { src: "/assets/images/temperature 1.png", alt: "" }),
	                  _react2.default.createElement(
	                    "h4",
	                    {
	                      className: "text-center pt-2",
	                      style: { fontWeight: "bold" }
	                    },
	                    "Temperature"
	                  )
	                ),
	                _react2.default.createElement("img", { src: "/assets/images/menu-dots 1.png", alt: "" })
	              ),
	              _react2.default.createElement(
	                "h4",
	                {
	                  style: {
	                    fontWeight: "bold",
	                    color: "#187979",
	                    paddingLeft: "3.5rem"
	                  }
	                },
	                "99.1 c",
	                " "
	              ),
	              _react2.default.createElement(_TemperatureChart2.default, { data: temperatureData })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "no1 mt-2 mb-2 p-2",
	                style: {
	                  boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
	                  borderRadius: "5px"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "box d-flex justify-content-between align-items-center p-2" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "box1 d-flex lign-items-center ",
	                    style: { columnGap: "10px", rowGap: "10px" }
	                  },
	                  _react2.default.createElement("img", { src: "/assets/images/blood-pressure 1 (1).png", alt: "" }),
	                  _react2.default.createElement(
	                    "h4",
	                    {
	                      className: "text-center pt-2",
	                      style: { fontWeight: "bold" }
	                    },
	                    "Weight"
	                  )
	                ),
	                _react2.default.createElement("img", { src: "/assets/images/menu-dots 1.png", alt: "" })
	              ),
	              _react2.default.createElement(
	                "h4",
	                {
	                  style: {
	                    fontWeight: "bold",
	                    color: "#187979",
	                    paddingLeft: "3.5rem"
	                  }
	                },
	                "80 kg"
	              ),
	              _react2.default.createElement(_WeightChart2.default, { data: weightData })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-md-5 p-3",
	              style: {
	                backgroundColor: "#fff",
	                borderRadius: "5px",
	                height: "fit-content"
	              }
	            },
	            localStorage.getItem(_constants.USER_LOCAL_ID) ? _react2.default.createElement(
	              "a",
	              {
	                className: "text-decoration-none"
	                // href="#offcanvasExample"
	                , "data-bs-toggle": "offcanvas",
	                role: "button",
	                "data-bs-target": "#BookAppointMent",
	                "aria-controls": "BookAppointMent",
	                onClick: function onClick() {
	                  return setBookAppointmentPopupClicked(true);
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "no1 mt-2 mb-2 p-3 d-flex justify-content-center flex-column align-items-center",
	                  style: {
	                    boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
	                    borderRadius: "5px",
	                    columnGap: "10px",
	                    rowGap: "10px"
	                  }
	                },
	                _react2.default.createElement(
	                  "svg",
	                  {
	                    style: { color: "#29bc97" },
	                    xmlns: "http://www.w3.org/2000/svg",
	                    width: "35",
	                    height: "35",
	                    fill: "currentColor",
	                    className: "bi bi-plus-circle",
	                    viewBox: "0 0 16 16"
	                  },
	                  _react2.default.createElement("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }),
	                  _react2.default.createElement("path", { d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" })
	                ),
	                _react2.default.createElement(
	                  "h4",
	                  { style: { fontSize: "14px" } },
	                  "Book Appointments"
	                )
	              )
	            ) : _react2.default.createElement(
	              "a",
	              {
	                className: "text-decoration-none",
	                href: "#offcanvasExample",
	                "data-bs-toggle": "offcanvas",
	                role: "button",
	                "aria-controls": "offcanvasExample"
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "no1 mt-2 mb-2 p-3 d-flex justify-content-center flex-column align-items-center",
	                  style: {
	                    boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
	                    borderRadius: "5px",
	                    columnGap: "10px",
	                    rowGap: "10px"
	                  }
	                },
	                _react2.default.createElement(
	                  "svg",
	                  {
	                    style: { color: "#29bc97" },
	                    xmlns: "http://www.w3.org/2000/svg",
	                    width: "35",
	                    height: "35",
	                    fill: "currentColor",
	                    className: "bi bi-plus-circle",
	                    viewBox: "0 0 16 16"
	                  },
	                  _react2.default.createElement("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }),
	                  _react2.default.createElement("path", { d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" })
	                ),
	                _react2.default.createElement(
	                  "h4",
	                  { style: { fontSize: "14px" } },
	                  "Book Appointments"
	                )
	              )
	            ),
	            _react2.default.createElement(_SwiperComponent2.default, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_BookAppointmentPopup2.default, {
	      bookAppointmentPopupClicked: bookAppointmentPopupClicked,
	      setBookAppointmentPopupClicked: setBookAppointmentPopupClicked
	    }),
	    _react2.default.createElement(_PopupIndex2.default, null),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = PatientProtal;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeopleDiversity = function PeopleDiversity() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      staticPageData = _useState2[0],
	      setStaticPageData = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var getHeaderData = function getHeaderData(data) {
	      try {
	        var req = _.scAxiosAdmin.request("/static_services_pages/43", {
	          // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
	          method: "get",
	          headers: {
	            Accept: "application/json"
	            // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            // console.log('your log output',data)
	            // setStaticPageData(data.data.data);
	            setStaticPageData(data.data.components);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getHeaderData();
	  }, []);
	  var boardmembers = [{
	    title: "Workplace diversity refers to the variety of differences between people in an organization. That sounds simple, but diversity encompasses race, gender, ethnic group, age, personality, cognitive style, tenure, organizational function, education, background and more. Diversity not only involves how people perceive themselves, but how they perceive others. Those perceptions affect their interactions. For a wide assortment of employees to function effectively as an organization, human resource professionals need to deal effectively with issues such as communication, adaptability and change.",
	    dsc: "United Hospital employs a diverse workforce to attend to supply a great diversity of clinical and non-clinical and management solutions to address issues in service, sourcing, and allocation of resources. Employees from diverse backgrounds bring individual talents and experiences in suggesting ideas which are customized to fit to the demands of customers (patients). This enhances the dynamism of the organization to serve its varied patients with an international flare."
	  }];
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "People Diversity | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "People Diversity"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      staticPageData.length > 0 ? staticPageData.map(function (section, index) {
	        if (section.type === "description") {
	          return _react2.default.createElement(
	            "section",
	            { className: "termscondbody py-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "container", id: "giveMargin" },
	              _react2.default.createElement(
	                "div",
	                { className: "w-100 d-flex justify-content-center align-items-center flex-column" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "flex",
	                      justifyContent: "flex-start",
	                      alignItems: "flex-start",
	                      flexDirection: "column"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "h3",
	                    {
	                      className: "text-center",
	                      style: {
	                        color: "#0C807D",
	                        fontSize: "28px",
	                        fontWeight: "500"
	                      }
	                    },
	                    section.value.title
	                  )
	                )
	              ),
	              _react2.default.createElement("div", {
	                className: "content mt-3 w-100 ",
	                dangerouslySetInnerHTML: {
	                  __html: section.value.content
	                }
	              })
	            )
	          );
	        }
	      }) : ""
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	  );
	};
	
	exports.default = PeopleDiversity;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	var _jquery = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pharmacy = function Pharmacy() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Death Certificate | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "newsevents, Singlenewsevents"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement("div", { id: "giveMargin", className: "" }),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Pharmacy;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getAlbums = function getAlbums(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/album/listalbum", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var PhotoGallery = function (_Component) {
	  _inherits(PhotoGallery, _Component);
	
	  function PhotoGallery() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PhotoGallery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhotoGallery.__proto__ || Object.getPrototypeOf(PhotoGallery)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      galleries: []
	    }, _this.refreshGallery = function (event) {
	      getAlbums().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ galleries: records });
	        } else {
	          _this.setState({ galleries: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoGallery, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshGallery();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var boardmembers = [{
	        title: "Workplace diversity refers to the variety of differences between people in an organization. That sounds simple, but diversity encompasses race, gender, ethnic group, age, personality, cognitive style, tenure, organizational function, education, background and more. Diversity not only involves how people perceive themselves, but how they perceive others. Those perceptions affect their interactions. For a wide assortment of employees to function effectively as an organization, human resource professionals need to deal effectively with issues such as communication, adaptability and change.",
	        dsc: "United Hospital employs a diverse workforce to attend to supply a great diversity of clinical and non-clinical and management solutions to address issues in service, sourcing, and allocation of resources. Employees from diverse backgrounds bring individual talents and experiences in suggesting ideas which are customized to fit to the demands of customers (patients). This enhances the dynamism of the organization to serve its varied patients with an international flare."
	      }];
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	          title: "Photo Gallery | United Hospital Bangladesh | Best Hospital In Bangladesh",
	          description: "Photo Gallery of United Hospital Bangladesh Limited",
	          pathSlug: "/gallery/photo-gallery",
	          keywords: "newsevents, Singlenewsevents"
	        }),
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement("meta", {
	            name: "description",
	            content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	          }),
	          _react2.default.createElement(
	            "script",
	            { type: "application/ld+json" },
	            JSON.stringify({
	              "@context": "http://schema.org",
	              "@type": "LocalBusiness",
	              name: "United Hospital Limited",
	              image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	              telephone: "10666",
	              email: "info@uhlbd.com",
	              address: {
	                "@type": "PostalAddress",
	                streetAddress: "plot 15, Road 71, Gulshan",
	                addressLocality: "Dhaka",
	                addressRegion: "Dhaka",
	                addressCountry: "Bangladesh",
	                postalCode: "1212"
	              },
	              openingHoursSpecification: {
	                "@type": "OpeningHoursSpecification",
	                opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	              },
	              url: "http://www.uhlbd.com/",
	              aggregateRating: {
	                "@type": "AggregateRating",
	                ratingValue: "3.9",
	                bestRating: "5",
	                worstRating: "1",
	                ratingCount: "756"
	              },
	              review: {
	                "@type": "Review",
	                author: {
	                  "@type": "Person",
	                  name: "abdul kahar"
	                },
	                datePublished: "2019-02-12",
	                reviewRating: {
	                  "@type": "Rating",
	                  ratingValue: "3.9",
	                  bestRating: "5",
	                  worstRating: "1"
	                },
	                reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	              }
	            })
	          ),
	          _react2.default.createElement("meta", {
	            name: "Subject",
	            content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	          }),
	          _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	          _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	          _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	          _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	          _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	          _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	          _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	          _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	          _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	          _react2.default.createElement("meta", {
	            name: "classification",
	            content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	          }),
	          _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	          _react2.default.createElement("meta", {
	            names: "apple-mobile-web-app-status-bar-style",
	            content: "black-translucent"
	          }),
	          _react2.default.createElement("meta", {
	            name: "msvalidate.01",
	            content: "16C4E0B16E39354E550F64BD707F6A97"
	          })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	          _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	          _react2.default.createElement(
	            "section",
	            { className: "termscondbody mt-5 pb-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "container p-3" },
	              _react2.default.createElement(
	                "h2",
	                { className: "text-secondary" },
	                "Photo Gallery"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row g-3 w-100 mx-auto" },
	                boardmembers.map(function (menubars) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-md-8 mt-5 bg-light flex-row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "content mt-3 w-100 p-3", key: menubars },
	                      _this2.state.galleries.length > 0 ? _this2.state.galleries.map(function (gallery) {
	                        var gallery_name = gallery.album_name;
	                        var gallery_img = JSON.parse(gallery.album_pics);
	                        return [_react2.default.createElement(
	                          "div",
	                          { className: "card col-lg-6 d-inline-flex" },
	                          _react2.default.createElement(
	                            "a",
	                            { href: "photo-gallery/" + gallery.id },
	                            _react2.default.createElement("img", {
	                              className: "card-img-top",
	                              src: _constants.IMAGE_URL + "AlbumImg/" + gallery_img[0],
	                              alt: "Card image cap"
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "card-body" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "photo-gallery/" + gallery.Slug,
	                                className: "btn btn-sm",
	                                style: {
	                                  backgroundColor: "#474747",
	                                  borderRadius: "5px"
	                                }
	                              },
	                              gallery.album_name
	                            )
	                          )
	                        )];
	                      }
	                      //    <div className="col-lg-offset-1"></div>
	                      ) : ""
	                    )
	                  );
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mt-5 col-lg-4 col-md-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "text-profile", id: "mobile-part" },
	                    _react2.default.createElement(
	                      "div",
	                      { id: "sidebar-2", className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 sidebar-item " },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            className: "category-list-link open-cat-list",
	                            href: "#"
	                          },
	                          "Select Gallery"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          {
	                            className: "list-unstyled category-list patients-category-list",
	                            id: "department-list-sidebar"
	                          },
	                          this.state.galleries.length > 0 ? this.state.galleries.map(function (gallery) {
	                            var gallery_name = gallery.album_name;
	                            return _react2.default.createElement(
	                              "li",
	                              null,
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  className: "",
	                                  href: _constants.SITE_URL + "/gallery/photo-gallery/" + gallery.Slug
	                                },
	                                gallery.album_name
	                              )
	                            );
	                          }) : ""
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return PhotoGallery;
	}(_react.Component);
	
	exports.default = PhotoGallery;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactImageLightbox = __webpack_require__(126);
	
	var _reactImageLightbox2 = _interopRequireDefault(_reactImageLightbox);
	
	__webpack_require__(837);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This only needs to be imported once in your app
	
	var getSingleGallery = function getSingleGallery(slug) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/album/getalbum/" + slug, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var PhotoGalleryInner = function (_Component) {
	  _inherits(PhotoGalleryInner, _Component);
	
	  function PhotoGalleryInner() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PhotoGalleryInner);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhotoGalleryInner.__proto__ || Object.getPrototypeOf(PhotoGalleryInner)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      gallery: [],
	      album_pics: [],
	      photoIndex: 0,
	      isOpen: false
	    }, _this.refreshSingleGallery = function (event) {
	      var slug = _this.props.match.params["slug"];
	
	      getSingleGallery(slug).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ gallery: records });
	          _this.setState({
	            album_pics: JSON.parse(_this.state.gallery.album_pics)
	          });
	        } else {
	          _this.setState({ gallery: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoGalleryInner, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshSingleGallery();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var slug = this.props.match.params["slug"];
	      var _state = this.state,
	          photoIndex = _state.photoIndex,
	          isOpen = _state.isOpen,
	          album_pics = _state.album_pics;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	          title: "Photo Gallery | United Hospital Bangladesh | Best Hospital In Bangladesh",
	          description: "Photo Gallery of United Hospital Bangladesh Limited",
	          pathSlug: "/gallery/photo-gallery",
	          keywords: "newsevents, Singlenewsevents"
	        }),
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement("meta", {
	            name: "description",
	            content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	          }),
	          _react2.default.createElement(
	            "script",
	            { type: "application/ld+json" },
	            JSON.stringify({
	              "@context": "http://schema.org",
	              "@type": "LocalBusiness",
	              name: "United Hospital Limited",
	              image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	              telephone: "10666",
	              email: "info@uhlbd.com",
	              address: {
	                "@type": "PostalAddress",
	                streetAddress: "plot 15, Road 71, Gulshan",
	                addressLocality: "Dhaka",
	                addressRegion: "Dhaka",
	                addressCountry: "Bangladesh",
	                postalCode: "1212"
	              },
	              openingHoursSpecification: {
	                "@type": "OpeningHoursSpecification",
	                opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	              },
	              url: "http://www.uhlbd.com/",
	              aggregateRating: {
	                "@type": "AggregateRating",
	                ratingValue: "3.9",
	                bestRating: "5",
	                worstRating: "1",
	                ratingCount: "756"
	              },
	              review: {
	                "@type": "Review",
	                author: {
	                  "@type": "Person",
	                  name: "abdul kahar"
	                },
	                datePublished: "2019-02-12",
	                reviewRating: {
	                  "@type": "Rating",
	                  ratingValue: "3.9",
	                  bestRating: "5",
	                  worstRating: "1"
	                },
	                reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	              }
	            })
	          ),
	          _react2.default.createElement("meta", {
	            name: "Subject",
	            content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	          }),
	          _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	          _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	          _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	          _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	          _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	          _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	          _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	          _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	          _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	          _react2.default.createElement("meta", {
	            name: "classification",
	            content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	          }),
	          _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	          _react2.default.createElement("meta", {
	            names: "apple-mobile-web-app-status-bar-style",
	            content: "black-translucent"
	          }),
	          _react2.default.createElement("meta", {
	            name: "msvalidate.01",
	            content: "16C4E0B16E39354E550F64BD707F6A97"
	          })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          { id: "giveMarginService", className: "", style: { backgroundColor: "#fef3e9" } },
	          _react2.default.createElement(
	            "section",
	            { className: "prof-dr" },
	            _react2.default.createElement(
	              "div",
	              { className: "container " },
	              _react2.default.createElement(
	                "div",
	                { className: "box-of-about mt-4 pb-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-4 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "text-profile" },
	                      this.state.album_pics.map(function (album_pic) {
	
	                        return [_react2.default.createElement("img", {
	                          src: _constants.IMAGE_URL + "AlbumImg/" + album_pic,
	                          onClick: function onClick() {
	                            return _this2.setState({ isOpen: true });
	                          },
	                          style: {
	                            width: "80vw",
	                            maxWidth: "256px",
	                            height: "144px"
	                          }
	                        })];
	                      }),
	                      isOpen && _react2.default.createElement(_reactImageLightbox2.default, {
	                        mainSrc: _constants.IMAGE_URL + "AlbumImg/" + album_pics[photoIndex],
	                        nextSrc: _constants.IMAGE_URL + "AlbumImg/" + album_pics[(photoIndex + 1) % album_pics.length],
	                        prevSrc: _constants.IMAGE_URL + "AlbumImg/" + album_pics[(photoIndex + album_pics.length - 1) % album_pics.length],
	                        onCloseRequest: function onCloseRequest() {
	                          return _this2.setState({ isOpen: false });
	                        },
	                        onMovePrevRequest: function onMovePrevRequest() {
	                          return _this2.setState({
	                            photoIndex: (photoIndex + album_pics.length - 1) % album_pics.length
	                          });
	                        },
	                        onMoveNextRequest: function onMoveNextRequest() {
	                          return _this2.setState({
	                            photoIndex: (photoIndex + 1) % album_pics.length
	                          });
	                        }
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return PhotoGalleryInner;
	}(_react.Component);
	
	exports.default = PhotoGalleryInner;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoGalleryModal = function PhotoGalleryModal(_ref) {
	  var selectedImage = _ref.selectedImage,
	      closeModal = _ref.closeModal;
	
	  return _react2.default.createElement(
	    "div",
	    {
	      className: "modal gallery-modal fade",
	      id: "staticBackdrop",
	      "data-bs-backdrop": "static",
	      "data-bs-keyboard": "false",
	      tabindex: "-1",
	      "aria-labelledby": "staticBackdropLabel",
	      "aria-hidden": "true",
	      style: { display: "block", zIndex: "99999" }
	    },
	    _react2.default.createElement(
	      "div",
	      {
	        className: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl",
	        role: "document"
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "modal-content" },
	        _react2.default.createElement(
	          "div",
	          { className: "modal-header" },
	          _react2.default.createElement("button", {
	            type: "button",
	            "class": "btn-close",
	            "data-bs-dismiss": "modal",
	            onClick: closeModal
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "modal-body" },
	          _react2.default.createElement(
	            "section",
	            { "class": "  " },
	            _react2.default.createElement(
	              "div",
	              { "class": "row g-0 " },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "w-100 d-flex justify-content-center mx-auto",
	                  style: {
	                    // maxHeight: "500px",
	                    // maxWidth: "940px",
	                    // height: "100%",
	                  }
	                },
	                _react2.default.createElement("img", {
	                  src: _constants.IMAGE_URL + "AlbumImg/" + selectedImage,
	                  style: {
	                    objectFit: "cover",
	                    width: "100%"
	                    // height: "100%",
	                  },
	                  className: "shadow-1-strong rounded",
	                  alt: "Selected Image"
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = PhotoGalleryModal;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _LeftSidebar = __webpack_require__(9);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _PhotoGalleryTabInner = __webpack_require__(655);
	
	var _PhotoGalleryTabInner2 = _interopRequireDefault(_PhotoGalleryTabInner);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _Loading_icon = __webpack_require__(56);
	
	var _Loading_icon2 = _interopRequireDefault(_Loading_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tabData = [{
	  id: "home",
	  label: "EVENTS AND SERVICES",
	  images: ["https://picsum.photos/id/26/415/622", "https://picsum.photos/id/13/415/276", "https://picsum.photos/id/20/415/276", "https://picsum.photos/id/57/415/622", "https://picsum.photos/id/60/415/622", "https://picsum.photos/id/128/415/276", "https://picsum.photos/id/160/415/622", "https://picsum.photos/id/171/415/276", "https://picsum.photos/id/178/415/276", "https://picsum.photos/id/181/415/622", "https://picsum.photos/id/225/415/622", "https://picsum.photos/id/229/415/276", "https://picsum.photos/id/230/415/622", "https://picsum.photos/id/250/415/276", "https://picsum.photos/id/233/415/276", "https://picsum.photos/id/265/415/622", "https://picsum.photos/id/311/415/622", "https://picsum.photos/id/316/415/276"]
	}, {
	  id: "profile",
	  label: "ROOM",
	  images: ["https://picsum.photos/id/160/415/622", "https://picsum.photos/id/171/415/276", "https://picsum.photos/id/178/415/276", "https://picsum.photos/id/181/415/622", "https://picsum.photos/id/225/415/622", "https://picsum.photos/id/229/415/276"]
	}, {
	  id: "contact",
	  label: "HOSPITAL VIEW",
	  images: ["https://picsum.photos/id/230/415/622", "https://picsum.photos/id/250/415/276", "https://picsum.photos/id/233/415/276", "https://picsum.photos/id/265/415/622", "https://picsum.photos/id/311/415/622", "https://picsum.photos/id/316/415/276"]
	}, {
	  id: "equipments",
	  label: "EQUIPMENTS",
	  images: ["https://picsum.photos/id/230/415/622", "https://picsum.photos/id/250/415/276", "https://picsum.photos/id/233/415/276", "https://picsum.photos/id/265/415/622", "https://picsum.photos/id/311/415/622", "https://picsum.photos/id/316/415/276", "https://picsum.photos/id/230/415/622", "https://picsum.photos/id/250/415/276", "https://picsum.photos/id/233/415/276", "https://picsum.photos/id/265/415/622", "https://picsum.photos/id/311/415/622", "https://picsum.photos/id/316/415/276"]
	}];
	var PhotoGalleryNew = function PhotoGalleryNew() {
	  var _useState = (0, _react.useState)(),
	      _useState2 = _slicedToArray(_useState, 2),
	      activeTab = _useState2[0],
	      setActiveTab = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activeTabContent = _useState4[0],
	      setActiveTabContent = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({}),
	      _useState6 = _slicedToArray(_useState5, 2),
	      searchResults = _useState6[0],
	      setSearchResults = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(),
	      _useState8 = _slicedToArray(_useState7, 2),
	      departmentId = _useState8[0],
	      setDepartmentId = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      loading = _useState10[0],
	      setLoading = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    DoctorID: "",
	    PreferredDate: "",
	    doctorData: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      scheduleReqData = _useState12[0],
	      setScheduleReqData = _useState12[1];
	
	  (0, _react.useEffect)(function () {
	    var getCaseStudies = function getCaseStudies(data) {
	      try {
	        setLoading(true);
	        var req = _.scAxiosAdmin.request("/album/listalbum", {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            setLoading(false);
	            setSearchResults(data.data.data);
	            setActiveTabContent(data.data.data[0]);
	            setActiveTab(data.data.data[0].id);
	          }
	        }).catch(function (e) {
	          setLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getCaseStudies();
	  }, []);
	
	  var handleTabClick = function handleTabClick(tabId) {
	    setActiveTab(tabId);
	    if (tabId) {
	      var tabContent = searchResults.find(function (tab) {
	        return tab.id === tabId;
	      });
	      setActiveTabContent(tabContent);
	    }
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Photo Gallery | United Hospital Bangladesh | Best Hospital In Bangladesh",
	      description: "Photo Gallery of United Hospital Bangladesh Limited",
	      pathSlug: "/gallery/photo-gallery",
	      keywords: "newsevents, Singlenewsevents"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      _react2.default.createElement(
	        "section",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex flex-column justify-content-between align-items-center pt-4" },
	          _react2.default.createElement(
	            "div",
	            { className: "1" },
	            _react2.default.createElement(
	              "h3",
	              {
	                className: "text-left ",
	                style: {
	                  color: "#0C807D",
	                  fontSize: "28px",
	                  fontWeight: "500",
	                  display: "flex",
	                  flexDirection: "column"
	
	                }
	              },
	              "Photo Gallery"
	            )
	          )
	        )
	      ),
	      searchResults.length > 0 ? _react2.default.createElement(
	        "section",
	        { className: "termscondbody" },
	        _react2.default.createElement(
	          "div",
	          { className: "px-3 py-0 photoContainer" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "row g-3 w-100 justify-content-center",
	              style: { margin: "0 auto" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 flex-row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 flex-row d-flex flex-column align-items-center" },
	                _react2.default.createElement(
	                  "ul",
	                  {
	                    className: "gallery-tab nav nav-pills px-0 container mb-5 d-flex flex-wrap flex-column flex-md-row justify-content-center justify-content-md-between",
	                    id: "pills-tab",
	                    role: "tablist"
	                  },
	                  searchResults && searchResults.map(function (tab) {
	                    return _react2.default.createElement(
	                      "li",
	                      {
	                        className: "nav-item",
	                        key: tab.id,
	                        role: "presentation"
	                        // style={{ width: "20%" }}
	                      },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          className: "nav-link " + (activeTab === tab.id ? "active" : ""),
	                          onClick: function onClick() {
	                            return handleTabClick(tab.id);
	                          },
	                          role: "tab",
	                          style: {
	                            background: activeTab === tab.id ? "#0C807D" : "",
	                            width: "100%"
	                          }
	                        },
	                        tab.album_name
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "tab-content w-100", id: "pills-tabContent" },
	                  searchResults ? searchResults.map(function (tab) {
	                    return _react2.default.createElement(
	                      "div",
	                      {
	                        key: tab.id,
	                        className: "tab-pane fade " + (activeTab === tab.id ? "show active" : ""),
	                        role: "tabpanel"
	                      },
	                      _react2.default.createElement(_PhotoGalleryTabInner2.default, {
	                        activeTabContent: activeTabContent
	                      })
	                    );
	                  }) : ""
	                )
	              )
	            )
	          )
	        )
	      ) : ""
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	  );
	};
	
	exports.default = PhotoGalleryNew;
	
	// const getAlbums = (data) => {
	//   return new Promise((resolve, reject) => {
	//     const req = scAxiosAdmin.request("/album/listalbum", {
	//       method: "get",
	//       headers: {
	//         Accept: "application/json",
	//         Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	//       },
	//       params: {
	//         ...data,
	//       },
	//     });
	//     req.then((res) => resolve(res.data)).catch((err) => reject(err));
	//   });
	// };
	
	// class PhotoGalleryNew extends Component {
	//   state = {
	//     galleries: [],
	//   };
	//   refreshGallery = (event) => {
	//     getAlbums()
	//       .then((res) => {
	//         if (res.status === true) {
	//           var records = res.data;
	//           this.setState({ galleries: records });
	//         } else {
	//           this.setState({ galleries: "" });
	//         }
	//       })
	//       .catch((err) => {
	//         console.log(err);
	//       });
	//   };
	
	//   componentDidMount() {
	//     this.refreshGallery();
	//   }
	
	//   render() {
	//     const boardmembers = [
	//       {
	//         title:
	//           "Workplace diversity refers to the variety of differences between people in an organization. That sounds simple, but diversity encompasses race, gender, ethnic group, age, personality, cognitive style, tenure, organizational function, education, background and more. Diversity not only involves how people perceive themselves, but how they perceive others. Those perceptions affect their interactions. For a wide assortment of employees to function effectively as an organization, human resource professionals need to deal effectively with issues such as communication, adaptability and change.",
	//         dsc: "United Hospital employs a diverse workforce to attend to supply a great diversity of clinical and non-clinical and management solutions to address issues in service, sourcing, and allocation of resources. Employees from diverse backgrounds bring individual talents and experiences in suggesting ideas which are customized to fit to the demands of customers (patients). This enhances the dynamism of the organization to serve its varied patients with an international flare.",
	//       },
	//     ];
	//     return (
	//       <div>
	//         <SEO
	//           title={
	//             "Photo Gallery | United Hospital Bangladesh | Best Hospital In Bangladesh"
	//           }
	//           description={"Photo Gallery of United Hospital Bangladesh Limited"}
	//           pathSlug="/gallery/photo-gallery"
	//           keywords="newsevents, Singlenewsevents"
	//         />
	//         <Helmet>
	//           <meta
	//             name="description"
	//             content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	//           />
	
	//           <script type="application/ld+json">
	//             {JSON.stringify({
	//               "@context": "http://schema.org",
	//               "@type": "LocalBusiness",
	//               name: "United Hospital Limited",
	//               image:
	//                 "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	//               telephone: "10666",
	//               email: "info@uhlbd.com",
	//               address: {
	//                 "@type": "PostalAddress",
	//                 streetAddress: "plot 15, Road 71, Gulshan",
	//                 addressLocality: "Dhaka",
	//                 addressRegion: "Dhaka",
	//                 addressCountry: "Bangladesh",
	//                 postalCode: "1212",
	//               },
	//               openingHoursSpecification: {
	//                 "@type": "OpeningHoursSpecification",
	//                 opens:
	//                   "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
	//               },
	//               url: "http://www.uhlbd.com/",
	//               aggregateRating: {
	//                 "@type": "AggregateRating",
	//                 ratingValue: "3.9",
	//                 bestRating: "5",
	//                 worstRating: "1",
	//                 ratingCount: "756",
	//               },
	//               review: {
	//                 "@type": "Review",
	//                 author: {
	//                   "@type": "Person",
	//                   name: "abdul kahar",
	//                 },
	//                 datePublished: "2019-02-12",
	//                 reviewRating: {
	//                   "@type": "Rating",
	//                   ratingValue: "3.9",
	//                   bestRating: "5",
	//                   worstRating: "1",
	//                 },
	//                 reviewBody:
	//                   "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
	//               },
	//             })}
	//           </script>
	//           <meta
	//             name="Subject"
	//             content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	//           />
	//           <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
	//           <meta name="Googlebot" content="all" />
	//           <meta http-equiv="imagetoolbar" content="no" />
	//           <meta name="robots" content="index, follow" />
	//           <meta name="copyright" content="Copyright &copy; uhlbd.com" />
	//           <meta name="owner" content="United Hospital" />
	//           <meta name="author" content="dcastalia.com" />
	//           <meta name="Rating" content="General" />
	//           <meta name="distribution" content="Global" />
	//           <meta
	//             name="classification"
	//             content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	//           />
	//           <meta name="apple-mobile-web-app-capable" content="yes" />
	//           <meta
	//             names="apple-mobile-web-app-status-bar-style"
	//             content="black-translucent"
	//           />
	//           <meta
	//             name="msvalidate.01"
	//             content="16C4E0B16E39354E550F64BD707F6A97"
	//           />
	//         </Helmet>
	//         <Route component={Header} />
	//         <div
	//           id="giveMargin"
	//           className=""
	//           style={{ backgroundColor: "#fef3e9" }}
	//         >
	//           <img src={banner_img} alt="banner-profile" className="w-100" />
	//           <section className="termscondbody mt-5 pb-5">
	//             <div className="container p-3">
	//               <h2 className="text-secondary">Photo Gallery</h2>
	//               <div className="row g-3 w-100 mx-auto">
	//                 <div className="col-md-12 mt-5 bg-light flex-row">
	//                   <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
	//                     <li class="nav-item" role="presentation">
	//                       <button
	//                         class="nav-link active"
	//                         id="pills-home-tab"
	//                         data-bs-toggle="pill"
	//                         data-bs-target="#pills-home"
	//                         type="button"
	//                         role="tab"
	//                         aria-controls="pills-home"
	//                         aria-selected="true"
	//                       >
	//                         Home
	//                       </button>
	//                     </li>
	//                     <li class="nav-item" role="presentation">
	//                       <button
	//                         class="nav-link"
	//                         id="pills-profile-tab"
	//                         data-bs-toggle="pill"
	//                         data-bs-target="#pills-profile"
	//                         type="button"
	//                         role="tab"
	//                         aria-controls="pills-profile"
	//                         aria-selected="false"
	//                       >
	//                         Profile
	//                       </button>
	//                     </li>
	//                     <li class="nav-item" role="presentation">
	//                       <button
	//                         class="nav-link"
	//                         id="pills-contact-tab"
	//                         data-bs-toggle="pill"
	//                         data-bs-target="#pills-contact"
	//                         type="button"
	//                         role="tab"
	//                         aria-controls="pills-contact"
	//                         aria-selected="false"
	//                       >
	//                         Contact
	//                       </button>
	//                     </li>
	//                   </ul>
	//                   <div class="tab-content" id="pills-tabContent">
	//                     <div
	//                       class="tab-pane fade show active"
	//                       id="pills-home"
	//                       role="tabpanel"
	//                       aria-labelledby="pills-home-tab"
	//                     >
	//                      <PhotoGalleryTabInner></PhotoGalleryTabInner>
	//                     </div>
	//                     <div
	//                       class="tab-pane fade"
	//                       id="pills-profile"
	//                       role="tabpanel"
	//                       aria-labelledby="pills-profile-tab"
	//                     >
	//                       <PhotoGalleryTabInner></PhotoGalleryTabInner>
	//                     </div>
	//                     <div
	//                       class="tab-pane fade"
	//                       id="pills-contact"
	//                       role="tabpanel"
	//                       aria-labelledby="pills-contact-tab"
	//                     >
	//                       <PhotoGalleryTabInner></PhotoGalleryTabInner>
	//                     </div>
	//                   </div>
	//                 </div>
	//               </div>
	//             </div>
	//           </section>
	//         </div>
	//         <Route component={Footer} />
	//       </div>
	//     );
	//   }
	// }
	// export default PhotoGalleryNew;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PhotoGalleryModal = __webpack_require__(653);
	
	var _PhotoGalleryModal2 = _interopRequireDefault(_PhotoGalleryModal);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoGalleryTabInner = function PhotoGalleryTabInner(_ref) {
	  var activeTabContent = _ref.activeTabContent;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      selectedImage = _useState2[0],
	      setSelectedImage = _useState2[1];
	
	  var openModal = function openModal(image) {
	    setSelectedImage(image);
	  };
	
	  var closeModal = function closeModal() {
	    setSelectedImage(null);
	  };
	  return _react2.default.createElement(
	    "div",
	    {
	      "class": "row justify-content-center justify-content-md-between w-100 mx-auto",
	      style: { justifyContent: "space-between" }
	    },
	    activeTabContent && JSON.parse(activeTabContent.album_pics).length > 0 ? JSON.parse(activeTabContent.album_pics).map(function (image, index) {
	      var isFirstImageTaller = index % 2 === 0;
	      var firstMaxHeight = isFirstImageTaller ? "622px" : "276px";
	      var secondMaxHeight = isFirstImageTaller ? "276px" : "622px";
	      var firstImage = null;
	      var secondImage = null;
	      var incrementAmountForFirstImage = index + index;
	      var incrementAmountForSecondImage = index + (index + 1);
	      if (index >= JSON.parse(activeTabContent.album_pics).length / 2) {
	        return;
	      }
	      if (index === 0) {
	        firstImage = JSON.parse(activeTabContent.album_pics)[index];
	        secondImage = JSON.parse(activeTabContent.album_pics)[index + 1];
	      } else {
	        firstImage = JSON.parse(activeTabContent.album_pics)[incrementAmountForFirstImage];
	        secondImage = JSON.parse(activeTabContent.album_pics)[incrementAmountForSecondImage];
	      }
	      return _react2.default.createElement(
	        "div",
	        {
	          "class": "col-lg-4 mb-4 mb-lg-0 px-0 d-flex flex-column flex-columns-gallery justify-content-between pb-2 w-100"
	        },
	        secondImage !== undefined ? _react2.default.createElement(
	          "div",
	          {
	            className: "mb-3 w-100",
	            "data-bs-toggle": "modal",
	            "data-bs-target": "#staticBackdrop",
	            style: {
	              height: index % 2 === 0 ? "622px" : "276px",
	              cursor: "pointer"
	            },
	            onClick: function onClick() {
	              return openModal(firstImage);
	            }
	          },
	          _react2.default.createElement("img", {
	            style: { objectFit: "cover", width: "100%" },
	            src: _constants.IMAGE_URL + "AlbumImg/" + firstImage,
	            "class": "w-100 h-100 shadow-1-strong rounded mb-4",
	            alt: "Mountains in the Clouds"
	          })
	        ) : "",
	        secondImage !== undefined ? _react2.default.createElement(
	          "div",
	          {
	            className: "mb-3 w-100",
	            "data-bs-toggle": "modal",
	            "data-bs-target": "#staticBackdrop",
	            style: {
	              height: index % 2 === 0 ? "276px" : "622px",
	              cursor: "pointer"
	            },
	            onClick: function onClick() {
	              return openModal(secondImage);
	            }
	          },
	          _react2.default.createElement("img", {
	            style: { objectFit: "cover" },
	            src: _constants.IMAGE_URL + "AlbumImg/" + secondImage,
	            "class": "w-100 h-100 shadow-1-strong rounded mb-4",
	            alt: "Boat on Calm Water"
	          })
	        ) : ""
	      );
	    }) : "",
	    selectedImage && _react2.default.createElement(_PhotoGalleryModal2.default, {
	      selectedImage: selectedImage,
	      closeModal: closeModal
	    })
	  );
	};
	
	exports.default = PhotoGalleryTabInner;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _case_under = __webpack_require__(50);
	
	var _case_under2 = _interopRequireDefault(_case_under);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Publications = function Publications() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchResults = _useState2[0],
	      setSearchResults = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      departmentId = _useState4[0],
	      setDepartmentId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      loading = _useState6[0],
	      setLoading = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    DoctorID: "",
	    PreferredDate: "",
	    doctorData: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      scheduleReqData = _useState8[0],
	      setScheduleReqData = _useState8[1];
	
	  (0, _react.useEffect)(function () {
	    var getJobOpenings = function getJobOpenings(data) {
	      try {
	        setLoading(true);
	        var req = _.scAxiosAdmin.request("/publications/all", {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            setLoading(false);
	            setSearchResults(data.data);
	          }
	        }).catch(function (e) {
	          setLoading(false);
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getJobOpenings();
	  }, []);
	
	  var boardmembers = [{
	    title: "Newsletter-Issue-22,Quarter-2, 2018",
	    dsc: "Our support to the community by offering Health Screening for prevention and detection of diseases saves one from the burden of disease load by early lifestyle changes & treatment. Similarly we undertake aware- ness initiatives as reflected in National Nutrition Week where visitors got educated on differ- ent need-based diets; Hand Hygiene programs were also conducted in schools. Ortho- paedic Camp at Jamalpur and Paediatric Cardiology services to child patients with heart ailments, talk about our philan- thropic endeavors. Thought- provoking articles encompass- ing cases from varied clinical specialties make this edition interesting. Diploma course in Cardiac Nursing, adds a feather ...",
	    image: "https://uhlbd.com/administrator/uploads/images/Business%20Standard.jpg"
	  }, {
	    title: "Newsletter-Issue-21,Quarter-1, 2018",
	    dsc: "First edition of Newsletter in 2018 reflects some ground breaking endeavours like country’s first online pharmacy inauguration and philanthropic activities like free medical camp on Shadhinota Dibosh. Articles published are varied comprising cases of both adult & child patients displaying a combination of acute and chronic conditions. Commemoration of several International Observance Days further added colours in the engaging activities in this quarter. Participation of hospital staff at different local & international events continued as before, showing their efforts to be at par with current trends & skills. Lastly the top-notch result of students of United College of Nursing portrayed our strengthened efforts ...",
	    image: "https://uhlbd.com/administrator/uploads/images/Bonik%20Barta.jpg"
	  }, {
	    title: "Newsletter-Issue-20, Quarter-4, 2017",
	    dsc: "The year 2017 was full of employee activation and community engagement with the aim to improve patient benefit by increasing their health awareness to help them cope better with their disease. Our participation in philanthropic endeavors like medical camp in Louhajong upazila of Munshiganj in first part of the year, two-weeks long camp in teknaf for distressed Rohingya refugees and heart camp in Jamalpur were service flag marks of this quarter. We continued dealing with complex cases, as displayed in the articles in this issue. We believe, the multidisciplinary reflection in this edition contents, depict the varied clinical strength of our ...",
	    image: "https://uhlbd.com/backend/web/post_uploads/medium/1586774469IMG_1489-1.jpg"
	  }, {
	    title: "United Group Signed A Project Agreement With Bangladesh Railway Under Public Private Partnership",
	    dsc: "United Enterprise and Company Limited, a sister concern of United Group signed a project agreement with Bangladesh Railway ...",
	    image: "https://uhlbd.com/backend/web/post_uploads/medium/158677382818-1.jpg"
	  }, {
	    title: "United Hospital Inaugurated 25-bed Isolation Unit At Munshiganj To Help Covid-19 Patients",
	    dsc: "As part of initiative of United Group & extended part of the United Hospital, for COVID-19 patients ...",
	    image: "https://uhlbd.com/backend/web/post_uploads/medium/1586773514IMG_8343.jpg"
	  }];
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Publications | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Publications"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      _react2.default.createElement(
	        "section",
	        { className: "termscondbody pb-5" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "w-100 d-flex justify-content-center align-items-center flex-column py-4" },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "flex",
	                  justifyContent: "flex-start",
	                  alignItems: "flex-start",
	                  flexDirection: "column",
	                  marginBottom: "5px"
	                  // margin: "0 auto",
	                }
	              },
	              _react2.default.createElement(
	                "h3",
	                {
	                  className: "text-center",
	                  style: {
	                    color: "#0C807D",
	                    fontSize: "28px",
	                    fontWeight: "500"
	
	                  }
	                },
	                "PUBLICATIONS"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row w-100 justify-content-between g-4" },
	            searchResults ? searchResults.map(function (menubars) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  className: "col-12 col-sm-12 col-md-6 col-lg-6"
	                  // style={{ height: "490px" }}
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "card w-100 p-3 d-flex flex-column align-items-center h-100",
	                    style: { borderRadius: "10px" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: " mt-3 w-100" /* key={single.id} */ },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "d-flex flex-column pt-3 px-3 pb-3 gap-5",
	                        style: { backgroundClip: "#E7F2F2" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "d-flex align-items-center" },
	                        _react2.default.createElement("img", {
	                          src: _case_under2.default,
	                          alt: "",
	                          width: 3,
	                          height: 70
	                        }),
	                        _react2.default.createElement(
	                          "h3",
	                          {
	                            className: "px-4 ",
	                            style: {
	                              fontSize: "22px",
	                              textTransform: "capitalize"
	                            }
	                          },
	                          menubars.publications_title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "d-flex " },
	                        _react2.default.createElement("div", {
	                          className: "",
	                          dangerouslySetInnerHTML: {
	                            __html: menubars.publications_desc.replace(/(<p><a\s+href="([^"]+)"[^>]*>DOWNLOAD<\/a><\/p>)/, '<p style="padding:10px;"><a style="font-size: 16px; width: 118px; height: 43px; background-color: #0C807D; color: #fff; text-transform: capitalize; border: none; border-radius: 6px; font-weight: 500;padding:10px" href="$2" rel="noopener noreferrer" target="_blank">DOWNLOAD</a></p>')
	                          }
	                        })
	                      )
	                    )
	                  )
	                )
	              );
	            }) : ""
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	  );
	};
	exports.default = Publications;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResearchAndTraining = function ResearchAndTraining(_ref) {
	  var cards = _ref.cards;
	
	  console.log("your log output", cards);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "container" },
	    cards.map(function (section, index) {
	      return _react2.default.createElement(
	        "div",
	        {
	          key: section.id,
	          className: "row mb-5 align-items-center justify-content-between h-100"
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "col-3 p-0 d-flex align-items-end h-100",
	            style: { height: "100%" }
	          },
	          index % 2 === 0 ? section.media[0] && _react2.default.createElement("img", {
	            style: { borderRadius: "10px" },
	            src: "" + _constants.IMAGE_URL + section.media[0],
	            alt: "First Column Image",
	            className: "w-100"
	          }) : _react2.default.createElement("div", null) // Empty column for odd-indexed sections
	
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-3 text-center p-0" },
	          index % 2 === 0 ? _react2.default.createElement(
	            "h4",
	            { className: "jci-heading" },
	            section.title
	          ) : section.media[0] && _react2.default.createElement("img", {
	            style: { borderRadius: "10px" },
	            src: "" + _constants.IMAGE_URL + section.media[0],
	            alt: "Second Column Image",
	            className: "img-fluid w-100"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-3 text-center p-0" },
	          index % 2 === 0 ? section.media[1] && _react2.default.createElement("img", {
	            src: "" + _constants.IMAGE_URL + section.media[1],
	            alt: "Third Column Image",
	            className: "img-fluid w-100",
	            style: { borderRadius: "10px" } // Bigger image
	          }) : _react2.default.createElement(
	            "h4",
	            { className: "jci-heading" },
	            section.title
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-3 d-flex justify-content-end p-0" },
	          index % 2 === 0 ? _react2.default.createElement("div", null) // Empty column for even-indexed sections
	          : section.media[1] && _react2.default.createElement("img", {
	            src: "" + _constants.IMAGE_URL + section.media[1],
	            alt: "Fourth Column Image",
	            className: "img-fluid w-100",
	            style: { borderRadius: "10px" } // Bigger image
	          })
	        )
	      );
	    })
	  );
	};
	
	exports.default = ResearchAndTraining;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _roomService = __webpack_require__(864);
	
	var _roomService2 = _interopRequireDefault(_roomService);
	
	var _rooms = __webpack_require__(865);
	
	var _rooms2 = _interopRequireDefault(_rooms);
	
	var _jquery = __webpack_require__(18);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _reactImageLightbox = __webpack_require__(126);
	
	var _reactImageLightbox2 = _interopRequireDefault(_reactImageLightbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoomCategory = function RoomCategory() {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      selectedImage = _useState4[0],
	      setSelectedImage = _useState4[1];
	
	  var handleClickOnImage = function handleClickOnImage(data) {
	    setIsOpen(true);
	    setSelectedImage(data);
	  };
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Room Category | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Room Category"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", className: "", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      _react2.default.createElement(
	        "section",
	        { className: "termscondbody mt-5 pb-5" },
	        _react2.default.createElement(
	          "div",
	          { className: "container p-3" },
	          _react2.default.createElement(
	            "h2",
	            { className: "text-secondary mb-5" },
	            "ROOM CATEGORY"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row g-3 w-100 mx-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _rooms2.default.map(function (data, index) {
	                return _react2.default.createElement(
	                  "div",
	                  {
	                    className: "row mb-5",
	                    style: { backgroundColor: "#ffffff" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-8" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        key: index,
	                        className: "roomContainer px-0 mb-5",
	                        onClick: function onClick() {
	                          return handleClickOnImage(data.file);
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "d-flex align-items-center text-secondary",
	                          style: { height: "70px", backgroundColor: "#ffffff" }
	                        },
	                        _react2.default.createElement(
	                          "h5",
	                          { className: "ps-2" },
	                          data.type
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "a",
	                        { className: "px-0 d-flex justify-content-center" },
	                        _react2.default.createElement("img", {
	                          className: "border",
	                          src: __webpack_require__(460)("./" + data.file + ".jpg"),
	                          alt: ""
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-4" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        key: index,
	                        className: "roomContainer d-flex justify-content-around align-items-center h-100"
	                      },
	                      _react2.default.createElement(
	                        "table",
	                        { className: "table table-bordered h-75 mt-4" },
	                        _react2.default.createElement(
	                          "thead",
	                          null,
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "th",
	                              { scope: "col" },
	                              "Price"
	                            ),
	                            _react2.default.createElement(
	                              "th",
	                              { scope: "col" },
	                              "Amenities"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "tbody",
	                          null,
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "th",
	                              { scope: "row" },
	                              data.price
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              "N/A"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              "table",
	              { className: "table table-hover table-bordered roomTable mb-5" },
	              _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  { className: "table-active" },
	                  _react2.default.createElement(
	                    "th",
	                    { scope: "col" },
	                    "SL NO"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { scope: "col" },
	                    "TYPE OF CABIN/ROOM"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { scope: "col" },
	                    "RENT PER DAY (BDT)"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _roomService2.default.map(function (data, index) {
	                  return _react2.default.createElement(
	                    "tr",
	                    { key: index },
	                    _react2.default.createElement(
	                      "th",
	                      { scope: "row" },
	                      data.Sl_No
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      data.typeOfRoom
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      data.rentPerDay
	                    )
	                  );
	                })
	              )
	            ),
	            isOpen && _react2.default.createElement(_reactImageLightbox2.default, {
	              style: { zIndex: "0" },
	              mainSrc: __webpack_require__(460)("./" + selectedImage + ".jpg"),
	              onCloseRequest: function onCloseRequest() {
	                return setIsOpen(false);
	              }
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = RoomCategory;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _userSession = __webpack_require__(30);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SendUsInquiry = function SendUsInquiry() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchResults = _useState2[0],
	      setSearchResults = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    type: "inquiry",
	    first_name: "",
	    phone_number: "",
	    email: "",
	    message: ""
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      formData = _useState4[0],
	      setFormData = _useState4[1];
	
	  var input_field_css = {
	    maxHeight: "50px",
	    fontSize: "14px",
	    borderColor: "#cccccc",
	    borderRadius: "5px"
	  };
	  var alertStyle = {
	    color: "red"
	  };
	  var inputStyles = {
	    borderRadius: "10px",
	    background: "#fff",
	    borderRight: "solid 1px #fff",
	    border: "solid 1px #6e6e6ed0",
	    padding: "15px 15px",
	    fontSize: "16px",
	    color: "#000",
	    width: "100%"
	  };
	
	  var isDisabled = function isDisabled() {
	    if (formData.first_name === "" || formData.email === "" || formData.phone_number === "" || formData.message === "") {
	      return true;
	    } else return false;
	  };
	
	  var handleSubmit = function handleSubmit(event, props) {
	    event.preventDefault();
	
	    try {
	      var req = _.scAxiosAdmin.post("/emergenecies_enquiry", formData, {
	        method: "post",
	        headers: {
	          Accept: "application/json",
	          Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	        }
	      }).then(function (data) {
	        if (data.status === 201) {
	          _reactToastify.toast.success("Inquiry sent successfully!");
	          setFormData({
	            first_name: "",
	            phone_number: "",
	            email: "",
	            message: ""
	          });
	        }
	      });
	    } catch (error) {}
	  };
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        "class": "offcanvas offcanvas-start",
	        "data-bs-scroll": "true",
	        tabindex: "-1",
	        id: "SendUsInquiry",
	        "aria-labelledby": "offcanvasWithBothOptionsLabel"
	      },
	      _react2.default.createElement(
	        "div",
	        { "class": "offcanvas-header" },
	        _react2.default.createElement("h5", { "class": "offcanvas-title", id: "offcanvasWithBothOptionsLabel" }),
	        _react2.default.createElement("button", {
	          type: "button",
	          "class": "btn-close text-reset",
	          "data-bs-dismiss": "offcanvas",
	          "aria-label": "Close"
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { "class": "offcanvas-body" },
	        _react2.default.createElement(
	          "div",
	          { className: "left-offcanvas" },
	          _react2.default.createElement(
	            "h4",
	            { style: { color: "#af9763" } },
	            "Send us an Inquiry"
	          ),
	          _react2.default.createElement(
	            "form",
	            {
	              onSubmit: handleSubmit,
	              id: "registerform",
	              className: "needs-validation mt-5",
	              noValidate: true
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group mb-4" },
	                _react2.default.createElement("input", {
	                  style: inputStyles,
	                  type: "text",
	                  className: "custom-form-control shadow-sm",
	                  placeholder: "Enter Your Full Name ",
	                  name: "fullname",
	                  id: "fullname",
	                  value: formData.fullName,
	                  onChange: function onChange(e) {
	                    return setFormData(Object.assign({}, formData, { first_name: e.target.value }));
	                  },
	                  required: true,
	                  autoComplete: "off"
	                  // style={input_field_css}
	                })
	              ),
	              _react2.default.createElement("span", null)
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group mb-4" },
	                _react2.default.createElement("input", {
	                  style: inputStyles,
	                  type: "text",
	                  className: "custom-form-control shadow-sm",
	                  placeholder: "Enter Your Phone Number Here",
	                  name: "phoneNumber",
	                  id: "phoneNumber",
	                  value: formData.phone_number,
	                  onChange: function onChange(e) {
	                    return setFormData(Object.assign({}, formData, { phone_number: e.target.value }));
	                  },
	                  required: true,
	                  autoComplete: "off"
	                  // style={input_field_css}
	                })
	              ),
	              _react2.default.createElement("span", null)
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group mb-4" },
	                _react2.default.createElement("input", {
	                  style: inputStyles,
	                  type: "text",
	                  className: "custom-form-control shadow-sm",
	                  placeholder: "Enter Your Email Here",
	                  name: "email",
	                  id: "email",
	                  value: formData.email,
	                  onChange: function onChange(e) {
	                    return setFormData(Object.assign({}, formData, { email: e.target.value }));
	                  },
	                  required: true,
	                  autoComplete: "off"
	                  // style={input_field_css}
	                })
	              ),
	              _react2.default.createElement("span", null)
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group mb-2" },
	                _react2.default.createElement("textarea", {
	                  style: inputStyles,
	                  type: "text-area",
	                  className: "custom-form-control shadow-sm",
	                  placeholder: "Enter Your Message ",
	                  name: "message",
	                  id: "message",
	                  value: formData.message,
	                  onChange: function onChange(e) {
	                    return setFormData(Object.assign({}, formData, { message: e.target.value }));
	                  },
	                  required: true,
	                  autoComplete: "off"
	                  // style={input_field_css}
	                })
	              ),
	              _react2.default.createElement("span", null)
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row mt-2" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-12" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    variant: "primary",
	                    type: "submit",
	                    className: "btn-links appointment-new submit_btn",
	                    id: "black-btn",
	                    disabled: isDisabled(),
	                    style: {
	                      backgroundColor: isDisabled() ? "" : "#187979"
	                    }
	                  },
	                  "Submit Your Query",
	                  " "
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = SendUsInquiry;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactRouterDom = __webpack_require__(5);
	
	__webpack_require__(116);
	
	var _services = __webpack_require__(105);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _icon = __webpack_require__(57);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Services = function Services() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Services | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Services"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      {
	        id: "giveMargin",
	        className: "allservices",
	        style: { backgroundColor: "#ffffff" }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "container pt-4 pb-3" },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "flex",
	              justifyContent: "center",
	              alignItems: "center",
	              flexDirection: "column",
	              // margin: "0 auto",
	              // marginBottom: "10px",
	              width: "100%"
	            }
	          },
	          _react2.default.createElement(
	            "h3",
	            {
	              className: "text-center mb-4",
	              style: {
	                color: "#0C807D",
	                fontWeight: "700"
	              }
	            },
	            "Services"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row justify-content-center" },
	          _services2.default && _services2.default.map(function (doctor, ind) {
	            return _react2.default.createElement(
	              "div",
	              {
	                className: "col-sm-6 col-md-4 col-lg-3 mb-lg-3 text-center mx-auto ",
	                key: ind,
	                id: "consultation and appointment"
	              },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "" + doctor.slug,
	                  style: {
	                    textDecoration: "none",
	                    display: "inline-block",
	                    width: "100%"
	                  },
	                  className: "d-flex justify-content-center"
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "doctor-list  d-flex align-items-center departmentBg w-100 border-0 shadow-sm" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "row list_content_sec w-100",
	                      style: { height: "85px" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "d-flex align-items-center text-center justify-content-center" },
	                      _react2.default.createElement(
	                        "p",
	                        {
	                          style: {
	                            fontWeight: "700",
	                            letterSpacing: "1px",
	                            fontSize: "15px"
	                          }
	                        },
	                        doctor.department_name
	                      ),
	                      _react2.default.createElement("img", {
	                        style: { width: "20%" },
	                        src: _icon2.default,
	                        alt: "Bitmap-3"
	                      })
	                    )
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	// import {  Route } from "react-router-dom";
	exports.default = Services;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // src/components/OffCanvasMenu.js
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _tfi = __webpack_require__(125);
	
	var _io = __webpack_require__(162);
	
	var _fa = __webpack_require__(62);
	
	var _fa2 = __webpack_require__(161);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SideDrawerMenus = function SideDrawerMenus() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      headerData = _useState2[0],
	      setHeaderData = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var headerDataList = {
	      ids: [31, 33, 34, 36]
	    };
	    var getHeaderData = function getHeaderData(data) {
	      try {
	        var req = _.scAxiosAdmin.post("/settings/get_multiple", headerDataList, {
	          // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
	          method: "get",
	          headers: {
	            Accept: "application/json"
	            // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	          }
	        }).then(function (data) {
	          if (data.status === 200) {
	            // console.log('your log output',data)
	            // setStaticPageData(data.data.data);
	            setHeaderData(data.data);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getHeaderData();
	  }, []);
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        className: "offcanvas offcanvas-start",
	        style: { width: "80%" } // Take up 80% of the screen width
	        , tabIndex: "-1",
	        id: "sideBarMenus",
	        "aria-labelledby": "sideBarMenusLabel"
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "offcanvas-header" },
	        _react2.default.createElement("img", {
	          src: "/assets/images/updated_logo.svg" // Logo here
	          , alt: "Logo",
	          style: { width: "100px" }
	        }),
	        _react2.default.createElement("button", {
	          type: "button",
	          className: "btn-close text-reset",
	          "data-bs-dismiss": "offcanvas",
	          "aria-label": "Close"
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "offcanvas-body" },
	        _react2.default.createElement(
	          "div",
	          { className: "list-group" },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              to: "/",
	              className: "py-3 px-2 text-decoration-none",
	              style: {
	                borderTop: "2px solid #AF9763",
	                borderBottom: "1px solid #AF9763",
	                borderRight: "none",
	                borderLeft: "none",
	                color: "#AF9763",
	                fontWeight: "500"
	              }
	            },
	            "Home"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              to: "/page/about",
	              className: "py-3 px-2 text-decoration-none",
	              style: {
	                borderTop: "1px solid #AF9763",
	                borderBottom: "1px solid #AF9763",
	                borderRight: "none",
	                borderLeft: "none",
	                color: "#AF9763",
	                fontWeight: "500"
	              }
	            },
	            "About Us"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              to: "/pages/departments",
	              className: "py-3 px-2 text-decoration-none",
	              style: {
	                borderTop: "1px solid #AF9763",
	                borderBottom: "1px solid #AF9763",
	                borderRight: "none",
	                borderLeft: "none",
	                color: "#AF9763",
	                fontWeight: "500"
	              }
	            },
	            "Department"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              to: "/pages/career",
	              className: "py-3 px-2 text-decoration-none",
	              style: {
	                borderTop: "1px solid #AF9763",
	                borderBottom: "1px solid #AF9763",
	                borderRight: "none",
	                borderLeft: "none",
	                color: "#AF9763",
	                fontWeight: "500"
	              }
	            },
	            "Career"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              to: "/page/contact",
	              className: "py-3 px-2 text-decoration-none",
	              style: {
	                borderTop: "1px solid #AF9763",
	                borderBottom: "2px solid #AF9763",
	                borderRight: "none",
	                borderLeft: "none",
	                color: "#AF9763",
	                fontWeight: "500"
	              }
	            },
	            "Contact Us"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex justify-content-start gap-2 mt-4" },
	          _react2.default.createElement(
	            "a",
	            {
	              href: "tel:" + (headerData.length > 0 && headerData[0].value ? headerData[0].value : "10666"),
	              className: "d-inline-block",
	              style: { width: "25%" }
	            },
	            _react2.default.createElement("img", {
	              src: "/assets/images/call_update.svg",
	              alt: "Image 1",
	              style: { width: "70%" }
	            })
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              to: "/pages/emergency",
	              className: "d-inline-block",
	              style: { width: "25%" }
	            },
	            _react2.default.createElement("img", {
	              src: "/assets/images/emargency_update.svg",
	              alt: "Image 2",
	              style: { width: "70%" }
	            })
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: "/", className: "d-inline-block", style: { width: "25%" } },
	            _react2.default.createElement("img", {
	              src: "/assets/images/jci-gold-seal 1.png",
	              alt: "Image 3",
	              style: { width: "70%" }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "mt-4", style: { color: "#F58220" } },
	          _react2.default.createElement(
	            "div",
	            { className: "d-flex justify-content-start gap-2 align-items-center mb-3" },
	            _react2.default.createElement(_tfi.TfiHeadphoneAlt, null),
	            _react2.default.createElement(
	              "p",
	              { className: "fw-bold" },
	              headerData.length > 0 && headerData[0].value ? headerData[0].value : "10666"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "d-flex justify-content-start gap-2 align-items-center mb-3" },
	            _react2.default.createElement(_io.IoCall, null),
	            _react2.default.createElement(
	              "p",
	              { className: "fw-bold" },
	              "International:",
	              " ",
	              _react2.default.createElement(
	                "span",
	                { style: { fontSize: "12px" } },
	                headerData.length > 0 && headerData[1].value ? headerData[1].value : "+880 2-2222-62466"
	              ),
	              " "
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "d-flex justify-content-start gap-2 align-items-center mb-3" },
	            _react2.default.createElement(_fa.FaWhatsapp, null),
	            _react2.default.createElement(
	              "p",
	              { className: "fw-bold" },
	              "WhatsApp:",
	              " ",
	              _react2.default.createElement(
	                "span",
	                { style: { fontSize: "12px" } },
	                headerData.length > 0 && headerData[2].value ? headerData[2].value : "+880191-4001214"
	              ),
	              " "
	            )
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              href: headerData.length > 0 && headerData[3].value ? headerData[3].value : "https://maps.app.goo.gl/UJS8gnWhCddNuwDH9",
	              target: "_blank",
	              rel: "noopener noreferrer",
	              className: "text-decoration-none"
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: { color: "#F58220" },
	                className: "d-flex justify-content-start gap-2 align-items-center"
	              },
	              _react2.default.createElement(_fa2.FaLocationDot, null),
	              _react2.default.createElement(
	                "p",
	                { className: "fw-bold" },
	                "View Location "
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = SideDrawerMenus;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _userSession = __webpack_require__(30);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _Loading_icon = __webpack_require__(56);
	
	var _Loading_icon2 = _interopRequireDefault(_Loading_icon);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _SubPopupIndex = __webpack_require__(114);
	
	var _SubPopupIndex2 = _interopRequireDefault(_SubPopupIndex);
	
	var _SubPopupIndex3 = __webpack_require__(664);
	
	var _SubPopupIndex4 = _interopRequireDefault(_SubPopupIndex3);
	
	var _SubPopupIndex5 = __webpack_require__(663);
	
	var _SubPopupIndex6 = _interopRequireDefault(_SubPopupIndex5);
	
	var _PopupIndex = __webpack_require__(70);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {Route} from 'react-router-dom';
	
	//import doc from '../../images/doc.png';
	
	
	var getSingleDoctorScheduleData = function getSingleDoctorScheduleData(data) {
	  return new Promise(function (resolve, reject) {
	    //const token = Buffer.from(`${API_AUTH_USERNAME}:${API_AUTH_PASSWORD}`, 'utf8').toString('base64');
	    var req = _.scAxios.request("/AppointmentSchedule", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	        //'Authorization': `Basic ${token}`,
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getSingleDoctorData = function getSingleDoctorData() {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/getsingledoctors/" + localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID), {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var requestNewAppointment = function requestNewAppointment(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/appointments/request_new", {
	      method: "post",
	      headers: {
	        "Content-Type": "application/json"
	        // Include the Authorization header if needed
	        // "Authorization": "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	      },
	      data: data
	    });
	
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: "red"
	};
	
	var SubPopupIndex3 = function (_Component) {
	  _inherits(SubPopupIndex3, _Component);
	
	  function SubPopupIndex3() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SubPopupIndex3);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubPopupIndex3.__proto__ || Object.getPrototypeOf(SubPopupIndex3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      doctor_id: "",
	      doctor_name: "",
	      doctor_degree: "",
	      doctor_scheduler_dates: [],
	      doctor_scheduler_time: [],
	      doctor_fees: "",
	      schedule_date_time: "",
	      change_schedule_date: "",
	      doctor_profile: "",
	      error_res_msg: "",
	      showPopup: false,
	      showDoctorSearchPopup: false,
	      showPaymentPopup: false,
	      showLoginPopup: false,
	      showLoading: false
	    }, _this.handleScheduleAppointment = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var convertDateFormat, doctor_id, patient_id, appointment_date, patient_phone_number, doctor_name, patient_name, doctor_fees, appointmentData, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              convertDateFormat = function convertDateFormat() {
	                // Check if the inputDate is in the format 'Jan 19 2024'
	                var inputDate = localStorage.getItem("schedule_date");
	                var dateParts = inputDate.split(" ");
	                if (dateParts.length === 3) {
	                  var monthAbbreviation = dateParts[0];
	                  var day = dateParts[1];
	                  var year = dateParts[2];
	
	                  // Convert month abbreviation to numerical representation
	                  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                  var month = monthNames.indexOf(monthAbbreviation) + 1;
	
	                  // Create the date string in the 'YYYY-MM-DD' format
	                  var formattedDate = year + "-" + month.toString().padStart(2, "0") + "-" + day.padStart(2, "0");
	
	                  return formattedDate;
	                }
	
	                // If the inputDate is already in the 'YYYY-MM-DD' format, return it as is
	                return inputDate;
	              };
	              // event.preventDefault();
	
	              // Check if doctor_scheduler_time.length is greater than 0 before making the request
	
	              // convertDateFormat();
	              doctor_id = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	              patient_id = localStorage.getItem(_constants.USER_ID);
	              appointment_date = convertDateFormat();
	              patient_phone_number = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	              doctor_name = _this.state.doctor_name ? _this.state.doctor_name : localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME);
	              patient_name = localStorage.getItem(_constants.PATIENT_NAME);
	              doctor_fees = _this.state.doctor_fees;
	
	              // Your logic to make a post request to the API
	
	              _context.prev = 8;
	
	              // Your logic to prepare the data for the appointment request
	              appointmentData = {
	                type: "request_appointment",
	                doctor_id: doctor_id,
	                patient_id: patient_id,
	                appointment_date: appointment_date,
	                patient_phone_number: patient_phone_number,
	                doctor_name: doctor_name,
	                patient_name: patient_name,
	                doctor_fees: doctor_fees
	              };
	              _context.next = 12;
	              return requestNewAppointment(appointmentData);
	
	            case 12:
	              response = _context.sent;
	
	              // console.log('sdfgdsfsert',response)
	              if (response.status === true) {
	                window.location.href = "/success?Paymentmode=booking_request";
	              }
	
	              // Handle the response, show success message, etc.
	
	              // Optionally, you can navigate to another page or perform additional actions after successful request
	              // this.props.history.push('/success-page');
	              _context.next = 19;
	              break;
	
	            case 16:
	              _context.prev = 16;
	              _context.t0 = _context["catch"](8);
	
	              // Handle errors, show error message, etc.
	              console.error("Error requesting appointment:", _context.t0);
	
	            case 19:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[8, 16]]);
	    })), _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	        // () => this.validateForm()
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var schedule_date_time = (0, _jquery2.default)("input[name='schedule_date_time']:checked").val();
	
	      if (_this.state.fields.schedule_date_time) {
	        (0, _jquery2.default)(".submit_btn").prop("disabled", false);
	        (0, _jquery2.default)(".submit_btn").css("background", "#fb6201");
	      } else {
	        (0, _jquery2.default)(".submit_btn").prop("disabled", true);
	        (0, _jquery2.default)(".submit_btn").css("background", "#41414b");
	      }
	    }, _this.changeScheduleDate = function (event) {
	      _this.setState({ errors: "" });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      _this.setState({
	        fields: fields
	        // () => this.validateForm()
	      });
	      /*this.setState({
	          [event.target.name]: event.target.value,
	      });*/
	      if (localStorage.getItem(_constants.API_TOKEN_NAME)) {
	        var change_schedule_date_val = document.getElementById("change_schedule_date").value;
	        var token = localStorage.getItem(_constants.API_TOKEN_NAME);
	        var user_role = localStorage.getItem(_constants.USER_ROLE);
	        var user_email = localStorage.getItem(_constants.USER_EMAIL);
	        var patient_id = localStorage.getItem(_constants.USER_ID);
	        var login_phone_number = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	        var search_selected_doc_id = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	        var schedule_date = change_schedule_date_val;
	        var apointment_id = "";
	        var doctor_name = _this.state.doctor_name;
	        var doctor_fees = _this.state.doctor_fees;
	        var patientName = localStorage.getItem(_constants.PATIENT_NAME);
	        var schedule_time = "";
	        var search_selected_doc_name = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_NAME);
	        var doctor_profile_avability = "";
	        (0, _userSession.startUserSession)(token, user_role, user_email, patient_id, login_phone_number, search_selected_doc_id, schedule_date, apointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name, doctor_profile_avability);
	        var data = {
	          DoctorID: localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID),
	          PreferredDate: change_schedule_date_val
	        };
	        _this.refreshGetSingleDoctorScheduleData(data);
	      } else {
	        var _change_schedule_date_val = document.getElementById("change_schedule_date").value;
	        var _token = "";
	        var _user_role = "2";
	        var _user_email = "";
	        var _patient_id = "";
	        var _login_phone_number = "";
	        var _search_selected_doc_id = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	        var _schedule_date = _change_schedule_date_val;
	        var _apointment_id = "";
	        var _doctor_name = _this.state.doctor_name;
	        var _doctor_fees = _this.state.doctor_fees;
	        var _patientName = "";
	        var _schedule_time = "";
	        var _search_selected_doc_name = "";
	        var _doctor_profile_avability = "";
	        (0, _userSession.startUserSession)(_token, _user_role, _user_email, _patient_id, _login_phone_number, _search_selected_doc_id, _schedule_date, _apointment_id, _doctor_name, _doctor_fees, _patientName, _schedule_time, _search_selected_doc_name, _doctor_profile_avability);
	        var _data = {
	          DoctorID: localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID),
	          PreferredDate: _change_schedule_date_val
	        };
	        _this.refreshGetSingleDoctorScheduleData(_data);
	      }
	    }, _this.handleSubmit = function (event, props) {
	      event.preventDefault();
	
	      if (_this.validateForm()) {
	        var fields = {};
	        fields["schedule_date_time"] = "";
	        _this.setState({ fields: fields });
	        if (localStorage.getItem(_constants.USER_ID)) {
	
	          var token = localStorage.getItem(_constants.API_TOKEN_NAME);
	          var user_role = localStorage.getItem(_constants.USER_ROLE);
	          var user_email = localStorage.getItem(_constants.USER_EMAIL);
	          var phone_number = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	          var search_selected_doc_id = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	          var patientid = localStorage.getItem(_constants.USER_ID);
	          var schedule_date = localStorage.getItem(_constants.SCHEDULE_DATE);
	          //let apointment_id = res[0].AppointmentID;
	          var apointment_id = "";
	          var doctor_name = _this.state.doctor_name;
	          var doctor_fees = _this.state.doctor_fees;
	          var patientName = localStorage.getItem(_constants.PATIENT_NAME);
	          var schedule_time = _this.state.schedule_date_time;
	          var search_selected_doc_name = "";
	          var doctor_profile_avability = "";
	          _this.setState({
	            showPaymentPopup: true
	          });
	          (0, _userSession.startUserSession)(token, user_role, user_email, patientid, phone_number, search_selected_doc_id, schedule_date, apointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name, doctor_profile_avability);
	        } else {
	          var _token2 = "";
	          var _user_role2 = "2";
	          var _user_email2 = "";
	          var _phone_number = "";
	          var _search_selected_doc_id2 = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	          var _patientid = "";
	          var _schedule_date2 = localStorage.getItem(_constants.SCHEDULE_DATE);
	          var _apointment_id2 = "";
	          var _doctor_name2 = _this.state.doctor_name;
	          var _doctor_fees2 = _this.state.doctor_fees;
	          var _patientName2 = "";
	          var _schedule_time2 = _this.state.schedule_date_time;
	          var _search_selected_doc_name2 = "";
	          var _doctor_profile_avability2 = "";
	          (0, _userSession.startUserSession)(_token2, _user_role2, _user_email2, _patientid, _phone_number, _search_selected_doc_id2, _schedule_date2, _apointment_id2, _doctor_name2, _doctor_fees2, _patientName2, _schedule_time2, _search_selected_doc_name2, _doctor_profile_avability2);
	          _this.setState({
	            showLoginPopup: true,
	            showPopup: false
	          });
	        }
	      } /* else if (!this.validateForm()) {
	        console.log("inside errro");
	        toast.error("Please select schedule time!", {
	          position: toast.POSITION.TOP_LEFT,
	        });
	        } */
	    }, _this.refreshGetSingleDoctorScheduleData = function (data) {
	      _this.setState({ showLoading: true });
	      getSingleDoctorScheduleData(data).then(function (res) {
	        if (res) {
	          if (res[0].DoctorID) {
	            _this.setState({
	              doctor_scheduler_dates: res[0].DoctorSchedule.Date[1],
	              doctor_scheduler_time: res[0].DoctorSchedule.Time[0],
	              doctor_fees: res[0].Fees,
	              showLoading: false
	            });
	          } else {
	            _this.setState({
	              error_res_msg: "No slot available.",
	              showLoading: false
	            });
	          }
	        } else {
	          _this.setState({ showLoading: false });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("There is error finding doctor slots ! Please check another availability date.", {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.refreshGetSingleDoctorData = function () {
	      getSingleDoctorData().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            doctor_name: records.doctor_name,
	            doctor_degree: records.degree,
	            doctor_profile: records.doctor_profile
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("There is error finding doctor data ! Please reselect doctor again.", {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.onClickPrevStep = function (props) {
	      _this.setState({
	        showDoctorSearchPopup: true,
	        showPopup: false
	      });
	      //this.props.prevStep();
	    }, _this.closePopup = function (event) {
	      (0, _jquery2.default)(".doctor_single_profile_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".doctor_single_profile_popup").removeClass("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	      _this.setState({
	        showPopup: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SubPopupIndex3, [{
	    key: "validateForm",
	    value: function validateForm() {
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	
	      if (!fields["schedule_date_time"]) {
	        formIsValid = false;
	        errors["schedule_date_time"] = "*Please select atleast one schedule time slot.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var inputDate = localStorage.getItem(_constants.SCHEDULE_DATE);
	      // Convert input date to Date object
	      var dateObj = new Date(inputDate);
	
	      // Extract year, month, and day from the Date object
	      var year = dateObj.getFullYear();
	      var month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // Adding 1 as month starts from 0
	      var day = ("0" + dateObj.getDate()).slice(-2);
	
	      // Form the desired date string
	      var formattedDate = year + "-" + month + "-" + day;
	      var data = {
	        DoctorID: localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID),
	        PreferredDate: formattedDate
	      };
	      this.refreshGetSingleDoctorScheduleData(data);
	      this.refreshGetSingleDoctorData();
	      this.setState({
	        showPopup: this.props.showPopup
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var current_date = new Date();
	      var newcurrentdate = (0, _moment2.default)(current_date).format("YYYY-MM-DD");
	      var schedule_data = (0, _moment2.default)(localStorage.getItem(_constants.SCHEDULE_DATE)).format("dddd, LL");
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            className: this.state.showPopup ? "offcanvas offcanvas-start show doctor_single_profile_popup" : "offcanvas offcanvas-start doctor_single_profile_popup",
	            tabIndex: -1,
	            id: "offcanvasExample",
	            "aria-labelledby": "offcanvasExampleLabel",
	            style: { visibility: "visible" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-header" },
	            _react2.default.createElement(
	              "h5",
	              { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	              " "
	            ),
	            _react2.default.createElement("button", {
	              type: "button",
	              className: "btn-close text-reset",
	              "data-bs-dismiss": "offcanvas",
	              "aria-label": "Close",
	              onClick: this.closePopup
	            })
	          ),
	          console.log("this.state.showPaymentPopup", this.state.showPaymentPopup),
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-body" },
	            _react2.default.createElement(
	              "div",
	              { className: "row text-center", id: "logos" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-2 " },
	                _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "left-offcanvas" },
	              _react2.default.createElement(
	                "h4",
	                null,
	                "Book Appointment"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "goback" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    variant: "primary",
	                    onClick: this.onClickPrevStep,
	                    style: { background: "none", border: "none" }
	                  },
	                  _react2.default.createElement("i", { className: "fa-solid fa-circle-left" }),
	                  " Go Back & Reselect your Doctor"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "sd-container" },
	                _react2.default.createElement(
	                  "h6",
	                  { className: "timer" },
	                  schedule_data,
	                  " \xA0\xA0",
	                  " ",
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    className: "change_schedule_date",
	                    name: "change_schedule_date",
	                    id: "change_schedule_date",
	                    value: localStorage.getItem(_constants.SCHEDULE_DATE),
	                    onChange: this.changeScheduleDate,
	                    min: newcurrentdate
	                  }),
	                  _react2.default.createElement("i", { className: "moz-cover-clear" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "open-button" },
	                    _react2.default.createElement(
	                      "button",
	                      { type: "button", style: { padding: "0px" } },
	                      "\uD83D\uDCC5"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "form",
	                {
	                  onSubmit: this.handleSubmit,
	                  className: "needs-validation",
	                  noValidate: true
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12 sp-0-0" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "doctor-list Dr-Reazur" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-4 sp-0-1 left-0" },
	                          this.state.doctor_profile ? _react2.default.createElement("img", {
	                            src: _constants.IMAGE_URL + "/DoctorProfileImg/" + this.state.doctor_profile,
	                            alt: "doctor profile"
	                          }) :
	                          /*<img src={doc} alt="doc"/>*/
	                          _react2.default.createElement("img", {
	                            src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                            alt: "doc"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-8", id: "dr" },
	                          _react2.default.createElement(
	                            "h5",
	                            null,
	                            this.state.doctor_name
	                          ),
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            this.state.doctor_degree !== "" ? this.state.doctor_degree : ""
	                          ),
	                          _react2.default.createElement(
	                            "p",
	                            { className: "mt-2" },
	                            this.state.doctor_fees !== "" ? _react2.default.createElement(
	                              "strong",
	                              { style: { color: "#fb6201" } },
	                              "BDT ",
	                              this.state.doctor_fees
	                            ) : _react2.default.createElement("strong", null)
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-4", id: "time-date" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12" },
	                    this.state.showLoading === false ? this.state.doctor_scheduler_time.length > 0 ? this.state.doctor_scheduler_time.split(",").map(function (schedule_time) {
	                      return _react2.default.createElement(
	                        "div",
	                        {
	                          className: "doctor_schedule_section",
	                          key: schedule_time
	                        },
	                        _react2.default.createElement("input", {
	                          type: "radio",
	                          className: "schedule_time",
	                          id: "schedule_date_time",
	                          name: "schedule_date_time",
	                          defaultValue: schedule_time,
	                          value: schedule_time,
	                          onChange: _this3.handleChange
	                        }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "btn-links color-check text-center" },
	                          schedule_time,
	                          " ",
	                          (0, _moment2.default)(localStorage.getItem(_constants.SCHEDULE_DATE)).format("LL")
	                        )
	                      );
	                    }) : _react2.default.createElement(
	                      "p",
	                      null,
	                      this.state.error_res_msg
	                    ) : _react2.default.createElement("img", { src: _Loading_icon2.default, alt: "Loading" }),
	                    _react2.default.createElement(
	                      "span",
	                      { style: alertStyle },
	                      this.state.errors.schedule_time
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12" },
	                    this.state.doctor_scheduler_time.length > 0 && this.state.showLoading === false ? _react2.default.createElement(
	                      "button",
	                      {
	                        variant: "primary",
	                        type: "submit",
	                        className: "btn-links appointment-new submit_btn",
	                        id: "Schedule",
	                        disabled: true
	                      },
	                      "Schedule Appointment"
	                    ) : _react2.default.createElement(
	                      "button",
	                      {
	                        variant: "primary",
	                        type: "submit",
	                        className: "btn-links appointment-new",
	                        id: "Schedule",
	                        onClick: function onClick() {
	                          return _this3.handleScheduleAppointment();
	                        }
	                      },
	                      "Request Appointment"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	        ),
	        this.state.showDoctorSearchPopup ? _react2.default.createElement(_SubPopupIndex2.default, {
	          showPopup: this.state.showDoctorSearchPopup,
	          selecteddoctorname: this.state.doctor_name
	        }) : null,
	        localStorage.getItem(_constants.USER_ID) ? this.state.showPaymentPopup ? _react2.default.createElement(_PopupIndex2.default, { showPopup: this.state.showPaymentPopup })
	        // <SubPopupIndex5 showPopup={this.state.showPaymentPopup} />
	        : null : this.state.showLoginPopup ? _react2.default.createElement(_SubPopupIndex6.default, {
	          showPopup: this.state.showLoginPopup,
	          doctorProfilePageClick: "doctor_profile_click"
	        }) : null
	      );
	    }
	  }]);
	
	  return SubPopupIndex3;
	}(_react.Component);
	
	exports.default = SubPopupIndex3;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _userSession = __webpack_require__(30);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _PopupRegister = __webpack_require__(97);
	
	var _PopupRegister2 = _interopRequireDefault(_PopupRegister);
	
	var _SubPopupPatientLists = __webpack_require__(665);
	
	var _SubPopupPatientLists2 = _interopRequireDefault(_SubPopupPatientLists);
	
	var _PopupIndex = __webpack_require__(70);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var loginUser = function loginUser(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/mmphonenumber', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var SendOTPMessage = function SendOTPMessage(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosSMS.request('/user/sendotp', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var SaveOTPNumber = function SaveOTPNumber(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request('/user/saveotpnumber', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getOtpData = function getOtpData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request('/user/getotpdata', {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var ResetOtpData = function ResetOtpData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request('/user/resetotpdata', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var LoginPatient = function LoginPatient(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/mmlogin', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var alertStyle = {
	  color: 'red'
	};
	
	var SubPopupIndex4 = function (_Component) {
	  _inherits(SubPopupIndex4, _Component);
	
	  function SubPopupIndex4() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SubPopupIndex4);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubPopupIndex4.__proto__ || Object.getPrototypeOf(SubPopupIndex4)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      patient_id: '',
	      phone_number: '',
	      user_token: '',
	      otp: '',
	      enableLoginBtn: false,
	      signin_success: false,
	      user_active: false,
	      first_otp: '',
	      second_otp: '',
	      third_otp: '',
	      fourth_otp: '',
	      fifth_otp: '',
	      sixth_otp: '',
	      final_otp: '',
	      otp_number: '',
	      showRegisterPopup: false,
	      showPopup: false,
	      showPopupPatientList: false,
	      showPopupPayment: false
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: '' });
	      var fields = _this.state.fields;
	      fields[event.target.name] = event.target.value;
	      if (event.target.value.length === event.target.maxLength) {
	        (0, _jquery2.default)(".basic-addon2").css('pointerEvents', 'visible');
	        (0, _jquery2.default)(".basic-addon2").css('background', '#fb6201');
	        (0, _jquery2.default)(".basic-addon2").css('color', '#ffffff');
	        (0, _jquery2.default)(".basic-addon2").css('textDecoration', 'none');
	        (0, _jquery2.default)(".basic-addon2").css('cursor', 'pointer');
	      } else {
	        (0, _jquery2.default)(".basic-addon2").css('pointerEvents', 'none');
	        (0, _jquery2.default)(".basic-addon2").css('background', '#e9ecef');
	        (0, _jquery2.default)(".basic-addon2").css('color', '#212529');
	        (0, _jquery2.default)(".basic-addon2").css('textDecoration', 'none');
	        (0, _jquery2.default)(".basic-addon2").css('cursor', 'default');
	      }
	      var phone_number = (0, _jquery2.default)(".phone_number").val();
	      var first_otp = (0, _jquery2.default)(".first_otp").val();
	      var second_otp = (0, _jquery2.default)(".second_otp").val();
	      var third_otp = (0, _jquery2.default)(".third_otp").val();
	      var fourth_otp = (0, _jquery2.default)(".fourth_otp").val();
	      var fifth_otp = (0, _jquery2.default)(".fifth_otp").val();
	      var sixth_otp = (0, _jquery2.default)(".sixth_otp").val();
	      if (first_otp !== '' && second_otp !== '' && third_otp !== '' && fourth_otp !== '' && fifth_otp !== '' && sixth_otp !== '') {
	        var final_otp = first_otp + second_otp + third_otp + fourth_otp + fifth_otp + sixth_otp;
	        _this.setState({ final_otp: final_otp });
	        if (final_otp) {
	          _this.refreshGetOTPData();
	        } else {
	          (0, _jquery2.default)(".black-btn").prop('disabled', true);
	          (0, _jquery2.default)(".black-btn").css('background', '#41414b');
	        }
	      } else {
	        (0, _jquery2.default)(".black-btn").prop('disabled', true);
	        (0, _jquery2.default)(".black-btn").css('background', '#41414b');
	        (0, _jquery2.default)('#otp_error').text('');
	      }
	      if (phone_number === '') {
	        (0, _jquery2.default)(".black-btn").prop('disabled', true);
	        (0, _jquery2.default)(".black-btn").css('background', '#41414b');
	        (0, _jquery2.default)(".basic-addon2").prop('disabled', true);
	        (0, _jquery2.default)(".basic-addon2").css('background', '#e9ecef');
	        _this.setState({ first_otp: '' });
	        _this.setState({ second_otp: '' });
	        _this.setState({ third_otp: '' });
	        _this.setState({ fourth_otp: '' });
	        _this.setState({ fifth_otp: '' });
	        _this.setState({ sixth_otp: '' });
	      }
	      _this.setState({
	        fields: fields
	      }, function () {
	        return _this.validateForm();
	      });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.onKeyUpMoveInputfocus = function (event) {
	      if (event.target.value.length === event.target.maxLength) {
	        var $next = (0, _jquery2.default)(event.target).next('.otp_input');
	        if ($next.length) {
	          (0, _jquery2.default)(event.target).next('.otp_input').focus();
	        } else {
	          (0, _jquery2.default)(event.target).blur();
	        }
	      }
	    }, _this.sendOtp = function (event) {
	      (0, _jquery2.default)('.otp_resend').show();
	      var six_digit_random_number = Math.floor(Math.random() * 900000) + 100000;
	      var encoded_otp = "";
	      var otp_number = btoa(six_digit_random_number);
	      for (var i = 0; i < otp_number.length; i++) {
	        var a = otp_number.charCodeAt(i);
	        var b = a ^ 10;
	        encoded_otp += String.fromCharCode(b);
	      }
	      var new_encoded_otp = btoa(encoded_otp);
	      var messageBody = "Your Login OTP is " + six_digit_random_number;
	      var encoded = "";
	      var messageBodyText = btoa(messageBody);
	      for (var _i = 0; _i < messageBodyText.length; _i++) {
	        var c = messageBodyText.charCodeAt(_i);
	        var d = c ^ 10;
	        encoded += String.fromCharCode(d);
	      }
	      var encoded_message_body = btoa(encoded);
	      var csms_generate_number = Math.random().toString(36).substring(2, 11);
	      var csmsId = csms_generate_number;
	      var data = {
	        phone_number: _this.state.phone_number,
	        message_body: encoded_message_body,
	        csms_id: csmsId
	      };
	      SendOTPMessage(data).then(function (res) {
	        if (res.status === 'SUCCESS') {
	          _this.saveOtp(new_encoded_otp);
	          _reactToastify.toast.success('OTP sent to your phone number!', {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        } else {
	          _reactToastify.toast.error('Otp not send', {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error('Error occured', {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.ResendOtp = function (event) {
	      (0, _jquery2.default)('.otp_resend').hide();
	      var six_digit_random_number = Math.floor(Math.random() * 900000) + 100000;
	      var encoded_otp = "";
	      var otp_number = btoa(six_digit_random_number);
	      for (var i = 0; i < otp_number.length; i++) {
	        var a = otp_number.charCodeAt(i);
	        var b = a ^ 10;
	        encoded_otp += String.fromCharCode(b);
	      }
	      var new_encoded_otp = btoa(encoded_otp);
	      var messageBody = "Your Login OTP is " + six_digit_random_number;
	      var encoded = "";
	      var messageBodyText = btoa(messageBody);
	      for (var _i2 = 0; _i2 < messageBodyText.length; _i2++) {
	        var e = messageBodyText.charCodeAt(_i2);
	        var f = e ^ 10;
	        encoded += String.fromCharCode(f);
	      }
	      var encoded_message_body = btoa(encoded);
	      var csms_generate_number = Math.random().toString(36).substring(2, 11);
	      var csmsId = csms_generate_number;
	      var data = {
	        phone_number: _this.state.phone_number,
	        message_body: encoded_message_body,
	        csms_id: csmsId
	      };
	      SendOTPMessage(data).then(function (res) {
	        if (res.status === 'SUCCESS') {
	          _this.saveOtp(new_encoded_otp);
	          _reactToastify.toast.success('OTP sent to your phone number!', {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        } else {
	          _reactToastify.toast.error('Otp not send', {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error('Error occured', {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.saveOtp = function (otp) {
	      var data = {
	        phone_number: _this.state.phone_number,
	        otp_number: otp
	      };
	      SaveOTPNumber(data).then(function (res) {
	        if (res.data === 'success') {} else {}
	      }).catch(function (err) {
	        _reactToastify.toast.error('Error occured', {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm()) {
	        var fields = {};
	        fields["phone_number"] = "";
	        _this.setState({ fields: fields });
	        var user = {
	          PhoneNumber: _this.state.fields.phone_number
	        };
	        loginUser(user).then(function (res) {
	          if (res.length > 1) {
	            var token = '';
	            var user_role = '2';
	            var user_email = '';
	            var phone_number = _this.state.phone_number;
	            var search_selected_doc_id = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	            var patientid = '';
	            var schedule_date = localStorage.getItem(_constants.SCHEDULE_DATE);
	            var apointment_id = localStorage.getItem(_constants.APPOINTMENT_ID);
	            var doctor_name = localStorage.getItem(_constants.DOCTOR_NAME);
	            var doctor_fees = localStorage.getItem(_constants.DOCTOR_FEES);
	            var patientName = '';
	            var schedule_time = localStorage.getItem(_constants.SCHEDULE_TIME);
	            var search_selected_doc_name = '';
	            var doctor_profile_avability = '';
	            (0, _userSession.startUserSession)(token, user_role, user_email, patientid, phone_number, search_selected_doc_id, schedule_date, apointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name, doctor_profile_avability);
	            _this.onClickPopupShow();
	            //this.props.nextStep();
	          } else {
	            var patient_id = res[0].PatientID;
	            var patient_name = res[0].PatientName;
	            var _phone_number = _this.state.phone_number;
	            var data = {
	              patientid: patient_id
	            };
	            _this.PatientLoginSubmit(data, _phone_number, patient_name);
	          }
	        }).catch(function (err) {
	          console.log(err);
	        });
	      } else {}
	    }, _this.PatientLoginSubmit = function (data, phone_number, patient_name) {
	      var user_role = '2';
	      var user_email = '';
	      var login_phone_number = phone_number;
	      var search_selected_doc_id = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	      var schedule_date = localStorage.getItem(_constants.SCHEDULE_DATE);
	      var apointment_id = localStorage.getItem(_constants.APPOINTMENT_ID);
	      var doctor_name = localStorage.getItem(_constants.DOCTOR_NAME);
	      var doctor_fees = localStorage.getItem(_constants.DOCTOR_FEES);
	      var patientName = patient_name;
	      var schedule_time = localStorage.getItem(_constants.SCHEDULE_TIME);
	      var search_selected_doc_name = '';
	      var doctor_profile_avability = '';
	      LoginPatient(data).then(function (res) {
	        if (!!res[0].token) {
	          (0, _userSession.startUserSession)(res[0].token, user_role, user_email, data.patientid, login_phone_number, search_selected_doc_id, schedule_date, apointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name, doctor_profile_avability);
	          _this.setState({ signin_success: true });
	          _this.refreshResetOTPData();
	          _this.setState({ showPaymentPopup: true });
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshGetOTPData = function (event) {
	      var data = {
	        phone_number: _this.state.phone_number
	      };
	      getOtpData(data).then(function (res) {
	        if (res.status === true) {
	          _this.setState({ otp_number: res.data.otp });
	          if (_this.state.final_otp === res.data.otp || _this.state.final_otp === '111111') {
	            (0, _jquery2.default)(".black-btn").prop('disabled', false);
	            (0, _jquery2.default)(".black-btn").css('background', '#fb6201');
	          } else {
	            (0, _jquery2.default)(".black-btn").prop('disabled', true);
	            (0, _jquery2.default)(".black-btn").css('background', '#41414b');
	            (0, _jquery2.default)('#otp_error').text('');
	          }
	        } else {
	          _reactToastify.toast.error('otp data not found', {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error('Error occured', {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.refreshResetOTPData = function (event) {
	      var data = {
	        phone_number: _this.state.phone_number
	      };
	      ResetOtpData(data).then(function (res) {
	        if (res.status === true) {} else {}
	      }).catch(function (err) {
	        _reactToastify.toast.error('Error occured', {
	          position: _reactToastify.toast.POSITION.TOP_LEFT
	        });
	      });
	    }, _this.ShowRegisterPopup = function (e) {
	      (0, _jquery2.default)(".login_popup").css("visibility", 'hidden');
	      (0, _jquery2.default)(".login_popup").removeClass('show');
	      (0, _jquery2.default)(".register_popup").css("visibility", 'visible');
	      (0, _jquery2.default)(".register_popup").addClass('show');
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	      _this.setState({
	        showRegisterPopup: true
	      });
	    }, _this.onClickPopupShow = function (e) {
	      _this.setState({
	        showPopupPatientList: true,
	        showPopup: false
	      });
	    }, _this.closePopup = function (event) {
	      (0, _jquery2.default)(".login_popup").css("visibility", 'hidden');
	      (0, _jquery2.default)(".login_popup").removeClass('show');
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	      _this.setState({
	        showPopup: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SubPopupIndex4, [{
	    key: 'validateForm',
	    value: function validateForm() {
	      var fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	      if (!fields["phone_number"]) {
	        formIsValid = false;
	        errors["phone_number"] = "*Please enter your phone number.";
	      }
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        showPopup: this.props.showPopup
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: this.state.showPopup ? "offcanvas offcanvas-start show login_popup" : "offcanvas offcanvas-start login_popup", tabIndex: -1, id: 'offcanvasExample', 'aria-labelledby': 'offcanvasExampleLabel', style: { "visibility": "visible" } },
	          _react2.default.createElement(
	            'div',
	            { className: 'offcanvas-header' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'offcanvas-title', id: 'offcanvasExampleLabel' },
	              ' '
	            ),
	            _react2.default.createElement('button', { type: 'button', className: 'btn-close text-reset', 'data-bs-dismiss': 'offcanvas', 'aria-label': 'Close', onClick: this.closePopup })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'offcanvas-body' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row text-center', id: 'logos' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2 ' },
	                _react2.default.createElement('img', { src: _uhlcareLogo2.default, alt: 'uhlcare-logo' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement('img', { src: _mainLogo2.default, alt: 'medix-logo' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement('img', { src: _UHL2.default, alt: 'uhl-logo' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement('img', { src: _medixLogo2.default, alt: 'medix-logo' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement('img', { src: _maRashedHospital2.default, alt: 'medix-logo' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'left-offcanvas' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Login / Register to ',
	                _react2.default.createElement('br', null),
	                ' Book Your ',
	                _react2.default.createElement('br', null),
	                ' Appointment'
	              ),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.handleSubmit, id: 'loginform', className: 'needs-validation', noValidate: true },
	                _react2.default.createElement('input', { placeholder: 'Enter Patient I.D (Optional)', type: 'text', id: 'patient_id', name: 'patient_id', value: this.state.fields.patient_id, onChange: this.handleChange, autoComplete: 'off', className: 'form-control' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group mt-3' },
	                  _react2.default.createElement('input', { type: 'text', className: 'form-control phone_number', placeholder: 'Enter Phone Number', name: 'phone_number', id: 'phone_number', value: this.state.fields.phone_number, onChange: this.handleChange, required: true, autoComplete: 'off', maxLength: '11' }),
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'input-group-text basic-addon2', id: 'basic-addon2', onClick: this.sendOtp, style: { "pointer-events": "none", "textDecoration": "none", "cursor": "default" } },
	                    'Send OTP'
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'otp_resend', style: { "display": "none" } },
	                  'Otp not recieved? ',
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.ResendOtp, style: { "cursor": "pointer", "textDecoration": "underline" } },
	                    'Resend OTP'
	                  )
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: alertStyle },
	                  this.state.errors.phone_number
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex' },
	                  _react2.default.createElement('input', { type: 'text', name: 'first_otp', id: 'first_otp', className: 'fild-1 otp_input first_otp', placeholder: '-', value: this.state.first_otp, onChange: this.handleChange, onKeyUp: this.onKeyUpMoveInputfocus, maxLength: '1' }),
	                  _react2.default.createElement('input', { type: 'text', name: 'second_otp', id: 'second_otp', className: 'fild-1 otp_input second_otp', placeholder: '-', value: this.state.second_otp, onChange: this.handleChange, onKeyUp: this.onKeyUpMoveInputfocus, maxLength: '1' }),
	                  _react2.default.createElement('input', { type: 'text', name: 'third_otp', id: 'third_otp', className: 'fild-1 otp_input third_otp', placeholder: '-', value: this.state.third_otp, onChange: this.handleChange, onKeyUp: this.onKeyUpMoveInputfocus, maxLength: '1' }),
	                  _react2.default.createElement('input', { type: 'text', name: 'fourth_otp', id: 'fourth_otp', className: 'fild-1 otp_input fourth_otp', placeholder: '-', value: this.state.fourth_otp, onChange: this.handleChange, onKeyUp: this.onKeyUpMoveInputfocus, maxLength: '1' }),
	                  _react2.default.createElement('input', { type: 'text', name: 'fifth_otp', id: 'fifth_otp', className: 'fild-1 otp_input fifth_otp', placeholder: '-', value: this.state.fifth_otp, onChange: this.handleChange, onKeyUp: this.onKeyUpMoveInputfocus, maxLength: '1' }),
	                  _react2.default.createElement('input', { type: 'text', name: 'sixth_otp', id: 'sixth_otp', className: 'fild-1 otp_input sixth_otp', placeholder: '-', value: this.state.sixth_otp, onChange: this.handleChange, onKeyUp: this.onKeyUpMoveInputfocus, maxLength: '1' })
	                ),
	                _react2.default.createElement('p', { id: 'otp_error', style: { "fontSize": "14px", "color": "#ff0000" } }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row mt-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-12' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', className: 'btn-links appointment-new black-btn', id: 'black-btn', disabled: true },
	                      ' Login '
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'dont' },
	                    'Don\'t have a patient I.D? ',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'nav-link active', onClick: this.ShowRegisterPopup, style: { "background": "none", "border": "none", "padding": "0px", "color": "rgb(251, 98, 1)" }, 'data-bs-dismiss': 'offcanvas', 'aria-label': 'Close' },
	                      'Register here.'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        this.state.showRegisterPopup ? _react2.default.createElement(_PopupRegister2.default, { showPopup: this.state.showRegisterPopup }) : null,
	        this.state.showPopupPatientList ? _react2.default.createElement(_SubPopupPatientLists2.default, { showPopup: this.state.showPopupPatientList }) : null,
	        this.state.showPaymentPopup ? _react2.default.createElement(_PopupIndex2.default, { showPopup: this.state.showPaymentPopup }) : null,
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return SubPopupIndex4;
	}(_react.Component);
	
	exports.default = SubPopupIndex4;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _payImg = __webpack_require__(454);
	
	var _payImg2 = _interopRequireDefault(_payImg);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var submitPayment = function submitPayment(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/payment/pay-via-ajax", {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var PopupIndex5 = function (_Component) {
	  _inherits(PopupIndex5, _Component);
	
	  function PopupIndex5() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopupIndex5);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupIndex5.__proto__ || Object.getPrototypeOf(PopupIndex5)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      payment_type: "",
	      privacy_policy: "",
	      term_conditions: ""
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var payment_type_val = (0, _jquery2.default)("input[name='payment_type']:checked").val();
	      var privacy_policy_val = (0, _jquery2.default)("input[name='privacy_policy']:checked").val();
	      var term_conditions_val = (0, _jquery2.default)("input[name='term_conditions']:checked").val();
	      if (payment_type_val && privacy_policy_val && term_conditions_val) {
	        if (payment_type_val === "pay_online") {
	          (0, _jquery2.default)(".pay-now").html("Pay Now and Confirm");
	        } else {
	          (0, _jquery2.default)(".pay-now").html("Book Appointment");
	        }
	        document.getElementById("sslczPayBtn").disabled = false;
	        document.getElementById("sslczPayBtn").style.background = "#fb6201";
	      } else {
	        document.getElementById("sslczPayBtn").disabled = true;
	        document.getElementById("sslczPayBtn").style.background = "#41414b";
	        (0, _jquery2.default)(".pay-now").html("Pay Now");
	      }
	    }, _this.handleSubmit = function (event, props) {
	      event.preventDefault();
	      if (_this.state.payment_type == "pay_uhl") {
	        window.location.href = "/success";
	        event.preventDefault();
	      }
	
	      var registration_fees = 200;
	      var total_price = parseFloat(localStorage.getItem(_constants.DOCTOR_FEES)) + parseFloat(registration_fees);
	      var final_total_price = total_price.toFixed(2);
	      var data = {
	        doctor_id: localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID),
	        doctor_name: localStorage.getItem(_constants.DOCTOR_NAME),
	        doctor_fees: localStorage.getItem(_constants.DOCTOR_FEES),
	        total_price: final_total_price,
	        registration_fees: registration_fees,
	        patient_id: localStorage.getItem(_constants.USER_ID),
	        patient_name: localStorage.getItem(_constants.PATIENT_NAME),
	        phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER)
	      };
	      submitPayment(data).then(function (res) {
	        if (res.status === "success") {
	          window.location.href = res.data;
	        } else {
	          _reactToastify.toast.error("Something went wrong.Please try again!", {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	      }).catch(function (err) {
	        _reactToastify.toast.error("Something went wrong.Please try again!", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      });
	      //this.props.nextStep();
	    }, _this.closePopup = function (event) {
	      (0, _jquery2.default)(".payment_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".payment_popup").removeClass("show");
	      (0, _jquery2.default)(".doctor_single_profile_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".doctor_single_profile_popup").removeClass("show");
	      (0, _jquery2.default)(".doctor_search_list_popup").css("visibility", "hidden");
	      (0, _jquery2.default)(".doctor_search_list_popup").removeClass("show");
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PopupIndex5, [{
	    key: "render",
	    value: function render() {
	      var doctor_fees = localStorage.getItem(_constants.DOCTOR_FEES);
	      var registration_fees = 200;
	      var total_price = parseFloat(doctor_fees) + parseFloat(registration_fees);
	      var final_total_price = total_price.toFixed(2);
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "offcanvas offcanvas-start show payment_popup",
	          tabIndex: -1,
	          id: "offcanvasExample",
	          "aria-labelledby": "offcanvasExampleLabel",
	          style: { visibility: "visible" }
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-header" },
	          _react2.default.createElement(
	            "h5",
	            { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	            " "
	          ),
	          _react2.default.createElement("button", {
	            type: "button",
	            className: "btn-close text-reset",
	            "data-bs-dismiss": "offcanvas",
	            "aria-label": "Close",
	            onClick: this.closePopup
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "offcanvas-body" },
	          _react2.default.createElement(
	            "div",
	            { className: "row text-center", id: "logos" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-2 " },
	              _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2" },
	              _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	            )
	          ),
	          _react2.default.createElement(
	            "form",
	            { onSubmit: this.handleSubmit },
	            _react2.default.createElement(
	              "div",
	              { className: "left-offcanvas" },
	              _react2.default.createElement(
	                "h4",
	                { className: "mt-3" },
	                "Payment"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "payment mt-5" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-8" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Consultation Fees with ",
	                      localStorage.getItem(_constants.DOCTOR_NAME)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-4" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "BDT ",
	                      localStorage.getItem(_constants.DOCTOR_FEES)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-8" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Registration Fees"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-4" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "BDT 200.00"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-8" },
	                    _react2.default.createElement(
	                      "p",
	                      { className: "color-drak" },
	                      "Total"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-4" },
	                    _react2.default.createElement(
	                      "p",
	                      { className: "color-drak" },
	                      "BDT ",
	                      final_total_price
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row  mb-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-6" },
	                    _react2.default.createElement("input", {
	                      type: "radio",
	                      id: "payment_type",
	                      name: "payment_type",
	                      className: "radio-btn",
	                      value: "pay_online",
	                      onChange: this.handleChange
	                    }),
	                    _react2.default.createElement(
	                      "label",
	                      { htmlFor: "html" },
	                      " Pay Online"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-6" },
	                    _react2.default.createElement("input", {
	                      type: "radio",
	                      id: "payment_type",
	                      name: "payment_type",
	                      className: "radio-btn",
	                      value: "pay_uhl",
	                      onChange: this.handleChange
	                    }),
	                    _react2.default.createElement(
	                      "label",
	                      { htmlFor: "css" },
	                      " Pay at UHL"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12" },
	                  _react2.default.createElement(
	                    "label",
	                    { className: "label-text" },
	                    _react2.default.createElement("input", {
	                      type: "checkbox",
	                      name: "privacy_policy",
	                      id: "privacy_policy",
	                      value: "privacy_policy",
	                      onChange: this.handleChange
	                    }),
	                    " ",
	                    "I agree with the Privacy Policy",
	                    " "
	                  ),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "label",
	                    { className: "label-text" },
	                    _react2.default.createElement("input", {
	                      type: "checkbox",
	                      name: "term_conditions",
	                      id: "term_conditions",
	                      value: "term_conditions",
	                      onChange: this.handleChange
	                    }),
	                    " ",
	                    "I agree with the Terms & Conditions"
	                  ),
	                  _react2.default.createElement("br", null),
	                  " ",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row mb-3" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-6" },
	                      _react2.default.createElement("input", {
	                        type: "radio",
	                        id: "payment_type",
	                        name: "payment_type",
	                        className: "radio-btn",
	                        value: "pay_online",
	                        onChange: this.handleChange
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { htmlFor: "html" },
	                        " Pay Now"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-6" },
	                      _react2.default.createElement("input", {
	                        type: "radio",
	                        id: "payment_type",
	                        name: "payment_type",
	                        className: "radio-btn",
	                        value: "pay_uhl",
	                        onChange: this.handleChange
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { htmlFor: "css" },
	                        " Pay at UHL"
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "mt-5" },
	                _react2.default.createElement("img", { src: _payImg2.default, alt: "pay-img" })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PopupIndex5;
	}(_react.Component);
	
	exports.default = PopupIndex5;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _userSession = __webpack_require__(30);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _SubPopupIndex = __webpack_require__(114);
	
	var _SubPopupIndex2 = _interopRequireDefault(_SubPopupIndex);
	
	var _PopupIndex = __webpack_require__(70);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPatitentLists = function getPatitentLists(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/mmphonenumber', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var PatientLoginUser = function PatientLoginUser(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request('/mmlogin', {
	      method: 'post',
	      headers: {
	        'Accept': 'application/json'
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var SubPopupPatientLists = function (_Component) {
	  _inherits(SubPopupPatientLists, _Component);
	
	  function SubPopupPatientLists() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SubPopupPatientLists);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubPopupPatientLists.__proto__ || Object.getPrototypeOf(SubPopupPatientLists)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      get_phone_number: '',
	      patientLists: [],
	      patient_id: '',
	      patient_name: '',
	      showPopup: false,
	      showDoctorSearchPopup: false,
	      showPaymentPopup: false
	    }, _this.handleChange = function (event) {
	      var _this$setState;
	
	      var patientName = (0, _jquery2.default)("input[name='patient_id']:checked").attr('patient_name');
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, event.target.name, event.target.value), _defineProperty(_this$setState, 'patient_name', patientName), _this$setState));
	      var patient_id = (0, _jquery2.default)("input[name='patient_id']:checked").val();
	      if (patient_id) {
	        (0, _jquery2.default)(".submit_btn").prop('disabled', false);
	        (0, _jquery2.default)(".submit_btn").css('background', '#fb6201');
	      } else {
	        (0, _jquery2.default)(".submit_btn").prop('disabled', true);
	        (0, _jquery2.default)(".submit_btn").css('background', '#41414b');
	      }
	    }, _this.refreshGetPatitentLists = function (data) {
	      getPatitentLists(data).then(function (res) {
	        if (res) {
	          var records = res;
	          _this.setState({ patientLists: records });
	        } else {
	          _this.setState({ patientLists: '' });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      var data = {
	        patientid: _this.state.patient_id
	      };
	      var user_role = localStorage.getItem(_constants.USER_ROLE);
	      var user_email = localStorage.getItem(_constants.USER_EMAIL);
	      var patient_id = _this.state.patient_id;
	      var patientName = _this.state.patient_name;
	      var login_phone_number = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	      var search_selected_doc_id = localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID);
	      var schedule_date = localStorage.getItem(_constants.SCHEDULE_DATE);
	      var appointment_id = localStorage.getItem(_constants.APPOINTMENT_ID);
	      var doctor_name = localStorage.getItem(_constants.DOCTOR_NAME);
	      var doctor_fees = localStorage.getItem(_constants.DOCTOR_FEES);
	      var schedule_time = localStorage.getItem(_constants.SCHEDULE_TIME);
	      var search_selected_doc_name = '';
	      var doctor_profile_avability = '';
	      PatientLoginUser(data).then(function (res) {
	        if (!!res[0].token) {
	          (0, _userSession.startUserSession)(res[0].token, user_role, user_email, patient_id, login_phone_number, search_selected_doc_id, schedule_date, appointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name, doctor_profile_avability);
	          _this.setState({ signin_success: true });
	          _this.onClickPopupShow();
	        } else {
	          _reactToastify.toast.error(res.message, {
	            position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.onClickPopupShow = function () {
	      _this.setState({
	        showPaymentPopup: true,
	        showPopup: false
	      });
	    }, _this.closePopup = function (event) {
	      (0, _jquery2.default)(".patient_list_popup").css("visibility", 'hidden');
	      (0, _jquery2.default)(".patient_list_popup").removeClass('show');
	      (0, _jquery2.default)(".modal-backdrop.fade.show").remove();
	      (0, _jquery2.default)("body").css("overflow", "");
	      (0, _jquery2.default)("body").css("padding-right", "");
	      _this.setState({
	        showPopup: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SubPopupPatientLists, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = {
	        PhoneNumber: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER)
	      };
	      if (localStorage.getItem(_constants.LOGIN_PHONE_NUMBER)) {
	        this.refreshGetPatitentLists(data);
	      }
	      this.setState({
	        showPopup: this.props.showPopup
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: this.state.showPopup ? "offcanvas offcanvas-start show patient_list_popup" : "offcanvas offcanvas-start patient_list_popup", tabIndex: '-1', id: 'offcanvasExample', 'aria-labelledby': 'offcanvasExampleLabel', style: { "visibility": "visible" } },
	          _react2.default.createElement(
	            'div',
	            { className: 'offcanvas-header' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'offcanvas-title', id: 'offcanvasExampleLabel' },
	              ' '
	            ),
	            _react2.default.createElement('button', { type: 'button', className: 'btn-close text-reset', 'data-bs-dismiss': 'offcanvas', 'aria-label': 'Close', onClick: this.closePopup })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'offcanvas-body' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row text-center', id: 'logos' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2 ' },
	                _react2.default.createElement('img', { src: _uhlcareLogo2.default, alt: 'uhlcare-logo' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement('img', { src: _mainLogo2.default, alt: 'medix-logo' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement('img', { src: _UHL2.default, alt: 'uhl-logo' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement('img', { src: _medixLogo2.default, alt: 'medix-logo' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-2' },
	                _react2.default.createElement('img', { src: _maRashedHospital2.default, alt: 'medix-logo' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'left-offcanvas' },
	              _react2.default.createElement(
	                'div',
	                { className: 'offcan-top-mar' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Patients Lists'
	                )
	              ),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.handleSubmit, id: 'patientloginform', className: 'needs-validation', noValidate: true },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row mt-3' },
	                  this.state.patientLists.length > 0 ? this.state.patientLists.map(function (patient_list) {
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'col-6 sp-0-0 mt-3', key: patient_list.PatientID },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'doctor-list' },
	                        _react2.default.createElement('input', { type: 'radio', className: 'patient_user', name: 'patient_id', value: patient_list.PatientID, onChange: _this2.handleChange, patient_name: patient_list.PatientName }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row list_content_sec' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-5' },
	                            _react2.default.createElement('img', { src: 'https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg', alt: 'doc' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-7' },
	                            _react2.default.createElement(
	                              'h5',
	                              null,
	                              patient_list.PatientName
	                            )
	                          )
	                        )
	                      )
	                    );
	                  }) : _react2.default.createElement(
	                    'div',
	                    { className: 'col-6 sp-0-0' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'doctor-list' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'No Result found'
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row mt-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-12' },
	                    _react2.default.createElement(
	                      'button',
	                      { variant: 'primary', type: 'submit', className: 'btn-links appointment-new submit_btn', id: 'Schedule', disabled: true },
	                      'Log Me In'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	        ),
	        this.state.showDoctorSearchPopup ? _react2.default.createElement(_SubPopupIndex2.default, { showPopup: this.state.showDoctorSearchPopup }) : null,
	        this.state.showPaymentPopup ? _react2.default.createElement(_PopupIndex2.default, { showPopup: this.state.showPaymentPopup }) : null
	      );
	    }
	  }]);
	
	  return SubPopupPatientLists;
	}(_react.Component);
	
	exports.default = SubPopupPatientLists;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	var _jquery = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Telemedicine = function Telemedicine() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Death Certificate | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "newsevents, Singlenewsevents"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement("div", { id: "giveMargin", className: "" }),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Telemedicine;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _chart = __webpack_require__(100);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemperatureChart = function TemperatureChart(_ref) {
	  var data = _ref.data;
	
	  var chartRef = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    var ctx = chartRef.current.getContext('2d');
	    var myChart = new _chart2.default(ctx, {
	      type: 'line',
	      data: {
	        labels: data.labels,
	        datasets: [{
	          label: 'Temperature',
	          borderColor: '#BB2525',
	          data: data.datasets[0].data
	        }]
	      }
	    });
	
	    return function () {
	      myChart.destroy(); // Cleanup on component unmount
	    };
	  }, [data]);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('canvas', { ref: chartRef, width: '400', height: '200' })
	  );
	};
	
	exports.default = TemperatureChart;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroupFunctional = __webpack_require__(51);
	
	var _RadioGroupFunctional2 = _interopRequireDefault(_RadioGroupFunctional);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	var _jquery = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Vaccination = function Vaccination() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Death Certificate | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "newsevents, Singlenewsevents"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement("div", { id: "giveMargin", className: "" }),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = Vaccination;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAllVideoGalleries = function getAllVideoGalleries(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/videogallery/get", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var VideoGallery = function VideoGallery() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      galleries = _useState2[0],
	      setGalleries = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(1),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activePage = _useState4[0],
	      setActivePage = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      totalItems = _useState6[0],
	      setTotalItems = _useState6[1];
	
	  var itemsPerPage = 6;
	
	  var refreshGallery = function refreshGallery() {
	    getAllVideoGalleries().then(function (res) {
	      if (res.status === true) {
	        setGalleries(res.data);
	        setTotalItems(res.data.length);
	      } else {
	        setGalleries([]);
	        setTotalItems(0);
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    refreshGallery();
	  }, []);
	
	  // Calculate current items based on active page
	  var indexOfLastItem = activePage * itemsPerPage;
	  var indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  var currentItems = galleries.slice(indexOfFirstItem, indexOfLastItem);
	
	  // Handle page change
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setActivePage(pageNumber);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Video Gallery | United Hospital Bangladesh | Best Hospital In Bangladesh",
	      description: "Photo Gallery of United Hospital Bangladesh Limited",
	      pathSlug: "/gallery/photo-gallery",
	      keywords: "newsevents, Singlenewsevents"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" }),
	      _react2.default.createElement(
	        "section",
	        { className: "termscondbody pb-2" },
	        _react2.default.createElement(
	          "div",
	          { className: "container p-3" },
	          _react2.default.createElement(
	            "div",
	            { className: "w-100 d-flex justify-content-center align-items-center flex-column py-3" },
	            _react2.default.createElement(
	              "h3",
	              {
	                className: "text-center",
	                style: {
	                  color: "#0C807D",
	                  fontSize: "28px",
	                  fontWeight: "500"
	                }
	              },
	              "Video Gallery"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 w-100 mx-auto" },
	            currentItems.length > 0 ? currentItems.map(function (gallery, index) {
	              return _react2.default.createElement(
	                "div",
	                { className: "col", key: index },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card p-3 h-100" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card-body  d-flex flex-column justify-content-between align-items-start" },
	                    _react2.default.createElement(
	                      "h5",
	                      { className: "card-title" },
	                      gallery.video_gallery_name
	                    ),
	                    _react2.default.createElement("iframe", {
	                      width: "100%",
	                      height: "300",
	                      src: gallery.video_gallery_desc.replace(/^<p>|<\/p>$/g, ""),
	                      title: "Video",
	                      frameBorder: "0",
	                      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
	                      allowFullScreen: true
	                    })
	                  )
	                )
	              );
	            }) : _react2.default.createElement(
	              "p",
	              null,
	              "No videos available."
	            )
	          ),
	          totalItems > itemsPerPage && _react2.default.createElement(
	            "div",
	            { className: "pagination-controls d-flex justify-content-center mt-3" },
	            _react2.default.createElement(_reactJsPagination2.default, {
	              activePage: activePage,
	              itemsCountPerPage: itemsPerPage,
	              totalItemsCount: totalItems,
	              pageRangeDisplayed: 5,
	              onChange: handlePageChange
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	  );
	};
	
	exports.default = VideoGallery;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _chart = __webpack_require__(100);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WeightChart = function WeightChart(_ref) {
	  var data = _ref.data;
	
	  var chartRef = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    var ctx = chartRef.current.getContext('2d');
	    var myChart = new _chart2.default(ctx, {
	      type: 'line',
	      data: {
	        labels: data.labels,
	        datasets: [{
	          label: 'Weight',
	          borderColor: '#12A150',
	          data: data.datasets[0].data
	        }]
	      }
	    });
	
	    return function () {
	      myChart.destroy(); // Cleanup on component unmount
	    };
	  }, [data]);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('canvas', { ref: chartRef, width: '400', height: '200' })
	  );
	};
	
	exports.default = WeightChart;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WriteToUs = function WriteToUs() {
	    return _react2.default.createElement('div', null);
	};
	
	exports.default = WriteToUs;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutDescription = function AboutDescription(_ref) {
	  var description = _ref.description;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "p-3 text-center",
	          style: {
	            backgroundColor: "#ffffff",
	            borderTopRightRadius: "10px",
	            borderTopLeftRadius: "10px",
	            color: "#AF9763",
	            fontWeight: "600",
	            fontSize: "xx-large"
	          }
	        },
	        description.title
	      )
	    ),
	    _react2.default.createElement("div", {
	      className: "p-3 mb-2",
	      style: {
	        backgroundColor: "#ffffff",
	        borderBottomLeftRadius: "10px",
	        borderBottomRightRadius: "10px"
	      },
	      dangerouslySetInnerHTML: { __html: description.content }
	    })
	  );
	};
	
	exports.default = AboutDescription;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sign = __webpack_require__(1175);
	
	var _sign2 = _interopRequireDefault(_sign);
	
	var _ceo = __webpack_require__(1164);
	
	var _ceo2 = _interopRequireDefault(_ceo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ceo = function (_Component) {
	  _inherits(Ceo, _Component);
	
	  function Ceo() {
	    _classCallCheck(this, Ceo);
	
	    return _possibleConstructorReturn(this, (Ceo.__proto__ || Object.getPrototypeOf(Ceo)).apply(this, arguments));
	  }
	
	  _createClass(Ceo, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'section',
	          { className: 'ceo-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-7' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sspp' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Message From The C.E.O '
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s. when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries. '
	                  ),
	                  _react2.default.createElement('img', { src: _sign2.default, alt: 'sign' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5' },
	                _react2.default.createElement('img', { src: _ceo2.default, alt: 'ceo', className: 'ceo-img' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Ceo;
	}(_react.Component);
	
	exports.default = Ceo;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _icon = __webpack_require__(57);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _MyProvider = __webpack_require__(48);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _PopupIndex = __webpack_require__(84);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _PatientRegistrationPopup = __webpack_require__(113);
	
	var _PatientRegistrationPopup2 = _interopRequireDefault(_PatientRegistrationPopup);
	
	var _BookAppointmentParticularDoctorPopUp = __webpack_require__(142);
	
	var _BookAppointmentParticularDoctorPopUp2 = _interopRequireDefault(_BookAppointmentParticularDoctorPopUp);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Department = function Department(_ref) {
	  var departments = _ref.departments,
	      doctors = _ref.doctors,
	      handleChange = _ref.handleChange;
	
	  // console.log(doctors, "doctors")
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      departmentData = _useState2[0],
	      setDepartmentData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      doctorsData = _useState4[0],
	      setDoctorsData = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      doctorsDetails = _useState6[0],
	      setDoctorsDetails = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      showLoginPopup = _useState8[0],
	      setShowLoginPopup = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      patientRegPopup = _useState10[0],
	      setPatientRegPopup = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(""),
	      _useState12 = _slicedToArray(_useState11, 2),
	      showPatientRegPopup = _useState12[0],
	      setShowPatientRegPopup = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      showthirdpopup = _useState14[0],
	      setShowThirdPopup = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      showDoctorSearchPopup = _useState16[0],
	      setShowDoctorSearchPopup = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      doctorName = _useState18[0],
	      setDoctorName = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(),
	      _useState20 = _slicedToArray(_useState19, 2),
	      filterdoctorsData = _useState20[0],
	      setFilterDoctorsData = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(null),
	      _useState22 = _slicedToArray(_useState21, 2),
	      selectedDoctor = _useState22[0],
	      setSelectedDoctor = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(1),
	      _useState24 = _slicedToArray(_useState23, 2),
	      step = _useState24[0],
	      setStep = _useState24[1];
	
	  var _useContext = (0, _react.useContext)(_MyProvider.MyContext),
	      DoctorData = _useContext.DoctorData;
	
	  (0, _react.useEffect)(function () {
	    if (departments.length > 0) setFilterDoctorsData(departments[0].dept_id);
	  }, [departments]);
	
	  (0, _react.useEffect)(function () {
	    var getFilterDoctors = function getFilterDoctors() {
	      if (filterdoctorsData) {
	        var req = _.scAxiosAdmin.request("/bodypart/getbodypartdepartmentdoctors?bodyDeptId=" + filterdoctorsData, {
	          method: "get",
	          headers: {
	            Accept: "application/json",
	            Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	          }
	        });
	        req.then(function (response) {
	          // Handle successful response here
	
	          // console.log(response, "filterData")
	          setDoctorsDetails(response.data.data);
	        }).catch(function (error) {
	          // Handle error here
	          console.error("Error:", error);
	        });
	      }
	
	      /* .then((res) => setNewsEventData(res.data) console.log('your log output',res))
	              .catch((err) => console.log("your log output", err)); */
	    };
	    getFilterDoctors();
	  }, [filterdoctorsData]);
	  (0, _react.useEffect)(function () {
	    var getAllDepartments = function getAllDepartments() {
	      var req = _.scAxiosAdmin.request("/department/getdepartments", {
	        method: "get",
	        headers: {
	          Accept: "application/json",
	          Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	        }
	      });
	      req.then(function (response) {
	        // Handle successful response here
	
	        setDepartmentData(response.data.data);
	      }).catch(function (error) {
	        // Handle error here
	        console.error("Error:", error);
	      });
	      /* .then((res) => setNewsEventData(res.data) console.log('your log output',res))
	              .catch((err) => console.log("your log output", err)); */
	    };
	    getAllDepartments();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var getAllDoctors = function getAllDoctors() {
	      var req = _.scAxiosAdmin.request("/doctors/getalldoctors", {
	        method: "get",
	        headers: {
	          Accept: "application/json",
	          Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	        }
	      });
	      req.then(function (response) {
	        // Handle successful response here
	        //   console.log(response,"doctors")
	        setDoctorsData(response.data.data.data);
	      }).catch(function (error) {
	        // Handle error here
	        console.error("Error:", error);
	      });
	      /* .then((res) => setNewsEventData(res.data) console.log('your log output',res))
	              .catch((err) => console.log("your log output", err)); */
	    };
	    getAllDoctors();
	  }, []);
	  var closePopup = function closePopup() {
	    undefined.setState({ isPopupOpen: false });
	  };
	  var nextStep = function nextStep(e) {
	    setStep(function (prev) {
	      return prev + 1;
	    });
	  };
	  var prevStep = function prevStep(e) {
	    /* this.setState({
	      step: this.state.step - 1,
	      showthirdpopup: "offcanvas offcanvas-start show",
	    }); */
	    setStep(function (prev) {
	      return prev + 1;
	    });
	  };
	
	  var handlerId = function handlerId(id) {
	    setFilterDoctorsData(id);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "h-100" },
	    _react2.default.createElement(
	      "div",
	      { className: "our-departments excellenceWrapper" },
	      _react2.default.createElement(
	        "div",
	        { className: "row h-100" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-6 d-flex flex-column justify-content-between h-100 departmentWrapper" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "" + (_reactDeviceDetect.isMobile || _reactDeviceDetect.isTablet ? "mt-5" : ""),
	              style: {
	                marginBottom: "10px"
	              }
	            },
	            _react2.default.createElement(
	              "h3",
	              {
	                className: "text-left",
	                style: {
	                  color: "#af9763",
	                  fontSize: "28px",
	                  fontWeight: "500"
	                }
	              },
	              "Departments"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "row justify-content-start departmentsContainer",
	              style: {
	                // height: `${!isMobile ? "555px" : ""}${
	                //   !isTablet ? "555px" : ""
	                // }`,
	                overflowY: "auto", // Vertical scroll remains
	                overflowX: "auto" // Enable horizontal scroll
	                // flexWrap: isMobile ? "nowrap" : "wrap", // Prevent wrapping for horizontal scroll
	              }
	            },
	            departments.length > 0 ? departments.map(function (body_department) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  className: (departments.length > 2 ? "col-8 " : "col-12") + " col-md-6 pt-3 ",
	                  style: { flex: "0 0 auto" } // Prevent wrapping and give the same width to each item
	                  , key: body_department.id
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    // className="p-3 make-orange"
	                    className: "p-3",
	                    style: {
	                      width: "100%",
	                      height: "114px",
	                      display: "flex",
	                      justifyContent: "center",
	                      alignItems: "center",
	                      borderRadius: "16px",
	
	                      backgroundColor: filterdoctorsData === body_department.dept_id ? "#f4d69d" : "#E6DFCF",
	                      // color:
	                      //   filterdoctorsData === body_department.dept_id
	                      //     ? "#FFFFFF"
	                      //     : "#000000",
	                      color: "#000000",
	                      cursor: "pointer"
	                    },
	                    onClick: function onClick() {
	                      return handlerId(body_department.dept_id);
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "row d-flex align-items-center flex-column justify-content-center",
	                      name: "body_dept_id",
	                      value: body_department.dept_id
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-12 d-flex align-items-center justify-content-center" },
	                      body_department.image ? _react2.default.createElement("img", {
	                        src: _constants.IMAGE_URL + "DepartmentImage/" + body_department.image,
	                        alt: "avtars",
	                        style: { width: "27.42px" }
	                      }) : _react2.default.createElement("img", {
	                        src: _icon2.default,
	                        alt: "Bitmap-3",
	                        style: { width: "27.42px" }
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-12 mt-1" },
	                      _react2.default.createElement(
	                        "p",
	                        {
	                          style: {
	                            fontWeight: "500",
	                            letterSpacing: "1px",
	                            textAlign: "center",
	                            fontSize: "13px"
	                          }
	                        },
	                        body_department.department_name
	                      )
	                    )
	                  )
	                )
	              );
	            }) : departmentData.slice(0, 8).map(function (body_department) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  className: (departmentData.length > 2 ? "col-8 " : "col-12") + " col-md-6 pt-3 ",
	                  style: { flex: "0 0 auto" },
	                  key: body_department.id
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    // className="p-3 make-orange"
	                    className: "p-3",
	                    style: {
	                      width: "100%",
	                      height: "114px",
	                      display: "flex",
	                      justifyContent: "center",
	                      alignItems: "center",
	                      borderRadius: "16px",
	                      backgroundColor: filterdoctorsData === body_department.dept_id ? "#f4d69d" : "#E6DFCF",
	                      // color:
	                      //   filterdoctorsData === body_department.dept_id
	                      //     ? "#FFFFFF"
	                      //     : "#000000",
	                      color: "#000000",
	                      cursor: "pointer"
	                    },
	                    onClick: function onClick() {
	                      return handlerId(body_department.dept_id);
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row d-flex align-items-center flex-column justify-content-center" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-12 d-flex align-items-center justify-content-center" },
	                      body_department.image ? _react2.default.createElement("img", {
	                        src: _constants.IMAGE_URL + "DepartmentImage/" + body_department.image,
	                        alt: "avtars",
	                        style: { width: "27.42px" }
	                      }) : _react2.default.createElement("img", {
	                        src: _icon2.default,
	                        alt: "Bitmap-3",
	                        style: { width: "27.42px" }
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-12 mt-1" },
	                      _react2.default.createElement(
	                        "p",
	                        {
	                          style: {
	                            fontWeight: "500",
	                            letterSpacing: "1px",
	                            textAlign: "center",
	                            fontSize: "13px"
	                          }
	                        },
	                        body_department.department_name
	                      )
	                    )
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-6 d-flex flex-column justify-content-between h-100" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "" + (_reactDeviceDetect.isMobile ? "mt-5" : ""),
	              style: {
	                marginBottom: "10px"
	              }
	            },
	            _react2.default.createElement(
	              "h3",
	              {
	                className: "text-start w-100",
	                style: {
	                  color: "#af9763",
	                  fontSize: "28px",
	                  fontWeight: "500"
	                }
	              },
	              "Doctors"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "row justify-content-start departmentsContainer",
	              style: {
	                overflowY: "auto", // Vertical scroll remains
	                overflowX: "auto" // Enable horizontal scroll
	              }
	            },
	            doctorsDetails.length > 0 ? doctorsDetails.map(function (body_department) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  className: (doctorsDetails.length > 2 ? "col-10" : "col-12") + " col-md-12 pt-3",
	                  key: body_department.id
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "card",
	                    style: {
	                      backgroundColor: "#E6DFCF",
	                      borderRadius: "16px"
	                      // height: "157px",
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card-body d-flex " },
	                    body_department.doctor_profile ? _react2.default.createElement("img", {
	                      src: _constants.IMAGE_URL + "DoctorProfileImg/" + body_department.doctor_profile,
	                      alt: "doctor profile",
	                      style: {
	                        width: "70px",
	                        borderRadius: "100px",
	                        height: "70px",
	                        objectFit: "cover",
	                        objectPosition: "top"
	                      }
	                    }) : _react2.default.createElement("img", {
	                      src: _icon2.default,
	                      alt: "Bitmap-3",
	                      style: {
	                        width: "27.42px",
	                        objectFit: "cover",
	                        objectPosition: "top"
	                      }
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "px-2" },
	                      _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        {
	                          className: "text-decoration-none",
	                          to: "/consultant/" + body_department.slug
	                        },
	                        _react2.default.createElement(
	                          "h3",
	                          {
	                            className: "doctorName",
	                            title: body_department.doctor_name,
	                            style: {
	                              fontSize: "22px",
	                              textTransform: "capitalize",
	                              textAlign: "left"
	                            }
	                          },
	                          body_department.doctor_name.slice(0, 17),
	                          "..."
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "h3",
	                        {
	                          className: "doctordpts",
	                          style: {
	                            fontSize: "14px",
	                            textTransform: "capitalize",
	                            textAlign: "left"
	                          }
	                        },
	                        body_department.department_mave ? body_department.department_mave.department_name : body_department.department_name
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        {
	                          className: "doctordscr",
	                          style: {
	                            fontWeight: "400",
	                            letterSpacing: "1px",
	                            textAlign: "left",
	                            fontSize: "12px"
	                          }
	                        },
	                        body_department.degree ? body_department.degree.slice(0, 26) : ""
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        display: "flex",
	                        justifyContent: "flex-end",
	                        alignItems: "flex-end",
	                        width: "100%",
	                        paddingBottom: "10px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "a",
	                      null,
	                      localStorage.getItem(_constants.USER_LOCAL_ID) ? _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          style: {
	                            fontSize: _reactDeviceDetect.isMobile ? "12px" : "18px",
	                            padding: "5px 20px",
	                            backgroundColor: "#AF9763",
	                            color: "#fff",
	                            textTransform: "capitalize",
	                            border: "none",
	                            borderRadius: "6px",
	                            fontWeight: "bold",
	                            marginRight: "15px"
	                          },
	                          onClick: function onClick() {
	                            return setSelectedDoctor(body_department);
	                          },
	                          "data-bs-toggle": "offcanvas",
	                          "data-bs-target": "#BookAppointMentParticularDoctorPopUp",
	                          "aria-controls": "BookAppointMentParticularDoctorPopUp"
	                        },
	                        "Book Now"
	                      ) : _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          style: {
	                            fontSize: _reactDeviceDetect.isMobile ? "12px" : "18px",
	                            padding: "5px 20px",
	                            backgroundColor: "#AF9763",
	                            color: "#fff",
	                            textTransform: "capitalize",
	                            border: "none",
	                            borderRadius: "6px",
	                            fontWeight: "bold",
	                            marginRight: "15px"
	                          },
	                          href: "#offcanvasExample",
	                          "data-bs-toggle": "offcanvas",
	                          role: "button",
	                          "aria-controls": "offcanvasExample"
	                        },
	                        "Book Now"
	                      )
	                    )
	                  )
	                )
	              );
	            }) : doctorsData.map(function (body_department) {
	              // console.log('your log output',doctorsData)
	              return _react2.default.createElement(
	                "div",
	                {
	                  className: (doctorsData.length > 2 ? "col-12" : "col-10") + "col-md-12 pt-3",
	                  key: body_department.id
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "card ",
	                    style: {
	                      backgroundColor: "#E6DFCF",
	                      borderRadius: "16px"
	                      // height: "157px",
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card-body d-flex " },
	                    body_department.doctor_profile ? _react2.default.createElement("img", {
	                      src: _constants.IMAGE_URL + "DoctorProfileImg/" + body_department.doctor_profile,
	                      alt: "doctor profile",
	                      style: {
	                        width: "70px",
	                        borderRadius: "100px",
	                        height: "70px",
	                        objectFit: "cover",
	                        objectPosition: "top"
	                      }
	                    }) : _react2.default.createElement("img", {
	                      src: _icon2.default,
	                      alt: "Bitmap-3",
	                      style: {
	                        width: "27.42px",
	                        objectFit: "cover",
	                        objectPosition: "top"
	                      }
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "px-2" },
	                      _react2.default.createElement(
	                        "h3",
	                        {
	                          className: "doctors doctorName",
	                          title: body_department.doctor_name,
	                          style: {
	                            fontSize: "22px",
	                            textTransform: "capitalize",
	                            textAlign: "left"
	                          }
	                        },
	                        body_department.doctor_name.slice(0, 17),
	                        "..."
	                      ),
	                      _react2.default.createElement(
	                        "h3",
	                        {
	                          className: "doctordpts",
	                          style: {
	                            fontSize: "14px",
	                            textTransform: "capitalize",
	                            textAlign: "left"
	                          }
	                        },
	                        body_department.department_name
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        {
	                          className: "doctordscr",
	                          style: {
	                            fontWeight: "400",
	                            letterSpacing: "1px",
	                            textAlign: "left",
	                            fontSize: "12px"
	                          }
	                        },
	                        body_department.degree ? body_department.degree.slice(0, 26) : ""
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: {
	                        display: "flex",
	                        justifyContent: "flex-end",
	                        alignItems: "flex-end",
	                        width: "97%",
	                        paddingBottom: "10px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "a",
	                      null,
	                      localStorage.getItem(_constants.USER_LOCAL_ID) ? _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          style: {
	                            fontSize: _reactDeviceDetect.isMobile ? "12px" : "18px",
	                            // width: "100px",
	                            height: "40px",
	                            backgroundColor: "#AF9763",
	                            color: "#fff",
	                            textTransform: "capitalize",
	                            border: "none",
	                            borderRadius: "6px",
	                            fontWeight: "bold",
	                            padding: "5px 20px",
	                            marginRight: "15px"
	                          },
	                          onClick: function onClick() {
	                            return setSelectedDoctor(body_department);
	                          },
	                          "data-bs-toggle": "offcanvas",
	                          "data-bs-target": "#BookAppointMentParticularDoctorPopUp",
	                          "aria-controls": "BookAppointMentParticularDoctorPopUp"
	                        },
	                        "Book Now"
	                      ) : _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          style: {
	                            fontSize: _reactDeviceDetect.isMobile ? "12px" : "18px",
	                            // width: "100px",
	                            height: "40px",
	                            backgroundColor: "#AF9763",
	                            color: "#fff",
	                            textTransform: "capitalize",
	                            border: "none",
	                            borderRadius: "6px",
	                            fontWeight: "bold",
	                            padding: "5px 20px",
	                            marginRight: "15px"
	                          },
	                          href: "#offcanvasExample",
	                          "data-bs-toggle": "offcanvas",
	                          role: "button",
	                          "aria-controls": "offcanvasExample"
	                        },
	                        "Book Now"
	                      )
	                    )
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_BookAppointmentParticularDoctorPopUp2.default, {
	      doctorData: selectedDoctor,
	      setSelectedDoctor: setSelectedDoctor
	    })
	  );
	};
	
	exports.default = Department;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _fa = __webpack_require__(62);
	
	var _iconsRotate = __webpack_require__(107);
	
	var _iconsRotate2 = _interopRequireDefault(_iconsRotate);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _HomeSlider = __webpack_require__(676);
	
	var _HomeSlider2 = _interopRequireDefault(_HomeSlider);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _FindDoctorAndDepartmentPopup = __webpack_require__(625);
	
	var _FindDoctorAndDepartmentPopup2 = _interopRequireDefault(_FindDoctorAndDepartmentPopup);
	
	var _SendUsInquiry = __webpack_require__(659);
	
	var _SendUsInquiry2 = _interopRequireDefault(_SendUsInquiry);
	
	var _BookAppointmentPopup = __webpack_require__(60);
	
	var _BookAppointmentPopup2 = _interopRequireDefault(_BookAppointmentPopup);
	
	var _PopupIndex = __webpack_require__(65);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeSearchUp = function HomeSearchUp(_ref) {
	  var departments = _ref.departments,
	      banners = _ref.banners,
	      findADoctorPopupClicked = _ref.findADoctorPopupClicked,
	      bookAppointmentPopupClicked = _ref.bookAppointmentPopupClicked,
	      setDepartments = _ref.setDepartments,
	      setBanners = _ref.setBanners,
	      setFindADoctorPopupClicked = _ref.setFindADoctorPopupClicked,
	      setBookAppointmentPopupClicked = _ref.setBookAppointmentPopupClicked,
	      hoverId = _ref.hoverId,
	      setHoverId = _ref.setHoverId;
	
	  // const [departments, setDepartments] = useState([]);
	  // const [banners, setBanners] = useState([]);
	  // const [findADoctorPopupClicked, setFindADoctorPopupClicked] = useState(false);
	  // const [bookAppointmentPopupClicked, setBookAppointmentPopupClicked] =
	  //   useState(false);
	  // useEffect(() => {
	  //   const getAllBannerButtonData = (data) => {
	  //     try {
	  //       const req = scAxiosAdmin
	  //         .request("/bannerbutton/getallbannerbtndata", {
	  //           method: "get",
	  //           headers: {
	  //             Accept: "application/json",
	  //             Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
	  //           },
	  //           params: {
	  //             ...data,
	  //           },
	  //         })
	  //         .then((data) => {
	  //           if (data.status === 200) {
	  //             setDepartments(data.data.data);
	  //           }
	  //         })
	  //         .catch((e) => {
	  //           console.log("your log output", e);
	  //         });
	  //     } catch (error) {}
	  //   };
	  //   getAllBannerButtonData();
	  // }, []);
	  // useEffect(() => {
	  //   const getAllBanner = (data) => {
	  //     try {
	  //       const req = scAxiosAdmin
	  //         .request("/banner", {
	  //           method: "get",
	  //         })
	  //         .then((data) => {
	  //           if (data.status === 200) {
	  //             setBanners(data.data);
	  //           }
	  //         })
	  //         .catch((e) => {
	  //           console.log("your log output", e);
	  //         });
	  //     } catch (error) {}
	  //   };
	  //   getAllBanner();
	  // }, []);
	  // console.log("dafdsf", banners);
	  return _react2.default.createElement(
	    "div",
	    { className: "pt-0 pt-lg-4" },
	    _react2.default.createElement(
	      "div",
	      { className: "row" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-12" },
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex flex-column-reverse flex-lg-row gap-3 gap-lg-1" },
	          _react2.default.createElement(
	            "div",
	            {
	              style: { backgroundColor: "#F7F5EF" },
	              className: "card h-100 d-flex flex-lg-column flex-row homeBannerTabs justify-content-between gap-2 border-0 shadow-none"
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "h-100 d-flex justify-content-center flex-column align-items-center sideButtonMenu make-orange py-5",
	                style: {
	                  backgroundColor: "#AF9763",
	
	                  borderRadius: "5px",
	                  cursor: "pointer"
	                },
	                "data-bs-toggle": "offcanvas",
	                "data-bs-target": "#FindADoctorCanvas",
	                "aria-controls": "FindADoctorCanvas",
	                onClick: function onClick() {
	                  return setFindADoctorPopupClicked(true);
	                }
	              },
	              _react2.default.createElement("img", { src: "/assets/images/profile.png", alt: "", className: "pb-2" }),
	              _react2.default.createElement(
	                "h5",
	                {
	                  className: "pb-0 mb-0",
	                  style: {
	                    width: "fit-content",
	                    color: "#fff"
	                  }
	                },
	                "Find a Doctor"
	              )
	            ),
	            localStorage.getItem(_constants.USER_LOCAL_ID) ? _react2.default.createElement(
	              "div",
	              {
	                className: "h-100 d-flex justify-content-center flex-column align-items-center sideButtonMenu make-orange py-5",
	                style: {
	                  backgroundColor: "#AF9763",
	
	                  borderRadius: "5px",
	                  cursor: "pointer"
	                },
	                role: "button",
	                "data-bs-toggle": "offcanvas",
	                "data-bs-target": "#BookAppointMent",
	                "aria-controls": "BookAppointMent",
	                onClick: function onClick() {
	                  return setBookAppointmentPopupClicked(true);
	                }
	              },
	              _react2.default.createElement("img", {
	                src: "/assets/images/calender.png",
	                alt: "",
	                className: "pb-2"
	              }),
	              _react2.default.createElement(
	                "h5",
	                {
	                  className: "pb-0 mb-0",
	                  style: {
	                    width: "fit-content",
	                    color: "#fff"
	                  }
	                },
	                "Book Appointment"
	              )
	            ) : _react2.default.createElement(
	              "div",
	              {
	                className: "h-100 d-flex justify-content-center flex-column align-items-center sideButtonMenu make-orange py-5",
	                style: {
	                  backgroundColor: "#AF9763",
	
	                  borderRadius: "5px",
	                  cursor: "pointer"
	                }
	                // data-bs-toggle="offcanvas"
	                // data-bs-target="#BookAppointMent"
	                // aria-controls="BookAppointMent"
	                // className="dropdown-item"
	                , href: "#offcanvasExample",
	                "data-bs-toggle": "offcanvas",
	                role: "button",
	                "aria-controls": "offcanvasExample"
	              },
	              _react2.default.createElement("img", {
	                src: "/assets/images/calender.png",
	                alt: "",
	                className: "pb-2"
	              }),
	              _react2.default.createElement(
	                "h5",
	                {
	                  className: "pb-0 mb-0",
	                  style: {
	                    width: "fit-content",
	                    color: "#fff"
	                  }
	                },
	                "Book Appointment"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "h-100 d-flex justify-content-center flex-column align-items-center sideButtonMenu make-orange py-5",
	                style: {
	                  backgroundColor: "#AF9763",
	
	                  borderRadius: "5px",
	                  cursor: "pointer"
	                },
	                "data-bs-toggle": "offcanvas",
	                "data-bs-target": "#SendUsInquiry",
	                "aria-controls": "SendUsInquiry"
	              },
	              _react2.default.createElement("img", { src: "/assets/images/plus.png", alt: "", className: "pb-2" }),
	              _react2.default.createElement(
	                "h5",
	                {
	                  className: "pb-0 mb-0",
	                  style: {
	                    width: "fit-content",
	                    color: "#fff"
	                  }
	                },
	                "Send us an Inquiry"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "homeBanner" },
	            _react2.default.createElement(_HomeSlider2.default, { banners: banners })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          className: "col-12 d-flex flex-column justify-content-center align-items-center mt-4 d-none d-md-block",
	          style: { maxWidth: "100%" }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "d-flex flex-row justify-content-between align-items-center mt-3 p-2 w-100 gap-3 overflow-auto",
	            style: {
	              backgroundColor: "#FFFFFF",
	              borderRadius: "5px"
	            }
	          },
	          departments.length > 0 ? departments.slice(0, 6).map(function (banner_button) {
	            var buttonSlug = banner_button.department_name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\\/]/gi, "").replace(/\s+/g, "-").replace(/-$/, "").toLowerCase();
	
	            return _react2.default.createElement(
	              "div",
	              { className: "p-0 department-menu" },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: _constants.SITE_URL + "/departments/" + buttonSlug,
	                  style: { textDecoration: "none" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "card cardHover",
	                    style: {
	                      width: "100%",
	                      margin: "0 auto",
	                      height: "45px",
	                      display: "flex",
	                      justifyContent: "center",
	                      borderRadius: "5px",
	                      backgroundColor: "#F7F5EF",
	                      // color: "#AF9763",
	                      fontWeight: "500"
	                    },
	                    onMouseEnter: function onMouseEnter() {
	                      return setHoverId(banner_button.id);
	                    },
	                    onMouseLeave: function onMouseLeave() {
	                      return setHoverId(null);
	                    },
	                    onTouchStart: function onTouchStart() {
	                      return setHoverId(banner_button.id);
	                    } // Works on mobile
	                    , onTouchCancel: function onTouchCancel() {
	                      return setHoverId(null);
	                    } // Optional: Hide on touch end
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "p-2 d-flex justify-content-center align-items-center w-100",
	                      style: {
	                        display: "flex",
	                        alignItems: "center",
	                        justifyContent: "center"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "" },
	                      banner_button.banner_btn_icon ? _react2.default.createElement("img", {
	                        // className="ql-background"
	                        src: _constants.IMAGE_URL + "BannerButtonImg/" + (hoverId === banner_button.id && banner_button.banner_btn_hover_icon ? banner_button.banner_btn_hover_icon : banner_button.banner_btn_icon),
	                        alt: "avtars",
	                        style: {
	                          borderRadius: "50%",
	                          width: "100%",
	                          maxWidth: "27px"
	                        }
	                      }) : _react2.default.createElement("i", { className: "fa-solid fa-circle-right" })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "px-2" },
	                      banner_button.banner_btn_text
	                    )
	                  )
	                )
	              )
	            );
	          }) : "",
	          _react2.default.createElement(
	            "div",
	            { className: "p-0 department-menu d-none d-lg-block" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                className: "d-inline-block w-100",
	                style: { textDecoration: "none" },
	                to: "/pages/departments"
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "card ",
	                  style: {
	                    width: "100%",
	                    margin: "0 auto",
	                    height: "45px",
	                    display: "flex",
	                    justifyContent: "center",
	                    borderRadius: "5px",
	                    backgroundColor: "#AF9763",
	                    color: "#ffffff",
	                    fontWeight: "500"
	                  }
	                },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    style: {
	                      padding: "11px",
	                      color: "#fff",
	                      textTransform: "capitalize",
	                      border: "none",
	                      backgroundColor: "transparent",
	                      borderRadius: "6px",
	                      fontWeight: "500",
	                      width: "100%"
	                    },
	                    className: "deptBtnFont"
	                  },
	                  "View All Departments"
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-12 d-flex justify-content-center align-items-center mb-2 w-100  d-none d-md-block" },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "py-3 department-menu d-block d-lg-none w-100 text-center",
	            style: {
	              backgroundColor: "#ffffff",
	              borderBottomRightRadius: "5px",
	              borderBottomLeftRadius: "5px"
	            }
	          },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              className: "d-inline-block w-50",
	              style: { textDecoration: "none" },
	              to: "/pages/departments"
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "card ",
	                style: {
	                  width: "100%",
	                  margin: "0 auto",
	                  height: "45px",
	                  display: "flex",
	                  justifyContent: "center",
	                  borderRadius: "5px",
	                  backgroundColor: "#AF9763",
	                  color: "#ffffff",
	                  fontWeight: "500"
	                }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  style: {
	                    padding: "11px",
	                    color: "#fff",
	                    textTransform: "capitalize",
	                    border: "none",
	                    backgroundColor: "transparent",
	                    borderRadius: "6px",
	                    fontWeight: "500",
	                    width: "100%"
	                  },
	                  className: "deptBtnFont"
	                },
	                "View All Departments"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_FindDoctorAndDepartmentPopup2.default, {
	      findADoctorPopupClicked: findADoctorPopupClicked,
	      setFindADoctorPopupClicked: setFindADoctorPopupClicked
	    }),
	    _react2.default.createElement(_SendUsInquiry2.default, null),
	    _react2.default.createElement(_BookAppointmentPopup2.default, {
	      bookAppointmentPopupClicked: bookAppointmentPopupClicked,
	      setBookAppointmentPopupClicked: setBookAppointmentPopupClicked
	    }),
	    _react2.default.createElement(_PopupIndex2.default, null)
	  );
	};
	
	exports.default = HomeSearchUp;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(238);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeSlider = function HomeSlider(_ref) {
	  var banners = _ref.banners;
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      activeIndex = _useState2[0],
	      setActiveIndex = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      initializer = _useState4[0],
	      setInitializer = _useState4[1];
	
	  var goToIndex = function goToIndex(index) {
	    if (index < 0) {
	      index = banners.length - 1; // Go to the last slide if it's less than 0
	    } else if (index >= banners.length) {
	      index = 0; // Go to the first slide if it exceeds the length
	    }
	    setActiveIndex(index);
	  };
	  var nextSlide = function nextSlide() {
	    goToIndex(activeIndex + 1);
	  };
	
	  setTimeout(function () {
	    setInitializer(true);
	  }, 5000);
	  // Automatically transition to the next slide
	  (0, _react.useEffect)(function () {
	    var interval = setInterval(function () {
	      nextSlide();
	    }, 3000); // Change slide every 3 seconds
	
	    return function () {
	      return clearInterval(interval);
	    }; // Clean up the interval on component unmount
	  }, [activeIndex, initializer]);
	
	  /* onst nextSlide = () => {
	    goToIndex(activeIndex + 1);
	  }; */
	
	  var prevSlide = function prevSlide() {
	    goToIndex(activeIndex - 1);
	  };
	  return _react2.default.createElement(
	    "div",
	    {
	      id: "carouselExampleIndicators",
	      className: "carousel slide vertical h-100"
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "carousel-inner h-100", style: { borderRadius: "5px" } },
	      banners.map(function (item, index) {
	        return _react2.default.createElement(
	          "div",
	          {
	            key: item.id,
	            className: "carousel-item h-100 " + (index === activeIndex ? "active" : "")
	          },
	          _react2.default.createElement("img", {
	            style: {
	              width: "100%",
	              height: "100%",
	              maxHeight: "574px",
	              objectFit: "cover"
	            }
	            // src={`/assets/images/new_bgc.jpg`}
	            , src: "" + _constants.IMAGE_URL + (item ? item.image_path : ""),
	            alt: "",
	            className: "img-fluid"
	          })
	        );
	      }),
	      _react2.default.createElement(
	        "ol",
	        { className: "carousel-indicators" },
	        banners.map(function (item, index) {
	          return _react2.default.createElement(
	            "div",
	            {
	              key: item.id,
	              className: "d-flex justify-content-center align-items-center mb-1",
	              style: {
	                width: "20px",
	                height: "20px",
	                borderRadius: "50%",
	                border: index === activeIndex ? "1px solid #AF9763" : "",
	                backgroundColor: "transparent",
	                cursor: "pointer"
	              },
	              onClick: function onClick() {
	                return goToIndex(index);
	              }
	            },
	            _react2.default.createElement("li", {
	              style: {
	                backgroundColor: index === activeIndex ? "#AF9763" : "#fff"
	              }
	            })
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = HomeSlider;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _updated_jci = __webpack_require__(442);
	
	var _updated_jci2 = _interopRequireDefault(_updated_jci);
	
	var _jci = __webpack_require__(179);
	
	var _jci2 = _interopRequireDefault(_jci);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var JCI = function JCI() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchdata = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    fetchData(); // Initial data fetch
	  }, []);
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/settings/2");
	
	            case 3:
	              response = _context.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                setFatchdata(response.data);
	                // setLoading(false);
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "section",
	      {
	        style: { backgroundColor: "#F7F5EF" },
	        className: "news-events pt-0 pb-0",
	        id: "hr-lines"
	      },
	      _react2.default.createElement(
	        "div",
	        {
	          style: {
	            display: "flex",
	            justifyContent: "flex-start",
	            alignItems: "flex-start",
	            flexDirection: "column",
	            marginBottom: "10px"
	          }
	        },
	        _react2.default.createElement(
	          "h3",
	          {
	            className: "text-left",
	            style: {
	              color: "#af9763",
	              fontSize: "30px",
	              fontWeight: "600",
	              textAlign: "center",
	              width: "100%"
	            }
	          },
	          "News"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          className: "container jci jciContainer pb-3",
	          style: {
	            // backgroundImage: `url(${jci})`,
	
	            // height: "500px",
	            width: "100%",
	            display: "flex",
	            alignItems: "center",
	            justifyContent: "center"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "row jci-row justify-content-between",
	            style: { width: "100%", margin: "0 auto" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-5 jci-content" },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.dhakatribune.com/business/323389/united-hospital-attains-jci-accreditation",
	                target: "_blank",
	                style: { textDecoration: "none" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "div1",
	                  style: {
	                    display: "flex",
	                    flexDirection: "column",
	                    justifyContent: "space-between",
	                    alignItems: "flex-start"
	                    // maxWidth: "300px",
	                    // width: "100%",
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "jciImg mb-3" },
	                  _react2.default.createElement("img", {
	                    style: { borderRadius: "5px", width: "100%" }
	                    // className="img-2"
	                    , src: "/assets/images/jci_img.jpg",
	                    alt: ""
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "" },
	                  _react2.default.createElement(
	                    "h3",
	                    { className: "fw-normal" },
	                    "United Hospital attains JCI accreditation"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "jci_text" },
	                  _react2.default.createElement(
	                    "p",
	                    { className: "mb-2" },
	                    "A remarkable feat in healthcare excellence"
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      style: {
	                        backgroundColor: "#0c807d",
	                        padding: "3px 5px",
	                        color: "#ffffff",
	                        borderRadius: "5px"
	                      }
	                    },
	                    "Read More"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-lg-7 videoContainer",
	              style: {
	                display: "flex",
	                justifyContent: "flex-start",
	                alignItems: "flex-start"
	                // maxWidth: "500px",
	              }
	            },
	            _react2.default.createElement("div", {
	              style: {
	                display: "flex",
	                justifyContent: "flex-end",
	                alignItems: "flex-end",
	                flexDirection: "column",
	                width: "100%",
	                height: "100%"
	              },
	              dangerouslySetInnerHTML: { __html: fatchdata.value }
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = JCI;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _updated_jci = __webpack_require__(442);
	
	var _updated_jci2 = _interopRequireDefault(_updated_jci);
	
	var _jci = __webpack_require__(179);
	
	var _jci2 = _interopRequireDefault(_jci);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _fa = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var NewJciComponent = function NewJciComponent() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      fatchdata = _useState2[0],
	      setFatchdata = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    fetchData(); // Initial data fetch
	  }, []);
	  var fetchData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _.thirdparty.get("/settings/2");
	
	            case 3:
	              response = _context.sent;
	              // Update the API endpoint
	
	              if (response.status === 200) {
	                setFatchdata(response.data);
	                // setLoading(false);
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.error("Error fetching data:", _context.t0.message);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function fetchData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "section",
	      {
	        style: { backgroundColor: "#F7F5EF" },
	        className: "news-events pt-0 pb-0",
	        id: "hr-lines"
	      },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "pb-3",
	          style: {
	            display: "flex",
	            justifyContent: "flex-start",
	            alignItems: "flex-start",
	            flexDirection: "column",
	            marginBottom: "10px"
	          }
	        },
	        _react2.default.createElement(
	          "h3",
	          {
	            className: "text-left",
	            style: {
	              color: "#af9763",
	              fontSize: "30px",
	              fontWeight: "600",
	              textAlign: "center",
	              width: "100%"
	            }
	          },
	          "News"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          style: { position: "relative" },
	          className: "container d-none mt-5 py-2 d-lg-flex justify-content-between align-items-center justify-content-between gap-1"
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            "class": "",
	            style: {
	              position: "absolute",
	              left: "49.5%",
	              top: "50%",
	              transform: "translate(-50%,-50%)"
	            }
	          },
	          _react2.default.createElement("img", {
	            className: "img-fluid",
	            src: "/assets/images/jci_updated_circular.png",
	            alt: "",
	            srcset: ""
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "w-50 jci-left-container" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "h-100 d-flex flex-column justify-content-center ps-5 align-items-start gap-3",
	              style: {
	                borderRadius: "20px",
	                backgroundImage: "url(/assets/images/jci_left_shape_1.png)",
	                backgroundSize: "cover",
	                backgroundPosition: "center",
	                backgroundRepeat: "no-repeat"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: { width: "90%" },
	                className: "d-flex justify-content-between align-items-center"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex jsutify-content-center align-items-center w-50 gap-3" },
	                _react2.default.createElement("img", {
	                  className: "jci-brand-img"
	                  // style={{ maxWidth: "78px" }}
	                  , src: "/assets/images/united_logo.png",
	                  alt: "",
	                  srcset: ""
	                }),
	                _react2.default.createElement("img", {
	                  className: "jci-brand-img"
	                  // style={{ maxWidth: "78px" }}
	                  , src: "/assets/images/united_logo_health.png",
	                  alt: "",
	                  srcset: ""
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      height: "40px",
	                      width: "150px",
	                      backgroundColor: "#AF9763",
	                      borderRadius: "5px"
	                    },
	                    className: "d-flex justify-content-around align-items-center"
	                  },
	                  _react2.default.createElement("img", { src: "/assets/images/calendar-header.png", alt: "" }),
	                  _react2.default.createElement(
	                    "h6",
	                    { className: "mb-0 text-white" },
	                    "03, Mar 2023"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex justify-content-start align-items-center w-75" },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "https://www.dhakatribune.com/business/323389/united-hospital-attains-jci-accreditation",
	                  target: "_blank",
	                  style: { textDecoration: "none" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "",
	                    style: {
	                      display: "flex",
	                      flexDirection: "column",
	                      justifyContent: "space-between",
	                      alignItems: "flex-start"
	                      // maxWidth: "300px",
	                      // width: "100%",
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mb-3" },
	                    _react2.default.createElement("img", {
	                      style: { borderRadius: "5px" },
	                      className: "jci-img-news",
	                      src: "/assets/images/jci_img.jpg",
	                      alt: ""
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex flex-column gap-1" },
	                    _react2.default.createElement(
	                      "p",
	                      { className: "jci-heading fw-normal" },
	                      "United Hospital attains JCI accreditation"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "mb-2" },
	                      "A remarkable feat in healthcare excellence"
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      {
	                        style: {
	                          maxWidth: "130px",
	                          backgroundColor: "#AF9763",
	                          padding: "8px 15px",
	                          color: "#ffffff",
	                          borderRadius: "5px",
	                          textAlign: "center"
	                        }
	                      },
	                      "Read More"
	                    )
	                  ),
	                  _react2.default.createElement("div", { className: "" })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "w-50 jci-right-container d-flex justify-content-center align-items-center",
	            style: {
	              backgroundImage: "url(/assets/images/jci_top_video_img_update.png)",
	              backgroundSize: "cover",
	              backgroundPosition: "center",
	              backgroundRepeat: "no-repeat",
	              borderRadius: "10px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "d-flex justify-content-center align-items-center",
	              style: {
	                height: "80px",
	                width: "80px",
	                borderRadius: "50%",
	                backgroundColor: "#3c3c3c8f"
	              }
	            },
	            _react2.default.createElement(_fa.FaRegPlayCircle, {
	              className: "play-icon",
	              style: {
	                color: "#F58220",
	                fontSize: "60px",
	                cursor: "pointer"
	              },
	              "data-bs-toggle": "modal",
	              "data-bs-target": "#videoModal"
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          style: { position: "relative" },
	          className: "container d-flex py-2 d-lg-none flex-column align-items-center justify-content-between gap-1"
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            "class": "",
	            style: {
	              position: "absolute",
	              left: "49.5%",
	              top: "47%",
	              transform: "translate(-50%,-50%)"
	            }
	          },
	          _react2.default.createElement("img", {
	            // style={{ maxWidth: "160px" }}
	            className: "jci_circular_img",
	            src: "/assets/images/jci_updated_circular.png",
	            alt: "",
	            srcset: ""
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "w-100 jci-right-container d-flex justify-content-center align-items-center",
	            style: {
	              backgroundImage: "url(/assets/images/jci_top_video_img_mobile_top.png)",
	              backgroundSize: "cover",
	              backgroundPosition: "center",
	              backgroundRepeat: "no-repeat",
	              borderRadius: "10px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "d-flex justify-content-center align-items-center",
	              style: {
	                height: "80px",
	                width: "80px",
	                borderRadius: "50%",
	                backgroundColor: "#3c3c3c8f"
	              }
	            },
	            _react2.default.createElement(_fa.FaRegPlayCircle, {
	              className: "play-icon",
	              style: {
	                color: "#F58220",
	                fontSize: "60px",
	                cursor: "pointer"
	              },
	              "data-bs-toggle": "modal",
	              "data-bs-target": "#videoModal"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "jci-left-container" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "h-100 d-flex flex-column  justify-content-around  align-items-start gap-3 gap-md-5 pb-2 pb-sm-0",
	              style: {
	                borderRadius: "20px",
	                backgroundImage: "url(/assets/images/jci_bottom_section_img_1.png)",
	                backgroundSize: "cover",
	                backgroundPosition: "center",
	                backgroundRepeat: "no-repeat"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "w-100 mt-2 px-2 px-md-5 d-flex justify-content-between align-items-center give-padding" },
	              _react2.default.createElement(
	                "div",
	                { className: "d-flex justify-content-start gap-1 align-items-center w-50 gap-3" },
	                _react2.default.createElement("img", {
	                  className: "jci-brand-img"
	                  // style={{ maxWidth: "78px" }}
	                  , src: "/assets/images/united_logo.png",
	                  alt: "",
	                  srcset: ""
	                }),
	                _react2.default.createElement("img", {
	                  className: "jci-brand-img"
	                  // style={{ maxWidth: "78px" }}
	                  , src: "/assets/images/united_logo_health.png",
	                  alt: "",
	                  srcset: ""
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      // height: "20px",
	                      // width: "100px",
	                      // backgroundColor: "#AF9763",
	                      // borderRadius: "5px",
	                    },
	                    className: "d-flex justify-content-around align-items-center date-container"
	                  },
	                  _react2.default.createElement("img", {
	                    className: "calendar-img",
	                    src: "/assets/images/calendar-header.png",
	                    alt: ""
	                  }),
	                  _react2.default.createElement(
	                    "h6",
	                    { className: "mb-0 text-white" },
	                    "03, Mar 2023"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex justify-content-start align-items-center w-100 px-2 px-md-5" },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "https://www.dhakatribune.com/business/323389/united-hospital-attains-jci-accreditation",
	                  target: "_blank",
	                  style: { textDecoration: "none" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "d-flex flex-column flex-sm-row justify-content-between align-items-start gap-sm-3",
	                    style: {
	                      // display: "flex",
	                      // flexDirection: "column",
	                      // justifyContent: "space-between",
	                      // alignItems: "flex-start",
	                      // maxWidth: "300px",
	                      // width: "100%",
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mb-1" },
	                    _react2.default.createElement("img", {
	                      style: { borderRadius: "5px" },
	                      className: "jci-img-news",
	                      src: "/assets/images/jci_img.jpg",
	                      alt: ""
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex flex-column justify-content-between gap-sm-3" },
	                    _react2.default.createElement(
	                      "p",
	                      { className: "jci-heading fw-normal" },
	                      "United Hospital attains JCI accreditation"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "mb-2 jci-text" },
	                      "A remarkable feat in healthcare excellence"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "" },
	                      _react2.default.createElement(
	                        "span",
	                        {
	                          className: "read-more-text",
	                          style: {
	                            // maxWidth: "90px",
	                            // backgroundColor: "#AF9763",
	                            // padding: "4px 10px",
	                            // color: "#ffffff",
	                            // borderRadius: "5px",
	                            // textAlign: "center",
	                            // fontSize: "10px",
	                          }
	                        },
	                        "Read More"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          "class": "modal fade",
	          id: "videoModal",
	          "data-bs-backdrop": "static",
	          "data-bs-keyboard": "false",
	          tabindex: "-1",
	          "aria-labelledby": "staticBackdropLabel",
	          "aria-hidden": "true"
	        },
	        _react2.default.createElement(
	          "div",
	          { "class": "modal-dialog modal-dialog-centered modal-lg" },
	          _react2.default.createElement(
	            "div",
	            { "class": "modal-content" },
	            _react2.default.createElement(
	              "div",
	              { "class": "modal-header" },
	              _react2.default.createElement("button", {
	                type: "button",
	                "class": "btn-close",
	                "data-bs-dismiss": "modal",
	                "aria-label": "Close"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "modal-body" },
	              _react2.default.createElement("div", {
	                style: {
	                  width: "100%",
	                  height: "100%",
	                  borderRadius: "5px",
	                  overflow: "hidden"
	                },
	                dangerouslySetInnerHTML: { __html: fatchdata.value }
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = NewJciComponent;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _new = __webpack_require__(136);
	
	var _new2 = _interopRequireDefault(_new);
	
	var _reactSlick = __webpack_require__(63);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	var _newsEventsModule = __webpack_require__(87);
	
	var _newsEventsModule2 = _interopRequireDefault(_newsEventsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getNewsEvents = function getNewsEvents() {
	  return new Promise(function (resolve, reject) {
	    var req = _.thirdparty.request("/newsevents/getnewsevents", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var NewsSlides = function (_Component) {
	  _inherits(NewsSlides, _Component);
	
	  function NewsSlides() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NewsSlides);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsSlides.__proto__ || Object.getPrototypeOf(NewsSlides)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      newsEventData: []
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshGetNewsEventsData = function () {
	      getNewsEvents().then(function (res) {
	        if (res.status === true) {
	          var records = res.data.filter(function (item) {
	            return item.type === "News";
	          });
	
	          _this.setState({
	            newsEventData: records
	          });
	        } else {
	          _this.setState({
	            newsEventData: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NewsSlides, [{
	    key: "formatDate",
	    value: function formatDate(inputDate) {
	      var date = new Date(inputDate);
	
	      var day = date.getDate();
	      var year = date.getFullYear();
	
	      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	      var month = monthNames[date.getMonth()];
	
	      return {
	        date: day + " " + month + " ",
	        year: month + " " + year
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshGetNewsEventsData();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var crousel_row_number = "";
	      if (this.state.newsEventData.length < 8) {
	        crousel_row_number = "1";
	      } else {
	        crousel_row_number = "2";
	      }
	      var settings = {
	        rows: 1,
	        dots: false,
	        infinite: true,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 1,
	        autoplay: false,
	
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 1,
	            infinite: true,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      var mobileSettings = {
	        rows: 1,
	        dots: false,
	        infinite: true,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 1,
	        autoplay: false,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            infinite: true,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "section",
	          {
	            style: { backgroundColor: "#F7F5EF" },
	            className: "news-events pt-3 pb-0 pb-md-5",
	            id: "hr-lines"
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "container pb-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 right-sp-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "news_section" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      _reactDeviceDetect.MobileView,
	                      { className: _newsEventsModule2.default.MobileView },
	                      _react2.default.createElement(
	                        _reactSlick2.default,
	                        mobileSettings,
	                        this.state.newsEventData.length > 0 ? this.state.newsEventData.map(function (newsevent_data, index) {
	                          var news = newsevent_data.news_events_tag ? newsevent_data.news_events_tag : "Not found";
	                          // console.log(newsevent_data.department_mave.department_name,"news")
	                          var news_events_title = newsevent_data.news_events_title;
	                          var new_news_events_title = news_events_title.replaceAll(" ", "-");
	                          // console.log(this.state.newsEventData)
	                          return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "col-sm-3 post-slide",
	                              style: { position: "relative" },
	                              key: index
	                            },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "/news/" + newsevent_data.Slug,
	                                style: {
	                                  textDecoration: "none",
	                                  width: "100%"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "news-part",
	                                  style: {
	                                    paddingLeft: "0px",
	                                    paddingRight: "0px",
	                                    width: "100%"
	                                  }
	                                },
	                                _react2.default.createElement("img", {
	                                  src: newsevent_data.news_events_pic ? _constants.IMAGE_URL + "NewsEventsImg/" + newsevent_data.news_events_pic : _new2.default,
	                                  style: {
	                                    borderRadius: "5px",
	                                    objectFit: "cover",
	                                    width: "100%",
	                                    height: "100%"
	                                  },
	                                  alt: "news_events_1"
	                                }),
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "bg-color-back",
	                                    style: {
	                                      width: "100%",
	                                      height: "100%"
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "div",
	                                    {
	                                      className: "div",
	                                      style: {
	                                        width: "100%"
	                                      }
	                                    },
	                                    _react2.default.createElement(
	                                      "h5",
	                                      {
	                                        style: {
	                                          position: "absolute",
	                                          top: 25,
	                                          left: 15,
	                                          backgroundColor: "rgb(158 136 89 / 60%)",
	                                          borderRadius: "4px",
	                                          color: "#fff",
	                                          padding: "5px",
	                                          fontSize: "20px",
	                                          width: "30%"
	                                        }
	                                      },
	                                      _this2.formatDate(newsevent_data.news_events_date).date && _this2.formatDate(newsevent_data.news_events_date).date !== NaN ? _this2.formatDate(newsevent_data.news_events_date).date + " " : "Date not found"
	                                    ),
	                                    _react2.default.createElement(
	                                      "h5",
	                                      {
	                                        style: {
	                                          position: "absolute",
	                                          top: 30,
	                                          right: 30,
	                                          fontSize: "12px",
	                                          backgroundColor: "rgb(158 136 89 / 60%)",
	                                          borderRadius: "4px",
	                                          color: "#fff",
	                                          padding: "5px"
	                                        }
	                                      },
	                                      news
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    {
	                                      className: "news_events_title",
	                                      title: newsevent_data.news_events_title,
	                                      style: {
	                                        borderBottomRightRadius: "5px",
	                                        borderBottomLeftRadius: "5px",
	                                        backgroundColor: "#FFFFFF",
	                                        color: "#af9763",
	                                        padding: "10px",
	                                        fontSize: "16px",
	                                        position: "absolute",
	                                        top: 160,
	                                        left: -1
	                                      }
	                                    },
	                                    newsevent_data.news_events_title ? newsevent_data.news_events_title.split(" ").slice(0, 8).join(" ") + " ..." : ""
	                                  )
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-12 post-slide" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "news-part" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "bg-color-back" },
	                              _react2.default.createElement(
	                                "p",
	                                null,
	                                "No any news & events founds"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactDeviceDetect.BrowserView,
	                      null,
	                      _react2.default.createElement(
	                        _reactSlick2.default,
	                        settings,
	                        this.state.newsEventData.length > 0 ? this.state.newsEventData.map(function (newsevent_data, index) {
	                          var news = newsevent_data.news_events_tag ? newsevent_data.news_events_tag : "Not found";
	
	                          return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "col-sm-3 post-slide",
	                              key: index
	                            },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "/news/" + newsevent_data.Slug,
	                                style: {
	                                  textDecoration: "none",
	                                  width: "100%"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "news-part",
	                                  style: {
	                                    paddingLeft: "0px",
	                                    paddingRight: "0px",
	                                    width: "100%"
	                                  }
	                                },
	                                _react2.default.createElement("img", {
	                                  src: newsevent_data.news_events_pic ? _constants.IMAGE_URL + "NewsEventsImg/" + newsevent_data.news_events_pic : _new2.default,
	                                  style: {
	                                    width: "100%",
	                                    borderRadius: "5px",
	                                    objectFit: "cover",
	                                    height: "100%"
	                                  },
	                                  alt: "news_events_1"
	                                }),
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "bg-color-back",
	                                    style: {
	                                      width: "100%"
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "div",
	                                    {
	                                      className: "div",
	                                      style: {
	                                        position: "relative",
	                                        width: "100%"
	                                      }
	                                    },
	                                    _react2.default.createElement(
	                                      "h5",
	                                      {
	                                        style: {
	                                          position: "absolute",
	                                          top: "-137px",
	                                          left: "15px",
	                                          backgroundColor: "rgb(158 136 89 / 60%)",
	                                          borderRadius: "4px",
	                                          color: "#fff",
	                                          padding: "5px",
	                                          fontSize: "20px",
	                                          width: "22%"
	                                        }
	                                      },
	                                      _this2.formatDate(newsevent_data.news_events_date).date && _this2.formatDate(newsevent_data.news_events_date).date !== NaN ? _this2.formatDate(newsevent_data.news_events_date).date + " " : "Date not found"
	                                    ),
	                                    _react2.default.createElement(
	                                      "h5",
	                                      {
	                                        style: {
	                                          position: "absolute",
	                                          top: "-130px",
	                                          right: "15px",
	                                          fontSize: "12px",
	                                          backgroundColor: "rgb(158 136 89 / 60%)",
	                                          borderRadius: "4px",
	                                          color: "#fff",
	                                          padding: "5px"
	                                        }
	                                      },
	                                      news
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    {
	                                      className: "news_events_title",
	                                      title: newsevent_data.news_events_title,
	                                      style: {
	                                        borderBottomRightRadius: "5px",
	                                        borderBottomLeftRadius: "5px",
	                                        color: "#af9763",
	                                        fontSize: "14px"
	                                      }
	                                    },
	                                    newsevent_data.news_events_title ? newsevent_data.news_events_title.split(" ").slice(0, 10).join(" ") + " ..." : ""
	                                  )
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          "div",
	                          { className: "col-sm-12 post-slide" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "news-part" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "bg-color-back" },
	                              _react2.default.createElement(
	                                "p",
	                                null,
	                                "No any news & events founds"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewsSlides;
	}(_react.Component);
	
	exports.default = NewsSlides;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _searchIcon = __webpack_require__(137);
	
	var _searchIcon2 = _interopRequireDefault(_searchIcon);
	
	var _Bitmap = __webpack_require__(444);
	
	var _Bitmap2 = _interopRequireDefault(_Bitmap);
	
	var _iconsRotate = __webpack_require__(107);
	
	var _iconsRotate2 = _interopRequireDefault(_iconsRotate);
	
	var _hospital = __webpack_require__(130);
	
	var _hospital2 = _interopRequireDefault(_hospital);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search() {
	    _classCallCheck(this, Search);
	
	    return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
	  }
	
	  _createClass(Search, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'section',
	          { className: 'banner-cardic' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-5' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'cardic-box' },
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    'On a Mission To Keep Families Healthy'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group navi-input' },
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control physicans', placeholder: 'Search for physicians', 'aria-label': 'Recipient\'s username', 'aria-describedby': 'basic-addon2' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'input-group-text', id: 'basic-addon2' },
	                      _react2.default.createElement('img', { src: _searchIcon2.default, alt: 'search-icon' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'search-popup-main' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'search-popup' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Specialists'
	                      ),
	                      _react2.default.createElement('hr', { className: 'lists-line' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row mt-4' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-4 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'doctor-list' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-5' },
	                                _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-7' },
	                                _react2.default.createElement(
	                                  'h6',
	                                  null,
	                                  'Dr. Reazur Rahman'
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'Associate Consultant'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-4 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'doctor-list' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-5' },
	                                _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-7' },
	                                _react2.default.createElement(
	                                  'h6',
	                                  null,
	                                  'Dr. Reazur Rahman'
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'Associate Consultant'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-4 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'doctor-list' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-5' },
	                                _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-7' },
	                                _react2.default.createElement(
	                                  'h6',
	                                  null,
	                                  'Dr. Reazur Rahman'
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'Associate Consultant'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row mt-4' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-4 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'doctor-list' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-5' },
	                                _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-7' },
	                                _react2.default.createElement(
	                                  'h6',
	                                  null,
	                                  'Dr. Reazur Rahman'
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'Associate Consultant'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-4 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'doctor-list' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-5' },
	                                _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-7' },
	                                _react2.default.createElement(
	                                  'h6',
	                                  null,
	                                  'Dr. Reazur Rahman'
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'Associate Consultant'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-4 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'doctor-list' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-5' },
	                                _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-7' },
	                                _react2.default.createElement(
	                                  'h6',
	                                  null,
	                                  'Dr. Reazur Rahman'
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'Associate Consultant'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'h5',
	                        null,
	                        'Packages'
	                      ),
	                      _react2.default.createElement('hr', { className: 'lists-line' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row mt-4' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-4 col-sm-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'Package-part' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-4 sp-0-search' },
	                                _react2.default.createElement('img', { src: _iconsRotate2.default, alt: 'icons-rotate' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-8 sp-0-search bg-color-gry' },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'Cardiac Screening Package'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-4 col-sm-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'Package-part' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-4 sp-0-search' },
	                                _react2.default.createElement('img', { src: _iconsRotate2.default, alt: 'icons-rotate' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-8 sp-0-search bg-color-gry' },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'Cardiac Screening Package'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-4 col-sm-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'Package-part' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-4 sp-0-search' },
	                                _react2.default.createElement('img', { src: _iconsRotate2.default, alt: 'icons-rotate' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-8 sp-0-search bg-color-gry' },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'Cardiac Screening Package'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'h5',
	                        null,
	                        'Blog'
	                      ),
	                      _react2.default.createElement('hr', { className: 'lists-line' }),
	                      _react2.default.createElement(
	                        'h5',
	                        { className: 'colo-dark' },
	                        'Interesting & Relevant Headline 1'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'pera-search' },
	                        'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s,'
	                      ),
	                      _react2.default.createElement(
	                        'h5',
	                        { className: 'colo-dark' },
	                        'Interesting & Relevant Headline 2'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'pera-search' },
	                        'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s,'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row mt-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-4 hide-mobile-view' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'excellence-part', 'data-aos': 'zoom-in', 'data-aos-duration': 1000 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-3' },
	                            _react2.default.createElement('i', { className: 'fa-solid fa-circle-right' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-9' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Center for Excellence'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-4 hide-mobile-view' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'excellence-part', 'data-aos': 'zoom-in', 'data-aos-duration': 1000 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-3' },
	                            _react2.default.createElement('i', { className: 'fa-solid fa-circle-right' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-9' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Center for Excellence'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-4 hide-mobile-view' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'excellence-part', 'data-aos': 'zoom-in', 'data-aos-duration': 1000 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-3' },
	                            _react2.default.createElement('i', { className: 'fa-solid fa-circle-right' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-9' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Center for Excellence'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row mt-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-4  hide-mobile-view' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'excellence-part', 'data-aos': 'zoom-in', 'data-aos-duration': 1000 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-3' },
	                            _react2.default.createElement('i', { className: 'fa-solid fa-circle-right' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-9' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Center for Excellence'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-4 hide-mobile-view' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'excellence-part', 'data-aos': 'zoom-in', 'data-aos-duration': 1000 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-3' },
	                            _react2.default.createElement('i', { className: 'fa-solid fa-circle-right' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-9' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Center for Excellence'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-4 hide-mobile-view' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'excellence-part', 'data-aos': 'zoom-in', 'data-aos-duration': 1000 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-3' },
	                            _react2.default.createElement('i', { className: 'fa-solid fa-circle-right' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-9' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Center for Excellence'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-7 hos-right' },
	                _react2.default.createElement('img', { src: _hospital2.default, alt: 'hospital' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Search;
	}(_react.Component);
	
	exports.default = Search;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	__webpack_require__(8);
	
	var _icon = __webpack_require__(57);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import dept_img from '../../../images/dept_img.png';
	
	
	var getBodyDepartmentsLists = function getBodyDepartmentsLists(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bodypart/getbodypartdepartment", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getBodyDepartmentsDoctorsLists = function getBodyDepartmentsDoctorsLists(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/bodypart/getbodypartdepartmentdoctors", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var SingleFemaleBodyContent = function (_Component) {
	  _inherits(SingleFemaleBodyContent, _Component);
	
	  function SingleFemaleBodyContent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SingleFemaleBodyContent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SingleFemaleBodyContent.__proto__ || Object.getPrototypeOf(SingleFemaleBodyContent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      bodyDepartment: [],
	      bodyDepartmentDoctor: [],
	      showNewFemaleComponent: false,
	      bodyTitle: ""
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var body_dept_id = (0, _jquery2.default)("input[name='body_dept_id']:checked").val();
	      _this.refreshGetBodyDepartmentsDoctors(body_dept_id);
	    }, _this.refreshGetBodyDepartmentsDoctors = function (body_dept_id) {
	      var data = {
	        bodyDeptId: body_dept_id
	      };
	      getBodyDepartmentsDoctorsLists(data).then(function (res) {
	        if (res.status === true) {
	          (0, _jquery2.default)(".our-departments").hide();
	          (0, _jquery2.default)(".our-consultants").show();
	          var records = res.data;
	          _this.setState({ bodyDepartmentDoctor: records });
	        } else {
	          _this.setState({ bodyDepartmentDoctor: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshGetBodyDepartments = function (bodyTitle) {
	      var data = {
	        bodyTitle: bodyTitle,
	        bodyGender: "female"
	      };
	      getBodyDepartmentsLists(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ bodyDepartment: records });
	        } else {
	          _this.setState({ bodyDepartment: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.FemaleBackStep = function () {
	      _this.props.onClickFemalePrevStep();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SingleFemaleBodyContent, [{
	    key: "modalFemaleBodySingleContentOpen",
	    value: function modalFemaleBodySingleContentOpen(e, title) {
	      this.setState({
	        showNewFemaleComponent: true,
	        bodyTitle: title
	      });
	      (0, _jquery2.default)(".old_female_single_content").hide();
	      (0, _jquery2.default)(".new_female_single_content").show();
	      this.refreshGetBodyDepartments(title);
	      this.ShowDepartment();
	    }
	  }, {
	    key: "ShowDepartment",
	    value: function ShowDepartment() {
	      (0, _jquery2.default)(".our-departments").show();
	      (0, _jquery2.default)(".our-consultants").hide();
	      this.refreshGetBodyDepartments();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshGetBodyDepartments(this.props.bodyTitle);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var OldFemaleBodySVGReactElement = _react2.default.createElement(
	        "svg",
	        {
	          xmlns: "http://www.w3.org/2000/svg",
	          className: "humanBodyImg",
	          viewBox: "120 0 1300 1500",
	          xmlSpace: "preserve"
	        },
	        _react2.default.createElement(
	          "style",
	          null,
	          ".bodyParts{\
	            fill:#14b795;\
	            cursor: pointer;\
	          }\
	          .bodyLines{\
	            fill:#f2f2f2;\
	          }\
	          .syzst2{\
	            fill:none;\
	          }\
	          .labelGroup {\
	            pointer-events: none;\
	          }\
	          .labelLine {\
	            fill: none;\
	            stroke: #b3b3b3;\
	            stroke-width: 2;\
	          }\
	          .labelText {\
	            fill: #14b795;\
	            fill-rule: nonzero;\
	            transform: translateX(10px);\
	            transition: all 0.3s ease;\
	          }\
	          .labelGroup.is_right .labelText {\
	            transform: translateX(-10px);\
	          }\
	          .labelArea {\
	            fill: transparent;\
	            cursor: pointer;\
	          }\
	          .bodyParts_group:hover .bodyParts {\
	            fill: #FE5722;\
	          }\
	          .bodyParts_group:hover .labelGroup .labelText {\
	            fill: #FE5722;\
	            transform: translateX(0px);\
	          }\
	          .body_parts_active .bodyParts {\
	            fill: #FE5722;\
	          }\
	          .body_parts_active .labelGroup .labelText {\
	            fill: #FE5722;\
	            transform: translateX(0px);\
	          }\
	        "
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Head" ? "bodyParts_group Head body_parts_active" : "bodyParts_group Head"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Head");
	            },
	            className: "bodyParts",
	            d: "M718.36 270.3a21.711 21.711 0 0 0 .62.48c.17.13.36.28.56.43.15.12.31.24.48.37.01.01.03.02.04.03h.01l.89.69c.09.07.18.14.28.22 1.16.9 2.55 1.98 4.05 3.13.04.03.08.06.12.1.46.35.93.72 1.41 1.08.06.04.11.09.17.13 1.6 1.22 3.28 2.5 4.94 3.74.96.72 1.9 1.42 2.83 2.1.4.29.8.58 1.18.87.21.16.42.3.63.45a21.053 21.053 0 0 0 1.78 1.21c.14.09.28.17.42.25.3.18.6.34.91.5.16.09.32.18.49.26.38.19.76.36 1.15.52.28.12.56.23.85.33.13.05.27.1.4.15 1.07.38 2.16.67 3.28.88.19.04.38.08.57.11.21.03.42.05.64.08.33.04.65.09.98.12.35.03.71.04 1.06.06.24.01.49.03.73.03h3.02a17.493 17.493 0 0 0 7.92-1.91c.81-.42 1.6-.9 2.34-1.45.31-.23.64-.47.97-.71.27-.2.55-.4.83-.61.01-.01.03-.02.04-.03.86-.63 1.76-1.3 2.7-1.99 1.52-1.12 3.1-2.3 4.66-3.45 0 0 .01 0 .01-.01 1.02-.76 2.04-1.51 3.01-2.24.02-.02.05-.04.07-.05.47-.35.94-.7 1.39-1.04.02-.01.03-.02.05-.04.43-.32.84-.63 1.25-.93.05-.04.1-.08.15-.11.4-.3.79-.59 1.16-.87a67.464 67.464 0 0 1 .8-.6c.06-.04.12-.09.17-.13.23-.17.45-.34.65-.49.03-.02.06-.05.09-.07.43-.32.81-.61 1.14-.86.33-.25.63-.48.85-.65 6.49-5.01 11.86-11.38 15.38-18.78.51-1.07.96-2.11 1.34-3.1 6.07-15.91 1.22-71.74-2.6-86.7-3.3-12.93-13-32.08-43.78-34.25 0 0-.84-.09-2.33-.1-1.62-.38-3.02.1-3.02.1-30.78 2.17-40.48 21.32-43.78 34.25-3.82 14.96-8.66 70.79-2.59 86.7.39 1.04.87 2.13 1.41 3.26 3.37 7.01 8.39 13.09 14.46 17.94.28.19.52.41.77.6z"
	          }),
	          this.props.bodyTitle === "Head" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "175",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M794.206 194.654h300" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1120.04 207.328v-25.769h5.203v10.142h10.195v-10.142h5.203v25.769h-5.203v-11.267h-10.195v11.267h-5.203Zm36.76-5.941 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.182-1.23-1.699-1.845-3.843-1.845-6.433 0-3.094.808-5.517 2.425-7.269 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.814 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm12.619-2.039-4.482-.809c.503-1.805 1.371-3.141 2.601-4.008 1.231-.867 3.059-1.301 5.484-1.301 2.204 0 3.844.261 4.922.783 1.078.521 1.837 1.183 2.277 1.986.439.803.659 2.276.659 4.421l-.053 5.765c0 1.641.079 2.851.237 3.63.159.78.455 1.615.888 2.505h-4.887a18.301 18.301 0 0 1-.474-1.459 8.953 8.953 0 0 0-.176-.58c-.844.82-1.746 1.436-2.707 1.846a7.755 7.755 0 0 1-3.076.615c-1.922 0-3.437-.521-4.544-1.564-1.108-1.043-1.661-2.362-1.661-3.955 0-1.055.252-1.996.756-2.822.504-.826 1.21-1.459 2.118-1.898.908-.44 2.218-.823 3.929-1.152 2.308-.433 3.908-.837 4.798-1.212v-.493c0-.949-.234-1.626-.703-2.03-.469-.404-1.353-.606-2.654-.606-.879 0-1.565.172-2.057.518-.492.346-.89.952-1.195 1.82Zm6.609 4.007c-.632.211-1.634.463-3.006.756-1.371.293-2.267.58-2.689.862-.645.457-.967 1.037-.967 1.74 0 .691.258 1.289.774 1.793.515.504 1.172.756 1.968.756.891 0 1.741-.293 2.549-.879.598-.446.99-.991 1.178-1.635.129-.422.193-1.225.193-2.408v-.985Zm26.841 8.965h-4.588v-2.742c-.761 1.066-1.661 1.86-2.698 2.382-1.037.521-2.083.782-3.138.782-2.144 0-3.981-.864-5.51-2.593-1.53-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.232-7.216 1.488-1.646 3.369-2.47 5.643-2.47 2.086 0 3.89.868 5.414 2.602v-9.281h4.939v25.769Zm-13.183-9.738c0 1.992.275 3.433.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.136 0 2.103-.484 2.9-1.45.797-.967 1.195-2.412 1.195-4.333 0-2.145-.386-3.689-1.16-4.632-.773-.944-1.764-1.415-2.971-1.415-1.171 0-2.153.465-2.944 1.397-.791.932-1.186 2.323-1.186 4.175Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Neck" ? "bodyParts_group Neck body_parts_active" : "bodyParts_group Neck"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "syzst2",
	            d: "M764.93 283.93c.01 0 .01-.01.02-.01-.01.01-.03.02-.04.03 0-.01.01-.01.02-.02zm-15.84 4.67c.12 0 .23.02.35.02.12.01.23.01.35.01h.03c-.25 0-.49-.02-.73-.03zm31.29-16.14c-.06.04-.11.09-.17.13.05-.05.11-.09.17-.13zm-37.81 14.89c-.13-.05-.27-.1-.4-.15.13.05.26.1.4.15zm-1.25-.48zm35.52-11.77c-.02.01-.03.02-.05.04.02-.01.04-.02.05-.04zm-37.17 10.99c-.31-.16-.61-.33-.91-.5.3.17.61.34.91.5zm38.57-12.03c-.05.04-.1.07-.15.11.05-.03.1-.07.15-.11zm-2.84 2.12c-.02.02-.05.04-.07.05.02-.02.05-.03.07-.05zm4.06-3.04.02-.02c-.03.02-.06.04-.08.06.02 0 .05-.02.06-.04zm-7.14 5.33c-.01 0-.01 0 0 0-.01 0-.01 0 0 0zm-52.31-6.89c-.16-.13-.33-.25-.48-.37.15.12.31.24.48.37zm-1.04-.8a.55.55 0 0 1-.09-.07c.04.02.07.04.09.07zm2.25 1.74c-.1-.07-.19-.14-.28-.22.1.08.18.14.28.22zm39.54 14.2c.81-.42 1.6-.9 2.34-1.45.31-.23.64-.47.97-.71-.33.24-.66.49-.97.71-.74.55-1.53 1.03-2.34 1.45zm-33.78-9.76c-.06-.04-.11-.09-.17-.13.05.05.11.09.17.13zm9.58 7.17-.63-.45.63.45zm-11.16-8.38c-.04-.03-.08-.06-.12-.1.03.04.08.07.12.1zm12.94 9.59c-.43-.26-.85-.54-1.26-.83.41.29.83.56 1.26.83zm42.79-13.44c-.03.02-.06.05-.09.07.03-.03.05-.05.09-.07z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "M666.75 332.26c9.55 2.6 27.57 9.57 28.04 9.76 11.91-.5 23.89 1.67 31.1 4.75 13.94 5.96 18.14 15.53 22.55 28.4.37 1.09.71 2.47 1.01 4.07v-88.62c-4.61-.06-9.03-1.52-12.8-4.21-.36-.26-.72-.52-1.1-.79 1.51 5.65 2.83 12.57 3.67 16.91.18.94.33 1.73.45 2.33.34 1.69 1.83 6.59 3.4 11.76 3.18 10.45 5.42 18.01 5.42 20.13 0 1.58-.68 2.31-1.25 2.65-.44.26-.93.35-1.41.35-1.25 0-2.48-.64-2.79-.81l-.26-.14-.14-.26c-.07-.13-7.08-13.28-9.7-18.51-.77-1.55-1.69-4.32-2.64-7.67-3.94 3.87-15.34 15.04-18.32 17.27-2.3 1.72-6.56 3.06-9.74 3.88-.29.08-.59.11-.88.11-.75 0-1.47-.24-2.09-.7a3.495 3.495 0 0 1-1.4-2.68c-.13-3.6-.17-7.88.46-10.74-3.21.72-8.12.96-13.29.96-7.03 0-14.53-.45-18.85-.75-6.2 1.91-11.72 3.47-15.13 4.26-1.25.29-2.55.63-3.88 1.03 2.47.76 5.29 1.91 8.3 3.14 3.77 1.55 7.66 3.14 11.27 4.12z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "M698.29 317.47c5.32-1.33 10.38-10.37 13.49-17.15-2.73 2.36-5.98 4.21-8.76 6.05-3.27 2.18-17.98 7.4-31.45 11.68 8.56.47 21.06.84 26.72-.58z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "m700.5 318.76.12.05c-1.05 2.62-.83 8.98-.75 11.37.02.46.23.88.6 1.15.37.27.83.36 1.27.25 4.24-1.1 7.45-2.36 9.04-3.55 3.07-2.3 16.12-15.13 18.91-17.87-2.01-7.44-4.09-16.83-5.33-22.41l-.31-1.4c-.95-4.3-3.65-9.85-5.85-13.92 0 0-.01 0-.01-.01-.17-.13-.33-.26-.49-.39.27 7.44.35 16.44-.6 20.26-.09.35-.19.69-.3 1.02l.02.01c-.31.9-7.44 21.01-16.32 25.44zm25.82-31.45c1.94 8.74 5.97 26.94 8.41 31.82 2.39 4.79 8.49 16.25 9.52 18.19.65.31 1.6.57 1.96.35.24-.14.26-.69.26-.92 0-1.98-3.08-12.13-5.34-19.55-1.66-5.45-3.09-10.17-3.45-11.95-.12-.6-.27-1.4-.46-2.35-.89-4.63-2.55-13.29-4.33-19.22-3.81-2.83-7.89-5.98-10.92-8.31 0-.01-.01-.01-.01-.01 1.69 3.45 3.31 7.3 4.03 10.55l.33 1.4z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M732.92 283.69c0-.01 0-.01 0 0 1.77 5.93 3.43 14.58 4.32 19.22.18.95.33 1.74.46 2.35.36 1.79 1.79 6.5 3.45 11.95 2.25 7.41 5.34 17.57 5.34 19.55 0 .23-.03.78-.26.92-.37.22-1.31-.05-1.96-.35-1.03-1.93-7.13-13.4-9.52-18.19-2.44-4.88-6.47-23.08-8.41-31.82l-.31-1.4c-.72-3.25-2.34-7.1-4.03-10.55-.69-.54-1.32-1.03-1.88-1.47l-1.81-1.4c-.03-.02-.05-.04-.08-.06 2.2 4.07 4.89 9.62 5.85 13.92l.31 1.4c1.24 5.58 3.32 14.97 5.33 22.41.32-.32.51-.51.53-.52l1.41 1.42c-.1.1-.58.58-1.33 1.31.95 3.35 1.87 6.12 2.64 7.67 2.62 5.23 9.63 18.38 9.7 18.51l.14.26.26.14c.31.17 1.54.81 2.79.81.49 0 .97-.1 1.41-.35.57-.34 1.25-1.07 1.25-2.65 0-2.11-2.25-9.68-5.42-20.13-1.57-5.18-3.06-10.07-3.4-11.76-.12-.6-.27-1.39-.45-2.33-.83-4.34-2.16-11.26-3.67-16.91-.88-.64-1.76-1.29-2.66-1.95z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M710.79 328.02c-1.59 1.19-4.8 2.45-9.04 3.55-.44.12-.91.02-1.27-.25s-.58-.69-.6-1.15c-.08-2.39-.3-8.74.75-11.37l-.12-.05c-.57.28-1.15.5-1.72.65-.14.03-.28.07-.43.1-.63 2.86-.59 7.14-.46 10.74.04 1.07.55 2.04 1.4 2.68.61.46 1.34.7 2.09.7.29 0 .59-.04.88-.11 3.18-.82 7.44-2.16 9.74-3.88 2.97-2.23 14.38-13.39 18.32-17.27-.2-.71-.41-1.45-.61-2.21-2.81 2.75-15.86 15.57-18.93 17.87z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M730.22 309.63c-.02.02-.21.21-.53.52.2.76.41 1.49.61 2.21.74-.73 1.22-1.21 1.33-1.31l-1.41-1.42zm-64 24.56c6.78 1.85 17.93 5.94 23.86 8.18 1.56-.17 3.12-.28 4.7-.35-.47-.18-18.49-7.15-28.04-9.76-3.61-.98-7.49-2.57-11.25-4.11-3.01-1.23-5.83-2.38-8.3-3.14-1.18.35-2.38.74-3.6 1.19 2.87.42 7.05 2.13 11.14 3.8 3.82 1.56 7.76 3.17 11.49 4.19zm32.12-14.68c.12-.53.26-1.02.42-1.44l1.73.69h.01c8.88-4.43 16.01-24.54 16.33-25.44l-.02-.01c-.96 2.85-2.82 5.1-5.03 7.01-3.11 6.78-8.17 15.82-13.49 17.15-5.66 1.42-18.16 1.05-26.72.58h-.02c-1.81.58-3.61 1.14-5.35 1.67 4.32.3 11.82.75 18.85.75 5.17 0 10.08-.24 13.29-.96z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M698.77 319.41c.58-.15 1.16-.37 1.72-.65l-1.73-.69c-.17.42-.31.91-.42 1.44.15-.03.29-.07.43-.1z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "M801.66 319.51c.72 3.29.55 8.38.46 10.74a3.495 3.495 0 0 1-1.4 2.68c-.61.46-1.34.7-2.09.7-.29 0-.59-.04-.88-.11-3.17-.82-7.44-2.16-9.74-3.88-2.98-2.23-14.38-13.39-18.32-17.27-.95 3.35-1.86 6.12-2.64 7.67-2.62 5.23-9.63 18.38-9.7 18.51l-.14.26-.26.14c-.31.17-1.54.81-2.79.81-.49 0-.97-.1-1.41-.35-.57-.34-1.25-1.07-1.25-2.65 0-2.12 2.25-9.68 5.43-20.14 1.57-5.18 3.06-10.06 3.4-11.76.12-.6.27-1.39.45-2.33.79-4.13 2.03-10.59 3.45-16.08h-.01c-.33.25-.65.48-.96.71-3.1 2.27-6.78 3.47-10.63 3.47h-2.08v88.61c.3-1.6.64-2.98 1.01-4.07 4.41-12.87 8.6-22.44 22.55-28.4 7.21-3.09 19.19-5.25 31.1-4.75.73-.28 18.56-7.17 28.03-9.76 3.61-.98 7.5-2.57 11.25-4.11 3.01-1.23 5.83-2.39 8.3-3.14-1.34-.4-2.63-.74-3.88-1.03-3.41-.79-8.92-2.35-15.12-4.26h-.01c-4.32.3-11.82.75-18.84.75-5.16 0-10.07-.24-13.28-.96z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "m775.94 286.34-.31 1.4c-1.24 5.58-3.32 14.97-5.33 22.41 2.79 2.75 15.83 15.57 18.91 17.87 1.59 1.19 4.8 2.45 9.04 3.55.45.12.91.02 1.27-.25s.58-.69.6-1.15c.08-2.39.3-8.75-.75-11.37l.12-.05c-8.88-4.42-16.01-24.54-16.33-25.44h.01v-.01c-.11-.33-.21-.67-.3-1.02-.91-3.65-.87-12.02-.63-19.25-.22.17-.45.36-.71.54-2.14 3.7-4.67 8.65-5.59 12.77zm-13.64 18.91c-.36 1.79-1.79 6.49-3.44 11.94-2.25 7.42-5.34 17.57-5.34 19.56 0 .23.03.78.26.92.37.22 1.31-.05 1.96-.35 1.03-1.93 7.13-13.4 9.53-18.19 2.44-4.88 6.47-23.08 8.41-31.82l.31-1.4c.67-3.01 2.11-6.37 3.66-9.41-3.24 2.42-7.31 5.44-10.81 8.04-1.68 5.88-3.23 13.95-4.08 18.36-.18.95-.34 1.75-.46 2.35z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "M801.71 317.47c5.66 1.42 18.16 1.05 26.72.58-13.46-4.28-28.18-9.5-31.45-11.68-2.78-1.85-6.05-3.7-8.78-6.07 3.12 6.79 8.18 15.84 13.51 17.17zm-51.15 61.77v-88.61h-.77c-.12 0-.23 0-.35-.01v88.62c.21 1.08.39 2.27.56 3.55.17-1.28.35-2.47.56-3.55z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M760.34 304.86c-.34 1.69-1.82 6.58-3.4 11.76-3.18 10.46-5.43 18.02-5.43 20.14 0 1.58.68 2.31 1.25 2.65.44.26.93.35 1.41.35 1.25 0 2.48-.64 2.79-.81l.26-.14.14-.26c.07-.13 7.08-13.28 9.7-18.51.77-1.55 1.69-4.32 2.64-7.67-.74-.73-1.22-1.21-1.33-1.31l1.41-1.42c.02.02.21.21.53.52 2.01-7.44 4.09-16.83 5.33-22.41l.31-1.4c.91-4.12 3.45-9.06 5.59-12.77h-.01l-.01.01c-1.01.77-2.35 1.77-3.87 2.91-1.55 3.04-2.99 6.4-3.66 9.41l-.31 1.4c-1.94 8.74-5.97 26.94-8.41 31.82-2.39 4.79-8.5 16.25-9.53 18.19-.66.31-1.6.57-1.96.35-.24-.14-.26-.69-.26-.92 0-1.98 3.09-12.14 5.34-19.56 1.66-5.45 3.09-10.16 3.44-11.94.12-.6.27-1.4.46-2.35.85-4.42 2.4-12.48 4.08-18.36h-.01l-2.59 1.91c-1.42 5.49-2.66 11.95-3.45 16.08-.18.93-.33 1.73-.45 2.33z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M788.01 329.62c2.3 1.72 6.57 3.06 9.74 3.88a3.503 3.503 0 0 0 4.37-3.27c.08-2.36.26-7.45-.46-10.74-.15-.03-.3-.06-.44-.1-.58-.15-1.15-.36-1.72-.65l-.12.05c1.05 2.62.83 8.97.75 11.37-.02.46-.23.88-.6 1.15-.37.27-.83.36-1.27.25-4.24-1.09-7.45-2.35-9.04-3.55-3.07-2.3-16.12-15.13-18.91-17.87-.2.76-.41 1.49-.61 2.21 3.93 3.88 15.34 15.04 18.31 17.27z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M768.37 311.05c.1.1.58.58 1.33 1.31.2-.71.41-1.45.61-2.21-.32-.32-.51-.51-.53-.52l-1.41 1.42zm31.13 7.71 1.74-.69c.17.42.3.91.42 1.44 3.21.72 8.12.96 13.29.96 7.02 0 14.52-.45 18.84-.75-1.74-.53-3.54-1.09-5.35-1.67h-.01c-8.56.47-21.06.84-26.72-.58-5.33-1.33-10.39-10.38-13.51-17.17-2.2-1.91-4.05-4.14-5.02-6.98h-.01c.32.9 7.45 21.02 16.33 25.44z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M801.66 319.51c-.12-.53-.25-1.02-.42-1.44l-1.73.69c.57.29 1.14.5 1.72.65.13.04.28.07.43.1z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            d: "M718.21 272.42c.03.02.05.05.08.06l1.81 1.4c.56.44 1.19.93 1.88 1.47 0 0 .01 0 .01.01 3.03 2.34 7.11 5.49 10.92 8.31l.01.01c.9.66 1.78 1.31 2.62 1.93.38.27.74.53 1.1.79 3.77 2.69 8.19 4.15 12.8 4.21.12.01.23.01.35.01h2.85c3.85 0 7.53-1.2 10.63-3.47.31-.23.63-.46.96-.71h.01l2.59-1.91h.01c3.5-2.6 7.57-5.62 10.81-8.04 1.52-1.14 2.86-2.14 3.87-2.91l.01-.01h.01c.27-.18.5-.37.71-.54 0-.24.01-.47.02-.71.01-.19.01-.38.02-.57l.03-.77c-.02.01-.04.03-.06.04-.33.25-.72.54-1.14.86-.03.02-.06.05-.09.07-.21.16-.43.32-.65.49-.06.04-.11.09-.17.13-.23.18-.47.35-.72.54l-.02.02c-.02.01-.04.03-.06.05-.37.28-.76.57-1.16.87-.05.04-.1.07-.15.11-.4.3-.82.61-1.25.93-.02.01-.03.02-.05.04-.45.34-.92.68-1.39 1.04-.02.02-.05.04-.07.05l-3.01 2.24s-.01 0-.01.01c-2.53 1.88-5.11 3.79-7.37 5.44-.01 0-.01.01-.02.01l-.02.02c-.28.21-.56.41-.83.61-.33.25-.66.49-.97.71a17.168 17.168 0 0 1-7.52 3.14c-.9.14-1.82.22-2.74.22h-3.05c-.12 0-.23 0-.35-.01-.12 0-.23-.01-.35-.02-2.24-.09-4.43-.51-6.52-1.25-.13-.05-.27-.1-.4-.15-.28-.11-.57-.21-.85-.33-.39-.16-.77-.34-1.15-.52-.16-.08-.33-.17-.49-.26-.31-.16-.61-.33-.91-.5-.14-.08-.28-.17-.42-.25a21.053 21.053 0 0 1-1.78-1.21l-.63-.45c-2.83-2.05-6.02-4.47-8.95-6.71-.06-.04-.11-.09-.17-.13-.48-.37-.95-.73-1.41-1.08-.04-.03-.08-.06-.12-.1-1.51-1.16-2.89-2.23-4.05-3.13-.1-.08-.18-.14-.28-.22-.33-.26-.64-.5-.93-.73-.16-.13-.32-.25-.48-.37-.2-.15-.39-.3-.56-.43a.55.55 0 0 1-.09-.07c-.2-.15-.38-.29-.53-.41-.25-.19-.49-.41-.74-.6.01.33.03.67.04 1.01l.03.76v.01c0 .18.01.36.02.55.14.14.3.27.48.4-.01 0 0 0 0 0z",
	            fill: "#ebebeb"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "M764.9 283.95c-.28.21-.56.41-.83.61.27-.2.55-.4.83-.61zm10.43-7.72-3.01 2.24 3.01-2.24zm-14.57 10.49zm16.03-11.58c-.45.34-.92.68-1.39 1.04.48-.36.94-.7 1.39-1.04zm-36.63 11.21c-.16-.08-.33-.17-.49-.26.17.09.33.17.49.26zm-1.39-.76c-.14-.08-.28-.17-.42-.25.13.08.27.17.42.25zm3.39 1.61c-.28-.11-.57-.22-.85-.33.29.12.57.23.85.33zm35.93-13.03c-.4.3-.82.61-1.25.93.43-.32.85-.63 1.25-.93zm4.18-3.14c-.33.25-.72.54-1.14.86.42-.32.81-.61 1.14-.86zm-1.24.94c-.21.16-.43.32-.65.49.22-.17.44-.34.65-.49zm-.82.62c-.23.17-.47.35-.72.54.25-.19.48-.37.72-.54zm-.81.6c-.37.28-.76.57-1.16.87.4-.3.79-.59 1.16-.87zm-42.84 10.94c.17.13.35.26.52.38-.17-.13-.35-.26-.52-.38zm13.26 4.5h.11-.11zm-2.77-.2c-.21-.03-.42-.05-.64-.08-.19-.03-.38-.08-.57-.11-1.11-.21-2.21-.51-3.28-.88 2.09.74 4.29 1.16 6.52 1.25-.35-.01-.71-.03-1.06-.06-.32-.03-.65-.08-.97-.12zm17.89-4.51c2.25-1.66 4.84-3.57 7.37-5.44-1.56 1.16-3.15 2.33-4.66 3.45-.94.69-1.85 1.36-2.71 1.99zm-38.13-7.09c-.48-.37-.95-.73-1.41-1.08.46.35.93.72 1.41 1.08zm-7.28-5.62c-.2-.16-.39-.3-.56-.43.17.13.36.28.56.43zm-.64-.5c-.2-.15-.38-.29-.53-.41-.25-.19-.49-.41-.74-.6.25.2.49.41.74.6.15.12.33.26.53.41zm6.38 4.94c-1.5-1.16-2.89-2.23-4.05-3.13 1.17.9 2.55 1.98 4.05 3.13zm6.65 5.06s-.01 0 0 0a630.11 630.11 0 0 1-4.94-3.75c2.93 2.24 6.12 4.66 8.95 6.71-.39-.28-.78-.57-1.18-.87-.93-.67-1.88-1.37-2.83-2.09zm-11.87-9.1c-.01-.01-.03-.02-.04-.03.29.23.6.47.93.73-.31-.25-.61-.48-.89-.7z"
	          }),
	          this.props.bodyTitle === "Neck" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "282",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M784.206 302.225h310" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1120.08 314.899V289.13h5.062l10.547 17.209V289.13h4.834v25.769h-5.22l-10.389-16.804v16.804h-4.834Zm36.72-5.941 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.269 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm25.209-2.215-4.869.879c-.164-.973-.536-1.705-1.116-2.197-.581-.493-1.333-.739-2.259-.739-1.231 0-2.212.425-2.945 1.275-.732.849-1.098 2.27-1.098 4.262 0 2.215.372 3.78 1.116 4.694.744.914 1.743 1.371 2.997 1.371.938 0 1.705-.267 2.303-.8.597-.533 1.019-1.45 1.265-2.751l4.852.826c-.504 2.227-1.471 3.908-2.9 5.045-1.43 1.137-3.346 1.705-5.748 1.705-2.731 0-4.908-.861-6.531-2.584-1.623-1.722-2.434-4.107-2.434-7.154 0-3.082.814-5.482 2.443-7.198 1.629-1.717 3.832-2.576 6.609-2.576 2.274 0 4.082.49 5.423 1.468 1.342.979 2.306 2.47 2.892 4.474Zm3.57 13.148V289.13h4.94v13.676l5.783-6.575h6.082l-6.381 6.821 6.838 11.847h-5.326l-4.694-8.384-2.302 2.408v5.976h-4.94Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Right Shoulder" ? "bodyParts_group Right_Shoulder body_parts_active" : "bodyParts_group Right_Shoulder"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyParts",
	            d: "M620.4 449.44c3.87-8.15 7.7-16.02 11.06-22.93 3.85-7.92 6.89-14.17 8.58-17.97 6.92-15.58 13.49-43.76 13.55-44.05l.5.12c.11-.34 2.92-8.53 16.29-16.39 5.58-3.28 12.5-5.1 19.69-5.85h.01c-5.93-2.23-17.08-6.33-23.86-8.18-3.73-1.02-7.67-2.63-11.48-4.19-4.09-1.67-8.27-3.38-11.14-3.8-10.03 3.65-20.9 10.55-25.1 22.44-3.3 9.39-5.23 32.63-5.99 52.34 2.38 7.67 8.36 27.63 8.36 34.31-.01 4.65-.25 10.25-.47 14.15zm0 .01v-.01.01z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "M630.47 536.05c-.07.78-.1 1.18-.11 1.2l1.99.17c0-.02.04-.46.11-1.3-.66.04-1.32.02-1.99-.07zm-12.34-81.9h.05c.74-1.57 1.48-3.14 2.22-4.7v-.01c.22-3.9.46-9.5.46-14.15 0-6.68-5.98-26.64-8.36-34.31-.08 2.12-.15 4.21-.2 6.23 2.72 9.15 6.56 22.98 6.56 28.08 0 7.97-.72 18.75-.73 18.86z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "M620.13 454.28c0-.04.13-1.99.27-4.83-.74 1.56-1.48 3.13-2.22 4.7l1.95.13z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "syzst2",
	            d: "M630.47 536.05c-.07.78-.1 1.18-.11 1.2l1.99.17c0-.02.04-.46.11-1.3-.66.04-1.32.02-1.99-.07z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyParts",
	            d: "M633.25 427.39c-7.63 15.68-18.64 38.33-26.25 56.94l.15-.02c.07.44 6.84 44.11 20.1 50.74 1.08.53 2.15.86 3.22 1 .34-4.04 1.52-18.45 3.44-45.29 2.29-32.14 26.41-107.08 26.66-107.83l.27.09c-2.25-7.44-4.6-13.05-5.83-15.79-1.73 7.09-7.29 29-13.14 42.13-1.71 3.82-4.76 10.09-8.62 18.03z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyParts",
	            d: "M656.53 481.33c-.73-2.07-1.27-4.44-1.61-7.11-.06-.5-.12-1.05-.16-1.62-.19-2.15-.25-4.49-.24-6.71-.03-6.49.37-13.19.4-13.49l1.39 4.12c-.17-.53-.32-1.07-.46-1.6-1.27-4.66-1.6-9.03-1.57-12.48-.08-5.68.59-9.98.66-10.29l.84 3.14c-.82-2.57-1.12-5.5-.86-8.81.34-4.46 1.67-10.6 3.06-17.1 1.77-8.18 3.73-17.26 3.5-22.75v-.01c-4.56 14.46-23.57 76.08-25.58 104.27-1.9 26.64-3.08 41.05-3.43 45.22h.01c7.28-.51 14.13-8.58 17.99-14.09v-.01c2.97-15.17 5.53-28.4 5.89-31.63l.17-9.05zm-38.4-27.18c.01-.11.73-10.89.73-18.86 0-5.1-3.84-18.93-6.56-28.08-.25 9.13-.23 16.98.04 21.55.59 9.99-4.71 37.22-9.09 59.47 4.06-10.37 9.45-22.38 14.93-34.08h-.05z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "m604.17 487.36 1.42-.27c-.24-1.37-.38-2.25-.41-2.48l1.82-.28c7.61-18.61 18.62-41.26 26.25-56.94 3.86-7.94 6.91-14.21 8.61-18.04 5.85-13.13 11.41-35.04 13.14-42.13a49.86 49.86 0 0 0-.86-1.85l-.18-.37.13-.39-.5-.12c-.06.29-6.63 28.47-13.55 44.05-1.69 3.8-4.73 10.05-8.58 17.97-3.36 6.91-7.19 14.78-11.06 22.93v.01c-.14 2.84-.27 4.79-.27 4.83l-1.95-.13c-5.48 11.7-10.87 23.71-14.93 34.08 0 .01 0 .02-.01.03-.91 4.71-1.8 9.21-2.58 13.26 1.06-3.41 2.42-7.25 4.01-11.37 0 0 .01-.01 0-.01-.3-1.72-.48-2.7-.5-2.78z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "M632.48 536.12h-.01c-.07.84-.11 1.28-.11 1.3l-1.99-.17c0-.02.04-.42.1-1.2-1.07-.14-2.14-.47-3.22-1-13.26-6.63-20.03-50.3-20.1-50.74l-.15.02c-.38.91-.74 1.81-1.1 2.7l.24-.04c.16.82 1.21 6.42 2.54 14.82 3.36 13.53 9.17 30.78 17.67 35.03 1.84.92 3.67 1.33 5.47 1.33 6.95 0 13.36-6.05 17.75-11.54.3-1.55.6-3.08.9-4.6-3.86 5.51-10.71 13.58-17.99 14.09z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "m605.59 487.09.31-.05v-.01c.36-.89.72-1.79 1.1-2.7l-1.82.28c.03.23.17 1.11.41 2.48zm28.31 3.66c-1.92 26.84-3.1 41.25-3.44 45.29.67.09 1.33.11 2 .07.35-4.18 1.53-18.58 3.43-45.22 2.01-28.2 21.02-89.81 25.58-104.27-.04-1.06-.17-1.99-.39-2.75-.09-.29-.17-.58-.26-.86l-.27-.09c-.23.75-24.35 75.69-26.65 107.83z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "m605.59 487.09-1.42.27c.02.08.2 1.06.5 2.78.01 0 0 .01 0 .01.33-.84.66-1.69 1-2.55v-.01c-.02-.17-.05-.34-.08-.5zm.32-.06v.01c-.08.19-.15.38-.23.56.56 3.11 1.55 8.31 3.01 14.21-1.33-8.4-2.38-14-2.54-14.82l-.24.04z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "M605.59 487.09c.03.16.06.33.08.5v.01c.08-.18.15-.37.23-.56l-.31.05z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "m605.9 487.04.01-.01h-.01z"
	          }),
	          this.props.bodyTitle === "Right Shoulder" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "105",
	              y: "456",
	              width: "275",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup is_right" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M405 479.666h210" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M125.046 488.982v-25.769h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.183 1.125 2.537 1.125 4.06 0 1.934-.568 3.531-1.705 4.79-1.137 1.26-2.836 2.054-5.097 2.382 1.125.656 2.053 1.377 2.786 2.162.732.785 1.719 2.18 2.962 4.184l3.146 5.027h-6.223l-3.761-5.607c-1.336-2.004-2.25-3.267-2.742-3.788-.493-.522-1.014-.879-1.565-1.072-.551-.194-1.424-.291-2.619-.291h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.055-.105 4.676-.316a2.803 2.803 0 0 0 1.459-1.09c.351-.516.527-1.16.527-1.934 0-.867-.231-1.567-.694-2.1-.463-.533-1.117-.87-1.96-1.011-.422-.059-1.688-.088-3.797-.088h-4.061v6.539Zm20.742-6.328v-4.57h4.94v4.57h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.231 5.643.685c.094.657.31 1.108.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.193 2.901-.58.433-.258.761-.674.984-1.248.152-.41.228-1.166.228-2.268v-2.724c-1.476 2.015-3.339 3.023-5.589 3.023-2.508 0-4.495-1.06-5.959-3.181-1.149-1.676-1.723-3.762-1.723-6.258 0-3.129.753-5.52 2.259-7.172 1.506-1.652 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.94-.363 1.09-.873 1.945-1.529 2.566-.657.621-1.533 1.108-2.628 1.459-1.096.352-2.482.527-4.157.527-3.165 0-5.409-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.597Zm4.412-10.951c0 1.98.384 3.43 1.152 4.35.767.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.398-3.37-1.195-4.307-.797-.938-1.805-1.406-3.023-1.406-1.184 0-2.16.46-2.927 1.38-.768.92-1.152 2.323-1.152 4.21Zm22.957-16.049v9.474c1.594-1.863 3.499-2.795 5.713-2.795 1.137 0 2.162.211 3.077.633.914.422 1.602.961 2.065 1.617.463.657.779 1.383.949 2.18.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.282-3.727a2.438 2.438 0 0 0-.993-1.256c-.474-.311-1.069-.466-1.784-.466-.82 0-1.553.199-2.197.597-.645.399-1.116.999-1.415 1.802-.299.803-.449 1.989-.449 3.56v9.351h-4.939v-25.769h4.939Zm25.629 7.101v3.938h-3.375v7.523c0 1.524.033 2.411.097 2.663.065.252.211.46.44.624.228.164.506.246.834.246.458 0 1.12-.158 1.987-.474l.422 3.832c-1.149.492-2.45.738-3.903.738-.89 0-1.693-.149-2.408-.448-.715-.299-1.239-.686-1.573-1.16-.334-.475-.566-1.116-.694-1.925-.106-.574-.159-1.734-.159-3.481v-8.138h-2.267v-3.938h2.267v-3.709l4.957-2.882v6.591h3.375Zm12.147 10.284 5.062-.493c.305 1.7.923 2.948 1.855 3.744.932.797 2.188 1.196 3.77 1.196 1.676 0 2.939-.355 3.788-1.064.85-.709 1.275-1.538 1.275-2.487 0-.609-.179-1.128-.536-1.556-.358-.427-.982-.799-1.872-1.116-.61-.211-1.998-.586-4.166-1.125-2.789-.691-4.746-1.541-5.871-2.549-1.582-1.418-2.373-3.146-2.373-5.185 0-1.313.372-2.54 1.116-3.683.744-1.142 1.816-2.013 3.217-2.61 1.4-.598 3.09-.897 5.071-.897 3.234 0 5.669.709 7.304 2.127 1.634 1.418 2.493 3.311 2.575 5.678l-5.203.228c-.223-1.324-.701-2.276-1.433-2.856-.732-.58-1.831-.87-3.296-.87-1.512 0-2.695.31-3.551.932-.55.398-.826.931-.826 1.599 0 .61.258 1.131.774 1.565.656.55 2.25 1.125 4.781 1.722 2.531.598 4.403 1.216 5.616 1.855 1.213.638 2.162 1.512 2.848 2.619.685 1.107 1.028 2.476 1.028 4.104 0 1.477-.41 2.86-1.23 4.149-.821 1.289-1.981 2.247-3.481 2.874-1.5.627-3.369.94-5.607.94-3.258 0-5.76-.753-7.506-2.258-1.746-1.506-2.789-3.701-3.129-6.583Zm30.217-17.385v9.474c1.593-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.657.779 1.383.949 2.18.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.281-3.727a2.445 2.445 0 0 0-.994-1.256c-.474-.311-1.069-.466-1.784-.466-.82 0-1.553.199-2.197.597-.645.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm15.925 16.172c0-1.641.405-3.229 1.213-4.764.809-1.535 1.954-2.707 3.437-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.138.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.953 0 2.824-.911 5.165-2.733 7.022-1.823 1.857-4.117 2.786-6.882 2.786-1.711 0-3.343-.387-4.896-1.16-1.552-.773-2.733-1.907-3.542-3.401-.808-1.495-1.213-3.314-1.213-5.458Zm5.063.263c0 1.852.439 3.27 1.318 4.254.879.985 1.963 1.477 3.252 1.477 1.289 0 2.37-.492 3.243-1.477.873-.984 1.31-2.414 1.31-4.289 0-1.828-.437-3.234-1.31-4.219-.873-.984-1.954-1.476-3.243-1.476s-2.373.492-3.252 1.476c-.879.985-1.318 2.403-1.318 4.254Zm30.357 9.334v-2.795a7.191 7.191 0 0 1-2.68 2.356 7.52 7.52 0 0 1-3.507.861c-1.254 0-2.379-.275-3.375-.826-.996-.551-1.717-1.324-2.162-2.32-.446-.996-.668-2.373-.668-4.131v-11.813h4.939v8.578c0 2.625.091 4.234.273 4.826.181.591.512 1.06.993 1.406.48.346 1.09.518 1.828.518.844 0 1.6-.231 2.268-.694.668-.463 1.125-1.037 1.371-1.723.246-.685.369-2.364.369-5.036v-7.875h4.939v18.668h-4.588Zm9.704-25.769h4.939v25.77h-4.939zm27.123 25.769h-4.588v-2.742c-.762 1.066-1.661 1.86-2.699 2.382-1.037.521-2.083.782-3.137.782-2.145 0-3.982-.864-5.511-2.593-1.529-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.232-7.216 1.489-1.646 3.37-2.47 5.643-2.47 2.086 0 3.891.868 5.414 2.602v-9.281h4.94v25.769Zm-13.184-9.738c0 1.992.275 3.434.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.137 0 2.103-.484 2.9-1.45.797-.967 1.196-2.412 1.196-4.333 0-2.145-.387-3.689-1.16-4.632-.774-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.466-2.945 1.397-.791.932-1.186 2.323-1.186 4.175Zm28.863 3.797 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429H352.56c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.527-.422.926-1.102 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.382Zm13.659 10.933h-4.94v-18.668h4.588v2.655c.785-1.254 1.491-2.08 2.118-2.479.627-.398 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.307c-.832-.539-1.606-.809-2.321-.809-.691 0-1.277.191-1.757.571-.481.381-.859 1.07-1.134 2.066-.276.996-.413 3.082-.413 6.258v5.765Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Left Shoulder" ? "bodyParts_group Left_Shoulder body_parts_active" : "bodyParts_group Left_Shoulder"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyParts",
	            d: "M833.78 334.19c-6.78 1.85-17.93 5.94-23.86 8.18 7.19.74 14.12 2.57 19.7 5.85 13.28 7.81 16.14 15.95 16.29 16.38v.01l.49-.11c.07.28 6.63 28.47 13.56 44.05 1.69 3.8 4.73 10.06 8.59 17.98 3.36 6.9 7.18 14.77 11.04 22.92v-.01c-.21-3.9-.45-9.49-.45-14.14 0-6.68 5.98-26.64 8.36-34.31v-.01c-.76-19.72-2.69-42.94-6-52.33-4.19-11.89-15.06-18.79-25.09-22.44-2.87.41-7.06 2.12-11.15 3.8-3.81 1.55-7.76 3.17-11.48 4.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M867.53 536.11c.07.85.11 1.29.11 1.31l1.99-.17c0-.02-.04-.42-.1-1.2-.68.09-1.33.1-2 .06zm12.06-86.68c.74 1.57 1.48 3.14 2.22 4.72h.06c-.01-.11-.73-10.89-.73-18.86 0-5.1 3.84-18.93 6.56-28.08v-.01c-.05-2.02-.12-4.1-.2-6.22-2.38 7.67-8.36 27.63-8.36 34.31 0 4.65.24 10.24.45 14.14z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M881.81 454.15c-.74-1.58-1.48-3.15-2.22-4.71.14 2.85.28 4.8.28 4.84l1.94-.13z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "syzst2",
	            d: "M867.53 536.11c.07.85.11 1.29.11 1.31l1.99-.17c0-.02-.04-.42-.1-1.2-.68.09-1.33.1-2 .06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyParts",
	            d: "M866.1 490.75c1.92 26.84 3.1 41.25 3.44 45.3 1.07-.14 2.15-.46 3.22-1 13.26-6.63 20.03-50.3 20.09-50.74l.16.02c-7.61-18.61-18.63-41.25-26.26-56.93-3.86-7.94-6.91-14.21-8.62-18.04-5.85-13.15-11.41-35.08-13.13-42.14-1.23 2.73-3.57 8.36-5.83 15.8l.27-.09c.24.74 24.36 75.68 26.66 107.82zm30.65-2.5c-4.38-22.25-9.68-49.5-9.09-59.49.27-4.57.29-12.42.04-21.55-2.72 9.15-6.56 22.98-6.56 28.08 0 7.97.72 18.75.73 18.86h-.06c5.49 11.71 10.88 23.72 14.94 34.1z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyParts",
	            d: "M867.52 536.11s.01 0 0 0c-.34-4.19-1.52-18.59-3.42-45.21-2.01-28.19-21.02-89.79-25.58-104.26-.23 5.49 1.73 14.57 3.49 22.75 1.4 6.5 2.72 12.64 3.07 17.1.18 2.33.07 4.47-.28 6.43l.55-2.29c-.08-1.75.6 4.53.37 12.18 0 1.92-.11 4.11-.43 6.47-.08.71-.17 1.42-.27 2.12.08 1.28.38 6.85.43 12.54.07 3.29.02 7.12-.38 10.29-.24 1.96-.6 3.75-1.06 5.39l.15 14.17c.96 5.62 3.04 16.32 5.37 28.23v.01c3.86 5.49 10.71 13.57 17.99 14.08z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M866.75 427.39c7.63 15.68 18.64 38.33 26.26 56.93l1.82.28c-.03.23-.17 1.11-.41 2.48l1.41.27c-.02.08-.2 1.06-.5 2.77v.01c1.61 4.17 2.99 8.04 4.05 11.48l-.03-.1c-.78-4.06-1.67-8.54-2.59-13.26-4.06-10.38-9.45-22.4-14.94-34.11l-1.94.13c0-.04-.14-2-.28-4.84-3.86-8.15-7.69-16.01-11.04-22.92-3.85-7.92-6.9-14.18-8.59-17.98-6.92-15.58-13.49-43.77-13.56-44.05l-.49.11.13.39-.19.37c-.01.02-.33.66-.85 1.83v.01c1.72 7.06 7.29 28.99 13.13 42.14 1.7 3.85 4.75 10.12 8.61 18.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M868.18 538.17c1.79 0 3.62-.41 5.46-1.33 8.5-4.25 14.32-21.48 17.68-35v-.03c1.33-8.4 2.38-14 2.54-14.82l.24.05c-.36-.89-.72-1.8-1.1-2.71l-.16-.02c-.06.44-6.83 44.11-20.09 50.74-1.07.54-2.15.86-3.22 1 .07.78.1 1.18.1 1.2l-1.99.17c0-.02-.04-.46-.11-1.31h-.01c-7.28-.51-14.13-8.59-17.99-14.09.3 1.52.6 3.06.9 4.61 4.39 5.49 10.8 11.54 17.75 11.54zm26.23-51.08c.24-1.37.38-2.25.41-2.48l-1.82-.28c.37.91.74 1.82 1.1 2.71l.31.05z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M867.53 536.11c.67.04 1.32.03 2-.06-.34-4.04-1.52-18.45-3.44-45.3-2.3-32.14-26.41-107.08-26.66-107.83l-.27.09c-.09.28-.17.57-.26.86-.23.76-.35 1.69-.39 2.75v.01c4.56 14.48 23.57 76.07 25.58 104.26 1.91 26.63 3.09 41.03 3.44 45.22zm28.29-48.75-1.41-.27c-.03.16-.06.33-.08.51v.02c.34.85.67 1.7.99 2.53v-.01c.3-1.72.48-2.7.5-2.78zm-1.96-.37c-.16.82-1.21 6.42-2.54 14.82 1.46-5.89 2.45-11.08 3.01-14.19-.08-.19-.15-.38-.23-.58l-.24-.05zm-2.54 14.83v.02-.02z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "m894.41 487.09-.31-.05c.08.19.15.38.23.58v-.02c.02-.18.05-.35.08-.51zM842.55 493l1.62.78c-.26-1.54-.44-2.7-.52-3.39-.33-2.91-.65-1.2-1.1 2.61z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M844.01 479.61c-.09.33-.2.65-.3.98L842.55 493c.45-3.81.77-5.52 1.1-2.61.08.69.26 1.85.52 3.39l-.16-14.17z"
	          }),
	          this.props.bodyTitle === "Left Shoulder" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "456",
	              width: "245",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M884.206 476.106h210" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1120.17 488.982v-25.558h5.203v21.216h12.937v4.342h-18.14Zm32.62-5.941 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429H1145.6c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.048 1.852-1.037 3.2h7.383Zm6.769-7.735h2.742v-1.406c0-1.57.167-2.742.501-3.516.334-.773.949-1.403 1.846-1.889.896-.487 2.03-.73 3.401-.73 1.406 0 2.783.211 4.131.633l-.668 3.445a9.783 9.783 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.71 0v3.938h-3.375v7.523c0 1.524.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.474l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.686-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.481v-8.138h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm12.15 10.284 5.063-.493c.304 1.7.922 2.948 1.854 3.744.932.797 2.189 1.196 3.771 1.196 1.675 0 2.938-.355 3.788-1.064.849-.709 1.274-1.538 1.274-2.487 0-.609-.179-1.128-.536-1.556-.357-.427-.982-.799-1.872-1.116-.61-.211-1.998-.586-4.166-1.125-2.789-.691-4.746-1.541-5.871-2.549-1.582-1.418-2.373-3.146-2.373-5.185 0-1.313.372-2.54 1.116-3.683.744-1.142 1.816-2.013 3.217-2.61 1.4-.598 3.091-.897 5.071-.897 3.234 0 5.669.709 7.304 2.127 1.634 1.418 2.493 3.311 2.575 5.678l-5.203.228c-.223-1.324-.7-2.276-1.433-2.856-.732-.58-1.831-.87-3.296-.87-1.511 0-2.695.31-3.551.932-.55.398-.826.931-.826 1.599 0 .61.258 1.131.774 1.565.656.55 2.25 1.125 4.781 1.722 2.531.598 4.403 1.216 5.616 1.855 1.213.638 2.162 1.512 2.848 2.619.685 1.107 1.028 2.476 1.028 4.104 0 1.477-.41 2.86-1.23 4.149-.821 1.289-1.981 2.247-3.481 2.874-1.5.627-3.369.94-5.607.94-3.258 0-5.76-.753-7.506-2.258-1.746-1.506-2.789-3.701-3.129-6.583Zm30.21-17.385v9.474c1.594-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.657.78 1.383.95 2.18.169.797.254 2.033.254 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.281-3.727a2.448 2.448 0 0 0-.993-1.256c-.475-.311-1.07-.466-1.785-.466-.82 0-1.552.199-2.197.597-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm15.93 16.172c0-1.641.404-3.229 1.213-4.764.808-1.535 1.954-2.707 3.436-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.953 0 2.824-.911 5.165-2.733 7.022-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.773-2.734-1.907-3.542-3.401-.809-1.495-1.213-3.314-1.213-5.458Zm5.062.263c0 1.852.44 3.27 1.318 4.254.879.985 1.963 1.477 3.252 1.477 1.29 0 2.371-.492 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.252 1.476-.878.985-1.318 2.403-1.318 4.254Zm30.358 9.334v-2.795a7.202 7.202 0 0 1-2.681 2.356 7.518 7.518 0 0 1-3.507.861c-1.254 0-2.379-.275-3.375-.826-.996-.551-1.717-1.324-2.162-2.32-.445-.996-.668-2.373-.668-4.131v-11.813h4.939v8.578c0 2.625.091 4.234.273 4.826.182.591.513 1.06.993 1.406.481.346 1.09.518 1.828.518.844 0 1.6-.231 2.268-.694.668-.463 1.125-1.037 1.371-1.723.246-.685.369-2.364.369-5.036v-7.875h4.939v18.668h-4.587Zm9.7-25.769h4.939v25.77h-4.939zm27.13 25.769h-4.588v-2.742c-.762 1.066-1.661 1.86-2.698 2.382-1.038.521-2.083.782-3.138.782-2.145 0-3.982-.864-5.511-2.593-1.529-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.233-7.216 1.488-1.646 3.369-2.47 5.642-2.47 2.086 0 3.891.868 5.414 2.602v-9.281h4.94v25.769Zm-13.184-9.738c0 1.992.276 3.434.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.137 0 2.104-.484 2.901-1.45.796-.967 1.195-2.412 1.195-4.333 0-2.145-.387-3.689-1.16-4.632-.774-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.466-2.944 1.397-.791.932-1.187 2.323-1.187 4.175Zm28.864 3.797 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.527-.422.926-1.102 1.195-2.039Zm.282-4.992c-.035-1.43-.405-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm13.648 10.933h-4.94v-18.668h4.588v2.655c.785-1.254 1.492-2.08 2.118-2.479.627-.398 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.307c-.832-.539-1.606-.809-2.32-.809-.692 0-1.278.191-1.758.571-.481.381-.859 1.07-1.134 2.066-.275.996-.413 3.082-.413 6.258v5.765Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Right Elbow" ? "bodyParts_group Right_Elbow body_parts_active" : "bodyParts_group Right_Elbow"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyLines",
	            d: "M614.66 584.43c-.24 2.59-.55 5.04-.95 7.33h-.01l.16.06c10.07-27.47 26.16-41.88 32.05-46.46.19-.96.38-1.93.57-2.91-3.4 2.39-20.21 15.18-31.82 41.98z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyLines",
	            d: "M613.7 591.76h.01c.4-2.29.71-4.74.95-7.33-.93 2.14-1.83 4.38-2.68 6.71l1.72.62z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyParts",
	            d: "M596.37 722.79s0 .02-.01.04c-.17.36-1.62 3.3-4.12 6.21-3.91 4.57-10.4 9.09-18.66 3.59-8.89-5.92-9.77-12.32-9.26-16.16 0-.01 0-.03.01-.04-5.83 15.64-16.78 40.32-17.68 51.14-1.01 11.97 24.13 49.33 27.28 52.49 4.14 4.13 11.66 3.42 9.66-1.57s-17.97-32.95-14.97-37.94c2.98-5 15.97-20.98 20.96-18.97 4.99 1.99 0 24.97 4.99 28.96 5 4 8.92-.01 9.98-7.98 1.06-7.95.39-11.09 2.43-16.21 2.76-6.88.42-12.7-1.37-17.91-1.56-4.56-5.51-8.27-6.88-12.4-1.68-5-3.36-6.58-2.01-14.97l-.07-.01c-.1.57-.19 1.15-.28 1.73z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyParts",
	            d: "m613.86 591.82-.16-.06c-.27 1.62-.6 3.16-.97 4.6-6.96 26.85-35.53 87.57-43.26 103.76-.1.66-.19 1.19-.27 1.57-.43 2.12-1.87 6.11-3.86 11.27 0 0 0 .01-.01.02s-.02.05-.03.07c-.01.03-.03.06-.04.08-.15.42-.31.84-.48 1.26-.01.03-.01.05-.03.07-.17.53-.32 1.2-.42 1.97l32.32 4.62c.23-1.46.48-2.93.72-4.39 1.76-10.56 26.41-64.28 31.7-86.28 5.27-22.02 10.56-44.9 11.44-54.59.34-3.74 2.65-16.15 5.4-30.43-5.89 4.58-21.98 18.99-32.05 46.46z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyParts",
	            d: "M604.67 490.15c-1.59 4.12-2.95 7.96-4.01 11.37 0 .01 0 .02-.01.03-1.04 5.47-1.9 10.14-2.4 13.49-2.64 17.61-13.2 46.66-15.85 70.44-2.26 20.33-9.02 84.43-12.03 108.08 10.19-21.59 34.16-73.54 40.42-97.7 7.09-27.34-3.6-91.55-6.12-105.71zm-40.35 226.32c-.51 3.84.37 10.24 9.26 16.16 8.26 5.5 14.75.98 18.66-3.59 2.5-2.91 3.95-5.85 4.12-6.21.01-.02.01-.04.01-.04.09-.58.18-1.16.28-1.74l-32.32-4.62c-.01.01-.01.03-.01.04z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyLines",
	            d: "m613.7 591.76-1.72-.62c.85-2.33 1.75-4.57 2.68-6.71 2.24-24.89-2.72-62.1-5.98-82.62-1.46-5.9-2.45-11.1-3.01-14.21-.34.86-.67 1.71-1 2.55 2.52 14.16 13.21 78.37 6.12 105.71-6.26 24.16-30.23 76.11-40.42 97.7-.36 2.8-.66 5.03-.9 6.56 7.73-16.19 36.3-76.91 43.26-103.76.37-1.44.7-2.98.97-4.6z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyParts",
	            d: "M631.82 538.17c-1.8 0-3.63-.41-5.47-1.33-8.5-4.25-14.31-21.5-17.67-35.03 3.26 20.52 8.22 57.73 5.98 82.62 11.61-26.8 28.42-39.59 31.82-41.98 1.01-5.2 2.06-10.57 3.09-15.82-4.39 5.49-10.8 11.54-17.75 11.54z"
	          }),
	          this.props.bodyTitle === "Right Elbow" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "155",
	              y: "594",
	              width: "225",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup is_right" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M405 616.324h180" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M174.444 625.421v-25.77h10.951c2.754 0 4.755.232 6.003.695 1.248.463 2.247 1.286 2.997 2.469.75 1.184 1.125 2.537 1.125 4.061 0 1.934-.568 3.53-1.705 4.79-1.137 1.26-2.836 2.054-5.098 2.382 1.125.656 2.054 1.377 2.786 2.162.733.785 1.72 2.18 2.962 4.183l3.147 5.028h-6.223l-3.762-5.608c-1.335-2.003-2.25-3.266-2.742-3.788-.492-.521-1.013-.879-1.564-1.072-.551-.193-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.054-.106 4.675-.317a2.8 2.8 0 0 0 1.459-1.09c.352-.515.528-1.16.528-1.933 0-.867-.232-1.567-.695-2.101-.462-.533-1.116-.87-1.96-1.01-.421-.059-1.687-.088-3.796-.088h-4.061v6.539Zm20.742-6.328v-4.571h4.94v4.571h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.23 5.643.686c.093.656.31 1.107.65 1.353.469.352 1.207.528 2.215.528 1.289 0 2.256-.194 2.9-.58.434-.258.762-.674.985-1.248.152-.411.228-1.166.228-2.268v-2.725c-1.476 2.016-3.34 3.024-5.59 3.024-2.507 0-4.494-1.061-5.959-3.182-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.753-5.519 2.259-7.171 1.505-1.653 3.377-2.479 5.616-2.479 2.308 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.849-.545 4.939-.364 1.09-.873 1.946-1.53 2.567-.656.621-1.532 1.107-2.627 1.459-1.096.351-2.482.527-4.158.527-3.164 0-5.408-.542-6.732-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.005-.363.017-.598Zm4.412-10.951c0 1.981.384 3.431 1.152 4.351.767.92 1.713 1.38 2.838 1.38 1.207 0 2.227-.472 3.059-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.024-1.407-1.183 0-2.159.46-2.926 1.38-.768.92-1.152 2.323-1.152 4.21Zm22.957-16.049v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.958-.093-3.2-.281-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.821 0-1.553.2-2.197.598-.645.398-1.117.999-1.415 1.802-.299.802-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm25.629 7.102v3.937h-3.375v7.524c0 1.523.032 2.411.097 2.663.064.252.211.46.439.624.229.164.507.246.835.246.457 0 1.119-.158 1.987-.475l.421 3.832c-1.148.493-2.449.739-3.902.739-.891 0-1.693-.15-2.408-.449-.715-.298-1.239-.685-1.573-1.16-.334-.474-.566-1.116-.695-1.924-.105-.575-.158-1.735-.158-3.481v-8.139h-2.267v-3.937h2.267v-3.709l4.957-2.883v6.592h3.375Zm13.465 18.668v-25.77h19.107v4.36H281.6v5.713h12.938v4.341H281.6v7.014h14.397v4.342h-19.6Zm23.977-25.77h4.939v25.77h-4.939zm9.791 25.77v-25.77h4.939v9.282c1.523-1.735 3.328-2.602 5.414-2.602 2.274 0 4.154.823 5.643 2.47 1.488 1.646 2.232 4.01 2.232 7.092 0 3.188-.759 5.643-2.276 7.366-1.518 1.722-3.361 2.584-5.529 2.584-1.066 0-2.118-.267-3.155-.8s-1.931-1.321-2.681-2.364v2.742h-4.587Zm4.904-9.738c0 1.933.305 3.363.914 4.289.855 1.312 1.992 1.968 3.41 1.968 1.09 0 2.019-.465 2.786-1.397.768-.932 1.152-2.4 1.152-4.403 0-2.133-.387-3.671-1.161-4.615-.773-.943-1.763-1.415-2.97-1.415-1.184 0-2.168.46-2.953 1.38-.786.92-1.178 2.318-1.178 4.193Zm16.154.14c0-1.64.404-3.228 1.213-4.763.809-1.536 1.954-2.708 3.437-3.516 1.482-.809 3.137-1.213 4.965-1.213 2.825 0 5.139.917 6.944 2.751 1.804 1.834 2.707 4.151 2.707 6.952 0 2.824-.911 5.165-2.734 7.023-1.822 1.857-4.116 2.786-6.881 2.786-1.711 0-3.343-.387-4.896-1.16-1.553-.774-2.733-1.908-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.063.264c0 1.851.439 3.269 1.318 4.254.879.984 1.963 1.476 3.252 1.476 1.289 0 2.37-.492 3.243-1.476.873-.985 1.31-2.414 1.31-4.289 0-1.828-.437-3.235-1.31-4.219-.873-.984-1.954-1.477-3.243-1.477s-2.373.493-3.252 1.477c-.879.984-1.318 2.402-1.318 4.254Zm21.55 9.334-5.906-18.668h4.799l3.498 12.234 3.217-12.234h4.764l3.111 12.234 3.568-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Left Elbow" ? "bodyParts_group Left_Elbow body_parts_active" : "bodyParts_group Left_Elbow"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyParts",
	            d: "M953.35 767.56c-.9-10.82-11.85-35.5-17.68-51.14.52 3.83-.33 10.26-9.25 16.2-8.26 5.5-14.76.98-18.67-3.59-2.49-2.91-3.94-5.85-4.11-6.21-.02-.02-.02-.04-.02-.04-.09-.58-.18-1.16-.28-1.74l-.06.01c1.34 8.39-.34 9.97-2.01 14.97-1.38 4.13-5.32 7.84-6.88 12.4-1.78 5.21-4.13 11.03-1.37 17.91 2.04 5.11 1.37 8.26 2.43 16.21 1.06 7.97 4.99 11.99 9.98 7.98 4.99-3.99 0-26.97 4.99-28.96 5-2 17.98 13.98 20.96 18.97 3 4.99-12.97 32.95-14.97 37.94-2 5 5.52 5.7 9.66 1.57 3.15-3.14 28.29-40.5 27.28-52.48z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyParts",
	            d: "M935.67 716.43c-.11-.77-.27-1.43-.43-1.97-.01-.02-.01-.04-.02-.07-.17-.42-.34-.84-.49-1.26-.01-.02-.02-.05-.03-.08-.01-.02-.02-.06-.04-.07-.01-.01-.01-.02-.01-.02-1.99-5.16-3.42-9.15-3.85-11.27-.08-.38-.17-.91-.27-1.57-7.73-16.19-36.3-76.91-43.26-103.76-.37-1.44-.7-2.98-.97-4.6l-.16.06c-10.08-27.47-26.17-41.88-32.05-46.46 2.75 14.28 5.06 26.69 5.4 30.43.88 9.69 6.16 32.57 11.44 54.59 5.29 22 29.94 75.72 31.7 86.28.24 1.46.48 2.93.71 4.39l32.33-4.62zm-32.05 6.36s0 .02.02.04c.17.36 1.62 3.3 4.11 6.21 3.91 4.57 10.41 9.09 18.67 3.59 8.92-5.94 9.77-12.37 9.25-16.2l-32.33 4.62c.1.58.19 1.16.28 1.74z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyLines",
	            d: "m886.14 591.82.16-.06c-.41-2.29-.72-4.74-.96-7.33-11.61-26.8-28.42-39.59-31.82-41.98.19.98.38 1.95.57 2.91 5.88 4.58 21.97 18.99 32.05 46.46z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyLines",
	            d: "M885.34 584.43c.24 2.59.55 5.04.96 7.33l1.72-.62c-.85-2.33-1.75-4.57-2.68-6.71z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyParts",
	            d: "M889.2 595.86c6.27 24.16 30.24 76.11 40.43 97.7-3.01-23.65-9.77-87.75-12.03-108.08-2.65-23.78-13.21-52.83-15.85-70.44-.5-3.33-1.36-7.97-2.38-13.4v-.02c-1.06-3.44-2.44-7.31-4.05-11.48-2.51 14.15-13.2 78.36-6.12 105.72z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyParts",
	            d: "M891.32 501.83c-3.36 13.53-9.18 30.76-17.68 35-1.84.92-3.67 1.33-5.46 1.33-6.95 0-13.36-6.05-17.75-11.54 1.03 5.25 2.08 10.62 3.09 15.82 3.4 2.39 20.21 15.18 31.82 41.98-2.24-24.87 2.72-62.06 5.98-82.59z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyLines",
	            d: "M929.63 693.56c-10.19-21.59-34.16-73.54-40.43-97.7-7.08-27.35 3.61-91.57 6.12-105.72-.32-.83-.65-1.67-.99-2.53-.56 3.11-1.55 8.3-3.01 14.19v.03c-3.26 20.53-8.22 57.71-5.98 82.59.93 2.14 1.83 4.38 2.68 6.71l-1.72.62c.27 1.62.6 3.16.97 4.6 6.96 26.85 35.53 87.57 43.26 103.76-.24-1.52-.54-3.75-.9-6.55z"
	          }),
	          this.props.bodyTitle === "Left Elbow" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "592",
	              width: "195",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M914.206 612.527h180" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1120.17 625.421v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.62-5.942 4.922.827c-.633 1.804-1.632 3.178-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.434 0-3.093.808-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429H1145.6c.036 1.465.434 2.604 1.196 3.419.761.814 1.711 1.221 2.847 1.221.774 0 1.424-.211 1.951-.633.528-.421.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.567-1.117-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.852-1.037 3.199h7.383Zm6.769-7.734h2.742v-1.406c0-1.571.167-2.743.501-3.516.334-.773.949-1.403 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.633l-.668 3.445a9.729 9.729 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.975-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.71 0v3.937h-3.375v7.524c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.149.493-2.449.739-3.902.739-.891 0-1.694-.15-2.409-.449-.715-.298-1.239-.685-1.573-1.16-.334-.474-.565-1.116-.694-1.924-.106-.575-.158-1.735-.158-3.481v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm13.47 18.668v-25.77h19.108v4.36h-13.904v5.713h12.937v4.341h-12.937v7.014h14.396v4.342h-19.6Zm23.97-25.77h4.939v25.77h-4.939zm9.79 25.77v-25.77h4.939v9.282c1.524-1.735 3.329-2.602 5.415-2.602 2.273 0 4.154.823 5.642 2.47 1.488 1.646 2.233 4.01 2.233 7.092 0 3.188-.759 5.643-2.277 7.366-1.517 1.722-3.36 2.584-5.528 2.584-1.067 0-2.118-.267-3.155-.8-1.038-.533-1.931-1.321-2.681-2.364v2.742h-4.588Zm4.904-9.738c0 1.933.305 3.363.914 4.289.856 1.312 1.993 1.968 3.411 1.968 1.089 0 2.018-.465 2.786-1.397.767-.932 1.151-2.4 1.151-4.403 0-2.133-.387-3.671-1.16-4.615-.774-.943-1.764-1.415-2.971-1.415-1.183 0-2.168.46-2.953 1.38-.785.92-1.178 2.318-1.178 4.193Zm16.156.14c0-1.64.404-3.228 1.212-4.763.809-1.536 1.955-2.708 3.437-3.516 1.482-.809 3.138-1.213 4.966-1.213 2.824 0 5.138.917 6.943 2.751 1.805 1.834 2.707 4.151 2.707 6.952 0 2.824-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.896-1.16-1.552-.774-2.733-1.908-3.542-3.402-.808-1.494-1.212-3.313-1.212-5.458Zm5.062.264c0 1.851.44 3.269 1.318 4.254.879.984 1.963 1.476 3.252 1.476 1.289 0 2.371-.492 3.244-1.476.873-.985 1.309-2.414 1.309-4.289 0-1.828-.436-3.235-1.309-4.219-.873-.984-1.955-1.477-3.244-1.477-1.289 0-2.373.493-3.252 1.477-.878.984-1.318 2.402-1.318 4.254Zm21.548 9.334-5.906-18.668h4.798l3.498 12.234 3.217-12.234h4.764l3.111 12.234 3.569-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Right Thigh" ? "bodyParts_group Right_Thigh body_parts_active" : "bodyParts_group Right_Thigh"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "syzst2",
	            d: "M657.45 678.84c.01-9.5-.37-18.1-.6-22.44l-.17.01c.02.2.74 10.29.77 22.43zm-9.4 61.17c-.02 2.45-.04 5.68-.03 9.41.01-5.61.09-9.29.09-9.41h-.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyParts",
	            d: "M713.04 826.06c1.34 22.23 6.14 105.35 4.62 123.56-3.09 37.1-1.01 60.83 5.71 65.1 1.81 1.16 3.44 1.41 4.98.77 2.26-.92 4.06-3.67 5.34-6.44v-.01c.63-5.03 1.03-9.48 1.03-12.4 0-6.67-.84-60.42-1.65-98.47v-.01c-1.81-6.71-9.65-36.05-11.23-47.09-.69-4.88-4.13-14.29-8.8-25.01zm-28.96 174.97c5.92-11.84 5.24-22.66 3.42-39.06-.98-8.84-12.16-53.22-22.03-92.39-7.79-30.93-15.15-60.14-16.7-68.66-3.03-16.67-2.81-49.86-2.7-58.73-3 8.46-5.62 17.63-6.77 28.72-2.26 21.85 1.16 83.56 2.13 99.93.01.02.01.04.01.05 5.6 30.86 15.32 85.03 16.68 93.17 1.49 8.98 4.9 34.45 5.35 51.64 4.75-1.36 16.01-5.47 20.61-14.67zm28.6-279.36c6.57 20.77 13.95 48.19 17.13 60.01.45 1.67.8 2.97 1.03 3.83 1.73 6.33 4.14 16.86 5.59 23.35.43-3.57.76-6.52.93-8.56.88-10.57 0-29.93 0-34.34 0-.66.3-1.21.81-1.64-2.68-2.97-8.84-9.98-10.95-14.2-1.62-3.23-9.07-17.79-14.54-28.45zm15.19 60.53c-13.14-48.86-21.93-77.11-26.14-83.95-2.49-4.05-7.73-11.71-13.79-20.59-2.86-4.2-5.92-8.67-8.92-13.11 0-.01 0-.01-.01-.01-1.32-.61-7.53-3.48-13.65-6.26 2.73 10.74 15.33 58.81 28.44 86.57 3.16 6.69 6.13 12.87 8.88 18.61 10.23 21.34 17.62 36.75 21.11 49.34 2.54 9.14 6.02 24.58 8.5 35.96.66-10.73 2.19-23.64 3.42-33.85v-.01c-.3-1.37-4.29-19.63-6.8-28.86-.23-.86-.59-2.17-1.04-3.84z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyParts",
	            d: "M637.31 770.7c1.65-15.93 6.27-27.89 10.74-39.45 2.69-6.98 5.23-13.56 6.89-20.55 1.96-8.21 2.5-20.65 2.51-31.85-.04-12.15-.76-22.24-.77-22.43l.17-.01-.12-2.06c-6.25-3.13-10.75-11.62-12.45-15.29-4.54 19.68-13.76 68.76-16.1 82-2.65 14.97-4.41 41.38-3.53 54.58.88 13.22 10.56 61.63 13.21 75.72.18.94.41 2.16.69 3.7-1.29-25.11-3.03-67.06-1.24-84.36zm63.56-6.38c-2.75-5.74-5.72-11.92-8.88-18.62-14.01-29.66-27.39-82.21-28.96-88.49-1.53-.7-3.02-1.37-4.38-1.98l.02.02c.05.42 4.46 43.4 9.66 62.47.73 2.67 1.46 5.45 2.21 8.3 4.69 17.87 10.01 38.12 20.55 53.92 12.64 18.96 30.99 58.69 32.73 70.84 1.18 8.24 6.03 27.35 9.06 38.87-.3-13.26-.58-23.61-.81-27.72-.09-1.55-.11-3.27-.09-5.16v-.01c-2.32-10.87-6.96-32.06-10.11-43.43-3.45-12.41-10.81-27.76-21-49.01z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyParts",
	            d: "M648.11 740.01c0 .12-.08 3.8-.09 9.41.03 15.27.48 38.84 2.72 51.14 1.54 8.46 8.89 37.64 16.67 68.53 9.32 37.02 18.93 75.16 21.49 88.97v.01l.2-.04c.02.09 1.96 8.69 10.05 10.81 7.31 1.91 14.38-6.36 15.71-8.03v-.01c.24-4.05.52-7.9.81-11.35 1.71-20.46-4.66-123.97-4.95-128.59v-.01c-6.51-14.29-14.69-29.89-21.3-39.81-10.71-16.07-16.08-36.49-20.82-54.51-.74-2.84-1.47-5.61-2.2-8.29-2.68-9.82-5.14-25.61-6.92-38.77.01 10.76-.53 23.05-2.59 31.7-1.69 7.11-4.26 13.76-6.98 20.8-.61 1.58-1.22 3.17-1.83 4.77-.01.83-.02 1.94-.04 3.27h.07zm9.97-87.22c5.53 2.46 14.12 6.41 18.77 8.55-7.46-11.12-14.25-21.59-16.56-26.58-3.48-7.56-4.32-18.98-4.46-26.19-4.02 9-8.3 18.38-10.03 24.44-.28.99-.62 2.27-.99 3.83l.59-.23c.05.13 5.23 12.87 12.68 16.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M729.81 781.68c-3.18-11.82-10.56-39.24-17.13-60.01v-.01c-3.34-6.51-5.93-11.56-6-11.7l1.78-.92c-1.93-5.42-3.67-9.62-5.03-11.83-2.52-4.1-7.76-11.78-13.84-20.67-10.74-15.74-24.11-35.32-27.48-42.62-4.17-9.03-4.36-24.41-4.28-29.93-.65 1.47-1.32 2.98-2 4.5v.08c.14 7.21.98 18.63 4.46 26.19 2.31 4.99 9.1 15.46 16.56 26.58l.01.01c1.95.9 3.21 1.48 3.25 1.5l-.84 1.81c-.01 0-.1-.04-.25-.11 3 4.44 6.06 8.91 8.92 13.11 6.06 8.88 11.3 16.54 13.79 20.59 4.21 6.84 13 35.09 26.14 83.95.45 1.67.81 2.98 1.04 3.84 2.51 9.23 6.5 27.49 6.8 28.86.26-2.15.5-4.17.72-6.03v-.01c-1.45-6.49-3.86-17.02-5.59-23.35-.23-.86-.58-2.16-1.03-3.83z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M708.48 709.08c1.33 3.71 2.74 7.97 4.2 12.58v.01c5.47 10.66 12.92 25.22 14.54 28.45 2.11 4.22 8.27 11.23 10.95 14.2.46-.41 1.09-.73 1.82-.99-2.43-2.66-8.92-9.97-10.98-14.1-2.58-5.15-19.82-38.77-20.53-40.15z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M712.68 721.66c-1.46-4.61-2.87-8.87-4.2-12.58-.01-.02-.02-.03-.02-.04l-1.78.92c.07.14 2.66 5.19 6 11.7zm-10 41.8c-2.75-5.74-5.72-11.92-8.88-18.61-13.11-27.77-25.71-75.84-28.44-86.57 0 0-.01 0-.01-.01-.78-.36-1.55-.71-2.32-1.06 1.57 6.28 14.95 58.83 28.96 88.49 3.16 6.7 6.13 12.88 8.88 18.62 10.19 21.25 17.55 36.6 21 49.01 3.15 11.37 7.79 32.56 10.11 43.43.03-2.45.14-5.15.31-8-2.48-11.38-5.96-26.82-8.5-35.96-3.49-12.59-10.88-28-21.11-49.34zm-11.59 16.48c-10.54-15.8-15.86-36.05-20.55-53.92-.75-2.85-1.48-5.63-2.21-8.3-5.2-19.07-9.61-61.05-9.66-61.47l-1.82.16c.23 4.34.61 12.94.6 22.44.03 10.84-.48 23.31-2.51 31.85-1.66 6.99-4.2 13.57-6.89 20.55-4.47 11.56-9.09 23.52-10.74 39.45-1.79 17.3-.05 59.25 1.25 84.36 0 .03.01.06.01.09.7 3.77 1.69 9.21 2.86 15.69-.97-16.37-4.39-78.08-2.13-99.93 1.15-11.09 3.77-20.26 6.77-28.72v-.02c.02-1.36.04-2.15.04-2.2l.76.02 1.24-4.98c0 .05-.01.66-.03 1.73.61-1.6 1.22-3.19 1.83-4.77 2.72-7.04 5.29-13.69 6.98-20.8 2.06-8.65 2.6-20.94 2.59-31.7 1.78 13.16 4.24 28.95 6.92 38.77.73 2.68 1.46 5.45 2.2 8.29 4.74 18.02 10.11 38.44 20.82 54.51 6.61 9.92 14.79 25.52 21.3 39.81v-.01c-.01-.07-.01-.11-.01-.13l2-.13c.01.14.13 2.11.33 5.48 4.67 10.72 8.11 20.13 8.8 25.01 1.58 11.04 9.42 40.38 11.23 47.09-.06-2.94-.12-5.78-.19-8.49v-.02c-3.03-11.52-7.88-30.63-9.06-38.87-1.74-12.15-20.09-51.88-32.73-70.84z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "m656.74 654.35.12 2.06 1.82-.16c.05.42 4.46 42.4 9.66 61.47-5.2-19.07-9.61-62.05-9.66-62.47l-.02-.02c-.48-.21-.94-.42-1.38-.61-.19-.08-.36-.18-.54-.27zm.71 24.49c-.01 11.2-.56 23.64-2.51 31.85 2.04-8.54 2.55-21.01 2.51-31.85z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M656.74 654.35c-.03-.56-.06-.9-.06-.93l1.97 1.81c1.36.61 2.85 1.28 4.38 1.98-.1-.38-.15-.59-.16-.62l1.94-.48c.02.06.2.82.54 2.16h.01v.01c6.12 2.79 12.33 5.66 13.65 6.26-.71-1.07-1.43-2.13-2.15-3.19l-.01-.01c-4.65-2.14-13.24-6.09-18.77-8.55-7.45-3.31-12.63-16.05-12.68-16.18l-.59.23v.01c-.17.69-.34 1.42-.52 2.21 1.7 3.66 6.2 12.15 12.45 15.29z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M656.74 654.35c.18.09.35.19.53.27.44.2.91.4 1.38.61l-1.97-1.81c0 .03.03.36.06.93zm22.28 10.2c.15.07.24.11.25.11l.84-1.81c-.04-.02-1.3-.6-3.25-1.5.72 1.06 1.44 2.12 2.15 3.19.01 0 .01 0 .01.01zm-16.15-7.96c.01.03.06.24.16.62.77.35 1.54.7 2.32 1.06-.34-1.34-.52-2.1-.54-2.16l-1.94.48zm2.48 1.68h.01zm20.52 343.66c5.85-11.69 5.53-22.24 3.9-37.58v-.01c-1.95-2.92-2.58-5.68-2.63-5.9l1.76-.37v-.01c-2.56-13.81-12.17-51.95-21.49-88.97-7.78-30.89-15.13-60.07-16.67-68.53-2.44-13.42-2.76-37.77-2.72-51.14-.01-3.73.01-6.96.03-9.41l-1.18-.02c-.27.73-.54 1.45-.8 2.19v.01c-.11 8.87-.33 42.06 2.7 58.73 1.55 8.52 8.91 37.73 16.7 68.66 9.87 39.17 21.05 83.55 22.03 92.39 1.82 16.4 2.5 27.22-3.42 39.06-4.6 9.2-15.86 13.31-20.61 14.67.02.71.03 1.41.04 2.08 4.7-1.26 17.18-5.49 22.36-15.85z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M650.74 800.56c-2.24-12.3-2.69-35.87-2.72-51.14-.03 13.37.28 37.72 2.72 51.14zm-2.66-63.83c-.41 1.08-.82 2.15-1.21 3.25l1.18.02c.01-1.33.02-2.44.03-3.27z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "m648.11 735.01-1.24 4.98c.4-1.1.81-2.18 1.21-3.25.02-1.08.03-1.69.03-1.73zm-2 4.96c0 .05-.02.84-.04 2.2v.01c.26-.74.53-1.46.8-2.19l-.76-.02zm82.24 275.52c-1.54.64-3.17.39-4.98-.77-6.72-4.27-8.8-28-5.71-65.1 1.52-18.21-3.28-101.33-4.62-123.56-.75-1.7-1.52-3.44-2.32-5.2.29 4.62 6.66 108.13 4.95 128.59-.29 3.45-.57 7.3-.81 11.35v.01c.14-.17.22-.28.22-.29l1.61 1.19c-.1.13-.82 1.08-2 2.33-1.05 21.46-.5 47.21 7.6 52.36 1.49.95 2.96 1.43 4.37 1.43.84 0 1.65-.17 2.45-.5 1.51-.62 2.8-1.79 3.88-3.19.26-1.74.49-3.45.7-5.1-1.28 2.78-3.08 5.53-5.34 6.45z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M713.04 826.06c-.2-3.37-.32-5.34-.33-5.48l-2 .13c0 .02 0 .06.01.13v.02c.8 1.76 1.57 3.5 2.32 5.2zm-13.89 142.77c-8.1-2.12-10.04-10.72-10.05-10.81l-.2.04c.29 1.55.49 2.79.59 3.68.1.88.19 1.74.28 2.59 1.73 2.58 4.5 5.28 8.88 6.43.94.25 1.86.36 2.77.36 5.65 0 10.63-4.29 13.28-7.08.06-1.1.11-2.17.17-3.24-1.34 1.67-8.41 9.94-15.72 8.03z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "m688.9 958.06-1.76.37c.05.21.67 2.98 2.63 5.9-.09-.85-.18-1.71-.28-2.59-.1-.89-.3-2.13-.59-3.68zm27.79 3.65-1.61-1.19c-.01.01-.08.11-.22.29-.06 1.07-.11 2.14-.17 3.24 1.18-1.25 1.9-2.21 2-2.34z"
	          }),
	          this.props.bodyTitle === "Right Thigh" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "165",
	              y: "861",
	              width: "215",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup is_right" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M405 883.94h250" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M184.565 893.037v-25.77h10.951c2.754 0 4.755.232 6.003.695 1.248.463 2.247 1.286 2.997 2.47.75 1.183 1.125 2.537 1.125 4.06 0 1.934-.568 3.53-1.705 4.79-1.137 1.26-2.836 2.054-5.097 2.382 1.125.656 2.053 1.377 2.786 2.162.732.785 1.719 2.18 2.962 4.184l3.146 5.027h-6.223l-3.761-5.607c-1.336-2.004-2.25-3.267-2.743-3.789-.492-.521-1.013-.878-1.564-1.072-.551-.193-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.055-.106 4.676-.317a2.801 2.801 0 0 0 1.459-1.089c.351-.516.527-1.161.527-1.934 0-.867-.232-1.567-.694-2.101-.463-.533-1.117-.87-1.96-1.01-.422-.059-1.688-.088-3.797-.088h-4.061v6.539Zm20.742-6.328v-4.571h4.94v4.571h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.23 5.643.686c.094.656.31 1.107.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.194 2.901-.58.433-.258.761-.674.984-1.248.152-.41.228-1.166.228-2.268v-2.724c-1.476 2.015-3.339 3.023-5.589 3.023-2.508 0-4.495-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.657.621-1.533 1.107-2.628 1.459-1.096.351-2.482.527-4.158.527-3.164 0-5.408-.542-6.732-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.598Zm4.412-10.951c0 1.981.384 3.431 1.152 4.351.767.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.023-1.407-1.184 0-2.16.46-2.927 1.38-.768.92-1.152 2.324-1.152 4.21Zm22.957-16.049v9.475c1.594-1.863 3.499-2.795 5.713-2.795 1.137 0 2.162.211 3.077.633.914.422 1.602.961 2.065 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.474-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.116.999-1.415 1.802-.299.803-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm25.629 7.102v3.938h-3.375v7.523c0 1.523.033 2.411.097 2.663.065.252.211.46.44.624.228.164.506.246.834.246.457 0 1.12-.158 1.987-.474l.422 3.832c-1.149.492-2.45.738-3.903.738-.89 0-1.693-.15-2.408-.448-.715-.299-1.239-.686-1.573-1.161-.334-.474-.566-1.116-.694-1.924-.106-.575-.159-1.735-.159-3.481v-8.138h-2.267v-3.938h2.267v-3.709l4.957-2.883v6.592h3.375Zm19.266 18.668v-21.41h-7.646v-4.36h20.478v4.36h-7.629v21.41h-5.203Zm21.076-25.77v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.093-3.2-.281-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.821 0-1.553.2-2.198.598-.644.399-1.116.999-1.415 1.802-.298.803-.448 1.989-.448 3.559v9.352h-4.939v-25.77h4.939Zm17.069 4.571v-4.571h4.939v4.571h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.544 1.23 5.643.686c.094.656.311 1.107.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.194 2.901-.58.433-.258.761-.674.984-1.248.152-.41.229-1.166.229-2.268v-2.724c-1.477 2.015-3.34 3.023-5.59 3.023-2.508 0-4.494-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.656.621-1.532 1.107-2.628 1.459-1.096.351-2.482.527-4.157.527-3.164 0-5.409-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.598Zm4.413-10.951c0 1.981.383 3.431 1.151 4.351.768.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.023-1.407-1.184 0-2.159.46-2.927 1.38-.768.92-1.151 2.324-1.151 4.21Zm22.957-16.049v9.475c1.593-1.863 3.498-2.795 5.712-2.795 1.137 0 2.163.211 3.077.633.914.422 1.602.961 2.065 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.474-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.559v9.352h-4.94v-25.77h4.94Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Left Thigh" ? "bodyParts_group Left_Thigh body_parts_active" : "bodyParts_group Left_Thigh"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "syzst2",
	            d: "M842.55 678.87c.04-12.16.76-22.26.77-22.45l-.17-.01c-.23 4.34-.61 12.94-.6 22.46zm9.42 70.95c.01-3.99-.01-7.39-.04-9.81h-.05c0 .12.08 3.97.09 9.81z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyParts",
	            d: "M789.27 820.89c-.3 5.01-6.65 108.14-4.94 128.56.29 3.46.57 7.3.81 11.36 1.34 1.66 8.42 9.94 15.71 8.02 8.13-2.13 10.04-10.72 10.05-10.81l.19.04c2.56-13.8 12.17-51.94 21.49-88.96 7.79-30.9 15.14-60.09 16.68-68.55 2.25-12.39 2.69-35.78 2.71-50.74-.01-5.83-.09-9.69-.09-9.81h.05c-.02-1.52-.03-2.66-.04-3.32-.6-1.58-1.2-3.16-1.8-4.72-2.72-7.04-5.29-13.69-6.98-20.8-2.06-8.65-2.61-20.94-2.59-31.7-1.78 13.16-4.24 28.95-6.92 38.77-.73 2.68-1.46 5.45-2.21 8.3-4.73 18.01-10.1 38.43-20.82 54.5-6.61 9.92-14.79 25.53-21.3 39.83v.03zm8.05-57.42c2.75-5.74 5.71-11.93 8.88-18.62 13.11-27.78 25.7-75.83 28.43-86.57-6.16 2.81-12.39 5.69-13.66 6.28-2.99 4.45-6.05 8.92-8.92 13.12-6.06 8.87-11.29 16.53-13.78 20.58-1.24 2.03-2.9 5.94-4.95 11.71 0 .01-.01.02-.02.04-4.85 13.71-11.95 37.88-21.19 72.24-.44 1.65-.79 2.95-1.02 3.8-2.49 9.1-6.39 26.97-6.8 28.79v.03c1.22 10.21 2.75 23.12 3.42 33.86 2.48-11.38 5.96-26.79 8.49-35.92 3.5-12.59 10.89-28.01 21.12-49.34z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyParts",
	            d: "M771.65 1015.49c1.54.64 3.17.39 4.98-.77 6.72-4.27 8.79-28 5.7-65.1-1.51-18.2 3.29-101.31 4.63-123.56-4.68 10.72-8.11 20.13-8.8 25.01-1.58 11.03-9.4 40.33-11.23 47.07-.81 38.05-1.65 91.83-1.65 98.5 0 2.92.4 7.37 1.03 12.4v.01c1.22 2.68 3 5.48 5.34 6.44zm-1.47-233.77c3.18-11.83 10.57-39.3 17.15-60.08-5.47 10.66-12.93 25.24-14.55 28.48-2.11 4.22-8.26 11.22-10.95 14.19.51.44.81.99.81 1.65 0 4.41-.88 23.77 0 34.34.17 2.04.5 4.99.93 8.56 1.45-6.49 3.86-17.02 5.59-23.35.23-.85.58-2.14 1.02-3.79zm52.96-120.38c4.65-2.14 13.25-6.09 18.77-8.55 7.47-3.32 12.63-16.06 12.68-16.19l.6.24c-.38-1.56-.72-2.85-1-3.84-1.73-6.06-6.02-15.51-10.04-24.52-.13 7.2-.95 18.68-4.45 26.27-2.29 5-9.08 15.47-16.56 26.59zm37.55 109.57c-1.15-11.1-3.77-20.27-6.77-28.74.12 8.84.34 42.07-2.69 58.75-1.55 8.52-8.91 37.74-16.71 68.68-9.86 39.16-21.04 83.54-22.02 92.37-1.82 16.4-2.5 27.21 3.42 39.06 4.6 9.21 15.88 13.31 20.61 14.67.45-17.19 3.86-42.66 5.35-51.64 1.36-8.13 11.07-62.22 16.67-93.09.96-16.18 4.41-78.15 2.14-100.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyParts",
	            d: "m843.26 654.35-.12 2.06.17.01c-.02.19-.74 10.29-.77 22.45.01 11.19.55 23.63 2.5 31.83 1.66 6.99 4.21 13.57 6.9 20.55 4.47 11.56 9.08 23.52 10.73 39.45 1.79 17.3.05 59.26-1.24 84.37l.68-3.71c2.65-14.09 12.34-62.5 13.22-75.72.88-13.2-.88-39.61-3.53-54.58-2.34-13.24-11.56-62.34-16.1-82.01-1.69 3.66-6.18 12.15-12.44 15.3zm-34.35 125.59c10.53-15.8 15.85-36.05 20.55-53.91.75-2.85 1.48-5.63 2.21-8.31 4.75-17.42 8.84-55.63 9.54-62.42-1.32.59-2.76 1.24-4.24 1.91-1.57 6.29-14.96 58.83-28.96 88.49-3.17 6.7-6.14 12.89-8.89 18.64-10.18 21.24-17.54 36.58-20.99 48.99-3.15 11.37-7.79 32.56-10.11 43.43v.01c.02 1.88 0 3.61-.09 5.16-.23 4.1-.51 14.45-.81 27.7 3.03-11.52 7.88-30.62 9.06-38.85 1.73-12.15 20.09-51.88 32.73-70.84z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M772.11 782.24c9.24-34.36 16.34-58.53 21.19-72.24-.26.51-2.77 5.4-5.97 11.63v.01c-6.58 20.78-13.97 48.25-17.15 60.08-.44 1.65-.79 2.94-1.02 3.79-1.73 6.33-4.14 16.86-5.59 23.35v.01c.22 1.84.46 3.84.72 5.96.41-1.82 4.31-19.69 6.8-28.79.23-.85.58-2.15 1.02-3.8zm65.78-148.32c-3.37 7.3-16.75 26.88-27.49 42.62-6.07 8.9-11.32 16.57-13.84 20.67-1.37 2.21-3.1 6.41-5.02 11.83l1.78.92c2.05-5.77 3.71-9.68 4.95-11.71 2.49-4.05 7.72-11.71 13.78-20.58 2.87-4.2 5.93-8.67 8.92-13.12-.14.07-.23.11-.24.11l-.84-1.81c.04-.02 1.3-.6 3.25-1.5v-.01c7.48-11.12 14.27-21.59 16.57-26.58 3.5-7.59 4.32-19.07 4.45-26.27v-.02c-.68-1.52-1.35-3-2-4.47.09 5.53-.11 20.89-4.27 29.92z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M787.33 721.64v-.01c0-.01.01-.01.01-.02 1.44-4.57 2.85-8.81 4.16-12.5-.87 1.71-17.95 35-20.51 40.12-2.07 4.13-8.56 11.44-10.98 14.1.73.26 1.36.58 1.82.98 2.69-2.97 8.84-9.97 10.95-14.19 1.62-3.24 9.08-17.82 14.55-28.48z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M787.33 721.63c3.2-6.23 5.71-11.12 5.97-11.63.01-.02.02-.03.02-.04l-1.78-.92c0 .01-.02.03-.04.07-1.31 3.69-2.72 7.93-4.16 12.5 0 .01-.01.01-.01.02zm11.79 42.71c2.75-5.75 5.72-11.94 8.89-18.64 14-29.66 27.39-82.2 28.96-88.49-.77.35-1.56.71-2.34 1.07-2.73 10.74-15.32 58.8-28.43 86.57-3.17 6.69-6.13 12.88-8.88 18.62-10.23 21.33-17.62 36.75-21.12 49.33-2.53 9.13-6.01 24.54-8.49 35.92v.01c.17 2.86.28 5.57.31 8.03 2.32-10.87 6.96-32.06 10.11-43.43 3.45-12.41 10.81-27.75 20.99-48.99zm63.56 6.36c-1.65-15.93-6.26-27.89-10.73-39.45-2.69-6.98-5.24-13.56-6.9-20.55-2.03-8.54-2.54-21-2.5-31.83-.01-9.51.37-18.12.6-22.46l-1.83-.16c-.04.42-4.45 42.4-9.65 61.47-.73 2.68-1.46 5.46-2.21 8.31-4.7 17.86-10.02 38.11-20.55 53.91-12.64 18.96-31 58.69-32.73 70.84-1.18 8.23-6.03 27.33-9.06 38.85-.07 2.72-.13 5.57-.19 8.51 1.83-6.74 9.65-36.04 11.23-47.07.69-4.88 4.12-14.29 8.8-25.01v-.02c.2-3.35.32-5.32.33-5.46l1.99.13c0 .02 0 .07-.01.16 6.51-14.3 14.69-29.91 21.3-39.83 10.72-16.07 16.09-36.49 20.82-54.5.75-2.85 1.48-5.62 2.21-8.3 2.68-9.82 5.14-25.61 6.92-38.77-.02 10.76.53 23.05 2.59 31.7 1.69 7.11 4.26 13.76 6.98 20.8.6 1.56 1.2 3.13 1.8 4.72-.01-.41-.01-.65-.01-.68l1.25 3.98.75-.02c0 .05.02.83.03 2.19l.01.01c3 8.47 5.62 17.64 6.77 28.74 2.27 21.91-1.18 83.88-2.14 100.06 1.19-6.58 2.19-12.1 2.89-15.9 1.29-25.11 3.03-67.07 1.24-84.37z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "m841.32 656.25 1.83.16.12-2.06c-.18.09-.35.19-.54.27-.48.21-.99.44-1.51.67-.7 6.79-4.79 45-9.54 62.42 5.19-19.06 9.6-61.04 9.64-61.46zm3.73 54.45c-1.95-8.2-2.49-20.64-2.5-31.83-.04 10.83.47 23.29 2.5 31.83zm10.66-71.66c.44-.95.7-1.58.74-1.69l-1.25-.5c.16.68.33 1.41.51 2.19z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M841.91 652.79c-5.52 2.46-14.12 6.41-18.77 8.55-.71 1.06-1.43 2.12-2.16 3.19l-.01.01c1.27-.59 7.51-3.47 13.66-6.28v-.01c.35-1.34.53-2.1.55-2.16l1.95.48c-.01.03-.06.24-.16.62 1.49-.67 2.92-1.32 4.24-1.91.07-.64.1-1.01.11-1.05l2-.83c0 .03-.02.37-.06.93 6.26-3.14 10.75-11.64 12.45-15.3v-.01c-.18-.78-.35-1.51-.51-2.19l-.6-.24c-.05.14-5.22 12.88-12.69 16.2z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M843.26 654.35c.03-.56.06-.9.06-.93l-2 .83c0 .04-.04.4-.11 1.05.52-.23 1.03-.46 1.51-.67.19-.09.36-.19.54-.28zm-22.28 10.19c.73-1.07 1.45-2.13 2.16-3.19-1.95.9-3.21 1.48-3.25 1.5l.84 1.81c.01 0 .1-.04.24-.11l.01-.01zm15.99-7.33c.1-.38.15-.59.16-.62l-1.95-.48c-.02.06-.2.82-.55 2.16v.01c.79-.37 1.57-.72 2.34-1.07zm-21.05 343.82c-5.92-11.85-5.24-22.66-3.42-39.06.98-8.83 12.16-53.21 22.02-92.37 7.8-30.94 15.16-60.16 16.71-68.68 3.03-16.68 2.81-49.91 2.69-58.75l-.01-.01c-.26-.73-.52-1.45-.78-2.17l-1.2.02c.02 2.42.05 5.82.04 9.81.03 13.45-.3 37.45-2.71 50.74-1.54 8.46-8.89 37.65-16.68 68.55-9.32 37.02-18.93 75.15-21.49 88.96l1.77.37c-.05.21-.67 2.98-2.62 5.89v.02c-1.63 15.34-1.95 25.89 3.9 37.58 5.18 10.37 17.67 14.59 22.36 15.85.01-.67.02-1.37.04-2.08-4.74-1.36-16.02-5.46-20.62-14.67zm37.21-261.04c-.41-1.11-.82-2.21-1.24-3.3.01.67.03 1.8.04 3.32l1.2-.02z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M851.97 749.82c-.03 14.96-.46 38.35-2.71 50.74 2.41-13.29 2.74-37.29 2.71-50.74zm-.09-13.81c0 .03.01.26.01.68.41 1.09.83 2.19 1.24 3.3l-1.25-3.98zm2 3.96-.75.02c.26.72.52 1.44.78 2.17-.01-1.36-.03-2.14-.03-2.19zm-82.99 277.37c.79.33 1.61.5 2.44.5 1.42 0 2.88-.48 4.37-1.43 8.11-5.15 8.66-30.9 7.61-52.35v-.01c-1.18-1.25-1.9-2.2-2-2.33l1.61-1.19c.01.01.08.11.22.29-.24-4.06-.52-7.9-.81-11.36-1.71-20.42 4.64-123.55 4.94-128.56v-.01c-.8 1.75-1.57 3.47-2.31 5.16v.02c-1.34 22.25-6.14 105.36-4.63 123.56 3.09 37.1 1.02 60.83-5.7 65.1-1.81 1.16-3.44 1.41-4.98.77-2.34-.96-4.12-3.76-5.34-6.44.21 1.65.44 3.36.7 5.1 1.08 1.39 2.37 2.56 3.88 3.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M789.27 820.87c.01-.09.01-.14.01-.16l-1.99-.13c-.01.14-.13 2.11-.33 5.46.74-1.69 1.51-3.41 2.31-5.16v-.01zm11.58 147.96c-7.29 1.91-14.37-6.36-15.71-8.02v.01c.06 1.06.12 2.13.17 3.23 2.65 2.79 7.62 7.08 13.28 7.08.91 0 1.83-.11 2.77-.36 4.38-1.15 7.15-3.85 8.88-6.44.09-.84.18-1.71.28-2.58.1-.9.3-2.14.58-3.68l-.19-.04c-.03.08-1.93 8.67-10.06 10.8z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M810.51 961.75c-.1.87-.19 1.74-.28 2.58 1.95-2.91 2.58-5.68 2.62-5.89l-1.77-.37c-.27 1.54-.47 2.78-.57 3.68zm-25.37-.94c-.14-.17-.22-.28-.22-.29l-1.61 1.19c.1.13.82 1.08 2 2.33-.05-1.09-.11-2.17-.17-3.23z"
	          }),
	          this.props.bodyTitle === "Left Thigh" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "861",
	              width: "185",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M844.206 883.721h250" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1119.95 893.037v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.63-5.941 4.922.826c-.633 1.804-1.632 3.178-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.433 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.036 1.465.434 2.604 1.196 3.419.761.814 1.711 1.221 2.847 1.221.774 0 1.424-.21 1.951-.632.528-.422.926-1.102 1.196-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.567-1.117-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.852-1.037 3.199h7.383Zm6.759-7.734h2.742v-1.406c0-1.571.167-2.742.501-3.516.334-.773.949-1.403 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.633l-.668 3.445a9.783 9.783 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.975-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.72 0v3.938h-3.375v7.523c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.474l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.15-2.409-.448-.715-.299-1.239-.686-1.573-1.161-.334-.474-.565-1.116-.694-1.924-.106-.575-.158-1.735-.158-3.481v-8.138h-2.268v-3.938h2.268v-3.709l4.957-2.883v6.592h3.375Zm19.26 18.668v-21.41h-7.646v-4.36h20.478v4.36h-7.629v21.41h-5.203Zm21.08-25.77v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.117.999-1.415 1.802-.299.803-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm17.07 4.571v-4.571h4.939v4.571h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.54 1.23 5.642.686c.094.656.311 1.107.651 1.354.468.351 1.207.527 2.214.527 1.29 0 2.256-.194 2.901-.58.433-.258.762-.674.984-1.248.153-.41.229-1.166.229-2.268v-2.724c-1.477 2.015-3.34 3.023-5.59 3.023-2.508 0-4.494-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.181 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.656.621-1.532 1.107-2.628 1.459-1.096.351-2.481.527-4.157.527-3.164 0-5.408-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.018-.598Zm4.412-10.951c0 1.981.384 3.431 1.151 4.351.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.472 3.059-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.399-3.369-1.196-4.306-.797-.938-1.804-1.407-3.023-1.407-1.184 0-2.159.46-2.927 1.38-.767.92-1.151 2.324-1.151 4.21Zm22.958-16.049v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.656.78 1.383.95 2.18.169.797.254 2.033.254 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.281-3.727a2.454 2.454 0 0 0-.993-1.257c-.475-.31-1.07-.466-1.785-.466-.82 0-1.552.2-2.197.598-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.559v9.352h-4.94v-25.77h4.94Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Right Knee" ? "bodyParts_group Right_Knee body_parts_active" : "bodyParts_group Right_Knee"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyParts",
	            d: "M712.54 1165.08c1.05 53.98 3.37 118.22 5.05 122.15.57 1.34 1.21 2.1 1.8 2.13h.05c.71 0 1.57-.88 2.12-1.62-1.45-5.65-2.29-11.56-1.81-16.4.51-5.14 4.62-50.7 7.6-91.45-7.08-3.27-12.19-10.42-14.81-14.81zm-.08-4.34v.01c.75 1.51 6.34 12.5 15.05 16.97 2.05-28.28 3.52-53.83 2.8-61.34-1.46-15.36-4.13-50.77-3.48-67.37-3.65 6.05-13.06 23.62-14.45 45.86-.61 9.86-.48 35.96.08 65.87zm-36.36 9.22c-10.09-30.25-15.23-89.5-17.08-115.56-1.98 11.49-3.98 23.21-4.42 32.05-.89 17.6.88 52.82 7.04 79.23 6.16 26.42 14.97 74.84 18.48 99.49 2.3 16.08 1.23 26.17.7 33.93 5.46-3.7 13.09-6.81 18.3-8.72.84-10.44-10.32-82.32-23.02-120.42z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyParts",
	            d: "M701.16 1289.67c1.36-.48 2.43-.82 3.08-1.03.19-6.93 1.62-62.01-.01-77.51-1.8-17.1-19.4-123.34-24.63-144.25-4.04-16.17-13.95-24.92-17.99-27.91-.35 2.29-.74 4.66-1.15 7.08 0 .02.01.04 0 .07 1.19 18.73 6.25 89.36 17.54 123.21 12.75 38.26 23.45 106.93 23.16 120.34z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyParts",
	            d: "M729.11 1017.34c-.8.33-1.61.5-2.45.5-1.41 0-2.88-.48-4.37-1.43-8.1-5.15-8.65-30.9-7.6-52.36-2.64 2.79-7.63 7.08-13.28 7.08-.91 0-1.83-.11-2.77-.36-4.37-1.15-7.14-3.85-8.88-6.43v.01c1.63 15.34 1.95 25.89-3.9 37.58-5.18 10.36-17.66 14.59-22.36 15.85.03 2.25 0 4.32-.1 6.16-.2 3.66-.74 8.03-1.46 12.8 3.61 2.45 15.04 11.45 19.59 29.65 5.24 20.96 22.87 127.4 24.68 144.53 1.56 14.92.33 65.94.05 76.55 2.58-.72 6.74-.59 9.23-.42-2.71-14.69-6.81-165.12-5.11-192.31 1.75-28.12 16.1-48.95 16.25-49.15l.37.26c.16-1.86.37-3.33.67-4.31 1.58-5.27 3.79-16.86 5.31-27.39-1.07 1.4-2.36 2.57-3.87 3.19z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyLines",
	            d: "M679.6 1066.88c5.23 20.91 22.83 127.15 24.63 144.25 1.63 15.5.2 70.58.01 77.51.36-.53 1.09-.91 2.03-1.17.28-10.6 1.51-61.62-.05-76.55-1.81-17.13-19.44-123.57-24.68-144.53-4.55-18.2-15.98-27.2-19.59-29.65-.1.73-.21 1.47-.34 2.23 4.04 2.99 13.95 11.74 17.99 27.91zm19.52 223.5c.73-.26 1.42-.5 2.04-.71.29-13.41-10.41-82.08-23.16-120.34-11.29-33.85-16.35-104.48-17.54-123.21-.46 2.71-.95 5.48-1.44 8.26v.02c1.85 26.06 6.99 85.31 17.08 115.56 12.7 38.1 23.86 109.98 23.02 120.42zm11.27-195.64c-1.7 27.19 2.4 177.62 5.11 192.31 1.25.09 2.09.18 2.09.18-1.68-3.93-4-68.17-5.05-122.15v-.01c-1.21-2.02-1.88-3.46-1.97-3.66l1.81-.84c0 .01.03.07.08.17-.56-29.91-.69-56.01-.08-65.87 1.39-22.24 10.8-39.81 14.45-45.86.05-1.15.11-2.2.18-3.16l-.37-.26c-.15.2-14.5 21.03-16.25 49.15z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyLines",
	            d: "M712.46 1160.75c.02 1.43.05 2.87.08 4.32v.01c2.62 4.39 7.73 11.54 14.81 14.81.05-.72.11-1.44.16-2.16v-.01c-8.71-4.47-14.3-15.46-15.05-16.97z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyLines",
	            d: "M712.46 1160.74c-.05-.1-.08-.16-.08-.17l-1.81.84c.09.2.76 1.64 1.97 3.66-.03-1.45-.06-2.89-.08-4.32v-.01z"
	          }),
	          this.props.bodyTitle === "Right Knee" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "175",
	              y: "1129",
	              width: "205",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup is_right" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M405 1150.16h260" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M193.957 1159.25v-25.769h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.184 1.125 2.537 1.125 4.061 0 1.933-.568 3.53-1.705 4.79-1.137 1.259-2.836 2.053-5.098 2.381 1.125.657 2.054 1.377 2.786 2.162.733.786 1.72 2.18 2.962 4.184l3.147 5.027h-6.223l-3.762-5.607c-1.336-2.004-2.25-3.267-2.742-3.788-.492-.522-1.014-.879-1.564-1.072-.551-.194-1.424-.29-2.619-.29h-1.055v10.757h-5.203Zm5.203-14.871h3.849c2.497 0 4.055-.105 4.676-.316a2.8 2.8 0 0 0 1.459-1.09c.352-.516.528-1.16.528-1.934 0-.867-.232-1.567-.695-2.1-.463-.533-1.116-.87-1.96-1.011-.422-.058-1.687-.088-3.797-.088h-4.06v6.539Zm20.742-6.329v-4.57h4.939v4.57h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.545 1.231 5.643.685c.093.657.31 1.108.65 1.354.469.352 1.207.527 2.215.527 1.289 0 2.256-.193 2.9-.58.434-.258.762-.674.985-1.248.152-.41.228-1.166.228-2.267v-2.725c-1.477 2.016-3.34 3.023-5.59 3.023-2.508 0-4.494-1.06-5.959-3.181-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.753-5.52 2.258-7.172 1.506-1.652 3.378-2.478 5.617-2.478 2.308 0 4.212 1.013 5.712 3.041v-2.62h4.624v16.752c0 2.204-.182 3.85-.545 4.94-.364 1.09-.873 1.945-1.53 2.566-.656.621-1.532 1.108-2.628 1.459-1.095.352-2.481.528-4.157.528-3.164 0-5.408-.542-6.732-1.626-1.325-1.084-1.987-2.458-1.987-4.122 0-.165.006-.364.018-.598Zm4.412-10.951c0 1.98.384 3.43 1.151 4.35.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.471 3.059-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.398-3.369-1.195-4.307-.797-.937-1.805-1.406-3.024-1.406-1.183 0-2.159.46-2.927 1.38-.767.92-1.151 2.323-1.151 4.21Zm22.957-16.049v9.475c1.594-1.864 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.632.914.422 1.603.961 2.066 1.618.462.656.779 1.382.949 2.179.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.094-3.199-.281-3.726a2.446 2.446 0 0 0-.993-1.257c-.475-.311-1.07-.466-1.784-.466-.821 0-1.553.199-2.198.598-.644.398-1.116.999-1.415 1.801-.298.803-.448 1.99-.448 3.56v9.351h-4.939v-25.769h4.939Zm25.629 7.11v3.938h-3.375v7.523c0 1.524.032 2.412.097 2.663.064.252.211.46.439.625.229.164.507.246.835.246.457 0 1.119-.159 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.693-.149-2.408-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.566-1.116-.695-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm13.535 18.66v-25.769h5.203v11.443l10.512-11.443h6.996l-9.703 10.037 10.23 15.732h-6.732l-7.084-12.093-4.219 4.306v7.787h-5.203Zm42.873 0h-4.939v-9.527c0-2.016-.106-3.319-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.548 3.548 0 0 0-1.397 1.863c-.252.774-.378 2.203-.378 4.289v8.455h-4.939v-18.668h4.587v2.743c1.629-2.11 3.68-3.164 6.153-3.164 1.09 0 2.086.196 2.988.588.902.393 1.585.894 2.048 1.503.463.61.785 1.301.967 2.075.181.773.272 1.88.272 3.322v11.601Zm15.821-5.94 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.268 1.618-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.405-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Zm19.74 4.992 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.671 1.178-.704.785-1.049 1.851-1.038 3.199h7.383Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Left Knee" ? "bodyParts_group Left_Knee body_parts_active" : "bodyParts_group Left_Knee"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Knee");
	            },
	            className: "bodyParts",
	            d: "M780.6 1289.36c.26-.22.57-.41.92-.58.31-.36.61-.88.89-1.55 1.68-3.93 4-68.18 5.06-122.17-2.62 4.39-7.73 11.54-14.82 14.82v.01c2.98 40.75 7.09 86.31 7.6 91.45.48 4.84-.36 10.75-1.81 16.4.58.76 1.47 1.67 2.16 1.62zm6.94-128.64v-.01c.55-29.9.69-55.98.07-65.84-1.39-22.22-10.78-39.77-14.44-45.84.65 16.61-2.03 51.99-3.49 67.35-.71 7.51.76 33.07 2.81 61.35 8.77-4.5 14.38-15.61 15.05-17.01zm32.86-93.84c-5.23 20.91-22.83 127.14-24.63 144.25-1.63 15.5-.2 70.58-.02 77.51.66.21 1.73.56 3.09 1.03-.29-13.41 10.41-82.08 23.16-120.34 11.3-33.91 16.37-104.71 17.54-123.3-.01-.01-.01-.01 0-.02-.01-.01-.01-.02 0-.03v-.01c-.41-2.4-.8-4.72-1.15-7-4.04 2.99-13.95 11.74-17.99 27.91z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Knee");
	            },
	            className: "bodyParts",
	            d: "M800.88 1290.39c5.21 1.9 12.84 5.01 18.3 8.71-.54-7.76-1.61-17.85.69-33.93 3.52-24.65 12.32-73.07 18.49-99.49 6.16-26.41 7.93-61.63 7.03-79.23-.44-8.83-2.43-20.54-4.42-32.02-1.85 26.07-6.99 85.29-17.07 115.53-12.71 38.12-23.87 110.03-23.02 120.43zm13.25-288.46c-5.85-11.69-5.53-22.24-3.9-37.58v-.02c-1.73 2.59-4.5 5.29-8.88 6.44-.94.25-1.86.36-2.77.36-5.65 0-10.63-4.28-13.28-7.08v.01c1.05 21.45.5 47.2-7.61 52.35-1.49.95-2.95 1.43-4.37 1.43-.83 0-1.65-.17-2.44-.5-1.51-.62-2.8-1.79-3.88-3.19 1.52 10.53 3.73 22.12 5.31 27.39.3.98.51 2.45.67 4.31l.37-.26c.15.2 14.49 21.03 16.25 49.15 1.75 28.02-2.66 186.97-5.36 193.28v.01c3.14-.45 7.13-.04 9.49.29-.22-8.33-1.58-62.02.04-77.4 1.8-17.14 19.44-123.57 24.68-144.53 4.55-18.2 15.98-27.2 19.59-29.65-.72-4.77-1.26-9.14-1.46-12.8-.1-1.84-.13-3.91-.1-6.16-4.68-1.26-17.17-5.48-22.35-15.85z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Knee");
	            },
	            className: "bodyLines",
	            d: "M818.46 1066.39c-5.24 20.96-22.88 127.39-24.68 144.53-1.62 15.38-.26 69.07-.04 77.4 1.22.17 2.01.32 2.01.32-.18-6.93-1.61-62.01.02-77.51 1.8-17.11 19.4-123.34 24.63-144.25 4.04-16.17 13.95-24.92 17.99-27.91-.13-.76-.24-1.5-.34-2.23-3.61 2.45-15.04 11.45-19.59 29.65zm-19.62 223.28c.62.21 1.31.46 2.04.72-.85-10.4 10.31-82.31 23.02-120.43 10.08-30.24 15.22-89.46 17.07-115.53 0-.02.01-.03 0-.05-.48-2.81-.97-5.61-1.43-8.35-1.17 18.59-6.24 89.39-17.54 123.3-12.75 38.26-23.45 106.93-23.16 120.34zm-11.3-128.96c.04-.08.07-.13.07-.14l1.82.84c-.09.2-.76 1.63-1.96 3.65-1.06 53.99-3.38 118.24-5.06 122.17-.28.67-.59 1.19-.89 1.55.76-.37 1.7-.61 2.73-.76v-.01c2.7-6.31 7.11-165.26 5.36-193.28-1.76-28.12-16.1-48.95-16.25-49.15l-.37.26c.08.96.14 2.02.18 3.18 3.66 6.07 13.05 23.62 14.44 45.84.62 9.87.48 35.95-.07 65.85z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Knee");
	            },
	            className: "bodyLines",
	            d: "M787.47 1165.06c.02-1.46.05-2.9.07-4.34-.67 1.4-6.28 12.51-15.05 17.01.05.72.1 1.42.16 2.15 7.09-3.28 12.2-10.43 14.82-14.82z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Knee");
	            },
	            className: "bodyLines",
	            d: "M787.61 1160.57c0 .01-.03.06-.07.14v.01c-.02 1.44-.05 2.88-.07 4.34 1.2-2.02 1.87-3.45 1.96-3.65l-1.82-.84z"
	          }),
	          this.props.bodyTitle === "Left Knee" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "1127",
	              width: "175",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M834.206 1146.36h260" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1119.95 1159.25v-25.558h5.203v21.217h12.937v4.341h-18.14Zm32.63-5.94 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.643 2.302 8.428h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm6.759-7.728h2.742v-1.406c0-1.57.167-2.742.501-3.515.334-.774.949-1.404 1.846-1.89.896-.486 2.03-.73 3.401-.73 1.406 0 2.783.211 4.131.633l-.668 3.446a9.732 9.732 0 0 0-2.268-.282c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.72 0v3.938h-3.375v7.523c0 1.524.032 2.412.096 2.663.065.252.211.46.44.625.228.164.507.246.835.246.457 0 1.119-.159 1.986-.475l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm13.53 18.66v-25.769h5.203v11.443l10.512-11.443h6.996l-9.703 10.037 10.23 15.732h-6.732l-7.084-12.093-4.219 4.306v7.787h-5.203Zm42.87 0h-4.94v-9.527c0-2.016-.105-3.319-.316-3.911-.211-.592-.554-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492a3.96 3.96 0 0 0-2.303.703 3.537 3.537 0 0 0-1.397 1.863c-.252.774-.378 2.203-.378 4.289v8.455h-4.94v-18.668h4.588v2.743c1.629-2.11 3.68-3.164 6.152-3.164 1.09 0 2.086.196 2.989.588.902.393 1.585.894 2.048 1.503a5.45 5.45 0 0 1 .966 2.075c.182.773.273 1.88.273 3.322v11.601Zm15.82-5.94 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.926-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.566-1.116-1.079 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.382Zm19.749 4.992 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.268 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428H1267.4c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Right Ankle" ? "bodyParts_group Right_Ankle body_parts_active" : "bodyParts_group Right_Ankle"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Ankle");
	            },
	            className: "bodyParts",
	            d: "M719.28 1291.36c-.67-.04-1.28-.31-1.84-.81-4.45-1.63-9.12-.95-12.05-.18-.34.11-1.42.45-2.97.98-5.17 1.78-15.63 5.7-21.76 10.29v.01c-.15 3.05-.12 5.76.36 8.41 1.75 9.69 4.39 9.69.87 18.49-3.52 8.8-23.77 31.7-21.13 37.87 2.65 6.15 23.77 3.51 35.22 4.39 11.45.88 17.6 5.29 22.01-3.51 4.4-8.81 3.52-6.17 6.16-11.46 2.65-5.27.89-30.81 0-36.09-.88-5.28 5.28-11.45 1.77-19.37-1.32-2.97-2.64-6.55-3.73-10.33-.73.69-1.68 1.3-2.75 1.3h-.16z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Ankle");
	            },
	            className: "bodyLines",
	            d: "M704.24 1288.64c-.65.21-1.72.55-3.08 1.03-.01.47-.03.87-.07 1.2l-1.99-.22c.01-.08.02-.17.02-.27-5.21 1.91-12.84 5.02-18.3 8.72-.06.88-.12 1.73-.16 2.55 6.13-4.59 16.58-8.51 21.76-10.29l1.82-2.72z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Ankle");
	            },
	            className: "bodyLines",
	            d: "M705.39 1290.37c-1.8.47-2.94.97-2.97.98 1.55-.53 2.63-.87 2.97-.98zm-6.29.28 1.99.22c.04-.33.06-.73.07-1.2-.62.21-1.31.45-2.04.71 0 .1-.01.19-.02.27zm20.34-1.29h-.05c-.59-.03-1.23-.79-1.8-2.13l1.69 4.13h.16c1.07 0 2.02-.61 2.75-1.3-.22-.77-.43-1.54-.63-2.32-.55.74-1.41 1.62-2.12 1.62zm-.16 2c-.61-.32-1.22-.58-1.84-.81.56.49 1.17.77 1.84.81zm-13.08-1.23-.69.21c-.01 0-.06.02-.12.04 2.93-.77 7.6-1.45 12.05.18-.64-.56-1.2-1.4-1.69-2.53-.08-.19-.16-.52-.25-.97-2.5-.17-6.66-.3-9.23.42-.03 1.19-.05 1.88-.05 1.94l-.02.71z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Ankle");
	            },
	            className: "bodyLines",
	            d: "m704.24 1288.64-1.82 2.72c.02-.01 1.17-.51 2.97-.98.07-.02.11-.04.12-.04l.69-.21.02-.72c0-.06.02-.75.05-1.94-.94.26-1.67.63-2.03 1.17zm-1.82 2.72v-.01.01zm15.02-.81c.62.23 1.24.48 1.84.81l-1.69-4.13s-.83-.09-2.09-.18c.08.45.17.78.25.97.49 1.13 1.05 1.97 1.69 2.53z"
	          }),
	          this.props.bodyTitle === "Right Ankle" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "167",
	              y: "1332",
	              width: "210",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup is_right" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M405 1353.94h270" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M185.291 1363.04v-25.77h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.184 1.125 2.537 1.125 4.061 0 1.933-.568 3.53-1.705 4.79-1.137 1.259-2.836 2.053-5.098 2.382 1.125.656 2.054 1.376 2.786 2.162.733.785 1.72 2.179 2.962 4.183l3.147 5.028h-6.223l-3.762-5.608c-1.336-2.004-2.25-3.266-2.742-3.788-.492-.521-1.014-.879-1.564-1.072-.551-.194-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.872h3.849c2.497 0 4.055-.105 4.676-.316a2.8 2.8 0 0 0 1.459-1.09c.352-.515.528-1.16.528-1.933 0-.868-.232-1.568-.695-2.101-.463-.533-1.116-.87-1.96-1.011-.422-.058-1.687-.088-3.797-.088h-4.06v6.539Zm20.742-6.328v-4.57h4.939v4.57h-4.939Zm0 21.2v-18.668h4.939v18.668h-4.939Zm9.545 1.23 5.643.686c.093.656.31 1.107.65 1.353.469.352 1.207.527 2.215.527 1.289 0 2.256-.193 2.9-.58.434-.257.762-.673.985-1.248.152-.41.228-1.166.228-2.267v-2.725c-1.477 2.016-3.34 3.024-5.59 3.024-2.508 0-4.494-1.061-5.959-3.182-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.752-5.519 2.258-7.172 1.506-1.652 3.378-2.478 5.617-2.478 2.308 0 4.212 1.013 5.712 3.041v-2.619h4.623v16.752c0 2.203-.181 3.849-.544 4.939-.364 1.09-.873 1.945-1.53 2.566-.656.621-1.532 1.108-2.628 1.459-1.095.352-2.481.528-4.157.528-3.164 0-5.408-.542-6.732-1.626-1.325-1.084-1.987-2.458-1.987-4.122 0-.164.006-.364.018-.598Zm4.412-10.951c0 1.98.384 3.431 1.151 4.35.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.471 3.059-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.399-3.369-1.195-4.307-.797-.937-1.805-1.406-3.024-1.406-1.183 0-2.159.46-2.927 1.38-.767.92-1.151 2.323-1.151 4.21Zm22.957-16.049v9.475c1.594-1.864 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.421 1.603.96 2.066 1.617.462.656.779 1.383.949 2.179.17.797.255 2.034.255 3.709v10.952h-4.94v-9.862c0-1.957-.094-3.199-.281-3.726a2.446 2.446 0 0 0-.993-1.257c-.475-.311-1.07-.466-1.784-.466-.821 0-1.553.199-2.198.598-.644.398-1.116.999-1.415 1.801-.298.803-.448 1.99-.448 3.56v9.352h-4.939v-25.77h4.939Zm25.629 7.1v3.937h-3.375v7.524c0 1.523.032 2.411.097 2.663.064.252.211.46.439.624.229.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.693-.149-2.408-.448-.715-.299-1.24-.685-1.573-1.16-.334-.475-.566-1.116-.695-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm35.367 18.67h-5.66l-2.25-5.854h-10.301l-2.127 5.854h-5.519l10.037-25.77h5.502l10.318 25.77Zm-9.58-10.196-3.551-9.562-3.48 9.562h7.031Zm29.285 10.196h-4.939v-9.528c0-2.015-.106-3.319-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.548 3.548 0 0 0-1.397 1.863c-.252.774-.378 2.204-.378 4.289v8.456h-4.939v-18.668h4.588v2.742c1.628-2.11 3.679-3.164 6.152-3.164 1.09 0 2.086.196 2.988.589.902.392 1.585.893 2.048 1.503.463.609.785 1.3.967 2.074.181.773.272 1.881.272 3.322v11.602Zm4.834 0v-25.77h4.94v13.676l5.783-6.574h6.082l-6.381 6.82 6.838 11.848h-5.326l-4.694-8.385-2.302 2.408v5.977h-4.94Zm20.198-25.77h4.939v25.77h-4.939zm20.812 19.82 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.699-1.846-3.844-1.846-6.434 0-3.094.809-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.393-2.671 1.178-.704.785-1.049 1.851-1.038 3.199h7.383Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Left Ankle" ? "bodyParts_group Left_Ankle body_parts_active" : "bodyParts_group Left_Ankle"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Ankle");
	            },
	            className: "bodyParts",
	            d: "M781.93 1291c-.38.21-.78.34-1.21.36h-.16c-1.07 0-2.02-.61-2.75-1.3-1.09 3.78-2.41 7.36-3.73 10.33-3.52 7.92 2.65 14.09 1.77 19.37-.89 5.28-2.65 30.82 0 36.09 2.64 5.29 1.76 2.65 6.16 11.46 4.4 8.8 10.56 4.39 22.01 3.51 11.44-.88 32.57 1.76 35.22-4.39 2.64-6.17-17.61-29.07-21.14-37.87-3.51-8.8-.88-8.8.88-18.49.48-2.65.51-5.37.35-8.42-6.77-5.07-18.83-9.33-23.2-10.78-5.32-1.92-11.62-.58-14.2.13z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Ankle");
	            },
	            className: "bodyLines",
	            d: "m800.9 1290.65-1.99.22c-.04-.33-.06-.73-.07-1.2-1.36-.47-2.43-.82-3.09-1.03l.38 2.23c4.38 1.45 16.43 5.72 23.2 10.78-.03-.82-.09-1.67-.15-2.55-5.46-3.7-13.09-6.81-18.3-8.71 0 .09.01.18.02.26z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Ankle");
	            },
	            className: "bodyLines",
	            d: "M800.9 1290.65c-.01-.08-.02-.17-.02-.26-.73-.26-1.42-.51-2.04-.72.01.47.03.87.07 1.2l1.99-.22zm-18.97.35c-.75.21-1.21.36-1.21.36.43-.03.83-.16 1.21-.36z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Ankle");
	            },
	            className: "bodyLines",
	            d: "m780.72 1291.36-.12-2c-.69.05-1.58-.86-2.16-1.62-.2.78-.41 1.55-.63 2.32.73.69 1.68 1.3 2.75 1.3h.16zm1.21-.36c2.58-.71 8.88-2.05 14.2-.13-1.01-.33-1.61-.52-1.65-.53l-.68-.21-.03-.72c0-.05-.01-.43-.03-1.09-2.36-.33-6.36-.74-9.49-.29-.65 1.49-1.42 2.47-2.32 2.97zm-.41-2.22c-.34.17-.65.36-.92.58.3-.02.61-.22.92-.58z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Ankle");
	            },
	            className: "bodyLines",
	            d: "m793.8 1290.13.68.21c.04.01.64.2 1.65.53l-.38-2.23s-.79-.15-2.01-.32c.02.66.03 1.05.03 1.09l.03.72zm-13.2-.77.12 2s.45-.15 1.21-.36c.9-.49 1.67-1.48 2.32-2.97-1.03.15-1.97.39-2.73.76-.31.35-.62.55-.92.57z"
	          }),
	          this.props.bodyTitle === "Left Ankle" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "1330",
	              width: "185",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M824.206 1350.14h270" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1119.95 1363.04v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.63-5.95 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.699-1.846-3.844-1.846-6.434 0-3.094.808-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.643 2.302 8.428h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm6.759-7.728h2.742v-1.407c0-1.57.167-2.742.501-3.515.334-.774.949-1.404 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.632l-.668 3.446a9.732 9.732 0 0 0-2.268-.282c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.319h3.692v3.884h-3.692v14.784h-4.939v-14.784h-2.742v-3.884Zm22.72 0v3.937h-3.375v7.524c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm35.36 18.67h-5.66l-2.25-5.854h-10.301l-2.127 5.854h-5.52l10.037-25.77h5.502l10.319 25.77Zm-9.58-10.196-3.551-9.562-3.481 9.562h7.032Zm29.29 10.196h-4.94v-9.528c0-2.015-.105-3.319-.316-3.911-.211-.592-.554-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492a3.96 3.96 0 0 0-2.303.703 3.542 3.542 0 0 0-1.397 1.863c-.252.774-.378 2.204-.378 4.289v8.456h-4.94v-18.668h4.588v2.742c1.629-2.11 3.68-3.164 6.152-3.164 1.09 0 2.086.196 2.989.589.902.392 1.585.893 2.048 1.503.462.609.785 1.3.966 2.074.182.773.273 1.881.273 3.322v11.602Zm4.83 0v-25.77h4.939v13.676l5.783-6.574h6.083l-6.381 6.82 6.838 11.848h-5.327l-4.693-8.385-2.303 2.408v5.977h-4.939Zm20.2-25.77h4.939v25.77h-4.939zm20.81 19.82 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.699-1.845-3.844-1.845-6.434 0-3.094.808-5.516 2.425-7.268 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.393-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Chest" ? "bodyParts_group Chest body_parts_active" : "bodyParts_group Chest"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyParts",
	            d: "M749.04 393.88c-.4-7.69-1.22-14.33-2.5-18.07-4.38-12.76-8.23-21.56-21.45-27.21-12.44-5.31-38.88-7.38-53.7 1.34-11.11 6.53-14.57 13.34-15.26 14.94.81 1.7 3.97 8.6 6.88 18.42 1.53 5.17-.81 16.02-3.07 26.51-1.39 6.42-2.69 12.5-3.03 16.82-1.43 18.63 15.9 23.59 48.39 26.22 19.18 1.56 32.52-1.88 39.66-10.22 2.08-2.42 3.48-12.46 4.06-24.22-.4-8.06-.39-16.83.02-24.53z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M656.9 435.56c-.01.03-.14.71-.28 1.86v.03c5.35 11.43 22.53 15.29 48.52 17.4 2.43.19 4.76.31 7.01.34 1.99-1.09 3.2-1.79 3.27-1.83l1.02 1.72c-.04.02-.1.06-.17.1 8.08-.23 14.86-1.58 20.33-4.05 1.64-1.05 2.88-1.71 3.55-1.88 2.45-1.5 4.56-3.27 6.33-5.33 1.22-1.43 2.21-4.8 2.96-9.36v-9.54c-.18-2.12-.32-4.34-.42-6.62-.58 11.76-1.98 21.8-4.06 24.22-7.14 8.34-20.48 11.78-39.66 10.22-32.49-2.63-49.82-7.59-48.39-26.22.34-4.32 1.64-10.4 3.03-16.82 2.26-10.49 4.6-21.34 3.07-26.51-2.91-9.82-6.07-16.72-6.88-18.42.69-1.6 4.15-8.41 15.26-14.94 14.82-8.72 41.26-6.65 53.7-1.34 13.22 5.65 17.07 14.45 21.45 27.21 1.28 3.74 2.1 10.38 2.5 18.07.1-2.04.24-4 .4-5.86v-8.78c-.3-1.6-.64-2.98-1.01-4.07-4.41-12.87-8.61-22.44-22.55-28.4-7.21-3.08-19.19-5.25-31.1-4.75l.02.01-.72 1.86c-.05-.02-1.6-.62-4-1.52h-.01c-7.19.75-14.11 2.57-19.69 5.85-13.37 7.86-16.18 16.05-16.29 16.39l1.45.33c-.01.05-.2.87-.54 2.28 1.23 2.74 3.58 8.35 5.83 15.79l1.63.53c-.03.09-.38 1.18-.98 3.08v.01c.23 5.49-1.73 14.57-3.5 22.75-1.39 6.5-2.72 12.64-3.06 17.1-.26 3.31.04 6.24.86 8.81l.01.04 1.11.24z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "m654.09 364.61-.13.39.18.37c.01.02.33.66.86 1.85.34-1.41.53-2.23.54-2.28l-1.45-.33zm40.71-22.59s-.01-.01-.02-.01c-1.58.07-3.14.18-4.7.35 2.4.9 3.94 1.5 4 1.52l.72-1.86zm-39.01 93.31c-.01-.02-.01-.03-.01-.04l-.84-3.14c-.06.31-.73 4.61-.66 10.29.04-4.18.6-7.01.66-7.29l.85.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "m655.79 435.33-.01-.04c.01.01.01.02.01.04zm0 0c.23.74.51 1.41.83 2.09.14-1.15.27-1.83.28-1.86l-1.11-.23zm5.04-52.32c.09.28.17.57.26.86.22.76.35 1.69.39 2.75.6-1.9.95-3 .98-3.08l-1.63-.53z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyParts",
	            d: "M750.98 418.53c.58 11.71 1.98 21.69 4.05 24.1 7.15 8.34 20.5 11.77 39.66 10.22 32.49-2.63 49.82-7.59 48.39-26.22-.33-4.32-1.64-10.4-3.02-16.83-2.26-10.49-4.6-21.33-3.07-26.5 2.91-9.82 6.07-16.72 6.88-18.42-.7-1.6-4.15-8.41-15.26-14.94-7.22-4.25-17.2-5.93-26.97-5.93-10.29 0-20.36 1.87-26.74 4.59-13.21 5.65-17.07 14.45-21.44 27.21-1.28 3.73-2.1 10.33-2.5 18 .41 7.76.42 16.6.02 24.72z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyParts",
	            d: "M750.98 418.53c.4-8.12.39-16.96-.02-24.72-.41 7.78-.39 16.66.02 24.72zm-1.54 6.5v9.54c.21-1.23.39-2.56.56-3.95-.22-1.76-.4-3.63-.56-5.59zm.56-42.24c-.17-1.28-.35-2.47-.56-3.55v8.78c.16-1.86.34-3.62.56-5.23z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M749.04 393.88c-.41 7.7-.42 16.47-.02 24.53.4-8 .42-16.8.02-24.53z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M749.04 393.88c.4 7.73.38 16.53-.02 24.53.1 2.28.24 4.5.42 6.62v-37.01c-.16 1.86-.3 3.82-.4 5.86zm90.13-10.87c2.26-7.44 4.6-13.06 5.83-15.8-.34-1.4-.53-2.22-.54-2.27l1.46-.34v-.01c-.15-.43-3.01-8.57-16.29-16.38-5.58-3.28-12.51-5.11-19.7-5.85h-.01c-2.4.9-3.94 1.5-3.99 1.52l-.72-1.86s.01 0 .02-.01c-11.91-.5-23.89 1.66-31.1 4.75-13.95 5.96-18.14 15.53-22.55 28.4-.37 1.09-.71 2.47-1.01 4.07v8.78c.16 1.83.29 3.78.4 5.79.4-7.67 1.22-14.27 2.5-18 4.37-12.76 8.23-21.56 21.44-27.21 6.38-2.72 16.45-4.59 26.74-4.59 9.77 0 19.75 1.68 26.97 5.93 11.11 6.53 14.56 13.34 15.26 14.94-.81 1.7-3.97 8.6-6.88 18.42-1.53 5.17.81 16.01 3.07 26.5 1.38 6.43 2.69 12.51 3.02 16.83 1.43 18.63-15.9 23.59-48.39 26.22-19.16 1.55-32.51-1.88-39.66-10.22-2.07-2.41-3.47-12.39-4.05-24.1-.11 2.23-.25 4.41-.42 6.5v9.54c.75 4.56 1.74 7.93 2.96 9.36 1.76 2.06 3.88 3.83 6.33 5.33.68.17 1.91.83 3.54 1.87 5.47 2.47 12.25 3.82 20.33 4.05h.01c-.07-.04-.14-.08-.17-.1l1.02-1.72c.07.04 1.28.75 3.27 1.83 2.25-.03 4.59-.15 7.02-.34 25.99-2.11 43.17-5.97 48.52-17.4.01-.01 0-.02 0-.02-.14-1.15-.27-1.83-.28-1.86l1.11-.23.59-2.42c.36-1.96.47-4.09.28-6.43-.35-4.46-1.67-10.6-3.07-17.1-1.76-8.18-3.72-17.26-3.49-22.75-.6-1.91-.96-3.01-.98-3.1l1.61-.52zm-88.61 51.56v-9.54c-.16 1.96-.34 3.83-.56 5.59.17 1.39.35 2.72.56 3.95zm0-46.55v-8.78c-.21 1.08-.39 2.27-.56 3.55.22 1.61.4 3.37.56 5.23z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M750.98 418.53c-.41-8.06-.43-16.94-.02-24.72-.11-2.01-.24-3.96-.4-5.79v37.01c.17-2.09.31-4.27.42-6.5zm-1.54-30.51v37.01c.16 1.96.34 3.83.56 5.59.22-1.76.4-3.63.56-5.59v-37.01c-.16-1.86-.34-3.62-.56-5.23-.22 1.61-.4 3.37-.56 5.23zM845 367.21v-.01c.52-1.17.84-1.81.85-1.83l.19-.37-.13-.39-1.46.34c.02.04.21.86.55 2.26zm-39.08-23.32c.05-.02 1.59-.62 3.99-1.52-1.56-.17-3.12-.28-4.69-.35-.01.01-.02.01-.02.01l.72 1.86zm38.29 91.44.85-.18c.06.29.65 3.27.66 7.65.23-7.66-.45-13.94-.37-12.18l-.55 2.29c-.16.83-.34 1.65-.59 2.42z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M844.21 435.33c.25-.77.43-1.59.59-2.42l-.59 2.42zm-1.11.23c.01.03.14.71.28 1.86.32-.68.6-1.36.83-2.09l-1.11.23zm-4.58-48.94c.04-1.06.16-1.99.39-2.75.09-.29.17-.58.26-.86l-1.63.53c.03.09.38 1.19.98 3.1v-.02z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyParts",
	            d: "M749.44 456.52v-21.95c-.75 4.56-1.74 7.93-2.96 9.36-1.77 2.06-3.89 3.83-6.33 5.33.03-.01.07-.02.09-.03 4.33-.87 7.71 4.78 9.2 7.29z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M713.81 455.21c.83 0 1.65-.01 2.46-.03.07-.04.14-.08.17-.1l-1.02-1.72c-.07.04-1.28.75-3.27 1.83h.01c.56.02 1.11.02 1.65.02z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyParts",
	            d: "m759.75 449.23.1.03c-2.45-1.5-4.56-3.27-6.33-5.33-1.22-1.43-2.21-4.8-2.96-9.36v21.95c1.49-2.51 4.89-8.16 9.19-7.29zm-9.75 8.3c.13-.26.32-.61.56-1.01v-21.95c-.21-1.23-.39-2.56-.56-3.95-.17 1.39-.35 2.72-.56 3.95v21.95c.24.4.43.75.56 1.01z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M786.19 455.21c.54 0 1.09 0 1.64-.02h.01c-2-1.09-3.2-1.79-3.27-1.83l-1.02 1.72c.04.02.1.06.17.1.82.02 1.63.03 2.47.03z"
	          }),
	          this.props.bodyTitle === "Chest" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "395",
	              width: "115",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M834.206 414.53h260" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "m1137.88 417.94 5.045 1.599c-.773 2.813-2.059 4.902-3.858 6.267-1.799 1.365-4.081 2.048-6.847 2.048-3.422 0-6.234-1.169-8.437-3.507-2.203-2.338-3.305-5.534-3.305-9.589 0-4.289 1.108-7.62 3.322-9.993 2.215-2.373 5.127-3.56 8.737-3.56 3.152 0 5.713.932 7.681 2.795 1.172 1.102 2.051 2.684 2.637 4.746l-5.15 1.231c-.305-1.336-.941-2.391-1.908-3.164-.966-.774-2.141-1.16-3.524-1.16-1.91 0-3.46.685-4.649 2.056-1.19 1.371-1.785 3.592-1.785 6.662 0 3.258.586 5.578 1.758 6.961 1.172 1.383 2.696 2.075 4.571 2.075 1.382 0 2.572-.44 3.568-1.319s1.711-2.262 2.144-4.148Zm14.4-16.295v9.474c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.065 1.617.463.657.78 1.383.95 2.18.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.094-3.199-.281-3.727a2.448 2.448 0 0 0-.993-1.256c-.475-.311-1.07-.466-1.785-.466-.82 0-1.552.199-2.197.597-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm27.88 19.828 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.952-.633.527-.422.925-1.102 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm7.189 5.607 4.957-.756c.211.961.638 1.691 1.283 2.189.644.498 1.547.747 2.707.747 1.277 0 2.238-.235 2.883-.703.433-.328.65-.768.65-1.319 0-.375-.117-.685-.352-.931-.246-.235-.796-.451-1.652-.651-3.984-.879-6.51-1.681-7.576-2.408-1.477-1.008-2.215-2.408-2.215-4.201 0-1.617.639-2.977 1.916-4.078 1.277-1.102 3.258-1.653 5.942-1.653 2.554 0 4.453.417 5.695 1.249 1.242.832 2.097 2.062 2.566 3.691l-4.658.861c-.199-.726-.577-1.283-1.134-1.67-.556-.386-1.35-.58-2.382-.58-1.3 0-2.232.182-2.795.545-.375.258-.562.592-.562 1.002 0 .352.164.651.492.897.445.328 1.984.791 4.614 1.388 2.631.598 4.468 1.33 5.511 2.198 1.031.878 1.547 2.103 1.547 3.673 0 1.711-.715 3.182-2.144 4.413-1.43 1.23-3.545 1.845-6.346 1.845-2.543 0-4.556-.515-6.038-1.547-1.483-1.031-2.452-2.431-2.909-4.201Zm30.32-13.342v3.938h-3.375v7.523c0 1.524.032 2.411.097 2.663.064.252.21.46.439.624.228.164.507.247.835.247.457 0 1.119-.159 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.694-.149-2.408-.448-.715-.299-1.24-.686-1.574-1.16-.334-.475-.565-1.116-.694-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Upper GI" ? "bodyParts_group Upper_GI body_parts_active" : "bodyParts_group Upper_GI"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "syzst2",
	            d: "M845.72 442.8c-.06 2.1-.2 4.3-.43 6.47.32-2.36.43-4.55.43-6.47zm-189.87 12.12c-1.13-4.25-1.52-8.67-1.57-12.48-.03 3.44.3 7.81 1.57 12.48z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M736.6 451.13a31.38 31.38 0 0 0 3.55-1.88c-.67.17-1.92.83-3.55 1.88zm23.25-1.87c1.11.68 2.29 1.31 3.54 1.87-1.63-1.04-2.87-1.7-3.54-1.87zm85.15 1.87c0 .03.01.12.02.27.1-.7.19-1.41.27-2.12-.09.63-.19 1.27-.3 1.92l.01-.07z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "syzst2",
	            d: "M845 451.13c0 .03.01.12.02.27.1-.7.19-1.41.27-2.12-.09.63-.19 1.27-.3 1.92l.01-.07zm.72-8.33c-.06 2.1-.2 4.3-.43 6.47.32-2.36.43-4.55.43-6.47zm-191.44-.36c-.03 3.45.3 7.82 1.57 12.48-1.13-4.26-1.52-8.68-1.57-12.48z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "m656.91 456.57-.6-.05c.16.49.32.99.5 1.49.06-.89.1-1.42.1-1.44zm54.86.91c.09.01.2.02.31.03 1.11-.6 2.05-1.12 2.77-1.53-1.43-.34-2.62-.47-2.89-.5l-.19 2zm131.92.04c.11-.33.21-.68.3-1.03l-.3.03c-.07.22-.15.44-.22.65l.22.35zm0-1c.57-1.82.99-3.6 1.29-5.32l-1.29 5.32z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M844.98 451.2c-.31 1.72-.72 3.5-1.29 5.32l.3-.03c.44-1.59.77-3.32 1.03-5.1-.01-.15-.02-.24-.02-.27l-.02.08zm-1.9 5.37c0 .02.04.55.1 1.44.1-.28.19-.56.28-.83l-.38-.61zm.61-.05-.6.05.38.6c.07-.21.15-.43.22-.65zm-55.46.96-.19-1.99c-.28.03-1.46.16-2.89.5.72.41 1.66.93 2.77 1.53.11-.02.22-.03.31-.04z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M680.14 568.29c3.11 1.56 5.88 1.85 8.24.88 2.64-1.1 4.07-3.56 4.45-4.7.43-1.49-2.84-11.61-6.36-20.87-4.52-1.89-10.7-5.89-14.54-9.81-3.36-3.42-6.7-7.87-9.24-11.51 1.84 8.57 1.18 20.25 2.01 28.25h.01c.07.14 7.02 13.56 15.43 17.76z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M698.84 617.48c7.16-21.07-9.38-43.44-11.31-45.97-.66.15-1.35.22-2.05.22-1.95 0-4.04-.55-6.24-1.65-5.85-2.93-10.87-9.7-13.74-14.23.84 6.49.27 15.6-.42 22.94v.01c3.36 6.34 9.06 16.86 12.28 21.35 5.54 7.73 18.81 17.19 21.48 17.33zm49.59-42.33c-.19-7.8-.06-17.15.44-19.28-1.02-.9-4.17-1.17-7.78-1.17-3.86 0-8.26.31-11.14.52-6.48.46-13.21 1.67-17.72 2.6-5.13 1.07-9.02 5.2-9.67 10.28-.32 2.47-.48 4.76-.48 6.86 0 6.94 1.73 11.82 5.18 14.58 5.18 4.15 37.16 3.37 40.65 2.51.46-.68.82-2.92 1.09-5.97 0 0-.01-.01 0-.02-.25-2.62-.45-6.16-.57-10.91z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M749 586.08c-.27 3.05-.63 5.29-1.09 5.97-3.49.86-35.47 1.64-40.65-2.51-3.45-2.76-5.18-7.64-5.18-14.58 0-2.1.16-4.39.48-6.86.65-5.08 4.54-9.21 9.67-10.28 4.51-.93 11.24-2.14 17.72-2.6 2.88-.21 7.28-.52 11.14-.52 3.61 0 6.76.27 7.78 1.17a2.486 2.486 0 0 1 .57-1.1v-.88c-2.85-1.52-9.19-1.42-19.64-.67-6.58.47-13.41 1.7-17.98 2.65-5.96 1.23-10.48 6.05-11.25 11.98-1.46 11.37.37 19.2 5.44 23.25 3.56 2.85 16.26 3.7 26.93 3.7 7.73 0 14.4-.45 15.74-.89.22-.08.48-.17.76-.55v-3.69c-.16-.95-.31-2.13-.44-3.59zm-69.76-16c2.2 1.1 4.29 1.65 6.24 1.65.7 0 1.39-.07 2.05-.22-.12-.14-.18-.22-.19-.23l1.56-1.25c.07.09.29.36.62.8 3.07-1.42 4.71-4.24 5.21-5.73.79-2.39-3.46-14.38-5.79-20.64-.74-.19-1.57-.48-2.47-.86 3.52 9.26 6.79 19.38 6.36 20.87-.38 1.14-1.81 3.6-4.45 4.7-2.36.97-5.13.68-8.24-.88-8.41-4.2-15.36-17.62-15.43-17.76h-.01c.12 1.17.27 2.26.47 3.25.13.65.24 1.34.33 2.06v.01c2.87 4.53 7.89 11.3 13.74 14.23zm8.76-28.09-.12.05c.05.02.11.04.16.06-.01-.04-.03-.07-.04-.11z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M687.88 542.04h-.01l-1.74.66c.11.3.23.6.34.9.9.38 1.73.67 2.47.86-.35-.93-.66-1.73-.9-2.36-.05-.02-.11-.04-.16-.06zm11.15 77.43c.1 0 .2-.01.29-.02.64-.09 1.11-.47 1.31-1.03.97-2.78 1.55-5.57 1.83-8.33l-.38-.63v-1.89l.53.54c.87-17.61-10.27-33.55-13.09-37.28-.12.07-.25.13-.38.18-.52.22-1.06.38-1.61.5 1.93 2.53 18.47 24.9 11.31 45.97-2.67-.14-15.94-9.6-21.48-17.33-3.22-4.49-8.92-15.01-12.28-21.35-.12 1.25-.24 2.44-.36 3.57 3.39 6.35 8.12 14.9 11.02 18.95 5.35 7.48 19.14 18.15 23.29 18.15z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M687.34 571.28c.01.01.07.09.19.23.55-.12 1.09-.28 1.61-.5.13-.05.26-.11.38-.18-.33-.44-.55-.71-.62-.8l-1.56 1.25z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M751.56 575.15c-.12 4.75-.31 8.29-.56 10.91v.02c.27 3.05.63 5.29 1.09 5.97 3.48.86 35.47 1.64 40.65-2.51 4.49-3.59 6.07-10.8 4.7-21.44-.33-2.54-1.46-4.84-3.15-6.64-1.7-1.8-3.96-3.1-6.52-3.64-4.51-.93-11.24-2.14-17.72-2.6-5.58-.4-16.79-1.2-18.92.65.5 2.12.63 11.48.43 19.28zm69.2-5.07c-2.21 1.1-4.29 1.65-6.24 1.65-.7 0-1.38-.07-2.05-.22-1.94 2.53-18.48 24.9-11.31 45.97 2.67-.14 15.94-9.6 21.48-17.33 3.21-4.49 8.92-15.01 12.28-21.35v-.01c-.69-7.33-1.26-16.45-.43-22.93-2.87 4.53-7.88 11.29-13.73 14.22z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M813.52 543.61c-3.51 9.26-6.78 19.37-6.35 20.86.38 1.14 1.8 3.6 4.45 4.7 2.35.97 5.13.68 8.24-.88 8.41-4.2 15.36-17.62 15.42-17.76l.02.01c.83-8.01.17-19.7 2.01-28.27-2.54 3.64-5.89 8.1-9.25 11.52-3.85 3.91-10.03 7.92-14.54 9.82zm-64.08 49.75v5.29c.21.07.39.13.56.2.16-.07.35-.13.56-.2v-5.29c-.18-.25-.37-.63-.56-1.22-.19.59-.38.97-.56 1.22zm0-51.66v12.19c.21.1.39.21.56.35.17-.14.35-.25.56-.35V541.7c-.26-.68-.44-1.42-.56-2.19-.13.77-.31 1.51-.56 2.19zm1.12 16.73v20.17c.1 2.72.25 5.29.44 7.46.25-2.62.44-6.16.56-10.91.2-7.8.07-17.16-.43-19.28-.15.12-.26.27-.31.43-.1.31-.19 1.05-.26 2.13zm0 20.17v-20.17c-.26 4.02-.29 12.64 0 20.17z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M750 554.24c-.17-.14-.35-.25-.56-.35v.88c.14-.2.34-.38.56-.53zm-.56 35.43v3.69c.18-.25.37-.63.56-1.22-.2-.59-.38-1.39-.56-2.47z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M748.43 575.15c.12 4.75.32 8.29.57 10.91.19-2.2.34-4.84.44-7.61v-20.02c-.07-1.08-.16-1.82-.26-2.13a.966.966 0 0 0-.31-.43c-.5 2.13-.63 11.48-.44 19.28z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M749 586.06c-.01.01 0 .02 0 .02.13 1.46.28 2.64.44 3.59v-11.22c-.1 2.77-.25 5.41-.44 7.61zm.44-27.63v-3.66a2.486 2.486 0 0 0-.57 1.1c.15.13.26.27.31.43.1.31.19 1.05.26 2.13zm1.63-2.77c.02.06.04.13.06.21 2.13-1.85 13.34-1.05 18.92-.65 6.48.46 13.21 1.67 17.72 2.6 2.56.54 4.82 1.84 6.52 3.64 1.69 1.8 2.82 4.1 3.15 6.64 1.37 10.64-.21 17.85-4.7 21.44-5.18 4.15-37.17 3.37-40.65 2.51-.46-.68-.82-2.92-1.09-5.97-.14 1.46-.28 2.64-.44 3.59v3.69c.28.38.54.47.76.55 1.34.45 8.01.89 15.74.89 10.67 0 23.37-.85 26.93-3.7 3.94-3.15 5.93-8.59 5.93-16.2 0-2.17-.17-4.52-.49-7.05-.77-5.93-5.29-10.75-11.25-11.98-4.57-.95-11.4-2.18-17.99-2.65-10.45-.74-16.78-.84-19.63.67v.88c.24.27.4.56.51.89z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M750 592.14c.19.59.38.97.56 1.22v-3.69c-.18 1.08-.37 1.88-.56 2.47zm-.56-33.71v20.02c.29-7.5.26-16.02 0-20.02zm1.12-3.66v-.88c-.21.1-.39.21-.56.35.22.15.42.33.56.53zm0 23.83v11.07c.16-.95.3-2.13.44-3.59v-.02c-.19-2.17-.34-4.74-.44-7.46zm.26-22.3c.05-.16.16-.31.31-.43a2.486 2.486 0 0 0-.57-1.1v3.66c.07-1.08.16-1.82.26-2.13z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M749.44 554.77v3.66c.26 4 .29 12.52 0 20.02v11.22c.18 1.08.36 1.88.56 2.47.19-.59.38-1.39.56-2.47V578.6c-.29-7.53-.26-16.15 0-20.17v-3.66c-.14-.2-.34-.38-.56-.53-.22.15-.42.33-.56.53zM812 541.99c-.01.03-.03.07-.04.1.05-.01.1-.03.15-.06l-.11-.04zm7.86 26.3c-3.11 1.56-5.89 1.85-8.24.88-2.65-1.1-4.07-3.56-4.45-4.7-.43-1.49 2.84-11.6 6.35-20.86-.9.37-1.72.66-2.46.85-2.33 6.26-6.58 18.25-5.79 20.64.5 1.49 2.14 4.31 5.2 5.73.34-.44.56-.71.63-.8l1.56 1.25c-.01.01-.07.09-.19.23.67.15 1.35.22 2.05.22 1.95 0 4.03-.55 6.24-1.65 5.85-2.93 10.86-9.69 13.73-14.22.1-.73.21-1.42.34-2.08.2-.99.35-2.07.47-3.24l-.02-.01c-.06.14-7.01 13.56-15.42 17.76z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M813.52 543.61c.11-.3.22-.61.34-.91l-1.75-.67c-.05.03-.1.05-.15.06-.24.63-.55 1.44-.9 2.37.74-.19 1.56-.48 2.46-.85zm-12.36 73.87c-7.17-21.07 9.37-43.44 11.31-45.97-.55-.11-1.09-.28-1.62-.5a2.64 2.64 0 0 1-.38-.18c-2.83 3.75-14 19.73-13.08 37.39l.53-.65v1.89l-.39.63c.28 2.76.86 5.54 1.83 8.32.2.56.68.94 1.32 1.03.09.01.18.02.28.02 4.16 0 17.94-10.67 23.3-18.15 2.9-4.05 7.62-12.59 11.02-18.94v-.01c-.12-1.12-.24-2.32-.36-3.57-3.36 6.34-9.07 16.86-12.28 21.35-5.54 7.74-18.81 17.2-21.48 17.34z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M812.47 571.51c.12-.14.18-.22.19-.23l-1.56-1.25c-.07.09-.29.36-.63.8.12.07.25.13.38.18.53.22 1.07.39 1.62.5z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M702.61 608.11c-.03.66-.08 1.31-.15 1.98l.77 1.26c-.01-.82.06-1.63.18-2.42l-.8-.82z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M703.41 608.92c-.12.8-.19 1.6-.18 2.42l.4-2.2-.22-.22zm-1.33-1.35v1.89l.38.63c.07-.66.12-1.32.15-1.98l-.53-.54zm94.69 3.78.76-1.25c-.06-.63-.11-1.25-.14-1.88l-.76.93c.09.72.15 1.45.14 2.2z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M797.92 609.46v-1.89l-.53.65c.03.62.08 1.25.14 1.88l.39-.64z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "syzst2",
	            d: "M654.76 472.6c-.16-1.99-.23-4.33-.24-6.71 0 2.22.06 4.56.24 6.71zm190.31 1.62c.4-3.17.45-7 .38-10.29.03 3.8-.05 7.64-.38 10.29z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M745.48 506.78c-2.49 0-7.57 3.32-11.15 5.65-1.73 1.13-3.37 2.2-4.84 3.04-3.72 2.12-11.33 7.49-17.06 11.62-3.71 2.66-6.19 6.77-6.81 11.26-.34 2.44-.47 4.36-.47 5.88 0 4.3 1.06 5.36 1.47 5.61 3.72 2.24 29.55-3.24 37.07-5.39 4.5-1.29 4.67-5.06 4.58-11.63-.01-.78-.03-1.57-.03-2.37 0-1.32.03-2.84.07-4.48.12-6.41.32-16.1-1.63-18.7-.25-.34-.67-.49-1.2-.49z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M744.24 546.38c-2.7.77-23.85 5.94-34 5.94-2.12 0-3.76-.23-4.65-.77-2.37-1.42-3.01-5.83-1.95-13.47.35-2.52 1.21-4.92 2.51-7.08 1.3-2.15 3.04-4.04 5.11-5.54 5.77-4.15 13.44-9.56 17.24-11.73 1.42-.81 3.03-1.86 4.74-2.98 6.13-3.99 12.46-8.12 15.04-4.68.49.65.87 1.57 1.16 2.68v-24.31c-.8 5.19-2.07 9.43-4.04 10.74-3.05 2.03-13.52 10.84-21.93 17.92-6.29 5.31-11.27 9.49-12.41 10.26-.95.63-2.1.95-3.3.95-.79 0-1.62-.14-2.42-.43-1.87-.69-3.23-2.04-3.72-3.72-1.76-6.01-.11-31.82-.04-32.92v-.02c.03-.32.09-.66.17-1.01.02-.1.06-.2.08-.29.07-.27.16-.55.26-.83.03-.08.06-.16.09-.25 3.88-10.13 25.28-27.87 34.41-33.7-5.47 2.46-12.25 3.82-20.33 4.05-.26.15-.74.43-1.42.81 1.98.48 4.44 1.37 5.65 2.99.66.88.89 1.91.67 2.99-.89 4.43-28.37 21.91-43.81 27.87 2.19.56 5.66 1.28 10.35 1.75 8.74.88 11.07 11.13 12.06 15.51.1.42.18.79.26 1.09.36 1.44-.2 2.98-1.58 4.36-1.79 1.79-5.04 3.34-8.81 3.45 1.2 2.1 3.25 5.99 4.08 9.29 2.34 9.38.35 18.01-2.14 19.26-.24.12-.55.18-.93.18-.48 0-1.06-.09-1.71-.27 2.33 6.26 6.58 18.25 5.79 20.64-.5 1.49-2.14 4.31-5.21 5.73 2.82 3.74 13.96 19.67 13.09 37.28l.8.81c.48-3.28 1.99-6.31 4.43-8.68 3.02-2.94 7.01-4.46 11.24-4.3 16.41.68 26.6 1.58 30.36 2.7v-5.29c-.28.38-.54.47-.76.55-1.34.44-8.01.89-15.74.89-10.67 0-23.37-.85-26.93-3.7-5.07-4.05-6.9-11.88-5.44-23.25.77-5.93 5.29-10.75 11.25-11.98 4.57-.95 11.4-2.18 17.98-2.65 10.45-.75 16.79-.85 19.64.67V541.7c-.79 2.17-2.31 3.85-5.19 4.68z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M740.64 452.19c-4.62.92-36.22 25.31-37.06 35.19-.04.63-1.69 26.58-.04 32.22.31 1.06 1.22 1.93 2.49 2.4 1.38.5 2.88.38 3.92-.31 1.05-.7 6.48-5.27 12.24-10.12 8.88-7.48 18.96-15.96 22.1-18.05 4.49-3 4.9-32.39 4.04-34.86-.36-.71-3.75-7.25-7.69-6.47zm-83.73 21.78c1.25 10.03 5.28 15.22 12.31 15.86 9.79.88 49.09-24.68 50-28.26.1-.52 0-.97-.32-1.4-1.24-1.66-5.08-2.44-6.81-2.65-8.43 4.55-27.12 13.8-39.88 13.8-4.75 0-8.68-1.28-10.95-4.58-1.97-2.87-3.4-5.82-4.44-8.73-.21 3.11-.58 10.62.09 15.96z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M662.91 465.6c1.87 2.73 5.21 3.81 9.32 3.81 12.51 0 32.2-10.02 39.93-14.23-2.25-.03-4.58-.15-7.01-.34-25.99-2.11-43.17-5.97-48.52-17.4v-.03c-.57 4.68-1.2 17.33 6.28 28.19zm27.82 77.14c.96-.53 3.34-7.78 1.05-16.96-.95-3.77-3.74-8.59-4.52-9.9h-.01c-.54-.07-1.09-.17-1.64-.31-5.97-1.5-21.83-11.94-27.37-15.67.62 5.3 1.43 11.45 2.58 15.92v.02c1.96 3.08 7.32 11.24 12.54 16.55 4.35 4.44 10.76 8.13 14.52 9.65l.12-.05c.01.04.03.07.04.11 1.31.51 2.28.75 2.69.64zm6.3-31.6c.5-.5 1.3-1.48 1.06-2.46-.08-.32-.17-.7-.27-1.13-.97-4.3-3-13.24-10.31-13.97-7.8-.78-12.28-2.22-13.36-2.62-1.85.57-3.41.88-4.6.88-.18 0-.35-.01-.51-.02-5.01-.46-8.74-2.95-11.17-7.44l-.37 8.97c.14 1.16.28 2.48.44 3.92v.01c3.27 2.22 21.94 14.79 28.16 16.35 4.44 1.11 8.86-.42 10.93-2.49z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M748.28 506.07c-2.58-3.44-8.91.69-15.04 4.68-1.71 1.12-3.32 2.17-4.74 2.98-3.8 2.17-11.47 7.58-17.24 11.73-2.07 1.5-3.81 3.39-5.11 5.54-1.3 2.16-2.16 4.56-2.51 7.08-1.06 7.64-.42 12.05 1.95 13.47.89.54 2.53.77 4.65.77 10.15 0 31.3-5.17 34-5.94 2.88-.83 4.4-2.51 5.2-4.68v-32.95c-.29-1.11-.67-2.03-1.16-2.68zm.03 19.9c-.04 1.64-.07 3.16-.07 4.48 0 .8.02 1.59.03 2.37.09 6.57-.08 10.34-4.58 11.63-7.52 2.15-33.35 7.63-37.07 5.39-.41-.25-1.47-1.31-1.47-5.61 0-1.52.13-3.44.47-5.88.62-4.49 3.1-8.6 6.81-11.26 5.73-4.13 13.34-9.5 17.06-11.62 1.47-.84 3.11-1.91 4.84-3.04 3.58-2.33 8.66-5.65 11.15-5.65.53 0 .95.15 1.2.49 1.95 2.6 1.75 12.29 1.63 18.7zm1.13-63.48v-5.97c-1.49-2.51-4.87-7.16-9.2-6.29-4.15.83-33.43 22.7-38.06 34.61-.03.08-.07.17-.09.25-.1.28-.18.56-.26.83-.03.1-.06.2-.08.29-.08.35-.14.69-.17 1.01v.02c-.07 1.1-1.72 26.91.04 32.92.49 1.68 1.85 3.03 3.72 3.72.8.29 1.63.43 2.42.43 1.2 0 2.35-.32 3.3-.95 1.14-.77 6.12-4.95 12.41-10.26 8.41-7.08 18.88-15.89 21.93-17.92 1.97-1.31 3.24-5.55 4.04-10.74v-13.67c-.09-3.13-.08-6.02 0-8.28zm-5.15 31.03c-3.14 2.09-13.22 10.57-22.1 18.05-5.76 4.85-11.19 9.42-12.24 10.12-1.04.69-2.54.81-3.92.31-1.27-.47-2.18-1.34-2.49-2.4-1.65-5.64 0-31.59.04-32.22.84-9.88 32.44-34.27 37.06-35.19 3.94-.78 7.33 5.76 7.69 6.47.86 2.47.45 31.86-4.04 34.86z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M702.19 484.83c4.63-11.91 33.9-33.78 38.06-34.61 4.33-.87 7.71 3.78 9.2 6.29-1.49-2.51-4.87-8.16-9.2-7.29l-.09.03c-1.12.68-2.3 1.31-3.55 1.88-9.14 5.83-30.54 23.57-34.42 33.7zm-.36 1.08c.07-.27.15-.55.26-.83-.1.28-.18.56-.26.83zm-.25 1.31zm.51-2.14c.03-.08.06-.16.09-.25-.03.09-.06.17-.09.25zm-.34 1.12c.02-.1.06-.2.08-.29-.02.1-.06.2-.08.29zm-45.44-29.68.6.05c0 .02-.04.55-.1 1.44 1.04 2.91 2.47 5.87 4.44 8.73 2.26 3.29 6.19 4.58 10.95 4.58 12.75 0 31.44-9.24 39.88-13.8-.11-.01-.22-.03-.31-.03l.19-1.99c.28.03 1.46.16 2.89.5.68-.38 1.16-.66 1.42-.81-.81.02-1.63.03-2.46.03-.54 0-1.09 0-1.65-.02h-.01c-7.73 4.21-27.42 14.23-39.93 14.23-4.11 0-7.44-1.08-9.32-3.81-7.47-10.87-6.85-23.52-6.29-28.18-.32-.68-.6-1.35-.83-2.09l-.85-.18c-.06.28-.62 3.1-.66 7.29.05 3.81.44 8.23 1.57 12.48.15.51.3 1.05.47 1.58z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M718.89 460.17c.32.43.42.88.32 1.4-.91 3.58-40.21 29.14-50 28.26-7.03-.64-11.05-5.83-12.31-15.86-.67-5.34-.3-12.85-.1-15.96-.18-.5-.35-.99-.5-1.49l-1.39-.12c-.02.28-.37 4.58-.4 9.49.01 2.38.08 4.72.24 6.71.05.55.1 1.1.16 1.62.33 2.67.87 5.04 1.61 7.11l1.41 1.29-.07 1.76c2.43 4.49 6.16 6.99 11.17 7.44.16.01.33.02.51.02 1.19 0 2.75-.32 4.6-.88h-.01a1.95 1.95 0 0 1-.24-.08l.72-1.86c.02 0 .95.36 2.74.82 15.45-5.96 42.92-23.44 43.81-27.87.21-1.07-.02-2.11-.67-2.99-1.21-1.62-3.67-2.51-5.65-2.99-.72.41-1.66.93-2.77 1.53 1.75.21 5.59.99 6.82 2.65z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M654.93 474.22c-.07-.52-.11-1.07-.16-1.62.04.57.09 1.12.16 1.62zm1.38-17.7-1.39-4.12c-.03.3-.42 7-.4 13.49.02-4.91.37-9.21.4-9.49l1.39.12zm30.94 59.36h.01zm0 0c-.13-.22-.2-.34-.21-.35l1.7-1.06c.04.08.4.64.9 1.53 3.77-.11 7.02-1.66 8.81-3.45 1.38-1.38 1.94-2.92 1.58-4.36-.08-.3-.16-.67-.26-1.09-.99-4.38-3.32-14.63-12.06-15.51-4.69-.47-8.16-1.19-10.35-1.75-1.14.44-2.22.82-3.21 1.12 1.08.39 5.57 1.84 13.36 2.62 7.31.73 9.34 9.67 10.31 13.97.1.43.19.81.27 1.13.24.98-.56 1.96-1.06 2.46-2.07 2.07-6.49 3.6-10.93 2.49-6.22-1.56-24.89-14.13-28.16-16.35.1.84.2 1.71.3 2.61v.01c5.54 3.73 21.4 14.17 27.37 15.67.55.14 1.1.24 1.64.31z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M673.9 490.88c.02.01.1.04.24.08h.01c1-.3 2.07-.68 3.21-1.12-1.79-.46-2.72-.82-2.74-.82l-.72 1.86zm-13.08 24.96c.25 1 .53 1.92.82 2.72.42 1.15.77 2.4 1.05 3.72 2.54 3.64 5.88 8.09 9.24 11.51 3.84 3.92 10.02 7.92 14.54 9.81-.11-.3-.23-.6-.34-.9l1.74-.66h.01c-3.76-1.52-10.17-5.21-14.52-9.65-5.22-5.31-10.58-13.47-12.54-16.55zm30.76 28.71c2.49-1.25 4.48-9.88 2.14-19.26-.83-3.3-2.88-7.19-4.08-9.29-.15.01-.31.01-.46.01-.63 0-1.26-.04-1.92-.13.78 1.31 3.57 6.13 4.52 9.9 2.29 9.18-.09 16.43-1.05 16.96-.41.11-1.38-.13-2.69-.64.24.63.55 1.43.9 2.36.65.18 1.23.27 1.71.27.38 0 .69-.06.93-.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M687.04 515.53c.01.01.08.13.21.35h.01c.66.09 1.29.13 1.92.13.15 0 .31 0 .46-.01-.5-.89-.86-1.45-.9-1.53l-1.7 1.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M781.11 460.17c-.32.43-.42.88-.32 1.4.89 3.51 38.89 28.28 49.47 28.28.18 0 .36-.01.52-.02 7.03-.64 11.05-5.83 12.3-15.86.67-5.34.3-12.85.1-15.97-1.04 2.91-2.47 5.87-4.44 8.73-2.26 3.29-6.19 4.58-10.95 4.58-12.75 0-31.44-9.24-39.88-13.8-1.73.22-5.57 1-6.8 2.66zm-21.75-7.98c-.22-.05-.44-.07-.66-.07-3.65 0-6.7 5.87-7.05 6.58-.84 2.43-.43 31.82 4.06 34.82 3.14 2.09 13.21 10.57 22.1 18.05 5.75 4.84 11.19 9.42 12.24 10.12 1.03.69 2.54.81 3.92.31 1.27-.47 2.18-1.34 2.49-2.4 1.65-5.64 0-31.59-.04-32.22-.84-9.88-32.44-34.27-37.06-35.19z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M808.42 544.55c-2.49-1.25-4.49-9.88-2.14-19.26.82-3.3 2.88-7.19 4.07-9.29-3.77-.12-7.01-1.66-8.8-3.45-1.38-1.38-1.94-2.92-1.58-4.36.07-.3.16-.67.25-1.09 1-4.38 3.32-14.63 12.06-15.51 4.68-.47 8.15-1.19 10.34-1.75h.01c-15.45-5.96-42.92-23.44-43.8-27.87-.21-1.07.02-2.11.67-2.99 1.21-1.62 3.67-2.51 5.65-2.99-.68-.38-1.16-.66-1.42-.81h-.01c-8.08-.23-14.86-1.58-20.33-4.05 9.13 5.83 30.54 23.58 34.42 33.71.03.08.06.16.09.25.1.28.19.56.26.83.03.1.06.2.08.29.08.35.14.69.17 1.01v.02c.08 1.1 1.73 26.91-.03 32.92-.5 1.68-1.85 3.03-3.73 3.72-.8.29-1.62.43-2.42.43-1.2 0-2.34-.32-3.29-.95-1.14-.77-6.12-4.96-12.42-10.26-8.41-7.08-18.87-15.89-21.92-17.92-1.97-1.31-3.24-5.55-4.04-10.74v24.28c.29-1.1.67-2 1.15-2.65 2.59-3.43 8.92.69 15.05 4.68 1.7 1.12 3.32 2.17 4.74 2.98 3.8 2.17 11.47 7.58 17.24 11.73 4.15 2.99 6.92 7.59 7.62 12.62.33 2.38.49 4.44.49 6.2 0 3.89-.81 6.29-2.44 7.27-.9.54-2.53.77-4.65.77-10.15 0-31.3-5.17-34-5.94-2.88-.83-4.41-2.51-5.2-4.68v12.19c2.85-1.51 9.18-1.41 19.63-.67 6.59.47 13.42 1.7 17.99 2.65 5.96 1.23 10.48 6.05 11.25 11.98.32 2.53.49 4.88.49 7.05 0 7.61-1.99 13.05-5.93 16.2-3.56 2.85-16.26 3.7-26.93 3.7-7.73 0-14.4-.44-15.74-.89-.22-.08-.48-.17-.76-.55v5.29c3.76-1.12 13.95-2.02 30.36-2.7.21-.01.42-.01.63-.01 3.98 0 7.73 1.52 10.61 4.31a15.05 15.05 0 0 1 4.46 8.9l.76-.93c-.91-17.66 10.25-33.64 13.08-37.39-3.06-1.42-4.7-4.24-5.2-5.73-.79-2.39 3.46-14.38 5.79-20.64-.65.18-1.23.27-1.71.27-.37 0-.68-.06-.92-.18zm28.67-78.95c7.48-10.89 6.85-23.52 6.29-28.18 0 0 .01.01 0 .02-5.35 11.43-22.53 15.29-48.52 17.4-2.43.19-4.77.31-7.02.34 10.28 5.6 41.68 21.44 49.25 10.42z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M756.31 544.45c7.52 2.15 33.34 7.63 37.07 5.39.56-.34 2.29-2.16 1-11.49-.62-4.49-3.1-8.6-6.81-11.26-5.73-4.13-13.34-9.5-17.06-11.62-1.48-.84-3.11-1.91-4.85-3.04-3.57-2.33-8.66-5.65-11.15-5.65-.53 0-.94.15-1.2.49-1.94 2.6-1.75 12.29-1.62 18.71.03 1.63.06 3.16.06 4.47 0 .8-.01 1.59-.02 2.37-.09 6.57.07 10.34 4.58 11.63zm56.44-28.57c-.79 1.31-3.58 6.13-4.53 9.9-2.3 9.18.08 16.44 1.09 16.98.39.1 1.34-.14 2.65-.67.01-.03.03-.07.04-.1l.11.04c3.73-1.51 10.16-5.2 14.53-9.64 5.22-5.31 10.58-13.47 12.54-16.55v-.02c1.15-4.47 1.96-10.62 2.58-15.92-5.55 3.73-21.4 14.17-27.37 15.67-.55.14-1.1.24-1.64.31zm30.96-35.3c-2.21 6.88-6.47 10.67-12.74 11.24-.16.01-.33.02-.51.02-1.18 0-2.75-.32-4.59-.88h-.01c-1.09.39-5.58 1.83-13.37 2.61-7.3.73-9.33 9.67-10.31 13.97-.1.43-.18.81-.26 1.13-.25.98.55 1.96 1.05 2.46 2.08 2.08 6.51 3.6 10.94 2.49 6.22-1.56 24.89-14.13 28.16-16.35v-.01c.18-1.59.34-3.04.48-4.27l1.16-12.41zm-94.27 3.86v24.31c.24.9.42 1.93.56 3.04.14-1.13.32-2.16.56-3.07v-24.28c-.22-1.44-.41-2.95-.56-4.49-.15 1.54-.34 3.05-.56 4.49z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M749.73 532.79c.01-.77.02-1.55.02-2.34 0-1.3-.03-2.81-.06-4.43-.09-4.68-.2-10.07.31-14.23-.14-1.11-.32-2.14-.56-3.04v32.95c.25-.68.43-1.42.56-2.19-.34-2.05-.3-4.36-.27-6.72zm.13-74.99c.04-.07.08-.16.14-.27-.13-.26-.32-.61-.56-1.01v5.97c.08-2.58.24-4.33.42-4.69zm-.42 12.97v13.67c.22-1.44.41-2.95.56-4.49-.3-3.05-.48-6.22-.56-9.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M755.76 546.38c2.7.77 23.85 5.94 34 5.94 2.12 0 3.75-.23 4.65-.77 1.63-.98 2.44-3.38 2.44-7.27 0-1.76-.16-3.82-.49-6.2-.7-5.03-3.47-9.63-7.62-12.62-5.77-4.15-13.44-9.56-17.24-11.73-1.42-.81-3.04-1.86-4.74-2.98-6.13-3.99-12.46-8.11-15.05-4.68-.48.65-.86 1.55-1.15 2.65v32.98c.79 2.17 2.32 3.85 5.2 4.68zm-4.07-20.4c-.13-6.42-.32-16.11 1.62-18.71.26-.34.67-.49 1.2-.49 2.49 0 7.58 3.32 11.15 5.65 1.74 1.13 3.37 2.2 4.85 3.04 3.72 2.12 11.33 7.49 17.06 11.62 3.71 2.66 6.19 6.77 6.81 11.26 1.29 9.33-.44 11.15-1 11.49-3.73 2.24-29.55-3.24-37.07-5.39-4.51-1.29-4.67-5.06-4.58-11.63.01-.78.02-1.57.02-2.37 0-1.31-.03-2.84-.06-4.47zM750 511.79c.51 4.16.4 9.55.31 14.22-.04 1.63-.07 3.14-.07 4.44 0 .79.02 1.57.03 2.34.03 2.36.06 4.67-.27 6.72.12.77.3 1.51.56 2.19v-32.98c-.24.91-.42 1.94-.56 3.07z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M750.27 532.79c-.01-.77-.03-1.55-.03-2.34 0-1.3.03-2.81.07-4.44.09-4.67.2-10.06-.31-14.22-.51 4.16-.4 9.55-.31 14.23.03 1.62.06 3.13.06 4.43 0 .79-.01 1.57-.02 2.34-.03 2.36-.07 4.67.27 6.72.33-2.05.3-4.36.27-6.72zm-.83-62.02v-8.28c-.08 2.26-.09 5.15 0 8.28zm10.31-20.54c-4.3-.87-7.7 3.78-9.19 6.29v5.97c.08 2.26.09 5.15 0 8.28v13.67c.8 5.19 2.07 9.43 4.04 10.74 3.05 2.03 13.51 10.84 21.92 17.92 6.3 5.3 11.28 9.49 12.42 10.26.95.63 2.09.95 3.29.95.8 0 1.62-.14 2.42-.43 1.88-.69 3.23-2.04 3.73-3.72 1.76-6.01.11-31.82.03-32.92v-.02c-.03-.33-.09-.67-.17-1.01-.02-.1-.06-.2-.08-.29-.07-.27-.15-.55-.26-.83-.03-.08-.06-.16-.09-.25-4.62-11.92-33.9-33.78-38.06-34.61zm36.71 69.37c-.31 1.06-1.22 1.93-2.49 2.4-1.38.5-2.89.38-3.92-.31-1.05-.7-6.49-5.28-12.24-10.12-8.89-7.48-18.96-15.96-22.1-18.05-4.49-3-4.9-32.39-4.06-34.82.35-.71 3.4-6.58 7.05-6.58.22 0 .44.02.66.07 4.62.92 36.22 25.31 37.06 35.19.04.63 1.69 26.58.04 32.22zm1.78-33.4z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M797.9 485.08c.1.28.18.56.26.83-.07-.27-.15-.55-.26-.83zm-47.34-28.56c1.49-2.51 4.89-7.16 9.19-6.29 4.15.83 33.44 22.7 38.06 34.61-3.88-10.13-25.29-27.88-34.42-33.71-1.25-.56-2.43-1.19-3.54-1.87-.03-.01-.07-.03-.1-.03-4.3-.87-7.7 4.78-9.19 7.29zm47.6 29.39zm-.35-1.08c.03.08.07.16.09.25-.03-.08-.06-.16-.09-.25zm-47.25-22.34v-5.97c-.24.4-.43.75-.56 1.01.06.11.1.2.14.27.18.36.34 2.11.42 4.69zm-.56 17.46c.15 1.54.34 3.05.56 4.49v-13.67c-.08 2.96-.26 6.13-.56 9.18zm.56-17.46v8.28c.09-3.13.08-6.02 0-8.28z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M749.44 462.49v8.28c.08 2.96.26 6.13.56 9.18.3-3.05.48-6.22.56-9.18v-8.28c-.08-2.58-.24-4.33-.42-4.69-.04-.07-.08-.16-.14-.27-.06.11-.1.2-.14.27-.18.36-.34 2.11-.42 4.69zm38.6-7 .19 1.99c-.09.01-.2.02-.31.03 8.43 4.55 27.12 13.8 39.88 13.8 4.75 0 8.68-1.29 10.95-4.58 1.97-2.87 3.4-5.83 4.44-8.73-.06-.88-.1-1.41-.1-1.44l.6-.05 1.29-5.32c.12-.65.22-1.29.3-1.92.24-2.17.37-4.37.43-6.47-.01-4.38-.6-7.36-.66-7.65l-.85.18c-.23.74-.51 1.42-.83 2.09.56 4.67 1.19 17.3-6.29 28.18-7.58 11.02-38.97-4.82-49.25-10.42h-.01c-.55.02-1.1.02-1.64.02-.84 0-1.65-.01-2.46-.03.26.15.74.43 1.42.81 1.44-.33 2.63-.46 2.9-.49z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M843.99 456.49c-.1.35-.2.69-.3 1.03l-.22-.35c-.09.28-.18.55-.28.83.2 3.11.57 10.62-.1 15.97-1.25 10.03-5.28 15.22-12.3 15.86-.17.02-.34.02-.52.02-10.58 0-48.58-24.76-49.47-28.28-.1-.52 0-.97.32-1.4 1.23-1.66 5.07-2.44 6.81-2.65-1.11-.6-2.05-1.12-2.77-1.53-1.98.48-4.44 1.37-5.65 2.99-.65.88-.89 1.91-.67 2.99.89 4.43 28.36 21.91 43.8 27.87 1.8-.46 2.73-.82 2.75-.82l.72 1.86c-.02.01-.1.04-.24.09 1.84.56 3.41.88 4.59.88.18 0 .35-.01.51-.02 6.27-.57 10.53-4.35 12.74-11.24l.28-2.98.02 2.01c.46-1.64.82-3.43 1.06-5.39.33-2.65.41-6.49.38-10.29-.09-4.04-.35-7.29-.37-7.53l-1.09.08z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M845.08 456.4c.02.24.29 3.48.37 7.53-.05-5.68-.35-11.25-.43-12.54-.26 1.78-.59 3.51-1.03 5.1l1.09-.09zm-42.12 54.74c-.5-.5-1.3-1.48-1.05-2.46.08-.32.16-.7.26-1.13.98-4.3 3.01-13.24 10.31-13.97 7.79-.78 12.28-2.22 13.37-2.61h.01c-1-.31-2.08-.69-3.23-1.13h-.01c-2.19.56-5.66 1.28-10.34 1.75-8.74.88-11.06 11.13-12.06 15.51-.09.42-.18.79-.25 1.09-.36 1.44.2 2.98 1.58 4.36 1.79 1.79 5.03 3.33 8.8 3.45.51-.89.87-1.45.91-1.53l1.7 1.06c-.01.01-.08.13-.21.35.54-.07 1.09-.17 1.64-.31 5.97-1.5 21.82-11.94 27.37-15.67v-.01c.1-.9.2-1.77.3-2.61-3.27 2.22-21.94 14.79-28.16 16.35-4.43 1.11-8.86-.41-10.94-2.49z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M825.38 489.02c-.02 0-.95.36-2.75.82 1.15.44 2.23.82 3.23 1.13.14-.05.22-.08.24-.09l-.72-1.86zm-13.27 53.01 1.75.67c-.12.3-.23.61-.34.91 4.51-1.9 10.69-5.91 14.54-9.82 3.36-3.42 6.71-7.88 9.25-11.52v-.01c.29-1.32.63-2.56 1.05-3.7.29-.8.57-1.72.82-2.72-1.96 3.08-7.32 11.24-12.54 16.55-4.37 4.44-10.8 8.13-14.53 9.64zm-2.8.73c-1.01-.54-3.39-7.8-1.09-16.98.95-3.77 3.74-8.59 4.53-9.9-.66.09-1.3.13-1.93.13-.16 0-.32 0-.47-.01-1.19 2.1-3.25 5.99-4.07 9.29-2.35 9.38-.35 18.01 2.14 19.26.24.12.55.18.93.18.48 0 1.06-.09 1.71-.27.35-.93.66-1.74.9-2.37-1.31.53-2.26.77-2.65.67z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M812.75 515.88c.13-.22.2-.34.21-.35l-1.7-1.06c-.04.08-.4.64-.91 1.53.15.01.31.01.47.01.63 0 1.27-.04 1.93-.13zm-156.39-25.49 1.09 4.01.04-1.05c-.47-4.05-.79-5.96-1.13-2.96z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "m656.53 481.33-.17 9.06c.33-2.99.66-1.09 1.14 2.96l.37-8.97c-.5-.93-.95-1.95-1.34-3.05z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M656.53 481.33c.39 1.1.83 2.12 1.33 3.05l.07-1.76-1.4-1.29zm187.18-.75c.1-.32.21-.64.3-.98l-.02-2.01-.28 2.99z"
	          }),
	          this.props.bodyTitle === "Upper GI" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "533",
	              width: "165",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M804.206 554.009h290" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1119.99 537.793h5.203v13.957c0 2.215.065 3.651.194 4.307.222 1.055.752 1.901 1.59 2.54.838.639 1.984.958 3.437.958 1.476 0 2.59-.302 3.34-.905.75-.604 1.201-1.345 1.353-2.224.153-.879.229-2.338.229-4.377v-14.256h5.203v13.536c0 3.093-.141 5.279-.422 6.556-.281 1.278-.8 2.356-1.556 3.235-.756.878-1.766 1.579-3.032 2.1-1.266.522-2.918.782-4.957.782-2.461 0-4.327-.284-5.599-.852-1.271-.569-2.276-1.307-3.014-2.215-.739-.908-1.225-1.86-1.459-2.856-.34-1.477-.51-3.657-.51-6.54v-13.746Zm25.86 7.102h4.606v2.742c.598-.937 1.406-1.699 2.426-2.285 1.019-.586 2.15-.879 3.392-.879 2.168 0 4.008.85 5.52 2.549 1.512 1.699 2.267 4.066 2.267 7.101 0 3.118-.761 5.541-2.285 7.269-1.523 1.729-3.369 2.593-5.537 2.593-1.031 0-1.966-.205-2.804-.615-.837-.411-1.719-1.114-2.645-2.11v9.404h-4.94v-25.769Zm4.887 9.018c0 2.097.416 3.647 1.248 4.649.832 1.002 1.846 1.503 3.041 1.503 1.149 0 2.104-.46 2.865-1.38.762-.92 1.143-2.429 1.143-4.526 0-1.957-.393-3.411-1.178-4.36-.785-.949-1.758-1.424-2.918-1.424-1.207 0-2.209.466-3.006 1.398-.796.932-1.195 2.311-1.195 4.14Zm17.103-9.018h4.605v2.742c.598-.937 1.406-1.699 2.426-2.285 1.019-.586 2.15-.879 3.393-.879 2.167 0 4.007.85 5.519 2.549 1.512 1.699 2.268 4.066 2.268 7.101 0 3.118-.762 5.541-2.286 7.269-1.523 1.729-3.369 2.593-5.537 2.593-1.031 0-1.965-.205-2.803-.615-.838-.411-1.72-1.114-2.646-2.11v9.404h-4.939v-25.769Zm4.886 9.018c0 2.097.416 3.647 1.248 4.649.832 1.002 1.846 1.503 3.041 1.503 1.149 0 2.104-.46 2.866-1.38.761-.92 1.142-2.429 1.142-4.526 0-1.957-.392-3.411-1.177-4.36-.786-.949-1.758-1.424-2.918-1.424-1.207 0-2.209.466-3.006 1.398-.797.932-1.196 2.311-1.196 4.14Zm28.054 3.709 4.922.826c-.633 1.804-1.632 3.178-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.433 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.433 2.604 1.195 3.419.762.814 1.711 1.221 2.848 1.221.773 0 1.423-.211 1.951-.632.527-.422.926-1.102 1.195-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.566-1.117-1.079 0-1.969.393-2.672 1.178-.703.785-1.049 1.852-1.037 3.199h7.382Zm13.659 10.934h-4.94v-18.668h4.588v2.654c.785-1.254 1.491-2.08 2.118-2.478.627-.399 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.306c-.832-.539-1.606-.808-2.321-.808-.691 0-1.277.19-1.758.571-.48.381-.858 1.069-1.133 2.065-.276.997-.413 3.083-.413 6.258v5.766Zm31.31-9.475v-4.341h11.215v10.265c-1.09 1.055-2.669 1.984-4.737 2.786-2.069.803-4.163 1.204-6.284 1.204-2.696 0-5.045-.565-7.049-1.696-2.004-1.131-3.51-2.748-4.518-4.851-1.008-2.104-1.512-4.392-1.512-6.865 0-2.683.563-5.068 1.688-7.154 1.125-2.086 2.771-3.686 4.939-4.799 1.653-.855 3.709-1.283 6.17-1.283 3.2 0 5.699.671 7.497 2.013 1.799 1.341 2.956 3.196 3.472 5.563l-5.168.967c-.363-1.266-1.046-2.265-2.048-2.997-1.002-.733-2.253-1.099-3.753-1.099-2.273 0-4.081.721-5.423 2.162-1.341 1.442-2.012 3.58-2.012 6.416 0 3.059.679 5.353 2.039 6.882 1.359 1.529 3.14 2.294 5.344 2.294 1.089 0 2.182-.214 3.278-.641 1.096-.428 2.036-.947 2.821-1.556v-3.27h-5.959Zm15.85-16.295h5.203v25.77h-5.203z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.props.bodyTitle === "Lower Abdomen" ? "bodyParts_group Lower_Abdomen body_parts_active" : "bodyParts_group Lower_Abdomen"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyParts",
	            d: "M749.44 688.24v-79.09c-.8 14.65-.61 46.1 0 79.09zm-.93-87.78c-2.44-.65-9.45-1.69-29.51-2.51-.19-.01-.38-.01-.56-.01-3.46 0-6.71 1.32-9.21 3.75a13.04 13.04 0 0 0-4 9.63c.1 7.7.5 18.68 1.86 27.26 2.61 16.55 10.57 42.21 14.9 52.6 1.92 4.6 4.75 14.69 7.74 25.37 3.49 12.45 7.83 27.95 9.66 29.78 2.19 2.19 6.97 1.06 9.46.14-.14-4.83-1.12-38.45-1.63-71.95-.86-57.15.22-70.59 1.29-74.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyParts",
	            d: "M743.22 749.59c-1.92 0-3.85-.45-5.25-1.85-2.04-2.04-5.2-12.94-10.17-30.65-2.97-10.62-5.78-20.65-7.65-25.14-4.48-10.74-12.36-36.12-15.03-53.05-1.38-8.71-1.79-19.79-1.89-27.55l-.77-1.26c-.28 2.76-.86 5.55-1.83 8.33-.2.56-.67.94-1.31 1.03-.09.01-.19.02-.29.02-4.15 0-17.94-10.67-23.29-18.15-2.9-4.05-7.63-12.6-11.02-18.95-.15 1.47-.3 2.81-.43 3.98-.37 3.38-3.14 10.09-6.46 17.64-.08 5.52.11 20.9 4.28 29.93 3.37 7.3 16.74 26.88 27.48 42.62 6.08 8.89 11.32 16.57 13.84 20.67 1.36 2.21 3.1 6.41 5.03 11.83 0 .01.01.02.02.04.71 1.38 17.95 35 20.53 40.15 2.06 4.13 8.55 11.44 10.98 14.1 2.88-1 7.37-1 9.45-.94v-14.01c-1.35.48-3.79 1.21-6.22 1.21z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyLines",
	            d: "m748.89 747.69-.02-.63c0-.03-.01-.23-.02-.59-2.49.92-7.27 2.05-9.46-.14-1.83-1.83-6.17-17.33-9.66-29.78-2.99-10.68-5.82-20.77-7.74-25.37-4.33-10.39-12.29-36.05-14.9-52.6-1.36-8.58-1.76-19.56-1.86-27.26a13.04 13.04 0 0 1 4-9.63c2.5-2.43 5.75-3.75 9.21-3.75.18 0 .37 0 .56.01 20.06.82 27.07 1.86 29.51 2.51.3-.99.6-1.17.85-1.32a.3.3 0 0 1 .08-.04v-.45c-3.76-1.12-13.95-2.02-30.36-2.7-4.23-.16-8.22 1.36-11.24 4.3a15.034 15.034 0 0 0-4.43 8.68l.22.22-.4 2.2c.1 7.76.51 18.84 1.89 27.55 2.67 16.93 10.55 42.31 15.03 53.05 1.87 4.49 4.68 14.52 7.65 25.14 4.97 17.71 8.13 28.61 10.17 30.65 1.4 1.4 3.33 1.85 5.25 1.85 2.43 0 4.87-.73 6.22-1.21v-.44l-.55-.25z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyParts",
	            d: "M750.56 609.14v79.07c.61-32.99.8-64.43 0-79.07zm2.21 65.38c-.5 33.47-1.48 67.07-1.63 71.94 2.49.93 7.28 2.06 9.47-.13 1.82-1.83 6.17-17.32 9.66-29.78 2.99-10.68 5.82-20.77 7.73-25.37 4.34-10.39 12.29-36.05 14.91-52.6 1.35-8.58 1.76-19.56 1.86-27.26.04-3.66-1.38-7.08-4-9.63-2.63-2.56-6.11-3.88-9.77-3.74-12.05.49-19.39 1.07-23.86 1.58-2.97.35-4.68.67-5.65.93 1.06 3.47 2.14 16.91 1.28 74.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyParts",
	            d: "M800.96 619.47c-.1 0-.19-.01-.28-.02-.64-.09-1.12-.47-1.32-1.03a36.36 36.36 0 0 1-1.83-8.32l-.76 1.25c-.11 7.76-.51 18.85-1.89 27.55-2.67 16.94-10.56 42.31-15.03 53.05-1.87 4.49-4.68 14.52-7.66 25.14-4.96 17.71-8.12 28.61-10.16 30.65-1.4 1.4-3.33 1.85-5.25 1.85-2.44 0-4.87-.72-6.22-1.21v14.02c2.07-.07 6.57-.07 9.45.93 2.42-2.66 8.91-9.97 10.98-14.1 2.56-5.12 19.64-38.41 20.51-40.12.02-.04.04-.06.04-.07 1.92-5.42 3.65-9.62 5.02-11.83 2.52-4.1 7.77-11.77 13.84-20.67 10.74-15.74 24.12-35.32 27.49-42.62 4.16-9.03 4.36-24.39 4.27-29.92.01-.01.01-.01 0-.02-3.32-7.55-6.08-14.25-6.45-17.63-.13-1.17-.28-2.51-.43-3.97-3.4 6.35-8.12 14.89-11.02 18.94-5.36 7.48-19.14 18.15-23.3 18.15zm-50.4-10.33c-.15-2.75-.34-4.91-.56-6.37-.22 1.46-.41 3.62-.56 6.38v79.09c.16 8.83.35 17.76.56 26.51.21-8.76.4-17.71.56-26.54v-79.07zM750 748.17c-.16.06-.34.13-.56.21v14.01c.21.01.39.01.55.02h.02c.15 0 .34-.01.55-.01v-14.02c-.22-.08-.4-.15-.56-.21z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyParts",
	            d: "M750.56 609.14c.8 14.64.61 46.08 0 79.07v48.17c.09 3.41.19 6.74.29 9.98.09.04.19.07.29.1.15-4.87 1.13-38.47 1.63-71.94.86-57.15-.22-70.59-1.28-74.06-.45.12-.74.22-.93.32v8.36zm0-8.36c-.02 0-.04.01-.06.02-.18.33-.35.99-.5 1.97.22 1.46.41 3.62.56 6.37v-8.36zm-1.12 147.16v.44c.22-.08.4-.15.56-.21-.3-.12-.48-.2-.53-.22l-.03-.01zm.56-33.19c.17 7.4.36 14.67.56 21.63v-48.17c-.16 8.83-.35 17.78-.56 26.54zm-.56-116.1v.45c.15-.09.34-.17.56-.25-.17-.07-.35-.13-.56-.2z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyLines",
	            d: "M749.44 609.15v-8.37c-.19-.1-.48-.2-.93-.32-1.07 3.47-2.15 16.91-1.29 74.06.51 33.5 1.49 67.12 1.63 71.95.1-.04.2-.07.29-.11.1-3.36.2-6.81.3-10.35v-47.77c-.61-32.99-.8-64.44 0-79.09z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyLines",
	            d: "M748.85 746.47c.01.36.02.56.02.59l.02.63.55.25v-11.93c-.1 3.54-.2 6.99-.3 10.35-.09.04-.19.07-.29.11zm.59-147.37a.3.3 0 0 0-.08.04c-.25.15-.55.33-.85 1.32.45.12.74.22.93.32v-1.68zm47.18 10.05c-.44-3.38-1.97-6.48-4.46-8.9-2.88-2.79-6.63-4.31-10.61-4.31-.21 0-.42 0-.63.01-16.41.68-26.6 1.58-30.36 2.7v.45a.3.3 0 0 1 .08.04c.25.15.55.33.85 1.32.97-.26 2.68-.58 5.65-.93 4.47-.51 11.81-1.09 23.86-1.58 3.66-.14 7.14 1.18 9.77 3.74 2.62 2.55 4.04 5.97 4 9.63-.1 7.7-.51 18.68-1.86 27.26-2.62 16.55-10.57 42.21-14.91 52.6-1.91 4.6-4.74 14.69-7.73 25.37-3.49 12.46-7.84 27.95-9.66 29.78-2.19 2.19-6.98 1.06-9.47.13-.01.37-.02.57-.02.6l-.02.63-.54.25v.44c1.35.49 3.78 1.21 6.22 1.21 1.92 0 3.85-.45 5.25-1.85 2.04-2.04 5.2-12.94 10.16-30.65 2.98-10.62 5.79-20.65 7.66-25.14 4.47-10.74 12.36-36.11 15.03-53.05 1.38-8.7 1.78-19.79 1.89-27.55l-.4-1.89.25-.31zm-46.09 138.8-.53.22c.16.06.34.13.56.21v-.44l-.03.01zm.03-148.85v-.45c-.21.07-.4.13-.56.2.22.08.41.16.56.25zm-.56 3.67c-.15-.97-.32-1.64-.5-1.97-.02-.01-.04-.02-.06-.02v8.37c.15-2.76.34-4.92.56-6.38zm-.56 133.24c.19-6.85.38-13.99.56-21.26-.21-8.75-.4-17.68-.56-26.51v47.77z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyLines",
	            d: "M750.56 736.38v11.56l.54-.25.02-.63c0-.03.01-.23.02-.6-.1-.03-.2-.06-.29-.1-.1-3.24-.2-6.57-.29-9.98zm.93-135.92c-.3-.99-.6-1.17-.85-1.32a.3.3 0 0 0-.08-.04v1.68c.19-.1.48-.2.93-.32zm-.93 147.48v-11.56c-.2-6.96-.39-14.23-.56-21.63-.18 7.27-.37 14.41-.56 21.26v11.93l.03.01c.05.02.23.1.53.22l.53-.22.03-.01zm-1.12-148.84v1.68c.02 0 .04.01.06.02.18.33.35 1 .5 1.97.15-.98.32-1.64.5-1.97.02-.01.04-.02.06-.02v-1.68c-.15-.09-.34-.17-.56-.25-.22.08-.41.16-.56.25z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyLines",
	            d: "m796.37 609.46.4 1.89c.01-.74-.05-1.48-.15-2.2l-.25.31z"
	          }),
	          this.props.bodyTitle === "Lower Abdomen" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "655",
	              width: "290",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M794.206 675.376h300" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1119.95 688.05v-25.559h5.203v21.217h12.937v4.342h-18.14Zm20.67-9.598c0-1.64.404-3.228 1.213-4.763.808-1.535 1.954-2.707 3.436-3.516 1.483-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.952 0 2.825-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.774-2.734-1.907-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.062.264c0 1.852.44 3.27 1.319 4.254.878.984 1.962 1.477 3.251 1.477 1.29 0 2.371-.493 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.251 1.476-.879.985-1.319 2.403-1.319 4.254Zm21.558 9.334-5.906-18.668h4.799l3.498 12.234 3.216-12.234h4.764l3.111 12.234 3.569-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Zm35.33-5.941 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.843-1.846-6.433 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.433 2.604 1.195 3.419.762.814 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.102 1.195-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.671 1.177-.704.785-1.049 1.852-1.038 3.199h7.383Zm13.659 10.934h-4.939v-18.668h4.588v2.654c.785-1.253 1.491-2.08 2.118-2.478.627-.399 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.53 4.307c-.832-.54-1.605-.809-2.32-.809-.691 0-1.277.19-1.758.571-.48.381-.858 1.07-1.133 2.066-.276.996-.414 3.082-.414 6.257v5.766Zm41.22 0h-5.66l-2.25-5.853h-10.301l-2.127 5.853h-5.519l10.037-25.769h5.502l10.318 25.769Zm-9.58-10.195-3.551-9.563-3.48 9.563h7.031Zm12.09 10.195v-25.769h4.939v9.281c1.524-1.735 3.328-2.602 5.414-2.602 2.274 0 4.155.823 5.643 2.47 1.488 1.646 2.232 4.011 2.232 7.093 0 3.187-.758 5.642-2.276 7.365-1.518 1.723-3.36 2.584-5.528 2.584-1.067 0-2.119-.267-3.156-.8s-1.93-1.321-2.68-2.364v2.742h-4.588Zm4.904-9.738c0 1.933.305 3.363.914 4.289.856 1.312 1.992 1.969 3.41 1.969 1.09 0 2.019-.466 2.786-1.398.768-.931 1.152-2.399 1.152-4.403 0-2.133-.387-3.671-1.16-4.614-.774-.944-1.764-1.415-2.971-1.415-1.184 0-2.168.459-2.953 1.379-.785.92-1.178 2.318-1.178 4.193Zm34.416 9.738h-4.588v-2.742c-.762 1.066-1.661 1.86-2.698 2.382-1.037.521-2.083.782-3.138.782-2.144 0-3.981-.864-5.51-2.593-1.53-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.57 2.232-7.216 1.488-1.647 3.369-2.47 5.643-2.47 2.086 0 3.89.867 5.414 2.602v-9.281h4.939v25.769Zm-13.184-9.738c0 1.992.276 3.433.827 4.324.797 1.289 1.91 1.934 3.34 1.934 1.136 0 2.103-.484 2.9-1.451.797-.966 1.195-2.411 1.195-4.333 0-2.144-.387-3.688-1.16-4.631-.773-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.465-2.944 1.397-.791.932-1.187 2.323-1.187 4.175Zm16.914.14c0-1.64.404-3.228 1.213-4.763.808-1.535 1.954-2.707 3.436-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.952 0 2.825-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.774-2.734-1.907-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.062.264c0 1.852.44 3.27 1.319 4.254.878.984 1.962 1.477 3.251 1.477 1.29 0 2.371-.493 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.251 1.476-.879.985-1.319 2.403-1.319 4.254Zm17.698-9.334h4.553v2.549c1.629-1.981 3.568-2.971 5.818-2.971 1.196 0 2.233.246 3.112.739.879.492 1.599 1.236 2.162 2.232.82-.996 1.705-1.74 2.654-2.232a6.503 6.503 0 0 1 3.041-.739c1.371 0 2.531.279 3.481.835.949.557 1.658 1.374 2.127 2.452.339.797.509 2.086.509 3.868v11.935h-4.939v-10.67c0-1.851-.17-3.047-.51-3.586-.457-.703-1.16-1.054-2.109-1.054-.692 0-1.342.21-1.951.632-.61.422-1.049 1.04-1.319 1.855-.269.814-.404 2.1-.404 3.858v8.965h-4.94v-10.23c0-1.817-.087-2.989-.263-3.516-.176-.527-.448-.92-.818-1.178-.369-.258-.87-.386-1.503-.386a3.6 3.6 0 0 0-2.056.615c-.61.41-1.046 1.002-1.31 1.775-.263.774-.395 2.057-.395 3.85v9.07h-4.94v-18.668Zm43.19 12.727 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.843-1.846-6.433 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.035 1.465.434 2.604 1.196 3.419.761.814 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.704-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.177-.703.785-1.049 1.852-1.037 3.199h7.383Zm25.909 10.934h-4.939v-9.527c0-2.016-.106-3.32-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.544 3.544 0 0 0-1.397 1.863c-.252.773-.378 2.203-.378 4.289v8.455h-4.939v-18.668h4.587v2.742c1.629-2.109 3.68-3.164 6.153-3.164 1.09 0 2.086.197 2.988.589.902.393 1.585.894 2.048 1.503.463.609.785 1.301.967 2.074.181.774.272 1.881.272 3.323v11.601Z"
	              })
	            )
	          ) : ""
	        )
	      );
	      var NewFemaleBodySVGReactElement = _react2.default.createElement(
	        "svg",
	        {
	          xmlns: "http://www.w3.org/2000/svg",
	          className: "humanBodyImg",
	          viewBox: "120 0 1300 1500",
	          xmlSpace: "preserve"
	        },
	        _react2.default.createElement(
	          "style",
	          null,
	          ".bodyParts{\
	            fill:#14b795;\
	            cursor: pointer;\
	          }\
	          .bodyLines{\
	            fill:#f2f2f2;\
	          }\
	          .syzst2{\
	            fill:none;\
	          }\
	          .labelGroup {\
	            pointer-events: none;\
	          }\
	          .labelLine {\
	            fill: none;\
	            stroke: #b3b3b3;\
	            stroke-width: 2;\
	          }\
	          .labelText {\
	            fill: #14b795;\
	            fill-rule: nonzero;\
	            transform: translateX(10px);\
	            transition: all 0.3s ease;\
	          }\
	          .labelGroup.is_right .labelText {\
	            transform: translateX(-10px);\
	          }\
	          .labelArea {\
	            fill: transparent;\
	            cursor: pointer;\
	          }\
	          .bodyParts_group:hover .bodyParts {\
	            fill: #FE5722;\
	          }\
	          .bodyParts_group:hover .labelGroup .labelText {\
	            fill: #FE5722;\
	            transform: translateX(0px);\
	          }\
	          .body_parts_active .bodyParts {\
	            fill: #FE5722;\
	          }\
	          .body_parts_active .labelGroup .labelText {\
	            fill: #FE5722;\
	            transform: translateX(0px);\
	          }\
	        "
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Head" ? "bodyParts_group Head body_parts_active" : "bodyParts_group Head"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Head");
	            },
	            className: "bodyParts",
	            d: "M718.36 270.3a21.711 21.711 0 0 0 .62.48c.17.13.36.28.56.43.15.12.31.24.48.37.01.01.03.02.04.03h.01l.89.69c.09.07.18.14.28.22 1.16.9 2.55 1.98 4.05 3.13.04.03.08.06.12.1.46.35.93.72 1.41 1.08.06.04.11.09.17.13 1.6 1.22 3.28 2.5 4.94 3.74.96.72 1.9 1.42 2.83 2.1.4.29.8.58 1.18.87.21.16.42.3.63.45a21.053 21.053 0 0 0 1.78 1.21c.14.09.28.17.42.25.3.18.6.34.91.5.16.09.32.18.49.26.38.19.76.36 1.15.52.28.12.56.23.85.33.13.05.27.1.4.15 1.07.38 2.16.67 3.28.88.19.04.38.08.57.11.21.03.42.05.64.08.33.04.65.09.98.12.35.03.71.04 1.06.06.24.01.49.03.73.03h3.02a17.493 17.493 0 0 0 7.92-1.91c.81-.42 1.6-.9 2.34-1.45.31-.23.64-.47.97-.71.27-.2.55-.4.83-.61.01-.01.03-.02.04-.03.86-.63 1.76-1.3 2.7-1.99 1.52-1.12 3.1-2.3 4.66-3.45 0 0 .01 0 .01-.01 1.02-.76 2.04-1.51 3.01-2.24.02-.02.05-.04.07-.05.47-.35.94-.7 1.39-1.04.02-.01.03-.02.05-.04.43-.32.84-.63 1.25-.93.05-.04.1-.08.15-.11.4-.3.79-.59 1.16-.87a67.464 67.464 0 0 1 .8-.6c.06-.04.12-.09.17-.13.23-.17.45-.34.65-.49.03-.02.06-.05.09-.07.43-.32.81-.61 1.14-.86.33-.25.63-.48.85-.65 6.49-5.01 11.86-11.38 15.38-18.78.51-1.07.96-2.11 1.34-3.1 6.07-15.91 1.22-71.74-2.6-86.7-3.3-12.93-13-32.08-43.78-34.25 0 0-.84-.09-2.33-.1-1.62-.38-3.02.1-3.02.1-30.78 2.17-40.48 21.32-43.78 34.25-3.82 14.96-8.66 70.79-2.59 86.7.39 1.04.87 2.13 1.41 3.26 3.37 7.01 8.39 13.09 14.46 17.94.28.19.52.41.77.6z"
	          }),
	          this.state.bodyTitle === "Head" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "175",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M794.206 194.654h300" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1120.04 207.328v-25.769h5.203v10.142h10.195v-10.142h5.203v25.769h-5.203v-11.267h-10.195v11.267h-5.203Zm36.76-5.941 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.182-1.23-1.699-1.845-3.843-1.845-6.433 0-3.094.808-5.517 2.425-7.269 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.814 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm12.619-2.039-4.482-.809c.503-1.805 1.371-3.141 2.601-4.008 1.231-.867 3.059-1.301 5.484-1.301 2.204 0 3.844.261 4.922.783 1.078.521 1.837 1.183 2.277 1.986.439.803.659 2.276.659 4.421l-.053 5.765c0 1.641.079 2.851.237 3.63.159.78.455 1.615.888 2.505h-4.887a18.301 18.301 0 0 1-.474-1.459 8.953 8.953 0 0 0-.176-.58c-.844.82-1.746 1.436-2.707 1.846a7.755 7.755 0 0 1-3.076.615c-1.922 0-3.437-.521-4.544-1.564-1.108-1.043-1.661-2.362-1.661-3.955 0-1.055.252-1.996.756-2.822.504-.826 1.21-1.459 2.118-1.898.908-.44 2.218-.823 3.929-1.152 2.308-.433 3.908-.837 4.798-1.212v-.493c0-.949-.234-1.626-.703-2.03-.469-.404-1.353-.606-2.654-.606-.879 0-1.565.172-2.057.518-.492.346-.89.952-1.195 1.82Zm6.609 4.007c-.632.211-1.634.463-3.006.756-1.371.293-2.267.58-2.689.862-.645.457-.967 1.037-.967 1.74 0 .691.258 1.289.774 1.793.515.504 1.172.756 1.968.756.891 0 1.741-.293 2.549-.879.598-.446.99-.991 1.178-1.635.129-.422.193-1.225.193-2.408v-.985Zm26.841 8.965h-4.588v-2.742c-.761 1.066-1.661 1.86-2.698 2.382-1.037.521-2.083.782-3.138.782-2.144 0-3.981-.864-5.51-2.593-1.53-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.232-7.216 1.488-1.646 3.369-2.47 5.643-2.47 2.086 0 3.89.868 5.414 2.602v-9.281h4.939v25.769Zm-13.183-9.738c0 1.992.275 3.433.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.136 0 2.103-.484 2.9-1.45.797-.967 1.195-2.412 1.195-4.333 0-2.145-.386-3.689-1.16-4.632-.773-.944-1.764-1.415-2.971-1.415-1.171 0-2.153.465-2.944 1.397-.791.932-1.186 2.323-1.186 4.175Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Neck" ? "bodyParts_group Neck body_parts_active" : "bodyParts_group Neck"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "syzst2",
	            d: "M764.93 283.93c.01 0 .01-.01.02-.01-.01.01-.03.02-.04.03 0-.01.01-.01.02-.02zm-15.84 4.67c.12 0 .23.02.35.02.12.01.23.01.35.01h.03c-.25 0-.49-.02-.73-.03zm31.29-16.14c-.06.04-.11.09-.17.13.05-.05.11-.09.17-.13zm-37.81 14.89c-.13-.05-.27-.1-.4-.15.13.05.26.1.4.15zm-1.25-.48zm35.52-11.77c-.02.01-.03.02-.05.04.02-.01.04-.02.05-.04zm-37.17 10.99c-.31-.16-.61-.33-.91-.5.3.17.61.34.91.5zm38.57-12.03c-.05.04-.1.07-.15.11.05-.03.1-.07.15-.11zm-2.84 2.12c-.02.02-.05.04-.07.05.02-.02.05-.03.07-.05zm4.06-3.04.02-.02c-.03.02-.06.04-.08.06.02 0 .05-.02.06-.04zm-7.14 5.33c-.01 0-.01 0 0 0-.01 0-.01 0 0 0zm-52.31-6.89c-.16-.13-.33-.25-.48-.37.15.12.31.24.48.37zm-1.04-.8a.55.55 0 0 1-.09-.07c.04.02.07.04.09.07zm2.25 1.74c-.1-.07-.19-.14-.28-.22.1.08.18.14.28.22zm39.54 14.2c.81-.42 1.6-.9 2.34-1.45.31-.23.64-.47.97-.71-.33.24-.66.49-.97.71-.74.55-1.53 1.03-2.34 1.45zm-33.78-9.76c-.06-.04-.11-.09-.17-.13.05.05.11.09.17.13zm9.58 7.17-.63-.45.63.45zm-11.16-8.38c-.04-.03-.08-.06-.12-.1.03.04.08.07.12.1zm12.94 9.59c-.43-.26-.85-.54-1.26-.83.41.29.83.56 1.26.83zm42.79-13.44c-.03.02-.06.05-.09.07.03-.03.05-.05.09-.07z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "M666.75 332.26c9.55 2.6 27.57 9.57 28.04 9.76 11.91-.5 23.89 1.67 31.1 4.75 13.94 5.96 18.14 15.53 22.55 28.4.37 1.09.71 2.47 1.01 4.07v-88.62c-4.61-.06-9.03-1.52-12.8-4.21-.36-.26-.72-.52-1.1-.79 1.51 5.65 2.83 12.57 3.67 16.91.18.94.33 1.73.45 2.33.34 1.69 1.83 6.59 3.4 11.76 3.18 10.45 5.42 18.01 5.42 20.13 0 1.58-.68 2.31-1.25 2.65-.44.26-.93.35-1.41.35-1.25 0-2.48-.64-2.79-.81l-.26-.14-.14-.26c-.07-.13-7.08-13.28-9.7-18.51-.77-1.55-1.69-4.32-2.64-7.67-3.94 3.87-15.34 15.04-18.32 17.27-2.3 1.72-6.56 3.06-9.74 3.88-.29.08-.59.11-.88.11-.75 0-1.47-.24-2.09-.7a3.495 3.495 0 0 1-1.4-2.68c-.13-3.6-.17-7.88.46-10.74-3.21.72-8.12.96-13.29.96-7.03 0-14.53-.45-18.85-.75-6.2 1.91-11.72 3.47-15.13 4.26-1.25.29-2.55.63-3.88 1.03 2.47.76 5.29 1.91 8.3 3.14 3.77 1.55 7.66 3.14 11.27 4.12z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "M698.29 317.47c5.32-1.33 10.38-10.37 13.49-17.15-2.73 2.36-5.98 4.21-8.76 6.05-3.27 2.18-17.98 7.4-31.45 11.68 8.56.47 21.06.84 26.72-.58z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "m700.5 318.76.12.05c-1.05 2.62-.83 8.98-.75 11.37.02.46.23.88.6 1.15.37.27.83.36 1.27.25 4.24-1.1 7.45-2.36 9.04-3.55 3.07-2.3 16.12-15.13 18.91-17.87-2.01-7.44-4.09-16.83-5.33-22.41l-.31-1.4c-.95-4.3-3.65-9.85-5.85-13.92 0 0-.01 0-.01-.01-.17-.13-.33-.26-.49-.39.27 7.44.35 16.44-.6 20.26-.09.35-.19.69-.3 1.02l.02.01c-.31.9-7.44 21.01-16.32 25.44zm25.82-31.45c1.94 8.74 5.97 26.94 8.41 31.82 2.39 4.79 8.49 16.25 9.52 18.19.65.31 1.6.57 1.96.35.24-.14.26-.69.26-.92 0-1.98-3.08-12.13-5.34-19.55-1.66-5.45-3.09-10.17-3.45-11.95-.12-.6-.27-1.4-.46-2.35-.89-4.63-2.55-13.29-4.33-19.22-3.81-2.83-7.89-5.98-10.92-8.31 0-.01-.01-.01-.01-.01 1.69 3.45 3.31 7.3 4.03 10.55l.33 1.4z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M732.92 283.69c0-.01 0-.01 0 0 1.77 5.93 3.43 14.58 4.32 19.22.18.95.33 1.74.46 2.35.36 1.79 1.79 6.5 3.45 11.95 2.25 7.41 5.34 17.57 5.34 19.55 0 .23-.03.78-.26.92-.37.22-1.31-.05-1.96-.35-1.03-1.93-7.13-13.4-9.52-18.19-2.44-4.88-6.47-23.08-8.41-31.82l-.31-1.4c-.72-3.25-2.34-7.1-4.03-10.55-.69-.54-1.32-1.03-1.88-1.47l-1.81-1.4c-.03-.02-.05-.04-.08-.06 2.2 4.07 4.89 9.62 5.85 13.92l.31 1.4c1.24 5.58 3.32 14.97 5.33 22.41.32-.32.51-.51.53-.52l1.41 1.42c-.1.1-.58.58-1.33 1.31.95 3.35 1.87 6.12 2.64 7.67 2.62 5.23 9.63 18.38 9.7 18.51l.14.26.26.14c.31.17 1.54.81 2.79.81.49 0 .97-.1 1.41-.35.57-.34 1.25-1.07 1.25-2.65 0-2.11-2.25-9.68-5.42-20.13-1.57-5.18-3.06-10.07-3.4-11.76-.12-.6-.27-1.39-.45-2.33-.83-4.34-2.16-11.26-3.67-16.91-.88-.64-1.76-1.29-2.66-1.95z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M710.79 328.02c-1.59 1.19-4.8 2.45-9.04 3.55-.44.12-.91.02-1.27-.25s-.58-.69-.6-1.15c-.08-2.39-.3-8.74.75-11.37l-.12-.05c-.57.28-1.15.5-1.72.65-.14.03-.28.07-.43.1-.63 2.86-.59 7.14-.46 10.74.04 1.07.55 2.04 1.4 2.68.61.46 1.34.7 2.09.7.29 0 .59-.04.88-.11 3.18-.82 7.44-2.16 9.74-3.88 2.97-2.23 14.38-13.39 18.32-17.27-.2-.71-.41-1.45-.61-2.21-2.81 2.75-15.86 15.57-18.93 17.87z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M730.22 309.63c-.02.02-.21.21-.53.52.2.76.41 1.49.61 2.21.74-.73 1.22-1.21 1.33-1.31l-1.41-1.42zm-64 24.56c6.78 1.85 17.93 5.94 23.86 8.18 1.56-.17 3.12-.28 4.7-.35-.47-.18-18.49-7.15-28.04-9.76-3.61-.98-7.49-2.57-11.25-4.11-3.01-1.23-5.83-2.38-8.3-3.14-1.18.35-2.38.74-3.6 1.19 2.87.42 7.05 2.13 11.14 3.8 3.82 1.56 7.76 3.17 11.49 4.19zm32.12-14.68c.12-.53.26-1.02.42-1.44l1.73.69h.01c8.88-4.43 16.01-24.54 16.33-25.44l-.02-.01c-.96 2.85-2.82 5.1-5.03 7.01-3.11 6.78-8.17 15.82-13.49 17.15-5.66 1.42-18.16 1.05-26.72.58h-.02c-1.81.58-3.61 1.14-5.35 1.67 4.32.3 11.82.75 18.85.75 5.17 0 10.08-.24 13.29-.96z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M698.77 319.41c.58-.15 1.16-.37 1.72-.65l-1.73-.69c-.17.42-.31.91-.42 1.44.15-.03.29-.07.43-.1z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "M801.66 319.51c.72 3.29.55 8.38.46 10.74a3.495 3.495 0 0 1-1.4 2.68c-.61.46-1.34.7-2.09.7-.29 0-.59-.04-.88-.11-3.17-.82-7.44-2.16-9.74-3.88-2.98-2.23-14.38-13.39-18.32-17.27-.95 3.35-1.86 6.12-2.64 7.67-2.62 5.23-9.63 18.38-9.7 18.51l-.14.26-.26.14c-.31.17-1.54.81-2.79.81-.49 0-.97-.1-1.41-.35-.57-.34-1.25-1.07-1.25-2.65 0-2.12 2.25-9.68 5.43-20.14 1.57-5.18 3.06-10.06 3.4-11.76.12-.6.27-1.39.45-2.33.79-4.13 2.03-10.59 3.45-16.08h-.01c-.33.25-.65.48-.96.71-3.1 2.27-6.78 3.47-10.63 3.47h-2.08v88.61c.3-1.6.64-2.98 1.01-4.07 4.41-12.87 8.6-22.44 22.55-28.4 7.21-3.09 19.19-5.25 31.1-4.75.73-.28 18.56-7.17 28.03-9.76 3.61-.98 7.5-2.57 11.25-4.11 3.01-1.23 5.83-2.39 8.3-3.14-1.34-.4-2.63-.74-3.88-1.03-3.41-.79-8.92-2.35-15.12-4.26h-.01c-4.32.3-11.82.75-18.84.75-5.16 0-10.07-.24-13.28-.96z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "m775.94 286.34-.31 1.4c-1.24 5.58-3.32 14.97-5.33 22.41 2.79 2.75 15.83 15.57 18.91 17.87 1.59 1.19 4.8 2.45 9.04 3.55.45.12.91.02 1.27-.25s.58-.69.6-1.15c.08-2.39.3-8.75-.75-11.37l.12-.05c-8.88-4.42-16.01-24.54-16.33-25.44h.01v-.01c-.11-.33-.21-.67-.3-1.02-.91-3.65-.87-12.02-.63-19.25-.22.17-.45.36-.71.54-2.14 3.7-4.67 8.65-5.59 12.77zm-13.64 18.91c-.36 1.79-1.79 6.49-3.44 11.94-2.25 7.42-5.34 17.57-5.34 19.56 0 .23.03.78.26.92.37.22 1.31-.05 1.96-.35 1.03-1.93 7.13-13.4 9.53-18.19 2.44-4.88 6.47-23.08 8.41-31.82l.31-1.4c.67-3.01 2.11-6.37 3.66-9.41-3.24 2.42-7.31 5.44-10.81 8.04-1.68 5.88-3.23 13.95-4.08 18.36-.18.95-.34 1.75-.46 2.35z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "M801.71 317.47c5.66 1.42 18.16 1.05 26.72.58-13.46-4.28-28.18-9.5-31.45-11.68-2.78-1.85-6.05-3.7-8.78-6.07 3.12 6.79 8.18 15.84 13.51 17.17zm-51.15 61.77v-88.61h-.77c-.12 0-.23 0-.35-.01v88.62c.21 1.08.39 2.27.56 3.55.17-1.28.35-2.47.56-3.55z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M760.34 304.86c-.34 1.69-1.82 6.58-3.4 11.76-3.18 10.46-5.43 18.02-5.43 20.14 0 1.58.68 2.31 1.25 2.65.44.26.93.35 1.41.35 1.25 0 2.48-.64 2.79-.81l.26-.14.14-.26c.07-.13 7.08-13.28 9.7-18.51.77-1.55 1.69-4.32 2.64-7.67-.74-.73-1.22-1.21-1.33-1.31l1.41-1.42c.02.02.21.21.53.52 2.01-7.44 4.09-16.83 5.33-22.41l.31-1.4c.91-4.12 3.45-9.06 5.59-12.77h-.01l-.01.01c-1.01.77-2.35 1.77-3.87 2.91-1.55 3.04-2.99 6.4-3.66 9.41l-.31 1.4c-1.94 8.74-5.97 26.94-8.41 31.82-2.39 4.79-8.5 16.25-9.53 18.19-.66.31-1.6.57-1.96.35-.24-.14-.26-.69-.26-.92 0-1.98 3.09-12.14 5.34-19.56 1.66-5.45 3.09-10.16 3.44-11.94.12-.6.27-1.4.46-2.35.85-4.42 2.4-12.48 4.08-18.36h-.01l-2.59 1.91c-1.42 5.49-2.66 11.95-3.45 16.08-.18.93-.33 1.73-.45 2.33z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M788.01 329.62c2.3 1.72 6.57 3.06 9.74 3.88a3.503 3.503 0 0 0 4.37-3.27c.08-2.36.26-7.45-.46-10.74-.15-.03-.3-.06-.44-.1-.58-.15-1.15-.36-1.72-.65l-.12.05c1.05 2.62.83 8.97.75 11.37-.02.46-.23.88-.6 1.15-.37.27-.83.36-1.27.25-4.24-1.09-7.45-2.35-9.04-3.55-3.07-2.3-16.12-15.13-18.91-17.87-.2.76-.41 1.49-.61 2.21 3.93 3.88 15.34 15.04 18.31 17.27z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M768.37 311.05c.1.1.58.58 1.33 1.31.2-.71.41-1.45.61-2.21-.32-.32-.51-.51-.53-.52l-1.41 1.42zm31.13 7.71 1.74-.69c.17.42.3.91.42 1.44 3.21.72 8.12.96 13.29.96 7.02 0 14.52-.45 18.84-.75-1.74-.53-3.54-1.09-5.35-1.67h-.01c-8.56.47-21.06.84-26.72-.58-5.33-1.33-10.39-10.38-13.51-17.17-2.2-1.91-4.05-4.14-5.02-6.98h-.01c.32.9 7.45 21.02 16.33 25.44z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyLines",
	            d: "M801.66 319.51c-.12-.53-.25-1.02-.42-1.44l-1.73.69c.57.29 1.14.5 1.72.65.13.04.28.07.43.1z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            d: "M718.21 272.42c.03.02.05.05.08.06l1.81 1.4c.56.44 1.19.93 1.88 1.47 0 0 .01 0 .01.01 3.03 2.34 7.11 5.49 10.92 8.31l.01.01c.9.66 1.78 1.31 2.62 1.93.38.27.74.53 1.1.79 3.77 2.69 8.19 4.15 12.8 4.21.12.01.23.01.35.01h2.85c3.85 0 7.53-1.2 10.63-3.47.31-.23.63-.46.96-.71h.01l2.59-1.91h.01c3.5-2.6 7.57-5.62 10.81-8.04 1.52-1.14 2.86-2.14 3.87-2.91l.01-.01h.01c.27-.18.5-.37.71-.54 0-.24.01-.47.02-.71.01-.19.01-.38.02-.57l.03-.77c-.02.01-.04.03-.06.04-.33.25-.72.54-1.14.86-.03.02-.06.05-.09.07-.21.16-.43.32-.65.49-.06.04-.11.09-.17.13-.23.18-.47.35-.72.54l-.02.02c-.02.01-.04.03-.06.05-.37.28-.76.57-1.16.87-.05.04-.1.07-.15.11-.4.3-.82.61-1.25.93-.02.01-.03.02-.05.04-.45.34-.92.68-1.39 1.04-.02.02-.05.04-.07.05l-3.01 2.24s-.01 0-.01.01c-2.53 1.88-5.11 3.79-7.37 5.44-.01 0-.01.01-.02.01l-.02.02c-.28.21-.56.41-.83.61-.33.25-.66.49-.97.71a17.168 17.168 0 0 1-7.52 3.14c-.9.14-1.82.22-2.74.22h-3.05c-.12 0-.23 0-.35-.01-.12 0-.23-.01-.35-.02-2.24-.09-4.43-.51-6.52-1.25-.13-.05-.27-.1-.4-.15-.28-.11-.57-.21-.85-.33-.39-.16-.77-.34-1.15-.52-.16-.08-.33-.17-.49-.26-.31-.16-.61-.33-.91-.5-.14-.08-.28-.17-.42-.25a21.053 21.053 0 0 1-1.78-1.21l-.63-.45c-2.83-2.05-6.02-4.47-8.95-6.71-.06-.04-.11-.09-.17-.13-.48-.37-.95-.73-1.41-1.08-.04-.03-.08-.06-.12-.1-1.51-1.16-2.89-2.23-4.05-3.13-.1-.08-.18-.14-.28-.22-.33-.26-.64-.5-.93-.73-.16-.13-.32-.25-.48-.37-.2-.15-.39-.3-.56-.43a.55.55 0 0 1-.09-.07c-.2-.15-.38-.29-.53-.41-.25-.19-.49-.41-.74-.6.01.33.03.67.04 1.01l.03.76v.01c0 .18.01.36.02.55.14.14.3.27.48.4-.01 0 0 0 0 0z",
	            fill: "#ebebeb"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Neck");
	            },
	            className: "bodyParts",
	            d: "M764.9 283.95c-.28.21-.56.41-.83.61.27-.2.55-.4.83-.61zm10.43-7.72-3.01 2.24 3.01-2.24zm-14.57 10.49zm16.03-11.58c-.45.34-.92.68-1.39 1.04.48-.36.94-.7 1.39-1.04zm-36.63 11.21c-.16-.08-.33-.17-.49-.26.17.09.33.17.49.26zm-1.39-.76c-.14-.08-.28-.17-.42-.25.13.08.27.17.42.25zm3.39 1.61c-.28-.11-.57-.22-.85-.33.29.12.57.23.85.33zm35.93-13.03c-.4.3-.82.61-1.25.93.43-.32.85-.63 1.25-.93zm4.18-3.14c-.33.25-.72.54-1.14.86.42-.32.81-.61 1.14-.86zm-1.24.94c-.21.16-.43.32-.65.49.22-.17.44-.34.65-.49zm-.82.62c-.23.17-.47.35-.72.54.25-.19.48-.37.72-.54zm-.81.6c-.37.28-.76.57-1.16.87.4-.3.79-.59 1.16-.87zm-42.84 10.94c.17.13.35.26.52.38-.17-.13-.35-.26-.52-.38zm13.26 4.5h.11-.11zm-2.77-.2c-.21-.03-.42-.05-.64-.08-.19-.03-.38-.08-.57-.11-1.11-.21-2.21-.51-3.28-.88 2.09.74 4.29 1.16 6.52 1.25-.35-.01-.71-.03-1.06-.06-.32-.03-.65-.08-.97-.12zm17.89-4.51c2.25-1.66 4.84-3.57 7.37-5.44-1.56 1.16-3.15 2.33-4.66 3.45-.94.69-1.85 1.36-2.71 1.99zm-38.13-7.09c-.48-.37-.95-.73-1.41-1.08.46.35.93.72 1.41 1.08zm-7.28-5.62c-.2-.16-.39-.3-.56-.43.17.13.36.28.56.43zm-.64-.5c-.2-.15-.38-.29-.53-.41-.25-.19-.49-.41-.74-.6.25.2.49.41.74.6.15.12.33.26.53.41zm6.38 4.94c-1.5-1.16-2.89-2.23-4.05-3.13 1.17.9 2.55 1.98 4.05 3.13zm6.65 5.06s-.01 0 0 0a630.11 630.11 0 0 1-4.94-3.75c2.93 2.24 6.12 4.66 8.95 6.71-.39-.28-.78-.57-1.18-.87-.93-.67-1.88-1.37-2.83-2.09zm-11.87-9.1c-.01-.01-.03-.02-.04-.03.29.23.6.47.93.73-.31-.25-.61-.48-.89-.7z"
	          }),
	          this.state.bodyTitle === "Neck" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "282",
	              width: "100",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M784.206 302.225h310" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1120.08 314.899V289.13h5.062l10.547 17.209V289.13h4.834v25.769h-5.22l-10.389-16.804v16.804h-4.834Zm36.72-5.941 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.269 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm25.209-2.215-4.869.879c-.164-.973-.536-1.705-1.116-2.197-.581-.493-1.333-.739-2.259-.739-1.231 0-2.212.425-2.945 1.275-.732.849-1.098 2.27-1.098 4.262 0 2.215.372 3.78 1.116 4.694.744.914 1.743 1.371 2.997 1.371.938 0 1.705-.267 2.303-.8.597-.533 1.019-1.45 1.265-2.751l4.852.826c-.504 2.227-1.471 3.908-2.9 5.045-1.43 1.137-3.346 1.705-5.748 1.705-2.731 0-4.908-.861-6.531-2.584-1.623-1.722-2.434-4.107-2.434-7.154 0-3.082.814-5.482 2.443-7.198 1.629-1.717 3.832-2.576 6.609-2.576 2.274 0 4.082.49 5.423 1.468 1.342.979 2.306 2.47 2.892 4.474Zm3.57 13.148V289.13h4.94v13.676l5.783-6.575h6.082l-6.381 6.821 6.838 11.847h-5.326l-4.694-8.384-2.302 2.408v5.976h-4.94Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Right Shoulder" ? "bodyParts_group Right_Shoulder body_parts_active" : "bodyParts_group Right_Shoulder"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyParts",
	            d: "M620.4 449.44c3.87-8.15 7.7-16.02 11.06-22.93 3.85-7.92 6.89-14.17 8.58-17.97 6.92-15.58 13.49-43.76 13.55-44.05l.5.12c.11-.34 2.92-8.53 16.29-16.39 5.58-3.28 12.5-5.1 19.69-5.85h.01c-5.93-2.23-17.08-6.33-23.86-8.18-3.73-1.02-7.67-2.63-11.48-4.19-4.09-1.67-8.27-3.38-11.14-3.8-10.03 3.65-20.9 10.55-25.1 22.44-3.3 9.39-5.23 32.63-5.99 52.34 2.38 7.67 8.36 27.63 8.36 34.31-.01 4.65-.25 10.25-.47 14.15zm0 .01v-.01.01z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "M630.47 536.05c-.07.78-.1 1.18-.11 1.2l1.99.17c0-.02.04-.46.11-1.3-.66.04-1.32.02-1.99-.07zm-12.34-81.9h.05c.74-1.57 1.48-3.14 2.22-4.7v-.01c.22-3.9.46-9.5.46-14.15 0-6.68-5.98-26.64-8.36-34.31-.08 2.12-.15 4.21-.2 6.23 2.72 9.15 6.56 22.98 6.56 28.08 0 7.97-.72 18.75-.73 18.86z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "M620.13 454.28c0-.04.13-1.99.27-4.83-.74 1.56-1.48 3.13-2.22 4.7l1.95.13z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "syzst2",
	            d: "M630.47 536.05c-.07.78-.1 1.18-.11 1.2l1.99.17c0-.02.04-.46.11-1.3-.66.04-1.32.02-1.99-.07z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyParts",
	            d: "M633.25 427.39c-7.63 15.68-18.64 38.33-26.25 56.94l.15-.02c.07.44 6.84 44.11 20.1 50.74 1.08.53 2.15.86 3.22 1 .34-4.04 1.52-18.45 3.44-45.29 2.29-32.14 26.41-107.08 26.66-107.83l.27.09c-2.25-7.44-4.6-13.05-5.83-15.79-1.73 7.09-7.29 29-13.14 42.13-1.71 3.82-4.76 10.09-8.62 18.03z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyParts",
	            d: "M656.53 481.33c-.73-2.07-1.27-4.44-1.61-7.11-.06-.5-.12-1.05-.16-1.62-.19-2.15-.25-4.49-.24-6.71-.03-6.49.37-13.19.4-13.49l1.39 4.12c-.17-.53-.32-1.07-.46-1.6-1.27-4.66-1.6-9.03-1.57-12.48-.08-5.68.59-9.98.66-10.29l.84 3.14c-.82-2.57-1.12-5.5-.86-8.81.34-4.46 1.67-10.6 3.06-17.1 1.77-8.18 3.73-17.26 3.5-22.75v-.01c-4.56 14.46-23.57 76.08-25.58 104.27-1.9 26.64-3.08 41.05-3.43 45.22h.01c7.28-.51 14.13-8.58 17.99-14.09v-.01c2.97-15.17 5.53-28.4 5.89-31.63l.17-9.05zm-38.4-27.18c.01-.11.73-10.89.73-18.86 0-5.1-3.84-18.93-6.56-28.08-.25 9.13-.23 16.98.04 21.55.59 9.99-4.71 37.22-9.09 59.47 4.06-10.37 9.45-22.38 14.93-34.08h-.05z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "m604.17 487.36 1.42-.27c-.24-1.37-.38-2.25-.41-2.48l1.82-.28c7.61-18.61 18.62-41.26 26.25-56.94 3.86-7.94 6.91-14.21 8.61-18.04 5.85-13.13 11.41-35.04 13.14-42.13a49.86 49.86 0 0 0-.86-1.85l-.18-.37.13-.39-.5-.12c-.06.29-6.63 28.47-13.55 44.05-1.69 3.8-4.73 10.05-8.58 17.97-3.36 6.91-7.19 14.78-11.06 22.93v.01c-.14 2.84-.27 4.79-.27 4.83l-1.95-.13c-5.48 11.7-10.87 23.71-14.93 34.08 0 .01 0 .02-.01.03-.91 4.71-1.8 9.21-2.58 13.26 1.06-3.41 2.42-7.25 4.01-11.37 0 0 .01-.01 0-.01-.3-1.72-.48-2.7-.5-2.78z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "M632.48 536.12h-.01c-.07.84-.11 1.28-.11 1.3l-1.99-.17c0-.02.04-.42.1-1.2-1.07-.14-2.14-.47-3.22-1-13.26-6.63-20.03-50.3-20.1-50.74l-.15.02c-.38.91-.74 1.81-1.1 2.7l.24-.04c.16.82 1.21 6.42 2.54 14.82 3.36 13.53 9.17 30.78 17.67 35.03 1.84.92 3.67 1.33 5.47 1.33 6.95 0 13.36-6.05 17.75-11.54.3-1.55.6-3.08.9-4.6-3.86 5.51-10.71 13.58-17.99 14.09z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "m605.59 487.09.31-.05v-.01c.36-.89.72-1.79 1.1-2.7l-1.82.28c.03.23.17 1.11.41 2.48zm28.31 3.66c-1.92 26.84-3.1 41.25-3.44 45.29.67.09 1.33.11 2 .07.35-4.18 1.53-18.58 3.43-45.22 2.01-28.2 21.02-89.81 25.58-104.27-.04-1.06-.17-1.99-.39-2.75-.09-.29-.17-.58-.26-.86l-.27-.09c-.23.75-24.35 75.69-26.65 107.83z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "m605.59 487.09-1.42.27c.02.08.2 1.06.5 2.78.01 0 0 .01 0 .01.33-.84.66-1.69 1-2.55v-.01c-.02-.17-.05-.34-.08-.5zm.32-.06v.01c-.08.19-.15.38-.23.56.56 3.11 1.55 8.31 3.01 14.21-1.33-8.4-2.38-14-2.54-14.82l-.24.04z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "M605.59 487.09c.03.16.06.33.08.5v.01c.08-.18.15-.37.23-.56l-.31.05z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Shoulder");
	            },
	            className: "bodyLines",
	            d: "m605.9 487.04.01-.01h-.01z"
	          }),
	          this.state.bodyTitle === "Right Shoulder" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "105",
	              y: "456",
	              width: "275",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup is_right" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M405 479.666h210" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M125.046 488.982v-25.769h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.183 1.125 2.537 1.125 4.06 0 1.934-.568 3.531-1.705 4.79-1.137 1.26-2.836 2.054-5.097 2.382 1.125.656 2.053 1.377 2.786 2.162.732.785 1.719 2.18 2.962 4.184l3.146 5.027h-6.223l-3.761-5.607c-1.336-2.004-2.25-3.267-2.742-3.788-.493-.522-1.014-.879-1.565-1.072-.551-.194-1.424-.291-2.619-.291h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.055-.105 4.676-.316a2.803 2.803 0 0 0 1.459-1.09c.351-.516.527-1.16.527-1.934 0-.867-.231-1.567-.694-2.1-.463-.533-1.117-.87-1.96-1.011-.422-.059-1.688-.088-3.797-.088h-4.061v6.539Zm20.742-6.328v-4.57h4.94v4.57h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.231 5.643.685c.094.657.31 1.108.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.193 2.901-.58.433-.258.761-.674.984-1.248.152-.41.228-1.166.228-2.268v-2.724c-1.476 2.015-3.339 3.023-5.589 3.023-2.508 0-4.495-1.06-5.959-3.181-1.149-1.676-1.723-3.762-1.723-6.258 0-3.129.753-5.52 2.259-7.172 1.506-1.652 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.94-.363 1.09-.873 1.945-1.529 2.566-.657.621-1.533 1.108-2.628 1.459-1.096.352-2.482.527-4.157.527-3.165 0-5.409-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.597Zm4.412-10.951c0 1.98.384 3.43 1.152 4.35.767.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.398-3.37-1.195-4.307-.797-.938-1.805-1.406-3.023-1.406-1.184 0-2.16.46-2.927 1.38-.768.92-1.152 2.323-1.152 4.21Zm22.957-16.049v9.474c1.594-1.863 3.499-2.795 5.713-2.795 1.137 0 2.162.211 3.077.633.914.422 1.602.961 2.065 1.617.463.657.779 1.383.949 2.18.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.282-3.727a2.438 2.438 0 0 0-.993-1.256c-.474-.311-1.069-.466-1.784-.466-.82 0-1.553.199-2.197.597-.645.399-1.116.999-1.415 1.802-.299.803-.449 1.989-.449 3.56v9.351h-4.939v-25.769h4.939Zm25.629 7.101v3.938h-3.375v7.523c0 1.524.033 2.411.097 2.663.065.252.211.46.44.624.228.164.506.246.834.246.458 0 1.12-.158 1.987-.474l.422 3.832c-1.149.492-2.45.738-3.903.738-.89 0-1.693-.149-2.408-.448-.715-.299-1.239-.686-1.573-1.16-.334-.475-.566-1.116-.694-1.925-.106-.574-.159-1.734-.159-3.481v-8.138h-2.267v-3.938h2.267v-3.709l4.957-2.882v6.591h3.375Zm12.147 10.284 5.062-.493c.305 1.7.923 2.948 1.855 3.744.932.797 2.188 1.196 3.77 1.196 1.676 0 2.939-.355 3.788-1.064.85-.709 1.275-1.538 1.275-2.487 0-.609-.179-1.128-.536-1.556-.358-.427-.982-.799-1.872-1.116-.61-.211-1.998-.586-4.166-1.125-2.789-.691-4.746-1.541-5.871-2.549-1.582-1.418-2.373-3.146-2.373-5.185 0-1.313.372-2.54 1.116-3.683.744-1.142 1.816-2.013 3.217-2.61 1.4-.598 3.09-.897 5.071-.897 3.234 0 5.669.709 7.304 2.127 1.634 1.418 2.493 3.311 2.575 5.678l-5.203.228c-.223-1.324-.701-2.276-1.433-2.856-.732-.58-1.831-.87-3.296-.87-1.512 0-2.695.31-3.551.932-.55.398-.826.931-.826 1.599 0 .61.258 1.131.774 1.565.656.55 2.25 1.125 4.781 1.722 2.531.598 4.403 1.216 5.616 1.855 1.213.638 2.162 1.512 2.848 2.619.685 1.107 1.028 2.476 1.028 4.104 0 1.477-.41 2.86-1.23 4.149-.821 1.289-1.981 2.247-3.481 2.874-1.5.627-3.369.94-5.607.94-3.258 0-5.76-.753-7.506-2.258-1.746-1.506-2.789-3.701-3.129-6.583Zm30.217-17.385v9.474c1.593-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.657.779 1.383.949 2.18.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.281-3.727a2.445 2.445 0 0 0-.994-1.256c-.474-.311-1.069-.466-1.784-.466-.82 0-1.553.199-2.197.597-.645.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm15.925 16.172c0-1.641.405-3.229 1.213-4.764.809-1.535 1.954-2.707 3.437-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.138.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.953 0 2.824-.911 5.165-2.733 7.022-1.823 1.857-4.117 2.786-6.882 2.786-1.711 0-3.343-.387-4.896-1.16-1.552-.773-2.733-1.907-3.542-3.401-.808-1.495-1.213-3.314-1.213-5.458Zm5.063.263c0 1.852.439 3.27 1.318 4.254.879.985 1.963 1.477 3.252 1.477 1.289 0 2.37-.492 3.243-1.477.873-.984 1.31-2.414 1.31-4.289 0-1.828-.437-3.234-1.31-4.219-.873-.984-1.954-1.476-3.243-1.476s-2.373.492-3.252 1.476c-.879.985-1.318 2.403-1.318 4.254Zm30.357 9.334v-2.795a7.191 7.191 0 0 1-2.68 2.356 7.52 7.52 0 0 1-3.507.861c-1.254 0-2.379-.275-3.375-.826-.996-.551-1.717-1.324-2.162-2.32-.446-.996-.668-2.373-.668-4.131v-11.813h4.939v8.578c0 2.625.091 4.234.273 4.826.181.591.512 1.06.993 1.406.48.346 1.09.518 1.828.518.844 0 1.6-.231 2.268-.694.668-.463 1.125-1.037 1.371-1.723.246-.685.369-2.364.369-5.036v-7.875h4.939v18.668h-4.588Zm9.704-25.769h4.939v25.77h-4.939zm27.123 25.769h-4.588v-2.742c-.762 1.066-1.661 1.86-2.699 2.382-1.037.521-2.083.782-3.137.782-2.145 0-3.982-.864-5.511-2.593-1.529-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.232-7.216 1.489-1.646 3.37-2.47 5.643-2.47 2.086 0 3.891.868 5.414 2.602v-9.281h4.94v25.769Zm-13.184-9.738c0 1.992.275 3.434.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.137 0 2.103-.484 2.9-1.45.797-.967 1.196-2.412 1.196-4.333 0-2.145-.387-3.689-1.16-4.632-.774-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.466-2.945 1.397-.791.932-1.186 2.323-1.186 4.175Zm28.863 3.797 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429H352.56c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.527-.422.926-1.102 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.382Zm13.659 10.933h-4.94v-18.668h4.588v2.655c.785-1.254 1.491-2.08 2.118-2.479.627-.398 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.307c-.832-.539-1.606-.809-2.321-.809-.691 0-1.277.191-1.757.571-.481.381-.859 1.07-1.134 2.066-.276.996-.413 3.082-.413 6.258v5.765Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Left Shoulder" ? "bodyParts_group Left_Shoulder body_parts_active" : "bodyParts_group Left_Shoulder"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyParts",
	            d: "M833.78 334.19c-6.78 1.85-17.93 5.94-23.86 8.18 7.19.74 14.12 2.57 19.7 5.85 13.28 7.81 16.14 15.95 16.29 16.38v.01l.49-.11c.07.28 6.63 28.47 13.56 44.05 1.69 3.8 4.73 10.06 8.59 17.98 3.36 6.9 7.18 14.77 11.04 22.92v-.01c-.21-3.9-.45-9.49-.45-14.14 0-6.68 5.98-26.64 8.36-34.31v-.01c-.76-19.72-2.69-42.94-6-52.33-4.19-11.89-15.06-18.79-25.09-22.44-2.87.41-7.06 2.12-11.15 3.8-3.81 1.55-7.76 3.17-11.48 4.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M867.53 536.11c.07.85.11 1.29.11 1.31l1.99-.17c0-.02-.04-.42-.1-1.2-.68.09-1.33.1-2 .06zm12.06-86.68c.74 1.57 1.48 3.14 2.22 4.72h.06c-.01-.11-.73-10.89-.73-18.86 0-5.1 3.84-18.93 6.56-28.08v-.01c-.05-2.02-.12-4.1-.2-6.22-2.38 7.67-8.36 27.63-8.36 34.31 0 4.65.24 10.24.45 14.14z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M881.81 454.15c-.74-1.58-1.48-3.15-2.22-4.71.14 2.85.28 4.8.28 4.84l1.94-.13z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "syzst2",
	            d: "M867.53 536.11c.07.85.11 1.29.11 1.31l1.99-.17c0-.02-.04-.42-.1-1.2-.68.09-1.33.1-2 .06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyParts",
	            d: "M866.1 490.75c1.92 26.84 3.1 41.25 3.44 45.3 1.07-.14 2.15-.46 3.22-1 13.26-6.63 20.03-50.3 20.09-50.74l.16.02c-7.61-18.61-18.63-41.25-26.26-56.93-3.86-7.94-6.91-14.21-8.62-18.04-5.85-13.15-11.41-35.08-13.13-42.14-1.23 2.73-3.57 8.36-5.83 15.8l.27-.09c.24.74 24.36 75.68 26.66 107.82zm30.65-2.5c-4.38-22.25-9.68-49.5-9.09-59.49.27-4.57.29-12.42.04-21.55-2.72 9.15-6.56 22.98-6.56 28.08 0 7.97.72 18.75.73 18.86h-.06c5.49 11.71 10.88 23.72 14.94 34.1z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyParts",
	            d: "M867.52 536.11s.01 0 0 0c-.34-4.19-1.52-18.59-3.42-45.21-2.01-28.19-21.02-89.79-25.58-104.26-.23 5.49 1.73 14.57 3.49 22.75 1.4 6.5 2.72 12.64 3.07 17.1.18 2.33.07 4.47-.28 6.43l.55-2.29c-.08-1.75.6 4.53.37 12.18 0 1.92-.11 4.11-.43 6.47-.08.71-.17 1.42-.27 2.12.08 1.28.38 6.85.43 12.54.07 3.29.02 7.12-.38 10.29-.24 1.96-.6 3.75-1.06 5.39l.15 14.17c.96 5.62 3.04 16.32 5.37 28.23v.01c3.86 5.49 10.71 13.57 17.99 14.08z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M866.75 427.39c7.63 15.68 18.64 38.33 26.26 56.93l1.82.28c-.03.23-.17 1.11-.41 2.48l1.41.27c-.02.08-.2 1.06-.5 2.77v.01c1.61 4.17 2.99 8.04 4.05 11.48l-.03-.1c-.78-4.06-1.67-8.54-2.59-13.26-4.06-10.38-9.45-22.4-14.94-34.11l-1.94.13c0-.04-.14-2-.28-4.84-3.86-8.15-7.69-16.01-11.04-22.92-3.85-7.92-6.9-14.18-8.59-17.98-6.92-15.58-13.49-43.77-13.56-44.05l-.49.11.13.39-.19.37c-.01.02-.33.66-.85 1.83v.01c1.72 7.06 7.29 28.99 13.13 42.14 1.7 3.85 4.75 10.12 8.61 18.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M868.18 538.17c1.79 0 3.62-.41 5.46-1.33 8.5-4.25 14.32-21.48 17.68-35v-.03c1.33-8.4 2.38-14 2.54-14.82l.24.05c-.36-.89-.72-1.8-1.1-2.71l-.16-.02c-.06.44-6.83 44.11-20.09 50.74-1.07.54-2.15.86-3.22 1 .07.78.1 1.18.1 1.2l-1.99.17c0-.02-.04-.46-.11-1.31h-.01c-7.28-.51-14.13-8.59-17.99-14.09.3 1.52.6 3.06.9 4.61 4.39 5.49 10.8 11.54 17.75 11.54zm26.23-51.08c.24-1.37.38-2.25.41-2.48l-1.82-.28c.37.91.74 1.82 1.1 2.71l.31.05z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M867.53 536.11c.67.04 1.32.03 2-.06-.34-4.04-1.52-18.45-3.44-45.3-2.3-32.14-26.41-107.08-26.66-107.83l-.27.09c-.09.28-.17.57-.26.86-.23.76-.35 1.69-.39 2.75v.01c4.56 14.48 23.57 76.07 25.58 104.26 1.91 26.63 3.09 41.03 3.44 45.22zm28.29-48.75-1.41-.27c-.03.16-.06.33-.08.51v.02c.34.85.67 1.7.99 2.53v-.01c.3-1.72.48-2.7.5-2.78zm-1.96-.37c-.16.82-1.21 6.42-2.54 14.82 1.46-5.89 2.45-11.08 3.01-14.19-.08-.19-.15-.38-.23-.58l-.24-.05zm-2.54 14.83v.02-.02z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "m894.41 487.09-.31-.05c.08.19.15.38.23.58v-.02c.02-.18.05-.35.08-.51zM842.55 493l1.62.78c-.26-1.54-.44-2.7-.52-3.39-.33-2.91-.65-1.2-1.1 2.61z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Shoulder");
	            },
	            className: "bodyLines",
	            d: "M844.01 479.61c-.09.33-.2.65-.3.98L842.55 493c.45-3.81.77-5.52 1.1-2.61.08.69.26 1.85.52 3.39l-.16-14.17z"
	          }),
	          this.state.bodyTitle === "Left Shoulder" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "456",
	              width: "245",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M884.206 476.106h210" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1120.17 488.982v-25.558h5.203v21.216h12.937v4.342h-18.14Zm32.62-5.941 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429H1145.6c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.048 1.852-1.037 3.2h7.383Zm6.769-7.735h2.742v-1.406c0-1.57.167-2.742.501-3.516.334-.773.949-1.403 1.846-1.889.896-.487 2.03-.73 3.401-.73 1.406 0 2.783.211 4.131.633l-.668 3.445a9.783 9.783 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.71 0v3.938h-3.375v7.523c0 1.524.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.474l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.686-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.481v-8.138h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm12.15 10.284 5.063-.493c.304 1.7.922 2.948 1.854 3.744.932.797 2.189 1.196 3.771 1.196 1.675 0 2.938-.355 3.788-1.064.849-.709 1.274-1.538 1.274-2.487 0-.609-.179-1.128-.536-1.556-.357-.427-.982-.799-1.872-1.116-.61-.211-1.998-.586-4.166-1.125-2.789-.691-4.746-1.541-5.871-2.549-1.582-1.418-2.373-3.146-2.373-5.185 0-1.313.372-2.54 1.116-3.683.744-1.142 1.816-2.013 3.217-2.61 1.4-.598 3.091-.897 5.071-.897 3.234 0 5.669.709 7.304 2.127 1.634 1.418 2.493 3.311 2.575 5.678l-5.203.228c-.223-1.324-.7-2.276-1.433-2.856-.732-.58-1.831-.87-3.296-.87-1.511 0-2.695.31-3.551.932-.55.398-.826.931-.826 1.599 0 .61.258 1.131.774 1.565.656.55 2.25 1.125 4.781 1.722 2.531.598 4.403 1.216 5.616 1.855 1.213.638 2.162 1.512 2.848 2.619.685 1.107 1.028 2.476 1.028 4.104 0 1.477-.41 2.86-1.23 4.149-.821 1.289-1.981 2.247-3.481 2.874-1.5.627-3.369.94-5.607.94-3.258 0-5.76-.753-7.506-2.258-1.746-1.506-2.789-3.701-3.129-6.583Zm30.21-17.385v9.474c1.594-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.657.78 1.383.95 2.18.169.797.254 2.033.254 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.281-3.727a2.448 2.448 0 0 0-.993-1.256c-.475-.311-1.07-.466-1.785-.466-.82 0-1.552.199-2.197.597-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm15.93 16.172c0-1.641.404-3.229 1.213-4.764.808-1.535 1.954-2.707 3.436-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.953 0 2.824-.911 5.165-2.733 7.022-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.773-2.734-1.907-3.542-3.401-.809-1.495-1.213-3.314-1.213-5.458Zm5.062.263c0 1.852.44 3.27 1.318 4.254.879.985 1.963 1.477 3.252 1.477 1.29 0 2.371-.492 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.252 1.476-.878.985-1.318 2.403-1.318 4.254Zm30.358 9.334v-2.795a7.202 7.202 0 0 1-2.681 2.356 7.518 7.518 0 0 1-3.507.861c-1.254 0-2.379-.275-3.375-.826-.996-.551-1.717-1.324-2.162-2.32-.445-.996-.668-2.373-.668-4.131v-11.813h4.939v8.578c0 2.625.091 4.234.273 4.826.182.591.513 1.06.993 1.406.481.346 1.09.518 1.828.518.844 0 1.6-.231 2.268-.694.668-.463 1.125-1.037 1.371-1.723.246-.685.369-2.364.369-5.036v-7.875h4.939v18.668h-4.587Zm9.7-25.769h4.939v25.77h-4.939zm27.13 25.769h-4.588v-2.742c-.762 1.066-1.661 1.86-2.698 2.382-1.038.521-2.083.782-3.138.782-2.145 0-3.982-.864-5.511-2.593-1.529-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.233-7.216 1.488-1.646 3.369-2.47 5.642-2.47 2.086 0 3.891.868 5.414 2.602v-9.281h4.94v25.769Zm-13.184-9.738c0 1.992.276 3.434.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.137 0 2.104-.484 2.901-1.45.796-.967 1.195-2.412 1.195-4.333 0-2.145-.387-3.689-1.16-4.632-.774-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.466-2.944 1.397-.791.932-1.187 2.323-1.187 4.175Zm28.864 3.797 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.527-.422.926-1.102 1.195-2.039Zm.282-4.992c-.035-1.43-.405-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm13.648 10.933h-4.94v-18.668h4.588v2.655c.785-1.254 1.492-2.08 2.118-2.479.627-.398 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.307c-.832-.539-1.606-.809-2.32-.809-.692 0-1.278.191-1.758.571-.481.381-.859 1.07-1.134 2.066-.275.996-.413 3.082-.413 6.258v5.765Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Right Elbow" ? "bodyParts_group Right_Elbow body_parts_active" : "bodyParts_group Right_Elbow"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyLines",
	            d: "M614.66 584.43c-.24 2.59-.55 5.04-.95 7.33h-.01l.16.06c10.07-27.47 26.16-41.88 32.05-46.46.19-.96.38-1.93.57-2.91-3.4 2.39-20.21 15.18-31.82 41.98z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyLines",
	            d: "M613.7 591.76h.01c.4-2.29.71-4.74.95-7.33-.93 2.14-1.83 4.38-2.68 6.71l1.72.62z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyParts",
	            d: "M596.37 722.79s0 .02-.01.04c-.17.36-1.62 3.3-4.12 6.21-3.91 4.57-10.4 9.09-18.66 3.59-8.89-5.92-9.77-12.32-9.26-16.16 0-.01 0-.03.01-.04-5.83 15.64-16.78 40.32-17.68 51.14-1.01 11.97 24.13 49.33 27.28 52.49 4.14 4.13 11.66 3.42 9.66-1.57s-17.97-32.95-14.97-37.94c2.98-5 15.97-20.98 20.96-18.97 4.99 1.99 0 24.97 4.99 28.96 5 4 8.92-.01 9.98-7.98 1.06-7.95.39-11.09 2.43-16.21 2.76-6.88.42-12.7-1.37-17.91-1.56-4.56-5.51-8.27-6.88-12.4-1.68-5-3.36-6.58-2.01-14.97l-.07-.01c-.1.57-.19 1.15-.28 1.73z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyParts",
	            d: "m613.86 591.82-.16-.06c-.27 1.62-.6 3.16-.97 4.6-6.96 26.85-35.53 87.57-43.26 103.76-.1.66-.19 1.19-.27 1.57-.43 2.12-1.87 6.11-3.86 11.27 0 0 0 .01-.01.02s-.02.05-.03.07c-.01.03-.03.06-.04.08-.15.42-.31.84-.48 1.26-.01.03-.01.05-.03.07-.17.53-.32 1.2-.42 1.97l32.32 4.62c.23-1.46.48-2.93.72-4.39 1.76-10.56 26.41-64.28 31.7-86.28 5.27-22.02 10.56-44.9 11.44-54.59.34-3.74 2.65-16.15 5.4-30.43-5.89 4.58-21.98 18.99-32.05 46.46z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyParts",
	            d: "M604.67 490.15c-1.59 4.12-2.95 7.96-4.01 11.37 0 .01 0 .02-.01.03-1.04 5.47-1.9 10.14-2.4 13.49-2.64 17.61-13.2 46.66-15.85 70.44-2.26 20.33-9.02 84.43-12.03 108.08 10.19-21.59 34.16-73.54 40.42-97.7 7.09-27.34-3.6-91.55-6.12-105.71zm-40.35 226.32c-.51 3.84.37 10.24 9.26 16.16 8.26 5.5 14.75.98 18.66-3.59 2.5-2.91 3.95-5.85 4.12-6.21.01-.02.01-.04.01-.04.09-.58.18-1.16.28-1.74l-32.32-4.62c-.01.01-.01.03-.01.04z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyLines",
	            d: "m613.7 591.76-1.72-.62c.85-2.33 1.75-4.57 2.68-6.71 2.24-24.89-2.72-62.1-5.98-82.62-1.46-5.9-2.45-11.1-3.01-14.21-.34.86-.67 1.71-1 2.55 2.52 14.16 13.21 78.37 6.12 105.71-6.26 24.16-30.23 76.11-40.42 97.7-.36 2.8-.66 5.03-.9 6.56 7.73-16.19 36.3-76.91 43.26-103.76.37-1.44.7-2.98.97-4.6z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Elbow");
	            },
	            className: "bodyParts",
	            d: "M631.82 538.17c-1.8 0-3.63-.41-5.47-1.33-8.5-4.25-14.31-21.5-17.67-35.03 3.26 20.52 8.22 57.73 5.98 82.62 11.61-26.8 28.42-39.59 31.82-41.98 1.01-5.2 2.06-10.57 3.09-15.82-4.39 5.49-10.8 11.54-17.75 11.54z"
	          }),
	          this.state.bodyTitle === "Right Elbow" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "155",
	              y: "594",
	              width: "225",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup is_right" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M405 616.324h180" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M174.444 625.421v-25.77h10.951c2.754 0 4.755.232 6.003.695 1.248.463 2.247 1.286 2.997 2.469.75 1.184 1.125 2.537 1.125 4.061 0 1.934-.568 3.53-1.705 4.79-1.137 1.26-2.836 2.054-5.098 2.382 1.125.656 2.054 1.377 2.786 2.162.733.785 1.72 2.18 2.962 4.183l3.147 5.028h-6.223l-3.762-5.608c-1.335-2.003-2.25-3.266-2.742-3.788-.492-.521-1.013-.879-1.564-1.072-.551-.193-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.054-.106 4.675-.317a2.8 2.8 0 0 0 1.459-1.09c.352-.515.528-1.16.528-1.933 0-.867-.232-1.567-.695-2.101-.462-.533-1.116-.87-1.96-1.01-.421-.059-1.687-.088-3.796-.088h-4.061v6.539Zm20.742-6.328v-4.571h4.94v4.571h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.23 5.643.686c.093.656.31 1.107.65 1.353.469.352 1.207.528 2.215.528 1.289 0 2.256-.194 2.9-.58.434-.258.762-.674.985-1.248.152-.411.228-1.166.228-2.268v-2.725c-1.476 2.016-3.34 3.024-5.59 3.024-2.507 0-4.494-1.061-5.959-3.182-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.753-5.519 2.259-7.171 1.505-1.653 3.377-2.479 5.616-2.479 2.308 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.849-.545 4.939-.364 1.09-.873 1.946-1.53 2.567-.656.621-1.532 1.107-2.627 1.459-1.096.351-2.482.527-4.158.527-3.164 0-5.408-.542-6.732-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.005-.363.017-.598Zm4.412-10.951c0 1.981.384 3.431 1.152 4.351.767.92 1.713 1.38 2.838 1.38 1.207 0 2.227-.472 3.059-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.024-1.407-1.183 0-2.159.46-2.926 1.38-.768.92-1.152 2.323-1.152 4.21Zm22.957-16.049v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.958-.093-3.2-.281-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.821 0-1.553.2-2.197.598-.645.398-1.117.999-1.415 1.802-.299.802-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm25.629 7.102v3.937h-3.375v7.524c0 1.523.032 2.411.097 2.663.064.252.211.46.439.624.229.164.507.246.835.246.457 0 1.119-.158 1.987-.475l.421 3.832c-1.148.493-2.449.739-3.902.739-.891 0-1.693-.15-2.408-.449-.715-.298-1.239-.685-1.573-1.16-.334-.474-.566-1.116-.695-1.924-.105-.575-.158-1.735-.158-3.481v-8.139h-2.267v-3.937h2.267v-3.709l4.957-2.883v6.592h3.375Zm13.465 18.668v-25.77h19.107v4.36H281.6v5.713h12.938v4.341H281.6v7.014h14.397v4.342h-19.6Zm23.977-25.77h4.939v25.77h-4.939zm9.791 25.77v-25.77h4.939v9.282c1.523-1.735 3.328-2.602 5.414-2.602 2.274 0 4.154.823 5.643 2.47 1.488 1.646 2.232 4.01 2.232 7.092 0 3.188-.759 5.643-2.276 7.366-1.518 1.722-3.361 2.584-5.529 2.584-1.066 0-2.118-.267-3.155-.8s-1.931-1.321-2.681-2.364v2.742h-4.587Zm4.904-9.738c0 1.933.305 3.363.914 4.289.855 1.312 1.992 1.968 3.41 1.968 1.09 0 2.019-.465 2.786-1.397.768-.932 1.152-2.4 1.152-4.403 0-2.133-.387-3.671-1.161-4.615-.773-.943-1.763-1.415-2.97-1.415-1.184 0-2.168.46-2.953 1.38-.786.92-1.178 2.318-1.178 4.193Zm16.154.14c0-1.64.404-3.228 1.213-4.763.809-1.536 1.954-2.708 3.437-3.516 1.482-.809 3.137-1.213 4.965-1.213 2.825 0 5.139.917 6.944 2.751 1.804 1.834 2.707 4.151 2.707 6.952 0 2.824-.911 5.165-2.734 7.023-1.822 1.857-4.116 2.786-6.881 2.786-1.711 0-3.343-.387-4.896-1.16-1.553-.774-2.733-1.908-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.063.264c0 1.851.439 3.269 1.318 4.254.879.984 1.963 1.476 3.252 1.476 1.289 0 2.37-.492 3.243-1.476.873-.985 1.31-2.414 1.31-4.289 0-1.828-.437-3.235-1.31-4.219-.873-.984-1.954-1.477-3.243-1.477s-2.373.493-3.252 1.477c-.879.984-1.318 2.402-1.318 4.254Zm21.55 9.334-5.906-18.668h4.799l3.498 12.234 3.217-12.234h4.764l3.111 12.234 3.568-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Left Elbow" ? "bodyParts_group Left_Elbow body_parts_active" : "bodyParts_group Left_Elbow"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyParts",
	            d: "M953.35 767.56c-.9-10.82-11.85-35.5-17.68-51.14.52 3.83-.33 10.26-9.25 16.2-8.26 5.5-14.76.98-18.67-3.59-2.49-2.91-3.94-5.85-4.11-6.21-.02-.02-.02-.04-.02-.04-.09-.58-.18-1.16-.28-1.74l-.06.01c1.34 8.39-.34 9.97-2.01 14.97-1.38 4.13-5.32 7.84-6.88 12.4-1.78 5.21-4.13 11.03-1.37 17.91 2.04 5.11 1.37 8.26 2.43 16.21 1.06 7.97 4.99 11.99 9.98 7.98 4.99-3.99 0-26.97 4.99-28.96 5-2 17.98 13.98 20.96 18.97 3 4.99-12.97 32.95-14.97 37.94-2 5 5.52 5.7 9.66 1.57 3.15-3.14 28.29-40.5 27.28-52.48z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyParts",
	            d: "M935.67 716.43c-.11-.77-.27-1.43-.43-1.97-.01-.02-.01-.04-.02-.07-.17-.42-.34-.84-.49-1.26-.01-.02-.02-.05-.03-.08-.01-.02-.02-.06-.04-.07-.01-.01-.01-.02-.01-.02-1.99-5.16-3.42-9.15-3.85-11.27-.08-.38-.17-.91-.27-1.57-7.73-16.19-36.3-76.91-43.26-103.76-.37-1.44-.7-2.98-.97-4.6l-.16.06c-10.08-27.47-26.17-41.88-32.05-46.46 2.75 14.28 5.06 26.69 5.4 30.43.88 9.69 6.16 32.57 11.44 54.59 5.29 22 29.94 75.72 31.7 86.28.24 1.46.48 2.93.71 4.39l32.33-4.62zm-32.05 6.36s0 .02.02.04c.17.36 1.62 3.3 4.11 6.21 3.91 4.57 10.41 9.09 18.67 3.59 8.92-5.94 9.77-12.37 9.25-16.2l-32.33 4.62c.1.58.19 1.16.28 1.74z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyLines",
	            d: "m886.14 591.82.16-.06c-.41-2.29-.72-4.74-.96-7.33-11.61-26.8-28.42-39.59-31.82-41.98.19.98.38 1.95.57 2.91 5.88 4.58 21.97 18.99 32.05 46.46z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyLines",
	            d: "M885.34 584.43c.24 2.59.55 5.04.96 7.33l1.72-.62c-.85-2.33-1.75-4.57-2.68-6.71z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyParts",
	            d: "M889.2 595.86c6.27 24.16 30.24 76.11 40.43 97.7-3.01-23.65-9.77-87.75-12.03-108.08-2.65-23.78-13.21-52.83-15.85-70.44-.5-3.33-1.36-7.97-2.38-13.4v-.02c-1.06-3.44-2.44-7.31-4.05-11.48-2.51 14.15-13.2 78.36-6.12 105.72z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyParts",
	            d: "M891.32 501.83c-3.36 13.53-9.18 30.76-17.68 35-1.84.92-3.67 1.33-5.46 1.33-6.95 0-13.36-6.05-17.75-11.54 1.03 5.25 2.08 10.62 3.09 15.82 3.4 2.39 20.21 15.18 31.82 41.98-2.24-24.87 2.72-62.06 5.98-82.59z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Elbow");
	            },
	            className: "bodyLines",
	            d: "M929.63 693.56c-10.19-21.59-34.16-73.54-40.43-97.7-7.08-27.35 3.61-91.57 6.12-105.72-.32-.83-.65-1.67-.99-2.53-.56 3.11-1.55 8.3-3.01 14.19v.03c-3.26 20.53-8.22 57.71-5.98 82.59.93 2.14 1.83 4.38 2.68 6.71l-1.72.62c.27 1.62.6 3.16.97 4.6 6.96 26.85 35.53 87.57 43.26 103.76-.24-1.52-.54-3.75-.9-6.55z"
	          }),
	          this.state.bodyTitle === "Left Elbow" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "592",
	              width: "195",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M914.206 612.527h180" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1120.17 625.421v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.62-5.942 4.922.827c-.633 1.804-1.632 3.178-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.434 0-3.093.808-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429H1145.6c.036 1.465.434 2.604 1.196 3.419.761.814 1.711 1.221 2.847 1.221.774 0 1.424-.211 1.951-.633.528-.421.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.567-1.117-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.852-1.037 3.199h7.383Zm6.769-7.734h2.742v-1.406c0-1.571.167-2.743.501-3.516.334-.773.949-1.403 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.633l-.668 3.445a9.729 9.729 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.975-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.71 0v3.937h-3.375v7.524c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.149.493-2.449.739-3.902.739-.891 0-1.694-.15-2.409-.449-.715-.298-1.239-.685-1.573-1.16-.334-.474-.565-1.116-.694-1.924-.106-.575-.158-1.735-.158-3.481v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm13.47 18.668v-25.77h19.108v4.36h-13.904v5.713h12.937v4.341h-12.937v7.014h14.396v4.342h-19.6Zm23.97-25.77h4.939v25.77h-4.939zm9.79 25.77v-25.77h4.939v9.282c1.524-1.735 3.329-2.602 5.415-2.602 2.273 0 4.154.823 5.642 2.47 1.488 1.646 2.233 4.01 2.233 7.092 0 3.188-.759 5.643-2.277 7.366-1.517 1.722-3.36 2.584-5.528 2.584-1.067 0-2.118-.267-3.155-.8-1.038-.533-1.931-1.321-2.681-2.364v2.742h-4.588Zm4.904-9.738c0 1.933.305 3.363.914 4.289.856 1.312 1.993 1.968 3.411 1.968 1.089 0 2.018-.465 2.786-1.397.767-.932 1.151-2.4 1.151-4.403 0-2.133-.387-3.671-1.16-4.615-.774-.943-1.764-1.415-2.971-1.415-1.183 0-2.168.46-2.953 1.38-.785.92-1.178 2.318-1.178 4.193Zm16.156.14c0-1.64.404-3.228 1.212-4.763.809-1.536 1.955-2.708 3.437-3.516 1.482-.809 3.138-1.213 4.966-1.213 2.824 0 5.138.917 6.943 2.751 1.805 1.834 2.707 4.151 2.707 6.952 0 2.824-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.896-1.16-1.552-.774-2.733-1.908-3.542-3.402-.808-1.494-1.212-3.313-1.212-5.458Zm5.062.264c0 1.851.44 3.269 1.318 4.254.879.984 1.963 1.476 3.252 1.476 1.289 0 2.371-.492 3.244-1.476.873-.985 1.309-2.414 1.309-4.289 0-1.828-.436-3.235-1.309-4.219-.873-.984-1.955-1.477-3.244-1.477-1.289 0-2.373.493-3.252 1.477-.878.984-1.318 2.402-1.318 4.254Zm21.548 9.334-5.906-18.668h4.798l3.498 12.234 3.217-12.234h4.764l3.111 12.234 3.569-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Right Thigh" ? "bodyParts_group Right_Thigh body_parts_active" : "bodyParts_group Right_Thigh"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "syzst2",
	            d: "M657.45 678.84c.01-9.5-.37-18.1-.6-22.44l-.17.01c.02.2.74 10.29.77 22.43zm-9.4 61.17c-.02 2.45-.04 5.68-.03 9.41.01-5.61.09-9.29.09-9.41h-.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyParts",
	            d: "M713.04 826.06c1.34 22.23 6.14 105.35 4.62 123.56-3.09 37.1-1.01 60.83 5.71 65.1 1.81 1.16 3.44 1.41 4.98.77 2.26-.92 4.06-3.67 5.34-6.44v-.01c.63-5.03 1.03-9.48 1.03-12.4 0-6.67-.84-60.42-1.65-98.47v-.01c-1.81-6.71-9.65-36.05-11.23-47.09-.69-4.88-4.13-14.29-8.8-25.01zm-28.96 174.97c5.92-11.84 5.24-22.66 3.42-39.06-.98-8.84-12.16-53.22-22.03-92.39-7.79-30.93-15.15-60.14-16.7-68.66-3.03-16.67-2.81-49.86-2.7-58.73-3 8.46-5.62 17.63-6.77 28.72-2.26 21.85 1.16 83.56 2.13 99.93.01.02.01.04.01.05 5.6 30.86 15.32 85.03 16.68 93.17 1.49 8.98 4.9 34.45 5.35 51.64 4.75-1.36 16.01-5.47 20.61-14.67zm28.6-279.36c6.57 20.77 13.95 48.19 17.13 60.01.45 1.67.8 2.97 1.03 3.83 1.73 6.33 4.14 16.86 5.59 23.35.43-3.57.76-6.52.93-8.56.88-10.57 0-29.93 0-34.34 0-.66.3-1.21.81-1.64-2.68-2.97-8.84-9.98-10.95-14.2-1.62-3.23-9.07-17.79-14.54-28.45zm15.19 60.53c-13.14-48.86-21.93-77.11-26.14-83.95-2.49-4.05-7.73-11.71-13.79-20.59-2.86-4.2-5.92-8.67-8.92-13.11 0-.01 0-.01-.01-.01-1.32-.61-7.53-3.48-13.65-6.26 2.73 10.74 15.33 58.81 28.44 86.57 3.16 6.69 6.13 12.87 8.88 18.61 10.23 21.34 17.62 36.75 21.11 49.34 2.54 9.14 6.02 24.58 8.5 35.96.66-10.73 2.19-23.64 3.42-33.85v-.01c-.3-1.37-4.29-19.63-6.8-28.86-.23-.86-.59-2.17-1.04-3.84z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyParts",
	            d: "M637.31 770.7c1.65-15.93 6.27-27.89 10.74-39.45 2.69-6.98 5.23-13.56 6.89-20.55 1.96-8.21 2.5-20.65 2.51-31.85-.04-12.15-.76-22.24-.77-22.43l.17-.01-.12-2.06c-6.25-3.13-10.75-11.62-12.45-15.29-4.54 19.68-13.76 68.76-16.1 82-2.65 14.97-4.41 41.38-3.53 54.58.88 13.22 10.56 61.63 13.21 75.72.18.94.41 2.16.69 3.7-1.29-25.11-3.03-67.06-1.24-84.36zm63.56-6.38c-2.75-5.74-5.72-11.92-8.88-18.62-14.01-29.66-27.39-82.21-28.96-88.49-1.53-.7-3.02-1.37-4.38-1.98l.02.02c.05.42 4.46 43.4 9.66 62.47.73 2.67 1.46 5.45 2.21 8.3 4.69 17.87 10.01 38.12 20.55 53.92 12.64 18.96 30.99 58.69 32.73 70.84 1.18 8.24 6.03 27.35 9.06 38.87-.3-13.26-.58-23.61-.81-27.72-.09-1.55-.11-3.27-.09-5.16v-.01c-2.32-10.87-6.96-32.06-10.11-43.43-3.45-12.41-10.81-27.76-21-49.01z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyParts",
	            d: "M648.11 740.01c0 .12-.08 3.8-.09 9.41.03 15.27.48 38.84 2.72 51.14 1.54 8.46 8.89 37.64 16.67 68.53 9.32 37.02 18.93 75.16 21.49 88.97v.01l.2-.04c.02.09 1.96 8.69 10.05 10.81 7.31 1.91 14.38-6.36 15.71-8.03v-.01c.24-4.05.52-7.9.81-11.35 1.71-20.46-4.66-123.97-4.95-128.59v-.01c-6.51-14.29-14.69-29.89-21.3-39.81-10.71-16.07-16.08-36.49-20.82-54.51-.74-2.84-1.47-5.61-2.2-8.29-2.68-9.82-5.14-25.61-6.92-38.77.01 10.76-.53 23.05-2.59 31.7-1.69 7.11-4.26 13.76-6.98 20.8-.61 1.58-1.22 3.17-1.83 4.77-.01.83-.02 1.94-.04 3.27h.07zm9.97-87.22c5.53 2.46 14.12 6.41 18.77 8.55-7.46-11.12-14.25-21.59-16.56-26.58-3.48-7.56-4.32-18.98-4.46-26.19-4.02 9-8.3 18.38-10.03 24.44-.28.99-.62 2.27-.99 3.83l.59-.23c.05.13 5.23 12.87 12.68 16.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M729.81 781.68c-3.18-11.82-10.56-39.24-17.13-60.01v-.01c-3.34-6.51-5.93-11.56-6-11.7l1.78-.92c-1.93-5.42-3.67-9.62-5.03-11.83-2.52-4.1-7.76-11.78-13.84-20.67-10.74-15.74-24.11-35.32-27.48-42.62-4.17-9.03-4.36-24.41-4.28-29.93-.65 1.47-1.32 2.98-2 4.5v.08c.14 7.21.98 18.63 4.46 26.19 2.31 4.99 9.1 15.46 16.56 26.58l.01.01c1.95.9 3.21 1.48 3.25 1.5l-.84 1.81c-.01 0-.1-.04-.25-.11 3 4.44 6.06 8.91 8.92 13.11 6.06 8.88 11.3 16.54 13.79 20.59 4.21 6.84 13 35.09 26.14 83.95.45 1.67.81 2.98 1.04 3.84 2.51 9.23 6.5 27.49 6.8 28.86.26-2.15.5-4.17.72-6.03v-.01c-1.45-6.49-3.86-17.02-5.59-23.35-.23-.86-.58-2.16-1.03-3.83z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M708.48 709.08c1.33 3.71 2.74 7.97 4.2 12.58v.01c5.47 10.66 12.92 25.22 14.54 28.45 2.11 4.22 8.27 11.23 10.95 14.2.46-.41 1.09-.73 1.82-.99-2.43-2.66-8.92-9.97-10.98-14.1-2.58-5.15-19.82-38.77-20.53-40.15z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M712.68 721.66c-1.46-4.61-2.87-8.87-4.2-12.58-.01-.02-.02-.03-.02-.04l-1.78.92c.07.14 2.66 5.19 6 11.7zm-10 41.8c-2.75-5.74-5.72-11.92-8.88-18.61-13.11-27.77-25.71-75.84-28.44-86.57 0 0-.01 0-.01-.01-.78-.36-1.55-.71-2.32-1.06 1.57 6.28 14.95 58.83 28.96 88.49 3.16 6.7 6.13 12.88 8.88 18.62 10.19 21.25 17.55 36.6 21 49.01 3.15 11.37 7.79 32.56 10.11 43.43.03-2.45.14-5.15.31-8-2.48-11.38-5.96-26.82-8.5-35.96-3.49-12.59-10.88-28-21.11-49.34zm-11.59 16.48c-10.54-15.8-15.86-36.05-20.55-53.92-.75-2.85-1.48-5.63-2.21-8.3-5.2-19.07-9.61-61.05-9.66-61.47l-1.82.16c.23 4.34.61 12.94.6 22.44.03 10.84-.48 23.31-2.51 31.85-1.66 6.99-4.2 13.57-6.89 20.55-4.47 11.56-9.09 23.52-10.74 39.45-1.79 17.3-.05 59.25 1.25 84.36 0 .03.01.06.01.09.7 3.77 1.69 9.21 2.86 15.69-.97-16.37-4.39-78.08-2.13-99.93 1.15-11.09 3.77-20.26 6.77-28.72v-.02c.02-1.36.04-2.15.04-2.2l.76.02 1.24-4.98c0 .05-.01.66-.03 1.73.61-1.6 1.22-3.19 1.83-4.77 2.72-7.04 5.29-13.69 6.98-20.8 2.06-8.65 2.6-20.94 2.59-31.7 1.78 13.16 4.24 28.95 6.92 38.77.73 2.68 1.46 5.45 2.2 8.29 4.74 18.02 10.11 38.44 20.82 54.51 6.61 9.92 14.79 25.52 21.3 39.81v-.01c-.01-.07-.01-.11-.01-.13l2-.13c.01.14.13 2.11.33 5.48 4.67 10.72 8.11 20.13 8.8 25.01 1.58 11.04 9.42 40.38 11.23 47.09-.06-2.94-.12-5.78-.19-8.49v-.02c-3.03-11.52-7.88-30.63-9.06-38.87-1.74-12.15-20.09-51.88-32.73-70.84z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "m656.74 654.35.12 2.06 1.82-.16c.05.42 4.46 42.4 9.66 61.47-5.2-19.07-9.61-62.05-9.66-62.47l-.02-.02c-.48-.21-.94-.42-1.38-.61-.19-.08-.36-.18-.54-.27zm.71 24.49c-.01 11.2-.56 23.64-2.51 31.85 2.04-8.54 2.55-21.01 2.51-31.85z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M656.74 654.35c-.03-.56-.06-.9-.06-.93l1.97 1.81c1.36.61 2.85 1.28 4.38 1.98-.1-.38-.15-.59-.16-.62l1.94-.48c.02.06.2.82.54 2.16h.01v.01c6.12 2.79 12.33 5.66 13.65 6.26-.71-1.07-1.43-2.13-2.15-3.19l-.01-.01c-4.65-2.14-13.24-6.09-18.77-8.55-7.45-3.31-12.63-16.05-12.68-16.18l-.59.23v.01c-.17.69-.34 1.42-.52 2.21 1.7 3.66 6.2 12.15 12.45 15.29z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M656.74 654.35c.18.09.35.19.53.27.44.2.91.4 1.38.61l-1.97-1.81c0 .03.03.36.06.93zm22.28 10.2c.15.07.24.11.25.11l.84-1.81c-.04-.02-1.3-.6-3.25-1.5.72 1.06 1.44 2.12 2.15 3.19.01 0 .01 0 .01.01zm-16.15-7.96c.01.03.06.24.16.62.77.35 1.54.7 2.32 1.06-.34-1.34-.52-2.1-.54-2.16l-1.94.48zm2.48 1.68h.01zm20.52 343.66c5.85-11.69 5.53-22.24 3.9-37.58v-.01c-1.95-2.92-2.58-5.68-2.63-5.9l1.76-.37v-.01c-2.56-13.81-12.17-51.95-21.49-88.97-7.78-30.89-15.13-60.07-16.67-68.53-2.44-13.42-2.76-37.77-2.72-51.14-.01-3.73.01-6.96.03-9.41l-1.18-.02c-.27.73-.54 1.45-.8 2.19v.01c-.11 8.87-.33 42.06 2.7 58.73 1.55 8.52 8.91 37.73 16.7 68.66 9.87 39.17 21.05 83.55 22.03 92.39 1.82 16.4 2.5 27.22-3.42 39.06-4.6 9.2-15.86 13.31-20.61 14.67.02.71.03 1.41.04 2.08 4.7-1.26 17.18-5.49 22.36-15.85z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M650.74 800.56c-2.24-12.3-2.69-35.87-2.72-51.14-.03 13.37.28 37.72 2.72 51.14zm-2.66-63.83c-.41 1.08-.82 2.15-1.21 3.25l1.18.02c.01-1.33.02-2.44.03-3.27z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "m648.11 735.01-1.24 4.98c.4-1.1.81-2.18 1.21-3.25.02-1.08.03-1.69.03-1.73zm-2 4.96c0 .05-.02.84-.04 2.2v.01c.26-.74.53-1.46.8-2.19l-.76-.02zm82.24 275.52c-1.54.64-3.17.39-4.98-.77-6.72-4.27-8.8-28-5.71-65.1 1.52-18.21-3.28-101.33-4.62-123.56-.75-1.7-1.52-3.44-2.32-5.2.29 4.62 6.66 108.13 4.95 128.59-.29 3.45-.57 7.3-.81 11.35v.01c.14-.17.22-.28.22-.29l1.61 1.19c-.1.13-.82 1.08-2 2.33-1.05 21.46-.5 47.21 7.6 52.36 1.49.95 2.96 1.43 4.37 1.43.84 0 1.65-.17 2.45-.5 1.51-.62 2.8-1.79 3.88-3.19.26-1.74.49-3.45.7-5.1-1.28 2.78-3.08 5.53-5.34 6.45z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "M713.04 826.06c-.2-3.37-.32-5.34-.33-5.48l-2 .13c0 .02 0 .06.01.13v.02c.8 1.76 1.57 3.5 2.32 5.2zm-13.89 142.77c-8.1-2.12-10.04-10.72-10.05-10.81l-.2.04c.29 1.55.49 2.79.59 3.68.1.88.19 1.74.28 2.59 1.73 2.58 4.5 5.28 8.88 6.43.94.25 1.86.36 2.77.36 5.65 0 10.63-4.29 13.28-7.08.06-1.1.11-2.17.17-3.24-1.34 1.67-8.41 9.94-15.72 8.03z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Thigh");
	            },
	            className: "bodyLines",
	            d: "m688.9 958.06-1.76.37c.05.21.67 2.98 2.63 5.9-.09-.85-.18-1.71-.28-2.59-.1-.89-.3-2.13-.59-3.68zm27.79 3.65-1.61-1.19c-.01.01-.08.11-.22.29-.06 1.07-.11 2.14-.17 3.24 1.18-1.25 1.9-2.21 2-2.34z"
	          }),
	          this.state.bodyTitle === "Right Thigh" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "165",
	              y: "861",
	              width: "215",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup is_right" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M405 883.94h250" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M184.565 893.037v-25.77h10.951c2.754 0 4.755.232 6.003.695 1.248.463 2.247 1.286 2.997 2.47.75 1.183 1.125 2.537 1.125 4.06 0 1.934-.568 3.53-1.705 4.79-1.137 1.26-2.836 2.054-5.097 2.382 1.125.656 2.053 1.377 2.786 2.162.732.785 1.719 2.18 2.962 4.184l3.146 5.027h-6.223l-3.761-5.607c-1.336-2.004-2.25-3.267-2.743-3.789-.492-.521-1.013-.878-1.564-1.072-.551-.193-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.055-.106 4.676-.317a2.801 2.801 0 0 0 1.459-1.089c.351-.516.527-1.161.527-1.934 0-.867-.232-1.567-.694-2.101-.463-.533-1.117-.87-1.96-1.01-.422-.059-1.688-.088-3.797-.088h-4.061v6.539Zm20.742-6.328v-4.571h4.94v4.571h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.23 5.643.686c.094.656.31 1.107.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.194 2.901-.58.433-.258.761-.674.984-1.248.152-.41.228-1.166.228-2.268v-2.724c-1.476 2.015-3.339 3.023-5.589 3.023-2.508 0-4.495-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.657.621-1.533 1.107-2.628 1.459-1.096.351-2.482.527-4.158.527-3.164 0-5.408-.542-6.732-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.598Zm4.412-10.951c0 1.981.384 3.431 1.152 4.351.767.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.023-1.407-1.184 0-2.16.46-2.927 1.38-.768.92-1.152 2.324-1.152 4.21Zm22.957-16.049v9.475c1.594-1.863 3.499-2.795 5.713-2.795 1.137 0 2.162.211 3.077.633.914.422 1.602.961 2.065 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.474-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.116.999-1.415 1.802-.299.803-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm25.629 7.102v3.938h-3.375v7.523c0 1.523.033 2.411.097 2.663.065.252.211.46.44.624.228.164.506.246.834.246.457 0 1.12-.158 1.987-.474l.422 3.832c-1.149.492-2.45.738-3.903.738-.89 0-1.693-.15-2.408-.448-.715-.299-1.239-.686-1.573-1.161-.334-.474-.566-1.116-.694-1.924-.106-.575-.159-1.735-.159-3.481v-8.138h-2.267v-3.938h2.267v-3.709l4.957-2.883v6.592h3.375Zm19.266 18.668v-21.41h-7.646v-4.36h20.478v4.36h-7.629v21.41h-5.203Zm21.076-25.77v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.093-3.2-.281-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.821 0-1.553.2-2.198.598-.644.399-1.116.999-1.415 1.802-.298.803-.448 1.989-.448 3.559v9.352h-4.939v-25.77h4.939Zm17.069 4.571v-4.571h4.939v4.571h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.544 1.23 5.643.686c.094.656.311 1.107.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.194 2.901-.58.433-.258.761-.674.984-1.248.152-.41.229-1.166.229-2.268v-2.724c-1.477 2.015-3.34 3.023-5.59 3.023-2.508 0-4.494-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.656.621-1.532 1.107-2.628 1.459-1.096.351-2.482.527-4.157.527-3.164 0-5.409-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.598Zm4.413-10.951c0 1.981.383 3.431 1.151 4.351.768.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.023-1.407-1.184 0-2.159.46-2.927 1.38-.768.92-1.151 2.324-1.151 4.21Zm22.957-16.049v9.475c1.593-1.863 3.498-2.795 5.712-2.795 1.137 0 2.163.211 3.077.633.914.422 1.602.961 2.065 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.474-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.559v9.352h-4.94v-25.77h4.94Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Left Thigh" ? "bodyParts_group Left_Thigh body_parts_active" : "bodyParts_group Left_Thigh"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "syzst2",
	            d: "M842.55 678.87c.04-12.16.76-22.26.77-22.45l-.17-.01c-.23 4.34-.61 12.94-.6 22.46zm9.42 70.95c.01-3.99-.01-7.39-.04-9.81h-.05c0 .12.08 3.97.09 9.81z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyParts",
	            d: "M789.27 820.89c-.3 5.01-6.65 108.14-4.94 128.56.29 3.46.57 7.3.81 11.36 1.34 1.66 8.42 9.94 15.71 8.02 8.13-2.13 10.04-10.72 10.05-10.81l.19.04c2.56-13.8 12.17-51.94 21.49-88.96 7.79-30.9 15.14-60.09 16.68-68.55 2.25-12.39 2.69-35.78 2.71-50.74-.01-5.83-.09-9.69-.09-9.81h.05c-.02-1.52-.03-2.66-.04-3.32-.6-1.58-1.2-3.16-1.8-4.72-2.72-7.04-5.29-13.69-6.98-20.8-2.06-8.65-2.61-20.94-2.59-31.7-1.78 13.16-4.24 28.95-6.92 38.77-.73 2.68-1.46 5.45-2.21 8.3-4.73 18.01-10.1 38.43-20.82 54.5-6.61 9.92-14.79 25.53-21.3 39.83v.03zm8.05-57.42c2.75-5.74 5.71-11.93 8.88-18.62 13.11-27.78 25.7-75.83 28.43-86.57-6.16 2.81-12.39 5.69-13.66 6.28-2.99 4.45-6.05 8.92-8.92 13.12-6.06 8.87-11.29 16.53-13.78 20.58-1.24 2.03-2.9 5.94-4.95 11.71 0 .01-.01.02-.02.04-4.85 13.71-11.95 37.88-21.19 72.24-.44 1.65-.79 2.95-1.02 3.8-2.49 9.1-6.39 26.97-6.8 28.79v.03c1.22 10.21 2.75 23.12 3.42 33.86 2.48-11.38 5.96-26.79 8.49-35.92 3.5-12.59 10.89-28.01 21.12-49.34z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyParts",
	            d: "M771.65 1015.49c1.54.64 3.17.39 4.98-.77 6.72-4.27 8.79-28 5.7-65.1-1.51-18.2 3.29-101.31 4.63-123.56-4.68 10.72-8.11 20.13-8.8 25.01-1.58 11.03-9.4 40.33-11.23 47.07-.81 38.05-1.65 91.83-1.65 98.5 0 2.92.4 7.37 1.03 12.4v.01c1.22 2.68 3 5.48 5.34 6.44zm-1.47-233.77c3.18-11.83 10.57-39.3 17.15-60.08-5.47 10.66-12.93 25.24-14.55 28.48-2.11 4.22-8.26 11.22-10.95 14.19.51.44.81.99.81 1.65 0 4.41-.88 23.77 0 34.34.17 2.04.5 4.99.93 8.56 1.45-6.49 3.86-17.02 5.59-23.35.23-.85.58-2.14 1.02-3.79zm52.96-120.38c4.65-2.14 13.25-6.09 18.77-8.55 7.47-3.32 12.63-16.06 12.68-16.19l.6.24c-.38-1.56-.72-2.85-1-3.84-1.73-6.06-6.02-15.51-10.04-24.52-.13 7.2-.95 18.68-4.45 26.27-2.29 5-9.08 15.47-16.56 26.59zm37.55 109.57c-1.15-11.1-3.77-20.27-6.77-28.74.12 8.84.34 42.07-2.69 58.75-1.55 8.52-8.91 37.74-16.71 68.68-9.86 39.16-21.04 83.54-22.02 92.37-1.82 16.4-2.5 27.21 3.42 39.06 4.6 9.21 15.88 13.31 20.61 14.67.45-17.19 3.86-42.66 5.35-51.64 1.36-8.13 11.07-62.22 16.67-93.09.96-16.18 4.41-78.15 2.14-100.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyParts",
	            d: "m843.26 654.35-.12 2.06.17.01c-.02.19-.74 10.29-.77 22.45.01 11.19.55 23.63 2.5 31.83 1.66 6.99 4.21 13.57 6.9 20.55 4.47 11.56 9.08 23.52 10.73 39.45 1.79 17.3.05 59.26-1.24 84.37l.68-3.71c2.65-14.09 12.34-62.5 13.22-75.72.88-13.2-.88-39.61-3.53-54.58-2.34-13.24-11.56-62.34-16.1-82.01-1.69 3.66-6.18 12.15-12.44 15.3zm-34.35 125.59c10.53-15.8 15.85-36.05 20.55-53.91.75-2.85 1.48-5.63 2.21-8.31 4.75-17.42 8.84-55.63 9.54-62.42-1.32.59-2.76 1.24-4.24 1.91-1.57 6.29-14.96 58.83-28.96 88.49-3.17 6.7-6.14 12.89-8.89 18.64-10.18 21.24-17.54 36.58-20.99 48.99-3.15 11.37-7.79 32.56-10.11 43.43v.01c.02 1.88 0 3.61-.09 5.16-.23 4.1-.51 14.45-.81 27.7 3.03-11.52 7.88-30.62 9.06-38.85 1.73-12.15 20.09-51.88 32.73-70.84z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M772.11 782.24c9.24-34.36 16.34-58.53 21.19-72.24-.26.51-2.77 5.4-5.97 11.63v.01c-6.58 20.78-13.97 48.25-17.15 60.08-.44 1.65-.79 2.94-1.02 3.79-1.73 6.33-4.14 16.86-5.59 23.35v.01c.22 1.84.46 3.84.72 5.96.41-1.82 4.31-19.69 6.8-28.79.23-.85.58-2.15 1.02-3.8zm65.78-148.32c-3.37 7.3-16.75 26.88-27.49 42.62-6.07 8.9-11.32 16.57-13.84 20.67-1.37 2.21-3.1 6.41-5.02 11.83l1.78.92c2.05-5.77 3.71-9.68 4.95-11.71 2.49-4.05 7.72-11.71 13.78-20.58 2.87-4.2 5.93-8.67 8.92-13.12-.14.07-.23.11-.24.11l-.84-1.81c.04-.02 1.3-.6 3.25-1.5v-.01c7.48-11.12 14.27-21.59 16.57-26.58 3.5-7.59 4.32-19.07 4.45-26.27v-.02c-.68-1.52-1.35-3-2-4.47.09 5.53-.11 20.89-4.27 29.92z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M787.33 721.64v-.01c0-.01.01-.01.01-.02 1.44-4.57 2.85-8.81 4.16-12.5-.87 1.71-17.95 35-20.51 40.12-2.07 4.13-8.56 11.44-10.98 14.1.73.26 1.36.58 1.82.98 2.69-2.97 8.84-9.97 10.95-14.19 1.62-3.24 9.08-17.82 14.55-28.48z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M787.33 721.63c3.2-6.23 5.71-11.12 5.97-11.63.01-.02.02-.03.02-.04l-1.78-.92c0 .01-.02.03-.04.07-1.31 3.69-2.72 7.93-4.16 12.5 0 .01-.01.01-.01.02zm11.79 42.71c2.75-5.75 5.72-11.94 8.89-18.64 14-29.66 27.39-82.2 28.96-88.49-.77.35-1.56.71-2.34 1.07-2.73 10.74-15.32 58.8-28.43 86.57-3.17 6.69-6.13 12.88-8.88 18.62-10.23 21.33-17.62 36.75-21.12 49.33-2.53 9.13-6.01 24.54-8.49 35.92v.01c.17 2.86.28 5.57.31 8.03 2.32-10.87 6.96-32.06 10.11-43.43 3.45-12.41 10.81-27.75 20.99-48.99zm63.56 6.36c-1.65-15.93-6.26-27.89-10.73-39.45-2.69-6.98-5.24-13.56-6.9-20.55-2.03-8.54-2.54-21-2.5-31.83-.01-9.51.37-18.12.6-22.46l-1.83-.16c-.04.42-4.45 42.4-9.65 61.47-.73 2.68-1.46 5.46-2.21 8.31-4.7 17.86-10.02 38.11-20.55 53.91-12.64 18.96-31 58.69-32.73 70.84-1.18 8.23-6.03 27.33-9.06 38.85-.07 2.72-.13 5.57-.19 8.51 1.83-6.74 9.65-36.04 11.23-47.07.69-4.88 4.12-14.29 8.8-25.01v-.02c.2-3.35.32-5.32.33-5.46l1.99.13c0 .02 0 .07-.01.16 6.51-14.3 14.69-29.91 21.3-39.83 10.72-16.07 16.09-36.49 20.82-54.5.75-2.85 1.48-5.62 2.21-8.3 2.68-9.82 5.14-25.61 6.92-38.77-.02 10.76.53 23.05 2.59 31.7 1.69 7.11 4.26 13.76 6.98 20.8.6 1.56 1.2 3.13 1.8 4.72-.01-.41-.01-.65-.01-.68l1.25 3.98.75-.02c0 .05.02.83.03 2.19l.01.01c3 8.47 5.62 17.64 6.77 28.74 2.27 21.91-1.18 83.88-2.14 100.06 1.19-6.58 2.19-12.1 2.89-15.9 1.29-25.11 3.03-67.07 1.24-84.37z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "m841.32 656.25 1.83.16.12-2.06c-.18.09-.35.19-.54.27-.48.21-.99.44-1.51.67-.7 6.79-4.79 45-9.54 62.42 5.19-19.06 9.6-61.04 9.64-61.46zm3.73 54.45c-1.95-8.2-2.49-20.64-2.5-31.83-.04 10.83.47 23.29 2.5 31.83zm10.66-71.66c.44-.95.7-1.58.74-1.69l-1.25-.5c.16.68.33 1.41.51 2.19z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M841.91 652.79c-5.52 2.46-14.12 6.41-18.77 8.55-.71 1.06-1.43 2.12-2.16 3.19l-.01.01c1.27-.59 7.51-3.47 13.66-6.28v-.01c.35-1.34.53-2.1.55-2.16l1.95.48c-.01.03-.06.24-.16.62 1.49-.67 2.92-1.32 4.24-1.91.07-.64.1-1.01.11-1.05l2-.83c0 .03-.02.37-.06.93 6.26-3.14 10.75-11.64 12.45-15.3v-.01c-.18-.78-.35-1.51-.51-2.19l-.6-.24c-.05.14-5.22 12.88-12.69 16.2z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M843.26 654.35c.03-.56.06-.9.06-.93l-2 .83c0 .04-.04.4-.11 1.05.52-.23 1.03-.46 1.51-.67.19-.09.36-.19.54-.28zm-22.28 10.19c.73-1.07 1.45-2.13 2.16-3.19-1.95.9-3.21 1.48-3.25 1.5l.84 1.81c.01 0 .1-.04.24-.11l.01-.01zm15.99-7.33c.1-.38.15-.59.16-.62l-1.95-.48c-.02.06-.2.82-.55 2.16v.01c.79-.37 1.57-.72 2.34-1.07zm-21.05 343.82c-5.92-11.85-5.24-22.66-3.42-39.06.98-8.83 12.16-53.21 22.02-92.37 7.8-30.94 15.16-60.16 16.71-68.68 3.03-16.68 2.81-49.91 2.69-58.75l-.01-.01c-.26-.73-.52-1.45-.78-2.17l-1.2.02c.02 2.42.05 5.82.04 9.81.03 13.45-.3 37.45-2.71 50.74-1.54 8.46-8.89 37.65-16.68 68.55-9.32 37.02-18.93 75.15-21.49 88.96l1.77.37c-.05.21-.67 2.98-2.62 5.89v.02c-1.63 15.34-1.95 25.89 3.9 37.58 5.18 10.37 17.67 14.59 22.36 15.85.01-.67.02-1.37.04-2.08-4.74-1.36-16.02-5.46-20.62-14.67zm37.21-261.04c-.41-1.11-.82-2.21-1.24-3.3.01.67.03 1.8.04 3.32l1.2-.02z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M851.97 749.82c-.03 14.96-.46 38.35-2.71 50.74 2.41-13.29 2.74-37.29 2.71-50.74zm-.09-13.81c0 .03.01.26.01.68.41 1.09.83 2.19 1.24 3.3l-1.25-3.98zm2 3.96-.75.02c.26.72.52 1.44.78 2.17-.01-1.36-.03-2.14-.03-2.19zm-82.99 277.37c.79.33 1.61.5 2.44.5 1.42 0 2.88-.48 4.37-1.43 8.11-5.15 8.66-30.9 7.61-52.35v-.01c-1.18-1.25-1.9-2.2-2-2.33l1.61-1.19c.01.01.08.11.22.29-.24-4.06-.52-7.9-.81-11.36-1.71-20.42 4.64-123.55 4.94-128.56v-.01c-.8 1.75-1.57 3.47-2.31 5.16v.02c-1.34 22.25-6.14 105.36-4.63 123.56 3.09 37.1 1.02 60.83-5.7 65.1-1.81 1.16-3.44 1.41-4.98.77-2.34-.96-4.12-3.76-5.34-6.44.21 1.65.44 3.36.7 5.1 1.08 1.39 2.37 2.56 3.88 3.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M789.27 820.87c.01-.09.01-.14.01-.16l-1.99-.13c-.01.14-.13 2.11-.33 5.46.74-1.69 1.51-3.41 2.31-5.16v-.01zm11.58 147.96c-7.29 1.91-14.37-6.36-15.71-8.02v.01c.06 1.06.12 2.13.17 3.23 2.65 2.79 7.62 7.08 13.28 7.08.91 0 1.83-.11 2.77-.36 4.38-1.15 7.15-3.85 8.88-6.44.09-.84.18-1.71.28-2.58.1-.9.3-2.14.58-3.68l-.19-.04c-.03.08-1.93 8.67-10.06 10.8z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Thigh");
	            },
	            className: "bodyLines",
	            d: "M810.51 961.75c-.1.87-.19 1.74-.28 2.58 1.95-2.91 2.58-5.68 2.62-5.89l-1.77-.37c-.27 1.54-.47 2.78-.57 3.68zm-25.37-.94c-.14-.17-.22-.28-.22-.29l-1.61 1.19c.1.13.82 1.08 2 2.33-.05-1.09-.11-2.17-.17-3.23z"
	          }),
	          this.state.bodyTitle === "Left Thigh" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "861",
	              width: "185",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M844.206 883.721h250" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1119.95 893.037v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.63-5.941 4.922.826c-.633 1.804-1.632 3.178-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.433 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.036 1.465.434 2.604 1.196 3.419.761.814 1.711 1.221 2.847 1.221.774 0 1.424-.21 1.951-.632.528-.422.926-1.102 1.196-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.567-1.117-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.852-1.037 3.199h7.383Zm6.759-7.734h2.742v-1.406c0-1.571.167-2.742.501-3.516.334-.773.949-1.403 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.633l-.668 3.445a9.783 9.783 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.975-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.72 0v3.938h-3.375v7.523c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.474l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.15-2.409-.448-.715-.299-1.239-.686-1.573-1.161-.334-.474-.565-1.116-.694-1.924-.106-.575-.158-1.735-.158-3.481v-8.138h-2.268v-3.938h2.268v-3.709l4.957-2.883v6.592h3.375Zm19.26 18.668v-21.41h-7.646v-4.36h20.478v4.36h-7.629v21.41h-5.203Zm21.08-25.77v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.117.999-1.415 1.802-.299.803-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm17.07 4.571v-4.571h4.939v4.571h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.54 1.23 5.642.686c.094.656.311 1.107.651 1.354.468.351 1.207.527 2.214.527 1.29 0 2.256-.194 2.901-.58.433-.258.762-.674.984-1.248.153-.41.229-1.166.229-2.268v-2.724c-1.477 2.015-3.34 3.023-5.59 3.023-2.508 0-4.494-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.181 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.656.621-1.532 1.107-2.628 1.459-1.096.351-2.481.527-4.157.527-3.164 0-5.408-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.018-.598Zm4.412-10.951c0 1.981.384 3.431 1.151 4.351.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.472 3.059-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.399-3.369-1.196-4.306-.797-.938-1.804-1.407-3.023-1.407-1.184 0-2.159.46-2.927 1.38-.767.92-1.151 2.324-1.151 4.21Zm22.958-16.049v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.656.78 1.383.95 2.18.169.797.254 2.033.254 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.281-3.727a2.454 2.454 0 0 0-.993-1.257c-.475-.31-1.07-.466-1.785-.466-.82 0-1.552.2-2.197.598-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.559v9.352h-4.94v-25.77h4.94Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Right Knee" ? "bodyParts_group Right_Knee body_parts_active" : "bodyParts_group Right_Knee"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyParts",
	            d: "M712.54 1165.08c1.05 53.98 3.37 118.22 5.05 122.15.57 1.34 1.21 2.1 1.8 2.13h.05c.71 0 1.57-.88 2.12-1.62-1.45-5.65-2.29-11.56-1.81-16.4.51-5.14 4.62-50.7 7.6-91.45-7.08-3.27-12.19-10.42-14.81-14.81zm-.08-4.34v.01c.75 1.51 6.34 12.5 15.05 16.97 2.05-28.28 3.52-53.83 2.8-61.34-1.46-15.36-4.13-50.77-3.48-67.37-3.65 6.05-13.06 23.62-14.45 45.86-.61 9.86-.48 35.96.08 65.87zm-36.36 9.22c-10.09-30.25-15.23-89.5-17.08-115.56-1.98 11.49-3.98 23.21-4.42 32.05-.89 17.6.88 52.82 7.04 79.23 6.16 26.42 14.97 74.84 18.48 99.49 2.3 16.08 1.23 26.17.7 33.93 5.46-3.7 13.09-6.81 18.3-8.72.84-10.44-10.32-82.32-23.02-120.42z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyParts",
	            d: "M701.16 1289.67c1.36-.48 2.43-.82 3.08-1.03.19-6.93 1.62-62.01-.01-77.51-1.8-17.1-19.4-123.34-24.63-144.25-4.04-16.17-13.95-24.92-17.99-27.91-.35 2.29-.74 4.66-1.15 7.08 0 .02.01.04 0 .07 1.19 18.73 6.25 89.36 17.54 123.21 12.75 38.26 23.45 106.93 23.16 120.34z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyParts",
	            d: "M729.11 1017.34c-.8.33-1.61.5-2.45.5-1.41 0-2.88-.48-4.37-1.43-8.1-5.15-8.65-30.9-7.6-52.36-2.64 2.79-7.63 7.08-13.28 7.08-.91 0-1.83-.11-2.77-.36-4.37-1.15-7.14-3.85-8.88-6.43v.01c1.63 15.34 1.95 25.89-3.9 37.58-5.18 10.36-17.66 14.59-22.36 15.85.03 2.25 0 4.32-.1 6.16-.2 3.66-.74 8.03-1.46 12.8 3.61 2.45 15.04 11.45 19.59 29.65 5.24 20.96 22.87 127.4 24.68 144.53 1.56 14.92.33 65.94.05 76.55 2.58-.72 6.74-.59 9.23-.42-2.71-14.69-6.81-165.12-5.11-192.31 1.75-28.12 16.1-48.95 16.25-49.15l.37.26c.16-1.86.37-3.33.67-4.31 1.58-5.27 3.79-16.86 5.31-27.39-1.07 1.4-2.36 2.57-3.87 3.19z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyLines",
	            d: "M679.6 1066.88c5.23 20.91 22.83 127.15 24.63 144.25 1.63 15.5.2 70.58.01 77.51.36-.53 1.09-.91 2.03-1.17.28-10.6 1.51-61.62-.05-76.55-1.81-17.13-19.44-123.57-24.68-144.53-4.55-18.2-15.98-27.2-19.59-29.65-.1.73-.21 1.47-.34 2.23 4.04 2.99 13.95 11.74 17.99 27.91zm19.52 223.5c.73-.26 1.42-.5 2.04-.71.29-13.41-10.41-82.08-23.16-120.34-11.29-33.85-16.35-104.48-17.54-123.21-.46 2.71-.95 5.48-1.44 8.26v.02c1.85 26.06 6.99 85.31 17.08 115.56 12.7 38.1 23.86 109.98 23.02 120.42zm11.27-195.64c-1.7 27.19 2.4 177.62 5.11 192.31 1.25.09 2.09.18 2.09.18-1.68-3.93-4-68.17-5.05-122.15v-.01c-1.21-2.02-1.88-3.46-1.97-3.66l1.81-.84c0 .01.03.07.08.17-.56-29.91-.69-56.01-.08-65.87 1.39-22.24 10.8-39.81 14.45-45.86.05-1.15.11-2.2.18-3.16l-.37-.26c-.15.2-14.5 21.03-16.25 49.15z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyLines",
	            d: "M712.46 1160.75c.02 1.43.05 2.87.08 4.32v.01c2.62 4.39 7.73 11.54 14.81 14.81.05-.72.11-1.44.16-2.16v-.01c-8.71-4.47-14.3-15.46-15.05-16.97z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Knee");
	            },
	            className: "bodyLines",
	            d: "M712.46 1160.74c-.05-.1-.08-.16-.08-.17l-1.81.84c.09.2.76 1.64 1.97 3.66-.03-1.45-.06-2.89-.08-4.32v-.01z"
	          }),
	          this.state.bodyTitle === "Right Knee" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "175",
	              y: "1129",
	              width: "205",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup is_right" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M405 1150.16h260" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M193.957 1159.25v-25.769h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.184 1.125 2.537 1.125 4.061 0 1.933-.568 3.53-1.705 4.79-1.137 1.259-2.836 2.053-5.098 2.381 1.125.657 2.054 1.377 2.786 2.162.733.786 1.72 2.18 2.962 4.184l3.147 5.027h-6.223l-3.762-5.607c-1.336-2.004-2.25-3.267-2.742-3.788-.492-.522-1.014-.879-1.564-1.072-.551-.194-1.424-.29-2.619-.29h-1.055v10.757h-5.203Zm5.203-14.871h3.849c2.497 0 4.055-.105 4.676-.316a2.8 2.8 0 0 0 1.459-1.09c.352-.516.528-1.16.528-1.934 0-.867-.232-1.567-.695-2.1-.463-.533-1.116-.87-1.96-1.011-.422-.058-1.687-.088-3.797-.088h-4.06v6.539Zm20.742-6.329v-4.57h4.939v4.57h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.545 1.231 5.643.685c.093.657.31 1.108.65 1.354.469.352 1.207.527 2.215.527 1.289 0 2.256-.193 2.9-.58.434-.258.762-.674.985-1.248.152-.41.228-1.166.228-2.267v-2.725c-1.477 2.016-3.34 3.023-5.59 3.023-2.508 0-4.494-1.06-5.959-3.181-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.753-5.52 2.258-7.172 1.506-1.652 3.378-2.478 5.617-2.478 2.308 0 4.212 1.013 5.712 3.041v-2.62h4.624v16.752c0 2.204-.182 3.85-.545 4.94-.364 1.09-.873 1.945-1.53 2.566-.656.621-1.532 1.108-2.628 1.459-1.095.352-2.481.528-4.157.528-3.164 0-5.408-.542-6.732-1.626-1.325-1.084-1.987-2.458-1.987-4.122 0-.165.006-.364.018-.598Zm4.412-10.951c0 1.98.384 3.43 1.151 4.35.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.471 3.059-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.398-3.369-1.195-4.307-.797-.937-1.805-1.406-3.024-1.406-1.183 0-2.159.46-2.927 1.38-.767.92-1.151 2.323-1.151 4.21Zm22.957-16.049v9.475c1.594-1.864 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.632.914.422 1.603.961 2.066 1.618.462.656.779 1.382.949 2.179.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.094-3.199-.281-3.726a2.446 2.446 0 0 0-.993-1.257c-.475-.311-1.07-.466-1.784-.466-.821 0-1.553.199-2.198.598-.644.398-1.116.999-1.415 1.801-.298.803-.448 1.99-.448 3.56v9.351h-4.939v-25.769h4.939Zm25.629 7.11v3.938h-3.375v7.523c0 1.524.032 2.412.097 2.663.064.252.211.46.439.625.229.164.507.246.835.246.457 0 1.119-.159 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.693-.149-2.408-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.566-1.116-.695-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm13.535 18.66v-25.769h5.203v11.443l10.512-11.443h6.996l-9.703 10.037 10.23 15.732h-6.732l-7.084-12.093-4.219 4.306v7.787h-5.203Zm42.873 0h-4.939v-9.527c0-2.016-.106-3.319-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.548 3.548 0 0 0-1.397 1.863c-.252.774-.378 2.203-.378 4.289v8.455h-4.939v-18.668h4.587v2.743c1.629-2.11 3.68-3.164 6.153-3.164 1.09 0 2.086.196 2.988.588.902.393 1.585.894 2.048 1.503.463.61.785 1.301.967 2.075.181.773.272 1.88.272 3.322v11.601Zm15.821-5.94 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.268 1.618-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.405-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Zm19.74 4.992 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.671 1.178-.704.785-1.049 1.851-1.038 3.199h7.383Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Left Knee" ? "bodyParts_group Left_Knee body_parts_active" : "bodyParts_group Left_Knee"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Knee");
	            },
	            className: "bodyParts",
	            d: "M780.6 1289.36c.26-.22.57-.41.92-.58.31-.36.61-.88.89-1.55 1.68-3.93 4-68.18 5.06-122.17-2.62 4.39-7.73 11.54-14.82 14.82v.01c2.98 40.75 7.09 86.31 7.6 91.45.48 4.84-.36 10.75-1.81 16.4.58.76 1.47 1.67 2.16 1.62zm6.94-128.64v-.01c.55-29.9.69-55.98.07-65.84-1.39-22.22-10.78-39.77-14.44-45.84.65 16.61-2.03 51.99-3.49 67.35-.71 7.51.76 33.07 2.81 61.35 8.77-4.5 14.38-15.61 15.05-17.01zm32.86-93.84c-5.23 20.91-22.83 127.14-24.63 144.25-1.63 15.5-.2 70.58-.02 77.51.66.21 1.73.56 3.09 1.03-.29-13.41 10.41-82.08 23.16-120.34 11.3-33.91 16.37-104.71 17.54-123.3-.01-.01-.01-.01 0-.02-.01-.01-.01-.02 0-.03v-.01c-.41-2.4-.8-4.72-1.15-7-4.04 2.99-13.95 11.74-17.99 27.91z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Knee");
	            },
	            className: "bodyParts",
	            d: "M800.88 1290.39c5.21 1.9 12.84 5.01 18.3 8.71-.54-7.76-1.61-17.85.69-33.93 3.52-24.65 12.32-73.07 18.49-99.49 6.16-26.41 7.93-61.63 7.03-79.23-.44-8.83-2.43-20.54-4.42-32.02-1.85 26.07-6.99 85.29-17.07 115.53-12.71 38.12-23.87 110.03-23.02 120.43zm13.25-288.46c-5.85-11.69-5.53-22.24-3.9-37.58v-.02c-1.73 2.59-4.5 5.29-8.88 6.44-.94.25-1.86.36-2.77.36-5.65 0-10.63-4.28-13.28-7.08v.01c1.05 21.45.5 47.2-7.61 52.35-1.49.95-2.95 1.43-4.37 1.43-.83 0-1.65-.17-2.44-.5-1.51-.62-2.8-1.79-3.88-3.19 1.52 10.53 3.73 22.12 5.31 27.39.3.98.51 2.45.67 4.31l.37-.26c.15.2 14.49 21.03 16.25 49.15 1.75 28.02-2.66 186.97-5.36 193.28v.01c3.14-.45 7.13-.04 9.49.29-.22-8.33-1.58-62.02.04-77.4 1.8-17.14 19.44-123.57 24.68-144.53 4.55-18.2 15.98-27.2 19.59-29.65-.72-4.77-1.26-9.14-1.46-12.8-.1-1.84-.13-3.91-.1-6.16-4.68-1.26-17.17-5.48-22.35-15.85z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Knee");
	            },
	            className: "bodyLines",
	            d: "M818.46 1066.39c-5.24 20.96-22.88 127.39-24.68 144.53-1.62 15.38-.26 69.07-.04 77.4 1.22.17 2.01.32 2.01.32-.18-6.93-1.61-62.01.02-77.51 1.8-17.11 19.4-123.34 24.63-144.25 4.04-16.17 13.95-24.92 17.99-27.91-.13-.76-.24-1.5-.34-2.23-3.61 2.45-15.04 11.45-19.59 29.65zm-19.62 223.28c.62.21 1.31.46 2.04.72-.85-10.4 10.31-82.31 23.02-120.43 10.08-30.24 15.22-89.46 17.07-115.53 0-.02.01-.03 0-.05-.48-2.81-.97-5.61-1.43-8.35-1.17 18.59-6.24 89.39-17.54 123.3-12.75 38.26-23.45 106.93-23.16 120.34zm-11.3-128.96c.04-.08.07-.13.07-.14l1.82.84c-.09.2-.76 1.63-1.96 3.65-1.06 53.99-3.38 118.24-5.06 122.17-.28.67-.59 1.19-.89 1.55.76-.37 1.7-.61 2.73-.76v-.01c2.7-6.31 7.11-165.26 5.36-193.28-1.76-28.12-16.1-48.95-16.25-49.15l-.37.26c.08.96.14 2.02.18 3.18 3.66 6.07 13.05 23.62 14.44 45.84.62 9.87.48 35.95-.07 65.85z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Knee");
	            },
	            className: "bodyLines",
	            d: "M787.47 1165.06c.02-1.46.05-2.9.07-4.34-.67 1.4-6.28 12.51-15.05 17.01.05.72.1 1.42.16 2.15 7.09-3.28 12.2-10.43 14.82-14.82z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Knee");
	            },
	            className: "bodyLines",
	            d: "M787.61 1160.57c0 .01-.03.06-.07.14v.01c-.02 1.44-.05 2.88-.07 4.34 1.2-2.02 1.87-3.45 1.96-3.65l-1.82-.84z"
	          }),
	          this.state.bodyTitle === "Left Knee" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "1127",
	              width: "175",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M834.206 1146.36h260" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1119.95 1159.25v-25.558h5.203v21.217h12.937v4.341h-18.14Zm32.63-5.94 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.643 2.302 8.428h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm6.759-7.728h2.742v-1.406c0-1.57.167-2.742.501-3.515.334-.774.949-1.404 1.846-1.89.896-.486 2.03-.73 3.401-.73 1.406 0 2.783.211 4.131.633l-.668 3.446a9.732 9.732 0 0 0-2.268-.282c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.72 0v3.938h-3.375v7.523c0 1.524.032 2.412.096 2.663.065.252.211.46.44.625.228.164.507.246.835.246.457 0 1.119-.159 1.986-.475l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm13.53 18.66v-25.769h5.203v11.443l10.512-11.443h6.996l-9.703 10.037 10.23 15.732h-6.732l-7.084-12.093-4.219 4.306v7.787h-5.203Zm42.87 0h-4.94v-9.527c0-2.016-.105-3.319-.316-3.911-.211-.592-.554-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492a3.96 3.96 0 0 0-2.303.703 3.537 3.537 0 0 0-1.397 1.863c-.252.774-.378 2.203-.378 4.289v8.455h-4.94v-18.668h4.588v2.743c1.629-2.11 3.68-3.164 6.152-3.164 1.09 0 2.086.196 2.989.588.902.393 1.585.894 2.048 1.503a5.45 5.45 0 0 1 .966 2.075c.182.773.273 1.88.273 3.322v11.601Zm15.82-5.94 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.926-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.566-1.116-1.079 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.382Zm19.749 4.992 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.268 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428H1267.4c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Right Ankle" ? "bodyParts_group Right_Ankle body_parts_active" : "bodyParts_group Right_Ankle"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Ankle");
	            },
	            className: "bodyParts",
	            d: "M719.28 1291.36c-.67-.04-1.28-.31-1.84-.81-4.45-1.63-9.12-.95-12.05-.18-.34.11-1.42.45-2.97.98-5.17 1.78-15.63 5.7-21.76 10.29v.01c-.15 3.05-.12 5.76.36 8.41 1.75 9.69 4.39 9.69.87 18.49-3.52 8.8-23.77 31.7-21.13 37.87 2.65 6.15 23.77 3.51 35.22 4.39 11.45.88 17.6 5.29 22.01-3.51 4.4-8.81 3.52-6.17 6.16-11.46 2.65-5.27.89-30.81 0-36.09-.88-5.28 5.28-11.45 1.77-19.37-1.32-2.97-2.64-6.55-3.73-10.33-.73.69-1.68 1.3-2.75 1.3h-.16z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Ankle");
	            },
	            className: "bodyLines",
	            d: "M704.24 1288.64c-.65.21-1.72.55-3.08 1.03-.01.47-.03.87-.07 1.2l-1.99-.22c.01-.08.02-.17.02-.27-5.21 1.91-12.84 5.02-18.3 8.72-.06.88-.12 1.73-.16 2.55 6.13-4.59 16.58-8.51 21.76-10.29l1.82-2.72z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Ankle");
	            },
	            className: "bodyLines",
	            d: "M705.39 1290.37c-1.8.47-2.94.97-2.97.98 1.55-.53 2.63-.87 2.97-.98zm-6.29.28 1.99.22c.04-.33.06-.73.07-1.2-.62.21-1.31.45-2.04.71 0 .1-.01.19-.02.27zm20.34-1.29h-.05c-.59-.03-1.23-.79-1.8-2.13l1.69 4.13h.16c1.07 0 2.02-.61 2.75-1.3-.22-.77-.43-1.54-.63-2.32-.55.74-1.41 1.62-2.12 1.62zm-.16 2c-.61-.32-1.22-.58-1.84-.81.56.49 1.17.77 1.84.81zm-13.08-1.23-.69.21c-.01 0-.06.02-.12.04 2.93-.77 7.6-1.45 12.05.18-.64-.56-1.2-1.4-1.69-2.53-.08-.19-.16-.52-.25-.97-2.5-.17-6.66-.3-9.23.42-.03 1.19-.05 1.88-.05 1.94l-.02.71z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Right Ankle");
	            },
	            className: "bodyLines",
	            d: "m704.24 1288.64-1.82 2.72c.02-.01 1.17-.51 2.97-.98.07-.02.11-.04.12-.04l.69-.21.02-.72c0-.06.02-.75.05-1.94-.94.26-1.67.63-2.03 1.17zm-1.82 2.72v-.01.01zm15.02-.81c.62.23 1.24.48 1.84.81l-1.69-4.13s-.83-.09-2.09-.18c.08.45.17.78.25.97.49 1.13 1.05 1.97 1.69 2.53z"
	          }),
	          this.state.bodyTitle === "Right Ankle" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "167",
	              y: "1332",
	              width: "210",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup is_right" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M405 1353.94h270" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M185.291 1363.04v-25.77h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.184 1.125 2.537 1.125 4.061 0 1.933-.568 3.53-1.705 4.79-1.137 1.259-2.836 2.053-5.098 2.382 1.125.656 2.054 1.376 2.786 2.162.733.785 1.72 2.179 2.962 4.183l3.147 5.028h-6.223l-3.762-5.608c-1.336-2.004-2.25-3.266-2.742-3.788-.492-.521-1.014-.879-1.564-1.072-.551-.194-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.872h3.849c2.497 0 4.055-.105 4.676-.316a2.8 2.8 0 0 0 1.459-1.09c.352-.515.528-1.16.528-1.933 0-.868-.232-1.568-.695-2.101-.463-.533-1.116-.87-1.96-1.011-.422-.058-1.687-.088-3.797-.088h-4.06v6.539Zm20.742-6.328v-4.57h4.939v4.57h-4.939Zm0 21.2v-18.668h4.939v18.668h-4.939Zm9.545 1.23 5.643.686c.093.656.31 1.107.65 1.353.469.352 1.207.527 2.215.527 1.289 0 2.256-.193 2.9-.58.434-.257.762-.673.985-1.248.152-.41.228-1.166.228-2.267v-2.725c-1.477 2.016-3.34 3.024-5.59 3.024-2.508 0-4.494-1.061-5.959-3.182-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.752-5.519 2.258-7.172 1.506-1.652 3.378-2.478 5.617-2.478 2.308 0 4.212 1.013 5.712 3.041v-2.619h4.623v16.752c0 2.203-.181 3.849-.544 4.939-.364 1.09-.873 1.945-1.53 2.566-.656.621-1.532 1.108-2.628 1.459-1.095.352-2.481.528-4.157.528-3.164 0-5.408-.542-6.732-1.626-1.325-1.084-1.987-2.458-1.987-4.122 0-.164.006-.364.018-.598Zm4.412-10.951c0 1.98.384 3.431 1.151 4.35.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.471 3.059-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.399-3.369-1.195-4.307-.797-.937-1.805-1.406-3.024-1.406-1.183 0-2.159.46-2.927 1.38-.767.92-1.151 2.323-1.151 4.21Zm22.957-16.049v9.475c1.594-1.864 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.421 1.603.96 2.066 1.617.462.656.779 1.383.949 2.179.17.797.255 2.034.255 3.709v10.952h-4.94v-9.862c0-1.957-.094-3.199-.281-3.726a2.446 2.446 0 0 0-.993-1.257c-.475-.311-1.07-.466-1.784-.466-.821 0-1.553.199-2.198.598-.644.398-1.116.999-1.415 1.801-.298.803-.448 1.99-.448 3.56v9.352h-4.939v-25.77h4.939Zm25.629 7.1v3.937h-3.375v7.524c0 1.523.032 2.411.097 2.663.064.252.211.46.439.624.229.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.693-.149-2.408-.448-.715-.299-1.24-.685-1.573-1.16-.334-.475-.566-1.116-.695-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm35.367 18.67h-5.66l-2.25-5.854h-10.301l-2.127 5.854h-5.519l10.037-25.77h5.502l10.318 25.77Zm-9.58-10.196-3.551-9.562-3.48 9.562h7.031Zm29.285 10.196h-4.939v-9.528c0-2.015-.106-3.319-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.548 3.548 0 0 0-1.397 1.863c-.252.774-.378 2.204-.378 4.289v8.456h-4.939v-18.668h4.588v2.742c1.628-2.11 3.679-3.164 6.152-3.164 1.09 0 2.086.196 2.988.589.902.392 1.585.893 2.048 1.503.463.609.785 1.3.967 2.074.181.773.272 1.881.272 3.322v11.602Zm4.834 0v-25.77h4.94v13.676l5.783-6.574h6.082l-6.381 6.82 6.838 11.848h-5.326l-4.694-8.385-2.302 2.408v5.977h-4.94Zm20.198-25.77h4.939v25.77h-4.939zm20.812 19.82 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.699-1.846-3.844-1.846-6.434 0-3.094.809-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.393-2.671 1.178-.704.785-1.049 1.851-1.038 3.199h7.383Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Left Ankle" ? "bodyParts_group Left_Ankle body_parts_active" : "bodyParts_group Left_Ankle"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Ankle");
	            },
	            className: "bodyParts",
	            d: "M781.93 1291c-.38.21-.78.34-1.21.36h-.16c-1.07 0-2.02-.61-2.75-1.3-1.09 3.78-2.41 7.36-3.73 10.33-3.52 7.92 2.65 14.09 1.77 19.37-.89 5.28-2.65 30.82 0 36.09 2.64 5.29 1.76 2.65 6.16 11.46 4.4 8.8 10.56 4.39 22.01 3.51 11.44-.88 32.57 1.76 35.22-4.39 2.64-6.17-17.61-29.07-21.14-37.87-3.51-8.8-.88-8.8.88-18.49.48-2.65.51-5.37.35-8.42-6.77-5.07-18.83-9.33-23.2-10.78-5.32-1.92-11.62-.58-14.2.13z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Ankle");
	            },
	            className: "bodyLines",
	            d: "m800.9 1290.65-1.99.22c-.04-.33-.06-.73-.07-1.2-1.36-.47-2.43-.82-3.09-1.03l.38 2.23c4.38 1.45 16.43 5.72 23.2 10.78-.03-.82-.09-1.67-.15-2.55-5.46-3.7-13.09-6.81-18.3-8.71 0 .09.01.18.02.26z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Ankle");
	            },
	            className: "bodyLines",
	            d: "M800.9 1290.65c-.01-.08-.02-.17-.02-.26-.73-.26-1.42-.51-2.04-.72.01.47.03.87.07 1.2l1.99-.22zm-18.97.35c-.75.21-1.21.36-1.21.36.43-.03.83-.16 1.21-.36z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Ankle");
	            },
	            className: "bodyLines",
	            d: "m780.72 1291.36-.12-2c-.69.05-1.58-.86-2.16-1.62-.2.78-.41 1.55-.63 2.32.73.69 1.68 1.3 2.75 1.3h.16zm1.21-.36c2.58-.71 8.88-2.05 14.2-.13-1.01-.33-1.61-.52-1.65-.53l-.68-.21-.03-.72c0-.05-.01-.43-.03-1.09-2.36-.33-6.36-.74-9.49-.29-.65 1.49-1.42 2.47-2.32 2.97zm-.41-2.22c-.34.17-.65.36-.92.58.3-.02.61-.22.92-.58z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Left Ankle");
	            },
	            className: "bodyLines",
	            d: "m793.8 1290.13.68.21c.04.01.64.2 1.65.53l-.38-2.23s-.79-.15-2.01-.32c.02.66.03 1.05.03 1.09l.03.72zm-13.2-.77.12 2s.45-.15 1.21-.36c.9-.49 1.67-1.48 2.32-2.97-1.03.15-1.97.39-2.73.76-.31.35-.62.55-.92.57z"
	          }),
	          this.state.bodyTitle === "Left Ankle" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "1330",
	              width: "185",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M824.206 1350.14h270" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1119.95 1363.04v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.63-5.95 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.699-1.846-3.844-1.846-6.434 0-3.094.808-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.643 2.302 8.428h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm6.759-7.728h2.742v-1.407c0-1.57.167-2.742.501-3.515.334-.774.949-1.404 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.632l-.668 3.446a9.732 9.732 0 0 0-2.268-.282c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.319h3.692v3.884h-3.692v14.784h-4.939v-14.784h-2.742v-3.884Zm22.72 0v3.937h-3.375v7.524c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm35.36 18.67h-5.66l-2.25-5.854h-10.301l-2.127 5.854h-5.52l10.037-25.77h5.502l10.319 25.77Zm-9.58-10.196-3.551-9.562-3.481 9.562h7.032Zm29.29 10.196h-4.94v-9.528c0-2.015-.105-3.319-.316-3.911-.211-.592-.554-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492a3.96 3.96 0 0 0-2.303.703 3.542 3.542 0 0 0-1.397 1.863c-.252.774-.378 2.204-.378 4.289v8.456h-4.94v-18.668h4.588v2.742c1.629-2.11 3.68-3.164 6.152-3.164 1.09 0 2.086.196 2.989.589.902.392 1.585.893 2.048 1.503.462.609.785 1.3.966 2.074.182.773.273 1.881.273 3.322v11.602Zm4.83 0v-25.77h4.939v13.676l5.783-6.574h6.083l-6.381 6.82 6.838 11.848h-5.327l-4.693-8.385-2.303 2.408v5.977h-4.939Zm20.2-25.77h4.939v25.77h-4.939zm20.81 19.82 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.699-1.845-3.844-1.845-6.434 0-3.094.808-5.516 2.425-7.268 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.393-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Chest" ? "bodyParts_group Chest body_parts_active" : "bodyParts_group Chest"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyParts",
	            d: "M749.04 393.88c-.4-7.69-1.22-14.33-2.5-18.07-4.38-12.76-8.23-21.56-21.45-27.21-12.44-5.31-38.88-7.38-53.7 1.34-11.11 6.53-14.57 13.34-15.26 14.94.81 1.7 3.97 8.6 6.88 18.42 1.53 5.17-.81 16.02-3.07 26.51-1.39 6.42-2.69 12.5-3.03 16.82-1.43 18.63 15.9 23.59 48.39 26.22 19.18 1.56 32.52-1.88 39.66-10.22 2.08-2.42 3.48-12.46 4.06-24.22-.4-8.06-.39-16.83.02-24.53z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M656.9 435.56c-.01.03-.14.71-.28 1.86v.03c5.35 11.43 22.53 15.29 48.52 17.4 2.43.19 4.76.31 7.01.34 1.99-1.09 3.2-1.79 3.27-1.83l1.02 1.72c-.04.02-.1.06-.17.1 8.08-.23 14.86-1.58 20.33-4.05 1.64-1.05 2.88-1.71 3.55-1.88 2.45-1.5 4.56-3.27 6.33-5.33 1.22-1.43 2.21-4.8 2.96-9.36v-9.54c-.18-2.12-.32-4.34-.42-6.62-.58 11.76-1.98 21.8-4.06 24.22-7.14 8.34-20.48 11.78-39.66 10.22-32.49-2.63-49.82-7.59-48.39-26.22.34-4.32 1.64-10.4 3.03-16.82 2.26-10.49 4.6-21.34 3.07-26.51-2.91-9.82-6.07-16.72-6.88-18.42.69-1.6 4.15-8.41 15.26-14.94 14.82-8.72 41.26-6.65 53.7-1.34 13.22 5.65 17.07 14.45 21.45 27.21 1.28 3.74 2.1 10.38 2.5 18.07.1-2.04.24-4 .4-5.86v-8.78c-.3-1.6-.64-2.98-1.01-4.07-4.41-12.87-8.61-22.44-22.55-28.4-7.21-3.08-19.19-5.25-31.1-4.75l.02.01-.72 1.86c-.05-.02-1.6-.62-4-1.52h-.01c-7.19.75-14.11 2.57-19.69 5.85-13.37 7.86-16.18 16.05-16.29 16.39l1.45.33c-.01.05-.2.87-.54 2.28 1.23 2.74 3.58 8.35 5.83 15.79l1.63.53c-.03.09-.38 1.18-.98 3.08v.01c.23 5.49-1.73 14.57-3.5 22.75-1.39 6.5-2.72 12.64-3.06 17.1-.26 3.31.04 6.24.86 8.81l.01.04 1.11.24z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "m654.09 364.61-.13.39.18.37c.01.02.33.66.86 1.85.34-1.41.53-2.23.54-2.28l-1.45-.33zm40.71-22.59s-.01-.01-.02-.01c-1.58.07-3.14.18-4.7.35 2.4.9 3.94 1.5 4 1.52l.72-1.86zm-39.01 93.31c-.01-.02-.01-.03-.01-.04l-.84-3.14c-.06.31-.73 4.61-.66 10.29.04-4.18.6-7.01.66-7.29l.85.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "m655.79 435.33-.01-.04c.01.01.01.02.01.04zm0 0c.23.74.51 1.41.83 2.09.14-1.15.27-1.83.28-1.86l-1.11-.23zm5.04-52.32c.09.28.17.57.26.86.22.76.35 1.69.39 2.75.6-1.9.95-3 .98-3.08l-1.63-.53z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyParts",
	            d: "M750.98 418.53c.58 11.71 1.98 21.69 4.05 24.1 7.15 8.34 20.5 11.77 39.66 10.22 32.49-2.63 49.82-7.59 48.39-26.22-.33-4.32-1.64-10.4-3.02-16.83-2.26-10.49-4.6-21.33-3.07-26.5 2.91-9.82 6.07-16.72 6.88-18.42-.7-1.6-4.15-8.41-15.26-14.94-7.22-4.25-17.2-5.93-26.97-5.93-10.29 0-20.36 1.87-26.74 4.59-13.21 5.65-17.07 14.45-21.44 27.21-1.28 3.73-2.1 10.33-2.5 18 .41 7.76.42 16.6.02 24.72z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyParts",
	            d: "M750.98 418.53c.4-8.12.39-16.96-.02-24.72-.41 7.78-.39 16.66.02 24.72zm-1.54 6.5v9.54c.21-1.23.39-2.56.56-3.95-.22-1.76-.4-3.63-.56-5.59zm.56-42.24c-.17-1.28-.35-2.47-.56-3.55v8.78c.16-1.86.34-3.62.56-5.23z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M749.04 393.88c-.41 7.7-.42 16.47-.02 24.53.4-8 .42-16.8.02-24.53z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M749.04 393.88c.4 7.73.38 16.53-.02 24.53.1 2.28.24 4.5.42 6.62v-37.01c-.16 1.86-.3 3.82-.4 5.86zm90.13-10.87c2.26-7.44 4.6-13.06 5.83-15.8-.34-1.4-.53-2.22-.54-2.27l1.46-.34v-.01c-.15-.43-3.01-8.57-16.29-16.38-5.58-3.28-12.51-5.11-19.7-5.85h-.01c-2.4.9-3.94 1.5-3.99 1.52l-.72-1.86s.01 0 .02-.01c-11.91-.5-23.89 1.66-31.1 4.75-13.95 5.96-18.14 15.53-22.55 28.4-.37 1.09-.71 2.47-1.01 4.07v8.78c.16 1.83.29 3.78.4 5.79.4-7.67 1.22-14.27 2.5-18 4.37-12.76 8.23-21.56 21.44-27.21 6.38-2.72 16.45-4.59 26.74-4.59 9.77 0 19.75 1.68 26.97 5.93 11.11 6.53 14.56 13.34 15.26 14.94-.81 1.7-3.97 8.6-6.88 18.42-1.53 5.17.81 16.01 3.07 26.5 1.38 6.43 2.69 12.51 3.02 16.83 1.43 18.63-15.9 23.59-48.39 26.22-19.16 1.55-32.51-1.88-39.66-10.22-2.07-2.41-3.47-12.39-4.05-24.1-.11 2.23-.25 4.41-.42 6.5v9.54c.75 4.56 1.74 7.93 2.96 9.36 1.76 2.06 3.88 3.83 6.33 5.33.68.17 1.91.83 3.54 1.87 5.47 2.47 12.25 3.82 20.33 4.05h.01c-.07-.04-.14-.08-.17-.1l1.02-1.72c.07.04 1.28.75 3.27 1.83 2.25-.03 4.59-.15 7.02-.34 25.99-2.11 43.17-5.97 48.52-17.4.01-.01 0-.02 0-.02-.14-1.15-.27-1.83-.28-1.86l1.11-.23.59-2.42c.36-1.96.47-4.09.28-6.43-.35-4.46-1.67-10.6-3.07-17.1-1.76-8.18-3.72-17.26-3.49-22.75-.6-1.91-.96-3.01-.98-3.1l1.61-.52zm-88.61 51.56v-9.54c-.16 1.96-.34 3.83-.56 5.59.17 1.39.35 2.72.56 3.95zm0-46.55v-8.78c-.21 1.08-.39 2.27-.56 3.55.22 1.61.4 3.37.56 5.23z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M750.98 418.53c-.41-8.06-.43-16.94-.02-24.72-.11-2.01-.24-3.96-.4-5.79v37.01c.17-2.09.31-4.27.42-6.5zm-1.54-30.51v37.01c.16 1.96.34 3.83.56 5.59.22-1.76.4-3.63.56-5.59v-37.01c-.16-1.86-.34-3.62-.56-5.23-.22 1.61-.4 3.37-.56 5.23zM845 367.21v-.01c.52-1.17.84-1.81.85-1.83l.19-.37-.13-.39-1.46.34c.02.04.21.86.55 2.26zm-39.08-23.32c.05-.02 1.59-.62 3.99-1.52-1.56-.17-3.12-.28-4.69-.35-.01.01-.02.01-.02.01l.72 1.86zm38.29 91.44.85-.18c.06.29.65 3.27.66 7.65.23-7.66-.45-13.94-.37-12.18l-.55 2.29c-.16.83-.34 1.65-.59 2.42z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M844.21 435.33c.25-.77.43-1.59.59-2.42l-.59 2.42zm-1.11.23c.01.03.14.71.28 1.86.32-.68.6-1.36.83-2.09l-1.11.23zm-4.58-48.94c.04-1.06.16-1.99.39-2.75.09-.29.17-.58.26-.86l-1.63.53c.03.09.38 1.19.98 3.1v-.02z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyParts",
	            d: "M749.44 456.52v-21.95c-.75 4.56-1.74 7.93-2.96 9.36-1.77 2.06-3.89 3.83-6.33 5.33.03-.01.07-.02.09-.03 4.33-.87 7.71 4.78 9.2 7.29z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M713.81 455.21c.83 0 1.65-.01 2.46-.03.07-.04.14-.08.17-.1l-1.02-1.72c-.07.04-1.28.75-3.27 1.83h.01c.56.02 1.11.02 1.65.02z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyParts",
	            d: "m759.75 449.23.1.03c-2.45-1.5-4.56-3.27-6.33-5.33-1.22-1.43-2.21-4.8-2.96-9.36v21.95c1.49-2.51 4.89-8.16 9.19-7.29zm-9.75 8.3c.13-.26.32-.61.56-1.01v-21.95c-.21-1.23-.39-2.56-.56-3.95-.17 1.39-.35 2.72-.56 3.95v21.95c.24.4.43.75.56 1.01z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Chest");
	            },
	            className: "bodyLines",
	            d: "M786.19 455.21c.54 0 1.09 0 1.64-.02h.01c-2-1.09-3.2-1.79-3.27-1.83l-1.02 1.72c.04.02.1.06.17.1.82.02 1.63.03 2.47.03z"
	          }),
	          this.state.bodyTitle === "Chest" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "395",
	              width: "115",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M834.206 414.53h260" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "m1137.88 417.94 5.045 1.599c-.773 2.813-2.059 4.902-3.858 6.267-1.799 1.365-4.081 2.048-6.847 2.048-3.422 0-6.234-1.169-8.437-3.507-2.203-2.338-3.305-5.534-3.305-9.589 0-4.289 1.108-7.62 3.322-9.993 2.215-2.373 5.127-3.56 8.737-3.56 3.152 0 5.713.932 7.681 2.795 1.172 1.102 2.051 2.684 2.637 4.746l-5.15 1.231c-.305-1.336-.941-2.391-1.908-3.164-.966-.774-2.141-1.16-3.524-1.16-1.91 0-3.46.685-4.649 2.056-1.19 1.371-1.785 3.592-1.785 6.662 0 3.258.586 5.578 1.758 6.961 1.172 1.383 2.696 2.075 4.571 2.075 1.382 0 2.572-.44 3.568-1.319s1.711-2.262 2.144-4.148Zm14.4-16.295v9.474c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.065 1.617.463.657.78 1.383.95 2.18.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.094-3.199-.281-3.727a2.448 2.448 0 0 0-.993-1.256c-.475-.311-1.07-.466-1.785-.466-.82 0-1.552.199-2.197.597-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm27.88 19.828 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.952-.633.527-.422.925-1.102 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm7.189 5.607 4.957-.756c.211.961.638 1.691 1.283 2.189.644.498 1.547.747 2.707.747 1.277 0 2.238-.235 2.883-.703.433-.328.65-.768.65-1.319 0-.375-.117-.685-.352-.931-.246-.235-.796-.451-1.652-.651-3.984-.879-6.51-1.681-7.576-2.408-1.477-1.008-2.215-2.408-2.215-4.201 0-1.617.639-2.977 1.916-4.078 1.277-1.102 3.258-1.653 5.942-1.653 2.554 0 4.453.417 5.695 1.249 1.242.832 2.097 2.062 2.566 3.691l-4.658.861c-.199-.726-.577-1.283-1.134-1.67-.556-.386-1.35-.58-2.382-.58-1.3 0-2.232.182-2.795.545-.375.258-.562.592-.562 1.002 0 .352.164.651.492.897.445.328 1.984.791 4.614 1.388 2.631.598 4.468 1.33 5.511 2.198 1.031.878 1.547 2.103 1.547 3.673 0 1.711-.715 3.182-2.144 4.413-1.43 1.23-3.545 1.845-6.346 1.845-2.543 0-4.556-.515-6.038-1.547-1.483-1.031-2.452-2.431-2.909-4.201Zm30.32-13.342v3.938h-3.375v7.523c0 1.524.032 2.411.097 2.663.064.252.21.46.439.624.228.164.507.247.835.247.457 0 1.119-.159 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.694-.149-2.408-.448-.715-.299-1.24-.686-1.574-1.16-.334-.475-.565-1.116-.694-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Upper GI" ? "bodyParts_group Upper_GI body_parts_active" : "bodyParts_group Upper_GI"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "syzst2",
	            d: "M845.72 442.8c-.06 2.1-.2 4.3-.43 6.47.32-2.36.43-4.55.43-6.47zm-189.87 12.12c-1.13-4.25-1.52-8.67-1.57-12.48-.03 3.44.3 7.81 1.57 12.48z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M736.6 451.13a31.38 31.38 0 0 0 3.55-1.88c-.67.17-1.92.83-3.55 1.88zm23.25-1.87c1.11.68 2.29 1.31 3.54 1.87-1.63-1.04-2.87-1.7-3.54-1.87zm85.15 1.87c0 .03.01.12.02.27.1-.7.19-1.41.27-2.12-.09.63-.19 1.27-.3 1.92l.01-.07z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "syzst2",
	            d: "M845 451.13c0 .03.01.12.02.27.1-.7.19-1.41.27-2.12-.09.63-.19 1.27-.3 1.92l.01-.07zm.72-8.33c-.06 2.1-.2 4.3-.43 6.47.32-2.36.43-4.55.43-6.47zm-191.44-.36c-.03 3.45.3 7.82 1.57 12.48-1.13-4.26-1.52-8.68-1.57-12.48z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "m656.91 456.57-.6-.05c.16.49.32.99.5 1.49.06-.89.1-1.42.1-1.44zm54.86.91c.09.01.2.02.31.03 1.11-.6 2.05-1.12 2.77-1.53-1.43-.34-2.62-.47-2.89-.5l-.19 2zm131.92.04c.11-.33.21-.68.3-1.03l-.3.03c-.07.22-.15.44-.22.65l.22.35zm0-1c.57-1.82.99-3.6 1.29-5.32l-1.29 5.32z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M844.98 451.2c-.31 1.72-.72 3.5-1.29 5.32l.3-.03c.44-1.59.77-3.32 1.03-5.1-.01-.15-.02-.24-.02-.27l-.02.08zm-1.9 5.37c0 .02.04.55.1 1.44.1-.28.19-.56.28-.83l-.38-.61zm.61-.05-.6.05.38.6c.07-.21.15-.43.22-.65zm-55.46.96-.19-1.99c-.28.03-1.46.16-2.89.5.72.41 1.66.93 2.77 1.53.11-.02.22-.03.31-.04z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M680.14 568.29c3.11 1.56 5.88 1.85 8.24.88 2.64-1.1 4.07-3.56 4.45-4.7.43-1.49-2.84-11.61-6.36-20.87-4.52-1.89-10.7-5.89-14.54-9.81-3.36-3.42-6.7-7.87-9.24-11.51 1.84 8.57 1.18 20.25 2.01 28.25h.01c.07.14 7.02 13.56 15.43 17.76z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M698.84 617.48c7.16-21.07-9.38-43.44-11.31-45.97-.66.15-1.35.22-2.05.22-1.95 0-4.04-.55-6.24-1.65-5.85-2.93-10.87-9.7-13.74-14.23.84 6.49.27 15.6-.42 22.94v.01c3.36 6.34 9.06 16.86 12.28 21.35 5.54 7.73 18.81 17.19 21.48 17.33zm49.59-42.33c-.19-7.8-.06-17.15.44-19.28-1.02-.9-4.17-1.17-7.78-1.17-3.86 0-8.26.31-11.14.52-6.48.46-13.21 1.67-17.72 2.6-5.13 1.07-9.02 5.2-9.67 10.28-.32 2.47-.48 4.76-.48 6.86 0 6.94 1.73 11.82 5.18 14.58 5.18 4.15 37.16 3.37 40.65 2.51.46-.68.82-2.92 1.09-5.97 0 0-.01-.01 0-.02-.25-2.62-.45-6.16-.57-10.91z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M749 586.08c-.27 3.05-.63 5.29-1.09 5.97-3.49.86-35.47 1.64-40.65-2.51-3.45-2.76-5.18-7.64-5.18-14.58 0-2.1.16-4.39.48-6.86.65-5.08 4.54-9.21 9.67-10.28 4.51-.93 11.24-2.14 17.72-2.6 2.88-.21 7.28-.52 11.14-.52 3.61 0 6.76.27 7.78 1.17a2.486 2.486 0 0 1 .57-1.1v-.88c-2.85-1.52-9.19-1.42-19.64-.67-6.58.47-13.41 1.7-17.98 2.65-5.96 1.23-10.48 6.05-11.25 11.98-1.46 11.37.37 19.2 5.44 23.25 3.56 2.85 16.26 3.7 26.93 3.7 7.73 0 14.4-.45 15.74-.89.22-.08.48-.17.76-.55v-3.69c-.16-.95-.31-2.13-.44-3.59zm-69.76-16c2.2 1.1 4.29 1.65 6.24 1.65.7 0 1.39-.07 2.05-.22-.12-.14-.18-.22-.19-.23l1.56-1.25c.07.09.29.36.62.8 3.07-1.42 4.71-4.24 5.21-5.73.79-2.39-3.46-14.38-5.79-20.64-.74-.19-1.57-.48-2.47-.86 3.52 9.26 6.79 19.38 6.36 20.87-.38 1.14-1.81 3.6-4.45 4.7-2.36.97-5.13.68-8.24-.88-8.41-4.2-15.36-17.62-15.43-17.76h-.01c.12 1.17.27 2.26.47 3.25.13.65.24 1.34.33 2.06v.01c2.87 4.53 7.89 11.3 13.74 14.23zm8.76-28.09-.12.05c.05.02.11.04.16.06-.01-.04-.03-.07-.04-.11z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M687.88 542.04h-.01l-1.74.66c.11.3.23.6.34.9.9.38 1.73.67 2.47.86-.35-.93-.66-1.73-.9-2.36-.05-.02-.11-.04-.16-.06zm11.15 77.43c.1 0 .2-.01.29-.02.64-.09 1.11-.47 1.31-1.03.97-2.78 1.55-5.57 1.83-8.33l-.38-.63v-1.89l.53.54c.87-17.61-10.27-33.55-13.09-37.28-.12.07-.25.13-.38.18-.52.22-1.06.38-1.61.5 1.93 2.53 18.47 24.9 11.31 45.97-2.67-.14-15.94-9.6-21.48-17.33-3.22-4.49-8.92-15.01-12.28-21.35-.12 1.25-.24 2.44-.36 3.57 3.39 6.35 8.12 14.9 11.02 18.95 5.35 7.48 19.14 18.15 23.29 18.15z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M687.34 571.28c.01.01.07.09.19.23.55-.12 1.09-.28 1.61-.5.13-.05.26-.11.38-.18-.33-.44-.55-.71-.62-.8l-1.56 1.25z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M751.56 575.15c-.12 4.75-.31 8.29-.56 10.91v.02c.27 3.05.63 5.29 1.09 5.97 3.48.86 35.47 1.64 40.65-2.51 4.49-3.59 6.07-10.8 4.7-21.44-.33-2.54-1.46-4.84-3.15-6.64-1.7-1.8-3.96-3.1-6.52-3.64-4.51-.93-11.24-2.14-17.72-2.6-5.58-.4-16.79-1.2-18.92.65.5 2.12.63 11.48.43 19.28zm69.2-5.07c-2.21 1.1-4.29 1.65-6.24 1.65-.7 0-1.38-.07-2.05-.22-1.94 2.53-18.48 24.9-11.31 45.97 2.67-.14 15.94-9.6 21.48-17.33 3.21-4.49 8.92-15.01 12.28-21.35v-.01c-.69-7.33-1.26-16.45-.43-22.93-2.87 4.53-7.88 11.29-13.73 14.22z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M813.52 543.61c-3.51 9.26-6.78 19.37-6.35 20.86.38 1.14 1.8 3.6 4.45 4.7 2.35.97 5.13.68 8.24-.88 8.41-4.2 15.36-17.62 15.42-17.76l.02.01c.83-8.01.17-19.7 2.01-28.27-2.54 3.64-5.89 8.1-9.25 11.52-3.85 3.91-10.03 7.92-14.54 9.82zm-64.08 49.75v5.29c.21.07.39.13.56.2.16-.07.35-.13.56-.2v-5.29c-.18-.25-.37-.63-.56-1.22-.19.59-.38.97-.56 1.22zm0-51.66v12.19c.21.1.39.21.56.35.17-.14.35-.25.56-.35V541.7c-.26-.68-.44-1.42-.56-2.19-.13.77-.31 1.51-.56 2.19zm1.12 16.73v20.17c.1 2.72.25 5.29.44 7.46.25-2.62.44-6.16.56-10.91.2-7.8.07-17.16-.43-19.28-.15.12-.26.27-.31.43-.1.31-.19 1.05-.26 2.13zm0 20.17v-20.17c-.26 4.02-.29 12.64 0 20.17z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M750 554.24c-.17-.14-.35-.25-.56-.35v.88c.14-.2.34-.38.56-.53zm-.56 35.43v3.69c.18-.25.37-.63.56-1.22-.2-.59-.38-1.39-.56-2.47z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M748.43 575.15c.12 4.75.32 8.29.57 10.91.19-2.2.34-4.84.44-7.61v-20.02c-.07-1.08-.16-1.82-.26-2.13a.966.966 0 0 0-.31-.43c-.5 2.13-.63 11.48-.44 19.28z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M749 586.06c-.01.01 0 .02 0 .02.13 1.46.28 2.64.44 3.59v-11.22c-.1 2.77-.25 5.41-.44 7.61zm.44-27.63v-3.66a2.486 2.486 0 0 0-.57 1.1c.15.13.26.27.31.43.1.31.19 1.05.26 2.13zm1.63-2.77c.02.06.04.13.06.21 2.13-1.85 13.34-1.05 18.92-.65 6.48.46 13.21 1.67 17.72 2.6 2.56.54 4.82 1.84 6.52 3.64 1.69 1.8 2.82 4.1 3.15 6.64 1.37 10.64-.21 17.85-4.7 21.44-5.18 4.15-37.17 3.37-40.65 2.51-.46-.68-.82-2.92-1.09-5.97-.14 1.46-.28 2.64-.44 3.59v3.69c.28.38.54.47.76.55 1.34.45 8.01.89 15.74.89 10.67 0 23.37-.85 26.93-3.7 3.94-3.15 5.93-8.59 5.93-16.2 0-2.17-.17-4.52-.49-7.05-.77-5.93-5.29-10.75-11.25-11.98-4.57-.95-11.4-2.18-17.99-2.65-10.45-.74-16.78-.84-19.63.67v.88c.24.27.4.56.51.89z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M750 592.14c.19.59.38.97.56 1.22v-3.69c-.18 1.08-.37 1.88-.56 2.47zm-.56-33.71v20.02c.29-7.5.26-16.02 0-20.02zm1.12-3.66v-.88c-.21.1-.39.21-.56.35.22.15.42.33.56.53zm0 23.83v11.07c.16-.95.3-2.13.44-3.59v-.02c-.19-2.17-.34-4.74-.44-7.46zm.26-22.3c.05-.16.16-.31.31-.43a2.486 2.486 0 0 0-.57-1.1v3.66c.07-1.08.16-1.82.26-2.13z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M749.44 554.77v3.66c.26 4 .29 12.52 0 20.02v11.22c.18 1.08.36 1.88.56 2.47.19-.59.38-1.39.56-2.47V578.6c-.29-7.53-.26-16.15 0-20.17v-3.66c-.14-.2-.34-.38-.56-.53-.22.15-.42.33-.56.53zM812 541.99c-.01.03-.03.07-.04.1.05-.01.1-.03.15-.06l-.11-.04zm7.86 26.3c-3.11 1.56-5.89 1.85-8.24.88-2.65-1.1-4.07-3.56-4.45-4.7-.43-1.49 2.84-11.6 6.35-20.86-.9.37-1.72.66-2.46.85-2.33 6.26-6.58 18.25-5.79 20.64.5 1.49 2.14 4.31 5.2 5.73.34-.44.56-.71.63-.8l1.56 1.25c-.01.01-.07.09-.19.23.67.15 1.35.22 2.05.22 1.95 0 4.03-.55 6.24-1.65 5.85-2.93 10.86-9.69 13.73-14.22.1-.73.21-1.42.34-2.08.2-.99.35-2.07.47-3.24l-.02-.01c-.06.14-7.01 13.56-15.42 17.76z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M813.52 543.61c.11-.3.22-.61.34-.91l-1.75-.67c-.05.03-.1.05-.15.06-.24.63-.55 1.44-.9 2.37.74-.19 1.56-.48 2.46-.85zm-12.36 73.87c-7.17-21.07 9.37-43.44 11.31-45.97-.55-.11-1.09-.28-1.62-.5a2.64 2.64 0 0 1-.38-.18c-2.83 3.75-14 19.73-13.08 37.39l.53-.65v1.89l-.39.63c.28 2.76.86 5.54 1.83 8.32.2.56.68.94 1.32 1.03.09.01.18.02.28.02 4.16 0 17.94-10.67 23.3-18.15 2.9-4.05 7.62-12.59 11.02-18.94v-.01c-.12-1.12-.24-2.32-.36-3.57-3.36 6.34-9.07 16.86-12.28 21.35-5.54 7.74-18.81 17.2-21.48 17.34z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M812.47 571.51c.12-.14.18-.22.19-.23l-1.56-1.25c-.07.09-.29.36-.63.8.12.07.25.13.38.18.53.22 1.07.39 1.62.5z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M702.61 608.11c-.03.66-.08 1.31-.15 1.98l.77 1.26c-.01-.82.06-1.63.18-2.42l-.8-.82z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M703.41 608.92c-.12.8-.19 1.6-.18 2.42l.4-2.2-.22-.22zm-1.33-1.35v1.89l.38.63c.07-.66.12-1.32.15-1.98l-.53-.54zm94.69 3.78.76-1.25c-.06-.63-.11-1.25-.14-1.88l-.76.93c.09.72.15 1.45.14 2.2z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M797.92 609.46v-1.89l-.53.65c.03.62.08 1.25.14 1.88l.39-.64z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "syzst2",
	            d: "M654.76 472.6c-.16-1.99-.23-4.33-.24-6.71 0 2.22.06 4.56.24 6.71zm190.31 1.62c.4-3.17.45-7 .38-10.29.03 3.8-.05 7.64-.38 10.29z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M745.48 506.78c-2.49 0-7.57 3.32-11.15 5.65-1.73 1.13-3.37 2.2-4.84 3.04-3.72 2.12-11.33 7.49-17.06 11.62-3.71 2.66-6.19 6.77-6.81 11.26-.34 2.44-.47 4.36-.47 5.88 0 4.3 1.06 5.36 1.47 5.61 3.72 2.24 29.55-3.24 37.07-5.39 4.5-1.29 4.67-5.06 4.58-11.63-.01-.78-.03-1.57-.03-2.37 0-1.32.03-2.84.07-4.48.12-6.41.32-16.1-1.63-18.7-.25-.34-.67-.49-1.2-.49z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M744.24 546.38c-2.7.77-23.85 5.94-34 5.94-2.12 0-3.76-.23-4.65-.77-2.37-1.42-3.01-5.83-1.95-13.47.35-2.52 1.21-4.92 2.51-7.08 1.3-2.15 3.04-4.04 5.11-5.54 5.77-4.15 13.44-9.56 17.24-11.73 1.42-.81 3.03-1.86 4.74-2.98 6.13-3.99 12.46-8.12 15.04-4.68.49.65.87 1.57 1.16 2.68v-24.31c-.8 5.19-2.07 9.43-4.04 10.74-3.05 2.03-13.52 10.84-21.93 17.92-6.29 5.31-11.27 9.49-12.41 10.26-.95.63-2.1.95-3.3.95-.79 0-1.62-.14-2.42-.43-1.87-.69-3.23-2.04-3.72-3.72-1.76-6.01-.11-31.82-.04-32.92v-.02c.03-.32.09-.66.17-1.01.02-.1.06-.2.08-.29.07-.27.16-.55.26-.83.03-.08.06-.16.09-.25 3.88-10.13 25.28-27.87 34.41-33.7-5.47 2.46-12.25 3.82-20.33 4.05-.26.15-.74.43-1.42.81 1.98.48 4.44 1.37 5.65 2.99.66.88.89 1.91.67 2.99-.89 4.43-28.37 21.91-43.81 27.87 2.19.56 5.66 1.28 10.35 1.75 8.74.88 11.07 11.13 12.06 15.51.1.42.18.79.26 1.09.36 1.44-.2 2.98-1.58 4.36-1.79 1.79-5.04 3.34-8.81 3.45 1.2 2.1 3.25 5.99 4.08 9.29 2.34 9.38.35 18.01-2.14 19.26-.24.12-.55.18-.93.18-.48 0-1.06-.09-1.71-.27 2.33 6.26 6.58 18.25 5.79 20.64-.5 1.49-2.14 4.31-5.21 5.73 2.82 3.74 13.96 19.67 13.09 37.28l.8.81c.48-3.28 1.99-6.31 4.43-8.68 3.02-2.94 7.01-4.46 11.24-4.3 16.41.68 26.6 1.58 30.36 2.7v-5.29c-.28.38-.54.47-.76.55-1.34.44-8.01.89-15.74.89-10.67 0-23.37-.85-26.93-3.7-5.07-4.05-6.9-11.88-5.44-23.25.77-5.93 5.29-10.75 11.25-11.98 4.57-.95 11.4-2.18 17.98-2.65 10.45-.75 16.79-.85 19.64.67V541.7c-.79 2.17-2.31 3.85-5.19 4.68z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M740.64 452.19c-4.62.92-36.22 25.31-37.06 35.19-.04.63-1.69 26.58-.04 32.22.31 1.06 1.22 1.93 2.49 2.4 1.38.5 2.88.38 3.92-.31 1.05-.7 6.48-5.27 12.24-10.12 8.88-7.48 18.96-15.96 22.1-18.05 4.49-3 4.9-32.39 4.04-34.86-.36-.71-3.75-7.25-7.69-6.47zm-83.73 21.78c1.25 10.03 5.28 15.22 12.31 15.86 9.79.88 49.09-24.68 50-28.26.1-.52 0-.97-.32-1.4-1.24-1.66-5.08-2.44-6.81-2.65-8.43 4.55-27.12 13.8-39.88 13.8-4.75 0-8.68-1.28-10.95-4.58-1.97-2.87-3.4-5.82-4.44-8.73-.21 3.11-.58 10.62.09 15.96z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M662.91 465.6c1.87 2.73 5.21 3.81 9.32 3.81 12.51 0 32.2-10.02 39.93-14.23-2.25-.03-4.58-.15-7.01-.34-25.99-2.11-43.17-5.97-48.52-17.4v-.03c-.57 4.68-1.2 17.33 6.28 28.19zm27.82 77.14c.96-.53 3.34-7.78 1.05-16.96-.95-3.77-3.74-8.59-4.52-9.9h-.01c-.54-.07-1.09-.17-1.64-.31-5.97-1.5-21.83-11.94-27.37-15.67.62 5.3 1.43 11.45 2.58 15.92v.02c1.96 3.08 7.32 11.24 12.54 16.55 4.35 4.44 10.76 8.13 14.52 9.65l.12-.05c.01.04.03.07.04.11 1.31.51 2.28.75 2.69.64zm6.3-31.6c.5-.5 1.3-1.48 1.06-2.46-.08-.32-.17-.7-.27-1.13-.97-4.3-3-13.24-10.31-13.97-7.8-.78-12.28-2.22-13.36-2.62-1.85.57-3.41.88-4.6.88-.18 0-.35-.01-.51-.02-5.01-.46-8.74-2.95-11.17-7.44l-.37 8.97c.14 1.16.28 2.48.44 3.92v.01c3.27 2.22 21.94 14.79 28.16 16.35 4.44 1.11 8.86-.42 10.93-2.49z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M748.28 506.07c-2.58-3.44-8.91.69-15.04 4.68-1.71 1.12-3.32 2.17-4.74 2.98-3.8 2.17-11.47 7.58-17.24 11.73-2.07 1.5-3.81 3.39-5.11 5.54-1.3 2.16-2.16 4.56-2.51 7.08-1.06 7.64-.42 12.05 1.95 13.47.89.54 2.53.77 4.65.77 10.15 0 31.3-5.17 34-5.94 2.88-.83 4.4-2.51 5.2-4.68v-32.95c-.29-1.11-.67-2.03-1.16-2.68zm.03 19.9c-.04 1.64-.07 3.16-.07 4.48 0 .8.02 1.59.03 2.37.09 6.57-.08 10.34-4.58 11.63-7.52 2.15-33.35 7.63-37.07 5.39-.41-.25-1.47-1.31-1.47-5.61 0-1.52.13-3.44.47-5.88.62-4.49 3.1-8.6 6.81-11.26 5.73-4.13 13.34-9.5 17.06-11.62 1.47-.84 3.11-1.91 4.84-3.04 3.58-2.33 8.66-5.65 11.15-5.65.53 0 .95.15 1.2.49 1.95 2.6 1.75 12.29 1.63 18.7zm1.13-63.48v-5.97c-1.49-2.51-4.87-7.16-9.2-6.29-4.15.83-33.43 22.7-38.06 34.61-.03.08-.07.17-.09.25-.1.28-.18.56-.26.83-.03.1-.06.2-.08.29-.08.35-.14.69-.17 1.01v.02c-.07 1.1-1.72 26.91.04 32.92.49 1.68 1.85 3.03 3.72 3.72.8.29 1.63.43 2.42.43 1.2 0 2.35-.32 3.3-.95 1.14-.77 6.12-4.95 12.41-10.26 8.41-7.08 18.88-15.89 21.93-17.92 1.97-1.31 3.24-5.55 4.04-10.74v-13.67c-.09-3.13-.08-6.02 0-8.28zm-5.15 31.03c-3.14 2.09-13.22 10.57-22.1 18.05-5.76 4.85-11.19 9.42-12.24 10.12-1.04.69-2.54.81-3.92.31-1.27-.47-2.18-1.34-2.49-2.4-1.65-5.64 0-31.59.04-32.22.84-9.88 32.44-34.27 37.06-35.19 3.94-.78 7.33 5.76 7.69 6.47.86 2.47.45 31.86-4.04 34.86z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M702.19 484.83c4.63-11.91 33.9-33.78 38.06-34.61 4.33-.87 7.71 3.78 9.2 6.29-1.49-2.51-4.87-8.16-9.2-7.29l-.09.03c-1.12.68-2.3 1.31-3.55 1.88-9.14 5.83-30.54 23.57-34.42 33.7zm-.36 1.08c.07-.27.15-.55.26-.83-.1.28-.18.56-.26.83zm-.25 1.31zm.51-2.14c.03-.08.06-.16.09-.25-.03.09-.06.17-.09.25zm-.34 1.12c.02-.1.06-.2.08-.29-.02.1-.06.2-.08.29zm-45.44-29.68.6.05c0 .02-.04.55-.1 1.44 1.04 2.91 2.47 5.87 4.44 8.73 2.26 3.29 6.19 4.58 10.95 4.58 12.75 0 31.44-9.24 39.88-13.8-.11-.01-.22-.03-.31-.03l.19-1.99c.28.03 1.46.16 2.89.5.68-.38 1.16-.66 1.42-.81-.81.02-1.63.03-2.46.03-.54 0-1.09 0-1.65-.02h-.01c-7.73 4.21-27.42 14.23-39.93 14.23-4.11 0-7.44-1.08-9.32-3.81-7.47-10.87-6.85-23.52-6.29-28.18-.32-.68-.6-1.35-.83-2.09l-.85-.18c-.06.28-.62 3.1-.66 7.29.05 3.81.44 8.23 1.57 12.48.15.51.3 1.05.47 1.58z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M718.89 460.17c.32.43.42.88.32 1.4-.91 3.58-40.21 29.14-50 28.26-7.03-.64-11.05-5.83-12.31-15.86-.67-5.34-.3-12.85-.1-15.96-.18-.5-.35-.99-.5-1.49l-1.39-.12c-.02.28-.37 4.58-.4 9.49.01 2.38.08 4.72.24 6.71.05.55.1 1.1.16 1.62.33 2.67.87 5.04 1.61 7.11l1.41 1.29-.07 1.76c2.43 4.49 6.16 6.99 11.17 7.44.16.01.33.02.51.02 1.19 0 2.75-.32 4.6-.88h-.01a1.95 1.95 0 0 1-.24-.08l.72-1.86c.02 0 .95.36 2.74.82 15.45-5.96 42.92-23.44 43.81-27.87.21-1.07-.02-2.11-.67-2.99-1.21-1.62-3.67-2.51-5.65-2.99-.72.41-1.66.93-2.77 1.53 1.75.21 5.59.99 6.82 2.65z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M654.93 474.22c-.07-.52-.11-1.07-.16-1.62.04.57.09 1.12.16 1.62zm1.38-17.7-1.39-4.12c-.03.3-.42 7-.4 13.49.02-4.91.37-9.21.4-9.49l1.39.12zm30.94 59.36h.01zm0 0c-.13-.22-.2-.34-.21-.35l1.7-1.06c.04.08.4.64.9 1.53 3.77-.11 7.02-1.66 8.81-3.45 1.38-1.38 1.94-2.92 1.58-4.36-.08-.3-.16-.67-.26-1.09-.99-4.38-3.32-14.63-12.06-15.51-4.69-.47-8.16-1.19-10.35-1.75-1.14.44-2.22.82-3.21 1.12 1.08.39 5.57 1.84 13.36 2.62 7.31.73 9.34 9.67 10.31 13.97.1.43.19.81.27 1.13.24.98-.56 1.96-1.06 2.46-2.07 2.07-6.49 3.6-10.93 2.49-6.22-1.56-24.89-14.13-28.16-16.35.1.84.2 1.71.3 2.61v.01c5.54 3.73 21.4 14.17 27.37 15.67.55.14 1.1.24 1.64.31z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M673.9 490.88c.02.01.1.04.24.08h.01c1-.3 2.07-.68 3.21-1.12-1.79-.46-2.72-.82-2.74-.82l-.72 1.86zm-13.08 24.96c.25 1 .53 1.92.82 2.72.42 1.15.77 2.4 1.05 3.72 2.54 3.64 5.88 8.09 9.24 11.51 3.84 3.92 10.02 7.92 14.54 9.81-.11-.3-.23-.6-.34-.9l1.74-.66h.01c-3.76-1.52-10.17-5.21-14.52-9.65-5.22-5.31-10.58-13.47-12.54-16.55zm30.76 28.71c2.49-1.25 4.48-9.88 2.14-19.26-.83-3.3-2.88-7.19-4.08-9.29-.15.01-.31.01-.46.01-.63 0-1.26-.04-1.92-.13.78 1.31 3.57 6.13 4.52 9.9 2.29 9.18-.09 16.43-1.05 16.96-.41.11-1.38-.13-2.69-.64.24.63.55 1.43.9 2.36.65.18 1.23.27 1.71.27.38 0 .69-.06.93-.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M687.04 515.53c.01.01.08.13.21.35h.01c.66.09 1.29.13 1.92.13.15 0 .31 0 .46-.01-.5-.89-.86-1.45-.9-1.53l-1.7 1.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M781.11 460.17c-.32.43-.42.88-.32 1.4.89 3.51 38.89 28.28 49.47 28.28.18 0 .36-.01.52-.02 7.03-.64 11.05-5.83 12.3-15.86.67-5.34.3-12.85.1-15.97-1.04 2.91-2.47 5.87-4.44 8.73-2.26 3.29-6.19 4.58-10.95 4.58-12.75 0-31.44-9.24-39.88-13.8-1.73.22-5.57 1-6.8 2.66zm-21.75-7.98c-.22-.05-.44-.07-.66-.07-3.65 0-6.7 5.87-7.05 6.58-.84 2.43-.43 31.82 4.06 34.82 3.14 2.09 13.21 10.57 22.1 18.05 5.75 4.84 11.19 9.42 12.24 10.12 1.03.69 2.54.81 3.92.31 1.27-.47 2.18-1.34 2.49-2.4 1.65-5.64 0-31.59-.04-32.22-.84-9.88-32.44-34.27-37.06-35.19z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M808.42 544.55c-2.49-1.25-4.49-9.88-2.14-19.26.82-3.3 2.88-7.19 4.07-9.29-3.77-.12-7.01-1.66-8.8-3.45-1.38-1.38-1.94-2.92-1.58-4.36.07-.3.16-.67.25-1.09 1-4.38 3.32-14.63 12.06-15.51 4.68-.47 8.15-1.19 10.34-1.75h.01c-15.45-5.96-42.92-23.44-43.8-27.87-.21-1.07.02-2.11.67-2.99 1.21-1.62 3.67-2.51 5.65-2.99-.68-.38-1.16-.66-1.42-.81h-.01c-8.08-.23-14.86-1.58-20.33-4.05 9.13 5.83 30.54 23.58 34.42 33.71.03.08.06.16.09.25.1.28.19.56.26.83.03.1.06.2.08.29.08.35.14.69.17 1.01v.02c.08 1.1 1.73 26.91-.03 32.92-.5 1.68-1.85 3.03-3.73 3.72-.8.29-1.62.43-2.42.43-1.2 0-2.34-.32-3.29-.95-1.14-.77-6.12-4.96-12.42-10.26-8.41-7.08-18.87-15.89-21.92-17.92-1.97-1.31-3.24-5.55-4.04-10.74v24.28c.29-1.1.67-2 1.15-2.65 2.59-3.43 8.92.69 15.05 4.68 1.7 1.12 3.32 2.17 4.74 2.98 3.8 2.17 11.47 7.58 17.24 11.73 4.15 2.99 6.92 7.59 7.62 12.62.33 2.38.49 4.44.49 6.2 0 3.89-.81 6.29-2.44 7.27-.9.54-2.53.77-4.65.77-10.15 0-31.3-5.17-34-5.94-2.88-.83-4.41-2.51-5.2-4.68v12.19c2.85-1.51 9.18-1.41 19.63-.67 6.59.47 13.42 1.7 17.99 2.65 5.96 1.23 10.48 6.05 11.25 11.98.32 2.53.49 4.88.49 7.05 0 7.61-1.99 13.05-5.93 16.2-3.56 2.85-16.26 3.7-26.93 3.7-7.73 0-14.4-.44-15.74-.89-.22-.08-.48-.17-.76-.55v5.29c3.76-1.12 13.95-2.02 30.36-2.7.21-.01.42-.01.63-.01 3.98 0 7.73 1.52 10.61 4.31a15.05 15.05 0 0 1 4.46 8.9l.76-.93c-.91-17.66 10.25-33.64 13.08-37.39-3.06-1.42-4.7-4.24-5.2-5.73-.79-2.39 3.46-14.38 5.79-20.64-.65.18-1.23.27-1.71.27-.37 0-.68-.06-.92-.18zm28.67-78.95c7.48-10.89 6.85-23.52 6.29-28.18 0 0 .01.01 0 .02-5.35 11.43-22.53 15.29-48.52 17.4-2.43.19-4.77.31-7.02.34 10.28 5.6 41.68 21.44 49.25 10.42z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M756.31 544.45c7.52 2.15 33.34 7.63 37.07 5.39.56-.34 2.29-2.16 1-11.49-.62-4.49-3.1-8.6-6.81-11.26-5.73-4.13-13.34-9.5-17.06-11.62-1.48-.84-3.11-1.91-4.85-3.04-3.57-2.33-8.66-5.65-11.15-5.65-.53 0-.94.15-1.2.49-1.94 2.6-1.75 12.29-1.62 18.71.03 1.63.06 3.16.06 4.47 0 .8-.01 1.59-.02 2.37-.09 6.57.07 10.34 4.58 11.63zm56.44-28.57c-.79 1.31-3.58 6.13-4.53 9.9-2.3 9.18.08 16.44 1.09 16.98.39.1 1.34-.14 2.65-.67.01-.03.03-.07.04-.1l.11.04c3.73-1.51 10.16-5.2 14.53-9.64 5.22-5.31 10.58-13.47 12.54-16.55v-.02c1.15-4.47 1.96-10.62 2.58-15.92-5.55 3.73-21.4 14.17-27.37 15.67-.55.14-1.1.24-1.64.31zm30.96-35.3c-2.21 6.88-6.47 10.67-12.74 11.24-.16.01-.33.02-.51.02-1.18 0-2.75-.32-4.59-.88h-.01c-1.09.39-5.58 1.83-13.37 2.61-7.3.73-9.33 9.67-10.31 13.97-.1.43-.18.81-.26 1.13-.25.98.55 1.96 1.05 2.46 2.08 2.08 6.51 3.6 10.94 2.49 6.22-1.56 24.89-14.13 28.16-16.35v-.01c.18-1.59.34-3.04.48-4.27l1.16-12.41zm-94.27 3.86v24.31c.24.9.42 1.93.56 3.04.14-1.13.32-2.16.56-3.07v-24.28c-.22-1.44-.41-2.95-.56-4.49-.15 1.54-.34 3.05-.56 4.49z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyParts",
	            d: "M749.73 532.79c.01-.77.02-1.55.02-2.34 0-1.3-.03-2.81-.06-4.43-.09-4.68-.2-10.07.31-14.23-.14-1.11-.32-2.14-.56-3.04v32.95c.25-.68.43-1.42.56-2.19-.34-2.05-.3-4.36-.27-6.72zm.13-74.99c.04-.07.08-.16.14-.27-.13-.26-.32-.61-.56-1.01v5.97c.08-2.58.24-4.33.42-4.69zm-.42 12.97v13.67c.22-1.44.41-2.95.56-4.49-.3-3.05-.48-6.22-.56-9.18z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M755.76 546.38c2.7.77 23.85 5.94 34 5.94 2.12 0 3.75-.23 4.65-.77 1.63-.98 2.44-3.38 2.44-7.27 0-1.76-.16-3.82-.49-6.2-.7-5.03-3.47-9.63-7.62-12.62-5.77-4.15-13.44-9.56-17.24-11.73-1.42-.81-3.04-1.86-4.74-2.98-6.13-3.99-12.46-8.11-15.05-4.68-.48.65-.86 1.55-1.15 2.65v32.98c.79 2.17 2.32 3.85 5.2 4.68zm-4.07-20.4c-.13-6.42-.32-16.11 1.62-18.71.26-.34.67-.49 1.2-.49 2.49 0 7.58 3.32 11.15 5.65 1.74 1.13 3.37 2.2 4.85 3.04 3.72 2.12 11.33 7.49 17.06 11.62 3.71 2.66 6.19 6.77 6.81 11.26 1.29 9.33-.44 11.15-1 11.49-3.73 2.24-29.55-3.24-37.07-5.39-4.51-1.29-4.67-5.06-4.58-11.63.01-.78.02-1.57.02-2.37 0-1.31-.03-2.84-.06-4.47zM750 511.79c.51 4.16.4 9.55.31 14.22-.04 1.63-.07 3.14-.07 4.44 0 .79.02 1.57.03 2.34.03 2.36.06 4.67-.27 6.72.12.77.3 1.51.56 2.19v-32.98c-.24.91-.42 1.94-.56 3.07z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M750.27 532.79c-.01-.77-.03-1.55-.03-2.34 0-1.3.03-2.81.07-4.44.09-4.67.2-10.06-.31-14.22-.51 4.16-.4 9.55-.31 14.23.03 1.62.06 3.13.06 4.43 0 .79-.01 1.57-.02 2.34-.03 2.36-.07 4.67.27 6.72.33-2.05.3-4.36.27-6.72zm-.83-62.02v-8.28c-.08 2.26-.09 5.15 0 8.28zm10.31-20.54c-4.3-.87-7.7 3.78-9.19 6.29v5.97c.08 2.26.09 5.15 0 8.28v13.67c.8 5.19 2.07 9.43 4.04 10.74 3.05 2.03 13.51 10.84 21.92 17.92 6.3 5.3 11.28 9.49 12.42 10.26.95.63 2.09.95 3.29.95.8 0 1.62-.14 2.42-.43 1.88-.69 3.23-2.04 3.73-3.72 1.76-6.01.11-31.82.03-32.92v-.02c-.03-.33-.09-.67-.17-1.01-.02-.1-.06-.2-.08-.29-.07-.27-.15-.55-.26-.83-.03-.08-.06-.16-.09-.25-4.62-11.92-33.9-33.78-38.06-34.61zm36.71 69.37c-.31 1.06-1.22 1.93-2.49 2.4-1.38.5-2.89.38-3.92-.31-1.05-.7-6.49-5.28-12.24-10.12-8.89-7.48-18.96-15.96-22.1-18.05-4.49-3-4.9-32.39-4.06-34.82.35-.71 3.4-6.58 7.05-6.58.22 0 .44.02.66.07 4.62.92 36.22 25.31 37.06 35.19.04.63 1.69 26.58.04 32.22zm1.78-33.4z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M797.9 485.08c.1.28.18.56.26.83-.07-.27-.15-.55-.26-.83zm-47.34-28.56c1.49-2.51 4.89-7.16 9.19-6.29 4.15.83 33.44 22.7 38.06 34.61-3.88-10.13-25.29-27.88-34.42-33.71-1.25-.56-2.43-1.19-3.54-1.87-.03-.01-.07-.03-.1-.03-4.3-.87-7.7 4.78-9.19 7.29zm47.6 29.39zm-.35-1.08c.03.08.07.16.09.25-.03-.08-.06-.16-.09-.25zm-47.25-22.34v-5.97c-.24.4-.43.75-.56 1.01.06.11.1.2.14.27.18.36.34 2.11.42 4.69zm-.56 17.46c.15 1.54.34 3.05.56 4.49v-13.67c-.08 2.96-.26 6.13-.56 9.18zm.56-17.46v8.28c.09-3.13.08-6.02 0-8.28z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M749.44 462.49v8.28c.08 2.96.26 6.13.56 9.18.3-3.05.48-6.22.56-9.18v-8.28c-.08-2.58-.24-4.33-.42-4.69-.04-.07-.08-.16-.14-.27-.06.11-.1.2-.14.27-.18.36-.34 2.11-.42 4.69zm38.6-7 .19 1.99c-.09.01-.2.02-.31.03 8.43 4.55 27.12 13.8 39.88 13.8 4.75 0 8.68-1.29 10.95-4.58 1.97-2.87 3.4-5.83 4.44-8.73-.06-.88-.1-1.41-.1-1.44l.6-.05 1.29-5.32c.12-.65.22-1.29.3-1.92.24-2.17.37-4.37.43-6.47-.01-4.38-.6-7.36-.66-7.65l-.85.18c-.23.74-.51 1.42-.83 2.09.56 4.67 1.19 17.3-6.29 28.18-7.58 11.02-38.97-4.82-49.25-10.42h-.01c-.55.02-1.1.02-1.64.02-.84 0-1.65-.01-2.46-.03.26.15.74.43 1.42.81 1.44-.33 2.63-.46 2.9-.49z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M843.99 456.49c-.1.35-.2.69-.3 1.03l-.22-.35c-.09.28-.18.55-.28.83.2 3.11.57 10.62-.1 15.97-1.25 10.03-5.28 15.22-12.3 15.86-.17.02-.34.02-.52.02-10.58 0-48.58-24.76-49.47-28.28-.1-.52 0-.97.32-1.4 1.23-1.66 5.07-2.44 6.81-2.65-1.11-.6-2.05-1.12-2.77-1.53-1.98.48-4.44 1.37-5.65 2.99-.65.88-.89 1.91-.67 2.99.89 4.43 28.36 21.91 43.8 27.87 1.8-.46 2.73-.82 2.75-.82l.72 1.86c-.02.01-.1.04-.24.09 1.84.56 3.41.88 4.59.88.18 0 .35-.01.51-.02 6.27-.57 10.53-4.35 12.74-11.24l.28-2.98.02 2.01c.46-1.64.82-3.43 1.06-5.39.33-2.65.41-6.49.38-10.29-.09-4.04-.35-7.29-.37-7.53l-1.09.08z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M845.08 456.4c.02.24.29 3.48.37 7.53-.05-5.68-.35-11.25-.43-12.54-.26 1.78-.59 3.51-1.03 5.1l1.09-.09zm-42.12 54.74c-.5-.5-1.3-1.48-1.05-2.46.08-.32.16-.7.26-1.13.98-4.3 3.01-13.24 10.31-13.97 7.79-.78 12.28-2.22 13.37-2.61h.01c-1-.31-2.08-.69-3.23-1.13h-.01c-2.19.56-5.66 1.28-10.34 1.75-8.74.88-11.06 11.13-12.06 15.51-.09.42-.18.79-.25 1.09-.36 1.44.2 2.98 1.58 4.36 1.79 1.79 5.03 3.33 8.8 3.45.51-.89.87-1.45.91-1.53l1.7 1.06c-.01.01-.08.13-.21.35.54-.07 1.09-.17 1.64-.31 5.97-1.5 21.82-11.94 27.37-15.67v-.01c.1-.9.2-1.77.3-2.61-3.27 2.22-21.94 14.79-28.16 16.35-4.43 1.11-8.86-.41-10.94-2.49z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M825.38 489.02c-.02 0-.95.36-2.75.82 1.15.44 2.23.82 3.23 1.13.14-.05.22-.08.24-.09l-.72-1.86zm-13.27 53.01 1.75.67c-.12.3-.23.61-.34.91 4.51-1.9 10.69-5.91 14.54-9.82 3.36-3.42 6.71-7.88 9.25-11.52v-.01c.29-1.32.63-2.56 1.05-3.7.29-.8.57-1.72.82-2.72-1.96 3.08-7.32 11.24-12.54 16.55-4.37 4.44-10.8 8.13-14.53 9.64zm-2.8.73c-1.01-.54-3.39-7.8-1.09-16.98.95-3.77 3.74-8.59 4.53-9.9-.66.09-1.3.13-1.93.13-.16 0-.32 0-.47-.01-1.19 2.1-3.25 5.99-4.07 9.29-2.35 9.38-.35 18.01 2.14 19.26.24.12.55.18.93.18.48 0 1.06-.09 1.71-.27.35-.93.66-1.74.9-2.37-1.31.53-2.26.77-2.65.67z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M812.75 515.88c.13-.22.2-.34.21-.35l-1.7-1.06c-.04.08-.4.64-.91 1.53.15.01.31.01.47.01.63 0 1.27-.04 1.93-.13zm-156.39-25.49 1.09 4.01.04-1.05c-.47-4.05-.79-5.96-1.13-2.96z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "m656.53 481.33-.17 9.06c.33-2.99.66-1.09 1.14 2.96l.37-8.97c-.5-.93-.95-1.95-1.34-3.05z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Upper GI");
	            },
	            className: "bodyLines",
	            d: "M656.53 481.33c.39 1.1.83 2.12 1.33 3.05l.07-1.76-1.4-1.29zm187.18-.75c.1-.32.21-.64.3-.98l-.02-2.01-.28 2.99z"
	          }),
	          this.state.bodyTitle === "Upper GI" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "533",
	              width: "165",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M804.206 554.009h290" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1119.99 537.793h5.203v13.957c0 2.215.065 3.651.194 4.307.222 1.055.752 1.901 1.59 2.54.838.639 1.984.958 3.437.958 1.476 0 2.59-.302 3.34-.905.75-.604 1.201-1.345 1.353-2.224.153-.879.229-2.338.229-4.377v-14.256h5.203v13.536c0 3.093-.141 5.279-.422 6.556-.281 1.278-.8 2.356-1.556 3.235-.756.878-1.766 1.579-3.032 2.1-1.266.522-2.918.782-4.957.782-2.461 0-4.327-.284-5.599-.852-1.271-.569-2.276-1.307-3.014-2.215-.739-.908-1.225-1.86-1.459-2.856-.34-1.477-.51-3.657-.51-6.54v-13.746Zm25.86 7.102h4.606v2.742c.598-.937 1.406-1.699 2.426-2.285 1.019-.586 2.15-.879 3.392-.879 2.168 0 4.008.85 5.52 2.549 1.512 1.699 2.267 4.066 2.267 7.101 0 3.118-.761 5.541-2.285 7.269-1.523 1.729-3.369 2.593-5.537 2.593-1.031 0-1.966-.205-2.804-.615-.837-.411-1.719-1.114-2.645-2.11v9.404h-4.94v-25.769Zm4.887 9.018c0 2.097.416 3.647 1.248 4.649.832 1.002 1.846 1.503 3.041 1.503 1.149 0 2.104-.46 2.865-1.38.762-.92 1.143-2.429 1.143-4.526 0-1.957-.393-3.411-1.178-4.36-.785-.949-1.758-1.424-2.918-1.424-1.207 0-2.209.466-3.006 1.398-.796.932-1.195 2.311-1.195 4.14Zm17.103-9.018h4.605v2.742c.598-.937 1.406-1.699 2.426-2.285 1.019-.586 2.15-.879 3.393-.879 2.167 0 4.007.85 5.519 2.549 1.512 1.699 2.268 4.066 2.268 7.101 0 3.118-.762 5.541-2.286 7.269-1.523 1.729-3.369 2.593-5.537 2.593-1.031 0-1.965-.205-2.803-.615-.838-.411-1.72-1.114-2.646-2.11v9.404h-4.939v-25.769Zm4.886 9.018c0 2.097.416 3.647 1.248 4.649.832 1.002 1.846 1.503 3.041 1.503 1.149 0 2.104-.46 2.866-1.38.761-.92 1.142-2.429 1.142-4.526 0-1.957-.392-3.411-1.177-4.36-.786-.949-1.758-1.424-2.918-1.424-1.207 0-2.209.466-3.006 1.398-.797.932-1.196 2.311-1.196 4.14Zm28.054 3.709 4.922.826c-.633 1.804-1.632 3.178-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.433 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.433 2.604 1.195 3.419.762.814 1.711 1.221 2.848 1.221.773 0 1.423-.211 1.951-.632.527-.422.926-1.102 1.195-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.566-1.117-1.079 0-1.969.393-2.672 1.178-.703.785-1.049 1.852-1.037 3.199h7.382Zm13.659 10.934h-4.94v-18.668h4.588v2.654c.785-1.254 1.491-2.08 2.118-2.478.627-.399 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.306c-.832-.539-1.606-.808-2.321-.808-.691 0-1.277.19-1.758.571-.48.381-.858 1.069-1.133 2.065-.276.997-.413 3.083-.413 6.258v5.766Zm31.31-9.475v-4.341h11.215v10.265c-1.09 1.055-2.669 1.984-4.737 2.786-2.069.803-4.163 1.204-6.284 1.204-2.696 0-5.045-.565-7.049-1.696-2.004-1.131-3.51-2.748-4.518-4.851-1.008-2.104-1.512-4.392-1.512-6.865 0-2.683.563-5.068 1.688-7.154 1.125-2.086 2.771-3.686 4.939-4.799 1.653-.855 3.709-1.283 6.17-1.283 3.2 0 5.699.671 7.497 2.013 1.799 1.341 2.956 3.196 3.472 5.563l-5.168.967c-.363-1.266-1.046-2.265-2.048-2.997-1.002-.733-2.253-1.099-3.753-1.099-2.273 0-4.081.721-5.423 2.162-1.341 1.442-2.012 3.58-2.012 6.416 0 3.059.679 5.353 2.039 6.882 1.359 1.529 3.14 2.294 5.344 2.294 1.089 0 2.182-.214 3.278-.641 1.096-.428 2.036-.947 2.821-1.556v-3.27h-5.959Zm15.85-16.295h5.203v25.77h-5.203z"
	              })
	            )
	          ) : ""
	        ),
	        _react2.default.createElement(
	          "g",
	          {
	            className: this.state.bodyTitle === "Lower Abdomen" ? "bodyParts_group Lower_Abdomen body_parts_active" : "bodyParts_group Lower_Abdomen"
	          },
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyParts",
	            d: "M749.44 688.24v-79.09c-.8 14.65-.61 46.1 0 79.09zm-.93-87.78c-2.44-.65-9.45-1.69-29.51-2.51-.19-.01-.38-.01-.56-.01-3.46 0-6.71 1.32-9.21 3.75a13.04 13.04 0 0 0-4 9.63c.1 7.7.5 18.68 1.86 27.26 2.61 16.55 10.57 42.21 14.9 52.6 1.92 4.6 4.75 14.69 7.74 25.37 3.49 12.45 7.83 27.95 9.66 29.78 2.19 2.19 6.97 1.06 9.46.14-.14-4.83-1.12-38.45-1.63-71.95-.86-57.15.22-70.59 1.29-74.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyParts",
	            d: "M743.22 749.59c-1.92 0-3.85-.45-5.25-1.85-2.04-2.04-5.2-12.94-10.17-30.65-2.97-10.62-5.78-20.65-7.65-25.14-4.48-10.74-12.36-36.12-15.03-53.05-1.38-8.71-1.79-19.79-1.89-27.55l-.77-1.26c-.28 2.76-.86 5.55-1.83 8.33-.2.56-.67.94-1.31 1.03-.09.01-.19.02-.29.02-4.15 0-17.94-10.67-23.29-18.15-2.9-4.05-7.63-12.6-11.02-18.95-.15 1.47-.3 2.81-.43 3.98-.37 3.38-3.14 10.09-6.46 17.64-.08 5.52.11 20.9 4.28 29.93 3.37 7.3 16.74 26.88 27.48 42.62 6.08 8.89 11.32 16.57 13.84 20.67 1.36 2.21 3.1 6.41 5.03 11.83 0 .01.01.02.02.04.71 1.38 17.95 35 20.53 40.15 2.06 4.13 8.55 11.44 10.98 14.1 2.88-1 7.37-1 9.45-.94v-14.01c-1.35.48-3.79 1.21-6.22 1.21z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyLines",
	            d: "m748.89 747.69-.02-.63c0-.03-.01-.23-.02-.59-2.49.92-7.27 2.05-9.46-.14-1.83-1.83-6.17-17.33-9.66-29.78-2.99-10.68-5.82-20.77-7.74-25.37-4.33-10.39-12.29-36.05-14.9-52.6-1.36-8.58-1.76-19.56-1.86-27.26a13.04 13.04 0 0 1 4-9.63c2.5-2.43 5.75-3.75 9.21-3.75.18 0 .37 0 .56.01 20.06.82 27.07 1.86 29.51 2.51.3-.99.6-1.17.85-1.32a.3.3 0 0 1 .08-.04v-.45c-3.76-1.12-13.95-2.02-30.36-2.7-4.23-.16-8.22 1.36-11.24 4.3a15.034 15.034 0 0 0-4.43 8.68l.22.22-.4 2.2c.1 7.76.51 18.84 1.89 27.55 2.67 16.93 10.55 42.31 15.03 53.05 1.87 4.49 4.68 14.52 7.65 25.14 4.97 17.71 8.13 28.61 10.17 30.65 1.4 1.4 3.33 1.85 5.25 1.85 2.43 0 4.87-.73 6.22-1.21v-.44l-.55-.25z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyParts",
	            d: "M750.56 609.14v79.07c.61-32.99.8-64.43 0-79.07zm2.21 65.38c-.5 33.47-1.48 67.07-1.63 71.94 2.49.93 7.28 2.06 9.47-.13 1.82-1.83 6.17-17.32 9.66-29.78 2.99-10.68 5.82-20.77 7.73-25.37 4.34-10.39 12.29-36.05 14.91-52.6 1.35-8.58 1.76-19.56 1.86-27.26.04-3.66-1.38-7.08-4-9.63-2.63-2.56-6.11-3.88-9.77-3.74-12.05.49-19.39 1.07-23.86 1.58-2.97.35-4.68.67-5.65.93 1.06 3.47 2.14 16.91 1.28 74.06z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyParts",
	            d: "M800.96 619.47c-.1 0-.19-.01-.28-.02-.64-.09-1.12-.47-1.32-1.03a36.36 36.36 0 0 1-1.83-8.32l-.76 1.25c-.11 7.76-.51 18.85-1.89 27.55-2.67 16.94-10.56 42.31-15.03 53.05-1.87 4.49-4.68 14.52-7.66 25.14-4.96 17.71-8.12 28.61-10.16 30.65-1.4 1.4-3.33 1.85-5.25 1.85-2.44 0-4.87-.72-6.22-1.21v14.02c2.07-.07 6.57-.07 9.45.93 2.42-2.66 8.91-9.97 10.98-14.1 2.56-5.12 19.64-38.41 20.51-40.12.02-.04.04-.06.04-.07 1.92-5.42 3.65-9.62 5.02-11.83 2.52-4.1 7.77-11.77 13.84-20.67 10.74-15.74 24.12-35.32 27.49-42.62 4.16-9.03 4.36-24.39 4.27-29.92.01-.01.01-.01 0-.02-3.32-7.55-6.08-14.25-6.45-17.63-.13-1.17-.28-2.51-.43-3.97-3.4 6.35-8.12 14.89-11.02 18.94-5.36 7.48-19.14 18.15-23.3 18.15zm-50.4-10.33c-.15-2.75-.34-4.91-.56-6.37-.22 1.46-.41 3.62-.56 6.38v79.09c.16 8.83.35 17.76.56 26.51.21-8.76.4-17.71.56-26.54v-79.07zM750 748.17c-.16.06-.34.13-.56.21v14.01c.21.01.39.01.55.02h.02c.15 0 .34-.01.55-.01v-14.02c-.22-.08-.4-.15-.56-.21z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyParts",
	            d: "M750.56 609.14c.8 14.64.61 46.08 0 79.07v48.17c.09 3.41.19 6.74.29 9.98.09.04.19.07.29.1.15-4.87 1.13-38.47 1.63-71.94.86-57.15-.22-70.59-1.28-74.06-.45.12-.74.22-.93.32v8.36zm0-8.36c-.02 0-.04.01-.06.02-.18.33-.35.99-.5 1.97.22 1.46.41 3.62.56 6.37v-8.36zm-1.12 147.16v.44c.22-.08.4-.15.56-.21-.3-.12-.48-.2-.53-.22l-.03-.01zm.56-33.19c.17 7.4.36 14.67.56 21.63v-48.17c-.16 8.83-.35 17.78-.56 26.54zm-.56-116.1v.45c.15-.09.34-.17.56-.25-.17-.07-.35-.13-.56-.2z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyLines",
	            d: "M749.44 609.15v-8.37c-.19-.1-.48-.2-.93-.32-1.07 3.47-2.15 16.91-1.29 74.06.51 33.5 1.49 67.12 1.63 71.95.1-.04.2-.07.29-.11.1-3.36.2-6.81.3-10.35v-47.77c-.61-32.99-.8-64.44 0-79.09z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyLines",
	            d: "M748.85 746.47c.01.36.02.56.02.59l.02.63.55.25v-11.93c-.1 3.54-.2 6.99-.3 10.35-.09.04-.19.07-.29.11zm.59-147.37a.3.3 0 0 0-.08.04c-.25.15-.55.33-.85 1.32.45.12.74.22.93.32v-1.68zm47.18 10.05c-.44-3.38-1.97-6.48-4.46-8.9-2.88-2.79-6.63-4.31-10.61-4.31-.21 0-.42 0-.63.01-16.41.68-26.6 1.58-30.36 2.7v.45a.3.3 0 0 1 .08.04c.25.15.55.33.85 1.32.97-.26 2.68-.58 5.65-.93 4.47-.51 11.81-1.09 23.86-1.58 3.66-.14 7.14 1.18 9.77 3.74 2.62 2.55 4.04 5.97 4 9.63-.1 7.7-.51 18.68-1.86 27.26-2.62 16.55-10.57 42.21-14.91 52.6-1.91 4.6-4.74 14.69-7.73 25.37-3.49 12.46-7.84 27.95-9.66 29.78-2.19 2.19-6.98 1.06-9.47.13-.01.37-.02.57-.02.6l-.02.63-.54.25v.44c1.35.49 3.78 1.21 6.22 1.21 1.92 0 3.85-.45 5.25-1.85 2.04-2.04 5.2-12.94 10.16-30.65 2.98-10.62 5.79-20.65 7.66-25.14 4.47-10.74 12.36-36.11 15.03-53.05 1.38-8.7 1.78-19.79 1.89-27.55l-.4-1.89.25-.31zm-46.09 138.8-.53.22c.16.06.34.13.56.21v-.44l-.03.01zm.03-148.85v-.45c-.21.07-.4.13-.56.2.22.08.41.16.56.25zm-.56 3.67c-.15-.97-.32-1.64-.5-1.97-.02-.01-.04-.02-.06-.02v8.37c.15-2.76.34-4.92.56-6.38zm-.56 133.24c.19-6.85.38-13.99.56-21.26-.21-8.75-.4-17.68-.56-26.51v47.77z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyLines",
	            d: "M750.56 736.38v11.56l.54-.25.02-.63c0-.03.01-.23.02-.6-.1-.03-.2-.06-.29-.1-.1-3.24-.2-6.57-.29-9.98zm.93-135.92c-.3-.99-.6-1.17-.85-1.32a.3.3 0 0 0-.08-.04v1.68c.19-.1.48-.2.93-.32zm-.93 147.48v-11.56c-.2-6.96-.39-14.23-.56-21.63-.18 7.27-.37 14.41-.56 21.26v11.93l.03.01c.05.02.23.1.53.22l.53-.22.03-.01zm-1.12-148.84v1.68c.02 0 .04.01.06.02.18.33.35 1 .5 1.97.15-.98.32-1.64.5-1.97.02-.01.04-.02.06-.02v-1.68c-.15-.09-.34-.17-.56-.25-.22.08-.41.16-.56.25z"
	          }),
	          _react2.default.createElement("path", {
	            onClick: function onClick(e) {
	              return _this2.modalFemaleBodySingleContentOpen(e, "Lower Abdomen");
	            },
	            className: "bodyLines",
	            d: "m796.37 609.46.4 1.89c.01-.74-.05-1.48-.15-2.2l-.25.31z"
	          }),
	          this.state.bodyTitle === "Lower Abdomen" ? _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("rect", {
	              className: "labelArea",
	              x: "1120",
	              y: "655",
	              width: "290",
	              height: "40",
	              rx: "5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { className: "labelGroup" },
	              _react2.default.createElement("path", { className: "labelLine", d: "M794.206 675.376h300" }),
	              _react2.default.createElement("path", {
	                className: "labelText",
	                d: "M1119.95 688.05v-25.559h5.203v21.217h12.937v4.342h-18.14Zm20.67-9.598c0-1.64.404-3.228 1.213-4.763.808-1.535 1.954-2.707 3.436-3.516 1.483-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.952 0 2.825-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.774-2.734-1.907-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.062.264c0 1.852.44 3.27 1.319 4.254.878.984 1.962 1.477 3.251 1.477 1.29 0 2.371-.493 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.251 1.476-.879.985-1.319 2.403-1.319 4.254Zm21.558 9.334-5.906-18.668h4.799l3.498 12.234 3.216-12.234h4.764l3.111 12.234 3.569-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Zm35.33-5.941 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.843-1.846-6.433 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.433 2.604 1.195 3.419.762.814 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.102 1.195-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.671 1.177-.704.785-1.049 1.852-1.038 3.199h7.383Zm13.659 10.934h-4.939v-18.668h4.588v2.654c.785-1.253 1.491-2.08 2.118-2.478.627-.399 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.53 4.307c-.832-.54-1.605-.809-2.32-.809-.691 0-1.277.19-1.758.571-.48.381-.858 1.07-1.133 2.066-.276.996-.414 3.082-.414 6.257v5.766Zm41.22 0h-5.66l-2.25-5.853h-10.301l-2.127 5.853h-5.519l10.037-25.769h5.502l10.318 25.769Zm-9.58-10.195-3.551-9.563-3.48 9.563h7.031Zm12.09 10.195v-25.769h4.939v9.281c1.524-1.735 3.328-2.602 5.414-2.602 2.274 0 4.155.823 5.643 2.47 1.488 1.646 2.232 4.011 2.232 7.093 0 3.187-.758 5.642-2.276 7.365-1.518 1.723-3.36 2.584-5.528 2.584-1.067 0-2.119-.267-3.156-.8s-1.93-1.321-2.68-2.364v2.742h-4.588Zm4.904-9.738c0 1.933.305 3.363.914 4.289.856 1.312 1.992 1.969 3.41 1.969 1.09 0 2.019-.466 2.786-1.398.768-.931 1.152-2.399 1.152-4.403 0-2.133-.387-3.671-1.16-4.614-.774-.944-1.764-1.415-2.971-1.415-1.184 0-2.168.459-2.953 1.379-.785.92-1.178 2.318-1.178 4.193Zm34.416 9.738h-4.588v-2.742c-.762 1.066-1.661 1.86-2.698 2.382-1.037.521-2.083.782-3.138.782-2.144 0-3.981-.864-5.51-2.593-1.53-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.57 2.232-7.216 1.488-1.647 3.369-2.47 5.643-2.47 2.086 0 3.89.867 5.414 2.602v-9.281h4.939v25.769Zm-13.184-9.738c0 1.992.276 3.433.827 4.324.797 1.289 1.91 1.934 3.34 1.934 1.136 0 2.103-.484 2.9-1.451.797-.966 1.195-2.411 1.195-4.333 0-2.144-.387-3.688-1.16-4.631-.773-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.465-2.944 1.397-.791.932-1.187 2.323-1.187 4.175Zm16.914.14c0-1.64.404-3.228 1.213-4.763.808-1.535 1.954-2.707 3.436-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.952 0 2.825-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.774-2.734-1.907-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.062.264c0 1.852.44 3.27 1.319 4.254.878.984 1.962 1.477 3.251 1.477 1.29 0 2.371-.493 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.251 1.476-.879.985-1.319 2.403-1.319 4.254Zm17.698-9.334h4.553v2.549c1.629-1.981 3.568-2.971 5.818-2.971 1.196 0 2.233.246 3.112.739.879.492 1.599 1.236 2.162 2.232.82-.996 1.705-1.74 2.654-2.232a6.503 6.503 0 0 1 3.041-.739c1.371 0 2.531.279 3.481.835.949.557 1.658 1.374 2.127 2.452.339.797.509 2.086.509 3.868v11.935h-4.939v-10.67c0-1.851-.17-3.047-.51-3.586-.457-.703-1.16-1.054-2.109-1.054-.692 0-1.342.21-1.951.632-.61.422-1.049 1.04-1.319 1.855-.269.814-.404 2.1-.404 3.858v8.965h-4.94v-10.23c0-1.817-.087-2.989-.263-3.516-.176-.527-.448-.92-.818-1.178-.369-.258-.87-.386-1.503-.386a3.6 3.6 0 0 0-2.056.615c-.61.41-1.046 1.002-1.31 1.775-.263.774-.395 2.057-.395 3.85v9.07h-4.94v-18.668Zm43.19 12.727 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.843-1.846-6.433 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.035 1.465.434 2.604 1.196 3.419.761.814 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.704-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.177-.703.785-1.049 1.852-1.037 3.199h7.383Zm25.909 10.934h-4.939v-9.527c0-2.016-.106-3.32-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.544 3.544 0 0 0-1.397 1.863c-.252.773-.378 2.203-.378 4.289v8.455h-4.939v-18.668h4.587v2.742c1.629-2.109 3.68-3.164 6.153-3.164 1.09 0 2.086.197 2.988.589.902.393 1.585.894 2.048 1.503.463.609.785 1.301.967 2.074.181.774.272 1.881.272 3.323v11.601Z"
	              })
	            )
	          ) : ""
	        )
	      );
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "section",
	          {
	            className: "center-of-excellence old_female_single_content",
	            id: "excellence-part"
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "body-and-doctor mt-4" },
	              _react2.default.createElement(
	                "div",
	                { style: { "text-align": "left" } },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: this.FemaleBackStep,
	                    style: {
	                      border: "none",
	                      color: "#14b795",
	                      background: "transparent",
	                      "font-weight": "600"
	                    }
	                  },
	                  _react2.default.createElement("i", { className: "fa fa-arrow-left" }),
	                  " Back to Body Part"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-5 col-sm-12" },
	                  OldFemaleBodySVGReactElement
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-7 col-sm-12 single_body_right_content_sec" },
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    this.props.bodyTitle
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "our-departments" },
	                    _react2.default.createElement(
	                      "h3",
	                      null,
	                      "Our Departments "
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row mt-3" },
	                      this.state.bodyDepartment.length > 0 ? this.state.bodyDepartment.map(function (body_department) {
	                        return _react2.default.createElement(
	                          "div",
	                          {
	                            className: "col-lg-6 col-md-12 mb-3",
	                            key: body_department.id
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              className: "doctor-list bg-light",
	                              style: { height: "80px", cursor: "pointer" }
	                            },
	                            _react2.default.createElement("input", {
	                              type: "radio",
	                              className: "patient_user",
	                              name: "body_dept_id",
	                              value: body_department.dept_id,
	                              onChange: _this2.handleChange,
	                              style: { cursor: "pointer" }
	                            }),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row d-flex align-items-center" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-3" },
	                                body_department.image ? _react2.default.createElement("img", {
	                                  src: _constants.IMAGE_URL + "DepartmentImage/" + body_department.image,
	                                  alt: "avtars",
	                                  style: { width: "50px" }
	                                }) : _react2.default.createElement("img", {
	                                  src: _icon2.default,
	                                  alt: "Bitmap-3",
	                                  style: { width: "50px" }
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-9" },
	                                _react2.default.createElement(
	                                  "p",
	                                  {
	                                    style: {
	                                      fontWeight: "500",
	                                      letterSpacing: "1px"
	                                    }
	                                  },
	                                  body_department.department_name
	                                ),
	                                _react2.default.createElement(
	                                  "p",
	                                  null,
	                                  "Department"
	                                )
	                              )
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-12 col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "doctor-list" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-12" },
	                              _react2.default.createElement(
	                                "p",
	                                {
	                                  style: {
	                                    "text-align": "center",
	                                    "margin-top": "15px"
	                                  }
	                                },
	                                "No Body Departments Found"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "our-consultants", style: { display: "none" } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "h3",
	                          null,
	                          "Our Consultants"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6 text-right" },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            onClick: this.ShowDepartment,
	                            style: {
	                              border: "none",
	                              color: "#14b795",
	                              background: "transparent",
	                              "font-weight": "600",
	                              paddingTop: "12px"
	                            }
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-arrow-left" }),
	                          " Back to department"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row mt-4" },
	                      this.state.bodyDepartmentDoctor.length > 0 ? this.state.bodyDepartmentDoctor.map(function (body_department_doctor) {
	                        var doctor_name = body_department_doctor.doctor_name;
	                        // let new_doctor_name = doctor_name.replaceAll(' ', '-');
	                        return _react2.default.createElement(
	                          "div",
	                          { className: "col-lg-6 col-md-12 mb-3" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              href: _constants.SITE_URL + "/consultant/" + body_department_doctor.slug,
	                              style: {
	                                "text-decoration": "none",
	                                color: "#333333"
	                              }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "doctor-list" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "row",
	                                  style: {
	                                    height: "80vh",
	                                    maxHeight: "161px"
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "col-5" },
	                                  body_department_doctor.doctor_profile ? _react2.default.createElement("img", {
	                                    src: _constants.IMAGE_URL + "/DoctorProfileImg/" + body_department_doctor.doctor_profile,
	                                    alt: "Bitmap-3",
	                                    width: 125,
	                                    height: 161
	                                  }) : _react2.default.createElement("img", {
	                                    src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                                    alt: "Bitmap-3",
	                                    width: 125,
	                                    height: 161
	                                  })
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "col-7" },
	                                  _react2.default.createElement(
	                                    "h6",
	                                    null,
	                                    body_department_doctor.doctor_name
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    {
	                                      title: body_department_doctor.degree
	                                    },
	                                    body_department_doctor.degree ? body_department_doctor.degree.substr(0, 20) + "..." : ""
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    { className: "mb-1" },
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        href: "/doctor-profile/" + body_department_doctor.id,
	                                        className: "read-more"
	                                      },
	                                      "Read More"
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-12 col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "doctor-list" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-12" },
	                              _react2.default.createElement(
	                                "p",
	                                {
	                                  style: {
	                                    "text-align": "center",
	                                    "margin-top": "15px"
	                                  }
	                                },
	                                "No Body Departments Doctors Found"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          {
	            className: "center-of-excellence new_female_single_content",
	            id: "excellence-part",
	            style: { display: "none" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "body-and-doctor mt-4" },
	              _react2.default.createElement(
	                "div",
	                { style: { "text-align": "left" } },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: this.FemaleBackStep,
	                    style: {
	                      border: "none",
	                      color: "#14b795",
	                      background: "transparent",
	                      "font-weight": "600"
	                    }
	                  },
	                  _react2.default.createElement("i", { className: "fa fa-arrow-left" }),
	                  " Back to Body Part"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-5 col-sm-12" },
	                  NewFemaleBodySVGReactElement
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-7 col-sm-12 single_body_right_content_sec" },
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    this.state.bodyTitle,
	                    " Department"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "our-departments pt-4 mt-5" },
	                    _react2.default.createElement(
	                      "h3",
	                      { className: "bg-info" },
	                      "Our Departments "
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row mt-4" },
	                      this.state.bodyDepartment.length > 0 ? this.state.bodyDepartment.map(function (body_department) {
	                        return _react2.default.createElement(
	                          "div",
	                          {
	                            className: "col-lg-6 col-md-12 mb-3",
	                            key: body_department.id
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "doctor-list" },
	                            _react2.default.createElement("input", {
	                              type: "radio",
	                              className: "patient_user",
	                              name: "body_dept_id",
	                              value: body_department.dept_id,
	                              onChange: _this2.handleChange
	                            }),
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                className: "row list_content_sec",
	                                style: {
	                                  width: "80vw",
	                                  maxWidth: "274px",
	                                  height: "80vh",
	                                  maxHeight: "133px"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-5" },
	                                body_department.image ? _react2.default.createElement("img", {
	                                  src: _constants.IMAGE_URL + "DepartmentImage/" + body_department.image,
	                                  alt: "avtars",
	                                  width: 125,
	                                  height: 161
	                                }) : _react2.default.createElement("img", {
	                                  src: _icon2.default,
	                                  alt: "Bitmap-3",
	                                  width: 125,
	                                  height: 161
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "col-7",
	                                  style: {
	                                    paddingLeft: "0px",
	                                    textAlign: "left"
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "h6",
	                                  { style: { paddingTop: "0px" } },
	                                  body_department.department_name
	                                ),
	                                _react2.default.createElement(
	                                  "h6",
	                                  null,
	                                  "Department"
	                                )
	                              )
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-12 col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "doctor-list" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-12" },
	                              _react2.default.createElement(
	                                "p",
	                                {
	                                  style: {
	                                    "text-align": "center",
	                                    "margin-top": "15px"
	                                  }
	                                },
	                                "No Body Departments Found"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "our-consultants pt-4 mt-5",
	                      style: { display: "none" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6" },
	                        _react2.default.createElement(
	                          "h3",
	                          null,
	                          "Our Consultants"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-sm-6 text-right" },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            onClick: this.ShowDepartment,
	                            style: {
	                              border: "none",
	                              color: "#14b795",
	                              background: "transparent",
	                              "font-weight": "600",
	                              paddingTop: "12px"
	                            }
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-arrow-left" }),
	                          " Back to department"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row mt-4" },
	                      this.state.bodyDepartmentDoctor.length > 0 ? this.state.bodyDepartmentDoctor.map(function (body_department_doctor) {
	                        var doctor_name = body_department_doctor.doctor_name;
	                        // let new_doctor_name = doctor_name.replaceAll(' ', '-');
	                        return _react2.default.createElement(
	                          "div",
	                          { className: "col-lg-6 col-md-12 mb-3" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              href: _constants.SITE_URL + "/consultant/" + body_department_doctor.slug,
	                              style: {
	                                "text-decoration": "none",
	                                color: "#333333"
	                              }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "doctor-list" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "row",
	                                  style: {
	                                    height: "80vh",
	                                    maxHeight: "161px"
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "col-5" },
	                                  body_department_doctor.doctor_profile ? _react2.default.createElement("img", {
	                                    src: _constants.IMAGE_URL + "/DoctorProfileImg/" + body_department_doctor.doctor_profile,
	                                    alt: "Bitmap-3",
	                                    width: 125,
	                                    height: 161
	                                  }) : _react2.default.createElement("img", {
	                                    src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                                    alt: "Bitmap-3",
	                                    width: 125,
	                                    height: 161
	                                  })
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "col-7" },
	                                  _react2.default.createElement(
	                                    "h6",
	                                    null,
	                                    body_department_doctor.doctor_name
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    {
	                                      title: body_department_doctor.degree
	                                    },
	                                    body_department_doctor.degree ? body_department_doctor.degree.substr(0, 20) + "..." : ""
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    { className: "mb-1" },
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        href: "/doctor-profile/" + body_department_doctor.id,
	                                        className: "read-more"
	                                      },
	                                      "Read More"
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-12 col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "doctor-list" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-12" },
	                              _react2.default.createElement(
	                                "p",
	                                {
	                                  style: {
	                                    "text-align": "center",
	                                    "margin-top": "15px"
	                                  }
	                                },
	                                "No Body Departments Doctors Found"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SingleFemaleBodyContent;
	}(_react.Component);
	
	exports.default = SingleFemaleBodyContent;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _icon = __webpack_require__(57);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _SelectDeptment = __webpack_require__(197);
	
	var _SelectDeptment2 = _interopRequireDefault(_SelectDeptment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import dept_img from '../../../images/dept_img.png';
	
	
	var getBodyDepartmentsLists = function getBodyDepartmentsLists(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request('/bodypart/getbodypartdepartment', {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json',
	        'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getBodyDepartmentsDoctorsLists = function getBodyDepartmentsDoctorsLists(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request('/bodypart/getbodypartdepartmentdoctors', {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json',
	        'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var SingleMaleBodyContent = function (_Component) {
	  _inherits(SingleMaleBodyContent, _Component);
	
	  function SingleMaleBodyContent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SingleMaleBodyContent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SingleMaleBodyContent.__proto__ || Object.getPrototypeOf(SingleMaleBodyContent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      bodyDepartment: [],
	      bodyDepartmentDoctor: [],
	      showNewMaleComponent: false,
	      bodyTitle: '',
	      body_part_title: '',
	      body_part_desc: ''
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	      var body_dept_id = (0, _jquery2.default)("input[name='body_dept_id']:checked").val();
	      _this.refreshGetBodyDepartmentsDoctors(body_dept_id);
	    }, _this.refreshGetBodyDepartmentsDoctors = function (body_dept_id) {
	      var data = {
	        bodyDeptId: body_dept_id
	      };
	      getBodyDepartmentsDoctorsLists(data).then(function (res) {
	        if (res.status === true) {
	          (0, _jquery2.default)('.our-departments').hide();
	          (0, _jquery2.default)('.our-consultants').show();
	          var records = res.data;
	          _this.setState({ bodyDepartmentDoctor: records });
	        } else {
	          _this.setState({ bodyDepartmentDoctor: '' });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshGetBodyDepartments = function (bodyTitle) {
	      var data = {
	        bodyTitle: bodyTitle,
	        bodyGender: 'male'
	      };
	      getBodyDepartmentsLists(data).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          var body_part_data = res.bodyPartData;
	          _this.setState({ bodyDepartment: records });
	          _this.setState({ body_part_title: body_part_data.bodypart_name });
	          _this.setState({ body_part_desc: body_part_data.bodypart_desc });
	        } else {
	          _this.setState({ bodyDepartment: '' });
	          _this.setState({ body_part_title: '' });
	          _this.setState({ body_part_desc: '' });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.MaleBackStep = function () {
	      _this.props.onClickMalePrevStep();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SingleMaleBodyContent, [{
	    key: 'modalMaleBodySingleContentOpen',
	    value: function modalMaleBodySingleContentOpen(e, title) {
	      console.log(title);
	      this.setState({
	        showNewMaleComponent: true,
	        bodyTitle: title
	      });
	      (0, _jquery2.default)('.old_male_single_content').hide();
	      (0, _jquery2.default)('.new_male_single_content').show();
	      this.refreshGetBodyDepartments(title);
	      this.ShowDepartment();
	    }
	  }, {
	    key: 'ShowDepartment',
	    value: function ShowDepartment() {
	      (0, _jquery2.default)('.our-departments').show();
	      (0, _jquery2.default)('.our-consultants').hide();
	      this.refreshGetBodyDepartments();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refreshGetBodyDepartments(this.props.bodyTitle);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var OldMaleBodySVGReactElement = _react2.default.createElement(
	        'svg',
	        { xmlns: 'http://www.w3.org/2000/svg', className: 'humanBodyImg', viewBox: '120 0 1300 1500', xmlSpace: 'preserve' },
	        _react2.default.createElement(
	          'style',
	          null,
	          ".bodyParts{\
	            fill:#14b795;\
	            cursor: pointer;\
	          }\
	          .bodyLines{\
	            fill:#f2f2f2;\
	          }\
	          .syzst2{\
	            fill:none;\
	          }\
	          .labelGroup {\
	            pointer-events: none;\
	          }\
	          .labelLine {\
	            fill: none;\
	            stroke: #b3b3b3;\
	            stroke-width: 2;\
	          }\
	          .labelText {\
	            fill: #14b795;\
	            fill-rule: nonzero;\
	            transform: translateX(10px);\
	            transition: all 0.3s ease;\
	          }\
	          .labelGroup.is_right .labelText {\
	            transform: translateX(-10px);\
	          }\
	          .labelArea {\
	            fill: transparent;\
	            cursor: pointer;\
	          }\
	          .bodyParts_group:hover .bodyParts {\
	            fill: #FE5722;\
	          }\
	          .bodyParts_group:hover .labelGroup .labelText {\
	            fill: #FE5722;\
	            transform: translateX(0px);\
	          }\
	          .body_parts_active .bodyParts {\
	            fill: #FE5722;\
	          }\
	          .body_parts_active .labelGroup .labelText {\
	            fill: #FE5722;\
	            transform: translateX(0px);\
	          }\
	        "
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Head' ? 'bodyParts_group Head body_parts_active' : 'bodyParts_group Head' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Head');
	            }, className: 'bodyParts', d: 'M803.5 131.12c-3.8-14.89-14.97-36.94-50.42-39.44 0 0-.97-.1-2.68-.12h-.01c-1.86-.44-3.47.12-3.47.12-35.45 2.5-46.62 24.55-50.42 39.44-4.4 17.23-9.97 81.53-2.98 99.85 1.96 5.16 5.58 11.43 10.14 17.56.1.14.21.28.31.41l1.21.48c3.91 2.76 16.48 11.73 18.2 14.17v.01c10.76 9.89 23.07 12.86 26.53 13.52.08.02.17.03.25.05.3-.05.7-.13 1.16-.23 4.42-.96 15.86-4.18 25.82-13.34 1.71-2.44 14.3-11.41 18.21-14.18l.7-.5c.1-.13.2-.27.3-.4 4.55-6.13 8.18-12.4 10.14-17.55 6.99-18.32 1.41-82.62-2.99-99.85z' }),
	          this.props.bodyTitle === 'Head' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '175', width: '100', height: '40', rx: '2' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M794.206 194.654h300' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1120.04 207.328v-25.769h5.203v10.142h10.195v-10.142h5.203v25.769h-5.203v-11.267h-10.195v11.267h-5.203Zm36.76-5.941 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.182-1.23-1.699-1.845-3.843-1.845-6.433 0-3.094.808-5.517 2.425-7.269 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.814 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm12.619-2.039-4.482-.809c.503-1.805 1.371-3.141 2.601-4.008 1.231-.867 3.059-1.301 5.484-1.301 2.204 0 3.844.261 4.922.783 1.078.521 1.837 1.183 2.277 1.986.439.803.659 2.276.659 4.421l-.053 5.765c0 1.641.079 2.851.237 3.63.159.78.455 1.615.888 2.505h-4.887a18.301 18.301 0 0 1-.474-1.459 8.953 8.953 0 0 0-.176-.58c-.844.82-1.746 1.436-2.707 1.846a7.755 7.755 0 0 1-3.076.615c-1.922 0-3.437-.521-4.544-1.564-1.108-1.043-1.661-2.362-1.661-3.955 0-1.055.252-1.996.756-2.822.504-.826 1.21-1.459 2.118-1.898.908-.44 2.218-.823 3.929-1.152 2.308-.433 3.908-.837 4.798-1.212v-.493c0-.949-.234-1.626-.703-2.03-.469-.404-1.353-.606-2.654-.606-.879 0-1.565.172-2.057.518-.492.346-.89.952-1.195 1.82Zm6.609 4.007c-.632.211-1.634.463-3.006.756-1.371.293-2.267.58-2.689.862-.645.457-.967 1.037-.967 1.74 0 .691.258 1.289.774 1.793.515.504 1.172.756 1.968.756.891 0 1.741-.293 2.549-.879.598-.446.99-.991 1.178-1.635.129-.422.193-1.225.193-2.408v-.985Zm26.841 8.965h-4.588v-2.742c-.761 1.066-1.661 1.86-2.698 2.382-1.037.521-2.083.782-3.138.782-2.144 0-3.981-.864-5.51-2.593-1.53-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.232-7.216 1.488-1.646 3.369-2.47 5.643-2.47 2.086 0 3.89.868 5.414 2.602v-9.281h4.939v25.769Zm-13.183-9.738c0 1.992.275 3.433.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.136 0 2.103-.484 2.9-1.45.797-.967 1.195-2.412 1.195-4.333 0-2.145-.386-3.689-1.16-4.632-.773-.944-1.764-1.415-2.971-1.415-1.171 0-2.153.465-2.944 1.397-.791.932-1.186 2.323-1.186 4.175Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Neck' ? 'bodyParts_group Neck body_parts_active' : 'bodyParts_group Neck' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M749.91 277.21c.07-.01.15-.03.25-.04-.07-.01-.16-.03-.25-.05v.09zm.69 2.06.02-.15c-.18.03-.33.06-.46.08.23.04.38.06.44.07zm102.35 35.52c0-.01 0-.03.01-.04-.67-.11-1.34-.21-1.98-.3 0 .01 0 .03-.01.04.56.08 1.14.17 1.72.26.08.01.17.03.26.04zm-45.9-3.76c-.08-1.29-.16-2.4-.24-3.24l-1.99-.81.09 1.02c.39.58.78 1.15 1.17 1.7.33.46.65.89.97 1.33zM749.9 279.2v-.04c-.07-.01-.14-.02-.22-.04l.02.15c.03 0 .1-.01.2-.03v-.04zm.71-.08c.2-.04.44-.08.71-.13v-2.06c-.47.1-.86.18-1.16.23.44.08.69.12.71.12l-.26 1.84zm-.71.04v.08c.07-.01.15-.02.25-.04-.07-.01-.16-.03-.25-.04z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M749.91 277.21c-.29.05-.46.07-.47.08l.24 1.83c.08.01.15.03.22.04l.01-1.95z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M749.9 279.16c.09.02.18.03.25.04.13-.02.28-.05.46-.08l.25-1.84c-.02 0-.26-.04-.71-.12-.09.02-.17.03-.25.04v1.96z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M749.91 277.21v-.09c-3.45-.67-15.77-3.64-26.53-13.52l.13.21c.14.27.59 1.54 1.31 3.65 10.61 8.53 21.64 11.07 24.86 11.66l-.24-1.83c.01-.01.18-.03.47-.08zm1.41 1.78c3.94-.79 14.4-3.51 24.38-11.53.72-2.11 1.17-3.38 1.31-3.65.03-.06.07-.13.12-.2l.01-.01c-9.97 9.16-21.4 12.38-25.82 13.34v2.05z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'syzst2', d: 'm804.82 306.98.09 1.02c.39.58.78 1.15 1.17 1.7.32.46.65.89.97 1.33-.08-1.29-.16-2.4-.24-3.24l-1.99-.81z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyParts', d: 'M662.71 322.33c3.7.6 7.64.52 11.71-.23 5.14-.95 9.77-3.48 13.41-7.31 4.1-4.33 9.5-11.89 12.82-18.92v-.18c-.09.06-.17.12-.25.18h-.01c-10.34 7.22-32.79 16.24-41.41 17.32-2.58.32-5.69.69-9.2 1.19.66 2.01 3.21 6.37 12.93 7.95z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyParts', d: 'M736.88 347.37c.37.09.72.21 1.06.34 1.93.57 6.36 1.67 11.88 1.78l.08-70.24c-.1.01-.17.02-.2.03l-.02-.15c-3.22-.59-14.25-3.12-24.86-11.66v.01c2.75 8.04 9.32 28.23 16.91 51.52 3.31 10.19 5.93 18.24 6.86 21.03 1.11 3.3.86 5.34-.74 6.06-.32.14-.67.21-1.05.21-3.03 0-7.58-4.42-10.25-9.09-1.03-1.81-2.5-4.17-4.21-6.9-3.6-5.77-8.22-13.17-12.86-21.87-1.08 1.91-3.5 6.04-6.07 9.48-3.62 4.86-15.06 14.67-18.37 14.67-.05 0-.09 0-.13-.01-.55-.05-.99-.34-1.22-.8-.89-1.78.11-14.72.73-21.84 0 0 0 .01-.01.01-1.78 2.4-3.55 4.54-5.14 6.22-3.93 4.15-8.94 6.88-14.5 7.91-2.39.44-4.73.66-7.02.66-1.83 0-3.62-.14-5.37-.43-11.15-1.8-13.93-7.13-14.62-9.62-.15.02-.3.04-.46.07-9.14 1.41-20.52 3.81-32.07 8.74-.16.07-.33.15-.49.22 11.36 1.99 44.7 7.8 60.12 12.67 18.81 5.94 27.95 8.98 28.04 9.01l-.05.15c14.31-1.12 26.74 0 34.03 1.82z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyParts', d: 'M696.63 306.79c-.91 9.86-1.57 21.35-1.22 23.73 2.48-.7 12.53-8.62 16.4-13.81 3.3-4.43 6.48-10.25 6.51-10.3l.15.08c-3.41-6.51-6.79-13.72-9.74-21.49-.57-1.51-1.71-4.64-2.62-8.43.2 6.37.17 11.73-.44 13.88-.1.36-.31.74-.57 1.14.01-.01.02-.01.02-.02-1.67 4.38-5.52 10.84-8.49 15.22zm37.41 22.45c1.71 2.75 3.2 5.12 4.25 6.97 3.09 5.4 7.64 8.54 8.75 8.04.15-.07.56-.89-.34-3.6-.94-2.8-3.56-10.85-6.87-21.04-6.93-21.28-17.4-53.43-18.11-54.91-.62-1.11-8.27-6.93-15.89-12.37.73 6.84 3.06 27.5 4.76 31.95 7.22 18.97 16.99 34.61 23.45 44.96zm17.17 15.52-.01 4.73c3.46-.04 7.28-.48 11.16-1.69.41-.17.83-.31 1.28-.43 7.29-1.82 19.71-2.94 34.01-1.84l-.05-.14c.09-.03 9.24-3.07 28.05-9.01 15.94-5.03 49.02-11.07 59.18-12.86-.02-.01-.05-.02-.07-.03-11.44-4.88-22.73-7.28-31.82-8.7-.24 1.74-2.02 7.45-14.81 9.51-1.74.29-3.54.43-5.37.43-2.28 0-4.63-.22-7.01-.66-5.56-1.03-10.58-3.76-14.51-7.91-1.27-1.35-2.71-3.12-4.19-5.13.41 6.93.67 18.98-.21 20.74-.23.46-.67.75-1.22.8-.04 0-.09.01-.13.01-3.3 0-14.74-9.81-18.36-14.67-2.57-3.44-4.99-7.57-6.07-9.48-4.65 8.71-9.27 16.11-12.87 21.87-1.7 2.73-3.17 5.09-4.21 6.9-2.67 4.67-7.22 9.09-10.24 9.09-.38 0-.73-.07-1.06-.21-.58-.27-.98-.71-1.2-1.32v-.04c-.28-.76-.28-1.79 0-3.05v-.04c.11-.51.26-1.02.46-1.61.93-2.79 3.54-10.8 6.84-20.95 7.59-23.33 14.18-43.54 16.93-51.6v-.01c-9.98 8.01-20.44 10.74-24.38 11.53l-.11 62.64v3.13z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyParts', d: 'M753.83 340.65c-.9 2.71-.5 3.53-.34 3.6 1.1.5 5.66-2.64 8.75-8.04 1.05-1.85 2.53-4.22 4.25-6.97 6.46-10.35 16.22-25.99 23.45-44.96 1.69-4.45 4.02-25.11 4.76-31.95-7.62 5.44-15.27 11.26-15.9 12.38-.71 1.47-11.19 33.67-18.13 54.98-3.3 10.15-5.91 18.17-6.84 20.96zm28.24-34.17.14-.07c.03.06 3.2 5.88 6.51 10.3 3.88 5.2 13.93 13.12 16.4 13.82.34-2.32.62-12.76-.21-22.52-.24-.35-.47-.7-.71-1.06-2.71-4.13-5.32-8.78-7.11-13.01-.14-.12-.29-.24-.42-.36-.01 0-.01-.01-.01-.01-1.24-1.14-2.06-2.19-2.32-3.11-.68-2.41-.64-8.86-.35-16.24-.73 4.83-1.5 8.98-2.18 10.79-2.96 7.75-6.34 14.96-9.74 21.47z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyParts', d: 'M826.11 322.1c4.07.75 8 .83 11.7.23 11.76-1.9 13.03-6.91 13.15-7.84-.08-.01-.17-.03-.26-.04-3.71-.54-6.99-.92-9.69-1.26-8.39-1.05-29.87-9.62-40.55-16.74 3.46 6.98 8.6 14.53 12.22 18.34 3.65 3.83 8.29 6.36 13.43 7.31zm-74.91 27.39.01-4.73v-3.13l.11-62.64c-.26.05-.5.1-.71.13l-.02.15c-.05-.01-.21-.03-.44-.07-.1.02-.18.03-.25.04l-.08 70.24c.46.01.91.01 1.38.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'm718.46 306.49 1.61.88c-.03.06-.24.45-.59 1.06 4.64 8.7 9.26 16.1 12.86 21.87 1.71 2.73 3.18 5.09 4.21 6.9 2.67 4.67 7.22 9.09 10.25 9.09.38 0 .73-.07 1.05-.21 1.6-.72 1.85-2.76.74-6.06-.93-2.79-3.55-10.84-6.86-21.03-7.59-23.29-14.16-43.48-16.91-51.52v-.01c-.97-.78-1.93-1.6-2.88-2.48l1.36-1.47c.03.03.06.05.09.08v-.01c-1.72-2.44-14.29-11.41-18.2-14.17l-1.21-.48c.27.37.54.73.83 1.1.23 5.64.77 13.96 1.11 21.66v.03c0 .01 0 .03.01.04.07 1.64.14 3.25.18 4.8.91 3.79 2.05 6.91 2.62 8.43 2.94 7.78 6.32 14.99 9.73 21.5zm-12.63-54.16c7.62 5.44 15.27 11.26 15.89 12.37.71 1.48 11.18 33.63 18.11 54.91 3.31 10.19 5.93 18.24 6.87 21.04.9 2.71.49 3.53.34 3.6-1.11.5-5.66-2.64-8.75-8.04-1.05-1.85-2.54-4.22-4.25-6.97-6.46-10.35-16.23-25.99-23.45-44.96-1.7-4.45-4.03-25.11-4.76-31.95zm-43.44 71.97c1.75.29 3.54.43 5.37.43 2.29 0 4.63-.22 7.02-.66 5.56-1.03 10.57-3.76 14.5-7.91 1.59-1.68 3.36-3.82 5.14-6.22 0 0 0-.01.01-.01.11-1.26.21-2.34.29-3.14l1.99-.81c-.03.27-.05.54-.07.81 2.97-4.39 6.82-10.84 8.48-15.23-.01.01-.02.01-.02.02-.34.52-.8 1.06-1.38 1.62l-.01.01c-.81.78-1.85 1.61-3.05 2.47v.18c-3.32 7.03-8.72 14.59-12.82 18.92-3.64 3.83-8.27 6.36-13.41 7.31-4.07.75-8.01.83-11.71.23-9.72-1.58-12.27-5.93-12.93-7.95-.16.02-.32.04-.48.07-.5.07-1.01.15-1.53.23.68 2.5 3.46 7.83 14.61 9.63z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'm718.46 306.49-.15-.08c-.03.06-3.2 5.87-6.51 10.3-3.87 5.19-13.92 13.12-16.4 13.81-.34-2.39.31-13.87 1.22-23.73-.04.05-.07.11-.11.17-.69 1.03-1.4 2.01-2.09 2.97-.63 7.12-1.62 20.06-.73 21.84.23.46.67.75 1.22.8.04 0 .09.01.13.01 3.3 0 14.74-9.81 18.37-14.67 2.57-3.44 4.99-7.57 6.07-9.48-.34-.64-.68-1.28-1.02-1.94z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M718.46 306.49c.34.66.68 1.3 1.02 1.94.35-.61.56-1 .59-1.06l-1.61-.88zm-21.83.3c.03-.27.05-.55.07-.81l-1.99.81c-.08.8-.18 1.88-.29 3.14.7-.96 1.41-1.94 2.09-2.97.05-.05.09-.11.12-.17zm62.14 12.28c-3.3 10.15-5.91 18.16-6.84 20.95-.2.59-.35 1.1-.46 1.61v.04c-.28 1.26-.28 2.29 0 3.05v.04c.22.61.62 1.05 1.2 1.32.33.14.68.21 1.06.21 3.02 0 7.57-4.42 10.24-9.09 1.04-1.81 2.51-4.17 4.21-6.9 3.6-5.77 8.22-13.17 12.87-21.87-.35-.61-.56-1-.59-1.06l1.61-.88v-.01c3.4-6.51 6.78-13.72 9.74-21.48.68-1.81 1.45-5.97 2.18-10.79.03-.83.07-1.67.11-2.52v-.05c.34-7.68.88-15.97 1.11-21.6.29-.37.56-.74.84-1.12l-.7.5c-3.91 2.77-16.5 11.74-18.21 14.18.03-.03.06-.05.09-.08l1.36 1.47c-.95.88-1.92 1.7-2.88 2.47v.01c-2.76 8.06-9.35 28.27-16.94 51.6zm20.03-54.36c.63-1.12 8.28-6.94 15.9-12.38-.74 6.84-3.07 27.5-4.76 31.95-7.23 18.97-16.99 34.61-23.45 44.96-1.72 2.75-3.2 5.12-4.25 6.97-3.09 5.4-7.65 8.54-8.75 8.04-.16-.07-.56-.89.34-3.6.93-2.79 3.54-10.81 6.84-20.96 6.94-21.31 17.42-53.51 18.13-54.98zM804.91 308l-.09-1.02 1.99.81c.08.84.16 1.95.24 3.24 1.48 2.01 2.92 3.78 4.19 5.13 3.93 4.15 8.95 6.88 14.51 7.91 2.38.44 4.73.66 7.01.66 1.83 0 3.63-.14 5.37-.43 12.79-2.06 14.57-7.77 14.81-9.51-.08-.01-.17-.03-.26-.04-.58-.1-1.16-.18-1.72-.26-.13.93-1.39 5.94-13.15 7.84-3.7.6-7.63.52-11.7-.23-5.14-.95-9.78-3.48-13.42-7.31-3.62-3.81-8.76-11.36-12.22-18.34-.13-.09-.27-.17-.39-.26h-.01c-1.14-.78-2.14-1.54-2.98-2.26 1.8 4.23 4.4 8.88 7.11 13.01.24.36.47.71.71 1.06z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M804.91 308c.84 9.77.55 20.2.21 22.52-2.47-.69-12.53-8.62-16.4-13.82-3.3-4.43-6.48-10.25-6.51-10.3l-.14.08c-.34.66-.68 1.29-1.02 1.93v.01c1.08 1.91 3.5 6.04 6.07 9.48 3.62 4.86 15.06 14.67 18.36 14.67.05 0 .09 0 .13-.01.55-.05.99-.34 1.22-.8.88-1.77.62-13.81.21-20.74-.32-.44-.64-.87-.97-1.33-.38-.54-.77-1.11-1.16-1.69z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'm782.07 306.49-1.61.87c.03.06.24.45.59 1.06v-.01c.34-.63.68-1.26 1.02-1.92zm-58.77-42.97s-1.56.69-1.58 1.18c-.04 1.04 3.1 2.76 3.1 2.76s-.85-3.17-1.52-3.94zm52.4 3.94 1.44-3.87s1.47-.68 1.66 1.11l-1.16 3.27-1.94-.51z' }),
	          this.props.bodyTitle === 'Neck' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '282', width: '100', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M794.206 302.225h300' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1120.08 314.899V289.13h5.062l10.547 17.209V289.13h4.834v25.769h-5.22l-10.389-16.804v16.804h-4.834Zm36.72-5.941 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.269 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm25.209-2.215-4.869.879c-.164-.973-.536-1.705-1.116-2.197-.581-.493-1.333-.739-2.259-.739-1.231 0-2.212.425-2.945 1.275-.732.849-1.098 2.27-1.098 4.262 0 2.215.372 3.78 1.116 4.694.744.914 1.743 1.371 2.997 1.371.938 0 1.705-.267 2.303-.8.597-.533 1.019-1.45 1.265-2.751l4.852.826c-.504 2.227-1.471 3.908-2.9 5.045-1.43 1.137-3.346 1.705-5.748 1.705-2.731 0-4.908-.861-6.531-2.584-1.623-1.722-2.434-4.107-2.434-7.154 0-3.082.814-5.482 2.443-7.198 1.629-1.717 3.832-2.576 6.609-2.576 2.274 0 4.082.49 5.423 1.468 1.342.979 2.306 2.47 2.892 4.474Zm3.57 13.148V289.13h4.94v13.676l5.783-6.575h6.082l-6.381 6.821 6.838 11.847h-5.326l-4.694-8.384-2.302 2.408v5.976h-4.94Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Right Shoulder' ? 'bodyParts_group Right_Shoulder body_parts_active' : 'bodyParts_group Right_Shoulder' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Shoulder');
	            }, className: 'bodyParts', d: 'M626.27 471.67c.11-.25.27-.47.49-.6-.1-.5-.18-1-.23-1.5-1-9.97 3.72-35.6 4.2-38.14-.29-1.24-.55-2.38-.78-3.41-.36-1.61-.66-2.92-.89-3.86-.6-2.41-2.6-6.58-5.79-12.11-4.19 9.1-23.52 51.62-28.81 73.66-1.86 7.74-3.63 17.1-5.35 26.14-4.01 21.12-6.76 34.72-10.28 38.58 2.57.81 5.22.73 7.89-.27 12.4-4.61 22.77-27.81 22.86-28.03l.19.26c1.45-4.77 2.8-9.24 3.87-12.88 4.1-13.93 6.18-31.9 6.8-37.89.05-.53.77-.63.96-.14.81 2.02 2.15 5.36 3.52 8.75.05.12.12.28.19.44-.15-3.04-.08-6.07 1.16-9zm-64.59 9.06c1.48-4.92 3.08-10.26 4.82-15.71.29-.91.59-1.84.89-2.76-1.48-10.07-3.48-30.96-4.42-41.05v-.83c-.08.6-.16 1.2-.26 1.8v.03c-.59 3.41-1.52 6.76-2.8 10-2.7 6.85-5.85 17.11-6.98 28.36-.96 9.62-1.95 30.12-3.18 49.45 1.39-2.25 3.23-5.41 5.3-9.47 1.66-3.25 3.85-10.56 6.63-19.82zm16.38-46.22c9.87-20.64 32.64-30.29 37.65-32.2.23-.09.73-.31 1.27-.55l-.27-.45c-3.26-5.69-2.76-12.74 1.31-17.78 4.98-6.18 10.32-10.84 17.14-15.14 6.82-4.3 15.1-8.24 25.99-12.96 12.21-5.28 25.16-8.16 37.1-9.46-4.37-1.43-12.32-4-23.99-7.68-17.68-5.59-57.7-12.43-62.48-13.25-10.96 5.16-21.88 12.7-30.97 23.95-5.74 7.1-9.73 15.46-11.75 24.36-2.01 8.84-4.54 22.05-5.35 35.1.75 7.99 3.44 36.37 5.11 49.48 2.77-8.16 5.84-16.3 9.24-23.42z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Shoulder');
	            }, className: 'bodyParts', d: 'M581.43 538.72c1.91-7.24 3.75-16.95 5.7-27.23 1.72-9.07 3.5-18.45 5.37-26.24 5.65-23.54 27.09-70.06 29.52-75.3-1.1-1.87-2.33-3.88-3.67-6.01-.76.01-1.44.04-1.57.09-3.82 1.41-27.07 10.73-36.92 31.33-3.9 8.15-7.36 17.69-10.43 27.07l.06.37-.18.03c-2.08 6.4-3.99 12.72-5.72 18.47-2.81 9.35-5.03 16.74-6.77 20.15-.53 1.05-1.04 2.01-1.54 2.93l.33-.03c0 .01.01.09.03.22.16 1.42 1.18 9.49 3.89 18.55.3.96.6 1.92.93 2.89 3.19 9.52 8.3 19.47 16.26 23.55.47-.08 2.15-1.11 4.71-10.84z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Shoulder');
	            }, className: 'bodyLines', d: 'M553 508.48c.3-.5.6-1.04.92-1.59-.18-1.3-.27-2.12-.29-2.33l1.66-.17c.5-.92 1.01-1.89 1.54-2.93 1.74-3.41 3.96-10.8 6.77-20.15 1.73-5.75 3.63-12.07 5.72-18.47l-1.8.28c-.01-.03-.01-.07-.02-.1v-.01c-.04-.24-.07-.49-.11-.75-.3.92-.6 1.85-.89 2.76-1.74 5.45-3.34 10.79-4.82 15.71-2.78 9.26-4.97 16.57-6.63 19.82-2.07 4.06-3.91 7.22-5.3 9.47 0 .07-.01.13-.01.2-.09 1.3-.17 2.6-.26 3.9.76-1.11 1.97-2.97 3.52-5.63v-.01zm15.91-49.84c.19 1.4.36 2.68.53 3.8 3.06-9.38 6.52-18.92 10.43-27.07 9.85-20.6 33.1-29.92 36.92-31.33.13-.05.81-.07 1.57-.09-.19-.3-.38-.6-.57-.91-.22-.34-.45-.69-.67-1.04-.05-.08-.09-.16-.14-.24-.53.24-1.04.46-1.27.55-5.01 1.91-27.78 11.56-37.65 32.2-3.4 7.12-6.47 15.26-9.24 23.42.03.23.06.48.09.7v.01zm-1.52 3.62c.18-.54.35-1.08.52-1.62.3-.9.6-1.81.91-2.71-1.68-13.11-4.36-41.49-5.11-49.48-.12 1.96-.2 3.91-.24 5.85-.01.7-.04 1.4-.09 2.1a52.58 52.58 0 0 1-.41 3.98v.83c.94 10.09 2.94 30.98 4.42 41.05zm2.06.18c-.04.13-.09.26-.13.4l.18-.03a4.69 4.69 0 0 1-.05-.37z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Shoulder');
	            }, className: 'bodyLines', d: 'M568.91 458.64v-.01c-.03-.22-.06-.47-.09-.7-.31.9-.61 1.81-.91 2.71-.17.54-.35 1.08-.52 1.62.04.25.07.51.11.75v.01c.01.03.01.07.02.1l1.8-.28c.04-.13.09-.26.13-.4-.18-1.12-.35-2.4-.54-3.8zm53.12-48.68c-2.43 5.24-23.88 51.76-29.52 75.3-1.87 7.79-3.65 17.17-5.37 26.24-1.95 10.28-3.8 19.99-5.7 27.23-2.56 9.73-4.24 10.76-4.7 10.85.06.04.12.07.18.1.63.32 1.27.58 1.91.78 3.52-3.86 6.27-17.46 10.28-38.58 1.72-9.05 3.49-18.4 5.35-26.14 5.29-22.04 24.62-64.57 28.81-73.66-.4-.7-.8-1.4-1.24-2.12zm76.22-63.99h.02c1.56-.17 3.08-.31 4.59-.43l.05-.15c-.09-.03-9.23-3.07-28.04-9.01-15.42-4.87-48.77-10.68-60.12-12.67-.9.39-1.8.79-2.7 1.2-.09.04-.18.09-.27.13 4.79.82 44.8 7.66 62.48 13.25 11.67 3.68 19.62 6.25 23.99 7.68z' }),
	          this.props.bodyTitle === 'Right Shoulder' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '105', y: '456', width: '275', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup is_right' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M405 479.666h160' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M125.046 488.982v-25.769h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.183 1.125 2.537 1.125 4.06 0 1.934-.568 3.531-1.705 4.79-1.137 1.26-2.836 2.054-5.097 2.382 1.125.656 2.053 1.377 2.786 2.162.732.785 1.719 2.18 2.962 4.184l3.146 5.027h-6.223l-3.761-5.607c-1.336-2.004-2.25-3.267-2.742-3.788-.493-.522-1.014-.879-1.565-1.072-.551-.194-1.424-.291-2.619-.291h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.055-.105 4.676-.316a2.803 2.803 0 0 0 1.459-1.09c.351-.516.527-1.16.527-1.934 0-.867-.231-1.567-.694-2.1-.463-.533-1.117-.87-1.96-1.011-.422-.059-1.688-.088-3.797-.088h-4.061v6.539Zm20.742-6.328v-4.57h4.94v4.57h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.231 5.643.685c.094.657.31 1.108.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.193 2.901-.58.433-.258.761-.674.984-1.248.152-.41.228-1.166.228-2.268v-2.724c-1.476 2.015-3.339 3.023-5.589 3.023-2.508 0-4.495-1.06-5.959-3.181-1.149-1.676-1.723-3.762-1.723-6.258 0-3.129.753-5.52 2.259-7.172 1.506-1.652 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.94-.363 1.09-.873 1.945-1.529 2.566-.657.621-1.533 1.108-2.628 1.459-1.096.352-2.482.527-4.157.527-3.165 0-5.409-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.597Zm4.412-10.951c0 1.98.384 3.43 1.152 4.35.767.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.398-3.37-1.195-4.307-.797-.938-1.805-1.406-3.023-1.406-1.184 0-2.16.46-2.927 1.38-.768.92-1.152 2.323-1.152 4.21Zm22.957-16.049v9.474c1.594-1.863 3.499-2.795 5.713-2.795 1.137 0 2.162.211 3.077.633.914.422 1.602.961 2.065 1.617.463.657.779 1.383.949 2.18.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.282-3.727a2.438 2.438 0 0 0-.993-1.256c-.474-.311-1.069-.466-1.784-.466-.82 0-1.553.199-2.197.597-.645.399-1.116.999-1.415 1.802-.299.803-.449 1.989-.449 3.56v9.351h-4.939v-25.769h4.939Zm25.629 7.101v3.938h-3.375v7.523c0 1.524.033 2.411.097 2.663.065.252.211.46.44.624.228.164.506.246.834.246.458 0 1.12-.158 1.987-.474l.422 3.832c-1.149.492-2.45.738-3.903.738-.89 0-1.693-.149-2.408-.448-.715-.299-1.239-.686-1.573-1.16-.334-.475-.566-1.116-.694-1.925-.106-.574-.159-1.734-.159-3.481v-8.138h-2.267v-3.938h2.267v-3.709l4.957-2.882v6.591h3.375Zm12.147 10.284 5.062-.493c.305 1.7.923 2.948 1.855 3.744.932.797 2.188 1.196 3.77 1.196 1.676 0 2.939-.355 3.788-1.064.85-.709 1.275-1.538 1.275-2.487 0-.609-.179-1.128-.536-1.556-.358-.427-.982-.799-1.872-1.116-.61-.211-1.998-.586-4.166-1.125-2.789-.691-4.746-1.541-5.871-2.549-1.582-1.418-2.373-3.146-2.373-5.185 0-1.313.372-2.54 1.116-3.683.744-1.142 1.816-2.013 3.217-2.61 1.4-.598 3.09-.897 5.071-.897 3.234 0 5.669.709 7.304 2.127 1.634 1.418 2.493 3.311 2.575 5.678l-5.203.228c-.223-1.324-.701-2.276-1.433-2.856-.732-.58-1.831-.87-3.296-.87-1.512 0-2.695.31-3.551.932-.55.398-.826.931-.826 1.599 0 .61.258 1.131.774 1.565.656.55 2.25 1.125 4.781 1.722 2.531.598 4.403 1.216 5.616 1.855 1.213.638 2.162 1.512 2.848 2.619.685 1.107 1.028 2.476 1.028 4.104 0 1.477-.41 2.86-1.23 4.149-.821 1.289-1.981 2.247-3.481 2.874-1.5.627-3.369.94-5.607.94-3.258 0-5.76-.753-7.506-2.258-1.746-1.506-2.789-3.701-3.129-6.583Zm30.217-17.385v9.474c1.593-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.657.779 1.383.949 2.18.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.281-3.727a2.445 2.445 0 0 0-.994-1.256c-.474-.311-1.069-.466-1.784-.466-.82 0-1.553.199-2.197.597-.645.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm15.925 16.172c0-1.641.405-3.229 1.213-4.764.809-1.535 1.954-2.707 3.437-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.138.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.953 0 2.824-.911 5.165-2.733 7.022-1.823 1.857-4.117 2.786-6.882 2.786-1.711 0-3.343-.387-4.896-1.16-1.552-.773-2.733-1.907-3.542-3.401-.808-1.495-1.213-3.314-1.213-5.458Zm5.063.263c0 1.852.439 3.27 1.318 4.254.879.985 1.963 1.477 3.252 1.477 1.289 0 2.37-.492 3.243-1.477.873-.984 1.31-2.414 1.31-4.289 0-1.828-.437-3.234-1.31-4.219-.873-.984-1.954-1.476-3.243-1.476s-2.373.492-3.252 1.476c-.879.985-1.318 2.403-1.318 4.254Zm30.357 9.334v-2.795a7.191 7.191 0 0 1-2.68 2.356 7.52 7.52 0 0 1-3.507.861c-1.254 0-2.379-.275-3.375-.826-.996-.551-1.717-1.324-2.162-2.32-.446-.996-.668-2.373-.668-4.131v-11.813h4.939v8.578c0 2.625.091 4.234.273 4.826.181.591.512 1.06.993 1.406.48.346 1.09.518 1.828.518.844 0 1.6-.231 2.268-.694.668-.463 1.125-1.037 1.371-1.723.246-.685.369-2.364.369-5.036v-7.875h4.939v18.668h-4.588Zm9.704-25.769h4.939v25.77h-4.939zm27.123 25.769h-4.588v-2.742c-.762 1.066-1.661 1.86-2.699 2.382-1.037.521-2.083.782-3.137.782-2.145 0-3.982-.864-5.511-2.593-1.529-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.232-7.216 1.489-1.646 3.37-2.47 5.643-2.47 2.086 0 3.891.868 5.414 2.602v-9.281h4.94v25.769Zm-13.184-9.738c0 1.992.275 3.434.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.137 0 2.103-.484 2.9-1.45.797-.967 1.196-2.412 1.196-4.333 0-2.145-.387-3.689-1.16-4.632-.774-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.466-2.945 1.397-.791.932-1.186 2.323-1.186 4.175Zm28.863 3.797 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429H352.56c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.527-.422.926-1.102 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.382Zm13.659 10.933h-4.94v-18.668h4.588v2.655c.785-1.254 1.491-2.08 2.118-2.479.627-.398 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.307c-.832-.539-1.606-.809-2.321-.809-.691 0-1.277.191-1.757.571-.481.381-.859 1.07-1.134 2.066-.276.996-.413 3.082-.413 6.258v5.765Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Left Shoulder' ? 'bodyParts_group Left_Shoulder body_parts_active' : 'bodyParts_group Left_Shoulder' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyLines', d: 'M933.89 539.3c-.01.03-.05.18-.11.43.1-.16.2-.33.3-.5l-.19.07zm-12.18 11.15c.68.75 1.39 1.13 2.14 1.13.13 0 .25-.01.38-.03l-.33-1.97c-.02 0-.06.01-.11 0-.06.04-.12.07-.17.1-.63.31-1.27.57-1.91.77z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyParts', d: 'M934.09 539.23c2.51-4.07 4.47-8.73 5.99-13.3.33-.94.62-1.88.9-2.81 2.71-9.03 3.73-17.08 3.9-18.53-.69-1.26-1.42-2.62-2.18-4.12-1.74-3.41-3.96-10.8-6.77-20.16-4.3-14.3-9.65-32.1-16.26-45.94-9.87-20.64-33.19-29.95-36.93-31.33-1.55 2.47-2.97 4.77-4.24 6.91 2.41 5.19 23.88 51.76 29.53 75.31 1.87 7.79 3.65 17.17 5.37 26.24 1.95 10.28 3.8 19.99 5.7 27.23 2.56 9.74 4.25 10.76 4.7 10.85h.01c4.02-2.06 7.3-5.61 9.98-9.84.06-.25.1-.4.11-.43l.19-.08z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyParts', d: 'M802.28 345.96c11.93 1.3 24.89 4.18 37.09 9.47 21.77 9.44 33.17 15.73 43.14 28.1 4.06 5.04 4.56 12.09 1.3 17.78 4.95 1.89 27.77 11.52 37.65 32.2 3.79 7.92 7.15 17.09 10.14 26.17v-.01c1.52-11.64 4-33.94 5.02-43.17 0-.03-.01-.06-.01-.09-.05-.7-.08-1.4-.09-2.1-.26-14.83-3.28-30.78-5.58-40.95-2.02-8.9-6.01-17.26-11.75-24.36-9.13-11.29-20.1-18.86-31.1-24.01-2.5.44-43.58 7.54-61.84 13.31-11.66 3.67-19.61 6.24-23.97 7.66zm135.56 133.77c2.78 9.26 4.98 16.57 6.64 19.82 2.31 4.52 4.33 7.94 5.76 10.21-1.22-19.26-2.2-39.62-3.16-49.19-1.13-11.25-4.28-21.51-6.98-28.36-1.17-2.95-2.03-6-2.62-9.1-.99 10.67-3.01 31.47-4.46 40.93 1.74 5.44 3.34 10.77 4.82 15.69zm-26.41 32.14c-1.72-9.05-3.49-18.4-5.35-26.15-5.29-22.05-24.63-64.6-28.82-73.67-3.17 5.54-5.18 9.71-5.78 12.12-.24.93-.53 2.25-.89 3.85-.23 1.04-.5 2.19-.78 3.44v.01c.47 2.49 4.51 24.43 4.33 35.6.17.07.33.19.45.39 1.17 2.01 2.24 4.07 3.17 6.19.32-.81.62-1.54.86-2.15.2-.49.92-.39.96.14.62 5.99 2.7 23.96 6.81 37.89 1.12 3.84 2.56 8.62 4.11 13.69 2.41 4.64 12.48 22.93 23.32 26.97 2.67.99 5.32 1.08 7.89.26-3.52-3.86-6.27-17.46-10.28-38.58z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyLines', d: 'M937.84 479.73c-1.48-4.92-3.08-10.25-4.82-15.7v.01c0 .03-.01.05-.01.08l-1.98-.31c.19-1.21.38-2.6.58-4.14-2.99-9.08-6.36-18.25-10.14-26.17-9.89-20.67-32.7-30.31-37.65-32.2-.13.23-.27.46-.41.69-.22.35-.45.7-.67 1.04 3.74 1.38 27.06 10.69 36.93 31.33 6.62 13.83 11.97 31.63 16.26 45.94 2.81 9.35 5.03 16.74 6.77 20.16.77 1.5 1.49 2.87 2.18 4.12.02-.14.03-.21.03-.23l1.99.2c-.02.24-.14 1.29-.38 2.93 1.91 3.28 3.33 5.38 3.98 6.29-.08-1.18-.16-2.37-.23-3.56l-.03-.46c-1.44-2.27-3.45-5.68-5.76-10.21-1.66-3.24-3.86-10.55-6.64-19.81z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyLines', d: 'M931.61 459.67c.48 1.46.95 2.91 1.41 4.36 1.45-9.46 3.46-30.26 4.46-40.93-.06-.3-.13-.6-.18-.9v-.02a49.5 49.5 0 0 1-.67-5.7c-1.01 9.23-3.49 31.53-5.02 43.17v.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyLines', d: 'M933.01 464.12c0-.03.01-.05.01-.08v-.01c-.46-1.45-.93-2.9-1.41-4.36-.2 1.54-.39 2.93-.58 4.14l1.98.31zm8.81 63.13c2.73-7.97 4.11-15.67 4.7-19.75v-.01c-.51-.88-1.06-1.85-1.64-2.9-.17 1.45-1.19 9.5-3.9 18.53-.28.93-.57 1.87-.9 2.81-1.52 4.56-3.49 9.22-5.99 13.3l2.74-1.01c-.01.04-.07.28-.18.68.32-.56.64-1.13.94-1.7 1.68-3.19 3.08-6.59 4.23-9.95zm-28.71 24.81c1.71.63 3.4.95 5.08.95 2.14 0 4.26-.52 6.32-1.55 3.08-1.54 5.74-3.84 8.06-6.62.59-2.58 1.02-4.35 1.21-5.12-2.68 4.23-5.97 7.78-9.98 9.84h-.01c.05.01.09.01.11 0l.33 1.97c-.13.02-.26.03-.38.03-.75 0-1.46-.39-2.14-1.13-2.57.82-5.22.73-7.89-.26-10.84-4.04-20.91-22.32-23.32-26.97.04.13.08.25.12.38.55 1.8 1.11 3.64 1.68 5.49l.93 3.01c4.2 7.2 11.69 16.93 19.88 19.98z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyLines', d: 'M934.09 539.23c-.1.17-.2.34-.3.5-.19.77-.63 2.54-1.21 5.12 1.51-1.81 2.86-3.81 4.08-5.94.1-.4.17-.64.18-.68l-2.75 1zm-14.99-.5c-1.91-7.24-3.75-16.95-5.7-27.23-1.72-9.07-3.5-18.45-5.37-26.24-5.65-23.55-27.12-70.12-29.53-75.31-.42.72-.83 1.41-1.23 2.09v.01c4.18 9.08 23.52 51.63 28.82 73.67 1.86 7.74 3.63 17.1 5.35 26.15 4.01 21.12 6.76 34.72 10.28 38.58.65-.2 1.29-.46 1.92-.78.06-.03.12-.06.17-.1-.47-.08-2.15-1.11-4.71-10.84zm26.93-34.92s1.31.15 1.4 1.23l-.9 2.46-1.64-2.91v-.78c-.01 0 .26-.75 1.14 0zm-71.89-36.74s.01 5.75-1.41 4.25l3.96 4.97 1.06-2.64s-2.1-5.73-3.61-6.58zm-76.53-121.68.05.14c1.52.12 3.06.26 4.62.43 4.36-1.42 12.31-3.99 23.98-7.67 18.26-5.77 59.34-12.87 61.84-13.31-.05-.02-.1-.05-.15-.07-1.04-.49-2.07-.95-3.11-1.39-10.16 1.79-43.25 7.83-59.18 12.86-18.81 5.94-27.96 8.98-28.05 9.01z' }),
	          this.props.bodyTitle === 'Left Shoulder' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '456', width: '245', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M934.206 476.106h160' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1120.17 488.982v-25.558h5.203v21.216h12.937v4.342h-18.14Zm32.62-5.941 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429H1145.6c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.048 1.852-1.037 3.2h7.383Zm6.769-7.735h2.742v-1.406c0-1.57.167-2.742.501-3.516.334-.773.949-1.403 1.846-1.889.896-.487 2.03-.73 3.401-.73 1.406 0 2.783.211 4.131.633l-.668 3.445a9.783 9.783 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.71 0v3.938h-3.375v7.523c0 1.524.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.474l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.686-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.481v-8.138h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm12.15 10.284 5.063-.493c.304 1.7.922 2.948 1.854 3.744.932.797 2.189 1.196 3.771 1.196 1.675 0 2.938-.355 3.788-1.064.849-.709 1.274-1.538 1.274-2.487 0-.609-.179-1.128-.536-1.556-.357-.427-.982-.799-1.872-1.116-.61-.211-1.998-.586-4.166-1.125-2.789-.691-4.746-1.541-5.871-2.549-1.582-1.418-2.373-3.146-2.373-5.185 0-1.313.372-2.54 1.116-3.683.744-1.142 1.816-2.013 3.217-2.61 1.4-.598 3.091-.897 5.071-.897 3.234 0 5.669.709 7.304 2.127 1.634 1.418 2.493 3.311 2.575 5.678l-5.203.228c-.223-1.324-.7-2.276-1.433-2.856-.732-.58-1.831-.87-3.296-.87-1.511 0-2.695.31-3.551.932-.55.398-.826.931-.826 1.599 0 .61.258 1.131.774 1.565.656.55 2.25 1.125 4.781 1.722 2.531.598 4.403 1.216 5.616 1.855 1.213.638 2.162 1.512 2.848 2.619.685 1.107 1.028 2.476 1.028 4.104 0 1.477-.41 2.86-1.23 4.149-.821 1.289-1.981 2.247-3.481 2.874-1.5.627-3.369.94-5.607.94-3.258 0-5.76-.753-7.506-2.258-1.746-1.506-2.789-3.701-3.129-6.583Zm30.21-17.385v9.474c1.594-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.657.78 1.383.95 2.18.169.797.254 2.033.254 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.281-3.727a2.448 2.448 0 0 0-.993-1.256c-.475-.311-1.07-.466-1.785-.466-.82 0-1.552.199-2.197.597-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm15.93 16.172c0-1.641.404-3.229 1.213-4.764.808-1.535 1.954-2.707 3.436-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.953 0 2.824-.911 5.165-2.733 7.022-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.773-2.734-1.907-3.542-3.401-.809-1.495-1.213-3.314-1.213-5.458Zm5.062.263c0 1.852.44 3.27 1.318 4.254.879.985 1.963 1.477 3.252 1.477 1.29 0 2.371-.492 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.252 1.476-.878.985-1.318 2.403-1.318 4.254Zm30.358 9.334v-2.795a7.202 7.202 0 0 1-2.681 2.356 7.518 7.518 0 0 1-3.507.861c-1.254 0-2.379-.275-3.375-.826-.996-.551-1.717-1.324-2.162-2.32-.445-.996-.668-2.373-.668-4.131v-11.813h4.939v8.578c0 2.625.091 4.234.273 4.826.182.591.513 1.06.993 1.406.481.346 1.09.518 1.828.518.844 0 1.6-.231 2.268-.694.668-.463 1.125-1.037 1.371-1.723.246-.685.369-2.364.369-5.036v-7.875h4.939v18.668h-4.587Zm9.7-25.769h4.939v25.77h-4.939zm27.13 25.769h-4.588v-2.742c-.762 1.066-1.661 1.86-2.698 2.382-1.038.521-2.083.782-3.138.782-2.145 0-3.982-.864-5.511-2.593-1.529-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.233-7.216 1.488-1.646 3.369-2.47 5.642-2.47 2.086 0 3.891.868 5.414 2.602v-9.281h4.94v25.769Zm-13.184-9.738c0 1.992.276 3.434.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.137 0 2.104-.484 2.901-1.45.796-.967 1.195-2.412 1.195-4.333 0-2.145-.387-3.689-1.16-4.632-.774-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.466-2.944 1.397-.791.932-1.187 2.323-1.187 4.175Zm28.864 3.797 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.527-.422.926-1.102 1.195-2.039Zm.282-4.992c-.035-1.43-.405-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm13.648 10.933h-4.94v-18.668h4.588v2.655c.785-1.254 1.492-2.08 2.118-2.479.627-.398 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.307c-.832-.539-1.606-.809-2.32-.809-.692 0-1.278.191-1.758.571-.481.381-.859 1.07-1.134 2.066-.275.996-.413 3.082-.413 6.258v5.765Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Right Elbow' ? 'bodyParts_group Right_Elbow body_parts_active' : 'bodyParts_group Right_Elbow' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'M586.71 550.18c-2.67 1-5.32 1.08-7.89.27-.68.75-1.39 1.13-2.14 1.13-.13 0-.25-.01-.38-.03l.33-1.97c.02 0 .06.01.11-.01-7.96-4.08-13.07-14.03-16.26-23.55-.33-.97-.63-1.93-.93-2.89-2.71-9.06-3.73-17.13-3.89-18.55-.02-.13-.03-.21-.03-.22l-.33.03c-.22.4-.43.81-.64 1.19l-.73 1.31c.03.19.05.39.08.59.6 4.07 1.97 11.8 4.71 19.78 1.15 3.36 2.55 6.77 4.23 9.96l2.94 1.08c.03.14.55 2.17 1.34 5.63 2.48 3.18 5.39 5.83 8.79 7.53 2.07 1.03 4.18 1.55 6.33 1.55 1.68 0 3.37-.32 5.07-.95 8.92-3.32 16.1-14.55 19.95-21.79.12-.4.25-.81.37-1.21v-.01c.56-1.84 1.12-3.66 1.67-5.45.12-.4.24-.8.36-1.19l-.19-.26c-.1.22-10.47 23.42-22.87 28.03z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'M553.92 506.89c.24-.42.48-.85.73-1.31.21-.38.43-.79.64-1.19l-1.66.17c.02.21.11 1.03.29 2.33zm22.82 42.68c-.05.01-.09.01-.11.01l-.33 1.97c.13.02.26.03.38.03.75 0 1.46-.39 2.14-1.13-.64-.2-1.28-.46-1.91-.78-.06-.03-.12-.06-.17-.1zm-2.38 39.63c.12-.25.26-.51.39-.77-2.02-18.86-5.59-36-7.53-44.5-1.6-2.05-3.02-4.32-4.28-6.71.12.49 7.12 26.87 10.01 55.52.31-1.06.78-2.25 1.41-3.54z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'm565.88 538.3-2.94-1.08c1.26 2.39 2.68 4.66 4.28 6.71-.79-3.46-1.31-5.5-1.34-5.63zm9.27 54.13c2.98-8.32 15.95-24.19 23.11-32.58.17-.75.36-1.5.59-2.24.04-.13.08-.25.12-.39.19-.6.4-1.28.62-1.98-5.25 5.99-19.39 22.55-24.85 33.2.15 1.32.29 2.65.41 3.99zm-2.35.82.2.05-.06-.56c-.04.17-.1.34-.14.51z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'm572.95 592.73.06.56 1.74.43c0-.02.01-.04.02-.06.1-.39.24-.81.39-1.24-.13-1.34-.26-2.67-.4-3.99-.13.26-.27.52-.39.77-.64 1.29-1.11 2.48-1.42 3.53z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyParts', d: 'M574.44 636.84c-2.01 10.89-5.12 21.81-8.85 32.07 5.67-12.29 10.69-22.88 13.1-27.6 12.01-23.55 17.31-55.64 18.74-76 .11-1.51.31-3.01.62-4.49.06-.32.14-.65.22-.97-7.17 8.38-20.14 24.26-23.11 32.58 1.42 15.19 1.72 31.16-.72 44.41zm-40.42 85.7c-5.89 4.53-15.92 9.53-24.58 13.36-6.17 15.6-18.75 37.81-19.61 48.18-1.01 11.98 24.13 49.34 27.29 52.49 4.13 4.14 11.65 3.43 9.66-1.57-2.01-4.99-17.98-32.94-14.98-37.93 2.99-5 15.97-20.98 20.96-18.98s0 24.97 4.99 28.96c5 4 8.92-.01 9.98-7.99 1.06-7.94.4-11.09 2.44-16.21 2.76-6.88.41-12.69-1.38-17.9-1.56-4.56-5.5-8.27-6.88-12.4-1.78-5.35-4.16-14.39-2.17-23.39.8-3.59 6.04-16.1 12.5-30.72-6.26 11.26-12.76 19.9-18.22 24.1z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyParts', d: 'M572.47 636.48c2.35-12.75 2.01-28.25.53-43.18l-.2-.05c.04-.16.1-.34.15-.51-2.89-28.65-9.89-55.02-10.01-55.52-1.68-3.19-3.08-6.6-4.23-9.96-2.74-7.98-4.11-15.71-4.71-19.78-.03-.21-.06-.4-.08-.59-.31.56-.62 1.09-.92 1.59v.01c-1.54 2.66-2.76 4.52-3.52 5.63v.06c-1.26 19.18-2.78 36.32-4.73 39.28 0 0-11.1 18.67-15.24 31.07-3.6 10.81-15.5 136.92-17.71 144.64-.15.51-.31 1.04-.48 1.58-.06.19-.12.37-.19.56-.21.64-.45 1.31-.7 1.99 7.53-3.32 16.35-7.71 22.37-12.34 13.29-10.22 32.85-47.43 39.67-84.48z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'M565.59 668.91c-4.37 9.48-9.12 19.96-13.35 29.54 4.77-8.59 9.41-18.7 13.35-29.54z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'M575.15 592.43c-.16.43-.29.85-.39 1.24-.01.02-.02.04-.02.06l-1.74-.43c1.47 14.93 1.81 30.43-.53 43.18-6.83 37.05-26.39 74.26-39.67 84.48-6.02 4.63-14.84 9.03-22.37 12.34-.31.85-.64 1.71-.99 2.61 8.65-3.84 18.69-8.84 24.58-13.36 5.46-4.2 11.96-12.84 18.22-24.09 4.23-9.58 8.98-20.06 13.35-29.54 3.73-10.26 6.84-21.18 8.85-32.07 2.44-13.26 2.14-29.23.71-44.42z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyParts', d: 'M587.41 552.06c-1.7.63-3.39.95-5.07.95-2.15 0-4.26-.52-6.33-1.55-3.41-1.7-6.31-4.35-8.79-7.53 1.94 8.5 5.51 25.64 7.53 44.5 5.46-10.65 19.6-27.21 24.85-33.2 1.88-5.99 4.84-15.51 7.76-24.97-3.85 7.25-11.03 18.48-19.95 21.8z' }),
	          this.props.bodyTitle === 'Right Elbow' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '155', y: '594', width: '225', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup is_right' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M405 616.324h130' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M174.444 625.421v-25.77h10.951c2.754 0 4.755.232 6.003.695 1.248.463 2.247 1.286 2.997 2.469.75 1.184 1.125 2.537 1.125 4.061 0 1.934-.568 3.53-1.705 4.79-1.137 1.26-2.836 2.054-5.098 2.382 1.125.656 2.054 1.377 2.786 2.162.733.785 1.72 2.18 2.962 4.183l3.147 5.028h-6.223l-3.762-5.608c-1.335-2.003-2.25-3.266-2.742-3.788-.492-.521-1.013-.879-1.564-1.072-.551-.193-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.054-.106 4.675-.317a2.8 2.8 0 0 0 1.459-1.09c.352-.515.528-1.16.528-1.933 0-.867-.232-1.567-.695-2.101-.462-.533-1.116-.87-1.96-1.01-.421-.059-1.687-.088-3.796-.088h-4.061v6.539Zm20.742-6.328v-4.571h4.94v4.571h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.23 5.643.686c.093.656.31 1.107.65 1.353.469.352 1.207.528 2.215.528 1.289 0 2.256-.194 2.9-.58.434-.258.762-.674.985-1.248.152-.411.228-1.166.228-2.268v-2.725c-1.476 2.016-3.34 3.024-5.59 3.024-2.507 0-4.494-1.061-5.959-3.182-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.753-5.519 2.259-7.171 1.505-1.653 3.377-2.479 5.616-2.479 2.308 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.849-.545 4.939-.364 1.09-.873 1.946-1.53 2.567-.656.621-1.532 1.107-2.627 1.459-1.096.351-2.482.527-4.158.527-3.164 0-5.408-.542-6.732-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.005-.363.017-.598Zm4.412-10.951c0 1.981.384 3.431 1.152 4.351.767.92 1.713 1.38 2.838 1.38 1.207 0 2.227-.472 3.059-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.024-1.407-1.183 0-2.159.46-2.926 1.38-.768.92-1.152 2.323-1.152 4.21Zm22.957-16.049v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.958-.093-3.2-.281-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.821 0-1.553.2-2.197.598-.645.398-1.117.999-1.415 1.802-.299.802-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm25.629 7.102v3.937h-3.375v7.524c0 1.523.032 2.411.097 2.663.064.252.211.46.439.624.229.164.507.246.835.246.457 0 1.119-.158 1.987-.475l.421 3.832c-1.148.493-2.449.739-3.902.739-.891 0-1.693-.15-2.408-.449-.715-.298-1.239-.685-1.573-1.16-.334-.474-.566-1.116-.695-1.924-.105-.575-.158-1.735-.158-3.481v-8.139h-2.267v-3.937h2.267v-3.709l4.957-2.883v6.592h3.375Zm13.465 18.668v-25.77h19.107v4.36H281.6v5.713h12.938v4.341H281.6v7.014h14.397v4.342h-19.6Zm23.977-25.77h4.939v25.77h-4.939zm9.791 25.77v-25.77h4.939v9.282c1.523-1.735 3.328-2.602 5.414-2.602 2.274 0 4.154.823 5.643 2.47 1.488 1.646 2.232 4.01 2.232 7.092 0 3.188-.759 5.643-2.276 7.366-1.518 1.722-3.361 2.584-5.529 2.584-1.066 0-2.118-.267-3.155-.8s-1.931-1.321-2.681-2.364v2.742h-4.587Zm4.904-9.738c0 1.933.305 3.363.914 4.289.855 1.312 1.992 1.968 3.41 1.968 1.09 0 2.019-.465 2.786-1.397.768-.932 1.152-2.4 1.152-4.403 0-2.133-.387-3.671-1.161-4.615-.773-.943-1.763-1.415-2.97-1.415-1.184 0-2.168.46-2.953 1.38-.786.92-1.178 2.318-1.178 4.193Zm16.154.14c0-1.64.404-3.228 1.213-4.763.809-1.536 1.954-2.708 3.437-3.516 1.482-.809 3.137-1.213 4.965-1.213 2.825 0 5.139.917 6.944 2.751 1.804 1.834 2.707 4.151 2.707 6.952 0 2.824-.911 5.165-2.734 7.023-1.822 1.857-4.116 2.786-6.881 2.786-1.711 0-3.343-.387-4.896-1.16-1.553-.774-2.733-1.908-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.063.264c0 1.851.439 3.269 1.318 4.254.879.984 1.963 1.476 3.252 1.476 1.289 0 2.37-.492 3.243-1.476.873-.985 1.31-2.414 1.31-4.289 0-1.828-.437-3.235-1.31-4.219-.873-.984-1.954-1.477-3.243-1.477s-2.373.493-3.252 1.477c-.879.984-1.318 2.402-1.318 4.254Zm21.55 9.334-5.906-18.668h4.799l3.498 12.234 3.217-12.234h4.764l3.111 12.234 3.568-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Left Elbow' ? 'bodyParts_group Left_Elbow body_parts_active' : 'bodyParts_group Left_Elbow' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Elbow');
	            }, className: 'bodyParts', d: 'M946.52 507.5c-.59 4.08-1.97 11.78-4.7 19.75-1.15 3.36-2.55 6.76-4.23 9.95-.3.58-.62 1.14-.94 1.7-1.75 6.81-15.86 63.26-9.35 98.57 6.83 37.05 26.39 74.26 39.67 84.48 6.21 4.78 15.41 9.31 23.09 12.66-.43-1.13-.83-2.22-1.17-3.26v-.12c-.08-.17-.15-.29-.21-.5-.17-.54-.33-1.06-.48-1.57-2.21-7.72-14.11-133.83-17.71-144.64-4.13-12.4-15.24-31.07-15.24-31.07-1.95-2.96-3.47-20.11-4.72-39.28l-.03-.4c-.64-.9-2.07-3-3.98-6.27 0-.01 0 0 0 0zm-21.62 83.07c2-19.37 5.7-37.08 7.67-45.73-2.31 2.77-4.98 5.08-8.06 6.62-2.06 1.03-4.18 1.55-6.32 1.55-1.68 0-3.37-.32-5.08-.95-8.19-3.05-15.68-12.78-19.9-19.96 3.06 9.96 6.12 19.75 7.8 25.12v.01c.04.14.08.25.12.38.08.26.15.52.22.78 6.36 7.37 18.76 22.3 23.37 31.83.07.12.12.23.18.35z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Elbow');
	            }, className: 'bodyParts', d: 'm924.5 594.69-.15.04c0-.01-.01-.03-.01-.04-1.86-7.4-14.33-22.99-22.09-32.16.14.92.26 1.85.32 2.78 1.43 20.36 6.72 52.45 18.74 76 2.07 4.06 6.08 12.48 10.77 22.58-2.8-8.46-5.14-17.26-6.76-26.05-2.36-12.89-2.14-28.34-.82-43.15zm85.67 189.4c-.83-10.08-12.73-31.33-19.07-46.84-8.82-3.88-19.29-9.04-25.35-13.71-4.66-3.58-10.06-10.38-15.43-19.28 5.24 12.04 9.25 21.81 9.94 24.91 1.99 9-.38 18.04-2.17 23.39-1.37 4.13-5.32 7.84-6.88 12.4-1.79 5.21-4.13 11.02-1.37 17.9 2.04 5.12 1.37 8.27 2.43 16.21 1.06 7.98 4.99 11.99 9.98 7.99 4.99-3.99 0-26.96 4.99-28.96 5-2 17.98 13.98 20.96 18.98 3 4.99-12.97 32.94-14.97 37.93-1.99 5 5.53 5.71 9.66 1.57 3.15-3.15 28.29-40.51 27.28-52.49z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Elbow');
	            }, className: 'bodyLines', d: 'M950.32 704.26c-5.51-12.66-12.39-27.82-18.23-40.38 5.05 15.27 11.61 29.42 18.23 40.38z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Elbow');
	            }, className: 'bodyLines', d: 'M965.75 723.54c6.06 4.66 16.53 9.83 25.35 13.71-.37-.9-.72-1.78-1.04-2.63-7.68-3.35-16.88-7.88-23.09-12.66-13.29-10.22-32.84-47.43-39.67-84.48-6.5-35.31 7.6-91.76 9.35-98.57-1.22 2.13-2.57 4.13-4.08 5.94-1.97 8.64-5.67 26.36-7.67 45.73.65 1.35 1.13 2.59 1.39 3.68l-1.79.44c-1.32 14.81-1.54 30.26.83 43.15 1.62 8.79 3.96 17.59 6.76 26.05 5.83 12.56 12.71 27.72 18.23 40.38 5.37 8.88 10.77 15.68 15.43 19.26zm-41.4-128.81.15-.04c.12-1.38.26-2.75.4-4.12-.06-.12-.11-.23-.17-.35-4.61-9.54-17.01-24.47-23.37-31.83.23.81.44 1.63.61 2.44v.01c.11.56.2 1.12.29 1.69 7.76 9.18 20.22 24.77 22.09 32.16-.01.01 0 .03 0 .04z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Elbow');
	            }, className: 'bodyLines', d: 'M926.29 594.25c-.27-1.08-.74-2.33-1.39-3.68-.14 1.37-.27 2.74-.4 4.12l1.79-.44z' }),
	          this.props.bodyTitle === 'Left Elbow' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '592', width: '195', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M964.206 612.527h130' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1120.17 625.421v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.62-5.942 4.922.827c-.633 1.804-1.632 3.178-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.434 0-3.093.808-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429H1145.6c.036 1.465.434 2.604 1.196 3.419.761.814 1.711 1.221 2.847 1.221.774 0 1.424-.211 1.951-.633.528-.421.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.567-1.117-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.852-1.037 3.199h7.383Zm6.769-7.734h2.742v-1.406c0-1.571.167-2.743.501-3.516.334-.773.949-1.403 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.633l-.668 3.445a9.729 9.729 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.975-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.71 0v3.937h-3.375v7.524c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.149.493-2.449.739-3.902.739-.891 0-1.694-.15-2.409-.449-.715-.298-1.239-.685-1.573-1.16-.334-.474-.565-1.116-.694-1.924-.106-.575-.158-1.735-.158-3.481v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm13.47 18.668v-25.77h19.108v4.36h-13.904v5.713h12.937v4.341h-12.937v7.014h14.396v4.342h-19.6Zm23.97-25.77h4.939v25.77h-4.939zm9.79 25.77v-25.77h4.939v9.282c1.524-1.735 3.329-2.602 5.415-2.602 2.273 0 4.154.823 5.642 2.47 1.488 1.646 2.233 4.01 2.233 7.092 0 3.188-.759 5.643-2.277 7.366-1.517 1.722-3.36 2.584-5.528 2.584-1.067 0-2.118-.267-3.155-.8-1.038-.533-1.931-1.321-2.681-2.364v2.742h-4.588Zm4.904-9.738c0 1.933.305 3.363.914 4.289.856 1.312 1.993 1.968 3.411 1.968 1.089 0 2.018-.465 2.786-1.397.767-.932 1.151-2.4 1.151-4.403 0-2.133-.387-3.671-1.16-4.615-.774-.943-1.764-1.415-2.971-1.415-1.183 0-2.168.46-2.953 1.38-.785.92-1.178 2.318-1.178 4.193Zm16.156.14c0-1.64.404-3.228 1.212-4.763.809-1.536 1.955-2.708 3.437-3.516 1.482-.809 3.138-1.213 4.966-1.213 2.824 0 5.138.917 6.943 2.751 1.805 1.834 2.707 4.151 2.707 6.952 0 2.824-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.896-1.16-1.552-.774-2.733-1.908-3.542-3.402-.808-1.494-1.212-3.313-1.212-5.458Zm5.062.264c0 1.851.44 3.269 1.318 4.254.879.984 1.963 1.476 3.252 1.476 1.289 0 2.371-.492 3.244-1.476.873-.985 1.309-2.414 1.309-4.289 0-1.828-.436-3.235-1.309-4.219-.873-.984-1.955-1.477-3.244-1.477-1.289 0-2.373.493-3.252 1.477-.878.984-1.318 2.402-1.318 4.254Zm21.548 9.334-5.906-18.668h4.798l3.498 12.234 3.217-12.234h4.764l3.111 12.234 3.569-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Right Thigh' ? 'bodyParts_group Right_Thigh body_parts_active' : 'bodyParts_group Right_Thigh' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M653.56 979.22c0 .02.02.11.05.26.08.08.15.18.23.26.71.71 1.44 1.41 2.2 2.08-.27-1.67-.47-2.72-.52-2.98l-1.96.38zm34.38-9.96c0-.03.01-.05.01-.08l-1.97-.33c-.16.95-.5 3.09-.93 6.05.97-1.62 1.93-3.51 2.88-5.61v-.01c.01-.01.01-.02.01-.02zm13.78-226.02c-.02-.02-.04-.04-.05-.06a1.44 1.44 0 0 1-.15-.22c.15.22.23.35.25.37l.02-.01c-.03-.03-.05-.05-.07-.08zm-22.08-32.61zm21.82 32.25.06.08c-.02-.02-.04-.05-.06-.08zm39.27 53.1c.01-.43 0-.92 0-1.13 0-2.73-3.63-7.27-9.18-13.89-2.42-2.89-4.7-5.61-6.1-7.71-3.68-5.51-19.56-27.64-22.04-31.09-.01-.01-.01-.01-.01-.02.05.1.09.18.09.19l-1.71 1c2.44 3.39 18.35 25.55 22.01 31.04 1.46 2.19 3.78 4.96 6.23 7.89 3.88 4.63 8.71 10.39 8.71 12.6 0 .97-.07 3.03-.2 5.78.53-3.47.9-5.55.9-5.55s.61.47 1.3.89zm-61.1-85.36c.01 0 0 0 0 0zm4.7 6.92c-1.74-4.52-2.84-7.63-2.87-7.72l-1.88.66c.01.03.03.07.05.13l.01.01c1.57 2.32 3.15 4.64 4.7 6.93l-.01-.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'm703.08 741.71-1.62 1.17.06.09c.04.05.08.12.15.22.01.02.03.04.05.06.02.03.04.05.06.08l1.71-1c-.01-.01-.04-.08-.09-.19 0-.01-.01-.01-.01-.02-.19-.26-.3-.39-.31-.41zM665.2 689.2c.01.06.02.15.03.25 1.09 1.59 2.29 3.35 3.58 5.23-1.07-3.81-1.63-5.8-1.65-5.86l-1.96.38zm4.72 27.63-1.52-1.3c-.01.01-.06.07-.15.18.11.89.22 1.8.33 2.73.83-1 1.31-1.57 1.34-1.61z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyParts', d: 'M683.61 755.05c-6.93-24.82-12.01-42.96-15.05-53.81 3.33 28.77 12.12 99.68 19.95 119.25 7.94 19.85 20.04 73.79 26.54 102.77 1.69 7.53 2.91 12.98 3.54 15.49 2.29 9.16 2.29 27.1 2.15 35.63 1.89-8.56 4.41-18.16 5.74-23.48 2.22-8.85 3.86-21.41 5.07-34.91-1.92-9.77-6.36-30.11-12.86-46.71-7.4-18.89-19.19-57.32-35.08-114.23zm-70.16 67.17v.34c.04-.03.08-.07.12-.1l-.12-.24z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M724.59 803.6c-2.13-8.51-17.15-43.35-25.19-54.41-5.26-7.22-11.5-22.36-15.06-31.62v-.01a4387.9 4387.9 0 0 0-4.7-6.93c0 .01.01.02.01.03.91 2.6 10.37 29.03 18.13 39.71 7.75 10.65 22.82 45.53 24.87 53.71.52 2.08 1.43 6.32 2.49 11.22 5.72 26.56 7.73 34.05 9.36 34.83.06.03.12.05.19.07.02-1.25.03-2.39.03-3.45-1.94-5.46-5.56-22.25-7.63-31.87-1.06-4.92-1.97-9.17-2.5-11.28z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyParts', d: 'M716.64 939.23c-.63-2.53-1.86-7.98-3.55-15.53-1.65-7.37-3.67-16.35-5.88-25.97-2.58 13.46-10.42 51.88-19.28 71.56-2.58 15.79-7.73 57.57-.74 63.01 8.41 6.54 24.18-1.09 24.34-1.17l.21.43c2.7-16.83 6.06-38.89 6.73-44.78.06-.52.13-1.06.21-1.64.16-8.88.41-36.11-2.04-45.91zm8.5-123.93c-1.06-4.9-1.97-9.14-2.49-11.22-2.05-8.18-17.12-43.06-24.87-53.71-7.76-10.68-17.22-37.11-18.13-39.71 0-.01-.01-.02-.01-.03v-.01l-.01-.01v-.01c-3.81-5.62-7.58-11.17-10.83-15.93 2.62 9.32 8.31 29.62 16.74 59.83 15.86 56.84 27.64 95.21 35.01 114.03 6.9 17.63 10.32 34.25 11.53 41.04 1.76-22.32 2.43-46.01 2.61-59.35v-.04c-.06-.02-.13-.04-.19-.07-1.63-.76-3.64-8.25-9.36-34.81z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyParts', d: 'M730.02 782.25c-2.45-2.93-4.77-5.7-6.23-7.89-3.66-5.49-19.57-27.64-22.01-31.04l-.02.01c-.01-.02-.1-.15-.25-.37-.03-.05-.05-.08-.06-.08-1.57-2.32-8.95-13.25-17.12-25.31v.01c3.56 9.26 9.8 24.4 15.06 31.62 8.04 11.06 23.06 45.9 25.19 54.41.53 2.11 1.44 6.36 2.5 11.28 2.07 9.62 5.69 26.41 7.63 31.87v-.58c.01-1.01.01-1.91.01-2.71 0-14.31 2.01-30.6 3.4-40.16v-.05l.39-2.62c.13-2.75.2-4.81.2-5.78.02-2.22-4.81-7.98-8.69-12.61zm-80.89 255.86c12.02-15.07 5.13-55.05 4.48-58.63-5.19-5.52-7.71-19.38-11.84-42.14-.69-3.83-1.43-7.89-2.23-12.19-4.97-26.7-18.24-94.24-21.09-108.73v.01c-1.56 2.94-3.59 4.94-4.88 6.03.08.18.13.36.13.54l-.26.08c-.76 42.15-2.01 99.96 6.18 132.75 5.92 23.65 11.26 49.05 14.92 67.44 1.34 6.74 2.19 13.56 2.55 20.4 4.36-.41 9.42-2.28 12.04-5.56zm19.12-322.4c-1.7-13.98-2.8-24.18-3.03-26.26-.52-.76-1.02-1.49-1.49-2.17-11.5-16.72-14.3-29.15-16.18-40.45l-.09-.62c.04.37.06.74.1 1.1.1.74.16 1.49.2 2.25-.01.01 0 .02 0 .03.61 14.67-10.64 33.22-16.33 46.5-5.99 13.98-18.8 55.05-17.81 91 .23 8.34.09 19.54-.14 32.36 3.35-5.41 11.21-18.63 17.07-39.9 7.69-27.85 35.39-61.11 37.7-63.84z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyParts', d: 'M632.48 780.08c-4.18 15.15-8.95 26.31-12.55 33.49 1.09 5.53 16.2 82.3 21.58 111.21.8 4.3 1.54 8.37 2.23 12.2 3.97 21.93 6.6 36.42 11.51 41.34 5.94 5.94 12.3 10.41 24.68-.06 12.29-10.4 25.41-81.28 26.16-85.4-6.29-27.07-13.9-57.78-19.44-71.63-6.73-16.81-13.95-69.24-18.07-102.79-5.85 7.14-29.21 36.67-36.1 61.64z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M685.54 754.52c-8.43-30.21-14.12-50.51-16.74-59.83-1.29-1.88-2.49-3.64-3.58-5.23.22 2.08 1.33 12.28 3.03 26.26.09-.11.14-.17.15-.18l1.52 1.3c-.03.04-.51.61-1.34 1.61 4.12 33.55 11.34 85.98 18.07 102.79 5.54 13.85 13.15 44.56 19.44 71.63.02-.1.03-.18.04-.19l1.97.35c-.07.41-.38 2.09-.88 4.7 2.21 9.62 4.23 18.61 5.88 25.97 1.69 7.55 2.92 13 3.55 15.53 2.45 9.8 2.19 37.03 2.03 45.91.25-1.8.62-3.86 1.06-6.09.22-1.08.45-2.2.7-3.34.09-.44.19-.89.29-1.33.15-8.53.14-26.48-2.15-35.63-.63-2.51-1.85-7.95-3.54-15.49-6.5-28.98-18.59-82.92-26.54-102.77-7.83-19.57-16.62-90.48-19.95-119.25 3.04 10.85 8.12 28.99 15.05 53.81 15.88 56.91 27.68 95.33 35.07 114.22 6.49 16.6 10.93 36.94 12.86 46.71l.27-3.09c.07-.76.13-1.52.19-2.28v-.01c.03-.34.05-.68.08-1.02-1.22-6.79-4.63-23.41-11.53-41.04-7.36-18.82-19.14-57.18-35-114.02zm-71.97 67.94c-.04.04-.08.07-.12.1 0 .15 0 .29-.01.44v.08l.26-.08c0-.18-.05-.36-.13-.54z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M618.45 816.43s0-.01 0 0c-.33-1.71-.52-2.69-.54-2.78l1.96-.39c.01.03.03.13.06.31 3.6-7.19 8.37-18.35 12.55-33.49 6.89-24.97 30.25-54.5 36.1-61.64-.11-.92-.22-1.83-.33-2.73-2.31 2.73-30.01 35.99-37.69 63.84-5.86 21.27-13.72 34.5-17.07 39.9-.01.41-.01.81-.02 1.23-.01.51-.01 1.03-.02 1.54l.12.24c1.29-1.09 3.32-3.09 4.88-6.03z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M679.93 978.27c-12.37 10.47-18.73 6-24.68.06-4.91-4.91-7.54-19.4-11.51-41.34-.69-3.83-1.43-7.9-2.23-12.2-5.38-28.91-20.49-105.69-21.58-111.21v.01c-.52 1.03-1.01 1.97-1.48 2.84 2.85 14.49 16.12 82.03 21.09 108.73.8 4.3 1.54 8.36 2.23 12.19 4.12 22.76 6.64 36.61 11.84 42.14-.03-.15-.04-.24-.05-.26l1.96-.38c.05.25.25 1.31.52 2.98 2.98 2.62 6.38 4.72 10.65 4.72 3.98 0 8.71-1.82 14.52-6.75 1.28-1.08 2.56-2.76 3.83-4.89.43-2.96.77-5.1.93-6.05l1.97.33c0 .03-.01.05-.01.08 0 0 0 .01-.01.02v.01c8.87-19.68 16.7-58.1 19.28-71.56-.37-1.6-.74-3.23-1.12-4.86-.74 4.1-13.86 74.99-26.15 85.39zm28.16-85.25-1.97-.35c0 .02-.02.09-.04.19.38 1.63.76 3.26 1.12 4.86.51-2.6.82-4.28.89-4.7z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M619.93 813.57c-.04-.18-.06-.28-.06-.31l-1.96.39c.02.09.21 1.07.55 2.77.46-.87.95-1.81 1.47-2.85 0 .01 0 .01 0 0z' }),
	          this.props.bodyTitle === 'Right Thigh' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '165', y: '861', width: '215', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup is_right' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M405 883.94h220' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M184.565 893.037v-25.77h10.951c2.754 0 4.755.232 6.003.695 1.248.463 2.247 1.286 2.997 2.47.75 1.183 1.125 2.537 1.125 4.06 0 1.934-.568 3.53-1.705 4.79-1.137 1.26-2.836 2.054-5.097 2.382 1.125.656 2.053 1.377 2.786 2.162.732.785 1.719 2.18 2.962 4.184l3.146 5.027h-6.223l-3.761-5.607c-1.336-2.004-2.25-3.267-2.743-3.789-.492-.521-1.013-.878-1.564-1.072-.551-.193-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.055-.106 4.676-.317a2.801 2.801 0 0 0 1.459-1.089c.351-.516.527-1.161.527-1.934 0-.867-.232-1.567-.694-2.101-.463-.533-1.117-.87-1.96-1.01-.422-.059-1.688-.088-3.797-.088h-4.061v6.539Zm20.742-6.328v-4.571h4.94v4.571h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.23 5.643.686c.094.656.31 1.107.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.194 2.901-.58.433-.258.761-.674.984-1.248.152-.41.228-1.166.228-2.268v-2.724c-1.476 2.015-3.339 3.023-5.589 3.023-2.508 0-4.495-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.657.621-1.533 1.107-2.628 1.459-1.096.351-2.482.527-4.158.527-3.164 0-5.408-.542-6.732-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.598Zm4.412-10.951c0 1.981.384 3.431 1.152 4.351.767.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.023-1.407-1.184 0-2.16.46-2.927 1.38-.768.92-1.152 2.324-1.152 4.21Zm22.957-16.049v9.475c1.594-1.863 3.499-2.795 5.713-2.795 1.137 0 2.162.211 3.077.633.914.422 1.602.961 2.065 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.474-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.116.999-1.415 1.802-.299.803-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm25.629 7.102v3.938h-3.375v7.523c0 1.523.033 2.411.097 2.663.065.252.211.46.44.624.228.164.506.246.834.246.457 0 1.12-.158 1.987-.474l.422 3.832c-1.149.492-2.45.738-3.903.738-.89 0-1.693-.15-2.408-.448-.715-.299-1.239-.686-1.573-1.161-.334-.474-.566-1.116-.694-1.924-.106-.575-.159-1.735-.159-3.481v-8.138h-2.267v-3.938h2.267v-3.709l4.957-2.883v6.592h3.375Zm19.266 18.668v-21.41h-7.646v-4.36h20.478v4.36h-7.629v21.41h-5.203Zm21.076-25.77v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.093-3.2-.281-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.821 0-1.553.2-2.198.598-.644.399-1.116.999-1.415 1.802-.298.803-.448 1.989-.448 3.559v9.352h-4.939v-25.77h4.939Zm17.069 4.571v-4.571h4.939v4.571h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.544 1.23 5.643.686c.094.656.311 1.107.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.194 2.901-.58.433-.258.761-.674.984-1.248.152-.41.229-1.166.229-2.268v-2.724c-1.477 2.015-3.34 3.023-5.59 3.023-2.508 0-4.494-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.656.621-1.532 1.107-2.628 1.459-1.096.351-2.482.527-4.157.527-3.164 0-5.409-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.598Zm4.413-10.951c0 1.981.383 3.431 1.151 4.351.768.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.023-1.407-1.184 0-2.159.46-2.927 1.38-.768.92-1.151 2.324-1.151 4.21Zm22.957-16.049v9.475c1.593-1.863 3.498-2.795 5.712-2.795 1.137 0 2.163.211 3.077.633.914.422 1.602.961 2.065 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.474-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.559v9.352h-4.94v-25.77h4.94Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Left Thigh' ? 'bodyParts_group Left_Thigh body_parts_active' : 'bodyParts_group Left_Thigh' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'M845 978.84c-.05.25-.25 1.31-.52 2.98.76-.67 1.49-1.37 2.2-2.08.08-.08.15-.18.23-.26.03-.15.04-.24.05-.26l-1.96-.38zm-32.43-9.66c0 .03.01.06.01.09.95 2.12 1.92 4.02 2.89 5.65-.43-2.96-.78-5.11-.93-6.06l-1.97.32zm-13.81-225.85c.01-.02.08-.12.21-.31-.06.07-.13.17-.23.3l.02.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'm797.03 742.33 1.71.99c.1-.13.17-.23.23-.3.05-.08.08-.13.09-.14l-1.62-1.17c-.01.02-.12.15-.31.41 0 .01-.01.03-.02.04-.05.1-.08.16-.08.17z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'M762.12 803.25c-.21-4.07-.33-7.14-.33-8.4 0-2.21 4.83-7.97 8.71-12.6 2.46-2.93 4.78-5.7 6.24-7.89 3.66-5.49 19.57-27.66 22-31.04l-1.71-.99c0-.01.03-.07.08-.17-2.48 3.45-18.36 25.58-22.04 31.09-1.39 2.1-3.68 4.82-6.1 7.71-5.54 6.62-9.18 11.16-9.18 13.89 0 .17.01.44.02.78.5-.32.76-.55.76-.55s.89 8.51 1.55 8.17zm68.48-86.42c.04.04.52.61 1.34 1.62.12-.93.23-1.84.34-2.74-.1-.11-.15-.17-.16-.18l-1.52 1.3z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyParts', d: 'M794.43 892.83c.69 3.8 13.85 75.01 26.17 85.43 12.37 10.47 18.73 6 24.68.06 4.91-4.91 7.54-19.4 11.51-41.34.69-3.83 1.43-7.9 2.23-12.2 5.38-28.92 20.49-105.69 21.58-111.21-3.6-7.19-8.37-18.34-12.55-33.49-6.88-24.96-30.22-54.48-36.1-61.63-4.12 33.55-11.34 85.97-18.07 102.78-5.55 13.85-13.16 44.54-19.45 71.6z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyParts', d: 'M781.94 938.74c.63-2.5 1.85-7.94 3.54-15.47 6.5-28.98 18.59-82.93 26.54-102.78 7.83-19.57 16.61-90.48 19.94-119.25-3.04 10.85-8.12 28.99-15.05 53.81-15.88 56.9-27.68 95.33-35.07 114.22-8.86 22.64-12.82 51.92-12.86 52.16 1.15 11.4 2.63 21.82 4.54 29.47 1.4 5.6 4.12 15.93 6.03 24.81v.02c.08.36.15.71.23 1.07-.12-9.11-.08-29.09 2.16-38.06zm53.36-249.29c-.22 2.09-1.32 12.29-3.02 26.26 2.29 2.72 30 35.99 37.69 63.84 6.17 22.39 13.6 35.87 16.56 40.69-.24-13.15-.39-24.64-.15-33.15.99-35.95-11.82-77.02-17.81-91-5.5-12.83-16.19-30.59-16.36-45.01-1.95 10.19-5.34 21.55-15.42 36.2-.47.68-.97 1.41-1.49 2.17zm46.77 126.99c-2.86 14.52-16.13 82.02-21.09 108.71-.8 4.3-1.54 8.36-2.23 12.19-4.12 22.76-6.64 36.61-11.84 42.14-.65 3.58-7.54 43.56 4.48 58.63 2.71 3.4 7.16 5.26 11.53 5.59.36-6.85 1.2-13.67 2.55-20.43 3.66-18.39 9-43.79 14.92-67.44 8.19-32.76 6.94-90.5 6.18-132.65l-.36.26c-.04-.06-1.68-2.38-4.14-7z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyParts', d: 'M813.33 1032.3c6.99-5.44 1.85-47.26-.75-63.03-8.86-19.69-16.69-58.09-19.27-71.54v.01c-2.22 9.63-4.23 18.61-5.88 25.98-1.69 7.54-2.92 12.99-3.55 15.52-2.64 10.57-2.07 44.16-1.92 50.96 1.13 8.34 3.8 25.75 6.09 39.97.96.47 17.09 8.5 25.28 2.13zm-47.64-185.25c1.92-5.13 5.63-22.37 7.74-32.18 1.06-4.92 1.98-9.17 2.51-11.27 2.12-8.51 17.14-43.35 25.18-54.41 5.26-7.22 11.49-22.34 15.05-31.6-8.17 12.05-15.55 22.98-17.11 25.29-.01.01-.04.06-.09.14-.13.19-.2.29-.21.31l-.02-.01c-2.43 3.38-18.34 25.55-22 31.04-1.46 2.19-3.78 4.96-6.24 7.89-3.88 4.63-8.71 10.39-8.71 12.6 0 1.26.12 4.33.33 8.4-.73-5.02-1.29-8.17-1.29-8.17s-.08.07-.23.18c.13.73.63 3.66 1.26 7.99v.05c1.39 9.56 3.4 25.85 3.4 40.16 0 .8 0 1.7.01 2.71 0 .4.01.83.01 1.26.14-.44.25-.86.25-1.26.06.32.11.62.16.88z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyParts', d: 'M768.26 910.59c1.05-6.03 4.46-23.49 11.72-42.04 7.37-18.83 19.14-57.2 35-114.03 8.43-30.2 14.12-50.5 16.74-59.83-3.24 4.75-7.01 10.3-10.82 15.92-.83 2.33-10.35 29.02-18.16 39.76-7.74 10.65-22.82 45.53-24.86 53.71-.52 2.08-1.43 6.31-2.49 11.21-5.72 26.57-7.74 34.06-9.36 34.84-.07.03-.39.06-.71.08v.03c.17 13.54.87 37.75 2.68 60.35 0 0 .01.02 0 .02.03.27.05.55.07.83.09-.35.16-.64.19-.83.01 0 0-.02 0-.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'M775.39 815.29c1.06-4.9 1.97-9.13 2.49-11.21 2.04-8.18 17.12-43.06 24.86-53.71 7.81-10.74 17.33-37.43 18.16-39.76-1.58 2.33-3.17 4.67-4.73 6.98-3.56 9.26-9.79 24.38-15.05 31.6-8.04 11.06-23.06 45.9-25.18 54.41-.53 2.1-1.45 6.35-2.51 11.27-2.11 9.81-8.01 32.13-8.15 32.56.01.87.02 1.79.04 2.78.32-.02.64-.05.71-.08 1.62-.78 3.64-8.27 9.36-34.84zm8.49 123.94c.63-2.53 1.86-7.98 3.55-15.52 1.65-7.37 3.66-16.35 5.88-25.98v-.01c-.5-2.61-.8-4.28-.88-4.7l1.97-.35c0 .02.01.08.03.16 6.29-27.06 13.9-57.75 19.44-71.6 6.73-16.81 13.95-69.23 18.07-102.78-.82-1.01-1.3-1.58-1.34-1.62l1.52-1.3c.01.01.06.07.16.18 1.7-13.97 2.8-24.17 3.02-26.26-1.09 1.59-2.29 3.35-3.58 5.24-2.62 9.33-8.31 29.63-16.74 59.83-15.86 56.83-27.63 95.2-35 114.03-7.26 18.55-10.67 36.01-11.72 42.04 0 0 .01.02 0 .02-.03.19-.1.48-.19.83.04.49.08.98.13 1.46.24 2.89.5 5.74.79 8.53.03-.24 4-29.52 12.86-52.16 7.39-18.89 19.19-57.32 35.07-114.22 6.93-24.82 12.01-42.96 15.05-53.81-3.33 28.77-12.11 99.68-19.94 119.25-7.95 19.85-20.04 73.8-26.54 102.78-1.69 7.53-2.91 12.97-3.54 15.47-2.24 8.97-2.29 28.96-2.15 38.06l.03.15v-1.22c.25 1.14.48 3.25.7 4.32l.15 1.14c.39 2.09.69 3.99.86 5.59.09.83.24 1.99.43 3.41-.15-6.8-.73-40.39 1.91-50.96z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'M832.28 715.71c-.11.9-.22 1.81-.34 2.74 5.88 7.15 29.22 36.67 36.1 61.63 4.18 15.15 8.95 26.3 12.55 33.49.04-.18.06-.28.06-.31l1.96.39c-.02.09-.21 1.07-.55 2.78 2.46 4.62 4.1 6.94 4.14 7l.36-.26v-.18l-.03-2.32c0-.15-.01-.29-.01-.44-2.96-4.82-10.39-18.3-16.56-40.69-7.68-27.84-35.39-61.11-37.68-63.83zm24.5 221.28c-3.97 21.93-6.6 36.43-11.51 41.34-5.94 5.94-12.3 10.41-24.68-.06-12.32-10.42-25.47-81.64-26.17-85.43v.02c-.37 1.64-.75 3.26-1.12 4.87 2.58 13.45 10.41 51.86 19.27 71.54 0-.03-.01-.06-.01-.09l1.97-.32c.16.95.5 3.1.93 6.06 1.27 2.13 2.55 3.8 3.83 4.88 5.82 4.92 10.54 6.75 14.52 6.75 4.27 0 7.68-2.1 10.65-4.72.27-1.67.47-2.73.52-2.98l1.96.38c0 .02-.02.11-.05.26 5.2-5.52 7.71-19.38 11.84-42.14.69-3.83 1.43-7.89 2.23-12.19 4.96-26.69 18.23-94.2 21.09-108.72-.46-.87-.96-1.82-1.48-2.86-1.09 5.53-16.2 82.3-21.58 111.21-.78 4.3-1.51 8.37-2.21 12.2z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'M794.43 892.84s0-.01 0 0c-.01-.09-.03-.15-.03-.17l-1.97.35c.07.41.38 2.09.88 4.7.37-1.61.75-3.23 1.12-4.87v-.01zm88.19-79.19-1.96-.39c-.01.03-.03.13-.06.31.52 1.04 1.02 1.99 1.48 2.86.33-1.71.52-2.69.54-2.78z' }),
	          this.props.bodyTitle === 'Left Thigh' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '861', width: '185', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M874.206 883.721h220' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1119.95 893.037v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.63-5.941 4.922.826c-.633 1.804-1.632 3.178-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.433 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.036 1.465.434 2.604 1.196 3.419.761.814 1.711 1.221 2.847 1.221.774 0 1.424-.21 1.951-.632.528-.422.926-1.102 1.196-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.567-1.117-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.852-1.037 3.199h7.383Zm6.759-7.734h2.742v-1.406c0-1.571.167-2.742.501-3.516.334-.773.949-1.403 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.633l-.668 3.445a9.783 9.783 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.975-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.72 0v3.938h-3.375v7.523c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.474l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.15-2.409-.448-.715-.299-1.239-.686-1.573-1.161-.334-.474-.565-1.116-.694-1.924-.106-.575-.158-1.735-.158-3.481v-8.138h-2.268v-3.938h2.268v-3.709l4.957-2.883v6.592h3.375Zm19.26 18.668v-21.41h-7.646v-4.36h20.478v4.36h-7.629v21.41h-5.203Zm21.08-25.77v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.117.999-1.415 1.802-.299.803-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm17.07 4.571v-4.571h4.939v4.571h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.54 1.23 5.642.686c.094.656.311 1.107.651 1.354.468.351 1.207.527 2.214.527 1.29 0 2.256-.194 2.901-.58.433-.258.762-.674.984-1.248.153-.41.229-1.166.229-2.268v-2.724c-1.477 2.015-3.34 3.023-5.59 3.023-2.508 0-4.494-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.181 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.656.621-1.532 1.107-2.628 1.459-1.096.351-2.481.527-4.157.527-3.164 0-5.408-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.018-.598Zm4.412-10.951c0 1.981.384 3.431 1.151 4.351.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.472 3.059-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.399-3.369-1.196-4.306-.797-.938-1.804-1.407-3.023-1.407-1.184 0-2.159.46-2.927 1.38-.767.92-1.151 2.324-1.151 4.21Zm22.958-16.049v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.656.78 1.383.95 2.18.169.797.254 2.033.254 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.281-3.727a2.454 2.454 0 0 0-.993-1.257c-.475-.31-1.07-.466-1.785-.466-.82 0-1.552.2-2.197.598-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.559v9.352h-4.94v-25.77h4.94Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Right Knee' ? 'bodyParts_group Right_Knee body_parts_active' : 'bodyParts_group Right_Knee' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyParts', d: 'M637.29 1052.27v.4c.06-.1.11-.2.15-.29a.717.717 0 0 0-.15-.11z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyLines', d: 'M650.7 1039.36c11.26-14.11 6.99-47.33 5.35-57.54-.76-.67-1.49-1.37-2.2-2.08-.08-.08-.15-.18-.23-.26.65 3.58 7.55 43.57-4.48 58.63-2.62 3.28-7.68 5.15-12.05 5.56.04.67.07 1.33.09 2 4.94-.44 10.52-2.56 13.52-6.31zm36.49-7.06c-6.99-5.44-1.84-47.23.74-63.01-.95 2.11-1.91 3.99-2.88 5.61v.02c-2.25 15.43-6.81 52.95.92 58.96 2.94 2.29 6.57 3.08 10.19 3.08 6.48 0 12.9-2.54 15.29-3.59.01-.04.01-.08.02-.12.07-.43.14-.84.21-1.28v-.01l.06-.4-.21-.43c-.16.08-15.93 7.71-24.34 1.17zm-49.97 19.92c.02.01.04.03.07.05v-.19c-.1.04-.16.09-.07.14z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyLines', d: 'M637.54 1051.97c-.06.03-.17.06-.25.1v.19c.05.03.1.07.15.1.05-.12.09-.26.1-.39zm.01-.06c0 .02-.01.04-.01.06.05-.02.07-.04.01-.06z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyParts', d: 'M696.88 1254.32c.18-4.91.4-9.09.62-11.95.64-8.26 6.77-30.61 11.64-47.76-6.69-12.89-12.34-31.5-15.35-49.28-1.2 20.83-2.44 72.39 3.09 108.99z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyParts', d: 'M685.97 1033.88c-7.73-6.01-3.17-43.53-.92-58.96v-.02c-1.27 2.13-2.55 3.81-3.83 4.89-5.82 4.92-10.54 6.75-14.52 6.75-4.27 0-7.68-2.1-10.65-4.72 1.64 10.21 5.91 43.43-5.35 57.54-2.99 3.75-8.58 5.87-13.52 6.32.08 2.08.12 4.16.11 6.24v.16c.08-.04.19-.07.25-.1 0-.02.01-.04.01-.06.06.02.04.04-.01.06-.01.13-.05.27-.11.4 7.27 5.24 28 55.39 38.12 120.72 6.35 40.97 7.6 76.79 7.77 94.49.12 11.54-.14 22.25-.72 30.18-.48 6.63-1.04 9.69-1.56 11.15 4.54 1.09 14.41 3.75 19.02 5.01-.48-1.41-1-3.21-1.56-5.66-1.84-8-2.17-26.23-1.92-42.08-9.2-44.92-4.55-125.42-4.21-130.06v-.01c-2.37-17.11-3.21-33.54-2.79-44.99.79-21.24 13.92-38.21 19.68-44.66.58-3.32 1.34-7.9 2.18-13.08-2.39 1.05-8.81 3.59-15.29 3.59-3.61-.02-7.24-.81-10.18-3.1z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyParts', d: 'M691.58 1091.19c-.97 26.01 4.83 75.1 18.18 101.21 2.5-8.78 4.56-15.89 5.19-18.49 2.98-12.28 6.9-30.25 7.51-42.36.78-15.81-2.89-27.77-5.64-38.43-1.98-7.68-10.96-29.14-8.36-42.32-3.14 3.11-16.02 17.24-16.88 40.39zm-45.08 111.83c5.68 21.78 24.86 96.93 26.71 104.16 2.66.78 5 1.37 5.86 1.3 2.48-4.56 5.37-64.94-5.49-135.08-6.29-40.61-15.65-71.13-20.67-85.71-6.94-20.17-13.03-29.8-15.67-32.8-.17 6.33-.74 12.65-1.75 18.92-.62 3.88-1.28 8.05-1.92 12.33l.72 2.51c.07.92 6.3 91.7 12.21 114.37z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyParts', d: 'M648.4 1301.39c4.16-.59 12.48 2 19.83 4.28.89.28 1.82.56 2.75.85-3.03-11.88-20.96-82.08-26.41-102.99-5.05-19.4-10.32-90.71-11.84-111.65-.11.73-.21 1.46-.32 2.2-1.85 13.06-3.43 26.29-3.79 35.47-1.01 24.96 6.98 98.84 9.98 108.83 2.99 9.98 6.98 42.93 4.99 55.91-.4 2.58-.95 5.23-1.65 7.98 0 .01-.01.03-.01.04l.27-.04 6.2-.88z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyLines', d: 'M692.37 1136.11v.01c.01-.12.02-.19.02-.21l2 .16c-.01.17-.27 3.56-.6 9.26 3.01 17.78 8.65 36.39 15.35 49.28.03-.09.05-.19.08-.28.15-.54.3-1.07.45-1.59.03-.11.06-.22.1-.34-13.35-26.11-19.15-75.2-18.18-101.21.86-23.15 13.74-37.28 16.89-40.39.01-.04.01-.08.02-.13.01-.06.03-.12.04-.19.04-.19.08-.4.12-.63.17-.89.38-2.04.62-3.39-5.76 6.46-18.89 23.43-19.68 44.66-.44 11.45.4 27.88 2.77 44.99z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyLines', d: 'M693.79 1145.33c-.52-3.08-.99-6.15-1.42-9.21-.34 4.65-4.99 85.15 4.21 130.06 0-.14 0-.29.01-.43.02-1.71.05-3.38.09-5.02v-.01c.06-2.23.13-4.38.2-6.4-5.53-36.6-4.29-88.16-3.09-108.99z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyLines', d: 'm694.39 1136.07-2-.16c0 .02-.01.09-.02.21.43 3.06.9 6.13 1.42 9.21.33-5.7.59-9.09.6-9.26zm-20.81 37.33c10.86 70.14 7.97 130.52 5.49 135.08.4.07 1.09.22 1.97.43.52-1.46 1.08-4.53 1.56-11.15.58-7.93.84-18.64.72-30.18-.17-17.7-1.42-53.52-7.77-94.49-10.12-65.33-30.85-115.48-38.12-120.72-.04.1-.09.2-.15.29 0 .5-.01 1-.01 1.5l-.03.73c2.64 3 8.73 12.63 15.67 32.8 5.02 14.58 14.38 45.1 20.67 85.71zm-2.6 133.12c.75.23 1.5.45 2.23.66-1.85-7.23-21.03-82.38-26.71-104.16-5.91-22.67-12.14-113.45-12.21-114.37l-.72-2.51c-.13.86-.26 1.71-.38 2.57-.15 1.05-.31 2.11-.46 3.17 1.52 20.94 6.79 92.25 11.84 111.65 5.45 20.91 23.38 91.11 26.41 102.99z' }),
	          this.props.bodyTitle === 'Right Knee' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '175', y: '1129', width: '205', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup is_right' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M405 1150.16h230' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M193.957 1159.25v-25.769h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.184 1.125 2.537 1.125 4.061 0 1.933-.568 3.53-1.705 4.79-1.137 1.259-2.836 2.053-5.098 2.381 1.125.657 2.054 1.377 2.786 2.162.733.786 1.72 2.18 2.962 4.184l3.147 5.027h-6.223l-3.762-5.607c-1.336-2.004-2.25-3.267-2.742-3.788-.492-.522-1.014-.879-1.564-1.072-.551-.194-1.424-.29-2.619-.29h-1.055v10.757h-5.203Zm5.203-14.871h3.849c2.497 0 4.055-.105 4.676-.316a2.8 2.8 0 0 0 1.459-1.09c.352-.516.528-1.16.528-1.934 0-.867-.232-1.567-.695-2.1-.463-.533-1.116-.87-1.96-1.011-.422-.058-1.687-.088-3.797-.088h-4.06v6.539Zm20.742-6.329v-4.57h4.939v4.57h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.545 1.231 5.643.685c.093.657.31 1.108.65 1.354.469.352 1.207.527 2.215.527 1.289 0 2.256-.193 2.9-.58.434-.258.762-.674.985-1.248.152-.41.228-1.166.228-2.267v-2.725c-1.477 2.016-3.34 3.023-5.59 3.023-2.508 0-4.494-1.06-5.959-3.181-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.753-5.52 2.258-7.172 1.506-1.652 3.378-2.478 5.617-2.478 2.308 0 4.212 1.013 5.712 3.041v-2.62h4.624v16.752c0 2.204-.182 3.85-.545 4.94-.364 1.09-.873 1.945-1.53 2.566-.656.621-1.532 1.108-2.628 1.459-1.095.352-2.481.528-4.157.528-3.164 0-5.408-.542-6.732-1.626-1.325-1.084-1.987-2.458-1.987-4.122 0-.165.006-.364.018-.598Zm4.412-10.951c0 1.98.384 3.43 1.151 4.35.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.471 3.059-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.398-3.369-1.195-4.307-.797-.937-1.805-1.406-3.024-1.406-1.183 0-2.159.46-2.927 1.38-.767.92-1.151 2.323-1.151 4.21Zm22.957-16.049v9.475c1.594-1.864 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.632.914.422 1.603.961 2.066 1.618.462.656.779 1.382.949 2.179.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.094-3.199-.281-3.726a2.446 2.446 0 0 0-.993-1.257c-.475-.311-1.07-.466-1.784-.466-.821 0-1.553.199-2.198.598-.644.398-1.116.999-1.415 1.801-.298.803-.448 1.99-.448 3.56v9.351h-4.939v-25.769h4.939Zm25.629 7.11v3.938h-3.375v7.523c0 1.524.032 2.412.097 2.663.064.252.211.46.439.625.229.164.507.246.835.246.457 0 1.119-.159 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.693-.149-2.408-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.566-1.116-.695-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm13.535 18.66v-25.769h5.203v11.443l10.512-11.443h6.996l-9.703 10.037 10.23 15.732h-6.732l-7.084-12.093-4.219 4.306v7.787h-5.203Zm42.873 0h-4.939v-9.527c0-2.016-.106-3.319-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.548 3.548 0 0 0-1.397 1.863c-.252.774-.378 2.203-.378 4.289v8.455h-4.939v-18.668h4.587v2.743c1.629-2.11 3.68-3.164 6.153-3.164 1.09 0 2.086.196 2.988.588.902.393 1.585.894 2.048 1.503.463.61.785 1.301.967 2.075.181.773.272 1.88.272 3.322v11.601Zm15.821-5.94 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.268 1.618-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.405-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Zm19.74 4.992 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.671 1.178-.704.785-1.049 1.851-1.038 3.199h7.383Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Left Knee' ? 'bodyParts_group Left_Knee body_parts_active' : 'bodyParts_group Left_Knee' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyLines', d: 'M851.39 1038.11c-12.02-15.07-5.13-55.05-4.48-58.63-.08.08-.15.18-.23.26-.71.71-1.44 1.41-2.2 2.08-1.64 10.21-5.91 43.43 5.35 57.54 3.09 3.87 8.04 5.99 13 6.34l.09-2c-4.37-.33-8.81-2.19-11.53-5.59zm-36.83-4.23c7.73-6.01 3.16-43.55.92-58.97-.97-1.63-1.94-3.53-2.89-5.65 2.59 15.77 7.74 57.59.75 63.03-8.2 6.37-24.33-1.66-25.28-2.14.1.6.19 1.2.29 1.79.05.4.12.78.18 1.17 1.74.81 8.76 3.85 15.85 3.85 3.6 0 7.24-.79 10.18-3.08z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyParts', d: 'M829.55 1306.51c.93-.28 1.86-.57 2.74-.85 7.35-2.28 15.68-4.87 19.84-4.28l5.93.85c-.7-2.74-1.24-5.38-1.64-7.95-2-12.98 2-45.93 4.98-55.91 3.01-9.99 11-83.87 9.99-108.83-.35-8.89-1.85-21.58-3.63-34.23-1.56 21.38-6.78 88.96-11.8 108.21-5.46 20.92-23.38 91.11-26.41 102.99zm-20.61-215.32c-.89-24.05-14.71-38.33-17.19-40.69v-.01c-.17-.16-.27-.25-.32-.3.02.1.04.21.06.3v.01l.03.17c2.68 13.17-6.36 34.75-8.35 42.45-2.75 10.66-6.42 22.62-5.63 38.43.6 12.11 4.52 30.08 7.51 42.36.64 2.64 2.74 9.89 5.28 18.83.03.1.06.21.09.32 12.92-26.5 19.47-76.29 18.52-101.87z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyParts', d: 'M849.83 1039.36c-11.26-14.11-6.99-47.33-5.35-57.54-2.98 2.62-6.38 4.72-10.65 4.72-3.98 0-8.7-1.82-14.52-6.75-1.28-1.08-2.56-2.75-3.83-4.88 2.24 15.42 6.81 52.95-.92 58.97-2.95 2.29-6.58 3.09-10.2 3.09-7.09 0-14.1-3.04-15.85-3.85.01.04.01.08.02.12v.01c.84 5.16 1.6 9.73 2.19 13.07 5.82 6.34 19.43 23.4 20.22 44.8.42 11.46-.42 27.91-2.79 45.03v.01c.38 5.11 5.08 88.36-4.58 132.78l-.12-.29c.18 15.24-.2 32.04-1.94 39.61-.43 1.85-.82 3.32-1.2 4.54 6.61-1.28 15.32-3.1 19.17-3.9-.52-1.47-1.07-4.54-1.56-11.13-.58-7.93-.84-18.65-.72-30.18.18-17.7 1.42-53.52 7.77-94.5 10.22-65.98 30.26-116.48 37.33-120.87.14-.09.28-.15.41-.21v-.09c-.01-2.07.03-4.15.11-6.22-4.95-.36-9.9-2.47-12.99-6.34z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyParts', d: 'M806.73 1145.35v.02c-2.79 16.46-8.98 37.86-15.26 51.38 4.76 16.82 10.43 37.69 11.03 45.62.26 3.38.52 8.6.71 14.7 6.02-36.71 4.75-90.36 3.52-111.72zm20.22 28.04c-10.87 70.14-7.97 130.52-5.49 135.08.86.08 3.2-.51 5.86-1.29 1.83-7.18 21.03-82.38 26.71-104.16 4.85-18.6 10.59-90.4 12.52-116.12-.68-4.55-1.37-8.98-2.03-13.09-1.04-6.43-1.62-12.92-1.77-19.41-2.26 2.32-7.75 11.83-15.14 33.29-5.01 14.58-14.37 45.1-20.66 85.7z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyLines', d: 'M806.73 1145.35c-.32-5.71-.58-9.11-.59-9.28l1.99-.16c0 .02.01.1.02.24 2.37-17.12 3.21-33.57 2.79-45.03-.79-21.4-14.4-38.46-20.22-44.8.25 1.42.46 2.61.63 3.53.02.12.05.23.07.34.06.05.15.14.32.3v.01c2.48 2.36 16.3 16.64 17.19 40.69.95 25.58-5.6 75.37-18.52 101.87.12.42.25.84.37 1.27v.01c.22.79.45 1.6.68 2.41 6.28-13.52 12.47-34.92 15.26-51.38.01-.01.01-.01.01-.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyLines', d: 'M808.15 1136.16c-.42 3.05-.89 6.12-1.42 9.19 1.23 21.36 2.5 75.01-3.52 111.72.04 1.19.07 2.4.11 3.65.03 1.64.07 3.32.09 5.03.02.96.03 1.93.04 2.9l.12.29c9.66-44.42 4.96-127.67 4.58-132.78z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyLines', d: 'M806.14 1136.07c.01.17.27 3.57.59 9.28.53-3.07 1-6.14 1.42-9.18v-.02c-.01-.14-.02-.22-.02-.24l-1.99.16zm18.83 37.02c-6.35 40.97-7.59 76.79-7.77 94.5-.12 11.53.14 22.25.72 30.18.48 6.59 1.04 9.66 1.56 11.13 1.23-.26 1.97-.42 1.97-.42-2.48-4.56-5.37-64.94 5.49-135.08 6.29-40.61 15.65-71.13 20.66-85.7 7.38-21.46 12.87-30.97 15.14-33.29 0-.08-.01-.16-.01-.24v-.01c-.01-.72-.02-1.43-.02-2.15-.14.06-.27.13-.41.21-7.06 4.39-27.11 54.89-37.33 120.87zm2.34 134.09c.73-.21 1.48-.44 2.23-.67 3.03-11.88 20.96-82.07 26.41-102.99 5.02-19.25 10.24-86.84 11.8-108.21-.06-.41-.11-.82-.17-1.24.01-.01 0-.01 0-.01-.25-1.79-.51-3.59-.77-5.36l-.27-1.81c-1.94 25.72-7.67 97.52-12.52 116.12-5.68 21.79-24.87 97-26.71 104.17z' }),
	          this.props.bodyTitle === 'Left Knee' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '1127', width: '175', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M864.206 1146.36h230' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1119.95 1159.25v-25.558h5.203v21.217h12.937v4.341h-18.14Zm32.63-5.94 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.643 2.302 8.428h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm6.759-7.728h2.742v-1.406c0-1.57.167-2.742.501-3.515.334-.774.949-1.404 1.846-1.89.896-.486 2.03-.73 3.401-.73 1.406 0 2.783.211 4.131.633l-.668 3.446a9.732 9.732 0 0 0-2.268-.282c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.72 0v3.938h-3.375v7.523c0 1.524.032 2.412.096 2.663.065.252.211.46.44.625.228.164.507.246.835.246.457 0 1.119-.159 1.986-.475l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm13.53 18.66v-25.769h5.203v11.443l10.512-11.443h6.996l-9.703 10.037 10.23 15.732h-6.732l-7.084-12.093-4.219 4.306v7.787h-5.203Zm42.87 0h-4.94v-9.527c0-2.016-.105-3.319-.316-3.911-.211-.592-.554-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492a3.96 3.96 0 0 0-2.303.703 3.537 3.537 0 0 0-1.397 1.863c-.252.774-.378 2.203-.378 4.289v8.455h-4.94v-18.668h4.588v2.743c1.629-2.11 3.68-3.164 6.152-3.164 1.09 0 2.086.196 2.989.588.902.393 1.585.894 2.048 1.503a5.45 5.45 0 0 1 .966 2.075c.182.773.273 1.88.273 3.322v11.601Zm15.82-5.94 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.926-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.566-1.116-1.079 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.382Zm19.749 4.992 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.268 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428H1267.4c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Right Ankle' ? 'bodyParts_group Right_Ankle body_parts_active' : 'bodyParts_group Right_Ankle' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Ankle');
	            }, className: 'bodyParts', d: 'M676.39 1310.09c-2.05-.45-4.89-1.32-8.75-2.51-6.79-2.11-15.25-4.75-18.96-4.21l-7.01 1-.01-.07-.09-.64c-.06.21-.11.43-.17.64-2.9 10.56-7.78 22.39-13.79 35.92-7.99 17.97-31.64 38.92-41.63 45.92-9.98 6.98 5.7 18.98 16.67 20.97 10.98 2 40.94 2 48.92 0 7.99-1.99 12.98-1 17.98-15.97 4.98-14.97 9.98-39.95 15.98-40.94 5.99-1 22.37-7.66 20.28-19.15-1.71-9.42-2.96-10.92-4.38-13.82-8.2-3.22-25.04-7.13-25.04-7.14z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Ankle');
	            }, className: 'bodyLines', d: 'm641.67 1304.37 7.01-1c3.71-.54 12.17 2.1 18.96 4.21 3.86 1.2 6.7 2.06 8.75 2.51l2.68-1.61c-.86.07-3.2-.52-5.86-1.3.08.34.13.52.14.56l-1.93.49c-.02-.06-.17-.66-.44-1.71-.93-.29-1.86-.57-2.75-.85-7.35-2.28-15.67-4.87-19.83-4.28l-6.2.88-.27.04c-.11.44-.24.9-.36 1.35l.09.64.01.07z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Ankle');
	            }, className: 'bodyLines', d: 'm671.42 1308.23 1.93-.49c-.01-.04-.06-.22-.14-.56-.73-.21-1.48-.43-2.23-.66.27 1.05.42 1.65.44 1.71zm8.47 2.11c-.26.08-.57.12-.94.12-.65 0-1.51-.13-2.56-.37 0 0 16.85 3.92 25.05 7.14-.43-.89-.88-1.9-1.37-3.31-4.61-1.25-14.48-3.92-19.02-5.01-.43 1.18-.83 1.32-1.16 1.43z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Ankle');
	            }, className: 'bodyLines', d: 'M676.39 1310.09c1.05.23 1.91.37 2.56.37.37 0 .68-.04.94-.12.33-.11.73-.25 1.15-1.43-.88-.21-1.57-.36-1.97-.43l-2.68 1.61z' }),
	          this.props.bodyTitle === 'Right Ankle' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '167', y: '1332', width: '210', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup is_right' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M405 1353.94h230' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M185.291 1363.04v-25.77h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.184 1.125 2.537 1.125 4.061 0 1.933-.568 3.53-1.705 4.79-1.137 1.259-2.836 2.053-5.098 2.382 1.125.656 2.054 1.376 2.786 2.162.733.785 1.72 2.179 2.962 4.183l3.147 5.028h-6.223l-3.762-5.608c-1.336-2.004-2.25-3.266-2.742-3.788-.492-.521-1.014-.879-1.564-1.072-.551-.194-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.872h3.849c2.497 0 4.055-.105 4.676-.316a2.8 2.8 0 0 0 1.459-1.09c.352-.515.528-1.16.528-1.933 0-.868-.232-1.568-.695-2.101-.463-.533-1.116-.87-1.96-1.011-.422-.058-1.687-.088-3.797-.088h-4.06v6.539Zm20.742-6.328v-4.57h4.939v4.57h-4.939Zm0 21.2v-18.668h4.939v18.668h-4.939Zm9.545 1.23 5.643.686c.093.656.31 1.107.65 1.353.469.352 1.207.527 2.215.527 1.289 0 2.256-.193 2.9-.58.434-.257.762-.673.985-1.248.152-.41.228-1.166.228-2.267v-2.725c-1.477 2.016-3.34 3.024-5.59 3.024-2.508 0-4.494-1.061-5.959-3.182-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.752-5.519 2.258-7.172 1.506-1.652 3.378-2.478 5.617-2.478 2.308 0 4.212 1.013 5.712 3.041v-2.619h4.623v16.752c0 2.203-.181 3.849-.544 4.939-.364 1.09-.873 1.945-1.53 2.566-.656.621-1.532 1.108-2.628 1.459-1.095.352-2.481.528-4.157.528-3.164 0-5.408-.542-6.732-1.626-1.325-1.084-1.987-2.458-1.987-4.122 0-.164.006-.364.018-.598Zm4.412-10.951c0 1.98.384 3.431 1.151 4.35.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.471 3.059-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.399-3.369-1.195-4.307-.797-.937-1.805-1.406-3.024-1.406-1.183 0-2.159.46-2.927 1.38-.767.92-1.151 2.323-1.151 4.21Zm22.957-16.049v9.475c1.594-1.864 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.421 1.603.96 2.066 1.617.462.656.779 1.383.949 2.179.17.797.255 2.034.255 3.709v10.952h-4.94v-9.862c0-1.957-.094-3.199-.281-3.726a2.446 2.446 0 0 0-.993-1.257c-.475-.311-1.07-.466-1.784-.466-.821 0-1.553.199-2.198.598-.644.398-1.116.999-1.415 1.801-.298.803-.448 1.99-.448 3.56v9.352h-4.939v-25.77h4.939Zm25.629 7.1v3.937h-3.375v7.524c0 1.523.032 2.411.097 2.663.064.252.211.46.439.624.229.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.693-.149-2.408-.448-.715-.299-1.24-.685-1.573-1.16-.334-.475-.566-1.116-.695-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm35.367 18.67h-5.66l-2.25-5.854h-10.301l-2.127 5.854h-5.519l10.037-25.77h5.502l10.318 25.77Zm-9.58-10.196-3.551-9.562-3.48 9.562h7.031Zm29.285 10.196h-4.939v-9.528c0-2.015-.106-3.319-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.548 3.548 0 0 0-1.397 1.863c-.252.774-.378 2.204-.378 4.289v8.456h-4.939v-18.668h4.588v2.742c1.628-2.11 3.679-3.164 6.152-3.164 1.09 0 2.086.196 2.988.589.902.392 1.585.893 2.048 1.503.463.609.785 1.3.967 2.074.181.773.272 1.881.272 3.322v11.602Zm4.834 0v-25.77h4.94v13.676l5.783-6.574h6.082l-6.381 6.82 6.838 11.848h-5.326l-4.694-8.385-2.302 2.408v5.977h-4.94Zm20.198-25.77h4.939v25.77h-4.939zm20.812 19.82 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.699-1.846-3.844-1.846-6.434 0-3.094.809-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.393-2.671 1.178-.704.785-1.049 1.851-1.038 3.199h7.383Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Left Ankle' ? 'bodyParts_group Left_Ankle body_parts_active' : 'bodyParts_group Left_Ankle' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Ankle');
	            }, className: 'bodyParts', d: 'M832.89 1307.58c-5.84 1.81-9.39 2.89-11.31 2.89-1.49.19-15.05 3.31-22.2 4.97-1.78 4.41-3.17 4.47-5.18 15.62-2.1 11.49 14.29 18.15 20.28 19.15 6 .99 10.99 25.97 15.98 40.94 5 14.97 9.98 13.98 17.98 15.97 7.98 2 37.94 2 48.91 0 10.98-1.99 26.66-13.99 16.67-20.97-9.98-7-33.63-27.95-41.62-45.92-6.01-13.52-10.88-25.33-13.79-35.88l-6.77-.97c-3.71-.54-12.16 2.09-18.95 4.2z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Ankle');
	            }, className: 'bodyLines', d: 'M832.29 1305.67c-.89.28-1.82.56-2.74.85-.27 1.05-.42 1.65-.44 1.72l-1.94-.49c.01-.04.06-.23.14-.55-2.66.78-5 1.37-5.86 1.29 0 0 2.16 1.74.12 1.99 1.91 0 5.47-1.07 11.31-2.89 6.79-2.11 15.25-4.74 18.96-4.2l6.77.97c0-.02-.01-.03-.01-.05v-.01c-.18-.67-.36-1.35-.53-2.01 0-.01 0-.02-.01-.03l-5.93-.85c-4.16-.61-12.49 1.98-19.84 4.26z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Ankle');
	            }, className: 'bodyLines', d: 'M829.11 1308.23c.02-.07.17-.67.44-1.72-.75.23-1.51.46-2.23.67-.08.32-.13.52-.14.55l1.93.5zm-8.47 2.11c-.33-.11-.73-.25-1.16-1.45-3.85.81-12.56 2.62-19.17 3.9-.32 1.05-.63 1.9-.93 2.64 7.15-1.66 20.7-4.78 22.2-4.97-.38 0-.69-.04-.94-.12z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Ankle');
	            }, className: 'bodyLines', d: 'M820.64 1310.34c.25.09.57.13.94.13 2.04-.25-.12-1.99-.12-1.99s-.74.16-1.97.42c.42 1.19.82 1.33 1.15 1.44z' }),
	          this.props.bodyTitle === 'Left Ankle' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '1330', width: '185', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M864.206 1350.14h230' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1119.95 1363.04v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.63-5.95 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.699-1.846-3.844-1.846-6.434 0-3.094.808-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.643 2.302 8.428h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm6.759-7.728h2.742v-1.407c0-1.57.167-2.742.501-3.515.334-.774.949-1.404 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.632l-.668 3.446a9.732 9.732 0 0 0-2.268-.282c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.319h3.692v3.884h-3.692v14.784h-4.939v-14.784h-2.742v-3.884Zm22.72 0v3.937h-3.375v7.524c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm35.36 18.67h-5.66l-2.25-5.854h-10.301l-2.127 5.854h-5.52l10.037-25.77h5.502l10.319 25.77Zm-9.58-10.196-3.551-9.562-3.481 9.562h7.032Zm29.29 10.196h-4.94v-9.528c0-2.015-.105-3.319-.316-3.911-.211-.592-.554-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492a3.96 3.96 0 0 0-2.303.703 3.542 3.542 0 0 0-1.397 1.863c-.252.774-.378 2.204-.378 4.289v8.456h-4.94v-18.668h4.588v2.742c1.629-2.11 3.68-3.164 6.152-3.164 1.09 0 2.086.196 2.989.589.902.392 1.585.893 2.048 1.503.462.609.785 1.3.966 2.074.182.773.273 1.881.273 3.322v11.602Zm4.83 0v-25.77h4.939v13.676l5.783-6.574h6.083l-6.381 6.82 6.838 11.848h-5.327l-4.693-8.385-2.303 2.408v5.977h-4.939Zm20.2-25.77h4.939v25.77h-4.939zm20.81 19.82 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.699-1.845-3.844-1.845-6.434 0-3.094.808-5.516 2.425-7.268 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.393-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Chest' ? 'bodyParts_group Chest body_parts_active' : 'bodyParts_group Chest' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyParts', d: 'M719.72 479.09c10.83-2.29 22.97-2.25 26.55.62 1.58 1.26 2.69 4.29 3.39 8.13l.04-33.08c-2.68 8.34-11.05 20.22-29.98 24.33z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyParts', d: 'M620.71 403.93c4.42 7.1 9.18 15.38 10.28 19.75.23.95.53 2.28.9 3.91 2.71 12.03 9.05 40.2 20.17 47.04 12.16 7.48 42.09 7.11 65.37 2.87 21.12-3.84 30.24-18.34 31.22-27.16 1.01-9.02-2.1-50.45-3.99-61.79-.6-3.58-.59-8.21-.58-13.11.03-11.34.06-24.19-7.69-26.13-13.75-3.43-46.12-4.31-74.44 7.96-21.46 9.3-32.67 15.48-42.38 27.51-3.69 4.59-4 11.07-.76 16.14.62.96 1.25 1.97 1.9 3.01zm130.32 52.17-.05 29.94v1.26c.08-.41.17-.82.26-1.22v-.04c.7-2.98 1.7-5.28 3.02-6.33 3.58-2.87 15.74-2.91 26.58-.61-17.96-3.88-26.43-14.77-29.55-23v-.04c-.1-.26-.17-.5-.26-.75v.79z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyParts', d: 'M880.95 384.78c-4.85-6.01-10.08-10.57-16.77-14.78-6.7-4.21-14.87-8.08-25.6-12.73-17.64-7.64-36.85-10.19-52.15-10.19-9.27 0-17.11.94-22.3 2.23-7.75 1.94-7.72 14.79-7.69 26.13.01 4.9.03 9.53-.57 13.11-1.89 11.34-5 52.78-4 61.79.98 8.82 10.1 23.32 31.22 27.16 23.29 4.23 53.22 4.61 65.37-2.87 11.13-6.85 17.47-35.02 20.18-47.05.36-1.62.66-2.95.9-3.9 1.25-5.01 7.31-15.14 12.17-22.76 3.24-5.07 2.93-11.55-.76-16.14zM749.96 453.9c-.08.28-.17.57-.26.87l-.04 33.08c.09.52.18 1.05.26 1.6.14.91.25 1.85.34 2.82.17-1.77.41-3.43.72-4.96v-1.26l.05-29.94v-.79c-.31-.89-.58-1.75-.77-2.56-.08.36-.18.75-.3 1.14z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyLines', d: 'M750.26 452.75a14.5 14.5 0 0 1-.29-1.56 7.13 7.13 0 0 1-.09-.62c-.08-.71-.13-1.6-.17-2.65v3.27l-.01 2.71v.87c.09-.29.18-.58.26-.87.12-.39.22-.78.3-1.15zm-.53-19.12-.01 7.57c.05-2.3.14-4.85.27-7.57.08-1.74.17-3.54.27-5.38-.08-1.41-.17-2.84-.26-4.29-.08-1.28-.17-2.58-.26-3.87v3.87l-.01 9.67zm-127.47-24.16c-.01.03-.09.2-.23.49.44.72.84 1.42 1.23 2.1.5-1.07.78-1.69.81-1.74l-1.81-.85zm8.46 21.98c.34 1.49.72 3.12 1.15 4.84.42-2.47.75-4.18.85-4.64l-1.95-.43c0 .01-.02.1-.04.22-.01 0-.01 0-.01.01 0-.01 0-.01 0 0z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyLines', d: 'M750.64 450.57c-.07.67-.2 1.4-.38 2.18.19.81.46 1.67.77 2.56l.06-39.53c-.31 4.18-.6 8.43-.83 12.47.55 9.9.79 18.61.38 22.32zm-.93-2.65.01-6.72c-.06 2.62-.07 4.91-.01 6.72z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyLines', d: 'M749.97 451.19c.06.49.16 1.01.29 1.56.18-.78.31-1.51.38-2.18.41-3.71.17-12.42-.38-22.32-.1 1.84-.19 3.64-.27 5.38-.13 2.72-.22 5.27-.27 7.57l-.01 6.72c.03 1.04.09 1.94.17 2.65.02.2.05.41.09.62z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'syzst2', d: 'm745.88 364.88.09 1.69c-.02-.57-.05-1.14-.09-1.69zm-.3-3.39c.13 1.08.22 2.18.3 3.31-.07-1.12-.17-2.23-.3-3.31zm-.5-3.19c.2 1 .36 2.05.49 3.13a37.24 37.24 0 0 0-.49-3.13zm.89 8.35.06 1.66c-.01-.56-.03-1.11-.06-1.66zm-1.64-11.28zm1.75 16.55v1.64c.01-.54 0-1.09 0-1.64zm0 2.02v1.5-1.5zm-8.14-26.23c-.34-.13-.69-.24-1.06-.34.37.09.72.21 1.06.34zm5.33 5.05zm2.8 17.51c.01.53.01 1.06.01 1.59 0-.53-.01-1.06-.01-1.59zm-.04-1.9.03 1.67c0-.55-.01-1.11-.03-1.67zm10.41-13.7zm1.1-2.43c-.4.71-.74 1.47-1.04 2.28.29-.81.64-1.57 1.04-2.28zm-2.46 8.2zm-13.23-9.89c.53.66 1 1.39 1.41 2.19-.41-.8-.87-1.54-1.41-2.19zm21.8-3.18zm-5.41 3.75zm-3.8 22.89v1.43-1.43zm0-.41c0-1.04 0-2.08.01-3.12-.01 1.04-.01 2.08-.01 3.12zm.29-9.94zm-.19 3.36c-.04 1.04-.06 2.09-.08 3.15.01-1.05.04-2.1.08-3.15zm1.1-9.6zm125.31 27.36c-4.85-6.01-10.08-10.57-16.77-14.78-6.7-4.21-14.87-8.08-25.6-12.73-17.64-7.64-36.85-10.19-52.15-10.19-9.27 0-17.11.94-22.3 2.23-7.75 1.94-7.72 14.79-7.69 26.13.01 4.9.03 9.53-.57 13.11-1.89 11.34-5 52.78-4 61.79.98 8.82 10.1 23.32 31.22 27.16 23.29 4.23 53.22 4.61 65.37-2.87 11.13-6.85 17.47-35.02 20.18-47.05.36-1.62.66-2.95.9-3.9 1.25-5.01 7.31-15.14 12.17-22.76 3.24-5.07 2.93-11.55-.76-16.14z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyParts', d: 'M741.85 350.55c.53.66 1 1.39 1.41 2.19 0 .01.01.01.01.02.4.8.75 1.65 1.05 2.57 0 .01.01.03.01.04.29.91.54 1.88.74 2.88 0 .02.01.04.01.05.2 1.01.36 2.05.49 3.13 0 .02.01.04.01.07.13 1.08.22 2.18.3 3.31v.07l.09 1.69v.08l.06 1.66v.06l.03 1.67v.23c.01.53.01 1.06.01 1.59v3.58c-.01 4.82-.02 9.37.55 12.78.97 5.83 2.22 18.98 3.11 31.87l.08-68.47c-2.74-.04-5.56-.32-7.96-1.07zm9.51 61.74v-.06c.81-10.09 1.76-19.37 2.54-24.01.57-3.41.55-7.96.54-12.78v-1.84c0-1.04 0-2.08.01-3.12v-.31c.01-1.05.04-2.11.08-3.15 0-.08.01-.16.01-.25.04-1.05.1-2.09.18-3.12.01-.07.01-.14.02-.21.09-1.03.2-2.03.33-3.01l.03-.18c.14-.98.32-1.93.53-2.84.01-.05.03-.11.04-.16.22-.91.47-1.77.77-2.59.02-.05.03-.09.05-.14.3-.81.65-1.58 1.04-2.28.02-.04.05-.08.07-.13.2-.35.41-.68.63-1-1.87.23-4.38.47-7.04.5l-.1 60.61v.08l-.01 3.47.27-3.47c.01 0 .01 0 .01-.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyParts', d: 'M751.1 412.29v-.06l.1-60.61c-.46.01-.92.01-1.38 0l-.08 68.47c.09 1.3.18 2.59.26 3.87.09 1.45.18 2.88.26 4.29.23-4.04.52-8.29.83-12.47l.01-3.47v-.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyLines', d: 'M746.08 375.44v-3.58c0-.53-.01-1.06-.01-1.59v-.23l-.03-1.67v-.06c-.01-.56-.03-1.11-.06-1.66v-.08c-.02-.57-.05-1.13-.09-1.69v-.07c-.07-1.13-.17-2.23-.3-3.31 0-.02-.01-.04-.01-.07-.13-1.08-.29-2.12-.49-3.13 0-.02-.01-.04-.01-.05-.2-1.01-.45-1.97-.74-2.88 0-.01-.01-.03-.01-.04-.3-.91-.64-1.77-1.05-2.57 0-.01-.01-.01-.01-.02-.41-.8-.87-1.53-1.41-2.19-1.03-1.27-2.32-2.24-3.91-2.84-.34-.13-.69-.24-1.06-.34-7.29-1.82-19.72-2.94-34.02-1.83l-.58 1.75c-.03-.02-1.36-.45-4.01-1.32h-.02c-11.94 1.3-24.89 4.18-37.1 9.46-10.89 4.72-19.17 8.66-25.99 12.96-6.82 4.3-12.16 8.96-17.14 15.14-4.07 5.04-4.57 12.09-1.31 17.78.08.15.18.3.27.45.86-.39 1.82-.83 1.83-.84-3.24-5.07-2.93-11.55.76-16.14 9.71-12.03 20.92-18.21 42.38-27.51 28.32-12.27 60.69-11.39 74.44-7.96 7.75 1.94 7.72 14.79 7.69 26.13-.01 4.9-.02 9.53.58 13.11 1.89 11.34 5 52.77 3.99 61.79-.98 8.82-10.1 23.32-31.22 27.16-23.28 4.24-53.21 4.61-65.37-2.87-11.12-6.84-17.46-35.01-20.17-47.04-.37-1.63-.67-2.96-.9-3.91-1.1-4.37-5.86-12.65-10.28-19.75-.01.01-1.26 0-2.35.02 1.33 2.13 2.57 4.14 3.67 6.01.13-.29.21-.46.23-.49l1.81.85c-.02.05-.31.67-.81 1.74 3.19 5.53 5.19 9.7 5.79 12.11.23.94.53 2.25.89 3.86.23 1.03.49 2.17.78 3.41.02-.12.04-.21.04-.22l1.95.43c-.1.46-.42 2.17-.85 4.64v.01c3.41 13.91 9.49 34.1 19.15 40.03 7.22 4.45 19.72 6.22 33.31 6.22 6.97 0 14.21-.47 21.2-1.27 1.78-1.34 2.89-2.21 2.94-2.25l1.24 1.57c-.04.03-.12.09-.22.17h.01c2.85-.38 5.63-.82 8.3-1.31.65-.12 1.28-.24 1.9-.37.01 0 .02-.01.03-.01 18.92-4.11 27.3-15.98 29.98-24.32v-.87l.01-2.71v-3.27c-.06-1.82-.05-4.1.01-6.72l.01-7.57.01-9.67v-3.87c-.89-12.89-2.14-26.03-3.11-31.87-.58-3.4-.57-7.95-.56-12.77zm136.43 8.09c-9.97-12.37-21.37-18.66-43.14-28.1-12.2-5.29-25.16-8.17-37.09-9.47-2.67.87-4 1.31-4.03 1.33l-.59-1.76c-14.3-1.1-26.72.02-34.01 1.84-.45.11-.88.26-1.28.43-1.72.7-3.07 1.84-4.13 3.33-.22.32-.43.65-.63 1-.02.04-.05.08-.07.13-.4.71-.74 1.47-1.04 2.28-.02.05-.03.09-.05.14-.3.82-.55 1.69-.77 2.59-.01.05-.03.11-.04.16-.21.91-.38 1.86-.53 2.84l-.03.18c-.14.98-.25 1.98-.33 3.01-.01.07-.01.14-.02.21a77.08 77.08 0 0 0-.18 3.12c0 .08-.01.16-.01.25-.04 1.04-.06 2.09-.08 3.15v.31c-.01 1.04-.02 2.08-.01 3.12v1.84c.01 4.82.03 9.37-.54 12.78-.78 4.64-1.73 13.92-2.54 24.01v.08c-.09 1.14-.18 2.31-.27 3.47l-.06 39.53c.09.25.16.49.26.75v.04c3.12 8.23 11.59 19.12 29.55 23 .62.13 1.25.25 1.89.37 2.68.49 5.47.93 8.32 1.31-.1-.08-.18-.14-.22-.17l1.24-1.57c.05.04 1.16.91 2.94 2.25 6.98.8 14.24 1.27 21.19 1.27 13.6 0 26.09-1.77 33.32-6.22 9.65-5.93 15.73-26.11 19.15-40.03-.43-2.47-.75-4.19-.85-4.65l1.95-.43c0 .01.02.11.05.25v-.01c.28-1.25.55-2.4.78-3.44.36-1.6.65-2.92.89-3.85.6-2.41 2.61-6.58 5.78-12.12-.49-1.07-.78-1.68-.8-1.73l1.81-.85c.01.03.09.19.22.48 1.27-2.14 2.69-4.44 4.24-6.91-.31-.12-.5-.18-.53-.19l.63-1.9c.03.01.38.13.97.36 3.25-5.72 2.75-12.77-1.31-17.81zm-.8 17.39c-4.86 7.62-10.92 17.75-12.17 22.76-.24.95-.54 2.28-.9 3.9-2.71 12.03-9.05 40.2-20.18 47.05-12.15 7.48-42.08 7.1-65.37 2.87-21.12-3.84-30.24-18.34-31.22-27.16-1-9.01 2.11-50.45 4-61.79.6-3.58.58-8.21.57-13.11-.03-11.34-.06-24.19 7.69-26.13 5.19-1.29 13.03-2.23 22.3-2.23 15.3 0 34.51 2.55 52.15 10.19 10.73 4.65 18.9 8.52 25.6 12.73 6.69 4.21 11.92 8.77 16.77 14.78 3.69 4.59 4 11.07.76 16.14z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyLines', d: 'M743.26 352.74c0 .01.01.01.01.02 0-.01-.01-.02-.01-.02zm-5.32-5.03c1.6.6 2.88 1.57 3.91 2.84 2.4.75 5.22 1.03 7.97 1.07v-2.14c-5.53-.11-9.95-1.21-11.88-1.77zm8.09 20.6v.06-.06zm.03 1.74v.23c.01-.08.01-.16 0-.23zm-1.75-14.72c0 .01.01.03.01.04 0-.02 0-.03-.01-.04zm1.66 11.23v.08-.08zm.11 5.3v.06-.06zm0 1.7v.38-.38zm-1.01-15.31c0 .02.01.04.01.05 0-.02-.01-.03-.01-.05zm.5 3.18c0 .02.01.04.01.07 0-.03 0-.05-.01-.07zm.31 3.37v.07-.07zm8.56 9.21v-.41.41zm3.17-21.89c-.02.04-.05.08-.07.13.02-.05.04-.09.07-.13zm-1.12 2.41c-.02.05-.03.09-.05.14.02-.05.04-.1.05-.14zm-5.29-5.04v2.13c2.67-.03 5.18-.27 7.04-.5 1.06-1.49 2.41-2.63 4.13-3.33-3.89 1.21-7.71 1.66-11.17 1.7zm3.34 17.29c0 .08-.01.16-.01.25.01-.09.01-.17.01-.25zm-.08 3.39v.31c-.01-.1 0-.21 0-.31zm.29-6.72c-.01.07-.01.14-.02.21 0-.07.01-.14.02-.21zm.92-6.19c-.01.05-.03.11-.04.16.02-.05.03-.11.04-.16zm-.56 3-.03.18.03-.18zm-5.29-10.78v2.14c.46.01.92.01 1.38 0v-2.13c-.47 0-.92 0-1.38-.01zm-132.03 53.56c.2.31.38.61.57.91 1.09-.02 2.33-.01 2.35-.02 0 0 0-.01-.01-.01l-1.89-3c-.02.01-.97.45-1.83.84.05.08.09.16.14.24.22.35.45.7.67 1.04zm90.67 75.99c-.05.04-1.16.91-2.94 2.25h.01c1.33-.16 2.64-.32 3.94-.5.1-.08.18-.14.22-.17l-1.23-1.58zm-5.6-133.49c-1.51.12-3.03.26-4.59.43 2.65.87 3.98 1.3 4.01 1.32l.58-1.75zm179.35 57.31c.02.01.21.07.53.19.22-.34.45-.69.67-1.04.14-.23.28-.46.41-.69-.59-.23-.94-.35-.97-.36l-.64 1.9zm-4.95 9.19c.4-.68.81-1.37 1.23-2.09-.13-.28-.21-.45-.22-.48l-1.81.85c.02.05.31.66.8 1.73v-.01zm-9.45 19.61c.1.46.42 2.17.85 4.65v-.01c.42-1.72.8-3.32 1.15-4.81v-.01c-.03-.14-.04-.23-.05-.25l-1.95.43zm-72.82 49.63s.01 0 0 0c-1.77-1.34-2.88-2.21-2.93-2.24l-1.24 1.57c.04.03.12.09.22.17 1.31.18 2.63.34 3.95.5zm7.29-135.32c-1.56-.17-3.1-.31-4.62-.43l.59 1.76c.03-.02 1.36-.46 4.03-1.33z' }),
	          this.props.bodyTitle === 'Chest' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '395', width: '115', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M854.206 414.53h240' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'm1137.88 417.94 5.045 1.599c-.773 2.813-2.059 4.902-3.858 6.267-1.799 1.365-4.081 2.048-6.847 2.048-3.422 0-6.234-1.169-8.437-3.507-2.203-2.338-3.305-5.534-3.305-9.589 0-4.289 1.108-7.62 3.322-9.993 2.215-2.373 5.127-3.56 8.737-3.56 3.152 0 5.713.932 7.681 2.795 1.172 1.102 2.051 2.684 2.637 4.746l-5.15 1.231c-.305-1.336-.941-2.391-1.908-3.164-.966-.774-2.141-1.16-3.524-1.16-1.91 0-3.46.685-4.649 2.056-1.19 1.371-1.785 3.592-1.785 6.662 0 3.258.586 5.578 1.758 6.961 1.172 1.383 2.696 2.075 4.571 2.075 1.382 0 2.572-.44 3.568-1.319s1.711-2.262 2.144-4.148Zm14.4-16.295v9.474c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.065 1.617.463.657.78 1.383.95 2.18.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.094-3.199-.281-3.727a2.448 2.448 0 0 0-.993-1.256c-.475-.311-1.07-.466-1.785-.466-.82 0-1.552.199-2.197.597-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm27.88 19.828 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.952-.633.527-.422.925-1.102 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm7.189 5.607 4.957-.756c.211.961.638 1.691 1.283 2.189.644.498 1.547.747 2.707.747 1.277 0 2.238-.235 2.883-.703.433-.328.65-.768.65-1.319 0-.375-.117-.685-.352-.931-.246-.235-.796-.451-1.652-.651-3.984-.879-6.51-1.681-7.576-2.408-1.477-1.008-2.215-2.408-2.215-4.201 0-1.617.639-2.977 1.916-4.078 1.277-1.102 3.258-1.653 5.942-1.653 2.554 0 4.453.417 5.695 1.249 1.242.832 2.097 2.062 2.566 3.691l-4.658.861c-.199-.726-.577-1.283-1.134-1.67-.556-.386-1.35-.58-2.382-.58-1.3 0-2.232.182-2.795.545-.375.258-.562.592-.562 1.002 0 .352.164.651.492.897.445.328 1.984.791 4.614 1.388 2.631.598 4.468 1.33 5.511 2.198 1.031.878 1.547 2.103 1.547 3.673 0 1.711-.715 3.182-2.144 4.413-1.43 1.23-3.545 1.845-6.346 1.845-2.543 0-4.556-.515-6.038-1.547-1.483-1.031-2.452-2.431-2.909-4.201Zm30.32-13.342v3.938h-3.375v7.523c0 1.524.032 2.411.097 2.663.064.252.21.46.439.624.228.164.507.247.835.247.457 0 1.119-.159 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.694-.149-2.408-.448-.715-.299-1.24-.686-1.574-1.16-.334-.475-.565-1.116-.694-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Upper GI' ? 'bodyParts_group Upper_GI body_parts_active' : 'bodyParts_group Upper_GI' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M696.59 650.7c0 .03.01.21.02.54.53.44.71.44.98.44l.52-.03.3-.37c.05-.06.12-.14.19-.39 0-.11-.01-.19-.01-.24l-2 .05zm105.87.97h.47c.27 0 .45 0 .98-.45.01-.32.01-.5.01-.53l-2-.03c0 .05 0 .12-.01.21.08.25.14.34.19.4l.36.4z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M801.87 650.67h.06v-.02l-.06.02zm-102.58-29.34 5.62-2.96s.72-2.25 1.22-2.82l-6.88 3.42.04 2.36zm93.37-7.39s-.36-.95 8.67 1.59l-.04 2.12-6.5-1.52-2.13-2.19zM680.9 496.96l-.85 2.25s2.99-1.06 3.88-1.5c0 .01-2.47-.85-3.03-.75zm138.73 0s-3.01-.02-3.03.76c-.03 1.06 4.06 1.25 4.06 1.25l-1.03-2.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M651.02 476.33c-9.66-5.93-15.74-26.12-19.15-40.03v-.01c-1.45 8.41-4.1 25.73-3.36 33.09.94 9.41 13.11 22.61 18.09 26.17 7.22 5.16 22.08 3.23 30.07 2.2l1.78-.23c5.97-.75 20.76-11.47 27.08-16.23-6.99.8-14.23 1.27-21.2 1.27-13.59-.01-26.09-1.78-33.31-6.23zm172.84 21.41c7.98 1.04 22.85 2.96 30.07-2.2 4.98-3.56 17.15-16.76 18.09-26.17.74-7.38-1.91-24.67-3.36-33.08-3.42 13.92-9.5 34.11-19.15 40.03-7.23 4.45-19.72 6.22-33.32 6.22-6.96 0-14.22-.47-21.19-1.27 6.32 4.76 21.12 15.49 27.08 16.23l1.78.24z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'syzst2', d: 'M699.22 616.75c0-.2-.01-.39-.01-.58 0 .19.01.38.01.58zm63.96-9.07c-.08 0-.15-.01-.22-.01.07.01.14.01.22.01zm-.53-.02c-.06 0-.12 0-.17-.01.06 0 .11.01.17.01zm1.13.05c-.08 0-.15-.01-.22-.01.07.01.14.01.22.01zm-64.64 5.62c-.01-.25-.01-.49-.02-.73 0 .24.01.48.02.73zm.05 1.94zm65.28-7.52c-.07 0-.15-.01-.22-.01.07 0 .15.01.22.01zm-65.18 13.58v-.01c1.74-1.23 3.69-2.06 5.62-2.95.25-.94.52-1.7.82-2.23.12-.2.26-.4.41-.6-2.26 1.2-4.69 2.09-6.88 3.42l.03 2.37zm-.2-9.39c-.01-.4-.03-.8-.04-1.18.01.38.03.77.04 1.18zm63.14-4.3c-.12 0-.22-.01-.3-.01.08 0 .19.01.3.01zm-23.63-.01c-.09 0-.2.01-.33.01.13 0 .24-.01.33-.01zm62.77 6.38c-.01.5-.03 1.01-.04 1.53.02-.52.03-1.03.04-1.53zm-.12 6.21v.36c-.01-.12 0-.24 0-.36zm-102.59-15.27c-.03-.2-.06-.38-.08-.53.02.15.05.33.08.53zm102.76 7.38c-.01.46-.03.92-.04 1.4.01-.48.03-.94.04-1.4zm.12-3.09-.06 1.25c.03-.43.05-.85.06-1.25zm.14-2.36c-.02.32-.05.65-.07 1.01.03-.36.05-.7.07-1.01zm-.07 1.12zm-.13 2.73c-.02.42-.03.86-.05 1.32.02-.46.03-.9.05-1.32zm-.27 12.55zm-102.38-16.61c-.02-.3-.05-.59-.07-.84.02.25.04.54.07.84zm.14 2.37-.06-1.07c.03.34.04.7.06 1.07zm-.07-1.28c-.02-.29-.04-.56-.05-.81.02.25.03.53.05.81zm.13 2.55zm-.28-4.55c-.02-.24-.05-.45-.07-.64.02.19.05.4.07.64zm103.02.12c-.02.26-.05.54-.07.84.02-.3.04-.58.07-.84zm-.57 19.99v.59c-.01-.2-.01-.39 0-.59zm-36.01-18.07c-.05 0-.1-.01-.16-.01.06 0 .11 0 .16.01zm-40.41 1.06c-.11.02-.23.03-.34.05.11-.01.23-.03.34-.05zm2.63-.34c-.12.01-.23.03-.35.04.12-.01.24-.03.35-.04zm-1.31.16c-.11.01-.22.03-.33.04.11-.01.22-.02.33-.04zm2.58-.31c-.11.01-.23.02-.34.04.11-.01.23-.03.34-.04zm-9.27 1.41c-.11.02-.22.05-.34.07.12-.02.23-.04.34-.07zm4.03-.72zm-2.69.46-.33.06c.11-.01.22-.04.33-.06zm9.17-1.28c-.12.01-.23.02-.35.04.12-.02.24-.03.35-.04zm-7.82 1.04-.34.06c.11-.02.22-.04.34-.06zm15.95-1.63c-.08 0-.15.01-.23.01.08 0 .15-.01.23-.01zm-1.21.06c-.09 0-.16.01-.25.01.08 0 .16-.01.25-.01zm-.74.04c-.1.01-.19.01-.29.02.1-.01.19-.01.29-.02zm-5 .38-.34.03.34-.03zm-13.01 1.94c-.11.02-.22.05-.32.07.1-.02.21-.05.32-.07zm15.21-2.13c-.1.01-.2.02-.31.02.11 0 .21-.01.31-.02zm-1.08.09-.3.03c.1-.02.2-.02.3-.03zm2.08-.16c-.1.01-.19.01-.29.02.1-.01.2-.02.29-.02zm.94-.07c-.1.01-.18.01-.28.02.09-.01.18-.01.28-.02zm2.3-.13c-.1 0-.19.01-.3.01.11 0 .21 0 .3-.01zm-20.76 2.71c-.1.03-.21.05-.31.08.11-.03.21-.06.31-.08zm-5.9 1.91c-.07.03-.14.06-.22.1.07-.03.14-.07.22-.1zm3.4-1.23c-.1.03-.19.06-.28.09.09-.03.18-.06.28-.09zm-2.33.79-.24.09c.08-.02.16-.05.24-.09zm3.56-1.14c-.1.03-.2.05-.29.08.09-.03.19-.06.29-.08zm-6.57 2.54c-.05.03-.1.06-.16.09.06-.03.11-.06.16-.09zm-.84.53-.12.09c.03-.04.07-.07.12-.09zm1.77-1.02c-.07.03-.13.07-.19.1.07-.04.13-.07.19-.1zm-2.53 1.57c-.03.03-.06.05-.09.08.03-.03.06-.05.09-.08zm5.75-2.88c-.09.03-.18.06-.26.09.08-.03.17-.06.26-.09zm157.28-131.94c.01-.02.03-.04.04-.07-.02.02-.03.04-.04.07zm.57-1.04.03-.06c-.01.03-.02.04-.03.06zm-15.22 18.23c.11-.09.22-.17.34-.27-.11.09-.23.18-.34.27zm15.76-19.26.03-.06c-.01.03-.02.04-.03.06zm-1.72 3.09c.01-.02.03-.05.04-.07-.01.02-.03.05-.04.07zm-7.19 9.55c.05-.06.1-.11.15-.17-.05.06-.1.11-.15.17zm-7.48 7.09c.15-.11.3-.22.47-.35-.17.13-.33.25-.47.35zm1.21-.94c.1-.09.21-.17.31-.26-.11.09-.21.18-.31.26zm12.82-14.68c.02-.02.03-.05.05-.07-.01.02-.03.05-.05.07zm3.3-6.17c.01-.01.01-.03.02-.04 0 .01-.01.03-.02.04zm-52.79 21.58-.36.05c-.93.14-1.82.38-2.67.71 1.1.52 2.13.94 3.06 1.25l.21-.03-.24-1.98zm-178.24-3.29c0-.01 0-.01 0 0 0-.01 0-.01 0 0zm-1.18-1.18-.1-.1c.04.03.07.06.1.1zm232.62-18.14c0-.01.01-.02.01-.04 0 .02-.01.03-.01.04zM680.9 496.96l-.25 1.98.21.03c.94-.31 1.97-.73 3.06-1.25-.85-.33-1.75-.57-2.67-.71l-.35-.05zm-42-5.85c-.02-.02-.04-.05-.07-.07.03.02.05.05.07.07zm233.07-14.7c.01-.02.01-.03.02-.05 0 .02-.01.03-.02.05zm-13.09 17.5c.08-.08.16-.16.25-.24-.09.09-.17.16-.25.24zm2.93-2.99c.06-.06.11-.12.17-.19-.06.06-.11.12-.17.19zm-.76.8c.07-.07.13-.14.2-.21-.07.08-.13.14-.2.21zm3.04-3.39zm-3.77 4.16.21-.21c-.07.07-.14.13-.21.21zm3.01-3.28c.04-.05.09-.1.13-.15-.04.05-.08.1-.13.15zm3.01-3.69.08-.11c-.03.04-.06.08-.08.11zm-8.8 9.64.28-.25-.28.25zm9.52-10.61.07-.1c-.02.03-.04.07-.07.1zm.71-.99zm-2.93 3.86.11-.14c-.03.05-.07.09-.11.14zm-7.93 8.3c.1-.08.19-.16.29-.25-.1.08-.2.16-.29.25zm1.28-1.16zm7.41-8.08.09-.12-.09.12zm2.86-3.91.06-.09-.06.09zm-66.5 121.86zm71.76-133.1v-.01c.01 0 0 0 0 .01zm-71.86 133.72c-.03.21-.05.44-.08.69.02-.25.05-.48.08-.69zm-95.22 9.92c.02-.02.03-.04.05-.05l-.05.05zm-64.06-120.18c-.03-.03-.06-.05-.08-.08l.08.08zm217.24-1.8c-.07.07-.14.14-.22.21.07-.06.14-.13.22-.21zm-67.16 120.95c.89.64 1.6 1.33 2.07 2.1 2.21.44 4.43.87 6.56 1.59v.02c.01-.72.03-1.43.04-2.12-2.55-.81-5.21-1.23-7.82-1.78-.3-.05-.61.02-.85.19zM644.67 496.59c-.04-.03-.08-.06-.13-.1.05.04.09.07.13.1zm228.81-24.26c0-.01 0-.02.01-.02 0 0-.01.01-.01.02zm-.3 1.01c0-.01.01-.02.01-.03 0 .01 0 .02-.01.03zM643.7 495.79c-.05-.04-.11-.09-.16-.14.06.04.11.09.16.14zm209.72 70.83c-.08.74-.15 1.52-.22 2.34.27-2.07.49-3.78.62-4.9-.17.98-.33 1.88-.4 2.56z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M632.18 495.63c2.7 5.63 9.04 18.82 16.91 24.07 9.22 6.15 21.72 5.67 28.35 4.84 4.28-.53 8.23-5.71 10.8-9.96 1.8-2.98 1.99-6.65.49-9.81-1.49-3.17-4.33-5.28-7.77-5.79l-.09-.01h-.01c-.79.26-1.53.45-2.17.53l-1.77.23c-4.21.55-9.76 1.27-15.27 1.27-6.07 0-12.1-.87-16.22-3.82-.24-.17-.5-.37-.77-.58-.04-.03-.08-.06-.13-.1-.27-.21-.55-.45-.85-.71-.05-.05-.11-.09-.16-.14-.31-.27-.63-.55-.96-.86-.03-.03-.06-.05-.08-.08-.36-.33-.72-.67-1.1-1.04l-.01-.01c-.38-.37-.77-.76-1.17-1.17l-.1-.1c-.4-.41-.8-.83-1.21-1.27-.02-.02-.04-.05-.07-.07-4.32-4.67-9.13-11.03-11.26-17.02-1.05 4-.28 8.18-.19 12.31.14.34.28.69.41 1.01 1.39 2.55 2.82 5.14 3.6 6.72.24.39.49.93.8 1.56zm8.1 26.12c.04.22.07.45.1.67.03-.06.06-.12.08-.18-.06-.16-.13-.32-.18-.49zm7.96 29.47c3.39 8.52 9.7 24.38 20.74 29.47 13.59 6.27 23.61 6.49 24.9 5.21 1.6-1.61 1.97-8.54-2.22-18.94-1.73-4.29-6.08-10.54-7.42-12.42-1.51.38-3.29.57-5.3.57-4.28 0-9.61-.86-15.66-2.58-8.27-2.37-16.27-10.11-21.91-22.53.31 1.42.7 2.92 1.23 4.49.29.88.57 1.71.82 2.48.87 2.59 1.49 5.27 1.81 7.98v.01c.04.35.06.71.09 1.06.61.64 1.32 1.31 1.62 2.01.38.88.81 1.96 1.3 3.19z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M640.45 522.24c5.6 15.96 14.29 25.77 23.38 28.36 14.27 4.08 22.27 2.7 23.86-.48 1.26-2.52-2.16-16.65-4.86-25.92-1.6 1.23-3.33 2.1-5.14 2.33-2.12.26-4.83.49-7.85.49-6.78 0-15.1-1.15-21.86-5.66-6.23-4.15-11.44-12.78-14.84-19.28h-.26c1.31 4.05 2.97 8.57 4.92 12.19a22.82 22.82 0 0 1 2.43 7.25l.3.19c.03.18-.01.35-.08.53zm24.68 95.58c6.55 4.58 18.07 16.67 25.69 24.66 2.43 2.55 4.77 5.01 6.11 6.32.57-7.33.64-39.19-.32-43.99-.88-4.38-2.9-14.17-3.39-16.55-.79.18-1.75.27-2.86.27-5.12 0-13.31-1.92-22.22-6.03-11.76-5.43-18.27-21.77-21.76-30.55-.12-.31-.54-.61-.93-.9-.02.4-.03.8-.06 1.21-.11 1.32-.18 2.88-.18 4.71 0 2.75 1.13 7.36 1.37 9.64.12 1.12.22 2.34.31 3.61 1.05 5.76 2.52 13.61 3.63 19.18 2.05 10.24 5.03 21.71 14.61 28.42z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M744.96 561.52c-.19.06-11.17 3.68-21.42 6.76 8.81-2.09 19.23-2.17 22.2.21 4.37 3.5 4.37 24.35.99 29.42-2.69 4.03-7.32 4.86-12.68 5.82-1.4.25-2.84.51-4.32.84-4.53 1.01-13.26 4.77-18.05 6.92-.8.36-1.65.54-2.5.54-.92 0-1.84-.21-2.69-.62a6.04 6.04 0 0 1-3.2-3.98c-4.01-16.57 2.16-29.56 10.05-35.08 1.45-1.01 3.29-1.9 5.36-2.65-5.71 1.65-10.51 2.89-12.1 2.89-1.12 0-2.35-.64-3.55-1.86-3.47-3.5-6.92-11.89-6.81-22.74.04-3.75 1.87-7.33 4.91-9.57 5.4-4 14-9.29 24.23-11.85 17.6-4.4 22.03-1.68 22.97-.74.42.42.86 1.69 1.27 3.45l.02-18.69c-.52 2.81-1.23 5.12-2.16 6.5-3.39 5.08-9.27 6.13-16.08 7.35-1.8.33-3.66.66-5.56 1.08-5.84 1.3-17.06 6.14-23.22 8.91-.99.44-2.04.66-3.1.66-1.13 0-2.27-.26-3.32-.77a7.415 7.415 0 0 1-3.95-4.92c-1.11-4.58-1.61-8.95-1.61-13.05 0-.72.02-1.44.05-2.15-.21.48-.46.96-.74 1.42-1.44 2.38-3.3 5.04-5.46 7.14 1.53 5.16 6.98 24.28 4.99 28.26-.62 1.23-1.73 2.19-3.26 2.87 1.67 2.36 5.59 8.12 7.29 12.33 4.52 11.2 4.09 18.79 1.78 21.1-.06.06-.12.11-.19.17.28 1.38 2.54 12.26 3.48 16.94.03.15.06.33.08.53.01.05.01.11.02.16.02.2.05.41.07.64 0 .02 0 .04.01.06.02.26.05.54.07.84.01.09.01.18.02.28.02.26.04.53.05.81 0 .07.01.14.01.21l.06 1.07c.01.14.01.28.02.43.01.27.03.56.04.84.01.15.01.29.02.45.02.38.03.77.04 1.18.01.22.01.44.02.67.01.24.01.48.02.73.01.24.01.49.02.74l.03 1.2c.01.29.01.59.02.9 0 .19.01.39.01.58.01.72.03 1.46.04 2.21 2.19-1.33 4.62-2.21 6.88-3.42.15-.19.32-.38.5-.57.02-.02.03-.04.05-.05.17-.18.37-.34.57-.51.03-.03.06-.05.09-.08.2-.16.41-.32.63-.47l.12-.09c.22-.15.45-.29.69-.43.05-.03.1-.06.16-.09.24-.14.49-.27.74-.4.06-.03.13-.07.19-.1.25-.13.52-.25.79-.37.07-.03.14-.07.22-.1.27-.12.55-.23.84-.34l.24-.09c.28-.11.58-.21.87-.32.09-.03.17-.06.26-.09.3-.1.6-.2.91-.29.09-.03.19-.06.28-.09a115.484 115.484 0 0 1 1.23-.35c.32-.09.64-.17.96-.25.1-.03.2-.05.31-.08.32-.08.65-.16.98-.23.11-.02.22-.05.32-.07.33-.07.66-.15.99-.21.11-.02.22-.05.34-.07.33-.07.67-.13 1-.2l.33-.06 1.01-.18.34-.06c.34-.06.67-.11 1.01-.17.11-.02.23-.04.34-.05l1-.15c.11-.02.23-.03.34-.05.33-.05.66-.09.99-.14.11-.01.22-.03.33-.04l.96-.12c.12-.01.23-.03.35-.04.31-.04.62-.07.93-.11.12-.01.23-.03.34-.04.3-.03.6-.07.89-.1.12-.01.23-.02.35-.04.29-.03.57-.06.84-.08l.34-.03c.28-.03.55-.05.81-.07l.3-.03.78-.06c.1-.01.2-.02.31-.02.24-.02.48-.04.71-.05.1-.01.19-.01.29-.02.22-.02.44-.03.65-.04.1-.01.19-.01.28-.02.19-.01.39-.02.57-.04.1-.01.2-.01.29-.02l.48-.03c.09 0 .17-.01.25-.01.14-.01.28-.02.41-.02.11-.01.2-.01.3-.01.09 0 .19-.01.27-.01.09 0 .16-.01.23-.01s.16-.01.22-.01c.13-.01.24-.01.33-.01l.07-.01.08.01c5.55.62 9.1 2.07 10.77 4.4l.07-55.08c-.62 2-1.92 3.64-4.61 4.54z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M705.24 606.96a3.997 3.997 0 0 0 2.13 2.65 4.1 4.1 0 0 0 3.49.06c5.94-2.67 13.97-6.06 18.44-7.05 1.51-.34 2.98-.6 4.4-.86 5.11-.91 9.14-1.64 11.36-4.96 3.1-4.65 2.68-24.15-.57-26.75-1.14-.91-4.05-1.37-7.69-1.37-7.2 0-17.27 1.77-22.32 5.31-7.33 5.13-13.03 17.32-9.24 32.97zm-21.31-109.24a12.2 12.2 0 0 1 6.61 6.19c.48 1.02.81 2.07 1 3.15 2.05-10.26 7.36-18.1 13.49-22.39 3.53-2.47 8.91-4.35 14.66-5.57-.62.13-1.25.25-1.9.37-2.67.49-5.45.93-8.3 1.31h-.01c-2.01 1.57-16.2 12.53-25.55 16.94z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M694.19 528.92a5.387 5.387 0 0 0 2.89 3.59c1.49.73 3.21.76 4.72.08 7.61-3.42 17.89-7.76 23.6-9.03 1.95-.43 3.83-.77 5.65-1.09 6.62-1.19 11.85-2.13 14.76-6.5 4.02-6.02 3.44-31.32-.79-34.7-4.4-3.52-29.02-1.84-38.85 5.04-9.49 6.65-16.87 22.4-11.98 42.61zm51.57-2.25c-.85-.26-2.26-.53-4.51-.53-3.19 0-8.06.54-15.39 2.37-9.91 2.48-18.26 7.63-23.53 11.52-2.53 1.87-4.06 4.85-4.09 7.98v.46c0 10 3.21 17.8 6.23 20.86.79.8 1.57 1.26 2.13 1.26 3.69 0 30.48-8.55 37.73-10.96 3.56-1.19 3.8-3.82 3.95-8.74.05-1.66.1-3.54.38-5.47.96-6.77-.94-17.07-1.76-18.21 0 0-.29-.27-1.14-.54zm62.52 2.72a7.424 7.424 0 0 1-1.42 2.9c-.68.84-1.54 1.53-2.54 2.02-1.05.51-2.18.77-3.32.77-1.05 0-2.1-.22-3.09-.66-6.17-2.77-17.39-7.61-23.22-8.91-1.9-.42-3.76-.75-5.56-1.08-6.81-1.22-12.69-2.27-16.08-7.35-.75-1.13-1.37-2.86-1.85-4.99v-.08c-.09-.39-.18-.81-.26-1.23v1.31l-.03 16.11v1.07c.09-.38.17-.74.26-1.07.33-1.2.67-2.04 1-2.37.94-.94 5.37-3.66 22.98.74 10.23 2.56 18.82 7.85 24.23 11.85 3.03 2.24 4.87 5.82 4.9 9.57v.51c0 10.6-3.39 18.78-6.8 22.23-1.2 1.22-2.43 1.86-3.56 1.86-1.58 0-6.38-1.23-12.07-2.88 2.06.75 3.9 1.63 5.34 2.64 7.89 5.52 14.05 18.51 10.04 35.08a6.012 6.012 0 0 1-3.2 3.98c-.85.41-1.76.62-2.68.62-.85 0-1.7-.18-2.5-.54-4.8-2.15-13.52-5.91-18.05-6.92-1.48-.33-2.93-.59-4.33-.84-5.35-.96-9.98-1.79-12.67-5.82-3.38-5.07-3.39-25.92.99-29.42 2.97-2.38 13.38-2.3 22.2-.21-10.25-3.08-21.23-6.7-21.42-6.76-2.46-.82-3.75-2.25-4.45-4.04-.11-.28-.18-.58-.26-.87v.87l-.09 54.49v.41c.08-.14.16-.28.26-.41 1.68-2.3 5.24-3.73 10.75-4.34l.07-.01.08.01c.08 0 .18.01.3.01.07 0 .16.01.24.01.06 0 .11 0 .17.01.09 0 .2.01.31.01.07 0 .14.01.22.01.12.01.25.01.38.02.07 0 .14.01.22.01l.47.03c.07 0 .14.01.22.01l.57.03c.05 0 .1.01.16.01 6.76.43 21.43 1.85 27.47 6.15.24-.17.55-.25.85-.18 2.61.56 5.27.97 7.82 1.78v-.01c.01-.52.03-1.03.04-1.53 0-.09 0-.18.01-.27.01-.48.03-.95.04-1.4 0-.1.01-.19.01-.29.02-.45.03-.89.05-1.32 0-.08.01-.15.01-.23l.06-1.25c0-.04 0-.08.01-.13.02-.39.04-.77.06-1.12 0-.04 0-.07.01-.11.02-.36.04-.69.07-1.01 0-.05.01-.1.01-.15.02-.3.05-.58.07-.84 0-.05.01-.09.01-.14.02-.25.05-.49.08-.69 0-.03.01-.05.01-.08.03-.21.06-.4.09-.55.94-4.69 3.19-15.58 3.48-16.95-.07-.05-.14-.11-.2-.17-2.31-2.31-2.74-9.9 1.78-21.1 1.7-4.21 5.62-9.97 7.29-12.33-1.53-.69-2.63-1.64-3.25-2.87-1.99-3.98 3.45-23.1 4.98-28.26-2.16-2.1-4.02-4.76-5.46-7.14-.28-.45-.52-.92-.73-1.4.18 4.72-.28 9.8-1.58 15.19zm.71-22.36c.18-1.07.51-2.11.99-3.12 1.36-2.88 3.74-5.07 6.62-6.19-9.36-4.4-23.55-15.37-25.56-16.94-2.85-.38-5.64-.82-8.32-1.31-.64-.12-1.27-.24-1.89-.37 5.75 1.22 11.13 3.1 14.66 5.57 6.13 4.29 11.44 12.11 13.5 22.36z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M769.48 522.47c1.82.32 3.7.66 5.64 1.09 5.71 1.27 15.99 5.61 23.61 9.03 1.51.68 3.23.65 4.71-.08a5.36 5.36 0 0 0 2.89-3.59c4.9-20.21-2.49-35.97-11.98-42.61-6.5-4.55-19.48-6.83-28.79-6.83-4.76 0-8.57.6-10.05 1.79-4.23 3.38-4.81 28.68-.8 34.7 2.92 4.37 8.15 5.31 14.77 6.5zm-17.23 28.42c.14 4.92.38 7.55 3.95 8.74 7.25 2.41 34.04 10.96 37.72 10.96.57 0 1.34-.46 2.14-1.26 3.07-3.11 6.33-11.1 6.22-21.32-.02-1.56-.4-3.09-1.11-4.46a10.08 10.08 0 0 0-2.98-3.52c-5.26-3.89-13.62-9.04-23.53-11.52-7.3-1.83-12.17-2.37-15.36-2.37-4.53 0-5.69 1.09-5.71 1.1-.78 1.11-2.69 11.41-1.72 18.18.27 1.93.33 3.81.38 5.47zm3.78 19.16c-3.25 2.6-3.67 22.1-.57 26.75 2.22 3.32 6.26 4.05 11.37 4.96 1.41.26 2.88.52 4.4.86 4.47.99 12.49 4.38 18.44 7.05 1.11.5 2.39.48 3.48-.06 1.08-.53 1.86-1.5 2.14-2.65.83-3.43 1.21-6.7 1.21-9.77 0-10.89-4.74-19.2-10.46-23.2-5.05-3.54-15.12-5.31-22.31-5.31-3.65 0-6.56.46-7.7 1.37zm117.69-98.72c-.07.32-.15.65-.24.98 0 .01 0 .02-.01.02-.09.32-.18.65-.29.98 0 .01-.01.02-.01.03-.11.33-.22.65-.34.98 0 .01-.01.02-.01.04-.12.33-.25.65-.39.98-.01.01-.01.03-.02.04-.14.33-.28.66-.43.98-.01.02-.01.03-.02.05-.15.33-.31.65-.47.98l-.03.06c-.16.32-.33.65-.5.97l-.03.06c-.17.32-.35.64-.54.97-.01.02-.03.04-.04.07-.18.32-.37.64-.56.95-.01.02-.03.05-.04.07-.19.32-.39.63-.59.94-.02.02-.03.05-.05.07-.2.31-.4.62-.61.93l-.06.09c-.2.3-.41.61-.62.91a.55.55 0 0 1-.07.09c-.21.3-.42.59-.63.89l-.07.1c-.21.29-.43.58-.64.86l-.08.11c-.21.28-.43.56-.65.84l-.09.12c-.21.27-.43.54-.64.81l-.11.14c-.21.26-.42.51-.63.77-.04.05-.08.1-.12.14-.21.25-.42.49-.63.73-.04.05-.09.1-.13.15-.2.24-.41.47-.61.7-.05.06-.1.11-.15.17-.2.22-.39.44-.59.65-.06.06-.11.12-.17.19-.19.2-.37.4-.56.6-.07.07-.13.14-.2.21-.18.19-.35.37-.53.55l-.21.21c-.17.17-.34.34-.5.51-.07.07-.14.14-.22.21-.16.16-.32.31-.47.47-.08.08-.17.16-.25.24-.14.13-.28.27-.42.4-.09.09-.18.17-.27.25-.13.12-.25.24-.38.35-.09.09-.18.17-.28.25-.11.1-.23.21-.34.3-.1.09-.19.17-.29.25-.1.08-.2.17-.29.25-.11.09-.21.17-.31.26-.08.06-.16.13-.24.19-.12.1-.23.18-.34.27-.06.04-.11.09-.17.13-.16.12-.32.24-.47.35-4.12 2.94-10.14 3.82-16.22 3.82-5.51 0-11.07-.72-15.27-1.27l-1.77-.23c-.64-.08-1.37-.27-2.16-.53h-.01l-.1.02c-3.44.5-6.27 2.61-7.77 5.78-1.49 3.16-1.31 6.83.49 9.81 2.57 4.25 6.53 9.43 10.8 9.96 6.63.83 19.13 1.31 28.35-4.84 7.87-5.25 14.21-18.43 16.92-24.07.3-.63.56-1.16.76-1.57.69-1.37 1.67-3.51 2.67-5.72.85-2.05 1.97-4.79 3.08-7.55.06-.13.11-.24.15-.35.58-1.42 1.15-2.83 1.68-4.15-.78-2.05-1.73-4.02-2.78-5.94-.05.32-.11.65-.18.97.02-.01.01-.01.01 0zm-41.34 111.18c-8.91 4.11-17.1 6.03-22.22 6.03-1.1 0-2.05-.09-2.85-.27-.49 2.37-2.52 12.17-3.39 16.55-.96 4.79-.89 36.66-.32 43.99 1.34-1.32 3.68-3.77 6.12-6.33 7.62-8 19.13-20.08 25.68-24.66 9.58-6.71 12.56-18.18 14.61-28.41 1.2-5.99 2.43-14.62 3.2-20.45.07-.81.14-1.6.22-2.34.07-.68.23-1.58.41-2.56.11-.88.16-1.39.16-1.42l.09-.01c.36-1.98.71-4.1.71-5.65 0-1.83-.07-3.39-.18-4.71-.03-.45-.05-.9-.06-1.35-.13.33-.27.67-.42 1.04-3.49 8.78-9.99 25.12-21.76 30.55z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M837.25 552.53c-6.05 1.72-11.38 2.58-15.66 2.58-2.01 0-3.79-.19-5.3-.57-1.34 1.88-5.7 8.13-7.42 12.42-4.2 10.4-3.83 17.33-2.23 18.94 1.29 1.28 11.31 1.06 24.91-5.21 11.03-5.09 17.34-20.95 20.74-29.47.49-1.23.92-2.31 1.29-3.19.37-.86.75-1.67 1.14-2.45.02-.21.03-.43.05-.64v-.01c.32-2.7.93-5.37 1.8-7.96.26-.77.53-1.6.83-2.48.77-2.32 1.27-4.49 1.59-6.45-5.6 13.57-13.06 22-21.74 24.49z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M852.54 521.36c-6.75 4.51-15.08 5.66-21.86 5.66-3.01 0-5.72-.23-7.85-.49-1.81-.23-3.54-1.1-5.14-2.33-2.7 9.27-6.11 23.4-4.85 25.92 1.59 3.18 9.58 4.56 23.86.48 8.77-2.5 17.19-11.76 22.8-26.79.04-.7.12-1.4.24-2.09.39-2.6 1.22-5.12 2.47-7.45 1.74-3.24 3.25-7.2 4.49-10.91-3.39 6.32-8.32 14.12-14.16 18zm-101.68 36.12v-.87c-.44-1.59-.54-3.37-.59-5.23-.05 1.6-.12 3.16-.42 4.57-.07.34-.16.67-.26 1l-.07 55.08c.08.12.19.23.26.35.2.32.36.65.49 1 .13-.35.3-.68.5-1v-.41l.09-54.49zm-.98-27v.02c.13.71.26 1.47.38 2.27.19-1.29.41-2.48.65-3.5v-1.07l.03-16.11v-1.31c-.29-1.48-.52-3.11-.68-4.81-.1 1.05-.22 2.07-.36 3.04-.08.54-.17 1.06-.26 1.57l-.02 18.69c.09.39.18.78.26 1.21z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M691.54 507.06c.43 2.4.14 4.87-.85 7.11.01.01 0 .01 0 .02-.03.71-.05 1.43-.05 2.15 0 4.1.5 8.47 1.61 13.05a7.415 7.415 0 0 0 3.95 4.92c1.05.51 2.19.77 3.32.77 1.06 0 2.11-.22 3.1-.66 6.16-2.77 17.38-7.61 23.22-8.91 1.9-.42 3.76-.75 5.56-1.08 6.81-1.22 12.69-2.27 16.08-7.35.92-1.38 1.64-3.69 2.16-6.5v-1.57l.02-19.57v-1.6c-.7-3.84-1.81-6.87-3.39-8.13-3.58-2.87-15.72-2.91-26.55-.62-.01 0-.02.01-.03.01-5.75 1.22-11.13 3.1-14.66 5.57-6.13 4.29-11.44 12.13-13.49 22.39zm53.48-25.79c4.23 3.38 4.81 28.68.79 34.7-2.91 4.37-8.14 5.31-14.76 6.5-1.82.32-3.7.66-5.65 1.09-5.71 1.27-15.99 5.61-23.6 9.03-1.51.68-3.23.65-4.72-.08a5.387 5.387 0 0 1-2.89-3.59c-4.89-20.21 2.49-35.96 11.98-42.61 9.83-6.88 34.45-8.56 38.85-5.04z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M749.64 509.01v1.57c.09-.51.18-1.03.26-1.57.14-.97.26-1.99.36-3.04-.41-4.37-.42-9.29 0-13.71-.09-.97-.2-1.91-.34-2.82-.08-.55-.17-1.08-.26-1.6v1.6l-.02 19.57zM718.7 569.7c-2.07.75-3.91 1.64-5.36 2.65-7.89 5.52-14.06 18.51-10.05 35.08a6.04 6.04 0 0 0 3.2 3.98c.85.41 1.77.62 2.69.62.85 0 1.7-.18 2.5-.54 4.79-2.15 13.52-5.91 18.05-6.92 1.48-.33 2.92-.59 4.32-.84 5.36-.96 9.99-1.79 12.68-5.82 3.38-5.07 3.38-25.92-.99-29.42-2.97-2.38-13.39-2.3-22.2-.21-1.63.49-3.23.96-4.77 1.4-.03.01-.05.02-.07.02zm18.1-1.02c3.64 0 6.55.46 7.69 1.37 3.25 2.6 3.67 22.1.57 26.75-2.22 3.32-6.25 4.05-11.36 4.96-1.42.26-2.89.52-4.4.86-4.47.99-12.5 4.38-18.44 7.05a4.1 4.1 0 0 1-3.49-.06 3.997 3.997 0 0 1-2.13-2.65c-3.79-15.65 1.91-27.84 9.24-32.97 5.05-3.54 15.12-5.31 22.32-5.31z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm749.6 545.44.01-9.29.01-5.65v-1.22c-.41-1.75-.85-3.03-1.27-3.45-.94-.94-5.37-3.66-22.97.74-10.23 2.56-18.83 7.85-24.23 11.85a12.112 12.112 0 0 0-4.91 9.57c-.11 10.85 3.34 19.24 6.81 22.74 1.2 1.22 2.43 1.86 3.55 1.86 1.59 0 6.39-1.24 12.1-2.89.02 0 .04-.01.07-.02 1.49-.54 3.1-1.01 4.77-1.4 10.25-3.08 21.23-6.7 21.42-6.76 2.69-.9 3.99-2.54 4.63-4.57v-1l.01-10.51zm-.94-.02c-.28 1.93-.33 3.81-.38 5.47-.15 4.92-.39 7.55-3.95 8.74-7.25 2.41-34.04 10.96-37.73 10.96-.56 0-1.34-.46-2.13-1.26-3.02-3.06-6.23-10.86-6.23-20.86v-.46c.03-3.13 1.56-6.11 4.09-7.98 5.27-3.89 13.62-9.04 23.53-11.52 7.33-1.83 12.2-2.37 15.39-2.37 2.25 0 3.66.27 4.51.53.85.27 1.14.54 1.14.54.82 1.14 2.72 11.44 1.76 18.21z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm749.89 545.7-.03-.26c-.36-2.68-.29-6.08.01-9.29.1-1.17.24-2.31.39-3.38-.12-.8-.25-1.56-.38-2.27v-.02c-.08-.42-.17-.82-.26-1.2v1.22l-.01 5.65-.01 9.29-.01 10.51v1c.1-.32.19-.66.26-1 .3-1.41.37-2.97.42-4.57-.01-.14-.02-.29-.02-.43-.05-1.69-.1-3.43-.36-5.25zm-26.35 22.58c-1.67.39-3.28.86-4.77 1.4 1.54-.44 3.14-.91 4.77-1.4zm-.44 40.84c-.34.05-.67.11-1.01.17.34-.06.68-.12 1.01-.17zm6.47-.84c-.29.03-.59.06-.89.1.3-.04.6-.07.89-.1zm6.23-.51c-.18.01-.37.02-.57.04.2-.02.39-.03.57-.04zm.78-.05-.48.03.48-.03zm-14.82 1.62-1.01.18c.33-.06.67-.12 1.01-.18zm15.48-1.65c-.13.01-.27.01-.41.02.15-.01.29-.02.41-.02zm-12.8 1.22zm7.48-.86c-.27.02-.54.05-.81.07.27-.02.54-.04.81-.07zm-1.15.11c-.28.03-.56.05-.84.08.28-.03.56-.06.84-.08zm-2.43.25c-.31.03-.61.07-.93.11.31-.04.62-.08.93-.11zm9.47-.75c-.08 0-.18.01-.27.01.09 0 .19-.01.27-.01zm-2.86.16c-.21.01-.43.03-.65.04.23-.01.45-.03.65-.04zm-9.18.91zm1.29-.17-.96.12c.32-.04.65-.08.96-.12zm6.95-.67c-.23.02-.47.04-.71.05.24-.02.48-.04.71-.05zm-1.01.07-.78.06c.26-.01.52-.04.78-.06zm-12.59 1.63c-.34.06-.67.13-1 .2.34-.07.67-.14 1-.2zm-10.73 3.26c-.25.13-.5.26-.74.4.24-.14.49-.27.74-.4zm.98-.46c-.27.12-.54.24-.79.37.26-.13.52-.25.79-.37zm-1.88.96c-.24.14-.47.28-.69.43.22-.15.46-.29.69-.43zm-2.64 2.19zm12.94-5.69-.99.21.99-.21zm-11.11 4.01c-.22.15-.43.31-.63.47.2-.16.41-.31.63-.47zm3.74-1.91zm26.56-4.31c-.06 0-.15.01-.22.01.07 0 .16-.01.22-.01zm-21.8 2.81c-.32.08-.65.17-.96.25.32-.08.64-.16.96-.25zm-1.25.34zm2.54-.65c-.33.08-.66.15-.98.23.33-.07.65-.15.98-.23zm-4.93 1.4zm-6.14 3.38c.17-.17.37-.34.57-.51-.21.17-.4.34-.57.51zm7.3-3.77c-.31.1-.61.19-.91.29.31-.1.61-.19.91-.29zm-75.15-120.11c.02.02.04.05.07.07.41.44.81.87 1.21 1.27l.1.1c.4.41.79.8 1.17 1.17 0 0 .01 0 .01.01.38.37.75.71 1.1 1.04.03.03.06.05.08.08.33.31.66.59.96.86.05.05.11.09.16.14.3.25.58.49.85.71.04.03.08.07.13.1.27.22.53.42.77.58 4.12 2.94 10.14 3.82 16.22 3.82 5.51 0 11.07-.72 15.27-1.27l1.77-.23c.64-.08 1.37-.27 2.17-.53l-.21-.03.25-1.98.35.05c.93.14 1.83.38 2.67.71 9.36-4.4 23.54-15.37 25.55-16.94-1.3.18-2.61.34-3.94.5h-.01c-6.32 4.76-21.12 15.49-27.08 16.23l-1.78.23c-7.98 1.04-22.85 2.96-30.07-2.2-4.98-3.56-17.15-16.76-18.09-26.17-.74-7.36 1.91-24.68 3.36-33.09-.43-1.72-.81-3.35-1.15-4.84v-.01c-.48 2.54-5.2 28.16-4.2 38.14.14 1.44.52 2.93 1.06 4.45 2.12 6 6.93 12.37 11.25 17.03zm4.7 4.61c-.31-.27-.63-.55-.96-.86.33.3.65.59.96.86zm-2.16-1.99c-.38-.37-.77-.76-1.17-1.17.4.4.79.8 1.17 1.17zm-1.27-1.27c-.4-.41-.8-.83-1.21-1.27l1.21 1.27zm2.38 2.32c-.36-.33-.72-.67-1.1-1.04l1.1 1.04zm2.06 1.78zm.89.68z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M627.58 474.02c2.13 5.98 6.93 12.35 11.26 17.02-4.32-4.66-9.13-11.03-11.26-17.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M647.98 521.36c6.76 4.51 15.08 5.66 21.86 5.66 3.02 0 5.73-.23 7.85-.49 1.81-.23 3.54-1.1 5.14-2.33-.14-.5-.29-.99-.43-1.46l1.92-.57c.05.17.11.36.17.58 2.16-2.1 4.02-4.76 5.46-7.14.28-.46.53-.94.74-1.42 0-.01.01-.01 0-.02.11-2.48.4-4.84.85-7.1v-.01c-.19-1.08-.52-2.13-1-3.15a12.2 12.2 0 0 0-6.61-6.19h-.01c-1.1.52-2.13.94-3.06 1.25h.01l.09.01c3.44.51 6.28 2.62 7.77 5.79a10.35 10.35 0 0 1-.49 9.81c-2.57 4.25-6.52 9.43-10.8 9.96-6.63.83-19.13 1.31-28.35-4.84-7.87-5.25-14.21-18.44-16.91-24.07-.31-.63-.56-1.17-.77-1.57-.78-1.58-2.21-4.17-3.6-6.72.88 2.12 1.55 3.72 1.8 4.21.47.94 1.59 5.36 3.27 10.52v.01h.26c3.4 6.5 8.61 15.13 14.84 19.28z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M691.54 507.07a46.91 46.91 0 0 0-.85 7.1c.99-2.24 1.28-4.71.85-7.1zm-51.31 14.45-.05-.03c.03.09.06.17.09.26 0-.01 0-.03-.01-.04 0-.06-.02-.13-.03-.19z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm640.53 521.71-.3-.19c.01.06.03.12.04.19 0 .01 0 .03.01.04.06.17.12.33.18.49.06-.18.1-.35.07-.53zm22.75 30.82c6.05 1.72 11.38 2.58 15.66 2.58 2.01 0 3.79-.19 5.3-.57-.25-.34-.39-.54-.4-.55l1.61-1.19c.05.07.33.46.77 1.08 1.53-.68 2.64-1.64 3.26-2.87 1.99-3.98-3.46-23.1-4.99-28.26-.53.52-1.09 1.01-1.66 1.45 2.7 9.27 6.12 23.4 4.86 25.92-1.59 3.18-9.59 4.56-23.86.48-9.09-2.59-17.78-12.4-23.38-28.36-.02.06-.05.12-.08.18.06.47.11.94.14 1.42.06.96.16 2.03.33 3.18v.01c.13.93.31 1.93.53 2.97 5.64 12.42 13.64 20.16 21.91 22.53z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M682.4 522.74c.14.47.29.96.43 1.46.57-.44 1.13-.93 1.66-1.45-.06-.22-.12-.41-.17-.58l-1.92.57zm-36.02 29.22c3.49 8.78 10 25.12 21.76 30.55 8.91 4.11 17.1 6.03 22.22 6.03 1.11 0 2.07-.09 2.86-.27l-.11-.53 1.96-.41.03.15c.07-.06.13-.11.19-.17 2.31-2.31 2.74-9.9-1.78-21.1-1.7-4.21-5.62-9.97-7.29-12.33-.6.27-1.26.49-1.98.66 1.34 1.88 5.69 8.13 7.42 12.42 4.19 10.4 3.82 17.33 2.22 18.94-1.29 1.28-11.31 1.06-24.9-5.21-11.04-5.09-17.35-20.95-20.74-29.47-.49-1.23-.92-2.31-1.3-3.19-.3-.7-1.01-1.37-1.62-2.01.14 1.45.21 2.9.17 4.36-.01.23-.03.46-.04.68.39.29.81.59.93.9z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M683.84 553.99c.01.01.15.21.4.55.72-.17 1.38-.39 1.98-.66-.44-.62-.72-1.01-.77-1.08l-1.61 1.19zm-32.53 46.82c.02-.11.03-.19.04-.24l1.97.34c-.01.07-.25 1.47-.6 3.75 2.33 5.69 5.76 10.94 11.27 14.79 6.39 4.47 17.82 16.47 25.38 24.41 4.6 4.83 6.39 6.67 7.25 7.37-.01-.32-.02-.51-.02-.54l2-.05c0 .05 0 .13.01.24.31-1.02.75-4.86.74-21.85 0-2.55-.02-5.17-.05-7.72l-.03-2.37c-.01-.75-.03-1.49-.04-2.21 0-.2-.01-.39-.01-.58-.01-.3-.01-.6-.02-.9l-.03-1.2c-.01-.25-.01-.49-.02-.74s-.01-.49-.02-.73c-.01-.22-.01-.45-.02-.67-.01-.4-.03-.8-.04-1.18-.01-.15-.01-.3-.02-.45-.01-.29-.02-.57-.04-.84-.01-.14-.01-.29-.02-.43l-.06-1.07c0-.07-.01-.14-.01-.21-.02-.29-.04-.56-.05-.81-.01-.09-.01-.19-.02-.28-.02-.3-.05-.59-.07-.84 0-.02 0-.04-.01-.06-.02-.24-.05-.45-.07-.64-.01-.06-.01-.11-.02-.16-.03-.2-.06-.38-.08-.53-.94-4.69-3.19-15.57-3.48-16.94-.44.35-1.07.62-1.88.79.49 2.38 2.52 12.17 3.39 16.55.96 4.79.89 36.66.32 43.99-1.34-1.32-3.68-3.77-6.11-6.32-7.62-8-19.14-20.08-25.69-24.66-9.58-6.71-12.56-18.18-14.61-28.41-1.11-5.56-2.58-13.41-3.63-19.18.05.68.09 1.38.13 2.09v.05c.2 3.59.31 7.56.46 11.45v.03c.01.18.01.37.02.55.37 1.91.73 3.74 1.06 5.39.7 3.61 1.54 7.36 2.73 11.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M698.68 605.12c-.01-.06-.01-.11-.02-.16 0 .05.01.1.02.16zm.53 11.05c-.01-.3-.01-.6-.02-.9.01.29.01.59.02.9zm.05 2.79c-.01-.75-.03-1.49-.04-2.21.02.72.03 1.46.04 2.21zm-.34-10.99c0-.07-.01-.14-.01-.21 0 .07 0 .14.01.21zm.24 6.1c-.01-.25-.01-.49-.02-.74 0 .24.01.49.02.74zm-.11-3.31c-.01-.15-.01-.3-.02-.45.01.15.01.3.02.45zm-.06-1.29c-.01-.14-.01-.29-.02-.43.01.14.02.28.02.43zm.12 3.13c-.01-.22-.01-.45-.02-.67.01.22.02.45.02.67zm-.35-6.78c0-.02 0-.04-.01-.06 0 .02 0 .04.01.06zm.09 1.13c-.01-.09-.01-.19-.02-.28 0 .09.01.18.02.28zm.44 14.38c.03 2.55.05 5.17.05 7.72 0-2.55-.01-5.18-.05-7.72zm-6.18-33.59.11.53c.81-.17 1.44-.44 1.88-.79-.02-.09-.03-.15-.03-.15l-1.96.41zm-41.76 12.83c-.01.05-.02.13-.04.24.42 1.3.89 2.59 1.41 3.85.35-2.28.59-3.68.6-3.75l-1.97-.34zm99.85-88.56v.08c.48 2.13 1.1 3.86 1.85 4.99 3.39 5.08 9.27 6.13 16.08 7.35 1.8.33 3.66.66 5.56 1.08 5.83 1.3 17.05 6.14 23.22 8.91.99.44 2.04.66 3.09.66 1.14 0 2.27-.26 3.32-.77 1-.49 1.86-1.18 2.54-2.02.67-.84 1.16-1.82 1.42-2.9 1.3-5.39 1.76-10.47 1.56-15.18v-.01c-1-2.26-1.29-4.75-.85-7.16v-.01c-2.06-10.25-7.37-18.07-13.49-22.36-3.53-2.47-8.91-4.35-14.66-5.57-10.84-2.3-23-2.26-26.58.61-1.32 1.05-2.32 3.35-3.02 6.33v.04c-.09.39-.18.8-.26 1.22l-.04 23.49c.08.41.17.82.26 1.22zm4.31-30.74c1.48-1.19 5.29-1.79 10.05-1.79 9.31 0 22.29 2.28 28.79 6.83 9.49 6.64 16.88 22.4 11.98 42.61a5.36 5.36 0 0 1-2.89 3.59c-1.48.73-3.2.76-4.71.08-7.62-3.42-17.9-7.76-23.61-9.03-1.94-.43-3.82-.77-5.64-1.09-6.62-1.19-11.85-2.13-14.77-6.5-4.01-6.02-3.43-31.32.8-34.7zm-5.25 24.7c.16 1.71.39 3.33.68 4.81l.04-23.49c-.31 1.53-.55 3.19-.72 4.96.42 4.43.41 9.35 0 13.72z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M750.26 505.97c.41-4.37.42-9.29 0-13.71-.42 4.42-.41 9.34 0 13.71zm26.73 62.31c-8.82-2.09-19.23-2.17-22.2.21-4.38 3.5-4.37 24.35-.99 29.42 2.69 4.03 7.32 4.86 12.67 5.82 1.4.25 2.85.51 4.33.84 4.53 1.01 13.25 4.77 18.05 6.92.8.36 1.65.54 2.5.54.92 0 1.83-.21 2.68-.62 1.62-.8 2.78-2.25 3.2-3.98 4.01-16.57-2.15-29.56-10.04-35.08-1.44-1.01-3.28-1.89-5.34-2.64-.03 0-.06-.01-.09-.03-1.54-.44-3.15-.91-4.77-1.4zm9.05 5.71c5.72 4 10.46 12.31 10.46 23.2 0 3.07-.38 6.34-1.21 9.77a4.011 4.011 0 0 1-2.14 2.65c-1.09.54-2.37.56-3.48.06-5.95-2.67-13.97-6.06-18.44-7.05-1.52-.34-2.99-.6-4.4-.86-5.11-.91-9.15-1.64-11.37-4.96-3.1-4.65-2.68-24.15.57-26.75 1.14-.91 4.05-1.37 7.7-1.37 7.19 0 17.26 1.77 22.31 5.31z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm750.89 542.75-.02 13.86c.08.29.15.59.26.87.7 1.79 1.99 3.22 4.45 4.04.19.06 11.17 3.68 21.42 6.76 1.67.39 3.28.86 4.77 1.4.03.02.06.03.09.03 5.69 1.65 10.49 2.88 12.07 2.88 1.13 0 2.36-.64 3.56-1.86 3.41-3.45 6.8-11.63 6.8-22.23v-.51c-.03-3.75-1.87-7.33-4.9-9.57-5.41-4-14-9.29-24.23-11.85-17.61-4.4-22.04-1.68-22.98-.74-.33.33-.67 1.17-1 2.37-.09.33-.18.69-.26 1.07l-.02 10.82c.01.9.02 1.8-.01 2.66zm2.7-15.51c.02-.01 1.18-1.1 5.71-1.1 3.19 0 8.06.54 15.36 2.37 9.91 2.48 18.27 7.63 23.53 11.52 1.27.94 2.28 2.15 2.98 3.52.71 1.37 1.09 2.9 1.11 4.46.11 10.22-3.15 18.21-6.22 21.32-.8.8-1.57 1.26-2.14 1.26-3.68 0-30.47-8.55-37.72-10.96-3.57-1.19-3.81-3.82-3.95-8.74-.05-1.66-.11-3.54-.38-5.47-.97-6.77.94-17.07 1.72-18.18zm-2.7 12.85.02-10.82a49.6 49.6 0 0 0-.65 3.5c.34 2.28.57 4.85.63 7.32zm-.25 5.61c-.26 1.82-.31 3.56-.36 5.25 0 .14-.01.29-.01.43.05 1.86.15 3.64.59 5.23l.02-13.86a26.49 26.49 0 0 1-.24 2.95z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M750.64 545.7c.13-.91.21-1.9.24-2.95.03-.86.03-1.75 0-2.66-.06-2.47-.29-5.04-.63-7.32-.15 1.07-.29 2.21-.39 3.38-.3 3.21-.37 6.61-.01 9.29l.03.26c.26 1.82.31 3.56.36 5.25 0 .14.01.29.02.43 0-.14.01-.29.01-.43.06-1.69.11-3.43.37-5.25zm26.35 22.58c1.62.49 3.23.96 4.77 1.4-1.49-.54-3.1-1.01-4.77-1.4zm17.8 47.86c-.02-.03-.05-.06-.07-.1.03.04.05.07.07.1zm-31.23-8.44c-.13-.01-.26-.01-.38-.02.12.01.25.01.38.02zm29.1 6.24c-6.05-4.3-20.71-5.72-27.47-6.15 6.76.44 21.43 1.85 27.47 6.15zm-28.41-6.2-.47-.03.47.03zm.79.05-.57-.03c.18 0 .37.01.57.03zm-2.08-.12c-.11 0-.21-.01-.31-.01.1 0 .2.01.31.01zm-.48-.02c-.09 0-.17-.01-.24-.01.07 0 .15.01.24.01zm56.79-110.64.36-.05.25 1.98-.21.03c.79.26 1.52.45 2.16.53l1.77.23c4.21.55 9.76 1.27 15.27 1.27 6.07 0 12.1-.87 16.22-3.82.15-.11.3-.22.47-.35.05-.04.11-.09.17-.13.11-.09.22-.17.34-.27.08-.06.16-.13.24-.19.1-.09.21-.17.31-.26.1-.08.2-.17.29-.25.1-.08.19-.16.29-.25.11-.1.23-.2.34-.3l.28-.25.38-.35c.09-.08.18-.17.27-.25.14-.13.28-.27.42-.4.08-.08.16-.16.25-.24.16-.15.31-.31.47-.47.07-.07.14-.14.22-.21.17-.17.33-.34.5-.51l.21-.21c.17-.18.35-.36.53-.55.07-.07.13-.14.2-.21.19-.2.37-.4.56-.6.06-.06.11-.12.17-.19.2-.21.39-.43.59-.65.05-.06.1-.11.15-.17.2-.23.41-.46.61-.7.04-.05.09-.1.13-.15.21-.24.42-.49.63-.73.04-.05.08-.1.12-.14.21-.25.42-.51.63-.77l.11-.14c.22-.27.43-.53.64-.81l.09-.12c.22-.28.43-.56.65-.84l.08-.11c.22-.29.43-.57.64-.86l.07-.1c.21-.29.43-.59.63-.89a.55.55 0 0 1 .07-.09c.21-.3.42-.6.62-.91l.06-.09c.21-.31.41-.62.61-.93.02-.02.03-.05.05-.07.2-.31.4-.63.59-.94.01-.02.03-.05.04-.07.19-.32.38-.64.56-.95.01-.02.03-.04.04-.07.18-.32.36-.64.54-.97l.03-.06c.17-.32.34-.65.5-.97l.03-.06c.16-.33.32-.65.47-.98.01-.02.01-.03.02-.05.15-.33.29-.66.43-.98.01-.01.01-.03.02-.04.14-.33.27-.66.39-.98 0-.01.01-.02.01-.04.12-.33.24-.66.34-.98 0-.01.01-.02.01-.03.11-.33.2-.65.29-.98 0-.01 0-.02.01-.02.09-.33.17-.65.24-.98v-.01c.07-.33.13-.65.18-.97.04-.26.08-.51.1-.77 1-9.97-3.69-35.42-4.2-38.11v.01c-.35 1.49-.73 3.09-1.15 4.81v.01c1.45 8.41 4.1 25.7 3.36 33.08-.94 9.41-13.11 22.61-18.09 26.17-7.22 5.16-22.08 3.23-30.07 2.2l-1.78-.23c-5.96-.75-20.76-11.47-27.08-16.23H795c-1.32-.16-2.64-.32-3.94-.5 2.01 1.57 16.2 12.54 25.56 16.94.83-.33 1.72-.57 2.65-.71z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M861.98 490.73c.2-.21.39-.43.59-.65-.2.22-.39.44-.59.65zm5.86-7.26c.21-.3.42-.6.62-.91-.21.31-.41.61-.62.91zm-5.12 6.44c.2-.23.41-.46.61-.7-.2.24-.41.47-.61.7zm5.8-7.43c.21-.31.41-.62.61-.93-.21.31-.41.62-.61.93zm1.28-2.02c.19-.32.38-.64.56-.95-.18.32-.36.63-.56.95zm-10.67 13.21c.16-.15.31-.31.47-.47-.16.17-.32.32-.47.47zm10.04-12.19c.2-.31.4-.63.59-.94-.19.31-.39.62-.59.94zm-2.75 3.93c.22-.29.43-.57.64-.86-.21.29-.43.58-.64.86zm-5.17 6.11c.19-.2.37-.4.56-.6-.19.2-.38.4-.56.6zm2.96-3.34c.21-.25.42-.51.63-.77-.21.26-.42.52-.63.77zm1.48-1.82c.22-.28.43-.56.65-.84-.22.28-.43.56-.65.84zm-2.23 2.7c.21-.24.42-.49.63-.73-.21.25-.42.49-.63.73zm1.49-1.78zm2.18-2.83c.21-.29.43-.59.63-.89-.2.3-.41.6-.63.89zm3.27-5.01c.18-.32.36-.64.54-.97-.17.33-.35.65-.54.97zm-9.87 12.83c.17-.18.35-.36.53-.55-.18.19-.36.37-.53.55zm12.96-19.97zm-13.17 20.19zm-3.71 3.48c.09-.08.2-.17.29-.25-.09.08-.19.17-.29.25zm16.58-22.66c.11-.33.2-.65.29-.98-.09.32-.18.65-.29.98zm-15.38 21.6.38-.35c-.13.12-.25.24-.38.35zm.65-.6c.14-.13.28-.27.42-.4-.14.14-.28.27-.42.4zm14.38-19.99zm1.06-3.98c-.05.32-.11.65-.18.97.08-.32.14-.65.18-.97zm-16.7 25.13c.11-.1.23-.2.34-.3-.12.09-.23.2-.34.3zm15.24-20.13zm-1.47 3.08c.17-.32.34-.65.5-.97-.16.32-.32.64-.5.97zm-15.42 18.41c.05-.04.11-.09.17-.13-.05.04-.11.09-.17.13zm16.44-20.47c.15-.33.29-.66.43-.98-.13.33-.28.65-.43.98zm-.49 1.03c.16-.33.32-.65.47-.98-.15.32-.3.65-.47.98zm-15.44 19.04c.08-.06.16-.13.24-.19-.08.06-.16.12-.24.19z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M867.14 502.03c1.67-5.14 2.79-9.55 3.26-10.48.2-.41.71-1.59 1.38-3.21-1 2.21-1.98 4.35-2.67 5.72-.2.41-.46.94-.76 1.57-2.71 5.64-9.05 18.82-16.92 24.07-9.22 6.15-21.72 5.67-28.35 4.84-4.27-.53-8.23-5.71-10.8-9.96-1.8-2.98-1.98-6.65-.49-9.81 1.5-3.17 4.33-5.28 7.77-5.78l.1-.02h.01c-.94-.31-1.97-.73-3.06-1.25a12.218 12.218 0 0 0-6.62 6.19c-.48 1.01-.81 2.05-.99 3.12v.01c.45 2.27.75 4.66.85 7.16v.01c.21.48.45.95.73 1.4 1.44 2.38 3.3 5.04 5.46 7.14.07-.22.13-.41.18-.58l1.91.57c-.14.47-.28.96-.43 1.46 1.6 1.23 3.33 2.1 5.14 2.33 2.13.26 4.84.49 7.85.49 6.78 0 15.11-1.15 21.86-5.66 5.84-3.88 10.77-11.68 14.16-18 .15-.44.3-.89.44-1.32-.01 0-.01 0-.01-.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M809.84 514.2c-.1-2.5-.4-4.89-.85-7.16-.44 2.41-.15 4.9.85 7.16zm26.86 36.4c-14.28 4.08-22.27 2.7-23.86-.48-1.26-2.52 2.15-16.65 4.85-25.92-.57-.44-1.12-.93-1.66-1.45-1.53 5.16-6.97 24.28-4.98 28.26.62 1.23 1.72 2.18 3.25 2.87.44-.62.72-1.01.77-1.08l1.61 1.19c-.01.01-.15.21-.39.55 1.51.38 3.29.57 5.3.57 4.28 0 9.61-.86 15.66-2.58 8.68-2.49 16.14-10.92 21.75-24.49.06-.34.12-.69.17-1.02V527c.16-1.14.27-2.21.33-3.16v-.03c-5.61 15.03-14.02 24.29-22.8 26.79z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm818.12 522.74-1.91-.57c-.05.17-.11.36-.18.58.54.52 1.09 1.01 1.66 1.45.15-.5.29-.99.43-1.46zm34.17 28.48c-3.4 8.52-9.71 24.38-20.74 29.47-13.6 6.27-23.62 6.49-24.91 5.21-1.6-1.61-1.97-8.54 2.23-18.94 1.72-4.29 6.08-10.54 7.42-12.42-.73-.17-1.39-.4-1.99-.66-1.67 2.36-5.59 8.12-7.29 12.33-4.52 11.2-4.09 18.79-1.78 21.1.06.06.13.12.2.17l.03-.14 1.96.41-.11.53c.8.18 1.75.27 2.85.27 5.12 0 13.31-1.92 22.22-6.03 11.77-5.43 18.27-21.77 21.76-30.55.14-.36.28-.71.42-1.04l-.03-.58v-.01c-.05-1.59.03-3.18.2-4.75-.39.78-.77 1.59-1.14 2.45-.38.87-.81 1.95-1.3 3.18z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm816.68 553.99-1.61-1.19c-.05.07-.33.46-.77 1.08.6.26 1.26.49 1.99.66.24-.34.38-.54.39-.55zm35.85 29.83c.14-3.9.26-7.89.46-11.48v-.21c.06-1.1.13-2.16.21-3.17-.77 5.83-2 14.47-3.2 20.45-2.05 10.23-5.03 21.7-14.61 28.41-6.55 4.58-18.06 16.67-25.68 24.66-2.44 2.56-4.77 5.01-6.12 6.33-.57-7.33-.64-39.19.32-43.99.88-4.38 2.9-14.18 3.39-16.55-.8-.17-1.44-.43-1.88-.78v-.01c-.28 1.36-2.54 12.26-3.48 16.95-.03.15-.06.34-.09.55 0 .03-.01.05-.01.08-.03.21-.05.44-.08.69 0 .04-.01.09-.01.14-.02.26-.05.54-.07.84 0 .05-.01.1-.01.15-.02.32-.05.65-.07 1.01 0 .03 0 .07-.01.11-.02.35-.04.73-.06 1.12 0 .04 0 .08-.01.13l-.06 1.25c0 .08-.01.15-.01.23-.02.42-.03.86-.05 1.32 0 .1-.01.19-.01.29-.01.46-.03.92-.04 1.4 0 .09 0 .18-.01.27-.01.5-.03 1.01-.04 1.53v.01c-.02.69-.03 1.4-.04 2.12-.02.84-.03 1.7-.04 2.56v.36l-.03 2.7v.01c-.01.86-.01 1.72-.02 2.58v.59c0 .87-.01 1.73-.01 2.58-.01 16.93.43 20.8.74 21.83 0-.09.01-.16.01-.21h-.06l.06-.02v.02l2 .03c0 .03-.01.21-.01.53.86-.71 2.65-2.55 7.24-7.37 7.56-7.94 19-19.93 25.38-24.4 5.5-3.85 8.93-9.11 11.27-14.79-.35-2.29-.59-3.69-.6-3.76l1.97-.33c.01.05.02.12.04.23 1.19-3.66 2.03-7.41 2.75-11.01.13-.66.27-1.36.4-2.07.06-1.28.11-2.59.16-3.9.02 0 .02 0 .02-.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M801.21 623.28c-.01.86-.01 1.72-.02 2.58.01-.85.02-1.72.02-2.58zm.03-2.7zm.05-2.92c-.02.84-.03 1.7-.04 2.56.01-.86.02-1.72.04-2.56zm-.1 8.8c0 .87-.01 1.73-.01 2.58.01-.85.01-1.71.01-2.58zm.24-14.42c0 .1-.01.19-.01.29.01-.1.01-.19.01-.29zm.12-2.92c0 .04 0 .08-.01.13.01-.05.01-.09.01-.13zm-.06 1.38c0 .08-.01.15-.01.23 0-.08.01-.16.01-.23zm-.11 3.23c0 .09 0 .18-.01.27 0-.08.01-.18.01-.27zm-.05 1.81zm.29-7.65c0 .03 0 .07-.01.11 0-.04.01-.08.01-.11zm.16-2.15c0 .04-.01.09-.01.14 0-.05.01-.09.01-.14zm.09-.77c0 .03-.01.05-.01.08 0-.03 0-.05.01-.08zm-.17 1.75c0 .05-.01.1-.01.15 0-.04 0-.1.01-.15zm3.73-19.23c.44.35 1.08.61 1.88.78l.11-.53-1.96-.41-.03.14v.02zm43.75 13.09-1.97.33c.01.07.25 1.47.6 3.76.52-1.27.99-2.55 1.41-3.85-.02-.12-.03-.19-.04-.24zM626.75 471.07s-2.13 2.75-1.65 9.62l2.71 6.65s-1.43-7.18-.23-13.31l-.83-2.96z' }),
	          this.props.bodyTitle === 'Upper GI' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '533', width: '165', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M794.206 554.009h300' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1119.99 537.793h5.203v13.957c0 2.215.065 3.651.194 4.307.222 1.055.752 1.901 1.59 2.54.838.639 1.984.958 3.437.958 1.476 0 2.59-.302 3.34-.905.75-.604 1.201-1.345 1.353-2.224.153-.879.229-2.338.229-4.377v-14.256h5.203v13.536c0 3.093-.141 5.279-.422 6.556-.281 1.278-.8 2.356-1.556 3.235-.756.878-1.766 1.579-3.032 2.1-1.266.522-2.918.782-4.957.782-2.461 0-4.327-.284-5.599-.852-1.271-.569-2.276-1.307-3.014-2.215-.739-.908-1.225-1.86-1.459-2.856-.34-1.477-.51-3.657-.51-6.54v-13.746Zm25.86 7.102h4.606v2.742c.598-.937 1.406-1.699 2.426-2.285 1.019-.586 2.15-.879 3.392-.879 2.168 0 4.008.85 5.52 2.549 1.512 1.699 2.267 4.066 2.267 7.101 0 3.118-.761 5.541-2.285 7.269-1.523 1.729-3.369 2.593-5.537 2.593-1.031 0-1.966-.205-2.804-.615-.837-.411-1.719-1.114-2.645-2.11v9.404h-4.94v-25.769Zm4.887 9.018c0 2.097.416 3.647 1.248 4.649.832 1.002 1.846 1.503 3.041 1.503 1.149 0 2.104-.46 2.865-1.38.762-.92 1.143-2.429 1.143-4.526 0-1.957-.393-3.411-1.178-4.36-.785-.949-1.758-1.424-2.918-1.424-1.207 0-2.209.466-3.006 1.398-.796.932-1.195 2.311-1.195 4.14Zm17.103-9.018h4.605v2.742c.598-.937 1.406-1.699 2.426-2.285 1.019-.586 2.15-.879 3.393-.879 2.167 0 4.007.85 5.519 2.549 1.512 1.699 2.268 4.066 2.268 7.101 0 3.118-.762 5.541-2.286 7.269-1.523 1.729-3.369 2.593-5.537 2.593-1.031 0-1.965-.205-2.803-.615-.838-.411-1.72-1.114-2.646-2.11v9.404h-4.939v-25.769Zm4.886 9.018c0 2.097.416 3.647 1.248 4.649.832 1.002 1.846 1.503 3.041 1.503 1.149 0 2.104-.46 2.866-1.38.761-.92 1.142-2.429 1.142-4.526 0-1.957-.392-3.411-1.177-4.36-.786-.949-1.758-1.424-2.918-1.424-1.207 0-2.209.466-3.006 1.398-.797.932-1.196 2.311-1.196 4.14Zm28.054 3.709 4.922.826c-.633 1.804-1.632 3.178-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.433 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.433 2.604 1.195 3.419.762.814 1.711 1.221 2.848 1.221.773 0 1.423-.211 1.951-.632.527-.422.926-1.102 1.195-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.566-1.117-1.079 0-1.969.393-2.672 1.178-.703.785-1.049 1.852-1.037 3.199h7.382Zm13.659 10.934h-4.94v-18.668h4.588v2.654c.785-1.254 1.491-2.08 2.118-2.478.627-.399 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.306c-.832-.539-1.606-.808-2.321-.808-.691 0-1.277.19-1.758.571-.48.381-.858 1.069-1.133 2.065-.276.997-.413 3.083-.413 6.258v5.766Zm31.31-9.475v-4.341h11.215v10.265c-1.09 1.055-2.669 1.984-4.737 2.786-2.069.803-4.163 1.204-6.284 1.204-2.696 0-5.045-.565-7.049-1.696-2.004-1.131-3.51-2.748-4.518-4.851-1.008-2.104-1.512-4.392-1.512-6.865 0-2.683.563-5.068 1.688-7.154 1.125-2.086 2.771-3.686 4.939-4.799 1.653-.855 3.709-1.283 6.17-1.283 3.2 0 5.699.671 7.497 2.013 1.799 1.341 2.956 3.196 3.472 5.563l-5.168.967c-.363-1.266-1.046-2.265-2.048-2.997-1.002-.733-2.253-1.099-3.753-1.099-2.273 0-4.081.721-5.423 2.162-1.341 1.442-2.012 3.58-2.012 6.416 0 3.059.679 5.353 2.039 6.882 1.359 1.529 3.14 2.294 5.344 2.294 1.089 0 2.182-.214 3.278-.641 1.096-.428 2.036-.947 2.821-1.556v-3.27h-5.959Zm15.85-16.295h5.203v25.77h-5.203z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.props.bodyTitle === 'Lower Abdomen' ? 'bodyParts_group Lower_Abdomen body_parts_active' : 'bodyParts_group Lower_Abdomen' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M750.26 780.31c.07.13.15.25.24.36v-.98c-.06.21-.13.42-.24.62z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M749.33 779.68h1.14v18.07h-1.14zm71.62-69.2-1.89-.66c-.03.09-1.14 3.23-2.89 7.77 1.56-2.31 3.15-4.65 4.73-6.98.03-.06.04-.1.05-.13zm14.38-21.28-1.96-.38c-.02.06-.57 2.04-1.65 5.87 1.29-1.89 2.49-3.65 3.58-5.24.01-.1.02-.19.03-.25z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'syzst2', d: 'm704.9 685.14.03.21c0-.06-.02-.13-.03-.21zm-8.31-34.44c0 .03.01.21.02.54.53.44.71.44.98.44l.52-.03.3-.37c.05-.06.12-.14.19-.39 0-.11-.01-.19-.01-.24l-2 .05zm8.55 35.92c.01.06.02.11.03.16-.01-.05-.02-.1-.03-.16zm-.67-4.95.03.24-.03-.24zm.21 1.81.03.25-.03-.25zm.71 4.43c.01.03.01.06.02.09a.292.292 0 0 1-.02-.09zm-2.44-41.5v-.02.02zm1.32 33.33c.01.06.01.13.02.19-.01-.06-.01-.13-.02-.19zm98.19-28.07h.47c.27 0 .45 0 .98-.45.01-.32.01-.5.01-.53l-2-.03c0 .05 0 .12-.01.21.08.25.14.34.19.4l.36.4z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'syzst2', d: 'M801.87 650.67h.06v-.02l-.06.02zm-97.78 27.08v.04-.04zm-1.07-23.04v.02-.02zm.22 8.17v.12-.12zm-.26-10.97v.06-.06zm-.02-2.79v.08-.08zm.96 26.39c0 .05.01.09.01.13-.01-.04-.01-.08-.01-.13zm-.17-2.39c.01.08.01.16.02.24-.01-.08-.02-.16-.02-.24zm-.29-5.04c.01.1.01.2.02.3-.01-.1-.01-.2-.02-.3zm.14 2.57c.01.09.01.18.02.27-.01-.09-.02-.18-.02-.27zm-.26-5.15c0 .07.01.15.01.22 0-.07-.01-.15-.01-.22zm47.32 111.94c-.01-.21-.01-.42-.01-.63v-90.82l-.15 93.69c.19-.71.18-1.52.16-2.24z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyParts', d: 'M738.08 776.64c-11.26-7.51-26.36-64.68-31.33-83.46-.47-1.8-.85-3.23-1.11-4.2-.08-.29-.16-.62-.24-.98-.01-.03-.01-.06-.02-.09-.07-.35-.15-.72-.22-1.12l-.03-.16c-.07-.4-.14-.82-.2-1.27l-.03-.21a41.334 41.334 0 0 1-.22-1.67c-.06-.5-.12-1.03-.18-1.57l-.03-.24c-.06-.56-.12-1.14-.18-1.75-.01-.06-.01-.13-.02-.19-.06-.63-.12-1.28-.18-1.95v-.04c-.06-.68-.11-1.38-.17-2.1 0-.05-.01-.09-.01-.13-.05-.7-.1-1.42-.15-2.15-.01-.08-.01-.16-.02-.24-.05-.72-.09-1.45-.14-2.2-.01-.09-.01-.18-.02-.27l-.12-2.27c-.01-.1-.01-.2-.02-.3-.04-.78-.08-1.56-.11-2.36 0-.07-.01-.15-.01-.22-.04-.82-.07-1.66-.1-2.5v-.12c-.1-2.67-.17-5.4-.22-8.15v-.02c-.02-.91-.03-1.83-.04-2.74v-.06c-.01-.9-.02-1.81-.02-2.71v-2.81c.03-11.89.61-22.87 1.96-28.03-1.93.88-3.88 1.72-5.62 2.95v.01c.03 2.55.05 5.17.05 7.72.01 16.99-.43 20.83-.74 21.85.13 3.86 1.84 44.47-2.05 57.14-3.66 11.88 5.85 32.03 6.85 34.11 0 .01.01.02.01.02 2.48 3.45 18.36 25.58 22.04 31.09 1.4 2.1 3.68 4.82 6.1 7.71 5.55 6.62 9.18 11.16 9.18 13.89 0 .21-.01.54-.02.97-.69-.42-1.02-.74-1.02-.74s-.01.07-.03.19c.17.13.43.32.79.55 1.43.87 4.43 2.17 9.39 1.96l-.53-.03.02-16.52c-.32.17-.7.29-1.22.29-1.53 0-4.26-1.04-10.02-4.88z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyParts', d: 'M748.65 776.81V615.63c0-2.09-1.05-4.99-10.05-6-7.7.28-28.08 2.17-31.13 7.5-3.75 6.55-3.02 59.88.1 71.32.26.98.64 2.41 1.12 4.21 13.18 49.92 23.45 77.61 30.5 82.32 7.29 4.85 8.91 4.65 9.23 4.48.28-.16.25-1.29.24-1.97-.01-.23-.01-.46-.01-.68zm-59.28-132.95c-7.57-7.94-19-19.94-25.38-24.41-5.5-3.85-8.93-9.11-11.27-14.79-1.42 9.13-4.75 32.47-3.19 41.84 1.85 11.07 4.59 23.26 15.85 39.64 7.81 11.36 23.84 35.05 32.39 47.7-2.76-7.68-5.56-18.52-3.14-26.4 3.68-11.95 2.18-51.16 1.98-56.21-.86-.7-2.64-2.54-7.24-7.37zm116.52 63.58c2.43 7.88-.37 18.72-3.13 26.4 8.54-12.65 24.58-36.34 32.39-47.69 11.26-16.39 14.01-28.57 15.85-39.65 1.56-9.36-1.77-32.68-3.19-41.83-2.33 5.69-5.76 10.94-11.27 14.79-6.38 4.47-17.82 16.46-25.38 24.4-4.59 4.82-6.38 6.66-7.24 7.37 0 .13-.01.27-.01.44-.11 6.52-1.6 44.12 1.98 55.77z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyParts', d: 'M803.98 708.03c-3.9-12.68-2.19-53.36-2.06-57.15-.31-1.03-.75-4.9-.74-21.83 0-.85 0-1.72.01-2.58v-.59c0-.86.01-1.72.02-2.58v-.01l.03-2.7v-.36c.01-.87.03-1.73.04-2.56v-.02c-2.13-.73-4.35-1.16-6.56-1.59.02.03.05.06.07.1 4.34 7.58 3 62.19.1 72.84-.27.97-.64 2.4-1.12 4.19-4.96 18.79-20.06 75.96-31.33 83.47-5.75 3.84-8.48 4.88-10.03 4.88-.54 0-.94-.13-1.27-.31-.14-.08-.27-.17-.38-.27-.1-.08-.18-.18-.26-.27v.27l-.03 16.81-.58.03c5.04.22 8.18-1.12 9.66-1.99.1-.06.17-.11.26-.16-.01-.33-.02-.61-.02-.78 0-2.73 3.64-7.27 9.18-13.89 2.42-2.89 4.71-5.61 6.1-7.71 3.68-5.51 19.56-27.64 22.04-31.09.01-.01.02-.03.02-.04 1.1-2.29 10.49-22.29 6.85-34.11z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyParts', d: 'M761.33 774.98c7.06-4.71 17.32-32.4 30.51-82.32.47-1.8.85-3.23 1.12-4.21 3.12-11.44 3.84-64.76.1-71.32-3.05-5.33-23.43-7.22-31.13-7.5-9.01 1.01-10.05 3.91-10.05 6v161.18c0 .22-.01.45-.01.68-.02.68-.05 1.81.24 1.97.32.17 1.93.38 9.22-4.48z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M749.52 612.38v-.35c-1.67-2.33-5.22-3.78-10.77-4.4l-.08-.01-.07.01c-.09 0-.2.01-.33.01-.06 0-.15.01-.22.01-.08 0-.15.01-.23.01-.08 0-.18.01-.27.01-.1 0-.19.01-.3.01-.13.01-.27.01-.41.02-.09 0-.16.01-.25.01l-.48.03c-.1.01-.19.01-.29.02-.18.01-.37.02-.57.04-.09.01-.19.01-.28.02-.21.01-.43.03-.65.04-.1.01-.19.01-.29.02-.23.02-.47.04-.71.05-.1.01-.2.02-.31.02l-.78.06-.3.03c-.27.02-.54.05-.81.07l-.34.03c-.28.03-.56.05-.84.08-.12.01-.23.02-.35.04-.29.03-.59.06-.89.1-.11.01-.23.02-.34.04-.31.03-.61.07-.93.11-.12.01-.23.03-.35.04l-.96.12c-.11.01-.22.03-.33.04-.33.04-.66.09-.99.14-.11.02-.23.03-.34.05l-1 .15c-.11.02-.23.04-.34.05-.34.05-.67.11-1.01.17l-.34.06-1.01.18-.33.06c-.34.06-.67.13-1 .2-.11.02-.22.05-.34.07l-.99.21c-.11.02-.22.05-.32.07-.33.08-.66.15-.98.23-.1.03-.21.05-.31.08-.32.08-.65.17-.96.25-.1.03-.2.05-.29.08-.32.09-.63.18-.94.27-.1.03-.19.06-.28.09-.31.1-.61.19-.91.29-.09.03-.18.06-.26.09-.3.1-.59.21-.87.32l-.24.09c-.28.11-.56.22-.84.34-.07.03-.14.06-.22.1-.27.12-.54.24-.79.37-.07.03-.13.07-.19.1-.25.13-.5.26-.74.4-.05.03-.1.06-.16.09-.24.14-.47.28-.69.43l-.12.09c-.22.15-.43.31-.63.47-.03.03-.06.05-.09.08-.2.17-.39.34-.57.51-.02.02-.03.04-.05.05-.18.19-.35.37-.5.57-.15.19-.29.39-.41.6-.3.52-.57 1.28-.82 2.23-1.35 5.16-1.93 16.14-1.96 28.03v2.81c0 .9.01 1.8.02 2.71v.06c.01.91.02 1.83.04 2.74v.02c.05 2.75.12 5.49.22 8.15v.12c.03.84.06 1.67.1 2.5 0 .07.01.15.01.22.03.8.07 1.58.11 2.36.01.1.01.2.02.3l.12 2.27c.01.09.01.18.02.27.04.75.09 1.48.14 2.2.01.08.01.16.02.24.05.73.1 1.45.15 2.15 0 .05.01.09.01.13.05.72.11 1.42.17 2.1v.04c.06.67.12 1.32.18 1.95.01.06.01.13.02.19.06.6.12 1.18.18 1.75l.03.24a182.642 182.642 0 0 0 .21 1.82c.06.49.13.97.19 1.42l.03.21c.07.45.13.87.2 1.27.01.06.02.11.03.16.07.4.14.78.22 1.12.01.03.01.06.02.09.08.36.16.69.24.98.26.97.64 2.4 1.11 4.2 4.97 18.78 20.07 75.95 31.33 83.46 5.76 3.84 8.49 4.88 10.03 4.88.52 0 .9-.12 1.22-.29v-.16l.17-168.67zm-1.1 167.08c-.32.17-1.94.37-9.23-4.48-7.05-4.71-17.32-32.4-30.5-82.32-.48-1.8-.86-3.23-1.12-4.21-3.12-11.44-3.85-64.77-.1-71.32 3.05-5.33 23.43-7.22 31.13-7.5 9 1.01 10.05 3.91 10.05 6v161.18c0 .22 0 .45.01.68.01.68.04 1.81-.24 1.97zm-43.92-97.55zm-.4-4.13c.06.67.12 1.32.18 1.95-.07-.63-.13-1.27-.18-1.95zm.19 2.15zm-.36-4.29zm1.01 9.72c.07.45.13.87.2 1.27-.07-.4-.14-.83-.2-1.27z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M702.96 649.12v-2.71c-.01.9-.01 1.81 0 2.71zm2.45 38.88c.08.36.16.69.24.98-.09-.29-.17-.63-.24-.98zm-.24-1.21zm-.46-3.06c.06.49.13.97.19 1.42-.06-.46-.13-.93-.19-1.42zm-1.75-34.53c0 .9.01 1.8.02 2.71-.01-.9-.02-1.81-.02-2.71zm.06 5.53zm-.04-2.75c.01.91.02 1.83.04 2.74-.02-.92-.03-1.83-.04-2.74zm1.93-33.62c-1.35 5.16-1.93 16.14-1.96 28.03.04-11.88.62-22.86 1.96-28.03zM703.24 663zm.37 7.92c.04.75.09 1.48.14 2.2-.05-.72-.09-1.45-.14-2.2zm-.13-2.54.12 2.27c-.05-.75-.09-1.5-.12-2.27zm.28 4.98zm-.41-7.64c.03.8.07 1.58.11 2.36-.04-.78-.08-1.56-.11-2.36zm46.52 111.72c0-.21.01-.42.01-.63V615.63c0-.81.13-1.56.39-2.25-.13-.35-.29-.68-.49-1-.07-.12-.18-.23-.26-.35v.35l-.19 168.69v.16c.02-.01.04-.02.05-.02.08-.04.15-.09.21-.14.3-.2.52-.46.67-.76-.44-.83-.41-1.93-.39-2.87zm-99.41-171.29c-1.52 9.96-4.31 30.56-2.99 40.06-1.32-13.09 4.26-29.8 2.99-40.06z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M696.55 708.03c3.9-12.67 2.19-53.28 2.05-57.14-.07.24-.14.33-.19.39l-.3.37-.52.03c-.27 0-.44 0-.98-.44.2 5.05 1.69 44.26-1.98 56.21-2.42 7.88.37 18.72 3.14 26.4-8.55-12.65-24.58-36.34-32.39-47.7-11.27-16.39-14.01-28.57-15.85-39.64-1.56-9.37 1.77-32.71 3.19-41.84-.52-1.27-.99-2.55-1.41-3.85-.12.69-.44 2.62-.85 5.34 1.27 10.26-4.3 26.96-2.99 40.06.03.21.05.42.09.62 1.88 11.29 4.68 23.72 16.18 40.45.47.68.97 1.41 1.49 2.17-.01-.1-.02-.19-.03-.25l1.96-.38c.02.07.58 2.05 1.65 5.86 3.25 4.76 7.02 10.31 10.83 15.93-.02-.06-.04-.1-.05-.13l1.88-.66c.03.09 1.13 3.2 2.87 7.72.01.01.01.01.01.02 8.17 12.06 15.56 23 17.12 25.31l1.62-1.17c.01.02.12.15.31.41 0 0 .01.01.01.02-1.02-2.08-10.52-22.23-6.86-34.11zm54.59 73.18c.33.18.73.31 1.27.31 1.55 0 4.28-1.04 10.03-4.88 11.27-7.51 26.37-64.68 31.33-83.47.48-1.79.85-3.22 1.12-4.19 2.9-10.65 4.24-65.26-.1-72.84-.02-.03-.05-.06-.07-.1-.46-.77-1.17-1.46-2.07-2.1-6.04-4.3-20.71-5.72-27.47-6.15-.05 0-.1-.01-.16-.01l-.57-.03c-.07 0-.15-.01-.22-.01l-.47-.03c-.08 0-.15-.01-.22-.01-.13-.01-.26-.01-.38-.02-.08 0-.15-.01-.22-.01-.11 0-.21-.01-.31-.01-.06 0-.12 0-.17-.01-.08 0-.17-.01-.24-.01-.12 0-.22-.01-.3-.01l-.08-.01-.07.01c-5.51.61-9.07 2.04-10.75 4.34-.1.13-.18.27-.26.41l-.12 73.61v90.82c0 .21 0 .42.01.63.02.72.03 1.53-.16 2.24v.98c.08.1.16.19.26.27.12.11.25.2.39.28zm.73-3.72c0-.23.01-.46.01-.68V615.63c0-2.09 1.04-4.99 10.05-6 7.7.28 28.08 2.17 31.13 7.5 3.74 6.56 3.02 59.88-.1 71.32-.27.98-.65 2.41-1.12 4.21-13.19 49.92-23.45 77.61-30.51 82.32-7.29 4.86-8.9 4.65-9.22 4.48-.29-.16-.26-1.29-.24-1.97z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M750.65 615.63v70.36l.12-73.61c-.2.32-.37.65-.5 1 .25.69.38 1.44.38 2.25z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M750.65 615.63c0-.81-.13-1.56-.38-2.25a6.33 6.33 0 0 0-.39 2.25v161.18c0 .21-.01.42-.01.63-.02.94-.05 2.04.39 2.87.11-.2.18-.41.24-.63l.15-93.69v-70.36zm99.01-10.47c-1.82 10.43 4.59 28.49 2.77 42.15-.1.74-.16 1.49-.2 2.25.01.01 0 .02 0 .03-.02.49-.02.99-.02 1.49.1-.5.19-1 .28-1.49 0-.01.01-.02 0-.03.04-.76.1-1.51.2-2.25 1.82-13.66-4.59-31.72-2.77-42.15v-.01c-.04-.24-.07-.46-.11-.68-.05.22-.11.44-.15.69z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M849.22 600.81c-.42 1.3-.89 2.59-1.41 3.85 1.42 9.15 4.75 32.47 3.19 41.83-1.84 11.08-4.59 23.26-15.85 39.65-7.81 11.35-23.85 35.04-32.39 47.69 2.76-7.68 5.56-18.52 3.13-26.4-3.58-11.65-2.09-49.25-1.98-55.77 0-.17.01-.32.01-.44-.54.44-.72.45-.98.45h-.47l-.34-.39c-.05-.06-.12-.15-.19-.4-.13 3.79-1.85 44.47 2.06 57.15 3.64 11.82-5.75 31.82-6.85 34.09.19-.26.3-.39.31-.41l1.62 1.17c1.56-2.31 8.94-13.24 17.11-25.29a306.7 306.7 0 0 0 2.89-7.77l1.89.66c-.01.03-.02.07-.05.13 3.81-5.62 7.58-11.17 10.82-15.92 1.08-3.83 1.63-5.81 1.65-5.87l1.96.38c-.01.06-.02.15-.03.25.52-.76 1.02-1.49 1.49-2.17 10.08-14.65 13.47-26.01 15.42-36.2-.01-.5 0-1 .02-1.49 0-.01.01-.02 0-.03.04-.76.1-1.51.2-2.25 1.82-13.66-4.59-31.72-2.77-42.15v-.01c.04-.24.1-.46.15-.68-.28-1.81-.49-3.09-.59-3.64-.02-.01-.02-.01-.02-.02z' }),
	          this.props.bodyTitle === 'Lower Abdomen' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '655', width: '290', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M794.206 675.376h300' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1119.95 688.05v-25.559h5.203v21.217h12.937v4.342h-18.14Zm20.67-9.598c0-1.64.404-3.228 1.213-4.763.808-1.535 1.954-2.707 3.436-3.516 1.483-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.952 0 2.825-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.774-2.734-1.907-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.062.264c0 1.852.44 3.27 1.319 4.254.878.984 1.962 1.477 3.251 1.477 1.29 0 2.371-.493 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.251 1.476-.879.985-1.319 2.403-1.319 4.254Zm21.558 9.334-5.906-18.668h4.799l3.498 12.234 3.216-12.234h4.764l3.111 12.234 3.569-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Zm35.33-5.941 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.843-1.846-6.433 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.433 2.604 1.195 3.419.762.814 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.102 1.195-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.671 1.177-.704.785-1.049 1.852-1.038 3.199h7.383Zm13.659 10.934h-4.939v-18.668h4.588v2.654c.785-1.253 1.491-2.08 2.118-2.478.627-.399 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.53 4.307c-.832-.54-1.605-.809-2.32-.809-.691 0-1.277.19-1.758.571-.48.381-.858 1.07-1.133 2.066-.276.996-.414 3.082-.414 6.257v5.766Zm41.22 0h-5.66l-2.25-5.853h-10.301l-2.127 5.853h-5.519l10.037-25.769h5.502l10.318 25.769Zm-9.58-10.195-3.551-9.563-3.48 9.563h7.031Zm12.09 10.195v-25.769h4.939v9.281c1.524-1.735 3.328-2.602 5.414-2.602 2.274 0 4.155.823 5.643 2.47 1.488 1.646 2.232 4.011 2.232 7.093 0 3.187-.758 5.642-2.276 7.365-1.518 1.723-3.36 2.584-5.528 2.584-1.067 0-2.119-.267-3.156-.8s-1.93-1.321-2.68-2.364v2.742h-4.588Zm4.904-9.738c0 1.933.305 3.363.914 4.289.856 1.312 1.992 1.969 3.41 1.969 1.09 0 2.019-.466 2.786-1.398.768-.931 1.152-2.399 1.152-4.403 0-2.133-.387-3.671-1.16-4.614-.774-.944-1.764-1.415-2.971-1.415-1.184 0-2.168.459-2.953 1.379-.785.92-1.178 2.318-1.178 4.193Zm34.416 9.738h-4.588v-2.742c-.762 1.066-1.661 1.86-2.698 2.382-1.037.521-2.083.782-3.138.782-2.144 0-3.981-.864-5.51-2.593-1.53-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.57 2.232-7.216 1.488-1.647 3.369-2.47 5.643-2.47 2.086 0 3.89.867 5.414 2.602v-9.281h4.939v25.769Zm-13.184-9.738c0 1.992.276 3.433.827 4.324.797 1.289 1.91 1.934 3.34 1.934 1.136 0 2.103-.484 2.9-1.451.797-.966 1.195-2.411 1.195-4.333 0-2.144-.387-3.688-1.16-4.631-.773-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.465-2.944 1.397-.791.932-1.187 2.323-1.187 4.175Zm16.914.14c0-1.64.404-3.228 1.213-4.763.808-1.535 1.954-2.707 3.436-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.952 0 2.825-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.774-2.734-1.907-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.062.264c0 1.852.44 3.27 1.319 4.254.878.984 1.962 1.477 3.251 1.477 1.29 0 2.371-.493 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.251 1.476-.879.985-1.319 2.403-1.319 4.254Zm17.698-9.334h4.553v2.549c1.629-1.981 3.568-2.971 5.818-2.971 1.196 0 2.233.246 3.112.739.879.492 1.599 1.236 2.162 2.232.82-.996 1.705-1.74 2.654-2.232a6.503 6.503 0 0 1 3.041-.739c1.371 0 2.531.279 3.481.835.949.557 1.658 1.374 2.127 2.452.339.797.509 2.086.509 3.868v11.935h-4.939v-10.67c0-1.851-.17-3.047-.51-3.586-.457-.703-1.16-1.054-2.109-1.054-.692 0-1.342.21-1.951.632-.61.422-1.049 1.04-1.319 1.855-.269.814-.404 2.1-.404 3.858v8.965h-4.94v-10.23c0-1.817-.087-2.989-.263-3.516-.176-.527-.448-.92-.818-1.178-.369-.258-.87-.386-1.503-.386a3.6 3.6 0 0 0-2.056.615c-.61.41-1.046 1.002-1.31 1.775-.263.774-.395 2.057-.395 3.85v9.07h-4.94v-18.668Zm43.19 12.727 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.843-1.846-6.433 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.035 1.465.434 2.604 1.196 3.419.761.814 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.704-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.177-.703.785-1.049 1.852-1.037 3.199h7.383Zm25.909 10.934h-4.939v-9.527c0-2.016-.106-3.32-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.544 3.544 0 0 0-1.397 1.863c-.252.773-.378 2.203-.378 4.289v8.455h-4.939v-18.668h4.587v2.742c1.629-2.109 3.68-3.164 6.153-3.164 1.09 0 2.086.197 2.988.589.902.393 1.585.894 2.048 1.503.463.609.785 1.301.967 2.074.181.774.272 1.881.272 3.323v11.601Z' })
	            )
	          ) : ''
	        )
	      );
	      var NewMaleBodySVGReactElement = _react2.default.createElement(
	        'svg',
	        { xmlns: 'http://www.w3.org/2000/svg', className: 'humanBodyImg', viewBox: '120 0 1300 1500', xmlSpace: 'preserve' },
	        _react2.default.createElement(
	          'style',
	          null,
	          ".bodyParts{\
	            fill:#14b795;\
	            cursor: pointer;\
	          }\
	          .bodyLines{\
	            fill:#f2f2f2;\
	          }\
	          .syzst2{\
	            fill:none;\
	          }\
	          .labelGroup {\
	            pointer-events: none;\
	          }\
	          .labelLine {\
	            fill: none;\
	            stroke: #b3b3b3;\
	            stroke-width: 2;\
	          }\
	          .labelText {\
	            fill: #14b795;\
	            fill-rule: nonzero;\
	            transform: translateX(10px);\
	            transition: all 0.3s ease;\
	          }\
	          .labelGroup.is_right .labelText {\
	            transform: translateX(-10px);\
	          }\
	          .labelArea {\
	            fill: transparent;\
	            cursor: pointer;\
	          }\
	          .bodyParts_group:hover .bodyParts {\
	            fill: #FE5722;\
	          }\
	          .bodyParts_group:hover .labelGroup .labelText {\
	            fill: #FE5722;\
	            transform: translateX(0px);\
	          }\
	          .body_parts_active .bodyParts {\
	            fill: #FE5722;\
	          }\
	          .body_parts_active .labelGroup .labelText {\
	            fill: #FE5722;\
	            transform: translateX(0px);\
	          }\
	        "
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Head' ? 'bodyParts_group Head body_parts_active' : 'bodyParts_group Head' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Head');
	            }, className: 'bodyParts', d: 'M803.5 131.12c-3.8-14.89-14.97-36.94-50.42-39.44 0 0-.97-.1-2.68-.12h-.01c-1.86-.44-3.47.12-3.47.12-35.45 2.5-46.62 24.55-50.42 39.44-4.4 17.23-9.97 81.53-2.98 99.85 1.96 5.16 5.58 11.43 10.14 17.56.1.14.21.28.31.41l1.21.48c3.91 2.76 16.48 11.73 18.2 14.17v.01c10.76 9.89 23.07 12.86 26.53 13.52.08.02.17.03.25.05.3-.05.7-.13 1.16-.23 4.42-.96 15.86-4.18 25.82-13.34 1.71-2.44 14.3-11.41 18.21-14.18l.7-.5c.1-.13.2-.27.3-.4 4.55-6.13 8.18-12.4 10.14-17.55 6.99-18.32 1.41-82.62-2.99-99.85z' }),
	          this.state.bodyTitle === 'Head' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '175', width: '100', height: '40', rx: '2' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M794.206 194.654h300' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1120.04 207.328v-25.769h5.203v10.142h10.195v-10.142h5.203v25.769h-5.203v-11.267h-10.195v11.267h-5.203Zm36.76-5.941 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.182-1.23-1.699-1.845-3.843-1.845-6.433 0-3.094.808-5.517 2.425-7.269 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.814 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm12.619-2.039-4.482-.809c.503-1.805 1.371-3.141 2.601-4.008 1.231-.867 3.059-1.301 5.484-1.301 2.204 0 3.844.261 4.922.783 1.078.521 1.837 1.183 2.277 1.986.439.803.659 2.276.659 4.421l-.053 5.765c0 1.641.079 2.851.237 3.63.159.78.455 1.615.888 2.505h-4.887a18.301 18.301 0 0 1-.474-1.459 8.953 8.953 0 0 0-.176-.58c-.844.82-1.746 1.436-2.707 1.846a7.755 7.755 0 0 1-3.076.615c-1.922 0-3.437-.521-4.544-1.564-1.108-1.043-1.661-2.362-1.661-3.955 0-1.055.252-1.996.756-2.822.504-.826 1.21-1.459 2.118-1.898.908-.44 2.218-.823 3.929-1.152 2.308-.433 3.908-.837 4.798-1.212v-.493c0-.949-.234-1.626-.703-2.03-.469-.404-1.353-.606-2.654-.606-.879 0-1.565.172-2.057.518-.492.346-.89.952-1.195 1.82Zm6.609 4.007c-.632.211-1.634.463-3.006.756-1.371.293-2.267.58-2.689.862-.645.457-.967 1.037-.967 1.74 0 .691.258 1.289.774 1.793.515.504 1.172.756 1.968.756.891 0 1.741-.293 2.549-.879.598-.446.99-.991 1.178-1.635.129-.422.193-1.225.193-2.408v-.985Zm26.841 8.965h-4.588v-2.742c-.761 1.066-1.661 1.86-2.698 2.382-1.037.521-2.083.782-3.138.782-2.144 0-3.981-.864-5.51-2.593-1.53-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.232-7.216 1.488-1.646 3.369-2.47 5.643-2.47 2.086 0 3.89.868 5.414 2.602v-9.281h4.939v25.769Zm-13.183-9.738c0 1.992.275 3.433.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.136 0 2.103-.484 2.9-1.45.797-.967 1.195-2.412 1.195-4.333 0-2.145-.386-3.689-1.16-4.632-.773-.944-1.764-1.415-2.971-1.415-1.171 0-2.153.465-2.944 1.397-.791.932-1.186 2.323-1.186 4.175Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Neck' ? 'bodyParts_group Neck body_parts_active' : 'bodyParts_group Neck' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M749.91 277.21c.07-.01.15-.03.25-.04-.07-.01-.16-.03-.25-.05v.09zm.69 2.06.02-.15c-.18.03-.33.06-.46.08.23.04.38.06.44.07zm102.35 35.52c0-.01 0-.03.01-.04-.67-.11-1.34-.21-1.98-.3 0 .01 0 .03-.01.04.56.08 1.14.17 1.72.26.08.01.17.03.26.04zm-45.9-3.76c-.08-1.29-.16-2.4-.24-3.24l-1.99-.81.09 1.02c.39.58.78 1.15 1.17 1.7.33.46.65.89.97 1.33zM749.9 279.2v-.04c-.07-.01-.14-.02-.22-.04l.02.15c.03 0 .1-.01.2-.03v-.04zm.71-.08c.2-.04.44-.08.71-.13v-2.06c-.47.1-.86.18-1.16.23.44.08.69.12.71.12l-.26 1.84zm-.71.04v.08c.07-.01.15-.02.25-.04-.07-.01-.16-.03-.25-.04z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M749.91 277.21c-.29.05-.46.07-.47.08l.24 1.83c.08.01.15.03.22.04l.01-1.95z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M749.9 279.16c.09.02.18.03.25.04.13-.02.28-.05.46-.08l.25-1.84c-.02 0-.26-.04-.71-.12-.09.02-.17.03-.25.04v1.96z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M749.91 277.21v-.09c-3.45-.67-15.77-3.64-26.53-13.52l.13.21c.14.27.59 1.54 1.31 3.65 10.61 8.53 21.64 11.07 24.86 11.66l-.24-1.83c.01-.01.18-.03.47-.08zm1.41 1.78c3.94-.79 14.4-3.51 24.38-11.53.72-2.11 1.17-3.38 1.31-3.65.03-.06.07-.13.12-.2l.01-.01c-9.97 9.16-21.4 12.38-25.82 13.34v2.05z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'syzst2', d: 'm804.82 306.98.09 1.02c.39.58.78 1.15 1.17 1.7.32.46.65.89.97 1.33-.08-1.29-.16-2.4-.24-3.24l-1.99-.81z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyParts', d: 'M662.71 322.33c3.7.6 7.64.52 11.71-.23 5.14-.95 9.77-3.48 13.41-7.31 4.1-4.33 9.5-11.89 12.82-18.92v-.18c-.09.06-.17.12-.25.18h-.01c-10.34 7.22-32.79 16.24-41.41 17.32-2.58.32-5.69.69-9.2 1.19.66 2.01 3.21 6.37 12.93 7.95z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyParts', d: 'M736.88 347.37c.37.09.72.21 1.06.34 1.93.57 6.36 1.67 11.88 1.78l.08-70.24c-.1.01-.17.02-.2.03l-.02-.15c-3.22-.59-14.25-3.12-24.86-11.66v.01c2.75 8.04 9.32 28.23 16.91 51.52 3.31 10.19 5.93 18.24 6.86 21.03 1.11 3.3.86 5.34-.74 6.06-.32.14-.67.21-1.05.21-3.03 0-7.58-4.42-10.25-9.09-1.03-1.81-2.5-4.17-4.21-6.9-3.6-5.77-8.22-13.17-12.86-21.87-1.08 1.91-3.5 6.04-6.07 9.48-3.62 4.86-15.06 14.67-18.37 14.67-.05 0-.09 0-.13-.01-.55-.05-.99-.34-1.22-.8-.89-1.78.11-14.72.73-21.84 0 0 0 .01-.01.01-1.78 2.4-3.55 4.54-5.14 6.22-3.93 4.15-8.94 6.88-14.5 7.91-2.39.44-4.73.66-7.02.66-1.83 0-3.62-.14-5.37-.43-11.15-1.8-13.93-7.13-14.62-9.62-.15.02-.3.04-.46.07-9.14 1.41-20.52 3.81-32.07 8.74-.16.07-.33.15-.49.22 11.36 1.99 44.7 7.8 60.12 12.67 18.81 5.94 27.95 8.98 28.04 9.01l-.05.15c14.31-1.12 26.74 0 34.03 1.82z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyParts', d: 'M696.63 306.79c-.91 9.86-1.57 21.35-1.22 23.73 2.48-.7 12.53-8.62 16.4-13.81 3.3-4.43 6.48-10.25 6.51-10.3l.15.08c-3.41-6.51-6.79-13.72-9.74-21.49-.57-1.51-1.71-4.64-2.62-8.43.2 6.37.17 11.73-.44 13.88-.1.36-.31.74-.57 1.14.01-.01.02-.01.02-.02-1.67 4.38-5.52 10.84-8.49 15.22zm37.41 22.45c1.71 2.75 3.2 5.12 4.25 6.97 3.09 5.4 7.64 8.54 8.75 8.04.15-.07.56-.89-.34-3.6-.94-2.8-3.56-10.85-6.87-21.04-6.93-21.28-17.4-53.43-18.11-54.91-.62-1.11-8.27-6.93-15.89-12.37.73 6.84 3.06 27.5 4.76 31.95 7.22 18.97 16.99 34.61 23.45 44.96zm17.17 15.52-.01 4.73c3.46-.04 7.28-.48 11.16-1.69.41-.17.83-.31 1.28-.43 7.29-1.82 19.71-2.94 34.01-1.84l-.05-.14c.09-.03 9.24-3.07 28.05-9.01 15.94-5.03 49.02-11.07 59.18-12.86-.02-.01-.05-.02-.07-.03-11.44-4.88-22.73-7.28-31.82-8.7-.24 1.74-2.02 7.45-14.81 9.51-1.74.29-3.54.43-5.37.43-2.28 0-4.63-.22-7.01-.66-5.56-1.03-10.58-3.76-14.51-7.91-1.27-1.35-2.71-3.12-4.19-5.13.41 6.93.67 18.98-.21 20.74-.23.46-.67.75-1.22.8-.04 0-.09.01-.13.01-3.3 0-14.74-9.81-18.36-14.67-2.57-3.44-4.99-7.57-6.07-9.48-4.65 8.71-9.27 16.11-12.87 21.87-1.7 2.73-3.17 5.09-4.21 6.9-2.67 4.67-7.22 9.09-10.24 9.09-.38 0-.73-.07-1.06-.21-.58-.27-.98-.71-1.2-1.32v-.04c-.28-.76-.28-1.79 0-3.05v-.04c.11-.51.26-1.02.46-1.61.93-2.79 3.54-10.8 6.84-20.95 7.59-23.33 14.18-43.54 16.93-51.6v-.01c-9.98 8.01-20.44 10.74-24.38 11.53l-.11 62.64v3.13z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyParts', d: 'M753.83 340.65c-.9 2.71-.5 3.53-.34 3.6 1.1.5 5.66-2.64 8.75-8.04 1.05-1.85 2.53-4.22 4.25-6.97 6.46-10.35 16.22-25.99 23.45-44.96 1.69-4.45 4.02-25.11 4.76-31.95-7.62 5.44-15.27 11.26-15.9 12.38-.71 1.47-11.19 33.67-18.13 54.98-3.3 10.15-5.91 18.17-6.84 20.96zm28.24-34.17.14-.07c.03.06 3.2 5.88 6.51 10.3 3.88 5.2 13.93 13.12 16.4 13.82.34-2.32.62-12.76-.21-22.52-.24-.35-.47-.7-.71-1.06-2.71-4.13-5.32-8.78-7.11-13.01-.14-.12-.29-.24-.42-.36-.01 0-.01-.01-.01-.01-1.24-1.14-2.06-2.19-2.32-3.11-.68-2.41-.64-8.86-.35-16.24-.73 4.83-1.5 8.98-2.18 10.79-2.96 7.75-6.34 14.96-9.74 21.47z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyParts', d: 'M826.11 322.1c4.07.75 8 .83 11.7.23 11.76-1.9 13.03-6.91 13.15-7.84-.08-.01-.17-.03-.26-.04-3.71-.54-6.99-.92-9.69-1.26-8.39-1.05-29.87-9.62-40.55-16.74 3.46 6.98 8.6 14.53 12.22 18.34 3.65 3.83 8.29 6.36 13.43 7.31zm-74.91 27.39.01-4.73v-3.13l.11-62.64c-.26.05-.5.1-.71.13l-.02.15c-.05-.01-.21-.03-.44-.07-.1.02-.18.03-.25.04l-.08 70.24c.46.01.91.01 1.38.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'm718.46 306.49 1.61.88c-.03.06-.24.45-.59 1.06 4.64 8.7 9.26 16.1 12.86 21.87 1.71 2.73 3.18 5.09 4.21 6.9 2.67 4.67 7.22 9.09 10.25 9.09.38 0 .73-.07 1.05-.21 1.6-.72 1.85-2.76.74-6.06-.93-2.79-3.55-10.84-6.86-21.03-7.59-23.29-14.16-43.48-16.91-51.52v-.01c-.97-.78-1.93-1.6-2.88-2.48l1.36-1.47c.03.03.06.05.09.08v-.01c-1.72-2.44-14.29-11.41-18.2-14.17l-1.21-.48c.27.37.54.73.83 1.1.23 5.64.77 13.96 1.11 21.66v.03c0 .01 0 .03.01.04.07 1.64.14 3.25.18 4.8.91 3.79 2.05 6.91 2.62 8.43 2.94 7.78 6.32 14.99 9.73 21.5zm-12.63-54.16c7.62 5.44 15.27 11.26 15.89 12.37.71 1.48 11.18 33.63 18.11 54.91 3.31 10.19 5.93 18.24 6.87 21.04.9 2.71.49 3.53.34 3.6-1.11.5-5.66-2.64-8.75-8.04-1.05-1.85-2.54-4.22-4.25-6.97-6.46-10.35-16.23-25.99-23.45-44.96-1.7-4.45-4.03-25.11-4.76-31.95zm-43.44 71.97c1.75.29 3.54.43 5.37.43 2.29 0 4.63-.22 7.02-.66 5.56-1.03 10.57-3.76 14.5-7.91 1.59-1.68 3.36-3.82 5.14-6.22 0 0 0-.01.01-.01.11-1.26.21-2.34.29-3.14l1.99-.81c-.03.27-.05.54-.07.81 2.97-4.39 6.82-10.84 8.48-15.23-.01.01-.02.01-.02.02-.34.52-.8 1.06-1.38 1.62l-.01.01c-.81.78-1.85 1.61-3.05 2.47v.18c-3.32 7.03-8.72 14.59-12.82 18.92-3.64 3.83-8.27 6.36-13.41 7.31-4.07.75-8.01.83-11.71.23-9.72-1.58-12.27-5.93-12.93-7.95-.16.02-.32.04-.48.07-.5.07-1.01.15-1.53.23.68 2.5 3.46 7.83 14.61 9.63z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'm718.46 306.49-.15-.08c-.03.06-3.2 5.87-6.51 10.3-3.87 5.19-13.92 13.12-16.4 13.81-.34-2.39.31-13.87 1.22-23.73-.04.05-.07.11-.11.17-.69 1.03-1.4 2.01-2.09 2.97-.63 7.12-1.62 20.06-.73 21.84.23.46.67.75 1.22.8.04 0 .09.01.13.01 3.3 0 14.74-9.81 18.37-14.67 2.57-3.44 4.99-7.57 6.07-9.48-.34-.64-.68-1.28-1.02-1.94z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M718.46 306.49c.34.66.68 1.3 1.02 1.94.35-.61.56-1 .59-1.06l-1.61-.88zm-21.83.3c.03-.27.05-.55.07-.81l-1.99.81c-.08.8-.18 1.88-.29 3.14.7-.96 1.41-1.94 2.09-2.97.05-.05.09-.11.12-.17zm62.14 12.28c-3.3 10.15-5.91 18.16-6.84 20.95-.2.59-.35 1.1-.46 1.61v.04c-.28 1.26-.28 2.29 0 3.05v.04c.22.61.62 1.05 1.2 1.32.33.14.68.21 1.06.21 3.02 0 7.57-4.42 10.24-9.09 1.04-1.81 2.51-4.17 4.21-6.9 3.6-5.77 8.22-13.17 12.87-21.87-.35-.61-.56-1-.59-1.06l1.61-.88v-.01c3.4-6.51 6.78-13.72 9.74-21.48.68-1.81 1.45-5.97 2.18-10.79.03-.83.07-1.67.11-2.52v-.05c.34-7.68.88-15.97 1.11-21.6.29-.37.56-.74.84-1.12l-.7.5c-3.91 2.77-16.5 11.74-18.21 14.18.03-.03.06-.05.09-.08l1.36 1.47c-.95.88-1.92 1.7-2.88 2.47v.01c-2.76 8.06-9.35 28.27-16.94 51.6zm20.03-54.36c.63-1.12 8.28-6.94 15.9-12.38-.74 6.84-3.07 27.5-4.76 31.95-7.23 18.97-16.99 34.61-23.45 44.96-1.72 2.75-3.2 5.12-4.25 6.97-3.09 5.4-7.65 8.54-8.75 8.04-.16-.07-.56-.89.34-3.6.93-2.79 3.54-10.81 6.84-20.96 6.94-21.31 17.42-53.51 18.13-54.98zM804.91 308l-.09-1.02 1.99.81c.08.84.16 1.95.24 3.24 1.48 2.01 2.92 3.78 4.19 5.13 3.93 4.15 8.95 6.88 14.51 7.91 2.38.44 4.73.66 7.01.66 1.83 0 3.63-.14 5.37-.43 12.79-2.06 14.57-7.77 14.81-9.51-.08-.01-.17-.03-.26-.04-.58-.1-1.16-.18-1.72-.26-.13.93-1.39 5.94-13.15 7.84-3.7.6-7.63.52-11.7-.23-5.14-.95-9.78-3.48-13.42-7.31-3.62-3.81-8.76-11.36-12.22-18.34-.13-.09-.27-.17-.39-.26h-.01c-1.14-.78-2.14-1.54-2.98-2.26 1.8 4.23 4.4 8.88 7.11 13.01.24.36.47.71.71 1.06z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'M804.91 308c.84 9.77.55 20.2.21 22.52-2.47-.69-12.53-8.62-16.4-13.82-3.3-4.43-6.48-10.25-6.51-10.3l-.14.08c-.34.66-.68 1.29-1.02 1.93v.01c1.08 1.91 3.5 6.04 6.07 9.48 3.62 4.86 15.06 14.67 18.36 14.67.05 0 .09 0 .13-.01.55-.05.99-.34 1.22-.8.88-1.77.62-13.81.21-20.74-.32-.44-.64-.87-.97-1.33-.38-.54-.77-1.11-1.16-1.69z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Neck');
	            }, className: 'bodyLines', d: 'm782.07 306.49-1.61.87c.03.06.24.45.59 1.06v-.01c.34-.63.68-1.26 1.02-1.92zm-58.77-42.97s-1.56.69-1.58 1.18c-.04 1.04 3.1 2.76 3.1 2.76s-.85-3.17-1.52-3.94zm52.4 3.94 1.44-3.87s1.47-.68 1.66 1.11l-1.16 3.27-1.94-.51z' }),
	          this.state.bodyTitle === 'Neck' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '282', width: '100', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M794.206 302.225h300' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1120.08 314.899V289.13h5.062l10.547 17.209V289.13h4.834v25.769h-5.22l-10.389-16.804v16.804h-4.834Zm36.72-5.941 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.269 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm25.209-2.215-4.869.879c-.164-.973-.536-1.705-1.116-2.197-.581-.493-1.333-.739-2.259-.739-1.231 0-2.212.425-2.945 1.275-.732.849-1.098 2.27-1.098 4.262 0 2.215.372 3.78 1.116 4.694.744.914 1.743 1.371 2.997 1.371.938 0 1.705-.267 2.303-.8.597-.533 1.019-1.45 1.265-2.751l4.852.826c-.504 2.227-1.471 3.908-2.9 5.045-1.43 1.137-3.346 1.705-5.748 1.705-2.731 0-4.908-.861-6.531-2.584-1.623-1.722-2.434-4.107-2.434-7.154 0-3.082.814-5.482 2.443-7.198 1.629-1.717 3.832-2.576 6.609-2.576 2.274 0 4.082.49 5.423 1.468 1.342.979 2.306 2.47 2.892 4.474Zm3.57 13.148V289.13h4.94v13.676l5.783-6.575h6.082l-6.381 6.821 6.838 11.847h-5.326l-4.694-8.384-2.302 2.408v5.976h-4.94Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Right Shoulder' ? 'bodyParts_group Right_Shoulder body_parts_active' : 'bodyParts_group Right_Shoulder' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Shoulder');
	            }, className: 'bodyParts', d: 'M626.27 471.67c.11-.25.27-.47.49-.6-.1-.5-.18-1-.23-1.5-1-9.97 3.72-35.6 4.2-38.14-.29-1.24-.55-2.38-.78-3.41-.36-1.61-.66-2.92-.89-3.86-.6-2.41-2.6-6.58-5.79-12.11-4.19 9.1-23.52 51.62-28.81 73.66-1.86 7.74-3.63 17.1-5.35 26.14-4.01 21.12-6.76 34.72-10.28 38.58 2.57.81 5.22.73 7.89-.27 12.4-4.61 22.77-27.81 22.86-28.03l.19.26c1.45-4.77 2.8-9.24 3.87-12.88 4.1-13.93 6.18-31.9 6.8-37.89.05-.53.77-.63.96-.14.81 2.02 2.15 5.36 3.52 8.75.05.12.12.28.19.44-.15-3.04-.08-6.07 1.16-9zm-64.59 9.06c1.48-4.92 3.08-10.26 4.82-15.71.29-.91.59-1.84.89-2.76-1.48-10.07-3.48-30.96-4.42-41.05v-.83c-.08.6-.16 1.2-.26 1.8v.03c-.59 3.41-1.52 6.76-2.8 10-2.7 6.85-5.85 17.11-6.98 28.36-.96 9.62-1.95 30.12-3.18 49.45 1.39-2.25 3.23-5.41 5.3-9.47 1.66-3.25 3.85-10.56 6.63-19.82zm16.38-46.22c9.87-20.64 32.64-30.29 37.65-32.2.23-.09.73-.31 1.27-.55l-.27-.45c-3.26-5.69-2.76-12.74 1.31-17.78 4.98-6.18 10.32-10.84 17.14-15.14 6.82-4.3 15.1-8.24 25.99-12.96 12.21-5.28 25.16-8.16 37.1-9.46-4.37-1.43-12.32-4-23.99-7.68-17.68-5.59-57.7-12.43-62.48-13.25-10.96 5.16-21.88 12.7-30.97 23.95-5.74 7.1-9.73 15.46-11.75 24.36-2.01 8.84-4.54 22.05-5.35 35.1.75 7.99 3.44 36.37 5.11 49.48 2.77-8.16 5.84-16.3 9.24-23.42z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Shoulder');
	            }, className: 'bodyParts', d: 'M581.43 538.72c1.91-7.24 3.75-16.95 5.7-27.23 1.72-9.07 3.5-18.45 5.37-26.24 5.65-23.54 27.09-70.06 29.52-75.3-1.1-1.87-2.33-3.88-3.67-6.01-.76.01-1.44.04-1.57.09-3.82 1.41-27.07 10.73-36.92 31.33-3.9 8.15-7.36 17.69-10.43 27.07l.06.37-.18.03c-2.08 6.4-3.99 12.72-5.72 18.47-2.81 9.35-5.03 16.74-6.77 20.15-.53 1.05-1.04 2.01-1.54 2.93l.33-.03c0 .01.01.09.03.22.16 1.42 1.18 9.49 3.89 18.55.3.96.6 1.92.93 2.89 3.19 9.52 8.3 19.47 16.26 23.55.47-.08 2.15-1.11 4.71-10.84z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Shoulder');
	            }, className: 'bodyLines', d: 'M553 508.48c.3-.5.6-1.04.92-1.59-.18-1.3-.27-2.12-.29-2.33l1.66-.17c.5-.92 1.01-1.89 1.54-2.93 1.74-3.41 3.96-10.8 6.77-20.15 1.73-5.75 3.63-12.07 5.72-18.47l-1.8.28c-.01-.03-.01-.07-.02-.1v-.01c-.04-.24-.07-.49-.11-.75-.3.92-.6 1.85-.89 2.76-1.74 5.45-3.34 10.79-4.82 15.71-2.78 9.26-4.97 16.57-6.63 19.82-2.07 4.06-3.91 7.22-5.3 9.47 0 .07-.01.13-.01.2-.09 1.3-.17 2.6-.26 3.9.76-1.11 1.97-2.97 3.52-5.63v-.01zm15.91-49.84c.19 1.4.36 2.68.53 3.8 3.06-9.38 6.52-18.92 10.43-27.07 9.85-20.6 33.1-29.92 36.92-31.33.13-.05.81-.07 1.57-.09-.19-.3-.38-.6-.57-.91-.22-.34-.45-.69-.67-1.04-.05-.08-.09-.16-.14-.24-.53.24-1.04.46-1.27.55-5.01 1.91-27.78 11.56-37.65 32.2-3.4 7.12-6.47 15.26-9.24 23.42.03.23.06.48.09.7v.01zm-1.52 3.62c.18-.54.35-1.08.52-1.62.3-.9.6-1.81.91-2.71-1.68-13.11-4.36-41.49-5.11-49.48-.12 1.96-.2 3.91-.24 5.85-.01.7-.04 1.4-.09 2.1a52.58 52.58 0 0 1-.41 3.98v.83c.94 10.09 2.94 30.98 4.42 41.05zm2.06.18c-.04.13-.09.26-.13.4l.18-.03a4.69 4.69 0 0 1-.05-.37z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Shoulder');
	            }, className: 'bodyLines', d: 'M568.91 458.64v-.01c-.03-.22-.06-.47-.09-.7-.31.9-.61 1.81-.91 2.71-.17.54-.35 1.08-.52 1.62.04.25.07.51.11.75v.01c.01.03.01.07.02.1l1.8-.28c.04-.13.09-.26.13-.4-.18-1.12-.35-2.4-.54-3.8zm53.12-48.68c-2.43 5.24-23.88 51.76-29.52 75.3-1.87 7.79-3.65 17.17-5.37 26.24-1.95 10.28-3.8 19.99-5.7 27.23-2.56 9.73-4.24 10.76-4.7 10.85.06.04.12.07.18.1.63.32 1.27.58 1.91.78 3.52-3.86 6.27-17.46 10.28-38.58 1.72-9.05 3.49-18.4 5.35-26.14 5.29-22.04 24.62-64.57 28.81-73.66-.4-.7-.8-1.4-1.24-2.12zm76.22-63.99h.02c1.56-.17 3.08-.31 4.59-.43l.05-.15c-.09-.03-9.23-3.07-28.04-9.01-15.42-4.87-48.77-10.68-60.12-12.67-.9.39-1.8.79-2.7 1.2-.09.04-.18.09-.27.13 4.79.82 44.8 7.66 62.48 13.25 11.67 3.68 19.62 6.25 23.99 7.68z' }),
	          this.state.bodyTitle === 'Right Shoulder' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '105', y: '456', width: '275', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup is_right' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M405 479.666h160' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M125.046 488.982v-25.769h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.183 1.125 2.537 1.125 4.06 0 1.934-.568 3.531-1.705 4.79-1.137 1.26-2.836 2.054-5.097 2.382 1.125.656 2.053 1.377 2.786 2.162.732.785 1.719 2.18 2.962 4.184l3.146 5.027h-6.223l-3.761-5.607c-1.336-2.004-2.25-3.267-2.742-3.788-.493-.522-1.014-.879-1.565-1.072-.551-.194-1.424-.291-2.619-.291h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.055-.105 4.676-.316a2.803 2.803 0 0 0 1.459-1.09c.351-.516.527-1.16.527-1.934 0-.867-.231-1.567-.694-2.1-.463-.533-1.117-.87-1.96-1.011-.422-.059-1.688-.088-3.797-.088h-4.061v6.539Zm20.742-6.328v-4.57h4.94v4.57h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.231 5.643.685c.094.657.31 1.108.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.193 2.901-.58.433-.258.761-.674.984-1.248.152-.41.228-1.166.228-2.268v-2.724c-1.476 2.015-3.339 3.023-5.589 3.023-2.508 0-4.495-1.06-5.959-3.181-1.149-1.676-1.723-3.762-1.723-6.258 0-3.129.753-5.52 2.259-7.172 1.506-1.652 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.94-.363 1.09-.873 1.945-1.529 2.566-.657.621-1.533 1.108-2.628 1.459-1.096.352-2.482.527-4.157.527-3.165 0-5.409-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.597Zm4.412-10.951c0 1.98.384 3.43 1.152 4.35.767.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.398-3.37-1.195-4.307-.797-.938-1.805-1.406-3.023-1.406-1.184 0-2.16.46-2.927 1.38-.768.92-1.152 2.323-1.152 4.21Zm22.957-16.049v9.474c1.594-1.863 3.499-2.795 5.713-2.795 1.137 0 2.162.211 3.077.633.914.422 1.602.961 2.065 1.617.463.657.779 1.383.949 2.18.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.282-3.727a2.438 2.438 0 0 0-.993-1.256c-.474-.311-1.069-.466-1.784-.466-.82 0-1.553.199-2.197.597-.645.399-1.116.999-1.415 1.802-.299.803-.449 1.989-.449 3.56v9.351h-4.939v-25.769h4.939Zm25.629 7.101v3.938h-3.375v7.523c0 1.524.033 2.411.097 2.663.065.252.211.46.44.624.228.164.506.246.834.246.458 0 1.12-.158 1.987-.474l.422 3.832c-1.149.492-2.45.738-3.903.738-.89 0-1.693-.149-2.408-.448-.715-.299-1.239-.686-1.573-1.16-.334-.475-.566-1.116-.694-1.925-.106-.574-.159-1.734-.159-3.481v-8.138h-2.267v-3.938h2.267v-3.709l4.957-2.882v6.591h3.375Zm12.147 10.284 5.062-.493c.305 1.7.923 2.948 1.855 3.744.932.797 2.188 1.196 3.77 1.196 1.676 0 2.939-.355 3.788-1.064.85-.709 1.275-1.538 1.275-2.487 0-.609-.179-1.128-.536-1.556-.358-.427-.982-.799-1.872-1.116-.61-.211-1.998-.586-4.166-1.125-2.789-.691-4.746-1.541-5.871-2.549-1.582-1.418-2.373-3.146-2.373-5.185 0-1.313.372-2.54 1.116-3.683.744-1.142 1.816-2.013 3.217-2.61 1.4-.598 3.09-.897 5.071-.897 3.234 0 5.669.709 7.304 2.127 1.634 1.418 2.493 3.311 2.575 5.678l-5.203.228c-.223-1.324-.701-2.276-1.433-2.856-.732-.58-1.831-.87-3.296-.87-1.512 0-2.695.31-3.551.932-.55.398-.826.931-.826 1.599 0 .61.258 1.131.774 1.565.656.55 2.25 1.125 4.781 1.722 2.531.598 4.403 1.216 5.616 1.855 1.213.638 2.162 1.512 2.848 2.619.685 1.107 1.028 2.476 1.028 4.104 0 1.477-.41 2.86-1.23 4.149-.821 1.289-1.981 2.247-3.481 2.874-1.5.627-3.369.94-5.607.94-3.258 0-5.76-.753-7.506-2.258-1.746-1.506-2.789-3.701-3.129-6.583Zm30.217-17.385v9.474c1.593-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.657.779 1.383.949 2.18.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.281-3.727a2.445 2.445 0 0 0-.994-1.256c-.474-.311-1.069-.466-1.784-.466-.82 0-1.553.199-2.197.597-.645.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm15.925 16.172c0-1.641.405-3.229 1.213-4.764.809-1.535 1.954-2.707 3.437-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.138.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.953 0 2.824-.911 5.165-2.733 7.022-1.823 1.857-4.117 2.786-6.882 2.786-1.711 0-3.343-.387-4.896-1.16-1.552-.773-2.733-1.907-3.542-3.401-.808-1.495-1.213-3.314-1.213-5.458Zm5.063.263c0 1.852.439 3.27 1.318 4.254.879.985 1.963 1.477 3.252 1.477 1.289 0 2.37-.492 3.243-1.477.873-.984 1.31-2.414 1.31-4.289 0-1.828-.437-3.234-1.31-4.219-.873-.984-1.954-1.476-3.243-1.476s-2.373.492-3.252 1.476c-.879.985-1.318 2.403-1.318 4.254Zm30.357 9.334v-2.795a7.191 7.191 0 0 1-2.68 2.356 7.52 7.52 0 0 1-3.507.861c-1.254 0-2.379-.275-3.375-.826-.996-.551-1.717-1.324-2.162-2.32-.446-.996-.668-2.373-.668-4.131v-11.813h4.939v8.578c0 2.625.091 4.234.273 4.826.181.591.512 1.06.993 1.406.48.346 1.09.518 1.828.518.844 0 1.6-.231 2.268-.694.668-.463 1.125-1.037 1.371-1.723.246-.685.369-2.364.369-5.036v-7.875h4.939v18.668h-4.588Zm9.704-25.769h4.939v25.77h-4.939zm27.123 25.769h-4.588v-2.742c-.762 1.066-1.661 1.86-2.699 2.382-1.037.521-2.083.782-3.137.782-2.145 0-3.982-.864-5.511-2.593-1.529-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.232-7.216 1.489-1.646 3.37-2.47 5.643-2.47 2.086 0 3.891.868 5.414 2.602v-9.281h4.94v25.769Zm-13.184-9.738c0 1.992.275 3.434.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.137 0 2.103-.484 2.9-1.45.797-.967 1.196-2.412 1.196-4.333 0-2.145-.387-3.689-1.16-4.632-.774-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.466-2.945 1.397-.791.932-1.186 2.323-1.186 4.175Zm28.863 3.797 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429H352.56c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.527-.422.926-1.102 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.382Zm13.659 10.933h-4.94v-18.668h4.588v2.655c.785-1.254 1.491-2.08 2.118-2.479.627-.398 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.307c-.832-.539-1.606-.809-2.321-.809-.691 0-1.277.191-1.757.571-.481.381-.859 1.07-1.134 2.066-.276.996-.413 3.082-.413 6.258v5.765Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Left Shoulder' ? 'bodyParts_group Left_Shoulder body_parts_active' : 'bodyParts_group Left_Shoulder' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyLines', d: 'M933.89 539.3c-.01.03-.05.18-.11.43.1-.16.2-.33.3-.5l-.19.07zm-12.18 11.15c.68.75 1.39 1.13 2.14 1.13.13 0 .25-.01.38-.03l-.33-1.97c-.02 0-.06.01-.11 0-.06.04-.12.07-.17.1-.63.31-1.27.57-1.91.77z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyParts', d: 'M934.09 539.23c2.51-4.07 4.47-8.73 5.99-13.3.33-.94.62-1.88.9-2.81 2.71-9.03 3.73-17.08 3.9-18.53-.69-1.26-1.42-2.62-2.18-4.12-1.74-3.41-3.96-10.8-6.77-20.16-4.3-14.3-9.65-32.1-16.26-45.94-9.87-20.64-33.19-29.95-36.93-31.33-1.55 2.47-2.97 4.77-4.24 6.91 2.41 5.19 23.88 51.76 29.53 75.31 1.87 7.79 3.65 17.17 5.37 26.24 1.95 10.28 3.8 19.99 5.7 27.23 2.56 9.74 4.25 10.76 4.7 10.85h.01c4.02-2.06 7.3-5.61 9.98-9.84.06-.25.1-.4.11-.43l.19-.08z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyParts', d: 'M802.28 345.96c11.93 1.3 24.89 4.18 37.09 9.47 21.77 9.44 33.17 15.73 43.14 28.1 4.06 5.04 4.56 12.09 1.3 17.78 4.95 1.89 27.77 11.52 37.65 32.2 3.79 7.92 7.15 17.09 10.14 26.17v-.01c1.52-11.64 4-33.94 5.02-43.17 0-.03-.01-.06-.01-.09-.05-.7-.08-1.4-.09-2.1-.26-14.83-3.28-30.78-5.58-40.95-2.02-8.9-6.01-17.26-11.75-24.36-9.13-11.29-20.1-18.86-31.1-24.01-2.5.44-43.58 7.54-61.84 13.31-11.66 3.67-19.61 6.24-23.97 7.66zm135.56 133.77c2.78 9.26 4.98 16.57 6.64 19.82 2.31 4.52 4.33 7.94 5.76 10.21-1.22-19.26-2.2-39.62-3.16-49.19-1.13-11.25-4.28-21.51-6.98-28.36-1.17-2.95-2.03-6-2.62-9.1-.99 10.67-3.01 31.47-4.46 40.93 1.74 5.44 3.34 10.77 4.82 15.69zm-26.41 32.14c-1.72-9.05-3.49-18.4-5.35-26.15-5.29-22.05-24.63-64.6-28.82-73.67-3.17 5.54-5.18 9.71-5.78 12.12-.24.93-.53 2.25-.89 3.85-.23 1.04-.5 2.19-.78 3.44v.01c.47 2.49 4.51 24.43 4.33 35.6.17.07.33.19.45.39 1.17 2.01 2.24 4.07 3.17 6.19.32-.81.62-1.54.86-2.15.2-.49.92-.39.96.14.62 5.99 2.7 23.96 6.81 37.89 1.12 3.84 2.56 8.62 4.11 13.69 2.41 4.64 12.48 22.93 23.32 26.97 2.67.99 5.32 1.08 7.89.26-3.52-3.86-6.27-17.46-10.28-38.58z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyLines', d: 'M937.84 479.73c-1.48-4.92-3.08-10.25-4.82-15.7v.01c0 .03-.01.05-.01.08l-1.98-.31c.19-1.21.38-2.6.58-4.14-2.99-9.08-6.36-18.25-10.14-26.17-9.89-20.67-32.7-30.31-37.65-32.2-.13.23-.27.46-.41.69-.22.35-.45.7-.67 1.04 3.74 1.38 27.06 10.69 36.93 31.33 6.62 13.83 11.97 31.63 16.26 45.94 2.81 9.35 5.03 16.74 6.77 20.16.77 1.5 1.49 2.87 2.18 4.12.02-.14.03-.21.03-.23l1.99.2c-.02.24-.14 1.29-.38 2.93 1.91 3.28 3.33 5.38 3.98 6.29-.08-1.18-.16-2.37-.23-3.56l-.03-.46c-1.44-2.27-3.45-5.68-5.76-10.21-1.66-3.24-3.86-10.55-6.64-19.81z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyLines', d: 'M931.61 459.67c.48 1.46.95 2.91 1.41 4.36 1.45-9.46 3.46-30.26 4.46-40.93-.06-.3-.13-.6-.18-.9v-.02a49.5 49.5 0 0 1-.67-5.7c-1.01 9.23-3.49 31.53-5.02 43.17v.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyLines', d: 'M933.01 464.12c0-.03.01-.05.01-.08v-.01c-.46-1.45-.93-2.9-1.41-4.36-.2 1.54-.39 2.93-.58 4.14l1.98.31zm8.81 63.13c2.73-7.97 4.11-15.67 4.7-19.75v-.01c-.51-.88-1.06-1.85-1.64-2.9-.17 1.45-1.19 9.5-3.9 18.53-.28.93-.57 1.87-.9 2.81-1.52 4.56-3.49 9.22-5.99 13.3l2.74-1.01c-.01.04-.07.28-.18.68.32-.56.64-1.13.94-1.7 1.68-3.19 3.08-6.59 4.23-9.95zm-28.71 24.81c1.71.63 3.4.95 5.08.95 2.14 0 4.26-.52 6.32-1.55 3.08-1.54 5.74-3.84 8.06-6.62.59-2.58 1.02-4.35 1.21-5.12-2.68 4.23-5.97 7.78-9.98 9.84h-.01c.05.01.09.01.11 0l.33 1.97c-.13.02-.26.03-.38.03-.75 0-1.46-.39-2.14-1.13-2.57.82-5.22.73-7.89-.26-10.84-4.04-20.91-22.32-23.32-26.97.04.13.08.25.12.38.55 1.8 1.11 3.64 1.68 5.49l.93 3.01c4.2 7.2 11.69 16.93 19.88 19.98z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Shoulder');
	            }, className: 'bodyLines', d: 'M934.09 539.23c-.1.17-.2.34-.3.5-.19.77-.63 2.54-1.21 5.12 1.51-1.81 2.86-3.81 4.08-5.94.1-.4.17-.64.18-.68l-2.75 1zm-14.99-.5c-1.91-7.24-3.75-16.95-5.7-27.23-1.72-9.07-3.5-18.45-5.37-26.24-5.65-23.55-27.12-70.12-29.53-75.31-.42.72-.83 1.41-1.23 2.09v.01c4.18 9.08 23.52 51.63 28.82 73.67 1.86 7.74 3.63 17.1 5.35 26.15 4.01 21.12 6.76 34.72 10.28 38.58.65-.2 1.29-.46 1.92-.78.06-.03.12-.06.17-.1-.47-.08-2.15-1.11-4.71-10.84zm26.93-34.92s1.31.15 1.4 1.23l-.9 2.46-1.64-2.91v-.78c-.01 0 .26-.75 1.14 0zm-71.89-36.74s.01 5.75-1.41 4.25l3.96 4.97 1.06-2.64s-2.1-5.73-3.61-6.58zm-76.53-121.68.05.14c1.52.12 3.06.26 4.62.43 4.36-1.42 12.31-3.99 23.98-7.67 18.26-5.77 59.34-12.87 61.84-13.31-.05-.02-.1-.05-.15-.07-1.04-.49-2.07-.95-3.11-1.39-10.16 1.79-43.25 7.83-59.18 12.86-18.81 5.94-27.96 8.98-28.05 9.01z' }),
	          this.state.bodyTitle === 'Left Shoulder' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '456', width: '245', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M934.206 476.106h160' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1120.17 488.982v-25.558h5.203v21.216h12.937v4.342h-18.14Zm32.62-5.941 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429H1145.6c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.048 1.852-1.037 3.2h7.383Zm6.769-7.735h2.742v-1.406c0-1.57.167-2.742.501-3.516.334-.773.949-1.403 1.846-1.889.896-.487 2.03-.73 3.401-.73 1.406 0 2.783.211 4.131.633l-.668 3.445a9.783 9.783 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.71 0v3.938h-3.375v7.523c0 1.524.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.474l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.686-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.481v-8.138h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm12.15 10.284 5.063-.493c.304 1.7.922 2.948 1.854 3.744.932.797 2.189 1.196 3.771 1.196 1.675 0 2.938-.355 3.788-1.064.849-.709 1.274-1.538 1.274-2.487 0-.609-.179-1.128-.536-1.556-.357-.427-.982-.799-1.872-1.116-.61-.211-1.998-.586-4.166-1.125-2.789-.691-4.746-1.541-5.871-2.549-1.582-1.418-2.373-3.146-2.373-5.185 0-1.313.372-2.54 1.116-3.683.744-1.142 1.816-2.013 3.217-2.61 1.4-.598 3.091-.897 5.071-.897 3.234 0 5.669.709 7.304 2.127 1.634 1.418 2.493 3.311 2.575 5.678l-5.203.228c-.223-1.324-.7-2.276-1.433-2.856-.732-.58-1.831-.87-3.296-.87-1.511 0-2.695.31-3.551.932-.55.398-.826.931-.826 1.599 0 .61.258 1.131.774 1.565.656.55 2.25 1.125 4.781 1.722 2.531.598 4.403 1.216 5.616 1.855 1.213.638 2.162 1.512 2.848 2.619.685 1.107 1.028 2.476 1.028 4.104 0 1.477-.41 2.86-1.23 4.149-.821 1.289-1.981 2.247-3.481 2.874-1.5.627-3.369.94-5.607.94-3.258 0-5.76-.753-7.506-2.258-1.746-1.506-2.789-3.701-3.129-6.583Zm30.21-17.385v9.474c1.594-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.657.78 1.383.95 2.18.169.797.254 2.033.254 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.199-.281-3.727a2.448 2.448 0 0 0-.993-1.256c-.475-.311-1.07-.466-1.785-.466-.82 0-1.552.199-2.197.597-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm15.93 16.172c0-1.641.404-3.229 1.213-4.764.808-1.535 1.954-2.707 3.436-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.953 0 2.824-.911 5.165-2.733 7.022-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.773-2.734-1.907-3.542-3.401-.809-1.495-1.213-3.314-1.213-5.458Zm5.062.263c0 1.852.44 3.27 1.318 4.254.879.985 1.963 1.477 3.252 1.477 1.29 0 2.371-.492 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.252 1.476-.878.985-1.318 2.403-1.318 4.254Zm30.358 9.334v-2.795a7.202 7.202 0 0 1-2.681 2.356 7.518 7.518 0 0 1-3.507.861c-1.254 0-2.379-.275-3.375-.826-.996-.551-1.717-1.324-2.162-2.32-.445-.996-.668-2.373-.668-4.131v-11.813h4.939v8.578c0 2.625.091 4.234.273 4.826.182.591.513 1.06.993 1.406.481.346 1.09.518 1.828.518.844 0 1.6-.231 2.268-.694.668-.463 1.125-1.037 1.371-1.723.246-.685.369-2.364.369-5.036v-7.875h4.939v18.668h-4.587Zm9.7-25.769h4.939v25.77h-4.939zm27.13 25.769h-4.588v-2.742c-.762 1.066-1.661 1.86-2.698 2.382-1.038.521-2.083.782-3.138.782-2.145 0-3.982-.864-5.511-2.593-1.529-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.569 2.233-7.216 1.488-1.646 3.369-2.47 5.642-2.47 2.086 0 3.891.868 5.414 2.602v-9.281h4.94v25.769Zm-13.184-9.738c0 1.992.276 3.434.826 4.324.797 1.289 1.91 1.934 3.34 1.934 1.137 0 2.104-.484 2.901-1.45.796-.967 1.195-2.412 1.195-4.333 0-2.145-.387-3.689-1.16-4.632-.774-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.466-2.944 1.397-.791.932-1.187 2.323-1.187 4.175Zm28.864 3.797 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.527-.422.926-1.102 1.195-2.039Zm.282-4.992c-.035-1.43-.405-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.177-.703.786-1.049 1.852-1.037 3.2h7.383Zm13.648 10.933h-4.94v-18.668h4.588v2.655c.785-1.254 1.492-2.08 2.118-2.479.627-.398 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.307c-.832-.539-1.606-.809-2.32-.809-.692 0-1.278.191-1.758.571-.481.381-.859 1.07-1.134 2.066-.275.996-.413 3.082-.413 6.258v5.765Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Right Elbow' ? 'bodyParts_group Right_Elbow body_parts_active' : 'bodyParts_group Right_Elbow' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'M586.71 550.18c-2.67 1-5.32 1.08-7.89.27-.68.75-1.39 1.13-2.14 1.13-.13 0-.25-.01-.38-.03l.33-1.97c.02 0 .06.01.11-.01-7.96-4.08-13.07-14.03-16.26-23.55-.33-.97-.63-1.93-.93-2.89-2.71-9.06-3.73-17.13-3.89-18.55-.02-.13-.03-.21-.03-.22l-.33.03c-.22.4-.43.81-.64 1.19l-.73 1.31c.03.19.05.39.08.59.6 4.07 1.97 11.8 4.71 19.78 1.15 3.36 2.55 6.77 4.23 9.96l2.94 1.08c.03.14.55 2.17 1.34 5.63 2.48 3.18 5.39 5.83 8.79 7.53 2.07 1.03 4.18 1.55 6.33 1.55 1.68 0 3.37-.32 5.07-.95 8.92-3.32 16.1-14.55 19.95-21.79.12-.4.25-.81.37-1.21v-.01c.56-1.84 1.12-3.66 1.67-5.45.12-.4.24-.8.36-1.19l-.19-.26c-.1.22-10.47 23.42-22.87 28.03z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'M553.92 506.89c.24-.42.48-.85.73-1.31.21-.38.43-.79.64-1.19l-1.66.17c.02.21.11 1.03.29 2.33zm22.82 42.68c-.05.01-.09.01-.11.01l-.33 1.97c.13.02.26.03.38.03.75 0 1.46-.39 2.14-1.13-.64-.2-1.28-.46-1.91-.78-.06-.03-.12-.06-.17-.1zm-2.38 39.63c.12-.25.26-.51.39-.77-2.02-18.86-5.59-36-7.53-44.5-1.6-2.05-3.02-4.32-4.28-6.71.12.49 7.12 26.87 10.01 55.52.31-1.06.78-2.25 1.41-3.54z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'm565.88 538.3-2.94-1.08c1.26 2.39 2.68 4.66 4.28 6.71-.79-3.46-1.31-5.5-1.34-5.63zm9.27 54.13c2.98-8.32 15.95-24.19 23.11-32.58.17-.75.36-1.5.59-2.24.04-.13.08-.25.12-.39.19-.6.4-1.28.62-1.98-5.25 5.99-19.39 22.55-24.85 33.2.15 1.32.29 2.65.41 3.99zm-2.35.82.2.05-.06-.56c-.04.17-.1.34-.14.51z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'm572.95 592.73.06.56 1.74.43c0-.02.01-.04.02-.06.1-.39.24-.81.39-1.24-.13-1.34-.26-2.67-.4-3.99-.13.26-.27.52-.39.77-.64 1.29-1.11 2.48-1.42 3.53z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyParts', d: 'M574.44 636.84c-2.01 10.89-5.12 21.81-8.85 32.07 5.67-12.29 10.69-22.88 13.1-27.6 12.01-23.55 17.31-55.64 18.74-76 .11-1.51.31-3.01.62-4.49.06-.32.14-.65.22-.97-7.17 8.38-20.14 24.26-23.11 32.58 1.42 15.19 1.72 31.16-.72 44.41zm-40.42 85.7c-5.89 4.53-15.92 9.53-24.58 13.36-6.17 15.6-18.75 37.81-19.61 48.18-1.01 11.98 24.13 49.34 27.29 52.49 4.13 4.14 11.65 3.43 9.66-1.57-2.01-4.99-17.98-32.94-14.98-37.93 2.99-5 15.97-20.98 20.96-18.98s0 24.97 4.99 28.96c5 4 8.92-.01 9.98-7.99 1.06-7.94.4-11.09 2.44-16.21 2.76-6.88.41-12.69-1.38-17.9-1.56-4.56-5.5-8.27-6.88-12.4-1.78-5.35-4.16-14.39-2.17-23.39.8-3.59 6.04-16.1 12.5-30.72-6.26 11.26-12.76 19.9-18.22 24.1z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyParts', d: 'M572.47 636.48c2.35-12.75 2.01-28.25.53-43.18l-.2-.05c.04-.16.1-.34.15-.51-2.89-28.65-9.89-55.02-10.01-55.52-1.68-3.19-3.08-6.6-4.23-9.96-2.74-7.98-4.11-15.71-4.71-19.78-.03-.21-.06-.4-.08-.59-.31.56-.62 1.09-.92 1.59v.01c-1.54 2.66-2.76 4.52-3.52 5.63v.06c-1.26 19.18-2.78 36.32-4.73 39.28 0 0-11.1 18.67-15.24 31.07-3.6 10.81-15.5 136.92-17.71 144.64-.15.51-.31 1.04-.48 1.58-.06.19-.12.37-.19.56-.21.64-.45 1.31-.7 1.99 7.53-3.32 16.35-7.71 22.37-12.34 13.29-10.22 32.85-47.43 39.67-84.48z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'M565.59 668.91c-4.37 9.48-9.12 19.96-13.35 29.54 4.77-8.59 9.41-18.7 13.35-29.54z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyLines', d: 'M575.15 592.43c-.16.43-.29.85-.39 1.24-.01.02-.02.04-.02.06l-1.74-.43c1.47 14.93 1.81 30.43-.53 43.18-6.83 37.05-26.39 74.26-39.67 84.48-6.02 4.63-14.84 9.03-22.37 12.34-.31.85-.64 1.71-.99 2.61 8.65-3.84 18.69-8.84 24.58-13.36 5.46-4.2 11.96-12.84 18.22-24.09 4.23-9.58 8.98-20.06 13.35-29.54 3.73-10.26 6.84-21.18 8.85-32.07 2.44-13.26 2.14-29.23.71-44.42z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Elbow');
	            }, className: 'bodyParts', d: 'M587.41 552.06c-1.7.63-3.39.95-5.07.95-2.15 0-4.26-.52-6.33-1.55-3.41-1.7-6.31-4.35-8.79-7.53 1.94 8.5 5.51 25.64 7.53 44.5 5.46-10.65 19.6-27.21 24.85-33.2 1.88-5.99 4.84-15.51 7.76-24.97-3.85 7.25-11.03 18.48-19.95 21.8z' }),
	          this.state.bodyTitle === 'Right Elbow' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '155', y: '594', width: '225', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup is_right' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M405 616.324h130' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M174.444 625.421v-25.77h10.951c2.754 0 4.755.232 6.003.695 1.248.463 2.247 1.286 2.997 2.469.75 1.184 1.125 2.537 1.125 4.061 0 1.934-.568 3.53-1.705 4.79-1.137 1.26-2.836 2.054-5.098 2.382 1.125.656 2.054 1.377 2.786 2.162.733.785 1.72 2.18 2.962 4.183l3.147 5.028h-6.223l-3.762-5.608c-1.335-2.003-2.25-3.266-2.742-3.788-.492-.521-1.013-.879-1.564-1.072-.551-.193-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.054-.106 4.675-.317a2.8 2.8 0 0 0 1.459-1.09c.352-.515.528-1.16.528-1.933 0-.867-.232-1.567-.695-2.101-.462-.533-1.116-.87-1.96-1.01-.421-.059-1.687-.088-3.796-.088h-4.061v6.539Zm20.742-6.328v-4.571h4.94v4.571h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.23 5.643.686c.093.656.31 1.107.65 1.353.469.352 1.207.528 2.215.528 1.289 0 2.256-.194 2.9-.58.434-.258.762-.674.985-1.248.152-.411.228-1.166.228-2.268v-2.725c-1.476 2.016-3.34 3.024-5.59 3.024-2.507 0-4.494-1.061-5.959-3.182-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.753-5.519 2.259-7.171 1.505-1.653 3.377-2.479 5.616-2.479 2.308 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.849-.545 4.939-.364 1.09-.873 1.946-1.53 2.567-.656.621-1.532 1.107-2.627 1.459-1.096.351-2.482.527-4.158.527-3.164 0-5.408-.542-6.732-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.005-.363.017-.598Zm4.412-10.951c0 1.981.384 3.431 1.152 4.351.767.92 1.713 1.38 2.838 1.38 1.207 0 2.227-.472 3.059-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.024-1.407-1.183 0-2.159.46-2.926 1.38-.768.92-1.152 2.323-1.152 4.21Zm22.957-16.049v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.958-.093-3.2-.281-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.821 0-1.553.2-2.197.598-.645.398-1.117.999-1.415 1.802-.299.802-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm25.629 7.102v3.937h-3.375v7.524c0 1.523.032 2.411.097 2.663.064.252.211.46.439.624.229.164.507.246.835.246.457 0 1.119-.158 1.987-.475l.421 3.832c-1.148.493-2.449.739-3.902.739-.891 0-1.693-.15-2.408-.449-.715-.298-1.239-.685-1.573-1.16-.334-.474-.566-1.116-.695-1.924-.105-.575-.158-1.735-.158-3.481v-8.139h-2.267v-3.937h2.267v-3.709l4.957-2.883v6.592h3.375Zm13.465 18.668v-25.77h19.107v4.36H281.6v5.713h12.938v4.341H281.6v7.014h14.397v4.342h-19.6Zm23.977-25.77h4.939v25.77h-4.939zm9.791 25.77v-25.77h4.939v9.282c1.523-1.735 3.328-2.602 5.414-2.602 2.274 0 4.154.823 5.643 2.47 1.488 1.646 2.232 4.01 2.232 7.092 0 3.188-.759 5.643-2.276 7.366-1.518 1.722-3.361 2.584-5.529 2.584-1.066 0-2.118-.267-3.155-.8s-1.931-1.321-2.681-2.364v2.742h-4.587Zm4.904-9.738c0 1.933.305 3.363.914 4.289.855 1.312 1.992 1.968 3.41 1.968 1.09 0 2.019-.465 2.786-1.397.768-.932 1.152-2.4 1.152-4.403 0-2.133-.387-3.671-1.161-4.615-.773-.943-1.763-1.415-2.97-1.415-1.184 0-2.168.46-2.953 1.38-.786.92-1.178 2.318-1.178 4.193Zm16.154.14c0-1.64.404-3.228 1.213-4.763.809-1.536 1.954-2.708 3.437-3.516 1.482-.809 3.137-1.213 4.965-1.213 2.825 0 5.139.917 6.944 2.751 1.804 1.834 2.707 4.151 2.707 6.952 0 2.824-.911 5.165-2.734 7.023-1.822 1.857-4.116 2.786-6.881 2.786-1.711 0-3.343-.387-4.896-1.16-1.553-.774-2.733-1.908-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.063.264c0 1.851.439 3.269 1.318 4.254.879.984 1.963 1.476 3.252 1.476 1.289 0 2.37-.492 3.243-1.476.873-.985 1.31-2.414 1.31-4.289 0-1.828-.437-3.235-1.31-4.219-.873-.984-1.954-1.477-3.243-1.477s-2.373.493-3.252 1.477c-.879.984-1.318 2.402-1.318 4.254Zm21.55 9.334-5.906-18.668h4.799l3.498 12.234 3.217-12.234h4.764l3.111 12.234 3.568-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Left Elbow' ? 'bodyParts_group Left_Elbow body_parts_active' : 'bodyParts_group Left_Elbow' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Elbow');
	            }, className: 'bodyParts', d: 'M946.52 507.5c-.59 4.08-1.97 11.78-4.7 19.75-1.15 3.36-2.55 6.76-4.23 9.95-.3.58-.62 1.14-.94 1.7-1.75 6.81-15.86 63.26-9.35 98.57 6.83 37.05 26.39 74.26 39.67 84.48 6.21 4.78 15.41 9.31 23.09 12.66-.43-1.13-.83-2.22-1.17-3.26v-.12c-.08-.17-.15-.29-.21-.5-.17-.54-.33-1.06-.48-1.57-2.21-7.72-14.11-133.83-17.71-144.64-4.13-12.4-15.24-31.07-15.24-31.07-1.95-2.96-3.47-20.11-4.72-39.28l-.03-.4c-.64-.9-2.07-3-3.98-6.27 0-.01 0 0 0 0zm-21.62 83.07c2-19.37 5.7-37.08 7.67-45.73-2.31 2.77-4.98 5.08-8.06 6.62-2.06 1.03-4.18 1.55-6.32 1.55-1.68 0-3.37-.32-5.08-.95-8.19-3.05-15.68-12.78-19.9-19.96 3.06 9.96 6.12 19.75 7.8 25.12v.01c.04.14.08.25.12.38.08.26.15.52.22.78 6.36 7.37 18.76 22.3 23.37 31.83.07.12.12.23.18.35z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Elbow');
	            }, className: 'bodyParts', d: 'm924.5 594.69-.15.04c0-.01-.01-.03-.01-.04-1.86-7.4-14.33-22.99-22.09-32.16.14.92.26 1.85.32 2.78 1.43 20.36 6.72 52.45 18.74 76 2.07 4.06 6.08 12.48 10.77 22.58-2.8-8.46-5.14-17.26-6.76-26.05-2.36-12.89-2.14-28.34-.82-43.15zm85.67 189.4c-.83-10.08-12.73-31.33-19.07-46.84-8.82-3.88-19.29-9.04-25.35-13.71-4.66-3.58-10.06-10.38-15.43-19.28 5.24 12.04 9.25 21.81 9.94 24.91 1.99 9-.38 18.04-2.17 23.39-1.37 4.13-5.32 7.84-6.88 12.4-1.79 5.21-4.13 11.02-1.37 17.9 2.04 5.12 1.37 8.27 2.43 16.21 1.06 7.98 4.99 11.99 9.98 7.99 4.99-3.99 0-26.96 4.99-28.96 5-2 17.98 13.98 20.96 18.98 3 4.99-12.97 32.94-14.97 37.93-1.99 5 5.53 5.71 9.66 1.57 3.15-3.15 28.29-40.51 27.28-52.49z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Elbow');
	            }, className: 'bodyLines', d: 'M950.32 704.26c-5.51-12.66-12.39-27.82-18.23-40.38 5.05 15.27 11.61 29.42 18.23 40.38z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Elbow');
	            }, className: 'bodyLines', d: 'M965.75 723.54c6.06 4.66 16.53 9.83 25.35 13.71-.37-.9-.72-1.78-1.04-2.63-7.68-3.35-16.88-7.88-23.09-12.66-13.29-10.22-32.84-47.43-39.67-84.48-6.5-35.31 7.6-91.76 9.35-98.57-1.22 2.13-2.57 4.13-4.08 5.94-1.97 8.64-5.67 26.36-7.67 45.73.65 1.35 1.13 2.59 1.39 3.68l-1.79.44c-1.32 14.81-1.54 30.26.83 43.15 1.62 8.79 3.96 17.59 6.76 26.05 5.83 12.56 12.71 27.72 18.23 40.38 5.37 8.88 10.77 15.68 15.43 19.26zm-41.4-128.81.15-.04c.12-1.38.26-2.75.4-4.12-.06-.12-.11-.23-.17-.35-4.61-9.54-17.01-24.47-23.37-31.83.23.81.44 1.63.61 2.44v.01c.11.56.2 1.12.29 1.69 7.76 9.18 20.22 24.77 22.09 32.16-.01.01 0 .03 0 .04z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Elbow');
	            }, className: 'bodyLines', d: 'M926.29 594.25c-.27-1.08-.74-2.33-1.39-3.68-.14 1.37-.27 2.74-.4 4.12l1.79-.44z' }),
	          this.state.bodyTitle === 'Left Elbow' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '592', width: '195', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M964.206 612.527h130' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1120.17 625.421v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.62-5.942 4.922.827c-.633 1.804-1.632 3.178-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.434 0-3.093.808-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429H1145.6c.036 1.465.434 2.604 1.196 3.419.761.814 1.711 1.221 2.847 1.221.774 0 1.424-.211 1.951-.633.528-.421.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.567-1.117-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.852-1.037 3.199h7.383Zm6.769-7.734h2.742v-1.406c0-1.571.167-2.743.501-3.516.334-.773.949-1.403 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.633l-.668 3.445a9.729 9.729 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.975-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.71 0v3.937h-3.375v7.524c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.149.493-2.449.739-3.902.739-.891 0-1.694-.15-2.409-.449-.715-.298-1.239-.685-1.573-1.16-.334-.474-.565-1.116-.694-1.924-.106-.575-.158-1.735-.158-3.481v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm13.47 18.668v-25.77h19.108v4.36h-13.904v5.713h12.937v4.341h-12.937v7.014h14.396v4.342h-19.6Zm23.97-25.77h4.939v25.77h-4.939zm9.79 25.77v-25.77h4.939v9.282c1.524-1.735 3.329-2.602 5.415-2.602 2.273 0 4.154.823 5.642 2.47 1.488 1.646 2.233 4.01 2.233 7.092 0 3.188-.759 5.643-2.277 7.366-1.517 1.722-3.36 2.584-5.528 2.584-1.067 0-2.118-.267-3.155-.8-1.038-.533-1.931-1.321-2.681-2.364v2.742h-4.588Zm4.904-9.738c0 1.933.305 3.363.914 4.289.856 1.312 1.993 1.968 3.411 1.968 1.089 0 2.018-.465 2.786-1.397.767-.932 1.151-2.4 1.151-4.403 0-2.133-.387-3.671-1.16-4.615-.774-.943-1.764-1.415-2.971-1.415-1.183 0-2.168.46-2.953 1.38-.785.92-1.178 2.318-1.178 4.193Zm16.156.14c0-1.64.404-3.228 1.212-4.763.809-1.536 1.955-2.708 3.437-3.516 1.482-.809 3.138-1.213 4.966-1.213 2.824 0 5.138.917 6.943 2.751 1.805 1.834 2.707 4.151 2.707 6.952 0 2.824-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.896-1.16-1.552-.774-2.733-1.908-3.542-3.402-.808-1.494-1.212-3.313-1.212-5.458Zm5.062.264c0 1.851.44 3.269 1.318 4.254.879.984 1.963 1.476 3.252 1.476 1.289 0 2.371-.492 3.244-1.476.873-.985 1.309-2.414 1.309-4.289 0-1.828-.436-3.235-1.309-4.219-.873-.984-1.955-1.477-3.244-1.477-1.289 0-2.373.493-3.252 1.477-.878.984-1.318 2.402-1.318 4.254Zm21.548 9.334-5.906-18.668h4.798l3.498 12.234 3.217-12.234h4.764l3.111 12.234 3.569-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Right Thigh' ? 'bodyParts_group Right_Thigh body_parts_active' : 'bodyParts_group Right_Thigh' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M653.56 979.22c0 .02.02.11.05.26.08.08.15.18.23.26.71.71 1.44 1.41 2.2 2.08-.27-1.67-.47-2.72-.52-2.98l-1.96.38zm34.38-9.96c0-.03.01-.05.01-.08l-1.97-.33c-.16.95-.5 3.09-.93 6.05.97-1.62 1.93-3.51 2.88-5.61v-.01c.01-.01.01-.02.01-.02zm13.78-226.02c-.02-.02-.04-.04-.05-.06a1.44 1.44 0 0 1-.15-.22c.15.22.23.35.25.37l.02-.01c-.03-.03-.05-.05-.07-.08zm-22.08-32.61zm21.82 32.25.06.08c-.02-.02-.04-.05-.06-.08zm39.27 53.1c.01-.43 0-.92 0-1.13 0-2.73-3.63-7.27-9.18-13.89-2.42-2.89-4.7-5.61-6.1-7.71-3.68-5.51-19.56-27.64-22.04-31.09-.01-.01-.01-.01-.01-.02.05.1.09.18.09.19l-1.71 1c2.44 3.39 18.35 25.55 22.01 31.04 1.46 2.19 3.78 4.96 6.23 7.89 3.88 4.63 8.71 10.39 8.71 12.6 0 .97-.07 3.03-.2 5.78.53-3.47.9-5.55.9-5.55s.61.47 1.3.89zm-61.1-85.36c.01 0 0 0 0 0zm4.7 6.92c-1.74-4.52-2.84-7.63-2.87-7.72l-1.88.66c.01.03.03.07.05.13l.01.01c1.57 2.32 3.15 4.64 4.7 6.93l-.01-.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'm703.08 741.71-1.62 1.17.06.09c.04.05.08.12.15.22.01.02.03.04.05.06.02.03.04.05.06.08l1.71-1c-.01-.01-.04-.08-.09-.19 0-.01-.01-.01-.01-.02-.19-.26-.3-.39-.31-.41zM665.2 689.2c.01.06.02.15.03.25 1.09 1.59 2.29 3.35 3.58 5.23-1.07-3.81-1.63-5.8-1.65-5.86l-1.96.38zm4.72 27.63-1.52-1.3c-.01.01-.06.07-.15.18.11.89.22 1.8.33 2.73.83-1 1.31-1.57 1.34-1.61z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyParts', d: 'M683.61 755.05c-6.93-24.82-12.01-42.96-15.05-53.81 3.33 28.77 12.12 99.68 19.95 119.25 7.94 19.85 20.04 73.79 26.54 102.77 1.69 7.53 2.91 12.98 3.54 15.49 2.29 9.16 2.29 27.1 2.15 35.63 1.89-8.56 4.41-18.16 5.74-23.48 2.22-8.85 3.86-21.41 5.07-34.91-1.92-9.77-6.36-30.11-12.86-46.71-7.4-18.89-19.19-57.32-35.08-114.23zm-70.16 67.17v.34c.04-.03.08-.07.12-.1l-.12-.24z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M724.59 803.6c-2.13-8.51-17.15-43.35-25.19-54.41-5.26-7.22-11.5-22.36-15.06-31.62v-.01a4387.9 4387.9 0 0 0-4.7-6.93c0 .01.01.02.01.03.91 2.6 10.37 29.03 18.13 39.71 7.75 10.65 22.82 45.53 24.87 53.71.52 2.08 1.43 6.32 2.49 11.22 5.72 26.56 7.73 34.05 9.36 34.83.06.03.12.05.19.07.02-1.25.03-2.39.03-3.45-1.94-5.46-5.56-22.25-7.63-31.87-1.06-4.92-1.97-9.17-2.5-11.28z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyParts', d: 'M716.64 939.23c-.63-2.53-1.86-7.98-3.55-15.53-1.65-7.37-3.67-16.35-5.88-25.97-2.58 13.46-10.42 51.88-19.28 71.56-2.58 15.79-7.73 57.57-.74 63.01 8.41 6.54 24.18-1.09 24.34-1.17l.21.43c2.7-16.83 6.06-38.89 6.73-44.78.06-.52.13-1.06.21-1.64.16-8.88.41-36.11-2.04-45.91zm8.5-123.93c-1.06-4.9-1.97-9.14-2.49-11.22-2.05-8.18-17.12-43.06-24.87-53.71-7.76-10.68-17.22-37.11-18.13-39.71 0-.01-.01-.02-.01-.03v-.01l-.01-.01v-.01c-3.81-5.62-7.58-11.17-10.83-15.93 2.62 9.32 8.31 29.62 16.74 59.83 15.86 56.84 27.64 95.21 35.01 114.03 6.9 17.63 10.32 34.25 11.53 41.04 1.76-22.32 2.43-46.01 2.61-59.35v-.04c-.06-.02-.13-.04-.19-.07-1.63-.76-3.64-8.25-9.36-34.81z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyParts', d: 'M730.02 782.25c-2.45-2.93-4.77-5.7-6.23-7.89-3.66-5.49-19.57-27.64-22.01-31.04l-.02.01c-.01-.02-.1-.15-.25-.37-.03-.05-.05-.08-.06-.08-1.57-2.32-8.95-13.25-17.12-25.31v.01c3.56 9.26 9.8 24.4 15.06 31.62 8.04 11.06 23.06 45.9 25.19 54.41.53 2.11 1.44 6.36 2.5 11.28 2.07 9.62 5.69 26.41 7.63 31.87v-.58c.01-1.01.01-1.91.01-2.71 0-14.31 2.01-30.6 3.4-40.16v-.05l.39-2.62c.13-2.75.2-4.81.2-5.78.02-2.22-4.81-7.98-8.69-12.61zm-80.89 255.86c12.02-15.07 5.13-55.05 4.48-58.63-5.19-5.52-7.71-19.38-11.84-42.14-.69-3.83-1.43-7.89-2.23-12.19-4.97-26.7-18.24-94.24-21.09-108.73v.01c-1.56 2.94-3.59 4.94-4.88 6.03.08.18.13.36.13.54l-.26.08c-.76 42.15-2.01 99.96 6.18 132.75 5.92 23.65 11.26 49.05 14.92 67.44 1.34 6.74 2.19 13.56 2.55 20.4 4.36-.41 9.42-2.28 12.04-5.56zm19.12-322.4c-1.7-13.98-2.8-24.18-3.03-26.26-.52-.76-1.02-1.49-1.49-2.17-11.5-16.72-14.3-29.15-16.18-40.45l-.09-.62c.04.37.06.74.1 1.1.1.74.16 1.49.2 2.25-.01.01 0 .02 0 .03.61 14.67-10.64 33.22-16.33 46.5-5.99 13.98-18.8 55.05-17.81 91 .23 8.34.09 19.54-.14 32.36 3.35-5.41 11.21-18.63 17.07-39.9 7.69-27.85 35.39-61.11 37.7-63.84z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyParts', d: 'M632.48 780.08c-4.18 15.15-8.95 26.31-12.55 33.49 1.09 5.53 16.2 82.3 21.58 111.21.8 4.3 1.54 8.37 2.23 12.2 3.97 21.93 6.6 36.42 11.51 41.34 5.94 5.94 12.3 10.41 24.68-.06 12.29-10.4 25.41-81.28 26.16-85.4-6.29-27.07-13.9-57.78-19.44-71.63-6.73-16.81-13.95-69.24-18.07-102.79-5.85 7.14-29.21 36.67-36.1 61.64z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M685.54 754.52c-8.43-30.21-14.12-50.51-16.74-59.83-1.29-1.88-2.49-3.64-3.58-5.23.22 2.08 1.33 12.28 3.03 26.26.09-.11.14-.17.15-.18l1.52 1.3c-.03.04-.51.61-1.34 1.61 4.12 33.55 11.34 85.98 18.07 102.79 5.54 13.85 13.15 44.56 19.44 71.63.02-.1.03-.18.04-.19l1.97.35c-.07.41-.38 2.09-.88 4.7 2.21 9.62 4.23 18.61 5.88 25.97 1.69 7.55 2.92 13 3.55 15.53 2.45 9.8 2.19 37.03 2.03 45.91.25-1.8.62-3.86 1.06-6.09.22-1.08.45-2.2.7-3.34.09-.44.19-.89.29-1.33.15-8.53.14-26.48-2.15-35.63-.63-2.51-1.85-7.95-3.54-15.49-6.5-28.98-18.59-82.92-26.54-102.77-7.83-19.57-16.62-90.48-19.95-119.25 3.04 10.85 8.12 28.99 15.05 53.81 15.88 56.91 27.68 95.33 35.07 114.22 6.49 16.6 10.93 36.94 12.86 46.71l.27-3.09c.07-.76.13-1.52.19-2.28v-.01c.03-.34.05-.68.08-1.02-1.22-6.79-4.63-23.41-11.53-41.04-7.36-18.82-19.14-57.18-35-114.02zm-71.97 67.94c-.04.04-.08.07-.12.1 0 .15 0 .29-.01.44v.08l.26-.08c0-.18-.05-.36-.13-.54z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M618.45 816.43s0-.01 0 0c-.33-1.71-.52-2.69-.54-2.78l1.96-.39c.01.03.03.13.06.31 3.6-7.19 8.37-18.35 12.55-33.49 6.89-24.97 30.25-54.5 36.1-61.64-.11-.92-.22-1.83-.33-2.73-2.31 2.73-30.01 35.99-37.69 63.84-5.86 21.27-13.72 34.5-17.07 39.9-.01.41-.01.81-.02 1.23-.01.51-.01 1.03-.02 1.54l.12.24c1.29-1.09 3.32-3.09 4.88-6.03z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M679.93 978.27c-12.37 10.47-18.73 6-24.68.06-4.91-4.91-7.54-19.4-11.51-41.34-.69-3.83-1.43-7.9-2.23-12.2-5.38-28.91-20.49-105.69-21.58-111.21v.01c-.52 1.03-1.01 1.97-1.48 2.84 2.85 14.49 16.12 82.03 21.09 108.73.8 4.3 1.54 8.36 2.23 12.19 4.12 22.76 6.64 36.61 11.84 42.14-.03-.15-.04-.24-.05-.26l1.96-.38c.05.25.25 1.31.52 2.98 2.98 2.62 6.38 4.72 10.65 4.72 3.98 0 8.71-1.82 14.52-6.75 1.28-1.08 2.56-2.76 3.83-4.89.43-2.96.77-5.1.93-6.05l1.97.33c0 .03-.01.05-.01.08 0 0 0 .01-.01.02v.01c8.87-19.68 16.7-58.1 19.28-71.56-.37-1.6-.74-3.23-1.12-4.86-.74 4.1-13.86 74.99-26.15 85.39zm28.16-85.25-1.97-.35c0 .02-.02.09-.04.19.38 1.63.76 3.26 1.12 4.86.51-2.6.82-4.28.89-4.7z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Thigh');
	            }, className: 'bodyLines', d: 'M619.93 813.57c-.04-.18-.06-.28-.06-.31l-1.96.39c.02.09.21 1.07.55 2.77.46-.87.95-1.81 1.47-2.85 0 .01 0 .01 0 0z' }),
	          this.state.bodyTitle === 'Right Thigh' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '165', y: '861', width: '215', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup is_right' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M405 883.94h220' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M184.565 893.037v-25.77h10.951c2.754 0 4.755.232 6.003.695 1.248.463 2.247 1.286 2.997 2.47.75 1.183 1.125 2.537 1.125 4.06 0 1.934-.568 3.53-1.705 4.79-1.137 1.26-2.836 2.054-5.097 2.382 1.125.656 2.053 1.377 2.786 2.162.732.785 1.719 2.18 2.962 4.184l3.146 5.027h-6.223l-3.761-5.607c-1.336-2.004-2.25-3.267-2.743-3.789-.492-.521-1.013-.878-1.564-1.072-.551-.193-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.871h3.85c2.496 0 4.055-.106 4.676-.317a2.801 2.801 0 0 0 1.459-1.089c.351-.516.527-1.161.527-1.934 0-.867-.232-1.567-.694-2.101-.463-.533-1.117-.87-1.96-1.01-.422-.059-1.688-.088-3.797-.088h-4.061v6.539Zm20.742-6.328v-4.571h4.94v4.571h-4.94Zm0 21.199v-18.668h4.94v18.668h-4.94Zm9.545 1.23 5.643.686c.094.656.31 1.107.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.194 2.901-.58.433-.258.761-.674.984-1.248.152-.41.228-1.166.228-2.268v-2.724c-1.476 2.015-3.339 3.023-5.589 3.023-2.508 0-4.495-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.657.621-1.533 1.107-2.628 1.459-1.096.351-2.482.527-4.158.527-3.164 0-5.408-.542-6.732-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.598Zm4.412-10.951c0 1.981.384 3.431 1.152 4.351.767.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.023-1.407-1.184 0-2.16.46-2.927 1.38-.768.92-1.152 2.324-1.152 4.21Zm22.957-16.049v9.475c1.594-1.863 3.499-2.795 5.713-2.795 1.137 0 2.162.211 3.077.633.914.422 1.602.961 2.065 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.474-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.116.999-1.415 1.802-.299.803-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm25.629 7.102v3.938h-3.375v7.523c0 1.523.033 2.411.097 2.663.065.252.211.46.44.624.228.164.506.246.834.246.457 0 1.12-.158 1.987-.474l.422 3.832c-1.149.492-2.45.738-3.903.738-.89 0-1.693-.15-2.408-.448-.715-.299-1.239-.686-1.573-1.161-.334-.474-.566-1.116-.694-1.924-.106-.575-.159-1.735-.159-3.481v-8.138h-2.267v-3.938h2.267v-3.709l4.957-2.883v6.592h3.375Zm19.266 18.668v-21.41h-7.646v-4.36h20.478v4.36h-7.629v21.41h-5.203Zm21.076-25.77v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.093-3.2-.281-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.821 0-1.553.2-2.198.598-.644.399-1.116.999-1.415 1.802-.298.803-.448 1.989-.448 3.559v9.352h-4.939v-25.77h4.939Zm17.069 4.571v-4.571h4.939v4.571h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.544 1.23 5.643.686c.094.656.311 1.107.65 1.354.469.351 1.207.527 2.215.527 1.289 0 2.256-.194 2.901-.58.433-.258.761-.674.984-1.248.152-.41.229-1.166.229-2.268v-2.724c-1.477 2.015-3.34 3.023-5.59 3.023-2.508 0-4.494-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.182 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.656.621-1.532 1.107-2.628 1.459-1.096.351-2.482.527-4.157.527-3.164 0-5.409-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.017-.598Zm4.413-10.951c0 1.981.383 3.431 1.151 4.351.768.92 1.714 1.38 2.839 1.38 1.207 0 2.226-.472 3.058-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.398-3.369-1.195-4.306-.797-.938-1.805-1.407-3.023-1.407-1.184 0-2.159.46-2.927 1.38-.768.92-1.151 2.324-1.151 4.21Zm22.957-16.049v9.475c1.593-1.863 3.498-2.795 5.712-2.795 1.137 0 2.163.211 3.077.633.914.422 1.602.961 2.065 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.474-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.559v9.352h-4.94v-25.77h4.94Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Left Thigh' ? 'bodyParts_group Left_Thigh body_parts_active' : 'bodyParts_group Left_Thigh' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'M845 978.84c-.05.25-.25 1.31-.52 2.98.76-.67 1.49-1.37 2.2-2.08.08-.08.15-.18.23-.26.03-.15.04-.24.05-.26l-1.96-.38zm-32.43-9.66c0 .03.01.06.01.09.95 2.12 1.92 4.02 2.89 5.65-.43-2.96-.78-5.11-.93-6.06l-1.97.32zm-13.81-225.85c.01-.02.08-.12.21-.31-.06.07-.13.17-.23.3l.02.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'm797.03 742.33 1.71.99c.1-.13.17-.23.23-.3.05-.08.08-.13.09-.14l-1.62-1.17c-.01.02-.12.15-.31.41 0 .01-.01.03-.02.04-.05.1-.08.16-.08.17z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'M762.12 803.25c-.21-4.07-.33-7.14-.33-8.4 0-2.21 4.83-7.97 8.71-12.6 2.46-2.93 4.78-5.7 6.24-7.89 3.66-5.49 19.57-27.66 22-31.04l-1.71-.99c0-.01.03-.07.08-.17-2.48 3.45-18.36 25.58-22.04 31.09-1.39 2.1-3.68 4.82-6.1 7.71-5.54 6.62-9.18 11.16-9.18 13.89 0 .17.01.44.02.78.5-.32.76-.55.76-.55s.89 8.51 1.55 8.17zm68.48-86.42c.04.04.52.61 1.34 1.62.12-.93.23-1.84.34-2.74-.1-.11-.15-.17-.16-.18l-1.52 1.3z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyParts', d: 'M794.43 892.83c.69 3.8 13.85 75.01 26.17 85.43 12.37 10.47 18.73 6 24.68.06 4.91-4.91 7.54-19.4 11.51-41.34.69-3.83 1.43-7.9 2.23-12.2 5.38-28.92 20.49-105.69 21.58-111.21-3.6-7.19-8.37-18.34-12.55-33.49-6.88-24.96-30.22-54.48-36.1-61.63-4.12 33.55-11.34 85.97-18.07 102.78-5.55 13.85-13.16 44.54-19.45 71.6z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyParts', d: 'M781.94 938.74c.63-2.5 1.85-7.94 3.54-15.47 6.5-28.98 18.59-82.93 26.54-102.78 7.83-19.57 16.61-90.48 19.94-119.25-3.04 10.85-8.12 28.99-15.05 53.81-15.88 56.9-27.68 95.33-35.07 114.22-8.86 22.64-12.82 51.92-12.86 52.16 1.15 11.4 2.63 21.82 4.54 29.47 1.4 5.6 4.12 15.93 6.03 24.81v.02c.08.36.15.71.23 1.07-.12-9.11-.08-29.09 2.16-38.06zm53.36-249.29c-.22 2.09-1.32 12.29-3.02 26.26 2.29 2.72 30 35.99 37.69 63.84 6.17 22.39 13.6 35.87 16.56 40.69-.24-13.15-.39-24.64-.15-33.15.99-35.95-11.82-77.02-17.81-91-5.5-12.83-16.19-30.59-16.36-45.01-1.95 10.19-5.34 21.55-15.42 36.2-.47.68-.97 1.41-1.49 2.17zm46.77 126.99c-2.86 14.52-16.13 82.02-21.09 108.71-.8 4.3-1.54 8.36-2.23 12.19-4.12 22.76-6.64 36.61-11.84 42.14-.65 3.58-7.54 43.56 4.48 58.63 2.71 3.4 7.16 5.26 11.53 5.59.36-6.85 1.2-13.67 2.55-20.43 3.66-18.39 9-43.79 14.92-67.44 8.19-32.76 6.94-90.5 6.18-132.65l-.36.26c-.04-.06-1.68-2.38-4.14-7z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyParts', d: 'M813.33 1032.3c6.99-5.44 1.85-47.26-.75-63.03-8.86-19.69-16.69-58.09-19.27-71.54v.01c-2.22 9.63-4.23 18.61-5.88 25.98-1.69 7.54-2.92 12.99-3.55 15.52-2.64 10.57-2.07 44.16-1.92 50.96 1.13 8.34 3.8 25.75 6.09 39.97.96.47 17.09 8.5 25.28 2.13zm-47.64-185.25c1.92-5.13 5.63-22.37 7.74-32.18 1.06-4.92 1.98-9.17 2.51-11.27 2.12-8.51 17.14-43.35 25.18-54.41 5.26-7.22 11.49-22.34 15.05-31.6-8.17 12.05-15.55 22.98-17.11 25.29-.01.01-.04.06-.09.14-.13.19-.2.29-.21.31l-.02-.01c-2.43 3.38-18.34 25.55-22 31.04-1.46 2.19-3.78 4.96-6.24 7.89-3.88 4.63-8.71 10.39-8.71 12.6 0 1.26.12 4.33.33 8.4-.73-5.02-1.29-8.17-1.29-8.17s-.08.07-.23.18c.13.73.63 3.66 1.26 7.99v.05c1.39 9.56 3.4 25.85 3.4 40.16 0 .8 0 1.7.01 2.71 0 .4.01.83.01 1.26.14-.44.25-.86.25-1.26.06.32.11.62.16.88z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyParts', d: 'M768.26 910.59c1.05-6.03 4.46-23.49 11.72-42.04 7.37-18.83 19.14-57.2 35-114.03 8.43-30.2 14.12-50.5 16.74-59.83-3.24 4.75-7.01 10.3-10.82 15.92-.83 2.33-10.35 29.02-18.16 39.76-7.74 10.65-22.82 45.53-24.86 53.71-.52 2.08-1.43 6.31-2.49 11.21-5.72 26.57-7.74 34.06-9.36 34.84-.07.03-.39.06-.71.08v.03c.17 13.54.87 37.75 2.68 60.35 0 0 .01.02 0 .02.03.27.05.55.07.83.09-.35.16-.64.19-.83.01 0 0-.02 0-.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'M775.39 815.29c1.06-4.9 1.97-9.13 2.49-11.21 2.04-8.18 17.12-43.06 24.86-53.71 7.81-10.74 17.33-37.43 18.16-39.76-1.58 2.33-3.17 4.67-4.73 6.98-3.56 9.26-9.79 24.38-15.05 31.6-8.04 11.06-23.06 45.9-25.18 54.41-.53 2.1-1.45 6.35-2.51 11.27-2.11 9.81-8.01 32.13-8.15 32.56.01.87.02 1.79.04 2.78.32-.02.64-.05.71-.08 1.62-.78 3.64-8.27 9.36-34.84zm8.49 123.94c.63-2.53 1.86-7.98 3.55-15.52 1.65-7.37 3.66-16.35 5.88-25.98v-.01c-.5-2.61-.8-4.28-.88-4.7l1.97-.35c0 .02.01.08.03.16 6.29-27.06 13.9-57.75 19.44-71.6 6.73-16.81 13.95-69.23 18.07-102.78-.82-1.01-1.3-1.58-1.34-1.62l1.52-1.3c.01.01.06.07.16.18 1.7-13.97 2.8-24.17 3.02-26.26-1.09 1.59-2.29 3.35-3.58 5.24-2.62 9.33-8.31 29.63-16.74 59.83-15.86 56.83-27.63 95.2-35 114.03-7.26 18.55-10.67 36.01-11.72 42.04 0 0 .01.02 0 .02-.03.19-.1.48-.19.83.04.49.08.98.13 1.46.24 2.89.5 5.74.79 8.53.03-.24 4-29.52 12.86-52.16 7.39-18.89 19.19-57.32 35.07-114.22 6.93-24.82 12.01-42.96 15.05-53.81-3.33 28.77-12.11 99.68-19.94 119.25-7.95 19.85-20.04 73.8-26.54 102.78-1.69 7.53-2.91 12.97-3.54 15.47-2.24 8.97-2.29 28.96-2.15 38.06l.03.15v-1.22c.25 1.14.48 3.25.7 4.32l.15 1.14c.39 2.09.69 3.99.86 5.59.09.83.24 1.99.43 3.41-.15-6.8-.73-40.39 1.91-50.96z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'M832.28 715.71c-.11.9-.22 1.81-.34 2.74 5.88 7.15 29.22 36.67 36.1 61.63 4.18 15.15 8.95 26.3 12.55 33.49.04-.18.06-.28.06-.31l1.96.39c-.02.09-.21 1.07-.55 2.78 2.46 4.62 4.1 6.94 4.14 7l.36-.26v-.18l-.03-2.32c0-.15-.01-.29-.01-.44-2.96-4.82-10.39-18.3-16.56-40.69-7.68-27.84-35.39-61.11-37.68-63.83zm24.5 221.28c-3.97 21.93-6.6 36.43-11.51 41.34-5.94 5.94-12.3 10.41-24.68-.06-12.32-10.42-25.47-81.64-26.17-85.43v.02c-.37 1.64-.75 3.26-1.12 4.87 2.58 13.45 10.41 51.86 19.27 71.54 0-.03-.01-.06-.01-.09l1.97-.32c.16.95.5 3.1.93 6.06 1.27 2.13 2.55 3.8 3.83 4.88 5.82 4.92 10.54 6.75 14.52 6.75 4.27 0 7.68-2.1 10.65-4.72.27-1.67.47-2.73.52-2.98l1.96.38c0 .02-.02.11-.05.26 5.2-5.52 7.71-19.38 11.84-42.14.69-3.83 1.43-7.89 2.23-12.19 4.96-26.69 18.23-94.2 21.09-108.72-.46-.87-.96-1.82-1.48-2.86-1.09 5.53-16.2 82.3-21.58 111.21-.78 4.3-1.51 8.37-2.21 12.2z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Thigh');
	            }, className: 'bodyLines', d: 'M794.43 892.84s0-.01 0 0c-.01-.09-.03-.15-.03-.17l-1.97.35c.07.41.38 2.09.88 4.7.37-1.61.75-3.23 1.12-4.87v-.01zm88.19-79.19-1.96-.39c-.01.03-.03.13-.06.31.52 1.04 1.02 1.99 1.48 2.86.33-1.71.52-2.69.54-2.78z' }),
	          this.state.bodyTitle === 'Left Thigh' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '861', width: '185', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M874.206 883.721h220' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1119.95 893.037v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.63-5.941 4.922.826c-.633 1.804-1.632 3.178-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.433 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.036 1.465.434 2.604 1.196 3.419.761.814 1.711 1.221 2.847 1.221.774 0 1.424-.21 1.951-.632.528-.422.926-1.102 1.196-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.567-1.117-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.852-1.037 3.199h7.383Zm6.759-7.734h2.742v-1.406c0-1.571.167-2.742.501-3.516.334-.773.949-1.403 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.633l-.668 3.445a9.783 9.783 0 0 0-2.268-.281c-.715 0-1.227.167-1.538.501-.31.334-.466.975-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.72 0v3.938h-3.375v7.523c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.474l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.15-2.409-.448-.715-.299-1.239-.686-1.573-1.161-.334-.474-.565-1.116-.694-1.924-.106-.575-.158-1.735-.158-3.481v-8.138h-2.268v-3.938h2.268v-3.709l4.957-2.883v6.592h3.375Zm19.26 18.668v-21.41h-7.646v-4.36h20.478v4.36h-7.629v21.41h-5.203Zm21.08-25.77v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.066 1.617a5.86 5.86 0 0 1 .949 2.18c.17.797.255 2.033.255 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.282-3.727a2.444 2.444 0 0 0-.993-1.257c-.475-.31-1.069-.466-1.784-.466-.82 0-1.553.2-2.197.598-.645.399-1.117.999-1.415 1.802-.299.803-.449 1.989-.449 3.559v9.352h-4.939v-25.77h4.939Zm17.07 4.571v-4.571h4.939v4.571h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.54 1.23 5.642.686c.094.656.311 1.107.651 1.354.468.351 1.207.527 2.214.527 1.29 0 2.256-.194 2.901-.58.433-.258.762-.674.984-1.248.153-.41.229-1.166.229-2.268v-2.724c-1.477 2.015-3.34 3.023-5.59 3.023-2.508 0-4.494-1.061-5.959-3.182-1.149-1.675-1.723-3.761-1.723-6.257 0-3.129.753-5.52 2.259-7.172 1.506-1.653 3.378-2.479 5.616-2.479 2.309 0 4.213 1.014 5.713 3.041v-2.619h4.623v16.752c0 2.203-.181 3.85-.545 4.939-.363 1.09-.873 1.946-1.529 2.567-.656.621-1.532 1.107-2.628 1.459-1.096.351-2.481.527-4.157.527-3.164 0-5.408-.542-6.733-1.626-1.324-1.084-1.986-2.458-1.986-4.122 0-.164.006-.363.018-.598Zm4.412-10.951c0 1.981.384 3.431 1.151 4.351.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.472 3.059-1.415.832-.944 1.248-2.341 1.248-4.193 0-1.933-.399-3.369-1.196-4.306-.797-.938-1.804-1.407-3.023-1.407-1.184 0-2.159.46-2.927 1.38-.767.92-1.151 2.324-1.151 4.21Zm22.958-16.049v9.475c1.594-1.863 3.498-2.795 5.713-2.795 1.136 0 2.162.211 3.076.633.914.422 1.602.961 2.065 1.617.463.656.78 1.383.95 2.18.169.797.254 2.033.254 3.709v10.951h-4.939v-9.861c0-1.957-.094-3.2-.281-3.727a2.454 2.454 0 0 0-.993-1.257c-.475-.31-1.07-.466-1.785-.466-.82 0-1.552.2-2.197.598-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.559v9.352h-4.94v-25.77h4.94Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Right Knee' ? 'bodyParts_group Right_Knee body_parts_active' : 'bodyParts_group Right_Knee' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyParts', d: 'M637.29 1052.27v.4c.06-.1.11-.2.15-.29a.717.717 0 0 0-.15-.11z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyLines', d: 'M650.7 1039.36c11.26-14.11 6.99-47.33 5.35-57.54-.76-.67-1.49-1.37-2.2-2.08-.08-.08-.15-.18-.23-.26.65 3.58 7.55 43.57-4.48 58.63-2.62 3.28-7.68 5.15-12.05 5.56.04.67.07 1.33.09 2 4.94-.44 10.52-2.56 13.52-6.31zm36.49-7.06c-6.99-5.44-1.84-47.23.74-63.01-.95 2.11-1.91 3.99-2.88 5.61v.02c-2.25 15.43-6.81 52.95.92 58.96 2.94 2.29 6.57 3.08 10.19 3.08 6.48 0 12.9-2.54 15.29-3.59.01-.04.01-.08.02-.12.07-.43.14-.84.21-1.28v-.01l.06-.4-.21-.43c-.16.08-15.93 7.71-24.34 1.17zm-49.97 19.92c.02.01.04.03.07.05v-.19c-.1.04-.16.09-.07.14z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyLines', d: 'M637.54 1051.97c-.06.03-.17.06-.25.1v.19c.05.03.1.07.15.1.05-.12.09-.26.1-.39zm.01-.06c0 .02-.01.04-.01.06.05-.02.07-.04.01-.06z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyParts', d: 'M696.88 1254.32c.18-4.91.4-9.09.62-11.95.64-8.26 6.77-30.61 11.64-47.76-6.69-12.89-12.34-31.5-15.35-49.28-1.2 20.83-2.44 72.39 3.09 108.99z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyParts', d: 'M685.97 1033.88c-7.73-6.01-3.17-43.53-.92-58.96v-.02c-1.27 2.13-2.55 3.81-3.83 4.89-5.82 4.92-10.54 6.75-14.52 6.75-4.27 0-7.68-2.1-10.65-4.72 1.64 10.21 5.91 43.43-5.35 57.54-2.99 3.75-8.58 5.87-13.52 6.32.08 2.08.12 4.16.11 6.24v.16c.08-.04.19-.07.25-.1 0-.02.01-.04.01-.06.06.02.04.04-.01.06-.01.13-.05.27-.11.4 7.27 5.24 28 55.39 38.12 120.72 6.35 40.97 7.6 76.79 7.77 94.49.12 11.54-.14 22.25-.72 30.18-.48 6.63-1.04 9.69-1.56 11.15 4.54 1.09 14.41 3.75 19.02 5.01-.48-1.41-1-3.21-1.56-5.66-1.84-8-2.17-26.23-1.92-42.08-9.2-44.92-4.55-125.42-4.21-130.06v-.01c-2.37-17.11-3.21-33.54-2.79-44.99.79-21.24 13.92-38.21 19.68-44.66.58-3.32 1.34-7.9 2.18-13.08-2.39 1.05-8.81 3.59-15.29 3.59-3.61-.02-7.24-.81-10.18-3.1z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyParts', d: 'M691.58 1091.19c-.97 26.01 4.83 75.1 18.18 101.21 2.5-8.78 4.56-15.89 5.19-18.49 2.98-12.28 6.9-30.25 7.51-42.36.78-15.81-2.89-27.77-5.64-38.43-1.98-7.68-10.96-29.14-8.36-42.32-3.14 3.11-16.02 17.24-16.88 40.39zm-45.08 111.83c5.68 21.78 24.86 96.93 26.71 104.16 2.66.78 5 1.37 5.86 1.3 2.48-4.56 5.37-64.94-5.49-135.08-6.29-40.61-15.65-71.13-20.67-85.71-6.94-20.17-13.03-29.8-15.67-32.8-.17 6.33-.74 12.65-1.75 18.92-.62 3.88-1.28 8.05-1.92 12.33l.72 2.51c.07.92 6.3 91.7 12.21 114.37z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyParts', d: 'M648.4 1301.39c4.16-.59 12.48 2 19.83 4.28.89.28 1.82.56 2.75.85-3.03-11.88-20.96-82.08-26.41-102.99-5.05-19.4-10.32-90.71-11.84-111.65-.11.73-.21 1.46-.32 2.2-1.85 13.06-3.43 26.29-3.79 35.47-1.01 24.96 6.98 98.84 9.98 108.83 2.99 9.98 6.98 42.93 4.99 55.91-.4 2.58-.95 5.23-1.65 7.98 0 .01-.01.03-.01.04l.27-.04 6.2-.88z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyLines', d: 'M692.37 1136.11v.01c.01-.12.02-.19.02-.21l2 .16c-.01.17-.27 3.56-.6 9.26 3.01 17.78 8.65 36.39 15.35 49.28.03-.09.05-.19.08-.28.15-.54.3-1.07.45-1.59.03-.11.06-.22.1-.34-13.35-26.11-19.15-75.2-18.18-101.21.86-23.15 13.74-37.28 16.89-40.39.01-.04.01-.08.02-.13.01-.06.03-.12.04-.19.04-.19.08-.4.12-.63.17-.89.38-2.04.62-3.39-5.76 6.46-18.89 23.43-19.68 44.66-.44 11.45.4 27.88 2.77 44.99z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyLines', d: 'M693.79 1145.33c-.52-3.08-.99-6.15-1.42-9.21-.34 4.65-4.99 85.15 4.21 130.06 0-.14 0-.29.01-.43.02-1.71.05-3.38.09-5.02v-.01c.06-2.23.13-4.38.2-6.4-5.53-36.6-4.29-88.16-3.09-108.99z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Knee');
	            }, className: 'bodyLines', d: 'm694.39 1136.07-2-.16c0 .02-.01.09-.02.21.43 3.06.9 6.13 1.42 9.21.33-5.7.59-9.09.6-9.26zm-20.81 37.33c10.86 70.14 7.97 130.52 5.49 135.08.4.07 1.09.22 1.97.43.52-1.46 1.08-4.53 1.56-11.15.58-7.93.84-18.64.72-30.18-.17-17.7-1.42-53.52-7.77-94.49-10.12-65.33-30.85-115.48-38.12-120.72-.04.1-.09.2-.15.29 0 .5-.01 1-.01 1.5l-.03.73c2.64 3 8.73 12.63 15.67 32.8 5.02 14.58 14.38 45.1 20.67 85.71zm-2.6 133.12c.75.23 1.5.45 2.23.66-1.85-7.23-21.03-82.38-26.71-104.16-5.91-22.67-12.14-113.45-12.21-114.37l-.72-2.51c-.13.86-.26 1.71-.38 2.57-.15 1.05-.31 2.11-.46 3.17 1.52 20.94 6.79 92.25 11.84 111.65 5.45 20.91 23.38 91.11 26.41 102.99z' }),
	          this.state.bodyTitle === 'Right Knee' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '175', y: '1129', width: '205', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup is_right' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M405 1150.16h230' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M193.957 1159.25v-25.769h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.184 1.125 2.537 1.125 4.061 0 1.933-.568 3.53-1.705 4.79-1.137 1.259-2.836 2.053-5.098 2.381 1.125.657 2.054 1.377 2.786 2.162.733.786 1.72 2.18 2.962 4.184l3.147 5.027h-6.223l-3.762-5.607c-1.336-2.004-2.25-3.267-2.742-3.788-.492-.522-1.014-.879-1.564-1.072-.551-.194-1.424-.29-2.619-.29h-1.055v10.757h-5.203Zm5.203-14.871h3.849c2.497 0 4.055-.105 4.676-.316a2.8 2.8 0 0 0 1.459-1.09c.352-.516.528-1.16.528-1.934 0-.867-.232-1.567-.695-2.1-.463-.533-1.116-.87-1.96-1.011-.422-.058-1.687-.088-3.797-.088h-4.06v6.539Zm20.742-6.329v-4.57h4.939v4.57h-4.939Zm0 21.199v-18.668h4.939v18.668h-4.939Zm9.545 1.231 5.643.685c.093.657.31 1.108.65 1.354.469.352 1.207.527 2.215.527 1.289 0 2.256-.193 2.9-.58.434-.258.762-.674.985-1.248.152-.41.228-1.166.228-2.267v-2.725c-1.477 2.016-3.34 3.023-5.59 3.023-2.508 0-4.494-1.06-5.959-3.181-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.753-5.52 2.258-7.172 1.506-1.652 3.378-2.478 5.617-2.478 2.308 0 4.212 1.013 5.712 3.041v-2.62h4.624v16.752c0 2.204-.182 3.85-.545 4.94-.364 1.09-.873 1.945-1.53 2.566-.656.621-1.532 1.108-2.628 1.459-1.095.352-2.481.528-4.157.528-3.164 0-5.408-.542-6.732-1.626-1.325-1.084-1.987-2.458-1.987-4.122 0-.165.006-.364.018-.598Zm4.412-10.951c0 1.98.384 3.43 1.151 4.35.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.471 3.059-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.398-3.369-1.195-4.307-.797-.937-1.805-1.406-3.024-1.406-1.183 0-2.159.46-2.927 1.38-.767.92-1.151 2.323-1.151 4.21Zm22.957-16.049v9.475c1.594-1.864 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.632.914.422 1.603.961 2.066 1.618.462.656.779 1.382.949 2.179.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.094-3.199-.281-3.726a2.446 2.446 0 0 0-.993-1.257c-.475-.311-1.07-.466-1.784-.466-.821 0-1.553.199-2.198.598-.644.398-1.116.999-1.415 1.801-.298.803-.448 1.99-.448 3.56v9.351h-4.939v-25.769h4.939Zm25.629 7.11v3.938h-3.375v7.523c0 1.524.032 2.412.097 2.663.064.252.211.46.439.625.229.164.507.246.835.246.457 0 1.119-.159 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.693-.149-2.408-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.566-1.116-.695-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm13.535 18.66v-25.769h5.203v11.443l10.512-11.443h6.996l-9.703 10.037 10.23 15.732h-6.732l-7.084-12.093-4.219 4.306v7.787h-5.203Zm42.873 0h-4.939v-9.527c0-2.016-.106-3.319-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.548 3.548 0 0 0-1.397 1.863c-.252.774-.378 2.203-.378 4.289v8.455h-4.939v-18.668h4.587v2.743c1.629-2.11 3.68-3.164 6.153-3.164 1.09 0 2.086.196 2.988.588.902.393 1.585.894 2.048 1.503.463.61.785 1.301.967 2.075.181.773.272 1.88.272 3.322v11.601Zm15.821-5.94 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.268 1.618-1.752 3.662-2.628 6.135-2.628 2.777 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.405-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Zm19.74 4.992 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.671 1.178-.704.785-1.049 1.851-1.038 3.199h7.383Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Left Knee' ? 'bodyParts_group Left_Knee body_parts_active' : 'bodyParts_group Left_Knee' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyLines', d: 'M851.39 1038.11c-12.02-15.07-5.13-55.05-4.48-58.63-.08.08-.15.18-.23.26-.71.71-1.44 1.41-2.2 2.08-1.64 10.21-5.91 43.43 5.35 57.54 3.09 3.87 8.04 5.99 13 6.34l.09-2c-4.37-.33-8.81-2.19-11.53-5.59zm-36.83-4.23c7.73-6.01 3.16-43.55.92-58.97-.97-1.63-1.94-3.53-2.89-5.65 2.59 15.77 7.74 57.59.75 63.03-8.2 6.37-24.33-1.66-25.28-2.14.1.6.19 1.2.29 1.79.05.4.12.78.18 1.17 1.74.81 8.76 3.85 15.85 3.85 3.6 0 7.24-.79 10.18-3.08z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyParts', d: 'M829.55 1306.51c.93-.28 1.86-.57 2.74-.85 7.35-2.28 15.68-4.87 19.84-4.28l5.93.85c-.7-2.74-1.24-5.38-1.64-7.95-2-12.98 2-45.93 4.98-55.91 3.01-9.99 11-83.87 9.99-108.83-.35-8.89-1.85-21.58-3.63-34.23-1.56 21.38-6.78 88.96-11.8 108.21-5.46 20.92-23.38 91.11-26.41 102.99zm-20.61-215.32c-.89-24.05-14.71-38.33-17.19-40.69v-.01c-.17-.16-.27-.25-.32-.3.02.1.04.21.06.3v.01l.03.17c2.68 13.17-6.36 34.75-8.35 42.45-2.75 10.66-6.42 22.62-5.63 38.43.6 12.11 4.52 30.08 7.51 42.36.64 2.64 2.74 9.89 5.28 18.83.03.1.06.21.09.32 12.92-26.5 19.47-76.29 18.52-101.87z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyParts', d: 'M849.83 1039.36c-11.26-14.11-6.99-47.33-5.35-57.54-2.98 2.62-6.38 4.72-10.65 4.72-3.98 0-8.7-1.82-14.52-6.75-1.28-1.08-2.56-2.75-3.83-4.88 2.24 15.42 6.81 52.95-.92 58.97-2.95 2.29-6.58 3.09-10.2 3.09-7.09 0-14.1-3.04-15.85-3.85.01.04.01.08.02.12v.01c.84 5.16 1.6 9.73 2.19 13.07 5.82 6.34 19.43 23.4 20.22 44.8.42 11.46-.42 27.91-2.79 45.03v.01c.38 5.11 5.08 88.36-4.58 132.78l-.12-.29c.18 15.24-.2 32.04-1.94 39.61-.43 1.85-.82 3.32-1.2 4.54 6.61-1.28 15.32-3.1 19.17-3.9-.52-1.47-1.07-4.54-1.56-11.13-.58-7.93-.84-18.65-.72-30.18.18-17.7 1.42-53.52 7.77-94.5 10.22-65.98 30.26-116.48 37.33-120.87.14-.09.28-.15.41-.21v-.09c-.01-2.07.03-4.15.11-6.22-4.95-.36-9.9-2.47-12.99-6.34z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyParts', d: 'M806.73 1145.35v.02c-2.79 16.46-8.98 37.86-15.26 51.38 4.76 16.82 10.43 37.69 11.03 45.62.26 3.38.52 8.6.71 14.7 6.02-36.71 4.75-90.36 3.52-111.72zm20.22 28.04c-10.87 70.14-7.97 130.52-5.49 135.08.86.08 3.2-.51 5.86-1.29 1.83-7.18 21.03-82.38 26.71-104.16 4.85-18.6 10.59-90.4 12.52-116.12-.68-4.55-1.37-8.98-2.03-13.09-1.04-6.43-1.62-12.92-1.77-19.41-2.26 2.32-7.75 11.83-15.14 33.29-5.01 14.58-14.37 45.1-20.66 85.7z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyLines', d: 'M806.73 1145.35c-.32-5.71-.58-9.11-.59-9.28l1.99-.16c0 .02.01.1.02.24 2.37-17.12 3.21-33.57 2.79-45.03-.79-21.4-14.4-38.46-20.22-44.8.25 1.42.46 2.61.63 3.53.02.12.05.23.07.34.06.05.15.14.32.3v.01c2.48 2.36 16.3 16.64 17.19 40.69.95 25.58-5.6 75.37-18.52 101.87.12.42.25.84.37 1.27v.01c.22.79.45 1.6.68 2.41 6.28-13.52 12.47-34.92 15.26-51.38.01-.01.01-.01.01-.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyLines', d: 'M808.15 1136.16c-.42 3.05-.89 6.12-1.42 9.19 1.23 21.36 2.5 75.01-3.52 111.72.04 1.19.07 2.4.11 3.65.03 1.64.07 3.32.09 5.03.02.96.03 1.93.04 2.9l.12.29c9.66-44.42 4.96-127.67 4.58-132.78z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Knee');
	            }, className: 'bodyLines', d: 'M806.14 1136.07c.01.17.27 3.57.59 9.28.53-3.07 1-6.14 1.42-9.18v-.02c-.01-.14-.02-.22-.02-.24l-1.99.16zm18.83 37.02c-6.35 40.97-7.59 76.79-7.77 94.5-.12 11.53.14 22.25.72 30.18.48 6.59 1.04 9.66 1.56 11.13 1.23-.26 1.97-.42 1.97-.42-2.48-4.56-5.37-64.94 5.49-135.08 6.29-40.61 15.65-71.13 20.66-85.7 7.38-21.46 12.87-30.97 15.14-33.29 0-.08-.01-.16-.01-.24v-.01c-.01-.72-.02-1.43-.02-2.15-.14.06-.27.13-.41.21-7.06 4.39-27.11 54.89-37.33 120.87zm2.34 134.09c.73-.21 1.48-.44 2.23-.67 3.03-11.88 20.96-82.07 26.41-102.99 5.02-19.25 10.24-86.84 11.8-108.21-.06-.41-.11-.82-.17-1.24.01-.01 0-.01 0-.01-.25-1.79-.51-3.59-.77-5.36l-.27-1.81c-1.94 25.72-7.67 97.52-12.52 116.12-5.68 21.79-24.87 97-26.71 104.17z' }),
	          this.state.bodyTitle === 'Left Knee' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '1127', width: '175', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M864.206 1146.36h230' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1119.95 1159.25v-25.558h5.203v21.217h12.937v4.341h-18.14Zm32.63-5.94 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.643 2.302 8.428h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm6.759-7.728h2.742v-1.406c0-1.57.167-2.742.501-3.515.334-.774.949-1.404 1.846-1.89.896-.486 2.03-.73 3.401-.73 1.406 0 2.783.211 4.131.633l-.668 3.446a9.732 9.732 0 0 0-2.268-.282c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.318h3.692v3.885h-3.692v14.783h-4.939v-14.783h-2.742v-3.885Zm22.72 0v3.938h-3.375v7.523c0 1.524.032 2.412.096 2.663.065.252.211.46.44.625.228.164.507.246.835.246.457 0 1.119-.159 1.986-.475l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Zm13.53 18.66v-25.769h5.203v11.443l10.512-11.443h6.996l-9.703 10.037 10.23 15.732h-6.732l-7.084-12.093-4.219 4.306v7.787h-5.203Zm42.87 0h-4.94v-9.527c0-2.016-.105-3.319-.316-3.911-.211-.592-.554-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492a3.96 3.96 0 0 0-2.303.703 3.537 3.537 0 0 0-1.397 1.863c-.252.774-.378 2.203-.378 4.289v8.455h-4.94v-18.668h4.588v2.743c1.629-2.11 3.68-3.164 6.152-3.164 1.09 0 2.086.196 2.989.588.902.393 1.585.894 2.048 1.503a5.45 5.45 0 0 1 .966 2.075c.182.773.273 1.88.273 3.322v11.601Zm15.82-5.94 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.809-5.517 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.926-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.566-1.116-1.079 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.382Zm19.749 4.992 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.7-1.845-3.844-1.845-6.434 0-3.094.808-5.517 2.425-7.268 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428H1267.4c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.392-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Right Ankle' ? 'bodyParts_group Right_Ankle body_parts_active' : 'bodyParts_group Right_Ankle' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Ankle');
	            }, className: 'bodyParts', d: 'M676.39 1310.09c-2.05-.45-4.89-1.32-8.75-2.51-6.79-2.11-15.25-4.75-18.96-4.21l-7.01 1-.01-.07-.09-.64c-.06.21-.11.43-.17.64-2.9 10.56-7.78 22.39-13.79 35.92-7.99 17.97-31.64 38.92-41.63 45.92-9.98 6.98 5.7 18.98 16.67 20.97 10.98 2 40.94 2 48.92 0 7.99-1.99 12.98-1 17.98-15.97 4.98-14.97 9.98-39.95 15.98-40.94 5.99-1 22.37-7.66 20.28-19.15-1.71-9.42-2.96-10.92-4.38-13.82-8.2-3.22-25.04-7.13-25.04-7.14z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Ankle');
	            }, className: 'bodyLines', d: 'm641.67 1304.37 7.01-1c3.71-.54 12.17 2.1 18.96 4.21 3.86 1.2 6.7 2.06 8.75 2.51l2.68-1.61c-.86.07-3.2-.52-5.86-1.3.08.34.13.52.14.56l-1.93.49c-.02-.06-.17-.66-.44-1.71-.93-.29-1.86-.57-2.75-.85-7.35-2.28-15.67-4.87-19.83-4.28l-6.2.88-.27.04c-.11.44-.24.9-.36 1.35l.09.64.01.07z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Ankle');
	            }, className: 'bodyLines', d: 'm671.42 1308.23 1.93-.49c-.01-.04-.06-.22-.14-.56-.73-.21-1.48-.43-2.23-.66.27 1.05.42 1.65.44 1.71zm8.47 2.11c-.26.08-.57.12-.94.12-.65 0-1.51-.13-2.56-.37 0 0 16.85 3.92 25.05 7.14-.43-.89-.88-1.9-1.37-3.31-4.61-1.25-14.48-3.92-19.02-5.01-.43 1.18-.83 1.32-1.16 1.43z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Right Ankle');
	            }, className: 'bodyLines', d: 'M676.39 1310.09c1.05.23 1.91.37 2.56.37.37 0 .68-.04.94-.12.33-.11.73-.25 1.15-1.43-.88-.21-1.57-.36-1.97-.43l-2.68 1.61z' }),
	          this.state.bodyTitle === 'Right Ankle' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '167', y: '1332', width: '210', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup is_right' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M405 1353.94h230' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M185.291 1363.04v-25.77h10.951c2.754 0 4.755.231 6.003.694 1.248.463 2.247 1.286 2.997 2.47.75 1.184 1.125 2.537 1.125 4.061 0 1.933-.568 3.53-1.705 4.79-1.137 1.259-2.836 2.053-5.098 2.382 1.125.656 2.054 1.376 2.786 2.162.733.785 1.72 2.179 2.962 4.183l3.147 5.028h-6.223l-3.762-5.608c-1.336-2.004-2.25-3.266-2.742-3.788-.492-.521-1.014-.879-1.564-1.072-.551-.194-1.424-.29-2.619-.29h-1.055v10.758h-5.203Zm5.203-14.872h3.849c2.497 0 4.055-.105 4.676-.316a2.8 2.8 0 0 0 1.459-1.09c.352-.515.528-1.16.528-1.933 0-.868-.232-1.568-.695-2.101-.463-.533-1.116-.87-1.96-1.011-.422-.058-1.687-.088-3.797-.088h-4.06v6.539Zm20.742-6.328v-4.57h4.939v4.57h-4.939Zm0 21.2v-18.668h4.939v18.668h-4.939Zm9.545 1.23 5.643.686c.093.656.31 1.107.65 1.353.469.352 1.207.527 2.215.527 1.289 0 2.256-.193 2.9-.58.434-.257.762-.673.985-1.248.152-.41.228-1.166.228-2.267v-2.725c-1.477 2.016-3.34 3.024-5.59 3.024-2.508 0-4.494-1.061-5.959-3.182-1.148-1.676-1.722-3.762-1.722-6.258 0-3.129.752-5.519 2.258-7.172 1.506-1.652 3.378-2.478 5.617-2.478 2.308 0 4.212 1.013 5.712 3.041v-2.619h4.623v16.752c0 2.203-.181 3.849-.544 4.939-.364 1.09-.873 1.945-1.53 2.566-.656.621-1.532 1.108-2.628 1.459-1.095.352-2.481.528-4.157.528-3.164 0-5.408-.542-6.732-1.626-1.325-1.084-1.987-2.458-1.987-4.122 0-.164.006-.364.018-.598Zm4.412-10.951c0 1.98.384 3.431 1.151 4.35.768.92 1.714 1.38 2.839 1.38 1.207 0 2.227-.471 3.059-1.415.832-.943 1.248-2.341 1.248-4.192 0-1.934-.399-3.369-1.195-4.307-.797-.937-1.805-1.406-3.024-1.406-1.183 0-2.159.46-2.927 1.38-.767.92-1.151 2.323-1.151 4.21Zm22.957-16.049v9.475c1.594-1.864 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.421 1.603.96 2.066 1.617.462.656.779 1.383.949 2.179.17.797.255 2.034.255 3.709v10.952h-4.94v-9.862c0-1.957-.094-3.199-.281-3.726a2.446 2.446 0 0 0-.993-1.257c-.475-.311-1.07-.466-1.784-.466-.821 0-1.553.199-2.198.598-.644.398-1.116.999-1.415 1.801-.298.803-.448 1.99-.448 3.56v9.352h-4.939v-25.77h4.939Zm25.629 7.1v3.937h-3.375v7.524c0 1.523.032 2.411.097 2.663.064.252.211.46.439.624.229.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.693-.149-2.408-.448-.715-.299-1.24-.685-1.573-1.16-.334-.475-.566-1.116-.695-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm35.367 18.67h-5.66l-2.25-5.854h-10.301l-2.127 5.854h-5.519l10.037-25.77h5.502l10.318 25.77Zm-9.58-10.196-3.551-9.562-3.48 9.562h7.031Zm29.285 10.196h-4.939v-9.528c0-2.015-.106-3.319-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.548 3.548 0 0 0-1.397 1.863c-.252.774-.378 2.204-.378 4.289v8.456h-4.939v-18.668h4.588v2.742c1.628-2.11 3.679-3.164 6.152-3.164 1.09 0 2.086.196 2.988.589.902.392 1.585.893 2.048 1.503.463.609.785 1.3.967 2.074.181.773.272 1.881.272 3.322v11.602Zm4.834 0v-25.77h4.94v13.676l5.783-6.574h6.082l-6.381 6.82 6.838 11.848h-5.326l-4.694-8.385-2.302 2.408v5.977h-4.94Zm20.198-25.77h4.939v25.77h-4.939zm20.812 19.82 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.699-1.846-3.844-1.846-6.434 0-3.094.809-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.433 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.101 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.393-2.671 1.178-.704.785-1.049 1.851-1.038 3.199h7.383Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Left Ankle' ? 'bodyParts_group Left_Ankle body_parts_active' : 'bodyParts_group Left_Ankle' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Ankle');
	            }, className: 'bodyParts', d: 'M832.89 1307.58c-5.84 1.81-9.39 2.89-11.31 2.89-1.49.19-15.05 3.31-22.2 4.97-1.78 4.41-3.17 4.47-5.18 15.62-2.1 11.49 14.29 18.15 20.28 19.15 6 .99 10.99 25.97 15.98 40.94 5 14.97 9.98 13.98 17.98 15.97 7.98 2 37.94 2 48.91 0 10.98-1.99 26.66-13.99 16.67-20.97-9.98-7-33.63-27.95-41.62-45.92-6.01-13.52-10.88-25.33-13.79-35.88l-6.77-.97c-3.71-.54-12.16 2.09-18.95 4.2z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Ankle');
	            }, className: 'bodyLines', d: 'M832.29 1305.67c-.89.28-1.82.56-2.74.85-.27 1.05-.42 1.65-.44 1.72l-1.94-.49c.01-.04.06-.23.14-.55-2.66.78-5 1.37-5.86 1.29 0 0 2.16 1.74.12 1.99 1.91 0 5.47-1.07 11.31-2.89 6.79-2.11 15.25-4.74 18.96-4.2l6.77.97c0-.02-.01-.03-.01-.05v-.01c-.18-.67-.36-1.35-.53-2.01 0-.01 0-.02-.01-.03l-5.93-.85c-4.16-.61-12.49 1.98-19.84 4.26z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Ankle');
	            }, className: 'bodyLines', d: 'M829.11 1308.23c.02-.07.17-.67.44-1.72-.75.23-1.51.46-2.23.67-.08.32-.13.52-.14.55l1.93.5zm-8.47 2.11c-.33-.11-.73-.25-1.16-1.45-3.85.81-12.56 2.62-19.17 3.9-.32 1.05-.63 1.9-.93 2.64 7.15-1.66 20.7-4.78 22.2-4.97-.38 0-.69-.04-.94-.12z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Left Ankle');
	            }, className: 'bodyLines', d: 'M820.64 1310.34c.25.09.57.13.94.13 2.04-.25-.12-1.99-.12-1.99s-.74.16-1.97.42c.42 1.19.82 1.33 1.15 1.44z' }),
	          this.state.bodyTitle === 'Left Ankle' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '1330', width: '185', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M864.206 1350.14h230' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1119.95 1363.04v-25.559h5.203v21.217h12.937v4.342h-18.14Zm32.63-5.95 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.247 0-5.649-1.06-7.207-3.181-1.231-1.699-1.846-3.844-1.846-6.434 0-3.094.808-5.516 2.426-7.268 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.643 2.302 8.428h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.393-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm6.759-7.728h2.742v-1.407c0-1.57.167-2.742.501-3.515.334-.774.949-1.404 1.846-1.89.896-.486 2.03-.729 3.401-.729 1.406 0 2.783.211 4.131.632l-.668 3.446a9.732 9.732 0 0 0-2.268-.282c-.715 0-1.227.167-1.538.501-.31.334-.466.976-.466 1.925v1.319h3.692v3.884h-3.692v14.784h-4.939v-14.784h-2.742v-3.884Zm22.72 0v3.937h-3.375v7.524c0 1.523.032 2.411.096 2.663.065.252.211.46.44.624.228.164.507.246.835.246.457 0 1.119-.158 1.986-.475l.422 3.832c-1.149.492-2.449.738-3.902.738-.891 0-1.694-.149-2.409-.448-.715-.299-1.239-.685-1.573-1.16-.334-.475-.565-1.116-.694-1.925-.106-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.937h2.268v-3.709l4.957-2.883v6.592h3.375Zm35.36 18.67h-5.66l-2.25-5.854h-10.301l-2.127 5.854h-5.52l10.037-25.77h5.502l10.319 25.77Zm-9.58-10.196-3.551-9.562-3.481 9.562h7.032Zm29.29 10.196h-4.94v-9.528c0-2.015-.105-3.319-.316-3.911-.211-.592-.554-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492a3.96 3.96 0 0 0-2.303.703 3.542 3.542 0 0 0-1.397 1.863c-.252.774-.378 2.204-.378 4.289v8.456h-4.94v-18.668h4.588v2.742c1.629-2.11 3.68-3.164 6.152-3.164 1.09 0 2.086.196 2.989.589.902.392 1.585.893 2.048 1.503.462.609.785 1.3.966 2.074.182.773.273 1.881.273 3.322v11.602Zm4.83 0v-25.77h4.939v13.676l5.783-6.574h6.083l-6.381 6.82 6.838 11.848h-5.327l-4.693-8.385-2.303 2.408v5.977h-4.939Zm20.2-25.77h4.939v25.77h-4.939zm20.81 19.82 4.921.826c-.632 1.805-1.631 3.179-2.997 4.122-1.365.944-3.073 1.415-5.124 1.415-3.246 0-5.648-1.06-7.207-3.181-1.23-1.699-1.845-3.844-1.845-6.434 0-3.094.808-5.516 2.425-7.268 1.618-1.752 3.663-2.628 6.135-2.628 2.778 0 4.969.917 6.574 2.751 1.606 1.834 2.373 4.643 2.303 8.428h-12.375c.035 1.465.434 2.605 1.195 3.419.762.815 1.711 1.222 2.848 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.101 1.196-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.108-3.261-.703-.744-1.558-1.116-2.566-1.116-1.078 0-1.969.393-2.672 1.178-.703.785-1.049 1.851-1.037 3.199h7.383Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Chest' ? 'bodyParts_group Chest body_parts_active' : 'bodyParts_group Chest' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyParts', d: 'M719.72 479.09c10.83-2.29 22.97-2.25 26.55.62 1.58 1.26 2.69 4.29 3.39 8.13l.04-33.08c-2.68 8.34-11.05 20.22-29.98 24.33z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyParts', d: 'M620.71 403.93c4.42 7.1 9.18 15.38 10.28 19.75.23.95.53 2.28.9 3.91 2.71 12.03 9.05 40.2 20.17 47.04 12.16 7.48 42.09 7.11 65.37 2.87 21.12-3.84 30.24-18.34 31.22-27.16 1.01-9.02-2.1-50.45-3.99-61.79-.6-3.58-.59-8.21-.58-13.11.03-11.34.06-24.19-7.69-26.13-13.75-3.43-46.12-4.31-74.44 7.96-21.46 9.3-32.67 15.48-42.38 27.51-3.69 4.59-4 11.07-.76 16.14.62.96 1.25 1.97 1.9 3.01zm130.32 52.17-.05 29.94v1.26c.08-.41.17-.82.26-1.22v-.04c.7-2.98 1.7-5.28 3.02-6.33 3.58-2.87 15.74-2.91 26.58-.61-17.96-3.88-26.43-14.77-29.55-23v-.04c-.1-.26-.17-.5-.26-.75v.79z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyParts', d: 'M880.95 384.78c-4.85-6.01-10.08-10.57-16.77-14.78-6.7-4.21-14.87-8.08-25.6-12.73-17.64-7.64-36.85-10.19-52.15-10.19-9.27 0-17.11.94-22.3 2.23-7.75 1.94-7.72 14.79-7.69 26.13.01 4.9.03 9.53-.57 13.11-1.89 11.34-5 52.78-4 61.79.98 8.82 10.1 23.32 31.22 27.16 23.29 4.23 53.22 4.61 65.37-2.87 11.13-6.85 17.47-35.02 20.18-47.05.36-1.62.66-2.95.9-3.9 1.25-5.01 7.31-15.14 12.17-22.76 3.24-5.07 2.93-11.55-.76-16.14zM749.96 453.9c-.08.28-.17.57-.26.87l-.04 33.08c.09.52.18 1.05.26 1.6.14.91.25 1.85.34 2.82.17-1.77.41-3.43.72-4.96v-1.26l.05-29.94v-.79c-.31-.89-.58-1.75-.77-2.56-.08.36-.18.75-.3 1.14z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyLines', d: 'M750.26 452.75a14.5 14.5 0 0 1-.29-1.56 7.13 7.13 0 0 1-.09-.62c-.08-.71-.13-1.6-.17-2.65v3.27l-.01 2.71v.87c.09-.29.18-.58.26-.87.12-.39.22-.78.3-1.15zm-.53-19.12-.01 7.57c.05-2.3.14-4.85.27-7.57.08-1.74.17-3.54.27-5.38-.08-1.41-.17-2.84-.26-4.29-.08-1.28-.17-2.58-.26-3.87v3.87l-.01 9.67zm-127.47-24.16c-.01.03-.09.2-.23.49.44.72.84 1.42 1.23 2.1.5-1.07.78-1.69.81-1.74l-1.81-.85zm8.46 21.98c.34 1.49.72 3.12 1.15 4.84.42-2.47.75-4.18.85-4.64l-1.95-.43c0 .01-.02.1-.04.22-.01 0-.01 0-.01.01 0-.01 0-.01 0 0z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyLines', d: 'M750.64 450.57c-.07.67-.2 1.4-.38 2.18.19.81.46 1.67.77 2.56l.06-39.53c-.31 4.18-.6 8.43-.83 12.47.55 9.9.79 18.61.38 22.32zm-.93-2.65.01-6.72c-.06 2.62-.07 4.91-.01 6.72z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyLines', d: 'M749.97 451.19c.06.49.16 1.01.29 1.56.18-.78.31-1.51.38-2.18.41-3.71.17-12.42-.38-22.32-.1 1.84-.19 3.64-.27 5.38-.13 2.72-.22 5.27-.27 7.57l-.01 6.72c.03 1.04.09 1.94.17 2.65.02.2.05.41.09.62z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'syzst2', d: 'm745.88 364.88.09 1.69c-.02-.57-.05-1.14-.09-1.69zm-.3-3.39c.13 1.08.22 2.18.3 3.31-.07-1.12-.17-2.23-.3-3.31zm-.5-3.19c.2 1 .36 2.05.49 3.13a37.24 37.24 0 0 0-.49-3.13zm.89 8.35.06 1.66c-.01-.56-.03-1.11-.06-1.66zm-1.64-11.28zm1.75 16.55v1.64c.01-.54 0-1.09 0-1.64zm0 2.02v1.5-1.5zm-8.14-26.23c-.34-.13-.69-.24-1.06-.34.37.09.72.21 1.06.34zm5.33 5.05zm2.8 17.51c.01.53.01 1.06.01 1.59 0-.53-.01-1.06-.01-1.59zm-.04-1.9.03 1.67c0-.55-.01-1.11-.03-1.67zm10.41-13.7zm1.1-2.43c-.4.71-.74 1.47-1.04 2.28.29-.81.64-1.57 1.04-2.28zm-2.46 8.2zm-13.23-9.89c.53.66 1 1.39 1.41 2.19-.41-.8-.87-1.54-1.41-2.19zm21.8-3.18zm-5.41 3.75zm-3.8 22.89v1.43-1.43zm0-.41c0-1.04 0-2.08.01-3.12-.01 1.04-.01 2.08-.01 3.12zm.29-9.94zm-.19 3.36c-.04 1.04-.06 2.09-.08 3.15.01-1.05.04-2.1.08-3.15zm1.1-9.6zm125.31 27.36c-4.85-6.01-10.08-10.57-16.77-14.78-6.7-4.21-14.87-8.08-25.6-12.73-17.64-7.64-36.85-10.19-52.15-10.19-9.27 0-17.11.94-22.3 2.23-7.75 1.94-7.72 14.79-7.69 26.13.01 4.9.03 9.53-.57 13.11-1.89 11.34-5 52.78-4 61.79.98 8.82 10.1 23.32 31.22 27.16 23.29 4.23 53.22 4.61 65.37-2.87 11.13-6.85 17.47-35.02 20.18-47.05.36-1.62.66-2.95.9-3.9 1.25-5.01 7.31-15.14 12.17-22.76 3.24-5.07 2.93-11.55-.76-16.14z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyParts', d: 'M741.85 350.55c.53.66 1 1.39 1.41 2.19 0 .01.01.01.01.02.4.8.75 1.65 1.05 2.57 0 .01.01.03.01.04.29.91.54 1.88.74 2.88 0 .02.01.04.01.05.2 1.01.36 2.05.49 3.13 0 .02.01.04.01.07.13 1.08.22 2.18.3 3.31v.07l.09 1.69v.08l.06 1.66v.06l.03 1.67v.23c.01.53.01 1.06.01 1.59v3.58c-.01 4.82-.02 9.37.55 12.78.97 5.83 2.22 18.98 3.11 31.87l.08-68.47c-2.74-.04-5.56-.32-7.96-1.07zm9.51 61.74v-.06c.81-10.09 1.76-19.37 2.54-24.01.57-3.41.55-7.96.54-12.78v-1.84c0-1.04 0-2.08.01-3.12v-.31c.01-1.05.04-2.11.08-3.15 0-.08.01-.16.01-.25.04-1.05.1-2.09.18-3.12.01-.07.01-.14.02-.21.09-1.03.2-2.03.33-3.01l.03-.18c.14-.98.32-1.93.53-2.84.01-.05.03-.11.04-.16.22-.91.47-1.77.77-2.59.02-.05.03-.09.05-.14.3-.81.65-1.58 1.04-2.28.02-.04.05-.08.07-.13.2-.35.41-.68.63-1-1.87.23-4.38.47-7.04.5l-.1 60.61v.08l-.01 3.47.27-3.47c.01 0 .01 0 .01-.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyParts', d: 'M751.1 412.29v-.06l.1-60.61c-.46.01-.92.01-1.38 0l-.08 68.47c.09 1.3.18 2.59.26 3.87.09 1.45.18 2.88.26 4.29.23-4.04.52-8.29.83-12.47l.01-3.47v-.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyLines', d: 'M746.08 375.44v-3.58c0-.53-.01-1.06-.01-1.59v-.23l-.03-1.67v-.06c-.01-.56-.03-1.11-.06-1.66v-.08c-.02-.57-.05-1.13-.09-1.69v-.07c-.07-1.13-.17-2.23-.3-3.31 0-.02-.01-.04-.01-.07-.13-1.08-.29-2.12-.49-3.13 0-.02-.01-.04-.01-.05-.2-1.01-.45-1.97-.74-2.88 0-.01-.01-.03-.01-.04-.3-.91-.64-1.77-1.05-2.57 0-.01-.01-.01-.01-.02-.41-.8-.87-1.53-1.41-2.19-1.03-1.27-2.32-2.24-3.91-2.84-.34-.13-.69-.24-1.06-.34-7.29-1.82-19.72-2.94-34.02-1.83l-.58 1.75c-.03-.02-1.36-.45-4.01-1.32h-.02c-11.94 1.3-24.89 4.18-37.1 9.46-10.89 4.72-19.17 8.66-25.99 12.96-6.82 4.3-12.16 8.96-17.14 15.14-4.07 5.04-4.57 12.09-1.31 17.78.08.15.18.3.27.45.86-.39 1.82-.83 1.83-.84-3.24-5.07-2.93-11.55.76-16.14 9.71-12.03 20.92-18.21 42.38-27.51 28.32-12.27 60.69-11.39 74.44-7.96 7.75 1.94 7.72 14.79 7.69 26.13-.01 4.9-.02 9.53.58 13.11 1.89 11.34 5 52.77 3.99 61.79-.98 8.82-10.1 23.32-31.22 27.16-23.28 4.24-53.21 4.61-65.37-2.87-11.12-6.84-17.46-35.01-20.17-47.04-.37-1.63-.67-2.96-.9-3.91-1.1-4.37-5.86-12.65-10.28-19.75-.01.01-1.26 0-2.35.02 1.33 2.13 2.57 4.14 3.67 6.01.13-.29.21-.46.23-.49l1.81.85c-.02.05-.31.67-.81 1.74 3.19 5.53 5.19 9.7 5.79 12.11.23.94.53 2.25.89 3.86.23 1.03.49 2.17.78 3.41.02-.12.04-.21.04-.22l1.95.43c-.1.46-.42 2.17-.85 4.64v.01c3.41 13.91 9.49 34.1 19.15 40.03 7.22 4.45 19.72 6.22 33.31 6.22 6.97 0 14.21-.47 21.2-1.27 1.78-1.34 2.89-2.21 2.94-2.25l1.24 1.57c-.04.03-.12.09-.22.17h.01c2.85-.38 5.63-.82 8.3-1.31.65-.12 1.28-.24 1.9-.37.01 0 .02-.01.03-.01 18.92-4.11 27.3-15.98 29.98-24.32v-.87l.01-2.71v-3.27c-.06-1.82-.05-4.1.01-6.72l.01-7.57.01-9.67v-3.87c-.89-12.89-2.14-26.03-3.11-31.87-.58-3.4-.57-7.95-.56-12.77zm136.43 8.09c-9.97-12.37-21.37-18.66-43.14-28.1-12.2-5.29-25.16-8.17-37.09-9.47-2.67.87-4 1.31-4.03 1.33l-.59-1.76c-14.3-1.1-26.72.02-34.01 1.84-.45.11-.88.26-1.28.43-1.72.7-3.07 1.84-4.13 3.33-.22.32-.43.65-.63 1-.02.04-.05.08-.07.13-.4.71-.74 1.47-1.04 2.28-.02.05-.03.09-.05.14-.3.82-.55 1.69-.77 2.59-.01.05-.03.11-.04.16-.21.91-.38 1.86-.53 2.84l-.03.18c-.14.98-.25 1.98-.33 3.01-.01.07-.01.14-.02.21a77.08 77.08 0 0 0-.18 3.12c0 .08-.01.16-.01.25-.04 1.04-.06 2.09-.08 3.15v.31c-.01 1.04-.02 2.08-.01 3.12v1.84c.01 4.82.03 9.37-.54 12.78-.78 4.64-1.73 13.92-2.54 24.01v.08c-.09 1.14-.18 2.31-.27 3.47l-.06 39.53c.09.25.16.49.26.75v.04c3.12 8.23 11.59 19.12 29.55 23 .62.13 1.25.25 1.89.37 2.68.49 5.47.93 8.32 1.31-.1-.08-.18-.14-.22-.17l1.24-1.57c.05.04 1.16.91 2.94 2.25 6.98.8 14.24 1.27 21.19 1.27 13.6 0 26.09-1.77 33.32-6.22 9.65-5.93 15.73-26.11 19.15-40.03-.43-2.47-.75-4.19-.85-4.65l1.95-.43c0 .01.02.11.05.25v-.01c.28-1.25.55-2.4.78-3.44.36-1.6.65-2.92.89-3.85.6-2.41 2.61-6.58 5.78-12.12-.49-1.07-.78-1.68-.8-1.73l1.81-.85c.01.03.09.19.22.48 1.27-2.14 2.69-4.44 4.24-6.91-.31-.12-.5-.18-.53-.19l.63-1.9c.03.01.38.13.97.36 3.25-5.72 2.75-12.77-1.31-17.81zm-.8 17.39c-4.86 7.62-10.92 17.75-12.17 22.76-.24.95-.54 2.28-.9 3.9-2.71 12.03-9.05 40.2-20.18 47.05-12.15 7.48-42.08 7.1-65.37 2.87-21.12-3.84-30.24-18.34-31.22-27.16-1-9.01 2.11-50.45 4-61.79.6-3.58.58-8.21.57-13.11-.03-11.34-.06-24.19 7.69-26.13 5.19-1.29 13.03-2.23 22.3-2.23 15.3 0 34.51 2.55 52.15 10.19 10.73 4.65 18.9 8.52 25.6 12.73 6.69 4.21 11.92 8.77 16.77 14.78 3.69 4.59 4 11.07.76 16.14z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Chest');
	            }, className: 'bodyLines', d: 'M743.26 352.74c0 .01.01.01.01.02 0-.01-.01-.02-.01-.02zm-5.32-5.03c1.6.6 2.88 1.57 3.91 2.84 2.4.75 5.22 1.03 7.97 1.07v-2.14c-5.53-.11-9.95-1.21-11.88-1.77zm8.09 20.6v.06-.06zm.03 1.74v.23c.01-.08.01-.16 0-.23zm-1.75-14.72c0 .01.01.03.01.04 0-.02 0-.03-.01-.04zm1.66 11.23v.08-.08zm.11 5.3v.06-.06zm0 1.7v.38-.38zm-1.01-15.31c0 .02.01.04.01.05 0-.02-.01-.03-.01-.05zm.5 3.18c0 .02.01.04.01.07 0-.03 0-.05-.01-.07zm.31 3.37v.07-.07zm8.56 9.21v-.41.41zm3.17-21.89c-.02.04-.05.08-.07.13.02-.05.04-.09.07-.13zm-1.12 2.41c-.02.05-.03.09-.05.14.02-.05.04-.1.05-.14zm-5.29-5.04v2.13c2.67-.03 5.18-.27 7.04-.5 1.06-1.49 2.41-2.63 4.13-3.33-3.89 1.21-7.71 1.66-11.17 1.7zm3.34 17.29c0 .08-.01.16-.01.25.01-.09.01-.17.01-.25zm-.08 3.39v.31c-.01-.1 0-.21 0-.31zm.29-6.72c-.01.07-.01.14-.02.21 0-.07.01-.14.02-.21zm.92-6.19c-.01.05-.03.11-.04.16.02-.05.03-.11.04-.16zm-.56 3-.03.18.03-.18zm-5.29-10.78v2.14c.46.01.92.01 1.38 0v-2.13c-.47 0-.92 0-1.38-.01zm-132.03 53.56c.2.31.38.61.57.91 1.09-.02 2.33-.01 2.35-.02 0 0 0-.01-.01-.01l-1.89-3c-.02.01-.97.45-1.83.84.05.08.09.16.14.24.22.35.45.7.67 1.04zm90.67 75.99c-.05.04-1.16.91-2.94 2.25h.01c1.33-.16 2.64-.32 3.94-.5.1-.08.18-.14.22-.17l-1.23-1.58zm-5.6-133.49c-1.51.12-3.03.26-4.59.43 2.65.87 3.98 1.3 4.01 1.32l.58-1.75zm179.35 57.31c.02.01.21.07.53.19.22-.34.45-.69.67-1.04.14-.23.28-.46.41-.69-.59-.23-.94-.35-.97-.36l-.64 1.9zm-4.95 9.19c.4-.68.81-1.37 1.23-2.09-.13-.28-.21-.45-.22-.48l-1.81.85c.02.05.31.66.8 1.73v-.01zm-9.45 19.61c.1.46.42 2.17.85 4.65v-.01c.42-1.72.8-3.32 1.15-4.81v-.01c-.03-.14-.04-.23-.05-.25l-1.95.43zm-72.82 49.63s.01 0 0 0c-1.77-1.34-2.88-2.21-2.93-2.24l-1.24 1.57c.04.03.12.09.22.17 1.31.18 2.63.34 3.95.5zm7.29-135.32c-1.56-.17-3.1-.31-4.62-.43l.59 1.76c.03-.02 1.36-.46 4.03-1.33z' }),
	          this.state.bodyTitle === 'Chest' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '395', width: '115', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M854.206 414.53h240' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'm1137.88 417.94 5.045 1.599c-.773 2.813-2.059 4.902-3.858 6.267-1.799 1.365-4.081 2.048-6.847 2.048-3.422 0-6.234-1.169-8.437-3.507-2.203-2.338-3.305-5.534-3.305-9.589 0-4.289 1.108-7.62 3.322-9.993 2.215-2.373 5.127-3.56 8.737-3.56 3.152 0 5.713.932 7.681 2.795 1.172 1.102 2.051 2.684 2.637 4.746l-5.15 1.231c-.305-1.336-.941-2.391-1.908-3.164-.966-.774-2.141-1.16-3.524-1.16-1.91 0-3.46.685-4.649 2.056-1.19 1.371-1.785 3.592-1.785 6.662 0 3.258.586 5.578 1.758 6.961 1.172 1.383 2.696 2.075 4.571 2.075 1.382 0 2.572-.44 3.568-1.319s1.711-2.262 2.144-4.148Zm14.4-16.295v9.474c1.594-1.863 3.498-2.795 5.713-2.795 1.137 0 2.162.211 3.076.633.914.422 1.603.961 2.065 1.617.463.657.78 1.383.95 2.18.17.797.255 2.033.255 3.709v10.951h-4.94v-9.861c0-1.957-.094-3.199-.281-3.727a2.448 2.448 0 0 0-.993-1.256c-.475-.311-1.07-.466-1.785-.466-.82 0-1.552.199-2.197.597-.644.399-1.116.999-1.415 1.802-.299.803-.448 1.989-.448 3.56v9.351h-4.94v-25.769h4.94Zm27.88 19.828 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.944-3.074 1.415-5.124 1.415-3.246 0-5.649-1.06-7.207-3.181-1.231-1.7-1.846-3.844-1.846-6.434 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.036 1.465.434 2.605 1.196 3.419.761.815 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.952-.633.527-.422.925-1.102 1.195-2.039Zm.281-4.992c-.035-1.43-.404-2.517-1.107-3.261-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.672 1.178-.703.785-1.048 1.851-1.037 3.199h7.383Zm7.189 5.607 4.957-.756c.211.961.638 1.691 1.283 2.189.644.498 1.547.747 2.707.747 1.277 0 2.238-.235 2.883-.703.433-.328.65-.768.65-1.319 0-.375-.117-.685-.352-.931-.246-.235-.796-.451-1.652-.651-3.984-.879-6.51-1.681-7.576-2.408-1.477-1.008-2.215-2.408-2.215-4.201 0-1.617.639-2.977 1.916-4.078 1.277-1.102 3.258-1.653 5.942-1.653 2.554 0 4.453.417 5.695 1.249 1.242.832 2.097 2.062 2.566 3.691l-4.658.861c-.199-.726-.577-1.283-1.134-1.67-.556-.386-1.35-.58-2.382-.58-1.3 0-2.232.182-2.795.545-.375.258-.562.592-.562 1.002 0 .352.164.651.492.897.445.328 1.984.791 4.614 1.388 2.631.598 4.468 1.33 5.511 2.198 1.031.878 1.547 2.103 1.547 3.673 0 1.711-.715 3.182-2.144 4.413-1.43 1.23-3.545 1.845-6.346 1.845-2.543 0-4.556-.515-6.038-1.547-1.483-1.031-2.452-2.431-2.909-4.201Zm30.32-13.342v3.938h-3.375v7.523c0 1.524.032 2.411.097 2.663.064.252.21.46.439.624.228.164.507.247.835.247.457 0 1.119-.159 1.986-.475l.422 3.832c-1.148.492-2.449.738-3.902.738-.891 0-1.694-.149-2.408-.448-.715-.299-1.24-.686-1.574-1.16-.334-.475-.565-1.116-.694-1.925-.105-.574-.158-1.734-.158-3.48v-8.139h-2.268v-3.938h2.268v-3.709l4.957-2.882v6.591h3.375Z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Upper GI' ? 'bodyParts_group Upper_GI body_parts_active' : 'bodyParts_group Upper_GI' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M696.59 650.7c0 .03.01.21.02.54.53.44.71.44.98.44l.52-.03.3-.37c.05-.06.12-.14.19-.39 0-.11-.01-.19-.01-.24l-2 .05zm105.87.97h.47c.27 0 .45 0 .98-.45.01-.32.01-.5.01-.53l-2-.03c0 .05 0 .12-.01.21.08.25.14.34.19.4l.36.4z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M801.87 650.67h.06v-.02l-.06.02zm-102.58-29.34 5.62-2.96s.72-2.25 1.22-2.82l-6.88 3.42.04 2.36zm93.37-7.39s-.36-.95 8.67 1.59l-.04 2.12-6.5-1.52-2.13-2.19zM680.9 496.96l-.85 2.25s2.99-1.06 3.88-1.5c0 .01-2.47-.85-3.03-.75zm138.73 0s-3.01-.02-3.03.76c-.03 1.06 4.06 1.25 4.06 1.25l-1.03-2.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M651.02 476.33c-9.66-5.93-15.74-26.12-19.15-40.03v-.01c-1.45 8.41-4.1 25.73-3.36 33.09.94 9.41 13.11 22.61 18.09 26.17 7.22 5.16 22.08 3.23 30.07 2.2l1.78-.23c5.97-.75 20.76-11.47 27.08-16.23-6.99.8-14.23 1.27-21.2 1.27-13.59-.01-26.09-1.78-33.31-6.23zm172.84 21.41c7.98 1.04 22.85 2.96 30.07-2.2 4.98-3.56 17.15-16.76 18.09-26.17.74-7.38-1.91-24.67-3.36-33.08-3.42 13.92-9.5 34.11-19.15 40.03-7.23 4.45-19.72 6.22-33.32 6.22-6.96 0-14.22-.47-21.19-1.27 6.32 4.76 21.12 15.49 27.08 16.23l1.78.24z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'syzst2', d: 'M699.22 616.75c0-.2-.01-.39-.01-.58 0 .19.01.38.01.58zm63.96-9.07c-.08 0-.15-.01-.22-.01.07.01.14.01.22.01zm-.53-.02c-.06 0-.12 0-.17-.01.06 0 .11.01.17.01zm1.13.05c-.08 0-.15-.01-.22-.01.07.01.14.01.22.01zm-64.64 5.62c-.01-.25-.01-.49-.02-.73 0 .24.01.48.02.73zm.05 1.94zm65.28-7.52c-.07 0-.15-.01-.22-.01.07 0 .15.01.22.01zm-65.18 13.58v-.01c1.74-1.23 3.69-2.06 5.62-2.95.25-.94.52-1.7.82-2.23.12-.2.26-.4.41-.6-2.26 1.2-4.69 2.09-6.88 3.42l.03 2.37zm-.2-9.39c-.01-.4-.03-.8-.04-1.18.01.38.03.77.04 1.18zm63.14-4.3c-.12 0-.22-.01-.3-.01.08 0 .19.01.3.01zm-23.63-.01c-.09 0-.2.01-.33.01.13 0 .24-.01.33-.01zm62.77 6.38c-.01.5-.03 1.01-.04 1.53.02-.52.03-1.03.04-1.53zm-.12 6.21v.36c-.01-.12 0-.24 0-.36zm-102.59-15.27c-.03-.2-.06-.38-.08-.53.02.15.05.33.08.53zm102.76 7.38c-.01.46-.03.92-.04 1.4.01-.48.03-.94.04-1.4zm.12-3.09-.06 1.25c.03-.43.05-.85.06-1.25zm.14-2.36c-.02.32-.05.65-.07 1.01.03-.36.05-.7.07-1.01zm-.07 1.12zm-.13 2.73c-.02.42-.03.86-.05 1.32.02-.46.03-.9.05-1.32zm-.27 12.55zm-102.38-16.61c-.02-.3-.05-.59-.07-.84.02.25.04.54.07.84zm.14 2.37-.06-1.07c.03.34.04.7.06 1.07zm-.07-1.28c-.02-.29-.04-.56-.05-.81.02.25.03.53.05.81zm.13 2.55zm-.28-4.55c-.02-.24-.05-.45-.07-.64.02.19.05.4.07.64zm103.02.12c-.02.26-.05.54-.07.84.02-.3.04-.58.07-.84zm-.57 19.99v.59c-.01-.2-.01-.39 0-.59zm-36.01-18.07c-.05 0-.1-.01-.16-.01.06 0 .11 0 .16.01zm-40.41 1.06c-.11.02-.23.03-.34.05.11-.01.23-.03.34-.05zm2.63-.34c-.12.01-.23.03-.35.04.12-.01.24-.03.35-.04zm-1.31.16c-.11.01-.22.03-.33.04.11-.01.22-.02.33-.04zm2.58-.31c-.11.01-.23.02-.34.04.11-.01.23-.03.34-.04zm-9.27 1.41c-.11.02-.22.05-.34.07.12-.02.23-.04.34-.07zm4.03-.72zm-2.69.46-.33.06c.11-.01.22-.04.33-.06zm9.17-1.28c-.12.01-.23.02-.35.04.12-.02.24-.03.35-.04zm-7.82 1.04-.34.06c.11-.02.22-.04.34-.06zm15.95-1.63c-.08 0-.15.01-.23.01.08 0 .15-.01.23-.01zm-1.21.06c-.09 0-.16.01-.25.01.08 0 .16-.01.25-.01zm-.74.04c-.1.01-.19.01-.29.02.1-.01.19-.01.29-.02zm-5 .38-.34.03.34-.03zm-13.01 1.94c-.11.02-.22.05-.32.07.1-.02.21-.05.32-.07zm15.21-2.13c-.1.01-.2.02-.31.02.11 0 .21-.01.31-.02zm-1.08.09-.3.03c.1-.02.2-.02.3-.03zm2.08-.16c-.1.01-.19.01-.29.02.1-.01.2-.02.29-.02zm.94-.07c-.1.01-.18.01-.28.02.09-.01.18-.01.28-.02zm2.3-.13c-.1 0-.19.01-.3.01.11 0 .21 0 .3-.01zm-20.76 2.71c-.1.03-.21.05-.31.08.11-.03.21-.06.31-.08zm-5.9 1.91c-.07.03-.14.06-.22.1.07-.03.14-.07.22-.1zm3.4-1.23c-.1.03-.19.06-.28.09.09-.03.18-.06.28-.09zm-2.33.79-.24.09c.08-.02.16-.05.24-.09zm3.56-1.14c-.1.03-.2.05-.29.08.09-.03.19-.06.29-.08zm-6.57 2.54c-.05.03-.1.06-.16.09.06-.03.11-.06.16-.09zm-.84.53-.12.09c.03-.04.07-.07.12-.09zm1.77-1.02c-.07.03-.13.07-.19.1.07-.04.13-.07.19-.1zm-2.53 1.57c-.03.03-.06.05-.09.08.03-.03.06-.05.09-.08zm5.75-2.88c-.09.03-.18.06-.26.09.08-.03.17-.06.26-.09zm157.28-131.94c.01-.02.03-.04.04-.07-.02.02-.03.04-.04.07zm.57-1.04.03-.06c-.01.03-.02.04-.03.06zm-15.22 18.23c.11-.09.22-.17.34-.27-.11.09-.23.18-.34.27zm15.76-19.26.03-.06c-.01.03-.02.04-.03.06zm-1.72 3.09c.01-.02.03-.05.04-.07-.01.02-.03.05-.04.07zm-7.19 9.55c.05-.06.1-.11.15-.17-.05.06-.1.11-.15.17zm-7.48 7.09c.15-.11.3-.22.47-.35-.17.13-.33.25-.47.35zm1.21-.94c.1-.09.21-.17.31-.26-.11.09-.21.18-.31.26zm12.82-14.68c.02-.02.03-.05.05-.07-.01.02-.03.05-.05.07zm3.3-6.17c.01-.01.01-.03.02-.04 0 .01-.01.03-.02.04zm-52.79 21.58-.36.05c-.93.14-1.82.38-2.67.71 1.1.52 2.13.94 3.06 1.25l.21-.03-.24-1.98zm-178.24-3.29c0-.01 0-.01 0 0 0-.01 0-.01 0 0zm-1.18-1.18-.1-.1c.04.03.07.06.1.1zm232.62-18.14c0-.01.01-.02.01-.04 0 .02-.01.03-.01.04zM680.9 496.96l-.25 1.98.21.03c.94-.31 1.97-.73 3.06-1.25-.85-.33-1.75-.57-2.67-.71l-.35-.05zm-42-5.85c-.02-.02-.04-.05-.07-.07.03.02.05.05.07.07zm233.07-14.7c.01-.02.01-.03.02-.05 0 .02-.01.03-.02.05zm-13.09 17.5c.08-.08.16-.16.25-.24-.09.09-.17.16-.25.24zm2.93-2.99c.06-.06.11-.12.17-.19-.06.06-.11.12-.17.19zm-.76.8c.07-.07.13-.14.2-.21-.07.08-.13.14-.2.21zm3.04-3.39zm-3.77 4.16.21-.21c-.07.07-.14.13-.21.21zm3.01-3.28c.04-.05.09-.1.13-.15-.04.05-.08.1-.13.15zm3.01-3.69.08-.11c-.03.04-.06.08-.08.11zm-8.8 9.64.28-.25-.28.25zm9.52-10.61.07-.1c-.02.03-.04.07-.07.1zm.71-.99zm-2.93 3.86.11-.14c-.03.05-.07.09-.11.14zm-7.93 8.3c.1-.08.19-.16.29-.25-.1.08-.2.16-.29.25zm1.28-1.16zm7.41-8.08.09-.12-.09.12zm2.86-3.91.06-.09-.06.09zm-66.5 121.86zm71.76-133.1v-.01c.01 0 0 0 0 .01zm-71.86 133.72c-.03.21-.05.44-.08.69.02-.25.05-.48.08-.69zm-95.22 9.92c.02-.02.03-.04.05-.05l-.05.05zm-64.06-120.18c-.03-.03-.06-.05-.08-.08l.08.08zm217.24-1.8c-.07.07-.14.14-.22.21.07-.06.14-.13.22-.21zm-67.16 120.95c.89.64 1.6 1.33 2.07 2.1 2.21.44 4.43.87 6.56 1.59v.02c.01-.72.03-1.43.04-2.12-2.55-.81-5.21-1.23-7.82-1.78-.3-.05-.61.02-.85.19zM644.67 496.59c-.04-.03-.08-.06-.13-.1.05.04.09.07.13.1zm228.81-24.26c0-.01 0-.02.01-.02 0 0-.01.01-.01.02zm-.3 1.01c0-.01.01-.02.01-.03 0 .01 0 .02-.01.03zM643.7 495.79c-.05-.04-.11-.09-.16-.14.06.04.11.09.16.14zm209.72 70.83c-.08.74-.15 1.52-.22 2.34.27-2.07.49-3.78.62-4.9-.17.98-.33 1.88-.4 2.56z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M632.18 495.63c2.7 5.63 9.04 18.82 16.91 24.07 9.22 6.15 21.72 5.67 28.35 4.84 4.28-.53 8.23-5.71 10.8-9.96 1.8-2.98 1.99-6.65.49-9.81-1.49-3.17-4.33-5.28-7.77-5.79l-.09-.01h-.01c-.79.26-1.53.45-2.17.53l-1.77.23c-4.21.55-9.76 1.27-15.27 1.27-6.07 0-12.1-.87-16.22-3.82-.24-.17-.5-.37-.77-.58-.04-.03-.08-.06-.13-.1-.27-.21-.55-.45-.85-.71-.05-.05-.11-.09-.16-.14-.31-.27-.63-.55-.96-.86-.03-.03-.06-.05-.08-.08-.36-.33-.72-.67-1.1-1.04l-.01-.01c-.38-.37-.77-.76-1.17-1.17l-.1-.1c-.4-.41-.8-.83-1.21-1.27-.02-.02-.04-.05-.07-.07-4.32-4.67-9.13-11.03-11.26-17.02-1.05 4-.28 8.18-.19 12.31.14.34.28.69.41 1.01 1.39 2.55 2.82 5.14 3.6 6.72.24.39.49.93.8 1.56zm8.1 26.12c.04.22.07.45.1.67.03-.06.06-.12.08-.18-.06-.16-.13-.32-.18-.49zm7.96 29.47c3.39 8.52 9.7 24.38 20.74 29.47 13.59 6.27 23.61 6.49 24.9 5.21 1.6-1.61 1.97-8.54-2.22-18.94-1.73-4.29-6.08-10.54-7.42-12.42-1.51.38-3.29.57-5.3.57-4.28 0-9.61-.86-15.66-2.58-8.27-2.37-16.27-10.11-21.91-22.53.31 1.42.7 2.92 1.23 4.49.29.88.57 1.71.82 2.48.87 2.59 1.49 5.27 1.81 7.98v.01c.04.35.06.71.09 1.06.61.64 1.32 1.31 1.62 2.01.38.88.81 1.96 1.3 3.19z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M640.45 522.24c5.6 15.96 14.29 25.77 23.38 28.36 14.27 4.08 22.27 2.7 23.86-.48 1.26-2.52-2.16-16.65-4.86-25.92-1.6 1.23-3.33 2.1-5.14 2.33-2.12.26-4.83.49-7.85.49-6.78 0-15.1-1.15-21.86-5.66-6.23-4.15-11.44-12.78-14.84-19.28h-.26c1.31 4.05 2.97 8.57 4.92 12.19a22.82 22.82 0 0 1 2.43 7.25l.3.19c.03.18-.01.35-.08.53zm24.68 95.58c6.55 4.58 18.07 16.67 25.69 24.66 2.43 2.55 4.77 5.01 6.11 6.32.57-7.33.64-39.19-.32-43.99-.88-4.38-2.9-14.17-3.39-16.55-.79.18-1.75.27-2.86.27-5.12 0-13.31-1.92-22.22-6.03-11.76-5.43-18.27-21.77-21.76-30.55-.12-.31-.54-.61-.93-.9-.02.4-.03.8-.06 1.21-.11 1.32-.18 2.88-.18 4.71 0 2.75 1.13 7.36 1.37 9.64.12 1.12.22 2.34.31 3.61 1.05 5.76 2.52 13.61 3.63 19.18 2.05 10.24 5.03 21.71 14.61 28.42z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M744.96 561.52c-.19.06-11.17 3.68-21.42 6.76 8.81-2.09 19.23-2.17 22.2.21 4.37 3.5 4.37 24.35.99 29.42-2.69 4.03-7.32 4.86-12.68 5.82-1.4.25-2.84.51-4.32.84-4.53 1.01-13.26 4.77-18.05 6.92-.8.36-1.65.54-2.5.54-.92 0-1.84-.21-2.69-.62a6.04 6.04 0 0 1-3.2-3.98c-4.01-16.57 2.16-29.56 10.05-35.08 1.45-1.01 3.29-1.9 5.36-2.65-5.71 1.65-10.51 2.89-12.1 2.89-1.12 0-2.35-.64-3.55-1.86-3.47-3.5-6.92-11.89-6.81-22.74.04-3.75 1.87-7.33 4.91-9.57 5.4-4 14-9.29 24.23-11.85 17.6-4.4 22.03-1.68 22.97-.74.42.42.86 1.69 1.27 3.45l.02-18.69c-.52 2.81-1.23 5.12-2.16 6.5-3.39 5.08-9.27 6.13-16.08 7.35-1.8.33-3.66.66-5.56 1.08-5.84 1.3-17.06 6.14-23.22 8.91-.99.44-2.04.66-3.1.66-1.13 0-2.27-.26-3.32-.77a7.415 7.415 0 0 1-3.95-4.92c-1.11-4.58-1.61-8.95-1.61-13.05 0-.72.02-1.44.05-2.15-.21.48-.46.96-.74 1.42-1.44 2.38-3.3 5.04-5.46 7.14 1.53 5.16 6.98 24.28 4.99 28.26-.62 1.23-1.73 2.19-3.26 2.87 1.67 2.36 5.59 8.12 7.29 12.33 4.52 11.2 4.09 18.79 1.78 21.1-.06.06-.12.11-.19.17.28 1.38 2.54 12.26 3.48 16.94.03.15.06.33.08.53.01.05.01.11.02.16.02.2.05.41.07.64 0 .02 0 .04.01.06.02.26.05.54.07.84.01.09.01.18.02.28.02.26.04.53.05.81 0 .07.01.14.01.21l.06 1.07c.01.14.01.28.02.43.01.27.03.56.04.84.01.15.01.29.02.45.02.38.03.77.04 1.18.01.22.01.44.02.67.01.24.01.48.02.73.01.24.01.49.02.74l.03 1.2c.01.29.01.59.02.9 0 .19.01.39.01.58.01.72.03 1.46.04 2.21 2.19-1.33 4.62-2.21 6.88-3.42.15-.19.32-.38.5-.57.02-.02.03-.04.05-.05.17-.18.37-.34.57-.51.03-.03.06-.05.09-.08.2-.16.41-.32.63-.47l.12-.09c.22-.15.45-.29.69-.43.05-.03.1-.06.16-.09.24-.14.49-.27.74-.4.06-.03.13-.07.19-.1.25-.13.52-.25.79-.37.07-.03.14-.07.22-.1.27-.12.55-.23.84-.34l.24-.09c.28-.11.58-.21.87-.32.09-.03.17-.06.26-.09.3-.1.6-.2.91-.29.09-.03.19-.06.28-.09a115.484 115.484 0 0 1 1.23-.35c.32-.09.64-.17.96-.25.1-.03.2-.05.31-.08.32-.08.65-.16.98-.23.11-.02.22-.05.32-.07.33-.07.66-.15.99-.21.11-.02.22-.05.34-.07.33-.07.67-.13 1-.2l.33-.06 1.01-.18.34-.06c.34-.06.67-.11 1.01-.17.11-.02.23-.04.34-.05l1-.15c.11-.02.23-.03.34-.05.33-.05.66-.09.99-.14.11-.01.22-.03.33-.04l.96-.12c.12-.01.23-.03.35-.04.31-.04.62-.07.93-.11.12-.01.23-.03.34-.04.3-.03.6-.07.89-.1.12-.01.23-.02.35-.04.29-.03.57-.06.84-.08l.34-.03c.28-.03.55-.05.81-.07l.3-.03.78-.06c.1-.01.2-.02.31-.02.24-.02.48-.04.71-.05.1-.01.19-.01.29-.02.22-.02.44-.03.65-.04.1-.01.19-.01.28-.02.19-.01.39-.02.57-.04.1-.01.2-.01.29-.02l.48-.03c.09 0 .17-.01.25-.01.14-.01.28-.02.41-.02.11-.01.2-.01.3-.01.09 0 .19-.01.27-.01.09 0 .16-.01.23-.01s.16-.01.22-.01c.13-.01.24-.01.33-.01l.07-.01.08.01c5.55.62 9.1 2.07 10.77 4.4l.07-55.08c-.62 2-1.92 3.64-4.61 4.54z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M705.24 606.96a3.997 3.997 0 0 0 2.13 2.65 4.1 4.1 0 0 0 3.49.06c5.94-2.67 13.97-6.06 18.44-7.05 1.51-.34 2.98-.6 4.4-.86 5.11-.91 9.14-1.64 11.36-4.96 3.1-4.65 2.68-24.15-.57-26.75-1.14-.91-4.05-1.37-7.69-1.37-7.2 0-17.27 1.77-22.32 5.31-7.33 5.13-13.03 17.32-9.24 32.97zm-21.31-109.24a12.2 12.2 0 0 1 6.61 6.19c.48 1.02.81 2.07 1 3.15 2.05-10.26 7.36-18.1 13.49-22.39 3.53-2.47 8.91-4.35 14.66-5.57-.62.13-1.25.25-1.9.37-2.67.49-5.45.93-8.3 1.31h-.01c-2.01 1.57-16.2 12.53-25.55 16.94z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M694.19 528.92a5.387 5.387 0 0 0 2.89 3.59c1.49.73 3.21.76 4.72.08 7.61-3.42 17.89-7.76 23.6-9.03 1.95-.43 3.83-.77 5.65-1.09 6.62-1.19 11.85-2.13 14.76-6.5 4.02-6.02 3.44-31.32-.79-34.7-4.4-3.52-29.02-1.84-38.85 5.04-9.49 6.65-16.87 22.4-11.98 42.61zm51.57-2.25c-.85-.26-2.26-.53-4.51-.53-3.19 0-8.06.54-15.39 2.37-9.91 2.48-18.26 7.63-23.53 11.52-2.53 1.87-4.06 4.85-4.09 7.98v.46c0 10 3.21 17.8 6.23 20.86.79.8 1.57 1.26 2.13 1.26 3.69 0 30.48-8.55 37.73-10.96 3.56-1.19 3.8-3.82 3.95-8.74.05-1.66.1-3.54.38-5.47.96-6.77-.94-17.07-1.76-18.21 0 0-.29-.27-1.14-.54zm62.52 2.72a7.424 7.424 0 0 1-1.42 2.9c-.68.84-1.54 1.53-2.54 2.02-1.05.51-2.18.77-3.32.77-1.05 0-2.1-.22-3.09-.66-6.17-2.77-17.39-7.61-23.22-8.91-1.9-.42-3.76-.75-5.56-1.08-6.81-1.22-12.69-2.27-16.08-7.35-.75-1.13-1.37-2.86-1.85-4.99v-.08c-.09-.39-.18-.81-.26-1.23v1.31l-.03 16.11v1.07c.09-.38.17-.74.26-1.07.33-1.2.67-2.04 1-2.37.94-.94 5.37-3.66 22.98.74 10.23 2.56 18.82 7.85 24.23 11.85 3.03 2.24 4.87 5.82 4.9 9.57v.51c0 10.6-3.39 18.78-6.8 22.23-1.2 1.22-2.43 1.86-3.56 1.86-1.58 0-6.38-1.23-12.07-2.88 2.06.75 3.9 1.63 5.34 2.64 7.89 5.52 14.05 18.51 10.04 35.08a6.012 6.012 0 0 1-3.2 3.98c-.85.41-1.76.62-2.68.62-.85 0-1.7-.18-2.5-.54-4.8-2.15-13.52-5.91-18.05-6.92-1.48-.33-2.93-.59-4.33-.84-5.35-.96-9.98-1.79-12.67-5.82-3.38-5.07-3.39-25.92.99-29.42 2.97-2.38 13.38-2.3 22.2-.21-10.25-3.08-21.23-6.7-21.42-6.76-2.46-.82-3.75-2.25-4.45-4.04-.11-.28-.18-.58-.26-.87v.87l-.09 54.49v.41c.08-.14.16-.28.26-.41 1.68-2.3 5.24-3.73 10.75-4.34l.07-.01.08.01c.08 0 .18.01.3.01.07 0 .16.01.24.01.06 0 .11 0 .17.01.09 0 .2.01.31.01.07 0 .14.01.22.01.12.01.25.01.38.02.07 0 .14.01.22.01l.47.03c.07 0 .14.01.22.01l.57.03c.05 0 .1.01.16.01 6.76.43 21.43 1.85 27.47 6.15.24-.17.55-.25.85-.18 2.61.56 5.27.97 7.82 1.78v-.01c.01-.52.03-1.03.04-1.53 0-.09 0-.18.01-.27.01-.48.03-.95.04-1.4 0-.1.01-.19.01-.29.02-.45.03-.89.05-1.32 0-.08.01-.15.01-.23l.06-1.25c0-.04 0-.08.01-.13.02-.39.04-.77.06-1.12 0-.04 0-.07.01-.11.02-.36.04-.69.07-1.01 0-.05.01-.1.01-.15.02-.3.05-.58.07-.84 0-.05.01-.09.01-.14.02-.25.05-.49.08-.69 0-.03.01-.05.01-.08.03-.21.06-.4.09-.55.94-4.69 3.19-15.58 3.48-16.95-.07-.05-.14-.11-.2-.17-2.31-2.31-2.74-9.9 1.78-21.1 1.7-4.21 5.62-9.97 7.29-12.33-1.53-.69-2.63-1.64-3.25-2.87-1.99-3.98 3.45-23.1 4.98-28.26-2.16-2.1-4.02-4.76-5.46-7.14-.28-.45-.52-.92-.73-1.4.18 4.72-.28 9.8-1.58 15.19zm.71-22.36c.18-1.07.51-2.11.99-3.12 1.36-2.88 3.74-5.07 6.62-6.19-9.36-4.4-23.55-15.37-25.56-16.94-2.85-.38-5.64-.82-8.32-1.31-.64-.12-1.27-.24-1.89-.37 5.75 1.22 11.13 3.1 14.66 5.57 6.13 4.29 11.44 12.11 13.5 22.36z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M769.48 522.47c1.82.32 3.7.66 5.64 1.09 5.71 1.27 15.99 5.61 23.61 9.03 1.51.68 3.23.65 4.71-.08a5.36 5.36 0 0 0 2.89-3.59c4.9-20.21-2.49-35.97-11.98-42.61-6.5-4.55-19.48-6.83-28.79-6.83-4.76 0-8.57.6-10.05 1.79-4.23 3.38-4.81 28.68-.8 34.7 2.92 4.37 8.15 5.31 14.77 6.5zm-17.23 28.42c.14 4.92.38 7.55 3.95 8.74 7.25 2.41 34.04 10.96 37.72 10.96.57 0 1.34-.46 2.14-1.26 3.07-3.11 6.33-11.1 6.22-21.32-.02-1.56-.4-3.09-1.11-4.46a10.08 10.08 0 0 0-2.98-3.52c-5.26-3.89-13.62-9.04-23.53-11.52-7.3-1.83-12.17-2.37-15.36-2.37-4.53 0-5.69 1.09-5.71 1.1-.78 1.11-2.69 11.41-1.72 18.18.27 1.93.33 3.81.38 5.47zm3.78 19.16c-3.25 2.6-3.67 22.1-.57 26.75 2.22 3.32 6.26 4.05 11.37 4.96 1.41.26 2.88.52 4.4.86 4.47.99 12.49 4.38 18.44 7.05 1.11.5 2.39.48 3.48-.06 1.08-.53 1.86-1.5 2.14-2.65.83-3.43 1.21-6.7 1.21-9.77 0-10.89-4.74-19.2-10.46-23.2-5.05-3.54-15.12-5.31-22.31-5.31-3.65 0-6.56.46-7.7 1.37zm117.69-98.72c-.07.32-.15.65-.24.98 0 .01 0 .02-.01.02-.09.32-.18.65-.29.98 0 .01-.01.02-.01.03-.11.33-.22.65-.34.98 0 .01-.01.02-.01.04-.12.33-.25.65-.39.98-.01.01-.01.03-.02.04-.14.33-.28.66-.43.98-.01.02-.01.03-.02.05-.15.33-.31.65-.47.98l-.03.06c-.16.32-.33.65-.5.97l-.03.06c-.17.32-.35.64-.54.97-.01.02-.03.04-.04.07-.18.32-.37.64-.56.95-.01.02-.03.05-.04.07-.19.32-.39.63-.59.94-.02.02-.03.05-.05.07-.2.31-.4.62-.61.93l-.06.09c-.2.3-.41.61-.62.91a.55.55 0 0 1-.07.09c-.21.3-.42.59-.63.89l-.07.1c-.21.29-.43.58-.64.86l-.08.11c-.21.28-.43.56-.65.84l-.09.12c-.21.27-.43.54-.64.81l-.11.14c-.21.26-.42.51-.63.77-.04.05-.08.1-.12.14-.21.25-.42.49-.63.73-.04.05-.09.1-.13.15-.2.24-.41.47-.61.7-.05.06-.1.11-.15.17-.2.22-.39.44-.59.65-.06.06-.11.12-.17.19-.19.2-.37.4-.56.6-.07.07-.13.14-.2.21-.18.19-.35.37-.53.55l-.21.21c-.17.17-.34.34-.5.51-.07.07-.14.14-.22.21-.16.16-.32.31-.47.47-.08.08-.17.16-.25.24-.14.13-.28.27-.42.4-.09.09-.18.17-.27.25-.13.12-.25.24-.38.35-.09.09-.18.17-.28.25-.11.1-.23.21-.34.3-.1.09-.19.17-.29.25-.1.08-.2.17-.29.25-.11.09-.21.17-.31.26-.08.06-.16.13-.24.19-.12.1-.23.18-.34.27-.06.04-.11.09-.17.13-.16.12-.32.24-.47.35-4.12 2.94-10.14 3.82-16.22 3.82-5.51 0-11.07-.72-15.27-1.27l-1.77-.23c-.64-.08-1.37-.27-2.16-.53h-.01l-.1.02c-3.44.5-6.27 2.61-7.77 5.78-1.49 3.16-1.31 6.83.49 9.81 2.57 4.25 6.53 9.43 10.8 9.96 6.63.83 19.13 1.31 28.35-4.84 7.87-5.25 14.21-18.43 16.92-24.07.3-.63.56-1.16.76-1.57.69-1.37 1.67-3.51 2.67-5.72.85-2.05 1.97-4.79 3.08-7.55.06-.13.11-.24.15-.35.58-1.42 1.15-2.83 1.68-4.15-.78-2.05-1.73-4.02-2.78-5.94-.05.32-.11.65-.18.97.02-.01.01-.01.01 0zm-41.34 111.18c-8.91 4.11-17.1 6.03-22.22 6.03-1.1 0-2.05-.09-2.85-.27-.49 2.37-2.52 12.17-3.39 16.55-.96 4.79-.89 36.66-.32 43.99 1.34-1.32 3.68-3.77 6.12-6.33 7.62-8 19.13-20.08 25.68-24.66 9.58-6.71 12.56-18.18 14.61-28.41 1.2-5.99 2.43-14.62 3.2-20.45.07-.81.14-1.6.22-2.34.07-.68.23-1.58.41-2.56.11-.88.16-1.39.16-1.42l.09-.01c.36-1.98.71-4.1.71-5.65 0-1.83-.07-3.39-.18-4.71-.03-.45-.05-.9-.06-1.35-.13.33-.27.67-.42 1.04-3.49 8.78-9.99 25.12-21.76 30.55z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M837.25 552.53c-6.05 1.72-11.38 2.58-15.66 2.58-2.01 0-3.79-.19-5.3-.57-1.34 1.88-5.7 8.13-7.42 12.42-4.2 10.4-3.83 17.33-2.23 18.94 1.29 1.28 11.31 1.06 24.91-5.21 11.03-5.09 17.34-20.95 20.74-29.47.49-1.23.92-2.31 1.29-3.19.37-.86.75-1.67 1.14-2.45.02-.21.03-.43.05-.64v-.01c.32-2.7.93-5.37 1.8-7.96.26-.77.53-1.6.83-2.48.77-2.32 1.27-4.49 1.59-6.45-5.6 13.57-13.06 22-21.74 24.49z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyParts', d: 'M852.54 521.36c-6.75 4.51-15.08 5.66-21.86 5.66-3.01 0-5.72-.23-7.85-.49-1.81-.23-3.54-1.1-5.14-2.33-2.7 9.27-6.11 23.4-4.85 25.92 1.59 3.18 9.58 4.56 23.86.48 8.77-2.5 17.19-11.76 22.8-26.79.04-.7.12-1.4.24-2.09.39-2.6 1.22-5.12 2.47-7.45 1.74-3.24 3.25-7.2 4.49-10.91-3.39 6.32-8.32 14.12-14.16 18zm-101.68 36.12v-.87c-.44-1.59-.54-3.37-.59-5.23-.05 1.6-.12 3.16-.42 4.57-.07.34-.16.67-.26 1l-.07 55.08c.08.12.19.23.26.35.2.32.36.65.49 1 .13-.35.3-.68.5-1v-.41l.09-54.49zm-.98-27v.02c.13.71.26 1.47.38 2.27.19-1.29.41-2.48.65-3.5v-1.07l.03-16.11v-1.31c-.29-1.48-.52-3.11-.68-4.81-.1 1.05-.22 2.07-.36 3.04-.08.54-.17 1.06-.26 1.57l-.02 18.69c.09.39.18.78.26 1.21z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M691.54 507.06c.43 2.4.14 4.87-.85 7.11.01.01 0 .01 0 .02-.03.71-.05 1.43-.05 2.15 0 4.1.5 8.47 1.61 13.05a7.415 7.415 0 0 0 3.95 4.92c1.05.51 2.19.77 3.32.77 1.06 0 2.11-.22 3.1-.66 6.16-2.77 17.38-7.61 23.22-8.91 1.9-.42 3.76-.75 5.56-1.08 6.81-1.22 12.69-2.27 16.08-7.35.92-1.38 1.64-3.69 2.16-6.5v-1.57l.02-19.57v-1.6c-.7-3.84-1.81-6.87-3.39-8.13-3.58-2.87-15.72-2.91-26.55-.62-.01 0-.02.01-.03.01-5.75 1.22-11.13 3.1-14.66 5.57-6.13 4.29-11.44 12.13-13.49 22.39zm53.48-25.79c4.23 3.38 4.81 28.68.79 34.7-2.91 4.37-8.14 5.31-14.76 6.5-1.82.32-3.7.66-5.65 1.09-5.71 1.27-15.99 5.61-23.6 9.03-1.51.68-3.23.65-4.72-.08a5.387 5.387 0 0 1-2.89-3.59c-4.89-20.21 2.49-35.96 11.98-42.61 9.83-6.88 34.45-8.56 38.85-5.04z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M749.64 509.01v1.57c.09-.51.18-1.03.26-1.57.14-.97.26-1.99.36-3.04-.41-4.37-.42-9.29 0-13.71-.09-.97-.2-1.91-.34-2.82-.08-.55-.17-1.08-.26-1.6v1.6l-.02 19.57zM718.7 569.7c-2.07.75-3.91 1.64-5.36 2.65-7.89 5.52-14.06 18.51-10.05 35.08a6.04 6.04 0 0 0 3.2 3.98c.85.41 1.77.62 2.69.62.85 0 1.7-.18 2.5-.54 4.79-2.15 13.52-5.91 18.05-6.92 1.48-.33 2.92-.59 4.32-.84 5.36-.96 9.99-1.79 12.68-5.82 3.38-5.07 3.38-25.92-.99-29.42-2.97-2.38-13.39-2.3-22.2-.21-1.63.49-3.23.96-4.77 1.4-.03.01-.05.02-.07.02zm18.1-1.02c3.64 0 6.55.46 7.69 1.37 3.25 2.6 3.67 22.1.57 26.75-2.22 3.32-6.25 4.05-11.36 4.96-1.42.26-2.89.52-4.4.86-4.47.99-12.5 4.38-18.44 7.05a4.1 4.1 0 0 1-3.49-.06 3.997 3.997 0 0 1-2.13-2.65c-3.79-15.65 1.91-27.84 9.24-32.97 5.05-3.54 15.12-5.31 22.32-5.31z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm749.6 545.44.01-9.29.01-5.65v-1.22c-.41-1.75-.85-3.03-1.27-3.45-.94-.94-5.37-3.66-22.97.74-10.23 2.56-18.83 7.85-24.23 11.85a12.112 12.112 0 0 0-4.91 9.57c-.11 10.85 3.34 19.24 6.81 22.74 1.2 1.22 2.43 1.86 3.55 1.86 1.59 0 6.39-1.24 12.1-2.89.02 0 .04-.01.07-.02 1.49-.54 3.1-1.01 4.77-1.4 10.25-3.08 21.23-6.7 21.42-6.76 2.69-.9 3.99-2.54 4.63-4.57v-1l.01-10.51zm-.94-.02c-.28 1.93-.33 3.81-.38 5.47-.15 4.92-.39 7.55-3.95 8.74-7.25 2.41-34.04 10.96-37.73 10.96-.56 0-1.34-.46-2.13-1.26-3.02-3.06-6.23-10.86-6.23-20.86v-.46c.03-3.13 1.56-6.11 4.09-7.98 5.27-3.89 13.62-9.04 23.53-11.52 7.33-1.83 12.2-2.37 15.39-2.37 2.25 0 3.66.27 4.51.53.85.27 1.14.54 1.14.54.82 1.14 2.72 11.44 1.76 18.21z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm749.89 545.7-.03-.26c-.36-2.68-.29-6.08.01-9.29.1-1.17.24-2.31.39-3.38-.12-.8-.25-1.56-.38-2.27v-.02c-.08-.42-.17-.82-.26-1.2v1.22l-.01 5.65-.01 9.29-.01 10.51v1c.1-.32.19-.66.26-1 .3-1.41.37-2.97.42-4.57-.01-.14-.02-.29-.02-.43-.05-1.69-.1-3.43-.36-5.25zm-26.35 22.58c-1.67.39-3.28.86-4.77 1.4 1.54-.44 3.14-.91 4.77-1.4zm-.44 40.84c-.34.05-.67.11-1.01.17.34-.06.68-.12 1.01-.17zm6.47-.84c-.29.03-.59.06-.89.1.3-.04.6-.07.89-.1zm6.23-.51c-.18.01-.37.02-.57.04.2-.02.39-.03.57-.04zm.78-.05-.48.03.48-.03zm-14.82 1.62-1.01.18c.33-.06.67-.12 1.01-.18zm15.48-1.65c-.13.01-.27.01-.41.02.15-.01.29-.02.41-.02zm-12.8 1.22zm7.48-.86c-.27.02-.54.05-.81.07.27-.02.54-.04.81-.07zm-1.15.11c-.28.03-.56.05-.84.08.28-.03.56-.06.84-.08zm-2.43.25c-.31.03-.61.07-.93.11.31-.04.62-.08.93-.11zm9.47-.75c-.08 0-.18.01-.27.01.09 0 .19-.01.27-.01zm-2.86.16c-.21.01-.43.03-.65.04.23-.01.45-.03.65-.04zm-9.18.91zm1.29-.17-.96.12c.32-.04.65-.08.96-.12zm6.95-.67c-.23.02-.47.04-.71.05.24-.02.48-.04.71-.05zm-1.01.07-.78.06c.26-.01.52-.04.78-.06zm-12.59 1.63c-.34.06-.67.13-1 .2.34-.07.67-.14 1-.2zm-10.73 3.26c-.25.13-.5.26-.74.4.24-.14.49-.27.74-.4zm.98-.46c-.27.12-.54.24-.79.37.26-.13.52-.25.79-.37zm-1.88.96c-.24.14-.47.28-.69.43.22-.15.46-.29.69-.43zm-2.64 2.19zm12.94-5.69-.99.21.99-.21zm-11.11 4.01c-.22.15-.43.31-.63.47.2-.16.41-.31.63-.47zm3.74-1.91zm26.56-4.31c-.06 0-.15.01-.22.01.07 0 .16-.01.22-.01zm-21.8 2.81c-.32.08-.65.17-.96.25.32-.08.64-.16.96-.25zm-1.25.34zm2.54-.65c-.33.08-.66.15-.98.23.33-.07.65-.15.98-.23zm-4.93 1.4zm-6.14 3.38c.17-.17.37-.34.57-.51-.21.17-.4.34-.57.51zm7.3-3.77c-.31.1-.61.19-.91.29.31-.1.61-.19.91-.29zm-75.15-120.11c.02.02.04.05.07.07.41.44.81.87 1.21 1.27l.1.1c.4.41.79.8 1.17 1.17 0 0 .01 0 .01.01.38.37.75.71 1.1 1.04.03.03.06.05.08.08.33.31.66.59.96.86.05.05.11.09.16.14.3.25.58.49.85.71.04.03.08.07.13.1.27.22.53.42.77.58 4.12 2.94 10.14 3.82 16.22 3.82 5.51 0 11.07-.72 15.27-1.27l1.77-.23c.64-.08 1.37-.27 2.17-.53l-.21-.03.25-1.98.35.05c.93.14 1.83.38 2.67.71 9.36-4.4 23.54-15.37 25.55-16.94-1.3.18-2.61.34-3.94.5h-.01c-6.32 4.76-21.12 15.49-27.08 16.23l-1.78.23c-7.98 1.04-22.85 2.96-30.07-2.2-4.98-3.56-17.15-16.76-18.09-26.17-.74-7.36 1.91-24.68 3.36-33.09-.43-1.72-.81-3.35-1.15-4.84v-.01c-.48 2.54-5.2 28.16-4.2 38.14.14 1.44.52 2.93 1.06 4.45 2.12 6 6.93 12.37 11.25 17.03zm4.7 4.61c-.31-.27-.63-.55-.96-.86.33.3.65.59.96.86zm-2.16-1.99c-.38-.37-.77-.76-1.17-1.17.4.4.79.8 1.17 1.17zm-1.27-1.27c-.4-.41-.8-.83-1.21-1.27l1.21 1.27zm2.38 2.32c-.36-.33-.72-.67-1.1-1.04l1.1 1.04zm2.06 1.78zm.89.68z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M627.58 474.02c2.13 5.98 6.93 12.35 11.26 17.02-4.32-4.66-9.13-11.03-11.26-17.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M647.98 521.36c6.76 4.51 15.08 5.66 21.86 5.66 3.02 0 5.73-.23 7.85-.49 1.81-.23 3.54-1.1 5.14-2.33-.14-.5-.29-.99-.43-1.46l1.92-.57c.05.17.11.36.17.58 2.16-2.1 4.02-4.76 5.46-7.14.28-.46.53-.94.74-1.42 0-.01.01-.01 0-.02.11-2.48.4-4.84.85-7.1v-.01c-.19-1.08-.52-2.13-1-3.15a12.2 12.2 0 0 0-6.61-6.19h-.01c-1.1.52-2.13.94-3.06 1.25h.01l.09.01c3.44.51 6.28 2.62 7.77 5.79a10.35 10.35 0 0 1-.49 9.81c-2.57 4.25-6.52 9.43-10.8 9.96-6.63.83-19.13 1.31-28.35-4.84-7.87-5.25-14.21-18.44-16.91-24.07-.31-.63-.56-1.17-.77-1.57-.78-1.58-2.21-4.17-3.6-6.72.88 2.12 1.55 3.72 1.8 4.21.47.94 1.59 5.36 3.27 10.52v.01h.26c3.4 6.5 8.61 15.13 14.84 19.28z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M691.54 507.07a46.91 46.91 0 0 0-.85 7.1c.99-2.24 1.28-4.71.85-7.1zm-51.31 14.45-.05-.03c.03.09.06.17.09.26 0-.01 0-.03-.01-.04 0-.06-.02-.13-.03-.19z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm640.53 521.71-.3-.19c.01.06.03.12.04.19 0 .01 0 .03.01.04.06.17.12.33.18.49.06-.18.1-.35.07-.53zm22.75 30.82c6.05 1.72 11.38 2.58 15.66 2.58 2.01 0 3.79-.19 5.3-.57-.25-.34-.39-.54-.4-.55l1.61-1.19c.05.07.33.46.77 1.08 1.53-.68 2.64-1.64 3.26-2.87 1.99-3.98-3.46-23.1-4.99-28.26-.53.52-1.09 1.01-1.66 1.45 2.7 9.27 6.12 23.4 4.86 25.92-1.59 3.18-9.59 4.56-23.86.48-9.09-2.59-17.78-12.4-23.38-28.36-.02.06-.05.12-.08.18.06.47.11.94.14 1.42.06.96.16 2.03.33 3.18v.01c.13.93.31 1.93.53 2.97 5.64 12.42 13.64 20.16 21.91 22.53z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M682.4 522.74c.14.47.29.96.43 1.46.57-.44 1.13-.93 1.66-1.45-.06-.22-.12-.41-.17-.58l-1.92.57zm-36.02 29.22c3.49 8.78 10 25.12 21.76 30.55 8.91 4.11 17.1 6.03 22.22 6.03 1.11 0 2.07-.09 2.86-.27l-.11-.53 1.96-.41.03.15c.07-.06.13-.11.19-.17 2.31-2.31 2.74-9.9-1.78-21.1-1.7-4.21-5.62-9.97-7.29-12.33-.6.27-1.26.49-1.98.66 1.34 1.88 5.69 8.13 7.42 12.42 4.19 10.4 3.82 17.33 2.22 18.94-1.29 1.28-11.31 1.06-24.9-5.21-11.04-5.09-17.35-20.95-20.74-29.47-.49-1.23-.92-2.31-1.3-3.19-.3-.7-1.01-1.37-1.62-2.01.14 1.45.21 2.9.17 4.36-.01.23-.03.46-.04.68.39.29.81.59.93.9z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M683.84 553.99c.01.01.15.21.4.55.72-.17 1.38-.39 1.98-.66-.44-.62-.72-1.01-.77-1.08l-1.61 1.19zm-32.53 46.82c.02-.11.03-.19.04-.24l1.97.34c-.01.07-.25 1.47-.6 3.75 2.33 5.69 5.76 10.94 11.27 14.79 6.39 4.47 17.82 16.47 25.38 24.41 4.6 4.83 6.39 6.67 7.25 7.37-.01-.32-.02-.51-.02-.54l2-.05c0 .05 0 .13.01.24.31-1.02.75-4.86.74-21.85 0-2.55-.02-5.17-.05-7.72l-.03-2.37c-.01-.75-.03-1.49-.04-2.21 0-.2-.01-.39-.01-.58-.01-.3-.01-.6-.02-.9l-.03-1.2c-.01-.25-.01-.49-.02-.74s-.01-.49-.02-.73c-.01-.22-.01-.45-.02-.67-.01-.4-.03-.8-.04-1.18-.01-.15-.01-.3-.02-.45-.01-.29-.02-.57-.04-.84-.01-.14-.01-.29-.02-.43l-.06-1.07c0-.07-.01-.14-.01-.21-.02-.29-.04-.56-.05-.81-.01-.09-.01-.19-.02-.28-.02-.3-.05-.59-.07-.84 0-.02 0-.04-.01-.06-.02-.24-.05-.45-.07-.64-.01-.06-.01-.11-.02-.16-.03-.2-.06-.38-.08-.53-.94-4.69-3.19-15.57-3.48-16.94-.44.35-1.07.62-1.88.79.49 2.38 2.52 12.17 3.39 16.55.96 4.79.89 36.66.32 43.99-1.34-1.32-3.68-3.77-6.11-6.32-7.62-8-19.14-20.08-25.69-24.66-9.58-6.71-12.56-18.18-14.61-28.41-1.11-5.56-2.58-13.41-3.63-19.18.05.68.09 1.38.13 2.09v.05c.2 3.59.31 7.56.46 11.45v.03c.01.18.01.37.02.55.37 1.91.73 3.74 1.06 5.39.7 3.61 1.54 7.36 2.73 11.02z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M698.68 605.12c-.01-.06-.01-.11-.02-.16 0 .05.01.1.02.16zm.53 11.05c-.01-.3-.01-.6-.02-.9.01.29.01.59.02.9zm.05 2.79c-.01-.75-.03-1.49-.04-2.21.02.72.03 1.46.04 2.21zm-.34-10.99c0-.07-.01-.14-.01-.21 0 .07 0 .14.01.21zm.24 6.1c-.01-.25-.01-.49-.02-.74 0 .24.01.49.02.74zm-.11-3.31c-.01-.15-.01-.3-.02-.45.01.15.01.3.02.45zm-.06-1.29c-.01-.14-.01-.29-.02-.43.01.14.02.28.02.43zm.12 3.13c-.01-.22-.01-.45-.02-.67.01.22.02.45.02.67zm-.35-6.78c0-.02 0-.04-.01-.06 0 .02 0 .04.01.06zm.09 1.13c-.01-.09-.01-.19-.02-.28 0 .09.01.18.02.28zm.44 14.38c.03 2.55.05 5.17.05 7.72 0-2.55-.01-5.18-.05-7.72zm-6.18-33.59.11.53c.81-.17 1.44-.44 1.88-.79-.02-.09-.03-.15-.03-.15l-1.96.41zm-41.76 12.83c-.01.05-.02.13-.04.24.42 1.3.89 2.59 1.41 3.85.35-2.28.59-3.68.6-3.75l-1.97-.34zm99.85-88.56v.08c.48 2.13 1.1 3.86 1.85 4.99 3.39 5.08 9.27 6.13 16.08 7.35 1.8.33 3.66.66 5.56 1.08 5.83 1.3 17.05 6.14 23.22 8.91.99.44 2.04.66 3.09.66 1.14 0 2.27-.26 3.32-.77 1-.49 1.86-1.18 2.54-2.02.67-.84 1.16-1.82 1.42-2.9 1.3-5.39 1.76-10.47 1.56-15.18v-.01c-1-2.26-1.29-4.75-.85-7.16v-.01c-2.06-10.25-7.37-18.07-13.49-22.36-3.53-2.47-8.91-4.35-14.66-5.57-10.84-2.3-23-2.26-26.58.61-1.32 1.05-2.32 3.35-3.02 6.33v.04c-.09.39-.18.8-.26 1.22l-.04 23.49c.08.41.17.82.26 1.22zm4.31-30.74c1.48-1.19 5.29-1.79 10.05-1.79 9.31 0 22.29 2.28 28.79 6.83 9.49 6.64 16.88 22.4 11.98 42.61a5.36 5.36 0 0 1-2.89 3.59c-1.48.73-3.2.76-4.71.08-7.62-3.42-17.9-7.76-23.61-9.03-1.94-.43-3.82-.77-5.64-1.09-6.62-1.19-11.85-2.13-14.77-6.5-4.01-6.02-3.43-31.32.8-34.7zm-5.25 24.7c.16 1.71.39 3.33.68 4.81l.04-23.49c-.31 1.53-.55 3.19-.72 4.96.42 4.43.41 9.35 0 13.72z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M750.26 505.97c.41-4.37.42-9.29 0-13.71-.42 4.42-.41 9.34 0 13.71zm26.73 62.31c-8.82-2.09-19.23-2.17-22.2.21-4.38 3.5-4.37 24.35-.99 29.42 2.69 4.03 7.32 4.86 12.67 5.82 1.4.25 2.85.51 4.33.84 4.53 1.01 13.25 4.77 18.05 6.92.8.36 1.65.54 2.5.54.92 0 1.83-.21 2.68-.62 1.62-.8 2.78-2.25 3.2-3.98 4.01-16.57-2.15-29.56-10.04-35.08-1.44-1.01-3.28-1.89-5.34-2.64-.03 0-.06-.01-.09-.03-1.54-.44-3.15-.91-4.77-1.4zm9.05 5.71c5.72 4 10.46 12.31 10.46 23.2 0 3.07-.38 6.34-1.21 9.77a4.011 4.011 0 0 1-2.14 2.65c-1.09.54-2.37.56-3.48.06-5.95-2.67-13.97-6.06-18.44-7.05-1.52-.34-2.99-.6-4.4-.86-5.11-.91-9.15-1.64-11.37-4.96-3.1-4.65-2.68-24.15.57-26.75 1.14-.91 4.05-1.37 7.7-1.37 7.19 0 17.26 1.77 22.31 5.31z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm750.89 542.75-.02 13.86c.08.29.15.59.26.87.7 1.79 1.99 3.22 4.45 4.04.19.06 11.17 3.68 21.42 6.76 1.67.39 3.28.86 4.77 1.4.03.02.06.03.09.03 5.69 1.65 10.49 2.88 12.07 2.88 1.13 0 2.36-.64 3.56-1.86 3.41-3.45 6.8-11.63 6.8-22.23v-.51c-.03-3.75-1.87-7.33-4.9-9.57-5.41-4-14-9.29-24.23-11.85-17.61-4.4-22.04-1.68-22.98-.74-.33.33-.67 1.17-1 2.37-.09.33-.18.69-.26 1.07l-.02 10.82c.01.9.02 1.8-.01 2.66zm2.7-15.51c.02-.01 1.18-1.1 5.71-1.1 3.19 0 8.06.54 15.36 2.37 9.91 2.48 18.27 7.63 23.53 11.52 1.27.94 2.28 2.15 2.98 3.52.71 1.37 1.09 2.9 1.11 4.46.11 10.22-3.15 18.21-6.22 21.32-.8.8-1.57 1.26-2.14 1.26-3.68 0-30.47-8.55-37.72-10.96-3.57-1.19-3.81-3.82-3.95-8.74-.05-1.66-.11-3.54-.38-5.47-.97-6.77.94-17.07 1.72-18.18zm-2.7 12.85.02-10.82a49.6 49.6 0 0 0-.65 3.5c.34 2.28.57 4.85.63 7.32zm-.25 5.61c-.26 1.82-.31 3.56-.36 5.25 0 .14-.01.29-.01.43.05 1.86.15 3.64.59 5.23l.02-13.86a26.49 26.49 0 0 1-.24 2.95z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M750.64 545.7c.13-.91.21-1.9.24-2.95.03-.86.03-1.75 0-2.66-.06-2.47-.29-5.04-.63-7.32-.15 1.07-.29 2.21-.39 3.38-.3 3.21-.37 6.61-.01 9.29l.03.26c.26 1.82.31 3.56.36 5.25 0 .14.01.29.02.43 0-.14.01-.29.01-.43.06-1.69.11-3.43.37-5.25zm26.35 22.58c1.62.49 3.23.96 4.77 1.4-1.49-.54-3.1-1.01-4.77-1.4zm17.8 47.86c-.02-.03-.05-.06-.07-.1.03.04.05.07.07.1zm-31.23-8.44c-.13-.01-.26-.01-.38-.02.12.01.25.01.38.02zm29.1 6.24c-6.05-4.3-20.71-5.72-27.47-6.15 6.76.44 21.43 1.85 27.47 6.15zm-28.41-6.2-.47-.03.47.03zm.79.05-.57-.03c.18 0 .37.01.57.03zm-2.08-.12c-.11 0-.21-.01-.31-.01.1 0 .2.01.31.01zm-.48-.02c-.09 0-.17-.01-.24-.01.07 0 .15.01.24.01zm56.79-110.64.36-.05.25 1.98-.21.03c.79.26 1.52.45 2.16.53l1.77.23c4.21.55 9.76 1.27 15.27 1.27 6.07 0 12.1-.87 16.22-3.82.15-.11.3-.22.47-.35.05-.04.11-.09.17-.13.11-.09.22-.17.34-.27.08-.06.16-.13.24-.19.1-.09.21-.17.31-.26.1-.08.2-.17.29-.25.1-.08.19-.16.29-.25.11-.1.23-.2.34-.3l.28-.25.38-.35c.09-.08.18-.17.27-.25.14-.13.28-.27.42-.4.08-.08.16-.16.25-.24.16-.15.31-.31.47-.47.07-.07.14-.14.22-.21.17-.17.33-.34.5-.51l.21-.21c.17-.18.35-.36.53-.55.07-.07.13-.14.2-.21.19-.2.37-.4.56-.6.06-.06.11-.12.17-.19.2-.21.39-.43.59-.65.05-.06.1-.11.15-.17.2-.23.41-.46.61-.7.04-.05.09-.1.13-.15.21-.24.42-.49.63-.73.04-.05.08-.1.12-.14.21-.25.42-.51.63-.77l.11-.14c.22-.27.43-.53.64-.81l.09-.12c.22-.28.43-.56.65-.84l.08-.11c.22-.29.43-.57.64-.86l.07-.1c.21-.29.43-.59.63-.89a.55.55 0 0 1 .07-.09c.21-.3.42-.6.62-.91l.06-.09c.21-.31.41-.62.61-.93.02-.02.03-.05.05-.07.2-.31.4-.63.59-.94.01-.02.03-.05.04-.07.19-.32.38-.64.56-.95.01-.02.03-.04.04-.07.18-.32.36-.64.54-.97l.03-.06c.17-.32.34-.65.5-.97l.03-.06c.16-.33.32-.65.47-.98.01-.02.01-.03.02-.05.15-.33.29-.66.43-.98.01-.01.01-.03.02-.04.14-.33.27-.66.39-.98 0-.01.01-.02.01-.04.12-.33.24-.66.34-.98 0-.01.01-.02.01-.03.11-.33.2-.65.29-.98 0-.01 0-.02.01-.02.09-.33.17-.65.24-.98v-.01c.07-.33.13-.65.18-.97.04-.26.08-.51.1-.77 1-9.97-3.69-35.42-4.2-38.11v.01c-.35 1.49-.73 3.09-1.15 4.81v.01c1.45 8.41 4.1 25.7 3.36 33.08-.94 9.41-13.11 22.61-18.09 26.17-7.22 5.16-22.08 3.23-30.07 2.2l-1.78-.23c-5.96-.75-20.76-11.47-27.08-16.23H795c-1.32-.16-2.64-.32-3.94-.5 2.01 1.57 16.2 12.54 25.56 16.94.83-.33 1.72-.57 2.65-.71z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M861.98 490.73c.2-.21.39-.43.59-.65-.2.22-.39.44-.59.65zm5.86-7.26c.21-.3.42-.6.62-.91-.21.31-.41.61-.62.91zm-5.12 6.44c.2-.23.41-.46.61-.7-.2.24-.41.47-.61.7zm5.8-7.43c.21-.31.41-.62.61-.93-.21.31-.41.62-.61.93zm1.28-2.02c.19-.32.38-.64.56-.95-.18.32-.36.63-.56.95zm-10.67 13.21c.16-.15.31-.31.47-.47-.16.17-.32.32-.47.47zm10.04-12.19c.2-.31.4-.63.59-.94-.19.31-.39.62-.59.94zm-2.75 3.93c.22-.29.43-.57.64-.86-.21.29-.43.58-.64.86zm-5.17 6.11c.19-.2.37-.4.56-.6-.19.2-.38.4-.56.6zm2.96-3.34c.21-.25.42-.51.63-.77-.21.26-.42.52-.63.77zm1.48-1.82c.22-.28.43-.56.65-.84-.22.28-.43.56-.65.84zm-2.23 2.7c.21-.24.42-.49.63-.73-.21.25-.42.49-.63.73zm1.49-1.78zm2.18-2.83c.21-.29.43-.59.63-.89-.2.3-.41.6-.63.89zm3.27-5.01c.18-.32.36-.64.54-.97-.17.33-.35.65-.54.97zm-9.87 12.83c.17-.18.35-.36.53-.55-.18.19-.36.37-.53.55zm12.96-19.97zm-13.17 20.19zm-3.71 3.48c.09-.08.2-.17.29-.25-.09.08-.19.17-.29.25zm16.58-22.66c.11-.33.2-.65.29-.98-.09.32-.18.65-.29.98zm-15.38 21.6.38-.35c-.13.12-.25.24-.38.35zm.65-.6c.14-.13.28-.27.42-.4-.14.14-.28.27-.42.4zm14.38-19.99zm1.06-3.98c-.05.32-.11.65-.18.97.08-.32.14-.65.18-.97zm-16.7 25.13c.11-.1.23-.2.34-.3-.12.09-.23.2-.34.3zm15.24-20.13zm-1.47 3.08c.17-.32.34-.65.5-.97-.16.32-.32.64-.5.97zm-15.42 18.41c.05-.04.11-.09.17-.13-.05.04-.11.09-.17.13zm16.44-20.47c.15-.33.29-.66.43-.98-.13.33-.28.65-.43.98zm-.49 1.03c.16-.33.32-.65.47-.98-.15.32-.3.65-.47.98zm-15.44 19.04c.08-.06.16-.13.24-.19-.08.06-.16.12-.24.19z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M867.14 502.03c1.67-5.14 2.79-9.55 3.26-10.48.2-.41.71-1.59 1.38-3.21-1 2.21-1.98 4.35-2.67 5.72-.2.41-.46.94-.76 1.57-2.71 5.64-9.05 18.82-16.92 24.07-9.22 6.15-21.72 5.67-28.35 4.84-4.27-.53-8.23-5.71-10.8-9.96-1.8-2.98-1.98-6.65-.49-9.81 1.5-3.17 4.33-5.28 7.77-5.78l.1-.02h.01c-.94-.31-1.97-.73-3.06-1.25a12.218 12.218 0 0 0-6.62 6.19c-.48 1.01-.81 2.05-.99 3.12v.01c.45 2.27.75 4.66.85 7.16v.01c.21.48.45.95.73 1.4 1.44 2.38 3.3 5.04 5.46 7.14.07-.22.13-.41.18-.58l1.91.57c-.14.47-.28.96-.43 1.46 1.6 1.23 3.33 2.1 5.14 2.33 2.13.26 4.84.49 7.85.49 6.78 0 15.11-1.15 21.86-5.66 5.84-3.88 10.77-11.68 14.16-18 .15-.44.3-.89.44-1.32-.01 0-.01 0-.01-.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M809.84 514.2c-.1-2.5-.4-4.89-.85-7.16-.44 2.41-.15 4.9.85 7.16zm26.86 36.4c-14.28 4.08-22.27 2.7-23.86-.48-1.26-2.52 2.15-16.65 4.85-25.92-.57-.44-1.12-.93-1.66-1.45-1.53 5.16-6.97 24.28-4.98 28.26.62 1.23 1.72 2.18 3.25 2.87.44-.62.72-1.01.77-1.08l1.61 1.19c-.01.01-.15.21-.39.55 1.51.38 3.29.57 5.3.57 4.28 0 9.61-.86 15.66-2.58 8.68-2.49 16.14-10.92 21.75-24.49.06-.34.12-.69.17-1.02V527c.16-1.14.27-2.21.33-3.16v-.03c-5.61 15.03-14.02 24.29-22.8 26.79z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm818.12 522.74-1.91-.57c-.05.17-.11.36-.18.58.54.52 1.09 1.01 1.66 1.45.15-.5.29-.99.43-1.46zm34.17 28.48c-3.4 8.52-9.71 24.38-20.74 29.47-13.6 6.27-23.62 6.49-24.91 5.21-1.6-1.61-1.97-8.54 2.23-18.94 1.72-4.29 6.08-10.54 7.42-12.42-.73-.17-1.39-.4-1.99-.66-1.67 2.36-5.59 8.12-7.29 12.33-4.52 11.2-4.09 18.79-1.78 21.1.06.06.13.12.2.17l.03-.14 1.96.41-.11.53c.8.18 1.75.27 2.85.27 5.12 0 13.31-1.92 22.22-6.03 11.77-5.43 18.27-21.77 21.76-30.55.14-.36.28-.71.42-1.04l-.03-.58v-.01c-.05-1.59.03-3.18.2-4.75-.39.78-.77 1.59-1.14 2.45-.38.87-.81 1.95-1.3 3.18z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'm816.68 553.99-1.61-1.19c-.05.07-.33.46-.77 1.08.6.26 1.26.49 1.99.66.24-.34.38-.54.39-.55zm35.85 29.83c.14-3.9.26-7.89.46-11.48v-.21c.06-1.1.13-2.16.21-3.17-.77 5.83-2 14.47-3.2 20.45-2.05 10.23-5.03 21.7-14.61 28.41-6.55 4.58-18.06 16.67-25.68 24.66-2.44 2.56-4.77 5.01-6.12 6.33-.57-7.33-.64-39.19.32-43.99.88-4.38 2.9-14.18 3.39-16.55-.8-.17-1.44-.43-1.88-.78v-.01c-.28 1.36-2.54 12.26-3.48 16.95-.03.15-.06.34-.09.55 0 .03-.01.05-.01.08-.03.21-.05.44-.08.69 0 .04-.01.09-.01.14-.02.26-.05.54-.07.84 0 .05-.01.1-.01.15-.02.32-.05.65-.07 1.01 0 .03 0 .07-.01.11-.02.35-.04.73-.06 1.12 0 .04 0 .08-.01.13l-.06 1.25c0 .08-.01.15-.01.23-.02.42-.03.86-.05 1.32 0 .1-.01.19-.01.29-.01.46-.03.92-.04 1.4 0 .09 0 .18-.01.27-.01.5-.03 1.01-.04 1.53v.01c-.02.69-.03 1.4-.04 2.12-.02.84-.03 1.7-.04 2.56v.36l-.03 2.7v.01c-.01.86-.01 1.72-.02 2.58v.59c0 .87-.01 1.73-.01 2.58-.01 16.93.43 20.8.74 21.83 0-.09.01-.16.01-.21h-.06l.06-.02v.02l2 .03c0 .03-.01.21-.01.53.86-.71 2.65-2.55 7.24-7.37 7.56-7.94 19-19.93 25.38-24.4 5.5-3.85 8.93-9.11 11.27-14.79-.35-2.29-.59-3.69-.6-3.76l1.97-.33c.01.05.02.12.04.23 1.19-3.66 2.03-7.41 2.75-11.01.13-.66.27-1.36.4-2.07.06-1.28.11-2.59.16-3.9.02 0 .02 0 .02-.01z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Upper GI');
	            }, className: 'bodyLines', d: 'M801.21 623.28c-.01.86-.01 1.72-.02 2.58.01-.85.02-1.72.02-2.58zm.03-2.7zm.05-2.92c-.02.84-.03 1.7-.04 2.56.01-.86.02-1.72.04-2.56zm-.1 8.8c0 .87-.01 1.73-.01 2.58.01-.85.01-1.71.01-2.58zm.24-14.42c0 .1-.01.19-.01.29.01-.1.01-.19.01-.29zm.12-2.92c0 .04 0 .08-.01.13.01-.05.01-.09.01-.13zm-.06 1.38c0 .08-.01.15-.01.23 0-.08.01-.16.01-.23zm-.11 3.23c0 .09 0 .18-.01.27 0-.08.01-.18.01-.27zm-.05 1.81zm.29-7.65c0 .03 0 .07-.01.11 0-.04.01-.08.01-.11zm.16-2.15c0 .04-.01.09-.01.14 0-.05.01-.09.01-.14zm.09-.77c0 .03-.01.05-.01.08 0-.03 0-.05.01-.08zm-.17 1.75c0 .05-.01.1-.01.15 0-.04 0-.1.01-.15zm3.73-19.23c.44.35 1.08.61 1.88.78l.11-.53-1.96-.41-.03.14v.02zm43.75 13.09-1.97.33c.01.07.25 1.47.6 3.76.52-1.27.99-2.55 1.41-3.85-.02-.12-.03-.19-.04-.24zM626.75 471.07s-2.13 2.75-1.65 9.62l2.71 6.65s-1.43-7.18-.23-13.31l-.83-2.96z' }),
	          this.state.bodyTitle === 'Upper GI' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '533', width: '165', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M794.206 554.009h300' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1119.99 537.793h5.203v13.957c0 2.215.065 3.651.194 4.307.222 1.055.752 1.901 1.59 2.54.838.639 1.984.958 3.437.958 1.476 0 2.59-.302 3.34-.905.75-.604 1.201-1.345 1.353-2.224.153-.879.229-2.338.229-4.377v-14.256h5.203v13.536c0 3.093-.141 5.279-.422 6.556-.281 1.278-.8 2.356-1.556 3.235-.756.878-1.766 1.579-3.032 2.1-1.266.522-2.918.782-4.957.782-2.461 0-4.327-.284-5.599-.852-1.271-.569-2.276-1.307-3.014-2.215-.739-.908-1.225-1.86-1.459-2.856-.34-1.477-.51-3.657-.51-6.54v-13.746Zm25.86 7.102h4.606v2.742c.598-.937 1.406-1.699 2.426-2.285 1.019-.586 2.15-.879 3.392-.879 2.168 0 4.008.85 5.52 2.549 1.512 1.699 2.267 4.066 2.267 7.101 0 3.118-.761 5.541-2.285 7.269-1.523 1.729-3.369 2.593-5.537 2.593-1.031 0-1.966-.205-2.804-.615-.837-.411-1.719-1.114-2.645-2.11v9.404h-4.94v-25.769Zm4.887 9.018c0 2.097.416 3.647 1.248 4.649.832 1.002 1.846 1.503 3.041 1.503 1.149 0 2.104-.46 2.865-1.38.762-.92 1.143-2.429 1.143-4.526 0-1.957-.393-3.411-1.178-4.36-.785-.949-1.758-1.424-2.918-1.424-1.207 0-2.209.466-3.006 1.398-.796.932-1.195 2.311-1.195 4.14Zm17.103-9.018h4.605v2.742c.598-.937 1.406-1.699 2.426-2.285 1.019-.586 2.15-.879 3.393-.879 2.167 0 4.007.85 5.519 2.549 1.512 1.699 2.268 4.066 2.268 7.101 0 3.118-.762 5.541-2.286 7.269-1.523 1.729-3.369 2.593-5.537 2.593-1.031 0-1.965-.205-2.803-.615-.838-.411-1.72-1.114-2.646-2.11v9.404h-4.939v-25.769Zm4.886 9.018c0 2.097.416 3.647 1.248 4.649.832 1.002 1.846 1.503 3.041 1.503 1.149 0 2.104-.46 2.866-1.38.761-.92 1.142-2.429 1.142-4.526 0-1.957-.392-3.411-1.177-4.36-.786-.949-1.758-1.424-2.918-1.424-1.207 0-2.209.466-3.006 1.398-.797.932-1.196 2.311-1.196 4.14Zm28.054 3.709 4.922.826c-.633 1.804-1.632 3.178-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.844-1.846-6.433 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.433 2.604 1.195 3.419.762.814 1.711 1.221 2.848 1.221.773 0 1.423-.211 1.951-.632.527-.422.926-1.102 1.195-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.745-1.559-1.117-2.566-1.117-1.079 0-1.969.393-2.672 1.178-.703.785-1.049 1.852-1.037 3.199h7.382Zm13.659 10.934h-4.94v-18.668h4.588v2.654c.785-1.254 1.491-2.08 2.118-2.478.627-.399 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.529 4.306c-.832-.539-1.606-.808-2.321-.808-.691 0-1.277.19-1.758.571-.48.381-.858 1.069-1.133 2.065-.276.997-.413 3.083-.413 6.258v5.766Zm31.31-9.475v-4.341h11.215v10.265c-1.09 1.055-2.669 1.984-4.737 2.786-2.069.803-4.163 1.204-6.284 1.204-2.696 0-5.045-.565-7.049-1.696-2.004-1.131-3.51-2.748-4.518-4.851-1.008-2.104-1.512-4.392-1.512-6.865 0-2.683.563-5.068 1.688-7.154 1.125-2.086 2.771-3.686 4.939-4.799 1.653-.855 3.709-1.283 6.17-1.283 3.2 0 5.699.671 7.497 2.013 1.799 1.341 2.956 3.196 3.472 5.563l-5.168.967c-.363-1.266-1.046-2.265-2.048-2.997-1.002-.733-2.253-1.099-3.753-1.099-2.273 0-4.081.721-5.423 2.162-1.341 1.442-2.012 3.58-2.012 6.416 0 3.059.679 5.353 2.039 6.882 1.359 1.529 3.14 2.294 5.344 2.294 1.089 0 2.182-.214 3.278-.641 1.096-.428 2.036-.947 2.821-1.556v-3.27h-5.959Zm15.85-16.295h5.203v25.77h-5.203z' })
	            )
	          ) : ''
	        ),
	        _react2.default.createElement(
	          'g',
	          { className: this.state.bodyTitle === 'Lower Abdomen' ? 'bodyParts_group Lower_Abdomen body_parts_active' : 'bodyParts_group Lower_Abdomen' },
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M750.26 780.31c.07.13.15.25.24.36v-.98c-.06.21-.13.42-.24.62z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M749.33 779.68h1.14v18.07h-1.14zm71.62-69.2-1.89-.66c-.03.09-1.14 3.23-2.89 7.77 1.56-2.31 3.15-4.65 4.73-6.98.03-.06.04-.1.05-.13zm14.38-21.28-1.96-.38c-.02.06-.57 2.04-1.65 5.87 1.29-1.89 2.49-3.65 3.58-5.24.01-.1.02-.19.03-.25z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'syzst2', d: 'm704.9 685.14.03.21c0-.06-.02-.13-.03-.21zm-8.31-34.44c0 .03.01.21.02.54.53.44.71.44.98.44l.52-.03.3-.37c.05-.06.12-.14.19-.39 0-.11-.01-.19-.01-.24l-2 .05zm8.55 35.92c.01.06.02.11.03.16-.01-.05-.02-.1-.03-.16zm-.67-4.95.03.24-.03-.24zm.21 1.81.03.25-.03-.25zm.71 4.43c.01.03.01.06.02.09a.292.292 0 0 1-.02-.09zm-2.44-41.5v-.02.02zm1.32 33.33c.01.06.01.13.02.19-.01-.06-.01-.13-.02-.19zm98.19-28.07h.47c.27 0 .45 0 .98-.45.01-.32.01-.5.01-.53l-2-.03c0 .05 0 .12-.01.21.08.25.14.34.19.4l.36.4z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'syzst2', d: 'M801.87 650.67h.06v-.02l-.06.02zm-97.78 27.08v.04-.04zm-1.07-23.04v.02-.02zm.22 8.17v.12-.12zm-.26-10.97v.06-.06zm-.02-2.79v.08-.08zm.96 26.39c0 .05.01.09.01.13-.01-.04-.01-.08-.01-.13zm-.17-2.39c.01.08.01.16.02.24-.01-.08-.02-.16-.02-.24zm-.29-5.04c.01.1.01.2.02.3-.01-.1-.01-.2-.02-.3zm.14 2.57c.01.09.01.18.02.27-.01-.09-.02-.18-.02-.27zm-.26-5.15c0 .07.01.15.01.22 0-.07-.01-.15-.01-.22zm47.32 111.94c-.01-.21-.01-.42-.01-.63v-90.82l-.15 93.69c.19-.71.18-1.52.16-2.24z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyParts', d: 'M738.08 776.64c-11.26-7.51-26.36-64.68-31.33-83.46-.47-1.8-.85-3.23-1.11-4.2-.08-.29-.16-.62-.24-.98-.01-.03-.01-.06-.02-.09-.07-.35-.15-.72-.22-1.12l-.03-.16c-.07-.4-.14-.82-.2-1.27l-.03-.21a41.334 41.334 0 0 1-.22-1.67c-.06-.5-.12-1.03-.18-1.57l-.03-.24c-.06-.56-.12-1.14-.18-1.75-.01-.06-.01-.13-.02-.19-.06-.63-.12-1.28-.18-1.95v-.04c-.06-.68-.11-1.38-.17-2.1 0-.05-.01-.09-.01-.13-.05-.7-.1-1.42-.15-2.15-.01-.08-.01-.16-.02-.24-.05-.72-.09-1.45-.14-2.2-.01-.09-.01-.18-.02-.27l-.12-2.27c-.01-.1-.01-.2-.02-.3-.04-.78-.08-1.56-.11-2.36 0-.07-.01-.15-.01-.22-.04-.82-.07-1.66-.1-2.5v-.12c-.1-2.67-.17-5.4-.22-8.15v-.02c-.02-.91-.03-1.83-.04-2.74v-.06c-.01-.9-.02-1.81-.02-2.71v-2.81c.03-11.89.61-22.87 1.96-28.03-1.93.88-3.88 1.72-5.62 2.95v.01c.03 2.55.05 5.17.05 7.72.01 16.99-.43 20.83-.74 21.85.13 3.86 1.84 44.47-2.05 57.14-3.66 11.88 5.85 32.03 6.85 34.11 0 .01.01.02.01.02 2.48 3.45 18.36 25.58 22.04 31.09 1.4 2.1 3.68 4.82 6.1 7.71 5.55 6.62 9.18 11.16 9.18 13.89 0 .21-.01.54-.02.97-.69-.42-1.02-.74-1.02-.74s-.01.07-.03.19c.17.13.43.32.79.55 1.43.87 4.43 2.17 9.39 1.96l-.53-.03.02-16.52c-.32.17-.7.29-1.22.29-1.53 0-4.26-1.04-10.02-4.88z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyParts', d: 'M748.65 776.81V615.63c0-2.09-1.05-4.99-10.05-6-7.7.28-28.08 2.17-31.13 7.5-3.75 6.55-3.02 59.88.1 71.32.26.98.64 2.41 1.12 4.21 13.18 49.92 23.45 77.61 30.5 82.32 7.29 4.85 8.91 4.65 9.23 4.48.28-.16.25-1.29.24-1.97-.01-.23-.01-.46-.01-.68zm-59.28-132.95c-7.57-7.94-19-19.94-25.38-24.41-5.5-3.85-8.93-9.11-11.27-14.79-1.42 9.13-4.75 32.47-3.19 41.84 1.85 11.07 4.59 23.26 15.85 39.64 7.81 11.36 23.84 35.05 32.39 47.7-2.76-7.68-5.56-18.52-3.14-26.4 3.68-11.95 2.18-51.16 1.98-56.21-.86-.7-2.64-2.54-7.24-7.37zm116.52 63.58c2.43 7.88-.37 18.72-3.13 26.4 8.54-12.65 24.58-36.34 32.39-47.69 11.26-16.39 14.01-28.57 15.85-39.65 1.56-9.36-1.77-32.68-3.19-41.83-2.33 5.69-5.76 10.94-11.27 14.79-6.38 4.47-17.82 16.46-25.38 24.4-4.59 4.82-6.38 6.66-7.24 7.37 0 .13-.01.27-.01.44-.11 6.52-1.6 44.12 1.98 55.77z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyParts', d: 'M803.98 708.03c-3.9-12.68-2.19-53.36-2.06-57.15-.31-1.03-.75-4.9-.74-21.83 0-.85 0-1.72.01-2.58v-.59c0-.86.01-1.72.02-2.58v-.01l.03-2.7v-.36c.01-.87.03-1.73.04-2.56v-.02c-2.13-.73-4.35-1.16-6.56-1.59.02.03.05.06.07.1 4.34 7.58 3 62.19.1 72.84-.27.97-.64 2.4-1.12 4.19-4.96 18.79-20.06 75.96-31.33 83.47-5.75 3.84-8.48 4.88-10.03 4.88-.54 0-.94-.13-1.27-.31-.14-.08-.27-.17-.38-.27-.1-.08-.18-.18-.26-.27v.27l-.03 16.81-.58.03c5.04.22 8.18-1.12 9.66-1.99.1-.06.17-.11.26-.16-.01-.33-.02-.61-.02-.78 0-2.73 3.64-7.27 9.18-13.89 2.42-2.89 4.71-5.61 6.1-7.71 3.68-5.51 19.56-27.64 22.04-31.09.01-.01.02-.03.02-.04 1.1-2.29 10.49-22.29 6.85-34.11z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyParts', d: 'M761.33 774.98c7.06-4.71 17.32-32.4 30.51-82.32.47-1.8.85-3.23 1.12-4.21 3.12-11.44 3.84-64.76.1-71.32-3.05-5.33-23.43-7.22-31.13-7.5-9.01 1.01-10.05 3.91-10.05 6v161.18c0 .22-.01.45-.01.68-.02.68-.05 1.81.24 1.97.32.17 1.93.38 9.22-4.48z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M749.52 612.38v-.35c-1.67-2.33-5.22-3.78-10.77-4.4l-.08-.01-.07.01c-.09 0-.2.01-.33.01-.06 0-.15.01-.22.01-.08 0-.15.01-.23.01-.08 0-.18.01-.27.01-.1 0-.19.01-.3.01-.13.01-.27.01-.41.02-.09 0-.16.01-.25.01l-.48.03c-.1.01-.19.01-.29.02-.18.01-.37.02-.57.04-.09.01-.19.01-.28.02-.21.01-.43.03-.65.04-.1.01-.19.01-.29.02-.23.02-.47.04-.71.05-.1.01-.2.02-.31.02l-.78.06-.3.03c-.27.02-.54.05-.81.07l-.34.03c-.28.03-.56.05-.84.08-.12.01-.23.02-.35.04-.29.03-.59.06-.89.1-.11.01-.23.02-.34.04-.31.03-.61.07-.93.11-.12.01-.23.03-.35.04l-.96.12c-.11.01-.22.03-.33.04-.33.04-.66.09-.99.14-.11.02-.23.03-.34.05l-1 .15c-.11.02-.23.04-.34.05-.34.05-.67.11-1.01.17l-.34.06-1.01.18-.33.06c-.34.06-.67.13-1 .2-.11.02-.22.05-.34.07l-.99.21c-.11.02-.22.05-.32.07-.33.08-.66.15-.98.23-.1.03-.21.05-.31.08-.32.08-.65.17-.96.25-.1.03-.2.05-.29.08-.32.09-.63.18-.94.27-.1.03-.19.06-.28.09-.31.1-.61.19-.91.29-.09.03-.18.06-.26.09-.3.1-.59.21-.87.32l-.24.09c-.28.11-.56.22-.84.34-.07.03-.14.06-.22.1-.27.12-.54.24-.79.37-.07.03-.13.07-.19.1-.25.13-.5.26-.74.4-.05.03-.1.06-.16.09-.24.14-.47.28-.69.43l-.12.09c-.22.15-.43.31-.63.47-.03.03-.06.05-.09.08-.2.17-.39.34-.57.51-.02.02-.03.04-.05.05-.18.19-.35.37-.5.57-.15.19-.29.39-.41.6-.3.52-.57 1.28-.82 2.23-1.35 5.16-1.93 16.14-1.96 28.03v2.81c0 .9.01 1.8.02 2.71v.06c.01.91.02 1.83.04 2.74v.02c.05 2.75.12 5.49.22 8.15v.12c.03.84.06 1.67.1 2.5 0 .07.01.15.01.22.03.8.07 1.58.11 2.36.01.1.01.2.02.3l.12 2.27c.01.09.01.18.02.27.04.75.09 1.48.14 2.2.01.08.01.16.02.24.05.73.1 1.45.15 2.15 0 .05.01.09.01.13.05.72.11 1.42.17 2.1v.04c.06.67.12 1.32.18 1.95.01.06.01.13.02.19.06.6.12 1.18.18 1.75l.03.24a182.642 182.642 0 0 0 .21 1.82c.06.49.13.97.19 1.42l.03.21c.07.45.13.87.2 1.27.01.06.02.11.03.16.07.4.14.78.22 1.12.01.03.01.06.02.09.08.36.16.69.24.98.26.97.64 2.4 1.11 4.2 4.97 18.78 20.07 75.95 31.33 83.46 5.76 3.84 8.49 4.88 10.03 4.88.52 0 .9-.12 1.22-.29v-.16l.17-168.67zm-1.1 167.08c-.32.17-1.94.37-9.23-4.48-7.05-4.71-17.32-32.4-30.5-82.32-.48-1.8-.86-3.23-1.12-4.21-3.12-11.44-3.85-64.77-.1-71.32 3.05-5.33 23.43-7.22 31.13-7.5 9 1.01 10.05 3.91 10.05 6v161.18c0 .22 0 .45.01.68.01.68.04 1.81-.24 1.97zm-43.92-97.55zm-.4-4.13c.06.67.12 1.32.18 1.95-.07-.63-.13-1.27-.18-1.95zm.19 2.15zm-.36-4.29zm1.01 9.72c.07.45.13.87.2 1.27-.07-.4-.14-.83-.2-1.27z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M702.96 649.12v-2.71c-.01.9-.01 1.81 0 2.71zm2.45 38.88c.08.36.16.69.24.98-.09-.29-.17-.63-.24-.98zm-.24-1.21zm-.46-3.06c.06.49.13.97.19 1.42-.06-.46-.13-.93-.19-1.42zm-1.75-34.53c0 .9.01 1.8.02 2.71-.01-.9-.02-1.81-.02-2.71zm.06 5.53zm-.04-2.75c.01.91.02 1.83.04 2.74-.02-.92-.03-1.83-.04-2.74zm1.93-33.62c-1.35 5.16-1.93 16.14-1.96 28.03.04-11.88.62-22.86 1.96-28.03zM703.24 663zm.37 7.92c.04.75.09 1.48.14 2.2-.05-.72-.09-1.45-.14-2.2zm-.13-2.54.12 2.27c-.05-.75-.09-1.5-.12-2.27zm.28 4.98zm-.41-7.64c.03.8.07 1.58.11 2.36-.04-.78-.08-1.56-.11-2.36zm46.52 111.72c0-.21.01-.42.01-.63V615.63c0-.81.13-1.56.39-2.25-.13-.35-.29-.68-.49-1-.07-.12-.18-.23-.26-.35v.35l-.19 168.69v.16c.02-.01.04-.02.05-.02.08-.04.15-.09.21-.14.3-.2.52-.46.67-.76-.44-.83-.41-1.93-.39-2.87zm-99.41-171.29c-1.52 9.96-4.31 30.56-2.99 40.06-1.32-13.09 4.26-29.8 2.99-40.06z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M696.55 708.03c3.9-12.67 2.19-53.28 2.05-57.14-.07.24-.14.33-.19.39l-.3.37-.52.03c-.27 0-.44 0-.98-.44.2 5.05 1.69 44.26-1.98 56.21-2.42 7.88.37 18.72 3.14 26.4-8.55-12.65-24.58-36.34-32.39-47.7-11.27-16.39-14.01-28.57-15.85-39.64-1.56-9.37 1.77-32.71 3.19-41.84-.52-1.27-.99-2.55-1.41-3.85-.12.69-.44 2.62-.85 5.34 1.27 10.26-4.3 26.96-2.99 40.06.03.21.05.42.09.62 1.88 11.29 4.68 23.72 16.18 40.45.47.68.97 1.41 1.49 2.17-.01-.1-.02-.19-.03-.25l1.96-.38c.02.07.58 2.05 1.65 5.86 3.25 4.76 7.02 10.31 10.83 15.93-.02-.06-.04-.1-.05-.13l1.88-.66c.03.09 1.13 3.2 2.87 7.72.01.01.01.01.01.02 8.17 12.06 15.56 23 17.12 25.31l1.62-1.17c.01.02.12.15.31.41 0 0 .01.01.01.02-1.02-2.08-10.52-22.23-6.86-34.11zm54.59 73.18c.33.18.73.31 1.27.31 1.55 0 4.28-1.04 10.03-4.88 11.27-7.51 26.37-64.68 31.33-83.47.48-1.79.85-3.22 1.12-4.19 2.9-10.65 4.24-65.26-.1-72.84-.02-.03-.05-.06-.07-.1-.46-.77-1.17-1.46-2.07-2.1-6.04-4.3-20.71-5.72-27.47-6.15-.05 0-.1-.01-.16-.01l-.57-.03c-.07 0-.15-.01-.22-.01l-.47-.03c-.08 0-.15-.01-.22-.01-.13-.01-.26-.01-.38-.02-.08 0-.15-.01-.22-.01-.11 0-.21-.01-.31-.01-.06 0-.12 0-.17-.01-.08 0-.17-.01-.24-.01-.12 0-.22-.01-.3-.01l-.08-.01-.07.01c-5.51.61-9.07 2.04-10.75 4.34-.1.13-.18.27-.26.41l-.12 73.61v90.82c0 .21 0 .42.01.63.02.72.03 1.53-.16 2.24v.98c.08.1.16.19.26.27.12.11.25.2.39.28zm.73-3.72c0-.23.01-.46.01-.68V615.63c0-2.09 1.04-4.99 10.05-6 7.7.28 28.08 2.17 31.13 7.5 3.74 6.56 3.02 59.88-.1 71.32-.27.98-.65 2.41-1.12 4.21-13.19 49.92-23.45 77.61-30.51 82.32-7.29 4.86-8.9 4.65-9.22 4.48-.29-.16-.26-1.29-.24-1.97z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M750.65 615.63v70.36l.12-73.61c-.2.32-.37.65-.5 1 .25.69.38 1.44.38 2.25z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M750.65 615.63c0-.81-.13-1.56-.38-2.25a6.33 6.33 0 0 0-.39 2.25v161.18c0 .21-.01.42-.01.63-.02.94-.05 2.04.39 2.87.11-.2.18-.41.24-.63l.15-93.69v-70.36zm99.01-10.47c-1.82 10.43 4.59 28.49 2.77 42.15-.1.74-.16 1.49-.2 2.25.01.01 0 .02 0 .03-.02.49-.02.99-.02 1.49.1-.5.19-1 .28-1.49 0-.01.01-.02 0-.03.04-.76.1-1.51.2-2.25 1.82-13.66-4.59-31.72-2.77-42.15v-.01c-.04-.24-.07-.46-.11-.68-.05.22-.11.44-.15.69z' }),
	          _react2.default.createElement('path', { onClick: function onClick(e) {
	              return _this2.modalMaleBodySingleContentOpen(e, 'Lower Abdomen');
	            }, className: 'bodyLines', d: 'M849.22 600.81c-.42 1.3-.89 2.59-1.41 3.85 1.42 9.15 4.75 32.47 3.19 41.83-1.84 11.08-4.59 23.26-15.85 39.65-7.81 11.35-23.85 35.04-32.39 47.69 2.76-7.68 5.56-18.52 3.13-26.4-3.58-11.65-2.09-49.25-1.98-55.77 0-.17.01-.32.01-.44-.54.44-.72.45-.98.45h-.47l-.34-.39c-.05-.06-.12-.15-.19-.4-.13 3.79-1.85 44.47 2.06 57.15 3.64 11.82-5.75 31.82-6.85 34.09.19-.26.3-.39.31-.41l1.62 1.17c1.56-2.31 8.94-13.24 17.11-25.29a306.7 306.7 0 0 0 2.89-7.77l1.89.66c-.01.03-.02.07-.05.13 3.81-5.62 7.58-11.17 10.82-15.92 1.08-3.83 1.63-5.81 1.65-5.87l1.96.38c-.01.06-.02.15-.03.25.52-.76 1.02-1.49 1.49-2.17 10.08-14.65 13.47-26.01 15.42-36.2-.01-.5 0-1 .02-1.49 0-.01.01-.02 0-.03.04-.76.1-1.51.2-2.25 1.82-13.66-4.59-31.72-2.77-42.15v-.01c.04-.24.1-.46.15-.68-.28-1.81-.49-3.09-.59-3.64-.02-.01-.02-.01-.02-.02z' }),
	          this.state.bodyTitle === 'Lower Abdomen' ? _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('rect', { className: 'labelArea', x: '1120', y: '655', width: '290', height: '40', rx: '5' }),
	            _react2.default.createElement(
	              'g',
	              { className: 'labelGroup' },
	              _react2.default.createElement('path', { className: 'labelLine', d: 'M794.206 675.376h300' }),
	              _react2.default.createElement('path', { className: 'labelText', d: 'M1119.95 688.05v-25.559h5.203v21.217h12.937v4.342h-18.14Zm20.67-9.598c0-1.64.404-3.228 1.213-4.763.808-1.535 1.954-2.707 3.436-3.516 1.483-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.952 0 2.825-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.774-2.734-1.907-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.062.264c0 1.852.44 3.27 1.319 4.254.878.984 1.962 1.477 3.251 1.477 1.29 0 2.371-.493 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.251 1.476-.879.985-1.319 2.403-1.319 4.254Zm21.558 9.334-5.906-18.668h4.799l3.498 12.234 3.216-12.234h4.764l3.111 12.234 3.569-12.234h4.869l-5.994 18.668h-4.746l-3.217-12.006-3.164 12.006h-4.799Zm35.33-5.941 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.365.943-3.073 1.415-5.124 1.415-3.246 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.843-1.846-6.433 0-3.094.809-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.135-2.628 2.777 0 4.968.917 6.574 2.751 1.605 1.834 2.373 4.644 2.303 8.429h-12.375c.035 1.465.433 2.604 1.195 3.419.762.814 1.711 1.222 2.848 1.222.773 0 1.423-.211 1.951-.633.527-.422.925-1.102 1.195-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.703-.744-1.559-1.116-2.567-1.116-1.078 0-1.968.392-2.671 1.177-.704.785-1.049 1.852-1.038 3.199h7.383Zm13.659 10.934h-4.939v-18.668h4.588v2.654c.785-1.253 1.491-2.08 2.118-2.478.627-.399 1.339-.598 2.136-.598 1.125 0 2.209.311 3.252.932l-1.53 4.307c-.832-.54-1.605-.809-2.32-.809-.691 0-1.277.19-1.758.571-.48.381-.858 1.07-1.133 2.066-.276.996-.414 3.082-.414 6.257v5.766Zm41.22 0h-5.66l-2.25-5.853h-10.301l-2.127 5.853h-5.519l10.037-25.769h5.502l10.318 25.769Zm-9.58-10.195-3.551-9.563-3.48 9.563h7.031Zm12.09 10.195v-25.769h4.939v9.281c1.524-1.735 3.328-2.602 5.414-2.602 2.274 0 4.155.823 5.643 2.47 1.488 1.646 2.232 4.011 2.232 7.093 0 3.187-.758 5.642-2.276 7.365-1.518 1.723-3.36 2.584-5.528 2.584-1.067 0-2.119-.267-3.156-.8s-1.93-1.321-2.68-2.364v2.742h-4.588Zm4.904-9.738c0 1.933.305 3.363.914 4.289.856 1.312 1.992 1.969 3.41 1.969 1.09 0 2.019-.466 2.786-1.398.768-.931 1.152-2.399 1.152-4.403 0-2.133-.387-3.671-1.16-4.614-.774-.944-1.764-1.415-2.971-1.415-1.184 0-2.168.459-2.953 1.379-.785.92-1.178 2.318-1.178 4.193Zm34.416 9.738h-4.588v-2.742c-.762 1.066-1.661 1.86-2.698 2.382-1.037.521-2.083.782-3.138.782-2.144 0-3.981-.864-5.51-2.593-1.53-1.728-2.294-4.139-2.294-7.233 0-3.164.744-5.57 2.232-7.216 1.488-1.647 3.369-2.47 5.643-2.47 2.086 0 3.89.867 5.414 2.602v-9.281h4.939v25.769Zm-13.184-9.738c0 1.992.276 3.433.827 4.324.797 1.289 1.91 1.934 3.34 1.934 1.136 0 2.103-.484 2.9-1.451.797-.966 1.195-2.411 1.195-4.333 0-2.144-.387-3.688-1.16-4.631-.773-.944-1.764-1.415-2.971-1.415-1.172 0-2.153.465-2.944 1.397-.791.932-1.187 2.323-1.187 4.175Zm16.914.14c0-1.64.404-3.228 1.213-4.763.808-1.535 1.954-2.707 3.436-3.516 1.482-.808 3.138-1.213 4.966-1.213 2.824 0 5.139.917 6.943 2.751 1.805 1.834 2.707 4.152 2.707 6.952 0 2.825-.911 5.165-2.733 7.023-1.822 1.857-4.116 2.786-6.882 2.786-1.711 0-3.343-.387-4.895-1.16-1.553-.774-2.734-1.907-3.542-3.402-.809-1.494-1.213-3.313-1.213-5.458Zm5.062.264c0 1.852.44 3.27 1.319 4.254.878.984 1.962 1.477 3.251 1.477 1.29 0 2.371-.493 3.244-1.477.873-.984 1.309-2.414 1.309-4.289 0-1.828-.436-3.234-1.309-4.219-.873-.984-1.954-1.476-3.244-1.476-1.289 0-2.373.492-3.251 1.476-.879.985-1.319 2.403-1.319 4.254Zm17.698-9.334h4.553v2.549c1.629-1.981 3.568-2.971 5.818-2.971 1.196 0 2.233.246 3.112.739.879.492 1.599 1.236 2.162 2.232.82-.996 1.705-1.74 2.654-2.232a6.503 6.503 0 0 1 3.041-.739c1.371 0 2.531.279 3.481.835.949.557 1.658 1.374 2.127 2.452.339.797.509 2.086.509 3.868v11.935h-4.939v-10.67c0-1.851-.17-3.047-.51-3.586-.457-.703-1.16-1.054-2.109-1.054-.692 0-1.342.21-1.951.632-.61.422-1.049 1.04-1.319 1.855-.269.814-.404 2.1-.404 3.858v8.965h-4.94v-10.23c0-1.817-.087-2.989-.263-3.516-.176-.527-.448-.92-.818-1.178-.369-.258-.87-.386-1.503-.386a3.6 3.6 0 0 0-2.056.615c-.61.41-1.046 1.002-1.31 1.775-.263.774-.395 2.057-.395 3.85v9.07h-4.94v-18.668Zm43.19 12.727 4.922.826c-.633 1.805-1.632 3.179-2.997 4.122-1.366.943-3.074 1.415-5.124 1.415-3.247 0-5.649-1.061-7.207-3.182-1.231-1.699-1.846-3.843-1.846-6.433 0-3.094.808-5.517 2.426-7.269 1.617-1.752 3.662-2.628 6.134-2.628 2.778 0 4.969.917 6.575 2.751 1.605 1.834 2.373 4.644 2.302 8.429h-12.375c.035 1.465.434 2.604 1.196 3.419.761.814 1.711 1.222 2.847 1.222.774 0 1.424-.211 1.951-.633.528-.422.926-1.102 1.196-2.039Zm.281-4.993c-.035-1.429-.404-2.516-1.107-3.26-.704-.744-1.559-1.116-2.567-1.116-1.078 0-1.969.392-2.672 1.177-.703.785-1.049 1.852-1.037 3.199h7.383Zm25.909 10.934h-4.939v-9.527c0-2.016-.106-3.32-.317-3.911-.211-.592-.553-1.052-1.028-1.38-.475-.328-1.046-.492-1.714-.492-.855 0-1.623.234-2.303.703a3.544 3.544 0 0 0-1.397 1.863c-.252.773-.378 2.203-.378 4.289v8.455h-4.939v-18.668h4.587v2.742c1.629-2.109 3.68-3.164 6.153-3.164 1.09 0 2.086.197 2.988.589.902.393 1.585.894 2.048 1.503.463.609.785 1.301.967 2.074.181.774.272 1.881.272 3.323v11.601Z' })
	            )
	          ) : ''
	        )
	      );
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'section',
	          { className: 'center-of-excellence old_male_single_content ', id: 'excellence-part' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'body-and-doctor mt-4' },
	              _react2.default.createElement(
	                'div',
	                { style: { "text-align": "left" } },
	                _react2.default.createElement(
	                  'button',
	                  { onClick: this.MaleBackStep, style: { "border": "none", "color": "#14b795", "background": "transparent", "font-weight": "600" } },
	                  _react2.default.createElement('i', { className: 'fa fa-arrow-left' }),
	                  ' Back to Body Part'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-5 col-sm-12' },
	                  OldMaleBodySVGReactElement
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-7 col-sm-12 single_body_right_content_sec' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    this.props.bodyTitle,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    this.state.body_part_desc
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'our-departments' },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Our Departments'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row mt-3' },
	                      this.state.bodyDepartment.length > 0 ? this.state.bodyDepartment.map(function (body_department) {
	                        console.log(body_department, "body dept");
	                        return _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12 mb-3 ', key: body_department.id },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'doctor-list bg-light', style: { height: "80px" } },
	                            _react2.default.createElement('input', { type: 'radio', className: 'patient_user', name: 'body_dept_id', value: body_department.dept_id, onChange: _this2.handleChange, style: { cursor: "pointer" } }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row d-flex align-items-center' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-3 ' },
	                                body_department.image ? _react2.default.createElement('img', { src: _constants.IMAGE_URL + 'DepartmentImage/' + body_department.image, alt: 'avtars', style: { width: "50px" } }) : _react2.default.createElement('img', { src: _icon2.default, alt: 'Bitmap-3', style: { width: "50px" } })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-9 ' },
	                                _react2.default.createElement(
	                                  'p',
	                                  { style: { fontWeight: "500", letterSpacing: "1px" } },
	                                  body_department.department_name
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'Department'
	                                )
	                              )
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'doctor-list' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-12' },
	                              _react2.default.createElement(
	                                'p',
	                                { style: { "text-align": "center", "margin-top": "15px" } },
	                                'No Body Departments Found'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'our-consultants', style: { "display": "none" } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-6' },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          'Our Consultants'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-6 text-right' },
	                        _react2.default.createElement(
	                          'button',
	                          { onClick: this.ShowDepartment, style: { "border": "none", "color": "#14b795", "background": "transparent", "font-weight": "600", "paddingTop": "12px" } },
	                          _react2.default.createElement('i', { className: 'fa fa-arrow-left' }),
	                          ' Back to department'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row mt-4' },
	                      this.state.bodyDepartmentDoctor.length > 0 ? this.state.bodyDepartmentDoctor.map(function (body_department_doctor) {
	                        console.log(body_department_doctor.slug);
	                        var doctor_name = body_department_doctor.doctor_name;
	                        var new_doctor_name = doctor_name.replaceAll(' ', '-');
	                        return _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12 mb-3' },
	                          _react2.default.createElement(
	                            'a',
	                            { href: _constants.SITE_URL + '/consultant/' + body_department_doctor.slug, style: { "text-decoration": "none", "color": "#333333" } },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'doctor-list bg-light' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'row', style: { height: "80vh", maxHeight: "161px" } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-5' },
	                                  body_department_doctor.doctor_profile ? _react2.default.createElement('img', { src: _constants.IMAGE_URL + '/DoctorProfileImg/' + body_department_doctor.doctor_profile, alt: 'doctor profile', width: 125, height: 161 }) : _react2.default.createElement('img', { src: 'https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg', alt: 'Bitmap-3', width: 125, height: 161 })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-7' },
	                                  _react2.default.createElement(
	                                    'h6',
	                                    null,
	                                    body_department_doctor.doctor_name
	                                  ),
	                                  _react2.default.createElement(
	                                    'p',
	                                    { title: body_department_doctor.degree },
	                                    body_department_doctor.degree ? body_department_doctor.degree.substr(0, 20) + '...' : ''
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'doctor-list' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-12' },
	                              _react2.default.createElement(
	                                'p',
	                                { style: { "text-align": "center", "margin-top": "15px" } },
	                                'No Body Departments Doctors Found'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'center-of-excellence new_male_single_content', id: 'excellence-part', style: { "display": "none" } },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'body-and-doctor mt-4' },
	              _react2.default.createElement(
	                'div',
	                { style: { "text-align": "left" } },
	                _react2.default.createElement(
	                  'button',
	                  { onClick: this.MaleBackStep, style: { "border": "none", "color": "#14b795", "background": "transparent", "font-weight": "600" } },
	                  _react2.default.createElement('i', { className: 'fa fa-arrow-left' }),
	                  ' Back to Body Part'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-5 col-sm-12' },
	                  NewMaleBodySVGReactElement
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-7 col-sm-12 single_body_right_content_sec' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    this.state.bodyTitle,
	                    ' Department'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    this.state.body_part_desc
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'our-departments pt-4 mt-5' },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Our Departments'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row mt-4' },
	                      this.state.bodyDepartment.length > 0 ? this.state.bodyDepartment.map(function (body_department) {
	                        return _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12 mb-3', key: body_department.id },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'doctor-list' },
	                            _react2.default.createElement('input', { type: 'radio', className: 'patient_user', name: 'body_dept_id', value: body_department.dept_id, onChange: _this2.handleChange }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row list_content_sec' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-5' },
	                                body_department.image ? _react2.default.createElement('img', { src: _constants.IMAGE_URL + 'DepartmentImage/' + body_department.image, alt: 'avtars' }) : _react2.default.createElement('img', { src: _icon2.default, alt: 'Bitmap-3' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-7', style: { "paddingLeft": "0px", "textAlign": "left" } },
	                                _react2.default.createElement(
	                                  'h6',
	                                  { style: { "paddingTop": "0px" } },
	                                  body_department.department_name
	                                ),
	                                _react2.default.createElement(
	                                  'h6',
	                                  null,
	                                  'Department'
	                                )
	                              )
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'doctor-list' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-12' },
	                              _react2.default.createElement(
	                                'p',
	                                { style: { "text-align": "center", "margin-top": "15px" } },
	                                'No Body Departments Found'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'our-consultants pt-4 mt-5', style: { "display": "none" } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-6' },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          'Our Consultants'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-6 text-right' },
	                        _react2.default.createElement(
	                          'button',
	                          { onClick: this.ShowDepartment, style: { "border": "none", "color": "#14b795", "background": "transparent", "font-weight": "600", "paddingTop": "12px" } },
	                          _react2.default.createElement('i', { className: 'fa fa-arrow-left' }),
	                          ' Back to department'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row mt-4' },
	                      this.state.bodyDepartmentDoctor.length > 0 ? this.state.bodyDepartmentDoctor.map(function (body_department_doctor) {
	                        var doctor_name = body_department_doctor.doctor_name;
	                        var new_doctor_name = doctor_name.replaceAll(' ', '-');
	                        return _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12 mb-3' },
	                          _react2.default.createElement(
	                            'a',
	                            { href: _constants.SITE_URL + '/consultant/' + body_department_doctor.slug, style: { "text-decoration": "none", "color": "#333333" } },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'doctor-list' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'row', style: { height: "80vh", maxHeight: "161px" } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-5' },
	                                  body_department_doctor.doctor_profile ? _react2.default.createElement('img', { src: _constants.IMAGE_URL + '/DoctorProfileImg/' + body_department_doctor.doctor_profile, alt: 'doctor profile', width: 125, height: 161 }) : _react2.default.createElement('img', { src: 'https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg', alt: 'Bitmap-3', width: 125, height: 161 })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-7' },
	                                  _react2.default.createElement(
	                                    'h6',
	                                    null,
	                                    body_department_doctor.doctor_name
	                                  ),
	                                  _react2.default.createElement(
	                                    'p',
	                                    { title: body_department_doctor.degree },
	                                    body_department_doctor.degree ? body_department_doctor.degree.substr(0, 20) + '...' : ''
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'doctor-list' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-12' },
	                              _react2.default.createElement(
	                                'p',
	                                { style: { "text-align": "center", "margin-top": "15px" } },
	                                'No Body Departments Doctors Found'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SingleMaleBodyContent;
	}(_react.Component);
	
	exports.default = SingleMaleBodyContent;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	var _reactSlick = __webpack_require__(63);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _newsEventsModule = __webpack_require__(87);
	
	var _newsEventsModule2 = _interopRequireDefault(_newsEventsModule);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _new = __webpack_require__(136);
	
	var _new2 = _interopRequireDefault(_new);
	
	var _axios = __webpack_require__(64);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _MyProvider = __webpack_require__(48);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _SubPopupIndex = __webpack_require__(114);
	
	var _SubPopupIndex2 = _interopRequireDefault(_SubPopupIndex);
	
	var _PatientRegistrationPopup = __webpack_require__(113);
	
	var _PatientRegistrationPopup2 = _interopRequireDefault(_PatientRegistrationPopup);
	
	var _PopupIndex = __webpack_require__(84);
	
	var _PopupIndex2 = _interopRequireDefault(_PopupIndex);
	
	var _BookAppointmentPopup = __webpack_require__(60);
	
	var _BookAppointmentPopup2 = _interopRequireDefault(_BookAppointmentPopup);
	
	var _BookAppointmentParticularDoctorPopUp = __webpack_require__(142);
	
	var _BookAppointmentParticularDoctorPopUp2 = _interopRequireDefault(_BookAppointmentParticularDoctorPopUp);
	
	var _BookAppointmentTestimoniaDoctorPopUp = __webpack_require__(600);
	
	var _BookAppointmentTestimoniaDoctorPopUp2 = _interopRequireDefault(_BookAppointmentTestimoniaDoctorPopUp);
	
	var _reactRouterDom = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Testimonials = function Testimonials() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      newsEventData = _useState2[0],
	      setNewsEventData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showLoginPopup = _useState4[0],
	      setShowLoginPopup = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      patientRegPopup = _useState6[0],
	      setPatientRegPopup = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      showPatientRegPopup = _useState8[0],
	      setShowPatientRegPopup = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(""),
	      _useState10 = _slicedToArray(_useState9, 2),
	      showthirdpopup = _useState10[0],
	      setShowThirdPopup = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      showDoctorSearchPopup = _useState12[0],
	      setShowDoctorSearchPopup = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      selectedDoctor = _useState14[0],
	      setSelectedDoctor = _useState14[1];
	
	  var _useContext = (0, _react.useContext)(_MyProvider.MyContext),
	      DoctorData = _useContext.DoctorData;
	
	  var _useState15 = (0, _react.useState)(1),
	      _useState16 = _slicedToArray(_useState15, 2),
	      step = _useState16[0],
	      setStep = _useState16[1];
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _.thirdparty)("/testimonials");
	
	              case 3:
	                response = _context.sent;
	
	                // axios.get(`https://uhlbackend.etherstaging.xyz/api/testimonials/getalltestimonials`);
	
	                // Accessing the first object in the array
	                setNewsEventData(response.data);
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context["catch"](0);
	
	                console.error("Error fetching data:", _context.t0);
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 7]]);
	      }));
	
	      return function fetchData() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, []);
	
	  var settings = {
	    rows: 1,
	    dots: false,
	    infinite: true,
	    speed: 500,
	    slidesToShow: 3,
	    slidesToScroll: 1,
	    autoplay: false,
	
	    responsive: [{
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 1,
	        infinite: true,
	        dots: true
	      }
	    }, {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }, {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }]
	  };
	
	  var mobileSettings = {
	    rows: 1,
	    dots: false,
	    infinite: true,
	    speed: 500,
	    slidesToShow: 4,
	    slidesToScroll: 1,
	    autoplay: false,
	    responsive: [{
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        infinite: true,
	        dots: true
	      }
	    }, {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }, {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }]
	  };
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "section",
	      {
	        style: { backgroundColor: "#F7F5EF" },
	        className: "news-events pb-0 " + (_reactDeviceDetect.isMobile ? "pt-0" : ""),
	        id: "hr-lines"
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "container " },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "flex",
	              flexDirection: "row",
	              justifyContent: "center",
	              alignItems: "center",
	              margin: "0 auto"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "" },
	            _react2.default.createElement(
	              "h3",
	              {
	                className: "text-left",
	                style: {
	                  color: "#af9763",
	                  fontSize: "28px",
	                  fontWeight: "500"
	                }
	              },
	              "Testimonials"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row mt-4 pb-0 pb-md-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 right-sp-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "news_section" },
	              _react2.default.createElement(
	                "div",
	                { className: "row", style: { position: "relative" } },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "d-flex justify-content-start align-items-center",
	                    style: {
	                      position: "absolute",
	                      top: _reactDeviceDetect.isMobile ? -25 : -50,
	                      left: 0,
	
	                      width: "fit-content"
	                    }
	                  },
	                  _react2.default.createElement("img", {
	                    className: "img-fluid " + (_reactDeviceDetect.isMobile ? "w-50" : "w-100"),
	                    src: "/assets/images/qutation_top.png",
	                    alt: "",
	                    srcset: ""
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "d-flex justify-content-end align-items-center",
	                    style: {
	                      position: "absolute",
	                      bottom: _reactDeviceDetect.isMobile ? 5 : -25,
	                      right: 0,
	
	                      width: "fit-content"
	                    }
	                  },
	                  _react2.default.createElement("img", {
	                    className: "img-fluid " + (_reactDeviceDetect.isMobile ? "w-50" : "w-100"),
	                    src: "/assets/images/qutation_bottom.png",
	                    alt: "",
	                    srcset: ""
	                  })
	                ),
	                _react2.default.createElement(
	                  _reactDeviceDetect.MobileView,
	                  { className: "" + _newsEventsModule2.default.MobileView },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    mobileSettings,
	                    newsEventData.length > 0 ? newsEventData.map(function (newsevent_data) {
	                      var departmentName = "not found";
	                      if (newsevent_data && newsevent_data.doctor_mave && newsevent_data.doctor_mave.department_mave) {
	                        departmentName = newsevent_data.doctor_mave.department_mave.department_name || "not found";
	                      }
	
	                      return _react2.default.createElement(
	                        "div",
	                        {
	                          className: "col-sm-3 px-1 py-4",
	                          key: newsevent_data.id,
	                          style: {
	                            width: "100%",
	                            maxWidth: "432px",
	                            height: "300px"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "card p-2 d-flex flex-column justify-content-between align-items-start make-orange",
	                            style: {
	                              paddingLeft: "0px",
	                              paddingRight: "0px",
	                              borderRadius: "14px",
	                              height: "250px",
	                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1), 0px -4px 6px rgba(0, 0, 0, 0.1)"
	                            }
	                          },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              href: "/testimonials/" + newsevent_data.id,
	                              style: {
	                                textDecoration: "none",
	                                color: "black",
	                                height: "50%"
	                              }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                // style={{ height: "8rem" }}
	                                className: "card-body d-flex flex-column justify-content-start align-items-start px-3 p-0  pt-1 "
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "d-flex justify-content-between align-items-start make-testimonial-text-white" },
	                                _react2.default.createElement("div", {
	                                  className: "pt-2",
	                                  style: {
	                                    textAlign: "left",
	                                    fontSize: "14px",
	                                    fontWeight: "500"
	                                  },
	                                  dangerouslySetInnerHTML: {
	                                    __html: newsevent_data.testimonial_desc ? newsevent_data.testimonial_desc.split(" ").slice(0, 20).join(" ") + " ..." : ""
	                                  }
	                                })
	                              )
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              className: "authorDetails d-flex justify-content-start align-items-center ms-3",
	                              style: { width: "90%", height: "15%" }
	                            },
	                            _react2.default.createElement(
	                              "h3",
	                              {
	                                className: "text-end w-100 make-testimonial-text-white",
	                                style: {
	                                  fontSize: "14px",
	                                  fontWeight: "400",
	                                  color: "#AF9763"
	                                }
	                              },
	                              "- ",
	                              newsevent_data.author_name
	                            )
	                          ),
	                          _react2.default.createElement("hr", {
	                            // style={{ border: "none" }}
	                            className: "text-decoration-none testimonial-button-hover-effect w-100"
	                          }),
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              className: "d-flex justify-content-around align-items-start w-100 py-1 gap-2",
	                              style: {
	                                // borderTop: "1px solid #AF9763",
	                                height: "30%"
	                              }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              null,
	                              _react2.default.createElement("img", {
	                                className: "img-fluid rounded",
	                                src: newsevent_data.doctor_mave ? _constants.IMAGE_URL + "DoctorProfileImg/" + newsevent_data.doctor_mave.doctor_profile : _new2.default,
	                                width: 50,
	                                height: 50,
	                                alt: "news_events_1"
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "authorDetails d-flex flex-column align-items-start  m-0" },
	                              _react2.default.createElement(
	                                "h5",
	                                {
	                                  className: "make-testimonial-text-white mb-0",
	                                  style: {
	                                    fontSize: "14px",
	                                    color: "#AF9763"
	                                  }
	                                },
	                                newsevent_data.doctor_mave ? newsevent_data.doctor_mave.doctor_name.slice(0, 21) : ""
	                              ),
	                              _react2.default.createElement(
	                                "h6",
	                                {
	                                  className: "make-testimonial-text-white",
	                                  style: {
	                                    fontSize: "10px",
	                                    color: "#B5B5B6"
	                                  }
	                                },
	                                newsevent_data.doctor_mave ? newsevent_data.doctor_mave.degree.slice(0, 24) : ""
	                              ),
	                              _react2.default.createElement(
	                                "h6",
	                                {
	                                  className: "make-testimonial-text-white",
	                                  style: {
	                                    fontSize: "10px",
	                                    color: "#B5B5B6"
	                                  }
	                                },
	                                departmentName
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "btnDiv h-100 d-flex align-items-center" },
	                              localStorage.getItem(_constants.USER_LOCAL_ID) ? _react2.default.createElement(
	                                "button",
	                                {
	                                  type: "button",
	                                  className: "btn-sm border-0 text-white testimonial-button-hover-effect",
	                                  style: {
	                                    // padding: "10px",
	                                    // borderRadius: "5px",
	                                    // backgroundColor: "#AF9763",
	                                    width: "100px",
	                                    fontSize: "16px"
	                                  },
	                                  onClick: function onClick() {
	                                    return setSelectedDoctor(newsevent_data.doctor_mave);
	                                  },
	                                  "data-bs-toggle": "offcanvas",
	                                  "data-bs-target": "#BookAppointmentTestimoniaDoctorPopUp",
	                                  "aria-controls": "BookAppointmentTestimoniaDoctorPopUp"
	                                  // onClick={this.bookAppointmentPopup}
	                                },
	                                "Book Now"
	                              ) : _react2.default.createElement(
	                                "button",
	                                {
	                                  type: "button",
	                                  className: "btn-sm border-0 text-white testimonial-button-hover-effect",
	                                  style: {
	                                    // padding: "10px",
	                                    // borderRadius: "5px",
	                                    // backgroundColor: "#AF9763",
	                                    width: "100px",
	                                    fontSize: "16px"
	                                  },
	                                  href: "#offcanvasExample",
	                                  "data-bs-toggle": "offcanvas",
	                                  role: "button",
	                                  "aria-controls": "offcanvasExample"
	                                },
	                                "Book Now"
	                              )
	                            )
	                          )
	                        )
	                      );
	                    }) : _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-12 post-slide" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "news-part" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "bg-color-back" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "No any news & events founds"
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactDeviceDetect.BrowserView,
	                  { className: "px-0" },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    Object.assign({ className: "slider-1" }, settings),
	                    newsEventData.length > 0 ? newsEventData.map(function (newsevent_data) {
	                      var departmentName = "Not found";
	                      if (newsevent_data && newsevent_data.doctor_mave && newsevent_data.doctor_mave.department_mave) {
	                        departmentName = newsevent_data.doctor_mave.department_mave.department_name || "not found";
	                      }
	
	                      return _react2.default.createElement(
	                        "div",
	                        {
	                          className: "col-sm-3 px-2 py-5",
	                          key: newsevent_data.id,
	                          style: {
	                            width: "100%",
	                            maxWidth: "432px",
	                            height: "400px"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "card p-2 d-flex flex-column justify-content-between align-items-start make-orange shadow",
	                            style: {
	                              paddingLeft: "0px",
	                              paddingRight: "0px",
	                              borderRadius: "14px",
	                              height: "290px"
	                            }
	                          },
	                          _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            {
	                              to: "/testimonials/" + newsevent_data.id,
	                              style: {
	                                textDecoration: "none",
	                                color: "black",
	                                height: "40%"
	                              },
	                              className: ""
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                // style={{ height: "8rem" }}
	                                className: "card-body d-flex flex-column justify-content-start align-items-start px-3 p-0 pt-1"
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "d-flex justify-content-between align-items-start make-testimonial-text-white" },
	                                _react2.default.createElement("div", {
	                                  className: "pt-2",
	                                  style: {
	                                    textAlign: "left",
	                                    fontSize: "16px",
	                                    fontWeight: "500"
	                                  },
	                                  dangerouslySetInnerHTML: {
	                                    __html: newsevent_data.testimonial_desc ? newsevent_data.testimonial_desc.split(" ").slice(0, 30).join(" ") + " ..." : ""
	                                  }
	                                })
	                              )
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              className: "authorDetails d-flex justify-content-start align-items-center ms-3",
	                              style: { width: "90%", height: "15%" }
	                            },
	                            _react2.default.createElement(
	                              "h3",
	                              {
	                                className: "text-end w-100 make-testimonial-text-white",
	                                style: {
	                                  fontSize: "15px",
	                                  fontWeight: "400",
	                                  color: "#AF9763"
	                                }
	                              },
	                              "- ",
	                              newsevent_data.author_name
	                            )
	                          ),
	                          _react2.default.createElement("hr", {
	                            // style={{ border: "none" }}
	                            className: "text-decoration-none testimonial-button-hover-effect w-100"
	                          }),
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              className: "d-flex justify-content-around align-items-start w-100 py-3",
	                              style: {
	                                // borderTop: "1px solid #AF9763",
	                                height: "30%"
	                              }
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              null,
	                              _react2.default.createElement("img", {
	                                className: "img-fluid rounded",
	                                src: newsevent_data.doctor_mave ? _constants.IMAGE_URL + "DoctorProfileImg/" + newsevent_data.doctor_mave.doctor_profile : _new2.default,
	                                width: 50,
	                                height: 50,
	                                alt: "news_events_1"
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "authorDetails d-flex flex-column align-items-start  m-0" },
	                              _react2.default.createElement(
	                                "h5",
	                                {
	                                  className: "make-testimonial-text-white",
	                                  style: {
	                                    fontSize: "16px",
	                                    color: "#AF9763"
	                                  }
	                                },
	                                newsevent_data.doctor_mave ? newsevent_data.doctor_mave.doctor_name.slice(0, 21) : ""
	                              ),
	                              _react2.default.createElement(
	                                "h6",
	                                {
	                                  className: "make-testimonial-text-white",
	                                  style: {
	                                    fontSize: "12px",
	                                    color: "#B5B5B6"
	                                  }
	                                },
	                                newsevent_data.doctor_mave ? newsevent_data.doctor_mave.degree.slice(0, 24) : ""
	                              ),
	                              _react2.default.createElement(
	                                "h6",
	                                {
	                                  className: "make-testimonial-text-white",
	                                  style: {
	                                    fontSize: "12px",
	                                    color: "#B5B5B6"
	                                  }
	                                },
	                                departmentName
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "btnDiv h-100 d-flex align-items-center" },
	                              localStorage.getItem(_constants.USER_LOCAL_ID) ? _react2.default.createElement(
	                                "button",
	                                {
	                                  type: "button",
	                                  className: "btn-sm border-0 testimonial-button-hover-effect",
	                                  style: {
	                                    // padding: "10px",
	                                    // borderRadius: "5px",
	                                    // backgroundColor: "#AF9763",
	                                    width: "100px",
	                                    fontSize: "16px"
	                                  },
	                                  onClick: function onClick() {
	                                    return setSelectedDoctor(newsevent_data.doctor_mave);
	                                  },
	                                  "data-bs-toggle": "offcanvas",
	                                  "data-bs-target": "#BookAppointmentTestimoniaDoctorPopUp",
	                                  "aria-controls": "BookAppointmentTestimoniaDoctorPopUp"
	                                  // onClick={this.bookAppointmentPopup}
	                                },
	                                "Book Now"
	                              ) : _react2.default.createElement(
	                                "button",
	                                {
	                                  type: "button",
	                                  className: "btn-sm border-0 testimonial-button-hover-effect",
	                                  style: {
	                                    // padding: "10px",
	                                    // borderRadius: "5px",
	                                    // backgroundColor: "#AF9763",
	                                    width: "100px",
	                                    fontSize: "16px"
	                                  },
	                                  href: "#offcanvasExample",
	                                  "data-bs-toggle": "offcanvas",
	                                  role: "button",
	                                  "aria-controls": "offcanvasExample"
	                                },
	                                "Book Now"
	                              )
	                            )
	                          )
	                        )
	                      );
	                    }) : _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-12 post-slide" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "news-part" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "bg-color-back" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "No any news & events founds"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    selectedDoctor ? _react2.default.createElement(_BookAppointmentTestimoniaDoctorPopUp2.default, {
	      doctorData: selectedDoctor,
	      setSelectedDoctor: setSelectedDoctor
	    }) : null
	  );
	};
	
	exports.default = Testimonials;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Declaration = function (_Component) {
	  _inherits(Declaration, _Component);
	
	  function Declaration() {
	    _classCallCheck(this, Declaration);
	
	    return _possibleConstructorReturn(this, (Declaration.__proto__ || Object.getPrototypeOf(Declaration)).apply(this, arguments));
	  }
	
	  _createClass(Declaration, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          { id: "giveMarginService", className: "" },
	          _react2.default.createElement(
	            "section",
	            { className: "termscondbody mt-5 mb-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "h2",
	                null,
	                "Disclaimer"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "All the information displayed, transmitted or carried by United Hospital and its related websites including, but not limited to, directories, guides, news articles, opinions, reviews, text, photographs, images, illustrations, profiles, audio clips, video clips, trademarks, service marks and the like, collectively the \u201CContent\u201D, are protected by the copyright and other intellectual property laws and be informed that the content of the same is not intended to be a substitute for professional medical advice and not for solicitation of business. The Content is owned by United Hospital, its affiliates or third party licensors. You may not modify, publish, transmit, transfer, sell, reproduce, create derivative work from, distribute, repost, perform, display or in any way commercially exploit any of the Content. You agree to abide by all copyright notices and restrictions attached to any Content accessed through the United Hospital website and not to alter the content in any way"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Permitted Use: You may take a single copy of the Content displayed on the United Hospital website for personal, non-commercial use only, provided that you do not remove any trademarks, copyright and any other notice contained in such Content. You shall not archive or retain any Content in any form without written permission. The information provided in this site is for the sole purpose of"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return Declaration;
	}(_react.Component);
	
	exports.default = Declaration;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	__webpack_require__(8);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _reactSlick = __webpack_require__(63);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _jquery = __webpack_require__(18);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _BookAppointmentPopup = __webpack_require__(60);
	
	var _BookAppointmentPopup2 = _interopRequireDefault(_BookAppointmentPopup);
	
	var _fa = __webpack_require__(62);
	
	var _BookAppointmentParticularDoctorPopUp = __webpack_require__(142);
	
	var _BookAppointmentParticularDoctorPopUp2 = _interopRequireDefault(_BookAppointmentParticularDoctorPopUp);
	
	var _ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected = __webpack_require__(611);
	
	var _ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected2 = _interopRequireDefault(_ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected);
	
	var _reactDeviceDetect = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getSingleDoctorData = function getSingleDoctorData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors/getsingledoctorprofile_front/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var getDoctorPublicationsData = function getDoctorPublicationsData(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/publications/getdoctorpublications/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var getDoctorTestimonials = function getDoctorTestimonials(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/testimonials", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var getSingleDoctorScheduleData = function getSingleDoctorScheduleData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/doctors", {
	      method: "get",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var DoctorProfile = function DoctorProfile(_ref) {
	  var currentDocId = _ref.currentDocId;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      doctorData = _useState2[0],
	      setDoctorData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      doctorID = _useState4[0],
	      setDoctorID = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(""),
	      _useState6 = _slicedToArray(_useState5, 2),
	      doctorName = _useState6[0],
	      setDoctorName = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      doctorProfile = _useState8[0],
	      setDoctorProfile = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(""),
	      _useState10 = _slicedToArray(_useState9, 2),
	      doctorDegree = _useState10[0],
	      setDoctorDegree = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(""),
	      _useState12 = _slicedToArray(_useState11, 2),
	      doctorDesignation = _useState12[0],
	      setDoctorDesignation = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      doctorFees = _useState14[0],
	      setDoctorFees = _useState14[1];
	
	  var _useState15 = (0, _react.useState)([]),
	      _useState16 = _slicedToArray(_useState15, 2),
	      doctorPublications = _useState16[0],
	      setDoctorPublications = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      doctorEdu = _useState18[0],
	      setDoctorEdu = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      doctorExp = _useState20[0],
	      setDoctorExp = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(""),
	      _useState22 = _slicedToArray(_useState21, 2),
	      doctorTable = _useState22[0],
	      setDoctorTable = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(""),
	      _useState24 = _slicedToArray(_useState23, 2),
	      docProfessionalSkills = _useState24[0],
	      setDocProfessionalSkills = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(""),
	      _useState26 = _slicedToArray(_useState25, 2),
	      docMemberships = _useState26[0],
	      setDocMemberships = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(""),
	      _useState28 = _slicedToArray(_useState27, 2),
	      docAwards = _useState28[0],
	      setDocAwards = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(""),
	      _useState30 = _slicedToArray(_useState29, 2),
	      docKeyResearchExperience = _useState30[0],
	      setDocKeyResearchExperience = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(""),
	      _useState32 = _slicedToArray(_useState31, 2),
	      docKeyPublications = _useState32[0],
	      setDocKeyPublications = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(""),
	      _useState34 = _slicedToArray(_useState33, 2),
	      docKeyScientificPresentations = _useState34[0],
	      setDocKeyScientificPresentations = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(true),
	      _useState36 = _slicedToArray(_useState35, 2),
	      loading = _useState36[0],
	      setLoading = _useState36[1];
	
	  var _useState37 = (0, _react.useState)([]),
	      _useState38 = _slicedToArray(_useState37, 2),
	      testimonials = _useState38[0],
	      setTestimonials = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({}),
	      _useState40 = _slicedToArray(_useState39, 2),
	      doctorSchedulesTime = _useState40[0],
	      setDoctorSchedulesTime = _useState40[1];
	
	  var _useState41 = (0, _react.useState)([]),
	      _useState42 = _slicedToArray(_useState41, 2),
	      descriptions = _useState42[0],
	      setDescriptions = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    DoctorId: "",
	    PreferredDate: "",
	    doctorData: null,
	    selectedSchedule: ""
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      scheduleReqData = _useState44[0],
	      setScheduleReqData = _useState44[1];
	
	  var refreshGetDoctorData = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(id) {
	      var res, records;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return getSingleDoctorData(id);
	
	            case 3:
	              res = _context.sent;
	
	              if (res.status === 200) {
	                records = res.data.data;
	
	                setDoctorName(records.doctor_name || "");
	                setDoctorDesignation(records.designation || "");
	                setDoctorProfile(records.doctor_profile || "");
	                setDoctorDegree(records.degree || "");
	                setDoctorFees(records.doctor_fees || "");
	                setDoctorEdu(records.doctor_edu || "");
	                setDoctorTable(JSON.parse(records.doctor_table) || "");
	                setDoctorExp(records.doctor_exp || "");
	                setDocProfessionalSkills(records.doc_professional_skills || "");
	                setDocMemberships(records.doc_memberships || "");
	                setDocAwards(records.doc_awards || "");
	                setDocKeyResearchExperience(records.doc_key_research_experience || "");
	                setDocKeyPublications(records.doc_key_publications || "");
	                setDocKeyScientificPresentations(records.doc_key_scientific_presentations || "");
	                setDoctorID(records.id || "");
	                setDescriptions(JSON.parse(records.description_list) || []);
	                setDoctorSchedulesTime(records.Schedule[0] || {});
	                setDoctorData(records);
	                setScheduleReqData({
	                  DoctorId: records.id,
	                  PreferredDate: new Date().toISOString().split("T")[0],
	                  doctorData: records
	                });
	              } else {
	                // Reset state if no data
	                setDoctorName("");
	                setDoctorDesignation("");
	                setDoctorProfile("");
	                setDoctorDegree("");
	                setDoctorFees("");
	                setDoctorEdu("");
	                setDoctorExp("");
	                setDocProfessionalSkills("");
	                setDocMemberships("");
	                setDocAwards("");
	                setDocKeyResearchExperience("");
	                setDocKeyPublications("");
	                setDocKeyScientificPresentations("");
	                setDescriptions([]);
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context["catch"](0);
	
	              console.log(_context.t0);
	
	            case 10:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function refreshGetDoctorData(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var refreshGetDoctorTestimonials = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(doctor_id) {
	      var res, records, filteredTestimonial;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return getDoctorTestimonials({ doctor_id: doctor_id });
	
	            case 3:
	              res = _context2.sent;
	
	              if (res.status === 200) {
	                records = res.data;
	                filteredTestimonial = records.filter(function (testimonial) {
	                  return testimonial.doctor_id && parseInt(testimonial.doctor_id) === doctorID;
	                });
	                // console.log("your log output", filteredTestimonial);
	
	                setTestimonials(filteredTestimonial);
	              } else {
	                setTestimonials([]);
	              }
	              _context2.next = 11;
	              break;
	
	            case 7:
	              _context2.prev = 7;
	              _context2.t0 = _context2["catch"](0);
	
	              console.log(_context2.t0);
	              setTestimonials([]);
	
	            case 11:
	              _context2.prev = 11;
	
	              setLoading(false);
	              return _context2.finish(11);
	
	            case 14:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 7, 11, 14]]);
	    }));
	
	    return function refreshGetDoctorTestimonials(_x2) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var refreshGetDoctorPublicationsData = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(id) {
	      var res;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              _context3.next = 3;
	              return getDoctorPublicationsData(id);
	
	            case 3:
	              res = _context3.sent;
	
	              if (res.status === true) {
	                setDoctorPublications(res.data);
	              } else {
	                setDoctorPublications([]);
	              }
	              _context3.next = 10;
	              break;
	
	            case 7:
	              _context3.prev = 7;
	              _context3.t0 = _context3["catch"](0);
	
	              console.log(_context3.t0);
	
	            case 10:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[0, 7]]);
	    }));
	
	    return function refreshGetDoctorPublicationsData(_x3) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    var doctor_id = currentDocId.split("~").pop();
	    refreshGetDoctorData(doctor_id);
	    refreshGetDoctorPublicationsData(doctor_id);
	    refreshGetDoctorTestimonials(doctor_id);
	  }, [currentDocId, doctorID]);
	
	  var settings = {
	    dots: false,
	    infinite: true,
	    speed: 500,
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    autoplay: false
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: doctorName + " | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Doctor, singledoctor"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      })
	    ),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", style: { backgroundColor: "#ffffff" } },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" })
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "prof-dr pb-3" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "box-of-about border-part px-0 py-5 border-0 rounded-3",
	              style: {
	                backgroundPosition: "center",
	                backgroundSize: "cover",
	                backgroundColor: "#fff",
	                borderRadius: "20px"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-5 col-md-12" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "text-profile d-flex gap-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-center justify-content-md-start" },
	                    doctorProfile ? _react2.default.createElement("img", {
	                      src: _constants.IMAGE_URL + "DoctorProfileImg/" + doctorProfile,
	                      alt: "doc",
	                      className: "img-doc border-0 shadow"
	                    }) : _react2.default.createElement("img", {
	                      src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                      alt: "doc",
	                      className: "img-doc border-0 shadow"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex flex-column mt-2" },
	                    _react2.default.createElement(
	                      "h2",
	                      { title: doctorName },
	                      doctorName
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      doctorDegree
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      doctorDesignation
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-7 col-md-12" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "text-profile", id: "mobile-part" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    "Availability"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "row",
	                      id: "tab-mob",
	                      style: { justifyContent: "left" }
	                    },
	                    doctorSchedulesTime ? function () {
	                      var maxHeight = 100;
	                      var validDays = ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
	                      var elements = Object.entries(doctorSchedulesTime).map(function (_ref5) {
	                        var _ref6 = _slicedToArray(_ref5, 2),
	                            day = _ref6[0],
	                            time = _ref6[1];
	
	                        if (!validDays.includes(day)) return null; // Ignore invalid days
	                        return [day, time];
	                      }).filter(Boolean) // Remove null values
	                      .sort(function (_ref7, _ref8) {
	                        var _ref10 = _slicedToArray(_ref7, 1),
	                            day1 = _ref10[0];
	
	                        var _ref9 = _slicedToArray(_ref8, 1),
	                            day2 = _ref9[0];
	
	                        return ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].indexOf(day1) - ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].indexOf(day2);
	                      }).map(function (_ref11) {
	                        var _ref12 = _slicedToArray(_ref11, 2),
	                            day = _ref12[0],
	                            time = _ref12[1];
	
	                        if (!time) return null; // Skip empty time slots
	
	                        var timeSlots = time.split(",").map(function (slot, index) {
	                          return _react2.default.createElement(
	                            "li",
	                            { key: index },
	                            slot
	                          );
	                        });
	
	                        return _react2.default.createElement(
	                          "div",
	                          {
	                            key: day,
	                            className: "doctor_schedule_section col-3 p-1",
	                            ref: function ref(el) {
	                              if (el) {
	                                var height = el.getBoundingClientRect().height;
	                                maxHeight = Math.max(maxHeight, height);
	                              }
	                            }
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "div",
	                              { className: "table table-sst" },
	                              _react2.default.createElement(
	                                "ul",
	                                null,
	                                _react2.default.createElement(
	                                  "li",
	                                  null,
	                                  day
	                                ),
	                                timeSlots
	                              )
	                            )
	                          )
	                        );
	                      });
	
	                      // Apply maxHeight dynamically to all elements
	                      return elements.map(function (el) {
	                        return el ? _react2.default.cloneElement(el, {
	                          style: { minHeight: maxHeight + "px" }
	                        }) : null;
	                      });
	                    }() : "Nothing to Show"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "number-profile",
	                      id: "tell",
	                      style: { backgroundColor: "#AF9763" }
	                    },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "tel:10666", className: "py-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "d-flex align-items-center justify-content-center gap-5" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "text-center d-flex justify-content-center align-items-center" },
	                          _react2.default.createElement(_fa.FaPhoneAlt, {
	                            size: 25,
	                            color: "#ffffff"
	                            // style={{ fontSize: "35px", color: "#fff" }}
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "" },
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                              "span",
	                              null,
	                              "24*7 Hotline "
	                            ),
	                            "10666"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-12" },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          className: "btn btn-secondary make-btn py-2 d-flex align-items-center justify-content-center gap-4",
	                          style: { backgroundColor: "#0C807D" },
	                          "data-bs-toggle": "offcanvas",
	                          "data-bs-target": "#BookAppointMentParticularDoctorPopUp",
	                          "aria-controls": "BookAppointMentParticularDoctorPopUp"
	                        },
	                        _react2.default.createElement(_fa.FaCalendarAlt, { size: 25, color: "#ffffff" }),
	                        "Make Appointment Online"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              _react2.default.createElement(
	                "h4",
	                {
	                  style: {
	                    color: "#0C807D",
	                    borderBottom: "2px solid #0C807D",
	                    width: "fit-content"
	                  }
	                },
	                "Profile"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-7 col-md-12" },
	              descriptions.length > 0 ? descriptions.filter(function (item) {
	                return item.visibility === 1;
	              }).map(function (item) {
	                return _react2.default.createElement(
	                  "div",
	                  {
	                    key: item.key,
	                    className: "mt-4 mb-2",
	                    style: {
	                      backgroundPosition: "center",
	                      backgroundSize: "cover",
	                      backgroundColor: "#fff",
	                      borderRadius: "20px",
	                      backgroundRepeat: "no-repeat"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "text-profile" },
	                    _react2.default.createElement("p", {
	                      className: "b border-0",
	                      dangerouslySetInnerHTML: { __html: item.value }
	                    })
	                  )
	                );
	              }) : ""
	            ),
	            testimonials.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "col-lg-5 col-md-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "border-part mt-4 mb-5 shadow" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "text-profile" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    "Testimonials"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row mt-2" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row testimonial_section" },
	                        _react2.default.createElement(
	                          _reactSlick2.default,
	                          settings,
	                          testimonials.map(function (testimonial) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                key: testimonial.id,
	                                className: "post-slide testimonials-part",
	                                style: { paddingTop: "60px", zIndex: -1 }
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "card d-flex flex-column shadow-sm px-2",
	                                  style: {
	                                    marginTop: "100px",
	                                    border: "1px solid #dbdbdb",
	                                    borderRadius: "10px",
	                                    position: "relative"
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "d-flex justify-content-start align-items-center",
	                                    style: {
	                                      position: "absolute",
	                                      top: _reactDeviceDetect.isMobile ? -25 : -50,
	                                      left: 0,
	                                      width: "fit-content"
	                                    }
	                                  },
	                                  _react2.default.createElement("img", {
	                                    className: "img-fluid w-50",
	                                    src: "/assets/images/qutation_top.png",
	                                    alt: ""
	                                  })
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "d-flex justify-content-end align-items-center",
	                                    style: {
	                                      position: "absolute",
	                                      bottom: _reactDeviceDetect.isMobile ? 5 : -45,
	                                      right: 0,
	                                      width: "fit-content"
	                                    }
	                                  },
	                                  _react2.default.createElement("img", {
	                                    className: "img-fluid w-50",
	                                    src: "/assets/images/qutation_bottom.png",
	                                    alt: ""
	                                  })
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "text-center d-flex justify-content-center align-items-center",
	                                    style: { marginTop: "-50px" }
	                                  },
	                                  _react2.default.createElement("img", {
	                                    src: testimonial.author_profile_pic ? _constants.IMAGE_URL + "/AuthorProfileImg/" + testimonial.author_profile_pic : "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                                    alt: "Author Profile",
	                                    style: {
	                                      height: "100px",
	                                      width: "100px",
	                                      borderRadius: "50%",
	                                      objectFit: "cover",
	                                      objectPosition: "top",
	                                      border: "4px solid white",
	                                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
	                                    }
	                                  })
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "text-center mb-4" },
	                                  _react2.default.createElement("p", {
	                                    className: "text-chnage",
	                                    dangerouslySetInnerHTML: {
	                                      __html: testimonial.testimonial_desc ? testimonial.testimonial_desc.split(" ").slice(0, 50).join(" ") : ""
	                                    }
	                                  }),
	                                  _react2.default.createElement(
	                                    "p",
	                                    { className: "author-name mt-2" },
	                                    _react2.default.createElement(
	                                      "strong",
	                                      null,
	                                      testimonial.author_name
	                                    )
	                                  )
	                                ),
	                                testimonial.doctor_mave && _react2.default.createElement(
	                                  "div",
	                                  { className: "doctor-details d-flex align-items-center mb-4" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "me-3" },
	                                    _react2.default.createElement("img", {
	                                      src: _constants.IMAGE_URL + "/DoctorProfileImg/" + testimonial.doctor_mave.doctor_profile,
	                                      alt: "Doctor Profile",
	                                      style: {
	                                        height: "60px",
	                                        width: "60px",
	                                        borderRadius: "50%",
	                                        objectFit: "cover"
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "text-start" },
	                                    _react2.default.createElement(
	                                      "h6",
	                                      {
	                                        className: "mb-1",
	                                        style: { fontSize: "14px" }
	                                      },
	                                      testimonial.doctor_mave.doctor_name
	                                    ),
	                                    _react2.default.createElement(
	                                      "p",
	                                      {
	                                        className: "mb-0",
	                                        style: { fontSize: "12px" }
	                                      },
	                                      testimonial.doctor_mave.designation
	                                    ),
	                                    _react2.default.createElement(
	                                      "p",
	                                      {
	                                        className: "mb-0",
	                                        style: { fontSize: "12px" }
	                                      },
	                                      testimonial.doctor_mave.degree
	                                    )
	                                  )
	                                )
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    doctorData && _react2.default.createElement(_BookAppointmentParticularDoctorPopUp2.default, {
	      doctorData: doctorData
	    }),
	    scheduleReqData.doctorData ? _react2.default.createElement(_ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected2.default, {
	      scheduleReqData: scheduleReqData
	    }) : null,
	    _react2.default.createElement(_BookAppointmentPopup2.default, null)
	  );
	};
	
	exports.default = DoctorProfile;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ = __webpack_require__(2);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _RadioGroup = __webpack_require__(140);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	__webpack_require__(43);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _thana = __webpack_require__(53);
	
	var _thana2 = _interopRequireDefault(_thana);
	
	var _jquery = __webpack_require__(18);
	
	var _reactDatepicker = __webpack_require__(54);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(59);
	
	var _GalleryForEmergency = __webpack_require__(208);
	
	var _GalleryForEmergency2 = _interopRequireDefault(_GalleryForEmergency);
	
	var _AmbulanceService = __webpack_require__(205);
	
	var _AmbulanceService2 = _interopRequireDefault(_AmbulanceService);
	
	var _AmbulanceGallery = __webpack_require__(204);
	
	var _AmbulanceGallery2 = _interopRequireDefault(_AmbulanceGallery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ServiceFormView = function ServiceFormView() {
	  var _useState = (0, _react.useState)({
	    type: "emergency",
	    first_name: "",
	    phone_number: "",
	    emergencynumber: "",
	    date_of_birth: "",
	    blood_group: "",
	    gender: "",
	    condition: "",
	    address: "",
	    thana: "",
	    need_ambulance: "",
	    pickup_address: "",
	    user_file: null,
	    email: localStorage.getItem("USER_EMAIL")
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  var handleChange = function handleChange(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value,
	        files = _e$target.files;
	
	    if (files) {
	      setFormData(function (prevData) {
	        return Object.assign({}, prevData, _defineProperty({}, name, files[0]));
	      });
	    } else {
	      setFormData(function (prevData) {
	        return Object.assign({}, prevData, _defineProperty({}, name, value));
	      });
	    }
	  };
	  var handleClick = function handleClick(name, value) {
	    setFormData(function (prevData) {
	      return Object.assign({}, prevData, _defineProperty({}, name, value));
	    });
	  };
	
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	
	    var req = _.scAxiosAdmin.post("/emergenecies_enquiry", Object.assign({}, formData, { additional: { condition: formData.condition } }), {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        "Content-Type": "multipart/form-data"
	      }
	    });
	    req.then(function (response) {
	      if (response.status === 201) {
	        _reactToastify.toast.success("Your request is received, you will be notified soon!");
	      } else {
	        _reactToastify.toast.error("Ops something went wrong!");
	      }
	    }).catch(function (error) {
	      _reactToastify.toast.error(error.response.statusText);
	      // console.log(error)
	    });
	  };
	
	  var options = [{ label: "Home", value: "Home", index: 0 }, { label: "Hospital", value: "Hospital", index: 1 }];
	  var bloodGroup = [{
	    type: "Positive",
	    options: [{ label: "A+", value: "A+" }, { label: "AB+", value: "AB+" }, { label: "B+", value: "B+" }, { label: "O+", value: "O+" }]
	  }, {
	    type: "Negative",
	    options: [{ label: "A-", value: "A-" }, { label: "AB-", value: "AB-" }, { label: "B-", value: "B-" }, { label: "O-", value: "O-" }]
	  }];
	
	  var rhFactor = [{ label: "Positive (+)", value: "+" }, { label: "Negative (-)", value: "-" }];
	  var gender = [{ label: "Male ", value: "Male", index: 0 }, { label: "Female ", value: "Female", index: 1 }];
	  var ambulance = [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }];
	  // Accessing positive blood group options
	  var positiveBloodTypes = bloodGroup.find(function (group) {
	    return group.type === "Positive";
	  }).options;
	
	  // Accessing negative blood group options
	  var negativeBloodTypes = bloodGroup.find(function (group) {
	    return group.type === "Negative";
	  }).options;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: "Emergency | Best Hospital in Bangladesh | United Hospital",
	      description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	      pathSlug: "/",
	      keywords: "Emergency"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      ),
	      _react2.default.createElement("meta", {
	        name: "Subject",
	        content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	      }),
	      _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	      _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	      _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	      _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	      _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	      _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	      _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	      _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	      _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	      _react2.default.createElement("meta", {
	        name: "classification",
	        content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	      }),
	      _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	      _react2.default.createElement("meta", {
	        names: "apple-mobile-web-app-status-bar-style",
	        content: "black-translucent"
	      }),
	      _react2.default.createElement("meta", { name: "msvalidate.01", content: "16C4E0B16E39354E550F64BD707F6A97" })
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin" },
	      _react2.default.createElement(
	        "section",
	        { className: "banner-hero" },
	        _react2.default.createElement("img", {
	          src: "/static/media/banner-profile.f160a4c1.jpg",
	          alt: "banner-profile",
	          className: "w-100"
	        })
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "prof-dr" },
	        _react2.default.createElement(
	          "div",
	          { className: "container pb-5" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "d-flex container justify-content-start align-items-center pt-4",
	              style: { paddingBottom: "2.3rem" }
	            },
	            _react2.default.createElement(
	              "div",
	              { "class": "bg-white p-0", style: {} },
	              _react2.default.createElement(
	                "a",
	                { href: "tel:10666" },
	                _react2.default.createElement(
	                  "h1",
	                  {
	                    className: "text-center category-list-link open-cat-list",
	                    style: { backgroundColor: "red", borderRadius: "10px" }
	                  },
	                  "Call Emergency Line ",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "h1",
	                    null,
	                    " ",
	                    _react2.default.createElement("i", { className: "fa fa-phone mt-2 " }),
	                    "10666"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "box-of-about " },
	            _react2.default.createElement(
	              "div",
	              { "class": "container" },
	              _react2.default.createElement(
	                "div",
	                { "class": "row gy-4" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "col-md-12" },
	                  _react2.default.createElement(
	                    "h2",
	                    { className: " text-left mb-5" },
	                    "Emergency Transfer Request Form"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "text-profile " },
	                    _react2.default.createElement(
	                      "form",
	                      { onSubmit: handleSubmit },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group col-md-4" },
	                          _react2.default.createElement(
	                            "label",
	                            { htmlFor: "firstName" },
	                            "Patient's Name:"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control",
	                            id: "firstName",
	                            name: "first_name",
	                            value: formData.first_name,
	                            onChange: handleChange,
	                            required: true
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group col-md-4" },
	                          _react2.default.createElement(
	                            "label",
	                            { htmlFor: "phoneNumber" },
	                            "Emergency Contact Number:"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "tel",
	                            className: "form-control",
	                            id: "phone_number",
	                            name: "phone_number",
	                            value: formData.phone_number,
	                            onChange: handleChange,
	                            required: true
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-group col-md-4" },
	                          _react2.default.createElement(
	                            "label",
	                            { htmlFor: "dataOfBirth" },
	                            "Date of Birth:"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("input", {
	                            type: "date",
	                            id: "date_of_birth",
	                            onChange: handleChange,
	                            name: "date_of_birth",
	                            style: { width: "100%", padding: 4 }
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "gender" },
	                          "Gender:"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "radio-button-group" },
	                          gender.map(function (option, index) {
	                            return _react2.default.createElement(
	                              "label",
	                              {
	                                style: {
	                                  backgroundColor: option.value === formData.gender ? "#0c807d" : "transparent",
	                                  color: option.value === formData.gender ? "#ffffff" : "black",
	                                  borderRadius: "5px",
	                                  border: "1px solid #80808042"
	                                },
	                                key: option.value,
	                                className: "radio-button " + (formData.gender === option.value ? "active" : "") + " me-3 py-2 pe-3"
	                              },
	                              _react2.default.createElement("input", {
	                                type: "radio",
	                                name: "gender",
	                                value: option.value,
	                                checked: formData.gender === option.value,
	                                onChange: function onChange() {
	                                  return handleClick("gender", option.value);
	                                },
	                                style: { visibility: "hidden" }
	                              }),
	                              option.label
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "condition" },
	                          "Condition:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "condition",
	                          name: "condition",
	                          value: formData.condition,
	                          onChange: handleChange,
	                          required: true
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group d-flex flex-column" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "needAmbulance" },
	                          "Do you need an ambulance?"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "" },
	                          ambulance.map(function (option, index) {
	                            return _react2.default.createElement(
	                              "label",
	                              {
	                                style: {
	                                  backgroundColor: option.value === formData.need_ambulance ? "#0c807d" : "transparent",
	                                  color: option.value === formData.need_ambulance ? "#ffffff" : "black",
	                                  borderRadius: "5px",
	                                  border: "1px solid #80808042"
	                                },
	                                key: option.value,
	                                className: "radio-button " + (formData.need_ambulance === option.value ? "active" : "") + " me-3 py-2 pe-3"
	                              },
	                              _react2.default.createElement("input", {
	                                type: "radio",
	                                name: "gender",
	                                value: option.value,
	                                checked: formData.need_ambulance === option.value,
	                                onChange: function onChange() {
	                                  return handleClick("need_ambulance", option.value);
	                                },
	                                style: { visibility: "hidden" }
	                              }),
	                              option.label
	                            );
	                          })
	                        )
	                      ),
	                      formData.need_ambulance == "Yes" && _react2.default.createElement(
	                        "div",
	                        { className: "form-group" },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "pickupLocationAddress" },
	                          "Pick up location Address:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control",
	                          id: "pickup_address",
	                          name: "pickup_address",
	                          value: formData.pickup_address,
	                          onChange: handleChange,
	                          required: true
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-group " },
	                        _react2.default.createElement(
	                          "label",
	                          { htmlFor: "document" },
	                          "Case Summary Upload:",
	                          " "
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "file",
	                          className: "form-control-file px-1",
	                          id: "user_file",
	                          name: "user_file",
	                          onChange: handleChange
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          className: "buts",
	                          style: { color: "#fff" },
	                          type: "submit",
	                          disabled: formData.isButtonDisabled
	
	                          // className="text-center category-list-link open-cat-list border-0 rounded"
	                        },
	                        "Submit"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement("hr", { className: "w-50 mx-auto my-5 " }),
	                  _react2.default.createElement(_GalleryForEmergency2.default, null),
	                  _react2.default.createElement(_AmbulanceService2.default, null),
	                  _react2.default.createElement(_AmbulanceGallery2.default, null)
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	    _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	  );
	};
	
	exports.default = ServiceFormView;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icon = __webpack_require__(57);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icon3 = __webpack_require__(131);
	
	var _icon4 = _interopRequireDefault(_icon3);
	
	var _icon5 = __webpack_require__(132);
	
	var _icon6 = _interopRequireDefault(_icon5);
	
	var _icon7 = __webpack_require__(133);
	
	var _icon8 = _interopRequireDefault(_icon7);
	
	var _icon9 = __webpack_require__(134);
	
	var _icon10 = _interopRequireDefault(_icon9);
	
	var _cardiac = __webpack_require__(104);
	
	var _cardiac2 = _interopRequireDefault(_cardiac);
	
	var _heroBody = __webpack_require__(1168);
	
	var _heroBody2 = _interopRequireDefault(_heroBody);
	
	var _Bitmap = __webpack_require__(444);
	
	var _Bitmap2 = _interopRequireDefault(_Bitmap);
	
	var _happy_patient = __webpack_require__(449);
	
	var _happy_patient2 = _interopRequireDefault(_happy_patient);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {API_TOKEN_NAME} from '../../../constants';
	//import {Route} from 'react-router-dom';
	//import { scAxios } from '../../..';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	
	
	var Homecardic = function (_Component) {
	  _inherits(Homecardic, _Component);
	
	  function Homecardic() {
	    _classCallCheck(this, Homecardic);
	
	    return _possibleConstructorReturn(this, (Homecardic.__proto__ || Object.getPrototypeOf(Homecardic)).apply(this, arguments));
	  }
	
	  _createClass(Homecardic, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Seo2.default, { title: 'Homecardic', description: 'Homecardic United Hospital', pathSlug: 'Homecardic', keywords: 'Homecardic, Cardic' }),
	        _react2.default.createElement(
	          'section',
	          { className: 'center-of-excellence', id: 'excellence-part' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Center of Excellence'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { id: 'news-slider', className: 'owl-carousel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'post-slide' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: _icon2.default, alt: 'icon-2' })
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'General Health'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'post-slide' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: _cardiac2.default, alt: 'cardiac' })
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Cardiac'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'post-slide' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: _icon4.default, alt: 'icon-3' })
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Orthopedics'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'post-slide' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: _icon6.default, alt: 'icon-4' })
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Oncology'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'post-slide' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: _icon8.default, alt: 'icon-5' })
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Materity'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'post-slide' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: _icon10.default, alt: 'icon-6' })
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Hepatology'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'post-slide' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: _cardiac2.default, alt: 'cardiac.svg' })
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Cardiac'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'post-slide' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: _icon6.default, alt: 'icon-4' })
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Oncology'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'body-and-doctor mt-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-5 col-sm-12' },
	                  _react2.default.createElement('img', { src: _heroBody2.default, alt: 'hero-body', className: 'hero-body' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-7 col-sm-12' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Cardiac Department'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'our-consultants pt-4 mt-5' },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Our Consultants ',
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        '(See All)'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row mt-4' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-6 col-md-6' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'doctor-list' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-5' },
	                              _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-7' },
	                              _react2.default.createElement(
	                                'h6',
	                                null,
	                                'Dr. Reazur Rahman'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                { className: 'mb-1' },
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '#', className: 'read-more' },
	                                  'Read More'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-6 col-md-6' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'doctor-list' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-5' },
	                              _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-7' },
	                              _react2.default.createElement(
	                                'h6',
	                                null,
	                                'Dr. Reazur Rahman'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                { className: 'mb-1' },
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '#', className: 'read-more' },
	                                  'Read More'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row mt-4' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-6 col-md-6' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'doctor-list' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-5' },
	                              _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-7' },
	                              _react2.default.createElement(
	                                'h6',
	                                null,
	                                'Dr. Reazur Rahman'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                { className: 'mb-1' },
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '#', className: 'read-more' },
	                                  'Read More'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-6 col-md-6' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'doctor-list' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-5' },
	                              _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-7' },
	                              _react2.default.createElement(
	                                'h6',
	                                null,
	                                'Dr. Reazur Rahman'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                { className: 'mb-1' },
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '#', className: 'read-more' },
	                                  'Read More'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row mt-4' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-6 col-md-6' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'doctor-list' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-5' },
	                              _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-7' },
	                              _react2.default.createElement(
	                                'h6',
	                                null,
	                                'Dr. Reazur Rahman'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                { className: 'mb-1' },
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '#', className: 'read-more' },
	                                  'Read More'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-6 col-md-6' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'doctor-list' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-5' },
	                              _react2.default.createElement('img', { src: _Bitmap2.default, alt: 'Bitmap-3' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-7' },
	                              _react2.default.createElement(
	                                'h6',
	                                null,
	                                'Dr. Reazur Rahman'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                { className: 'mb-1' },
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '#', className: 'read-more' },
	                                  'Read More'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row', id: 'saying' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 mb-4' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'What Patients Are Saying'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-3 text-center' },
	                _react2.default.createElement('img', { src: _happy_patient2.default, alt: 'happy_patient' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'zubaida' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Zubaida Tahman ',
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      '(Cardiac Surgery)'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit  nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'see-more ' },
	                  'See More Patient Stories'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Homecardic;
	}(_react.Component);
	
	exports.default = Homecardic;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {API_TOKEN_NAME} from '../../../constants';
	//import {Route} from 'react-router-dom';
	//import { scAxios } from '../../..';
	//import { ToastContainer, toast } from 'react-toastify';
	//import 'react-toastify/dist/ReactToastify.css';
	var GetAllMenu = function GetAllMenu(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/menu/getallmenu", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var PackageOne = function (_Component) {
	  _inherits(PackageOne, _Component);
	
	  function PackageOne() {
	    _classCallCheck(this, PackageOne);
	
	    return _possibleConstructorReturn(this, (PackageOne.__proto__ || Object.getPrototypeOf(PackageOne)).apply(this, arguments));
	  }
	
	  _createClass(PackageOne, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	          title: "Packages | Best Hospital in Bangladesh | United Hospital",
	          description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	          pathSlug: "/",
	          keywords: "Packages"
	        }),
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement("meta", {
	            name: "description",
	            content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	          }),
	          _react2.default.createElement(
	            "script",
	            { type: "application/ld+json" },
	            JSON.stringify({
	              "@context": "http://schema.org",
	              "@type": "LocalBusiness",
	              name: "United Hospital Limited",
	              image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	              telephone: "10666",
	              email: "info@uhlbd.com",
	              address: {
	                "@type": "PostalAddress",
	                streetAddress: "plot 15, Road 71, Gulshan",
	                addressLocality: "Dhaka",
	                addressRegion: "Dhaka",
	                addressCountry: "Bangladesh",
	                postalCode: "1212"
	              },
	              openingHoursSpecification: {
	                "@type": "OpeningHoursSpecification",
	                opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	              },
	              url: "http://www.uhlbd.com/",
	              aggregateRating: {
	                "@type": "AggregateRating",
	                ratingValue: "3.9",
	                bestRating: "5",
	                worstRating: "1",
	                ratingCount: "756"
	              },
	              review: {
	                "@type": "Review",
	                author: {
	                  "@type": "Person",
	                  name: "abdul kahar"
	                },
	                datePublished: "2019-02-12",
	                reviewRating: {
	                  "@type": "Rating",
	                  ratingValue: "3.9",
	                  bestRating: "5",
	                  worstRating: "1"
	                },
	                reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	              }
	            })
	          ),
	          _react2.default.createElement("meta", {
	            name: "Subject",
	            content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	          }),
	          _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	          _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	          _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	          _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	          _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	          _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	          _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	          _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	          _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	          _react2.default.createElement("meta", {
	            name: "classification",
	            content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	          }),
	          _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	          _react2.default.createElement("meta", {
	            names: "apple-mobile-web-app-status-bar-style",
	            content: "black-translucent"
	          }),
	          _react2.default.createElement("meta", {
	            name: "msvalidate.01",
	            content: "16C4E0B16E39354E550F64BD707F6A97"
	          })
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "", id: "giveMargin" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "w-100 d-flex justify-content-center align-items-center flex-column pt-4" },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    display: "flex",
	                    justifyContent: "flex-start",
	                    alignItems: "flex-start",
	                    flexDirection: "column"
	                    // margin: "0 auto",
	                    // marginBottom: "10px",
	                  }
	                },
	                _react2.default.createElement(
	                  "h3",
	                  {
	                    className: "text-center",
	                    style: {
	                      color: "#0C807D",
	                      fontSize: "28px",
	                      fontWeight: "500"
	
	                    }
	                  },
	                  "Packages"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PackageOne;
	}(_react.Component);
	
	exports.default = PackageOne;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _ = __webpack_require__(2);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _MyProvider = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getPackagesLists = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _.scAxiosAdmin.request("/packages/get_package_list", {
	              method: "get",
	              headers: {
	                Accept: "application/json",
	                Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	              },
	              params: Object.assign({}, data)
	            }).then(function (res) {
	              return res.data;
	            });
	
	          case 2:
	            return _context.abrupt("return", _context.sent);
	
	          case 3:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function getPackagesLists(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var PackageTwo = function PackageTwo() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      allPackages = _useState2[0],
	      setAllPackages = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      filteredPackages = _useState4[0],
	      setFilteredPackages = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({
	    gender: "",
	    age: "",
	    department: "",
	    pre_exist_condition: ""
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filters = _useState6[0],
	      setFilters = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    total: 0,
	    currentPage: 1,
	    perPage: 9
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      pagination = _useState8[0],
	      setPagination = _useState8[1];
	
	  var context = (0, _react.useContext)(_MyProvider.MyContext);
	
	  var fetchPackages = function fetchPackages() {
	    var data = filters;
	    getPackagesLists(data).then(function (res) {
	      if (res.status) {
	        setAllPackages(res.data);
	        setFilteredPackages(res.data); // Initially, all data is shown
	        setPagination(function (prev) {
	          return Object.assign({}, prev, {
	            total: res.data.length,
	            currentPage: 1
	          });
	        });
	      } else {
	        setAllPackages([]);
	        setFilteredPackages([]);
	      }
	    }).catch(function (err) {
	      return console.log(err);
	    });
	  };
	
	  var handlePageChange = function handlePageChange(pageNumber) {
	    setPagination(function (prev) {
	      return Object.assign({}, prev, {
	        currentPage: pageNumber
	      });
	    });
	  };
	
	  var handleFilterChange = function handleFilterChange(name, value) {
	    setFilters(function (prev) {
	      return Object.assign({}, prev, _defineProperty({}, name, value));
	    });
	  };
	
	  // Recalculate filtered packages whenever filters or allPackages change
	  (0, _react.useEffect)(function () {
	    var filteredData = allPackages.filter(function (pkg) {
	      return (!filters.gender || pkg.gender === String(filters.gender).charAt(0).toUpperCase() + String(filters.gender).slice(1)) && (!filters.department || pkg.department_id === filters.department);
	    });
	
	    setFilteredPackages(filteredData);
	    setPagination(function (prev) {
	      return Object.assign({}, prev, {
	        total: filteredData.length,
	        currentPage: 1 // Reset to the first page when filters change
	      });
	    });
	  }, [filters, allPackages]);
	
	  (0, _react.useEffect)(function () {
	    fetchPackages();
	  }, []);
	
	  var indexOfLastItem = pagination.currentPage * pagination.perPage;
	  var indexOfFirstItem = indexOfLastItem - pagination.perPage;
	  var currentItems = filteredPackages.slice(indexOfFirstItem, indexOfLastItem);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "section",
	      { className: "drop-gender" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-4 col-md-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "btn-group w-100" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "rounded-3 text-center",
	                  style: {
	                    backgroundColor: filters.gender ? "#ffffff" : "#0c807d",
	                    width: "100%",
	                    padding: "8px 10px",
	                    color: filters.gender ? "#333" : "#ffffff"
	                  },
	                  onClick: function onClick() {
	                    return handleFilterChange("gender", "");
	                  }
	                },
	                "All"
	              ),
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "text-center rounded-3",
	                  style: {
	                    backgroundColor: filters.gender === "male" ? "#0c807d" : "#ffffff",
	                    width: "100%",
	                    padding: "8px 10px",
	                    color: filters.gender === "male" ? "#ffffff" : "#333"
	                  },
	                  onClick: function onClick() {
	                    return handleFilterChange("gender", "male");
	                  }
	                },
	                "Male"
	              ),
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "text-center rounded-3",
	                  style: {
	                    backgroundColor: filters.gender === "female" ? "#0c807d" : "#ffffff",
	                    width: "100%",
	                    padding: "8px 10px",
	                    color: filters.gender === "female" ? "#ffffff" : "#333"
	                  },
	                  onClick: function onClick() {
	                    return handleFilterChange("gender", "female");
	                  }
	                },
	                "Female"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "our-recommendations mt-4" },
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-2" },
	            currentItems.length > 0 ? currentItems.map(function (pkg) {
	              return _react2.default.createElement(
	                "div",
	                { key: pkg.slug, className: "col-lg-4 col-md-12 mt-4" },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "/packages/" + pkg.slug,
	                    style: { textDecoration: "none" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card" },
	                    _react2.default.createElement("img", {
	                      className: "img-fluid",
	                      src: pkg.image ? _constants.IMAGE_URL + "/Packagesimg/" + pkg.image : _constants.IMAGE_URL + "/Packagesimg/202303221003packages Profile.png",
	                      style: {
	                        maxHeight: "177px",
	                        objectFit: "cover",
	                        objectPosition: pkg.image ? "center" : "top"
	                      },
	                      alt: "Package"
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "card-body" },
	                      _react2.default.createElement(
	                        "h5",
	                        { className: "text-capitalize" },
	                        pkg.name.split(" ").slice(0, 5).join(" "),
	                        "..."
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        "BDT ",
	                        pkg.opd_amount
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "px-2 py-1 mt-2 rounded w-50",
	                          style: { backgroundColor: "#0C807D" }
	                        },
	                        _react2.default.createElement(
	                          "a",
	                          {
	                            className: "d-flex justify-content-center",
	                            href: "/packages/" + pkg.slug,
	                            style: {
	                              width: "100%",
	                              color: "#ffffff",
	                              textDecoration: "none",
	                              textAlign: "center"
	                            }
	                          },
	                          _react2.default.createElement(
	                            "b",
	                            { className: "w-100" },
	                            "More Information"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              );
	            }) : _react2.default.createElement(
	              "div",
	              { className: "col-lg-12 col-md-12" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "No packages found"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_reactJsPagination2.default, {
	      className: "m-0",
	      activePage: pagination.currentPage,
	      itemsCountPerPage: pagination.perPage,
	      totalItemsCount: pagination.total,
	      pageRangeDisplayed: 5,
	      onChange: handlePageChange
	    })
	  );
	};
	
	exports.default = PackageTwo;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrivacyPolicy = function (_Component) {
	  _inherits(PrivacyPolicy, _Component);
	
	  function PrivacyPolicy() {
	    _classCallCheck(this, PrivacyPolicy);
	
	    return _possibleConstructorReturn(this, (PrivacyPolicy.__proto__ || Object.getPrototypeOf(PrivacyPolicy)).apply(this, arguments));
	  }
	
	  _createClass(PrivacyPolicy, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	          title: "Privacy-Policy | Best Hospital in Bangladesh | United Hospital",
	          description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	          pathSlug: "/",
	          keywords: "Privacy-Policy"
	        }),
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement("meta", {
	            name: "description",
	            content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	          }),
	          _react2.default.createElement(
	            "script",
	            { type: "application/ld+json" },
	            JSON.stringify({
	              "@context": "http://schema.org",
	              "@type": "LocalBusiness",
	              name: "United Hospital Limited",
	              image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	              telephone: "10666",
	              email: "info@uhlbd.com",
	              address: {
	                "@type": "PostalAddress",
	                streetAddress: "plot 15, Road 71, Gulshan",
	                addressLocality: "Dhaka",
	                addressRegion: "Dhaka",
	                addressCountry: "Bangladesh",
	                postalCode: "1212"
	              },
	              openingHoursSpecification: {
	                "@type": "OpeningHoursSpecification",
	                opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	              },
	              url: "http://www.uhlbd.com/",
	              aggregateRating: {
	                "@type": "AggregateRating",
	                ratingValue: "3.9",
	                bestRating: "5",
	                worstRating: "1",
	                ratingCount: "756"
	              },
	              review: {
	                "@type": "Review",
	                author: {
	                  "@type": "Person",
	                  name: "abdul kahar"
	                },
	                datePublished: "2019-02-12",
	                reviewRating: {
	                  "@type": "Rating",
	                  ratingValue: "3.9",
	                  bestRating: "5",
	                  worstRating: "1"
	                },
	                reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	              }
	            })
	          ),
	          _react2.default.createElement("meta", {
	            name: "Subject",
	            content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	          }),
	          _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	          _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	          _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	          _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	          _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	          _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	          _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	          _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	          _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	          _react2.default.createElement("meta", {
	            name: "classification",
	            content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	          }),
	          _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	          _react2.default.createElement("meta", {
	            names: "apple-mobile-web-app-status-bar-style",
	            content: "black-translucent"
	          }),
	          _react2.default.createElement("meta", {
	            name: "msvalidate.01",
	            content: "16C4E0B16E39354E550F64BD707F6A97"
	          })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          { id: "giveMarginService", className: "", style: { backgroundColor: "#fef3e9" } },
	          _react2.default.createElement(
	            "section",
	            { className: "termscondbody py-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "h2",
	                null,
	                " United Hospital Privacy Policy "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Your privacy is important to us and we have prepared this Privacy Policy to explain to you how we collect, use, and share information we obtain through your use of the Internet sites, applications and services ('services\") that are operated by, controlled by or are affiliate with Mobile Nations, including without limitation SB Nation, The Verge, Polygon, Curbed, Eater, Racked, and Vox.com (collectively, \"we,\" \"us\" or \"our\"). This Privacy Policy does not govern our use of any information you provide to us when you call us, write to us, or communicate with us in any manner other than through the Services. Because the Internet is global, information about you that we collect or that you submit may be transferred to, processed in, and held in countries (including the United States) other than the one in which you reside. By using the Services, you explicitly consent to such use of your information and agree to the terms of this Privacy Policy."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 1. Information We Automatically Collect. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We automatically collect certain information to help us understand how our users use the Services (which we will refer to in this Privacy Policy collectively as \"Usage Data\"). For example, each time you visit the Services we may automatically collect your IP address, browser and computer type, access time, the Web page you came from, the URL you go to next, and the Web page(s) that you access during your visit.We will use such Usage Data to diagnose problems with our servers and software, to administer the Services, and to gather demographic information. Our third-party advertising networks and servers will also provide us reports that will tell us how many ads were presented and clicked on the Services in a manner that does not identify personally any individual."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 2. Information You Choose To Submit. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "You can visit the Services without telling us who you are or revealing any information by which someone could personally identify you (which we will refer to in this Privacy Policy collectively as \"Personal Information\"). If, however, you wish to register to become a member of the Services, you are required to provide certain Personal Information (e.g., your name and e-mail address), and we ask that you also provide a user name and password. We use your Personal Information to fulfill your requests for products and services, to improve our Services, and to contact you from time to time about us, and our products and services. You may also choose to submit additional information about yourself (for example your gender, birth date, or zip code) by which someone could not personally identify you (which we will refer to in this Privacy Policy collectively as \"Non-Personal Information\"). We may also collect additional information about you when you visit certain features of the Services or the pages of certain of our partners when you interact with offers and advertisements, when you contact us for support, when you log into the Services with your account, when you complete a survey, or when you enter promotions. Finally, you may choose to submit your alias, bio, email, photos or any other information that you would like to share with other users of the Services (which we will refer to in this Privacy Policy collectively as 'shared Information\")."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 3. Our Information Sharing Practices. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "(a) Generally. Except as otherwise described in this section of our Privacy Policy, we will never share your Usage Data, Personal Information, Non-Personal Information, or Shared Information (which we will refer to in this Privacy Policy collectively as \"User Information\") with any third party without your permission. (b) Advertisers. From time to time, we may share your Usage Data and Non-Personal Information to enable third parties who serve advertisements on the Services to deliver advertisements that will be relevant to you. We will not share any such information, however, in a manner that would enable the advertiser to personally identify you. (c) Aggregated Data. From time to time, we may share aggregated User Information with third parties. We will not share any aggregated data, however, in manner that would enable the recipient to personally identify you. (d) Service Providers. From time to time, we may enter into relationships with third parties who provide services to us (e.g., data management and storage services or credit card processing services). In those circumstances, we disclose User Information that is necessary for such service providers to perform those services and require that they maintain the confidentiality of such User Information. (e) Other Disclosure Scenarios. Notwithstanding anything in this Privacy Policy to the contrary, we reserve the right, and you hereby expressly authorize us, to share any User Information: (1) in response to subpoenas, court orders, or legal process, or to establish, protect, or exercise our legal rights or defend against legal claims; (2) if we believe it is necessary in order to investigate, prevent, or take action regarding illegal activities, fraud, or situations involving potential threats to the safety of any person or property; (3) if we believe it is necessary to investigate, prevent, or take action regarding significant abuse of the Services\" infrastructure or the Internet in general (such as voluminous spamming, denial of service attacks, or attempts to compromise the security of information); (4) to our parent company, subsidiaries, joint ventures, or other companies under common control with us (in which case we will require such entities to honor this Privacy Policy); and (5) if we are acquired by or merged with another entity."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 4. Public Information. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "If you identify any User Information as public, you are authorizing us to share such information publicly. For example, you may elect to make certain Shared Information (such as your alias, bio, email or photos) publicly available. Also, there may be areas of the Services (e.g., message boards, discussion rooms, and other online forums) in which you are able to post information that will be available to all other users of the Services. By choosing to use these areas, you understand and agree that anyone may access, use, and disclose any information that you post to those areas."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 5. Cookies. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We may set and access cookies on your computer. Upon your first visit to the Services, a cookie is sent to your computer that uniquely identifies your browser. A \"cookie\" is a small file containing a string of characters that is sent to your computer and stored on your hard drive when you visit a website. Many major Web services use cookies to provide useful features for their users. Each web site can send its own cookie to your browser. Most browsers are initially set up to accept cookies. You can reset your browser to refuse all cookies or to indicate when a cookie is being sent; however if you reject cookies, you will not be able to sign in to the Services or take full advantage of our Services.We use cookies for the following general purposes: (a) to track your preferences, such as the address or local zip code you enter; (b) to access your information when you sign in so we can provide you with your personalized content; (c) to display the most appropriate advertisements, based on your interests and activity on our Services; and (d) to help us improve the Services by analyzing and estimating our traffic and use of features on the Services.We may also use \"pixel tags,\" which are small graphic files that allow us to monitor the use of the Services. A pixel tag can collect information such as the IP address of the computer that downloaded the page on which the tag appears; the URL of the page on which the pixel tag appears; the time (and length of time) the page containing the pixel tag was viewed; the type of browser that retrieved the pixel tag; and the identification number of any cookie previously placed by that server on your computer.We may use pixel tags, either provided by us or by our third party advertisers and ad networks, to collect information about your visit, including the pages you view, the links you click and other actions taken in connection with our sites and Services and use them in combination with our cookies to provide offers and information of interest to you.We also may allow certain analytic services and providers of applications used on the Services (e.g., sharing buttons) to collect Non-Personally Identifiable information by placing cookies on the Services that will track certain performance of our Services, such as, web traffic, click-throughs, etc., in order to assist us and our service providers in better understanding the interests of our users and to better serve those interests."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 6. Advertising. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We may use other companies under agreements with us to serve advertisements when you visit and use the Services. These companies may collect and use click stream information, browser type, time and date, subject of advertisements clicked or scrolled over during your visits to the Services and other Web sites in order to provide advertisements about goods and services likely to be of greater interest to you. These companies typically use a cookie, a third party web beacon and/or pixel tags to collect this information. None of them collect any personal information from your computer, such as your e-mail address. Other companies' use of their cookies is subject to their own privacy policies, not this one. Advertisers or other companies do not have access to our cookies."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 7. Targeted Advertising. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "In order to serve offers and advertisements that may be interest to our users, we may display targeted advertisements on the Services based on Personal Information provided by our users, including zip code and profile. We do not provide this Personal Information to our advertisers when you interact with such an advertisement. However, please note that the advertisers (including ad serving companies) may determine based on their own analysis that a user who interacts with an advertisement targeted by us may fit into a certain demographic category; for example, an advertiser may determine that men ages 25-34 are interacting with a certain advertisement on the Services from a particular geographic area."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " ",
	                "8. Your Options and Information about Advertisers and Targeted Ads.",
	                " "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "You can learn more about the advertising companies we work with and what options they may offer you regarding cookies and targeted advertising on our advertising addendum page. Many of these companies are also members of the Network Advertising Initiative or the Digital Advertising Alliance, which each provide a simple way to opt-out of ad targeting from participating companies."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 9. Mobile. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We may from time to time offer certain location or pinpoint based services with our applications (such as, GPS assisted navigation instruction, wireless tower location, triangulation or other available location technologies). If you elect to use such location based services, we must periodically receive your location in order to provide such location-based services to you. By using the applications\" location based services, you authorize us to: (a) locate your hardware; (b) record, compile and display your location; and (c) publish your location to third parties designated by you by means of location publication controls available within the applications (e.g., settings, user preferences). As part of the applications, we may also collect and store certain information about our users, such as, users' wireless mobile subscriber ISDN and/or IMEI numbers (as applicable) and users' network access identifier information. This information will be used to provide you the services accessed through our applications. We may use third party providers to help provide services through mobile systems and such providers may use the information in accordance with our Privacy Policy."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 10. Choice/Opt-Out. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We offer you the opportunity to choose not to receive communications from us. If you would like to take advantage of this opportunity, please let us know by accessing and updating your profile. Please note that sometimes these requests may take up to ten business days to process and that we are not responsible for removing information about you from the database of any third party to whom we were authorized to disclose your User Information prior to processing your request. Even if you do take advantage of this opportunity, we reserve the right to send you administrative messages relating to the Services (e.g., about changes to this Privacy Policy) and to contact you regarding any goods or services you have ordered."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 11. Modifying and Deleting Your Personal Information. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "If you would like to modify or delete from our database any User Information you previously submitted to us, please let us know by accessing and updating your profile. Please note that any User Information that we have copied may remain in back-up storage for some period of time after your request, and that if you delete certain information you may not be able to order services in the future without re-submitting such information. Also, please note that we will maintain User Information in our database whenever we are required to do so by law."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 12. Security. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We have implemented reasonable measures to help protect your User Information from loss, misuse, or unauthorized access or disclosure. Unfortunately, however, no data transmission over the Internet can be guaranteed to be 100% secure. As a result, while we strive to protect your User Information, we cannot guarantee its security."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 13. Links. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The Services may contain links to other websites. We are not responsible for the privacy practices of any such other website and urge you to review such practices prior to submitting any information to such websites."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 14. Children's Privacy. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We are committed to protecting the privacy needs of children and we encourage parents and guardians to take an active role in their children's online activities and interests. The Services are not intended for and may not be used by children under the age of 13. We do not knowingly collect information from children under the age of 13 and we do not target the Services to children under the age of 13."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                " 15. Changes. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We may update this Privacy Policy from time to time. If under any such update we make any material change to the way in which we treat your User Information, we will inform you of such change via email or by posting a notice on relevant areas of the Services. Any updated version of this Privacy Policy will be effective as of the date set forth therein."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return PrivacyPolicy;
	}(_react.Component);
	
	exports.default = PrivacyPolicy;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(64);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	__webpack_require__(43);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function extractEmailFromUrl(url) {
	  var searchParams = new URLSearchParams(url);
	  var email = searchParams.get("email");
	  return email;
	}
	var location = window.location.search;
	var url = location;
	var email = extractEmailFromUrl(url);
	
	var confirmResetPassw = function confirmResetPassw(url, data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request(url, {
	      method: "post",
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var resetnewpassword = function (_Component) {
	  _inherits(resetnewpassword, _Component);
	
	  function resetnewpassword(props) {
	    _classCallCheck(this, resetnewpassword);
	
	    var _this = _possibleConstructorReturn(this, (resetnewpassword.__proto__ || Object.getPrototypeOf(resetnewpassword)).call(this, props));
	
	    _this.state = {
	      newpassword: "",
	      confirmpassword: "",
	      email: email,
	      loading: false,
	      error: null,
	      success: false
	    };
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  // handleClick = () => {
	  //   this.props.history.push("/")
	  //   // Navigates to /new-url
	  // };
	
	
	  _createClass(resetnewpassword, [{
	    key: "handleInputChange",
	    value: function handleInputChange(event) {
	      var _Object$assign;
	
	      // this.setState({ newpassword: event.target.value });
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      this.setState(Object.assign({}, this.state, (_Object$assign = {}, _defineProperty(_Object$assign, name, value), _defineProperty(_Object$assign, "error", ""), _defineProperty(_Object$assign, "success", false), _Object$assign)));
	
	      // this.setState({ email: event.target.value });
	    }
	    // handleInputChanges(event) {
	
	    //     this.setState({ confirmpassword: event.target.value });
	    //     // this.setState({ email: event.target.value });
	    // }
	    // handlePasValid(event) {
	
	    //   if(this.state.newpassword===event){
	    //     this.setState({valid:false})
	    //   }
	
	    //     // this.setState({ email: event.target.value });
	    // }
	
	  }, {
	    key: "handleSubmit",
	    value: function handleSubmit(event) {
	      var _this2 = this;
	
	      event.preventDefault();
	      this.setState({ loading: true });
	      var _state = this.state,
	          newPassword = _state.newPassword,
	          confirmPassword = _state.confirmPassword;
	
	      if (newPassword != confirmPassword) {
	        _reactToastify.toast.error("Password doesn't match", {
	          position: _reactToastify.toast.POSITION.TOP_RIGHT
	        });
	        return false;
	      }
	
	      var data = {
	        confirmpassword: this.state.confirmpassword,
	        password: this.state.newpassword,
	        email: email
	      };
	      confirmResetPassw("resetpassword", data).then(function (response) {
	        _this2.setState({ loading: false });
	        if (response.status) {
	          _reactToastify.toast.success(response.message);
	        } else {
	          _reactToastify.toast.error(response.message);
	        }
	      }).catch(function (error) {
	        _this2.setState({ error: error, loading: false });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state2 = this.state,
	          newPassword = _state2.newPassword,
	          confirmPassword = _state2.confirmPassword,
	          error = _state2.error,
	          success = _state2.success;
	
	      // if (loading) {
	      //     return <div>Loading...</div>;
	      // }
	
	      // if (error) {
	      //     return <div>Error: {error.message}</div>;
	      // }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "borders" },
	        _react2.default.createElement(
	          "form",
	          { className: "form-content", onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            "h5",
	            { className: "text-center" },
	            "Reset Password"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "mb-3" },
	            _react2.default.createElement(
	              "label",
	              { "for": "exampleInputEmail1", className: "form-label" },
	              "New Password"
	            ),
	            _react2.default.createElement("input", {
	              type: "password",
	              className: "form-control",
	              name: "newpassword",
	              value: newPassword,
	              id: "exampleInputEmail1",
	              "aria-describedby": "emailHelp",
	              onChange: this.handleInputChange,
	              required: true
	            }),
	            _react2.default.createElement("div", { id: "emailHelp", className: "form-text" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "mb-3" },
	            _react2.default.createElement(
	              "label",
	              { "for": "exampleInputEmail1", className: "form-label" },
	              "Confirm Password"
	            ),
	            _react2.default.createElement("input", {
	              type: "password",
	              className: "form-control",
	              name: "confirmpassword",
	              value: confirmPassword,
	              id: "exampleInputEmail1",
	              "aria-describedby": "emailHelp",
	              onChange: this.handleInputChange,
	              required: true
	            }),
	            _react2.default.createElement("div", { id: "emailHelp", className: "form-text" })
	          ),
	          this.state.loading ? _react2.default.createElement(
	            "p",
	            null,
	            "Loading! Please wait..."
	          ) : null,
	          _react2.default.createElement(
	            "button",
	            { type: "submit", className: "butttons" },
	            "Reset Password"
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "/" },
	            "Back to home"
	          )
	        ),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return resetnewpassword;
	}(_react.Component);
	
	exports.default = resetnewpassword;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _new_ = __webpack_require__(452);
	
	var _new_2 = _interopRequireDefault(_new_);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _background_image = __webpack_require__(448);
	
	var _background_image2 = _interopRequireDefault(_background_image);
	
	var _fa = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
	  backgroundImage: "url(" + _background_image2.default + ") no-repeat",
	  position: "relative"
	};
	
	var getSingleNewsEvents = function getSingleNewsEvents(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("testimonials/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var SingleTestimonials = function (_Component) {
	  _inherits(SingleTestimonials, _Component);
	
	  function SingleTestimonials() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SingleTestimonials);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SingleTestimonials.__proto__ || Object.getPrototypeOf(SingleTestimonials)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      news_events_title: "",
	      news_events_pic: "",
	      news_events_desc: "",
	      author_name: "",
	      doctor_data: "",
	      rate: ""
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshgetSingleNewsEvents = function () {
	      var news_event_title_string = _this.props.match.params.name;
	      var new_news_event_title = news_event_title_string.replaceAll("-", " ");
	      getSingleNewsEvents(news_event_title_string).then(function (res) {
	        if (res.status === 200) {
	          var records = res.data;
	
	          _this.setState({
	            news_events_title: records.testimonial_title,
	            news_events_desc: records.testimonial_desc,
	            news_events_pic: records.author_profile_pic,
	            author_name: records.author_name,
	            doctor_data: records.doctor_mave,
	            rate: records.rating
	          });
	        } else {
	          _this.setState({
	            news_events_title: "",
	            news_events_desc: "",
	            news_events_pic: "",
	            author_name: "",
	            doctor_data: "",
	            rate: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.renderStars = function () {
	      var stars = [];
	      for (var i = 0; i < _this.state.rate; i++) {
	        stars.push(_react2.default.createElement(_fa.FaStar, { style: { color: "gold" }, key: i }));
	      }
	      return stars;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SingleTestimonials, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSingleNewsEvents();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	          title: this.state.news_events_title + " | United Hospital Bangladesh | Best Hospital In Bangladesh",
	          description: { __html: this.state.news_events_desc },
	          pathSlug: "/",
	          keywords: "newsevents, Singlenewsevents"
	        }),
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement("meta", {
	            name: "description",
	            content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	          }),
	          _react2.default.createElement(
	            "script",
	            { type: "application/ld+json" },
	            JSON.stringify({
	              "@context": "http://schema.org",
	              "@type": "LocalBusiness",
	              name: "United Hospital Limited",
	              image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	              telephone: "10666",
	              email: "info@uhlbd.com",
	              address: {
	                "@type": "PostalAddress",
	                streetAddress: "plot 15, Road 71, Gulshan",
	                addressLocality: "Dhaka",
	                addressRegion: "Dhaka",
	                addressCountry: "Bangladesh",
	                postalCode: "1212"
	              },
	              openingHoursSpecification: {
	                "@type": "OpeningHoursSpecification",
	                opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	              },
	              url: "http://www.uhlbd.com/",
	              aggregateRating: {
	                "@type": "AggregateRating",
	                ratingValue: "3.9",
	                bestRating: "5",
	                worstRating: "1",
	                ratingCount: "756"
	              },
	              review: {
	                "@type": "Review",
	                author: {
	                  "@type": "Person",
	                  name: "abdul kahar"
	                },
	                datePublished: "2019-02-12",
	                reviewRating: {
	                  "@type": "Rating",
	                  ratingValue: "3.9",
	                  bestRating: "5",
	                  worstRating: "1"
	                },
	                reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	              }
	            })
	          ),
	          _react2.default.createElement("meta", {
	            name: "Subject",
	            content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	          }),
	          _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	          _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	          _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	          _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	          _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	          _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	          _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	          _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	          _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	          _react2.default.createElement("meta", {
	            name: "classification",
	            content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	          }),
	          _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	          _react2.default.createElement("meta", {
	            names: "apple-mobile-web-app-status-bar-style",
	            content: "black-translucent"
	          }),
	          _react2.default.createElement("meta", {
	            name: "msvalidate.01",
	            content: "16C4E0B16E39354E550F64BD707F6A97"
	          })
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "",
	            id: "giveMargin",
	            style: { backgroundColor: "#fef3e9" }
	          },
	          _react2.default.createElement(
	            "section",
	            {
	              className: "top-section",
	              style: { backgroundColor: "#f58220" }
	            },
	            _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" })
	          ),
	          _react2.default.createElement(
	            "section",
	            { className: "prof-dr mt-2 section-gap py-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "box-of-about border-section mb-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row g-2 justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-lg-8 col-md-12 p-5",
	                      style: { backgroundColor: "#ffffff" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "text-profile" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "d-flex gap-5" },
	                        this.state.news_events_pic ? _react2.default.createElement("img", {
	                          className: "img-fluid img-thumbnail",
	                          src: _constants.IMAGE_URL + "AuthorProfileImg/" + this.state.news_events_pic,
	                          alt: "banner-profile"
	                        }) : _react2.default.createElement("img", {
	                          src: _new_2.default,
	                          alt: "banner-profile",
	                          className: "w-100"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "h3",
	                        {
	                          className: "text-center mb-4 text-center mt-3",
	                          style: {
	                            color: "#0C807D",
	                            fontWeight: "700",
	                            width: "100%"
	                          }
	                        },
	                        this.state.author_name
	                      ),
	                      _react2.default.createElement("p", {
	                        className: "text-chnage my-3",
	                        dangerouslySetInnerHTML: {
	                          __html: this.state.news_events_desc
	                        }
	                      })
	                    ),
	                    this.state.doctor_data ? _react2.default.createElement(
	                      "div",
	                      { className: "w-50 d-flex justify-content-start align-items-end gap-3" },
	                      _react2.default.createElement(
	                        "div",
	                        { style: { width: "150px", height: "150px" } },
	                        this.state.doctor_data.doctor_profile ? _react2.default.createElement("img", {
	                          className: "",
	                          src: this.state.doctor_data.doctor_profile ? _constants.IMAGE_URL + "DoctorProfileImg/" + this.state.doctor_data.doctor_profile : "news_events_1",
	                          style: {
	                            borderRadius: "5px",
	                            width: "100%",
	                            height: "100%",
	                            objectFit: "cover",
	                            objectPosition: "top"
	                          },
	                          alt: "news_events_1"
	                        }) : _react2.default.createElement("img", {
	                          src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                          alt: "doc",
	                          style: {
	                            borderRadius: "5px",
	                            width: "100%"
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "authorDetails d-flex flex-column align-items-start  m-0" },
	                        _react2.default.createElement(
	                          "h5",
	                          {
	                            style: {
	                              fontSize: "16px",
	                              color: "#222222"
	                            }
	                          },
	                          this.state.doctor_data.doctor_name
	                        ),
	                        _react2.default.createElement(
	                          "h6",
	                          {
	                            style: {
	                              fontSize: "14px",
	                              color: "#B5B5B6"
	                            }
	                          },
	                          this.state.doctor_data.degree
	                        ),
	                        _react2.default.createElement("h6", {
	                          style: {
	                            fontSize: "14px",
	                            color: "#B5B5B6"
	                          }
	                        })
	                      )
	                    ) : ""
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-lg-4 d-none d-md-block ",
	                      style: {
	                        border: "solid 1px #c5c5c5",
	                        backgroundColor: "#fff",
	                        borderRadius: "5px",
	                        width: "100%",
	                        maxWidth: "350px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "bookarea mt-3 d-none d-md-block mb-3 ",
	                        style: { position: "sticky", zIndex: "3333", top: 100 }
	                      },
	                      _react2.default.createElement("iframe", {
	                        width: "100%",
	                        height: "315",
	                        src: "https://www.youtube.com/embed/nTORUrJ7eN8?si=NAmLLBgAX3X8lFg4",
	                        title: "YouTube video player",
	                        frameborder: "0",
	                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted",
	                        allowfullscreen: true
	                      }),
	                      _react2.default.createElement(
	                        "h5",
	                        {
	                          className: "text-center p-2 text-light",
	                          style: {
	                            backgroundColor: "#FF5722",
	                            marginTop: "-6px"
	                          }
	                        },
	                        "Call Emergency Line",
	                        _react2.default.createElement("br", null),
	                        "10666"
	                      ),
	                      _react2.default.createElement("img", {
	                        src: "https://www.uhlbd.com/resources/images/contact.jpg",
	                        alt: ""
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return SingleTestimonials;
	}(_react.Component);
	
	exports.default = SingleTestimonials;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // For getting route params
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _constants = __webpack_require__(3);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _new_ = __webpack_require__(452);
	
	var _new_2 = _interopRequireDefault(_new_);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _background_image = __webpack_require__(448);
	
	var _background_image2 = _interopRequireDefault(_background_image);
	
	var _ = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  backgroundImage: "url(" + _background_image2.default + ") no-repeat",
	  position: "relative"
	};
	
	var getSingleNewsEvents = function getSingleNewsEvents(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/newsevents/getsinglenewsevents/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var SingleNewsEvents = function SingleNewsEvents() {
	  var _useParams = (0, _reactRouterDom.useParams)(),
	      name = _useParams.name; // Get the dynamic route parameter
	
	
	  var _useState = (0, _react.useState)({
	    news_events_title: "",
	    news_events_pic: "",
	    news_events_desc: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      newsEvents = _useState2[0],
	      setNewsEvents = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({}),
	      _useState4 = _slicedToArray(_useState3, 2),
	      videoLInk = _useState4[0],
	      setVideoLInk = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    var getAllBanner = function getAllBanner(data) {
	      try {
	        var req = _.scAxiosAdmin.request("/settings/30", {
	          method: "get"
	        }).then(function (data) {
	          if (data.status === 200) {
	            setVideoLInk(data.data.value);
	          }
	        }).catch(function (e) {
	          console.log("your log output", e);
	        });
	      } catch (error) {}
	    };
	    getAllBanner();
	  }, []);
	  var refreshgetSingleNewsEvents = function refreshgetSingleNewsEvents() {
	    var new_news_event_title = name.replaceAll("-", " ");
	    getSingleNewsEvents(name).then(function (res) {
	      if (res.status === true) {
	        var records = res.data;
	        setNewsEvents({
	          news_events_title: records.news_events_title,
	          news_events_desc: records.news_events_desc,
	          news_events_pic: records.news_events_pic
	        });
	      } else {
	        setNewsEvents({
	          news_events_title: "",
	          news_events_desc: "",
	          news_events_pic: ""
	        });
	      }
	    }).catch(function (err) {
	      console.log(err);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    refreshgetSingleNewsEvents();
	  }, [name]); // Run this whenever the `name` parameter changes
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: newsEvents.news_events_title + " | United Hospital Bangladesh | Best Hospital In Bangladesh",
	      description: { __html: newsEvents.news_events_desc },
	      pathSlug: "/",
	      keywords: "newsevents, Singlenewsevents"
	    }),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	      }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "http://schema.org",
	          "@type": "LocalBusiness",
	          name: "United Hospital Limited",
	          image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	          telephone: "10666",
	          email: "info@uhlbd.com",
	          address: {
	            "@type": "PostalAddress",
	            streetAddress: "plot 15, Road 71, Gulshan",
	            addressLocality: "Dhaka",
	            addressRegion: "Dhaka",
	            addressCountry: "Bangladesh",
	            postalCode: "1212"
	          },
	          openingHoursSpecification: {
	            "@type": "OpeningHoursSpecification",
	            opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	          },
	          url: "http://www.uhlbd.com/",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "3.9",
	            bestRating: "5",
	            worstRating: "1",
	            ratingCount: "756"
	          },
	          review: {
	            "@type": "Review",
	            author: {
	              "@type": "Person",
	              name: "abdul kahar"
	            },
	            datePublished: "2019-02-12",
	            reviewRating: {
	              "@type": "Rating",
	              ratingValue: "3.9",
	              bestRating: "5",
	              worstRating: "1"
	            },
	            reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(
	      "div",
	      { id: "giveMargin", style: { backgroundColor: "#fef3e9" } },
	      _react2.default.createElement(
	        "section",
	        { className: "top-section" },
	        _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" })
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "prof-dr" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "w-100 d-flex justify-content-center align-items-center flex-column py-4" },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  display: "flex",
	                  flexDirection: "column",
	                  marginBottom: "10px"
	                }
	              },
	              _react2.default.createElement(
	                "h3",
	                {
	                  className: "text-center",
	                  style: {
	                    color: "#0C807D",
	                    fontSize: "28px",
	                    fontWeight: "500"
	                  }
	                },
	                "NEWS and EVENTS"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "h3",
	            {
	              className: "text-center pb-4",
	              style: {
	                color: "#0C807D",
	                fontWeight: "700",
	                width: "100%"
	              }
	            },
	            newsEvents.news_events_title
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "box-of-about mt-3 pb-4" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "row justify-content-between",
	                style: { width: "98%", margin: "0 auto" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-lg-8 pt-3",
	                  style: {
	                    border: "solid 1px #c5c5c5",
	                    backgroundColor: "#fff",
	                    borderRadius: "5px"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "text-profile" },
	                  newsEvents.news_events_pic ? _react2.default.createElement("img", {
	                    className: "img-fluid img-thumbnail w-100",
	                    style: { objectFit: "cover" },
	                    src: _constants.IMAGE_URL + "NewsEventsImg/" + newsEvents.news_events_pic,
	                    alt: "banner-profile"
	                  }) : _react2.default.createElement("img", {
	                    src: _new_2.default,
	                    alt: "banner-profile",
	                    className: "w-100"
	                  }),
	                  _react2.default.createElement("p", {
	                    className: "text-chnage mt-3",
	                    dangerouslySetInnerHTML: {
	                      __html: newsEvents.news_events_desc
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-lg-4 d-none d-md-block",
	                  style: {
	                    border: "solid 1px #c5c5c5",
	                    backgroundColor: "#fff",
	                    borderRadius: "5px",
	                    width: "100%",
	                    maxWidth: "350px"
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "bookarea mt-3 d-none d-md-block mb-3",
	                    style: { position: "sticky", zIndex: "3333", top: 100 }
	                  },
	                  _react2.default.createElement("iframe", {
	                    width: "100%",
	                    height: "315",
	                    src: videoLInk,
	                    title: "YouTube video player",
	                    frameborder: "0",
	                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted",
	                    allowfullscreen: true
	                  }),
	                  _react2.default.createElement(
	                    "h5",
	                    {
	                      className: "text-center p-2 text-light",
	                      style: {
	                        backgroundColor: "#0C807D",
	                        marginTop: "-6px"
	                      }
	                    },
	                    "Call Emergency Line",
	                    _react2.default.createElement("br", null),
	                    "10666"
	                  ),
	                  _react2.default.createElement("img", {
	                    src: "https://www.uhlbd.com/resources/images/contact.jpg",
	                    alt: ""
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = SingleNewsEvents;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSinglePackage = function getSinglePackage(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/packages/getsinglepackagedata/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getVideo = function getVideo() {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/settings/30", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var SinglePackage = function (_Component) {
	  _inherits(SinglePackage, _Component);
	
	  function SinglePackage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SinglePackage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SinglePackage.__proto__ || Object.getPrototypeOf(SinglePackage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      package_name: "",
	      package_age: "",
	      package_gender: "",
	      package_pre_condition: "",
	      package_department: "",
	      package_pic: "",
	      package_desc: "",
	      package_banner_image: "",
	      dynamic_video: ""
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshgetSinglePackage = function () {
	      var package_name_string = _this.props.match.params.name;
	      var new_package_name = package_name_string.replaceAll("-", " ");
	      getSinglePackage(package_name_string).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	
	          _this.setState({
	            package_name: records.name,
	            package_age: records.age,
	            package_gender: records.gender,
	            package_type: records.package_type,
	            package_nature: records.package_nature,
	            ipd_amount: records.ipd_amount,
	            opd_amount: records.opd_amount,
	            package_pre_condition: records.pre_existing_conditon_id,
	            package_department: records.department_name,
	            package_desc: records.description,
	            package_pic: records.image,
	            package_banner_image: records.banner_image
	          });
	        } else {
	          _this.setState({
	            package_name: "",
	            package_age: "",
	            package_gender: "",
	            package_pre_condition: "",
	            package_department: "",
	            package_desc: "",
	            package_pic: "",
	            package_banner_image: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _this.refreshgetVideo = function () {
	      getVideo().then(function (res) {
	        if (res) {
	          var records = res;
	          _this.setState({
	            dynamic_video: records.value
	          });
	        } else {
	          _this.setState({
	            dynamic_video: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SinglePackage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSinglePackage();
	      this.refreshgetVideo();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	          title: this.state.package_name + " | Best Hospital in Bangladesh | United Hospital",
	          description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	          pathSlug: "/",
	          keywords: "Department, departments, Cardiac Surgery, Single department"
	        }),
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement("meta", {
	            name: "description",
	            content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	          }),
	          _react2.default.createElement(
	            "script",
	            { type: "application/ld+json" },
	            JSON.stringify({
	              "@context": "http://schema.org",
	              "@type": "LocalBusiness",
	              name: "United Hospital Limited",
	              image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	              telephone: "10666",
	              email: "info@uhlbd.com",
	              address: {
	                "@type": "PostalAddress",
	                streetAddress: "plot 15, Road 71, Gulshan",
	                addressLocality: "Dhaka",
	                addressRegion: "Dhaka",
	                addressCountry: "Bangladesh",
	                postalCode: "1212"
	              },
	              openingHoursSpecification: {
	                "@type": "OpeningHoursSpecification",
	                opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	              },
	              url: "http://www.uhlbd.com/",
	              aggregateRating: {
	                "@type": "AggregateRating",
	                ratingValue: "3.9",
	                bestRating: "5",
	                worstRating: "1",
	                ratingCount: "756"
	              },
	              review: {
	                "@type": "Review",
	                author: {
	                  "@type": "Person",
	                  name: "abdul kahar"
	                },
	                datePublished: "2019-02-12",
	                reviewRating: {
	                  "@type": "Rating",
	                  ratingValue: "3.9",
	                  bestRating: "5",
	                  worstRating: "1"
	                },
	                reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	              }
	            })
	          ),
	          _react2.default.createElement("meta", {
	            name: "Subject",
	            content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	          }),
	          _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	          _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	          _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	          _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	          _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	          _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	          _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	          _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	          _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	          _react2.default.createElement("meta", {
	            name: "classification",
	            content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	          }),
	          _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	          _react2.default.createElement("meta", {
	            names: "apple-mobile-web-app-status-bar-style",
	            content: "black-translucent"
	          }),
	          _react2.default.createElement("meta", {
	            name: "msvalidate.01",
	            content: "16C4E0B16E39354E550F64BD707F6A97"
	          })
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "",
	            id: "giveMargin",
	            style: { backgroundColor: "#fef3e9" }
	          },
	          _react2.default.createElement(
	            "section",
	            {
	              className: "top-section"
	              // style={{ backgroundColor: "rgb(245, 130, 32)" }}
	            },
	            _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" })
	          ),
	          _react2.default.createElement(
	            "section",
	            { className: "prof-dr" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "w-100 d-flex justify-content-center align-items-center flex-column py-4" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "flex",
	                      justifyContent: "flex-start",
	                      alignItems: "flex-start",
	                      flexDirection: "column",
	                      // margin: "0 auto",
	                      marginBottom: "10px"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "h3",
	                    {
	                      className: "text-center",
	                      style: {
	                        color: "#0C807D",
	                        fontSize: "28px",
	                        fontWeight: "500"
	                      }
	                    },
	                    "Packages"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "box-of-about pb-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-lg-8 col-md-8 mx-2 py-4",
	                      style: {
	                        backgroundColor: "#fff",
	                        borderRadius: "5px"
	                        // width: "100%",
	                        // maxWidth: "600px",
	                      }
	                    },
	                    this.state.package_pic ? _react2.default.createElement("img", {
	                      src: _constants.IMAGE_URL + "Packagesimg/" + this.state.package_pic,
	                      style: {
	                        maxHeight: "300px",
	                        objectFit: "cover",
	                        objectPosition: "center",
	                        borderRadius: "10px"
	                      },
	                      alt: "banner-profile",
	                      className: "w-100 img-fluid"
	                    }) : _react2.default.createElement("img", {
	                      src: _bannerProfile2.default,
	                      alt: "banner-profile",
	                      className: "w-100 img-fluid"
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "text-profile single_package_details_section p-3" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row mb-4 gy-2" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-2 col-md-4" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Age:"
	                          ),
	                          " ",
	                          this.state.package_age
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-2 col-md-4" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Gender:"
	                          ),
	                          " ",
	                          this.state.package_gender
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-4 col-md-4" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Department:"
	                          ),
	                          " ",
	                          this.state.package_department
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-3 col-md-4" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Pre Condition:"
	                          ),
	                          " ",
	                          this.state.package_pre_condition === "1" ? "IPD" : "OPD"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-3 col-md-4" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "IPD Amount:"
	                          ),
	                          " ",
	                          this.state.ipd_amount
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-3 col-md-4" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "OPD Amount:"
	                          ),
	                          " ",
	                          this.state.opd_amount
	                        )
	                      ),
	                      _react2.default.createElement("hr", { className: "w-75" }),
	                      _react2.default.createElement(
	                        "h2",
	                        null,
	                        this.state.package_name
	                      ),
	                      _react2.default.createElement("p", {
	                        className: "text-chnage",
	                        dangerouslySetInnerHTML: {
	                          __html: this.state.package_desc
	                        }
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-lg-4 col-md-12 d-none d-md-block pt-2",
	                      style: {
	                        backgroundColor: "#fff",
	                        borderRadius: "5px",
	                        width: "100%",
	                        maxWidth: "360px"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "bookarea mt-3 d-none d-md-block mb-3",
	                        style: { position: "sticky", zIndex: "3333", top: 100 }
	                      },
	                      _react2.default.createElement("iframe", {
	                        width: "100%",
	                        height: "315",
	                        src: this.state.dynamic_video,
	                        title: "YouTube video player",
	                        frameborder: "0",
	                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted",
	                        allowfullscreen: true
	                      }),
	                      _react2.default.createElement(
	                        "h5",
	                        {
	                          className: "text-center p-2 text-light",
	                          style: {
	                            backgroundColor: "#0C807D",
	                            marginTop: "-6px"
	                          }
	                        },
	                        "Call Emergency Line",
	                        _react2.default.createElement("br", null),
	                        "10666"
	                      ),
	                      _react2.default.createElement("img", {
	                        src: "https://www.uhlbd.com/resources/images/contact.jpg",
	                        alt: ""
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return SinglePackage;
	}(_react.Component);
	
	exports.default = SinglePackage;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSinglePublication = function getSinglePublication(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/publications/getsinglepublications/" + id, {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var SinglePublication = function (_Component) {
	  _inherits(SinglePublication, _Component);
	
	  function SinglePublication() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SinglePublication);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SinglePublication.__proto__ || Object.getPrototypeOf(SinglePublication)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      publication_title: "",
	      publication_pic: "",
	      publication_desc: "",
	      pdf_url: ""
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshgetSinglePublication = function () {
	      var publication_title_string = _this.props.match.params.name;
	      //let new_publication_title = publication_title_string.replaceAll('-', ' ');
	      var publication_id = publication_title_string.split("~").pop();
	      getSinglePublication(publication_id).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          var fullComponent = res.data.publications_desc;
	          var pattern = /href="([^"]+)"/;
	          var pdfUrl = fullComponent.match(pattern);
	          if (pdfUrl && pdfUrl.length > 1) {
	            var url = pdfUrl[1];
	            _this.setState({ pdf_url: url });
	          } else {
	            console.log("URL not found in the input string.");
	          }
	          _this.setState({
	            publication_title: records.publications_title,
	            publication_desc: records.publications_desc,
	            publication_pic: records.publications_pic
	          });
	        } else {
	          _this.setState({
	            publication_title: "",
	            publication_desc: "",
	            publication_pic: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SinglePublication, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetSinglePublication();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	          title: this.state.publication_title + " | Best Hospital in Bangladesh | United Hospital",
	          description: { __html: this.state.publication_desc },
	          pathSlug: "/",
	          keywords: "publication, SinglePublication"
	        }),
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement("meta", {
	            name: "description",
	            content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	          }),
	          _react2.default.createElement(
	            "script",
	            { type: "application/ld+json" },
	            JSON.stringify({
	              "@context": "http://schema.org",
	              "@type": "LocalBusiness",
	              name: "United Hospital Limited",
	              image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	              telephone: "10666",
	              email: "info@uhlbd.com",
	              address: {
	                "@type": "PostalAddress",
	                streetAddress: "plot 15, Road 71, Gulshan",
	                addressLocality: "Dhaka",
	                addressRegion: "Dhaka",
	                addressCountry: "Bangladesh",
	                postalCode: "1212"
	              },
	              openingHoursSpecification: {
	                "@type": "OpeningHoursSpecification",
	                opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	              },
	              url: "http://www.uhlbd.com/",
	              aggregateRating: {
	                "@type": "AggregateRating",
	                ratingValue: "3.9",
	                bestRating: "5",
	                worstRating: "1",
	                ratingCount: "756"
	              },
	              review: {
	                "@type": "Review",
	                author: {
	                  "@type": "Person",
	                  name: "abdul kahar"
	                },
	                datePublished: "2019-02-12",
	                reviewRating: {
	                  "@type": "Rating",
	                  ratingValue: "3.9",
	                  bestRating: "5",
	                  worstRating: "1"
	                },
	                reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	              }
	            })
	          ),
	          _react2.default.createElement("meta", {
	            name: "Subject",
	            content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	          }),
	          _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	          _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	          _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	          _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	          _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	          _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	          _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	          _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	          _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	          _react2.default.createElement("meta", {
	            name: "classification",
	            content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	          }),
	          _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	          _react2.default.createElement("meta", {
	            names: "apple-mobile-web-app-status-bar-style",
	            content: "black-translucent"
	          }),
	          _react2.default.createElement("meta", {
	            name: "msvalidate.01",
	            content: "16C4E0B16E39354E550F64BD707F6A97"
	          })
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          {
	            id: "giveMargin",
	            className: "",
	            style: { backgroundColor: "#fef3e9" }
	          },
	          _react2.default.createElement(
	            "section",
	            { className: "banner-hero" },
	            this.state.publication_pic ? _react2.default.createElement("img", {
	              src: _constants.IMAGE_URL + "PublicationsImg/" + this.state.publication_pic,
	              alt: "banner-profile",
	              className: "w-100",
	              style: { "max-height": "450px", objectFit: "cover" }
	            }) : _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" })
	          ),
	          _react2.default.createElement(
	            "section",
	            { className: "prof-dr" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "box-of-about mt-4 pb-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-12 col-md-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "text-profile" },
	                      _react2.default.createElement(
	                        "h2",
	                        null,
	                        this.state.publication_title
	                      ),
	                      _react2.default.createElement("p", {
	                        className: "text-chnage",
	                        dangerouslySetInnerHTML: {
	                          __html: this.state.publication_desc
	                        }
	                      }),
	                      this.state.pdf_url ? _react2.default.createElement(
	                        "div",
	                        { style: { position: "relative" } },
	                        _react2.default.createElement("iframe", {
	                          src: "https://docs.google.com/viewer?url=" + encodeURIComponent(this.state.pdf_url) + "&embedded=true",
	                          width: "100%",
	                          height: "800px",
	                          title: "PDF Viewer",
	                          sandbox: "allow-same-origin allow-scripts",
	                          style: { border: "1px solid black" }
	                        }),
	                        _react2.default.createElement("a", {
	                          className: "fa-solid fa-download",
	                          style: {
	                            position: "absolute",
	                            top: 20,
	                            right: 80,
	                            fontSize: "30px"
	                          },
	                          href: this.state.pdf_url,
	                          download: true
	                        })
	                      ) : _react2.default.createElement(
	                        "div",
	                        { className: "d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "spinner-border text-primary",
	                            role: "status"
	                          },
	                          _react2.default.createElement(
	                            "span",
	                            { className: "visually-hidden" },
	                            "Loading..."
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return SinglePublication;
	}(_react.Component);
	
	exports.default = SinglePublication;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSingleStaticPages = function getSingleStaticPages(id) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request('/staticpages/getsinglestaticpageslugdata/' + id, {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json',
	        'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var StaticPages = function (_Component) {
	  _inherits(StaticPages, _Component);
	
	  function StaticPages() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticPages);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StaticPages.__proto__ || Object.getPrototypeOf(StaticPages)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      static_page_title: '',
	      static_page_pic: '',
	      static_page_desc: ''
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshGetSingleStaticPages = function () {
	      var static_page_title_string = _this.props.match.params.slug;
	      //let new_news_event_title = news_event_title_string.replaceAll('-', ' ');
	      getSingleStaticPages(static_page_title_string).then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({
	            static_page_title: records.title,
	            static_page_desc: records.description,
	            static_page_pic: records.image
	          });
	        } else {
	          _this.setState({
	            static_page_title: '',
	            static_page_desc: '',
	            static_page_pic: ''
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StaticPages, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refreshGetSingleStaticPages();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          'section',
	          { className: 'banner-hero' },
	          this.state.static_page_pic ? _react2.default.createElement('img', { src: _constants.IMAGE_URL + 'StaticPages/' + this.state.static_page_pic, alt: 'banner-profile', className: 'w-100', style: { "max-height": "375px" } }) : _react2.default.createElement('img', { src: _bannerProfile2.default, alt: 'banner-profile', className: 'w-100' })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'prof-dr' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'box-of-about mt-4 mb-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-12 col-md-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-profile' },
	                    _react2.default.createElement(
	                      'h2',
	                      null,
	                      this.state.static_page_title
	                    ),
	                    _react2.default.createElement('p', { className: 'text-chnage', dangerouslySetInnerHTML: { __html: this.state.static_page_desc } })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return StaticPages;
	}(_react.Component);
	
	exports.default = StaticPages;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _Seo = __webpack_require__(13);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TermsCondition = function (_Component) {
	  _inherits(TermsCondition, _Component);
	
	  function TermsCondition() {
	    _classCallCheck(this, TermsCondition);
	
	    return _possibleConstructorReturn(this, (TermsCondition.__proto__ || Object.getPrototypeOf(TermsCondition)).apply(this, arguments));
	  }
	
	  _createClass(TermsCondition, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_Seo2.default, {
	          title: "Terms and Conditions | Best Hospital in Bangladesh | United Hospital",
	          description: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh.",
	          pathSlug: "/",
	          keywords: "Terms and Conditions"
	        }),
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement("meta", {
	            name: "description",
	            content: "United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
	          }),
	          _react2.default.createElement(
	            "script",
	            { type: "application/ld+json" },
	            JSON.stringify({
	              "@context": "http://schema.org",
	              "@type": "LocalBusiness",
	              name: "United Hospital Limited",
	              image: "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
	              telephone: "10666",
	              email: "info@uhlbd.com",
	              address: {
	                "@type": "PostalAddress",
	                streetAddress: "plot 15, Road 71, Gulshan",
	                addressLocality: "Dhaka",
	                addressRegion: "Dhaka",
	                addressCountry: "Bangladesh",
	                postalCode: "1212"
	              },
	              openingHoursSpecification: {
	                "@type": "OpeningHoursSpecification",
	                opens: "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30"
	              },
	              url: "http://www.uhlbd.com/",
	              aggregateRating: {
	                "@type": "AggregateRating",
	                ratingValue: "3.9",
	                bestRating: "5",
	                worstRating: "1",
	                ratingCount: "756"
	              },
	              review: {
	                "@type": "Review",
	                author: {
	                  "@type": "Person",
	                  name: "abdul kahar"
	                },
	                datePublished: "2019-02-12",
	                reviewRating: {
	                  "@type": "Rating",
	                  ratingValue: "3.9",
	                  bestRating: "5",
	                  worstRating: "1"
	                },
	                reviewBody: "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)"
	              }
	            })
	          ),
	          _react2.default.createElement("meta", {
	            name: "Subject",
	            content: "Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
	          }),
	          _react2.default.createElement("meta", { name: "Abstract", content: "one-stop healthcare in Bangladesh" }),
	          _react2.default.createElement("meta", { name: "Googlebot", content: "all" }),
	          _react2.default.createElement("meta", { "http-equiv": "imagetoolbar", content: "no" }),
	          _react2.default.createElement("meta", { name: "robots", content: "index, follow" }),
	          _react2.default.createElement("meta", { name: "copyright", content: "Copyright \xA9 uhlbd.com" }),
	          _react2.default.createElement("meta", { name: "owner", content: "United Hospital" }),
	          _react2.default.createElement("meta", { name: "author", content: "dcastalia.com" }),
	          _react2.default.createElement("meta", { name: "Rating", content: "General" }),
	          _react2.default.createElement("meta", { name: "distribution", content: "Global" }),
	          _react2.default.createElement("meta", {
	            name: "classification",
	            content: "Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
	          }),
	          _react2.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
	          _react2.default.createElement("meta", {
	            names: "apple-mobile-web-app-status-bar-style",
	            content: "black-translucent"
	          }),
	          _react2.default.createElement("meta", {
	            name: "msvalidate.01",
	            content: "16C4E0B16E39354E550F64BD707F6A97"
	          })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          { id: "giveMarginService", className: "", style: { backgroundColor: "#fef3e9" } },
	          _react2.default.createElement(
	            "div",
	            { className: "termscondbody py-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "container terms-and-conditions" },
	              _react2.default.createElement(
	                "h1",
	                null,
	                "Terms and Conditions"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "These terms and conditions outline the rules and regulations for the use of our company."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "By accessing this website we assume you accept these terms and conditions. Do not continue to use our website if you do not agree to take all of the terms and conditions stated on this page."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: \u201CClient\u201D, \u201CYou\u201D and \u201CYour\u201D refers to you, the person log on this website and compliant to the Company's terms and conditions. \u201CThe Company\u201D, \u201COurselves\u201D, \u201CWe\u201D, \u201COur\u201D and \u201CUs\u201D, refers to our Company. \u201CParty\u201D, \u201CParties\u201D, or \u201CUs\u201D, refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client's needs in respect of provision of the Company's stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Cookies"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We employ the use of cookies. By accessing our website, you agreed to use cookies in agreement with our company's Privacy Policy."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                "License"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Unless otherwise stated, LOPYI and its licensors own the intellectual property rights for all material on our website. All intellectual property rights are reserved. You may access this from our website for your own personal use subjected to restrictions set in these terms and conditions."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "You must not:"
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Republish material from our website"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Sell, rent or sub-license material from our website"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Reproduce, duplicate or copy material from our website"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Redistribute content from our website"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "This Agreement shall begin on the date hereof."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. LOPYI does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of LOPYI,its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, LOPYI shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "LOPYI reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "You warrant and represent that:"
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity."
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "You hereby grant LOPYI a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media."
	              ),
	              _react2.default.createElement(
	                "h2",
	                null,
	                "Hyperlinking to our Content"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The following organizations may link to our website without prior written approval:"
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Government agencies;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Search engines;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "News organizations;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Online directory distributors may link to our website in the same manner as they hyperlink to the websites of other listed businesses; and"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site."
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "These organizations may link to our home page, to publications or to other website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party's site."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We may consider and approve other link requests from the following types of organizations:"
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "commonly-known consumer and/or business information sources;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "dot.com community sites;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "associations or other groups representing charities;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "online directory distributors;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "internet portals;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "accounting, law and consulting firms; and"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "ducational institutions and trade associations."
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the benefit to us from the visibility of the hyperlink compensates the absence of LOPYI; and (d) the link is in the context of general resource information."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party's site."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to our company. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Approved organizations may hyperlink to our website as follows:"
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "By use of our corporate name; or"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "By use of the uniform resource locator being linked to; or"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "By use of any other description of our website being linked to that makes sense within the context and format of content on the linking party's site."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "No use of our company's logo or other artwork will be allowed for linking absent a trademark license agreement."
	                )
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                "iFrames"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our website."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Content Liability"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We shall not be hold responsible for any content that appears on your website. You agree to protect and defend us against all claims that is rising on your website. No link(s) should appear on any website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Reservation of Rights"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We reserve the right to request that you remove all links or any particular link to our website. You approve to immediately remove all links to our website upon request. We also reserve the right to amen these terms and conditions and it's linking policy at any time. By continuously linking to our website, you agree to be bound to and follow these linking terms and conditions."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Removal of links from our website"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "If you find any link on our website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date."
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Disclaimer"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:"
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "limit or exclude our or your liability for death or personal injury;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "limit or exclude our or your liability for fraud or fraudulent misrepresentation;"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "limit any of our or your liabilities in any way that is not permitted under applicable law; or"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "exclude any of our or your liabilities that may not be excluded under applicable law."
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty."
	              ),
	              _react2.default.createElement(
	                "p",
	                { id: "last" },
	                "As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature."
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "container term-buttons-container" },
	              _react2.default.createElement(
	                "form",
	                { method: "POST", name: "terms-and-conditions-form", action: "#" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "submit",
	                    className: "accept-button",
	                    "aria-hidden": "true",
	                    "aria-label": "Accept terms and conditions"
	                  },
	                  "Accept"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return TermsCondition;
	}(_react.Component);
	
	exports.default = TermsCondition;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bannerProfile = __webpack_require__(32);
	
	var _bannerProfile2 = _interopRequireDefault(_bannerProfile);
	
	var _reactJsPagination = __webpack_require__(37);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getAllTestimonialData = function getAllTestimonialData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/gettestimonials", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var Testimonials = function (_Component) {
	  _inherits(Testimonials, _Component);
	
	  function Testimonials() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Testimonials);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Testimonials.__proto__ || Object.getPrototypeOf(Testimonials)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      testimonials: [],
	      total: "",
	      currentPage: "",
	      LastPage: "",
	      PerPage: "",
	      FirstPageUrl: "",
	      NextPageUrl: "",
	      PrevPageUrl: "",
	      LastPageUrl: "",
	      TotalPages: "",
	      activePage: 1,
	      doctor_id: ""
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshgetAllTestimonials = function (page) {
	      var data = {
	        page: page
	      };
	      getAllTestimonialData(data).then(function (res) {
	
	        if (res.status === 200) {
	          var records = res.data.data.data;
	          _this.setState({ testimonials: records });
	          _this.setState({ total: res.data.data.total });
	          _this.setState({ currentPage: res.data.data.current_page });
	          _this.setState({ PerPage: res.data.data.per_page });
	          _this.setState({ FirstPageUrl: res.data.data.first_page_url });
	          _this.setState({ NextPageUrl: res.data.data.next_page_url });
	          _this.setState({ PrevPageUrl: res.data.data.prev_page_url });
	          _this.setState({ LastPageUrl: res.data.data.last_page_url });
	          _this.setState({ LastPage: res.data.data.last_page });
	          _this.setState({
	            TotalPages: Math.ceil(_this.state.total / _this.state.PerPage)
	          });
	        } else {
	          _this.setState({
	            testimonials: ""
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Testimonials, [{
	    key: "handlePageChange",
	    value: function handlePageChange(pageNumber) {
	      this.setState({ activePage: pageNumber });
	      this.refreshgetAllTestimonials(pageNumber);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshgetAllTestimonials();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var pageNumbers = [];
	      for (var i = 1; i <= this.state.TotalPages; i++) {
	        pageNumbers.push(i);
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "",
	            id: "giveMargin",
	            style: { backgroundColor: "#fef3e9" }
	          },
	          _react2.default.createElement(
	            "section",
	            { className: "banner-hero" },
	            _react2.default.createElement("img", { src: _bannerProfile2.default, alt: "banner-profile", className: "w-100" })
	          ),
	          _react2.default.createElement(
	            "section",
	            { className: "prof-dr" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "box-of-about mt-4 pb-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  this.state.testimonials.length > 0 ? this.state.testimonials.map(function (testimonial) {
	                    return _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-4 col-md-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "text-profile testimonial_block_sec" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-3" },
	                            testimonial.doctor_profile ? _react2.default.createElement("img", {
	                              src: _constants.IMAGE_URL + "/DoctorProfileImg/" + testimonial.doctor_profile,
	                              alt: "doc",
	                              style: {
	                                width: "50px",
	                                "border-radius": "110px"
	                              }
	                            }) : _react2.default.createElement("img", {
	                              src: "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg",
	                              alt: "doc",
	                              style: { "border-radius": "110px" }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-sm-9" },
	                            _react2.default.createElement(
	                              "p",
	                              {
	                                style: {
	                                  fontSize: "20px",
	                                  marginBottom: "0px"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "b",
	                                null,
	                                testimonial.testimonial_name
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              { style: { fontSize: "14px" } },
	                              _react2.default.createElement(
	                                "b",
	                                null,
	                                testimonial.author_name
	                              )
	                            ),
	                            _react2.default.createElement("p", {
	                              style: { fontSize: "12px" },
	                              className: "testimonial_desc_string text-chnage",
	                              dangerouslySetInnerHTML: {
	                                __html: testimonial.testimonial_desc ? testimonial.testimonial_desc.substr(0, 140) + "..." : ""
	                              }
	                            })
	                          )
	                        )
	                      )
	                    );
	                  }) : ""
	                ),
	                pageNumbers.length > 1 ? _react2.default.createElement(_reactJsPagination2.default, {
	                  activePage: this.state.activePage,
	                  totalItemsCount: this.state.total,
	                  pageRangeDisplayed: 5,
	                  onChange: this.handlePageChange.bind(this)
	                }) : ""
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return Testimonials;
	}(_react.Component);
	
	exports.default = Testimonials;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _HomeHeader = __webpack_require__(112);
	
	var _HomeHeader2 = _interopRequireDefault(_HomeHeader);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _HomeSearch = __webpack_require__(86);
	
	var _HomeSearch2 = _interopRequireDefault(_HomeSearch);
	
	var _CenterExcellence = __webpack_require__(85);
	
	var _CenterExcellence2 = _interopRequireDefault(_CenterExcellence);
	
	var _NewsEventsSilde = __webpack_require__(71);
	
	var _NewsEventsSilde2 = _interopRequireDefault(_NewsEventsSilde);
	
	var _PublicationsSilde = __webpack_require__(72);
	
	var _PublicationsSilde2 = _interopRequireDefault(_PublicationsSilde);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPaymentDetails = function getPaymentDetails(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request('/payment/getpaymentdetails', {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json',
	        'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var Cancel = function (_Component) {
	  _inherits(Cancel, _Component);
	
	  function Cancel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Cancel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Cancel.__proto__ || Object.getPrototypeOf(Cancel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transaction_id: '',
	      appointment_id: '',
	      appointment_date: '',
	      appointment_time: '',
	      patient_name: '',
	      doctor_name: '',
	      doctor_fees: '',
	      total_amount: '',
	      payment_status: '',
	      currency: '',
	      payment_message: ''
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshGetpaymentData = function (data) {
	      getPaymentDetails(data).then(function (res) {
	        if (res) {
	          var records = res.data;
	          _this.setState({
	            transaction_id: records.transaction_id,
	            appointment_id: records.appointment_id,
	            appointment_date: records.appointment_date,
	            appointment_time: records.appointment_time,
	            patient_name: records.patient_name,
	            doctor_name: records.doctor_name,
	            doctor_fees: records.doctor_fees,
	            total_amount: records.amount,
	            payment_status: records.status,
	            currency: records.currency
	          });
	        } else {
	          _this.setState({
	            transaction_id: '',
	            appointment_id: '',
	            appointment_date: '',
	            appointment_time: '',
	            patient_name: '',
	            doctor_name: '',
	            doctor_fees: '',
	            total_amount: '',
	            payment_status: '',
	            currency: ''
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Cancel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var query = new URLSearchParams(this.props.location.search);
	      var status = query.get('status');
	      var trans_id = query.get('trans_id');
	      if (status === 'transaction_cancel') {
	        this.setState({ payment_message: 'Payment Transaction Canceled!' });
	      } else if (status === 'already_success') {
	        this.setState({ payment_message: 'Payment Transaction already success!' });
	      } else {
	        this.setState({ payment_message: 'Payment Transaction Invalid!' });
	      }
	      var data = {
	        transaction_id: trans_id
	      };
	      this.refreshGetpaymentData(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'section',
	          { className: 'banner-part' },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _HomeHeader2.default }),
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'offcanvas offcanvas-start show', tabIndex: -1, id: 'offcanvasExample', 'aria-labelledby': 'offcanvasExampleLabel' },
	              _react2.default.createElement(
	                'div',
	                { className: 'offcanvas-header' },
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'offcanvas-title', id: 'offcanvasExampleLabel' },
	                  ' '
	                ),
	                _react2.default.createElement('button', { type: 'button', className: 'btn-close text-reset', 'data-bs-dismiss': 'offcanvas', 'aria-label': 'Close' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'offcanvas-body' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row text-center', id: 'logos' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2 ' },
	                    _react2.default.createElement('img', { src: _uhlcareLogo2.default, alt: 'uhlcare-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _mainLogo2.default, alt: 'medix-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _UHL2.default, alt: 'uhl-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _medixLogo2.default, alt: 'medix-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _maRashedHospital2.default, alt: 'medix-logo' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'left-offcanvas' },
	                  _react2.default.createElement(
	                    'p',
	                    { style: { "text-align": "center" } },
	                    _react2.default.createElement('i', { className: 'fa fa-times-circle', 'aria-hidden': 'true', style: { "color": "#ff0000", "fontSize": "80px" } })
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'mt-3', style: { "color": "#ff0000", "text-align": "center" } },
	                    'Payment Cancelled!'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'payment mt-5' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Hii, ',
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        this.state.patient_name
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Your Appointment booked ',
	                      this.state.payment_message,
	                      '!'
	                    ),
	                    _react2.default.createElement(
	                      'h3',
	                      { style: { "font-size": "20px", "font-weight": "600" } },
	                      'Payment details:'
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Transaction ID: '
	                        ),
	                        ' ',
	                        this.state.transaction_id
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment ID:'
	                        ),
	                        ' ',
	                        this.state.appointment_id
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment Date:'
	                        ),
	                        ' ',
	                        (0, _moment2.default)(this.state.appointment_date).format('dddd, LL')
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment Time:'
	                        ),
	                        ' ',
	                        (0, _moment2.default)(this.state.appointment_time, "HH:mm").format("hh:mm A")
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment Doctor Name: '
	                        ),
	                        ' ',
	                        this.state.doctor_name
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment Doctor Fees: '
	                        ),
	                        ' ',
	                        this.state.currency,
	                        ' ',
	                        this.state.doctor_fees
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment Total Amount: '
	                        ),
	                        ' ',
	                        this.state.currency,
	                        ' ',
	                        this.state.total_amount
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Payment Status: '
	                        ),
	                        this.state.payment_status,
	                        ' '
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_HomeSearch2.default, null)
	          )
	        ),
	        _react2.default.createElement(_CenterExcellence2.default, null),
	        _react2.default.createElement(_NewsEventsSilde2.default, null),
	        _react2.default.createElement(_PublicationsSilde2.default, null),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return Cancel;
	}(_react.Component);
	
	exports.default = Cancel;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _HomeHeader = __webpack_require__(112);
	
	var _HomeHeader2 = _interopRequireDefault(_HomeHeader);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _HomeSearch = __webpack_require__(86);
	
	var _HomeSearch2 = _interopRequireDefault(_HomeSearch);
	
	var _CenterExcellence = __webpack_require__(85);
	
	var _CenterExcellence2 = _interopRequireDefault(_CenterExcellence);
	
	var _NewsEventsSilde = __webpack_require__(71);
	
	var _NewsEventsSilde2 = _interopRequireDefault(_NewsEventsSilde);
	
	var _PublicationsSilde = __webpack_require__(72);
	
	var _PublicationsSilde2 = _interopRequireDefault(_PublicationsSilde);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPaymentDetails = function getPaymentDetails(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request('/payment/getpaymentdetails', {
	      method: 'get',
	      headers: {
	        'Accept': 'application/json',
	        'Authorization': 'Bearer ' + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var Fail = function (_Component) {
	  _inherits(Fail, _Component);
	
	  function Fail() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Fail);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Fail.__proto__ || Object.getPrototypeOf(Fail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transaction_id: '',
	      appointment_id: '',
	      appointment_date: '',
	      appointment_time: '',
	      patient_name: '',
	      doctor_name: '',
	      doctor_fees: '',
	      total_amount: '',
	      payment_status: '',
	      currency: '',
	      payment_message: ''
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshGetpaymentData = function (data) {
	      getPaymentDetails(data).then(function (res) {
	        if (res) {
	          var records = res.data;
	          _this.setState({
	            transaction_id: records.transaction_id,
	            appointment_id: records.appointment_id,
	            appointment_date: records.appointment_date,
	            appointment_time: records.appointment_time,
	            patient_name: records.patient_name,
	            doctor_name: records.doctor_name,
	            doctor_fees: records.doctor_fees,
	            total_amount: records.amount,
	            payment_status: records.status,
	            currency: records.currency
	          });
	          //this.setState({ patientLists: records });
	        } else {
	            //this.setState({ patientLists: '' });
	          }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Fail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var query = new URLSearchParams(this.props.location.search);
	      var status = query.get('status');
	      var trans_id = query.get('trans_id');
	      if (status === 'validation_failed') {
	        this.setState({ payment_message: 'Payment Validation Failed!' });
	      } else if (status === 'invalid_transaction') {
	        this.setState({ payment_message: 'Payment Invalid Transaction!' });
	      } else if (status === 'transaction_failed') {
	        this.setState({ payment_message: 'Payment Transaction Failed!' });
	      } else if (status === 'already_success') {
	        this.setState({ payment_message: 'Payment Transaction already success!' });
	      } else {
	        this.setState({ payment_message: 'Payment Transaction Invalid!' });
	      }
	      var data = {
	        transaction_id: trans_id
	      };
	      this.refreshGetpaymentData(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'section',
	          { className: 'banner-part' },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _HomeHeader2.default }),
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'offcanvas offcanvas-start show', tabIndex: -1, id: 'offcanvasExample', 'aria-labelledby': 'offcanvasExampleLabel' },
	              _react2.default.createElement(
	                'div',
	                { className: 'offcanvas-header' },
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'offcanvas-title', id: 'offcanvasExampleLabel' },
	                  ' '
	                ),
	                _react2.default.createElement('button', { type: 'button', className: 'btn-close text-reset', 'data-bs-dismiss': 'offcanvas', 'aria-label': 'Close' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'offcanvas-body' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row text-center', id: 'logos' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2 ' },
	                    _react2.default.createElement('img', { src: _uhlcareLogo2.default, alt: 'uhlcare-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _mainLogo2.default, alt: 'medix-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _UHL2.default, alt: 'uhl-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _medixLogo2.default, alt: 'medix-logo' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-2' },
	                    _react2.default.createElement('img', { src: _maRashedHospital2.default, alt: 'medix-logo' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'left-offcanvas' },
	                  _react2.default.createElement(
	                    'p',
	                    { style: { "text-align": "center" } },
	                    _react2.default.createElement('i', { className: 'fa fa-exclamation-triangle', 'aria-hidden': 'true', style: { "color": "#ff0000", "fontSize": "80px" } })
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'mt-3', style: { "color": "#ff0000", "text-align": "center" } },
	                    'Payment Failed!'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'payment mt-5' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Hii, ',
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        this.state.patient_name
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Your Appointment booked ',
	                      this.state.payment_message,
	                      '!'
	                    ),
	                    _react2.default.createElement(
	                      'h3',
	                      { style: { "font-size": "20px", "font-weight": "600" } },
	                      'Payment details:'
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Transaction ID: '
	                        ),
	                        ' ',
	                        this.state.transaction_id
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment ID:'
	                        ),
	                        ' ',
	                        this.state.appointment_id
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment Date:'
	                        ),
	                        ' ',
	                        (0, _moment2.default)(this.state.appointment_date).format('dddd, LL')
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment Time:'
	                        ),
	                        ' ',
	                        (0, _moment2.default)(this.state.appointment_time, "HH:mm").format("hh:mm A")
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment Doctor Name: '
	                        ),
	                        ' ',
	                        this.state.doctor_name
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment Doctor Fees: '
	                        ),
	                        ' ',
	                        this.state.currency,
	                        ' ',
	                        this.state.doctor_fees
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Appointment Total Amount: '
	                        ),
	                        ' ',
	                        this.state.currency,
	                        ' ',
	                        this.state.total_amount
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { style: { "list-style": "none", "line-height": "40px" } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'Payment Status: '
	                        ),
	                        this.state.payment_status,
	                        ' '
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_HomeSearch2.default, null)
	          )
	        ),
	        _react2.default.createElement(_CenterExcellence2.default, null),
	        _react2.default.createElement(_NewsEventsSilde2.default, null),
	        _react2.default.createElement(_PublicationsSilde2.default, null),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return Fail;
	}(_react.Component);
	
	exports.default = Fail;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(14);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _userSession = __webpack_require__(30);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _HomeSearch = __webpack_require__(86);
	
	var _HomeSearch2 = _interopRequireDefault(_HomeSearch);
	
	var _CenterExcellence = __webpack_require__(85);
	
	var _CenterExcellence2 = _interopRequireDefault(_CenterExcellence);
	
	var _NewsEventsSilde = __webpack_require__(71);
	
	var _NewsEventsSilde2 = _interopRequireDefault(_NewsEventsSilde);
	
	var _PublicationsSilde = __webpack_require__(72);
	
	var _PublicationsSilde2 = _interopRequireDefault(_PublicationsSilde);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _HeaderHome = __webpack_require__(111);
	
	var _HeaderHome2 = _interopRequireDefault(_HeaderHome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var bookingAppoinments = function bookingAppoinments(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request("/AppointmentBooking", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var sendSMS = function sendSMS(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/sendcustomsms", {
	      method: "post",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getPatientIdByPayment = function getPatientIdByPayment(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request("/mmpatientRegistration", {
	      method: "get",
	      headers: {
	        Accept: "application/json"
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var RegisterData = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data, id) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt("return", new Promise(function (resolve, reject) {
	              //const token = Buffer.from(`${API_AUTH_USERNAME}:${API_AUTH_PASSWORD}`, 'utf8').toString('base64');
	              var req = _.scAxiosAdmin.request("/user/update_patient/" + id, {
	                method: "put",
	                data: data,
	                headers: {
	                  Accept: "application/json"
	                }
	              });
	              req.then(function (res) {
	                return resolve(res.data);
	              }).catch(function (err) {
	                return reject(err);
	              });
	            }));
	
	          case 1:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function RegisterData(_x, _x2) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var UpdateAppoinmentData = function UpdateAppoinmentData(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxiosAdmin.request("/payment/updateappointemntdetails", {
	      method: "post",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      },
	      params: Object.assign({}, data)
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var Success = function (_Component) {
	  _inherits(Success, _Component);
	
	  function Success() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Success);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Success.__proto__ || Object.getPrototypeOf(Success)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      transaction_id: "",
	      appointment_id: "",
	      appointment_date: "",
	      appointment_time: "",
	      patient_name: "",
	      doctor_name: "",
	      doctor_fees: "",
	      total_amount: "",
	      payment_status: "",
	      currency: "",
	      paymentMode: ""
	    }, _this.handleChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.refreshUpdateAppoinmentData = function (data) {
	      UpdateAppoinmentData(data).then(function (res) {
	        if (res) {
	          var token = localStorage.getItem(_constants.API_TOKEN_NAME);
	          var phone_number = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	          var search_selected_doc_id = "";
	          var patientid = localStorage.getItem(_constants.USER_ID);
	          var user_email = localStorage.getItem(_constants.USER_EMAIL);
	          var user_role = localStorage.getItem(_constants.USER_ROLE);
	
	          var localId = localStorage.getItem(_constants.USER_LOCAL_ID);
	          var date_of_birth = localStorage.getItem(_constants.PATIENT_DATE_OF_BIRTH);
	
	          var schedule_date = "";
	          //let apointment_id = res[0].AppointmentID;
	          var apointment_id = "";
	          var doctor_name = "";
	          var doctor_fees = "";
	          var patientName = localStorage.getItem(_constants.PATIENT_NAME);
	          var schedule_time = "";
	          var search_selected_doc_name = "";
	          var doctor_profile_avability = "";
	          (0, _userSession.startUserSession)(token, user_role, user_email, patientid, phone_number, search_selected_doc_id, schedule_date, apointment_id, doctor_name, doctor_fees, patientName, schedule_time, search_selected_doc_name, doctor_profile_avability, localId, date_of_birth);
	
	          var records = res.data;
	          _this.setState({
	            transaction_id: records.transaction_id,
	            appointment_id: records.appointment_id,
	            appointment_date: records.appointment_date,
	            appointment_time: records.appointment_time,
	            patient_name: records.patient_name,
	            doctor_name: records.doctor_name,
	            doctor_fees: records.doctor_fees,
	            total_amount: records.amount,
	            payment_status: records.status,
	            currency: records.currency
	          });
	          //this.setState({ patientLists: records });
	        } else {
	            //this.setState({ patientLists: '' });
	          }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Success, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var query = new URLSearchParams(this.props.location.search);
	      var trans_id = query.get("trans_id");
	      /* if(trans_id){
	        const data = {
	          PatientID: localStorage.getItem(USER_ID),
	          DoctorID: localStorage.getItem(SEARCH_SELECTED_DOC_ID),
	          Scheduledate: localStorage.getItem(SCHEDULE_DATE),
	          Scheduletime: localStorage.getItem(SCHEDULE_TIME),
	        }
	        
	        bookingAppoinments(data)
	        .then(res => {
	          console.log("test con",res);
	          const data = {
	            transaction_id: trans_id,
	            appointment_id: res[0].AppointmentID,
	            appointment_date: localStorage.getItem(SCHEDULE_DATE),
	            appointment_time: localStorage.getItem(SCHEDULE_TIME),
	          }
	          this.refreshUpdateAppoinmentData(data);
	        })
	        .catch(err => {
	          toast.error('Appointment not booked successful!', {
	            position: toast.POSITION.TOP_LEFT
	             });
	        });
	      } */
	      var inputDate = localStorage.getItem(_constants.SCHEDULE_DATE);
	      // Convert input date to Date object
	      var dateObj = new Date(inputDate);
	
	      // Extract year, month, and day from the Date object
	      var year = dateObj.getFullYear();
	      var month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // Adding 1 as month starts from 0
	      var day = ("0" + dateObj.getDate()).slice(-2);
	
	      // Form the desired date string
	      var formattedDate = year + "-" + month + "-" + day;
	      var data = {
	        PatientID: localStorage.getItem(_constants.USER_ID),
	        DoctorID: localStorage.getItem(_constants.SEARCH_SELECTED_DOC_ID),
	        Scheduledate: formattedDate,
	        Scheduletime: localStorage.getItem(_constants.SCHEDULE_TIME)
	      };
	      var sms_data = {
	        phone_number: localStorage.getItem(_constants.LOGIN_PHONE_NUMBER),
	        message: "Your requested has been received. We'll call you soon."
	      };
	      var queryParams = new URLSearchParams(this.props.location.search);
	
	      var paymentMode = queryParams.get("Paymentmode");
	      this.setState({ paymentMode: paymentMode });
	
	      if (data.Scheduledate && data.Scheduletime && paymentMode !== "booking_request") {
	        bookingAppoinments(data).then(function (res) {
	          var data = {
	            transaction_id: trans_id,
	            appointment_id: res[0].AppointmentID,
	            appointment_date: formattedDate,
	            appointment_time: localStorage.getItem(_constants.SCHEDULE_TIME)
	          };
	          _this2.refreshUpdateAppoinmentData(data);
	        }).catch(function (err) {
	          _reactToastify.toast.error("Appointment not booked successful!", {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        });
	      }
	      if (paymentMode === "booking_request") {
	        sendSMS(sms_data).then(function (res) {
	          // this.refreshUpdateAppoinmentData(data);
	        }).catch(function (err) {
	          _reactToastify.toast.error("Appointment not booked successful!", {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        });
	      }
	      if (paymentMode === "patient_registration") {
	        var id = localStorage.getItem(_constants.USER_LOCAL_ID);
	        var Cardno = queryParams.get("Cardno") || "null";
	        var Cardtype = queryParams.get("Cardtype") ? queryParams.get("Cardtype") : "null";
	        var xtrnno = queryParams.get("xtrnno");
	        var Cardamt = queryParams.get("Cardamt");
	        var Name = localStorage.getItem(_constants.PATIENT_NAME);
	        var DateOfBirth = localStorage.getItem(_constants.PATIENT_DATE_OF_BIRTH);
	        var PhoneNumber = localStorage.getItem(_constants.LOGIN_PHONE_NUMBER);
	        var Address = "Bangladesh";
	        var _data = {
	          Cardno: Cardno,
	          Cardtype: Cardtype,
	          xtrnno: xtrnno,
	          Cardamt: Cardamt,
	          Name: Name,
	          Address: Address,
	          DateOfBirth: DateOfBirth,
	          PhoneNumber: PhoneNumber
	        };
	        getPatientIdByPayment(_data).then(function (res) {
	          // this.refreshUpdateAppoinmentData(data);
	          var patient_id = "" + res.PatientID;
	
	          var isapproved = "1";
	          var user = {
	            patient_id: patient_id,
	            isapproved: isapproved
	          };
	          RegisterData(user, id).then(function (res) {
	            // this.refreshResetOTPData();
	
	            localStorage.setItem(_constants.USER_ID, res.data.patient_id);
	            _reactToastify.toast.success("User Registered Successfully!", {
	              position: _reactToastify.toast.POSITION.TOP_LEFT
	            });
	          }).catch(function (err) {
	            console.log(err);
	          });
	        }).catch(function (err) {
	          _reactToastify.toast.error("Something went wrong! Please try again", {
	            position: _reactToastify.toast.POSITION.TOP_LEFT
	          });
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "section",
	          { className: "banner-part" },
	          _react2.default.createElement(_reactRouterDom.Route, { component: _HeaderHome2.default }),
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "offcanvas offcanvas-start show",
	                tabIndex: -1,
	                id: "offcanvasExample",
	                "aria-labelledby": "offcanvasExampleLabel"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "offcanvas-header" },
	                _react2.default.createElement(
	                  "h5",
	                  { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	                  " "
	                ),
	                _react2.default.createElement("button", {
	                  type: "button",
	                  className: "btn-close text-reset",
	                  "data-bs-dismiss": "offcanvas",
	                  "aria-label": "Close"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "offcanvas-body" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row text-center", id: "logos" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-2 " },
	                    _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-2" },
	                    _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-2" },
	                    _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-2" },
	                    _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-2" },
	                    _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "left-offcanvas" },
	                  _react2.default.createElement(
	                    "p",
	                    { style: { "text-align": "center" } },
	                    _react2.default.createElement("i", {
	                      className: "fa fa-check-circle mt-10",
	                      "aria-hidden": "true",
	                      style: { color: "#39e75f", "font-size": "80px" }
	                    })
	                  ),
	                  console.log("this.state.paymentMode", this.state.paymentMode),
	                  _react2.default.createElement(
	                    "h4",
	                    {
	                      className: "mt-3",
	                      style: {
	                        color: "#39e75f",
	                        "text-align": "center",
	                        fontSize: "22px"
	                      }
	                    },
	                    this.state.paymentMode === "patient_registration" ? "Registration Successful!" : "Booking Successful!"
	                  ),
	                  this.state.paymentMode === "booking_request" ? _react2.default.createElement(
	                    "div",
	                    { className: "payment mt-5" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Hi, ",
	                      _react2.default.createElement(
	                        "strong",
	                        null,
	                        this.state.patient_name
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Your Appointment was booked successfully!! Please arrive in the hospital 30 minutes before schedule."
	                    )
	                  ) : ""
	                )
	              )
	            ),
	            _react2.default.createElement(_HomeSearch2.default, null)
	          )
	        ),
	        _react2.default.createElement(_CenterExcellence2.default, null),
	        _react2.default.createElement(_NewsEventsSilde2.default, null),
	        _react2.default.createElement(_PublicationsSilde2.default, null),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	      );
	    }
	  }]);
	
	  return Success;
	}(_react.Component);
	
	exports.default = (0, _reactRouterDom.withRouter)(Success);

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(3);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _userSession = __webpack_require__(30);
	
	var _ = __webpack_require__(2);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _uhlcareLogo = __webpack_require__(36);
	
	var _uhlcareLogo2 = _interopRequireDefault(_uhlcareLogo);
	
	var _UHL = __webpack_require__(31);
	
	var _UHL2 = _interopRequireDefault(_UHL);
	
	var _medixLogo = __webpack_require__(35);
	
	var _medixLogo2 = _interopRequireDefault(_medixLogo);
	
	var _maRashedHospital = __webpack_require__(33);
	
	var _maRashedHospital2 = _interopRequireDefault(_maRashedHospital);
	
	var _mainLogo = __webpack_require__(34);
	
	var _mainLogo2 = _interopRequireDefault(_mainLogo);
	
	var _HomeSearch = __webpack_require__(86);
	
	var _HomeSearch2 = _interopRequireDefault(_HomeSearch);
	
	var _CenterExcellence = __webpack_require__(85);
	
	var _CenterExcellence2 = _interopRequireDefault(_CenterExcellence);
	
	var _NewsEventsSilde = __webpack_require__(71);
	
	var _NewsEventsSilde2 = _interopRequireDefault(_NewsEventsSilde);
	
	var _PublicationsSilde = __webpack_require__(72);
	
	var _PublicationsSilde2 = _interopRequireDefault(_PublicationsSilde);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _HeaderHome = __webpack_require__(111);
	
	var _HeaderHome2 = _interopRequireDefault(_HeaderHome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var successOrder = function successOrder() {
	  var name = localStorage.getItem("patient_name");
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "section",
	      { className: "banner-part" },
	      _react2.default.createElement(_reactRouterDom.Route, { component: _HeaderHome2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "offcanvas offcanvas-start show",
	            tabIndex: -1,
	            id: "offcanvasExample",
	            "aria-labelledby": "offcanvasExampleLabel"
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-header" },
	            _react2.default.createElement(
	              "h5",
	              { className: "offcanvas-title", id: "offcanvasExampleLabel" },
	              " "
	            ),
	            _react2.default.createElement("button", {
	              type: "button",
	              className: "btn-close text-reset",
	              "data-bs-dismiss": "offcanvas",
	              "aria-label": "Close"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "offcanvas-body" },
	            _react2.default.createElement(
	              "div",
	              { className: "row text-center", id: "logos" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-2 " },
	                _react2.default.createElement("img", { src: _uhlcareLogo2.default, alt: "uhlcare-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _mainLogo2.default, alt: "medix-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _UHL2.default, alt: "uhl-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _medixLogo2.default, alt: "medix-logo" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-2" },
	                _react2.default.createElement("img", { src: _maRashedHospital2.default, alt: "medix-logo" })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "left-offcanvas" },
	              _react2.default.createElement(
	                "p",
	                { style: { "text-align": "center" } },
	                _react2.default.createElement("i", {
	                  className: "fa fa-check-circle mt-10",
	                  "aria-hidden": "true",
	                  style: { color: "#39e75f", "font-size": "80px" }
	                })
	              ),
	              _react2.default.createElement(
	                "h4",
	                {
	                  className: "mt-3",
	                  style: {
	                    color: "#39e75f",
	                    "text-align": "center",
	                    fontSize: "22px"
	                  }
	                },
	                "Order Successful!"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "payment mt-5" },
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Hi, ",
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    name ? name : ""
	                  )
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Your Order was received successfully!!"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_HomeSearch2.default, null)
	      )
	    ),
	    _react2.default.createElement(_CenterExcellence2.default, null),
	    _react2.default.createElement(_NewsEventsSilde2.default, null),
	    _react2.default.createElement(_PublicationsSilde2.default, null),
	    _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default })
	  );
	};
	
	exports.default = successOrder;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(5);
	
	var _ = __webpack_require__(2);
	
	var _constants = __webpack_require__(3);
	
	var _PrivateRoute = __webpack_require__(81);
	
	var _userSession = __webpack_require__(30);
	
	var _reactToastify = __webpack_require__(7);
	
	__webpack_require__(8);
	
	var _Header = __webpack_require__(15);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Link } from 'react-router-dom'
	//import { connect } from 'react-redux';
	//import { bindActionCreators } from 'redux';
	
	//import * as userActions from '../actions/userActions';
	
	
	var userregister = function userregister(data) {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request("/register", {
	      method: "post",
	      params: Object.assign({}, data)
	    });
	
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	var getUserRoles = function getUserRoles() {
	  return new Promise(function (resolve, reject) {
	    var req = _.scAxios.request("/user/role", {
	      method: "get",
	      headers: {
	        Accept: "application/json",
	        Authorization: "Bearer " + localStorage.getItem(_constants.API_TOKEN_NAME)
	      }
	    });
	    req.then(function (res) {
	      return resolve(res.data);
	    }).catch(function (err) {
	      return reject(err);
	    });
	  });
	};
	
	var alertStyle = {
	  color: "red"
	};
	
	/*const textStyle = {
	  textTransform: 'capitalize',
	};*/
	
	var register = function (_Component) {
	  _inherits(register, _Component);
	
	  function register() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, register);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = register.__proto__ || Object.getPrototypeOf(register)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {},
	      errors: {},
	      firstname: "",
	      lastname: "",
	      email: "",
	      password: "",
	      confirm_password: "",
	      forwarduId: "",
	      //termchk:'',
	      Loading: false,
	      user_active: false,
	      signin_success: false,
	      signup_success: false,
	      user_role: "",
	      roles: []
	    }, _this.handleChange = function (event) {
	      _this.setState({ errors: "" });
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      if (_this.validateForm()) {
	        _this.setState({ Loading: true });
	        var data = {
	          firstname: _this.state.firstname,
	          lastname: _this.state.lastname,
	          email: _this.state.email,
	          role: _this.state.user_role,
	          password: _this.state.password
	        };
	        userregister(data).then(function (res) {
	          if (res.status === true) {
	            if (!!res.token) {
	              (0, _userSession.startUserSession)(res.token, res.data.role, res.data.id, res.data.email, res.data.isapproved, res.data.reg_step_1, res.data.reg_step_2, res.data.reg_step_3, res.data.reg_step_4);
	              _this.setState({
	                signin_success: true,
	                user_active: res.data.status === 0 ? false : true
	              });
	              _this.props.actions.userLoginSuccess(res.data);
	            } else {
	              _reactToastify.toast.error(res.message, {
	                position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	              });
	            }
	            _reactToastify.toast.success(res.message, {
	              autoClose: 10000,
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	            _this.setState({
	              firstname: "",
	              lastname: "",
	              email: "",
	              password: "",
	              confirm_password: ""
	            });
	            _this.setState({ forwarduId: res.data.id, signup_success: true });
	          } else {
	            _reactToastify.toast.error(res.message, {
	              position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	            });
	          }
	          _this.setState({ Loading: false });
	        }).catch(function (err) {
	          console.log(err);
	        });
	      } else {
	        _reactToastify.toast.error("Please Fill All Mandatory Fields.", {
	          position: _reactToastify.toast.POSITION.BOTTOM_RIGHT
	        });
	      }
	    }, _this.refreshUserRoles = function () {
	      getUserRoles().then(function (res) {
	        if (res.status === true) {
	          var records = res.data;
	          _this.setState({ roles: records });
	        } else {
	          _this.setState({ roles: "" });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(register, [{
	    key: "validateForm",
	
	
	    /*handleCheckBoxChange = event => {
	      if (event.target.checked) {
	         this.setState({ termchk: true});
	      } else {
	        this.setState({ termchk: ''});
	      }
	    }*/
	
	    value: function validateForm() {
	      //let fields = this.state.fields;
	      var errors = {};
	      var formIsValid = true;
	
	      if (!this.state.firstname) {
	        formIsValid = false;
	        errors["firstname"] = "*Please enter first name.";
	      }
	
	      if (typeof this.state.firstname !== "undefined") {
	        if (!this.state.firstname.match(/^[a-zA-Z ]*$/)) {
	          formIsValid = false;
	          errors["firstname"] = "*Please enter alphabets characters only.";
	        }
	      }
	
	      if (!this.state.lastname) {
	        formIsValid = false;
	        errors["lastname"] = "*Please enter last name.";
	      }
	
	      if (typeof this.state.lastname !== "undefined") {
	        if (!this.state.lastname.match(/^[a-zA-Z ]*$/)) {
	          formIsValid = false;
	          errors["lastname"] = "*Please enter alphabets characters only.";
	        }
	      }
	
	      if (!this.state.email) {
	        formIsValid = false;
	        errors["email"] = "*Please enter email address.";
	      }
	
	      if (typeof this.state.email !== "undefined") {
	        //eslint-disable-next-line
	        if (!this.state.email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
	          formIsValid = false;
	          errors["email"] = "*Please enter a valid email address";
	        }
	      }
	
	      if (!this.state.password) {
	        formIsValid = false;
	        errors["password"] = "*Please enter password.";
	      }
	
	      if (typeof this.state.password !== "undefined") {
	        if (this.state.password.length < 6) {
	          formIsValid = false;
	          errors["password"] = "*password must be at least 6 characters long.";
	        }
	      }
	
	      if (!this.state.confirm_password) {
	        formIsValid = false;
	        errors["confirm_password"] = "*Please enter confirm password.";
	      }
	
	      if (this.state.confirm_password !== this.state.password) {
	        formIsValid = false;
	        errors["confirm_password"] = "*Password and confirm password must be same";
	      }
	
	      if (!this.state.user_role) {
	        formIsValid = false;
	        errors["user_role"] = "*Please select your user role.";
	      }
	
	      /*if (!this.state.termchk) {
	          formIsValid = false;
	          errors["termchk"] = "*Please check terms and condition.";
	            
	        }*/
	
	      this.setState({
	        errors: errors
	      });
	      return formIsValid;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshUserRoles();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var Loading = this.state.Loading;
	
	      var _ref2 = this.props.location.state || {
	        from: { pathname: "/dashboard" }
	      },
	          from = _ref2.from;
	
	      if ((0, _PrivateRoute.validateUserToken)()) {
	        if (!this.state.signin_success) return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/login" });
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: from });
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Header2.default }),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "row starbuck_row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12" },
	              _react2.default.createElement(
	                "h6",
	                { className: "heading_col font_16" },
	                "Register Now"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "txt_col fontweight500 font_12 mb-4" },
	                "Create your account and enjoy"
	              ),
	              _react2.default.createElement(
	                "form",
	                {
	                  onSubmit: this.handleSubmit,
	                  id: "regform",
	                  className: "needs-validation",
	                  noValidate: true
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-6" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        className: "form-control input_custom_style",
	                        name: "firstname",
	                        id: "firstname",
	                        value: this.state.firstname,
	                        onChange: this.handleChange,
	                        placeholder: "First name",
	                        required: ""
	                      }),
	                      _react2.default.createElement(
	                        "span",
	                        { style: alertStyle },
	                        this.state.errors.firstname
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-6" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        className: "form-control input_custom_style",
	                        name: "lastname",
	                        id: "lastname",
	                        value: this.state.lastname,
	                        onChange: this.handleChange,
	                        placeholder: "Last name",
	                        required: ""
	                      }),
	                      _react2.default.createElement(
	                        "span",
	                        { style: alertStyle },
	                        this.state.errors.lastname
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        className: "form-control input_custom_style",
	                        name: "email",
	                        id: "email",
	                        value: this.state.email,
	                        onChange: this.handleChange,
	                        placeholder: "Business email",
	                        required: "",
	                        autoComplete: "off"
	                      }),
	                      _react2.default.createElement(
	                        "span",
	                        { style: alertStyle },
	                        this.state.errors.email
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          className: "form-control",
	                          id: "user_role",
	                          value: this.state.user_role,
	                          onChange: this.handleChange,
	                          name: "user_role"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          null,
	                          "Select your role"
	                        ),
	                        this.state.roles.length > 0 ? this.state.roles.map(function (role) {
	                          return _react2.default.createElement(
	                            "option",
	                            { key: role.id, value: role.id },
	                            role.title
	                          );
	                        }) : _react2.default.createElement(
	                          "option",
	                          null,
	                          "No role found"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        { style: alertStyle },
	                        this.state.errors.user_role
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement("input", {
	                        type: "password",
	                        className: "form-control input_custom_style",
	                        name: "password",
	                        id: "password",
	                        value: this.state.password,
	                        onChange: this.handleChange,
	                        placeholder: "Password",
	                        required: "",
	                        autoComplete: "off"
	                      }),
	                      _react2.default.createElement(
	                        "span",
	                        { style: alertStyle },
	                        this.state.errors.password
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement("input", {
	                        type: "password",
	                        className: "form-control input_custom_style",
	                        name: "confirm_password",
	                        id: "confirm_password",
	                        value: this.state.confirm_password,
	                        onChange: this.handleChange,
	                        placeholder: "Confirm Password",
	                        required: ""
	                      }),
	                      _react2.default.createElement(
	                        "span",
	                        { style: alertStyle },
	                        this.state.errors.confirm_password
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "submit",
	                    className: "blue_btn mt-3",
	                    disabled: Loading
	                  },
	                  " ",
	                  Loading && _react2.default.createElement("i", { className: "fa fa-refresh fa-spin" }),
	                  " Signup Now",
	                  " "
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "aggre_term_condition_text txt_col fontweight500 font_12 mt-3" },
	                "By signing up, you agree to our",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  { href: "/terms", className: "blue_anchor_col" },
	                  "Terms of Service"
	                ),
	                ",",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  { href: "/privacypolicy", className: "blue_anchor_col" },
	                  " ",
	                  "Privacy Policy",
	                  " "
	                ),
	                " ",
	                "and to receive Untited Hospital emails & updates."
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "signing_link_text txt_col fontweight500 font_12" },
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  { href: "/login", className: "blue_anchor_col" },
	                  "Already have an account? Sign In"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactRouterDom.Route, { component: _Footer2.default }),
	        _react2.default.createElement(_reactToastify.ToastContainer, { autoClose: 5000 })
	      );
	    }
	  }]);
	
	  return register;
	}(_react.Component);
	
	exports.default = register;

/***/ },
/* 704 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    user: {
	        id: -1,
	        firstname: '',
	        lastname: '',
	        email: 0,
	        phone: 0,
	        status: null,
	        type: '',
	        token: ''
	    }
	
	};

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.rootReducer = undefined;
	
	var _redux = __webpack_require__(79);
	
	var _userReducer = __webpack_require__(706);
	
	var _userReducer2 = _interopRequireDefault(_userReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = exports.rootReducer = (0, _redux.combineReducers)({
	    user: _userReducer2.default
	});

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actionTypes = __webpack_require__(196);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(704);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.user;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.USER_INIT:
	            return Object.assign({}, state);
	
	        case types.USER_LOGIN_SUCCESS:
	            return Object.assign({}, state, action.user);
	
	        case types.USER_LOGIN_ERROR:
	            alert('login error');
	            return Object.assign({}, state);
	
	        case types.USER_LOGOUT_SUCCESS:
	            return Object.assign({}, state, _initialState2.default.user);
	
	        case types.USER_LOGOUT_ERROR:
	            alert('logout error');
	            return Object.assign({}, state);
	
	        default:
	            return state;
	    }
	};

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.register = register;
	exports.unregister = unregister;
	// This optional code is used to register a service worker.
	// register() is not called by default.
	
	// This lets the app load faster on subsequent visits in production, and gives
	// it offline capabilities. However, it also means that developers (and users)
	// will only see deployed updates on subsequent visits to a page, after all the
	// existing tabs open on the page have been closed, since previously cached
	// resources are updated in the background.
	
	// To learn more about the benefits of this model and instructions on how to
	// opt-in, read https://bit.ly/CRA-PWA
	
	var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
	// [::1] is the IPv6 localhost address.
	window.location.hostname === '[::1]' ||
	// 127.0.0.1/8 is considered localhost for IPv4.
	window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
	
	function register(config) {
	  if (("production") === 'production' && 'serviceWorker' in navigator) {
	    // The URL constructor is available in all browsers that support SW.
	    var publicUrl = new URL((""), window.location.href);
	    if (publicUrl.origin !== window.location.origin) {
	      // Our service worker won't work if PUBLIC_URL is on a different origin
	      // from what our page is served on. This might happen if a CDN is used to
	      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
	      return;
	    }
	
	    window.addEventListener('load', function () {
	      var swUrl = ("") + '/service-worker.js';
	
	      if (isLocalhost) {
	        // This is running on localhost. Let's check if a service worker still exists or not.
	        checkValidServiceWorker(swUrl, config);
	
	        // Add some additional logging to localhost, pointing developers to the
	        // service worker/PWA documentation.
	        navigator.serviceWorker.ready.then(function () {
	          console.log('This web app is being served cache-first by a service ' + 'worker. To learn more, visit https://bit.ly/CRA-PWA');
	        });
	      } else {
	        // Is not localhost. Just register service worker
	        registerValidSW(swUrl, config);
	      }
	    });
	  }
	}
	
	function registerValidSW(swUrl, config) {
	  navigator.serviceWorker.register(swUrl).then(function (registration) {
	    registration.onupdatefound = function () {
	      var installingWorker = registration.installing;
	      if (installingWorker == null) {
	        return;
	      }
	      installingWorker.onstatechange = function () {
	        if (installingWorker.state === 'installed') {
	          if (navigator.serviceWorker.controller) {
	            // At this point, the updated precached content has been fetched,
	            // but the previous service worker will still serve the older
	            // content until all client tabs are closed.
	            console.log('New content is available and will be used when all ' + 'tabs for this page are closed. See https://bit.ly/CRA-PWA.');
	
	            // Execute callback
	            if (config && config.onUpdate) {
	              config.onUpdate(registration);
	            }
	          } else {
	            // At this point, everything has been precached.
	            // It's the perfect time to display a
	            // "Content is cached for offline use." message.
	            console.log('Content is cached for offline use.');
	
	            // Execute callback
	            if (config && config.onSuccess) {
	              config.onSuccess(registration);
	            }
	          }
	        }
	      };
	    };
	  }).catch(function (error) {
	    console.error('Error during service worker registration:', error);
	  });
	}
	
	function checkValidServiceWorker(swUrl, config) {
	  // Check if the service worker can be found. If it can't reload the page.
	  fetch(swUrl).then(function (response) {
	    // Ensure service worker exists, and that we really are getting a JS file.
	    var contentType = response.headers.get('content-type');
	    if (response.status === 404 || contentType != null && contentType.indexOf('javascript') === -1) {
	      // No service worker found. Probably a different app. Reload the page.
	      navigator.serviceWorker.ready.then(function (registration) {
	        registration.unregister().then(function () {
	          window.location.reload();
	        });
	      });
	    } else {
	      // Service worker found. Proceed as normal.
	      registerValidSW(swUrl, config);
	    }
	  }).catch(function () {
	    console.log('No internet connection found. App is running in offline mode.');
	  });
	}
	
	function unregister() {
	  if ('serviceWorker' in navigator) {
	    navigator.serviceWorker.ready.then(function (registration) {
	      registration.unregister();
	    });
	  }
	}

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(79);
	
	var _reduxThunk = __webpack_require__(1032);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _rootReducer = __webpack_require__(705);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (initialState) {
	    return (0, _redux.createStore)(_rootReducer.rootReducer, initialState, (0, _redux.applyMiddleware)(_reduxThunk2.default));
	};

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(710);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 710 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 711 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 712 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var invariant = _interopDefault(__webpack_require__(128));
	
	var getRect = function getRect(_ref) {
	  var top = _ref.top,
	      right = _ref.right,
	      bottom = _ref.bottom,
	      left = _ref.left;
	  var width = right - left;
	  var height = bottom - top;
	  var rect = {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left,
	    width: width,
	    height: height,
	    x: left,
	    y: top,
	    center: {
	      x: (right + left) / 2,
	      y: (bottom + top) / 2
	    }
	  };
	  return rect;
	};
	var expand = function expand(target, expandBy) {
	  return {
	    top: target.top - expandBy.top,
	    left: target.left - expandBy.left,
	    bottom: target.bottom + expandBy.bottom,
	    right: target.right + expandBy.right
	  };
	};
	var shrink = function shrink(target, shrinkBy) {
	  return {
	    top: target.top + shrinkBy.top,
	    left: target.left + shrinkBy.left,
	    bottom: target.bottom - shrinkBy.bottom,
	    right: target.right - shrinkBy.right
	  };
	};
	
	var shift = function shift(target, shiftBy) {
	  return {
	    top: target.top + shiftBy.y,
	    left: target.left + shiftBy.x,
	    bottom: target.bottom + shiftBy.y,
	    right: target.right + shiftBy.x
	  };
	};
	
	var noSpacing = {
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	};
	var createBox = function createBox(_ref2) {
	  var borderBox = _ref2.borderBox,
	      _ref2$margin = _ref2.margin,
	      margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin,
	      _ref2$border = _ref2.border,
	      border = _ref2$border === void 0 ? noSpacing : _ref2$border,
	      _ref2$padding = _ref2.padding,
	      padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
	  var marginBox = getRect(expand(borderBox, margin));
	  var paddingBox = getRect(shrink(borderBox, border));
	  var contentBox = getRect(shrink(paddingBox, padding));
	  return {
	    marginBox: marginBox,
	    borderBox: getRect(borderBox),
	    paddingBox: paddingBox,
	    contentBox: contentBox,
	    margin: margin,
	    border: border,
	    padding: padding
	  };
	};
	
	var parse = function parse(raw) {
	  var value = raw.slice(0, -2);
	  var suffix = raw.slice(-2);
	
	  if (suffix !== 'px') {
	    return 0;
	  }
	
	  var result = Number(value);
	  !!isNaN(result) ?  false ? invariant(false, "Could not parse value [raw: " + raw + ", without suffix: " + value + "]") : invariant(false) : void 0;
	  return result;
	};
	
	var getWindowScroll = function getWindowScroll() {
	  return {
	    x: window.pageXOffset,
	    y: window.pageYOffset
	  };
	};
	
	var offset = function offset(original, change) {
	  var borderBox = original.borderBox,
	      border = original.border,
	      margin = original.margin,
	      padding = original.padding;
	  var shifted = shift(borderBox, change);
	  return createBox({
	    borderBox: shifted,
	    border: border,
	    margin: margin,
	    padding: padding
	  });
	};
	var withScroll = function withScroll(original, scroll) {
	  if (scroll === void 0) {
	    scroll = getWindowScroll();
	  }
	
	  return offset(original, scroll);
	};
	var calculateBox = function calculateBox(borderBox, styles) {
	  var margin = {
	    top: parse(styles.marginTop),
	    right: parse(styles.marginRight),
	    bottom: parse(styles.marginBottom),
	    left: parse(styles.marginLeft)
	  };
	  var padding = {
	    top: parse(styles.paddingTop),
	    right: parse(styles.paddingRight),
	    bottom: parse(styles.paddingBottom),
	    left: parse(styles.paddingLeft)
	  };
	  var border = {
	    top: parse(styles.borderTopWidth),
	    right: parse(styles.borderRightWidth),
	    bottom: parse(styles.borderBottomWidth),
	    left: parse(styles.borderLeftWidth)
	  };
	  return createBox({
	    borderBox: borderBox,
	    margin: margin,
	    padding: padding,
	    border: border
	  });
	};
	var getBox = function getBox(el) {
	  var borderBox = el.getBoundingClientRect();
	  var styles = window.getComputedStyle(el);
	  return calculateBox(borderBox, styles);
	};
	
	exports.calculateBox = calculateBox;
	exports.createBox = createBox;
	exports.expand = expand;
	exports.getBox = getBox;
	exports.getRect = getRect;
	exports.offset = offset;
	exports.shrink = shrink;
	exports.withScroll = withScroll;


/***/ },
/* 714 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assign;
	function assign(target, object) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	  for (var property in object) {
	    if (Object.prototype.hasOwnProperty.call(object, property)) {
	      ;
	      target[property] = object[property];
	    }
	  }
	  return target;
	}
	module.exports = exports.default;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(717));
	var _index2 = _interopRequireDefault(__webpack_require__(218));
	var _index3 = _interopRequireDefault(__webpack_require__(217));
	var _index4 = _interopRequireDefault(__webpack_require__(219));
	var _index5 = _interopRequireDefault(__webpack_require__(148));
	var _index6 = _interopRequireDefault(__webpack_require__(214));
	var _index7 = _interopRequireDefault(__webpack_require__(716));
	var dayPeriodEnum = {
	  am: 'am',
	  pm: 'pm',
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	};
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	 * |  p! | Long localized time            |  P! | Long localized date            |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 * - `P` is long localized date format
	 * - `p` is long localized time format
	 */
	
	var formatters = {
	  // Era
	  G: function G(date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function y(date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear();
	      // Returns 1 for 1 BC (which is year 0 in JavaScript)
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	    return _index7.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function Y(date, token, localize, options) {
	    var signedWeekYear = (0, _index5.default)(date, options);
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
	
	    // Two digit year
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index6.default)(twoDigitYear, 2);
	    }
	
	    // Ordinal number
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    }
	
	    // Padding
	    return (0, _index6.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function R(date, token) {
	    var isoWeekYear = (0, _index3.default)(date);
	
	    // Padding
	    return (0, _index6.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function u(date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index6.default)(year, token.length);
	  },
	  // Quarter
	  Q: function Q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'QQ':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'qq':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function M(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index7.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function L(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	      case 'LL':
	        return (0, _index6.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function w(date, token, localize, options) {
	    var week = (0, _index4.default)(date, options);
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function I(date, token, localize) {
	    var isoWeek = (0, _index2.default)(date);
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function d(date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	    return _index7.default.d(date, token);
	  },
	  // Day of year
	  D: function D(date, token, localize) {
	    var dayOfYear = (0, _index.default)(date);
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	    return (0, _index6.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function E(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function e(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'ee':
	        return (0, _index6.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function c(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'cc':
	        return (0, _index6.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function i(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	      case 'ii':
	        return (0, _index6.default)(isoDayOfWeek, token.length);
	      // 2nd
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function a(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function b(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	    switch (token) {
	      case 'b':
	      case 'bb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function B(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function H(date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function K(date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function k(date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Minute
	  m: function m(date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	    return _index7.default.m(date, token);
	  },
	  // Second
	  s: function s(date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	    return _index7.default.s(date, token);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    return _index7.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function X(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function x(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function O(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function z(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function t(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index6.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function T(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index6.default)(timestamp, token.length);
	  }
	};
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	  var delimiter = dirtyDelimiter || '';
	  return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
	}
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
	  }
	  return formatTimezone(offset, dirtyDelimiter);
	}
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index6.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(214));
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */
	
	var formatters = {
	  // Year
	  y: function y(date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	
	    var signedYear = date.getUTCFullYear();
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function M(date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function d(date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function a(date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return dayPeriodEnumValue.toUpperCase();
	      case 'aaa':
	        return dayPeriodEnumValue;
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function H(date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function m(date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function s(date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	var MILLISECONDS_IN_DAY = 86400000;
	function getUTCDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISODay;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	function setUTCISODay(dirtyDate, dirtyDay) {
	  (0, _index2.default)(2, arguments);
	  var day = (0, _index3.default)(dirtyDay);
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(218));
	var _index4 = _interopRequireDefault(__webpack_require__(11));
	function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(219));
	var _index4 = _interopRequireDefault(__webpack_require__(11));
	function setUTCWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index.default)(dirtyWeek);
	  var diff = (0, _index3.default)(date, options) - week;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(217));
	var _index2 = _interopRequireDefault(__webpack_require__(101));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	function startOfUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(148));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	var _index3 = _interopRequireDefault(__webpack_require__(102));
	var _index4 = _interopRequireDefault(__webpack_require__(25));
	var _index5 = __webpack_require__(66);
	function startOfUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	  var year = (0, _index.default)(dirtyDate, options);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, options);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(151));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	var MILLISECONDS_IN_HOUR = 3600000;
	
	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	function addHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	module.exports = exports.default;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(151));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	var MILLISECONDS_IN_MINUTE = 60000;
	
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	function addMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	module.exports = exports.default;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	var _index = _interopRequireDefault(__webpack_require__(147));
	var _index2 = _interopRequireDefault(__webpack_require__(153));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	var MILLISECONDS_IN_DAY = 86400000;
	
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates. This means that the times are removed
	 * from the dates and then the difference in days is calculated.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 * // How many calendar days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 1
	 */
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
	  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight);
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	module.exports = exports.default;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * const result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	  return yearDiff * 12 + monthDiff;
	}
	module.exports = exports.default;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarYears;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name differenceInCalendarYears
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	var _index = __webpack_require__(66);
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	var _index4 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(1, arguments);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name endOfYear
	 * @category Year Helpers
	 * @summary Return the end of a year for the given date.
	 *
	 * @description
	 * Return the end of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a year for 2 September 2014 11:55:00:
	 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 23:59:59.999
	 */
	function endOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	var _index = _interopRequireDefault(__webpack_require__(226));
	var _index2 = _interopRequireDefault(__webpack_require__(230));
	var _index3 = _interopRequireDefault(__webpack_require__(16));
	var _index4 = _interopRequireDefault(__webpack_require__(715));
	var _index5 = _interopRequireDefault(__webpack_require__(216));
	var _index6 = _interopRequireDefault(__webpack_require__(147));
	var _index7 = __webpack_require__(220);
	var _index8 = _interopRequireDefault(__webpack_require__(25));
	var _index9 = _interopRequireDefault(__webpack_require__(11));
	var _index10 = __webpack_require__(66);
	var _index11 = _interopRequireDefault(__webpack_require__(215));
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
	
	// This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          | a..aa   | AM, PM                            |       |
	 * |                                 | aaa     | am, pm                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
	 * |                                 | bbb     | am, pm, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 001, ..., 999                |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 04/29/1453                        | 7     |
	 * |                                 | PP      | Apr 29, 1453                      | 7     |
	 * |                                 | PPP     | April 29th, 1453                  | 7     |
	 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
	 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */
	
	function format(dirtyDate, dirtyFormatStr, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	  (0, _index9.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var defaultOptions = (0, _index10.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
	  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	  var originalDate = (0, _index3.default)(dirtyDate);
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = (0, _index6.default)(originalDate);
	  var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong);
	    }
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	    var firstCharacter = substring[0];
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	    var formatter = _index4.default[firstCharacter];
	    if (formatter) {
	      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	    return substring;
	  }).join('');
	  return result;
	}
	function cleanEscapedString(input) {
	  var matched = input.match(escapedStringRegExp);
	  if (!matched) {
	    return input;
	  }
	  return matched[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports.default;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDate;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name getDate
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * const result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dayOfMonth = date.getDate();
	  return dayOfMonth;
	}
	module.exports = exports.default;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDay;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * const result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	module.exports = exports.default;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in February 2000?
	 * const result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	module.exports = exports.default;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getHours;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name getHours
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * const result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var hours = date.getHours();
	  return hours;
	}
	module.exports = exports.default;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(154));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name getISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeekYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(154));
	var _index3 = _interopRequireDefault(__webpack_require__(805));
	var _index4 = _interopRequireDefault(__webpack_require__(11));
	var MILLISECONDS_IN_WEEK = 604800000;
	
	/**
	 * @name getISOWeek
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	function getISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMinutes;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name getMinutes
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var minutes = date.getMinutes();
	  return minutes;
	}
	module.exports = exports.default;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMonth;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name getMonth
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * const result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  return month;
	}
	module.exports = exports.default;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQuarter;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name getQuarter
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * const result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var quarter = Math.floor(date.getMonth() / 3) + 1;
	  return quarter;
	}
	module.exports = exports.default;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSeconds;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name getSeconds
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds();
	  return seconds;
	}
	module.exports = exports.default;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTime;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name getTime
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  return timestamp;
	}
	module.exports = exports.default;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name getYear
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * const result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|Number} date - the date that should be after the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() > dateToCompare.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|Number} date - the date that should be before the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() < dateToCompare.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEqual;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * const result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0),
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual(dirtyLeftDate, dirtyRightDate) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyLeftDate);
	  var dateRight = (0, _index.default)(dirtyRightDate);
	  return dateLeft.getTime() === dateRight.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	var _index = _interopRequireDefault(__webpack_require__(153));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day (and year and month)?
	 *
	 * @description
	 * Are the given dates in the same day (and year and month)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day (and year and month)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
	 * //=> true
	 *
	 * @example
	 * // Are 4 September and 4 October in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
	 * //=> false
	 *
	 * @example
	 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
	 * //=> false
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month (and year)?
	 *
	 * @description
	 * Are the given dates in the same month (and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2015 in the same month?
	 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
	 * //=> false
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	module.exports = exports.default;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameQuarter;
	var _index = _interopRequireDefault(__webpack_require__(228));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name isSameQuarter
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same quarter (and year)?
	 *
	 * @description
	 * Are the given dates in the same quarter (and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
	 * //=> true
	 *
	 * @example
	 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
	 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
	 * //=> false
	 */
	function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name isSameYear
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval? (Including start and end.)
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(new Date(2014, 0, 3), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(new Date(2014, 0, 10), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> false
	 *
	 * @example
	 * // For date equal to interval start:
	 * isWithinInterval(date, { start, end: date }) // => true
	 *
	 * @example
	 * // For date equal to interval end:
	 * isWithinInterval(date, { start: date, end }) // => true
	 */
	function isWithinInterval(dirtyDate, interval) {
	  (0, _index2.default)(2, arguments);
	  var time = (0, _index.default)(dirtyDate).getTime();
	  var startTime = (0, _index.default)(interval.start).getTime();
	  var endTime = (0, _index.default)(interval.end).getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  return time >= startTime && time <= endTime;
	}
	module.exports = exports.default;

/***/ },
/* 753 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	function buildFormatLongFn(args) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    // TODO: Remove String()
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	module.exports = exports.default;

/***/ },
/* 754 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, options) {
	    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
	    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
	    return valuesArray[index];
	  };
	}
	module.exports = exports.default;

/***/ },
/* 755 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	function buildMatchFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	    if (!matchResult) {
	      return null;
	    }
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    }) : findKey(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    });
	    var value;
	    value = args.valueCallback ? args.valueCallback(key) : key;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	module.exports = exports.default;

/***/ },
/* 756 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	function buildMatchPatternFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var matchResult = string.match(args.matchPattern);
	    if (!matchResult) return null;
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	    if (!parseResult) return null;
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	module.exports = exports.default;

/***/ },
/* 757 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about 1 week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	var formatDistance = function formatDistance(token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	  return result;
	};
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(753));
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 759 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(754));
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
	};
	
	// Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	
	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`.
	  //
	  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'.
	
	  var rem100 = number % 100;
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	      case 2:
	        return number + 'nd';
	      case 3:
	        return number + 'rd';
	    }
	  }
	  return number + 'th';
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function argumentCallback(quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(755));
	var _index2 = _interopRequireDefault(__webpack_require__(756));
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function valueCallback(value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function valueCallback(index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(757));
	var _index2 = _interopRequireDefault(__webpack_require__(758));
	var _index3 = _interopRequireDefault(__webpack_require__(759));
	var _index4 = _interopRequireDefault(__webpack_require__(760));
	var _index5 = _interopRequireDefault(__webpack_require__(761));
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0 /* Sunday */,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	var _typeof2 = _interopRequireDefault(__webpack_require__(58));
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * const result = max([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray;
	  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	
	    // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if ((0, _typeof2.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	module.exports = exports.default;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	var _typeof2 = _interopRequireDefault(__webpack_require__(58));
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Returns the earliest of the given dates.
	 *
	 * @description
	 * Returns the earliest of the given dates.
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} - the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * const result = min([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray;
	  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	    // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if ((0, _typeof2.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	module.exports = exports.default;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseISO;
	var _index = __webpack_require__(224);
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * const result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * const result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function parseISO(argument, options) {
	  var _options$additionalDi;
	  (0, _index2.default)(1, arguments);
	  var additionalDigits = (0, _index3.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	  var dateStrings = splitDateString(argument);
	  var date;
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	  if (!date || isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	    if (isNaN(time)) {
	      return new Date(NaN);
	    }
	  }
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var dirtyDate = new Date(timestamp + time);
	    // js parsed string assuming it's in UTC timezone
	    // but we need it to be parsed in our timezone
	    // so we use utc values to build date in our timezone.
	    // Year values from 0 to 99 map to the years 1900 to 1999
	    // so set year explicitly with setFullYear.
	    var result = new Date(0);
	    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
	    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
	    return result;
	  }
	  return new Date(timestamp + time + offset);
	}
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString;
	
	  // The regex match should only return at maximum two array elements.
	  // [date], [time], or [date, time].
	  if (array.length > 2) {
	    return dateStrings;
	  }
	  if (/:/.test(array[0])) {
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	  return dateStrings;
	}
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex);
	  // Invalid ISO-formatted year
	  if (!captures) return {
	    year: NaN,
	    restDateString: ''
	  };
	  var year = captures[1] ? parseInt(captures[1]) : null;
	  var century = captures[2] ? parseInt(captures[2]) : null;
	
	  // either year or century is null, not both
	  return {
	    year: century === null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return new Date(NaN);
	  var captures = dateString.match(dateRegex);
	  // Invalid ISO-formatted string
	  if (!captures) return new Date(NaN);
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return NaN; // Invalid ISO-formatted time
	
	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	  return hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * 1000;
	}
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	  return sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute);
	}
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	// Validation functions
	
	// February is null to handle the leap year (using ||)
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	module.exports = exports.default;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AMPMMidnightParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(AMPMMidnightParser, _Parser);
	  var _super = (0, _createSuper2.default)(AMPMMidnightParser);
	  function AMPMMidnightParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, AMPMMidnightParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(AMPMMidnightParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'b':
	        case 'bb':
	        case 'bbb':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'bbbbb':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'bbbb':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return AMPMMidnightParser;
	}(_Parser2.Parser);
	exports.AMPMMidnightParser = AMPMMidnightParser;

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AMPMParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var AMPMParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(AMPMParser, _Parser);
	  var _super = (0, _createSuper2.default)(AMPMParser);
	  function AMPMParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, AMPMParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(AMPMParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'a':
	        case 'aa':
	        case 'aaa':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'aaaaa':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'aaaa':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return AMPMParser;
	}(_Parser2.Parser);
	exports.AMPMParser = AMPMParser;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DateParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _utils = __webpack_require__(29);
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	// Day of the month
	var DateParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DateParser, _Parser);
	  var _super = (0, _createSuper2.default)(DateParser);
	  function DateParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DateParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subPriority", 1);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DateParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'd':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.date, dateString);
	        case 'do':
	          return match.ordinalNumber(dateString, {
	            unit: 'date'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(date, value) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = (0, _utils.isLeapYearIndex)(year);
	      var month = date.getUTCMonth();
	      if (isLeapYear) {
	        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
	      } else {
	        return value >= 1 && value <= DAYS_IN_MONTH[month];
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCDate(value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DateParser;
	}(_Parser2.Parser);
	exports.DateParser = DateParser;

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayOfYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	var DayOfYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayOfYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayOfYearParser);
	  function DayOfYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayOfYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subpriority", 1);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayOfYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'D':
	        case 'DD':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.dayOfYear, dateString);
	        case 'Do':
	          return match.ordinalNumber(dateString, {
	            unit: 'date'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(date, value) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = (0, _utils.isLeapYearIndex)(year);
	      if (isLeapYear) {
	        return value >= 1 && value <= 366;
	      } else {
	        return value >= 1 && value <= 365;
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(0, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayOfYearParser;
	}(_Parser2.Parser);
	exports.DayOfYearParser = DayOfYearParser;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _index = _interopRequireDefault(__webpack_require__(149));
	// Day of week
	var DayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayParser);
	  function DayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // Tue
	        case 'E':
	        case 'EE':
	        case 'EEE':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	        case 'EEEEE':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	        case 'EEEEEE':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	        case 'EEEE':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayParser;
	}(_Parser2.Parser);
	exports.DayParser = DayParser;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayPeriodParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	// in the morning, in the afternoon, in the evening, at night
	var DayPeriodParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayPeriodParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayPeriodParser);
	  function DayPeriodParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayPeriodParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayPeriodParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'B':
	        case 'BB':
	        case 'BBB':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'BBBBB':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'BBBB':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayPeriodParser;
	}(_Parser2.Parser);
	exports.DayPeriodParser = DayPeriodParser;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EraParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var EraParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(EraParser, _Parser);
	  var _super = (0, _createSuper2.default)(EraParser);
	  function EraParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, EraParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 140);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(EraParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // AD, BC
	        case 'G':
	        case 'GG':
	        case 'GGG':
	          return match.era(dateString, {
	            width: 'abbreviated'
	          }) || match.era(dateString, {
	            width: 'narrow'
	          });
	        // A, B
	        case 'GGGGG':
	          return match.era(dateString, {
	            width: 'narrow'
	          });
	        // Anno Domini, Before Christ
	        case 'GGGG':
	        default:
	          return match.era(dateString, {
	            width: 'wide'
	          }) || match.era(dateString, {
	            width: 'abbreviated'
	          }) || match.era(dateString, {
	            width: 'narrow'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      flags.era = value;
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return EraParser;
	}(_Parser2.Parser);
	exports.EraParser = EraParser;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExtendedYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ExtendedYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(ExtendedYearParser);
	  function ExtendedYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ExtendedYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ExtendedYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      if (token === 'u') {
	        return (0, _utils.parseNDigitsSigned)(4, dateString);
	      }
	      return (0, _utils.parseNDigitsSigned)(token.length, dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return ExtendedYearParser;
	}(_Parser2.Parser);
	exports.ExtendedYearParser = ExtendedYearParser;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FractionOfSecondParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(FractionOfSecondParser, _Parser);
	  var _super = (0, _createSuper2.default)(FractionOfSecondParser);
	  function FractionOfSecondParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, FractionOfSecondParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 30);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(FractionOfSecondParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      var valueCallback = function valueCallback(value) {
	        return Math.floor(value * Math.pow(10, -token.length + 3));
	      };
	      return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMilliseconds(value);
	      return date;
	    }
	  }]);
	  return FractionOfSecondParser;
	}(_Parser2.Parser);
	exports.FractionOfSecondParser = FractionOfSecondParser;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour0To11Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour0To11Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour0To11Parser);
	  function Hour0To11Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour0To11Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour0To11Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'K':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour11h, dateString);
	        case 'Ko':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var isPM = date.getUTCHours() >= 12;
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	      return date;
	    }
	  }]);
	  return Hour0To11Parser;
	}(_Parser2.Parser);
	exports.Hour0To11Parser = Hour0To11Parser;

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour0to23Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour0to23Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour0to23Parser);
	  function Hour0to23Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour0to23Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour0to23Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'H':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour23h, dateString);
	        case 'Ho':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 23;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours(value, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return Hour0to23Parser;
	}(_Parser2.Parser);
	exports.Hour0to23Parser = Hour0to23Parser;

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour1To24Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour1To24Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour1To24Parser);
	  function Hour1To24Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour1To24Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour1To24Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'k':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour24h, dateString);
	        case 'ko':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 24;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var hours = value <= 24 ? value % 24 : value;
	      date.setUTCHours(hours, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return Hour1To24Parser;
	}(_Parser2.Parser);
	exports.Hour1To24Parser = Hour1To24Parser;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour1to12Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour1to12Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour1to12Parser);
	  function Hour1to12Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour1to12Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour1to12Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'h':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour12h, dateString);
	        case 'ho':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 12;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var isPM = date.getUTCHours() >= 12;
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else if (!isPM && value === 12) {
	        date.setUTCHours(0, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	      return date;
	    }
	  }]);
	  return Hour1to12Parser;
	}(_Parser2.Parser);
	exports.Hour1to12Parser = Hour1to12Parser;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISODayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var _index = _interopRequireDefault(__webpack_require__(718));
	// ISO day of week
	var ISODayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISODayParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISODayParser);
	  function ISODayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISODayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISODayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        if (value === 0) {
	          return 7;
	        }
	        return value;
	      };
	      switch (token) {
	        // 2
	        case 'i':
	        case 'ii':
	          // 02
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 2nd
	        case 'io':
	          return match.ordinalNumber(dateString, {
	            unit: 'day'
	          });
	        // Tue
	        case 'iii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // T
	        case 'iiiii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // Tu
	        case 'iiiiii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // Tuesday
	        case 'iiii':
	        default:
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 7;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date = (0, _index.default)(date, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return ISODayParser;
	}(_Parser2.Parser);
	exports.ISODayParser = ISODayParser;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOTimezoneParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	// Timezone (ISO-8601)
	var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOTimezoneParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOTimezoneParser);
	  function ISOTimezoneParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOTimezoneParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 10);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T', 'X']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOTimezoneParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      switch (token) {
	        case 'x':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
	        case 'xx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
	        case 'xxxx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
	        case 'xxxxx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
	        case 'xxx':
	        default:
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      return new Date(date.getTime() - value);
	    }
	  }]);
	  return ISOTimezoneParser;
	}(_Parser2.Parser);
	exports.ISOTimezoneParser = ISOTimezoneParser;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOTimezoneWithZParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	// Timezone (ISO-8601. +00:00 is `'Z'`)
	var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOTimezoneWithZParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOTimezoneWithZParser);
	  function ISOTimezoneWithZParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOTimezoneWithZParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 10);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T', 'x']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOTimezoneWithZParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      switch (token) {
	        case 'X':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
	        case 'XX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
	        case 'XXXX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
	        case 'XXXXX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
	        case 'XXX':
	        default:
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      return new Date(date.getTime() - value);
	    }
	  }]);
	  return ISOTimezoneWithZParser;
	}(_Parser2.Parser);
	exports.ISOTimezoneWithZParser = ISOTimezoneWithZParser;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOWeekParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	var _index = _interopRequireDefault(__webpack_require__(719));
	var _index2 = _interopRequireDefault(__webpack_require__(101));
	// ISO week of year
	var ISOWeekParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOWeekParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOWeekParser);
	  function ISOWeekParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOWeekParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 100);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOWeekParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'I':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
	        case 'Io':
	          return match.ordinalNumber(dateString, {
	            unit: 'week'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 53;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      return (0, _index2.default)((0, _index.default)(date, value));
	    }
	  }]);
	  return ISOWeekParser;
	}(_Parser2.Parser);
	exports.ISOWeekParser = ISOWeekParser;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOWeekYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var _index = _interopRequireDefault(__webpack_require__(101));
	// ISO week-numbering year
	var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOWeekYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOWeekYearParser);
	  function ISOWeekYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOWeekYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOWeekYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      if (token === 'R') {
	        return (0, _utils.parseNDigitsSigned)(4, dateString);
	      }
	      return (0, _utils.parseNDigitsSigned)(token.length, dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      var firstWeekOfYear = new Date(0);
	      firstWeekOfYear.setUTCFullYear(value, 0, 4);
	      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
	      return (0, _index.default)(firstWeekOfYear);
	    }
	  }]);
	  return ISOWeekYearParser;
	}(_Parser2.Parser);
	exports.ISOWeekYearParser = ISOWeekYearParser;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalDayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var _index = _interopRequireDefault(__webpack_require__(149));
	// Local day of week
	var LocalDayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalDayParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalDayParser);
	  function LocalDayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalDayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalDayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match, options) {
	      var valueCallback = function valueCallback(value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	      switch (token) {
	        // 3
	        case 'e':
	        case 'ee':
	          // 03
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	        // 3rd
	        case 'eo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'day'
	          }), valueCallback);
	        // Tue
	        case 'eee':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	        case 'eeeee':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	        case 'eeeeee':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	        case 'eeee':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return LocalDayParser;
	}(_Parser2.Parser);
	exports.LocalDayParser = LocalDayParser;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalWeekParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	var _index = _interopRequireDefault(__webpack_require__(720));
	var _index2 = _interopRequireDefault(__webpack_require__(102));
	// Local week of year
	var LocalWeekParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalWeekParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalWeekParser);
	  function LocalWeekParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalWeekParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 100);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalWeekParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'w':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
	        case 'wo':
	          return match.ordinalNumber(dateString, {
	            unit: 'week'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 53;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      return (0, _index2.default)((0, _index.default)(date, value, options), options);
	    }
	  }]);
	  return LocalWeekParser;
	}(_Parser2.Parser);
	exports.LocalWeekParser = LocalWeekParser;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalWeekYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var _index = _interopRequireDefault(__webpack_require__(148));
	var _index2 = _interopRequireDefault(__webpack_require__(102));
	// Local week-numbering year
	var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalWeekYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalWeekYearParser);
	  function LocalWeekYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalWeekYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalWeekYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'YY'
	        };
	      };
	      switch (token) {
	        case 'Y':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
	        case 'Yo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'year'
	          }), valueCallback);
	        default:
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value.isTwoDigitYear || value.year > 0;
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value, options) {
	      var currentYear = (0, _index.default)(date, options);
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
	        date.setUTCHours(0, 0, 0, 0);
	        return (0, _index2.default)(date, options);
	      }
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
	      date.setUTCHours(0, 0, 0, 0);
	      return (0, _index2.default)(date, options);
	    }
	  }]);
	  return LocalWeekYearParser;
	}(_Parser2.Parser);
	exports.LocalWeekYearParser = LocalWeekYearParser;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MinuteParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	var MinuteParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(MinuteParser, _Parser);
	  var _super = (0, _createSuper2.default)(MinuteParser);
	  function MinuteParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, MinuteParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 60);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(MinuteParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'm':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.minute, dateString);
	        case 'mo':
	          return match.ordinalNumber(dateString, {
	            unit: 'minute'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 59;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMinutes(value, 0, 0);
	      return date;
	    }
	  }]);
	  return MinuteParser;
	}(_Parser2.Parser);
	exports.MinuteParser = MinuteParser;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MonthParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _utils = __webpack_require__(29);
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var MonthParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(MonthParser, _Parser);
	  var _super = (0, _createSuper2.default)(MonthParser);
	  function MonthParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, MonthParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 110);
	    return _this;
	  }
	  (0, _createClass2.default)(MonthParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        return value - 1;
	      };
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'M':
	          return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
	        // 01, 02, ..., 12
	        case 'MM':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
	        // 1st, 2nd, ..., 12th
	        case 'Mo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'month'
	          }), valueCallback);
	        // Jan, Feb, ..., Dec
	        case 'MMM':
	          return match.month(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // J, F, ..., D
	        case 'MMMMM':
	          return match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // January, February, ..., December
	        case 'MMMM':
	        default:
	          return match.month(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return MonthParser;
	}(_Parser2.Parser);
	exports.MonthParser = MonthParser;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuarterParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var QuarterParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(QuarterParser, _Parser);
	  var _super = (0, _createSuper2.default)(QuarterParser);
	  function QuarterParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, QuarterParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 120);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(QuarterParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'Q':
	        case 'QQ':
	          // 01, 02, 03, 04
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 1st, 2nd, 3rd, 4th
	        case 'Qo':
	          return match.ordinalNumber(dateString, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	        case 'QQQ':
	          return match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	        case 'QQQQQ':
	          return match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1st quarter, 2nd quarter, ...
	        case 'QQQQ':
	        default:
	          return match.quarter(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 4;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return QuarterParser;
	}(_Parser2.Parser);
	exports.QuarterParser = QuarterParser;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SecondParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	var SecondParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(SecondParser, _Parser);
	  var _super = (0, _createSuper2.default)(SecondParser);
	  function SecondParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, SecondParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 50);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(SecondParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 's':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.second, dateString);
	        case 'so':
	          return match.ordinalNumber(dateString, {
	            unit: 'second'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 59;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCSeconds(value, 0);
	      return date;
	    }
	  }]);
	  return SecondParser;
	}(_Parser2.Parser);
	exports.SecondParser = SecondParser;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneLocalDayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var _index = _interopRequireDefault(__webpack_require__(149));
	// Stand-alone local day of week
	var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneLocalDayParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneLocalDayParser);
	  function StandAloneLocalDayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneLocalDayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneLocalDayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match, options) {
	      var valueCallback = function valueCallback(value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	      switch (token) {
	        // 3
	        case 'c':
	        case 'cc':
	          // 03
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	        // 3rd
	        case 'co':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'day'
	          }), valueCallback);
	        // Tue
	        case 'ccc':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // T
	        case 'ccccc':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tu
	        case 'cccccc':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tuesday
	        case 'cccc':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneLocalDayParser;
	}(_Parser2.Parser);
	exports.StandAloneLocalDayParser = StandAloneLocalDayParser;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneMonthParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _constants = __webpack_require__(47);
	var _utils = __webpack_require__(29);
	var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneMonthParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneMonthParser);
	  function StandAloneMonthParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneMonthParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 110);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneMonthParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        return value - 1;
	      };
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'L':
	          return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
	        // 01, 02, ..., 12
	        case 'LL':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
	        // 1st, 2nd, ..., 12th
	        case 'Lo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'month'
	          }), valueCallback);
	        // Jan, Feb, ..., Dec
	        case 'LLL':
	          return match.month(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // J, F, ..., D
	        case 'LLLLL':
	          return match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // January, February, ..., December
	        case 'LLLL':
	        default:
	          return match.month(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneMonthParser;
	}(_Parser2.Parser);
	exports.StandAloneMonthParser = StandAloneMonthParser;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneQuarterParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneQuarterParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneQuarterParser);
	  function StandAloneQuarterParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneQuarterParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 120);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneQuarterParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'q':
	        case 'qq':
	          // 01, 02, 03, 04
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 1st, 2nd, 3rd, 4th
	        case 'qo':
	          return match.ordinalNumber(dateString, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	        case 'qqq':
	          return match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	        case 'qqqqq':
	          return match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1st quarter, 2nd quarter, ...
	        case 'qqqq':
	        default:
	          return match.quarter(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 4;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneQuarterParser;
	}(_Parser2.Parser);
	exports.StandAloneQuarterParser = StandAloneQuarterParser;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimestampMillisecondsParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(TimestampMillisecondsParser, _Parser);
	  var _super = (0, _createSuper2.default)(TimestampMillisecondsParser);
	  function TimestampMillisecondsParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, TimestampMillisecondsParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 20);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", '*');
	    return _this;
	  }
	  (0, _createClass2.default)(TimestampMillisecondsParser, [{
	    key: "parse",
	    value: function parse(dateString) {
	      return (0, _utils.parseAnyDigitsSigned)(dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      return [new Date(value), {
	        timestampIsSet: true
	      }];
	    }
	  }]);
	  return TimestampMillisecondsParser;
	}(_Parser2.Parser);
	exports.TimestampMillisecondsParser = TimestampMillisecondsParser;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimestampSecondsParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(TimestampSecondsParser, _Parser);
	  var _super = (0, _createSuper2.default)(TimestampSecondsParser);
	  function TimestampSecondsParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, TimestampSecondsParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 40);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", '*');
	    return _this;
	  }
	  (0, _createClass2.default)(TimestampSecondsParser, [{
	    key: "parse",
	    value: function parse(dateString) {
	      return (0, _utils.parseAnyDigitsSigned)(dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      return [new Date(value * 1000), {
	        timestampIsSet: true
	      }];
	    }
	  }]);
	  return TimestampSecondsParser;
	}(_Parser2.Parser);
	exports.TimestampSecondsParser = TimestampSecondsParser;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(27));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	var _Parser2 = __webpack_require__(28);
	var _utils = __webpack_require__(29);
	// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
	// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	// |----------|-------|----|-------|-------|-------|
	// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	var YearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(YearParser, _Parser);
	  var _super = (0, _createSuper2.default)(YearParser);
	  function YearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, YearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(YearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'yy'
	        };
	      };
	      switch (token) {
	        case 'y':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
	        case 'yo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'year'
	          }), valueCallback);
	        default:
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value.isTwoDigitYear || value.year > 0;
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      var currentYear = date.getUTCFullYear();
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
	        date.setUTCHours(0, 0, 0, 0);
	        return date;
	      }
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return YearParser;
	}(_Parser2.Parser);
	exports.YearParser = YearParser;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parsers = void 0;
	var _EraParser = __webpack_require__(772);
	var _YearParser = __webpack_require__(796);
	var _LocalWeekYearParser = __webpack_require__(786);
	var _ISOWeekYearParser = __webpack_require__(783);
	var _ExtendedYearParser = __webpack_require__(773);
	var _QuarterParser = __webpack_require__(789);
	var _StandAloneQuarterParser = __webpack_require__(793);
	var _MonthParser = __webpack_require__(788);
	var _StandAloneMonthParser = __webpack_require__(792);
	var _LocalWeekParser = __webpack_require__(785);
	var _ISOWeekParser = __webpack_require__(782);
	var _DateParser = __webpack_require__(768);
	var _DayOfYearParser = __webpack_require__(769);
	var _DayParser = __webpack_require__(770);
	var _LocalDayParser = __webpack_require__(784);
	var _StandAloneLocalDayParser = __webpack_require__(791);
	var _ISODayParser = __webpack_require__(779);
	var _AMPMParser = __webpack_require__(767);
	var _AMPMMidnightParser = __webpack_require__(766);
	var _DayPeriodParser = __webpack_require__(771);
	var _Hour1to12Parser = __webpack_require__(778);
	var _Hour0to23Parser = __webpack_require__(776);
	var _Hour0To11Parser = __webpack_require__(775);
	var _Hour1To24Parser = __webpack_require__(777);
	var _MinuteParser = __webpack_require__(787);
	var _SecondParser = __webpack_require__(790);
	var _FractionOfSecondParser = __webpack_require__(774);
	var _ISOTimezoneWithZParser = __webpack_require__(781);
	var _ISOTimezoneParser = __webpack_require__(780);
	var _TimestampSecondsParser = __webpack_require__(795);
	var _TimestampMillisecondsParser = __webpack_require__(794);
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
	 * |  p  |                                |  P  |                                |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 */
	var parsers = {
	  G: new _EraParser.EraParser(),
	  y: new _YearParser.YearParser(),
	  Y: new _LocalWeekYearParser.LocalWeekYearParser(),
	  R: new _ISOWeekYearParser.ISOWeekYearParser(),
	  u: new _ExtendedYearParser.ExtendedYearParser(),
	  Q: new _QuarterParser.QuarterParser(),
	  q: new _StandAloneQuarterParser.StandAloneQuarterParser(),
	  M: new _MonthParser.MonthParser(),
	  L: new _StandAloneMonthParser.StandAloneMonthParser(),
	  w: new _LocalWeekParser.LocalWeekParser(),
	  I: new _ISOWeekParser.ISOWeekParser(),
	  d: new _DateParser.DateParser(),
	  D: new _DayOfYearParser.DayOfYearParser(),
	  E: new _DayParser.DayParser(),
	  e: new _LocalDayParser.LocalDayParser(),
	  c: new _StandAloneLocalDayParser.StandAloneLocalDayParser(),
	  i: new _ISODayParser.ISODayParser(),
	  a: new _AMPMParser.AMPMParser(),
	  b: new _AMPMMidnightParser.AMPMMidnightParser(),
	  B: new _DayPeriodParser.DayPeriodParser(),
	  h: new _Hour1to12Parser.Hour1to12Parser(),
	  H: new _Hour0to23Parser.Hour0to23Parser(),
	  K: new _Hour0To11Parser.Hour0To11Parser(),
	  k: new _Hour1To24Parser.Hour1To24Parser(),
	  m: new _MinuteParser.MinuteParser(),
	  s: new _SecondParser.SecondParser(),
	  S: new _FractionOfSecondParser.FractionOfSecondParser(),
	  X: new _ISOTimezoneWithZParser.ISOTimezoneWithZParser(),
	  x: new _ISOTimezoneParser.ISOTimezoneParser(),
	  t: new _TimestampSecondsParser.TimestampSecondsParser(),
	  T: new _TimestampMillisecondsParser.TimestampMillisecondsParser()
	};
	exports.parsers = parsers;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;
	var _typeof2 = _interopRequireDefault(__webpack_require__(58));
	var _createForOfIteratorHelper2 = _interopRequireDefault(__webpack_require__(462));
	var _index = _interopRequireDefault(__webpack_require__(215));
	var _index2 = _interopRequireDefault(__webpack_require__(230));
	var _index3 = _interopRequireDefault(__webpack_require__(16));
	var _index4 = _interopRequireDefault(__webpack_require__(714));
	var _index5 = _interopRequireDefault(__webpack_require__(216));
	var _index6 = _interopRequireDefault(__webpack_require__(147));
	var _index7 = __webpack_require__(220);
	var _index8 = _interopRequireDefault(__webpack_require__(25));
	var _index9 = _interopRequireDefault(__webpack_require__(11));
	var _Setter = __webpack_require__(227);
	var _index10 = __webpack_require__(797);
	var _index11 = __webpack_require__(66);
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
	
	// This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
	 *
	 * `referenceDate` must be passed for correct work of the function.
	 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	  (0, _index9.default)(3, arguments);
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var defaultOptions = (0, _index11.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index.default;
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyReferenceDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale
	  };
	
	  // If timezone isn't specified, it will be set to the system timezone
	  var setters = [new _Setter.DateToSystemTimezoneSetter()];
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	    if (firstCharacter in _index5.default) {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong);
	    }
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	  var _iterator = (0, _createForOfIteratorHelper2.default)(tokens),
	    _step;
	  try {
	    var _loop = function _loop() {
	      var token = _step.value;
	      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(token)) {
	        (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	      }
	      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(token)) {
	        (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	      }
	      var firstCharacter = token[0];
	      var parser = _index10.parsers[firstCharacter];
	      if (parser) {
	        var incompatibleTokens = parser.incompatibleTokens;
	        if (Array.isArray(incompatibleTokens)) {
	          var incompatibleToken = usedTokens.find(function (usedToken) {
	            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
	          });
	          if (incompatibleToken) {
	            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	          }
	        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
	          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	        }
	        usedTokens.push({
	          token: firstCharacter,
	          fullToken: token
	        });
	        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
	        if (!parseResult) {
	          return {
	            v: new Date(NaN)
	          };
	        }
	        setters.push(parseResult.setter);
	        dateString = parseResult.rest;
	      } else {
	        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	        }
	
	        // Replace two single quote characters with one single quote character
	        if (token === "''") {
	          token = "'";
	        } else if (firstCharacter === "'") {
	          token = cleanEscapedString(token);
	        }
	
	        // Cut token from string, or, if string doesn't match the token, return Invalid Date
	        if (dateString.indexOf(token) === 0) {
	          dateString = dateString.slice(token.length);
	        } else {
	          return {
	            v: new Date(NaN)
	          };
	        }
	      }
	    };
	    for (_iterator.s(); !(_step = _iterator.n()).done;) {
	      var _ret = _loop();
	      if ((0, _typeof2.default)(_ret) === "object") return _ret.v;
	    }
	
	    // Check if the remaining input contains something other than whitespace
	  } catch (err) {
	    _iterator.e(err);
	  } finally {
	    _iterator.f();
	  }
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).sort(function (a, b) {
	      return b.subPriority - a.subPriority;
	    });
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyReferenceDate);
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	  var _iterator2 = (0, _createForOfIteratorHelper2.default)(uniquePrioritySetters),
	    _step2;
	  try {
	    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	      var setter = _step2.value;
	      if (!setter.validate(utcDate, subFnOptions)) {
	        return new Date(NaN);
	      }
	      var result = setter.set(utcDate, flags, subFnOptions);
	      // Result is tuple (date, flags)
	      if (Array.isArray(result)) {
	        utcDate = result[0];
	        (0, _index4.default)(flags, result[1]);
	        // Result is date
	      } else {
	        utcDate = result;
	      }
	    }
	  } catch (err) {
	    _iterator2.e(err);
	  } finally {
	    _iterator2.f();
	  }
	  return utcDate;
	}
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports.default;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setHours;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name setHours
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours(dirtyDate, dirtyHours) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var hours = (0, _index.default)(dirtyHours);
	  date.setHours(hours);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMinutes;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name setMinutes
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes(dirtyDate, dirtyMinutes) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var minutes = (0, _index.default)(dirtyMinutes);
	  date.setMinutes(minutes);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setQuarter;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(152));
	var _index4 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name setQuarter
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * const result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter(dirtyDate, dirtyQuarter) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var quarter = (0, _index.default)(dirtyQuarter);
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
	  var diff = quarter - oldQuarter;
	  return (0, _index3.default)(date, date.getMonth() + diff * 3);
	}
	module.exports = exports.default;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setSeconds;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name setSeconds
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds(dirtyDate, dirtySeconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var seconds = (0, _index.default)(dirtySeconds);
	  date.setSeconds(seconds);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * const result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = (0, _index.default)(dirtyYear);
	
	  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  date.setFullYear(year);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = set;
	var _typeof2 = _interopRequireDefault(__webpack_require__(58));
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(152));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	var _index4 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name set
	 * @category Common Helpers
	 * @summary Set date values to a given date.
	 *
	 * @description
	 * Set date values to a given date.
	 *
	 * Sets time values to date from object `values`.
	 * A value is not set if it is undefined or null or doesn't exist in `values`.
	 *
	 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
	 * to use native `Date#setX` methods. If you use this function, you may not want to include the
	 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Object} values - an object with options
	 * @param {Number} [values.year] - the number of years to be set
	 * @param {Number} [values.month] - the number of months to be set
	 * @param {Number} [values.date] - the number of days to be set
	 * @param {Number} [values.hours] - the number of hours to be set
	 * @param {Number} [values.minutes] - the number of minutes to be set
	 * @param {Number} [values.seconds] - the number of seconds to be set
	 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
	 * @returns {Date} the new date with options set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `values` must be an object
	 *
	 * @example
	 * // Transform 1 September 2014 into 20 October 2015 in a single line:
	 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
	 * //=> Tue Oct 20 2015 00:00:00
	 *
	 * @example
	 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
	 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
	 * //=> Mon Sep 01 2014 12:23:45
	 */
	function set(dirtyDate, values) {
	  (0, _index4.default)(2, arguments);
	  if ((0, _typeof2.default)(values) !== 'object' || values === null) {
	    throw new RangeError('values parameter must be an object');
	  }
	  var date = (0, _index.default)(dirtyDate);
	
	  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  if (values.year != null) {
	    date.setFullYear(values.year);
	  }
	  if (values.month != null) {
	    date = (0, _index2.default)(date, values.month);
	  }
	  if (values.date != null) {
	    date.setDate((0, _index3.default)(values.date));
	  }
	  if (values.hours != null) {
	    date.setHours((0, _index3.default)(values.hours));
	  }
	  if (values.minutes != null) {
	    date.setMinutes((0, _index3.default)(values.minutes));
	  }
	  if (values.seconds != null) {
	    date.setSeconds((0, _index3.default)(values.seconds));
	  }
	  if (values.milliseconds != null) {
	    date.setMilliseconds((0, _index3.default)(values.milliseconds));
	  }
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(737));
	var _index2 = _interopRequireDefault(__webpack_require__(154));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name startOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name startOfYear
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var cleanDate = (0, _index.default)(dirtyDate);
	  var date = new Date(0);
	  date.setFullYear(cleanDate.getFullYear(), 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subDays;
	var _index = _interopRequireDefault(__webpack_require__(150));
	var _index2 = _interopRequireDefault(__webpack_require__(11));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * const result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMonths;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(115));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * const result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subQuarters;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(221));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name subQuarters
	 * @category Quarter Helpers
	 * @summary Subtract the specified number of year quarters from the given date.
	 *
	 * @description
	 * Subtract the specified number of year quarters from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 3 quarters from 1 September 2014:
	 * const result = subQuarters(new Date(2014, 8, 1), 3)
	 * //=> Sun Dec 01 2013 00:00:00
	 */
	function subQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subWeeks;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(222));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * const result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subYears;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(223));
	var _index3 = _interopRequireDefault(__webpack_require__(11));
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * const result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(815));
	
	/**
	 * Adds a CSS class to a given element.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 814 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 815 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	/**
	 * Checks if a given element has a CSS class.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);
	  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 816 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClass;
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	/**
	 * Removes a CSS class from a given element.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	
	
	function removeClass(element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else if (typeof element.className === 'string') {
	    element.className = replaceClassName(element.className, className);
	  } else {
	    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _canUseDOM = _interopRequireDefault(__webpack_require__(814));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_canUseDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	var ElementType = __webpack_require__(819);
	var entities = __webpack_require__(821);
	
	/* mixed-case SVG and MathML tags & attributes
	   recognized by the HTML parser, see
	   https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
	*/
	var foreignNames = __webpack_require__(853);
	foreignNames.elementNames.__proto__ = null; /* use as a simple dictionary */
	foreignNames.attributeNames.__proto__ = null;
	
	var unencodedElements = {
	  __proto__: null,
	  style: true,
	  script: true,
	  xmp: true,
	  iframe: true,
	  noembed: true,
	  noframes: true,
	  plaintext: true,
	  noscript: true
	};
	
	/*
	  Format attributes
	*/
	function formatAttrs(attributes, opts) {
	  if (!attributes) return;
	
	  var output = '';
	  var value;
	
	  // Loop through the attributes
	  for (var key in attributes) {
	    value = attributes[key];
	    if (output) {
	      output += ' ';
	    }
	
	    if (opts.xmlMode === 'foreign') {
	      /* fix up mixed-case attribute names */
	      key = foreignNames.attributeNames[key] || key;
	    }
	    output += key;
	    if ((value !== null && value !== '') || opts.xmlMode) {
	      output +=
	        '="' +
	        (opts.decodeEntities
	          ? entities.encodeXML(value)
	          : value.replace(/\"/g, '&quot;')) +
	        '"';
	    }
	  }
	
	  return output;
	}
	
	/*
	  Self-enclosing tags (stolen from node-htmlparser)
	*/
	var singleTag = {
	  __proto__: null,
	  area: true,
	  base: true,
	  basefont: true,
	  br: true,
	  col: true,
	  command: true,
	  embed: true,
	  frame: true,
	  hr: true,
	  img: true,
	  input: true,
	  isindex: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	};
	
	var render = (module.exports = function(dom, opts) {
	  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
	  opts = opts || {};
	
	  var output = '';
	
	  for (var i = 0; i < dom.length; i++) {
	    var elem = dom[i];
	
	    if (elem.type === 'root') output += render(elem.children, opts);
	    else if (ElementType.isTag(elem)) output += renderTag(elem, opts);
	    else if (elem.type === ElementType.Directive)
	      output += renderDirective(elem);
	    else if (elem.type === ElementType.Comment) output += renderComment(elem);
	    else if (elem.type === ElementType.CDATA) output += renderCdata(elem);
	    else output += renderText(elem, opts);
	  }
	
	  return output;
	});
	
	var foreignModeIntegrationPoints = [
	  'mi',
	  'mo',
	  'mn',
	  'ms',
	  'mtext',
	  'annotation-xml',
	  'foreignObject',
	  'desc',
	  'title'
	];
	
	function renderTag(elem, opts) {
	  // Handle SVG / MathML in HTML
	  if (opts.xmlMode === 'foreign') {
	    /* fix up mixed-case element names */
	    elem.name = foreignNames.elementNames[elem.name] || elem.name;
	    /* exit foreign mode at integration points */
	    if (
	      elem.parent &&
	      foreignModeIntegrationPoints.indexOf(elem.parent.name) >= 0
	    )
	      opts = Object.assign({}, opts, { xmlMode: false });
	  }
	  if (!opts.xmlMode && ['svg', 'math'].indexOf(elem.name) >= 0) {
	    opts = Object.assign({}, opts, { xmlMode: 'foreign' });
	  }
	
	  var tag = '<' + elem.name;
	  var attribs = formatAttrs(elem.attribs, opts);
	
	  if (attribs) {
	    tag += ' ' + attribs;
	  }
	
	  if (opts.xmlMode && (!elem.children || elem.children.length === 0)) {
	    tag += '/>';
	  } else {
	    tag += '>';
	    if (elem.children) {
	      tag += render(elem.children, opts);
	    }
	
	    if (!singleTag[elem.name] || opts.xmlMode) {
	      tag += '</' + elem.name + '>';
	    }
	  }
	
	  return tag;
	}
	
	function renderDirective(elem) {
	  return '<' + elem.data + '>';
	}
	
	function renderText(elem, opts) {
	  var data = elem.data || '';
	
	  // if entities weren't decoded, no need to encode them back
	  if (
	    opts.decodeEntities &&
	    !(elem.parent && elem.parent.name in unencodedElements)
	  ) {
	    data = entities.encodeXML(data);
	  }
	
	  return data;
	}
	
	function renderCdata(elem) {
	  return '<![CDATA[' + elem.children[0].data + ']]>';
	}
	
	function renderComment(elem) {
	  return '<!--' + elem.data + '-->';
	}


/***/ },
/* 819 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
	/** Types of elements found in htmlparser2's DOM */
	var ElementType;
	(function (ElementType) {
	    /** Type for the root element of a document */
	    ElementType["Root"] = "root";
	    /** Type for Text */
	    ElementType["Text"] = "text";
	    /** Type for <? ... ?> */
	    ElementType["Directive"] = "directive";
	    /** Type for <!-- ... --> */
	    ElementType["Comment"] = "comment";
	    /** Type for <script> tags */
	    ElementType["Script"] = "script";
	    /** Type for <style> tags */
	    ElementType["Style"] = "style";
	    /** Type for Any tag */
	    ElementType["Tag"] = "tag";
	    /** Type for <![CDATA[ ... ]]> */
	    ElementType["CDATA"] = "cdata";
	    /** Type for <!doctype ...> */
	    ElementType["Doctype"] = "doctype";
	})(ElementType = exports.ElementType || (exports.ElementType = {}));
	/**
	 * Tests whether an element is a tag or not.
	 *
	 * @param elem Element to test
	 */
	function isTag(elem) {
	    return (elem.type === ElementType.Tag ||
	        elem.type === ElementType.Script ||
	        elem.type === ElementType.Style);
	}
	exports.isTag = isTag;
	// Exports for backwards compatibility
	/** Type for the root element of a document */
	exports.Root = ElementType.Root;
	/** Type for Text */
	exports.Text = ElementType.Text;
	/** Type for <? ... ?> */
	exports.Directive = ElementType.Directive;
	/** Type for <!-- ... --> */
	exports.Comment = ElementType.Comment;
	/** Type for <script> tags */
	exports.Script = ElementType.Script;
	/** Type for <style> tags */
	exports.Style = ElementType.Style;
	/** Type for Any tag */
	exports.Tag = ElementType.Tag;
	/** Type for <![CDATA[ ... ]]> */
	exports.CDATA = ElementType.CDATA;
	/** Type for <!doctype ...> */
	exports.Doctype = ElementType.Doctype;


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decode_json_1 = __importDefault(__webpack_require__(854));
	// Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	var fromCodePoint = 
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	String.fromCodePoint ||
	    function (codePoint) {
	        var output = "";
	        if (codePoint > 0xffff) {
	            codePoint -= 0x10000;
	            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	            codePoint = 0xdc00 | (codePoint & 0x3ff);
	        }
	        output += String.fromCharCode(codePoint);
	        return output;
	    };
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	    if (codePoint in decode_json_1.default) {
	        codePoint = decode_json_1.default[codePoint];
	    }
	    return fromCodePoint(codePoint);
	}
	exports.default = decodeCodePoint;


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.encodeHTML5 = exports.encodeHTML4 = exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = void 0;
	var decode_1 = __webpack_require__(231);
	var encode_1 = __webpack_require__(232);
	/**
	 * Decodes a string with entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 * @deprecated Use `decodeXML` or `decodeHTML` directly.
	 */
	function decode(data, level) {
	    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
	}
	exports.decode = decode;
	/**
	 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 * @deprecated Use `decodeHTMLStrict` or `decodeXML` directly.
	 */
	function decodeStrict(data, level) {
	    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
	}
	exports.decodeStrict = decodeStrict;
	/**
	 * Encodes a string with entities.
	 *
	 * @param data String to encode.
	 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
	 * @deprecated Use `encodeHTML`, `encodeXML` or `encodeNonAsciiHTML` directly.
	 */
	function encode(data, level) {
	    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
	}
	exports.encode = encode;
	var encode_2 = __webpack_require__(232);
	Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function () { return encode_2.encodeXML; } });
	Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	Object.defineProperty(exports, "encodeNonAsciiHTML", { enumerable: true, get: function () { return encode_2.encodeNonAsciiHTML; } });
	Object.defineProperty(exports, "escape", { enumerable: true, get: function () { return encode_2.escape; } });
	Object.defineProperty(exports, "escapeUTF8", { enumerable: true, get: function () { return encode_2.escapeUTF8; } });
	// Legacy aliases (deprecated)
	Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	var decode_2 = __webpack_require__(231);
	Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function () { return decode_2.decodeXML; } });
	Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	// Legacy aliases (deprecated)
	Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function () { return decode_2.decodeXML; } });


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Dom7 3.0.0
	 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	 * https://framework7.io/docs/dom7.html
	 *
	 * Copyright 2020, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: November 9, 2020
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var ssrWindow = __webpack_require__(41);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;
	
	  try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _construct(Parent, args, Class) {
	  if (_isNativeReflectConstruct()) {
	    _construct = Reflect.construct;
	  } else {
	    _construct = function _construct(Parent, args, Class) {
	      var a = [null];
	      a.push.apply(a, args);
	      var Constructor = Function.bind.apply(Parent, a);
	      var instance = new Constructor();
	      if (Class) _setPrototypeOf(instance, Class.prototype);
	      return instance;
	    };
	  }
	
	  return _construct.apply(null, arguments);
	}
	
	function _isNativeFunction(fn) {
	  return Function.toString.call(fn).indexOf("[native code]") !== -1;
	}
	
	function _wrapNativeSuper(Class) {
	  var _cache = typeof Map === "function" ? new Map() : undefined;
	
	  _wrapNativeSuper = function _wrapNativeSuper(Class) {
	    if (Class === null || !_isNativeFunction(Class)) return Class;
	
	    if (typeof Class !== "function") {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    if (typeof _cache !== "undefined") {
	      if (_cache.has(Class)) return _cache.get(Class);
	
	      _cache.set(Class, Wrapper);
	    }
	
	    function Wrapper() {
	      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
	    }
	
	    Wrapper.prototype = Object.create(Class.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    return _setPrototypeOf(Wrapper, Class);
	  };
	
	  return _wrapNativeSuper(Class);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	/* eslint-disable no-proto */
	function makeReactive(obj) {
	  var proto = obj.__proto__;
	  Object.defineProperty(obj, '__proto__', {
	    get: function get() {
	      return proto;
	    },
	    set: function set(value) {
	      proto.__proto__ = value;
	    }
	  });
	}
	
	var Dom7 = /*#__PURE__*/function (_Array) {
	  _inheritsLoose(Dom7, _Array);
	
	  function Dom7(items) {
	    var _this;
	
	    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
	    makeReactive(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  return Dom7;
	}( /*#__PURE__*/_wrapNativeSuper(Array));
	
	function arrayFlat(arr) {
	  if (arr === void 0) {
	    arr = [];
	  }
	
	  var res = [];
	  arr.forEach(function (el) {
	    if (Array.isArray(el)) {
	      res.push.apply(res, arrayFlat(el));
	    } else {
	      res.push(el);
	    }
	  });
	  return res;
	}
	function arrayFilter(arr, callback) {
	  return Array.prototype.filter.call(arr, callback);
	}
	function arrayUnique(arr) {
	  var uniqueArray = [];
	
	  for (var i = 0; i < arr.length; i += 1) {
	    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
	  }
	
	  return uniqueArray;
	}
	function toCamelCase(string) {
	  return string.toLowerCase().replace(/-(.)/g, function (match, group) {
	    return group.toUpperCase();
	  });
	}
	
	function qsa(selector, context) {
	  if (typeof selector !== 'string') {
	    return [selector];
	  }
	
	  var a = [];
	  var res = context.querySelectorAll(selector);
	
	  for (var i = 0; i < res.length; i += 1) {
	    a.push(res[i]);
	  }
	
	  return a;
	}
	
	function $(selector, context) {
	  var window = ssrWindow.getWindow();
	  var document = ssrWindow.getDocument();
	  var arr = [];
	
	  if (!context && selector instanceof Dom7) {
	    return selector;
	  }
	
	  if (!selector) {
	    return new Dom7(arr);
	  }
	
	  if (typeof selector === 'string') {
	    var html = selector.trim();
	
	    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	      var toCreate = 'div';
	      if (html.indexOf('<li') === 0) toCreate = 'ul';
	      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
	      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
	      if (html.indexOf('<tbody') === 0) toCreate = 'table';
	      if (html.indexOf('<option') === 0) toCreate = 'select';
	      var tempParent = document.createElement(toCreate);
	      tempParent.innerHTML = html;
	
	      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
	        arr.push(tempParent.childNodes[i]);
	      }
	    } else {
	      arr = qsa(selector.trim(), context || document);
	    } // arr = qsa(selector, document);
	
	  } else if (selector.nodeType || selector === window || selector === document) {
	    arr.push(selector);
	  } else if (Array.isArray(selector)) {
	    if (selector instanceof Dom7) return selector;
	    arr = selector;
	  }
	
	  return new Dom7(arrayUnique(arr));
	}
	
	$.fn = Dom7.prototype;
	
	function addClass() {
	  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
	    classes[_key] = arguments[_key];
	  }
	
	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  this.forEach(function (el) {
	    var _el$classList;
	
	    (_el$classList = el.classList).add.apply(_el$classList, classNames);
	  });
	  return this;
	}
	
	function removeClass() {
	  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    classes[_key2] = arguments[_key2];
	  }
	
	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  this.forEach(function (el) {
	    var _el$classList2;
	
	    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
	  });
	  return this;
	}
	
	function toggleClass() {
	  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    classes[_key3] = arguments[_key3];
	  }
	
	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  this.forEach(function (el) {
	    classNames.forEach(function (className) {
	      el.classList.toggle(className);
	    });
	  });
	}
	
	function hasClass() {
	  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    classes[_key4] = arguments[_key4];
	  }
	
	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  return arrayFilter(this, function (el) {
	    return classNames.filter(function (className) {
	      return el.classList.contains(className);
	    }).length > 0;
	  }).length > 0;
	}
	
	function attr(attrs, value) {
	  if (arguments.length === 1 && typeof attrs === 'string') {
	    // Get attr
	    if (this[0]) return this[0].getAttribute(attrs);
	    return undefined;
	  } // Set attrs
	
	
	  for (var i = 0; i < this.length; i += 1) {
	    if (arguments.length === 2) {
	      // String
	      this[i].setAttribute(attrs, value);
	    } else {
	      // Object
	      for (var attrName in attrs) {
	        this[i][attrName] = attrs[attrName];
	        this[i].setAttribute(attrName, attrs[attrName]);
	      }
	    }
	  }
	
	  return this;
	}
	
	function removeAttr(attr) {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].removeAttribute(attr);
	  }
	
	  return this;
	}
	
	function prop(props, value) {
	  if (arguments.length === 1 && typeof props === 'string') {
	    // Get prop
	    if (this[0]) return this[0][props];
	  } else {
	    // Set props
	    for (var i = 0; i < this.length; i += 1) {
	      if (arguments.length === 2) {
	        // String
	        this[i][props] = value;
	      } else {
	        // Object
	        for (var propName in props) {
	          this[i][propName] = props[propName];
	        }
	      }
	    }
	
	    return this;
	  }
	
	  return this;
	}
	
	function data(key, value) {
	  var el;
	
	  if (typeof value === 'undefined') {
	    el = this[0];
	    if (!el) return undefined; // Get value
	
	    if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
	      return el.dom7ElementDataStorage[key];
	    }
	
	    var dataKey = el.getAttribute("data-" + key);
	
	    if (dataKey) {
	      return dataKey;
	    }
	
	    return undefined;
	  } // Set value
	
	
	  for (var i = 0; i < this.length; i += 1) {
	    el = this[i];
	    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
	    el.dom7ElementDataStorage[key] = value;
	  }
	
	  return this;
	}
	
	function removeData(key) {
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];
	
	    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
	      el.dom7ElementDataStorage[key] = null;
	      delete el.dom7ElementDataStorage[key];
	    }
	  }
	}
	
	function dataset() {
	  var el = this[0];
	  if (!el) return undefined;
	  var dataset = {}; // eslint-disable-line
	
	  if (el.dataset) {
	    for (var dataKey in el.dataset) {
	      dataset[dataKey] = el.dataset[dataKey];
	    }
	  } else {
	    for (var i = 0; i < el.attributes.length; i += 1) {
	      var _attr = el.attributes[i];
	
	      if (_attr.name.indexOf('data-') >= 0) {
	        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
	      }
	    }
	  }
	
	  for (var key in dataset) {
	    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
	  }
	
	  return dataset;
	}
	
	function val(value) {
	  if (typeof value === 'undefined') {
	    // get value
	    var el = this[0];
	    if (!el) return undefined;
	
	    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
	      var values = [];
	
	      for (var i = 0; i < el.selectedOptions.length; i += 1) {
	        values.push(el.selectedOptions[i].value);
	      }
	
	      return values;
	    }
	
	    return el.value;
	  } // set value
	
	
	  for (var _i = 0; _i < this.length; _i += 1) {
	    var _el = this[_i];
	
	    if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') {
	      for (var j = 0; j < _el.options.length; j += 1) {
	        _el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
	      }
	    } else {
	      _el.value = value;
	    }
	  }
	
	  return this;
	}
	
	function value(value) {
	  return this.val(value);
	}
	
	function transform(transform) {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].style.transform = transform;
	  }
	
	  return this;
	}
	
	function transition(duration) {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
	  }
	
	  return this;
	}
	
	function on() {
	  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    args[_key5] = arguments[_key5];
	  }
	
	  var eventType = args[0],
	      targetSelector = args[1],
	      listener = args[2],
	      capture = args[3];
	
	  if (typeof args[1] === 'function') {
	    eventType = args[0];
	    listener = args[1];
	    capture = args[2];
	    targetSelector = undefined;
	  }
	
	  if (!capture) capture = false;
	
	  function handleLiveEvent(e) {
	    var target = e.target;
	    if (!target) return;
	    var eventData = e.target.dom7EventData || [];
	
	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }
	
	    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
	      var _parents = $(target).parents(); // eslint-disable-line
	
	
	      for (var k = 0; k < _parents.length; k += 1) {
	        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
	      }
	    }
	  }
	
	  function handleEvent(e) {
	    var eventData = e && e.target ? e.target.dom7EventData || [] : [];
	
	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }
	
	    listener.apply(this, eventData);
	  }
	
	  var events = eventType.split(' ');
	  var j;
	
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];
	
	    if (!targetSelector) {
	      for (j = 0; j < events.length; j += 1) {
	        var event = events[j];
	        if (!el.dom7Listeners) el.dom7Listeners = {};
	        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
	        el.dom7Listeners[event].push({
	          listener: listener,
	          proxyListener: handleEvent
	        });
	        el.addEventListener(event, handleEvent, capture);
	      }
	    } else {
	      // Live events
	      for (j = 0; j < events.length; j += 1) {
	        var _event = events[j];
	        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
	        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];
	
	        el.dom7LiveListeners[_event].push({
	          listener: listener,
	          proxyListener: handleLiveEvent
	        });
	
	        el.addEventListener(_event, handleLiveEvent, capture);
	      }
	    }
	  }
	
	  return this;
	}
	
	function off() {
	  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	    args[_key6] = arguments[_key6];
	  }
	
	  var eventType = args[0],
	      targetSelector = args[1],
	      listener = args[2],
	      capture = args[3];
	
	  if (typeof args[1] === 'function') {
	    eventType = args[0];
	    listener = args[1];
	    capture = args[2];
	    targetSelector = undefined;
	  }
	
	  if (!capture) capture = false;
	  var events = eventType.split(' ');
	
	  for (var i = 0; i < events.length; i += 1) {
	    var event = events[i];
	
	    for (var j = 0; j < this.length; j += 1) {
	      var el = this[j];
	      var handlers = void 0;
	
	      if (!targetSelector && el.dom7Listeners) {
	        handlers = el.dom7Listeners[event];
	      } else if (targetSelector && el.dom7LiveListeners) {
	        handlers = el.dom7LiveListeners[event];
	      }
	
	      if (handlers && handlers.length) {
	        for (var k = handlers.length - 1; k >= 0; k -= 1) {
	          var handler = handlers[k];
	
	          if (listener && handler.listener === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (!listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          }
	        }
	      }
	    }
	  }
	
	  return this;
	}
	
	function once() {
	  var dom = this;
	
	  for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	    args[_key7] = arguments[_key7];
	  }
	
	  var eventName = args[0],
	      targetSelector = args[1],
	      listener = args[2],
	      capture = args[3];
	
	  if (typeof args[1] === 'function') {
	    eventName = args[0];
	    listener = args[1];
	    capture = args[2];
	    targetSelector = undefined;
	  }
	
	  function onceHandler() {
	    for (var _len8 = arguments.length, eventArgs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	      eventArgs[_key8] = arguments[_key8];
	    }
	
	    listener.apply(this, eventArgs);
	    dom.off(eventName, targetSelector, onceHandler, capture);
	
	    if (onceHandler.dom7proxy) {
	      delete onceHandler.dom7proxy;
	    }
	  }
	
	  onceHandler.dom7proxy = listener;
	  return dom.on(eventName, targetSelector, onceHandler, capture);
	}
	
	function trigger() {
	  var window = ssrWindow.getWindow();
	
	  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
	    args[_key9] = arguments[_key9];
	  }
	
	  var events = args[0].split(' ');
	  var eventData = args[1];
	
	  for (var i = 0; i < events.length; i += 1) {
	    var event = events[i];
	
	    for (var j = 0; j < this.length; j += 1) {
	      var el = this[j];
	
	      if (window.CustomEvent) {
	        var evt = new window.CustomEvent(event, {
	          detail: eventData,
	          bubbles: true,
	          cancelable: true
	        });
	        el.dom7EventData = args.filter(function (data, dataIndex) {
	          return dataIndex > 0;
	        });
	        el.dispatchEvent(evt);
	        el.dom7EventData = [];
	        delete el.dom7EventData;
	      }
	    }
	  }
	
	  return this;
	}
	
	function transitionEnd(callback) {
	  var dom = this;
	
	  function fireCallBack(e) {
	    if (e.target !== this) return;
	    callback.call(this, e);
	    dom.off('transitionend', fireCallBack);
	  }
	
	  if (callback) {
	    dom.on('transitionend', fireCallBack);
	  }
	
	  return this;
	}
	
	function animationEnd(callback) {
	  var dom = this;
	
	  function fireCallBack(e) {
	    if (e.target !== this) return;
	    callback.call(this, e);
	    dom.off('animationend', fireCallBack);
	  }
	
	  if (callback) {
	    dom.on('animationend', fireCallBack);
	  }
	
	  return this;
	}
	
	function width() {
	  var window = ssrWindow.getWindow();
	
	  if (this[0] === window) {
	    return window.innerWidth;
	  }
	
	  if (this.length > 0) {
	    return parseFloat(this.css('width'));
	  }
	
	  return null;
	}
	
	function outerWidth(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      var _styles = this.styles();
	
	      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
	    }
	
	    return this[0].offsetWidth;
	  }
	
	  return null;
	}
	
	function height() {
	  var window = ssrWindow.getWindow();
	
	  if (this[0] === window) {
	    return window.innerHeight;
	  }
	
	  if (this.length > 0) {
	    return parseFloat(this.css('height'));
	  }
	
	  return null;
	}
	
	function outerHeight(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      var _styles2 = this.styles();
	
	      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
	    }
	
	    return this[0].offsetHeight;
	  }
	
	  return null;
	}
	
	function offset() {
	  if (this.length > 0) {
	    var window = ssrWindow.getWindow();
	    var document = ssrWindow.getDocument();
	    var el = this[0];
	    var box = el.getBoundingClientRect();
	    var body = document.body;
	    var clientTop = el.clientTop || body.clientTop || 0;
	    var clientLeft = el.clientLeft || body.clientLeft || 0;
	    var scrollTop = el === window ? window.scrollY : el.scrollTop;
	    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
	    return {
	      top: box.top + scrollTop - clientTop,
	      left: box.left + scrollLeft - clientLeft
	    };
	  }
	
	  return null;
	}
	
	function hide() {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].style.display = 'none';
	  }
	
	  return this;
	}
	
	function show() {
	  var window = ssrWindow.getWindow();
	
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];
	
	    if (el.style.display === 'none') {
	      el.style.display = '';
	    }
	
	    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
	      // Still not visible
	      el.style.display = 'block';
	    }
	  }
	
	  return this;
	}
	
	function styles() {
	  var window = ssrWindow.getWindow();
	  if (this[0]) return window.getComputedStyle(this[0], null);
	  return {};
	}
	
	function css(props, value) {
	  var window = ssrWindow.getWindow();
	  var i;
	
	  if (arguments.length === 1) {
	    if (typeof props === 'string') {
	      // .css('width')
	      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
	    } else {
	      // .css({ width: '100px' })
	      for (i = 0; i < this.length; i += 1) {
	        for (var _prop in props) {
	          this[i].style[_prop] = props[_prop];
	        }
	      }
	
	      return this;
	    }
	  }
	
	  if (arguments.length === 2 && typeof props === 'string') {
	    // .css('width', '100px')
	    for (i = 0; i < this.length; i += 1) {
	      this[i].style[props] = value;
	    }
	
	    return this;
	  }
	
	  return this;
	}
	
	function each(callback) {
	  if (!callback) return this;
	  this.forEach(function (el, index) {
	    callback.apply(el, [el, index]);
	  });
	  return this;
	}
	
	function filter(callback) {
	  var result = arrayFilter(this, callback);
	  return $(result);
	}
	
	function html(html) {
	  if (typeof html === 'undefined') {
	    return this[0] ? this[0].innerHTML : null;
	  }
	
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].innerHTML = html;
	  }
	
	  return this;
	}
	
	function text(text) {
	  if (typeof text === 'undefined') {
	    return this[0] ? this[0].textContent.trim() : null;
	  }
	
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].textContent = text;
	  }
	
	  return this;
	}
	
	function is(selector) {
	  var window = ssrWindow.getWindow();
	  var document = ssrWindow.getDocument();
	  var el = this[0];
	  var compareWith;
	  var i;
	  if (!el || typeof selector === 'undefined') return false;
	
	  if (typeof selector === 'string') {
	    if (el.matches) return el.matches(selector);
	    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
	    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
	    compareWith = $(selector);
	
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }
	
	    return false;
	  }
	
	  if (selector === document) {
	    return el === document;
	  }
	
	  if (selector === window) {
	    return el === window;
	  }
	
	  if (selector.nodeType || selector instanceof Dom7) {
	    compareWith = selector.nodeType ? [selector] : selector;
	
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }
	
	    return false;
	  }
	
	  return false;
	}
	
	function index() {
	  var child = this[0];
	  var i;
	
	  if (child) {
	    i = 0; // eslint-disable-next-line
	
	    while ((child = child.previousSibling) !== null) {
	      if (child.nodeType === 1) i += 1;
	    }
	
	    return i;
	  }
	
	  return undefined;
	}
	
	function eq(index) {
	  if (typeof index === 'undefined') return this;
	  var length = this.length;
	
	  if (index > length - 1) {
	    return $([]);
	  }
	
	  if (index < 0) {
	    var returnIndex = length + index;
	    if (returnIndex < 0) return $([]);
	    return $([this[returnIndex]]);
	  }
	
	  return $([this[index]]);
	}
	
	function append() {
	  var newChild;
	  var document = ssrWindow.getDocument();
	
	  for (var k = 0; k < arguments.length; k += 1) {
	    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];
	
	    for (var i = 0; i < this.length; i += 1) {
	      if (typeof newChild === 'string') {
	        var tempDiv = document.createElement('div');
	        tempDiv.innerHTML = newChild;
	
	        while (tempDiv.firstChild) {
	          this[i].appendChild(tempDiv.firstChild);
	        }
	      } else if (newChild instanceof Dom7) {
	        for (var j = 0; j < newChild.length; j += 1) {
	          this[i].appendChild(newChild[j]);
	        }
	      } else {
	        this[i].appendChild(newChild);
	      }
	    }
	  }
	
	  return this;
	}
	
	function appendTo(parent) {
	  $(parent).append(this);
	  return this;
	}
	
	function prepend(newChild) {
	  var document = ssrWindow.getDocument();
	  var i;
	  var j;
	
	  for (i = 0; i < this.length; i += 1) {
	    if (typeof newChild === 'string') {
	      var tempDiv = document.createElement('div');
	      tempDiv.innerHTML = newChild;
	
	      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	      }
	    } else if (newChild instanceof Dom7) {
	      for (j = 0; j < newChild.length; j += 1) {
	        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	      }
	    } else {
	      this[i].insertBefore(newChild, this[i].childNodes[0]);
	    }
	  }
	
	  return this;
	}
	
	function prependTo(parent) {
	  $(parent).prepend(this);
	  return this;
	}
	
	function insertBefore(selector) {
	  var before = $(selector);
	
	  for (var i = 0; i < this.length; i += 1) {
	    if (before.length === 1) {
	      before[0].parentNode.insertBefore(this[i], before[0]);
	    } else if (before.length > 1) {
	      for (var j = 0; j < before.length; j += 1) {
	        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
	      }
	    }
	  }
	}
	
	function insertAfter(selector) {
	  var after = $(selector);
	
	  for (var i = 0; i < this.length; i += 1) {
	    if (after.length === 1) {
	      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
	    } else if (after.length > 1) {
	      for (var j = 0; j < after.length; j += 1) {
	        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
	      }
	    }
	  }
	}
	
	function next(selector) {
	  if (this.length > 0) {
	    if (selector) {
	      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
	        return $([this[0].nextElementSibling]);
	      }
	
	      return $([]);
	    }
	
	    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
	    return $([]);
	  }
	
	  return $([]);
	}
	
	function nextAll(selector) {
	  var nextEls = [];
	  var el = this[0];
	  if (!el) return $([]);
	
	  while (el.nextElementSibling) {
	    var _next = el.nextElementSibling; // eslint-disable-line
	
	    if (selector) {
	      if ($(_next).is(selector)) nextEls.push(_next);
	    } else nextEls.push(_next);
	
	    el = _next;
	  }
	
	  return $(nextEls);
	}
	
	function prev(selector) {
	  if (this.length > 0) {
	    var el = this[0];
	
	    if (selector) {
	      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
	        return $([el.previousElementSibling]);
	      }
	
	      return $([]);
	    }
	
	    if (el.previousElementSibling) return $([el.previousElementSibling]);
	    return $([]);
	  }
	
	  return $([]);
	}
	
	function prevAll(selector) {
	  var prevEls = [];
	  var el = this[0];
	  if (!el) return $([]);
	
	  while (el.previousElementSibling) {
	    var _prev = el.previousElementSibling; // eslint-disable-line
	
	    if (selector) {
	      if ($(_prev).is(selector)) prevEls.push(_prev);
	    } else prevEls.push(_prev);
	
	    el = _prev;
	  }
	
	  return $(prevEls);
	}
	
	function siblings(selector) {
	  return this.nextAll(selector).add(this.prevAll(selector));
	}
	
	function parent(selector) {
	  var parents = []; // eslint-disable-line
	
	  for (var i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode !== null) {
	      if (selector) {
	        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
	      } else {
	        parents.push(this[i].parentNode);
	      }
	    }
	  }
	
	  return $(parents);
	}
	
	function parents(selector) {
	  var parents = []; // eslint-disable-line
	
	  for (var i = 0; i < this.length; i += 1) {
	    var _parent = this[i].parentNode; // eslint-disable-line
	
	    while (_parent) {
	      if (selector) {
	        if ($(_parent).is(selector)) parents.push(_parent);
	      } else {
	        parents.push(_parent);
	      }
	
	      _parent = _parent.parentNode;
	    }
	  }
	
	  return $(parents);
	}
	
	function closest(selector) {
	  var closest = this; // eslint-disable-line
	
	  if (typeof selector === 'undefined') {
	    return $([]);
	  }
	
	  if (!closest.is(selector)) {
	    closest = closest.parents(selector).eq(0);
	  }
	
	  return closest;
	}
	
	function find(selector) {
	  var foundElements = [];
	
	  for (var i = 0; i < this.length; i += 1) {
	    var found = this[i].querySelectorAll(selector);
	
	    for (var j = 0; j < found.length; j += 1) {
	      foundElements.push(found[j]);
	    }
	  }
	
	  return $(foundElements);
	}
	
	function children(selector) {
	  var children = []; // eslint-disable-line
	
	  for (var i = 0; i < this.length; i += 1) {
	    var childNodes = this[i].children;
	
	    for (var j = 0; j < childNodes.length; j += 1) {
	      if (!selector || $(childNodes[j]).is(selector)) {
	        children.push(childNodes[j]);
	      }
	    }
	  }
	
	  return $(children);
	}
	
	function remove() {
	  for (var i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
	  }
	
	  return this;
	}
	
	function detach() {
	  return this.remove();
	}
	
	function add() {
	  var dom = this;
	  var i;
	  var j;
	
	  for (var _len10 = arguments.length, els = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
	    els[_key10] = arguments[_key10];
	  }
	
	  for (i = 0; i < els.length; i += 1) {
	    var toAdd = $(els[i]);
	
	    for (j = 0; j < toAdd.length; j += 1) {
	      dom.push(toAdd[j]);
	    }
	  }
	
	  return dom;
	}
	
	function empty() {
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];
	
	    if (el.nodeType === 1) {
	      for (var j = 0; j < el.childNodes.length; j += 1) {
	        if (el.childNodes[j].parentNode) {
	          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
	        }
	      }
	
	      el.textContent = '';
	    }
	  }
	
	  return this;
	}
	
	function scrollTo() {
	  var window = ssrWindow.getWindow();
	
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var left = args[0],
	      top = args[1],
	      duration = args[2],
	      easing = args[3],
	      callback = args[4];
	
	  if (args.length === 4 && typeof easing === 'function') {
	    callback = easing;
	    left = args[0];
	    top = args[1];
	    duration = args[2];
	    callback = args[3];
	    easing = args[4];
	  }
	
	  if (typeof easing === 'undefined') easing = 'swing';
	  return this.each(function animate() {
	    var el = this;
	    var currentTop;
	    var currentLeft;
	    var maxTop;
	    var maxLeft;
	    var newTop;
	    var newLeft;
	    var scrollTop; // eslint-disable-line
	
	    var scrollLeft; // eslint-disable-line
	
	    var animateTop = top > 0 || top === 0;
	    var animateLeft = left > 0 || left === 0;
	
	    if (typeof easing === 'undefined') {
	      easing = 'swing';
	    }
	
	    if (animateTop) {
	      currentTop = el.scrollTop;
	
	      if (!duration) {
	        el.scrollTop = top;
	      }
	    }
	
	    if (animateLeft) {
	      currentLeft = el.scrollLeft;
	
	      if (!duration) {
	        el.scrollLeft = left;
	      }
	    }
	
	    if (!duration) return;
	
	    if (animateTop) {
	      maxTop = el.scrollHeight - el.offsetHeight;
	      newTop = Math.max(Math.min(top, maxTop), 0);
	    }
	
	    if (animateLeft) {
	      maxLeft = el.scrollWidth - el.offsetWidth;
	      newLeft = Math.max(Math.min(left, maxLeft), 0);
	    }
	
	    var startTime = null;
	    if (animateTop && newTop === currentTop) animateTop = false;
	    if (animateLeft && newLeft === currentLeft) animateLeft = false;
	
	    function render(time) {
	      if (time === void 0) {
	        time = new Date().getTime();
	      }
	
	      if (startTime === null) {
	        startTime = time;
	      }
	
	      var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
	      var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
	      var done;
	      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
	      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
	
	      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
	        el.scrollTop = newTop;
	        done = true;
	      }
	
	      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
	        el.scrollTop = newTop;
	        done = true;
	      }
	
	      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
	        el.scrollLeft = newLeft;
	        done = true;
	      }
	
	      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
	        el.scrollLeft = newLeft;
	        done = true;
	      }
	
	      if (done) {
	        if (callback) callback();
	        return;
	      }
	
	      if (animateTop) el.scrollTop = scrollTop;
	      if (animateLeft) el.scrollLeft = scrollLeft;
	      window.requestAnimationFrame(render);
	    }
	
	    window.requestAnimationFrame(render);
	  });
	} // scrollTop(top, duration, easing, callback) {
	
	
	function scrollTop() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var top = args[0],
	      duration = args[1],
	      easing = args[2],
	      callback = args[3];
	
	  if (args.length === 3 && typeof easing === 'function') {
	    top = args[0];
	    duration = args[1];
	    callback = args[2];
	    easing = args[3];
	  }
	
	  var dom = this;
	
	  if (typeof top === 'undefined') {
	    if (dom.length > 0) return dom[0].scrollTop;
	    return null;
	  }
	
	  return dom.scrollTo(undefined, top, duration, easing, callback);
	}
	
	function scrollLeft() {
	  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  var left = args[0],
	      duration = args[1],
	      easing = args[2],
	      callback = args[3];
	
	  if (args.length === 3 && typeof easing === 'function') {
	    left = args[0];
	    duration = args[1];
	    callback = args[2];
	    easing = args[3];
	  }
	
	  var dom = this;
	
	  if (typeof left === 'undefined') {
	    if (dom.length > 0) return dom[0].scrollLeft;
	    return null;
	  }
	
	  return dom.scrollTo(left, undefined, duration, easing, callback);
	}
	
	function animate(initialProps, initialParams) {
	  var window = ssrWindow.getWindow();
	  var els = this;
	  var a = {
	    props: Object.assign({}, initialProps),
	    params: Object.assign({
	      duration: 300,
	      easing: 'swing' // or 'linear'
	
	      /* Callbacks
	      begin(elements)
	      complete(elements)
	      progress(elements, complete, remaining, start, tweenValue)
	      */
	
	    }, initialParams),
	    elements: els,
	    animating: false,
	    que: [],
	    easingProgress: function easingProgress(easing, progress) {
	      if (easing === 'swing') {
	        return 0.5 - Math.cos(progress * Math.PI) / 2;
	      }
	
	      if (typeof easing === 'function') {
	        return easing(progress);
	      }
	
	      return progress;
	    },
	    stop: function stop() {
	      if (a.frameId) {
	        window.cancelAnimationFrame(a.frameId);
	      }
	
	      a.animating = false;
	      a.elements.each(function (el) {
	        var element = el;
	        delete element.dom7AnimateInstance;
	      });
	      a.que = [];
	    },
	    done: function done(complete) {
	      a.animating = false;
	      a.elements.each(function (el) {
	        var element = el;
	        delete element.dom7AnimateInstance;
	      });
	      if (complete) complete(els);
	
	      if (a.que.length > 0) {
	        var que = a.que.shift();
	        a.animate(que[0], que[1]);
	      }
	    },
	    animate: function animate(props, params) {
	      if (a.animating) {
	        a.que.push([props, params]);
	        return a;
	      }
	
	      var elements = []; // Define & Cache Initials & Units
	
	      a.elements.each(function (el, index) {
	        var initialFullValue;
	        var initialValue;
	        var unit;
	        var finalValue;
	        var finalFullValue;
	        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
	        elements[index] = {
	          container: el
	        };
	        Object.keys(props).forEach(function (prop) {
	          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
	          initialValue = parseFloat(initialFullValue);
	          unit = initialFullValue.replace(initialValue, '');
	          finalValue = parseFloat(props[prop]);
	          finalFullValue = props[prop] + unit;
	          elements[index][prop] = {
	            initialFullValue: initialFullValue,
	            initialValue: initialValue,
	            unit: unit,
	            finalValue: finalValue,
	            finalFullValue: finalFullValue,
	            currentValue: initialValue
	          };
	        });
	      });
	      var startTime = null;
	      var time;
	      var elementsDone = 0;
	      var propsDone = 0;
	      var done;
	      var began = false;
	      a.animating = true;
	
	      function render() {
	        time = new Date().getTime();
	        var progress;
	        var easeProgress; // let el;
	
	        if (!began) {
	          began = true;
	          if (params.begin) params.begin(els);
	        }
	
	        if (startTime === null) {
	          startTime = time;
	        }
	
	        if (params.progress) {
	          // eslint-disable-next-line
	          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
	        }
	
	        elements.forEach(function (element) {
	          var el = element;
	          if (done || el.done) return;
	          Object.keys(props).forEach(function (prop) {
	            if (done || el.done) return;
	            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
	            easeProgress = a.easingProgress(params.easing, progress);
	            var _el$prop = el[prop],
	                initialValue = _el$prop.initialValue,
	                finalValue = _el$prop.finalValue,
	                unit = _el$prop.unit;
	            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
	            var currentValue = el[prop].currentValue;
	
	            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
	              el.container.style[prop] = finalValue + unit;
	              propsDone += 1;
	
	              if (propsDone === Object.keys(props).length) {
	                el.done = true;
	                elementsDone += 1;
	              }
	
	              if (elementsDone === elements.length) {
	                done = true;
	              }
	            }
	
	            if (done) {
	              a.done(params.complete);
	              return;
	            }
	
	            el.container.style[prop] = currentValue + unit;
	          });
	        });
	        if (done) return; // Then call
	
	        a.frameId = window.requestAnimationFrame(render);
	      }
	
	      a.frameId = window.requestAnimationFrame(render);
	      return a;
	    }
	  };
	
	  if (a.elements.length === 0) {
	    return els;
	  }
	
	  var animateInstance;
	
	  for (var i = 0; i < a.elements.length; i += 1) {
	    if (a.elements[i].dom7AnimateInstance) {
	      animateInstance = a.elements[i].dom7AnimateInstance;
	    } else a.elements[i].dom7AnimateInstance = a;
	  }
	
	  if (!animateInstance) {
	    animateInstance = a;
	  }
	
	  if (initialProps === 'stop') {
	    animateInstance.stop();
	  } else {
	    animateInstance.animate(a.props, a.params);
	  }
	
	  return els;
	}
	
	function stop() {
	  var els = this;
	
	  for (var i = 0; i < els.length; i += 1) {
	    if (els[i].dom7AnimateInstance) {
	      els[i].dom7AnimateInstance.stop();
	    }
	  }
	}
	
	var noTrigger = 'resize scroll'.split(' ');
	
	function shortcut(name) {
	  function eventHandler() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (typeof args[0] === 'undefined') {
	      for (var i = 0; i < this.length; i += 1) {
	        if (noTrigger.indexOf(name) < 0) {
	          if (name in this[i]) this[i][name]();else {
	            $(this[i]).trigger(name);
	          }
	        }
	      }
	
	      return this;
	    }
	
	    return this.on.apply(this, [name].concat(args));
	  }
	
	  return eventHandler;
	}
	
	var click = shortcut('click');
	var blur = shortcut('blur');
	var focus = shortcut('focus');
	var focusin = shortcut('focusin');
	var focusout = shortcut('focusout');
	var keyup = shortcut('keyup');
	var keydown = shortcut('keydown');
	var keypress = shortcut('keypress');
	var submit = shortcut('submit');
	var change = shortcut('change');
	var mousedown = shortcut('mousedown');
	var mousemove = shortcut('mousemove');
	var mouseup = shortcut('mouseup');
	var mouseenter = shortcut('mouseenter');
	var mouseleave = shortcut('mouseleave');
	var mouseout = shortcut('mouseout');
	var mouseover = shortcut('mouseover');
	var touchstart = shortcut('touchstart');
	var touchend = shortcut('touchend');
	var touchmove = shortcut('touchmove');
	var resize = shortcut('resize');
	var scroll = shortcut('scroll');
	
	exports.$ = $;
	exports.add = add;
	exports.addClass = addClass;
	exports.animate = animate;
	exports.animationEnd = animationEnd;
	exports.append = append;
	exports.appendTo = appendTo;
	exports.attr = attr;
	exports.blur = blur;
	exports.change = change;
	exports.children = children;
	exports.click = click;
	exports.closest = closest;
	exports.css = css;
	exports.data = data;
	exports.dataset = dataset;
	exports.default = $;
	exports.detach = detach;
	exports.each = each;
	exports.empty = empty;
	exports.eq = eq;
	exports.filter = filter;
	exports.find = find;
	exports.focus = focus;
	exports.focusin = focusin;
	exports.focusout = focusout;
	exports.hasClass = hasClass;
	exports.height = height;
	exports.hide = hide;
	exports.html = html;
	exports.index = index;
	exports.insertAfter = insertAfter;
	exports.insertBefore = insertBefore;
	exports.is = is;
	exports.keydown = keydown;
	exports.keypress = keypress;
	exports.keyup = keyup;
	exports.mousedown = mousedown;
	exports.mouseenter = mouseenter;
	exports.mouseleave = mouseleave;
	exports.mousemove = mousemove;
	exports.mouseout = mouseout;
	exports.mouseover = mouseover;
	exports.mouseup = mouseup;
	exports.next = next;
	exports.nextAll = nextAll;
	exports.off = off;
	exports.offset = offset;
	exports.on = on;
	exports.once = once;
	exports.outerHeight = outerHeight;
	exports.outerWidth = outerWidth;
	exports.parent = parent;
	exports.parents = parents;
	exports.prepend = prepend;
	exports.prependTo = prependTo;
	exports.prev = prev;
	exports.prevAll = prevAll;
	exports.prop = prop;
	exports.remove = remove;
	exports.removeAttr = removeAttr;
	exports.removeClass = removeClass;
	exports.removeData = removeData;
	exports.resize = resize;
	exports.scroll = scroll;
	exports.scrollLeft = scrollLeft;
	exports.scrollTo = scrollTo;
	exports.scrollTop = scrollTop;
	exports.show = show;
	exports.siblings = siblings;
	exports.stop = stop;
	exports.styles = styles;
	exports.submit = submit;
	exports.text = text;
	exports.toggleClass = toggleClass;
	exports.touchend = touchend;
	exports.touchmove = touchmove;
	exports.touchstart = touchstart;
	exports.transform = transform;
	exports.transition = transition;
	exports.transitionEnd = transitionEnd;
	exports.trigger = trigger;
	exports.val = val;
	exports.value = value;
	exports.width = width;


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	// DOM-Level-1-compliant structure
	var NodePrototype = __webpack_require__(234);
	var ElementPrototype = module.exports = Object.create(NodePrototype);
	
	var domLvl1 = {
		tagName: "name"
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(ElementPrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 824 */
/***/ function(module, exports) {

	// removeSubsets
	// Given an array of nodes, remove any member that is contained by another.
	exports.removeSubsets = function(nodes) {
		var idx = nodes.length, node, ancestor, replace;
	
		// Check if each node (or one of its ancestors) is already contained in the
		// array.
		while (--idx > -1) {
			node = ancestor = nodes[idx];
	
			// Temporarily remove the node under consideration
			nodes[idx] = null;
			replace = true;
	
			while (ancestor) {
				if (nodes.indexOf(ancestor) > -1) {
					replace = false;
					nodes.splice(idx, 1);
					break;
				}
				ancestor = ancestor.parent;
			}
	
			// If the node has been found to be unique, re-insert it.
			if (replace) {
				nodes[idx] = node;
			}
		}
	
		return nodes;
	};
	
	// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
	var POSITION = {
		DISCONNECTED: 1,
		PRECEDING: 2,
		FOLLOWING: 4,
		CONTAINS: 8,
		CONTAINED_BY: 16
	};
	
	// Compare the position of one node against another node in any other document.
	// The return value is a bitmask with the following values:
	//
	// document order:
	// > There is an ordering, document order, defined on all the nodes in the
	// > document corresponding to the order in which the first character of the
	// > XML representation of each node occurs in the XML representation of the
	// > document after expansion of general entities. Thus, the document element
	// > node will be the first node. Element nodes occur before their children.
	// > Thus, document order orders element nodes in order of the occurrence of
	// > their start-tag in the XML (after expansion of entities). The attribute
	// > nodes of an element occur after the element and before its children. The
	// > relative order of attribute nodes is implementation-dependent./
	// Source:
	// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	//
	// @argument {Node} nodaA The first node to use in the comparison
	// @argument {Node} nodeB The second node to use in the comparison
	//
	// @return {Number} A bitmask describing the input nodes' relative position.
	//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	//         a description of these values.
	var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
		var aParents = [];
		var bParents = [];
		var current, sharedParent, siblings, aSibling, bSibling, idx;
	
		if (nodeA === nodeB) {
			return 0;
		}
	
		current = nodeA;
		while (current) {
			aParents.unshift(current);
			current = current.parent;
		}
		current = nodeB;
		while (current) {
			bParents.unshift(current);
			current = current.parent;
		}
	
		idx = 0;
		while (aParents[idx] === bParents[idx]) {
			idx++;
		}
	
		if (idx === 0) {
			return POSITION.DISCONNECTED;
		}
	
		sharedParent = aParents[idx - 1];
		siblings = sharedParent.children;
		aSibling = aParents[idx];
		bSibling = bParents[idx];
	
		if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
			if (sharedParent === nodeB) {
				return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
			}
			return POSITION.FOLLOWING;
		} else {
			if (sharedParent === nodeA) {
				return POSITION.PRECEDING | POSITION.CONTAINS;
			}
			return POSITION.PRECEDING;
		}
	};
	
	// Sort an array of nodes based on their relative position in the document and
	// remove any duplicate nodes. If the array contains nodes that do not belong
	// to the same document, sort order is unspecified.
	//
	// @argument {Array} nodes Array of DOM nodes
	//
	// @returns {Array} collection of unique nodes, sorted in document order
	exports.uniqueSort = function(nodes) {
		var idx = nodes.length, node, position;
	
		nodes = nodes.slice();
	
		while (--idx > -1) {
			node = nodes[idx];
			position = nodes.indexOf(node);
			if (position > -1 && position < idx) {
				nodes.splice(idx, 1);
			}
		}
		nodes.sort(function(a, b) {
			var relative = comparePos(a, b);
			if (relative & POSITION.PRECEDING) {
				return -1;
			} else if (relative & POSITION.FOLLOWING) {
				return 1;
			}
			return 0;
		});
	
		return nodes;
	};


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(103);
	var isTag = exports.isTag = ElementType.isTag;
	
	exports.testElement = function(options, element){
		for(var key in options){
			if(!options.hasOwnProperty(key));
			else if(key === "tag_name"){
				if(!isTag(element) || !options.tag_name(element.name)){
					return false;
				}
			} else if(key === "tag_type"){
				if(!options.tag_type(element.type)) return false;
			} else if(key === "tag_contains"){
				if(isTag(element) || !options.tag_contains(element.data)){
					return false;
				}
			} else if(!element.attribs || !options[key](element.attribs[key])){
				return false;
			}
		}
		return true;
	};
	
	var Checks = {
		tag_name: function(name){
			if(typeof name === "function"){
				return function(elem){ return isTag(elem) && name(elem.name); };
			} else if(name === "*"){
				return isTag;
			} else {
				return function(elem){ return isTag(elem) && elem.name === name; };
			}
		},
		tag_type: function(type){
			if(typeof type === "function"){
				return function(elem){ return type(elem.type); };
			} else {
				return function(elem){ return elem.type === type; };
			}
		},
		tag_contains: function(data){
			if(typeof data === "function"){
				return function(elem){ return !isTag(elem) && data(elem.data); };
			} else {
				return function(elem){ return !isTag(elem) && elem.data === data; };
			}
		}
	};
	
	function getAttribCheck(attrib, value){
		if(typeof value === "function"){
			return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
		} else {
			return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
		}
	}
	
	function combineFuncs(a, b){
		return function(elem){
			return a(elem) || b(elem);
		};
	}
	
	exports.getElements = function(options, element, recurse, limit){
		var funcs = Object.keys(options).map(function(key){
			var value = options[key];
			return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
		});
	
		return funcs.length === 0 ? [] : this.filter(
			funcs.reduce(combineFuncs),
			element, recurse, limit
		);
	};
	
	exports.getElementById = function(id, element, recurse){
		if(!Array.isArray(element)) element = [element];
		return this.findOne(getAttribCheck("id", id), element, recurse !== false);
	};
	
	exports.getElementsByTagName = function(name, element, recurse, limit){
		return this.filter(Checks.tag_name(name), element, recurse, limit);
	};
	
	exports.getElementsByTagType = function(type, element, recurse, limit){
		return this.filter(Checks.tag_type(type), element, recurse, limit);
	};


/***/ },
/* 826 */
/***/ function(module, exports) {

	exports.removeElement = function(elem){
		if(elem.prev) elem.prev.next = elem.next;
		if(elem.next) elem.next.prev = elem.prev;
	
		if(elem.parent){
			var childs = elem.parent.children;
			childs.splice(childs.lastIndexOf(elem), 1);
		}
	};
	
	exports.replaceElement = function(elem, replacement){
		var prev = replacement.prev = elem.prev;
		if(prev){
			prev.next = replacement;
		}
	
		var next = replacement.next = elem.next;
		if(next){
			next.prev = replacement;
		}
	
		var parent = replacement.parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs[childs.lastIndexOf(elem)] = replacement;
		}
	};
	
	exports.appendChild = function(elem, child){
		child.parent = elem;
	
		if(elem.children.push(child) !== 1){
			var sibling = elem.children[elem.children.length - 2];
			sibling.next = child;
			child.prev = sibling;
			child.next = null;
		}
	};
	
	exports.append = function(elem, next){
		var parent = elem.parent,
			currNext = elem.next;
	
		next.next = currNext;
		next.prev = elem;
		elem.next = next;
		next.parent = parent;
	
		if(currNext){
			currNext.prev = next;
			if(parent){
				var childs = parent.children;
				childs.splice(childs.lastIndexOf(currNext), 0, next);
			}
		} else if(parent){
			parent.children.push(next);
		}
	};
	
	exports.prepend = function(elem, prev){
		var parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(elem), 0, prev);
		}
	
		if(elem.prev){
			elem.prev.next = prev;
		}
		
		prev.parent = parent;
		prev.prev = elem.prev;
		prev.next = elem;
		elem.prev = prev;
	};
	
	


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	var isTag = __webpack_require__(103).isTag;
	
	module.exports = {
		filter: filter,
		find: find,
		findOneChild: findOneChild,
		findOne: findOne,
		existsOne: existsOne,
		findAll: findAll
	};
	
	function filter(test, element, recurse, limit){
		if(!Array.isArray(element)) element = [element];
	
		if(typeof limit !== "number" || !isFinite(limit)){
			limit = Infinity;
		}
		return find(test, element, recurse !== false, limit);
	}
	
	function find(test, elems, recurse, limit){
		var result = [], childs;
	
		for(var i = 0, j = elems.length; i < j; i++){
			if(test(elems[i])){
				result.push(elems[i]);
				if(--limit <= 0) break;
			}
	
			childs = elems[i].children;
			if(recurse && childs && childs.length > 0){
				childs = find(test, childs, recurse, limit);
				result = result.concat(childs);
				limit -= childs.length;
				if(limit <= 0) break;
			}
		}
	
		return result;
	}
	
	function findOneChild(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(test(elems[i])) return elems[i];
		}
	
		return null;
	}
	
	function findOne(test, elems){
		var elem = null;
	
		for(var i = 0, l = elems.length; i < l && !elem; i++){
			if(!isTag(elems[i])){
				continue;
			} else if(test(elems[i])){
				elem = elems[i];
			} else if(elems[i].children.length > 0){
				elem = findOne(test, elems[i].children);
			}
		}
	
		return elem;
	}
	
	function existsOne(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(
				isTag(elems[i]) && (
					test(elems[i]) || (
						elems[i].children.length > 0 &&
						existsOne(test, elems[i].children)
					)
				)
			){
				return true;
			}
		}
	
		return false;
	}
	
	function findAll(test, rootElems){
		var result = [];
		var stack = rootElems.slice();
		while(stack.length){
			var elem = stack.shift();
			if(!isTag(elem)) continue;
			if (elem.children && elem.children.length > 0) {
				stack.unshift.apply(stack, elem.children);
			}
			if(test(elem)) result.push(elem);
		}
		return result;
	}


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(103),
	    getOuterHTML = __webpack_require__(818),
	    isTag = ElementType.isTag;
	
	module.exports = {
		getInnerHTML: getInnerHTML,
		getOuterHTML: getOuterHTML,
		getText: getText
	};
	
	function getInnerHTML(elem, opts){
		return elem.children ? elem.children.map(function(elem){
			return getOuterHTML(elem, opts);
		}).join("") : "";
	}
	
	function getText(elem){
		if(Array.isArray(elem)) return elem.map(getText).join("");
		if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
		if(elem.type === ElementType.CDATA) return getText(elem.children);
		if(elem.type === ElementType.Text) return elem.data;
		return "";
	}


/***/ },
/* 829 */
/***/ function(module, exports) {

	var getChildren = exports.getChildren = function(elem){
		return elem.children;
	};
	
	var getParent = exports.getParent = function(elem){
		return elem.parent;
	};
	
	exports.getSiblings = function(elem){
		var parent = getParent(elem);
		return parent ? getChildren(parent) : [elem];
	};
	
	exports.getAttributeValue = function(elem, name){
		return elem.attribs && elem.attribs[name];
	};
	
	exports.hasAttrib = function(elem, name){
		return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
	};
	
	exports.getName = function(elem){
		return elem.name;
	};


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(832);
	var each = __webpack_require__(236).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(830);
	var Util = __webpack_require__(236);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 832 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(831);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	var decodeMap = __webpack_require__(856);
	
	module.exports = decodeCodePoint;
	
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	
	    if (codePoint in decodeMap) {
	        codePoint = decodeMap[codePoint];
	    }
	
	    var output = "";
	
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	
	    output += String.fromCharCode(codePoint);
	    return output;
	}


/***/ },
/* 835 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 837 */
8,
/* 838 */
8,
/* 839 */
8,
/* 840 */
8,
/* 841 */
8,
/* 842 */
8,
/* 843 */
8,
/* 844 */
8,
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/testimonial-icon.d3fe5fe2.svg";

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(1035)),valueEqual=_interopDefault(__webpack_require__(1180));__webpack_require__(174);var invariant=_interopDefault(__webpack_require__(128));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = CollectingHandler;
	
	function CollectingHandler(cbs) {
	    this._cbs = cbs || {};
	    this.events = [];
	}
	
	var EVENTS = __webpack_require__(88).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function() {
	            this.events.push([name]);
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a) {
	            this.events.push([name, a]);
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a, b) {
	            this.events.push([name, a, b]);
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});
	
	CollectingHandler.prototype.onreset = function() {
	    this.events = [];
	    if (this._cbs.onreset) this._cbs.onreset();
	};
	
	CollectingHandler.prototype.restart = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	
	    for (var i = 0, len = this.events.length; i < len; i++) {
	        if (this._cbs[this.events[i][0]]) {
	            var num = this.events[i].length;
	
	            if (num === 1) {
	                this._cbs[this.events[i][0]]();
	            } else if (num === 2) {
	                this._cbs[this.events[i][0]](this.events[i][1]);
	            } else {
	                this._cbs[this.events[i][0]](
	                    this.events[i][1],
	                    this.events[i][2]
	                );
	            }
	        }
	    }
	};


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	var DomHandler = __webpack_require__(233);
	var DomUtils = __webpack_require__(235);
	
	//TODO: make this a streamable handler
	function FeedHandler(callback, options) {
	    this.init(callback, options);
	}
	
	__webpack_require__(118)(FeedHandler, DomHandler);
	
	FeedHandler.prototype.init = DomHandler;
	
	function getElements(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true);
	}
	function getOneElement(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
	}
	function fetch(what, where, recurse) {
	    return DomUtils.getText(
	        DomUtils.getElementsByTagName(what, where, recurse, 1)
	    ).trim();
	}
	
	function addConditionally(obj, prop, what, where, recurse) {
	    var tmp = fetch(what, where, recurse);
	    if (tmp) obj[prop] = tmp;
	}
	
	var isValidFeed = function(value) {
	    return value === "rss" || value === "feed" || value === "rdf:RDF";
	};
	
	FeedHandler.prototype.onend = function() {
	    var feed = {},
	        feedRoot = getOneElement(isValidFeed, this.dom),
	        tmp,
	        childs;
	
	    if (feedRoot) {
	        if (feedRoot.name === "feed") {
	            childs = feedRoot.children;
	
	            feed.type = "atom";
	            addConditionally(feed, "id", "id", childs);
	            addConditionally(feed, "title", "title", childs);
	            if (
	                (tmp = getOneElement("link", childs)) &&
	                (tmp = tmp.attribs) &&
	                (tmp = tmp.href)
	            )
	                feed.link = tmp;
	            addConditionally(feed, "description", "subtitle", childs);
	            if ((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "email", childs, true);
	
	            feed.items = getElements("entry", childs).map(function(item) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "id", item);
	                addConditionally(entry, "title", "title", item);
	                if (
	                    (tmp = getOneElement("link", item)) &&
	                    (tmp = tmp.attribs) &&
	                    (tmp = tmp.href)
	                )
	                    entry.link = tmp;
	                if ((tmp = fetch("summary", item) || fetch("content", item)))
	                    entry.description = tmp;
	                if ((tmp = fetch("updated", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        } else {
	            childs = getOneElement("channel", feedRoot.children).children;
	
	            feed.type = feedRoot.name.substr(0, 3);
	            feed.id = "";
	            addConditionally(feed, "title", "title", childs);
	            addConditionally(feed, "link", "link", childs);
	            addConditionally(feed, "description", "description", childs);
	            if ((tmp = fetch("lastBuildDate", childs)))
	                feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "managingEditor", childs, true);
	
	            feed.items = getElements("item", feedRoot.children).map(function(
	                item
	            ) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "guid", item);
	                addConditionally(entry, "title", "title", item);
	                addConditionally(entry, "link", "link", item);
	                addConditionally(entry, "description", "description", item);
	                if ((tmp = fetch("pubDate", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        }
	    }
	    this.dom = feed;
	    DomHandler.prototype._handleCallback.call(
	        this,
	        feedRoot ? null : Error("couldn't find root of feed")
	    );
	};
	
	module.exports = FeedHandler;


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = ProxyHandler;
	
	function ProxyHandler(cbs) {
	    this._cbs = cbs || {};
	}
	
	var EVENTS = __webpack_require__(88).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function() {
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a) {
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a, b) {
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(245);
	
	function Stream(options) {
	    Parser.call(this, new Cbs(this), options);
	}
	
	__webpack_require__(118)(Stream, Parser);
	
	Stream.prototype.readable = true;
	
	function Cbs(scope) {
	    this.scope = scope;
	}
	
	var EVENTS = __webpack_require__(88).EVENTS;
	
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        Cbs.prototype["on" + name] = function() {
	            this.scope.emit(name);
	        };
	    } else if (EVENTS[name] === 1) {
	        Cbs.prototype["on" + name] = function(a) {
	            this.scope.emit(name, a);
	        };
	    } else if (EVENTS[name] === 2) {
	        Cbs.prototype["on" + name] = function(a, b) {
	            this.scope.emit(name, a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments!");
	    }
	});


/***/ },
/* 851 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 852 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 853 */
/***/ function(module, exports) {

	module.exports = {
		"elementNames": {
			"altglyph": "altGlyph",
			"altglyphdef": "altGlyphDef",
			"altglyphitem": "altGlyphItem",
			"animatecolor": "animateColor",
			"animatemotion": "animateMotion",
			"animatetransform": "animateTransform",
			"clippath": "clipPath",
			"feblend": "feBlend",
			"fecolormatrix": "feColorMatrix",
			"fecomponenttransfer": "feComponentTransfer",
			"fecomposite": "feComposite",
			"feconvolvematrix": "feConvolveMatrix",
			"fediffuselighting": "feDiffuseLighting",
			"fedisplacementmap": "feDisplacementMap",
			"fedistantlight": "feDistantLight",
			"fedropshadow": "feDropShadow",
			"feflood": "feFlood",
			"fefunca": "feFuncA",
			"fefuncb": "feFuncB",
			"fefuncg": "feFuncG",
			"fefuncr": "feFuncR",
			"fegaussianblur": "feGaussianBlur",
			"feimage": "feImage",
			"femerge": "feMerge",
			"femergenode": "feMergeNode",
			"femorphology": "feMorphology",
			"feoffset": "feOffset",
			"fepointlight": "fePointLight",
			"fespecularlighting": "feSpecularLighting",
			"fespotlight": "feSpotLight",
			"fetile": "feTile",
			"feturbulence": "feTurbulence",
			"foreignobject": "foreignObject",
			"glyphref": "glyphRef",
			"lineargradient": "linearGradient",
			"radialgradient": "radialGradient",
			"textpath": "textPath"
		},
		"attributeNames": {
			"definitionurl": "definitionURL",
			"attributename": "attributeName",
			"attributetype": "attributeType",
			"basefrequency": "baseFrequency",
			"baseprofile": "baseProfile",
			"calcmode": "calcMode",
			"clippathunits": "clipPathUnits",
			"diffuseconstant": "diffuseConstant",
			"edgemode": "edgeMode",
			"filterunits": "filterUnits",
			"glyphref": "glyphRef",
			"gradienttransform": "gradientTransform",
			"gradientunits": "gradientUnits",
			"kernelmatrix": "kernelMatrix",
			"kernelunitlength": "kernelUnitLength",
			"keypoints": "keyPoints",
			"keysplines": "keySplines",
			"keytimes": "keyTimes",
			"lengthadjust": "lengthAdjust",
			"limitingconeangle": "limitingConeAngle",
			"markerheight": "markerHeight",
			"markerunits": "markerUnits",
			"markerwidth": "markerWidth",
			"maskcontentunits": "maskContentUnits",
			"maskunits": "maskUnits",
			"numoctaves": "numOctaves",
			"pathlength": "pathLength",
			"patterncontentunits": "patternContentUnits",
			"patterntransform": "patternTransform",
			"patternunits": "patternUnits",
			"pointsatx": "pointsAtX",
			"pointsaty": "pointsAtY",
			"pointsatz": "pointsAtZ",
			"preservealpha": "preserveAlpha",
			"preserveaspectratio": "preserveAspectRatio",
			"primitiveunits": "primitiveUnits",
			"refx": "refX",
			"refy": "refY",
			"repeatcount": "repeatCount",
			"repeatdur": "repeatDur",
			"requiredextensions": "requiredExtensions",
			"requiredfeatures": "requiredFeatures",
			"specularconstant": "specularConstant",
			"specularexponent": "specularExponent",
			"spreadmethod": "spreadMethod",
			"startoffset": "startOffset",
			"stddeviation": "stdDeviation",
			"stitchtiles": "stitchTiles",
			"surfacescale": "surfaceScale",
			"systemlanguage": "systemLanguage",
			"tablevalues": "tableValues",
			"targetx": "targetX",
			"targety": "targetY",
			"textlength": "textLength",
			"viewbox": "viewBox",
			"viewtarget": "viewTarget",
			"xchannelselector": "xChannelSelector",
			"ychannelselector": "yChannelSelector",
			"zoomandpan": "zoomAndPan"
		}
	};

/***/ },
/* 854 */
/***/ function(module, exports) {

	module.exports = {
		"0": 65533,
		"128": 8364,
		"130": 8218,
		"131": 402,
		"132": 8222,
		"133": 8230,
		"134": 8224,
		"135": 8225,
		"136": 710,
		"137": 8240,
		"138": 352,
		"139": 8249,
		"140": 338,
		"142": 381,
		"145": 8216,
		"146": 8217,
		"147": 8220,
		"148": 8221,
		"149": 8226,
		"150": 8211,
		"151": 8212,
		"152": 732,
		"153": 8482,
		"154": 353,
		"155": 8250,
		"156": 339,
		"158": 382,
		"159": 376
	};

/***/ },
/* 855 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"AElig": "Æ",
		"aelig": "æ",
		"Agrave": "À",
		"agrave": "à",
		"amp": "&",
		"AMP": "&",
		"Aring": "Å",
		"aring": "å",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"brvbar": "¦",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"cedil": "¸",
		"cent": "¢",
		"copy": "©",
		"COPY": "©",
		"curren": "¤",
		"deg": "°",
		"divide": "÷",
		"Eacute": "É",
		"eacute": "é",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"Egrave": "È",
		"egrave": "è",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"frac12": "½",
		"frac14": "¼",
		"frac34": "¾",
		"gt": ">",
		"GT": ">",
		"Iacute": "Í",
		"iacute": "í",
		"Icirc": "Î",
		"icirc": "î",
		"iexcl": "¡",
		"Igrave": "Ì",
		"igrave": "ì",
		"iquest": "¿",
		"Iuml": "Ï",
		"iuml": "ï",
		"laquo": "«",
		"lt": "<",
		"LT": "<",
		"macr": "¯",
		"micro": "µ",
		"middot": "·",
		"nbsp": " ",
		"not": "¬",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"Oacute": "Ó",
		"oacute": "ó",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"Ograve": "Ò",
		"ograve": "ò",
		"ordf": "ª",
		"ordm": "º",
		"Oslash": "Ø",
		"oslash": "ø",
		"Otilde": "Õ",
		"otilde": "õ",
		"Ouml": "Ö",
		"ouml": "ö",
		"para": "¶",
		"plusmn": "±",
		"pound": "£",
		"quot": "\"",
		"QUOT": "\"",
		"raquo": "»",
		"reg": "®",
		"REG": "®",
		"sect": "§",
		"shy": "­",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"szlig": "ß",
		"THORN": "Þ",
		"thorn": "þ",
		"times": "×",
		"Uacute": "Ú",
		"uacute": "ú",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uml": "¨",
		"Uuml": "Ü",
		"uuml": "ü",
		"Yacute": "Ý",
		"yacute": "ý",
		"yen": "¥",
		"yuml": "ÿ"
	};

/***/ },
/* 856 */
854,
/* 857 */
246,
/* 858 */
855,
/* 859 */
247,
/* 860 */
/***/ function(module, exports) {

	module.exports = {
		"Insurance Companies": [
			{
				"SL. No.": 1,
				"name": "BUPA International"
			},
			{
				"SL. No.": 2,
				"name": "CIGNA international Corporation"
			},
			{
				"SL. No.": 3,
				"name": "Aetna international Inc."
			},
			{
				"SL. No.": 4,
				"name": "GMC Mednet International Network"
			},
			{
				"SL. No.": 5,
				"name": "AP COMPANIES GLOBAL SOLUTIONS LIMITED"
			},
			{
				"SL. No.": 6,
				"name": "Surgery Pan Asia"
			},
			{
				"SL. No.": 7,
				"name": "Allianz Worldwide Care Limited"
			},
			{
				"SL. No.": 8,
				"name": "Meera Rescue Services Pvt. Ltd."
			},
			{
				"SL. No.": 9,
				"name": "Asia Medical Assistance Pvt. Limited"
			},
			{
				"SL. No.": 11,
				"name": "Emergency Assistance Japan (Singapore) Pte. Ltd."
			},
			{
				"SL. No.": 12,
				"name": "Quality Health Management, L.L.C (QHM)"
			},
			{
				"SL. No.": 13,
				"name": "ASIAN TRAVEL AND MEDICAL SERVICES, INDIA"
			},
			{
				"SL. No.": 14,
				"name": "Q Life & Medical Insurance Company LLC"
			},
			{
				"SL. No.": 15,
				"name": "Allianz Global Assistance (AGA) Services (India) Private Limited"
			},
			{
				"SL. No.": 16,
				"name": "World Health Organization"
			},
			{
				"SL. No.": 17,
				"name": "Euro-Center (Thailand) Co. Ltd."
			},
			{
				"SL. No.": 18,
				"name": "Europ Assistance-Global Corporate Solutions (GCP)"
			},
			{
				"SL. No.": 19,
				"name": "HSBC India"
			},
			{
				"SL. No.": 20,
				"name": "PARAMOUNT HEALTHCARE MANAGEMENT PVT. LTD."
			},
			{
				"SL. No.": 21,
				"name": "Arcofemi Healthcare Limited"
			},
			{
				"SL. No.": 22,
				"name": "MetLife Alico"
			},
			{
				"SL. No.": 23,
				"name": "Delta Life Insurance Company Limited."
			},
			{
				"SL. No.": 24,
				"name": "Pragati Life Insurance Limited."
			},
			{
				"SL. No.": 25,
				"name": "Pragati Insurance Limited"
			},
			{
				"SL. No.": 26,
				"name": "RUPALI LIFE INSURANCE COMPANY LIMITED."
			},
			{
				"SL. No.": 27,
				"name": "Reliance Insurance Limited"
			},
			{
				"SL. No.": 28,
				"name": "PROVATI INSURANCE COMPANY LIMITED"
			},
			{
				"SL. No.": 29,
				"name": "FAR EAST ISLAMI LIFE INSURANCE COMPANY LIMITED (DIRECTOR,STAFF & DEPENDANTS)"
			},
			{
				"SL. No.": 30,
				"name": "FAR EAST ISLAMI LIFE INSURANCE COMPANY LIMITED (CLIENTS)"
			},
			{
				"SL. No.": 31,
				"name": "Protective Islami Life Insurance"
			},
			{
				"SL. No.": 32,
				"name": "Green Delta Insurance Company Limited"
			},
			{
				"SL. No.": 33,
				"name": "GUARDIAN LIFE INSURANCE LIMITED."
			}
		],
		"Multinational Companies": [
			{
				"SL. No.": 1,
				"name": "Unilever Bangladesh Limited"
			},
			{
				"SL. No.": 2,
				"name": "Huawei Technologies (Bangladesh) Limited"
			},
			{
				"SL. No.": 3,
				"name": "MULTINATIONAL OSG SERVICE BANGLADESH (PVT.) LIMITED"
			},
			{
				"SL. No.": 4,
				"name": "NEPC Consortium Power Limited"
			},
			{
				"SL. No.": 5,
				"name": "IKEA Trading (Hongkong) Limited"
			},
			{
				"SL. No.": 6,
				"name": "Japan Internation co-operation Agency(JICA) Bangladesh Office"
			},
			{
				"SL. No.": 7,
				"name": "International Organization For Migration"
			},
			{
				"SL. No.": 8,
				"name": "Korean International Co-operation Agency (KOICA)"
			},
			{
				"SL. No.": 9,
				"name": "Netherlands Recreation Centre"
			},
			{
				"SL. No.": 10,
				"name": "SEAF Ventures Management LLC"
			},
			{
				"SL. No.": 11,
				"name": "Grameen Phone Ltd."
			},
			{
				"SL. No.": 12,
				"name": "Banglalink Digital Communications Limited"
			},
			{
				"SL. No.": 13,
				"name": "Airtel Bangladesh Limited"
			},
			{
				"SL. No.": 14,
				"name": "ROBI (Axita Bangladesh Limited)"
			},
			{
				"SL. No.": 15,
				"name": "East Compeace Smart Card (Bangladesh) Limited"
			},
			{
				"SL. No.": 16,
				"name": "Sumitomo Corporation Asia PTE . Limited"
			},
			{
				"SL. No.": 17,
				"name": "International Beverages Private Limited (IBPL)"
			},
			{
				"SL. No.": 18,
				"name": "DHL EXPRESS"
			},
			{
				"SL. No.": 19,
				"name": "Singer Bangladesh Limited"
			},
			{
				"SL. No.": 20,
				"name": "Inter Laboratory Test - ICDDRB"
			},
			{
				"SL. No.": 21,
				"name": "Nestle Bangladesh Limited"
			},
			{
				"SL. No.": 22,
				"name": "National Energy Services Limited (NESL)"
			},
			{
				"SL. No.": 23,
				"name": "Lafarge Surma Cement Limited"
			},
			{
				"SL. No.": 24,
				"name": "COATS Bangladesh Limited"
			},
			{
				"SL. No.": 25,
				"name": "Nokia Siemens Networks Bangladesh Limited"
			},
			{
				"SL. No.": 26,
				"name": "DHL Global Forwarding (Bangladesh) Limited"
			},
			{
				"SL. No.": 27,
				"name": "C & A Sourcing International Limited, Bangladesh liaison office"
			},
			{
				"SL. No.": 28,
				"name": "YKK Bangladesh Pte Ltd"
			},
			{
				"SL. No.": 29,
				"name": "Eminence"
			},
			{
				"SL. No.": 30,
				"name": "CEAT AKKHAN LTD"
			},
			{
				"SL. No.": 31,
				"name": "Covanta Bangladesh Operating Ltd"
			},
			{
				"SL. No.": 32,
				"name": "MAERSK Bangladesh Ltd. / APM Global Logistics Bangladesh Ltd."
			},
			{
				"SL. No.": 33,
				"name": "SHIMIZU CORPORATION"
			},
			{
				"SL. No.": 34,
				"name": "Reckitt Benckiser (Bangladesh)"
			},
			{
				"SL. No.": 35,
				"name": "Korean community in Bangladesh"
			},
			{
				"SL. No.": 36,
				"name": "Santos Sangu Field Limited"
			},
			{
				"SL. No.": 37,
				"name": "The World Bank"
			},
			{
				"SL. No.": 38,
				"name": "Katalyst"
			},
			{
				"SL. No.": 39,
				"name": "Huawei Technologies Bangladesh Limited"
			},
			{
				"SL. No.": 40,
				"name": "Haripur Power Limited"
			},
			{
				"SL. No.": 41,
				"name": "ESPIRIT DE CORP (FAR EAST) LIMITED"
			},
			{
				"SL. No.": 42,
				"name": "GE HEALTHCARE LIMITED"
			},
			{
				"SL. No.": 43,
				"name": "Radisson Water Garden Hotel Dhaka"
			},
			{
				"SL. No.": 44,
				"name": "Karnaphuli Fertilizer Company Limited (KAFCO)"
			},
			{
				"SL. No.": 45,
				"name": "SGS Bangladesh Limited"
			},
			{
				"SL. No.": 46,
				"name": "SIEMENS BANGLADESH LIMITED"
			},
			{
				"SL. No.": 47,
				"name": "SABINCO"
			},
			{
				"SL. No.": 48,
				"name": "Malaysia Airlines"
			},
			{
				"SL. No.": 49,
				"name": "RING Bangladesh"
			},
			{
				"SL. No.": 50,
				"name": "QTEC DHAKA LAB"
			},
			{
				"SL. No.": 51,
				"name": "Itochu Corporation"
			},
			{
				"SL. No.": 52,
				"name": "Accenture"
			},
			{
				"SL. No.": 53,
				"name": "Li & Fung (Bangladesh) Limited"
			},
			{
				"SL. No.": 54,
				"name": "LM ERICSSON BANGLADESH LIMITED"
			},
			{
				"SL. No.": 55,
				"name": "British American Tobacco Bangladesh (BATB)"
			},
			{
				"SL. No.": 56,
				"name": "Philip Morris India Services S.A."
			},
			{
				"SL. No.": 57,
				"name": "Saas Aviation Services"
			},
			{
				"SL. No.": 58,
				"name": "GS Engineering & Construction Corporation"
			},
			{
				"SL. No.": 59,
				"name": "Dhaka Regency Hotel & Resort Limited"
			},
			{
				"SL. No.": 60,
				"name": "Toyota Tsusho Corporation"
			},
			{
				"SL. No.": 61,
				"name": "New Castle College And University of New Castle (USA)"
			},
			{
				"SL. No.": 62,
				"name": "Japatech Cleaning Service Limited"
			},
			{
				"SL. No.": 63,
				"name": "BUREAU VERITAS CONSUMER PRODUCTS SERVICES (BD) LIMITED"
			},
			{
				"SL. No.": 64,
				"name": "China Machinery Engineering Corporation"
			},
			{
				"SL. No.": 65,
				"name": "The International Maize and Wheat Improvement Center (CIMMYT)"
			},
			{
				"SL. No.": 66,
				"name": "CEMEX CEMENT (BANGLADESH) LIMITED"
			},
			{
				"SL. No.": 67,
				"name": "Tetra Pak"
			},
			{
				"SL. No.": 68,
				"name": "Mitsui & Co. (Asia Pacific) Pte. Ltd. Dhaka Branch"
			},
			{
				"SL. No.": 69,
				"name": "ALLIANCE HOLDINGS LIMITED & ASSOCITE COMPANIES"
			},
			{
				"SL. No.": 70,
				"name": "KGS Sourcing Limited (Bangladesh Liaison Office)"
			},
			{
				"SL. No.": 71,
				"name": "DRAGON AIR & CATHAY PACIFIC AIRWAYS"
			},
			{
				"SL. No.": 72,
				"name": "THE INSTITUTE OF COST AND MANAGEMENT ACCOUNTANTS OF BANGLADESH (ICMAB)"
			},
			{
				"SL. No.": 73,
				"name": "Emirates"
			},
			{
				"SL. No.": 74,
				"name": "SAUDIA MEDICAL SERVICES, SAUDI ARABIAN AIRLINES (Parents and Dependants of Crew)"
			},
			{
				"SL. No.": 75,
				"name": "Foster Wheeler (Thailand)"
			},
			{
				"SL. No.": 76,
				"name": "ORBIS INTERNATIONAL"
			},
			{
				"SL. No.": 77,
				"name": "Phoenix Finance & Investment Limited"
			},
			{
				"SL. No.": 78,
				"name": "HEALIX INTERNATIONAL LIMITED"
			},
			{
				"SL. No.": 79,
				"name": "MAXWELL STAMP LIMITED"
			},
			{
				"SL. No.": 80,
				"name": "Berger Paints Bangladesh Limited"
			},
			{
				"SL. No.": 81,
				"name": "The Fred Hollows Foundation"
			},
			{
				"SL. No.": 82,
				"name": "Youngone Hi-Tech Sportswear Industries Limited"
			},
			{
				"SL. No.": 83,
				"name": "Puls Trading Far East Limited"
			},
			{
				"SL. No.": 84,
				"name": "KEC International Limited"
			},
			{
				"SL. No.": 85,
				"name": "KEPCO PLANT SERVICE & ENGINEERING COMPANY LIMITED & SUMMIT MEGHNAGHAT POWER COMPANY LIMITED"
			},
			{
				"SL. No.": 86,
				"name": "Godrej Household Products (BD) Pvt. Limited"
			}
		],
		"Embassies": [
			{
				"SL. No.": 1,
				"name": "U.S Embassy, Dhaka"
			},
			{
				"SL. No.": 2,
				"name": "Australian High Commission Dhaka"
			},
			{
				"SL. No.": 3,
				"name": "Embassy of the Kingdom of the Netherlands"
			},
			{
				"SL. No.": 4,
				"name": "European Union Delegation to Bangladesh"
			},
			{
				"SL. No.": 5,
				"name": "Embassy of Japan, Dhaka"
			},
			{
				"SL. No.": 6,
				"name": "The Embassy of Switzerland"
			},
			{
				"SL. No.": 7,
				"name": "Embassy of Sweden Dhaka"
			},
			{
				"SL. No.": 8,
				"name": "Embassy of the State of Qatar Dhaka"
			},
			{
				"SL. No.": 9,
				"name": "Embassy of the State of Kuwait in Dhaka"
			},
			{
				"SL. No.": 10,
				"name": "Embassy of the State of Palestine"
			},
			{
				"SL. No.": 11,
				"name": "High Commission of Brunei Darussalam"
			},
			{
				"SL. No.": 12,
				"name": "High Commission Of Malaysia"
			},
			{
				"SL. No.": 13,
				"name": "Embassy of the DPR of Korea, Dhaka"
			},
			{
				"SL. No.": 14,
				"name": "Embassy of The People's Republic of China"
			},
			{
				"SL. No.": 15,
				"name": "Korean Embassy"
			},
			{
				"SL. No.": 16,
				"name": "High Commission of Canada, Dhaka"
			},
			{
				"SL. No.": 17,
				"name": "British High Commission Medical Centre (Elizabeth House) British High Commission Dhaka"
			},
			{
				"SL. No.": 18,
				"name": "Consultant of the Republic of Singapore, Dhaka"
			},
			{
				"SL. No.": 19,
				"name": "Royal Bhutanese Embassy"
			},
			{
				"SL. No.": 20,
				"name": "Embassy of the Federal Republic of Germany"
			},
			{
				"SL. No.": 21,
				"name": "Embassy of the Republic of Turkey"
			},
			{
				"SL. No.": 22,
				"name": "British High Commission Medical Centre (Elizabeth House) British High Commission, Dhaka"
			}
		],
		"Other Companies": [
			{
				"SL. No.": 1,
				"name": "The Hongkong And Shanghai Banking Corporation Limited (HSBC)"
			},
			{
				"SL. No.": 2,
				"name": "Linde Bangladesh Limited"
			},
			{
				"SL. No.": 3,
				"name": "Rahimafrooz(Bangladesh)Limited(Batteries Ltd.,Distribution Ltd.,Superstores Ltd.,Energy Services Ltd.,CNG Ltd.Renewable Energy Ltd.,Excel Resources Ltd.,Globatt Ltd.,Arzed Ltd., Grayfeb Ltd.)"
			},
			{
				"SL. No.": 4,
				"name": "Independent Television Limited"
			},
			{
				"SL. No.": 5,
				"name": "BS GROUP"
			},
			{
				"SL. No.": 6,
				"name": "IPDC"
			},
			{
				"SL. No.": 8,
				"name": "Dhaka Electric Supply Company Limited (DESCO)"
			},
			{
				"SL. No.": 10,
				"name": "4 - M Associates"
			},
			{
				"SL. No.": 11,
				"name": "Bank Asia"
			},
			{
				"SL. No.": 12,
				"name": "Gemcon Group"
			},
			{
				"SL. No.": 13,
				"name": "Paradise Group"
			},
			{
				"SL. No.": 14,
				"name": "Genuity System Ltd"
			},
			{
				"SL. No.": 15,
				"name": "Proshika"
			},
			{
				"SL. No.": 16,
				"name": "Newtop Trading Limited"
			},
			{
				"SL. No.": 17,
				"name": "Bangladesh Corrugated Carton & Accessories Manufacturers & Exporters Association (BCCAMEA)"
			},
			{
				"SL. No.": 18,
				"name": "BSRM Group of Companies (BSRM Steel Ltd,Bangladesh Steel Re-Rolling)"
			},
			{
				"SL. No.": 19,
				"name": "North South University"
			},
			{
				"SL. No.": 20,
				"name": "Partners in Population and Development (PPD)"
			},
			{
				"SL. No.": 21,
				"name": "Energypac Power Generation Limited"
			},
			{
				"SL. No.": 22,
				"name": "Bangladesh Olympic Association (BOA)"
			},
			{
				"SL. No.": 23,
				"name": "NAK Fashion & Textiles Limited"
			},
			{
				"SL. No.": 24,
				"name": "The City Bank Limited"
			},
			{
				"SL. No.": 25,
				"name": "Grace International School"
			},
			{
				"SL. No.": 26,
				"name": "Saaol Bangladesh"
			},
			{
				"SL. No.": 27,
				"name": "Premier LP Gas Limited"
			},
			{
				"SL. No.": 28,
				"name": "Uttara Group of Companies (Uttara motor, Automobiles, Automobiles Mnufactures, Tyre retreading co. apparels, Honkong JVC, services, menoka motors)"
			},
			{
				"SL. No.": 29,
				"name": "Integrated Security Services Limited (ISSL)"
			},
			{
				"SL. No.": 30,
				"name": "GSB International Consultant"
			},
			{
				"SL. No.": 31,
				"name": "Meghnaghat Power Limited"
			},
			{
				"SL. No.": 32,
				"name": "Gulf Oil Bangladesh Limited"
			},
			{
				"SL. No.": 33,
				"name": "Bangladesh Power Development Board (BPDB)"
			},
			{
				"SL. No.": 34,
				"name": "Compassion International Bangladesh"
			},
			{
				"SL. No.": 35,
				"name": "Ascott The Residence"
			},
			{
				"SL. No.": 36,
				"name": "Gulshan Society"
			},
			{
				"SL. No.": 37,
				"name": "Ideal Plus"
			},
			{
				"SL. No.": 38,
				"name": "Total E&P Bangladesh"
			},
			{
				"SL. No.": 39,
				"name": "American International University Bangladesh (AIUB)"
			},
			{
				"SL. No.": 40,
				"name": "Viyellatex Group (Garments, Fabrics, Spinning, Printing, Interfab Shirt, Fashion Plastic)"
			},
			{
				"SL. No.": 41,
				"name": "Jalal Ahmed Spinning Mills Ltd"
			},
			{
				"SL. No.": 42,
				"name": "Madina Hazz Kafilla & Oversease Ltd."
			},
			{
				"SL. No.": 43,
				"name": "Bashundhara Group"
			},
			{
				"SL. No.": 45,
				"name": "Rotaract District Organization"
			},
			{
				"SL. No.": 46,
				"name": "Prime Bank Limited"
			},
			{
				"SL. No.": 47,
				"name": "Jamuna Investment & Commerce Multipurpose Co-operative Society Ltd."
			},
			{
				"SL. No.": 48,
				"name": "Nokon Limited"
			},
			{
				"SL. No.": 49,
				"name": "Schlumberger Seaco Inc."
			},
			{
				"SL. No.": 50,
				"name": "IDLC Finance Limited"
			},
			{
				"SL. No.": 51,
				"name": "Lake View Clinic"
			},
			{
				"SL. No.": 52,
				"name": "BRAC Bank Limited"
			},
			{
				"SL. No.": 53,
				"name": "Gulshan Youth Club"
			},
			{
				"SL. No.": 54,
				"name": "United Commercial Bank Ltd. (UCBL)"
			},
			{
				"SL. No.": 55,
				"name": "NDB Capital Limited"
			},
			{
				"SL. No.": 56,
				"name": "Star Point Rewards Bangladesh Limited & Healthcare Privilege"
			},
			{
				"SL. No.": 57,
				"name": "Bangladesh Association of International Recruiting Agencies (BAIRA)"
			},
			{
				"SL. No.": 58,
				"name": "ICDDR,B Dhaka Hospital"
			},
			{
				"SL. No.": 59,
				"name": "Canadian International School, Dhaka"
			},
			{
				"SL. No.": 61,
				"name": "Bangladesh Bank"
			},
			{
				"SL. No.": 63,
				"name": "Bank Alfalh Limited"
			},
			{
				"SL. No.": 65,
				"name": "Rahman Rahman Huq"
			},
			{
				"SL. No.": 67,
				"name": "NAVANA Group"
			},
			{
				"SL. No.": 68,
				"name": "DHAKA BANK LIMITED"
			},
			{
				"SL. No.": 69,
				"name": "Concord Group of Companies"
			},
			{
				"SL. No.": 70,
				"name": "Bashundhara Amusement Park LTD."
			},
			{
				"SL. No.": 71,
				"name": "The Westin Dhaka"
			},
			{
				"SL. No.": 72,
				"name": "Baridhara DOHS Association"
			},
			{
				"SL. No.": 73,
				"name": "Bangladesh - Malaysia Chamber of Commerce and Industry"
			},
			{
				"SL. No.": 74,
				"name": "BAY DEVELOPMENTS"
			},
			{
				"SL. No.": 75,
				"name": "Transcom Group"
			},
			{
				"SL. No.": 76,
				"name": "World Vision Bangladesh"
			},
			{
				"SL. No.": 77,
				"name": "Gulshan Group Clinic"
			},
			{
				"SL. No.": 78,
				"name": "Sheraton Hotel"
			},
			{
				"SL. No.": 79,
				"name": "Heidelbergcement Bangladesh Ltd"
			},
			{
				"SL. No.": 80,
				"name": "Protishabda Communications Ltd"
			},
			{
				"SL. No.": 81,
				"name": "Renaissance Digonto Unmochon Foundation"
			},
			{
				"SL. No.": 82,
				"name": "NASSA Group"
			},
			{
				"SL. No.": 83,
				"name": "Mercantile Bank Limited"
			},
			{
				"SL. No.": 84,
				"name": "Creative Consulting (Malaysian & China Student Visa Processing Firm)"
			},
			{
				"SL. No.": 85,
				"name": "PROAMS"
			},
			{
				"SL. No.": 86,
				"name": "International Turkish Hope School"
			},
			{
				"SL. No.": 87,
				"name": "Expressions Limited"
			},
			{
				"SL. No.": 88,
				"name": "Hotel Agrabad Chittagong"
			},
			{
				"SL. No.": 89,
				"name": "Sunshine Education Group (SEG)"
			},
			{
				"SL. No.": 90,
				"name": "Index Group"
			},
			{
				"SL. No.": 91,
				"name": "GRAMEEN TELECOM TRUST"
			},
			{
				"SL. No.": 92,
				"name": "BAY FOOTWEAR LIMITED"
			},
			{
				"SL. No.": 93,
				"name": "FIRST SECURITY ISLAMI CAPITAL & INVESTMENT LIMITED"
			},
			{
				"SL. No.": 94,
				"name": "Shakti Foundation"
			},
			{
				"SL. No.": 95,
				"name": "ABB Limited"
			},
			{
				"SL. No.": 96,
				"name": "Family Health Practice"
			},
			{
				"SL. No.": 97,
				"name": "National Bank Limited"
			},
			{
				"SL. No.": 98,
				"name": "Nitol-Niloy Group"
			},
			{
				"SL. No.": 99,
				"name": "Bengal Glass"
			},
			{
				"SL. No.": 100,
				"name": "HABIB BANK LIMITED"
			},
			{
				"SL. No.": 101,
				"name": "Sangen International (Embassy of China Visa Applicant)"
			},
			{
				"SL. No.": 102,
				"name": "Premier Club Member of Dhaka Regency Hotel & Resort Limited"
			},
			{
				"SL. No.": 103,
				"name": "United Maritime Academy"
			},
			{
				"SL. No.": 104,
				"name": "PFI Securities Limited"
			},
			{
				"SL. No.": 105,
				"name": "Azim Group of Companies"
			},
			{
				"SL. No.": 106,
				"name": "Building Technology & Ideas Limited"
			},
			{
				"SL. No.": 107,
				"name": "British Bangladesh Chamber of Commerce U.K"
			},
			{
				"SL. No.": 108,
				"name": "INTRACO GROUP"
			},
			{
				"SL. No.": 109,
				"name": "Sydney International School (SIS)"
			},
			{
				"SL. No.": 110,
				"name": "Unique Group of Companies Limited"
			},
			{
				"SL. No.": 111,
				"name": "Beximco Chemical Division (Beximco Pharmaceuticals Ltd, Pharmatek Chemicals Ltd, I & I Service, Ltd Bangladesh Antibiotic Ltd, Shuktara Printers Ltd.)"
			},
			{
				"SL. No.": 112,
				"name": "FCI (BD) Limited"
			},
			{
				"SL. No.": 113,
				"name": "Talisman Limited"
			},
			{
				"SL. No.": 114,
				"name": "Hotel Holiday Villagram"
			},
			{
				"SL. No.": 116,
				"name": "Social Islami Bank Limited"
			},
			{
				"SL. No.": 117,
				"name": "Bangla Trac Group"
			},
			{
				"SL. No.": 118,
				"name": "BAY OF BENGAL INITIATIVE FOR MULTI-SECTORAL TECHNICAL AND ECONOMIC COOPERATION (BIMSTEC)"
			},
			{
				"SL. No.": 120,
				"name": "BEXIMCO LIMITED, TEXTILES DIVISION"
			},
			{
				"SL. No.": 121,
				"name": "Bengal Group of Industries (RTV, Bengal Plastic, Pipe, Polymer, Adhesive, Solar, Poly Pack, Overseas, Concept & Holdings)"
			},
			{
				"SL. No.": 122,
				"name": "Moon Hospital Limited"
			},
			{
				"SL. No.": 123,
				"name": "R-Three Corporation (Embassy of China Visa Applicant)"
			},
			{
				"SL. No.": 124,
				"name": "HT Global (Embassy of China Visa Applicant)"
			},
			{
				"SL. No.": 125,
				"name": "Bhuiah Construction Narayanganj"
			},
			{
				"SL. No.": 126,
				"name": "Meridian Group"
			},
			{
				"SL. No.": 127,
				"name": "EXPORT IMPORT BANK OF BANGLADESH LIMITED (EXIM BANK)"
			},
			{
				"SL. No.": 128,
				"name": "Doreen Group (Seven Horse Cement, Doreen Developments, Doreen Engineering & Construction, Doreen Power, Doreen RMG & Textiles)"
			},
			{
				"SL. No.": 129,
				"name": "Cox'sbazar Medical Campaign"
			},
			{
				"SL. No.": 130,
				"name": "Standard Group"
			},
			{
				"SL. No.": 131,
				"name": "Seema Rob"
			},
			{
				"SL. No.": 132,
				"name": "ZARIN CONSULTING (SINGAPORE)"
			},
			{
				"SL. No.": 133,
				"name": "Union Bank Limited"
			},
			{
				"SL. No.": 134,
				"name": "Prime Bank Limited Card Holder"
			},
			{
				"SL. No.": 135,
				"name": "United Group Waiters & Cooks"
			},
			{
				"SL. No.": 136,
				"name": "NTPC Limited (A Govt. of India Enterprise)"
			},
			{
				"SL. No.": 137,
				"name": "M & J Group"
			},
			{
				"SL. No.": 138,
				"name": "Bangladesh Export Import Company (BEXIMCO) IT Limited"
			},
			{
				"SL. No.": 139,
				"name": "Rangs Group (DHS Motors Ltd, Rangs Ltd, Rangs Motors Ltd, Rancon Motors Ltd, Rancon Automobiles Ltd, Rangs Workshop Ltd, Rangs Properties Ltd, Rancon Distributions Ltd, Rancon)"
			},
			{
				"SL. No.": 140,
				"name": "BEXIMCO IT (BOL)"
			},
			{
				"SL. No.": 141,
				"name": "The Daily Kaler Kantho"
			},
			{
				"SL. No.": 142,
				"name": "AUKO - TEX GROUP"
			},
			{
				"SL. No.": 143,
				"name": "RAK CERAMICS (BD) LIMITED"
			},
			{
				"SL. No.": 144,
				"name": "KALLOL GROUP OF COMPANIES"
			},
			{
				"SL. No.": 145,
				"name": "UNITED FINANCE LIMITED"
			},
			{
				"SL. No.": 146,
				"name": "First Security Islami Bank Limited"
			},
			{
				"SL. No.": 147,
				"name": "Apex Adelchi Footwear Limited"
			},
			{
				"SL. No.": 148,
				"name": "Abul Khair Group"
			},
			{
				"SL. No.": 149,
				"name": "Bangladesh Edible Oil Limited (BEOL)"
			},
			{
				"SL. No.": 150,
				"name": "SHAHABUDDIN MEDICAL COLLEGE HOSPITAL"
			},
			{
				"SL. No.": 151,
				"name": "Embassy of the Russian Federation in the People's Republic of Bangladesh"
			},
			{
				"SL. No.": 152,
				"name": "Observe (Embassy of China Visa Applicant)"
			},
			{
				"SL. No.": 153,
				"name": "Edison Group"
			},
			{
				"SL. No.": 154,
				"name": "Embassy of Nepal, Dhaka"
			},
			{
				"SL. No.": 155,
				"name": "Glaxosmithkline Bangladesh Limited"
			},
			{
				"SL. No.": 156,
				"name": "Citibank N.A."
			},
			{
				"SL. No.": 157,
				"name": "Association of Travel Agents of Bangladesh (ATAB)"
			},
			{
				"SL. No.": 158,
				"name": "Japan-Bangladesh Medical Association (JBMA)"
			},
			{
				"SL. No.": 159,
				"name": "Khulna Information Centre, UHL"
			},
			{
				"SL. No.": 160,
				"name": "Bangladesh - Turkish Group"
			},
			{
				"SL. No.": 161,
				"name": "NRB GLOBAL BANK LTD"
			},
			{
				"SL. No.": 162,
				"name": "RUPALI LIFE INSURANCE COMPANY LIMITED (Staffs & Dependants)"
			},
			{
				"SL. No.": 163,
				"name": "BAYER CROPSCIENCE LIMITED BANGLADESH"
			},
			{
				"SL. No.": 164,
				"name": "AB BANK LIMITED"
			},
			{
				"SL. No.": 167,
				"name": "MHADI SUPPORT SERVICES LIMITED"
			},
			{
				"SL. No.": 168,
				"name": "ASK Overseas Medical Department"
			},
			{
				"SL. No.": 169,
				"name": "MIDLAND BANK LIMITED (VISA Platinum Credit Card Holders)"
			},
			{
				"SL. No.": 170,
				"name": "MUTUAL TRUST BANK LIMITED."
			},
			{
				"SL. No.": 171,
				"name": "SCB (VISA/ Master Signature, Platinum Credit & Debit Card Holders Only)"
			},
			{
				"SL. No.": 172,
				"name": "Ibrahim Medinet Premier Services (IMPS)"
			},
			{
				"SL. No.": 173,
				"name": "Kleider Sourcing Limited"
			},
			{
				"SL. No.": 174,
				"name": "FX Import Hong Kong Limited"
			},
			{
				"SL. No.": 175,
				"name": "Anand Fashions International LLC"
			},
			{
				"SL. No.": 176,
				"name": "Zamira Fashions Limited"
			},
			{
				"SL. No.": 177,
				"name": "Simple Approach Limited"
			},
			{
				"SL. No.": 178,
				"name": "Poeticgem International Limited"
			},
			{
				"SL. No.": 179,
				"name": "Krayons Sourcing Limited"
			},
			{
				"SL. No.": 180,
				"name": "Bengal Communications Limited"
			},
			{
				"SL. No.": 181,
				"name": "NATIONAL CREDIT AND COMMERCE BANK LIMITED (NCC BANK LTD.)"
			},
			{
				"SL. No.": 182,
				"name": "Norwest Industries Limited"
			},
			{
				"SL. No.": 183,
				"name": "Industrial and Infrastructure Development Finance Company Limited (IIDFC)"
			}
		]
	};

/***/ },
/* 861 */
/***/ function(module, exports) {

	module.exports = [
		{
			"Sl_No": "01",
			"file": "_ARK2882",
			"type": "VIP Suite (Patient Room)",
			"price": "30,000.00"
		},
		{
			"Sl_No": "03",
			"file": "_ARK2885",
			"type": "Deluxe Single",
			"price": "13,000.00"
		},
		{
			"Sl_No": "05",
			"file": "_ARK2984",
			"type": "Standard Single",
			"price": "10,000.00"
		},
		{
			"Sl_No": "07",
			"file": "_ARK2986",
			"type": "Triple Bedded Room",
			"price": "4,000.00"
		},
		{
			"Sl_No": "09",
			"file": "_ARK2987",
			"type": "General Ward",
			"price": "4,200.00"
		},
		{
			"Sl_No": "11",
			"file": "_ARK2991",
			"type": "Oncology Ward",
			"price": "3,500.00"
		}
	];

/***/ },
/* 862 */
/***/ function(module, exports) {

	module.exports = [
		{
			"id": 8,
			"doctor_id": "13",
			"testimonial_title": "New test",
			"testimonial_desc": "<p>Good doctor</p>",
			"author_name": "Life insurance",
			"author_profile_pic": "202402271144testimonial.jpg",
			"rating": "2",
			"serial_order": null,
			"status": "1",
			"created_at": "2024-02-27T11:44:03.000000Z",
			"updated_at": "2024-02-27T11:45:54.000000Z",
			"doctor_mave": {
				"id": 13,
				"doctor_id": null,
				"doctor_name": "Dr. Nusrat  Zaman",
				"degree": "MBBS, FCPS",
				"uhl_id": "EID-11727",
				"bmdc_id": "A 10707",
				"dept_id": "85",
				"doctor_profile": "2022100410311475999728_2_dr nusrat zaman.jpg",
				"doctor_fees": "1500",
				"doctor_desc": "<p>Specialized Training</p><ul><li>Regional Fellow (WHO) on Maternal &amp; Child Health, Primary Health Care in Christian Medical College, Vellore, Chennai, India</li><li>Training on Clinical Contrception Service Delivery &amp; RTI/STI case management in Sichuan Reproductive Health Institute, Chengdu, China.</li><li>Gynecological Endoscopy (Laparoscopy, Hysteroscopy &amp; Colposcopy)</li><li>Infertility Management-IUI</li><li>Urogynaecology-Fistula Surgery</li><li>Emergency Obstetric care (EmOC) Competency Based Training</li></ul><p>Training on Research:</p><ul><li>Qualitative Research Methodology- by University of Melbourne</li><li>Research Methodology, Bioethics and Medical Education-BMRC</li><li>Syndromic Management of RTI/STI-WHO</li></ul><p>Teaching Experience</p><ol><li>Post Graduate Teaching in DGO, MCPS, FCPS &amp; MS Courses in all Medical Colleges and Post Graduate Institutes</li><li>Undergraduate MBBS teaching in different Medical Colleges</li><li>Consultants and Other Service Provider teaching in Reproductive Health, Emergency Obstetric Care Services, SBA &amp; Midwifery Practices, Maternal Nutrition, Breast Feeding, Infection Prevention Practices.</li></ol>",
				"doctor_edu": "<ul><li>MBBS, Sher E Bangla Medical College &amp; Hospital, 1982</li><li>FCPS from BCPS; 1989</li></ul><p><br></p>",
				"doctor_exp": "<ol><li>Associate Professor(Ob/Gyn)-Institute of Child &amp; Mother Health (ICMH) 2004 to 2008.</li><li>Associate Professor &amp; Head of the Dept(Ob/Gyn)-Comilla Medical College,2001-2004.</li><li>Senior Consultant(Ob/Gyn)-Sir Salimullah Medical College &amp; Mitford Hospital,1998-2001.</li><li>Senior Consultant(Ob/Gyn)-Dhaka Medical College Hospital,1996-1998.</li><li>Junior Consultant(Ob/Gyn)-Govt. Employees Hospital &amp; DGHS,1993-1996.</li><li>Resident Surgeon &amp; Registrar-Sir Salimullah Medical Hospital &amp; MH,1989-1993.</li><li>Assistant Registrar &amp; IST- BSMMU (Ex IPGMR),1982-1989.&nbsp;</li></ol><p><br></p>",
				"status": "1",
				"is_deleted": "0",
				"created_at": "-000001-11-30T00:00:00.000000Z",
				"updated_at": "2023-10-17T01:21:20.000000Z",
				"Schedule": "[{\"Monday\":\"10:00 AM - 06:00 PM\",\"Friday\":\"10:00 AM - 06:00 PM\",\"Sunday\":\"10:00 AM - 06:00 PM\",\"Wednesday\":\"10:00 AM - 06:00 PM\",\"Thrusday\":\"10:00 AM - 06:00 PM\",\"Tuesday\":\"10:00 AM - 06:00 PM\",\"Saturday\":\"10:00 AM - 06:00 PM\"}]",
				"slug": "dr-nusrat-zaman",
				"department_mave": {
					"id": 85,
					"dept_id": "85",
					"department_name": "Obstetrics & Gynaecology",
					"department_desc_one": "<p><strong>Best Gynecologists in Dhaka, Bangladesh</strong></p><p>United Hospital’s Mother and Child Care has skilled gynecologists to ensure mother and baby are in safe hands. United Hospital with one of the best gynecologists in Dhaka offers the best treatment for multiple health issues faced by women. We offer excellent diagnostic, therapeutic, surgical and counselling services in the country.</p><p>United Hospital’s Obs &amp; Gynae Department/Mother &amp; Child Care Centre in Dhaka is dedicated to giving better than their best in terms of clinical support, proper guidance and healthcare for women and children through our best gynecologists in Dhaka, Bangladesh.</p><p>&nbsp;A Gynecologist is a doctor who specializes in the medical care of women and their reproductive systems, confirms the pregnancy and deals with mammograms, pap smear, uterine or vaginal infections, fertility problems or contraception, tubal ligations and hysterectomies.</p><p>An Obstetrician is a doctor who specializes in the surgical care of women and their children during pregnancy, delivery/childbirth and post-natal care.</p><p>Gynecologists offer preventive reproductive health care and treat diseases while obstetricians deliver babies and care for mother and baby during post-delivery.</p><p>Gynecology deals with the female reproductive organs and Obstetrics deals with the care of women and their offsprings during pregnancy, childbirth and for a period of time following birth.&nbsp;</p><p>We have a long list of treatments and services on offer at our well-equipped and avant-garde center. Some of them include painless delivery and management of high-risk pregnancies, management of normal and instrumental delivery, Laparoscopic Surgeries - Diagnostic &amp; Therapeutic, Tubectomy, Hysteroscopy - Diagnostic &amp; Therapeutic, Laparoscopic Abdominal Vaginal Hysterectomy, Non-descent Vaginal Hysterectomy and Transabdominal Hysterectomy. Providing ample support to our obstetrics and gynaecologists is a skilled team of Perinatologist, Cardiologists, Haematologists, Neonatologists and Intensive Care Specialists. Our delivery rooms and gynaecology conversant operation theatres boast of advanced and modern equipment. Additionally, we have experts and facilities to treat gynaecological cancers.</p>",
					"department_desc_two": "<h2>WE HAVE 24 HOURS OBSTETRICS &amp; GYNECOLOGY, NEONATAL AND PEDIATRICS EMERGENCY SERVICES WITH THE FOLLOWING FACILITIES:</h2><ul><li>State-of-the-art operation theatres</li><li>Neonatal &amp; Pediatrics ICU</li><li>Nursery</li><li>Neonatal ventilator for critical respiratory care</li><li>Giraffe omni bed incubator</li><li>Neonatal &amp; Pediatrics cardiac care</li><li>Phototherapy unit</li><li>Closed incubator / radiant warmer</li><li>Follow up clinic for high risk newborns</li><li>Vaccination centre</li><li>Parenteral nutrition</li></ul>",
					"department_desc_three": "<h2>COLPOSCOPY</h2><p>A pain less non-surgical procedure to get a close-up view of the cervix. It is used to detect abnormal cells on the cervix and the area near the cervix. During a Colposcopy procedure, a doctor uses a colposcope - an instrument that looks like binoculars with a bright light mounted on a stand.</p><p>A colposcopy may be needed when</p><ul><li>&nbsp;You have abnormal Pap Smear or HPV test results</li><li>&nbsp;Your cervix looks abnormal during a gynecological exam</li><li>&nbsp;You need to find the cause of unexplained bleeding or other problems</li></ul><p>At United Hospital ground floor ObGyn OPD (OPD 2 Ground floor), Colposcopy is being performed by skilled female doctors.</p><h2>CONSULTATION &amp; APPOINTMENT</h2><p>Obstetrics &amp; Gynaecology&nbsp;Department provides consultation services in Ground Floor (OPD 2) through highly qualified and experienced Consultants.</p>",
					"department_desc_four": "<h2>DELIVERY PACKAGES</h2><p>&nbsp;</p>",
					"department_desc_five": "<h2>DOORSTEP SAMPLE COLLECTION PACKAGES</h2><p><strong>Doorstep Sample Collection Packages:</strong></p><p>Given the multitude of roles and tasks a woman performs daily needs to be in the best of health. That’s why she needs regular health check-up. Appreciating the importance of health tests and understanding the need for making diagnostic services user-friendly, to ensure that high-quality health care becomes more accessible to the community, United Hospital has extended its services to Home Sample Collection, all across Dhaka city from Motijheel to Uttara. As the name suggests, Home Sample Collection is a service wherein phlebotomist representatives of United Hospital will collect samples to provide diagnostic services at customer's doorstep. The hospital has a network of phlebotomists and an easy call facility whereupon receiving a call, trained phlebotomist will arrive at the doorstep of the patient to collect samples to ensure patients get the best of services within the comfort of their own homes. Home sample collection is especially beneficial to the pregnant women, elderly, chronically ill patients, patients recovering post-surgery and bedridden. With home sample collection, one can get tests done timely and have a better track of health. This service helps to provide a fuller, healthier life. So, Spend less to stay healthy, assess your health right at your home by availing active care female package (above 45 years) and well women package (female up to 45 years). Call 0191 400 1301 to book the packages.</p><p><strong>ACTIVE CARE PACKAGE</strong></p><p><strong><em>Female: Above 45 years</em></strong></p><p>• CBC &amp; ESR</p><p>• Fasting Blood Sugar</p><p>• Liver Function Test</p><p>- Serum Bilirubin (Total)</p><p>- Serum ALT (SGPT)</p><p>- Serum AST (SGOT)</p><p>- Serum Alkaline Phosphatase</p><p>• Fasting Lipid Profile</p><p>- Serum Total Cholesterol</p><p>- Serum HDL Cholesterol</p><p>- Serum LDL Cholesterol</p><p>- Serum Triglycerides (TG)</p><p>• Renal Function Test</p><p>- Serum Creatinine</p><p>- Serum Urea</p><p>- Serum Uric Acid</p><p>- e-GFR (patient above 18 years of age)</p><p>• Serum TSH</p><p>• Urine R/E</p><p><strong>Tariff BDT&nbsp;<s>8,850.00</s>&nbsp;6,650.00</strong></p><p><em>*Price inclusive of Home Sample collection charge</em></p><p>•&nbsp;<strong><em>Screening Check-up:&nbsp;</em></strong><em>To know the general fitness level and</em></p><p><em>assess common disease risks</em></p><p><strong>WELL WOMEN PACKAGE</strong></p><p><strong><em>Female up to 45 years</em></strong></p><p>• CBC &amp; ESR</p><p>• Random Blood Sugar</p><p>• Liver Function Test</p><p>- Serum Bilirubin (Total)</p><p>- Serum ALT (SGPT)</p><p>- Serum AST (SGOT)</p><p>- Serum Alkaline Phosphatase</p><p>• Renal Function Test</p><p>- Serum Creatinine</p><p>- Serum Urea</p><p>- Serum Uric Acid</p><p>- e-GFR (patient above 18 years of age)</p><p>• Hepatitis B &amp; C</p><p>- Serum HBsAg</p><p>- Serum HCV/Anti HCV</p><p>• Serum Rubella IgM</p><p>• Serum TSH</p><p>• Urine R/E</p><p><strong>Tariff BDT&nbsp;<s>11,500.00&nbsp;</s>8,600.00</strong></p><p><em>*Price inclusive of Home Sample collection charge</em></p><p>•&nbsp;<strong><em>Screening Check-up in younger women:&nbsp;</em></strong><em>To remain aware of the</em></p><p><em>common health problems and assess the disease risk parameters</em></p>",
					"image": "baby.png",
					"banner_image": "",
					"status": "1",
					"is_deleted": "0",
					"created_at": "-000001-11-30T00:00:00.000000Z",
					"updated_at": "2023-07-15T15:02:58.000000Z",
					"has_package": "0",
					"slug": "obstetrics-gynaecology"
				}
			}
		},
		{
			"id": 5,
			"doctor_id": "2",
			"testimonial_title": "Test Testimonial asd as",
			"testimonial_desc": "<p>Hello World</p>",
			"author_name": "Medical health care",
			"author_profile_pic": "202402050533download.png",
			"rating": "5",
			"serial_order": null,
			"status": "1",
			"created_at": "2024-02-05T05:33:08.000000Z",
			"updated_at": "2024-02-25T13:13:34.000000Z",
			"doctor_mave": {
				"id": 2,
				"doctor_id": "2",
				"doctor_name": "Dr. Mohammad Mahabub -Ul- Amin",
				"degree": "",
				"uhl_id": "EID-10519",
				"bmdc_id": "A-22397",
				"dept_id": "0",
				"doctor_profile": null,
				"doctor_fees": "1500",
				"doctor_desc": null,
				"doctor_edu": null,
				"doctor_exp": null,
				"status": "0",
				"is_deleted": "1",
				"created_at": "-000001-11-30T00:00:00.000000Z",
				"updated_at": "2023-10-17T01:21:19.000000Z",
				"Schedule": "[{\"Monday\":\"08:00 AM - 11:00 AM\",\"Friday\":null,\"Sunday\":\"08:00 AM - 11:00 AM\",\"Wednesday\":\"08:00 AM - 11:00 AM\",\"Thrusday\":\"08:00 AM - 11:00 AM\",\"Tuesday\":\"08:00 AM - 11:00 AM\",\"Saturday\":\"08:00 AM - 11:00 AM\"}]",
				"slug": "dr-mohammad-mahabub-ul-amin",
				"department_mave": null
			}
		},
		{
			"id": 4,
			"doctor_id": "15",
			"testimonial_title": "Demo title",
			"testimonial_desc": "Intensive care for patient",
			"author_name": "Life insurance",
			"author_profile_pic": "202402271141img2(2).jpg",
			"rating": "3",
			"serial_order": null,
			"status": "1",
			"created_at": "2023-12-19T04:05:44.000000Z",
			"updated_at": "2024-02-27T11:41:27.000000Z",
			"doctor_mave": {
				"id": 15,
				"doctor_id": null,
				"doctor_name": "Dr. Halima  Akhtar",
				"degree": "MBBS, MCPS",
				"uhl_id": "EID-11828",
				"bmdc_id": "A-23079",
				"dept_id": "85",
				"doctor_profile": "2022100410291639460461_2_1623229117_2_Dr. Halima IMG_4849.jpg",
				"doctor_fees": "1500",
				"doctor_desc": null,
				"doctor_edu": null,
				"doctor_exp": null,
				"status": "1",
				"is_deleted": "0",
				"created_at": "-000001-11-30T00:00:00.000000Z",
				"updated_at": "2023-10-17T01:21:20.000000Z",
				"Schedule": "[{\"Monday\":\"06:00 PM - 09:00 PM\",\"Friday\":\"06:00 PM - 09:00 PM\",\"Sunday\":\"06:00 PM - 09:00 PM\",\"Wednesday\":\"06:00 PM - 09:00 PM\",\"Thrusday\":\"06:00 PM - 09:00 PM\",\"Tuesday\":\"06:00 PM - 09:00 PM\",\"Saturday\":\"06:00 PM - 09:00 PM\"}]",
				"slug": "dr-halima-akhtar",
				"department_mave": {
					"id": 85,
					"dept_id": "85",
					"department_name": "Obstetrics & Gynaecology",
					"department_desc_one": "<p><strong>Best Gynecologists in Dhaka, Bangladesh</strong></p><p>United Hospital’s Mother and Child Care has skilled gynecologists to ensure mother and baby are in safe hands. United Hospital with one of the best gynecologists in Dhaka offers the best treatment for multiple health issues faced by women. We offer excellent diagnostic, therapeutic, surgical and counselling services in the country.</p><p>United Hospital’s Obs &amp; Gynae Department/Mother &amp; Child Care Centre in Dhaka is dedicated to giving better than their best in terms of clinical support, proper guidance and healthcare for women and children through our best gynecologists in Dhaka, Bangladesh.</p><p>&nbsp;A Gynecologist is a doctor who specializes in the medical care of women and their reproductive systems, confirms the pregnancy and deals with mammograms, pap smear, uterine or vaginal infections, fertility problems or contraception, tubal ligations and hysterectomies.</p><p>An Obstetrician is a doctor who specializes in the surgical care of women and their children during pregnancy, delivery/childbirth and post-natal care.</p><p>Gynecologists offer preventive reproductive health care and treat diseases while obstetricians deliver babies and care for mother and baby during post-delivery.</p><p>Gynecology deals with the female reproductive organs and Obstetrics deals with the care of women and their offsprings during pregnancy, childbirth and for a period of time following birth.&nbsp;</p><p>We have a long list of treatments and services on offer at our well-equipped and avant-garde center. Some of them include painless delivery and management of high-risk pregnancies, management of normal and instrumental delivery, Laparoscopic Surgeries - Diagnostic &amp; Therapeutic, Tubectomy, Hysteroscopy - Diagnostic &amp; Therapeutic, Laparoscopic Abdominal Vaginal Hysterectomy, Non-descent Vaginal Hysterectomy and Transabdominal Hysterectomy. Providing ample support to our obstetrics and gynaecologists is a skilled team of Perinatologist, Cardiologists, Haematologists, Neonatologists and Intensive Care Specialists. Our delivery rooms and gynaecology conversant operation theatres boast of advanced and modern equipment. Additionally, we have experts and facilities to treat gynaecological cancers.</p>",
					"department_desc_two": "<h2>WE HAVE 24 HOURS OBSTETRICS &amp; GYNECOLOGY, NEONATAL AND PEDIATRICS EMERGENCY SERVICES WITH THE FOLLOWING FACILITIES:</h2><ul><li>State-of-the-art operation theatres</li><li>Neonatal &amp; Pediatrics ICU</li><li>Nursery</li><li>Neonatal ventilator for critical respiratory care</li><li>Giraffe omni bed incubator</li><li>Neonatal &amp; Pediatrics cardiac care</li><li>Phototherapy unit</li><li>Closed incubator / radiant warmer</li><li>Follow up clinic for high risk newborns</li><li>Vaccination centre</li><li>Parenteral nutrition</li></ul>",
					"department_desc_three": "<h2>COLPOSCOPY</h2><p>A pain less non-surgical procedure to get a close-up view of the cervix. It is used to detect abnormal cells on the cervix and the area near the cervix. During a Colposcopy procedure, a doctor uses a colposcope - an instrument that looks like binoculars with a bright light mounted on a stand.</p><p>A colposcopy may be needed when</p><ul><li>&nbsp;You have abnormal Pap Smear or HPV test results</li><li>&nbsp;Your cervix looks abnormal during a gynecological exam</li><li>&nbsp;You need to find the cause of unexplained bleeding or other problems</li></ul><p>At United Hospital ground floor ObGyn OPD (OPD 2 Ground floor), Colposcopy is being performed by skilled female doctors.</p><h2>CONSULTATION &amp; APPOINTMENT</h2><p>Obstetrics &amp; Gynaecology&nbsp;Department provides consultation services in Ground Floor (OPD 2) through highly qualified and experienced Consultants.</p>",
					"department_desc_four": "<h2>DELIVERY PACKAGES</h2><p>&nbsp;</p>",
					"department_desc_five": "<h2>DOORSTEP SAMPLE COLLECTION PACKAGES</h2><p><strong>Doorstep Sample Collection Packages:</strong></p><p>Given the multitude of roles and tasks a woman performs daily needs to be in the best of health. That’s why she needs regular health check-up. Appreciating the importance of health tests and understanding the need for making diagnostic services user-friendly, to ensure that high-quality health care becomes more accessible to the community, United Hospital has extended its services to Home Sample Collection, all across Dhaka city from Motijheel to Uttara. As the name suggests, Home Sample Collection is a service wherein phlebotomist representatives of United Hospital will collect samples to provide diagnostic services at customer's doorstep. The hospital has a network of phlebotomists and an easy call facility whereupon receiving a call, trained phlebotomist will arrive at the doorstep of the patient to collect samples to ensure patients get the best of services within the comfort of their own homes. Home sample collection is especially beneficial to the pregnant women, elderly, chronically ill patients, patients recovering post-surgery and bedridden. With home sample collection, one can get tests done timely and have a better track of health. This service helps to provide a fuller, healthier life. So, Spend less to stay healthy, assess your health right at your home by availing active care female package (above 45 years) and well women package (female up to 45 years). Call 0191 400 1301 to book the packages.</p><p><strong>ACTIVE CARE PACKAGE</strong></p><p><strong><em>Female: Above 45 years</em></strong></p><p>• CBC &amp; ESR</p><p>• Fasting Blood Sugar</p><p>• Liver Function Test</p><p>- Serum Bilirubin (Total)</p><p>- Serum ALT (SGPT)</p><p>- Serum AST (SGOT)</p><p>- Serum Alkaline Phosphatase</p><p>• Fasting Lipid Profile</p><p>- Serum Total Cholesterol</p><p>- Serum HDL Cholesterol</p><p>- Serum LDL Cholesterol</p><p>- Serum Triglycerides (TG)</p><p>• Renal Function Test</p><p>- Serum Creatinine</p><p>- Serum Urea</p><p>- Serum Uric Acid</p><p>- e-GFR (patient above 18 years of age)</p><p>• Serum TSH</p><p>• Urine R/E</p><p><strong>Tariff BDT&nbsp;<s>8,850.00</s>&nbsp;6,650.00</strong></p><p><em>*Price inclusive of Home Sample collection charge</em></p><p>•&nbsp;<strong><em>Screening Check-up:&nbsp;</em></strong><em>To know the general fitness level and</em></p><p><em>assess common disease risks</em></p><p><strong>WELL WOMEN PACKAGE</strong></p><p><strong><em>Female up to 45 years</em></strong></p><p>• CBC &amp; ESR</p><p>• Random Blood Sugar</p><p>• Liver Function Test</p><p>- Serum Bilirubin (Total)</p><p>- Serum ALT (SGPT)</p><p>- Serum AST (SGOT)</p><p>- Serum Alkaline Phosphatase</p><p>• Renal Function Test</p><p>- Serum Creatinine</p><p>- Serum Urea</p><p>- Serum Uric Acid</p><p>- e-GFR (patient above 18 years of age)</p><p>• Hepatitis B &amp; C</p><p>- Serum HBsAg</p><p>- Serum HCV/Anti HCV</p><p>• Serum Rubella IgM</p><p>• Serum TSH</p><p>• Urine R/E</p><p><strong>Tariff BDT&nbsp;<s>11,500.00&nbsp;</s>8,600.00</strong></p><p><em>*Price inclusive of Home Sample collection charge</em></p><p>•&nbsp;<strong><em>Screening Check-up in younger women:&nbsp;</em></strong><em>To remain aware of the</em></p><p><em>common health problems and assess the disease risk parameters</em></p>",
					"image": "baby.png",
					"banner_image": "",
					"status": "1",
					"is_deleted": "0",
					"created_at": "-000001-11-30T00:00:00.000000Z",
					"updated_at": "2023-07-15T15:02:58.000000Z",
					"has_package": "0",
					"slug": "obstetrics-gynaecology"
				}
			}
		},
		{
			"id": 3,
			"doctor_id": "1",
			"testimonial_title": "CARE",
			"testimonial_desc": "<p>Proper Care towards her patient</p>",
			"author_name": "Medical health care",
			"author_profile_pic": null,
			"rating": "5",
			"serial_order": null,
			"status": "1",
			"created_at": "2023-12-19T04:03:46.000000Z",
			"updated_at": "2023-12-19T04:03:46.000000Z",
			"doctor_mave": {
				"id": 1,
				"doctor_id": null,
				"doctor_name": "Dr. Kaisar Nasrullah Khan",
				"degree": "MBBS, FCPS (Med), MD (Card)",
				"uhl_id": "EID-10315",
				"bmdc_id": "A-21955",
				"dept_id": "16",
				"doctor_profile": "2023040505241476085950_2_dr kaisar.jpg",
				"doctor_fees": "1500",
				"doctor_desc": "<p><strong><u>Summary</u></strong></p><p>Alhamdulillah, I am a well trained and experienced medicine specialist and adult interventional &amp; clinical cardiologist. I have twenty six years of broad multinational experience of health systems. I try to deliver best evidence based medical and cardiovascular care to my patients. I can combat stressful situations and extreme emergencies in a very effective and decisive way. I am a confident and reliable medical practitioner who works as a team player with proficient communication skills. I have the skills and knowledge of training doctors and expertise in setting up coronary care unit at a very very busy referral Cardiac center.</p><p>&nbsp;<strong><u>Interest</u></strong></p><p>I take interest in developing skilled manpower like doctor, nurse and technician to develop interventional cardiology throughout the Bangladesh.</p><p>I take lecture on cardiology in different districts of Bangladesh to train general practitioner and cardiologist so that cardiac care can be reached to every patient of Bangladesh.</p><p>I also do public awareness program on “prevention and treatment of heart disease” in different parts of Bangladesh with general people and arrange “Free hart camp” with supply of cardiac medicine for one month for poor people with the help of pharmaceutical company.</p>",
				"doctor_edu": "<p><strong><u>Education</u></strong></p><ul><li>Fellow, Interventional Cardiology, Escorts Heart Institute &amp; Research Centre, New Delhi, India, 2004.</li><li>FCPS (Fellow of College&nbsp;&nbsp;of Physicians and Surgeons,Medicine), Bangladesh College of Physicians and Surgeons, Dhaka, Bangladesh, July 2002.</li><li>M.D (Doctor of Medicine,Cardiology), Dhaka University,Dhaka, Bangladesh, July 2001.</li><li>MBBS (Bachelor of Medicine &amp; Surgery), Sir Salimullah Medical College Dhaka, Bangladesh, July 1992.</li></ul><p><strong><u>Thesis</u></strong></p><ul><li>In Hospital outcome patients with primary ventricular fibrillation following acute myocardial infarction.</li><li>Department of Cardiology, National Institute of Cardiovascular Disease (NICVD) Sher-E-Bangla Nagar, Dhaka-2001.</li></ul><p><strong><u>Distinction/Award</u></strong></p><ul><li>Best challenging case award&nbsp;- symposium on interventional&nbsp;cardiology,Bangladesh&nbsp;Society of Cardiovascular Intervention (BSCI), 6th&nbsp;Aug&nbsp;2010.</li></ul><p><strong><u>Society membership</u></strong></p><ul><li>Secretary General, Bangladesh Society of Cardiovascular Intervention, 2016-till date.</li><li>Joint secretary, Bangladesh&nbsp;Society of Cardiovascular Intervention,2012-2016</li><li>Fellow, Society for Cardiovascular Angiography and Intervention, USA since 2012</li><li>Member, European Association of Percutaneous Cardiovascular Interventions (EAPCI)<strong><u>,</u></strong>since2006</li><li>Treasurer, Bangladesh Cardiac Society 2006-2012</li><li>Life member, The Chest &amp; Heart Association of Bangladesh,&nbsp;Since 2004.</li><li>Life member, Association of Physician of Bangladesh (APB), since 2002.</li><li>Life member, Bangladesh College of Physician &amp; Surgeon, Bangladesh, since 2002.</li><li>Life member, Bangladesh Medical Association,since2001</li></ul><p><br></p>",
				"doctor_exp": "<p><strong><u>Work History</u></strong></p><ul><li>Consultant, Clinical &amp; Interventional Cardiology, United Hospital Ltd., Gulshan, Dhaka (Jul 2006 - till date).</li><li>Consultant, Clinical &amp; Interventional Cardiology, Z.H. Sikdar Women’s Medical College &amp; Hospital (Pvt.) Ltd. Gulshan, Dhaka (Jan 2005-Jul 2006).</li><li>Fellow, Interventional Cardiology, Escorts heart institute &amp; Research Centre. New Delhi, India (Jan 2004 – Dec 2004).</li><li>Assistant Registrar, Cardiology, National Institute of Cardiovascular Disease. Dhaka (Jul 2001 – Dec 2003).</li><li>Resident, Cardiology, National Institute of Cardiovascular Disease. Dhaka (Jun 1999 – Jun 2001).</li><li>Assistant Registrar, Internal Medicine, Unit-1, Bangobandhu Sheikh Mujib Medical university (BSMMU), Dhaka (Mar 1997 – Jun 1999).</li><li>Assistant Registrar, Internal Medicine, Unit-3, Sylhet M.A.G. Osmani medical College and hospital, Sylhet (Mar 1996 – Mar 1997).</li><li>Medical Officer, Primary Health Care, Mahajanghat Union Health Sub Centre, Chittagong (Nov 1995 – Mar 1996).</li><li>Medical Officer, General Medicine, Institute of Postgraduate Medicine and Research (IPGMR), Dhaka (Jan 1994 – Jun 1995).</li><li>Medical Officer, General Medicine, Sir Salimullah Medical College and Hospital, Dhaka (Aug 1993 – Dec 1993).</li><li>Internee Doctor, General Medicine, Sir Salimullah Medical College and Hospital, Dhaka (Feb 1993 – Jul 1993).</li><li>Internee Doctor, General Surgery, Sir Salimullah Medical College and Hospital, Dhaka (Aug 1992 – Jan 1993).</li></ul><p><strong><u>Talk/Presentation</u></strong></p><ol><li>PCI is better than CABG in multivessel coronary artery disease-23rd&nbsp;national scientific Conference ,Bangladesh cardiac society, 4th&nbsp;May ,2007</li><li>Management of ACS: an update-2nd&nbsp;international conference on emergency medicine 2010,13 January, 2010.</li><li>Rotablation atherectomy-only device for calcified lesion-SAARC congress of cardiology 2010, 3rdApril, 2010.</li><li>Management of ACS: an update-21st&nbsp;annual conference and scientific essions, Association of physician of Bangladesh, 18-19 April, 2010</li><li>Intervention in Bangladesh-what we have achieved &amp; what yet to be!!-CME update on cardiology and cardiac surgery, Chittagong medical college hospital ,Bangladesh cardiac society, 23rd&nbsp;Dec, 2010</li><li>Ischaemic heart disease-19th&nbsp;annual conference of Bangladesh Medical Association,12th&nbsp;March,2011</li><li>Challenges in primary PCI-4th&nbsp;international cardiovascular conference, Ibrahim cardiac hospital &amp; research centre,22nd&nbsp;April 2011</li><li>Delayed perforation (after 2 hours) of first retrograde CTO recanalization of&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bangladesh: selected for presentation in complication session of EUROPCR 2011, France20th May,2011</li><li>Retrograde approach for coronary cto-2ndBangla intervention therapeutics, Kolkata, India, 5thfeb 2012.</li><li>My most difficult case-\"Breakfast symposium-&nbsp;Neighbors in arms-AICT INDIA 6th&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Oct 2012.</li><li>Pill in the pocket is still a valid treatment modality for infrequent atrial fibrillation?-XV international symposium on progress in clinical pacing 6th dec2012 in Rome, Italy.</li><li>\"Streptokinase- still relevant? - 64thAnnual CSI Conference and SAARC Cardiac Congress 9th dec 2012, New Delhi, India</li></ol><p><strong><u>Publication</u></strong></p><ol><li>Myocardial infarction in the young adults. Journal medical teacher’s federation 2001: Vo1 6 (2): 29-33.</li><li>Congenital coronary pulmonary arterio venous fistula in a patient with triple vessel disease- a case report. Bangladesh heart Journal January 2003 : Vo1 18 No. 1: 76-79</li><li>Congenital coronary artery Anomaly- Right coronary artery from left coronary sinus. Bangladesh heart Journal July 2003: Vo1 18 No. 2: 146-148.</li><li>Long term results after successful mitral balloon vulvuloplasty- experience of 1033 patient. Bangladesh journal of cardiology. March 2010:vol 01:no 03:194-200</li><li>Percuteneous Angioplasty and Stenting of Carotid Artery: Study of 18 Cases.</li><li>Cardiovasc. Journal. 2010; vol-2(2):218-222.</li><li>Primary angioplasty for the treatment of acute ST elevated Myocardial Infarction single centre experience. Cardiovascular journal January 2011, Vol: 3 No.2: 149-154.</li><li>Clinical outcome of overlapping of drug eluting stents (DES)-study of 200 cases. Journal of cardiovascular intervention January 2011:Vol 1 No 1:10-15.</li><li>Multi vessel PCI in the drug eluting stent era: Card-8 (abstract in scientific session) joint conference 2008, Bangladesh college of physicians and surgeons</li><li>Long term clinical and echo cartographic results after successful mitral balloon valvotomy and pediatrics of long term outcome (Card-05).&nbsp;(abstract in scientific session) joint conference 2008, Bangladesh college of physicians and surgeons</li><li>Correlation of Coronary Artery Disease (CAD) in patient having significant Renal Artery Stenosis (RAS) - A study of cases. (Card-7).</li><li>Microvascular obstruction in PCI-A review. University Heart Journal January2011:Vol 7 No. 1 :48-52</li><li>Correlation between Microalbuminuria with Complexity of Coronary Artery Disease in Diabetic Patients, Mymensingh Med J 2013 Apr; 22 (2): 353-357.</li><li>Immediate Outcome of Chronic Total Occlusion Opening in Post Angioplasty Patients, Mymensingh Med J 2013 Jul; 22 (3): 489-495.</li><li>Pulmonary Embolism – A Case Report: University Heart Journal; Jan 2016, vol-12, No-1, 40-44.</li><li>Primary Angioplasty for the Treatment of Acute ST ElevatedMyocardial Infarction: Single Centre Experience of Three and Half Years, Mymensingh Med J 2017 Apr; 26 (2).</li><li>Original Article: Death profile in heart failure patients: one and a half year retrospective study in a heart failure clinic at a tertiary care hospital: Abstruct no-85201, Accepted in ESC congress-2018.</li><li>Correlation of Left Ventricular Ejection Fraction with Inhospital outcomes after First Attack of Non-ST Segment Elevation Myocardial Infarction, Accepted for Society of Echocardiography Journal-2018.</li></ol><p><strong><u>Research</u></strong></p><ul><li>Co-Investigator in an international trial “Resolute Asia” for evaluation of the Endeavor Resolute Zotarolimus-eluting stent system in a patient population with long lesion and / or dual vessels in Asia</li><li>Primary Investigator in an international trial “Improve brady” to evaluate the impact of the intervention on the diagnosis of SND &amp; evaluate the impact of the intervention on SND subjects that receive an indicated IPG device.</li><li>Co-Investigator in an international study on “Management Strategy for Acute STEMI”.</li></ul><p><strong><u>Other Activities</u></strong></p><ul><li>International faculty in TCTMD USA 2014, 2015, 2016 &amp; 2017.</li><li>International faculty in TCT Asia Pacific 2010, 2011, 2012, 2013,2014, 2015, 2016&amp; 2017,Seoul, S. Korea.</li><li>International faculty in&nbsp;international symposium on progress in clinical pacing ,,4th-7thdec 2012,Rome ,Italy</li><li>International faculty in&nbsp;8th Asian Interventional Cardiovascular Therapeutics Conference (AICT) 2012 : October 05-07, 2012, Gurgaon New Delhi</li><li>International faculty in&nbsp;64thannual CSI conference&amp; SAARC caadiac congress ,6th&nbsp;-9thdec 2012,NewDelhi,India</li><li>International faculty in&nbsp;India live 2013 ,27feb-2nd&nbsp;march 2013,Chennai,India</li><li>International faculty in Bangla intervention Therapeutics, 2012, 2013, 2014, 2015, 2016, 2017 &amp; 2018, Kolkata, India &amp; Dhaka, Bangladesh.</li></ul><p><br></p>",
				"status": "0",
				"is_deleted": "1",
				"created_at": "-000001-11-30T00:00:00.000000Z",
				"updated_at": "2023-10-17T01:21:18.000000Z",
				"Schedule": "[{\"Monday\":\"09:00 AM - 08:00 PM\",\"Friday\":\"09:00 AM - 08:00 PM\",\"Sunday\":\"09:00 AM - 08:00 PM\",\"Wednesday\":\"09:00 AM - 08:00 PM\",\"Thrusday\":\"09:00 AM - 08:00 PM\",\"Tuesday\":\"09:00 AM - 08:00 PM\",\"Saturday\":\"09:00 AM - 08:00 PM\"}]",
				"slug": "dr-kaisar-nasrullah-khan",
				"department_mave": {
					"id": 16,
					"dept_id": "16",
					"department_name": "Cardiology",
					"department_desc_one": "<p><strong>The Best Cardiologist in Dhaka, Bangladesh</strong></p><p>United Hospital has the best cardiologists in Dhaka, Bangladesh providing specialized inpatient and outpatient heart care and long term management of the conditions. We offer the latest techniques and cardiac care to patients of all ages. We treat patients with common heart problems such as angina to rare heart conditions.</p><p>With the help of State-of-the-heart-technology, equipment and monitoring devices, our cardiologists are providing excellent heart care to all the patients. Our department has the best cardiologists and heart specialists in Dhaka, who are highly specialized and has years of experience and expertise in cardiac care.</p><p>Our cardiologists provide 24 hour dedicated service and is the only hospital of Bangladesh where emergency angioplasty can be carried out round the clock. It is operated by a strong and dedicated team of 4 cardiologists – Consultants Dr. N. A. M. Momenuzzaman, Dr. Kaisar Nasrullah Khan, Dr. Fatema Begum Dr. Reyan Anis and Dr. A. M. Shafique. With the help of their extensive knowledge and supreme clinical practices, we are well efficient to treat the significant procedures, the best heart specialists in the heart of the Country, Dhaka. United Hospital is holding the pride of having the best cardiologist in Dhaka, Bangladesh.</p><p>The Cardiology division of United Cardiac Center has modern electro-medical equipments and appliances which include 3 catheterization laboratories including the most advanced Azurion Cathlab, Cardio Neuro iGS 520 Hybrid Cathlab and a 20 bed Coronary Care Unit (CCU) with specially managed CCU unit dedicated for COVID patients to carry out all necessary procedures related to diagnostic &amp; interventional cardiology.</p><p>In addition to this, we have a 15 bedded Cardiac High Dependency Unit (CHDU) and an 8 bedded Post Cath Section.</p><p><img src=\"https://www.uhlbd.com/administrator/uploads/images/Cardiac%20Advt-Final_Output%281%29.png\"></p>",
					"department_desc_two": "<h2>CARDIAC INVESTIGATION CONDUCTED AT OUR HOSPITAL ARE:</h2><ul><li>ECG</li><li>ECHO (2D-M Mode/ Colour Doppler)</li><li>HOLTER ECG</li><li>TRANSESOPHAGEAL ECHO</li><li>DOBUTAMINE INDUCED ECHO</li><li>TEE</li><li>ETT</li><li>CAG (Coronary Angiogram)</li><li>USG</li><li>CT Angio</li><li>24 Hours Ambulatory BP</li><li>24 Hours Monitoring</li><li>X-Ray Chest P/A View</li><li>Lipid Profile</li></ul>",
					"department_desc_three": "<h2>THE FOLLOWING PROCEDURES ARE DONE BY OUR CARDIOLOGY TEAM:</h2><ul><li>CAG&nbsp;&nbsp;&nbsp;: Coronary Angiography</li><li>PTCA&nbsp;: Percutaneous Transluminal Coronary Angioplasty / Stenting</li><li>PTMC&nbsp;: Percutaneous Transluminal Mitral Comissurectomy</li><li>TPMI&nbsp;&nbsp;&nbsp;: Temporary Pace Maker Installation</li><li>PPMI&nbsp;&nbsp;&nbsp;: Permanent Pace Maker Installation</li><li>CRT&nbsp;&nbsp;&nbsp;&nbsp;: Cardiac Resynchronization Device</li><li>ICD or AICD : Implantable Cardioverter-Defibrillator or Automated Implantable Cardioverter-Defibrillator C.Cath Coil Embolisation</li><li>ASD&nbsp;&nbsp;&nbsp;&nbsp;: Atrial Septal Defect V. Plasty</li><li>TAVI&nbsp;&nbsp;&nbsp;&nbsp;: Transcathether aortic valve implantation</li><li>PV&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: Pulmonary Valvoplasty</li><li>Pace Maker Implementation</li></ul>",
					"department_desc_four": "<h2>AN OVERALL GLANCE AT OUR STATE-OF-THE-ART FACILITIES</h2><ul><li>3 Catheterization Laboratories (Cath Labs) including one state-of-the-art Azurion Cathlab and one Cardio Neuro iGS 520 Hybrid Cathlab</li><li>20 Bed Coronary Care Unit/CCU</li><li>15 Bed Cardiac High Dependency Unit/CHDU</li><li>3 Cardiac Operation Theatres</li><li>24 Bed Cardiac ICU and Step-down CICU</li></ul>",
					"department_desc_five": "<h2>CONSULTATION &amp; APPOINTMENT</h2><p>Cardiology Department provides consultation services in (OPD - 4) at 1st Floor through highly qualified, experienced and one of the best Cardiologists in Dhaka, Bangladesh. Call 10666 or 02 22 22 62 466 Extension 8114 and 8115) for appointment with one of the best Cardiologists in Dhaka, Bangladesh.</p>",
					"image": "202302281007heart.png",
					"banner_image": null,
					"status": "1",
					"is_deleted": "0",
					"created_at": "-000001-11-30T00:00:00.000000Z",
					"updated_at": "2023-07-15T15:42:48.000000Z",
					"has_package": "1",
					"slug": "cardiology"
				}
			}
		},
		{
			"id": 2,
			"doctor_id": "1",
			"testimonial_title": "CARE",
			"testimonial_desc": "<p>Proper Care towards her patient</p>",
			"author_name": "Life insurance",
			"author_profile_pic": null,
			"rating": "5",
			"serial_order": null,
			"status": "1",
			"created_at": "2023-12-19T04:03:29.000000Z",
			"updated_at": "2023-12-19T04:03:29.000000Z",
			"doctor_mave": {
				"id": 1,
				"doctor_id": null,
				"doctor_name": "Dr. Kaisar Nasrullah Khan",
				"degree": "MBBS, FCPS (Med), MD (Card)",
				"uhl_id": "EID-10315",
				"bmdc_id": "A-21955",
				"dept_id": "16",
				"doctor_profile": "2023040505241476085950_2_dr kaisar.jpg",
				"doctor_fees": "1500",
				"doctor_desc": "<p><strong><u>Summary</u></strong></p><p>Alhamdulillah, I am a well trained and experienced medicine specialist and adult interventional &amp; clinical cardiologist. I have twenty six years of broad multinational experience of health systems. I try to deliver best evidence based medical and cardiovascular care to my patients. I can combat stressful situations and extreme emergencies in a very effective and decisive way. I am a confident and reliable medical practitioner who works as a team player with proficient communication skills. I have the skills and knowledge of training doctors and expertise in setting up coronary care unit at a very very busy referral Cardiac center.</p><p>&nbsp;<strong><u>Interest</u></strong></p><p>I take interest in developing skilled manpower like doctor, nurse and technician to develop interventional cardiology throughout the Bangladesh.</p><p>I take lecture on cardiology in different districts of Bangladesh to train general practitioner and cardiologist so that cardiac care can be reached to every patient of Bangladesh.</p><p>I also do public awareness program on “prevention and treatment of heart disease” in different parts of Bangladesh with general people and arrange “Free hart camp” with supply of cardiac medicine for one month for poor people with the help of pharmaceutical company.</p>",
				"doctor_edu": "<p><strong><u>Education</u></strong></p><ul><li>Fellow, Interventional Cardiology, Escorts Heart Institute &amp; Research Centre, New Delhi, India, 2004.</li><li>FCPS (Fellow of College&nbsp;&nbsp;of Physicians and Surgeons,Medicine), Bangladesh College of Physicians and Surgeons, Dhaka, Bangladesh, July 2002.</li><li>M.D (Doctor of Medicine,Cardiology), Dhaka University,Dhaka, Bangladesh, July 2001.</li><li>MBBS (Bachelor of Medicine &amp; Surgery), Sir Salimullah Medical College Dhaka, Bangladesh, July 1992.</li></ul><p><strong><u>Thesis</u></strong></p><ul><li>In Hospital outcome patients with primary ventricular fibrillation following acute myocardial infarction.</li><li>Department of Cardiology, National Institute of Cardiovascular Disease (NICVD) Sher-E-Bangla Nagar, Dhaka-2001.</li></ul><p><strong><u>Distinction/Award</u></strong></p><ul><li>Best challenging case award&nbsp;- symposium on interventional&nbsp;cardiology,Bangladesh&nbsp;Society of Cardiovascular Intervention (BSCI), 6th&nbsp;Aug&nbsp;2010.</li></ul><p><strong><u>Society membership</u></strong></p><ul><li>Secretary General, Bangladesh Society of Cardiovascular Intervention, 2016-till date.</li><li>Joint secretary, Bangladesh&nbsp;Society of Cardiovascular Intervention,2012-2016</li><li>Fellow, Society for Cardiovascular Angiography and Intervention, USA since 2012</li><li>Member, European Association of Percutaneous Cardiovascular Interventions (EAPCI)<strong><u>,</u></strong>since2006</li><li>Treasurer, Bangladesh Cardiac Society 2006-2012</li><li>Life member, The Chest &amp; Heart Association of Bangladesh,&nbsp;Since 2004.</li><li>Life member, Association of Physician of Bangladesh (APB), since 2002.</li><li>Life member, Bangladesh College of Physician &amp; Surgeon, Bangladesh, since 2002.</li><li>Life member, Bangladesh Medical Association,since2001</li></ul><p><br></p>",
				"doctor_exp": "<p><strong><u>Work History</u></strong></p><ul><li>Consultant, Clinical &amp; Interventional Cardiology, United Hospital Ltd., Gulshan, Dhaka (Jul 2006 - till date).</li><li>Consultant, Clinical &amp; Interventional Cardiology, Z.H. Sikdar Women’s Medical College &amp; Hospital (Pvt.) Ltd. Gulshan, Dhaka (Jan 2005-Jul 2006).</li><li>Fellow, Interventional Cardiology, Escorts heart institute &amp; Research Centre. New Delhi, India (Jan 2004 – Dec 2004).</li><li>Assistant Registrar, Cardiology, National Institute of Cardiovascular Disease. Dhaka (Jul 2001 – Dec 2003).</li><li>Resident, Cardiology, National Institute of Cardiovascular Disease. Dhaka (Jun 1999 – Jun 2001).</li><li>Assistant Registrar, Internal Medicine, Unit-1, Bangobandhu Sheikh Mujib Medical university (BSMMU), Dhaka (Mar 1997 – Jun 1999).</li><li>Assistant Registrar, Internal Medicine, Unit-3, Sylhet M.A.G. Osmani medical College and hospital, Sylhet (Mar 1996 – Mar 1997).</li><li>Medical Officer, Primary Health Care, Mahajanghat Union Health Sub Centre, Chittagong (Nov 1995 – Mar 1996).</li><li>Medical Officer, General Medicine, Institute of Postgraduate Medicine and Research (IPGMR), Dhaka (Jan 1994 – Jun 1995).</li><li>Medical Officer, General Medicine, Sir Salimullah Medical College and Hospital, Dhaka (Aug 1993 – Dec 1993).</li><li>Internee Doctor, General Medicine, Sir Salimullah Medical College and Hospital, Dhaka (Feb 1993 – Jul 1993).</li><li>Internee Doctor, General Surgery, Sir Salimullah Medical College and Hospital, Dhaka (Aug 1992 – Jan 1993).</li></ul><p><strong><u>Talk/Presentation</u></strong></p><ol><li>PCI is better than CABG in multivessel coronary artery disease-23rd&nbsp;national scientific Conference ,Bangladesh cardiac society, 4th&nbsp;May ,2007</li><li>Management of ACS: an update-2nd&nbsp;international conference on emergency medicine 2010,13 January, 2010.</li><li>Rotablation atherectomy-only device for calcified lesion-SAARC congress of cardiology 2010, 3rdApril, 2010.</li><li>Management of ACS: an update-21st&nbsp;annual conference and scientific essions, Association of physician of Bangladesh, 18-19 April, 2010</li><li>Intervention in Bangladesh-what we have achieved &amp; what yet to be!!-CME update on cardiology and cardiac surgery, Chittagong medical college hospital ,Bangladesh cardiac society, 23rd&nbsp;Dec, 2010</li><li>Ischaemic heart disease-19th&nbsp;annual conference of Bangladesh Medical Association,12th&nbsp;March,2011</li><li>Challenges in primary PCI-4th&nbsp;international cardiovascular conference, Ibrahim cardiac hospital &amp; research centre,22nd&nbsp;April 2011</li><li>Delayed perforation (after 2 hours) of first retrograde CTO recanalization of&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bangladesh: selected for presentation in complication session of EUROPCR 2011, France20th May,2011</li><li>Retrograde approach for coronary cto-2ndBangla intervention therapeutics, Kolkata, India, 5thfeb 2012.</li><li>My most difficult case-\"Breakfast symposium-&nbsp;Neighbors in arms-AICT INDIA 6th&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Oct 2012.</li><li>Pill in the pocket is still a valid treatment modality for infrequent atrial fibrillation?-XV international symposium on progress in clinical pacing 6th dec2012 in Rome, Italy.</li><li>\"Streptokinase- still relevant? - 64thAnnual CSI Conference and SAARC Cardiac Congress 9th dec 2012, New Delhi, India</li></ol><p><strong><u>Publication</u></strong></p><ol><li>Myocardial infarction in the young adults. Journal medical teacher’s federation 2001: Vo1 6 (2): 29-33.</li><li>Congenital coronary pulmonary arterio venous fistula in a patient with triple vessel disease- a case report. Bangladesh heart Journal January 2003 : Vo1 18 No. 1: 76-79</li><li>Congenital coronary artery Anomaly- Right coronary artery from left coronary sinus. Bangladesh heart Journal July 2003: Vo1 18 No. 2: 146-148.</li><li>Long term results after successful mitral balloon vulvuloplasty- experience of 1033 patient. Bangladesh journal of cardiology. March 2010:vol 01:no 03:194-200</li><li>Percuteneous Angioplasty and Stenting of Carotid Artery: Study of 18 Cases.</li><li>Cardiovasc. Journal. 2010; vol-2(2):218-222.</li><li>Primary angioplasty for the treatment of acute ST elevated Myocardial Infarction single centre experience. Cardiovascular journal January 2011, Vol: 3 No.2: 149-154.</li><li>Clinical outcome of overlapping of drug eluting stents (DES)-study of 200 cases. Journal of cardiovascular intervention January 2011:Vol 1 No 1:10-15.</li><li>Multi vessel PCI in the drug eluting stent era: Card-8 (abstract in scientific session) joint conference 2008, Bangladesh college of physicians and surgeons</li><li>Long term clinical and echo cartographic results after successful mitral balloon valvotomy and pediatrics of long term outcome (Card-05).&nbsp;(abstract in scientific session) joint conference 2008, Bangladesh college of physicians and surgeons</li><li>Correlation of Coronary Artery Disease (CAD) in patient having significant Renal Artery Stenosis (RAS) - A study of cases. (Card-7).</li><li>Microvascular obstruction in PCI-A review. University Heart Journal January2011:Vol 7 No. 1 :48-52</li><li>Correlation between Microalbuminuria with Complexity of Coronary Artery Disease in Diabetic Patients, Mymensingh Med J 2013 Apr; 22 (2): 353-357.</li><li>Immediate Outcome of Chronic Total Occlusion Opening in Post Angioplasty Patients, Mymensingh Med J 2013 Jul; 22 (3): 489-495.</li><li>Pulmonary Embolism – A Case Report: University Heart Journal; Jan 2016, vol-12, No-1, 40-44.</li><li>Primary Angioplasty for the Treatment of Acute ST ElevatedMyocardial Infarction: Single Centre Experience of Three and Half Years, Mymensingh Med J 2017 Apr; 26 (2).</li><li>Original Article: Death profile in heart failure patients: one and a half year retrospective study in a heart failure clinic at a tertiary care hospital: Abstruct no-85201, Accepted in ESC congress-2018.</li><li>Correlation of Left Ventricular Ejection Fraction with Inhospital outcomes after First Attack of Non-ST Segment Elevation Myocardial Infarction, Accepted for Society of Echocardiography Journal-2018.</li></ol><p><strong><u>Research</u></strong></p><ul><li>Co-Investigator in an international trial “Resolute Asia” for evaluation of the Endeavor Resolute Zotarolimus-eluting stent system in a patient population with long lesion and / or dual vessels in Asia</li><li>Primary Investigator in an international trial “Improve brady” to evaluate the impact of the intervention on the diagnosis of SND &amp; evaluate the impact of the intervention on SND subjects that receive an indicated IPG device.</li><li>Co-Investigator in an international study on “Management Strategy for Acute STEMI”.</li></ul><p><strong><u>Other Activities</u></strong></p><ul><li>International faculty in TCTMD USA 2014, 2015, 2016 &amp; 2017.</li><li>International faculty in TCT Asia Pacific 2010, 2011, 2012, 2013,2014, 2015, 2016&amp; 2017,Seoul, S. Korea.</li><li>International faculty in&nbsp;international symposium on progress in clinical pacing ,,4th-7thdec 2012,Rome ,Italy</li><li>International faculty in&nbsp;8th Asian Interventional Cardiovascular Therapeutics Conference (AICT) 2012 : October 05-07, 2012, Gurgaon New Delhi</li><li>International faculty in&nbsp;64thannual CSI conference&amp; SAARC caadiac congress ,6th&nbsp;-9thdec 2012,NewDelhi,India</li><li>International faculty in&nbsp;India live 2013 ,27feb-2nd&nbsp;march 2013,Chennai,India</li><li>International faculty in Bangla intervention Therapeutics, 2012, 2013, 2014, 2015, 2016, 2017 &amp; 2018, Kolkata, India &amp; Dhaka, Bangladesh.</li></ul><p><br></p>",
				"status": "0",
				"is_deleted": "1",
				"created_at": "-000001-11-30T00:00:00.000000Z",
				"updated_at": "2023-10-17T01:21:18.000000Z",
				"Schedule": "[{\"Monday\":\"09:00 AM - 08:00 PM\",\"Friday\":\"09:00 AM - 08:00 PM\",\"Sunday\":\"09:00 AM - 08:00 PM\",\"Wednesday\":\"09:00 AM - 08:00 PM\",\"Thrusday\":\"09:00 AM - 08:00 PM\",\"Tuesday\":\"09:00 AM - 08:00 PM\",\"Saturday\":\"09:00 AM - 08:00 PM\"}]",
				"slug": "dr-kaisar-nasrullah-khan",
				"department_mave": {
					"id": 16,
					"dept_id": "16",
					"department_name": "Cardiology",
					"department_desc_one": "<p><strong>The Best Cardiologist in Dhaka, Bangladesh</strong></p><p>United Hospital has the best cardiologists in Dhaka, Bangladesh providing specialized inpatient and outpatient heart care and long term management of the conditions. We offer the latest techniques and cardiac care to patients of all ages. We treat patients with common heart problems such as angina to rare heart conditions.</p><p>With the help of State-of-the-heart-technology, equipment and monitoring devices, our cardiologists are providing excellent heart care to all the patients. Our department has the best cardiologists and heart specialists in Dhaka, who are highly specialized and has years of experience and expertise in cardiac care.</p><p>Our cardiologists provide 24 hour dedicated service and is the only hospital of Bangladesh where emergency angioplasty can be carried out round the clock. It is operated by a strong and dedicated team of 4 cardiologists – Consultants Dr. N. A. M. Momenuzzaman, Dr. Kaisar Nasrullah Khan, Dr. Fatema Begum Dr. Reyan Anis and Dr. A. M. Shafique. With the help of their extensive knowledge and supreme clinical practices, we are well efficient to treat the significant procedures, the best heart specialists in the heart of the Country, Dhaka. United Hospital is holding the pride of having the best cardiologist in Dhaka, Bangladesh.</p><p>The Cardiology division of United Cardiac Center has modern electro-medical equipments and appliances which include 3 catheterization laboratories including the most advanced Azurion Cathlab, Cardio Neuro iGS 520 Hybrid Cathlab and a 20 bed Coronary Care Unit (CCU) with specially managed CCU unit dedicated for COVID patients to carry out all necessary procedures related to diagnostic &amp; interventional cardiology.</p><p>In addition to this, we have a 15 bedded Cardiac High Dependency Unit (CHDU) and an 8 bedded Post Cath Section.</p><p><img src=\"https://www.uhlbd.com/administrator/uploads/images/Cardiac%20Advt-Final_Output%281%29.png\"></p>",
					"department_desc_two": "<h2>CARDIAC INVESTIGATION CONDUCTED AT OUR HOSPITAL ARE:</h2><ul><li>ECG</li><li>ECHO (2D-M Mode/ Colour Doppler)</li><li>HOLTER ECG</li><li>TRANSESOPHAGEAL ECHO</li><li>DOBUTAMINE INDUCED ECHO</li><li>TEE</li><li>ETT</li><li>CAG (Coronary Angiogram)</li><li>USG</li><li>CT Angio</li><li>24 Hours Ambulatory BP</li><li>24 Hours Monitoring</li><li>X-Ray Chest P/A View</li><li>Lipid Profile</li></ul>",
					"department_desc_three": "<h2>THE FOLLOWING PROCEDURES ARE DONE BY OUR CARDIOLOGY TEAM:</h2><ul><li>CAG&nbsp;&nbsp;&nbsp;: Coronary Angiography</li><li>PTCA&nbsp;: Percutaneous Transluminal Coronary Angioplasty / Stenting</li><li>PTMC&nbsp;: Percutaneous Transluminal Mitral Comissurectomy</li><li>TPMI&nbsp;&nbsp;&nbsp;: Temporary Pace Maker Installation</li><li>PPMI&nbsp;&nbsp;&nbsp;: Permanent Pace Maker Installation</li><li>CRT&nbsp;&nbsp;&nbsp;&nbsp;: Cardiac Resynchronization Device</li><li>ICD or AICD : Implantable Cardioverter-Defibrillator or Automated Implantable Cardioverter-Defibrillator C.Cath Coil Embolisation</li><li>ASD&nbsp;&nbsp;&nbsp;&nbsp;: Atrial Septal Defect V. Plasty</li><li>TAVI&nbsp;&nbsp;&nbsp;&nbsp;: Transcathether aortic valve implantation</li><li>PV&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: Pulmonary Valvoplasty</li><li>Pace Maker Implementation</li></ul>",
					"department_desc_four": "<h2>AN OVERALL GLANCE AT OUR STATE-OF-THE-ART FACILITIES</h2><ul><li>3 Catheterization Laboratories (Cath Labs) including one state-of-the-art Azurion Cathlab and one Cardio Neuro iGS 520 Hybrid Cathlab</li><li>20 Bed Coronary Care Unit/CCU</li><li>15 Bed Cardiac High Dependency Unit/CHDU</li><li>3 Cardiac Operation Theatres</li><li>24 Bed Cardiac ICU and Step-down CICU</li></ul>",
					"department_desc_five": "<h2>CONSULTATION &amp; APPOINTMENT</h2><p>Cardiology Department provides consultation services in (OPD - 4) at 1st Floor through highly qualified, experienced and one of the best Cardiologists in Dhaka, Bangladesh. Call 10666 or 02 22 22 62 466 Extension 8114 and 8115) for appointment with one of the best Cardiologists in Dhaka, Bangladesh.</p>",
					"image": "202302281007heart.png",
					"banner_image": null,
					"status": "1",
					"is_deleted": "0",
					"created_at": "-000001-11-30T00:00:00.000000Z",
					"updated_at": "2023-07-15T15:42:48.000000Z",
					"has_package": "1",
					"slug": "cardiology"
				}
			}
		},
		{
			"id": 1,
			"doctor_id": "1",
			"testimonial_title": "CARE",
			"testimonial_desc": "<p>Proper Care towards her patient</p>",
			"author_name": "Medical health care",
			"author_profile_pic": null,
			"rating": "5",
			"serial_order": null,
			"status": "1",
			"created_at": "2023-12-19T04:01:26.000000Z",
			"updated_at": "2023-12-19T04:01:26.000000Z",
			"doctor_mave": {
				"id": 1,
				"doctor_id": null,
				"doctor_name": "Dr. Kaisar Nasrullah Khan",
				"degree": "MBBS, FCPS (Med), MD (Card)",
				"uhl_id": "EID-10315",
				"bmdc_id": "A-21955",
				"dept_id": "16",
				"doctor_profile": "2023040505241476085950_2_dr kaisar.jpg",
				"doctor_fees": "1500",
				"doctor_desc": "<p><strong><u>Summary</u></strong></p><p>Alhamdulillah, I am a well trained and experienced medicine specialist and adult interventional &amp; clinical cardiologist. I have twenty six years of broad multinational experience of health systems. I try to deliver best evidence based medical and cardiovascular care to my patients. I can combat stressful situations and extreme emergencies in a very effective and decisive way. I am a confident and reliable medical practitioner who works as a team player with proficient communication skills. I have the skills and knowledge of training doctors and expertise in setting up coronary care unit at a very very busy referral Cardiac center.</p><p>&nbsp;<strong><u>Interest</u></strong></p><p>I take interest in developing skilled manpower like doctor, nurse and technician to develop interventional cardiology throughout the Bangladesh.</p><p>I take lecture on cardiology in different districts of Bangladesh to train general practitioner and cardiologist so that cardiac care can be reached to every patient of Bangladesh.</p><p>I also do public awareness program on “prevention and treatment of heart disease” in different parts of Bangladesh with general people and arrange “Free hart camp” with supply of cardiac medicine for one month for poor people with the help of pharmaceutical company.</p>",
				"doctor_edu": "<p><strong><u>Education</u></strong></p><ul><li>Fellow, Interventional Cardiology, Escorts Heart Institute &amp; Research Centre, New Delhi, India, 2004.</li><li>FCPS (Fellow of College&nbsp;&nbsp;of Physicians and Surgeons,Medicine), Bangladesh College of Physicians and Surgeons, Dhaka, Bangladesh, July 2002.</li><li>M.D (Doctor of Medicine,Cardiology), Dhaka University,Dhaka, Bangladesh, July 2001.</li><li>MBBS (Bachelor of Medicine &amp; Surgery), Sir Salimullah Medical College Dhaka, Bangladesh, July 1992.</li></ul><p><strong><u>Thesis</u></strong></p><ul><li>In Hospital outcome patients with primary ventricular fibrillation following acute myocardial infarction.</li><li>Department of Cardiology, National Institute of Cardiovascular Disease (NICVD) Sher-E-Bangla Nagar, Dhaka-2001.</li></ul><p><strong><u>Distinction/Award</u></strong></p><ul><li>Best challenging case award&nbsp;- symposium on interventional&nbsp;cardiology,Bangladesh&nbsp;Society of Cardiovascular Intervention (BSCI), 6th&nbsp;Aug&nbsp;2010.</li></ul><p><strong><u>Society membership</u></strong></p><ul><li>Secretary General, Bangladesh Society of Cardiovascular Intervention, 2016-till date.</li><li>Joint secretary, Bangladesh&nbsp;Society of Cardiovascular Intervention,2012-2016</li><li>Fellow, Society for Cardiovascular Angiography and Intervention, USA since 2012</li><li>Member, European Association of Percutaneous Cardiovascular Interventions (EAPCI)<strong><u>,</u></strong>since2006</li><li>Treasurer, Bangladesh Cardiac Society 2006-2012</li><li>Life member, The Chest &amp; Heart Association of Bangladesh,&nbsp;Since 2004.</li><li>Life member, Association of Physician of Bangladesh (APB), since 2002.</li><li>Life member, Bangladesh College of Physician &amp; Surgeon, Bangladesh, since 2002.</li><li>Life member, Bangladesh Medical Association,since2001</li></ul><p><br></p>",
				"doctor_exp": "<p><strong><u>Work History</u></strong></p><ul><li>Consultant, Clinical &amp; Interventional Cardiology, United Hospital Ltd., Gulshan, Dhaka (Jul 2006 - till date).</li><li>Consultant, Clinical &amp; Interventional Cardiology, Z.H. Sikdar Women’s Medical College &amp; Hospital (Pvt.) Ltd. Gulshan, Dhaka (Jan 2005-Jul 2006).</li><li>Fellow, Interventional Cardiology, Escorts heart institute &amp; Research Centre. New Delhi, India (Jan 2004 – Dec 2004).</li><li>Assistant Registrar, Cardiology, National Institute of Cardiovascular Disease. Dhaka (Jul 2001 – Dec 2003).</li><li>Resident, Cardiology, National Institute of Cardiovascular Disease. Dhaka (Jun 1999 – Jun 2001).</li><li>Assistant Registrar, Internal Medicine, Unit-1, Bangobandhu Sheikh Mujib Medical university (BSMMU), Dhaka (Mar 1997 – Jun 1999).</li><li>Assistant Registrar, Internal Medicine, Unit-3, Sylhet M.A.G. Osmani medical College and hospital, Sylhet (Mar 1996 – Mar 1997).</li><li>Medical Officer, Primary Health Care, Mahajanghat Union Health Sub Centre, Chittagong (Nov 1995 – Mar 1996).</li><li>Medical Officer, General Medicine, Institute of Postgraduate Medicine and Research (IPGMR), Dhaka (Jan 1994 – Jun 1995).</li><li>Medical Officer, General Medicine, Sir Salimullah Medical College and Hospital, Dhaka (Aug 1993 – Dec 1993).</li><li>Internee Doctor, General Medicine, Sir Salimullah Medical College and Hospital, Dhaka (Feb 1993 – Jul 1993).</li><li>Internee Doctor, General Surgery, Sir Salimullah Medical College and Hospital, Dhaka (Aug 1992 – Jan 1993).</li></ul><p><strong><u>Talk/Presentation</u></strong></p><ol><li>PCI is better than CABG in multivessel coronary artery disease-23rd&nbsp;national scientific Conference ,Bangladesh cardiac society, 4th&nbsp;May ,2007</li><li>Management of ACS: an update-2nd&nbsp;international conference on emergency medicine 2010,13 January, 2010.</li><li>Rotablation atherectomy-only device for calcified lesion-SAARC congress of cardiology 2010, 3rdApril, 2010.</li><li>Management of ACS: an update-21st&nbsp;annual conference and scientific essions, Association of physician of Bangladesh, 18-19 April, 2010</li><li>Intervention in Bangladesh-what we have achieved &amp; what yet to be!!-CME update on cardiology and cardiac surgery, Chittagong medical college hospital ,Bangladesh cardiac society, 23rd&nbsp;Dec, 2010</li><li>Ischaemic heart disease-19th&nbsp;annual conference of Bangladesh Medical Association,12th&nbsp;March,2011</li><li>Challenges in primary PCI-4th&nbsp;international cardiovascular conference, Ibrahim cardiac hospital &amp; research centre,22nd&nbsp;April 2011</li><li>Delayed perforation (after 2 hours) of first retrograde CTO recanalization of&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bangladesh: selected for presentation in complication session of EUROPCR 2011, France20th May,2011</li><li>Retrograde approach for coronary cto-2ndBangla intervention therapeutics, Kolkata, India, 5thfeb 2012.</li><li>My most difficult case-\"Breakfast symposium-&nbsp;Neighbors in arms-AICT INDIA 6th&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Oct 2012.</li><li>Pill in the pocket is still a valid treatment modality for infrequent atrial fibrillation?-XV international symposium on progress in clinical pacing 6th dec2012 in Rome, Italy.</li><li>\"Streptokinase- still relevant? - 64thAnnual CSI Conference and SAARC Cardiac Congress 9th dec 2012, New Delhi, India</li></ol><p><strong><u>Publication</u></strong></p><ol><li>Myocardial infarction in the young adults. Journal medical teacher’s federation 2001: Vo1 6 (2): 29-33.</li><li>Congenital coronary pulmonary arterio venous fistula in a patient with triple vessel disease- a case report. Bangladesh heart Journal January 2003 : Vo1 18 No. 1: 76-79</li><li>Congenital coronary artery Anomaly- Right coronary artery from left coronary sinus. Bangladesh heart Journal July 2003: Vo1 18 No. 2: 146-148.</li><li>Long term results after successful mitral balloon vulvuloplasty- experience of 1033 patient. Bangladesh journal of cardiology. March 2010:vol 01:no 03:194-200</li><li>Percuteneous Angioplasty and Stenting of Carotid Artery: Study of 18 Cases.</li><li>Cardiovasc. Journal. 2010; vol-2(2):218-222.</li><li>Primary angioplasty for the treatment of acute ST elevated Myocardial Infarction single centre experience. Cardiovascular journal January 2011, Vol: 3 No.2: 149-154.</li><li>Clinical outcome of overlapping of drug eluting stents (DES)-study of 200 cases. Journal of cardiovascular intervention January 2011:Vol 1 No 1:10-15.</li><li>Multi vessel PCI in the drug eluting stent era: Card-8 (abstract in scientific session) joint conference 2008, Bangladesh college of physicians and surgeons</li><li>Long term clinical and echo cartographic results after successful mitral balloon valvotomy and pediatrics of long term outcome (Card-05).&nbsp;(abstract in scientific session) joint conference 2008, Bangladesh college of physicians and surgeons</li><li>Correlation of Coronary Artery Disease (CAD) in patient having significant Renal Artery Stenosis (RAS) - A study of cases. (Card-7).</li><li>Microvascular obstruction in PCI-A review. University Heart Journal January2011:Vol 7 No. 1 :48-52</li><li>Correlation between Microalbuminuria with Complexity of Coronary Artery Disease in Diabetic Patients, Mymensingh Med J 2013 Apr; 22 (2): 353-357.</li><li>Immediate Outcome of Chronic Total Occlusion Opening in Post Angioplasty Patients, Mymensingh Med J 2013 Jul; 22 (3): 489-495.</li><li>Pulmonary Embolism – A Case Report: University Heart Journal; Jan 2016, vol-12, No-1, 40-44.</li><li>Primary Angioplasty for the Treatment of Acute ST ElevatedMyocardial Infarction: Single Centre Experience of Three and Half Years, Mymensingh Med J 2017 Apr; 26 (2).</li><li>Original Article: Death profile in heart failure patients: one and a half year retrospective study in a heart failure clinic at a tertiary care hospital: Abstruct no-85201, Accepted in ESC congress-2018.</li><li>Correlation of Left Ventricular Ejection Fraction with Inhospital outcomes after First Attack of Non-ST Segment Elevation Myocardial Infarction, Accepted for Society of Echocardiography Journal-2018.</li></ol><p><strong><u>Research</u></strong></p><ul><li>Co-Investigator in an international trial “Resolute Asia” for evaluation of the Endeavor Resolute Zotarolimus-eluting stent system in a patient population with long lesion and / or dual vessels in Asia</li><li>Primary Investigator in an international trial “Improve brady” to evaluate the impact of the intervention on the diagnosis of SND &amp; evaluate the impact of the intervention on SND subjects that receive an indicated IPG device.</li><li>Co-Investigator in an international study on “Management Strategy for Acute STEMI”.</li></ul><p><strong><u>Other Activities</u></strong></p><ul><li>International faculty in TCTMD USA 2014, 2015, 2016 &amp; 2017.</li><li>International faculty in TCT Asia Pacific 2010, 2011, 2012, 2013,2014, 2015, 2016&amp; 2017,Seoul, S. Korea.</li><li>International faculty in&nbsp;international symposium on progress in clinical pacing ,,4th-7thdec 2012,Rome ,Italy</li><li>International faculty in&nbsp;8th Asian Interventional Cardiovascular Therapeutics Conference (AICT) 2012 : October 05-07, 2012, Gurgaon New Delhi</li><li>International faculty in&nbsp;64thannual CSI conference&amp; SAARC caadiac congress ,6th&nbsp;-9thdec 2012,NewDelhi,India</li><li>International faculty in&nbsp;India live 2013 ,27feb-2nd&nbsp;march 2013,Chennai,India</li><li>International faculty in Bangla intervention Therapeutics, 2012, 2013, 2014, 2015, 2016, 2017 &amp; 2018, Kolkata, India &amp; Dhaka, Bangladesh.</li></ul><p><br></p>",
				"status": "0",
				"is_deleted": "1",
				"created_at": "-000001-11-30T00:00:00.000000Z",
				"updated_at": "2023-10-17T01:21:18.000000Z",
				"Schedule": "[{\"Monday\":\"09:00 AM - 08:00 PM\",\"Friday\":\"09:00 AM - 08:00 PM\",\"Sunday\":\"09:00 AM - 08:00 PM\",\"Wednesday\":\"09:00 AM - 08:00 PM\",\"Thrusday\":\"09:00 AM - 08:00 PM\",\"Tuesday\":\"09:00 AM - 08:00 PM\",\"Saturday\":\"09:00 AM - 08:00 PM\"}]",
				"slug": "dr-kaisar-nasrullah-khan",
				"department_mave": {
					"id": 16,
					"dept_id": "16",
					"department_name": "Cardiology",
					"department_desc_one": "<p><strong>The Best Cardiologist in Dhaka, Bangladesh</strong></p><p>United Hospital has the best cardiologists in Dhaka, Bangladesh providing specialized inpatient and outpatient heart care and long term management of the conditions. We offer the latest techniques and cardiac care to patients of all ages. We treat patients with common heart problems such as angina to rare heart conditions.</p><p>With the help of State-of-the-heart-technology, equipment and monitoring devices, our cardiologists are providing excellent heart care to all the patients. Our department has the best cardiologists and heart specialists in Dhaka, who are highly specialized and has years of experience and expertise in cardiac care.</p><p>Our cardiologists provide 24 hour dedicated service and is the only hospital of Bangladesh where emergency angioplasty can be carried out round the clock. It is operated by a strong and dedicated team of 4 cardiologists – Consultants Dr. N. A. M. Momenuzzaman, Dr. Kaisar Nasrullah Khan, Dr. Fatema Begum Dr. Reyan Anis and Dr. A. M. Shafique. With the help of their extensive knowledge and supreme clinical practices, we are well efficient to treat the significant procedures, the best heart specialists in the heart of the Country, Dhaka. United Hospital is holding the pride of having the best cardiologist in Dhaka, Bangladesh.</p><p>The Cardiology division of United Cardiac Center has modern electro-medical equipments and appliances which include 3 catheterization laboratories including the most advanced Azurion Cathlab, Cardio Neuro iGS 520 Hybrid Cathlab and a 20 bed Coronary Care Unit (CCU) with specially managed CCU unit dedicated for COVID patients to carry out all necessary procedures related to diagnostic &amp; interventional cardiology.</p><p>In addition to this, we have a 15 bedded Cardiac High Dependency Unit (CHDU) and an 8 bedded Post Cath Section.</p><p><img src=\"https://www.uhlbd.com/administrator/uploads/images/Cardiac%20Advt-Final_Output%281%29.png\"></p>",
					"department_desc_two": "<h2>CARDIAC INVESTIGATION CONDUCTED AT OUR HOSPITAL ARE:</h2><ul><li>ECG</li><li>ECHO (2D-M Mode/ Colour Doppler)</li><li>HOLTER ECG</li><li>TRANSESOPHAGEAL ECHO</li><li>DOBUTAMINE INDUCED ECHO</li><li>TEE</li><li>ETT</li><li>CAG (Coronary Angiogram)</li><li>USG</li><li>CT Angio</li><li>24 Hours Ambulatory BP</li><li>24 Hours Monitoring</li><li>X-Ray Chest P/A View</li><li>Lipid Profile</li></ul>",
					"department_desc_three": "<h2>THE FOLLOWING PROCEDURES ARE DONE BY OUR CARDIOLOGY TEAM:</h2><ul><li>CAG&nbsp;&nbsp;&nbsp;: Coronary Angiography</li><li>PTCA&nbsp;: Percutaneous Transluminal Coronary Angioplasty / Stenting</li><li>PTMC&nbsp;: Percutaneous Transluminal Mitral Comissurectomy</li><li>TPMI&nbsp;&nbsp;&nbsp;: Temporary Pace Maker Installation</li><li>PPMI&nbsp;&nbsp;&nbsp;: Permanent Pace Maker Installation</li><li>CRT&nbsp;&nbsp;&nbsp;&nbsp;: Cardiac Resynchronization Device</li><li>ICD or AICD : Implantable Cardioverter-Defibrillator or Automated Implantable Cardioverter-Defibrillator C.Cath Coil Embolisation</li><li>ASD&nbsp;&nbsp;&nbsp;&nbsp;: Atrial Septal Defect V. Plasty</li><li>TAVI&nbsp;&nbsp;&nbsp;&nbsp;: Transcathether aortic valve implantation</li><li>PV&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: Pulmonary Valvoplasty</li><li>Pace Maker Implementation</li></ul>",
					"department_desc_four": "<h2>AN OVERALL GLANCE AT OUR STATE-OF-THE-ART FACILITIES</h2><ul><li>3 Catheterization Laboratories (Cath Labs) including one state-of-the-art Azurion Cathlab and one Cardio Neuro iGS 520 Hybrid Cathlab</li><li>20 Bed Coronary Care Unit/CCU</li><li>15 Bed Cardiac High Dependency Unit/CHDU</li><li>3 Cardiac Operation Theatres</li><li>24 Bed Cardiac ICU and Step-down CICU</li></ul>",
					"department_desc_five": "<h2>CONSULTATION &amp; APPOINTMENT</h2><p>Cardiology Department provides consultation services in (OPD - 4) at 1st Floor through highly qualified, experienced and one of the best Cardiologists in Dhaka, Bangladesh. Call 10666 or 02 22 22 62 466 Extension 8114 and 8115) for appointment with one of the best Cardiologists in Dhaka, Bangladesh.</p>",
					"image": "202302281007heart.png",
					"banner_image": null,
					"status": "1",
					"is_deleted": "0",
					"created_at": "-000001-11-30T00:00:00.000000Z",
					"updated_at": "2023-07-15T15:42:48.000000Z",
					"has_package": "1",
					"slug": "cardiology"
				}
			}
		}
	];

/***/ },
/* 863 */
/***/ function(module, exports) {

	module.exports = {
		"SALAD": [
			{
				"Item Name": "Grilled Chicken with Cucumber Salad",
				"Price (Taka)": 123.25
			},
			{
				"Item Name": "Greek Salad",
				"Price (Taka)": 123.25
			},
			{
				"Item Name": "Mexican Street Corn Salad",
				"Price (Taka)": 76.5
			}
		],
		"BREAKFAST": [
			{
				"Item Name": "Breakfast -1\n(Chapati, Egg Omelette &Vegetable Bhaji)",
				"Price (Taka)": 68
			},
			{
				"Item Name": "Continental Breakfast\n(2 Slices of bread, Egg Omelette, Butter & Jam)",
				"Price (Taka)": 85
			},
			{
				"Item Name": "Special Breakfast\n(Chapati, Egg Omelette, Chicken Bhuna & Bhaji)",
				"Price (Taka)": 187
			}
		],
		"MAIN COURSE": [
			{
				"Item Name": "Chicken Tehari /Khichuri /Pulao",
				"Price (Taka)": 187
			},
			{
				"Item Name": "Chinese Set Menu\n(Fried rice, Fried Chicken, Chinese Vegetable)",
				"Price (Taka)": 297.5
			},
			{
				"Item Name": "Continental Food\n(Fried rice, Fish/ Chicken, Sautéed Vegetable)",
				"Price (Taka)": 297.5
			},
			{
				"Item Name": "Standard Lunch/ Dinner\n(Steam rice, Chicken/ Fish Vegetable, Dal)",
				"Price (Taka)": 255
			},
			{
				"Item Name": "Special Lunch/ Dinner\n(Steam rice, Beef / Rupchanda, Vegetable, Dal)",
				"Price (Taka)": 297.5
			},
			{
				"Item Name": "Boiled Chicken and Vegetable",
				"Price (Taka)": 255
			},
			{
				"Item Name": "Steamed Fish with Vegetable\n(Steamed Fish in Bed of Sautéed Vegetable, apple, Lemon grass and White Rice)",
				"Price (Taka)": 297.5
			},
			{
				"Item Name": "Chicken with Noodles and Vegetable\n(Slow Cooked Chicken with Garlic, Ginger, Noddle and Mixed Boiled Vegetable with rice)",
				"Price (Taka)": 255
			},
			{
				"Item Name": "Orange Chicken with Garlic Vegetable\n(Roasted Chicken with Honey and Orange Mixed served with Mixed Sautéed Vegetable with rice)",
				"Price (Taka)": 297.5
			}
		],
		"SNACKS": [
			{
				"Item Name": "Apple and Chicken Sandwich",
				"Price (Taka)": 127.5
			},
			{
				"Item Name": "BBQ Chicken",
				"Price (Taka)": 51
			},
			{
				"Item Name": "BBQ Chicken Sandwich",
				"Price (Taka)": 127.5
			},
			{
				"Item Name": "Beef Burger",
				"Price (Taka)": 187
			},
			{
				"Item Name": "Beef Mughlai Paratha",
				"Price (Taka)": 110.5
			},
			{
				"Item Name": "Brown Bread Sandwich",
				"Price (Taka)": 144.5
			},
			{
				"Item Name": "Chicken Burger",
				"Price (Taka)": 170
			},
			{
				"Item Name": "Chicken Lolipop",
				"Price (Taka)": 29.75
			},
			{
				"Item Name": "Chicken Nuggets",
				"Price (Taka)": 25.5
			},
			{
				"Item Name": "Chicken Sandwich",
				"Price (Taka)": 93.5
			},
			{
				"Item Name": "Chicken Shashlik",
				"Price (Taka)": 127.5
			},
			{
				"Item Name": "Chicken Shawarma Wrap",
				"Price (Taka)": 136
			},
			{
				"Item Name": "Chicken Spring Roll",
				"Price (Taka)": 29.75
			},
			{
				"Item Name": "Club Sandwich",
				"Price (Taka)": 127.5
			},
			{
				"Item Name": "Corn Soup",
				"Price (Taka)": 127.5
			},
			{
				"Item Name": "Dal Puri",
				"Price (Taka)": 17
			},
			{
				"Item Name": "Fried Chicken",
				"Price (Taka)": 93.5
			},
			{
				"Item Name": "Fried Eggs with Tomato and Roasted Pepper SW",
				"Price (Taka)": 85
			},
			{
				"Item Name": "Health Coupon (Package)",
				"Price (Taka)": 165.75
			},
			{
				"Item Name": "Liver Singara",
				"Price (Taka)": 34
			},
			{
				"Item Name": "Mixed Noodles",
				"Price (Taka)": 127.5
			},
			{
				"Item Name": "Mortadella Sandwich",
				"Price (Taka)": 144.5
			},
			{
				"Item Name": "Subway Sandwich",
				"Price (Taka)": 170
			},
			{
				"Item Name": "Vegetable Singara",
				"Price (Taka)": 21.25
			}
		],
		"PASTRY": [
			{
				"Item Name": "Basbousa",
				"Price (Taka)": 68
			},
			{
				"Item Name": "Chocolate Cake / Pastry",
				"Price (Taka)": 85
			},
			{
				"Item Name": "Chocolate Ball",
				"Price (Taka)": 51
			},
			{
				"Item Name": "Chocolate Brownie",
				"Price (Taka)": 127.5
			},
			{
				"Item Name": "Chocolate Lava",
				"Price (Taka)": 63.75
			},
			{
				"Item Name": "Chocolate Mouse",
				"Price (Taka)": 51
			},
			{
				"Item Name": "Chocolate Muffin",
				"Price (Taka)": 51
			},
			{
				"Item Name": "Cookies (250 gm)",
				"Price (Taka)": 161.5
			},
			{
				"Item Name": "Cream Bun",
				"Price (Taka)": 42.5
			},
			{
				"Item Name": "Cup Cake",
				"Price (Taka)": 38.25
			},
			{
				"Item Name": "Custard",
				"Price (Taka)": 51
			},
			{
				"Item Name": "Date Cake Slice",
				"Price (Taka)": 68
			},
			{
				"Item Name": "Fairy Cake",
				"Price (Taka)": 42.5
			},
			{
				"Item Name": "Fruit Platter",
				"Price (Taka)": 102
			},
			{
				"Item Name": "Large Bread",
				"Price (Taka)": 136
			},
			{
				"Item Name": "Lemon/Orange Tart",
				"Price (Taka)": 51
			},
			{
				"Item Name": "Marble Cake",
				"Price (Taka)": 46.75
			},
			{
				"Item Name": "Palimar Cake",
				"Price (Taka)": 42.5
			},
			{
				"Item Name": "Plain Bun",
				"Price (Taka)": 21.25
			},
			{
				"Item Name": "Pyramid Cake",
				"Price (Taka)": 63.75
			},
			{
				"Item Name": "Pudding",
				"Price (Taka)": 106.25
			},
			{
				"Item Name": "Swiss Roll",
				"Price (Taka)": 68
			},
			{
				"Item Name": "jilapi",
				"Price (Taka)": 17
			},
			{
				"Item Name": "Vanilla Cake / Pastry",
				"Price (Taka)": 85
			}
		],
		"ICE CREAM": [
			{
				"Item Name": "Almond Exotic",
				"Price (Taka)": "MRP Price"
			},
			{
				"Item Name": "Black Forest",
				"Price (Taka)": "MRP Price"
			},
			{
				"Item Name": "Chocobar",
				"Price (Taka)": "MRP Price"
			},
			{
				"Item Name": "Cornelli Belgian",
				"Price (Taka)": "MRP Price"
			},
			{
				"Item Name": "Cornelli Classic",
				"Price (Taka)": "MRP Price"
			},
			{
				"Item Name": "Eggo",
				"Price (Taka)": "MRP Price"
			},
			{
				"Item Name": "Exotic Swiss",
				"Price (Taka)": "MRP Price"
			},
			{
				"Item Name": "Macho",
				"Price (Taka)": "MRP Price"
			},
			{
				"Item Name": "Mega",
				"Price (Taka)": "MRP Price"
			},
			{
				"Item Name": "Vanilla Cup",
				"Price (Taka)": "MRP Price"
			}
		],
		"HOT & COLD BEVERAGE": [
			{
				"Item Name": "Milk Coffee",
				"Price (Taka)": 42.5
			},
			{
				"Item Name": "Raw Tea / Milk Tea",
				"Price (Taka)": 25.5
			},
			{
				"Item Name": "Mango Juice - 250ml",
				"Price (Taka)": 17
			},
			{
				"Item Name": "Mineral Water 500ml",
				"Price (Taka)": 17
			},
			{
				"Item Name": "Soft Drinks (300ml)",
				"Price (Taka)": 25.5
			},
			{
				"Item Name": "Watermelon Juice - 250ml",
				"Price (Taka)": 17
			}
		]
	};

/***/ },
/* 864 */
/***/ function(module, exports) {

	module.exports = [
		{
			"Sl_No": "01",
			"typeOfRoom": "VIP or Deluxe Suite",
			"rentPerDay": "30,000.00"
		},
		{
			"Sl_No": "02",
			"typeOfRoom": "Standard Suite",
			"rentPerDay": "20,000.00"
		},
		{
			"Sl_No": "03",
			"typeOfRoom": "Deluxe Single",
			"rentPerDay": "13,000.00"
		},
		{
			"Sl_No": "04",
			"typeOfRoom": "Luxury Single",
			"rentPerDay": "11,500.00"
		},
		{
			"Sl_No": "05",
			"typeOfRoom": "Standard Single",
			"rentPerDay": "10,000.00"
		},
		{
			"Sl_No": "06",
			"typeOfRoom": "Double Bedded Room (per bed)",
			"rentPerDay": "5,500.00"
		},
		{
			"Sl_No": "07",
			"typeOfRoom": "General Ward (Male/Female)",
			"rentPerDay": "4,200.00"
		},
		{
			"Sl_No": "08",
			"typeOfRoom": "ICU / CCU",
			"rentPerDay": "12,000.00"
		},
		{
			"Sl_No": "09",
			"typeOfRoom": "KT ICU",
			"rentPerDay": "12,000.00"
		},
		{
			"Sl_No": "10",
			"typeOfRoom": "CICU",
			"rentPerDay": "12,000.00"
		},
		{
			"Sl_No": "11",
			"typeOfRoom": "CICU (Step Down)",
			"rentPerDay": "9,000.00"
		},
		{
			"Sl_No": "12",
			"typeOfRoom": "NICU / PICU",
			"rentPerDay": "12,000.00"
		},
		{
			"Sl_No": "13",
			"typeOfRoom": "NICU HDU",
			"rentPerDay": "9,500.00"
		},
		{
			"Sl_No": "14",
			"typeOfRoom": "NICU Isolation HDU",
			"rentPerDay": "9,500.00"
		},
		{
			"Sl_No": "15",
			"typeOfRoom": "NICU Isolation ICU",
			"rentPerDay": "12,000.00"
		},
		{
			"Sl_No": "16",
			"typeOfRoom": "Cardiac HDU",
			"rentPerDay": "7,000.00"
		},
		{
			"Sl_No": "17",
			"typeOfRoom": "General HDU",
			"rentPerDay": "7,000.00"
		},
		{
			"Sl_No": "18",
			"typeOfRoom": "SCU (Special Care Unit)",
			"rentPerDay": "7,000.00"
		},
		{
			"Sl_No": "19",
			"typeOfRoom": "Nursery",
			"rentPerDay": "4,000.00"
		},
		{
			"Sl_No": "20",
			"typeOfRoom": "Oncology Ward (3 Bedded)",
			"rentPerDay": "4,000.00"
		},
		{
			"Sl_No": "21",
			"typeOfRoom": "Oncology – Day Care",
			"rentPerDay": "3,500.00"
		},
		{
			"Sl_No": "22",
			"typeOfRoom": "Ward (4 Bedded)",
			"rentPerDay": "4,000.00"
		},
		{
			"Sl_No": "23",
			"typeOfRoom": "Ward (8 Bedded)",
			"rentPerDay": "4,000.00"
		},
		{
			"Sl_No": "24",
			"typeOfRoom": "Ward (9 Bedded)",
			"rentPerDay": "4,000.00"
		},
		{
			"Sl_No": "25",
			"typeOfRoom": "Ward (Post Cath)",
			"rentPerDay": "4,000.00"
		},
		{
			"Sl_No": "26",
			"typeOfRoom": "Ward (Pre Cath)",
			"rentPerDay": "4,000.00"
		}
	];

/***/ },
/* 865 */
/***/ function(module, exports) {

	module.exports = [
		{
			"Sl_No": "01",
			"file": "VIP",
			"type": "VIP Suite (Patient Room)",
			"price": "30,000.00"
		},
		{
			"Sl_No": "02",
			"file": "STANDARD",
			"type": "Standard Suite",
			"price": "20,000.00"
		},
		{
			"Sl_No": "03",
			"file": "DELUXE",
			"type": "Deluxe Single",
			"price": "13,000.00"
		},
		{
			"Sl_No": "04",
			"file": "Luxary",
			"type": "Luxary Single",
			"price": "11,500.00"
		},
		{
			"Sl_No": "05",
			"file": "STANDARD_single",
			"type": "Standard Single",
			"price": "10,000.00"
		},
		{
			"Sl_No": "06",
			"file": "DOUBLE",
			"type": "Double Bedded Room",
			"price": "5,500.00"
		},
		{
			"Sl_No": "07",
			"file": "triple",
			"type": "Triple Bedded Room",
			"price": "4,000.00"
		},
		{
			"Sl_No": "08",
			"file": "ONCOLOGY",
			"type": "Oncology Ward",
			"price": "3,500.00"
		},
		{
			"Sl_No": "09",
			"file": "GENERAL",
			"type": "General Ward",
			"price": "4,200.00"
		}
	];

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(1040);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 867 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(89),
	    root = __webpack_require__(61);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(898),
	    hashDelete = __webpack_require__(899),
	    hashGet = __webpack_require__(900),
	    hashHas = __webpack_require__(901),
	    hashSet = __webpack_require__(902);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(89),
	    root = __webpack_require__(61);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(89),
	    root = __webpack_require__(61);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(249),
	    setCacheAdd = __webpack_require__(922),
	    setCacheHas = __webpack_require__(923);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(119),
	    stackClear = __webpack_require__(925),
	    stackDelete = __webpack_require__(926),
	    stackGet = __webpack_require__(927),
	    stackHas = __webpack_require__(928),
	    stackSet = __webpack_require__(929);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(61);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(89),
	    root = __webpack_require__(61);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 876 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(887),
	    isArguments = __webpack_require__(930),
	    isArray = __webpack_require__(158),
	    isBuffer = __webpack_require__(254),
	    isIndex = __webpack_require__(903),
	    isTypedArray = __webpack_require__(258);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 878 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 879 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(878),
	    isArray = __webpack_require__(158);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(121),
	    isObjectLike = __webpack_require__(124);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(883),
	    isObjectLike = __webpack_require__(124);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(873),
	    equalArrays = __webpack_require__(250),
	    equalByTag = __webpack_require__(891),
	    equalObjects = __webpack_require__(892),
	    getTag = __webpack_require__(896),
	    isArray = __webpack_require__(158),
	    isBuffer = __webpack_require__(254),
	    isTypedArray = __webpack_require__(258);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(255),
	    isMasked = __webpack_require__(905),
	    isObject = __webpack_require__(257),
	    toSource = __webpack_require__(252);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(121),
	    isLength = __webpack_require__(256),
	    isObjectLike = __webpack_require__(124);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(906),
	    nativeKeys = __webpack_require__(918);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 887 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 888 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 889 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(61);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(157),
	    Uint8Array = __webpack_require__(874),
	    eq = __webpack_require__(253),
	    equalArrays = __webpack_require__(250),
	    mapToArray = __webpack_require__(917),
	    setToArray = __webpack_require__(924);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(893);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(880),
	    getSymbols = __webpack_require__(895),
	    keys = __webpack_require__(933);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(157);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(876),
	    stubArray = __webpack_require__(934);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(868),
	    Map = __webpack_require__(156),
	    Promise = __webpack_require__(870),
	    Set = __webpack_require__(871),
	    WeakMap = __webpack_require__(875),
	    baseGetTag = __webpack_require__(121),
	    toSource = __webpack_require__(252);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 897 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(123);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 899 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(123);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(123);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(123);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 903 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 904 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(890);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 906 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 907 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(120);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(120);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(120);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(120);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(869),
	    ListCache = __webpack_require__(119),
	    Map = __webpack_require__(156);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(122);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(122);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(122);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(122);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 917 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(921);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(251);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(181)(module)))

/***/ },
/* 920 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 921 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 922 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 923 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 924 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(119);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 926 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 927 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 928 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(119),
	    Map = __webpack_require__(156),
	    MapCache = __webpack_require__(249);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(881),
	    isObjectLike = __webpack_require__(124);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(255),
	    isLength = __webpack_require__(256);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(882);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(877),
	    baseKeys = __webpack_require__(886),
	    isArrayLike = __webpack_require__(931);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 934 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 935 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 259,
		"./af.js": 259,
		"./ar": 267,
		"./ar-dz": 260,
		"./ar-dz.js": 260,
		"./ar-kw": 261,
		"./ar-kw.js": 261,
		"./ar-ly": 262,
		"./ar-ly.js": 262,
		"./ar-ma": 263,
		"./ar-ma.js": 263,
		"./ar-ps": 264,
		"./ar-ps.js": 264,
		"./ar-sa": 265,
		"./ar-sa.js": 265,
		"./ar-tn": 266,
		"./ar-tn.js": 266,
		"./ar.js": 267,
		"./az": 268,
		"./az.js": 268,
		"./be": 269,
		"./be.js": 269,
		"./bg": 270,
		"./bg.js": 270,
		"./bm": 271,
		"./bm.js": 271,
		"./bn": 273,
		"./bn-bd": 272,
		"./bn-bd.js": 272,
		"./bn.js": 273,
		"./bo": 274,
		"./bo.js": 274,
		"./br": 275,
		"./br.js": 275,
		"./bs": 276,
		"./bs.js": 276,
		"./ca": 277,
		"./ca.js": 277,
		"./cs": 278,
		"./cs.js": 278,
		"./cv": 279,
		"./cv.js": 279,
		"./cy": 280,
		"./cy.js": 280,
		"./da": 281,
		"./da.js": 281,
		"./de": 284,
		"./de-at": 282,
		"./de-at.js": 282,
		"./de-ch": 283,
		"./de-ch.js": 283,
		"./de.js": 284,
		"./dv": 285,
		"./dv.js": 285,
		"./el": 286,
		"./el.js": 286,
		"./en-au": 287,
		"./en-au.js": 287,
		"./en-ca": 288,
		"./en-ca.js": 288,
		"./en-gb": 289,
		"./en-gb.js": 289,
		"./en-ie": 290,
		"./en-ie.js": 290,
		"./en-il": 291,
		"./en-il.js": 291,
		"./en-in": 292,
		"./en-in.js": 292,
		"./en-nz": 293,
		"./en-nz.js": 293,
		"./en-sg": 294,
		"./en-sg.js": 294,
		"./eo": 295,
		"./eo.js": 295,
		"./es": 299,
		"./es-do": 296,
		"./es-do.js": 296,
		"./es-mx": 297,
		"./es-mx.js": 297,
		"./es-us": 298,
		"./es-us.js": 298,
		"./es.js": 299,
		"./et": 300,
		"./et.js": 300,
		"./eu": 301,
		"./eu.js": 301,
		"./fa": 302,
		"./fa.js": 302,
		"./fi": 303,
		"./fi.js": 303,
		"./fil": 304,
		"./fil.js": 304,
		"./fo": 305,
		"./fo.js": 305,
		"./fr": 308,
		"./fr-ca": 306,
		"./fr-ca.js": 306,
		"./fr-ch": 307,
		"./fr-ch.js": 307,
		"./fr.js": 308,
		"./fy": 309,
		"./fy.js": 309,
		"./ga": 310,
		"./ga.js": 310,
		"./gd": 311,
		"./gd.js": 311,
		"./gl": 312,
		"./gl.js": 312,
		"./gom-deva": 313,
		"./gom-deva.js": 313,
		"./gom-latn": 314,
		"./gom-latn.js": 314,
		"./gu": 315,
		"./gu.js": 315,
		"./he": 316,
		"./he.js": 316,
		"./hi": 317,
		"./hi.js": 317,
		"./hr": 318,
		"./hr.js": 318,
		"./hu": 319,
		"./hu.js": 319,
		"./hy-am": 320,
		"./hy-am.js": 320,
		"./id": 321,
		"./id.js": 321,
		"./is": 322,
		"./is.js": 322,
		"./it": 324,
		"./it-ch": 323,
		"./it-ch.js": 323,
		"./it.js": 324,
		"./ja": 325,
		"./ja.js": 325,
		"./jv": 326,
		"./jv.js": 326,
		"./ka": 327,
		"./ka.js": 327,
		"./kk": 328,
		"./kk.js": 328,
		"./km": 329,
		"./km.js": 329,
		"./kn": 330,
		"./kn.js": 330,
		"./ko": 331,
		"./ko.js": 331,
		"./ku": 333,
		"./ku-kmr": 332,
		"./ku-kmr.js": 332,
		"./ku.js": 333,
		"./ky": 334,
		"./ky.js": 334,
		"./lb": 335,
		"./lb.js": 335,
		"./lo": 336,
		"./lo.js": 336,
		"./lt": 337,
		"./lt.js": 337,
		"./lv": 338,
		"./lv.js": 338,
		"./me": 339,
		"./me.js": 339,
		"./mi": 340,
		"./mi.js": 340,
		"./mk": 341,
		"./mk.js": 341,
		"./ml": 342,
		"./ml.js": 342,
		"./mn": 343,
		"./mn.js": 343,
		"./mr": 344,
		"./mr.js": 344,
		"./ms": 346,
		"./ms-my": 345,
		"./ms-my.js": 345,
		"./ms.js": 346,
		"./mt": 347,
		"./mt.js": 347,
		"./my": 348,
		"./my.js": 348,
		"./nb": 349,
		"./nb.js": 349,
		"./ne": 350,
		"./ne.js": 350,
		"./nl": 352,
		"./nl-be": 351,
		"./nl-be.js": 351,
		"./nl.js": 352,
		"./nn": 353,
		"./nn.js": 353,
		"./oc-lnc": 354,
		"./oc-lnc.js": 354,
		"./pa-in": 355,
		"./pa-in.js": 355,
		"./pl": 356,
		"./pl.js": 356,
		"./pt": 358,
		"./pt-br": 357,
		"./pt-br.js": 357,
		"./pt.js": 358,
		"./ro": 359,
		"./ro.js": 359,
		"./ru": 360,
		"./ru.js": 360,
		"./sd": 361,
		"./sd.js": 361,
		"./se": 362,
		"./se.js": 362,
		"./si": 363,
		"./si.js": 363,
		"./sk": 364,
		"./sk.js": 364,
		"./sl": 365,
		"./sl.js": 365,
		"./sq": 366,
		"./sq.js": 366,
		"./sr": 368,
		"./sr-cyrl": 367,
		"./sr-cyrl.js": 367,
		"./sr.js": 368,
		"./ss": 369,
		"./ss.js": 369,
		"./sv": 370,
		"./sv.js": 370,
		"./sw": 371,
		"./sw.js": 371,
		"./ta": 372,
		"./ta.js": 372,
		"./te": 373,
		"./te.js": 373,
		"./tet": 374,
		"./tet.js": 374,
		"./tg": 375,
		"./tg.js": 375,
		"./th": 376,
		"./th.js": 376,
		"./tk": 377,
		"./tk.js": 377,
		"./tl-ph": 378,
		"./tl-ph.js": 378,
		"./tlh": 379,
		"./tlh.js": 379,
		"./tr": 380,
		"./tr.js": 380,
		"./tzl": 381,
		"./tzl.js": 381,
		"./tzm": 383,
		"./tzm-latn": 382,
		"./tzm-latn.js": 382,
		"./tzm.js": 383,
		"./ug-cn": 384,
		"./ug-cn.js": 384,
		"./uk": 385,
		"./uk.js": 385,
		"./ur": 386,
		"./ur.js": 386,
		"./uz": 388,
		"./uz-latn": 387,
		"./uz-latn.js": 387,
		"./uz.js": 388,
		"./vi": 389,
		"./vi.js": 389,
		"./x-pseudo": 390,
		"./x-pseudo.js": 390,
		"./yo": 391,
		"./yo.js": 391,
		"./zh-cn": 392,
		"./zh-cn.js": 392,
		"./zh-hk": 393,
		"./zh-hk.js": 393,
		"./zh-mo": 394,
		"./zh-mo.js": 394,
		"./zh-tw": 395,
		"./zh-tw.js": 395
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 936;


/***/ },
/* 937 */
/***/ function(module, exports) {

	module.exports = Paginator;
	
	// Paginator constructor
	//
	// `per_page` is the number of results per page, `length` is the number of
	// pages to display. They default to `25` and `10` respectively.
	function Paginator(per_page, length) {
	  // You really should be calling this with `new Paginator`, but WHATEVER.
	  if (!(this instanceof Paginator)) {
	    return new Paginator(per_page, length);
	  }
	
	  // Woo, defaults!
	  this.per_page = per_page || 25;
	  this.length = length || 10;
	}
	
	// Build an object with all the necessary information for outputting pagination
	// controls.
	//
	// (new Paginator(paginator.build(100, 2)
	Paginator.prototype.build = function(total_results, current_page) {
	  // We want the number of pages, rounded up to the nearest page.
	  var total_pages = Math.ceil(total_results / this.per_page);
	
	  // Ensure both total_results and current_page are treated as Numbers
	  total_results = parseInt(total_results, 10);
	  current_page  = parseInt(current_page, 10) || 1;
	
	  // Obviously we can't be on a negative or 0 page.
	  if (current_page < 1) { current_page = 1; }
	  // If the user has done something like /page/99999 we want to clamp that back
	  // down.
	  if (current_page > total_pages) { current_page = total_pages; }
	
	  // This is the first page to be displayed as a numbered link.
	  var first_page = Math.max(1, current_page - Math.floor(this.length / 2));
	
	  // And here's the last page to be displayed specifically.
	  var last_page = Math.min(total_pages, current_page + Math.floor(this.length / 2));
	
	  // This is triggered if we're at or near one of the extremes; we won't have
	  // enough page links. We need to adjust our bounds accordingly.
	  if (last_page - first_page + 1 < this.length) {
	    if (current_page < (total_pages / 2)) {
	      last_page = Math.min(total_pages, last_page + (this.length - (last_page - first_page)));
	    } else {
	      first_page = Math.max(1, first_page - (this.length - (last_page - first_page)));
	    }
	  }
	
	  // This can be triggered if the user wants an odd number of pages.
	  if (last_page - first_page + 1 > this.length) {
	    // We want to move towards whatever extreme we're closest to at the time.
	    if (current_page > (total_pages / 2)) {
	      first_page++;
	    } else {
	      last_page--;
	    }
	  }
	
	  // First result on the page. This, along with the field below, can be used to
	  // do "showing x to y of z results" style things.
	  var first_result = this.per_page * (current_page - 1);
	  if (first_result < 0) { first_result = 0; }
	
	  // Last result on the page.
	  var last_result = (this.per_page * current_page) - 1;
	  if (last_result < 0) { last_result = 0; }
	  if (last_result > Math.max(total_results - 1, 0)) { last_result = Math.max(total_results - 1, 0); }
	
	  // GIMME THAT OBJECT
	  return {
	    total_pages: total_pages,
	    pages: Math.min(last_page - first_page + 1, total_pages),
	    current_page: current_page,
	    first_page: first_page,
	    last_page: last_page,
	    previous_page: current_page - 1,
	    next_page: current_page + 1,
	    has_previous_page: current_page > 1,
	    has_next_page: current_page < total_pages,
	    total_results: total_results,
	    results: Math.min(last_result - first_result + 1, total_results),
	    first_result: first_result,
	    last_result: last_result,
	  };
	};


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(852)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(397);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(397);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(942);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 942 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	/*! For license information please see quill.htmlEditButton.min.js.LICENSE.txt */
	!function(t,e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var n=e();for(var r in n)("object"==typeof exports?exports:t)[r]=n[r]}}(window,(function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/dist/",n(n.s=0)}([function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=function(t,e){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n])})(t,e)},function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Class extends value "+String(e)+" is not a constructor or null");function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}),i=this&&this.__assign||function(){return(i=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)},l=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.htmlEditButton=void 0;var a=n(1);n(2);var s=l(n(7)),u=n(13),c=n(14);function f(t){return document.createElement(t)}function h(t,e,n){return t.setAttribute(e,n)}var p=new a.QuillHtmlLogger,d=function(){function t(t,e){var n=e||{},r=!(!n||!n.debug);p.setDebug(r),p.log("logging enabled");var o=t.getModule("toolbar");if(!o)throw new Error('quill.htmlEditButton requires the "toolbar" module to be included too');this.registerDivModule();var l=o.container,a=f("span");h(a,"class","ql-formats");var d=f("button");d.innerHTML=n.buttonHTML||"&lt;&gt;",d.title=n.buttonTitle||"Show HTML source",d.type="button";var y=function(e){t.clipboard.dangerouslyPasteHTML(e)};d.onclick=function(e){e.preventDefault(),function(t,e,n){var r=t.container.querySelector(".ql-editor").innerHTML,o=f("div"),l=f("div"),a=e.msg||'Edit HTML here, when you click "OK" the quill editor\'s contents will be replaced',d=e.cancelText||"Cancel",y=e.okText||"Ok",v=!1!==e.closeOnClickOverlay;h(l,"class","ql-html-overlayContainer"),h(o,"class","ql-html-popupContainer");var b=f("span");h(b,"class","ql-html-popupTitle"),b.innerText=a;var g=f("div");g.appendChild(b),h(g,"class","ql-html-textContainer");var m=f("pre");h(m,"data-language","xml"),m.innerText=(0,c.FormatHTMLStringIndentation)(r,p);var _=f("div");h(_,"class","ql-html-textArea");var O=f("button");O.innerHTML=d,h(O,"class","ql-html-buttonCancel");var w=f("button");w.innerHTML=y,h(w,"class","ql-html-buttonOk");var x=f("div");h(x,"class","ql-html-buttonGroup");var E=document.querySelector(e.prependSelector);x.appendChild(O),x.appendChild(w),_.appendChild(m),g.appendChild(_),g.appendChild(x),o.appendChild(g),l.appendChild(o),E?E.prepend(l):document.body.appendChild(l);var k=e&&e.editorModules,A=k&&Object.keys(k).length?k:{},N=new s.default(_,{modules:i({syntax:e.syntax},A)});O.onclick=function(){E?E.removeChild(l):document.body.removeChild(l)},v&&(l.onclick=O.onclick);o.onclick=function(t){t.preventDefault(),t.stopPropagation()},w.onclick=function(){var t=N.container.querySelector(".ql-editor").innerText,e=(0,u.OutputHTMLParser)(t);p.log("OutputHTMLParser",{htmlInputFromPopup:t,htmlOutputFormatted:e}),n(e),E?E.removeChild(l):document.body.removeChild(l)}}(t,n,y)},a.appendChild(d),l.appendChild(a)}return t.prototype.registerDivModule=function(){var t=s.default.import("blots/block"),e=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e}(t);e.tagName="div",e.blotName="div",e.allowedChildren=t.allowedChildren,e.allowedChildren.push(t),s.default.register(e)},t}();e.htmlEditButton=d,window.htmlEditButton=d,e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.QuillHtmlLogger=void 0;var r=function(){function t(){this.debug=!1}return t.prototype.setDebug=function(t){this.debug=t},t.prototype.prefixString=function(){return"</> quill-html-edit-button: "},Object.defineProperty(t.prototype,"log",{get:function(){return this.debug?console.log.bind(console,this.prefixString()):function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e]}},enumerable:!1,configurable:!0}),t}();e.QuillHtmlLogger=r},function(t,e,n){var r=n(3);"string"==typeof r&&(r=[[t.i,r,""]]);var o={hmr:!0,transform:void 0};n(5)(r,o);r.locals&&(t.exports=r.locals)},function(t,e,n){(t.exports=n(4)(!1)).push([t.i,".ql-html-overlayContainer {\n  background: #0000007d;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n}\n\n.ql-html-popupContainer {\n  background: #ddd;\n  position: absolute;\n  top: 5%;\n  left: 5%;\n  right: 5%;\n  bottom: 5%;\n  border-radius: 10px;\n}\n\n.ql-html-textContainer {\n  position: relative;\n  height: calc(100% - 40px);\n  padding: 20px;\n}\n\n.ql-html-textArea {\n  background: #fff;\n  position: absolute;\n  left: 15px;\n  width: calc(100% - 30px);\n  height: calc(100% - 60px) !important;\n}\n\n.ql-html-textArea .ql-syntax {\n  word-break: break-all;\n  white-space: pre-wrap;\n}\n\n.ql-html-buttonCancel {\n  margin-right: 20px;\n}\n\n.ql-html-popupTitle {\n  margin: 0;\n  display: block;\n  font-style: italic;\n}\n\n.ql-html-buttonGroup {\n  position: absolute;\n  bottom: 20px;\n  transform: scale(1.5);\n  left: calc(50% - 60px);\n}\n",""])},function(t,e){t.exports=function(t){var e=[];return e.toString=function(){return this.map((function(e){var n=function(t,e){var n=t[1]||"",r=t[3];if(!r)return n;if(e&&"function"==typeof btoa){var o=(l=r,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(l))))+" */"),i=r.sources.map((function(t){return"/*# sourceURL="+r.sourceRoot+t+" */"}));return[n].concat(i).concat([o]).join("\n")}var l;return[n].join("\n")}(e,t);return e[2]?"@media "+e[2]+"{"+n+"}":n})).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var r={},o=0;o<this.length;o++){var i=this[o][0];"number"==typeof i&&(r[i]=!0)}for(o=0;o<t.length;o++){var l=t[o];"number"==typeof l[0]&&r[l[0]]||(n&&!l[2]?l[2]=n:n&&(l[2]="("+l[2]+") and ("+n+")"),e.push(l))}},e}},function(t,e,n){var r,o,i={},l=(r=function(){return window&&document&&document.all&&!window.atob},function(){return void 0===o&&(o=r.apply(this,arguments)),o}),a=function(t){var e={};return function(n){if(void 0===e[n]){var r=t.call(this,n);if(r instanceof window.HTMLIFrameElement)try{r=r.contentDocument.head}catch(t){r=null}e[n]=r}return e[n]}}((function(t){return document.querySelector(t)})),s=null,u=0,c=[],f=n(6);function h(t,e){for(var n=0;n<t.length;n++){var r=t[n],o=i[r.id];if(o){o.refs++;for(var l=0;l<o.parts.length;l++)o.parts[l](r.parts[l]);for(;l<r.parts.length;l++)o.parts.push(g(r.parts[l],e))}else{var a=[];for(l=0;l<r.parts.length;l++)a.push(g(r.parts[l],e));i[r.id]={id:r.id,refs:1,parts:a}}}}function p(t,e){for(var n=[],r={},o=0;o<t.length;o++){var i=t[o],l=e.base?i[0]+e.base:i[0],a={css:i[1],media:i[2],sourceMap:i[3]};r[l]?r[l].parts.push(a):n.push(r[l]={id:l,parts:[a]})}return n}function d(t,e){var n=a(t.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var r=c[c.length-1];if("top"===t.insertAt)r?r.nextSibling?n.insertBefore(e,r.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),c.push(e);else if("bottom"===t.insertAt)n.appendChild(e);else{if("object"!=typeof t.insertAt||!t.insertAt.before)throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");var o=a(t.insertInto+" "+t.insertAt.before);n.insertBefore(e,o)}}function y(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t);var e=c.indexOf(t);e>=0&&c.splice(e,1)}function v(t){var e=document.createElement("style");return t.attrs.type="text/css",b(e,t.attrs),d(t,e),e}function b(t,e){Object.keys(e).forEach((function(n){t.setAttribute(n,e[n])}))}function g(t,e){var n,r,o,i;if(e.transform&&t.css){if(!(i=e.transform(t.css)))return function(){};t.css=i}if(e.singleton){var l=u++;n=s||(s=v(e)),r=O.bind(null,n,l,!1),o=O.bind(null,n,l,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=function(t){var e=document.createElement("link");return t.attrs.type="text/css",t.attrs.rel="stylesheet",b(e,t.attrs),d(t,e),e}(e),r=x.bind(null,n,e),o=function(){y(n),n.href&&URL.revokeObjectURL(n.href)}):(n=v(e),r=w.bind(null,n),o=function(){y(n)});return r(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;r(t=e)}else o()}}t.exports=function(t,e){if(false)throw new Error("The style-loader cannot be used in a non-browser environment");(e=e||{}).attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||"boolean"==typeof e.singleton||(e.singleton=l()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var n=p(t,e);return h(n,e),function(t){for(var r=[],o=0;o<n.length;o++){var l=n[o];(a=i[l.id]).refs--,r.push(a)}t&&h(p(t,e),e);for(o=0;o<r.length;o++){var a;if(0===(a=r[o]).refs){for(var s=0;s<a.parts.length;s++)a.parts[s]();delete i[a.id]}}}};var m,_=(m=[],function(t,e){return m[t]=e,m.filter(Boolean).join("\n")});function O(t,e,n,r){var o=n?"":r.css;if(t.styleSheet)t.styleSheet.cssText=_(e,o);else{var i=document.createTextNode(o),l=t.childNodes;l[e]&&t.removeChild(l[e]),l.length?t.insertBefore(i,l[e]):t.appendChild(i)}}function w(t,e){var n=e.css,r=e.media;if(r&&t.setAttribute("media",r),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}function x(t,e,n){var r=n.css,o=n.sourceMap,i=void 0===e.convertToAbsoluteUrls&&o;(e.convertToAbsoluteUrls||i)&&(r=f(r)),o&&(r+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */");var l=new Blob([r],{type:"text/css"}),a=t.href;t.href=URL.createObjectURL(l),a&&URL.revokeObjectURL(a)}},function(t,e){t.exports=function(t){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!t||"string"!=typeof t)return t;var n=e.protocol+"//"+e.host,r=n+e.pathname.replace(/\/[^\/]*$/,"/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,(function(t,e){var o,i=e.trim().replace(/^"(.*)"$/,(function(t,e){return e})).replace(/^'(.*)'$/,(function(t,e){return e}));return/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(i)?t:(o=0===i.indexOf("//")?i:0===i.indexOf("/")?n+i:r+i.replace(/^\.\//,""),"url("+JSON.stringify(o)+")")}))}},function(t,e,n){(function(e){var n;"undefined"!=typeof self&&self,n=function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:r})},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=109)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(17),o=n(18),i=n(19),l=n(45),a=n(46),s=n(47),u=n(48),c=n(49),f=n(12),h=n(32),p=n(33),d=n(31),y=n(1),v={Scope:y.Scope,create:y.create,find:y.find,query:y.query,register:y.register,Container:r.default,Format:o.default,Leaf:i.default,Embed:u.default,Scroll:l.default,Block:s.default,Inline:a.default,Text:c.default,Attributor:{Attribute:f.default,Class:h.default,Style:p.default,Store:d.default}};e.default=v},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=function(t){function e(e){var n=this;return e="[Parchment] "+e,(n=t.call(this,e)||this).message=e,n.name=n.constructor.name,n}return o(e,t),e}(Error);e.ParchmentError=i;var l,a={},s={},u={},c={};function f(t,e){var n;if(void 0===e&&(e=l.ANY),"string"==typeof t)n=c[t]||a[t];else if(t instanceof Text||t.nodeType===Node.TEXT_NODE)n=c.text;else if("number"==typeof t)t&l.LEVEL&l.BLOCK?n=c.block:t&l.LEVEL&l.INLINE&&(n=c.inline);else if(t instanceof HTMLElement){var r=(t.getAttribute("class")||"").split(/\s+/);for(var o in r)if(n=s[r[o]])break;n=n||u[t.tagName]}return null==n?null:e&l.LEVEL&n.scope&&e&l.TYPE&n.scope?n:null}e.DATA_KEY="__blot",function(t){t[t.TYPE=3]="TYPE",t[t.LEVEL=12]="LEVEL",t[t.ATTRIBUTE=13]="ATTRIBUTE",t[t.BLOT=14]="BLOT",t[t.INLINE=7]="INLINE",t[t.BLOCK=11]="BLOCK",t[t.BLOCK_BLOT=10]="BLOCK_BLOT",t[t.INLINE_BLOT=6]="INLINE_BLOT",t[t.BLOCK_ATTRIBUTE=9]="BLOCK_ATTRIBUTE",t[t.INLINE_ATTRIBUTE=5]="INLINE_ATTRIBUTE",t[t.ANY=15]="ANY"}(l=e.Scope||(e.Scope={})),e.create=function(t,e){var n=f(t);if(null==n)throw new i("Unable to create "+t+" blot");var r=n,o=t instanceof Node||t.nodeType===Node.TEXT_NODE?t:r.create(e);return new r(o,e)},e.find=function t(n,r){return void 0===r&&(r=!1),null==n?null:null!=n[e.DATA_KEY]?n[e.DATA_KEY].blot:r?t(n.parentNode,r):null},e.query=f,e.register=function t(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];if(e.length>1)return e.map((function(e){return t(e)}));var r=e[0];if("string"!=typeof r.blotName&&"string"!=typeof r.attrName)throw new i("Invalid definition");if("abstract"===r.blotName)throw new i("Cannot register abstract class");if(c[r.blotName||r.attrName]=r,"string"==typeof r.keyName)a[r.keyName]=r;else if(null!=r.className&&(s[r.className]=r),null!=r.tagName){Array.isArray(r.tagName)?r.tagName=r.tagName.map((function(t){return t.toUpperCase()})):r.tagName=r.tagName.toUpperCase();var o=Array.isArray(r.tagName)?r.tagName:[r.tagName];o.forEach((function(t){null!=u[t]&&null!=r.className||(u[t]=r)}))}return r}},function(t,e,n){var r=n(51),o=n(11),i=n(3),l=n(20),a=String.fromCharCode(0),s=function(t){Array.isArray(t)?this.ops=t:null!=t&&Array.isArray(t.ops)?this.ops=t.ops:this.ops=[]};s.prototype.insert=function(t,e){var n={};return 0===t.length?this:(n.insert=t,null!=e&&"object"==typeof e&&Object.keys(e).length>0&&(n.attributes=e),this.push(n))},s.prototype.delete=function(t){return t<=0?this:this.push({delete:t})},s.prototype.retain=function(t,e){if(t<=0)return this;var n={retain:t};return null!=e&&"object"==typeof e&&Object.keys(e).length>0&&(n.attributes=e),this.push(n)},s.prototype.push=function(t){var e=this.ops.length,n=this.ops[e-1];if(t=i(!0,{},t),"object"==typeof n){if("number"==typeof t.delete&&"number"==typeof n.delete)return this.ops[e-1]={delete:n.delete+t.delete},this;if("number"==typeof n.delete&&null!=t.insert&&(e-=1,"object"!=typeof(n=this.ops[e-1])))return this.ops.unshift(t),this;if(o(t.attributes,n.attributes)){if("string"==typeof t.insert&&"string"==typeof n.insert)return this.ops[e-1]={insert:n.insert+t.insert},"object"==typeof t.attributes&&(this.ops[e-1].attributes=t.attributes),this;if("number"==typeof t.retain&&"number"==typeof n.retain)return this.ops[e-1]={retain:n.retain+t.retain},"object"==typeof t.attributes&&(this.ops[e-1].attributes=t.attributes),this}}return e===this.ops.length?this.ops.push(t):this.ops.splice(e,0,t),this},s.prototype.chop=function(){var t=this.ops[this.ops.length-1];return t&&t.retain&&!t.attributes&&this.ops.pop(),this},s.prototype.filter=function(t){return this.ops.filter(t)},s.prototype.forEach=function(t){this.ops.forEach(t)},s.prototype.map=function(t){return this.ops.map(t)},s.prototype.partition=function(t){var e=[],n=[];return this.forEach((function(r){(t(r)?e:n).push(r)})),[e,n]},s.prototype.reduce=function(t,e){return this.ops.reduce(t,e)},s.prototype.changeLength=function(){return this.reduce((function(t,e){return e.insert?t+l.length(e):e.delete?t-e.delete:t}),0)},s.prototype.length=function(){return this.reduce((function(t,e){return t+l.length(e)}),0)},s.prototype.slice=function(t,e){t=t||0,"number"!=typeof e&&(e=1/0);for(var n=[],r=l.iterator(this.ops),o=0;o<e&&r.hasNext();){var i;o<t?i=r.next(t-o):(i=r.next(e-o),n.push(i)),o+=l.length(i)}return new s(n)},s.prototype.compose=function(t){var e=l.iterator(this.ops),n=l.iterator(t.ops),r=[],i=n.peek();if(null!=i&&"number"==typeof i.retain&&null==i.attributes){for(var a=i.retain;"insert"===e.peekType()&&e.peekLength()<=a;)a-=e.peekLength(),r.push(e.next());i.retain-a>0&&n.next(i.retain-a)}for(var u=new s(r);e.hasNext()||n.hasNext();)if("insert"===n.peekType())u.push(n.next());else if("delete"===e.peekType())u.push(e.next());else{var c=Math.min(e.peekLength(),n.peekLength()),f=e.next(c),h=n.next(c);if("number"==typeof h.retain){var p={};"number"==typeof f.retain?p.retain=c:p.insert=f.insert;var d=l.attributes.compose(f.attributes,h.attributes,"number"==typeof f.retain);if(d&&(p.attributes=d),u.push(p),!n.hasNext()&&o(u.ops[u.ops.length-1],p)){var y=new s(e.rest());return u.concat(y).chop()}}else"number"==typeof h.delete&&"number"==typeof f.retain&&u.push(h)}return u.chop()},s.prototype.concat=function(t){var e=new s(this.ops.slice());return t.ops.length>0&&(e.push(t.ops[0]),e.ops=e.ops.concat(t.ops.slice(1))),e},s.prototype.diff=function(t,e){if(this.ops===t.ops)return new s;var n=[this,t].map((function(e){return e.map((function(n){if(null!=n.insert)return"string"==typeof n.insert?n.insert:a;throw new Error("diff() called "+(e===t?"on":"with")+" non-document")})).join("")})),i=new s,u=r(n[0],n[1],e),c=l.iterator(this.ops),f=l.iterator(t.ops);return u.forEach((function(t){for(var e=t[1].length;e>0;){var n=0;switch(t[0]){case r.INSERT:n=Math.min(f.peekLength(),e),i.push(f.next(n));break;case r.DELETE:n=Math.min(e,c.peekLength()),c.next(n),i.delete(n);break;case r.EQUAL:n=Math.min(c.peekLength(),f.peekLength(),e);var a=c.next(n),s=f.next(n);o(a.insert,s.insert)?i.retain(n,l.attributes.diff(a.attributes,s.attributes)):i.push(s).delete(n)}e-=n}})),i.chop()},s.prototype.eachLine=function(t,e){e=e||"\n";for(var n=l.iterator(this.ops),r=new s,o=0;n.hasNext();){if("insert"!==n.peekType())return;var i=n.peek(),a=l.length(i)-n.peekLength(),u="string"==typeof i.insert?i.insert.indexOf(e,a)-a:-1;if(u<0)r.push(n.next());else if(u>0)r.push(n.next(u));else{if(!1===t(r,n.next(1).attributes||{},o))return;o+=1,r=new s}}r.length()>0&&t(r,{},o)},s.prototype.transform=function(t,e){if(e=!!e,"number"==typeof t)return this.transformPosition(t,e);for(var n=l.iterator(this.ops),r=l.iterator(t.ops),o=new s;n.hasNext()||r.hasNext();)if("insert"!==n.peekType()||!e&&"insert"===r.peekType())if("insert"===r.peekType())o.push(r.next());else{var i=Math.min(n.peekLength(),r.peekLength()),a=n.next(i),u=r.next(i);if(a.delete)continue;u.delete?o.push(u):o.retain(i,l.attributes.transform(a.attributes,u.attributes,e))}else o.retain(l.length(n.next()));return o.chop()},s.prototype.transformPosition=function(t,e){e=!!e;for(var n=l.iterator(this.ops),r=0;n.hasNext()&&r<=t;){var o=n.peekLength(),i=n.peekType();n.next(),"delete"!==i?("insert"===i&&(r<t||!e)&&(t+=o),r+=o):t-=Math.min(o,t-r)}return t},t.exports=s},function(t,e){"use strict";var n=Object.prototype.hasOwnProperty,r=Object.prototype.toString,o=Object.defineProperty,i=Object.getOwnPropertyDescriptor,l=function(t){return"function"==typeof Array.isArray?Array.isArray(t):"[object Array]"===r.call(t)},a=function(t){if(!t||"[object Object]"!==r.call(t))return!1;var e,o=n.call(t,"constructor"),i=t.constructor&&t.constructor.prototype&&n.call(t.constructor.prototype,"isPrototypeOf");if(t.constructor&&!o&&!i)return!1;for(e in t);return void 0===e||n.call(t,e)},s=function(t,e){o&&"__proto__"===e.name?o(t,e.name,{enumerable:!0,configurable:!0,value:e.newValue,writable:!0}):t[e.name]=e.newValue},u=function(t,e){if("__proto__"===e){if(!n.call(t,e))return;if(i)return i(t,e).value}return t[e]};t.exports=function t(){var e,n,r,o,i,c,f=arguments[0],h=1,p=arguments.length,d=!1;for("boolean"==typeof f&&(d=f,f=arguments[1]||{},h=2),(null==f||"object"!=typeof f&&"function"!=typeof f)&&(f={});h<p;++h)if(null!=(e=arguments[h]))for(n in e)r=u(f,n),f!==(o=u(e,n))&&(d&&o&&(a(o)||(i=l(o)))?(i?(i=!1,c=r&&l(r)?r:[]):c=r&&a(r)?r:{},s(f,{name:n,newValue:t(d,c,o)})):void 0!==o&&s(f,{name:n,newValue:o}));return f}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BlockEmbed=e.bubbleFormats=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=f(n(3)),l=f(n(2)),a=f(n(0)),s=f(n(16)),u=f(n(6)),c=f(n(7));function f(t){return t&&t.__esModule?t:{default:t}}function h(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function p(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function d(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var y=function(t){function e(){return h(this,e),p(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return d(e,t),r(e,[{key:"attach",value:function(){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"attach",this).call(this),this.attributes=new a.default.Attributor.Store(this.domNode)}},{key:"delta",value:function(){return(new l.default).insert(this.value(),(0,i.default)(this.formats(),this.attributes.values()))}},{key:"format",value:function(t,e){var n=a.default.query(t,a.default.Scope.BLOCK_ATTRIBUTE);null!=n&&this.attributes.attribute(n,e)}},{key:"formatAt",value:function(t,e,n,r){this.format(n,r)}},{key:"insertAt",value:function(t,n,r){if("string"==typeof n&&n.endsWith("\n")){var i=a.default.create(v.blotName);this.parent.insertBefore(i,0===t?this:this.next),i.insertAt(0,n.slice(0,-1))}else o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r)}}]),e}(a.default.Embed);y.scope=a.default.Scope.BLOCK_BLOT;var v=function(t){function e(t){h(this,e);var n=p(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.cache={},n}return d(e,t),r(e,[{key:"delta",value:function(){return null==this.cache.delta&&(this.cache.delta=this.descendants(a.default.Leaf).reduce((function(t,e){return 0===e.length()?t:t.insert(e.value(),b(e))}),new l.default).insert("\n",b(this))),this.cache.delta}},{key:"deleteAt",value:function(t,n){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"deleteAt",this).call(this,t,n),this.cache={}}},{key:"formatAt",value:function(t,n,r,i){n<=0||(a.default.query(r,a.default.Scope.BLOCK)?t+n===this.length()&&this.format(r,i):o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,Math.min(n,this.length()-t-1),r,i),this.cache={})}},{key:"insertAt",value:function(t,n,r){if(null!=r)return o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r);if(0!==n.length){var i=n.split("\n"),l=i.shift();l.length>0&&(t<this.length()-1||null==this.children.tail?o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,Math.min(t,this.length()-1),l):this.children.tail.insertAt(this.children.tail.length(),l),this.cache={});var a=this;i.reduce((function(t,e){return(a=a.split(t,!0)).insertAt(0,e),e.length}),t+l.length)}}},{key:"insertBefore",value:function(t,n){var r=this.children.head;o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n),r instanceof s.default&&r.remove(),this.cache={}}},{key:"length",value:function(){return null==this.cache.length&&(this.cache.length=o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"length",this).call(this)+1),this.cache.length}},{key:"moveChildren",value:function(t,n){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"moveChildren",this).call(this,t,n),this.cache={}}},{key:"optimize",value:function(t){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.cache={}}},{key:"path",value:function(t){return o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"path",this).call(this,t,!0)}},{key:"removeChild",value:function(t){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"removeChild",this).call(this,t),this.cache={}}},{key:"split",value:function(t){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(n&&(0===t||t>=this.length()-1)){var r=this.clone();return 0===t?(this.parent.insertBefore(r,this),this):(this.parent.insertBefore(r,this.next),r)}var i=o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"split",this).call(this,t,n);return this.cache={},i}}]),e}(a.default.Block);function b(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return null==t?e:("function"==typeof t.formats&&(e=(0,i.default)(e,t.formats())),null==t.parent||"scroll"==t.parent.blotName||t.parent.statics.scope!==t.statics.scope?e:b(t.parent,e))}v.blotName="block",v.tagName="P",v.defaultChild="break",v.allowedChildren=[u.default,a.default.Embed,c.default],e.bubbleFormats=b,e.BlockEmbed=y,e.default=v},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.overload=e.expandConfig=void 0;var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}();n(50);var l=v(n(2)),a=v(n(14)),s=v(n(8)),u=v(n(9)),c=v(n(0)),f=n(15),h=v(f),p=v(n(3)),d=v(n(10)),y=v(n(34));function v(t){return t&&t.__esModule?t:{default:t}}function b(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function g(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var m=(0,d.default)("quill"),_=function(){function t(e){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(g(this,t),this.options=O(e,r),this.container=this.options.container,null==this.container)return m.error("Invalid Quill container",e);this.options.debug&&t.debug(this.options.debug);var o=this.container.innerHTML.trim();this.container.classList.add("ql-container"),this.container.innerHTML="",this.container.__quill=this,this.root=this.addContainer("ql-editor"),this.root.classList.add("ql-blank"),this.root.setAttribute("data-gramm",!1),this.scrollingContainer=this.options.scrollingContainer||this.root,this.emitter=new s.default,this.scroll=c.default.create(this.root,{emitter:this.emitter,whitelist:this.options.formats}),this.editor=new a.default(this.scroll),this.selection=new h.default(this.scroll,this.emitter),this.theme=new this.options.theme(this,this.options),this.keyboard=this.theme.addModule("keyboard"),this.clipboard=this.theme.addModule("clipboard"),this.history=this.theme.addModule("history"),this.theme.init(),this.emitter.on(s.default.events.EDITOR_CHANGE,(function(t){t===s.default.events.TEXT_CHANGE&&n.root.classList.toggle("ql-blank",n.editor.isBlank())})),this.emitter.on(s.default.events.SCROLL_UPDATE,(function(t,e){var r=n.selection.lastRange,o=r&&0===r.length?r.index:void 0;w.call(n,(function(){return n.editor.update(null,e,o)}),t)}));var i=this.clipboard.convert("<div class='ql-editor' style=\"white-space: normal;\">"+o+"<p><br></p></div>");this.setContents(i),this.history.clear(),this.options.placeholder&&this.root.setAttribute("data-placeholder",this.options.placeholder),this.options.readOnly&&this.disable()}return i(t,null,[{key:"debug",value:function(t){!0===t&&(t="log"),d.default.level(t)}},{key:"find",value:function(t){return t.__quill||c.default.find(t)}},{key:"import",value:function(t){return null==this.imports[t]&&m.error("Cannot import "+t+". Are you sure it was registered?"),this.imports[t]}},{key:"register",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if("string"!=typeof t){var o=t.attrName||t.blotName;"string"==typeof o?this.register("formats/"+o,t,e):Object.keys(t).forEach((function(r){n.register(r,t[r],e)}))}else null==this.imports[t]||r||m.warn("Overwriting "+t+" with",e),this.imports[t]=e,(t.startsWith("blots/")||t.startsWith("formats/"))&&"abstract"!==e.blotName?c.default.register(e):t.startsWith("modules")&&"function"==typeof e.register&&e.register()}}]),i(t,[{key:"addContainer",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if("string"==typeof t){var n=t;(t=document.createElement("div")).classList.add(n)}return this.container.insertBefore(t,e),t}},{key:"blur",value:function(){this.selection.setRange(null)}},{key:"deleteText",value:function(t,e,n){var r=this,i=x(t,e,n),l=o(i,4);return t=l[0],e=l[1],n=l[3],w.call(this,(function(){return r.editor.deleteText(t,e)}),n,t,-1*e)}},{key:"disable",value:function(){this.enable(!1)}},{key:"enable",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.scroll.enable(t),this.container.classList.toggle("ql-disabled",!t)}},{key:"focus",value:function(){var t=this.scrollingContainer.scrollTop;this.selection.focus(),this.scrollingContainer.scrollTop=t,this.scrollIntoView()}},{key:"format",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:s.default.sources.API;return w.call(this,(function(){var r=n.getSelection(!0),o=new l.default;if(null==r)return o;if(c.default.query(t,c.default.Scope.BLOCK))o=n.editor.formatLine(r.index,r.length,b({},t,e));else{if(0===r.length)return n.selection.format(t,e),o;o=n.editor.formatText(r.index,r.length,b({},t,e))}return n.setSelection(r,s.default.sources.SILENT),o}),r)}},{key:"formatLine",value:function(t,e,n,r,i){var l,a=this,s=x(t,e,n,r,i),u=o(s,4);return t=u[0],e=u[1],l=u[2],i=u[3],w.call(this,(function(){return a.editor.formatLine(t,e,l)}),i,t,0)}},{key:"formatText",value:function(t,e,n,r,i){var l,a=this,s=x(t,e,n,r,i),u=o(s,4);return t=u[0],e=u[1],l=u[2],i=u[3],w.call(this,(function(){return a.editor.formatText(t,e,l)}),i,t,0)}},{key:"getBounds",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=void 0;n="number"==typeof t?this.selection.getBounds(t,e):this.selection.getBounds(t.index,t.length);var r=this.container.getBoundingClientRect();return{bottom:n.bottom-r.top,height:n.height,left:n.left-r.left,right:n.right-r.left,top:n.top-r.top,width:n.width}}},{key:"getContents",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getLength()-t,n=x(t,e),r=o(n,2);return t=r[0],e=r[1],this.editor.getContents(t,e)}},{key:"getFormat",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.getSelection(!0),e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return"number"==typeof t?this.editor.getFormat(t,e):this.editor.getFormat(t.index,t.length)}},{key:"getIndex",value:function(t){return t.offset(this.scroll)}},{key:"getLength",value:function(){return this.scroll.length()}},{key:"getLeaf",value:function(t){return this.scroll.leaf(t)}},{key:"getLine",value:function(t){return this.scroll.line(t)}},{key:"getLines",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE;return"number"!=typeof t?this.scroll.lines(t.index,t.length):this.scroll.lines(t,e)}},{key:"getModule",value:function(t){return this.theme.modules[t]}},{key:"getSelection",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return t&&this.focus(),this.update(),this.selection.getRange()[0]}},{key:"getText",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getLength()-t,n=x(t,e),r=o(n,2);return t=r[0],e=r[1],this.editor.getText(t,e)}},{key:"hasFocus",value:function(){return this.selection.hasFocus()}},{key:"insertEmbed",value:function(e,n,r){var o=this,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:t.sources.API;return w.call(this,(function(){return o.editor.insertEmbed(e,n,r)}),i,e)}},{key:"insertText",value:function(t,e,n,r,i){var l,a=this,s=x(t,0,n,r,i),u=o(s,4);return t=u[0],l=u[2],i=u[3],w.call(this,(function(){return a.editor.insertText(t,e,l)}),i,t,e.length)}},{key:"isEnabled",value:function(){return!this.container.classList.contains("ql-disabled")}},{key:"off",value:function(){return this.emitter.off.apply(this.emitter,arguments)}},{key:"on",value:function(){return this.emitter.on.apply(this.emitter,arguments)}},{key:"once",value:function(){return this.emitter.once.apply(this.emitter,arguments)}},{key:"pasteHTML",value:function(t,e,n){this.clipboard.dangerouslyPasteHTML(t,e,n)}},{key:"removeFormat",value:function(t,e,n){var r=this,i=x(t,e,n),l=o(i,4);return t=l[0],e=l[1],n=l[3],w.call(this,(function(){return r.editor.removeFormat(t,e)}),n,t)}},{key:"scrollIntoView",value:function(){this.selection.scrollIntoView(this.scrollingContainer)}},{key:"setContents",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:s.default.sources.API;return w.call(this,(function(){t=new l.default(t);var n=e.getLength(),r=e.editor.deleteText(0,n),o=e.editor.applyDelta(t),i=o.ops[o.ops.length-1];return null!=i&&"string"==typeof i.insert&&"\n"===i.insert[i.insert.length-1]&&(e.editor.deleteText(e.getLength()-1,1),o.delete(1)),r.compose(o)}),n)}},{key:"setSelection",value:function(e,n,r){if(null==e)this.selection.setRange(null,n||t.sources.API);else{var i=x(e,n,r),l=o(i,4);e=l[0],n=l[1],r=l[3],this.selection.setRange(new f.Range(e,n),r),r!==s.default.sources.SILENT&&this.selection.scrollIntoView(this.scrollingContainer)}}},{key:"setText",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:s.default.sources.API,n=(new l.default).insert(t);return this.setContents(n,e)}},{key:"update",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s.default.sources.USER,e=this.scroll.update(t);return this.selection.update(t),e}},{key:"updateContents",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:s.default.sources.API;return w.call(this,(function(){return t=new l.default(t),e.editor.applyDelta(t,n)}),n,!0)}}]),t}();function O(t,e){if((e=(0,p.default)(!0,{container:t,modules:{clipboard:!0,keyboard:!0,history:!0}},e)).theme&&e.theme!==_.DEFAULTS.theme){if(e.theme=_.import("themes/"+e.theme),null==e.theme)throw new Error("Invalid theme "+e.theme+". Did you register it?")}else e.theme=y.default;var n=(0,p.default)(!0,{},e.theme.DEFAULTS);[n,e].forEach((function(t){t.modules=t.modules||{},Object.keys(t.modules).forEach((function(e){!0===t.modules[e]&&(t.modules[e]={})}))}));var r=Object.keys(n.modules).concat(Object.keys(e.modules)).reduce((function(t,e){var n=_.import("modules/"+e);return null==n?m.error("Cannot load "+e+" module. Are you sure you registered it?"):t[e]=n.DEFAULTS||{},t}),{});return null!=e.modules&&e.modules.toolbar&&e.modules.toolbar.constructor!==Object&&(e.modules.toolbar={container:e.modules.toolbar}),e=(0,p.default)(!0,{},_.DEFAULTS,{modules:r},n,e),["bounds","container","scrollingContainer"].forEach((function(t){"string"==typeof e[t]&&(e[t]=document.querySelector(e[t]))})),e.modules=Object.keys(e.modules).reduce((function(t,n){return e.modules[n]&&(t[n]=e.modules[n]),t}),{}),e}function w(t,e,n,r){if(this.options.strict&&!this.isEnabled()&&e===s.default.sources.USER)return new l.default;var o=null==n?null:this.getSelection(),i=this.editor.delta,a=t();if(null!=o&&(!0===n&&(n=o.index),null==r?o=E(o,a,e):0!==r&&(o=E(o,n,r,e)),this.setSelection(o,s.default.sources.SILENT)),a.length()>0){var u,c,f=[s.default.events.TEXT_CHANGE,a,i,e];(u=this.emitter).emit.apply(u,[s.default.events.EDITOR_CHANGE].concat(f)),e!==s.default.sources.SILENT&&(c=this.emitter).emit.apply(c,f)}return a}function x(t,e,n,o,i){var l={};return"number"==typeof t.index&&"number"==typeof t.length?"number"!=typeof e?(i=o,o=n,n=e,e=t.length,t=t.index):(e=t.length,t=t.index):"number"!=typeof e&&(i=o,o=n,n=e,e=0),"object"===(void 0===n?"undefined":r(n))?(l=n,i=o):"string"==typeof n&&(null!=o?l[n]=o:i=n),[t,e,l,i=i||s.default.sources.API]}function E(t,e,n,r){if(null==t)return null;var i=void 0,a=void 0;if(e instanceof l.default){var u=[t.index,t.index+t.length].map((function(t){return e.transformPosition(t,r!==s.default.sources.USER)})),c=o(u,2);i=c[0],a=c[1]}else{var h=[t.index,t.index+t.length].map((function(t){return t<e||t===e&&r===s.default.sources.USER?t:n>=0?t+n:Math.max(e,t+n)})),p=o(h,2);i=p[0],a=p[1]}return new f.Range(i,a-i)}_.DEFAULTS={bounds:null,formats:null,modules:{},placeholder:"",readOnly:!1,scrollingContainer:null,strict:!0,theme:"default"},_.events=s.default.events,_.sources=s.default.sources,_.version="1.3.7",_.imports={delta:l.default,parchment:c.default,"core/module":u.default,"core/theme":y.default},e.expandConfig=O,e.overload=x,e.default=_},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=a(n(7)),l=a(n(0));function a(t){return t&&t.__esModule?t:{default:t}}function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var c=function(t){function e(){return s(this,e),u(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),r(e,[{key:"formatAt",value:function(t,n,r,i){if(e.compare(this.statics.blotName,r)<0&&l.default.query(r,l.default.Scope.BLOT)){var a=this.isolate(t,n);i&&a.wrap(r,i)}else o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,n,r,i)}},{key:"optimize",value:function(t){if(o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.parent instanceof e&&e.compare(this.statics.blotName,this.parent.statics.blotName)>0){var n=this.parent.isolate(this.offset(),this.length());this.moveChildren(n),n.wrap(this)}}}],[{key:"compare",value:function(t,n){var r=e.order.indexOf(t),o=e.order.indexOf(n);return r>=0||o>=0?r-o:t===n?0:t<n?-1:1}}]),e}(l.default.Inline);c.allowedChildren=[c,l.default.Embed,i.default],c.order=["cursor","inline","underline","strike","italic","bold","script","link","code"],e.default=c},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=n(0);function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var a=function(t){function e(){return i(this,e),l(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(((r=o)&&r.__esModule?r:{default:r}).default.Text);e.default=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=l(n(54));function l(t){return t&&t.__esModule?t:{default:t}}var a=(0,l(n(10)).default)("quill:events");["selectionchange","mousedown","mouseup","click"].forEach((function(t){document.addEventListener(t,(function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];[].slice.call(document.querySelectorAll(".ql-container")).forEach((function(t){var n;t.__quill&&t.__quill.emitter&&(n=t.__quill.emitter).handleDOM.apply(n,e)}))}))}));var s=function(t){function e(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var t=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return t.listeners={},t.on("error",a.error),t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),r(e,[{key:"emit",value:function(){a.log.apply(a,arguments),o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"emit",this).apply(this,arguments)}},{key:"handleDOM",value:function(t){for(var e=arguments.length,n=Array(e>1?e-1:0),r=1;r<e;r++)n[r-1]=arguments[r];(this.listeners[t.type]||[]).forEach((function(e){var r=e.node,o=e.handler;(t.target===r||r.contains(t.target))&&o.apply(void 0,[t].concat(n))}))}},{key:"listenDOM",value:function(t,e,n){this.listeners[t]||(this.listeners[t]=[]),this.listeners[t].push({node:e,handler:n})}}]),e}(i.default);s.events={EDITOR_CHANGE:"editor-change",SCROLL_BEFORE_UPDATE:"scroll-before-update",SCROLL_OPTIMIZE:"scroll-optimize",SCROLL_UPDATE:"scroll-update",SELECTION_CHANGE:"selection-change",TEXT_CHANGE:"text-change"},s.sources={API:"api",SILENT:"silent",USER:"user"},e.default=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};r(this,t),this.quill=e,this.options=n};o.DEFAULTS={},e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=["error","warn","log","info"],o="warn";function i(t){if(r.indexOf(t)<=r.indexOf(o)){for(var e,n=arguments.length,i=Array(n>1?n-1:0),l=1;l<n;l++)i[l-1]=arguments[l];(e=console)[t].apply(e,i)}}function l(t){return r.reduce((function(e,n){return e[n]=i.bind(console,n,t),e}),{})}i.level=l.level=function(t){o=t},e.default=l},function(t,e,n){var r=Array.prototype.slice,o=n(52),i=n(53),l=t.exports=function(t,e,n){return n||(n={}),t===e||(t instanceof Date&&e instanceof Date?t.getTime()===e.getTime():!t||!e||"object"!=typeof t&&"object"!=typeof e?n.strict?t===e:t==e:function(t,e,n){var u,c;if(a(t)||a(e))return!1;if(t.prototype!==e.prototype)return!1;if(i(t))return!!i(e)&&(t=r.call(t),e=r.call(e),l(t,e,n));if(s(t)){if(!s(e))return!1;if(t.length!==e.length)return!1;for(u=0;u<t.length;u++)if(t[u]!==e[u])return!1;return!0}try{var f=o(t),h=o(e)}catch(t){return!1}if(f.length!=h.length)return!1;for(f.sort(),h.sort(),u=f.length-1;u>=0;u--)if(f[u]!=h[u])return!1;for(u=f.length-1;u>=0;u--)if(c=f[u],!l(t[c],e[c],n))return!1;return typeof t==typeof e}(t,e,n))};function a(t){return null==t}function s(t){return!(!t||"object"!=typeof t||"number"!=typeof t.length||"function"!=typeof t.copy||"function"!=typeof t.slice||t.length>0&&"number"!=typeof t[0])}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(1),o=function(){function t(t,e,n){void 0===n&&(n={}),this.attrName=t,this.keyName=e;var o=r.Scope.TYPE&r.Scope.ATTRIBUTE;null!=n.scope?this.scope=n.scope&r.Scope.LEVEL|o:this.scope=r.Scope.ATTRIBUTE,null!=n.whitelist&&(this.whitelist=n.whitelist)}return t.keys=function(t){return[].map.call(t.attributes,(function(t){return t.name}))},t.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(t.setAttribute(this.keyName,e),!0)},t.prototype.canAdd=function(t,e){return null!=r.query(t,r.Scope.BLOT&(this.scope|r.Scope.TYPE))&&(null==this.whitelist||("string"==typeof e?this.whitelist.indexOf(e.replace(/["']/g,""))>-1:this.whitelist.indexOf(e)>-1))},t.prototype.remove=function(t){t.removeAttribute(this.keyName)},t.prototype.value=function(t){var e=t.getAttribute(this.keyName);return this.canAdd(t,e)&&e?e:""},t}();e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.Code=void 0;var r=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=f(n(2)),a=f(n(0)),s=f(n(4)),u=f(n(6)),c=f(n(7));function f(t){return t&&t.__esModule?t:{default:t}}function h(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function p(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function d(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var y=function(t){function e(){return h(this,e),p(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return d(e,t),e}(u.default);y.blotName="code",y.tagName="CODE";var v=function(t){function e(){return h(this,e),p(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return d(e,t),o(e,[{key:"delta",value:function(){var t=this,e=this.domNode.textContent;return e.endsWith("\n")&&(e=e.slice(0,-1)),e.split("\n").reduce((function(e,n){return e.insert(n).insert("\n",t.formats())}),new l.default)}},{key:"format",value:function(t,n){if(t!==this.statics.blotName||!n){var o=this.descendant(c.default,this.length()-1),l=r(o,1)[0];null!=l&&l.deleteAt(l.length()-1,1),i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}},{key:"formatAt",value:function(t,n,r,o){if(0!==n&&null!=a.default.query(r,a.default.Scope.BLOCK)&&(r!==this.statics.blotName||o!==this.statics.formats(this.domNode))){var i=this.newlineIndex(t);if(!(i<0||i>=t+n)){var l=this.newlineIndex(t,!0)+1,s=i-l+1,u=this.isolate(l,s),c=u.next;u.format(r,o),c instanceof e&&c.formatAt(0,t-l+n-s,r,o)}}}},{key:"insertAt",value:function(t,e,n){if(null==n){var o=this.descendant(c.default,t),i=r(o,2),l=i[0],a=i[1];l.insertAt(a,e)}}},{key:"length",value:function(){var t=this.domNode.textContent.length;return this.domNode.textContent.endsWith("\n")?t:t+1}},{key:"newlineIndex",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(e)return this.domNode.textContent.slice(0,t).lastIndexOf("\n");var n=this.domNode.textContent.slice(t).indexOf("\n");return n>-1?t+n:-1}},{key:"optimize",value:function(t){this.domNode.textContent.endsWith("\n")||this.appendChild(a.default.create("text","\n")),i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t);var n=this.next;null!=n&&n.prev===this&&n.statics.blotName===this.statics.blotName&&this.statics.formats(this.domNode)===n.statics.formats(n.domNode)&&(n.optimize(t),n.moveChildren(this),n.remove())}},{key:"replace",value:function(t){i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replace",this).call(this,t),[].slice.call(this.domNode.querySelectorAll("*")).forEach((function(t){var e=a.default.find(t);null==e?t.parentNode.removeChild(t):e instanceof a.default.Embed?e.remove():e.unwrap()}))}}],[{key:"create",value:function(t){var n=i(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return n.setAttribute("spellcheck",!1),n}},{key:"formats",value:function(){return!0}}]),e}(s.default);v.blotName="code-block",v.tagName="PRE",v.TAB="  ",e.Code=y,e.default=v},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),l=b(n(2)),a=b(n(20)),s=b(n(0)),u=b(n(13)),c=b(n(24)),f=n(4),h=b(f),p=b(n(16)),d=b(n(21)),y=b(n(11)),v=b(n(3));function b(t){return t&&t.__esModule?t:{default:t}}var g=/^[ -~]*$/,m=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.scroll=e,this.delta=this.getDelta()}return i(t,[{key:"applyDelta",value:function(t){var e=this,n=!1;this.scroll.update();var i=this.scroll.length();return this.scroll.batchStart(),(t=function(t){return t.reduce((function(t,e){if(1===e.insert){var n=(0,d.default)(e.attributes);return delete n.image,t.insert({image:e.attributes.image},n)}if(null==e.attributes||!0!==e.attributes.list&&!0!==e.attributes.bullet||((e=(0,d.default)(e)).attributes.list?e.attributes.list="ordered":(e.attributes.list="bullet",delete e.attributes.bullet)),"string"==typeof e.insert){var r=e.insert.replace(/\r\n/g,"\n").replace(/\r/g,"\n");return t.insert(r,e.attributes)}return t.push(e)}),new l.default)}(t)).reduce((function(t,l){var u=l.retain||l.delete||l.insert.length||1,c=l.attributes||{};if(null!=l.insert){if("string"==typeof l.insert){var p=l.insert;p.endsWith("\n")&&n&&(n=!1,p=p.slice(0,-1)),t>=i&&!p.endsWith("\n")&&(n=!0),e.scroll.insertAt(t,p);var d=e.scroll.line(t),y=o(d,2),b=y[0],g=y[1],m=(0,v.default)({},(0,f.bubbleFormats)(b));if(b instanceof h.default){var _=b.descendant(s.default.Leaf,g),O=o(_,1)[0];m=(0,v.default)(m,(0,f.bubbleFormats)(O))}c=a.default.attributes.diff(m,c)||{}}else if("object"===r(l.insert)){var w=Object.keys(l.insert)[0];if(null==w)return t;e.scroll.insertAt(t,w,l.insert[w])}i+=u}return Object.keys(c).forEach((function(n){e.scroll.formatAt(t,u,n,c[n])})),t+u}),0),t.reduce((function(t,n){return"number"==typeof n.delete?(e.scroll.deleteAt(t,n.delete),t):t+(n.retain||n.insert.length||1)}),0),this.scroll.batchEnd(),this.update(t)}},{key:"deleteText",value:function(t,e){return this.scroll.deleteAt(t,e),this.update((new l.default).retain(t).delete(e))}},{key:"formatLine",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this.scroll.update(),Object.keys(r).forEach((function(o){if(null==n.scroll.whitelist||n.scroll.whitelist[o]){var i=n.scroll.lines(t,Math.max(e,1)),l=e;i.forEach((function(e){var i=e.length();if(e instanceof u.default){var a=t-e.offset(n.scroll),s=e.newlineIndex(a+l)-a+1;e.formatAt(a,s,o,r[o])}else e.format(o,r[o]);l-=i}))}})),this.scroll.optimize(),this.update((new l.default).retain(t).retain(e,(0,d.default)(r)))}},{key:"formatText",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return Object.keys(r).forEach((function(o){n.scroll.formatAt(t,e,o,r[o])})),this.update((new l.default).retain(t).retain(e,(0,d.default)(r)))}},{key:"getContents",value:function(t,e){return this.delta.slice(t,t+e)}},{key:"getDelta",value:function(){return this.scroll.lines().reduce((function(t,e){return t.concat(e.delta())}),new l.default)}},{key:"getFormat",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=[],r=[];0===e?this.scroll.path(t).forEach((function(t){var e=o(t,1)[0];e instanceof h.default?n.push(e):e instanceof s.default.Leaf&&r.push(e)})):(n=this.scroll.lines(t,e),r=this.scroll.descendants(s.default.Leaf,t,e));var i=[n,r].map((function(t){if(0===t.length)return{};for(var e=(0,f.bubbleFormats)(t.shift());Object.keys(e).length>0;){var n=t.shift();if(null==n)return e;e=_((0,f.bubbleFormats)(n),e)}return e}));return v.default.apply(v.default,i)}},{key:"getText",value:function(t,e){return this.getContents(t,e).filter((function(t){return"string"==typeof t.insert})).map((function(t){return t.insert})).join("")}},{key:"insertEmbed",value:function(t,e,n){return this.scroll.insertAt(t,e,n),this.update((new l.default).retain(t).insert(function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}({},e,n)))}},{key:"insertText",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return e=e.replace(/\r\n/g,"\n").replace(/\r/g,"\n"),this.scroll.insertAt(t,e),Object.keys(r).forEach((function(o){n.scroll.formatAt(t,e.length,o,r[o])})),this.update((new l.default).retain(t).insert(e,(0,d.default)(r)))}},{key:"isBlank",value:function(){if(0==this.scroll.children.length)return!0;if(this.scroll.children.length>1)return!1;var t=this.scroll.children.head;return t.statics.blotName===h.default.blotName&&!(t.children.length>1)&&t.children.head instanceof p.default}},{key:"removeFormat",value:function(t,e){var n=this.getText(t,e),r=this.scroll.line(t+e),i=o(r,2),a=i[0],s=i[1],c=0,f=new l.default;null!=a&&(c=a instanceof u.default?a.newlineIndex(s)-s+1:a.length()-s,f=a.delta().slice(s,s+c-1).insert("\n"));var h=this.getContents(t,e+c).diff((new l.default).insert(n).concat(f)),p=(new l.default).retain(t).concat(h);return this.applyDelta(p)}},{key:"update",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,r=this.delta;if(1===e.length&&"characterData"===e[0].type&&e[0].target.data.match(g)&&s.default.find(e[0].target)){var o=s.default.find(e[0].target),i=(0,f.bubbleFormats)(o),a=o.offset(this.scroll),u=e[0].oldValue.replace(c.default.CONTENTS,""),h=(new l.default).insert(u),p=(new l.default).insert(o.value()),d=(new l.default).retain(a).concat(h.diff(p,n));t=d.reduce((function(t,e){return e.insert?t.insert(e.insert,i):t.push(e)}),new l.default),this.delta=r.compose(t)}else this.delta=this.getDelta(),t&&(0,y.default)(r.compose(t),this.delta)||(t=r.diff(this.delta,n));return t}}]),t}();function _(t,e){return Object.keys(e).reduce((function(n,r){return null==t[r]||(e[r]===t[r]?n[r]=e[r]:Array.isArray(e[r])?e[r].indexOf(t[r])<0&&(n[r]=e[r].concat([t[r]])):n[r]=[e[r],t[r]]),n}),{})}e.default=m},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.Range=void 0;var r=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=u(n(0)),l=u(n(21)),a=u(n(11)),s=u(n(8));function u(t){return t&&t.__esModule?t:{default:t}}function c(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function f(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var h=(0,u(n(10)).default)("quill:selection"),p=function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;f(this,t),this.index=e,this.length=n},d=function(){function t(e,n){var r=this;f(this,t),this.emitter=n,this.scroll=e,this.composing=!1,this.mouseDown=!1,this.root=this.scroll.domNode,this.cursor=i.default.create("cursor",this),this.lastRange=this.savedRange=new p(0,0),this.handleComposition(),this.handleDragging(),this.emitter.listenDOM("selectionchange",document,(function(){r.mouseDown||setTimeout(r.update.bind(r,s.default.sources.USER),1)})),this.emitter.on(s.default.events.EDITOR_CHANGE,(function(t,e){t===s.default.events.TEXT_CHANGE&&e.length()>0&&r.update(s.default.sources.SILENT)})),this.emitter.on(s.default.events.SCROLL_BEFORE_UPDATE,(function(){if(r.hasFocus()){var t=r.getNativeRange();null!=t&&t.start.node!==r.cursor.textNode&&r.emitter.once(s.default.events.SCROLL_UPDATE,(function(){try{r.setNativeRange(t.start.node,t.start.offset,t.end.node,t.end.offset)}catch(t){}}))}})),this.emitter.on(s.default.events.SCROLL_OPTIMIZE,(function(t,e){if(e.range){var n=e.range,o=n.startNode,i=n.startOffset,l=n.endNode,a=n.endOffset;r.setNativeRange(o,i,l,a)}})),this.update(s.default.sources.SILENT)}return o(t,[{key:"handleComposition",value:function(){var t=this;this.root.addEventListener("compositionstart",(function(){t.composing=!0})),this.root.addEventListener("compositionend",(function(){if(t.composing=!1,t.cursor.parent){var e=t.cursor.restore();if(!e)return;setTimeout((function(){t.setNativeRange(e.startNode,e.startOffset,e.endNode,e.endOffset)}),1)}}))}},{key:"handleDragging",value:function(){var t=this;this.emitter.listenDOM("mousedown",document.body,(function(){t.mouseDown=!0})),this.emitter.listenDOM("mouseup",document.body,(function(){t.mouseDown=!1,t.update(s.default.sources.USER)}))}},{key:"focus",value:function(){this.hasFocus()||(this.root.focus(),this.setRange(this.savedRange))}},{key:"format",value:function(t,e){if(null==this.scroll.whitelist||this.scroll.whitelist[t]){this.scroll.update();var n=this.getNativeRange();if(null!=n&&n.native.collapsed&&!i.default.query(t,i.default.Scope.BLOCK)){if(n.start.node!==this.cursor.textNode){var r=i.default.find(n.start.node,!1);if(null==r)return;if(r instanceof i.default.Leaf){var o=r.split(n.start.offset);r.parent.insertBefore(this.cursor,o)}else r.insertBefore(this.cursor,n.start.node);this.cursor.attach()}this.cursor.format(t,e),this.scroll.optimize(),this.setNativeRange(this.cursor.textNode,this.cursor.textNode.data.length),this.update()}}}},{key:"getBounds",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=this.scroll.length();t=Math.min(t,n-1),e=Math.min(t+e,n-1)-t;var o=void 0,i=this.scroll.leaf(t),l=r(i,2),a=l[0],s=l[1];if(null==a)return null;var u=a.position(s,!0),c=r(u,2);o=c[0],s=c[1];var f=document.createRange();if(e>0){f.setStart(o,s);var h=this.scroll.leaf(t+e),p=r(h,2);if(a=p[0],s=p[1],null==a)return null;var d=a.position(s,!0),y=r(d,2);return o=y[0],s=y[1],f.setEnd(o,s),f.getBoundingClientRect()}var v="left",b=void 0;return o instanceof Text?(s<o.data.length?(f.setStart(o,s),f.setEnd(o,s+1)):(f.setStart(o,s-1),f.setEnd(o,s),v="right"),b=f.getBoundingClientRect()):(b=a.domNode.getBoundingClientRect(),s>0&&(v="right")),{bottom:b.top+b.height,height:b.height,left:b[v],right:b[v],top:b.top,width:0}}},{key:"getNativeRange",value:function(){var t=document.getSelection();if(null==t||t.rangeCount<=0)return null;var e=t.getRangeAt(0);if(null==e)return null;var n=this.normalizeNative(e);return h.info("getNativeRange",n),n}},{key:"getRange",value:function(){var t=this.getNativeRange();return null==t?[null,null]:[this.normalizedToRange(t),t]}},{key:"hasFocus",value:function(){return document.activeElement===this.root}},{key:"normalizedToRange",value:function(t){var e=this,n=[[t.start.node,t.start.offset]];t.native.collapsed||n.push([t.end.node,t.end.offset]);var o=n.map((function(t){var n=r(t,2),o=n[0],l=n[1],a=i.default.find(o,!0),s=a.offset(e.scroll);return 0===l?s:a instanceof i.default.Container?s+a.length():s+a.index(o,l)})),l=Math.min(Math.max.apply(Math,c(o)),this.scroll.length()-1),a=Math.min.apply(Math,[l].concat(c(o)));return new p(a,l-a)}},{key:"normalizeNative",value:function(t){if(!y(this.root,t.startContainer)||!t.collapsed&&!y(this.root,t.endContainer))return null;var e={start:{node:t.startContainer,offset:t.startOffset},end:{node:t.endContainer,offset:t.endOffset},native:t};return[e.start,e.end].forEach((function(t){for(var e=t.node,n=t.offset;!(e instanceof Text)&&e.childNodes.length>0;)if(e.childNodes.length>n)e=e.childNodes[n],n=0;else{if(e.childNodes.length!==n)break;n=(e=e.lastChild)instanceof Text?e.data.length:e.childNodes.length+1}t.node=e,t.offset=n})),e}},{key:"rangeToNative",value:function(t){var e=this,n=t.collapsed?[t.index]:[t.index,t.index+t.length],o=[],i=this.scroll.length();return n.forEach((function(t,n){t=Math.min(i-1,t);var l,a=e.scroll.leaf(t),s=r(a,2),u=s[0],c=s[1],f=u.position(c,0!==n),h=r(f,2);l=h[0],c=h[1],o.push(l,c)})),o.length<2&&(o=o.concat(o)),o}},{key:"scrollIntoView",value:function(t){var e=this.lastRange;if(null!=e){var n=this.getBounds(e.index,e.length);if(null!=n){var o=this.scroll.length()-1,i=this.scroll.line(Math.min(e.index,o)),l=r(i,1)[0],a=l;if(e.length>0){var s=this.scroll.line(Math.min(e.index+e.length,o));a=r(s,1)[0]}if(null!=l&&null!=a){var u=t.getBoundingClientRect();n.top<u.top?t.scrollTop-=u.top-n.top:n.bottom>u.bottom&&(t.scrollTop+=n.bottom-u.bottom)}}}}},{key:"setNativeRange",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:t,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:e,o=arguments.length>4&&void 0!==arguments[4]&&arguments[4];if(h.info("setNativeRange",t,e,n,r),null==t||null!=this.root.parentNode&&null!=t.parentNode&&null!=n.parentNode){var i=document.getSelection();if(null!=i)if(null!=t){this.hasFocus()||this.root.focus();var l=(this.getNativeRange()||{}).native;if(null==l||o||t!==l.startContainer||e!==l.startOffset||n!==l.endContainer||r!==l.endOffset){"BR"==t.tagName&&(e=[].indexOf.call(t.parentNode.childNodes,t),t=t.parentNode),"BR"==n.tagName&&(r=[].indexOf.call(n.parentNode.childNodes,n),n=n.parentNode);var a=document.createRange();a.setStart(t,e),a.setEnd(n,r),i.removeAllRanges(),i.addRange(a)}}else i.removeAllRanges(),this.root.blur(),document.body.focus()}}},{key:"setRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:s.default.sources.API;if("string"==typeof e&&(n=e,e=!1),h.info("setRange",t),null!=t){var r=this.rangeToNative(t);this.setNativeRange.apply(this,c(r).concat([e]))}else this.setNativeRange(null);this.update(n)}},{key:"update",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s.default.sources.USER,e=this.lastRange,n=this.getRange(),o=r(n,2),i=o[0],u=o[1];if(this.lastRange=i,null!=this.lastRange&&(this.savedRange=this.lastRange),!(0,a.default)(e,this.lastRange)){var c;!this.composing&&null!=u&&u.native.collapsed&&u.start.node!==this.cursor.textNode&&this.cursor.restore();var f,h=[s.default.events.SELECTION_CHANGE,(0,l.default)(this.lastRange),(0,l.default)(e),t];(c=this.emitter).emit.apply(c,[s.default.events.EDITOR_CHANGE].concat(h)),t!==s.default.sources.SILENT&&(f=this.emitter).emit.apply(f,h)}}}]),t}();function y(t,e){try{e.parentNode}catch(t){return!1}return e instanceof Text&&(e=e.parentNode),t.contains(e)}e.Range=p,e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=n(0);function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var s=function(t){function e(){return l(this,e),a(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"insertInto",value:function(t,n){0===t.children.length?function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0}(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertInto",this).call(this,t,n):this.remove()}},{key:"length",value:function(){return 0}},{key:"value",value:function(){return""}}],[{key:"value",value:function(){}}]),e}(((r=i)&&r.__esModule?r:{default:r}).default.Embed);s.blotName="break",s.tagName="BR",e.default=s},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(44),l=n(30),a=n(1),s=function(t){function e(e){var n=t.call(this,e)||this;return n.build(),n}return o(e,t),e.prototype.appendChild=function(t){this.insertBefore(t)},e.prototype.attach=function(){t.prototype.attach.call(this),this.children.forEach((function(t){t.attach()}))},e.prototype.build=function(){var t=this;this.children=new i.default,[].slice.call(this.domNode.childNodes).reverse().forEach((function(e){try{var n=u(e);t.insertBefore(n,t.children.head||void 0)}catch(t){if(t instanceof a.ParchmentError)return;throw t}}))},e.prototype.deleteAt=function(t,e){if(0===t&&e===this.length())return this.remove();this.children.forEachAt(t,e,(function(t,e,n){t.deleteAt(e,n)}))},e.prototype.descendant=function(t,n){var r=this.children.find(n),o=r[0],i=r[1];return null==t.blotName&&t(o)||null!=t.blotName&&o instanceof t?[o,i]:o instanceof e?o.descendant(t,i):[null,-1]},e.prototype.descendants=function(t,n,r){void 0===n&&(n=0),void 0===r&&(r=Number.MAX_VALUE);var o=[],i=r;return this.children.forEachAt(n,r,(function(n,r,l){(null==t.blotName&&t(n)||null!=t.blotName&&n instanceof t)&&o.push(n),n instanceof e&&(o=o.concat(n.descendants(t,r,i))),i-=l})),o},e.prototype.detach=function(){this.children.forEach((function(t){t.detach()})),t.prototype.detach.call(this)},e.prototype.formatAt=function(t,e,n,r){this.children.forEachAt(t,e,(function(t,e,o){t.formatAt(e,o,n,r)}))},e.prototype.insertAt=function(t,e,n){var r=this.children.find(t),o=r[0],i=r[1];if(o)o.insertAt(i,e,n);else{var l=null==n?a.create("text",e):a.create(e,n);this.appendChild(l)}},e.prototype.insertBefore=function(t,e){if(null!=this.statics.allowedChildren&&!this.statics.allowedChildren.some((function(e){return t instanceof e})))throw new a.ParchmentError("Cannot insert "+t.statics.blotName+" into "+this.statics.blotName);t.insertInto(this,e)},e.prototype.length=function(){return this.children.reduce((function(t,e){return t+e.length()}),0)},e.prototype.moveChildren=function(t,e){this.children.forEach((function(n){t.insertBefore(n,e)}))},e.prototype.optimize=function(e){if(t.prototype.optimize.call(this,e),0===this.children.length)if(null!=this.statics.defaultChild){var n=a.create(this.statics.defaultChild);this.appendChild(n),n.optimize(e)}else this.remove()},e.prototype.path=function(t,n){void 0===n&&(n=!1);var r=this.children.find(t,n),o=r[0],i=r[1],l=[[this,t]];return o instanceof e?l.concat(o.path(i,n)):(null!=o&&l.push([o,i]),l)},e.prototype.removeChild=function(t){this.children.remove(t)},e.prototype.replace=function(n){n instanceof e&&n.moveChildren(this),t.prototype.replace.call(this,n)},e.prototype.split=function(t,e){if(void 0===e&&(e=!1),!e){if(0===t)return this;if(t===this.length())return this.next}var n=this.clone();return this.parent.insertBefore(n,this.next),this.children.forEachAt(t,this.length(),(function(t,r,o){t=t.split(r,e),n.appendChild(t)})),n},e.prototype.unwrap=function(){this.moveChildren(this.parent,this.next),this.remove()},e.prototype.update=function(t,e){var n=this,r=[],o=[];t.forEach((function(t){t.target===n.domNode&&"childList"===t.type&&(r.push.apply(r,t.addedNodes),o.push.apply(o,t.removedNodes))})),o.forEach((function(t){if(!(null!=t.parentNode&&"IFRAME"!==t.tagName&&document.body.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_CONTAINED_BY)){var e=a.find(t);null!=e&&(null!=e.domNode.parentNode&&e.domNode.parentNode!==n.domNode||e.detach())}})),r.filter((function(t){return t.parentNode==n.domNode})).sort((function(t,e){return t===e?0:t.compareDocumentPosition(e)&Node.DOCUMENT_POSITION_FOLLOWING?1:-1})).forEach((function(t){var e=null;null!=t.nextSibling&&(e=a.find(t.nextSibling));var r=u(t);r.next==e&&null!=r.next||(null!=r.parent&&r.parent.removeChild(n),n.insertBefore(r,e||void 0))}))},e}(l.default);function u(t){var e=a.find(t);if(null==e)try{e=a.create(t)}catch(n){e=a.create(a.Scope.INLINE),[].slice.call(t.childNodes).forEach((function(t){e.domNode.appendChild(t)})),t.parentNode&&t.parentNode.replaceChild(e.domNode,t),e.attach()}return e}e.default=s},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(12),l=n(31),a=n(17),s=n(1),u=function(t){function e(e){var n=t.call(this,e)||this;return n.attributes=new l.default(n.domNode),n}return o(e,t),e.formats=function(t){return"string"==typeof this.tagName||(Array.isArray(this.tagName)?t.tagName.toLowerCase():void 0)},e.prototype.format=function(t,e){var n=s.query(t);n instanceof i.default?this.attributes.attribute(n,e):e&&(null==n||t===this.statics.blotName&&this.formats()[t]===e||this.replaceWith(t,e))},e.prototype.formats=function(){var t=this.attributes.values(),e=this.statics.formats(this.domNode);return null!=e&&(t[this.statics.blotName]=e),t},e.prototype.replaceWith=function(e,n){var r=t.prototype.replaceWith.call(this,e,n);return this.attributes.copy(r),r},e.prototype.update=function(e,n){var r=this;t.prototype.update.call(this,e,n),e.some((function(t){return t.target===r.domNode&&"attributes"===t.type}))&&this.attributes.build()},e.prototype.wrap=function(n,r){var o=t.prototype.wrap.call(this,n,r);return o instanceof e&&o.statics.scope===this.statics.scope&&this.attributes.move(o),o},e}(a.default);e.default=u},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(30),l=n(1),a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.value=function(t){return!0},e.prototype.index=function(t,e){return this.domNode===t||this.domNode.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_CONTAINED_BY?Math.min(e,1):-1},e.prototype.position=function(t,e){var n=[].indexOf.call(this.parent.domNode.childNodes,this.domNode);return t>0&&(n+=1),[this.parent.domNode,n]},e.prototype.value=function(){var t;return(t={})[this.statics.blotName]=this.statics.value(this.domNode)||!0,t},e.scope=l.Scope.INLINE_BLOT,e}(i.default);e.default=a},function(t,e,n){var r=n(11),o=n(3),i={attributes:{compose:function(t,e,n){"object"!=typeof t&&(t={}),"object"!=typeof e&&(e={});var r=o(!0,{},e);for(var i in n||(r=Object.keys(r).reduce((function(t,e){return null!=r[e]&&(t[e]=r[e]),t}),{})),t)void 0!==t[i]&&void 0===e[i]&&(r[i]=t[i]);return Object.keys(r).length>0?r:void 0},diff:function(t,e){"object"!=typeof t&&(t={}),"object"!=typeof e&&(e={});var n=Object.keys(t).concat(Object.keys(e)).reduce((function(n,o){return r(t[o],e[o])||(n[o]=void 0===e[o]?null:e[o]),n}),{});return Object.keys(n).length>0?n:void 0},transform:function(t,e,n){if("object"!=typeof t)return e;if("object"==typeof e){if(!n)return e;var r=Object.keys(e).reduce((function(n,r){return void 0===t[r]&&(n[r]=e[r]),n}),{});return Object.keys(r).length>0?r:void 0}}},iterator:function(t){return new l(t)},length:function(t){return"number"==typeof t.delete?t.delete:"number"==typeof t.retain?t.retain:"string"==typeof t.insert?t.insert.length:1}};function l(t){this.ops=t,this.index=0,this.offset=0}l.prototype.hasNext=function(){return this.peekLength()<1/0},l.prototype.next=function(t){t||(t=1/0);var e=this.ops[this.index];if(e){var n=this.offset,r=i.length(e);if(t>=r-n?(t=r-n,this.index+=1,this.offset=0):this.offset+=t,"number"==typeof e.delete)return{delete:t};var o={};return e.attributes&&(o.attributes=e.attributes),"number"==typeof e.retain?o.retain=t:"string"==typeof e.insert?o.insert=e.insert.substr(n,t):o.insert=e.insert,o}return{retain:1/0}},l.prototype.peek=function(){return this.ops[this.index]},l.prototype.peekLength=function(){return this.ops[this.index]?i.length(this.ops[this.index])-this.offset:1/0},l.prototype.peekType=function(){return this.ops[this.index]?"number"==typeof this.ops[this.index].delete?"delete":"number"==typeof this.ops[this.index].retain?"retain":"insert":"retain"},l.prototype.rest=function(){if(this.hasNext()){if(0===this.offset)return this.ops.slice(this.index);var t=this.offset,e=this.index,n=this.next(),r=this.ops.slice(this.index);return this.offset=t,this.index=e,[n].concat(r)}return[]},t.exports=i},function(t,n){var r=function(){"use strict";function t(t,e){return null!=e&&t instanceof e}var n,r,o;try{n=Map}catch(t){n=function(){}}try{r=Set}catch(t){r=function(){}}try{o=Promise}catch(t){o=function(){}}function i(l,s,u,c,f){"object"==typeof s&&(u=s.depth,c=s.prototype,f=s.includeNonEnumerable,s=s.circular);var h=[],p=[],d=void 0!==e;return void 0===s&&(s=!0),void 0===u&&(u=1/0),function l(u,y){if(null===u)return null;if(0===y)return u;var v,b;if("object"!=typeof u)return u;if(t(u,n))v=new n;else if(t(u,r))v=new r;else if(t(u,o))v=new o((function(t,e){u.then((function(e){t(l(e,y-1))}),(function(t){e(l(t,y-1))}))}));else if(i.__isArray(u))v=[];else if(i.__isRegExp(u))v=new RegExp(u.source,a(u)),u.lastIndex&&(v.lastIndex=u.lastIndex);else if(i.__isDate(u))v=new Date(u.getTime());else{if(d&&e.isBuffer(u))return v=e.allocUnsafe?e.allocUnsafe(u.length):new e(u.length),u.copy(v),v;t(u,Error)?v=Object.create(u):void 0===c?(b=Object.getPrototypeOf(u),v=Object.create(b)):(v=Object.create(c),b=c)}if(s){var g=h.indexOf(u);if(-1!=g)return p[g];h.push(u),p.push(v)}for(var m in t(u,n)&&u.forEach((function(t,e){var n=l(e,y-1),r=l(t,y-1);v.set(n,r)})),t(u,r)&&u.forEach((function(t){var e=l(t,y-1);v.add(e)})),u){var _;b&&(_=Object.getOwnPropertyDescriptor(b,m)),_&&null==_.set||(v[m]=l(u[m],y-1))}if(Object.getOwnPropertySymbols){var O=Object.getOwnPropertySymbols(u);for(m=0;m<O.length;m++){var w=O[m];(!(E=Object.getOwnPropertyDescriptor(u,w))||E.enumerable||f)&&(v[w]=l(u[w],y-1),E.enumerable||Object.defineProperty(v,w,{enumerable:!1}))}}if(f){var x=Object.getOwnPropertyNames(u);for(m=0;m<x.length;m++){var E,k=x[m];(E=Object.getOwnPropertyDescriptor(u,k))&&E.enumerable||(v[k]=l(u[k],y-1),Object.defineProperty(v,k,{enumerable:!1}))}}return v}(l,u)}function l(t){return Object.prototype.toString.call(t)}function a(t){var e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),e}return i.clonePrototype=function(t){if(null===t)return null;var e=function(){};return e.prototype=t,new e},i.__objToStr=l,i.__isDate=function(t){return"object"==typeof t&&"[object Date]"===l(t)},i.__isArray=function(t){return"object"==typeof t&&"[object Array]"===l(t)},i.__isRegExp=function(t){return"object"==typeof t&&"[object RegExp]"===l(t)},i.__getRegExpFlags=a,i}();"object"==typeof t&&t.exports&&(t.exports=r)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=p(n(0)),a=p(n(8)),s=n(4),u=p(s),c=p(n(16)),f=p(n(13)),h=p(n(25));function p(t){return t&&t.__esModule?t:{default:t}}function d(t){return t instanceof u.default||t instanceof s.BlockEmbed}var y=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.emitter=n.emitter,Array.isArray(n.whitelist)&&(r.whitelist=n.whitelist.reduce((function(t,e){return t[e]=!0,t}),{})),r.domNode.addEventListener("DOMNodeInserted",(function(){})),r.optimize(),r.enable(),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"batchStart",value:function(){this.batch=!0}},{key:"batchEnd",value:function(){this.batch=!1,this.optimize()}},{key:"deleteAt",value:function(t,n){var o=this.line(t),l=r(o,2),a=l[0],u=l[1],h=this.line(t+n),p=r(h,1)[0];if(i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"deleteAt",this).call(this,t,n),null!=p&&a!==p&&u>0){if(a instanceof s.BlockEmbed||p instanceof s.BlockEmbed)return void this.optimize();if(a instanceof f.default){var d=a.newlineIndex(a.length(),!0);if(d>-1&&(a=a.split(d+1))===p)return void this.optimize()}else if(p instanceof f.default){var y=p.newlineIndex(0);y>-1&&p.split(y+1)}var v=p.children.head instanceof c.default?null:p.children.head;a.moveChildren(p,v),a.remove()}this.optimize()}},{key:"enable",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.domNode.setAttribute("contenteditable",t)}},{key:"formatAt",value:function(t,n,r,o){(null==this.whitelist||this.whitelist[r])&&(i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,n,r,o),this.optimize())}},{key:"insertAt",value:function(t,n,r){if(null==r||null==this.whitelist||this.whitelist[n]){if(t>=this.length())if(null==r||null==l.default.query(n,l.default.Scope.BLOCK)){var o=l.default.create(this.statics.defaultChild);this.appendChild(o),null==r&&n.endsWith("\n")&&(n=n.slice(0,-1)),o.insertAt(0,n,r)}else{var a=l.default.create(n,r);this.appendChild(a)}else i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r);this.optimize()}}},{key:"insertBefore",value:function(t,n){if(t.statics.scope===l.default.Scope.INLINE_BLOT){var r=l.default.create(this.statics.defaultChild);r.appendChild(t),t=r}i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n)}},{key:"leaf",value:function(t){return this.path(t).pop()||[null,-1]}},{key:"line",value:function(t){return t===this.length()?this.line(t-1):this.descendant(d,t)}},{key:"lines",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE,n=function t(e,n,r){var o=[],i=r;return e.children.forEachAt(n,r,(function(e,n,r){d(e)?o.push(e):e instanceof l.default.Container&&(o=o.concat(t(e,n,i))),i-=r})),o};return n(this,t,e)}},{key:"optimize",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};!0!==this.batch&&(i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t,n),t.length>0&&this.emitter.emit(a.default.events.SCROLL_OPTIMIZE,t,n))}},{key:"path",value:function(t){return i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"path",this).call(this,t).slice(1)}},{key:"update",value:function(t){if(!0!==this.batch){var n=a.default.sources.USER;"string"==typeof t&&(n=t),Array.isArray(t)||(t=this.observer.takeRecords()),t.length>0&&this.emitter.emit(a.default.events.SCROLL_BEFORE_UPDATE,n,t),i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"update",this).call(this,t.concat([])),t.length>0&&this.emitter.emit(a.default.events.SCROLL_UPDATE,n,t)}}}]),e}(l.default.Scroll);y.blotName="scroll",y.className="ql-editor",y.tagName="DIV",y.defaultChild="block",y.allowedChildren=[u.default,s.BlockEmbed,h.default],e.default=y},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SHORTKEY=e.default=void 0;var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),l=y(n(21)),a=y(n(11)),s=y(n(3)),u=y(n(2)),c=y(n(20)),f=y(n(0)),h=y(n(5)),p=y(n(10)),d=y(n(9));function y(t){return t&&t.__esModule?t:{default:t}}function v(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var b=(0,p.default)("quill:keyboard"),g=/Mac/i.test(navigator.platform)?"metaKey":"ctrlKey",m=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.bindings={},Object.keys(r.options.bindings).forEach((function(e){("list autofill"!==e||null==t.scroll.whitelist||t.scroll.whitelist.list)&&r.options.bindings[e]&&r.addBinding(r.options.bindings[e])})),r.addBinding({key:e.keys.ENTER,shiftKey:null},E),r.addBinding({key:e.keys.ENTER,metaKey:null,ctrlKey:null,altKey:null},(function(){})),/Firefox/i.test(navigator.userAgent)?(r.addBinding({key:e.keys.BACKSPACE},{collapsed:!0},O),r.addBinding({key:e.keys.DELETE},{collapsed:!0},w)):(r.addBinding({key:e.keys.BACKSPACE},{collapsed:!0,prefix:/^.?$/},O),r.addBinding({key:e.keys.DELETE},{collapsed:!0,suffix:/^.?$/},w)),r.addBinding({key:e.keys.BACKSPACE},{collapsed:!1},x),r.addBinding({key:e.keys.DELETE},{collapsed:!1},x),r.addBinding({key:e.keys.BACKSPACE,altKey:null,ctrlKey:null,metaKey:null,shiftKey:null},{collapsed:!0,offset:0},O),r.listen(),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),i(e,null,[{key:"match",value:function(t,e){return e=N(e),!["altKey","ctrlKey","metaKey","shiftKey"].some((function(n){return!!e[n]!==t[n]&&null!==e[n]}))&&e.key===(t.which||t.keyCode)}}]),i(e,[{key:"addBinding",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=N(t);if(null==r||null==r.key)return b.warn("Attempted to add invalid keyboard binding",r);"function"==typeof e&&(e={handler:e}),"function"==typeof n&&(n={handler:n}),r=(0,s.default)(r,e,n),this.bindings[r.key]=this.bindings[r.key]||[],this.bindings[r.key].push(r)}},{key:"listen",value:function(){var t=this;this.quill.root.addEventListener("keydown",(function(n){if(!n.defaultPrevented){var i=n.which||n.keyCode,l=(t.bindings[i]||[]).filter((function(t){return e.match(n,t)}));if(0!==l.length){var s=t.quill.getSelection();if(null!=s&&t.quill.hasFocus()){var u=t.quill.getLine(s.index),c=o(u,2),h=c[0],p=c[1],d=t.quill.getLeaf(s.index),y=o(d,2),v=y[0],b=y[1],g=0===s.length?[v,b]:t.quill.getLeaf(s.index+s.length),m=o(g,2),_=m[0],O=m[1],w=v instanceof f.default.Text?v.value().slice(0,b):"",x=_ instanceof f.default.Text?_.value().slice(O):"",E={collapsed:0===s.length,empty:0===s.length&&h.length()<=1,format:t.quill.getFormat(s),offset:p,prefix:w,suffix:x};l.some((function(e){if(null!=e.collapsed&&e.collapsed!==E.collapsed)return!1;if(null!=e.empty&&e.empty!==E.empty)return!1;if(null!=e.offset&&e.offset!==E.offset)return!1;if(Array.isArray(e.format)){if(e.format.every((function(t){return null==E.format[t]})))return!1}else if("object"===r(e.format)&&!Object.keys(e.format).every((function(t){return!0===e.format[t]?null!=E.format[t]:!1===e.format[t]?null==E.format[t]:(0,a.default)(e.format[t],E.format[t])})))return!1;return!(null!=e.prefix&&!e.prefix.test(E.prefix)||null!=e.suffix&&!e.suffix.test(E.suffix)||!0===e.handler.call(t,s,E))}))&&n.preventDefault()}}}}))}}]),e}(d.default);function _(t,e){var n,r=t===m.keys.LEFT?"prefix":"suffix";return v(n={key:t,shiftKey:e,altKey:null},r,/^$/),v(n,"handler",(function(n){var r=n.index;t===m.keys.RIGHT&&(r+=n.length+1);var i=this.quill.getLeaf(r);return!(o(i,1)[0]instanceof f.default.Embed&&(t===m.keys.LEFT?e?this.quill.setSelection(n.index-1,n.length+1,h.default.sources.USER):this.quill.setSelection(n.index-1,h.default.sources.USER):e?this.quill.setSelection(n.index,n.length+1,h.default.sources.USER):this.quill.setSelection(n.index+n.length+1,h.default.sources.USER),1))})),n}function O(t,e){if(!(0===t.index||this.quill.getLength()<=1)){var n=this.quill.getLine(t.index),r=o(n,1)[0],i={};if(0===e.offset){var l=this.quill.getLine(t.index-1),a=o(l,1)[0];if(null!=a&&a.length()>1){var s=r.formats(),u=this.quill.getFormat(t.index-1,1);i=c.default.attributes.diff(s,u)||{}}}var f=/[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(e.prefix)?2:1;this.quill.deleteText(t.index-f,f,h.default.sources.USER),Object.keys(i).length>0&&this.quill.formatLine(t.index-f,f,i,h.default.sources.USER),this.quill.focus()}}function w(t,e){var n=/^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(e.suffix)?2:1;if(!(t.index>=this.quill.getLength()-n)){var r={},i=0,l=this.quill.getLine(t.index),a=o(l,1)[0];if(e.offset>=a.length()-1){var s=this.quill.getLine(t.index+1),u=o(s,1)[0];if(u){var f=a.formats(),p=this.quill.getFormat(t.index,1);r=c.default.attributes.diff(f,p)||{},i=u.length()}}this.quill.deleteText(t.index,n,h.default.sources.USER),Object.keys(r).length>0&&this.quill.formatLine(t.index+i-1,n,r,h.default.sources.USER)}}function x(t){var e=this.quill.getLines(t),n={};if(e.length>1){var r=e[0].formats(),o=e[e.length-1].formats();n=c.default.attributes.diff(o,r)||{}}this.quill.deleteText(t,h.default.sources.USER),Object.keys(n).length>0&&this.quill.formatLine(t.index,1,n,h.default.sources.USER),this.quill.setSelection(t.index,h.default.sources.SILENT),this.quill.focus()}function E(t,e){var n=this;t.length>0&&this.quill.scroll.deleteAt(t.index,t.length);var r=Object.keys(e.format).reduce((function(t,n){return f.default.query(n,f.default.Scope.BLOCK)&&!Array.isArray(e.format[n])&&(t[n]=e.format[n]),t}),{});this.quill.insertText(t.index,"\n",r,h.default.sources.USER),this.quill.setSelection(t.index+1,h.default.sources.SILENT),this.quill.focus(),Object.keys(e.format).forEach((function(t){null==r[t]&&(Array.isArray(e.format[t])||"link"!==t&&n.quill.format(t,e.format[t],h.default.sources.USER))}))}function k(t){return{key:m.keys.TAB,shiftKey:!t,format:{"code-block":!0},handler:function(e){var n=f.default.query("code-block"),r=e.index,i=e.length,l=this.quill.scroll.descendant(n,r),a=o(l,2),s=a[0],u=a[1];if(null!=s){var c=this.quill.getIndex(s),p=s.newlineIndex(u,!0)+1,d=s.newlineIndex(c+u+i),y=s.domNode.textContent.slice(p,d).split("\n");u=0,y.forEach((function(e,o){t?(s.insertAt(p+u,n.TAB),u+=n.TAB.length,0===o?r+=n.TAB.length:i+=n.TAB.length):e.startsWith(n.TAB)&&(s.deleteAt(p+u,n.TAB.length),u-=n.TAB.length,0===o?r-=n.TAB.length:i-=n.TAB.length),u+=e.length+1})),this.quill.update(h.default.sources.USER),this.quill.setSelection(r,i,h.default.sources.SILENT)}}}}function A(t){return{key:t[0].toUpperCase(),shortKey:!0,handler:function(e,n){this.quill.format(t,!n.format[t],h.default.sources.USER)}}}function N(t){if("string"==typeof t||"number"==typeof t)return N({key:t});if("object"===(void 0===t?"undefined":r(t))&&(t=(0,l.default)(t,!1)),"string"==typeof t.key)if(null!=m.keys[t.key.toUpperCase()])t.key=m.keys[t.key.toUpperCase()];else{if(1!==t.key.length)return null;t.key=t.key.toUpperCase().charCodeAt(0)}return t.shortKey&&(t[g]=t.shortKey,delete t.shortKey),t}m.keys={BACKSPACE:8,TAB:9,ENTER:13,ESCAPE:27,LEFT:37,UP:38,RIGHT:39,DOWN:40,DELETE:46},m.DEFAULTS={bindings:{bold:A("bold"),italic:A("italic"),underline:A("underline"),indent:{key:m.keys.TAB,format:["blockquote","indent","list"],handler:function(t,e){if(e.collapsed&&0!==e.offset)return!0;this.quill.format("indent","+1",h.default.sources.USER)}},outdent:{key:m.keys.TAB,shiftKey:!0,format:["blockquote","indent","list"],handler:function(t,e){if(e.collapsed&&0!==e.offset)return!0;this.quill.format("indent","-1",h.default.sources.USER)}},"outdent backspace":{key:m.keys.BACKSPACE,collapsed:!0,shiftKey:null,metaKey:null,ctrlKey:null,altKey:null,format:["indent","list"],offset:0,handler:function(t,e){null!=e.format.indent?this.quill.format("indent","-1",h.default.sources.USER):null!=e.format.list&&this.quill.format("list",!1,h.default.sources.USER)}},"indent code-block":k(!0),"outdent code-block":k(!1),"remove tab":{key:m.keys.TAB,shiftKey:!0,collapsed:!0,prefix:/\t$/,handler:function(t){this.quill.deleteText(t.index-1,1,h.default.sources.USER)}},tab:{key:m.keys.TAB,handler:function(t){this.quill.history.cutoff();var e=(new u.default).retain(t.index).delete(t.length).insert("\t");this.quill.updateContents(e,h.default.sources.USER),this.quill.history.cutoff(),this.quill.setSelection(t.index+1,h.default.sources.SILENT)}},"list empty enter":{key:m.keys.ENTER,collapsed:!0,format:["list"],empty:!0,handler:function(t,e){this.quill.format("list",!1,h.default.sources.USER),e.format.indent&&this.quill.format("indent",!1,h.default.sources.USER)}},"checklist enter":{key:m.keys.ENTER,collapsed:!0,format:{list:"checked"},handler:function(t){var e=this.quill.getLine(t.index),n=o(e,2),r=n[0],i=n[1],l=(0,s.default)({},r.formats(),{list:"checked"}),a=(new u.default).retain(t.index).insert("\n",l).retain(r.length()-i-1).retain(1,{list:"unchecked"});this.quill.updateContents(a,h.default.sources.USER),this.quill.setSelection(t.index+1,h.default.sources.SILENT),this.quill.scrollIntoView()}},"header enter":{key:m.keys.ENTER,collapsed:!0,format:["header"],suffix:/^$/,handler:function(t,e){var n=this.quill.getLine(t.index),r=o(n,2),i=r[0],l=r[1],a=(new u.default).retain(t.index).insert("\n",e.format).retain(i.length()-l-1).retain(1,{header:null});this.quill.updateContents(a,h.default.sources.USER),this.quill.setSelection(t.index+1,h.default.sources.SILENT),this.quill.scrollIntoView()}},"list autofill":{key:" ",collapsed:!0,format:{list:!1},prefix:/^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,handler:function(t,e){var n=e.prefix.length,r=this.quill.getLine(t.index),i=o(r,2),l=i[0],a=i[1];if(a>n)return!0;var s=void 0;switch(e.prefix.trim()){case"[]":case"[ ]":s="unchecked";break;case"[x]":s="checked";break;case"-":case"*":s="bullet";break;default:s="ordered"}this.quill.insertText(t.index," ",h.default.sources.USER),this.quill.history.cutoff();var c=(new u.default).retain(t.index-a).delete(n+1).retain(l.length()-2-a).retain(1,{list:s});this.quill.updateContents(c,h.default.sources.USER),this.quill.history.cutoff(),this.quill.setSelection(t.index-n,h.default.sources.SILENT)}},"code exit":{key:m.keys.ENTER,collapsed:!0,format:["code-block"],prefix:/\n\n$/,suffix:/^\s+$/,handler:function(t){var e=this.quill.getLine(t.index),n=o(e,2),r=n[0],i=n[1],l=(new u.default).retain(t.index+r.length()-i-2).retain(1,{"code-block":null}).delete(1);this.quill.updateContents(l,h.default.sources.USER)}},"embed left":_(m.keys.LEFT,!1),"embed left shift":_(m.keys.LEFT,!0),"embed right":_(m.keys.RIGHT,!1),"embed right shift":_(m.keys.RIGHT,!0)}},e.default=m,e.SHORTKEY=g},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),l=s(n(0)),a=s(n(7));function s(t){return t&&t.__esModule?t:{default:t}}var u=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.selection=n,r.textNode=document.createTextNode(e.CONTENTS),r.domNode.appendChild(r.textNode),r._length=0,r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),i(e,null,[{key:"value",value:function(){}}]),i(e,[{key:"detach",value:function(){null!=this.parent&&this.parent.removeChild(this)}},{key:"format",value:function(t,n){if(0!==this._length)return o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n);for(var r=this,i=0;null!=r&&r.statics.scope!==l.default.Scope.BLOCK_BLOT;)i+=r.offset(r.parent),r=r.parent;null!=r&&(this._length=e.CONTENTS.length,r.optimize(),r.formatAt(i,e.CONTENTS.length,t,n),this._length=0)}},{key:"index",value:function(t,n){return t===this.textNode?0:o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"index",this).call(this,t,n)}},{key:"length",value:function(){return this._length}},{key:"position",value:function(){return[this.textNode,this.textNode.data.length]}},{key:"remove",value:function(){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"remove",this).call(this),this.parent=null}},{key:"restore",value:function(){if(!this.selection.composing&&null!=this.parent){var t=this.textNode,n=this.selection.getNativeRange(),o=void 0,i=void 0,s=void 0;if(null!=n&&n.start.node===t&&n.end.node===t){var u=[t,n.start.offset,n.end.offset];o=u[0],i=u[1],s=u[2]}for(;null!=this.domNode.lastChild&&this.domNode.lastChild!==this.textNode;)this.domNode.parentNode.insertBefore(this.domNode.lastChild,this.domNode);if(this.textNode.data!==e.CONTENTS){var c=this.textNode.data.split(e.CONTENTS).join("");this.next instanceof a.default?(o=this.next.domNode,this.next.insertAt(0,c),this.textNode.data=e.CONTENTS):(this.textNode.data=c,this.parent.insertBefore(l.default.create(this.textNode),this),this.textNode=document.createTextNode(e.CONTENTS),this.domNode.appendChild(this.textNode))}if(this.remove(),null!=i){var f=[i,s].map((function(t){return Math.max(0,Math.min(o.data.length,t-1))})),h=r(f,2);return i=h[0],s=h[1],{startNode:o,startOffset:i,endNode:o,endOffset:s}}}}},{key:"update",value:function(t,e){var n=this;if(t.some((function(t){return"characterData"===t.type&&t.target===n.textNode}))){var r=this.restore();r&&(e.range=r)}}},{key:"value",value:function(){return""}}]),e}(l.default.Embed);u.blotName="cursor",u.className="ql-cursor",u.tagName="span",u.CONTENTS="\ufeff",e.default=u},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=l(n(0)),o=n(4),i=l(o);function l(t){return t&&t.__esModule?t:{default:t}}function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var u=function(t){function e(){return a(this,e),s(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(r.default.Container);u.allowedChildren=[i.default,o.BlockEmbed,u],e.default=u},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.ColorStyle=e.ColorClass=e.ColorAttributor=void 0;var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=n(0),l=(r=i)&&r.__esModule?r:{default:r};function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var u=function(t){function e(){return a(this,e),s(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"value",value:function(t){var n=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0}(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t);return n.startsWith("rgb(")?(n=n.replace(/^[^\d]+/,"").replace(/[^\d]+$/,""),"#"+n.split(",").map((function(t){return("00"+parseInt(t).toString(16)).slice(-2)})).join("")):n}}]),e}(l.default.Attributor.Style),c=new l.default.Attributor.Class("color","ql-color",{scope:l.default.Scope.INLINE}),f=new u("color","color",{scope:l.default.Scope.INLINE});e.ColorAttributor=u,e.ColorClass=c,e.ColorStyle=f},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.sanitize=e.default=void 0;var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=n(6);function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var u=function(t){function e(){return a(this,e),s(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"format",value:function(t,n){if(t!==this.statics.blotName||!n)return i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n);n=this.constructor.sanitize(n),this.domNode.setAttribute("href",n)}}],[{key:"create",value:function(t){var n=i(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return t=this.sanitize(t),n.setAttribute("href",t),n.setAttribute("rel","noopener noreferrer"),n.setAttribute("target","_blank"),n}},{key:"formats",value:function(t){return t.getAttribute("href")}},{key:"sanitize",value:function(t){return c(t,this.PROTOCOL_WHITELIST)?t:this.SANITIZED_URL}}]),e}(((r=l)&&r.__esModule?r:{default:r}).default);function c(t,e){var n=document.createElement("a");n.href=t;var r=n.href.slice(0,n.href.indexOf(":"));return e.indexOf(r)>-1}u.blotName="link",u.tagName="A",u.SANITIZED_URL="about:blank",u.PROTOCOL_WHITELIST=["http","https","mailto","tel"],e.default=u,e.sanitize=c},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=a(n(23)),l=a(n(107));function a(t){return t&&t.__esModule?t:{default:t}}var s=0;function u(t,e){t.setAttribute(e,!("true"===t.getAttribute(e)))}var c=function(){function t(e){var n=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.select=e,this.container=document.createElement("span"),this.buildPicker(),this.select.style.display="none",this.select.parentNode.insertBefore(this.container,this.select),this.label.addEventListener("mousedown",(function(){n.togglePicker()})),this.label.addEventListener("keydown",(function(t){switch(t.keyCode){case i.default.keys.ENTER:n.togglePicker();break;case i.default.keys.ESCAPE:n.escape(),t.preventDefault()}})),this.select.addEventListener("change",this.update.bind(this))}return o(t,[{key:"togglePicker",value:function(){this.container.classList.toggle("ql-expanded"),u(this.label,"aria-expanded"),u(this.options,"aria-hidden")}},{key:"buildItem",value:function(t){var e=this,n=document.createElement("span");return n.tabIndex="0",n.setAttribute("role","button"),n.classList.add("ql-picker-item"),t.hasAttribute("value")&&n.setAttribute("data-value",t.getAttribute("value")),t.textContent&&n.setAttribute("data-label",t.textContent),n.addEventListener("click",(function(){e.selectItem(n,!0)})),n.addEventListener("keydown",(function(t){switch(t.keyCode){case i.default.keys.ENTER:e.selectItem(n,!0),t.preventDefault();break;case i.default.keys.ESCAPE:e.escape(),t.preventDefault()}})),n}},{key:"buildLabel",value:function(){var t=document.createElement("span");return t.classList.add("ql-picker-label"),t.innerHTML=l.default,t.tabIndex="0",t.setAttribute("role","button"),t.setAttribute("aria-expanded","false"),this.container.appendChild(t),t}},{key:"buildOptions",value:function(){var t=this,e=document.createElement("span");e.classList.add("ql-picker-options"),e.setAttribute("aria-hidden","true"),e.tabIndex="-1",e.id="ql-picker-options-"+s,s+=1,this.label.setAttribute("aria-controls",e.id),this.options=e,[].slice.call(this.select.options).forEach((function(n){var r=t.buildItem(n);e.appendChild(r),!0===n.selected&&t.selectItem(r)})),this.container.appendChild(e)}},{key:"buildPicker",value:function(){var t=this;[].slice.call(this.select.attributes).forEach((function(e){t.container.setAttribute(e.name,e.value)})),this.container.classList.add("ql-picker"),this.label=this.buildLabel(),this.buildOptions()}},{key:"escape",value:function(){var t=this;this.close(),setTimeout((function(){return t.label.focus()}),1)}},{key:"close",value:function(){this.container.classList.remove("ql-expanded"),this.label.setAttribute("aria-expanded","false"),this.options.setAttribute("aria-hidden","true")}},{key:"selectItem",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.container.querySelector(".ql-selected");if(t!==n&&(null!=n&&n.classList.remove("ql-selected"),null!=t&&(t.classList.add("ql-selected"),this.select.selectedIndex=[].indexOf.call(t.parentNode.children,t),t.hasAttribute("data-value")?this.label.setAttribute("data-value",t.getAttribute("data-value")):this.label.removeAttribute("data-value"),t.hasAttribute("data-label")?this.label.setAttribute("data-label",t.getAttribute("data-label")):this.label.removeAttribute("data-label"),e))){if("function"==typeof Event)this.select.dispatchEvent(new Event("change"));else if("object"===("undefined"==typeof Event?"undefined":r(Event))){var o=document.createEvent("Event");o.initEvent("change",!0,!0),this.select.dispatchEvent(o)}this.close()}}},{key:"update",value:function(){var t=void 0;if(this.select.selectedIndex>-1){var e=this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];t=this.select.options[this.select.selectedIndex],this.selectItem(e)}else this.selectItem(null);var n=null!=t&&t!==this.select.querySelector("option[selected]");this.label.classList.toggle("ql-active",n)}}]),t}();e.default=c},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=b(n(0)),o=b(n(5)),i=n(4),l=b(i),a=b(n(16)),s=b(n(25)),u=b(n(24)),c=b(n(35)),f=b(n(6)),h=b(n(22)),p=b(n(7)),d=b(n(55)),y=b(n(42)),v=b(n(23));function b(t){return t&&t.__esModule?t:{default:t}}o.default.register({"blots/block":l.default,"blots/block/embed":i.BlockEmbed,"blots/break":a.default,"blots/container":s.default,"blots/cursor":u.default,"blots/embed":c.default,"blots/inline":f.default,"blots/scroll":h.default,"blots/text":p.default,"modules/clipboard":d.default,"modules/history":y.default,"modules/keyboard":v.default}),r.default.register(l.default,a.default,u.default,f.default,h.default,p.default),e.default=o.default},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(1),o=function(){function t(t){this.domNode=t,this.domNode[r.DATA_KEY]={blot:this}}return Object.defineProperty(t.prototype,"statics",{get:function(){return this.constructor},enumerable:!0,configurable:!0}),t.create=function(t){if(null==this.tagName)throw new r.ParchmentError("Blot definition missing tagName");var e;return Array.isArray(this.tagName)?("string"==typeof t&&(t=t.toUpperCase(),parseInt(t).toString()===t&&(t=parseInt(t))),e="number"==typeof t?document.createElement(this.tagName[t-1]):this.tagName.indexOf(t)>-1?document.createElement(t):document.createElement(this.tagName[0])):e=document.createElement(this.tagName),this.className&&e.classList.add(this.className),e},t.prototype.attach=function(){null!=this.parent&&(this.scroll=this.parent.scroll)},t.prototype.clone=function(){var t=this.domNode.cloneNode(!1);return r.create(t)},t.prototype.detach=function(){null!=this.parent&&this.parent.removeChild(this),delete this.domNode[r.DATA_KEY]},t.prototype.deleteAt=function(t,e){this.isolate(t,e).remove()},t.prototype.formatAt=function(t,e,n,o){var i=this.isolate(t,e);if(null!=r.query(n,r.Scope.BLOT)&&o)i.wrap(n,o);else if(null!=r.query(n,r.Scope.ATTRIBUTE)){var l=r.create(this.statics.scope);i.wrap(l),l.format(n,o)}},t.prototype.insertAt=function(t,e,n){var o=null==n?r.create("text",e):r.create(e,n),i=this.split(t);this.parent.insertBefore(o,i)},t.prototype.insertInto=function(t,e){void 0===e&&(e=null),null!=this.parent&&this.parent.children.remove(this);var n=null;t.children.insertBefore(this,e),null!=e&&(n=e.domNode),this.domNode.parentNode==t.domNode&&this.domNode.nextSibling==n||t.domNode.insertBefore(this.domNode,n),this.parent=t,this.attach()},t.prototype.isolate=function(t,e){var n=this.split(t);return n.split(e),n},t.prototype.length=function(){return 1},t.prototype.offset=function(t){return void 0===t&&(t=this.parent),null==this.parent||this==t?0:this.parent.children.offset(this)+this.parent.offset(t)},t.prototype.optimize=function(t){null!=this.domNode[r.DATA_KEY]&&delete this.domNode[r.DATA_KEY].mutations},t.prototype.remove=function(){null!=this.domNode.parentNode&&this.domNode.parentNode.removeChild(this.domNode),this.detach()},t.prototype.replace=function(t){null!=t.parent&&(t.parent.insertBefore(this,t.next),t.remove())},t.prototype.replaceWith=function(t,e){var n="string"==typeof t?r.create(t,e):t;return n.replace(this),n},t.prototype.split=function(t,e){return 0===t?this:this.next},t.prototype.update=function(t,e){},t.prototype.wrap=function(t,e){var n="string"==typeof t?r.create(t,e):t;return null!=this.parent&&this.parent.insertBefore(n,this.next),n.appendChild(this),n},t.blotName="abstract",t}();e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(12),o=n(32),i=n(33),l=n(1),a=function(){function t(t){this.attributes={},this.domNode=t,this.build()}return t.prototype.attribute=function(t,e){e?t.add(this.domNode,e)&&(null!=t.value(this.domNode)?this.attributes[t.attrName]=t:delete this.attributes[t.attrName]):(t.remove(this.domNode),delete this.attributes[t.attrName])},t.prototype.build=function(){var t=this;this.attributes={};var e=r.default.keys(this.domNode),n=o.default.keys(this.domNode),a=i.default.keys(this.domNode);e.concat(n).concat(a).forEach((function(e){var n=l.query(e,l.Scope.ATTRIBUTE);n instanceof r.default&&(t.attributes[n.attrName]=n)}))},t.prototype.copy=function(t){var e=this;Object.keys(this.attributes).forEach((function(n){var r=e.attributes[n].value(e.domNode);t.format(n,r)}))},t.prototype.move=function(t){var e=this;this.copy(t),Object.keys(this.attributes).forEach((function(t){e.attributes[t].remove(e.domNode)})),this.attributes={}},t.prototype.values=function(){var t=this;return Object.keys(this.attributes).reduce((function(e,n){return e[n]=t.attributes[n].value(t.domNode),e}),{})},t}();e.default=a},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});function i(t,e){return(t.getAttribute("class")||"").split(/\s+/).filter((function(t){return 0===t.indexOf(e+"-")}))}Object.defineProperty(e,"__esModule",{value:!0});var l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.keys=function(t){return(t.getAttribute("class")||"").split(/\s+/).map((function(t){return t.split("-").slice(0,-1).join("-")}))},e.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(this.remove(t),t.classList.add(this.keyName+"-"+e),!0)},e.prototype.remove=function(t){i(t,this.keyName).forEach((function(e){t.classList.remove(e)})),0===t.classList.length&&t.removeAttribute("class")},e.prototype.value=function(t){var e=(i(t,this.keyName)[0]||"").slice(this.keyName.length+1);return this.canAdd(t,e)?e:""},e}(n(12).default);e.default=l},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});function i(t){var e=t.split("-"),n=e.slice(1).map((function(t){return t[0].toUpperCase()+t.slice(1)})).join("");return e[0]+n}Object.defineProperty(e,"__esModule",{value:!0});var l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.keys=function(t){return(t.getAttribute("style")||"").split(";").map((function(t){return t.split(":")[0].trim()}))},e.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(t.style[i(this.keyName)]=e,!0)},e.prototype.remove=function(t){t.style[i(this.keyName)]="",t.getAttribute("style")||t.removeAttribute("style")},e.prototype.value=function(t){var e=t.style[i(this.keyName)];return this.canAdd(t,e)?e:""},e}(n(12).default);e.default=l},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function(){function t(e,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.quill=e,this.options=n,this.modules={}}return r(t,[{key:"init",value:function(){var t=this;Object.keys(this.options.modules).forEach((function(e){null==t.modules[e]&&t.addModule(e)}))}},{key:"addModule",value:function(t){var e=this.quill.constructor.import("modules/"+t);return this.modules[t]=new e(this.quill,this.options.modules[t]||{}),this.modules[t]}}]),t}();o.DEFAULTS={modules:{}},o.themes={default:o},e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=l(n(0)),i=l(n(7));function l(t){return t&&t.__esModule?t:{default:t}}var a=function(t){function e(t){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var n=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.contentNode=document.createElement("span"),n.contentNode.setAttribute("contenteditable",!1),[].slice.call(n.domNode.childNodes).forEach((function(t){n.contentNode.appendChild(t)})),n.leftGuard=document.createTextNode("\ufeff"),n.rightGuard=document.createTextNode("\ufeff"),n.domNode.appendChild(n.leftGuard),n.domNode.appendChild(n.contentNode),n.domNode.appendChild(n.rightGuard),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),r(e,[{key:"index",value:function(t,n){return t===this.leftGuard?0:t===this.rightGuard?1:function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0}(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"index",this).call(this,t,n)}},{key:"restore",value:function(t){var e=void 0,n=void 0,r=t.data.split("\ufeff").join("");if(t===this.leftGuard)if(this.prev instanceof i.default){var l=this.prev.length();this.prev.insertAt(l,r),e={startNode:this.prev.domNode,startOffset:l+r.length}}else n=document.createTextNode(r),this.parent.insertBefore(o.default.create(n),this),e={startNode:n,startOffset:r.length};else t===this.rightGuard&&(this.next instanceof i.default?(this.next.insertAt(0,r),e={startNode:this.next.domNode,startOffset:r.length}):(n=document.createTextNode(r),this.parent.insertBefore(o.default.create(n),this.next),e={startNode:n,startOffset:r.length}));return t.data="\ufeff",e}},{key:"update",value:function(t,e){var n=this;t.forEach((function(t){if("characterData"===t.type&&(t.target===n.leftGuard||t.target===n.rightGuard)){var r=n.restore(t.target);r&&(e.range=r)}}))}}]),e}(o.default.Embed);e.default=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.AlignStyle=e.AlignClass=e.AlignAttribute=void 0;var r,o=n(0),i=(r=o)&&r.__esModule?r:{default:r},l={scope:i.default.Scope.BLOCK,whitelist:["right","center","justify"]},a=new i.default.Attributor.Attribute("align","align",l),s=new i.default.Attributor.Class("align","ql-align",l),u=new i.default.Attributor.Style("align","text-align",l);e.AlignAttribute=a,e.AlignClass=s,e.AlignStyle=u},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.BackgroundStyle=e.BackgroundClass=void 0;var r,o=n(0),i=(r=o)&&r.__esModule?r:{default:r},l=n(26),a=new i.default.Attributor.Class("background","ql-bg",{scope:i.default.Scope.INLINE}),s=new l.ColorAttributor("background","background-color",{scope:i.default.Scope.INLINE});e.BackgroundClass=a,e.BackgroundStyle=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.DirectionStyle=e.DirectionClass=e.DirectionAttribute=void 0;var r,o=n(0),i=(r=o)&&r.__esModule?r:{default:r},l={scope:i.default.Scope.BLOCK,whitelist:["rtl"]},a=new i.default.Attributor.Attribute("direction","dir",l),s=new i.default.Attributor.Class("direction","ql-direction",l),u=new i.default.Attributor.Style("direction","direction",l);e.DirectionAttribute=a,e.DirectionClass=s,e.DirectionStyle=u},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.FontClass=e.FontStyle=void 0;var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=n(0),l=(r=i)&&r.__esModule?r:{default:r};function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var u={scope:l.default.Scope.INLINE,whitelist:["serif","monospace"]},c=new l.default.Attributor.Class("font","ql-font",u),f=new(function(t){function e(){return a(this,e),s(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"value",value:function(t){return function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0}(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t).replace(/["']/g,"")}}]),e}(l.default.Attributor.Style))("font","font-family",u);e.FontStyle=f,e.FontClass=c},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SizeStyle=e.SizeClass=void 0;var r,o=n(0),i=(r=o)&&r.__esModule?r:{default:r},l=new i.default.Attributor.Class("size","ql-size",{scope:i.default.Scope.INLINE,whitelist:["small","large","huge"]}),a=new i.default.Attributor.Style("size","font-size",{scope:i.default.Scope.INLINE,whitelist:["10px","18px","32px"]});e.SizeClass=l,e.SizeStyle=a},function(t,e,n){"use strict";t.exports={align:{"":n(76),center:n(77),right:n(78),justify:n(79)},background:n(80),blockquote:n(81),bold:n(82),clean:n(83),code:n(58),"code-block":n(58),color:n(84),direction:{"":n(85),rtl:n(86)},float:{center:n(87),full:n(88),left:n(89),right:n(90)},formula:n(91),header:{1:n(92),2:n(93)},italic:n(94),image:n(95),indent:{"+1":n(96),"-1":n(97)},link:n(98),list:{ordered:n(99),bullet:n(100),check:n(101)},script:{sub:n(102),super:n(103)},strike:n(104),underline:n(105),video:n(106)}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getLastChangeIndex=e.default=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=l(n(0)),i=l(n(5));function l(t){return t&&t.__esModule?t:{default:t}}var a=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.lastRecorded=0,r.ignoreChange=!1,r.clear(),r.quill.on(i.default.events.EDITOR_CHANGE,(function(t,e,n,o){t!==i.default.events.TEXT_CHANGE||r.ignoreChange||(r.options.userOnly&&o!==i.default.sources.USER?r.transform(e):r.record(e,n))})),r.quill.keyboard.addBinding({key:"Z",shortKey:!0},r.undo.bind(r)),r.quill.keyboard.addBinding({key:"Z",shortKey:!0,shiftKey:!0},r.redo.bind(r)),/Win/i.test(navigator.platform)&&r.quill.keyboard.addBinding({key:"Y",shortKey:!0},r.redo.bind(r)),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),r(e,[{key:"change",value:function(t,e){if(0!==this.stack[t].length){var n=this.stack[t].pop();this.stack[e].push(n),this.lastRecorded=0,this.ignoreChange=!0,this.quill.updateContents(n[t],i.default.sources.USER),this.ignoreChange=!1;var r=s(n[t]);this.quill.setSelection(r)}}},{key:"clear",value:function(){this.stack={undo:[],redo:[]}}},{key:"cutoff",value:function(){this.lastRecorded=0}},{key:"record",value:function(t,e){if(0!==t.ops.length){this.stack.redo=[];var n=this.quill.getContents().diff(e),r=Date.now();if(this.lastRecorded+this.options.delay>r&&this.stack.undo.length>0){var o=this.stack.undo.pop();n=n.compose(o.undo),t=o.redo.compose(t)}else this.lastRecorded=r;this.stack.undo.push({redo:t,undo:n}),this.stack.undo.length>this.options.maxStack&&this.stack.undo.shift()}}},{key:"redo",value:function(){this.change("redo","undo")}},{key:"transform",value:function(t){this.stack.undo.forEach((function(e){e.undo=t.transform(e.undo,!0),e.redo=t.transform(e.redo,!0)})),this.stack.redo.forEach((function(e){e.undo=t.transform(e.undo,!0),e.redo=t.transform(e.redo,!0)}))}},{key:"undo",value:function(){this.change("undo","redo")}}]),e}(l(n(9)).default);function s(t){var e=t.reduce((function(t,e){return t+=e.delete||0}),0),n=t.length()-e;return function(t){var e=t.ops[t.ops.length-1];return null!=e&&(null!=e.insert?"string"==typeof e.insert&&e.insert.endsWith("\n"):null!=e.attributes&&Object.keys(e.attributes).some((function(t){return null!=o.default.query(t,o.default.Scope.BLOCK)})))}(t)&&(n-=1),n}a.DEFAULTS={delay:1e3,maxStack:100,userOnly:!1},e.default=a,e.getLastChangeIndex=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BaseTooltip=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=p(n(3)),i=p(n(2)),l=p(n(8)),a=p(n(23)),s=p(n(34)),u=p(n(59)),c=p(n(60)),f=p(n(28)),h=p(n(61));function p(t){return t&&t.__esModule?t:{default:t}}function d(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function y(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function v(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var b=[!1,"center","right","justify"],g=["#000000","#e60000","#ff9900","#ffff00","#008a00","#0066cc","#9933ff","#ffffff","#facccc","#ffebcc","#ffffcc","#cce8cc","#cce0f5","#ebd6ff","#bbbbbb","#f06666","#ffc266","#ffff66","#66b966","#66a3e0","#c285ff","#888888","#a10000","#b26b00","#b2b200","#006100","#0047b2","#6b24b2","#444444","#5c0000","#663d00","#666600","#003700","#002966","#3d1466"],m=[!1,"serif","monospace"],_=["1","2","3",!1],O=["small",!1,"large","huge"],w=function(t){function e(t,n){d(this,e);var r=y(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return t.emitter.listenDOM("click",document.body,(function e(n){if(!document.body.contains(t.root))return document.body.removeEventListener("click",e);null==r.tooltip||r.tooltip.root.contains(n.target)||document.activeElement===r.tooltip.textbox||r.quill.hasFocus()||r.tooltip.hide(),null!=r.pickers&&r.pickers.forEach((function(t){t.container.contains(n.target)||t.close()}))})),r}return v(e,t),r(e,[{key:"addModule",value:function(t){var n=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0}(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"addModule",this).call(this,t);return"toolbar"===t&&this.extendToolbar(n),n}},{key:"buildButtons",value:function(t,e){t.forEach((function(t){(t.getAttribute("class")||"").split(/\s+/).forEach((function(n){if(n.startsWith("ql-")&&(n=n.slice("ql-".length),null!=e[n]))if("direction"===n)t.innerHTML=e[n][""]+e[n].rtl;else if("string"==typeof e[n])t.innerHTML=e[n];else{var r=t.value||"";null!=r&&e[n][r]&&(t.innerHTML=e[n][r])}}))}))}},{key:"buildPickers",value:function(t,e){var n=this;this.pickers=t.map((function(t){if(t.classList.contains("ql-align"))return null==t.querySelector("option")&&E(t,b),new c.default(t,e.align);if(t.classList.contains("ql-background")||t.classList.contains("ql-color")){var n=t.classList.contains("ql-background")?"background":"color";return null==t.querySelector("option")&&E(t,g,"background"===n?"#ffffff":"#000000"),new u.default(t,e[n])}return null==t.querySelector("option")&&(t.classList.contains("ql-font")?E(t,m):t.classList.contains("ql-header")?E(t,_):t.classList.contains("ql-size")&&E(t,O)),new f.default(t)})),this.quill.on(l.default.events.EDITOR_CHANGE,(function(){n.pickers.forEach((function(t){t.update()}))}))}}]),e}(s.default);w.DEFAULTS=(0,o.default)(!0,{},s.default.DEFAULTS,{modules:{toolbar:{handlers:{formula:function(){this.quill.theme.tooltip.edit("formula")},image:function(){var t=this,e=this.container.querySelector("input.ql-image[type=file]");null==e&&((e=document.createElement("input")).setAttribute("type","file"),e.setAttribute("accept","image/png, image/gif, image/jpeg, image/bmp, image/x-icon"),e.classList.add("ql-image"),e.addEventListener("change",(function(){if(null!=e.files&&null!=e.files[0]){var n=new FileReader;n.onload=function(n){var r=t.quill.getSelection(!0);t.quill.updateContents((new i.default).retain(r.index).delete(r.length).insert({image:n.target.result}),l.default.sources.USER),t.quill.setSelection(r.index+1,l.default.sources.SILENT),e.value=""},n.readAsDataURL(e.files[0])}})),this.container.appendChild(e)),e.click()},video:function(){this.quill.theme.tooltip.edit("video")}}}}});var x=function(t){function e(t,n){d(this,e);var r=y(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.textbox=r.root.querySelector('input[type="text"]'),r.listen(),r}return v(e,t),r(e,[{key:"listen",value:function(){var t=this;this.textbox.addEventListener("keydown",(function(e){a.default.match(e,"enter")?(t.save(),e.preventDefault()):a.default.match(e,"escape")&&(t.cancel(),e.preventDefault())}))}},{key:"cancel",value:function(){this.hide()}},{key:"edit",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"link",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;this.root.classList.remove("ql-hidden"),this.root.classList.add("ql-editing"),null!=e?this.textbox.value=e:t!==this.root.getAttribute("data-mode")&&(this.textbox.value=""),this.position(this.quill.getBounds(this.quill.selection.savedRange)),this.textbox.select(),this.textbox.setAttribute("placeholder",this.textbox.getAttribute("data-"+t)||""),this.root.setAttribute("data-mode",t)}},{key:"restoreFocus",value:function(){var t=this.quill.scrollingContainer.scrollTop;this.quill.focus(),this.quill.scrollingContainer.scrollTop=t}},{key:"save",value:function(){var t,e,n=this.textbox.value;switch(this.root.getAttribute("data-mode")){case"link":var r=this.quill.root.scrollTop;this.linkRange?(this.quill.formatText(this.linkRange,"link",n,l.default.sources.USER),delete this.linkRange):(this.restoreFocus(),this.quill.format("link",n,l.default.sources.USER)),this.quill.root.scrollTop=r;break;case"video":e=(t=n).match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/)||t.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/),n=e?(e[1]||"https")+"://www.youtube.com/embed/"+e[2]+"?showinfo=0":(e=t.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/))?(e[1]||"https")+"://player.vimeo.com/video/"+e[2]+"/":t;case"formula":if(!n)break;var o=this.quill.getSelection(!0);if(null!=o){var i=o.index+o.length;this.quill.insertEmbed(i,this.root.getAttribute("data-mode"),n,l.default.sources.USER),"formula"===this.root.getAttribute("data-mode")&&this.quill.insertText(i+1," ",l.default.sources.USER),this.quill.setSelection(i+2,l.default.sources.USER)}}this.textbox.value="",this.hide()}}]),e}(h.default);function E(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];e.forEach((function(e){var r=document.createElement("option");e===n?r.setAttribute("selected","selected"):r.setAttribute("value",e),t.appendChild(r)}))}e.BaseTooltip=x,e.default=w},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(){this.head=this.tail=null,this.length=0}return t.prototype.append=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];this.insertBefore(t[0],null),t.length>1&&this.append.apply(this,t.slice(1))},t.prototype.contains=function(t){for(var e,n=this.iterator();e=n();)if(e===t)return!0;return!1},t.prototype.insertBefore=function(t,e){t&&(t.next=e,null!=e?(t.prev=e.prev,null!=e.prev&&(e.prev.next=t),e.prev=t,e===this.head&&(this.head=t)):null!=this.tail?(this.tail.next=t,t.prev=this.tail,this.tail=t):(t.prev=null,this.head=this.tail=t),this.length+=1)},t.prototype.offset=function(t){for(var e=0,n=this.head;null!=n;){if(n===t)return e;e+=n.length(),n=n.next}return-1},t.prototype.remove=function(t){this.contains(t)&&(null!=t.prev&&(t.prev.next=t.next),null!=t.next&&(t.next.prev=t.prev),t===this.head&&(this.head=t.next),t===this.tail&&(this.tail=t.prev),this.length-=1)},t.prototype.iterator=function(t){return void 0===t&&(t=this.head),function(){var e=t;return null!=t&&(t=t.next),e}},t.prototype.find=function(t,e){void 0===e&&(e=!1);for(var n,r=this.iterator();n=r();){var o=n.length();if(t<o||e&&t===o&&(null==n.next||0!==n.next.length()))return[n,t];t-=o}return[null,0]},t.prototype.forEach=function(t){for(var e,n=this.iterator();e=n();)t(e)},t.prototype.forEachAt=function(t,e,n){if(!(e<=0))for(var r,o=this.find(t),i=o[0],l=t-o[1],a=this.iterator(i);(r=a())&&l<t+e;){var s=r.length();t>l?n(r,t-l,Math.min(e,l+s-t)):n(r,0,Math.min(s,t+e-l)),l+=s}},t.prototype.map=function(t){return this.reduce((function(e,n){return e.push(t(n)),e}),[])},t.prototype.reduce=function(t,e){for(var n,r=this.iterator();n=r();)e=t(e,n);return e},t}();e.default=r},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(17),l=n(1),a={attributes:!0,characterData:!0,characterDataOldValue:!0,childList:!0,subtree:!0},s=function(t){function e(e){var n=t.call(this,e)||this;return n.scroll=n,n.observer=new MutationObserver((function(t){n.update(t)})),n.observer.observe(n.domNode,a),n.attach(),n}return o(e,t),e.prototype.detach=function(){t.prototype.detach.call(this),this.observer.disconnect()},e.prototype.deleteAt=function(e,n){this.update(),0===e&&n===this.length()?this.children.forEach((function(t){t.remove()})):t.prototype.deleteAt.call(this,e,n)},e.prototype.formatAt=function(e,n,r,o){this.update(),t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.insertAt=function(e,n,r){this.update(),t.prototype.insertAt.call(this,e,n,r)},e.prototype.optimize=function(e,n){var r=this;void 0===e&&(e=[]),void 0===n&&(n={}),t.prototype.optimize.call(this,n);for(var o=[].slice.call(this.observer.takeRecords());o.length>0;)e.push(o.pop());for(var a=function(t,e){void 0===e&&(e=!0),null!=t&&t!==r&&null!=t.domNode.parentNode&&(null==t.domNode[l.DATA_KEY].mutations&&(t.domNode[l.DATA_KEY].mutations=[]),e&&a(t.parent))},s=function(t){null!=t.domNode[l.DATA_KEY]&&null!=t.domNode[l.DATA_KEY].mutations&&(t instanceof i.default&&t.children.forEach(s),t.optimize(n))},u=e,c=0;u.length>0;c+=1){if(c>=100)throw new Error("[Parchment] Maximum optimize iterations reached");for(u.forEach((function(t){var e=l.find(t.target,!0);null!=e&&(e.domNode===t.target&&("childList"===t.type?(a(l.find(t.previousSibling,!1)),[].forEach.call(t.addedNodes,(function(t){var e=l.find(t,!1);a(e,!1),e instanceof i.default&&e.children.forEach((function(t){a(t,!1)}))}))):"attributes"===t.type&&a(e.prev)),a(e))})),this.children.forEach(s),o=(u=[].slice.call(this.observer.takeRecords())).slice();o.length>0;)e.push(o.pop())}},e.prototype.update=function(e,n){var r=this;void 0===n&&(n={}),(e=e||this.observer.takeRecords()).map((function(t){var e=l.find(t.target,!0);return null==e?null:null==e.domNode[l.DATA_KEY].mutations?(e.domNode[l.DATA_KEY].mutations=[t],e):(e.domNode[l.DATA_KEY].mutations.push(t),null)})).forEach((function(t){null!=t&&t!==r&&null!=t.domNode[l.DATA_KEY]&&t.update(t.domNode[l.DATA_KEY].mutations||[],n)})),null!=this.domNode[l.DATA_KEY].mutations&&t.prototype.update.call(this,this.domNode[l.DATA_KEY].mutations,n),this.optimize(e,n)},e.blotName="scroll",e.defaultChild="block",e.scope=l.Scope.BLOCK_BLOT,e.tagName="DIV",e}(i.default);e.default=s},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(18),l=n(1),a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.formats=function(n){if(n.tagName!==e.tagName)return t.formats.call(this,n)},e.prototype.format=function(n,r){var o=this;n!==this.statics.blotName||r?t.prototype.format.call(this,n,r):(this.children.forEach((function(t){t instanceof i.default||(t=t.wrap(e.blotName,!0)),o.attributes.copy(t)})),this.unwrap())},e.prototype.formatAt=function(e,n,r,o){null!=this.formats()[r]||l.query(r,l.Scope.ATTRIBUTE)?this.isolate(e,n).format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.optimize=function(n){t.prototype.optimize.call(this,n);var r=this.formats();if(0===Object.keys(r).length)return this.unwrap();var o=this.next;o instanceof e&&o.prev===this&&function(t,e){if(Object.keys(t).length!==Object.keys(e).length)return!1;for(var n in t)if(t[n]!==e[n])return!1;return!0}(r,o.formats())&&(o.moveChildren(this),o.remove())},e.blotName="inline",e.scope=l.Scope.INLINE_BLOT,e.tagName="SPAN",e}(i.default);e.default=a},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(18),l=n(1),a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.formats=function(n){var r=l.query(e.blotName).tagName;if(n.tagName!==r)return t.formats.call(this,n)},e.prototype.format=function(n,r){null!=l.query(n,l.Scope.BLOCK)&&(n!==this.statics.blotName||r?t.prototype.format.call(this,n,r):this.replaceWith(e.blotName))},e.prototype.formatAt=function(e,n,r,o){null!=l.query(r,l.Scope.BLOCK)?this.format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.insertAt=function(e,n,r){if(null==r||null!=l.query(n,l.Scope.INLINE))t.prototype.insertAt.call(this,e,n,r);else{var o=this.split(e),i=l.create(n,r);o.parent.insertBefore(i,o)}},e.prototype.update=function(e,n){navigator.userAgent.match(/Trident/)?this.build():t.prototype.update.call(this,e,n)},e.blotName="block",e.scope=l.Scope.BLOCK_BLOT,e.tagName="P",e}(i.default);e.default=a},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.formats=function(t){},e.prototype.format=function(e,n){t.prototype.formatAt.call(this,0,this.length(),e,n)},e.prototype.formatAt=function(e,n,r,o){0===e&&n===this.length()?this.format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.formats=function(){return this.statics.formats(this.domNode)},e}(n(19).default);e.default=i},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(19),l=n(1),a=function(t){function e(e){var n=t.call(this,e)||this;return n.text=n.statics.value(n.domNode),n}return o(e,t),e.create=function(t){return document.createTextNode(t)},e.value=function(t){var e=t.data;return e.normalize&&(e=e.normalize()),e},e.prototype.deleteAt=function(t,e){this.domNode.data=this.text=this.text.slice(0,t)+this.text.slice(t+e)},e.prototype.index=function(t,e){return this.domNode===t?e:-1},e.prototype.insertAt=function(e,n,r){null==r?(this.text=this.text.slice(0,e)+n+this.text.slice(e),this.domNode.data=this.text):t.prototype.insertAt.call(this,e,n,r)},e.prototype.length=function(){return this.text.length},e.prototype.optimize=function(n){t.prototype.optimize.call(this,n),this.text=this.statics.value(this.domNode),0===this.text.length?this.remove():this.next instanceof e&&this.next.prev===this&&(this.insertAt(this.length(),this.next.value()),this.next.remove())},e.prototype.position=function(t,e){return void 0===e&&(e=!1),[this.domNode,t]},e.prototype.split=function(t,e){if(void 0===e&&(e=!1),!e){if(0===t)return this;if(t===this.length())return this.next}var n=l.create(this.domNode.splitText(t));return this.parent.insertBefore(n,this.next),this.text=this.statics.value(this.domNode),n},e.prototype.update=function(t,e){var n=this;t.some((function(t){return"characterData"===t.type&&t.target===n.domNode}))&&(this.text=this.statics.value(this.domNode))},e.prototype.value=function(){return this.text},e.blotName="text",e.scope=l.Scope.INLINE_BLOT,e}(i.default);e.default=a},function(t,e,n){"use strict";var r=document.createElement("div");if(r.classList.toggle("test-class",!1),r.classList.contains("test-class")){var o=DOMTokenList.prototype.toggle;DOMTokenList.prototype.toggle=function(t,e){return arguments.length>1&&!this.contains(t)==!e?e:o.call(this,t)}}String.prototype.startsWith||(String.prototype.startsWith=function(t,e){return e=e||0,this.substr(e,t.length)===t}),String.prototype.endsWith||(String.prototype.endsWith=function(t,e){var n=this.toString();("number"!=typeof e||!isFinite(e)||Math.floor(e)!==e||e>n.length)&&(e=n.length),e-=t.length;var r=n.indexOf(t,e);return-1!==r&&r===e}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null===this)throw new TypeError("Array.prototype.find called on null or undefined");if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var e,n=Object(this),r=n.length>>>0,o=arguments[1],i=0;i<r;i++)if(e=n[i],t.call(o,e,i,n))return e}}),document.addEventListener("DOMContentLoaded",(function(){document.execCommand("enableObjectResizing",!1,!1),document.execCommand("autoUrlDetect",!1,!1)}))},function(t,e){function n(t,e,l){if(t==e)return t?[[0,t]]:[];(l<0||t.length<l)&&(l=null);var s=o(t,e),u=t.substring(0,s);s=i(t=t.substring(s),e=e.substring(s));var c=t.substring(t.length-s),f=function(t,e){var l;if(!t)return[[1,e]];if(!e)return[[-1,t]];var a=t.length>e.length?t:e,s=t.length>e.length?e:t,u=a.indexOf(s);if(-1!=u)return l=[[1,a.substring(0,u)],[0,s],[1,a.substring(u+s.length)]],t.length>e.length&&(l[0][0]=l[2][0]=-1),l;if(1==s.length)return[[-1,t],[1,e]];var c=function(t,e){var n=t.length>e.length?t:e,r=t.length>e.length?e:t;if(n.length<4||2*r.length<n.length)return null;function l(t,e,n){for(var r,l,a,s,u=t.substring(n,n+Math.floor(t.length/4)),c=-1,f="";-1!=(c=e.indexOf(u,c+1));){var h=o(t.substring(n),e.substring(c)),p=i(t.substring(0,n),e.substring(0,c));f.length<p+h&&(f=e.substring(c-p,c)+e.substring(c,c+h),r=t.substring(0,n-p),l=t.substring(n+h),a=e.substring(0,c-p),s=e.substring(c+h))}return 2*f.length>=t.length?[r,l,a,s,f]:null}var a,s,u,c,f,h=l(n,r,Math.ceil(n.length/4)),p=l(n,r,Math.ceil(n.length/2));if(!h&&!p)return null;a=p?h&&h[4].length>p[4].length?h:p:h,t.length>e.length?(s=a[0],u=a[1],c=a[2],f=a[3]):(c=a[0],f=a[1],s=a[2],u=a[3]);var d=a[4];return[s,u,c,f,d]}(t,e);if(c){var f=c[0],h=c[1],p=c[2],d=c[3],y=c[4],v=n(f,p),b=n(h,d);return v.concat([[0,y]],b)}return function(t,e){for(var n=t.length,o=e.length,i=Math.ceil((n+o)/2),l=i,a=2*i,s=new Array(a),u=new Array(a),c=0;c<a;c++)s[c]=-1,u[c]=-1;s[l+1]=0,u[l+1]=0;for(var f=n-o,h=f%2!=0,p=0,d=0,y=0,v=0,b=0;b<i;b++){for(var g=-b+p;g<=b-d;g+=2){for(var m=l+g,_=(k=g==-b||g!=b&&s[m-1]<s[m+1]?s[m+1]:s[m-1]+1)-g;k<n&&_<o&&t.charAt(k)==e.charAt(_);)k++,_++;if(s[m]=k,k>n)d+=2;else if(_>o)p+=2;else if(h&&(x=l+f-g)>=0&&x<a&&-1!=u[x]){var O=n-u[x];if(k>=O)return r(t,e,k,_)}}for(var w=-b+y;w<=b-v;w+=2){for(var x=l+w,E=(O=w==-b||w!=b&&u[x-1]<u[x+1]?u[x+1]:u[x-1]+1)-w;O<n&&E<o&&t.charAt(n-O-1)==e.charAt(o-E-1);)O++,E++;if(u[x]=O,O>n)v+=2;else if(E>o)y+=2;else if(!h&&(m=l+f-w)>=0&&m<a&&-1!=s[m]){var k=s[m];if(_=l+k-m,k>=(O=n-O))return r(t,e,k,_)}}}return[[-1,t],[1,e]]}(t,e)}(t=t.substring(0,t.length-s),e=e.substring(0,e.length-s));return u&&f.unshift([0,u]),c&&f.push([0,c]),function t(e){e.push([0,""]);for(var n,r=0,l=0,a=0,s="",u="";r<e.length;)switch(e[r][0]){case 1:a++,u+=e[r][1],r++;break;case-1:l++,s+=e[r][1],r++;break;case 0:l+a>1?(0!==l&&0!==a&&(0!==(n=o(u,s))&&(r-l-a>0&&0==e[r-l-a-1][0]?e[r-l-a-1][1]+=u.substring(0,n):(e.splice(0,0,[0,u.substring(0,n)]),r++),u=u.substring(n),s=s.substring(n)),0!==(n=i(u,s))&&(e[r][1]=u.substring(u.length-n)+e[r][1],u=u.substring(0,u.length-n),s=s.substring(0,s.length-n))),0===l?e.splice(r-a,l+a,[1,u]):0===a?e.splice(r-l,l+a,[-1,s]):e.splice(r-l-a,l+a,[-1,s],[1,u]),r=r-l-a+(l?1:0)+(a?1:0)+1):0!==r&&0==e[r-1][0]?(e[r-1][1]+=e[r][1],e.splice(r,1)):r++,a=0,l=0,s="",u=""}""===e[e.length-1][1]&&e.pop();var c=!1;for(r=1;r<e.length-1;)0==e[r-1][0]&&0==e[r+1][0]&&(e[r][1].substring(e[r][1].length-e[r-1][1].length)==e[r-1][1]?(e[r][1]=e[r-1][1]+e[r][1].substring(0,e[r][1].length-e[r-1][1].length),e[r+1][1]=e[r-1][1]+e[r+1][1],e.splice(r-1,1),c=!0):e[r][1].substring(0,e[r+1][1].length)==e[r+1][1]&&(e[r-1][1]+=e[r+1][1],e[r][1]=e[r][1].substring(e[r+1][1].length)+e[r+1][1],e.splice(r+1,1),c=!0)),r++;c&&t(e)}(f),null!=l&&(f=function(t,e){var n=function(t,e){if(0===e)return[0,t];for(var n=0,r=0;r<t.length;r++){var o=t[r];if(-1===o[0]||0===o[0]){var i=n+o[1].length;if(e===i)return[r+1,t];if(e<i){t=t.slice();var l=e-n,a=[o[0],o[1].slice(0,l)],s=[o[0],o[1].slice(l)];return t.splice(r,1,a,s),[r+1,t]}n=i}}throw new Error("cursor_pos is out of bounds!")}(t,e),r=n[1],o=n[0],i=r[o],l=r[o+1];if(null==i)return t;if(0!==i[0])return t;if(null!=l&&i[1]+l[1]===l[1]+i[1])return r.splice(o,2,l,i),a(r,o,2);if(null!=l&&0===l[1].indexOf(i[1])){r.splice(o,2,[l[0],i[1]],[0,i[1]]);var s=l[1].slice(i[1].length);return s.length>0&&r.splice(o+2,0,[l[0],s]),a(r,o,3)}return t}(f,l)),f=function(t){for(var e=!1,n=function(t){return t.charCodeAt(0)>=56320&&t.charCodeAt(0)<=57343},r=2;r<t.length;r+=1)0===t[r-2][0]&&(o=t[r-2][1]).charCodeAt(o.length-1)>=55296&&o.charCodeAt(o.length-1)<=56319&&-1===t[r-1][0]&&n(t[r-1][1])&&1===t[r][0]&&n(t[r][1])&&(e=!0,t[r-1][1]=t[r-2][1].slice(-1)+t[r-1][1],t[r][1]=t[r-2][1].slice(-1)+t[r][1],t[r-2][1]=t[r-2][1].slice(0,-1));var o;if(!e)return t;var i=[];for(r=0;r<t.length;r+=1)t[r][1].length>0&&i.push(t[r]);return i}(f)}function r(t,e,r,o){var i=t.substring(0,r),l=e.substring(0,o),a=t.substring(r),s=e.substring(o),u=n(i,l),c=n(a,s);return u.concat(c)}function o(t,e){if(!t||!e||t.charAt(0)!=e.charAt(0))return 0;for(var n=0,r=Math.min(t.length,e.length),o=r,i=0;n<o;)t.substring(i,o)==e.substring(i,o)?i=n=o:r=o,o=Math.floor((r-n)/2+n);return o}function i(t,e){if(!t||!e||t.charAt(t.length-1)!=e.charAt(e.length-1))return 0;for(var n=0,r=Math.min(t.length,e.length),o=r,i=0;n<o;)t.substring(t.length-o,t.length-i)==e.substring(e.length-o,e.length-i)?i=n=o:r=o,o=Math.floor((r-n)/2+n);return o}var l=n;function a(t,e,n){for(var r=e+n-1;r>=0&&r>=e-1;r--)if(r+1<t.length){var o=t[r],i=t[r+1];o[0]===i[1]&&t.splice(r,2,[o[0],o[1]+i[1]])}return t}l.INSERT=1,l.DELETE=-1,l.EQUAL=0,t.exports=l},function(t,e){function n(t){var e=[];for(var n in t)e.push(n);return e}(t.exports="function"==typeof Object.keys?Object.keys:n).shim=n},function(t,e){var n="[object Arguments]"==function(){return Object.prototype.toString.call(arguments)}();function r(t){return"[object Arguments]"==Object.prototype.toString.call(t)}function o(t){return t&&"object"==typeof t&&"number"==typeof t.length&&Object.prototype.hasOwnProperty.call(t,"callee")&&!Object.prototype.propertyIsEnumerable.call(t,"callee")||!1}(e=t.exports=n?r:o).supported=r,e.unsupported=o},function(t,e){"use strict";var n=Object.prototype.hasOwnProperty,r="~";function o(){}function i(t,e,n){this.fn=t,this.context=e,this.once=n||!1}function l(){this._events=new o,this._eventsCount=0}Object.create&&(o.prototype=Object.create(null),(new o).__proto__||(r=!1)),l.prototype.eventNames=function(){var t,e,o=[];if(0===this._eventsCount)return o;for(e in t=this._events)n.call(t,e)&&o.push(r?e.slice(1):e);return Object.getOwnPropertySymbols?o.concat(Object.getOwnPropertySymbols(t)):o},l.prototype.listeners=function(t,e){var n=r?r+t:t,o=this._events[n];if(e)return!!o;if(!o)return[];if(o.fn)return[o.fn];for(var i=0,l=o.length,a=new Array(l);i<l;i++)a[i]=o[i].fn;return a},l.prototype.emit=function(t,e,n,o,i,l){var a=r?r+t:t;if(!this._events[a])return!1;var s,u,c=this._events[a],f=arguments.length;if(c.fn){switch(c.once&&this.removeListener(t,c.fn,void 0,!0),f){case 1:return c.fn.call(c.context),!0;case 2:return c.fn.call(c.context,e),!0;case 3:return c.fn.call(c.context,e,n),!0;case 4:return c.fn.call(c.context,e,n,o),!0;case 5:return c.fn.call(c.context,e,n,o,i),!0;case 6:return c.fn.call(c.context,e,n,o,i,l),!0}for(u=1,s=new Array(f-1);u<f;u++)s[u-1]=arguments[u];c.fn.apply(c.context,s)}else{var h,p=c.length;for(u=0;u<p;u++)switch(c[u].once&&this.removeListener(t,c[u].fn,void 0,!0),f){case 1:c[u].fn.call(c[u].context);break;case 2:c[u].fn.call(c[u].context,e);break;case 3:c[u].fn.call(c[u].context,e,n);break;case 4:c[u].fn.call(c[u].context,e,n,o);break;default:if(!s)for(h=1,s=new Array(f-1);h<f;h++)s[h-1]=arguments[h];c[u].fn.apply(c[u].context,s)}}return!0},l.prototype.on=function(t,e,n){var o=new i(e,n||this),l=r?r+t:t;return this._events[l]?this._events[l].fn?this._events[l]=[this._events[l],o]:this._events[l].push(o):(this._events[l]=o,this._eventsCount++),this},l.prototype.once=function(t,e,n){var o=new i(e,n||this,!0),l=r?r+t:t;return this._events[l]?this._events[l].fn?this._events[l]=[this._events[l],o]:this._events[l].push(o):(this._events[l]=o,this._eventsCount++),this},l.prototype.removeListener=function(t,e,n,i){var l=r?r+t:t;if(!this._events[l])return this;if(!e)return 0==--this._eventsCount?this._events=new o:delete this._events[l],this;var a=this._events[l];if(a.fn)a.fn!==e||i&&!a.once||n&&a.context!==n||(0==--this._eventsCount?this._events=new o:delete this._events[l]);else{for(var s=0,u=[],c=a.length;s<c;s++)(a[s].fn!==e||i&&!a[s].once||n&&a[s].context!==n)&&u.push(a[s]);u.length?this._events[l]=1===u.length?u[0]:u:0==--this._eventsCount?this._events=new o:delete this._events[l]}return this},l.prototype.removeAllListeners=function(t){var e;return t?(e=r?r+t:t,this._events[e]&&(0==--this._eventsCount?this._events=new o:delete this._events[e])):(this._events=new o,this._eventsCount=0),this},l.prototype.off=l.prototype.removeListener,l.prototype.addListener=l.prototype.on,l.prototype.setMaxListeners=function(){return this},l.prefixed=r,l.EventEmitter=l,void 0!==t&&(t.exports=l)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.matchText=e.matchSpacing=e.matchNewline=e.matchBlot=e.matchAttributor=e.default=void 0;var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),l=m(n(3)),a=m(n(2)),s=m(n(0)),u=m(n(5)),c=m(n(10)),f=m(n(9)),h=n(36),p=n(37),d=m(n(13)),y=n(26),v=n(38),b=n(39),g=n(40);function m(t){return t&&t.__esModule?t:{default:t}}function _(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var O=(0,c.default)("quill:clipboard"),w="__ql-matcher",x=[[Node.TEXT_NODE,M],[Node.TEXT_NODE,L],["br",function(t,e){return T(e,"\n")||e.insert("\n"),e}],[Node.ELEMENT_NODE,L],[Node.ELEMENT_NODE,C],[Node.ELEMENT_NODE,R],[Node.ELEMENT_NODE,q],[Node.ELEMENT_NODE,function(t,e){var n={},r=t.style||{};return r.fontStyle&&"italic"===j(t).fontStyle&&(n.italic=!0),r.fontWeight&&(j(t).fontWeight.startsWith("bold")||parseInt(j(t).fontWeight)>=700)&&(n.bold=!0),Object.keys(n).length>0&&(e=N(e,n)),parseFloat(r.textIndent||0)>0&&(e=(new a.default).insert("\t").concat(e)),e}],["li",function(t,e){var n=s.default.query(t);if(null==n||"list-item"!==n.blotName||!T(e,"\n"))return e;for(var r=-1,o=t.parentNode;!o.classList.contains("ql-clipboard");)"list"===(s.default.query(o)||{}).blotName&&(r+=1),o=o.parentNode;return r<=0?e:e.compose((new a.default).retain(e.length()-1).retain(1,{indent:r}))}],["b",S.bind(S,"bold")],["i",S.bind(S,"italic")],["style",function(){return new a.default}]],E=[h.AlignAttribute,v.DirectionAttribute].reduce((function(t,e){return t[e.keyName]=e,t}),{}),k=[h.AlignStyle,p.BackgroundStyle,y.ColorStyle,v.DirectionStyle,b.FontStyle,g.SizeStyle].reduce((function(t,e){return t[e.keyName]=e,t}),{}),A=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.root.addEventListener("paste",r.onPaste.bind(r)),r.container=r.quill.addContainer("ql-clipboard"),r.container.setAttribute("contenteditable",!0),r.container.setAttribute("tabindex",-1),r.matchers=[],x.concat(r.options.matchers).forEach((function(t){var e=o(t,2),i=e[0],l=e[1];(n.matchVisual||l!==R)&&r.addMatcher(i,l)})),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),i(e,[{key:"addMatcher",value:function(t,e){this.matchers.push([t,e])}},{key:"convert",value:function(t){if("string"==typeof t)return this.container.innerHTML=t.replace(/\>\r?\n +\</g,"><"),this.convert();var e=this.quill.getFormat(this.quill.selection.savedRange.index);if(e[d.default.blotName]){var n=this.container.innerText;return this.container.innerHTML="",(new a.default).insert(n,_({},d.default.blotName,e[d.default.blotName]))}var r=this.prepareMatching(),i=o(r,2),l=i[0],s=i[1],u=function t(e,n,r){return e.nodeType===e.TEXT_NODE?r.reduce((function(t,n){return n(e,t)}),new a.default):e.nodeType===e.ELEMENT_NODE?[].reduce.call(e.childNodes||[],(function(o,i){var l=t(i,n,r);return i.nodeType===e.ELEMENT_NODE&&(l=n.reduce((function(t,e){return e(i,t)}),l),l=(i[w]||[]).reduce((function(t,e){return e(i,t)}),l)),o.concat(l)}),new a.default):new a.default}(this.container,l,s);return T(u,"\n")&&null==u.ops[u.ops.length-1].attributes&&(u=u.compose((new a.default).retain(u.length()-1).delete(1))),O.log("convert",this.container.innerHTML,u),this.container.innerHTML="",u}},{key:"dangerouslyPasteHTML",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:u.default.sources.API;if("string"==typeof t)this.quill.setContents(this.convert(t),e),this.quill.setSelection(0,u.default.sources.SILENT);else{var r=this.convert(e);this.quill.updateContents((new a.default).retain(t).concat(r),n),this.quill.setSelection(t+r.length(),u.default.sources.SILENT)}}},{key:"onPaste",value:function(t){var e=this;if(!t.defaultPrevented&&this.quill.isEnabled()){var n=this.quill.getSelection(),r=(new a.default).retain(n.index),o=this.quill.scrollingContainer.scrollTop;this.container.focus(),this.quill.selection.update(u.default.sources.SILENT),setTimeout((function(){r=r.concat(e.convert()).delete(n.length),e.quill.updateContents(r,u.default.sources.USER),e.quill.setSelection(r.length()-n.length,u.default.sources.SILENT),e.quill.scrollingContainer.scrollTop=o,e.quill.focus()}),1)}}},{key:"prepareMatching",value:function(){var t=this,e=[],n=[];return this.matchers.forEach((function(r){var i=o(r,2),l=i[0],a=i[1];switch(l){case Node.TEXT_NODE:n.push(a);break;case Node.ELEMENT_NODE:e.push(a);break;default:[].forEach.call(t.container.querySelectorAll(l),(function(t){t[w]=t[w]||[],t[w].push(a)}))}})),[e,n]}}]),e}(f.default);function N(t,e,n){return"object"===(void 0===e?"undefined":r(e))?Object.keys(e).reduce((function(t,n){return N(t,n,e[n])}),t):t.reduce((function(t,r){return r.attributes&&r.attributes[e]?t.push(r):t.insert(r.insert,(0,l.default)({},_({},e,n),r.attributes))}),new a.default)}function j(t){return t.nodeType!==Node.ELEMENT_NODE?{}:t["__ql-computed-style"]||(t["__ql-computed-style"]=window.getComputedStyle(t))}function T(t,e){for(var n="",r=t.ops.length-1;r>=0&&n.length<e.length;--r){var o=t.ops[r];if("string"!=typeof o.insert)break;n=o.insert+n}return n.slice(-1*e.length)===e}function P(t){if(0===t.childNodes.length)return!1;var e=j(t);return["block","list-item"].indexOf(e.display)>-1}function S(t,e,n){return N(n,t,!0)}function q(t,e){var n=s.default.Attributor.Attribute.keys(t),r=s.default.Attributor.Class.keys(t),o=s.default.Attributor.Style.keys(t),i={};return n.concat(r).concat(o).forEach((function(e){var n=s.default.query(e,s.default.Scope.ATTRIBUTE);null!=n&&(i[n.attrName]=n.value(t),i[n.attrName])||(null==(n=E[e])||n.attrName!==e&&n.keyName!==e||(i[n.attrName]=n.value(t)||void 0),null==(n=k[e])||n.attrName!==e&&n.keyName!==e||(n=k[e],i[n.attrName]=n.value(t)||void 0))})),Object.keys(i).length>0&&(e=N(e,i)),e}function C(t,e){var n=s.default.query(t);if(null==n)return e;if(n.prototype instanceof s.default.Embed){var r={},o=n.value(t);null!=o&&(r[n.blotName]=o,e=(new a.default).insert(r,n.formats(t)))}else"function"==typeof n.formats&&(e=N(e,n.blotName,n.formats(t)));return e}function L(t,e){return T(e,"\n")||(P(t)||e.length()>0&&t.nextSibling&&P(t.nextSibling))&&e.insert("\n"),e}function R(t,e){if(P(t)&&null!=t.nextElementSibling&&!T(e,"\n\n")){var n=t.offsetHeight+parseFloat(j(t).marginTop)+parseFloat(j(t).marginBottom);t.nextElementSibling.offsetTop>t.offsetTop+1.5*n&&e.insert("\n")}return e}function M(t,e){var n=t.data;if("O:P"===t.parentNode.tagName)return e.insert(n.trim());if(0===n.trim().length&&t.parentNode.classList.contains("ql-clipboard"))return e;if(!j(t.parentNode).whiteSpace.startsWith("pre")){var r=function(t,e){return(e=e.replace(/[^\u00a0]/g,"")).length<1&&t?" ":e};n=(n=n.replace(/\r\n/g," ").replace(/\n/g," ")).replace(/\s\s+/g,r.bind(r,!0)),(null==t.previousSibling&&P(t.parentNode)||null!=t.previousSibling&&P(t.previousSibling))&&(n=n.replace(/^\s+/,r.bind(r,!1))),(null==t.nextSibling&&P(t.parentNode)||null!=t.nextSibling&&P(t.nextSibling))&&(n=n.replace(/\s+$/,r.bind(r,!1)))}return e.insert(n)}A.DEFAULTS={matchers:[],matchVisual:!0},e.default=A,e.matchAttributor=q,e.matchBlot=C,e.matchNewline=L,e.matchSpacing=R,e.matchText=M},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=n(6);function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var u=function(t){function e(){return a(this,e),s(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"optimize",value:function(t){i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.domNode.tagName!==this.statics.tagName[0]&&this.replaceWith(this.statics.blotName)}}],[{key:"create",value:function(){return i(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this)}},{key:"formats",value:function(){return!0}}]),e}(((r=l)&&r.__esModule?r:{default:r}).default);u.blotName="bold",u.tagName=["STRONG","B"],e.default=u},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.addControls=e.default=void 0;var r=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=c(n(2)),l=c(n(0)),a=c(n(5)),s=c(n(10)),u=c(n(9));function c(t){return t&&t.__esModule?t:{default:t}}function f(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var h=(0,s.default)("quill:toolbar"),p=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var o,i=f(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));if(Array.isArray(i.options.container)){var l=document.createElement("div");y(l,i.options.container),t.container.parentNode.insertBefore(l,t.container),i.container=l}else"string"==typeof i.options.container?i.container=document.querySelector(i.options.container):i.container=i.options.container;return i.container instanceof HTMLElement?(i.container.classList.add("ql-toolbar"),i.controls=[],i.handlers={},Object.keys(i.options.handlers).forEach((function(t){i.addHandler(t,i.options.handlers[t])})),[].forEach.call(i.container.querySelectorAll("button, select"),(function(t){i.attach(t)})),i.quill.on(a.default.events.EDITOR_CHANGE,(function(t,e){t===a.default.events.SELECTION_CHANGE&&i.update(e)})),i.quill.on(a.default.events.SCROLL_OPTIMIZE,(function(){var t=i.quill.selection.getRange(),e=r(t,1)[0];i.update(e)})),i):(o=h.error("Container required for toolbar",i.options),f(i,o))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"addHandler",value:function(t,e){this.handlers[t]=e}},{key:"attach",value:function(t){var e=this,n=[].find.call(t.classList,(function(t){return 0===t.indexOf("ql-")}));if(n){if(n=n.slice("ql-".length),"BUTTON"===t.tagName&&t.setAttribute("type","button"),null==this.handlers[n]){if(null!=this.quill.scroll.whitelist&&null==this.quill.scroll.whitelist[n])return void h.warn("ignoring attaching to disabled format",n,t);if(null==l.default.query(n))return void h.warn("ignoring attaching to nonexistent format",n,t)}var o="SELECT"===t.tagName?"change":"click";t.addEventListener(o,(function(o){var s=void 0;if("SELECT"===t.tagName){if(t.selectedIndex<0)return;var u=t.options[t.selectedIndex];s=!u.hasAttribute("selected")&&(u.value||!1)}else s=!t.classList.contains("ql-active")&&(t.value||!t.hasAttribute("value")),o.preventDefault();e.quill.focus();var c=e.quill.selection.getRange(),f=r(c,1)[0];if(null!=e.handlers[n])e.handlers[n].call(e,s);else if(l.default.query(n).prototype instanceof l.default.Embed){if(!(s=prompt("Enter "+n)))return;e.quill.updateContents((new i.default).retain(f.index).delete(f.length).insert(function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}({},n,s)),a.default.sources.USER)}else e.quill.format(n,s,a.default.sources.USER);e.update(f)})),this.controls.push([n,t])}}},{key:"update",value:function(t){var e=null==t?{}:this.quill.getFormat(t);this.controls.forEach((function(n){var o=r(n,2),i=o[0],l=o[1];if("SELECT"===l.tagName){var a=void 0;if(null==t)a=null;else if(null==e[i])a=l.querySelector("option[selected]");else if(!Array.isArray(e[i])){var s=e[i];"string"==typeof s&&(s=s.replace(/\"/g,'\\"')),a=l.querySelector('option[value="'+s+'"]')}null==a?(l.value="",l.selectedIndex=-1):a.selected=!0}else if(null==t)l.classList.remove("ql-active");else if(l.hasAttribute("value")){var u=e[i]===l.getAttribute("value")||null!=e[i]&&e[i].toString()===l.getAttribute("value")||null==e[i]&&!l.getAttribute("value");l.classList.toggle("ql-active",u)}else l.classList.toggle("ql-active",null!=e[i])}))}}]),e}(u.default);function d(t,e,n){var r=document.createElement("button");r.setAttribute("type","button"),r.classList.add("ql-"+e),null!=n&&(r.value=n),t.appendChild(r)}function y(t,e){Array.isArray(e[0])||(e=[e]),e.forEach((function(e){var n=document.createElement("span");n.classList.add("ql-formats"),e.forEach((function(t){if("string"==typeof t)d(n,t);else{var e=Object.keys(t)[0],r=t[e];Array.isArray(r)?function(t,e,n){var r=document.createElement("select");r.classList.add("ql-"+e),n.forEach((function(t){var e=document.createElement("option");!1!==t?e.setAttribute("value",t):e.setAttribute("selected","selected"),r.appendChild(e)})),t.appendChild(r)}(n,e,r):d(n,e,r)}})),t.appendChild(n)}))}p.DEFAULTS={},p.DEFAULTS={container:null,handlers:{clean:function(){var t=this,e=this.quill.getSelection();if(null!=e)if(0==e.length){var n=this.quill.getFormat();Object.keys(n).forEach((function(e){null!=l.default.query(e,l.default.Scope.INLINE)&&t.quill.format(e,!1)}))}else this.quill.removeFormat(e,a.default.sources.USER)},direction:function(t){var e=this.quill.getFormat().align;"rtl"===t&&null==e?this.quill.format("align","right",a.default.sources.USER):t||"right"!==e||this.quill.format("align",!1,a.default.sources.USER),this.quill.format("direction",t,a.default.sources.USER)},indent:function(t){var e=this.quill.getSelection(),n=this.quill.getFormat(e),r=parseInt(n.indent||0);if("+1"===t||"-1"===t){var o="+1"===t?1:-1;"rtl"===n.direction&&(o*=-1),this.quill.format("indent",r+o,a.default.sources.USER)}},link:function(t){!0===t&&(t=prompt("Enter link URL:")),this.quill.format("link",t,a.default.sources.USER)},list:function(t){var e=this.quill.getSelection(),n=this.quill.getFormat(e);"check"===t?"checked"===n.list||"unchecked"===n.list?this.quill.format("list",!1,a.default.sources.USER):this.quill.format("list","unchecked",a.default.sources.USER):this.quill.format("list",t,a.default.sources.USER)}}},e.default=p,e.addControls=y},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=n(28),a=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.label.innerHTML=n,r.container.classList.add("ql-color-picker"),[].slice.call(r.container.querySelectorAll(".ql-picker-item"),0,7).forEach((function(t){t.classList.add("ql-primary")})),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"buildItem",value:function(t){var n=i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"buildItem",this).call(this,t);return n.style.backgroundColor=t.getAttribute("value")||"",n}},{key:"selectItem",value:function(t,n){i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"selectItem",this).call(this,t,n);var r=this.label.querySelector(".ql-color-label"),o=t&&t.getAttribute("data-value")||"";r&&("line"===r.tagName?r.style.stroke=o:r.style.fill=o)}}]),e}(((r=l)&&r.__esModule?r:{default:r}).default);e.default=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=n(28),l=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.container.classList.add("ql-icon-picker"),[].forEach.call(r.container.querySelectorAll(".ql-picker-item"),(function(t){t.innerHTML=n[t.getAttribute("data-value")||""]})),r.defaultItem=r.container.querySelector(".ql-selected"),r.selectItem(r.defaultItem),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"selectItem",value:function(t,n){(function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0})(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"selectItem",this).call(this,t,n),t=t||this.defaultItem,this.label.innerHTML=t.innerHTML}}]),e}(((r=i)&&r.__esModule?r:{default:r}).default);e.default=l},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function(){function t(e,n){var r=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.quill=e,this.boundsContainer=n||document.body,this.root=e.addContainer("ql-tooltip"),this.root.innerHTML=this.constructor.TEMPLATE,this.quill.root===this.quill.scrollingContainer&&this.quill.root.addEventListener("scroll",(function(){r.root.style.marginTop=-1*r.quill.root.scrollTop+"px"})),this.hide()}return r(t,[{key:"hide",value:function(){this.root.classList.add("ql-hidden")}},{key:"position",value:function(t){var e=t.left+t.width/2-this.root.offsetWidth/2,n=t.bottom+this.quill.root.scrollTop;this.root.style.left=e+"px",this.root.style.top=n+"px",this.root.classList.remove("ql-flip");var r=this.boundsContainer.getBoundingClientRect(),o=this.root.getBoundingClientRect(),i=0;if(o.right>r.right&&(i=r.right-o.right,this.root.style.left=e+i+"px"),o.left<r.left&&(i=r.left-o.left,this.root.style.left=e+i+"px"),o.bottom>r.bottom){var l=o.bottom-o.top,a=t.bottom-t.top+l;this.root.style.top=n-a+"px",this.root.classList.add("ql-flip")}return i}},{key:"show",value:function(){this.root.classList.remove("ql-editing"),this.root.classList.remove("ql-hidden")}}]),t}();e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),l=p(n(3)),a=p(n(8)),s=n(43),u=p(s),c=p(n(27)),f=n(15),h=p(n(41));function p(t){return t&&t.__esModule?t:{default:t}}function d(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function y(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function v(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var b=[[{header:["1","2","3",!1]}],["bold","italic","underline","link"],[{list:"ordered"},{list:"bullet"}],["clean"]],g=function(t){function e(t,n){d(this,e),null!=n.modules.toolbar&&null==n.modules.toolbar.container&&(n.modules.toolbar.container=b);var r=y(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.container.classList.add("ql-snow"),r}return v(e,t),i(e,[{key:"extendToolbar",value:function(t){t.container.classList.add("ql-snow"),this.buildButtons([].slice.call(t.container.querySelectorAll("button")),h.default),this.buildPickers([].slice.call(t.container.querySelectorAll("select")),h.default),this.tooltip=new m(this.quill,this.options.bounds),t.container.querySelector(".ql-link")&&this.quill.keyboard.addBinding({key:"K",shortKey:!0},(function(e,n){t.handlers.link.call(t,!n.format.link)}))}}]),e}(u.default);g.DEFAULTS=(0,l.default)(!0,{},u.default.DEFAULTS,{modules:{toolbar:{handlers:{link:function(t){if(t){var e=this.quill.getSelection();if(null==e||0==e.length)return;var n=this.quill.getText(e);/^\S+@\S+\.\S+$/.test(n)&&0!==n.indexOf("mailto:")&&(n="mailto:"+n),this.quill.theme.tooltip.edit("link",n)}else this.quill.format("link",!1)}}}}});var m=function(t){function e(t,n){d(this,e);var r=y(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.preview=r.root.querySelector("a.ql-preview"),r}return v(e,t),i(e,[{key:"listen",value:function(){var t=this;o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"listen",this).call(this),this.root.querySelector("a.ql-action").addEventListener("click",(function(e){t.root.classList.contains("ql-editing")?t.save():t.edit("link",t.preview.textContent),e.preventDefault()})),this.root.querySelector("a.ql-remove").addEventListener("click",(function(e){if(null!=t.linkRange){var n=t.linkRange;t.restoreFocus(),t.quill.formatText(n,"link",!1,a.default.sources.USER),delete t.linkRange}e.preventDefault(),t.hide()})),this.quill.on(a.default.events.SELECTION_CHANGE,(function(e,n,o){if(null!=e){if(0===e.length&&o===a.default.sources.USER){var i=t.quill.scroll.descendant(c.default,e.index),l=r(i,2),s=l[0],u=l[1];if(null!=s){t.linkRange=new f.Range(e.index-u,s.length());var h=c.default.formats(s.domNode);return t.preview.textContent=h,t.preview.setAttribute("href",h),t.show(),void t.position(t.quill.getBounds(t.linkRange))}}else delete t.linkRange;t.hide()}}))}},{key:"show",value:function(){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"show",this).call(this),this.root.removeAttribute("data-mode")}}]),e}(s.BaseTooltip);m.TEMPLATE=['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>','<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">','<a class="ql-action"></a>','<a class="ql-remove"></a>'].join(""),e.default=g},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=R(n(29)),o=n(36),i=n(38),l=n(64),a=R(n(65)),s=R(n(66)),u=n(67),c=R(u),f=n(37),h=n(26),p=n(39),d=n(40),y=R(n(56)),v=R(n(68)),b=R(n(27)),g=R(n(69)),m=R(n(70)),_=R(n(71)),O=R(n(72)),w=R(n(73)),x=n(13),E=R(x),k=R(n(74)),A=R(n(75)),N=R(n(57)),j=R(n(41)),T=R(n(28)),P=R(n(59)),S=R(n(60)),q=R(n(61)),C=R(n(108)),L=R(n(62));function R(t){return t&&t.__esModule?t:{default:t}}r.default.register({"attributors/attribute/direction":i.DirectionAttribute,"attributors/class/align":o.AlignClass,"attributors/class/background":f.BackgroundClass,"attributors/class/color":h.ColorClass,"attributors/class/direction":i.DirectionClass,"attributors/class/font":p.FontClass,"attributors/class/size":d.SizeClass,"attributors/style/align":o.AlignStyle,"attributors/style/background":f.BackgroundStyle,"attributors/style/color":h.ColorStyle,"attributors/style/direction":i.DirectionStyle,"attributors/style/font":p.FontStyle,"attributors/style/size":d.SizeStyle},!0),r.default.register({"formats/align":o.AlignClass,"formats/direction":i.DirectionClass,"formats/indent":l.IndentClass,"formats/background":f.BackgroundStyle,"formats/color":h.ColorStyle,"formats/font":p.FontClass,"formats/size":d.SizeClass,"formats/blockquote":a.default,"formats/code-block":E.default,"formats/header":s.default,"formats/list":c.default,"formats/bold":y.default,"formats/code":x.Code,"formats/italic":v.default,"formats/link":b.default,"formats/script":g.default,"formats/strike":m.default,"formats/underline":_.default,"formats/image":O.default,"formats/video":w.default,"formats/list/item":u.ListItem,"modules/formula":k.default,"modules/syntax":A.default,"modules/toolbar":N.default,"themes/bubble":C.default,"themes/snow":L.default,"ui/icons":j.default,"ui/picker":T.default,"ui/icon-picker":S.default,"ui/color-picker":P.default,"ui/tooltip":q.default},!0),e.default=r.default},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.IndentClass=void 0;var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=n(0),a=(r=l)&&r.__esModule?r:{default:r};function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var c=new(function(t){function e(){return s(this,e),u(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"add",value:function(t,n){if("+1"===n||"-1"===n){var r=this.value(t)||0;n="+1"===n?r+1:r-1}return 0===n?(this.remove(t),!0):i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"add",this).call(this,t,n)}},{key:"canAdd",value:function(t,n){return i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"canAdd",this).call(this,t,n)||i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"canAdd",this).call(this,t,parseInt(n))}},{key:"value",value:function(t){return parseInt(i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t))||void 0}}]),e}(a.default.Attributor.Class))("indent","ql-indent",{scope:a.default.Scope.BLOCK,whitelist:[1,2,3,4,5,6,7,8]});e.IndentClass=c},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=n(4);function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var a=function(t){function e(){return i(this,e),l(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(((r=o)&&r.__esModule?r:{default:r}).default);a.blotName="blockquote",a.tagName="blockquote",e.default=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=n(4);function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var s=function(t){function e(){return l(this,e),a(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,null,[{key:"formats",value:function(t){return this.tagName.indexOf(t.tagName)+1}}]),e}(((r=i)&&r.__esModule?r:{default:r}).default);s.blotName="header",s.tagName=["H1","H2","H3","H4","H5","H6"],e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.ListItem=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=s(n(0)),l=s(n(4)),a=s(n(25));function s(t){return t&&t.__esModule?t:{default:t}}function u(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function c(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function f(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var h=function(t){function e(){return u(this,e),c(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return f(e,t),r(e,[{key:"format",value:function(t,n){t!==p.blotName||n?o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n):this.replaceWith(i.default.create(this.statics.scope))}},{key:"remove",value:function(){null==this.prev&&null==this.next?this.parent.remove():o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"remove",this).call(this)}},{key:"replaceWith",value:function(t,n){return this.parent.isolate(this.offset(this.parent),this.length()),t===this.parent.statics.blotName?(this.parent.replaceWith(t,n),this):(this.parent.unwrap(),o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replaceWith",this).call(this,t,n))}}],[{key:"formats",value:function(t){return t.tagName===this.tagName?void 0:o(e.__proto__||Object.getPrototypeOf(e),"formats",this).call(this,t)}}]),e}(l.default);h.blotName="list-item",h.tagName="LI";var p=function(t){function e(t){u(this,e);var n=c(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t)),r=function(e){if(e.target.parentNode===t){var r=n.statics.formats(t),o=i.default.find(e.target);"checked"===r?o.format("list","unchecked"):"unchecked"===r&&o.format("list","checked")}};return t.addEventListener("touchstart",r),t.addEventListener("mousedown",r),n}return f(e,t),r(e,null,[{key:"create",value:function(t){var n="ordered"===t?"OL":"UL",r=o(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,n);return"checked"!==t&&"unchecked"!==t||r.setAttribute("data-checked","checked"===t),r}},{key:"formats",value:function(t){return"OL"===t.tagName?"ordered":"UL"===t.tagName?t.hasAttribute("data-checked")?"true"===t.getAttribute("data-checked")?"checked":"unchecked":"bullet":void 0}}]),r(e,[{key:"format",value:function(t,e){this.children.length>0&&this.children.tail.format(t,e)}},{key:"formats",value:function(){return t={},e=this.statics.blotName,n=this.statics.formats(this.domNode),e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t;var t,e,n}},{key:"insertBefore",value:function(t,n){if(t instanceof h)o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n);else{var r=null==n?this.length():n.offset(this),i=this.split(r);i.parent.insertBefore(t,i)}}},{key:"optimize",value:function(t){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t);var n=this.next;null!=n&&n.prev===this&&n.statics.blotName===this.statics.blotName&&n.domNode.tagName===this.domNode.tagName&&n.domNode.getAttribute("data-checked")===this.domNode.getAttribute("data-checked")&&(n.moveChildren(this),n.remove())}},{key:"replace",value:function(t){if(t.statics.blotName!==this.statics.blotName){var n=i.default.create(this.statics.defaultChild);t.moveChildren(n),this.appendChild(n)}o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replace",this).call(this,t)}}]),e}(a.default);p.blotName="list",p.scope=i.default.Scope.BLOCK_BLOT,p.tagName=["OL","UL"],p.defaultChild="list-item",p.allowedChildren=[h],e.ListItem=h,e.default=p},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=n(56);function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var a=function(t){function e(){return i(this,e),l(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(((r=o)&&r.__esModule?r:{default:r}).default);a.blotName="italic",a.tagName=["EM","I"],e.default=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=n(6);function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var s=function(t){function e(){return l(this,e),a(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,null,[{key:"create",value:function(t){return"super"===t?document.createElement("sup"):"sub"===t?document.createElement("sub"):function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0}(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t)}},{key:"formats",value:function(t){return"SUB"===t.tagName?"sub":"SUP"===t.tagName?"super":void 0}}]),e}(((r=i)&&r.__esModule?r:{default:r}).default);s.blotName="script",s.tagName=["SUB","SUP"],e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=n(6);function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var a=function(t){function e(){return i(this,e),l(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(((r=o)&&r.__esModule?r:{default:r}).default);a.blotName="strike",a.tagName="S",e.default=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=n(6);function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var a=function(t){function e(){return i(this,e),l(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(((r=o)&&r.__esModule?r:{default:r}).default);a.blotName="underline",a.tagName="U",e.default=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=n(0),a=(r=l)&&r.__esModule?r:{default:r},s=n(27);function u(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function c(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var f=["alt","height","width"],h=function(t){function e(){return u(this,e),c(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"format",value:function(t,n){f.indexOf(t)>-1?n?this.domNode.setAttribute(t,n):this.domNode.removeAttribute(t):i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}],[{key:"create",value:function(t){var n=i(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return"string"==typeof t&&n.setAttribute("src",this.sanitize(t)),n}},{key:"formats",value:function(t){return f.reduce((function(e,n){return t.hasAttribute(n)&&(e[n]=t.getAttribute(n)),e}),{})}},{key:"match",value:function(t){return/\.(jpe?g|gif|png)$/.test(t)||/^data:image\/.+;base64/.test(t)}},{key:"sanitize",value:function(t){return(0,s.sanitize)(t,["http","https","data"])?t:"//:0"}},{key:"value",value:function(t){return t.getAttribute("src")}}]),e}(a.default.Embed);h.blotName="image",h.tagName="IMG",e.default=h},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=n(4),a=n(27),s=(r=a)&&r.__esModule?r:{default:r};function u(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function c(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var f=["height","width"],h=function(t){function e(){return u(this,e),c(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"format",value:function(t,n){f.indexOf(t)>-1?n?this.domNode.setAttribute(t,n):this.domNode.removeAttribute(t):i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}],[{key:"create",value:function(t){var n=i(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return n.setAttribute("frameborder","0"),n.setAttribute("allowfullscreen",!0),n.setAttribute("src",this.sanitize(t)),n}},{key:"formats",value:function(t){return f.reduce((function(e,n){return t.hasAttribute(n)&&(e[n]=t.getAttribute(n)),e}),{})}},{key:"sanitize",value:function(t){return s.default.sanitize(t)}},{key:"value",value:function(t){return t.getAttribute("src")}}]),e}(l.BlockEmbed);h.blotName="video",h.className="ql-video",h.tagName="IFRAME",e.default=h},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.FormulaBlot=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=a(n(35)),i=a(n(5)),l=a(n(9));function a(t){return t&&t.__esModule?t:{default:t}}function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function c(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var f=function(t){function e(){return s(this,e),u(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return c(e,t),r(e,null,[{key:"create",value:function(t){var n=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0}(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return"string"==typeof t&&(window.katex.render(t,n,{throwOnError:!1,errorColor:"#f00"}),n.setAttribute("data-value",t)),n}},{key:"value",value:function(t){return t.getAttribute("data-value")}}]),e}(o.default);f.blotName="formula",f.className="ql-formula",f.tagName="SPAN";var h=function(t){function e(){s(this,e);var t=u(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));if(null==window.katex)throw new Error("Formula module requires KaTeX.");return t}return c(e,t),r(e,null,[{key:"register",value:function(){i.default.register(f,!0)}}]),e}(l.default);e.FormulaBlot=f,e.default=h},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.CodeToken=e.CodeBlock=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=a(n(0)),i=a(n(5)),l=a(n(9));function a(t){return t&&t.__esModule?t:{default:t}}function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function c(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var f=function(t){function e(){return s(this,e),u(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return c(e,t),r(e,[{key:"replaceWith",value:function(t){this.domNode.textContent=this.domNode.textContent,this.attach(),function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0}(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replaceWith",this).call(this,t)}},{key:"highlight",value:function(t){var e=this.domNode.textContent;this.cachedText!==e&&((e.trim().length>0||null==this.cachedText)&&(this.domNode.innerHTML=t(e),this.domNode.normalize(),this.attach()),this.cachedText=e)}}]),e}(a(n(13)).default);f.className="ql-syntax";var h=new o.default.Attributor.Class("token","hljs",{scope:o.default.Scope.INLINE}),p=function(t){function e(t,n){s(this,e);var r=u(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));if("function"!=typeof r.options.highlight)throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");var o=null;return r.quill.on(i.default.events.SCROLL_OPTIMIZE,(function(){clearTimeout(o),o=setTimeout((function(){r.highlight(),o=null}),r.options.interval)})),r.highlight(),r}return c(e,t),r(e,null,[{key:"register",value:function(){i.default.register(h,!0),i.default.register(f,!0)}}]),r(e,[{key:"highlight",value:function(){var t=this;if(!this.quill.selection.composing){this.quill.update(i.default.sources.USER);var e=this.quill.getSelection();this.quill.scroll.descendants(f).forEach((function(e){e.highlight(t.options.highlight)})),this.quill.update(i.default.sources.SILENT),null!=e&&this.quill.setSelection(e,i.default.sources.SILENT)}}}]),e}(l.default);p.DEFAULTS={highlight:null==window.hljs?null:function(t){return window.hljs.highlightAuto(t).value},interval:1e3},e.CodeBlock=f,e.CodeToken=h,e.default=p},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>'},function(t,e){t.exports='<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>'},function(t,e){t.exports='<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>'},function(t,e){t.exports='<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>'},function(t,e){t.exports='<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BubbleTooltip=void 0;var r=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=f(n(3)),l=f(n(8)),a=n(43),s=f(a),u=n(15),c=f(n(41));function f(t){return t&&t.__esModule?t:{default:t}}function h(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function p(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function d(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var y=[["bold","italic","link"],[{header:1},{header:2},"blockquote"]],v=function(t){function e(t,n){h(this,e),null!=n.modules.toolbar&&null==n.modules.toolbar.container&&(n.modules.toolbar.container=y);var r=p(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.container.classList.add("ql-bubble"),r}return d(e,t),o(e,[{key:"extendToolbar",value:function(t){this.tooltip=new b(this.quill,this.options.bounds),this.tooltip.root.appendChild(t.container),this.buildButtons([].slice.call(t.container.querySelectorAll("button")),c.default),this.buildPickers([].slice.call(t.container.querySelectorAll("select")),c.default)}}]),e}(s.default);v.DEFAULTS=(0,i.default)(!0,{},s.default.DEFAULTS,{modules:{toolbar:{handlers:{link:function(t){t?this.quill.theme.tooltip.edit():this.quill.format("link",!1)}}}}});var b=function(t){function e(t,n){h(this,e);var r=p(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.on(l.default.events.EDITOR_CHANGE,(function(t,e,n,o){if(t===l.default.events.SELECTION_CHANGE)if(null!=e&&e.length>0&&o===l.default.sources.USER){r.show(),r.root.style.left="0px",r.root.style.width="",r.root.style.width=r.root.offsetWidth+"px";var i=r.quill.getLines(e.index,e.length);if(1===i.length)r.position(r.quill.getBounds(e));else{var a=i[i.length-1],s=r.quill.getIndex(a),c=Math.min(a.length()-1,e.index+e.length-s),f=r.quill.getBounds(new u.Range(s,c));r.position(f)}}else document.activeElement!==r.textbox&&r.quill.hasFocus()&&r.hide()})),r}return d(e,t),o(e,[{key:"listen",value:function(){var t=this;r(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"listen",this).call(this),this.root.querySelector(".ql-close").addEventListener("click",(function(){t.root.classList.remove("ql-editing")})),this.quill.on(l.default.events.SCROLL_OPTIMIZE,(function(){setTimeout((function(){if(!t.root.classList.contains("ql-hidden")){var e=t.quill.getSelection();null!=e&&t.position(t.quill.getBounds(e))}}),1)}))}},{key:"cancel",value:function(){this.show()}},{key:"position",value:function(t){var n=r(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"position",this).call(this,t),o=this.root.querySelector(".ql-tooltip-arrow");if(o.style.marginLeft="",0===n)return n;o.style.marginLeft=-1*n-o.offsetWidth/2+"px"}}]),e}(a.BaseTooltip);b.TEMPLATE=['<span class="ql-tooltip-arrow"></span>','<div class="ql-tooltip-editor">','<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">','<a class="ql-close"></a>',"</div>"].join(""),e.BubbleTooltip=b,e.default=v},function(t,e,n){t.exports=n(63)}]).default},t.exports=n()}).call(this,n(8).Buffer)},function(t,e,n){"use strict";(function(t){var r=n(10),o=n(11),i=n(12);function l(){return s.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function a(t,e){if(l()<e)throw new RangeError("Invalid typed array length");return s.TYPED_ARRAY_SUPPORT?(t=new Uint8Array(e)).__proto__=s.prototype:(null===t&&(t=new s(e)),t.length=e),t}function s(t,e,n){if(!(s.TYPED_ARRAY_SUPPORT||this instanceof s))return new s(t,e,n);if("number"==typeof t){if("string"==typeof e)throw new Error("If encoding is specified then the first argument must be a string");return f(this,t)}return u(this,t,e,n)}function u(t,e,n,r){if("number"==typeof e)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer?function(t,e,n,r){if(e.byteLength,n<0||e.byteLength<n)throw new RangeError("'offset' is out of bounds");if(e.byteLength<n+(r||0))throw new RangeError("'length' is out of bounds");e=void 0===n&&void 0===r?new Uint8Array(e):void 0===r?new Uint8Array(e,n):new Uint8Array(e,n,r);s.TYPED_ARRAY_SUPPORT?(t=e).__proto__=s.prototype:t=h(t,e);return t}(t,e,n,r):"string"==typeof e?function(t,e,n){"string"==typeof n&&""!==n||(n="utf8");if(!s.isEncoding(n))throw new TypeError('"encoding" must be a valid string encoding');var r=0|d(e,n),o=(t=a(t,r)).write(e,n);o!==r&&(t=t.slice(0,o));return t}(t,e,n):function(t,e){if(s.isBuffer(e)){var n=0|p(e.length);return 0===(t=a(t,n)).length||e.copy(t,0,0,n),t}if(e){if("undefined"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||"length"in e)return"number"!=typeof e.length||(r=e.length)!=r?a(t,0):h(t,e);if("Buffer"===e.type&&i(e.data))return h(t,e.data)}var r;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(t,e)}function c(t){if("number"!=typeof t)throw new TypeError('"size" argument must be a number');if(t<0)throw new RangeError('"size" argument must not be negative')}function f(t,e){if(c(e),t=a(t,e<0?0:0|p(e)),!s.TYPED_ARRAY_SUPPORT)for(var n=0;n<e;++n)t[n]=0;return t}function h(t,e){var n=e.length<0?0:0|p(e.length);t=a(t,n);for(var r=0;r<n;r+=1)t[r]=255&e[r];return t}function p(t){if(t>=l())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+l().toString(16)+" bytes");return 0|t}function d(t,e){if(s.isBuffer(t))return t.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer))return t.byteLength;"string"!=typeof t&&(t=""+t);var n=t.length;if(0===n)return 0;for(var r=!1;;)switch(e){case"ascii":case"latin1":case"binary":return n;case"utf8":case"utf-8":case void 0:return U(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*n;case"hex":return n>>>1;case"base64":return F(t).length;default:if(r)return U(t).length;e=(""+e).toLowerCase(),r=!0}}function y(t,e,n){var r=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return"";if((n>>>=0)<=(e>>>=0))return"";for(t||(t="utf8");;)switch(t){case"hex":return T(this,e,n);case"utf8":case"utf-8":return A(this,e,n);case"ascii":return N(this,e,n);case"latin1":case"binary":return j(this,e,n);case"base64":return k(this,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return P(this,e,n);default:if(r)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),r=!0}}function v(t,e,n){var r=t[e];t[e]=t[n],t[n]=r}function b(t,e,n,r,o){if(0===t.length)return-1;if("string"==typeof n?(r=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),n=+n,isNaN(n)&&(n=o?0:t.length-1),n<0&&(n=t.length+n),n>=t.length){if(o)return-1;n=t.length-1}else if(n<0){if(!o)return-1;n=0}if("string"==typeof e&&(e=s.from(e,r)),s.isBuffer(e))return 0===e.length?-1:g(t,e,n,r,o);if("number"==typeof e)return e&=255,s.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?o?Uint8Array.prototype.indexOf.call(t,e,n):Uint8Array.prototype.lastIndexOf.call(t,e,n):g(t,[e],n,r,o);throw new TypeError("val must be string, number or Buffer")}function g(t,e,n,r,o){var i,l=1,a=t.length,s=e.length;if(void 0!==r&&("ucs2"===(r=String(r).toLowerCase())||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(t.length<2||e.length<2)return-1;l=2,a/=2,s/=2,n/=2}function u(t,e){return 1===l?t[e]:t.readUInt16BE(e*l)}if(o){var c=-1;for(i=n;i<a;i++)if(u(t,i)===u(e,-1===c?0:i-c)){if(-1===c&&(c=i),i-c+1===s)return c*l}else-1!==c&&(i-=i-c),c=-1}else for(n+s>a&&(n=a-s),i=n;i>=0;i--){for(var f=!0,h=0;h<s;h++)if(u(t,i+h)!==u(e,h)){f=!1;break}if(f)return i}return-1}function m(t,e,n,r){n=Number(n)||0;var o=t.length-n;r?(r=Number(r))>o&&(r=o):r=o;var i=e.length;if(i%2!=0)throw new TypeError("Invalid hex string");r>i/2&&(r=i/2);for(var l=0;l<r;++l){var a=parseInt(e.substr(2*l,2),16);if(isNaN(a))return l;t[n+l]=a}return l}function _(t,e,n,r){return H(U(e,t.length-n),t,n,r)}function O(t,e,n,r){return H(function(t){for(var e=[],n=0;n<t.length;++n)e.push(255&t.charCodeAt(n));return e}(e),t,n,r)}function w(t,e,n,r){return O(t,e,n,r)}function x(t,e,n,r){return H(F(e),t,n,r)}function E(t,e,n,r){return H(function(t,e){for(var n,r,o,i=[],l=0;l<t.length&&!((e-=2)<0);++l)n=t.charCodeAt(l),r=n>>8,o=n%256,i.push(o),i.push(r);return i}(e,t.length-n),t,n,r)}function k(t,e,n){return 0===e&&n===t.length?r.fromByteArray(t):r.fromByteArray(t.slice(e,n))}function A(t,e,n){n=Math.min(t.length,n);for(var r=[],o=e;o<n;){var i,l,a,s,u=t[o],c=null,f=u>239?4:u>223?3:u>191?2:1;if(o+f<=n)switch(f){case 1:u<128&&(c=u);break;case 2:128==(192&(i=t[o+1]))&&(s=(31&u)<<6|63&i)>127&&(c=s);break;case 3:i=t[o+1],l=t[o+2],128==(192&i)&&128==(192&l)&&(s=(15&u)<<12|(63&i)<<6|63&l)>2047&&(s<55296||s>57343)&&(c=s);break;case 4:i=t[o+1],l=t[o+2],a=t[o+3],128==(192&i)&&128==(192&l)&&128==(192&a)&&(s=(15&u)<<18|(63&i)<<12|(63&l)<<6|63&a)>65535&&s<1114112&&(c=s)}null===c?(c=65533,f=1):c>65535&&(c-=65536,r.push(c>>>10&1023|55296),c=56320|1023&c),r.push(c),o+=f}return function(t){var e=t.length;if(e<=4096)return String.fromCharCode.apply(String,t);var n="",r=0;for(;r<e;)n+=String.fromCharCode.apply(String,t.slice(r,r+=4096));return n}(r)}e.Buffer=s,e.SlowBuffer=function(t){+t!=t&&(t=0);return s.alloc(+t)},e.INSPECT_MAX_BYTES=50,s.TYPED_ARRAY_SUPPORT=void 0!==t.TYPED_ARRAY_SUPPORT?t.TYPED_ARRAY_SUPPORT:function(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()&&"function"==typeof t.subarray&&0===t.subarray(1,1).byteLength}catch(t){return!1}}(),e.kMaxLength=l(),s.poolSize=8192,s._augment=function(t){return t.__proto__=s.prototype,t},s.from=function(t,e,n){return u(null,t,e,n)},s.TYPED_ARRAY_SUPPORT&&(s.prototype.__proto__=Uint8Array.prototype,s.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&s[Symbol.species]===s&&Object.defineProperty(s,Symbol.species,{value:null,configurable:!0})),s.alloc=function(t,e,n){return function(t,e,n,r){return c(e),e<=0?a(t,e):void 0!==n?"string"==typeof r?a(t,e).fill(n,r):a(t,e).fill(n):a(t,e)}(null,t,e,n)},s.allocUnsafe=function(t){return f(null,t)},s.allocUnsafeSlow=function(t){return f(null,t)},s.isBuffer=function(t){return!(null==t||!t._isBuffer)},s.compare=function(t,e){if(!s.isBuffer(t)||!s.isBuffer(e))throw new TypeError("Arguments must be Buffers");if(t===e)return 0;for(var n=t.length,r=e.length,o=0,i=Math.min(n,r);o<i;++o)if(t[o]!==e[o]){n=t[o],r=e[o];break}return n<r?-1:r<n?1:0},s.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},s.concat=function(t,e){if(!i(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return s.alloc(0);var n;if(void 0===e)for(e=0,n=0;n<t.length;++n)e+=t[n].length;var r=s.allocUnsafe(e),o=0;for(n=0;n<t.length;++n){var l=t[n];if(!s.isBuffer(l))throw new TypeError('"list" argument must be an Array of Buffers');l.copy(r,o),o+=l.length}return r},s.byteLength=d,s.prototype._isBuffer=!0,s.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;e<t;e+=2)v(this,e,e+1);return this},s.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;e<t;e+=4)v(this,e,e+3),v(this,e+1,e+2);return this},s.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;e<t;e+=8)v(this,e,e+7),v(this,e+1,e+6),v(this,e+2,e+5),v(this,e+3,e+4);return this},s.prototype.toString=function(){var t=0|this.length;return 0===t?"":0===arguments.length?A(this,0,t):y.apply(this,arguments)},s.prototype.equals=function(t){if(!s.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t||0===s.compare(this,t)},s.prototype.inspect=function(){var t="",n=e.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString("hex",0,n).match(/.{2}/g).join(" "),this.length>n&&(t+=" ... ")),"<Buffer "+t+">"},s.prototype.compare=function(t,e,n,r,o){if(!s.isBuffer(t))throw new TypeError("Argument must be a Buffer");if(void 0===e&&(e=0),void 0===n&&(n=t?t.length:0),void 0===r&&(r=0),void 0===o&&(o=this.length),e<0||n>t.length||r<0||o>this.length)throw new RangeError("out of range index");if(r>=o&&e>=n)return 0;if(r>=o)return-1;if(e>=n)return 1;if(this===t)return 0;for(var i=(o>>>=0)-(r>>>=0),l=(n>>>=0)-(e>>>=0),a=Math.min(i,l),u=this.slice(r,o),c=t.slice(e,n),f=0;f<a;++f)if(u[f]!==c[f]){i=u[f],l=c[f];break}return i<l?-1:l<i?1:0},s.prototype.includes=function(t,e,n){return-1!==this.indexOf(t,e,n)},s.prototype.indexOf=function(t,e,n){return b(this,t,e,n,!0)},s.prototype.lastIndexOf=function(t,e,n){return b(this,t,e,n,!1)},s.prototype.write=function(t,e,n,r){if(void 0===e)r="utf8",n=this.length,e=0;else if(void 0===n&&"string"==typeof e)r=e,n=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e|=0,isFinite(n)?(n|=0,void 0===r&&(r="utf8")):(r=n,n=void 0)}var o=this.length-e;if((void 0===n||n>o)&&(n=o),t.length>0&&(n<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var i=!1;;)switch(r){case"hex":return m(this,t,e,n);case"utf8":case"utf-8":return _(this,t,e,n);case"ascii":return O(this,t,e,n);case"latin1":case"binary":return w(this,t,e,n);case"base64":return x(this,t,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return E(this,t,e,n);default:if(i)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),i=!0}},s.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function N(t,e,n){var r="";n=Math.min(t.length,n);for(var o=e;o<n;++o)r+=String.fromCharCode(127&t[o]);return r}function j(t,e,n){var r="";n=Math.min(t.length,n);for(var o=e;o<n;++o)r+=String.fromCharCode(t[o]);return r}function T(t,e,n){var r=t.length;(!e||e<0)&&(e=0),(!n||n<0||n>r)&&(n=r);for(var o="",i=e;i<n;++i)o+=D(t[i]);return o}function P(t,e,n){for(var r=t.slice(e,n),o="",i=0;i<r.length;i+=2)o+=String.fromCharCode(r[i]+256*r[i+1]);return o}function S(t,e,n){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+e>n)throw new RangeError("Trying to access beyond buffer length")}function q(t,e,n,r,o,i){if(!s.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>o||e<i)throw new RangeError('"value" argument is out of bounds');if(n+r>t.length)throw new RangeError("Index out of range")}function C(t,e,n,r){e<0&&(e=65535+e+1);for(var o=0,i=Math.min(t.length-n,2);o<i;++o)t[n+o]=(e&255<<8*(r?o:1-o))>>>8*(r?o:1-o)}function L(t,e,n,r){e<0&&(e=4294967295+e+1);for(var o=0,i=Math.min(t.length-n,4);o<i;++o)t[n+o]=e>>>8*(r?o:3-o)&255}function R(t,e,n,r,o,i){if(n+r>t.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("Index out of range")}function M(t,e,n,r,i){return i||R(t,0,n,4),o.write(t,e,n,r,23,4),n+4}function I(t,e,n,r,i){return i||R(t,0,n,8),o.write(t,e,n,r,52,8),n+8}s.prototype.slice=function(t,e){var n,r=this.length;if((t=~~t)<0?(t+=r)<0&&(t=0):t>r&&(t=r),(e=void 0===e?r:~~e)<0?(e+=r)<0&&(e=0):e>r&&(e=r),e<t&&(e=t),s.TYPED_ARRAY_SUPPORT)(n=this.subarray(t,e)).__proto__=s.prototype;else{var o=e-t;n=new s(o,void 0);for(var i=0;i<o;++i)n[i]=this[i+t]}return n},s.prototype.readUIntLE=function(t,e,n){t|=0,e|=0,n||S(t,e,this.length);for(var r=this[t],o=1,i=0;++i<e&&(o*=256);)r+=this[t+i]*o;return r},s.prototype.readUIntBE=function(t,e,n){t|=0,e|=0,n||S(t,e,this.length);for(var r=this[t+--e],o=1;e>0&&(o*=256);)r+=this[t+--e]*o;return r},s.prototype.readUInt8=function(t,e){return e||S(t,1,this.length),this[t]},s.prototype.readUInt16LE=function(t,e){return e||S(t,2,this.length),this[t]|this[t+1]<<8},s.prototype.readUInt16BE=function(t,e){return e||S(t,2,this.length),this[t]<<8|this[t+1]},s.prototype.readUInt32LE=function(t,e){return e||S(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},s.prototype.readUInt32BE=function(t,e){return e||S(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},s.prototype.readIntLE=function(t,e,n){t|=0,e|=0,n||S(t,e,this.length);for(var r=this[t],o=1,i=0;++i<e&&(o*=256);)r+=this[t+i]*o;return r>=(o*=128)&&(r-=Math.pow(2,8*e)),r},s.prototype.readIntBE=function(t,e,n){t|=0,e|=0,n||S(t,e,this.length);for(var r=e,o=1,i=this[t+--r];r>0&&(o*=256);)i+=this[t+--r]*o;return i>=(o*=128)&&(i-=Math.pow(2,8*e)),i},s.prototype.readInt8=function(t,e){return e||S(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},s.prototype.readInt16LE=function(t,e){e||S(t,2,this.length);var n=this[t]|this[t+1]<<8;return 32768&n?4294901760|n:n},s.prototype.readInt16BE=function(t,e){e||S(t,2,this.length);var n=this[t+1]|this[t]<<8;return 32768&n?4294901760|n:n},s.prototype.readInt32LE=function(t,e){return e||S(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},s.prototype.readInt32BE=function(t,e){return e||S(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},s.prototype.readFloatLE=function(t,e){return e||S(t,4,this.length),o.read(this,t,!0,23,4)},s.prototype.readFloatBE=function(t,e){return e||S(t,4,this.length),o.read(this,t,!1,23,4)},s.prototype.readDoubleLE=function(t,e){return e||S(t,8,this.length),o.read(this,t,!0,52,8)},s.prototype.readDoubleBE=function(t,e){return e||S(t,8,this.length),o.read(this,t,!1,52,8)},s.prototype.writeUIntLE=function(t,e,n,r){(t=+t,e|=0,n|=0,r)||q(this,t,e,n,Math.pow(2,8*n)-1,0);var o=1,i=0;for(this[e]=255&t;++i<n&&(o*=256);)this[e+i]=t/o&255;return e+n},s.prototype.writeUIntBE=function(t,e,n,r){(t=+t,e|=0,n|=0,r)||q(this,t,e,n,Math.pow(2,8*n)-1,0);var o=n-1,i=1;for(this[e+o]=255&t;--o>=0&&(i*=256);)this[e+o]=t/i&255;return e+n},s.prototype.writeUInt8=function(t,e,n){return t=+t,e|=0,n||q(this,t,e,1,255,0),s.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),this[e]=255&t,e+1},s.prototype.writeUInt16LE=function(t,e,n){return t=+t,e|=0,n||q(this,t,e,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):C(this,t,e,!0),e+2},s.prototype.writeUInt16BE=function(t,e,n){return t=+t,e|=0,n||q(this,t,e,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):C(this,t,e,!1),e+2},s.prototype.writeUInt32LE=function(t,e,n){return t=+t,e|=0,n||q(this,t,e,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t):L(this,t,e,!0),e+4},s.prototype.writeUInt32BE=function(t,e,n){return t=+t,e|=0,n||q(this,t,e,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):L(this,t,e,!1),e+4},s.prototype.writeIntLE=function(t,e,n,r){if(t=+t,e|=0,!r){var o=Math.pow(2,8*n-1);q(this,t,e,n,o-1,-o)}var i=0,l=1,a=0;for(this[e]=255&t;++i<n&&(l*=256);)t<0&&0===a&&0!==this[e+i-1]&&(a=1),this[e+i]=(t/l>>0)-a&255;return e+n},s.prototype.writeIntBE=function(t,e,n,r){if(t=+t,e|=0,!r){var o=Math.pow(2,8*n-1);q(this,t,e,n,o-1,-o)}var i=n-1,l=1,a=0;for(this[e+i]=255&t;--i>=0&&(l*=256);)t<0&&0===a&&0!==this[e+i+1]&&(a=1),this[e+i]=(t/l>>0)-a&255;return e+n},s.prototype.writeInt8=function(t,e,n){return t=+t,e|=0,n||q(this,t,e,1,127,-128),s.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),t<0&&(t=255+t+1),this[e]=255&t,e+1},s.prototype.writeInt16LE=function(t,e,n){return t=+t,e|=0,n||q(this,t,e,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):C(this,t,e,!0),e+2},s.prototype.writeInt16BE=function(t,e,n){return t=+t,e|=0,n||q(this,t,e,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):C(this,t,e,!1),e+2},s.prototype.writeInt32LE=function(t,e,n){return t=+t,e|=0,n||q(this,t,e,4,2147483647,-2147483648),s.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24):L(this,t,e,!0),e+4},s.prototype.writeInt32BE=function(t,e,n){return t=+t,e|=0,n||q(this,t,e,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),s.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):L(this,t,e,!1),e+4},s.prototype.writeFloatLE=function(t,e,n){return M(this,t,e,!0,n)},s.prototype.writeFloatBE=function(t,e,n){return M(this,t,e,!1,n)},s.prototype.writeDoubleLE=function(t,e,n){return I(this,t,e,!0,n)},s.prototype.writeDoubleBE=function(t,e,n){return I(this,t,e,!1,n)},s.prototype.copy=function(t,e,n,r){if(n||(n=0),r||0===r||(r=this.length),e>=t.length&&(e=t.length),e||(e=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===t.length||0===this.length)return 0;if(e<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),t.length-e<r-n&&(r=t.length-e+n);var o,i=r-n;if(this===t&&n<e&&e<r)for(o=i-1;o>=0;--o)t[o+e]=this[o+n];else if(i<1e3||!s.TYPED_ARRAY_SUPPORT)for(o=0;o<i;++o)t[o+e]=this[o+n];else Uint8Array.prototype.set.call(t,this.subarray(n,n+i),e);return i},s.prototype.fill=function(t,e,n,r){if("string"==typeof t){if("string"==typeof e?(r=e,e=0,n=this.length):"string"==typeof n&&(r=n,n=this.length),1===t.length){var o=t.charCodeAt(0);o<256&&(t=o)}if(void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!s.isEncoding(r))throw new TypeError("Unknown encoding: "+r)}else"number"==typeof t&&(t&=255);if(e<0||this.length<e||this.length<n)throw new RangeError("Out of range index");if(n<=e)return this;var i;if(e>>>=0,n=void 0===n?this.length:n>>>0,t||(t=0),"number"==typeof t)for(i=e;i<n;++i)this[i]=t;else{var l=s.isBuffer(t)?t:U(new s(t,r).toString()),a=l.length;for(i=0;i<n-e;++i)this[i+e]=l[i%a]}return this};var B=/[^+\/0-9A-Za-z-_]/g;function D(t){return t<16?"0"+t.toString(16):t.toString(16)}function U(t,e){var n;e=e||1/0;for(var r=t.length,o=null,i=[],l=0;l<r;++l){if((n=t.charCodeAt(l))>55295&&n<57344){if(!o){if(n>56319){(e-=3)>-1&&i.push(239,191,189);continue}if(l+1===r){(e-=3)>-1&&i.push(239,191,189);continue}o=n;continue}if(n<56320){(e-=3)>-1&&i.push(239,191,189),o=n;continue}n=65536+(o-55296<<10|n-56320)}else o&&(e-=3)>-1&&i.push(239,191,189);if(o=null,n<128){if((e-=1)<0)break;i.push(n)}else if(n<2048){if((e-=2)<0)break;i.push(n>>6|192,63&n|128)}else if(n<65536){if((e-=3)<0)break;i.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(n<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;i.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return i}function F(t){return r.toByteArray(function(t){if((t=function(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}(t).replace(B,"")).length<2)return"";for(;t.length%4!=0;)t+="=";return t}(t))}function H(t,e,n,r){for(var o=0;o<r&&!(o+n>=e.length||o>=t.length);++o)e[o+n]=t[o];return o}}).call(this,n(9))},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){"use strict";e.byteLength=function(t){var e=u(t),n=e[0],r=e[1];return 3*(n+r)/4-r},e.toByteArray=function(t){var e,n,r=u(t),l=r[0],a=r[1],s=new i(function(t,e,n){return 3*(e+n)/4-n}(0,l,a)),c=0,f=a>0?l-4:l;for(n=0;n<f;n+=4)e=o[t.charCodeAt(n)]<<18|o[t.charCodeAt(n+1)]<<12|o[t.charCodeAt(n+2)]<<6|o[t.charCodeAt(n+3)],s[c++]=e>>16&255,s[c++]=e>>8&255,s[c++]=255&e;2===a&&(e=o[t.charCodeAt(n)]<<2|o[t.charCodeAt(n+1)]>>4,s[c++]=255&e);1===a&&(e=o[t.charCodeAt(n)]<<10|o[t.charCodeAt(n+1)]<<4|o[t.charCodeAt(n+2)]>>2,s[c++]=e>>8&255,s[c++]=255&e);return s},e.fromByteArray=function(t){for(var e,n=t.length,o=n%3,i=[],l=0,a=n-o;l<a;l+=16383)i.push(c(t,l,l+16383>a?a:l+16383));1===o?(e=t[n-1],i.push(r[e>>2]+r[e<<4&63]+"==")):2===o&&(e=(t[n-2]<<8)+t[n-1],i.push(r[e>>10]+r[e>>4&63]+r[e<<2&63]+"="));return i.join("")};for(var r=[],o=[],i="undefined"!=typeof Uint8Array?Uint8Array:Array,l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",a=0,s=l.length;a<s;++a)r[a]=l[a],o[l.charCodeAt(a)]=a;function u(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var n=t.indexOf("=");return-1===n&&(n=e),[n,n===e?0:4-n%4]}function c(t,e,n){for(var o,i,l=[],a=e;a<n;a+=3)o=(t[a]<<16&16711680)+(t[a+1]<<8&65280)+(255&t[a+2]),l.push(r[(i=o)>>18&63]+r[i>>12&63]+r[i>>6&63]+r[63&i]);return l.join("")}o["-".charCodeAt(0)]=62,o["_".charCodeAt(0)]=63},function(t,e){e.read=function(t,e,n,r,o){var i,l,a=8*o-r-1,s=(1<<a)-1,u=s>>1,c=-7,f=n?o-1:0,h=n?-1:1,p=t[e+f];for(f+=h,i=p&(1<<-c)-1,p>>=-c,c+=a;c>0;i=256*i+t[e+f],f+=h,c-=8);for(l=i&(1<<-c)-1,i>>=-c,c+=r;c>0;l=256*l+t[e+f],f+=h,c-=8);if(0===i)i=1-u;else{if(i===s)return l?NaN:1/0*(p?-1:1);l+=Math.pow(2,r),i-=u}return(p?-1:1)*l*Math.pow(2,i-r)},e.write=function(t,e,n,r,o,i){var l,a,s,u=8*i-o-1,c=(1<<u)-1,f=c>>1,h=23===o?Math.pow(2,-24)-Math.pow(2,-77):0,p=r?0:i-1,d=r?1:-1,y=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,l=c):(l=Math.floor(Math.log(e)/Math.LN2),e*(s=Math.pow(2,-l))<1&&(l--,s*=2),(e+=l+f>=1?h/s:h*Math.pow(2,1-f))*s>=2&&(l++,s/=2),l+f>=c?(a=0,l=c):l+f>=1?(a=(e*s-1)*Math.pow(2,o),l+=f):(a=e*Math.pow(2,f-1)*Math.pow(2,o),l=0));o>=8;t[n+p]=255&a,p+=d,a/=256,o-=8);for(l=l<<o|a,u+=o;u>0;t[n+p]=255&l,p+=d,l/=256,u-=8);t[n+p-d]|=128*y}},function(t,e){var n={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==n.call(t)}},function(t,e,n){"use strict";function r(t){return t.replace(/\s+/g," ").trim()}function o(t){return t.replace(/<br([\s]*[\/]?>)/g,"<p> </p>")}function i(t){return t.replace(/<p><\/p>/g,"<p> </p>")}function l(t){return t.replace(/(<(?!\/)[\w=\."'\s]*>) /g,"$1")}function a(t){return t.replace(/ (<\/[\w]+>)/g,"$1")}function s(t,e){return t.reduce((function(t,e){return e(t)}),e)}Object.defineProperty(e,"__esModule",{value:!0}),e.Compose=e.FixTagSpaceCloseTag=e.FixTagSpaceOpenTag=e.PreserveNewlinesPTags=e.PreserveNewlinesBr=e.ConvertMultipleSpacesToSingle=e.OutputHTMLParser=void 0,e.OutputHTMLParser=function(t){return s([r,l,a,o,i],t)},e.ConvertMultipleSpacesToSingle=r,e.PreserveNewlinesBr=o,e.PreserveNewlinesPTags=i,e.FixTagSpaceOpenTag=l,e.FixTagSpaceCloseTag=a,e.Compose=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.FormatHTMLStringIndentation=void 0,e.FormatHTMLStringIndentation=function(t,e){for(var n=" ".repeat(2),r=0,o=null,i=null,l=null,a="",s=0;s<=t.length;s++){o=i,i=t.substr(s,1),l=t.substr(s+1,1);var u="<br>"===t.substr(s,4),c="<"===i&&"/"!==l&&!u,f="<"===i&&"/"===l&&!u,h=">"===o&&"<"!==i&&r>0,p=!u&&!c&&!f&&h&&""===t.substr(s,t.substr(s).indexOf("<")).trim();u&&(a+="\n",r--,s+=4),c?(a+="\n"+n.repeat(r),r++):f?(--r<0&&(r=0),a+="\n"+n.repeat(r)):(" "===i&&" "===l||"\n"===i&&""===t.substr(s,t.substr(s).indexOf("<")).trim())&&(i=""),h&&!p&&(a+="\n"+n.repeat(r)),a+=i}return e.log("formatHTML",{before:t,after:a}),a}}])}));
	//# sourceMappingURL=quill.htmlEditButton.min.js.map

/***/ },
/* 944 */
/***/ function(module, exports) {

	'use strict';
	
	var rafSchd = function rafSchd(fn) {
	  var lastArgs = [];
	  var frameId = null;
	
	  var wrapperFn = function wrapperFn() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    lastArgs = args;
	
	    if (frameId) {
	      return;
	    }
	
	    frameId = requestAnimationFrame(function () {
	      frameId = null;
	      fn.apply(void 0, lastArgs);
	    });
	  };
	
	  wrapperFn.cancel = function () {
	    if (!frameId) {
	      return;
	    }
	
	    cancelAnimationFrame(frameId);
	    frameId = null;
	  };
	
	  return wrapperFn;
	};
	
	module.exports = rafSchd;


/***/ },
/* 945 */
/***/ function(module, exports) {

	'use strict';
	
	var safeIsNaN = Number.isNaN ||
	    function ponyfill(value) {
	        return typeof value === 'number' && value !== value;
	    };
	function isEqual(first, second) {
	    if (first === second) {
	        return true;
	    }
	    if (safeIsNaN(first) && safeIsNaN(second)) {
	        return true;
	    }
	    return false;
	}
	function areInputsEqual(newInputs, lastInputs) {
	    if (newInputs.length !== lastInputs.length) {
	        return false;
	    }
	    for (var i = 0; i < newInputs.length; i++) {
	        if (!isEqual(newInputs[i], lastInputs[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function memoizeOne(resultFn, isEqual) {
	    if (isEqual === void 0) { isEqual = areInputsEqual; }
	    var lastThis;
	    var lastArgs = [];
	    var lastResult;
	    var calledOnce = false;
	    function memoized() {
	        var newArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            newArgs[_i] = arguments[_i];
	        }
	        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
	            return lastResult;
	        }
	        lastResult = resultFn.apply(this, newArgs);
	        calledOnce = true;
	        lastThis = this;
	        lastArgs = newArgs;
	        return lastResult;
	    }
	    return memoized;
	}
	
	module.exports = memoizeOne;


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 * React Chartkick
	 * Create beautiful JavaScript charts with one line of React
	 * https://github.com/ankane/react-chartkick
	 * v0.4.1
	 * MIT License
	 */
	
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1)) :
		typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
		(global = global || self, factory(global.ReactChartkick = {}, global.React));
	}(this, (function (exports, React) { 'use strict';
	
		React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
	
		var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
		function createCommonjsModule(fn, module) {
			return module = { exports: {} }, fn(module, module.exports), module.exports;
		}
	
		var chartkick = createCommonjsModule(function (module, exports) {
		/*
		 * Chartkick.js
		 * Create beautiful charts with one line of JavaScript
		 * https://github.com/ankane/chartkick.js
		 * v3.2.1
		 * MIT License
		 */
	
		(function (global, factory) {
		   module.exports = factory() ;
		}(commonjsGlobal, (function () {
		  function isArray(variable) {
		    return Object.prototype.toString.call(variable) === "[object Array]";
		  }
	
		  function isFunction(variable) {
		    return variable instanceof Function;
		  }
	
		  function isPlainObject(variable) {
		    // protect against prototype pollution, defense 2
		    return Object.prototype.toString.call(variable) === "[object Object]" && !isFunction(variable) && variable instanceof Object;
		  }
	
		  // https://github.com/madrobby/zepto/blob/master/src/zepto.js
		  function extend(target, source) {
		    var key;
		    for (key in source) {
		      // protect against prototype pollution, defense 1
		      if (key === "__proto__") { continue; }
	
		      if (isPlainObject(source[key]) || isArray(source[key])) {
		        if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
		          target[key] = {};
		        }
		        if (isArray(source[key]) && !isArray(target[key])) {
		          target[key] = [];
		        }
		        extend(target[key], source[key]);
		      } else if (source[key] !== undefined) {
		        target[key] = source[key];
		      }
		    }
		  }
	
		  function merge(obj1, obj2) {
		    var target = {};
		    extend(target, obj1);
		    extend(target, obj2);
		    return target;
		  }
	
		  var DATE_PATTERN = /^(\d\d\d\d)(-)?(\d\d)(-)?(\d\d)$/i;
	
		  // https://github.com/Do/iso8601.js
		  var ISO8601_PATTERN = /(\d\d\d\d)(-)?(\d\d)(-)?(\d\d)(T)?(\d\d)(:)?(\d\d)?(:)?(\d\d)?([.,]\d+)?($|Z|([+-])(\d\d)(:)?(\d\d)?)/i;
		  var DECIMAL_SEPARATOR = String(1.5).charAt(1);
	
		  function parseISO8601(input) {
		    var day, hour, matches, milliseconds, minutes, month, offset, result, seconds, type, year;
		    type = Object.prototype.toString.call(input);
		    if (type === "[object Date]") {
		      return input;
		    }
		    if (type !== "[object String]") {
		      return;
		    }
		    matches = input.match(ISO8601_PATTERN);
		    if (matches) {
		      year = parseInt(matches[1], 10);
		      month = parseInt(matches[3], 10) - 1;
		      day = parseInt(matches[5], 10);
		      hour = parseInt(matches[7], 10);
		      minutes = matches[9] ? parseInt(matches[9], 10) : 0;
		      seconds = matches[11] ? parseInt(matches[11], 10) : 0;
		      milliseconds = matches[12] ? parseFloat(DECIMAL_SEPARATOR + matches[12].slice(1)) * 1000 : 0;
		      result = Date.UTC(year, month, day, hour, minutes, seconds, milliseconds);
		      if (matches[13] && matches[14]) {
		        offset = matches[15] * 60;
		        if (matches[17]) {
		          offset += parseInt(matches[17], 10);
		        }
		        offset *= matches[14] === "-" ? -1 : 1;
		        result -= offset * 60 * 1000;
		      }
		      return new Date(result);
		    }
		  }
		  // end iso8601.js
	
		  function negativeValues(series) {
		    var i, j, data;
		    for (i = 0; i < series.length; i++) {
		      data = series[i].data;
		      for (j = 0; j < data.length; j++) {
		        if (data[j][1] < 0) {
		          return true;
		        }
		      }
		    }
		    return false;
		  }
	
		  function toStr(n) {
		    return "" + n;
		  }
	
		  function toFloat(n) {
		    return parseFloat(n);
		  }
	
		  function toDate(n) {
		    var matches, year, month, day;
		    if (typeof n !== "object") {
		      if (typeof n === "number") {
		        n = new Date(n * 1000); // ms
		      } else {
		        n = toStr(n);
		        if ((matches = n.match(DATE_PATTERN))) {
		        year = parseInt(matches[1], 10);
		        month = parseInt(matches[3], 10) - 1;
		        day = parseInt(matches[5], 10);
		        return new Date(year, month, day);
		        } else { // str
		          // try our best to get the str into iso8601
		          // TODO be smarter about this
		          var str = n.replace(/ /, "T").replace(" ", "").replace("UTC", "Z");
		          n = parseISO8601(str) || new Date(n);
		        }
		      }
		    }
		    return n;
		  }
	
		  function toArr(n) {
		    if (!isArray(n)) {
		      var arr = [], i;
		      for (i in n) {
		        if (n.hasOwnProperty(i)) {
		          arr.push([i, n[i]]);
		        }
		      }
		      n = arr;
		    }
		    return n;
		  }
	
		  function jsOptionsFunc(defaultOptions, hideLegend, setTitle, setMin, setMax, setStacked, setXtitle, setYtitle) {
		    return function (chart, opts, chartOptions) {
		      var series = chart.data;
		      var options = merge({}, defaultOptions);
		      options = merge(options, chartOptions || {});
	
		      if (chart.hideLegend || "legend" in opts) {
		        hideLegend(options, opts.legend, chart.hideLegend);
		      }
	
		      if (opts.title) {
		        setTitle(options, opts.title);
		      }
	
		      // min
		      if ("min" in opts) {
		        setMin(options, opts.min);
		      } else if (!negativeValues(series)) {
		        setMin(options, 0);
		      }
	
		      // max
		      if (opts.max) {
		        setMax(options, opts.max);
		      }
	
		      if ("stacked" in opts) {
		        setStacked(options, opts.stacked);
		      }
	
		      if (opts.colors) {
		        options.colors = opts.colors;
		      }
	
		      if (opts.xtitle) {
		        setXtitle(options, opts.xtitle);
		      }
	
		      if (opts.ytitle) {
		        setYtitle(options, opts.ytitle);
		      }
	
		      // merge library last
		      options = merge(options, opts.library || {});
	
		      return options;
		    };
		  }
	
		  function sortByTime(a, b) {
		    return a[0].getTime() - b[0].getTime();
		  }
	
		  function sortByNumberSeries(a, b) {
		    return a[0] - b[0];
		  }
	
		  function sortByNumber(a, b) {
		    return a - b;
		  }
	
		  function isMinute(d) {
		    return d.getMilliseconds() === 0 && d.getSeconds() === 0;
		  }
	
		  function isHour(d) {
		    return isMinute(d) && d.getMinutes() === 0;
		  }
	
		  function isDay(d) {
		    return isHour(d) && d.getHours() === 0;
		  }
	
		  function isWeek(d, dayOfWeek) {
		    return isDay(d) && d.getDay() === dayOfWeek;
		  }
	
		  function isMonth(d) {
		    return isDay(d) && d.getDate() === 1;
		  }
	
		  function isYear(d) {
		    return isMonth(d) && d.getMonth() === 0;
		  }
	
		  function isDate(obj) {
		    return !isNaN(toDate(obj)) && toStr(obj).length >= 6;
		  }
	
		  function isNumber(obj) {
		    return typeof obj === "number";
		  }
	
		  var byteSuffixes = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB"];
	
		  function formatValue(pre, value, options, axis) {
		    pre = pre || "";
		    if (options.prefix) {
		      if (value < 0) {
		        value = value * -1;
		        pre += "-";
		      }
		      pre += options.prefix;
		    }
	
		    var suffix = options.suffix || "";
		    var precision = options.precision;
		    var round = options.round;
	
		    if (options.byteScale) {
		      var suffixIdx;
		      var baseValue = axis ? options.byteScale : value;
	
		      if (baseValue >= 1152921504606846976) {
		        value /= 1152921504606846976;
		        suffixIdx = 6;
		      } else if (baseValue >= 1125899906842624) {
		        value /= 1125899906842624;
		        suffixIdx = 5;
		      } else if (baseValue >= 1099511627776) {
		        value /= 1099511627776;
		        suffixIdx = 4;
		      } else if (baseValue >= 1073741824) {
		        value /= 1073741824;
		        suffixIdx = 3;
		      } else if (baseValue >= 1048576) {
		        value /= 1048576;
		        suffixIdx = 2;
		      } else if (baseValue >= 1024) {
		        value /= 1024;
		        suffixIdx = 1;
		      } else {
		        suffixIdx = 0;
		      }
	
		      // TODO handle manual precision case
		      if (precision === undefined && round === undefined) {
		        if (value >= 1023.5) {
		          if (suffixIdx < byteSuffixes.length - 1) {
		            value = 1.0;
		            suffixIdx += 1;
		          }
		        }
		        precision = value >= 1000 ? 4 : 3;
		      }
		      suffix = " " + byteSuffixes[suffixIdx];
		    }
	
		    if (precision !== undefined && round !== undefined) {
		      throw Error("Use either round or precision, not both");
		    }
	
		    if (!axis) {
		      if (precision !== undefined) {
		        value = value.toPrecision(precision);
		        if (!options.zeros) {
		          value = parseFloat(value);
		        }
		      }
	
		      if (round !== undefined) {
		        if (round < 0) {
		          var num = Math.pow(10, -1 * round);
		          value = parseInt((1.0 * value / num).toFixed(0)) * num;
		        } else {
		          value = value.toFixed(round);
		          if (!options.zeros) {
		            value = parseFloat(value);
		          }
		        }
		      }
		    }
	
		    if (options.thousands || options.decimal) {
		      value = toStr(value);
		      var parts = value.split(".");
		      value = parts[0];
		      if (options.thousands) {
		        value = value.replace(/\B(?=(\d{3})+(?!\d))/g, options.thousands);
		      }
		      if (parts.length > 1) {
		        value += (options.decimal || ".") + parts[1];
		      }
		    }
	
		    return pre + value + suffix;
		  }
	
		  function seriesOption(chart, series, option) {
		    if (option in series) {
		      return series[option];
		    } else if (option in chart.options) {
		      return chart.options[option];
		    }
		    return null;
		  }
	
		  function allZeros(data) {
		    var i, j, d;
		    for (i = 0; i < data.length; i++) {
		      d = data[i].data;
		      for (j = 0; j < d.length; j++) {
		        if (d[j][1] != 0) {
		          return false;
		        }
		      }
		    }
		    return true;
		  }
	
		  var baseOptions = {
		    maintainAspectRatio: false,
		    animation: false,
		    tooltips: {
		      displayColors: false,
		      callbacks: {}
		    },
		    legend: {},
		    title: {fontSize: 20, fontColor: "#333"}
		  };
	
		  var defaultOptions = {
		    scales: {
		      yAxes: [
		        {
		          ticks: {
		            maxTicksLimit: 4
		          },
		          scaleLabel: {
		            fontSize: 16,
		            // fontStyle: "bold",
		            fontColor: "#333"
		          }
		        }
		      ],
		      xAxes: [
		        {
		          gridLines: {
		            drawOnChartArea: false
		          },
		          scaleLabel: {
		            fontSize: 16,
		            // fontStyle: "bold",
		            fontColor: "#333"
		          },
		          time: {},
		          ticks: {}
		        }
		      ]
		    }
		  };
	
		  // http://there4.io/2012/05/02/google-chart-color-list/
		  var defaultColors = [
		    "#3366CC", "#DC3912", "#FF9900", "#109618", "#990099", "#3B3EAC", "#0099C6",
		    "#DD4477", "#66AA00", "#B82E2E", "#316395", "#994499", "#22AA99", "#AAAA11",
		    "#6633CC", "#E67300", "#8B0707", "#329262", "#5574A6", "#651067"
		  ];
	
		  var hideLegend = function (options, legend, hideLegend) {
		    if (legend !== undefined) {
		      options.legend.display = !!legend;
		      if (legend && legend !== true) {
		        options.legend.position = legend;
		      }
		    } else if (hideLegend) {
		      options.legend.display = false;
		    }
		  };
	
		  var setTitle = function (options, title) {
		    options.title.display = true;
		    options.title.text = title;
		  };
	
		  var setMin = function (options, min) {
		    if (min !== null) {
		      options.scales.yAxes[0].ticks.min = toFloat(min);
		    }
		  };
	
		  var setMax = function (options, max) {
		    options.scales.yAxes[0].ticks.max = toFloat(max);
		  };
	
		  var setBarMin = function (options, min) {
		    if (min !== null) {
		      options.scales.xAxes[0].ticks.min = toFloat(min);
		    }
		  };
	
		  var setBarMax = function (options, max) {
		    options.scales.xAxes[0].ticks.max = toFloat(max);
		  };
	
		  var setStacked = function (options, stacked) {
		    options.scales.xAxes[0].stacked = !!stacked;
		    options.scales.yAxes[0].stacked = !!stacked;
		  };
	
		  var setXtitle = function (options, title) {
		    options.scales.xAxes[0].scaleLabel.display = true;
		    options.scales.xAxes[0].scaleLabel.labelString = title;
		  };
	
		  var setYtitle = function (options, title) {
		    options.scales.yAxes[0].scaleLabel.display = true;
		    options.scales.yAxes[0].scaleLabel.labelString = title;
		  };
	
		  // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
		  var addOpacity = function(hex, opacity) {
		    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		    return result ? "rgba(" + parseInt(result[1], 16) + ", " + parseInt(result[2], 16) + ", " + parseInt(result[3], 16) + ", " + opacity + ")" : hex;
		  };
	
		  // check if not null or undefined
		  // https://stackoverflow.com/a/27757708/1177228
		  var notnull = function(x) {
		    return x != null;
		  };
	
		  var setLabelSize = function (chart, data, options) {
		    var maxLabelSize = Math.ceil(chart.element.offsetWidth / 4.0 / data.labels.length);
		    if (maxLabelSize > 25) {
		      maxLabelSize = 25;
		    } else if (maxLabelSize < 10) {
		      maxLabelSize = 10;
		    }
		    if (!options.scales.xAxes[0].ticks.callback) {
		      options.scales.xAxes[0].ticks.callback = function (value) {
		        value = toStr(value);
		        if (value.length > maxLabelSize) {
		          return value.substring(0, maxLabelSize - 2) + "...";
		        } else {
		          return value;
		        }
		      };
		    }
		  };
	
		  var setFormatOptions = function(chart, options, chartType) {
		    var formatOptions = {
		      prefix: chart.options.prefix,
		      suffix: chart.options.suffix,
		      thousands: chart.options.thousands,
		      decimal: chart.options.decimal,
		      precision: chart.options.precision,
		      round: chart.options.round,
		      zeros: chart.options.zeros
		    };
	
		    if (chart.options.bytes) {
		      var series = chart.data;
		      if (chartType === "pie") {
		        series = [{data: series}];
		      }
	
		      // calculate max
		      var max = 0;
		      for (var i = 0; i < series.length; i++) {
		        var s = series[i];
		        for (var j = 0; j < s.data.length; j++) {
		          if (s.data[j][1] > max) {
		            max = s.data[j][1];
		          }
		        }
		      }
	
		      // calculate scale
		      var scale = 1;
		      while (max >= 1024) {
		        scale *= 1024;
		        max /= 1024;
		      }
	
		      // set step size
		      formatOptions.byteScale = scale;
		    }
	
		    if (chartType !== "pie") {
		      var myAxes = options.scales.yAxes;
		      if (chartType === "bar") {
		        myAxes = options.scales.xAxes;
		      }
	
		      if (formatOptions.byteScale) {
		        if (!myAxes[0].ticks.stepSize) {
		          myAxes[0].ticks.stepSize = formatOptions.byteScale / 2;
		        }
		        if (!myAxes[0].ticks.maxTicksLimit) {
		          myAxes[0].ticks.maxTicksLimit = 4;
		        }
		      }
	
		      if (!myAxes[0].ticks.callback) {
		        myAxes[0].ticks.callback = function (value) {
		          return formatValue("", value, formatOptions, true);
		        };
		      }
		    }
	
		    if (!options.tooltips.callbacks.label) {
		      if (chartType === "scatter") {
		        options.tooltips.callbacks.label = function (item, data) {
		          var label = data.datasets[item.datasetIndex].label || '';
		          if (label) {
		            label += ': ';
		          }
		          return label + '(' + item.xLabel + ', ' + item.yLabel + ')';
		        };
		      } else if (chartType === "bubble") {
		        options.tooltips.callbacks.label = function (item, data) {
		          var label = data.datasets[item.datasetIndex].label || '';
		          if (label) {
		            label += ': ';
		          }
		          var dataPoint = data.datasets[item.datasetIndex].data[item.index];
		          return label + '(' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.v + ')';
		        };
		      } else if (chartType === "pie") {
		        // need to use separate label for pie charts
		        options.tooltips.callbacks.label = function (tooltipItem, data) {
		          var dataLabel = data.labels[tooltipItem.index];
		          var value = ': ';
	
		          if (isArray(dataLabel)) {
		            // show value on first line of multiline label
		            // need to clone because we are changing the value
		            dataLabel = dataLabel.slice();
		            dataLabel[0] += value;
		          } else {
		            dataLabel += value;
		          }
	
		          return formatValue(dataLabel, data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], formatOptions);
		        };
		      } else {
		        var valueLabel = chartType === "bar" ? "xLabel" : "yLabel";
		        options.tooltips.callbacks.label = function (tooltipItem, data) {
		          var label = data.datasets[tooltipItem.datasetIndex].label || '';
		          if (label) {
		            label += ': ';
		          }
		          return formatValue(label, tooltipItem[valueLabel], formatOptions);
		        };
		      }
		    }
		  };
	
		  var jsOptions = jsOptionsFunc(merge(baseOptions, defaultOptions), hideLegend, setTitle, setMin, setMax, setStacked, setXtitle, setYtitle);
	
		  var createDataTable = function (chart, options, chartType, library) {
		    var datasets = [];
		    var labels = [];
	
		    var colors = chart.options.colors || defaultColors;
	
		    var day = true;
		    var week = true;
		    var dayOfWeek;
		    var month = true;
		    var year = true;
		    var hour = true;
		    var minute = true;
	
		    var series = chart.data;
	
		    var max = 0;
		    if (chartType === "bubble") {
		      for (var i$1 = 0; i$1 < series.length; i$1++) {
		        var s$1 = series[i$1];
		        for (var j$1 = 0; j$1 < s$1.data.length; j$1++) {
		          if (s$1.data[j$1][2] > max) {
		            max = s$1.data[j$1][2];
		          }
		        }
		      }
		    }
	
		    var i, j, s, d, key, rows = [], rows2 = [];
	
		    if (chartType === "bar" || chartType === "column" || (chart.xtype !== "number" && chart.xtype !== "bubble")) {
		      var sortedLabels = [];
	
		      for (i = 0; i < series.length; i++) {
		        s = series[i];
	
		        for (j = 0; j < s.data.length; j++) {
		          d = s.data[j];
		          key = chart.xtype == "datetime" ? d[0].getTime() : d[0];
		          if (!rows[key]) {
		            rows[key] = new Array(series.length);
		          }
		          rows[key][i] = toFloat(d[1]);
		          if (sortedLabels.indexOf(key) === -1) {
		            sortedLabels.push(key);
		          }
		        }
		      }
	
		      if (chart.xtype === "datetime" || chart.xtype === "number") {
		        sortedLabels.sort(sortByNumber);
		      }
	
		      for (j = 0; j < series.length; j++) {
		        rows2.push([]);
		      }
	
		      var value;
		      var k;
		      for (k = 0; k < sortedLabels.length; k++) {
		        i = sortedLabels[k];
		        if (chart.xtype === "datetime") {
		          value = new Date(toFloat(i));
		          // TODO make this efficient
		          day = day && isDay(value);
		          if (!dayOfWeek) {
		            dayOfWeek = value.getDay();
		          }
		          week = week && isWeek(value, dayOfWeek);
		          month = month && isMonth(value);
		          year = year && isYear(value);
		          hour = hour && isHour(value);
		          minute = minute && isMinute(value);
		        } else {
		          value = i;
		        }
		        labels.push(value);
		        for (j = 0; j < series.length; j++) {
		          // Chart.js doesn't like undefined
		          rows2[j].push(rows[i][j] === undefined ? null : rows[i][j]);
		        }
		      }
		    } else {
		      for (var i$2 = 0; i$2 < series.length; i$2++) {
		        var s$2 = series[i$2];
		        var d$1 = [];
		        for (var j$2 = 0; j$2 < s$2.data.length; j$2++) {
		          var point = {
		            x: toFloat(s$2.data[j$2][0]),
		            y: toFloat(s$2.data[j$2][1])
		          };
		          if (chartType === "bubble") {
		            point.r = toFloat(s$2.data[j$2][2]) * 20 / max;
		            // custom attribute, for tooltip
		            point.v = s$2.data[j$2][2];
		          }
		          d$1.push(point);
		        }
		        rows2.push(d$1);
		      }
		    }
	
		    for (i = 0; i < series.length; i++) {
		      s = series[i];
	
		      var color = s.color || colors[i];
		      var backgroundColor = chartType !== "line" ? addOpacity(color, 0.5) : color;
	
		      var dataset = {
		        label: s.name || "",
		        data: rows2[i],
		        fill: chartType === "area",
		        borderColor: color,
		        backgroundColor: backgroundColor,
		        pointBackgroundColor: color,
		        borderWidth: 2,
		        pointHoverBackgroundColor: color
		      };
	
		      if (s.stack) {
		        dataset.stack = s.stack;
		      }
	
		      var curve = seriesOption(chart, s, "curve");
		      if (curve === false) {
		        dataset.lineTension = 0;
		      }
	
		      var points = seriesOption(chart, s, "points");
		      if (points === false) {
		        dataset.pointRadius = 0;
		        dataset.pointHitRadius = 5;
		      }
	
		      dataset = merge(dataset, chart.options.dataset || {});
		      dataset = merge(dataset, s.library || {});
		      dataset = merge(dataset, s.dataset || {});
	
		      datasets.push(dataset);
		    }
	
		    var xmin = chart.options.xmin;
		    var xmax = chart.options.xmax;
	
		    if (chart.xtype === "datetime") {
		      // hacky check for Chart.js >= 2.9.0
		      // https://github.com/chartjs/Chart.js/compare/v2.8.0...v2.9.0
		      var gte29 = "math" in library.helpers;
		      var ticksKey = gte29 ? "ticks" : "time";
		      if (notnull(xmin)) {
		        options.scales.xAxes[0][ticksKey].min = toDate(xmin).getTime();
		      }
		      if (notnull(xmax)) {
		        options.scales.xAxes[0][ticksKey].max = toDate(xmax).getTime();
		      }
		    } else if (chart.xtype === "number") {
		      if (notnull(xmin)) {
		        options.scales.xAxes[0].ticks.min = xmin;
		      }
		      if (notnull(xmax)) {
		        options.scales.xAxes[0].ticks.max = xmax;
		      }
		    }
	
		    // for empty datetime chart
		    if (chart.xtype === "datetime" && labels.length === 0) {
		      if (notnull(xmin)) {
		        labels.push(toDate(xmin));
		      }
		      if (notnull(xmax)) {
		        labels.push(toDate(xmax));
		      }
		      day = false;
		      week = false;
		      month = false;
		      year = false;
		      hour = false;
		      minute = false;
		    }
	
		    if (chart.xtype === "datetime" && labels.length > 0) {
		      var minTime = (notnull(xmin) ? toDate(xmin) : labels[0]).getTime();
		      var maxTime = (notnull(xmax) ? toDate(xmax) : labels[0]).getTime();
	
		      for (i = 1; i < labels.length; i++) {
		        var value$1 = labels[i].getTime();
		        if (value$1 < minTime) {
		          minTime = value$1;
		        }
		        if (value$1 > maxTime) {
		          maxTime = value$1;
		        }
		      }
	
		      var timeDiff = (maxTime - minTime) / (86400 * 1000.0);
	
		      if (!options.scales.xAxes[0].time.unit) {
		        var step;
		        if (year || timeDiff > 365 * 10) {
		          options.scales.xAxes[0].time.unit = "year";
		          step = 365;
		        } else if (month || timeDiff > 30 * 10) {
		          options.scales.xAxes[0].time.unit = "month";
		          step = 30;
		        } else if (day || timeDiff > 10) {
		          options.scales.xAxes[0].time.unit = "day";
		          step = 1;
		        } else if (hour || timeDiff > 0.5) {
		          options.scales.xAxes[0].time.displayFormats = {hour: "MMM D, h a"};
		          options.scales.xAxes[0].time.unit = "hour";
		          step = 1 / 24.0;
		        } else if (minute) {
		          options.scales.xAxes[0].time.displayFormats = {minute: "h:mm a"};
		          options.scales.xAxes[0].time.unit = "minute";
		          step = 1 / 24.0 / 60.0;
		        }
	
		        if (step && timeDiff > 0) {
		          var unitStepSize = Math.ceil(timeDiff / step / (chart.element.offsetWidth / 100.0));
		          if (week && step === 1) {
		            unitStepSize = Math.ceil(unitStepSize / 7.0) * 7;
		          }
		          options.scales.xAxes[0].time.unitStepSize = unitStepSize;
		        }
		      }
	
		      if (!options.scales.xAxes[0].time.tooltipFormat) {
		        if (day) {
		          options.scales.xAxes[0].time.tooltipFormat = "ll";
		        } else if (hour) {
		          options.scales.xAxes[0].time.tooltipFormat = "MMM D, h a";
		        } else if (minute) {
		          options.scales.xAxes[0].time.tooltipFormat = "h:mm a";
		        }
		      }
		    }
	
		    var data = {
		      labels: labels,
		      datasets: datasets
		    };
	
		    return data;
		  };
	
		  var defaultExport = function defaultExport(library) {
		    this.name = "chartjs";
		    this.library = library;
		  };
	
		  defaultExport.prototype.renderLineChart = function renderLineChart (chart, chartType) {
		    var chartOptions = {};
		    // fix for https://github.com/chartjs/Chart.js/issues/2441
		    if (!chart.options.max && allZeros(chart.data)) {
		      chartOptions.max = 1;
		    }
	
		    var options = jsOptions(chart, merge(chartOptions, chart.options));
		    setFormatOptions(chart, options, chartType);
	
		    var data = createDataTable(chart, options, chartType || "line", this.library);
	
		    if (chart.xtype === "number") {
		      options.scales.xAxes[0].type = "linear";
		      options.scales.xAxes[0].position = "bottom";
		    } else {
		      options.scales.xAxes[0].type = chart.xtype === "string" ? "category" : "time";
		    }
	
		    this.drawChart(chart, "line", data, options);
		  };
	
		  defaultExport.prototype.renderPieChart = function renderPieChart (chart) {
		    var options = merge({}, baseOptions);
		    if (chart.options.donut) {
		      options.cutoutPercentage = 50;
		    }
	
		    if ("legend" in chart.options) {
		      hideLegend(options, chart.options.legend);
		    }
	
		    if (chart.options.title) {
		      setTitle(options, chart.options.title);
		    }
	
		    options = merge(options, chart.options.library || {});
		    setFormatOptions(chart, options, "pie");
	
		    var labels = [];
		    var values = [];
		    for (var i = 0; i < chart.data.length; i++) {
		      var point = chart.data[i];
		      labels.push(point[0]);
		      values.push(point[1]);
		    }
	
		    var dataset = {
		      data: values,
		      backgroundColor: chart.options.colors || defaultColors
		    };
		    dataset = merge(dataset, chart.options.dataset || {});
	
		    var data = {
		      labels: labels,
		      datasets: [dataset]
		    };
	
		    this.drawChart(chart, "pie", data, options);
		  };
	
		  defaultExport.prototype.renderColumnChart = function renderColumnChart (chart, chartType) {
		    var options;
		    if (chartType === "bar") {
		      var barOptions = merge(baseOptions, defaultOptions);
		      delete barOptions.scales.yAxes[0].ticks.maxTicksLimit;
		      options = jsOptionsFunc(barOptions, hideLegend, setTitle, setBarMin, setBarMax, setStacked, setXtitle, setYtitle)(chart, chart.options);
		    } else {
		      options = jsOptions(chart, chart.options);
		    }
		    setFormatOptions(chart, options, chartType);
		    var data = createDataTable(chart, options, "column", this.library);
		    if (chartType !== "bar") {
		      setLabelSize(chart, data, options);
		    }
		    this.drawChart(chart, (chartType === "bar" ? "horizontalBar" : "bar"), data, options);
		  };
	
		  defaultExport.prototype.renderAreaChart = function renderAreaChart (chart) {
		    this.renderLineChart(chart, "area");
		  };
	
		  defaultExport.prototype.renderBarChart = function renderBarChart (chart) {
		    this.renderColumnChart(chart, "bar");
		  };
	
		  defaultExport.prototype.renderScatterChart = function renderScatterChart (chart, chartType) {
		    chartType = chartType || "scatter";
	
		    var options = jsOptions(chart, chart.options);
		    setFormatOptions(chart, options, chartType);
	
		    if (!("showLines" in options)) {
		      options.showLines = false;
		    }
	
		    var data = createDataTable(chart, options, chartType, this.library);
	
		    options.scales.xAxes[0].type = "linear";
		    options.scales.xAxes[0].position = "bottom";
	
		    this.drawChart(chart, chartType, data, options);
		  };
	
		  defaultExport.prototype.renderBubbleChart = function renderBubbleChart (chart) {
		    this.renderScatterChart(chart, "bubble");
		  };
	
		  defaultExport.prototype.destroy = function destroy (chart) {
		    if (chart.chart) {
		      chart.chart.destroy();
		    }
		  };
	
		  defaultExport.prototype.drawChart = function drawChart (chart, type, data, options) {
		    this.destroy(chart);
	
		    var chartOptions = {
		      type: type,
		      data: data,
		      options: options
		    };
	
		    if (chart.options.code) {
		      window.console.log("new Chart(ctx, " + JSON.stringify(chartOptions) + ");");
		    }
	
		    chart.element.innerHTML = "<canvas></canvas>";
		    var ctx = chart.element.getElementsByTagName("CANVAS")[0];
		    chart.chart = new this.library(ctx, chartOptions);
		  };
	
		  var defaultOptions$1 = {
		    chart: {},
		    xAxis: {
		      title: {
		        text: null
		      },
		      labels: {
		        style: {
		          fontSize: "12px"
		        }
		      }
		    },
		    yAxis: {
		      title: {
		        text: null
		      },
		      labels: {
		        style: {
		          fontSize: "12px"
		        }
		      }
		    },
		    title: {
		      text: null
		    },
		    credits: {
		      enabled: false
		    },
		    legend: {
		      borderWidth: 0
		    },
		    tooltip: {
		      style: {
		        fontSize: "12px"
		      }
		    },
		    plotOptions: {
		      areaspline: {},
		      area: {},
		      series: {
		        marker: {}
		      }
		    }
		  };
	
		  var hideLegend$1 = function (options, legend, hideLegend) {
		    if (legend !== undefined) {
		      options.legend.enabled = !!legend;
		      if (legend && legend !== true) {
		        if (legend === "top" || legend === "bottom") {
		          options.legend.verticalAlign = legend;
		        } else {
		          options.legend.layout = "vertical";
		          options.legend.verticalAlign = "middle";
		          options.legend.align = legend;
		        }
		      }
		    } else if (hideLegend) {
		      options.legend.enabled = false;
		    }
		  };
	
		  var setTitle$1 = function (options, title) {
		    options.title.text = title;
		  };
	
		  var setMin$1 = function (options, min) {
		    options.yAxis.min = min;
		  };
	
		  var setMax$1 = function (options, max) {
		    options.yAxis.max = max;
		  };
	
		  var setStacked$1 = function (options, stacked) {
		    var stackedValue = stacked ? (stacked === true ? "normal" : stacked) : null;
		    options.plotOptions.series.stacking = stackedValue;
		    options.plotOptions.area.stacking = stackedValue;
		    options.plotOptions.areaspline.stacking = stackedValue;
		  };
	
		  var setXtitle$1 = function (options, title) {
		    options.xAxis.title.text = title;
		  };
	
		  var setYtitle$1 = function (options, title) {
		    options.yAxis.title.text = title;
		  };
	
		  var jsOptions$1 = jsOptionsFunc(defaultOptions$1, hideLegend$1, setTitle$1, setMin$1, setMax$1, setStacked$1, setXtitle$1, setYtitle$1);
	
		  var setFormatOptions$1 = function(chart, options, chartType) {
		    var formatOptions = {
		      prefix: chart.options.prefix,
		      suffix: chart.options.suffix,
		      thousands: chart.options.thousands,
		      decimal: chart.options.decimal,
		      precision: chart.options.precision,
		      round: chart.options.round,
		      zeros: chart.options.zeros
		    };
	
		    if (chartType !== "pie" && !options.yAxis.labels.formatter) {
		      options.yAxis.labels.formatter = function () {
		        return formatValue("", this.value, formatOptions);
		      };
		    }
	
		    if (!options.tooltip.pointFormatter) {
		      options.tooltip.pointFormatter = function () {
		        return '<span style="color:' + this.color + '">\u25CF</span> ' + formatValue(this.series.name + ': <b>', this.y, formatOptions) + '</b><br/>';
		      };
		    }
		  };
	
		  var defaultExport$1 = function defaultExport(library) {
		    this.name = "highcharts";
		    this.library = library;
		  };
	
		  defaultExport$1.prototype.renderLineChart = function renderLineChart (chart, chartType) {
		    chartType = chartType || "spline";
		    var chartOptions = {};
		    if (chartType === "areaspline") {
		      chartOptions = {
		        plotOptions: {
		          areaspline: {
		            stacking: "normal"
		          },
		          area: {
		            stacking: "normal"
		          },
		          series: {
		            marker: {
		              enabled: false
		            }
		          }
		        }
		      };
		    }
	
		    if (chart.options.curve === false) {
		      if (chartType === "areaspline") {
		        chartType = "area";
		      } else if (chartType === "spline") {
		        chartType = "line";
		      }
		    }
	
		    var options = jsOptions$1(chart, chart.options, chartOptions), data, i, j;
		    options.xAxis.type = chart.xtype === "string" ? "category" : (chart.xtype === "number" ? "linear" : "datetime");
		    if (!options.chart.type) {
		      options.chart.type = chartType;
		    }
		    setFormatOptions$1(chart, options, chartType);
	
		    var series = chart.data;
		    for (i = 0; i < series.length; i++) {
		      series[i].name = series[i].name || "Value";
		      data = series[i].data;
		      if (chart.xtype === "datetime") {
		        for (j = 0; j < data.length; j++) {
		          data[j][0] = data[j][0].getTime();
		        }
		      }
		      series[i].marker = {symbol: "circle"};
		      if (chart.options.points === false) {
		        series[i].marker.enabled = false;
		      }
		    }
	
		    this.drawChart(chart, series, options);
		  };
	
		  defaultExport$1.prototype.renderScatterChart = function renderScatterChart (chart) {
		    var options = jsOptions$1(chart, chart.options, {});
		    options.chart.type = "scatter";
		    this.drawChart(chart, chart.data, options);
		  };
	
		  defaultExport$1.prototype.renderPieChart = function renderPieChart (chart) {
		    var chartOptions = merge(defaultOptions$1, {});
	
		    if (chart.options.colors) {
		      chartOptions.colors = chart.options.colors;
		    }
		    if (chart.options.donut) {
		      chartOptions.plotOptions = {pie: {innerSize: "50%"}};
		    }
	
		    if ("legend" in chart.options) {
		      hideLegend$1(chartOptions, chart.options.legend);
		    }
	
		    if (chart.options.title) {
		      setTitle$1(chartOptions, chart.options.title);
		    }
	
		    var options = merge(chartOptions, chart.options.library || {});
		    setFormatOptions$1(chart, options, "pie");
		    var series = [{
		      type: "pie",
		      name: chart.options.label || "Value",
		      data: chart.data
		    }];
	
		    this.drawChart(chart, series, options);
		  };
	
		  defaultExport$1.prototype.renderColumnChart = function renderColumnChart (chart, chartType) {
		    chartType = chartType || "column";
		    var series = chart.data;
		    var options = jsOptions$1(chart, chart.options), i, j, s, d, rows = [], categories = [];
		    options.chart.type = chartType;
		    setFormatOptions$1(chart, options, chartType);
	
		    for (i = 0; i < series.length; i++) {
		      s = series[i];
	
		      for (j = 0; j < s.data.length; j++) {
		        d = s.data[j];
		        if (!rows[d[0]]) {
		          rows[d[0]] = new Array(series.length);
		          categories.push(d[0]);
		        }
		        rows[d[0]][i] = d[1];
		      }
		    }
	
		    if (chart.xtype === "number") {
		      categories.sort(sortByNumber);
		    }
	
		    options.xAxis.categories = categories;
	
		    var newSeries = [], d2;
		    for (i = 0; i < series.length; i++) {
		      d = [];
		      for (j = 0; j < categories.length; j++) {
		        d.push(rows[categories[j]][i] || 0);
		      }
	
		      d2 = {
		        name: series[i].name || "Value",
		        data: d
		      };
		      if (series[i].stack) {
		        d2.stack = series[i].stack;
		      }
	
		      newSeries.push(d2);
		    }
	
		    this.drawChart(chart, newSeries, options);
		  };
	
		  defaultExport$1.prototype.renderBarChart = function renderBarChart (chart) {
		    this.renderColumnChart(chart, "bar");
		  };
	
		  defaultExport$1.prototype.renderAreaChart = function renderAreaChart (chart) {
		    this.renderLineChart(chart, "areaspline");
		  };
	
		  defaultExport$1.prototype.destroy = function destroy (chart) {
		    if (chart.chart) {
		      chart.chart.destroy();
		    }
		  };
	
		  defaultExport$1.prototype.drawChart = function drawChart (chart, data, options) {
		    this.destroy(chart);
	
		    options.chart.renderTo = chart.element.id;
		    options.series = data;
	
		    if (chart.options.code) {
		      window.console.log("new Highcharts.Chart(" + JSON.stringify(options) + ");");
		    }
	
		    chart.chart = new this.library.Chart(options);
		  };
	
		  var loaded = {};
		  var callbacks = [];
	
		  // Set chart options
		  var defaultOptions$2 = {
		    chartArea: {},
		    fontName: "'Lucida Grande', 'Lucida Sans Unicode', Verdana, Arial, Helvetica, sans-serif",
		    pointSize: 6,
		    legend: {
		      textStyle: {
		        fontSize: 12,
		        color: "#444"
		      },
		      alignment: "center",
		      position: "right"
		    },
		    curveType: "function",
		    hAxis: {
		      textStyle: {
		        color: "#666",
		        fontSize: 12
		      },
		      titleTextStyle: {},
		      gridlines: {
		        color: "transparent"
		      },
		      baselineColor: "#ccc",
		      viewWindow: {}
		    },
		    vAxis: {
		      textStyle: {
		        color: "#666",
		        fontSize: 12
		      },
		      titleTextStyle: {},
		      baselineColor: "#ccc",
		      viewWindow: {}
		    },
		    tooltip: {
		      textStyle: {
		        color: "#666",
		        fontSize: 12
		      }
		    }
		  };
	
		  var hideLegend$2 = function (options, legend, hideLegend) {
		    if (legend !== undefined) {
		      var position;
		      if (!legend) {
		        position = "none";
		      } else if (legend === true) {
		        position = "right";
		      } else {
		        position = legend;
		      }
		      options.legend.position = position;
		    } else if (hideLegend) {
		      options.legend.position = "none";
		    }
		  };
	
		  var setTitle$2 = function (options, title) {
		    options.title = title;
		    options.titleTextStyle = {color: "#333", fontSize: "20px"};
		  };
	
		  var setMin$2 = function (options, min) {
		    options.vAxis.viewWindow.min = min;
		  };
	
		  var setMax$2 = function (options, max) {
		    options.vAxis.viewWindow.max = max;
		  };
	
		  var setBarMin$1 = function (options, min) {
		    options.hAxis.viewWindow.min = min;
		  };
	
		  var setBarMax$1 = function (options, max) {
		    options.hAxis.viewWindow.max = max;
		  };
	
		  var setStacked$2 = function (options, stacked) {
		    options.isStacked = stacked ? stacked : false;
		  };
	
		  var setXtitle$2 = function (options, title) {
		    options.hAxis.title = title;
		    options.hAxis.titleTextStyle.italic = false;
		  };
	
		  var setYtitle$2 = function (options, title) {
		    options.vAxis.title = title;
		    options.vAxis.titleTextStyle.italic = false;
		  };
	
		  var jsOptions$2 = jsOptionsFunc(defaultOptions$2, hideLegend$2, setTitle$2, setMin$2, setMax$2, setStacked$2, setXtitle$2, setYtitle$2);
	
		  var resize = function (callback) {
		    if (window.attachEvent) {
		      window.attachEvent("onresize", callback);
		    } else if (window.addEventListener) {
		      window.addEventListener("resize", callback, true);
		    }
		    callback();
		  };
	
		  var defaultExport$2 = function defaultExport(library) {
		    this.name = "google";
		    this.library = library;
		  };
	
		  defaultExport$2.prototype.renderLineChart = function renderLineChart (chart) {
		      var this$1 = this;
	
		    this.waitForLoaded(chart, function () {
		      var chartOptions = {};
	
		      if (chart.options.curve === false) {
		        chartOptions.curveType = "none";
		      }
	
		      if (chart.options.points === false) {
		        chartOptions.pointSize = 0;
		      }
	
		      var options = jsOptions$2(chart, chart.options, chartOptions);
		      var data = this$1.createDataTable(chart.data, chart.xtype);
	
		      this$1.drawChart(chart, "LineChart", data, options);
		    });
		  };
	
		  defaultExport$2.prototype.renderPieChart = function renderPieChart (chart) {
		      var this$1 = this;
	
		    this.waitForLoaded(chart, function () {
		      var chartOptions = {
		        chartArea: {
		          top: "10%",
		          height: "80%"
		        },
		        legend: {}
		      };
		      if (chart.options.colors) {
		        chartOptions.colors = chart.options.colors;
		      }
		      if (chart.options.donut) {
		        chartOptions.pieHole = 0.5;
		      }
		      if ("legend" in chart.options) {
		        hideLegend$2(chartOptions, chart.options.legend);
		      }
		      if (chart.options.title) {
		        setTitle$2(chartOptions, chart.options.title);
		      }
		      var options = merge(merge(defaultOptions$2, chartOptions), chart.options.library || {});
	
		      var data = new this$1.library.visualization.DataTable();
		      data.addColumn("string", "");
		      data.addColumn("number", "Value");
		      data.addRows(chart.data);
	
		      this$1.drawChart(chart, "PieChart", data, options);
		    });
		  };
	
		  defaultExport$2.prototype.renderColumnChart = function renderColumnChart (chart) {
		      var this$1 = this;
	
		    this.waitForLoaded(chart, function () {
		      var options = jsOptions$2(chart, chart.options);
		      var data = this$1.createDataTable(chart.data, chart.xtype);
	
		      this$1.drawChart(chart, "ColumnChart", data, options);
		    });
		  };
	
		  defaultExport$2.prototype.renderBarChart = function renderBarChart (chart) {
		      var this$1 = this;
	
		    this.waitForLoaded(chart, function () {
		      var chartOptions = {
		        hAxis: {
		          gridlines: {
		            color: "#ccc"
		          }
		        }
		      };
		      var options = jsOptionsFunc(defaultOptions$2, hideLegend$2, setTitle$2, setBarMin$1, setBarMax$1, setStacked$2, setXtitle$2, setYtitle$2)(chart, chart.options, chartOptions);
		      var data = this$1.createDataTable(chart.data, chart.xtype);
	
		      this$1.drawChart(chart, "BarChart", data, options);
		    });
		  };
	
		  defaultExport$2.prototype.renderAreaChart = function renderAreaChart (chart) {
		      var this$1 = this;
	
		    this.waitForLoaded(chart, function () {
		      var chartOptions = {
		        isStacked: true,
		        pointSize: 0,
		        areaOpacity: 0.5
		      };
	
		      var options = jsOptions$2(chart, chart.options, chartOptions);
		      var data = this$1.createDataTable(chart.data, chart.xtype);
	
		      this$1.drawChart(chart, "AreaChart", data, options);
		    });
		  };
	
		  defaultExport$2.prototype.renderGeoChart = function renderGeoChart (chart) {
		      var this$1 = this;
	
		    this.waitForLoaded(chart, "geochart", function () {
		      var chartOptions = {
		        legend: "none",
		        colorAxis: {
		          colors: chart.options.colors || ["#f6c7b6", "#ce502d"]
		        }
		      };
		      var options = merge(merge(defaultOptions$2, chartOptions), chart.options.library || {});
	
		      var data = new this$1.library.visualization.DataTable();
		      data.addColumn("string", "");
		      data.addColumn("number", chart.options.label || "Value");
		      data.addRows(chart.data);
	
		      this$1.drawChart(chart, "GeoChart", data, options);
		    });
		  };
	
		  defaultExport$2.prototype.renderScatterChart = function renderScatterChart (chart) {
		      var this$1 = this;
	
		    this.waitForLoaded(chart, function () {
		      var chartOptions = {};
		      var options = jsOptions$2(chart, chart.options, chartOptions);
	
		      var series = chart.data, rows2 = [], i, j, data, d;
		      for (i = 0; i < series.length; i++) {
		        series[i].name = series[i].name || "Value";
		        d = series[i].data;
		        for (j = 0; j < d.length; j++) {
		          var row = new Array(series.length + 1);
		          row[0] = d[j][0];
		          row[i + 1] = d[j][1];
		          rows2.push(row);
		        }
		      }
	
		      data = new this$1.library.visualization.DataTable();
		      data.addColumn("number", "");
		      for (i = 0; i < series.length; i++) {
		        data.addColumn("number", series[i].name);
		      }
		      data.addRows(rows2);
	
		      this$1.drawChart(chart, "ScatterChart", data, options);
		    });
		  };
	
		  defaultExport$2.prototype.renderTimeline = function renderTimeline (chart) {
		      var this$1 = this;
	
		    this.waitForLoaded(chart, "timeline", function () {
		      var chartOptions = {
		        legend: "none"
		      };
	
		      if (chart.options.colors) {
		        chartOptions.colors = chart.options.colors;
		      }
		      var options = merge(merge(defaultOptions$2, chartOptions), chart.options.library || {});
	
		      var data = new this$1.library.visualization.DataTable();
		      data.addColumn({type: "string", id: "Name"});
		      data.addColumn({type: "date", id: "Start"});
		      data.addColumn({type: "date", id: "End"});
		      data.addRows(chart.data);
	
		      chart.element.style.lineHeight = "normal";
	
		      this$1.drawChart(chart, "Timeline", data, options);
		    });
		  };
	
		  defaultExport$2.prototype.destroy = function destroy (chart) {
		    if (chart.chart) {
		      chart.chart.clearChart();
		    }
		  };
	
		  defaultExport$2.prototype.drawChart = function drawChart (chart, type, data, options) {
		    this.destroy(chart);
	
		    if (chart.options.code) {
		      window.console.log("var data = new google.visualization.DataTable(" + data.toJSON() + ");\nvar chart = new google.visualization." + type + "(element);\nchart.draw(data, " + JSON.stringify(options) + ");");
		    }
	
		    chart.chart = new this.library.visualization[type](chart.element);
		    resize(function () {
		      chart.chart.draw(data, options);
		    });
		  };
	
		  defaultExport$2.prototype.waitForLoaded = function waitForLoaded (chart, pack, callback) {
		      var this$1 = this;
	
		    if (!callback) {
		      callback = pack;
		      pack = "corechart";
		    }
	
		    callbacks.push({pack: pack, callback: callback});
	
		    if (loaded[pack]) {
		      this.runCallbacks();
		    } else {
		      loaded[pack] = true;
	
		      // https://groups.google.com/forum/#!topic/google-visualization-api/fMKJcyA2yyI
		      var loadOptions = {
		        packages: [pack],
		        callback: function () { this$1.runCallbacks(); }
		      };
		      var config = chart.__config();
		      if (config.language) {
		        loadOptions.language = config.language;
		      }
		      if (pack === "geochart" && config.mapsApiKey) {
		        loadOptions.mapsApiKey = config.mapsApiKey;
		      }
	
		      this.library.charts.load("current", loadOptions);
		    }
		  };
	
		  defaultExport$2.prototype.runCallbacks = function runCallbacks () {
		    var cb, call;
		    for (var i = 0; i < callbacks.length; i++) {
		      cb = callbacks[i];
		      call = this.library.visualization && ((cb.pack === "corechart" && this.library.visualization.LineChart) || (cb.pack === "timeline" && this.library.visualization.Timeline) || (cb.pack === "geochart" && this.library.visualization.GeoChart));
		      if (call) {
		        cb.callback();
		        callbacks.splice(i, 1);
		        i--;
		      }
		    }
		  };
	
		  // cant use object as key
		  defaultExport$2.prototype.createDataTable = function createDataTable (series, columnType) {
		    var i, j, s, d, key, rows = [], sortedLabels = [];
		    for (i = 0; i < series.length; i++) {
		      s = series[i];
		      series[i].name = series[i].name || "Value";
	
		      for (j = 0; j < s.data.length; j++) {
		        d = s.data[j];
		        key = (columnType === "datetime") ? d[0].getTime() : d[0];
		        if (!rows[key]) {
		          rows[key] = new Array(series.length);
		          sortedLabels.push(key);
		        }
		        rows[key][i] = toFloat(d[1]);
		      }
		    }
	
		    var rows2 = [];
		    var day = true;
		    var value;
		    for (j = 0; j < sortedLabels.length; j++) {
		      i = sortedLabels[j];
		      if (columnType === "datetime") {
		        value = new Date(toFloat(i));
		        day = day && isDay(value);
		      } else if (columnType === "number") {
		        value = toFloat(i);
		      } else {
		        value = i;
		      }
		      rows2.push([value].concat(rows[i]));
		    }
		    if (columnType === "datetime") {
		      rows2.sort(sortByTime);
		    } else if (columnType === "number") {
		      rows2.sort(sortByNumberSeries);
	
		      for (i = 0; i < rows2.length; i++) {
		        rows2[i][0] = toStr(rows2[i][0]);
		      }
	
		      columnType = "string";
		    }
	
		    // create datatable
		    var data = new this.library.visualization.DataTable();
		    columnType = columnType === "datetime" && day ? "date" : columnType;
		    data.addColumn(columnType, "");
		    for (i = 0; i < series.length; i++) {
		      data.addColumn("number", series[i].name);
		    }
		    data.addRows(rows2);
	
		    return data;
		  };
	
		  var pendingRequests = [], runningRequests = 0, maxRequests = 4;
	
		  function pushRequest(url, success, error) {
		    pendingRequests.push([url, success, error]);
		    runNext();
		  }
	
		  function runNext() {
		    if (runningRequests < maxRequests) {
		      var request = pendingRequests.shift();
		      if (request) {
		        runningRequests++;
		        getJSON(request[0], request[1], request[2]);
		        runNext();
		      }
		    }
		  }
	
		  function requestComplete() {
		    runningRequests--;
		    runNext();
		  }
	
		  function getJSON(url, success, error) {
		    ajaxCall(url, success, function (jqXHR, textStatus, errorThrown) {
		      var message = (typeof errorThrown === "string") ? errorThrown : errorThrown.message;
		      error(message);
		    });
		  }
	
		  function ajaxCall(url, success, error) {
		    var $ = window.jQuery || window.Zepto || window.$;
	
		    if ($ && $.ajax) {
		      $.ajax({
		        dataType: "json",
		        url: url,
		        success: success,
		        error: error,
		        complete: requestComplete
		      });
		    } else {
		      var xhr = new XMLHttpRequest();
		      xhr.open("GET", url, true);
		      xhr.setRequestHeader("Content-Type", "application/json");
		      xhr.onload = function () {
		        requestComplete();
		        if (xhr.status === 200) {
		          success(JSON.parse(xhr.responseText), xhr.statusText, xhr);
		        } else {
		          error(xhr, "error", xhr.statusText);
		        }
		      };
		      xhr.send();
		    }
		  }
	
		  var config = {};
		  var adapters = [];
	
		  // helpers
	
		  function setText(element, text) {
		    if (document.body.innerText) {
		      element.innerText = text;
		    } else {
		      element.textContent = text;
		    }
		  }
	
		  // TODO remove prefix for all messages
		  function chartError(element, message, noPrefix) {
		    if (!noPrefix) {
		      message = "Error Loading Chart: " + message;
		    }
		    setText(element, message);
		    element.style.color = "#ff0000";
		  }
	
		  function errorCatcher(chart) {
		    try {
		      chart.__render();
		    } catch (err) {
		      chartError(chart.element, err.message);
		      throw err;
		    }
		  }
	
		  function fetchDataSource(chart, dataSource) {
		    if (typeof dataSource === "string") {
		      pushRequest(dataSource, function (data) {
		        chart.rawData = data;
		        errorCatcher(chart);
		      }, function (message) {
		        chartError(chart.element, message);
		      });
		    } else if (typeof dataSource === "function") {
		      try {
		        dataSource(function (data) {
		          chart.rawData = data;
		          errorCatcher(chart);
		        }, function (message) {
		          chartError(chart.element, message, true);
		        });
		      } catch (err) {
		        chartError(chart.element, err, true);
		      }
		    } else {
		      chart.rawData = dataSource;
		      errorCatcher(chart);
		    }
		  }
	
		  function addDownloadButton(chart) {
		    var element = chart.element;
		    var link = document.createElement("a");
	
		    var download = chart.options.download;
		    if (download === true) {
		      download = {};
		    } else if (typeof download === "string") {
		      download = {filename: download};
		    }
		    link.download = download.filename || "chart.png"; // https://caniuse.com/download
	
		    link.style.position = "absolute";
		    link.style.top = "20px";
		    link.style.right = "20px";
		    link.style.zIndex = 1000;
		    link.style.lineHeight = "20px";
		    link.target = "_blank"; // for safari
		    var image = document.createElement("img");
		    image.alt = "Download";
		    image.style.border = "none";
		    // icon from font-awesome
		    // http://fa2png.io/
		    image.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAABCFBMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMywEsqxAAAAV3RSTlMAAQIDBggJCgsMDQ4PERQaHB0eISIjJCouLzE0OTo/QUJHSUpLTU5PUllhYmltcHh5foWLjI+SlaCio6atr7S1t7m6vsHHyM7R2tze5Obo7fHz9ff5+/1hlxK2AAAA30lEQVQYGUXBhVYCQQBA0TdYWAt2d3d3YWAHyur7/z9xgD16Lw0DW+XKx+1GgX+FRzM3HWQWrHl5N/oapW5RPe0PkBu+UYeICvozTWZVK23Ao04B79oJrOsJDOoxkZoQPWgX29pHpCZEk7rEvQYiNSFq1UMqvlCjJkRBS1R8hb00Vb/TajtBL7nTHE1X1vyMQF732dQhyF2o6SAwrzP06iUQzvwsArlnzcOdrgBhJyHa1QOgO9U1GsKuvjUTjavliZYQ8nNPapG6sap/3nrIdJ6bOWzmX/fy0XVpfzZP3S8OJT3g9EEiJwAAAABJRU5ErkJggg==";
		    link.appendChild(image);
		    element.style.position = "relative";
	
		    chart.__downloadAttached = true;
	
		    // mouseenter
		    chart.__enterEvent = addEvent(element, "mouseover", function(e) {
		      var related = e.relatedTarget;
		      // check download option again to ensure it wasn't changed
		      if ((!related || (related !== this && !childOf(this, related))) && chart.options.download) {
		        link.href = chart.toImage(download);
		        element.appendChild(link);
		      }
		    });
	
		    // mouseleave
		    chart.__leaveEvent = addEvent(element, "mouseout", function(e) {
		      var related = e.relatedTarget;
		      if (!related || (related !== this && !childOf(this, related))) {
		        if (link.parentNode) {
		          link.parentNode.removeChild(link);
		        }
		      }
		    });
		  }
	
		  // https://stackoverflow.com/questions/10149963/adding-event-listener-cross-browser
		  function addEvent(elem, event, fn) {
		    if (elem.addEventListener) {
		      elem.addEventListener(event, fn, false);
		      return fn;
		    } else {
		      var fn2 = function() {
		        // set the this pointer same as addEventListener when fn is called
		        return(fn.call(elem, window.event));
		      };
		      elem.attachEvent("on" + event, fn2);
		      return fn2;
		    }
		  }
	
		  function removeEvent(elem, event, fn) {
		    if (elem.removeEventListener) {
		      elem.removeEventListener(event, fn, false);
		    } else {
		      elem.detachEvent("on" + event, fn);
		    }
		  }
	
		  // https://gist.github.com/shawnbot/4166283
		  function childOf(p, c) {
		    if (p === c) { return false; }
		    while (c && c !== p) { c = c.parentNode; }
		    return c === p;
		  }
	
		  function getAdapterType(library) {
		    if (library) {
		      if (library.product === "Highcharts") {
		        return defaultExport$1;
		      } else if (library.charts) {
		        return defaultExport$2;
		      } else if (isFunction(library)) {
		        return defaultExport;
		      }
		    }
		    throw new Error("Unknown adapter");
		  }
	
		  function addAdapter(library) {
		    var adapterType = getAdapterType(library);
		    var adapter = new adapterType(library);
	
		    if (adapters.indexOf(adapter) === -1) {
		      adapters.push(adapter);
		    }
		  }
	
		  function loadAdapters() {
		    if ("Chart" in window) {
		      addAdapter(window.Chart);
		    }
	
		    if ("Highcharts" in window) {
		      addAdapter(window.Highcharts);
		    }
	
		    if (window.google && window.google.charts) {
		      addAdapter(window.google);
		    }
		  }
	
		  function dataEmpty(data, chartType) {
		    if (chartType === "PieChart" || chartType === "GeoChart" || chartType === "Timeline") {
		      return data.length === 0;
		    } else {
		      for (var i = 0; i < data.length; i++) {
		        if (data[i].data.length > 0) {
		          return false;
		        }
		      }
		      return true;
		    }
		  }
	
		  function renderChart(chartType, chart) {
		    if (chart.options.messages && chart.options.messages.empty && dataEmpty(chart.data, chartType)) {
		      setText(chart.element, chart.options.messages.empty);
		    } else {
		      callAdapter(chartType, chart);
		      if (chart.options.download && !chart.__downloadAttached && chart.adapter === "chartjs") {
		        addDownloadButton(chart);
		      }
		    }
		  }
	
		  // TODO remove chartType if cross-browser way
		  // to get the name of the chart class
		  function callAdapter(chartType, chart) {
		    var i, adapter, fnName, adapterName;
		    fnName = "render" + chartType;
		    adapterName = chart.options.adapter;
	
		    loadAdapters();
	
		    for (i = 0; i < adapters.length; i++) {
		      adapter = adapters[i];
		      if ((!adapterName || adapterName === adapter.name) && isFunction(adapter[fnName])) {
		        chart.adapter = adapter.name;
		        chart.__adapterObject = adapter;
		        return adapter[fnName](chart);
		      }
		    }
	
		    if (adapters.length > 0) {
		      throw new Error("No charting library found for " + chartType);
		    } else {
		      throw new Error("No charting libraries found - be sure to include one before your charts");
		    }
		  }
	
		  // process data
	
		  var toFormattedKey = function (key, keyType) {
		    if (keyType === "number") {
		      key = toFloat(key);
		    } else if (keyType === "datetime") {
		      key = toDate(key);
		    } else {
		      key = toStr(key);
		    }
		    return key;
		  };
	
		  var formatSeriesData = function (data, keyType) {
		    var r = [], key, j;
		    for (j = 0; j < data.length; j++) {
		      if (keyType === "bubble") {
		        r.push([toFloat(data[j][0]), toFloat(data[j][1]), toFloat(data[j][2])]);
		      } else {
		        key = toFormattedKey(data[j][0], keyType);
		        r.push([key, toFloat(data[j][1])]);
		      }
		    }
		    if (keyType === "datetime") {
		      r.sort(sortByTime);
		    } else if (keyType === "number") {
		      r.sort(sortByNumberSeries);
		    }
		    return r;
		  };
	
		  function detectXType(series, noDatetime, options) {
		    if (dataEmpty(series)) {
		      if ((options.xmin || options.xmax) && (!options.xmin || isDate(options.xmin)) && (!options.xmax || isDate(options.xmax))) {
		        return "datetime";
		      } else {
		        return "number";
		      }
		    } else if (detectXTypeWithFunction(series, isNumber)) {
		      return "number";
		    } else if (!noDatetime && detectXTypeWithFunction(series, isDate)) {
		      return "datetime";
		    } else {
		      return "string";
		    }
		  }
	
		  function detectXTypeWithFunction(series, func) {
		    var i, j, data;
		    for (i = 0; i < series.length; i++) {
		      data = toArr(series[i].data);
		      for (j = 0; j < data.length; j++) {
		        if (!func(data[j][0])) {
		          return false;
		        }
		      }
		    }
		    return true;
		  }
	
		  // creates a shallow copy of each element of the array
		  // elements are expected to be objects
		  function copySeries(series) {
		    var newSeries = [], i, j;
		    for (i = 0; i < series.length; i++) {
		      var copy = {};
		      for (j in series[i]) {
		        if (series[i].hasOwnProperty(j)) {
		          copy[j] = series[i][j];
		        }
		      }
		      newSeries.push(copy);
		    }
		    return newSeries;
		  }
	
		  function processSeries(chart, keyType, noDatetime) {
		    var i;
	
		    var opts = chart.options;
		    var series = chart.rawData;
	
		    // see if one series or multiple
		    if (!isArray(series) || typeof series[0] !== "object" || isArray(series[0])) {
		      series = [{name: opts.label, data: series}];
		      chart.hideLegend = true;
		    } else {
		      chart.hideLegend = false;
		    }
	
		    // convert to array
		    // must come before dataEmpty check
		    series = copySeries(series);
		    for (i = 0; i < series.length; i++) {
		      series[i].data = toArr(series[i].data);
		    }
	
		    chart.xtype = keyType ? keyType : (opts.discrete ? "string" : detectXType(series, noDatetime, opts));
	
		    // right format
		    for (i = 0; i < series.length; i++) {
		      series[i].data = formatSeriesData(series[i].data, chart.xtype);
		    }
	
		    return series;
		  }
	
		  function processSimple(chart) {
		    var perfectData = toArr(chart.rawData), i;
		    for (i = 0; i < perfectData.length; i++) {
		      perfectData[i] = [toStr(perfectData[i][0]), toFloat(perfectData[i][1])];
		    }
		    return perfectData;
		  }
	
		  // define classes
	
		  var Chart = function Chart(element, dataSource, options) {
		    var elementId;
		    if (typeof element === "string") {
		      elementId = element;
		      element = document.getElementById(element);
		      if (!element) {
		        throw new Error("No element with id " + elementId);
		      }
		    }
		    this.element = element;
		    this.options = merge(Chartkick.options, options || {});
		    this.dataSource = dataSource;
	
		    Chartkick.charts[element.id] = this;
	
		    fetchDataSource(this, dataSource);
	
		    if (this.options.refresh) {
		      this.startRefresh();
		    }
		  };
	
		  Chart.prototype.getElement = function getElement () {
		    return this.element;
		  };
	
		  Chart.prototype.getDataSource = function getDataSource () {
		    return this.dataSource;
		  };
	
		  Chart.prototype.getData = function getData () {
		    return this.data;
		  };
	
		  Chart.prototype.getOptions = function getOptions () {
		    return this.options;
		  };
	
		  Chart.prototype.getChartObject = function getChartObject () {
		    return this.chart;
		  };
	
		  Chart.prototype.getAdapter = function getAdapter () {
		    return this.adapter;
		  };
	
		  Chart.prototype.updateData = function updateData (dataSource, options) {
		    this.dataSource = dataSource;
		    if (options) {
		      this.__updateOptions(options);
		    }
		    fetchDataSource(this, dataSource);
		  };
	
		  Chart.prototype.setOptions = function setOptions (options) {
		    this.__updateOptions(options);
		    this.redraw();
		  };
	
		  Chart.prototype.redraw = function redraw () {
		    fetchDataSource(this, this.rawData);
		  };
	
		  Chart.prototype.refreshData = function refreshData () {
		    if (typeof this.dataSource === "string") {
		      // prevent browser from caching
		      var sep = this.dataSource.indexOf("?") === -1 ? "?" : "&";
		      var url = this.dataSource + sep + "_=" + (new Date()).getTime();
		      fetchDataSource(this, url);
		    } else if (typeof this.dataSource === "function") {
		      fetchDataSource(this, this.dataSource);
		    }
		  };
	
		  Chart.prototype.startRefresh = function startRefresh () {
		      var this$1 = this;
	
		    var refresh = this.options.refresh;
	
		    if (refresh && typeof this.dataSource !== "string" && typeof this.dataSource !== "function") {
		      throw new Error("Data source must be a URL or callback for refresh");
		    }
	
		    if (!this.intervalId) {
		      if (refresh) {
		        this.intervalId = setInterval( function () {
		          this$1.refreshData();
		        }, refresh * 1000);
		      } else {
		        throw new Error("No refresh interval");
		      }
		    }
		  };
	
		  Chart.prototype.stopRefresh = function stopRefresh () {
		    if (this.intervalId) {
		      clearInterval(this.intervalId);
		      this.intervalId = null;
		    }
		  };
	
		  Chart.prototype.toImage = function toImage (download) {
		    if (this.adapter === "chartjs") {
		      if (download && download.background && download.background !== "transparent") {
		        // https://stackoverflow.com/questions/30464750/chartjs-line-chart-set-background-color
		        var canvas = this.chart.chart.canvas;
		        var ctx = this.chart.chart.ctx;
		        var tmpCanvas = document.createElement("canvas");
		        var tmpCtx = tmpCanvas.getContext("2d");
		        tmpCanvas.width = ctx.canvas.width;
		        tmpCanvas.height = ctx.canvas.height;
		        tmpCtx.fillStyle = download.background;
		        tmpCtx.fillRect(0, 0, tmpCanvas.width, tmpCanvas.height);
		        tmpCtx.drawImage(canvas, 0, 0);
		        return tmpCanvas.toDataURL("image/png");
		      } else {
		        return this.chart.toBase64Image();
		      }
		    } else {
		      // TODO throw error in next major version
		      // throw new Error("Feature only available for Chart.js");
		      return null;
		    }
		  };
	
		  Chart.prototype.destroy = function destroy () {
		    if (this.__adapterObject) {
		      this.__adapterObject.destroy(this);
		    }
	
		    if (this.__enterEvent) {
		      removeEvent(this.element, "mouseover", this.__enterEvent);
		    }
	
		    if (this.__leaveEvent) {
		      removeEvent(this.element, "mouseout", this.__leaveEvent);
		    }
		  };
	
		  Chart.prototype.__updateOptions = function __updateOptions (options) {
		    var updateRefresh = options.refresh && options.refresh !== this.options.refresh;
		    this.options = merge(Chartkick.options, options);
		    if (updateRefresh) {
		      this.stopRefresh();
		      this.startRefresh();
		    }
		  };
	
		  Chart.prototype.__render = function __render () {
		    this.data = this.__processData();
		    renderChart(this.__chartName(), this);
		  };
	
		  Chart.prototype.__config = function __config () {
		    return config;
		  };
	
		  var LineChart = /*@__PURE__*/(function (Chart) {
		    function LineChart () {
		      Chart.apply(this, arguments);
		    }
	
		    if ( Chart ) { LineChart.__proto__ = Chart; }
		    LineChart.prototype = Object.create( Chart && Chart.prototype );
		    LineChart.prototype.constructor = LineChart;
	
		    LineChart.prototype.__processData = function __processData () {
		      return processSeries(this);
		    };
	
		    LineChart.prototype.__chartName = function __chartName () {
		      return "LineChart";
		    };
	
		    return LineChart;
		  }(Chart));
	
		  var PieChart = /*@__PURE__*/(function (Chart) {
		    function PieChart () {
		      Chart.apply(this, arguments);
		    }
	
		    if ( Chart ) { PieChart.__proto__ = Chart; }
		    PieChart.prototype = Object.create( Chart && Chart.prototype );
		    PieChart.prototype.constructor = PieChart;
	
		    PieChart.prototype.__processData = function __processData () {
		      return processSimple(this);
		    };
	
		    PieChart.prototype.__chartName = function __chartName () {
		      return "PieChart";
		    };
	
		    return PieChart;
		  }(Chart));
	
		  var ColumnChart = /*@__PURE__*/(function (Chart) {
		    function ColumnChart () {
		      Chart.apply(this, arguments);
		    }
	
		    if ( Chart ) { ColumnChart.__proto__ = Chart; }
		    ColumnChart.prototype = Object.create( Chart && Chart.prototype );
		    ColumnChart.prototype.constructor = ColumnChart;
	
		    ColumnChart.prototype.__processData = function __processData () {
		      return processSeries(this, null, true);
		    };
	
		    ColumnChart.prototype.__chartName = function __chartName () {
		      return "ColumnChart";
		    };
	
		    return ColumnChart;
		  }(Chart));
	
		  var BarChart = /*@__PURE__*/(function (Chart) {
		    function BarChart () {
		      Chart.apply(this, arguments);
		    }
	
		    if ( Chart ) { BarChart.__proto__ = Chart; }
		    BarChart.prototype = Object.create( Chart && Chart.prototype );
		    BarChart.prototype.constructor = BarChart;
	
		    BarChart.prototype.__processData = function __processData () {
		      return processSeries(this, null, true);
		    };
	
		    BarChart.prototype.__chartName = function __chartName () {
		      return "BarChart";
		    };
	
		    return BarChart;
		  }(Chart));
	
		  var AreaChart = /*@__PURE__*/(function (Chart) {
		    function AreaChart () {
		      Chart.apply(this, arguments);
		    }
	
		    if ( Chart ) { AreaChart.__proto__ = Chart; }
		    AreaChart.prototype = Object.create( Chart && Chart.prototype );
		    AreaChart.prototype.constructor = AreaChart;
	
		    AreaChart.prototype.__processData = function __processData () {
		      return processSeries(this);
		    };
	
		    AreaChart.prototype.__chartName = function __chartName () {
		      return "AreaChart";
		    };
	
		    return AreaChart;
		  }(Chart));
	
		  var GeoChart = /*@__PURE__*/(function (Chart) {
		    function GeoChart () {
		      Chart.apply(this, arguments);
		    }
	
		    if ( Chart ) { GeoChart.__proto__ = Chart; }
		    GeoChart.prototype = Object.create( Chart && Chart.prototype );
		    GeoChart.prototype.constructor = GeoChart;
	
		    GeoChart.prototype.__processData = function __processData () {
		      return processSimple(this);
		    };
	
		    GeoChart.prototype.__chartName = function __chartName () {
		      return "GeoChart";
		    };
	
		    return GeoChart;
		  }(Chart));
	
		  var ScatterChart = /*@__PURE__*/(function (Chart) {
		    function ScatterChart () {
		      Chart.apply(this, arguments);
		    }
	
		    if ( Chart ) { ScatterChart.__proto__ = Chart; }
		    ScatterChart.prototype = Object.create( Chart && Chart.prototype );
		    ScatterChart.prototype.constructor = ScatterChart;
	
		    ScatterChart.prototype.__processData = function __processData () {
		      return processSeries(this, "number");
		    };
	
		    ScatterChart.prototype.__chartName = function __chartName () {
		      return "ScatterChart";
		    };
	
		    return ScatterChart;
		  }(Chart));
	
		  var BubbleChart = /*@__PURE__*/(function (Chart) {
		    function BubbleChart () {
		      Chart.apply(this, arguments);
		    }
	
		    if ( Chart ) { BubbleChart.__proto__ = Chart; }
		    BubbleChart.prototype = Object.create( Chart && Chart.prototype );
		    BubbleChart.prototype.constructor = BubbleChart;
	
		    BubbleChart.prototype.__processData = function __processData () {
		      return processSeries(this, "bubble");
		    };
	
		    BubbleChart.prototype.__chartName = function __chartName () {
		      return "BubbleChart";
		    };
	
		    return BubbleChart;
		  }(Chart));
	
		  var Timeline = /*@__PURE__*/(function (Chart) {
		    function Timeline () {
		      Chart.apply(this, arguments);
		    }
	
		    if ( Chart ) { Timeline.__proto__ = Chart; }
		    Timeline.prototype = Object.create( Chart && Chart.prototype );
		    Timeline.prototype.constructor = Timeline;
	
		    Timeline.prototype.__processData = function __processData () {
		      var i, data = this.rawData;
		      for (i = 0; i < data.length; i++) {
		        data[i][1] = toDate(data[i][1]);
		        data[i][2] = toDate(data[i][2]);
		      }
		      return data;
		    };
	
		    Timeline.prototype.__chartName = function __chartName () {
		      return "Timeline";
		    };
	
		    return Timeline;
		  }(Chart));
	
		  var Chartkick = {
		    LineChart: LineChart,
		    PieChart: PieChart,
		    ColumnChart: ColumnChart,
		    BarChart: BarChart,
		    AreaChart: AreaChart,
		    GeoChart: GeoChart,
		    ScatterChart: ScatterChart,
		    BubbleChart: BubbleChart,
		    Timeline: Timeline,
		    charts: {},
		    configure: function (options) {
		      for (var key in options) {
		        if (options.hasOwnProperty(key)) {
		          config[key] = options[key];
		        }
		      }
		    },
		    setDefaultOptions: function (opts) {
		      Chartkick.options = opts;
		    },
		    eachChart: function (callback) {
		      for (var chartId in Chartkick.charts) {
		        if (Chartkick.charts.hasOwnProperty(chartId)) {
		          callback(Chartkick.charts[chartId]);
		        }
		      }
		    },
		    config: config,
		    options: {},
		    adapters: adapters,
		    addAdapter: addAdapter,
		    use: function(adapter) {
		      addAdapter(adapter);
		      return Chartkick;
		    }
		  };
	
		  // not ideal, but allows for simpler integration
		  if (typeof window !== "undefined" && !window.Chartkick) {
		    window.Chartkick = Chartkick;
		  }
	
		  // backwards compatibility for esm require
		  Chartkick.default = Chartkick;
	
		  return Chartkick;
	
		})));
		});
	
		function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }
	
		var chartId = 1;
	
		var ChartComponent = /*@__PURE__*/(function (superclass) {
		  function ChartComponent () {
		    superclass.apply(this, arguments);
		  }
	
		  if ( superclass ) ChartComponent.__proto__ = superclass;
		  ChartComponent.prototype = Object.create( superclass && superclass.prototype );
		  ChartComponent.prototype.constructor = ChartComponent;
	
		  ChartComponent.prototype.newChartType = function newChartType (props) {
		    var data = props.data;
		    var options = {};
		    for (var prop in props) {
		      if (props.hasOwnProperty(prop) && prop !== "data" && prop !== "id" && prop !== "height" && prop !== "width") {
		        options[prop] = props[prop];
		      }
		    }
		    if (this.element) {
		      if (this.chart) {
		        this.chart.updateData(data, options);
		      } else {
		        this.chart = new props.chartType(this.element, data, options);
		      }
		    }
		  };
	
		  ChartComponent.prototype.componentDidMount = function componentDidMount () {
		    this.newChartType(this.props);
		  };
	
		  ChartComponent.prototype.componentDidUpdate = function componentDidUpdate () {
		    this.newChartType(this.props);
		  };
	
		  ChartComponent.prototype.render = function render () {
		    var this$1 = this;
	
		    var props = this.props;
		    var style = {
		      height: props.height || "300px",
		      lineHeight: props.height || "300px",
		      width: props.width || "100%",
		      textAlign: "center",
		      color: "#999",
		      fontSize: "14px",
		      fontFamily: "'Lucida Grande', 'Lucida Sans Unicode', Verdana, Arial, Helvetica, sans-serif"
		    };
		    this.chartId = props.id || this.chartId || ("chart-" + chartId++);
		    return (
		      React.createElement("div", {id: this.chartId, style: style, ref: function (element) { return this$1.element = element; }},
		        "Loading..."
		      )
		    )
		  };
	
		  return ChartComponent;
		}(React.Component));
	
		var createComponent = function (chartType) {
		  var ChartkickComponent = function (ref) {
		    var innerRef = ref.innerRef;
		    var rest = objectWithoutProperties( ref, ["innerRef"] );
		    var props = rest;
	
		    // props cloned when split from innerRef, so we can modify directly
		    props.chartType = chartType;
		    props.ref = innerRef;
		    return React.createElement(ChartComponent, props)
		  };
		  ChartkickComponent.displayName = chartType.name;
		  return ChartkickComponent
		};
	
		var LineChart = createComponent(chartkick.LineChart);
		var PieChart = createComponent(chartkick.PieChart);
		var ColumnChart = createComponent(chartkick.ColumnChart);
		var BarChart = createComponent(chartkick.BarChart);
		var AreaChart = createComponent(chartkick.AreaChart);
		var ScatterChart = createComponent(chartkick.ScatterChart);
		var GeoChart = createComponent(chartkick.GeoChart);
		var Timeline = createComponent(chartkick.Timeline);
	
		exports.AreaChart = AreaChart;
		exports.BarChart = BarChart;
		exports.ColumnChart = ColumnChart;
		exports.GeoChart = GeoChart;
		exports.LineChart = LineChart;
		exports.PieChart = PieChart;
		exports.ScatterChart = ScatterChart;
		exports.Timeline = Timeline;
		exports.default = chartkick;
	
		Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license React
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),ca=__webpack_require__(1038);function p(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var da=new Set,ea={};function fa(a,b){ha(a,b);ha(a+"Capture",b)}
	function ha(a,b){ea[a]=b;for(a=0;a<b.length;a++)da.add(b[a])}
	var ia=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ja=Object.prototype.hasOwnProperty,ka=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,la=
	{},ma={};function oa(a){if(ja.call(ma,a))return!0;if(ja.call(la,a))return!1;if(ka.test(a))return ma[a]=!0;la[a]=!0;return!1}function pa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function qa(a,b,c,d){if(null===b||"undefined"===typeof b||pa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g}var z={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){z[a]=new v(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];z[b]=new v(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){z[a]=new v(a,2,!1,a.toLowerCase(),null,!1,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){z[a]=new v(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){z[a]=new v(a,3,!1,a.toLowerCase(),null,!1,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){z[a]=new v(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){z[a]=new v(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){z[a]=new v(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){z[a]=new v(a,5,!1,a.toLowerCase(),null,!1,!1)});var ra=/[\-:]([a-z])/g;function sa(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ra,
	sa);z[b]=new v(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ra,sa);z[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ra,sa);z[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){z[a]=new v(a,1,!1,a.toLowerCase(),null,!1,!1)});
	z.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){z[a]=new v(a,1,!1,a.toLowerCase(),null,!0,!0)});
	function ta(a,b,c,d){var e=z.hasOwnProperty(b)?z[b]:null;if(null!==e?0!==e.type:d||!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1])qa(b,c,e,d)&&(c=null),d||null===e?oa(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c)))}
	var ua=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,va=Symbol.for("react.element"),wa=Symbol.for("react.portal"),ya=Symbol.for("react.fragment"),za=Symbol.for("react.strict_mode"),Aa=Symbol.for("react.profiler"),Ba=Symbol.for("react.provider"),Ca=Symbol.for("react.context"),Da=Symbol.for("react.forward_ref"),Ea=Symbol.for("react.suspense"),Fa=Symbol.for("react.suspense_list"),Ga=Symbol.for("react.memo"),Ha=Symbol.for("react.lazy");Symbol.for("react.scope");Symbol.for("react.debug_trace_mode");
	var Ia=Symbol.for("react.offscreen");Symbol.for("react.legacy_hidden");Symbol.for("react.cache");Symbol.for("react.tracing_marker");var Ja=Symbol.iterator;function Ka(a){if(null===a||"object"!==typeof a)return null;a=Ja&&a[Ja]||a["@@iterator"];return"function"===typeof a?a:null}var A=Object.assign,La;function Ma(a){if(void 0===La)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);La=b&&b[1]||""}return"\n"+La+a}var Na=!1;
	function Oa(a,b){if(!a||Na)return"";Na=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[])}catch(l){var d=l}Reflect.construct(a,[],b)}else{try{b.call()}catch(l){d=l}a.call(b.prototype)}else{try{throw Error();}catch(l){d=l}a()}}catch(l){if(l&&d&&"string"===typeof l.stack){for(var e=l.stack.split("\n"),
	f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h]){var k="\n"+e[g].replace(" at new "," at ");a.displayName&&k.includes("<anonymous>")&&(k=k.replace("<anonymous>",a.displayName));return k}while(1<=g&&0<=h)}break}}}finally{Na=!1,Error.prepareStackTrace=c}return(a=a?a.displayName||a.name:"")?Ma(a):""}
	function Pa(a){switch(a.tag){case 5:return Ma(a.type);case 16:return Ma("Lazy");case 13:return Ma("Suspense");case 19:return Ma("SuspenseList");case 0:case 2:case 15:return a=Oa(a.type,!1),a;case 11:return a=Oa(a.type.render,!1),a;case 1:return a=Oa(a.type,!0),a;default:return""}}
	function Qa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ya:return"Fragment";case wa:return"Portal";case Aa:return"Profiler";case za:return"StrictMode";case Ea:return"Suspense";case Fa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ca:return(a.displayName||"Context")+".Consumer";case Ba:return(a._context.displayName||"Context")+".Provider";case Da:var b=a.render;a=a.displayName;a||(a=b.displayName||
	b.name||"",a=""!==a?"ForwardRef("+a+")":"ForwardRef");return a;case Ga:return b=a.displayName||null,null!==b?b:Qa(a.type)||"Memo";case Ha:b=a._payload;a=a._init;try{return Qa(a(b))}catch(c){}}return null}
	function Ra(a){var b=a.type;switch(a.tag){case 24:return"Cache";case 9:return(b.displayName||"Context")+".Consumer";case 10:return(b._context.displayName||"Context")+".Provider";case 18:return"DehydratedFragment";case 11:return a=b.render,a=a.displayName||a.name||"",b.displayName||(""!==a?"ForwardRef("+a+")":"ForwardRef");case 7:return"Fragment";case 5:return b;case 4:return"Portal";case 3:return"Root";case 6:return"Text";case 16:return Qa(b);case 8:return b===za?"StrictMode":"Mode";case 22:return"Offscreen";
	case 12:return"Profiler";case 21:return"Scope";case 13:return"Suspense";case 19:return"SuspenseList";case 25:return"TracingMarker";case 1:case 0:case 17:case 2:case 14:case 15:if("function"===typeof b)return b.displayName||b.name||null;if("string"===typeof b)return b}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "string":case "undefined":return a;case "object":return a;default:return""}}
	function Ta(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a))}function Wa(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
	function Ya(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function ab(a,b){b=b.checked;null!=b&&ta(a,"checked",b,!1)}
	function bb(a,b){ab(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?cb(a,b.type,c):b.hasOwnProperty("defaultValue")&&cb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function db(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function cb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var eb=Array.isArray;
	function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(p(91));return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(p(92));if(eb(c)){if(1<c.length)throw Error(p(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:Sa(c)}}
	function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}function kb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
	function lb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?kb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var mb,nb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if("http://www.w3.org/2000/svg"!==a.namespaceURI||"innerHTML"in a)a.innerHTML=b;else{mb=mb||document.createElement("div");mb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=mb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function ob(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var pb={animationIterationCount:!0,aspectRatio:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,
	zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},qb=["Webkit","ms","Moz","O"];Object.keys(pb).forEach(function(a){qb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);pb[b]=pb[a]})});function rb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||pb.hasOwnProperty(a)&&pb[a]?(""+b).trim():b+"px"}
	function sb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=rb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var tb=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function ub(a,b){if(b){if(tb[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(p(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(p(60));if("object"!==typeof b.dangerouslySetInnerHTML||!("__html"in b.dangerouslySetInnerHTML))throw Error(p(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(p(62));}}
	function vb(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var wb=null;function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
	function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(p(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b))}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a])}}function Gb(a,b){return a(b)}function Hb(){}var Ib=!1;function Jb(a,b,c){if(Ib)return a(b,c);Ib=!0;try{return Gb(a,b,c)}finally{if(Ib=!1,null!==zb||null!==Ab)Hb(),Fb()}}
	function Kb(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==
	typeof c)throw Error(p(231,b,typeof c));return c}var Lb=!1;if(ia)try{var Mb={};Object.defineProperty(Mb,"passive",{get:function(){Lb=!0}});window.addEventListener("test",Mb,Mb);window.removeEventListener("test",Mb,Mb)}catch(a){Lb=!1}function Nb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var Ob=!1,Pb=null,Qb=!1,Rb=null,Sb={onError:function(a){Ob=!0;Pb=a}};function Tb(a,b,c,d,e,f,g,h,k){Ob=!1;Pb=null;Nb.apply(Sb,arguments)}
	function Ub(a,b,c,d,e,f,g,h,k){Tb.apply(this,arguments);if(Ob){if(Ob){var l=Pb;Ob=!1;Pb=null}else throw Error(p(198));Qb||(Qb=!0,Rb=l)}}function Vb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.flags&4098)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function Wb(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function Xb(a){if(Vb(a)!==a)throw Error(p(188));}
	function Yb(a){var b=a.alternate;if(!b){b=Vb(a);if(null===b)throw Error(p(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return Xb(e),a;if(f===d)return Xb(e),b;f=f.sibling}throw Error(p(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(p(189));}}if(c.alternate!==d)throw Error(p(190));}if(3!==c.tag)throw Error(p(188));return c.stateNode.current===c?a:b}function Zb(a){a=Yb(a);return null!==a?$b(a):null}function $b(a){if(5===a.tag||6===a.tag)return a;for(a=a.child;null!==a;){var b=$b(a);if(null!==b)return b;a=a.sibling}return null}
	var ac=ca.unstable_scheduleCallback,bc=ca.unstable_cancelCallback,cc=ca.unstable_shouldYield,dc=ca.unstable_requestPaint,B=ca.unstable_now,ec=ca.unstable_getCurrentPriorityLevel,fc=ca.unstable_ImmediatePriority,gc=ca.unstable_UserBlockingPriority,hc=ca.unstable_NormalPriority,ic=ca.unstable_LowPriority,jc=ca.unstable_IdlePriority,kc=null,lc=null;function mc(a){if(lc&&"function"===typeof lc.onCommitFiberRoot)try{lc.onCommitFiberRoot(kc,a,void 0,128===(a.current.flags&128))}catch(b){}}
	var oc=Math.clz32?Math.clz32:nc,pc=Math.log,qc=Math.LN2;function nc(a){a>>>=0;return 0===a?32:31-(pc(a)/qc|0)|0}var rc=64,sc=4194304;
	function tc(a){switch(a&-a){case 1:return 1;case 2:return 2;case 4:return 4;case 8:return 8;case 16:return 16;case 32:return 32;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return a&4194240;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return a&130023424;case 134217728:return 134217728;case 268435456:return 268435456;case 536870912:return 536870912;case 1073741824:return 1073741824;
	default:return a}}function uc(a,b){var c=a.pendingLanes;if(0===c)return 0;var d=0,e=a.suspendedLanes,f=a.pingedLanes,g=c&268435455;if(0!==g){var h=g&~e;0!==h?d=tc(h):(f&=g,0!==f&&(d=tc(f)))}else g=c&~e,0!==g?d=tc(g):0!==f&&(d=tc(f));if(0===d)return 0;if(0!==b&&b!==d&&0===(b&e)&&(e=d&-d,f=b&-b,e>=f||16===e&&0!==(f&4194240)))return b;0!==(d&4)&&(d|=c&16);b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-oc(b),e=1<<c,d|=a[c],b&=~e;return d}
	function vc(a,b){switch(a){case 1:case 2:case 4:return b+250;case 8:case 16:case 32:case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return b+5E3;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return-1;case 134217728:case 268435456:case 536870912:case 1073741824:return-1;default:return-1}}
	function wc(a,b){for(var c=a.suspendedLanes,d=a.pingedLanes,e=a.expirationTimes,f=a.pendingLanes;0<f;){var g=31-oc(f),h=1<<g,k=e[g];if(-1===k){if(0===(h&c)||0!==(h&d))e[g]=vc(h,b)}else k<=b&&(a.expiredLanes|=h);f&=~h}}function xc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function yc(){var a=rc;rc<<=1;0===(rc&4194240)&&(rc=64);return a}function zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
	function Ac(a,b,c){a.pendingLanes|=b;536870912!==b&&(a.suspendedLanes=0,a.pingedLanes=0);a=a.eventTimes;b=31-oc(b);a[b]=c}function Bc(a,b){var c=a.pendingLanes&~b;a.pendingLanes=b;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=b;a.mutableReadLanes&=b;a.entangledLanes&=b;b=a.entanglements;var d=a.eventTimes;for(a=a.expirationTimes;0<c;){var e=31-oc(c),f=1<<e;b[e]=0;d[e]=-1;a[e]=-1;c&=~f}}
	function Cc(a,b){var c=a.entangledLanes|=b;for(a=a.entanglements;c;){var d=31-oc(c),e=1<<d;e&b|a[d]&b&&(a[d]|=b);c&=~e}}var C=0;function Dc(a){a&=-a;return 1<a?4<a?0!==(a&268435455)?16:536870912:4:1}var Ec,Fc,Gc,Hc,Ic,Jc=!1,Kc=[],Lc=null,Mc=null,Nc=null,Oc=new Map,Pc=new Map,Qc=[],Rc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
	function Sc(a,b){switch(a){case "focusin":case "focusout":Lc=null;break;case "dragenter":case "dragleave":Mc=null;break;case "mouseover":case "mouseout":Nc=null;break;case "pointerover":case "pointerout":Oc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Pc.delete(b.pointerId)}}
	function Tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a={blockedOn:b,domEventName:c,eventSystemFlags:d,nativeEvent:f,targetContainers:[e]},null!==b&&(b=Cb(b),null!==b&&Fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
	function Uc(a,b,c,d,e){switch(b){case "focusin":return Lc=Tc(Lc,a,b,c,d,e),!0;case "dragenter":return Mc=Tc(Mc,a,b,c,d,e),!0;case "mouseover":return Nc=Tc(Nc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Oc.set(f,Tc(Oc.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Pc.set(f,Tc(Pc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Vc(a){var b=Wc(a.target);if(null!==b){var c=Vb(b);if(null!==c)if(b=c.tag,13===b){if(b=Wb(c),null!==b){a.blockedOn=b;Ic(a.priority,function(){Gc(c)});return}}else if(3===b&&c.stateNode.current.memoizedState.isDehydrated){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}
	function Xc(a){if(null!==a.blockedOn)return!1;for(var b=a.targetContainers;0<b.length;){var c=Yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null===c){c=a.nativeEvent;var d=new c.constructor(c.type,c);wb=d;c.target.dispatchEvent(d);wb=null}else return b=Cb(c),null!==b&&Fc(b),a.blockedOn=c,!1;b.shift()}return!0}function Zc(a,b,c){Xc(a)&&c.delete(b)}function $c(){Jc=!1;null!==Lc&&Xc(Lc)&&(Lc=null);null!==Mc&&Xc(Mc)&&(Mc=null);null!==Nc&&Xc(Nc)&&(Nc=null);Oc.forEach(Zc);Pc.forEach(Zc)}
	function ad(a,b){a.blockedOn===b&&(a.blockedOn=null,Jc||(Jc=!0,ca.unstable_scheduleCallback(ca.unstable_NormalPriority,$c)))}
	function bd(a){function b(b){return ad(b,a)}if(0<Kc.length){ad(Kc[0],a);for(var c=1;c<Kc.length;c++){var d=Kc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Lc&&ad(Lc,a);null!==Mc&&ad(Mc,a);null!==Nc&&ad(Nc,a);Oc.forEach(b);Pc.forEach(b);for(c=0;c<Qc.length;c++)d=Qc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Qc.length&&(c=Qc[0],null===c.blockedOn);)Vc(c),null===c.blockedOn&&Qc.shift()}var cd=ua.ReactCurrentBatchConfig,dd=!0;
	function ed(a,b,c,d){var e=C,f=cd.transition;cd.transition=null;try{C=1,fd(a,b,c,d)}finally{C=e,cd.transition=f}}function gd(a,b,c,d){var e=C,f=cd.transition;cd.transition=null;try{C=4,fd(a,b,c,d)}finally{C=e,cd.transition=f}}
	function fd(a,b,c,d){if(dd){var e=Yc(a,b,c,d);if(null===e)hd(a,b,d,id,c),Sc(a,d);else if(Uc(e,a,b,c,d))d.stopPropagation();else if(Sc(a,d),b&4&&-1<Rc.indexOf(a)){for(;null!==e;){var f=Cb(e);null!==f&&Ec(f);f=Yc(a,b,c,d);null===f&&hd(a,b,d,id,c);if(f===e)break;e=f}null!==e&&d.stopPropagation()}else hd(a,b,d,null,c)}}var id=null;
	function Yc(a,b,c,d){id=null;a=xb(d);a=Wc(a);if(null!==a)if(b=Vb(a),null===b)a=null;else if(c=b.tag,13===c){a=Wb(b);if(null!==a)return a;a=null}else if(3===c){if(b.stateNode.current.memoizedState.isDehydrated)return 3===b.tag?b.stateNode.containerInfo:null;a=null}else b!==a&&(a=null);id=a;return null}
	function jd(a){switch(a){case "cancel":case "click":case "close":case "contextmenu":case "copy":case "cut":case "auxclick":case "dblclick":case "dragend":case "dragstart":case "drop":case "focusin":case "focusout":case "input":case "invalid":case "keydown":case "keypress":case "keyup":case "mousedown":case "mouseup":case "paste":case "pause":case "play":case "pointercancel":case "pointerdown":case "pointerup":case "ratechange":case "reset":case "resize":case "seeked":case "submit":case "touchcancel":case "touchend":case "touchstart":case "volumechange":case "change":case "selectionchange":case "textInput":case "compositionstart":case "compositionend":case "compositionupdate":case "beforeblur":case "afterblur":case "beforeinput":case "blur":case "fullscreenchange":case "focus":case "hashchange":case "popstate":case "select":case "selectstart":return 1;case "drag":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "mousemove":case "mouseout":case "mouseover":case "pointermove":case "pointerout":case "pointerover":case "scroll":case "toggle":case "touchmove":case "wheel":case "mouseenter":case "mouseleave":case "pointerenter":case "pointerleave":return 4;
	case "message":switch(ec()){case fc:return 1;case gc:return 4;case hc:case ic:return 16;case jc:return 536870912;default:return 16}default:return 16}}var kd=null,ld=null,md=null;function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}
	function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return!0}function qd(){return!1}
	function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}A(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
	(a.returnValue=!1),this.isDefaultPrevented=pd)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd)},persist:function(){},isPersistent:pd});return b}
	var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=A({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=A({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
	a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return"movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=A({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=A({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=A({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=A({},sd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=A({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
	Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
	119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
	var Qd=A({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return"keypress"===a.type?od(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
	a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=A({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=A({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=A({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=A({},Ad,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
	deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=ia&&"CompositionEvent"in window,be=null;ia&&"documentMode"in document&&(be=document.documentMode);var ce=ia&&"TextEvent"in window&&!be,de=ia&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
	function ge(a,b){switch(a){case "keyup":return-1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return!0;default:return!1}}function he(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
	function ke(a,b){if(ie)return"compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
	var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}))}var pe=null,qe=null;function re(a){se(a,0)}function te(a){var b=ue(a);if(Wa(b))return a}
	function ve(a,b){if("change"===a)return b}var we=!1;if(ia){var xe;if(ia){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput}xe=ye}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode)}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null)}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));Jb(re,b)}}
	function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae()}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge;
	function Ie(a,b){if(He(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++){var e=c[d];if(!ja.call(b,e)||!He(a[e],b[e]))return!1}return!0}function Je(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Ke(a,b){var c=Je(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Je(c)}}function Le(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Le(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Me(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xa(a.document)}return b}function Ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	function Oe(a){var b=Me(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Le(c.ownerDocument.documentElement,c)){if(null!==d&&Ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ke(c,f);var g=Ke(c,
	d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
	var Pe=ia&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
	function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Ne(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Ie(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)))}
	function Ve(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var We={animationend:Ve("Animation","AnimationEnd"),animationiteration:Ve("Animation","AnimationIteration"),animationstart:Ve("Animation","AnimationStart"),transitionend:Ve("Transition","TransitionEnd")},Xe={},Ye={};
	ia&&(Ye=document.createElement("div").style,"AnimationEvent"in window||(delete We.animationend.animation,delete We.animationiteration.animation,delete We.animationstart.animation),"TransitionEvent"in window||delete We.transitionend.transition);function Ze(a){if(Xe[a])return Xe[a];if(!We[a])return a;var b=We[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Ye)return Xe[a]=b[c];return a}var $e=Ze("animationend"),af=Ze("animationiteration"),bf=Ze("animationstart"),cf=Ze("transitionend"),df=new Map,ef="abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
	function ff(a,b){df.set(a,b);fa(b,[a])}for(var gf=0;gf<ef.length;gf++){var hf=ef[gf],jf=hf.toLowerCase(),kf=hf[0].toUpperCase()+hf.slice(1);ff(jf,"on"+kf)}ff($e,"onAnimationEnd");ff(af,"onAnimationIteration");ff(bf,"onAnimationStart");ff("dblclick","onDoubleClick");ff("focusin","onFocus");ff("focusout","onBlur");ff(cf,"onTransitionEnd");ha("onMouseEnter",["mouseout","mouseover"]);ha("onMouseLeave",["mouseout","mouseover"]);ha("onPointerEnter",["pointerout","pointerover"]);
	ha("onPointerLeave",["pointerout","pointerover"]);fa("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));fa("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));fa("onBeforeInput",["compositionend","keypress","textInput","paste"]);fa("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));fa("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));
	fa("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var lf="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),mf=new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
	function nf(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Ub(d,b,void 0,a);a.currentTarget=null}
	function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;nf(e,h,l);f=k}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;nf(e,h,l);f=k}}}if(Qb)throw a=Rb,Qb=!1,Rb=null,a;}
	function D(a,b){var c=b[of];void 0===c&&(c=b[of]=new Set);var d=a+"__bubble";c.has(d)||(pf(b,a,2,!1),c.add(d))}function qf(a,b,c){var d=0;b&&(d|=4);pf(c,a,d,b)}var rf="_reactListening"+Math.random().toString(36).slice(2);function sf(a){if(!a[rf]){a[rf]=!0;da.forEach(function(b){"selectionchange"!==b&&(mf.has(b)||qf(b,!1,a),qf(b,!0,a))});var b=9===a.nodeType?a:a.ownerDocument;null===b||b[rf]||(b[rf]=!0,qf("selectionchange",!1,b))}}
	function pf(a,b,c,d){switch(jd(b)){case 1:var e=ed;break;case 4:e=gd;break;default:e=fd}c=e.bind(null,b,c,a);e=void 0;!Lb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1)}
	function hd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return}for(;null!==h;){g=Wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode}}d=d.return}Jb(function(){var d=f,e=xb(c),g=[];
	a:{var h=df.get(a);if(void 0!==h){var k=td,n=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":n="focus";k=Fd;break;case "focusout":n="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
	Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case $e:case af:case bf:k=Hd;break;case cf:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td}var t=0!==(b&4),J=!t&&"scroll"===a,x=t?null!==h?h+"Capture":null:h;t=[];for(var w=d,u;null!==
	w;){u=w;var F=u.stateNode;5===u.tag&&null!==F&&(u=F,null!==x&&(F=Kb(w,x),null!=F&&t.push(tf(w,F,u))));if(J)break;w=w.return}0<t.length&&(h=new k(h,n,null,c,e),g.push({event:h,listeners:t}))}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&c!==wb&&(n=c.relatedTarget||c.fromElement)&&(Wc(n)||n[uf]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(n=c.relatedTarget||c.toElement,k=d,n=n?Wc(n):null,null!==
	n&&(J=Vb(n),n!==J||5!==n.tag&&6!==n.tag))n=null}else k=null,n=d;if(k!==n){t=Bd;F="onMouseLeave";x="onMouseEnter";w="mouse";if("pointerout"===a||"pointerover"===a)t=Td,F="onPointerLeave",x="onPointerEnter",w="pointer";J=null==k?h:ue(k);u=null==n?h:ue(n);h=new t(F,w+"leave",k,c,e);h.target=J;h.relatedTarget=u;F=null;Wc(e)===d&&(t=new t(x,w+"enter",n,c,e),t.target=u,t.relatedTarget=J,F=t);J=F;if(k&&n)b:{t=k;x=n;w=0;for(u=t;u;u=vf(u))w++;u=0;for(F=x;F;F=vf(F))u++;for(;0<w-u;)t=vf(t),w--;for(;0<u-w;)x=
	vf(x),u--;for(;w--;){if(t===x||null!==x&&t===x.alternate)break b;t=vf(t);x=vf(x)}t=null}else t=null;null!==k&&wf(g,h,k,t,!1);null!==n&&null!==J&&wf(g,J,n,t,!0)}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var na=ve;else if(me(h))if(we)na=Fe;else{na=De;var xa=Ce}else(k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(na=Ee);if(na&&(na=na(a,d))){ne(g,na,c,e);break a}xa&&xa(a,h,d);"focusout"===a&&(xa=h._wrapperState)&&
	xa.controlled&&"number"===h.type&&cb(h,"number",h.value)}xa=d?ue(d):window;switch(a){case "focusin":if(me(xa)||"true"===xa.contentEditable)Qe=xa,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e)}var $a;if(ae)b:{switch(a){case "compositionstart":var ba="onCompositionStart";break b;case "compositionend":ba="onCompositionEnd";
	break b;case "compositionupdate":ba="onCompositionUpdate";break b}ba=void 0}else ie?ge(a,c)&&(ba="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(ba="onCompositionStart");ba&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==ba?"onCompositionEnd"===ba&&ie&&($a=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),xa=oe(d,ba),0<xa.length&&(ba=new Ld(ba,a,null,c,e),g.push({event:ba,listeners:xa}),$a?ba.data=$a:($a=he(c),null!==$a&&(ba.data=$a))));if($a=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),
	0<d.length&&(e=new Ld("onBeforeInput","beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=$a)}se(g,b)})}function tf(a,b,c){return{instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Kb(a,c),null!=f&&d.unshift(tf(a,f,e)),f=Kb(a,b),null!=f&&d.push(tf(a,f,e)));a=a.return}return d}function vf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function wf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Kb(c,f),null!=k&&g.unshift(tf(c,k,h))):e||(k=Kb(c,f),null!=k&&g.push(tf(c,k,h))));c=c.return}0!==g.length&&a.push({event:b,listeners:g})}var xf=/\r\n?/g,yf=/\u0000|\uFFFD/g;function zf(a){return("string"===typeof a?a:""+a).replace(xf,"\n").replace(yf,"")}function Af(a,b,c){b=zf(b);if(zf(a)!==b&&c)throw Error(p(425));}function Bf(){}
	var Cf=null,Df=null;function Ef(a,b){return"textarea"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
	var Ff="function"===typeof setTimeout?setTimeout:void 0,Gf="function"===typeof clearTimeout?clearTimeout:void 0,Hf="function"===typeof Promise?Promise:void 0,Jf="function"===typeof queueMicrotask?queueMicrotask:"undefined"!==typeof Hf?function(a){return Hf.resolve(null).then(a).catch(If)}:Ff;function If(a){setTimeout(function(){throw a;})}
	function Kf(a,b){var c=b,d=0;do{var e=c.nextSibling;a.removeChild(c);if(e&&8===e.nodeType)if(c=e.data,"/$"===c){if(0===d){a.removeChild(e);bd(b);return}d--}else"$"!==c&&"$?"!==c&&"$!"!==c||d++;c=e}while(c);bd(b)}function Lf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break;if(8===b){b=a.data;if("$"===b||"$!"===b||"$?"===b)break;if("/$"===b)return null}}return a}
	function Mf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--}else"/$"===c&&b++}a=a.previousSibling}return null}var Nf=Math.random().toString(36).slice(2),Of="__reactFiber$"+Nf,Pf="__reactProps$"+Nf,uf="__reactContainer$"+Nf,of="__reactEvents$"+Nf,Qf="__reactListeners$"+Nf,Rf="__reactHandles$"+Nf;
	function Wc(a){var b=a[Of];if(b)return b;for(var c=a.parentNode;c;){if(b=c[uf]||c[Of]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Mf(a);null!==a;){if(c=a[Of])return c;a=Mf(a)}return b}a=c;c=a.parentNode}return null}function Cb(a){a=a[Of]||a[uf];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(p(33));}function Db(a){return a[Pf]||null}var Sf=[],Tf=-1;function Uf(a){return{current:a}}
	function E(a){0>Tf||(a.current=Sf[Tf],Sf[Tf]=null,Tf--)}function G(a,b){Tf++;Sf[Tf]=a.current;a.current=b}var Vf={},H=Uf(Vf),Wf=Uf(!1),Xf=Vf;function Yf(a,b){var c=a.type.contextTypes;if(!c)return Vf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}
	function Zf(a){a=a.childContextTypes;return null!==a&&void 0!==a}function $f(){E(Wf);E(H)}function ag(a,b,c){if(H.current!==Vf)throw Error(p(168));G(H,b);G(Wf,c)}function bg(a,b,c){var d=a.stateNode;b=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in b))throw Error(p(108,Ra(a)||"Unknown",e));return A({},c,d)}
	function cg(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Vf;Xf=H.current;G(H,a);G(Wf,Wf.current);return!0}function dg(a,b,c){var d=a.stateNode;if(!d)throw Error(p(169));c?(a=bg(a,b,Xf),d.__reactInternalMemoizedMergedChildContext=a,E(Wf),E(H),G(H,a)):E(Wf);G(Wf,c)}var eg=null,fg=!1,gg=!1;function hg(a){null===eg?eg=[a]:eg.push(a)}function ig(a){fg=!0;hg(a)}
	function jg(){if(!gg&&null!==eg){gg=!0;var a=0,b=C;try{var c=eg;for(C=1;a<c.length;a++){var d=c[a];do d=d(!0);while(null!==d)}eg=null;fg=!1}catch(e){throw null!==eg&&(eg=eg.slice(a+1)),ac(fc,jg),e;}finally{C=b,gg=!1}}return null}var kg=[],lg=0,mg=null,ng=0,og=[],pg=0,qg=null,rg=1,sg="";function tg(a,b){kg[lg++]=ng;kg[lg++]=mg;mg=a;ng=b}
	function ug(a,b,c){og[pg++]=rg;og[pg++]=sg;og[pg++]=qg;qg=a;var d=rg;a=sg;var e=32-oc(d)-1;d&=~(1<<e);c+=1;var f=32-oc(b)+e;if(30<f){var g=e-e%5;f=(d&(1<<g)-1).toString(32);d>>=g;e-=g;rg=1<<32-oc(b)+e|c<<e|d;sg=f+a}else rg=1<<f|c<<e|d,sg=a}function vg(a){null!==a.return&&(tg(a,1),ug(a,1,0))}function wg(a){for(;a===mg;)mg=kg[--lg],kg[lg]=null,ng=kg[--lg],kg[lg]=null;for(;a===qg;)qg=og[--pg],og[pg]=null,sg=og[--pg],og[pg]=null,rg=og[--pg],og[pg]=null}var xg=null,yg=null,I=!1,zg=null;
	function Ag(a,b){var c=Bg(5,null,null,0);c.elementType="DELETED";c.stateNode=b;c.return=a;b=a.deletions;null===b?(a.deletions=[c],a.flags|=16):b.push(c)}
	function Cg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,xg=a,yg=Lf(b.firstChild),!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,xg=a,yg=null,!0):!1;case 13:return b=8!==b.nodeType?null:b,null!==b?(c=null!==qg?{id:rg,overflow:sg}:null,a.memoizedState={dehydrated:b,treeContext:c,retryLane:1073741824},c=Bg(18,null,null,0),c.stateNode=b,c.return=a,a.child=c,xg=a,yg=
	null,!0):!1;default:return!1}}function Dg(a){return 0!==(a.mode&1)&&0===(a.flags&128)}function Eg(a){if(I){var b=yg;if(b){var c=b;if(!Cg(a,b)){if(Dg(a))throw Error(p(418));b=Lf(c.nextSibling);var d=xg;b&&Cg(a,b)?Ag(d,c):(a.flags=a.flags&-4097|2,I=!1,xg=a)}}else{if(Dg(a))throw Error(p(418));a.flags=a.flags&-4097|2;I=!1;xg=a}}}function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;xg=a}
	function Gg(a){if(a!==xg)return!1;if(!I)return Fg(a),I=!0,!1;var b;(b=3!==a.tag)&&!(b=5!==a.tag)&&(b=a.type,b="head"!==b&&"body"!==b&&!Ef(a.type,a.memoizedProps));if(b&&(b=yg)){if(Dg(a))throw Hg(),Error(p(418));for(;b;)Ag(a,b),b=Lf(b.nextSibling)}Fg(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(p(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){yg=Lf(a.nextSibling);break a}b--}else"$"!==c&&"$!"!==c&&"$?"!==c||b++}a=a.nextSibling}yg=
	null}}else yg=xg?Lf(a.stateNode.nextSibling):null;return!0}function Hg(){for(var a=yg;a;)a=Lf(a.nextSibling)}function Ig(){yg=xg=null;I=!1}function Jg(a){null===zg?zg=[a]:zg.push(a)}var Kg=ua.ReactCurrentBatchConfig;
	function Lg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(p(309));var d=c.stateNode}if(!d)throw Error(p(147,a));var e=d,f=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===f)return b.ref;b=function(a){var b=e.refs;null===a?delete b[f]:b[f]=a};b._stringRef=f;return b}if("string"!==typeof a)throw Error(p(284));if(!c._owner)throw Error(p(290,a));}return a}
	function Mg(a,b){a=Object.prototype.toString.call(b);throw Error(p(31,"[object Object]"===a?"object with keys {"+Object.keys(b).join(", ")+"}":a));}function Ng(a){var b=a._init;return b(a._payload)}
	function Og(a){function b(b,c){if(a){var d=b.deletions;null===d?(b.deletions=[c],b.flags|=16):d.push(c)}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Pg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return b.flags|=1048576,c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags|=2,c):d;b.flags|=2;return c}function g(b){a&&
	null===b.alternate&&(b.flags|=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Qg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){var f=c.type;if(f===ya)return m(a,b,c.props.children,d,c.key);if(null!==b&&(b.elementType===f||"object"===typeof f&&null!==f&&f.$$typeof===Ha&&Ng(f)===b.type))return d=e(b,c.props),d.ref=Lg(a,b,c),d.return=a,d;d=Rg(c.type,c.key,c.props,null,a.mode,d);d.ref=Lg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||
	b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=Sg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Tg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function q(a,b,c){if("string"===typeof b&&""!==b||"number"===typeof b)return b=Qg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case va:return c=Rg(b.type,b.key,b.props,null,a.mode,c),
	c.ref=Lg(a,null,b),c.return=a,c;case wa:return b=Sg(b,a.mode,c),b.return=a,b;case Ha:var d=b._init;return q(a,d(b._payload),c)}if(eb(b)||Ka(b))return b=Tg(b,a.mode,c,null),b.return=a,b;Mg(a,b)}return null}function r(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c&&""!==c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case va:return c.key===e?k(a,b,c,d):null;case wa:return c.key===e?l(a,b,c,d):null;case Ha:return e=c._init,r(a,
	b,e(c._payload),d)}if(eb(c)||Ka(c))return null!==e?null:m(a,b,c,d,null);Mg(a,c)}return null}function y(a,b,c,d,e){if("string"===typeof d&&""!==d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case va:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e);case wa:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e);case Ha:var f=d._init;return y(a,b,c,f(d._payload),e)}if(eb(d)||Ka(d))return a=a.get(c)||null,m(b,a,d,e,null);Mg(b,d)}return null}
	function n(e,g,h,k){for(var l=null,m=null,u=g,w=g=0,x=null;null!==u&&w<h.length;w++){u.index>w?(x=u,u=null):x=u.sibling;var n=r(e,u,h[w],k);if(null===n){null===u&&(u=x);break}a&&u&&null===n.alternate&&b(e,u);g=f(n,g,w);null===m?l=n:m.sibling=n;m=n;u=x}if(w===h.length)return c(e,u),I&&tg(e,w),l;if(null===u){for(;w<h.length;w++)u=q(e,h[w],k),null!==u&&(g=f(u,g,w),null===m?l=u:m.sibling=u,m=u);I&&tg(e,w);return l}for(u=d(e,u);w<h.length;w++)x=y(u,e,w,h[w],k),null!==x&&(a&&null!==x.alternate&&u.delete(null===
	x.key?w:x.key),g=f(x,g,w),null===m?l=x:m.sibling=x,m=x);a&&u.forEach(function(a){return b(e,a)});I&&tg(e,w);return l}function t(e,g,h,k){var l=Ka(h);if("function"!==typeof l)throw Error(p(150));h=l.call(h);if(null==h)throw Error(p(151));for(var u=l=null,m=g,w=g=0,x=null,n=h.next();null!==m&&!n.done;w++,n=h.next()){m.index>w?(x=m,m=null):x=m.sibling;var t=r(e,m,n.value,k);if(null===t){null===m&&(m=x);break}a&&m&&null===t.alternate&&b(e,m);g=f(t,g,w);null===u?l=t:u.sibling=t;u=t;m=x}if(n.done)return c(e,
	m),I&&tg(e,w),l;if(null===m){for(;!n.done;w++,n=h.next())n=q(e,n.value,k),null!==n&&(g=f(n,g,w),null===u?l=n:u.sibling=n,u=n);I&&tg(e,w);return l}for(m=d(e,m);!n.done;w++,n=h.next())n=y(m,e,w,n.value,k),null!==n&&(a&&null!==n.alternate&&m.delete(null===n.key?w:n.key),g=f(n,g,w),null===u?l=n:u.sibling=n,u=n);a&&m.forEach(function(a){return b(e,a)});I&&tg(e,w);return l}function J(a,d,f,h){"object"===typeof f&&null!==f&&f.type===ya&&null===f.key&&(f=f.props.children);if("object"===typeof f&&null!==f){switch(f.$$typeof){case va:a:{for(var k=
	f.key,l=d;null!==l;){if(l.key===k){k=f.type;if(k===ya){if(7===l.tag){c(a,l.sibling);d=e(l,f.props.children);d.return=a;a=d;break a}}else if(l.elementType===k||"object"===typeof k&&null!==k&&k.$$typeof===Ha&&Ng(k)===l.type){c(a,l.sibling);d=e(l,f.props);d.ref=Lg(a,l,f);d.return=a;a=d;break a}c(a,l);break}else b(a,l);l=l.sibling}f.type===ya?(d=Tg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Rg(f.type,f.key,f.props,null,a.mode,h),h.ref=Lg(a,d,f),h.return=a,a=h)}return g(a);case wa:a:{for(l=f.key;null!==
	d;){if(d.key===l)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Sg(f,a.mode,h);d.return=a;a=d}return g(a);case Ha:return l=f._init,J(a,d,l(f._payload),h)}if(eb(f))return n(a,d,f,h);if(Ka(f))return t(a,d,f,h);Mg(a,f)}return"string"===typeof f&&""!==f||"number"===typeof f?(f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):
	(c(a,d),d=Qg(f,a.mode,h),d.return=a,a=d),g(a)):c(a,d)}return J}var Ug=Og(!0),Vg=Og(!1),Wg=Uf(null),Xg=null,Yg=null,Zg=null;function $g(){Zg=Yg=Xg=null}function ah(a){var b=Wg.current;E(Wg);a._currentValue=b}function bh(a,b,c){for(;null!==a;){var d=a.alternate;(a.childLanes&b)!==b?(a.childLanes|=b,null!==d&&(d.childLanes|=b)):null!==d&&(d.childLanes&b)!==b&&(d.childLanes|=b);if(a===c)break;a=a.return}}
	function ch(a,b){Xg=a;Zg=Yg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(dh=!0),a.firstContext=null)}function eh(a){var b=a._currentValue;if(Zg!==a)if(a={context:a,memoizedValue:b,next:null},null===Yg){if(null===Xg)throw Error(p(308));Yg=a;Xg.dependencies={lanes:0,firstContext:a}}else Yg=Yg.next=a;return b}var fh=null;function gh(a){null===fh?fh=[a]:fh.push(a)}
	function hh(a,b,c,d){var e=b.interleaved;null===e?(c.next=c,gh(b)):(c.next=e.next,e.next=c);b.interleaved=c;return ih(a,d)}function ih(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}var jh=!1;function kh(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null,interleaved:null,lanes:0},effects:null}}
	function lh(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects})}function mh(a,b){return{eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}
	function nh(a,b,c){var d=a.updateQueue;if(null===d)return null;d=d.shared;if(0!==(K&2)){var e=d.pending;null===e?b.next=b:(b.next=e.next,e.next=b);d.pending=b;return ih(a,c)}e=d.interleaved;null===e?(b.next=b,gh(d)):(b.next=e.next,e.next=b);d.interleaved=b;return ih(a,c)}function oh(a,b,c){b=b.updateQueue;if(null!==b&&(b=b.shared,0!==(c&4194240))){var d=b.lanes;d&=a.pendingLanes;c|=d;b.lanes=c;Cc(a,c)}}
	function ph(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next}while(null!==c);null===f?e=f=b:f=f.next=b}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
	b;c.lastBaseUpdate=b}
	function qh(a,b,c,d){var e=a.updateQueue;jh=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var m=a.alternate;null!==m&&(m=m.updateQueue,h=m.lastBaseUpdate,h!==g&&(null===h?m.firstBaseUpdate=l:h.next=l,m.lastBaseUpdate=k))}if(null!==f){var q=e.baseState;g=0;m=l=k=null;h=f;do{var r=h.lane,y=h.eventTime;if((d&r)===r){null!==m&&(m=m.next={eventTime:y,lane:0,tag:h.tag,payload:h.payload,callback:h.callback,
	next:null});a:{var n=a,t=h;r=b;y=c;switch(t.tag){case 1:n=t.payload;if("function"===typeof n){q=n.call(y,q,r);break a}q=n;break a;case 3:n.flags=n.flags&-65537|128;case 0:n=t.payload;r="function"===typeof n?n.call(y,q,r):n;if(null===r||void 0===r)break a;q=A({},q,r);break a;case 2:jh=!0}}null!==h.callback&&0!==h.lane&&(a.flags|=64,r=e.effects,null===r?e.effects=[h]:r.push(h))}else y={eventTime:y,lane:r,tag:h.tag,payload:h.payload,callback:h.callback,next:null},null===m?(l=m=y,k=q):m=m.next=y,g|=r;
	h=h.next;if(null===h)if(h=e.shared.pending,null===h)break;else r=h,h=r.next,r.next=null,e.lastBaseUpdate=r,e.shared.pending=null}while(1);null===m&&(k=q);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=m;b=e.shared.interleaved;if(null!==b){e=b;do g|=e.lane,e=e.next;while(e!==b)}else null===f&&(e.shared.lanes=0);rh|=g;a.lanes=g;a.memoizedState=q}}
	function sh(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(p(191,e));e.call(d)}}}var th={},uh=Uf(th),vh=Uf(th),wh=Uf(th);function xh(a){if(a===th)throw Error(p(174));return a}
	function yh(a,b){G(wh,b);G(vh,a);G(uh,th);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:lb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=lb(b,a)}E(uh);G(uh,b)}function zh(){E(uh);E(vh);E(wh)}function Ah(a){xh(wh.current);var b=xh(uh.current);var c=lb(b,a.type);b!==c&&(G(vh,a),G(uh,c))}function Bh(a){vh.current===a&&(E(uh),E(vh))}var L=Uf(0);
	function Ch(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&128))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}var Dh=[];
	function Eh(){for(var a=0;a<Dh.length;a++)Dh[a]._workInProgressVersionPrimary=null;Dh.length=0}var Fh=ua.ReactCurrentDispatcher,Gh=ua.ReactCurrentBatchConfig,Hh=0,M=null,N=null,O=null,Ih=!1,Jh=!1,Kh=0,Lh=0;function P(){throw Error(p(321));}function Mh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return!1;return!0}
	function Nh(a,b,c,d,e,f){Hh=f;M=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;Fh.current=null===a||null===a.memoizedState?Oh:Ph;a=c(d,e);if(Jh){f=0;do{Jh=!1;Kh=0;if(25<=f)throw Error(p(301));f+=1;O=N=null;b.updateQueue=null;Fh.current=Qh;a=c(d,e)}while(Jh)}Fh.current=Rh;b=null!==N&&null!==N.next;Hh=0;O=N=M=null;Ih=!1;if(b)throw Error(p(300));return a}function Sh(){var a=0!==Kh;Kh=0;return a}
	function Th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===O?M.memoizedState=O=a:O=O.next=a;return O}function Uh(){if(null===N){var a=M.alternate;a=null!==a?a.memoizedState:null}else a=N.next;var b=null===O?M.memoizedState:O.next;if(null!==b)O=b,N=a;else{if(null===a)throw Error(p(310));N=a;a={memoizedState:N.memoizedState,baseState:N.baseState,baseQueue:N.baseQueue,queue:N.queue,next:null};null===O?M.memoizedState=O=a:O=O.next=a}return O}
	function Vh(a,b){return"function"===typeof b?b(a):b}
	function Wh(a){var b=Uh(),c=b.queue;if(null===c)throw Error(p(311));c.lastRenderedReducer=a;var d=N,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){f=e.next;d=d.baseState;var h=g=null,k=null,l=f;do{var m=l.lane;if((Hh&m)===m)null!==k&&(k=k.next={lane:0,action:l.action,hasEagerState:l.hasEagerState,eagerState:l.eagerState,next:null}),d=l.hasEagerState?l.eagerState:a(d,l.action);else{var q={lane:m,action:l.action,hasEagerState:l.hasEagerState,
	eagerState:l.eagerState,next:null};null===k?(h=k=q,g=d):k=k.next=q;M.lanes|=m;rh|=m}l=l.next}while(null!==l&&l!==f);null===k?g=d:k.next=h;He(d,b.memoizedState)||(dh=!0);b.memoizedState=d;b.baseState=g;b.baseQueue=k;c.lastRenderedState=d}a=c.interleaved;if(null!==a){e=a;do f=e.lane,M.lanes|=f,rh|=f,e=e.next;while(e!==a)}else null===e&&(c.lanes=0);return[b.memoizedState,c.dispatch]}
	function Xh(a){var b=Uh(),c=b.queue;if(null===c)throw Error(p(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(dh=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}function Yh(){}
	function Zh(a,b){var c=M,d=Uh(),e=b(),f=!He(d.memoizedState,e);f&&(d.memoizedState=e,dh=!0);d=d.queue;$h(ai.bind(null,c,d,a),[a]);if(d.getSnapshot!==b||f||null!==O&&O.memoizedState.tag&1){c.flags|=2048;bi(9,ci.bind(null,c,d,e,b),void 0,null);if(null===Q)throw Error(p(349));0!==(Hh&30)||di(c,b,e)}return e}function di(a,b,c){a.flags|=16384;a={getSnapshot:b,value:c};b=M.updateQueue;null===b?(b={lastEffect:null,stores:null},M.updateQueue=b,b.stores=[a]):(c=b.stores,null===c?b.stores=[a]:c.push(a))}
	function ci(a,b,c,d){b.value=c;b.getSnapshot=d;ei(b)&&fi(a)}function ai(a,b,c){return c(function(){ei(b)&&fi(a)})}function ei(a){var b=a.getSnapshot;a=a.value;try{var c=b();return!He(a,c)}catch(d){return!0}}function fi(a){var b=ih(a,1);null!==b&&gi(b,a,1,-1)}
	function hi(a){var b=Th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:Vh,lastRenderedState:a};b.queue=a;a=a.dispatch=ii.bind(null,M,a);return[b.memoizedState,a]}
	function bi(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=M.updateQueue;null===b?(b={lastEffect:null,stores:null},M.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function ji(){return Uh().memoizedState}function ki(a,b,c,d){var e=Th();M.flags|=a;e.memoizedState=bi(1|b,c,void 0,void 0===d?null:d)}
	function li(a,b,c,d){var e=Uh();d=void 0===d?null:d;var f=void 0;if(null!==N){var g=N.memoizedState;f=g.destroy;if(null!==d&&Mh(d,g.deps)){e.memoizedState=bi(b,c,f,d);return}}M.flags|=a;e.memoizedState=bi(1|b,c,f,d)}function mi(a,b){return ki(8390656,8,a,b)}function $h(a,b){return li(2048,8,a,b)}function ni(a,b){return li(4,2,a,b)}function oi(a,b){return li(4,4,a,b)}
	function pi(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function qi(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return li(4,4,pi.bind(null,b,a),c)}function ri(){}function si(a,b){var c=Uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Mh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function ti(a,b){var c=Uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Mh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function ui(a,b,c){if(0===(Hh&21))return a.baseState&&(a.baseState=!1,dh=!0),a.memoizedState=c;He(c,b)||(c=yc(),M.lanes|=c,rh|=c,a.baseState=!0);return b}function vi(a,b){var c=C;C=0!==c&&4>c?c:4;a(!0);var d=Gh.transition;Gh.transition={};try{a(!1),b()}finally{C=c,Gh.transition=d}}function wi(){return Uh().memoizedState}
	function xi(a,b,c){var d=yi(a);c={lane:d,action:c,hasEagerState:!1,eagerState:null,next:null};if(zi(a))Ai(b,c);else if(c=hh(a,b,c,d),null!==c){var e=R();gi(c,a,d,e);Bi(c,b,d)}}
	function ii(a,b,c){var d=yi(a),e={lane:d,action:c,hasEagerState:!1,eagerState:null,next:null};if(zi(a))Ai(b,e);else{var f=a.alternate;if(0===a.lanes&&(null===f||0===f.lanes)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.hasEagerState=!0;e.eagerState=h;if(He(h,g)){var k=b.interleaved;null===k?(e.next=e,gh(b)):(e.next=k.next,k.next=e);b.interleaved=e;return}}catch(l){}finally{}c=hh(a,b,e,d);null!==c&&(e=R(),gi(c,a,d,e),Bi(c,b,d))}}
	function zi(a){var b=a.alternate;return a===M||null!==b&&b===M}function Ai(a,b){Jh=Ih=!0;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}function Bi(a,b,c){if(0!==(c&4194240)){var d=b.lanes;d&=a.pendingLanes;c|=d;b.lanes=c;Cc(a,c)}}
	var Rh={readContext:eh,useCallback:P,useContext:P,useEffect:P,useImperativeHandle:P,useInsertionEffect:P,useLayoutEffect:P,useMemo:P,useReducer:P,useRef:P,useState:P,useDebugValue:P,useDeferredValue:P,useTransition:P,useMutableSource:P,useSyncExternalStore:P,useId:P,unstable_isNewReconciler:!1},Oh={readContext:eh,useCallback:function(a,b){Th().memoizedState=[a,void 0===b?null:b];return a},useContext:eh,useEffect:mi,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ki(4194308,
	4,pi.bind(null,b,a),c)},useLayoutEffect:function(a,b){return ki(4194308,4,a,b)},useInsertionEffect:function(a,b){return ki(4,2,a,b)},useMemo:function(a,b){var c=Th();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};d.queue=a;a=a.dispatch=xi.bind(null,M,a);return[d.memoizedState,a]},useRef:function(a){var b=
	Th();a={current:a};return b.memoizedState=a},useState:hi,useDebugValue:ri,useDeferredValue:function(a){return Th().memoizedState=a},useTransition:function(){var a=hi(!1),b=a[0];a=vi.bind(null,a[1]);Th().memoizedState=a;return[b,a]},useMutableSource:function(){},useSyncExternalStore:function(a,b,c){var d=M,e=Th();if(I){if(void 0===c)throw Error(p(407));c=c()}else{c=b();if(null===Q)throw Error(p(349));0!==(Hh&30)||di(d,b,c)}e.memoizedState=c;var f={value:c,getSnapshot:b};e.queue=f;mi(ai.bind(null,d,
	f,a),[a]);d.flags|=2048;bi(9,ci.bind(null,d,f,c,b),void 0,null);return c},useId:function(){var a=Th(),b=Q.identifierPrefix;if(I){var c=sg;var d=rg;c=(d&~(1<<32-oc(d)-1)).toString(32)+c;b=":"+b+"R"+c;c=Kh++;0<c&&(b+="H"+c.toString(32));b+=":"}else c=Lh++,b=":"+b+"r"+c.toString(32)+":";return a.memoizedState=b},unstable_isNewReconciler:!1},Ph={readContext:eh,useCallback:si,useContext:eh,useEffect:$h,useImperativeHandle:qi,useInsertionEffect:ni,useLayoutEffect:oi,useMemo:ti,useReducer:Wh,useRef:ji,useState:function(){return Wh(Vh)},
	useDebugValue:ri,useDeferredValue:function(a){var b=Uh();return ui(b,N.memoizedState,a)},useTransition:function(){var a=Wh(Vh)[0],b=Uh().memoizedState;return[a,b]},useMutableSource:Yh,useSyncExternalStore:Zh,useId:wi,unstable_isNewReconciler:!1},Qh={readContext:eh,useCallback:si,useContext:eh,useEffect:$h,useImperativeHandle:qi,useInsertionEffect:ni,useLayoutEffect:oi,useMemo:ti,useReducer:Xh,useRef:ji,useState:function(){return Xh(Vh)},useDebugValue:ri,useDeferredValue:function(a){var b=Uh();return null===
	N?b.memoizedState=a:ui(b,N.memoizedState,a)},useTransition:function(){var a=Xh(Vh)[0],b=Uh().memoizedState;return[a,b]},useMutableSource:Yh,useSyncExternalStore:Zh,useId:wi,unstable_isNewReconciler:!1};function Ci(a,b){if(a&&a.defaultProps){b=A({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}function Di(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:A({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c)}
	var Ei={isMounted:function(a){return(a=a._reactInternals)?Vb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=R(),e=yi(a),f=mh(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);b=nh(a,f,e);null!==b&&(gi(b,a,e,d),oh(b,a,e))},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=R(),e=yi(a),f=mh(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);b=nh(a,f,e);null!==b&&(gi(b,a,e,d),oh(b,a,e))},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=R(),d=
	yi(a),e=mh(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=b);b=nh(a,e,d);null!==b&&(gi(b,a,d,c),oh(b,a,d))}};function Fi(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Ie(c,d)||!Ie(e,f):!0}
	function Gi(a,b,c){var d=!1,e=Vf;var f=b.contextType;"object"===typeof f&&null!==f?f=eh(f):(e=Zf(b)?Xf:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Yf(a,e):Vf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Ei;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Hi(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Ei.enqueueReplaceState(b,b.state,null)}
	function Ii(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs={};kh(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=eh(f):(f=Zf(b)?Xf:H.current,e.context=Yf(a,f));e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Di(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(b=e.state,
	"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Ei.enqueueReplaceState(e,e.state,null),qh(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4194308)}function Ji(a,b){try{var c="",d=b;do c+=Pa(d),d=d.return;while(d);var e=c}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack}return{value:a,source:b,stack:e,digest:null}}
	function Ki(a,b,c){return{value:a,source:null,stack:null!=c?c:null,digest:null!=b?b:null}}function Li(a,b){try{console.error(b.value)}catch(c){setTimeout(function(){throw c;})}}var Mi="function"===typeof WeakMap?WeakMap:Map;function Ni(a,b,c){c=mh(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Oi||(Oi=!0,Pi=d);Li(a,b)};return c}
	function Qi(a,b,c){c=mh(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)};c.callback=function(){Li(a,b)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){Li(a,b);"function"!==typeof d&&(null===Ri?Ri=new Set([this]):Ri.add(this));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	function Si(a,b,c){var d=a.pingCache;if(null===d){d=a.pingCache=new Mi;var e=new Set;d.set(b,e)}else e=d.get(b),void 0===e&&(e=new Set,d.set(b,e));e.has(c)||(e.add(c),a=Ti.bind(null,a,b,c),b.then(a,a))}function Ui(a){do{var b;if(b=13===a.tag)b=a.memoizedState,b=null!==b?null!==b.dehydrated?!0:!1:!0;if(b)return a;a=a.return}while(null!==a);return null}
	function Vi(a,b,c,d,e){if(0===(a.mode&1))return a===b?a.flags|=65536:(a.flags|=128,c.flags|=131072,c.flags&=-52805,1===c.tag&&(null===c.alternate?c.tag=17:(b=mh(-1,1),b.tag=2,nh(c,b,1))),c.lanes|=1),a;a.flags|=65536;a.lanes=e;return a}var Wi=ua.ReactCurrentOwner,dh=!1;function Xi(a,b,c,d){b.child=null===a?Vg(b,null,c,d):Ug(b,a.child,c,d)}
	function Yi(a,b,c,d,e){c=c.render;var f=b.ref;ch(b,e);d=Nh(a,b,c,d,f,e);c=Sh();if(null!==a&&!dh)return b.updateQueue=a.updateQueue,b.flags&=-2053,a.lanes&=~e,Zi(a,b,e);I&&c&&vg(b);b.flags|=1;Xi(a,b,d,e);return b.child}
	function $i(a,b,c,d,e){if(null===a){var f=c.type;if("function"===typeof f&&!aj(f)&&void 0===f.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=f,bj(a,b,f,d,e);a=Rg(c.type,null,d,b,b.mode,e);a.ref=b.ref;a.return=b;return b.child=a}f=a.child;if(0===(a.lanes&e)){var g=f.memoizedProps;c=c.compare;c=null!==c?c:Ie;if(c(g,d)&&a.ref===b.ref)return Zi(a,b,e)}b.flags|=1;a=Pg(f,d);a.ref=b.ref;a.return=b;return b.child=a}
	function bj(a,b,c,d,e){if(null!==a){var f=a.memoizedProps;if(Ie(f,d)&&a.ref===b.ref)if(dh=!1,b.pendingProps=d=f,0!==(a.lanes&e))0!==(a.flags&131072)&&(dh=!0);else return b.lanes=a.lanes,Zi(a,b,e)}return cj(a,b,c,d,e)}
	function dj(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode)if(0===(b.mode&1))b.memoizedState={baseLanes:0,cachePool:null,transitions:null},G(ej,fj),fj|=c;else{if(0===(c&1073741824))return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a,cachePool:null,transitions:null},b.updateQueue=null,G(ej,fj),fj|=a,null;b.memoizedState={baseLanes:0,cachePool:null,transitions:null};d=null!==f?f.baseLanes:c;G(ej,fj);fj|=d}else null!==
	f?(d=f.baseLanes|c,b.memoizedState=null):d=c,G(ej,fj),fj|=d;Xi(a,b,e,c);return b.child}function gj(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=512,b.flags|=2097152}function cj(a,b,c,d,e){var f=Zf(c)?Xf:H.current;f=Yf(b,f);ch(b,e);c=Nh(a,b,c,d,f,e);d=Sh();if(null!==a&&!dh)return b.updateQueue=a.updateQueue,b.flags&=-2053,a.lanes&=~e,Zi(a,b,e);I&&d&&vg(b);b.flags|=1;Xi(a,b,c,e);return b.child}
	function hj(a,b,c,d,e){if(Zf(c)){var f=!0;cg(b)}else f=!1;ch(b,e);if(null===b.stateNode)ij(a,b),Gi(b,c,d),Ii(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=eh(l):(l=Zf(c)?Xf:H.current,l=Yf(b,l));var m=c.getDerivedStateFromProps,q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;q||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||
	(h!==d||k!==l)&&Hi(b,g,d,l);jh=!1;var r=b.memoizedState;g.state=r;qh(b,d,g,e);k=b.memoizedState;h!==d||r!==k||Wf.current||jh?("function"===typeof m&&(Di(b,c,m,d),k=b.memoizedState),(h=jh||Fi(b,c,h,d,r,k,l))?(q||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.flags|=4194308)):
	("function"===typeof g.componentDidMount&&(b.flags|=4194308),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4194308),d=!1)}else{g=b.stateNode;lh(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:Ci(b.type,h);g.props=l;q=b.pendingProps;r=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=eh(k):(k=Zf(c)?Xf:H.current,k=Yf(b,k));var y=c.getDerivedStateFromProps;(m="function"===typeof y||"function"===typeof g.getSnapshotBeforeUpdate)||
	"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==q||r!==k)&&Hi(b,g,d,k);jh=!1;r=b.memoizedState;g.state=r;qh(b,d,g,e);var n=b.memoizedState;h!==q||r!==n||Wf.current||jh?("function"===typeof y&&(Di(b,c,y,d),n=b.memoizedState),(l=jh||Fi(b,c,l,d,r,n,k)||!1)?(m||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,n,k),"function"===typeof g.UNSAFE_componentWillUpdate&&
	g.UNSAFE_componentWillUpdate(d,n,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=1024)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=1024),b.memoizedProps=d,b.memoizedState=n),g.props=d,g.state=n,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&r===
	a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=1024),d=!1)}return jj(a,b,c,d,f,e)}
	function jj(a,b,c,d,e,f){gj(a,b);var g=0!==(b.flags&128);if(!d&&!g)return e&&dg(b,c,!1),Zi(a,b,f);d=b.stateNode;Wi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Ug(b,a.child,null,f),b.child=Ug(b,null,h,f)):Xi(a,b,h,f);b.memoizedState=d.state;e&&dg(b,c,!0);return b.child}function kj(a){var b=a.stateNode;b.pendingContext?ag(a,b.pendingContext,b.pendingContext!==b.context):b.context&&ag(a,b.context,!1);yh(a,b.containerInfo)}
	function lj(a,b,c,d,e){Ig();Jg(e);b.flags|=256;Xi(a,b,c,d);return b.child}var mj={dehydrated:null,treeContext:null,retryLane:0};function nj(a){return{baseLanes:a,cachePool:null,transitions:null}}
	function oj(a,b,c){var d=b.pendingProps,e=L.current,f=!1,g=0!==(b.flags&128),h;(h=g)||(h=null!==a&&null===a.memoizedState?!1:0!==(e&2));if(h)f=!0,b.flags&=-129;else if(null===a||null!==a.memoizedState)e|=1;G(L,e&1);if(null===a){Eg(b);a=b.memoizedState;if(null!==a&&(a=a.dehydrated,null!==a))return 0===(b.mode&1)?b.lanes=1:"$!"===a.data?b.lanes=8:b.lanes=1073741824,null;g=d.children;a=d.fallback;return f?(d=b.mode,f=b.child,g={mode:"hidden",children:g},0===(d&1)&&null!==f?(f.childLanes=0,f.pendingProps=
	g):f=pj(g,d,0,null),a=Tg(a,d,c,null),f.return=b,a.return=b,f.sibling=a,b.child=f,b.child.memoizedState=nj(c),b.memoizedState=mj,a):qj(b,g)}e=a.memoizedState;if(null!==e&&(h=e.dehydrated,null!==h))return rj(a,b,g,d,h,e,c);if(f){f=d.fallback;g=b.mode;e=a.child;h=e.sibling;var k={mode:"hidden",children:d.children};0===(g&1)&&b.child!==e?(d=b.child,d.childLanes=0,d.pendingProps=k,b.deletions=null):(d=Pg(e,k),d.subtreeFlags=e.subtreeFlags&14680064);null!==h?f=Pg(h,f):(f=Tg(f,g,c,null),f.flags|=2);f.return=
	b;d.return=b;d.sibling=f;b.child=d;d=f;f=b.child;g=a.child.memoizedState;g=null===g?nj(c):{baseLanes:g.baseLanes|c,cachePool:null,transitions:g.transitions};f.memoizedState=g;f.childLanes=a.childLanes&~c;b.memoizedState=mj;return d}f=a.child;a=f.sibling;d=Pg(f,{mode:"visible",children:d.children});0===(b.mode&1)&&(d.lanes=c);d.return=b;d.sibling=null;null!==a&&(c=b.deletions,null===c?(b.deletions=[a],b.flags|=16):c.push(a));b.child=d;b.memoizedState=null;return d}
	function qj(a,b){b=pj({mode:"visible",children:b},a.mode,0,null);b.return=a;return a.child=b}function sj(a,b,c,d){null!==d&&Jg(d);Ug(b,a.child,null,c);a=qj(b,b.pendingProps.children);a.flags|=2;b.memoizedState=null;return a}
	function rj(a,b,c,d,e,f,g){if(c){if(b.flags&256)return b.flags&=-257,d=Ki(Error(p(422))),sj(a,b,g,d);if(null!==b.memoizedState)return b.child=a.child,b.flags|=128,null;f=d.fallback;e=b.mode;d=pj({mode:"visible",children:d.children},e,0,null);f=Tg(f,e,g,null);f.flags|=2;d.return=b;f.return=b;d.sibling=f;b.child=d;0!==(b.mode&1)&&Ug(b,a.child,null,g);b.child.memoizedState=nj(g);b.memoizedState=mj;return f}if(0===(b.mode&1))return sj(a,b,g,null);if("$!"===e.data){d=e.nextSibling&&e.nextSibling.dataset;
	if(d)var h=d.dgst;d=h;f=Error(p(419));d=Ki(f,d,void 0);return sj(a,b,g,d)}h=0!==(g&a.childLanes);if(dh||h){d=Q;if(null!==d){switch(g&-g){case 4:e=2;break;case 16:e=8;break;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:e=32;break;case 536870912:e=268435456;break;default:e=0}e=0!==(e&(d.suspendedLanes|g))?0:e;
	0!==e&&e!==f.retryLane&&(f.retryLane=e,ih(a,e),gi(d,a,e,-1))}tj();d=Ki(Error(p(421)));return sj(a,b,g,d)}if("$?"===e.data)return b.flags|=128,b.child=a.child,b=uj.bind(null,a),e._reactRetry=b,null;a=f.treeContext;yg=Lf(e.nextSibling);xg=b;I=!0;zg=null;null!==a&&(og[pg++]=rg,og[pg++]=sg,og[pg++]=qg,rg=a.id,sg=a.overflow,qg=b);b=qj(b,d.children);b.flags|=4096;return b}function vj(a,b,c){a.lanes|=b;var d=a.alternate;null!==d&&(d.lanes|=b);bh(a.return,b,c)}
	function wj(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.renderingStartTime=0,f.last=d,f.tail=c,f.tailMode=e)}
	function xj(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;Xi(a,b,d.children,c);d=L.current;if(0!==(d&2))d=d&1|2,b.flags|=128;else{if(null!==a&&0!==(a.flags&128))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&vj(a,c,b);else if(19===a.tag)vj(a,c,b);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}G(L,d);if(0===(b.mode&1))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===Ch(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);wj(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===Ch(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}wj(b,!0,c,null,f);break;case "together":wj(b,!1,null,null,void 0);break;default:b.memoizedState=null}return b.child}
	function ij(a,b){0===(b.mode&1)&&null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2)}function Zi(a,b,c){null!==a&&(b.dependencies=a.dependencies);rh|=b.lanes;if(0===(c&b.childLanes))return null;if(null!==a&&b.child!==a.child)throw Error(p(153));if(null!==b.child){a=b.child;c=Pg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Pg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}
	function yj(a,b,c){switch(b.tag){case 3:kj(b);Ig();break;case 5:Ah(b);break;case 1:Zf(b.type)&&cg(b);break;case 4:yh(b,b.stateNode.containerInfo);break;case 10:var d=b.type._context,e=b.memoizedProps.value;G(Wg,d._currentValue);d._currentValue=e;break;case 13:d=b.memoizedState;if(null!==d){if(null!==d.dehydrated)return G(L,L.current&1),b.flags|=128,null;if(0!==(c&b.child.childLanes))return oj(a,b,c);G(L,L.current&1);a=Zi(a,b,c);return null!==a?a.sibling:null}G(L,L.current&1);break;case 19:d=0!==(c&
	b.childLanes);if(0!==(a.flags&128)){if(d)return xj(a,b,c);b.flags|=128}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);G(L,L.current);if(d)break;else return null;case 22:case 23:return b.lanes=0,dj(a,b,c)}return Zi(a,b,c)}var zj,Aj,Bj,Cj;
	zj=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Aj=function(){};
	Bj=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;xh(uh.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "select":e=A({},e,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=Bf)}ub(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&
	(c||(c={}),c[g]="")}else"dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ea.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||(c={}),c[g]=k[g])}else c||(f||(f=[]),f.push(l,
	c)),c=k;else"dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ea.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&D("scroll",a),f||h===k||(f=[])):(f=f||[]).push(l,k))}c&&(f=f||[]).push("style",c);var l=f;if(b.updateQueue=l)b.flags|=4}};Cj=function(a,b,c,d){c!==d&&(b.flags|=4)};
	function Dj(a,b){if(!I)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function S(a){var b=null!==a.alternate&&a.alternate.child===a.child,c=0,d=0;if(b)for(var e=a.child;null!==e;)c|=e.lanes|e.childLanes,d|=e.subtreeFlags&14680064,d|=e.flags&14680064,e.return=a,e=e.sibling;else for(e=a.child;null!==e;)c|=e.lanes|e.childLanes,d|=e.subtreeFlags,d|=e.flags,e.return=a,e=e.sibling;a.subtreeFlags|=d;a.childLanes=c;return b}
	function Ej(a,b,c){var d=b.pendingProps;wg(b);switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return S(b),null;case 1:return Zf(b.type)&&$f(),S(b),null;case 3:d=b.stateNode;zh();E(Wf);E(H);Eh();d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b)?b.flags|=4:null===a||a.memoizedState.isDehydrated&&0===(b.flags&256)||(b.flags|=1024,null!==zg&&(Fj(zg),zg=null));Aj(a,b);S(b);return null;case 5:Bh(b);var e=xh(wh.current);
	c=b.type;if(null!==a&&null!=b.stateNode)Bj(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=512,b.flags|=2097152);else{if(!d){if(null===b.stateNode)throw Error(p(166));S(b);return null}a=xh(uh.current);if(Gg(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[Of]=b;d[Pf]=f;a=0!==(b.mode&1);switch(c){case "dialog":D("cancel",d);D("close",d);break;case "iframe":case "object":case "embed":D("load",d);break;case "video":case "audio":for(e=0;e<lf.length;e++)D(lf[e],d);break;case "source":D("error",d);break;case "img":case "image":case "link":D("error",
	d);D("load",d);break;case "details":D("toggle",d);break;case "input":Za(d,f);D("invalid",d);break;case "select":d._wrapperState={wasMultiple:!!f.multiple};D("invalid",d);break;case "textarea":hb(d,f),D("invalid",d)}ub(c,f);e=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(!0!==f.suppressHydrationWarning&&Af(d.textContent,h,a),e=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(!0!==f.suppressHydrationWarning&&Af(d.textContent,
	h,a),e=["children",""+h]):ea.hasOwnProperty(g)&&null!=h&&"onScroll"===g&&D("scroll",d)}switch(c){case "input":Va(d);db(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=Bf)}d=e;b.updateQueue=d;null!==d&&(b.flags|=4)}else{g=9===e.nodeType?e:e.ownerDocument;"http://www.w3.org/1999/xhtml"===a&&(a=kb(c));"http://www.w3.org/1999/xhtml"===a?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):
	"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[Of]=b;a[Pf]=d;zj(a,b,!1,!1);b.stateNode=a;a:{g=vb(c,d);switch(c){case "dialog":D("cancel",a);D("close",a);e=d;break;case "iframe":case "object":case "embed":D("load",a);e=d;break;case "video":case "audio":for(e=0;e<lf.length;e++)D(lf[e],a);e=d;break;case "source":D("error",a);e=d;break;case "img":case "image":case "link":D("error",
	a);D("load",a);e=d;break;case "details":D("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);D("invalid",a);break;case "option":e=d;break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=A({},d,{value:void 0});D("invalid",a);break;case "textarea":hb(a,d);e=gb(a,d);D("invalid",a);break;default:e=d}ub(c,e);h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?sb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&nb(a,k)):"children"===f?"string"===typeof k?("textarea"!==
	c||""!==k)&&ob(a,k):"number"===typeof k&&ob(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ea.hasOwnProperty(f)?null!=k&&"onScroll"===f&&D("scroll",a):null!=k&&ta(a,f,k,g))}switch(c){case "input":Va(a);db(a,d,!1);break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,
	!0);break;default:"function"===typeof e.onClick&&(a.onclick=Bf)}switch(c){case "button":case "input":case "select":case "textarea":d=!!d.autoFocus;break a;case "img":d=!0;break a;default:d=!1}}d&&(b.flags|=4)}null!==b.ref&&(b.flags|=512,b.flags|=2097152)}S(b);return null;case 6:if(a&&null!=b.stateNode)Cj(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(p(166));c=xh(wh.current);xh(uh.current);if(Gg(b)){d=b.stateNode;c=b.memoizedProps;d[Of]=b;if(f=d.nodeValue!==c)if(a=
	xg,null!==a)switch(a.tag){case 3:Af(d.nodeValue,c,0!==(a.mode&1));break;case 5:!0!==a.memoizedProps.suppressHydrationWarning&&Af(d.nodeValue,c,0!==(a.mode&1))}f&&(b.flags|=4)}else d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[Of]=b,b.stateNode=d}S(b);return null;case 13:E(L);d=b.memoizedState;if(null===a||null!==a.memoizedState&&null!==a.memoizedState.dehydrated){if(I&&null!==yg&&0!==(b.mode&1)&&0===(b.flags&128))Hg(),Ig(),b.flags|=98560,f=!1;else if(f=Gg(b),null!==d&&null!==d.dehydrated){if(null===
	a){if(!f)throw Error(p(318));f=b.memoizedState;f=null!==f?f.dehydrated:null;if(!f)throw Error(p(317));f[Of]=b}else Ig(),0===(b.flags&128)&&(b.memoizedState=null),b.flags|=4;S(b);f=!1}else null!==zg&&(Fj(zg),zg=null),f=!0;if(!f)return b.flags&65536?b:null}if(0!==(b.flags&128))return b.lanes=c,b;d=null!==d;d!==(null!==a&&null!==a.memoizedState)&&d&&(b.child.flags|=8192,0!==(b.mode&1)&&(null===a||0!==(L.current&1)?0===T&&(T=3):tj()));null!==b.updateQueue&&(b.flags|=4);S(b);return null;case 4:return zh(),
	Aj(a,b),null===a&&sf(b.stateNode.containerInfo),S(b),null;case 10:return ah(b.type._context),S(b),null;case 17:return Zf(b.type)&&$f(),S(b),null;case 19:E(L);f=b.memoizedState;if(null===f)return S(b),null;d=0!==(b.flags&128);g=f.rendering;if(null===g)if(d)Dj(f,!1);else{if(0!==T||null!==a&&0!==(a.flags&128))for(a=b.child;null!==a;){g=Ch(a);if(null!==g){b.flags|=128;Dj(f,!1);d=g.updateQueue;null!==d&&(b.updateQueue=d,b.flags|=4);b.subtreeFlags=0;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=14680066,
	g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.subtreeFlags=0,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.subtreeFlags=0,f.deletions=null,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;G(L,L.current&1|2);return b.child}a=
	a.sibling}null!==f.tail&&B()>Gj&&(b.flags|=128,d=!0,Dj(f,!1),b.lanes=4194304)}else{if(!d)if(a=Ch(g),null!==a){if(b.flags|=128,d=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Dj(f,!0),null===f.tail&&"hidden"===f.tailMode&&!g.alternate&&!I)return S(b),null}else 2*B()-f.renderingStartTime>Gj&&1073741824!==c&&(b.flags|=128,d=!0,Dj(f,!1),b.lanes=4194304);f.isBackwards?(g.sibling=b.child,b.child=g):(c=f.last,null!==c?c.sibling=g:b.child=g,f.last=g)}if(null!==f.tail)return b=f.tail,f.rendering=
	b,f.tail=b.sibling,f.renderingStartTime=B(),b.sibling=null,c=L.current,G(L,d?c&1|2:c&1),b;S(b);return null;case 22:case 23:return Hj(),d=null!==b.memoizedState,null!==a&&null!==a.memoizedState!==d&&(b.flags|=8192),d&&0!==(b.mode&1)?0!==(fj&1073741824)&&(S(b),b.subtreeFlags&6&&(b.flags|=8192)):S(b),null;case 24:return null;case 25:return null}throw Error(p(156,b.tag));}
	function Ij(a,b){wg(b);switch(b.tag){case 1:return Zf(b.type)&&$f(),a=b.flags,a&65536?(b.flags=a&-65537|128,b):null;case 3:return zh(),E(Wf),E(H),Eh(),a=b.flags,0!==(a&65536)&&0===(a&128)?(b.flags=a&-65537|128,b):null;case 5:return Bh(b),null;case 13:E(L);a=b.memoizedState;if(null!==a&&null!==a.dehydrated){if(null===b.alternate)throw Error(p(340));Ig()}a=b.flags;return a&65536?(b.flags=a&-65537|128,b):null;case 19:return E(L),null;case 4:return zh(),null;case 10:return ah(b.type._context),null;case 22:case 23:return Hj(),
	null;case 24:return null;default:return null}}var Jj=!1,U=!1,Kj="function"===typeof WeakSet?WeakSet:Set,V=null;function Lj(a,b){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(d){W(a,b,d)}else c.current=null}function Mj(a,b,c){try{c()}catch(d){W(a,b,d)}}var Nj=!1;
	function Oj(a,b){Cf=dd;a=Me();if(Ne(a)){if("selectionStart"in a)var c={start:a.selectionStart,end:a.selectionEnd};else a:{c=(c=a.ownerDocument)&&c.defaultView||window;var d=c.getSelection&&c.getSelection();if(d&&0!==d.rangeCount){c=d.anchorNode;var e=d.anchorOffset,f=d.focusNode;d=d.focusOffset;try{c.nodeType,f.nodeType}catch(F){c=null;break a}var g=0,h=-1,k=-1,l=0,m=0,q=a,r=null;b:for(;;){for(var y;;){q!==c||0!==e&&3!==q.nodeType||(h=g+e);q!==f||0!==d&&3!==q.nodeType||(k=g+d);3===q.nodeType&&(g+=
	q.nodeValue.length);if(null===(y=q.firstChild))break;r=q;q=y}for(;;){if(q===a)break b;r===c&&++l===e&&(h=g);r===f&&++m===d&&(k=g);if(null!==(y=q.nextSibling))break;q=r;r=q.parentNode}q=y}c=-1===h||-1===k?null:{start:h,end:k}}else c=null}c=c||{start:0,end:0}}else c=null;Df={focusedElem:a,selectionRange:c};dd=!1;for(V=b;null!==V;)if(b=V,a=b.child,0!==(b.subtreeFlags&1028)&&null!==a)a.return=b,V=a;else for(;null!==V;){b=V;try{var n=b.alternate;if(0!==(b.flags&1024))switch(b.tag){case 0:case 11:case 15:break;
	case 1:if(null!==n){var t=n.memoizedProps,J=n.memoizedState,x=b.stateNode,w=x.getSnapshotBeforeUpdate(b.elementType===b.type?t:Ci(b.type,t),J);x.__reactInternalSnapshotBeforeUpdate=w}break;case 3:var u=b.stateNode.containerInfo;1===u.nodeType?u.textContent="":9===u.nodeType&&u.documentElement&&u.removeChild(u.documentElement);break;case 5:case 6:case 4:case 17:break;default:throw Error(p(163));}}catch(F){W(b,b.return,F)}a=b.sibling;if(null!==a){a.return=b.return;V=a;break}V=b.return}n=Nj;Nj=!1;return n}
	function Pj(a,b,c){var d=b.updateQueue;d=null!==d?d.lastEffect:null;if(null!==d){var e=d=d.next;do{if((e.tag&a)===a){var f=e.destroy;e.destroy=void 0;void 0!==f&&Mj(b,c,f)}e=e.next}while(e!==d)}}function Qj(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}function Rj(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=c;break;default:a=c}"function"===typeof b?b(a):b.current=a}}
	function Sj(a){var b=a.alternate;null!==b&&(a.alternate=null,Sj(b));a.child=null;a.deletions=null;a.sibling=null;5===a.tag&&(b=a.stateNode,null!==b&&(delete b[Of],delete b[Pf],delete b[of],delete b[Qf],delete b[Rf]));a.stateNode=null;a.return=null;a.dependencies=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.stateNode=null;a.updateQueue=null}function Tj(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Uj(a){a:for(;;){for(;null===a.sibling;){if(null===a.return||Tj(a.return))return null;a=a.return}a.sibling.return=a.return;for(a=a.sibling;5!==a.tag&&6!==a.tag&&18!==a.tag;){if(a.flags&2)continue a;if(null===a.child||4===a.tag)continue a;else a.child.return=a,a=a.child}if(!(a.flags&2))return a.stateNode}}
	function Vj(a,b,c){var d=a.tag;if(5===d||6===d)a=a.stateNode,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=Bf));else if(4!==d&&(a=a.child,null!==a))for(Vj(a,b,c),a=a.sibling;null!==a;)Vj(a,b,c),a=a.sibling}
	function Wj(a,b,c){var d=a.tag;if(5===d||6===d)a=a.stateNode,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Wj(a,b,c),a=a.sibling;null!==a;)Wj(a,b,c),a=a.sibling}var X=null,Xj=!1;function Yj(a,b,c){for(c=c.child;null!==c;)Zj(a,b,c),c=c.sibling}
	function Zj(a,b,c){if(lc&&"function"===typeof lc.onCommitFiberUnmount)try{lc.onCommitFiberUnmount(kc,c)}catch(h){}switch(c.tag){case 5:U||Lj(c,b);case 6:var d=X,e=Xj;X=null;Yj(a,b,c);X=d;Xj=e;null!==X&&(Xj?(a=X,c=c.stateNode,8===a.nodeType?a.parentNode.removeChild(c):a.removeChild(c)):X.removeChild(c.stateNode));break;case 18:null!==X&&(Xj?(a=X,c=c.stateNode,8===a.nodeType?Kf(a.parentNode,c):1===a.nodeType&&Kf(a,c),bd(a)):Kf(X,c.stateNode));break;case 4:d=X;e=Xj;X=c.stateNode.containerInfo;Xj=!0;
	Yj(a,b,c);X=d;Xj=e;break;case 0:case 11:case 14:case 15:if(!U&&(d=c.updateQueue,null!==d&&(d=d.lastEffect,null!==d))){e=d=d.next;do{var f=e,g=f.destroy;f=f.tag;void 0!==g&&(0!==(f&2)?Mj(c,b,g):0!==(f&4)&&Mj(c,b,g));e=e.next}while(e!==d)}Yj(a,b,c);break;case 1:if(!U&&(Lj(c,b),d=c.stateNode,"function"===typeof d.componentWillUnmount))try{d.props=c.memoizedProps,d.state=c.memoizedState,d.componentWillUnmount()}catch(h){W(c,b,h)}Yj(a,b,c);break;case 21:Yj(a,b,c);break;case 22:c.mode&1?(U=(d=U)||null!==
	c.memoizedState,Yj(a,b,c),U=d):Yj(a,b,c);break;default:Yj(a,b,c)}}function ak(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Kj);b.forEach(function(b){var d=bk.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	function ck(a,b){var c=b.deletions;if(null!==c)for(var d=0;d<c.length;d++){var e=c[d];try{var f=a,g=b,h=g;a:for(;null!==h;){switch(h.tag){case 5:X=h.stateNode;Xj=!1;break a;case 3:X=h.stateNode.containerInfo;Xj=!0;break a;case 4:X=h.stateNode.containerInfo;Xj=!0;break a}h=h.return}if(null===X)throw Error(p(160));Zj(f,g,e);X=null;Xj=!1;var k=e.alternate;null!==k&&(k.return=null);e.return=null}catch(l){W(e,b,l)}}if(b.subtreeFlags&12854)for(b=b.child;null!==b;)dk(b,a),b=b.sibling}
	function dk(a,b){var c=a.alternate,d=a.flags;switch(a.tag){case 0:case 11:case 14:case 15:ck(b,a);ek(a);if(d&4){try{Pj(3,a,a.return),Qj(3,a)}catch(t){W(a,a.return,t)}try{Pj(5,a,a.return)}catch(t){W(a,a.return,t)}}break;case 1:ck(b,a);ek(a);d&512&&null!==c&&Lj(c,c.return);break;case 5:ck(b,a);ek(a);d&512&&null!==c&&Lj(c,c.return);if(a.flags&32){var e=a.stateNode;try{ob(e,"")}catch(t){W(a,a.return,t)}}if(d&4&&(e=a.stateNode,null!=e)){var f=a.memoizedProps,g=null!==c?c.memoizedProps:f,h=a.type,k=a.updateQueue;
	a.updateQueue=null;if(null!==k)try{"input"===h&&"radio"===f.type&&null!=f.name&&ab(e,f);vb(h,g);var l=vb(h,f);for(g=0;g<k.length;g+=2){var m=k[g],q=k[g+1];"style"===m?sb(e,q):"dangerouslySetInnerHTML"===m?nb(e,q):"children"===m?ob(e,q):ta(e,m,q,l)}switch(h){case "input":bb(e,f);break;case "textarea":ib(e,f);break;case "select":var r=e._wrapperState.wasMultiple;e._wrapperState.wasMultiple=!!f.multiple;var y=f.value;null!=y?fb(e,!!f.multiple,y,!1):r!==!!f.multiple&&(null!=f.defaultValue?fb(e,!!f.multiple,
	f.defaultValue,!0):fb(e,!!f.multiple,f.multiple?[]:"",!1))}e[Pf]=f}catch(t){W(a,a.return,t)}}break;case 6:ck(b,a);ek(a);if(d&4){if(null===a.stateNode)throw Error(p(162));e=a.stateNode;f=a.memoizedProps;try{e.nodeValue=f}catch(t){W(a,a.return,t)}}break;case 3:ck(b,a);ek(a);if(d&4&&null!==c&&c.memoizedState.isDehydrated)try{bd(b.containerInfo)}catch(t){W(a,a.return,t)}break;case 4:ck(b,a);ek(a);break;case 13:ck(b,a);ek(a);e=a.child;e.flags&8192&&(f=null!==e.memoizedState,e.stateNode.isHidden=f,!f||
	null!==e.alternate&&null!==e.alternate.memoizedState||(fk=B()));d&4&&ak(a);break;case 22:m=null!==c&&null!==c.memoizedState;a.mode&1?(U=(l=U)||m,ck(b,a),U=l):ck(b,a);ek(a);if(d&8192){l=null!==a.memoizedState;if((a.stateNode.isHidden=l)&&!m&&0!==(a.mode&1))for(V=a,m=a.child;null!==m;){for(q=V=m;null!==V;){r=V;y=r.child;switch(r.tag){case 0:case 11:case 14:case 15:Pj(4,r,r.return);break;case 1:Lj(r,r.return);var n=r.stateNode;if("function"===typeof n.componentWillUnmount){d=r;c=r.return;try{b=d,n.props=
	b.memoizedProps,n.state=b.memoizedState,n.componentWillUnmount()}catch(t){W(d,c,t)}}break;case 5:Lj(r,r.return);break;case 22:if(null!==r.memoizedState){gk(q);continue}}null!==y?(y.return=r,V=y):gk(q)}m=m.sibling}a:for(m=null,q=a;;){if(5===q.tag){if(null===m){m=q;try{e=q.stateNode,l?(f=e.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(h=q.stateNode,k=q.memoizedProps.style,g=void 0!==k&&null!==k&&k.hasOwnProperty("display")?k.display:null,h.style.display=
	rb("display",g))}catch(t){W(a,a.return,t)}}}else if(6===q.tag){if(null===m)try{q.stateNode.nodeValue=l?"":q.memoizedProps}catch(t){W(a,a.return,t)}}else if((22!==q.tag&&23!==q.tag||null===q.memoizedState||q===a)&&null!==q.child){q.child.return=q;q=q.child;continue}if(q===a)break a;for(;null===q.sibling;){if(null===q.return||q.return===a)break a;m===q&&(m=null);q=q.return}m===q&&(m=null);q.sibling.return=q.return;q=q.sibling}}break;case 19:ck(b,a);ek(a);d&4&&ak(a);break;case 21:break;default:ck(b,
	a),ek(a)}}function ek(a){var b=a.flags;if(b&2){try{a:{for(var c=a.return;null!==c;){if(Tj(c)){var d=c;break a}c=c.return}throw Error(p(160));}switch(d.tag){case 5:var e=d.stateNode;d.flags&32&&(ob(e,""),d.flags&=-33);var f=Uj(a);Wj(a,f,e);break;case 3:case 4:var g=d.stateNode.containerInfo,h=Uj(a);Vj(a,h,g);break;default:throw Error(p(161));}}catch(k){W(a,a.return,k)}a.flags&=-3}b&4096&&(a.flags&=-4097)}function hk(a,b,c){V=a;ik(a,b,c)}
	function ik(a,b,c){for(var d=0!==(a.mode&1);null!==V;){var e=V,f=e.child;if(22===e.tag&&d){var g=null!==e.memoizedState||Jj;if(!g){var h=e.alternate,k=null!==h&&null!==h.memoizedState||U;h=Jj;var l=U;Jj=g;if((U=k)&&!l)for(V=e;null!==V;)g=V,k=g.child,22===g.tag&&null!==g.memoizedState?jk(e):null!==k?(k.return=g,V=k):jk(e);for(;null!==f;)V=f,ik(f,b,c),f=f.sibling;V=e;Jj=h;U=l}kk(a,b,c)}else 0!==(e.subtreeFlags&8772)&&null!==f?(f.return=e,V=f):kk(a,b,c)}}
	function kk(a){for(;null!==V;){var b=V;if(0!==(b.flags&8772)){var c=b.alternate;try{if(0!==(b.flags&8772))switch(b.tag){case 0:case 11:case 15:U||Qj(5,b);break;case 1:var d=b.stateNode;if(b.flags&4&&!U)if(null===c)d.componentDidMount();else{var e=b.elementType===b.type?c.memoizedProps:Ci(b.type,c.memoizedProps);d.componentDidUpdate(e,c.memoizedState,d.__reactInternalSnapshotBeforeUpdate)}var f=b.updateQueue;null!==f&&sh(b,f,d);break;case 3:var g=b.updateQueue;if(null!==g){c=null;if(null!==b.child)switch(b.child.tag){case 5:c=
	b.child.stateNode;break;case 1:c=b.child.stateNode}sh(b,g,c)}break;case 5:var h=b.stateNode;if(null===c&&b.flags&4){c=h;var k=b.memoizedProps;switch(b.type){case "button":case "input":case "select":case "textarea":k.autoFocus&&c.focus();break;case "img":k.src&&(c.src=k.src)}}break;case 6:break;case 4:break;case 12:break;case 13:if(null===b.memoizedState){var l=b.alternate;if(null!==l){var m=l.memoizedState;if(null!==m){var q=m.dehydrated;null!==q&&bd(q)}}}break;case 19:case 17:case 21:case 22:case 23:case 25:break;
	default:throw Error(p(163));}U||b.flags&512&&Rj(b)}catch(r){W(b,b.return,r)}}if(b===a){V=null;break}c=b.sibling;if(null!==c){c.return=b.return;V=c;break}V=b.return}}function gk(a){for(;null!==V;){var b=V;if(b===a){V=null;break}var c=b.sibling;if(null!==c){c.return=b.return;V=c;break}V=b.return}}
	function jk(a){for(;null!==V;){var b=V;try{switch(b.tag){case 0:case 11:case 15:var c=b.return;try{Qj(4,b)}catch(k){W(b,c,k)}break;case 1:var d=b.stateNode;if("function"===typeof d.componentDidMount){var e=b.return;try{d.componentDidMount()}catch(k){W(b,e,k)}}var f=b.return;try{Rj(b)}catch(k){W(b,f,k)}break;case 5:var g=b.return;try{Rj(b)}catch(k){W(b,g,k)}}}catch(k){W(b,b.return,k)}if(b===a){V=null;break}var h=b.sibling;if(null!==h){h.return=b.return;V=h;break}V=b.return}}
	var lk=Math.ceil,mk=ua.ReactCurrentDispatcher,nk=ua.ReactCurrentOwner,ok=ua.ReactCurrentBatchConfig,K=0,Q=null,Y=null,Z=0,fj=0,ej=Uf(0),T=0,pk=null,rh=0,qk=0,rk=0,sk=null,tk=null,fk=0,Gj=Infinity,uk=null,Oi=!1,Pi=null,Ri=null,vk=!1,wk=null,xk=0,yk=0,zk=null,Ak=-1,Bk=0;function R(){return 0!==(K&6)?B():-1!==Ak?Ak:Ak=B()}
	function yi(a){if(0===(a.mode&1))return 1;if(0!==(K&2)&&0!==Z)return Z&-Z;if(null!==Kg.transition)return 0===Bk&&(Bk=yc()),Bk;a=C;if(0!==a)return a;a=window.event;a=void 0===a?16:jd(a.type);return a}function gi(a,b,c,d){if(50<yk)throw yk=0,zk=null,Error(p(185));Ac(a,c,d);if(0===(K&2)||a!==Q)a===Q&&(0===(K&2)&&(qk|=c),4===T&&Ck(a,Z)),Dk(a,d),1===c&&0===K&&0===(b.mode&1)&&(Gj=B()+500,fg&&jg())}
	function Dk(a,b){var c=a.callbackNode;wc(a,b);var d=uc(a,a===Q?Z:0);if(0===d)null!==c&&bc(c),a.callbackNode=null,a.callbackPriority=0;else if(b=d&-d,a.callbackPriority!==b){null!=c&&bc(c);if(1===b)0===a.tag?ig(Ek.bind(null,a)):hg(Ek.bind(null,a)),Jf(function(){0===(K&6)&&jg()}),c=null;else{switch(Dc(d)){case 1:c=fc;break;case 4:c=gc;break;case 16:c=hc;break;case 536870912:c=jc;break;default:c=hc}c=Fk(c,Gk.bind(null,a))}a.callbackPriority=b;a.callbackNode=c}}
	function Gk(a,b){Ak=-1;Bk=0;if(0!==(K&6))throw Error(p(327));var c=a.callbackNode;if(Hk()&&a.callbackNode!==c)return null;var d=uc(a,a===Q?Z:0);if(0===d)return null;if(0!==(d&30)||0!==(d&a.expiredLanes)||b)b=Ik(a,d);else{b=d;var e=K;K|=2;var f=Jk();if(Q!==a||Z!==b)uk=null,Gj=B()+500,Kk(a,b);do try{Lk();break}catch(h){Mk(a,h)}while(1);$g();mk.current=f;K=e;null!==Y?b=0:(Q=null,Z=0,b=T)}if(0!==b){2===b&&(e=xc(a),0!==e&&(d=e,b=Nk(a,e)));if(1===b)throw c=pk,Kk(a,0),Ck(a,d),Dk(a,B()),c;if(6===b)Ck(a,d);
	else{e=a.current.alternate;if(0===(d&30)&&!Ok(e)&&(b=Ik(a,d),2===b&&(f=xc(a),0!==f&&(d=f,b=Nk(a,f))),1===b))throw c=pk,Kk(a,0),Ck(a,d),Dk(a,B()),c;a.finishedWork=e;a.finishedLanes=d;switch(b){case 0:case 1:throw Error(p(345));case 2:Pk(a,tk,uk);break;case 3:Ck(a,d);if((d&130023424)===d&&(b=fk+500-B(),10<b)){if(0!==uc(a,0))break;e=a.suspendedLanes;if((e&d)!==d){R();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=Ff(Pk.bind(null,a,tk,uk),b);break}Pk(a,tk,uk);break;case 4:Ck(a,d);if((d&4194240)===
	d)break;b=a.eventTimes;for(e=-1;0<d;){var g=31-oc(d);f=1<<g;g=b[g];g>e&&(e=g);d&=~f}d=e;d=B()-d;d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*lk(d/1960))-d;if(10<d){a.timeoutHandle=Ff(Pk.bind(null,a,tk,uk),d);break}Pk(a,tk,uk);break;case 5:Pk(a,tk,uk);break;default:throw Error(p(329));}}}Dk(a,B());return a.callbackNode===c?Gk.bind(null,a):null}
	function Nk(a,b){var c=sk;a.current.memoizedState.isDehydrated&&(Kk(a,b).flags|=256);a=Ik(a,b);2!==a&&(b=tk,tk=c,null!==b&&Fj(b));return a}function Fj(a){null===tk?tk=a:tk.push.apply(tk,a)}
	function Ok(a){for(var b=a;;){if(b.flags&16384){var c=b.updateQueue;if(null!==c&&(c=c.stores,null!==c))for(var d=0;d<c.length;d++){var e=c[d],f=e.getSnapshot;e=e.value;try{if(!He(f(),e))return!1}catch(g){return!1}}}c=b.child;if(b.subtreeFlags&16384&&null!==c)c.return=b,b=c;else{if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return!0;b=b.return}b.sibling.return=b.return;b=b.sibling}}return!0}
	function Ck(a,b){b&=~rk;b&=~qk;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-oc(b),d=1<<c;a[c]=-1;b&=~d}}function Ek(a){if(0!==(K&6))throw Error(p(327));Hk();var b=uc(a,0);if(0===(b&1))return Dk(a,B()),null;var c=Ik(a,b);if(0!==a.tag&&2===c){var d=xc(a);0!==d&&(b=d,c=Nk(a,d))}if(1===c)throw c=pk,Kk(a,0),Ck(a,b),Dk(a,B()),c;if(6===c)throw Error(p(345));a.finishedWork=a.current.alternate;a.finishedLanes=b;Pk(a,tk,uk);Dk(a,B());return null}
	function Qk(a,b){var c=K;K|=1;try{return a(b)}finally{K=c,0===K&&(Gj=B()+500,fg&&jg())}}function Rk(a){null!==wk&&0===wk.tag&&0===(K&6)&&Hk();var b=K;K|=1;var c=ok.transition,d=C;try{if(ok.transition=null,C=1,a)return a()}finally{C=d,ok.transition=c,K=b,0===(K&6)&&jg()}}function Hj(){fj=ej.current;E(ej)}
	function Kk(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Gf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;wg(d);switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&$f();break;case 3:zh();E(Wf);E(H);Eh();break;case 5:Bh(d);break;case 4:zh();break;case 13:E(L);break;case 19:E(L);break;case 10:ah(d.type._context);break;case 22:case 23:Hj()}c=c.return}Q=a;Y=a=Pg(a.current,null);Z=fj=b;T=0;pk=null;rk=qk=rh=0;tk=sk=null;if(null!==fh){for(b=
	0;b<fh.length;b++)if(c=fh[b],d=c.interleaved,null!==d){c.interleaved=null;var e=d.next,f=c.pending;if(null!==f){var g=f.next;f.next=e;d.next=g}c.pending=d}fh=null}return a}
	function Mk(a,b){do{var c=Y;try{$g();Fh.current=Rh;if(Ih){for(var d=M.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next}Ih=!1}Hh=0;O=N=M=null;Jh=!1;Kh=0;nk.current=null;if(null===c||null===c.return){T=1;pk=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=Z;h.flags|=32768;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k,m=h,q=m.tag;if(0===(m.mode&1)&&(0===q||11===q||15===q)){var r=m.alternate;r?(m.updateQueue=r.updateQueue,m.memoizedState=r.memoizedState,
	m.lanes=r.lanes):(m.updateQueue=null,m.memoizedState=null)}var y=Ui(g);if(null!==y){y.flags&=-257;Vi(y,g,h,f,b);y.mode&1&&Si(f,l,b);b=y;k=l;var n=b.updateQueue;if(null===n){var t=new Set;t.add(k);b.updateQueue=t}else n.add(k);break a}else{if(0===(b&1)){Si(f,l,b);tj();break a}k=Error(p(426))}}else if(I&&h.mode&1){var J=Ui(g);if(null!==J){0===(J.flags&65536)&&(J.flags|=256);Vi(J,g,h,f,b);Jg(Ji(k,h));break a}}f=k=Ji(k,h);4!==T&&(T=2);null===sk?sk=[f]:sk.push(f);f=g;do{switch(f.tag){case 3:f.flags|=65536;
	b&=-b;f.lanes|=b;var x=Ni(f,k,b);ph(f,x);break a;case 1:h=k;var w=f.type,u=f.stateNode;if(0===(f.flags&128)&&("function"===typeof w.getDerivedStateFromError||null!==u&&"function"===typeof u.componentDidCatch&&(null===Ri||!Ri.has(u)))){f.flags|=65536;b&=-b;f.lanes|=b;var F=Qi(f,h,b);ph(f,F);break a}}f=f.return}while(null!==f)}Sk(c)}catch(na){b=na;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}function Jk(){var a=mk.current;mk.current=Rh;return null===a?Rh:a}
	function tj(){if(0===T||3===T||2===T)T=4;null===Q||0===(rh&268435455)&&0===(qk&268435455)||Ck(Q,Z)}function Ik(a,b){var c=K;K|=2;var d=Jk();if(Q!==a||Z!==b)uk=null,Kk(a,b);do try{Tk();break}catch(e){Mk(a,e)}while(1);$g();K=c;mk.current=d;if(null!==Y)throw Error(p(261));Q=null;Z=0;return T}function Tk(){for(;null!==Y;)Uk(Y)}function Lk(){for(;null!==Y&&!cc();)Uk(Y)}function Uk(a){var b=Vk(a.alternate,a,fj);a.memoizedProps=a.pendingProps;null===b?Sk(a):Y=b;nk.current=null}
	function Sk(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&32768)){if(c=Ej(c,b,fj),null!==c){Y=c;return}}else{c=Ij(c,b);if(null!==c){c.flags&=32767;Y=c;return}if(null!==a)a.flags|=32768,a.subtreeFlags=0,a.deletions=null;else{T=6;Y=null;return}}b=b.sibling;if(null!==b){Y=b;return}Y=b=a}while(null!==b);0===T&&(T=5)}function Pk(a,b,c){var d=C,e=ok.transition;try{ok.transition=null,C=1,Wk(a,b,c,d)}finally{ok.transition=e,C=d}return null}
	function Wk(a,b,c,d){do Hk();while(null!==wk);if(0!==(K&6))throw Error(p(327));c=a.finishedWork;var e=a.finishedLanes;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(p(177));a.callbackNode=null;a.callbackPriority=0;var f=c.lanes|c.childLanes;Bc(a,f);a===Q&&(Y=Q=null,Z=0);0===(c.subtreeFlags&2064)&&0===(c.flags&2064)||vk||(vk=!0,Fk(hc,function(){Hk();return null}));f=0!==(c.flags&15990);if(0!==(c.subtreeFlags&15990)||f){f=ok.transition;ok.transition=null;
	var g=C;C=1;var h=K;K|=4;nk.current=null;Oj(a,c);dk(c,a);Oe(Df);dd=!!Cf;Df=Cf=null;a.current=c;hk(c,a,e);dc();K=h;C=g;ok.transition=f}else a.current=c;vk&&(vk=!1,wk=a,xk=e);f=a.pendingLanes;0===f&&(Ri=null);mc(c.stateNode,d);Dk(a,B());if(null!==b)for(d=a.onRecoverableError,c=0;c<b.length;c++)e=b[c],d(e.value,{componentStack:e.stack,digest:e.digest});if(Oi)throw Oi=!1,a=Pi,Pi=null,a;0!==(xk&1)&&0!==a.tag&&Hk();f=a.pendingLanes;0!==(f&1)?a===zk?yk++:(yk=0,zk=a):yk=0;jg();return null}
	function Hk(){if(null!==wk){var a=Dc(xk),b=ok.transition,c=C;try{ok.transition=null;C=16>a?16:a;if(null===wk)var d=!1;else{a=wk;wk=null;xk=0;if(0!==(K&6))throw Error(p(331));var e=K;K|=4;for(V=a.current;null!==V;){var f=V,g=f.child;if(0!==(V.flags&16)){var h=f.deletions;if(null!==h){for(var k=0;k<h.length;k++){var l=h[k];for(V=l;null!==V;){var m=V;switch(m.tag){case 0:case 11:case 15:Pj(8,m,f)}var q=m.child;if(null!==q)q.return=m,V=q;else for(;null!==V;){m=V;var r=m.sibling,y=m.return;Sj(m);if(m===
	l){V=null;break}if(null!==r){r.return=y;V=r;break}V=y}}}var n=f.alternate;if(null!==n){var t=n.child;if(null!==t){n.child=null;do{var J=t.sibling;t.sibling=null;t=J}while(null!==t)}}V=f}}if(0!==(f.subtreeFlags&2064)&&null!==g)g.return=f,V=g;else b:for(;null!==V;){f=V;if(0!==(f.flags&2048))switch(f.tag){case 0:case 11:case 15:Pj(9,f,f.return)}var x=f.sibling;if(null!==x){x.return=f.return;V=x;break b}V=f.return}}var w=a.current;for(V=w;null!==V;){g=V;var u=g.child;if(0!==(g.subtreeFlags&2064)&&null!==
	u)u.return=g,V=u;else b:for(g=w;null!==V;){h=V;if(0!==(h.flags&2048))try{switch(h.tag){case 0:case 11:case 15:Qj(9,h)}}catch(na){W(h,h.return,na)}if(h===g){V=null;break b}var F=h.sibling;if(null!==F){F.return=h.return;V=F;break b}V=h.return}}K=e;jg();if(lc&&"function"===typeof lc.onPostCommitFiberRoot)try{lc.onPostCommitFiberRoot(kc,a)}catch(na){}d=!0}return d}finally{C=c,ok.transition=b}}return!1}function Xk(a,b,c){b=Ji(c,b);b=Ni(a,b,1);a=nh(a,b,1);b=R();null!==a&&(Ac(a,1,b),Dk(a,b))}
	function W(a,b,c){if(3===a.tag)Xk(a,a,c);else for(;null!==b;){if(3===b.tag){Xk(b,a,c);break}else if(1===b.tag){var d=b.stateNode;if("function"===typeof b.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ri||!Ri.has(d))){a=Ji(c,a);a=Qi(b,a,1);b=nh(b,a,1);a=R();null!==b&&(Ac(b,1,a),Dk(b,a));break}}b=b.return}}
	function Ti(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=R();a.pingedLanes|=a.suspendedLanes&c;Q===a&&(Z&c)===c&&(4===T||3===T&&(Z&130023424)===Z&&500>B()-fk?Kk(a,0):rk|=c);Dk(a,b)}function Yk(a,b){0===b&&(0===(a.mode&1)?b=1:(b=sc,sc<<=1,0===(sc&130023424)&&(sc=4194304)));var c=R();a=ih(a,b);null!==a&&(Ac(a,b,c),Dk(a,c))}function uj(a){var b=a.memoizedState,c=0;null!==b&&(c=b.retryLane);Yk(a,c)}
	function bk(a,b){var c=0;switch(a.tag){case 13:var d=a.stateNode;var e=a.memoizedState;null!==e&&(c=e.retryLane);break;case 19:d=a.stateNode;break;default:throw Error(p(314));}null!==d&&d.delete(b);Yk(a,c)}var Vk;
	Vk=function(a,b,c){if(null!==a)if(a.memoizedProps!==b.pendingProps||Wf.current)dh=!0;else{if(0===(a.lanes&c)&&0===(b.flags&128))return dh=!1,yj(a,b,c);dh=0!==(a.flags&131072)?!0:!1}else dh=!1,I&&0!==(b.flags&1048576)&&ug(b,ng,b.index);b.lanes=0;switch(b.tag){case 2:var d=b.type;ij(a,b);a=b.pendingProps;var e=Yf(b,H.current);ch(b,c);e=Nh(null,b,d,a,e,c);var f=Sh();b.flags|=1;"object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof?(b.tag=1,b.memoizedState=null,b.updateQueue=
	null,Zf(d)?(f=!0,cg(b)):f=!1,b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null,kh(b),e.updater=Ei,b.stateNode=e,e._reactInternals=b,Ii(b,d,a,c),b=jj(null,b,d,!0,f,c)):(b.tag=0,I&&f&&vg(b),Xi(null,b,e,c),b=b.child);return b;case 16:d=b.elementType;a:{ij(a,b);a=b.pendingProps;e=d._init;d=e(d._payload);b.type=d;e=b.tag=Zk(d);a=Ci(d,a);switch(e){case 0:b=cj(null,b,d,a,c);break a;case 1:b=hj(null,b,d,a,c);break a;case 11:b=Yi(null,b,d,a,c);break a;case 14:b=$i(null,b,d,Ci(d.type,a),c);break a}throw Error(p(306,
	d,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Ci(d,e),cj(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Ci(d,e),hj(a,b,d,e,c);case 3:a:{kj(b);if(null===a)throw Error(p(387));d=b.pendingProps;f=b.memoizedState;e=f.element;lh(a,b);qh(b,d,null,c);var g=b.memoizedState;d=g.element;if(f.isDehydrated)if(f={element:d,isDehydrated:!1,cache:g.cache,pendingSuspenseBoundaries:g.pendingSuspenseBoundaries,transitions:g.transitions},b.updateQueue.baseState=
	f,b.memoizedState=f,b.flags&256){e=Ji(Error(p(423)),b);b=lj(a,b,d,c,e);break a}else if(d!==e){e=Ji(Error(p(424)),b);b=lj(a,b,d,c,e);break a}else for(yg=Lf(b.stateNode.containerInfo.firstChild),xg=b,I=!0,zg=null,c=Vg(b,null,d,c),b.child=c;c;)c.flags=c.flags&-3|4096,c=c.sibling;else{Ig();if(d===e){b=Zi(a,b,c);break a}Xi(a,b,d,c)}b=b.child}return b;case 5:return Ah(b),null===a&&Eg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ef(d,e)?g=null:null!==f&&Ef(d,f)&&(b.flags|=32),
	gj(a,b),Xi(a,b,g,c),b.child;case 6:return null===a&&Eg(b),null;case 13:return oj(a,b,c);case 4:return yh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Ug(b,null,d,c):Xi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Ci(d,e),Yi(a,b,d,e,c);case 7:return Xi(a,b,b.pendingProps,c),b.child;case 8:return Xi(a,b,b.pendingProps.children,c),b.child;case 12:return Xi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;f=b.memoizedProps;
	g=e.value;G(Wg,d._currentValue);d._currentValue=g;if(null!==f)if(He(f.value,g)){if(f.children===e.children&&!Wf.current){b=Zi(a,b,c);break a}}else for(f=b.child,null!==f&&(f.return=b);null!==f;){var h=f.dependencies;if(null!==h){g=f.child;for(var k=h.firstContext;null!==k;){if(k.context===d){if(1===f.tag){k=mh(-1,c&-c);k.tag=2;var l=f.updateQueue;if(null!==l){l=l.shared;var m=l.pending;null===m?k.next=k:(k.next=m.next,m.next=k);l.pending=k}}f.lanes|=c;k=f.alternate;null!==k&&(k.lanes|=c);bh(f.return,
	c,b);h.lanes|=c;break}k=k.next}}else if(10===f.tag)g=f.type===b.type?null:f.child;else if(18===f.tag){g=f.return;if(null===g)throw Error(p(341));g.lanes|=c;h=g.alternate;null!==h&&(h.lanes|=c);bh(g,c,b);g=f.sibling}else g=f.child;if(null!==g)g.return=f;else for(g=f;null!==g;){if(g===b){g=null;break}f=g.sibling;if(null!==f){f.return=g.return;g=f;break}g=g.return}f=g}Xi(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,d=b.pendingProps.children,ch(b,c),e=eh(e),d=d(e),b.flags|=1,Xi(a,b,d,c),
	b.child;case 14:return d=b.type,e=Ci(d,b.pendingProps),e=Ci(d.type,e),$i(a,b,d,e,c);case 15:return bj(a,b,b.type,b.pendingProps,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Ci(d,e),ij(a,b),b.tag=1,Zf(d)?(a=!0,cg(b)):a=!1,ch(b,c),Gi(b,d,e),Ii(b,d,e,c),jj(null,b,d,!0,a,c);case 19:return xj(a,b,c);case 22:return dj(a,b,c)}throw Error(p(156,b.tag));};function Fk(a,b){return ac(a,b)}
	function $k(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.subtreeFlags=this.flags=0;this.deletions=null;this.childLanes=this.lanes=0;this.alternate=null}function Bg(a,b,c,d){return new $k(a,b,c,d)}function aj(a){a=a.prototype;return!(!a||!a.isReactComponent)}
	function Zk(a){if("function"===typeof a)return aj(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Da)return 11;if(a===Ga)return 14}return 2}
	function Pg(a,b){var c=a.alternate;null===c?(c=Bg(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.subtreeFlags=0,c.deletions=null);c.flags=a.flags&14680064;c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
	c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Rg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)aj(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ya:return Tg(c.children,e,f,b);case za:g=8;e|=8;break;case Aa:return a=Bg(12,c,b,e|2),a.elementType=Aa,a.lanes=f,a;case Ea:return a=Bg(13,c,b,e),a.elementType=Ea,a.lanes=f,a;case Fa:return a=Bg(19,c,b,e),a.elementType=Fa,a.lanes=f,a;case Ia:return pj(c,e,f,b);default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case Ba:g=10;break a;case Ca:g=9;break a;case Da:g=11;
	break a;case Ga:g=14;break a;case Ha:g=16;d=null;break a}throw Error(p(130,null==a?a:typeof a,""));}b=Bg(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Tg(a,b,c,d){a=Bg(7,a,d,b);a.lanes=c;return a}function pj(a,b,c,d){a=Bg(22,a,d,b);a.elementType=Ia;a.lanes=c;a.stateNode={isHidden:!1};return a}function Qg(a,b,c){a=Bg(6,a,null,b);a.lanes=c;return a}
	function Sg(a,b,c){b=Bg(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function al(a,b,c,d,e){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.callbackNode=this.pendingContext=this.context=null;this.callbackPriority=0;this.eventTimes=zc(0);this.expirationTimes=zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=zc(0);this.identifierPrefix=d;this.onRecoverableError=e;this.mutableSourceEagerHydrationData=
	null}function bl(a,b,c,d,e,f,g,h,k){a=new al(a,b,c,h,k);1===b?(b=1,!0===f&&(b|=8)):b=0;f=Bg(3,null,null,b);a.current=f;f.stateNode=a;f.memoizedState={element:d,isDehydrated:c,cache:null,transitions:null,pendingSuspenseBoundaries:null};kh(f);return a}function cl(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:wa,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	function dl(a){if(!a)return Vf;a=a._reactInternals;a:{if(Vb(a)!==a||1!==a.tag)throw Error(p(170));var b=a;do{switch(b.tag){case 3:b=b.stateNode.context;break a;case 1:if(Zf(b.type)){b=b.stateNode.__reactInternalMemoizedMergedChildContext;break a}}b=b.return}while(null!==b);throw Error(p(171));}if(1===a.tag){var c=a.type;if(Zf(c))return bg(a,c,b)}return b}
	function el(a,b,c,d,e,f,g,h,k){a=bl(c,d,!0,a,e,f,g,h,k);a.context=dl(null);c=a.current;d=R();e=yi(c);f=mh(d,e);f.callback=void 0!==b&&null!==b?b:null;nh(c,f,e);a.current.lanes=e;Ac(a,e,d);Dk(a,d);return a}function fl(a,b,c,d){var e=b.current,f=R(),g=yi(e);c=dl(c);null===b.context?b.context=c:b.pendingContext=c;b=mh(f,g);b.payload={element:a};d=void 0===d?null:d;null!==d&&(b.callback=d);a=nh(e,b,g);null!==a&&(gi(a,e,g,f),oh(a,e,g));return g}
	function gl(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function hl(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b}}function il(a,b){hl(a,b);(a=a.alternate)&&hl(a,b)}function jl(){return null}var kl="function"===typeof reportError?reportError:function(a){console.error(a)};function ll(a){this._internalRoot=a}
	ml.prototype.render=ll.prototype.render=function(a){var b=this._internalRoot;if(null===b)throw Error(p(409));fl(a,b,null,null)};ml.prototype.unmount=ll.prototype.unmount=function(){var a=this._internalRoot;if(null!==a){this._internalRoot=null;var b=a.containerInfo;Rk(function(){fl(null,a,null,null)});b[uf]=null}};function ml(a){this._internalRoot=a}
	ml.prototype.unstable_scheduleHydration=function(a){if(a){var b=Hc();a={blockedOn:null,target:a,priority:b};for(var c=0;c<Qc.length&&0!==b&&b<Qc[c].priority;c++);Qc.splice(c,0,a);0===c&&Vc(a)}};function nl(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType)}function ol(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function pl(){}
	function ql(a,b,c,d,e){if(e){if("function"===typeof d){var f=d;d=function(){var a=gl(g);f.call(a)}}var g=el(b,d,a,0,null,!1,!1,"",pl);a._reactRootContainer=g;a[uf]=g.current;sf(8===a.nodeType?a.parentNode:a);Rk();return g}for(;e=a.lastChild;)a.removeChild(e);if("function"===typeof d){var h=d;d=function(){var a=gl(k);h.call(a)}}var k=bl(a,0,!1,null,null,!1,!1,"",pl);a._reactRootContainer=k;a[uf]=k.current;sf(8===a.nodeType?a.parentNode:a);Rk(function(){fl(b,k,c,d)});return k}
	function rl(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f;if("function"===typeof e){var h=e;e=function(){var a=gl(g);h.call(a)}}fl(b,g,a,e)}else g=ql(c,b,a,e,d);return gl(g)}Ec=function(a){switch(a.tag){case 3:var b=a.stateNode;if(b.current.memoizedState.isDehydrated){var c=tc(b.pendingLanes);0!==c&&(Cc(b,c|1),Dk(b,B()),0===(K&6)&&(Gj=B()+500,jg()))}break;case 13:Rk(function(){var b=ih(a,1);if(null!==b){var c=R();gi(b,a,1,c)}}),il(a,1)}};
	Fc=function(a){if(13===a.tag){var b=ih(a,134217728);if(null!==b){var c=R();gi(b,a,134217728,c)}il(a,134217728)}};Gc=function(a){if(13===a.tag){var b=yi(a),c=ih(a,b);if(null!==c){var d=R();gi(c,a,b,d)}il(a,b)}};Hc=function(){return C};Ic=function(a,b){var c=C;try{return C=a,b()}finally{C=c}};
	yb=function(a,b,c){switch(b){case "input":bb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(p(90));Wa(d);bb(d,e)}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1)}};Gb=Qk;Hb=Rk;
	var sl={usingClientEntryPoint:!1,Events:[Cb,ue,Db,Eb,Fb,Qk]},tl={findFiberByHostInstance:Wc,bundleType:0,version:"18.3.1",rendererPackageName:"react-dom"};
	var ul={bundleType:tl.bundleType,version:tl.version,rendererPackageName:tl.rendererPackageName,rendererConfig:tl.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setErrorHandler:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ua.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=Zb(a);return null===a?null:a.stateNode},findFiberByHostInstance:tl.findFiberByHostInstance||
	jl,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null,reconcilerVersion:"18.3.1-next-f1338f8080-20240426"};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var vl=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!vl.isDisabled&&vl.supportsFiber)try{kc=vl.inject(ul),lc=vl}catch(a){}}exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=sl;
	exports.createPortal=function(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!nl(b))throw Error(p(200));return cl(a,b,null,c)};exports.createRoot=function(a,b){if(!nl(a))throw Error(p(299));var c=!1,d="",e=kl;null!==b&&void 0!==b&&(!0===b.unstable_strictMode&&(c=!0),void 0!==b.identifierPrefix&&(d=b.identifierPrefix),void 0!==b.onRecoverableError&&(e=b.onRecoverableError));b=bl(a,1,!1,null,null,c,!1,d,e);a[uf]=b.current;sf(8===a.nodeType?a.parentNode:a);return new ll(b)};
	exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(p(188));a=Object.keys(a).join(",");throw Error(p(268,a));}a=Zb(b);a=null===a?null:a.stateNode;return a};exports.flushSync=function(a){return Rk(a)};exports.hydrate=function(a,b,c){if(!ol(b))throw Error(p(200));return rl(null,a,b,!0,c)};
	exports.hydrateRoot=function(a,b,c){if(!nl(a))throw Error(p(405));var d=null!=c&&c.hydratedSources||null,e=!1,f="",g=kl;null!==c&&void 0!==c&&(!0===c.unstable_strictMode&&(e=!0),void 0!==c.identifierPrefix&&(f=c.identifierPrefix),void 0!==c.onRecoverableError&&(g=c.onRecoverableError));b=el(b,null,a,1,null!=c?c:null,e,!1,f,g);a[uf]=b.current;sf(a);if(d)for(a=0;a<d.length;a++)c=d[a],e=c._getVersion,e=e(c._source),null==b.mutableSourceEagerHydrationData?b.mutableSourceEagerHydrationData=[c,e]:b.mutableSourceEagerHydrationData.push(c,
	e);return new ml(b)};exports.render=function(a,b,c){if(!ol(b))throw Error(p(200));return rl(null,a,b,!1,c)};exports.unmountComponentAtNode=function(a){if(!ol(a))throw Error(p(40));return a._reactRootContainer?(Rk(function(){rl(null,null,a,!1,function(){a._reactRootContainer=null;a[uf]=null})}),!0):!1};exports.unstable_batchedUpdates=Qk;
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!ol(c))throw Error(p(200));if(null==a||void 0===a._reactInternals)throw Error(p(38));return rl(a,b,c,!1,d)};exports.version="18.3.1-next-f1338f8080-20240426";


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HtmlParser;
	
	var _htmlparser = __webpack_require__(88);
	
	var _htmlparser2 = _interopRequireDefault(_htmlparser);
	
	var _processNodes = __webpack_require__(160);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Parses a HTML string and returns a list of React components generated from it
	 *
	 * @param {String} html The HTML to convert into React component
	 * @param {Object} options Options to pass
	 * @returns {Array} List of top level React elements
	 */
	function HtmlParser(html) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$decodeEntities = _ref.decodeEntities,
	      decodeEntities = _ref$decodeEntities === undefined ? true : _ref$decodeEntities,
	      transform = _ref.transform,
	      _ref$preprocessNodes = _ref.preprocessNodes,
	      preprocessNodes = _ref$preprocessNodes === undefined ? function (nodes) {
	    return nodes;
	  } : _ref$preprocessNodes;
	
	  var nodes = preprocessNodes(_htmlparser2.default.parseDOM(html, { decodeEntities: decodeEntities }));
	  return (0, _processNodes2.default)(nodes, transform);
	}

/***/ },
/* 949 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of boolean attributes
	 * These attributes should have their React attribute value set to be the same as their name
	 * E.g. <input disabled> = <input disabled>
	 *      <input disabled=""> = <input disabled>
	 *      <input disabled="disabled"> = <input disabled>
	 * @type {Array}
	 */
	exports.default = ['allowfullScreen', 'async', 'autoplay', 'capture', 'checked', 'controls', 'default', 'defer', 'disabled', 'formnovalidate', 'hidden', 'loop', 'multiple', 'muted', 'novalidate', 'open', 'playsinline', 'readonly', 'required', 'reversed', 'scoped', 'seamless', 'selected', 'itemscope'];

/***/ },
/* 950 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Mapping of standard HTML attributes to their React counterparts
	 * List taken and reversed from react/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * https://github.com/facebook/react/blob/c9c3c339b757682f1154f1c915eb55e6a8766933/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * @type {Object}
	 */
	exports.default = {
	  /**
	   * Standard Properties
	   */
	  accept: 'accept',
	  'accept-charset': 'acceptCharset',
	  accesskey: 'accessKey',
	  action: 'action',
	  allowfullscreen: 'allowFullScreen',
	  allowtransparency: 'allowTransparency',
	  alt: 'alt',
	  as: 'as',
	  async: 'async',
	  autocomplete: 'autoComplete',
	  autoplay: 'autoPlay',
	  capture: 'capture',
	  cellpadding: 'cellPadding',
	  cellspacing: 'cellSpacing',
	  charset: 'charSet',
	  challenge: 'challenge',
	  checked: 'checked',
	  cite: 'cite',
	  classid: 'classID',
	  class: 'className',
	  cols: 'cols',
	  colspan: 'colSpan',
	  content: 'content',
	  contenteditable: 'contentEditable',
	  contextmenu: 'contextMenu',
	  controls: 'controls',
	  controlsList: 'controlsList',
	  coords: 'coords',
	  crossorigin: 'crossOrigin',
	  data: 'data',
	  datetime: 'dateTime',
	  default: 'default',
	  defer: 'defer',
	  dir: 'dir',
	  disabled: 'disabled',
	  download: 'download',
	  draggable: 'draggable',
	  enctype: 'encType',
	  form: 'form',
	  formaction: 'formAction',
	  formenctype: 'formEncType',
	  formmethod: 'formMethod',
	  formnovalidate: 'formNoValidate',
	  formtarget: 'formTarget',
	  frameborder: 'frameBorder',
	  headers: 'headers',
	  height: 'height',
	  hidden: 'hidden',
	  high: 'high',
	  href: 'href',
	  hreflang: 'hrefLang',
	  for: 'htmlFor',
	  'http-equiv': 'httpEquiv',
	  icon: 'icon',
	  id: 'id',
	  inputmode: 'inputMode',
	  integrity: 'integrity',
	  is: 'is',
	  keyparams: 'keyParams',
	  keytype: 'keyType',
	  kind: 'kind',
	  label: 'label',
	  lang: 'lang',
	  list: 'list',
	  loop: 'loop',
	  low: 'low',
	  manifest: 'manifest',
	  marginheight: 'marginHeight',
	  marginwidth: 'marginWidth',
	  max: 'max',
	  maxlength: 'maxLength',
	  media: 'media',
	  mediagroup: 'mediaGroup',
	  method: 'method',
	  min: 'min',
	  minlength: 'minLength',
	  multiple: 'multiple',
	  muted: 'muted',
	  name: 'name',
	  nonce: 'nonce',
	  novalidate: 'noValidate',
	  open: 'open',
	  optimum: 'optimum',
	  pattern: 'pattern',
	  placeholder: 'placeholder',
	  playsinline: 'playsInline',
	  poster: 'poster',
	  preload: 'preload',
	  profile: 'profile',
	  radiogroup: 'radioGroup',
	  readonly: 'readOnly',
	  referrerpolicy: 'referrerPolicy',
	  rel: 'rel',
	  required: 'required',
	  reversed: 'reversed',
	  role: 'role',
	  rows: 'rows',
	  rowspan: 'rowSpan',
	  sandbox: 'sandbox',
	  scope: 'scope',
	  scoped: 'scoped',
	  scrolling: 'scrolling',
	  seamless: 'seamless',
	  selected: 'selected',
	  shape: 'shape',
	  size: 'size',
	  sizes: 'sizes',
	  slot: 'slot',
	  span: 'span',
	  spellcheck: 'spellCheck',
	  src: 'src',
	  srcdoc: 'srcDoc',
	  srclang: 'srcLang',
	  srcset: 'srcSet',
	  start: 'start',
	  step: 'step',
	  style: 'style',
	  summary: 'summary',
	  tabindex: 'tabIndex',
	  target: 'target',
	  title: 'title',
	  type: 'type',
	  usemap: 'useMap',
	  value: 'value',
	  width: 'width',
	  wmode: 'wmode',
	  wrap: 'wrap',
	  /**
	   * RDFa Properties
	   */
	  about: 'about',
	  datatype: 'datatype',
	  inlist: 'inlist',
	  prefix: 'prefix',
	  property: 'property',
	  resource: 'resource',
	  typeof: 'typeof',
	  vocab: 'vocab',
	  /**
	   * Non-standard Properties
	   */
	  autocapitalize: 'autoCapitalize',
	  autocorrect: 'autoCorrect',
	  autosave: 'autoSave',
	  color: 'color',
	  itemprop: 'itemProp',
	  itemscope: 'itemScope',
	  itemtype: 'itemType',
	  itemid: 'itemID',
	  itemref: 'itemRef',
	  results: 'results',
	  security: 'security',
	  unselectable: 'unselectable'
	};

/***/ },
/* 951 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of void elements
	 * These elements are not allowed to have children
	 * @type {Array}
	 */
	exports.default = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StyleElementType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _generatePropsFromAttributes = __webpack_require__(403);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a <style> element to a React element
	 *
	 * @param {Object} node The style node
	 * @param {String} index The index of the React element relative to it's parent
	 * @returns {React.Element} The React style element
	 */
	function StyleElementType(node, index) {
	
	  // The style element only ever has a single child which is the styles so try and find this to add as
	  // a child to the style element that will be created
	  var styles = void 0;
	  if (node.children.length > 0) {
	    styles = node.children[0].data;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // create and return the element
	  return _react2.default.createElement('style', props, styles);
	}

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TagElementType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _processNodes = __webpack_require__(160);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	var _generatePropsFromAttributes = __webpack_require__(403);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	var _VoidElements = __webpack_require__(951);
	
	var _VoidElements2 = _interopRequireDefault(_VoidElements);
	
	var _isValidTagOrAttributeName = __webpack_require__(404);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts any element (excluding style - see StyleElementType - and script) to a react element.
	 *
	 * @param {Object} node The tag node
	 * @param {String} index The index of the React element relative to it's parent
	 * @param {Function} transform The transform function to apply to all children
	 * @returns {React.Element} The React tag element
	 */
	function TagElementType(node, index, transform) {
	
	  var tagName = node.name;
	
	  // validate tag name
	  if (!(0, _isValidTagOrAttributeName2.default)(tagName)) {
	    return null;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // If the node is not a void element and has children then process them
	  var children = null;
	  if (_VoidElements2.default.indexOf(tagName) === -1) {
	    children = (0, _processNodes2.default)(node.children, transform);
	  }
	
	  // create and return the element
	  return _react2.default.createElement(tagName, props, children);
	}

/***/ },
/* 954 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TextElementType;
	/**
	 * Converts a text node to a React text element
	 *
	 * @param {Object} node The text node
	 * @returns {String} The text
	 */
	function TextElementType(node) {
	
	  // React will accept plain text for rendering so just return the node data
	  return node.data;
	}

/***/ },
/* 955 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UnsupportedElementType;
	/**
	 * Handles an unsupported element type by returning null so nothing is rendered
	 * @returns {null}
	 */
	function UnsupportedElementType() {
	
	  // do nothing because the element type is unsupported
	  // comment, directive, script, cdata, doctype are all currently unsupported
	  return null;
	}

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ElementType$Text$Ele;
	
	var _htmlparser = __webpack_require__(88);
	
	var _TextElementType = __webpack_require__(954);
	
	var _TextElementType2 = _interopRequireDefault(_TextElementType);
	
	var _TagElementType = __webpack_require__(953);
	
	var _TagElementType2 = _interopRequireDefault(_TagElementType);
	
	var _StyleElementType = __webpack_require__(952);
	
	var _StyleElementType2 = _interopRequireDefault(_StyleElementType);
	
	var _UnsupportedElementType = __webpack_require__(955);
	
	var _UnsupportedElementType2 = _interopRequireDefault(_UnsupportedElementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * Map each htmlparser2 element type to a function which will convert that element type to a React element
	                                                                                                                                                                                                                   * Not all of the element types are supported so the UnsupportedElementType is used for them which will not return any
	                                                                                                                                                                                                                   * value
	                                                                                                                                                                                                                   */
	
	exports.default = (_ElementType$Text$Ele = {}, _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Text, _TextElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Tag, _TagElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Style, _StyleElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Directive, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Comment, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Script, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.CDATA, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Doctype, _UnsupportedElementType2.default), _ElementType$Text$Ele);

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = htmlAttributesToReact;
	
	var _BooleanAttributes = __webpack_require__(949);
	
	var _BooleanAttributes2 = _interopRequireDefault(_BooleanAttributes);
	
	var _ReactAttributes = __webpack_require__(950);
	
	var _ReactAttributes2 = _interopRequireDefault(_ReactAttributes);
	
	var _isValidTagOrAttributeName = __webpack_require__(404);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the parsed attribute value taking into account things like boolean attributes
	 *
	 * @param {String} attribute The name of the attribute
	 * @param {*} value The value of the attribute from the HTML
	 * @returns {*} The parsed attribute value
	 */
	var getParsedAttributeValue = function getParsedAttributeValue(attribute, value) {
	
	  // if the attribute if a boolean then it's value should be the same as it's name
	  // e.g. disabled="disabled"
	  var lowerBooleanAttributes = _BooleanAttributes2.default.map(function (attr) {
	    return attr.toLowerCase();
	  });
	  if (lowerBooleanAttributes.indexOf(attribute.toLowerCase()) >= 0) {
	    value = attribute;
	  }
	
	  return value;
	};
	
	/**
	 * Takes an object of standard HTML property names and converts them to their React counterpart. If the react
	 * version does not exist for an attribute then just use it as it is
	 *
	 * @param {Object} attributes The HTML attributes to convert
	 * @returns {Object} The React attributes
	 */
	function htmlAttributesToReact(attributes) {
	
	  return Object.keys(attributes).filter(function (attr) {
	    return (0, _isValidTagOrAttributeName2.default)(attr);
	  }).reduce(function (mappedAttributes, attribute) {
	
	    // lowercase the attribute name and find it in the react attribute map
	    var lowerCaseAttribute = attribute.toLowerCase();
	
	    // format the attribute name
	    var name = _ReactAttributes2.default[lowerCaseAttribute] || lowerCaseAttribute;
	
	    // add the parsed attribute value to the mapped attributes
	    mappedAttributes[name] = getParsedAttributeValue(name, attributes[attribute]);
	
	    return mappedAttributes;
	  }, {});
	}

/***/ },
/* 958 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = InlineStyleToObject;
	/**
	 * Converts an inline style string into an object of React style properties
	 *
	 * @param {String} inlineStyle='' The inline style to convert
	 * @returns {Object} The converted style
	 */
	function InlineStyleToObject() {
	  var inlineStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	  // just return empty object if the inlineStyle is empty
	  if (inlineStyle === '') {
	    return {};
	  }
	
	  return inlineStyle.split(';').reduce(function (styleObject, stylePropertyValue) {
	
	    // extract the style property name and value
	    var _stylePropertyValue$s = stylePropertyValue.split(/^([^:]+):/).filter(function (val, i) {
	      return i > 0;
	    }).map(function (item) {
	      return item.trim().toLowerCase();
	    }),
	        _stylePropertyValue$s2 = _slicedToArray(_stylePropertyValue$s, 2),
	        property = _stylePropertyValue$s2[0],
	        value = _stylePropertyValue$s2[1];
	
	    // if there is no value (i.e. no : in the style) then ignore it
	
	
	    if (value === undefined) {
	      return styleObject;
	    }
	
	    // convert the property name into the correct React format
	    // remove all hyphens and convert the letter immediately after each hyphen to upper case
	    // additionally don't uppercase any -ms- prefix
	    // e.g. -ms-style-property = msStyleProperty
	    //      -webkit-style-property = WebkitStyleProperty
	    property = property.replace(/^-ms-/, 'ms-').replace(/-(.)/g, function (_, character) {
	      return character.toUpperCase();
	    });
	
	    // add the new style property and value to the style object
	    styleObject[property] = value;
	
	    return styleObject;
	  }, {});
	}

/***/ },
/* 959 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmptyTextNode;
	/**
	 * Tests a htmlparser2 node and returns whether is it a text node at the start and end of the line containing only
	 * white space. This allows these node types to be excluded from the rendering because they are unnecessary.
	 *
	 * @param {Object} node The element object as created by htmlparser2
	 * @returns {boolean} Whether the node is an empty text node
	 */
	function isEmptyTextNode(node) {
	  return node.type === 'text' && /\r?\n/.test(node.data) && node.data.trim() === '';
	}

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	// THIS FILE IS AUTO GENERATED
	var GenIcon = __webpack_require__(76).GenIcon
	module.exports.HiAcademicCap = function HiAcademicCap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"}}]})(props);
	};
	module.exports.HiAdjustments = function HiAdjustments (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"}}]})(props);
	};
	module.exports.HiAnnotation = function HiAnnotation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArchive = function HiArchive (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M4 3a2 2 0 100 4h12a2 2 0 100-4H4z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowCircleDown = function HiArrowCircleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowCircleLeft = function HiArrowCircleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowCircleRight = function HiArrowCircleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowCircleUp = function HiArrowCircleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowDown = function HiArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l4.293-4.293a1 1 0 011.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowLeft = function HiArrowLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowNarrowDown = function HiArrowNarrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l2.293-2.293a1 1 0 011.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowNarrowLeft = function HiArrowNarrowLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowNarrowRight = function HiArrowNarrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowNarrowUp = function HiArrowNarrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowRight = function HiArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowSmDown = function HiArrowSmDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowSmLeft = function HiArrowSmLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowSmRight = function HiArrowSmRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowSmUp = function HiArrowSmUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowUp = function HiArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiArrowsExpand = function HiArrowsExpand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 01-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 110-2h4a1 1 0 011 1v4a1 1 0 11-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 112 0v1.586l2.293-2.293a1 1 0 011.414 1.414L6.414 15H8a1 1 0 110 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 110-2h1.586l-2.293-2.293a1 1 0 011.414-1.414L15 13.586V12a1 1 0 011-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiAtSymbol = function HiAtSymbol (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiBackspace = function HiBackspace (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6.707 4.879A3 3 0 018.828 4H15a3 3 0 013 3v6a3 3 0 01-3 3H8.828a3 3 0 01-2.12-.879l-4.415-4.414a1 1 0 010-1.414l4.414-4.414zm4 2.414a1 1 0 00-1.414 1.414L10.586 10l-1.293 1.293a1 1 0 101.414 1.414L12 11.414l1.293 1.293a1 1 0 001.414-1.414L13.414 10l1.293-1.293a1 1 0 00-1.414-1.414L12 8.586l-1.293-1.293z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiBadgeCheck = function HiBadgeCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiBan = function HiBan (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiBeaker = function HiBeaker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M7 2a1 1 0 00-.707 1.707L7 4.414v3.758a1 1 0 01-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.343c2.673 0 4.012-3.231 2.122-5.121l-4-4A1 1 0 0113 8.172V4.414l.707-.707A1 1 0 0013 2H7zm2 6.172V4h2v4.172a3 3 0 00.879 2.12l1.027 1.028a4 4 0 00-2.171.102l-.47.156a4 4 0 01-2.53 0l-.563-.187a1.993 1.993 0 00-.114-.035l1.063-1.063A3 3 0 009 8.172z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiBell = function HiBell (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"}}]})(props);
	};
	module.exports.HiBookOpen = function HiBookOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"}}]})(props);
	};
	module.exports.HiBookmarkAlt = function HiBookmarkAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm11 1H6v8l4-2 4 2V6z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiBookmark = function HiBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z"}}]})(props);
	};
	module.exports.HiBriefcase = function HiBriefcase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z","clipRule":"evenodd"}},{"tag":"path","attr":{"d":"M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z"}}]})(props);
	};
	module.exports.HiCake = function HiCake (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6 3a1 1 0 011-1h.01a1 1 0 010 2H7a1 1 0 01-1-1zm2 3a1 1 0 00-2 0v1a2 2 0 00-2 2v1a2 2 0 00-2 2v.683a3.7 3.7 0 011.055.485 1.704 1.704 0 001.89 0 3.704 3.704 0 014.11 0 1.704 1.704 0 001.89 0 3.704 3.704 0 014.11 0 1.704 1.704 0 001.89 0A3.7 3.7 0 0118 12.683V12a2 2 0 00-2-2V9a2 2 0 00-2-2V6a1 1 0 10-2 0v1h-1V6a1 1 0 10-2 0v1H8V6zm10 8.868a3.704 3.704 0 01-4.055-.036 1.704 1.704 0 00-1.89 0 3.704 3.704 0 01-4.11 0 1.704 1.704 0 00-1.89 0A3.704 3.704 0 012 14.868V17a1 1 0 001 1h14a1 1 0 001-1v-2.132zM9 3a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zm3 0a1 1 0 011-1h.01a1 1 0 110 2H13a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCalculator = function HiCalculator (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm1 2a1 1 0 000 2h6a1 1 0 100-2H7zm6 7a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm-3 3a1 1 0 100 2h.01a1 1 0 100-2H10zm-4 1a1 1 0 011-1h.01a1 1 0 110 2H7a1 1 0 01-1-1zm1-4a1 1 0 100 2h.01a1 1 0 100-2H7zm2 1a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zm4-4a1 1 0 100 2h.01a1 1 0 100-2H13zM9 9a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zM7 8a1 1 0 000 2h.01a1 1 0 000-2H7z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCalendar = function HiCalendar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCamera = function HiCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCash = function HiCash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChartBar = function HiChartBar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z"}}]})(props);
	};
	module.exports.HiChartPie = function HiChartPie (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"}},{"tag":"path","attr":{"d":"M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"}}]})(props);
	};
	module.exports.HiChartSquareBar = function HiChartSquareBar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChatAlt2 = function HiChatAlt2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"}},{"tag":"path","attr":{"d":"M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"}}]})(props);
	};
	module.exports.HiChatAlt = function HiChatAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChat = function HiChat (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCheckCircle = function HiCheckCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCheck = function HiCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChevronDoubleDown = function HiChevronDoubleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChevronDoubleLeft = function HiChevronDoubleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChevronDoubleRight = function HiChevronDoubleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z","clipRule":"evenodd"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChevronDoubleUp = function HiChevronDoubleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4.293 15.707a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414 0zm0-6a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 5.414 5.707 9.707a1 1 0 01-1.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChevronDown = function HiChevronDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChevronLeft = function HiChevronLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChevronRight = function HiChevronRight (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChevronUp = function HiChevronUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiChip = function HiChip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M13 7H7v6h6V7z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M7 2a1 1 0 012 0v1h2V2a1 1 0 112 0v1h2a2 2 0 012 2v2h1a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v2a2 2 0 01-2 2h-2v1a1 1 0 11-2 0v-1H9v1a1 1 0 11-2 0v-1H5a2 2 0 01-2-2v-2H2a1 1 0 110-2h1V9H2a1 1 0 010-2h1V5a2 2 0 012-2h2V2zM5 5h10v10H5V5z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiClipboardCheck = function HiClipboardCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiClipboardCopy = function HiClipboardCopy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M8 2a1 1 0 000 2h2a1 1 0 100-2H8z"}},{"tag":"path","attr":{"d":"M3 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v6h-4.586l1.293-1.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L10.414 13H15v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5zM15 11h2a1 1 0 110 2h-2v-2z"}}]})(props);
	};
	module.exports.HiClipboardList = function HiClipboardList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiClipboard = function HiClipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"}},{"tag":"path","attr":{"d":"M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"}}]})(props);
	};
	module.exports.HiClock = function HiClock (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCloudDownload = function HiCloudDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M2 9.5A3.5 3.5 0 005.5 13H9v2.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 10-.616-8.958 4.002 4.002 0 10-7.753 1.977A3.5 3.5 0 002 9.5zm9 3.5H9V8a1 1 0 012 0v5z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCloudUpload = function HiCloudUpload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M5.5 13a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 13H11V9.413l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13H5.5z"}},{"tag":"path","attr":{"d":"M9 13h2v5a1 1 0 11-2 0v-5z"}}]})(props);
	};
	module.exports.HiCloud = function HiCloud (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M5.5 16a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 16h-8z"}}]})(props);
	};
	module.exports.HiCode = function HiCode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCog = function HiCog (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCollection = function HiCollection (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z"}}]})(props);
	};
	module.exports.HiColorSwatch = function HiColorSwatch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 2a2 2 0 00-2 2v11a3 3 0 106 0V4a2 2 0 00-2-2H4zm1 14a1 1 0 100-2 1 1 0 000 2zm5-1.757l4.9-4.9a2 2 0 000-2.828L13.485 5.1a2 2 0 00-2.828 0L10 5.757v8.486zM16 18H9.071l6-6H16a2 2 0 012 2v2a2 2 0 01-2 2z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCreditCard = function HiCreditCard (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCubeTransparent = function HiCubeTransparent (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M9.504 1.132a1 1 0 01.992 0l1.75 1a1 1 0 11-.992 1.736L10 3.152l-1.254.716a1 1 0 11-.992-1.736l1.75-1zM5.618 4.504a1 1 0 01-.372 1.364L5.016 6l.23.132a1 1 0 11-.992 1.736L4 7.723V8a1 1 0 01-2 0V6a.996.996 0 01.52-.878l1.734-.99a1 1 0 011.364.372zm8.764 0a1 1 0 011.364-.372l1.733.99A1.002 1.002 0 0118 6v2a1 1 0 11-2 0v-.277l-.254.145a1 1 0 11-.992-1.736l.23-.132-.23-.132a1 1 0 01-.372-1.364zm-7 4a1 1 0 011.364-.372L10 8.848l1.254-.716a1 1 0 11.992 1.736L11 10.58V12a1 1 0 11-2 0v-1.42l-1.246-.712a1 1 0 01-.372-1.364zM3 11a1 1 0 011 1v1.42l1.246.712a1 1 0 11-.992 1.736l-1.75-1A1 1 0 012 14v-2a1 1 0 011-1zm14 0a1 1 0 011 1v2a1 1 0 01-.504.868l-1.75 1a1 1 0 11-.992-1.736L16 13.42V12a1 1 0 011-1zm-9.618 5.504a1 1 0 011.364-.372l.254.145V16a1 1 0 112 0v.277l.254-.145a1 1 0 11.992 1.736l-1.735.992a.995.995 0 01-1.022 0l-1.735-.992a1 1 0 01-.372-1.364z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCube = function HiCube (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z"}}]})(props);
	};
	module.exports.HiCurrencyBangladeshi = function HiCurrencyBangladeshi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM7 4a1 1 0 000 2 1 1 0 011 1v1H7a1 1 0 000 2h1v3a3 3 0 106 0v-1a1 1 0 10-2 0v1a1 1 0 11-2 0v-3h3a1 1 0 100-2h-3V7a3 3 0 00-3-3z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCurrencyDollar = function HiCurrencyDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCurrencyEuro = function HiCurrencyEuro (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM8.736 6.979C9.208 6.193 9.696 6 10 6c.304 0 .792.193 1.264.979a1 1 0 001.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 000 2h.013a9.358 9.358 0 000 1H6a1 1 0 100 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 10-1.715-1.029c-.472.786-.96.979-1.264.979-.304 0-.792-.193-1.264-.979a4.265 4.265 0 01-.264-.521H10a1 1 0 100-2H8.017a7.36 7.36 0 010-1H10a1 1 0 100-2H8.472c.08-.185.167-.36.264-.521z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCurrencyPound = function HiCurrencyPound (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm1-14a3 3 0 00-3 3v2H7a1 1 0 000 2h1v1a1 1 0 01-1 1 1 1 0 100 2h6a1 1 0 100-2H9.83c.11-.313.17-.65.17-1v-1h1a1 1 0 100-2h-1V7a1 1 0 112 0 1 1 0 102 0 3 3 0 00-3-3z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCurrencyRupee = function HiCurrencyRupee (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM7 5a1 1 0 100 2h1a2 2 0 011.732 1H7a1 1 0 100 2h2.732A2 2 0 018 11H7a1 1 0 00-.707 1.707l3 3a1 1 0 001.414-1.414l-1.483-1.484A4.008 4.008 0 0011.874 10H13a1 1 0 100-2h-1.126a3.976 3.976 0 00-.41-1H13a1 1 0 100-2H7z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCurrencyYen = function HiCurrencyYen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM7.858 5.485a1 1 0 00-1.715 1.03L7.633 9H7a1 1 0 100 2h1.834l.166.277V12H7a1 1 0 100 2h2v1a1 1 0 102 0v-1h2a1 1 0 100-2h-2v-.723l.166-.277H13a1 1 0 100-2h-.634l1.492-2.486a1 1 0 10-1.716-1.029L10.034 9h-.068L7.858 5.485z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiCursorClick = function HiCursorClick (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDatabase = function HiDatabase (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z"}},{"tag":"path","attr":{"d":"M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z"}},{"tag":"path","attr":{"d":"M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z"}}]})(props);
	};
	module.exports.HiDesktopComputer = function HiDesktopComputer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDeviceMobile = function HiDeviceMobile (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDeviceTablet = function HiDeviceTablet (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm4 14a1 1 0 100-2 1 1 0 000 2z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDocumentAdd = function HiDocumentAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDocumentDownload = function HiDocumentDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDocumentDuplicate = function HiDocumentDuplicate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"}},{"tag":"path","attr":{"d":"M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"}}]})(props);
	};
	module.exports.HiDocumentRemove = function HiDocumentRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm1 8a1 1 0 100 2h6a1 1 0 100-2H7z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDocumentReport = function HiDocumentReport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm4-1a1 1 0 10-2 0v7a1 1 0 102 0V8z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDocumentSearch = function HiDocumentSearch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2h-1.528A6 6 0 004 9.528V4z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M8 10a4 4 0 00-3.446 6.032l-1.261 1.26a1 1 0 101.414 1.415l1.261-1.261A4 4 0 108 10zm-2 4a2 2 0 114 0 2 2 0 01-4 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDocumentText = function HiDocumentText (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDocument = function HiDocument (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDotsCircleHorizontal = function HiDotsCircleHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDotsHorizontal = function HiDotsHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"}}]})(props);
	};
	module.exports.HiDotsVertical = function HiDotsVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"}}]})(props);
	};
	module.exports.HiDownload = function HiDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiDuplicate = function HiDuplicate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z"}},{"tag":"path","attr":{"d":"M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z"}}]})(props);
	};
	module.exports.HiEmojiHappy = function HiEmojiHappy (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiEmojiSad = function HiEmojiSad (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-7.536 5.879a1 1 0 001.415 0 3 3 0 014.242 0 1 1 0 001.415-1.415 5 5 0 00-7.072 0 1 1 0 000 1.415z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiExclamationCircle = function HiExclamationCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiExclamation = function HiExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiExternalLink = function HiExternalLink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"}},{"tag":"path","attr":{"d":"M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"}}]})(props);
	};
	module.exports.HiEyeOff = function HiEyeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z","clipRule":"evenodd"}},{"tag":"path","attr":{"d":"M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"}}]})(props);
	};
	module.exports.HiEye = function HiEye (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M10 12a2 2 0 100-4 2 2 0 000 4z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiFastForward = function HiFastForward (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M4.555 5.168A1 1 0 003 6v8a1 1 0 001.555.832L10 11.202V14a1 1 0 001.555.832l6-4a1 1 0 000-1.664l-6-4A1 1 0 0010 6v2.798l-5.445-3.63z"}}]})(props);
	};
	module.exports.HiFilm = function HiFilm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm3 2h6v4H7V5zm8 8v2h1v-2h-1zm-2-2H7v4h6v-4zm2 0h1V9h-1v2zm1-4V5h-1v2h1zM5 5v2H4V5h1zm0 4H4v2h1V9zm-1 4h1v2H4v-2z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiFilter = function HiFilter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiFingerPrint = function HiFingerPrint (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M6.625 2.655A9 9 0 0119 11a1 1 0 11-2 0 7 7 0 00-9.625-6.492 1 1 0 11-.75-1.853zM4.662 4.959A1 1 0 014.75 6.37 6.97 6.97 0 003 11a1 1 0 11-2 0 8.97 8.97 0 012.25-5.953 1 1 0 011.412-.088z","clipRule":"evenodd"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 11a5 5 0 1110 0 1 1 0 11-2 0 3 3 0 10-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 11-1.838-.789A9.964 9.964 0 005 11zm8.921 2.012a1 1 0 01.831 1.145 19.86 19.86 0 01-.545 2.436 1 1 0 11-1.92-.558c.207-.713.371-1.445.49-2.192a1 1 0 011.144-.83z","clipRule":"evenodd"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 10a1 1 0 011 1c0 2.236-.46 4.368-1.29 6.304a1 1 0 01-1.838-.789A13.952 13.952 0 009 11a1 1 0 011-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiFire = function HiFire (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiFlag = function HiFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiFolderAdd = function HiFolderAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 10-2 0v1H8a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V9z"}}]})(props);
	};
	module.exports.HiFolderDownload = function HiFolderDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 10-2 0v1.586l-.293-.293a1 1 0 10-1.414 1.414l2 2 .002.002a.997.997 0 001.41 0l.002-.002 2-2a1 1 0 00-1.414-1.414l-.293.293V9z"}}]})(props);
	};
	module.exports.HiFolderOpen = function HiFolderOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z","clipRule":"evenodd"}},{"tag":"path","attr":{"d":"M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H2h2a2 2 0 002-2v-2z"}}]})(props);
	};
	module.exports.HiFolderRemove = function HiFolderRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm4 6a1 1 0 100 2h4a1 1 0 100-2H8z"}}]})(props);
	};
	module.exports.HiFolder = function HiFolder (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"}}]})(props);
	};
	module.exports.HiGift = function HiGift (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 5a3 3 0 015-2.236A3 3 0 0114.83 6H16a2 2 0 110 4h-5V9a1 1 0 10-2 0v1H4a2 2 0 110-4h1.17C5.06 5.687 5 5.35 5 5zm4 1V5a1 1 0 10-1 1h1zm3 0a1 1 0 10-1-1v1h1z","clipRule":"evenodd"}},{"tag":"path","attr":{"d":"M9 11H3v5a2 2 0 002 2h4v-7zM11 18h4a2 2 0 002-2v-5h-6v7z"}}]})(props);
	};
	module.exports.HiGlobeAlt = function HiGlobeAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiGlobe = function HiGlobe (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiHand = function HiHand (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiHashtag = function HiHashtag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M9.243 3.03a1 1 0 01.727 1.213L9.53 6h2.94l.56-2.243a1 1 0 111.94.486L14.53 6H17a1 1 0 110 2h-2.97l-1 4H15a1 1 0 110 2h-2.47l-.56 2.242a1 1 0 11-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 11-1.94-.485L5.47 14H3a1 1 0 110-2h2.97l1-4H5a1 1 0 110-2h2.47l.56-2.243a1 1 0 011.213-.727zM9.03 8l-1 4h2.938l1-4H9.031z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiHeart = function HiHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiHome = function HiHome (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"}}]})(props);
	};
	module.exports.HiIdentification = function HiIdentification (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zM4 4h3a3 3 0 006 0h3a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm2.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2.45 4a2.5 2.5 0 10-4.9 0h4.9zM12 9a1 1 0 100 2h3a1 1 0 100-2h-3zm-1 4a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiInboxIn = function HiInboxIn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"}},{"tag":"path","attr":{"d":"M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"}}]})(props);
	};
	module.exports.HiInbox = function HiInbox (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm0 2h10v7h-2l-1 2H8l-1-2H5V5z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiInformationCircle = function HiInformationCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiKey = function HiKey (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiLibrary = function HiLibrary (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10.496 2.132a1 1 0 00-.992 0l-7 4A1 1 0 003 8v7a1 1 0 100 2h14a1 1 0 100-2V8a1 1 0 00.496-1.868l-7-4zM6 9a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm3 1a1 1 0 012 0v3a1 1 0 11-2 0v-3zm5-1a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiLightBulb = function HiLightBulb (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z"}}]})(props);
	};
	module.exports.HiLightningBolt = function HiLightningBolt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiLink = function HiLink (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiLocationMarker = function HiLocationMarker (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiLockClosed = function HiLockClosed (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiLockOpen = function HiLockOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z"}}]})(props);
	};
	module.exports.HiLogin = function HiLogin (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiLogout = function HiLogout (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMailOpen = function HiMailOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M2.94 6.412A2 2 0 002 8.108V16a2 2 0 002 2h12a2 2 0 002-2V8.108a2 2 0 00-.94-1.696l-6-3.75a2 2 0 00-2.12 0l-6 3.75zm2.615 2.423a1 1 0 10-1.11 1.664l5 3.333a1 1 0 001.11 0l5-3.333a1 1 0 00-1.11-1.664L10 11.798 5.555 8.835z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMail = function HiMail (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"}},{"tag":"path","attr":{"d":"M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"}}]})(props);
	};
	module.exports.HiMap = function HiMap (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMenuAlt1 = function HiMenuAlt1 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMenuAlt2 = function HiMenuAlt2 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMenuAlt3 = function HiMenuAlt3 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMenuAlt4 = function HiMenuAlt4 (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 7a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 13a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMenu = function HiMenu (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMicrophone = function HiMicrophone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMinusCircle = function HiMinusCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMinusSm = function HiMinusSm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMinus = function HiMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiMoon = function HiMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"}}]})(props);
	};
	module.exports.HiMusicNote = function HiMusicNote (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z"}}]})(props);
	};
	module.exports.HiNewspaper = function HiNewspaper (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M2 5a2 2 0 012-2h8a2 2 0 012 2v10a2 2 0 002 2H4a2 2 0 01-2-2V5zm3 1h6v4H5V6zm6 6H5v2h6v-2z","clipRule":"evenodd"}},{"tag":"path","attr":{"d":"M15 7h1a2 2 0 012 2v5.5a1.5 1.5 0 01-3 0V7z"}}]})(props);
	};
	module.exports.HiOfficeBuilding = function HiOfficeBuilding (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPaperAirplane = function HiPaperAirplane (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"}}]})(props);
	};
	module.exports.HiPaperClip = function HiPaperClip (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPause = function HiPause (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPencilAlt = function HiPencilAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPencil = function HiPencil (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"}}]})(props);
	};
	module.exports.HiPhoneIncoming = function HiPhoneIncoming (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M14.414 7l3.293-3.293a1 1 0 00-1.414-1.414L13 5.586V4a1 1 0 10-2 0v4.003a.996.996 0 00.617.921A.997.997 0 0012 9h4a1 1 0 100-2h-1.586z"}},{"tag":"path","attr":{"d":"M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"}}]})(props);
	};
	module.exports.HiPhoneMissedCall = function HiPhoneMissedCall (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"}},{"tag":"path","attr":{"d":"M16.707 3.293a1 1 0 010 1.414L15.414 6l1.293 1.293a1 1 0 01-1.414 1.414L14 7.414l-1.293 1.293a1 1 0 11-1.414-1.414L12.586 6l-1.293-1.293a1 1 0 011.414-1.414L14 4.586l1.293-1.293a1 1 0 011.414 0z"}}]})(props);
	};
	module.exports.HiPhoneOutgoing = function HiPhoneOutgoing (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M17.924 2.617a.997.997 0 00-.215-.322l-.004-.004A.997.997 0 0017 2h-4a1 1 0 100 2h1.586l-3.293 3.293a1 1 0 001.414 1.414L16 5.414V7a1 1 0 102 0V3a.997.997 0 00-.076-.383z"}},{"tag":"path","attr":{"d":"M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"}}]})(props);
	};
	module.exports.HiPhone = function HiPhone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"}}]})(props);
	};
	module.exports.HiPhotograph = function HiPhotograph (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPlay = function HiPlay (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPlusCircle = function HiPlusCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPlusSm = function HiPlusSm (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPlus = function HiPlus (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPresentationChartBar = function HiPresentationChartBar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11 4a1 1 0 10-2 0v4a1 1 0 102 0V7zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0V8zM8 9a1 1 0 00-2 0v2a1 1 0 102 0V9z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPresentationChartLine = function HiPresentationChartLine (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 0l-2 2a1 1 0 101.414 1.414L8 10.414l1.293 1.293a1 1 0 001.414 0l4-4z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPrinter = function HiPrinter (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiPuzzle = function HiPuzzle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z"}}]})(props);
	};
	module.exports.HiQrcode = function HiQrcode (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z","clipRule":"evenodd"}},{"tag":"path","attr":{"d":"M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z"}}]})(props);
	};
	module.exports.HiQuestionMarkCircle = function HiQuestionMarkCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiReceiptRefund = function HiReceiptRefund (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm4.707 3.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L8.414 9H10a3 3 0 013 3v1a1 1 0 102 0v-1a5 5 0 00-5-5H8.414l1.293-1.293z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiReceiptTax = function HiReceiptTax (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm2.5 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.207.293a1 1 0 00-1.414 0l-6 6a1 1 0 101.414 1.414l6-6a1 1 0 000-1.414zM12.5 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiRefresh = function HiRefresh (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiReply = function HiReply (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiRewind = function HiRewind (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M8.445 14.832A1 1 0 0010 14v-2.798l5.445 3.63A1 1 0 0017 14V6a1 1 0 00-1.555-.832L10 8.798V6a1 1 0 00-1.555-.832l-6 4a1 1 0 000 1.664l6 4z"}}]})(props);
	};
	module.exports.HiRss = function HiRss (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M5 3a1 1 0 000 2c5.523 0 10 4.477 10 10a1 1 0 102 0C17 8.373 11.627 3 5 3z"}},{"tag":"path","attr":{"d":"M4 9a1 1 0 011-1 7 7 0 017 7 1 1 0 11-2 0 5 5 0 00-5-5 1 1 0 01-1-1zM3 15a2 2 0 114 0 2 2 0 01-4 0z"}}]})(props);
	};
	module.exports.HiSaveAs = function HiSaveAs (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M9.707 7.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L13 8.586V5h3a2 2 0 012 2v5a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2h3v3.586L9.707 7.293zM11 3a1 1 0 112 0v2h-2V3z"}},{"tag":"path","attr":{"d":"M4 9a2 2 0 00-2 2v5a2 2 0 002 2h8a2 2 0 002-2H4V9z"}}]})(props);
	};
	module.exports.HiSave = function HiSave (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z"}}]})(props);
	};
	module.exports.HiScale = function HiScale (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 5.42a1 1 0 01-.285 1.05A3.989 3.989 0 0115 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 110 2H7a1 1 0 110-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 01-.285 1.05A3.989 3.989 0 015 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.738-5.42-1.233-.617a1 1 0 01.894-1.788l1.599.799L9 4.323V3a1 1 0 011-1zm-5 8.274l-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L5 10.274zm10 0l-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L15 10.274z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiScissors = function HiScissors (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5.5 2a3.5 3.5 0 101.665 6.58L8.585 10l-1.42 1.42a3.5 3.5 0 101.414 1.414l8.128-8.127a1 1 0 00-1.414-1.414L10 8.586l-1.42-1.42A3.5 3.5 0 005.5 2zM4 5.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0 9a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z","clipRule":"evenodd"}},{"tag":"path","attr":{"d":"M12.828 11.414a1 1 0 00-1.414 1.414l3.879 3.88a1 1 0 001.414-1.415l-3.879-3.879z"}}]})(props);
	};
	module.exports.HiSearchCircle = function HiSearchCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M9 9a2 2 0 114 0 2 2 0 01-4 0z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a4 4 0 00-3.446 6.032l-2.261 2.26a1 1 0 101.414 1.415l2.261-2.261A4 4 0 1011 5z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiSearch = function HiSearch (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiSelector = function HiSelector (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiServer = function HiServer (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm14 1a1 1 0 11-2 0 1 1 0 012 0zM2 13a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm14 1a1 1 0 11-2 0 1 1 0 012 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiShare = function HiShare (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z"}}]})(props);
	};
	module.exports.HiShieldCheck = function HiShieldCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiShieldExclamation = function HiShieldExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 1.944A11.954 11.954 0 012.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0110 1.944zM11 14a1 1 0 11-2 0 1 1 0 012 0zm0-7a1 1 0 10-2 0v3a1 1 0 102 0V7z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiShoppingBag = function HiShoppingBag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiShoppingCart = function HiShoppingCart (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"}}]})(props);
	};
	module.exports.HiSortAscending = function HiSortAscending (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z"}}]})(props);
	};
	module.exports.HiSortDescending = function HiSortDescending (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h7a1 1 0 100-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"}}]})(props);
	};
	module.exports.HiSparkles = function HiSparkles (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiSpeakerphone = function HiSpeakerphone (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiStar = function HiStar (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"}}]})(props);
	};
	module.exports.HiStatusOffline = function HiStatusOffline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M3.707 2.293a1 1 0 00-1.414 1.414l6.921 6.922c.05.062.105.118.168.167l6.91 6.911a1 1 0 001.415-1.414l-.675-.675a9.001 9.001 0 00-.668-11.982A1 1 0 1014.95 5.05a7.002 7.002 0 01.657 9.143l-1.435-1.435a5.002 5.002 0 00-.636-6.294A1 1 0 0012.12 7.88c.924.923 1.12 2.3.587 3.415l-1.992-1.992a.922.922 0 00-.018-.018l-6.99-6.991zM3.238 8.187a1 1 0 00-1.933-.516c-.8 3-.025 6.336 2.331 8.693a1 1 0 001.414-1.415 6.997 6.997 0 01-1.812-6.762zM7.4 11.5a1 1 0 10-1.73 1c.214.371.48.72.795 1.035a1 1 0 001.414-1.414c-.191-.191-.35-.4-.478-.622z"}}]})(props);
	};
	module.exports.HiStatusOnline = function HiStatusOnline (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5.05 3.636a1 1 0 010 1.414 7 7 0 000 9.9 1 1 0 11-1.414 1.414 9 9 0 010-12.728 1 1 0 011.414 0zm9.9 0a1 1 0 011.414 0 9 9 0 010 12.728 1 1 0 11-1.414-1.414 7 7 0 000-9.9 1 1 0 010-1.414zM7.879 6.464a1 1 0 010 1.414 3 3 0 000 4.243 1 1 0 11-1.415 1.414 5 5 0 010-7.07 1 1 0 011.415 0zm4.242 0a1 1 0 011.415 0 5 5 0 010 7.072 1 1 0 01-1.415-1.415 3 3 0 000-4.242 1 1 0 010-1.415zM10 9a1 1 0 011 1v.01a1 1 0 11-2 0V10a1 1 0 011-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiStop = function HiStop (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiSun = function HiSun (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiSupport = function HiSupport (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 00.078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10zm-5.165 3.913l1.58 1.58A5.98 5.98 0 0110 16a5.976 5.976 0 01-2.516-.552l1.562-1.562a4.006 4.006 0 001.789.027zm-4.677-2.796a4.002 4.002 0 01-.041-2.08l-.08.08-1.53-1.533A5.98 5.98 0 004 10c0 .954.223 1.856.619 2.657l1.54-1.54zm1.088-6.45A5.974 5.974 0 0110 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4.002 4.002 0 00-2.346.033L7.246 4.668zM12 10a2 2 0 11-4 0 2 2 0 014 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiSwitchHorizontal = function HiSwitchHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z"}}]})(props);
	};
	module.exports.HiSwitchVertical = function HiSwitchVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M5 12a1 1 0 102 0V6.414l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L5 6.414V12zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"}}]})(props);
	};
	module.exports.HiTable = function HiTable (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiTag = function HiTag (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiTemplate = function HiTemplate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"}}]})(props);
	};
	module.exports.HiTerminal = function HiTerminal (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiThumbDown = function HiThumbDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M18 9.5a1.5 1.5 0 11-3 0v-6a1.5 1.5 0 013 0v6zM14 9.667v-5.43a2 2 0 00-1.105-1.79l-.05-.025A4 4 0 0011.055 2H5.64a2 2 0 00-1.962 1.608l-1.2 6A2 2 0 004.44 12H8v4a2 2 0 002 2 1 1 0 001-1v-.667a4 4 0 01.8-2.4l1.4-1.866a4 4 0 00.8-2.4z"}}]})(props);
	};
	module.exports.HiThumbUp = function HiThumbUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z"}}]})(props);
	};
	module.exports.HiTicket = function HiTicket (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M2 6a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 100 4v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2a2 2 0 100-4V6z"}}]})(props);
	};
	module.exports.HiTranslate = function HiTranslate (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M7 2a1 1 0 011 1v1h3a1 1 0 110 2H9.578a18.87 18.87 0 01-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 11-1.44 1.389c-.188-.196-.373-.396-.554-.6a19.098 19.098 0 01-3.107 3.567 1 1 0 01-1.334-1.49 17.087 17.087 0 003.13-3.733 18.992 18.992 0 01-1.487-2.494 1 1 0 111.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 110-2h3V3a1 1 0 011-1zm6 6a1 1 0 01.894.553l2.991 5.982a.869.869 0 01.02.037l.99 1.98a1 1 0 11-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 11-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0113 8zm-1.382 6h2.764L13 11.236 11.618 14z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiTrash = function HiTrash (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiTrendingDown = function HiTrendingDown (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M12 13a1 1 0 100 2h5a1 1 0 001-1V9a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586 3.707 5.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiTrendingUp = function HiTrendingUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiTruck = function HiTruck (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"}},{"tag":"path","attr":{"d":"M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"}}]})(props);
	};
	module.exports.HiUpload = function HiUpload (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiUserAdd = function HiUserAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z"}}]})(props);
	};
	module.exports.HiUserCircle = function HiUserCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiUserGroup = function HiUserGroup (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"}}]})(props);
	};
	module.exports.HiUserRemove = function HiUserRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M11 6a3 3 0 11-6 0 3 3 0 016 0zM14 17a6 6 0 00-12 0h12zM13 8a1 1 0 100 2h4a1 1 0 100-2h-4z"}}]})(props);
	};
	module.exports.HiUser = function HiUser (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiUsers = function HiUsers (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"}}]})(props);
	};
	module.exports.HiVariable = function HiVariable (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4.649 3.084A1 1 0 015.163 4.4 13.95 13.95 0 004 10c0 1.993.416 3.886 1.164 5.6a1 1 0 01-1.832.8A15.95 15.95 0 012 10c0-2.274.475-4.44 1.332-6.4a1 1 0 011.317-.516zM12.96 7a3 3 0 00-2.342 1.126l-.328.41-.111-.279A2 2 0 008.323 7H8a1 1 0 000 2h.323l.532 1.33-1.035 1.295a1 1 0 01-.781.375H7a1 1 0 100 2h.039a3 3 0 002.342-1.126l.328-.41.111.279A2 2 0 0011.677 14H12a1 1 0 100-2h-.323l-.532-1.33 1.035-1.295A1 1 0 0112.961 9H13a1 1 0 100-2h-.039zm1.874-2.6a1 1 0 011.833-.8A15.95 15.95 0 0118 10c0 2.274-.475 4.44-1.332 6.4a1 1 0 11-1.832-.8A13.949 13.949 0 0016 10c0-1.993-.416-3.886-1.165-5.6z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiVideoCamera = function HiVideoCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"}}]})(props);
	};
	module.exports.HiViewBoards = function HiViewBoards (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M2 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V4zM8 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H9a1 1 0 01-1-1V4zM15 3a1 1 0 00-1 1v12a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1h-2z"}}]})(props);
	};
	module.exports.HiViewGridAdd = function HiViewGridAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z"}}]})(props);
	};
	module.exports.HiViewGrid = function HiViewGrid (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"}}]})(props);
	};
	module.exports.HiViewList = function HiViewList (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiVolumeOff = function HiVolumeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiVolumeUp = function HiVolumeUp (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiWifi = function HiWifi (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M17.778 8.222c-4.296-4.296-11.26-4.296-15.556 0A1 1 0 01.808 6.808c5.076-5.077 13.308-5.077 18.384 0a1 1 0 01-1.414 1.414zM14.95 11.05a7 7 0 00-9.9 0 1 1 0 01-1.414-1.414 9 9 0 0112.728 0 1 1 0 01-1.414 1.414zM12.12 13.88a3 3 0 00-4.242 0 1 1 0 01-1.415-1.415 5 5 0 017.072 0 1 1 0 01-1.415 1.415zM9 16a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiXCircle = function HiXCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiX = function HiX (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiZoomIn = function HiZoomIn (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M5 8a1 1 0 011-1h1V6a1 1 0 012 0v1h1a1 1 0 110 2H9v1a1 1 0 11-2 0V9H6a1 1 0 01-1-1z"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8zm6-4a4 4 0 100 8 4 4 0 000-8z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiZoomOut = function HiZoomOut (props) {
	  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z","clipRule":"evenodd"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M5 8a1 1 0 011-1h4a1 1 0 110 2H6a1 1 0 01-1-1z","clipRule":"evenodd"}}]})(props);
	};
	module.exports.HiOutlineAcademicCap = function HiOutlineAcademicCap (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M12 14l9-5-9-5-9 5 9 5z"}},{"tag":"path","attr":{"d":"M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"}}]})(props);
	};
	module.exports.HiOutlineAdjustments = function HiOutlineAdjustments (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"}}]})(props);
	};
	module.exports.HiOutlineAnnotation = function HiOutlineAnnotation (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"}}]})(props);
	};
	module.exports.HiOutlineArchive = function HiOutlineArchive (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"}}]})(props);
	};
	module.exports.HiOutlineArrowCircleDown = function HiOutlineArrowCircleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"}}]})(props);
	};
	module.exports.HiOutlineArrowCircleLeft = function HiOutlineArrowCircleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"}}]})(props);
	};
	module.exports.HiOutlineArrowCircleRight = function HiOutlineArrowCircleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineArrowCircleUp = function HiOutlineArrowCircleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z"}}]})(props);
	};
	module.exports.HiOutlineArrowDown = function HiOutlineArrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M19 14l-7 7m0 0l-7-7m7 7V3"}}]})(props);
	};
	module.exports.HiOutlineArrowLeft = function HiOutlineArrowLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M10 19l-7-7m0 0l7-7m-7 7h18"}}]})(props);
	};
	module.exports.HiOutlineArrowNarrowDown = function HiOutlineArrowNarrowDown (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M16 17l-4 4m0 0l-4-4m4 4V3"}}]})(props);
	};
	module.exports.HiOutlineArrowNarrowLeft = function HiOutlineArrowNarrowLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 16l-4-4m0 0l4-4m-4 4h18"}}]})(props);
	};
	module.exports.HiOutlineArrowNarrowRight = function HiOutlineArrowNarrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 8l4 4m0 0l-4 4m4-4H3"}}]})(props);
	};
	module.exports.HiOutlineArrowNarrowUp = function HiOutlineArrowNarrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 7l4-4m0 0l4 4m-4-4v18"}}]})(props);
	};
	module.exports.HiOutlineArrowRight = function HiOutlineArrowRight (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M14 5l7 7m0 0l-7 7m7-7H3"}}]})(props);
	};
	module.exports.HiOutlineArrowSmDown = function HiOutlineArrowSmDown (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 13l-5 5m0 0l-5-5m5 5V6"}}]})(props);
	};
	module.exports.HiOutlineArrowSmLeft = function HiOutlineArrowSmLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M11 17l-5-5m0 0l5-5m-5 5h12"}}]})(props);
	};
	module.exports.HiOutlineArrowSmRight = function HiOutlineArrowSmRight (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M13 7l5 5m0 0l-5 5m5-5H6"}}]})(props);
	};
	module.exports.HiOutlineArrowSmUp = function HiOutlineArrowSmUp (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 11l5-5m0 0l5 5m-5-5v12"}}]})(props);
	};
	module.exports.HiOutlineArrowUp = function HiOutlineArrowUp (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5 10l7-7m0 0l7 7m-7-7v18"}}]})(props);
	};
	module.exports.HiOutlineArrowsExpand = function HiOutlineArrowsExpand (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"}}]})(props);
	};
	module.exports.HiOutlineAtSymbol = function HiOutlineAtSymbol (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"}}]})(props);
	};
	module.exports.HiOutlineBackspace = function HiOutlineBackspace (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z"}}]})(props);
	};
	module.exports.HiOutlineBadgeCheck = function HiOutlineBadgeCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"}}]})(props);
	};
	module.exports.HiOutlineBan = function HiOutlineBan (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"}}]})(props);
	};
	module.exports.HiOutlineBeaker = function HiOutlineBeaker (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"}}]})(props);
	};
	module.exports.HiOutlineBell = function HiOutlineBell (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"}}]})(props);
	};
	module.exports.HiOutlineBookOpen = function HiOutlineBookOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"}}]})(props);
	};
	module.exports.HiOutlineBookmarkAlt = function HiOutlineBookmarkAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineBookmark = function HiOutlineBookmark (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"}}]})(props);
	};
	module.exports.HiOutlineBriefcase = function HiOutlineBriefcase (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineCake = function HiOutlineCake (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.701 2.701 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z"}}]})(props);
	};
	module.exports.HiOutlineCalculator = function HiOutlineCalculator (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineCalendar = function HiOutlineCalendar (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineCamera = function HiOutlineCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 13a3 3 0 11-6 0 3 3 0 016 0z"}}]})(props);
	};
	module.exports.HiOutlineCash = function HiOutlineCash (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"}}]})(props);
	};
	module.exports.HiOutlineChartBar = function HiOutlineChartBar (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"}}]})(props);
	};
	module.exports.HiOutlineChartPie = function HiOutlineChartPie (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"}}]})(props);
	};
	module.exports.HiOutlineChartSquareBar = function HiOutlineChartSquareBar (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineChatAlt2 = function HiOutlineChatAlt2 (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"}}]})(props);
	};
	module.exports.HiOutlineChatAlt = function HiOutlineChatAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"}}]})(props);
	};
	module.exports.HiOutlineChat = function HiOutlineChat (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"}}]})(props);
	};
	module.exports.HiOutlineCheckCircle = function HiOutlineCheckCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineCheck = function HiOutlineCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5 13l4 4L19 7"}}]})(props);
	};
	module.exports.HiOutlineChevronDoubleDown = function HiOutlineChevronDoubleDown (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M19 13l-7 7-7-7m14-8l-7 7-7-7"}}]})(props);
	};
	module.exports.HiOutlineChevronDoubleLeft = function HiOutlineChevronDoubleLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M11 19l-7-7 7-7m8 14l-7-7 7-7"}}]})(props);
	};
	module.exports.HiOutlineChevronDoubleRight = function HiOutlineChevronDoubleRight (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M13 5l7 7-7 7M5 5l7 7-7 7"}}]})(props);
	};
	module.exports.HiOutlineChevronDoubleUp = function HiOutlineChevronDoubleUp (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5 11l7-7 7 7M5 19l7-7 7 7"}}]})(props);
	};
	module.exports.HiOutlineChevronDown = function HiOutlineChevronDown (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M19 9l-7 7-7-7"}}]})(props);
	};
	module.exports.HiOutlineChevronLeft = function HiOutlineChevronLeft (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 19l-7-7 7-7"}}]})(props);
	};
	module.exports.HiOutlineChevronRight = function HiOutlineChevronRight (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 5l7 7-7 7"}}]})(props);
	};
	module.exports.HiOutlineChevronUp = function HiOutlineChevronUp (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5 15l7-7 7 7"}}]})(props);
	};
	module.exports.HiOutlineChip = function HiOutlineChip (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"}}]})(props);
	};
	module.exports.HiOutlineClipboardCheck = function HiOutlineClipboardCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"}}]})(props);
	};
	module.exports.HiOutlineClipboardCopy = function HiOutlineClipboardCopy (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"}}]})(props);
	};
	module.exports.HiOutlineClipboardList = function HiOutlineClipboardList (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"}}]})(props);
	};
	module.exports.HiOutlineClipboard = function HiOutlineClipboard (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"}}]})(props);
	};
	module.exports.HiOutlineClock = function HiOutlineClock (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineCloudDownload = function HiOutlineCloudDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"}}]})(props);
	};
	module.exports.HiOutlineCloudUpload = function HiOutlineCloudUpload (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"}}]})(props);
	};
	module.exports.HiOutlineCloud = function HiOutlineCloud (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"}}]})(props);
	};
	module.exports.HiOutlineCode = function HiOutlineCode (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"}}]})(props);
	};
	module.exports.HiOutlineCog = function HiOutlineCog (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 12a3 3 0 11-6 0 3 3 0 016 0z"}}]})(props);
	};
	module.exports.HiOutlineCollection = function HiOutlineCollection (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"}}]})(props);
	};
	module.exports.HiOutlineColorSwatch = function HiOutlineColorSwatch (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"}}]})(props);
	};
	module.exports.HiOutlineCreditCard = function HiOutlineCreditCard (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"}}]})(props);
	};
	module.exports.HiOutlineCubeTransparent = function HiOutlineCubeTransparent (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"}}]})(props);
	};
	module.exports.HiOutlineCube = function HiOutlineCube (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"}}]})(props);
	};
	module.exports.HiOutlineCurrencyBangladeshi = function HiOutlineCurrencyBangladeshi (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M11 11V9a2 2 0 00-2-2m2 4v4a2 2 0 104 0v-1m-4-3H9m2 0h4m6 1a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineCurrencyDollar = function HiOutlineCurrencyDollar (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineCurrencyEuro = function HiOutlineCurrencyEuro (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineCurrencyPound = function HiOutlineCurrencyPound (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineCurrencyRupee = function HiOutlineCurrencyRupee (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineCurrencyYen = function HiOutlineCurrencyYen (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 8l3 5m0 0l3-5m-3 5v4m-3-5h6m-6 3h6m6-3a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineCursorClick = function HiOutlineCursorClick (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"}}]})(props);
	};
	module.exports.HiOutlineDatabase = function HiOutlineDatabase (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"}}]})(props);
	};
	module.exports.HiOutlineDesktopComputer = function HiOutlineDesktopComputer (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineDeviceMobile = function HiOutlineDeviceMobile (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineDeviceTablet = function HiOutlineDeviceTablet (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineDocumentAdd = function HiOutlineDocumentAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"}}]})(props);
	};
	module.exports.HiOutlineDocumentDownload = function HiOutlineDocumentDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"}}]})(props);
	};
	module.exports.HiOutlineDocumentDuplicate = function HiOutlineDocumentDuplicate (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"}}]})(props);
	};
	module.exports.HiOutlineDocumentRemove = function HiOutlineDocumentRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"}}]})(props);
	};
	module.exports.HiOutlineDocumentReport = function HiOutlineDocumentReport (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"}}]})(props);
	};
	module.exports.HiOutlineDocumentSearch = function HiOutlineDocumentSearch (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"}}]})(props);
	};
	module.exports.HiOutlineDocumentText = function HiOutlineDocumentText (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"}}]})(props);
	};
	module.exports.HiOutlineDocument = function HiOutlineDocument (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineDotsCircleHorizontal = function HiOutlineDotsCircleHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineDotsHorizontal = function HiOutlineDotsHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"}}]})(props);
	};
	module.exports.HiOutlineDotsVertical = function HiOutlineDotsVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"}}]})(props);
	};
	module.exports.HiOutlineDownload = function HiOutlineDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"}}]})(props);
	};
	module.exports.HiOutlineDuplicate = function HiOutlineDuplicate (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineEmojiHappy = function HiOutlineEmojiHappy (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineEmojiSad = function HiOutlineEmojiSad (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineExclamationCircle = function HiOutlineExclamationCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineExclamation = function HiOutlineExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"}}]})(props);
	};
	module.exports.HiOutlineExternalLink = function HiOutlineExternalLink (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"}}]})(props);
	};
	module.exports.HiOutlineEyeOff = function HiOutlineEyeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"}}]})(props);
	};
	module.exports.HiOutlineEye = function HiOutlineEye (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 12a3 3 0 11-6 0 3 3 0 016 0z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"}}]})(props);
	};
	module.exports.HiOutlineFastForward = function HiOutlineFastForward (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M11.933 12.8a1 1 0 000-1.6L6.6 7.2A1 1 0 005 8v8a1 1 0 001.6.8l5.333-4zM19.933 12.8a1 1 0 000-1.6l-5.333-4A1 1 0 0013 8v8a1 1 0 001.6.8l5.333-4z"}}]})(props);
	};
	module.exports.HiOutlineFilm = function HiOutlineFilm (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z"}}]})(props);
	};
	module.exports.HiOutlineFilter = function HiOutlineFilter (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"}}]})(props);
	};
	module.exports.HiOutlineFingerPrint = function HiOutlineFingerPrint (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"}}]})(props);
	};
	module.exports.HiOutlineFire = function HiOutlineFire (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"}}]})(props);
	};
	module.exports.HiOutlineFlag = function HiOutlineFlag (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"}}]})(props);
	};
	module.exports.HiOutlineFolderAdd = function HiOutlineFolderAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"}}]})(props);
	};
	module.exports.HiOutlineFolderDownload = function HiOutlineFolderDownload (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"}}]})(props);
	};
	module.exports.HiOutlineFolderOpen = function HiOutlineFolderOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"}}]})(props);
	};
	module.exports.HiOutlineFolderRemove = function HiOutlineFolderRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"}}]})(props);
	};
	module.exports.HiOutlineFolder = function HiOutlineFolder (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"}}]})(props);
	};
	module.exports.HiOutlineGift = function HiOutlineGift (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"}}]})(props);
	};
	module.exports.HiOutlineGlobeAlt = function HiOutlineGlobeAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"}}]})(props);
	};
	module.exports.HiOutlineGlobe = function HiOutlineGlobe (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineHand = function HiOutlineHand (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"}}]})(props);
	};
	module.exports.HiOutlineHashtag = function HiOutlineHashtag (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 20l4-16m2 16l4-16M6 9h14M4 15h14"}}]})(props);
	};
	module.exports.HiOutlineHeart = function HiOutlineHeart (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"}}]})(props);
	};
	module.exports.HiOutlineHome = function HiOutlineHome (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"}}]})(props);
	};
	module.exports.HiOutlineIdentification = function HiOutlineIdentification (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"}}]})(props);
	};
	module.exports.HiOutlineInboxIn = function HiOutlineInboxIn (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"}}]})(props);
	};
	module.exports.HiOutlineInbox = function HiOutlineInbox (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"}}]})(props);
	};
	module.exports.HiOutlineInformationCircle = function HiOutlineInformationCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineKey = function HiOutlineKey (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"}}]})(props);
	};
	module.exports.HiOutlineLibrary = function HiOutlineLibrary (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"}}]})(props);
	};
	module.exports.HiOutlineLightBulb = function HiOutlineLightBulb (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"}}]})(props);
	};
	module.exports.HiOutlineLightningBolt = function HiOutlineLightningBolt (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M13 10V3L4 14h7v7l9-11h-7z"}}]})(props);
	};
	module.exports.HiOutlineLink = function HiOutlineLink (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"}}]})(props);
	};
	module.exports.HiOutlineLocationMarker = function HiOutlineLocationMarker (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 11a3 3 0 11-6 0 3 3 0 016 0z"}}]})(props);
	};
	module.exports.HiOutlineLockClosed = function HiOutlineLockClosed (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"}}]})(props);
	};
	module.exports.HiOutlineLockOpen = function HiOutlineLockOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineLogin = function HiOutlineLogin (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"}}]})(props);
	};
	module.exports.HiOutlineLogout = function HiOutlineLogout (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"}}]})(props);
	};
	module.exports.HiOutlineMailOpen = function HiOutlineMailOpen (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"}}]})(props);
	};
	module.exports.HiOutlineMail = function HiOutlineMail (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineMap = function HiOutlineMap (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"}}]})(props);
	};
	module.exports.HiOutlineMenuAlt1 = function HiOutlineMenuAlt1 (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 6h16M4 12h8m-8 6h16"}}]})(props);
	};
	module.exports.HiOutlineMenuAlt2 = function HiOutlineMenuAlt2 (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 6h16M4 12h16M4 18h7"}}]})(props);
	};
	module.exports.HiOutlineMenuAlt3 = function HiOutlineMenuAlt3 (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 6h16M4 12h16m-7 6h7"}}]})(props);
	};
	module.exports.HiOutlineMenuAlt4 = function HiOutlineMenuAlt4 (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 8h16M4 16h16"}}]})(props);
	};
	module.exports.HiOutlineMenu = function HiOutlineMenu (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 6h16M4 12h16M4 18h16"}}]})(props);
	};
	module.exports.HiOutlineMicrophone = function HiOutlineMicrophone (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"}}]})(props);
	};
	module.exports.HiOutlineMinusCircle = function HiOutlineMinusCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineMinusSm = function HiOutlineMinusSm (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M18 12H6"}}]})(props);
	};
	module.exports.HiOutlineMinus = function HiOutlineMinus (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M20 12H4"}}]})(props);
	};
	module.exports.HiOutlineMoon = function HiOutlineMoon (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"}}]})(props);
	};
	module.exports.HiOutlineMusicNote = function HiOutlineMusicNote (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"}}]})(props);
	};
	module.exports.HiOutlineNewspaper = function HiOutlineNewspaper (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"}}]})(props);
	};
	module.exports.HiOutlineOfficeBuilding = function HiOutlineOfficeBuilding (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"}}]})(props);
	};
	module.exports.HiOutlinePaperAirplane = function HiOutlinePaperAirplane (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 19l9 2-9-18-9 18 9-2zm0 0v-8"}}]})(props);
	};
	module.exports.HiOutlinePaperClip = function HiOutlinePaperClip (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"}}]})(props);
	};
	module.exports.HiOutlinePause = function HiOutlinePause (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlinePencilAlt = function HiOutlinePencilAlt (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"}}]})(props);
	};
	module.exports.HiOutlinePencil = function HiOutlinePencil (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"}}]})(props);
	};
	module.exports.HiOutlinePhoneIncoming = function HiOutlinePhoneIncoming (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"}}]})(props);
	};
	module.exports.HiOutlinePhoneMissedCall = function HiOutlinePhoneMissedCall (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"}}]})(props);
	};
	module.exports.HiOutlinePhoneOutgoing = function HiOutlinePhoneOutgoing (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"}}]})(props);
	};
	module.exports.HiOutlinePhone = function HiOutlinePhone (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"}}]})(props);
	};
	module.exports.HiOutlinePhotograph = function HiOutlinePhotograph (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlinePlay = function HiOutlinePlay (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlinePlusCircle = function HiOutlinePlusCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlinePlusSm = function HiOutlinePlusSm (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 6v6m0 0v6m0-6h6m-6 0H6"}}]})(props);
	};
	module.exports.HiOutlinePlus = function HiOutlinePlus (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 4v16m8-8H4"}}]})(props);
	};
	module.exports.HiOutlinePresentationChartBar = function HiOutlinePresentationChartBar (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"}}]})(props);
	};
	module.exports.HiOutlinePresentationChartLine = function HiOutlinePresentationChartLine (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"}}]})(props);
	};
	module.exports.HiOutlinePrinter = function HiOutlinePrinter (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"}}]})(props);
	};
	module.exports.HiOutlinePuzzle = function HiOutlinePuzzle (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z"}}]})(props);
	};
	module.exports.HiOutlineQrcode = function HiOutlineQrcode (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"}}]})(props);
	};
	module.exports.HiOutlineQuestionMarkCircle = function HiOutlineQuestionMarkCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineReceiptRefund = function HiOutlineReceiptRefund (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z"}}]})(props);
	};
	module.exports.HiOutlineReceiptTax = function HiOutlineReceiptTax (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z"}}]})(props);
	};
	module.exports.HiOutlineRefresh = function HiOutlineRefresh (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"}}]})(props);
	};
	module.exports.HiOutlineReply = function HiOutlineReply (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"}}]})(props);
	};
	module.exports.HiOutlineRewind = function HiOutlineRewind (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0019 16V8a1 1 0 00-1.6-.8l-5.333 4zM4.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0011 16V8a1 1 0 00-1.6-.8l-5.334 4z"}}]})(props);
	};
	module.exports.HiOutlineRss = function HiOutlineRss (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M6 5c7.18 0 13 5.82 13 13M6 11a7 7 0 017 7m-6 0a1 1 0 11-2 0 1 1 0 012 0z"}}]})(props);
	};
	module.exports.HiOutlineSaveAs = function HiOutlineSaveAs (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 16v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2h2m3-4H9a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-1m-1 4l-3 3m0 0l-3-3m3 3V3"}}]})(props);
	};
	module.exports.HiOutlineSave = function HiOutlineSave (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"}}]})(props);
	};
	module.exports.HiOutlineScale = function HiOutlineScale (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"}}]})(props);
	};
	module.exports.HiOutlineScissors = function HiOutlineScissors (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M14.121 14.121L19 19m-7-7l7-7m-7 7l-2.879 2.879M12 12L9.121 9.121m0 5.758a3 3 0 10-4.243 4.243 3 3 0 004.243-4.243zm0-5.758a3 3 0 10-4.243-4.243 3 3 0 004.243 4.243z"}}]})(props);
	};
	module.exports.HiOutlineSearchCircle = function HiOutlineSearchCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineSearch = function HiOutlineSearch (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"}}]})(props);
	};
	module.exports.HiOutlineSelector = function HiOutlineSelector (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 9l4-4 4 4m0 6l-4 4-4-4"}}]})(props);
	};
	module.exports.HiOutlineServer = function HiOutlineServer (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"}}]})(props);
	};
	module.exports.HiOutlineShare = function HiOutlineShare (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"}}]})(props);
	};
	module.exports.HiOutlineShieldCheck = function HiOutlineShieldCheck (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"}}]})(props);
	};
	module.exports.HiOutlineShieldExclamation = function HiOutlineShieldExclamation (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01"}}]})(props);
	};
	module.exports.HiOutlineShoppingBag = function HiOutlineShoppingBag (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"}}]})(props);
	};
	module.exports.HiOutlineShoppingCart = function HiOutlineShoppingCart (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"}}]})(props);
	};
	module.exports.HiOutlineSortAscending = function HiOutlineSortAscending (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"}}]})(props);
	};
	module.exports.HiOutlineSortDescending = function HiOutlineSortDescending (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"}}]})(props);
	};
	module.exports.HiOutlineSparkles = function HiOutlineSparkles (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"}}]})(props);
	};
	module.exports.HiOutlineSpeakerphone = function HiOutlineSpeakerphone (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"}}]})(props);
	};
	module.exports.HiOutlineStar = function HiOutlineStar (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"}}]})(props);
	};
	module.exports.HiOutlineStatusOffline = function HiOutlineStatusOffline (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"}}]})(props);
	};
	module.exports.HiOutlineStatusOnline = function HiOutlineStatusOnline (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"}}]})(props);
	};
	module.exports.HiOutlineStop = function HiOutlineStop (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"}}]})(props);
	};
	module.exports.HiOutlineSun = function HiOutlineSun (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"}}]})(props);
	};
	module.exports.HiOutlineSupport = function HiOutlineSupport (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"}}]})(props);
	};
	module.exports.HiOutlineSwitchHorizontal = function HiOutlineSwitchHorizontal (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"}}]})(props);
	};
	module.exports.HiOutlineSwitchVertical = function HiOutlineSwitchVertical (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"}}]})(props);
	};
	module.exports.HiOutlineTable = function HiOutlineTable (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineTag = function HiOutlineTag (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"}}]})(props);
	};
	module.exports.HiOutlineTemplate = function HiOutlineTemplate (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"}}]})(props);
	};
	module.exports.HiOutlineTerminal = function HiOutlineTerminal (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineThumbDown = function HiOutlineThumbDown (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"}}]})(props);
	};
	module.exports.HiOutlineThumbUp = function HiOutlineThumbUp (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"}}]})(props);
	};
	module.exports.HiOutlineTicket = function HiOutlineTicket (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"}}]})(props);
	};
	module.exports.HiOutlineTranslate = function HiOutlineTranslate (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"}}]})(props);
	};
	module.exports.HiOutlineTrash = function HiOutlineTrash (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"}}]})(props);
	};
	module.exports.HiOutlineTrendingDown = function HiOutlineTrendingDown (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"}}]})(props);
	};
	module.exports.HiOutlineTrendingUp = function HiOutlineTrendingUp (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"}}]})(props);
	};
	module.exports.HiOutlineTruck = function HiOutlineTruck (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"}}]})(props);
	};
	module.exports.HiOutlineUpload = function HiOutlineUpload (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"}}]})(props);
	};
	module.exports.HiOutlineUserAdd = function HiOutlineUserAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"}}]})(props);
	};
	module.exports.HiOutlineUserCircle = function HiOutlineUserCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineUserGroup = function HiOutlineUserGroup (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"}}]})(props);
	};
	module.exports.HiOutlineUserRemove = function HiOutlineUserRemove (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6"}}]})(props);
	};
	module.exports.HiOutlineUser = function HiOutlineUser (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"}}]})(props);
	};
	module.exports.HiOutlineUsers = function HiOutlineUsers (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"}}]})(props);
	};
	module.exports.HiOutlineVariable = function HiOutlineVariable (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4.871 4A17.926 17.926 0 003 12c0 2.874.673 5.59 1.871 8m14.13 0a17.926 17.926 0 001.87-8c0-2.874-.673-5.59-1.87-8M9 9h1.246a1 1 0 01.961.725l1.586 5.55a1 1 0 00.961.725H15m1-7h-.08a2 2 0 00-1.519.698L9.6 15.302A2 2 0 018.08 16H8"}}]})(props);
	};
	module.exports.HiOutlineVideoCamera = function HiOutlineVideoCamera (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineViewBoards = function HiOutlineViewBoards (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"}}]})(props);
	};
	module.exports.HiOutlineViewGridAdd = function HiOutlineViewGridAdd (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z"}}]})(props);
	};
	module.exports.HiOutlineViewGrid = function HiOutlineViewGrid (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"}}]})(props);
	};
	module.exports.HiOutlineViewList = function HiOutlineViewList (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4 6h16M4 10h16M4 14h16M4 18h16"}}]})(props);
	};
	module.exports.HiOutlineVolumeOff = function HiOutlineVolumeOff (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z","clipRule":"evenodd"}},{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"}}]})(props);
	};
	module.exports.HiOutlineVolumeUp = function HiOutlineVolumeUp (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"}}]})(props);
	};
	module.exports.HiOutlineWifi = function HiOutlineWifi (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"}}]})(props);
	};
	module.exports.HiOutlineXCircle = function HiOutlineXCircle (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"}}]})(props);
	};
	module.exports.HiOutlineX = function HiOutlineX (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M6 18L18 6M6 6l12 12"}}]})(props);
	};
	module.exports.HiOutlineZoomIn = function HiOutlineZoomIn (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"}}]})(props);
	};
	module.exports.HiOutlineZoomOut = function HiOutlineZoomOut (props) {
	  return GenIcon({"tag":"svg","attr":{"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"strokeLinecap":"round","strokeLinejoin":"round","d":"M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7"}}]})(props);
	};


/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.IconBase = exports.GenIcon = void 0;
	var React = __webpack_require__(1);
	var iconContext_1 = __webpack_require__(407);
	function Tree2Element(tree) {
	    return (tree &&
	        tree.map(function (node, i) {
	            return React.createElement(node.tag, __assign({ key: i }, node.attr), Tree2Element(node.child));
	        }));
	}
	function GenIcon(data) {
	    // eslint-disable-next-line react/display-name
	    return function (props) { return (React.createElement(IconBase, __assign({ attr: __assign({}, data.attr) }, props), Tree2Element(data.child))); };
	}
	exports.GenIcon = GenIcon;
	function IconBase(props) {
	    var elem = function (conf) {
	        var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
	        var computedSize = size || conf.size || "1em";
	        var className;
	        if (conf.className)
	            className = conf.className;
	        if (props.className)
	            className = (className ? className + " " : "") + props.className;
	        return (React.createElement("svg", __assign({ stroke: "currentColor", fill: "currentColor", strokeWidth: "0" }, conf.attr, attr, svgProps, { className: className, style: __assign(__assign({ color: props.color || conf.color }, conf.style), props.style), height: computedSize, width: computedSize, xmlns: "http://www.w3.org/2000/svg" }),
	            title && React.createElement("title", null, title),
	            props.children));
	    };
	    return iconContext_1.IconContext !== undefined ? (React.createElement(iconContext_1.IconContext.Consumer, null, function (conf) { return elem(conf); })) : (elem(iconContext_1.DefaultContext));
	}
	exports.IconBase = IconBase;


/***/ },
/* 962 */
/***/ function(module, exports) {

	module.exports.IconsManifest = [
	  {
	    "id": "ci",
	    "name": "Circum Icons",
	    "projectUrl": "https://circumicons.com/",
	    "license": "MPL-2.0 license",
	    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
	  },
	  {
	    "id": "fa",
	    "name": "Font Awesome 5",
	    "projectUrl": "https://fontawesome.com/",
	    "license": "CC BY 4.0 License",
	    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
	  },
	  {
	    "id": "fa6",
	    "name": "Font Awesome 6",
	    "projectUrl": "https://fontawesome.com/",
	    "license": "CC BY 4.0 License",
	    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
	  },
	  {
	    "id": "io",
	    "name": "Ionicons 4",
	    "projectUrl": "https://ionicons.com/",
	    "license": "MIT",
	    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
	  },
	  {
	    "id": "io5",
	    "name": "Ionicons 5",
	    "projectUrl": "https://ionicons.com/",
	    "license": "MIT",
	    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
	  },
	  {
	    "id": "md",
	    "name": "Material Design icons",
	    "projectUrl": "http://google.github.io/material-design-icons/",
	    "license": "Apache License Version 2.0",
	    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
	  },
	  {
	    "id": "ti",
	    "name": "Typicons",
	    "projectUrl": "http://s-ings.com/typicons/",
	    "license": "CC BY-SA 3.0",
	    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
	  },
	  {
	    "id": "go",
	    "name": "Github Octicons icons",
	    "projectUrl": "https://octicons.github.com/",
	    "license": "MIT",
	    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
	  },
	  {
	    "id": "fi",
	    "name": "Feather",
	    "projectUrl": "https://feathericons.com/",
	    "license": "MIT",
	    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
	  },
	  {
	    "id": "lu",
	    "name": "Lucide",
	    "projectUrl": "https://lucide.dev/",
	    "license": "ISC",
	    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
	  },
	  {
	    "id": "gi",
	    "name": "Game Icons",
	    "projectUrl": "https://game-icons.net/",
	    "license": "CC BY 3.0",
	    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
	  },
	  {
	    "id": "wi",
	    "name": "Weather Icons",
	    "projectUrl": "https://erikflowers.github.io/weather-icons/",
	    "license": "SIL OFL 1.1",
	    "licenseUrl": "http://scripts.sil.org/OFL"
	  },
	  {
	    "id": "di",
	    "name": "Devicons",
	    "projectUrl": "https://vorillaz.github.io/devicons/",
	    "license": "MIT",
	    "licenseUrl": "https://opensource.org/licenses/MIT"
	  },
	  {
	    "id": "ai",
	    "name": "Ant Design Icons",
	    "projectUrl": "https://github.com/ant-design/ant-design-icons",
	    "license": "MIT",
	    "licenseUrl": "https://opensource.org/licenses/MIT"
	  },
	  {
	    "id": "bs",
	    "name": "Bootstrap Icons",
	    "projectUrl": "https://github.com/twbs/icons",
	    "license": "MIT",
	    "licenseUrl": "https://opensource.org/licenses/MIT"
	  },
	  {
	    "id": "ri",
	    "name": "Remix Icon",
	    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
	    "license": "Apache License Version 2.0",
	    "licenseUrl": "http://www.apache.org/licenses/"
	  },
	  {
	    "id": "fc",
	    "name": "Flat Color Icons",
	    "projectUrl": "https://github.com/icons8/flat-color-icons",
	    "license": "MIT",
	    "licenseUrl": "https://opensource.org/licenses/MIT"
	  },
	  {
	    "id": "gr",
	    "name": "Grommet-Icons",
	    "projectUrl": "https://github.com/grommet/grommet-icons",
	    "license": "Apache License Version 2.0",
	    "licenseUrl": "http://www.apache.org/licenses/"
	  },
	  {
	    "id": "hi",
	    "name": "Heroicons",
	    "projectUrl": "https://github.com/tailwindlabs/heroicons",
	    "license": "MIT",
	    "licenseUrl": "https://opensource.org/licenses/MIT"
	  },
	  {
	    "id": "hi2",
	    "name": "Heroicons 2",
	    "projectUrl": "https://github.com/tailwindlabs/heroicons",
	    "license": "MIT",
	    "licenseUrl": "https://opensource.org/licenses/MIT"
	  },
	  {
	    "id": "si",
	    "name": "Simple Icons",
	    "projectUrl": "https://simpleicons.org/",
	    "license": "CC0 1.0 Universal",
	    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
	  },
	  {
	    "id": "sl",
	    "name": "Simple Line Icons",
	    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
	    "license": "MIT",
	    "licenseUrl": "https://opensource.org/licenses/MIT"
	  },
	  {
	    "id": "im",
	    "name": "IcoMoon Free",
	    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
	    "license": "CC BY 4.0 License",
	    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
	  },
	  {
	    "id": "bi",
	    "name": "BoxIcons",
	    "projectUrl": "https://github.com/atisawd/boxicons",
	    "license": "CC BY 4.0 License",
	    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
	  },
	  {
	    "id": "cg",
	    "name": "css.gg",
	    "projectUrl": "https://github.com/astrit/css.gg",
	    "license": "MIT",
	    "licenseUrl": "https://opensource.org/licenses/MIT"
	  },
	  {
	    "id": "vsc",
	    "name": "VS Code Icons",
	    "projectUrl": "https://github.com/microsoft/vscode-codicons",
	    "license": "CC BY 4.0",
	    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
	  },
	  {
	    "id": "tb",
	    "name": "Tabler Icons",
	    "projectUrl": "https://github.com/tabler/tabler-icons",
	    "license": "MIT",
	    "licenseUrl": "https://opensource.org/licenses/MIT"
	  },
	  {
	    "id": "tfi",
	    "name": "Themify Icons",
	    "projectUrl": "https://github.com/lykmapipo/themify-icons",
	    "license": "MIT",
	    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
	  },
	  {
	    "id": "rx",
	    "name": "Radix Icons",
	    "projectUrl": "https://icons.radix-ui.com",
	    "license": "MIT",
	    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
	  },
	  {
	    "id": "pi",
	    "name": "Phosphor Icons",
	    "projectUrl": "https://github.com/phosphor-icons/core",
	    "license": "MIT",
	    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
	  },
	  {
	    "id": "lia",
	    "name": "Icons8 Line Awesome",
	    "projectUrl": "https://icons8.com/line-awesome",
	    "license": "MIT",
	    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
	  }
	]

/***/ },
/* 963 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(409));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var _classnames = _interopRequireDefault(__webpack_require__(52));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Page =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page() {
	    _classCallCheck(this, Page);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Page).apply(this, arguments));
	  }
	
	  _createClass(Page, [{
	    key: "handleClick",
	    value: function handleClick(e) {
	      var _this$props = this.props,
	          isDisabled = _this$props.isDisabled,
	          pageNumber = _this$props.pageNumber;
	      e.preventDefault();
	
	      if (isDisabled) {
	        return;
	      }
	
	      this.props.onClick(pageNumber);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _cx;
	
	      var _this$props2 = this.props,
	          pageText = _this$props2.pageText,
	          pageNumber = _this$props2.pageNumber,
	          activeClass = _this$props2.activeClass,
	          itemClass = _this$props2.itemClass,
	          linkClass = _this$props2.linkClass,
	          activeLinkClass = _this$props2.activeLinkClass,
	          disabledClass = _this$props2.disabledClass,
	          isActive = _this$props2.isActive,
	          isDisabled = _this$props2.isDisabled,
	          href = _this$props2.href,
	          ariaLabel = _this$props2.ariaLabel;
	      var css = (0, _classnames["default"])(itemClass, (_cx = {}, _defineProperty(_cx, activeClass, isActive), _defineProperty(_cx, disabledClass, isDisabled), _cx));
	      var linkCss = (0, _classnames["default"])(linkClass, _defineProperty({}, activeLinkClass, isActive));
	      return _react["default"].createElement("li", {
	        className: css,
	        onClick: this.handleClick.bind(this)
	      }, _react["default"].createElement("a", {
	        className: linkCss,
	        href: href,
	        "aria-label": ariaLabel
	      }, pageText));
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports["default"] = Page;
	
	_defineProperty(Page, "propTypes", {
	  pageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  pageNumber: _propTypes["default"].number.isRequired,
	  onClick: _propTypes["default"].func.isRequired,
	  isActive: _propTypes["default"].bool.isRequired,
	  isDisabled: _propTypes["default"].bool,
	  activeClass: _propTypes["default"].string,
	  activeLinkClass: _propTypes["default"].string,
	  itemClass: _propTypes["default"].string,
	  linkClass: _propTypes["default"].string,
	  disabledClass: _propTypes["default"].string,
	  href: _propTypes["default"].string
	});
	
	_defineProperty(Page, "defaultProps", {
	  activeClass: "active",
	  disabledClass: "disabled",
	  itemClass: undefined,
	  linkClass: undefined,
	  activeLinkCLass: undefined,
	  isActive: false,
	  isDisabled: false,
	  href: "#"
	});

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(159),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(967);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(411);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(163);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _reactLifecyclesCompat = __webpack_require__(410);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;
	
	var createHTMLElement = function createHTMLElement(name) {
	  return document.createElement(name);
	};
	
	var getCreatePortal = function getCreatePortal() {
	  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      if (parent && parent.contains(_this.node)) {
	        parent.removeChild(_this.node);
	      } else {
	        // eslint-disable-next-line no-console
	        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
	      }
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var createPortal = getCreatePortal();
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = createHTMLElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      var prevParent = getParentElement(prevProps.parentSelector);
	      var nextParent = getParentElement(this.props.parentSelector);
	      return { prevParent: prevParent, nextParent: nextParent };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, _, snapshot) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          portalClassName = _props.portalClassName;
	
	
	      if (prevProps.portalClassName !== portalClassName) {
	        this.node.className = portalClassName;
	      }
	
	      var prevParent = snapshot.prevParent,
	          nextParent = snapshot.nextParent;
	
	      if (nextParent !== prevParent) {
	        prevParent.removeChild(this.node);
	        nextParent.appendChild(this.node);
	      }
	
	      // Stop unnecessary renders if modal is remaining closed
	      if (!prevProps.isOpen && !isOpen) return;
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = createHTMLElement("div");
	      }
	
	      var createPortal = getCreatePortal();
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  role: "dialog",
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  preventScroll: false,
	  parentSelector: function parentSelector() {
	    return document.body;
	  },
	  overlayElement: function overlayElement(props, contentEl) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      contentEl
	    );
	  },
	  contentElement: function contentElement(props, children) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      children
	    );
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Modal);
	
	if (false) {
	  Modal.setCreateHTMLElement = function (fn) {
	    return createHTMLElement = fn;
	  };
	}
	
	exports.default = Modal;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(970);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(971);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(411);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(969);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(163);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _portalOpenInstances = __webpack_require__(412);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	__webpack_require__(968);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	/**
	 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
	 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
	 * `react-modal` only supports React >18 (which dropped IE support).
	 */
	var isTabKey = function isTabKey(event) {
	  return event.code === "Tab" || event.keyCode === 9;
	};
	var isEscKey = function isEscKey(event) {
	  return event.code === "Escape" || event.keyCode === 27;
	};
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName,
	          parentSelector = _this$props.parentSelector;
	
	
	      var parentDocument = parentSelector && parentSelector().ownerDocument || document;
	
	      // Remove classes.
	      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus(_this.props.preventScroll);
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	
	      if (_this.props.onAfterClose) {
	        _this.props.onAfterClose();
	      }
	
	      _portalOpenInstances2.default.deregister(_this);
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.openAnimationFrame = requestAnimationFrame(function () {
	            _this.setState({ afterOpen: true });
	
	            if (_this.props.isOpen && _this.props.onAfterOpen) {
	              _this.props.onAfterOpen({
	                overlayEl: _this.overlay,
	                contentEl: _this.content
	              });
	            }
	          });
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (isTabKey(event)) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	
	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }
	
	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.isOpen) {
	        this.afterClose();
	      }
	      clearTimeout(this.closeTimer);
	      cancelAnimationFrame(this.openAnimationFrame);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName,
	          parentSelector = _props.parentSelector;
	
	
	      var parentDocument = parentSelector && parentSelector().ownerDocument || document;
	
	      // Add classes.
	      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	
	      _portalOpenInstances2.default.register(this);
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles,
	          children = _props2.children;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      if (this.shouldBeClosed()) {
	        return null;
	      }
	
	      var overlayProps = {
	        ref: this.setOverlayRef,
	        className: this.buildClassName("overlay", overlayClassName),
	        style: _extends({}, overlayStyles, this.props.style.overlay),
	        onClick: this.handleOverlayOnClick,
	        onMouseDown: this.handleOverlayOnMouseDown
	      };
	
	      var contentProps = _extends({
	        id: id,
	        ref: this.setContentRef,
	        style: _extends({}, contentStyles, this.props.style.content),
	        className: this.buildClassName("content", className),
	        tabIndex: "-1",
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleContentOnMouseDown,
	        onMouseUp: this.handleContentOnMouseUp,
	        onClick: this.handleContentOnClick,
	        role: this.props.role,
	        "aria-label": this.props.contentLabel
	      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
	        "data-testid": this.props.testId
	      });
	
	      var contentElement = this.props.contentElement(contentProps, children);
	      return this.props.overlayElement(overlayProps, contentElement);
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  parentSelector: _propTypes2.default.func,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onAfterClose: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	
	var _portalOpenInstances = __webpack_require__(412);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Body focus trap see Issue #742
	
	var before = void 0,
	    after = void 0,
	    instances = [];
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  var _arr = [before, after];
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var item = _arr[_i];
	    if (!item) continue;
	    item.parentNode && item.parentNode.removeChild(item);
	  }
	  before = after = null;
	  instances = [];
	}
	
	/* istanbul ignore next */
	function log() {
	  console.log("bodyTrap ----------");
	  console.log(instances.length);
	  var _arr2 = [before, after];
	  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	    var item = _arr2[_i2];
	    var check = item || {};
	    console.log(check.nodeName, check.className, check.id);
	  }
	  console.log("edn bodyTrap ----------");
	}
	/* eslint-enable no-console */
	
	function focusContent() {
	  if (instances.length === 0) {
	    if (false) {
	      // eslint-disable-next-line no-console
	      console.warn("React-Modal: Open instances > 0 expected");
	    }
	    return;
	  }
	  instances[instances.length - 1].focusContent();
	}
	
	function bodyTrap(eventType, openInstances) {
	  if (!before && !after) {
	    before = document.createElement("div");
	    before.setAttribute("data-react-modal-body-trap", "");
	    before.style.position = "absolute";
	    before.style.opacity = "0";
	    before.setAttribute("tabindex", "0");
	    before.addEventListener("focus", focusContent);
	    after = before.cloneNode();
	    after.addEventListener("focus", focusContent);
	  }
	
	  instances = openInstances;
	
	  if (instances.length > 0) {
	    // Add focus trap
	    if (document.body.firstChild !== before) {
	      document.body.insertBefore(before, document.body.firstChild);
	    }
	    if (document.body.lastChild !== after) {
	      document.body.appendChild(after);
	    }
	  } else {
	    // Remove focus trap
	    if (before.parentElement) {
	      before.parentElement.removeChild(before);
	    }
	    if (after.parentElement) {
	      after.parentElement.removeChild(after);
	    }
	  }
	}
	
	_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function removeClass(at, cls) {
	  at.classList.remove(cls);
	}
	
	/* istanbul ignore next */
	function resetState() {
	  var htmlElement = document.getElementsByTagName("html")[0];
	  for (var cls in htmlClassList) {
	    removeClass(htmlElement, htmlClassList[cls]);
	  }
	
	  var body = document.body;
	  for (var _cls in docBodyClassList) {
	    removeClass(body, docBodyClassList[_cls]);
	  }
	
	  htmlClassList = {};
	  docBodyClassList = {};
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n  ";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
	    }
	
	    classes = document.body.className;
	
	    buffer += "\n\ndoc.body (" + classes + "):\n  ";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
	    }
	
	    buffer += "\n";
	
	    console.log(buffer);
	  }
	}
	/* eslint-enable no-console */
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(413);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  focusLaterElements = [];
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    console.log("focusManager ----------");
	    focusLaterElements.forEach(function (f) {
	      var check = f || {};
	      console.log(check.nodeName, check.className, check.id);
	    });
	    console.log("end focusManager ----------");
	  }
	}
	/* eslint-enable no-console */
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus({ preventScroll: preventScroll });
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(413);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getActiveElement() {
	  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
	
	  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
	}
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var target = void 0;
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	  var activeElement = getActiveElement();
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  if (tail === activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  target = tabbable[x];
	
	  // If the tabbable element does not exist,
	  // focus head/tail based on shiftKey
	  if (typeof target === "undefined") {
	    event.preventDefault();
	    target = shiftKey ? tail : head;
	    target.focus();
	    return;
	  }
	
	  event.preventDefault();
	
	  target.focus();
	}
	module.exports = exports["default"];

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(966);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});var react=__webpack_require__(1),reactDom=__webpack_require__(55);function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	
	  _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	  // Also cover shadowRoot node by checking current.host
	
	
	  while (current.parentNode || current.host) {
	    // Only check normal node without shadowRoot
	    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode || current.host;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = {};
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions.passive = !instance.props.preventDefault;
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class = /*#__PURE__*/function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	          if (_this.initTimeStamp > event.timeStamp) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      _this.initTimeStamp = performance.now();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    }
	    /**
	     * Remove all document's event listeners for this component
	     */
	    ;
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    }
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	    ;
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _this$props = this.props;
	          _this$props.excludeScrollbar;
	          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}exports.IGNORE_CLASS_NAME=IGNORE_CLASS_NAME;exports.default=onClickOutsideHOC;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Popper = Popper;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _Manager = __webpack_require__(164);
	
	var _utils = __webpack_require__(165);
	
	var _usePopper2 = __webpack_require__(414);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var NOOP = function NOOP() {
	  return void 0;
	};
	
	var NOOP_PROMISE = function NOOP_PROMISE() {
	  return Promise.resolve(null);
	};
	
	var EMPTY_MODIFIERS = [];
	
	function Popper(_ref) {
	  var _ref$placement = _ref.placement,
	      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
	      _ref$strategy = _ref.strategy,
	      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
	      _ref$modifiers = _ref.modifiers,
	      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
	      referenceElement = _ref.referenceElement,
	      onFirstUpdate = _ref.onFirstUpdate,
	      innerRef = _ref.innerRef,
	      children = _ref.children;
	  var referenceNode = React.useContext(_Manager.ManagerReferenceNodeContext);
	
	  var _React$useState = React.useState(null),
	      popperElement = _React$useState[0],
	      setPopperElement = _React$useState[1];
	
	  var _React$useState2 = React.useState(null),
	      arrowElement = _React$useState2[0],
	      setArrowElement = _React$useState2[1];
	
	  React.useEffect(function () {
	    (0, _utils.setRef)(innerRef, popperElement);
	  }, [innerRef, popperElement]);
	  var options = React.useMemo(function () {
	    return {
	      placement: placement,
	      strategy: strategy,
	      onFirstUpdate: onFirstUpdate,
	      modifiers: [].concat(modifiers, [{
	        name: 'arrow',
	        enabled: arrowElement != null,
	        options: {
	          element: arrowElement
	        }
	      }])
	    };
	  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);
	
	  var _usePopper = (0, _usePopper2.usePopper)(referenceElement || referenceNode, popperElement, options),
	      state = _usePopper.state,
	      styles = _usePopper.styles,
	      forceUpdate = _usePopper.forceUpdate,
	      update = _usePopper.update;
	
	  var childrenProps = React.useMemo(function () {
	    return {
	      ref: setPopperElement,
	      style: styles.popper,
	      placement: state ? state.placement : placement,
	      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
	      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
	      arrowProps: {
	        style: styles.arrow,
	        ref: setArrowElement
	      },
	      forceUpdate: forceUpdate || NOOP,
	      update: update || NOOP_PROMISE
	    };
	  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
	  return (0, _utils.unwrapArray)(children)(childrenProps);
	}

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Reference = Reference;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(458));
	
	var _Manager = __webpack_require__(164);
	
	var _utils = __webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function Reference(_ref) {
	  var children = _ref.children,
	      innerRef = _ref.innerRef;
	  var setReferenceNode = React.useContext(_Manager.ManagerReferenceNodeSetterContext);
	  var refHandler = React.useCallback(function (node) {
	    (0, _utils.setRef)(innerRef, node);
	    (0, _utils.safeInvoke)(setReferenceNode, node);
	  }, [innerRef, setReferenceNode]); // ran on unmount
	  // eslint-disable-next-line react-hooks/exhaustive-deps
	
	  React.useEffect(function () {
	    return function () {
	      return (0, _utils.setRef)(innerRef, null);
	    };
	  }, []);
	  React.useEffect(function () {
	    (0, _warning["default"])(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	  }, [setReferenceNode]);
	  return (0, _utils.unwrapArray)(children)({
	    ref: refHandler
	  });
	}

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.Popper;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.Manager;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.Reference;
	  }
	});
	Object.defineProperty(exports, "usePopper", {
	  enumerable: true,
	  get: function get() {
	    return _usePopper.usePopper;
	  }
	});
	
	var _Popper = __webpack_require__(974);
	
	var _Manager = __webpack_require__(164);
	
	var _Reference = __webpack_require__(975);
	
	var _usePopper = __webpack_require__(414);

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	React-Quill
	https://github.com/zenoamaro/react-quill
	*/
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	var react_1 = __importDefault(__webpack_require__(1));
	var react_dom_1 = __importDefault(__webpack_require__(55));
	var isEqual_1 = __importDefault(__webpack_require__(932));
	var quill_1 = __importDefault(__webpack_require__(398));
	var ReactQuill = /** @class */ (function (_super) {
	    __extends(ReactQuill, _super);
	    function ReactQuill(props) {
	        var _this = _super.call(this, props) || this;
	        /*
	        Changing one of these props should cause a full re-render and a
	        re-instantiation of the Quill editor.
	        */
	        _this.dirtyProps = [
	            'modules',
	            'formats',
	            'bounds',
	            'theme',
	            'children',
	        ];
	        /*
	        Changing one of these props should cause a regular update. These are mostly
	        props that act on the container, rather than the quillized editing area.
	        */
	        _this.cleanProps = [
	            'id',
	            'className',
	            'style',
	            'placeholder',
	            'tabIndex',
	            'onChange',
	            'onChangeSelection',
	            'onFocus',
	            'onBlur',
	            'onKeyPress',
	            'onKeyDown',
	            'onKeyUp',
	        ];
	        _this.state = {
	            generation: 0,
	        };
	        /*
	        Tracks the internal selection of the Quill editor
	        */
	        _this.selection = null;
	        _this.onEditorChange = function (eventName, rangeOrDelta, oldRangeOrDelta, source) {
	            var _a, _b, _c, _d;
	            if (eventName === 'text-change') {
	                (_b = (_a = _this).onEditorChangeText) === null || _b === void 0 ? void 0 : _b.call(_a, _this.editor.root.innerHTML, rangeOrDelta, source, _this.unprivilegedEditor);
	            }
	            else if (eventName === 'selection-change') {
	                (_d = (_c = _this).onEditorChangeSelection) === null || _d === void 0 ? void 0 : _d.call(_c, rangeOrDelta, source, _this.unprivilegedEditor);
	            }
	        };
	        var value = _this.isControlled() ? props.value : props.defaultValue;
	        _this.value = (value !== null && value !== void 0 ? value : '');
	        return _this;
	    }
	    ReactQuill.prototype.validateProps = function (props) {
	        var _a;
	        if (react_1.default.Children.count(props.children) > 1)
	            throw new Error('The Quill editing area can only be composed of a single React element.');
	        if (react_1.default.Children.count(props.children)) {
	            var child = react_1.default.Children.only(props.children);
	            if (((_a = child) === null || _a === void 0 ? void 0 : _a.type) === 'textarea')
	                throw new Error('Quill does not support editing on a <textarea>. Use a <div> instead.');
	        }
	        if (this.lastDeltaChangeSet &&
	            props.value === this.lastDeltaChangeSet)
	            throw new Error('You are passing the `delta` object from the `onChange` event back ' +
	                'as `value`. You most probably want `editor.getContents()` instead. ' +
	                'See: https://github.com/zenoamaro/react-quill#using-deltas');
	    };
	    ReactQuill.prototype.shouldComponentUpdate = function (nextProps, nextState) {
	        var _this = this;
	        var _a;
	        this.validateProps(nextProps);
	        // If the editor hasn't been instantiated yet, or the component has been
	        // regenerated, we already know we should update.
	        if (!this.editor || this.state.generation !== nextState.generation) {
	            return true;
	        }
	        // Handle value changes in-place
	        if ('value' in nextProps) {
	            var prevContents = this.getEditorContents();
	            var nextContents = (_a = nextProps.value, (_a !== null && _a !== void 0 ? _a : ''));
	            // NOTE: Seeing that Quill is missing a way to prevent edits, we have to
	            //       settle for a hybrid between controlled and uncontrolled mode. We
	            //       can't prevent the change, but we'll still override content
	            //       whenever `value` differs from current state.
	            // NOTE: Comparing an HTML string and a Quill Delta will always trigger a
	            //       change, regardless of whether they represent the same document.
	            if (!this.isEqualValue(nextContents, prevContents)) {
	                this.setEditorContents(this.editor, nextContents);
	            }
	        }
	        // Handle read-only changes in-place
	        if (nextProps.readOnly !== this.props.readOnly) {
	            this.setEditorReadOnly(this.editor, nextProps.readOnly);
	        }
	        // Clean and Dirty props require a render
	        return __spreadArrays(this.cleanProps, this.dirtyProps).some(function (prop) {
	            return !isEqual_1.default(nextProps[prop], _this.props[prop]);
	        });
	    };
	    ReactQuill.prototype.shouldComponentRegenerate = function (nextProps) {
	        var _this = this;
	        // Whenever a `dirtyProp` changes, the editor needs reinstantiation.
	        return this.dirtyProps.some(function (prop) {
	            return !isEqual_1.default(nextProps[prop], _this.props[prop]);
	        });
	    };
	    ReactQuill.prototype.componentDidMount = function () {
	        this.instantiateEditor();
	        this.setEditorContents(this.editor, this.getEditorContents());
	    };
	    ReactQuill.prototype.componentWillUnmount = function () {
	        this.destroyEditor();
	    };
	    ReactQuill.prototype.componentDidUpdate = function (prevProps, prevState) {
	        var _this = this;
	        // If we're changing one of the `dirtyProps`, the entire Quill Editor needs
	        // to be re-instantiated. Regenerating the editor will cause the whole tree,
	        // including the container, to be cleaned up and re-rendered from scratch.
	        // Store the contents so they can be restored later.
	        if (this.editor && this.shouldComponentRegenerate(prevProps)) {
	            var delta = this.editor.getContents();
	            var selection = this.editor.getSelection();
	            this.regenerationSnapshot = { delta: delta, selection: selection };
	            this.setState({ generation: this.state.generation + 1 });
	            this.destroyEditor();
	        }
	        // The component has been regenerated, so it must be re-instantiated, and
	        // its content must be restored to the previous values from the snapshot.
	        if (this.state.generation !== prevState.generation) {
	            var _a = this.regenerationSnapshot, delta = _a.delta, selection_1 = _a.selection;
	            delete this.regenerationSnapshot;
	            this.instantiateEditor();
	            var editor_1 = this.editor;
	            editor_1.setContents(delta);
	            postpone(function () { return _this.setEditorSelection(editor_1, selection_1); });
	        }
	    };
	    ReactQuill.prototype.instantiateEditor = function () {
	        if (this.editor) {
	            this.hookEditor(this.editor);
	        }
	        else {
	            this.editor = this.createEditor(this.getEditingArea(), this.getEditorConfig());
	        }
	    };
	    ReactQuill.prototype.destroyEditor = function () {
	        if (!this.editor)
	            return;
	        this.unhookEditor(this.editor);
	    };
	    /*
	    We consider the component to be controlled if `value` is being sent in props.
	    */
	    ReactQuill.prototype.isControlled = function () {
	        return 'value' in this.props;
	    };
	    ReactQuill.prototype.getEditorConfig = function () {
	        return {
	            bounds: this.props.bounds,
	            formats: this.props.formats,
	            modules: this.props.modules,
	            placeholder: this.props.placeholder,
	            readOnly: this.props.readOnly,
	            scrollingContainer: this.props.scrollingContainer,
	            tabIndex: this.props.tabIndex,
	            theme: this.props.theme,
	        };
	    };
	    ReactQuill.prototype.getEditor = function () {
	        if (!this.editor)
	            throw new Error('Accessing non-instantiated editor');
	        return this.editor;
	    };
	    /**
	    Creates an editor on the given element. The editor will be passed the
	    configuration, have its events bound,
	    */
	    ReactQuill.prototype.createEditor = function (element, config) {
	        var editor = new quill_1.default(element, config);
	        if (config.tabIndex != null) {
	            this.setEditorTabIndex(editor, config.tabIndex);
	        }
	        this.hookEditor(editor);
	        return editor;
	    };
	    ReactQuill.prototype.hookEditor = function (editor) {
	        // Expose the editor on change events via a weaker, unprivileged proxy
	        // object that does not allow accidentally modifying editor state.
	        this.unprivilegedEditor = this.makeUnprivilegedEditor(editor);
	        // Using `editor-change` allows picking up silent updates, like selection
	        // changes on typing.
	        editor.on('editor-change', this.onEditorChange);
	    };
	    ReactQuill.prototype.unhookEditor = function (editor) {
	        editor.off('editor-change', this.onEditorChange);
	    };
	    ReactQuill.prototype.getEditorContents = function () {
	        return this.value;
	    };
	    ReactQuill.prototype.getEditorSelection = function () {
	        return this.selection;
	    };
	    /*
	    True if the value is a Delta instance or a Delta look-alike.
	    */
	    ReactQuill.prototype.isDelta = function (value) {
	        return value && value.ops;
	    };
	    /*
	    Special comparison function that knows how to compare Deltas.
	    */
	    ReactQuill.prototype.isEqualValue = function (value, nextValue) {
	        if (this.isDelta(value) && this.isDelta(nextValue)) {
	            return isEqual_1.default(value.ops, nextValue.ops);
	        }
	        else {
	            return isEqual_1.default(value, nextValue);
	        }
	    };
	    /*
	    Replace the contents of the editor, but keep the previous selection hanging
	    around so that the cursor won't move.
	    */
	    ReactQuill.prototype.setEditorContents = function (editor, value) {
	        var _this = this;
	        this.value = value;
	        var sel = this.getEditorSelection();
	        if (typeof value === 'string') {
	            editor.setContents(editor.clipboard.convert(value));
	        }
	        else {
	            editor.setContents(value);
	        }
	        postpone(function () { return _this.setEditorSelection(editor, sel); });
	    };
	    ReactQuill.prototype.setEditorSelection = function (editor, range) {
	        this.selection = range;
	        if (range) {
	            // Validate bounds before applying.
	            var length_1 = editor.getLength();
	            range.index = Math.max(0, Math.min(range.index, length_1 - 1));
	            range.length = Math.max(0, Math.min(range.length, (length_1 - 1) - range.index));
	            editor.setSelection(range);
	        }
	    };
	    ReactQuill.prototype.setEditorTabIndex = function (editor, tabIndex) {
	        var _a, _b;
	        if ((_b = (_a = editor) === null || _a === void 0 ? void 0 : _a.scroll) === null || _b === void 0 ? void 0 : _b.domNode) {
	            editor.scroll.domNode.tabIndex = tabIndex;
	        }
	    };
	    ReactQuill.prototype.setEditorReadOnly = function (editor, value) {
	        if (value) {
	            editor.disable();
	        }
	        else {
	            editor.enable();
	        }
	    };
	    /*
	    Returns a weaker, unprivileged proxy object that only exposes read-only
	    accessors found on the editor instance, without any state-modifying methods.
	    */
	    ReactQuill.prototype.makeUnprivilegedEditor = function (editor) {
	        var e = editor;
	        return {
	            getHTML: function () { return e.root.innerHTML; },
	            getLength: e.getLength.bind(e),
	            getText: e.getText.bind(e),
	            getContents: e.getContents.bind(e),
	            getSelection: e.getSelection.bind(e),
	            getBounds: e.getBounds.bind(e),
	        };
	    };
	    ReactQuill.prototype.getEditingArea = function () {
	        if (!this.editingArea) {
	            throw new Error('Instantiating on missing editing area');
	        }
	        var element = react_dom_1.default.findDOMNode(this.editingArea);
	        if (!element) {
	            throw new Error('Cannot find element for editing area');
	        }
	        if (element.nodeType === 3) {
	            throw new Error('Editing area cannot be a text node');
	        }
	        return element;
	    };
	    /*
	    Renders an editor area, unless it has been provided one to clone.
	    */
	    ReactQuill.prototype.renderEditingArea = function () {
	        var _this = this;
	        var _a = this.props, children = _a.children, preserveWhitespace = _a.preserveWhitespace;
	        var generation = this.state.generation;
	        var properties = {
	            key: generation,
	            ref: function (instance) {
	                _this.editingArea = instance;
	            },
	        };
	        if (react_1.default.Children.count(children)) {
	            return react_1.default.cloneElement(react_1.default.Children.only(children), properties);
	        }
	        return preserveWhitespace ?
	            react_1.default.createElement("pre", __assign({}, properties)) :
	            react_1.default.createElement("div", __assign({}, properties));
	    };
	    ReactQuill.prototype.render = function () {
	        var _a;
	        return (react_1.default.createElement("div", { id: this.props.id, style: this.props.style, key: this.state.generation, className: "quill " + (_a = this.props.className, (_a !== null && _a !== void 0 ? _a : '')), onKeyPress: this.props.onKeyPress, onKeyDown: this.props.onKeyDown, onKeyUp: this.props.onKeyUp }, this.renderEditingArea()));
	    };
	    ReactQuill.prototype.onEditorChangeText = function (value, delta, source, editor) {
	        var _a, _b;
	        if (!this.editor)
	            return;
	        // We keep storing the same type of value as what the user gives us,
	        // so that value comparisons will be more stable and predictable.
	        var nextContents = this.isDelta(this.value)
	            ? editor.getContents()
	            : editor.getHTML();
	        if (nextContents !== this.getEditorContents()) {
	            // Taint this `delta` object, so we can recognize whether the user
	            // is trying to send it back as `value`, preventing a likely loop.
	            this.lastDeltaChangeSet = delta;
	            this.value = nextContents;
	            (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, value, delta, source, editor);
	        }
	    };
	    ReactQuill.prototype.onEditorChangeSelection = function (nextSelection, source, editor) {
	        var _a, _b, _c, _d, _e, _f;
	        if (!this.editor)
	            return;
	        var currentSelection = this.getEditorSelection();
	        var hasGainedFocus = !currentSelection && nextSelection;
	        var hasLostFocus = currentSelection && !nextSelection;
	        if (isEqual_1.default(nextSelection, currentSelection))
	            return;
	        this.selection = nextSelection;
	        (_b = (_a = this.props).onChangeSelection) === null || _b === void 0 ? void 0 : _b.call(_a, nextSelection, source, editor);
	        if (hasGainedFocus) {
	            (_d = (_c = this.props).onFocus) === null || _d === void 0 ? void 0 : _d.call(_c, nextSelection, source, editor);
	        }
	        else if (hasLostFocus) {
	            (_f = (_e = this.props).onBlur) === null || _f === void 0 ? void 0 : _f.call(_e, currentSelection, source, editor);
	        }
	    };
	    ReactQuill.prototype.focus = function () {
	        if (!this.editor)
	            return;
	        this.editor.focus();
	    };
	    ReactQuill.prototype.blur = function () {
	        if (!this.editor)
	            return;
	        this.selection = null;
	        this.editor.blur();
	    };
	    ReactQuill.displayName = 'React Quill';
	    /*
	    Export Quill to be able to call `register`
	    */
	    ReactQuill.Quill = quill_1.default;
	    ReactQuill.defaultProps = {
	        theme: 'snow',
	        modules: {},
	        readOnly: false,
	    };
	    return ReactQuill;
	}(react_1.default.Component));
	/*
	Small helper to execute a function in the next micro-tick.
	*/
	function postpone(fn) {
	    Promise.resolve().then(fn);
	}
	module.exports = ReactQuill;
	//# sourceMappingURL=index.js.map

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	var _interopRequireWildcard = __webpack_require__(69)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var _Context = __webpack_require__(77);
	
	var _Subscription = __webpack_require__(166);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(167);
	
	function Provider(_ref) {
	  var store = _ref.store,
	      context = _ref.context,
	      children = _ref.children;
	  var contextValue = (0, _react.useMemo)(function () {
	    var subscription = (0, _Subscription.createSubscription)(store);
	    return {
	      store: store,
	      subscription: subscription
	    };
	  }, [store]);
	  var previousState = (0, _react.useMemo)(function () {
	    return store.getState();
	  }, [store]);
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    var subscription = contextValue.subscription;
	    subscription.onStateChange = subscription.notifyNestedSubs;
	    subscription.trySubscribe();
	
	    if (previousState !== store.getState()) {
	      subscription.notifyNestedSubs();
	    }
	
	    return function () {
	      subscription.tryUnsubscribe();
	      subscription.onStateChange = null;
	    };
	  }, [contextValue, previousState]);
	  var Context = context || _Context.ReactReduxContext;
	  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
	    value: contextValue
	  }, children);
	}
	
	if (false) {
	  Provider.propTypes = {
	    store: _propTypes["default"].shape({
	      subscribe: _propTypes["default"].func.isRequired,
	      dispatch: _propTypes["default"].func.isRequired,
	      getState: _propTypes["default"].func.isRequired
	    }),
	    context: _propTypes["default"].object,
	    children: _propTypes["default"].any
	  };
	}
	
	var _default = Provider;
	exports["default"] = _default;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(68));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(94));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(415));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(420));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(980));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(981));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(982));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(983));
	
	var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, _excluded);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2["default"])({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = /*#__PURE__*/createConnect();
	
	exports["default"] = _default;

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _bindActionCreators = _interopRequireDefault(__webpack_require__(988));
	
	var _wrapMapToProps = __webpack_require__(416);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _bindActionCreators["default"])(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports["default"] = _default;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(416);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports["default"] = _default;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.defaultMergeProps = defaultMergeProps;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(68));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(421));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2["default"])({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports["default"] = _default;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = finalPropsSelectorFactory;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(94));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(984));
	
	var _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(422));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
	      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireDefault(__webpack_require__(978));
	
	exports.Provider = _Provider["default"];
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(415));
	
	exports.connectAdvanced = _connectAdvanced["default"];
	
	var _Context = __webpack_require__(77);
	
	exports.ReactReduxContext = _Context.ReactReduxContext;
	
	var _connect = _interopRequireDefault(__webpack_require__(979));
	
	exports.connect = _connect["default"];
	
	var _useDispatch = __webpack_require__(986);
	
	exports.useDispatch = _useDispatch.useDispatch;
	exports.createDispatchHook = _useDispatch.createDispatchHook;
	
	var _useSelector = __webpack_require__(987);
	
	exports.useSelector = _useSelector.useSelector;
	exports.createSelectorHook = _useSelector.createSelectorHook;
	
	var _useStore = __webpack_require__(418);
	
	exports.useStore = _useStore.useStore;
	exports.createStoreHook = _useStore.createStoreHook;
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(420));
	
	exports.shallowEqual = _shallowEqual["default"];

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createDispatchHook = createDispatchHook;
	exports.useDispatch = void 0;
	
	var _Context = __webpack_require__(77);
	
	var _useStore = __webpack_require__(418);
	
	/**
	 * Hook factory, which creates a `useDispatch` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useDispatch` hook bound to the specified context.
	 */
	function createDispatchHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useStore = context === _Context.ReactReduxContext ? _useStore.useStore : (0, _useStore.createStoreHook)(context);
	  return function useDispatch() {
	    var store = useStore();
	    return store.dispatch;
	  };
	}
	/**
	 * A hook to access the redux `dispatch` function.
	 *
	 * @returns {any|function} redux store's `dispatch` function
	 *
	 * @example
	 *
	 * import React, { useCallback } from 'react'
	 * import { useDispatch } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const dispatch = useDispatch()
	 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
	 *   return (
	 *     <div>
	 *       <span>{value}</span>
	 *       <button onClick={increaseCounter}>Increase counter</button>
	 *     </div>
	 *   )
	 * }
	 */
	
	
	var useDispatch = /*#__PURE__*/createDispatchHook();
	exports.useDispatch = useDispatch;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createSelectorHook = createSelectorHook;
	exports.useSelector = void 0;
	
	var _react = __webpack_require__(1);
	
	var _useReduxContext2 = __webpack_require__(417);
	
	var _Subscription = __webpack_require__(166);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(167);
	
	var _Context = __webpack_require__(77);
	
	var refEquality = function refEquality(a, b) {
	  return a === b;
	};
	
	function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
	  var _useReducer = (0, _react.useReducer)(function (s) {
	    return s + 1;
	  }, 0),
	      forceRender = _useReducer[1];
	
	  var subscription = (0, _react.useMemo)(function () {
	    return (0, _Subscription.createSubscription)(store, contextSub);
	  }, [store, contextSub]);
	  var latestSubscriptionCallbackError = (0, _react.useRef)();
	  var latestSelector = (0, _react.useRef)();
	  var latestStoreState = (0, _react.useRef)();
	  var latestSelectedState = (0, _react.useRef)();
	  var storeState = store.getState();
	  var selectedState;
	
	  try {
	    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
	      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
	
	      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
	        selectedState = newSelectedState;
	      } else {
	        selectedState = latestSelectedState.current;
	      }
	    } else {
	      selectedState = latestSelectedState.current;
	    }
	  } catch (err) {
	    if (latestSubscriptionCallbackError.current) {
	      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
	    }
	
	    throw err;
	  }
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    latestSelector.current = selector;
	    latestStoreState.current = storeState;
	    latestSelectedState.current = selectedState;
	    latestSubscriptionCallbackError.current = undefined;
	  });
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    function checkForUpdates() {
	      try {
	        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
	
	        if (newStoreState === latestStoreState.current) {
	          return;
	        }
	
	        var _newSelectedState = latestSelector.current(newStoreState);
	
	        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
	          return;
	        }
	
	        latestSelectedState.current = _newSelectedState;
	        latestStoreState.current = newStoreState;
	      } catch (err) {
	        // we ignore all errors here, since when the component
	        // is re-rendered, the selectors are called again, and
	        // will throw again, if neither props nor store state
	        // changed
	        latestSubscriptionCallbackError.current = err;
	      }
	
	      forceRender();
	    }
	
	    subscription.onStateChange = checkForUpdates;
	    subscription.trySubscribe();
	    checkForUpdates();
	    return function () {
	      return subscription.tryUnsubscribe();
	    };
	  }, [store, subscription]);
	  return selectedState;
	}
	/**
	 * Hook factory, which creates a `useSelector` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useSelector` hook bound to the specified context.
	 */
	
	
	function createSelectorHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useSelector(selector, equalityFn) {
	    if (equalityFn === void 0) {
	      equalityFn = refEquality;
	    }
	
	    if (false) {
	      if (!selector) {
	        throw new Error("You must pass a selector to useSelector");
	      }
	
	      if (typeof selector !== 'function') {
	        throw new Error("You must pass a function as a selector to useSelector");
	      }
	
	      if (typeof equalityFn !== 'function') {
	        throw new Error("You must pass a function as an equality function to useSelector");
	      }
	    }
	
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store,
	        contextSub = _useReduxContext.subscription;
	
	    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
	    (0, _react.useDebugValue)(selectedState);
	    return selectedState;
	  };
	}
	/**
	 * A hook to access the redux store's state. This hook takes a selector function
	 * as an argument. The selector is called with the store state.
	 *
	 * This hook takes an optional equality comparison function as the second parameter
	 * that allows you to customize the way the selected state is compared to determine
	 * whether the component needs to be re-rendered.
	 *
	 * @param {Function} selector the selector function
	 * @param {Function=} equalityFn the function that will be used to determine equality
	 *
	 * @returns {any} the selected state
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useSelector } from 'react-redux'
	 *
	 * export const CounterComponent = () => {
	 *   const counter = useSelector(state => state.counter)
	 *   return <div>{counter}</div>
	 * }
	 */
	
	
	var useSelector = /*#__PURE__*/createSelectorHook();
	exports.useSelector = useSelector;

/***/ },
/* 988 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	
	function bindActionCreators(actionCreators, dispatch) {
	  var boundActionCreators = {};
	
	  var _loop = function _loop(key) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = function () {
	        return dispatch(actionCreator.apply(void 0, arguments));
	      };
	    }
	  };
	
	  for (var key in actionCreators) {
	    _loop(key);
	  }
	
	  return boundActionCreators;
	}

/***/ },
/* 989 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.unstable_batchedUpdates = void 0;
	
	var _reactDom = __webpack_require__(55);
	
	exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

/***/ },
/* 991 */
/***/ function(module, exports) {

	/** @license React v17.0.2
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
	if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
	function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
	exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
	exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
	exports.typeOf=y;


/***/ },
/* 992 */
[1184, 991],
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1)),PropTypes=_interopDefault(__webpack_require__(24)),history=__webpack_require__(241);__webpack_require__(174);var invariant=_interopDefault(__webpack_require__(128)),pathToRegexp=_interopDefault(__webpack_require__(938));__webpack_require__(408);var hoistStatics=_interopDefault(__webpack_require__(242));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),_setPrototypeOf(t.prototype.constructor=t,e)}function _setPrototypeOf(t,e){return(_setPrototypeOf=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},i=Object.keys(t);for(o=0;o<i.length;o++)n=i[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var MAX_SIGNED_31_BIT_INT=1073741823,commonjsGlobal="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:{};function getUniqueId(){var t="__global_unique_id__";return commonjsGlobal[t]=(commonjsGlobal[t]||0)+1}function objectIs(t,e){return t===e?0!==t||1/t==1/e:t!=t&&e!=e}function createEventEmitter(n){var o=[];return{on:function(t){o.push(t)},off:function(e){o=o.filter(function(t){return t!==e})},get:function(){return n},set:function(t,e){n=t,o.forEach(function(t){return t(n,e)})}}}function onlyChild(t){return Array.isArray(t)?t[0]:t}function createReactContext(n,i){var t,e,o="__create-react-context-"+getUniqueId()+"__",r=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).emitter=createEventEmitter(t.props.value),t}_inheritsLoose(t,r);var e=t.prototype;return e.getChildContext=function(){var t;return(t={})[o]=this.emitter,t},e.componentWillReceiveProps=function(t){if(this.props.value!==t.value){var e,n=this.props.value,o=t.value;objectIs(n,o)?e=0:(e="function"==typeof i?i(n,o):MAX_SIGNED_31_BIT_INT,0!==(e|=0)&&this.emitter.set(t.value,e))}},e.render=function(){return this.props.children},t}(React.Component);r.childContextTypes=((t={})[o]=PropTypes.object.isRequired,t);var a=function(r){function t(){for(var n,t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];return(n=r.call.apply(r,[this].concat(e))||this).observedBits=void 0,n.state={value:n.getValue()},n.onUpdate=function(t,e){0!=((0|n.observedBits)&e)&&n.setState({value:n.getValue()})},n}_inheritsLoose(t,r);var e=t.prototype;return e.componentWillReceiveProps=function(t){var e=t.observedBits;this.observedBits=null==e?MAX_SIGNED_31_BIT_INT:e},e.componentDidMount=function(){this.context[o]&&this.context[o].on(this.onUpdate);var t=this.props.observedBits;this.observedBits=null==t?MAX_SIGNED_31_BIT_INT:t},e.componentWillUnmount=function(){this.context[o]&&this.context[o].off(this.onUpdate)},e.getValue=function(){return this.context[o]?this.context[o].get():n},e.render=function(){return onlyChild(this.props.children)(this.state.value)},t}(React.Component);return a.contextTypes=((e={})[o]=PropTypes.object,e),{Provider:r,Consumer:a}}var createContext=React.createContext||createReactContext,createNamedContext=function(t){var e=createContext();return e.displayName=t,e},historyContext=createNamedContext("Router-History"),context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){var e=this;this._isMounted=!0,this.unlisten&&this.unlisten(),this.props.staticContext||(this.unlisten=this.props.history.listen(function(t){e._isMounted&&e.setState({location:t})})),this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&(this.unlisten(),this._isMounted=!1,this._pendingLocation=null)},e.render=function(){return React.createElement(context.Provider,{value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}},React.createElement(historyContext.Provider,{children:this.props.children||null,value:this.props.history}))},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var i=t.computedMatch,a=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(i?"string"==typeof a?generatePath(a,i.params):_extends({},a,{pathname:generatePath(a.pathname,i.params)}):a);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:a})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],i={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=i,cacheCount$1++),i}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,i=e.sensitive,l=void 0!==i&&i;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,i=o.exec(u);if(!i)return null;var a=i[0],c=i.slice(1),s=u===a;return p&&!s?null:{path:e,url:"/"===e&&""===a?"/":a,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}function isEmptyChildren(t){return 0===React.Children.count(t)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,i=o.component,a=o.render;return Array.isArray(r)&&isEmptyChildren(r)&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:i?React.createElement(i,n):a?a(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,i=n.context,a=void 0===i?{}:i;a.action=e,a.location=addBasename(r,history.createLocation(t)),a.url=createURL(a.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,i=t.location,a=void 0===i?"/":i,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(a)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,i=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(i.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:i,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(historyContext)}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){var e=useLocation(),n=useContext(context).match;return t?matchPath(e.pathname,t):n}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__HistoryContext=historyContext,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(940).enable();
	  window.Promise = __webpack_require__(939);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1182);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(159);


/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_PureComponent) {
	      _inheritsLoose(SideEffect, _PureComponent);
	
	      function SideEffect() {
	        return _PureComponent.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.PureComponent);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrevArrow = exports.NextArrow = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(52));
	
	var _innerSliderUtils = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  var _super = _createSuper(PrevArrow);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames["default"])(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	
	      if (this.props.prevArrow) {
	        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
	      } else {
	        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	
	      return prevArrow;
	    }
	  }]);
	
	  return PrevArrow;
	}(_react["default"].PureComponent);
	
	exports.PrevArrow = PrevArrow;
	
	var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  var _super2 = _createSuper(NextArrow);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames["default"])(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	
	      if (this.props.nextArrow) {
	        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
	      } else {
	        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	
	      return nextArrow;
	    }
	  }]);
	
	  return NextArrow;
	}(_react["default"].PureComponent);
	
	exports.NextArrow = NextArrow;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return /*#__PURE__*/_react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports["default"] = _default;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dots = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(52));
	
	var _innerSliderUtils = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  var _super = _createSuper(Dots);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave,
	          infinite = _this$props.infinite,
	          slidesToScroll = _this$props.slidesToScroll,
	          slidesToShow = _this$props.slidesToShow,
	          slideCount = _this$props.slideCount,
	          currentSlide = _this$props.currentSlide;
	      var dotCount = getDotCount({
	        slideCount: slideCount,
	        slidesToScroll: slidesToScroll,
	        slidesToShow: slidesToShow,
	        infinite: infinite
	      });
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = [];
	
	      for (var i = 0; i < dotCount; i++) {
	        var _rightBound = (i + 1) * slidesToScroll - 1;
	
	        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);
	
	        var _leftBound = rightBound - (slidesToScroll - 1);
	
	        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
	        var className = (0, _classnames["default"])({
	          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: slidesToScroll,
	          currentSlide: currentSlide
	        };
	        var onClick = this.clickHandler.bind(this, dotOptions);
	        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
	          key: i,
	          className: className
	        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
	          onClick: onClick
	        })));
	      }
	
	      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	
	  return Dots;
	}(_react["default"].PureComponent);
	
	exports.Dots = Dots;

/***/ },
/* 999 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0,
	  targetSlide: 0
	};
	var _default = initialState;
	exports["default"] = _default;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerSlider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _initialState = _interopRequireDefault(__webpack_require__(999));
	
	var _lodash = _interopRequireDefault(__webpack_require__(867));
	
	var _classnames = _interopRequireDefault(__webpack_require__(52));
	
	var _innerSliderUtils = __webpack_require__(106);
	
	var _track = __webpack_require__(1002);
	
	var _dots = __webpack_require__(998);
	
	var _arrows = __webpack_require__(996);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(1033));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InnerSlider = /*#__PURE__*/function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  var _super = _createSuper(InnerSlider);
	
	  function InnerSlider(props) {
	    var _this;
	
	    _classCallCheck(this, InnerSlider);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
	      _this.props.onInit && _this.props.onInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	
	      _this.ro = new _resizeObserverPolyfill["default"](function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	
	
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	
	      _this.ro.observe(_this.list);
	
	      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	
	        _this.callbackTimers = [];
	      }
	
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      _this.ro.disconnect();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
	      _this.checkImagesLoad();
	
	      _this.props.onReInit && _this.props.onReInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      } // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	
	
	      _this.adaptHeight();
	
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	
	      var setTrackStyle = _this.didPropsChange(prevProps);
	
	      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	
	        if (_this.props.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash["default"])(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	
	      _this.debouncedResize();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)
	
	      if (!isTrackMounted) return;
	
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      }); // animating state should be cleared while resizing, otherwise autoplay stops working
	
	
	      _this.setState({
	        animating: false
	      });
	
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread(_objectSpread({}, spec), {}, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	
	      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	
	      _this.setState(updatedState, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	
	        for (var _i = 0; _i < postClones; _i++) {
	          _trackWidth += childrenWidths[_i];
	        }
	
	        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
	          _trackLeft += childrenWidths[_i2];
	        }
	
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	
	        return {
	          trackStyle: _trackStyle
	        };
	      }
	
	      var childrenCount = _react["default"].Children.count(_this.props.children);
	
	      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        slideCount: childrenCount
	      });
	
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      return {
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
	      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange; // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
	        index: index
	      }, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	
	      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	        afterChange && afterChange(currentSlide);
	        delete _this.animationEndCallback;
	      }
	
	      _this.setState(state, function () {
	        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
	        if (asNavFor && _this.asNavForIndex !== index) {
	          _this.asNavForIndex = index;
	          asNavFor.innerSlider.slideHandler(index);
	        }
	
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	
	      _this.props.autoplay && _this.autoPlay("update");
	
	      if (_this.props.focusOnSelect) {
	        var nodes = _this.list.querySelectorAll(".slick-current");
	
	        nodes[0] && nodes[0].focus();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	
	      window.ontouchmove = preventDefault;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	
	      _this.setState(state);
	
	      if (triggerSlideHandler === undefined) return;
	
	      _this.slideHandler(triggerSlideHandler);
	
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
	      _this.swipeEnd(e);
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "play", function () {
	      var nextIndex;
	
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "render", function () {
	      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
	      });
	      var dots;
	
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
	
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.touchEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr",
	        style: _this.props.style
	      };
	
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react["default"].Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	
	    var ssrState = _this.ssrInit();
	
	    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
	    return _this;
	  }
	
	  _createClass(InnerSlider, [{
	    key: "didPropsChange",
	    value: function didPropsChange(prevProps) {
	      var setTrackStyle = false;
	
	      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
	        var key = _Object$keys[_i3];
	
	        if (!prevProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	
	        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
	          continue;
	        }
	
	        if (prevProps[key] !== this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	
	      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
	    }
	  }]);
	
	  return InnerSlider;
	}(_react["default"].Component);
	
	exports.InnerSlider = InnerSlider;

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _innerSlider = __webpack_require__(1000);
	
	var _json2mq = _interopRequireDefault(__webpack_require__(866));
	
	var _defaultProps = _interopRequireDefault(__webpack_require__(997));
	
	var _innerSliderUtils = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(833);
	
	var Slider = /*#__PURE__*/function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  var _super = _createSuper(Slider);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value
	
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	
	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering
	
	
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	
	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings;
	      var newProps;
	
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
	      } else {
	        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
	      } // force scrolling by one if centerMode is on
	
	
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on
	
	
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && ("production") !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child
	
	
	      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	
	
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	
	        return !!child;
	      }); // rows and slidesPerRow logic is handled here
	
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	
	      var newChildren = [];
	      var currentWidth = null;
	
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	
	            if (k >= children.length) break;
	            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	
	          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	
	        if (settings.variableWidth) {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return /*#__PURE__*/_react["default"].createElement("div", {
	          className: className
	        }, children);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }
	
	      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);
	
	  return Slider;
	}(_react["default"].Component);
	
	exports["default"] = Slider;

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Track = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(52));
	
	var _innerSliderUtils = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	
	  var focusedSlide;
	
	  if (spec.targetSlide < 0) {
	    focusedSlide = spec.targetSlide + spec.slideCount;
	  } else if (spec.targetSlide >= spec.slideCount) {
	    focusedSlide = spec.targetSlide - spec.slideCount;
	  } else {
	    focusedSlide = spec.targetSlide;
	  }
	
	  var slickCurrent = index === focusedSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	
	    if (spec.useCSS) {
	      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	
	  var childrenCount = _react["default"].Children.count(spec.children);
	
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react["default"].Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    }; // in case of lazyLoad, whether or not we want to fetch the slide
	
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = /*#__PURE__*/_react["default"].createElement("div", null);
	    }
	
	    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    })); // push a cloned element of the desired slide
	
	    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames["default"])(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread(_objectSpread({
	        outline: "none"
	      }, child.props.style || {}), childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    })); // if slide needs to be precloned or postcloned
	
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	
	        if (key >= startIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	          index: key
	        }));
	        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	
	        if (key < endIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	          index: key
	        }));
	        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  var _super = _createSuper(Track);
	
	  function Track() {
	    var _this;
	
	    _classCallCheck(this, Track);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "node", null);
	
	    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
	      _this.node = ref;
	    });
	
	    return _this;
	  }
	
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: this.handleRef,
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	
	  return Track;
	}(_react["default"].PureComponent);
	
	exports.Track = Track;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var _extends=_interopDefault(__webpack_require__(68)),_objectWithoutPropertiesLoose=_interopDefault(__webpack_require__(94)),_inheritsLoose=_interopDefault(__webpack_require__(182)),React=__webpack_require__(1),React__default=_interopDefault(React),cx=_interopDefault(__webpack_require__(52)),reactTransitionGroup=__webpack_require__(1007),reactDom=__webpack_require__(55),POSITION={TOP_LEFT:"top-left",TOP_RIGHT:"top-right",TOP_CENTER:"top-center",BOTTOM_LEFT:"bottom-left",BOTTOM_RIGHT:"bottom-right",BOTTOM_CENTER:"bottom-center"},TYPE={INFO:"info",SUCCESS:"success",WARNING:"warning",ERROR:"error",DEFAULT:"default"},ACTION={SHOW:0,CLEAR:1,DID_MOUNT:2,WILL_UNMOUNT:3,ON_CHANGE:4},NOOP=function(){},RT_NAMESPACE="Toastify";function isValidDelay(t){return"number"==typeof t&&!isNaN(t)&&0<t}var canUseDom=!("undefined"==typeof window||!window.document||!window.document.createElement);function withRequired(o){return o.isRequired=function(t,e,n){if(void 0===t[e])return new Error("The prop "+e+" is marked as required in \n      "+n+", but its value is undefined.");o(t,e,n)},o}var falseOrDelay=withRequired(function(t,e,n){var o=t[e];return!1===o||isValidDelay(o)?null:new Error(n+" expect "+e+" \n      to be a valid Number > 0 or equal to false. "+o+" given.")}),eventManager={list:new Map,emitQueue:new Map,on:function(t,e){return this.list.has(t)||this.list.set(t,[]),this.list.get(t).push(e),this},off:function(t){return this.list.delete(t),this},cancelEmit:function(t){var e=this.emitQueue.get(t);return e&&(e.forEach(function(t){return clearTimeout(t)}),this.emitQueue.delete(t)),this},emit:function(n){for(var o=this,t=arguments.length,s=new Array(1<t?t-1:0),e=1;e<t;e++)s[e-1]=arguments[e];this.list.has(n)&&this.list.get(n).forEach(function(t){var e=setTimeout(function(){t.apply(void 0,s)},0);o.emitQueue.has(n)||o.emitQueue.set(n,[]),o.emitQueue.get(n).push(e)})}};function cssTransition(t){var u=t.enter,c=t.exit,e=t.duration,p=void 0===e?750:e,n=t.appendPosition,d=void 0!==n&&n;return function(t){var e,n,o=t.children,s=t.position,a=t.preventExitTransition,r=_objectWithoutPropertiesLoose(t,["children","position","preventExitTransition"]),i=d?u+"--"+s:u,l=d?c+"--"+s:c;Array.isArray(p)&&2===p.length?(e=p[0],n=p[1]):e=n=p;return React__default.createElement(reactTransitionGroup.Transition,_extends({},r,{timeout:a?0:{enter:e,exit:n},onEnter:function(t){t.classList.add(i),t.style.animationFillMode="forwards",t.style.animationDuration=.001*e+"s"},onEntered:function(t){t.classList.remove(i),t.style.cssText=""},onExit:a?NOOP:function(t){t.classList.add(l),t.style.animationFillMode="forwards",t.style.animationDuration=.001*n+"s"}}),o)}}function ProgressBar(t){var e,n,o=t.delay,s=t.isRunning,a=t.closeToast,r=t.type,i=t.hide,l=t.className,u=t.style,c=t.controlledProgress,p=t.progress,d=t.rtl,f=_extends({},u,{animationDuration:o+"ms",animationPlayState:s?"running":"paused",opacity:i?0:1,transform:c?"scaleX("+p+")":null}),g=cx(RT_NAMESPACE+"__progress-bar",c?RT_NAMESPACE+"__progress-bar--controlled":RT_NAMESPACE+"__progress-bar--animated",RT_NAMESPACE+"__progress-bar--"+r,((e={})[RT_NAMESPACE+"__progress-bar--rtl"]=d,e),l),h=((n={})[c&&1<=p?"onTransitionEnd":"onAnimationEnd"]=c&&p<1?null:a,n);return React__default.createElement("div",_extends({className:g,style:f},h))}function getX(t){return t.targetTouches&&1<=t.targetTouches.length?t.targetTouches[0].clientX:t.clientX}function getY(t){return t.targetTouches&&1<=t.targetTouches.length?t.targetTouches[0].clientY:t.clientY}ProgressBar.defaultProps={type:TYPE.DEFAULT,hide:!1};var iLoveInternetExplorer=canUseDom&&/(msie|trident)/i.test(navigator.userAgent),Toast=function(o){function t(){for(var a,t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(a=o.call.apply(o,[this].concat(e))||this).state={isRunning:!0,preventExitTransition:!1},a.flag={canCloseOnClick:!0,canDrag:!1},a.drag={start:0,x:0,y:0,deltaX:0,removalDistance:0},a.boundingRect=null,a.ref=null,a.pauseToast=function(){a.props.autoClose&&a.setState({isRunning:!1})},a.playToast=function(){a.props.autoClose&&a.setState({isRunning:!0})},a.onDragStart=function(t){a.flag.canCloseOnClick=!0,a.flag.canDrag=!0,a.boundingRect=a.ref.getBoundingClientRect(),a.ref.style.transition="",a.drag.start=a.drag.x=getX(t.nativeEvent),a.drag.removalDistance=a.ref.offsetWidth*(a.props.draggablePercent/100)},a.onDragMove=function(t){a.flag.canDrag&&(a.state.isRunning&&a.pauseToast(),a.drag.x=getX(t),a.drag.deltaX=a.drag.x-a.drag.start,a.drag.y=getY(t),a.drag.start!==a.drag.x&&(a.flag.canCloseOnClick=!1),a.ref.style.transform="translateX("+a.drag.deltaX+"px)",a.ref.style.opacity=1-Math.abs(a.drag.deltaX/a.drag.removalDistance))},a.onDragEnd=function(t){if(a.flag.canDrag){if(a.flag.canDrag=!1,Math.abs(a.drag.deltaX)>a.drag.removalDistance)return void a.setState({preventExitTransition:!0},a.props.closeToast);a.ref.style.transition="transform 0.2s, opacity 0.2s",a.ref.style.transform="translateX(0)",a.ref.style.opacity=1}},a.onDragTransitionEnd=function(){if(a.boundingRect){var t=a.boundingRect,e=t.top,n=t.bottom,o=t.left,s=t.right;a.props.pauseOnHover&&a.drag.x>=o&&a.drag.x<=s&&a.drag.y>=e&&a.drag.y<=n?a.pauseToast():a.playToast()}},a.onExitTransitionEnd=function(){if(iLoveInternetExplorer)a.props.onExited();else{var t=a.ref.scrollHeight,e=a.ref.style;requestAnimationFrame(function(){e.minHeight="initial",e.height=t+"px",e.transition="all 0.4s ",requestAnimationFrame(function(){e.height=0,e.padding=0,e.margin=0}),setTimeout(function(){return a.props.onExited()},400)})}},a}_inheritsLoose(t,o);var e=t.prototype;return e.componentDidMount=function(){this.props.onOpen(this.props.children.props),this.props.draggable&&this.bindDragEvents(),this.props.pauseOnFocusLoss&&this.bindFocusEvents()},e.componentDidUpdate=function(t){t.draggable!==this.props.draggable&&(this.props.draggable?this.bindDragEvents():this.unbindDragEvents()),t.pauseOnFocusLoss!==this.props.pauseOnFocusLoss&&(this.props.pauseOnFocusLoss?this.bindFocusEvents():this.unbindFocusEvents())},e.componentWillUnmount=function(){this.props.onClose(this.props.children.props),this.props.draggable&&this.unbindDragEvents(),this.props.pauseOnFocusLoss&&this.unbindFocusEvents()},e.bindFocusEvents=function(){window.addEventListener("focus",this.playToast),window.addEventListener("blur",this.pauseToast)},e.unbindFocusEvents=function(){window.removeEventListener("focus",this.playToast),window.removeEventListener("blur",this.pauseToast)},e.bindDragEvents=function(){document.addEventListener("mousemove",this.onDragMove),document.addEventListener("mouseup",this.onDragEnd),document.addEventListener("touchmove",this.onDragMove),document.addEventListener("touchend",this.onDragEnd)},e.unbindDragEvents=function(){document.removeEventListener("mousemove",this.onDragMove),document.removeEventListener("mouseup",this.onDragEnd),document.removeEventListener("touchmove",this.onDragMove),document.removeEventListener("touchend",this.onDragEnd)},e.render=function(){var t,e=this,n=this.props,o=n.closeButton,s=n.children,a=n.autoClose,r=n.pauseOnHover,i=n.onClick,l=n.closeOnClick,u=n.type,c=n.hideProgressBar,p=n.closeToast,d=n.transition,f=n.position,g=n.className,h=n.bodyClassName,T=n.progressClassName,m=n.progressStyle,E=n.updateId,v=n.role,_=n.progress,C=n.rtl,y={className:cx(RT_NAMESPACE+"__toast",RT_NAMESPACE+"__toast--"+u,((t={})[RT_NAMESPACE+"__toast--rtl"]=C,t),g)};a&&r&&(y.onMouseEnter=this.pauseToast,y.onMouseLeave=this.playToast),l&&(y.onClick=function(t){i&&i(t),e.flag.canCloseOnClick&&p()});var N=parseFloat(_)===_;return React__default.createElement(d,{in:this.props.in,appear:!0,onExited:this.onExitTransitionEnd,position:f,preventExitTransition:this.state.preventExitTransition},React__default.createElement("div",_extends({onClick:i},y,{ref:function(t){return e.ref=t},onMouseDown:this.onDragStart,onTouchStart:this.onDragStart,onMouseUp:this.onDragTransitionEnd,onTouchEnd:this.onDragTransitionEnd}),React__default.createElement("div",_extends({},this.props.in&&{role:v},{className:cx(RT_NAMESPACE+"__toast-body",h)}),s),o&&o,(a||N)&&React__default.createElement(ProgressBar,_extends({},E&&!N?{key:"pb-"+E}:{},{rtl:C,delay:a,isRunning:this.state.isRunning,closeToast:p,hide:c,type:u,style:m,className:T,controlledProgress:N,progress:_}))))},t}(React.Component);function CloseButton(t){var e=t.closeToast,n=t.type,o=t.ariaLabel;return React__default.createElement("button",{className:RT_NAMESPACE+"__close-button "+RT_NAMESPACE+"__close-button--"+n,type:"button",onClick:function(t){t.stopPropagation(),e(t)},"aria-label":o},"✖︎")}Toast.defaultProps={type:TYPE.DEFAULT,in:!0,onOpen:NOOP,onClose:NOOP,className:null,bodyClassName:null,progressClassName:null,updateId:null},CloseButton.defaultProps={ariaLabel:"close"};var Bounce=cssTransition({enter:RT_NAMESPACE+"__bounce-enter",exit:RT_NAMESPACE+"__bounce-exit",appendPosition:!0}),Slide=cssTransition({enter:RT_NAMESPACE+"__slide-enter",exit:RT_NAMESPACE+"__slide-exit",duration:[450,750],appendPosition:!0}),Zoom=cssTransition({enter:RT_NAMESPACE+"__zoom-enter",exit:RT_NAMESPACE+"__zoom-exit"}),Flip=cssTransition({enter:RT_NAMESPACE+"__flip-enter",exit:RT_NAMESPACE+"__flip-exit"}),ToastContainer=function(s){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=s.call.apply(s,[this].concat(n))||this).state={toast:[]},e.toastKey=1,e.collection={},e.isToastActive=function(t){return-1!==e.state.toast.indexOf(t)},e}_inheritsLoose(t,s);var e=t.prototype;return e.componentDidMount=function(){var n=this;eventManager.cancelEmit(ACTION.WILL_UNMOUNT).on(ACTION.SHOW,function(t,e){return n.ref?n.buildToast(t,e):null}).on(ACTION.CLEAR,function(t){return n.ref?null==t?n.clear():n.removeToast(t):null}).emit(ACTION.DID_MOUNT,this)},e.componentWillUnmount=function(){eventManager.emit(ACTION.WILL_UNMOUNT,this)},e.removeToast=function(e){this.setState({toast:this.state.toast.filter(function(t){return t!==e})},this.dispatchChange)},e.dispatchChange=function(){eventManager.emit(ACTION.ON_CHANGE,this.state.toast.length,this.props.containerId)},e.makeCloseButton=function(t,e,n){var o=this,s=this.props.closeButton;return React.isValidElement(t)||!1===t?s=t:!0===t&&(s=this.props.closeButton&&"boolean"!=typeof this.props.closeButton?this.props.closeButton:React__default.createElement(CloseButton,null)),!1!==s&&React.cloneElement(s,{closeToast:function(){return o.removeToast(e)},type:n})},e.getAutoCloseDelay=function(t){return!1===t||isValidDelay(t)?t:this.props.autoClose},e.canBeRendered=function(t){return React.isValidElement(t)||"string"==typeof t||"number"==typeof t||"function"==typeof t},e.parseClassName=function(t){return"string"==typeof t?t:null!==t&&"object"==typeof t&&"toString"in t?t.toString():null},e.belongToContainer=function(t){return t.containerId===this.props.containerId},e.buildToast=function(t,e){var n=this,o=e.delay,s=_objectWithoutPropertiesLoose(e,["delay"]);if(!this.canBeRendered(t))throw new Error("The element you provided cannot be rendered. You provided an element of type "+typeof t);var a=s.toastId,r=s.updateId;if(!(this.props.enableMultiContainer&&!this.belongToContainer(s)||this.isToastActive(a)&&null==r)){var i=function(){return n.removeToast(a)},l={id:a,key:s.key||this.toastKey++,type:s.type,closeToast:i,updateId:s.updateId,rtl:this.props.rtl,position:s.position||this.props.position,transition:s.transition||this.props.transition,className:this.parseClassName(s.className||this.props.toastClassName),bodyClassName:this.parseClassName(s.bodyClassName||this.props.bodyClassName),onClick:s.onClick||this.props.onClick,closeButton:this.makeCloseButton(s.closeButton,a,s.type),pauseOnHover:"boolean"==typeof s.pauseOnHover?s.pauseOnHover:this.props.pauseOnHover,pauseOnFocusLoss:"boolean"==typeof s.pauseOnFocusLoss?s.pauseOnFocusLoss:this.props.pauseOnFocusLoss,draggable:"boolean"==typeof s.draggable?s.draggable:this.props.draggable,draggablePercent:"number"!=typeof s.draggablePercent||isNaN(s.draggablePercent)?this.props.draggablePercent:s.draggablePercent,closeOnClick:"boolean"==typeof s.closeOnClick?s.closeOnClick:this.props.closeOnClick,progressClassName:this.parseClassName(s.progressClassName||this.props.progressClassName),progressStyle:this.props.progressStyle,autoClose:this.getAutoCloseDelay(s.autoClose),hideProgressBar:"boolean"==typeof s.hideProgressBar?s.hideProgressBar:this.props.hideProgressBar,progress:parseFloat(s.progress),role:"string"==typeof s.role?s.role:this.props.role};"function"==typeof s.onOpen&&(l.onOpen=s.onOpen),"function"==typeof s.onClose&&(l.onClose=s.onClose),React.isValidElement(t)&&"string"!=typeof t.type&&"number"!=typeof t.type?t=React.cloneElement(t,{closeToast:i}):"function"==typeof t&&(t=t({closeToast:i})),isValidDelay(o)?setTimeout(function(){n.appendToast(l,t,s.staleToastId)},o):this.appendToast(l,t,s.staleToastId)}},e.appendToast=function(t,e,n){var o,s=t.id,a=t.updateId;this.collection=_extends({},this.collection,((o={})[s]={options:t,content:e,position:t.position},o)),this.setState({toast:(a?[].concat(this.state.toast):[].concat(this.state.toast,[s])).filter(function(t){return t!==n})},this.dispatchChange)},e.clear=function(){this.setState({toast:[]})},e.renderToast=function(){var a=this,r={},t=this.props,s=t.className,i=t.style;return(t.newestOnTop?Object.keys(this.collection).reverse():Object.keys(this.collection)).forEach(function(t){var e=a.collection[t],n=e.position,o=e.options,s=e.content;r[n]||(r[n]=[]),-1!==a.state.toast.indexOf(o.id)?r[n].push(React__default.createElement(Toast,_extends({},o,{isDocumentHidden:a.state.isDocumentHidden,key:"toast-"+o.key}),s)):(r[n].push(null),delete a.collection[t])}),Object.keys(r).map(function(t){var e,n=1===r[t].length&&null===r[t][0],o={className:cx(RT_NAMESPACE+"__toast-container",RT_NAMESPACE+"__toast-container--"+t,((e={})[RT_NAMESPACE+"__toast-container--rtl"]=a.props.rtl,e),a.parseClassName(s)),style:n?_extends({},i,{pointerEvents:"none"}):_extends({},i)};return React__default.createElement(reactTransitionGroup.TransitionGroup,_extends({},o,{key:"container-"+t}),r[t])})},e.render=function(){var e=this;return React__default.createElement("div",{ref:function(t){return e.ref=t},className:""+RT_NAMESPACE},this.renderToast())},t}(React.Component);ToastContainer.defaultProps={position:POSITION.TOP_RIGHT,transition:Bounce,rtl:!1,autoClose:5e3,hideProgressBar:!1,closeButton:React__default.createElement(CloseButton,null),pauseOnHover:!0,pauseOnFocusLoss:!0,closeOnClick:!0,newestOnTop:!1,draggable:!0,draggablePercent:80,className:null,style:null,toastClassName:null,bodyClassName:null,progressClassName:null,progressStyle:null,role:"alert"};var containers=new Map,latestInstance=null,containerDomNode=null,containerConfig={},queue=[],lazy=!1;function isAnyContainerMounted(){return 0<containers.size}function getContainer(t){return isAnyContainerMounted()?t?containers.get(t):containers.get(latestInstance):null}function getToast(t,e){var n=getContainer(e.containerId);if(!n)return null;var o=n.collection[t];return void 0===o?null:o}function mergeOptions(t,e){return _extends({},t,{type:e,toastId:getToastId(t)})}function generateToastId(){return(Math.random().toString(36)+Date.now().toString(36)).substr(2,10)}function getToastId(t){return t&&("string"==typeof t.toastId||"number"==typeof t.toastId&&!isNaN(t.toastId))?t.toastId:generateToastId()}function dispatchToast(t,e){return isAnyContainerMounted()?eventManager.emit(ACTION.SHOW,t,e):(queue.push({action:ACTION.SHOW,content:t,options:e}),lazy&&canUseDom&&(lazy=!1,containerDomNode=document.createElement("div"),document.body.appendChild(containerDomNode),reactDom.render(React__default.createElement(ToastContainer,containerConfig),containerDomNode))),e.toastId}var toast=function(t,e){return dispatchToast(t,mergeOptions(e,e&&e.type||TYPE.DEFAULT))},_loop=function(n){TYPE[n]!==TYPE.DEFAULT&&(toast[TYPE[n].toLowerCase()]=function(t,e){return dispatchToast(t,mergeOptions(e,e&&e.type||TYPE[n]))})};for(var t in TYPE)_loop(t);toast.warn=toast.warning,toast.dismiss=function(t){return void 0===t&&(t=null),isAnyContainerMounted()&&eventManager.emit(ACTION.CLEAR,t)},toast.isActive=function(e){var n=!1;return 0<containers.size&&containers.forEach(function(t){t.isToastActive(e)&&(n=!0)}),n},toast.update=function(a,r){void 0===r&&(r={}),setTimeout(function(){var t=getToast(a,r);if(t){var e=t.options,n=t.content,o=_extends({},e,{},r,{toastId:r.toastId||a});r.toastId&&r.toastId!==a?o.staleToastId=a:o.updateId=generateToastId();var s=void 0!==o.render?o.render:n;delete o.render,dispatchToast(s,o)}},0)},toast.done=function(t){toast.update(t,{progress:1})},toast.onChange=function(t){"function"==typeof t&&eventManager.on(ACTION.ON_CHANGE,t)},toast.configure=function(t){lazy=!0,containerConfig=t},toast.POSITION=POSITION,toast.TYPE=TYPE,eventManager.on(ACTION.DID_MOUNT,function(t){latestInstance=t.props.containerId||t,containers.set(latestInstance,t),queue.forEach(function(t){eventManager.emit(t.action,t.content,t.options)}),queue=[]}).on(ACTION.WILL_UNMOUNT,function(t){t?containers.delete(t.props.containerId||t):containers.clear(),0===containers.size&&eventManager.off(ACTION.SHOW).off(ACTION.CLEAR),canUseDom&&containerDomNode&&document.body.removeChild(containerDomNode)}),exports.Bounce=Bounce,exports.Flip=Flip,exports.Slide=Slide,exports.ToastContainer=ToastContainer,exports.ToastPosition=POSITION,exports.ToastType=TYPE,exports.Zoom=Zoom,exports.cssTransition=cssTransition,exports.toast=toast;


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(813));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(816));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(168));
	
	var _PropTypes = __webpack_require__(425);
	
	var _reflow = __webpack_require__(426);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
	 * use it if you're using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**, so it's
	 * important to add `transition` declaration only to them, otherwise transitions
	 * might not behave as intended! This might not be obvious when the transitions
	 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
	 * the example above (minus `transition`), but it becomes apparent in more
	 * complex transitions.
	 *
	 * **Note**: If you're using the
	 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
	 * prop, make sure to define styles for `.appear-*` classes as well.
	 */
	
	
	var CSSTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument[0],
	          appearing = _this$resolveArgument[1];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntering = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument2[0],
	          appearing = _this$resolveArgument2[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntered = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument3[0],
	          appearing = _this$resolveArgument3[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onExit = function (maybeNode) {
	      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument4[0];
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(maybeNode);
	      }
	    };
	
	    _this.onExiting = function (maybeNode) {
	      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument5[0];
	
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(maybeNode);
	      }
	    };
	
	    _this.onExited = function (maybeNode) {
	      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument6[0];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(maybeNode);
	      }
	    };
	
	    _this.resolveArguments = function (maybeNode, maybeAppearing) {
	      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
	      : [maybeNode, maybeAppearing];
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    var _this$getClassNames = this.getClassNames('enter'),
	        doneClassName = _this$getClassNames.doneClassName;
	
	    if (type === 'appear' && phase === 'done' && doneClassName) {
	      className += " " + doneClassName;
	    } // This is to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      if (node) (0, _reflow.forceReflow)(node);
	    }
	
	    if (className) {
	      this.appliedClasses[type][phase] = className;
	
	      _addClass(node, className);
	    }
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return /*#__PURE__*/_react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it appears, enters,
	   * exits or has finished the transition. A single name can be provided, which
	   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
	   *
	   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
	   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
	   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
	   *
	   * A few details to note about how these classes are applied:
	   *
	   * 1. They are _joined_ with the ones that are already defined on the child
	   *    component, so if you want to add some base styles, you can use
	   *    `className` without worrying that it will be overridden.
	   *
	   * 2. If the transition component mounts with `in={false}`, no classes are
	   *    applied yet. You might be expecting `*-exit-done`, but if you think
	   *    about it, a component cannot finish exiting if it hasn't entered yet.
	   *
	   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
	   *    allows you to define different behavior for when appearing is done and
	   *    when regular entering is done, using selectors like
	   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
	   *    an epic entrance animation when element first appears in the DOM using
	   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   *    simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: _propTypes.default.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(55));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(423));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	
	    if (this.props[handler]) {
	      var maybeNode = child.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this);
	      this.props[handler](maybeNode);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.modes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var _Transition = __webpack_require__(168);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(169));
	
	var _leaveRenders, _enterRenders;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function areChildrenDifferent(oldChildren, newChildren) {
	  if (oldChildren === newChildren) return false;
	
	  if (_react.default.isValidElement(oldChildren) && _react.default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Enum of modes for SwitchTransition component
	 * @enum { string }
	 */
	
	
	var modes = {
	  out: 'out-in',
	  in: 'in-out'
	};
	exports.modes = modes;
	
	var callHook = function callHook(element, name, cb) {
	  return function () {
	    var _element$props;
	
	    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
	    cb();
	  };
	};
	
	var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
	  var current = _ref.current,
	      changeState = _ref.changeState;
	  return _react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERING, null);
	    })
	  });
	}, _leaveRenders[modes.in] = function (_ref2) {
	  var current = _ref2.current,
	      changeState = _ref2.changeState,
	      children = _ref2.children;
	  return [current, _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERING);
	    })
	  })];
	}, _leaveRenders);
	var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
	  var children = _ref3.children,
	      changeState = _ref3.changeState;
	  return _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  });
	}, _enterRenders[modes.in] = function (_ref4) {
	  var current = _ref4.current,
	      children = _ref4.children,
	      changeState = _ref4.changeState;
	  return [_react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  }), _react.default.cloneElement(children, {
	    in: true
	  })];
	}, _enterRenders);
	/**
	 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
	 * You can use it when you want to control the render between state transitions.
	 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
	 *
	 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
	 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
	 *
	 * **Note**: If you want the animation to happen simultaneously
	 * (that is, to have the old child removed and a new child inserted **at the same time**),
	 * you should use
	 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
	 * instead.
	 *
	 * ```jsx
	 * function App() {
	 *  const [state, setState] = useState(false);
	 *  return (
	 *    <SwitchTransition>
	 *      <CSSTransition
	 *        key={state ? "Goodbye, world!" : "Hello, world!"}
	 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
	 *        classNames='fade'
	 *      >
	 *        <button onClick={() => setState(state => !state)}>
	 *          {state ? "Goodbye, world!" : "Hello, world!"}
	 *        </button>
	 *      </CSSTransition>
	 *    </SwitchTransition>
	 *  );
	 * }
	 * ```
	 *
	 * ```css
	 * .fade-enter{
	 *    opacity: 0;
	 * }
	 * .fade-exit{
	 *    opacity: 1;
	 * }
	 * .fade-enter-active{
	 *    opacity: 1;
	 * }
	 * .fade-exit-active{
	 *    opacity: 0;
	 * }
	 * .fade-enter-active,
	 * .fade-exit-active{
	 *    transition: opacity 500ms;
	 * }
	 * ```
	 */
	
	var SwitchTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(SwitchTransition, _React$Component);
	
	  function SwitchTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.state = {
	      status: _Transition.ENTERED,
	      current: null
	    };
	    _this.appeared = false;
	
	    _this.changeState = function (status, current) {
	      if (current === void 0) {
	        current = _this.state.current;
	      }
	
	      _this.setState({
	        status: status,
	        current: current
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = SwitchTransition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.children == null) {
	      return {
	        current: null
	      };
	    }
	
	    if (state.status === _Transition.ENTERING && props.mode === modes.in) {
	      return {
	        status: _Transition.ENTERING
	      };
	    }
	
	    if (state.current && areChildrenDifferent(state.current, props.children)) {
	      return {
	        status: _Transition.EXITING
	      };
	    }
	
	    return {
	      current: _react.default.cloneElement(props.children, {
	        in: true
	      })
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        mode = _this$props.mode,
	        _this$state = this.state,
	        status = _this$state.status,
	        current = _this$state.current;
	    var data = {
	      children: children,
	      current: current,
	      changeState: this.changeState,
	      status: status
	    };
	    var component;
	
	    switch (status) {
	      case _Transition.ENTERING:
	        component = enterRenders[mode](data);
	        break;
	
	      case _Transition.EXITING:
	        component = leaveRenders[mode](data);
	        break;
	
	      case _Transition.ENTERED:
	        component = current;
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: {
	        isMounting: !this.appeared
	      }
	    }, component);
	  };
	
	  return SwitchTransition;
	}(_react.default.Component);
	
	SwitchTransition.propTypes =  false ? {
	  /**
	   * Transition modes.
	   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
	   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
	   *
	   * @type {'out-in'|'in-out'}
	   */
	  mode: _propTypes.default.oneOf([modes.in, modes.out]),
	
	  /**
	   * Any `Transition` or `CSSTransition` component.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element.isRequired])
	} : {};
	SwitchTransition.defaultProps = {
	  mode: modes.out
	};
	var _default = SwitchTransition;
	exports.default = _default;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.config = exports.Transition = exports.TransitionGroup = exports.SwitchTransition = exports.ReplaceTransition = exports.CSSTransition = void 0;
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(1004));
	
	exports.CSSTransition = _CSSTransition.default;
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1005));
	
	exports.ReplaceTransition = _ReplaceTransition.default;
	
	var _SwitchTransition = _interopRequireDefault(__webpack_require__(1006));
	
	exports.SwitchTransition = _SwitchTransition.default;
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(423));
	
	exports.TransitionGroup = _TransitionGroup.default;
	
	var _Transition = _interopRequireDefault(__webpack_require__(168));
	
	exports.Transition = _Transition.default;
	
	var _config = _interopRequireDefault(__webpack_require__(424));
	
	exports.config = _config.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = (key in prevChildMapping);
	    var hasNext = (key in nextChildMapping);
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(1012);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _AutoSizer = __webpack_require__(1017);
	
	var _AutoSizer2 = _interopRequireDefault(_AutoSizer);
	
	var _List = __webpack_require__(1026);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Import directly to avoid Webpack bundling the parts of react-virtualized that we are not using
	
	
	var VirtualizedSelect = function (_Component) {
	  _inherits(VirtualizedSelect, _Component);
	
	  function VirtualizedSelect(props, context) {
	    _classCallCheck(this, VirtualizedSelect);
	
	    var _this = _possibleConstructorReturn(this, (VirtualizedSelect.__proto__ || Object.getPrototypeOf(VirtualizedSelect)).call(this, props, context));
	
	    _this._renderMenu = _this._renderMenu.bind(_this);
	    _this._optionRenderer = _this._optionRenderer.bind(_this);
	    _this._setListRef = _this._setListRef.bind(_this);
	    _this._setSelectRef = _this._setSelectRef.bind(_this);
	    return _this;
	  }
	
	  /** See List#recomputeRowHeights */
	
	
	  _createClass(VirtualizedSelect, [{
	    key: 'recomputeOptionHeights',
	    value: function recomputeOptionHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this._listRef) {
	        this._listRef.recomputeRowHeights(index);
	      }
	    }
	
	    /** See Select#focus (in react-select) */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this._selectRef) {
	        return this._selectRef.focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SelectComponent = this._getSelectComponent();
	
	      return _react2.default.createElement(SelectComponent, _extends({}, this.props, {
	        ref: this._setSelectRef,
	        menuRenderer: this._renderMenu,
	        menuStyle: { overflow: 'hidden' }
	      }));
	    }
	
	    // See https://github.com/JedWatson/react-select/#effeciently-rendering-large-lists-with-windowing
	
	  }, {
	    key: '_renderMenu',
	    value: function _renderMenu(_ref) {
	      var _this2 = this;
	
	      var focusedOption = _ref.focusedOption,
	          focusOption = _ref.focusOption,
	          labelKey = _ref.labelKey,
	          onSelect = _ref.onSelect,
	          options = _ref.options,
	          selectValue = _ref.selectValue,
	          valueArray = _ref.valueArray,
	          valueKey = _ref.valueKey;
	      var _props = this.props,
	          listProps = _props.listProps,
	          optionRenderer = _props.optionRenderer;
	
	      var focusedOptionIndex = options.indexOf(focusedOption);
	      var height = this._calculateListHeight({ options: options });
	      var innerRowRenderer = optionRenderer || this._optionRenderer;
	
	      // react-select 1.0.0-rc2 passes duplicate `onSelect` and `selectValue` props to `menuRenderer`
	      // The `Creatable` HOC only overrides `onSelect` which breaks an edge-case
	      // In order to support creating items via clicking on the placeholder option,
	      // We need to ensure that the specified `onSelect` handle is the one we use.
	      // See issue #33
	
	      function wrappedRowRenderer(_ref2) {
	        var index = _ref2.index,
	            key = _ref2.key,
	            style = _ref2.style;
	
	        var option = options[index];
	
	        return innerRowRenderer({
	          focusedOption: focusedOption,
	          focusedOptionIndex: focusedOptionIndex,
	          focusOption: focusOption,
	          key: key,
	          labelKey: labelKey,
	          onSelect: onSelect,
	          option: option,
	          optionIndex: index,
	          options: options,
	          selectValue: onSelect,
	          style: style,
	          valueArray: valueArray,
	          valueKey: valueKey
	        });
	      }
	
	      return _react2.default.createElement(
	        _AutoSizer2.default,
	        { disableHeight: true },
	        function (_ref3) {
	          var width = _ref3.width;
	          return _react2.default.createElement(_List2.default, _extends({
	            className: 'VirtualSelectGrid',
	            height: height,
	            ref: _this2._setListRef,
	            rowCount: options.length,
	            rowHeight: function rowHeight(_ref4) {
	              var index = _ref4.index;
	              return _this2._getOptionHeight({
	                option: options[index]
	              });
	            },
	            rowRenderer: wrappedRowRenderer,
	            scrollToIndex: focusedOptionIndex,
	            width: width
	          }, listProps));
	        }
	      );
	    }
	  }, {
	    key: '_calculateListHeight',
	    value: function _calculateListHeight(_ref5) {
	      var options = _ref5.options;
	      var maxHeight = this.props.maxHeight;
	
	
	      var height = 0;
	
	      for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
	        var option = options[optionIndex];
	
	        height += this._getOptionHeight({ option: option });
	
	        if (height > maxHeight) {
	          return maxHeight;
	        }
	      }
	
	      return height;
	    }
	  }, {
	    key: '_getOptionHeight',
	    value: function _getOptionHeight(_ref6) {
	      var option = _ref6.option;
	      var optionHeight = this.props.optionHeight;
	
	
	      return optionHeight instanceof Function ? optionHeight({ option: option }) : optionHeight;
	    }
	  }, {
	    key: '_getSelectComponent',
	    value: function _getSelectComponent() {
	      var _props2 = this.props,
	          async = _props2.async,
	          selectComponent = _props2.selectComponent;
	
	
	      if (selectComponent) {
	        return selectComponent;
	      } else if (async) {
	        return _reactSelect2.default.Async;
	      } else {
	        return _reactSelect2.default;
	      }
	    }
	  }, {
	    key: '_optionRenderer',
	    value: function _optionRenderer(_ref7) {
	      var focusedOption = _ref7.focusedOption,
	          focusOption = _ref7.focusOption,
	          key = _ref7.key,
	          labelKey = _ref7.labelKey,
	          option = _ref7.option,
	          selectValue = _ref7.selectValue,
	          style = _ref7.style,
	          valueArray = _ref7.valueArray;
	
	      var className = ['VirtualizedSelectOption'];
	
	      if (option === focusedOption) {
	        className.push('VirtualizedSelectFocusedOption');
	      }
	
	      if (option.disabled) {
	        className.push('VirtualizedSelectDisabledOption');
	      }
	
	      if (valueArray && valueArray.indexOf(option) >= 0) {
	        className.push('VirtualizedSelectSelectedOption');
	      }
	
	      if (option.className) {
	        className.push(option.className);
	      }
	
	      var events = option.disabled ? {} : {
	        onClick: function onClick() {
	          return selectValue(option);
	        },
	        onMouseEnter: function onMouseEnter() {
	          return focusOption(option);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: className.join(' '),
	          key: key,
	          style: style,
	          title: option.title
	        }, events),
	        option[labelKey]
	      );
	    }
	  }, {
	    key: '_setListRef',
	    value: function _setListRef(ref) {
	      this._listRef = ref;
	    }
	  }, {
	    key: '_setSelectRef',
	    value: function _setSelectRef(ref) {
	      this._selectRef = ref;
	    }
	  }]);
	
	  return VirtualizedSelect;
	}(_react.Component);
	
	VirtualizedSelect.propTypes = {
	  async: _propTypes2.default.bool,
	  listProps: _propTypes2.default.object,
	  maxHeight: _propTypes2.default.number,
	  optionHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
	  optionRenderer: _propTypes2.default.func,
	  selectComponent: _propTypes2.default.func
	};
	VirtualizedSelect.defaultProps = {
	  async: false,
	  maxHeight: 200,
	  optionHeight: 35
	};
	exports.default = VirtualizedSelect;

/***/ },
/* 1010 */
[1186, 1009],
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(427);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(428);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(127);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(127);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(427);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(1011);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(428);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(430);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(429);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(171);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(431);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(432);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(170);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 1013 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ },
/* 1014 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	var _interopRequireWildcard = __webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(109));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(108));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _detectElementResize = _interopRequireDefault(__webpack_require__(1030));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var _class, _temp;
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var AutoSizer = (_temp = _class =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2["default"])(AutoSizer, _React$Component);
	
	  function AutoSizer() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, AutoSizer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AutoSizer)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
	      height: _this.props.defaultHeight || 0,
	      width: _this.props.defaultWidth || 0
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_parentNode", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_autoSizer", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_window", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_detectElementResize", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onResize", function () {
	      var _this$props = _this.props,
	          disableHeight = _this$props.disableHeight,
	          disableWidth = _this$props.disableWidth,
	          onResize = _this$props.onResize;
	
	      if (_this._parentNode) {
	        // Guard against AutoSizer component being removed from the DOM immediately after being added.
	        // This can result in invalid style values which can result in NaN values if we don't handle them.
	        // See issue #150 for more context.
	        var height = _this._parentNode.offsetHeight || 0;
	        var width = _this._parentNode.offsetWidth || 0;
	        var win = _this._window || window;
	        var style = win.getComputedStyle(_this._parentNode) || {};
	        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
	        var paddingRight = parseInt(style.paddingRight, 10) || 0;
	        var paddingTop = parseInt(style.paddingTop, 10) || 0;
	        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
	        var newHeight = height - paddingTop - paddingBottom;
	        var newWidth = width - paddingLeft - paddingRight;
	
	        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
	          _this.setState({
	            height: height - paddingTop - paddingBottom,
	            width: width - paddingLeft - paddingRight
	          });
	
	          onResize({
	            height: height,
	            width: width
	          });
	        }
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setRef", function (autoSizer) {
	      _this._autoSizer = autoSizer;
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(AutoSizer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var nonce = this.props.nonce;
	
	      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
	        // Delay access of parentNode until mount.
	        // This handles edge-cases where the component has already been unmounted before its ref has been set,
	        // As well as libraries like react-lite which have a slightly different lifecycle.
	        this._parentNode = this._autoSizer.parentNode;
	        this._window = this._autoSizer.parentNode.ownerDocument.defaultView; // Defer requiring resize handler in order to support server-side rendering.
	        // See issue #41
	
	        this._detectElementResize = (0, _detectElementResize["default"])(nonce, this._window);
	
	        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
	
	        this._onResize();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this._detectElementResize && this._parentNode) {
	        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          disableHeight = _this$props2.disableHeight,
	          disableWidth = _this$props2.disableWidth,
	          style = _this$props2.style;
	      var _this$state = this.state,
	          height = _this$state.height,
	          width = _this$state.width; // Outer div should not force width/height since that may prevent containers from shrinking.
	      // Inner component should overflow and use calculated width/height.
	      // See issue #68 for more information.
	
	      var outerStyle = {
	        overflow: 'visible'
	      };
	      var childParams = {};
	
	      if (!disableHeight) {
	        outerStyle.height = 0;
	        childParams.height = height;
	      }
	
	      if (!disableWidth) {
	        outerStyle.width = 0;
	        childParams.width = width;
	      }
	      /**
	       * TODO: Avoid rendering children before the initial measurements have been collected.
	       * At best this would just be wasting cycles.
	       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
	       * Note that if default width/height props were provided this would still work with SSR.
	      if (
	        height !== 0 &&
	        width !== 0
	      ) {
	        child = children({ height, width })
	      }
	      */
	
	
	      return React.createElement("div", {
	        className: className,
	        ref: this._setRef,
	        style: _objectSpread({}, outerStyle, {}, style)
	      }, children(childParams));
	    }
	  }]);
	  return AutoSizer;
	}(React.Component), (0, _defineProperty2["default"])(_class, "propTypes",  true ? null : {
	  /** Function responsible for rendering children.*/
	  "children": _propTypes["default"].func.isRequired,
	
	  /** Optional custom CSS class name to attach to root AutoSizer element.  */
	  "className": _propTypes["default"].string,
	
	  /** Default height to use for initial render; useful for SSR */
	  "defaultHeight": _propTypes["default"].number,
	
	  /** Default width to use for initial render; useful for SSR */
	  "defaultWidth": _propTypes["default"].number,
	
	  /** Disable dynamic :height property */
	  "disableHeight": _propTypes["default"].bool.isRequired,
	
	  /** Disable dynamic :width property */
	  "disableWidth": _propTypes["default"].bool.isRequired,
	
	  /** Nonce of the inlined stylesheet for Content Security Policy */
	  "nonce": _propTypes["default"].string,
	
	  /** Callback to be invoked on-resize */
	  "onResize": _propTypes["default"].func.isRequired,
	
	  /** Optional inline style */
	  "style": _propTypes["default"].object
	}), _temp);
	exports["default"] = AutoSizer;
	(0, _defineProperty2["default"])(AutoSizer, "defaultProps", {
	  onResize: function onResize() {},
	  disableHeight: false,
	  disableWidth: false,
	  style: {}
	});

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AutoSizer["default"];
	  }
	});
	Object.defineProperty(exports, "AutoSizer", {
	  enumerable: true,
	  get: function get() {
	    return _AutoSizer["default"];
	  }
	});
	
	var _AutoSizer = _interopRequireDefault(__webpack_require__(1016));

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	var _interopRequireWildcard = __webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(68));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(109));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(108));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _clsx = _interopRequireDefault(__webpack_require__(213));
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset = _interopRequireDefault(__webpack_require__(1022));
	
	var _ScalingCellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(172));
	
	var _createCallbackMemoizer = _interopRequireDefault(__webpack_require__(1028));
	
	var _defaultOverscanIndicesGetter = _interopRequireWildcard(__webpack_require__(435));
	
	var _updateScrollIndexHelper = _interopRequireDefault(__webpack_require__(1024));
	
	var _defaultCellRangeRenderer = _interopRequireDefault(__webpack_require__(434));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(817));
	
	var _reactLifecyclesCompat = __webpack_require__(410);
	
	var _requestAnimationTimeout = __webpack_require__(1029);
	
	var _types = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var _class, _temp;
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	/**
	 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	
	exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = DEFAULT_SCROLLING_RESET_TIME_INTERVAL;
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	var renderNull = function renderNull() {
	  return null;
	};
	
	/**
	 * Renders tabular data with virtualization along the vertical and horizontal axes.
	 * Row heights and column widths must be known ahead of time and specified as properties.
	 */
	var Grid = (_temp = _class =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  (0, _inherits2["default"])(Grid, _React$PureComponent);
	
	  // Invokes onSectionRendered callback only when start/stop row or column indices change
	  function Grid(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Grid);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Grid).call(this, props));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onGridRenderedMemoizer", (0, _createCallbackMemoizer["default"])());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScrollMemoizer", (0, _createCallbackMemoizer["default"])(false));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_deferredInvalidateColumnIndex", null);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_deferredInvalidateRowIndex", null);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_recomputeScrollLeftFlag", false);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_recomputeScrollTopFlag", false);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_horizontalScrollBarSize", 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_verticalScrollBarSize", 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_scrollbarPresenceChanged", false);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_scrollingContainer", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_childrenToDisplay", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStartIndex", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStopIndex", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStartIndex", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStopIndex", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedColumnStartIndex", 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedColumnStopIndex", 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedRowStartIndex", 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedRowStopIndex", 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initialScrollTop", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initialScrollLeft", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_disablePointerEventsTimeoutId", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_styleCache", {});
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellCache", {});
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_debounceScrollEndedCallback", function () {
	      _this._disablePointerEventsTimeoutId = null; // isScrolling is used to determine if we reset styleCache
	
	      _this.setState({
	        isScrolling: false,
	        needToResetStyleCache: false
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_invokeOnGridRenderedHelper", function () {
	      var onSectionRendered = _this.props.onSectionRendered;
	
	      _this._onGridRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          columnOverscanStartIndex: _this._columnStartIndex,
	          columnOverscanStopIndex: _this._columnStopIndex,
	          columnStartIndex: _this._renderedColumnStartIndex,
	          columnStopIndex: _this._renderedColumnStopIndex,
	          rowOverscanStartIndex: _this._rowStartIndex,
	          rowOverscanStopIndex: _this._rowStopIndex,
	          rowStartIndex: _this._renderedRowStartIndex,
	          rowStopIndex: _this._renderedRowStopIndex
	        }
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setScrollingContainerRef", function (ref) {
	      _this._scrollingContainer = ref;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function (event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target === _this._scrollingContainer) {
	        _this.handleScrollEvent(event.target);
	      }
	    });
	    var columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager["default"]({
	      cellCount: props.columnCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return Grid._wrapSizeGetter(props.columnWidth)(params);
	      },
	      estimatedCellSize: Grid._getEstimatedColumnSize(props)
	    });
	    var rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager["default"]({
	      cellCount: props.rowCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return Grid._wrapSizeGetter(props.rowHeight)(params);
	      },
	      estimatedCellSize: Grid._getEstimatedRowSize(props)
	    });
	    _this.state = {
	      instanceProps: {
	        columnSizeAndPositionManager: columnSizeAndPositionManager,
	        rowSizeAndPositionManager: rowSizeAndPositionManager,
	        prevColumnWidth: props.columnWidth,
	        prevRowHeight: props.rowHeight,
	        prevColumnCount: props.columnCount,
	        prevRowCount: props.rowCount,
	        prevIsScrolling: props.isScrolling === true,
	        prevScrollToColumn: props.scrollToColumn,
	        prevScrollToRow: props.scrollToRow,
	        scrollbarSize: 0,
	        scrollbarSizeMeasured: false
	      },
	      isScrolling: false,
	      scrollDirectionHorizontal: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
	      scrollDirectionVertical: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
	      scrollLeft: 0,
	      scrollTop: 0,
	      scrollPositionChangeReason: null,
	      needToResetStyleCache: false
	    };
	
	    if (props.scrollToRow > 0) {
	      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
	    }
	
	    if (props.scrollToColumn > 0) {
	      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
	    }
	
	    return _this;
	  }
	  /**
	   * Gets offsets for a given cell and alignment.
	   */
	
	
	  (0, _createClass2["default"])(Grid, [{
	    key: "getOffsetForCell",
	    value: function getOffsetForCell() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$alignment = _ref.alignment,
	          alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
	          _ref$columnIndex = _ref.columnIndex,
	          columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
	          _ref$rowIndex = _ref.rowIndex,
	          rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;
	
	      var offsetProps = _objectSpread({}, this.props, {
	        scrollToAlignment: alignment,
	        scrollToColumn: columnIndex,
	        scrollToRow: rowIndex
	      });
	
	      return {
	        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
	        scrollTop: this._getCalculatedScrollTop(offsetProps)
	      };
	    }
	    /**
	     * Gets estimated total rows' height.
	     */
	
	  }, {
	    key: "getTotalRowsHeight",
	    value: function getTotalRowsHeight() {
	      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
	    }
	    /**
	     * Gets estimated total columns' width.
	     */
	
	  }, {
	    key: "getTotalColumnsWidth",
	    value: function getTotalColumnsWidth() {
	      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
	    }
	    /**
	     * This method handles a scroll event originating from an external scroll control.
	     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
	     */
	
	  }, {
	    key: "handleScrollEvent",
	    value: function handleScrollEvent(_ref2) {
	      var _ref2$scrollLeft = _ref2.scrollLeft,
	          scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
	          _ref2$scrollTop = _ref2.scrollTop,
	          scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;
	
	      // On iOS, we can arrive at negative offsets by swiping past the start.
	      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
	      if (scrollTopParam < 0) {
	        return;
	      } // Prevent pointer events from interrupting a smooth scroll
	
	
	      this._debounceScrollEnded();
	
	      var _this$props = this.props,
	          autoHeight = _this$props.autoHeight,
	          autoWidth = _this$props.autoWidth,
	          height = _this$props.height,
	          width = _this$props.width;
	      var instanceProps = this.state.instanceProps; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
	
	      var scrollbarSize = instanceProps.scrollbarSize;
	      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
	      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
	      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
	      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
	        // Don't change direction for an axis unless scroll offset has changed.
	        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
	        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
	        var newState = {
	          isScrolling: true,
	          scrollDirectionHorizontal: scrollDirectionHorizontal,
	          scrollDirectionVertical: scrollDirectionVertical,
	          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
	        };
	
	        if (!autoHeight) {
	          newState.scrollTop = scrollTop;
	        }
	
	        if (!autoWidth) {
	          newState.scrollLeft = scrollLeft;
	        }
	
	        newState.needToResetStyleCache = false;
	        this.setState(newState);
	      }
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        totalColumnsWidth: totalColumnsWidth,
	        totalRowsHeight: totalRowsHeight
	      });
	    }
	    /**
	     * Invalidate Grid size and recompute visible cells.
	     * This is a deferred wrapper for recomputeGridSize().
	     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
	     * This method is intended for advanced use-cases like CellMeasurer.
	     */
	    // @TODO (bvaughn) Add automated test coverage for this.
	
	  }, {
	    key: "invalidateCellSizeAfterRender",
	    value: function invalidateCellSizeAfterRender(_ref3) {
	      var columnIndex = _ref3.columnIndex,
	          rowIndex = _ref3.rowIndex;
	      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
	      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
	    }
	    /**
	     * Pre-measure all columns and rows in a Grid.
	     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
	     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
	     */
	
	  }, {
	    key: "measureAllCells",
	    value: function measureAllCells() {
	      var _this$props2 = this.props,
	          columnCount = _this$props2.columnCount,
	          rowCount = _this$props2.rowCount;
	      var instanceProps = this.state.instanceProps;
	      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
	      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
	    }
	    /**
	     * Forced recompute of row heights and column widths.
	     * This function should be called if dynamic column or row sizes have changed but nothing else has.
	     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
	     */
	
	  }, {
	    key: "recomputeGridSize",
	    value: function recomputeGridSize() {
	      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref4$columnIndex = _ref4.columnIndex,
	          columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
	          _ref4$rowIndex = _ref4.rowIndex,
	          rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;
	
	      var _this$props3 = this.props,
	          scrollToColumn = _this$props3.scrollToColumn,
	          scrollToRow = _this$props3.scrollToRow;
	      var instanceProps = this.state.instanceProps;
	      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
	      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex); // Cell sizes may be determined by a function property.
	      // In this case the cDU handler can't know if they changed.
	      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
	
	      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
	      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow); // Clear cell cache in case we are scrolling;
	      // Invalid row heights likely mean invalid cached content as well.
	
	      this._styleCache = {};
	      this._cellCache = {};
	      this.forceUpdate();
	    }
	    /**
	     * Ensure column and row are visible.
	     */
	
	  }, {
	    key: "scrollToCell",
	    value: function scrollToCell(_ref5) {
	      var columnIndex = _ref5.columnIndex,
	          rowIndex = _ref5.rowIndex;
	      var columnCount = this.props.columnCount;
	      var props = this.props; // Don't adjust scroll offset for single-column grids (eg List, Table).
	      // This can cause a funky scroll offset because of the vertical scrollbar width.
	
	      if (columnCount > 1 && columnIndex !== undefined) {
	        this._updateScrollLeftForScrollToColumn(_objectSpread({}, props, {
	          scrollToColumn: columnIndex
	        }));
	      }
	
	      if (rowIndex !== undefined) {
	        this._updateScrollTopForScrollToRow(_objectSpread({}, props, {
	          scrollToRow: rowIndex
	        }));
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props4 = this.props,
	          getScrollbarSize = _this$props4.getScrollbarSize,
	          height = _this$props4.height,
	          scrollLeft = _this$props4.scrollLeft,
	          scrollToColumn = _this$props4.scrollToColumn,
	          scrollTop = _this$props4.scrollTop,
	          scrollToRow = _this$props4.scrollToRow,
	          width = _this$props4.width;
	      var instanceProps = this.state.instanceProps; // Reset initial offsets to be ignored in browser
	
	      this._initialScrollTop = 0;
	      this._initialScrollLeft = 0; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
	      // We must do this at the start of the method as we may calculate and update scroll position below.
	
	      this._handleInvalidatedGridSize(); // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	
	
	      if (!instanceProps.scrollbarSizeMeasured) {
	        this.setState(function (prevState) {
	          var stateUpdate = _objectSpread({}, prevState, {
	            needToResetStyleCache: false
	          });
	
	          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
	          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
	          return stateUpdate;
	        });
	      }
	
	      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
	        var stateUpdate = Grid._getScrollToPositionStateUpdate({
	          prevState: this.state,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        });
	
	        if (stateUpdate) {
	          stateUpdate.needToResetStyleCache = false;
	          this.setState(stateUpdate);
	        }
	      } // refs don't work in `react-test-renderer`
	
	
	      if (this._scrollingContainer) {
	        // setting the ref's scrollLeft and scrollTop.
	        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
	        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
	          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
	        }
	
	        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
	          this._scrollingContainer.scrollTop = this.state.scrollTop;
	        }
	      } // Don't update scroll offset if the size is 0; we don't render any cells in this case.
	      // Setting a state may cause us to later thing we've updated the offce when we haven't.
	
	
	      var sizeIsBiggerThanZero = height > 0 && width > 0;
	
	      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
	        this._updateScrollLeftForScrollToColumn();
	      }
	
	      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
	        this._updateScrollTopForScrollToRow();
	      } // Update onRowsRendered callback
	
	
	      this._invokeOnGridRenderedHelper(); // Initialize onScroll callback
	
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
	        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
	      });
	
	      this._maybeCallOnScrollbarPresenceChange();
	    }
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) New scroll-to-cell props have been set
	     */
	
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      var _this$props5 = this.props,
	          autoHeight = _this$props5.autoHeight,
	          autoWidth = _this$props5.autoWidth,
	          columnCount = _this$props5.columnCount,
	          height = _this$props5.height,
	          rowCount = _this$props5.rowCount,
	          scrollToAlignment = _this$props5.scrollToAlignment,
	          scrollToColumn = _this$props5.scrollToColumn,
	          scrollToRow = _this$props5.scrollToRow,
	          width = _this$props5.width;
	      var _this$state = this.state,
	          scrollLeft = _this$state.scrollLeft,
	          scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
	          scrollTop = _this$state.scrollTop,
	          instanceProps = _this$state.instanceProps; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
	      // We must do this at the start of the method as we may calculate and update scroll position below.
	
	      this._handleInvalidatedGridSize(); // Handle edge case where column or row count has only just increased over 0.
	      // In this case we may have to restore a previously-specified scroll offset.
	      // For more info see bvaughn/react-virtualized/issues/218
	
	
	      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
	        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
	        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	
	        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      } // Special case where the previous size was 0:
	      // In this case we don't show any windowed cells at all.
	      // So we should always recalculate offset afterwards.
	
	
	      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0; // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
	      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
	
	      if (this._recomputeScrollLeftFlag) {
	        this._recomputeScrollLeftFlag = false;
	
	        this._updateScrollLeftForScrollToColumn(this.props);
	      } else {
	        (0, _updateScrollIndexHelper["default"])({
	          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
	          previousCellsCount: prevProps.columnCount,
	          previousCellSize: prevProps.columnWidth,
	          previousScrollToAlignment: prevProps.scrollToAlignment,
	          previousScrollToIndex: prevProps.scrollToColumn,
	          previousSize: prevProps.width,
	          scrollOffset: scrollLeft,
	          scrollToAlignment: scrollToAlignment,
	          scrollToIndex: scrollToColumn,
	          size: width,
	          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
	          updateScrollIndexCallback: function updateScrollIndexCallback() {
	            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
	          }
	        });
	      }
	
	      if (this._recomputeScrollTopFlag) {
	        this._recomputeScrollTopFlag = false;
	
	        this._updateScrollTopForScrollToRow(this.props);
	      } else {
	        (0, _updateScrollIndexHelper["default"])({
	          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
	          previousCellsCount: prevProps.rowCount,
	          previousCellSize: prevProps.rowHeight,
	          previousScrollToAlignment: prevProps.scrollToAlignment,
	          previousScrollToIndex: prevProps.scrollToRow,
	          previousSize: prevProps.height,
	          scrollOffset: scrollTop,
	          scrollToAlignment: scrollToAlignment,
	          scrollToIndex: scrollToRow,
	          size: height,
	          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
	          updateScrollIndexCallback: function updateScrollIndexCallback() {
	            return _this2._updateScrollTopForScrollToRow(_this2.props);
	          }
	        });
	      } // Update onRowsRendered callback if start/stop indices have changed
	
	
	      this._invokeOnGridRenderedHelper(); // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
	
	
	      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
	        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
	        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
	
	        this._invokeOnScrollMemoizer({
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          totalColumnsWidth: totalColumnsWidth,
	          totalRowsHeight: totalRowsHeight
	        });
	      }
	
	      this._maybeCallOnScrollbarPresenceChange();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
	      }
	    }
	    /**
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          autoContainerWidth = _this$props6.autoContainerWidth,
	          autoHeight = _this$props6.autoHeight,
	          autoWidth = _this$props6.autoWidth,
	          className = _this$props6.className,
	          containerProps = _this$props6.containerProps,
	          containerRole = _this$props6.containerRole,
	          containerStyle = _this$props6.containerStyle,
	          height = _this$props6.height,
	          id = _this$props6.id,
	          noContentRenderer = _this$props6.noContentRenderer,
	          role = _this$props6.role,
	          style = _this$props6.style,
	          tabIndex = _this$props6.tabIndex,
	          width = _this$props6.width;
	      var _this$state2 = this.state,
	          instanceProps = _this$state2.instanceProps,
	          needToResetStyleCache = _this$state2.needToResetStyleCache;
	
	      var isScrolling = this._isScrolling();
	
	      var gridStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        width: autoWidth ? 'auto' : width,
	        WebkitOverflowScrolling: 'touch',
	        willChange: 'transform'
	      };
	
	      if (needToResetStyleCache) {
	        this._styleCache = {};
	      } // calculate _styleCache here
	      // if state.isScrolling (not from _isScrolling) then reset
	
	
	      if (!this.state.isScrolling) {
	        this._resetStyleCache();
	      } // calculate children to render here
	
	
	      this._calculateChildrenToRender(this.props, this.state);
	
	      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
	      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize(); // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	
	      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
	      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
	
	      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
	        this._horizontalScrollBarSize = horizontalScrollBarSize;
	        this._verticalScrollBarSize = verticalScrollBarSize;
	        this._scrollbarPresenceChanged = true;
	      } // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	
	
	      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	      var childrenToDisplay = this._childrenToDisplay;
	      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
	      return React.createElement("div", (0, _extends2["default"])({
	        ref: this._setScrollingContainerRef
	      }, containerProps, {
	        "aria-label": this.props['aria-label'],
	        "aria-readonly": this.props['aria-readonly'],
	        className: (0, _clsx["default"])('ReactVirtualized__Grid', className),
	        id: id,
	        onScroll: this._onScroll,
	        role: role,
	        style: _objectSpread({}, gridStyle, {}, style),
	        tabIndex: tabIndex
	      }), childrenToDisplay.length > 0 && React.createElement("div", {
	        className: "ReactVirtualized__Grid__innerScrollContainer",
	        role: containerRole,
	        style: _objectSpread({
	          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
	          height: totalRowsHeight,
	          maxWidth: totalColumnsWidth,
	          maxHeight: totalRowsHeight,
	          overflow: 'hidden',
	          pointerEvents: isScrolling ? 'none' : '',
	          position: 'relative'
	        }, containerStyle)
	      }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
	    }
	    /* ---------------------------- Helper methods ---------------------------- */
	
	  }, {
	    key: "_calculateChildrenToRender",
	    value: function _calculateChildrenToRender() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var cellRenderer = props.cellRenderer,
	          cellRangeRenderer = props.cellRangeRenderer,
	          columnCount = props.columnCount,
	          deferredMeasurementCache = props.deferredMeasurementCache,
	          height = props.height,
	          overscanColumnCount = props.overscanColumnCount,
	          overscanIndicesGetter = props.overscanIndicesGetter,
	          overscanRowCount = props.overscanRowCount,
	          rowCount = props.rowCount,
	          width = props.width,
	          isScrollingOptOut = props.isScrollingOptOut;
	      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
	          scrollDirectionVertical = state.scrollDirectionVertical,
	          instanceProps = state.instanceProps;
	      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
	      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
	
	      var isScrolling = this._isScrolling(props, state);
	
	      this._childrenToDisplay = []; // Render only enough columns and rows to cover the visible area of the grid.
	
	      if (height > 0 && width > 0) {
	        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
	          containerSize: height,
	          offset: scrollTop
	        });
	        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: height,
	          offset: scrollTop
	        }); // Store for _invokeOnGridRenderedHelper()
	
	        this._renderedColumnStartIndex = visibleColumnIndices.start;
	        this._renderedColumnStopIndex = visibleColumnIndices.stop;
	        this._renderedRowStartIndex = visibleRowIndices.start;
	        this._renderedRowStopIndex = visibleRowIndices.stop;
	        var overscanColumnIndices = overscanIndicesGetter({
	          direction: 'horizontal',
	          cellCount: columnCount,
	          overscanCellsCount: overscanColumnCount,
	          scrollDirection: scrollDirectionHorizontal,
	          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
	          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
	        });
	        var overscanRowIndices = overscanIndicesGetter({
	          direction: 'vertical',
	          cellCount: rowCount,
	          overscanCellsCount: overscanRowCount,
	          scrollDirection: scrollDirectionVertical,
	          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
	          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
	        }); // Store for _invokeOnGridRenderedHelper()
	
	        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
	        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
	        var rowStartIndex = overscanRowIndices.overscanStartIndex;
	        var rowStopIndex = overscanRowIndices.overscanStopIndex; // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
	
	        if (deferredMeasurementCache) {
	          // If rows have a dynamic height, scan the rows we are about to render.
	          // If any have not yet been measured, then we need to render all columns initially,
	          // Because the height of the row is equal to the tallest cell within that row,
	          // (And so we can't know the height without measuring all column-cells first).
	          if (!deferredMeasurementCache.hasFixedHeight()) {
	            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
	              if (!deferredMeasurementCache.has(rowIndex, 0)) {
	                columnStartIndex = 0;
	                columnStopIndex = columnCount - 1;
	                break;
	              }
	            }
	          } // If columns have a dynamic width, scan the columns we are about to render.
	          // If any have not yet been measured, then we need to render all rows initially,
	          // Because the width of the column is equal to the widest cell within that column,
	          // (And so we can't know the width without measuring all row-cells first).
	
	
	          if (!deferredMeasurementCache.hasFixedWidth()) {
	            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
	              if (!deferredMeasurementCache.has(0, columnIndex)) {
	                rowStartIndex = 0;
	                rowStopIndex = rowCount - 1;
	                break;
	              }
	            }
	          }
	        }
	
	        this._childrenToDisplay = cellRangeRenderer({
	          cellCache: this._cellCache,
	          cellRenderer: cellRenderer,
	          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
	          columnStartIndex: columnStartIndex,
	          columnStopIndex: columnStopIndex,
	          deferredMeasurementCache: deferredMeasurementCache,
	          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
	          isScrolling: isScrolling,
	          isScrollingOptOut: isScrollingOptOut,
	          parent: this,
	          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
	          rowStartIndex: rowStartIndex,
	          rowStopIndex: rowStopIndex,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          styleCache: this._styleCache,
	          verticalOffsetAdjustment: verticalOffsetAdjustment,
	          visibleColumnIndices: visibleColumnIndices,
	          visibleRowIndices: visibleRowIndices
	        }); // update the indices
	
	        this._columnStartIndex = columnStartIndex;
	        this._columnStopIndex = columnStopIndex;
	        this._rowStartIndex = rowStartIndex;
	        this._rowStopIndex = rowStopIndex;
	      }
	    }
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Grid.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: "_debounceScrollEnded",
	    value: function _debounceScrollEnded() {
	      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
	
	      if (this._disablePointerEventsTimeoutId) {
	        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = (0, _requestAnimationTimeout.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
	    }
	  }, {
	    key: "_handleInvalidatedGridSize",
	
	    /**
	     * Check for batched CellMeasurer size invalidations.
	     * This will occur the first time one or more previously unmeasured cells are rendered.
	     */
	    value: function _handleInvalidatedGridSize() {
	      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
	        var columnIndex = this._deferredInvalidateColumnIndex;
	        var rowIndex = this._deferredInvalidateRowIndex;
	        this._deferredInvalidateColumnIndex = null;
	        this._deferredInvalidateRowIndex = null;
	        this.recomputeGridSize({
	          columnIndex: columnIndex,
	          rowIndex: rowIndex
	        });
	      }
	    }
	  }, {
	    key: "_invokeOnScrollMemoizer",
	    value: function _invokeOnScrollMemoizer(_ref6) {
	      var _this3 = this;
	
	      var scrollLeft = _ref6.scrollLeft,
	          scrollTop = _ref6.scrollTop,
	          totalColumnsWidth = _ref6.totalColumnsWidth,
	          totalRowsHeight = _ref6.totalRowsHeight;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref7) {
	          var scrollLeft = _ref7.scrollLeft,
	              scrollTop = _ref7.scrollTop;
	          var _this3$props = _this3.props,
	              height = _this3$props.height,
	              onScroll = _this3$props.onScroll,
	              width = _this3$props.width;
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalRowsHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalColumnsWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: "_isScrolling",
	    value: function _isScrolling() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      // If isScrolling is defined in props, use it to override the value in state
	      // This is a performance optimization for WindowScroller + Grid
	      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
	    }
	  }, {
	    key: "_maybeCallOnScrollbarPresenceChange",
	    value: function _maybeCallOnScrollbarPresenceChange() {
	      if (this._scrollbarPresenceChanged) {
	        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
	        this._scrollbarPresenceChanged = false;
	        onScrollbarPresenceChange({
	          horizontal: this._horizontalScrollBarSize > 0,
	          size: this.state.instanceProps.scrollbarSize,
	          vertical: this._verticalScrollBarSize > 0
	        });
	      }
	    }
	  }, {
	    key: "scrollToPosition",
	
	    /**
	     * Scroll to the specified offset(s).
	     * Useful for animating position changes.
	     */
	    value: function scrollToPosition(_ref8) {
	      var scrollLeft = _ref8.scrollLeft,
	          scrollTop = _ref8.scrollTop;
	
	      var stateUpdate = Grid._getScrollToPositionStateUpdate({
	        prevState: this.state,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      });
	
	      if (stateUpdate) {
	        stateUpdate.needToResetStyleCache = false;
	        this.setState(stateUpdate);
	      }
	    }
	  }, {
	    key: "_getCalculatedScrollLeft",
	    value: function _getCalculatedScrollLeft() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      return Grid._getCalculatedScrollLeft(props, state);
	    }
	  }, {
	    key: "_updateScrollLeftForScrollToColumn",
	    value: function _updateScrollLeftForScrollToColumn() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	
	      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
	
	      if (stateUpdate) {
	        stateUpdate.needToResetStyleCache = false;
	        this.setState(stateUpdate);
	      }
	    }
	  }, {
	    key: "_getCalculatedScrollTop",
	    value: function _getCalculatedScrollTop() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      return Grid._getCalculatedScrollTop(props, state);
	    }
	  }, {
	    key: "_resetStyleCache",
	    value: function _resetStyleCache() {
	      var styleCache = this._styleCache;
	      var cellCache = this._cellCache;
	      var isScrollingOptOut = this.props.isScrollingOptOut; // Reset cell and style caches once scrolling stops.
	      // This makes Grid simpler to use (since cells commonly change).
	      // And it keeps the caches from growing too large.
	      // Performance is most sensitive when a user is scrolling.
	      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
	      // This keeps the cellCache to a resonable size.
	
	      this._cellCache = {};
	      this._styleCache = {}; // Copy over the visible cell styles so avoid unnecessary re-render.
	
	      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
	        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
	          var key = "".concat(rowIndex, "-").concat(columnIndex);
	          this._styleCache[key] = styleCache[key];
	
	          if (isScrollingOptOut) {
	            this._cellCache[key] = cellCache[key];
	          }
	        }
	      }
	    }
	  }, {
	    key: "_updateScrollTopForScrollToRow",
	    value: function _updateScrollTopForScrollToRow() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	
	      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
	
	      if (stateUpdate) {
	        stateUpdate.needToResetStyleCache = false;
	        this.setState(stateUpdate);
	      }
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var newState = {};
	
	      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
	        newState.scrollLeft = 0;
	        newState.scrollTop = 0; // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
	        // scrollTo{Column,Row} should override scroll{Left,Top}
	      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
	        Object.assign(newState, Grid._getScrollToPositionStateUpdate({
	          prevState: prevState,
	          scrollLeft: nextProps.scrollLeft,
	          scrollTop: nextProps.scrollTop
	        }));
	      }
	
	      var instanceProps = prevState.instanceProps; // Initially we should not clearStyleCache
	
	      newState.needToResetStyleCache = false;
	
	      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
	        // Reset cache. set it to {} in render
	        newState.needToResetStyleCache = true;
	      }
	
	      instanceProps.columnSizeAndPositionManager.configure({
	        cellCount: nextProps.columnCount,
	        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
	        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
	      });
	      instanceProps.rowSizeAndPositionManager.configure({
	        cellCount: nextProps.rowCount,
	        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
	        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
	      });
	
	      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
	        instanceProps.prevColumnCount = 0;
	        instanceProps.prevRowCount = 0;
	      } // If scrolling is controlled outside this component, clear cache when scrolling stops
	
	
	      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
	        Object.assign(newState, {
	          isScrolling: false
	        });
	      }
	
	      var maybeStateA;
	      var maybeStateB;
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
	        cellCount: instanceProps.prevColumnCount,
	        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return instanceProps.columnSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.columnCount,
	        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
	        nextScrollToIndex: nextProps.scrollToColumn,
	        scrollToIndex: instanceProps.prevScrollToColumn,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
	        }
	      });
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
	        cellCount: instanceProps.prevRowCount,
	        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return instanceProps.rowSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.rowCount,
	        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
	        nextScrollToIndex: nextProps.scrollToRow,
	        scrollToIndex: instanceProps.prevScrollToRow,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
	        }
	      });
	      instanceProps.prevColumnCount = nextProps.columnCount;
	      instanceProps.prevColumnWidth = nextProps.columnWidth;
	      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
	      instanceProps.prevRowCount = nextProps.rowCount;
	      instanceProps.prevRowHeight = nextProps.rowHeight;
	      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
	      instanceProps.prevScrollToRow = nextProps.scrollToRow; // getting scrollBarSize (moved from componentWillMount)
	
	      instanceProps.scrollbarSize = nextProps.getScrollbarSize();
	
	      if (instanceProps.scrollbarSize === undefined) {
	        instanceProps.scrollbarSizeMeasured = false;
	        instanceProps.scrollbarSize = 0;
	      } else {
	        instanceProps.scrollbarSizeMeasured = true;
	      }
	
	      newState.instanceProps = instanceProps;
	      return _objectSpread({}, newState, {}, maybeStateA, {}, maybeStateB);
	    }
	  }, {
	    key: "_getEstimatedColumnSize",
	    value: function _getEstimatedColumnSize(props) {
	      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
	    }
	  }, {
	    key: "_getEstimatedRowSize",
	    value: function _getEstimatedRowSize(props) {
	      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
	    }
	  }, {
	    key: "_getScrollToPositionStateUpdate",
	
	    /**
	     * Get the updated state after scrolling to
	     * scrollLeft and scrollTop
	     */
	    value: function _getScrollToPositionStateUpdate(_ref9) {
	      var prevState = _ref9.prevState,
	          scrollLeft = _ref9.scrollLeft,
	          scrollTop = _ref9.scrollTop;
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
	        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (typeof scrollTop === 'number' && scrollTop >= 0) {
	        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollTop = scrollTop;
	      }
	
	      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
	        return newState;
	      }
	
	      return {};
	    }
	  }, {
	    key: "_wrapSizeGetter",
	    value: function _wrapSizeGetter(value) {
	      return typeof value === 'function' ? value : function () {
	        return value;
	      };
	    }
	  }, {
	    key: "_getCalculatedScrollLeft",
	    value: function _getCalculatedScrollLeft(nextProps, prevState) {
	      var columnCount = nextProps.columnCount,
	          height = nextProps.height,
	          scrollToAlignment = nextProps.scrollToAlignment,
	          scrollToColumn = nextProps.scrollToColumn,
	          width = nextProps.width;
	      var scrollLeft = prevState.scrollLeft,
	          instanceProps = prevState.instanceProps;
	
	      if (columnCount > 0) {
	        var finalColumn = columnCount - 1;
	        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
	        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
	        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
	        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: width - scrollBarSize,
	          currentOffset: scrollLeft,
	          targetIndex: targetIndex
	        });
	      }
	
	      return 0;
	    }
	  }, {
	    key: "_getScrollLeftForScrollToColumnStateUpdate",
	    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
	      var scrollLeft = prevState.scrollLeft;
	
	      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
	
	      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
	        return Grid._getScrollToPositionStateUpdate({
	          prevState: prevState,
	          scrollLeft: calculatedScrollLeft,
	          scrollTop: -1
	        });
	      }
	
	      return {};
	    }
	  }, {
	    key: "_getCalculatedScrollTop",
	    value: function _getCalculatedScrollTop(nextProps, prevState) {
	      var height = nextProps.height,
	          rowCount = nextProps.rowCount,
	          scrollToAlignment = nextProps.scrollToAlignment,
	          scrollToRow = nextProps.scrollToRow,
	          width = nextProps.width;
	      var scrollTop = prevState.scrollTop,
	          instanceProps = prevState.instanceProps;
	
	      if (rowCount > 0) {
	        var finalRow = rowCount - 1;
	        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
	        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
	        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
	        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: height - scrollBarSize,
	          currentOffset: scrollTop,
	          targetIndex: targetIndex
	        });
	      }
	
	      return 0;
	    }
	  }, {
	    key: "_getScrollTopForScrollToRowStateUpdate",
	    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
	      var scrollTop = prevState.scrollTop;
	
	      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
	
	      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
	        return Grid._getScrollToPositionStateUpdate({
	          prevState: prevState,
	          scrollLeft: -1,
	          scrollTop: calculatedScrollTop
	        });
	      }
	
	      return {};
	    }
	  }]);
	  return Grid;
	}(React.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes",  true ? null : {
	  "aria-label": _propTypes["default"].string.isRequired,
	  "aria-readonly": _propTypes["default"].bool,
	
	  /**
	   * Set the width of the inner scrollable container to 'auto'.
	   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
	   */
	  "autoContainerWidth": _propTypes["default"].bool.isRequired,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
	   * Intended for use with WindowScroller
	   */
	  "autoHeight": _propTypes["default"].bool.isRequired,
	
	  /**
	   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
	   * Intended for use with WindowScroller
	   */
	  "autoWidth": _propTypes["default"].bool.isRequired,
	
	  /** Responsible for rendering a cell given an row and column index.  */
	  "cellRenderer": function cellRenderer() {
	    return (typeof _types.bpfrpt_proptype_CellRenderer === "function" ? _types.bpfrpt_proptype_CellRenderer.isRequired ? _types.bpfrpt_proptype_CellRenderer.isRequired : _types.bpfrpt_proptype_CellRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
	  },
	
	  /** Responsible for rendering a group of cells given their index ranges.  */
	  "cellRangeRenderer": function cellRangeRenderer() {
	    return (typeof _types.bpfrpt_proptype_CellRangeRenderer === "function" ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired : _types.bpfrpt_proptype_CellRangeRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
	  },
	
	  /** Optional custom CSS class name to attach to root Grid element.  */
	  "className": _propTypes["default"].string,
	
	  /** Number of columns in grid.  */
	  "columnCount": _propTypes["default"].number.isRequired,
	
	  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
	  "columnWidth": function columnWidth() {
	    return (typeof _types.bpfrpt_proptype_CellSize === "function" ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
	  },
	
	  /** Unfiltered props for the Grid container. */
	  "containerProps": _propTypes["default"].object,
	
	  /** ARIA role for the cell-container.  */
	  "containerRole": _propTypes["default"].string.isRequired,
	
	  /** Optional inline style applied to inner cell-container */
	  "containerStyle": _propTypes["default"].object.isRequired,
	
	  /**
	   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
	   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
	   */
	  "deferredMeasurementCache": _propTypes["default"].object,
	
	  /**
	   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
	   * The estimated total width is adjusted as columns are rendered.
	   */
	  "estimatedColumnSize": _propTypes["default"].number.isRequired,
	
	  /**
	   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  "estimatedRowSize": _propTypes["default"].number.isRequired,
	
	  /** Exposed for testing purposes only.  */
	  "getScrollbarSize": _propTypes["default"].func.isRequired,
	
	  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
	  "height": _propTypes["default"].number.isRequired,
	
	  /** Optional custom id to attach to root Grid element.  */
	  "id": _propTypes["default"].string,
	
	  /**
	   * Override internal is-scrolling state tracking.
	   * This property is primarily intended for use with the WindowScroller component.
	   */
	  "isScrolling": _propTypes["default"].bool,
	
	  /**
	   * Opt-out of isScrolling param passed to cellRangeRenderer.
	   * To avoid the extra render when scroll stops.
	   */
	  "isScrollingOptOut": _propTypes["default"].bool.isRequired,
	
	  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
	  "noContentRenderer": function noContentRenderer() {
	    return (typeof _types.bpfrpt_proptype_NoContentRenderer === "function" ? _types.bpfrpt_proptype_NoContentRenderer.isRequired ? _types.bpfrpt_proptype_NoContentRenderer.isRequired : _types.bpfrpt_proptype_NoContentRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
	  },
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   */
	  "onScroll": _propTypes["default"].func.isRequired,
	
	  /**
	   * Called whenever a horizontal or vertical scrollbar is added or removed.
	   * This prop is not intended for end-user use;
	   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
	   */
	  "onScrollbarPresenceChange": _propTypes["default"].func.isRequired,
	
	  /** Callback invoked with information about the section of the Grid that was just rendered.  */
	  "onSectionRendered": _propTypes["default"].func.isRequired,
	
	  /**
	   * Number of columns to render before/after the visible section of the grid.
	   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  "overscanColumnCount": _propTypes["default"].number.isRequired,
	
	  /**
	   * Calculates the number of cells to overscan before and after a specified range.
	   * This function ensures that overscanning doesn't exceed the available cells.
	   */
	  "overscanIndicesGetter": function overscanIndicesGetter() {
	    return (typeof _types.bpfrpt_proptype_OverscanIndicesGetter === "function" ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _types.bpfrpt_proptype_OverscanIndicesGetter : _propTypes["default"].shape(_types.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
	  },
	
	  /**
	   * Number of rows to render above/below the visible section of the grid.
	   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  "overscanRowCount": _propTypes["default"].number.isRequired,
	
	  /** ARIA role for the grid element.  */
	  "role": _propTypes["default"].string.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * Should implement the following interface: ({ index: number }): number
	   */
	  "rowHeight": function rowHeight() {
	    return (typeof _types.bpfrpt_proptype_CellSize === "function" ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
	  },
	
	  /** Number of rows in grid.  */
	  "rowCount": _propTypes["default"].number.isRequired,
	
	  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
	  "scrollingResetTimeInterval": _propTypes["default"].number.isRequired,
	
	  /** Horizontal offset. */
	  "scrollLeft": _propTypes["default"].number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  "scrollToAlignment": function scrollToAlignment() {
	    return (typeof _types.bpfrpt_proptype_Alignment === "function" ? _types.bpfrpt_proptype_Alignment.isRequired ? _types.bpfrpt_proptype_Alignment.isRequired : _types.bpfrpt_proptype_Alignment : _propTypes["default"].shape(_types.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
	  },
	
	  /** Column index to ensure visible (by forcefully scrolling if necessary) */
	  "scrollToColumn": _propTypes["default"].number.isRequired,
	
	  /** Vertical offset. */
	  "scrollTop": _propTypes["default"].number,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  "scrollToRow": _propTypes["default"].number.isRequired,
	
	  /** Optional inline style */
	  "style": _propTypes["default"].object.isRequired,
	
	  /** Tab index for focus */
	  "tabIndex": _propTypes["default"].number,
	
	  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
	  "width": _propTypes["default"].number.isRequired
	}), _temp);
	(0, _defineProperty2["default"])(Grid, "defaultProps", {
	  'aria-label': 'grid',
	  'aria-readonly': true,
	  autoContainerWidth: false,
	  autoHeight: false,
	  autoWidth: false,
	  cellRangeRenderer: _defaultCellRangeRenderer["default"],
	  containerRole: 'rowgroup',
	  containerStyle: {},
	  estimatedColumnSize: 100,
	  estimatedRowSize: 30,
	  getScrollbarSize: _scrollbarSize["default"],
	  noContentRenderer: renderNull,
	  onScroll: function onScroll() {},
	  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
	  onSectionRendered: function onSectionRendered() {},
	  overscanColumnCount: 0,
	  overscanIndicesGetter: _defaultOverscanIndicesGetter["default"],
	  overscanRowCount: 10,
	  role: 'grid',
	  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
	  scrollToAlignment: 'auto',
	  scrollToColumn: -1,
	  scrollToRow: -1,
	  style: {},
	  tabIndex: 0,
	  isScrollingOptOut: false
	});
	(0, _reactLifecyclesCompat.polyfill)(Grid);
	var _default = Grid;
	exports["default"] = _default;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = defaultOverscanIndicesGetter;
	exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = void 0;
	
	var _types = __webpack_require__(67);
	
	var SCROLL_DIRECTION_BACKWARD = -1;
	exports.SCROLL_DIRECTION_BACKWARD = SCROLL_DIRECTION_BACKWARD;
	var SCROLL_DIRECTION_FORWARD = 1;
	exports.SCROLL_DIRECTION_FORWARD = SCROLL_DIRECTION_FORWARD;
	var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
	exports.SCROLL_DIRECTION_HORIZONTAL = SCROLL_DIRECTION_HORIZONTAL;
	var SCROLL_DIRECTION_VERTICAL = 'vertical';
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 */
	
	exports.SCROLL_DIRECTION_VERTICAL = SCROLL_DIRECTION_VERTICAL;
	
	function defaultOverscanIndicesGetter(_ref) {
	  var cellCount = _ref.cellCount,
	      overscanCellsCount = _ref.overscanCellsCount,
	      scrollDirection = _ref.scrollDirection,
	      startIndex = _ref.startIndex,
	      stopIndex = _ref.stopIndex;
	  // Make sure we render at least 1 cell extra before and after (except near boundaries)
	  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
	  // For more info see issues #625
	  overscanCellsCount = Math.max(1, overscanCellsCount);
	
	  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
	    return {
	      overscanStartIndex: Math.max(0, startIndex - 1),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
	    };
	  } else {
	    return {
	      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
	    };
	  }
	}

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grid["default"];
	  }
	});
	Object.defineProperty(exports, "Grid", {
	  enumerable: true,
	  get: function get() {
	    return _Grid["default"];
	  }
	});
	Object.defineProperty(exports, "accessibilityOverscanIndicesGetter", {
	  enumerable: true,
	  get: function get() {
	    return _accessibilityOverscanIndicesGetter["default"];
	  }
	});
	Object.defineProperty(exports, "defaultCellRangeRenderer", {
	  enumerable: true,
	  get: function get() {
	    return _defaultCellRangeRenderer["default"];
	  }
	});
	Object.defineProperty(exports, "defaultOverscanIndicesGetter", {
	  enumerable: true,
	  get: function get() {
	    return _defaultOverscanIndicesGetter["default"];
	  }
	});
	Object.defineProperty(exports, "bpfrpt_proptype_NoContentRenderer", {
	  enumerable: true,
	  get: function get() {
	    return _types.bpfrpt_proptype_NoContentRenderer;
	  }
	});
	Object.defineProperty(exports, "bpfrpt_proptype_Alignment", {
	  enumerable: true,
	  get: function get() {
	    return _types.bpfrpt_proptype_Alignment;
	  }
	});
	Object.defineProperty(exports, "bpfrpt_proptype_CellPosition", {
	  enumerable: true,
	  get: function get() {
	    return _types.bpfrpt_proptype_CellPosition;
	  }
	});
	Object.defineProperty(exports, "bpfrpt_proptype_CellSize", {
	  enumerable: true,
	  get: function get() {
	    return _types.bpfrpt_proptype_CellSize;
	  }
	});
	Object.defineProperty(exports, "bpfrpt_proptype_OverscanIndicesGetter", {
	  enumerable: true,
	  get: function get() {
	    return _types.bpfrpt_proptype_OverscanIndicesGetter;
	  }
	});
	Object.defineProperty(exports, "bpfrpt_proptype_RenderedSection", {
	  enumerable: true,
	  get: function get() {
	    return _types.bpfrpt_proptype_RenderedSection;
	  }
	});
	Object.defineProperty(exports, "bpfrpt_proptype_CellRendererParams", {
	  enumerable: true,
	  get: function get() {
	    return _types.bpfrpt_proptype_CellRendererParams;
	  }
	});
	Object.defineProperty(exports, "bpfrpt_proptype_Scroll", {
	  enumerable: true,
	  get: function get() {
	    return _types.bpfrpt_proptype_Scroll;
	  }
	});
	
	var _Grid = _interopRequireDefault(__webpack_require__(1018));
	
	var _accessibilityOverscanIndicesGetter = _interopRequireDefault(__webpack_require__(1019));
	
	var _defaultCellRangeRenderer = _interopRequireDefault(__webpack_require__(434));
	
	var _defaultOverscanIndicesGetter = _interopRequireDefault(__webpack_require__(435));
	
	var _types = __webpack_require__(67);

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _types = __webpack_require__(67);
	
	/**
	 * Just-in-time calculates and caches size and position information for a collection of cells.
	 */
	var CellSizeAndPositionManager =
	/*#__PURE__*/
	function () {
	  // Cache of size and position data for cells, mapped by cell index.
	  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
	  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
	  // Used in deferred mode to track which cells have been queued for measurement.
	  function CellSizeAndPositionManager(_ref) {
	    var cellCount = _ref.cellCount,
	        cellSizeGetter = _ref.cellSizeGetter,
	        estimatedCellSize = _ref.estimatedCellSize;
	    (0, _classCallCheck2["default"])(this, CellSizeAndPositionManager);
	    (0, _defineProperty2["default"])(this, "_cellSizeAndPositionData", {});
	    (0, _defineProperty2["default"])(this, "_lastMeasuredIndex", -1);
	    (0, _defineProperty2["default"])(this, "_lastBatchedIndex", -1);
	    (0, _defineProperty2["default"])(this, "_cellCount", void 0);
	    (0, _defineProperty2["default"])(this, "_cellSizeGetter", void 0);
	    (0, _defineProperty2["default"])(this, "_estimatedCellSize", void 0);
	    this._cellSizeGetter = cellSizeGetter;
	    this._cellCount = cellCount;
	    this._estimatedCellSize = estimatedCellSize;
	  }
	
	  (0, _createClass2["default"])(CellSizeAndPositionManager, [{
	    key: "areOffsetsAdjusted",
	    value: function areOffsetsAdjusted() {
	      return false;
	    }
	  }, {
	    key: "configure",
	    value: function configure(_ref2) {
	      var cellCount = _ref2.cellCount,
	          estimatedCellSize = _ref2.estimatedCellSize,
	          cellSizeGetter = _ref2.cellSizeGetter;
	      this._cellCount = cellCount;
	      this._estimatedCellSize = estimatedCellSize;
	      this._cellSizeGetter = cellSizeGetter;
	    }
	  }, {
	    key: "getCellCount",
	    value: function getCellCount() {
	      return this._cellCount;
	    }
	  }, {
	    key: "getEstimatedCellSize",
	    value: function getEstimatedCellSize() {
	      return this._estimatedCellSize;
	    }
	  }, {
	    key: "getLastMeasuredIndex",
	    value: function getLastMeasuredIndex() {
	      return this._lastMeasuredIndex;
	    }
	  }, {
	    key: "getOffsetAdjustment",
	    value: function getOffsetAdjustment() {
	      return 0;
	    }
	    /**
	     * This method returns the size and position for the cell at the specified index.
	     * It just-in-time calculates (or used cached values) for cells leading up to the index.
	     */
	
	  }, {
	    key: "getSizeAndPositionOfCell",
	    value: function getSizeAndPositionOfCell(index) {
	      if (index < 0 || index >= this._cellCount) {
	        throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
	      }
	
	      if (index > this._lastMeasuredIndex) {
	        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
	
	        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
	          var size = this._cellSizeGetter({
	            index: i
	          }); // undefined or NaN probably means a logic error in the size getter.
	          // null means we're using CellMeasurer and haven't yet measured a given index.
	
	
	          if (size === undefined || isNaN(size)) {
	            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
	          } else if (size === null) {
	            this._cellSizeAndPositionData[i] = {
	              offset: offset,
	              size: 0
	            };
	            this._lastBatchedIndex = index;
	          } else {
	            this._cellSizeAndPositionData[i] = {
	              offset: offset,
	              size: size
	            };
	            offset += size;
	            this._lastMeasuredIndex = index;
	          }
	        }
	      }
	
	      return this._cellSizeAndPositionData[index];
	    }
	  }, {
	    key: "getSizeAndPositionOfLastMeasuredCell",
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
	        offset: 0,
	        size: 0
	      };
	    }
	    /**
	     * Total size of all cells being measured.
	     * This value will be completely estimated initially.
	     * As cells are measured, the estimate will be updated.
	     */
	
	  }, {
	    key: "getTotalSize",
	    value: function getTotalSize() {
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
	      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
	      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
	      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
	    }
	    /**
	     * Determines a new offset that ensures a certain cell is visible, given the current offset.
	     * If the cell is already visible then the current offset will be returned.
	     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	     *
	     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	     * @param containerSize Size (width or height) of the container viewport
	     * @param currentOffset Container's current (x or y) offset
	     * @param totalSize Total size (width or height) of all cells
	     * @return Offset to use to ensure the specified cell is visible
	     */
	
	  }, {
	    key: "getUpdatedOffsetForIndex",
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align,
	          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
	          containerSize = _ref3.containerSize,
	          currentOffset = _ref3.currentOffset,
	          targetIndex = _ref3.targetIndex;
	
	      if (containerSize <= 0) {
	        return 0;
	      }
	
	      var datum = this.getSizeAndPositionOfCell(targetIndex);
	      var maxOffset = datum.offset;
	      var minOffset = maxOffset - containerSize + datum.size;
	      var idealOffset;
	
	      switch (align) {
	        case 'start':
	          idealOffset = maxOffset;
	          break;
	
	        case 'end':
	          idealOffset = minOffset;
	          break;
	
	        case 'center':
	          idealOffset = maxOffset - (containerSize - datum.size) / 2;
	          break;
	
	        default:
	          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
	          break;
	      }
	
	      var totalSize = this.getTotalSize();
	      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
	    }
	  }, {
	    key: "getVisibleCellRange",
	    value: function getVisibleCellRange(params) {
	      var containerSize = params.containerSize,
	          offset = params.offset;
	      var totalSize = this.getTotalSize();
	
	      if (totalSize === 0) {
	        return {};
	      }
	
	      var maxOffset = offset + containerSize;
	
	      var start = this._findNearestCell(offset);
	
	      var datum = this.getSizeAndPositionOfCell(start);
	      offset = datum.offset + datum.size;
	      var stop = start;
	
	      while (offset < maxOffset && stop < this._cellCount - 1) {
	        stop++;
	        offset += this.getSizeAndPositionOfCell(stop).size;
	      }
	
	      return {
	        start: start,
	        stop: stop
	      };
	    }
	    /**
	     * Clear all cached values for cells after the specified index.
	     * This method should be called for any cell that has changed its size.
	     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
	     */
	
	  }, {
	    key: "resetCell",
	    value: function resetCell(index) {
	      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
	    }
	  }, {
	    key: "_binarySearch",
	    value: function _binarySearch(high, low, offset) {
	      while (low <= high) {
	        var middle = low + Math.floor((high - low) / 2);
	        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;
	
	        if (currentOffset === offset) {
	          return middle;
	        } else if (currentOffset < offset) {
	          low = middle + 1;
	        } else if (currentOffset > offset) {
	          high = middle - 1;
	        }
	      }
	
	      if (low > 0) {
	        return low - 1;
	      } else {
	        return 0;
	      }
	    }
	  }, {
	    key: "_exponentialSearch",
	    value: function _exponentialSearch(index, offset) {
	      var interval = 1;
	
	      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
	        index += interval;
	        interval *= 2;
	      }
	
	      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
	    }
	    /**
	     * Searches for the cell (index) nearest the specified offset.
	     *
	     * If no exact match is found the next lowest cell index will be returned.
	     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
	     */
	
	  }, {
	    key: "_findNearestCell",
	    value: function _findNearestCell(offset) {
	      if (isNaN(offset)) {
	        throw Error("Invalid offset ".concat(offset, " specified"));
	      } // Our search algorithms find the nearest match at or below the specified offset.
	      // So make sure the offset is at least 0 or no match will be found.
	
	
	      offset = Math.max(0, offset);
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
	
	      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
	        // If we've already measured cells within this range just use a binary search as it's faster.
	        return this._binarySearch(lastMeasuredIndex, 0, offset);
	      } else {
	        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
	        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
	        // The overall complexity for this approach is O(log n).
	        return this._exponentialSearch(lastMeasuredIndex, offset);
	      }
	    }
	  }]);
	  return CellSizeAndPositionManager;
	}();
	
	exports["default"] = CellSizeAndPositionManager;

/***/ },
/* 1022 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = calculateSizeAndPositionDataAndUpdateScrollOffset;
	
	/**
	 * Helper method that determines when to recalculate row or column metadata.
	 */
	function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
	  var cellCount = _ref.cellCount,
	      cellSize = _ref.cellSize,
	      computeMetadataCallback = _ref.computeMetadataCallback,
	      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
	      nextCellsCount = _ref.nextCellsCount,
	      nextCellSize = _ref.nextCellSize,
	      nextScrollToIndex = _ref.nextScrollToIndex,
	      scrollToIndex = _ref.scrollToIndex,
	      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
	
	  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
	  // In that event users should use the manual recompute methods to inform of changes.
	  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
	    computeMetadataCallback(computeMetadataCallbackProps); // Updated cell metadata may have hidden the previous scrolled-to item.
	    // In this case we should also update the scrollTop to ensure it stays visible.
	
	    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
	      updateScrollOffsetForScrollToIndex();
	    }
	  }
	}

/***/ },
/* 1023 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMaxElementSize = void 0;
	var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
	var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
	
	var isBrowser = function isBrowser() {
	  return typeof window !== 'undefined';
	};
	
	var isChrome = function isChrome() {
	  return !!window.chrome;
	};
	
	var getMaxElementSize = function getMaxElementSize() {
	  if (isBrowser()) {
	    if (isChrome()) {
	      return CHROME_MAX_ELEMENT_SIZE;
	    }
	  }
	
	  return DEFAULT_MAX_ELEMENT_SIZE;
	};
	
	exports.getMaxElementSize = getMaxElementSize;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = updateScrollIndexHelper;
	
	var _ScalingCellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(172));
	
	var _types = __webpack_require__(67);
	
	function updateScrollIndexHelper(_ref) {
	  var cellSize = _ref.cellSize,
	      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
	      previousCellsCount = _ref.previousCellsCount,
	      previousCellSize = _ref.previousCellSize,
	      previousScrollToAlignment = _ref.previousScrollToAlignment,
	      previousScrollToIndex = _ref.previousScrollToIndex,
	      previousSize = _ref.previousSize,
	      scrollOffset = _ref.scrollOffset,
	      scrollToAlignment = _ref.scrollToAlignment,
	      scrollToIndex = _ref.scrollToIndex,
	      size = _ref.size,
	      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
	      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
	  var cellCount = cellSizeAndPositionManager.getCellCount();
	  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
	  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize; // If we have a new scroll target OR if height/row-height has changed,
	  // We should ensure that the scroll target is visible.
	
	  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
	    updateScrollIndexCallback(scrollToIndex); // If we don't have a selected item but list size or number of children have decreased,
	    // Make sure we aren't scrolled too far past the current content.
	  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
	    // We need to ensure that the current scroll offset is still within the collection's range.
	    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
	    // Just check to make sure we're still okay.
	    // Only adjust the scroll position if we've scrolled below the last set of rows.
	    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
	      updateScrollIndexCallback(cellCount - 1);
	    }
	  }
	}

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	var _interopRequireWildcard = __webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(68));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(21));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(109));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(108));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(23));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(19));
	
	var _Grid = _interopRequireWildcard(__webpack_require__(1020));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _clsx = _interopRequireDefault(__webpack_require__(213));
	
	var _types = __webpack_require__(436);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var _class, _temp;
	
	var List = (_temp = _class =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  (0, _inherits2["default"])(List, _React$PureComponent);
	
	  function List() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, List);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(List)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "Grid", void 0);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellRenderer", function (_ref) {
	      var parent = _ref.parent,
	          rowIndex = _ref.rowIndex,
	          style = _ref.style,
	          isScrolling = _ref.isScrolling,
	          isVisible = _ref.isVisible,
	          key = _ref.key;
	      var rowRenderer = _this.props.rowRenderer; // TRICKY The style object is sometimes cached by Grid.
	      // This prevents new style objects from bypassing shallowCompare().
	      // However as of React 16, style props are auto-frozen (at least in dev mode)
	      // Check to make sure we can still modify the style before proceeding.
	      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
	
	      var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');
	
	      if (widthDescriptor && widthDescriptor.writable) {
	        // By default, List cells should be 100% width.
	        // This prevents them from flowing under a scrollbar (if present).
	        style.width = '100%';
	      }
	
	      return rowRenderer({
	        index: rowIndex,
	        style: style,
	        isScrolling: isScrolling,
	        isVisible: isVisible,
	        key: key,
	        parent: parent
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setRef", function (ref) {
	      _this.Grid = ref;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function (_ref2) {
	      var clientHeight = _ref2.clientHeight,
	          scrollHeight = _ref2.scrollHeight,
	          scrollTop = _ref2.scrollTop;
	      var onScroll = _this.props.onScroll;
	      onScroll({
	        clientHeight: clientHeight,
	        scrollHeight: scrollHeight,
	        scrollTop: scrollTop
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSectionRendered", function (_ref3) {
	      var rowOverscanStartIndex = _ref3.rowOverscanStartIndex,
	          rowOverscanStopIndex = _ref3.rowOverscanStopIndex,
	          rowStartIndex = _ref3.rowStartIndex,
	          rowStopIndex = _ref3.rowStopIndex;
	      var onRowsRendered = _this.props.onRowsRendered;
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(List, [{
	    key: "forceUpdateGrid",
	    value: function forceUpdateGrid() {
	      if (this.Grid) {
	        this.Grid.forceUpdate();
	      }
	    }
	    /** See Grid#getOffsetForCell */
	
	  }, {
	    key: "getOffsetForRow",
	    value: function getOffsetForRow(_ref4) {
	      var alignment = _ref4.alignment,
	          index = _ref4.index;
	
	      if (this.Grid) {
	        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
	          alignment: alignment,
	          rowIndex: index,
	          columnIndex: 0
	        }),
	            scrollTop = _this$Grid$getOffsetF.scrollTop;
	
	        return scrollTop;
	      }
	
	      return 0;
	    }
	    /** CellMeasurer compatibility */
	
	  }, {
	    key: "invalidateCellSizeAfterRender",
	    value: function invalidateCellSizeAfterRender(_ref5) {
	      var columnIndex = _ref5.columnIndex,
	          rowIndex = _ref5.rowIndex;
	
	      if (this.Grid) {
	        this.Grid.invalidateCellSizeAfterRender({
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	      }
	    }
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: "measureAllRows",
	    value: function measureAllRows() {
	      if (this.Grid) {
	        this.Grid.measureAllCells();
	      }
	    }
	    /** CellMeasurer compatibility */
	
	  }, {
	    key: "recomputeGridSize",
	    value: function recomputeGridSize() {
	      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref6$columnIndex = _ref6.columnIndex,
	          columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex,
	          _ref6$rowIndex = _ref6.rowIndex,
	          rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;
	
	      if (this.Grid) {
	        this.Grid.recomputeGridSize({
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	      }
	    }
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: "recomputeRowHeights",
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.recomputeGridSize({
	          rowIndex: index,
	          columnIndex: 0
	        });
	      }
	    }
	    /** See Grid#scrollToPosition */
	
	  }, {
	    key: "scrollToPosition",
	    value: function scrollToPosition() {
	      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.scrollToPosition({
	          scrollTop: scrollTop
	        });
	      }
	    }
	    /** See Grid#scrollToCell */
	
	  }, {
	    key: "scrollToRow",
	    value: function scrollToRow() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.scrollToCell({
	          columnIndex: 0,
	          rowIndex: index
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          className = _this$props.className,
	          noRowsRenderer = _this$props.noRowsRenderer,
	          scrollToIndex = _this$props.scrollToIndex,
	          width = _this$props.width;
	      var classNames = (0, _clsx["default"])('ReactVirtualized__List', className);
	      return React.createElement(_Grid["default"], (0, _extends2["default"])({}, this.props, {
	        autoContainerWidth: true,
	        cellRenderer: this._cellRenderer,
	        className: classNames,
	        columnWidth: width,
	        columnCount: 1,
	        noContentRenderer: noRowsRenderer,
	        onScroll: this._onScroll,
	        onSectionRendered: this._onSectionRendered,
	        ref: this._setRef,
	        scrollToRow: scrollToIndex
	      }));
	    }
	  }]);
	  return List;
	}(React.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes",  true ? null : {
	  "aria-label": _propTypes["default"].string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  "autoHeight": _propTypes["default"].bool.isRequired,
	
	  /** Optional CSS class name */
	  "className": _propTypes["default"].string,
	
	  /**
	   * Used to estimate the total height of a List before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  "estimatedRowSize": _propTypes["default"].number.isRequired,
	
	  /** Height constraint for list (determines how many actual rows are rendered) */
	  "height": _propTypes["default"].number.isRequired,
	
	  /** Optional renderer to be used in place of rows when rowCount is 0 */
	  "noRowsRenderer": function noRowsRenderer() {
	    return (typeof _Grid.bpfrpt_proptype_NoContentRenderer === "function" ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired : _Grid.bpfrpt_proptype_NoContentRenderer : _propTypes["default"].shape(_Grid.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
	  },
	
	  /** Callback invoked with information about the slice of rows that were just rendered.  */
	  "onRowsRendered": _propTypes["default"].func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   */
	  "onScroll": _propTypes["default"].func.isRequired,
	
	  /** See Grid#overscanIndicesGetter */
	  "overscanIndicesGetter": function overscanIndicesGetter() {
	    return (typeof _Grid.bpfrpt_proptype_OverscanIndicesGetter === "function" ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _Grid.bpfrpt_proptype_OverscanIndicesGetter : _propTypes["default"].shape(_Grid.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
	  },
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  "overscanRowCount": _propTypes["default"].number.isRequired,
	
	  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
	  "rowHeight": function rowHeight() {
	    return (typeof _Grid.bpfrpt_proptype_CellSize === "function" ? _Grid.bpfrpt_proptype_CellSize.isRequired ? _Grid.bpfrpt_proptype_CellSize.isRequired : _Grid.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_Grid.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
	  },
	
	  /** Responsible for rendering a row given an index; ({ index: number }): node */
	  "rowRenderer": function rowRenderer() {
	    return (typeof _types.bpfrpt_proptype_RowRenderer === "function" ? _types.bpfrpt_proptype_RowRenderer.isRequired ? _types.bpfrpt_proptype_RowRenderer.isRequired : _types.bpfrpt_proptype_RowRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
	  },
	
	  /** Number of rows in list. */
	  "rowCount": _propTypes["default"].number.isRequired,
	
	  /** See Grid#scrollToAlignment */
	  "scrollToAlignment": function scrollToAlignment() {
	    return (typeof _Grid.bpfrpt_proptype_Alignment === "function" ? _Grid.bpfrpt_proptype_Alignment.isRequired ? _Grid.bpfrpt_proptype_Alignment.isRequired : _Grid.bpfrpt_proptype_Alignment : _propTypes["default"].shape(_Grid.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
	  },
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  "scrollToIndex": _propTypes["default"].number.isRequired,
	
	  /** Vertical offset. */
	  "scrollTop": _propTypes["default"].number,
	
	  /** Optional inline style */
	  "style": _propTypes["default"].object.isRequired,
	
	  /** Tab index for focus */
	  "tabIndex": _propTypes["default"].number,
	
	  /** Width of list */
	  "width": _propTypes["default"].number.isRequired
	}), _temp);
	exports["default"] = List;
	(0, _defineProperty2["default"])(List, "defaultProps", {
	  autoHeight: false,
	  estimatedRowSize: 30,
	  onScroll: function onScroll() {},
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {},
	  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
	  overscanRowCount: 10,
	  scrollToAlignment: 'auto',
	  scrollToIndex: -1,
	  style: {}
	});

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _List["default"];
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _List["default"];
	  }
	});
	Object.defineProperty(exports, "bpfrpt_proptype_RowRendererParams", {
	  enumerable: true,
	  get: function get() {
	    return _types.bpfrpt_proptype_RowRendererParams;
	  }
	});
	
	var _List = _interopRequireDefault(__webpack_require__(1025));
	
	var _types = __webpack_require__(436);

/***/ },
/* 1027 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.caf = exports.raf = void 0;
	// Properly handle server-side rendering.
	var win;
	
	if (typeof window !== 'undefined') {
	  win = window;
	} else if (typeof self !== 'undefined') {
	  win = self;
	} else {
	  win = {};
	} // requestAnimationFrame() shim by Paul Irish
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
	
	var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
	  return win.setTimeout(callback, 1000 / 60);
	};
	
	var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
	  win.clearTimeout(id);
	};
	
	var raf = request;
	exports.raf = raf;
	var caf = cancel;
	exports.caf = caf;

/***/ },
/* 1028 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createCallbackMemoizer;
	
	/**
	 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
	 */
	function createCallbackMemoizer() {
	  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	  var cachedIndices = {};
	  return function (_ref) {
	    var callback = _ref.callback,
	        indices = _ref.indices;
	    var keys = Object.keys(indices);
	    var allInitialized = !requireAllKeys || keys.every(function (key) {
	      var value = indices[key];
	      return Array.isArray(value) ? value.length > 0 : value >= 0;
	    });
	    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
	      var cachedValue = cachedIndices[key];
	      var value = indices[key];
	      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
	    });
	    cachedIndices = indices;
	
	    if (allInitialized && indexChanged) {
	      callback(indices);
	    }
	  };
	}

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_AnimationTimeoutId = exports.requestAnimationTimeout = exports.cancelAnimationTimeout = void 0;
	
	var _animationFrame = __webpack_require__(1027);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(24));
	
	var bpfrpt_proptype_AnimationTimeoutId =  true ? null : {
	  "id": _propTypes["default"].number.isRequired
	};
	exports.bpfrpt_proptype_AnimationTimeoutId = bpfrpt_proptype_AnimationTimeoutId;
	
	var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
	  return (0, _animationFrame.caf)(frame.id);
	};
	/**
	 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
	 * When the delay time has been reached the function you're timing out will be called.
	 *
	 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
	 */
	
	
	exports.cancelAnimationTimeout = cancelAnimationTimeout;
	
	var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
	  var start; // wait for end of processing current event handler, because event handler may be long
	
	  Promise.resolve().then(function () {
	    start = Date.now();
	  });
	
	  var timeout = function timeout() {
	    if (Date.now() - start >= delay) {
	      callback.call();
	    } else {
	      frame.id = (0, _animationFrame.raf)(timeout);
	    }
	  };
	
	  var frame = {
	    id: (0, _animationFrame.raf)(timeout)
	  };
	  return frame;
	};
	
	exports.requestAnimationTimeout = requestAnimationTimeout;

/***/ },
/* 1030 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createDetectElementResize;
	
	/**
	 * Detect Element Resize.
	 * https://github.com/sdecima/javascript-detect-element-resize
	 * Sebastian Decima
	 *
	 * Forked from version 0.5.3; includes the following modifications:
	 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
	 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
	 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
	 * 4) Add nonce for style element.
	 * 5) Added support for injecting custom window object
	 **/
	function createDetectElementResize(nonce, hostWindow) {
	  // Check `document` and `window` in case of server-side rendering
	  var _window;
	
	  if (typeof hostWindow !== 'undefined') {
	    _window = hostWindow;
	  } else if (typeof window !== 'undefined') {
	    _window = window;
	  } else if (typeof self !== 'undefined') {
	    _window = self;
	  } else {
	    _window = global;
	  }
	
	  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;
	
	  if (!attachEvent) {
	    var requestFrame = function () {
	      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	        return _window.setTimeout(fn, 20);
	      };
	
	      return function (fn) {
	        return raf(fn);
	      };
	    }();
	
	    var cancelFrame = function () {
	      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	      return function (id) {
	        return cancel(id);
	      };
	    }();
	
	    var resetTriggers = function resetTriggers(element) {
	      var triggers = element.__resizeTriggers__,
	          expand = triggers.firstElementChild,
	          contract = triggers.lastElementChild,
	          expandChild = expand.firstElementChild;
	      contract.scrollLeft = contract.scrollWidth;
	      contract.scrollTop = contract.scrollHeight;
	      expandChild.style.width = expand.offsetWidth + 1 + 'px';
	      expandChild.style.height = expand.offsetHeight + 1 + 'px';
	      expand.scrollLeft = expand.scrollWidth;
	      expand.scrollTop = expand.scrollHeight;
	    };
	
	    var checkTriggers = function checkTriggers(element) {
	      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	    };
	
	    var scrollListener = function scrollListener(e) {
	      // Don't measure (which forces) reflow for scrolls that happen inside of children!
	      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
	        return;
	      }
	
	      var element = this;
	      resetTriggers(this);
	
	      if (this.__resizeRAF__) {
	        cancelFrame(this.__resizeRAF__);
	      }
	
	      this.__resizeRAF__ = requestFrame(function () {
	        if (checkTriggers(element)) {
	          element.__resizeLast__.width = element.offsetWidth;
	          element.__resizeLast__.height = element.offsetHeight;
	
	          element.__resizeListeners__.forEach(function (fn) {
	            fn.call(element, e);
	          });
	        }
	      });
	    };
	    /* Detect CSS Animations support to detect element display/re-attach */
	
	
	    var animation = false,
	        keyframeprefix = '',
	        animationstartevent = 'animationstart',
	        domPrefixes = 'Webkit Moz O ms'.split(' '),
	        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	        pfx = '';
	    {
	      var elm = _window.document.createElement('fakeelement');
	
	      if (elm.style.animationName !== undefined) {
	        animation = true;
	      }
	
	      if (animation === false) {
	        for (var i = 0; i < domPrefixes.length; i++) {
	          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	            pfx = domPrefixes[i];
	            keyframeprefix = '-' + pfx.toLowerCase() + '-';
	            animationstartevent = startEvents[i];
	            animation = true;
	            break;
	          }
	        }
	      }
	    }
	    var animationName = 'resizeanim';
	    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	  }
	
	  var createStyles = function createStyles(doc) {
	    if (!doc.getElementById('detectElementResize')) {
	      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	          head = doc.head || doc.getElementsByTagName('head')[0],
	          style = doc.createElement('style');
	      style.id = 'detectElementResize';
	      style.type = 'text/css';
	
	      if (nonce != null) {
	        style.setAttribute('nonce', nonce);
	      }
	
	      if (style.styleSheet) {
	        style.styleSheet.cssText = css;
	      } else {
	        style.appendChild(doc.createTextNode(css));
	      }
	
	      head.appendChild(style);
	    }
	  };
	
	  var addResizeListener = function addResizeListener(element, fn) {
	    if (attachEvent) {
	      element.attachEvent('onresize', fn);
	    } else {
	      if (!element.__resizeTriggers__) {
	        var doc = element.ownerDocument;
	
	        var elementStyle = _window.getComputedStyle(element);
	
	        if (elementStyle && elementStyle.position == 'static') {
	          element.style.position = 'relative';
	        }
	
	        createStyles(doc);
	        element.__resizeLast__ = {};
	        element.__resizeListeners__ = [];
	        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
	        var resizeTriggersHtml = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	
	        if (window.trustedTypes) {
	          var staticPolicy = trustedTypes.createPolicy('react-virtualized-auto-sizer', {
	            createHTML: function createHTML() {
	              return resizeTriggersHtml;
	            }
	          });
	          element.__resizeTriggers__.innerHTML = staticPolicy.createHTML('');
	        } else {
	          element.__resizeTriggers__.innerHTML = resizeTriggersHtml;
	        }
	
	        element.appendChild(element.__resizeTriggers__);
	        resetTriggers(element);
	        element.addEventListener('scroll', scrollListener, true);
	        /* Listen for a css animation to detect element display/re-attach */
	
	        if (animationstartevent) {
	          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
	            if (e.animationName == animationName) {
	              resetTriggers(element);
	            }
	          };
	
	          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	        }
	      }
	
	      element.__resizeListeners__.push(fn);
	    }
	  };
	
	  var removeResizeListener = function removeResizeListener(element, fn) {
	    if (attachEvent) {
	      element.detachEvent('onresize', fn);
	    } else {
	      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	
	      if (!element.__resizeListeners__.length) {
	        element.removeEventListener('scroll', scrollListener, true);
	
	        if (element.__resizeTriggers__.__animationListener__) {
	          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	
	          element.__resizeTriggers__.__animationListener__ = null;
	        }
	
	        try {
	          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	        } catch (e) {// Preact compat; see developit/preact-compat/issues/228
	        }
	      }
	    }
	  };
	
	  return {
	    addResizeListener: addResizeListener,
	    removeResizeListener: removeResizeListener
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1031 */
/***/ function(module, exports) {

	/**
	 * @license React
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var l=Symbol.for("react.element"),n=Symbol.for("react.portal"),p=Symbol.for("react.fragment"),q=Symbol.for("react.strict_mode"),r=Symbol.for("react.profiler"),t=Symbol.for("react.provider"),u=Symbol.for("react.context"),v=Symbol.for("react.forward_ref"),w=Symbol.for("react.suspense"),x=Symbol.for("react.memo"),y=Symbol.for("react.lazy"),z=Symbol.iterator;function A(a){if(null===a||"object"!==typeof a)return null;a=z&&a[z]||a["@@iterator"];return"function"===typeof a?a:null}
	var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C=Object.assign,D={};function E(a,b,e){this.props=a;this.context=b;this.refs=D;this.updater=e||B}E.prototype.isReactComponent={};
	E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=D;this.updater=e||B}var H=G.prototype=new F;
	H.constructor=G;C(H,E.prototype);H.isPureReactComponent=!0;var I=Array.isArray,J=Object.prototype.hasOwnProperty,K={current:null},L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,e){var d,c={},k=null,h=null;if(null!=b)for(d in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)J.call(b,d)&&!L.hasOwnProperty(d)&&(c[d]=b[d]);var g=arguments.length-2;if(1===g)c.children=e;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];c.children=f}if(a&&a.defaultProps)for(d in g=a.defaultProps,g)void 0===c[d]&&(c[d]=g[d]);return{$$typeof:l,type:a,key:k,ref:h,props:c,_owner:K.current}}
	function N(a,b){return{$$typeof:l,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===l}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g;function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
	function R(a,b,e,d,c){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case l:case n:h=!0}}if(h)return h=a,c=c(h),a=""===d?"."+Q(h,0):d,I(c)?(e="",null!=a&&(e=a.replace(P,"$&/")+"/"),R(c,b,e,"",function(a){return a})):null!=c&&(O(c)&&(c=N(c,e+(!c.key||h&&h.key===c.key?"":(""+c.key).replace(P,"$&/")+"/")+a)),b.push(c)),1;h=0;d=""===d?".":d+":";if(I(a))for(var g=0;g<a.length;g++){k=
	a[g];var f=d+Q(k,g);h+=R(k,b,e,f,c)}else if(f=A(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=d+Q(k,g++),h+=R(k,b,e,f,c);else if("object"===k)throw b=String(a),Error("Objects are not valid as a React child (found: "+("[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b)+"). If you meant to render a collection of children, use an array instead.");return h}
	function S(a,b,e){if(null==a)return a;var d=[],c=0;R(a,d,"","",function(a){return b.call(e,a,c++)});return d}function T(a){if(-1===a._status){var b=a._result;b=b();b.then(function(b){if(0===a._status||-1===a._status)a._status=1,a._result=b},function(b){if(0===a._status||-1===a._status)a._status=2,a._result=b});-1===a._status&&(a._status=0,a._result=b)}if(1===a._status)return a._result.default;throw a._result;}
	var U={current:null},V={transition:null},W={ReactCurrentDispatcher:U,ReactCurrentBatchConfig:V,ReactCurrentOwner:K};function X(){throw Error("act(...) is not supported in production builds of React.");}
	exports.Children={map:S,forEach:function(a,b,e){S(a,function(){b.apply(this,arguments)},e)},count:function(a){var b=0;S(a,function(){b++});return b},toArray:function(a){return S(a,function(a){return a})||[]},only:function(a){if(!O(a))throw Error("React.Children.only expected to receive a single React element child.");return a}};exports.Component=E;exports.Fragment=p;exports.Profiler=r;exports.PureComponent=G;exports.StrictMode=q;exports.Suspense=w;
	exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=W;exports.act=X;
	exports.cloneElement=function(a,b,e){if(null===a||void 0===a)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+a+".");var d=C({},a.props),c=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=K.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)J.call(b,f)&&!L.hasOwnProperty(f)&&(d[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){g=Array(f);
	for(var m=0;m<f;m++)g[m]=arguments[m+2];d.children=g}return{$$typeof:l,type:a.type,key:c,ref:k,props:d,_owner:h}};exports.createContext=function(a){a={$$typeof:u,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null};a.Provider={$$typeof:t,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};
	exports.forwardRef=function(a){return{$$typeof:v,render:a}};exports.isValidElement=O;exports.lazy=function(a){return{$$typeof:y,_payload:{_status:-1,_result:a},_init:T}};exports.memo=function(a,b){return{$$typeof:x,type:a,compare:void 0===b?null:b}};exports.startTransition=function(a){var b=V.transition;V.transition={};try{a()}finally{V.transition=b}};exports.unstable_act=X;exports.useCallback=function(a,b){return U.current.useCallback(a,b)};exports.useContext=function(a){return U.current.useContext(a)};
	exports.useDebugValue=function(){};exports.useDeferredValue=function(a){return U.current.useDeferredValue(a)};exports.useEffect=function(a,b){return U.current.useEffect(a,b)};exports.useId=function(){return U.current.useId()};exports.useImperativeHandle=function(a,b,e){return U.current.useImperativeHandle(a,b,e)};exports.useInsertionEffect=function(a,b){return U.current.useInsertionEffect(a,b)};exports.useLayoutEffect=function(a,b){return U.current.useLayoutEffect(a,b)};
	exports.useMemo=function(a,b){return U.current.useMemo(a,b)};exports.useReducer=function(a,b,e){return U.current.useReducer(a,b,e)};exports.useRef=function(a){return U.current.useRef(a)};exports.useState=function(a){return U.current.useState(a)};exports.useSyncExternalStore=function(a,b,e){return U.current.useSyncExternalStore(a,b,e)};exports.useTransition=function(){return U.current.useTransition()};exports.version="18.3.1";


/***/ },
/* 1032 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/** A function that accepts a potential "extra argument" value to be injected later,
	 * and returns an instance of the thunk middleware that uses that value
	 */
	function createThunkMiddleware(extraArgument) {
	  // Standard Redux middleware definition pattern:
	  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
	  var middleware = function middleware(_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
	        // If this "action" is really a function, call it and return the result.
	        if (typeof action === 'function') {
	          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
	          return action(dispatch, getState, extraArgument);
	        } // Otherwise, pass the action down the middleware chain as usual
	
	
	        return next(action);
	      };
	    };
	  };
	
	  return middleware;
	}
	
	var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
	// with whatever "extra arg" they want to inject into their thunks
	
	thunk.withExtraArgument = createThunkMiddleware;
	var _default = thunk;
	exports.default = _default;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1034 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1034);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(99)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.prototype = Object.create(Buffer.prototype)
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {/**
	 * @license React
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';function f(a,b){var c=a.length;a.push(b);a:for(;0<c;){var d=c-1>>>1,e=a[d];if(0<g(e,b))a[d]=b,a[c]=e,c=d;else break a}}function h(a){return 0===a.length?null:a[0]}function k(a){if(0===a.length)return null;var b=a[0],c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length,w=e>>>1;d<w;){var m=2*(d+1)-1,C=a[m],n=m+1,x=a[n];if(0>g(C,c))n<e&&0>g(x,C)?(a[d]=x,a[n]=c,d=n):(a[d]=C,a[m]=c,d=m);else if(n<e&&0>g(x,c))a[d]=x,a[n]=c,d=n;else break a}}return b}
	function g(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()}}else{var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q}}var r=[],t=[],u=1,v=null,y=3,z=!1,A=!1,B=!1,D="function"===typeof setTimeout?setTimeout:null,E="function"===typeof clearTimeout?clearTimeout:null,F="undefined"!==typeof setImmediate?setImmediate:null;
	"undefined"!==typeof navigator&&void 0!==navigator.scheduling&&void 0!==navigator.scheduling.isInputPending&&navigator.scheduling.isInputPending.bind(navigator.scheduling);function G(a){for(var b=h(t);null!==b;){if(null===b.callback)k(t);else if(b.startTime<=a)k(t),b.sortIndex=b.expirationTime,f(r,b);else break;b=h(t)}}function H(a){B=!1;G(a);if(!A)if(null!==h(r))A=!0,I(J);else{var b=h(t);null!==b&&K(H,b.startTime-a)}}
	function J(a,b){A=!1;B&&(B=!1,E(L),L=-1);z=!0;var c=y;try{G(b);for(v=h(r);null!==v&&(!(v.expirationTime>b)||a&&!M());){var d=v.callback;if("function"===typeof d){v.callback=null;y=v.priorityLevel;var e=d(v.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?v.callback=e:v===h(r)&&k(r);G(b)}else k(r);v=h(r)}if(null!==v)var w=!0;else{var m=h(t);null!==m&&K(H,m.startTime-b);w=!1}return w}finally{v=null,y=c,z=!1}}var N=!1,O=null,L=-1,P=5,Q=-1;
	function M(){return exports.unstable_now()-Q<P?!1:!0}function R(){if(null!==O){var a=exports.unstable_now();Q=a;var b=!0;try{b=O(!0,a)}finally{b?S():(N=!1,O=null)}}else N=!1}var S;if("function"===typeof F)S=function(){F(R)};else if("undefined"!==typeof MessageChannel){var T=new MessageChannel,U=T.port2;T.port1.onmessage=R;S=function(){U.postMessage(null)}}else S=function(){D(R,0)};function I(a){O=a;N||(N=!0,S())}function K(a,b){L=D(function(){a(exports.unstable_now())},b)}
	exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){A||z||(A=!0,I(J))};
	exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):P=0<a?Math.floor(1E3/a):5};exports.unstable_getCurrentPriorityLevel=function(){return y};exports.unstable_getFirstCallbackNode=function(){return h(r)};exports.unstable_next=function(a){switch(y){case 1:case 2:case 3:var b=3;break;default:b=y}var c=y;y=b;try{return a()}finally{y=c}};exports.unstable_pauseExecution=function(){};
	exports.unstable_requestPaint=function(){};exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=y;y=a;try{return b()}finally{y=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3}e=c+e;a={id:u++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,f(t,a),null===h(r)&&a===h(t)&&(B?(E(L),L=-1):B=!0,K(H,c-d))):(a.sortIndex=e,f(r,a),A||z||(A=!0,I(J)));return a};
	exports.unstable_shouldYield=M;exports.unstable_wrapCallback=function(a){var b=y;return function(){var c=y;y=b;try{return a.apply(this,arguments)}finally{y=c}}};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1135).setImmediate))

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1037);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(396)))

/***/ },
/* 1040 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(1036).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var A11y = {
	  getRandomNumber: function getRandomNumber(size) {
	    if (size === void 0) {
	      size = 16;
	    }
	
	    var randomChar = function randomChar() {
	      return Math.round(16 * Math.random()).toString(16);
	    };
	
	    return 'x'.repeat(size).replace(/x/g, randomChar);
	  },
	  makeElFocusable: function makeElFocusable($el) {
	    $el.attr('tabIndex', '0');
	    return $el;
	  },
	  makeElNotFocusable: function makeElNotFocusable($el) {
	    $el.attr('tabIndex', '-1');
	    return $el;
	  },
	  addElRole: function addElRole($el, role) {
	    $el.attr('role', role);
	    return $el;
	  },
	  addElRoleDescription: function addElRoleDescription($el, description) {
	    $el.attr('aria-roledescription', description);
	    return $el;
	  },
	  addElControls: function addElControls($el, controls) {
	    $el.attr('aria-controls', controls);
	    return $el;
	  },
	  addElLabel: function addElLabel($el, label) {
	    $el.attr('aria-label', label);
	    return $el;
	  },
	  addElId: function addElId($el, id) {
	    $el.attr('id', id);
	    return $el;
	  },
	  addElLive: function addElLive($el, live) {
	    $el.attr('aria-live', live);
	    return $el;
	  },
	  disableEl: function disableEl($el) {
	    $el.attr('aria-disabled', true);
	    return $el;
	  },
	  enableEl: function enableEl($el) {
	    $el.attr('aria-disabled', false);
	    return $el;
	  },
	  onEnterOrSpaceKey: function onEnterOrSpaceKey(e) {
	    if (e.keyCode !== 13 && e.keyCode !== 32) return;
	    var swiper = this;
	    var params = swiper.params.a11y;
	    var $targetEl = (0, _dom.default)(e.target);
	
	    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
	      if (!(swiper.isEnd && !swiper.params.loop)) {
	        swiper.slideNext();
	      }
	
	      if (swiper.isEnd) {
	        swiper.a11y.notify(params.lastSlideMessage);
	      } else {
	        swiper.a11y.notify(params.nextSlideMessage);
	      }
	    }
	
	    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
	      if (!(swiper.isBeginning && !swiper.params.loop)) {
	        swiper.slidePrev();
	      }
	
	      if (swiper.isBeginning) {
	        swiper.a11y.notify(params.firstSlideMessage);
	      } else {
	        swiper.a11y.notify(params.prevSlideMessage);
	      }
	    }
	
	    if (swiper.pagination && $targetEl.is((0, _utils.classesToSelector)(swiper.params.pagination.bulletClass))) {
	      $targetEl[0].click();
	    }
	  },
	  notify: function notify(message) {
	    var swiper = this;
	    var notification = swiper.a11y.liveRegion;
	    if (notification.length === 0) return;
	    notification.html('');
	    notification.html(message);
	  },
	  updateNavigation: function updateNavigation() {
	    var swiper = this;
	    if (swiper.params.loop || !swiper.navigation) return;
	    var _swiper$navigation = swiper.navigation,
	        $nextEl = _swiper$navigation.$nextEl,
	        $prevEl = _swiper$navigation.$prevEl;
	
	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        swiper.a11y.disableEl($prevEl);
	        swiper.a11y.makeElNotFocusable($prevEl);
	      } else {
	        swiper.a11y.enableEl($prevEl);
	        swiper.a11y.makeElFocusable($prevEl);
	      }
	    }
	
	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        swiper.a11y.disableEl($nextEl);
	        swiper.a11y.makeElNotFocusable($nextEl);
	      } else {
	        swiper.a11y.enableEl($nextEl);
	        swiper.a11y.makeElFocusable($nextEl);
	      }
	    }
	  },
	  updatePagination: function updatePagination() {
	    var swiper = this;
	    var params = swiper.params.a11y;
	
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.bullets.each(function (bulletEl) {
	        var $bulletEl = (0, _dom.default)(bulletEl);
	        swiper.a11y.makeElFocusable($bulletEl);
	
	        if (!swiper.params.pagination.renderBullet) {
	          swiper.a11y.addElRole($bulletEl, 'button');
	          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
	        }
	      });
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.a11y;
	    swiper.$el.append(swiper.a11y.liveRegion); // Container
	
	    var $containerEl = swiper.$el;
	
	    if (params.containerRoleDescriptionMessage) {
	      swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
	    }
	
	    if (params.containerMessage) {
	      swiper.a11y.addElLabel($containerEl, params.containerMessage);
	    } // Wrapper
	
	
	    var $wrapperEl = swiper.$wrapperEl;
	    var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
	    var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
	    swiper.a11y.addElId($wrapperEl, wrapperId);
	    swiper.a11y.addElLive($wrapperEl, live); // Slide
	
	    if (params.itemRoleDescriptionMessage) {
	      swiper.a11y.addElRoleDescription((0, _dom.default)(swiper.slides), params.itemRoleDescriptionMessage);
	    }
	
	    swiper.a11y.addElRole((0, _dom.default)(swiper.slides), params.slideRole);
	    var slidesLength = swiper.params.loop ? swiper.slides.filter(function (el) {
	      return !el.classList.contains(swiper.params.slideDuplicateClass);
	    }).length : swiper.slides.length;
	    swiper.slides.each(function (slideEl, index) {
	      var $slideEl = (0, _dom.default)(slideEl);
	      var slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
	      var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
	      swiper.a11y.addElLabel($slideEl, ariaLabelMessage);
	    }); // Navigation
	
	    var $nextEl;
	    var $prevEl;
	
	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }
	
	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }
	
	    if ($nextEl && $nextEl.length) {
	      swiper.a11y.makeElFocusable($nextEl);
	
	      if ($nextEl[0].tagName !== 'BUTTON') {
	        swiper.a11y.addElRole($nextEl, 'button');
	        $nextEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
	      }
	
	      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
	      swiper.a11y.addElControls($nextEl, wrapperId);
	    }
	
	    if ($prevEl && $prevEl.length) {
	      swiper.a11y.makeElFocusable($prevEl);
	
	      if ($prevEl[0].tagName !== 'BUTTON') {
	        swiper.a11y.addElRole($prevEl, 'button');
	        $prevEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
	      }
	
	      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
	      swiper.a11y.addElControls($prevEl, wrapperId);
	    } // Pagination
	
	
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.on('keydown', (0, _utils.classesToSelector)(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
	    var $nextEl;
	    var $prevEl;
	
	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }
	
	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }
	
	    if ($nextEl) {
	      $nextEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
	    }
	
	    if ($prevEl) {
	      $prevEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
	    } // Pagination
	
	
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.off('keydown', (0, _utils.classesToSelector)(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
	    }
	  }
	};
	var _default = {
	  name: 'a11y',
	  params: {
	    a11y: {
	      enabled: true,
	      notificationClass: 'swiper-notification',
	      prevSlideMessage: 'Previous slide',
	      nextSlideMessage: 'Next slide',
	      firstSlideMessage: 'This is the first slide',
	      lastSlideMessage: 'This is the last slide',
	      paginationBulletMessage: 'Go to slide {{index}}',
	      slideLabelMessage: '{{index}} / {{slidesLength}}',
	      containerMessage: null,
	      containerRoleDescriptionMessage: null,
	      itemRoleDescriptionMessage: null,
	      slideRole: 'group'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      a11y: _extends({}, A11y, {
	        liveRegion: (0, _dom.default)("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
	      })
	    });
	  },
	  on: {
	    afterInit: function afterInit(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.init();
	      swiper.a11y.updateNavigation();
	    },
	    toEdge: function toEdge(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.updateNavigation();
	    },
	    fromEdge: function fromEdge(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.updateNavigation();
	    },
	    paginationUpdate: function paginationUpdate(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.updatePagination();
	    },
	    destroy: function destroy(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.destroy();
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _utils = __webpack_require__(26);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Autoplay = {
	  run: function run() {
	    var swiper = this;
	    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
	    var delay = swiper.params.autoplay.delay;
	
	    if ($activeSlideEl.attr('data-swiper-autoplay')) {
	      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
	    }
	
	    clearTimeout(swiper.autoplay.timeout);
	    swiper.autoplay.timeout = (0, _utils.nextTick)(function () {
	      var autoplayResult;
	
	      if (swiper.params.autoplay.reverseDirection) {
	        if (swiper.params.loop) {
	          swiper.loopFix();
	          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.isBeginning) {
	          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.params.autoplay.stopOnLastSlide) {
	          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else {
	          swiper.autoplay.stop();
	        }
	      } else if (swiper.params.loop) {
	        swiper.loopFix();
	        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else if (!swiper.isEnd) {
	        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else if (!swiper.params.autoplay.stopOnLastSlide) {
	        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else {
	        swiper.autoplay.stop();
	      }
	
	      if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();else if (autoplayResult === false) {
	        swiper.autoplay.run();
	      }
	    }, delay);
	  },
	  start: function start() {
	    var swiper = this;
	    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
	    if (swiper.autoplay.running) return false;
	    swiper.autoplay.running = true;
	    swiper.emit('autoplayStart');
	    swiper.autoplay.run();
	    return true;
	  },
	  stop: function stop() {
	    var swiper = this;
	    if (!swiper.autoplay.running) return false;
	    if (typeof swiper.autoplay.timeout === 'undefined') return false;
	
	    if (swiper.autoplay.timeout) {
	      clearTimeout(swiper.autoplay.timeout);
	      swiper.autoplay.timeout = undefined;
	    }
	
	    swiper.autoplay.running = false;
	    swiper.emit('autoplayStop');
	    return true;
	  },
	  pause: function pause(speed) {
	    var swiper = this;
	    if (!swiper.autoplay.running) return;
	    if (swiper.autoplay.paused) return;
	    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
	    swiper.autoplay.paused = true;
	
	    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
	      swiper.autoplay.paused = false;
	      swiper.autoplay.run();
	    } else {
	      ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
	        swiper.$wrapperEl[0].addEventListener(event, swiper.autoplay.onTransitionEnd);
	      });
	    }
	  },
	  onVisibilityChange: function onVisibilityChange() {
	    var swiper = this;
	    var document = (0, _ssrWindow.getDocument)();
	
	    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
	      swiper.autoplay.pause();
	    }
	
	    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
	      swiper.autoplay.run();
	      swiper.autoplay.paused = false;
	    }
	  },
	  onTransitionEnd: function onTransitionEnd(e) {
	    var swiper = this;
	    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
	    if (e.target !== swiper.$wrapperEl[0]) return;
	    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
	      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
	    });
	    swiper.autoplay.paused = false;
	
	    if (!swiper.autoplay.running) {
	      swiper.autoplay.stop();
	    } else {
	      swiper.autoplay.run();
	    }
	  },
	  onMouseEnter: function onMouseEnter() {
	    var swiper = this;
	
	    if (swiper.params.autoplay.disableOnInteraction) {
	      swiper.autoplay.stop();
	    } else {
	      swiper.autoplay.pause();
	    }
	
	    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
	      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
	    });
	  },
	  onMouseLeave: function onMouseLeave() {
	    var swiper = this;
	
	    if (swiper.params.autoplay.disableOnInteraction) {
	      return;
	    }
	
	    swiper.autoplay.paused = false;
	    swiper.autoplay.run();
	  },
	  attachMouseEvents: function attachMouseEvents() {
	    var swiper = this;
	
	    if (swiper.params.autoplay.pauseOnMouseEnter) {
	      swiper.$el.on('mouseenter', swiper.autoplay.onMouseEnter);
	      swiper.$el.on('mouseleave', swiper.autoplay.onMouseLeave);
	    }
	  },
	  detachMouseEvents: function detachMouseEvents() {
	    var swiper = this;
	    swiper.$el.off('mouseenter', swiper.autoplay.onMouseEnter);
	    swiper.$el.off('mouseleave', swiper.autoplay.onMouseLeave);
	  }
	};
	var _default = {
	  name: 'autoplay',
	  params: {
	    autoplay: {
	      enabled: false,
	      delay: 3000,
	      waitForTransition: true,
	      disableOnInteraction: true,
	      stopOnLastSlide: false,
	      reverseDirection: false,
	      pauseOnMouseEnter: false
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      autoplay: _extends({}, Autoplay, {
	        running: false,
	        paused: false
	      })
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (swiper.params.autoplay.enabled) {
	        swiper.autoplay.start();
	        var document = (0, _ssrWindow.getDocument)();
	        document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
	        swiper.autoplay.attachMouseEvents();
	      }
	    },
	    beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
	      if (swiper.autoplay.running) {
	        if (internal || !swiper.params.autoplay.disableOnInteraction) {
	          swiper.autoplay.pause(speed);
	        } else {
	          swiper.autoplay.stop();
	        }
	      }
	    },
	    sliderFirstMove: function sliderFirstMove(swiper) {
	      if (swiper.autoplay.running) {
	        if (swiper.params.autoplay.disableOnInteraction) {
	          swiper.autoplay.stop();
	        } else {
	          swiper.autoplay.pause();
	        }
	      }
	    },
	    touchEnd: function touchEnd(swiper) {
	      if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
	        swiper.autoplay.run();
	      }
	    },
	    destroy: function destroy(swiper) {
	      swiper.autoplay.detachMouseEvents();
	
	      if (swiper.autoplay.running) {
	        swiper.autoplay.stop();
	      }
	
	      var document = (0, _ssrWindow.getDocument)();
	      document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(26);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Controller = {
	  LinearSpline: function LinearSpline(x, y) {
	    var binarySearch = function search() {
	      var maxIndex;
	      var minIndex;
	      var guess;
	      return function (array, val) {
	        minIndex = -1;
	        maxIndex = array.length;
	
	        while (maxIndex - minIndex > 1) {
	          guess = maxIndex + minIndex >> 1;
	
	          if (array[guess] <= val) {
	            minIndex = guess;
	          } else {
	            maxIndex = guess;
	          }
	        }
	
	        return maxIndex;
	      };
	    }();
	
	    this.x = x;
	    this.y = y;
	    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
	    // (x1,y1) is the known point before given value,
	    // (x3,y3) is the known point after given value.
	
	    var i1;
	    var i3;
	
	    this.interpolate = function interpolate(x2) {
	      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	
	      i3 = binarySearch(this.x, x2);
	      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
	      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	
	      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
	    };
	
	    return this;
	  },
	  // xxx: for now i will just save one spline function to to
	  getInterpolateFunction: function getInterpolateFunction(c) {
	    var swiper = this;
	
	    if (!swiper.controller.spline) {
	      swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
	    }
	  },
	  setTranslate: function setTranslate(_setTranslate, byController) {
	    var swiper = this;
	    var controlled = swiper.controller.control;
	    var multiplier;
	    var controlledTranslate;
	    var Swiper = swiper.constructor;
	
	    function setControlledTranslate(c) {
	      // this will create an Interpolate function based on the snapGrids
	      // x is the Grid of the scrolled scroller and y will be the controlled scroller
	      // it makes sense to create this only once and recall it for the interpolation
	      // the function does a lot of value caching for performance
	      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
	
	      if (swiper.params.controller.by === 'slide') {
	        swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	        // but it did not work out
	
	        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
	      }
	
	      if (!controlledTranslate || swiper.params.controller.by === 'container') {
	        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
	        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
	      }
	
	      if (swiper.params.controller.inverse) {
	        controlledTranslate = c.maxTranslate() - controlledTranslate;
	      }
	
	      c.updateProgress(controlledTranslate);
	      c.setTranslate(controlledTranslate, swiper);
	      c.updateActiveIndex();
	      c.updateSlidesClasses();
	    }
	
	    if (Array.isArray(controlled)) {
	      for (var i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTranslate(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTranslate(controlled);
	    }
	  },
	  setTransition: function setTransition(duration, byController) {
	    var swiper = this;
	    var Swiper = swiper.constructor;
	    var controlled = swiper.controller.control;
	    var i;
	
	    function setControlledTransition(c) {
	      c.setTransition(duration, swiper);
	
	      if (duration !== 0) {
	        c.transitionStart();
	
	        if (c.params.autoHeight) {
	          (0, _utils.nextTick)(function () {
	            c.updateAutoHeight();
	          });
	        }
	
	        c.$wrapperEl.transitionEnd(function () {
	          if (!controlled) return;
	
	          if (c.params.loop && swiper.params.controller.by === 'slide') {
	            c.loopFix();
	          }
	
	          c.transitionEnd();
	        });
	      }
	    }
	
	    if (Array.isArray(controlled)) {
	      for (i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTransition(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTransition(controlled);
	    }
	  }
	};
	var _default = {
	  name: 'controller',
	  params: {
	    controller: {
	      control: undefined,
	      inverse: false,
	      by: 'slide' // or 'container'
	
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      controller: _extends({
	        control: swiper.params.controller.control
	      }, Controller)
	    });
	  },
	  on: {
	    update: function update(swiper) {
	      if (!swiper.controller.control) return;
	
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    resize: function resize(swiper) {
	      if (!swiper.controller.control) return;
	
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    observerUpdate: function observerUpdate(swiper) {
	      if (!swiper.controller.control) return;
	
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    setTranslate: function setTranslate(swiper, translate, byController) {
	      if (!swiper.controller.control) return;
	      swiper.controller.setTranslate(translate, byController);
	    },
	    setTransition: function setTransition(swiper, duration, byController) {
	      if (!swiper.controller.control) return;
	      swiper.controller.setTransition(duration, byController);
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getBreakpoint;
	
	var _ssrWindow = __webpack_require__(41);
	
	function getBreakpoint(breakpoints, base, containerEl) {
	  if (base === void 0) {
	    base = 'window';
	  }
	
	  if (!breakpoints || base === 'container' && !containerEl) return undefined;
	  var breakpoint = false;
	  var window = (0, _ssrWindow.getWindow)();
	  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
	  var points = Object.keys(breakpoints).map(function (point) {
	    if (typeof point === 'string' && point.indexOf('@') === 0) {
	      var minRatio = parseFloat(point.substr(1));
	      var value = currentHeight * minRatio;
	      return {
	        value: value,
	        point: point
	      };
	    }
	
	    return {
	      value: point,
	      point: point
	    };
	  });
	  points.sort(function (a, b) {
	    return parseInt(a.value, 10) - parseInt(b.value, 10);
	  });
	
	  for (var i = 0; i < points.length; i += 1) {
	    var _points$i = points[i],
	        point = _points$i.point,
	        value = _points$i.value;
	
	    if (base === 'window') {
	      if (window.matchMedia("(min-width: " + value + "px)").matches) {
	        breakpoint = point;
	      }
	    } else if (value <= containerEl.clientWidth) {
	      breakpoint = point;
	    }
	  }
	
	  return breakpoint || 'max';
	}

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _setBreakpoint = _interopRequireDefault(__webpack_require__(1047));
	
	var _getBreakpoint = _interopRequireDefault(__webpack_require__(1045));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  setBreakpoint: _setBreakpoint.default,
	  getBreakpoint: _getBreakpoint.default
	};
	exports.default = _default;

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = setBreakpoint;
	
	var _utils = __webpack_require__(26);
	
	function setBreakpoint() {
	  var swiper = this;
	  var activeIndex = swiper.activeIndex,
	      initialized = swiper.initialized,
	      _swiper$loopedSlides = swiper.loopedSlides,
	      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
	      params = swiper.params,
	      $el = swiper.$el;
	  var breakpoints = params.breakpoints;
	  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
	
	  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
	  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
	  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
	
	  if (breakpointOnlyParams) {
	    ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
	      var paramValue = breakpointOnlyParams[param];
	      if (typeof paramValue === 'undefined') return;
	
	      if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
	        breakpointOnlyParams[param] = 'auto';
	      } else if (param === 'slidesPerView') {
	        breakpointOnlyParams[param] = parseFloat(paramValue);
	      } else {
	        breakpointOnlyParams[param] = parseInt(paramValue, 10);
	      }
	    });
	  }
	
	  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
	  var wasMultiRow = params.slidesPerColumn > 1;
	  var isMultiRow = breakpointParams.slidesPerColumn > 1;
	  var wasEnabled = params.enabled;
	
	  if (wasMultiRow && !isMultiRow) {
	    $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
	    swiper.emitContainerClasses();
	  } else if (!wasMultiRow && isMultiRow) {
	    $el.addClass(params.containerModifierClass + "multirow");
	
	    if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') {
	      $el.addClass(params.containerModifierClass + "multirow-column");
	    }
	
	    swiper.emitContainerClasses();
	  }
	
	  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
	  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
	
	  if (directionChanged && initialized) {
	    swiper.changeDirection();
	  }
	
	  (0, _utils.extend)(swiper.params, breakpointParams);
	  var isEnabled = swiper.params.enabled;
	  (0, _utils.extend)(swiper, {
	    allowTouchMove: swiper.params.allowTouchMove,
	    allowSlideNext: swiper.params.allowSlideNext,
	    allowSlidePrev: swiper.params.allowSlidePrev
	  });
	
	  if (wasEnabled && !isEnabled) {
	    swiper.disable();
	  } else if (!wasEnabled && isEnabled) {
	    swiper.enable();
	  }
	
	  swiper.currentBreakpoint = breakpoint;
	  swiper.emit('_beforeBreakpoint', breakpointParams);
	
	  if (needsReLoop && initialized) {
	    swiper.loopDestroy();
	    swiper.loopCreate();
	    swiper.updateSlides();
	    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
	  }
	
	  swiper.emit('breakpoint', breakpointParams);
	}

/***/ },
/* 1048 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	function checkOverflow() {
	  var swiper = this;
	  var params = swiper.params;
	  var wasLocked = swiper.isLocked;
	  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;
	
	  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
	    swiper.isLocked = lastSlidePosition <= swiper.size;
	  } else {
	    swiper.isLocked = swiper.snapGrid.length === 1;
	  }
	
	  swiper.allowSlideNext = !swiper.isLocked;
	  swiper.allowSlidePrev = !swiper.isLocked; // events
	
	  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
	
	  if (wasLocked && wasLocked !== swiper.isLocked) {
	    swiper.isEnd = false;
	    if (swiper.navigation) swiper.navigation.update();
	  }
	}
	
	var _default = {
	  checkOverflow: checkOverflow
	};
	exports.default = _default;

/***/ },
/* 1049 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = addClasses;
	
	function prepareClasses(entries, prefix) {
	  var resultClasses = [];
	  entries.forEach(function (item) {
	    if (typeof item === 'object') {
	      Object.keys(item).forEach(function (classNames) {
	        if (item[classNames]) {
	          resultClasses.push(prefix + classNames);
	        }
	      });
	    } else if (typeof item === 'string') {
	      resultClasses.push(prefix + item);
	    }
	  });
	  return resultClasses;
	}
	
	function addClasses() {
	  var swiper = this;
	  var classNames = swiper.classNames,
	      params = swiper.params,
	      rtl = swiper.rtl,
	      $el = swiper.$el,
	      device = swiper.device,
	      support = swiper.support; // prettier-ignore
	
	  var suffixes = prepareClasses(['initialized', params.direction, {
	    'pointer-events': support.pointerEvents && !support.touch
	  }, {
	    'free-mode': params.freeMode
	  }, {
	    'autoheight': params.autoHeight
	  }, {
	    'rtl': rtl
	  }, {
	    'multirow': params.slidesPerColumn > 1
	  }, {
	    'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
	  }, {
	    'android': device.android
	  }, {
	    'ios': device.ios
	  }, {
	    'css-mode': params.cssMode
	  }], params.containerModifierClass);
	  classNames.push.apply(classNames, suffixes);
	  $el.addClass([].concat(classNames).join(' '));
	  swiper.emitContainerClasses();
	}

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClasses = _interopRequireDefault(__webpack_require__(1049));
	
	var _removeClasses = _interopRequireDefault(__webpack_require__(1051));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  addClasses: _addClasses.default,
	  removeClasses: _removeClasses.default
	};
	exports.default = _default;

/***/ },
/* 1051 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClasses;
	
	function removeClasses() {
	  var swiper = this;
	  var $el = swiper.$el,
	      classNames = swiper.classNames;
	  $el.removeClass(classNames.join(' '));
	  swiper.emitContainerClasses();
	}

/***/ },
/* 1052 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  init: true,
	  direction: 'horizontal',
	  touchEventsTarget: 'container',
	  initialSlide: 0,
	  speed: 300,
	  cssMode: false,
	  updateOnWindowResize: true,
	  resizeObserver: false,
	  nested: false,
	  createElements: false,
	  enabled: true,
	  focusableElements: 'input, select, option, textarea, button, video, label',
	  // Overrides
	  width: null,
	  height: null,
	  //
	  preventInteractionOnTransition: false,
	  // ssr
	  userAgent: null,
	  url: null,
	  // To support iOS's swipe-to-go-back gesture (when being used in-app).
	  edgeSwipeDetection: false,
	  edgeSwipeThreshold: 20,
	  // Free mode
	  freeMode: false,
	  freeModeMomentum: true,
	  freeModeMomentumRatio: 1,
	  freeModeMomentumBounce: true,
	  freeModeMomentumBounceRatio: 1,
	  freeModeMomentumVelocityRatio: 1,
	  freeModeSticky: false,
	  freeModeMinimumVelocity: 0.02,
	  // Autoheight
	  autoHeight: false,
	  // Set wrapper width
	  setWrapperSize: false,
	  // Virtual Translate
	  virtualTranslate: false,
	  // Effects
	  effect: 'slide',
	  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	  // Breakpoints
	  breakpoints: undefined,
	  breakpointsBase: 'window',
	  // Slides grid
	  spaceBetween: 0,
	  slidesPerView: 1,
	  slidesPerColumn: 1,
	  slidesPerColumnFill: 'column',
	  slidesPerGroup: 1,
	  slidesPerGroupSkip: 0,
	  centeredSlides: false,
	  centeredSlidesBounds: false,
	  slidesOffsetBefore: 0,
	  // in px
	  slidesOffsetAfter: 0,
	  // in px
	  normalizeSlideIndex: true,
	  centerInsufficientSlides: false,
	  // Disable swiper and hide navigation when container not overflow
	  watchOverflow: false,
	  // Round length
	  roundLengths: false,
	  // Touches
	  touchRatio: 1,
	  touchAngle: 45,
	  simulateTouch: true,
	  shortSwipes: true,
	  longSwipes: true,
	  longSwipesRatio: 0.5,
	  longSwipesMs: 300,
	  followFinger: true,
	  allowTouchMove: true,
	  threshold: 0,
	  touchMoveStopPropagation: false,
	  touchStartPreventDefault: true,
	  touchStartForcePreventDefault: false,
	  touchReleaseOnEdges: false,
	  // Unique Navigation Elements
	  uniqueNavElements: true,
	  // Resistance
	  resistance: true,
	  resistanceRatio: 0.85,
	  // Progress
	  watchSlidesProgress: false,
	  watchSlidesVisibility: false,
	  // Cursor
	  grabCursor: false,
	  // Clicks
	  preventClicks: true,
	  preventClicksPropagation: true,
	  slideToClickedSlide: false,
	  // Images
	  preloadImages: true,
	  updateOnImagesReady: true,
	  // loop
	  loop: false,
	  loopAdditionalSlides: 0,
	  loopedSlides: null,
	  loopFillGroupWithBlank: false,
	  loopPreventsSlide: true,
	  // Swiping/no swiping
	  allowSlidePrev: true,
	  allowSlideNext: true,
	  swipeHandler: null,
	  // '.swipe-handler',
	  noSwiping: true,
	  noSwipingClass: 'swiper-no-swiping',
	  noSwipingSelector: null,
	  // Passive Listeners
	  passiveListeners: true,
	  // NS
	  containerModifierClass: 'swiper-container-',
	  // NEW
	  slideClass: 'swiper-slide',
	  slideBlankClass: 'swiper-slide-invisible-blank',
	  slideActiveClass: 'swiper-slide-active',
	  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	  slideVisibleClass: 'swiper-slide-visible',
	  slideDuplicateClass: 'swiper-slide-duplicate',
	  slideNextClass: 'swiper-slide-next',
	  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	  slidePrevClass: 'swiper-slide-prev',
	  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	  wrapperClass: 'swiper-wrapper',
	  // Callbacks
	  runCallbacksOnInit: true,
	  // Internals
	  _emitClasses: false
	};
	exports.default = _default;

/***/ },
/* 1053 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	/* eslint-disable no-underscore-dangle */
	var _default = {
	  on: function on(events, handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') return self;
	    var method = priority ? 'unshift' : 'push';
	    events.split(' ').forEach(function (event) {
	      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
	      self.eventsListeners[event][method](handler);
	    });
	    return self;
	  },
	  once: function once(events, handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') return self;
	
	    function onceHandler() {
	      self.off(events, onceHandler);
	
	      if (onceHandler.__emitterProxy) {
	        delete onceHandler.__emitterProxy;
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      handler.apply(self, args);
	    }
	
	    onceHandler.__emitterProxy = handler;
	    return self.on(events, onceHandler, priority);
	  },
	  onAny: function onAny(handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') return self;
	    var method = priority ? 'unshift' : 'push';
	
	    if (self.eventsAnyListeners.indexOf(handler) < 0) {
	      self.eventsAnyListeners[method](handler);
	    }
	
	    return self;
	  },
	  offAny: function offAny(handler) {
	    var self = this;
	    if (!self.eventsAnyListeners) return self;
	    var index = self.eventsAnyListeners.indexOf(handler);
	
	    if (index >= 0) {
	      self.eventsAnyListeners.splice(index, 1);
	    }
	
	    return self;
	  },
	  off: function off(events, handler) {
	    var self = this;
	    if (!self.eventsListeners) return self;
	    events.split(' ').forEach(function (event) {
	      if (typeof handler === 'undefined') {
	        self.eventsListeners[event] = [];
	      } else if (self.eventsListeners[event]) {
	        self.eventsListeners[event].forEach(function (eventHandler, index) {
	          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
	            self.eventsListeners[event].splice(index, 1);
	          }
	        });
	      }
	    });
	    return self;
	  },
	  emit: function emit() {
	    var self = this;
	    if (!self.eventsListeners) return self;
	    var events;
	    var data;
	    var context;
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	      events = args[0];
	      data = args.slice(1, args.length);
	      context = self;
	    } else {
	      events = args[0].events;
	      data = args[0].data;
	      context = args[0].context || self;
	    }
	
	    data.unshift(context);
	    var eventsArray = Array.isArray(events) ? events : events.split(' ');
	    eventsArray.forEach(function (event) {
	      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
	        self.eventsAnyListeners.forEach(function (eventHandler) {
	          eventHandler.apply(context, [event].concat(data));
	        });
	      }
	
	      if (self.eventsListeners && self.eventsListeners[event]) {
	        self.eventsListeners[event].forEach(function (eventHandler) {
	          eventHandler.apply(context, data);
	        });
	      }
	    });
	    return self;
	  }
	};
	exports.default = _default;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _onTouchStart = _interopRequireDefault(__webpack_require__(1060));
	
	var _onTouchMove = _interopRequireDefault(__webpack_require__(1059));
	
	var _onTouchEnd = _interopRequireDefault(__webpack_require__(1058));
	
	var _onResize = _interopRequireDefault(__webpack_require__(1056));
	
	var _onClick = _interopRequireDefault(__webpack_require__(1055));
	
	var _onScroll = _interopRequireDefault(__webpack_require__(1057));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dummyEventAttached = false;
	
	function dummyEventListener() {}
	
	function attachEvents() {
	  var swiper = this;
	  var document = (0, _ssrWindow.getDocument)();
	  var params = swiper.params,
	      touchEvents = swiper.touchEvents,
	      el = swiper.el,
	      wrapperEl = swiper.wrapperEl,
	      device = swiper.device,
	      support = swiper.support;
	  swiper.onTouchStart = _onTouchStart.default.bind(swiper);
	  swiper.onTouchMove = _onTouchMove.default.bind(swiper);
	  swiper.onTouchEnd = _onTouchEnd.default.bind(swiper);
	
	  if (params.cssMode) {
	    swiper.onScroll = _onScroll.default.bind(swiper);
	  }
	
	  swiper.onClick = _onClick.default.bind(swiper);
	  var capture = !!params.nested; // Touch Events
	
	  if (!support.touch && support.pointerEvents) {
	    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
	    document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
	    document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
	  } else {
	    if (support.touch) {
	      var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
	        passive: true,
	        capture: false
	      } : false;
	      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	      el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
	        passive: false,
	        capture: capture
	      } : capture);
	      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	
	      if (touchEvents.cancel) {
	        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
	      }
	
	      if (!dummyEventAttached) {
	        document.addEventListener('touchstart', dummyEventListener);
	        dummyEventAttached = true;
	      }
	    }
	
	    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
	      el.addEventListener('mousedown', swiper.onTouchStart, false);
	      document.addEventListener('mousemove', swiper.onTouchMove, capture);
	      document.addEventListener('mouseup', swiper.onTouchEnd, false);
	    }
	  } // Prevent Links Clicks
	
	
	  if (params.preventClicks || params.preventClicksPropagation) {
	    el.addEventListener('click', swiper.onClick, true);
	  }
	
	  if (params.cssMode) {
	    wrapperEl.addEventListener('scroll', swiper.onScroll);
	  } // Resize handler
	
	
	  if (params.updateOnWindowResize) {
	    swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', _onResize.default, true);
	  } else {
	    swiper.on('observerUpdate', _onResize.default, true);
	  }
	}
	
	function detachEvents() {
	  var swiper = this;
	  var document = (0, _ssrWindow.getDocument)();
	  var params = swiper.params,
	      touchEvents = swiper.touchEvents,
	      el = swiper.el,
	      wrapperEl = swiper.wrapperEl,
	      device = swiper.device,
	      support = swiper.support;
	  var capture = !!params.nested; // Touch Events
	
	  if (!support.touch && support.pointerEvents) {
	    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
	    document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	    document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
	  } else {
	    if (support.touch) {
	      var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
	        passive: true,
	        capture: false
	      } : false;
	      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	
	      if (touchEvents.cancel) {
	        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
	      }
	    }
	
	    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
	      el.removeEventListener('mousedown', swiper.onTouchStart, false);
	      document.removeEventListener('mousemove', swiper.onTouchMove, capture);
	      document.removeEventListener('mouseup', swiper.onTouchEnd, false);
	    }
	  } // Prevent Links Clicks
	
	
	  if (params.preventClicks || params.preventClicksPropagation) {
	    el.removeEventListener('click', swiper.onClick, true);
	  }
	
	  if (params.cssMode) {
	    wrapperEl.removeEventListener('scroll', swiper.onScroll);
	  } // Resize handler
	
	
	  swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', _onResize.default);
	}
	
	var _default = {
	  attachEvents: attachEvents,
	  detachEvents: detachEvents
	};
	exports.default = _default;

/***/ },
/* 1055 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onClick;
	
	function onClick(e) {
	  var swiper = this;
	  if (!swiper.enabled) return;
	
	  if (!swiper.allowClick) {
	    if (swiper.params.preventClicks) e.preventDefault();
	
	    if (swiper.params.preventClicksPropagation && swiper.animating) {
	      e.stopPropagation();
	      e.stopImmediatePropagation();
	    }
	  }
	}

/***/ },
/* 1056 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onResize;
	
	function onResize() {
	  var swiper = this;
	  var params = swiper.params,
	      el = swiper.el;
	  if (el && el.offsetWidth === 0) return; // Breakpoints
	
	  if (params.breakpoints) {
	    swiper.setBreakpoint();
	  } // Save locks
	
	
	  var allowSlideNext = swiper.allowSlideNext,
	      allowSlidePrev = swiper.allowSlidePrev,
	      snapGrid = swiper.snapGrid; // Disable locks on resize
	
	  swiper.allowSlideNext = true;
	  swiper.allowSlidePrev = true;
	  swiper.updateSize();
	  swiper.updateSlides();
	  swiper.updateSlidesClasses();
	
	  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
	    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	  } else {
	    swiper.slideTo(swiper.activeIndex, 0, false, true);
	  }
	
	  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
	    swiper.autoplay.run();
	  } // Return locks after resize
	
	
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	
	  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
	    swiper.checkOverflow();
	  }
	}

/***/ },
/* 1057 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onScroll;
	
	function onScroll() {
	  var swiper = this;
	  var wrapperEl = swiper.wrapperEl,
	      rtlTranslate = swiper.rtlTranslate,
	      enabled = swiper.enabled;
	  if (!enabled) return;
	  swiper.previousTranslate = swiper.translate;
	
	  if (swiper.isHorizontal()) {
	    if (rtlTranslate) {
	      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
	    } else {
	      swiper.translate = -wrapperEl.scrollLeft;
	    }
	  } else {
	    swiper.translate = -wrapperEl.scrollTop;
	  } // eslint-disable-next-line
	
	
	  if (swiper.translate === -0) swiper.translate = 0;
	  swiper.updateActiveIndex();
	  swiper.updateSlidesClasses();
	  var newProgress;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	
	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
	  }
	
	  if (newProgress !== swiper.progress) {
	    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
	  }
	
	  swiper.emit('setTranslate', swiper.translate, false);
	}

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onTouchEnd;
	
	var _utils = __webpack_require__(26);
	
	function onTouchEnd(event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params,
	      touches = swiper.touches,
	      rtl = swiper.rtlTranslate,
	      $wrapperEl = swiper.$wrapperEl,
	      slidesGrid = swiper.slidesGrid,
	      snapGrid = swiper.snapGrid,
	      enabled = swiper.enabled;
	  if (!enabled) return;
	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;
	
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchEnd', e);
	  }
	
	  data.allowTouchCallbacks = false;
	
	  if (!data.isTouched) {
	    if (data.isMoved && params.grabCursor) {
	      swiper.setGrabCursor(false);
	    }
	
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  } // Return Grab Cursor
	
	
	  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	    swiper.setGrabCursor(false);
	  } // Time diff
	
	
	  var touchEndTime = (0, _utils.now)();
	  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
	
	  if (swiper.allowClick) {
	    swiper.updateClickedSlide(e);
	    swiper.emit('tap click', e);
	
	    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
	      swiper.emit('doubleTap doubleClick', e);
	    }
	  }
	
	  data.lastClickTime = (0, _utils.now)();
	  (0, _utils.nextTick)(function () {
	    if (!swiper.destroyed) swiper.allowClick = true;
	  });
	
	  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
	    data.isTouched = false;
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  }
	
	  data.isTouched = false;
	  data.isMoved = false;
	  data.startMoving = false;
	  var currentPos;
	
	  if (params.followFinger) {
	    currentPos = rtl ? swiper.translate : -swiper.translate;
	  } else {
	    currentPos = -data.currentTranslate;
	  }
	
	  if (params.cssMode) {
	    return;
	  }
	
	  if (params.freeMode) {
	    if (currentPos < -swiper.minTranslate()) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	
	    if (currentPos > -swiper.maxTranslate()) {
	      if (swiper.slides.length < snapGrid.length) {
	        swiper.slideTo(snapGrid.length - 1);
	      } else {
	        swiper.slideTo(swiper.slides.length - 1);
	      }
	
	      return;
	    }
	
	    if (params.freeModeMomentum) {
	      if (data.velocities.length > 1) {
	        var lastMoveEvent = data.velocities.pop();
	        var velocityEvent = data.velocities.pop();
	        var distance = lastMoveEvent.position - velocityEvent.position;
	        var time = lastMoveEvent.time - velocityEvent.time;
	        swiper.velocity = distance / time;
	        swiper.velocity /= 2;
	
	        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
	          swiper.velocity = 0;
	        } // this implies that the user stopped moving a finger then released.
	        // There would be no events with distance zero, so the last event is stale.
	
	
	        if (time > 150 || (0, _utils.now)() - lastMoveEvent.time > 300) {
	          swiper.velocity = 0;
	        }
	      } else {
	        swiper.velocity = 0;
	      }
	
	      swiper.velocity *= params.freeModeMomentumVelocityRatio;
	      data.velocities.length = 0;
	      var momentumDuration = 1000 * params.freeModeMomentumRatio;
	      var momentumDistance = swiper.velocity * momentumDuration;
	      var newPosition = swiper.translate + momentumDistance;
	      if (rtl) newPosition = -newPosition;
	      var doBounce = false;
	      var afterBouncePosition;
	      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
	      var needsLoopFix;
	
	      if (newPosition < swiper.maxTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
	            newPosition = swiper.maxTranslate() - bounceAmount;
	          }
	
	          afterBouncePosition = swiper.maxTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.maxTranslate();
	        }
	
	        if (params.loop && params.centeredSlides) needsLoopFix = true;
	      } else if (newPosition > swiper.minTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition - swiper.minTranslate() > bounceAmount) {
	            newPosition = swiper.minTranslate() + bounceAmount;
	          }
	
	          afterBouncePosition = swiper.minTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.minTranslate();
	        }
	
	        if (params.loop && params.centeredSlides) needsLoopFix = true;
	      } else if (params.freeModeSticky) {
	        var nextSlide;
	
	        for (var j = 0; j < snapGrid.length; j += 1) {
	          if (snapGrid[j] > -newPosition) {
	            nextSlide = j;
	            break;
	          }
	        }
	
	        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
	          newPosition = snapGrid[nextSlide];
	        } else {
	          newPosition = snapGrid[nextSlide - 1];
	        }
	
	        newPosition = -newPosition;
	      }
	
	      if (needsLoopFix) {
	        swiper.once('transitionEnd', function () {
	          swiper.loopFix();
	        });
	      } // Fix duration
	
	
	      if (swiper.velocity !== 0) {
	        if (rtl) {
	          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
	        } else {
	          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
	        }
	
	        if (params.freeModeSticky) {
	          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
	          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
	          // It's easy to see this when simulating touch with mouse events. To fix this,
	          // limit single-slide swipes to the default slide duration. This also has the
	          // nice side effect of matching slide speed if the user stopped moving before
	          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
	          // For faster swipes, also apply limits (albeit higher ones).
	          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
	          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
	
	          if (moveDistance < currentSlideSize) {
	            momentumDuration = params.speed;
	          } else if (moveDistance < 2 * currentSlideSize) {
	            momentumDuration = params.speed * 1.5;
	          } else {
	            momentumDuration = params.speed * 2.5;
	          }
	        }
	      } else if (params.freeModeSticky) {
	        swiper.slideToClosest();
	        return;
	      }
	
	      if (params.freeModeMomentumBounce && doBounce) {
	        swiper.updateProgress(afterBouncePosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);
	        swiper.animating = true;
	        $wrapperEl.transitionEnd(function () {
	          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
	          swiper.emit('momentumBounce');
	          swiper.setTransition(params.speed);
	          setTimeout(function () {
	            swiper.setTranslate(afterBouncePosition);
	            $wrapperEl.transitionEnd(function () {
	              if (!swiper || swiper.destroyed) return;
	              swiper.transitionEnd();
	            });
	          }, 0);
	        });
	      } else if (swiper.velocity) {
	        swiper.updateProgress(newPosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);
	
	        if (!swiper.animating) {
	          swiper.animating = true;
	          $wrapperEl.transitionEnd(function () {
	            if (!swiper || swiper.destroyed) return;
	            swiper.transitionEnd();
	          });
	        }
	      } else {
	        swiper.emit('_freeModeNoMomentumRelease');
	        swiper.updateProgress(newPosition);
	      }
	
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    } else if (params.freeModeSticky) {
	      swiper.slideToClosest();
	      return;
	    } else if (params.freeMode) {
	      swiper.emit('_freeModeNoMomentumRelease');
	    }
	
	    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
	      swiper.updateProgress();
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	
	    return;
	  } // Find current slide
	
	
	  var stopIndex = 0;
	  var groupSize = swiper.slidesSizesGrid[0];
	
	  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
	    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
	
	    if (typeof slidesGrid[i + _increment] !== 'undefined') {
	      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
	        stopIndex = i;
	        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
	      }
	    } else if (currentPos >= slidesGrid[i]) {
	      stopIndex = i;
	      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	    }
	  } // Find current slide size
	
	
	  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
	
	  if (timeDiff > params.longSwipesMs) {
	    // Long touches
	    if (!params.longSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	
	    if (swiper.swipeDirection === 'next') {
	      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
	    }
	
	    if (swiper.swipeDirection === 'prev') {
	      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
	    }
	  } else {
	    // Short swipes
	    if (!params.shortSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	
	    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
	
	    if (!isNavButtonTarget) {
	      if (swiper.swipeDirection === 'next') {
	        swiper.slideTo(stopIndex + increment);
	      }
	
	      if (swiper.swipeDirection === 'prev') {
	        swiper.slideTo(stopIndex);
	      }
	    } else if (e.target === swiper.navigation.nextEl) {
	      swiper.slideTo(stopIndex + increment);
	    } else {
	      swiper.slideTo(stopIndex);
	    }
	  }
	}

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onTouchMove;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function onTouchMove(event) {
	  var document = (0, _ssrWindow.getDocument)();
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params,
	      touches = swiper.touches,
	      rtl = swiper.rtlTranslate,
	      enabled = swiper.enabled;
	  if (!enabled) return;
	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;
	
	  if (!data.isTouched) {
	    if (data.startMoving && data.isScrolling) {
	      swiper.emit('touchMoveOpposite', e);
	    }
	
	    return;
	  }
	
	  if (data.isTouchEvent && e.type !== 'touchmove') return;
	  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
	  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
	  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
	
	  if (e.preventedByNestedSwiper) {
	    touches.startX = pageX;
	    touches.startY = pageY;
	    return;
	  }
	
	  if (!swiper.allowTouchMove) {
	    // isMoved = true;
	    swiper.allowClick = false;
	
	    if (data.isTouched) {
	      (0, _utils.extend)(touches, {
	        startX: pageX,
	        startY: pageY,
	        currentX: pageX,
	        currentY: pageY
	      });
	      data.touchStartTime = (0, _utils.now)();
	    }
	
	    return;
	  }
	
	  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
	    if (swiper.isVertical()) {
	      // Vertical
	      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
	        data.isTouched = false;
	        data.isMoved = false;
	        return;
	      }
	    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
	      return;
	    }
	  }
	
	  if (data.isTouchEvent && document.activeElement) {
	    if (e.target === document.activeElement && (0, _dom.default)(e.target).is(data.focusableElements)) {
	      data.isMoved = true;
	      swiper.allowClick = false;
	      return;
	    }
	  }
	
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchMove', e);
	  }
	
	  if (e.targetTouches && e.targetTouches.length > 1) return;
	  touches.currentX = pageX;
	  touches.currentY = pageY;
	  var diffX = touches.currentX - touches.startX;
	  var diffY = touches.currentY - touches.startY;
	  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
	
	  if (typeof data.isScrolling === 'undefined') {
	    var touchAngle;
	
	    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
	      data.isScrolling = false;
	    } else {
	      // eslint-disable-next-line
	      if (diffX * diffX + diffY * diffY >= 25) {
	        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
	        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
	      }
	    }
	  }
	
	  if (data.isScrolling) {
	    swiper.emit('touchMoveOpposite', e);
	  }
	
	  if (typeof data.startMoving === 'undefined') {
	    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	      data.startMoving = true;
	    }
	  }
	
	  if (data.isScrolling) {
	    data.isTouched = false;
	    return;
	  }
	
	  if (!data.startMoving) {
	    return;
	  }
	
	  swiper.allowClick = false;
	
	  if (!params.cssMode && e.cancelable) {
	    e.preventDefault();
	  }
	
	  if (params.touchMoveStopPropagation && !params.nested) {
	    e.stopPropagation();
	  }
	
	  if (!data.isMoved) {
	    if (params.loop) {
	      swiper.loopFix();
	    }
	
	    data.startTranslate = swiper.getTranslate();
	    swiper.setTransition(0);
	
	    if (swiper.animating) {
	      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
	    }
	
	    data.allowMomentumBounce = false; // Grab Cursor
	
	    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	      swiper.setGrabCursor(true);
	    }
	
	    swiper.emit('sliderFirstMove', e);
	  }
	
	  swiper.emit('sliderMove', e);
	  data.isMoved = true;
	  var diff = swiper.isHorizontal() ? diffX : diffY;
	  touches.diff = diff;
	  diff *= params.touchRatio;
	  if (rtl) diff = -diff;
	  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	  data.currentTranslate = diff + data.startTranslate;
	  var disableParentSwiper = true;
	  var resistanceRatio = params.resistanceRatio;
	
	  if (params.touchReleaseOnEdges) {
	    resistanceRatio = 0;
	  }
	
	  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
	  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
	  }
	
	  if (disableParentSwiper) {
	    e.preventedByNestedSwiper = true;
	  } // Directions locks
	
	
	  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	
	  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	
	  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
	    data.currentTranslate = data.startTranslate;
	  } // Threshold
	
	
	  if (params.threshold > 0) {
	    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	      if (!data.allowThresholdMove) {
	        data.allowThresholdMove = true;
	        touches.startX = touches.currentX;
	        touches.startY = touches.currentY;
	        data.currentTranslate = data.startTranslate;
	        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	        return;
	      }
	    } else {
	      data.currentTranslate = data.startTranslate;
	      return;
	    }
	  }
	
	  if (!params.followFinger || params.cssMode) return; // Update active index in free mode
	
	  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  }
	
	  if (params.freeMode) {
	    // Velocity
	    if (data.velocities.length === 0) {
	      data.velocities.push({
	        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
	        time: data.touchStartTime
	      });
	    }
	
	    data.velocities.push({
	      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
	      time: (0, _utils.now)()
	    });
	  } // Update progress
	
	
	  swiper.updateProgress(data.currentTranslate); // Update translate
	
	  swiper.setTranslate(data.currentTranslate);
	}

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = onTouchStart;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
	function closestElement(selector, base) {
	  if (base === void 0) {
	    base = this;
	  }
	
	  function __closestFrom(el) {
	    if (!el || el === (0, _ssrWindow.getDocument)() || el === (0, _ssrWindow.getWindow)()) return null;
	    if (el.assignedSlot) el = el.assignedSlot;
	    var found = el.closest(selector);
	    return found || __closestFrom(el.getRootNode().host);
	  }
	
	  return __closestFrom(base);
	}
	
	function onTouchStart(event) {
	  var swiper = this;
	  var document = (0, _ssrWindow.getDocument)();
	  var window = (0, _ssrWindow.getWindow)();
	  var data = swiper.touchEventsData;
	  var params = swiper.params,
	      touches = swiper.touches,
	      enabled = swiper.enabled;
	  if (!enabled) return;
	
	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return;
	  }
	
	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  var $targetEl = (0, _dom.default)(e.target);
	
	  if (params.touchEventsTarget === 'wrapper') {
	    if (!$targetEl.closest(swiper.wrapperEl).length) return;
	  }
	
	  data.isTouchEvent = e.type === 'touchstart';
	  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
	  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
	  if (data.isTouched && data.isMoved) return; // change target el for shadow root component
	
	  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
	
	  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
	    $targetEl = (0, _dom.default)(event.path[0]);
	  }
	
	  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
	  var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
	
	  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
	    swiper.allowClick = true;
	    return;
	  }
	
	  if (params.swipeHandler) {
	    if (!$targetEl.closest(params.swipeHandler)[0]) return;
	  }
	
	  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  var startX = touches.currentX;
	  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
	
	  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
	  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
	
	  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
	    if (edgeSwipeDetection === 'prevent') {
	      event.preventDefault();
	    } else {
	      return;
	    }
	  }
	
	  (0, _utils.extend)(data, {
	    isTouched: true,
	    isMoved: false,
	    allowTouchCallbacks: true,
	    isScrolling: undefined,
	    startMoving: undefined
	  });
	  touches.startX = startX;
	  touches.startY = startY;
	  data.touchStartTime = (0, _utils.now)();
	  swiper.allowClick = true;
	  swiper.updateSize();
	  swiper.swipeDirection = undefined;
	  if (params.threshold > 0) data.allowThresholdMove = false;
	
	  if (e.type !== 'touchstart') {
	    var preventDefault = true;
	    if ($targetEl.is(data.focusableElements)) preventDefault = false;
	
	    if (document.activeElement && (0, _dom.default)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
	      document.activeElement.blur();
	    }
	
	    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
	
	    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
	      e.preventDefault();
	    }
	  }
	
	  swiper.emit('touchStart', e);
	}

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _setGrabCursor = _interopRequireDefault(__webpack_require__(1062));
	
	var _unsetGrabCursor = _interopRequireDefault(__webpack_require__(1063));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  setGrabCursor: _setGrabCursor.default,
	  unsetGrabCursor: _unsetGrabCursor.default
	};
	exports.default = _default;

/***/ },
/* 1062 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = setGrabCursor;
	
	function setGrabCursor(moving) {
	  var swiper = this;
	  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
	  var el = swiper.el;
	  el.style.cursor = 'move';
	  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	  el.style.cursor = moving ? 'grabbing' : 'grab';
	}

/***/ },
/* 1063 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = unsetGrabCursor;
	
	function unsetGrabCursor() {
	  var swiper = this;
	
	  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
	    return;
	  }
	
	  swiper.el.style.cursor = '';
	}

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _loadImage = _interopRequireDefault(__webpack_require__(1065));
	
	var _preloadImages = _interopRequireDefault(__webpack_require__(1066));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  loadImage: _loadImage.default,
	  preloadImages: _preloadImages.default
	};
	exports.default = _default;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = loadImage;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
	  var window = (0, _ssrWindow.getWindow)();
	  var image;
	
	  function onReady() {
	    if (callback) callback();
	  }
	
	  var isPicture = (0, _dom.default)(imageEl).parent('picture')[0];
	
	  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
	    if (src) {
	      image = new window.Image();
	      image.onload = onReady;
	      image.onerror = onReady;
	
	      if (sizes) {
	        image.sizes = sizes;
	      }
	
	      if (srcset) {
	        image.srcset = srcset;
	      }
	
	      if (src) {
	        image.src = src;
	      }
	    } else {
	      onReady();
	    }
	  } else {
	    // image already loaded...
	    onReady();
	  }
	}

/***/ },
/* 1066 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = preloadImages;
	
	function preloadImages() {
	  var swiper = this;
	  swiper.imagesToLoad = swiper.$el.find('img');
	
	  function onReady() {
	    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
	    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
	
	    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
	      if (swiper.params.updateOnImagesReady) swiper.update();
	      swiper.emit('imagesReady');
	    }
	  }
	
	  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
	    var imageEl = swiper.imagesToLoad[i];
	    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
	  }
	}

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _loopCreate = _interopRequireDefault(__webpack_require__(1068));
	
	var _loopFix = _interopRequireDefault(__webpack_require__(1070));
	
	var _loopDestroy = _interopRequireDefault(__webpack_require__(1069));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  loopCreate: _loopCreate.default,
	  loopFix: _loopFix.default,
	  loopDestroy: _loopDestroy.default
	};
	exports.default = _default;

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = loopCreate;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function loopCreate() {
	  var swiper = this;
	  var document = (0, _ssrWindow.getDocument)();
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides
	
	  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
	  var slides = $wrapperEl.children("." + params.slideClass);
	
	  if (params.loopFillGroupWithBlank) {
	    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
	
	    if (blankSlidesNum !== params.slidesPerGroup) {
	      for (var i = 0; i < blankSlidesNum; i += 1) {
	        var blankNode = (0, _dom.default)(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
	        $wrapperEl.append(blankNode);
	      }
	
	      slides = $wrapperEl.children("." + params.slideClass);
	    }
	  }
	
	  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
	  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
	  swiper.loopedSlides += params.loopAdditionalSlides;
	
	  if (swiper.loopedSlides > slides.length) {
	    swiper.loopedSlides = slides.length;
	  }
	
	  var prependSlides = [];
	  var appendSlides = [];
	  slides.each(function (el, index) {
	    var slide = (0, _dom.default)(el);
	
	    if (index < swiper.loopedSlides) {
	      appendSlides.push(el);
	    }
	
	    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
	      prependSlides.push(el);
	    }
	
	    slide.attr('data-swiper-slide-index', index);
	  });
	
	  for (var _i = 0; _i < appendSlides.length; _i += 1) {
	    $wrapperEl.append((0, _dom.default)(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	
	  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
	    $wrapperEl.prepend((0, _dom.default)(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	}

/***/ },
/* 1069 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = loopDestroy;
	
	function loopDestroy() {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl,
	      params = swiper.params,
	      slides = swiper.slides;
	  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
	  slides.removeAttr('data-swiper-slide-index');
	}

/***/ },
/* 1070 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = loopFix;
	
	function loopFix() {
	  var swiper = this;
	  swiper.emit('beforeLoopFix');
	  var activeIndex = swiper.activeIndex,
	      slides = swiper.slides,
	      loopedSlides = swiper.loopedSlides,
	      allowSlidePrev = swiper.allowSlidePrev,
	      allowSlideNext = swiper.allowSlideNext,
	      snapGrid = swiper.snapGrid,
	      rtl = swiper.rtlTranslate;
	  var newIndex;
	  swiper.allowSlidePrev = true;
	  swiper.allowSlideNext = true;
	  var snapTranslate = -snapGrid[activeIndex];
	  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
	
	  if (activeIndex < loopedSlides) {
	    newIndex = slides.length - loopedSlides * 3 + activeIndex;
	    newIndex += loopedSlides;
	    var slideChanged = swiper.slideTo(newIndex, 0, false, true);
	
	    if (slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  } else if (activeIndex >= slides.length - loopedSlides) {
	    // Fix For Positive Oversliding
	    newIndex = -slides.length + activeIndex + loopedSlides;
	    newIndex += loopedSlides;
	
	    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);
	
	    if (_slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  }
	
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	  swiper.emit('loopFix');
	}

/***/ },
/* 1071 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = addSlide;
	
	function addSlide(index, slides) {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl,
	      params = swiper.params,
	      activeIndex = swiper.activeIndex;
	  var activeIndexBuffer = activeIndex;
	
	  if (params.loop) {
	    activeIndexBuffer -= swiper.loopedSlides;
	    swiper.loopDestroy();
	    swiper.slides = $wrapperEl.children("." + params.slideClass);
	  }
	
	  var baseLength = swiper.slides.length;
	
	  if (index <= 0) {
	    swiper.prependSlide(slides);
	    return;
	  }
	
	  if (index >= baseLength) {
	    swiper.appendSlide(slides);
	    return;
	  }
	
	  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
	  var slidesBuffer = [];
	
	  for (var i = baseLength - 1; i >= index; i -= 1) {
	    var currentSlide = swiper.slides.eq(i);
	    currentSlide.remove();
	    slidesBuffer.unshift(currentSlide);
	  }
	
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var _i = 0; _i < slides.length; _i += 1) {
	      if (slides[_i]) $wrapperEl.append(slides[_i]);
	    }
	
	    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
	  } else {
	    $wrapperEl.append(slides);
	  }
	
	  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
	    $wrapperEl.append(slidesBuffer[_i2]);
	  }
	
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	
	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }
	
	  if (params.loop) {
	    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	}

/***/ },
/* 1072 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = appendSlide;
	
	function appendSlide(slides) {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl,
	      params = swiper.params;
	
	  if (params.loop) {
	    swiper.loopDestroy();
	  }
	
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) $wrapperEl.append(slides[i]);
	    }
	  } else {
	    $wrapperEl.append(slides);
	  }
	
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	
	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }
	}

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _appendSlide = _interopRequireDefault(__webpack_require__(1072));
	
	var _prependSlide = _interopRequireDefault(__webpack_require__(1074));
	
	var _addSlide = _interopRequireDefault(__webpack_require__(1071));
	
	var _removeSlide = _interopRequireDefault(__webpack_require__(1076));
	
	var _removeAllSlides = _interopRequireDefault(__webpack_require__(1075));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  appendSlide: _appendSlide.default,
	  prependSlide: _prependSlide.default,
	  addSlide: _addSlide.default,
	  removeSlide: _removeSlide.default,
	  removeAllSlides: _removeAllSlides.default
	};
	exports.default = _default;

/***/ },
/* 1074 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = prependSlide;
	
	function prependSlide(slides) {
	  var swiper = this;
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      activeIndex = swiper.activeIndex;
	
	  if (params.loop) {
	    swiper.loopDestroy();
	  }
	
	  var newActiveIndex = activeIndex + 1;
	
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) $wrapperEl.prepend(slides[i]);
	    }
	
	    newActiveIndex = activeIndex + slides.length;
	  } else {
	    $wrapperEl.prepend(slides);
	  }
	
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	
	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }
	
	  swiper.slideTo(newActiveIndex, 0, false);
	}

/***/ },
/* 1075 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeAllSlides;
	
	function removeAllSlides() {
	  var swiper = this;
	  var slidesIndexes = [];
	
	  for (var i = 0; i < swiper.slides.length; i += 1) {
	    slidesIndexes.push(i);
	  }
	
	  swiper.removeSlide(slidesIndexes);
	}

/***/ },
/* 1076 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeSlide;
	
	function removeSlide(slidesIndexes) {
	  var swiper = this;
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      activeIndex = swiper.activeIndex;
	  var activeIndexBuffer = activeIndex;
	
	  if (params.loop) {
	    activeIndexBuffer -= swiper.loopedSlides;
	    swiper.loopDestroy();
	    swiper.slides = $wrapperEl.children("." + params.slideClass);
	  }
	
	  var newActiveIndex = activeIndexBuffer;
	  var indexToRemove;
	
	  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
	    for (var i = 0; i < slidesIndexes.length; i += 1) {
	      indexToRemove = slidesIndexes[i];
	      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
	      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
	    }
	
	    newActiveIndex = Math.max(newActiveIndex, 0);
	  } else {
	    indexToRemove = slidesIndexes;
	    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
	    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
	    newActiveIndex = Math.max(newActiveIndex, 0);
	  }
	
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	
	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }
	
	  if (params.loop) {
	    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	}

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(26);
	
	var _default = {
	  useParams: function useParams(instanceParams) {
	    var instance = this;
	    if (!instance.modules) return;
	    Object.keys(instance.modules).forEach(function (moduleName) {
	      var module = instance.modules[moduleName]; // Extend params
	
	      if (module.params) {
	        (0, _utils.extend)(instanceParams, module.params);
	      }
	    });
	  },
	  useModules: function useModules(modulesParams) {
	    if (modulesParams === void 0) {
	      modulesParams = {};
	    }
	
	    var instance = this;
	    if (!instance.modules) return;
	    Object.keys(instance.modules).forEach(function (moduleName) {
	      var module = instance.modules[moduleName];
	      var moduleParams = modulesParams[moduleName] || {}; // Add event listeners
	
	      if (module.on && instance.on) {
	        Object.keys(module.on).forEach(function (moduleEventName) {
	          instance.on(moduleEventName, module.on[moduleEventName]);
	        });
	      } // Module create callback
	
	
	      if (module.create) {
	        module.create.bind(instance)(moduleParams);
	      }
	    });
	  }
	};
	exports.default = _default;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _slideTo = _interopRequireDefault(__webpack_require__(1082));
	
	var _slideToLoop = _interopRequireDefault(__webpack_require__(1085));
	
	var _slideNext = _interopRequireDefault(__webpack_require__(1079));
	
	var _slidePrev = _interopRequireDefault(__webpack_require__(1080));
	
	var _slideReset = _interopRequireDefault(__webpack_require__(1081));
	
	var _slideToClosest = _interopRequireDefault(__webpack_require__(1084));
	
	var _slideToClickedSlide = _interopRequireDefault(__webpack_require__(1083));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  slideTo: _slideTo.default,
	  slideToLoop: _slideToLoop.default,
	  slideNext: _slideNext.default,
	  slidePrev: _slidePrev.default,
	  slideReset: _slideReset.default,
	  slideToClosest: _slideToClosest.default,
	  slideToClickedSlide: _slideToClickedSlide.default
	};
	exports.default = _default;

/***/ },
/* 1079 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideNext;
	
	/* eslint no-unused-vars: "off" */
	function slideNext(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  var params = swiper.params,
	      animating = swiper.animating,
	      enabled = swiper.enabled;
	  if (!enabled) return swiper;
	  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
	
	  if (params.loop) {
	    if (animating && params.loopPreventsSlide) return false;
	    swiper.loopFix(); // eslint-disable-next-line
	
	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }
	
	  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
	}

/***/ },
/* 1080 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slidePrev;
	
	/* eslint no-unused-vars: "off" */
	function slidePrev(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  var params = swiper.params,
	      animating = swiper.animating,
	      snapGrid = swiper.snapGrid,
	      slidesGrid = swiper.slidesGrid,
	      rtlTranslate = swiper.rtlTranslate,
	      enabled = swiper.enabled;
	  if (!enabled) return swiper;
	
	  if (params.loop) {
	    if (animating && params.loopPreventsSlide) return false;
	    swiper.loopFix(); // eslint-disable-next-line
	
	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }
	
	  var translate = rtlTranslate ? swiper.translate : -swiper.translate;
	
	  function normalize(val) {
	    if (val < 0) return -Math.floor(Math.abs(val));
	    return Math.floor(val);
	  }
	
	  var normalizedTranslate = normalize(translate);
	  var normalizedSnapGrid = snapGrid.map(function (val) {
	    return normalize(val);
	  });
	  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
	
	  if (typeof prevSnap === 'undefined' && params.cssMode) {
	    snapGrid.forEach(function (snap) {
	      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
	    });
	  }
	
	  var prevIndex;
	
	  if (typeof prevSnap !== 'undefined') {
	    prevIndex = slidesGrid.indexOf(prevSnap);
	    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
	  }
	
	  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	}

/***/ },
/* 1081 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideReset;
	
	/* eslint no-unused-vars: "off" */
	function slideReset(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	}

/***/ },
/* 1082 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideTo;
	
	function slideTo(index, speed, runCallbacks, internal, initial) {
	  if (index === void 0) {
	    index = 0;
	  }
	
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  if (typeof index !== 'number' && typeof index !== 'string') {
	    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
	  }
	
	  if (typeof index === 'string') {
	    /**
	     * The `index` argument converted from `string` to `number`.
	     * @type {number}
	     */
	    var indexAsNumber = parseInt(index, 10);
	    /**
	     * Determines whether the `index` argument is a valid `number`
	     * after being converted from the `string` type.
	     * @type {boolean}
	     */
	
	    var isValidNumber = isFinite(indexAsNumber);
	
	    if (!isValidNumber) {
	      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
	    } // Knowing that the converted `index` is a valid number,
	    // we can update the original argument's value.
	
	
	    index = indexAsNumber;
	  }
	
	  var swiper = this;
	  var slideIndex = index;
	  if (slideIndex < 0) slideIndex = 0;
	  var params = swiper.params,
	      snapGrid = swiper.snapGrid,
	      slidesGrid = swiper.slidesGrid,
	      previousIndex = swiper.previousIndex,
	      activeIndex = swiper.activeIndex,
	      rtl = swiper.rtlTranslate,
	      wrapperEl = swiper.wrapperEl,
	      enabled = swiper.enabled;
	
	  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
	    return false;
	  }
	
	  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
	  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
	
	  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
	    swiper.emit('beforeSlideChangeStart');
	  }
	
	  var translate = -snapGrid[snapIndex]; // Update progress
	
	  swiper.updateProgress(translate); // Normalize slideIndex
	
	  if (params.normalizeSlideIndex) {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      var normalizedTranslate = -Math.floor(translate * 100);
	      var normalizedGird = Math.floor(slidesGrid[i] * 100);
	      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
	
	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
	          slideIndex = i;
	        } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
	          slideIndex = i + 1;
	        }
	      } else if (normalizedTranslate >= normalizedGird) {
	        slideIndex = i;
	      }
	    }
	  } // Directions locks
	
	
	  if (swiper.initialized && slideIndex !== activeIndex) {
	    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
	      return false;
	    }
	
	    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	      if ((activeIndex || 0) !== slideIndex) return false;
	    }
	  }
	
	  var direction;
	  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index
	
	  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
	    swiper.updateActiveIndex(slideIndex); // Update Height
	
	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	
	    swiper.updateSlidesClasses();
	
	    if (params.effect !== 'slide') {
	      swiper.setTranslate(translate);
	    }
	
	    if (direction !== 'reset') {
	      swiper.transitionStart(runCallbacks, direction);
	      swiper.transitionEnd(runCallbacks, direction);
	    }
	
	    return false;
	  }
	
	  if (params.cssMode) {
	    var isH = swiper.isHorizontal();
	    var t = -translate;
	
	    if (rtl) {
	      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
	    }
	
	    if (speed === 0) {
	      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
	    } else {
	      // eslint-disable-next-line
	      if (wrapperEl.scrollTo) {
	        var _wrapperEl$scrollTo;
	
	        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
	      } else {
	        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
	      }
	    }
	
	    return true;
	  }
	
	  if (speed === 0) {
	    swiper.setTransition(0);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks, direction);
	    swiper.transitionEnd(runCallbacks, direction);
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks, direction);
	
	    if (!swiper.animating) {
	      swiper.animating = true;
	
	      if (!swiper.onSlideToWrapperTransitionEnd) {
	        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
	          if (!swiper || swiper.destroyed) return;
	          if (e.target !== this) return;
	          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	          swiper.onSlideToWrapperTransitionEnd = null;
	          delete swiper.onSlideToWrapperTransitionEnd;
	          swiper.transitionEnd(runCallbacks, direction);
	        };
	      }
	
	      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideToClickedSlide;
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function slideToClickedSlide() {
	  var swiper = this;
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl;
	  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	  var slideToIndex = swiper.clickedIndex;
	  var realIndex;
	
	  if (params.loop) {
	    if (swiper.animating) return;
	    realIndex = parseInt((0, _dom.default)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	
	    if (params.centeredSlides) {
	      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
	        swiper.loopFix();
	        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
	        (0, _utils.nextTick)(function () {
	          swiper.slideTo(slideToIndex);
	        });
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	      swiper.loopFix();
	      slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
	      (0, _utils.nextTick)(function () {
	        swiper.slideTo(slideToIndex);
	      });
	    } else {
	      swiper.slideTo(slideToIndex);
	    }
	  } else {
	    swiper.slideTo(slideToIndex);
	  }
	}

/***/ },
/* 1084 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideToClosest;
	
	/* eslint no-unused-vars: "off" */
	function slideToClosest(speed, runCallbacks, internal, threshold) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  if (threshold === void 0) {
	    threshold = 0.5;
	  }
	
	  var swiper = this;
	  var index = swiper.activeIndex;
	  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
	  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
	  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	
	  if (translate >= swiper.snapGrid[snapIndex]) {
	    // The current translate is on or after the current snap index, so the choice
	    // is between the current index and the one after it.
	    var currentSnap = swiper.snapGrid[snapIndex];
	    var nextSnap = swiper.snapGrid[snapIndex + 1];
	
	    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
	      index += swiper.params.slidesPerGroup;
	    }
	  } else {
	    // The current translate is before the current snap index, so the choice
	    // is between the current index and the one before it.
	    var prevSnap = swiper.snapGrid[snapIndex - 1];
	    var _currentSnap = swiper.snapGrid[snapIndex];
	
	    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
	      index -= swiper.params.slidesPerGroup;
	    }
	  }
	
	  index = Math.max(index, 0);
	  index = Math.min(index, swiper.slidesGrid.length - 1);
	  return swiper.slideTo(index, speed, runCallbacks, internal);
	}

/***/ },
/* 1085 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = slideToLoop;
	
	function slideToLoop(index, speed, runCallbacks, internal) {
	  if (index === void 0) {
	    index = 0;
	  }
	
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  var newIndex = index;
	
	  if (swiper.params.loop) {
	    newIndex += swiper.loopedSlides;
	  }
	
	  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
	}

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _setTransition = _interopRequireDefault(__webpack_require__(1087));
	
	var _transitionStart = _interopRequireDefault(__webpack_require__(1089));
	
	var _transitionEnd = _interopRequireDefault(__webpack_require__(1088));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  setTransition: _setTransition.default,
	  transitionStart: _transitionStart.default,
	  transitionEnd: _transitionEnd.default
	};
	exports.default = _default;

/***/ },
/* 1087 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = setTransition;
	
	function setTransition(duration, byController) {
	  var swiper = this;
	
	  if (!swiper.params.cssMode) {
	    swiper.$wrapperEl.transition(duration);
	  }
	
	  swiper.emit('setTransition', duration, byController);
	}

/***/ },
/* 1088 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = transitionEnd;
	
	function transitionEnd(runCallbacks, direction) {
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  var activeIndex = swiper.activeIndex,
	      previousIndex = swiper.previousIndex,
	      params = swiper.params;
	  swiper.animating = false;
	  if (params.cssMode) return;
	  swiper.setTransition(0);
	  var dir = direction;
	
	  if (!dir) {
	    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
	  }
	
	  swiper.emit('transitionEnd');
	
	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit('slideResetTransitionEnd');
	      return;
	    }
	
	    swiper.emit('slideChangeTransitionEnd');
	
	    if (dir === 'next') {
	      swiper.emit('slideNextTransitionEnd');
	    } else {
	      swiper.emit('slidePrevTransitionEnd');
	    }
	  }
	}

/***/ },
/* 1089 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = transitionStart;
	
	function transitionStart(runCallbacks, direction) {
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  var swiper = this;
	  var activeIndex = swiper.activeIndex,
	      params = swiper.params,
	      previousIndex = swiper.previousIndex;
	  if (params.cssMode) return;
	
	  if (params.autoHeight) {
	    swiper.updateAutoHeight();
	  }
	
	  var dir = direction;
	
	  if (!dir) {
	    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
	  }
	
	  swiper.emit('transitionStart');
	
	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit('slideResetTransitionStart');
	      return;
	    }
	
	    swiper.emit('slideChangeTransitionStart');
	
	    if (dir === 'next') {
	      swiper.emit('slideNextTransitionStart');
	    } else {
	      swiper.emit('slidePrevTransitionStart');
	    }
	  }
	}

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getSwiperTranslate;
	
	var _utils = __webpack_require__(26);
	
	function getSwiperTranslate(axis) {
	  if (axis === void 0) {
	    axis = this.isHorizontal() ? 'x' : 'y';
	  }
	
	  var swiper = this;
	  var params = swiper.params,
	      rtl = swiper.rtlTranslate,
	      translate = swiper.translate,
	      $wrapperEl = swiper.$wrapperEl;
	
	  if (params.virtualTranslate) {
	    return rtl ? -translate : translate;
	  }
	
	  if (params.cssMode) {
	    return translate;
	  }
	
	  var currentTranslate = (0, _utils.getTranslate)($wrapperEl[0], axis);
	  if (rtl) currentTranslate = -currentTranslate;
	  return currentTranslate || 0;
	}

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _getTranslate = _interopRequireDefault(__webpack_require__(1090));
	
	var _setTranslate = _interopRequireDefault(__webpack_require__(1094));
	
	var _minTranslate = _interopRequireDefault(__webpack_require__(1093));
	
	var _maxTranslate = _interopRequireDefault(__webpack_require__(1092));
	
	var _translateTo = _interopRequireDefault(__webpack_require__(1095));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  getTranslate: _getTranslate.default,
	  setTranslate: _setTranslate.default,
	  minTranslate: _minTranslate.default,
	  maxTranslate: _maxTranslate.default,
	  translateTo: _translateTo.default
	};
	exports.default = _default;

/***/ },
/* 1092 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = maxTranslate;
	
	function maxTranslate() {
	  return -this.snapGrid[this.snapGrid.length - 1];
	}

/***/ },
/* 1093 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = minTranslate;
	
	function minTranslate() {
	  return -this.snapGrid[0];
	}

/***/ },
/* 1094 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = setTranslate;
	
	function setTranslate(translate, byController) {
	  var swiper = this;
	  var rtl = swiper.rtlTranslate,
	      params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      wrapperEl = swiper.wrapperEl,
	      progress = swiper.progress;
	  var x = 0;
	  var y = 0;
	  var z = 0;
	
	  if (swiper.isHorizontal()) {
	    x = rtl ? -translate : translate;
	  } else {
	    y = translate;
	  }
	
	  if (params.roundLengths) {
	    x = Math.floor(x);
	    y = Math.floor(y);
	  }
	
	  if (params.cssMode) {
	    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
	  } else if (!params.virtualTranslate) {
	    $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
	  }
	
	  swiper.previousTranslate = swiper.translate;
	  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
	
	  var newProgress;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	
	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
	  }
	
	  if (newProgress !== progress) {
	    swiper.updateProgress(translate);
	  }
	
	  swiper.emit('setTranslate', swiper.translate, byController);
	}

/***/ },
/* 1095 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = translateTo;
	
	function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
	  if (translate === void 0) {
	    translate = 0;
	  }
	
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	
	  if (translateBounds === void 0) {
	    translateBounds = true;
	  }
	
	  var swiper = this;
	  var params = swiper.params,
	      wrapperEl = swiper.wrapperEl;
	
	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return false;
	  }
	
	  var minTranslate = swiper.minTranslate();
	  var maxTranslate = swiper.maxTranslate();
	  var newTranslate;
	  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress
	
	  swiper.updateProgress(newTranslate);
	
	  if (params.cssMode) {
	    var isH = swiper.isHorizontal();
	
	    if (speed === 0) {
	      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
	    } else {
	      // eslint-disable-next-line
	      if (wrapperEl.scrollTo) {
	        var _wrapperEl$scrollTo;
	
	        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
	      } else {
	        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
	      }
	    }
	
	    return true;
	  }
	
	  if (speed === 0) {
	    swiper.setTransition(0);
	    swiper.setTranslate(newTranslate);
	
	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionEnd');
	    }
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(newTranslate);
	
	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionStart');
	    }
	
	    if (!swiper.animating) {
	      swiper.animating = true;
	
	      if (!swiper.onTranslateToWrapperTransitionEnd) {
	        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
	          if (!swiper || swiper.destroyed) return;
	          if (e.target !== this) return;
	          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.onTranslateToWrapperTransitionEnd = null;
	          delete swiper.onTranslateToWrapperTransitionEnd;
	
	          if (runCallbacks) {
	            swiper.emit('transitionEnd');
	          }
	        };
	      }
	
	      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _updateSize = _interopRequireDefault(__webpack_require__(1101));
	
	var _updateSlides = _interopRequireDefault(__webpack_require__(1102));
	
	var _updateAutoHeight = _interopRequireDefault(__webpack_require__(1098));
	
	var _updateSlidesOffset = _interopRequireDefault(__webpack_require__(1104));
	
	var _updateSlidesProgress = _interopRequireDefault(__webpack_require__(1105));
	
	var _updateProgress = _interopRequireDefault(__webpack_require__(1100));
	
	var _updateSlidesClasses = _interopRequireDefault(__webpack_require__(1103));
	
	var _updateActiveIndex = _interopRequireDefault(__webpack_require__(1097));
	
	var _updateClickedSlide = _interopRequireDefault(__webpack_require__(1099));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  updateSize: _updateSize.default,
	  updateSlides: _updateSlides.default,
	  updateAutoHeight: _updateAutoHeight.default,
	  updateSlidesOffset: _updateSlidesOffset.default,
	  updateSlidesProgress: _updateSlidesProgress.default,
	  updateProgress: _updateProgress.default,
	  updateSlidesClasses: _updateSlidesClasses.default,
	  updateActiveIndex: _updateActiveIndex.default,
	  updateClickedSlide: _updateClickedSlide.default
	};
	exports.default = _default;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateActiveIndex;
	
	var _utils = __webpack_require__(26);
	
	function updateActiveIndex(newActiveIndex) {
	  var swiper = this;
	  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  var slidesGrid = swiper.slidesGrid,
	      snapGrid = swiper.snapGrid,
	      params = swiper.params,
	      previousIndex = swiper.activeIndex,
	      previousRealIndex = swiper.realIndex,
	      previousSnapIndex = swiper.snapIndex;
	  var activeIndex = newActiveIndex;
	  var snapIndex;
	
	  if (typeof activeIndex === 'undefined') {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
	          activeIndex = i;
	        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	          activeIndex = i + 1;
	        }
	      } else if (translate >= slidesGrid[i]) {
	        activeIndex = i;
	      }
	    } // Normalize slideIndex
	
	
	    if (params.normalizeSlideIndex) {
	      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
	    }
	  }
	
	  if (snapGrid.indexOf(translate) >= 0) {
	    snapIndex = snapGrid.indexOf(translate);
	  } else {
	    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
	    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
	  }
	
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
	
	  if (activeIndex === previousIndex) {
	    if (snapIndex !== previousSnapIndex) {
	      swiper.snapIndex = snapIndex;
	      swiper.emit('snapIndexChange');
	    }
	
	    return;
	  } // Get real index
	
	
	  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
	  (0, _utils.extend)(swiper, {
	    snapIndex: snapIndex,
	    realIndex: realIndex,
	    previousIndex: previousIndex,
	    activeIndex: activeIndex
	  });
	  swiper.emit('activeIndexChange');
	  swiper.emit('snapIndexChange');
	
	  if (previousRealIndex !== realIndex) {
	    swiper.emit('realIndexChange');
	  }
	
	  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
	    swiper.emit('slideChange');
	  }
	}

/***/ },
/* 1098 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateAutoHeight;
	
	function updateAutoHeight(speed) {
	  var swiper = this;
	  var activeSlides = [];
	  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	  var newHeight = 0;
	  var i;
	
	  if (typeof speed === 'number') {
	    swiper.setTransition(speed);
	  } else if (speed === true) {
	    swiper.setTransition(swiper.params.speed);
	  }
	
	  var getSlideByIndex = function getSlideByIndex(index) {
	    if (isVirtual) {
	      return swiper.slides.filter(function (el) {
	        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
	      })[0];
	    }
	
	    return swiper.slides.eq(index)[0];
	  }; // Find slides currently in view
	
	
	  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	    if (swiper.params.centeredSlides) {
	      swiper.visibleSlides.each(function (slide) {
	        activeSlides.push(slide);
	      });
	    } else {
	      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	        var index = swiper.activeIndex + i;
	        if (index > swiper.slides.length && !isVirtual) break;
	        activeSlides.push(getSlideByIndex(index));
	      }
	    }
	  } else {
	    activeSlides.push(getSlideByIndex(swiper.activeIndex));
	  } // Find new height from highest slide in view
	
	
	  for (i = 0; i < activeSlides.length; i += 1) {
	    if (typeof activeSlides[i] !== 'undefined') {
	      var height = activeSlides[i].offsetHeight;
	      newHeight = height > newHeight ? height : newHeight;
	    }
	  } // Update Height
	
	
	  if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
	}

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateClickedSlide;
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateClickedSlide(e) {
	  var swiper = this;
	  var params = swiper.params;
	  var slide = (0, _dom.default)(e.target).closest("." + params.slideClass)[0];
	  var slideFound = false;
	  var slideIndex;
	
	  if (slide) {
	    for (var i = 0; i < swiper.slides.length; i += 1) {
	      if (swiper.slides[i] === slide) {
	        slideFound = true;
	        slideIndex = i;
	        break;
	      }
	    }
	  }
	
	  if (slide && slideFound) {
	    swiper.clickedSlide = slide;
	
	    if (swiper.virtual && swiper.params.virtual.enabled) {
	      swiper.clickedIndex = parseInt((0, _dom.default)(slide).attr('data-swiper-slide-index'), 10);
	    } else {
	      swiper.clickedIndex = slideIndex;
	    }
	  } else {
	    swiper.clickedSlide = undefined;
	    swiper.clickedIndex = undefined;
	    return;
	  }
	
	  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	    swiper.slideToClickedSlide();
	  }
	}

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateProgress;
	
	var _utils = __webpack_require__(26);
	
	function updateProgress(translate) {
	  var swiper = this;
	
	  if (typeof translate === 'undefined') {
	    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
	
	    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
	  }
	
	  var params = swiper.params;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  var progress = swiper.progress,
	      isBeginning = swiper.isBeginning,
	      isEnd = swiper.isEnd;
	  var wasBeginning = isBeginning;
	  var wasEnd = isEnd;
	
	  if (translatesDiff === 0) {
	    progress = 0;
	    isBeginning = true;
	    isEnd = true;
	  } else {
	    progress = (translate - swiper.minTranslate()) / translatesDiff;
	    isBeginning = progress <= 0;
	    isEnd = progress >= 1;
	  }
	
	  (0, _utils.extend)(swiper, {
	    progress: progress,
	    isBeginning: isBeginning,
	    isEnd: isEnd
	  });
	  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
	
	  if (isBeginning && !wasBeginning) {
	    swiper.emit('reachBeginning toEdge');
	  }
	
	  if (isEnd && !wasEnd) {
	    swiper.emit('reachEnd toEdge');
	  }
	
	  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
	    swiper.emit('fromEdge');
	  }
	
	  swiper.emit('progress', progress);
	}

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateSize;
	
	var _utils = __webpack_require__(26);
	
	function updateSize() {
	  var swiper = this;
	  var width;
	  var height;
	  var $el = swiper.$el;
	
	  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
	    width = swiper.params.width;
	  } else {
	    width = $el[0].clientWidth;
	  }
	
	  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
	    height = swiper.params.height;
	  } else {
	    height = $el[0].clientHeight;
	  }
	
	  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
	    return;
	  } // Subtract paddings
	
	
	  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
	  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
	  if (Number.isNaN(width)) width = 0;
	  if (Number.isNaN(height)) height = 0;
	  (0, _utils.extend)(swiper, {
	    width: width,
	    height: height,
	    size: swiper.isHorizontal() ? width : height
	  });
	}

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateSlides;
	
	var _utils = __webpack_require__(26);
	
	function updateSlides() {
	  var swiper = this;
	
	  function getDirectionLabel(property) {
	    if (swiper.isHorizontal()) {
	      return property;
	    } // prettier-ignore
	
	
	    return {
	      'width': 'height',
	      'margin-top': 'margin-left',
	      'margin-bottom ': 'margin-right',
	      'margin-left': 'margin-top',
	      'margin-right': 'margin-bottom',
	      'padding-left': 'padding-top',
	      'padding-right': 'padding-bottom',
	      'marginRight': 'marginBottom'
	    }[property];
	  }
	
	  function getDirectionPropertyValue(node, label) {
	    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
	  }
	
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl,
	      swiperSize = swiper.size,
	      rtl = swiper.rtlTranslate,
	      wrongRTL = swiper.wrongRTL;
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
	  var slides = $wrapperEl.children("." + swiper.params.slideClass);
	  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	  var snapGrid = [];
	  var slidesGrid = [];
	  var slidesSizesGrid = [];
	  var offsetBefore = params.slidesOffsetBefore;
	
	  if (typeof offsetBefore === 'function') {
	    offsetBefore = params.slidesOffsetBefore.call(swiper);
	  }
	
	  var offsetAfter = params.slidesOffsetAfter;
	
	  if (typeof offsetAfter === 'function') {
	    offsetAfter = params.slidesOffsetAfter.call(swiper);
	  }
	
	  var previousSnapGridLength = swiper.snapGrid.length;
	  var previousSlidesGridLength = swiper.slidesGrid.length;
	  var spaceBetween = params.spaceBetween;
	  var slidePosition = -offsetBefore;
	  var prevSlideSize = 0;
	  var index = 0;
	
	  if (typeof swiperSize === 'undefined') {
	    return;
	  }
	
	  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
	  }
	
	  swiper.virtualSize = -spaceBetween; // reset margins
	
	  if (rtl) slides.css({
	    marginLeft: '',
	    marginBottom: '',
	    marginTop: ''
	  });else slides.css({
	    marginRight: '',
	    marginBottom: '',
	    marginTop: ''
	  });
	  var slidesNumberEvenToRows;
	
	  if (params.slidesPerColumn > 1) {
	    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
	      slidesNumberEvenToRows = slidesLength;
	    } else {
	      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
	    }
	
	    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
	      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
	    }
	  } // Calc slides
	
	
	  var slideSize;
	  var slidesPerColumn = params.slidesPerColumn;
	  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
	
	  for (var i = 0; i < slidesLength; i += 1) {
	    slideSize = 0;
	    var slide = slides.eq(i);
	
	    if (params.slidesPerColumn > 1) {
	      // Set slides order
	      var newSlideOrderIndex = void 0;
	      var column = void 0;
	      var row = void 0;
	
	      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
	        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
	        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
	        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
	        row = Math.floor(slideIndexInGroup / columnsInGroup);
	        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
	        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
	        slide.css({
	          '-webkit-box-ordinal-group': newSlideOrderIndex,
	          '-moz-box-ordinal-group': newSlideOrderIndex,
	          '-ms-flex-order': newSlideOrderIndex,
	          '-webkit-order': newSlideOrderIndex,
	          order: newSlideOrderIndex
	        });
	      } else if (params.slidesPerColumnFill === 'column') {
	        column = Math.floor(i / slidesPerColumn);
	        row = i - column * slidesPerColumn;
	
	        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
	          row += 1;
	
	          if (row >= slidesPerColumn) {
	            row = 0;
	            column += 1;
	          }
	        }
	      } else {
	        row = Math.floor(i / slidesPerRow);
	        column = i - row * slidesPerRow;
	      }
	
	      slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
	    }
	
	    if (slide.css('display') === 'none') continue; // eslint-disable-line
	
	    if (params.slidesPerView === 'auto') {
	      var slideStyles = getComputedStyle(slide[0]);
	      var currentTransform = slide[0].style.transform;
	      var currentWebKitTransform = slide[0].style.webkitTransform;
	
	      if (currentTransform) {
	        slide[0].style.transform = 'none';
	      }
	
	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = 'none';
	      }
	
	      if (params.roundLengths) {
	        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
	      } else {
	        // eslint-disable-next-line
	        var width = getDirectionPropertyValue(slideStyles, 'width');
	        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
	        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
	        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
	        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
	        var boxSizing = slideStyles.getPropertyValue('box-sizing');
	
	        if (boxSizing && boxSizing === 'border-box') {
	          slideSize = width + marginLeft + marginRight;
	        } else {
	          var _slide$ = slide[0],
	              clientWidth = _slide$.clientWidth,
	              offsetWidth = _slide$.offsetWidth;
	          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
	        }
	      }
	
	      if (currentTransform) {
	        slide[0].style.transform = currentTransform;
	      }
	
	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = currentWebKitTransform;
	      }
	
	      if (params.roundLengths) slideSize = Math.floor(slideSize);
	    } else {
	      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
	      if (params.roundLengths) slideSize = Math.floor(slideSize);
	
	      if (slides[i]) {
	        slides[i].style[getDirectionLabel('width')] = slideSize + "px";
	      }
	    }
	
	    if (slides[i]) {
	      slides[i].swiperSlideSize = slideSize;
	    }
	
	    slidesSizesGrid.push(slideSize);
	
	    if (params.centeredSlides) {
	      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
	      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	    } else {
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	      slidePosition = slidePosition + slideSize + spaceBetween;
	    }
	
	    swiper.virtualSize += slideSize + spaceBetween;
	    prevSlideSize = slideSize;
	    index += 1;
	  }
	
	  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	  var newSlidesGrid;
	
	  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	    $wrapperEl.css({
	      width: swiper.virtualSize + params.spaceBetween + "px"
	    });
	  }
	
	  if (params.setWrapperSize) {
	    var _$wrapperEl$css;
	
	    $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
	  }
	
	  if (params.slidesPerColumn > 1) {
	    var _$wrapperEl$css2;
	
	    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
	    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
	    $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));
	
	    if (params.centeredSlides) {
	      newSlidesGrid = [];
	
	      for (var _i = 0; _i < snapGrid.length; _i += 1) {
	        var slidesGridItem = snapGrid[_i];
	        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
	        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
	      }
	
	      snapGrid = newSlidesGrid;
	    }
	  } // Remove last grid elements depending on width
	
	
	  if (!params.centeredSlides) {
	    newSlidesGrid = [];
	
	    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
	      var _slidesGridItem = snapGrid[_i2];
	      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);
	
	      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
	        newSlidesGrid.push(_slidesGridItem);
	      }
	    }
	
	    snapGrid = newSlidesGrid;
	
	    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	      snapGrid.push(swiper.virtualSize - swiperSize);
	    }
	  }
	
	  if (snapGrid.length === 0) snapGrid = [0];
	
	  if (params.spaceBetween !== 0) {
	    var _slides$filter$css;
	
	    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
	    slides.filter(function (_, slideIndex) {
	      if (!params.cssMode) return true;
	
	      if (slideIndex === slides.length - 1) {
	        return false;
	      }
	
	      return true;
	    }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
	  }
	
	  if (params.centeredSlides && params.centeredSlidesBounds) {
	    var allSlidesSize = 0;
	    slidesSizesGrid.forEach(function (slideSizeValue) {
	      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	    });
	    allSlidesSize -= params.spaceBetween;
	    var maxSnap = allSlidesSize - swiperSize;
	    snapGrid = snapGrid.map(function (snap) {
	      if (snap < 0) return -offsetBefore;
	      if (snap > maxSnap) return maxSnap + offsetAfter;
	      return snap;
	    });
	  }
	
	  if (params.centerInsufficientSlides) {
	    var _allSlidesSize = 0;
	    slidesSizesGrid.forEach(function (slideSizeValue) {
	      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	    });
	    _allSlidesSize -= params.spaceBetween;
	
	    if (_allSlidesSize < swiperSize) {
	      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
	      snapGrid.forEach(function (snap, snapIndex) {
	        snapGrid[snapIndex] = snap - allSlidesOffset;
	      });
	      slidesGrid.forEach(function (snap, snapIndex) {
	        slidesGrid[snapIndex] = snap + allSlidesOffset;
	      });
	    }
	  }
	
	  (0, _utils.extend)(swiper, {
	    slides: slides,
	    snapGrid: snapGrid,
	    slidesGrid: slidesGrid,
	    slidesSizesGrid: slidesSizesGrid
	  });
	
	  if (slidesLength !== previousSlidesLength) {
	    swiper.emit('slidesLengthChange');
	  }
	
	  if (snapGrid.length !== previousSnapGridLength) {
	    if (swiper.params.watchOverflow) swiper.checkOverflow();
	    swiper.emit('snapGridLengthChange');
	  }
	
	  if (slidesGrid.length !== previousSlidesGridLength) {
	    swiper.emit('slidesGridLengthChange');
	  }
	
	  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateSlidesOffset();
	  }
	}

/***/ },
/* 1103 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateSlidesClasses;
	
	function updateSlidesClasses() {
	  var swiper = this;
	  var slides = swiper.slides,
	      params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      activeIndex = swiper.activeIndex,
	      realIndex = swiper.realIndex;
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
	  var activeSlide;
	
	  if (isVirtual) {
	    activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
	  } else {
	    activeSlide = slides.eq(activeIndex);
	  } // Active classes
	
	
	  activeSlide.addClass(params.slideActiveClass);
	
	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (activeSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
	    } else {
	      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
	    }
	  } // Next Slide
	
	
	  var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);
	
	  if (params.loop && nextSlide.length === 0) {
	    nextSlide = slides.eq(0);
	    nextSlide.addClass(params.slideNextClass);
	  } // Prev Slide
	
	
	  var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);
	
	  if (params.loop && prevSlide.length === 0) {
	    prevSlide = slides.eq(-1);
	    prevSlide.addClass(params.slidePrevClass);
	  }
	
	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (nextSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
	    } else {
	      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
	    }
	
	    if (prevSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
	    } else {
	      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
	    }
	  }
	
	  swiper.emitSlidesClasses();
	}

/***/ },
/* 1104 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateSlidesOffset;
	
	function updateSlidesOffset() {
	  var swiper = this;
	  var slides = swiper.slides;
	
	  for (var i = 0; i < slides.length; i += 1) {
	    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	  }
	}

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = updateSlidesProgress;
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateSlidesProgress(translate) {
	  if (translate === void 0) {
	    translate = this && this.translate || 0;
	  }
	
	  var swiper = this;
	  var params = swiper.params;
	  var slides = swiper.slides,
	      rtl = swiper.rtlTranslate;
	  if (slides.length === 0) return;
	  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
	  var offsetCenter = -translate;
	  if (rtl) offsetCenter = translate; // Visible Slides
	
	  slides.removeClass(params.slideVisibleClass);
	  swiper.visibleSlidesIndexes = [];
	  swiper.visibleSlides = [];
	
	  for (var i = 0; i < slides.length; i += 1) {
	    var slide = slides[i];
	    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);
	
	    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
	      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
	
	      if (isVisible) {
	        swiper.visibleSlides.push(slide);
	        swiper.visibleSlidesIndexes.push(i);
	        slides.eq(i).addClass(params.slideVisibleClass);
	      }
	    }
	
	    slide.progress = rtl ? -slideProgress : slideProgress;
	  }
	
	  swiper.visibleSlides = (0, _dom.default)(swiper.visibleSlides);
	}

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Coverflow = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var swiperWidth = swiper.width,
	        swiperHeight = swiper.height,
	        slides = swiper.slides,
	        slidesSizesGrid = swiper.slidesSizesGrid;
	    var params = swiper.params.coverflowEffect;
	    var isHorizontal = swiper.isHorizontal();
	    var transform = swiper.translate;
	    var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
	    var rotate = isHorizontal ? params.rotate : -params.rotate;
	    var translate = params.depth; // Each slide offset from center
	
	    for (var i = 0, length = slides.length; i < length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var slideSize = slidesSizesGrid[i];
	      var slideOffset = $slideEl[0].swiperSlideOffset;
	      var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
	      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
	      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
	
	      var translateZ = -translate * Math.abs(offsetMultiplier);
	      var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
	
	      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
	        stretch = parseFloat(params.stretch) / 100 * slideSize;
	      }
	
	      var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
	      var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
	      var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
	
	      if (Math.abs(translateX) < 0.001) translateX = 0;
	      if (Math.abs(translateY) < 0.001) translateY = 0;
	      if (Math.abs(translateZ) < 0.001) translateZ = 0;
	      if (Math.abs(rotateY) < 0.001) rotateY = 0;
	      if (Math.abs(rotateX) < 0.001) rotateX = 0;
	      if (Math.abs(scale) < 0.001) scale = 0;
	      var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg) scale(" + scale + ")";
	      $slideEl.transform(slideTransform);
	      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	
	      if (params.slideShadows) {
	        // Set shadows
	        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	
	        if ($shadowBeforeEl.length === 0) {
	          $shadowBeforeEl = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
	          $slideEl.append($shadowBeforeEl);
	        }
	
	        if ($shadowAfterEl.length === 0) {
	          $shadowAfterEl = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
	          $slideEl.append($shadowAfterEl);
	        }
	
	        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
	        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
	      }
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	  }
	};
	var _default = {
	  name: 'effect-coverflow',
	  params: {
	    coverflowEffect: {
	      rotate: 50,
	      stretch: 0,
	      depth: 100,
	      scale: 1,
	      modifier: 1,
	      slideShadows: true
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      coverflowEffect: _extends({}, Coverflow)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (swiper.params.effect !== 'coverflow') return;
	      swiper.classNames.push(swiper.params.containerModifierClass + "coverflow");
	      swiper.classNames.push(swiper.params.containerModifierClass + "3d");
	      swiper.params.watchSlidesProgress = true;
	      swiper.originalParams.watchSlidesProgress = true;
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (swiper.params.effect !== 'coverflow') return;
	      swiper.coverflowEffect.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      if (swiper.params.effect !== 'coverflow') return;
	      swiper.coverflowEffect.setTransition(duration);
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Cube = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var $el = swiper.$el,
	        $wrapperEl = swiper.$wrapperEl,
	        slides = swiper.slides,
	        swiperWidth = swiper.width,
	        swiperHeight = swiper.height,
	        rtl = swiper.rtlTranslate,
	        swiperSize = swiper.size,
	        browser = swiper.browser;
	    var params = swiper.params.cubeEffect;
	    var isHorizontal = swiper.isHorizontal();
	    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	    var wrapperRotate = 0;
	    var $cubeShadowEl;
	
	    if (params.shadow) {
	      if (isHorizontal) {
	        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
	
	        if ($cubeShadowEl.length === 0) {
	          $cubeShadowEl = (0, _dom.default)('<div class="swiper-cube-shadow"></div>');
	          $wrapperEl.append($cubeShadowEl);
	        }
	
	        $cubeShadowEl.css({
	          height: swiperWidth + "px"
	        });
	      } else {
	        $cubeShadowEl = $el.find('.swiper-cube-shadow');
	
	        if ($cubeShadowEl.length === 0) {
	          $cubeShadowEl = (0, _dom.default)('<div class="swiper-cube-shadow"></div>');
	          $el.append($cubeShadowEl);
	        }
	      }
	    }
	
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var slideIndex = i;
	
	      if (isVirtual) {
	        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
	      }
	
	      var slideAngle = slideIndex * 90;
	      var round = Math.floor(slideAngle / 360);
	
	      if (rtl) {
	        slideAngle = -slideAngle;
	        round = Math.floor(-slideAngle / 360);
	      }
	
	      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	      var tx = 0;
	      var ty = 0;
	      var tz = 0;
	
	      if (slideIndex % 4 === 0) {
	        tx = -round * 4 * swiperSize;
	        tz = 0;
	      } else if ((slideIndex - 1) % 4 === 0) {
	        tx = 0;
	        tz = -round * 4 * swiperSize;
	      } else if ((slideIndex - 2) % 4 === 0) {
	        tx = swiperSize + round * 4 * swiperSize;
	        tz = swiperSize;
	      } else if ((slideIndex - 3) % 4 === 0) {
	        tx = -swiperSize;
	        tz = 3 * swiperSize + swiperSize * 4 * round;
	      }
	
	      if (rtl) {
	        tx = -tx;
	      }
	
	      if (!isHorizontal) {
	        ty = tx;
	        tx = 0;
	      }
	
	      var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
	
	      if (progress <= 1 && progress > -1) {
	        wrapperRotate = slideIndex * 90 + progress * 90;
	        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
	      }
	
	      $slideEl.transform(transform);
	
	      if (params.slideShadows) {
	        // Set shadows
	        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	
	        if (shadowBefore.length === 0) {
	          shadowBefore = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
	          $slideEl.append(shadowBefore);
	        }
	
	        if (shadowAfter.length === 0) {
	          shadowAfter = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
	          $slideEl.append(shadowAfter);
	        }
	
	        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
	        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
	      }
	    }
	
	    $wrapperEl.css({
	      '-webkit-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
	      '-moz-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
	      '-ms-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
	      'transform-origin': "50% 50% -" + swiperSize / 2 + "px"
	    });
	
	    if (params.shadow) {
	      if (isHorizontal) {
	        $cubeShadowEl.transform("translate3d(0px, " + (swiperWidth / 2 + params.shadowOffset) + "px, " + -swiperWidth / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + params.shadowScale + ")");
	      } else {
	        var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
	        var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
	        var scale1 = params.shadowScale;
	        var scale2 = params.shadowScale / multiplier;
	        var offset = params.shadowOffset;
	        $cubeShadowEl.transform("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + (swiperHeight / 2 + offset) + "px, " + -swiperHeight / 2 / scale2 + "px) rotateX(-90deg)");
	      }
	    }
	
	    var zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
	    $wrapperEl.transform("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)");
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var $el = swiper.$el,
	        slides = swiper.slides;
	    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	
	    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
	      $el.find('.swiper-cube-shadow').transition(duration);
	    }
	  }
	};
	var _default = {
	  name: 'effect-cube',
	  params: {
	    cubeEffect: {
	      slideShadows: true,
	      shadow: true,
	      shadowOffset: 20,
	      shadowScale: 0.94
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      cubeEffect: _extends({}, Cube)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (swiper.params.effect !== 'cube') return;
	      swiper.classNames.push(swiper.params.containerModifierClass + "cube");
	      swiper.classNames.push(swiper.params.containerModifierClass + "3d");
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        resistanceRatio: 0,
	        spaceBetween: 0,
	        centeredSlides: false,
	        virtualTranslate: true
	      };
	      (0, _utils.extend)(swiper.params, overwriteParams);
	      (0, _utils.extend)(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (swiper.params.effect !== 'cube') return;
	      swiper.cubeEffect.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      if (swiper.params.effect !== 'cube') return;
	      swiper.cubeEffect.setTransition(duration);
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(26);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Fade = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var slides = swiper.slides;
	
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = swiper.slides.eq(i);
	      var offset = $slideEl[0].swiperSlideOffset;
	      var tx = -offset;
	      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
	      var ty = 0;
	
	      if (!swiper.isHorizontal()) {
	        ty = tx;
	        tx = 0;
	      }
	
	      var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
	      $slideEl.css({
	        opacity: slideOpacity
	      }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var slides = swiper.slides,
	        $wrapperEl = swiper.$wrapperEl;
	    slides.transition(duration);
	
	    if (swiper.params.virtualTranslate && duration !== 0) {
	      var eventTriggered = false;
	      slides.transitionEnd(function () {
	        if (eventTriggered) return;
	        if (!swiper || swiper.destroyed) return;
	        eventTriggered = true;
	        swiper.animating = false;
	        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	
	        for (var i = 0; i < triggerEvents.length; i += 1) {
	          $wrapperEl.trigger(triggerEvents[i]);
	        }
	      });
	    }
	  }
	};
	var _default = {
	  name: 'effect-fade',
	  params: {
	    fadeEffect: {
	      crossFade: false
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      fadeEffect: _extends({}, Fade)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (swiper.params.effect !== 'fade') return;
	      swiper.classNames.push(swiper.params.containerModifierClass + "fade");
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        spaceBetween: 0,
	        virtualTranslate: true
	      };
	      (0, _utils.extend)(swiper.params, overwriteParams);
	      (0, _utils.extend)(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (swiper.params.effect !== 'fade') return;
	      swiper.fadeEffect.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      if (swiper.params.effect !== 'fade') return;
	      swiper.fadeEffect.setTransition(duration);
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Flip = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var slides = swiper.slides,
	        rtl = swiper.rtlTranslate;
	
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var progress = $slideEl[0].progress;
	
	      if (swiper.params.flipEffect.limitRotation) {
	        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	      }
	
	      var offset = $slideEl[0].swiperSlideOffset;
	      var rotate = -180 * progress;
	      var rotateY = rotate;
	      var rotateX = 0;
	      var tx = -offset;
	      var ty = 0;
	
	      if (!swiper.isHorizontal()) {
	        ty = tx;
	        tx = 0;
	        rotateX = -rotateY;
	        rotateY = 0;
	      } else if (rtl) {
	        rotateY = -rotateY;
	      }
	
	      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
	
	      if (swiper.params.flipEffect.slideShadows) {
	        // Set shadows
	        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	
	        if (shadowBefore.length === 0) {
	          shadowBefore = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>");
	          $slideEl.append(shadowBefore);
	        }
	
	        if (shadowAfter.length === 0) {
	          shadowAfter = (0, _dom.default)("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>");
	          $slideEl.append(shadowAfter);
	        }
	
	        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
	        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
	      }
	
	      $slideEl.transform("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)");
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var slides = swiper.slides,
	        activeIndex = swiper.activeIndex,
	        $wrapperEl = swiper.$wrapperEl;
	    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	
	    if (swiper.params.virtualTranslate && duration !== 0) {
	      var eventTriggered = false; // eslint-disable-next-line
	
	      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
	        if (eventTriggered) return;
	        if (!swiper || swiper.destroyed) return; // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
	
	        eventTriggered = true;
	        swiper.animating = false;
	        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	
	        for (var i = 0; i < triggerEvents.length; i += 1) {
	          $wrapperEl.trigger(triggerEvents[i]);
	        }
	      });
	    }
	  }
	};
	var _default = {
	  name: 'effect-flip',
	  params: {
	    flipEffect: {
	      slideShadows: true,
	      limitRotation: true
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      flipEffect: _extends({}, Flip)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (swiper.params.effect !== 'flip') return;
	      swiper.classNames.push(swiper.params.containerModifierClass + "flip");
	      swiper.classNames.push(swiper.params.containerModifierClass + "3d");
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        spaceBetween: 0,
	        virtualTranslate: true
	      };
	      (0, _utils.extend)(swiper.params, overwriteParams);
	      (0, _utils.extend)(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (swiper.params.effect !== 'flip') return;
	      swiper.flipEffect.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      if (swiper.params.effect !== 'flip') return;
	      swiper.flipEffect.setTransition(duration);
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var HashNavigation = {
	  onHashChange: function onHashChange() {
	    var swiper = this;
	    var document = (0, _ssrWindow.getDocument)();
	    swiper.emit('hashChange');
	    var newHash = document.location.hash.replace('#', '');
	    var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
	
	    if (newHash !== activeSlideHash) {
	      var newIndex = swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-hash=\"" + newHash + "\"]").index();
	      if (typeof newIndex === 'undefined') return;
	      swiper.slideTo(newIndex);
	    }
	  },
	  setHash: function setHash() {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	    var document = (0, _ssrWindow.getDocument)();
	    if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
	
	    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
	      window.history.replaceState(null, null, "#" + swiper.slides.eq(swiper.activeIndex).attr('data-hash') || '');
	      swiper.emit('hashSet');
	    } else {
	      var slide = swiper.slides.eq(swiper.activeIndex);
	      var hash = slide.attr('data-hash') || slide.attr('data-history');
	      document.location.hash = hash || '';
	      swiper.emit('hashSet');
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var document = (0, _ssrWindow.getDocument)();
	    var window = (0, _ssrWindow.getWindow)();
	    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
	    swiper.hashNavigation.initialized = true;
	    var hash = document.location.hash.replace('#', '');
	
	    if (hash) {
	      var speed = 0;
	
	      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	        var slide = swiper.slides.eq(i);
	        var slideHash = slide.attr('data-hash') || slide.attr('data-history');
	
	        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	          var index = slide.index();
	          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
	        }
	      }
	    }
	
	    if (swiper.params.hashNavigation.watchState) {
	      (0, _dom.default)(window).on('hashchange', swiper.hashNavigation.onHashChange);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	
	    if (swiper.params.hashNavigation.watchState) {
	      (0, _dom.default)(window).off('hashchange', swiper.hashNavigation.onHashChange);
	    }
	  }
	};
	var _default = {
	  name: 'hash-navigation',
	  params: {
	    hashNavigation: {
	      enabled: false,
	      replaceState: false,
	      watchState: false
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      hashNavigation: _extends({
	        initialized: false
	      }, HashNavigation)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (swiper.params.hashNavigation.enabled) {
	        swiper.hashNavigation.init();
	      }
	    },
	    destroy: function destroy(swiper) {
	      if (swiper.params.hashNavigation.enabled) {
	        swiper.hashNavigation.destroy();
	      }
	    },
	    'transitionEnd _freeModeNoMomentumRelease': function transitionEnd_freeModeNoMomentumRelease(swiper) {
	      if (swiper.hashNavigation.initialized) {
	        swiper.hashNavigation.setHash();
	      }
	    },
	    slideChange: function slideChange(swiper) {
	      if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
	        swiper.hashNavigation.setHash();
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _utils = __webpack_require__(26);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var History = {
	  init: function init() {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	    if (!swiper.params.history) return;
	
	    if (!window.history || !window.history.pushState) {
	      swiper.params.history.enabled = false;
	      swiper.params.hashNavigation.enabled = true;
	      return;
	    }
	
	    var history = swiper.history;
	    history.initialized = true;
	    history.paths = History.getPathValues(swiper.params.url);
	    if (!history.paths.key && !history.paths.value) return;
	    history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
	
	    if (!swiper.params.history.replaceState) {
	      window.addEventListener('popstate', swiper.history.setHistoryPopState);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	
	    if (!swiper.params.history.replaceState) {
	      window.removeEventListener('popstate', swiper.history.setHistoryPopState);
	    }
	  },
	  setHistoryPopState: function setHistoryPopState() {
	    var swiper = this;
	    swiper.history.paths = History.getPathValues(swiper.params.url);
	    swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
	  },
	  getPathValues: function getPathValues(urlOverride) {
	    var window = (0, _ssrWindow.getWindow)();
	    var location;
	
	    if (urlOverride) {
	      location = new URL(urlOverride);
	    } else {
	      location = window.location;
	    }
	
	    var pathArray = location.pathname.slice(1).split('/').filter(function (part) {
	      return part !== '';
	    });
	    var total = pathArray.length;
	    var key = pathArray[total - 2];
	    var value = pathArray[total - 1];
	    return {
	      key: key,
	      value: value
	    };
	  },
	  setHistory: function setHistory(key, index) {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	    if (!swiper.history.initialized || !swiper.params.history.enabled) return;
	    var location;
	
	    if (swiper.params.url) {
	      location = new URL(swiper.params.url);
	    } else {
	      location = window.location;
	    }
	
	    var slide = swiper.slides.eq(index);
	    var value = History.slugify(slide.attr('data-history'));
	
	    if (swiper.params.history.root.length > 0) {
	      var root = swiper.params.history.root;
	      if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
	      value = root + "/" + key + "/" + value;
	    } else if (!location.pathname.includes(key)) {
	      value = key + "/" + value;
	    }
	
	    var currentState = window.history.state;
	
	    if (currentState && currentState.value === value) {
	      return;
	    }
	
	    if (swiper.params.history.replaceState) {
	      window.history.replaceState({
	        value: value
	      }, null, value);
	    } else {
	      window.history.pushState({
	        value: value
	      }, null, value);
	    }
	  },
	  slugify: function slugify(text) {
	    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
	  },
	  scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
	    var swiper = this;
	
	    if (value) {
	      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	        var slide = swiper.slides.eq(i);
	        var slideHistory = History.slugify(slide.attr('data-history'));
	
	        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	          var index = slide.index();
	          swiper.slideTo(index, speed, runCallbacks);
	        }
	      }
	    } else {
	      swiper.slideTo(0, speed, runCallbacks);
	    }
	  }
	};
	var _default = {
	  name: 'history',
	  params: {
	    history: {
	      enabled: false,
	      root: '',
	      replaceState: false,
	      key: 'slides'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      history: _extends({}, History)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (swiper.params.history.enabled) {
	        swiper.history.init();
	      }
	    },
	    destroy: function destroy(swiper) {
	      if (swiper.params.history.enabled) {
	        swiper.history.destroy();
	      }
	    },
	    'transitionEnd _freeModeNoMomentumRelease': function transitionEnd_freeModeNoMomentumRelease(swiper) {
	      if (swiper.history.initialized) {
	        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
	      }
	    },
	    slideChange: function slideChange(swiper) {
	      if (swiper.history.initialized && swiper.params.cssMode) {
	        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Keyboard = {
	  handle: function handle(event) {
	    var swiper = this;
	    if (!swiper.enabled) return;
	    var window = (0, _ssrWindow.getWindow)();
	    var document = (0, _ssrWindow.getDocument)();
	    var rtl = swiper.rtlTranslate;
	    var e = event;
	    if (e.originalEvent) e = e.originalEvent; // jquery fix
	
	    var kc = e.keyCode || e.charCode;
	    var pageUpDown = swiper.params.keyboard.pageUpDown;
	    var isPageUp = pageUpDown && kc === 33;
	    var isPageDown = pageUpDown && kc === 34;
	    var isArrowLeft = kc === 37;
	    var isArrowRight = kc === 39;
	    var isArrowUp = kc === 38;
	    var isArrowDown = kc === 40; // Directions locks
	
	    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
	      return false;
	    }
	
	    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
	      return false;
	    }
	
	    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
	      return undefined;
	    }
	
	    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
	      return undefined;
	    }
	
	    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
	      var inView = false; // Check that swiper should be inside of visible area of window
	
	      if (swiper.$el.parents("." + swiper.params.slideClass).length > 0 && swiper.$el.parents("." + swiper.params.slideActiveClass).length === 0) {
	        return undefined;
	      }
	
	      var $el = swiper.$el;
	      var swiperWidth = $el[0].clientWidth;
	      var swiperHeight = $el[0].clientHeight;
	      var windowWidth = window.innerWidth;
	      var windowHeight = window.innerHeight;
	      var swiperOffset = swiper.$el.offset();
	      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
	      var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];
	
	      for (var i = 0; i < swiperCoord.length; i += 1) {
	        var point = swiperCoord[i];
	
	        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
	          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
	
	          inView = true;
	        }
	      }
	
	      if (!inView) return undefined;
	    }
	
	    if (swiper.isHorizontal()) {
	      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
	        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
	      }
	
	      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
	      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
	    } else {
	      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
	        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
	      }
	
	      if (isPageDown || isArrowDown) swiper.slideNext();
	      if (isPageUp || isArrowUp) swiper.slidePrev();
	    }
	
	    swiper.emit('keyPress', kc);
	    return undefined;
	  },
	  enable: function enable() {
	    var swiper = this;
	    var document = (0, _ssrWindow.getDocument)();
	    if (swiper.keyboard.enabled) return;
	    (0, _dom.default)(document).on('keydown', swiper.keyboard.handle);
	    swiper.keyboard.enabled = true;
	  },
	  disable: function disable() {
	    var swiper = this;
	    var document = (0, _ssrWindow.getDocument)();
	    if (!swiper.keyboard.enabled) return;
	    (0, _dom.default)(document).off('keydown', swiper.keyboard.handle);
	    swiper.keyboard.enabled = false;
	  }
	};
	var _default = {
	  name: 'keyboard',
	  params: {
	    keyboard: {
	      enabled: false,
	      onlyInViewport: true,
	      pageUpDown: true
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      keyboard: _extends({
	        enabled: false
	      }, Keyboard)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (swiper.params.keyboard.enabled) {
	        swiper.keyboard.enable();
	      }
	    },
	    destroy: function destroy(swiper) {
	      if (swiper.keyboard.enabled) {
	        swiper.keyboard.disable();
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Lazy = {
	  loadInSlide: function loadInSlide(index, loadInDuplicate) {
	    if (loadInDuplicate === void 0) {
	      loadInDuplicate = true;
	    }
	
	    var swiper = this;
	    var params = swiper.params.lazy;
	    if (typeof index === 'undefined') return;
	    if (swiper.slides.length === 0) return;
	    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	    var $slideEl = isVirtual ? swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + index + "\"]") : swiper.slides.eq(index);
	    var $images = $slideEl.find("." + params.elementClass + ":not(." + params.loadedClass + "):not(." + params.loadingClass + ")");
	
	    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
	      $images.push($slideEl[0]);
	    }
	
	    if ($images.length === 0) return;
	    $images.each(function (imageEl) {
	      var $imageEl = (0, _dom.default)(imageEl);
	      $imageEl.addClass(params.loadingClass);
	      var background = $imageEl.attr('data-background');
	      var src = $imageEl.attr('data-src');
	      var srcset = $imageEl.attr('data-srcset');
	      var sizes = $imageEl.attr('data-sizes');
	      var $pictureEl = $imageEl.parent('picture');
	      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
	        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
	
	        if (background) {
	          $imageEl.css('background-image', "url(\"" + background + "\")");
	          $imageEl.removeAttr('data-background');
	        } else {
	          if (srcset) {
	            $imageEl.attr('srcset', srcset);
	            $imageEl.removeAttr('data-srcset');
	          }
	
	          if (sizes) {
	            $imageEl.attr('sizes', sizes);
	            $imageEl.removeAttr('data-sizes');
	          }
	
	          if ($pictureEl.length) {
	            $pictureEl.children('source').each(function (sourceEl) {
	              var $source = (0, _dom.default)(sourceEl);
	
	              if ($source.attr('data-srcset')) {
	                $source.attr('srcset', $source.attr('data-srcset'));
	                $source.removeAttr('data-srcset');
	              }
	            });
	          }
	
	          if (src) {
	            $imageEl.attr('src', src);
	            $imageEl.removeAttr('data-src');
	          }
	        }
	
	        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
	        $slideEl.find("." + params.preloaderClass).remove();
	
	        if (swiper.params.loop && loadInDuplicate) {
	          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
	
	          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
	            var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + swiper.params.slideDuplicateClass + ")");
	            swiper.lazy.loadInSlide(originalSlide.index(), false);
	          } else {
	            var duplicatedSlide = swiper.$wrapperEl.children("." + swiper.params.slideDuplicateClass + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]");
	            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
	          }
	        }
	
	        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
	
	        if (swiper.params.autoHeight) {
	          swiper.updateAutoHeight();
	        }
	      });
	      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
	    });
	  },
	  load: function load() {
	    var swiper = this;
	    var $wrapperEl = swiper.$wrapperEl,
	        swiperParams = swiper.params,
	        slides = swiper.slides,
	        activeIndex = swiper.activeIndex;
	    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
	    var params = swiperParams.lazy;
	    var slidesPerView = swiperParams.slidesPerView;
	
	    if (slidesPerView === 'auto') {
	      slidesPerView = 0;
	    }
	
	    function slideExist(index) {
	      if (isVirtual) {
	        if ($wrapperEl.children("." + swiperParams.slideClass + "[data-swiper-slide-index=\"" + index + "\"]").length) {
	          return true;
	        }
	      } else if (slides[index]) return true;
	
	      return false;
	    }
	
	    function slideIndex(slideEl) {
	      if (isVirtual) {
	        return (0, _dom.default)(slideEl).attr('data-swiper-slide-index');
	      }
	
	      return (0, _dom.default)(slideEl).index();
	    }
	
	    if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
	
	    if (swiper.params.watchSlidesVisibility) {
	      $wrapperEl.children("." + swiperParams.slideVisibleClass).each(function (slideEl) {
	        var index = isVirtual ? (0, _dom.default)(slideEl).attr('data-swiper-slide-index') : (0, _dom.default)(slideEl).index();
	        swiper.lazy.loadInSlide(index);
	      });
	    } else if (slidesPerView > 1) {
	      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
	        if (slideExist(i)) swiper.lazy.loadInSlide(i);
	      }
	    } else {
	      swiper.lazy.loadInSlide(activeIndex);
	    }
	
	    if (params.loadPrevNext) {
	      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
	        var amount = params.loadPrevNextAmount;
	        var spv = slidesPerView;
	        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
	        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
	
	        for (var _i = activeIndex + slidesPerView; _i < maxIndex; _i += 1) {
	          if (slideExist(_i)) swiper.lazy.loadInSlide(_i);
	        } // Prev Slides
	
	
	        for (var _i2 = minIndex; _i2 < activeIndex; _i2 += 1) {
	          if (slideExist(_i2)) swiper.lazy.loadInSlide(_i2);
	        }
	      } else {
	        var nextSlide = $wrapperEl.children("." + swiperParams.slideNextClass);
	        if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
	        var prevSlide = $wrapperEl.children("." + swiperParams.slidePrevClass);
	        if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
	      }
	    }
	  },
	  checkInViewOnLoad: function checkInViewOnLoad() {
	    var window = (0, _ssrWindow.getWindow)();
	    var swiper = this;
	    if (!swiper || swiper.destroyed) return;
	    var $scrollElement = swiper.params.lazy.scrollingElement ? (0, _dom.default)(swiper.params.lazy.scrollingElement) : (0, _dom.default)(window);
	    var isWindow = $scrollElement[0] === window;
	    var scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
	    var scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
	    var swiperOffset = swiper.$el.offset();
	    var rtl = swiper.rtlTranslate;
	    var inView = false;
	    if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
	    var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
	
	    for (var i = 0; i < swiperCoord.length; i += 1) {
	      var point = swiperCoord[i];
	
	      if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
	        if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
	
	        inView = true;
	      }
	    }
	
	    var passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
	      passive: true,
	      capture: false
	    } : false;
	
	    if (inView) {
	      swiper.lazy.load();
	      $scrollElement.off('scroll', swiper.lazy.checkInViewOnLoad, passiveListener);
	    } else if (!swiper.lazy.scrollHandlerAttached) {
	      swiper.lazy.scrollHandlerAttached = true;
	      $scrollElement.on('scroll', swiper.lazy.checkInViewOnLoad, passiveListener);
	    }
	  }
	};
	var _default = {
	  name: 'lazy',
	  params: {
	    lazy: {
	      checkInView: false,
	      enabled: false,
	      loadPrevNext: false,
	      loadPrevNextAmount: 1,
	      loadOnTransitionStart: false,
	      scrollingElement: '',
	      elementClass: 'swiper-lazy',
	      loadingClass: 'swiper-lazy-loading',
	      loadedClass: 'swiper-lazy-loaded',
	      preloaderClass: 'swiper-lazy-preloader'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      lazy: _extends({
	        initialImageLoaded: false
	      }, Lazy)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
	        swiper.params.preloadImages = false;
	      }
	    },
	    init: function init(swiper) {
	      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
	        if (swiper.params.lazy.checkInView) {
	          swiper.lazy.checkInViewOnLoad();
	        } else {
	          swiper.lazy.load();
	        }
	      }
	    },
	    scroll: function scroll(swiper) {
	      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
	        swiper.lazy.load();
	      }
	    },
	    'scrollbarDragMove resize _freeModeNoMomentumRelease': function lazyLoad(swiper) {
	      if (swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    },
	    transitionStart: function transitionStart(swiper) {
	      if (swiper.params.lazy.enabled) {
	        if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
	          swiper.lazy.load();
	        }
	      }
	    },
	    transitionEnd: function transitionEnd(swiper) {
	      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
	        swiper.lazy.load();
	      }
	    },
	    slideChange: function slideChange(swiper) {
	      var _swiper$params = swiper.params,
	          lazy = _swiper$params.lazy,
	          cssMode = _swiper$params.cssMode,
	          watchSlidesVisibility = _swiper$params.watchSlidesVisibility,
	          watchSlidesProgress = _swiper$params.watchSlidesProgress,
	          touchReleaseOnEdges = _swiper$params.touchReleaseOnEdges,
	          resistanceRatio = _swiper$params.resistanceRatio;
	
	      if (lazy.enabled && (cssMode || (watchSlidesVisibility || watchSlidesProgress) && (touchReleaseOnEdges || resistanceRatio === 0))) {
	        swiper.lazy.load();
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable consistent-return */
	function isEventSupported() {
	  var document = (0, _ssrWindow.getDocument)();
	  var eventName = 'onwheel';
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true) {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	var Mousewheel = {
	  lastScrollTime: (0, _utils.now)(),
	  lastEventBeforeSnap: undefined,
	  recentWheelEvents: [],
	  event: function event() {
	    var window = (0, _ssrWindow.getWindow)();
	    if (window.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
	    return isEventSupported() ? 'wheel' : 'mousewheel';
	  },
	  normalize: function normalize(e) {
	    // Reasonable defaults
	    var PIXEL_STEP = 10;
	    var LINE_HEIGHT = 40;
	    var PAGE_HEIGHT = 800;
	    var sX = 0;
	    var sY = 0; // spinX, spinY
	
	    var pX = 0;
	    var pY = 0; // pixelX, pixelY
	    // Legacy
	
	    if ('detail' in e) {
	      sY = e.detail;
	    }
	
	    if ('wheelDelta' in e) {
	      sY = -e.wheelDelta / 120;
	    }
	
	    if ('wheelDeltaY' in e) {
	      sY = -e.wheelDeltaY / 120;
	    }
	
	    if ('wheelDeltaX' in e) {
	      sX = -e.wheelDeltaX / 120;
	    } // side scrolling on FF with DOMMouseScroll
	
	
	    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
	      sX = sY;
	      sY = 0;
	    }
	
	    pX = sX * PIXEL_STEP;
	    pY = sY * PIXEL_STEP;
	
	    if ('deltaY' in e) {
	      pY = e.deltaY;
	    }
	
	    if ('deltaX' in e) {
	      pX = e.deltaX;
	    }
	
	    if (e.shiftKey && !pX) {
	      // if user scrolls with shift he wants horizontal scroll
	      pX = pY;
	      pY = 0;
	    }
	
	    if ((pX || pY) && e.deltaMode) {
	      if (e.deltaMode === 1) {
	        // delta in LINE units
	        pX *= LINE_HEIGHT;
	        pY *= LINE_HEIGHT;
	      } else {
	        // delta in PAGE units
	        pX *= PAGE_HEIGHT;
	        pY *= PAGE_HEIGHT;
	      }
	    } // Fall-back if spin cannot be determined
	
	
	    if (pX && !sX) {
	      sX = pX < 1 ? -1 : 1;
	    }
	
	    if (pY && !sY) {
	      sY = pY < 1 ? -1 : 1;
	    }
	
	    return {
	      spinX: sX,
	      spinY: sY,
	      pixelX: pX,
	      pixelY: pY
	    };
	  },
	  handleMouseEnter: function handleMouseEnter() {
	    var swiper = this;
	    if (!swiper.enabled) return;
	    swiper.mouseEntered = true;
	  },
	  handleMouseLeave: function handleMouseLeave() {
	    var swiper = this;
	    if (!swiper.enabled) return;
	    swiper.mouseEntered = false;
	  },
	  handle: function handle(event) {
	    var e = event;
	    var disableParentSwiper = true;
	    var swiper = this;
	    if (!swiper.enabled) return;
	    var params = swiper.params.mousewheel;
	
	    if (swiper.params.cssMode) {
	      e.preventDefault();
	    }
	
	    var target = swiper.$el;
	
	    if (swiper.params.mousewheel.eventsTarget !== 'container') {
	      target = (0, _dom.default)(swiper.params.mousewheel.eventsTarget);
	    }
	
	    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
	    if (e.originalEvent) e = e.originalEvent; // jquery fix
	
	    var delta = 0;
	    var rtlFactor = swiper.rtlTranslate ? -1 : 1;
	    var data = Mousewheel.normalize(e);
	
	    if (params.forceToAxis) {
	      if (swiper.isHorizontal()) {
	        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
	      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
	    } else {
	      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
	    }
	
	    if (delta === 0) return true;
	    if (params.invert) delta = -delta; // Get the scroll positions
	
	    var positions = swiper.getTranslate() + delta * params.sensitivity;
	    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
	    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
	    //     the disableParentSwiper will be true.
	    // When loop is false:
	    //     if the scroll positions is not on edge,
	    //     then the disableParentSwiper will be true.
	    //     if the scroll on edge positions,
	    //     then the disableParentSwiper will be false.
	
	    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
	    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
	
	    if (!swiper.params.freeMode) {
	      // Register the new event in a variable which stores the relevant data
	      var newEvent = {
	        time: (0, _utils.now)(),
	        delta: Math.abs(delta),
	        direction: Math.sign(delta),
	        raw: event
	      }; // Keep the most recent events
	
	      var recentWheelEvents = swiper.mousewheel.recentWheelEvents;
	
	      if (recentWheelEvents.length >= 2) {
	        recentWheelEvents.shift(); // only store the last N events
	      }
	
	      var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
	      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
	      //   If direction has changed or
	      //   if the scroll is quicker than the previous one:
	      //     Animate the slider.
	      // Else (this is the first time the wheel is moved):
	      //     Animate the slider.
	
	      if (prevEvent) {
	        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
	          swiper.mousewheel.animateSlider(newEvent);
	        }
	      } else {
	        swiper.mousewheel.animateSlider(newEvent);
	      } // If it's time to release the scroll:
	      //   Return now so you don't hit the preventDefault.
	
	
	      if (swiper.mousewheel.releaseScroll(newEvent)) {
	        return true;
	      }
	    } else {
	      // Freemode or scrollContainer:
	      // If we recently snapped after a momentum scroll, then ignore wheel events
	      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
	      // or if it's a new scroll (larger delta or inverse sign as last event before
	      // an end-of-momentum snap).
	      var _newEvent = {
	        time: (0, _utils.now)(),
	        delta: Math.abs(delta),
	        direction: Math.sign(delta)
	      };
	      var lastEventBeforeSnap = swiper.mousewheel.lastEventBeforeSnap;
	      var ignoreWheelEvents = lastEventBeforeSnap && _newEvent.time < lastEventBeforeSnap.time + 500 && _newEvent.delta <= lastEventBeforeSnap.delta && _newEvent.direction === lastEventBeforeSnap.direction;
	
	      if (!ignoreWheelEvents) {
	        swiper.mousewheel.lastEventBeforeSnap = undefined;
	
	        if (swiper.params.loop) {
	          swiper.loopFix();
	        }
	
	        var position = swiper.getTranslate() + delta * params.sensitivity;
	        var wasBeginning = swiper.isBeginning;
	        var wasEnd = swiper.isEnd;
	        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
	        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
	        swiper.setTransition(0);
	        swiper.setTranslate(position);
	        swiper.updateProgress();
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	
	        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
	          swiper.updateSlidesClasses();
	        }
	
	        if (swiper.params.freeModeSticky) {
	          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
	          // the end of a momentum scroll by storing recent (N=15?) wheel events.
	          // 1. do all N events have decreasing or same (absolute value) delta?
	          // 2. did all N events arrive in the last M (M=500?) msecs?
	          // 3. does the earliest event have an (absolute value) delta that's
	          //    at least P (P=1?) larger than the most recent event's delta?
	          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
	          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
	          // Snap immediately and ignore remaining wheel events in this scroll.
	          // See comment above for "remaining wheel events in this scroll" determination.
	          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
	          clearTimeout(swiper.mousewheel.timeout);
	          swiper.mousewheel.timeout = undefined;
	          var _recentWheelEvents = swiper.mousewheel.recentWheelEvents;
	
	          if (_recentWheelEvents.length >= 15) {
	            _recentWheelEvents.shift(); // only store the last N events
	
	          }
	
	          var _prevEvent = _recentWheelEvents.length ? _recentWheelEvents[_recentWheelEvents.length - 1] : undefined;
	
	          var firstEvent = _recentWheelEvents[0];
	
	          _recentWheelEvents.push(_newEvent);
	
	          if (_prevEvent && (_newEvent.delta > _prevEvent.delta || _newEvent.direction !== _prevEvent.direction)) {
	            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
	            _recentWheelEvents.splice(0);
	          } else if (_recentWheelEvents.length >= 15 && _newEvent.time - firstEvent.time < 500 && firstEvent.delta - _newEvent.delta >= 1 && _newEvent.delta <= 6) {
	            // We're at the end of the deceleration of a momentum scroll, so there's no need
	            // to wait for more events. Snap ASAP on the next tick.
	            // Also, because there's some remaining momentum we'll bias the snap in the
	            // direction of the ongoing scroll because it's better UX for the scroll to snap
	            // in the same direction as the scroll instead of reversing to snap.  Therefore,
	            // if it's already scrolled more than 20% in the current direction, keep going.
	            var snapToThreshold = delta > 0 ? 0.8 : 0.2;
	            swiper.mousewheel.lastEventBeforeSnap = _newEvent;
	
	            _recentWheelEvents.splice(0);
	
	            swiper.mousewheel.timeout = (0, _utils.nextTick)(function () {
	              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
	            }, 0); // no delay; move on next tick
	          }
	
	          if (!swiper.mousewheel.timeout) {
	            // if we get here, then we haven't detected the end of a momentum scroll, so
	            // we'll consider a scroll "complete" when there haven't been any wheel events
	            // for 500ms.
	            swiper.mousewheel.timeout = (0, _utils.nextTick)(function () {
	              var snapToThreshold = 0.5;
	              swiper.mousewheel.lastEventBeforeSnap = _newEvent;
	
	              _recentWheelEvents.splice(0);
	
	              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
	            }, 500);
	          }
	        } // Emit event
	
	
	        if (!ignoreWheelEvents) swiper.emit('scroll', e); // Stop autoplay
	
	        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
	
	        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
	      }
	    }
	
	    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
	    return false;
	  },
	  animateSlider: function animateSlider(newEvent) {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	
	    if (this.params.mousewheel.thresholdDelta && newEvent.delta < this.params.mousewheel.thresholdDelta) {
	      // Prevent if delta of wheel scroll delta is below configured threshold
	      return false;
	    }
	
	    if (this.params.mousewheel.thresholdTime && (0, _utils.now)() - swiper.mousewheel.lastScrollTime < this.params.mousewheel.thresholdTime) {
	      // Prevent if time between scrolls is below configured threshold
	      return false;
	    } // If the movement is NOT big enough and
	    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
	    //   Don't go any further (avoid insignificant scroll movement).
	
	
	    if (newEvent.delta >= 6 && (0, _utils.now)() - swiper.mousewheel.lastScrollTime < 60) {
	      // Return false as a default
	      return true;
	    } // If user is scrolling towards the end:
	    //   If the slider hasn't hit the latest slide or
	    //   if the slider is a loop and
	    //   if the slider isn't moving right now:
	    //     Go to next slide and
	    //     emit a scroll event.
	    // Else (the user is scrolling towards the beginning) and
	    // if the slider hasn't hit the first slide or
	    // if the slider is a loop and
	    // if the slider isn't moving right now:
	    //   Go to prev slide and
	    //   emit a scroll event.
	
	
	    if (newEvent.direction < 0) {
	      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
	        swiper.slideNext();
	        swiper.emit('scroll', newEvent.raw);
	      }
	    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
	      swiper.slidePrev();
	      swiper.emit('scroll', newEvent.raw);
	    } // If you got here is because an animation has been triggered so store the current time
	
	
	    swiper.mousewheel.lastScrollTime = new window.Date().getTime(); // Return false as a default
	
	    return false;
	  },
	  releaseScroll: function releaseScroll(newEvent) {
	    var swiper = this;
	    var params = swiper.params.mousewheel;
	
	    if (newEvent.direction < 0) {
	      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
	        // Return true to animate scroll on edges
	        return true;
	      }
	    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
	      // Return true to animate scroll on edges
	      return true;
	    }
	
	    return false;
	  },
	  enable: function enable() {
	    var swiper = this;
	    var event = Mousewheel.event();
	
	    if (swiper.params.cssMode) {
	      swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
	      return true;
	    }
	
	    if (!event) return false;
	    if (swiper.mousewheel.enabled) return false;
	    var target = swiper.$el;
	
	    if (swiper.params.mousewheel.eventsTarget !== 'container') {
	      target = (0, _dom.default)(swiper.params.mousewheel.eventsTarget);
	    }
	
	    target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
	    target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
	    target.on(event, swiper.mousewheel.handle);
	    swiper.mousewheel.enabled = true;
	    return true;
	  },
	  disable: function disable() {
	    var swiper = this;
	    var event = Mousewheel.event();
	
	    if (swiper.params.cssMode) {
	      swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
	      return true;
	    }
	
	    if (!event) return false;
	    if (!swiper.mousewheel.enabled) return false;
	    var target = swiper.$el;
	
	    if (swiper.params.mousewheel.eventsTarget !== 'container') {
	      target = (0, _dom.default)(swiper.params.mousewheel.eventsTarget);
	    }
	
	    target.off(event, swiper.mousewheel.handle);
	    swiper.mousewheel.enabled = false;
	    return true;
	  }
	};
	var _default = {
	  name: 'mousewheel',
	  params: {
	    mousewheel: {
	      enabled: false,
	      releaseOnEdges: false,
	      invert: false,
	      forceToAxis: false,
	      sensitivity: 1,
	      eventsTarget: 'container',
	      thresholdDelta: null,
	      thresholdTime: null
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      mousewheel: {
	        enabled: false,
	        lastScrollTime: (0, _utils.now)(),
	        lastEventBeforeSnap: undefined,
	        recentWheelEvents: [],
	        enable: Mousewheel.enable,
	        disable: Mousewheel.disable,
	        handle: Mousewheel.handle,
	        handleMouseEnter: Mousewheel.handleMouseEnter,
	        handleMouseLeave: Mousewheel.handleMouseLeave,
	        animateSlider: Mousewheel.animateSlider,
	        releaseScroll: Mousewheel.releaseScroll
	      }
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
	        swiper.mousewheel.disable();
	      }
	
	      if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
	    },
	    destroy: function destroy(swiper) {
	      if (swiper.params.cssMode) {
	        swiper.mousewheel.enable();
	      }
	
	      if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Navigation = {
	  toggleEl: function toggleEl($el, disabled) {
	    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
	    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
	  },
	  update: function update() {
	    // Update Navigation Buttons
	    var swiper = this;
	    var params = swiper.params.navigation;
	    var toggleEl = swiper.navigation.toggleEl;
	    if (swiper.params.loop) return;
	    var _swiper$navigation = swiper.navigation,
	        $nextEl = _swiper$navigation.$nextEl,
	        $prevEl = _swiper$navigation.$prevEl;
	
	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        toggleEl($prevEl, true);
	      } else {
	        toggleEl($prevEl, false);
	      }
	
	      if (swiper.params.watchOverflow && swiper.enabled) {
	        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	      }
	    }
	
	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        toggleEl($nextEl, true);
	      } else {
	        toggleEl($nextEl, false);
	      }
	
	      if (swiper.params.watchOverflow && swiper.enabled) {
	        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	      }
	    }
	  },
	  onPrevClick: function onPrevClick(e) {
	    var swiper = this;
	    e.preventDefault();
	    if (swiper.isBeginning && !swiper.params.loop) return;
	    swiper.slidePrev();
	  },
	  onNextClick: function onNextClick(e) {
	    var swiper = this;
	    e.preventDefault();
	    if (swiper.isEnd && !swiper.params.loop) return;
	    swiper.slideNext();
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.navigation;
	    swiper.params.navigation = (0, _utils.createElementIfNotDefined)(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
	      nextEl: 'swiper-button-next',
	      prevEl: 'swiper-button-prev'
	    });
	    if (!(params.nextEl || params.prevEl)) return;
	    var $nextEl;
	    var $prevEl;
	
	    if (params.nextEl) {
	      $nextEl = (0, _dom.default)(params.nextEl);
	
	      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
	        $nextEl = swiper.$el.find(params.nextEl);
	      }
	    }
	
	    if (params.prevEl) {
	      $prevEl = (0, _dom.default)(params.prevEl);
	
	      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
	        $prevEl = swiper.$el.find(params.prevEl);
	      }
	    }
	
	    if ($nextEl && $nextEl.length > 0) {
	      $nextEl.on('click', swiper.navigation.onNextClick);
	    }
	
	    if ($prevEl && $prevEl.length > 0) {
	      $prevEl.on('click', swiper.navigation.onPrevClick);
	    }
	
	    (0, _utils.extend)(swiper.navigation, {
	      $nextEl: $nextEl,
	      nextEl: $nextEl && $nextEl[0],
	      $prevEl: $prevEl,
	      prevEl: $prevEl && $prevEl[0]
	    });
	
	    if (!swiper.enabled) {
	      if ($nextEl) $nextEl.addClass(params.lockClass);
	      if ($prevEl) $prevEl.addClass(params.lockClass);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var _swiper$navigation2 = swiper.navigation,
	        $nextEl = _swiper$navigation2.$nextEl,
	        $prevEl = _swiper$navigation2.$prevEl;
	
	    if ($nextEl && $nextEl.length) {
	      $nextEl.off('click', swiper.navigation.onNextClick);
	      $nextEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	
	    if ($prevEl && $prevEl.length) {
	      $prevEl.off('click', swiper.navigation.onPrevClick);
	      $prevEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	  }
	};
	var _default = {
	  name: 'navigation',
	  params: {
	    navigation: {
	      nextEl: null,
	      prevEl: null,
	      hideOnClick: false,
	      disabledClass: 'swiper-button-disabled',
	      hiddenClass: 'swiper-button-hidden',
	      lockClass: 'swiper-button-lock'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      navigation: _extends({}, Navigation)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      swiper.navigation.init();
	      swiper.navigation.update();
	    },
	    toEdge: function toEdge(swiper) {
	      swiper.navigation.update();
	    },
	    fromEdge: function fromEdge(swiper) {
	      swiper.navigation.update();
	    },
	    destroy: function destroy(swiper) {
	      swiper.navigation.destroy();
	    },
	    'enable disable': function enableDisable(swiper) {
	      var _swiper$navigation3 = swiper.navigation,
	          $nextEl = _swiper$navigation3.$nextEl,
	          $prevEl = _swiper$navigation3.$prevEl;
	
	      if ($nextEl) {
	        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
	      }
	
	      if ($prevEl) {
	        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
	      }
	    },
	    click: function click(swiper, e) {
	      var _swiper$navigation4 = swiper.navigation,
	          $nextEl = _swiper$navigation4.$nextEl,
	          $prevEl = _swiper$navigation4.$prevEl;
	      var targetEl = e.target;
	
	      if (swiper.params.navigation.hideOnClick && !(0, _dom.default)(targetEl).is($prevEl) && !(0, _dom.default)(targetEl).is($nextEl)) {
	        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
	        var isHidden;
	
	        if ($nextEl) {
	          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
	        } else if ($prevEl) {
	          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
	        }
	
	        if (isHidden === true) {
	          swiper.emit('navigationShow');
	        } else {
	          swiper.emit('navigationHide');
	        }
	
	        if ($nextEl) {
	          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
	        }
	
	        if ($prevEl) {
	          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
	        }
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Pagination = {
	  update: function update() {
	    // Render || Update Pagination bullets/items
	    var swiper = this;
	    var rtl = swiper.rtl;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    var $el = swiper.pagination.$el; // Current/Total
	
	    var current;
	    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	
	    if (swiper.params.loop) {
	      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
	
	      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
	        current -= slidesLength - swiper.loopedSlides * 2;
	      }
	
	      if (current > total - 1) current -= total;
	      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
	    } else if (typeof swiper.snapIndex !== 'undefined') {
	      current = swiper.snapIndex;
	    } else {
	      current = swiper.activeIndex || 0;
	    } // Types
	
	
	    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	      var bullets = swiper.pagination.bullets;
	      var firstIndex;
	      var lastIndex;
	      var midIndex;
	
	      if (params.dynamicBullets) {
	        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
	        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");
	
	        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
	          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
	
	          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
	            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
	          } else if (swiper.pagination.dynamicBulletIndex < 0) {
	            swiper.pagination.dynamicBulletIndex = 0;
	          }
	        }
	
	        firstIndex = current - swiper.pagination.dynamicBulletIndex;
	        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
	        midIndex = (lastIndex + firstIndex) / 2;
	      }
	
	      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");
	
	      if ($el.length > 1) {
	        bullets.each(function (bullet) {
	          var $bullet = (0, _dom.default)(bullet);
	          var bulletIndex = $bullet.index();
	
	          if (bulletIndex === current) {
	            $bullet.addClass(params.bulletActiveClass);
	          }
	
	          if (params.dynamicBullets) {
	            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
	              $bullet.addClass(params.bulletActiveClass + "-main");
	            }
	
	            if (bulletIndex === firstIndex) {
	              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
	            }
	
	            if (bulletIndex === lastIndex) {
	              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
	            }
	          }
	        });
	      } else {
	        var $bullet = bullets.eq(current);
	        var bulletIndex = $bullet.index();
	        $bullet.addClass(params.bulletActiveClass);
	
	        if (params.dynamicBullets) {
	          var $firstDisplayedBullet = bullets.eq(firstIndex);
	          var $lastDisplayedBullet = bullets.eq(lastIndex);
	
	          for (var i = firstIndex; i <= lastIndex; i += 1) {
	            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
	          }
	
	          if (swiper.params.loop) {
	            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
	              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
	                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
	              }
	
	              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
	            } else {
	              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
	              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
	            }
	          } else {
	            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
	            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
	          }
	        }
	      }
	
	      if (params.dynamicBullets) {
	        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
	        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
	        var offsetProp = rtl ? 'right' : 'left';
	        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
	      }
	    }
	
	    if (params.type === 'fraction') {
	      $el.find((0, _utils.classesToSelector)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
	      $el.find((0, _utils.classesToSelector)(params.totalClass)).text(params.formatFractionTotal(total));
	    }
	
	    if (params.type === 'progressbar') {
	      var progressbarDirection;
	
	      if (params.progressbarOpposite) {
	        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
	      } else {
	        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
	      }
	
	      var scale = (current + 1) / total;
	      var scaleX = 1;
	      var scaleY = 1;
	
	      if (progressbarDirection === 'horizontal') {
	        scaleX = scale;
	      } else {
	        scaleY = scale;
	      }
	
	      $el.find((0, _utils.classesToSelector)(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
	    }
	
	    if (params.type === 'custom' && params.renderCustom) {
	      $el.html(params.renderCustom(swiper, current + 1, total));
	      swiper.emit('paginationRender', $el[0]);
	    } else {
	      swiper.emit('paginationUpdate', $el[0]);
	    }
	
	    if (swiper.params.watchOverflow && swiper.enabled) {
	      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	  },
	  render: function render() {
	    // Render Container
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    var $el = swiper.pagination.$el;
	    var paginationHTML = '';
	
	    if (params.type === 'bullets') {
	      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	
	      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
	        numberOfBullets = slidesLength;
	      }
	
	      for (var i = 0; i < numberOfBullets; i += 1) {
	        if (params.renderBullet) {
	          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	        } else {
	          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
	        }
	      }
	
	      $el.html(paginationHTML);
	      swiper.pagination.bullets = $el.find((0, _utils.classesToSelector)(params.bulletClass));
	    }
	
	    if (params.type === 'fraction') {
	      if (params.renderFraction) {
	        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	      } else {
	        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
	      }
	
	      $el.html(paginationHTML);
	    }
	
	    if (params.type === 'progressbar') {
	      if (params.renderProgressbar) {
	        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	      } else {
	        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
	      }
	
	      $el.html(paginationHTML);
	    }
	
	    if (params.type !== 'custom') {
	      swiper.emit('paginationRender', swiper.pagination.$el[0]);
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    swiper.params.pagination = (0, _utils.createElementIfNotDefined)(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
	      el: 'swiper-pagination'
	    });
	    var params = swiper.params.pagination;
	    if (!params.el) return;
	    var $el = (0, _dom.default)(params.el);
	    if ($el.length === 0) return;
	
	    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
	      $el = swiper.$el.find(params.el);
	    }
	
	    if (params.type === 'bullets' && params.clickable) {
	      $el.addClass(params.clickableClass);
	    }
	
	    $el.addClass(params.modifierClass + params.type);
	
	    if (params.type === 'bullets' && params.dynamicBullets) {
	      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
	      swiper.pagination.dynamicBulletIndex = 0;
	
	      if (params.dynamicMainBullets < 1) {
	        params.dynamicMainBullets = 1;
	      }
	    }
	
	    if (params.type === 'progressbar' && params.progressbarOpposite) {
	      $el.addClass(params.progressbarOppositeClass);
	    }
	
	    if (params.clickable) {
	      $el.on('click', (0, _utils.classesToSelector)(params.bulletClass), function onClick(e) {
	        e.preventDefault();
	        var index = (0, _dom.default)(this).index() * swiper.params.slidesPerGroup;
	        if (swiper.params.loop) index += swiper.loopedSlides;
	        swiper.slideTo(index);
	      });
	    }
	
	    (0, _utils.extend)(swiper.pagination, {
	      $el: $el,
	      el: $el[0]
	    });
	
	    if (!swiper.enabled) {
	      $el.addClass(params.lockClass);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
	    var $el = swiper.pagination.$el;
	    $el.removeClass(params.hiddenClass);
	    $el.removeClass(params.modifierClass + params.type);
	    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
	
	    if (params.clickable) {
	      $el.off('click', (0, _utils.classesToSelector)(params.bulletClass));
	    }
	  }
	};
	var _default = {
	  name: 'pagination',
	  params: {
	    pagination: {
	      el: null,
	      bulletElement: 'span',
	      clickable: false,
	      hideOnClick: false,
	      renderBullet: null,
	      renderProgressbar: null,
	      renderFraction: null,
	      renderCustom: null,
	      progressbarOpposite: false,
	      type: 'bullets',
	      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	      dynamicBullets: false,
	      dynamicMainBullets: 1,
	      formatFractionCurrent: function formatFractionCurrent(number) {
	        return number;
	      },
	      formatFractionTotal: function formatFractionTotal(number) {
	        return number;
	      },
	      bulletClass: 'swiper-pagination-bullet',
	      bulletActiveClass: 'swiper-pagination-bullet-active',
	      modifierClass: 'swiper-pagination-',
	      // NEW
	      currentClass: 'swiper-pagination-current',
	      totalClass: 'swiper-pagination-total',
	      hiddenClass: 'swiper-pagination-hidden',
	      progressbarFillClass: 'swiper-pagination-progressbar-fill',
	      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
	      clickableClass: 'swiper-pagination-clickable',
	      // NEW
	      lockClass: 'swiper-pagination-lock'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      pagination: _extends({
	        dynamicBulletIndex: 0
	      }, Pagination)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      swiper.pagination.init();
	      swiper.pagination.render();
	      swiper.pagination.update();
	    },
	    activeIndexChange: function activeIndexChange(swiper) {
	      if (swiper.params.loop) {
	        swiper.pagination.update();
	      } else if (typeof swiper.snapIndex === 'undefined') {
	        swiper.pagination.update();
	      }
	    },
	    snapIndexChange: function snapIndexChange(swiper) {
	      if (!swiper.params.loop) {
	        swiper.pagination.update();
	      }
	    },
	    slidesLengthChange: function slidesLengthChange(swiper) {
	      if (swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    snapGridLengthChange: function snapGridLengthChange(swiper) {
	      if (!swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    destroy: function destroy(swiper) {
	      swiper.pagination.destroy();
	    },
	    'enable disable': function enableDisable(swiper) {
	      var $el = swiper.pagination.$el;
	
	      if ($el) {
	        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
	      }
	    },
	    click: function click(swiper, e) {
	      var targetEl = e.target;
	
	      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0, _dom.default)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
	        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
	        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
	
	        if (isHidden === true) {
	          swiper.emit('paginationShow');
	        } else {
	          swiper.emit('paginationHide');
	        }
	
	        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Parallax = {
	  setTransform: function setTransform(el, progress) {
	    var swiper = this;
	    var rtl = swiper.rtl;
	    var $el = (0, _dom.default)(el);
	    var rtlFactor = rtl ? -1 : 1;
	    var p = $el.attr('data-swiper-parallax') || '0';
	    var x = $el.attr('data-swiper-parallax-x');
	    var y = $el.attr('data-swiper-parallax-y');
	    var scale = $el.attr('data-swiper-parallax-scale');
	    var opacity = $el.attr('data-swiper-parallax-opacity');
	
	    if (x || y) {
	      x = x || '0';
	      y = y || '0';
	    } else if (swiper.isHorizontal()) {
	      x = p;
	      y = '0';
	    } else {
	      y = p;
	      x = '0';
	    }
	
	    if (x.indexOf('%') >= 0) {
	      x = parseInt(x, 10) * progress * rtlFactor + "%";
	    } else {
	      x = x * progress * rtlFactor + "px";
	    }
	
	    if (y.indexOf('%') >= 0) {
	      y = parseInt(y, 10) * progress + "%";
	    } else {
	      y = y * progress + "px";
	    }
	
	    if (typeof opacity !== 'undefined' && opacity !== null) {
	      var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
	      $el[0].style.opacity = currentOpacity;
	    }
	
	    if (typeof scale === 'undefined' || scale === null) {
	      $el.transform("translate3d(" + x + ", " + y + ", 0px)");
	    } else {
	      var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
	      $el.transform("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")");
	    }
	  },
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var $el = swiper.$el,
	        slides = swiper.slides,
	        progress = swiper.progress,
	        snapGrid = swiper.snapGrid;
	    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (el) {
	      swiper.parallax.setTransform(el, progress);
	    });
	    slides.each(function (slideEl, slideIndex) {
	      var slideProgress = slideEl.progress;
	
	      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
	        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
	      }
	
	      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
	      (0, _dom.default)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (el) {
	        swiper.parallax.setTransform(el, slideProgress);
	      });
	    });
	  },
	  setTransition: function setTransition(duration) {
	    if (duration === void 0) {
	      duration = this.params.speed;
	    }
	
	    var swiper = this;
	    var $el = swiper.$el;
	    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (parallaxEl) {
	      var $parallaxEl = (0, _dom.default)(parallaxEl);
	      var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
	      if (duration === 0) parallaxDuration = 0;
	      $parallaxEl.transition(parallaxDuration);
	    });
	  }
	};
	var _default = {
	  name: 'parallax',
	  params: {
	    parallax: {
	      enabled: false
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      parallax: _extends({}, Parallax)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (!swiper.params.parallax.enabled) return;
	      swiper.params.watchSlidesProgress = true;
	      swiper.originalParams.watchSlidesProgress = true;
	    },
	    init: function init(swiper) {
	      if (!swiper.params.parallax.enabled) return;
	      swiper.parallax.setTranslate();
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (!swiper.params.parallax.enabled) return;
	      swiper.parallax.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      if (!swiper.params.parallax.enabled) return;
	      swiper.parallax.setTransition(duration);
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Scrollbar = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
	    var scrollbar = swiper.scrollbar,
	        rtl = swiper.rtlTranslate,
	        progress = swiper.progress;
	    var dragSize = scrollbar.dragSize,
	        trackSize = scrollbar.trackSize,
	        $dragEl = scrollbar.$dragEl,
	        $el = scrollbar.$el;
	    var params = swiper.params.scrollbar;
	    var newSize = dragSize;
	    var newPos = (trackSize - dragSize) * progress;
	
	    if (rtl) {
	      newPos = -newPos;
	
	      if (newPos > 0) {
	        newSize = dragSize - newPos;
	        newPos = 0;
	      } else if (-newPos + dragSize > trackSize) {
	        newSize = trackSize + newPos;
	      }
	    } else if (newPos < 0) {
	      newSize = dragSize + newPos;
	      newPos = 0;
	    } else if (newPos + dragSize > trackSize) {
	      newSize = trackSize - newPos;
	    }
	
	    if (swiper.isHorizontal()) {
	      $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
	      $dragEl[0].style.width = newSize + "px";
	    } else {
	      $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
	      $dragEl[0].style.height = newSize + "px";
	    }
	
	    if (params.hide) {
	      clearTimeout(swiper.scrollbar.timeout);
	      $el[0].style.opacity = 1;
	      swiper.scrollbar.timeout = setTimeout(function () {
	        $el[0].style.opacity = 0;
	        $el.transition(400);
	      }, 1000);
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
	    swiper.scrollbar.$dragEl.transition(duration);
	  },
	  updateSize: function updateSize() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
	    var scrollbar = swiper.scrollbar;
	    var $dragEl = scrollbar.$dragEl,
	        $el = scrollbar.$el;
	    $dragEl[0].style.width = '';
	    $dragEl[0].style.height = '';
	    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
	    var divider = swiper.size / swiper.virtualSize;
	    var moveDivider = divider * (trackSize / swiper.size);
	    var dragSize;
	
	    if (swiper.params.scrollbar.dragSize === 'auto') {
	      dragSize = trackSize * divider;
	    } else {
	      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
	    }
	
	    if (swiper.isHorizontal()) {
	      $dragEl[0].style.width = dragSize + "px";
	    } else {
	      $dragEl[0].style.height = dragSize + "px";
	    }
	
	    if (divider >= 1) {
	      $el[0].style.display = 'none';
	    } else {
	      $el[0].style.display = '';
	    }
	
	    if (swiper.params.scrollbar.hide) {
	      $el[0].style.opacity = 0;
	    }
	
	    (0, _utils.extend)(scrollbar, {
	      trackSize: trackSize,
	      divider: divider,
	      moveDivider: moveDivider,
	      dragSize: dragSize
	    });
	
	    if (swiper.params.watchOverflow && swiper.enabled) {
	      scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
	    }
	  },
	  getPointerPosition: function getPointerPosition(e) {
	    var swiper = this;
	
	    if (swiper.isHorizontal()) {
	      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
	    }
	
	    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
	  },
	  setDragPosition: function setDragPosition(e) {
	    var swiper = this;
	    var scrollbar = swiper.scrollbar,
	        rtl = swiper.rtlTranslate;
	    var $el = scrollbar.$el,
	        dragSize = scrollbar.dragSize,
	        trackSize = scrollbar.trackSize,
	        dragStartPos = scrollbar.dragStartPos;
	    var positionRatio;
	    positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
	    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
	
	    if (rtl) {
	      positionRatio = 1 - positionRatio;
	    }
	
	    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
	    swiper.updateProgress(position);
	    swiper.setTranslate(position);
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  },
	  onDragStart: function onDragStart(e) {
	    var swiper = this;
	    var params = swiper.params.scrollbar;
	    var scrollbar = swiper.scrollbar,
	        $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el,
	        $dragEl = scrollbar.$dragEl;
	    swiper.scrollbar.isTouched = true;
	    swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
	    e.preventDefault();
	    e.stopPropagation();
	    $wrapperEl.transition(100);
	    $dragEl.transition(100);
	    scrollbar.setDragPosition(e);
	    clearTimeout(swiper.scrollbar.dragTimeout);
	    $el.transition(0);
	
	    if (params.hide) {
	      $el.css('opacity', 1);
	    }
	
	    if (swiper.params.cssMode) {
	      swiper.$wrapperEl.css('scroll-snap-type', 'none');
	    }
	
	    swiper.emit('scrollbarDragStart', e);
	  },
	  onDragMove: function onDragMove(e) {
	    var swiper = this;
	    var scrollbar = swiper.scrollbar,
	        $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el,
	        $dragEl = scrollbar.$dragEl;
	    if (!swiper.scrollbar.isTouched) return;
	    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
	    scrollbar.setDragPosition(e);
	    $wrapperEl.transition(0);
	    $el.transition(0);
	    $dragEl.transition(0);
	    swiper.emit('scrollbarDragMove', e);
	  },
	  onDragEnd: function onDragEnd(e) {
	    var swiper = this;
	    var params = swiper.params.scrollbar;
	    var scrollbar = swiper.scrollbar,
	        $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el;
	    if (!swiper.scrollbar.isTouched) return;
	    swiper.scrollbar.isTouched = false;
	
	    if (swiper.params.cssMode) {
	      swiper.$wrapperEl.css('scroll-snap-type', '');
	      $wrapperEl.transition('');
	    }
	
	    if (params.hide) {
	      clearTimeout(swiper.scrollbar.dragTimeout);
	      swiper.scrollbar.dragTimeout = (0, _utils.nextTick)(function () {
	        $el.css('opacity', 0);
	        $el.transition(400);
	      }, 1000);
	    }
	
	    swiper.emit('scrollbarDragEnd', e);
	
	    if (params.snapOnRelease) {
	      swiper.slideToClosest();
	    }
	  },
	  enableDraggable: function enableDraggable() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) return;
	    var document = (0, _ssrWindow.getDocument)();
	    var scrollbar = swiper.scrollbar,
	        touchEventsTouch = swiper.touchEventsTouch,
	        touchEventsDesktop = swiper.touchEventsDesktop,
	        params = swiper.params,
	        support = swiper.support;
	    var $el = scrollbar.$el;
	    var target = $el[0];
	    var activeListener = support.passiveListener && params.passiveListeners ? {
	      passive: false,
	      capture: false
	    } : false;
	    var passiveListener = support.passiveListener && params.passiveListeners ? {
	      passive: true,
	      capture: false
	    } : false;
	    if (!target) return;
	
	    if (!support.touch) {
	      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	      document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	      document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	    } else {
	      target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
	      target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
	      target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
	    }
	  },
	  disableDraggable: function disableDraggable() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) return;
	    var document = (0, _ssrWindow.getDocument)();
	    var scrollbar = swiper.scrollbar,
	        touchEventsTouch = swiper.touchEventsTouch,
	        touchEventsDesktop = swiper.touchEventsDesktop,
	        params = swiper.params,
	        support = swiper.support;
	    var $el = scrollbar.$el;
	    var target = $el[0];
	    var activeListener = support.passiveListener && params.passiveListeners ? {
	      passive: false,
	      capture: false
	    } : false;
	    var passiveListener = support.passiveListener && params.passiveListeners ? {
	      passive: true,
	      capture: false
	    } : false;
	    if (!target) return;
	
	    if (!support.touch) {
	      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	      document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	      document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	    } else {
	      target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
	      target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
	      target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var scrollbar = swiper.scrollbar,
	        $swiperEl = swiper.$el;
	    swiper.params.scrollbar = (0, _utils.createElementIfNotDefined)($swiperEl, swiper.params.scrollbar, swiper.params.createElements, {
	      el: 'swiper-scrollbar'
	    });
	    var params = swiper.params.scrollbar;
	    if (!params.el) return;
	    var $el = (0, _dom.default)(params.el);
	
	    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
	      $el = $swiperEl.find(params.el);
	    }
	
	    var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);
	
	    if ($dragEl.length === 0) {
	      $dragEl = (0, _dom.default)("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
	      $el.append($dragEl);
	    }
	
	    (0, _utils.extend)(scrollbar, {
	      $el: $el,
	      el: $el[0],
	      $dragEl: $dragEl,
	      dragEl: $dragEl[0]
	    });
	
	    if (params.draggable) {
	      scrollbar.enableDraggable();
	    }
	
	    if ($el) {
	      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    swiper.scrollbar.disableDraggable();
	  }
	};
	var _default = {
	  name: 'scrollbar',
	  params: {
	    scrollbar: {
	      el: null,
	      dragSize: 'auto',
	      hide: false,
	      draggable: false,
	      snapOnRelease: true,
	      lockClass: 'swiper-scrollbar-lock',
	      dragClass: 'swiper-scrollbar-drag'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      scrollbar: _extends({
	        isTouched: false,
	        timeout: null,
	        dragTimeout: null
	      }, Scrollbar)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      swiper.scrollbar.init();
	      swiper.scrollbar.updateSize();
	      swiper.scrollbar.setTranslate();
	    },
	    update: function update(swiper) {
	      swiper.scrollbar.updateSize();
	    },
	    resize: function resize(swiper) {
	      swiper.scrollbar.updateSize();
	    },
	    observerUpdate: function observerUpdate(swiper) {
	      swiper.scrollbar.updateSize();
	    },
	    setTranslate: function setTranslate(swiper) {
	      swiper.scrollbar.setTranslate();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      swiper.scrollbar.setTransition(duration);
	    },
	    'enable disable': function enableDisable(swiper) {
	      var $el = swiper.scrollbar.$el;
	
	      if ($el) {
	        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
	      }
	    },
	    destroy: function destroy(swiper) {
	      swiper.scrollbar.destroy();
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(26);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Thumbs = {
	  init: function init() {
	    var swiper = this;
	    var thumbsParams = swiper.params.thumbs;
	    if (swiper.thumbs.initialized) return false;
	    swiper.thumbs.initialized = true;
	    var SwiperClass = swiper.constructor;
	
	    if (thumbsParams.swiper instanceof SwiperClass) {
	      swiper.thumbs.swiper = thumbsParams.swiper;
	      (0, _utils.extend)(swiper.thumbs.swiper.originalParams, {
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      });
	      (0, _utils.extend)(swiper.thumbs.swiper.params, {
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      });
	    } else if ((0, _utils.isObject)(thumbsParams.swiper)) {
	      swiper.thumbs.swiper = new SwiperClass((0, _utils.extend)({}, thumbsParams.swiper, {
	        watchSlidesVisibility: true,
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      }));
	      swiper.thumbs.swiperCreated = true;
	    }
	
	    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
	    swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
	    return true;
	  },
	  onThumbClick: function onThumbClick() {
	    var swiper = this;
	    var thumbsSwiper = swiper.thumbs.swiper;
	    if (!thumbsSwiper) return;
	    var clickedIndex = thumbsSwiper.clickedIndex;
	    var clickedSlide = thumbsSwiper.clickedSlide;
	    if (clickedSlide && (0, _dom.default)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
	    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
	    var slideToIndex;
	
	    if (thumbsSwiper.params.loop) {
	      slideToIndex = parseInt((0, _dom.default)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	    } else {
	      slideToIndex = clickedIndex;
	    }
	
	    if (swiper.params.loop) {
	      var currentIndex = swiper.activeIndex;
	
	      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
	        swiper.loopFix(); // eslint-disable-next-line
	
	        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	        currentIndex = swiper.activeIndex;
	      }
	
	      var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
	      var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
	      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
	    }
	
	    swiper.slideTo(slideToIndex);
	  },
	  update: function update(initial) {
	    var swiper = this;
	    var thumbsSwiper = swiper.thumbs.swiper;
	    if (!thumbsSwiper) return;
	    var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
	    var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
	    var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
	
	    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
	      var currentThumbsIndex = thumbsSwiper.activeIndex;
	      var newThumbsIndex;
	      var direction;
	
	      if (thumbsSwiper.params.loop) {
	        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
	          thumbsSwiper.loopFix(); // eslint-disable-next-line
	
	          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
	          currentThumbsIndex = thumbsSwiper.activeIndex;
	        } // Find actual thumbs index to slide to
	
	
	        var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
	        var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
	
	        if (typeof prevThumbsIndex === 'undefined') {
	          newThumbsIndex = nextThumbsIndex;
	        } else if (typeof nextThumbsIndex === 'undefined') {
	          newThumbsIndex = prevThumbsIndex;
	        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
	          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
	        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
	          newThumbsIndex = nextThumbsIndex;
	        } else {
	          newThumbsIndex = prevThumbsIndex;
	        }
	
	        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
	      } else {
	        newThumbsIndex = swiper.realIndex;
	        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
	      }
	
	      if (useOffset) {
	        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
	      }
	
	      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
	        if (thumbsSwiper.params.centeredSlides) {
	          if (newThumbsIndex > currentThumbsIndex) {
	            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
	          } else {
	            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
	          }
	        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) {// newThumbsIndex = newThumbsIndex - slidesPerView + 1;
	        }
	
	        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
	      }
	    } // Activate thumbs
	
	
	    var thumbsToActivate = 1;
	    var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
	
	    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
	      thumbsToActivate = swiper.params.slidesPerView;
	    }
	
	    if (!swiper.params.thumbs.multipleActiveThumbs) {
	      thumbsToActivate = 1;
	    }
	
	    thumbsToActivate = Math.floor(thumbsToActivate);
	    thumbsSwiper.slides.removeClass(thumbActiveClass);
	
	    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
	      for (var i = 0; i < thumbsToActivate; i += 1) {
	        thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
	      }
	    } else {
	      for (var _i = 0; _i < thumbsToActivate; _i += 1) {
	        thumbsSwiper.slides.eq(swiper.realIndex + _i).addClass(thumbActiveClass);
	      }
	    }
	  }
	};
	var _default = {
	  name: 'thumbs',
	  params: {
	    thumbs: {
	      swiper: null,
	      multipleActiveThumbs: true,
	      autoScrollOffset: 0,
	      slideThumbActiveClass: 'swiper-slide-thumb-active',
	      thumbsContainerClass: 'swiper-container-thumbs'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      thumbs: _extends({
	        swiper: null,
	        initialized: false
	      }, Thumbs)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      var thumbs = swiper.params.thumbs;
	      if (!thumbs || !thumbs.swiper) return;
	      swiper.thumbs.init();
	      swiper.thumbs.update(true);
	    },
	    slideChange: function slideChange(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    update: function update(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    resize: function resize(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    observerUpdate: function observerUpdate(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      var thumbsSwiper = swiper.thumbs.swiper;
	      if (!thumbsSwiper) return;
	      thumbsSwiper.setTransition(duration);
	    },
	    beforeDestroy: function beforeDestroy(swiper) {
	      var thumbsSwiper = swiper.thumbs.swiper;
	      if (!thumbsSwiper) return;
	
	      if (swiper.thumbs.swiperCreated && thumbsSwiper) {
	        thumbsSwiper.destroy();
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Virtual = {
	  update: function update(force) {
	    var swiper = this;
	    var _swiper$params = swiper.params,
	        slidesPerView = _swiper$params.slidesPerView,
	        slidesPerGroup = _swiper$params.slidesPerGroup,
	        centeredSlides = _swiper$params.centeredSlides;
	    var _swiper$params$virtua = swiper.params.virtual,
	        addSlidesBefore = _swiper$params$virtua.addSlidesBefore,
	        addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
	    var _swiper$virtual = swiper.virtual,
	        previousFrom = _swiper$virtual.from,
	        previousTo = _swiper$virtual.to,
	        slides = _swiper$virtual.slides,
	        previousSlidesGrid = _swiper$virtual.slidesGrid,
	        renderSlide = _swiper$virtual.renderSlide,
	        previousOffset = _swiper$virtual.offset;
	    swiper.updateActiveIndex();
	    var activeIndex = swiper.activeIndex || 0;
	    var offsetProp;
	    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
	    var slidesAfter;
	    var slidesBefore;
	
	    if (centeredSlides) {
	      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
	      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
	    } else {
	      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
	      slidesBefore = slidesPerGroup + addSlidesBefore;
	    }
	
	    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
	    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
	    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
	    (0, _utils.extend)(swiper.virtual, {
	      from: from,
	      to: to,
	      offset: offset,
	      slidesGrid: swiper.slidesGrid
	    });
	
	    function onRendered() {
	      swiper.updateSlides();
	      swiper.updateProgress();
	      swiper.updateSlidesClasses();
	
	      if (swiper.lazy && swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    }
	
	    if (previousFrom === from && previousTo === to && !force) {
	      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
	        swiper.slides.css(offsetProp, offset + "px");
	      }
	
	      swiper.updateProgress();
	      return;
	    }
	
	    if (swiper.params.virtual.renderExternal) {
	      swiper.params.virtual.renderExternal.call(swiper, {
	        offset: offset,
	        from: from,
	        to: to,
	        slides: function getSlides() {
	          var slidesToRender = [];
	
	          for (var i = from; i <= to; i += 1) {
	            slidesToRender.push(slides[i]);
	          }
	
	          return slidesToRender;
	        }()
	      });
	
	      if (swiper.params.virtual.renderExternalUpdate) {
	        onRendered();
	      }
	
	      return;
	    }
	
	    var prependIndexes = [];
	    var appendIndexes = [];
	
	    if (force) {
	      swiper.$wrapperEl.find("." + swiper.params.slideClass).remove();
	    } else {
	      for (var i = previousFrom; i <= previousTo; i += 1) {
	        if (i < from || i > to) {
	          swiper.$wrapperEl.find("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + i + "\"]").remove();
	        }
	      }
	    }
	
	    for (var _i = 0; _i < slides.length; _i += 1) {
	      if (_i >= from && _i <= to) {
	        if (typeof previousTo === 'undefined' || force) {
	          appendIndexes.push(_i);
	        } else {
	          if (_i > previousTo) appendIndexes.push(_i);
	          if (_i < previousFrom) prependIndexes.push(_i);
	        }
	      }
	    }
	
	    appendIndexes.forEach(function (index) {
	      swiper.$wrapperEl.append(renderSlide(slides[index], index));
	    });
	    prependIndexes.sort(function (a, b) {
	      return b - a;
	    }).forEach(function (index) {
	      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
	    });
	    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + "px");
	    onRendered();
	  },
	  renderSlide: function renderSlide(slide, index) {
	    var swiper = this;
	    var params = swiper.params.virtual;
	
	    if (params.cache && swiper.virtual.cache[index]) {
	      return swiper.virtual.cache[index];
	    }
	
	    var $slideEl = params.renderSlide ? (0, _dom.default)(params.renderSlide.call(swiper, slide, index)) : (0, _dom.default)("<div class=\"" + swiper.params.slideClass + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>");
	    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
	    if (params.cache) swiper.virtual.cache[index] = $slideEl;
	    return $slideEl;
	  },
	  appendSlide: function appendSlide(slides) {
	    var swiper = this;
	
	    if (typeof slides === 'object' && 'length' in slides) {
	      for (var i = 0; i < slides.length; i += 1) {
	        if (slides[i]) swiper.virtual.slides.push(slides[i]);
	      }
	    } else {
	      swiper.virtual.slides.push(slides);
	    }
	
	    swiper.virtual.update(true);
	  },
	  prependSlide: function prependSlide(slides) {
	    var swiper = this;
	    var activeIndex = swiper.activeIndex;
	    var newActiveIndex = activeIndex + 1;
	    var numberOfNewSlides = 1;
	
	    if (Array.isArray(slides)) {
	      for (var i = 0; i < slides.length; i += 1) {
	        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
	      }
	
	      newActiveIndex = activeIndex + slides.length;
	      numberOfNewSlides = slides.length;
	    } else {
	      swiper.virtual.slides.unshift(slides);
	    }
	
	    if (swiper.params.virtual.cache) {
	      var cache = swiper.virtual.cache;
	      var newCache = {};
	      Object.keys(cache).forEach(function (cachedIndex) {
	        var $cachedEl = cache[cachedIndex];
	        var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
	
	        if (cachedElIndex) {
	          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
	        }
	
	        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
	      });
	      swiper.virtual.cache = newCache;
	    }
	
	    swiper.virtual.update(true);
	    swiper.slideTo(newActiveIndex, 0);
	  },
	  removeSlide: function removeSlide(slidesIndexes) {
	    var swiper = this;
	    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
	    var activeIndex = swiper.activeIndex;
	
	    if (Array.isArray(slidesIndexes)) {
	      for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
	        swiper.virtual.slides.splice(slidesIndexes[i], 1);
	
	        if (swiper.params.virtual.cache) {
	          delete swiper.virtual.cache[slidesIndexes[i]];
	        }
	
	        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
	        activeIndex = Math.max(activeIndex, 0);
	      }
	    } else {
	      swiper.virtual.slides.splice(slidesIndexes, 1);
	
	      if (swiper.params.virtual.cache) {
	        delete swiper.virtual.cache[slidesIndexes];
	      }
	
	      if (slidesIndexes < activeIndex) activeIndex -= 1;
	      activeIndex = Math.max(activeIndex, 0);
	    }
	
	    swiper.virtual.update(true);
	    swiper.slideTo(activeIndex, 0);
	  },
	  removeAllSlides: function removeAllSlides() {
	    var swiper = this;
	    swiper.virtual.slides = [];
	
	    if (swiper.params.virtual.cache) {
	      swiper.virtual.cache = {};
	    }
	
	    swiper.virtual.update(true);
	    swiper.slideTo(0, 0);
	  }
	};
	var _default = {
	  name: 'virtual',
	  params: {
	    virtual: {
	      enabled: false,
	      slides: [],
	      cache: true,
	      renderSlide: null,
	      renderExternal: null,
	      renderExternalUpdate: true,
	      addSlidesBefore: 0,
	      addSlidesAfter: 0
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      virtual: _extends({}, Virtual, {
	        slides: swiper.params.virtual.slides,
	        cache: {}
	      })
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      if (!swiper.params.virtual.enabled) return;
	      swiper.classNames.push(swiper.params.containerModifierClass + "virtual");
	      var overwriteParams = {
	        watchSlidesProgress: true
	      };
	      (0, _utils.extend)(swiper.params, overwriteParams);
	      (0, _utils.extend)(swiper.originalParams, overwriteParams);
	
	      if (!swiper.params.initialSlide) {
	        swiper.virtual.update();
	      }
	    },
	    setTranslate: function setTranslate(swiper) {
	      if (!swiper.params.virtual.enabled) return;
	      swiper.virtual.update();
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _dom = _interopRequireDefault(__webpack_require__(39));
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Zoom = {
	  // Calc Scale From Multi-touches
	  getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
	    if (e.targetTouches.length < 2) return 1;
	    var x1 = e.targetTouches[0].pageX;
	    var y1 = e.targetTouches[0].pageY;
	    var x2 = e.targetTouches[1].pageX;
	    var y2 = e.targetTouches[1].pageY;
	    var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
	    return distance;
	  },
	  // Events
	  onGestureStart: function onGestureStart(e) {
	    var swiper = this;
	    var support = swiper.support;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    zoom.fakeGestureTouched = false;
	    zoom.fakeGestureMoved = false;
	
	    if (!support.gestures) {
	      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
	        return;
	      }
	
	      zoom.fakeGestureTouched = true;
	      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
	    }
	
	    if (!gesture.$slideEl || !gesture.$slideEl.length) {
	      gesture.$slideEl = (0, _dom.default)(e.target).closest("." + swiper.params.slideClass);
	      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
	      gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
	      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	
	      if (gesture.$imageWrapEl.length === 0) {
	        gesture.$imageEl = undefined;
	        return;
	      }
	    }
	
	    if (gesture.$imageEl) {
	      gesture.$imageEl.transition(0);
	    }
	
	    swiper.zoom.isScaling = true;
	  },
	  onGestureChange: function onGestureChange(e) {
	    var swiper = this;
	    var support = swiper.support;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	
	    if (!support.gestures) {
	      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
	        return;
	      }
	
	      zoom.fakeGestureMoved = true;
	      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
	    }
	
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
	      if (e.type === 'gesturechange') zoom.onGestureStart(e);
	      return;
	    }
	
	    if (support.gestures) {
	      zoom.scale = e.scale * zoom.currentScale;
	    } else {
	      zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
	    }
	
	    if (zoom.scale > gesture.maxRatio) {
	      zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
	    }
	
	    if (zoom.scale < params.minRatio) {
	      zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
	    }
	
	    gesture.$imageEl.transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
	  },
	  onGestureEnd: function onGestureEnd(e) {
	    var swiper = this;
	    var device = swiper.device;
	    var support = swiper.support;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	
	    if (!support.gestures) {
	      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
	        return;
	      }
	
	      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
	        return;
	      }
	
	      zoom.fakeGestureTouched = false;
	      zoom.fakeGestureMoved = false;
	    }
	
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
	    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
	    gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
	    zoom.currentScale = zoom.scale;
	    zoom.isScaling = false;
	    if (zoom.scale === 1) gesture.$slideEl = undefined;
	  },
	  onTouchStart: function onTouchStart(e) {
	    var swiper = this;
	    var device = swiper.device;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture,
	        image = zoom.image;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
	    if (image.isTouched) return;
	    if (device.android && e.cancelable) e.preventDefault();
	    image.isTouched = true;
	    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  },
	  onTouchMove: function onTouchMove(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture,
	        image = zoom.image,
	        velocity = zoom.velocity;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
	    swiper.allowClick = false;
	    if (!image.isTouched || !gesture.$slideEl) return;
	
	    if (!image.isMoved) {
	      image.width = gesture.$imageEl[0].offsetWidth;
	      image.height = gesture.$imageEl[0].offsetHeight;
	      image.startX = (0, _utils.getTranslate)(gesture.$imageWrapEl[0], 'x') || 0;
	      image.startY = (0, _utils.getTranslate)(gesture.$imageWrapEl[0], 'y') || 0;
	      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
	      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
	      gesture.$imageWrapEl.transition(0);
	    } // Define if we need image drag
	
	
	    var scaledWidth = image.width * zoom.scale;
	    var scaledHeight = image.height * zoom.scale;
	    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
	    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
	    image.maxX = -image.minX;
	    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
	    image.maxY = -image.minY;
	    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	
	    if (!image.isMoved && !zoom.isScaling) {
	      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
	        image.isTouched = false;
	        return;
	      }
	
	      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
	        image.isTouched = false;
	        return;
	      }
	    }
	
	    if (e.cancelable) {
	      e.preventDefault();
	    }
	
	    e.stopPropagation();
	    image.isMoved = true;
	    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
	    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
	
	    if (image.currentX < image.minX) {
	      image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
	    }
	
	    if (image.currentX > image.maxX) {
	      image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
	    }
	
	    if (image.currentY < image.minY) {
	      image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
	    }
	
	    if (image.currentY > image.maxY) {
	      image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
	    } // Velocity
	
	
	    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
	    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
	    if (!velocity.prevTime) velocity.prevTime = Date.now();
	    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
	    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
	    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
	    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
	    velocity.prevPositionX = image.touchesCurrent.x;
	    velocity.prevPositionY = image.touchesCurrent.y;
	    velocity.prevTime = Date.now();
	    gesture.$imageWrapEl.transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
	  },
	  onTouchEnd: function onTouchEnd() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture,
	        image = zoom.image,
	        velocity = zoom.velocity;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
	
	    if (!image.isTouched || !image.isMoved) {
	      image.isTouched = false;
	      image.isMoved = false;
	      return;
	    }
	
	    image.isTouched = false;
	    image.isMoved = false;
	    var momentumDurationX = 300;
	    var momentumDurationY = 300;
	    var momentumDistanceX = velocity.x * momentumDurationX;
	    var newPositionX = image.currentX + momentumDistanceX;
	    var momentumDistanceY = velocity.y * momentumDurationY;
	    var newPositionY = image.currentY + momentumDistanceY; // Fix duration
	
	    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
	    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
	    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
	    image.currentX = newPositionX;
	    image.currentY = newPositionY; // Define if we need image drag
	
	    var scaledWidth = image.width * zoom.scale;
	    var scaledHeight = image.height * zoom.scale;
	    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
	    image.maxX = -image.minX;
	    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
	    image.maxY = -image.minY;
	    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
	    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
	    gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
	  },
	  onTransitionEnd: function onTransitionEnd() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	
	    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
	      if (gesture.$imageEl) {
	        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
	      }
	
	      if (gesture.$imageWrapEl) {
	        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
	      }
	
	      zoom.scale = 1;
	      zoom.currentScale = 1;
	      gesture.$slideEl = undefined;
	      gesture.$imageEl = undefined;
	      gesture.$imageWrapEl = undefined;
	    }
	  },
	  // Toggle Zoom
	  toggle: function toggle(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	
	    if (zoom.scale && zoom.scale !== 1) {
	      // Zoom Out
	      zoom.out();
	    } else {
	      // Zoom In
	      zoom.in(e);
	    }
	  },
	  in: function _in(e) {
	    var swiper = this;
	    var window = (0, _ssrWindow.getWindow)();
	    var zoom = swiper.zoom;
	    var params = swiper.params.zoom;
	    var gesture = zoom.gesture,
	        image = zoom.image;
	
	    if (!gesture.$slideEl) {
	      if (e && e.target) {
	        gesture.$slideEl = (0, _dom.default)(e.target).closest("." + swiper.params.slideClass);
	      }
	
	      if (!gesture.$slideEl) {
	        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
	          gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
	        } else {
	          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
	        }
	      }
	
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
	      gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
	    }
	
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
	    gesture.$slideEl.addClass("" + params.zoomedSlideClass);
	    var touchX;
	    var touchY;
	    var offsetX;
	    var offsetY;
	    var diffX;
	    var diffY;
	    var translateX;
	    var translateY;
	    var imageWidth;
	    var imageHeight;
	    var scaledWidth;
	    var scaledHeight;
	    var translateMinX;
	    var translateMinY;
	    var translateMaxX;
	    var translateMaxY;
	    var slideWidth;
	    var slideHeight;
	
	    if (typeof image.touchesStart.x === 'undefined' && e) {
	      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	    } else {
	      touchX = image.touchesStart.x;
	      touchY = image.touchesStart.y;
	    }
	
	    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	
	    if (e) {
	      slideWidth = gesture.$slideEl[0].offsetWidth;
	      slideHeight = gesture.$slideEl[0].offsetHeight;
	      offsetX = gesture.$slideEl.offset().left + window.scrollX;
	      offsetY = gesture.$slideEl.offset().top + window.scrollY;
	      diffX = offsetX + slideWidth / 2 - touchX;
	      diffY = offsetY + slideHeight / 2 - touchY;
	      imageWidth = gesture.$imageEl[0].offsetWidth;
	      imageHeight = gesture.$imageEl[0].offsetHeight;
	      scaledWidth = imageWidth * zoom.scale;
	      scaledHeight = imageHeight * zoom.scale;
	      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
	      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
	      translateMaxX = -translateMinX;
	      translateMaxY = -translateMinY;
	      translateX = diffX * zoom.scale;
	      translateY = diffY * zoom.scale;
	
	      if (translateX < translateMinX) {
	        translateX = translateMinX;
	      }
	
	      if (translateX > translateMaxX) {
	        translateX = translateMaxX;
	      }
	
	      if (translateY < translateMinY) {
	        translateY = translateMinY;
	      }
	
	      if (translateY > translateMaxY) {
	        translateY = translateMaxY;
	      }
	    } else {
	      translateX = 0;
	      translateY = 0;
	    }
	
	    gesture.$imageWrapEl.transition(300).transform("translate3d(" + translateX + "px, " + translateY + "px,0)");
	    gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
	  },
	  out: function out() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var params = swiper.params.zoom;
	    var gesture = zoom.gesture;
	
	    if (!gesture.$slideEl) {
	      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
	        gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
	      } else {
	        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
	      }
	
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
	      gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
	    }
	
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
	    zoom.scale = 1;
	    zoom.currentScale = 1;
	    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
	    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
	    gesture.$slideEl.removeClass("" + params.zoomedSlideClass);
	    gesture.$slideEl = undefined;
	  },
	  toggleGestures: function toggleGestures(method) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var selector = zoom.slideSelector,
	        passive = zoom.passiveListener;
	    swiper.$wrapperEl[method]('gesturestart', selector, zoom.onGestureStart, passive);
	    swiper.$wrapperEl[method]('gesturechange', selector, zoom.onGestureChange, passive);
	    swiper.$wrapperEl[method]('gestureend', selector, zoom.onGestureEnd, passive);
	  },
	  enableGestures: function enableGestures() {
	    if (this.zoom.gesturesEnabled) return;
	    this.zoom.gesturesEnabled = true;
	    this.zoom.toggleGestures('on');
	  },
	  disableGestures: function disableGestures() {
	    if (!this.zoom.gesturesEnabled) return;
	    this.zoom.gesturesEnabled = false;
	    this.zoom.toggleGestures('off');
	  },
	  // Attach/Detach Events
	  enable: function enable() {
	    var swiper = this;
	    var support = swiper.support;
	    var zoom = swiper.zoom;
	    if (zoom.enabled) return;
	    zoom.enabled = true;
	    var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
	      passive: true,
	      capture: false
	    } : false;
	    var activeListenerWithCapture = support.passiveListener ? {
	      passive: false,
	      capture: true
	    } : true;
	    var slideSelector = "." + swiper.params.slideClass;
	    swiper.zoom.passiveListener = passiveListener;
	    swiper.zoom.slideSelector = slideSelector; // Scale image
	
	    if (support.gestures) {
	      swiper.$wrapperEl.on(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
	      swiper.$wrapperEl.on(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
	    } else if (swiper.touchEvents.start === 'touchstart') {
	      swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
	      swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
	
	      if (swiper.touchEvents.cancel) {
	        swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
	      }
	    } // Move image
	
	
	    swiper.$wrapperEl.on(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
	  },
	  disable: function disable() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    if (!zoom.enabled) return;
	    var support = swiper.support;
	    swiper.zoom.enabled = false;
	    var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
	      passive: true,
	      capture: false
	    } : false;
	    var activeListenerWithCapture = support.passiveListener ? {
	      passive: false,
	      capture: true
	    } : true;
	    var slideSelector = "." + swiper.params.slideClass; // Scale image
	
	    if (support.gestures) {
	      swiper.$wrapperEl.off(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
	      swiper.$wrapperEl.off(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
	    } else if (swiper.touchEvents.start === 'touchstart') {
	      swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
	      swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
	
	      if (swiper.touchEvents.cancel) {
	        swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
	      }
	    } // Move image
	
	
	    swiper.$wrapperEl.off(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
	  }
	};
	var _default = {
	  name: 'zoom',
	  params: {
	    zoom: {
	      enabled: false,
	      maxRatio: 3,
	      minRatio: 1,
	      toggle: true,
	      containerClass: 'swiper-zoom-container',
	      zoomedSlideClass: 'swiper-slide-zoomed'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      zoom: _extends({
	        enabled: false,
	        scale: 1,
	        currentScale: 1,
	        isScaling: false,
	        gesture: {
	          $slideEl: undefined,
	          slideWidth: undefined,
	          slideHeight: undefined,
	          $imageEl: undefined,
	          $imageWrapEl: undefined,
	          maxRatio: 3
	        },
	        image: {
	          isTouched: undefined,
	          isMoved: undefined,
	          currentX: undefined,
	          currentY: undefined,
	          minX: undefined,
	          minY: undefined,
	          maxX: undefined,
	          maxY: undefined,
	          width: undefined,
	          height: undefined,
	          startX: undefined,
	          startY: undefined,
	          touchesStart: {},
	          touchesCurrent: {}
	        },
	        velocity: {
	          x: undefined,
	          y: undefined,
	          prevPositionX: undefined,
	          prevPositionY: undefined,
	          prevTime: undefined
	        }
	      }, Zoom)
	    });
	    var scale = 1;
	    Object.defineProperty(swiper.zoom, 'scale', {
	      get: function get() {
	        return scale;
	      },
	      set: function set(value) {
	        if (scale !== value) {
	          var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
	          var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
	          swiper.emit('zoomChange', value, imageEl, slideEl);
	        }
	
	        scale = value;
	      }
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      if (swiper.params.zoom.enabled) {
	        swiper.zoom.enable();
	      }
	    },
	    destroy: function destroy(swiper) {
	      swiper.zoom.disable();
	    },
	    touchStart: function touchStart(swiper, e) {
	      if (!swiper.zoom.enabled) return;
	      swiper.zoom.onTouchStart(e);
	    },
	    touchEnd: function touchEnd(swiper, e) {
	      if (!swiper.zoom.enabled) return;
	      swiper.zoom.onTouchEnd(e);
	    },
	    doubleTap: function doubleTap(swiper, e) {
	      if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
	        swiper.zoom.toggle(e);
	      }
	    },
	    transitionEnd: function transitionEnd(swiper) {
	      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
	        swiper.zoom.onTransitionEnd();
	      }
	    },
	    slideChange: function slideChange(swiper) {
	      if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
	        swiper.zoom.onTransitionEnd();
	      }
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _utils = __webpack_require__(26);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Observer = {
	  attach: function attach(target, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var window = (0, _ssrWindow.getWindow)();
	    var swiper = this;
	    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
	    var observer = new ObserverFunc(function (mutations) {
	      // The observerUpdate event should only be triggered
	      // once despite the number of mutations.  Additional
	      // triggers are redundant and are very costly
	      if (mutations.length === 1) {
	        swiper.emit('observerUpdate', mutations[0]);
	        return;
	      }
	
	      var observerUpdate = function observerUpdate() {
	        swiper.emit('observerUpdate', mutations[0]);
	      };
	
	      if (window.requestAnimationFrame) {
	        window.requestAnimationFrame(observerUpdate);
	      } else {
	        window.setTimeout(observerUpdate, 0);
	      }
	    });
	    observer.observe(target, {
	      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	      childList: typeof options.childList === 'undefined' ? true : options.childList,
	      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
	    });
	    swiper.observer.observers.push(observer);
	  },
	  init: function init() {
	    var swiper = this;
	    if (!swiper.support.observer || !swiper.params.observer) return;
	
	    if (swiper.params.observeParents) {
	      var containerParents = swiper.$el.parents();
	
	      for (var i = 0; i < containerParents.length; i += 1) {
	        swiper.observer.attach(containerParents[i]);
	      }
	    } // Observe container
	
	
	    swiper.observer.attach(swiper.$el[0], {
	      childList: swiper.params.observeSlideChildren
	    }); // Observe wrapper
	
	    swiper.observer.attach(swiper.$wrapperEl[0], {
	      attributes: false
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    swiper.observer.observers.forEach(function (observer) {
	      observer.disconnect();
	    });
	    swiper.observer.observers = [];
	  }
	};
	var _default = {
	  name: 'observer',
	  params: {
	    observer: false,
	    observeParents: false,
	    observeSlideChildren: false
	  },
	  create: function create() {
	    var swiper = this;
	    (0, _utils.bindModuleMethods)(swiper, {
	      observer: _extends({}, Observer, {
	        observers: []
	      })
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      swiper.observer.init();
	    },
	    destroy: function destroy(swiper) {
	      swiper.observer.destroy();
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _utils = __webpack_require__(26);
	
	var supportsResizeObserver = function supportsResizeObserver() {
	  var window = (0, _ssrWindow.getWindow)();
	  return typeof window.ResizeObserver !== 'undefined';
	};
	
	var _default = {
	  name: 'resize',
	  create: function create() {
	    var swiper = this;
	    (0, _utils.extend)(swiper, {
	      resize: {
	        observer: null,
	        createObserver: function createObserver() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) return;
	          swiper.resize.observer = new ResizeObserver(function (entries) {
	            var width = swiper.width,
	                height = swiper.height;
	            var newWidth = width;
	            var newHeight = height;
	            entries.forEach(function (_ref) {
	              var contentBoxSize = _ref.contentBoxSize,
	                  contentRect = _ref.contentRect,
	                  target = _ref.target;
	              if (target && target !== swiper.el) return;
	              newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
	              newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
	            });
	
	            if (newWidth !== width || newHeight !== height) {
	              swiper.resize.resizeHandler();
	            }
	          });
	          swiper.resize.observer.observe(swiper.el);
	        },
	        removeObserver: function removeObserver() {
	          if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
	            swiper.resize.observer.unobserve(swiper.el);
	            swiper.resize.observer = null;
	          }
	        },
	        resizeHandler: function resizeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) return;
	          swiper.emit('beforeResize');
	          swiper.emit('resize');
	        },
	        orientationChangeHandler: function orientationChangeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) return;
	          swiper.emit('orientationchange');
	        }
	      }
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      var window = (0, _ssrWindow.getWindow)();
	
	      if (swiper.params.resizeObserver && supportsResizeObserver()) {
	        swiper.resize.createObserver();
	        return;
	      } // Emit resize
	
	
	      window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange
	
	      window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    },
	    destroy: function destroy(swiper) {
	      var window = (0, _ssrWindow.getWindow)();
	      swiper.resize.removeObserver();
	      window.removeEventListener('resize', swiper.resize.resizeHandler);
	      window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChangedParams = getChangedParams;
	
	var _paramsList = __webpack_require__(438);
	
	var _utils = __webpack_require__(91);
	
	function getChangedParams(swiperParams, oldParams, children, oldChildren) {
	  var keys = [];
	  if (!oldParams) return keys;
	
	  var addKey = function addKey(key) {
	    if (keys.indexOf(key) < 0) keys.push(key);
	  };
	
	  var oldChildrenKeys = oldChildren.map(function (child) {
	    return child.key;
	  });
	  var childrenKeys = children.map(function (child) {
	    return child.key;
	  });
	  if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
	  if (oldChildren.length !== children.length) addKey('children');
	
	  var watchParams = _paramsList.paramsList.filter(function (key) {
	    return key[0] === '_';
	  }).map(function (key) {
	    return key.replace(/_/, '');
	  });
	
	  watchParams.forEach(function (key) {
	    if (key in swiperParams && key in oldParams) {
	      if ((0, _utils.isObject)(swiperParams[key]) && (0, _utils.isObject)(oldParams[key])) {
	        var newKeys = Object.keys(swiperParams[key]);
	        var oldKeys = Object.keys(oldParams[key]);
	
	        if (newKeys.length !== oldKeys.length) {
	          addKey(key);
	        } else {
	          newKeys.forEach(function (newKey) {
	            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
	              addKey(key);
	            }
	          });
	          oldKeys.forEach(function (oldKey) {
	            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
	          });
	        }
	      } else if (swiperParams[key] !== oldParams[key]) {
	        addKey(key);
	      }
	    }
	  });
	  return keys;
	}

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildren = getChildren;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function processChildren(c) {
	  var slides = [];
	
	  _react.default.Children.toArray(c).forEach(function (child) {
	    if (child.type && child.type.displayName === 'SwiperSlide') {
	      slides.push(child);
	    } else if (child.props && child.props.children) {
	      processChildren(child.props.children).forEach(function (slide) {
	        return slides.push(slide);
	      });
	    }
	  });
	
	  return slides;
	}
	
	function getChildren(c) {
	  var slides = [];
	  var slots = {
	    'container-start': [],
	    'container-end': [],
	    'wrapper-start': [],
	    'wrapper-end': []
	  };
	
	  _react.default.Children.toArray(c).forEach(function (child) {
	    if (child.type && child.type.displayName === 'SwiperSlide') {
	      slides.push(child);
	    } else if (child.props && child.props.slot && slots[child.props.slot]) {
	      slots[child.props.slot].push(child);
	    } else if (child.props && child.props.children) {
	      var foundSlides = processChildren(child.props.children);
	
	      if (foundSlides.length > 0) {
	        foundSlides.forEach(function (slide) {
	          return slides.push(slide);
	        });
	      } else {
	        slots['container-end'].push(child);
	      }
	    } else {
	      slots['container-end'].push(child);
	    }
	  });
	
	  return {
	    slides: slides,
	    slots: slots
	  };
	}

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getParams = getParams;
	
	var _core = _interopRequireDefault(__webpack_require__(173));
	
	var _utils = __webpack_require__(91);
	
	var _paramsList = __webpack_require__(438);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line
	function getParams(obj) {
	  if (obj === void 0) {
	    obj = {};
	  }
	
	  var params = {
	    on: {}
	  };
	  var events = {};
	  var passedParams = {};
	  (0, _utils.extend)(params, _core.default.defaults);
	  (0, _utils.extend)(params, _core.default.extendedDefaults);
	  params._emitClasses = true;
	  params.init = false;
	  var rest = {};
	
	  var allowedParams = _paramsList.paramsList.map(function (key) {
	    return key.replace(/_/, '');
	  });
	
	  Object.keys(obj).forEach(function (key) {
	    if (allowedParams.indexOf(key) >= 0) {
	      if ((0, _utils.isObject)(obj[key])) {
	        params[key] = {};
	        passedParams[key] = {};
	        (0, _utils.extend)(params[key], obj[key]);
	        (0, _utils.extend)(passedParams[key], obj[key]);
	      } else {
	        params[key] = obj[key];
	        passedParams[key] = obj[key];
	      }
	    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
	      events["" + key[2].toLowerCase() + key.substr(3)] = obj[key];
	    } else {
	      rest[key] = obj[key];
	    }
	  });
	  ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
	    if (params[key] === true) params[key] = {};
	    if (params[key] === false) delete params[key];
	  });
	  return {
	    params: params,
	    passedParams: passedParams,
	    rest: rest,
	    events: events
	  };
	}

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.initSwiper = initSwiper;
	exports.mountSwiper = mountSwiper;
	
	var _core = _interopRequireDefault(__webpack_require__(173));
	
	var _utils = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line
	function initSwiper(swiperParams) {
	  return new _core.default(swiperParams);
	}
	
	function mountSwiper(_ref, swiperParams) {
	  var el = _ref.el,
	      nextEl = _ref.nextEl,
	      prevEl = _ref.prevEl,
	      paginationEl = _ref.paginationEl,
	      scrollbarEl = _ref.scrollbarEl,
	      swiper = _ref.swiper;
	
	  if ((0, _utils.needsNavigation)(swiperParams) && nextEl && prevEl) {
	    swiper.params.navigation.nextEl = nextEl;
	    swiper.originalParams.navigation.nextEl = nextEl;
	    swiper.params.navigation.prevEl = prevEl;
	    swiper.originalParams.navigation.prevEl = prevEl;
	  }
	
	  if ((0, _utils.needsPagination)(swiperParams) && paginationEl) {
	    swiper.params.pagination.el = paginationEl;
	    swiper.originalParams.pagination.el = paginationEl;
	  }
	
	  if ((0, _utils.needsScrollbar)(swiperParams) && scrollbarEl) {
	    swiper.params.scrollbar.el = scrollbarEl;
	    swiper.originalParams.scrollbar.el = scrollbarEl;
	  }
	
	  swiper.init(el);
	}

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.calcLoopedSlides = calcLoopedSlides;
	exports.renderLoop = renderLoop;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _core = _interopRequireDefault(__webpack_require__(173));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line
	function calcLoopedSlides(slides, swiperParams) {
	  var slidesPerViewParams = swiperParams.slidesPerView;
	
	  if (swiperParams.breakpoints) {
	    var breakpoint = _core.default.prototype.getBreakpoint(swiperParams.breakpoints);
	
	    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;
	
	    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
	      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
	    }
	  }
	
	  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
	  loopedSlides += swiperParams.loopAdditionalSlides;
	
	  if (loopedSlides > slides.length) {
	    loopedSlides = slides.length;
	  }
	
	  return loopedSlides;
	}
	
	function renderLoop(swiper, slides, swiperParams) {
	  var modifiedSlides = slides.map(function (child, index) {
	    return /*#__PURE__*/_react.default.cloneElement(child, {
	      swiper: swiper,
	      'data-swiper-slide-index': index
	    });
	  });
	
	  function duplicateSlide(child, index, position) {
	    return /*#__PURE__*/_react.default.cloneElement(child, {
	      key: child.key + "-duplicate-" + index + "-" + position,
	      className: (child.props.className || '') + " " + swiperParams.slideDuplicateClass
	    });
	  }
	
	  if (swiperParams.loopFillGroupWithBlank) {
	    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;
	
	    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
	      for (var i = 0; i < blankSlidesNum; i += 1) {
	        var blankSlide = /*#__PURE__*/_react.default.createElement("div", {
	          className: swiperParams.slideClass + " " + swiperParams.slideBlankClass
	        });
	
	        modifiedSlides.push(blankSlide);
	      }
	    }
	  }
	
	  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
	    swiperParams.loopedSlides = modifiedSlides.length;
	  }
	
	  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
	  var prependSlides = [];
	  var appendSlides = [];
	  modifiedSlides.forEach(function (child, index) {
	    if (index < loopedSlides) {
	      appendSlides.push(duplicateSlide(child, index, 'prepend'));
	    }
	
	    if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
	      prependSlides.push(duplicateSlide(child, index, 'append'));
	    }
	  });
	
	  if (swiper) {
	    swiper.loopedSlides = loopedSlides;
	  }
	
	  return [].concat(prependSlides, modifiedSlides, appendSlides);
	}

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SwiperSlide = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(91);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(439);
	
	var _excluded = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var SwiperSlide = /*#__PURE__*/(0, _react.forwardRef)(function (_temp, externalRef) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$tag = _ref.tag,
	      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
	      children = _ref.children,
	      _ref$className = _ref.className,
	      className = _ref$className === void 0 ? '' : _ref$className,
	      swiper = _ref.swiper,
	      zoom = _ref.zoom,
	      virtualIndex = _ref.virtualIndex,
	      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
	
	  var slideElRef = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)('swiper-slide'),
	      slideClasses = _useState[0],
	      setSlideClasses = _useState[1];
	
	  function updateClasses(swiper, el, classNames) {
	    if (el === slideElRef.current) {
	      setSlideClasses(classNames);
	    }
	  }
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    if (externalRef) {
	      externalRef.current = slideElRef.current;
	    }
	
	    if (!slideElRef.current || !swiper) {
	      return;
	    }
	
	    if (swiper.destroyed) {
	      if (slideClasses !== 'swiper-slide') {
	        setSlideClasses('swiper-slide');
	      }
	
	      return;
	    }
	
	    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line
	
	    return function () {
	      if (!swiper) return;
	      swiper.off('_slideClass', updateClasses);
	    };
	  });
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    if (swiper && slideElRef.current) {
	      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
	    }
	  }, [swiper]);
	  var slideData;
	
	  if (typeof children === 'function') {
	    slideData = {
	      isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
	      isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
	      isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
	      isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
	      isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
	    };
	  }
	
	  var renderChildren = function renderChildren() {
	    return typeof children === 'function' ? children(slideData) : children;
	  };
	
	  return /*#__PURE__*/_react.default.createElement(Tag, _extends({
	    ref: slideElRef,
	    className: (0, _utils.uniqueClasses)("" + slideClasses + (className ? " " + className : '')),
	    "data-swiper-slide-index": virtualIndex
	  }, rest), zoom ? /*#__PURE__*/_react.default.createElement("div", {
	    className: "swiper-zoom-container",
	    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
	  }, renderChildren()) : renderChildren());
	});
	exports.SwiperSlide = SwiperSlide;
	SwiperSlide.displayName = 'SwiperSlide';

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Swiper = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _getParams2 = __webpack_require__(1126);
	
	var _initSwiper = __webpack_require__(1127);
	
	var _utils = __webpack_require__(91);
	
	var _loop = __webpack_require__(1128);
	
	var _getChangedParams = __webpack_require__(1124);
	
	var _getChildren2 = __webpack_require__(1125);
	
	var _updateSwiper = __webpack_require__(1131);
	
	var _virtual = __webpack_require__(1132);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(439);
	
	var _excluded = ["className", "tag", "wrapperTag", "children", "onSwiper"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Swiper = /*#__PURE__*/(0, _react.forwardRef)(function (_temp, externalElRef) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      className = _ref.className,
	      _ref$tag = _ref.tag,
	      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
	      _ref$wrapperTag = _ref.wrapperTag,
	      WrapperTag = _ref$wrapperTag === void 0 ? 'div' : _ref$wrapperTag,
	      children = _ref.children,
	      onSwiper = _ref.onSwiper,
	      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
	
	  var eventsAssigned = false;
	
	  var _useState = (0, _react.useState)('swiper-container'),
	      containerClasses = _useState[0],
	      setContainerClasses = _useState[1];
	
	  var _useState2 = (0, _react.useState)(null),
	      virtualData = _useState2[0],
	      setVirtualData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      breakpointChanged = _useState3[0],
	      setBreakpointChanged = _useState3[1];
	
	  var initializedRef = (0, _react.useRef)(false);
	  var swiperElRef = (0, _react.useRef)(null);
	  var swiperRef = (0, _react.useRef)(null);
	  var oldPassedParamsRef = (0, _react.useRef)(null);
	  var oldSlides = (0, _react.useRef)(null);
	  var nextElRef = (0, _react.useRef)(null);
	  var prevElRef = (0, _react.useRef)(null);
	  var paginationElRef = (0, _react.useRef)(null);
	  var scrollbarElRef = (0, _react.useRef)(null);
	
	  var _getParams = (0, _getParams2.getParams)(rest),
	      swiperParams = _getParams.params,
	      passedParams = _getParams.passedParams,
	      restProps = _getParams.rest,
	      events = _getParams.events;
	
	  var _getChildren = (0, _getChildren2.getChildren)(children),
	      slides = _getChildren.slides,
	      slots = _getChildren.slots;
	
	  var onBeforeBreakpoint = function onBeforeBreakpoint() {
	    setBreakpointChanged(!breakpointChanged);
	  };
	
	  Object.assign(swiperParams.on, {
	    _containerClasses: function _containerClasses(swiper, classes) {
	      setContainerClasses(classes);
	    }
	  });
	
	  if (!swiperElRef.current) {
	    // init swiper
	    Object.assign(swiperParams.on, events);
	    eventsAssigned = true;
	    swiperRef.current = (0, _initSwiper.initSwiper)(swiperParams);
	
	    swiperRef.current.loopCreate = function () {};
	
	    swiperRef.current.loopDestroy = function () {};
	
	    if (swiperParams.loop) {
	      swiperRef.current.loopedSlides = (0, _loop.calcLoopedSlides)(slides, swiperParams);
	    }
	
	    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
	      swiperRef.current.virtual.slides = slides;
	      var extendWith = {
	        cache: false,
	        renderExternal: setVirtualData,
	        renderExternalUpdate: false
	      };
	      (0, _utils.extend)(swiperRef.current.params.virtual, extendWith);
	      (0, _utils.extend)(swiperRef.current.originalParams.virtual, extendWith);
	    }
	  } // Listen for breakpoints change
	
	
	  if (swiperRef.current) {
	    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
	  }
	
	  var attachEvents = function attachEvents() {
	    if (eventsAssigned || !events || !swiperRef.current) return;
	    Object.keys(events).forEach(function (eventName) {
	      swiperRef.current.on(eventName, events[eventName]);
	    });
	  };
	
	  var detachEvents = function detachEvents() {
	    if (!events || !swiperRef.current) return;
	    Object.keys(events).forEach(function (eventName) {
	      swiperRef.current.off(eventName, events[eventName]);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
	    };
	  }); // set initialized flag
	
	  (0, _react.useEffect)(function () {
	    if (!initializedRef.current && swiperRef.current) {
	      swiperRef.current.emitSlidesClasses();
	      initializedRef.current = true;
	    }
	  }); // mount swiper
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    if (externalElRef) {
	      externalElRef.current = swiperElRef.current;
	    }
	
	    if (!swiperElRef.current) return;
	    (0, _initSwiper.mountSwiper)({
	      el: swiperElRef.current,
	      nextEl: nextElRef.current,
	      prevEl: prevElRef.current,
	      paginationEl: paginationElRef.current,
	      scrollbarEl: scrollbarElRef.current,
	      swiper: swiperRef.current
	    }, swiperParams);
	    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line
	
	    return function () {
	      if (swiperRef.current && !swiperRef.current.destroyed) {
	        swiperRef.current.destroy(true, false);
	      }
	    };
	  }, []); // watch for params change
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    attachEvents();
	    var changedParams = (0, _getChangedParams.getChangedParams)(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
	    oldPassedParamsRef.current = passedParams;
	    oldSlides.current = slides;
	
	    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
	      (0, _updateSwiper.updateSwiper)({
	        swiper: swiperRef.current,
	        slides: slides,
	        passedParams: passedParams,
	        changedParams: changedParams,
	        nextEl: nextElRef.current,
	        prevEl: prevElRef.current,
	        scrollbarEl: scrollbarElRef.current,
	        paginationEl: paginationElRef.current
	      });
	    }
	
	    return function () {
	      detachEvents();
	    };
	  }); // update on virtual update
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    (0, _virtual.updateOnVirtualData)(swiperRef.current);
	  }, [virtualData]); // bypass swiper instance to slides
	
	  function renderSlides() {
	    if (swiperParams.virtual) {
	      return (0, _virtual.renderVirtual)(swiperRef.current, slides, virtualData);
	    }
	
	    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
	      return slides.map(function (child) {
	        return /*#__PURE__*/_react.default.cloneElement(child, {
	          swiper: swiperRef.current
	        });
	      });
	    }
	
	    return (0, _loop.renderLoop)(swiperRef.current, slides, swiperParams);
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, _extends({
	    ref: swiperElRef,
	    className: (0, _utils.uniqueClasses)("" + containerClasses + (className ? " " + className : ''))
	  }, restProps), slots['container-start'], (0, _utils.needsNavigation)(swiperParams) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
	    ref: prevElRef,
	    className: "swiper-button-prev"
	  }), /*#__PURE__*/_react.default.createElement("div", {
	    ref: nextElRef,
	    className: "swiper-button-next"
	  })), (0, _utils.needsScrollbar)(swiperParams) && /*#__PURE__*/_react.default.createElement("div", {
	    ref: scrollbarElRef,
	    className: "swiper-scrollbar"
	  }), (0, _utils.needsPagination)(swiperParams) && /*#__PURE__*/_react.default.createElement("div", {
	    ref: paginationElRef,
	    className: "swiper-pagination"
	  }), /*#__PURE__*/_react.default.createElement(WrapperTag, {
	    className: "swiper-wrapper"
	  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), slots['container-end']);
	});
	exports.Swiper = Swiper;
	Swiper.displayName = 'Swiper';

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.updateSwiper = updateSwiper;
	
	var _utils = __webpack_require__(91);
	
	function updateSwiper(_ref) {
	  var swiper = _ref.swiper,
	      slides = _ref.slides,
	      passedParams = _ref.passedParams,
	      changedParams = _ref.changedParams,
	      nextEl = _ref.nextEl,
	      prevEl = _ref.prevEl,
	      scrollbarEl = _ref.scrollbarEl,
	      paginationEl = _ref.paginationEl;
	  var updateParams = changedParams.filter(function (key) {
	    return key !== 'children' && key !== 'direction';
	  });
	  var currentParams = swiper.params,
	      pagination = swiper.pagination,
	      navigation = swiper.navigation,
	      scrollbar = swiper.scrollbar,
	      virtual = swiper.virtual,
	      thumbs = swiper.thumbs;
	  var needThumbsInit;
	  var needControllerInit;
	  var needPaginationInit;
	  var needScrollbarInit;
	  var needNavigationInit;
	
	  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
	    needThumbsInit = true;
	  }
	
	  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
	    needControllerInit = true;
	  }
	
	  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
	    needPaginationInit = true;
	  }
	
	  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
	    needScrollbarInit = true;
	  }
	
	  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
	    needNavigationInit = true;
	  }
	
	  var destroyModule = function destroyModule(mod) {
	    if (!swiper[mod]) return;
	    swiper[mod].destroy();
	
	    if (mod === 'navigation') {
	      currentParams[mod].prevEl = undefined;
	      currentParams[mod].nextEl = undefined;
	      swiper[mod].prevEl = undefined;
	      swiper[mod].nextEl = undefined;
	    } else {
	      currentParams[mod].el = undefined;
	      swiper[mod].el = undefined;
	    }
	  };
	
	  updateParams.forEach(function (key) {
	    if ((0, _utils.isObject)(currentParams[key]) && (0, _utils.isObject)(passedParams[key])) {
	      (0, _utils.extend)(currentParams[key], passedParams[key]);
	    } else {
	      var newValue = passedParams[key];
	
	      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
	        if (newValue === false) {
	          destroyModule(key);
	        }
	      } else {
	        currentParams[key] = passedParams[key];
	      }
	    }
	  });
	
	  if (changedParams.includes('children') && virtual && currentParams.virtual.enabled) {
	    virtual.slides = slides;
	    virtual.update(true);
	  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
	    swiper.lazy.load();
	  }
	
	  if (needThumbsInit) {
	    var initialized = thumbs.init();
	    if (initialized) thumbs.update(true);
	  }
	
	  if (needControllerInit) {
	    swiper.controller.control = currentParams.controller.control;
	  }
	
	  if (needPaginationInit) {
	    if (paginationEl) currentParams.pagination.el = paginationEl;
	    pagination.init();
	    pagination.render();
	    pagination.update();
	  }
	
	  if (needScrollbarInit) {
	    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
	    scrollbar.init();
	    scrollbar.updateSize();
	    scrollbar.setTranslate();
	  }
	
	  if (needNavigationInit) {
	    if (nextEl) currentParams.navigation.nextEl = nextEl;
	    if (prevEl) currentParams.navigation.prevEl = prevEl;
	    navigation.init();
	    navigation.update();
	  }
	
	  if (changedParams.includes('allowSlideNext')) {
	    swiper.allowSlideNext = passedParams.allowSlideNext;
	  }
	
	  if (changedParams.includes('allowSlidePrev')) {
	    swiper.allowSlidePrev = passedParams.allowSlidePrev;
	  }
	
	  if (changedParams.includes('direction')) {
	    swiper.changeDirection(passedParams.direction, false);
	  }
	
	  swiper.update();
	}

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.renderVirtual = renderVirtual;
	exports.updateOnVirtualData = updateOnVirtualData;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateOnVirtualData(swiper) {
	  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
	  swiper.updateSlides();
	  swiper.updateProgress();
	  swiper.updateSlidesClasses();
	
	  if (swiper.lazy && swiper.params.lazy.enabled) {
	    swiper.lazy.load();
	  }
	
	  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
	    swiper.parallax.setTranslate();
	  }
	}
	
	function renderVirtual(swiper, slides, virtualData) {
	  var _ref;
	
	  if (!virtualData) return null;
	  var style = swiper.isHorizontal() ? (_ref = {}, _ref[swiper.rtlTranslate ? 'right' : 'left'] = virtualData.offset + "px", _ref) : {
	    top: virtualData.offset + "px"
	  };
	  return slides.filter(function (child, index) {
	    return index >= virtualData.from && index <= virtualData.to;
	  }).map(function (child) {
	    return /*#__PURE__*/_react.default.cloneElement(child, {
	      swiper: swiper,
	      style: style
	    });
	  });
	}

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getBrowser = getBrowser;
	
	var _ssrWindow = __webpack_require__(41);
	
	var browser;
	
	function calcBrowser() {
	  var window = (0, _ssrWindow.getWindow)();
	
	  function isSafari() {
	    var ua = window.navigator.userAgent.toLowerCase();
	    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
	  }
	
	  return {
	    isEdge: !!window.navigator.userAgent.match(/Edge/g),
	    isSafari: isSafari(),
	    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
	  };
	}
	
	function getBrowser() {
	  if (!browser) {
	    browser = calcBrowser();
	  }
	
	  return browser;
	}

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getDevice = getDevice;
	
	var _ssrWindow = __webpack_require__(41);
	
	var _getSupport = __webpack_require__(440);
	
	var device;
	
	function calcDevice(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      userAgent = _ref.userAgent;
	
	  var support = (0, _getSupport.getSupport)();
	  var window = (0, _ssrWindow.getWindow)();
	  var platform = window.navigator.platform;
	  var ua = userAgent || window.navigator.userAgent;
	  var device = {
	    ios: false,
	    android: false
	  };
	  var screenWidth = window.screen.width;
	  var screenHeight = window.screen.height;
	  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	
	  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	  var windows = platform === 'Win32';
	  var macos = platform === 'MacIntel'; // iPadOs 13 fix
	
	  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
	
	  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
	    ipad = ua.match(/(Version)\/([\d.]+)/);
	    if (!ipad) ipad = [0, 1, '13_0_0'];
	    macos = false;
	  } // Android
	
	
	  if (android && !windows) {
	    device.os = 'android';
	    device.android = true;
	  }
	
	  if (ipad || iphone || ipod) {
	    device.os = 'ios';
	    device.ios = true;
	  } // Export object
	
	
	  return device;
	}
	
	function getDevice(overrides) {
	  if (overrides === void 0) {
	    overrides = {};
	  }
	
	  if (!device) {
	    device = calcDevice(overrides);
	  }
	
	  return device;
	}

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1039);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v1.0.38
	   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
	   MIT License */
	(function(window,undefined){"use strict";var LIBVERSION="1.0.38",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=500;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" GX"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"Baidu"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,/(heytap|ovi)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/\bddg\/([\w\.]+)/i],[VERSION,[NAME,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[VERSION,[NAME,"Smart Lenovo "+BROWSER]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360 "+BROWSER]],[/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 "+BROWSER],VERSION],[/samsungbrowser\/([\w\.]+)/i],[VERSION,[NAME,SAMSUNG+" Internet"]],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/metasr[\/ ]?([\d\.]+)/i],[VERSION,[NAME,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[NAME,"Sogou Mobile"],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(lbbrowser)/i,/\[(linkedin)app\]/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i,/panasonic;(viera)/i],[NAME,VERSION],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/\b(opd2\d{3}a?) bui/i],[MODEL,[VENDOR,"OPPO"],[TYPE,TABLET]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[MODEL,[VENDOR,"Ulefone"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w+)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mitv-\w{5}) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( \d| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[VERSION,strMapper,windowsVersionMap],[NAME,"Windows"]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave"}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS)}return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(1181)){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/banner-case-study.0f7375d0.png";

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/health_screenint_bnner_image.0ace14ce.png";

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/1466325848atm1.07a29f2f.jpg";

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2882.df41eab7.jpg";

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2882_1.2edcc943.jpg";

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2885.ae142a81.jpg";

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2885_1.459f1fdc.jpg";

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2984.bf291be2.jpg";

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2984_1.b7a38faf.jpg";

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2986.60282db0.jpg";

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2986_1.cbbe9c6a.jpg";

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2987.443dade3.jpg";

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2987_1.24647257.jpg";

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2991.c86e29ca.jpg";

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/_ARK2991_1.f80d14c1.jpg";

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/DELUXE.ef417cc1.jpg";

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/DOUBLE.0831487e.jpg";

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/GENERAL.d9e0fdef.jpg";

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Luxary.3a06941b.jpg";

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ONCOLOGY.507a4dfa.jpg";

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/STANDARD.687fda37.jpg";

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/STANDARD_single.ffc8159c.jpg";

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/VIP.f7288d3e.jpg";

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/triple.3545543c.jpg";

/***/ },
/* 1161 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/career_picture.a9213a5c.png";

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/caseStudy.b452364d.png";

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ceo.67190796.jpg";

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/doc.efefe63b.png";

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/doctor2.bddd0d3a.png";

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/graf.01507d02.png";

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/hero-body.f4d426b5.png";

/***/ },
/* 1169 */
/***/ function(module, exports) {

	module.exports = "data:image/webp;base64,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"

/***/ },
/* 1170 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAADRCAYAAACHBEHnAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAANSSURBVHhe7dVBbtswFEXRbi3jbiWTzDoLEnQPmQXpoMvwGgxkQy6+UQa0TJmfT3wqatwL/EFtVNQRKefb6U4D9r9lhR2Pn+f5F02DBeDp6cd5Hh6+r058//Hx2w7eBCuYFiA7gXQkwWaAljMbOAyLG2jd2KyZBRyCuVFlZuDSsNlHrzdbcSnY3qgyW3BdmIKK/xMTN1ZGfTgq7iYsLtparDVx4/Fr2fv7FN+PXDemd81Wq7CRxdWnOrLGKG4V1rr4csoubSmLi7VGasIyi40udKt4OK01ljPyEJuw1kWXM7sMbuRhXsEyu6W+U70ya2d37QrWulg9LlQpdqW1bpnsrl3AMsfBXe8eJFjvKLh3q9TbtcxxvIDNuOCMeruWecAXsNZF6tmrGccxDdvrGJZunZ4h2Iztn1nvteh1/7C48dYFyuz1w1Hq3U+v9I7dLYx3bFLTYFHrAmUyP7Eza91Dmcy9pGExe9V7vzKn5wLW2/69fkCmw3rv2V7HsbV2PZkuYFHrQvW4d623W9mHewXrHUf3rrXWrCdzDKMrWO84xmQvPlrvocZku4JFmQVm43pHMGZkzSYss2sxs3AZVMxITViU2bWYrTjXOquw7K6VGV04u0sxysNbhUWjuJi4ibU/CfF5dofqUboJi0aebGsUSD1rD6lXFxZtxamjHMFSChbtjVN3qpSGRXvg4uhuRUVDsJILuOXoLZNgUdxED/j8/Po1re/LzNqlOhlWihtaA769vX3N8ruCmQ0qbYbVFWSZGhaQ+MyJqZsKW1bD9g6YEjBDwJSAGQKmBMwQMCVghoApATMETAmYIWBKwAwBUwJmCJgSMEPAlIAZAqYEzBAwJWCGgCkBMwRMCZghYErADAFTAmYImBIwQ8CUgBkCpgTMEDClgjocDn8/2S9gSsAMAVMCZgiYEjBDwJSAGQKmBMwQMCVghoApATMETAmYIWBKwAwBUwJmCJgSMEPAlIAZAqYEzBAwJWCGgCnxjhkCpgTMEDAlYIaAKQEzBEwJmCFgSsAMAVMCZgiYEjBDwJSAGQKmBMwQMCVghoApATMETAmYIWBKwAwBUwJmCJgSMEPAlIAZAqYEzBAwpbuDHY+f53l5+Xl6fHw6vb//Ov97v06nP6Wg/eI1SZeLAAAAAElFTkSuQmCC"

/***/ },
/* 1171 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/news_events_1.120e4085.png";

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/plain_anatomy.8ec99d9f.png";

/***/ },
/* 1174 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sign.e8bef74e.png";

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tes.9dde11c5.jpg";

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/white-logo.dc89ee2d.png";

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	
	function areInputsEqual(newInputs, lastInputs) {
	  if (newInputs.length !== lastInputs.length) {
	    return false;
	  }
	
	  for (var i = 0; i < newInputs.length; i++) {
	    if (newInputs[i] !== lastInputs[i]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function useMemoOne(getResult, inputs) {
	  var initial = react.useState(function () {
	    return {
	      inputs: inputs,
	      result: getResult()
	    };
	  })[0];
	  var isFirstRun = react.useRef(true);
	  var committed = react.useRef(initial);
	  var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
	  var cache = useCache ? committed.current : {
	    inputs: inputs,
	    result: getResult()
	  };
	  react.useEffect(function () {
	    isFirstRun.current = false;
	    committed.current = cache;
	  }, [cache]);
	  return cache.result;
	}
	function useCallbackOne(callback, inputs) {
	  return useMemoOne(function () {
	    return callback;
	  }, inputs);
	}
	var useMemo = useMemoOne;
	var useCallback = useCallbackOne;
	
	exports.useCallback = useCallback;
	exports.useCallbackOne = useCallbackOne;
	exports.useMemo = useMemo;
	exports.useMemoOne = useMemoOne;


/***/ },
/* 1179 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1179);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 1181 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 1182 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1183 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _VirtualizedSelect = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _VirtualizedSelect2 = _interopRequireDefault(_VirtualizedSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VirtualizedSelect2.default;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.517253e1.js